/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 596);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(2213)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(494),
  /* template */
  __webpack_require__(2110),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
//! version : 2.18.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    var k;
    for (k in obj) {
        // even if its not own property I'd still call it non-empty
        return false;
    }
    return true;
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null,
        rfc2822         : false,
        weekdayMismatch : false
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

var some$1 = some;

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var keys$1 = keys;

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    ss : '%d seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid()) {
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;


var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

var indexOf$1 = indexOf;

function daysInMonth(year, month) {
    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return isArray(this._months) ? this._months :
            this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort :
            this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function createDate (y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date = new Date(y, m, d, h, M, s, ms);

    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return isArray(this._weekdays) ? this._weekdays :
            this._weekdays['standalone'];
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf$1.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('k',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

// months
// week
// weekdays
// meridiem
var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return null;
}

function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            __webpack_require__(1173)("./" + name);
            // because defineLocale currently also sets the global locale, we
            // want to undo that for lazy loaded locales
            getSetGlobalLocale(oldLocale);
        } catch (e) { }
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                if (!localeFamilies[config.parentLocale]) {
                    localeFamilies[config.parentLocale] = [];
                }
                localeFamilies[config.parentLocale].push({
                    name: name,
                    config: config
                });
                return null;
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, parentConfig = baseConfig;
        // MERGE
        if (locales[name] != null) {
            parentConfig = locales[name]._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys$1(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
var basicRfcRegex = /^((?:Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d?\d\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(?:\d\d)?\d\d\s)(\d\d:\d\d)(\:\d\d)?(\s(?:UT|GMT|[ECMP][SD]T|[A-IK-Za-ik-z]|[+-]\d{4}))$/;

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var string, match, dayFormat,
        dateFormat, timeFormat, tzFormat;
    var timezones = {
        ' GMT': ' +0000',
        ' EDT': ' -0400',
        ' EST': ' -0500',
        ' CDT': ' -0500',
        ' CST': ' -0600',
        ' MDT': ' -0600',
        ' MST': ' -0700',
        ' PDT': ' -0700',
        ' PST': ' -0800'
    };
    var military = 'YXWVUTSRQPONZABCDEFGHIKLM';
    var timezone, timezoneIndex;

    string = config._i
        .replace(/\([^\)]*\)|[\n\t]/g, ' ') // Remove comments and folding whitespace
        .replace(/(\s\s+)/g, ' ') // Replace multiple-spaces with a single space
        .replace(/^\s|\s$/g, ''); // Remove leading and trailing spaces
    match = basicRfcRegex.exec(string);

    if (match) {
        dayFormat = match[1] ? 'ddd' + ((match[1].length === 5) ? ', ' : ' ') : '';
        dateFormat = 'D MMM ' + ((match[2].length > 10) ? 'YYYY ' : 'YY ');
        timeFormat = 'HH:mm' + (match[4] ? ':ss' : '');

        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        if (match[1]) { // day of week given
            var momentDate = new Date(match[2]);
            var momentDay = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][momentDate.getDay()];

            if (match[1].substr(0,3) !== momentDay) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return;
            }
        }

        switch (match[5].length) {
            case 2: // military
                if (timezoneIndex === 0) {
                    timezone = ' +0000';
                } else {
                    timezoneIndex = military.indexOf(match[5][1].toUpperCase()) - 12;
                    timezone = ((timezoneIndex < 0) ? ' -' : ' +') +
                        (('' + timezoneIndex).replace(/^-?/, '0')).match(/..$/)[0] + '00';
                }
                break;
            case 4: // Zone
                timezone = timezones[match[5]];
                break;
            default: // UT or +/-9999
                timezone = timezones[' GMT'];
        }
        match[5] = timezone;
        config._i = match.splice(1).join('');
        tzFormat = ' ZZ';
        config._f = dayFormat + dateFormat + timeFormat + tzFormat;
        configFromStringAndFormat(config);
        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

function isDurationValid(m) {
    for (var key in m) {
        if (!(ordering.indexOf(key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
        }
    }

    var unitHasDecimal = false;
    for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        delta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    if (units === 'year' || units === 'month' || units === 'quarter') {
        output = monthDiff(this, that);
        if (units === 'quarter') {
            output = output / 3;
        } else if (units === 'year') {
            output = output / 12;
        }
    } else {
        delta = this - that;
        output = units === 'second' ? delta / 1e3 : // 1000
            units === 'minute' ? delta / 6e4 : // 1000 * 60
            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
            delta;
    }
    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString() {
    if (!this.isValid()) {
        return null;
    }
    var m = this.clone().utc();
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        return this.toDate().toISOString();
    }
    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ?
      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
      locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0], 10);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$2;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;

// Year
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;

// Week Year
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;

// Quarter
proto.quarter = proto.quarters = getSetQuarter;

// Month
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;

// Week
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;

// Day
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;

// Hour
proto.hour = proto.hours = getSetHour;

// Minute
proto.minute = proto.minutes = getSetMinute;

// Second
proto.second = proto.seconds = getSetSecond;

// Millisecond
proto.millisecond = proto.milliseconds = getSetMillisecond;

// Offset
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;

// Timezone
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;

// Deprecations
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

// Month
proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;

// Week
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

// Day of Week
proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

// Hours
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports
hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function get$2 (units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    ss: 44,         // a few seconds to seconds
    s : 45,         // seconds to minute
    m : 45,         // minutes to hour
    h : 22,         // hours to day
    d : 26,         // days to month
    M : 11          // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds <= thresholds.ss && ['s', seconds]  ||
            seconds < thresholds.s   && ['ss', seconds] ||
            minutes <= 1             && ['m']           ||
            minutes < thresholds.m   && ['mm', minutes] ||
            hours   <= 1             && ['h']           ||
            hours   < thresholds.h   && ['hh', hours]   ||
            days    <= 1             && ['d']           ||
            days    < thresholds.d   && ['dd', days]    ||
            months  <= 1             && ['M']           ||
            months  < thresholds.M   && ['MM', months]  ||
            years   <= 1             && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize (withSuffix) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds;
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    return (total < 0 ? '-' : '') +
        'P' +
        (Y ? Y + 'Y' : '') +
        (M ? M + 'M' : '') +
        (D ? D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? h + 'H' : '') +
        (m ? m + 'M' : '') +
        (s ? s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.isValid        = isValid$1;
proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

// Deprecations
proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports


hooks.version = '2.18.1';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;

return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(234)(module)))

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(26);
var core = __webpack_require__(56);
var hide = __webpack_require__(42);
var redefine = __webpack_require__(43);
var ctx = __webpack_require__(50);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  scopeId,
  cssModules
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  // inject cssModules
  if (cssModules) {
    var computed = options.computed || (options.computed = {})
    Object.keys(cssModules).forEach(function (key) {
      var module = cssModules[key]
      computed[key] = function () { return module }
    })
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var isDate = __webpack_require__(203)

var MILLISECONDS_IN_HOUR = 3600000
var MILLISECONDS_IN_MINUTE = 60000
var DEFAULT_ADDITIONAL_DIGITS = 2

var parseTokenDateTimeDelimeter = /[T ]/
var parseTokenPlainTime = /:/

// year tokens
var parseTokenYY = /^(\d{2})$/
var parseTokensYYY = [
  /^([+-]\d{2})$/, // 0 additional digits
  /^([+-]\d{3})$/, // 1 additional digit
  /^([+-]\d{4})$/ // 2 additional digits
]

var parseTokenYYYY = /^(\d{4})/
var parseTokensYYYYY = [
  /^([+-]\d{4})/, // 0 additional digits
  /^([+-]\d{5})/, // 1 additional digit
  /^([+-]\d{6})/ // 2 additional digits
]

// date tokens
var parseTokenMM = /^-(\d{2})$/
var parseTokenDDD = /^-?(\d{3})$/
var parseTokenMMDD = /^-?(\d{2})-?(\d{2})$/
var parseTokenWww = /^-?W(\d{2})$/
var parseTokenWwwD = /^-?W(\d{2})-?(\d{1})$/

// time tokens
var parseTokenHH = /^(\d{2}([.,]\d*)?)$/
var parseTokenHHMM = /^(\d{2}):?(\d{2}([.,]\d*)?)$/
var parseTokenHHMMSS = /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/

// timezone tokens
var parseTokenTimezone = /([Z+-].*)$/
var parseTokenTimezoneZ = /^(Z)$/
var parseTokenTimezoneHH = /^([+-])(\d{2})$/
var parseTokenTimezoneHHMM = /^([+-])(\d{2}):?(\d{2})$/

/**
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If an argument is a string, the function tries to parse it.
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If all above fails, the function passes the given argument to Date constructor.
 *
 * @param {Date|String|Number} argument - the value to convert
 * @param {Object} [options] - the object with options
 * @param {0 | 1 | 2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = parse('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Parse string '+02014101',
 * // if the additional number of digits in the extended year format is 1:
 * var result = parse('+02014101', {additionalDigits: 1})
 * //=> Fri Apr 11 2014 00:00:00
 */
function parse (argument, dirtyOptions) {
  if (isDate(argument)) {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime())
  } else if (typeof argument !== 'string') {
    return new Date(argument)
  }

  var options = dirtyOptions || {}
  var additionalDigits = options.additionalDigits
  if (additionalDigits == null) {
    additionalDigits = DEFAULT_ADDITIONAL_DIGITS
  } else {
    additionalDigits = Number(additionalDigits)
  }

  var dateStrings = splitDateString(argument)

  var parseYearResult = parseYear(dateStrings.date, additionalDigits)
  var year = parseYearResult.year
  var restDateString = parseYearResult.restDateString

  var date = parseDate(restDateString, year)

  if (date) {
    var timestamp = date.getTime()
    var time = 0
    var offset

    if (dateStrings.time) {
      time = parseTime(dateStrings.time)
    }

    if (dateStrings.timezone) {
      offset = parseTimezone(dateStrings.timezone)
    } else {
      // get offset accurate to hour in timezones that change offset
      offset = new Date(timestamp + time).getTimezoneOffset()
      offset = new Date(timestamp + time + offset * MILLISECONDS_IN_MINUTE).getTimezoneOffset()
    }

    return new Date(timestamp + time + offset * MILLISECONDS_IN_MINUTE)
  } else {
    return new Date(argument)
  }
}

function splitDateString (dateString) {
  var dateStrings = {}
  var array = dateString.split(parseTokenDateTimeDelimeter)
  var timeString

  if (parseTokenPlainTime.test(array[0])) {
    dateStrings.date = null
    timeString = array[0]
  } else {
    dateStrings.date = array[0]
    timeString = array[1]
  }

  if (timeString) {
    var token = parseTokenTimezone.exec(timeString)
    if (token) {
      dateStrings.time = timeString.replace(token[1], '')
      dateStrings.timezone = token[1]
    } else {
      dateStrings.time = timeString
    }
  }

  return dateStrings
}

function parseYear (dateString, additionalDigits) {
  var parseTokenYYY = parseTokensYYY[additionalDigits]
  var parseTokenYYYYY = parseTokensYYYYY[additionalDigits]

  var token

  // YYYY or ±YYYYY
  token = parseTokenYYYY.exec(dateString) || parseTokenYYYYY.exec(dateString)
  if (token) {
    var yearString = token[1]
    return {
      year: parseInt(yearString, 10),
      restDateString: dateString.slice(yearString.length)
    }
  }

  // YY or ±YYY
  token = parseTokenYY.exec(dateString) || parseTokenYYY.exec(dateString)
  if (token) {
    var centuryString = token[1]
    return {
      year: parseInt(centuryString, 10) * 100,
      restDateString: dateString.slice(centuryString.length)
    }
  }

  // Invalid ISO-formatted year
  return {
    year: null
  }
}

function parseDate (dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) {
    return null
  }

  var token
  var date
  var month
  var week

  // YYYY
  if (dateString.length === 0) {
    date = new Date(0)
    date.setUTCFullYear(year)
    return date
  }

  // YYYY-MM
  token = parseTokenMM.exec(dateString)
  if (token) {
    date = new Date(0)
    month = parseInt(token[1], 10) - 1
    date.setUTCFullYear(year, month)
    return date
  }

  // YYYY-DDD or YYYYDDD
  token = parseTokenDDD.exec(dateString)
  if (token) {
    date = new Date(0)
    var dayOfYear = parseInt(token[1], 10)
    date.setUTCFullYear(year, 0, dayOfYear)
    return date
  }

  // YYYY-MM-DD or YYYYMMDD
  token = parseTokenMMDD.exec(dateString)
  if (token) {
    date = new Date(0)
    month = parseInt(token[1], 10) - 1
    var day = parseInt(token[2], 10)
    date.setUTCFullYear(year, month, day)
    return date
  }

  // YYYY-Www or YYYYWww
  token = parseTokenWww.exec(dateString)
  if (token) {
    week = parseInt(token[1], 10) - 1
    return dayOfISOYear(year, week)
  }

  // YYYY-Www-D or YYYYWwwD
  token = parseTokenWwwD.exec(dateString)
  if (token) {
    week = parseInt(token[1], 10) - 1
    var dayOfWeek = parseInt(token[2], 10) - 1
    return dayOfISOYear(year, week, dayOfWeek)
  }

  // Invalid ISO-formatted date
  return null
}

function parseTime (timeString) {
  var token
  var hours
  var minutes

  // hh
  token = parseTokenHH.exec(timeString)
  if (token) {
    hours = parseFloat(token[1].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR
  }

  // hh:mm or hhmm
  token = parseTokenHHMM.exec(timeString)
  if (token) {
    hours = parseInt(token[1], 10)
    minutes = parseFloat(token[2].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE
  }

  // hh:mm:ss or hhmmss
  token = parseTokenHHMMSS.exec(timeString)
  if (token) {
    hours = parseInt(token[1], 10)
    minutes = parseInt(token[2], 10)
    var seconds = parseFloat(token[3].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE +
      seconds * 1000
  }

  // Invalid ISO-formatted time
  return null
}

function parseTimezone (timezoneString) {
  var token
  var absoluteOffset

  // Z
  token = parseTokenTimezoneZ.exec(timezoneString)
  if (token) {
    return 0
  }

  // ±hh
  token = parseTokenTimezoneHH.exec(timezoneString)
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  // ±hh:mm or ±hhmm
  token = parseTokenTimezoneHHMM.exec(timezoneString)
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60 + parseInt(token[3], 10)
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  return 0
}

function dayOfISOYear (isoYear, week, day) {
  week = week || 0
  day = day || 0
  var date = new Date(0)
  date.setUTCFullYear(isoYear, 0, 4)
  var fourthOfJanuaryDay = date.getUTCDay() || 7
  var diff = week * 7 + day + 1 - fourthOfJanuaryDay
  date.setUTCDate(date.getUTCDate() + diff)
  return date
}

module.exports = parse


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__settings__ = __webpack_require__(237);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }





var GeoFire = __webpack_require__(1143);

var _require = __webpack_require__(40),
    map = _require.map;



var app = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp(ENV.firebase);
var auth = app.auth();
var database = app.database();

var geoRef = database.ref('realestate_locations');
var geoFire = new GeoFire(geoRef);

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

// GEOHASH METHODS

var BITS = [16, 8, 4, 2, 1];

var BASE32 = '0123456789bcdefghjkmnpqrstuvwxyz';
var NEIGHBORS = {
    right: { even: 'bc01fg45238967deuvhjyznpkmstqrwx' },
    left: { even: '238967debc01fg45kmstqrwxuvhjyznp' },
    top: { even: 'p0r21436x8zb9dcf5h7kjnmqesgutwvy' },
    bottom: { even: '14365h7k9dcfesgujnmqp0r2twvyx8zb' }
};
var BORDERS = {
    right: { even: 'bcfguvyz' },
    left: { even: '0145hjnp' },
    top: { even: 'prxz' },
    bottom: { even: '028b' }
};

NEIGHBORS.bottom.odd = NEIGHBORS.left.even;
NEIGHBORS.top.odd = NEIGHBORS.right.even;
NEIGHBORS.left.odd = NEIGHBORS.bottom.even;
NEIGHBORS.right.odd = NEIGHBORS.top.even;

BORDERS.bottom.odd = BORDERS.left.even;
BORDERS.top.odd = BORDERS.right.even;
BORDERS.left.odd = BORDERS.bottom.even;
BORDERS.right.odd = BORDERS.top.even;

function refine_interval(interval, cd, mask) {
    if (cd & mask) interval[0] = (interval[0] + interval[1]) / 2;else interval[1] = (interval[0] + interval[1]) / 2;
}

function calculateAdjacent(srcHash, dir) {
    srcHash = srcHash.toLowerCase();
    var lastChr = srcHash.charAt(srcHash.length - 1);
    var type = srcHash.length % 2 ? 'odd' : 'even';
    var base = srcHash.substring(0, srcHash.length - 1);
    if (BORDERS[dir][type].indexOf(lastChr) !== -1) base = calculateAdjacent(base, dir);
    return base + BASE32[NEIGHBORS[dir][type].indexOf(lastChr)];
}

function decodeGeoHash(geohash) {
    var is_even = 1;
    var lat = [];
    var lon = [];
    lat[0] = -90.0;
    lat[1] = 90.0;
    lon[0] = -180.0;
    lon[1] = 180.0;
    var lat_err = 90.0;
    var lon_err = 180.0;

    for (i = 0; i < geohash.length; i++) {
        c = geohash[i];
        cd = BASE32.indexOf(c);
        for (j = 0; j < 5; j++) {
            mask = BITS[j];
            if (is_even) {
                lon_err /= 2;
                refine_interval(lon, cd, mask);
            } else {
                lat_err /= 2;
                refine_interval(lat, cd, mask);
            }
            is_even = !is_even;
        }
    }
    lat[2] = (lat[0] + lat[1]) / 2;
    lon[2] = (lon[0] + lon[1]) / 2;

    return { latitude: lat, longitude: lon };
}

function encodeGeoHash(latitude, longitude) {
    var is_even = 1;
    var i = 0;
    var lat = [];
    var lon = [];
    var bit = 0;
    var ch = 0;
    var precision = 12;
    var geohash = '';

    lat[0] = -90.0;
    lat[1] = 90.0;
    lon[0] = -180.0;
    lon[1] = 180.0;

    while (geohash.length < precision) {
        if (is_even) {
            var mid = (lon[0] + lon[1]) / 2;
            if (longitude > mid) {
                ch |= BITS[bit];
                lon[0] = mid;
            } else lon[1] = mid;
        } else {
            var _mid = (lat[0] + lat[1]) / 2;
            if (latitude > _mid) {
                ch |= BITS[bit];
                lat[0] = _mid;
            } else lat[1] = _mid;
        }

        is_even = !is_even;
        if (bit < 4) bit++;else {
            geohash += BASE32[ch];
            bit = 0;
            ch = 0;
        }
    }
    return geohash;
}

// END OF GEOHASH METHODS

/* harmony default export */ __webpack_exports__["a"] = ({
    set_new: function set_new(data) {
        console.log('--- api.js set_new');
        console.log('data: ');
        console.log(data);
        console.log('----------');

        return new Promise(function (resolve, reject) {
            var dateCreated = __WEBPACK_IMPORTED_MODULE_2_moment___default()().valueOf();
            var object = {
                date_created: dateCreated,
                date_modified: dateCreated
            };
            var ref = database.ref(data.path + data.key);
            return ref.set(object).then(function (res) {
                return resolve({
                    key: data.key,
                    date_created: dateCreated,
                    date_modified: dateCreated,
                    path: data.path
                });
            });
        });
    },
    set_value: function set_value(data) {

        console.log('--- api.js set_value');
        console.log('path: ');
        console.log(data.path);
        console.log('value: ');
        console.log(data.value);
        console.log('----------');

        return new Promise(function (resolve, reject) {
            var ref = database.ref(data.path);
            var dateModified = __WEBPACK_IMPORTED_MODULE_2_moment___default()().valueOf();
            /*if(data.save_timestamp === true){
             data.object['date_modified'] = dateModified
             }*/
            return ref.set(data.value).then(function (res) {
                return resolve({ date_modified: dateModified });
            }).catch(function (err) {
                reject();
                console.log('error catched...');
                console.log(err);
            });
        });
    },
    update: function update(data) {
        console.log('--- api.js update');
        console.log('path: ');
        console.log(data.path);
        console.log('object: ');
        console.log(data.object);
        console.log('----------');
        return new Promise(function (resolve, reject) {
            var ref = database.ref(data.path);
            var dateModified = __WEBPACK_IMPORTED_MODULE_2_moment___default()().valueOf();
            if (data.save_timestamp === true) {
                data.object.date_modified = dateModified;
            }
            return ref.update(data.object).then(function (res) {
                return resolve({ date_modified: dateModified });
            }).catch(function (err) {
                reject();
                console.log('error catched...');
                console.log(err);
            });
        });
    },
    create: function create(data) {
        console.log('--- api.js create');
        console.log('path: ');
        console.log(data.path);
        console.log('----------');
        return new Promise(function (resolve, reject) {
            var dateCreated = __WEBPACK_IMPORTED_MODULE_2_moment___default()().valueOf();
            var object = {
                date_created: dateCreated,
                date_modified: dateCreated,
                path: check_undefined(data.path),
                parent_path: check_undefined(data.parent_path)
            };
            var ref = database.ref(data.path);
            return ref.push(object).then(function (res) {
                return resolve({
                    key: res.key,
                    date_created: dateCreated,
                    date_modified: dateCreated,
                    path: check_undefined(data.path),
                    parent_path: check_undefined(data.parent_path)
                });
            }).catch(function (err) {
                reject();
                console.log('error catched...');
                console.log(err);
            });
        });
    },
    delete: function _delete(data) {
        console.log('--- api.js delete');
        console.log('path: ');
        console.log(data.path);
        console.log('----------');
        return new Promise(function (resolve, reject) {
            var ref = database.ref(data.path);
            var dateModified = __WEBPACK_IMPORTED_MODULE_2_moment___default()().valueOf();
            return ref.remove().then(function (res) {
                return resolve({ date_modified: dateModified });
            }).catch(function (err) {
                reject();
                console.log('error catched...');
                console.log(err);
            });
        });
    },
    queryGeohash: function queryGeohash(data) {
        console.log('--- api.js queryGeohash');
        console.log('radius: ');
        console.log(data.distance_km);
        console.log('lat: ');
        console.log(data.lat);
        console.log('lng: ');
        console.log(data.lng);
        console.log('----------');

        /*
         return new Promise((resolve, reject) => {
         geoFire.query({
         center: [data.lat, data.lng],
         radius: data.distance_km
         }).then(function() {
         console.log("Query has been done to GeoFire")
         resolve()
         }, function(error) {
         console.log("Error: " + error)
         reject()
         })
         })
         */

        var querytest = geoFire.query({
            center: [data.lat, data.lng],
            radius: data.distance_km
        });

        querytest.on('key_entered', function (key, location, distance) {
            console.log(key + ' is located at [' + location + '] which is within the query (' + distance.toFixed(2) + ' km from center)');
        });
    },
    getGeohash: function getGeohash(data) {
        console.log('--- api.js setGeohash');
        console.log('key: ');
        console.log(data.key);
        console.log('lat: ');
        console.log(data.lat);
        console.log('lng: ');
        console.log(data.lng);
        console.log('----------');

        return new Promise(function (resolve, reject) {

            var geohash = encodeGeoHash(data.lat, data.lng);
            resolve({ geohash: geohash });

            /*
             geoFire.set(data.key, [data.lat, data.lng]).then(function () {
             console.log('Provided key has been added to GeoFire')
             resolve()
             }, function (error) {
             console.log('Error: ' + error)
             reject()
             })
             */
        });
    },
    logIn: function logIn(email, password) {
        return auth.signInWithEmailAndPassword(email, password);
    },
    logOut: function logOut() {
        return auth.signOut();
    },
    signUp: function signUp(email, password) {
        return auth.createUserWithEmailAndPassword(email, password);
    },
    initNotesForUserId: function initNotesForUserId(userId) {
        var _this = this;

        var vm = this;
        return new Promise(function (resolve, reject) {
            return _this.getDefaultNotes().then(function (notes) {
                var dateModified = __WEBPACK_IMPORTED_MODULE_2_moment___default()().toString();
                __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forEach(notes, function (note, key) {
                    note.date_modified = dateModified;
                    note.date_created = dateModified;
                    vm.createNote(userId, note);
                });
                vm.updateTheme(userId, 'light');
                vm.updateRole(userId, 'guest');
                resolve(true);
            });
        });
    },
    get: function get(data) {
        console.log('--- api.js get');
        console.log('path: ');
        console.log(data.path);
        console.log('----------');
        return new Promise(function (resolve, reject) {
            var ref = database.ref(data.path);
            return ref.once('value').then(function (res) {
                return resolve(res.val());
            });
        });
    },
    getAllChildren: function getAllChildren(data) {
        console.log('--- api.js getAllChildren');
        console.log('path: ');
        console.log(data.path);
        console.log('----------');

        var all_children = [];

        return new Promise(function (resolve, reject) {
            var ref = database.ref(data.path);
            return ref.once('value').then(function (snapshot) {

                snapshot.forEach(function (childSnapshot) {
                    //Here you can access  childSnapshot.key

                    all_children.push(childSnapshot.val());
                }).then(function (res) {
                    return resolve({ all_children: all_children });
                });
            });
        });
    },
    getContacts: function getContacts() {
        return new Promise(function (resolve, reject) {
            var contactsRef = database.ref('contacts');
            return contactsRef.once('value').then(function (res) {
                return resolve(res.val());
            });
        });
    },
    getDefaultNotes: function getDefaultNotes() {
        return new Promise(function (resolve, reject) {
            var notesRef = database.ref('default_notes/notes');
            return notesRef.once('value').then(function (res) {
                return resolve(res.val());
            });
        });
    },
    getAppraisalIdsForUserId: function getAppraisalIdsForUserId(userId) {
        return new Promise(function (resolve, reject) {
            var userRef = database.ref('users/' + userId + '/appraisals');
            return userRef.once('value').then(function (res) {
                return resolve(res.val());
            });
        });
    },
    getAppraisal: function getAppraisal() {
        return new Promise(function (resolve, reject) {
            var userRef = database.ref('appraisals');
            return userRef.once('value').then(function (res) {
                return resolve(res.val());
            });
        });
    },
    getUserRole: function getUserRole(userId) {
        return new Promise(function (resolve, reject) {
            var rolesRef = database.ref('users/' + userId + '/roles');
            return rolesRef.once('value').then(function (res) {
                return resolve(res.val());
            });
        });
    },
    getDataForUserId: function getDataForUserId(userId) {
        return new Promise(function (resolve, reject) {
            var userRef = database.ref('users/' + userId);
            return userRef.once('value').then(function (res) {
                return resolve(res.val());
            });
        });
    },
    getValuationPrices: function getValuationPrices() {
        return new Promise(function (resolve, reject) {
            var valuationPricesRef = database.ref('valuation_prices');
            return valuationPricesRef.once('value').then(function (res) {
                return resolve(res.val());
            });
        });
    },
    getPreviewData: function getPreviewData() {
        return new Promise(function (resolve, reject) {
            var notesRef = database.ref('default_notes/notes');
            return notesRef.once('value').then(function (res) {
                var notes = {};
                var dateModified = __WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract(1, 'minute').toString();
                res.val().forEach(function (note) {
                    note.date_modified = dateModified;
                    notes[note.id] = note;
                });
                resolve({ notes: notes, theme: 'light' });
            });
        });
    },
    createNote: function createNote(userId, note) {
        return new Promise(function (resolve, reject) {
            var userNotesRef = database.ref('users/' + userId + '/notes');
            return userNotesRef.push(note).then(function (res) {
                return resolve(res.key);
            });
        });
    },
    updateBudgetRequest: function updateBudgetRequest(data) {
        return new Promise(function (resolve, reject) {
            var budgetRef = database.ref('budgetrequests');
            var timestamp = __WEBPACK_IMPORTED_MODULE_2_moment___default()().valueOf();
            return budgetRef.push({
                petitioner_name: data.petitioner_name,
                petitioner_surnames: data.petitioner_surnames,
                petitioner_company: data.petitioner_company,
                petitioner_email: data.petitioner_email,
                petitioner_telephone: data.petitioner_telephone,
                property_type: data.property_type,
                property_address: data.property_address,
                property_postal_code: data.property_postal_code,
                property_municipality: data.property_municipality,
                property_province: data.property_province,
                property_area: data.property_area,
                property_cadastral_reference: data.property_cadastral_reference,
                property_appraisal_purpose: data.property_appraisal_purpose,
                property_notes: data.property_notes,
                timestamp: timestamp
            }).then(function (res) {
                return resolve({ data: data, timestamp: timestamp });
            });
        });
    },
    updateNote: function updateNote(userId, key, note) {
        return new Promise(function (resolve, reject) {
            var notesRef = database.ref('users/' + userId + '/notes/' + key);
            var dateModified = __WEBPACK_IMPORTED_MODULE_2_moment___default()().toString();
            return notesRef.update({
                name: note.name,
                body: note.body,
                date_modified: dateModified
            }).then(function (res) {
                return resolve({ key: key, date_modified: dateModified });
            });
        });
    },
    deleteNote: function deleteNote(userId, key) {
        var notesRef = database.ref('users/' + userId + '/notes/' + key);
        return notesRef.remove();
    },
    updateLanguage: function updateLanguage(userId, language) {
        return new Promise(function (resolve, reject) {
            var userRef = database.ref('users/' + userId);
            return userRef.update({ language: language }).then(function (res) {
                return resolve(language);
            });
        });
    },
    updateTheme: function updateTheme(userId, theme) {
        return new Promise(function (resolve, reject) {
            var userRef = database.ref('users/' + userId);
            return userRef.update({ theme: theme }).then(function (res) {
                return resolve(theme);
            });
        });
    },
    updateRole: function updateRole(userId, role) {
        return new Promise(function (resolve, reject) {
            var userRef = database.ref('users/' + userId);
            return userRef.update({ role: role }).then(function (res) {
                return resolve(role);
            });
        });
    },
    updateUserInitialData: function updateUserInitialData(userId, data) {
        return new Promise(function (resolve, reject) {
            var userRef = database.ref('users/' + userId);
            return userRef.update({ name: data.name, surnames: data.surnames, company: data.company }).then(function (res) {
                return resolve(data);
            });
        });
    },
    getPublicNoteForId: function getPublicNoteForId(noteId) {
        return new Promise(function (resolve, reject) {
            var noteRef = database.ref('public_notes/' + noteId);
            return noteRef.on('value', function (snapshot) {
                var data = snapshot.val();
                if (data) {
                    var notesRef = database.ref('users/' + data.user_id + '/notes/' + data.note_id);
                    notesRef.on('value', function (snapshot) {
                        var note = snapshot.val();
                        resolve(note);
                    });
                } else {
                    reject('Nothing here.');
                }
            });
        });
    },
    toggleIsPublic: function toggleIsPublic(userId, key, note) {
        var is_public = !note.is_public;
        return new Promise(function (resolve, reject) {
            var notesRef = database.ref('users/' + userId + '/notes/' + key);
            return notesRef.update({
                is_public: is_public
            }).then(function (res) {
                var publicNoteRef = database.ref('public_notes/' + key);
                if (is_public) {
                    publicNoteRef.set({
                        user_id: userId,
                        note_id: key
                    });
                } else {
                    publicNoteRef.remove();
                }
                resolve({ key: key, is_public: is_public });
            });
        });
    },
    deleteImage: function deleteImage(data) {
        return new Promise(function (resolve, reject) {
            var path = data.path;
            var filename = data.filename;
            console.log('--> delete Photograph');
            console.log('path: ' + path);

            // Get a reference to the storage service, which is used to create references in your storage bucket
            var storage = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.storage();
            // Create a storage reference from our storage service
            var storageRef = storage.ref();
            // Create a reference to the file to delete
            var imageRef = storageRef.child(path + filename);

            // Delete the file
            imageRef.delete().then(function () {
                // File deleted successfully
                resolve();
            }).catch(function (error) {
                // Uh-oh, an error occurred!
                reject();
            });
        });
    },
    uploadImages: function uploadImages(data) {
        return new Promise(function (resolve, reject) {
            var path = data.path;
            var files = data.files;
            var storageRef = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.storage().ref(path);

            var inCreate = function inCreate(data) {
                return new Promise(function (resolve, reject) {
                    var dateCreated = __WEBPACK_IMPORTED_MODULE_2_moment___default()().valueOf();
                    var object = {
                        date_created: dateCreated,
                        date_modified: dateCreated,
                        path: check_undefined(data.path),
                        parent_path: check_undefined(data.parent_path)
                    };
                    var ref = database.ref(data.path);
                    return ref.push(object).then(function (res) {
                        return resolve({
                            key: res.key,
                            date_created: dateCreated,
                            date_modified: dateCreated,
                            path: check_undefined(data.path),
                            parent_path: check_undefined(data.parent_path)
                        });
                    }).catch(function (err) {
                        reject();
                        console.log('error catched...');
                        console.log(err);
                    });
                });
            };

            var inSetValue = function inSetValue(data) {
                console.log('--- api.js set_value');
                console.log('path: ');
                console.log(data.path);
                console.log('value: ');
                console.log(data.value);
                console.log('----------');

                return new Promise(function (resolve, reject) {
                    var ref = database.ref(data.path);
                    var dateModified = __WEBPACK_IMPORTED_MODULE_2_moment___default()().valueOf();
                    /*if(data.save_timestamp === true){
                     data.object['date_modified'] = dateModified
                     }*/
                    return ref.set(data.value).then(function (res) {
                        return resolve({ date_modified: dateModified });
                    }).catch(function (err) {
                        reject();
                        console.log('error catched...');
                        console.log(err);
                    });
                });
            };

            var isImage = function isImage(file) {
                return file['type'].split('/')[0] === 'image';
                //returns true or false
            };

            var uploadFile = function uploadFile(file) {

                return new Promise(function (resolve, reject) {
                    if (isImage(file)) {

                        inCreate({ path: data.path }).then(function (res) {
                            // console.log(res)
                            var key = res.key;
                            var date_created = res.date_created;
                            var date_modified = res.date_modified;
                            var path = res.path;

                            inSetValue({
                                path: data.path + key + '/' + 'id',
                                value: key
                            }).then(function (res) {
                                inSetValue({
                                    path: data.path + key + '/' + 'filename',
                                    value: file.name
                                }).then(function (res) {
                                    inSetValue({
                                        path: data.path + key + '/' + 'date_created',
                                        value: date_created
                                    }).then(function (res) {
                                        inSetValue({
                                            path: data.path + key + '/' + 'date_modified',
                                            value: date_modified
                                        }).then(function (res) {
                                            inSetValue({
                                                path: data.path + key + '/' + 'path',
                                                value: path
                                            }).then(function (res) {

                                                var thisRef = storageRef.child(key + '/' + file.name);
                                                return thisRef.put(file).then(function (snapshot) {
                                                    console.log('Uploaded a blob or file!');
                                                }).then(function (result) {
                                                    //get request to get URL for uploaded file
                                                    thisRef.getDownloadURL().then(function (url) {
                                                        console.log(url);

                                                        inSetValue({
                                                            path: data.path + key + '/' + 'url',
                                                            value: url
                                                        }).then(function (res) {

                                                            resolve();
                                                        });
                                                    });
                                                });
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    } else {
                        alert('L\'arxiu "' + file.name + '" no és una imatge! No s\'ha carregat. Només s\'accepten arxius en format imatge');
                    }
                });
            };

            /*
                return Promise.all(filesArray.map(function (file) {
                     if (isImage(file)) {
                        let thisRef = storageRef.child(file.name)
                        return thisRef.put(file).then(function (snapshot) {
                            console.log('Uploaded a blob or file!')
                        }).then(function (result) {
                            //get request to get URL for uploaded file
                            thisRef.getDownloadURL().then(function (url) {
                                console.log(url)
                                inCreate({path: 'realestate_appraisals/' + data.path}).then(res => {
                                    // console.log(res)
                                    let key = res.key
                                    let date_created = res.date_created
                                    let date_modified = res.date_modified
                                    let path = res.path
                                     inSetValue({
                                        path: 'realestate_appraisals/' + data.path + key + '/' + 'url',
                                        value: url
                                    }).then(res => {
                                        inSetValue({
                                            path: 'realestate_appraisals/' + data.path + key + '/' + 'id',
                                            value: key
                                        }).then(res => {
                                            inSetValue({
                                                path: 'realestate_appraisals/' + data.path + key + '/' + 'filename',
                                                value: file.name
                                            }).then(res => {
                                                inSetValue({
                                                    path: 'realestate_appraisals/' + data.path + key + '/' + 'date_created',
                                                    value: date_created
                                                }).then(res => {
                                                    inSetValue({
                                                        path: 'realestate_appraisals/' + data.path + key + '/' + 'date_modified',
                                                        value: date_modified
                                                    }).then(res => {
                                                        inSetValue({
                                                            path: 'realestate_appraisals/' + data.path + key + '/' + 'path',
                                                            value: path
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    } else {
                        alert('L\'arxiu "' + file.name + '" no és una imatge! No s\'ha carregat. Només s\'accepten arxius en format imatge')
                    }
                 }))
                */

            // set it up
            storageRef.constructor.prototype.putFiles = function (files) {
                var ref = this;
                var filesArray = [].concat(_toConsumableArray(files));
                return new Promise(function (resolve, reject) {
                    map(filesArray, function (file) {
                        return uploadFile(file).then(function (result) {

                            resolve();
                        });
                    });
                });
            };

            // use it!
            storageRef.putFiles(files).then(function (metadatas) {
                // Get an array of file metadata
                resolve();
            }).catch(function (error) {
                // If any task fails, handle this
                reject();
            });
        });
    }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_LANGUAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_THEME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_94", function() { return SET_TAGS_DISPLAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_116", function() { return SET_VALUATION_PRICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_RESULT_INDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_RENAMING_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_EDITING_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_118", function() { return UPDATE_BUDGET_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_115", function() { return SET_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_NOTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_ACTIVE_CONTACT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_ACTIVE_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_ACTIVE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_574", function() { return SET_APPRAISALFILES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_114", function() { return SET_USER_ROLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_99", function() { return SET_BECPROPERTIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_117", function() { return CREATE_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_119", function() { return TOGGLE_IS_PUBLIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_95", function() { return SET_BDE_APPRAISAL_FILES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_96", function() { return SET_BDE_REALESTATE_FILES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_97", function() { return SET_BDE_COMPARABLE_FILES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_98", function() { return SET_BDE_RELATIONSHIPS_FILES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_112", function() { return SET_STATS_CURRENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_102", function() { return SET_APPRAISALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_105", function() { return SET_MARKETSTUDIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_106", function() { return SET_AD_COMPARABLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_103", function() { return SET_WARNINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_104", function() { return SET_CONSTRAINTS; });
/* unused harmony export CREATE_NEW_AD */
/* unused harmony export DELETE_AD */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_997", function() { return RESET_AD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_998", function() { return SET_AD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1010", function() { return SET_AD_CADASTRAL_REFERENCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1009", function() { return SET_AD_CENSUS_SECTION_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1011", function() { return SET_AD_COUNTRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_994", function() { return SET_AD_DATE_CREATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_995", function() { return SET_AD_DATE_MODIFIED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1012", function() { return SET_AD_DESCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1019", function() { return SET_AD_DIRTYNESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1013", function() { return SET_AD_DOOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1006", function() { return SET_AD_EPSG25831_X; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1007", function() { return SET_AD_EPSG25831_Y; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1014", function() { return SET_AD_FLOOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1008", function() { return SET_AD_GEOHASH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_999", function() { return SET_AD_GOOGLE_FORMATTED_ADDRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1000", function() { return SET_AD_GOOGLE_VIEWPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_993", function() { return SET_AD_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1001", function() { return SET_AD_LAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1002", function() { return SET_AD_LNG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1015", function() { return SET_AD_MUNICIPALITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1016", function() { return SET_AD_PARENT_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_996", function() { return SET_AD_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1003", function() { return SET_AD_POSTAL_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1017", function() { return SET_AD_PROVINCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1018", function() { return SET_AD_STAIRCASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1004", function() { return SET_AD_STREET_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1005", function() { return SET_AD_STREET_NUMBER; });
/* unused harmony export UPDATE_AD */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1020", function() { return SET_AD_CADASTRAL_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1021", function() { return SET_AD_REGISTRY_IDUFIR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1022", function() { return SET_AD_AD_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1023", function() { return SET_AD_AD_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1024", function() { return SET_AD_AD_YEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1025", function() { return SET_AD_ADOPTED_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1026", function() { return SET_AD_ADOPTED_AGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1027", function() { return SET_AD_AIR_CONDITIONING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1028", function() { return SET_AD_BATHROOMS_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1029", function() { return SET_AD_BEDROOMS_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1030", function() { return SET_AD_COVERED_OUTDOOR_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1031", function() { return SET_AD_UNCOVERED_OUTDOOR_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1032", function() { return SET_AD_CONSTRUCTION_YEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1033", function() { return SET_AD_DWELLING_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1034", function() { return SET_AD_ESTIMATED_SALE_PRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1035", function() { return SET_AD_EXTERNAL_STORAGE_ROOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1036", function() { return SET_AD_FLOOR_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1037", function() { return SET_AD_FLOOR_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1038", function() { return SET_AD_GREEN_AREAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1039", function() { return SET_AD_HEATING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1040", function() { return SET_AD_LAST_RENOVATION_YEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1041", function() { return SET_AD_LIFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1042", function() { return SET_AD_OFFER_PRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1043", function() { return SET_AD_PARKING_LOTS_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1044", function() { return SET_AD_QUALITY_OF_NEIGHBOURHOOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1045", function() { return SET_AD_QUALITY_OF_SITUATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1046", function() { return SET_AD_QUALITY_OF_CONSTRUCTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1047", function() { return SET_AD_QUALITY_OF_REALESTATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1048", function() { return SET_AD_SPORTS_FACILITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1049", function() { return SET_AD_SWIMMING_POOL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1050", function() { return SET_AD_AD_ADDRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1051", function() { return SET_AD_BUILT_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1052", function() { return SET_AD_CAPTURE_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1053", function() { return SET_AD_AD_DATA_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1054", function() { return SET_AD_AD_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1055", function() { return SET_AD_INTERIOR_VISIT_CHECK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1056", function() { return SET_AD_LAND_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1057", function() { return SET_AD_NET_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1058", function() { return SET_AD_CADASTRAL_DATA_CHECK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1059", function() { return SET_AD_CONTACT_TELEPHONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1060", function() { return SET_AD_NOTES_1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1061", function() { return SET_AD_NOTES_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1062", function() { return SET_AD_ORIENTATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1063", function() { return SET_AD_PROPERTY_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1064", function() { return SET_AD_SOURCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1065", function() { return SET_AD_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1066", function() { return SET_AD_BLOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1067", function() { return SET_AD_CONTACT_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1068", function() { return SET_AD_OFFER_UNIT_PRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1069", function() { return SET_AD_CONSERVATION_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1070", function() { return SET_AD_OFFER_PRICE_REDUCTION_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1071", function() { return SET_AD_ESTIMATED_UNIT_SALE_PRICE; });
/* unused harmony export CREATE_NEW_AD_COMPARABLE */
/* unused harmony export DELETE_AD_COMPARABLE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_376", function() { return RESET_AD_COMPARABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_377", function() { return SET_AD_COMPARABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_372", function() { return SET_AD_COMPARABLE_DATE_CREATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_373", function() { return SET_AD_COMPARABLE_DATE_MODIFIED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_378", function() { return SET_AD_COMPARABLE_DIRTYNESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_371", function() { return SET_AD_COMPARABLE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_374", function() { return SET_AD_COMPARABLE_PARENT_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_375", function() { return SET_AD_COMPARABLE_PATH; });
/* unused harmony export UPDATE_AD_COMPARABLE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_379", function() { return SET_AD_COMPARABLE_DESCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_992", function() { return SET_AD_MUNICIPALITIES; });
/* unused harmony export CREATE_NEW_REALESTATE */
/* unused harmony export DELETE_REALESTATE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_189", function() { return RESET_REALESTATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_190", function() { return SET_REALESTATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_202", function() { return SET_REALESTATE_CADASTRAL_REFERENCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_201", function() { return SET_REALESTATE_CENSUS_SECTION_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_203", function() { return SET_REALESTATE_COUNTRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_186", function() { return SET_REALESTATE_DATE_CREATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_187", function() { return SET_REALESTATE_DATE_MODIFIED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_204", function() { return SET_REALESTATE_DESCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_227", function() { return SET_REALESTATE_DIRTYNESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_205", function() { return SET_REALESTATE_DOOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_198", function() { return SET_REALESTATE_EPSG25831_X; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_199", function() { return SET_REALESTATE_EPSG25831_Y; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_206", function() { return SET_REALESTATE_FLOOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_207", function() { return SET_REALESTATE_FLOOR_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_200", function() { return SET_REALESTATE_GEOHASH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_191", function() { return SET_REALESTATE_GOOGLE_FORMATTED_ADDRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_192", function() { return SET_REALESTATE_GOOGLE_VIEWPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_185", function() { return SET_REALESTATE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_193", function() { return SET_REALESTATE_LAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_194", function() { return SET_REALESTATE_LNG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_208", function() { return SET_REALESTATE_MUNICIPALITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_209", function() { return SET_REALESTATE_PARENT_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_188", function() { return SET_REALESTATE_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_195", function() { return SET_REALESTATE_POSTAL_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_210", function() { return SET_REALESTATE_PROPERTY_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_211", function() { return SET_REALESTATE_PROVINCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_212", function() { return SET_REALESTATE_REGISTRY_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_213", function() { return SET_REALESTATE_STAIRCASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_196", function() { return SET_REALESTATE_STREET_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_197", function() { return SET_REALESTATE_STREET_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_214", function() { return SET_REALESTATE_MAP_GOOGLE_01_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_215", function() { return SET_REALESTATE_MAP_GOOGLE_01_LAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_216", function() { return SET_REALESTATE_MAP_GOOGLE_01_LNG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_217", function() { return SET_REALESTATE_MAP_GOOGLE_01_ZOOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_218", function() { return SET_REALESTATE_MAP_GOOGLE_02_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_219", function() { return SET_REALESTATE_MAP_GOOGLE_02_LAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_220", function() { return SET_REALESTATE_MAP_GOOGLE_02_LNG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_221", function() { return SET_REALESTATE_MAP_GOOGLE_02_ZOOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_222", function() { return SET_REALESTATE_MAP_GOOGLE_03_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_223", function() { return SET_REALESTATE_MAP_GOOGLE_03_LAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_224", function() { return SET_REALESTATE_MAP_GOOGLE_03_LNG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_225", function() { return SET_REALESTATE_MAP_GOOGLE_03_ZOOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_228", function() { return SET_REALESTATE_FULL_ADDRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_229", function() { return SET_REALESTATE_SHORT_ADDRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_230", function() { return SET_REALESTATE_BLOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_101", function() { return SET_REALESTATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_231", function() { return SET_REALESTATE_AREA_ADS_MARKERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_232", function() { return SET_REALESTATE_AREA_AVERAGE_PRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_233", function() { return SET_REALESTATE_AREA_AVERAGE_PRICE_COEF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_234", function() { return SET_REALESTATE_ADOPTED_AREA_AVERAGE_PRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_235", function() { return SET_REALESTATE_ESTIMATED_BUILT_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_236", function() { return SET_REALESTATE_PRE_APPRAISAL_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_237", function() { return SET_REALESTATE_TRAVEL_ONE_WAY_HOURS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_238", function() { return SET_REALESTATE_TRAVEL_BOTH_WAYS_HOURS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_239", function() { return SET_REALESTATE_TRAVEL_FEES_PER_HOUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_240", function() { return SET_REALESTATE_CAR_FUEL_EXPENSES_ONE_WAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_241", function() { return SET_REALESTATE_CAR_FUEL_EXPENSES_BOTH_WAYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_242", function() { return SET_REALESTATE_CAR_TOLL_EXPENSES_ONE_WAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_243", function() { return SET_REALESTATE_CAR_TOLL_EXPENSES_BOTH_WAYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_244", function() { return SET_REALESTATE_CAR_EXPENSES_ONE_WAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_245", function() { return SET_REALESTATE_CAR_EXPENSES_BOTH_WAYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_246", function() { return SET_REALESTATE_TOTAL_TRAVEL_FEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_248", function() { return SET_REALESTATE_QUOTE_BASE_FEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_249", function() { return SET_REALESTATE_QUOTE_EXCESS_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_250", function() { return SET_REALESTATE_QUOTE_BASE_PRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_251", function() { return SET_REALESTATE_QUOTE_BASE_PRICE_COEF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_247", function() { return SET_REALESTATE_QUOTE_APPRAISAL_TYPE_IS_ECO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_255", function() { return SET_REALESTATE_QUOTE_PRICE_INCL_TRAVEL_EXPENSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_252", function() { return SET_REALESTATE_AREA_ADS_QUERY_STARTDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_253", function() { return SET_REALESTATE_AREA_ADS_QUERY_LIMITDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_254", function() { return SET_REALESTATE_AREA_ADS_QUERY_DISTANCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_256", function() { return SET_REALESTATE_INVOICE_BASE_FEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_257", function() { return SET_REALESTATE_INVOICE_EXCESS_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_258", function() { return SET_REALESTATE_INVOICE_BASE_PRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_259", function() { return SET_REALESTATE_INVOICE_BASE_PRICE_COEF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_260", function() { return SET_REALESTATE_INVOICE_APPRAISAL_TYPE_IS_ECO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_261", function() { return SET_REALESTATE_QUOTE_EXCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_262", function() { return SET_REALESTATE_ASSET_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_263", function() { return SET_REALESTATE_DWELLING_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_226", function() { return SET_REALESTATE_FLOOR_TYPE; });
/* unused harmony export UPDATE_REALESTATE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_183", function() { return SET_ALL_REALESTATE_APPRAISALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_184", function() { return SET_REALESTATE_APPRAISALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_180", function() { return SET_REALESTATE_MARKETSTUDIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_181", function() { return SET_TEMP_REALESTATE_MARKETSTUDIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_177", function() { return SET_ALL_REALESTATE_PROJECTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_178", function() { return SET_REALESTATE_PROJECTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_179", function() { return SET_REALESTATE_MUNICIPALITIES; });
/* unused harmony export CREATE_NEW_APPRAISAL */
/* unused harmony export DELETE_APPRAISAL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_612", function() { return RESET_APPRAISAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_613", function() { return SET_APPRAISAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_606", function() { return SET_APPRAISAL_DATE_CREATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_607", function() { return SET_APPRAISAL_DATE_MODIFIED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_635", function() { return SET_APPRAISAL_DIRTYNESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_605", function() { return SET_APPRAISAL_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_609", function() { return SET_APPRAISAL_PARENT_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_610", function() { return SET_APPRAISAL_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_663", function() { return SET_APPRAISAL_PURPOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_664", function() { return SET_APPRAISAL_PURPOSE_NOTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_665", function() { return SET_APPRAISAL_TYPE; });
/* unused harmony export UPDATE_APPRAISAL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_608", function() { return SET_APPRAISAL_APPRAISALDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_633", function() { return SET_APPRAISAL_VISITDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_634", function() { return SET_APPRAISAL_TECHNICIAN_VISITING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_662", function() { return SET_APPRAISAL_DESCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_636", function() { return SET_APPRAISAL_CHECKS_CADASTRAL_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_637", function() { return SET_APPRAISAL_CHECKS_CONSERVATION_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_638", function() { return SET_APPRAISAL_CHECKS_EXPROPRIATION_PROCEDURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_639", function() { return SET_APPRAISAL_CHECKS_EXPROPRIATION_PLAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_640", function() { return SET_APPRAISAL_CHECKS_EXPROPRIATION_ADMIN_RULING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_641", function() { return SET_APPRAISAL_CHECKS_EXPROPRIATION_FILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_642", function() { return SET_APPRAISAL_CHECKS_INTERIOR_VISIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_643", function() { return SET_APPRAISAL_CHECKS_OCCUPANCY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_644", function() { return SET_APPRAISAL_CHECKS_OTHER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_645", function() { return SET_APPRAISAL_CHECKS_REGISTRY_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_646", function() { return SET_APPRAISAL_CHECKS_SERVITUDES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_647", function() { return SET_APPRAISAL_CHECKS_SUBSIDY_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_648", function() { return SET_APPRAISAL_CHECKS_URBAN_PLANNING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_649", function() { return SET_APPRAISAL_DOCS_APPROVED_PROJECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_650", function() { return SET_APPRAISAL_DOCS_CADASTRAL_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_651", function() { return SET_APPRAISAL_DOCS_CONSTRUCTION_LICENSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_652", function() { return SET_APPRAISAL_DOCS_CONSTRUCTION_LAST_CERTIFICATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_653", function() { return SET_APPRAISAL_DOCS_CONSTRUCTION_CONTRACT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_654", function() { return SET_APPRAISAL_DOCS_OCCUPANCY_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_991", function() { return SET_APPRAISAL_DOCS_OTHER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_655", function() { return SET_APPRAISAL_DOCS_PHOTOGRAPHIC_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_656", function() { return SET_APPRAISAL_DOCS_PROPERTY_SKETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_657", function() { return SET_APPRAISAL_DOCS_PROPERTY_TITLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_658", function() { return SET_APPRAISAL_DOCS_SITUATION_PLAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_659", function() { return SET_APPRAISAL_DOCS_SUBSIDY_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_660", function() { return SET_APPRAISAL_DOCS_TENYEAR_INSURANCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_661", function() { return SET_APPRAISAL_DOCS_URBAN_PLAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_666", function() { return SET_APPRAISAL_ADOPTED_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_667", function() { return SET_APPRAISAL_LIFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_668", function() { return SET_APPRAISAL_ADOPTED_AGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_670", function() { return SET_APPRAISAL_PROPERTY_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_671", function() { return SET_APPRAISAL_QUALITY_OF_NEIGHBOURHOOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_672", function() { return SET_APPRAISAL_QUALITY_OF_SITUATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_673", function() { return SET_APPRAISAL_QUALITY_OF_CONSTRUCTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_674", function() { return SET_APPRAISAL_QUALITY_OF_REALESTATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_675", function() { return SET_APPRAISAL_CONSERVATION_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_676", function() { return SET_APPRAISAL_FLOOR_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_677", function() { return SET_APPRAISAL_MARKET_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_678", function() { return SET_APPRAISAL_MARKET_UNIT_VALUE; });
/* unused harmony export SET_MARKET_VALUE_APPRAISER_ADJUSTMENT_PCT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_739", function() { return SET_APPRAISAL_ADOPTED_MARKET_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_740", function() { return SET_APPRAISAL_ADOPTED_MARKET_UNIT_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_679", function() { return SET_APPRAISAL_BEC_PRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_680", function() { return SET_APPRAISAL_ADJUSTED_BEC_PRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_681", function() { return SET_APPRAISAL_BC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_682", function() { return SET_APPRAISAL_BC_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_683", function() { return SET_APPRAISAL_GC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_684", function() { return SET_APPRAISAL_GC_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_685", function() { return SET_APPRAISAL_BC_AND_GC_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_686", function() { return SET_APPRAISAL_BC_AND_GC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_687", function() { return SET_APPRAISAL_CC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_688", function() { return SET_APPRAISAL_CC_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_689", function() { return SET_APPRAISAL_HTL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_690", function() { return SET_APPRAISAL_HTL_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_691", function() { return SET_APPRAISAL_INR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_692", function() { return SET_APPRAISAL_INR_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_693", function() { return SET_APPRAISAL_GA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_694", function() { return SET_APPRAISAL_GA_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_695", function() { return SET_APPRAISAL_GPD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_696", function() { return SET_APPRAISAL_GPD_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_697", function() { return SET_APPRAISAL_OCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_698", function() { return SET_APPRAISAL_OCT_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_699", function() { return SET_APPRAISAL_GP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_700", function() { return SET_APPRAISAL_GP_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_701", function() { return SET_APPRAISAL_CC_AND_GP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_702", function() { return SET_APPRAISAL_F; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_703", function() { return SET_APPRAISAL_CRB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_704", function() { return SET_APPRAISAL_CCD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_705", function() { return SET_APPRAISAL_TLR_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_706", function() { return SET_APPRAISAL_PR_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_707", function() { return SET_APPRAISAL_AM_COEF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_708", function() { return SET_APPRAISAL_B1_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_709", function() { return SET_APPRAISAL_B2_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_710", function() { return SET_APPRAISAL_B_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_711", function() { return SET_APPRAISAL_B_REMAINING_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_712", function() { return SET_APPRAISAL_I_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_713", function() { return SET_APPRAISAL_TENANT_AGE_YEARS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_714", function() { return SET_APPRAISAL_TENANT_LIFE_EXPECTANCY_YEARS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_715", function() { return SET_APPRAISAL_TENANT_REMAINING_LIFE_EXPECTANCY_YEARS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_716", function() { return SET_APPRAISAL_CESSION_BOOLEAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_717", function() { return SET_APPRAISAL_CESSION_GROSS_MONTHLY_INCOME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_718", function() { return SET_APPRAISAL_CESSION_GROSS_YEARLY_INCOME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_719", function() { return SET_APPRAISAL_CESSION_NET_YEARLY_INCOME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_720", function() { return SET_APPRAISAL_CESSION_CONTRACT_PERIOD_YEARS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_721", function() { return SET_APPRAISAL_CESSION_CONTRACT_REMAINING_YEARS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_722", function() { return SET_APPRAISAL_CESSION_CONTRACT_START_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_723", function() { return SET_APPRAISAL_LANDLORD_EXPENSES_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_724", function() { return SET_APPRAISAL_REDUCTION_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_725", function() { return SET_APPRAISAL_ADJUSTMENT_COEF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_726", function() { return SET_APPRAISAL_USUFRUCTUARY_AGE_YEARS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_727", function() { return SET_APPRAISAL_USEFUL_LIFE_YEARS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_728", function() { return SET_APPRAISAL_REMAINING_USEFUL_LIFE_YEARS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_729", function() { return SET_APPRAISAL_MAX_LEGAL_PRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_730", function() { return SET_APPRAISAL_MAX_LEGAL_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_731", function() { return SET_APPRAISAL_MATERIAL_EXECUTION_COST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_732", function() { return SET_APPRAISAL_DEPRECATED_MATERIAL_EXECUTION_COST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_733", function() { return SET_APPRAISAL_MEC_ADJUSTMENT_COEF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_734", function() { return SET_APPRAISAL_ADOPTED_MATERIAL_EXECUTION_COST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_735", function() { return SET_APPRAISAL_PHYSICAL_DEPRECIATION_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_736", function() { return SET_APPRAISAL_FUNCTIONAL_DEPRECIATION_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_737", function() { return SET_APPRAISAL_TOTAL_DEPRECIATION_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_738", function() { return SET_APPRAISAL_TOTAL_CONSTRUCTION_PROGRESS_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_741", function() { return SET_APPRAISAL_MARKET_VALUE_APPRAISER_ADJUSTMENT_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_742", function() { return SET_APPRAISAL_DEPRECATED_LAND_AND_CC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_743", function() { return SET_APPRAISAL_FINISHED_REALESTATE_CRN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_744", function() { return SET_APPRAISAL_CCR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_745", function() { return SET_APPRAISAL_EXECUTED_CONSTRUCTION_COST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_746", function() { return SET_APPRAISAL_UNDER_CONSTRUCTION_REALESTATE_CRN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_747", function() { return SET_APPRAISAL_K; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_748", function() { return SET_APPRAISAL_REPERCUSSION_METHOD_LAND_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_749", function() { return SET_APPRAISAL_COST_METHOD_CONSTRUCTION_CRB_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_750", function() { return SET_APPRAISAL_COST_METHOD_CONSTRUCTION_CRN_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_751", function() { return SET_APPRAISAL_COST_METHOD_REALESTATE_CRB_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_752", function() { return SET_APPRAISAL_COST_METHOD_REALESTATE_CRN_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_753", function() { return SET_APPRAISAL_COMPARISON_METHOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_754", function() { return SET_APPRAISAL_ADJUSTED_MARKET_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_755", function() { return SET_APPRAISAL_MAX_LEGAL_METHOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_756", function() { return SET_APPRAISAL_VC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_757", function() { return SET_APPRAISAL_INCOME_PERPETUITY_UPDATE_METHOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_758", function() { return SET_APPRAISAL_U; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_759", function() { return SET_APPRAISAL_RESIDUAL_DEPRECIATION_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_760", function() { return SET_APPRAISAL_RESIDUAL_DEPRECIATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_761", function() { return SET_APPRAISAL_REALESTATE_RESIDUAL_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_762", function() { return SET_APPRAISAL_I; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_763", function() { return SET_APPRAISAL_NP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_764", function() { return SET_APPRAISAL_COEF_1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_765", function() { return SET_APPRAISAL_CURRENT_FUTURE_INCOME_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_766", function() { return SET_APPRAISAL_COEF_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_767", function() { return SET_APPRAISAL_UPDATED_REVERSION_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_768", function() { return SET_APPRAISAL_UPDATE_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_769", function() { return SET_APPRAISAL_INSURANCE_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_770", function() { return SET_APPRAISAL_VU_COEF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_771", function() { return SET_APPRAISAL_USUFRUCT_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_772", function() { return SET_APPRAISAL_BARE_OWNERSHIP_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_773", function() { return SET_APPRAISAL_REALESTATE_TOTAL_ADOPTED_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_774", function() { return SET_APPRAISAL_REALESTATE_ADOPTED_APPRAISAL_METHOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_611", function() { return SET_APPRAISAL_REALESTATE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_669", function() { return SET_APPRAISAL_ADOPTED_AGE_YEARS_OLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_775", function() { return SET_APPRAISAL_RIGHT_OF_USE_BOOLEAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_776", function() { return SET_APPRAISAL_PROTECTION_BOOLEAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_777", function() { return SET_APPRAISAL_PROTECTION_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_778", function() { return SET_APPRAISAL_PROTECTION_REGIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_779", function() { return SET_APPRAISAL_PROTECTION_ZONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_620", function() { return SET_APPRAISAL_URBAN_PLANNING_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_621", function() { return SET_APPRAISAL_URBAN_PLANNING_FILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_622", function() { return SET_APPRAISAL_URBAN_PLANNING_COUNCIL_QUALIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_623", function() { return SET_APPRAISAL_URBAN_PLANNING_COUNCIL_QUALIFICATION_DESCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_624", function() { return SET_APPRAISAL_URBAN_PLANNING_COUNCIL_CLASSIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_625", function() { return SET_APPRAISAL_URBAN_PLANNING_COUNCIL_CLASSIFICATION_DESCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_626", function() { return SET_APPRAISAL_URBAN_PLANNING_REGIONAL_QUALIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_627", function() { return SET_APPRAISAL_URBAN_PLANNING_REGIONAL_QUALIFICATION_DESCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_628", function() { return SET_APPRAISAL_URBAN_PLANNING_REGIONAL_CLASSIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_629", function() { return SET_APPRAISAL_URBAN_PLANNING_REGIONAL_CLASSIFICATION_DESCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_630", function() { return SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_631", function() { return SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_632", function() { return SET_APPRAISAL_MAP_URBAN_ICC_TOPO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_780", function() { return SET_APPRAISAL_LAND_REGISTRY_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_781", function() { return SET_APPRAISAL_LAND_CADASTRAL_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_782", function() { return SET_APPRAISAL_LAND_CHECKED_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_783", function() { return SET_APPRAISAL_LAND_ADOPTED_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_784", function() { return SET_APPRAISAL_LAND_INFRASTRUCTURE_PAVING_EXECUTION_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_785", function() { return SET_APPRAISAL_LAND_INFRASTRUCTURE_SEWAGE_EXECUTION_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_786", function() { return SET_APPRAISAL_LAND_INFRASTRUCTURE_PUBLIC_LIGHTING_EXECUTION_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_787", function() { return SET_APPRAISAL_LAND_INFRASTRUCTURE_ELECTRICITY_SUPPLY_EXECUTION_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_788", function() { return SET_APPRAISAL_LAND_INFRASTRUCTURE_PIPED_GAS_EXECUTION_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_789", function() { return SET_APPRAISAL_LAND_INFRASTRUCTURE_TELEPHONE_SERVICE_EXECUTION_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_790", function() { return SET_APPRAISAL_LAND_INFRASTRUCTURE_GARDENED_AREAS_EXECUTION_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_791", function() { return SET_APPRAISAL_LAND_INFRASTRUCTURE_TOTAL_EXECUTION_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_792", function() { return SET_APPRAISAL_LAND_INFRASTRUCTURE_REPERCUSSION_COST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_793", function() { return SET_APPRAISAL_LAND_INFRASTRUCTURE_PENDING_INVESTMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_794", function() { return SET_APPRAISAL_LAND_INFRASTRUCTURE_PAVING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_795", function() { return SET_APPRAISAL_LAND_INFRASTRUCTURE_SEWAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_796", function() { return SET_APPRAISAL_LAND_INFRASTRUCTURE_PUBLIC_LIGHTING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_797", function() { return SET_APPRAISAL_LAND_INFRASTRUCTURE_ELECTRICITY_SUPPLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_798", function() { return SET_APPRAISAL_LAND_INFRASTRUCTURE_PIPED_GAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_799", function() { return SET_APPRAISAL_LAND_INFRASTRUCTURE_TELEPHONE_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_800", function() { return SET_APPRAISAL_LAND_INFRASTRUCTURE_GARDENED_AREAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_801", function() { return SET_APPRAISAL_LAND_IS_PLOT_ACCORDING_TO_LAW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_802", function() { return SET_APPRAISAL_LAND_AREA_NOTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_803", function() { return SET_APPRAISAL_LAND_INFRASTRUCTURE_NOTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_804", function() { return SET_APPRAISAL_LAND_INFRASTRUCTURE_CONSERVATION_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_805", function() { return SET_APPRAISAL_LAND_INFRASTRUCTURE_WATER_SUPPLY_EXECUTION_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_806", function() { return SET_APPRAISAL_LAND_INFRASTRUCTURE_WATER_SUPPLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_807", function() { return SET_APPRAISAL_PLOT_OCCUPATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_808", function() { return SET_APPRAISAL_PLOT_FREE_AREA_USAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_809", function() { return SET_APPRAISAL_FLOORS_NUMBER_UNDERGROUND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_810", function() { return SET_APPRAISAL_FLOORS_NUMBER_OVERGROUND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_811", function() { return SET_APPRAISAL_PARKING_SLOTS_INCLUDED_IN_APPRAISAL_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_812", function() { return SET_APPRAISAL_ENTRANCE_HALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_813", function() { return SET_APPRAISAL_DOORMAN_SPACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_814", function() { return SET_APPRAISAL_STAIRCASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_815", function() { return SET_APPRAISAL_SWIMMING_POOL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_816", function() { return SET_APPRAISAL_GARDENED_AREAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_817", function() { return SET_APPRAISAL_SPORTS_FACILITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_818", function() { return SET_APPRAISAL_COMMUNITY_ROOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_819", function() { return SET_APPRAISAL_STORAGE_ROOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_820", function() { return SET_APPRAISAL_COMMUNITY_PARKING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_821", function() { return SET_APPRAISAL_FACILITIES_OTHERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_822", function() { return SET_APPRAISAL_FLOORS_USAGE_UNDERGROUND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_823", function() { return SET_APPRAISAL_FLOORS_USAGE_OVERGROUND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_824", function() { return SET_APPRAISAL_GROUNDFLOOR_USAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_825", function() { return SET_APPRAISAL_COMMUNICATIONS_AIRPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_826", function() { return SET_APPRAISAL_COMMUNICATIONS_HARBOUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_827", function() { return SET_APPRAISAL_COMMUNICATIONS_TRAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_828", function() { return SET_APPRAISAL_PUBLIC_TRANSPORT_URBAN_UNDERGROUND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_829", function() { return SET_APPRAISAL_PUBLIC_TRANSPORT_INTERURBAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_830", function() { return SET_APPRAISAL_SURROUNDING_FACILITIES_NOTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_831", function() { return SET_APPRAISAL_SURROUNDING_TERRITORIAL_FEATURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_832", function() { return SET_APPRAISAL_SURROUNDING_INCOME_LEVEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_833", function() { return SET_APPRAISAL_SURROUNDING_HOMOGENEITY_FEATURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_834", function() { return SET_APPRAISAL_SURROUNDING_MAIN_USES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_835", function() { return SET_APPRAISAL_SURROUNDING_DENSITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_836", function() { return SET_APPRAISAL_SURROUNDING_ACCESSIBILITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_837", function() { return SET_APPRAISAL_SURROUNDING_CONSOLIDATION_DEGREE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_838", function() { return SET_APPRAISAL_SURROUNDING_OCCUPATION_DEGREE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_839", function() { return SET_APPRAISAL_SURROUNDING_EVOLUTION_SPEED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_840", function() { return SET_APPRAISAL_SURROUNDING_AVERAGE_AGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_841", function() { return SET_APPRAISAL_SURROUNDING_CONSERVATION_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_842", function() { return SET_APPRAISAL_SURROUNDING_COMMERCIAL_FACILITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_843", function() { return SET_APPRAISAL_SURROUNDING_EDUCATIONAL_FACILITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_844", function() { return SET_APPRAISAL_SURROUNDING_PUBLIC_PARKING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_845", function() { return SET_APPRAISAL_SURROUNDING_MEDICAL_ASSISTANCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_846", function() { return SET_APPRAISAL_SURROUNDING_LEISURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_847", function() { return SET_APPRAISAL_CADASTRAL_USAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_848", function() { return SET_APPRAISAL_CADASTRAL_FLOOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_849", function() { return SET_APPRAISAL_CADASTRAL_DOOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_850", function() { return SET_APPRAISAL_CADASTRAL_BLOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_851", function() { return SET_APPRAISAL_CADASTRAL_STAIRCASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_852", function() { return SET_APPRAISAL_REGISTRY_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_853", function() { return SET_APPRAISAL_REGISTRY_SECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_854", function() { return SET_APPRAISAL_REGISTRY_VOLUME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_855", function() { return SET_APPRAISAL_REGISTRY_BOOK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_856", function() { return SET_APPRAISAL_REGISTRY_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_857", function() { return SET_APPRAISAL_REGISTRY_REAL_ESTATE_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_858", function() { return SET_APPRAISAL_REGISTRY_IDUFIR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_859", function() { return SET_APPRAISAL_REGISTRY_OWNER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_860", function() { return SET_APPRAISAL_REGISTRY_PROPERTY_COEF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_861", function() { return SET_APPRAISAL_NET_CADASTRAL_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_862", function() { return SET_APPRAISAL_NET_REGISTRY_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_863", function() { return SET_APPRAISAL_NET_CHECKED_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_864", function() { return SET_APPRAISAL_NET_ADOPTED_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_865", function() { return SET_APPRAISAL_ENCLOSED_CADASTRAL_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_866", function() { return SET_APPRAISAL_ENCLOSED_REGISTRY_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_867", function() { return SET_APPRAISAL_ENCLOSED_CHECKED_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_868", function() { return SET_APPRAISAL_ENCLOSED_ADOPTED_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_869", function() { return SET_APPRAISAL_COVERED_TERRACES_TOTAL_CADASTRAL_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_870", function() { return SET_APPRAISAL_COVERED_TERRACES_TOTAL_REGISTRY_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_871", function() { return SET_APPRAISAL_COVERED_TERRACES_TOTAL_CHECKED_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_872", function() { return SET_APPRAISAL_COVERED_TERRACES_TOTAL_ADOPTED_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_873", function() { return SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_CADASTRAL_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_874", function() { return SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_REGISTRY_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_875", function() { return SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_CHECKED_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_876", function() { return SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_ADOPTED_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_877", function() { return SET_APPRAISAL_BUILT_CADASTRAL_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_878", function() { return SET_APPRAISAL_BUILT_REGISTRY_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_879", function() { return SET_APPRAISAL_BUILT_CHECKED_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_880", function() { return SET_APPRAISAL_BUILT_ADOPTED_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_881", function() { return SET_APPRAISAL_COMMON_ELEMENTS_CADASTRAL_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_882", function() { return SET_APPRAISAL_COMMON_ELEMENTS_REGISTRY_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_883", function() { return SET_APPRAISAL_COMMON_ELEMENTS_CHECKED_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_884", function() { return SET_APPRAISAL_COMMON_ELEMENTS_ADOPTED_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_885", function() { return SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_CADASTRAL_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_886", function() { return SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_REGISTRY_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_887", function() { return SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_CHECKED_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_888", function() { return SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_ADOPTED_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_889", function() { return SET_APPRAISAL_BATHROOMS_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_890", function() { return SET_APPRAISAL_BEDROOMS_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_891", function() { return SET_APPRAISAL_NET_SELECTED_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_892", function() { return SET_APPRAISAL_ENCLOSED_SELECTED_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_893", function() { return SET_APPRAISAL_COVERED_OUTDOORS_SELECTED_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_894", function() { return SET_APPRAISAL_BUILT_SELECTED_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_895", function() { return SET_APPRAISAL_COMMON_ELEMENTS_SELECTED_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_896", function() { return SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_SELECTED_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_897", function() { return SET_APPRAISAL_LAND_SELECTED_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_898", function() { return SET_APPRAISAL_REALESTATE_ROOMS_TO_EXTERIOR_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_899", function() { return SET_APPRAISAL_REALESTATE_DAY_NIGHT_ZONING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_900", function() { return SET_APPRAISAL_REALESTATE_SYSTEMS_DOOR_OPENER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_901", function() { return SET_APPRAISAL_REALESTATE_SYSTEMS_FITTED_CUPBOARDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_902", function() { return SET_APPRAISAL_REALESTATE_SYSTEMS_GAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_903", function() { return SET_APPRAISAL_REALESTATE_SYSTEMS_SANITARY_FITTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_904", function() { return SET_APPRAISAL_REALESTATE_SYSTEMS_TAPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_905", function() { return SET_APPRAISAL_REALESTATE_SYSTEMS_HOT_WATER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_906", function() { return SET_APPRAISAL_REALESTATE_SYSTEMS_HEATING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_907", function() { return SET_APPRAISAL_REALESTATE_SYSTEMS_AIR_CONDITIONING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_908", function() { return SET_APPRAISAL_REALESTATE_SYSTEMS_TV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_909", function() { return SET_APPRAISAL_REALESTATE_SYSTEMS_TELEPHONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_910", function() { return SET_APPRAISAL_REALESTATE_SYSTEMS_FIRE_PREVENTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_911", function() { return SET_APPRAISAL_REALESTATE_SYSTEMS_INTRUSION_PREVENTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_912", function() { return SET_APPRAISAL_REALESTATE_FOUNDATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_913", function() { return SET_APPRAISAL_REALESTATE_STRUCTURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_914", function() { return SET_APPRAISAL_REALESTATE_ROOF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_915", function() { return SET_APPRAISAL_REALESTATE_EXTERNAL_ENCLOSURES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_916", function() { return SET_APPRAISAL_REALESTATE_INSULATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_917", function() { return SET_APPRAISAL_REALESTATE_EXTERNAL_CARPENTRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_918", function() { return SET_APPRAISAL_REALESTATE_GLAZING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_919", function() { return SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_LIVING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_920", function() { return SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_CORRIDOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_921", function() { return SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_BEDROOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_922", function() { return SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_KITCHEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_923", function() { return SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_BATHROOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_924", function() { return SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_QUALITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_925", function() { return SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_LIVING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_926", function() { return SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_CORRIDOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_927", function() { return SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_BEDROOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_928", function() { return SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_KITCHEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_929", function() { return SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_BATHROOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_930", function() { return SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_QUALITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_931", function() { return SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_LIVING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_932", function() { return SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_CORRIDOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_933", function() { return SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_BEDROOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_934", function() { return SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_KITCHEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_935", function() { return SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_BATHROOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_936", function() { return SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_QUALITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_937", function() { return SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_LIVING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_938", function() { return SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_CORRIDOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_939", function() { return SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_BEDROOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_940", function() { return SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_KITCHEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_941", function() { return SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_BATHROOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_942", function() { return SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_QUALITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_943", function() { return SET_APPRAISAL_REALESTATE_MAIN_ORIENTATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_944", function() { return SET_APPRAISAL_REALESTATE_MAIN_VIEWS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_945", function() { return SET_APPRAISAL_REALESTATE_WINDOWS_SIZE_AND_QUANTITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_946", function() { return SET_APPRAISAL_REALESTATE_NOISE_FACADE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_947", function() { return SET_APPRAISAL_REALESTATE_SYSTEMS_SANITARY_FITTINGS_QUALITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_948", function() { return SET_APPRAISAL_REALESTATE_SYSTEMS_TAPS_QUALITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_949", function() { return SET_APPRAISAL_BEC_ADJUSTMENT_COEF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_950", function() { return SET_APPRAISAL_BEC_PROPERTY_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_951", function() { return SET_APPRAISAL_BEC_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_952", function() { return SET_APPRAISAL_CONSTRUCTION_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_953", function() { return SET_APPRAISAL_EXPENSES_AND_INDUSTRIAL_BENEFIT_BEC_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_954", function() { return SET_APPRAISAL_CONSTRUCTION_COST_NOTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_955", function() { return SET_APPRAISAL_CADASTRAL_CONSTRUCTION_YEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_956", function() { return SET_APPRAISAL_CONSTRUCTION_YEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_957", function() { return SET_APPRAISAL_LAST_RENOVATION_YEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_614", function() { return SET_APPRAISAL_NUCLEUS_POPULATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_616", function() { return SET_APPRAISAL_NUCLEUS_POPULATION_DENSITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_617", function() { return SET_APPRAISAL_NUCLEUS_POPULATION_GROWTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_958", function() { return SET_APPRAISAL_OCCUPATION_AGRICULTURE_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_959", function() { return SET_APPRAISAL_OCCUPATION_INDUSTRY_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_960", function() { return SET_APPRAISAL_OCCUPATION_CONSTRUCTION_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_961", function() { return SET_APPRAISAL_OCCUPATION_SERVICES_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_962", function() { return SET_APPRAISAL_OCCUPATION_TOTAL_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_618", function() { return SET_APPRAISAL_NUCLEUS_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_619", function() { return SET_APPRAISAL_OCCUPATION_DESCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_615", function() { return SET_APPRAISAL_NUCLEUS_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_963", function() { return SET_APPRAISAL_PROPERTY_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_964", function() { return SET_APPRAISAL_USAGE_ASSIGNED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_965", function() { return SET_APPRAISAL_INSPECTION_REALIZED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_966", function() { return SET_APPRAISAL_ECONOMICAL_ACTIVITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_967", function() { return SET_APPRAISAL_OCCUPANCY_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_968", function() { return SET_APPRAISAL_MARKETSTUDY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_182", function() { return SET_APPRAISAL_MARKETSTUDIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_969", function() { return SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_OFFSET_X; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_970", function() { return SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_OFFSET_Y; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_971", function() { return SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_ZOOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_972", function() { return SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_OFFSET_X; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_973", function() { return SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_OFFSET_Y; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_974", function() { return SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_ZOOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_975", function() { return SET_APPRAISAL_MAP_URBAN_ICC_TOPO_OFFSET_X; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_976", function() { return SET_APPRAISAL_MAP_URBAN_ICC_TOPO_OFFSET_Y; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_977", function() { return SET_APPRAISAL_MAP_URBAN_ICC_TOPO_ZOOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_978", function() { return SET_APPRAISAL_QUOTE_TRAVEL_ONE_WAY_HOURS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_979", function() { return SET_APPRAISAL_QUOTE_TRAVEL_BOTH_WAYS_HOURS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_980", function() { return SET_APPRAISAL_QUOTE_TRAVEL_FEES_PER_HOUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_981", function() { return SET_APPRAISAL_QUOTE_CAR_EXPENSES_ONE_WAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_982", function() { return SET_APPRAISAL_QUOTE_CAR_EXPENSES_BOTH_WAYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_983", function() { return SET_APPRAISAL_QUOTE_TOTAL_TRAVEL_FEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_984", function() { return SET_APPRAISAL_QUOTE_AREA_AVERAGE_UNIT_PRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_985", function() { return SET_APPRAISAL_QUOTE_BASE_FEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_986", function() { return SET_APPRAISAL_QUOTE_EXCESS_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_987", function() { return SET_APPRAISAL_QUOTE_BASE_PRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_988", function() { return SET_APPRAISAL_QUOTE_BASE_PRICE_COEF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_989", function() { return SET_APPRAISAL_USAGE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_990", function() { return SET_APPRAISAL_PARKING_SPOTS_INCLUDED_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_603", function() { return SET_APPRAISAL_BEC_PROPERTIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_604", function() { return SET_APPRAISAL_BEC_PRICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_602", function() { return SET_APPRAISAL_ROOMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_601", function() { return SET_APPRAISAL_COVERED_OUTDOORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_600", function() { return SET_APPRAISAL_UNCOVERED_OUTDOORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_599", function() { return SET_APPRAISAL_CONSTRAINTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_598", function() { return SET_APPRAISAL_WARNINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_597", function() { return SET_APPRAISAL_NOTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_596", function() { return SET_APPRAISAL_PHOTOGRAPHS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_595", function() { return SET_APPRAISAL_REGISTRYANNEXES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_594", function() { return SET_APPRAISAL_CADASTERANNEXES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_593", function() { return SET_APPRAISAL_URBANANNEXES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_592", function() { return SET_APPRAISAL_PLANANNEXES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_591", function() { return SET_APPRAISAL_CESSIONANNEXES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_590", function() { return SET_APPRAISAL_OTHERANNEXES; });
/* unused harmony export CREATE_NEW_APPRAISALFILE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_581", function() { return RESET_APPRAISALFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_587", function() { return SET_APPRAISALFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_584", function() { return SET_APPRAISALFILE_DATE_CREATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_585", function() { return SET_APPRAISALFILE_DATE_MODIFIED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_588", function() { return SET_APPRAISALFILE_DIRTYNESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_583", function() { return SET_APPRAISALFILE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_586", function() { return SET_APPRAISALFILE_PATH; });
/* unused harmony export UPDATE_APPRAISALFILE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_589", function() { return SET_APPRAISALFILE_DESCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_582", function() { return SET_APPRAISALFILE_NUMBER; });
/* unused harmony export CREATE_NEW_APPRAISALREPORT */
/* unused harmony export DELETE_APPRAISALREPORT */
/* unused harmony export GET_APPRAISALREPORT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_548", function() { return RESET_APPRAISALREPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_549", function() { return SET_APPRAISALREPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_539", function() { return SET_APPRAISALREPORT_DATE_CREATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_540", function() { return SET_APPRAISALREPORT_DATE_MODIFIED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_552", function() { return SET_APPRAISALREPORT_DIRTYNESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_547", function() { return SET_APPRAISALREPORT_FILE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_538", function() { return SET_APPRAISALREPORT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_541", function() { return SET_APPRAISALREPORT_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_544", function() { return SET_APPRAISALREPORT_PARENT_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_543", function() { return SET_APPRAISALREPORT_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_553", function() { return SET_APPRAISALREPORT_DESCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_554", function() { return SET_APPRAISALREPORT_PETITIONER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_555", function() { return SET_APPRAISALREPORT_PETITIONER_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_556", function() { return SET_APPRAISALREPORT_ENTITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_557", function() { return SET_APPRAISALREPORT_SUPERVISOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_558", function() { return SET_APPRAISALREPORT_APPRAISER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_545", function() { return SET_APPRAISALREPORT_REPORTDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_550", function() { return SET_APPRAISALREPORT_SEND_TO_BDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_551", function() { return SET_APPRAISALREPORT_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_546", function() { return SET_APPRAISALREPORT_VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_559", function() { return SET_APPRAISALREPORT_COVER_PHOTO_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_560", function() { return SET_APPRAISALREPORT_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_542", function() { return SET_APPRAISALREPORT_FULL_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_561", function() { return SET_APPRAISALREPORT_SIGNATURE_SV_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_562", function() { return SET_APPRAISALREPORT_SIGNATURE_SV_BASE64; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_563", function() { return SET_APPRAISALREPORT_SIGNATURE_SV_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_564", function() { return SET_APPRAISALREPORT_SIGNATURE_SV_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_565", function() { return SET_APPRAISALREPORT_SIGNATURE_SV_UID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_566", function() { return SET_APPRAISALREPORT_SIGNATURE_AP_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_567", function() { return SET_APPRAISALREPORT_SIGNATURE_AP_BASE64; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_568", function() { return SET_APPRAISALREPORT_SIGNATURE_AP_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_569", function() { return SET_APPRAISALREPORT_SIGNATURE_AP_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_570", function() { return SET_APPRAISALREPORT_SIGNATURE_AP_UID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_571", function() { return SET_APPRAISALREPORT_IS_SIGNED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_572", function() { return SET_APPRAISALREPORT_IS_SV_SIGNED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_573", function() { return SET_APPRAISALREPORT_IS_AP_SIGNED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_108", function() { return SET_APPRAISALREPORTS; });
/* unused harmony export UPDATE_APPRAISALREPORT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_349", function() { return SET_APPRAISALREPORT_PETITIONERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_350", function() { return SET_APPRAISALREPORT_REALESTATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_351", function() { return SET_TEMP_APPRAISALREPORT_REALESTATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_579", function() { return SET_APPRAISALFILE_APPRAISALREPORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_580", function() { return SET_TEMP_APPRAISALFILE_APPRAISALREPORTS; });
/* unused harmony export CREATE_NEW_APPRAISALQUOTE */
/* unused harmony export DELETE_APPRAISALQUOTE */
/* unused harmony export GET_APPRAISALQUOTE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_511", function() { return RESET_APPRAISALQUOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_512", function() { return SET_APPRAISALQUOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_502", function() { return SET_APPRAISALQUOTE_DATE_CREATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_503", function() { return SET_APPRAISALQUOTE_DATE_MODIFIED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_515", function() { return SET_APPRAISALQUOTE_DIRTYNESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_510", function() { return SET_APPRAISALQUOTE_FILE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_501", function() { return SET_APPRAISALQUOTE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_504", function() { return SET_APPRAISALQUOTE_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_506", function() { return SET_APPRAISALQUOTE_PARENT_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_505", function() { return SET_APPRAISALQUOTE_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_516", function() { return SET_APPRAISALQUOTE_DESCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_517", function() { return SET_APPRAISALQUOTE_PETITIONER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_518", function() { return SET_APPRAISALQUOTE_PETITIONER_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_519", function() { return SET_APPRAISALQUOTE_ENTITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_520", function() { return SET_APPRAISALQUOTE_SUPERVISOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_521", function() { return SET_APPRAISALQUOTE_APPRAISER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_507", function() { return SET_APPRAISALQUOTE_REPORTDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_513", function() { return SET_APPRAISALQUOTE_SEND_TO_BDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_514", function() { return SET_APPRAISALQUOTE_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_508", function() { return SET_APPRAISALQUOTE_VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_522", function() { return SET_APPRAISALQUOTE_COVER_PHOTO_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_524", function() { return SET_APPRAISALQUOTE_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_523", function() { return SET_APPRAISALQUOTE_VAT_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_525", function() { return SET_APPRAISALQUOTE_BANK_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_526", function() { return SET_APPRAISALQUOTE_IBAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_527", function() { return SET_APPRAISALQUOTE_COURT_ASSISTANCE_FEES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_528", function() { return SET_APPRAISALQUOTE_DISCOUNT_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_529", function() { return SET_APPRAISALQUOTE_DISCOUNT_NOTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_530", function() { return SET_APPRAISALQUOTE_FINAL_PRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_531", function() { return SET_APPRAISALQUOTE_REQUIREDDOC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_509", function() { return SET_APPRAISALQUOTE_FULL_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_532", function() { return SET_APPRAISALQUOTE_SIGNATURE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_533", function() { return SET_APPRAISALQUOTE_SIGNATURE_BASE64; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_534", function() { return SET_APPRAISALQUOTE_SIGNATURE_DATE; });
/* unused harmony export SET_APPRAISALQUOTE_IS_SIGNED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_535", function() { return SET_APPRAISALQUOTE_SIGNATURE_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_536", function() { return SET_APPRAISALQUOTE_SIGNATURE_UID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_537", function() { return SET_APPRAISALQUOTE_PURPOSE; });
/* unused harmony export UPDATE_APPRAISALQUOTE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_347", function() { return SET_APPRAISALQUOTE_PETITIONERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_348", function() { return SET_TEMP_APPRAISALQUOTE_PETITIONERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_345", function() { return SET_APPRAISALQUOTE_REALESTATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_346", function() { return SET_TEMP_APPRAISALQUOTE_REALESTATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_344", function() { return SET_APPRAISALQUOTE_REQUIREDDOCS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_577", function() { return SET_APPRAISALFILE_APPRAISALQUOTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_578", function() { return SET_TEMP_APPRAISALFILE_APPRAISALQUOTES; });
/* unused harmony export CREATE_NEW_APPRAISALINVOICE */
/* unused harmony export DELETE_APPRAISALINVOICE */
/* unused harmony export GET_APPRAISALINVOICE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_473", function() { return RESET_APPRAISALINVOICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_474", function() { return SET_APPRAISALINVOICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_463", function() { return SET_APPRAISALINVOICE_DATE_CREATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_464", function() { return SET_APPRAISALINVOICE_DATE_MODIFIED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_477", function() { return SET_APPRAISALINVOICE_DIRTYNESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_472", function() { return SET_APPRAISALINVOICE_FILE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_462", function() { return SET_APPRAISALINVOICE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_465", function() { return SET_APPRAISALINVOICE_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_467", function() { return SET_APPRAISALINVOICE_PARENT_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_466", function() { return SET_APPRAISALINVOICE_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_478", function() { return SET_APPRAISALINVOICE_DESCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_479", function() { return SET_APPRAISALINVOICE_PETITIONER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_480", function() { return SET_APPRAISALINVOICE_PETITIONER_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_481", function() { return SET_APPRAISALINVOICE_ENTITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_482", function() { return SET_APPRAISALINVOICE_SUPERVISOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_483", function() { return SET_APPRAISALINVOICE_APPRAISER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_468", function() { return SET_APPRAISALINVOICE_REPORTDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_475", function() { return SET_APPRAISALINVOICE_SEND_TO_BDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_476", function() { return SET_APPRAISALINVOICE_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_469", function() { return SET_APPRAISALINVOICE_VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_484", function() { return SET_APPRAISALINVOICE_COVER_PHOTO_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_486", function() { return SET_APPRAISALINVOICE_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_485", function() { return SET_APPRAISALINVOICE_VAT_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_487", function() { return SET_APPRAISALINVOICE_QUOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_470", function() { return SET_APPRAISALINVOICE_FULL_NUMBER; });
/* unused harmony export UPDATE_APPRAISALINVOICE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_488", function() { return SET_APPRAISALINVOICE_BASE_PRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_489", function() { return SET_APPRAISALINVOICE_DISCOUNT_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_490", function() { return SET_APPRAISALINVOICE_FINAL_PRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_491", function() { return SET_APPRAISALINVOICE_FINAL_PRICE_INCL_VAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_492", function() { return SET_APPRAISALINVOICE_DISCOUNT_NOTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_493", function() { return SET_APPRAISALINVOICE_BANK_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_494", function() { return SET_APPRAISALINVOICE_IBAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_110", function() { return SET_APPRAISALINVOICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_111", function() { return SET_APPRAISALQUOTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_471", function() { return SET_APPRAISALINVOICE_FISCAL_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_495", function() { return SET_APPRAISALINVOICE_SIGNATURE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_496", function() { return SET_APPRAISALINVOICE_SIGNATURE_BASE64; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_497", function() { return SET_APPRAISALINVOICE_SIGNATURE_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_498", function() { return SET_APPRAISALINVOICE_SIGNATURE_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_499", function() { return SET_APPRAISALINVOICE_SIGNATURE_UID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_500", function() { return SET_APPRAISALINVOICE_IS_SIGNED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_343", function() { return SET_APPRAISALINVOICE_LINES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_341", function() { return SET_APPRAISALINVOICE_PETITIONERS; });
/* unused harmony export SET_TEMP_APPRAISALINVOICE_PETITIONERS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_342", function() { return SET_APPRAISALINVOICE_APPRAISALQUOTES; });
/* unused harmony export SET_TEMP_APPRAISALINVOICE_APPRAISALQUOTES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_575", function() { return SET_APPRAISALFILE_APPRAISALINVOICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_576", function() { return SET_TEMP_APPRAISALFILE_APPRAISALINVOICES; });
/* unused harmony export CREATE_NEW_BECPRICE */
/* unused harmony export DELETE_BECPRICE */
/* unused harmony export GET_BECPRICE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_398", function() { return RESET_BECPRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_397", function() { return SET_BECPRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_393", function() { return SET_BECPRICE_DATE_CREATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_394", function() { return SET_BECPRICE_DATE_MODIFIED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_399", function() { return SET_BECPRICE_DIRTYNESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_392", function() { return SET_BECPRICE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_396", function() { return SET_BECPRICE_PARENT_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_395", function() { return SET_BECPRICE_PATH; });
/* unused harmony export UPDATE_BECPRICE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_400", function() { return SET_BECPRICE_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_401", function() { return SET_BECPRICE_QUARTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_402", function() { return SET_BECPRICE_YEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_403", function() { return SET_BECPRICE_AIRE_ACONDICIONADO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_404", function() { return SET_BECPRICE_ALBANILERIA_ACABADOS_FACHADA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_405", function() { return SET_BECPRICE_ALBANILERIA_ACABADOS_INTERIORES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_406", function() { return SET_BECPRICE_ALBANILERIA_AYUDAS_INDUSTRIALES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_407", function() { return SET_BECPRICE_ALBANILERIA_AZOTEAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_408", function() { return SET_BECPRICE_ALBANILERIA_GRUESA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_409", function() { return SET_BECPRICE_ALBANILERIA_SOLADOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_410", function() { return SET_BECPRICE_ASCENSORES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_411", function() { return SET_BECPRICE_CALEFACCION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_412", function() { return SET_BECPRICE_CARPINTERIA_EXTERIOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_413", function() { return SET_BECPRICE_CARPINTERIA_INTERIOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_414", function() { return SET_BECPRICE_CERRAJERIA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_415", function() { return SET_BECPRICE_CIMENTACION_Y_MURO_SOTANO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_416", function() { return SET_BECPRICE_ELECTRICIDAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_417", function() { return SET_BECPRICE_ENERGIA_SOLAR_ACS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_418", function() { return SET_BECPRICE_ESTRUCTURA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_419", function() { return SET_BECPRICE_FONTANERIA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_420", function() { return SET_BECPRICE_FUMISTERIA_Y_MUEBLES_COCINA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_421", function() { return SET_BECPRICE_INSTAL_ESPECIALES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_422", function() { return SET_BECPRICE_JARDINERIA_DECORATIVA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_423", function() { return SET_BECPRICE_MAT_SANITARIO_GRIFERIA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_424", function() { return SET_BECPRICE_MOVIMIENTO_TIERRAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_425", function() { return SET_BECPRICE_PERSIANAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_426", function() { return SET_BECPRICE_PINTURA_Y_ESTUCOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_427", function() { return SET_BECPRICE_RENOVACION_AIRE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_428", function() { return SET_BECPRICE_SANEAMIENTO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_429", function() { return SET_BECPRICE_SEGURIDAD_Y_SALUD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_430", function() { return SET_BECPRICE_SUBTOTAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_431", function() { return SET_BECPRICE_TOTAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_432", function() { return SET_BECPRICE_VIDRIERIA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_433", function() { return SET_BECPRICE_YESERIA_CIELOSRASOS; });
/* unused harmony export CREATE_NEW_BECPROPERTY */
/* unused harmony export DELETE_BECPROPERTY */
/* unused harmony export GET_BECPROPERTY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_385", function() { return RESET_BECPROPERTY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_386", function() { return SET_BECPROPERTY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_382", function() { return SET_BECPROPERTY_DATE_CREATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_383", function() { return SET_BECPROPERTY_DATE_MODIFIED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_388", function() { return SET_BECPROPERTY_DIRTYNESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_381", function() { return SET_BECPROPERTY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_387", function() { return SET_BECPROPERTY_PARENT_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_384", function() { return SET_BECPROPERTY_PATH; });
/* unused harmony export UPDATE_BECPROPERTY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_389", function() { return SET_BECPROPERTY_NAME_CA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_390", function() { return SET_BECPROPERTY_NAME_EN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_391", function() { return SET_BECPROPERTY_NAME_ES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_380", function() { return SET_BECPROPERTY_BECPRICES; });
/* unused harmony export CREATE_NEW_CONSTRAINT */
/* unused harmony export DELETE_CONSTRAINT */
/* unused harmony export GET_CONSTRAINT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_88", function() { return RESET_CONSTRAINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_87", function() { return SET_CONSTRAINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return SET_CONSTRAINT_DATE_CREATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return SET_CONSTRAINT_DATE_MODIFIED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_89", function() { return SET_CONSTRAINT_DIRTYNESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return SET_CONSTRAINT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return SET_CONSTRAINT_PARENT_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return SET_CONSTRAINT_PATH; });
/* unused harmony export UPDATE_CONSTRAINT */
/* unused harmony export CREATE_NEW_WARNING */
/* unused harmony export DELETE_WARNING */
/* unused harmony export GET_WARNING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return RESET_WARNING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return SET_WARNING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return SET_WARNING_DATE_CREATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return SET_WARNING_DATE_MODIFIED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return SET_WARNING_DIRTYNESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return SET_WARNING_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return SET_WARNING_PARENT_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return SET_WARNING_PATH; });
/* unused harmony export UPDATE_WARNING */
/* unused harmony export CREATE_NEW_NOTE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_120", function() { return DELETE_NOTE; });
/* unused harmony export GET_NOTE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return RESET_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return SET_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return SET_NOTE_DATE_CREATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return SET_NOTE_DATE_MODIFIED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return SET_NOTE_DIRTYNESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return SET_NOTE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return SET_NOTE_PARENT_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return SET_NOTE_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_121", function() { return UPDATE_NOTE; });
/* unused harmony export CREATE_NEW_CONTACT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_352", function() { return RESET_CONTACT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_357", function() { return SET_CONTACT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_354", function() { return SET_CONTACT_DATE_CREATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_355", function() { return SET_CONTACT_DATE_MODIFIED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_370", function() { return SET_CONTACT_DIRTYNESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_353", function() { return SET_CONTACT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_358", function() { return SET_CONTACT_MAIN_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_359", function() { return SET_CONTACT_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_360", function() { return SET_CONTACT_ORGANIZATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_356", function() { return SET_CONTACT_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_361", function() { return SET_CONTACT_PERSON_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_362", function() { return SET_CONTACT_REPRESENTATIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_363", function() { return SET_CONTACT_REPRESENTATIVE_TIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_364", function() { return SET_CONTACT_SURNAMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_365", function() { return SET_CONTACT_TIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_366", function() { return SET_CONTACT_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_367", function() { return SET_CONTACT_COMPLETE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_368", function() { return SET_CONTACT_COMPLETE_FISCAL_ADDRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_369", function() { return SET_CONTACT_MAIN_TELEPHONENUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_109", function() { return SET_CONTACTS; });
/* unused harmony export UPDATE_CONTACT */
/* unused harmony export CREATE_NEW_APPRAISER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_448", function() { return RESET_APPRAISER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_453", function() { return SET_APPRAISER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_450", function() { return SET_APPRAISER_DATE_CREATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_451", function() { return SET_APPRAISER_DATE_MODIFIED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_461", function() { return SET_APPRAISER_DIRTYNESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_449", function() { return SET_APPRAISER_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_454", function() { return SET_APPRAISER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_455", function() { return SET_APPRAISER_ORGANIZATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_452", function() { return SET_APPRAISER_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_456", function() { return SET_APPRAISER_SURNAMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_457", function() { return SET_APPRAISER_TIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_458", function() { return SET_APPRAISER_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_459", function() { return SET_APPRAISER_COMPLETE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_460", function() { return SET_APPRAISER_PROF_ASSOC_REG_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_100", function() { return SET_APPRAISERS; });
/* unused harmony export UPDATE_APPRAISER */
/* unused harmony export CREATE_NEW_SUPERVISOR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_434", function() { return RESET_SUPERVISOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_439", function() { return SET_SUPERVISOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_436", function() { return SET_SUPERVISOR_DATE_CREATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_437", function() { return SET_SUPERVISOR_DATE_MODIFIED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_447", function() { return SET_SUPERVISOR_DIRTYNESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_435", function() { return SET_SUPERVISOR_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_440", function() { return SET_SUPERVISOR_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_441", function() { return SET_SUPERVISOR_ORGANIZATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_438", function() { return SET_SUPERVISOR_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_442", function() { return SET_SUPERVISOR_SURNAMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_443", function() { return SET_SUPERVISOR_TIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_444", function() { return SET_SUPERVISOR_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_445", function() { return SET_SUPERVISOR_COMPLETE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_446", function() { return SET_SUPERVISOR_PROF_ASSOC_REG_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_107", function() { return SET_SUPERVISORS; });
/* unused harmony export UPDATE_SUPERVISOR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_340", function() { return SET_CONTACT_ADDRESSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_338", function() { return SET_CONTACT_TELEPHONENUMBERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_339", function() { return SET_CONTACT_EMAILADDRESSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_337", function() { return SET_CONTACT_APPRAISALINVOICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_336", function() { return SET_CONTACT_APPRAISALQUOTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_335", function() { return SET_CONTACT_APPRAISALREPORTS; });
/* unused harmony export CREATE_NEW_ENTITY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_316", function() { return RESET_ENTITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_321", function() { return SET_ENTITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_318", function() { return SET_ENTITY_DATE_CREATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_319", function() { return SET_ENTITY_DATE_MODIFIED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_322", function() { return SET_ENTITY_DIRTYNESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_317", function() { return SET_ENTITY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_320", function() { return SET_ENTITY_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_113", function() { return SET_ENTITIES; });
/* unused harmony export UPDATE_ENTITY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_323", function() { return SET_ENTITY_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_324", function() { return SET_ENTITY_TIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_325", function() { return SET_ENTITY_BDE_CODE; });
/* unused harmony export CREATE_NEW_MARKETSTUDY */
/* unused harmony export DELETE_MARKETSTUDY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_273", function() { return RESET_MARKETSTUDY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_274", function() { return SET_MARKETSTUDY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_267", function() { return SET_MARKETSTUDY_DATE_CREATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_268", function() { return SET_MARKETSTUDY_DATE_MODIFIED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_275", function() { return SET_MARKETSTUDY_DIRTYNESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_266", function() { return SET_MARKETSTUDY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_269", function() { return SET_MARKETSTUDY_PARENT_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_270", function() { return SET_MARKETSTUDY_PATH; });
/* unused harmony export SET_MARKETSTUDY_PURPOSE */
/* unused harmony export SET_MARKETSTUDY_PURPOSE_NOTES */
/* unused harmony export SET_MARKETSTUDY_TYPE */
/* unused harmony export UPDATE_MARKETSTUDY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_276", function() { return SET_MARKETSTUDY_APPRAISAL_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_277", function() { return SET_MARKETSTUDY_DESCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_278", function() { return SET_MARKETSTUDY_QUERY_AD_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_279", function() { return SET_MARKETSTUDY_QUERY_DISTANCE_KM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_271", function() { return SET_MARKETSTUDY_QUERY_LIMITDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_272", function() { return SET_MARKETSTUDY_QUERY_STARTDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_280", function() { return SET_MARKETSTUDY_REPRESENTATIVE_SAMPLE_TYPICAL_DEVIATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_281", function() { return SET_MARKETSTUDY_UNIVERSAL_SAMPLE_TYPICAL_DEVIATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_282", function() { return SET_MARKETSTUDY_WEIGHING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_283", function() { return SET_MARKETSTUDY_WEIGHING_AD_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_284", function() { return SET_MARKETSTUDY_WEIGHING_PROPERTY_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_285", function() { return SET_MARKETSTUDY_WEIGHING_QUALITY_OF_NEIGHBOURHOOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_286", function() { return SET_MARKETSTUDY_WEIGHING_QUALITY_OF_SITUATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_287", function() { return SET_MARKETSTUDY_WEIGHING_QUALITY_OF_CONSTRUCTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_288", function() { return SET_MARKETSTUDY_WEIGHING_QUALITY_OF_REALESTATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_289", function() { return SET_MARKETSTUDY_WEIGHING_ADOPTED_AGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_290", function() { return SET_MARKETSTUDY_WEIGHING_CONSERVATION_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_291", function() { return SET_MARKETSTUDY_WEIGHING_FLOOR_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_292", function() { return SET_MARKETSTUDY_WEIGHING_ADOPTED_AREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_293", function() { return SET_MARKETSTUDY_WEIGHING_LIFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_294", function() { return SET_MARKETSTUDY_APPRAISED_POINTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_295", function() { return SET_MARKETSTUDY_COMPARABLE_POINTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_296", function() { return SET_MARKETSTUDY_REGRESSIONLINE_POINTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_297", function() { return SET_MARKETSTUDY_MARKET_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_298", function() { return SET_MARKETSTUDY_MARKET_UNIT_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_299", function() { return SET_MARKETSTUDY_REALESTATE_APPRAISALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_300", function() { return SET_MARKETSTUDY_PRICES_ESTIMATED_YEARLY_EVOLUTION_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_301", function() { return SET_MARKETSTUDY_MARKET_VALUE_EVOLUTION_PROBABILITY_PCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_302", function() { return SET_MARKETSTUDY_OFFER_PRODUCTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_303", function() { return SET_MARKETSTUDY_OFFER_YEARLY_STOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_304", function() { return SET_MARKETSTUDY_OFFER_TREND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_305", function() { return SET_MARKETSTUDY_DEMAND_LEVEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_306", function() { return SET_MARKETSTUDY_DEMAND_SPEED_OF_SALES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_307", function() { return SET_MARKETSTUDY_DEMAND_TREND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_308", function() { return SET_MARKETSTUDY_PRICES_EXPECTANCY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_309", function() { return SET_MARKETSTUDY_PRICES_PAST_CICLES_VOLATILITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_310", function() { return SET_MARKETSTUDY_MARKET_CONJUNCTURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_311", function() { return SET_MARKETSTUDY_MARKET_VALUE_REDUCTION_PROBABILITY_EXPECTANCY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_312", function() { return SET_MARKETSTUDY_PRICES_MAX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_313", function() { return SET_MARKETSTUDY_PRICES_MIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_314", function() { return SET_MARKETSTUDY_PRICES_MEAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_315", function() { return SET_MARKETSTUDY_PRICES_MEDIAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_265", function() { return SET_MARKETSTUDY_MATCHED_ADS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_264", function() { return SET_MARKETSTUDY_AD_COMPARABLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_90", function() { return SET_CONSTRAINT_NAME_CA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_91", function() { return SET_CONSTRAINT_NAME_EN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_92", function() { return SET_CONSTRAINT_NAME_ES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_93", function() { return SET_CONSTRAINT_DEFAULT_CONSTRAINTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return SET_WARNING_NAME_CA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return SET_WARNING_NAME_EN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return SET_WARNING_NAME_ES; });
/* unused harmony export SET_CONSTRAINT_DEFAULT_WARNINGS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return SET_NOTE_NAME_CA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return SET_NOTE_NAME_EN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return SET_NOTE_NAME_ES; });
/* unused harmony export SET_CONSTRAINT_DEFAULT_NOTES */
/* unused harmony export CREATE_NEW_PHOTOGRAPH */
/* unused harmony export DELETE_PHOTOGRAPH */
/* unused harmony export GET_PHOTOGRAPH */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return RESET_PHOTOGRAPH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return SET_PHOTOGRAPH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return SET_PHOTOGRAPH_DATE_CREATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return SET_PHOTOGRAPH_DATE_MODIFIED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return SET_PHOTOGRAPH_DIRTYNESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return SET_PHOTOGRAPH_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return SET_PHOTOGRAPH_PARENT_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return SET_PHOTOGRAPH_PATH; });
/* unused harmony export UPDATE_PHOTOGRAPH */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return SET_PHOTOGRAPH_NAME_CA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return SET_PHOTOGRAPH_NAME_EN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return SET_PHOTOGRAPH_NAME_ES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return SET_PHOTOGRAPH_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return SET_PHOTOGRAPH_FILENAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return SET_PHOTOGRAPH_IS_COVER_PHOTO; });
/* unused harmony export CREATE_NEW_PROJECT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return RESET_PROJECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return SET_PROJECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return SET_PROJECT_DATE_CREATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return SET_PROJECT_DATE_MODIFIED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return SET_PROJECT_DIRTYNESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return SET_PROJECT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return SET_PROJECT_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return SET_PROJECT_PARENT_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return SET_PROJECT_PROJECTDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return SET_PROJECT_REALESTATE_ID; });
/* unused harmony export UPDATE_PROJECT */
/* unused harmony export CREATE_NEW_REGISTRYANNEX */
/* unused harmony export DELETE_REGISTRYANNEX */
/* unused harmony export GET_REGISTRYANNEX */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return RESET_REGISTRYANNEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return SET_REGISTRYANNEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return SET_REGISTRYANNEX_DATE_CREATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return SET_REGISTRYANNEX_DATE_MODIFIED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return SET_REGISTRYANNEX_DIRTYNESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return SET_REGISTRYANNEX_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return SET_REGISTRYANNEX_PARENT_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return SET_REGISTRYANNEX_PATH; });
/* unused harmony export UPDATE_REGISTRYANNEX */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return SET_REGISTRYANNEX_NAME_CA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return SET_REGISTRYANNEX_NAME_EN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return SET_REGISTRYANNEX_NAME_ES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return SET_REGISTRYANNEX_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return SET_REGISTRYANNEX_FILENAME; });
/* unused harmony export CREATE_NEW_CADASTERANNEX */
/* unused harmony export DELETE_CADASTERANNEX */
/* unused harmony export GET_CADASTERANNEX */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return RESET_CADASTERANNEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return SET_CADASTERANNEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return SET_CADASTERANNEX_DATE_CREATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return SET_CADASTERANNEX_DATE_MODIFIED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return SET_CADASTERANNEX_DIRTYNESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return SET_CADASTERANNEX_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return SET_CADASTERANNEX_PARENT_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return SET_CADASTERANNEX_PATH; });
/* unused harmony export UPDATE_CADASTERANNEX */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return SET_CADASTERANNEX_NAME_CA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return SET_CADASTERANNEX_NAME_EN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return SET_CADASTERANNEX_NAME_ES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return SET_CADASTERANNEX_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return SET_CADASTERANNEX_FILENAME; });
/* unused harmony export CREATE_NEW_URBANANNEX */
/* unused harmony export DELETE_URBANANNEX */
/* unused harmony export GET_URBANANNEX */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return RESET_URBANANNEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return SET_URBANANNEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return SET_URBANANNEX_DATE_CREATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return SET_URBANANNEX_DATE_MODIFIED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return SET_URBANANNEX_DIRTYNESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return SET_URBANANNEX_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return SET_URBANANNEX_PARENT_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return SET_URBANANNEX_PATH; });
/* unused harmony export UPDATE_URBANANNEX */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return SET_URBANANNEX_NAME_CA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return SET_URBANANNEX_NAME_EN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return SET_URBANANNEX_NAME_ES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return SET_URBANANNEX_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return SET_URBANANNEX_FILENAME; });
/* unused harmony export CREATE_NEW_PLANANNEX */
/* unused harmony export DELETE_PLANANNEX */
/* unused harmony export GET_PLANANNEX */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return RESET_PLANANNEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return SET_PLANANNEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return SET_PLANANNEX_DATE_CREATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return SET_PLANANNEX_DATE_MODIFIED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return SET_PLANANNEX_DIRTYNESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return SET_PLANANNEX_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return SET_PLANANNEX_PARENT_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return SET_PLANANNEX_PATH; });
/* unused harmony export UPDATE_PLANANNEX */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return SET_PLANANNEX_NAME_CA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return SET_PLANANNEX_NAME_EN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return SET_PLANANNEX_NAME_ES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return SET_PLANANNEX_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return SET_PLANANNEX_FILENAME; });
/* unused harmony export CREATE_NEW_CESSIONANNEX */
/* unused harmony export DELETE_CESSIONANNEX */
/* unused harmony export GET_CESSIONANNEX */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return RESET_CESSIONANNEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return SET_CESSIONANNEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return SET_CESSIONANNEX_DATE_CREATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return SET_CESSIONANNEX_DATE_MODIFIED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return SET_CESSIONANNEX_DIRTYNESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return SET_CESSIONANNEX_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return SET_CESSIONANNEX_PARENT_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return SET_CESSIONANNEX_PATH; });
/* unused harmony export UPDATE_CESSIONANNEX */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return SET_CESSIONANNEX_NAME_CA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return SET_CESSIONANNEX_NAME_EN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return SET_CESSIONANNEX_NAME_ES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return SET_CESSIONANNEX_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return SET_CESSIONANNEX_FILENAME; });
/* unused harmony export CREATE_NEW_OTHERANNEX */
/* unused harmony export DELETE_OTHERANNEX */
/* unused harmony export GET_OTHERANNEX */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return RESET_OTHERANNEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SET_OTHERANNEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_OTHERANNEX_DATE_CREATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SET_OTHERANNEX_DATE_MODIFIED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SET_OTHERANNEX_DIRTYNESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_OTHERANNEX_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SET_OTHERANNEX_PARENT_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SET_OTHERANNEX_PATH; });
/* unused harmony export UPDATE_OTHERANNEX */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SET_OTHERANNEX_NAME_CA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SET_OTHERANNEX_NAME_EN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SET_OTHERANNEX_NAME_ES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SET_OTHERANNEX_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SET_OTHERANNEX_FILENAME; });
/* unused harmony export CREATE_NEW_ROOM */
/* unused harmony export DELETE_ROOM */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_171", function() { return RESET_ROOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_172", function() { return SET_ROOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_167", function() { return SET_ROOM_DATE_CREATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_168", function() { return SET_ROOM_DATE_MODIFIED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_173", function() { return SET_ROOM_DIRTYNESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_166", function() { return SET_ROOM_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_169", function() { return SET_ROOM_PARENT_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_170", function() { return SET_ROOM_PATH; });
/* unused harmony export UPDATE_ROOM */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_174", function() { return SET_ROOM_DESCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_176", function() { return SET_ROOM_NETAREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_175", function() { return SET_ROOM_TYPE; });
/* unused harmony export CREATE_NEW_LINE */
/* unused harmony export DELETE_LINE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_159", function() { return RESET_LINE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_160", function() { return SET_LINE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_155", function() { return SET_LINE_DATE_CREATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_156", function() { return SET_LINE_DATE_MODIFIED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_161", function() { return SET_LINE_DIRTYNESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_154", function() { return SET_LINE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_157", function() { return SET_LINE_PARENT_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_158", function() { return SET_LINE_PATH; });
/* unused harmony export UPDATE_LINE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_162", function() { return SET_LINE_DESCRIPTION; });
/* unused harmony export SET_LINE_NETAREA */
/* unused harmony export SET_LINE_TYPE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_163", function() { return SET_LINE_UNITS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_164", function() { return SET_LINE_UNIT_PRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_165", function() { return SET_LINE_PRICE; });
/* unused harmony export CREATE_NEW_COVERED_OUTDOOR */
/* unused harmony export DELETE_COVERED_OUTDOOR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_148", function() { return RESET_COVERED_OUTDOOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_149", function() { return SET_COVERED_OUTDOOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_144", function() { return SET_COVERED_OUTDOOR_DATE_CREATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_145", function() { return SET_COVERED_OUTDOOR_DATE_MODIFIED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_150", function() { return SET_COVERED_OUTDOOR_DIRTYNESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_143", function() { return SET_COVERED_OUTDOOR_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_146", function() { return SET_COVERED_OUTDOOR_PARENT_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_147", function() { return SET_COVERED_OUTDOOR_PATH; });
/* unused harmony export UPDATE_COVERED_OUTDOOR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_151", function() { return SET_COVERED_OUTDOOR_DESCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_153", function() { return SET_COVERED_OUTDOOR_NETAREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_152", function() { return SET_COVERED_OUTDOOR_TYPE; });
/* unused harmony export CREATE_NEW_UNCOVERED_OUTDOOR */
/* unused harmony export DELETE_UNCOVERED_OUTDOOR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_137", function() { return RESET_UNCOVERED_OUTDOOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_138", function() { return SET_UNCOVERED_OUTDOOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_133", function() { return SET_UNCOVERED_OUTDOOR_DATE_CREATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_134", function() { return SET_UNCOVERED_OUTDOOR_DATE_MODIFIED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_139", function() { return SET_UNCOVERED_OUTDOOR_DIRTYNESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_132", function() { return SET_UNCOVERED_OUTDOOR_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_135", function() { return SET_UNCOVERED_OUTDOOR_PARENT_PATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_136", function() { return SET_UNCOVERED_OUTDOOR_PATH; });
/* unused harmony export UPDATE_UNCOVERED_OUTDOOR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_140", function() { return SET_UNCOVERED_OUTDOOR_DESCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_142", function() { return SET_UNCOVERED_OUTDOOR_NETAREA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_141", function() { return SET_UNCOVERED_OUTDOOR_TYPE; });
/* unused harmony export CREATE_NEW_TELEPHONENUMBER */
/* unused harmony export DELETE_TELEPHONENUMBER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_126", function() { return RESET_TELEPHONENUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_127", function() { return SET_TELEPHONENUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_123", function() { return SET_TELEPHONENUMBER_DATE_CREATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_124", function() { return SET_TELEPHONENUMBER_DATE_MODIFIED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_131", function() { return SET_TELEPHONENUMBER_DIRTYNESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_122", function() { return SET_TELEPHONENUMBER_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_125", function() { return SET_TELEPHONENUMBER_PATH; });
/* unused harmony export UPDATE_TELEPHONENUMBER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_128", function() { return SET_TELEPHONENUMBER_DESCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_129", function() { return SET_TELEPHONENUMBER_NUMBER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_130", function() { return SET_TELEPHONENUMBER_PREFIX; });
/* unused harmony export CREATE_NEW_EMAILADDRESS */
/* unused harmony export DELETE_EMAILADDRESS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_330", function() { return RESET_EMAILADDRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_331", function() { return SET_EMAILADDRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_327", function() { return SET_EMAILADDRESS_DATE_CREATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_328", function() { return SET_EMAILADDRESS_DATE_MODIFIED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_332", function() { return SET_EMAILADDRESS_DIRTYNESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_326", function() { return SET_EMAILADDRESS_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_329", function() { return SET_EMAILADDRESS_PATH; });
/* unused harmony export UPDATE_EMAILADDRESS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_334", function() { return SET_EMAILADDRESS_DESCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_333", function() { return SET_EMAILADDRESS_ADDRESS; });
// Root state constants
var SET_LANGUAGE = 'SET_LANGUAGE';
var SET_THEME = 'SET_THEME';
var SET_TAGS_DISPLAY = 'SET_TAGS_DISPLAY';
var SET_VALUATION_PRICES = 'SET_VALUATION_PRICES';
var SET_QUERY = 'SET_QUERY';
var SET_RESULT_INDEX = 'SET_RESULT_INDEX';
var SET_RENAMING_ID = 'SET_RENAMING_ID';
var SET_EDITING_ID = 'SET_EDITING_ID';
var UPDATE_BUDGET_REQUEST = 'UPDATE_BUDGET_REQUEST';

// Auth module constants
var SET_USER = 'SET_USER';

// Notes module constants
var SET_NOTES = 'SET_NOTES';
var SET_ACTIVE_CONTACT = 'SET_ACTIVE_CONTACT';
var SET_ACTIVE_NOTE = 'SET_ACTIVE_NOTE';
var SET_ACTIVE_KEY = 'SET_ACTIVE_KEY';
var SET_APPRAISALFILES = 'SET_APPRAISALFILES';
var SET_USER_ROLE = 'SET_USER_ROLE';
var SET_BECPROPERTIES = 'SET_BECPROPERTIES';
var CREATE_NOTE = 'CREATE_NOTE';
var TOGGLE_IS_PUBLIC = 'TOGGLE_IS_PUBLIC';
var SET_BDE_APPRAISAL_FILES = 'SET_BDE_APPRAISAL_FILES';
var SET_BDE_REALESTATE_FILES = 'SET_BDE_REALESTATE_FILES';
var SET_BDE_COMPARABLE_FILES = 'SET_BDE_COMPARABLE_FILES';
var SET_BDE_RELATIONSHIPS_FILES = 'SET_BDE_RELATIONSHIPS_FILES';

// Stats
var SET_STATS_CURRENT = 'SET_STATS_CURRENT';

// App
var SET_APPRAISALS = 'SET_APPRAISALS';
var SET_MARKETSTUDIES = 'SET_MARKETSTUDIES';
var SET_AD_COMPARABLES = 'SET_AD_COMPARABLES';
var SET_WARNINGS = 'SET_WARNINGS';
var SET_CONSTRAINTS = 'SET_CONSTRAINTS';

// ad
var CREATE_NEW_AD = 'CREATE_NEW_AD';
var DELETE_AD = 'DELETE_AD';
var RESET_AD = 'RESET_AD';
var SET_AD = 'SET_AD';
var SET_AD_CADASTRAL_REFERENCE = 'SET_AD_CADASTRAL_REFERENCE';
var SET_AD_CENSUS_SECTION_CODE = 'SET_AD_CENSUS_SECTION_CODE';
var SET_AD_COUNTRY = 'SET_AD_COUNTRY';
var SET_AD_DATE_CREATED = 'SET_AD_DATE_CREATED';
var SET_AD_DATE_MODIFIED = 'SET_AD_DATE_MODIFIED';
var SET_AD_DESCRIPTION = 'SET_AD_DESCRIPTION';
var SET_AD_DIRTYNESS = 'SET_AD_DIRTYNESS';
var SET_AD_DOOR = 'SET_AD_DOOR';
var SET_AD_EPSG25831_X = 'SET_AD_EPSG25831_X';
var SET_AD_EPSG25831_Y = 'SET_AD_EPSG25831_Y';
var SET_AD_FLOOR = 'SET_AD_FLOOR';
var SET_AD_GEOHASH = 'SET_AD_GEOHASH';
var SET_AD_GOOGLE_FORMATTED_ADDRESS = 'SET_AD_GOOGLE_FORMATTED_ADDRESS';
var SET_AD_GOOGLE_VIEWPORT = 'SET_AD_GOOGLE_VIEWPORT';
var SET_AD_ID = 'SET_AD_ID';
var SET_AD_LAT = 'SET_AD_LAT';
var SET_AD_LNG = 'SET_AD_LNG';
var SET_AD_MUNICIPALITY = 'SET_AD_MUNICIPALITY';
var SET_AD_PARENT_PATH = 'SET_AD_PARENT_PATH';
var SET_AD_PATH = 'SET_AD_PATH';
var SET_AD_POSTAL_CODE = 'SET_AD_POSTAL_CODE';
var SET_AD_PROVINCE = 'SET_AD_PROVINCE';
var SET_AD_STAIRCASE = 'SET_AD_STAIRCASE';
var SET_AD_STREET_NAME = 'SET_AD_STREET_NAME';
var SET_AD_STREET_NUMBER = 'SET_AD_STREET_NUMBER';
var UPDATE_AD = 'UPDATE_AD';
var SET_AD_CADASTRAL_AREA = 'SET_AD_CADASTRAL_AREA';
var SET_AD_REGISTRY_IDUFIR = 'SET_AD_REGISTRY_IDUFIR';
var SET_AD_AD_DATE = 'SET_AD_AD_DATE';
var SET_AD_AD_TYPE = 'SET_AD_AD_TYPE';
var SET_AD_AD_YEAR = 'SET_AD_AD_YEAR';
var SET_AD_ADOPTED_AREA = 'SET_AD_ADOPTED_AREA';
var SET_AD_ADOPTED_AGE = 'SET_AD_ADOPTED_AGE';
var SET_AD_AIR_CONDITIONING = 'SET_AD_AIR_CONDITIONING';
var SET_AD_BATHROOMS_NUMBER = 'SET_AD_BATHROOMS_NUMBER';
var SET_AD_BEDROOMS_NUMBER = 'SET_AD_BEDROOMS_NUMBER';
var SET_AD_COVERED_OUTDOOR_AREA = 'SET_AD_COVERED_OUTDOOR_AREA';
var SET_AD_UNCOVERED_OUTDOOR_AREA = 'SET_AD_UNCOVERED_OUTDOOR_AREA';
var SET_AD_CONSTRUCTION_YEAR = 'SET_AD_CONSTRUCTION_YEAR';
var SET_AD_DWELLING_TYPE = 'SET_AD_DWELLING_TYPE';
var SET_AD_ESTIMATED_SALE_PRICE = 'SET_AD_ESTIMATED_SALE_PRICE';
var SET_AD_EXTERNAL_STORAGE_ROOM = 'SET_AD_EXTERNAL_STORAGE_ROOM';
var SET_AD_FLOOR_NUMBER = 'SET_AD_FLOOR_NUMBER';
var SET_AD_FLOOR_TYPE = 'SET_AD_FLOOR_TYPE';
var SET_AD_GREEN_AREAS = 'SET_AD_GREEN_AREAS';
var SET_AD_HEATING = 'SET_AD_HEATING';
var SET_AD_LAST_RENOVATION_YEAR = 'SET_AD_LAST_RENOVATION_YEAR';
var SET_AD_LIFT = 'SET_AD_LIFT';
var SET_AD_OFFER_PRICE = 'SET_AD_OFFER_PRICE';
var SET_AD_PARKING_LOTS_NUMBER = 'SET_AD_PARKING_LOTS_NUMBER';
var SET_AD_QUALITY_OF_NEIGHBOURHOOD = 'SET_AD_QUALITY_OF_NEIGHBOURHOOD';
var SET_AD_QUALITY_OF_SITUATION = 'SET_AD_QUALITY_OF_SITUATION';
var SET_AD_QUALITY_OF_CONSTRUCTION = 'SET_AD_QUALITY_OF_CONSTRUCTION';
var SET_AD_QUALITY_OF_REALESTATE = 'SET_AD_QUALITY_OF_REALESTATE';
var SET_AD_SPORTS_FACILITIES = 'SET_AD_SPORTS_FACILITIES';
var SET_AD_SWIMMING_POOL = 'SET_AD_SWIMMING_POOL';
var SET_AD_AD_ADDRESS = 'SET_AD_AD_ADDRESS';
var SET_AD_BUILT_AREA = 'SET_AD_BUILT_AREA';
var SET_AD_CAPTURE_DATE = 'SET_AD_CAPTURE_DATE';
var SET_AD_AD_DATA_TYPE = 'SET_AD_DATA_TYPE';
var SET_AD_AD_CODE = 'SET_AD_AD_CODE';
var SET_AD_INTERIOR_VISIT_CHECK = 'SET_AD_INTERIOR_VISIT_CHECK';
var SET_AD_LAND_AREA = 'SET_AD_LAND_AREA';
var SET_AD_NET_AREA = 'SET_AD_NET_AREA';
var SET_AD_CADASTRAL_DATA_CHECK = 'SET_AD_CADASTRAL_DATA_CHECK';
var SET_AD_CONTACT_TELEPHONE = 'SET_AD_CONTACT_TELEPHONE';
var SET_AD_NOTES_1 = 'SET_AD_NOTES_1';
var SET_AD_NOTES_2 = 'SET_AD_NOTES_2';
var SET_AD_ORIENTATION = 'SET_AD_ORIENTATION';
var SET_AD_PROPERTY_TYPE = 'SET_AD_PROPERTY_TYPE';
var SET_AD_SOURCE = 'SET_AD_SOURCE';
var SET_AD_URL = 'SET_AD_URL';
var SET_AD_BLOCK = 'SET_AD_BLOCK';
var SET_AD_CONTACT_NAME = 'SET_AD_CONTACT_NAME';
var SET_AD_OFFER_UNIT_PRICE = 'SET_AD_OFFER_UNIT_PRICE';
var SET_AD_CONSERVATION_STATUS = 'SET_AD_CONSERVATION_STATUS';
var SET_AD_OFFER_PRICE_REDUCTION_PCT = 'SET_AD_OFFER_PRICE_REDUCTION_PCT';
var SET_AD_ESTIMATED_UNIT_SALE_PRICE = 'SET_AD_ESTIMATED_UNIT_SALE_PRICE';

// ad_comparable
var CREATE_NEW_AD_COMPARABLE = 'CREATE_NEW_AD_COMPARABLE';
var DELETE_AD_COMPARABLE = 'DELETE_AD_COMPARABLE';
var RESET_AD_COMPARABLE = 'RESET_AD_COMPARABLE';
var SET_AD_COMPARABLE = 'SET_AD_COMPARABLE';
var SET_AD_COMPARABLE_DATE_CREATED = 'SET_AD_COMPARABLE_DATE_CREATED';
var SET_AD_COMPARABLE_DATE_MODIFIED = 'SET_AD_COMPARABLE_DATE_MODIFIED';
var SET_AD_COMPARABLE_DIRTYNESS = 'SET_AD_COMPARABLE_DIRTYNESS';
var SET_AD_COMPARABLE_ID = 'SET_AD_COMPARABLE_ID';
var SET_AD_COMPARABLE_PARENT_PATH = 'SET_AD_COMPARABLE_PARENT_PATH';
var SET_AD_COMPARABLE_PATH = 'SET_AD_COMPARABLE_PATH';
var UPDATE_AD_COMPARABLE = 'UPDATE_AD_COMPARABLE';
var SET_AD_COMPARABLE_DESCRIPTION = 'SET_AD_COMPARABLE_DESCRIPTION';

// ad_municipalities
var SET_AD_MUNICIPALITIES = 'SET_AD_MUNICIPALITIES';

// realestate
var CREATE_NEW_REALESTATE = 'CREATE_NEW_REALESTATE';
var DELETE_REALESTATE = 'DELETE_REALESTATE';
var RESET_REALESTATE = 'RESET_REALESTATE';
var SET_REALESTATE = 'SET_REALESTATE';
var SET_REALESTATE_CADASTRAL_REFERENCE = 'SET_REALESTATE_CADASTRAL_REFERENCE';
var SET_REALESTATE_CENSUS_SECTION_CODE = 'SET_REALESTATE_CENSUS_SECTION_CODE';
var SET_REALESTATE_COUNTRY = 'SET_REALESTATE_COUNTRY';
var SET_REALESTATE_DATE_CREATED = 'SET_REALESTATE_DATE_CREATED';
var SET_REALESTATE_DATE_MODIFIED = 'SET_REALESTATE_DATE_MODIFIED';
var SET_REALESTATE_DESCRIPTION = 'SET_REALESTATE_DESCRIPTION';
var SET_REALESTATE_DIRTYNESS = 'SET_REALESTATE_DIRTYNESS';
var SET_REALESTATE_DOOR = 'SET_REALESTATE_DOOR';
var SET_REALESTATE_EPSG25831_X = 'SET_REALESTATE_EPSG25831_X';
var SET_REALESTATE_EPSG25831_Y = 'SET_REALESTATE_EPSG25831_Y';
var SET_REALESTATE_FLOOR = 'SET_REALESTATE_FLOOR';
var SET_REALESTATE_FLOOR_NUMBER = 'SET_REALESTATE_FLOOR_NUMBER';
var SET_REALESTATE_GEOHASH = 'SET_REALESTATE_GEOHASH';
var SET_REALESTATE_GOOGLE_FORMATTED_ADDRESS = 'SET_REALESTATE_GOOGLE_FORMATTED_ADDRESS';
var SET_REALESTATE_GOOGLE_VIEWPORT = 'SET_REALESTATE_GOOGLE_VIEWPORT';
var SET_REALESTATE_ID = 'SET_REALESTATE_ID';
var SET_REALESTATE_LAT = 'SET_REALESTATE_LAT';
var SET_REALESTATE_LNG = 'SET_REALESTATE_LNG';
var SET_REALESTATE_MUNICIPALITY = 'SET_REALESTATE_MUNICIPALITY';
var SET_REALESTATE_PARENT_PATH = 'SET_REALESTATE_PARENT_PATH';
var SET_REALESTATE_PATH = 'SET_REALESTATE_PATH';
var SET_REALESTATE_POSTAL_CODE = 'SET_REALESTATE_POSTAL_CODE';
var SET_REALESTATE_PROPERTY_TYPE = 'SET_REALESTATE_PROPERTY_TYPE';
var SET_REALESTATE_PROVINCE = 'SET_REALESTATE_PROVINCE';
var SET_REALESTATE_REGISTRY_NAME = 'SET_REALESTATE_REGISTRY_NAME';
var SET_REALESTATE_STAIRCASE = 'SET_REALESTATE_STAIRCASE';
var SET_REALESTATE_STREET_NAME = 'SET_REALESTATE_STREET_NAME';
var SET_REALESTATE_STREET_NUMBER = 'SET_REALESTATE_STREET_NUMBER';
var SET_REALESTATE_MAP_GOOGLE_01_URL = 'SET_REALESTATE_MAP_GOOGLE_01_URL';
var SET_REALESTATE_MAP_GOOGLE_01_LAT = 'SET_REALESTATE_MAP_GOOGLE_01_LAT';
var SET_REALESTATE_MAP_GOOGLE_01_LNG = 'SET_REALESTATE_MAP_GOOGLE_01_LNG';
var SET_REALESTATE_MAP_GOOGLE_01_ZOOM = 'SET_REALESTATE_MAP_GOOGLE_01_ZOOM';
var SET_REALESTATE_MAP_GOOGLE_02_URL = 'SET_REALESTATE_MAP_GOOGLE_02_URL';
var SET_REALESTATE_MAP_GOOGLE_02_LAT = 'SET_REALESTATE_MAP_GOOGLE_02_LAT';
var SET_REALESTATE_MAP_GOOGLE_02_LNG = 'SET_REALESTATE_MAP_GOOGLE_02_LNG';
var SET_REALESTATE_MAP_GOOGLE_02_ZOOM = 'SET_REALESTATE_MAP_GOOGLE_02_ZOOM';
var SET_REALESTATE_MAP_GOOGLE_03_URL = 'SET_REALESTATE_MAP_GOOGLE_03_URL';
var SET_REALESTATE_MAP_GOOGLE_03_LAT = 'SET_REALESTATE_MAP_GOOGLE_03_LAT';
var SET_REALESTATE_MAP_GOOGLE_03_LNG = 'SET_REALESTATE_MAP_GOOGLE_03_LNG';
var SET_REALESTATE_MAP_GOOGLE_03_ZOOM = 'SET_REALESTATE_MAP_GOOGLE_03_ZOOM';
var SET_REALESTATE_FULL_ADDRESS = 'SET_REALESTATE_FULL_ADDRESS';
var SET_REALESTATE_SHORT_ADDRESS = 'SET_REALESTATE_SHORT_ADDRESS';
var SET_REALESTATE_BLOCK = 'SET_REALESTATE_BLOCK';
var SET_REALESTATES = 'SET_REALESTATES';
var SET_REALESTATE_AREA_ADS_MARKERS = 'SET_REALESTATE_AREA_ADS_MARKERS';
var SET_REALESTATE_AREA_AVERAGE_PRICE = 'SET_REALESTATE_AREA_AVERAGE_PRICE';
var SET_REALESTATE_AREA_AVERAGE_PRICE_COEF = 'SET_REALESTATE_AREA_AVERAGE_PRICE_COEF';
var SET_REALESTATE_ADOPTED_AREA_AVERAGE_PRICE = 'SET_REALESTATE_ADOPTED_AREA_AVERAGE_PRICE';
var SET_REALESTATE_ESTIMATED_BUILT_AREA = 'SET_REALESTATE_ESTIMATED_BUILT_AREA';
var SET_REALESTATE_PRE_APPRAISAL_VALUE = 'SET_REALESTATE_PRE_APPRAISAL_VALUE';
var SET_REALESTATE_TRAVEL_ONE_WAY_HOURS = 'SET_REALESTATE_TRAVEL_ONE_WAY_HOURS';
var SET_REALESTATE_TRAVEL_BOTH_WAYS_HOURS = 'SET_REALESTATE_TRAVEL_BOTH_WAYS_HOURS';
var SET_REALESTATE_TRAVEL_FEES_PER_HOUR = 'SET_REALESTATE_TRAVEL_FEES_PER_HOUR';
var SET_REALESTATE_CAR_FUEL_EXPENSES_ONE_WAY = 'SET_REALESTATE_CAR_FUEL_EXPENSES_ONE_WAY';
var SET_REALESTATE_CAR_FUEL_EXPENSES_BOTH_WAYS = 'SET_REALESTATE_CAR_FUEL_EXPENSES_BOTH_WAYS';
var SET_REALESTATE_CAR_TOLL_EXPENSES_ONE_WAY = 'SET_REALESTATE_CAR_TOLL_EXPENSES_ONE_WAY';
var SET_REALESTATE_CAR_TOLL_EXPENSES_BOTH_WAYS = 'SET_REALESTATE_CAR_TOLL_EXPENSES_BOTH_WAYS';
var SET_REALESTATE_CAR_EXPENSES_ONE_WAY = 'SET_REALESTATE_CAR_EXPENSES_ONE_WAY';
var SET_REALESTATE_CAR_EXPENSES_BOTH_WAYS = 'SET_REALESTATE_CAR_EXPENSES_BOTH_WAYS';
var SET_REALESTATE_TOTAL_TRAVEL_FEES = 'SET_REALESTATE_TOTAL_TRAVEL_FEES';
var SET_REALESTATE_QUOTE_BASE_FEES = 'SET_REALESTATE_QUOTE_BASE_FEES';
var SET_REALESTATE_QUOTE_EXCESS_PCT = 'SET_REALESTATE_QUOTE_EXCESS_PCT';
var SET_REALESTATE_QUOTE_BASE_PRICE = 'SET_REALESTATE_QUOTE_BASE_PRICE';
var SET_REALESTATE_QUOTE_BASE_PRICE_COEF = 'SET_REALESTATE_QUOTE_BASE_PRICE_COEF';
var SET_REALESTATE_QUOTE_APPRAISAL_TYPE_IS_ECO = 'SET_REALESTATE_QUOTE_APPRAISAL_TYPE_IS_ECO';
var SET_REALESTATE_QUOTE_PRICE_INCL_TRAVEL_EXPENSES = 'SET_REALESTATE_QUOTE_PRICE_INCL_TRAVEL_EXPENSES';
var SET_REALESTATE_AREA_ADS_QUERY_STARTDATE = 'SET_REALESTATE_AREA_ADS_QUERY_STARTDATE';
var SET_REALESTATE_AREA_ADS_QUERY_LIMITDATE = 'SET_REALESTATE_AREA_ADS_QUERY_LIMITDATE';
var SET_REALESTATE_AREA_ADS_QUERY_DISTANCE = 'SET_REALESTATE_AREA_ADS_QUERY_DISTANCE';
var SET_REALESTATE_INVOICE_BASE_FEES = 'SET_REALESTATE_INVOICE_BASE_FEES';
var SET_REALESTATE_INVOICE_EXCESS_PCT = 'SET_REALESTATE_INVOICE_EXCESS_PCT';
var SET_REALESTATE_INVOICE_BASE_PRICE = 'SET_REALESTATE_INVOICE_BASE_PRICE';
var SET_REALESTATE_INVOICE_BASE_PRICE_COEF = 'SET_REALESTATE_INVOICE_BASE_PRICE_COEF';
var SET_REALESTATE_INVOICE_APPRAISAL_TYPE_IS_ECO = 'SET_REALESTATE_INVOICE_APPRAISAL_TYPE_IS_ECO';
var SET_REALESTATE_QUOTE_EXCESS = 'SET_REALESTATE_QUOTE_EXCESS';
var SET_REALESTATE_ASSET_TYPE = 'SET_REALESTATE_ASSET_TYPE';
var SET_REALESTATE_DWELLING_TYPE = 'SET_REALESTATE_DWELLING_TYPE';
var SET_REALESTATE_FLOOR_TYPE = 'SET_REALESTATE_FLOOR_TYPE';
var UPDATE_REALESTATE = 'UPDATE_REALESTATE';

// realestate_appraisals
var SET_ALL_REALESTATE_APPRAISALS = 'SET_ALL_REALESTATE_APPRAISALS';
var SET_REALESTATE_APPRAISALS = 'SET_REALESTATE_APPRAISALS';

// realestate_marketstudies
var SET_REALESTATE_MARKETSTUDIES = 'SET_REALESTATE_MARKETSTUDIES';
var SET_TEMP_REALESTATE_MARKETSTUDIES = 'SET_TEMP_REALESTATE_MARKETSTUDIES';

// realestate_projects
var SET_ALL_REALESTATE_PROJECTS = 'SET_ALL_REALESTATE_PROJECTS';
var SET_REALESTATE_PROJECTS = 'SET_REALESTATE_PROJECTS';

// realestate_municipalities
var SET_REALESTATE_MUNICIPALITIES = 'SET_REALESTATE_MUNICIPALITIES';

// appraisal
var CREATE_NEW_APPRAISAL = 'CREATE_NEW_APPRAISAL';
var DELETE_APPRAISAL = 'DELETE_APPRAISAL';
var RESET_APPRAISAL = 'RESET_APPRAISAL';
var SET_APPRAISAL = 'SET_APPRAISAL';
var SET_APPRAISAL_DATE_CREATED = 'SET_APPRAISAL_DATE_CREATED';
var SET_APPRAISAL_DATE_MODIFIED = 'SET_APPRAISAL_DATE_MODIFIED';
var SET_APPRAISAL_DIRTYNESS = 'SET_APPRAISAL_DIRTYNESS';
var SET_APPRAISAL_ID = 'SET_APPRAISAL_ID';
var SET_APPRAISAL_PARENT_PATH = 'SET_APPRAISAL_PARENT_PATH';
var SET_APPRAISAL_PATH = 'SET_APPRAISAL_PATH';
var SET_APPRAISAL_PURPOSE = 'SET_APPRAISAL_PURPOSE';
var SET_APPRAISAL_PURPOSE_NOTES = 'SET_APPRAISAL_PURPOSE_NOTES';
var SET_APPRAISAL_TYPE = 'SET_APPRAISAL_TYPE';
var UPDATE_APPRAISAL = 'UPDATE_APPRAISAL';
var SET_APPRAISAL_APPRAISALDATE = 'SET_APPRAISAL_APPRAISALDATE';
var SET_APPRAISAL_VISITDATE = 'SET_APPRAISAL_VISITDATE';
var SET_APPRAISAL_TECHNICIAN_VISITING = 'SET_APPRAISAL_TECHNICIAN_VISITING';
var SET_APPRAISAL_DESCRIPTION = 'SET_APPRAISAL_DESCRIPTION';
var SET_APPRAISAL_CHECKS_CADASTRAL_DATA = 'SET_APPRAISAL_CHECKS_CADASTRAL_DATA';
var SET_APPRAISAL_CHECKS_CONSERVATION_STATUS = 'SET_APPRAISAL_CHECKS_CONSERVATION_STATUS';
var SET_APPRAISAL_CHECKS_EXPROPRIATION_PROCEDURE = 'SET_APPRAISAL_CHECKS_EXPROPRIATION_PROCEDURE';
var SET_APPRAISAL_CHECKS_EXPROPRIATION_PLAN = 'SET_APPRAISAL_CHECKS_EXPROPRIATION_PLAN';
var SET_APPRAISAL_CHECKS_EXPROPRIATION_ADMIN_RULING = 'SET_APPRAISAL_CHECKS_EXPROPRIATION_ADMIN_RULING';
var SET_APPRAISAL_CHECKS_EXPROPRIATION_FILE = 'SET_APPRAISAL_CHECKS_EXPROPRIATION_FILE';
var SET_APPRAISAL_CHECKS_INTERIOR_VISIT = 'SET_APPRAISAL_CHECKS_INTERIOR_VISIT';
var SET_APPRAISAL_CHECKS_OCCUPANCY = 'SET_APPRAISAL_CHECKS_OCCUPANCY';
var SET_APPRAISAL_CHECKS_OTHER = 'SET_APPRAISAL_CHECKS_OTHER';
var SET_APPRAISAL_CHECKS_REGISTRY_DATA = 'SET_APPRAISAL_CHECKS_REGISTRY_DATA';
var SET_APPRAISAL_CHECKS_SERVITUDES = 'SET_APPRAISAL_CHECKS_SERVITUDES';
var SET_APPRAISAL_CHECKS_SUBSIDY_STATUS = 'SET_APPRAISAL_CHECKS_SUBSIDY_STATUS';
var SET_APPRAISAL_CHECKS_URBAN_PLANNING = 'SET_APPRAISAL_CHECKS_URBAN_PLANNING';
var SET_APPRAISAL_DOCS_APPROVED_PROJECT = 'SET_APPRAISAL_DOCS_APPROVED_PROJECT';
var SET_APPRAISAL_DOCS_CADASTRAL_DATA = 'SET_APPRAISAL_DOCS_CADASTRAL_DATA';
var SET_APPRAISAL_DOCS_CONSTRUCTION_LICENSE = 'SET_APPRAISAL_DOCS_CONSTRUCTION_LICENSE';
var SET_APPRAISAL_DOCS_CONSTRUCTION_LAST_CERTIFICATE = 'SET_APPRAISAL_CONSTRUCTION_LAST_CERTIFICATE';
var SET_APPRAISAL_DOCS_CONSTRUCTION_CONTRACT = 'SET_APPRAISAL_DOCS_CONSTRUCTION_CONTRACT';
var SET_APPRAISAL_DOCS_OCCUPANCY_STATUS = 'SET_APPRAISAL_DOCS_OCCUPANCY_STATUS';
var SET_APPRAISAL_DOCS_OTHER = 'SET_APPRAISAL_DOCS_OTHER';
var SET_APPRAISAL_DOCS_PHOTOGRAPHIC_REPORT = 'SET_APPRAISAL_DOCS_PHOTOGRAPHIC_REPORT';
var SET_APPRAISAL_DOCS_PROPERTY_SKETCH = 'SET_APPRAISAL_DOCS_PROPERTY_SKETCH';
var SET_APPRAISAL_DOCS_PROPERTY_TITLES = 'SET_APPRAISAL_DOCS_PROPERTY_TITLES';
var SET_APPRAISAL_DOCS_SITUATION_PLAN = 'SET_APPRAISAL_DOCS_SITUATION_PLAN';
var SET_APPRAISAL_DOCS_SUBSIDY_STATUS = 'SET_APPRAISAL_DOCS_SUBSIDY_STATUS';
var SET_APPRAISAL_DOCS_TENYEAR_INSURANCE = 'SET_APPRAISAL_DOCS_TENYEAR_INSURANCE';
var SET_APPRAISAL_DOCS_URBAN_PLAN = 'SET_APPRAISAL_DOCS_URBAN_PLAN';
var SET_APPRAISAL_ADOPTED_AREA = 'SET_APPRAISAL_ADOPTED_AREA';
var SET_APPRAISAL_LIFT = 'SET_APPRAISAL_LIFT';
var SET_APPRAISAL_ADOPTED_AGE = 'SET_APPRAISAL_ADOPTED_AGE';
var SET_APPRAISAL_PROPERTY_TYPE = 'SET_APPRAISAL_PROPERTY_TYPE';
var SET_APPRAISAL_QUALITY_OF_NEIGHBOURHOOD = 'SET_APPRAISAL_QUALITY_OF_NEIGHBOURHOOD';
var SET_APPRAISAL_QUALITY_OF_SITUATION = 'SET_APPRAISAL_QUALITY_OF_SITUATION';
var SET_APPRAISAL_QUALITY_OF_CONSTRUCTION = 'SET_APPRAISAL_QUALITY_OF_CONSTRUCTION';
var SET_APPRAISAL_QUALITY_OF_REALESTATE = 'SET_APPRAISAL_QUALITY_OF_REALESTATE';
var SET_APPRAISAL_CONSERVATION_STATUS = 'SET_APPRAISAL_CONSERVATION_STATUS';
var SET_APPRAISAL_FLOOR_NUMBER = 'SET_APPRAISAL_FLOOR_NUMBER';
var SET_APPRAISAL_MARKET_VALUE = 'SET_APPRAISAL_MARKET_VALUE';
var SET_APPRAISAL_MARKET_UNIT_VALUE = 'SET_APPRAISAL_MARKET_UNIT_VALUE';
var SET_MARKET_VALUE_APPRAISER_ADJUSTMENT_PCT = 'SET_MARKET_VALUE_APPRAISER_ADJUSTMENT_PCT';
var SET_APPRAISAL_ADOPTED_MARKET_VALUE = 'SET_APPRAISAL_MARKET_VALUE';
var SET_APPRAISAL_ADOPTED_MARKET_UNIT_VALUE = 'SET_APPRAISAL_MARKET_UNIT_VALUE';
var SET_APPRAISAL_BEC_PRICE = 'SET_APPRAISAL_BEC_PRICE';
var SET_APPRAISAL_ADJUSTED_BEC_PRICE = 'SET_APPRAISAL_ADJUSTED_BEC_PRICE';
var SET_APPRAISAL_BC = 'SET_APPRAISAL_BC';
var SET_APPRAISAL_BC_PCT = 'SET_APPRAISAL_BC_PCT';
var SET_APPRAISAL_GC = 'SET_APPRAISAL_GC';
var SET_APPRAISAL_GC_PCT = 'SET_APPRAISAL_GC_PCT';
var SET_APPRAISAL_BC_AND_GC_PCT = 'SET_APPRAISAL_BC_AND_GC_PCT';
var SET_APPRAISAL_BC_AND_GC = 'SET_APPRAISAL_BC_AND_GC';
var SET_APPRAISAL_CC = 'SET_APPRAISAL_CC';
var SET_APPRAISAL_CC_PCT = 'SET_APPRAISAL_CC_PCT';
var SET_APPRAISAL_HTL = 'SET_APPRAISAL_HTL';
var SET_APPRAISAL_HTL_PCT = 'SET_APPRAISAL_HTL_PCT';
var SET_APPRAISAL_INR = 'SET_APPRAISAL_INR';
var SET_APPRAISAL_INR_PCT = 'SET_APPRAISAL_INR_PCT';
var SET_APPRAISAL_GA = 'SET_APPRAISAL_GA';
var SET_APPRAISAL_GA_PCT = 'SET_APPRAISAL_GA_PCT';
var SET_APPRAISAL_GPD = 'SET_APPRAISAL_GPD';
var SET_APPRAISAL_GPD_PCT = 'SET_APPRAISAL_GPD_PCT';
var SET_APPRAISAL_OCT = 'SET_APPRAISAL_OCT';
var SET_APPRAISAL_OCT_PCT = 'SET_APPRAISAL_OCT_PCT';
var SET_APPRAISAL_GP = 'SET_APPRAISAL_GP';
var SET_APPRAISAL_GP_PCT = 'SET_APPRAISAL_GP_PCT';
var SET_APPRAISAL_CC_AND_GP = 'SET_APPRAISAL_CC_AND_GP';
var SET_APPRAISAL_F = 'SET_APPRAISAL_F';
var SET_APPRAISAL_CRB = 'SET_APPRAISAL_CRB';
var SET_APPRAISAL_CCD = 'SET_APPRAISAL_CCD';
var SET_APPRAISAL_TLR_PCT = 'SET_APPRAISAL_TLR_PCT';
var SET_APPRAISAL_PR_PCT = 'SET_APPRAISAL_PR_PCT';
var SET_APPRAISAL_AM_COEF = 'SET_APPRAISAL_AM_COEF';
var SET_APPRAISAL_B1_PCT = 'SET_APPRAISAL_B1_PCT';
var SET_APPRAISAL_B2_PCT = 'SET_APPRAISAL_B2_PCT';
var SET_APPRAISAL_B_PCT = 'SET_APPRAISAL_B_PCT';
var SET_APPRAISAL_B_REMAINING_PCT = 'SET_APPRAISAL_B_REMAINING_PCT';
var SET_APPRAISAL_I_PCT = 'SET_APPRAISAL_I_PCT';
var SET_APPRAISAL_TENANT_AGE_YEARS = 'SET_APPRAISAL_TENANT_AGE_YEARS';
var SET_APPRAISAL_TENANT_LIFE_EXPECTANCY_YEARS = 'SET_APPRAISAL_TENANT_LIFE_EXPECTANCY_YEARS';
var SET_APPRAISAL_TENANT_REMAINING_LIFE_EXPECTANCY_YEARS = 'SET_APPRAISAL_TENANT_REMAINING_LIFE_EXPECTANCY_YEARS';
var SET_APPRAISAL_CESSION_BOOLEAN = 'SET_APPRAISAL_CESSION_BOOLEAN';
var SET_APPRAISAL_CESSION_GROSS_MONTHLY_INCOME = 'SET_APPRAISAL_CESSION_GROSS_MONTHLY_INCOME';
var SET_APPRAISAL_CESSION_GROSS_YEARLY_INCOME = 'SET_APPRAISAL_CESSION_GROSS_YEARLY_INCOME';
var SET_APPRAISAL_CESSION_NET_YEARLY_INCOME = 'SET_APPRAISAL_CESSION_NET_YEARLY_INCOME';
var SET_APPRAISAL_CESSION_CONTRACT_PERIOD_YEARS = 'SET_APPRAISAL_CESSION_CONTRACT_PERIOD_YEARS';
var SET_APPRAISAL_CESSION_CONTRACT_REMAINING_YEARS = 'SET_APPRAISAL_CESSION_CONTRACT_REMAINING_YEARS';
var SET_APPRAISAL_CESSION_CONTRACT_START_DATE = 'SET_APPRAISAL_CESSION_CONTRACT_START_DATE';
var SET_APPRAISAL_LANDLORD_EXPENSES_PCT = 'SET_APPRAISAL_LANDLORD_EXPENSES_PCT';
var SET_APPRAISAL_REDUCTION_PCT = 'SET_APPRAISAL_REDUCTION_PCT';
var SET_APPRAISAL_ADJUSTMENT_COEF = 'SET_APPRAISAL_ADJUSTMENT_COEF';
var SET_APPRAISAL_USUFRUCTUARY_AGE_YEARS = 'SET_APPRAISAL_USUFRUCTUARY_AGE_YEARS';
var SET_APPRAISAL_USEFUL_LIFE_YEARS = 'SET_APPRAISAL_USEFUL_LIFE_YEARS';
var SET_APPRAISAL_REMAINING_USEFUL_LIFE_YEARS = 'SET_APPRAISAL_REMAINING_USEFUL_LIFE_YEARS';
var SET_APPRAISAL_MAX_LEGAL_PRICE = 'SET_APPRAISAL_MAX_LEGAL_PRICE';
var SET_APPRAISAL_MAX_LEGAL_AREA = 'SET_APPRAISAL_MAX_LEGAL_AREA';
var SET_APPRAISAL_MATERIAL_EXECUTION_COST = 'SET_APPRAISAL_MATERIAL_EXECUTION_COST';
var SET_APPRAISAL_DEPRECATED_MATERIAL_EXECUTION_COST = 'SET_APPRAISAL_DEPRECATED_MATERIAL_EXECUTION_COST';
var SET_APPRAISAL_MEC_ADJUSTMENT_COEF = 'SET_APPRAISAL_MEC_ADJUSTMENT_COEF';
var SET_APPRAISAL_ADOPTED_MATERIAL_EXECUTION_COST = 'SET_APPRAISAL_ADOPTED_MATERIAL_EXECUTION_COST';
var SET_APPRAISAL_PHYSICAL_DEPRECIATION_PCT = 'SET_APPRAISAL_PHYSICAL_DEPRECIATION_PCT';
var SET_APPRAISAL_FUNCTIONAL_DEPRECIATION_PCT = 'SET_APPRAISAL_FUNCTIONAL_DEPRECIATION_PCT';
var SET_APPRAISAL_TOTAL_DEPRECIATION_PCT = 'SET_APPRAISAL_TOTAL_DEPRECIATION_PCT';
var SET_APPRAISAL_TOTAL_CONSTRUCTION_PROGRESS_PCT = 'SET_APPRAISAL_TOTAL_CONSTRUCTION_PROGRESS_PCT';
var SET_APPRAISAL_MARKET_VALUE_APPRAISER_ADJUSTMENT_PCT = 'SET_APPRAISAL_MARKET_VALUE_APPRAISER_ADJUSTMENT_PCT';
var SET_APPRAISAL_DEPRECATED_LAND_AND_CC = 'SET_APPRAISAL_DEPRECATED_LAND_AND_CC';
var SET_APPRAISAL_FINISHED_REALESTATE_CRN = 'SET_APPRAISAL_FINISHED_REALESTATE_CRN';
var SET_APPRAISAL_CCR = 'SET_APPRAISAL_CCR';
var SET_APPRAISAL_EXECUTED_CONSTRUCTION_COST = 'SET_APPRAISAL_EXECUTED_CONSTRUCTION_COST';
var SET_APPRAISAL_UNDER_CONSTRUCTION_REALESTATE_CRN = 'SET_APPRAISAL_UNDER_CONSTRUCTION_REALESTATE_CRN';
var SET_APPRAISAL_K = 'SET_APPRAISAL_K';
var SET_APPRAISAL_REPERCUSSION_METHOD_LAND_VALUE = 'SET_APPRAISAL_REPERCUSSION_METHOD_LAND_VALUE';
var SET_APPRAISAL_COST_METHOD_CONSTRUCTION_CRB_VALUE = 'SET_APPRAISAL_COST_METHOD_CONSTRUCTION_CRB_VALUE';
var SET_APPRAISAL_COST_METHOD_CONSTRUCTION_CRN_VALUE = 'SET_APPRAISAL_COST_METHOD_CONSTRUCTION_CRN_VALUE';
var SET_APPRAISAL_COST_METHOD_REALESTATE_CRB_VALUE = 'SET_APPRAISAL_COST_METHOD_REALESTATE_CRB_VALUE';
var SET_APPRAISAL_COST_METHOD_REALESTATE_CRN_VALUE = 'SET_APPRAISAL_COST_METHOD_REALESTATE_CRN_VALUE';
var SET_APPRAISAL_COMPARISON_METHOD = 'SET_APPRAISAL_COMPARISON_METHOD';
var SET_APPRAISAL_ADJUSTED_MARKET_VALUE = 'SET_APPRAISAL_ADJUSTED_MARKET_VALUE';
var SET_APPRAISAL_MAX_LEGAL_METHOD = 'SET_APPRAISAL_MAX_LEGAL_METHOD';
var SET_APPRAISAL_VC = 'SET_APPRAISAL_VC';
var SET_APPRAISAL_INCOME_PERPETUITY_UPDATE_METHOD = 'SET_APPRAISAL_INCOME_PERPETUITY_UPDATE_METHOD';
var SET_APPRAISAL_U = 'SET_APPRAISAL_U';
var SET_APPRAISAL_RESIDUAL_DEPRECIATION_PCT = 'SET_APPRAISAL_RESIDUAL_DEPRECIATION_PCT';
var SET_APPRAISAL_RESIDUAL_DEPRECIATION = 'SET_APPRAISAL_RESIDUAL_DEPRECIATION';
var SET_APPRAISAL_REALESTATE_RESIDUAL_VALUE = 'SET_APPRAISAL_REALESTATE_RESIDUAL_VALUE';
var SET_APPRAISAL_I = 'SET_APPRAISAL_I';
var SET_APPRAISAL_NP = 'SET_APPRAISAL_NP';
var SET_APPRAISAL_COEF_1 = 'SET_APPRAISAL_COEF_1';
var SET_APPRAISAL_CURRENT_FUTURE_INCOME_VALUE = 'SET_APPRAISAL_CURRENT_FUTURE_INCOME_VALUE';
var SET_APPRAISAL_COEF_2 = 'SET_APPRAISAL_COEF_2';
var SET_APPRAISAL_UPDATED_REVERSION_VALUE = 'SET_APPRAISAL_UPDATED_REVERSION_VALUE';
var SET_APPRAISAL_UPDATE_VALUE = 'SET_APPRAISAL_UPDATE_VALUE';
var SET_APPRAISAL_INSURANCE_VALUE = 'SET_APPRAISAL_INSURANCE_VALUE';
var SET_APPRAISAL_VU_COEF = 'SET_APPRAISAL_VU_COEF';
var SET_APPRAISAL_USUFRUCT_VALUE = 'SET_APPRAISAL_USUFRUCT_VALUE';
var SET_APPRAISAL_BARE_OWNERSHIP_VALUE = 'SET_APPRAISAL_BARE_OWNERSHIP_VALUE';
var SET_APPRAISAL_REALESTATE_TOTAL_ADOPTED_VALUE = 'SET_APPRAISAL_REALESTATE_TOTAL_ADOPTED_VALUE';
var SET_APPRAISAL_REALESTATE_ADOPTED_APPRAISAL_METHOD = 'SET_APPRAISAL_REALESTATE_ADOPTED_APPRAISAL_METHOD';
var SET_APPRAISAL_REALESTATE_ID = 'SET_APPRAISAL_REALESTATE_ID';
var SET_APPRAISAL_ADOPTED_AGE_YEARS_OLD = 'SET_APPRAISAL_ADOPTED_AGE_YEARS_OLD';
var SET_APPRAISAL_RIGHT_OF_USE_BOOLEAN = 'SET_APPRAISAL_RIGHT_OF_USE_BOOLEAN';
var SET_APPRAISAL_PROTECTION_BOOLEAN = 'SET_APPRAISAL_PROTECTION_BOOLEAN';
var SET_APPRAISAL_PROTECTION_TYPE = 'SET_APPRAISAL_PROTECTION_TYPE';
var SET_APPRAISAL_PROTECTION_REGIME = 'SET_APPRAISAL_PROTECTION_REGIME';
var SET_APPRAISAL_PROTECTION_ZONE = 'SET_APPRAISAL_PROTECTION_ZONE';
var SET_APPRAISAL_URBAN_PLANNING_TYPE = 'SET_APPRAISAL_URBAN_PLANNING_TYPE';
var SET_APPRAISAL_URBAN_PLANNING_FILE = 'SET_APPRAISAL_URBAN_PLANNING_FILE';
var SET_APPRAISAL_URBAN_PLANNING_COUNCIL_QUALIFICATION = 'SET_APPRAISAL_URBAN_PLANNING_COUNCIL_QUALIFICATION';
var SET_APPRAISAL_URBAN_PLANNING_COUNCIL_QUALIFICATION_DESCRIPTION = 'SET_APPRAISAL_URBAN_PLANNING_COUNCIL_QUALIFICATION_DESCRIPTION';
var SET_APPRAISAL_URBAN_PLANNING_COUNCIL_CLASSIFICATION = 'SET_APPRAISAL_URBAN_PLANNING_COUNCIL_CLASSIFICATION';
var SET_APPRAISAL_URBAN_PLANNING_COUNCIL_CLASSIFICATION_DESCRIPTION = 'SET_APPRAISAL_URBAN_PLANNING_COUNCIL_CLASSIFICATION_DESCRIPTION';
var SET_APPRAISAL_URBAN_PLANNING_REGIONAL_QUALIFICATION = 'SET_APPRAISAL_URBAN_PLANNING_REGIONAL_QUALIFICATION';
var SET_APPRAISAL_URBAN_PLANNING_REGIONAL_QUALIFICATION_DESCRIPTION = 'SET_APPRAISAL_URBAN_PLANNING_REGIONAL_QUALIFICATION_DESCRIPTION';
var SET_APPRAISAL_URBAN_PLANNING_REGIONAL_CLASSIFICATION = 'SET_APPRAISAL_URBAN_PLANNING_REGIONAL_CLASSIFICATION';
var SET_APPRAISAL_URBAN_PLANNING_REGIONAL_CLASSIFICATION_DESCRIPTION = 'SET_APPRAISAL_URBAN_PLANNING_REGIONAL_CLASSIFICATION_DESCRIPTION';
var SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS = 'SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS';
var SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL = 'SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL';
var SET_APPRAISAL_MAP_URBAN_ICC_TOPO = 'SET_APPRAISAL_MAP_URBAN_ICC_TOPO';
var SET_APPRAISAL_LAND_REGISTRY_AREA = 'SET_APPRAISAL_LAND_REGISTRY_AREA';
var SET_APPRAISAL_LAND_CADASTRAL_AREA = 'SET_APPRAISAL_LAND_CADASTRAL_AREA';
var SET_APPRAISAL_LAND_CHECKED_AREA = 'SET_APPRAISAL_LAND_CHECKED_AREA';
var SET_APPRAISAL_LAND_ADOPTED_AREA = 'SET_APPRAISAL_LAND_ADOPTED_AREA';
var SET_APPRAISAL_LAND_INFRASTRUCTURE_PAVING_EXECUTION_PCT = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_PAVING_EXECUTION_PCT';
var SET_APPRAISAL_LAND_INFRASTRUCTURE_SEWAGE_EXECUTION_PCT = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_SEWAGE_EXECUTION_PCT';
var SET_APPRAISAL_LAND_INFRASTRUCTURE_PUBLIC_LIGHTING_EXECUTION_PCT = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_PUBLIC_LIGHTING_EXECUTION_PCT';
var SET_APPRAISAL_LAND_INFRASTRUCTURE_ELECTRICITY_SUPPLY_EXECUTION_PCT = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_ELECTRICITY_SUPPLY_EXECUTION_PCT';
var SET_APPRAISAL_LAND_INFRASTRUCTURE_PIPED_GAS_EXECUTION_PCT = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_PIPED_GAS_EXECUTION_PCT';
var SET_APPRAISAL_LAND_INFRASTRUCTURE_TELEPHONE_SERVICE_EXECUTION_PCT = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_TELEPHONE_SERVICE_EXECUTION_PCT';
var SET_APPRAISAL_LAND_INFRASTRUCTURE_GARDENED_AREAS_EXECUTION_PCT = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_GARDENED_AREAS_EXECUTION_PCT';
var SET_APPRAISAL_LAND_INFRASTRUCTURE_TOTAL_EXECUTION_PCT = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_TOTAL_EXECUTION_PCT';
var SET_APPRAISAL_LAND_INFRASTRUCTURE_REPERCUSSION_COST = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_REPERCUSSION_COST';
var SET_APPRAISAL_LAND_INFRASTRUCTURE_PENDING_INVESTMENT = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_PENDING_INVESTMENT';
var SET_APPRAISAL_LAND_INFRASTRUCTURE_PAVING = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_PAVING';
var SET_APPRAISAL_LAND_INFRASTRUCTURE_SEWAGE = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_SEWAGE';
var SET_APPRAISAL_LAND_INFRASTRUCTURE_PUBLIC_LIGHTING = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_PUBLIC_LIGHTING';
var SET_APPRAISAL_LAND_INFRASTRUCTURE_ELECTRICITY_SUPPLY = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_ELECTRICITY_SUPPLY';
var SET_APPRAISAL_LAND_INFRASTRUCTURE_PIPED_GAS = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_PIPED_GAS';
var SET_APPRAISAL_LAND_INFRASTRUCTURE_TELEPHONE_SERVICE = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_TELEPHONE_SERVICE';
var SET_APPRAISAL_LAND_INFRASTRUCTURE_GARDENED_AREAS = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_GARDENED_AREAS';
var SET_APPRAISAL_LAND_IS_PLOT_ACCORDING_TO_LAW = 'SET_APPRAISAL_LAND_IS_PLOT_ACCORDING_TO_LAW';
var SET_APPRAISAL_LAND_AREA_NOTES = 'SET_APPRAISAL_LAND_AREA_NOTES';
var SET_APPRAISAL_LAND_INFRASTRUCTURE_NOTES = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_NOTES';
var SET_APPRAISAL_LAND_INFRASTRUCTURE_CONSERVATION_STATUS = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_CONSERVATION_STATUS';
var SET_APPRAISAL_LAND_INFRASTRUCTURE_WATER_SUPPLY_EXECUTION_PCT = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_WATER_SUPPLY_EXECUTION_PCT';
var SET_APPRAISAL_LAND_INFRASTRUCTURE_WATER_SUPPLY = 'SET_APPRAISAL_LAND_INFRASTRUCTURE_WATER_SUPPLY';
var SET_APPRAISAL_PLOT_OCCUPATION = 'SET_APPRAISAL_PLOT_OCCUPATION';
var SET_APPRAISAL_PLOT_FREE_AREA_USAGE = 'SET_APPRAISAL_PLOT_FREE_AREA_USAGE';
var SET_APPRAISAL_FLOORS_NUMBER_UNDERGROUND = 'SET_APPRAISAL_FLOORS_NUMBER_UNDERGROUND';
var SET_APPRAISAL_FLOORS_NUMBER_OVERGROUND = 'SET_APPRAISAL_FLOORS_NUMBER_OVERGROUND';
var SET_APPRAISAL_PARKING_SLOTS_INCLUDED_IN_APPRAISAL_NUMBER = 'SET_APPRAISAL_PARKING_SLOTS_INCLUDED_IN_APPRAISAL_NUMBER';
var SET_APPRAISAL_ENTRANCE_HALL = 'SET_APPRAISAL_ENTRANCE_HALL';
var SET_APPRAISAL_DOORMAN_SPACE = 'SET_APPRAISAL_DOORMAN_SPACE';
var SET_APPRAISAL_STAIRCASE = 'SET_APPRAISAL_STAIRCASE';
var SET_APPRAISAL_SWIMMING_POOL = 'SET_APPRAISAL_SWIMMING_POOL';
var SET_APPRAISAL_GARDENED_AREAS = 'SET_APPRAISAL_GARDENED_AREAS';
var SET_APPRAISAL_SPORTS_FACILITIES = 'SET_APPRAISAL_SPORTS_FACILITIES';
var SET_APPRAISAL_COMMUNITY_ROOM = 'SET_APPRAISAL_COMMUNITY_ROOM';
var SET_APPRAISAL_STORAGE_ROOM = 'SET_APPRAISAL_STORAGE_ROOM';
var SET_APPRAISAL_COMMUNITY_PARKING = 'SET_APPRAISAL_COMMUNITY_PARKING';
var SET_APPRAISAL_FACILITIES_OTHERS = 'SET_APPRAISAL_FACILITIES_OTHERS';
var SET_APPRAISAL_FLOORS_USAGE_UNDERGROUND = 'SET_APPRAISAL_FLOORS_USAGE_UNDERGROUND';
var SET_APPRAISAL_FLOORS_USAGE_OVERGROUND = 'SET_APPRAISAL_FLOORS_USAGE_OVERGROUND';
var SET_APPRAISAL_GROUNDFLOOR_USAGE = 'SET_APPRAISAL_GROUNDFLOOR_USAGE';
var SET_APPRAISAL_COMMUNICATIONS_AIRPORT = 'SET_APPRAISAL_COMMUNICATIONS_AIRPORT';
var SET_APPRAISAL_COMMUNICATIONS_HARBOUR = 'SET_APPRAISAL_COMMUNICATIONS_HARBOUR';
var SET_APPRAISAL_COMMUNICATIONS_TRAIN = 'SET_APPRAISAL_COMMUNICATIONS_TRAIN';
var SET_APPRAISAL_PUBLIC_TRANSPORT_URBAN_UNDERGROUND = 'SET_APPRAISAL_PUBLIC_TRANSPORT_URBAN_UNDERGROUND';
var SET_APPRAISAL_PUBLIC_TRANSPORT_INTERURBAN = 'SET_APPRAISAL_PUBLIC_TRANSPORT_INTERURBAN';
var SET_APPRAISAL_SURROUNDING_FACILITIES_NOTES = 'SET_APPRAISAL_SURROUNDING_FACILITIES_NOTES';
var SET_APPRAISAL_SURROUNDING_TERRITORIAL_FEATURE = 'SET_APPRAISAL_SURROUNDING_TERRITORIAL_FEATURE';
var SET_APPRAISAL_SURROUNDING_INCOME_LEVEL = 'SET_APPRAISAL_SURROUNDING_INCOME_LEVEL';
var SET_APPRAISAL_SURROUNDING_HOMOGENEITY_FEATURE = 'SET_APPRAISAL_SURROUNDING_HOMOGENEITY_FEATURE';
var SET_APPRAISAL_SURROUNDING_MAIN_USES = 'SET_APPRAISAL_SURROUNDING_MAIN_USES';
var SET_APPRAISAL_SURROUNDING_DENSITY = 'SET_APPRAISAL_SURROUNDING_DENSITY';
var SET_APPRAISAL_SURROUNDING_ACCESSIBILITY = 'SET_APPRAISAL_SURROUNDING_ACCESSIBILITY';
var SET_APPRAISAL_SURROUNDING_CONSOLIDATION_DEGREE = 'SET_APPRAISAL_SURROUNDING_CONSOLIDATION_DEGREE';
var SET_APPRAISAL_SURROUNDING_OCCUPATION_DEGREE = 'SET_APPRAISAL_SURROUNDING_OCCUPATION_DEGREE';
var SET_APPRAISAL_SURROUNDING_EVOLUTION_SPEED = 'SET_APPRAISAL_SURROUNDING_EVOLUTION_SPEED';
var SET_APPRAISAL_SURROUNDING_AVERAGE_AGE = 'SET_APPRAISAL_SURROUNDING_AVERAGE_AGE';
var SET_APPRAISAL_SURROUNDING_CONSERVATION_STATUS = 'SET_APPRAISAL_SURROUNDING_CONSERVATION_STATUS';
var SET_APPRAISAL_SURROUNDING_COMMERCIAL_FACILITIES = 'SET_APPRAISAL_SURROUNDING_COMMERCIAL_FACILITIES';
var SET_APPRAISAL_SURROUNDING_EDUCATIONAL_FACILITIES = 'SET_APPRAISAL_SURROUNDING_EDUCATIONAL_FACILITIES';
var SET_APPRAISAL_SURROUNDING_PUBLIC_PARKING = 'SET_APPRAISAL_SURROUNDING_PUBLIC_PARKING';
var SET_APPRAISAL_SURROUNDING_MEDICAL_ASSISTANCE = 'SET_APPRAISAL_SURROUNDING_MEDICAL_ASSISTANCE';
var SET_APPRAISAL_SURROUNDING_LEISURE = 'SET_APPRAISAL_SURROUNDING_LEISURE';
var SET_APPRAISAL_CADASTRAL_USAGE = 'SET_APPRAISAL_CADASTRAL_USAGE';
var SET_APPRAISAL_CADASTRAL_FLOOR = 'SET_APPRAISAL_CADASTRAL_FLOOR';
var SET_APPRAISAL_CADASTRAL_DOOR = 'SET_APPRAISAL_CADASTRAL_DOOR';
var SET_APPRAISAL_CADASTRAL_BLOCK = 'SET_APPRAISAL_CADASTRAL_BLOCK';
var SET_APPRAISAL_CADASTRAL_STAIRCASE = 'SET_APPRAISAL_CADASTRAL_STAIRCASE';
var SET_APPRAISAL_REGISTRY_NAME = 'SET_APPRAISAL_REGISTRY_NAME';
var SET_APPRAISAL_REGISTRY_SECTION = 'SET_APPRAISAL_REGISTRY_SECTION';
var SET_APPRAISAL_REGISTRY_VOLUME = 'SET_APPRAISAL_REGISTRY_VOLUME';
var SET_APPRAISAL_REGISTRY_BOOK = 'SET_APPRAISAL_REGISTRY_BOOK';
var SET_APPRAISAL_REGISTRY_PAGE = 'SET_APPRAISAL_REGISTRY_PAGE';
var SET_APPRAISAL_REGISTRY_REAL_ESTATE_NUMBER = 'SET_APPRAISAL_REGISTRY_REAL_ESTATE_NUMBER';
var SET_APPRAISAL_REGISTRY_IDUFIR = 'SET_APPRAISAL_REGISTRY_IDUFIR';
var SET_APPRAISAL_REGISTRY_OWNER = 'SET_APPRAISAL_REGISTRY_OWNER';
var SET_APPRAISAL_REGISTRY_PROPERTY_COEF = 'SET_APPRAISAL_REGISTRY_PROPERTY_COEF';
var SET_APPRAISAL_NET_CADASTRAL_AREA = 'SET_APPRAISAL_NET_CADASTRAL_AREA';
var SET_APPRAISAL_NET_REGISTRY_AREA = 'SET_APPRAISAL_NET_REGISTRY_AREA';
var SET_APPRAISAL_NET_CHECKED_AREA = 'SET_APPRAISAL_NET_CHECKED_AREA';
var SET_APPRAISAL_NET_ADOPTED_AREA = 'SET_APPRAISAL_NET_ADOPTED_AREA';
var SET_APPRAISAL_ENCLOSED_CADASTRAL_AREA = 'SET_APPRAISAL_ENCLOSED_CADASTRAL_AREA';
var SET_APPRAISAL_ENCLOSED_REGISTRY_AREA = 'SET_APPRAISAL_ENCLOSED_REGISTRY_AREA';
var SET_APPRAISAL_ENCLOSED_CHECKED_AREA = 'SET_APPRAISAL_ENCLOSED_CHECKED_AREA';
var SET_APPRAISAL_ENCLOSED_ADOPTED_AREA = 'SET_APPRAISAL_ENCLOSED_ADOPTED_AREA';
var SET_APPRAISAL_COVERED_TERRACES_TOTAL_CADASTRAL_AREA = 'SET_APPRAISAL_COVERED_TERRACES_TOTAL_CADASTRAL_AREA';
var SET_APPRAISAL_COVERED_TERRACES_TOTAL_REGISTRY_AREA = 'SET_APPRAISAL_COVERED_TERRACES_TOTAL_REGISTRY_AREA';
var SET_APPRAISAL_COVERED_TERRACES_TOTAL_CHECKED_AREA = 'SET_APPRAISAL_COVERED_TERRACES_TOTAL_CHECKED_AREA';
var SET_APPRAISAL_COVERED_TERRACES_TOTAL_ADOPTED_AREA = 'SET_APPRAISAL_COVERED_TERRACES_TOTAL_ADOPTED_AREA';
var SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_CADASTRAL_AREA = 'SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_CADASTRAL_AREA';
var SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_REGISTRY_AREA = 'SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_REGISTRY_AREA';
var SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_CHECKED_AREA = 'SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_CHECKED_AREA';
var SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_ADOPTED_AREA = 'SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_ADOPTED_AREA';
var SET_APPRAISAL_BUILT_CADASTRAL_AREA = 'SET_APPRAISAL_BUILT_CADASTRAL_AREA';
var SET_APPRAISAL_BUILT_REGISTRY_AREA = 'SET_APPRAISAL_BUILT_REGISTRY_AREA';
var SET_APPRAISAL_BUILT_CHECKED_AREA = 'SET_APPRAISAL_BUILT_CHECKED_AREA';
var SET_APPRAISAL_BUILT_ADOPTED_AREA = 'SET_APPRAISAL_BUILT_ADOPTED_AREA';
var SET_APPRAISAL_COMMON_ELEMENTS_CADASTRAL_AREA = 'SET_APPRAISAL_COMMON_ELEMENTS_CADASTRAL_AREA';
var SET_APPRAISAL_COMMON_ELEMENTS_REGISTRY_AREA = 'SET_APPRAISAL_COMMON_ELEMENTS_REGISTRY_AREA';
var SET_APPRAISAL_COMMON_ELEMENTS_CHECKED_AREA = 'SET_APPRAISAL_COMMON_ELEMENTS_CHECKED_AREA';
var SET_APPRAISAL_COMMON_ELEMENTS_ADOPTED_AREA = 'SET_APPRAISAL_COMMON_ELEMENTS_ADOPTED_AREA';
var SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_CADASTRAL_AREA = 'SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_CADASTRAL_AREA';
var SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_REGISTRY_AREA = 'SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_REGISTRY_AREA';
var SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_CHECKED_AREA = 'SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_CHECKED_AREA';
var SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_ADOPTED_AREA = 'SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_ADOPTED_AREA';
var SET_APPRAISAL_BATHROOMS_NUMBER = 'SET_APPRAISAL_BATHROOMS_NUMBER';
var SET_APPRAISAL_BEDROOMS_NUMBER = 'SET_APPRAISAL_BEDROOMS_NUMBER';
var SET_APPRAISAL_NET_SELECTED_AREA = 'SET_APPRAISAL_NET_SELECTED_AREA';
var SET_APPRAISAL_ENCLOSED_SELECTED_AREA = 'SET_APPRAISAL_ENCLOSED_SELECTED_AREA';
var SET_APPRAISAL_COVERED_OUTDOORS_SELECTED_AREA = 'SET_APPRAISAL_COVERED_OUTDOORS_SELECTED_AREA';
var SET_APPRAISAL_BUILT_SELECTED_AREA = 'SET_APPRAISAL_BUILT_SELECTED_AREA';
var SET_APPRAISAL_COMMON_ELEMENTS_SELECTED_AREA = 'SET_APPRAISAL_COMMON_ELEMENTS_SELECTED_AREA';
var SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_SELECTED_AREA = 'SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_SELECTED_AREA';
var SET_APPRAISAL_LAND_SELECTED_AREA = 'SET_APPRAISAL_LAND_SELECTED_AREA';
var SET_APPRAISAL_REALESTATE_ROOMS_TO_EXTERIOR_NUMBER = 'SET_APPRAISAL_REALESTATE_ROOMS_TO_EXTERIOR_NUMBER';
var SET_APPRAISAL_REALESTATE_DAY_NIGHT_ZONING = 'SET_APPRAISAL_REALESTATE_DAY_NIGHT_ZONING';
var SET_APPRAISAL_REALESTATE_SYSTEMS_DOOR_OPENER = 'SET_APPRAISAL_REALESTATE_SYSTEMS_DOOR_OPENER';
var SET_APPRAISAL_REALESTATE_SYSTEMS_FITTED_CUPBOARDS = 'SET_APPRAISAL_REALESTATE_SYSTEMS_FITTED_CUPBOARDS';
var SET_APPRAISAL_REALESTATE_SYSTEMS_GAS = 'SET_APPRAISAL_REALESTATE_SYSTEMS_GAS';
var SET_APPRAISAL_REALESTATE_SYSTEMS_SANITARY_FITTINGS = 'SET_APPRAISAL_REALESTATE_SYSTEMS_SANITARY_FITTINGS';
var SET_APPRAISAL_REALESTATE_SYSTEMS_TAPS = 'SET_APPRAISAL_REALESTATE_SYSTEMS_TAPS';
var SET_APPRAISAL_REALESTATE_SYSTEMS_HOT_WATER = 'SET_APPRAISAL_REALESTATE_SYSTEMS_HOT_WATER';
var SET_APPRAISAL_REALESTATE_SYSTEMS_HEATING = 'SET_APPRAISAL_REALESTATE_SYSTEMS_HEATING';
var SET_APPRAISAL_REALESTATE_SYSTEMS_AIR_CONDITIONING = 'SET_APPRAISAL_REALESTATE_SYSTEMS_AIR_CONDITIONING';
var SET_APPRAISAL_REALESTATE_SYSTEMS_TV = 'SET_APPRAISAL_REALESTATE_SYSTEMS_TV';
var SET_APPRAISAL_REALESTATE_SYSTEMS_TELEPHONE = 'SET_APPRAISAL_REALESTATE_SYSTEMS_TELEPHONE';
var SET_APPRAISAL_REALESTATE_SYSTEMS_FIRE_PREVENTION = 'SET_APPRAISAL_REALESTATE_SYSTEMS_FIRE_PREVENTION';
var SET_APPRAISAL_REALESTATE_SYSTEMS_INTRUSION_PREVENTION = 'SET_APPRAISAL_REALESTATE_SYSTEMS_INTRUSION_PREVENTION';
var SET_APPRAISAL_REALESTATE_FOUNDATION = 'SET_APPRAISAL_REALESTATE_FOUNDATION';
var SET_APPRAISAL_REALESTATE_STRUCTURE = 'SET_APPRAISAL_REALESTATE_STRUCTURE';
var SET_APPRAISAL_REALESTATE_ROOF = 'SET_APPRAISAL_REALESTATE_ROOF';
var SET_APPRAISAL_REALESTATE_EXTERNAL_ENCLOSURES = 'SET_APPRAISAL_REALESTATE_EXTERNAL_ENCLOSURES';
var SET_APPRAISAL_REALESTATE_INSULATION = 'SET_APPRAISAL_REALESTATE_INSULATION';
var SET_APPRAISAL_REALESTATE_EXTERNAL_CARPENTRY = 'SET_APPRAISAL_REALESTATE_EXTERNAL_CARPENTRY';
var SET_APPRAISAL_REALESTATE_GLAZING = 'SET_APPRAISAL_REALESTATE_GLAZING';
var SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_LIVING = 'SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_LIVING';
var SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_CORRIDOR = 'SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_CORRIDOR';
var SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_BEDROOM = 'SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_BEDROOM';
var SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_KITCHEN = 'SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_KITCHEN';
var SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_BATHROOM = 'SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_BATHROOM';
var SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_QUALITY = 'SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_QUALITY';
var SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_LIVING = 'SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_LIVING';
var SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_CORRIDOR = 'SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_CORRIDOR';
var SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_BEDROOM = 'SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_BEDROOM';
var SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_KITCHEN = 'SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_KITCHEN';
var SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_BATHROOM = 'SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_BATHROOM';
var SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_QUALITY = 'SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_QUALITY';
var SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_LIVING = 'SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_LIVING';
var SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_CORRIDOR = 'SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_CORRIDOR';
var SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_BEDROOM = 'SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_BEDROOM';
var SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_KITCHEN = 'SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_KITCHEN';
var SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_BATHROOM = 'SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_BATHROOM';
var SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_QUALITY = 'SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_QUALITY';
var SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_LIVING = 'SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_LIVING';
var SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_CORRIDOR = 'SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_CORRIDOR';
var SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_BEDROOM = 'SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_BEDROOM';
var SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_KITCHEN = 'SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_KITCHEN';
var SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_BATHROOM = 'SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_BATHROOM';
var SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_QUALITY = 'SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_QUALITY';
var SET_APPRAISAL_REALESTATE_MAIN_ORIENTATION = 'SET_APPRAISAL_REALESTATE_MAIN_ORIENTATION';
var SET_APPRAISAL_REALESTATE_MAIN_VIEWS = 'SET_APPRAISAL_REALESTATE_MAIN_VIEWS';
var SET_APPRAISAL_REALESTATE_WINDOWS_SIZE_AND_QUANTITY = 'SET_APPRAISAL_REALESTATE_WINDOWS_SIZE_AND_QUANTITY';
var SET_APPRAISAL_REALESTATE_NOISE_FACADE = 'SET_APPRAISAL_REALESTATE_NOISE_FACADE';
var SET_APPRAISAL_REALESTATE_SYSTEMS_SANITARY_FITTINGS_QUALITY = 'SET_APPRAISAL_REALESTATE_SYSTEMS_SANITARY_FITTINGS_QUALITY';
var SET_APPRAISAL_REALESTATE_SYSTEMS_TAPS_QUALITY = 'SET_APPRAISAL_REALESTATE_SYSTEMS_TAPS_QUALITY';
var SET_APPRAISAL_BEC_ADJUSTMENT_COEF = 'SET_APPRAISAL_BEC_ADJUSTMENT_COEF';
var SET_APPRAISAL_BEC_PROPERTY_TYPE = 'SET_APPRAISAL_BEC_PROPERTY_TYPE';
var SET_APPRAISAL_BEC_NUMBER = 'SET_APPRAISAL_BEC_NUMBER';
var SET_APPRAISAL_CONSTRUCTION_STATUS = 'SET_APPRAISAL_CONSTRUCTION_STATUS';
var SET_APPRAISAL_EXPENSES_AND_INDUSTRIAL_BENEFIT_BEC_PCT = 'SET_APPRAISAL_EXPENSES_AND_INDUSTRIAL_BENEFIT_BEC_PCT';
var SET_APPRAISAL_CONSTRUCTION_COST_NOTES = 'SET_APPRAISAL_CONSTRUCTION_COST_NOTES';
var SET_APPRAISAL_CADASTRAL_CONSTRUCTION_YEAR = 'SET_APPRAISAL_CADASTRAL_CONSTRUCTION_YEAR';
var SET_APPRAISAL_CONSTRUCTION_YEAR = 'SET_APPRAISAL_CONSTRUCTION_YEAR';
var SET_APPRAISAL_LAST_RENOVATION_YEAR = 'SET_APPRAISAL_LAST_RENOVATION_YEAR';
var SET_APPRAISAL_NUCLEUS_POPULATION = 'SET_APPRAISAL_NUCLEUS_POPULATION';
var SET_APPRAISAL_NUCLEUS_POPULATION_DENSITY = 'SET_APPRAISAL_NUCLEUS_POPULATION_DENSITY';
var SET_APPRAISAL_NUCLEUS_POPULATION_GROWTH = 'SET_APPRAISAL_NUCLEUS_POPULATION_GROWTH';
var SET_APPRAISAL_OCCUPATION_AGRICULTURE_PCT = 'SET_APPRAISAL_OCCUPATION_AGRICULTURE_PCT';
var SET_APPRAISAL_OCCUPATION_INDUSTRY_PCT = 'SET_APPRAISAL_OCCUPATION_INDUSTRY_PCT';
var SET_APPRAISAL_OCCUPATION_CONSTRUCTION_PCT = 'SET_APPRAISAL_OCCUPATION_CONSTRUCTION_PCT';
var SET_APPRAISAL_OCCUPATION_SERVICES_PCT = 'SET_APPRAISAL_OCCUPATION_SERVICES_PCT';
var SET_APPRAISAL_OCCUPATION_TOTAL_PCT = 'SET_APPRAISAL_OCCUPATION_TOTAL_PCT';
var SET_APPRAISAL_NUCLEUS_TYPE = 'SET_APPRAISAL_NUCLEUS_TYPE';
var SET_APPRAISAL_OCCUPATION_DESCRIPTION = 'SET_APPRAISAL_OCCUPATION_DESCRIPTION';
var SET_APPRAISAL_NUCLEUS_AREA = 'SET_APPRAISAL_NUCLEUS_AREA';
var SET_APPRAISAL_PROPERTY_TITLE = 'SET_APPRAISAL_PROPERTY_TITLE';
var SET_APPRAISAL_USAGE_ASSIGNED = 'SET_APPRAISAL_USAGE_ASSIGNED';
var SET_APPRAISAL_INSPECTION_REALIZED = 'SET_APPRAISAL_INSPECTION_REALIZED';
var SET_APPRAISAL_ECONOMICAL_ACTIVITY = 'SET_APPRAISAL_ECONOMICAL_ACTIVITY';
var SET_APPRAISAL_OCCUPANCY_STATUS = 'SET_APPRAISAL_OCCUPANCY_STATUS';
var SET_APPRAISAL_MARKETSTUDY_ID = 'SET_APPRAISAL_MARKETSTUDY_ID';
var SET_APPRAISAL_MARKETSTUDIES = 'SET_APPRAISAL_MARKETSTUDIES';
var SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_OFFSET_X = 'SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_OFFSET_X';
var SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_OFFSET_Y = 'SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_OFFSET_Y';
var SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_ZOOM = 'SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_ZOOM';
var SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_OFFSET_X = 'SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_OFFSET_X';
var SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_OFFSET_Y = 'SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_OFFSET_Y';
var SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_ZOOM = 'SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_ZOOM';
var SET_APPRAISAL_MAP_URBAN_ICC_TOPO_OFFSET_X = 'SET_APPRAISAL_MAP_URBAN_ICC_TOPO_OFFSET_X';
var SET_APPRAISAL_MAP_URBAN_ICC_TOPO_OFFSET_Y = 'SET_APPRAISAL_MAP_URBAN_ICC_TOPO_OFFSET_Y';
var SET_APPRAISAL_MAP_URBAN_ICC_TOPO_ZOOM = 'SET_APPRAISAL_MAP_URBAN_ICC_TOPO_ZOOM';
var SET_APPRAISAL_QUOTE_TRAVEL_ONE_WAY_HOURS = 'SET_APPRAISAL_QUOTE_TRAVEL_ONE_WAY_HOURS';
var SET_APPRAISAL_QUOTE_TRAVEL_BOTH_WAYS_HOURS = 'SET_APPRAISAL_QUOTE_TRAVEL_BOTH_WAYS_HOURS';
var SET_APPRAISAL_QUOTE_TRAVEL_FEES_PER_HOUR = 'SET_APPRAISAL_QUOTE_TRAVEL_FEES_PER_HOUR';
var SET_APPRAISAL_QUOTE_CAR_EXPENSES_ONE_WAY = 'SET_APPRAISAL_QUOTE_CAR_EXPENSES_ONE_WAY';
var SET_APPRAISAL_QUOTE_CAR_EXPENSES_BOTH_WAYS = 'SET_APPRAISAL_QUOTE_CAR_EXPENSES_BOTH_WAYS';
var SET_APPRAISAL_QUOTE_TOTAL_TRAVEL_FEES = 'SET_APPRAISAL_QUOTE_TOTAL_TRAVEL_FEES';
var SET_APPRAISAL_QUOTE_AREA_AVERAGE_UNIT_PRICE = 'SET_APPRAISAL_QUOTE_AREA_AVERAGE_UNIT_PRICE';
var SET_APPRAISAL_QUOTE_BASE_FEES = 'SET_APPRAISAL_QUOTE_BASE_FEES';
var SET_APPRAISAL_QUOTE_EXCESS_PCT = 'SET_APPRAISAL_QUOTE_EXCESS_PCT';
var SET_APPRAISAL_QUOTE_BASE_PRICE = 'SET_APPRAISAL_QUOTE_BASE_PRICE';
var SET_APPRAISAL_QUOTE_BASE_PRICE_COEF = 'SET_APPRAISAL_QUOTE_BASE_PRICE_COEF';
var SET_APPRAISAL_USAGE_TYPE = 'SET_APPRAISAL_USAGE_TYPE';
var SET_APPRAISAL_PARKING_SPOTS_INCLUDED_NUMBER = 'SET_APPRAISAL_PARKING_SPOTS_INCLUDED_NUMBER';

// appraisal_bec_properties
var SET_APPRAISAL_BEC_PROPERTIES = 'SET_APPRAISAL_BEC_PROPERTIES';

// appraisal_bec_prices
var SET_APPRAISAL_BEC_PRICES = 'SET_APPRAISAL_BEC_PRICES';

// appraisal_rooms
var SET_APPRAISAL_ROOMS = 'SET_APPRAISAL_ROOMS';

// appraisal_covered_outdoors
var SET_APPRAISAL_COVERED_OUTDOORS = 'SET_APPRAISAL_COVERED_OUTDOORS';

// appraisal_uncovered_outdoors
var SET_APPRAISAL_UNCOVERED_OUTDOORS = 'SET_APPRAISAL_UNCOVERED_OUTDOORS';

// appraisal_constraints
var SET_APPRAISAL_CONSTRAINTS = 'SET_APPRAISAL_CONSTRAINTS';

// appraisal_warnings
var SET_APPRAISAL_WARNINGS = 'SET_APPRAISAL_WARNINGS';

// appraisal_notes
var SET_APPRAISAL_NOTES = 'SET_APPRAISAL_NOTES';

// appraisal_photographs
var SET_APPRAISAL_PHOTOGRAPHS = 'SET_APPRAISAL_PHOTOGRAPHS';

// appraisal_registryannexes
var SET_APPRAISAL_REGISTRYANNEXES = 'SET_APPRAISAL_REGISTRYANNEXES';

// appraisal_cadasterannexes
var SET_APPRAISAL_CADASTERANNEXES = 'SET_APPRAISAL_CADASTERANNEXES';

// appraisal_urbanannexes
var SET_APPRAISAL_URBANANNEXES = 'SET_APPRAISAL_URBANANNEXES';

// appraisal_planannexes
var SET_APPRAISAL_PLANANNEXES = 'SET_APPRAISAL_PLANANNEXES';

// appraisal_cessionannexes
var SET_APPRAISAL_CESSIONANNEXES = 'SET_APPRAISAL_CESSIONANNEXES';

// appraisal_otherannexes
var SET_APPRAISAL_OTHERANNEXES = 'SET_APPRAISAL_OTHERANNEXES';

// appraisalfile
var CREATE_NEW_APPRAISALFILE = 'CREATE_NEW_APPRAISALFILE';
var RESET_APPRAISALFILE = 'RESET_APPRAISALFILE';
var SET_APPRAISALFILE = 'SET_APPRAISALFILE';
var SET_APPRAISALFILE_DATE_CREATED = 'SET_APPRAISALFILE_DATE_CREATED';
var SET_APPRAISALFILE_DATE_MODIFIED = 'SET_APPRAISALFILE_DATE_MODIFIED';
var SET_APPRAISALFILE_DIRTYNESS = 'SET_APPRAISALFILE_DIRTYNESS';
var SET_APPRAISALFILE_ID = 'SET_APPRAISALFILE_ID';
var SET_APPRAISALFILE_PATH = 'SET_APPRAISALFILE_PATH';
var UPDATE_APPRAISALFILE = 'UPDATE_APPRAISALFILE';
var SET_APPRAISALFILE_DESCRIPTION = 'SET_APPRAISALFILE_DESCRIPTION';
var SET_APPRAISALFILE_NUMBER = 'SET_APPRAISALFILE_NUMBER';

// appraisalreport
var CREATE_NEW_APPRAISALREPORT = 'CREATE_NEW_APPRAISALREPORT';
var DELETE_APPRAISALREPORT = 'DELETE_APPRAISALREPORT';
var GET_APPRAISALREPORT = 'GET_APPRAISALREPORT';
var RESET_APPRAISALREPORT = 'RESET_APPRAISALREPORT';
var SET_APPRAISALREPORT = 'SET_APPRAISALREPORT';
var SET_APPRAISALREPORT_DATE_CREATED = 'SET_APPRAISALREPORT_DATE_CREATED';
var SET_APPRAISALREPORT_DATE_MODIFIED = 'SET_APPRAISALREPORT_DATE_MODIFIED';
var SET_APPRAISALREPORT_DIRTYNESS = 'SET_APPRAISALREPORT_DIRTYNESS';
var SET_APPRAISALREPORT_FILE_ID = 'SET_APPRAISALREPORT_FILE_ID';
var SET_APPRAISALREPORT_ID = 'SET_APPRAISALREPORT_ID';
var SET_APPRAISALREPORT_NUMBER = 'SET_APPRAISALREPORT_NUMBER';
var SET_APPRAISALREPORT_PARENT_PATH = 'SET_APPRAISALREPORT_PARENT_PATH';
var SET_APPRAISALREPORT_PATH = 'SET_APPRAISALREPORT_PATH';
var SET_APPRAISALREPORT_DESCRIPTION = 'SET_APPRAISALREPORT_DESCRIPTION';
var SET_APPRAISALREPORT_PETITIONER = 'SET_APPRAISALREPORT_PETITIONER';
var SET_APPRAISALREPORT_PETITIONER_TYPE = 'SET_APPRAISALREPORT_PETITIONER_TYPE';
var SET_APPRAISALREPORT_ENTITY = 'SET_APPRAISALREPORT_ENTITY';
var SET_APPRAISALREPORT_SUPERVISOR = 'SET_APPRAISALREPORT_SUPERVISOR';
var SET_APPRAISALREPORT_APPRAISER = 'SET_APPRAISALREPORT_APPRAISER';
var SET_APPRAISALREPORT_REPORTDATE = 'SET_APPRAISALREPORT_REPORTDATE';
var SET_APPRAISALREPORT_SEND_TO_BDE = 'SET_APPRAISALREPORT_SEND_TO_BDE';
var SET_APPRAISALREPORT_TITLE = 'SET_APPRAISALREPORT_TITLE';
var SET_APPRAISALREPORT_VERSION = 'SET_APPRAISALREPORT_VERSION';
var SET_APPRAISALREPORT_COVER_PHOTO_URL = 'SET_APPRAISALREPORT_COVER_PHOTO_URL';
var SET_APPRAISALREPORT_STATUS = 'SET_APPRAISALREPORT_STATUS';
var SET_APPRAISALREPORT_FULL_NUMBER = 'SET_APPRAISALREPORT_FULL_NUMBER';
var SET_APPRAISALREPORT_SIGNATURE_SV_NAME = 'SET_APPRAISALREPORT_SIGNATURE_SV_NAME';
var SET_APPRAISALREPORT_SIGNATURE_SV_BASE64 = 'SET_APPRAISALREPORT_SIGNATURE_SV_BASE64';
var SET_APPRAISALREPORT_SIGNATURE_SV_DATE = 'SET_APPRAISALREPORT_SIGNATURE_SV_DATE';
var SET_APPRAISALREPORT_SIGNATURE_SV_EMAIL = 'SET_APPRAISALREPORT_SIGNATURE_SV_EMAIL';
var SET_APPRAISALREPORT_SIGNATURE_SV_UID = 'SET_APPRAISALREPORT_SIGNATURE_SV_UID';
var SET_APPRAISALREPORT_SIGNATURE_AP_NAME = 'SET_APPRAISALREPORT_SIGNATURE_AP_NAME';
var SET_APPRAISALREPORT_SIGNATURE_AP_BASE64 = 'SET_APPRAISALREPORT_SIGNATURE_AP_BASE64';
var SET_APPRAISALREPORT_SIGNATURE_AP_DATE = 'SET_APPRAISALREPORT_SIGNATURE_AP_DATE';
var SET_APPRAISALREPORT_SIGNATURE_AP_EMAIL = 'SET_APPRAISALREPORT_SIGNATURE_AP_EMAIL';
var SET_APPRAISALREPORT_SIGNATURE_AP_UID = 'SET_APPRAISALREPORT_SIGNATURE_AP_UID';
var SET_APPRAISALREPORT_IS_SIGNED = 'SET_APPRAISALREPORT_IS_SIGNED';
var SET_APPRAISALREPORT_IS_SV_SIGNED = 'SET_APPRAISALREPORT_IS_SV_SIGNED';
var SET_APPRAISALREPORT_IS_AP_SIGNED = 'SET_APPRAISALREPORT_IS_AP_SIGNED';
var SET_APPRAISALREPORTS = 'SET_APPRAISALREPORTS';
var UPDATE_APPRAISALREPORT = 'UPDATE_APPRAISALREPORT';

// appraisalreport_petitioners
var SET_APPRAISALREPORT_PETITIONERS = 'SET_APPRAISALREPORT_PETITIONERS';

// appraisalreport_realestates
var SET_APPRAISALREPORT_REALESTATES = 'SET_APPRAISALREPORT_REALESTATES';
var SET_TEMP_APPRAISALREPORT_REALESTATES = 'SET_TEMP_APPRAISALREPORT_REALESTATES';

//appraisalfile_appraisalreports
var SET_APPRAISALFILE_APPRAISALREPORTS = 'SET_APPRAISALFILE_APPRAISALREPORTS';
var SET_TEMP_APPRAISALFILE_APPRAISALREPORTS = 'SET_TEMP_APPRAISALFILE_APPRAISALREPORTS';

// appraisalquote
var CREATE_NEW_APPRAISALQUOTE = 'CREATE_NEW_APPRAISALQUOTE';
var DELETE_APPRAISALQUOTE = 'DELETE_APPRAISALQUOTE';
var GET_APPRAISALQUOTE = 'GET_APPRAISALQUOTE';
var RESET_APPRAISALQUOTE = 'RESET_APPRAISALQUOTE';
var SET_APPRAISALQUOTE = 'SET_APPRAISALQUOTE';
var SET_APPRAISALQUOTE_DATE_CREATED = 'SET_APPRAISALQUOTE_DATE_CREATED';
var SET_APPRAISALQUOTE_DATE_MODIFIED = 'SET_APPRAISALQUOTE_DATE_MODIFIED';
var SET_APPRAISALQUOTE_DIRTYNESS = 'SET_APPRAISALQUOTE_DIRTYNESS';
var SET_APPRAISALQUOTE_FILE_ID = 'SET_APPRAISALQUOTE_FILE_ID';
var SET_APPRAISALQUOTE_ID = 'SET_APPRAISALQUOTE_ID';
var SET_APPRAISALQUOTE_NUMBER = 'SET_APPRAISALQUOTE_NUMBER';
var SET_APPRAISALQUOTE_PARENT_PATH = 'SET_APPRAISALQUOTE_PARENT_PATH';
var SET_APPRAISALQUOTE_PATH = 'SET_APPRAISALQUOTE_PATH';
var SET_APPRAISALQUOTE_DESCRIPTION = 'SET_APPRAISALQUOTE_DESCRIPTION';
var SET_APPRAISALQUOTE_PETITIONER = 'SET_APPRAISALQUOTE_PETITIONER';
var SET_APPRAISALQUOTE_PETITIONER_TYPE = 'SET_APPRAISALQUOTE_PETITIONER_TYPE';
var SET_APPRAISALQUOTE_ENTITY = 'SET_APPRAISALQUOTE_ENTITY';
var SET_APPRAISALQUOTE_SUPERVISOR = 'SET_APPRAISALQUOTE_SUPERVISOR';
var SET_APPRAISALQUOTE_APPRAISER = 'SET_APPRAISALQUOTE_APPRAISER';
var SET_APPRAISALQUOTE_REPORTDATE = 'SET_APPRAISALQUOTE_REPORTDATE';
var SET_APPRAISALQUOTE_SEND_TO_BDE = 'SET_APPRAISALQUOTE_SEND_TO_BDE';
var SET_APPRAISALQUOTE_TITLE = 'SET_APPRAISALQUOTE_TITLE';
var SET_APPRAISALQUOTE_VERSION = 'SET_APPRAISALQUOTE_VERSION';
var SET_APPRAISALQUOTE_COVER_PHOTO_URL = 'SET_APPRAISALQUOTE_COVER_PHOTO_URL';
var SET_APPRAISALQUOTE_STATUS = 'SET_APPRAISALQUOTE_STATUS';
var SET_APPRAISALQUOTE_VAT_PCT = 'SET_APPRAISALQUOTE_VAT_PCT';
var SET_APPRAISALQUOTE_BANK_NAME = 'SET_APPRAISALQUOTE_BANK_NAME';
var SET_APPRAISALQUOTE_IBAN = 'SET_APPRAISALQUOTE_IBAN';
var SET_APPRAISALQUOTE_COURT_ASSISTANCE_FEES = 'SET_APPRAISALQUOTE_COURT_ASSISTANCE_FEES';
var SET_APPRAISALQUOTE_DISCOUNT_PCT = 'SET_APPRAISALQUOTE_DISCOUNT_PCT';
var SET_APPRAISALQUOTE_DISCOUNT_NOTES = 'SET_APPRAISALQUOTE_DISCOUNT_NOTES';
var SET_APPRAISALQUOTE_FINAL_PRICE = 'SET_APPRAISALQUOTE_FINAL_PRICE';
var SET_APPRAISALQUOTE_REQUIREDDOC = 'SET_APPRAISALQUOTE_REQUIREDDOC';
var SET_APPRAISALQUOTE_FULL_NUMBER = 'SET_APPRAISALQUOTE_FULL_NUMBER';
var SET_APPRAISALQUOTE_SIGNATURE_NAME = 'SET_APPRAISALQUOTE_SIGNATURE_NAME';
var SET_APPRAISALQUOTE_SIGNATURE_BASE64 = 'SET_APPRAISALQUOTE_SIGNATURE_BASE64';
var SET_APPRAISALQUOTE_SIGNATURE_DATE = 'SET_APPRAISALQUOTE_SIGNATURE_DATE';
var SET_APPRAISALQUOTE_IS_SIGNED = 'SET_APPRAISALQUOTE_IS_SIGNED';
var SET_APPRAISALQUOTE_SIGNATURE_EMAIL = 'SET_APPRAISALQUOTE_SIGNATURE_EMAIL';
var SET_APPRAISALQUOTE_SIGNATURE_UID = 'SET_APPRAISALQUOTE_SIGNATURE_UID';
var SET_APPRAISALQUOTE_PURPOSE = 'SET_APPRAISALQUOTE_PURPOSE';
var UPDATE_APPRAISALQUOTE = 'UPDATE_APPRAISALQUOTE';

// appraisalquote_petitioners
var SET_APPRAISALQUOTE_PETITIONERS = 'SET_APPRAISALQUOTE_PETITIONERS';
var SET_TEMP_APPRAISALQUOTE_PETITIONERS = 'SET_TEMP_APPRAISALQUOTE_PETITIONERS';

// appraisalquote_realestates
var SET_APPRAISALQUOTE_REALESTATES = 'SET_APPRAISALQUOTE_REALESTATES';
var SET_TEMP_APPRAISALQUOTE_REALESTATES = 'SET_TEMP_APPRAISALQUOTE_REALESTATES';

// appraisalquote_requireddocs
var SET_APPRAISALQUOTE_REQUIREDDOCS = 'SET_APPRAISALQUOTE_REQUIREDDOCS';

//appraisalfile_appraisalquotes
var SET_APPRAISALFILE_APPRAISALQUOTES = 'SET_APPRAISALFILE_APPRAISALQUOTES';
var SET_TEMP_APPRAISALFILE_APPRAISALQUOTES = 'SET_TEMP_APPRAISALFILE_APPRAISALQUOTES';

// appraisalinvoice
var CREATE_NEW_APPRAISALINVOICE = 'CREATE_NEW_APPRAISALINVOICE';
var DELETE_APPRAISALINVOICE = 'DELETE_APPRAISALINVOICE';
var GET_APPRAISALINVOICE = 'GET_APPRAISALINVOICE';
var RESET_APPRAISALINVOICE = 'RESET_APPRAISALINVOICE';
var SET_APPRAISALINVOICE = 'SET_APPRAISALINVOICE';
var SET_APPRAISALINVOICE_DATE_CREATED = 'SET_APPRAISALINVOICE_DATE_CREATED';
var SET_APPRAISALINVOICE_DATE_MODIFIED = 'SET_APPRAISALINVOICE_DATE_MODIFIED';
var SET_APPRAISALINVOICE_DIRTYNESS = 'SET_APPRAISALINVOICE_DIRTYNESS';
var SET_APPRAISALINVOICE_FILE_ID = 'SET_APPRAISALINVOICE_FILE_ID';
var SET_APPRAISALINVOICE_ID = 'SET_APPRAISALINVOICE_ID';
var SET_APPRAISALINVOICE_NUMBER = 'SET_APPRAISALINVOICE_NUMBER';
var SET_APPRAISALINVOICE_PARENT_PATH = 'SET_APPRAISALINVOICE_PARENT_PATH';
var SET_APPRAISALINVOICE_PATH = 'SET_APPRAISALINVOICE_PATH';
var SET_APPRAISALINVOICE_DESCRIPTION = 'SET_APPRAISALINVOICE_DESCRIPTION';
var SET_APPRAISALINVOICE_PETITIONER = 'SET_APPRAISALINVOICE_PETITIONER';
var SET_APPRAISALINVOICE_PETITIONER_TYPE = 'SET_APPRAISALINVOICE_PETITIONER_TYPE';
var SET_APPRAISALINVOICE_ENTITY = 'SET_APPRAISALINVOICE_ENTITY';
var SET_APPRAISALINVOICE_SUPERVISOR = 'SET_APPRAISALINVOICE_SUPERVISOR';
var SET_APPRAISALINVOICE_APPRAISER = 'SET_APPRAISALINVOICE_APPRAISER';
var SET_APPRAISALINVOICE_REPORTDATE = 'SET_APPRAISALINVOICE_REPORTDATE';
var SET_APPRAISALINVOICE_SEND_TO_BDE = 'SET_APPRAISALINVOICE_SEND_TO_BDE';
var SET_APPRAISALINVOICE_TITLE = 'SET_APPRAISALINVOICE_TITLE';
var SET_APPRAISALINVOICE_VERSION = 'SET_APPRAISALINVOICE_VERSION';
var SET_APPRAISALINVOICE_COVER_PHOTO_URL = 'SET_APPRAISALINVOICE_COVER_PHOTO_URL';
var SET_APPRAISALINVOICE_STATUS = 'SET_APPRAISALINVOICE_STATUS';
var SET_APPRAISALINVOICE_VAT_PCT = 'SET_APPRAISALINVOICE_VAT_PCT';
var SET_APPRAISALINVOICE_QUOTE = 'SET_APPRAISALINVOICE_QUOTE';
var SET_APPRAISALINVOICE_FULL_NUMBER = 'SET_APPRAISALINVOICE_FULL_NUMBER';
var UPDATE_APPRAISALINVOICE = 'UPDATE_APPRAISALINVOICE';
var SET_APPRAISALINVOICE_BASE_PRICE = 'SET_APPRAISALINVOICE_BASE_PRICE';
var SET_APPRAISALINVOICE_DISCOUNT_PCT = 'SET_APPRAISALINVOICE_DISCOUNT_PCT';
var SET_APPRAISALINVOICE_FINAL_PRICE = 'SET_APPRAISALINVOICE_FINAL_PRICE';
var SET_APPRAISALINVOICE_FINAL_PRICE_INCL_VAT = 'SET_APPRAISALINVOICE_FINAL_PRICE_INCL_VAT';
var SET_APPRAISALINVOICE_DISCOUNT_NOTES = 'SET_APPRAISALINVOICE_DISCOUNT_NOTES';
var SET_APPRAISALINVOICE_BANK_NAME = 'SET_APPRAISALINVOICE_BANK_NAME';
var SET_APPRAISALINVOICE_IBAN = 'SET_APPRAISALINVOICE_IBAN';
var SET_APPRAISALINVOICES = 'SET_APPRAISALINVOICES';
var SET_APPRAISALQUOTES = 'SET_APPRAISALQUOTES';
var SET_APPRAISALINVOICE_FISCAL_NUMBER = 'SET_APPRAISALINVOICE_FISCAL_NUMBER';
var SET_APPRAISALINVOICE_SIGNATURE_NAME = 'SET_APPRAISALINVOICE_SIGNATURE_NAME';
var SET_APPRAISALINVOICE_SIGNATURE_BASE64 = 'SET_APPRAISALINVOICE_SIGNATURE_BASE64';
var SET_APPRAISALINVOICE_SIGNATURE_DATE = 'SET_APPRAISALINVOICE_SIGNATURE_DATE';
var SET_APPRAISALINVOICE_SIGNATURE_EMAIL = 'SET_APPRAISALINVOICE_SIGNATURE_EMAIL';
var SET_APPRAISALINVOICE_SIGNATURE_UID = 'SET_APPRAISALINVOICE_SIGNATURE_UID';
var SET_APPRAISALINVOICE_IS_SIGNED = 'SET_APPRAISALINVOICE_IS_SIGNED';

// appraisalinvoice_lines
var SET_APPRAISALINVOICE_LINES = 'SET_APPRAISALINVOICE_LINES';

// appraisalinvoice_petitioners
var SET_APPRAISALINVOICE_PETITIONERS = 'SET_APPRAISALINVOICE_PETITIONERS';
var SET_TEMP_APPRAISALINVOICE_PETITIONERS = 'SET_TEMP_APPRAISALINVOICE_PETITIONERS';

// appraisalinvoice_appraisalquotes
var SET_APPRAISALINVOICE_APPRAISALQUOTES = 'SET_APPRAISALINVOICE_APPRAISALQUOTES';
var SET_TEMP_APPRAISALINVOICE_APPRAISALQUOTES = 'SET_TEMP_APPRAISALINVOICE_APPRAISALQUOTES';

//appraisalfile_appraisalinvoices
var SET_APPRAISALFILE_APPRAISALINVOICES = 'SET_APPRAISALFILE_APPRAISALINVOICES';
var SET_TEMP_APPRAISALFILE_APPRAISALINVOICES = 'SET_TEMP_APPRAISALFILE_APPRAISALINVOICES';

// becprice
var CREATE_NEW_BECPRICE = 'CREATE_NEW_BECPRICE';
var DELETE_BECPRICE = 'DELETE_BECPRICE';
var GET_BECPRICE = 'GET_BECPRICE';
var RESET_BECPRICE = 'RESET_BECPRICE';
var SET_BECPRICE = 'SET_BECPRICE';
var SET_BECPRICE_DATE_CREATED = 'SET_BECPRICE_DATE_CREATED';
var SET_BECPRICE_DATE_MODIFIED = 'SET_BECPRICE_DATE_MODIFIED';
var SET_BECPRICE_DIRTYNESS = 'SET_BECPRICE_DIRTYNESS';
var SET_BECPRICE_ID = 'SET_BECPRICE_ID';
var SET_BECPRICE_PARENT_PATH = 'SET_BECPRICE_PARENT_PATH';
var SET_BECPRICE_PATH = 'SET_BECPRICE_PATH';
var UPDATE_BECPRICE = 'UPDATE_BECPRICE';
var SET_BECPRICE_NUMBER = 'SET_BECPRICE_NUMBER';
var SET_BECPRICE_QUARTER = 'SET_BECPRICE_QUARTER';
var SET_BECPRICE_YEAR = 'SET_BECPRICE_YEAR';
var SET_BECPRICE_AIRE_ACONDICIONADO = 'SET_BECPRICE_AIRE_ACONDICIONADO';
var SET_BECPRICE_ALBANILERIA_ACABADOS_FACHADA = 'SET_BECPRICE_ALBANILERIA_ACABADOS_FACHADA';
var SET_BECPRICE_ALBANILERIA_ACABADOS_INTERIORES = 'SET_BECPRICE_ALBANILERIA_ACABADOS_INTERIORES';
var SET_BECPRICE_ALBANILERIA_AYUDAS_INDUSTRIALES = 'SET_BECPRICE_ALBANILERIA_AYUDAS_INDUSTRIALES';
var SET_BECPRICE_ALBANILERIA_AZOTEAS = 'SET_BECPRICE_ALBANILERIA_AZOTEAS';
var SET_BECPRICE_ALBANILERIA_GRUESA = 'SET_BECPRICE_ALBANILERIA_GRUESA';
var SET_BECPRICE_ALBANILERIA_SOLADOS = 'SET_BECPRICE_ALBANILERIA_SOLADOS';
var SET_BECPRICE_ASCENSORES = 'SET_BECPRICE_ASCENSORES';
var SET_BECPRICE_CALEFACCION = 'SET_BECPRICE_CALEFACCION';
var SET_BECPRICE_CARPINTERIA_EXTERIOR = 'SET_BECPRICE_CARPINTERIA_EXTERIOR';
var SET_BECPRICE_CARPINTERIA_INTERIOR = 'SET_BECPRICE_CARPINTERIA_INTERIOR';
var SET_BECPRICE_CERRAJERIA = 'SET_BECPRICE_CERRAJERIA';
var SET_BECPRICE_CIMENTACION_Y_MURO_SOTANO = 'SET_BECPRICE_CIMENTACION_Y_MURO_SOTANO';
var SET_BECPRICE_ELECTRICIDAD = 'SET_BECPRICE_ELECTRICIDAD';
var SET_BECPRICE_ENERGIA_SOLAR_ACS = 'SET_BECPRICE_ENERGIA_SOLAR_ACS';
var SET_BECPRICE_ESTRUCTURA = 'SET_BECPRICE_ESTRUCTURA';
var SET_BECPRICE_FONTANERIA = 'SET_BECPRICE_FONTANERIA';
var SET_BECPRICE_FUMISTERIA_Y_MUEBLES_COCINA = 'SET_BECPRICE_FUMISTERIA_Y_MUEBLES_COCINA';
var SET_BECPRICE_INSTAL_ESPECIALES = 'SET_BECPRICE_INSTAL_ESPECIALES';
var SET_BECPRICE_JARDINERIA_DECORATIVA = 'SET_BECPRICE_JARDINERIA_DECORATIVA';
var SET_BECPRICE_MAT_SANITARIO_GRIFERIA = 'SET_BECPRICE_MAT_SANITARIO_GRIFERIA';
var SET_BECPRICE_MOVIMIENTO_TIERRAS = 'SET_BECPRICE_MOVIMIENTO_TIERRAS';
var SET_BECPRICE_PERSIANAS = 'SET_BECPRICE_PERSIANAS';
var SET_BECPRICE_PINTURA_Y_ESTUCOS = 'SET_BECPRICE_PINTURA_Y_ESTUCOS';
var SET_BECPRICE_RENOVACION_AIRE = 'SET_BECPRICE_RENOVACION_AIRE';
var SET_BECPRICE_SANEAMIENTO = 'SET_BECPRICE_SANEAMIENTO';
var SET_BECPRICE_SEGURIDAD_Y_SALUD = 'SET_BECPRICE_SEGURIDAD_Y_SALUD';
var SET_BECPRICE_SUBTOTAL = 'SET_BECPRICE_SUBTOTAL';
var SET_BECPRICE_TOTAL = 'SET_BECPRICE_TOTAL';
var SET_BECPRICE_VIDRIERIA = 'SET_BECPRICE_VIDRIERIA';
var SET_BECPRICE_YESERIA_CIELOSRASOS = 'SET_BECPRICE_YESERIA_CIELOSRASOS';

// becproperty
var CREATE_NEW_BECPROPERTY = 'CREATE_NEW_BECPROPERTY';
var DELETE_BECPROPERTY = 'DELETE_BECPROPERTY';
var GET_BECPROPERTY = 'GET_BECPROPERTY';
var RESET_BECPROPERTY = 'RESET_BECPROPERTY';
var SET_BECPROPERTY = 'SET_BECPROPERTY';
var SET_BECPROPERTY_DATE_CREATED = 'SET_BECPROPERTY_DATE_CREATED';
var SET_BECPROPERTY_DATE_MODIFIED = 'SET_BECPROPERTY_DATE_MODIFIED';
var SET_BECPROPERTY_DIRTYNESS = 'SET_BECPROPERTY_DIRTYNESS';
var SET_BECPROPERTY_ID = 'SET_BECPROPERTY_ID';
var SET_BECPROPERTY_PARENT_PATH = 'SET_BECPROPERTY_PARENT_PATH';
var SET_BECPROPERTY_PATH = 'SET_BECPROPERTY_PATH';
var UPDATE_BECPROPERTY = 'UPDATE_BECPROPERTY';
var SET_BECPROPERTY_NAME_CA = 'SET_BECPROPERTY_NAME_CA';
var SET_BECPROPERTY_NAME_EN = 'SET_BECPROPERTY_NAME_EN';
var SET_BECPROPERTY_NAME_ES = 'SET_BECPROPERTY_NAME_ES';

// becproperty_becprices
var SET_BECPROPERTY_BECPRICES = 'SET_BECPROPERTY_BECPRICES';

// constraint
var CREATE_NEW_CONSTRAINT = 'CREATE_NEW_CONSTRAINT';
var DELETE_CONSTRAINT = 'DELETE_CONSTRAINT';
var GET_CONSTRAINT = 'GET_CONSTRAINT';
var RESET_CONSTRAINT = 'RESET_CONSTRAINT';
var SET_CONSTRAINT = 'SET_CONSTRAINT';
var SET_CONSTRAINT_DATE_CREATED = 'SET_CONSTRAINT_DATE_CREATED';
var SET_CONSTRAINT_DATE_MODIFIED = 'SET_CONSTRAINT_DATE_MODIFIED';
var SET_CONSTRAINT_DIRTYNESS = 'SET_CONSTRAINT_DIRTYNESS';
var SET_CONSTRAINT_ID = 'SET_CONSTRAINT_ID';
var SET_CONSTRAINT_PARENT_PATH = 'SET_CONSTRAINT_PARENT_PATH';
var SET_CONSTRAINT_PATH = 'SET_CONSTRAINT_PATH';
var UPDATE_CONSTRAINT = 'UPDATE_CONSTRAINT';

// warning
var CREATE_NEW_WARNING = 'CREATE_NEW_WARNING';
var DELETE_WARNING = 'DELETE_WARNING';
var GET_WARNING = 'GET_WARNING';
var RESET_WARNING = 'RESET_WARNING';
var SET_WARNING = 'SET_WARNING';
var SET_WARNING_DATE_CREATED = 'SET_WARNING_DATE_CREATED';
var SET_WARNING_DATE_MODIFIED = 'SET_WARNING_DATE_MODIFIED';
var SET_WARNING_DIRTYNESS = 'SET_WARNING_DIRTYNESS';
var SET_WARNING_ID = 'SET_WARNING_ID';
var SET_WARNING_PARENT_PATH = 'SET_WARNING_PARENT_PATH';
var SET_WARNING_PATH = 'SET_WARNING_PATH';
var UPDATE_WARNING = 'UPDATE_WARNING';

// note
var CREATE_NEW_NOTE = 'CREATE_NEW_NOTE';
var DELETE_NOTE = 'DELETE_NOTE';
var GET_NOTE = 'GET_NOTE';
var RESET_NOTE = 'RESET_NOTE';
var SET_NOTE = 'SET_NOTE';
var SET_NOTE_DATE_CREATED = 'SET_NOTE_DATE_CREATED';
var SET_NOTE_DATE_MODIFIED = 'SET_NOTE_DATE_MODIFIED';
var SET_NOTE_DIRTYNESS = 'SET_NOTE_DIRTYNESS';
var SET_NOTE_ID = 'SET_NOTE_ID';
var SET_NOTE_PARENT_PATH = 'SET_NOTE_PARENT_PATH';
var SET_NOTE_PATH = 'SET_NOTE_PATH';
var UPDATE_NOTE = 'UPDATE_NOTE';

// contact
var CREATE_NEW_CONTACT = 'CREATE_NEW_CONTACT';
var RESET_CONTACT = 'RESET_CONTACT';
var SET_CONTACT = 'SET_CONTACT';
var SET_CONTACT_DATE_CREATED = 'SET_CONTACT_DATE_CREATED';
var SET_CONTACT_DATE_MODIFIED = 'SET_CONTACT_DATE_MODIFIED';
var SET_CONTACT_DIRTYNESS = 'SET_CONTACT_DIRTYNESS';
var SET_CONTACT_ID = 'SET_CONTACT_ID';
var SET_CONTACT_MAIN_EMAIL = 'SET_CONTACT_MAIN_EMAIL';
var SET_CONTACT_NAME = 'SET_CONTACT_NAME';
var SET_CONTACT_ORGANIZATION = 'SET_CONTACT_ORGANIZATION';
var SET_CONTACT_PATH = 'SET_CONTACT_PATH';
var SET_CONTACT_PERSON_TYPE = 'SET_CONTACT_PERSON_TYPE';
var SET_CONTACT_REPRESENTATIVE = 'SET_CONTACT_REPRESENTATIVE';
var SET_CONTACT_REPRESENTATIVE_TIN = 'SET_CONTACT_REPRESENTATIVE_TIN';
var SET_CONTACT_SURNAMES = 'SET_CONTACT_SURNAMES';
var SET_CONTACT_TIN = 'SET_CONTACT_TIN';
var SET_CONTACT_TITLE = 'SET_CONTACT_TITLE';
var SET_CONTACT_COMPLETE_NAME = 'SET_CONTACT_COMPLETE_NAME';
var SET_CONTACT_COMPLETE_FISCAL_ADDRESS = 'SET_CONTACT_COMPLETE_FISCAL_ADDRESS';
var SET_CONTACT_MAIN_TELEPHONENUMBER = 'SET_CONTACT_MAIN_TELEPHONENUMBER';
var SET_CONTACTS = 'SET_CONTACTS';
var UPDATE_CONTACT = 'UPDATE_CONTACT';

// appraiser
var CREATE_NEW_APPRAISER = 'CREATE_NEW_APPRAISER';
var RESET_APPRAISER = 'RESET_APPRAISER';
var SET_APPRAISER = 'SET_APPRAISER';
var SET_APPRAISER_DATE_CREATED = 'SET_APPRAISER_DATE_CREATED';
var SET_APPRAISER_DATE_MODIFIED = 'SET_APPRAISER_DATE_MODIFIED';
var SET_APPRAISER_DIRTYNESS = 'SET_APPRAISER_DIRTYNESS';
var SET_APPRAISER_ID = 'SET_APPRAISER_ID';
var SET_APPRAISER_NAME = 'SET_APPRAISER_NAME';
var SET_APPRAISER_ORGANIZATION = 'SET_APPRAISER_ORGANIZATION';
var SET_APPRAISER_PATH = 'SET_APPRAISER_PATH';
var SET_APPRAISER_SURNAMES = 'SET_APPRAISER_SURNAMES';
var SET_APPRAISER_TIN = 'SET_APPRAISER_TIN';
var SET_APPRAISER_TITLE = 'SET_APPRAISER_TITLE';
var SET_APPRAISER_COMPLETE_NAME = 'SET_APPRAISER_COMPLETE_NAME';
var SET_APPRAISER_PROF_ASSOC_REG_NUMBER = 'SET_APPRAISER_PROF_ASSOC_REG_NUMBER';
var SET_APPRAISERS = 'SET_APPRAISERS';
var UPDATE_APPRAISER = 'UPDATE_APPRAISER';

// supervisor
var CREATE_NEW_SUPERVISOR = 'CREATE_NEW_SUPERVISOR';
var RESET_SUPERVISOR = 'RESET_SUPERVISOR';
var SET_SUPERVISOR = 'SET_SUPERVISOR';
var SET_SUPERVISOR_DATE_CREATED = 'SET_SUPERVISOR_DATE_CREATED';
var SET_SUPERVISOR_DATE_MODIFIED = 'SET_SUPERVISOR_DATE_MODIFIED';
var SET_SUPERVISOR_DIRTYNESS = 'SET_SUPERVISOR_DIRTYNESS';
var SET_SUPERVISOR_ID = 'SET_SUPERVISOR_ID';
var SET_SUPERVISOR_NAME = 'SET_SUPERVISOR_NAME';
var SET_SUPERVISOR_ORGANIZATION = 'SET_SUPERVISOR_ORGANIZATION';
var SET_SUPERVISOR_PATH = 'SET_SUPERVISOR_PATH';
var SET_SUPERVISOR_SURNAMES = 'SET_SUPERVISOR_SURNAMES';
var SET_SUPERVISOR_TIN = 'SET_SUPERVISOR_TIN';
var SET_SUPERVISOR_TITLE = 'SET_SUPERVISOR_TITLE';
var SET_SUPERVISOR_COMPLETE_NAME = 'SET_SUPERVISOR_COMPLETE_NAME';
var SET_SUPERVISOR_PROF_ASSOC_REG_NUMBER = 'SET_SUPERVISOR_PROF_ASSOC_REG_NUMBER';
var SET_SUPERVISORS = 'SET_SUPERVISORS';
var UPDATE_SUPERVISOR = 'UPDATE_SUPERVISOR';

//contact_addresses
var SET_CONTACT_ADDRESSES = 'SET_CONTACT_ADDRESSES';

//contact_telephonenumbers
var SET_CONTACT_TELEPHONENUMBERS = 'SET_CONTACT_TELEPHONENUMBERS';

//contact_telephonenumbers
var SET_CONTACT_EMAILADDRESSES = 'SET_CONTACT_EMAILADDRESSES';

//contact_appraisalinvoices
var SET_CONTACT_APPRAISALINVOICES = 'SET_CONTACT_APPRAISALINVOICES';

//contact_appraisalquotes
var SET_CONTACT_APPRAISALQUOTES = 'SET_CONTACT_APPRAISALQUOTES';

//contact_appraisalreports
var SET_CONTACT_APPRAISALREPORTS = 'SET_CONTACT_APPRAISALREPORTS';

// entity
var CREATE_NEW_ENTITY = 'CREATE_NEW_ENTITY';
var RESET_ENTITY = 'RESET_ENTITY';
var SET_ENTITY = 'SET_ENTITY';
var SET_ENTITY_DATE_CREATED = 'SET_ENTITY_DATE_CREATED';
var SET_ENTITY_DATE_MODIFIED = 'SET_ENTITY_DATE_MODIFIED';
var SET_ENTITY_DIRTYNESS = 'SET_ENTITY_DIRTYNESS';
var SET_ENTITY_ID = 'SET_ENTITY_ID';
var SET_ENTITY_PATH = 'SET_ENTITY_PATH';
var SET_ENTITIES = 'SET_ENTITIES';
var UPDATE_ENTITY = 'UPDATE_ENTITY';
var SET_ENTITY_NAME = 'SET_ENTITY_NAME';
var SET_ENTITY_TIN = 'SET_ENTITY_TIN';
var SET_ENTITY_BDE_CODE = 'SET_ENTITY_BDE_CODE';

// marketstudy
var CREATE_NEW_MARKETSTUDY = 'CREATE_NEW_MARKETSTUDY';
var DELETE_MARKETSTUDY = 'DELETE_MARKETSTUDY';
var RESET_MARKETSTUDY = 'RESET_MARKETSTUDY';
var SET_MARKETSTUDY = 'SET_MARKETSTUDY';
var SET_MARKETSTUDY_DATE_CREATED = 'SET_MARKETSTUDY_DATE_CREATED';
var SET_MARKETSTUDY_DATE_MODIFIED = 'SET_MARKETSTUDY_DATE_MODIFIED';
var SET_MARKETSTUDY_DIRTYNESS = 'SET_MARKETSTUDY_DIRTYNESS';
var SET_MARKETSTUDY_ID = 'SET_MARKETSTUDY_ID';
var SET_MARKETSTUDY_PARENT_PATH = 'SET_MARKETSTUDY_PARENT_PATH';
var SET_MARKETSTUDY_PATH = 'SET_MARKETSTUDY_PATH';
var SET_MARKETSTUDY_PURPOSE = 'SET_MARKETSTUDY_PURPOSE';
var SET_MARKETSTUDY_PURPOSE_NOTES = 'SET_MARKETSTUDY_PURPOSE_NOTES';
var SET_MARKETSTUDY_TYPE = 'SET_MARKETSTUDY_TYPE';
var UPDATE_MARKETSTUDY = 'UPDATE_MARKETSTUDY';
var SET_MARKETSTUDY_APPRAISAL_ID = 'SET_MARKETSTUDY_APPRAISAL_ID';
var SET_MARKETSTUDY_DESCRIPTION = 'SET_MARKETSTUDY_DESCRIPTION';
var SET_MARKETSTUDY_QUERY_AD_TYPE = 'SET_MARKETSTUDY_QUERY_AD_TYPE';
var SET_MARKETSTUDY_QUERY_DISTANCE_KM = 'SET_MARKETSTUDY_QUERY_DISTANCE_KM';
var SET_MARKETSTUDY_QUERY_LIMITDATE = 'SET_MARKETSTUDY_QUERY_LIMITDATE';
var SET_MARKETSTUDY_QUERY_STARTDATE = 'SET_MARKETSTUDY_QUERY_STARTDATE';
var SET_MARKETSTUDY_REPRESENTATIVE_SAMPLE_TYPICAL_DEVIATION = 'SET_MARKETSTUDY_REPRESENTATIVE_SAMPLE_TYPICAL_DEVIATION';
var SET_MARKETSTUDY_UNIVERSAL_SAMPLE_TYPICAL_DEVIATION = 'SET_MARKETSTUDY_UNIVERSAL_SAMPLE_TYPICAL_DEVIATION';
var SET_MARKETSTUDY_WEIGHING = 'SET_MARKETSTUDY_WEIGHING';
var SET_MARKETSTUDY_WEIGHING_AD_DATE = 'SET_MARKETSTUDY_WEIGHING_AD_DATE';
var SET_MARKETSTUDY_WEIGHING_PROPERTY_TYPE = 'SET_MARKETSTUDY_WEIGHING_PROPERTY_TYPE';
var SET_MARKETSTUDY_WEIGHING_QUALITY_OF_NEIGHBOURHOOD = 'SET_MARKETSTUDY_WEIGHING_QUALITY_OF_NEIGHBOURHOOD';
var SET_MARKETSTUDY_WEIGHING_QUALITY_OF_SITUATION = 'SET_MARKETSTUDY_WEIGHING_QUALITY_OF_SITUATION';
var SET_MARKETSTUDY_WEIGHING_QUALITY_OF_CONSTRUCTION = 'SET_MARKETSTUDY_WEIGHING_QUALITY_OF_CONSTRUCTION';
var SET_MARKETSTUDY_WEIGHING_QUALITY_OF_REALESTATE = 'SET_MARKETSTUDY_WEIGHING_QUALITY_OF_REALESTATE';
var SET_MARKETSTUDY_WEIGHING_ADOPTED_AGE = 'SET_MARKETSTUDY_WEIGHING_ADOPTED_AGE';
var SET_MARKETSTUDY_WEIGHING_CONSERVATION_STATUS = 'SET_MARKETSTUDY_WEIGHING_CONSERVATION_STATUS';
var SET_MARKETSTUDY_WEIGHING_FLOOR_NUMBER = 'SET_MARKETSTUDY_WEIGHING_FLOOR_NUMBER';
var SET_MARKETSTUDY_WEIGHING_ADOPTED_AREA = 'SET_MARKETSTUDY_WEIGHING_ADOPTED_AREA';
var SET_MARKETSTUDY_WEIGHING_LIFT = 'SET_MARKETSTUDY_WEIGHING_LIFT';
var SET_MARKETSTUDY_APPRAISED_POINTS = 'SET_MARKETSTUDY_APPRAISED_POINTS';
var SET_MARKETSTUDY_COMPARABLE_POINTS = 'SET_MARKETSTUDY_COMPARABLE_POINTS';
var SET_MARKETSTUDY_REGRESSIONLINE_POINTS = 'SET_MARKETSTUDY_REGRESSIONLINE_POINTS';
var SET_MARKETSTUDY_MARKET_VALUE = 'SET_MARKETSTUDY_MARKET_VALUE';
var SET_MARKETSTUDY_MARKET_UNIT_VALUE = 'SET_MARKETSTUDY_MARKET_UNIT_VALUE';
var SET_MARKETSTUDY_REALESTATE_APPRAISALS = 'SET_MARKETSTUDY_REALESTATE_APPRAISALS';
var SET_MARKETSTUDY_PRICES_ESTIMATED_YEARLY_EVOLUTION_PCT = 'SET_MARKETSTUDY_PRICES_ESTIMATED_YEARLY_EVOLUTION_PCT';
var SET_MARKETSTUDY_MARKET_VALUE_EVOLUTION_PROBABILITY_PCT = 'SET_MARKETSTUDY_MARKET_VALUE_EVOLUTION_PROBABILITY_PCT';
var SET_MARKETSTUDY_OFFER_PRODUCTION = 'SET_MARKETSTUDY_OFFER_PRODUCTION';
var SET_MARKETSTUDY_OFFER_YEARLY_STOCK = 'SET_MARKETSTUDY_OFFER_YEARLY_STOCK';
var SET_MARKETSTUDY_OFFER_TREND = 'SET_MARKETSTUDY_OFFER_TREND';
var SET_MARKETSTUDY_DEMAND_LEVEL = 'SET_MARKETSTUDY_DEMAND_LEVEL';
var SET_MARKETSTUDY_DEMAND_SPEED_OF_SALES = 'SET_MARKETSTUDY_DEMAND_SPEED_OF_SALES';
var SET_MARKETSTUDY_DEMAND_TREND = 'SET_MARKETSTUDY_DEMAND_TREND';
var SET_MARKETSTUDY_PRICES_EXPECTANCY = 'SET_MARKETSTUDY_PRICES_EXPECTANCY';
var SET_MARKETSTUDY_PRICES_PAST_CICLES_VOLATILITY = 'SET_MARKETSTUDY_PRICES_PAST_CICLES_VOLATILITY';
var SET_MARKETSTUDY_MARKET_CONJUNCTURE = 'SET_MARKETSTUDY_MARKET_CONJUNCTURE';
var SET_MARKETSTUDY_MARKET_VALUE_REDUCTION_PROBABILITY_EXPECTANCY = 'SET_MARKETSTUDY_MARKET_VALUE_REDUCTION_PROBABILITY_EXPECTANCY';
var SET_MARKETSTUDY_PRICES_MAX = 'SET_MARKETSTUDY_PRICES_MAX';
var SET_MARKETSTUDY_PRICES_MIN = 'SET_MARKETSTUDY_PRICES_MIN';
var SET_MARKETSTUDY_PRICES_MEAN = 'SET_MARKETSTUDY_PRICES_MEAN';
var SET_MARKETSTUDY_PRICES_MEDIAN = 'SET_MARKETSTUDY_PRICES_MEDIAN';

// marketstudy_ads
var SET_MARKETSTUDY_MATCHED_ADS = 'SET_MARKETSTUDY_MATCHED_ADS';

// marketstudy_ad_comparables
var SET_MARKETSTUDY_AD_COMPARABLES = 'SET_MARKETSTUDY_AD_COMPARABLES';

// constraint
var SET_CONSTRAINT_NAME_CA = 'SET_CONSTRAINT_NAME_CA';
var SET_CONSTRAINT_NAME_EN = 'SET_CONSTRAINT_NAME_EN';
var SET_CONSTRAINT_NAME_ES = 'SET_CONSTRAINT_NAME_ES';
var SET_CONSTRAINT_DEFAULT_CONSTRAINTS = 'SET_CONSTRAINT_DEFAULT_CONSTRAINTS';

// warning
var SET_WARNING_NAME_CA = 'SET_WARNING_NAME_CA';
var SET_WARNING_NAME_EN = 'SET_WARNING_NAME_EN';
var SET_WARNING_NAME_ES = 'SET_WARNING_NAME_ES';
var SET_CONSTRAINT_DEFAULT_WARNINGS = 'SET_CONSTRAINT_DEFAULT_WARNINGS';

// note
var SET_NOTE_NAME_CA = 'SET_NOTE_NAME_CA';
var SET_NOTE_NAME_EN = 'SET_NOTE_NAME_EN';
var SET_NOTE_NAME_ES = 'SET_NOTE_NAME_ES';
var SET_CONSTRAINT_DEFAULT_NOTES = 'SET_CONSTRAINT_DEFAULT_NOTES';

// photograph
var CREATE_NEW_PHOTOGRAPH = 'CREATE_NEW_PHOTOGRAPH';
var DELETE_PHOTOGRAPH = 'DELETE_PHOTOGRAPH';
var GET_PHOTOGRAPH = 'GET_PHOTOGRAPH';
var RESET_PHOTOGRAPH = 'RESET_PHOTOGRAPH';
var SET_PHOTOGRAPH = 'SET_PHOTOGRAPH';
var SET_PHOTOGRAPH_DATE_CREATED = 'SET_PHOTOGRAPH_DATE_CREATED';
var SET_PHOTOGRAPH_DATE_MODIFIED = 'SET_PHOTOGRAPH_DATE_MODIFIED';
var SET_PHOTOGRAPH_DIRTYNESS = 'SET_PHOTOGRAPH_DIRTYNESS';
var SET_PHOTOGRAPH_ID = 'SET_PHOTOGRAPH_ID';
var SET_PHOTOGRAPH_PARENT_PATH = 'SET_PHOTOGRAPH_PARENT_PATH';
var SET_PHOTOGRAPH_PATH = 'SET_PHOTOGRAPH_PATH';
var UPDATE_PHOTOGRAPH = 'UPDATE_PHOTOGRAPH';
var SET_PHOTOGRAPH_NAME_CA = 'SET_PHOTOGRAPH_NAME_CA';
var SET_PHOTOGRAPH_NAME_EN = 'SET_PHOTOGRAPH_NAME_EN';
var SET_PHOTOGRAPH_NAME_ES = 'SET_PHOTOGRAPH_NAME_ES';
var SET_PHOTOGRAPH_URL = 'SET_PHOTOGRAPH_URL';
var SET_PHOTOGRAPH_FILENAME = 'SET_PHOTOGRAPH_FILENAME';
var SET_PHOTOGRAPH_IS_COVER_PHOTO = 'SET_PHOTOGRAPH_IS_COVER_PHOTO';

// project
var CREATE_NEW_PROJECT = 'CREATE_NEW_PROJECT';
var RESET_PROJECT = 'RESET_PROJECT';
var SET_PROJECT = 'SET_PROJECT';
var SET_PROJECT_DATE_CREATED = 'SET_PROJECT_DATE_CREATED';
var SET_PROJECT_DATE_MODIFIED = 'SET_PROJECT_DATE_MODIFIED';
var SET_PROJECT_DIRTYNESS = 'SET_PROJECT_DIRTYNESS';
var SET_PROJECT_ID = 'SET_PROJECT_ID';
var SET_PROJECT_PATH = 'SET_PROJECT_PATH';
var SET_PROJECT_PARENT_PATH = 'SET_PROJECT_PARENT_PATH';
var SET_PROJECT_PROJECTDATE = 'SET_PROJECT_PROJECTDATE';
var SET_PROJECT_REALESTATE_ID = 'SET_PROJECT_REALESTATE_ID';
var UPDATE_PROJECT = 'UPDATE_PROJECT';

// registryannex
var CREATE_NEW_REGISTRYANNEX = 'CREATE_NEW_REGISTRYANNEX';
var DELETE_REGISTRYANNEX = 'DELETE_REGISTRYANNEX';
var GET_REGISTRYANNEX = 'GET_REGISTRYANNEX';
var RESET_REGISTRYANNEX = 'RESET_REGISTRYANNEX';
var SET_REGISTRYANNEX = 'SET_REGISTRYANNEX';
var SET_REGISTRYANNEX_DATE_CREATED = 'SET_REGISTRYANNEX_DATE_CREATED';
var SET_REGISTRYANNEX_DATE_MODIFIED = 'SET_REGISTRYANNEX_DATE_MODIFIED';
var SET_REGISTRYANNEX_DIRTYNESS = 'SET_REGISTRYANNEX_DIRTYNESS';
var SET_REGISTRYANNEX_ID = 'SET_REGISTRYANNEX_ID';
var SET_REGISTRYANNEX_PARENT_PATH = 'SET_REGISTRYANNEX_PARENT_PATH';
var SET_REGISTRYANNEX_PATH = 'SET_REGISTRYANNEX_PATH';
var UPDATE_REGISTRYANNEX = 'UPDATE_REGISTRYANNEX';
var SET_REGISTRYANNEX_NAME_CA = 'SET_REGISTRYANNEX_NAME_CA';
var SET_REGISTRYANNEX_NAME_EN = 'SET_REGISTRYANNEX_NAME_EN';
var SET_REGISTRYANNEX_NAME_ES = 'SET_REGISTRYANNEX_NAME_ES';
var SET_REGISTRYANNEX_URL = 'SET_REGISTRYANNEX_URL';
var SET_REGISTRYANNEX_FILENAME = 'SET_REGISTRYANNEX_FILENAME';

// cadasterannex
var CREATE_NEW_CADASTERANNEX = 'CREATE_NEW_CADASTERANNEX';
var DELETE_CADASTERANNEX = 'DELETE_CADASTERANNEX';
var GET_CADASTERANNEX = 'GET_CADASTERANNEX';
var RESET_CADASTERANNEX = 'RESET_CADASTERANNEX';
var SET_CADASTERANNEX = 'SET_CADASTERANNEX';
var SET_CADASTERANNEX_DATE_CREATED = 'SET_CADASTERANNEX_DATE_CREATED';
var SET_CADASTERANNEX_DATE_MODIFIED = 'SET_CADASTERANNEX_DATE_MODIFIED';
var SET_CADASTERANNEX_DIRTYNESS = 'SET_CADASTERANNEX_DIRTYNESS';
var SET_CADASTERANNEX_ID = 'SET_CADASTERANNEX_ID';
var SET_CADASTERANNEX_PARENT_PATH = 'SET_CADASTERANNEX_PARENT_PATH';
var SET_CADASTERANNEX_PATH = 'SET_CADASTERANNEX_PATH';
var UPDATE_CADASTERANNEX = 'UPDATE_CADASTERANNEX';
var SET_CADASTERANNEX_NAME_CA = 'SET_CADASTERANNEX_NAME_CA';
var SET_CADASTERANNEX_NAME_EN = 'SET_CADASTERANNEX_NAME_EN';
var SET_CADASTERANNEX_NAME_ES = 'SET_CADASTERANNEX_NAME_ES';
var SET_CADASTERANNEX_URL = 'SET_CADASTERANNEX_URL';
var SET_CADASTERANNEX_FILENAME = 'SET_CADASTERANNEX_FILENAME';

// urbanannex
var CREATE_NEW_URBANANNEX = 'CREATE_NEW_URBANANNEX';
var DELETE_URBANANNEX = 'DELETE_URBANANNEX';
var GET_URBANANNEX = 'GET_URBANANNEX';
var RESET_URBANANNEX = 'RESET_URBANANNEX';
var SET_URBANANNEX = 'SET_URBANANNEX';
var SET_URBANANNEX_DATE_CREATED = 'SET_URBANANNEX_DATE_CREATED';
var SET_URBANANNEX_DATE_MODIFIED = 'SET_URBANANNEX_DATE_MODIFIED';
var SET_URBANANNEX_DIRTYNESS = 'SET_URBANANNEX_DIRTYNESS';
var SET_URBANANNEX_ID = 'SET_URBANANNEX_ID';
var SET_URBANANNEX_PARENT_PATH = 'SET_URBANANNEX_PARENT_PATH';
var SET_URBANANNEX_PATH = 'SET_URBANANNEX_PATH';
var UPDATE_URBANANNEX = 'UPDATE_URBANANNEX';
var SET_URBANANNEX_NAME_CA = 'SET_URBANANNEX_NAME_CA';
var SET_URBANANNEX_NAME_EN = 'SET_URBANANNEX_NAME_EN';
var SET_URBANANNEX_NAME_ES = 'SET_URBANANNEX_NAME_ES';
var SET_URBANANNEX_URL = 'SET_URBANANNEX_URL';
var SET_URBANANNEX_FILENAME = 'SET_URBANANNEX_FILENAME';

// planannex
var CREATE_NEW_PLANANNEX = 'CREATE_NEW_PLANANNEX';
var DELETE_PLANANNEX = 'DELETE_PLANANNEX';
var GET_PLANANNEX = 'GET_PLANANNEX';
var RESET_PLANANNEX = 'RESET_PLANANNEX';
var SET_PLANANNEX = 'SET_PLANANNEX';
var SET_PLANANNEX_DATE_CREATED = 'SET_PLANANNEX_DATE_CREATED';
var SET_PLANANNEX_DATE_MODIFIED = 'SET_PLANANNEX_DATE_MODIFIED';
var SET_PLANANNEX_DIRTYNESS = 'SET_PLANANNEX_DIRTYNESS';
var SET_PLANANNEX_ID = 'SET_PLANANNEX_ID';
var SET_PLANANNEX_PARENT_PATH = 'SET_PLANANNEX_PARENT_PATH';
var SET_PLANANNEX_PATH = 'SET_PLANANNEX_PATH';
var UPDATE_PLANANNEX = 'UPDATE_PLANANNEX';
var SET_PLANANNEX_NAME_CA = 'SET_PLANANNEX_NAME_CA';
var SET_PLANANNEX_NAME_EN = 'SET_PLANANNEX_NAME_EN';
var SET_PLANANNEX_NAME_ES = 'SET_PLANANNEX_NAME_ES';
var SET_PLANANNEX_URL = 'SET_PLANANNEX_URL';
var SET_PLANANNEX_FILENAME = 'SET_PLANANNEX_FILENAME';

// cessionannex
var CREATE_NEW_CESSIONANNEX = 'CREATE_NEW_CESSIONANNEX';
var DELETE_CESSIONANNEX = 'DELETE_CESSIONANNEX';
var GET_CESSIONANNEX = 'GET_CESSIONANNEX';
var RESET_CESSIONANNEX = 'RESET_CESSIONANNEX';
var SET_CESSIONANNEX = 'SET_CESSIONANNEX';
var SET_CESSIONANNEX_DATE_CREATED = 'SET_CESSIONANNEX_DATE_CREATED';
var SET_CESSIONANNEX_DATE_MODIFIED = 'SET_CESSIONANNEX_DATE_MODIFIED';
var SET_CESSIONANNEX_DIRTYNESS = 'SET_CESSIONANNEX_DIRTYNESS';
var SET_CESSIONANNEX_ID = 'SET_CESSIONANNEX_ID';
var SET_CESSIONANNEX_PARENT_PATH = 'SET_CESSIONANNEX_PARENT_PATH';
var SET_CESSIONANNEX_PATH = 'SET_CESSIONANNEX_PATH';
var UPDATE_CESSIONANNEX = 'UPDATE_CESSIONANNEX';
var SET_CESSIONANNEX_NAME_CA = 'SET_CESSIONANNEX_NAME_CA';
var SET_CESSIONANNEX_NAME_EN = 'SET_CESSIONANNEX_NAME_EN';
var SET_CESSIONANNEX_NAME_ES = 'SET_CESSIONANNEX_NAME_ES';
var SET_CESSIONANNEX_URL = 'SET_CESSIONANNEX_URL';
var SET_CESSIONANNEX_FILENAME = 'SET_CESSIONANNEX_FILENAME';

// otherannex
var CREATE_NEW_OTHERANNEX = 'CREATE_NEW_OTHERANNEX';
var DELETE_OTHERANNEX = 'DELETE_OTHERANNEX';
var GET_OTHERANNEX = 'GET_OTHERANNEX';
var RESET_OTHERANNEX = 'RESET_OTHERANNEX';
var SET_OTHERANNEX = 'SET_OTHERANNEX';
var SET_OTHERANNEX_DATE_CREATED = 'SET_OTHERANNEX_DATE_CREATED';
var SET_OTHERANNEX_DATE_MODIFIED = 'SET_OTHERANNEX_DATE_MODIFIED';
var SET_OTHERANNEX_DIRTYNESS = 'SET_OTHERANNEX_DIRTYNESS';
var SET_OTHERANNEX_ID = 'SET_OTHERANNEX_ID';
var SET_OTHERANNEX_PARENT_PATH = 'SET_OTHERANNEX_PARENT_PATH';
var SET_OTHERANNEX_PATH = 'SET_OTHERANNEX_PATH';
var UPDATE_OTHERANNEX = 'UPDATE_OTHERANNEX';
var SET_OTHERANNEX_NAME_CA = 'SET_OTHERANNEX_NAME_CA';
var SET_OTHERANNEX_NAME_EN = 'SET_OTHERANNEX_NAME_EN';
var SET_OTHERANNEX_NAME_ES = 'SET_OTHERANNEX_NAME_ES';
var SET_OTHERANNEX_URL = 'SET_OTHERANNEX_URL';
var SET_OTHERANNEX_FILENAME = 'SET_OTHERANNEX_FILENAME';

// room
var CREATE_NEW_ROOM = 'CREATE_NEW_ROOM';
var DELETE_ROOM = 'DELETE_ROOM';
var RESET_ROOM = 'RESET_ROOM';
var SET_ROOM = 'SET_ROOM';
var SET_ROOM_DATE_CREATED = 'SET_ROOM_DATE_CREATED';
var SET_ROOM_DATE_MODIFIED = 'SET_ROOM_DATE_MODIFIED';
var SET_ROOM_DIRTYNESS = 'SET_ROOM_DIRTYNESS';
var SET_ROOM_ID = 'SET_ROOM_ID';
var SET_ROOM_PARENT_PATH = 'SET_ROOM_PARENT_PATH';
var SET_ROOM_PATH = 'SET_ROOM_PATH';
var UPDATE_ROOM = 'UPDATE_ROOM';
var SET_ROOM_DESCRIPTION = 'SET_ROOM_DESCRIPTION';
var SET_ROOM_NETAREA = 'SET_ROOM_NETAREA';
var SET_ROOM_TYPE = 'SET_ROOM_TYPE';

// line
var CREATE_NEW_LINE = 'CREATE_NEW_LINE';
var DELETE_LINE = 'DELETE_LINE';
var RESET_LINE = 'RESET_LINE';
var SET_LINE = 'SET_LINE';
var SET_LINE_DATE_CREATED = 'SET_LINE_DATE_CREATED';
var SET_LINE_DATE_MODIFIED = 'SET_LINE_DATE_MODIFIED';
var SET_LINE_DIRTYNESS = 'SET_LINE_DIRTYNESS';
var SET_LINE_ID = 'SET_LINE_ID';
var SET_LINE_PARENT_PATH = 'SET_LINE_PARENT_PATH';
var SET_LINE_PATH = 'SET_LINE_PATH';
var UPDATE_LINE = 'UPDATE_LINE';
var SET_LINE_DESCRIPTION = 'SET_LINE_DESCRIPTION';
var SET_LINE_NETAREA = 'SET_LINE_NETAREA';
var SET_LINE_TYPE = 'SET_LINE_TYPE';
var SET_LINE_UNITS = 'SET_LINE_UNITS';
var SET_LINE_UNIT_PRICE = 'SET_LINE_UNIT_PRICE';
var SET_LINE_PRICE = 'SET_LINE_PRICE';

// covered_outdoor
var CREATE_NEW_COVERED_OUTDOOR = 'CREATE_NEW_COVERED_OUTDOOR';
var DELETE_COVERED_OUTDOOR = 'DELETE_COVERED_OUTDOOR';
var RESET_COVERED_OUTDOOR = 'RESET_COVERED_OUTDOOR';
var SET_COVERED_OUTDOOR = 'SET_COVERED_OUTDOOR';
var SET_COVERED_OUTDOOR_DATE_CREATED = 'SET_COVERED_OUTDOOR_DATE_CREATED';
var SET_COVERED_OUTDOOR_DATE_MODIFIED = 'SET_COVERED_OUTDOOR_DATE_MODIFIED';
var SET_COVERED_OUTDOOR_DIRTYNESS = 'SET_COVERED_OUTDOOR_DIRTYNESS';
var SET_COVERED_OUTDOOR_ID = 'SET_COVERED_OUTDOOR_ID';
var SET_COVERED_OUTDOOR_PARENT_PATH = 'SET_COVERED_OUTDOOR_PARENT_PATH';
var SET_COVERED_OUTDOOR_PATH = 'SET_COVERED_OUTDOOR_PATH';
var UPDATE_COVERED_OUTDOOR = 'UPDATE_COVERED_OUTDOOR';
var SET_COVERED_OUTDOOR_DESCRIPTION = 'SET_COVERED_OUTDOOR_DESCRIPTION';
var SET_COVERED_OUTDOOR_NETAREA = 'SET_COVERED_OUTDOOR_NETAREA';
var SET_COVERED_OUTDOOR_TYPE = 'SET_COVERED_OUTDOOR_TYPE';

// uncovered_outdoor
var CREATE_NEW_UNCOVERED_OUTDOOR = 'CREATE_NEW_UNCOVERED_OUTDOOR';
var DELETE_UNCOVERED_OUTDOOR = 'DELETE_UNCOVERED_OUTDOOR';
var RESET_UNCOVERED_OUTDOOR = 'RESET_UNCOVERED_OUTDOOR';
var SET_UNCOVERED_OUTDOOR = 'SET_UNCOVERED_OUTDOOR';
var SET_UNCOVERED_OUTDOOR_DATE_CREATED = 'SET_UNCOVERED_OUTDOOR_DATE_CREATED';
var SET_UNCOVERED_OUTDOOR_DATE_MODIFIED = 'SET_UNCOVERED_OUTDOOR_DATE_MODIFIED';
var SET_UNCOVERED_OUTDOOR_DIRTYNESS = 'SET_UNCOVERED_OUTDOOR_DIRTYNESS';
var SET_UNCOVERED_OUTDOOR_ID = 'SET_UNCOVERED_OUTDOOR_ID';
var SET_UNCOVERED_OUTDOOR_PARENT_PATH = 'SET_UNCOVERED_OUTDOOR_PARENT_PATH';
var SET_UNCOVERED_OUTDOOR_PATH = 'SET_UNCOVERED_OUTDOOR_PATH';
var UPDATE_UNCOVERED_OUTDOOR = 'UPDATE_UNCOVERED_OUTDOOR';
var SET_UNCOVERED_OUTDOOR_DESCRIPTION = 'SET_UNCOVERED_OUTDOOR_DESCRIPTION';
var SET_UNCOVERED_OUTDOOR_NETAREA = 'SET_UNCOVERED_OUTDOOR_NETAREA';
var SET_UNCOVERED_OUTDOOR_TYPE = 'SET_UNCOVERED_OUTDOOR_TYPE';

// telephonenumber
var CREATE_NEW_TELEPHONENUMBER = 'CREATE_NEW_TELEPHONENUMBER';
var DELETE_TELEPHONENUMBER = 'DELETE_TELEPHONENUMBER';
var RESET_TELEPHONENUMBER = 'RESET_TELEPHONENUMBER';
var SET_TELEPHONENUMBER = 'SET_TELEPHONENUMBER';
var SET_TELEPHONENUMBER_DATE_CREATED = 'SET_TELEPHONENUMBER_DATE_CREATED';
var SET_TELEPHONENUMBER_DATE_MODIFIED = 'SET_TELEPHONENUMBER_DATE_MODIFIED';
var SET_TELEPHONENUMBER_DIRTYNESS = 'SET_TELEPHONENUMBER_DIRTYNESS';
var SET_TELEPHONENUMBER_ID = 'SET_TELEPHONENUMBER_ID';
var SET_TELEPHONENUMBER_PATH = 'SET_TELEPHONENUMBER_PATH';
var UPDATE_TELEPHONENUMBER = 'UPDATE_TELEPHONENUMBER';
var SET_TELEPHONENUMBER_DESCRIPTION = 'SET_TELEPHONENUMBER_DESCRIPTION';
var SET_TELEPHONENUMBER_NUMBER = 'SET_TELEPHONENUMBER_NUMBER';
var SET_TELEPHONENUMBER_PREFIX = 'SET_TELEPHONENUMBER_PREFIX';

// email
var CREATE_NEW_EMAILADDRESS = 'CREATE_NEW_EMAILADDRESS';
var DELETE_EMAILADDRESS = 'DELETE_EMAILADDRESS';
var RESET_EMAILADDRESS = 'RESET_EMAILADDRESS';
var SET_EMAILADDRESS = 'SET_EMAILADDRESS';
var SET_EMAILADDRESS_DATE_CREATED = 'SET_EMAILADDRESS_DATE_CREATED';
var SET_EMAILADDRESS_DATE_MODIFIED = 'SET_EMAILADDRESS_DATE_MODIFIED';
var SET_EMAILADDRESS_DIRTYNESS = 'SET_EMAILADDRESS_DIRTYNESS';
var SET_EMAILADDRESS_ID = 'SET_EMAILADDRESS_ID';
var SET_EMAILADDRESS_PATH = 'SET_EMAILADDRESS_PATH';
var UPDATE_EMAILADDRESS = 'UPDATE_EMAILADDRESS';
var SET_EMAILADDRESS_DESCRIPTION = 'SET_EMAILADDRESS_DESCRIPTION';
var SET_EMAILADDRESS_ADDRESS = 'SET_EMAILADDRESS_ADDRESS';

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Store */
/* unused harmony export mapState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mapMutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mapGetters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return mapActions; });
/**
 * vuex v2.3.0
 * (c) 2017 Evan You
 * @license MIT
 */
var applyMixin = function (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    var usesInit = Vue.config._lifecycleHooks.indexOf('init') > -1;
    Vue.mixin(usesInit ? { init: vuexInit } : { beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
};

var devtoolHook =
  typeof window !== 'undefined' &&
  window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */


/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function assert (condition, msg) {
  if (!condition) { throw new Error(("[vuex] " + msg)) }
}

var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  this._children = Object.create(null);
  this._rawModule = rawModule;
  var rawState = rawModule.state;
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors$1 = { namespaced: {} };

prototypeAccessors$1.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors$1 );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  var this$1 = this;

  // register root module (Vuex.Store options)
  this.root = new Module(rawRootModule, false);

  // register all nested modules
  if (rawRootModule.modules) {
    forEachValue(rawRootModule.modules, function (rawModule, key) {
      this$1.register([key], rawModule, false);
    });
  }
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update(this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  var parent = this.get(path.slice(0, -1));
  var newModule = new Module(rawModule, runtime);
  parent.addChild(path[path.length - 1], newModule);

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  if (!parent.getChild(key).runtime) { return }

  parent.removeChild(key);
};

function update (targetModule, newModule) {
  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        console.warn(
          "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
          'manual reload is needed'
        );
        return
      }
      update(targetModule.getChild(key), newModule.modules[key]);
    }
  }
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
  assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");

  var state = options.state; if ( state === void 0 ) state = {};
  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.concat(devtoolPlugin).forEach(function (plugin) { return plugin(this$1); });
};

var prototypeAccessors = { state: {} };

prototypeAccessors.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors.state.set = function (v) {
  assert(false, "Use store.replaceState() to explicit replace store state.");
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    console.error(("[vuex] unknown mutation type: " + type));
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });
  this._subscribers.forEach(function (sub) { return sub(mutation, this$1.state); });

  if (options && options.silent) {
    console.warn(
      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
      'Use the filter functionality in the vue-devtools'
    );
  }
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var entry = this._actions[type];
  if (!entry) {
    console.error(("[vuex] unknown action type: " + type));
    return
  }
  return entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload)
};

Store.prototype.subscribe = function subscribe (fn) {
  var subs = this._subscribers;
  if (subs.indexOf(fn) < 0) {
    subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;

  assert(typeof getter === 'function', "store.watch only accepts a function.");
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule) {
  if (typeof path === 'string') { path = [path]; }
  assert(Array.isArray(path), "module path must be a string or an Array.");
  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path));
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }
  assert(Array.isArray(path), "module path must be a string or an Array.");
  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors );

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    computed[key] = function () { return fn(store); };
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var namespacedType = namespace + key;
    registerAction(store, namespacedType, action, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (!store._actions[type]) {
          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (!store._mutations[type]) {
          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  var gettersProxy = {};

  var splitPos = namespace.length;
  Object.keys(store.getters).forEach(function (type) {
    // skip if the target getter is not match this namespace
    if (type.slice(0, splitPos) !== namespace) { return }

    // extract local getter type
    var localType = type.slice(splitPos);

    // Add a port to the getters proxy.
    // Define as getter property because
    // we do not want to evaluate the getters in this time.
    Object.defineProperty(gettersProxy, localType, {
      get: function () { return store.getters[type]; },
      enumerable: true
    });
  });

  return gettersProxy
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler(local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload, cb) {
    var res = handler({
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload, cb);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    console.error(("[vuex] duplicate getter key: " + type));
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
    assert(store._committing, "Do not mutate vuex store state outside mutation handlers.");
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.length
    ? path.reduce(function (state, key) { return state[key]; }, state)
    : state
}

function unifyObjectStyle (type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  assert(typeof type === 'string', ("Expects string as the type, but found " + (typeof type) + "."));

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue) {
    console.error(
      '[vuex] already installed. Vue.use(Vuex) should be called only once.'
    );
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

// auto install in dist mode
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    val = namespace + val;
    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      if (namespace && !getModuleByNamespace(this.$store, 'mapMutations', namespace)) {
        return
      }
      return this.$store.commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      if (!(val in this.$store.getters)) {
        console.error(("[vuex] unknown getter: " + val));
        return
      }
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    val = namespace + val;
    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      if (namespace && !getModuleByNamespace(this.$store, 'mapActions', namespace)) {
        return
      }
      return this.$store.dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

function normalizeMap (map) {
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if (!module) {
    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
  }
  return module
}

var index_esm = {
  Store: Store,
  install: install,
  version: '2.3.0',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions
};

/* harmony default export */ __webpack_exports__["a"] = (index_esm);


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return localStorageMixin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return noteMixin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return utilsMixin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return typeCheckMixin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return colorMixin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return objectsMixin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return mathMixin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return dateMixin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return dataURLMixin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return geohashMixin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return appraisalCalcMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_local_storage__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_local_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_local_storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_string_score__ = __webpack_require__(1233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_string_score___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_string_score__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__functions_global_functions__ = __webpack_require__(165);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }







var localStorageMixin = {
    methods: {
        ls_pushUser: function ls_pushUser(user) {
            __WEBPACK_IMPORTED_MODULE_0_local_storage___default.a.set('user', user);
        },
        ls_pullUser: function ls_pullUser() {
            return __WEBPACK_IMPORTED_MODULE_0_local_storage___default.a.get('user');
        },
        ls_logOut: function ls_logOut() {
            return __WEBPACK_IMPORTED_MODULE_0_local_storage___default.a.clear();
        }
    }
};

var noteMixin = {
    methods: {
        createNote: function createNote(id, name) {
            var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
            var dateModified = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : __WEBPACK_IMPORTED_MODULE_1_moment___default()();

            return {
                id: id,
                name: name,
                body: body,
                date_modified: dateModified.toString(),
                date_created: __WEBPACK_IMPORTED_MODULE_1_moment___default()().toString(),
                is_public: false
            };
        },
        findKeyForContactId: function findKeyForContactId(contactId, contacts) {
            return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findKey(contacts, { 'id': contactId });
        },
        findKeyForNoteId: function findKeyForNoteId(noteId, notes) {
            return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findKey(notes, { 'id': noteId });
        },
        nextIdForNotes: function nextIdForNotes(notes) {
            var ids = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(notes, function (note) {
                return note.id;
            });
            return ids.length > 0 ? Math.max.apply(Math, _toConsumableArray(ids)) + 1 : 1;
        },
        filterContactsForQuery: function filterContactsForQuery(query, contacts) {
            return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(contacts, function (contact) {
                var queryLower = query.toLowerCase();
                var nameScore = contact.name.toLowerCase().score(queryLower);
                var bodyScore = contact.body.toLowerCase().score(queryLower);
                contact.score = nameScore + bodyScore;
                return nameScore > 0 || bodyScore > 0;
            });
        },
        filterNotesForQuery: function filterNotesForQuery(query, notes) {
            return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(notes, function (note) {
                var queryLower = query.toLowerCase();
                var nameScore = note.name.toLowerCase().score(queryLower);
                var bodyScore = note.body.toLowerCase().score(queryLower);
                note.score = nameScore + bodyScore;
                return nameScore > 0 || bodyScore > 0;
            });
        },
        sortContacts: function sortContacts(contacts, useScore) {
            var _this = this;

            var now = __WEBPACK_IMPORTED_MODULE_1_moment___default()();
            if (useScore) return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.orderBy(contacts, ['score', function (contact) {
                return _this.secondsFromNow(now, contact.date_modified);
            }], ['desc', 'asc']);else return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.orderBy(contacts, [function (note) {
                return _this.secondsFromNow(now, note.date_modified);
            }], ['asc']);
        },
        sortNotes: function sortNotes(notes, useScore) {
            var _this2 = this;

            var now = __WEBPACK_IMPORTED_MODULE_1_moment___default()();
            if (useScore) return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.orderBy(notes, ['score', function (note) {
                return _this2.secondsFromNow(now, note.date_modified);
            }], ['desc', 'asc']);else return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.orderBy(notes, [function (note) {
                return _this2.secondsFromNow(now, note.date_modified);
            }], ['asc']);
        },
        secondsFromNow: function secondsFromNow(now, dateString) {
            var date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(dateString);
            return now.diff(date, 'seconds');
        }
    }
};

var utilsMixin = {
    methods: {
        selectElement: function selectElement(selector) {
            return document.querySelector('' + selector);
        },
        focusElement: function focusElement(selector) {
            var element = this.selectElement(selector);
            element.focus();
        },
        pad: function pad(num, size) {
            var s = num + '';
            while (s.length < size) {
                s = '0' + s;
            }return s;
        }
    }
};

var typeCheckMixin = {
    methods: {
        check_undefined: function check_undefined(myVar) {
            if (typeof myVar !== 'undefined') {
                return myVar;
            } else {
                return null;
            }
        },
        check_undefined_get_number: function check_undefined_get_number(myVar) {
            if (typeof myVar !== 'undefined') {
                return myVar;
            } else {
                return 0;
            }
        }
    }
};

var colorMixin = {
    methods: {
        getColor: function getColor(value) {
            //value from 0 to 1
            if (isNaN(value)) {
                value = 0.5;
            }
            var hue = ((1 - value) * 120).toString(10);
            return ['hsl(', hue, ',80%,80%)'].join('');
        }
    }
};

var objectsMixin = {
    methods: {
        object_to_array: function object_to_array(object) {
            // console.log('yeah')
            // console.log(object)
            return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(object);
        },
        object_length: function object_length(object) {
            return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.keys(object).length;
        }
    }
};

var mathMixin = {
    methods: {
        roundToTwo: function roundToTwo(num) {
            return +(Math.round(num + 'e+2') + 'e-2');
        },

        calcMax: function calcMax(array) {
            return Math.max.apply(null, array);
        },

        calcMin: function calcMin(array) {
            return Math.min.apply(null, array);
        },

        calcRange: function calcRange(array) {
            return this.this.calcMax(array) - this.calcMin(array);
        },

        calcMidRange: function calcMidRange(array) {
            return this.calcRange(array) / 2;
        },

        calcSum: function calcSum(array) {
            var num = 0;
            for (var i = 0, l = array.length; i < l; i++) {
                num += array[i];
            }return num;
        },

        calcMean: function calcMean(array) {
            return this.calcSum(array) / array.length;
        },

        calcMedian: function calcMedian(array) {
            array.sort(function (a, b) {
                return a - b;
            });
            var mid = array.length / 2;
            return mid % 1 ? array[mid - 0.5] : (array[mid - 1] + array[mid]) / 2;
        },

        calcModes: function calcModes(array) {
            if (!array.length) return [];
            var modeMap = {},
                maxCount = 0,
                modes = [];

            array.forEach(function (val) {
                if (!modeMap[val]) modeMap[val] = 1;else modeMap[val]++;

                if (modeMap[val] > maxCount) {
                    modes = [val];
                    maxCount = modeMap[val];
                } else if (modeMap[val] === maxCount) {
                    modes.push(val);
                    maxCount = modeMap[val];
                }
            });
            return modes;
        },

        calcLetiance: function calcLetiance(array) {
            var mean = this.calcMean(array);
            return this.calcMean(array.map(function (num) {
                return Math.pow(num - mean, 2);
            }));
        },

        calcStandardDeviation: function calcStandardDeviation(array) {
            return Math.sqrt(this.calcLetiance(array));
        },

        calcMeanAbsoluteDeviation: function calcMeanAbsoluteDeviation(array) {
            var mean = this.calcMean(array);
            return this.calcMean(array.map(function (num) {
                return Math.abs(num - mean);
            }));
        },

        calcZScores: function calcZScores(array) {
            var mean = this.calcMean(array);
            var standardDeviation = this.calcStandardDeviation(array);
            return array.map(function (num) {
                return (num - mean) / standardDeviation;
            });
        }
    }
};

var dateMixin = {
    methods: {
        date_to_millis: function date_to_millis(date) {
            return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date, 'YYYY-MM-DD').format('x');
        },
        millis_to_date: function millis_to_date(date_in_milliseconds) {
            return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date_in_milliseconds).format('DD/MM/YYYY');
        },
        millis_to_time: function millis_to_time(date_in_milliseconds) {
            return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date_in_milliseconds).format('DD/MM/YYYY HH:mm:ss');
        }
    }
};

var dataURLMixin = {
    methods: {
        canvasToDataURL: function canvasToDataURL(src, callback, outputFormat) {
            console.log('***** src: ');
            console.log(src);
            var img = new Image();
            img.crossOrigin = 'Anonymous';
            img.onload = function () {
                var canvas = document.createElement('CANVAS');
                var ctx = canvas.getContext('2d');
                var dataURL = void 0;
                canvas.height = this.naturalHeight;
                canvas.width = this.naturalWidth;
                ctx.drawImage(this, 0, 0);
                dataURL = canvas.toDataURL(outputFormat);
                callback(dataURL);
            };
            img.src = src;
            if (img.complete || img.complete === undefined) {
                img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
                img.src = src;
            }
        }
    }
};

var geohashMixin = {
    methods: {
        chunk: __WEBPACK_IMPORTED_MODULE_4__functions_global_functions__["a" /* default */]
    }
};

var appraisalCalcMixin = {
    methods: {
        calcAppraisal: function calcAppraisal(appraisal, market_id, market_value, market_unit_value) {

            //// Paràmetres per defecte de Càlcul Valors Tècnics -------------------------

            appraisal['marketstudy_id'] = market_id;
            appraisal['market_value'] = market_value;
            appraisal['market_unit_value'] = market_unit_value;

            if (!appraisal['market_value_appraiser_adjustment_pct']) {
                // DEFAULT_VALUE
                appraisal['market_value_appraiser_adjustment_pct'] = 100;
            }

            appraisal['adopted_market_value'] = this.roundToTwo(appraisal['market_value'] * (appraisal['market_value_appraiser_adjustment_pct'] / 100));
            appraisal['adopted_market_unit_value'] = this.roundToTwo(appraisal['market_unit_value'] * (appraisal['market_value_appraiser_adjustment_pct'] / 100));

            if (!appraisal['expenses_and_industrial_benefit_bec_pct']) {
                appraisal['expenses_and_industrial_benefit_bec_pct'] = 20;
            }

            if (!appraisal['useful_life_years'] || appraisal['useful_life_years'] === 0) {
                appraisal['useful_life_years'] = 100;
            }

            if (!appraisal['remaining_useful_life_years']) {
                appraisal['remaining_useful_life_years'] = appraisal['useful_life_years'];
            }

            if (!appraisal['construction_year'] && !appraisal['last_renovation_year'] && appraisal['adopted_age']) {
                appraisal['construction_year'] = appraisal['adopted_age'];
                appraisal['last_renovation_year'] = appraisal['adopted_age'];
            } else if (!appraisal['construction_year'] && !appraisal['last_renovation_year'] && !appraisal['adopted_age']) {
                // DEFAULT AGE
                appraisal['construction_year'] = 1970;
                appraisal['last_renovation_year'] = 1970;
                appraisal['adopted_age'] = 1970;
            } else {
                var age_average = Math.floor((appraisal['construction_year'] + appraisal['last_renovation_year']) / 2);
                var _appraisal_year = __WEBPACK_IMPORTED_MODULE_1_moment___default()(appraisal['appraisaldate']).format('YYYY');
                appraisal['adopted_age'] = age_average;
                appraisal['adopted_age_years_old'] = Number(_appraisal_year) - age_average;
            }

            console.log('(appraisal[\'appraisaldate\']: ');
            console.log(appraisal['appraisaldate']);

            var appraisal_year = __WEBPACK_IMPORTED_MODULE_1_moment___default()(appraisal['appraisaldate']).format('YYYY');
            appraisal['adopted_age_years_old'] = appraisal_year - appraisal['adopted_age'];

            appraisal['remaining_useful_life_years'] = appraisal['useful_life_years'] - appraisal['adopted_age_years_old'];
            appraisal['physical_depreciation_pct'] = this.roundToTwo(appraisal['adopted_age_years_old'] / appraisal['useful_life_years'] * 100);

            if (!appraisal['functional_depreciation_pct']) {
                appraisal['functional_depreciation_pct'] = 0;
            }

            appraisal['total_depreciation_pct'] = this.roundToTwo((100 - appraisal['physical_depreciation_pct']) * (100 - appraisal['functional_depreciation_pct']) / 100);

            if (!appraisal['total_construction_progress_pct']) {
                appraisal['total_construction_progress_pct'] = 100;
            } else if (appraisal['total_construction_progress_pct'] < 100) {
                // si l'edifici està en obres la depreciació física ha de ser 0!
                appraisal['physical_depreciation_pct'] = 100;
                appraisal['total_depreciation_pct'] = 100;
            }

            // console.log('physical_depreciation_pct: ')
            // console.log(appraisal['physical_depreciation_pct'])

            // console.log('functional_depreciation_pct: ')
            // console.log(appraisal['functional_depreciation_pct'])

            // console.log('total_depreciation_pct: ')
            // console.log(appraisal['total_depreciation_pct'])

            if (!appraisal['adjusted_bec_price']) {
                // DEFAULT_VALUE
                appraisal['adjusted_bec_price'] = 1200;
            }

            if (!appraisal['material_execution_cost']) {
                // DEFAULT_VALUE
                appraisal['material_execution_cost'] = 1000;
            }

            // ccb: Cost de Construcció a Nou (Cost de Construcció Brut)
            appraisal['ccb'] = appraisal['adjusted_bec_price'];
            console.log('ccb: ');
            appraisal['ccb'];

            if (!appraisal['mec_adjustment_coef']) {
                // DEFAULT_VALUE
                appraisal['mec_adjustment_coef'] = 1;
            }

            if (!appraisal['bc_pct']) {
                // Benefici industrial tipus del constructor
                appraisal['bc_pct'] = 6;
            }

            if (!appraisal['gc_pct']) {
                // Despeses generals del constructor
                appraisal['gc_pct'] = 14;
            }

            if (!appraisal['htl_pct']) {
                // Honoraris facultatius, taxes i llicències
                appraisal['htl_pct'] = 12;
            }

            if (!appraisal['inr_pct']) {
                // Impostos no recuperables
                appraisal['inr_pct'] = 10;
            }

            if (!appraisal['ga_pct']) {
                // Despeses d'administrador del promotor
                appraisal['ga_pct'] = 4;
            }

            if (!appraisal['gpd_pct']) {
                // Despeses de pòlissa decennal
                appraisal['gpd_pct'] = 0.65;
            }

            if (!appraisal['oct_pct']) {
                // OCT
                appraisal['oct_pct'] = 1.35;
            }

            // Despeses de promoció
            appraisal['gp_pct'] = appraisal['htl_pct'] + appraisal['inr_pct'] + appraisal['ga_pct'] + appraisal['gpd_pct'] + appraisal['oct_pct'];

            if (!appraisal['tlr_pct']) {
                // Taxa lliure de risc (Rendibilitat mitjana anual del deute de l'estat a un termini no inferior a 2 anys)
                appraisal['tlr_pct'] = 4;
            }

            //// Prima de risc segons EHA/3011/2007
            // Habitatges primera residència --> 8%
            // Habitatges segona residència --> 12%
            // Edificis d'oficines --> 10%
            // Edificis comercials --> 12%
            // Edificis industrials --> 14%
            // Places d'aparcament --> 9%
            // Hotels --> 11%
            // Residències estudiants i 3ª edat --> 12%
            // Altres --> 12%

            if (!appraisal['pr_pct']) {
                // Prima de risc
                appraisal['pr_pct'] = 8;
            }

            if (appraisal['property_type'].name_es === 'Piso') {
                appraisal['pr_pct'] = 8;
            } else if (appraisal['property_type'].name_es === 'Ático') {
                appraisal['pr_pct'] = 8;
            } else if (appraisal['property_type'].name_es === 'Sobreático') {
                appraisal['pr_pct'] = 8;
            } else if (appraisal['property_type'].name_es === 'Bajos') {
                appraisal['pr_pct'] = 8;
            } else if (appraisal['property_type'].name_es === 'Apartamento') {
                appraisal['pr_pct'] = 8;
            } else if (appraisal['property_type'].name_es === 'Loft') {
                appraisal['pr_pct'] = 8;
            } else if (appraisal['property_type'].name_es === 'Estudio') {
                appraisal['pr_pct'] = 8;
            } else if (appraisal['property_type'].name_es === 'Dúplex') {
                appraisal['pr_pct'] = 8;
            } else if (appraisal['property_type'].name_es === 'Triplex') {
                appraisal['pr_pct'] = 8;
            } else if (appraisal['property_type'].name_es === 'Plaza de aparcamiento') {
                appraisal['pr_pct'] = 9;
            } else if (appraisal['property_type'].name_es === 'Garaje') {
                appraisal['pr_pct'] = 9;
            } else if (appraisal['property_type'].name_es === 'Casa adosada') {
                appraisal['pr_pct'] = 8;
            } else if (appraisal['property_type'].name_es === 'Casa independiente') {
                appraisal['pr_pct'] = 8;
            } else if (appraisal['property_type'].name_es === 'Finca rústica') {
                appraisal['pr_pct'] = 8;
            } else if (appraisal['property_type'].name_es === 'Masía') {
                appraisal['pr_pct'] = 8;
            } else if (appraisal['property_type'].name_es === 'Piscina') {
                appraisal['pr_pct'] = 12;
            } else if (appraisal['property_type'].name_es === 'Trastero') {
                appraisal['pr_pct'] = 12;
            } else if (appraisal['property_type'].name_es === 'Pista deportiva') {
                appraisal['pr_pct'] = 12;
            } else if (appraisal['property_type'].name_es === 'Club deportivo') {
                appraisal['pr_pct'] = 12;
            } else if (appraisal['property_type'].name_es === 'Local con acceso directo') {
                appraisal['pr_pct'] = 12;
            } else if (appraisal['property_type'].name_es === 'Local sin acceso directo') {
                appraisal['pr_pct'] = 12;
            } else if (appraisal['property_type'].name_es === 'Nave industrial') {
                appraisal['pr_pct'] = 14;
            } else if (appraisal['property_type'].name_es === 'Escuela') {
                appraisal['pr_pct'] = 12;
            } else if (appraisal['property_type'].name_es === 'Hotel') {
                appraisal['pr_pct'] = 11;
            } else {
                appraisal['pr_pct'] = 12;
            }

            if (!appraisal['am_coef']) {
                //Coeficient d'agreujament o millora
                appraisal['am_coef'] = 1.5;
            }

            ////Benefici mínim segons la norma (ATASA)
            // Habitatges primera residència --> 18%
            // Habitatges segona residència --> 24%
            // Edificis d'oficines --> 21%
            // Edificis comercials --> 24%
            // Edificis industrials --> 27%
            // Places d'aparcament --> 20%
            // Hotels --> 22%
            // Residències estudiants i 3ª edat --> 24%
            // Altres --> 24%

            if (!appraisal['b2_pct']) {
                // Benefici mercat lliure 2
                appraisal['b2_pct'] = 18;
            }

            if (appraisal['property_type'].name_es === 'Piso') {
                appraisal['b2_pct'] = 18;
            } else if (appraisal['property_type'].name_es === 'Ático') {
                appraisal['b2_pct'] = 18;
            } else if (appraisal['property_type'].name_es === 'Sobreático') {
                appraisal['b2_pct'] = 18;
            } else if (appraisal['property_type'].name_es === 'Bajos') {
                appraisal['b2_pct'] = 18;
            } else if (appraisal['property_type'].name_es === 'Apartamento') {
                appraisal['b2_pct'] = 18;
            } else if (appraisal['property_type'].name_es === 'Loft') {
                appraisal['b2_pct'] = 18;
            } else if (appraisal['property_type'].name_es === 'Estudio') {
                appraisal['b2_pct'] = 18;
            } else if (appraisal['property_type'].name_es === 'Dúplex') {
                appraisal['b2_pct'] = 18;
            } else if (appraisal['property_type'].name_es === 'Triplex') {
                appraisal['b2_pct'] = 18;
            } else if (appraisal['property_type'].name_es === 'Plaza de aparcamiento') {
                appraisal['b2_pct'] = 20;
            } else if (appraisal['property_type'].name_es === 'Garaje') {
                appraisal['b2_pct'] = 20;
            } else if (appraisal['property_type'].name_es === 'Casa adosada') {
                appraisal['b2_pct'] = 18;
            } else if (appraisal['property_type'].name_es === 'Casa independiente') {
                appraisal['b2_pct'] = 18;
            } else if (appraisal['property_type'].name_es === 'Finca rústica') {
                appraisal['b2_pct'] = 18;
            } else if (appraisal['property_type'].name_es === 'Masía') {
                appraisal['b2_pct'] = 18;
            } else if (appraisal['property_type'].name_es === 'Piscina') {
                appraisal['b2_pct'] = 24;
            } else if (appraisal['property_type'].name_es === 'Trastero') {
                appraisal['b2_pct'] = 24;
            } else if (appraisal['property_type'].name_es === 'Pista deportiva') {
                appraisal['b2_pct'] = 24;
            } else if (appraisal['property_type'].name_es === 'Club deportivo') {
                appraisal['b2_pct'] = 24;
            } else if (appraisal['property_type'].name_es === 'Local con acceso directo') {
                appraisal['b2_pct'] = 24;
            } else if (appraisal['property_type'].name_es === 'Local sin acceso directo') {
                appraisal['b2_pct'] = 24;
            } else if (appraisal['property_type'].name_es === 'Nave industrial') {
                appraisal['b2_pct'] = 27;
            } else if (appraisal['property_type'].name_es === 'Escuela') {
                appraisal['b2_pct'] = 24;
            } else if (appraisal['property_type'].name_es === 'Hotel') {
                appraisal['b2_pct'] = 22;
            } else {
                appraisal['b2_pct'] = 24;
            }

            if (!appraisal['landlord_expenses_pct']) {
                //Despeses del llogater (sobre la renda bruta, per a calcular la renda neta del lloguer)
                appraisal['landlord_expenses_pct'] = 70;
            }

            // Tipus d'actualització (i)
            // Habitatges primera residència --> 4.5 %
            // Habitatges segona residència --> 4.5 %
            // Edificis d'oficines --> 7.5 %
            // Edificis comercials --> 5.5 %
            // Edificis industrials --> 7 %
            // Places d'aparcament --> 9 %
            // Hotels --> 6 %
            // Residències estudiants i 3ª edat --> 4 %
            // Altres --> 8 %

            if (!appraisal['i_pct']) {
                // Tipus d'actualització
                appraisal['i_pct'] = 4.5;

                if (appraisal['property_type'].name_es === 'Piso') {
                    appraisal['i_pct'] = 4.5;
                } else if (appraisal['property_type'].name_es === 'Ático') {
                    appraisal['i_pct'] = 4.5;
                } else if (appraisal['property_type'].name_es === 'Sobreático') {
                    appraisal['i_pct'] = 4.5;
                } else if (appraisal['property_type'].name_es === 'Bajos') {
                    appraisal['i_pct'] = 4.5;
                } else if (appraisal['property_type'].name_es === 'Apartamento') {
                    appraisal['i_pct'] = 4.5;
                } else if (appraisal['property_type'].name_es === 'Loft') {
                    appraisal['i_pct'] = 4.5;
                } else if (appraisal['property_type'].name_es === 'Estudio') {
                    appraisal['i_pct'] = 4.5;
                } else if (appraisal['property_type'].name_es === 'Dúplex') {
                    appraisal['i_pct'] = 4.5;
                } else if (appraisal['property_type'].name_es === 'Triplex') {
                    appraisal['i_pct'] = 4.5;
                } else if (appraisal['property_type'].name_es === 'Plaza de aparcamiento') {
                    appraisal['i_pct'] = 9;
                } else if (appraisal['property_type'].name_es === 'Garaje') {
                    appraisal['i_pct'] = 9;
                } else if (appraisal['property_type'].name_es === 'Casa adosada') {
                    appraisal['i_pct'] = 4.5;
                } else if (appraisal['property_type'].name_es === 'Casa independiente') {
                    appraisal['i_pct'] = 4.5;
                } else if (appraisal['property_type'].name_es === 'Finca rústica') {
                    appraisal['i_pct'] = 4.5;
                } else if (appraisal['property_type'].name_es === 'Masía') {
                    appraisal['i_pct'] = 4.5;
                } else if (appraisal['property_type'].name_es === 'Piscina') {
                    appraisal['i_pct'] = 8;
                } else if (appraisal['property_type'].name_es === 'Trastero') {
                    appraisal['i_pct'] = 8;
                } else if (appraisal['property_type'].name_es === 'Pista deportiva') {
                    appraisal['i_pct'] = 8;
                } else if (appraisal['property_type'].name_es === 'Club deportivo') {
                    appraisal['i_pct'] = 8;
                } else if (appraisal['property_type'].name_es === 'Local con acceso directo') {
                    appraisal['i_pct'] = 5.5;
                } else if (appraisal['property_type'].name_es === 'Local sin acceso directo') {
                    appraisal['i_pct'] = 5.5;
                } else if (appraisal['property_type'].name_es === 'Nave industrial') {
                    appraisal['i_pct'] = 7;
                } else if (appraisal['property_type'].name_es === 'Escuela') {
                    appraisal['i_pct'] = 8;
                } else if (appraisal['property_type'].name_es === 'Hotel') {
                    appraisal['i_pct'] = 6;
                } else {
                    appraisal['i_pct'] = 4.5;
                }
            }

            if (!appraisal['reduction_pct']) {
                // Coeficient de reducció
                appraisal['reduction_pct'] = 0;
            }

            if (!appraisal['tenant_life_expectancy_years']) {
                appraisal['tenant_life_expectancy_years'] = 80;
            }

            if (!appraisal['tenant_age_years']) {
                // Coeficient de reducció
                appraisal['tenant_age_years'] = 35;
            }

            if (!appraisal['usufructuary_age_years']) {
                // Coeficient de reducció
                appraisal['usufructuary_age_years'] = 35;
            }

            if (!appraisal['cession_contract_remaining_years']) {
                appraisal['cession_contract_remaining_years'] = 0;
            }

            if (!appraisal['cession_gross_monthly_income']) {
                appraisal['cession_gross_monthly_income'] = 0;
            }

            if (!appraisal['max_legal_price']) {
                appraisal['max_legal_price'] = 0;
            }

            if (!appraisal['max_legal_area']) {
                appraisal['max_legal_area'] = 0;
            }

            appraisal['adopted_material_execution_cost'] = this.roundToTwo(appraisal['material_execution_cost'] * appraisal['mec_adjustment_coef']);
            console.log('adopted_material_execution_cost: ');
            console.log(appraisal['adopted_material_execution_cost']);

            appraisal['deprecated_material_execution_cost'] = this.roundToTwo(appraisal['adopted_material_execution_cost'] * (appraisal['total_depreciation_pct'] / 100));
            console.log('deprecated_material_execution_cost: ');
            console.log(appraisal['deprecated_material_execution_cost']);

            appraisal['bc_and_gc_pct'] = appraisal['bc_pct'] + appraisal['gc_pct'];
            console.log('bc_and_gc_pct');
            console.log(appraisal['bc_and_gc_pct']);

            appraisal['cc_pct'] = 100 + appraisal['bc_and_gc_pct'];
            console.log('cc_pct: ');
            console.log(appraisal['cc_pct']);

            appraisal['b1_pct'] = this.roundToTwo((appraisal['tlr_pct'] + appraisal['pr_pct']) / 100 * appraisal['am_coef'] * 100);
            console.log('b1_pct: ');
            console.log(appraisal['b1_pct']);

            //Benefici del promotor: el màxim entre b1 i b2
            appraisal['b_pct'] = Math.max(appraisal['b1_pct'], appraisal['b2_pct']);
            console.log('b_pct: ');
            console.log(appraisal['b_pct']);

            appraisal['b_remaining_pct'] = 100 - appraisal['b_pct'];
            console.log('\'b_remaining_pct\': ');
            console.log(appraisal['b_remaining_pct']);

            // console.log('tenant_life_expectancy: ' + appraisal['tenant_life_expectancy_years'])
            // console.log('tenant_age_years: ' + appraisal['tenant_age_years'])
            appraisal['tenant_remaining_life_expectancy_years'] = appraisal['tenant_life_expectancy_years'] - appraisal['tenant_age_years'];
            // console.log('tenant_remaining_life_expectancy_years: ' + appraisal['tenant_remaining_life_expectancy_years'])
            console.log('tenant_remaining_life_expectancy_years: ');
            console.log(appraisal['tenant_remaining_life_expectancy_years']);

            // console.log('reduction_pct: '+ appraisal['reduction_pct'])
            appraisal['adjustment_coef'] = 1 + this.roundToTwo(appraisal['reduction_pct'] / 100);
            console.log('adjustment_coef: ' + appraisal['adjustment_coef']);

            //Benefici industrial tipus del constructor
            appraisal['bc'] = this.roundToTwo(appraisal['deprecated_material_execution_cost'] * (appraisal['bc_pct'] / 100));
            console.log('bc: ');
            console.log(appraisal['bc']);

            //Despeses generals del constructor
            appraisal['gc'] = this.roundToTwo(appraisal['deprecated_material_execution_cost'] * (appraisal['gc_pct'] / 100));
            console.log('gc: ');
            console.log(appraisal['gc']);

            appraisal['bc_and_gc'] = appraisal['bc'] + appraisal['gc'];
            console.log('bc_and_gc: ');
            console.log(appraisal['bc_and_gc']);

            //Costos de construcció
            appraisal['cc'] = this.roundToTwo(appraisal['deprecated_material_execution_cost'] * (appraisal['cc_pct'] / 100));
            console.log('cc: ');
            console.log(appraisal['cc']);

            //Honoraris facultatius, taxes i llicències
            appraisal['htl'] = this.roundToTwo(appraisal['cc'] * (appraisal['htl_pct'] / 100));
            console.log('htl: ');
            console.log(appraisal['htl']);

            //Impostos no recuperables
            appraisal['inr'] = this.roundToTwo(appraisal['cc'] * (appraisal['inr_pct'] / 100));
            console.log('inr: ');
            console.log(appraisal['inr']);

            //Despeses d'administrador del promotor
            appraisal['ga'] = this.roundToTwo(appraisal['cc'] * (appraisal['ga_pct'] / 100));
            console.log('ga: ');
            console.log(appraisal['ga']);

            //Despeses de pòlissa decennal
            appraisal['gpd'] = this.roundToTwo(appraisal['cc'] * (appraisal['gpd_pct'] / 100));
            console.log('gpd: ');
            console.log(appraisal['gpd']);

            //OCT
            appraisal['oct'] = this.roundToTwo(appraisal['cc'] * (appraisal['oct_pct'] / 100));
            console.log('oct: ');
            console.log(appraisal['oct']);

            //Despeses de promoció net ( és a dir, sobre const de construcció depreciat per antiguitat)
            appraisal['gp'] = this.roundToTwo(appraisal['cc'] * (appraisal['gp_pct'] / 100));
            console.log('gp: ');
            console.log(appraisal['gp']);

            //Despeses de promoció brut (sobre cost de construcció a nou)
            appraisal['gpb'] = this.roundToTwo(appraisal['ccb'] * (appraisal['gp_pct'] / 100));
            console.log('gpb: ');
            console.log(appraisal['gpb']);

            //Costos de reposició de la construcció
            appraisal['cc_and_gp'] = appraisal['cc'] + appraisal['gp'];
            console.log('cc_and_gp: ');
            console.log(appraisal['cc_and_gp']);

            //Costos de reposició de la construcció
            appraisal['ccb_and_gpb'] = appraisal['ccb'] + appraisal['gpb'];
            console.log('ccb_and_gpb: ');
            console.log(appraisal['ccb_and_gpb']);

            //Valor del sòl
            appraisal['f'] = this.roundToTwo(appraisal['adopted_market_unit_value'] * (1 - appraisal['b_pct'] / 100) - (appraisal['cc'] + appraisal['gp']));
            if (appraisal['f'] < 0) {
                //alert('Revisar dades: el valor del sòl dóna negatiu amb les dades actuals. S\'ha establert a 0 per evitar errors de càlcul a l\'aplicació')
                appraisal['f'] = 0;
            }
            console.log('f: ');
            console.log(appraisal['f']);

            // Cost de Reemplaçament-reposició Brut (CRB)
            appraisal['crb'] = appraisal['f'] + appraisal['ccb'] + appraisal['gpb'];
            console.log('crb: ');
            console.log(appraisal['crb']);

            //Cost de construcció depreciat (incloses despes de promoció)
            appraisal['ccd'] = this.roundToTwo((appraisal['ccb'] + appraisal['gpb']) * (appraisal['total_depreciation_pct'] / 100));
            console.log('ccd: ');
            console.log(appraisal['ccd']);

            //********* Cost de Reemplaçament-reposició Net (CRN) en Immoble Acabat
            // var crn_immoble_acabat = (f + (ccd * (depreciacio_total_pct / 100))) * ((100 + ga_pct) / 100);
            // Sòl més cost de construcció depreciat
            appraisal['deprecated_land_and_ccd'] = appraisal['f'] + appraisal['ccd'];
            appraisal['finished_realestate_crn'] = this.roundToTwo(appraisal['deprecated_land_and_ccd'] * ((100 + appraisal['ga_pct']) / 100));
            console.log('deprecated_land_and_ccd: ');
            console.log(appraisal['deprecated_land_and_ccd']);
            console.log('finished_realestate_crn');
            console.log(appraisal['finished_realestate_crn']);

            //********** Cost de Reemplaçament-reposició Net (CRN) en Immoble en Construcció
            //OJO PUFO CORRECTE PERO REVISAR AL FER EDIFICIS EN CONSTRUCCIÓ

            //Cost de construcció realitzada
            appraisal['ccr'] = this.roundToTwo((appraisal['ccb'] + appraisal['gpb']) * (appraisal['total_construction_progress_pct'] / 100));
            appraisal['executed_construction_cost'] = appraisal['f'] + appraisal['ccr'];
            appraisal['gar'] = (appraisal['f'] + appraisal['ccr']) * (appraisal['ga_pct'] / 100);
            appraisal['under_construction_realestate_crn'] = this.roundToTwo(appraisal['executed_construction_cost'] * ((100 + appraisal['ga_pct']) / 100));
            console.log('ccr: ');
            console.log(appraisal['ccr']);
            console.log('executed_construction_cost: ');
            console.log(appraisal['executed_construction_cost']);
            console.log('under_construction_realestate_crn: ');
            console.log(appraisal['under_construction_realestate_crn']);

            // Coeficient de mercat
            appraisal['k'] = this.roundToTwo(appraisal['adopted_market_unit_value'] / appraisal['finished_realestate_crn']);
            console.log('k: ');
            console.log(appraisal['k']);

            //////// VALORS TOTALS

            // Valor total del sòl (mètode de repercussió)
            appraisal['repercussion_method_land_value'] = this.roundToTwo(appraisal['adopted_area'] * this.roundToTwo(appraisal['f']));
            console.log('repercussion_method_land_value: ');
            console.log(appraisal['repercussion_method_land_value']);

            // Valor de la construccio, mètode del cost, CRB (no inclou el terreny)
            appraisal['cost_method_construction_crb_value'] = this.roundToTwo(appraisal['adopted_area'] * this.roundToTwo(appraisal['ccb_and_gpb']));
            console.log('cost_method_construction_crb_value: ');
            console.log(appraisal['cost_method_construction_crb_value']);

            // Valor de la construccio, mètode del cost, CRN (no inclou el terreny)
            appraisal['cost_method_construction_crn_value'] = this.roundToTwo(appraisal['adopted_area'] * this.roundToTwo(appraisal['ccd']));
            console.log('cost_method_construction_crn_value: ');
            console.log(appraisal['cost_method_construction_crn_value']);

            // Valor de l'immoble, mètode del cost, CRB (construcció + sòl)
            appraisal['cost_method_realestate_crb_value'] = this.roundToTwo(appraisal['adopted_area'] * this.roundToTwo(appraisal['crb']));
            console.log('cost_method_realestate_crb_value: ');
            console.log(appraisal['cost_method_realestate_crb_value']);

            // Valor de l'immoble acabat, mètode del cost, CRN (construcció + sòl)
            appraisal['cost_method_realestate_crn_value'] = this.roundToTwo(appraisal['adopted_area'] * this.roundToTwo(appraisal['finished_realestate_crn']));
            console.log('cost_method_realestate_crn_value: ');
            console.log(appraisal['cost_method_realestate_crn_value']);

            // Valor de l'immoble en construcció, mètode del cost, CRN (construcció + sòl)
            appraisal['cost_method_unfinished_realestate_crn_value'] = this.roundToTwo(appraisal['adopted_area'] * this.roundToTwo(appraisal['under_construction_realestate_crn']));
            console.log('cost_method_unfinished_realestate_crn_value: ');
            console.log(appraisal['cost_method_unfinished_realestate_crn_value']);

            if ('cost_method_unfinished_realestate_crn_value')

                // Valor de mercat l'immoble, mètode de comparació
                appraisal['comparison_method'] = this.roundToTwo(appraisal['adopted_area'] * this.roundToTwo(appraisal['adopted_market_unit_value']));
            console.log('comparison_method: ');
            console.log(appraisal['comparison_method']);

            // Valor de mercat ajustat
            console.log('adjustment_coef: ' + appraisal['adjustment_coef']);
            appraisal['adjusted_market_value'] = this.roundToTwo(appraisal['comparison_method'] * appraisal['adjustment_coef']);
            console.log('adjusted_market_value: ');
            console.log(appraisal['adjusted_market_value']);

            //Mètode màxim legal
            appraisal['max_legal_method'] = 0;
            if (appraisal['protection_boolean']) {
                appraisal['max_legal_method'] = this.roundToTwo(appraisal['max_legal_area'] * this.roundToTwo(appraisal['max_legal_price']));
            }

            console.log('max_legal_method: ');
            console.log(appraisal['max_legal_method']);

            ////// Mètode actualització de renda (Actualitzacio a perpetuïtat)
            appraisal['cession_gross_yearly_income'] = this.roundToTwo(appraisal['cession_gross_monthly_income'] * 12);
            appraisal['cession_net_yearly_income'] = this.roundToTwo(appraisal['cession_gross_monthly_income'] * 12 * (appraisal['landlord_expenses_pct'] / 100));
            appraisal['vc'] = this.roundToTwo(appraisal['cession_net_yearly_income'] / (appraisal['i_pct'] / 100));
            appraisal['income_perpetuity_update_method'] = appraisal['vc'];

            console.log('cession_gross_yearly_income: ');
            console.log(appraisal['cession_gross_yearly_income: ']);
            console.log('cession_net_yearly_income: ');
            console.log(appraisal['cession_net_yearly_income']);
            console.log('i_pct: ');
            console.log(appraisal['i_pct']);
            console.log('vc: ');
            console.log(appraisal['vc']);
            console.log('income_perpetuity_update_method: ');
            console.log(appraisal['income_perpetuity_update_method']);
            ////// Mètode actualització de rendes esperades
            /// Càlcul de la vida útil
            // Durada restant previsible del contracte (mínim de n1, n2 i n3)

            console.log('cession_contract_remaining_years: ' + appraisal['cession_contract_remaining_years']);
            console.log('remaining_useful_life_years: ' + appraisal['remaining_useful_life_years']);
            console.log('tenant_remaining_life_expectancy_years: ' + appraisal['tenant_remaining_life_expectancy_years']);

            var arr_times = [];
            arr_times.push(appraisal['cession_contract_remaining_years']);
            arr_times.push(appraisal['remaining_useful_life_years']);
            arr_times.push(appraisal['tenant_remaining_life_expectancy_years']);
            appraisal['u'] = Math.min.apply(null, arr_times);

            console.log('u: ' + appraisal['u']);

            /// Càlcul del valor residual de l'immoble
            // cost de reposició per contracta -> metode_cost_valor_construccio_crb
            appraisal['residual_depreciation_pct'] = this.roundToTwo(appraisal['u'] / appraisal['useful_life_years']);
            appraisal['residual_depreciation'] = this.roundToTwo(-1 * appraisal['cost_method_construction_crb_value'] * appraisal['residual_depreciation_pct']);
            // Valor residual de l'immoble al final de la vida útil del contracte
            appraisal['realestate_residual_value'] = this.roundToTwo(appraisal['comparison_method'] + appraisal['residual_depreciation']);

            console.log('residual_depreciation_pct: ');
            console.log(appraisal['residual_depreciation_pct']);
            console.log('residual_depreciation: ');
            console.log(appraisal['residual_depreciation']);
            console.log('realestate_residual_value: ');
            console.log(appraisal['realestate_residual_value']);

            /// Càlcul del valor actual de les rendes futures (A)
            appraisal['i'] = appraisal['i_pct'] / 100;
            appraisal['np'] = appraisal['u'];
            // Coef. 1 = [(1 + i) ^ n - 1] / [(1 + i) ^ n * i]
            appraisal['coef_1'] = this.roundToTwo((Math.pow(1 + appraisal['i'], appraisal['np']) - 1) / (Math.pow(1 + appraisal['i'], appraisal['np']) * appraisal['i']));
            appraisal['current_future_income_value'] = this.roundToTwo(appraisal['cession_net_yearly_income'] * appraisal['coef_1']);

            console.log('i: ');
            console.log(appraisal['i']);

            console.log('np: ');
            console.log(appraisal['np']);
            console.log('coef_1: ');
            console.log(appraisal['coef_1']);
            console.log('current_future_income_value: ');
            console.log(appraisal['current_future_income_value']);

            /// Càlcul del valor actual del valor de reversió (B)
            appraisal['coef_2'] = this.roundToTwo(Math.pow(1 + appraisal['i'], appraisal['np']));
            appraisal['updated_reversion_value'] = this.roundToTwo(appraisal['realestate_residual_value'] / appraisal['coef_2']);
            console.log('coef_2: ');
            console.log(appraisal['coef_2']);
            console.log('updated_reversion_value');
            console.log(appraisal['updated_reversion_value']);

            ///Càlcul del VALOR PER ACTUALITZACIÓ (A+B)
            appraisal['update_value'] = appraisal['current_future_income_value'] + appraisal['updated_reversion_value'];

            console.log('update_value: ');
            console.log(appraisal['update_value']);

            console.log('\'insurance_value\': ');
            console.log(appraisal['insurance_value']);

            // Valor de taxació adoptat per a l'element
            appraisal['realestate_total_adopted_value'] = 0;
            appraisal['realestate_adopted_appraisal_method'] = '';

            var crn_under_construction_method_obj = {
                id: 6,
                'bde_code': 'A01',
                'name_ca': 'Cost de Reemplaçament-reposició Net (immoble en construcció)',
                'name_en': 'Net Replacement Cost (building under construction)',
                'name_es': 'Coste de Reposición Neto (inmueble en construcción)'
            };

            var max_legal_method_obj = {
                id: 5,
                'bde_code': 'A12',
                'name_ca': 'Mètode Màxim Legal',
                'name_en': 'Maximum Legal Method',
                'name_es': 'Método Máximo Legal'
            };

            var perpetuity_income_update_method_obj = {
                id: 4,
                'bde_code': 'A09',
                'name_ca': 'Mètode Actualització de Renda a Perpetuïtat',
                'name_en': 'Perpetuity Income Update Method',
                'name_es': 'Método Actualización de Renta a Perpetuidad'
            };

            var expected_income_update_method_obj = {
                id: 3,
                'bde_code': 'A09',
                'name_ca': 'Mètode Actualització de Renda Esperada',
                'name_en': 'Expected Income Update Method',
                'name_es': 'Método Actualización de Renta Esperada'
            };

            var adjusted_comparison_method_obj = {
                id: 2,
                'bde_code': 'A06',
                'name_ca': 'Mètode de Comparació Ajustat',
                'name_en': 'Adjusted Comparison Method',
                'name_es': 'Método de Comparación Ajustado'
            };

            var comparison_method_obj = {
                id: 1,
                'bde_code': 'A06',
                'name_ca': 'Mètode de Comparació',
                'name_en': 'Comparison Method',
                'name_es': 'Método de Comparación'
            };

            if (appraisal['protection_boolean']) {

                if (appraisal['max_legal_method'] <= appraisal['adjusted_market_value']) {

                    if (appraisal['cession_boolean']) {

                        if (appraisal['update_value'] < appraisal['max_legal_method']) {

                            appraisal['realestate_total_adopted_value'] = appraisal['update_value'];
                            appraisal['realestate_adopted_appraisal_method'] = expected_income_update_method_obj;
                        } else if (appraisal['update_value'] >= appraisal['max_legal_method']) {

                            appraisal['realestate_total_adopted_value'] = appraisal['max_legal_method'];
                            appraisal['realestate_adopted_appraisal_method'] = max_legal_method_obj;
                        }

                        /*
                        // apliquem sempre el mateix mètode
                        if (appraisal['tenant_remaining_life_expectancy_years'] <= appraisal['cession_contract_remaining_years']) {
                             if (appraisal['income_perpetuity_update_method'] < appraisal['max_legal_method']) {
                                 appraisal['realestate_total_adopted_value'] = appraisal['income_perpetuity_update_method']
                                appraisal['realestate_adopted_appraisal_method'] = perpetuity_income_update_method_obj
                             } else if (appraisal['update_value'] >= appraisal['max_legal_method']) {
                                 appraisal['realestate_total_adopted_value'] = appraisal['max_legal_method']
                                appraisal['realestate_adopted_appraisal_method'] = max_legal_method_obj
                             }
                         } else if (appraisal['tenant_remaining_life_expectancy_years'] > appraisal['cession_contract_remaining_years']) {
                             if (appraisal['update_value'] < appraisal['max_legal_method']) {
                                 appraisal['realestate_total_adopted_value'] = appraisal['update_value']
                                appraisal['realestate_adopted_appraisal_method'] = expected_income_update_method_obj
                             } else if (appraisal['update_value'] >= appraisal['max_legal_method']) {
                                 appraisal['realestate_total_adopted_value'] = appraisal['max_legal_method']
                                appraisal['realestate_adopted_appraisal_method'] = max_legal_method_obj
                             }
                         }
                        */
                    } else {

                        appraisal['realestate_total_adopted_value'] = appraisal['max_legal_method'];
                        appraisal['realestate_adopted_appraisal_method'] = max_legal_method_obj;

                        if (appraisal['total_construction_progress_pct'] < 100) {
                            if (appraisal['cost_method_unfinished_realestate_crn_value'] < appraisal['max_legal_method']) {
                                appraisal['realestate_total_adopted_value'] = appraisal['cost_method_unfinished_realestate_crn_value'];
                                appraisal['realestate_adopted_appraisal_method'] = crn_under_construction_method_obj;
                            }
                        }
                    }
                } else if (appraisal['max_legal_method'] > appraisal['adjusted_market_value']) {

                    if (appraisal['cession_boolean']) {

                        if (appraisal['tenant_remaining_life_expectancy_years'] <= appraisal['u']) {

                            if (appraisal['income_perpetuity_update_method'] <= appraisal['adjusted_market_value']) {

                                // appraisal['realestate_total_adopted_value'] = appraisal['income_perpetuity_update_method']
                                // appraisal['realestate_adopted_appraisal_method'] = perpetuity_income_update_method_obj

                                appraisal['realestate_total_adopted_value'] = appraisal['update_value'];
                                appraisal['realestate_adopted_appraisal_method'] = expected_income_update_method_obj;
                            } else if (appraisal['update_value'] > appraisal['adjusted_market_value']) {

                                appraisal['realestate_total_adopted_value'] = appraisal['adjusted_market_value'];
                                appraisal['realestate_adopted_appraisal_method'] = adjusted_comparison_method_obj;
                                if (appraisal['reduction_pct'] >= 0) {
                                    appraisal['realestate_adopted_appraisal_method'] = comparison_method_obj;
                                }
                            }
                        } else if (appraisal['tenant_remaining_life_expectancy_years'] > appraisal['u']) {

                            if (appraisal['update_value'] <= appraisal['adjusted_market_value']) {

                                appraisal['realestate_total_adopted_value'] = appraisal['update_value'];
                                appraisal['realestate_adopted_appraisal_method'] = expected_income_update_method_obj;
                            } else if (appraisal['update_value'] > appraisal['adjusted_market_value']) {

                                appraisal['realestate_total_adopted_value'] = appraisal['adjusted_market_value'];
                                appraisal['realestate_adopted_appraisal_method'] = adjusted_comparison_method_obj;
                                if (appraisal['reduction_pct'] >= 0) {
                                    appraisal['realestate_adopted_appraisal_method'] = comparison_method_obj;
                                }
                            }
                        }
                    } else {

                        appraisal['realestate_total_adopted_value'] = appraisal['adjusted_market_value'];
                        appraisal['realestate_adopted_appraisal_method'] = adjusted_comparison_method_obj;
                        if (appraisal['reduction_pct'] >= 0) {
                            appraisal['realestate_adopted_appraisal_method'] = comparison_method_obj;
                        }

                        if (appraisal['total_construction_progress_pct'] < 100) {
                            if (appraisal['cost_method_unfinished_realestate_crn_value'] < appraisal['adjusted_market_value']) {
                                appraisal['realestate_total_adopted_value'] = appraisal['cost_method_unfinished_realestate_crn_value'];
                                appraisal['realestate_adopted_appraisal_method'] = crn_under_construction_method_obj;
                            }
                        }
                    }
                }
            } else {

                if (appraisal['cession_boolean']) {

                    if (appraisal['tenant_remaining_life_expectancy_years'] <= appraisal['u']) {

                        if (appraisal['income_perpetuity_update_method'] <= appraisal['adjusted_market_value']) {

                            // appraisal['realestate_total_adopted_value'] = appraisal['income_perpetuity_update_method']
                            // appraisal['realestate_adopted_appraisal_method'] = perpetuity_income_update_method_obj
                            appraisal['realestate_total_adopted_value'] = appraisal['update_value'];
                            appraisal['realestate_adopted_appraisal_method'] = expected_income_update_method_obj;
                        } else if (appraisal['update_value'] > appraisal['adjusted_market_value']) {

                            appraisal['realestate_total_adopted_value'] = appraisal['adjusted_market_value'];
                            appraisal['realestate_adopted_appraisal_method'] = adjusted_comparison_method_obj;
                            if (appraisal['reduction_pct'] >= 0) {
                                appraisal['realestate_adopted_appraisal_method'] = comparison_method_obj;
                            }
                        }
                    } else if (appraisal['tenant_remaining_life_expectancy_years'] > appraisal['u']) {

                        if (appraisal['update_value'] <= appraisal['adjusted_market_value']) {

                            appraisal['realestate_total_adopted_value'] = appraisal['update_value'];
                            appraisal['realestate_adopted_appraisal_method'] = expected_income_update_method_obj;
                        } else if (appraisal['update_value'] > appraisal['adjusted_market_value']) {

                            appraisal['realestate_total_adopted_value'] = appraisal['adjusted_market_value'];
                            appraisal['realestate_adopted_appraisal_method'] = adjusted_comparison_method_obj;
                            if (appraisal['reduction_pct'] >= 0) {
                                appraisal['realestate_adopted_appraisal_method'] = comparison_method_obj;
                            }
                        }
                    }
                } else {

                    appraisal['realestate_total_adopted_value'] = appraisal['adjusted_market_value'];
                    appraisal['realestate_adopted_appraisal_method'] = adjusted_comparison_method_obj;
                    if (appraisal['reduction_pct'] >= 0) {
                        appraisal['realestate_adopted_appraisal_method'] = comparison_method_obj;
                    }

                    if (appraisal['total_construction_progress_pct'] < 100) {
                        if (appraisal['cost_method_unfinished_realestate_crn_value'] < appraisal['adjusted_market_value']) {
                            appraisal['realestate_total_adopted_value'] = appraisal['cost_method_unfinished_realestate_crn_value'];
                            appraisal['realestate_adopted_appraisal_method'] = crn_under_construction_method_obj;
                        }
                    }
                }
            }

            // Valor del dret d'ús
            /*
            És evident que no és el mateix un habitatge que està lliure vacu i expedit que una que està ocupada. Intentem establir per tant un criteri que serveixi per determinar el menor valor que se li ha de donar per aquest concepte. Tot i que no és el cas estricte d'un usdefruit (en el qual la usuària podria arrendar l'habitatge a una tercera persona), el perjudici econòmic -perdre les rendes que podria generar l'habitatge- és equivalent, a efectes merament valoratius.
            Per això fem la valoració segons els criteris de nua propietat i usdefruit, a saber:
            Usdefruit. L'usdefruit és un dret que es constitueix a favor d'una persona, usufructuari, que adquireix la utilitat de la cosa, pertanyent, però, la propietat a una altra, el nu propietari. El dret pot constituir amb caràcter temporal o vitalici, sent la valoració a efectes de l'IP diferent en cada cas.
            Usdefruit temporal. El valor s'ha d'estimar en un 2% per cada any que resti de durada del contracte, amb un màxim del 70%. La nua propietat es valorarà en la resta del valor del bé fins al 100%.
            Usdefruit vitalici. Es pren el 70% del valor del bé si l'usufructuari té menys de 20 anys, minorant el percentatge en un 1% per cada any en què, a la data de la meritació, superi aquesta edat, amb el mínim del 10%. La nua propietat es valorarà en la resta del valor del bé fins al 100%-
            */

            //Coef Vu (valor mínim 0.1)
            appraisal['vu_coef'] = this.roundToTwo(Math.max(0.1, 0.7 - 0.01 * (appraisal['usufructuary_age_years'] - 20)));
            appraisal['usufruct_value'] = this.roundToTwo(appraisal['vu_coef'] * appraisal['realestate_total_adopted_value']);
            appraisal['bare_ownership_value'] = this.roundToTwo((1 - appraisal['vu_coef']) * appraisal['realestate_total_adopted_value']);

            console.log('vu_coef: ');
            console.log(appraisal['vu_coef']);
            console.log('usufruct_value: ');
            console.log(appraisal['usufruct_value']);
            console.log('bare_ownership_value: ');
            console.log(appraisal['bare_ownership_value']);

            console.log('\'realestate_total_adopted_value\': ');
            console.log(appraisal['realestate_total_adopted_value']);
            console.log('realestate_adopted_appraisal_method: ');
            console.log(appraisal['realestate_adopted_appraisal_method']);

            ///Valor assegurança
            //Serà el valor de construcció + les despeses d'administració del promotor per la superfície adoptada

            // appraisal['insurance_value'] = this.roundToTwo(appraisal['adopted_area'] * this.roundToTwo(appraisal['cc_and_gp']))

            appraisal['insurance_value'] = this.roundToTwo(appraisal['ccb_and_gpb'] * appraisal['adopted_area']);

            // cost_method_realestate_crb_value

            appraisal['insurance_value_rd_685_1982'] = this.roundToTwo(appraisal['cost_method_realestate_crb_value'] - appraisal['repercussion_method_land_value']);
            appraisal['insurance_value_rd_716_2009'] = this.roundToTwo(appraisal['realestate_total_adopted_value'] - appraisal['repercussion_method_land_value']);

            console.log('insurance_value_rd_685_1982:');
            console.log(appraisal['insurance_value_rd_685_1982']);

            console.log('insurance_value_rd_716_2009:');
            console.log(appraisal['insurance_value_rd_716_2009']);

            console.log('appraisal calculations done!');

            return appraisal;
        }
    }
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.4';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      reLeadingDot = /^\./,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',
      rsOrdUpper = '\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * Adds the key-value `pair` to `map`.
   *
   * @private
   * @param {Object} map The map to modify.
   * @param {Array} pair The key-value pair to add.
   * @returns {Object} Returns `map`.
   */
  function addMapEntry(map, pair) {
    // Don't return `map.set` because it's not chainable in IE 11.
    map.set(pair[0], pair[1]);
    return map;
  }

  /**
   * Adds `value` to `set`.
   *
   * @private
   * @param {Object} set The set to modify.
   * @param {*} value The value to add.
   * @returns {Object} Returns `set`.
   */
  function addSetEntry(set, value) {
    // Don't return `set.add` because it's not chainable in IE 11.
    set.add(value);
    return set;
  }

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, baseClone, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = object[key],
          srcValue = source[key],
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `map`.
     *
     * @private
     * @param {Object} map The map to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned map.
     */
    function cloneMap(map, isDeep, cloneFunc) {
      var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
      return arrayReduce(array, addMapEntry, new map.constructor);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of `set`.
     *
     * @private
     * @param {Object} set The set to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned set.
     */
    function cloneSet(set, isDeep, cloneFunc) {
      var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
      return arrayReduce(array, addSetEntry, new set.constructor);
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, cloneFunc, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return cloneMap(object, isDeep, cloneFunc);

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return cloneSet(object, isDeep, cloneFunc);

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      length = length == null ? MAX_SAFE_INTEGER : length;
      return !!length &&
        (typeof value == 'number' || reIsUint.test(value)) &&
        (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (reLeadingDot.test(string)) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            result = wait - timeSinceLastCall;

        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(args) {
      args.push(undefined, customDefaultsAssignIn);
      return apply(assignInWith, undefined, args);
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38), __webpack_require__(234)(module)))

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * Vue.js v2.3.4
 * (c) 2014-2017 Evan You
 * Released under the MIT License.
 */


/*  */

// these helpers produces better vm code in JS engines due to their
// explicitness and function inlining
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}
/**
 * Check if value is primitive
 */
function isPrimitive (value) {
  return typeof value === 'string' || typeof value === 'number'
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

var _toString = Object.prototype.toString;

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : typeof val === 'object'
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert a input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Remove an item from an array
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether the object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /([^-])([A-Z])/g;
var hyphenate = cached(function (str) {
  return str
    .replace(hyphenateRE, '$1-$2')
    .replace(hyphenateRE, '$1-$2')
    .toLowerCase()
});

/**
 * Simple bind, faster than native
 */
function bind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }
  // record original fn length
  boundFn._length = fn.length;
  return boundFn
}

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/**
 * Perform no operation.
 */
function noop () {}

/**
 * Always return false.
 */
var no = function () { return false; };

/**
 * Return same value
 */
var identity = function (_) { return _; };

/**
 * Generate a static keys string from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      return JSON.stringify(a) === JSON.stringify(b)
    } catch (e) {
      // possible circular reference
      return a === b
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated'
];

/*  */

var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

var emptyObject = Object.freeze({});

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = /[^\w.$]/;
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

var warn = noop;
var tip = noop;
var formatComponentName = (null); // work around flow check

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.error("[Vue warn]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var name = typeof vm === 'string'
      ? vm
      : typeof vm === 'function' && vm.options
        ? vm.options.name
        : vm._isVue
          ? vm.$options.name || vm.$options._componentTag
          : vm.name;

    var file = vm._isVue && vm.$options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  var generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

function handleError (err, vm, info) {
  if (config.errorHandler) {
    config.errorHandler.call(null, err, vm, info);
  } else {
    if (false) {
      warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
    }
    /* istanbul ignore else */
    if (inBrowser && typeof console !== 'undefined') {
      console.error(err);
    } else {
      throw err
    }
  }
}

/*  */
/* globals MutationObserver */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = UA && UA.indexOf('android') > 0;
var isIOS = UA && /iphone|ipad|ipod|ios/.test(UA);
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    } )); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

/**
 * Defer a task to execute it asynchronously.
 */
var nextTick = (function () {
  var callbacks = [];
  var pending = false;
  var timerFunc;

  function nextTickHandler () {
    pending = false;
    var copies = callbacks.slice(0);
    callbacks.length = 0;
    for (var i = 0; i < copies.length; i++) {
      copies[i]();
    }
  }

  // the nextTick behavior leverages the microtask queue, which can be accessed
  // via either native Promise.then or MutationObserver.
  // MutationObserver has wider support, however it is seriously bugged in
  // UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
  // completely stops working after triggering a few times... so, if native
  // Promise is available, we will use it:
  /* istanbul ignore if */
  if (typeof Promise !== 'undefined' && isNative(Promise)) {
    var p = Promise.resolve();
    var logError = function (err) { console.error(err); };
    timerFunc = function () {
      p.then(nextTickHandler).catch(logError);
      // in problematic UIWebViews, Promise.then doesn't completely break, but
      // it can get stuck in a weird state where callbacks are pushed into the
      // microtask queue but the queue isn't being flushed, until the browser
      // needs to do some other work, e.g. handle a timer. Therefore we can
      // "force" the microtask queue to be flushed by adding an empty timer.
      if (isIOS) { setTimeout(noop); }
    };
  } else if (typeof MutationObserver !== 'undefined' && (
    isNative(MutationObserver) ||
    // PhantomJS and iOS 7.x
    MutationObserver.toString() === '[object MutationObserverConstructor]'
  )) {
    // use MutationObserver where native Promise is not available,
    // e.g. PhantomJS IE11, iOS7, Android 4.4
    var counter = 1;
    var observer = new MutationObserver(nextTickHandler);
    var textNode = document.createTextNode(String(counter));
    observer.observe(textNode, {
      characterData: true
    });
    timerFunc = function () {
      counter = (counter + 1) % 2;
      textNode.data = String(counter);
    };
  } else {
    // fallback to setTimeout
    /* istanbul ignore next */
    timerFunc = function () {
      setTimeout(nextTickHandler, 0);
    };
  }

  return function queueNextTick (cb, ctx) {
    var _resolve;
    callbacks.push(function () {
      if (cb) {
        try {
          cb.call(ctx);
        } catch (e) {
          handleError(e, ctx, 'nextTick');
        }
      } else if (_resolve) {
        _resolve(ctx);
      }
    });
    if (!pending) {
      pending = true;
      timerFunc();
    }
    if (!cb && typeof Promise !== 'undefined') {
      return new Promise(function (resolve, reject) {
        _resolve = resolve;
      })
    }
  }
})();

var _Set;
/* istanbul ignore if */
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = (function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */


var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// the current target watcher being evaluated.
// this is globally unique because there could be only one
// watcher being evaluated at any time.
Dep.target = null;
var targetStack = [];

function pushTarget (_target) {
  if (Dep.target) { targetStack.push(Dep.target); }
  Dep.target = _target;
}

function popTarget () {
  Dep.target = targetStack.pop();
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);[
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
]
.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var arguments$1 = arguments;

    // avoid leaking arguments:
    // http://jsperf.com/closure-with-arguments
    var i = arguments.length;
    var args = new Array(i);
    while (i--) {
      args[i] = arguments$1[i];
    }
    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
        inserted = args;
        break
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * By default, when a reactive property is set, the new value is
 * also converted to become reactive. However when passing down props,
 * we don't want to force conversion because the value may be a nested value
 * under a frozen data structure. Converting it would defeat the optimization.
 */
var observerState = {
  shouldConvert: true,
  isSettingProps: false
};

/**
 * Observer class that are attached to each observed
 * object. Once attached, the observer converts target
 * object's property keys into getter/setters that
 * collect dependencies and dispatches updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    var augment = hasProto
      ? protoAugment
      : copyAugment;
    augment(value, arrayMethods, arrayKeys);
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through each property and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i], obj[keys[i]]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment an target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment an target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value)) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    observerState.shouldConvert &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;

  var childOb = observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
        }
        if (Array.isArray(value)) {
          dependArray(value);
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (Array.isArray(target) && typeof key === 'number') {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (hasOwn(target, key)) {
    target[key] = val;
    return val
  }
  var ob = (target ).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (Array.isArray(target) && typeof key === 'number') {
    target.splice(key, 1);
    return
  }
  var ob = (target ).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;
  var keys = Object.keys(from);
  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (isPlainObject(toVal) && isPlainObject(fromVal)) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        childVal.call(this),
        parentVal.call(this)
      )
    }
  } else if (parentVal || childVal) {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm)
        : undefined;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  return childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (parentVal, childVal) {
  var res = Object.create(parentVal || null);
  return childVal
    ? extend(res, childVal)
    : res
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (parentVal, childVal) {
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key in childVal) {
    var parent = ret[key];
    var child = childVal[key];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key] = parent
      ? parent.concat(child)
      : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.computed = function (parentVal, childVal) {
  if (!childVal) { return Object.create(parentVal || null) }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  extend(ret, childVal);
  return ret
};

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    var lower = key.toLowerCase();
    if (isBuiltInTag(lower) || config.isReservedTag(lower)) {
      warn(
        'Do not use built-in or reserved HTML elements as component ' +
        'id: ' + key
      );
    }
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  }
  options.props = res;
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def = dirs[key];
      if (typeof def === 'function') {
        dirs[key] = { bind: def, update: def };
      }
    }
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child);
  normalizeDirectives(child);
  var extendsFrom = child.extends;
  if (extendsFrom) {
    parent = mergeOptions(parent, extendsFrom, vm);
  }
  if (child.mixins) {
    for (var i = 0, l = child.mixins.length; i < l; i++) {
      parent = mergeOptions(parent, child.mixins[i], vm);
    }
  }
  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */

function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // handle boolean props
  if (isType(Boolean, prop.type)) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (!isType(String, prop.type) && (value === '' || value === hyphenate(key))) {
      value = true;
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldConvert = observerState.shouldConvert;
    observerState.shouldConvert = true;
    observe(value);
    observerState.shouldConvert = prevShouldConvert;
  }
  if (false) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }
  if (!valid) {
    warn(
      'Invalid prop: type check failed for prop "' + name + '".' +
      ' Expected ' + expectedTypes.map(capitalize).join(', ') +
      ', got ' + Object.prototype.toString.call(value).slice(8, -1) + '.',
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    valid = typeof value === expectedType.toLowerCase();
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isType (type, fn) {
  if (!Array.isArray(fn)) {
    return getType(fn) === getType(type)
  }
  for (var i = 0, len = fn.length; i < len; i++) {
    if (getType(fn[i]) === getType(type)) {
      return true
    }
  }
  /* istanbul ignore next */
  return false
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      perf.clearMeasures(name);
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      "referenced during render. Make sure to declare reactive data " +
      "properties in the data option.",
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' &&
    Proxy.toString().match(/native code/);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) || key.charAt(0) === '_';
      if (!has && !isAllowed) {
        warnNonPresent(target, key);
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        warnNonPresent(target, key);
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.functionalContext = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
};

var prototypeAccessors = { child: {} };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function () {
  var node = new VNode();
  node.text = '';
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    vnode.children,
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.isCloned = true;
  return cloned
}

function cloneVNodes (vnodes) {
  var len = vnodes.length;
  var res = new Array(len);
  for (var i = 0; i < len; i++) {
    res[i] = cloneVNode(vnodes[i]);
  }
  return res
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      for (var i = 0; i < fns.length; i++) {
        fns[i].apply(null, arguments$1);
      }
    } else {
      // return handler return value for single handlers
      return fns.apply(null, arguments)
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  vm
) {
  var name, cur, old, event;
  for (name in on) {
    cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur);
      }
      add(event.name, cur, event.once, event.capture, event.passive);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    last = res[res.length - 1];
    //  nested
    if (Array.isArray(c)) {
      res.push.apply(res, normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i)));
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        (last).text += String(c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[res.length - 1] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function ensureCtor (comp, base) {
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function resolveAsyncComponent (
  factory,
  baseCtor,
  context
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (isDef(factory.contexts)) {
    // already pending
    factory.contexts.push(context);
  } else {
    var contexts = factory.contexts = [context];
    var sync = true;

    var forceRender = function () {
      for (var i = 0, l = contexts.length; i < l; i++) {
        contexts[i].$forceUpdate();
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender();
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender();
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (typeof res.then === 'function') {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isDef(res.component) && typeof res.component.then === 'function') {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            setTimeout(function () {
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender();
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          setTimeout(function () {
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && isDef(c.componentOptions)) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn, once$$1) {
  if (once$$1) {
    target.$once(event, fn);
  } else {
    target.$on(event, fn);
  }
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, vm);
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var this$1 = this;

    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var this$1 = this;

    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        this$1.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (arguments.length === 1) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      for (var i = 0, l = cbs.length; i < l; i++) {
        cbs[i].apply(vm, args);
      }
    }
    return vm
  };
}

/*  */

/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  var slots = {};
  if (!children) {
    return slots
  }
  var defaultSlot = [];
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.functionalContext === context) &&
      child.data && child.data.slot != null
    ) {
      var name = child.data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children);
      } else {
        slot.push(child);
      }
    } else {
      defaultSlot.push(child);
    }
  }
  // ignore whitespace
  if (!defaultSlot.every(isWhitespace)) {
    slots.default = defaultSlot;
  }
  return slots
}

function isWhitespace (node) {
  return node.isComment || node.text === ' '
}

function resolveScopedSlots (
  fns, // see flow/vnode
  res
) {
  res = res || {};
  for (var i = 0; i < fns.length; i++) {
    if (Array.isArray(fns[i])) {
      resolveScopedSlots(fns[i], res);
    } else {
      res[fns[i].key] = fns[i].fn;
    }
  }
  return res
}

/*  */

var activeInstance = null;

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    if (vm._isMounted) {
      callHook(vm, 'beforeUpdate');
    }
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var prevActiveInstance = activeInstance;
    activeInstance = vm;
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(
        vm.$el, vnode, hydrating, false /* removeOnly */,
        vm.$options._parentElm,
        vm.$options._refElm
      );
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    activeInstance = prevActiveInstance;
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // remove reference to DOM nodes (prevents leak)
    vm.$options._parentElm = vm.$options._refElm = null;
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure((name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure((name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  vm._watcher = new Watcher(vm, updateComponent, noop);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren
  var hasChildren = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    parentVnode.data.scopedSlots || // has new scoped slots
    vm.$scopedSlots !== emptyObject // has old scoped slots
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render
  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update props
  if (propsData && vm.$options.props) {
    observerState.shouldConvert = false;
    if (false) {
      observerState.isSettingProps = true;
    }
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      props[key] = validateProp(key, vm.$options.props, propsData, vm);
    }
    observerState.shouldConvert = true;
    if (false) {
      observerState.isSettingProps = false;
    }
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }
  // update listeners
  if (listeners) {
    var oldListeners = vm.$options._parentListeners;
    vm.$options._parentListeners = listeners;
    updateComponentListeners(vm, listeners, oldListeners);
  }
  // resolve slots + force update if has children
  if (hasChildren) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  var handlers = vm.$options[hook];
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      try {
        handlers[i].call(vm);
      } catch (e) {
        handleError(e, vm, (hook + " hook"));
      }
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
}

/*  */


var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdateHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdateHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */

var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options
) {
  this.vm = vm;
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = function () {};
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  if (this.user) {
    try {
      value = this.getter.call(vm, vm);
    } catch (e) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    }
  } else {
    value = this.getter.call(vm, vm);
  }
  // "touch" every property so they are all tracked as
  // dependencies for deep watching
  if (this.deep) {
    traverse(value);
  }
  popTarget();
  this.cleanupDeps();
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    var dep = this$1.deps[i];
    if (!this$1.newDepIds.has(dep.id)) {
      dep.removeSub(this$1);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    this$1.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
    var this$1 = this;

  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this$1.deps[i].removeSub(this$1);
    }
    this.active = false;
  }
};

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
var seenObjects = new _Set();
function traverse (val) {
  seenObjects.clear();
  _traverse(val, seenObjects);
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || !Object.isExtensible(val)) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch) { initWatch(vm, opts.watch); }
}

var isReservedProp = {
  key: 1,
  ref: 1,
  slot: 1
};

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  observerState.shouldConvert = isRoot;
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      if (isReservedProp[key] || config.isReservedAttr(key)) {
        warn(
          ("\"" + key + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (vm.$parent && !observerState.isSettingProps) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  observerState.shouldConvert = true;
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var i = keys.length;
  while (i--) {
    if (props && hasOwn(props, keys[i])) {
      "production" !== 'production' && warn(
        "The data property \"" + (keys[i]) + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(keys[i])) {
      proxy(vm, "_data", keys[i]);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  try {
    return data.call(vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  var watchers = vm._computedWatchers = Object.create(null);

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      if (getter === undefined) {
        warn(
          ("No getter function has been defined for computed property \"" + key + "\"."),
          vm
        );
        getter = noop;
      }
    }
    // create internal watcher for the computed property.
    watchers[key] = new Watcher(vm, getter, noop, computedWatcherOptions);

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (target, key, userDef) {
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = createComputedGetter(key);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? userDef.cache !== false
        ? createComputedGetter(key)
        : userDef.get
      : noop;
    sharedPropertyDefinition.set = userDef.set
      ? userDef.set
      : noop;
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    vm[key] = methods[key] == null ? noop : bind(methods[key], vm);
    if (false) {
      if (methods[key] == null) {
        warn(
          "method \"" + key + "\" has an undefined value in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
    }
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (vm, key, handler) {
  var options;
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  vm.$watch(key, handler, options);
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function (newData) {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      cb.call(vm, watcher.value);
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    // isArray here
    var isArray = Array.isArray(inject);
    var result = Object.create(null);
    var keys = isArray
      ? inject
      : hasSymbol
        ? Reflect.ownKeys(inject)
        : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var provideKey = isArray ? key : inject[key];
      var source = vm;
      while (source) {
        if (source._provided && provideKey in source._provided) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
    }
    return result
  }
}

/*  */

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  context,
  children
) {
  var props = {};
  var propOptions = Ctor.options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || {});
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var _context = Object.create(context);
  var h = function (a, b, c, d) { return createElement(_context, a, b, c, d, true); };
  var vnode = Ctor.options.render.call(null, h, {
    data: data,
    props: props,
    children: children,
    parent: context,
    listeners: data.on || {},
    injections: resolveInject(Ctor.options.inject, context),
    slots: function () { return resolveSlots(children, context); }
  });
  if (vnode instanceof VNode) {
    vnode.functionalContext = context;
    vnode.functionalOptions = Ctor.options;
    if (data.slot) {
      (vnode.data || (vnode.data = {})).slot = data.slot;
    }
  }
  return vnode
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

// hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (
    vnode,
    hydrating,
    parentElm,
    refElm
  ) {
    if (!vnode.componentInstance || vnode.componentInstance._isDestroyed) {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance,
        parentElm,
        refElm
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    } else if (vnode.data.keepAlive) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  if (isUndef(Ctor.cid)) {
    Ctor = resolveAsyncComponent(Ctor, baseCtor, context);
    if (Ctor === undefined) {
      // return nothing if this is indeed an async component
      // wait for the callback to trigger parent update.
      return
    }
  }

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  data = data || {};

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners
    data = {};
  }

  // merge component management hooks onto the placeholder node
  mergeHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children }
  );
  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent, // activeInstance in lifecycle state
  parentElm,
  refElm
) {
  var vnodeComponentOptions = vnode.componentOptions;
  var options = {
    _isComponent: true,
    parent: parent,
    propsData: vnodeComponentOptions.propsData,
    _componentTag: vnodeComponentOptions.tag,
    _parentVnode: vnode,
    _parentListeners: vnodeComponentOptions.listeners,
    _renderChildren: vnodeComponentOptions.children,
    _parentElm: parentElm || null,
    _refElm: refElm || null
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnodeComponentOptions.Ctor(options)
}

function mergeHooks (data) {
  if (!data.hook) {
    data.hook = {};
  }
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var fromParent = data.hook[key];
    var ours = componentVNodeHooks[key];
    data.hook[key] = fromParent ? mergeHook$1(ours, fromParent) : ours;
  }
}

function mergeHook$1 (one, two) {
  return function (a, b, c, d) {
    one(a, b, c, d);
    two(a, b, c, d);
  }
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input';(data.props || (data.props = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  if (isDef(on[event])) {
    on[event] = [data.model.callback].concat(on[event]);
  } else {
    on[event] = data.model.callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if (isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (isDef(vnode)) {
    if (ns) { applyNS(vnode, ns); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    return
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && isUndef(child.ns)) {
        applyNS(child, ns);
      }
    }
  }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    keys = Object.keys(val);
    ret = new Array(keys.length);
    for (i = 0, l = keys.length; i < l; i++) {
      key = keys[i];
      ret[i] = render(val[key], key, i);
    }
  }
  if (isDef(ret)) {
    (ret)._isVList = true;
  }
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      extend(props, bindObject);
    }
    return scopedSlotFn(props) || fallback
  } else {
    var slotNodes = this.$slots[name];
    // warn duplicate slot usage
    if (slotNodes && "production" !== 'production') {
      slotNodes._rendered && warn(
        "Duplicate presence of slot \"" + name + "\" found in the same render tree " +
        "- this will likely cause render errors.",
        this
      );
      slotNodes._rendered = true;
    }
    return slotNodes || fallback
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

/**
 * Runtime helper for checking keyCodes from config.
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInAlias
) {
  var keyCodes = config.keyCodes[key] || builtInAlias;
  if (Array.isArray(keyCodes)) {
    return keyCodes.indexOf(eventKeyCode) === -1
  } else {
    return keyCodes !== eventKeyCode
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      for (var key in value) {
        if (key === 'class' || key === 'style') {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        if (!(key in hash)) {
          hash[key] = value[key];
        }
      }
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var tree = this._staticTrees[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree by doing a shallow clone.
  if (tree && !isInFor) {
    return Array.isArray(tree)
      ? cloneVNodes(tree)
      : cloneVNode(tree)
  }
  // otherwise, render a fresh tree.
  tree = this._staticTrees[index] =
    this.$options.staticRenderFns[index].call(this._renderProxy);
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null;
  var parentVnode = vm.$vnode = vm.$options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(vm.$options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };
}

function renderMixin (Vue) {
  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var staticRenderFns = ref.staticRenderFns;
    var _parentVnode = ref._parentVnode;

    if (vm._isMounted) {
      // clone slot nodes on re-renders
      for (var key in vm.$slots) {
        vm.$slots[key] = cloneVNodes(vm.$slots[key]);
      }
    }

    vm.$scopedSlots = (_parentVnode && _parentVnode.data.scopedSlots) || emptyObject;

    if (staticRenderFns && !vm._staticTrees) {
      vm._staticTrees = [];
    }
    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render function");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        vnode = vm.$options.renderError
          ? vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e)
          : vm._vnode;
      } else {
        vnode = vm._vnode;
      }
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };

  // internal render helpers.
  // these are exposed on the instance prototype to reduce generated render
  // code size.
  Vue.prototype._o = markOnce;
  Vue.prototype._n = toNumber;
  Vue.prototype._s = toString;
  Vue.prototype._l = renderList;
  Vue.prototype._t = renderSlot;
  Vue.prototype._q = looseEqual;
  Vue.prototype._i = looseIndexOf;
  Vue.prototype._m = renderStatic;
  Vue.prototype._f = resolveFilter;
  Vue.prototype._k = checkKeyCodes;
  Vue.prototype._b = bindObjectProps;
  Vue.prototype._v = createTextVNode;
  Vue.prototype._e = createEmptyVNode;
  Vue.prototype._u = resolveScopedSlots;
}

/*  */

var uid$1 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$1++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-init:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(((vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  opts.parent = options.parent;
  opts.propsData = options.propsData;
  opts._parentVnode = options._parentVnode;
  opts._parentListeners = options._parentListeners;
  opts._renderChildren = options._renderChildren;
  opts._componentTag = options._componentTag;
  opts._parentElm = options._parentElm;
  opts._refElm = options._refElm;
  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var extended = Ctor.extendOptions;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = dedupe(latest[key], extended[key], sealed[key]);
    }
  }
  return modified
}

function dedupe (latest, extended, sealed) {
  // compare latest and sealed to ensure lifecycle hooks won't be duplicated
  // between merges
  if (Array.isArray(latest)) {
    var res = [];
    sealed = Array.isArray(sealed) ? sealed : [sealed];
    extended = Array.isArray(extended) ? extended : [extended];
    for (var i = 0; i < latest.length; i++) {
      // push original options and not sealed options to exclude duplicated options
      if (extended.indexOf(latest[i]) >= 0 || sealed.indexOf(latest[i]) < 0) {
        res.push(latest[i]);
      }
    }
    return res
  } else {
    return latest
  }
}

function Vue$3 (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue$3);
stateMixin(Vue$3);
eventsMixin(Vue$3);
lifecycleMixin(Vue$3);
renderMixin(Vue$3);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    /* istanbul ignore if */
    if (plugin.installed) {
      return this
    }
    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    plugin.installed = true;
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      if (!/^[a-zA-Z][\w-]*$/.test(name)) {
        warn(
          'Invalid component name: "' + name + '". Component names ' +
          'can only contain alphanumeric characters and the hyphen, ' +
          'and must start with a letter.'
        );
      }
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          if (type === 'component' && config.isReservedTag(id)) {
            warn(
              'Do not use built-in or reserved HTML elements as component ' +
              'id: ' + id
            );
          }
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */

var patternTypes = [String, RegExp];

function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (cache, current, filter) {
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        if (cachedNode !== current) {
          pruneCacheEntry(cachedNode);
        }
        cache[key] = null;
      }
    }
  }
}

function pruneCacheEntry (vnode) {
  if (vnode) {
    vnode.componentInstance.$destroy();
  }
}

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes
  },

  created: function created () {
    this.cache = Object.create(null);
  },

  destroyed: function destroyed () {
    var this$1 = this;

    for (var key in this$1.cache) {
      pruneCacheEntry(this$1.cache[key]);
    }
  },

  watch: {
    include: function include (val) {
      pruneCache(this.cache, this._vnode, function (name) { return matches(val, name); });
    },
    exclude: function exclude (val) {
      pruneCache(this.cache, this._vnode, function (name) { return !matches(val, name); });
    }
  },

  render: function render () {
    var vnode = getFirstComponentChild(this.$slots.default);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      if (name && (
        (this.include && !matches(this.include, name)) ||
        (this.exclude && matches(this.exclude, name))
      )) {
        return vnode
      }
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (this.cache[key]) {
        vnode.componentInstance = this.cache[key].componentInstance;
      } else {
        this.cache[key] = vnode;
      }
      vnode.data.keepAlive = true;
    }
    return vnode
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue$3);

Object.defineProperty(Vue$3.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue$3.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode.ssrContext
  }
});

Vue$3.version = '2.3.4';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return genClassFromData(data)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function genClassFromData (data) {
  var dynamicClass = data.class;
  var staticClass = data.staticClass;
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (isUndef(value)) {
    return ''
  }
  if (typeof value === 'string') {
    return value
  }
  var res = '';
  if (Array.isArray(value)) {
    var stringified;
    for (var i = 0, l = value.length; i < l; i++) {
      if (isDef(value[i])) {
        if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
          res += stringified + ' ';
        }
      }
    }
    return res.slice(0, -1)
  }
  if (isObject(value)) {
    for (var key in value) {
      if (value[key]) { res += key + ' '; }
    }
    return res.slice(0, -1)
  }
  /* istanbul ignore next */
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setAttribute (node, key, val) {
  node.setAttribute(key, val);
}


var nodeOps = Object.freeze({
	createElement: createElement$1,
	createElementNS: createElementNS,
	createTextNode: createTextNode,
	createComment: createComment,
	insertBefore: insertBefore,
	removeChild: removeChild,
	appendChild: appendChild,
	parentNode: parentNode,
	nextSibling: nextSibling,
	tagName: tagName,
	setTextContent: setTextContent,
	setAttribute: setAttribute
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!key) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (Array.isArray(refs[key]) && refs[key].indexOf(ref) < 0) {
        refs[key].push(ref);
      } else {
        refs[key] = [ref];
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *

/*
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key &&
    a.tag === b.tag &&
    a.isComment === b.isComment &&
    isDef(a.data) === isDef(b.data) &&
    sameInputType(a, b)
  )
}

// Some browsers do not support dynamically changing type for <input>
// so they need to be treated as different nodes
function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  var inPre = 0;
  function createElm (vnode, insertedVnodeQueue, parentElm, refElm, nested) {
    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          inPre++;
        }
        if (
          !inPre &&
          !vnode.ns &&
          !(config.ignoredElements.length && config.ignoredElements.indexOf(tag) > -1) &&
          config.isUnknownElement(tag)
        ) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }
      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        inPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */, parentElm, refElm);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref) {
    if (isDef(parent)) {
      if (isDef(ref)) {
        if (ref.parentNode === parent) {
          nodeOps.insertBefore(parent, elm, ref);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(vnode.text));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    var ancestor = vnode;
    while (ancestor) {
      if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
        nodeOps.setAttribute(vnode.elm, i, '');
      }
      ancestor = ancestor.parent;
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setAttribute(vnode.elm, i, '');
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, elmToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key) ? oldKeyToIdx[newStartVnode.key] : null;
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm);
          newStartVnode = newCh[++newStartIdx];
        } else {
          elmToMove = oldCh[idxInOld];
          /* istanbul ignore if */
          if (false) {
            warn(
              'It seems there are duplicate keys that is causing an update error. ' +
              'Make sure each v-for item has a unique key.'
            );
          }
          if (sameVnode(elmToMove, newStartVnode)) {
            patchVnode(elmToMove, newStartVnode, insertedVnodeQueue);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, newStartVnode.elm, oldStartVnode.elm);
            newStartVnode = newCh[++newStartIdx];
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm);
            newStartVnode = newCh[++newStartIdx];
          }
        }
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function patchVnode (oldVnode, vnode, insertedVnodeQueue, removeOnly) {
    if (oldVnode === vnode) {
      return
    }
    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.elm = oldVnode.elm;
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }
    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }
    var elm = vnode.elm = oldVnode.elm;
    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var bailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  var isRenderedModule = makeMap('attrs,style,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue) {
    if (false) {
      if (!assertNodeMatch(elm, vnode)) {
        return false
      }
    }
    vnode.elm = elm;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          var childrenMatch = true;
          var childNode = elm.firstChild;
          for (var i$1 = 0; i$1 < children.length; i$1++) {
            if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue)) {
              childrenMatch = false;
              break
            }
            childNode = childNode.nextSibling;
          }
          // if childNode is not null, it means the actual childNodes list is
          // longer than the virtual children list.
          if (!childrenMatch || childNode) {
            if (false
            ) {
              bailed = true;
              console.warn('Parent: ', elm);
              console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
            }
            return false
          }
        }
      }
      if (isDef(data)) {
        for (var key in data) {
          if (!isRenderedModule(key)) {
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode) {
    if (isDef(vnode.tag)) {
      return (
        vnode.tag.indexOf('vue-component') === 0 ||
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly, parentElm, refElm) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue, parentElm, refElm);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }
        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm$1 = nodeOps.parentNode(oldElm);
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm$1,
          nodeOps.nextSibling(oldElm)
        );

        if (isDef(vnode.parent)) {
          // component root element replaced.
          // update parent placeholder node element, recursively
          var ancestor = vnode.parent;
          while (ancestor) {
            ancestor.elm = vnode.elm;
            ancestor = ancestor.parent;
          }
          if (isPatchable(vnode)) {
            for (var i = 0; i < cbs.create.length; ++i) {
              cbs.create[i](emptyNode, vnode.parent);
            }
          }
        }

        if (isDef(parentElm$1)) {
          removeVnodes(parentElm$1, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode.data.hook || (vnode.data.hook = {}), 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode.data.hook || (vnode.data.hook = {}), 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  /* istanbul ignore if */
  if (isIE9 && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      el.setAttribute(key, key);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, isFalsyAttrValue(value) || value === 'false' ? 'false' : 'true');
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      el.setAttribute(key, value);
    }
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + "," + args)
  }
}

/*  */

function baseWarn (msg) {
  console.error(("[Vue compiler]: " + msg));
}

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value) {
  (el.props || (el.props = [])).push({ name: name, value: value });
}

function addAttr (el, name, value) {
  (el.attrs || (el.attrs = [])).push({ name: name, value: value });
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  modifiers
) {
  (el.directives || (el.directives = [])).push({ name: name, rawName: rawName, value: value, arg: arg, modifiers: modifiers });
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn
) {
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.'
    );
  }
  // check capture modifier
  if (modifiers && modifiers.capture) {
    delete modifiers.capture;
    name = '!' + name; // mark the event as captured
  }
  if (modifiers && modifiers.once) {
    delete modifiers.once;
    name = '~' + name; // mark the event as once
  }
  /* istanbul ignore if */
  if (modifiers && modifiers.passive) {
    delete modifiers.passive;
    name = '&' + name; // mark the event as passive
  }
  var events;
  if (modifiers && modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }
  var newHandler = { value: value, modifiers: modifiers };
  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

function getAndRemoveAttr (el, name) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  return val
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
        "? " + baseValueExpression + ".trim()" +
        ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: ("\"" + value + "\""),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var modelRs = parseModel(value);
  if (modelRs.idx === null) {
    return (value + "=" + assignment)
  } else {
    return "var $$exp = " + (modelRs.exp) + ", $$idx = " + (modelRs.idx) + ";" +
      "if (!Array.isArray($$exp)){" +
        value + "=" + assignment + "}" +
      "else{$$exp.splice($$idx, 1, " + assignment + ")}"
  }
}

/**
 * parse directive model to do the array update transform. a[idx] = val => $$a.splice($$idx, 1, val)
 *
 * for loop possible cases:
 *
 * - test
 * - test[idx]
 * - test[test1[idx]]
 * - test["a"][idx]
 * - xxx.test[a[a].test1[idx]]
 * - test.xxx.a["asa"][test1[idx]]
 *
 */

var len;
var str;
var chr;
var index$1;
var expressionPos;
var expressionEndPos;

function parseModel (val) {
  str = val;
  len = str.length;
  index$1 = expressionPos = expressionEndPos = 0;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    return {
      exp: val,
      idx: null
    }
  }

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.substring(0, expressionPos),
    idx: val.substring(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    var dynamicType = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (tag === 'input' && dynamicType) {
      warn$1(
        "<input :type=\"" + dynamicType + "\" v-model=\"" + value + "\">:\n" +
        "v-model does not support dynamic input types. Use v-if branches instead."
      );
    }
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead."
      );
    }
  }

  if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.'
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
      "?_i(" + value + "," + valueBinding + ")>-1" + (
        trueValueBinding === 'true'
          ? (":(" + value + ")")
          : (":_q(" + value + "," + trueValueBinding + ")")
      )
  );
  addHandler(el, CHECKBOX_RADIO_TOKEN,
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$c){$$i<0&&(" + value + "=$$a.concat($$v))}" +
      "else{$$i>-1&&(" + value + "=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
    el,
    value,
    modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, CHECKBOX_RADIO_TOKEN, genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
    el,
    value,
    modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;
  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number || type === 'number') {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  var event;
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    // Chrome fires microtasks in between click/change, leads to #4521
    event = isChrome ? 'click' : 'change';
    on[event] = [].concat(on[CHECKBOX_RADIO_TOKEN], on[event] || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function add$1 (
  event,
  handler,
  once$$1,
  capture,
  passive
) {
  if (once$$1) {
    var oldHandler = handler;
    var _target = target$1; // save current target element in closure
    handler = function (ev) {
      var res = arguments.length === 1
        ? oldHandler(ev)
        : oldHandler.apply(null, arguments);
      if (res !== null) {
        remove$2(event, handler, capture, _target);
      }
    };
  }
  target$1.addEventListener(
    event,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  event,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(event, handler, capture);
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, vnode.context);
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (isUndef(props[key])) {
      elm[key] = '';
    }
  }
  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
    }

    if (key === 'value') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, vnode, strCur)) {
        elm.value = strCur;
      }
    } else {
      elm[key] = cur;
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (
  elm,
  vnode,
  checkVal
) {
  return (!elm.composing && (
    vnode.tag === 'option' ||
    isDirty(elm, checkVal) ||
    isInputChanged(elm, checkVal)
  ))
}

function isDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is not equal to the updated value
  return document.activeElement !== elm && elm.value !== checkVal
}

function isInputChanged (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if ((isDef(modifiers) && modifiers.number) || elm.type === 'number') {
    return toNumber(value) !== toNumber(newVal)
  }
  if (isDef(modifiers) && modifiers.trim) {
    return value.trim() !== newVal.trim()
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (childNode.data && (styleData = normalizeStyleData(childNode.data))) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(name, val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var prefixes = ['Webkit', 'Moz', 'ms'];

var testEl;
var normalize = cached(function (prop) {
  testEl = testEl || document.createElement('div');
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in testEl.style)) {
    return prop
  }
  var upper = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < prefixes.length; i++) {
    var prefixed = prefixes[i] + upper;
    if (prefixed in testEl.style) {
      return prefixed
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likley wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    el.setAttribute('class', cur.trim());
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser && window.requestAnimationFrame
  ? window.requestAnimationFrame.bind(window)
  : setTimeout;

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  (el._transitionClasses || (el._transitionClasses = [])).push(cls);
  addClass(el, cls);
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  var transitionDelays = styles[transitionProp + 'Delay'].split(', ');
  var transitionDurations = styles[transitionProp + 'Duration'].split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = styles[animationProp + 'Delay'].split(', ');
  var animationDurations = styles[animationProp + 'Duration'].split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

function toMs (s) {
  return Number(s.slice(0, -1)) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    transitionNode = transitionNode.parent;
    context = transitionNode.context;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode.data.hook || (vnode.data.hook = {}), 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      addTransitionClass(el, toClass);
      removeTransitionClass(el, startClass);
      if (!cb.cancelled && !userWantsControl) {
        if (isValidDuration(explicitEnterDuration)) {
          setTimeout(cb, explicitEnterDuration);
        } else {
          whenTransitionEnds(el, type, cb);
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        addTransitionClass(el, leaveToClass);
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled && !userWantsControl) {
          if (isValidDuration(explicitLeaveDuration)) {
            setTimeout(cb, explicitLeaveDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var model$1 = {
  inserted: function inserted (el, binding, vnode) {
    if (vnode.tag === 'select') {
      var cb = function () {
        setSelected(el, binding, vnode.context);
      };
      cb();
      /* istanbul ignore if */
      if (isIE || isEdge) {
        setTimeout(cb, 0);
      }
    } else if (vnode.tag === 'textarea' || el.type === 'text' || el.type === 'password') {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        if (!isAndroid) {
          el.addEventListener('compositionstart', onCompositionStart);
          el.addEventListener('compositionend', onCompositionEnd);
        }
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },
  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var needReset = el.multiple
        ? binding.value.some(function (v) { return hasNoMatchingOption(v, el.options); })
        : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, el.options);
      if (needReset) {
        trigger(el, 'change');
      }
    }
  }
};

function setSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  for (var i = 0, l = options.length; i < l; i++) {
    if (looseEqual(getValue(options[i]), value)) {
      return false
    }
  }
  return true
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition && !isIE9) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (value === oldValue) { return }
    vnode = locateNode(vnode);
    var transition = vnode.data && vnode.data.transition;
    if (transition && !isIE9) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: model$1,
  show: show
};

/*  */

// Provides transition support for a single element/component.
// supports transition mode (out-in / in-out)

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(function (c) { return c.tag; });
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(function (d) { return d.name === 'show'; })) {
      child.data.show = true;
    }

    if (oldChild && oldChild.data && !isSameChild(child, oldChild)) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild && (oldChild.data.transition = extend({}, data));
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

// Provides transition support for list items.
// supports move transitions using the FLIP technique.

// Because the vdom's children update algorithm is "unstable" - i.e.
// it doesn't guarantee the relative positioning of removed elements,
// we force transition-group to update its children into two passes:
// in the first pass, we remove all nodes that need to be removed,
// triggering their leaving transition; in the second pass, we insert/move
// into the final desired state. This way in the second pass removed
// nodes will remain where they should be.

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  beforeUpdate: function beforeUpdate () {
    // force removing pass
    this.__patch__(
      this._vnode,
      this.kept,
      false, // hydrating
      true // removeOnly (!important, avoids unnecessary moves)
    );
    this._vnode = this.kept;
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    var body = document.body;
    var f = body.offsetHeight; // eslint-disable-line

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      if (this._hasMove != null) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue$3.config.mustUseProp = mustUseProp;
Vue$3.config.isReservedTag = isReservedTag;
Vue$3.config.isReservedAttr = isReservedAttr;
Vue$3.config.getTagNamespace = getTagNamespace;
Vue$3.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue$3.options.directives, platformDirectives);
extend(Vue$3.options.components, platformComponents);

// install platform patch function
Vue$3.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue$3.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
setTimeout(function () {
  if (config.devtools) {
    if (devtools) {
      devtools.emit('init', Vue$3);
    } else if (false) {
      console[console.info ? 'info' : 'log'](
        'Download the Vue Devtools extension for a better development experience:\n' +
        'https://github.com/vuejs/vue-devtools'
      );
    }
  }
  if (false
  ) {
    console[console.info ? 'info' : 'log'](
      "You are running Vue in development mode.\n" +
      "Make sure to turn on production mode when deploying for production.\n" +
      "See more tips at https://vuejs.org/guide/deployment.html"
    );
  }
}, 0);

/*  */

// check whether current browser encodes a char inside attribute values
function shouldDecode (content, encoded) {
  var div = document.createElement('div');
  div.innerHTML = "<div a=\"" + content + "\">";
  return div.innerHTML.indexOf(encoded) > 0
}

// #3663
// IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? shouldDecode('\n', '&#10;') : false;

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/*  */

var decoder;

function decode (html) {
  decoder = decoder || document.createElement('div');
  decoder.innerHTML = html;
  return decoder.textContent
}

/**
 * Not type-checking this file because it's mostly vendor code.
 */

/*!
 * HTML Parser By John Resig (ejohn.org)
 * Modified by Juriy "kangax" Zaytsev
 * Original code by Erik Arvidsson, Mozilla Public License
 * http://erik.eae.net/simplehtmlparser/simplehtmlparser.js
 */

// Regular Expressions for parsing tags and attributes
var singleAttrIdentifier = /([^\s"'<>/=]+)/;
var singleAttrAssign = /(?:=)/;
var singleAttrValues = [
  // attr value double quotes
  /"([^"]*)"+/.source,
  // attr value, single quotes
  /'([^']*)'+/.source,
  // attr value, no quotes
  /([^\s"'=<>`]+)/.source
];
var attribute = new RegExp(
  '^\\s*' + singleAttrIdentifier.source +
  '(?:\\s*(' + singleAttrAssign.source + ')' +
  '\\s*(?:' + singleAttrValues.join('|') + '))?'
);

// could use https://www.w3.org/TR/1999/REC-xml-names-19990114/#NT-QName
// but for Vue templates we can enforce a simple charset
var ncname = '[a-zA-Z_][\\w\\-\\.]*';
var qnameCapture = '((?:' + ncname + '\\:)?' + ncname + ')';
var startTagOpen = new RegExp('^<' + qnameCapture);
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp('^<\\/' + qnameCapture + '[^>]*>');
var doctype = /^<!DOCTYPE [^>]+>/i;
var comment = /^<!--/;
var conditionalComment = /^<!\[/;

var IS_REGEX_CAPTURING_BROKEN = false;
'x'.replace(/x(.)?/g, function (m, g) {
  IS_REGEX_CAPTURING_BROKEN = g === '';
});

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n'
};
var encodedAttr = /&(?:lt|gt|quot|amp);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#10);/g;

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          continue
        }
      }

      var text = (void 0), rest$1 = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest$1 = html.slice(textEnd);
        while (
          !endTag.test(rest$1) &&
          !startTagOpen.test(rest$1) &&
          !comment.test(rest$1) &&
          !conditionalComment.test(rest$1)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest$1.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest$1 = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
        advance(textEnd);
      }

      if (textEnd < 0) {
        text = html;
        html = '';
      }

      if (options.chars && text) {
        options.chars(text);
      }
    } else {
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var endTagLength = 0;
      var rest = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!--([\s\S]*?)-->/g, '$1')
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest.length;
      html = rest;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""));
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(attribute))) {
        advance(attr[0].length);
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || tagName === 'html' && lastTag === 'head' || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      // hackish work around FF bug https://bugzilla.mozilla.org/show_bug.cgi?id=369778
      if (IS_REGEX_CAPTURING_BROKEN && args[0].indexOf('""') === -1) {
        if (args[3] === '') { delete args[3]; }
        if (args[4] === '') { delete args[4]; }
        if (args[5] === '') { delete args[5]; }
      }
      var value = args[3] || args[4] || args[5] || '';
      attrs[i] = {
        name: args[1],
        value: decodeAttr(
          value,
          options.shouldDecodeNewlines
        )
      };
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
    }

    // Find the closest opened tag of the same type
    if (tagName) {
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag.")
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var defaultTagRE = /\{\{((?:.|\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});

function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      tokens.push(JSON.stringify(text.slice(lastIndex, index)));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    tokens.push(JSON.stringify(text.slice(lastIndex)));
  }
  return tokens.join('+')
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /(.*?)\s+(?:in|of)\s+(.*)/;
var forIteratorRE = /\((\{[^}]*\}|[^,]*),([^,]*)(?:,([^,]*))?\)/;

var argRE = /:(.*)$/;
var bindRE = /^:|^v-bind:/;
var modifierRE = /\.[^.]+/g;

var decodeHTMLCached = cached(decode);

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;
  platformGetTagNamespace = options.getTagNamespace || no;
  platformMustUseProp = options.mustUseProp || no;
  platformIsPreTag = options.isPreTag || no;
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  transforms = pluckModuleFunction(options.modules, 'transformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');
  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg) {
    if (!warned) {
      warned = true;
      warn$2(msg);
    }
  }

  function endPre (element) {
    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    start: function start (tag, attrs, unary) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = {
        type: 1,
        tag: tag,
        attrsList: attrs,
        attrsMap: makeAttrsMap(attrs),
        parent: currentParent,
        children: []
      };
      if (ns) {
        element.ns = ns;
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.'
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        preTransforms[i](element, options);
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else {
        processFor(element);
        processIf(element);
        processOnce(element);
        processKey(element);

        // determine whether this is a plain element after
        // removing structural attributes
        element.plain = !element.key && !attrs.length;

        processRef(element);
        processSlot(element);
        processComponent(element);
        for (var i$1 = 0; i$1 < transforms.length; i$1++) {
          transforms[i$1](element, options);
        }
        processAttrs(element);
      }

      function checkRootConstraints (el) {
        if (false) {
          if (el.tag === 'slot' || el.tag === 'template') {
            warnOnce(
              "Cannot use <" + (el.tag) + "> as component root element because it may " +
              'contain multiple nodes.'
            );
          }
          if (el.attrsMap.hasOwnProperty('v-for')) {
            warnOnce(
              'Cannot use v-for on stateful component root element because ' +
              'it renders multiple elements.'
            );
          }
        }
      }

      // tree management
      if (!root) {
        root = element;
        checkRootConstraints(root);
      } else if (!stack.length) {
        // allow root elements with v-if, v-else-if and v-else
        if (root.if && (element.elseif || element.else)) {
          checkRootConstraints(element);
          addIfCondition(root, {
            exp: element.elseif,
            block: element
          });
        } else if (false) {
          warnOnce(
            "Component template should contain exactly one root element. " +
            "If you are using v-if on multiple elements, " +
            "use v-else-if to chain them instead."
          );
        }
      }
      if (currentParent && !element.forbidden) {
        if (element.elseif || element.else) {
          processIfConditions(element, currentParent);
        } else if (element.slotScope) { // scoped slot
          currentParent.plain = false;
          var name = element.slotTarget || '"default"';(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        } else {
          currentParent.children.push(element);
          element.parent = currentParent;
        }
      }
      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        endPre(element);
      }
      // apply post-transforms
      for (var i$2 = 0; i$2 < postTransforms.length; i$2++) {
        postTransforms[i$2](element, options);
      }
    },

    end: function end () {
      // remove trailing whitespace
      var element = stack[stack.length - 1];
      var lastNode = element.children[element.children.length - 1];
      if (lastNode && lastNode.type === 3 && lastNode.text === ' ' && !inPre) {
        element.children.pop();
      }
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      endPre(element);
    },

    chars: function chars (text) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.'
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored.")
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      text = inPre || text.trim()
        ? isTextTag(currentParent) ? text : decodeHTMLCached(text)
        // only preserve whitespace if its not right after a starting tag
        : preserveWhitespace && children.length ? ' ' : '';
      if (text) {
        var expression;
        if (!inVPre && text !== ' ' && (expression = parseText(text, delimiters))) {
          children.push({
            type: 2,
            expression: expression,
            text: text
          });
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          children.push({
            type: 3,
            text: text
          });
        }
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var l = el.attrsList.length;
  if (l) {
    var attrs = el.attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      attrs[i] = {
        name: el.attrsList[i].name,
        value: JSON.stringify(el.attrsList[i].value)
      };
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      warn$2("<template> cannot be keyed. Place the key on real elements instead.");
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var inMatch = exp.match(forAliasRE);
    if (!inMatch) {
      "production" !== 'production' && warn$2(
        ("Invalid v-for expression: " + exp)
      );
      return
    }
    el.for = inMatch[2].trim();
    var alias = inMatch[1].trim();
    var iteratorMatch = alias.match(forIteratorRE);
    if (iteratorMatch) {
      el.alias = iteratorMatch[1].trim();
      el.iterator1 = iteratorMatch[2].trim();
      if (iteratorMatch[3]) {
        el.iterator2 = iteratorMatch[3].trim();
      }
    } else {
      el.alias = alias;
    }
  }
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if."
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored."
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

function processSlot (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead."
      );
    }
  } else {
    var slotTarget = getBindingAttr(el, 'slot');
    if (slotTarget) {
      el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    }
    if (el.tag === 'template') {
      el.slotScope = getAndRemoveAttr(el, 'scope');
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, isProp;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name);
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isProp = false;
        if (modifiers) {
          if (modifiers.prop) {
            isProp = true;
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            addHandler(
              el,
              ("update:" + (camelize(name))),
              genAssignmentCode(value, "$event")
            );
          }
        }
        if (isProp || platformMustUseProp(el.tag, el.attrsMap.type, name)) {
          addProp(el, name, value);
        } else {
          addAttr(el, name, value);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        addHandler(el, name, value, modifiers, false, warn$2);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
        }
        addDirective(el, name, rawName, value, arg, modifiers);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var expression = parseText(value, delimiters);
        if (expression) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.'
          );
        }
      }
      addAttr(el, name, JSON.stringify(value));
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead."
      );
    }
    _el = _el.parent;
  }
}

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      walkThroughConditionsBlocks(node.ifConditions, isInFor);
    }
  }
}

function walkThroughConditionsBlocks (conditionBlocks, isInFor) {
  for (var i = 1, len = conditionBlocks.length; i < len; i++) {
    markStaticRoots(conditionBlocks[i].block, isInFor);
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^\s*([\w$_]+|\([^)]*?\))\s*=>|^function\s*\(/;
var simplePathRE = /^\s*[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['.*?']|\[".*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*\s*$/;

// keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative,
  warn
) {
  var res = isNative ? 'nativeOn:{' : 'on:{';
  for (var name in events) {
    var handler = events[name];
    // #5330: warn click.right, since right clicks do not actually fire click events.
    if (false
    ) {
      warn(
        "Use \"contextmenu\" instead of \"click.right\" since right clicks " +
        "do not actually fire \"click\" events."
      );
    }
    res += "\"" + name + "\":" + (genHandler(name, handler)) + ",";
  }
  return res.slice(0, -1) + '}'
}

function genHandler (
  name,
  handler
) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(name, handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);

  if (!handler.modifiers) {
    return isMethodPath || isFunctionExpression
      ? handler.value
      : ("function($event){" + (handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? handler.value + '($event)'
      : isFunctionExpression
        ? ("(" + (handler.value) + ")($event)")
        : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return ("if(!('button' in $event)&&" + (keys.map(genFilterCode).join('&&')) + ")return null;")
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var alias = keyCodes[key];
  return ("_k($event.keyCode," + (JSON.stringify(key)) + (alias ? ',' + JSON.stringify(alias) : '') + ")")
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + (dir.modifiers && dir.modifiers.prop ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  bind: bind$1,
  cloak: noop
};

/*  */

// configurable state
var warn$3;
var transforms$1;
var dataGenFns;
var platformDirectives$1;
var isPlatformReservedTag$1;
var staticRenderFns;
var onceCount;
var currentOptions;

function generate (
  ast,
  options
) {
  // save previous staticRenderFns so generate calls can be nested
  var prevStaticRenderFns = staticRenderFns;
  var currentStaticRenderFns = staticRenderFns = [];
  var prevOnceCount = onceCount;
  onceCount = 0;
  currentOptions = options;
  warn$3 = options.warn || baseWarn;
  transforms$1 = pluckModuleFunction(options.modules, 'transformCode');
  dataGenFns = pluckModuleFunction(options.modules, 'genData');
  platformDirectives$1 = options.directives || {};
  isPlatformReservedTag$1 = options.isReservedTag || no;
  var code = ast ? genElement(ast) : '_c("div")';
  staticRenderFns = prevStaticRenderFns;
  onceCount = prevOnceCount;
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: currentStaticRenderFns
  }
}

function genElement (el) {
  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el)
  } else if (el.for && !el.forProcessed) {
    return genFor(el)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el)
  } else if (el.tag === 'template' && !el.slotTarget) {
    return genChildren(el) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el);
    } else {
      var data = el.plain ? undefined : genData(el);

      var children = el.inlineTemplate ? null : genChildren(el, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < transforms$1.length; i++) {
      code = transforms$1[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el) {
  el.staticProcessed = true;
  staticRenderFns.push(("with(this){return " + (genElement(el)) + "}"));
  return ("_m(" + (staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && warn$3(
        "v-once can only be used inside v-for that is keyed. "
      );
      return genElement(el)
    }
    return ("_o(" + (genElement(el)) + "," + (onceCount++) + (key ? ("," + key) : "") + ")")
  } else {
    return genStatic(el)
  }
}

function genIf (el) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice())
}

function genIfConditions (conditions) {
  if (!conditions.length) {
    return '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return el.once ? genOnce(el) : genElement(el)
  }
}

function genFor (el) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (
    false
  ) {
    warn$3(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return "_l((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + (genElement(el)) +
    '})'
}

function genData (el) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < dataGenFns.length; i++) {
    data += dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:{" + (genProps(el.attrs)) + "},";
  }
  // DOM props
  if (el.props) {
    data += "domProps:{" + (genProps(el.props)) + "},";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false, warn$3)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true, warn$3)) + ",";
  }
  // slot target
  if (el.slotTarget) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el.scopedSlots)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  return data
}

function genDirectives (el) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = platformDirectives$1[dir.name] || baseDirectives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, warn$3);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:\"" + (dir.arg) + "\"") : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el) {
  var ast = el.children[0];
  if (false) {
    warn$3('Inline-template components must have exactly one child element.');
  }
  if (ast.type === 1) {
    var inlineRenderFns = generate(ast, currentOptions);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (slots) {
  return ("scopedSlots:_u([" + (Object.keys(slots).map(function (key) { return genScopedSlot(key, slots[key]); }).join(',')) + "])")
}

function genScopedSlot (key, el) {
  if (el.for && !el.forProcessed) {
    return genForScopedSlot(key, el)
  }
  return "{key:" + key + ",fn:function(" + (String(el.attrsMap.scope)) + "){" +
    "return " + (el.tag === 'template'
      ? genChildren(el) || 'void 0'
      : genElement(el)) + "}}"
}

function genForScopedSlot (key, el) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';
  el.forProcessed = true; // avoid recursion
  return "_l((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + (genScopedSlot(key, el)) +
    '})'
}

function genChildren (el, checkSkip) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      return genElement(el$1)
    }
    var normalizationType = checkSkip ? getNormalizationType(children) : 0;
    return ("[" + (children.map(genNode).join(',')) + "]" + (normalizationType ? ("," + normalizationType) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (children) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function maybeComponent (el) {
  return !isPlatformReservedTag$1(el.tag)
}

function genNode (node) {
  if (node.type === 1) {
    return genElement(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genSlot (el) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs && ("{" + (el.attrs.map(function (a) { return ((camelize(a.name)) + ":" + (a.value)); }).join(',')) + "}");
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (componentName, el) {
  var children = el.inlineTemplate ? null : genChildren(el, true);
  return ("_c(" + componentName + "," + (genData(el)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var res = '';
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    res += "\"" + (prop.name) + "\":" + (transformSpecialNewlines(prop.value)) + ",";
  }
  return res.slice(0, -1)
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */

// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// check valid identifier for v-for
var identRE = /[A-Za-z_$][\w$]*/;

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast) {
  var errors = [];
  if (ast) {
    checkNode(ast, errors);
  }
  return errors
}

function checkNode (node, errors) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), errors);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), errors);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), errors);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], errors);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, errors);
  }
}

function checkEvent (exp, text, errors) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    errors.push(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim())
    );
  }
  checkExpression(exp, text, errors);
}

function checkFor (node, text, errors) {
  checkExpression(node.for || '', text, errors);
  checkIdentifier(node.alias, 'v-for alias', text, errors);
  checkIdentifier(node.iterator1, 'v-for iterator', text, errors);
  checkIdentifier(node.iterator2, 'v-for iterator', text, errors);
}

function checkIdentifier (ident, type, text, errors) {
  if (typeof ident === 'string' && !identRE.test(ident)) {
    errors.push(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())));
  }
}

function checkExpression (exp, text, errors) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      errors.push(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim())
      );
    } else {
      errors.push(("invalid expression: " + (text.trim())));
    }
  }
}

/*  */

function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  optimize(ast, options);
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
}

function makeFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompiler (baseOptions) {
  var functionCompileCache = Object.create(null);

  function compile (
    template,
    options
  ) {
    var finalOptions = Object.create(baseOptions);
    var errors = [];
    var tips = [];
    finalOptions.warn = function (msg, tip$$1) {
      (tip$$1 ? tips : errors).push(msg);
    };

    if (options) {
      // merge custom modules
      if (options.modules) {
        finalOptions.modules = (baseOptions.modules || []).concat(options.modules);
      }
      // merge custom directives
      if (options.directives) {
        finalOptions.directives = extend(
          Object.create(baseOptions.directives),
          options.directives
        );
      }
      // copy other options
      for (var key in options) {
        if (key !== 'modules' && key !== 'directives') {
          finalOptions[key] = options[key];
        }
      }
    }

    var compiled = baseCompile(template, finalOptions);
    if (false) {
      errors.push.apply(errors, detectErrors(compiled.ast));
    }
    compiled.errors = errors;
    compiled.tips = tips;
    return compiled
  }

  function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = options || {};

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (functionCompileCache[key]) {
      return functionCompileCache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        warn(
          "Error compiling template:\n\n" + template + "\n\n" +
          compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
          vm
        );
      }
      if (compiled.tips && compiled.tips.length) {
        compiled.tips.forEach(function (msg) { return tip(msg, vm); });
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = makeFunction(compiled.render, fnGenErrors);
    var l = compiled.staticRenderFns.length;
    res.staticRenderFns = new Array(l);
    for (var i = 0; i < l; i++) {
      res.staticRenderFns[i] = makeFunction(compiled.staticRenderFns[i], fnGenErrors);
    }

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (functionCompileCache[key] = res)
  }

  return {
    compile: compile,
    compileToFunctions: compileToFunctions
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var expression = parseText(staticClass, options.delimiters);
    if (expression) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.'
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData$1
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var expression = parseText(staticStyle, options.delimiters);
      if (expression) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.'
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$2 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$2
};

var modules$1 = [
  klass$1,
  style$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"));
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"));
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

var ref$1 = createCompiler(baseOptions);
var compileToFunctions = ref$1.compileToFunctions;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue$3.prototype.$mount;
Vue$3.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        shouldDecodeNewlines: shouldDecodeNewlines,
        delimiters: options.delimiters
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(((this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue$3.compile = compileToFunctions;

module.exports = Vue$3;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_head__ = __webpack_require__(2025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_head___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_head__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(2198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_local_storage__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_local_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_local_storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_About_vue__ = __webpack_require__(2043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_About_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_About_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_app_ads_AdEditor_vue__ = __webpack_require__(2058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_app_ads_AdEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_app_ads_AdEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_app_ads_AdsIndex_vue__ = __webpack_require__(2059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_app_ads_AdsIndex_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_app_ads_AdsIndex_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_app_appraisals_AppraisalContainer_vue__ = __webpack_require__(2064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_app_appraisals_AppraisalContainer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_app_appraisals_AppraisalContainer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_app_appraisals_AppraisalEditor_vue__ = __webpack_require__(2065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_app_appraisals_AppraisalEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_app_appraisals_AppraisalEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_app_files_AppraisalFileEditor_vue__ = __webpack_require__(2082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_app_files_AppraisalFileEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_app_files_AppraisalFileEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_app_files_AppraisalFilesIndex_vue__ = __webpack_require__(2083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_app_files_AppraisalFilesIndex_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__pages_app_files_AppraisalFilesIndex_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_app_appraisalinvoices_AppraisalInvoicesIndex_vue__ = __webpack_require__(2061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_app_appraisalinvoices_AppraisalInvoicesIndex_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__pages_app_appraisalinvoices_AppraisalInvoicesIndex_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_app_appraisalreports_AppraisalReportEditor_vue__ = __webpack_require__(2063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_app_appraisalreports_AppraisalReportEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__pages_app_appraisalreports_AppraisalReportEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_app_appraisalquotes_AppraisalQuoteEditor_vue__ = __webpack_require__(2062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_app_appraisalquotes_AppraisalQuoteEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__pages_app_appraisalquotes_AppraisalQuoteEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_app_appraisalinvoices_AppraisalInvoiceEditor_vue__ = __webpack_require__(2060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_app_appraisalinvoices_AppraisalInvoiceEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__pages_app_appraisalinvoices_AppraisalInvoiceEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_app_appraisals_AppraisalsIndex_vue__ = __webpack_require__(2066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_app_appraisals_AppraisalsIndex_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__pages_app_appraisals_AppraisalsIndex_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_app_appraisers_AppraiserEditor_vue__ = __webpack_require__(2067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_app_appraisers_AppraiserEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__pages_app_appraisers_AppraiserEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_app_appraisers_AppraisersIndex_vue__ = __webpack_require__(2068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_app_appraisers_AppraisersIndex_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__pages_app_appraisers_AppraisersIndex_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_app_becproperties_BecPropertiesIndex_vue__ = __webpack_require__(2072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_app_becproperties_BecPropertiesIndex_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__pages_app_becproperties_BecPropertiesIndex_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_app_becprices_BecPriceEditor_vue__ = __webpack_require__(2071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_app_becprices_BecPriceEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__pages_app_becprices_BecPriceEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_app_becproperties_BecPropertyEditor_vue__ = __webpack_require__(2073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_app_becproperties_BecPropertyEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__pages_app_becproperties_BecPropertyEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_app_bdefiles_BdefilesIndex_vue__ = __webpack_require__(2070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_app_bdefiles_BdefilesIndex_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__pages_app_bdefiles_BdefilesIndex_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_app_bdefiles_BdefilesEditor_vue__ = __webpack_require__(2069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_app_bdefiles_BdefilesEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__pages_app_bdefiles_BdefilesEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_app_constraints_ConstraintEditor_vue__ = __webpack_require__(2076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_app_constraints_ConstraintEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__pages_app_constraints_ConstraintEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_Contact_vue__ = __webpack_require__(2044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_Contact_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__pages_Contact_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_app_contacts_ContactEditor_vue__ = __webpack_require__(2077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_app_contacts_ContactEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__pages_app_contacts_ContactEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_app_contacts_ContactsIndex_vue__ = __webpack_require__(2078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_app_contacts_ContactsIndex_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__pages_app_contacts_ContactsIndex_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_CustomerService_vue__ = __webpack_require__(2045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_CustomerService_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__pages_CustomerService_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_app_emailaddresses_EmailAddressEditor_vue__ = __webpack_require__(2079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_app_emailaddresses_EmailAddressEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__pages_app_emailaddresses_EmailAddressEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_app_entities_EntityEditor_vue__ = __webpack_require__(2081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_app_entities_EntityEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__pages_app_entities_EntityEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_app_entities_EntitiesIndex_vue__ = __webpack_require__(2080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_app_entities_EntitiesIndex_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__pages_app_entities_EntitiesIndex_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_Home_vue__ = __webpack_require__(2046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_Home_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__pages_Home_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_Main_vue__ = __webpack_require__(2047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_Main_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__pages_Main_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__pages_app_marketstudies_MarketStudyEditor_vue__ = __webpack_require__(2084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__pages_app_marketstudies_MarketStudyEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__pages_app_marketstudies_MarketStudyEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__pages_app_notes_NoteEditor_vue__ = __webpack_require__(2085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__pages_app_notes_NoteEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__pages_app_notes_NoteEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__pages_NotFound_vue__ = __webpack_require__(2048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__pages_NotFound_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__pages_NotFound_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__pages_app_realestates_RealEstatesIndex_vue__ = __webpack_require__(2091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__pages_app_realestates_RealEstatesIndex_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__pages_app_realestates_RealEstatesIndex_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__pages_app_realestates_RealEstateEditor_vue__ = __webpack_require__(2090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__pages_app_realestates_RealEstateEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__pages_app_realestates_RealEstateEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__pages_Restricted_vue__ = __webpack_require__(2053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__pages_Restricted_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__pages_Restricted_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__pages_auth_LogIn_vue__ = __webpack_require__(2098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__pages_auth_LogIn_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__pages_auth_LogIn_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__pages_app_NV_vue__ = __webpack_require__(2056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__pages_app_NV_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__pages_app_NV_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__pages_app_Dashboard_vue__ = __webpack_require__(2055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__pages_app_Dashboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__pages_app_Dashboard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__pages_OurClients_vue__ = __webpack_require__(2049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__pages_OurClients_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__pages_OurClients_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__pages_Philosophy_vue__ = __webpack_require__(2050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__pages_Philosophy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__pages_Philosophy_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__pages_app_photographs_PhotographEditor_vue__ = __webpack_require__(2087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__pages_app_photographs_PhotographEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__pages_app_photographs_PhotographEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__pages_app_registryannexes_RegistryAnnexEditor_vue__ = __webpack_require__(2092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__pages_app_registryannexes_RegistryAnnexEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__pages_app_registryannexes_RegistryAnnexEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__pages_app_urbanannexes_UrbanAnnexEditor_vue__ = __webpack_require__(2096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__pages_app_urbanannexes_UrbanAnnexEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__pages_app_urbanannexes_UrbanAnnexEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__pages_app_cadasterannexes_CadasterAnnexEditor_vue__ = __webpack_require__(2074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__pages_app_cadasterannexes_CadasterAnnexEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__pages_app_cadasterannexes_CadasterAnnexEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__pages_app_planannexes_PlanAnnexEditor_vue__ = __webpack_require__(2088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__pages_app_planannexes_PlanAnnexEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__pages_app_planannexes_PlanAnnexEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__pages_app_projects_ProjectEditor_vue__ = __webpack_require__(2089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__pages_app_projects_ProjectEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__pages_app_projects_ProjectEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__pages_app_cessionannexes_CessionAnnexEditor_vue__ = __webpack_require__(2075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__pages_app_cessionannexes_CessionAnnexEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__pages_app_cessionannexes_CessionAnnexEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__pages_app_otherannexes_OtherAnnexEditor_vue__ = __webpack_require__(2086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__pages_app_otherannexes_OtherAnnexEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__pages_app_otherannexes_OtherAnnexEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__pages_app_Public_vue__ = __webpack_require__(2057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__pages_app_Public_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__pages_app_Public_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__pages_Pricing_vue__ = __webpack_require__(2051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__pages_Pricing_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__pages_Pricing_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__pages_QuoteRequest_vue__ = __webpack_require__(2052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__pages_QuoteRequest_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__pages_QuoteRequest_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__pages_Services_vue__ = __webpack_require__(2054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__pages_Services_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__pages_Services_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__pages_auth_SignUp_vue__ = __webpack_require__(2099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__pages_auth_SignUp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__pages_auth_SignUp_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__pages_app_supervisors_SupervisorEditor_vue__ = __webpack_require__(2093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__pages_app_supervisors_SupervisorEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__pages_app_supervisors_SupervisorEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__pages_app_supervisors_SupervisorsIndex_vue__ = __webpack_require__(2094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__pages_app_supervisors_SupervisorsIndex_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__pages_app_supervisors_SupervisorsIndex_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__pages_app_telephonenumbers_TelephoneNumberEditor_vue__ = __webpack_require__(2095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__pages_app_telephonenumbers_TelephoneNumberEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__pages_app_telephonenumbers_TelephoneNumberEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__pages_app_warnings_WarningEditor_vue__ = __webpack_require__(2097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__pages_app_warnings_WarningEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__pages_app_warnings_WarningEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__store_index_js__ = __webpack_require__(235);
































































// TODO: repassar que tota el CREATE I DELETE funcioni correctament en tots els objectes (si al borrar es borren també els seus parents i paths dependents que també haurien de borrar-se, etc)





__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_head___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
    mode: 'history',
    routes: [{ path: '/', name: 'home', component: __WEBPACK_IMPORTED_MODULE_31__pages_Home_vue___default.a }, { path: '/sobre-nosotros', name: 'about', component: __WEBPACK_IMPORTED_MODULE_4__pages_About_vue___default.a }, { path: '/dashboard', name: 'dashboard', component: __WEBPACK_IMPORTED_MODULE_41__pages_app_Dashboard_vue___default.a, meta: { requiresAuth: true } }, {
        path: '/ad-editor',
        name: 'ad-editor',
        component: __WEBPACK_IMPORTED_MODULE_5__pages_app_ads_AdEditor_vue___default.a,
        meta: { requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor'] }
    }, {
        path: '/ads-index',
        name: 'ads-index',
        component: __WEBPACK_IMPORTED_MODULE_6__pages_app_ads_AdsIndex_vue___default.a,
        meta: { requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor'] }
    }, {
        path: '/realestate-editor',
        name: 'realestate-editor',
        component: __WEBPACK_IMPORTED_MODULE_37__pages_app_realestates_RealEstateEditor_vue___default.a,
        meta: { requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor'] }
    }, {
        path: '/appraisal-container',
        name: 'appraisal-container',
        component: __WEBPACK_IMPORTED_MODULE_7__pages_app_appraisals_AppraisalContainer_vue___default.a,
        meta: { requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor'] }
    }, {
        path: '/appraisal-editor',
        name: 'appraisal-editor',
        component: __WEBPACK_IMPORTED_MODULE_8__pages_app_appraisals_AppraisalEditor_vue___default.a,
        meta: { requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor'] }
    }, {
        path: '/appraisalfile-editor',
        name: 'appraisalfile-editor',
        component: __WEBPACK_IMPORTED_MODULE_9__pages_app_files_AppraisalFileEditor_vue___default.a,
        meta: { requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor'] }
    }, {
        path: '/appraisalreport-editor',
        name: 'appraisalreport-editor',
        component: __WEBPACK_IMPORTED_MODULE_12__pages_app_appraisalreports_AppraisalReportEditor_vue___default.a,
        meta: { requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor'] }
    }, {
        path: '/appraisalquote-editor',
        name: 'appraisalquote-editor',
        component: __WEBPACK_IMPORTED_MODULE_13__pages_app_appraisalquotes_AppraisalQuoteEditor_vue___default.a,
        meta: { requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor'] }
    }, {
        path: '/appraisalinvoice-editor',
        name: 'appraisalinvoice-editor',
        component: __WEBPACK_IMPORTED_MODULE_14__pages_app_appraisalinvoices_AppraisalInvoiceEditor_vue___default.a,
        meta: { requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor'] }
    }, {
        path: '/appraisals-index',
        name: 'appraisals-index',
        component: __WEBPACK_IMPORTED_MODULE_15__pages_app_appraisals_AppraisalsIndex_vue___default.a,
        meta: { requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor'] }
    }, {
        path: '/appraiser-editor',
        name: 'appraiser-editor',
        component: __WEBPACK_IMPORTED_MODULE_16__pages_app_appraisers_AppraiserEditor_vue___default.a,
        meta: { requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor'] }
    }, {
        path: '/appraisers-index',
        name: 'appraisers-index',
        component: __WEBPACK_IMPORTED_MODULE_17__pages_app_appraisers_AppraisersIndex_vue___default.a,
        meta: { requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor'] }
    }, {
        path: '/supervisor-editor',
        name: 'supervisor-editor',
        component: __WEBPACK_IMPORTED_MODULE_57__pages_app_supervisors_SupervisorEditor_vue___default.a,
        meta: { requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor'] }
    }, {
        path: '/supervisors-index',
        name: 'supervisors-index',
        component: __WEBPACK_IMPORTED_MODULE_58__pages_app_supervisors_SupervisorsIndex_vue___default.a,
        meta: { requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor'] }
    }, {
        path: '/bdefiles-index',
        name: 'bdefiles-index',
        component: __WEBPACK_IMPORTED_MODULE_21__pages_app_bdefiles_BdefilesIndex_vue___default.a,
        meta: { requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor'] }
    }, {
        path: '/bdefiles-editor',
        name: 'bdefiles-editor',
        component: __WEBPACK_IMPORTED_MODULE_22__pages_app_bdefiles_BdefilesEditor_vue___default.a,
        meta: { requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor'] }
    }, {
        path: '/becproperties-index',
        name: 'becproperties-index',
        component: __WEBPACK_IMPORTED_MODULE_18__pages_app_becproperties_BecPropertiesIndex_vue___default.a,
        meta: { requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor'] }
    }, {
        path: '/becproperty-editor',
        name: 'becproperty-editor',
        component: __WEBPACK_IMPORTED_MODULE_20__pages_app_becproperties_BecPropertyEditor_vue___default.a,
        meta: { requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor'] }
    }, {
        path: '/becprice-editor',
        name: 'becprice-editor',
        component: __WEBPACK_IMPORTED_MODULE_19__pages_app_becprices_BecPriceEditor_vue___default.a,
        meta: { requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor'] }
    }, {
        path: '/emailaddress-editor',
        name: 'emailaddress-editor',
        component: __WEBPACK_IMPORTED_MODULE_28__pages_app_emailaddresses_EmailAddressEditor_vue___default.a,
        meta: { requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor'] }
    }, {
        path: '/entity-editor',
        name: 'entity-editor',
        component: __WEBPACK_IMPORTED_MODULE_29__pages_app_entities_EntityEditor_vue___default.a,
        meta: { requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor'] }
    }, {
        path: '/entities-index',
        name: 'entities-index',
        component: __WEBPACK_IMPORTED_MODULE_30__pages_app_entities_EntitiesIndex_vue___default.a,
        meta: { requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor'] }
    }, {
        path: '/marketstudy-editor',
        name: 'marketstudy-editor',
        component: __WEBPACK_IMPORTED_MODULE_33__pages_app_marketstudies_MarketStudyEditor_vue___default.a,
        meta: { requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor'] }
    }, {
        path: '/realestates-index',
        name: 'realestates-index',
        component: __WEBPACK_IMPORTED_MODULE_36__pages_app_realestates_RealEstatesIndex_vue___default.a,
        meta: { requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor'] }
    }, {
        path: '/telephonenumber-editor',
        name: 'telephonenumber-editor',
        component: __WEBPACK_IMPORTED_MODULE_59__pages_app_telephonenumbers_TelephoneNumberEditor_vue___default.a,
        meta: { requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor'] }
    }, {
        path: '/appraisalfiles-index',
        name: 'appraisalfiles-index',
        component: __WEBPACK_IMPORTED_MODULE_10__pages_app_files_AppraisalFilesIndex_vue___default.a,
        meta: { requiresAuth: true, allowedRoles: ['ceo', 'admin', 'tech_appraiser', 'tech_supervisor'] }
    }, {
        path: '/appraisalinvoices-index',
        name: 'appraisalinvoices-index',
        component: __WEBPACK_IMPORTED_MODULE_11__pages_app_appraisalinvoices_AppraisalInvoicesIndex_vue___default.a,
        meta: { requiresAuth: true, allowedRoles: ['ceo', 'admin', 'tech_appraiser', 'tech_supervisor'] }
    }, { path: '/contacto', name: 'contact', component: __WEBPACK_IMPORTED_MODULE_24__pages_Contact_vue___default.a }, {
        path: '/contact-editor',
        name: 'contact-editor',
        component: __WEBPACK_IMPORTED_MODULE_25__pages_app_contacts_ContactEditor_vue___default.a,
        meta: { requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor'] }
    }, {
        path: '/contacts-index',
        name: 'contacts-index',
        component: __WEBPACK_IMPORTED_MODULE_26__pages_app_contacts_ContactsIndex_vue___default.a,
        meta: { requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor'] }
    }, {
        path: '/constraint-editor',
        name: 'constraint-editor',
        component: __WEBPACK_IMPORTED_MODULE_23__pages_app_constraints_ConstraintEditor_vue___default.a,
        meta: { requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor'] }
    }, {
        path: '/photograph-editor',
        name: 'photograph-editor',
        component: __WEBPACK_IMPORTED_MODULE_44__pages_app_photographs_PhotographEditor_vue___default.a,
        meta: { requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor'] }
    }, {
        path: '/urban-annex-editor',
        name: 'urban-annex-editor',
        component: __WEBPACK_IMPORTED_MODULE_46__pages_app_urbanannexes_UrbanAnnexEditor_vue___default.a,
        meta: { requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor'] }
    }, {
        path: '/registry-annex-editor',
        name: 'registry-annex-editor',
        component: __WEBPACK_IMPORTED_MODULE_45__pages_app_registryannexes_RegistryAnnexEditor_vue___default.a,
        meta: { requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor'] }
    }, {
        path: '/cadaster-annex-editor',
        name: 'cadaster-annex-editor',
        component: __WEBPACK_IMPORTED_MODULE_47__pages_app_cadasterannexes_CadasterAnnexEditor_vue___default.a,
        meta: { requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor'] }
    }, {
        path: '/plan-annex-editor',
        name: 'plan-annex-editor',
        component: __WEBPACK_IMPORTED_MODULE_48__pages_app_planannexes_PlanAnnexEditor_vue___default.a,
        meta: { requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor'] }
    }, {
        path: '/cession-annex-editor',
        name: 'cession-annex-editor',
        component: __WEBPACK_IMPORTED_MODULE_50__pages_app_cessionannexes_CessionAnnexEditor_vue___default.a,
        meta: { requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor'] }
    }, {
        path: '/other-annex-editor',
        name: 'other-annex-editor',
        component: __WEBPACK_IMPORTED_MODULE_51__pages_app_otherannexes_OtherAnnexEditor_vue___default.a,
        meta: { requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor'] }
    }, {
        path: '/project-editor',
        name: 'project-editor',
        component: __WEBPACK_IMPORTED_MODULE_49__pages_app_projects_ProjectEditor_vue___default.a,
        meta: { requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor'] }
    }, {
        path: '/note-editor',
        name: 'note-editor',
        component: __WEBPACK_IMPORTED_MODULE_34__pages_app_notes_NoteEditor_vue___default.a,
        meta: { requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor'] }
    }, {
        path: '/warning-editor',
        name: 'warning-editor',
        component: __WEBPACK_IMPORTED_MODULE_60__pages_app_warnings_WarningEditor_vue___default.a,
        meta: { requiresAuth: true, allowedRoles: ['ceo', 'hr', 'admin', 'tech_appraiser', 'tech_supervisor'] }
    }, { path: '/servicio-atencion-cliente', name: 'customer-service', component: __WEBPACK_IMPORTED_MODULE_27__pages_CustomerService_vue___default.a }, { path: '/iniciar-sesion', name: 'login', component: __WEBPACK_IMPORTED_MODULE_39__pages_auth_LogIn_vue___default.a }, { path: '/nuestros-clientes', name: 'our-clients', component: __WEBPACK_IMPORTED_MODULE_42__pages_OurClients_vue___default.a }, { path: '/filosofia', name: 'philosophy', component: __WEBPACK_IMPORTED_MODULE_43__pages_Philosophy_vue___default.a }, { path: '/tarifas', name: 'pricing', component: __WEBPACK_IMPORTED_MODULE_53__pages_Pricing_vue___default.a }, { path: '/presupuesto', name: 'quote-request', component: __WEBPACK_IMPORTED_MODULE_54__pages_QuoteRequest_vue___default.a }, { path: '/restricted', name: 'restricted', component: __WEBPACK_IMPORTED_MODULE_38__pages_Restricted_vue___default.a }, { path: '/servicios', name: 'services', component: __WEBPACK_IMPORTED_MODULE_55__pages_Services_vue___default.a }, { path: '/main', name: 'main', component: __WEBPACK_IMPORTED_MODULE_32__pages_Main_vue___default.a }, { path: '/signup', name: 'signup', component: __WEBPACK_IMPORTED_MODULE_56__pages_auth_SignUp_vue___default.a }, { path: '/n/:id', name: 'public', component: __WEBPACK_IMPORTED_MODULE_52__pages_app_Public_vue___default.a }, { path: '/error', name: 'error', component: Error }, { path: '*', name: 'notfound', component: __WEBPACK_IMPORTED_MODULE_35__pages_NotFound_vue___default.a }]
});

router.beforeEach(function (to, from, next) {

    var user = __WEBPACK_IMPORTED_MODULE_3_local_storage___default.a.get('user');
    var user_role = __WEBPACK_IMPORTED_MODULE_62__store_index_js__["a" /* default */].getters.user_role;

    if (to.matched.some(function (record) {
        return record.meta.requiresAuth;
    })) {

        if (user) {

            if (to.meta.allowedRoles) {

                //console.log(user_role)
                var f = __WEBPACK_IMPORTED_MODULE_61_lodash___default.a.includes(to.meta.allowedRoles, user_role);

                //console.log(f)
                if (f) {
                    next();
                } else {
                    console.log("restricted...");
                    next({ name: 'restricted', query: { redirect: to.fullPath } });
                }
            } else {
                next();
            }
        } else {
            next({ name: 'login', query: { redirect: to.fullPath } });
        }
    } else {

        // next()

        if (user && to.name !== 'public') {
            next({ name: 'dashboard' });
        } else {
            next();
        }
    }

    window.scrollTo(0, 0);
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(2207)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(515),
  /* template */
  __webpack_require__(2165),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(2203)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(523),
  /* template */
  __webpack_require__(2143),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(507),
  /* template */
  __webpack_require__(2112),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(498),
  /* template */
  __webpack_require__(2155),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(513),
  /* template */
  __webpack_require__(2182),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(2219)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(522),
  /* template */
  __webpack_require__(2142),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__min__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__max__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__count__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__average__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__total__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__variance__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__standard_deviation__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__median__ = __webpack_require__(591);









/* harmony default export */ __webpack_exports__["a"] = ({
    min: __WEBPACK_IMPORTED_MODULE_0__min__["a" /* default */],
    max: __WEBPACK_IMPORTED_MODULE_1__max__["a" /* default */],
    count: __WEBPACK_IMPORTED_MODULE_2__count__["a" /* default */],
    average: __WEBPACK_IMPORTED_MODULE_3__average__["a" /* default */],
    total: __WEBPACK_IMPORTED_MODULE_4__total__["a" /* default */],
    variance: __WEBPACK_IMPORTED_MODULE_5__variance__["a" /* default */],
    standardDeviation: __WEBPACK_IMPORTED_MODULE_6__standard_deviation__["a" /* default */],
    median: __WEBPACK_IMPORTED_MODULE_7__median__["a" /* default */]
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__currency__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__datetime__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__date_short__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__date_long__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__percentage__ = __webpack_require__(602);






/* harmony default export */ __webpack_exports__["a"] = ({
    currency: __WEBPACK_IMPORTED_MODULE_0__currency__["a" /* default */],
    datetime: __WEBPACK_IMPORTED_MODULE_1__datetime__["a" /* default */],
    dateShort: __WEBPACK_IMPORTED_MODULE_2__date_short__["a" /* default */],
    dateLong: __WEBPACK_IMPORTED_MODULE_3__date_long__["a" /* default */],
    homg_percentage: __WEBPACK_IMPORTED_MODULE_4__percentage__["a" /* default */]
});

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(2200)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(503),
  /* template */
  __webpack_require__(2128),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(2199)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(504),
  /* template */
  __webpack_require__(2122),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(2204)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(517),
  /* template */
  __webpack_require__(2158),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(2201)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(525),
  /* template */
  __webpack_require__(2139),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(30);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(499),
  /* template */
  __webpack_require__(2116),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 26 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 27 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PJD_3PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PJD_7PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return PJD_WGS84; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return PJD_NODATUM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SEC_TO_RAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HALF_PI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SIXTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return RA4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return RA6; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EPSLN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return D2R; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return R2D; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FORTPI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TWO_PI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SPI; });
var PJD_3PARAM = 1;
var PJD_7PARAM = 2;
var PJD_WGS84 = 4; // WGS84 or equivalent
var PJD_NODATUM = 5; // WGS84 or equivalent
var SEC_TO_RAD = 4.84813681109535993589914102357e-6;
var HALF_PI = Math.PI/2;
// ellipoid pj_set_ell.c
var SIXTH = 0.1666666666666666667;
/* 1/6 */
var RA4 = 0.04722222222222222222;
/* 17/360 */
var RA6 = 0.02215608465608465608;
var EPSLN = 1.0e-10;
// you'd think you could use Number.EPSILON above but that makes
// Mollweide get into an infinate loop.

var D2R = 0.01745329251994329577;
var R2D = 57.29577951308232088;
var FORTPI = Math.PI/4;
var TWO_PI = Math.PI * 2;
// SPI is slightly greater than Math.PI, so values that exceed the -180..180
// degree range by a tiny amount don't get wrapped. This prevents points that
// have drifted from their original location along the 180th meridian (due to
// floating point error) from changing their sign.
var SPI = 3.14159265359;


/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(2228)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction) {
  isProduction = _isProduction

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[data-vue-ssr-id~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(136)('wks');
var uid = __webpack_require__(88);
var Symbol = __webpack_require__(26).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_values__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sign__ = __webpack_require__(114);




/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return (Math.abs(x) <= __WEBPACK_IMPORTED_MODULE_0__constants_values__["c" /* SPI */]) ? x : (x - (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sign__["a" /* default */])(x) * __WEBPACK_IMPORTED_MODULE_0__constants_values__["e" /* TWO_PI */]));
});


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(29)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(24);
var IE8_DOM_DEFINE = __webpack_require__(267);
var toPrimitive = __webpack_require__(60);
var dP = Object.defineProperty;

exports.f = __webpack_require__(34) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(59);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(57);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 38 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// require("babel-polyfill") afegit per mi
__webpack_require__(730);
var staticMethods = __webpack_require__(236);
var instanceMethods = __webpack_require__(491);

module.exports = Object.assign(staticMethods, { instanceMethods: instanceMethods });

/***/ }),
/* 41 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(35);
var createDesc = __webpack_require__(84);
module.exports = __webpack_require__(34) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(26);
var hide = __webpack_require__(42);
var has = __webpack_require__(41);
var SRC = __webpack_require__(88)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(56).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var fails = __webpack_require__(29);
var defined = __webpack_require__(57);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(105);
var createDesc = __webpack_require__(84);
var toIObject = __webpack_require__(47);
var toPrimitive = __webpack_require__(60);
var has = __webpack_require__(41);
var IE8_DOM_DEFINE = __webpack_require__(267);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(34) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(41);
var toObject = __webpack_require__(37);
var IE_PROTO = __webpack_require__(186)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(104);
var defined = __webpack_require__(57);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var store  = __webpack_require__(474)('wks')
  , uid    = __webpack_require__(476)
  , Symbol = __webpack_require__(70).Symbol;
module.exports = function(name){
  return store[name] || (store[name] =
    Symbol && Symbol[name] || (Symbol || uid)('Symbol.' + name));
};

/***/ }),
/* 49 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(39);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(29);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* vim: set softtabstop=2 shiftwidth=2 expandtab : */

var _ = __webpack_require__(9);
var assert = __webpack_require__(163);

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

exports.default = function (vueElement, googleMapsElement, props, options) {
  options = options || {};
  var _options = options,
      afterModelChanged = _options.afterModelChanged;

  _.forEach(props, function (_ref, attribute) {
    var twoWay = _ref.twoWay,
        type = _ref.type,
        trackProperties = _ref.trackProperties;

    var setMethodName = 'set' + capitalizeFirstLetter(attribute);
    var getMethodName = 'get' + capitalizeFirstLetter(attribute);
    var eventName = attribute.toLowerCase() + '_changed';
    var initialValue = vueElement[attribute];

    assert(googleMapsElement[setMethodName], setMethodName + ' is not a method of (the Maps object corresponding to) ' + vueElement.$options._componentTag);

    // We need to avoid an endless
    // propChanged -> event emitted -> propChanged -> event emitted loop
    // although this may really be the user's responsibility
    var timesSet = 0;
    if (type !== Object || !trackProperties) {
      // Track the object deeply
      vueElement.$watch(attribute, function () {
        var attributeValue = vueElement[attribute];

        timesSet++;
        googleMapsElement[setMethodName](attributeValue);
        if (afterModelChanged) {
          afterModelChanged(attribute, attributeValue);
        }
      }, {
        immediate: typeof initialValue !== 'undefined',
        deep: type === Object
      });
    } else if (type === Object && trackProperties) {
      // I can watch multiple properties, but the danger is that each of
      // them triggers the event handler multiple times
      // This ensures that the event handler will only be fired once
      var tick = 0,
          expectedTick = 0;

      var raiseExpectation = function raiseExpectation() {
        expectedTick += 1;
      };

      var updateTick = function updateTick() {
        tick = Math.max(expectedTick, tick + 1);
      };

      var respondToChange = function respondToChange() {
        if (tick < expectedTick) {
          googleMapsElement[setMethodName](vueElement[attribute]);

          if (afterModelChanged) {
            afterModelChanged(attribute, attributeValue);
          }

          updateTick();
        }
      };

      trackProperties.forEach(function (propName) {
        // When any props change -- assume they change on the same tick
        vueElement.$watch(attribute + '.' + propName, function () {
          raiseExpectation();
          vueElement.$nextTick(respondToChange);
        }, {
          immediate: typeof initialValue !== 'undefined'
        });
      });
    }

    if (twoWay) {
      googleMapsElement.addListener(eventName, function (ev) {
        // eslint-disable-line no-unused-vars
        /* Check for type === Object because we're quite happy
          when primitive types change -- the change detection is cheap
        */
        if (type === Object && timesSet > 0) {
          timesSet--;
          return;
        } else {
          vueElement.$emit(eventName, googleMapsElement[getMethodName]());
        }
      });
    }
  });
};

/***/ }),
/* 53 */
/***/ (function(module, exports) {

var $Object = Object;
module.exports = {
  create:     $Object.create,
  getProto:   $Object.getPrototypeOf,
  isEnum:     {}.propertyIsEnumerable,
  getDesc:    $Object.getOwnPropertyDescriptor,
  setDesc:    $Object.defineProperty,
  setDescs:   $Object.defineProperties,
  getKeys:    $Object.keys,
  getNames:   $Object.getOwnPropertyNames,
  getSymbols: $Object.getOwnPropertySymbols,
  each:       [].forEach
};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Vue-awesome-swiper
 * @author Surmon.me
 */

var Swiper = __webpack_require__(466)
var SwiperComponent = __webpack_require__(2027)
var SlideComponent = __webpack_require__(2026)
SwiperComponent = SwiperComponent.default || SwiperComponent
SlideComponent = SlideComponent.default || SlideComponent
if (typeof window !== 'undefined') {
  window.Swiper = Swiper
}

var swiper = {
  swiperSlide: SlideComponent,
  swiper: SwiperComponent,
  swiperPlugins: Swiper.prototype.plugins,
  install: function(Vue) {
    Vue.component(SwiperComponent.name, SwiperComponent)
    Vue.component(SlideComponent.name, SlideComponent)
  }
}

module.exports = swiper


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(50);
var IObject = __webpack_require__(104);
var toObject = __webpack_require__(37);
var toLength = __webpack_require__(36);
var asc = __webpack_require__(171);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 56 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 57 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(2);
var core = __webpack_require__(56);
var fails = __webpack_require__(29);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 59 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(30);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(2220)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(512),
  /* template */
  __webpack_require__(2148),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(514),
  /* template */
  __webpack_require__(2157),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(516),
  /* template */
  __webpack_require__(2124),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(9);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  methods: {
    getPropsValues: function getPropsValues() {
      var _this = this;

      return _lodash2.default.mapValues(this.$options.props, function (v, k) {
        return _this[k];
      });
    }
  }
};

/***/ }),
/* 65 */
/***/ (function(module, exports) {

var core = module.exports = {version: '1.2.6'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    abb_ca: 'Sr.',
    abb_en: 'Mr',
    abb_es: 'Sr.',
    name_ca: 'Senyor',
    name_en: 'Mister',
    name_es: 'Señor',
    gender: 'male'
}, {
    id: 2,
    abb_ca: 'Sra.',
    abb_en: 'Ms',
    abb_es: 'Sra.',
    name_ca: 'Senyora',
    name_en: 'Miss',
    name_es: 'Señora',
    gender: 'female'
}, {
    id: 3,
    abb_ca: 'Srta.',
    abb_en: 'Mss',
    abb_es: 'Srta.',
    name_ca: 'Senyoreta',
    name_en: 'Misses',
    name_es: 'Señorita',
    gender: 'female'
}, {
    id: 4,
    abb_ca: 'Don',
    abb_en: 'Don',
    abb_es: 'Don',
    name_ca: 'Don',
    name_en: 'Don',
    name_es: 'Don',
    gender: 'male'
}, {
    id: 5,
    abb_ca: 'Doña',
    abb_en: 'Doña',
    abb_es: 'Doña',
    name_ca: 'Doña',
    name_en: 'Doña',
    name_es: 'Doña',
    gender: 'female'
}, {
    id: 6,
    abb_ca: 'Dr.',
    abb_en: 'Dr',
    abb_es: 'Dr.',
    name_ca: 'Doctor',
    name_en: 'Doctor',
    name_es: 'Doctor',
    gender: 'male'
}, {
    id: 7,
    abb_ca: 'Dra.',
    abb_en: 'Dra',
    abb_es: 'Dra.',
    name_ca: 'Doctora',
    name_en: 'Doctora',
    name_es: 'Doctora',
    gender: 'female'
}, {
    id: 8,
    abb_ca: 'Excm. Sr.',
    abb_en: 'The Most Excellent Mr',
    abb_es: 'Excmo. Sr.',
    name_ca: 'Excel·lentíssim Senyor',
    name_en: 'The Most Excellent Mister',
    name_es: 'Excelentísimo Señor',
    gender: 'male'
}, {
    id: 9,
    abb_ca: 'Excm. Sra.',
    abb_en: 'Most Excellent Ms',
    abb_es: 'Excma. Sra.',
    name_ca: 'Excel·lentíssima Senyora',
    name_en: 'The Most Excellent Miss',
    name_es: 'Excelentísima Señora',
    gender: 'female'
}]);

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(288);
var $export = __webpack_require__(2);
var shared = __webpack_require__(136)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(291))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(34)) {
  var LIBRARY = __webpack_require__(80);
  var global = __webpack_require__(26);
  var fails = __webpack_require__(29);
  var $export = __webpack_require__(2);
  var $typed = __webpack_require__(138);
  var $buffer = __webpack_require__(192);
  var ctx = __webpack_require__(50);
  var anInstance = __webpack_require__(78);
  var propertyDesc = __webpack_require__(84);
  var hide = __webpack_require__(42);
  var redefineAll = __webpack_require__(85);
  var toInteger = __webpack_require__(59);
  var toLength = __webpack_require__(36);
  var toIndex = __webpack_require__(286);
  var toAbsoluteIndex = __webpack_require__(87);
  var toPrimitive = __webpack_require__(60);
  var has = __webpack_require__(41);
  var classof = __webpack_require__(103);
  var isObject = __webpack_require__(30);
  var toObject = __webpack_require__(37);
  var isArrayIter = __webpack_require__(178);
  var create = __webpack_require__(81);
  var getPrototypeOf = __webpack_require__(46);
  var gOPN = __webpack_require__(82).f;
  var getIterFn = __webpack_require__(194);
  var uid = __webpack_require__(88);
  var wks = __webpack_require__(32);
  var createArrayMethod = __webpack_require__(55);
  var createArrayIncludes = __webpack_require__(125);
  var speciesConstructor = __webpack_require__(137);
  var ArrayIterators = __webpack_require__(195);
  var Iterators = __webpack_require__(93);
  var $iterDetect = __webpack_require__(131);
  var setSpecies = __webpack_require__(86);
  var arrayFill = __webpack_require__(170);
  var arrayCopyWithin = __webpack_require__(259);
  var $DP = __webpack_require__(35);
  var $GOPD = __webpack_require__(45);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(9);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (vueElement, googleMapObject, events) {
  _lodash2.default.forEach(events, function (eventName) {
    var exposedName = eventName;
    googleMapObject.addListener(eventName, function (ev) {
      vueElement.$emit(exposedName, ev);
    });
  });
}; /* vim: set softtabstop=2 shiftwidth=2 expandtab : */

/***/ }),
/* 70 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(32)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(42)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(88)('meta');
var isObject = __webpack_require__(30);
var has = __webpack_require__(41);
var setDesc = __webpack_require__(35).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(29)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseBoundCurves = exports.calculatePaddingBoxPath = exports.calculateBorderBoxPath = exports.parsePathForBorder = exports.parseDocumentSize = exports.calculateContentBox = exports.calculatePaddingBox = exports.parseBounds = exports.Bounds = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Vector = __webpack_require__(146);

var _Vector2 = _interopRequireDefault(_Vector);

var _BezierCurve = __webpack_require__(1154);

var _BezierCurve2 = _interopRequireDefault(_BezierCurve);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TOP = 0;
var RIGHT = 1;
var BOTTOM = 2;
var LEFT = 3;

var H = 0;
var V = 1;

var Bounds = exports.Bounds = function () {
    function Bounds(x, y, w, h) {
        _classCallCheck(this, Bounds);

        this.left = x;
        this.top = y;
        this.width = w;
        this.height = h;
    }

    _createClass(Bounds, null, [{
        key: 'fromClientRect',
        value: function fromClientRect(clientRect, scrollX, scrollY) {
            return new Bounds(clientRect.left + scrollX, clientRect.top + scrollY, clientRect.width, clientRect.height);
        }
    }]);

    return Bounds;
}();

var parseBounds = exports.parseBounds = function parseBounds(node, scrollX, scrollY) {
    return Bounds.fromClientRect(node.getBoundingClientRect(), scrollX, scrollY);
};

var calculatePaddingBox = exports.calculatePaddingBox = function calculatePaddingBox(bounds, borders) {
    return new Bounds(bounds.left + borders[LEFT].borderWidth, bounds.top + borders[TOP].borderWidth, bounds.width - (borders[RIGHT].borderWidth + borders[LEFT].borderWidth), bounds.height - (borders[TOP].borderWidth + borders[BOTTOM].borderWidth));
};

var calculateContentBox = exports.calculateContentBox = function calculateContentBox(bounds, padding, borders) {
    // TODO support percentage paddings
    var paddingTop = padding[TOP].value;
    var paddingRight = padding[RIGHT].value;
    var paddingBottom = padding[BOTTOM].value;
    var paddingLeft = padding[LEFT].value;

    return new Bounds(bounds.left + paddingLeft + borders[LEFT].borderWidth, bounds.top + paddingTop + borders[TOP].borderWidth, bounds.width - (borders[RIGHT].borderWidth + borders[LEFT].borderWidth + paddingLeft + paddingRight), bounds.height - (borders[TOP].borderWidth + borders[BOTTOM].borderWidth + paddingTop + paddingBottom));
};

var parseDocumentSize = exports.parseDocumentSize = function parseDocumentSize(document) {
    var body = document.body;
    var documentElement = document.documentElement;

    if (!body || !documentElement) {
        throw new Error( false ? 'Unable to get document size' : '');
    }
    var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));

    var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));

    return new Bounds(0, 0, width, height);
};

var parsePathForBorder = exports.parsePathForBorder = function parsePathForBorder(curves, borderSide) {
    switch (borderSide) {
        case TOP:
            return createPathFromCurves(curves.topLeftOuter, curves.topLeftInner, curves.topRightOuter, curves.topRightInner);
        case RIGHT:
            return createPathFromCurves(curves.topRightOuter, curves.topRightInner, curves.bottomRightOuter, curves.bottomRightInner);
        case BOTTOM:
            return createPathFromCurves(curves.bottomRightOuter, curves.bottomRightInner, curves.bottomLeftOuter, curves.bottomLeftInner);
        case LEFT:
        default:
            return createPathFromCurves(curves.bottomLeftOuter, curves.bottomLeftInner, curves.topLeftOuter, curves.topLeftInner);
    }
};

var createPathFromCurves = function createPathFromCurves(outer1, inner1, outer2, inner2) {
    var path = [];
    if (outer1 instanceof _BezierCurve2.default) {
        path.push(outer1.subdivide(0.5, false));
    } else {
        path.push(outer1);
    }

    if (outer2 instanceof _BezierCurve2.default) {
        path.push(outer2.subdivide(0.5, true));
    } else {
        path.push(outer2);
    }

    if (inner2 instanceof _BezierCurve2.default) {
        path.push(inner2.subdivide(0.5, true).reverse());
    } else {
        path.push(inner2);
    }

    if (inner1 instanceof _BezierCurve2.default) {
        path.push(inner1.subdivide(0.5, false).reverse());
    } else {
        path.push(inner1);
    }

    return path;
};

var calculateBorderBoxPath = exports.calculateBorderBoxPath = function calculateBorderBoxPath(curves) {
    return [curves.topLeftOuter, curves.topRightOuter, curves.bottomRightOuter, curves.bottomLeftOuter];
};

var calculatePaddingBoxPath = exports.calculatePaddingBoxPath = function calculatePaddingBoxPath(curves) {
    return [curves.topLeftInner, curves.topRightInner, curves.bottomRightInner, curves.bottomLeftInner];
};

var parseBoundCurves = exports.parseBoundCurves = function parseBoundCurves(bounds, borders, borderRadius) {
    var HALF_WIDTH = bounds.width / 2;
    var HALF_HEIGHT = bounds.height / 2;
    var tlh = borderRadius[CORNER.TOP_LEFT][H].getAbsoluteValue(bounds.width) < HALF_WIDTH ? borderRadius[CORNER.TOP_LEFT][H].getAbsoluteValue(bounds.width) : HALF_WIDTH;
    var tlv = borderRadius[CORNER.TOP_LEFT][V].getAbsoluteValue(bounds.height) < HALF_HEIGHT ? borderRadius[CORNER.TOP_LEFT][V].getAbsoluteValue(bounds.height) : HALF_HEIGHT;
    var trh = borderRadius[CORNER.TOP_RIGHT][H].getAbsoluteValue(bounds.width) < HALF_WIDTH ? borderRadius[CORNER.TOP_RIGHT][H].getAbsoluteValue(bounds.width) : HALF_WIDTH;
    var trv = borderRadius[CORNER.TOP_RIGHT][V].getAbsoluteValue(bounds.height) < HALF_HEIGHT ? borderRadius[CORNER.TOP_RIGHT][V].getAbsoluteValue(bounds.height) : HALF_HEIGHT;
    var brh = borderRadius[CORNER.BOTTOM_RIGHT][H].getAbsoluteValue(bounds.width) < HALF_WIDTH ? borderRadius[CORNER.BOTTOM_RIGHT][H].getAbsoluteValue(bounds.width) : HALF_WIDTH;
    var brv = borderRadius[CORNER.BOTTOM_RIGHT][V].getAbsoluteValue(bounds.height) < HALF_HEIGHT ? borderRadius[CORNER.BOTTOM_RIGHT][V].getAbsoluteValue(bounds.height) : HALF_HEIGHT;
    var blh = borderRadius[CORNER.BOTTOM_LEFT][H].getAbsoluteValue(bounds.width) < HALF_WIDTH ? borderRadius[CORNER.BOTTOM_LEFT][H].getAbsoluteValue(bounds.width) : HALF_WIDTH;
    var blv = borderRadius[CORNER.BOTTOM_LEFT][V].getAbsoluteValue(bounds.height) < HALF_HEIGHT ? borderRadius[CORNER.BOTTOM_LEFT][V].getAbsoluteValue(bounds.height) : HALF_HEIGHT;

    var topWidth = bounds.width - trh;
    var rightHeight = bounds.height - brv;
    var bottomWidth = bounds.width - brh;
    var leftHeight = bounds.height - blv;

    return {
        topLeftOuter: tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new _Vector2.default(bounds.left, bounds.top),
        topLeftInner: tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borders[LEFT].borderWidth, bounds.top + borders[TOP].borderWidth, Math.max(0, tlh - borders[LEFT].borderWidth), Math.max(0, tlv - borders[TOP].borderWidth), CORNER.TOP_LEFT) : new _Vector2.default(bounds.left + borders[LEFT].borderWidth, bounds.top + borders[TOP].borderWidth),
        topRightOuter: trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new _Vector2.default(bounds.left + bounds.width, bounds.top),
        topRightInner: trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borders[LEFT].borderWidth), bounds.top + borders[TOP].borderWidth, topWidth > bounds.width + borders[LEFT].borderWidth ? 0 : trh - borders[LEFT].borderWidth, trv - borders[TOP].borderWidth, CORNER.TOP_RIGHT) : new _Vector2.default(bounds.left + bounds.width - borders[RIGHT].borderWidth, bounds.top + borders[TOP].borderWidth),
        bottomRightOuter: brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new _Vector2.default(bounds.left + bounds.width, bounds.top + bounds.height),
        bottomRightInner: brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borders[LEFT].borderWidth), bounds.top + Math.min(rightHeight, bounds.height + borders[TOP].borderWidth), Math.max(0, brh - borders[RIGHT].borderWidth), brv - borders[BOTTOM].borderWidth, CORNER.BOTTOM_RIGHT) : new _Vector2.default(bounds.left + bounds.width - borders[RIGHT].borderWidth, bounds.top + bounds.height - borders[BOTTOM].borderWidth),
        bottomLeftOuter: blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new _Vector2.default(bounds.left, bounds.top + bounds.height),
        bottomLeftInner: blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borders[LEFT].borderWidth, bounds.top + leftHeight, Math.max(0, blh - borders[LEFT].borderWidth), blv - borders[BOTTOM].borderWidth, CORNER.BOTTOM_LEFT) : new _Vector2.default(bounds.left + borders[LEFT].borderWidth, bounds.top + bounds.height - borders[BOTTOM].borderWidth)
    };
};

var CORNER = {
    TOP_LEFT: 0,
    TOP_RIGHT: 1,
    BOTTOM_RIGHT: 2,
    BOTTOM_LEFT: 3
};

var getCurvePoints = function getCurvePoints(x, y, r1, r2, position) {
    var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
    var ox = r1 * kappa; // control point offset horizontal
    var oy = r2 * kappa; // control point offset vertical
    var xm = x + r1; // x-middle
    var ym = y + r2; // y-middle

    switch (position) {
        case CORNER.TOP_LEFT:
            return new _BezierCurve2.default(new _Vector2.default(x, ym), new _Vector2.default(x, ym - oy), new _Vector2.default(xm - ox, y), new _Vector2.default(xm, y));
        case CORNER.TOP_RIGHT:
            return new _BezierCurve2.default(new _Vector2.default(x, y), new _Vector2.default(x + ox, y), new _Vector2.default(xm, ym - oy), new _Vector2.default(xm, ym));
        case CORNER.BOTTOM_RIGHT:
            return new _BezierCurve2.default(new _Vector2.default(xm, y), new _Vector2.default(xm, y + oy), new _Vector2.default(x + ox, ym), new _Vector2.default(x, ym));
        case CORNER.BOTTOM_LEFT:
        default:
            return new _BezierCurve2.default(new _Vector2.default(xm, ym), new _Vector2.default(xm - ox, ym), new _Vector2.default(x, y + oy), new _Vector2.default(x, y));
    }
};

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// http://dev.w3.org/csswg/css-color/

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HEX3 = /^#([a-f0-9]{3})$/i;
var hex3 = function hex3(value) {
    var match = value.match(HEX3);
    if (match) {
        return [parseInt(match[1][0] + match[1][0], 16), parseInt(match[1][1] + match[1][1], 16), parseInt(match[1][2] + match[1][2], 16), null];
    }
    return false;
};

var HEX6 = /^#([a-f0-9]{6})$/i;
var hex6 = function hex6(value) {
    var match = value.match(HEX6);
    if (match) {
        return [parseInt(match[1].substring(0, 2), 16), parseInt(match[1].substring(2, 4), 16), parseInt(match[1].substring(4, 6), 16), null];
    }
    return false;
};

var RGB = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
var rgb = function rgb(value) {
    var match = value.match(RGB);
    if (match) {
        return [Number(match[1]), Number(match[2]), Number(match[3]), null];
    }
    return false;
};

var RGBA = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d?\.?\d+)\s*\)$/;
var rgba = function rgba(value) {
    var match = value.match(RGBA);
    if (match && match.length > 4) {
        return [Number(match[1]), Number(match[2]), Number(match[3]), Number(match[4])];
    }
    return false;
};

var fromArray = function fromArray(array) {
    return [Math.min(array[0], 255), Math.min(array[1], 255), Math.min(array[2], 255), array.length > 3 ? array[3] : null];
};

var namedColor = function namedColor(name) {
    var color = NAMED_COLORS[name.toLowerCase()];
    return color ? color : false;
};

var Color = function () {
    function Color(value) {
        _classCallCheck(this, Color);

        var _ref = Array.isArray(value) ? fromArray(value) : hex3(value) || rgb(value) || rgba(value) || namedColor(value) || hex6(value) || [0, 0, 0, null],
            _ref2 = _slicedToArray(_ref, 4),
            r = _ref2[0],
            g = _ref2[1],
            b = _ref2[2],
            a = _ref2[3];

        this.r = r;
        this.g = g;
        this.b = b;
        this.a = a;
    }

    _createClass(Color, [{
        key: 'isTransparent',
        value: function isTransparent() {
            return this.a === 0;
        }
    }, {
        key: 'toString',
        value: function toString() {
            return this.a !== null && this.a !== 1 ? 'rgba(' + this.r + ',' + this.g + ',' + this.b + ',' + this.a + ')' : 'rgb(' + this.r + ',' + this.g + ',' + this.b + ')';
        }
    }]);

    return Color;
}();

exports.default = Color;


var NAMED_COLORS = {
    transparent: [0, 0, 0, 0],
    aliceblue: [240, 248, 255, null],
    antiquewhite: [250, 235, 215, null],
    aqua: [0, 255, 255, null],
    aquamarine: [127, 255, 212, null],
    azure: [240, 255, 255, null],
    beige: [245, 245, 220, null],
    bisque: [255, 228, 196, null],
    black: [0, 0, 0, null],
    blanchedalmond: [255, 235, 205, null],
    blue: [0, 0, 255, null],
    blueviolet: [138, 43, 226, null],
    brown: [165, 42, 42, null],
    burlywood: [222, 184, 135, null],
    cadetblue: [95, 158, 160, null],
    chartreuse: [127, 255, 0, null],
    chocolate: [210, 105, 30, null],
    coral: [255, 127, 80, null],
    cornflowerblue: [100, 149, 237, null],
    cornsilk: [255, 248, 220, null],
    crimson: [220, 20, 60, null],
    cyan: [0, 255, 255, null],
    darkblue: [0, 0, 139, null],
    darkcyan: [0, 139, 139, null],
    darkgoldenrod: [184, 134, 11, null],
    darkgray: [169, 169, 169, null],
    darkgreen: [0, 100, 0, null],
    darkgrey: [169, 169, 169, null],
    darkkhaki: [189, 183, 107, null],
    darkmagenta: [139, 0, 139, null],
    darkolivegreen: [85, 107, 47, null],
    darkorange: [255, 140, 0, null],
    darkorchid: [153, 50, 204, null],
    darkred: [139, 0, 0, null],
    darksalmon: [233, 150, 122, null],
    darkseagreen: [143, 188, 143, null],
    darkslateblue: [72, 61, 139, null],
    darkslategray: [47, 79, 79, null],
    darkslategrey: [47, 79, 79, null],
    darkturquoise: [0, 206, 209, null],
    darkviolet: [148, 0, 211, null],
    deeppink: [255, 20, 147, null],
    deepskyblue: [0, 191, 255, null],
    dimgray: [105, 105, 105, null],
    dimgrey: [105, 105, 105, null],
    dodgerblue: [30, 144, 255, null],
    firebrick: [178, 34, 34, null],
    floralwhite: [255, 250, 240, null],
    forestgreen: [34, 139, 34, null],
    fuchsia: [255, 0, 255, null],
    gainsboro: [220, 220, 220, null],
    ghostwhite: [248, 248, 255, null],
    gold: [255, 215, 0, null],
    goldenrod: [218, 165, 32, null],
    gray: [128, 128, 128, null],
    green: [0, 128, 0, null],
    greenyellow: [173, 255, 47, null],
    grey: [128, 128, 128, null],
    honeydew: [240, 255, 240, null],
    hotpink: [255, 105, 180, null],
    indianred: [205, 92, 92, null],
    indigo: [75, 0, 130, null],
    ivory: [255, 255, 240, null],
    khaki: [240, 230, 140, null],
    lavender: [230, 230, 250, null],
    lavenderblush: [255, 240, 245, null],
    lawngreen: [124, 252, 0, null],
    lemonchiffon: [255, 250, 205, null],
    lightblue: [173, 216, 230, null],
    lightcoral: [240, 128, 128, null],
    lightcyan: [224, 255, 255, null],
    lightgoldenrodyellow: [250, 250, 210, null],
    lightgray: [211, 211, 211, null],
    lightgreen: [144, 238, 144, null],
    lightgrey: [211, 211, 211, null],
    lightpink: [255, 182, 193, null],
    lightsalmon: [255, 160, 122, null],
    lightseagreen: [32, 178, 170, null],
    lightskyblue: [135, 206, 250, null],
    lightslategray: [119, 136, 153, null],
    lightslategrey: [119, 136, 153, null],
    lightsteelblue: [176, 196, 222, null],
    lightyellow: [255, 255, 224, null],
    lime: [0, 255, 0, null],
    limegreen: [50, 205, 50, null],
    linen: [250, 240, 230, null],
    magenta: [255, 0, 255, null],
    maroon: [128, 0, 0, null],
    mediumaquamarine: [102, 205, 170, null],
    mediumblue: [0, 0, 205, null],
    mediumorchid: [186, 85, 211, null],
    mediumpurple: [147, 112, 219, null],
    mediumseagreen: [60, 179, 113, null],
    mediumslateblue: [123, 104, 238, null],
    mediumspringgreen: [0, 250, 154, null],
    mediumturquoise: [72, 209, 204, null],
    mediumvioletred: [199, 21, 133, null],
    midnightblue: [25, 25, 112, null],
    mintcream: [245, 255, 250, null],
    mistyrose: [255, 228, 225, null],
    moccasin: [255, 228, 181, null],
    navajowhite: [255, 222, 173, null],
    navy: [0, 0, 128, null],
    oldlace: [253, 245, 230, null],
    olive: [128, 128, 0, null],
    olivedrab: [107, 142, 35, null],
    orange: [255, 165, 0, null],
    orangered: [255, 69, 0, null],
    orchid: [218, 112, 214, null],
    palegoldenrod: [238, 232, 170, null],
    palegreen: [152, 251, 152, null],
    paleturquoise: [175, 238, 238, null],
    palevioletred: [219, 112, 147, null],
    papayawhip: [255, 239, 213, null],
    peachpuff: [255, 218, 185, null],
    peru: [205, 133, 63, null],
    pink: [255, 192, 203, null],
    plum: [221, 160, 221, null],
    powderblue: [176, 224, 230, null],
    purple: [128, 0, 128, null],
    rebeccapurple: [102, 51, 153, null],
    red: [255, 0, 0, null],
    rosybrown: [188, 143, 143, null],
    royalblue: [65, 105, 225, null],
    saddlebrown: [139, 69, 19, null],
    salmon: [250, 128, 114, null],
    sandybrown: [244, 164, 96, null],
    seagreen: [46, 139, 87, null],
    seashell: [255, 245, 238, null],
    sienna: [160, 82, 45, null],
    silver: [192, 192, 192, null],
    skyblue: [135, 206, 235, null],
    slateblue: [106, 90, 205, null],
    slategray: [112, 128, 144, null],
    slategrey: [112, 128, 144, null],
    snow: [255, 250, 250, null],
    springgreen: [0, 255, 127, null],
    steelblue: [70, 130, 180, null],
    tan: [210, 180, 140, null],
    teal: [0, 128, 128, null],
    thistle: [216, 191, 216, null],
    tomato: [255, 99, 71, null],
    turquoise: [64, 224, 208, null],
    violet: [238, 130, 238, null],
    wheat: [245, 222, 179, null],
    white: [255, 255, 255, null],
    whitesmoke: [245, 245, 245, null],
    yellow: [255, 255, 0, null],
    yellowgreen: [154, 205, 50, null]
};

var TRANSPARENT = exports.TRANSPARENT = new Color([0, 0, 0, 0]);

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(2208)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(524),
  /* template */
  __webpack_require__(2166),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _deferredReady = __webpack_require__(156);

/**
 * @class MapElementMixin @mixins DeferredReadyMixin
 *
 * Extends components to include the following fields:
 *
 * @property $map        The Google map (valid only after the promise returns)
 *
 *
 * */
exports.default = {

  mixins: [_deferredReady.DeferredReadyMixin],

  created: function created() {
    var _this = this;

    /* Search for the Map component in the parent */
    var search = this.$findAncestor(function (ans) {
      return ans.$mapCreated;
    });

    if (!search) {
      throw new Error(this.constructor.name + ' component must be used within a <Map>');
    }

    this.$mapPromise = search.$mapCreated.then(function (map) {
      _this.$map = map;
    });
    // FIXME: This is a hack to ensure correct loading
    // when the map has already be instantiated.
    if (search.$mapObject) {
      this.$map = search.$mapObject;
    }
    this.$MapElementMixin = search;
    this.$map = null;
  },
  beforeDeferredReady: function beforeDeferredReady() {
    return this.$mapPromise;
  },


  methods: {
    $findAncestor: function $findAncestor(condition) {
      var search = this.$parent;

      while (search) {
        if (condition(search)) {
          return search;
        }
        search = search.$parent;
      }
      return null;
    }
  }

}; /* vim: set softtabstop=2 shiftwidth=2 expandtab : */

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  id: 1,
  name_ca: 'Persona física',
  name_en: 'Natural person',
  name_es: 'Persona física'
}, {
  id: 2,
  name_ca: 'Persona jurídica',
  name_en: 'Legal person',
  name_es: 'Persona jurídica'
}]);

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(50);
var call = __webpack_require__(270);
var isArrayIter = __webpack_require__(178);
var anObject = __webpack_require__(24);
var toLength = __webpack_require__(36);
var getIterFn = __webpack_require__(194);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(24);
var dPs = __webpack_require__(276);
var enumBugKeys = __webpack_require__(174);
var IE_PROTO = __webpack_require__(186)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(173)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(176).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(278);
var hiddenKeys = __webpack_require__(174).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(278);
var enumBugKeys = __webpack_require__(174);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(43);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(26);
var dP = __webpack_require__(35);
var DESCRIPTORS = __webpack_require__(34);
var SPECIES = __webpack_require__(32)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(59);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 88 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)
var startOfISOWeek = __webpack_require__(91)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * var result = getISOYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()

  var fourthOfJanuaryOfNextYear = new Date(0)
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4)
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0)
  var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear)

  var fourthOfJanuaryOfThisYear = new Date(0)
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4)
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0)
  var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear)

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year
  } else {
    return year - 1
  }
}

module.exports = getISOYear


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay (dirtyDate) {
  var date = parse(dirtyDate)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfDay


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var startOfWeek = __webpack_require__(142)

/**
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek (dirtyDate) {
  return startOfWeek(dirtyDate, {weekStartsOn: 1})
}

module.exports = startOfISOWeek


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(160);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(35).f;
var has = __webpack_require__(41);
var TAG = __webpack_require__(32)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var defined = __webpack_require__(57);
var fails = __webpack_require__(29);
var spaces = __webpack_require__(190);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(30);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.calculateLengthFromValueWithUnit = exports.LENGTH_TYPE = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _NodeContainer = __webpack_require__(144);

var _NodeContainer2 = _interopRequireDefault(_NodeContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LENGTH_WITH_UNIT = /([\d.]+)(px|r?em|%)/i;

var LENGTH_TYPE = exports.LENGTH_TYPE = {
    PX: 0,
    PERCENTAGE: 1
};

var Length = function () {
    function Length(value) {
        _classCallCheck(this, Length);

        this.type = value.substr(value.length - 1) === '%' ? LENGTH_TYPE.PERCENTAGE : LENGTH_TYPE.PX;
        var parsedValue = parseFloat(value);
        if (false) {
            console.error('Invalid value given for Length: "' + value + '"');
        }
        this.value = isNaN(parsedValue) ? 0 : parsedValue;
    }

    _createClass(Length, [{
        key: 'isPercentage',
        value: function isPercentage() {
            return this.type === LENGTH_TYPE.PERCENTAGE;
        }
    }, {
        key: 'getAbsoluteValue',
        value: function getAbsoluteValue(parentLength) {
            return this.isPercentage() ? parentLength * (this.value / 100) : this.value;
        }
    }], [{
        key: 'create',
        value: function create(v) {
            return new Length(v);
        }
    }]);

    return Length;
}();

exports.default = Length;


var getRootFontSize = function getRootFontSize(container) {
    var parent = container.parent;
    return parent ? getRootFontSize(parent) : parseFloat(container.style.font.fontSize);
};

var calculateLengthFromValueWithUnit = exports.calculateLengthFromValueWithUnit = function calculateLengthFromValueWithUnit(container, value, unit) {
    switch (unit) {
        case 'px':
        case '%':
            return new Length(value + unit);
        case 'em':
        case 'rem':
            var length = new Length(value);
            length.value *= unit === 'em' ? parseFloat(container.style.font.fontSize) : getRootFontSize(container);
            return length;
        default:
            // TODO: handle correctly if unknown unit is used
            return new Length('0');
    }
};

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  if (Math.abs(x) > 1) {
    x = (x > 1) ? 1 : -1;
  }
  return Math.asin(x);
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(eccent, sinphi, cosphi) {
  var con = eccent * sinphi;
  return cosphi / (Math.sqrt(1 - con * con));
});

/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = {};

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    'name_ca': 'Altres persones físiques o jurídiques',
    'name_en': 'Other natural or legal persons',
    'name_es': 'Otras personas físicas o jurídicas'
}, {
    id: 2,
    'name_ca': 'Entitats de crèdit de capital públic estatal',
    'name_en': 'State public credit institutions',
    'name_es': 'Entidades de crédito de capital público estatal'
}, {
    id: 3,
    'name_ca': 'Bancs privats',
    'name_en': 'Private banks',
    'name_es': 'Bancos privados'
}, {
    id: 4,
    'name_ca': 'Caixes d\'estalvi',
    'name_en': 'Savings banks',
    'name_es': 'Cajas de ahorro'
}, {
    id: 5,
    'name_ca': 'Cooperatives de crèdit',
    'name_en': 'Credit unions',
    'name_es': 'Cooperativas de crédito'
}, {
    id: 6,
    'name_ca': 'Societats de crèdit hipotecari',
    'name_en': 'Mortgage companies',
    'name_es': 'Sociedades de crédito hipotecario'
}, {
    id: 7,
    'name_ca': 'Societats d\'arrendament financer',
    'name_en': 'Leasing companies',
    'name_es': 'Sociedades de arrendamiento financiero'
}, {
    id: 8,
    'name_ca': 'Entitats de crèdit de capital públic estatal',
    'name_en': 'State public credit institutions',
    'name_es': 'Entidades de crédito de capital público estatal'
}, {
    id: 9,
    'name_ca': 'Altres entitats de crèdit',
    'name_en': 'Other credit institutions',
    'name_es': 'Otras entidades de crédito'
}, {
    id: 10,
    'name_ca': 'Entitats asseguradores',
    'name_en': 'Insurance companies',
    'name_es': 'Entidades aseguradoras'
}, {
    id: 11,
    'name_ca': 'Administracions i organismes públics',
    'name_en': 'Public administrations and institutions',
    'name_es': 'Administraciones y organismos públicos'
}]);

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// si canvia algun camp revisar i actualitzar, per exemple, RealEstateEditor.vue funció "set_realestate_property_type"
/* harmony default export */ __webpack_exports__["a"] = ([{
    'id': 1,
    'name_ca': 'Pis',
    'name_es': 'Piso',
    'name_en': 'Flat',
    'name_db': 'residential',
    'usage_type_ca': "Habitatge",
    'usage_type_en': "Dwelling",
    'usage_type_es': "Vivienda"
}, {
    'id': 2,
    'name_ca': 'Casa adossada',
    'name_es': 'Casa adosada',
    'name_en': 'Attached single-family house',
    'name_db': 'residential',
    'usage_type_ca': "Habitatge",
    'usage_type_en': "Dwelling",
    'usage_type_es': "Vivienda"
}, {
    'id': 3,
    'name_ca': 'Casa independent',
    'name_es': 'Casa independiente',
    'name_en': 'Detached single-family house',
    'name_db': 'residential',
    'usage_type_ca': "Habitatge",
    'usage_type_en': "Dwelling",
    'usage_type_es': "Vivienda"
}, {
    'id': 4,
    'name_ca': 'Apartament',
    'name_es': 'Apartamento',
    'name_en': 'Apartment',
    'name_db': 'residential',
    'usage_type_ca': "Habitatge",
    'usage_type_en': "Dwelling",
    'usage_type_es': "Vivienda"
}, {
    'id': 5,
    'name_ca': 'Loft',
    'name_es': 'Loft',
    'name_en': 'Loft',
    'name_db': 'residential',
    'usage_type_ca': "Habitatge",
    'usage_type_en': "Dwelling",
    'usage_type_es': "Vivienda"
}, {
    'id': 6,
    'name_ca': 'Estudi',
    'name_es': 'Estudio',
    'name_en': 'Studio',
    'name_db': 'office',
    'usage_type_ca': "Local sense accés directe",
    'usage_type_en': "Commercial premise without direct access",
    'usage_type_es': "Local sin acceso directo"
}, {
    'id': 7,
    'name_ca': 'Dúplex',
    'name_es': 'Dúplex',
    'name_en': 'Duplex',
    'name_db': 'residential',
    'usage_type_ca': "Habitatge",
    'usage_type_en': "Dwelling",
    'usage_type_es': "Vivienda"
}, {
    'id': 8,
    'name_ca': 'Triplex',
    'name_es': 'Triplex',
    'name_en': 'Triplex',
    'name_db': 'residential',
    'usage_type_ca': "Habitatge",
    'usage_type_en': "Dwelling",
    'usage_type_es': "Vivienda"
}, {
    'id': 9,
    'name_ca': 'Edifici',
    'name_es': 'Edificio',
    'name_en': 'Building',
    'name_db': 'entire_buildings',
    'usage_type_ca': "Edifici",
    'usage_type_en': "Building",
    'usage_type_es': "Edificio"
}, {
    'id': 10,
    'name_ca': 'Plaça d\'aparcament',
    'name_es': 'Plaza de aparcamiento',
    'name_en': 'Parking space',
    'name_db': 'parking',
    'usage_type_ca': "Aparcament",
    'usage_type_en': "Parking",
    'usage_type_es': "Aparcamiento"
}, {
    'id': 11,
    'name_ca': 'Garatge',
    'name_es': 'Garaje',
    'name_en': 'Parking',
    'name_db': 'parking',
    'usage_type_ca': "Aparcament",
    'usage_type_en': "Parking",
    'usage_type_es': "Aparcamiento"
}, {
    'id': 12,
    'name_ca': 'Finca rústica',
    'name_es': 'Finca rústica',
    'name_en': 'Rural house',
    'name_db': 'residential',
    'usage_type_ca': "Finca rústica",
    'usage_type_en': "Rural house",
    'usage_type_es': "Finca rústica"
}, {
    'id': 13,
    'name_ca': 'Masia',
    'name_es': 'Masía',
    'name_en': 'Farmhouse',
    'name_db': 'residential',
    'usage_type_ca': "Finca rústica",
    'usage_type_en': "Rural house",
    'usage_type_es': "Finca rústica"
}, {
    'id': 14,
    'name_ca': 'Piscina',
    'name_es': 'Piscina',
    'name_en': 'Swimming pool',
    'name_db': 'residential',
    'usage_type_ca': "Piscina",
    'usage_type_en': "Swimming pool",
    'usage_type_es': "Piscina"
}, {
    'id': 15,
    'name_ca': 'Traster',
    'name_es': 'Trastero',
    'name_en': 'Storage room',
    'name_db': 'storage',
    'usage_type_ca': "Traster",
    'usage_type_en': "Storage",
    'usage_type_es': "Traster"
}, {
    'id': 16,
    'name_ca': 'Pista esportiva',
    'name_es': 'Pista deportiva',
    'name_en': 'Sports pitch',
    'name_db': 'retail_and_industrial',
    'usage_type_ca': "Pista esportiva",
    'usage_type_en': "Sports pitch",
    'usage_type_es': "Finca rústica"
}, {
    'id': 17,
    'name_ca': 'Club esportiu',
    'name_es': 'Club deportivo',
    'name_en': 'Sports club',
    'name_db': 'retail_and_industrial',
    'usage_type_ca': "Club esportiu",
    'usage_type_en': "Sports club",
    'usage_type_es': "Club deportivo"
}, {
    'id': 18,
    'name_ca': 'Local amb accés directe',
    'name_es': 'Local con acceso directo',
    'name_en': 'Commercial premise with direct access',
    'name_db': 'retail_and_industrial',
    'usage_type_ca': "Local amb accés directe",
    'usage_type_en': "Commercial premise with direct access",
    'usage_type_es': "Local con acceso directo"
}, {
    'id': 19,
    'name_ca': 'Local sense accés directe',
    'name_es': 'Local sin acceso directo',
    'name_en': 'Commercial premise without direct access',
    'name_db': 'office',
    'usage_type_ca': "Local sense accés directe",
    'usage_type_en': "Commercial premise without direct access",
    'usage_type_es': "Local sin acceso directo"
}, {
    'id': 20,
    'name_ca': 'Nau industrial',
    'name_es': 'Nave industrial',
    'name_en': 'Industrial warehouse',
    'name_db': 'retail_and_industrial',
    'usage_type_ca': "Nau industrial",
    'usage_type_en': "Industrial warehouse",
    'usage_type_es': "Nave industrial"
}, {
    'id': 21,
    'name_ca': 'Escola',
    'name_es': 'Escuela',
    'name_en': 'School',
    'name_db': 'retail_and_industrial',
    'usage_type_ca': "Escola",
    'usage_type_en': "School",
    'usage_type_es': "Escuela"
}, {
    'id': 22,
    'name_ca': 'Hotel',
    'name_es': 'Hotel',
    'name_en': 'Hotel',
    'name_db': 'retail_and_industrial',
    'usage_type_ca': "Hotel",
    'usage_type_en': "Hotel",
    'usage_type_es': "Hotel"
}, {
    'id': 23,
    'name_ca': 'Sòl urbà consolidat',
    'name_es': 'Suelo urbano consolidado',
    'name_en': 'Consolidated urban land',
    'name_db': 'land',
    'usage_type_ca': "Sòl urbà consolidat",
    'usage_type_en': "Consolidated urban land",
    'usage_type_es': "Suelo urbano consolidado"
}, {
    'id': 24,
    'name_ca': 'Sòl urbà no consolidat',
    'name_es': 'Suelo urbano no consolidado',
    'name_en': 'Unconsolidated urban land',
    'name_db': 'land',
    'usage_type_ca': "Sòl urbà no consolidat",
    'usage_type_en': "Unconsolidated urban land",
    'usage_type_es': "Suelo urbano no consolidado"
}, {
    'id': 25,
    'name_ca': 'Sòl urbanitzable programat',
    'name_es': 'Suelo urbanizable programado',
    'name_en': 'Programmed developable land',
    'name_db': 'land',
    'usage_type_ca': 'Sòl urbanitzable programat',
    'usage_type_es': 'Suelo urbanizable programado',
    'usage_type_en': 'Programmed developable land'
}, {
    'id': 26,
    'name_ca': 'Sòl urbanitzable no programat',
    'name_es': 'Suelo urbanizable no programado',
    'name_en': 'Unprogrammed developable land',
    'name_db': 'land',
    'usage_type_ca': 'Sòl urbanitzable no programat',
    'usage_type_es': 'Suelo urbanizable no programado',
    'usage_type_en': 'Unprogrammed developable land'
}, {
    'id': 27,
    'name_ca': 'Sòl no urbanitzable',
    'name_es': 'Suelo no urbanizable',
    'name_en': 'Non-buildable land',
    'name_db': 'land',
    'usage_type_ca': 'Sòl no urbanitzable',
    'usage_type_es': 'Suelo no urbanizable',
    'usage_type_en': 'Non-buildable land'
}]);

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(49);
var TAG = __webpack_require__(32)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(49);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 105 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added
 * @returns {Date} the new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * var result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays (dirtyDate, dirtyAmount) {
  var date = parse(dirtyDate)
  var amount = Number(dirtyAmount)
  date.setDate(date.getDate() + amount)
  return date
}

module.exports = addDays


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added
 * @returns {Date} the new date with the milliseconds added
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds (dirtyDate, dirtyAmount) {
  var timestamp = parse(dirtyDate).getTime()
  var amount = Number(dirtyAmount)
  return new Date(timestamp + amount)
}

module.exports = addMilliseconds


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * var result = compareAsc(
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * )
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * var result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */
function compareAsc (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var timeLeft = dateLeft.getTime()
  var dateRight = parse(dirtyDateRight)
  var timeRight = dateRight.getTime()

  if (timeLeft < timeRight) {
    return -1
  } else if (timeLeft > timeRight) {
    return 1
  } else {
    return 0
  }
}

module.exports = compareAsc


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__(89)
var startOfISOWeek = __webpack_require__(91)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an ISO year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * var result = startOfISOYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOYear (dirtyDate) {
  var year = getISOYear(dirtyDate)
  var fourthOfJanuary = new Date(0)
  fourthOfJanuary.setFullYear(year, 0, 4)
  fourthOfJanuary.setHours(0, 0, 0, 0)
  var date = startOfISOWeek(fourthOfJanuary)
  return date
}

module.exports = startOfISOYear


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {/*! @license Firebase v3.9.0
Build: rev-cc77c9e
Terms: https://firebase.google.com/terms/ */

var firebase=function(e){function t(r){if(n[r])return n[r].exports;var i=n[r]={i:r,l:!1,exports:{}};return e[r].call(i.exports,i,i.exports,t),i.l=!0,i.exports}var n={};return t.m=e,t.c=n,t.i=function(e){return e},t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=11)}([function(e,t,n){"use strict";(function(e){Object.defineProperty(t,"__esModule",{value:!0});var r=void 0;if(void 0!==e)r=e;else if("undefined"!=typeof self)r=self;else try{r=Function("return this")()}catch(e){throw new Error("polyfill failed because global object is unavailable in this environment")}var i=r.Promise||n(8);t.local={Promise:i,GoogPromise:i}}).call(t,n(1))},function(e,t){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(e){"object"==typeof window&&(n=window)}e.exports=n},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(5),i=(0,r.createFirebaseNamespace)();t.default=i,e.exports=t.default},function(e,t,n){"use strict";function r(e){return i(void 0,e)}function i(e,t){if(!(t instanceof Object))return t;switch(t.constructor){case Date:return new Date(t.getTime());case Object:void 0===e&&(e={});break;case Array:e=[];break;default:return t}for(var n in t)t.hasOwnProperty(n)&&(e[n]=i(e[n],t[n]));return e}function o(e,t,n){e[t]=n}Object.defineProperty(t,"__esModule",{value:!0}),t.deepCopy=r,t.deepExtend=i,t.patchProperty=o},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e){var t=a;return a=e,t}Object.defineProperty(t,"__esModule",{value:!0});var o=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}();t.patchCapture=i;var a=Error.captureStackTrace,c=function e(t,n){if(r(this,e),this.code=t,this.message=n,a)a(this,s.prototype.create);else{var i=Error.apply(this,arguments);this.name="FirebaseError",Object.defineProperty(this,"stack",{get:function(){return i.stack}})}};c.prototype=Object.create(Error.prototype),c.prototype.constructor=c,c.prototype.name="FirebaseError";var s=t.ErrorFactory=function(){function e(t,n,i){r(this,e),this.service=t,this.serviceName=n,this.errors=i,this.pattern=/\{\$([^}]+)}/g}return o(e,[{key:"create",value:function(e,t){void 0===t&&(t={});var n=this.errors[e],r=this.service+"/"+e,i=void 0;i=void 0===n?"Error":n.replace(this.pattern,function(e,n){var r=t[n];return void 0!==r?r.toString():"<"+n+"?>"}),i=this.serviceName+": "+i+" ("+r+").";var o=new c(r,i);for(var a in t)t.hasOwnProperty(a)&&"_"!==a.slice(-1)&&(o[a]=t[a]);return o}}]),e}()},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(){function e(e){e=e||d;var t=r[e];return void 0===t&&o("no-app",{name:e}),t}function t(e,t){Object.keys(a).forEach(function(r){var i=n(e,r);null!==i&&h[i]&&h[i](t,e)})}function n(e,t){if("serverAuth"===t)return null;var n=t,r=e.options;return"auth"===t&&(r.serviceAccount||r.credential)&&(n="serverAuth","serverAuth"in a||o("sa-not-supported")),n}var r={},a={},h={},v={__esModule:!0,initializeApp:function(e,n){void 0===n?n=d:"string"==typeof n&&""!==n||o("bad-app-name",{name:n+""}),void 0!==r[n]&&o("duplicate-app",{name:n});var i=new p(e,n,v);return r[n]=i,t(i,"create"),void 0!=i.INTERNAL&&void 0!=i.INTERNAL.getToken||(0,c.deepExtend)(i,{INTERNAL:{getUid:function(){return null},getToken:function(){return l.resolve(null)},addAuthTokenListener:function(){},removeAuthTokenListener:function(){}}}),i},app:e,apps:null,Promise:l,SDK_VERSION:"3.9.0",INTERNAL:{registerService:function(t,n,r,i,s){a[t]&&o("duplicate-service",{name:t}),a[t]=s?n:function(e,t){return n(e,t,d)},i&&(h[t]=i);var u=void 0;return u=function(n){return void 0===n&&(n=e()),"function"!=typeof n[t]&&o("invalid-app-argument",{name:t}),n[t]()},void 0!==r&&(0,c.deepExtend)(u,r),v[t]=u,u},createFirebaseNamespace:i,extendNamespace:function(e){(0,c.deepExtend)(v,e)},createSubscribe:s.createSubscribe,ErrorFactory:u.ErrorFactory,removeApp:function(e){t(r[e],"delete"),delete r[e]},factories:a,useAsService:n,Promise:f.local.GoogPromise,deepExtend:c.deepExtend}};return(0,c.patchProperty)(v,"default",v),Object.defineProperty(v,"apps",{get:function(){return Object.keys(r).map(function(e){return r[e]})}}),(0,c.patchProperty)(e,"App",p),v}function o(e,t){throw v.create(e,t)}Object.defineProperty(t,"__esModule",{value:!0});var a=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}();t.createFirebaseNamespace=i;var c=n(3),s=n(6),u=n(4),f=n(0),l=f.local.Promise,d="[DEFAULT]",p=function(){function e(t,n,i){var o=this;r(this,e),this.firebase_=i,this.isDeleted_=!1,this.services_={},this.name_=n,this.options_=(0,c.deepCopy)(t);var a="credential"in this.options_,s="serviceAccount"in this.options_;if(a||s){var u=s?"serviceAccount":"credential";"undefined"!=typeof console&&console.log("The '"+u+"' property specified in the first argument to initializeApp() is deprecated and will be removed in the next major version. You should instead use the 'firebase-admin' package. See https://firebase.google.com/docs/admin/setup for details on how to get started.")}Object.keys(i.INTERNAL.factories).forEach(function(e){var t=i.INTERNAL.useAsService(o,e);if(null!==t){var n=o.getService.bind(o,t);(0,c.patchProperty)(o,e,n)}})}return a(e,[{key:"delete",value:function(){var e=this;return new l(function(t){e.checkDestroyed_(),t()}).then(function(){e.firebase_.INTERNAL.removeApp(e.name_);var t=[];return Object.keys(e.services_).forEach(function(n){Object.keys(e.services_[n]).forEach(function(r){t.push(e.services_[n][r])})}),l.all(t.map(function(e){return e.INTERNAL.delete()}))}).then(function(){e.isDeleted_=!0,e.services_={}})}},{key:"getService",value:function(e,t){this.checkDestroyed_(),void 0===this.services_[e]&&(this.services_[e]={});var n=t||d;if(void 0===this.services_[e][n]){var r=this.firebase_.INTERNAL.factories[e](this,this.extendApp.bind(this),t);return this.services_[e][n]=r,r}return this.services_[e][n]}},{key:"extendApp",value:function(e){(0,c.deepExtend)(this,e)}},{key:"checkDestroyed_",value:function(){this.isDeleted_&&o("app-deleted",{name:this.name_})}},{key:"name",get:function(){return this.checkDestroyed_(),this.name_}},{key:"options",get:function(){return this.checkDestroyed_(),this.options_}}]),e}();p.prototype.name&&p.prototype.options||p.prototype.delete||console.log("dc");var h={"no-app":"No Firebase App '{$name}' has been created - call Firebase App.initializeApp()","bad-app-name":"Illegal App name: '{$name}","duplicate-app":"Firebase App named '{$name}' already exists","app-deleted":"Firebase App named '{$name}' already deleted","duplicate-service":"Firebase service named '{$name}' already registered","sa-not-supported":"Initializing the Firebase SDK with a service account is only allowed in a Node.js environment. On client devices, you should instead initialize the SDK with an api key and auth domain","invalid-app-argument":"firebase.{$name}() takes either no argument or a Firebase App instance."},v=new u.ErrorFactory("app","Firebase",h)},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){var n=new d(e,t);return n.subscribe.bind(n)}function o(e,t){return function(){for(var n=arguments.length,r=Array(n),i=0;i<n;i++)r[i]=arguments[i];l.resolve(!0).then(function(){e.apply(void 0,r)}).catch(function(e){t&&t(e)})}}function a(e,t){if("object"!==(void 0===e?"undefined":s(e))||null===e)return!1;var n=!0,r=!1,i=void 0;try{for(var o,a=t[Symbol.iterator]();!(n=(o=a.next()).done);n=!0){var c=o.value;if(c in e&&"function"==typeof e[c])return!0}}catch(e){r=!0,i=e}finally{try{!n&&a.return&&a.return()}finally{if(r)throw i}}return!1}function c(){}Object.defineProperty(t,"__esModule",{value:!0});var s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}();t.createSubscribe=i,t.async=o;var f=n(0),l=f.local.Promise,d=function(){function e(t,n){var i=this;r(this,e),this.observers=[],this.unsubscribes=[],this.observerCount=0,this.task=l.resolve(),this.finalized=!1,this.onNoObservers=n,this.task.then(function(){t(i)}).catch(function(e){i.error(e)})}return u(e,[{key:"next",value:function(e){this.forEachObserver(function(t){t.next(e)})}},{key:"error",value:function(e){this.forEachObserver(function(t){t.error(e)}),this.close(e)}},{key:"complete",value:function(){this.forEachObserver(function(e){e.complete()}),this.close()}},{key:"subscribe",value:function(e,t,n){var r=this,i=void 0;if(void 0===e&&void 0===t&&void 0===n)throw new Error("Missing Observer.");i=a(e,["next","error","complete"])?e:{next:e,error:t,complete:n},void 0===i.next&&(i.next=c),void 0===i.error&&(i.error=c),void 0===i.complete&&(i.complete=c);var o=this.unsubscribeOne.bind(this,this.observers.length);return this.finalized&&this.task.then(function(){try{r.finalError?i.error(r.finalError):i.complete()}catch(e){}}),this.observers.push(i),o}},{key:"unsubscribeOne",value:function(e){void 0!==this.observers&&void 0!==this.observers[e]&&(delete this.observers[e],this.observerCount-=1,0===this.observerCount&&void 0!==this.onNoObservers&&this.onNoObservers(this))}},{key:"forEachObserver",value:function(e){if(!this.finalized)for(var t=0;t<this.observers.length;t++)this.sendOne(t,e)}},{key:"sendOne",value:function(e,t){var n=this;this.task.then(function(){if(void 0!==n.observers&&void 0!==n.observers[e])try{t(n.observers[e])}catch(e){"undefined"!=typeof console&&console.error&&console.error(e)}})}},{key:"close",value:function(e){var t=this;this.finalized||(this.finalized=!0,void 0!==e&&(this.finalError=e),this.task.then(function(){t.observers=void 0,t.onNoObservers=void 0}))}}]),e}()},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function i(e){if(f===setTimeout)return setTimeout(e,0);if((f===n||!f)&&setTimeout)return f=setTimeout,setTimeout(e,0);try{return f(e,0)}catch(t){try{return f.call(null,e,0)}catch(t){return f.call(this,e,0)}}}function o(e){if(l===clearTimeout)return clearTimeout(e);if((l===r||!l)&&clearTimeout)return l=clearTimeout,clearTimeout(e);try{return l(e)}catch(t){try{return l.call(null,e)}catch(t){return l.call(this,e)}}}function a(){v&&p&&(v=!1,p.length?h=p.concat(h):m=-1,h.length&&c())}function c(){if(!v){var e=i(a);v=!0;for(var t=h.length;t;){for(p=h,h=[];++m<t;)p&&p[m].run();m=-1,t=h.length}p=null,v=!1,o(e)}}function s(e,t){this.fun=e,this.array=t}function u(){}var f,l,d=e.exports={};!function(){try{f="function"==typeof setTimeout?setTimeout:n}catch(e){f=n}try{l="function"==typeof clearTimeout?clearTimeout:r}catch(e){l=r}}();var p,h=[],v=!1,m=-1;d.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];h.push(new s(e,t)),1!==h.length||v||i(c)},s.prototype.run=function(){this.fun.apply(null,this.array)},d.title="browser",d.browser=!0,d.env={},d.argv=[],d.version="",d.versions={},d.on=u,d.addListener=u,d.once=u,d.off=u,d.removeListener=u,d.removeAllListeners=u,d.emit=u,d.binding=function(e){throw new Error("process.binding is not supported")},d.cwd=function(){return"/"},d.chdir=function(e){throw new Error("process.chdir is not supported")},d.umask=function(){return 0}},function(e,t,n){(function(t){!function(n){function r(){}function i(e,t){return function(){e.apply(t,arguments)}}function o(e){if("object"!=typeof this)throw new TypeError("Promises must be constructed via new");if("function"!=typeof e)throw new TypeError("not a function");this._state=0,this._handled=!1,this._value=void 0,this._deferreds=[],l(e,this)}function a(e,t){for(;3===e._state;)e=e._value;if(0===e._state)return void e._deferreds.push(t);e._handled=!0,o._immediateFn(function(){var n=1===e._state?t.onFulfilled:t.onRejected;if(null===n)return void(1===e._state?c:s)(t.promise,e._value);var r;try{r=n(e._value)}catch(e){return void s(t.promise,e)}c(t.promise,r)})}function c(e,t){try{if(t===e)throw new TypeError("A promise cannot be resolved with itself.");if(t&&("object"==typeof t||"function"==typeof t)){var n=t.then;if(t instanceof o)return e._state=3,e._value=t,void u(e);if("function"==typeof n)return void l(i(n,t),e)}e._state=1,e._value=t,u(e)}catch(t){s(e,t)}}function s(e,t){e._state=2,e._value=t,u(e)}function u(e){2===e._state&&0===e._deferreds.length&&o._immediateFn(function(){e._handled||o._unhandledRejectionFn(e._value)});for(var t=0,n=e._deferreds.length;t<n;t++)a(e,e._deferreds[t]);e._deferreds=null}function f(e,t,n){this.onFulfilled="function"==typeof e?e:null,this.onRejected="function"==typeof t?t:null,this.promise=n}function l(e,t){var n=!1;try{e(function(e){n||(n=!0,c(t,e))},function(e){n||(n=!0,s(t,e))})}catch(e){if(n)return;n=!0,s(t,e)}}var d=setTimeout;o.prototype.catch=function(e){return this.then(null,e)},o.prototype.then=function(e,t){var n=new this.constructor(r);return a(this,new f(e,t,n)),n},o.all=function(e){var t=Array.prototype.slice.call(e);return new o(function(e,n){function r(o,a){try{if(a&&("object"==typeof a||"function"==typeof a)){var c=a.then;if("function"==typeof c)return void c.call(a,function(e){r(o,e)},n)}t[o]=a,0==--i&&e(t)}catch(e){n(e)}}if(0===t.length)return e([]);for(var i=t.length,o=0;o<t.length;o++)r(o,t[o])})},o.resolve=function(e){return e&&"object"==typeof e&&e.constructor===o?e:new o(function(t){t(e)})},o.reject=function(e){return new o(function(t,n){n(e)})},o.race=function(e){return new o(function(t,n){for(var r=0,i=e.length;r<i;r++)e[r].then(t,n)})},o._immediateFn="function"==typeof t&&function(e){t(e)}||function(e){d(e,0)},o._unhandledRejectionFn=function(e){"undefined"!=typeof console&&console&&console.warn("Possible Unhandled Promise Rejection:",e)},o._setImmediateFn=function(e){o._immediateFn=e},o._setUnhandledRejectionFn=function(e){o._unhandledRejectionFn=e},void 0!==e&&e.exports?e.exports=o:n.Promise||(n.Promise=o)}(this)}).call(t,n(10).setImmediate)},function(e,t,n){(function(e,t){!function(e,n){"use strict";function r(e){"function"!=typeof e&&(e=new Function(""+e));for(var t=new Array(arguments.length-1),n=0;n<t.length;n++)t[n]=arguments[n+1];var r={callback:e,args:t};return u[s]=r,c(s),s++}function i(e){delete u[e]}function o(e){var t=e.callback,r=e.args;switch(r.length){case 0:t();break;case 1:t(r[0]);break;case 2:t(r[0],r[1]);break;case 3:t(r[0],r[1],r[2]);break;default:t.apply(n,r)}}function a(e){if(f)setTimeout(a,0,e);else{var t=u[e];if(t){f=!0;try{o(t)}finally{i(e),f=!1}}}}if(!e.setImmediate){var c,s=1,u={},f=!1,l=e.document,d=Object.getPrototypeOf&&Object.getPrototypeOf(e);d=d&&d.setTimeout?d:e,"[object process]"==={}.toString.call(e.process)?function(){c=function(e){t.nextTick(function(){a(e)})}}():function(){if(e.postMessage&&!e.importScripts){var t=!0,n=e.onmessage;return e.onmessage=function(){t=!1},e.postMessage("","*"),e.onmessage=n,t}}()?function(){var t="setImmediate$"+Math.random()+"$",n=function(n){n.source===e&&"string"==typeof n.data&&0===n.data.indexOf(t)&&a(+n.data.slice(t.length))};e.addEventListener?e.addEventListener("message",n,!1):e.attachEvent("onmessage",n),c=function(n){e.postMessage(t+n,"*")}}():e.MessageChannel?function(){var e=new MessageChannel;e.port1.onmessage=function(e){a(e.data)},c=function(t){e.port2.postMessage(t)}}():l&&"onreadystatechange"in l.createElement("script")?function(){var e=l.documentElement;c=function(t){var n=l.createElement("script");n.onreadystatechange=function(){a(t),n.onreadystatechange=null,e.removeChild(n),n=null},e.appendChild(n)}}():function(){c=function(e){setTimeout(a,0,e)}}(),d.setImmediate=r,d.clearImmediate=i}}("undefined"==typeof self?void 0===e?this:e:self)}).call(t,n(1),n(7))},function(e,t,n){function r(e,t){this._id=e,this._clearFn=t}var i=Function.prototype.apply;t.setTimeout=function(){return new r(i.call(setTimeout,window,arguments),clearTimeout)},t.setInterval=function(){return new r(i.call(setInterval,window,arguments),clearInterval)},t.clearTimeout=t.clearInterval=function(e){e&&e.close()},r.prototype.unref=r.prototype.ref=function(){},r.prototype.close=function(){this._clearFn.call(window,this._id)},t.enroll=function(e,t){clearTimeout(e._idleTimeoutId),e._idleTimeout=t},t.unenroll=function(e){clearTimeout(e._idleTimeoutId),e._idleTimeout=-1},t._unrefActive=t.active=function(e){clearTimeout(e._idleTimeoutId);var t=e._idleTimeout;t>=0&&(e._idleTimeoutId=setTimeout(function(){e._onTimeout&&e._onTimeout()},t))},n(9),t.setImmediate=setImmediate,t.clearImmediate=clearImmediate},function(e,t,n){e.exports=n(2)}]);module.exports=firebase;
//# sourceMappingURL=app.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(155).setImmediate, __webpack_require__(155).clearImmediate))

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var contains = exports.contains = function contains(bit, value) {
    return (bit & value) !== 0;
};

var distance = exports.distance = function distance(a, b) {
    return Math.sqrt(a * a + b * b);
};

var copyCSSStyles = exports.copyCSSStyles = function copyCSSStyles(style, target) {
    // Edge does not provide value for cssText
    for (var i = style.length - 1; i >= 0; i--) {
        var property = style.item(i);
        // Safari shows pseudoelements if content is set
        if (property !== 'content') {
            target.style.setProperty(property, style.getPropertyValue(property));
        }
    }
    return target;
};

var SMALL_IMAGE = exports.SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {


var Keyboard = __webpack_require__(1168);
var Locale   = __webpack_require__(338);
var KeyCombo = __webpack_require__(209);

var keyboard = new Keyboard();

keyboard.setLocale('us', __webpack_require__(1169));

exports          = module.exports = keyboard;
exports.Keyboard = Keyboard;
exports.Locale   = Locale;
exports.KeyCombo = KeyCombo;


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_values__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sign__ = __webpack_require__(114);



/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return (Math.abs(x) < __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */]) ? x : (x - (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sign__["a" /* default */])(x) * Math.PI));
});


/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x<0 ? -1 : 1;
});

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(2206)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(508),
  /* template */
  __webpack_require__(2164),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.load = exports.loaded = undefined;

var _keys = __webpack_require__(2237);

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = __webpack_require__(2239);

var _typeof3 = _interopRequireDefault(_typeof2);

var _promise = __webpack_require__(157);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* vim: set softtabstop=2 shiftwidth=2 expandtab : */

var setUp = false;

var loaded = exports.loaded = new _promise2.default(function (resolve, reject) {
  // eslint-disable-line no-unused-vars
  if (typeof window === 'undefined') {
    // Do nothing if run from server-side
    return;
  }
  window['vueGoogleMapsInit'] = resolve;
});

/**
 * @param apiKey    API Key, or object with the URL parameters. For example
 *                  to use Google Maps Premium API, pass
 *                    `{ client: <YOUR-CLIENT-ID> }`.
 *                  You may pass the libraries and/or version (as `v`) parameter into
 *                  this parameter and skip the next two parameters
 * @param version   Google for Maps version
 * @param libraries Libraries to load (@see
 *                  https://developers.google.com/maps/documentation/javascript/libraries)
 * @param loadCn    Boolean. If set to true, the map will be loaded form goole maps China
 *                  (@see https://developers.google.com/maps/documentation/javascript/basics#GoogleMapsChina)
 *
 * Example:
 * ```
 *      import {load} from 'vue-google-maps'
 *
 *      load(<YOUR-API-KEY>)
 *
 *      load({
 *              key: <YOUR-API-KEY>,
 *      })
 *
 *      load({
 *              client: <YOUR-CLIENT-ID>,
 *              channel: <YOUR CHANNEL>
 *      })
 * ```
 */
var load = exports.load = function load(apiKey, version, libraries, loadCn) {
  if (typeof document === 'undefined') {
    // Do nothing if run from server-side
    return;
  }
  if (!setUp) {
    var googleMapScript = document.createElement('SCRIPT');

    // Allow apiKey to be an object.
    // This is to support more esoteric means of loading Google Maps,
    // such as Google for business
    // https://developers.google.com/maps/documentation/javascript/get-api-key#premium-auth
    var options = {};
    if (typeof apiKey == 'string') {
      options.key = apiKey;
    } else if ((typeof apiKey === 'undefined' ? 'undefined' : (0, _typeof3.default)(apiKey)) == 'object') {
      for (var k in apiKey) {
        // transfer values in apiKey to options
        options[k] = apiKey[k];
      }
    } else {
      throw new Error('apiKey should either be a string or an object');
    }

    // libraries
    var librariesPath = '';
    if (libraries && libraries.length > 0) {
      librariesPath = libraries.join(',');
      options['libraries'] = librariesPath;
    } else if (Array.prototype.isPrototypeOf(options.libraries)) {
      options.libraries = options.libraries.join(',');
    }
    options['callback'] = 'vueGoogleMapsInit';

    var baseUrl = 'https://maps.googleapis.com/';

    if (typeof loadCn == 'boolean' && loadCn === true) {
      baseUrl = 'http://maps.google.cn/';
    }

    var url = baseUrl + 'maps/api/js?' + (0, _keys2.default)(options).map(function (key) {
      return encodeURIComponent(key) + '=' + encodeURIComponent(options[key]);
    }).join('&');

    if (version) {
      url = url + '&v=' + version;
    }

    googleMapScript.setAttribute('src', url);
    googleMapScript.setAttribute('async', '');
    googleMapScript.setAttribute('defer', '');
    document.body.appendChild(googleMapScript);
  } else {
    throw new Error('You already started the loading of google maps');
  }
};

/***/ }),
/* 117 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(223);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        module.exports = factory();
    } else {
        global.numeral = factory();
    }
}(this, function () {
    /************************************
        Variables
    ************************************/

    var numeral,
        _,
        VERSION = '2.0.6',
        formats = {},
        locales = {},
        defaults = {
            currentLocale: 'en',
            zeroFormat: null,
            nullFormat: null,
            defaultFormat: '0,0',
            scalePercentBy100: true
        },
        options = {
            currentLocale: defaults.currentLocale,
            zeroFormat: defaults.zeroFormat,
            nullFormat: defaults.nullFormat,
            defaultFormat: defaults.defaultFormat,
            scalePercentBy100: defaults.scalePercentBy100
        };


    /************************************
        Constructors
    ************************************/

    // Numeral prototype object
    function Numeral(input, number) {
        this._input = input;

        this._value = number;
    }

    numeral = function(input) {
        var value,
            kind,
            unformatFunction,
            regexp;

        if (numeral.isNumeral(input)) {
            value = input.value();
        } else if (input === 0 || typeof input === 'undefined') {
            value = 0;
        } else if (input === null || _.isNaN(input)) {
            value = null;
        } else if (typeof input === 'string') {
            if (options.zeroFormat && input === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                for (kind in formats) {
                    regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;

                    if (regexp && input.match(regexp)) {
                        unformatFunction = formats[kind].unformat;

                        break;
                    }
                }

                unformatFunction = unformatFunction || numeral._.stringToNumber;

                value = unformatFunction(input);
            }
        } else {
            value = Number(input)|| null;
        }

        return new Numeral(input, value);
    };

    // version number
    numeral.version = VERSION;

    // compare numeral object
    numeral.isNumeral = function(obj) {
        return obj instanceof Numeral;
    };

    // helper functions
    numeral._ = _ = {
        // formats numbers separators, decimals places, signs, abbreviations
        numberToFormat: function(value, format, roundingFunction) {
            var locale = locales[numeral.options.currentLocale],
                negP = false,
                optDec = false,
                leadingCount = 0,
                abbr = '',
                trillion = 1000000000000,
                billion = 1000000000,
                million = 1000000,
                thousand = 1000,
                decimal = '',
                neg = false,
                abbrForce, // force abbreviation
                abs,
                min,
                max,
                power,
                int,
                precision,
                signed,
                thousands,
                output;

            // make sure we never format a null value
            value = value || 0;

            abs = Math.abs(value);

            // see if we should use parentheses for negative number or if we should prefix with a sign
            // if both are present we default to parentheses
            if (numeral._.includes(format, '(')) {
                negP = true;
                format = format.replace(/[\(|\)]/g, '');
            } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
                signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
                format = format.replace(/[\+|\-]/g, '');
            }

            // see if abbreviation is wanted
            if (numeral._.includes(format, 'a')) {
                abbrForce = format.match(/a(k|m|b|t)?/);

                abbrForce = abbrForce ? abbrForce[1] : false;

                // check for space before abbreviation
                if (numeral._.includes(format, ' a')) {
                    abbr = ' ';
                }

                format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');

                if (abs >= trillion && !abbrForce || abbrForce === 't') {
                    // trillion
                    abbr += locale.abbreviations.trillion;
                    value = value / trillion;
                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
                    // billion
                    abbr += locale.abbreviations.billion;
                    value = value / billion;
                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
                    // million
                    abbr += locale.abbreviations.million;
                    value = value / million;
                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
                    // thousand
                    abbr += locale.abbreviations.thousand;
                    value = value / thousand;
                }
            }

            // check for optional decimals
            if (numeral._.includes(format, '[.]')) {
                optDec = true;
                format = format.replace('[.]', '.');
            }

            // break number and format
            int = value.toString().split('.')[0];
            precision = format.split('.')[1];
            thousands = format.indexOf(',');
            leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;

            if (precision) {
                if (numeral._.includes(precision, '[')) {
                    precision = precision.replace(']', '');
                    precision = precision.split('[');
                    decimal = numeral._.toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
                } else {
                    decimal = numeral._.toFixed(value, precision.length, roundingFunction);
                }

                int = decimal.split('.')[0];

                if (numeral._.includes(decimal, '.')) {
                    decimal = locale.delimiters.decimal + decimal.split('.')[1];
                } else {
                    decimal = '';
                }

                if (optDec && Number(decimal.slice(1)) === 0) {
                    decimal = '';
                }
            } else {
                int = numeral._.toFixed(value, 0, roundingFunction);
            }

            // check abbreviation again after rounding
            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
                int = String(Number(int) / 1000);

                switch (abbr) {
                    case locale.abbreviations.thousand:
                        abbr = locale.abbreviations.million;
                        break;
                    case locale.abbreviations.million:
                        abbr = locale.abbreviations.billion;
                        break;
                    case locale.abbreviations.billion:
                        abbr = locale.abbreviations.trillion;
                        break;
                }
            }


            // format number
            if (numeral._.includes(int, '-')) {
                int = int.slice(1);
                neg = true;
            }

            if (int.length < leadingCount) {
                for (var i = leadingCount - int.length; i > 0; i--) {
                    int = '0' + int;
                }
            }

            if (thousands > -1) {
                int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
            }

            if (format.indexOf('.') === 0) {
                int = '';
            }

            output = int + decimal + (abbr ? abbr : '');

            if (negP) {
                output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
            } else {
                if (signed >= 0) {
                    output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
                } else if (neg) {
                    output = '-' + output;
                }
            }

            return output;
        },
        // unformats numbers separators, decimals places, signs, abbreviations
        stringToNumber: function(string) {
            var locale = locales[options.currentLocale],
                stringOriginal = string,
                abbreviations = {
                    thousand: 3,
                    million: 6,
                    billion: 9,
                    trillion: 12
                },
                abbreviation,
                value,
                i,
                regexp;

            if (options.zeroFormat && string === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                value = 1;

                if (locale.delimiters.decimal !== '.') {
                    string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
                }

                for (abbreviation in abbreviations) {
                    regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');

                    if (stringOriginal.match(regexp)) {
                        value *= Math.pow(10, abbreviations[abbreviation]);
                        break;
                    }
                }

                // check for negative number
                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;

                // remove non numbers
                string = string.replace(/[^0-9\.]+/g, '');

                value *= Number(string);
            }

            return value;
        },
        isNaN: function(value) {
            return typeof value === 'number' && isNaN(value);
        },
        includes: function(string, search) {
            return string.indexOf(search) !== -1;
        },
        insert: function(string, subString, start) {
            return string.slice(0, start) + subString + string.slice(start);
        },
        reduce: function(array, callback /*, initialValue*/) {
            if (this === null) {
                throw new TypeError('Array.prototype.reduce called on null or undefined');
            }

            if (typeof callback !== 'function') {
                throw new TypeError(callback + ' is not a function');
            }

            var t = Object(array),
                len = t.length >>> 0,
                k = 0,
                value;

            if (arguments.length === 3) {
                value = arguments[2];
            } else {
                while (k < len && !(k in t)) {
                    k++;
                }

                if (k >= len) {
                    throw new TypeError('Reduce of empty array with no initial value');
                }

                value = t[k++];
            }
            for (; k < len; k++) {
                if (k in t) {
                    value = callback(value, t[k], k, t);
                }
            }
            return value;
        },
        /**
         * Computes the multiplier necessary to make x >= 1,
         * effectively eliminating miscalculations caused by
         * finite precision.
         */
        multiplier: function (x) {
            var parts = x.toString().split('.');

            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
        },
        /**
         * Given a variable number of arguments, returns the maximum
         * multiplier that must be used to normalize an operation involving
         * all of them.
         */
        correctionFactor: function () {
            var args = Array.prototype.slice.call(arguments);

            return args.reduce(function(accum, next) {
                var mn = _.multiplier(next);
                return accum > mn ? accum : mn;
            }, 1);
        },
        /**
         * Implementation of toFixed() that treats floats more like decimals
         *
         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
         * problems for accounting- and finance-related software.
         */
        toFixed: function(value, maxDecimals, roundingFunction, optionals) {
            var splitValue = value.toString().split('.'),
                minDecimals = maxDecimals - (optionals || 0),
                boundedPrecision,
                optionalsRegExp,
                power,
                output;

            // Use the smallest precision value possible to avoid errors from floating point representation
            if (splitValue.length === 2) {
              boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
            } else {
              boundedPrecision = minDecimals;
            }

            power = Math.pow(10, boundedPrecision);

            // Multiply up by precision, round accurately, then divide and use native toFixed():
            output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);

            if (optionals > maxDecimals - boundedPrecision) {
                optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
                output = output.replace(optionalsRegExp, '');
            }

            return output;
        }
    };

    // avaliable options
    numeral.options = options;

    // avaliable formats
    numeral.formats = formats;

    // avaliable formats
    numeral.locales = locales;

    // This function sets the current locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    numeral.locale = function(key) {
        if (key) {
            options.currentLocale = key.toLowerCase();
        }

        return options.currentLocale;
    };

    // This function provides access to the loaded locale data.  If
    // no arguments are passed in, it will simply return the current
    // global locale object.
    numeral.localeData = function(key) {
        if (!key) {
            return locales[options.currentLocale];
        }

        key = key.toLowerCase();

        if (!locales[key]) {
            throw new Error('Unknown locale : ' + key);
        }

        return locales[key];
    };

    numeral.reset = function() {
        for (var property in defaults) {
            options[property] = defaults[property];
        }
    };

    numeral.zeroFormat = function(format) {
        options.zeroFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.nullFormat = function (format) {
        options.nullFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.defaultFormat = function(format) {
        options.defaultFormat = typeof(format) === 'string' ? format : '0.0';
    };

    numeral.register = function(type, name, format) {
        name = name.toLowerCase();

        if (this[type + 's'][name]) {
            throw new TypeError(name + ' ' + type + ' already registered.');
        }

        this[type + 's'][name] = format;

        return format;
    };


    numeral.validate = function(val, culture) {
        var _decimalSep,
            _thousandSep,
            _currSymbol,
            _valArray,
            _abbrObj,
            _thousandRegEx,
            localeData,
            temp;

        //coerce val to string
        if (typeof val !== 'string') {
            val += '';

            if (console.warn) {
                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
            }
        }

        //trim whitespaces from either sides
        val = val.trim();

        //if val is just digits return true
        if (!!val.match(/^\d+$/)) {
            return true;
        }

        //if val is empty return false
        if (val === '') {
            return false;
        }

        //get the decimal and thousands separator from numeral.localeData
        try {
            //check if the culture is understood by numeral. if not, default it to current locale
            localeData = numeral.localeData(culture);
        } catch (e) {
            localeData = numeral.localeData(numeral.locale());
        }

        //setup the delimiters and currency symbol based on culture/locale
        _currSymbol = localeData.currency.symbol;
        _abbrObj = localeData.abbreviations;
        _decimalSep = localeData.delimiters.decimal;
        if (localeData.delimiters.thousands === '.') {
            _thousandSep = '\\.';
        } else {
            _thousandSep = localeData.delimiters.thousands;
        }

        // validating currency symbol
        temp = val.match(/^[^\d]+/);
        if (temp !== null) {
            val = val.substr(1);
            if (temp[0] !== _currSymbol) {
                return false;
            }
        }

        //validating abbreviation symbol
        temp = val.match(/[^\d]+$/);
        if (temp !== null) {
            val = val.slice(0, -1);
            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
                return false;
            }
        }

        _thousandRegEx = new RegExp(_thousandSep + '{2}');

        if (!val.match(/[^\d.,]/g)) {
            _valArray = val.split(_decimalSep);
            if (_valArray.length > 2) {
                return false;
            } else {
                if (_valArray.length < 2) {
                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
                } else {
                    if (_valArray[0].length === 1) {
                        return ( !! _valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    } else {
                        return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    }
                }
            }
        }

        return false;
    };


    /************************************
        Numeral Prototype
    ************************************/

    numeral.fn = Numeral.prototype = {
        clone: function() {
            return numeral(this);
        },
        format: function(inputString, roundingFunction) {
            var value = this._value,
                format = inputString || options.defaultFormat,
                kind,
                output,
                formatFunction;

            // make sure we have a roundingFunction
            roundingFunction = roundingFunction || Math.round;

            // format based on value
            if (value === 0 && options.zeroFormat !== null) {
                output = options.zeroFormat;
            } else if (value === null && options.nullFormat !== null) {
                output = options.nullFormat;
            } else {
                for (kind in formats) {
                    if (format.match(formats[kind].regexps.format)) {
                        formatFunction = formats[kind].format;

                        break;
                    }
                }

                formatFunction = formatFunction || numeral._.numberToFormat;

                output = formatFunction(value, format, roundingFunction);
            }

            return output;
        },
        value: function() {
            return this._value;
        },
        input: function() {
            return this._input;
        },
        set: function(value) {
            this._value = Number(value);

            return this;
        },
        add: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum + Math.round(corrFactor * curr);
            }

            this._value = _.reduce([this._value, value], cback, 0) / corrFactor;

            return this;
        },
        subtract: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum - Math.round(corrFactor * curr);
            }

            this._value = _.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;

            return this;
        },
        multiply: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback, 1);

            return this;
        },
        divide: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback);

            return this;
        },
        difference: function(value) {
            return Math.abs(numeral(this._value).subtract(value).value());
        }
    };

    /************************************
        Default Locale && Format
    ************************************/

    numeral.register('locale', 'en', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function(number) {
            var b = number % 10;
            return (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: '$'
        }
    });

    

(function() {
        numeral.register('format', 'bps', {
            regexps: {
                format: /(BPS)/,
                unformat: /(BPS)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, ' BPS') ? ' ' : '',
                    output;

                value = value * 10000;

                // check for space before BPS
                format = format.replace(/\s?BPS/, '');

                output = numeral._.numberToFormat(value, format, roundingFunction);

                if (numeral._.includes(output, ')')) {
                    output = output.split('');

                    output.splice(-1, 0, space + 'BPS');

                    output = output.join('');
                } else {
                    output = output + space + 'BPS';
                }

                return output;
            },
            unformat: function(string) {
                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
            }
        });
})();


(function() {
        var decimal = {
            base: 1000,
            suffixes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        },
        binary = {
            base: 1024,
            suffixes: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
        };

    var allSuffixes =  decimal.suffixes.concat(binary.suffixes.filter(function (item) {
            return decimal.suffixes.indexOf(item) < 0;
        }));
        var unformatRegex = allSuffixes.join('|');
        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
        unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';

    numeral.register('format', 'bytes', {
        regexps: {
            format: /([0\s]i?b)/,
            unformat: new RegExp(unformatRegex)
        },
        format: function(value, format, roundingFunction) {
            var output,
                bytes = numeral._.includes(format, 'ib') ? binary : decimal,
                suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '',
                power,
                min,
                max;

            // check for space before
            format = format.replace(/\s?i?b/, '');

            for (power = 0; power <= bytes.suffixes.length; power++) {
                min = Math.pow(bytes.base, power);
                max = Math.pow(bytes.base, power + 1);

                if (value === null || value === 0 || value >= min && value < max) {
                    suffix += bytes.suffixes[power];

                    if (min > 0) {
                        value = value / min;
                    }

                    break;
                }
            }

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + suffix;
        },
        unformat: function(string) {
            var value = numeral._.stringToNumber(string),
                power,
                bytesMultiplier;

            if (value) {
                for (power = decimal.suffixes.length - 1; power >= 0; power--) {
                    if (numeral._.includes(string, decimal.suffixes[power])) {
                        bytesMultiplier = Math.pow(decimal.base, power);

                        break;
                    }

                    if (numeral._.includes(string, binary.suffixes[power])) {
                        bytesMultiplier = Math.pow(binary.base, power);

                        break;
                    }
                }

                value *= (bytesMultiplier || 1);
            }

            return value;
        }
    });
})();


(function() {
        numeral.register('format', 'currency', {
        regexps: {
            format: /(\$)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                symbols = {
                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
                },
                output,
                symbol,
                i;

            // strip format of spaces and $
            format = format.replace(/\s?\$\s?/, '');

            // format the number
            output = numeral._.numberToFormat(value, format, roundingFunction);

            // update the before and after based on value
            if (value >= 0) {
                symbols.before = symbols.before.replace(/[\-\(]/, '');
                symbols.after = symbols.after.replace(/[\-\)]/, '');
            } else if (value < 0 && (!numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '('))) {
                symbols.before = '-' + symbols.before;
            }

            // loop through each before symbol
            for (i = 0; i < symbols.before.length; i++) {
                symbol = symbols.before[i];

                switch (symbol) {
                    case '$':
                        output = numeral._.insert(output, locale.currency.symbol, i);
                        break;
                    case ' ':
                        output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
                        break;
                }
            }

            // loop through each after symbol
            for (i = symbols.after.length - 1; i >= 0; i--) {
                symbol = symbols.after[i];

                switch (symbol) {
                    case '$':
                        output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
                        break;
                    case ' ':
                        output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
                        break;
                }
            }


            return output;
        }
    });
})();


(function() {
        numeral.register('format', 'exponential', {
        regexps: {
            format: /(e\+|e-)/,
            unformat: /(e\+|e-)/
        },
        format: function(value, format, roundingFunction) {
            var output,
                exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0',
                parts = exponential.split('e');

            format = format.replace(/e[\+|\-]{1}0/, '');

            output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);

            return output + 'e' + parts[1];
        },
        unformat: function(string) {
            var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'),
                value = Number(parts[0]),
                power = Number(parts[1]);

            power = numeral._.includes(string, 'e-') ? power *= -1 : power;

            function cback(accum, curr, currI, O) {
                var corrFactor = numeral._.correctionFactor(accum, curr),
                    num = (accum * corrFactor) * (curr * corrFactor) / (corrFactor * corrFactor);
                return num;
            }

            return numeral._.reduce([value, Math.pow(10, power)], cback, 1);
        }
    });
})();


(function() {
        numeral.register('format', 'ordinal', {
        regexps: {
            format: /(o)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                output,
                ordinal = numeral._.includes(format, ' o') ? ' ' : '';

            // check for space before
            format = format.replace(/\s?o/, '');

            ordinal += locale.ordinal(value);

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + ordinal;
        }
    });
})();


(function() {
        numeral.register('format', 'percentage', {
        regexps: {
            format: /(%)/,
            unformat: /(%)/
        },
        format: function(value, format, roundingFunction) {
            var space = numeral._.includes(format, ' %') ? ' ' : '',
                output;

            if (numeral.options.scalePercentBy100) {
                value = value * 100;
            }

            // check for space before %
            format = format.replace(/\s?\%/, '');

            output = numeral._.numberToFormat(value, format, roundingFunction);

            if (numeral._.includes(output, ')')) {
                output = output.split('');

                output.splice(-1, 0, space + '%');

                output = output.join('');
            } else {
                output = output + space + '%';
            }

            return output;
        },
        unformat: function(string) {
            var number = numeral._.stringToNumber(string);
            if (numeral.options.scalePercentBy100) {
                return number * 0.01;
            }
            return number;
        }
    });
})();


(function() {
        numeral.register('format', 'time', {
        regexps: {
            format: /(:)/,
            unformat: /(:)/
        },
        format: function(value, format, roundingFunction) {
            var hours = Math.floor(value / 60 / 60),
                minutes = Math.floor((value - (hours * 60 * 60)) / 60),
                seconds = Math.round(value - (hours * 60 * 60) - (minutes * 60));

            return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
        },
        unformat: function(string) {
            var timeArray = string.split(':'),
                seconds = 0;

            // turn hours and minutes into seconds and add them all up
            if (timeArray.length === 3) {
                // hours
                seconds = seconds + (Number(timeArray[0]) * 60 * 60);
                // minutes
                seconds = seconds + (Number(timeArray[1]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[2]);
            } else if (timeArray.length === 2) {
                // minutes
                seconds = seconds + (Number(timeArray[0]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[1]);
            }
            return Number(seconds);
        }
    });
})();

return numeral;
}));


/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    code_bde: 1,
    name_ca: 'Nova',
    name_en: 'New',
    name_es: 'Nueva'
}, {
    id: 2,
    code_bde: 2,
    name_ca: 'Bona',
    name_en: 'Good',
    name_es: 'Buena'
}, {
    id: 3,
    code_bde: 3,
    name_ca: 'Regular / Mitjana',
    name_en: 'Regular / Average',
    name_es: 'Regular / Media'
}, {
    id: 4,
    code_bde: 4,
    name_ca: 'Dolenta',
    name_en: 'Bad',
    name_es: 'Mala'
}, {
    id: 5,
    code_bde: 5,
    name_ca: 'No comprovat',
    name_en: 'Not checked',
    name_es: 'No comprobado'
}]);

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{ 'iso_3166_alpha2_code': 'AF', 'name_en': 'Afghanistan' }, { 'iso_3166_alpha2_code': 'AX', 'name_en': 'Åland Islands' }, { 'iso_3166_alpha2_code': 'AL', 'name_en': 'Albania' }, { 'iso_3166_alpha2_code': 'DZ', 'name_en': 'Algeria' }, { 'iso_3166_alpha2_code': 'AS', 'name_en': 'American Samoa' }, { 'iso_3166_alpha2_code': 'AD', 'name_en': 'Andorra' }, { 'iso_3166_alpha2_code': 'AO', 'name_en': 'Angola' }, { 'iso_3166_alpha2_code': 'AI', 'name_en': 'Anguilla' }, { 'iso_3166_alpha2_code': 'AQ', 'name_en': 'Antarctica' }, { 'iso_3166_alpha2_code': 'AG', 'name_en': 'Antigua and Barbuda' }, { 'iso_3166_alpha2_code': 'AR', 'name_en': 'Argentina' }, { 'iso_3166_alpha2_code': 'AM', 'name_en': 'Armenia' }, { 'iso_3166_alpha2_code': 'AW', 'name_en': 'Aruba' }, { 'iso_3166_alpha2_code': 'AU', 'name_en': 'Australia' }, { 'iso_3166_alpha2_code': 'AT', 'name_en': 'Austria' }, { 'iso_3166_alpha2_code': 'AZ', 'name_en': 'Azerbaijan' }, { 'iso_3166_alpha2_code': 'BS', 'name_en': 'Bahamas' }, { 'iso_3166_alpha2_code': 'BH', 'name_en': 'Bahrain' }, { 'iso_3166_alpha2_code': 'BD', 'name_en': 'Bangladesh' }, { 'iso_3166_alpha2_code': 'BB', 'name_en': 'Barbados' }, { 'iso_3166_alpha2_code': 'BY', 'name_en': 'Belarus' }, { 'iso_3166_alpha2_code': 'BE', 'name_en': 'Belgium' }, { 'iso_3166_alpha2_code': 'BZ', 'name_en': 'Belize' }, { 'iso_3166_alpha2_code': 'BJ', 'name_en': 'Benin' }, { 'iso_3166_alpha2_code': 'BM', 'name_en': 'Bermuda' }, { 'iso_3166_alpha2_code': 'BT', 'name_en': 'Bhutan' }, { 'iso_3166_alpha2_code': 'BO', 'name_en': 'Bolivia' }, { 'iso_3166_alpha2_code': 'BA', 'name_en': 'Bosnia and Herzegovina' }, { 'iso_3166_alpha2_code': 'BW', 'name_en': 'Botswana' }, { 'iso_3166_alpha2_code': 'BV', 'name_en': 'Bouvet Island' }, { 'iso_3166_alpha2_code': 'BR', 'name_en': 'Brazil' }, { 'iso_3166_alpha2_code': 'IO', 'name_en': 'British Indian Ocean Territory' }, { 'iso_3166_alpha2_code': 'BN', 'name_en': 'Brunei Darussalam' }, { 'iso_3166_alpha2_code': 'BG', 'name_en': 'Bulgaria' }, { 'iso_3166_alpha2_code': 'BF', 'name_en': 'Burkina Faso' }, { 'iso_3166_alpha2_code': 'BI', 'name_en': 'Burundi' }, { 'iso_3166_alpha2_code': 'KH', 'name_en': 'Cambodia' }, { 'iso_3166_alpha2_code': 'CM', 'name_en': 'Cameroon' }, { 'iso_3166_alpha2_code': 'CA', 'name_en': 'Canada' }, { 'iso_3166_alpha2_code': 'CV', 'name_en': 'Cape Verde' }, { 'iso_3166_alpha2_code': 'KY', 'name_en': 'Cayman Islands' }, { 'iso_3166_alpha2_code': 'CF', 'name_en': 'Central African Republic' }, { 'iso_3166_alpha2_code': 'TD', 'name_en': 'Chad' }, { 'iso_3166_alpha2_code': 'CL', 'name_en': 'Chile' }, { 'iso_3166_alpha2_code': 'CN', 'name_en': 'China' }, { 'iso_3166_alpha2_code': 'CX', 'name_en': 'Christmas Island' }, { 'iso_3166_alpha2_code': 'CC', 'name_en': 'Cocos (Keeling) Islands' }, { 'iso_3166_alpha2_code': 'CO', 'name_en': 'Colombia' }, { 'iso_3166_alpha2_code': 'KM', 'name_en': 'Comoros' }, { 'iso_3166_alpha2_code': 'CG', 'name_en': 'Congo' }, { 'iso_3166_alpha2_code': 'CD', 'name_en': 'Congo, The Democratic Republic of the' }, { 'iso_3166_alpha2_code': 'CK', 'name_en': 'Cook Islands' }, { 'iso_3166_alpha2_code': 'CR', 'name_en': 'Costa Rica' }, { 'iso_3166_alpha2_code': 'CI', 'name_en': 'Cote D\'Ivoire' }, { 'iso_3166_alpha2_code': 'HR', 'name_en': 'Croatia' }, { 'iso_3166_alpha2_code': 'CU', 'name_en': 'Cuba' }, { 'iso_3166_alpha2_code': 'CY', 'name_en': 'Cyprus' }, { 'iso_3166_alpha2_code': 'CZ', 'name_en': 'Czech Republic' }, { 'iso_3166_alpha2_code': 'DK', 'name_en': 'Denmark' }, { 'iso_3166_alpha2_code': 'DJ', 'name_en': 'Djibouti' }, { 'iso_3166_alpha2_code': 'DM', 'name_en': 'Dominica' }, { 'iso_3166_alpha2_code': 'DO', 'name_en': 'Dominican Republic' }, { 'iso_3166_alpha2_code': 'EC', 'name_en': 'Ecuador' }, { 'iso_3166_alpha2_code': 'EG', 'name_en': 'Egypt' }, { 'iso_3166_alpha2_code': 'SV', 'name_en': 'El Salvador' }, { 'iso_3166_alpha2_code': 'GQ', 'name_en': 'Equatorial Guinea' }, { 'iso_3166_alpha2_code': 'ER', 'name_en': 'Eritrea' }, { 'iso_3166_alpha2_code': 'EE', 'name_en': 'Estonia' }, { 'iso_3166_alpha2_code': 'ET', 'name_en': 'Ethiopia' }, { 'iso_3166_alpha2_code': 'FK', 'name_en': 'Falkland Islands (Malvinas)' }, { 'iso_3166_alpha2_code': 'FO', 'name_en': 'Faroe Islands' }, { 'iso_3166_alpha2_code': 'FJ', 'name_en': 'Fiji' }, { 'iso_3166_alpha2_code': 'FI', 'name_en': 'Finland' }, { 'iso_3166_alpha2_code': 'FR', 'name_en': 'France' }, { 'iso_3166_alpha2_code': 'GF', 'name_en': 'French Guiana' }, { 'iso_3166_alpha2_code': 'PF', 'name_en': 'French Polynesia' }, { 'iso_3166_alpha2_code': 'TF', 'name_en': 'French Southern Territories' }, { 'iso_3166_alpha2_code': 'GA', 'name_en': 'Gabon' }, { 'iso_3166_alpha2_code': 'GM', 'name_en': 'Gambia' }, { 'iso_3166_alpha2_code': 'GE', 'name_en': 'Georgia' }, { 'iso_3166_alpha2_code': 'DE', 'name_en': 'Germany' }, { 'iso_3166_alpha2_code': 'GH', 'name_en': 'Ghana' }, { 'iso_3166_alpha2_code': 'GI', 'name_en': 'Gibraltar' }, { 'iso_3166_alpha2_code': 'GR', 'name_en': 'Greece' }, { 'iso_3166_alpha2_code': 'GL', 'name_en': 'Greenland' }, { 'iso_3166_alpha2_code': 'GD', 'name_en': 'Grenada' }, { 'iso_3166_alpha2_code': 'GP', 'name_en': 'Guadeloupe' }, { 'iso_3166_alpha2_code': 'GU', 'name_en': 'Guam' }, { 'iso_3166_alpha2_code': 'GT', 'name_en': 'Guatemala' }, { 'iso_3166_alpha2_code': 'GG', 'name_en': 'Guernsey' }, { 'iso_3166_alpha2_code': 'GN', 'name_en': 'Guinea' }, { 'iso_3166_alpha2_code': 'GW', 'name_en': 'Guinea-Bissau' }, { 'iso_3166_alpha2_code': 'GY', 'name_en': 'Guyana' }, { 'iso_3166_alpha2_code': 'HT', 'name_en': 'Haiti' }, { 'iso_3166_alpha2_code': 'HM', 'name_en': 'Heard Island and Mcdonald Islands' }, { 'iso_3166_alpha2_code': 'VA', 'name_en': 'Holy See (Vatican City State)' }, { 'iso_3166_alpha2_code': 'HN', 'name_en': 'Honduras' }, { 'iso_3166_alpha2_code': 'HK', 'name_en': 'Hong Kong' }, { 'iso_3166_alpha2_code': 'HU', 'name_en': 'Hungary' }, { 'iso_3166_alpha2_code': 'IS', 'name_en': 'Iceland' }, { 'iso_3166_alpha2_code': 'IN', 'name_en': 'India' }, { 'iso_3166_alpha2_code': 'ID', 'name_en': 'Indonesia' }, { 'iso_3166_alpha2_code': 'IR', 'name_en': 'Iran, Islamic Republic Of' }, { 'iso_3166_alpha2_code': 'IQ', 'name_en': 'Iraq' }, { 'iso_3166_alpha2_code': 'IE', 'name_en': 'Ireland' }, { 'iso_3166_alpha2_code': 'IM', 'name_en': 'Isle of Man' }, { 'iso_3166_alpha2_code': 'IL', 'name_en': 'Israel' }, { 'iso_3166_alpha2_code': 'IT', 'name_en': 'Italy' }, { 'iso_3166_alpha2_code': 'JM', 'name_en': 'Jamaica' }, { 'iso_3166_alpha2_code': 'JP', 'name_en': 'Japan' }, { 'iso_3166_alpha2_code': 'JE', 'name_en': 'Jersey' }, { 'iso_3166_alpha2_code': 'JO', 'name_en': 'Jordan' }, { 'iso_3166_alpha2_code': 'KZ', 'name_en': 'Kazakhstan' }, { 'iso_3166_alpha2_code': 'KE', 'name_en': 'Kenya' }, { 'iso_3166_alpha2_code': 'KI', 'name_en': 'Kiribati' }, { 'iso_3166_alpha2_code': 'KP', 'name_en': 'Democratic People\'s Republic of Korea' }, { 'iso_3166_alpha2_code': 'KR', 'name_en': 'Korea, Republic of' }, { 'iso_3166_alpha2_code': 'XK', 'name_en': 'Kosovo' }, { 'iso_3166_alpha2_code': 'KW', 'name_en': 'Kuwait' }, { 'iso_3166_alpha2_code': 'KG', 'name_en': 'Kyrgyzstan' }, { 'iso_3166_alpha2_code': 'LA', 'name_en': 'Lao People\'s Democratic Republic' }, { 'iso_3166_alpha2_code': 'LV', 'name_en': 'Latvia' }, { 'iso_3166_alpha2_code': 'LB', 'name_en': 'Lebanon' }, { 'iso_3166_alpha2_code': 'LS', 'name_en': 'Lesotho' }, { 'iso_3166_alpha2_code': 'LR', 'name_en': 'Liberia' }, { 'iso_3166_alpha2_code': 'LY', 'name_en': 'Libyan Arab Jamahiriya' }, { 'iso_3166_alpha2_code': 'LI', 'name_en': 'Liechtenstein' }, { 'iso_3166_alpha2_code': 'LT', 'name_en': 'Lithuania' }, { 'iso_3166_alpha2_code': 'LU', 'name_en': 'Luxembourg' }, { 'iso_3166_alpha2_code': 'MO', 'name_en': 'Macao' }, { 'iso_3166_alpha2_code': 'MK', 'name_en': 'Macedonia, The Former Yugoslav Republic of' }, { 'iso_3166_alpha2_code': 'MG', 'name_en': 'Madagascar' }, { 'iso_3166_alpha2_code': 'MW', 'name_en': 'Malawi' }, { 'iso_3166_alpha2_code': 'MY', 'name_en': 'Malaysia' }, { 'iso_3166_alpha2_code': 'MV', 'name_en': 'Maldives' }, { 'iso_3166_alpha2_code': 'ML', 'name_en': 'Mali' }, { 'iso_3166_alpha2_code': 'MT', 'name_en': 'Malta' }, { 'iso_3166_alpha2_code': 'MH', 'name_en': 'Marshall Islands' }, { 'iso_3166_alpha2_code': 'MQ', 'name_en': 'Martinique' }, { 'iso_3166_alpha2_code': 'MR', 'name_en': 'Mauritania' }, { 'iso_3166_alpha2_code': 'MU', 'name_en': 'Mauritius' }, { 'iso_3166_alpha2_code': 'YT', 'name_en': 'Mayotte' }, { 'iso_3166_alpha2_code': 'MX', 'name_en': 'Mexico' }, { 'iso_3166_alpha2_code': 'FM', 'name_en': 'Micronesia, Federated States of' }, { 'iso_3166_alpha2_code': 'MD', 'name_en': 'Moldova, Republic of' }, { 'iso_3166_alpha2_code': 'MC', 'name_en': 'Monaco' }, { 'iso_3166_alpha2_code': 'MN', 'name_en': 'Mongolia' }, { 'iso_3166_alpha2_code': 'ME', 'name_en': 'Montenegro' }, { 'iso_3166_alpha2_code': 'MS', 'name_en': 'Montserrat' }, { 'iso_3166_alpha2_code': 'MA', 'name_en': 'Morocco' }, { 'iso_3166_alpha2_code': 'MZ', 'name_en': 'Mozambique' }, { 'iso_3166_alpha2_code': 'MM', 'name_en': 'Myanmar' }, { 'iso_3166_alpha2_code': 'NA', 'name_en': 'Namibia' }, { 'iso_3166_alpha2_code': 'NR', 'name_en': 'Nauru' }, { 'iso_3166_alpha2_code': 'NP', 'name_en': 'Nepal' }, { 'iso_3166_alpha2_code': 'NL', 'name_en': 'Netherlands' }, { 'iso_3166_alpha2_code': 'AN', 'name_en': 'Netherlands Antilles' }, { 'iso_3166_alpha2_code': 'NC', 'name_en': 'New Caledonia' }, { 'iso_3166_alpha2_code': 'NZ', 'name_en': 'New Zealand' }, { 'iso_3166_alpha2_code': 'NI', 'name_en': 'Nicaragua' }, { 'iso_3166_alpha2_code': 'NE', 'name_en': 'Niger' }, { 'iso_3166_alpha2_code': 'NG', 'name_en': 'Nigeria' }, { 'iso_3166_alpha2_code': 'NU', 'name_en': 'Niue' }, { 'iso_3166_alpha2_code': 'NF', 'name_en': 'Norfolk Island' }, { 'iso_3166_alpha2_code': 'MP', 'name_en': 'Northern Mariana Islands' }, { 'iso_3166_alpha2_code': 'NO', 'name_en': 'Norway' }, { 'iso_3166_alpha2_code': 'OM', 'name_en': 'Oman' }, { 'iso_3166_alpha2_code': 'PK', 'name_en': 'Pakistan' }, { 'iso_3166_alpha2_code': 'PW', 'name_en': 'Palau' }, { 'iso_3166_alpha2_code': 'PS', 'name_en': 'Palestinian Territory, Occupied' }, { 'iso_3166_alpha2_code': 'PA', 'name_en': 'Panama' }, { 'iso_3166_alpha2_code': 'PG', 'name_en': 'Papua New Guinea' }, { 'iso_3166_alpha2_code': 'PY', 'name_en': 'Paraguay' }, { 'iso_3166_alpha2_code': 'PE', 'name_en': 'Peru' }, { 'iso_3166_alpha2_code': 'PH', 'name_en': 'Philippines' }, { 'iso_3166_alpha2_code': 'PN', 'name_en': 'Pitcairn' }, { 'iso_3166_alpha2_code': 'PL', 'name_en': 'Poland' }, { 'iso_3166_alpha2_code': 'PT', 'name_en': 'Portugal' }, { 'iso_3166_alpha2_code': 'PR', 'name_en': 'Puerto Rico' }, { 'iso_3166_alpha2_code': 'QA', 'name_en': 'Qatar' }, { 'iso_3166_alpha2_code': 'RE', 'name_en': 'Reunion' }, { 'iso_3166_alpha2_code': 'RO', 'name_en': 'Romania' }, { 'iso_3166_alpha2_code': 'RU', 'name_en': 'Russian Federation' }, { 'iso_3166_alpha2_code': 'RW', 'name_en': 'Rwanda' }, { 'iso_3166_alpha2_code': 'SH', 'name_en': 'Saint Helena' }, { 'iso_3166_alpha2_code': 'KN', 'name_en': 'Saint Kitts and Nevis' }, { 'iso_3166_alpha2_code': 'LC', 'name_en': 'Saint Lucia' }, { 'iso_3166_alpha2_code': 'PM', 'name_en': 'Saint Pierre and Miquelon' }, { 'iso_3166_alpha2_code': 'VC', 'name_en': 'Saint Vincent and the Grenadines' }, { 'iso_3166_alpha2_code': 'WS', 'name_en': 'Samoa' }, { 'iso_3166_alpha2_code': 'SM', 'name_en': 'San Marino' }, { 'iso_3166_alpha2_code': 'ST', 'name_en': 'Sao Tome and Principe' }, { 'iso_3166_alpha2_code': 'SA', 'name_en': 'Saudi Arabia' }, { 'iso_3166_alpha2_code': 'SN', 'name_en': 'Senegal' }, { 'iso_3166_alpha2_code': 'RS', 'name_en': 'Serbia' }, { 'iso_3166_alpha2_code': 'SC', 'name_en': 'Seychelles' }, { 'iso_3166_alpha2_code': 'SL', 'name_en': 'Sierra Leone' }, { 'iso_3166_alpha2_code': 'SG', 'name_en': 'Singapore' }, { 'iso_3166_alpha2_code': 'SK', 'name_en': 'Slovakia' }, { 'iso_3166_alpha2_code': 'SI', 'name_en': 'Slovenia' }, { 'iso_3166_alpha2_code': 'SB', 'name_en': 'Solomon Islands' }, { 'iso_3166_alpha2_code': 'SO', 'name_en': 'Somalia' }, { 'iso_3166_alpha2_code': 'ZA', 'name_en': 'South Africa' }, { 'iso_3166_alpha2_code': 'GS', 'name_en': 'South Georgia and the South Sandwich Islands' }, { 'iso_3166_alpha2_code': 'ES', 'name_en': 'Spain' }, { 'iso_3166_alpha2_code': 'LK', 'name_en': 'Sri Lanka' }, { 'iso_3166_alpha2_code': 'SD', 'name_en': 'Sudan' }, { 'iso_3166_alpha2_code': 'SR', 'name_en': 'Suriname_en' }, { 'iso_3166_alpha2_code': 'SJ', 'name_en': 'Svalbard and Jan Mayen' }, { 'iso_3166_alpha2_code': 'SZ', 'name_en': 'Swaziland' }, { 'iso_3166_alpha2_code': 'SE', 'name_en': 'Sweden' }, { 'iso_3166_alpha2_code': 'CH', 'name_en': 'Switzerland' }, { 'iso_3166_alpha2_code': 'SY', 'name_en': 'Syrian Arab Republic' }, { 'iso_3166_alpha2_code': 'TW', 'name_en': 'Taiwan' }, { 'iso_3166_alpha2_code': 'TJ', 'name_en': 'Tajikistan' }, { 'iso_3166_alpha2_code': 'TZ', 'name_en': 'Tanzania, United Republic of' }, { 'iso_3166_alpha2_code': 'TH', 'name_en': 'Thailand' }, { 'iso_3166_alpha2_code': 'TL', 'name_en': 'Timor-Leste' }, { 'iso_3166_alpha2_code': 'TG', 'name_en': 'Togo' }, { 'iso_3166_alpha2_code': 'TK', 'name_en': 'Tokelau' }, { 'iso_3166_alpha2_code': 'TO', 'name_en': 'Tonga' }, { 'iso_3166_alpha2_code': 'TT', 'name_en': 'Trinidad and Tobago' }, { 'iso_3166_alpha2_code': 'TN', 'name_en': 'Tunisia' }, { 'iso_3166_alpha2_code': 'TR', 'name_en': 'Turkey' }, { 'iso_3166_alpha2_code': 'TM', 'name_en': 'Turkmenistan' }, { 'iso_3166_alpha2_code': 'TC', 'name_en': 'Turks and Caicos Islands' }, { 'iso_3166_alpha2_code': 'TV', 'name_en': 'Tuvalu' }, { 'iso_3166_alpha2_code': 'UG', 'name_en': 'Uganda' }, { 'iso_3166_alpha2_code': 'UA', 'name_en': 'Ukraine' }, { 'iso_3166_alpha2_code': 'AE', 'name_en': 'United Arab Emirates' }, { 'iso_3166_alpha2_code': 'GB', 'name_en': 'United Kingdom' }, { 'iso_3166_alpha2_code': 'US', 'name_en': 'United States' }, { 'iso_3166_alpha2_code': 'UM', 'name_en': 'United States Minor Outlying Islands' }, { 'iso_3166_alpha2_code': 'UY', 'name_en': 'Uruguay' }, { 'iso_3166_alpha2_code': 'UZ', 'name_en': 'Uzbekistan' }, { 'iso_3166_alpha2_code': 'VU', 'name_en': 'Vanuatu' }, { 'iso_3166_alpha2_code': 'VE', 'name_en': 'Venezuela' }, { 'iso_3166_alpha2_code': 'VN', 'name_en': 'Viet Nam' }, { 'iso_3166_alpha2_code': 'VG', 'name_en': 'Virgin Islands, British' }, { 'iso_3166_alpha2_code': 'VI', 'name_en': 'Virgin Islands, U.S.' }, { 'iso_3166_alpha2_code': 'WF', 'name_en': 'Wallis and Futuna' }, { 'iso_3166_alpha2_code': 'EH', 'name_en': 'Western Sahara' }, { 'iso_3166_alpha2_code': 'YE', 'name_en': 'Yemen' }, { 'iso_3166_alpha2_code': 'ZM', 'name_en': 'Zambia' }, { 'iso_3166_alpha2_code': 'ZW', 'name_en': 'Zimbabwe' }]);

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  'ine_region_code': '08',
  'ine_province_code': '02',
  'id': 1,
  'name_cadaster': 'ALBACETE',
  'name_es': 'Albacete',
  'name_ca': 'Albacete',
  'name_ine': 'Albacete'
}, {
  'ine_region_code': '10',
  'ine_province_code': '03',
  'id': 2,
  'name_cadaster': 'ALACANT',
  'name_es': 'Alicante',
  'name_ca': 'Alacant',
  'name_ine': 'Alicante/Alacant'
}, {
  'ine_region_code': '01',
  'ine_province_code': '04',
  'id': 3,
  'name_cadaster': 'ALMERIA',
  'name_es': 'Almería',
  'name_ca': 'Almeria',
  'name_ine': 'Almería'
}, {
  'ine_region_code': '16',
  'ine_province_code': '01',
  'id': 4,
  'name_cadaster': '',
  'name_es': 'Álava',
  'name_ca': 'Àlaba',
  'name_ine': 'Araba/Álava'
}, {
  'ine_region_code': '03',
  'ine_province_code': '33',
  'id': 5,
  'name_cadaster': 'ASTURIAS',
  'name_es': 'Asturias',
  'name_ca': 'Astúries',
  'name_ine': 'Asturias'
}, {
  'ine_region_code': '07',
  'ine_province_code': '05',
  'id': 6,
  'name_cadaster': 'AVILA',
  'name_es': 'Ávila',
  'name_ca': 'Àvila',
  'name_ine': 'Ávila'
}, {
  'ine_region_code': '11',
  'ine_province_code': '06',
  'id': 7,
  'name_cadaster': 'BADAJOZ',
  'name_es': 'Badajoz',
  'name_ca': 'Badajoz',
  'name_ine': 'Badajoz'
}, {
  'ine_region_code': '04',
  'ine_province_code': '07',
  'id': 8,
  'name_cadaster': 'ILLES BALEARS',
  'name_es': 'Baleares, Islas',
  'name_ca': 'Balears, Illes',
  'name_ine': 'Balears, Illes'
}, {
  'ine_region_code': '09',
  'ine_province_code': '08',
  'id': 9,
  'name_cadaster': 'BARCELONA',
  'name_es': 'Barcelona',
  'name_ca': 'Barcelona',
  'name_ine': 'Barcelona'
}, {
  'ine_region_code': '16',
  'ine_province_code': '48',
  'id': 10,
  'name_cadaster': '',
  'name_es': 'Vizcaya',
  'name_ca': 'Biscaia',
  'name_ine': 'Bizkaia'
}, {
  'ine_region_code': '07',
  'ine_province_code': '09',
  'id': 11,
  'name_cadaster': 'BURGOS',
  'name_es': 'Burgos',
  'name_ca': 'Burgos',
  'name_ine': 'Burgos'
}, {
  'ine_region_code': '11',
  'ine_province_code': '10',
  'id': 12,
  'name_cadaster': 'CACERES',
  'name_es': 'Cáceres',
  'name_ca': 'Càceres',
  'name_ine': 'Cáceres'
}, {
  'ine_region_code': '01',
  'ine_province_code': '11',
  'id': 13,
  'name_cadaster': 'CADIZ',
  'name_es': 'Cádiz',
  'name_ca': 'Cadis',
  'name_ine': 'Cádiz'
}, {
  'ine_region_code': '06',
  'ine_province_code': '39',
  'id': 14,
  'name_cadaster': 'CANTABRIA',
  'name_es': 'Cantabria',
  'name_ca': 'Cantàbria',
  'name_ine': 'Cantabria'
}, {
  'ine_region_code': '10',
  'ine_province_code': '12',
  'id': 15,
  'name_cadaster': 'CASTELLO',
  'name_es': 'Castellón',
  'name_ca': 'Castelló',
  'name_ine': 'Castellón/Castelló'
}, {
  'ine_region_code': '08',
  'ine_province_code': '13',
  'id': 16,
  'name_cadaster': 'CIUDAD REAL',
  'name_es': 'Ciudad Real',
  'name_ca': 'Ciutat Real',
  'name_ine': 'Ciudad Real'
}, {
  'ine_region_code': '01',
  'ine_province_code': '14',
  'id': 17,
  'name_cadaster': 'CORDOBA',
  'name_es': 'Córdoba',
  'name_ca': 'Còrdoba',
  'name_ine': 'Córdoba'
}, {
  'ine_region_code': '12',
  'ine_province_code': '15',
  'id': 18,
  'name_cadaster': 'A CORUÑA',
  'name_es': 'Coruña,A',
  'name_ca': 'Corunya, La',
  'name_ine': 'Coruña, A'
}, {
  'ine_region_code': '08',
  'ine_province_code': '16',
  'id': 19,
  'name_cadaster': 'CUENCA',
  'name_es': 'Cuenca',
  'name_ca': 'Conca',
  'name_ine': 'Cuenca'
}, {
  'ine_region_code': '16',
  'ine_province_code': '20',
  'id': 20,
  'name_cadaster': '',
  'name_es': 'Guipúzcoa',
  'name_ca': 'Guipúscoa',
  'name_ine': 'Gipuzkoa'
}, {
  'ine_region_code': '09',
  'ine_province_code': '17',
  'id': 21,
  'name_cadaster': 'GIRONA',
  'name_es': 'Gerona',
  'name_ca': 'Girona',
  'name_ine': 'Girona'
}, {
  'ine_region_code': '01',
  'ine_province_code': '18',
  'id': 22,
  'name_cadaster': 'GRANADA',
  'name_es': 'Granada',
  'name_ca': 'Granada',
  'name_ine': 'Granada'
}, {
  'ine_region_code': '08',
  'ine_province_code': '19',
  'id': 23,
  'name_cadaster': 'GUADALAJARA',
  'name_es': 'Guadalajara',
  'name_ca': 'Guadalajara',
  'name_ine': 'Guadalajara'
}, {
  'ine_region_code': '01',
  'ine_province_code': '21',
  'id': 24,
  'name_cadaster': 'HUELVA',
  'name_es': 'Huelva',
  'name_ca': 'Huelva',
  'name_ine': 'Huelva'
}, {
  'ine_region_code': '02',
  'ine_province_code': '22',
  'id': 25,
  'name_cadaster': 'HUESCA',
  'name_es': 'Huesca',
  'name_ca': 'Huesca',
  'name_ine': 'Huesca'
}, {
  'ine_region_code': '01',
  'ine_province_code': '23',
  'id': 26,
  'name_cadaster': 'JAEN',
  'name_es': 'Jaén',
  'name_ca': 'Jaén',
  'name_ine': 'Jaén'
}, {
  'ine_region_code': '07',
  'ine_province_code': '24',
  'id': 27,
  'name_cadaster': 'LEON',
  'name_es': 'León',
  'name_ca': 'Lleó',
  'name_ine': 'León'
}, {
  'ine_region_code': '09',
  'ine_province_code': '25',
  'id': 28,
  'name_cadaster': 'LLEIDA',
  'name_es': 'Lérida',
  'name_ca': 'Lleida',
  'name_ine': 'Lleida'
}, {
  'ine_region_code': '12',
  'ine_province_code': '27',
  'id': 29,
  'name_cadaster': 'LUGO',
  'name_es': 'Lugo',
  'name_ca': 'Lugo',
  'name_ine': 'Lugo'
}, {
  'ine_region_code': '13',
  'ine_province_code': '28',
  'id': 30,
  'name_cadaster': 'MADRID',
  'name_es': 'Madrid',
  'name_ca': 'Madrid',
  'name_ine': 'Madrid'
}, {
  'ine_region_code': '01',
  'ine_province_code': '29',
  'id': 31,
  'name_cadaster': 'MALAGA',
  'name_es': 'Málaga',
  'name_ca': 'Màlaga',
  'name_ine': 'Málaga'
}, {
  'ine_region_code': '14',
  'ine_province_code': '30',
  'id': 32,
  'name_cadaster': 'MURCIA',
  'name_es': 'Murcia',
  'name_ca': 'Múrcia',
  'name_ine': 'Murcia'
}, {
  'ine_region_code': '15',
  'ine_province_code': '31',
  'id': 33,
  'name_es': 'Navarra',
  'name_ca': 'Navarra',
  'name_ine': 'Navarra'
}, {
  'ine_region_code': '12',
  'ine_province_code': '32',
  'id': 34,
  'name_cadaster': 'OURENSE',
  'name_es': 'Orense',
  'name_ca': 'Ourense',
  'name_ine': 'Ourense'
}, {
  'ine_region_code': '07',
  'ine_province_code': '34',
  'id': 35,
  'name_cadaster': 'PALENCIA',
  'name_es': 'Palencia',
  'name_ca': 'Palència',
  'name_ine': 'Palencia'
}, {
  'ine_region_code': '05',
  'ine_province_code': '35',
  'id': 36,
  'name_cadaster': 'LAS PALMAS',
  'name_es': 'Palmas, Las',
  'name_ca': 'Palmas, Las',
  'name_ine': 'Palmas, Las'
}, {
  'ine_region_code': '12',
  'ine_province_code': '36',
  'id': 37,
  'name_cadaster': 'PONTEVEDRA',
  'name_es': 'Pontevedra',
  'name_ca': 'Pontevedra',
  'name_ine': 'Pontevedra'
}, {
  'ine_region_code': '17',
  'ine_province_code': '26',
  'id': 38,
  'name_cadaster': 'LA RIOJA',
  'name_es': 'Rioja, La',
  'name_ca': 'Rioja, La',
  'name_ine': 'Rioja, La'
}, {
  'ine_region_code': '07',
  'ine_province_code': '37',
  'id': 39,
  'name_cadaster': 'SALAMANCA',
  'name_es': 'Salamanca',
  'name_ca': 'Salamanca',
  'name_ine': 'Salamanca'
}, {
  'ine_region_code': '05',
  'ine_province_code': '38',
  'id': 40,
  'name_cadaster': 'S.C. TENERIFE',
  'name_es': 'Santa Cruz de Tenerife',
  'name_ca': 'Santa Cruz de Tenerife',
  'name_ine': 'Santa Cruz de Tenerife'
}, {
  'ine_region_code': '07',
  'ine_province_code': '40',
  'id': 41,
  'name_cadaster': 'SEGOVIA',
  'name_es': 'Segovia',
  'name_ca': 'Segòvia',
  'name_ine': 'Segovia'
}, {
  'ine_region_code': '01',
  'ine_province_code': '41',
  'id': 42,
  'name_cadaster': 'SEVILLA',
  'name_es': 'Sevilla',
  'name_ca': 'Sevilla',
  'name_ine': 'Sevilla'
}, {
  'ine_region_code': '07',
  'ine_province_code': '42',
  'id': 43,
  'name_cadaster': 'SORIA',
  'name_es': 'Soria',
  'name_ca': 'Sòria',
  'name_ine': 'Soria'
}, {
  'ine_region_code': '09',
  'ine_province_code': '43',
  'id': 44,
  'name_cadaster': 'TARRAGONA',
  'name_es': 'Tarragona',
  'name_ca': 'Tarragona',
  'name_ine': 'Tarragona'
}, {
  'ine_region_code': '02',
  'ine_province_code': '44',
  'id': 45,
  'name_cadaster': 'TERUEL',
  'name_es': 'Teruel',
  'name_ca': 'Teruel',
  'name_ine': 'Teruel'
}, {
  'ine_region_code': '08',
  'ine_province_code': '45',
  'id': 46,
  'name_cadaster': 'TOLEDO',
  'name_es': 'Toledo',
  'name_ca': 'Toledo',
  'name_ine': 'Toledo'
}, {
  'ine_region_code': '10',
  'ine_province_code': '46',
  'id': 47,
  'name_cadaster': 'VALENCIA',
  'name_es': 'Valencia',
  'name_ca': 'València',
  'name_ine': 'Valencia/València'
}, {
  'ine_region_code': '07',
  'ine_province_code': '47',
  'id': 48,
  'name_cadaster': 'VALLADOLID',
  'name_es': 'Valladolid',
  'name_ca': 'Valladolid',
  'name_ine': 'Valladolid'
}, {
  'ine_region_code': '07',
  'ine_province_code': '49',
  'id': 49,
  'name_cadaster': 'ZAMORA',
  'name_es': 'Zamora',
  'name_ca': 'Zamora',
  'name_ine': 'Zamora'
}, {
  'ine_region_code': '02',
  'ine_province_code': '50',
  'id': 50,
  'name_cadaster': 'ZARAGOZA',
  'name_es': 'Zaragoza',
  'name_ca': 'Saragossa',
  'name_ine': 'Zaragoza'
}, {
  'ine_region_code': '18',
  'ine_province_code': '51',
  'id': 51,
  'name_cadaster': 'CEUTA',
  'name_es': 'Ceuta',
  'name_ca': 'Ceuta',
  'name_ine': 'Ceuta'
}, {
  'ine_region_code': '19',
  'ine_province_code': '52',
  'id': 52,
  'name_cadaster': 'MELILLA',
  'name_es': 'Melilla',
  'name_ca': 'Melilla',
  'name_ine': 'Melilla'
}]);

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__settings__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);



/* harmony default export */ __webpack_exports__["a"] = ({
    geolocate: function geolocate(data) {

        console.log('--- maps_api.js geolocate data: ');
        console.log(data);
        console.log('----------');

        return new Promise(function (resolve, reject) {

            // geocode api key
            var api_key = 'AIzaSyB__K_9Sk2AOlY8rJKWPy7XYuWRASaWxDU';
            var address = data.street_name + ', ' + data.street_number + ', ' + data.municipality.name_ine;
            var postUrl = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + address + '&key=' + api_key;

            __WEBPACK_IMPORTED_MODULE_1_vue___default.a.http.post(postUrl, null, {
                emulateHTTP: true, headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            }).then(function (res) {
                return resolve({
                    results: res.body.results,
                    lat: res.body.results[0].geometry.location.lat,
                    lng: res.body.results[0].geometry.location.lng,
                    formatted_address: res.body.results[0].formatted_address,
                    street_number: parseInt(res.body.results[0].address_components[0].long_name),
                    street_name: res.body.results[0].address_components[1].long_name,
                    municipality: res.body.results[0].address_components[2].long_name,
                    province: res.body.results[0].address_components[3].long_name,
                    region: res.body.results[0].address_components[4].long_name,
                    country: res.body.results[0].address_components[5].long_name,
                    postal_code: res.body.results[0].address_components[6].long_name,
                    viewport: res.body.results[0].geometry.viewport
                });
            }, function (res) {
                console.error(res.body);
            });
        });
    },
    googledistance: function googledistance(data) {

        console.log('--- maps_api.js distance data: ');
        console.log(data);
        console.log('----------');

        return new Promise(function (resolve, reject) {

            // we don't have yet a key for distancematrix api
            var api_key = '';
            var origin = 'Carrer de Còrsega, 168, Barcelona';
            var destination = data.street_name + ', ' + data.street_number + ', ' + data.municipality.name_ine;
            var mode = 'driving';
            var postUrl = 'https://maps.googleapis.com/maps/api/distancematrix/json?origins=' + origin + '&destinations=' + destination + '&key=' + api_key;

            __WEBPACK_IMPORTED_MODULE_1_vue___default.a.http.post(postUrl, null, {
                emulateHTTP: true, headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            }).then(function (res) {
                return resolve({
                    results: res
                });
            }, function (res) {
                console.error(res.body);
            });
        });

        // const url = 'https://maps.googleapis.com/maps/api/directions/json?origin='+origin+'&destination='+destination+'&mode='+mode+'+&key=' + api_key

        /*
        const url = 'https://us-central1-barnatasa5.cloudfunctions.net/googledistance?destination='+destination
         Vue.http.get(url, null, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        })
            */
    },
    request_icc_census_section_info: function request_icc_census_section_info(data) {

        //https://www1.sedecatastro.gob.es/Cartografia/mapa.aspx?del=8&mun=900&refcat=9025701DF2892E0021AF&final=

        var dist = 600;
        var coord_a1 = data.x - dist / 2;
        var coord_a2 = data.y - dist / 2;
        var coord_b1 = data.x + dist / 2;
        var coord_b2 = data.y + dist / 2;

        var bbox = coord_a1 + ',' + coord_a2 + ',' + coord_b1 + ',' + coord_b2;

        return new Promise(function (resolve, reject) {

            // const url = 'http://geoserveis.icc.cat/icc_bseccen/wms/service?REQUEST=GetFeatureInfo&SERVICE=WMS&VERSION=1.3.0&QUERY_LAYERS=2014_gris_TX&CRS=EPSG:25831&info_format=text%2Fhtml&BBOX=' + bbox + '&WIDTH=800&HEIGHT=800&X=400&Y=400'
            var url = 'https://us-central1-barnatasa5.cloudfunctions.net/icc_census_section_info_by_bbox?bbox=' + bbox;
            __WEBPACK_IMPORTED_MODULE_1_vue___default.a.http.get(url, null, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            }).then(function (res) {
                return resolve({
                    html: res.body

                });
            }, function (res) {
                console.error(res.body);
            });
        });
    },
    request_idescat_info_by_code_ine: function request_idescat_info_by_code_ine(data) {

        return new Promise(function (resolve, reject) {

            // const url = 'http://geoserveis.icc.cat/icc_bseccen/wms/service?REQUEST=GetFeatureInfo&SERVICE=WMS&VERSION=1.3.0&QUERY_LAYERS=2014_gris_TX&CRS=EPSG:25831&info_format=text%2Fhtml&BBOX=' + bbox + '&WIDTH=800&HEIGHT=800&X=400&Y=400'
            var url = 'https://us-central1-barnatasa5.cloudfunctions.net/idescat_info_by_code_ine?code_ine=' + data.code_ine;

            __WEBPACK_IMPORTED_MODULE_1_vue___default.a.http.get(url, null, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            }).then(function (res) {
                return resolve({
                    html: res.body

                });
            }, function (res) {
                console.error(res.body);
            });
        });
    },
    request_muc_info: function request_muc_info(data) {

        //https://www1.sedecatastro.gob.es/Cartografia/mapa.aspx?del=8&mun=900&refcat=9025701DF2892E0021AF&final=

        var dist = 600;
        var coord_a1 = data.x - dist / 2;
        var coord_a2 = data.y - dist / 2;
        var coord_b1 = data.x + dist / 2;
        var coord_b2 = data.y + dist / 2;

        var bbox = coord_a1 + ',' + coord_a2 + ',' + coord_b1 + ',' + coord_b2;

        return new Promise(function (resolve, reject) {

            // const url = 'http://geoserveis.icc.cat/icc_bseccen/wms/service?REQUEST=GetFeatureInfo&SERVICE=WMS&VERSION=1.3.0&QUERY_LAYERS=2014_gris_TX&CRS=EPSG:25831&info_format=text%2Fhtml&BBOX=' + bbox + '&WIDTH=800&HEIGHT=800&X=400&Y=400'
            var url = 'https://us-central1-barnatasa5.cloudfunctions.net/muc_info_by_bbox?bbox=' + bbox;
            __WEBPACK_IMPORTED_MODULE_1_vue___default.a.http.get(url, null, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            }).then(function (res) {
                return resolve({
                    html: res.body

                });
            }, function (res) {
                console.error(res.body);
                reject();
            });
        });
    },
    request_map_urban_muc_land_colors_by_bbox: function request_map_urban_muc_land_colors_by_bbox(data) {

        console.log('request_muc_map data in maps_api.js: ');
        console.log(data);

        //https://www1.sedecatastro.gob.es/Cartografia/mapa.aspx?del=8&mun=900&refcat=9025701DF2892E0021AF&final=

        var factor = 0.2;
        var width = data.width * data.zoom * factor;
        var height = data.height * data.zoom * factor;
        var coord_a1 = data.x - width / 2;
        var coord_a2 = data.y - height / 2;
        var coord_b1 = data.x + width / 2;
        var coord_b2 = data.y + height / 2;

        var bbox = coord_a1 + ',' + coord_a2 + ',' + coord_b1 + ',' + coord_b2;

        return new Promise(function (resolve, reject) {

            // const url = 'http://geoserveis.icc.cat/icc_bseccen/wms/service?REQUEST=GetFeatureInfo&SERVICE=WMS&VERSION=1.3.0&QUERY_LAYERS=2014_gris_TX&CRS=EPSG:25831&info_format=text%2Fhtml&BBOX=' + bbox + '&WIDTH=800&HEIGHT=800&X=400&Y=400'
            var url = 'https://us-central1-barnatasa5.cloudfunctions.net/map_urban_muc_land_colors_by_bbox?bbox=' + bbox + '&realestate_id=' + data.realestate_id + '&appraisal_id=' + data.appraisal_id;
            __WEBPACK_IMPORTED_MODULE_1_vue___default.a.http.get(url, null, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            }).then(function (res) {
                return resolve({
                    link: res.body

                });
            }, function (res) {
                console.error(res);
                reject();
            });
        });
    },
    request_map_urban_muc_council_qual_by_bbox: function request_map_urban_muc_council_qual_by_bbox(data) {

        console.log('request_muc_map data in maps_api.js: ');
        console.log(data);

        //https://www1.sedecatastro.gob.es/Cartografia/mapa.aspx?del=8&mun=900&refcat=9025701DF2892E0021AF&final=

        var factor = 0.2;
        var width = data.width * data.zoom * factor;
        var height = data.height * data.zoom * factor;
        var coord_a1 = data.x - width / 2;
        var coord_a2 = data.y - height / 2;
        var coord_b1 = data.x + width / 2;
        var coord_b2 = data.y + height / 2;

        var bbox = coord_a1 + ',' + coord_a2 + ',' + coord_b1 + ',' + coord_b2;

        return new Promise(function (resolve, reject) {

            // const url = 'http://geoserveis.icc.cat/icc_bseccen/wms/service?REQUEST=GetFeatureInfo&SERVICE=WMS&VERSION=1.3.0&QUERY_LAYERS=2014_gris_TX&CRS=EPSG:25831&info_format=text%2Fhtml&BBOX=' + bbox + '&WIDTH=800&HEIGHT=800&X=400&Y=400'
            var url = 'https://us-central1-barnatasa5.cloudfunctions.net/map_urban_muc_council_qual_by_bbox?bbox=' + bbox + '&realestate_id=' + data.realestate_id + '&appraisal_id=' + data.appraisal_id;
            __WEBPACK_IMPORTED_MODULE_1_vue___default.a.http.get(url, null, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            }).then(function (res) {
                return resolve({
                    link: res.body

                });
            }, function (res) {
                console.error(res);
                reject();
            });
        });
    },
    request_map_urban_icc_topo_by_bbox: function request_map_urban_icc_topo_by_bbox(data) {

        console.log('request_muc_map data in maps_api.js: ');
        console.log(data);

        //https://www1.sedecatastro.gob.es/Cartografia/mapa.aspx?del=8&mun=900&refcat=9025701DF2892E0021AF&final=
        var factor = 0.2;
        var width = data.width * data.zoom * factor;
        var height = data.height * data.zoom * factor;
        var coord_a1 = data.x - width / 2;
        var coord_a2 = data.y - height / 2;
        var coord_b1 = data.x + width / 2;
        var coord_b2 = data.y + height / 2;

        var bbox = coord_a1 + ',' + coord_a2 + ',' + coord_b1 + ',' + coord_b2;

        return new Promise(function (resolve, reject) {

            // const url = 'http://geoserveis.icc.cat/icc_bseccen/wms/service?REQUEST=GetFeatureInfo&SERVICE=WMS&VERSION=1.3.0&QUERY_LAYERS=2014_gris_TX&CRS=EPSG:25831&info_format=text%2Fhtml&BBOX=' + bbox + '&WIDTH=800&HEIGHT=800&X=400&Y=400'
            var url = 'https://us-central1-barnatasa5.cloudfunctions.net/map_urban_icc_topo_by_bbox?bbox=' + bbox + '&realestate_id=' + data.realestate_id + '&appraisal_id=' + data.appraisal_id;
            __WEBPACK_IMPORTED_MODULE_1_vue___default.a.http.get(url, null, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            }).then(function (res) {
                return resolve({
                    link: res.body

                });
            }, function (res) {
                console.error(res);
                reject();
            });
        });
    },
    request_cadastral_reference_by_coordinates: function request_cadastral_reference_by_coordinates(data) {
        console.log('maps_api.js request_cadastral_reference_by_coordinates: ');
        console.log(data);

        function xmlToJson(xml) {

            // Create the return object
            var obj = {};

            if (xml.nodeType == 1) {
                // element
                // do attributes
                if (xml.attributes.length > 0) {
                    obj['@attributes'] = {};
                    for (var j = 0; j < xml.attributes.length; j++) {
                        var attribute = xml.attributes.item(j);
                        obj['@attributes'][attribute.nodeName] = attribute.nodeValue;
                    }
                }
            } else if (xml.nodeType == 3) {
                // text
                obj = xml.nodeValue;
            }

            // do children
            // If just one text node inside
            if (xml.hasChildNodes() && xml.childNodes.length === 1 && xml.childNodes[0].nodeType === 3) {
                obj = xml.childNodes[0].nodeValue;
            } else if (xml.hasChildNodes()) {
                for (var i = 0; i < xml.childNodes.length; i++) {
                    var item = xml.childNodes.item(i);
                    var nodeName = item.nodeName;
                    if (typeof obj[nodeName] == 'undefined') {
                        obj[nodeName] = xmlToJson(item);
                    } else {
                        if (typeof obj[nodeName].push == 'undefined') {
                            var old = obj[nodeName];
                            obj[nodeName] = [];
                            obj[nodeName].push(old);
                        }
                        obj[nodeName].push(xmlToJson(item));
                    }
                }
            }
            return obj;
        }

        return new Promise(function (resolve, reject) {

            var parser = new DOMParser();

            var srs = 'EPSG:25831';
            var x = data.x.toString();
            var y = data.y.toString();

            // const getUrl = 'http://ovc.catastro.meh.es/ovcservweb/OVCSWLocalizacionRC/OVCCoordenadas.asmx/Consulta_RCCOOR_Distancia?SRS=' + SRS + '&Coordenada_X=' + x + '&Coordenada_Y=' + y
            var getUrl = 'https://us-central1-barnatasa5.cloudfunctions.net/cad_ref_by_coords?srs=' + srs + '&x=' + x + '&y=' + y;

            __WEBPACK_IMPORTED_MODULE_1_vue___default.a.http.get(getUrl, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            }).then(function (res) {
                return resolve({
                    result: xmlToJson(parser.parseFromString(res.body, 'text/xml'))
                });
            }, function (res) {
                console.error(res.body);
            });
        });
    }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = aggregate;
function aggregate(array, callback, startValue) {

    var accumulator = startValue || 0;

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = array[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;


            var result = callback.call(this, accumulator, item, array);

            if (result === false) {
                return false;
            }

            accumulator = result;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return accumulator;
}

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(47);
var toLength = __webpack_require__(36);
var toAbsoluteIndex = __webpack_require__(87);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(26);
var $export = __webpack_require__(2);
var redefine = __webpack_require__(43);
var redefineAll = __webpack_require__(85);
var meta = __webpack_require__(72);
var forOf = __webpack_require__(79);
var anInstance = __webpack_require__(78);
var isObject = __webpack_require__(30);
var fails = __webpack_require__(29);
var $iterDetect = __webpack_require__(131);
var setToStringTag = __webpack_require__(94);
var inheritIfRequired = __webpack_require__(177);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hide = __webpack_require__(42);
var redefine = __webpack_require__(43);
var fails = __webpack_require__(29);
var defined = __webpack_require__(57);
var wks = __webpack_require__(32);

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);
  var fns = exec(defined, SYMBOL, ''[KEY]);
  var strfn = fns[0];
  var rxfn = fns[1];
  if (fails(function () {
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  })) {
    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(24);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(49);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(30);
var cof = __webpack_require__(49);
var MATCH = __webpack_require__(32)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(32)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(80) || !__webpack_require__(29)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(26)[K];
});


/***/ }),
/* 133 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(2);
var aFunction = __webpack_require__(39);
var ctx = __webpack_require__(50);
var forOf = __webpack_require__(79);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(2);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(26);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(24);
var aFunction = __webpack_require__(39);
var SPECIES = __webpack_require__(32)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(26);
var hide = __webpack_require__(42);
var uid = __webpack_require__(88);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)
var getDaysInMonth = __webpack_require__(201)

/**
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added
 * @returns {Date} the new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * var result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */
function addMonths (dirtyDate, dirtyAmount) {
  var date = parse(dirtyDate)
  var amount = Number(dirtyAmount)
  var desiredMonth = date.getMonth() + amount
  var dateWithDesiredMonth = new Date(0)
  dateWithDesiredMonth.setFullYear(date.getFullYear(), desiredMonth, 1)
  dateWithDesiredMonth.setHours(0, 0, 0, 0)
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth)
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  date.setMonth(desiredMonth, Math.min(daysInMonth, date.getDate()))
  return date
}

module.exports = addMonths


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(90)

var MILLISECONDS_IN_MINUTE = 60000
var MILLISECONDS_IN_DAY = 86400000

/**
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 */
function differenceInCalendarDays (dirtyDateLeft, dirtyDateRight) {
  var startOfDayLeft = startOfDay(dirtyDateLeft)
  var startOfDayRight = startOfDay(dirtyDateRight)

  var timestampLeft = startOfDayLeft.getTime() -
    startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
  var timestampRight = startOfDayRight.getTime() -
    startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY)
}

module.exports = differenceInCalendarDays


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of milliseconds
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * var result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */
function differenceInMilliseconds (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)
  return dateLeft.getTime() - dateRight.getTime()
}

module.exports = differenceInMilliseconds


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

  var date = parse(dirtyDate)
  var day = date.getDay()
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn

  date.setDate(date.getDate() - diff)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfWeek


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ForeignObjectRenderer = __webpack_require__(337);

var testRangeBounds = function testRangeBounds(document) {
    var TEST_HEIGHT = 123;

    if (document.createRange) {
        var range = document.createRange();
        if (range.getBoundingClientRect) {
            var testElement = document.createElement('boundtest');
            testElement.style.height = TEST_HEIGHT + 'px';
            testElement.style.display = 'block';
            document.body.appendChild(testElement);

            range.selectNode(testElement);
            var rangeBounds = range.getBoundingClientRect();
            var rangeHeight = Math.round(rangeBounds.height);
            document.body.removeChild(testElement);
            if (rangeHeight === TEST_HEIGHT) {
                return true;
            }
        }
    }

    return false;
};

// iOS 10.3 taints canvas with base64 images unless crossOrigin = 'anonymous'
var testBase64 = function testBase64(document, src) {
    var img = new Image();
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');

    return new Promise(function (resolve) {
        // Single pixel base64 image renders fine on iOS 10.3???
        img.src = src;

        var onload = function onload() {
            try {
                ctx.drawImage(img, 0, 0);
                canvas.toDataURL();
            } catch (e) {
                return resolve(false);
            }

            return resolve(true);
        };

        img.onload = onload;
        img.onerror = function () {
            return resolve(false);
        };

        if (img.complete === true) {
            setTimeout(function () {
                onload();
            }, 500);
        }
    });
};

var testCORS = function testCORS() {
    return typeof new Image().crossOrigin !== 'undefined';
};

var testResponseType = function testResponseType() {
    return typeof new XMLHttpRequest().responseType === 'string';
};

var testSVG = function testSVG(document) {
    var img = new Image();
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    img.src = 'data:image/svg+xml,<svg xmlns=\'http://www.w3.org/2000/svg\'></svg>';

    try {
        ctx.drawImage(img, 0, 0);
        canvas.toDataURL();
    } catch (e) {
        return false;
    }
    return true;
};

var isGreenPixel = function isGreenPixel(data) {
    return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
};

var testForeignObject = function testForeignObject(document) {
    var canvas = document.createElement('canvas');
    var size = 100;
    canvas.width = size;
    canvas.height = size;
    var ctx = canvas.getContext('2d');
    ctx.fillStyle = 'rgb(0, 255, 0)';
    ctx.fillRect(0, 0, size, size);

    var img = new Image();
    var greenImageSrc = canvas.toDataURL();
    img.src = greenImageSrc;
    var svg = (0, _ForeignObjectRenderer.createForeignObjectSVG)(size, size, 0, 0, img);
    ctx.fillStyle = 'red';
    ctx.fillRect(0, 0, size, size);

    return (0, _ForeignObjectRenderer.loadSerializedSVG)(svg).then(function (img) {
        ctx.drawImage(img, 0, 0);
        var data = ctx.getImageData(0, 0, size, size).data;
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);

        var node = document.createElement('div');
        node.style.backgroundImage = 'url(' + greenImageSrc + ')';
        node.style.height = size + 'px';
        // Firefox 55 does not render inline <img /> tags
        return isGreenPixel(data) ? (0, _ForeignObjectRenderer.loadSerializedSVG)((0, _ForeignObjectRenderer.createForeignObjectSVG)(size, size, 0, 0, node)) : Promise.reject(false);
    }).then(function (img) {
        ctx.drawImage(img, 0, 0);
        // Edge does not render background-images
        return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
    }).catch(function (e) {
        return false;
    });
};

var FEATURES = {
    // $FlowFixMe - get/set properties not yet supported
    get SUPPORT_RANGE_BOUNDS() {
        'use strict';

        var value = testRangeBounds(document);
        Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', { value: value });
        return value;
    },
    // $FlowFixMe - get/set properties not yet supported
    get SUPPORT_SVG_DRAWING() {
        'use strict';

        var value = testSVG(document);
        Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', { value: value });
        return value;
    },
    // $FlowFixMe - get/set properties not yet supported
    get SUPPORT_BASE64_DRAWING() {
        'use strict';

        return function (src) {
            var _value = testBase64(document, src);
            Object.defineProperty(FEATURES, 'SUPPORT_BASE64_DRAWING', { value: function value() {
                    return _value;
                } });
            return _value;
        };
    },
    // $FlowFixMe - get/set properties not yet supported
    get SUPPORT_FOREIGNOBJECT_DRAWING() {
        'use strict';

        var value = typeof Array.from === 'function' && typeof window.fetch === 'function' ? testForeignObject(document) : Promise.resolve(false);
        Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', { value: value });
        return value;
    },
    // $FlowFixMe - get/set properties not yet supported
    get SUPPORT_CORS_IMAGES() {
        'use strict';

        var value = testCORS();
        Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', { value: value });
        return value;
    },
    // $FlowFixMe - get/set properties not yet supported
    get SUPPORT_RESPONSE_TYPE() {
        'use strict';

        var value = testResponseType();
        Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', { value: value });
        return value;
    },
    // $FlowFixMe - get/set properties not yet supported
    get SUPPORT_CORS_XHR() {
        'use strict';

        var value = 'withCredentials' in new XMLHttpRequest();
        Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', { value: value });
        return value;
    }
};

exports.default = FEATURES;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Color = __webpack_require__(74);

var _Color2 = _interopRequireDefault(_Color);

var _Util = __webpack_require__(111);

var _background = __webpack_require__(147);

var _border = __webpack_require__(207);

var _borderRadius = __webpack_require__(1158);

var _display = __webpack_require__(1159);

var _float = __webpack_require__(1160);

var _font = __webpack_require__(1161);

var _letterSpacing = __webpack_require__(1162);

var _overflow = __webpack_require__(1163);

var _padding = __webpack_require__(333);

var _position = __webpack_require__(334);

var _textDecoration = __webpack_require__(208);

var _textShadow = __webpack_require__(1164);

var _textTransform = __webpack_require__(335);

var _transform = __webpack_require__(1165);

var _visibility = __webpack_require__(1166);

var _zIndex = __webpack_require__(1167);

var _Bounds = __webpack_require__(73);

var _Input = __webpack_require__(329);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var INPUT_TAGS = ['INPUT', 'TEXTAREA', 'SELECT'];

var NodeContainer = function () {
    function NodeContainer(node, parent, resourceLoader, index) {
        var _this = this;

        _classCallCheck(this, NodeContainer);

        this.parent = parent;
        this.index = index;
        this.childNodes = [];
        var defaultView = node.ownerDocument.defaultView;
        var scrollX = defaultView.pageXOffset;
        var scrollY = defaultView.pageYOffset;
        var style = defaultView.getComputedStyle(node, null);
        var display = (0, _display.parseDisplay)(style.display);

        var IS_INPUT = node.type === 'radio' || node.type === 'checkbox';

        var position = (0, _position.parsePosition)(style.position);

        this.style = {
            background: IS_INPUT ? _Input.INPUT_BACKGROUND : (0, _background.parseBackground)(style, resourceLoader),
            border: IS_INPUT ? _Input.INPUT_BORDERS : (0, _border.parseBorder)(style),
            borderRadius: (node instanceof defaultView.HTMLInputElement || node instanceof HTMLInputElement) && IS_INPUT ? (0, _Input.getInputBorderRadius)(node) : (0, _borderRadius.parseBorderRadius)(style),
            color: IS_INPUT ? _Input.INPUT_COLOR : new _Color2.default(style.color),
            display: display,
            float: (0, _float.parseCSSFloat)(style.float),
            font: (0, _font.parseFont)(style),
            letterSpacing: (0, _letterSpacing.parseLetterSpacing)(style.letterSpacing),
            opacity: parseFloat(style.opacity),
            overflow: INPUT_TAGS.indexOf(node.tagName) === -1 ? (0, _overflow.parseOverflow)(style.overflow) : _overflow.OVERFLOW.HIDDEN,
            padding: (0, _padding.parsePadding)(style),
            position: position,
            textDecoration: (0, _textDecoration.parseTextDecoration)(style),
            textShadow: (0, _textShadow.parseTextShadow)(style.textShadow),
            textTransform: (0, _textTransform.parseTextTransform)(style.textTransform),
            transform: (0, _transform.parseTransform)(style),
            visibility: (0, _visibility.parseVisibility)(style.visibility),
            zIndex: (0, _zIndex.parseZIndex)(position !== _position.POSITION.STATIC ? style.zIndex : 'auto')
        };

        if (this.isTransformed()) {
            // getBoundingClientRect provides values post-transform, we want them without the transformation
            node.style.transform = 'matrix(1,0,0,1,0,0)';
        }

        // TODO move bound retrieval for all nodes to a later stage?
        if (node.tagName === 'IMG') {
            node.addEventListener('load', function () {
                _this.bounds = (0, _Bounds.parseBounds)(node, scrollX, scrollY);
                _this.curvedBounds = (0, _Bounds.parseBoundCurves)(_this.bounds, _this.style.border, _this.style.borderRadius);
            });
        }
        this.image = getImage(node, resourceLoader);
        this.bounds = IS_INPUT ? (0, _Input.reformatInputBounds)((0, _Bounds.parseBounds)(node, scrollX, scrollY)) : (0, _Bounds.parseBounds)(node, scrollX, scrollY);
        this.curvedBounds = (0, _Bounds.parseBoundCurves)(this.bounds, this.style.border, this.style.borderRadius);

        if (false) {
            this.name = '' + node.tagName.toLowerCase() + (node.id ? '#' + node.id : '') + node.className.toString().split(' ').map(function (s) {
                return s.length ? '.' + s : '';
            }).join('');
        }
    }

    _createClass(NodeContainer, [{
        key: 'getClipPaths',
        value: function getClipPaths() {
            var parentClips = this.parent ? this.parent.getClipPaths() : [];
            var isClipped = this.style.overflow === _overflow.OVERFLOW.HIDDEN || this.style.overflow === _overflow.OVERFLOW.SCROLL;

            return isClipped ? parentClips.concat([(0, _Bounds.calculatePaddingBoxPath)(this.curvedBounds)]) : parentClips;
        }
    }, {
        key: 'isInFlow',
        value: function isInFlow() {
            return this.isRootElement() && !this.isFloating() && !this.isAbsolutelyPositioned();
        }
    }, {
        key: 'isVisible',
        value: function isVisible() {
            return !(0, _Util.contains)(this.style.display, _display.DISPLAY.NONE) && this.style.opacity > 0 && this.style.visibility === _visibility.VISIBILITY.VISIBLE;
        }
    }, {
        key: 'isAbsolutelyPositioned',
        value: function isAbsolutelyPositioned() {
            return this.style.position !== _position.POSITION.STATIC && this.style.position !== _position.POSITION.RELATIVE;
        }
    }, {
        key: 'isPositioned',
        value: function isPositioned() {
            return this.style.position !== _position.POSITION.STATIC;
        }
    }, {
        key: 'isFloating',
        value: function isFloating() {
            return this.style.float !== _float.FLOAT.NONE;
        }
    }, {
        key: 'isRootElement',
        value: function isRootElement() {
            return this.parent === null;
        }
    }, {
        key: 'isTransformed',
        value: function isTransformed() {
            return this.style.transform !== null;
        }
    }, {
        key: 'isPositionedWithZIndex',
        value: function isPositionedWithZIndex() {
            return this.isPositioned() && !this.style.zIndex.auto;
        }
    }, {
        key: 'isInlineLevel',
        value: function isInlineLevel() {
            return (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE) || (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_BLOCK) || (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_FLEX) || (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_GRID) || (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_LIST_ITEM) || (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_TABLE);
        }
    }, {
        key: 'isInlineBlockOrInlineTable',
        value: function isInlineBlockOrInlineTable() {
            return (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_BLOCK) || (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_TABLE);
        }
    }]);

    return NodeContainer;
}();

exports.default = NodeContainer;


var getImage = function getImage(node, resourceLoader) {
    if (node instanceof node.ownerDocument.defaultView.SVGSVGElement || node instanceof SVGSVGElement) {
        var s = new XMLSerializer();
        return resourceLoader.loadImage('data:image/svg+xml,' + encodeURIComponent(s.serializeToString(node)));
    }
    switch (node.tagName) {
        case 'IMG':
            // $FlowFixMe
            var img = node;
            return resourceLoader.loadImage(img.currentSrc || img.src);
        case 'CANVAS':
            // $FlowFixMe
            var canvas = node;
            return resourceLoader.loadCanvas(canvas);
        case 'IFRAME':
            var iframeKey = node.getAttribute('data-html2canvas-internal-iframe-key');
            if (iframeKey) {
                return iframeKey;
            }
            break;
    }

    return null;
};

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var PATH = exports.PATH = {
    VECTOR: 0,
    BEZIER_CURVE: 1,
    CIRCLE: 2
};

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Path = __webpack_require__(145);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Vector = function Vector(x, y) {
    _classCallCheck(this, Vector);

    this.type = _Path.PATH.VECTOR;
    this.x = x;
    this.y = y;
    if (false) {
        if (isNaN(x)) {
            console.error('Invalid x value given for Vector');
        }
        if (isNaN(y)) {
            console.error('Invalid y value given for Vector');
        }
    }
};

exports.default = Vector;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseBackgroundImage = exports.parseBackground = exports.calculateBackgroundRepeatPath = exports.calculateBackgroundPosition = exports.calculateBackgroungPositioningArea = exports.calculateBackgroungPaintingArea = exports.calculateGradientBackgroundSize = exports.calculateBackgroundSize = exports.BACKGROUND_ORIGIN = exports.BACKGROUND_CLIP = exports.BACKGROUND_SIZE = exports.BACKGROUND_REPEAT = undefined;

var _Color = __webpack_require__(74);

var _Color2 = _interopRequireDefault(_Color);

var _Length = __webpack_require__(97);

var _Length2 = _interopRequireDefault(_Length);

var _Size = __webpack_require__(1156);

var _Size2 = _interopRequireDefault(_Size);

var _Vector = __webpack_require__(146);

var _Vector2 = _interopRequireDefault(_Vector);

var _Bounds = __webpack_require__(73);

var _padding = __webpack_require__(333);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BACKGROUND_REPEAT = exports.BACKGROUND_REPEAT = {
    REPEAT: 0,
    NO_REPEAT: 1,
    REPEAT_X: 2,
    REPEAT_Y: 3
};

var BACKGROUND_SIZE = exports.BACKGROUND_SIZE = {
    AUTO: 0,
    CONTAIN: 1,
    COVER: 2,
    LENGTH: 3
};

var BACKGROUND_CLIP = exports.BACKGROUND_CLIP = {
    BORDER_BOX: 0,
    PADDING_BOX: 1,
    CONTENT_BOX: 2
};

var BACKGROUND_ORIGIN = exports.BACKGROUND_ORIGIN = BACKGROUND_CLIP;

var AUTO = 'auto';

var BackgroundSize = function BackgroundSize(size) {
    _classCallCheck(this, BackgroundSize);

    switch (size) {
        case 'contain':
            this.size = BACKGROUND_SIZE.CONTAIN;
            break;
        case 'cover':
            this.size = BACKGROUND_SIZE.COVER;
            break;
        case 'auto':
            this.size = BACKGROUND_SIZE.AUTO;
            break;
        default:
            this.value = new _Length2.default(size);
    }
};

var calculateBackgroundSize = exports.calculateBackgroundSize = function calculateBackgroundSize(backgroundImage, image, bounds) {
    var width = 0;
    var height = 0;
    var size = backgroundImage.size;
    if (size[0].size === BACKGROUND_SIZE.CONTAIN || size[0].size === BACKGROUND_SIZE.COVER) {
        var targetRatio = bounds.width / bounds.height;
        var currentRatio = image.width / image.height;
        return targetRatio < currentRatio !== (size[0].size === BACKGROUND_SIZE.COVER) ? new _Size2.default(bounds.width, bounds.width / currentRatio) : new _Size2.default(bounds.height * currentRatio, bounds.height);
    }

    if (size[0].value) {
        width = size[0].value.getAbsoluteValue(bounds.width);
    }

    if (size[0].size === BACKGROUND_SIZE.AUTO && size[1].size === BACKGROUND_SIZE.AUTO) {
        height = image.height;
    } else if (size[1].size === BACKGROUND_SIZE.AUTO) {
        height = width / image.width * image.height;
    } else if (size[1].value) {
        height = size[1].value.getAbsoluteValue(bounds.height);
    }

    if (size[0].size === BACKGROUND_SIZE.AUTO) {
        width = height / image.height * image.width;
    }

    return new _Size2.default(width, height);
};

var calculateGradientBackgroundSize = exports.calculateGradientBackgroundSize = function calculateGradientBackgroundSize(backgroundImage, bounds) {
    var size = backgroundImage.size;
    var width = size[0].value ? size[0].value.getAbsoluteValue(bounds.width) : bounds.width;
    var height = size[1].value ? size[1].value.getAbsoluteValue(bounds.height) : size[0].value ? width : bounds.height;

    return new _Size2.default(width, height);
};

var AUTO_SIZE = new BackgroundSize(AUTO);

var calculateBackgroungPaintingArea = exports.calculateBackgroungPaintingArea = function calculateBackgroungPaintingArea(curves, clip) {
    switch (clip) {
        case BACKGROUND_CLIP.BORDER_BOX:
            return (0, _Bounds.calculateBorderBoxPath)(curves);
        case BACKGROUND_CLIP.PADDING_BOX:
        default:
            return (0, _Bounds.calculatePaddingBoxPath)(curves);
    }
};

var calculateBackgroungPositioningArea = exports.calculateBackgroungPositioningArea = function calculateBackgroungPositioningArea(backgroundOrigin, bounds, padding, border) {
    var paddingBox = (0, _Bounds.calculatePaddingBox)(bounds, border);

    switch (backgroundOrigin) {
        case BACKGROUND_ORIGIN.BORDER_BOX:
            return bounds;
        case BACKGROUND_ORIGIN.CONTENT_BOX:
            var paddingLeft = padding[_padding.PADDING_SIDES.LEFT].getAbsoluteValue(bounds.width);
            var paddingRight = padding[_padding.PADDING_SIDES.RIGHT].getAbsoluteValue(bounds.width);
            var paddingTop = padding[_padding.PADDING_SIDES.TOP].getAbsoluteValue(bounds.width);
            var paddingBottom = padding[_padding.PADDING_SIDES.BOTTOM].getAbsoluteValue(bounds.width);
            return new _Bounds.Bounds(paddingBox.left + paddingLeft, paddingBox.top + paddingTop, paddingBox.width - paddingLeft - paddingRight, paddingBox.height - paddingTop - paddingBottom);
        case BACKGROUND_ORIGIN.PADDING_BOX:
        default:
            return paddingBox;
    }
};

var calculateBackgroundPosition = exports.calculateBackgroundPosition = function calculateBackgroundPosition(position, size, bounds) {
    return new _Vector2.default(position[0].getAbsoluteValue(bounds.width - size.width), position[1].getAbsoluteValue(bounds.height - size.height));
};

var calculateBackgroundRepeatPath = exports.calculateBackgroundRepeatPath = function calculateBackgroundRepeatPath(background, position, size, backgroundPositioningArea, bounds) {
    var repeat = background.repeat;
    switch (repeat) {
        case BACKGROUND_REPEAT.REPEAT_X:
            return [new _Vector2.default(Math.round(bounds.left), Math.round(backgroundPositioningArea.top + position.y)), new _Vector2.default(Math.round(bounds.left + bounds.width), Math.round(backgroundPositioningArea.top + position.y)), new _Vector2.default(Math.round(bounds.left + bounds.width), Math.round(size.height + backgroundPositioningArea.top + position.y)), new _Vector2.default(Math.round(bounds.left), Math.round(size.height + backgroundPositioningArea.top + position.y))];
        case BACKGROUND_REPEAT.REPEAT_Y:
            return [new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x), Math.round(bounds.top)), new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x + size.width), Math.round(bounds.top)), new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x + size.width), Math.round(bounds.height + bounds.top)), new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x), Math.round(bounds.height + bounds.top))];
        case BACKGROUND_REPEAT.NO_REPEAT:
            return [new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x), Math.round(backgroundPositioningArea.top + position.y)), new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x + size.width), Math.round(backgroundPositioningArea.top + position.y)), new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x + size.width), Math.round(backgroundPositioningArea.top + position.y + size.height)), new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x), Math.round(backgroundPositioningArea.top + position.y + size.height))];
        default:
            return [new _Vector2.default(Math.round(bounds.left), Math.round(bounds.top)), new _Vector2.default(Math.round(bounds.left + bounds.width), Math.round(bounds.top)), new _Vector2.default(Math.round(bounds.left + bounds.width), Math.round(bounds.height + bounds.top)), new _Vector2.default(Math.round(bounds.left), Math.round(bounds.height + bounds.top))];
    }
};

var parseBackground = exports.parseBackground = function parseBackground(style, resourceLoader) {
    return {
        backgroundColor: new _Color2.default(style.backgroundColor),
        backgroundImage: parseBackgroundImages(style, resourceLoader),
        backgroundClip: parseBackgroundClip(style.backgroundClip),
        backgroundOrigin: parseBackgroundOrigin(style.backgroundOrigin)
    };
};

var parseBackgroundClip = function parseBackgroundClip(backgroundClip) {
    switch (backgroundClip) {
        case 'padding-box':
            return BACKGROUND_CLIP.PADDING_BOX;
        case 'content-box':
            return BACKGROUND_CLIP.CONTENT_BOX;
    }
    return BACKGROUND_CLIP.BORDER_BOX;
};

var parseBackgroundOrigin = function parseBackgroundOrigin(backgroundOrigin) {
    switch (backgroundOrigin) {
        case 'padding-box':
            return BACKGROUND_ORIGIN.PADDING_BOX;
        case 'content-box':
            return BACKGROUND_ORIGIN.CONTENT_BOX;
    }
    return BACKGROUND_ORIGIN.BORDER_BOX;
};

var parseBackgroundRepeat = function parseBackgroundRepeat(backgroundRepeat) {
    switch (backgroundRepeat.trim()) {
        case 'no-repeat':
            return BACKGROUND_REPEAT.NO_REPEAT;
        case 'repeat-x':
        case 'repeat no-repeat':
            return BACKGROUND_REPEAT.REPEAT_X;
        case 'repeat-y':
        case 'no-repeat repeat':
            return BACKGROUND_REPEAT.REPEAT_Y;
        case 'repeat':
            return BACKGROUND_REPEAT.REPEAT;
    }

    if (false) {
        console.error('Invalid background-repeat value "' + backgroundRepeat + '"');
    }

    return BACKGROUND_REPEAT.REPEAT;
};

var parseBackgroundImages = function parseBackgroundImages(style, resourceLoader) {
    var sources = parseBackgroundImage(style.backgroundImage).map(function (backgroundImage) {
        if (backgroundImage.method === 'url') {
            var key = resourceLoader.loadImage(backgroundImage.args[0]);
            backgroundImage.args = key ? [key] : [];
        }
        return backgroundImage;
    });
    var positions = style.backgroundPosition.split(',');
    var repeats = style.backgroundRepeat.split(',');
    var sizes = style.backgroundSize.split(',');

    return sources.map(function (source, index) {
        var size = (sizes[index] || AUTO).trim().split(' ').map(parseBackgroundSize);
        var position = (positions[index] || AUTO).trim().split(' ').map(parseBackgoundPosition);

        return {
            source: source,
            repeat: parseBackgroundRepeat(typeof repeats[index] === 'string' ? repeats[index] : repeats[0]),
            size: size.length < 2 ? [size[0], AUTO_SIZE] : [size[0], size[1]],
            position: position.length < 2 ? [position[0], position[0]] : [position[0], position[1]]
        };
    });
};

var parseBackgroundSize = function parseBackgroundSize(size) {
    return size === 'auto' ? AUTO_SIZE : new BackgroundSize(size);
};

var parseBackgoundPosition = function parseBackgoundPosition(position) {
    switch (position) {
        case 'bottom':
        case 'right':
            return new _Length2.default('100%');
        case 'left':
        case 'top':
            return new _Length2.default('0%');
        case 'auto':
            return new _Length2.default('0');
    }
    return new _Length2.default(position);
};

var parseBackgroundImage = exports.parseBackgroundImage = function parseBackgroundImage(image) {
    var whitespace = /^\s$/;
    var results = [];

    var args = [];
    var method = '';
    var quote = null;
    var definition = '';
    var mode = 0;
    var numParen = 0;

    var appendResult = function appendResult() {
        var prefix = '';
        if (method) {
            if (definition.substr(0, 1) === '"') {
                definition = definition.substr(1, definition.length - 2);
            }

            if (definition) {
                args.push(definition.trim());
            }

            var prefix_i = method.indexOf('-', 1) + 1;
            if (method.substr(0, 1) === '-' && prefix_i > 0) {
                prefix = method.substr(0, prefix_i).toLowerCase();
                method = method.substr(prefix_i);
            }
            method = method.toLowerCase();
            if (method !== 'none') {
                results.push({
                    prefix: prefix,
                    method: method,
                    args: args
                });
            }
        }
        args = [];
        method = definition = '';
    };

    image.split('').forEach(function (c) {
        if (mode === 0 && whitespace.test(c)) {
            return;
        }
        switch (c) {
            case '"':
                if (!quote) {
                    quote = c;
                } else if (quote === c) {
                    quote = null;
                }
                break;
            case '(':
                if (quote) {
                    break;
                } else if (mode === 0) {
                    mode = 1;
                    return;
                } else {
                    numParen++;
                }
                break;
            case ')':
                if (quote) {
                    break;
                } else if (mode === 1) {
                    if (numParen === 0) {
                        mode = 0;
                        appendResult();
                        return;
                    } else {
                        numParen--;
                    }
                }
                break;

            case ',':
                if (quote) {
                    break;
                } else if (mode === 0) {
                    appendResult();
                    return;
                } else if (mode === 1) {
                    if (numParen === 0 && !method.match(/^url$/i)) {
                        args.push(definition.trim());
                        definition = '';
                        return;
                    }
                }
                break;
        }

        if (mode === 0) {
            method += c;
        } else {
            definition += c;
        }
    });

    appendResult();
    return results;
};

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return (1 - 0.25 * x * (1 + x / 16 * (3 + 1.25 * x)));
});

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return (0.375 * x * (1 + 0.25 * x * (1 + 0.46875 * x)));
});

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return (0.05859375 * x * x * (1 + 0.75 * x));
});

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return (x * x * x * (35 / 3072));
});

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(e0, e1, e2, e3, phi) {
  return (e0 * phi - e1 * Math.sin(2 * phi) + e2 * Math.sin(4 * phi) - e3 * Math.sin(6 * phi));
});

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_values__ = __webpack_require__(28);


/* harmony default export */ __webpack_exports__["a"] = (function(eccent, ts) {
  var eccnth = 0.5 * eccent;
  var con, dphi;
  var phi = __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */] - 2 * Math.atan(ts);
  for (var i = 0; i <= 15; i++) {
    con = eccent * Math.sin(phi);
    dphi = __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */] - 2 * Math.atan(ts * (Math.pow(((1 - con) / (1 + con)), eccnth))) - phi;
    phi += dphi;
    if (Math.abs(dphi) <= 0.0000000001) {
      return phi;
    }
  }
  //console.log("phi2z has NoConvergence");
  return -9999;
});


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_values__ = __webpack_require__(28);


/* harmony default export */ __webpack_exports__["a"] = (function(eccent, phi, sinphi) {
  var con = eccent * sinphi;
  var com = 0.5 * eccent;
  con = Math.pow(((1 - con) / (1 + con)), com);
  return (Math.tan(0.5 * (__WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */] - phi)) / con);
});


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(1232);
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeferredReadyMixin = exports.DeferredReady = undefined;

var _promise = __webpack_require__(157);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 1. Create a DeferredReady plugin.
 *
 * a. Updates options.configMergeStrategies to handle our new hook correctly (using Promise.all!)
 *
 * 2. VueGoogleMaps uses a DeferredReady mixin.
 *
 *     a. Each component checks for ancestors that are also DeferredReady (via dispatch/emit)
 *     b. If no, then run DeferredReady after ready.
 *     c. If yes, then run DeferredReady after parent's deferredReady.
 *
 *
 * Say we have the following inheritance:
 *
 * --> == 'child of'
 *
 * A --> B --> C
 *
 * ready is called in the following order:
 *
 * A.ready, B.ready, C.ready
 *
 * C.ready -- no further ancestors supporting mixin, so in ready() we run+
 *
   **/

var DeferredReady = exports.DeferredReady = {
  install: function install(Vue, options) {
    // eslint-disable-line no-unused-vars
    // Use the same merge strategy as regular hooks
    Vue.config.optionMergeStrategies.deferredReady = Vue.config.optionMergeStrategies.created;
    Vue.config.optionMergeStrategies.beforeDeferredReady = Vue.config.optionMergeStrategies.beforeDeferredReady;
  }
};

function runHooks(vm) {
  var hooks = vm.$options.deferredReady || [];

  // Run the beforeDeferredReady methods first
  var beforePromise = vm.beforeDeferredReady ? typeof vm.beforeDeferredReady.then === 'function' ? vm.beforeDeferredReady : _promise2.default.all(vm.beforeDeferredReady) : _promise2.default.resolve(null);

  beforePromise.then(function () {
    if (typeof hooks === 'function') {
      hooks = [hooks];
    }
    return _promise2.default.all(hooks.map(function (x) {
      try {
        return x.apply(vm);
      } catch (err) {
        console.error(err.stack); // eslint-disable-line no-console
      }
    }));
    // execute all handlers, expecting them to return promises
    // wait for the promises to complete, before allowing child to execute
  }).then(function () {
    vm.$deferredReadyPromiseResolve();
  });
}

var DeferredReadyMixin = exports.DeferredReadyMixin = {
  /* Resolved after the deferredReady has been called
    and the (optional) promise it returns has been
    resolved */
  $deferredReadyPromise: false,
  $deferredReadyPromiseResolve: false,
  $deferredReadyAncestor: false,

  created: function created() {
    var _this = this;

    this.$deferredReadyPromise = new _promise2.default(function (resolve, reject) {
      // eslint-disable-line no-unused-vars
      _this.$deferredReadyPromiseResolve = resolve;
    });

    var search = this.$parent;
    while (search) {
      if (search.$deferredReadyPromise) {
        this.$deferredReadyAncestor = search;
        break;
      }
      search = search.$parent;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    // Execute the hooks only if this is the first
    // ancestor that is a DeferredReady
    // this.$deferredReadyMountedPromiseResolve();

    if (!this.$deferredReadyAncestor) {
      runHooks(this);
    } else {
      this.$deferredReadyAncestor.$deferredReadyPromise.then(function () {
        runHooks(_this2);
      });
    }
  }
};

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2243), __esModule: true };

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(226)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(70)
  , core      = __webpack_require__(65)
  , ctx       = __webpack_require__(118)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && key in target;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(param){
        return this instanceof C ? new C(param) : C(param);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    if(IS_PROTO)(exports[PROTOTYPE] || (exports[PROTOTYPE] = {}))[key] = out;
  }
};
// type bitmap
$export.F = 1;  // forced
$export.G = 2;  // global
$export.S = 4;  // static
$export.P = 8;  // proto
$export.B = 16; // bind
$export.W = 32; // wrap
module.exports = $export;

/***/ }),
/* 160 */
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(53).setDesc
  , has = __webpack_require__(227)
  , TAG = __webpack_require__(48)('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(2252)
  , defined = __webpack_require__(225);
module.exports = function(it){
  return IObject(defined(it));
};

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:

/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
function compare(a, b) {
  if (a === b) {
    return 0;
  }

  var x = a.length;
  var y = b.length;

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }

  if (x < y) {
    return -1;
  }
  if (y < x) {
    return 1;
  }
  return 0;
}
function isBuffer(b) {
  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
    return global.Buffer.isBuffer(b);
  }
  return !!(b != null && b._isBuffer);
}

// based on node assert, original notice:

// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
//
// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
//
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var util = __webpack_require__(1238);
var hasOwn = Object.prototype.hasOwnProperty;
var pSlice = Array.prototype.slice;
var functionsHaveNames = (function () {
  return function foo() {}.name === 'foo';
}());
function pToString (obj) {
  return Object.prototype.toString.call(obj);
}
function isView(arrbuf) {
  if (isBuffer(arrbuf)) {
    return false;
  }
  if (typeof global.ArrayBuffer !== 'function') {
    return false;
  }
  if (typeof ArrayBuffer.isView === 'function') {
    return ArrayBuffer.isView(arrbuf);
  }
  if (!arrbuf) {
    return false;
  }
  if (arrbuf instanceof DataView) {
    return true;
  }
  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
    return true;
  }
  return false;
}
// 1. The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.

var assert = module.exports = ok;

// 2. The AssertionError is defined in assert.
// new assert.AssertionError({ message: message,
//                             actual: actual,
//                             expected: expected })

var regex = /\s*function\s+([^\(\s]*)\s*/;
// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
function getName(func) {
  if (!util.isFunction(func)) {
    return;
  }
  if (functionsHaveNames) {
    return func.name;
  }
  var str = func.toString();
  var match = str.match(regex);
  return match && match[1];
}
assert.AssertionError = function AssertionError(options) {
  this.name = 'AssertionError';
  this.actual = options.actual;
  this.expected = options.expected;
  this.operator = options.operator;
  if (options.message) {
    this.message = options.message;
    this.generatedMessage = false;
  } else {
    this.message = getMessage(this);
    this.generatedMessage = true;
  }
  var stackStartFunction = options.stackStartFunction || fail;
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, stackStartFunction);
  } else {
    // non v8 browsers so we can have a stacktrace
    var err = new Error();
    if (err.stack) {
      var out = err.stack;

      // try to strip useless frames
      var fn_name = getName(stackStartFunction);
      var idx = out.indexOf('\n' + fn_name);
      if (idx >= 0) {
        // once we have located the function frame
        // we need to strip out everything before it (and its line)
        var next_line = out.indexOf('\n', idx + 1);
        out = out.substring(next_line + 1);
      }

      this.stack = out;
    }
  }
};

// assert.AssertionError instanceof Error
util.inherits(assert.AssertionError, Error);

function truncate(s, n) {
  if (typeof s === 'string') {
    return s.length < n ? s : s.slice(0, n);
  } else {
    return s;
  }
}
function inspect(something) {
  if (functionsHaveNames || !util.isFunction(something)) {
    return util.inspect(something);
  }
  var rawname = getName(something);
  var name = rawname ? ': ' + rawname : '';
  return '[Function' +  name + ']';
}
function getMessage(self) {
  return truncate(inspect(self.actual), 128) + ' ' +
         self.operator + ' ' +
         truncate(inspect(self.expected), 128);
}

// At present only the three keys mentioned above are used and
// understood by the spec. Implementations or sub modules can pass
// other keys to the AssertionError's constructor - they will be
// ignored.

// 3. All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided.  All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.

function fail(actual, expected, message, operator, stackStartFunction) {
  throw new assert.AssertionError({
    message: message,
    actual: actual,
    expected: expected,
    operator: operator,
    stackStartFunction: stackStartFunction
  });
}

// EXTENSION! allows for well behaved errors defined elsewhere.
assert.fail = fail;

// 4. Pure assertion tests whether a value is truthy, as determined
// by !!guard.
// assert.ok(guard, message_opt);
// This statement is equivalent to assert.equal(true, !!guard,
// message_opt);. To test strictly for the value true, use
// assert.strictEqual(true, guard, message_opt);.

function ok(value, message) {
  if (!value) fail(value, true, message, '==', assert.ok);
}
assert.ok = ok;

// 5. The equality assertion tests shallow, coercive equality with
// ==.
// assert.equal(actual, expected, message_opt);

assert.equal = function equal(actual, expected, message) {
  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
};

// 6. The non-equality assertion tests for whether two objects are not equal
// with != assert.notEqual(actual, expected, message_opt);

assert.notEqual = function notEqual(actual, expected, message) {
  if (actual == expected) {
    fail(actual, expected, message, '!=', assert.notEqual);
  }
};

// 7. The equivalence assertion tests a deep equality relation.
// assert.deepEqual(actual, expected, message_opt);

assert.deepEqual = function deepEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
  }
};

assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
  }
};

function _deepEqual(actual, expected, strict, memos) {
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;
  } else if (isBuffer(actual) && isBuffer(expected)) {
    return compare(actual, expected) === 0;

  // 7.2. If the expected value is a Date object, the actual value is
  // equivalent if it is also a Date object that refers to the same time.
  } else if (util.isDate(actual) && util.isDate(expected)) {
    return actual.getTime() === expected.getTime();

  // 7.3 If the expected value is a RegExp object, the actual value is
  // equivalent if it is also a RegExp object with the same source and
  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
    return actual.source === expected.source &&
           actual.global === expected.global &&
           actual.multiline === expected.multiline &&
           actual.lastIndex === expected.lastIndex &&
           actual.ignoreCase === expected.ignoreCase;

  // 7.4. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if ((actual === null || typeof actual !== 'object') &&
             (expected === null || typeof expected !== 'object')) {
    return strict ? actual === expected : actual == expected;

  // If both values are instances of typed arrays, wrap their underlying
  // ArrayBuffers in a Buffer each to increase performance
  // This optimization requires the arrays to have the same type as checked by
  // Object.prototype.toString (aka pToString). Never perform binary
  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
  // bit patterns are not identical.
  } else if (isView(actual) && isView(expected) &&
             pToString(actual) === pToString(expected) &&
             !(actual instanceof Float32Array ||
               actual instanceof Float64Array)) {
    return compare(new Uint8Array(actual.buffer),
                   new Uint8Array(expected.buffer)) === 0;

  // 7.5 For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else if (isBuffer(actual) !== isBuffer(expected)) {
    return false;
  } else {
    memos = memos || {actual: [], expected: []};

    var actualIndex = memos.actual.indexOf(actual);
    if (actualIndex !== -1) {
      if (actualIndex === memos.expected.indexOf(expected)) {
        return true;
      }
    }

    memos.actual.push(actual);
    memos.expected.push(expected);

    return objEquiv(actual, expected, strict, memos);
  }
}

function isArguments(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
}

function objEquiv(a, b, strict, actualVisitedObjects) {
  if (a === null || a === undefined || b === null || b === undefined)
    return false;
  // if one is a primitive, the other must be same
  if (util.isPrimitive(a) || util.isPrimitive(b))
    return a === b;
  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
    return false;
  var aIsArgs = isArguments(a);
  var bIsArgs = isArguments(b);
  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
    return false;
  if (aIsArgs) {
    a = pSlice.call(a);
    b = pSlice.call(b);
    return _deepEqual(a, b, strict);
  }
  var ka = objectKeys(a);
  var kb = objectKeys(b);
  var key, i;
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length !== kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] !== kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
      return false;
  }
  return true;
}

// 8. The non-equivalence assertion tests for any deep inequality.
// assert.notDeepEqual(actual, expected, message_opt);

assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
  }
};

assert.notDeepStrictEqual = notDeepStrictEqual;
function notDeepStrictEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
  }
}


// 9. The strict equality assertion tests strict equality, as determined by ===.
// assert.strictEqual(actual, expected, message_opt);

assert.strictEqual = function strictEqual(actual, expected, message) {
  if (actual !== expected) {
    fail(actual, expected, message, '===', assert.strictEqual);
  }
};

// 10. The strict non-equality assertion tests for strict inequality, as
// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);

assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
  if (actual === expected) {
    fail(actual, expected, message, '!==', assert.notStrictEqual);
  }
};

function expectedException(actual, expected) {
  if (!actual || !expected) {
    return false;
  }

  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
    return expected.test(actual);
  }

  try {
    if (actual instanceof expected) {
      return true;
    }
  } catch (e) {
    // Ignore.  The instanceof check doesn't work for arrow functions.
  }

  if (Error.isPrototypeOf(expected)) {
    return false;
  }

  return expected.call({}, actual) === true;
}

function _tryBlock(block) {
  var error;
  try {
    block();
  } catch (e) {
    error = e;
  }
  return error;
}

function _throws(shouldThrow, block, expected, message) {
  var actual;

  if (typeof block !== 'function') {
    throw new TypeError('"block" argument must be a function');
  }

  if (typeof expected === 'string') {
    message = expected;
    expected = null;
  }

  actual = _tryBlock(block);

  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
            (message ? ' ' + message : '.');

  if (shouldThrow && !actual) {
    fail(actual, expected, 'Missing expected exception' + message);
  }

  var userProvidedMessage = typeof message === 'string';
  var isUnwantedException = !shouldThrow && util.isError(actual);
  var isUnexpectedException = !shouldThrow && actual && !expected;

  if ((isUnwantedException &&
      userProvidedMessage &&
      expectedException(actual, expected)) ||
      isUnexpectedException) {
    fail(actual, expected, 'Got unwanted exception' + message);
  }

  if ((shouldThrow && actual && expected &&
      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
    throw actual;
  }
}

// 11. Expected to throw an error:
// assert.throws(block, Error_opt, message_opt);

assert.throws = function(block, /*optional*/error, /*optional*/message) {
  _throws(true, block, error, message);
};

// EXTENSION! This is annoying to write outside this module.
assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
  _throws(false, block, error, message);
};

assert.ifError = function(err) { if (err) throw err; };

var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    if (hasOwn.call(obj, key)) keys.push(key);
  }
  return keys;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = datetime;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns__);


function datetime(value, pattern) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_date_fns__["format"])(value, pattern);
}

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = chunk;
function chunk(str, n) {
    var ret = [];
    var i = void 0;
    var len = void 0;

    for (i = 0, len = str.length; i < len; i += n) {
        ret.push(str.substr(i, n));
    }

    return ret;
}

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    code_bde: 1,
    name_ca: 'Molt Alta',
    name_en: 'Very high',
    name_es: 'Muy Alta'
}, {
    id: 2,
    code_bde: 2,
    name_ca: 'Alta',
    name_en: 'High',
    name_es: 'Alta'
}, {
    id: 3,
    code_bde: 3,
    name_ca: 'Mitjana',
    name_en: 'Medium',
    name_es: 'Media'
}, {
    id: 4,
    code_bde: 4,
    name_ca: 'Baixa',
    name_en: 'Low',
    name_es: 'Baja'
}, {
    id: 5,
    code_bde: 5,
    name_ca: 'No comprovat',
    name_en: 'Not checked',
    name_es: 'No comprobado'
}]);

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    code_bde: 1,
    name_ca: 'Molt Alta',
    name_en: 'Very high',
    name_es: 'Muy Alta'
}, {
    id: 2,
    code_bde: 2,
    name_ca: 'Alta',
    name_en: 'High',
    name_es: 'Alta'
}, {
    id: 3,
    code_bde: 3,
    name_ca: 'Mitjana',
    name_en: 'Medium',
    name_es: 'Media'
}, {
    id: 4,
    code_bde: 4,
    name_ca: 'Baixa',
    name_en: 'Low',
    name_es: 'Baja'
}, {
    id: 5,
    code_bde: 5,
    name_ca: 'No comprovat',
    name_en: 'Not checked',
    name_es: 'No comprobado'
}]);

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    code_bde: 1,
    name_ca: 'Molt Alta',
    name_en: 'Very high',
    name_es: 'Muy Alta'
}, {
    id: 2,
    code_bde: 2,
    name_ca: 'Alta',
    name_en: 'High',
    name_es: 'Alta'
}, {
    id: 3,
    code_bde: 3,
    name_ca: 'Mitjana',
    name_en: 'Medium',
    name_es: 'Media'
}, {
    id: 4,
    code_bde: 4,
    name_ca: 'Baixa',
    name_en: 'Low',
    name_es: 'Baja'
}, {
    id: 5,
    code_bde: 5,
    name_ca: 'No comprovat',
    name_en: 'Not checked',
    name_es: 'No comprobado'
}]);

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    code_bde: 1,
    name_ca: 'Molt Alta',
    name_en: 'Very high',
    name_es: 'Muy Alta'
}, {
    id: 2,
    code_bde: 2,
    name_ca: 'Alta',
    name_en: 'High',
    name_es: 'Alta'
}, {
    id: 3,
    code_bde: 3,
    name_ca: 'Mitjana',
    name_en: 'Medium',
    name_es: 'Media'
}, {
    id: 4,
    code_bde: 4,
    name_ca: 'Baixa',
    name_en: 'Low',
    name_es: 'Baja'
}, {
    id: 5,
    code_bde: 5,
    name_ca: 'No comprovat',
    name_en: 'Not checked',
    name_es: 'No comprobado'
}]);

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(37);
var toAbsoluteIndex = __webpack_require__(87);
var toLength = __webpack_require__(36);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(732);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(35);
var createDesc = __webpack_require__(84);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(30);
var document = __webpack_require__(26).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 174 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(32)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(26).document;
module.exports = document && document.documentElement;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(30);
var setPrototypeOf = __webpack_require__(185).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(93);
var ITERATOR = __webpack_require__(32)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(81);
var descriptor = __webpack_require__(84);
var setToStringTag = __webpack_require__(94);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(42)(IteratorPrototype, __webpack_require__(32)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(80);
var $export = __webpack_require__(2);
var redefine = __webpack_require__(43);
var hide = __webpack_require__(42);
var has = __webpack_require__(41);
var Iterators = __webpack_require__(93);
var $iterCreate = __webpack_require__(179);
var setToStringTag = __webpack_require__(94);
var getPrototypeOf = __webpack_require__(46);
var ITERATOR = __webpack_require__(32)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 181 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 182 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(26);
var macrotask = __webpack_require__(191).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(49)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if (Observer) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(39);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(30);
var anObject = __webpack_require__(24);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(50)(Function.call, __webpack_require__(45).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(136)('keys');
var uid = __webpack_require__(88);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(59);
var defined = __webpack_require__(57);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(130);
var defined = __webpack_require__(57);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(59);
var defined = __webpack_require__(57);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 190 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(50);
var invoke = __webpack_require__(268);
var html = __webpack_require__(176);
var cel = __webpack_require__(173);
var global = __webpack_require__(26);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(49)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(26);
var DESCRIPTORS = __webpack_require__(34);
var LIBRARY = __webpack_require__(80);
var $typed = __webpack_require__(138);
var hide = __webpack_require__(42);
var redefineAll = __webpack_require__(85);
var fails = __webpack_require__(29);
var anInstance = __webpack_require__(78);
var toInteger = __webpack_require__(59);
var toLength = __webpack_require__(36);
var toIndex = __webpack_require__(286);
var gOPN = __webpack_require__(82).f;
var dP = __webpack_require__(35).f;
var arrayFill = __webpack_require__(170);
var setToStringTag = __webpack_require__(94);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(26);
var core = __webpack_require__(56);
var LIBRARY = __webpack_require__(80);
var wksExt = __webpack_require__(287);
var defineProperty = __webpack_require__(35).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(103);
var ITERATOR = __webpack_require__(32)('iterator');
var Iterators = __webpack_require__(93);
module.exports = __webpack_require__(56).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(71);
var step = __webpack_require__(271);
var Iterators = __webpack_require__(93);
var toIObject = __webpack_require__(47);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(180)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var addDays = __webpack_require__(106)

/**
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be added
 * @returns {Date} the new date with the weeks added
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * var result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */
function addWeeks (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  var days = amount * 7
  return addDays(dirtyDate, days)
}

module.exports = addWeeks


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Common Helpers
 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return -1 if the first date is after the second,
 * 1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
 * var result = compareDesc(
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * )
 * //=> 1
 *
 * @example
 * // Sort the array of dates in reverse chronological order:
 * var result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareDesc)
 * //=> [
 * //   Sun Jul 02 1995 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Wed Feb 11 1987 00:00:00
 * // ]
 */
function compareDesc (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var timeLeft = dateLeft.getTime()
  var dateRight = parse(dirtyDateRight)
  var timeRight = dateRight.getTime()

  if (timeLeft > timeRight) {
    return -1
  } else if (timeLeft < timeRight) {
    return 1
  } else {
    return 0
  }
}

module.exports = compareDesc


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)
var differenceInCalendarMonths = __webpack_require__(300)
var compareAsc = __webpack_require__(108)

/**
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full months
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 7
 */
function differenceInMonths (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarMonths(dateLeft, dateRight))
  dateLeft.setMonth(dateLeft.getMonth() - sign * difference)

  // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastMonthNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastMonthNotFull)
}

module.exports = differenceInMonths


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var differenceInMilliseconds = __webpack_require__(141)

/**
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of seconds
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * var result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */
function differenceInSeconds (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / 1000
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInSeconds


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a day
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * var result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */
function endOfDay (dirtyDate) {
  var date = parse(dirtyDate)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfDay


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * var result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */
function getDaysInMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  var monthIndex = date.getMonth()
  var lastDayOfMonth = new Date(0)
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0)
  lastDayOfMonth.setHours(0, 0, 0, 0)
  return lastDayOfMonth.getDate()
}

module.exports = getDaysInMonth


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)
var startOfISOWeek = __webpack_require__(91)
var startOfISOYear = __webpack_require__(109)

var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * var result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */
function getISOWeek (dirtyDate) {
  var date = parse(dirtyDate)
  var diff = startOfISOWeek(date).getTime() - startOfISOYear(date).getTime()

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1
}

module.exports = getISOWeek


/***/ }),
/* 203 */
/***/ (function(module, exports) {

/**
 * @category Common Helpers
 * @summary Is the given argument an instance of Date?
 *
 * @description
 * Is the given argument an instance of Date?
 *
 * @param {*} argument - the argument to check
 * @returns {Boolean} the given argument is an instance of Date
 *
 * @example
 * // Is 'mayonnaise' a Date?
 * var result = isDate('mayonnaise')
 * //=> false
 */
function isDate (argument) {
  return argument instanceof Date
}

module.exports = isDate


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var startOfWeek = __webpack_require__(142)

/**
 * @category Week Helpers
 * @summary Are the given dates in the same week?
 *
 * @description
 * Are the given dates in the same week?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Boolean} the dates are in the same week
 *
 * @example
 * // Are 31 August 2014 and 4 September 2014 in the same week?
 * var result = isSameWeek(
 *   new Date(2014, 7, 31),
 *   new Date(2014, 8, 4)
 * )
 * //=> true
 *
 * @example
 * // If week starts with Monday,
 * // are 31 August 2014 and 4 September 2014 in the same week?
 * var result = isSameWeek(
 *   new Date(2014, 7, 31),
 *   new Date(2014, 8, 4),
 *   {weekStartsOn: 1}
 * )
 * //=> false
 */
function isSameWeek (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  var dateLeftStartOfWeek = startOfWeek(dirtyDateLeft, dirtyOptions)
  var dateRightStartOfWeek = startOfWeek(dirtyDateRight, dirtyOptions)

  return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime()
}

module.exports = isSameWeek


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var buildDistanceInWordsLocale = __webpack_require__(1038)
var buildFormatLocale = __webpack_require__(1039)

/**
 * @category Locales
 * @summary English locale.
 */
module.exports = {
  distanceInWords: buildDistanceInWordsLocale(),
  format: buildFormatLocale()
}


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _textTransform = __webpack_require__(335);

var _TextBounds = __webpack_require__(332);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TextContainer = function () {
    function TextContainer(text, parent, bounds) {
        _classCallCheck(this, TextContainer);

        this.text = text;
        this.parent = parent;
        this.bounds = bounds;
    }

    _createClass(TextContainer, null, [{
        key: 'fromTextNode',
        value: function fromTextNode(node, parent) {
            var text = transform(node.data, parent.style.textTransform);
            return new TextContainer(text, parent, (0, _TextBounds.parseTextBounds)(text, parent, node));
        }
    }]);

    return TextContainer;
}();

exports.default = TextContainer;


var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;

var transform = function transform(text, _transform) {
    switch (_transform) {
        case _textTransform.TEXT_TRANSFORM.LOWERCASE:
            return text.toLowerCase();
        case _textTransform.TEXT_TRANSFORM.CAPITALIZE:
            return text.replace(CAPITALIZE, capitalize);
        case _textTransform.TEXT_TRANSFORM.UPPERCASE:
            return text.toUpperCase();
        default:
            return text;
    }
};

function capitalize(m, p1, p2) {
    if (m.length > 0) {
        return p1 + p2.toUpperCase();
    }

    return m;
}

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseBorder = exports.BORDER_SIDES = exports.BORDER_STYLE = undefined;

var _Color = __webpack_require__(74);

var _Color2 = _interopRequireDefault(_Color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BORDER_STYLE = exports.BORDER_STYLE = {
    NONE: 0,
    SOLID: 1
};

var BORDER_SIDES = exports.BORDER_SIDES = {
    TOP: 0,
    RIGHT: 1,
    BOTTOM: 2,
    LEFT: 3
};

var SIDES = Object.keys(BORDER_SIDES).map(function (s) {
    return s.toLowerCase();
});

var parseBorderStyle = function parseBorderStyle(style) {
    switch (style) {
        case 'none':
            return BORDER_STYLE.NONE;
    }
    return BORDER_STYLE.SOLID;
};

var parseBorder = exports.parseBorder = function parseBorder(style) {
    return SIDES.map(function (side) {
        var borderColor = new _Color2.default(style.getPropertyValue('border-' + side + '-color'));
        var borderStyle = parseBorderStyle(style.getPropertyValue('border-' + side + '-style'));
        var borderWidth = parseFloat(style.getPropertyValue('border-' + side + '-width'));
        return {
            borderColor: borderColor,
            borderStyle: borderStyle,
            borderWidth: isNaN(borderWidth) ? 0 : borderWidth
        };
    });
};

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseTextDecoration = exports.TEXT_DECORATION_LINE = exports.TEXT_DECORATION = exports.TEXT_DECORATION_STYLE = undefined;

var _Color = __webpack_require__(74);

var _Color2 = _interopRequireDefault(_Color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TEXT_DECORATION_STYLE = exports.TEXT_DECORATION_STYLE = {
    SOLID: 0,
    DOUBLE: 1,
    DOTTED: 2,
    DASHED: 3,
    WAVY: 4
};

var TEXT_DECORATION = exports.TEXT_DECORATION = {
    NONE: null
};

var TEXT_DECORATION_LINE = exports.TEXT_DECORATION_LINE = {
    UNDERLINE: 1,
    OVERLINE: 2,
    LINE_THROUGH: 3,
    BLINK: 4
};

var parseLine = function parseLine(line) {
    switch (line) {
        case 'underline':
            return TEXT_DECORATION_LINE.UNDERLINE;
        case 'overline':
            return TEXT_DECORATION_LINE.OVERLINE;
        case 'line-through':
            return TEXT_DECORATION_LINE.LINE_THROUGH;
    }
    return TEXT_DECORATION_LINE.BLINK;
};

var parseTextDecorationLine = function parseTextDecorationLine(line) {
    if (line === 'none') {
        return null;
    }

    return line.split(' ').map(parseLine);
};

var parseTextDecorationStyle = function parseTextDecorationStyle(style) {
    switch (style) {
        case 'double':
            return TEXT_DECORATION_STYLE.DOUBLE;
        case 'dotted':
            return TEXT_DECORATION_STYLE.DOTTED;
        case 'dashed':
            return TEXT_DECORATION_STYLE.DASHED;
        case 'wavy':
            return TEXT_DECORATION_STYLE.WAVY;
    }
    return TEXT_DECORATION_STYLE.SOLID;
};

var parseTextDecoration = exports.parseTextDecoration = function parseTextDecoration(style) {
    var textDecorationLine = parseTextDecorationLine(style.textDecorationLine ? style.textDecorationLine : style.textDecoration);
    if (textDecorationLine === null) {
        return TEXT_DECORATION.NONE;
    }

    var textDecorationColor = style.textDecorationColor ? new _Color2.default(style.textDecorationColor) : null;
    var textDecorationStyle = parseTextDecorationStyle(style.textDecorationStyle);

    return {
        textDecorationLine: textDecorationLine,
        textDecorationColor: textDecorationColor,
        textDecorationStyle: textDecorationStyle
    };
};

/***/ }),
/* 209 */
/***/ (function(module, exports) {


function KeyCombo(keyComboStr) {
  this.sourceStr = keyComboStr;
  this.subCombos = KeyCombo.parseComboStr(keyComboStr);
  this.keyNames  = this.subCombos.reduce(function(memo, nextSubCombo) {
    return memo.concat(nextSubCombo);
  });
}

// TODO: Add support for key combo sequences
KeyCombo.sequenceDeliminator = '>>';
KeyCombo.comboDeliminator    = '>';
KeyCombo.keyDeliminator      = '+';

KeyCombo.parseComboStr = function(keyComboStr) {
  var subComboStrs = KeyCombo._splitStr(keyComboStr, KeyCombo.comboDeliminator);
  var combo        = [];

  for (var i = 0 ; i < subComboStrs.length; i += 1) {
    combo.push(KeyCombo._splitStr(subComboStrs[i], KeyCombo.keyDeliminator));
  }
  return combo;
};

KeyCombo.prototype.check = function(pressedKeyNames) {
  var startingKeyNameIndex = 0;
  for (var i = 0; i < this.subCombos.length; i += 1) {
    startingKeyNameIndex = this._checkSubCombo(
      this.subCombos[i],
      startingKeyNameIndex,
      pressedKeyNames
    );
    if (startingKeyNameIndex === -1) { return false; }
  }
  return true;
};

KeyCombo.prototype.isEqual = function(otherKeyCombo) {
  if (
    !otherKeyCombo ||
    typeof otherKeyCombo !== 'string' &&
    typeof otherKeyCombo !== 'object'
  ) { return false; }

  if (typeof otherKeyCombo === 'string') {
    otherKeyCombo = new KeyCombo(otherKeyCombo);
  }

  if (this.subCombos.length !== otherKeyCombo.subCombos.length) {
    return false;
  }
  for (var i = 0; i < this.subCombos.length; i += 1) {
    if (this.subCombos[i].length !== otherKeyCombo.subCombos[i].length) {
      return false;
    }
  }

  for (var i = 0; i < this.subCombos.length; i += 1) {
    var subCombo      = this.subCombos[i];
    var otherSubCombo = otherKeyCombo.subCombos[i].slice(0);

    for (var j = 0; j < subCombo.length; j += 1) {
      var keyName = subCombo[j];
      var index   = otherSubCombo.indexOf(keyName);

      if (index > -1) {
        otherSubCombo.splice(index, 1);
      }
    }
    if (otherSubCombo.length !== 0) {
      return false;
    }
  }

  return true;
};

KeyCombo._splitStr = function(str, deliminator) {
  var s  = str;
  var d  = deliminator;
  var c  = '';
  var ca = [];

  for (var ci = 0; ci < s.length; ci += 1) {
    if (ci > 0 && s[ci] === d && s[ci - 1] !== '\\') {
      ca.push(c.trim());
      c = '';
      ci += 1;
    }
    c += s[ci];
  }
  if (c) { ca.push(c.trim()); }

  return ca;
};

KeyCombo.prototype._checkSubCombo = function(subCombo, startingKeyNameIndex, pressedKeyNames) {
  subCombo = subCombo.slice(0);
  pressedKeyNames = pressedKeyNames.slice(startingKeyNameIndex);

  var endIndex = startingKeyNameIndex;
  for (var i = 0; i < subCombo.length; i += 1) {

    var keyName = subCombo[i];
    if (keyName[0] === '\\') {
      var escapedKeyName = keyName.slice(1);
      if (
        escapedKeyName === KeyCombo.comboDeliminator ||
        escapedKeyName === KeyCombo.keyDeliminator
      ) {
        keyName = escapedKeyName;
      }
    }

    var index = pressedKeyNames.indexOf(keyName);
    if (index > -1) {
      subCombo.splice(i, 1);
      i -= 1;
      if (index > endIndex) {
        endIndex = index;
      }
      if (subCombo.length === 0) {
        return endIndex;
      }
    }
  }
  return -1;
};


module.exports = KeyCombo;


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ca = moment.defineLocale('ca', {
    months : {
        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
        isFormat: /D[oD]?(\s)+MMMM/
    },
    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
    monthsParseExact : true,
    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
    weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : '[el] D MMMM [de] YYYY',
        ll : 'D MMM YYYY',
        LLL : '[el] D MMMM [de] YYYY [a les] H:mm',
        lll : 'D MMM YYYY, H:mm',
        LLLL : '[el] dddd D MMMM [de] YYYY [a les] H:mm',
        llll : 'ddd D MMM YYYY, H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        nextDay : function () {
            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        lastDay : function () {
            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'd\'aquí %s',
        past : 'fa %s',
        s : 'uns segons',
        m : 'un minut',
        mm : '%d minuts',
        h : 'una hora',
        hh : '%d hores',
        d : 'un dia',
        dd : '%d dies',
        M : 'un mes',
        MM : '%d mesos',
        y : 'un any',
        yy : '%d anys'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
    ordinal : function (number, period) {
        var output = (number === 1) ? 'r' :
            (number === 2) ? 'n' :
            (number === 3) ? 'r' :
            (number === 4) ? 't' : 'è';
        if (period === 'w' || period === 'W') {
            output = 'a';
        }
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ca;

})));


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {/*! pdfmake v0.1.33, @license MIT, @link http://pdfmake.org */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["pdfMake"] = __webpack_require__(1);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, global) {/* jslint node: true */
	/* jslint browser: true */
	'use strict';

	var PdfPrinter = __webpack_require__(6);
	var FileSaver = __webpack_require__(306);
	var saveAs = FileSaver.saveAs;

	var defaultClientFonts = {
		Roboto: {
			normal: 'Roboto-Regular.ttf',
			bold: 'Roboto-Medium.ttf',
			italics: 'Roboto-Italic.ttf',
			bolditalics: 'Roboto-MediumItalic.ttf'
		}
	};

	function Document(docDefinition, tableLayouts, fonts, vfs) {
		this.docDefinition = docDefinition;
		this.tableLayouts = tableLayouts || null;
		this.fonts = fonts || defaultClientFonts;
		this.vfs = vfs;
	}

	function canCreatePdf() {
		// Ensure the browser provides the level of support needed
		if (!Object.keys) {
			return false;
		}
		return true;
	}

	Document.prototype._createDoc = function (options, callback) {
		options = options || {};
		if (this.tableLayouts) {
			options.tableLayouts = this.tableLayouts;
		}

		var printer = new PdfPrinter(this.fonts);
		printer.fs.bindFS(this.vfs);

		var doc = printer.createPdfKitDocument(this.docDefinition, options);
		var chunks = [];
		var result;

		doc.on('readable', function () {
			var chunk;
			while ((chunk = doc.read(9007199254740991)) !== null) {
				chunks.push(chunk);
			}
		});
		doc.on('end', function () {
			result = Buffer.concat(chunks);
			callback(result, doc._pdfMakePages);
		});
		doc.end();
	};

	Document.prototype._getPages = function (options, cb) {
		if (!cb) {
			throw '_getPages is an async method and needs a callback argument';
		}
		this._createDoc(options, function (ignoreBuffer, pages) {
			cb(pages);
		});
	};

	Document.prototype._bufferToBlob = function (buffer) {
		var blob;
		try {
			blob = new Blob([buffer], {type: 'application/pdf'});
		} catch (e) {
			// Old browser which can't handle it without making it an byte array (ie10)
			if (e.name === 'InvalidStateError') {
				var byteArray = new Uint8Array(buffer);
				blob = new Blob([byteArray.buffer], {type: 'application/pdf'});
			}
		}

		if (!blob) {
			throw 'Could not generate blob';
		}

		return blob;
	};

	Document.prototype._openWindow = function () {
		// we have to open the window immediately and store the reference
		// otherwise popup blockers will stop us
		var win = global.open('', '_blank');
		if (win === null) {
			throw 'Open PDF in new window blocked by browser';
		}

		return win;
	};

	Document.prototype._openPdf = function (options, win) {
		if (!win) {
			win = this._openWindow();
		}
		try {
			this.getBlob(function (result) {
				var urlCreator = global.URL || global.webkitURL;
				var pdfUrl = urlCreator.createObjectURL(result);
				win.location.href = pdfUrl;
			}, options);
		} catch (e) {
			win.close();
			throw e;
		}
	};

	Document.prototype.open = function (options, win) {
		options = options || {};
		options.autoPrint = false;
		win = win || null;

		this._openPdf(options, win);
	};


	Document.prototype.print = function (options, win) {
		options = options || {};
		options.autoPrint = true;
		win = win || null;

		this._openPdf(options, win);
	};

	Document.prototype.download = function (defaultFileName, cb, options) {
		if (typeof defaultFileName === 'function') {
			cb = defaultFileName;
			defaultFileName = null;
		}

		defaultFileName = defaultFileName || 'file.pdf';
		this.getBlob(function (result) {
			saveAs(result, defaultFileName);

			if (typeof cb === 'function') {
				cb();
			}
		}, options);
	};

	Document.prototype.getBase64 = function (cb, options) {
		if (!cb) {
			throw 'getBase64 is an async method and needs a callback argument';
		}
		this.getBuffer(function (buffer) {
			cb(buffer.toString('base64'));
		}, options);
	};

	Document.prototype.getDataUrl = function (cb, options) {
		if (!cb) {
			throw 'getDataUrl is an async method and needs a callback argument';
		}
		this.getBuffer(function (buffer) {
			cb('data:application/pdf;base64,' + buffer.toString('base64'));
		}, options);
	};

	Document.prototype.getBlob = function (cb, options) {
		if (!cb) {
			throw 'getBlob is an async method and needs a callback argument';
		}
		var that = this;
		this.getBuffer(function (result) {
			var blob = that._bufferToBlob(result);
			cb(blob);
		}, options);
	};

	Document.prototype.getBuffer = function (cb, options) {
		if (!cb) {
			throw 'getBuffer is an async method and needs a callback argument';
		}
		this._createDoc(options, function (buffer) {
			cb(buffer);
		});
	};

	module.exports = {
		createPdf: function (docDefinition) {
			if (!canCreatePdf()) {
				throw 'Your browser does not provide the level of support needed';
			}
			return new Document(docDefinition, global.pdfMake.tableLayouts, global.pdfMake.fonts, global.pdfMake.vfs);
		}
	};

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer, (function() { return this; }())))

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */

	'use strict'

	var base64 = __webpack_require__(3)
	var ieee754 = __webpack_require__(4)
	var isArray = __webpack_require__(5)

	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50

	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.

	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()

	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()

	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}

	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}

	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }

	  return that
	}

	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */

	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }

	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}

	Buffer.poolSize = 8192 // not used by this implementation

	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}

	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }

	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }

	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }

	  return fromObject(that, value)
	}

	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}

	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}

	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}

	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}

	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}

	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}

	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}

	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }

	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }

	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)

	  var actual = that.write(string, encoding)

	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }

	  return that
	}

	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}

	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer

	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }

	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }

	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }

	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}

	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)

	    if (that.length === 0) {
	      return that
	    }

	    obj.copy(that, 0, 0, len)
	    return that
	  }

	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }

	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }

	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}

	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}

	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}

	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}

	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }

	  if (a === b) return 0

	  var x = a.length
	  var y = b.length

	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }

	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}

	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}

	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }

	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }

	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }

	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}

	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }

	  var len = string.length
	  if (len === 0) return 0

	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength

	function slowToString (encoding, start, end) {
	  var loweredCase = false

	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.

	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }

	  if (end === undefined || end > this.length) {
	    end = this.length
	  }

	  if (end <= 0) {
	    return ''
	  }

	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0

	  if (end <= start) {
	    return ''
	  }

	  if (!encoding) encoding = 'utf8'

	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)

	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)

	      case 'ascii':
	        return asciiSlice(this, start, end)

	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)

	      case 'base64':
	        return base64Slice(this, start, end)

	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)

	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}

	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true

	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}

	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}

	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}

	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}

	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}

	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}

	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}

	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }

	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }

	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }

	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }

	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0

	  if (this === target) return 0

	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)

	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)

	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }

	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}

	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1

	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }

	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }

	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }

	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }

	  throw new TypeError('val must be string, number or Buffer')
	}

	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length

	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }

	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }

	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }

	  return -1
	}

	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}

	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}

	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}

	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }

	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}

	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}

	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}

	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}

	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}

	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}

	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }

	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining

	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }

	  if (!encoding) encoding = 'utf8'

	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)

	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)

	      case 'ascii':
	        return asciiWrite(this, string, offset, length)

	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)

	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)

	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)

	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}

	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}

	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}

	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []

	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1

	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint

	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }

	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }

	    res.push(codePoint)
	    i += bytesPerSequence
	  }

	  return decodeCodePointsArray(res)
	}

	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000

	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }

	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}

	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)

	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}

	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)

	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}

	function hexSlice (buf, start, end) {
	  var len = buf.length

	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len

	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}

	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}

	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end

	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }

	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }

	  if (end < start) end = start

	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }

	  return newBuf
	}

	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}

	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)

	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }

	  return val
	}

	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }

	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }

	  return val
	}

	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}

	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}

	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}

	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)

	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}

	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)

	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}

	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)

	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80

	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

	  return val
	}

	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)

	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80

	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

	  return val
	}

	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}

	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}

	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}

	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)

	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}

	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)

	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}

	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}

	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}

	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}

	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}

	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}

	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }

	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }

	  return offset + byteLength
	}

	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }

	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }

	  return offset + byteLength
	}

	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}

	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}

	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}

	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}

	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}

	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}

	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}

	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)

	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }

	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }

	  return offset + byteLength
	}

	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)

	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }

	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }

	  return offset + byteLength
	}

	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}

	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}

	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}

	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}

	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}

	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}

	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}

	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}

	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}

	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}

	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}

	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}

	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start

	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0

	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')

	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }

	  var len = end - start
	  var i

	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }

	  return len
	}

	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }

	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }

	  if (end <= start) {
	    return this
	  }

	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0

	  if (!val) val = 0

	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }

	  return this
	}

	// HELPER FUNCTIONS
	// ================

	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}

	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}

	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}

	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []

	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)

	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }

	        // valid lead
	        leadSurrogate = codePoint

	        continue
	      }

	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }

	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }

	    leadSurrogate = null

	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }

	  return bytes
	}

	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}

	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break

	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }

	  return byteArray
	}

	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}

	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}

	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	'use strict'

	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray

	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}

	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63

	function placeHoldersCount (b64) {
	  var len = b64.length
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }

	  // the number of equal signs (place holders)
	  // if there are two placeholders, than the two characters before it
	  // represent one byte
	  // if there is only one, then the three characters before it represent 2 bytes
	  // this is just a cheap hack to not do indexOf twice
	  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
	}

	function byteLength (b64) {
	  // base64 is 4/3 + up to two characters of the original data
	  return (b64.length * 3 / 4) - placeHoldersCount(b64)
	}

	function toByteArray (b64) {
	  var i, l, tmp, placeHolders, arr
	  var len = b64.length
	  placeHolders = placeHoldersCount(b64)

	  arr = new Arr((len * 3 / 4) - placeHolders)

	  // if there are placeholders, only get up to the last complete 4 chars
	  l = placeHolders > 0 ? len - 4 : len

	  var L = 0

	  for (i = 0; i < l; i += 4) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
	    arr[L++] = (tmp >> 16) & 0xFF
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }

	  if (placeHolders === 2) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[L++] = tmp & 0xFF
	  } else if (placeHolders === 1) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }

	  return arr
	}

	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
	}

	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}

	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var output = ''
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3

	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }

	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    output += lookup[tmp >> 2]
	    output += lookup[(tmp << 4) & 0x3F]
	    output += '=='
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
	    output += lookup[tmp >> 10]
	    output += lookup[(tmp >> 4) & 0x3F]
	    output += lookup[(tmp << 2) & 0x3F]
	    output += '='
	  }

	  parts.push(output)

	  return parts.join('')
	}


/***/ }),
/* 4 */
/***/ (function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]

	  i += d

	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}

	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

	  value = Math.abs(value)

	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }

	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }

	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 5 */
/***/ (function(module, exports) {

	var toString = {}.toString;

	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	/* jslint node: true */
	'use strict';

	var _ = __webpack_require__(7);
	var FontProvider = __webpack_require__(9);
	var LayoutBuilder = __webpack_require__(10);
	var PdfKit = __webpack_require__(30);
	var sizes = __webpack_require__(303);
	var ImageMeasure = __webpack_require__(304);
	var textDecorator = __webpack_require__(305);
	var TextTools = __webpack_require__(15);

	_.noConflict();

	////////////////////////////////////////
	// PdfPrinter

	/**
	 * @class Creates an instance of a PdfPrinter which turns document definition into a pdf
	 *
	 * @param {Object} fontDescriptors font definition dictionary
	 *
	 * @example
	 * var fontDescriptors = {
	 *	Roboto: {
	 *		normal: 'fonts/Roboto-Regular.ttf',
	 *		bold: 'fonts/Roboto-Medium.ttf',
	 *		italics: 'fonts/Roboto-Italic.ttf',
	 *		bolditalics: 'fonts/Roboto-MediumItalic.ttf'
	 *	}
	 * };
	 *
	 * var printer = new PdfPrinter(fontDescriptors);
	 */
	function PdfPrinter(fontDescriptors) {
		this.fontDescriptors = fontDescriptors;
	}

	/**
	 * Executes layout engine for the specified document and renders it into a pdfkit document
	 * ready to be saved.
	 *
	 * @param {Object} docDefinition document definition
	 * @param {Object} docDefinition.content an array describing the pdf structure (for more information take a look at the examples in the /examples folder)
	 * @param {Object} [docDefinition.defaultStyle] default (implicit) style definition
	 * @param {Object} [docDefinition.styles] dictionary defining all styles which can be used in the document
	 * @param {Object} [docDefinition.pageSize] page size (pdfkit units, A4 dimensions by default)
	 * @param {Number} docDefinition.pageSize.width width
	 * @param {Number} docDefinition.pageSize.height height
	 * @param {Object} [docDefinition.pageMargins] page margins (pdfkit units)
	 * @param {Number} docDefinition.maxPagesNumber maximum number of pages to render
	 *
	 * @example
	 *
	 * var docDefinition = {
	 * 	info: {
	 *		title: 'awesome Document',
	 *		author: 'john doe',
	 *		subject: 'subject of document',
	 *		keywords: 'keywords for document',
	 * 	},
	 *	content: [
	 *		'First paragraph',
	 *		'Second paragraph, this time a little bit longer',
	 *		{ text: 'Third paragraph, slightly bigger font size', fontSize: 20 },
	 *		{ text: 'Another paragraph using a named style', style: 'header' },
	 *		{ text: ['playing with ', 'inlines' ] },
	 *		{ text: ['and ', { text: 'restyling ', bold: true }, 'them'] },
	 *	],
	 *	styles: {
	 *		header: { fontSize: 30, bold: true }
	 *	}
	 * }
	 *
	 * var pdfKitDoc = printer.createPdfKitDocument(docDefinition);
	 *
	 * pdfKitDoc.pipe(fs.createWriteStream('sample.pdf'));
	 * pdfKitDoc.end();
	 *
	 * @return {Object} a pdfKit document object which can be saved or encode to data-url
	 */
	PdfPrinter.prototype.createPdfKitDocument = function (docDefinition, options) {
		options = options || {};

		var pageSize = fixPageSize(docDefinition.pageSize, docDefinition.pageOrientation);

		this.pdfKitDoc = new PdfKit({size: [pageSize.width, pageSize.height], autoFirstPage: false, compress: docDefinition.compress || true});
		setMetadata(docDefinition, this.pdfKitDoc);

		this.fontProvider = new FontProvider(this.fontDescriptors, this.pdfKitDoc);

		docDefinition.images = docDefinition.images || {};

		var builder = new LayoutBuilder(pageSize, fixPageMargins(docDefinition.pageMargins || 40), new ImageMeasure(this.pdfKitDoc, docDefinition.images));

		registerDefaultTableLayouts(builder);
		if (options.tableLayouts) {
			builder.registerTableLayouts(options.tableLayouts);
		}

		var pages = builder.layoutDocument(docDefinition.content, this.fontProvider, docDefinition.styles || {}, docDefinition.defaultStyle || {fontSize: 12, font: 'Roboto'}, docDefinition.background, docDefinition.header, docDefinition.footer, docDefinition.images, docDefinition.watermark, docDefinition.pageBreakBefore);
		var maxNumberPages = docDefinition.maxPagesNumber || -1;
		if (typeof maxNumberPages === 'number' && maxNumberPages > -1) {
			pages = pages.slice(0, maxNumberPages);
		}

		// if pageSize.height is set to Infinity, calculate the actual height of the page that
		// was laid out using the height of each of the items in the page.
		if (pageSize.height === Infinity) {
			var pageHeight = calculatePageHeight(pages, docDefinition.pageMargins);
			this.pdfKitDoc.options.size = [pageSize.width, pageHeight];
		}

		renderPages(pages, this.fontProvider, this.pdfKitDoc, options.progressCallback);

		if (options.autoPrint) {
			var printActionRef = this.pdfKitDoc.ref({
				Type: 'Action',
				S: 'Named',
				N: 'Print'
			});
			this.pdfKitDoc._root.data.OpenAction = printActionRef;
			printActionRef.end();
		}
		return this.pdfKitDoc;
	};

	function setMetadata(docDefinition, pdfKitDoc) {
		// PDF standard has these properties reserved: Title, Author, Subject, Keywords,
		// Creator, Producer, CreationDate, ModDate, Trapped.
		// To keep the pdfmake api consistent, the info field are defined lowercase.
		// Custom properties don't contain a space.
		function standardizePropertyKey(key) {
			var standardProperties = ['Title', 'Author', 'Subject', 'Keywords',
				'Creator', 'Producer', 'CreationDate', 'ModDate', 'Trapped'];
			var standardizedKey = key.charAt(0).toUpperCase() + key.slice(1);
			if (standardProperties.indexOf(standardizedKey) !== -1) {
				return standardizedKey;
			}

			return key.replace(/\s+/g, '');
		}

		pdfKitDoc.info.Producer = 'pdfmake';
		pdfKitDoc.info.Creator = 'pdfmake';

		if (docDefinition.info) {
			for (var key in docDefinition.info) {
				var value = docDefinition.info[key];
				if (value) {
					key = standardizePropertyKey(key);
					pdfKitDoc.info[key] = value;
				}
			}
		}
	}

	function calculatePageHeight(pages, margins) {
		function getItemHeight(item) {
			if (typeof item.item.getHeight === 'function') {
				return item.item.getHeight();
			} else if (item.item._height) {
				return item.item._height;
			} else {
				// TODO: add support for next item types
				return 0;
			}
		}

		var fixedMargins = fixPageMargins(margins || 40);
		var height = fixedMargins.top + fixedMargins.bottom;
		pages.forEach(function (page) {
			page.items.forEach(function (item) {
				height += getItemHeight(item);
			});
		});
		return height;
	}

	function fixPageSize(pageSize, pageOrientation) {
		function isNeedSwapPageSizes(pageOrientation) {
			if (typeof pageOrientation === 'string' || pageOrientation instanceof String) {
				pageOrientation = pageOrientation.toLowerCase();
				return ((pageOrientation === 'portrait') && (size.width > size.height)) ||
					((pageOrientation === 'landscape') && (size.width < size.height));
			}
			return false;
		}

		// if pageSize.height is set to auto, set the height to infinity so there are no page breaks.
		if (pageSize && pageSize.height === 'auto') {
			pageSize.height = Infinity;
		}

		var size = pageSize2widthAndHeight(pageSize || 'A4');
		if (isNeedSwapPageSizes(pageOrientation)) { // swap page sizes
			size = {width: size.height, height: size.width};
		}
		size.orientation = size.width > size.height ? 'landscape' : 'portrait';
		return size;
	}

	function fixPageMargins(margin) {
		if (!margin) {
			return null;
		}

		if (typeof margin === 'number' || margin instanceof Number) {
			margin = {left: margin, right: margin, top: margin, bottom: margin};
		} else if (Array.isArray(margin)) {
			if (margin.length === 2) {
				margin = {left: margin[0], top: margin[1], right: margin[0], bottom: margin[1]};
			} else if (margin.length === 4) {
				margin = {left: margin[0], top: margin[1], right: margin[2], bottom: margin[3]};
			} else {
				throw 'Invalid pageMargins definition';
			}
		}

		return margin;
	}

	function registerDefaultTableLayouts(layoutBuilder) {
		/*jshint unused: false */
		layoutBuilder.registerTableLayouts({
			noBorders: {
				hLineWidth: function (i) {
					return 0;
				},
				vLineWidth: function (i) {
					return 0;
				},
				paddingLeft: function (i) {
					return i && 4 || 0;
				},
				paddingRight: function (i, node) {
					return (i < node.table.widths.length - 1) ? 4 : 0;
				}
			},
			headerLineOnly: {
				hLineWidth: function (i, node) {
					if (i === 0 || i === node.table.body.length) {
						return 0;
					}
					return (i === node.table.headerRows) ? 2 : 0;
				},
				vLineWidth: function (i) {
					return 0;
				},
				paddingLeft: function (i) {
					return i === 0 ? 0 : 8;
				},
				paddingRight: function (i, node) {
					return (i === node.table.widths.length - 1) ? 0 : 8;
				}
			},
			lightHorizontalLines: {
				hLineWidth: function (i, node) {
					if (i === 0 || i === node.table.body.length) {
						return 0;
					}
					return (i === node.table.headerRows) ? 2 : 1;
				},
				vLineWidth: function (i) {
					return 0;
				},
				hLineColor: function (i) {
					return i === 1 ? 'black' : '#aaa';
				},
				paddingLeft: function (i) {
					return i === 0 ? 0 : 8;
				},
				paddingRight: function (i, node) {
					return (i === node.table.widths.length - 1) ? 0 : 8;
				}
			}
		});
	}

	function pageSize2widthAndHeight(pageSize) {
		if (typeof pageSize === 'string' || pageSize instanceof String) {
			var size = sizes[pageSize.toUpperCase()];
			if (!size) {
				throw 'Page size ' + pageSize + ' not recognized';
			}
			return {width: size[0], height: size[1]};
		}

		return pageSize;
	}

	function updatePageOrientationInOptions(currentPage, pdfKitDoc) {
		var previousPageOrientation = pdfKitDoc.options.size[0] > pdfKitDoc.options.size[1] ? 'landscape' : 'portrait';

		if (currentPage.pageSize.orientation !== previousPageOrientation) {
			var width = pdfKitDoc.options.size[0];
			var height = pdfKitDoc.options.size[1];
			pdfKitDoc.options.size = [height, width];
		}
	}

	function renderPages(pages, fontProvider, pdfKitDoc, progressCallback) {
		pdfKitDoc._pdfMakePages = pages;
		pdfKitDoc.addPage();

		var totalItems = progressCallback && _.sumBy(pages, function (page) {
			return page.items.length;
		});
		var renderedItems = 0;
		progressCallback = progressCallback || function () {};

		for (var i = 0; i < pages.length; i++) {
			if (i > 0) {
				updatePageOrientationInOptions(pages[i], pdfKitDoc);
				pdfKitDoc.addPage(pdfKitDoc.options);
			}

			var page = pages[i];
			for (var ii = 0, il = page.items.length; ii < il; ii++) {
				var item = page.items[ii];
				switch (item.type) {
					case 'vector':
						renderVector(item.item, pdfKitDoc);
						break;
					case 'line':
						renderLine(item.item, item.item.x, item.item.y, pdfKitDoc);
						break;
					case 'image':
						renderImage(item.item, item.item.x, item.item.y, pdfKitDoc);
						break;
				}
				renderedItems++;
				progressCallback(renderedItems / totalItems);
			}
			if (page.watermark) {
				renderWatermark(page, pdfKitDoc);
			}
		}
	}

	function renderLine(line, x, y, pdfKitDoc) {
		if (line._tocItemNode) {
			var newWidth;
			var diffWidth;
			var textTools = new TextTools(null);

			line.inlines[0].text = line._tocItemNode.positions[0].pageNumber.toString();
			newWidth = textTools.widthOfString(line.inlines[0].text, line.inlines[0].font, line.inlines[0].fontSize, line.inlines[0].characterSpacing);
			diffWidth = line.inlines[0].width - newWidth;
			line.inlines[0].width = newWidth;

			switch (line.inlines[0].alignment) {
				case 'right':
					line.inlines[0].x += diffWidth;
					break;
				case 'center':
					line.inlines[0].x += diffWidth / 2;
					break;
			}
		}

		x = x || 0;
		y = y || 0;

		var lineHeight = line.getHeight();
		var ascenderHeight = line.getAscenderHeight();
		var descent = lineHeight - ascenderHeight;

		textDecorator.drawBackground(line, x, y, pdfKitDoc);

		//TODO: line.optimizeInlines();
		for (var i = 0, l = line.inlines.length; i < l; i++) {
			var inline = line.inlines[i];
			var shiftToBaseline = lineHeight - ((inline.font.ascender / 1000) * inline.fontSize) - descent;

			pdfKitDoc.fill(inline.color || 'black');

			pdfKitDoc._font = inline.font;
			pdfKitDoc.fontSize(inline.fontSize);
			pdfKitDoc.text(inline.text, x + inline.x, y + shiftToBaseline, {
				lineBreak: false,
				textWidth: inline.width,
				characterSpacing: inline.characterSpacing,
				wordCount: 1,
				link: inline.link
			});

			if (inline.linkToPage) {
				var _ref = pdfKitDoc.ref({Type: 'Action', S: 'GoTo', D: [inline.linkToPage, 0, 0]}).end();
				pdfKitDoc.annotate(x + inline.x, y + shiftToBaseline, inline.width, inline.height, {Subtype: 'Link', Dest: [inline.linkToPage - 1, 'XYZ', null, null, null]});
			}

		}

		textDecorator.drawDecorations(line, x, y, pdfKitDoc);
	}

	function renderWatermark(page, pdfKitDoc) {
		var watermark = page.watermark;

		pdfKitDoc.fill(watermark.color);
		pdfKitDoc.opacity(watermark.opacity);

		pdfKitDoc.save();

		var angle = Math.atan2(pdfKitDoc.page.height, pdfKitDoc.page.width) * -180 / Math.PI;
		pdfKitDoc.rotate(angle, {origin: [pdfKitDoc.page.width / 2, pdfKitDoc.page.height / 2]});

		var x = pdfKitDoc.page.width / 2 - watermark.size.size.width / 2;
		var y = pdfKitDoc.page.height / 2 - watermark.size.size.height / 4;

		pdfKitDoc._font = watermark.font;
		pdfKitDoc.fontSize(watermark.size.fontSize);
		pdfKitDoc.text(watermark.text, x, y, {lineBreak: false});

		pdfKitDoc.restore();
	}

	function renderVector(vector, pdfKitDoc) {
		//TODO: pdf optimization (there's no need to write all properties everytime)
		pdfKitDoc.lineWidth(vector.lineWidth || 1);
		if (vector.dash) {
			pdfKitDoc.dash(vector.dash.length, {space: vector.dash.space || vector.dash.length, phase: vector.dash.phase || 0});
		} else {
			pdfKitDoc.undash();
		}
		pdfKitDoc.lineJoin(vector.lineJoin || 'miter');

		//TODO: clipping

		switch (vector.type) {
			case 'ellipse':
				pdfKitDoc.ellipse(vector.x, vector.y, vector.r1, vector.r2);
				break;
			case 'rect':
				if (vector.r) {
					pdfKitDoc.roundedRect(vector.x, vector.y, vector.w, vector.h, vector.r);
				} else {
					pdfKitDoc.rect(vector.x, vector.y, vector.w, vector.h);
				}

				if (vector.linearGradient) {
					var gradient = pdfKitDoc.linearGradient(vector.x, vector.y, vector.x + vector.w, vector.y);
					var step = 1 / (vector.linearGradient.length - 1);

					for (var i = 0; i < vector.linearGradient.length; i++) {
						gradient.stop(i * step, vector.linearGradient[i]);
					}

					vector.color = gradient;
				}
				break;
			case 'line':
				pdfKitDoc.moveTo(vector.x1, vector.y1);
				pdfKitDoc.lineTo(vector.x2, vector.y2);
				break;
			case 'polyline':
				if (vector.points.length === 0) {
					break;
				}

				pdfKitDoc.moveTo(vector.points[0].x, vector.points[0].y);
				for (var i = 1, l = vector.points.length; i < l; i++) {
					pdfKitDoc.lineTo(vector.points[i].x, vector.points[i].y);
				}

				if (vector.points.length > 1) {
					var p1 = vector.points[0];
					var pn = vector.points[vector.points.length - 1];

					if (vector.closePath || p1.x === pn.x && p1.y === pn.y) {
						pdfKitDoc.closePath();
					}
				}
				break;
			case 'path':
				pdfKitDoc.path(vector.d);
				break;
		}

		if (vector.color && vector.lineColor) {
			pdfKitDoc.fillColor(vector.color, vector.fillOpacity || 1);
			pdfKitDoc.strokeColor(vector.lineColor, vector.strokeOpacity || 1);
			pdfKitDoc.fillAndStroke();
		} else if (vector.color) {
			pdfKitDoc.fillColor(vector.color, vector.fillOpacity || 1);
			pdfKitDoc.fill();
		} else {
			pdfKitDoc.strokeColor(vector.lineColor || 'black', vector.strokeOpacity || 1);
			pdfKitDoc.stroke();
		}
	}

	function renderImage(image, x, y, pdfKitDoc) {
		pdfKitDoc.image(image.image, image.x, image.y, {width: image._width, height: image._height});
		if (image.link) {
			pdfKitDoc.link(image.x, image.y, image._width, image._height, image.link);
		}
	}

	module.exports = PdfPrinter;


	/* temporary browser extension */
	PdfPrinter.prototype.fs = __webpack_require__(56);


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {

	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;

	  /** Used as the semantic version number. */
	  var VERSION = '4.17.4';

	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;

	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';

	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';

	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;

	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';

	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;

	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;

	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;

	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';

	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;

	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;

	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;

	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];

	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';

	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';

	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;

	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      reLeadingDot = /^\./,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);

	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;

	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;

	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;

	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;

	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;

	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;

	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;

	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;

	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;

	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';

	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',
	      rsOrdUpper = '\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');

	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');

	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');

	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];

	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;

	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;

	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;

	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };

	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };

	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };

	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };

	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;

	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();

	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;

	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;

	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());

	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

	  /*--------------------------------------------------------------------------*/

	  /**
	   * Adds the key-value `pair` to `map`.
	   *
	   * @private
	   * @param {Object} map The map to modify.
	   * @param {Array} pair The key-value pair to add.
	   * @returns {Object} Returns `map`.
	   */
	  function addMapEntry(map, pair) {
	    // Don't return `map.set` because it's not chainable in IE 11.
	    map.set(pair[0], pair[1]);
	    return map;
	  }

	  /**
	   * Adds `value` to `set`.
	   *
	   * @private
	   * @param {Object} set The set to modify.
	   * @param {*} value The value to add.
	   * @returns {Object} Returns `set`.
	   */
	  function addSetEntry(set, value) {
	    // Don't return `set.add` because it's not chainable in IE 11.
	    set.add(value);
	    return set;
	  }

	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }

	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;

	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }

	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;

	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }

	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;

	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }

	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;

	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }

	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];

	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }

	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }

	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;

	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }

	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);

	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }

	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;

	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }

	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;

	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }

	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }

	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;

	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }

	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');

	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }

	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }

	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }

	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);

	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }

	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }

	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;

	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }

	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }

	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }

	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }

	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }

	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }

	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;

	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }

	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;

	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }

	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);

	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }

	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }

	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }

	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }

	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }

	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;

	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }

	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;

	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }

	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;

	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }

	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);

	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);

	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }

	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }

	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }

	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }

	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];

	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }

	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);

	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }

	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }

	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];

	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }

	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);

	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }

	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);

	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }

	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;

	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }

	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }

	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }

	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }

	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }

	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }

	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }

	  /*--------------------------------------------------------------------------*/

	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;

	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;

	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];

	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;

	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;

	    /** Used to generate unique IDs. */
	    var idCounter = 0;

	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());

	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;

	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);

	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;

	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );

	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());

	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;

	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');

	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;

	    /** Used to lookup unminified function names. */
	    var realNames = {};

	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);

	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }

	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());

	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }

	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }

	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {

	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,

	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,

	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,

	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',

	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {

	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };

	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;

	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }

	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }

	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }

	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);

	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];

	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;

	        var iterIndex = -1,
	            value = array[index];

	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);

	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }

	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;

	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }

	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }

	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }

	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }

	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }

	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }

	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;

	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }

	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }

	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);

	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }

	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);

	      return index < 0 ? undefined : data[index][1];
	    }

	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }

	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);

	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }

	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;

	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }

	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }

	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }

	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }

	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }

	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;

	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }

	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;

	    /*------------------------------------------------------------------------*/

	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;

	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }

	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }

	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }

	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }

	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }

	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);

	      this.size = data.size;
	      return result;
	    }

	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }

	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }

	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }

	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;

	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }

	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }

	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }

	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }

	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }

	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }

	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }

	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }

	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }

	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }

	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }

	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;

	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }

	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;

	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;

	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, baseClone, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);

	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);

	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }

	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }

	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];

	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }

	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }

	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;

	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);

	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);

	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);

	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }

	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;

	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);

	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;

	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }

	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }

	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;

	      predicate || (predicate = isFlattenable);
	      result || (result = []);

	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();

	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);

	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }

	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }

	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }

	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);

	      var index = 0,
	          length = path.length;

	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }

	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }

	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }

	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }

	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }

	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }

	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }

	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];

	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];

	      var index = -1,
	          seen = caches[0];

	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;

	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }

	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }

	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }

	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }

	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }

	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }

	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);

	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;

	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;

	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;

	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }

	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }

	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;

	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];

	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }

	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }

	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }

	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }

	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }

	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }

	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];

	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }

	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];

	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }

	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }

	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }

	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	            : undefined;

	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }

	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = object[key],
	          srcValue = source[key],
	          stacked = stack.get(srcValue);

	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;

	      var isCommon = newValue === undefined;

	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }

	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }

	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });

	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }

	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }

	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};

	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);

	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }

	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }

	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;

	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;

	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }

	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;

	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }

	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }

	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);

	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);

	      return result;
	    }

	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }

	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }

	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }

	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);

	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;

	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;

	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }

	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };

	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };

	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }

	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;

	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;

	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;

	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }

	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;

	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];

	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }

	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);

	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;

	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);

	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }

	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];

	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;

	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }

	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }

	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;

	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;

	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }

	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }

	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }

	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;

	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}

	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }

	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }

	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);

	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;

	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }

	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};

	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }

	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }

	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }

	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }

	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;

	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }

	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };

	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

	      buffer.copy(result);
	      return result;
	    }

	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }

	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }

	    /**
	     * Creates a clone of `map`.
	     *
	     * @private
	     * @param {Object} map The map to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned map.
	     */
	    function cloneMap(map, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
	      return arrayReduce(array, addMapEntry, new map.constructor);
	    }

	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }

	    /**
	     * Creates a clone of `set`.
	     *
	     * @private
	     * @param {Object} set The set to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned set.
	     */
	    function cloneSet(set, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
	      return arrayReduce(array, addSetEntry, new set.constructor);
	    }

	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }

	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }

	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);

	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);

	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }

	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;

	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }

	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;

	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }

	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;

	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }

	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;

	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }

	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});

	      var index = -1,
	          length = props.length;

	      while (++index < length) {
	        var key = props[index];

	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;

	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }

	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }

	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }

	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};

	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }

	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;

	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;

	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }

	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);

	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }

	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;

	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }

	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);

	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }

	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);

	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;

	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);

	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);

	        return chr[methodName]() + trailing;
	      };
	    }

	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }

	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);

	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }

	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);

	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);

	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);

	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }

	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }

	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;

	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];

	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;

	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];

	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;

	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }

	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);

	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;

	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;

	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }

	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }

	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }

	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }

	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);

	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }

	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);

	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }

	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }

	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }

	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;

	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];

	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }

	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));

	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }

	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };

	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }

	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;

	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;

	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);

	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];

	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);

	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }

	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }

	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }

	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }

	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;

	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

	      stack.set(array, other);
	      stack.set(other, array);

	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];

	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }

	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;

	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;

	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);

	        case errorTag:
	          return object.name == other.name && object.message == other.message;

	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');

	        case mapTag:
	          var convert = mapToArray;

	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);

	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;

	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;

	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }

	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;

	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);

	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];

	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;

	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }

	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }

	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }

	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }

	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };

	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }

	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }

	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }

	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }

	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;

	      while (length--) {
	        var key = result[length],
	            value = object[key];

	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }

	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }

	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];

	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}

	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }

	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };

	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };

	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;

	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';

	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }

	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;

	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;

	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }

	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }

	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);

	      var index = -1,
	          length = path.length,
	          result = false;

	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }

	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = array.constructor(length);

	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }

	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }

	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, cloneFunc, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);

	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);

	        case dataViewTag:
	          return cloneDataView(object, isDeep);

	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);

	        case mapTag:
	          return cloneMap(object, isDeep, cloneFunc);

	        case numberTag:
	        case stringTag:
	          return new Ctor(object);

	        case regexpTag:
	          return cloneRegExp(object);

	        case setTag:
	          return cloneSet(object, isDeep, cloneFunc);

	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }

	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }

	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }

	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return !!length &&
	        (typeof value == 'number' || reIsUint.test(value)) &&
	        (value > -1 && value % 1 == 0 && value < length);
	    }

	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }

	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }

	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }

	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];

	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }

	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }

	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;

	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

	      return value === proto;
	    }

	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }

	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }

	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });

	      var cache = result.cache;
	      return result;
	    }

	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;

	      return data;
	    }

	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }

	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }

	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);

	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }

	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }

	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);

	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }

	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);

	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };

	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);

	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }

	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;

	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);

	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }

	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;

	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];

	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }

	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (reLeadingDot.test(string)) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });

	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }

	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }

	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }

	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));

	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }

	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];

	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }

	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;

	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }

	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });

	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });

	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });

	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }

	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }

	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }

	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }

	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }

	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }

	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }

	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }

	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }

	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }

	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};

	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }

	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }

	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }

	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }

	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });

	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);

	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });

	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);

	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });

	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }

	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }

	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }

	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }

	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);

	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }

	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }

	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }

	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);

	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));

	      return result;
	    });

	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;

	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }

	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }

	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }

	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }

	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }

	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }

	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }

	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }

	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }

	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }

	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }

	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }

	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }

	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }

	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }

	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }

	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });

	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });

	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });

	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }

	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }

	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }

	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }

	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }

	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });

	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });

	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });

	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });

	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);

	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }

	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }

	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;

	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }

	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }

	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }

	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };

	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });

	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }

	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }

	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];

	      return { 'done': done, 'value': value };
	    }

	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }

	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;

	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }

	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }

	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });

	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }

	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }

	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);

	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);

	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }

	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }

	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }

	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }

	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }

	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });

	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }

	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];

	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });

	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });

	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }

	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }

	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });

	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;

	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }

	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;

	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }

	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }

	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }

	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }

	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }

	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }

	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }

	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });

	    /*------------------------------------------------------------------------*/

	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };

	    /*------------------------------------------------------------------------*/

	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }

	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }

	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }

	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });

	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });

	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }

	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }

	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;

	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }

	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;

	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }

	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }

	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            result = wait - timeSinceLastCall;

	        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	      }

	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;

	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }

	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }

	      function trailingEdge(time) {
	        timerId = undefined;

	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }

	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }

	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }

	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);

	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;

	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }

	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });

	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });

	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }

	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;

	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }

	    // Expose `MapCache`.
	    memoize.Cache = MapCache;

	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }

	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }

	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);

	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });

	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });

	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });

	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });

	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }

	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);

	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }

	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;

	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }

	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }

	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }

	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }

	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }

	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }

	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }

	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }

	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }

	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);

	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });

	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };

	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;

	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }

	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }

	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }

	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;

	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }

	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }

	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }

	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }

	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }

	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }

	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }

	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }

	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }

	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }

	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }

	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }

	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }

	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }

	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }

	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }

	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }

	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }

	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }

	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }

	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }

	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }

	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }

	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }

	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }

	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);

	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });

	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

	      return func(value);
	    }

	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }

	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;

	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }

	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }

	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }

	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }

	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }

	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });

	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });

	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });

	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });

	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);

	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }

	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(args) {
	      args.push(undefined, customDefaultsAssignIn);
	      return apply(assignInWith, undefined, args);
	    });

	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });

	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }

	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }

	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }

	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }

	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }

	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }

	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }

	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }

	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }

	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }

	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }

	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      result[value] = key;
	    }, constant(identity));

	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);

	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);

	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }

	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }

	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);

	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }

	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);

	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }

	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });

	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });

	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });

	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }

	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });

	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }

	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);

	      var index = -1,
	          length = path.length;

	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }

	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }

	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }

	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);

	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);

	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }

	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }

	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }

	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }

	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }

	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }

	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }

	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });

	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }

	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }

	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);

	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);

	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }

	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }

	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }

	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });

	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });

	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');

	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);

	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }

	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);

	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }

	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);

	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }

	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }

	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }

	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);

	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }

	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });

	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }

	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });

	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);

	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }

	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;

	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);

	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);

	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";

	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');

	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';

	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);

	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;

	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });

	      source += "';\n";

	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');

	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';

	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });

	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }

	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }

	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }

	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;

	      return castSlice(strSymbols, start, end).join('');
	    }

	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

	      return castSlice(strSymbols, 0, end).join('');
	    }

	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));

	      return castSlice(strSymbols, start).join('');
	    }

	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;

	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);

	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);

	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;

	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }

	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }

	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });

	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');

	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;

	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });

	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });

	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();

	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });

	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }

	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }

	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }

	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }

	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();

	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);

	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }

	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }

	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }

	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }

	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });

	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });

	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);

	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);

	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);

	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });

	      return object;
	    }

	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }

	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }

	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }

	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);

	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);

	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);

	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }

	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }

	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();

	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);

	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }

	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }

	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }

	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }

	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }

	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);

	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;

	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }

	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }

	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }

	    /*------------------------------------------------------------------------*/

	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);

	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');

	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);

	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');

	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }

	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }

	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }

	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }

	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }

	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }

	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);

	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');

	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);

	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }

	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }

	    /*------------------------------------------------------------------------*/

	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;

	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;

	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);

	    /*------------------------------------------------------------------------*/

	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;

	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;

	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });

	    /*------------------------------------------------------------------------*/

	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;

	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });

	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();

	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };

	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });

	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });

	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');

	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });

	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');

	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });

	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };

	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };

	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };

	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });

	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };

	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);

	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };

	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };

	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };

	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);

	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);

	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };

	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;

	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });

	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });

	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);

	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });

	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];

	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;

	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;

	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });

	  /*--------------------------------------------------------------------------*/

	  // Export lodash.
	  var _ = runInContext();

	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;

	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(8)(module)))

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	/* jslint node: true */
	'use strict';

	var _ = __webpack_require__(7);

	_.noConflict();

	function typeName(bold, italics) {
		var type = 'normal';
		if (bold && italics) {
			type = 'bolditalics';
		} else if (bold) {
			type = 'bold';
		} else if (italics) {
			type = 'italics';
		}
		return type;
	}

	function FontProvider(fontDescriptors, pdfKitDoc) {
		this.fonts = {};
		this.pdfKitDoc = pdfKitDoc;
		this.fontCache = {};

		for (var font in fontDescriptors) {
			if (fontDescriptors.hasOwnProperty(font)) {
				var fontDef = fontDescriptors[font];

				this.fonts[font] = {
					normal: fontDef.normal,
					bold: fontDef.bold,
					italics: fontDef.italics,
					bolditalics: fontDef.bolditalics
				};
			}
		}
	}

	FontProvider.prototype.provideFont = function (familyName, bold, italics) {
		var type = typeName(bold, italics);
		if (!this.fonts[familyName] || !this.fonts[familyName][type]) {
			throw new Error('Font \'' + familyName + '\' in style \'' + type + '\' is not defined in the font section of the document definition.');
		}

		this.fontCache[familyName] = this.fontCache[familyName] || {};

		if (!this.fontCache[familyName][type]) {
			var def = this.fonts[familyName][type];
			if (!Array.isArray(def)) {
				def = [def];
			}
			this.fontCache[familyName][type] = this.pdfKitDoc.font.apply(this.pdfKitDoc, def)._font;
		}

		return this.fontCache[familyName][type];
	};

	module.exports = FontProvider;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	/* jslint node: true */
	'use strict';

	var _ = __webpack_require__(7);
	var TraversalTracker = __webpack_require__(11);
	var DocPreprocessor = __webpack_require__(12);
	var DocMeasure = __webpack_require__(14);
	var DocumentContext = __webpack_require__(25);
	var PageElementWriter = __webpack_require__(26);
	var ColumnCalculator = __webpack_require__(23);
	var TableProcessor = __webpack_require__(29);
	var Line = __webpack_require__(28);
	var pack = __webpack_require__(13).pack;
	var offsetVector = __webpack_require__(13).offsetVector;
	var fontStringify = __webpack_require__(13).fontStringify;
	var isFunction = __webpack_require__(13).isFunction;
	var TextTools = __webpack_require__(15);
	var StyleContextStack = __webpack_require__(22);

	function addAll(target, otherArray) {
		_.each(otherArray, function (item) {
			target.push(item);
		});
	}

	/**
	 * Creates an instance of LayoutBuilder - layout engine which turns document-definition-object
	 * into a set of pages, lines, inlines and vectors ready to be rendered into a PDF
	 *
	 * @param {Object} pageSize - an object defining page width and height
	 * @param {Object} pageMargins - an object defining top, left, right and bottom margins
	 */
	function LayoutBuilder(pageSize, pageMargins, imageMeasure) {
		this.pageSize = pageSize;
		this.pageMargins = pageMargins;
		this.tracker = new TraversalTracker();
		this.imageMeasure = imageMeasure;
		this.tableLayouts = {};
	}

	LayoutBuilder.prototype.registerTableLayouts = function (tableLayouts) {
		this.tableLayouts = pack(this.tableLayouts, tableLayouts);
	};

	/**
	 * Executes layout engine on document-definition-object and creates an array of pages
	 * containing positioned Blocks, Lines and inlines
	 *
	 * @param {Object} docStructure document-definition-object
	 * @param {Object} fontProvider font provider
	 * @param {Object} styleDictionary dictionary with style definitions
	 * @param {Object} defaultStyle default style definition
	 * @return {Array} an array of pages
	 */
	LayoutBuilder.prototype.layoutDocument = function (docStructure, fontProvider, styleDictionary, defaultStyle, background, header, footer, images, watermark, pageBreakBeforeFct) {

		function addPageBreaksIfNecessary(linearNodeList, pages) {

			if (!isFunction(pageBreakBeforeFct)) {
				return false;
			}

			linearNodeList = _.reject(linearNodeList, function (node) {
				return _.isEmpty(node.positions);
			});

			_.each(linearNodeList, function (node) {
				var nodeInfo = _.pick(node, [
					'id', 'text', 'ul', 'ol', 'table', 'image', 'qr', 'canvas', 'columns',
					'headlineLevel', 'style', 'pageBreak', 'pageOrientation',
					'width', 'height'
				]);
				nodeInfo.startPosition = _.first(node.positions);
				nodeInfo.pageNumbers = _.chain(node.positions).map('pageNumber').uniq().value();
				nodeInfo.pages = pages.length;
				nodeInfo.stack = _.isArray(node.stack);

				node.nodeInfo = nodeInfo;
			});

			return _.some(linearNodeList, function (node, index, followingNodeList) {
				if (node.pageBreak !== 'before' && !node.pageBreakCalculated) {
					node.pageBreakCalculated = true;
					var pageNumber = _.first(node.nodeInfo.pageNumbers);

					var followingNodesOnPage = _.chain(followingNodeList).drop(index + 1).filter(function (node0) {
						return _.includes(node0.nodeInfo.pageNumbers, pageNumber);
					}).value();

					var nodesOnNextPage = _.chain(followingNodeList).drop(index + 1).filter(function (node0) {
						return _.includes(node0.nodeInfo.pageNumbers, pageNumber + 1);
					}).value();

					var previousNodesOnPage = _.chain(followingNodeList).take(index).filter(function (node0) {
						return _.includes(node0.nodeInfo.pageNumbers, pageNumber);
					}).value();

					if (pageBreakBeforeFct(node.nodeInfo,
						_.map(followingNodesOnPage, 'nodeInfo'),
						_.map(nodesOnNextPage, 'nodeInfo'),
						_.map(previousNodesOnPage, 'nodeInfo'))) {
						node.pageBreak = 'before';
						return true;
					}
				}
			});
		}

		this.docPreprocessor = new DocPreprocessor();
		this.docMeasure = new DocMeasure(fontProvider, styleDictionary, defaultStyle, this.imageMeasure, this.tableLayouts, images);


		function resetXYs(result) {
			_.each(result.linearNodeList, function (node) {
				node.resetXY();
			});
		}

		var result = this.tryLayoutDocument(docStructure, fontProvider, styleDictionary, defaultStyle, background, header, footer, images, watermark);
		while (addPageBreaksIfNecessary(result.linearNodeList, result.pages)) {
			resetXYs(result);
			result = this.tryLayoutDocument(docStructure, fontProvider, styleDictionary, defaultStyle, background, header, footer, images, watermark);
		}

		return result.pages;
	};

	LayoutBuilder.prototype.tryLayoutDocument = function (docStructure, fontProvider, styleDictionary, defaultStyle, background, header, footer, images, watermark, pageBreakBeforeFct) {

		this.linearNodeList = [];
		docStructure = this.docPreprocessor.preprocessDocument(docStructure);
		docStructure = this.docMeasure.measureDocument(docStructure);

		this.writer = new PageElementWriter(
			new DocumentContext(this.pageSize, this.pageMargins), this.tracker);

		var _this = this;
		this.writer.context().tracker.startTracking('pageAdded', function () {
			_this.addBackground(background);
		});

		this.addBackground(background);
		this.processNode(docStructure);
		this.addHeadersAndFooters(header, footer);
		/* jshint eqnull:true */
		if (watermark != null) {
			this.addWatermark(watermark, fontProvider, defaultStyle);
		}

		return {pages: this.writer.context().pages, linearNodeList: this.linearNodeList};
	};


	LayoutBuilder.prototype.addBackground = function (background) {
		var backgroundGetter = isFunction(background) ? background : function () {
			return background;
		};

		var pageBackground = backgroundGetter(this.writer.context().page + 1);

		if (pageBackground) {
			var pageSize = this.writer.context().getCurrentPage().pageSize;
			this.writer.beginUnbreakableBlock(pageSize.width, pageSize.height);
			pageBackground = this.docPreprocessor.preprocessDocument(pageBackground);
			this.processNode(this.docMeasure.measureDocument(pageBackground));
			this.writer.commitUnbreakableBlock(0, 0);
		}
	};

	LayoutBuilder.prototype.addStaticRepeatable = function (headerOrFooter, sizeFunction) {
		this.addDynamicRepeatable(function () {
			return JSON.parse(JSON.stringify(headerOrFooter)); // copy to new object
		}, sizeFunction);
	};

	LayoutBuilder.prototype.addDynamicRepeatable = function (nodeGetter, sizeFunction) {
		var pages = this.writer.context().pages;

		for (var pageIndex = 0, l = pages.length; pageIndex < l; pageIndex++) {
			this.writer.context().page = pageIndex;

			var node = nodeGetter(pageIndex + 1, l, this.writer.context().pages[pageIndex].pageSize);

			if (node) {
				var sizes = sizeFunction(this.writer.context().getCurrentPage().pageSize, this.pageMargins);
				this.writer.beginUnbreakableBlock(sizes.width, sizes.height);
				node = this.docPreprocessor.preprocessDocument(node);
				this.processNode(this.docMeasure.measureDocument(node));
				this.writer.commitUnbreakableBlock(sizes.x, sizes.y);
			}
		}
	};

	LayoutBuilder.prototype.addHeadersAndFooters = function (header, footer) {
		var headerSizeFct = function (pageSize, pageMargins) {
			return {
				x: 0,
				y: 0,
				width: pageSize.width,
				height: pageMargins.top
			};
		};

		var footerSizeFct = function (pageSize, pageMargins) {
			return {
				x: 0,
				y: pageSize.height - pageMargins.bottom,
				width: pageSize.width,
				height: pageMargins.bottom
			};
		};

		if (isFunction(header)) {
			this.addDynamicRepeatable(header, headerSizeFct);
		} else if (header) {
			this.addStaticRepeatable(header, headerSizeFct);
		}

		if (isFunction(footer)) {
			this.addDynamicRepeatable(footer, footerSizeFct);
		} else if (footer) {
			this.addStaticRepeatable(footer, footerSizeFct);
		}
	};

	LayoutBuilder.prototype.addWatermark = function (watermark, fontProvider, defaultStyle) {
		if (typeof watermark === 'string') {
			watermark = {'text': watermark};
		}

		if (!watermark.text) { // empty watermark text
			return;
		}

		watermark.font = watermark.font || defaultStyle.font || 'Roboto';
		watermark.color = watermark.color || 'black';
		watermark.opacity = watermark.opacity || 0.6;
		watermark.bold = watermark.bold || false;
		watermark.italics = watermark.italics || false;

		var watermarkObject = {
			text: watermark.text,
			font: fontProvider.provideFont(watermark.font, watermark.bold, watermark.italics),
			size: getSize(this.pageSize, watermark, fontProvider),
			color: watermark.color,
			opacity: watermark.opacity
		};

		var pages = this.writer.context().pages;
		for (var i = 0, l = pages.length; i < l; i++) {
			pages[i].watermark = watermarkObject;
		}

		function getSize(pageSize, watermark, fontProvider) {
			var width = pageSize.width;
			var height = pageSize.height;
			var targetWidth = Math.sqrt(width * width + height * height) * 0.8; /* page diagonal * sample factor */
			var textTools = new TextTools(fontProvider);
			var styleContextStack = new StyleContextStack(null, {font: watermark.font, bold: watermark.bold, italics: watermark.italics});
			var size;

			/**
			 * Binary search the best font size.
			 * Initial bounds [0, 1000]
			 * Break when range < 1
			 */
			var a = 0;
			var b = 1000;
			var c = (a + b) / 2;
			while (Math.abs(a - b) > 1) {
				styleContextStack.push({
					fontSize: c
				});
				size = textTools.sizeOfString(watermark.text, styleContextStack);
				if (size.width > targetWidth) {
					b = c;
					c = (a + b) / 2;
				} else if (size.width < targetWidth) {
					a = c;
					c = (a + b) / 2;
				}
				styleContextStack.pop();
			}
			/*
			 End binary search
			 */
			return {size: size, fontSize: c};
		}
	};

	function decorateNode(node) {
		var x = node.x, y = node.y;
		node.positions = [];

		_.each(node.canvas, function (vector) {
			var x = vector.x, y = vector.y, x1 = vector.x1, y1 = vector.y1, x2 = vector.x2, y2 = vector.y2;
			vector.resetXY = function () {
				vector.x = x;
				vector.y = y;
				vector.x1 = x1;
				vector.y1 = y1;
				vector.x2 = x2;
				vector.y2 = y2;
			};
		});

		node.resetXY = function () {
			node.x = x;
			node.y = y;
			_.each(node.canvas, function (vector) {
				vector.resetXY();
			});
		};
	}

	LayoutBuilder.prototype.processNode = function (node) {
		var self = this;

		this.linearNodeList.push(node);
		decorateNode(node);

		applyMargins(function () {
			var unbreakable = node.unbreakable;
			if (unbreakable) {
				self.writer.beginUnbreakableBlock();
			}

			var absPosition = node.absolutePosition;
			if (absPosition) {
				self.writer.context().beginDetachedBlock();
				self.writer.context().moveTo(absPosition.x || 0, absPosition.y || 0);
			}

			var relPosition = node.relativePosition;
			if (relPosition) {
				self.writer.context().beginDetachedBlock();
				self.writer.context().moveTo((relPosition.x || 0) + self.writer.context().x, (relPosition.y || 0) + self.writer.context().y);
			}

			if (node.stack) {
				self.processVerticalContainer(node);
			} else if (node.columns) {
				self.processColumns(node);
			} else if (node.ul) {
				self.processList(false, node);
			} else if (node.ol) {
				self.processList(true, node);
			} else if (node.table) {
				self.processTable(node);
			} else if (node.text !== undefined) {
				self.processLeaf(node);
			} else if (node.toc) {
				self.processToc(node);
			} else if (node.image) {
				self.processImage(node);
			} else if (node.canvas) {
				self.processCanvas(node);
			} else if (node.qr) {
				self.processQr(node);
			} else if (!node._span) {
				throw 'Unrecognized document structure: ' + JSON.stringify(node, fontStringify);
			}

			if (absPosition || relPosition) {
				self.writer.context().endDetachedBlock();
			}

			if (unbreakable) {
				self.writer.commitUnbreakableBlock();
			}
		});

		function applyMargins(callback) {
			var margin = node._margin;

			if (node.pageBreak === 'before') {
				self.writer.moveToNextPage(node.pageOrientation);
			}

			if (margin) {
				self.writer.context().moveDown(margin[1]);
				self.writer.context().addMargin(margin[0], margin[2]);
			}

			callback();

			if (margin) {
				self.writer.context().addMargin(-margin[0], -margin[2]);
				self.writer.context().moveDown(margin[3]);
			}

			if (node.pageBreak === 'after') {
				self.writer.moveToNextPage(node.pageOrientation);
			}
		}
	};

	// vertical container
	LayoutBuilder.prototype.processVerticalContainer = function (node) {
		var self = this;
		node.stack.forEach(function (item) {
			self.processNode(item);
			addAll(node.positions, item.positions);

			//TODO: paragraph gap
		});
	};

	// columns
	LayoutBuilder.prototype.processColumns = function (columnNode) {
		var columns = columnNode.columns;
		var availableWidth = this.writer.context().availableWidth;
		var gaps = gapArray(columnNode._gap);

		if (gaps) {
			availableWidth -= (gaps.length - 1) * columnNode._gap;
		}

		ColumnCalculator.buildColumnWidths(columns, availableWidth);
		var result = this.processRow(columns, columns, gaps);
		addAll(columnNode.positions, result.positions);


		function gapArray(gap) {
			if (!gap) {
				return null;
			}

			var gaps = [];
			gaps.push(0);

			for (var i = columns.length - 1; i > 0; i--) {
				gaps.push(gap);
			}

			return gaps;
		}
	};

	LayoutBuilder.prototype.processRow = function (columns, widths, gaps, tableBody, tableRow) {
		var self = this;
		var pageBreaks = [], positions = [];

		this.tracker.auto('pageChanged', storePageBreakData, function () {
			widths = widths || columns;

			self.writer.context().beginColumnGroup();

			for (var i = 0, l = columns.length; i < l; i++) {
				var column = columns[i];
				var width = widths[i]._calcWidth;
				var leftOffset = colLeftOffset(i);

				if (column.colSpan && column.colSpan > 1) {
					for (var j = 1; j < column.colSpan; j++) {
						width += widths[++i]._calcWidth + gaps[i];
					}
				}

				self.writer.context().beginColumn(width, leftOffset, getEndingCell(column, i));
				if (!column._span) {
					self.processNode(column);
					addAll(positions, column.positions);
				} else if (column._columnEndingContext) {
					// row-span ending
					self.writer.context().markEnding(column);
				}
			}

			self.writer.context().completeColumnGroup();
		});

		return {pageBreaks: pageBreaks, positions: positions};

		function storePageBreakData(data) {
			var pageDesc;

			for (var i = 0, l = pageBreaks.length; i < l; i++) {
				var desc = pageBreaks[i];
				if (desc.prevPage === data.prevPage) {
					pageDesc = desc;
					break;
				}
			}

			if (!pageDesc) {
				pageDesc = data;
				pageBreaks.push(pageDesc);
			}
			pageDesc.prevY = Math.max(pageDesc.prevY, data.prevY);
			pageDesc.y = Math.min(pageDesc.y, data.y);
		}

		function colLeftOffset(i) {
			if (gaps && gaps.length > i) {
				return gaps[i];
			}
			return 0;
		}

		function getEndingCell(column, columnIndex) {
			if (column.rowSpan && column.rowSpan > 1) {
				var endingRow = tableRow + column.rowSpan - 1;
				if (endingRow >= tableBody.length) {
					throw 'Row span for column ' + columnIndex + ' (with indexes starting from 0) exceeded row count';
				}
				return tableBody[endingRow][columnIndex];
			}

			return null;
		}
	};

	// lists
	LayoutBuilder.prototype.processList = function (orderedList, node) {
		var self = this,
			items = orderedList ? node.ol : node.ul,
			gapSize = node._gapSize;

		this.writer.context().addMargin(gapSize.width);

		var nextMarker;
		this.tracker.auto('lineAdded', addMarkerToFirstLeaf, function () {
			items.forEach(function (item) {
				nextMarker = item.listMarker;
				self.processNode(item);
				addAll(node.positions, item.positions);
			});
		});

		this.writer.context().addMargin(-gapSize.width);

		function addMarkerToFirstLeaf(line) {
			// I'm not very happy with the way list processing is implemented
			// (both code and algorithm should be rethinked)
			if (nextMarker) {
				var marker = nextMarker;
				nextMarker = null;

				if (marker.canvas) {
					var vector = marker.canvas[0];

					offsetVector(vector, -marker._minWidth, 0);
					self.writer.addVector(vector);
				} else if (marker._inlines) {
					var markerLine = new Line(self.pageSize.width);
					markerLine.addInline(marker._inlines[0]);
					markerLine.x = -marker._minWidth;
					markerLine.y = line.getAscenderHeight() - markerLine.getAscenderHeight();
					self.writer.addLine(markerLine, true);
				}
			}
		}
	};

	// tables
	LayoutBuilder.prototype.processTable = function (tableNode) {
		var processor = new TableProcessor(tableNode);

		processor.beginTable(this.writer);

		for (var i = 0, l = tableNode.table.body.length; i < l; i++) {
			processor.beginRow(i, this.writer);

			var result = this.processRow(tableNode.table.body[i], tableNode.table.widths, tableNode._offsets.offsets, tableNode.table.body, i);
			addAll(tableNode.positions, result.positions);

			processor.endRow(i, this.writer, result.pageBreaks);
		}

		processor.endTable(this.writer);
	};

	// leafs (texts)
	LayoutBuilder.prototype.processLeaf = function (node) {
		var line = this.buildNextLine(node);
		var currentHeight = (line) ? line.getHeight() : 0;
		var maxHeight = node.maxHeight || -1;

		if (node._tocItemRef) {
			line._tocItemNode = node._tocItemRef;
		}

		while (line && (maxHeight === -1 || currentHeight < maxHeight)) {
			var positions = this.writer.addLine(line);
			node.positions.push(positions);
			line = this.buildNextLine(node);
			if (line) {
				currentHeight += line.getHeight();
			}
		}
	};

	LayoutBuilder.prototype.processToc = function (node) {
		if (node.toc.title) {
			this.processNode(node.toc.title);
		}
		this.processNode(node.toc._table);
	};

	LayoutBuilder.prototype.buildNextLine = function (textNode) {

		function cloneInline(inline) {
			var newInline = inline.constructor();
			for (var key in inline) {
				newInline[key] = inline[key];
			}
			return newInline;
		}

		if (!textNode._inlines || textNode._inlines.length === 0) {
			return null;
		}

		var line = new Line(this.writer.context().availableWidth);
		var textTools = new TextTools(null);

		while (textNode._inlines && textNode._inlines.length > 0 && line.hasEnoughSpaceForInline(textNode._inlines[0])) {
			var inline = textNode._inlines.shift();

			if (!inline.noWrap && inline.text.length > 1 && inline.width > line.maxWidth) {
				var widthPerChar = inline.width / inline.text.length;
				var maxChars = Math.floor(line.maxWidth / widthPerChar);
				if (maxChars < 1) {
					maxChars = 1;
				}
				if (maxChars < inline.text.length) {
					var newInline = cloneInline(inline);

					newInline.text = inline.text.substr(maxChars);
					inline.text = inline.text.substr(0, maxChars);

					newInline.width = textTools.widthOfString(newInline.text, newInline.font, newInline.fontSize, newInline.characterSpacing);
					inline.width = textTools.widthOfString(inline.text, inline.font, inline.fontSize, inline.characterSpacing);

					textNode._inlines.unshift(newInline);
				}
			}

			line.addInline(inline);
		}

		line.lastLineInParagraph = textNode._inlines.length === 0;

		return line;
	};

	// images
	LayoutBuilder.prototype.processImage = function (node) {
		var position = this.writer.addImage(node);
		node.positions.push(position);
	};

	LayoutBuilder.prototype.processCanvas = function (node) {
		var height = node._minHeight;

		if (this.writer.context().availableHeight < height) {
			// TODO: support for canvas larger than a page
			// TODO: support for other overflow methods

			this.writer.moveToNextPage();
		}

		node.canvas.forEach(function (vector) {
			var position = this.writer.addVector(vector);
			node.positions.push(position);
		}, this);

		this.writer.context().moveDown(height);
	};

	LayoutBuilder.prototype.processQr = function (node) {
		var position = this.writer.addQr(node);
		node.positions.push(position);
	};

	module.exports = LayoutBuilder;


/***/ }),
/* 11 */
/***/ (function(module, exports) {

	/* jslint node: true */
	'use strict';

	/**
	 * Creates an instance of TraversalTracker
	 *
	 * @constructor
	 */
	function TraversalTracker() {
		this.events = {};
	}

	TraversalTracker.prototype.startTracking = function (event, cb) {
		var callbacks = (this.events[event] || (this.events[event] = []));

		if (callbacks.indexOf(cb) < 0) {
			callbacks.push(cb);
		}
	};

	TraversalTracker.prototype.stopTracking = function (event, cb) {
		var callbacks = this.events[event];

		if (callbacks) {
			var index = callbacks.indexOf(cb);
			if (index >= 0) {
				callbacks.splice(index, 1);
			}
		}
	};

	TraversalTracker.prototype.emit = function (event) {
		var args = Array.prototype.slice.call(arguments, 1);

		var callbacks = this.events[event];

		if (callbacks) {
			callbacks.forEach(function (cb) {
				cb.apply(this, args);
			});
		}
	};

	TraversalTracker.prototype.auto = function (event, cb, innerBlock) {
		this.startTracking(event, cb);
		innerBlock();
		this.stopTracking(event, cb);
	};

	module.exports = TraversalTracker;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	/* jslint node: true */
	'use strict';

	var fontStringify = __webpack_require__(13).fontStringify;

	function DocPreprocessor() {

	}

	DocPreprocessor.prototype.preprocessDocument = function (docStructure) {
		this.tocs = [];
		return this.preprocessNode(docStructure);
	};

	DocPreprocessor.prototype.preprocessNode = function (node) {
		// expand shortcuts and casting values
		if (Array.isArray(node)) {
			node = {stack: node};
		} else if (typeof node === 'string' || node instanceof String) {
			node = {text: node};
		} else if (typeof node === 'number' || typeof node === 'boolean') {
			node = {text: node.toString()};
		} else if (node === null) {
			node = {text: ''};
		} else if (Object.keys(node).length === 0) { // empty object
			node = {text: ''};
		}

		if (node.columns) {
			return this.preprocessColumns(node);
		} else if (node.stack) {
			return this.preprocessVerticalContainer(node);
		} else if (node.ul) {
			return this.preprocessList(node);
		} else if (node.ol) {
			return this.preprocessList(node);
		} else if (node.table) {
			return this.preprocessTable(node);
		} else if (node.text !== undefined) {
			return this.preprocessText(node);
		} else if (node.toc) {
			return this.preprocessToc(node);
		} else if (node.image) {
			return this.preprocessImage(node);
		} else if (node.canvas) {
			return this.preprocessCanvas(node);
		} else if (node.qr) {
			return this.preprocessQr(node);
		} else {
			throw 'Unrecognized document structure: ' + JSON.stringify(node, fontStringify);
		}
	};

	DocPreprocessor.prototype.preprocessColumns = function (node) {
		var columns = node.columns;

		for (var i = 0, l = columns.length; i < l; i++) {
			columns[i] = this.preprocessNode(columns[i]);
		}

		return node;
	};

	DocPreprocessor.prototype.preprocessVerticalContainer = function (node) {
		var items = node.stack;

		for (var i = 0, l = items.length; i < l; i++) {
			items[i] = this.preprocessNode(items[i]);
		}

		return node;
	};

	DocPreprocessor.prototype.preprocessList = function (node) {
		var items = node.ul || node.ol;

		for (var i = 0, l = items.length; i < l; i++) {
			items[i] = this.preprocessNode(items[i]);
		}

		return node;
	};

	DocPreprocessor.prototype.preprocessTable = function (node) {
		var col, row, cols, rows;

		for (col = 0, cols = node.table.body[0].length; col < cols; col++) {
			for (row = 0, rows = node.table.body.length; row < rows; row++) {
				var rowData = node.table.body[row];
				var data = rowData[col];
				if (data !== undefined) {
					if (data === null) { // transform to object
						data = '';
					}
					if (!data._span) {
						rowData[col] = this.preprocessNode(data);
					}
				}
			}
		}

		return node;
	};

	DocPreprocessor.prototype.preprocessText = function (node) {
		if (node.tocItem) {
			if (!Array.isArray(node.tocItem)) {
				node.tocItem = [node.tocItem];
			}

			for (var i = 0, l = node.tocItem.length; i < l; i++) {
				if (!(typeof node.tocItem[i] === 'string' || node.tocItem[i] instanceof String)) {
					node.tocItem[i] = '_default_';
				}

				var tocItemId = node.tocItem[i];

				if (!this.tocs[tocItemId]) {
					this.tocs[tocItemId] = {toc: {_items: [], _pseudo: true}};
				}

				this.tocs[tocItemId].toc._items.push(node);
			}
		}

		if (node.text && node.text.text) {
			node.text = [this.preprocessNode(node.text)];
		}

		return node;
	};

	DocPreprocessor.prototype.preprocessToc = function (node) {
		if (!node.toc.id) {
			node.toc.id = '_default_';
		}

		node.toc.title = node.toc.title ? this.preprocessNode(node.toc.title) : null;
		node.toc._items = [];

		if (this.tocs[node.toc.id]) {
			if (!this.tocs[node.toc.id].toc._pseudo) {
				throw "TOC '" + node.toc.id + "' already exists";
			}

			node.toc._items = this.tocs[node.toc.id].toc._items;
		}

		this.tocs[node.toc.id] = node;

		return node;
	};

	DocPreprocessor.prototype.preprocessImage = function (node) {
		return node;
	};

	DocPreprocessor.prototype.preprocessCanvas = function (node) {
		return node;
	};

	DocPreprocessor.prototype.preprocessQr = function (node) {
		return node;
	};

	module.exports = DocPreprocessor;

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	/* jslint node: true */
	'use strict';

	function pack() {
		var result = {};

		for (var i = 0, l = arguments.length; i < l; i++) {
			var obj = arguments[i];

			if (obj) {
				for (var key in obj) {
					if (obj.hasOwnProperty(key)) {
						result[key] = obj[key];
					}
				}
			}
		}

		return result;
	}

	function offsetVector(vector, x, y) {
		switch (vector.type) {
			case 'ellipse':
			case 'rect':
				vector.x += x;
				vector.y += y;
				break;
			case 'line':
				vector.x1 += x;
				vector.x2 += x;
				vector.y1 += y;
				vector.y2 += y;
				break;
			case 'polyline':
				for (var i = 0, l = vector.points.length; i < l; i++) {
					vector.points[i].x += x;
					vector.points[i].y += y;
				}
				break;
		}
	}

	function fontStringify(key, val) {
		if (key === 'font') {
			return 'font';
		}
		return val;
	}

	function isFunction(functionToCheck) {
		var getType = {};
		return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	}


	module.exports = {
		pack: pack,
		fontStringify: fontStringify,
		offsetVector: offsetVector,
		isFunction: isFunction
	};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	/* jslint node: true */
	'use strict';

	var TextTools = __webpack_require__(15);
	var StyleContextStack = __webpack_require__(22);
	var ColumnCalculator = __webpack_require__(23);
	var fontStringify = __webpack_require__(13).fontStringify;
	var pack = __webpack_require__(13).pack;
	var qrEncoder = __webpack_require__(24);

	/**
	 * @private
	 */
	function DocMeasure(fontProvider, styleDictionary, defaultStyle, imageMeasure, tableLayouts, images) {
		this.textTools = new TextTools(fontProvider);
		this.styleStack = new StyleContextStack(styleDictionary, defaultStyle);
		this.imageMeasure = imageMeasure;
		this.tableLayouts = tableLayouts;
		this.images = images;
		this.autoImageIndex = 1;
	}

	/**
	 * Measures all nodes and sets min/max-width properties required for the second
	 * layout-pass.
	 * @param  {Object} docStructure document-definition-object
	 * @return {Object}              document-measurement-object
	 */
	DocMeasure.prototype.measureDocument = function (docStructure) {
		return this.measureNode(docStructure);
	};

	DocMeasure.prototype.measureNode = function (node) {

		var self = this;

		return this.styleStack.auto(node, function () {
			// TODO: refactor + rethink whether this is the proper way to handle margins
			node._margin = getNodeMargin(node);

			if (node.columns) {
				return extendMargins(self.measureColumns(node));
			} else if (node.stack) {
				return extendMargins(self.measureVerticalContainer(node));
			} else if (node.ul) {
				return extendMargins(self.measureUnorderedList(node));
			} else if (node.ol) {
				return extendMargins(self.measureOrderedList(node));
			} else if (node.table) {
				return extendMargins(self.measureTable(node));
			} else if (node.text !== undefined) {
				return extendMargins(self.measureLeaf(node));
			} else if (node.toc) {
				return extendMargins(self.measureToc(node));
			} else if (node.image) {
				return extendMargins(self.measureImage(node));
			} else if (node.canvas) {
				return extendMargins(self.measureCanvas(node));
			} else if (node.qr) {
				return extendMargins(self.measureQr(node));
			} else {
				throw 'Unrecognized document structure: ' + JSON.stringify(node, fontStringify);
			}
		});

		function extendMargins(node) {
			var margin = node._margin;

			if (margin) {
				node._minWidth += margin[0] + margin[2];
				node._maxWidth += margin[0] + margin[2];
			}

			return node;
		}

		function getNodeMargin() {

			function processSingleMargins(node, currentMargin) {
				if (node.marginLeft || node.marginTop || node.marginRight || node.marginBottom) {
					return [
						node.marginLeft || currentMargin[0] || 0,
						node.marginTop || currentMargin[1] || 0,
						node.marginRight || currentMargin[2] || 0,
						node.marginBottom || currentMargin[3] || 0
					];
				}
				return currentMargin;
			}

			function flattenStyleArray(styleArray) {
				var flattenedStyles = {};
				for (var i = styleArray.length - 1; i >= 0; i--) {
					var styleName = styleArray[i];
					var style = self.styleStack.styleDictionary[styleName];
					for (var key in style) {
						if (style.hasOwnProperty(key)) {
							flattenedStyles[key] = style[key];
						}
					}
				}
				return flattenedStyles;
			}

			function convertMargin(margin) {
				if (typeof margin === 'number' || margin instanceof Number) {
					margin = [margin, margin, margin, margin];
				} else if (Array.isArray(margin)) {
					if (margin.length === 2) {
						margin = [margin[0], margin[1], margin[0], margin[1]];
					}
				}
				return margin;
			}

			var margin = [undefined, undefined, undefined, undefined];

			if (node.style) {
				var styleArray = (Array.isArray(node.style)) ? node.style : [node.style];
				var flattenedStyleArray = flattenStyleArray(styleArray);

				if (flattenedStyleArray) {
					margin = processSingleMargins(flattenedStyleArray, margin);
				}

				if (flattenedStyleArray.margin) {
					margin = convertMargin(flattenedStyleArray.margin);
				}
			}

			margin = processSingleMargins(node, margin);

			if (node.margin) {
				margin = convertMargin(node.margin);
			}

			if (margin[0] === undefined && margin[1] === undefined && margin[2] === undefined && margin[3] === undefined) {
				return null;
			} else {
				return margin;
			}
		}
	};

	DocMeasure.prototype.convertIfBase64Image = function (node) {
		if (/^data:image\/(jpeg|jpg|png);base64,/.test(node.image)) {
			var label = '$$pdfmake$$' + this.autoImageIndex++;
			this.images[label] = node.image;
			node.image = label;
		}
	};

	DocMeasure.prototype.measureImage = function (node) {
		if (this.images) {
			this.convertIfBase64Image(node);
		}

		var imageSize = this.imageMeasure.measureImage(node.image);

		if (node.fit) {
			var factor = (imageSize.width / imageSize.height > node.fit[0] / node.fit[1]) ? node.fit[0] / imageSize.width : node.fit[1] / imageSize.height;
			node._width = node._minWidth = node._maxWidth = imageSize.width * factor;
			node._height = imageSize.height * factor;
		} else {
			node._width = node._minWidth = node._maxWidth = node.width || imageSize.width;
			node._height = node.height || (imageSize.height * node._width / imageSize.width);

			if (typeof node.maxWidth === "number" && node.maxWidth < node._width) {
				node._width = node._minWidth = node._maxWidth = node.maxWidth;
				node._height = node._width * imageSize.height / imageSize.width;
			}

			if (typeof node.maxHeight === "number" && node.maxHeight < node._height) {
				node._height = node.maxHeight;
				node._width = node._minWidth = node._maxWidth = node._height * imageSize.width / imageSize.height;
			}

			if (typeof node.minWidth === "number" && node.minWidth > node._width) {
				node._width = node._minWidth = node._maxWidth = node.minWidth;
				node._height = node._width * imageSize.height / imageSize.width;
			}

			if (typeof node.minHeight === "number" && node.minHeight > node._height) {
				node._height = node.minHeight;
				node._width = node._minWidth = node._maxWidth = node._height * imageSize.width / imageSize.height;
			}
		}

		node._alignment = this.styleStack.getProperty('alignment');
		return node;
	};

	DocMeasure.prototype.measureLeaf = function (node) {

		// Make sure style properties of the node itself are considered when building inlines.
		// We could also just pass [node] to buildInlines, but that fails for bullet points.
		var styleStack = this.styleStack.clone();
		styleStack.push(node);

		var data = this.textTools.buildInlines(node.text, styleStack);

		node._inlines = data.items;
		node._minWidth = data.minWidth;
		node._maxWidth = data.maxWidth;

		return node;
	};

	DocMeasure.prototype.measureToc = function (node) {
		if (node.toc.title) {
			node.toc.title = this.measureNode(node.toc.title);
		}

		var body = [];
		var textStyle = node.toc.textStyle || {};
		var numberStyle = node.toc.numberStyle || textStyle;
		var textMargin = node.toc.textMargin || [0, 0, 0, 0];
		for (var i = 0, l = node.toc._items.length; i < l; i++) {
			var item = node.toc._items[i];
			var lineStyle = node.toc._items[i].tocStyle || textStyle;
			var lineMargin = node.toc._items[i].tocMargin || textMargin;
			body.push([
				{text: item.text, alignment: 'left', style: lineStyle, margin: lineMargin},
				{text: '00000', alignment: 'right', _tocItemRef: item, style: numberStyle, margin: [0, lineMargin[1], 0, lineMargin[3]]}
			]);
		}


		node.toc._table = {
			table: {
				dontBreakRows: true,
				widths: ['*', 'auto'],
				body: body
			},
			layout: 'noBorders'
		};

		node.toc._table = this.measureNode(node.toc._table);

		return node;
	};

	DocMeasure.prototype.measureVerticalContainer = function (node) {
		var items = node.stack;

		node._minWidth = 0;
		node._maxWidth = 0;

		for (var i = 0, l = items.length; i < l; i++) {
			items[i] = this.measureNode(items[i]);

			node._minWidth = Math.max(node._minWidth, items[i]._minWidth);
			node._maxWidth = Math.max(node._maxWidth, items[i]._maxWidth);
		}

		return node;
	};

	DocMeasure.prototype.gapSizeForList = function () {
		return this.textTools.sizeOfString('9. ', this.styleStack);
	};

	DocMeasure.prototype.buildUnorderedMarker = function (styleStack, gapSize, type) {
		function buildDisc(gapSize, color) {
			// TODO: ascender-based calculations
			var radius = gapSize.fontSize / 6;
			return {
				canvas: [{
						x: radius,
						y: (gapSize.height / gapSize.lineHeight) + gapSize.descender - gapSize.fontSize / 3,
						r1: radius,
						r2: radius,
						type: 'ellipse',
						color: color
					}]
			};
		}

		function buildSquare(gapSize, color) {
			// TODO: ascender-based calculations
			var size = gapSize.fontSize / 3;
			return {
				canvas: [{
						x: 0,
						y: (gapSize.height / gapSize.lineHeight) + gapSize.descender - (gapSize.fontSize / 3) - (size / 2),
						h: size,
						w: size,
						type: 'rect',
						color: color
					}]
			};
		}

		function buildCircle(gapSize, color) {
			// TODO: ascender-based calculations
			var radius = gapSize.fontSize / 6;
			return {
				canvas: [{
						x: radius,
						y: (gapSize.height / gapSize.lineHeight) + gapSize.descender - gapSize.fontSize / 3,
						r1: radius,
						r2: radius,
						type: 'ellipse',
						lineColor: color
					}]
			};
		}

		var marker;
		var color = styleStack.getProperty('markerColor') || styleStack.getProperty('color') || 'black';

		switch (type) {
			case 'circle':
				marker = buildCircle(gapSize, color);
				break;

			case 'square':
				marker = buildSquare(gapSize, color);
				break;

			case 'none':
				marker = {};
				break;

			case 'disc':
			default:
				marker = buildDisc(gapSize, color);
				break;
		}

		marker._minWidth = marker._maxWidth = gapSize.width;
		marker._minHeight = marker._maxHeight = gapSize.height;

		return marker;
	};

	DocMeasure.prototype.buildOrderedMarker = function (counter, styleStack, type, separator) {
		function prepareAlpha(counter) {
			function toAlpha(num) {
				return (num >= 26 ? toAlpha((num / 26 >> 0) - 1) : '') + 'abcdefghijklmnopqrstuvwxyz'[num % 26 >> 0];
			}

			if (counter < 1) {
				return counter.toString();
			}

			return toAlpha(counter - 1);
		}

		function prepareRoman(counter) {
			if (counter < 1 || counter > 4999) {
				return counter.toString();
			}
			var num = counter;
			var lookup = {M: 1000, CM: 900, D: 500, CD: 400, C: 100, XC: 90, L: 50, XL: 40, X: 10, IX: 9, V: 5, IV: 4, I: 1}, roman = '', i;
			for (i in lookup) {
				while (num >= lookup[i]) {
					roman += i;
					num -= lookup[i];
				}
			}
			return roman;
		}

		function prepareDecimal(counter) {
			return counter.toString();
		}

		var counterText;
		switch (type) {
			case 'none':
				counterText = null;
				break;

			case 'upper-alpha':
				counterText = prepareAlpha(counter).toUpperCase();
				break;

			case 'lower-alpha':
				counterText = prepareAlpha(counter);
				break;

			case 'upper-roman':
				counterText = prepareRoman(counter);
				break;

			case 'lower-roman':
				counterText = prepareRoman(counter).toLowerCase();
				break;

			case 'decimal':
			default:
				counterText = prepareDecimal(counter);
				break;
		}

		if (counterText === null) {
			return {};
		}

		if (separator) {
			if (Array.isArray(separator)) {
				if (separator[0]) {
					counterText = separator[0] + counterText;
				}

				if (separator[1]) {
					counterText += separator[1];
				}
				counterText += ' ';
			} else {
				counterText += separator + ' ';
			}
		}

		var textArray = {text: counterText};
		var markerColor = styleStack.getProperty('markerColor');
		if (markerColor) {
			textArray.color = markerColor;
		}

		return {_inlines: this.textTools.buildInlines(textArray, styleStack).items};
	};

	DocMeasure.prototype.measureUnorderedList = function (node) {
		var style = this.styleStack.clone();
		var items = node.ul;
		node.type = node.type || 'disc';
		node._gapSize = this.gapSizeForList();
		node._minWidth = 0;
		node._maxWidth = 0;

		for (var i = 0, l = items.length; i < l; i++) {
			var item = items[i] = this.measureNode(items[i]);

			if (!item.ol && !item.ul) {
				item.listMarker = this.buildUnorderedMarker(style, node._gapSize, item.listType || node.type);
			}

			node._minWidth = Math.max(node._minWidth, items[i]._minWidth + node._gapSize.width);
			node._maxWidth = Math.max(node._maxWidth, items[i]._maxWidth + node._gapSize.width);
		}

		return node;
	};

	DocMeasure.prototype.measureOrderedList = function (node) {
		var style = this.styleStack.clone();
		var items = node.ol;
		node.type = node.type || 'decimal';
		node.separator = node.separator || '.';
		node.reversed = node.reversed || false;
		if (!node.start) {
			node.start = node.reversed ? items.length : 1;
		}
		node._gapSize = this.gapSizeForList();
		node._minWidth = 0;
		node._maxWidth = 0;

		var counter = node.start;
		for (var i = 0, l = items.length; i < l; i++) {
			var item = items[i] = this.measureNode(items[i]);

			if (!item.ol && !item.ul) {
				item.listMarker = this.buildOrderedMarker(item.counter || counter, style, item.listType || node.type, node.separator);
				if (item.listMarker._inlines) {
					node._gapSize.width = Math.max(node._gapSize.width, item.listMarker._inlines[0].width);
				}
			}  // TODO: else - nested lists numbering

			node._minWidth = Math.max(node._minWidth, items[i]._minWidth);
			node._maxWidth = Math.max(node._maxWidth, items[i]._maxWidth);

			if (node.reversed) {
				counter--;
			} else {
				counter++;
			}
		}

		node._minWidth += node._gapSize.width;
		node._maxWidth += node._gapSize.width;

		for (var i = 0, l = items.length; i < l; i++) {
			var item = items[i];
			if (!item.ol && !item.ul) {
				item.listMarker._minWidth = item.listMarker._maxWidth = node._gapSize.width;
			}
		}

		return node;
	};

	DocMeasure.prototype.measureColumns = function (node) {
		var columns = node.columns;
		node._gap = this.styleStack.getProperty('columnGap') || 0;

		for (var i = 0, l = columns.length; i < l; i++) {
			columns[i] = this.measureNode(columns[i]);
		}

		var measures = ColumnCalculator.measureMinMax(columns);

		var numGaps = (columns.length > 0) ? (columns.length - 1) : 0;
		node._minWidth = measures.min + node._gap * numGaps;
		node._maxWidth = measures.max + node._gap * numGaps;

		return node;
	};

	DocMeasure.prototype.measureTable = function (node) {
		extendTableWidths(node);
		node._layout = getLayout(this.tableLayouts);
		node._offsets = getOffsets(node._layout);

		var colSpans = [];
		var col, row, cols, rows;

		for (col = 0, cols = node.table.body[0].length; col < cols; col++) {
			var c = node.table.widths[col];
			c._minWidth = 0;
			c._maxWidth = 0;

			for (row = 0, rows = node.table.body.length; row < rows; row++) {
				var rowData = node.table.body[row];
				var data = rowData[col];
				if (data === undefined) {
					console.error('Malformed table row ', rowData, 'in node ', node);
					throw 'Malformed table row, a cell is undefined.';
				}
				if (data === null) { // transform to object
					data = '';
				}

				if (!data._span) {
					data = rowData[col] = this.styleStack.auto(data, measureCb(this, data));

					if (data.colSpan && data.colSpan > 1) {
						markSpans(rowData, col, data.colSpan);
						colSpans.push({col: col, span: data.colSpan, minWidth: data._minWidth, maxWidth: data._maxWidth});
					} else {
						c._minWidth = Math.max(c._minWidth, data._minWidth);
						c._maxWidth = Math.max(c._maxWidth, data._maxWidth);
					}
				}

				if (data.rowSpan && data.rowSpan > 1) {
					markVSpans(node.table, row, col, data.rowSpan);
				}
			}
		}

		extendWidthsForColSpans();

		var measures = ColumnCalculator.measureMinMax(node.table.widths);

		node._minWidth = measures.min + node._offsets.total;
		node._maxWidth = measures.max + node._offsets.total;

		return node;

		function measureCb(_this, data) {
			return function () {
				if (data !== null && typeof data === 'object') {
					data.fillColor = _this.styleStack.getProperty('fillColor');
				}
				return _this.measureNode(data);
			};
		}

		function getLayout(tableLayouts) {
			var layout = node.layout;

			if (typeof node.layout === 'string' || node instanceof String) {
				layout = tableLayouts[layout];
			}

			/*jshint unused: false */
			var defaultLayout = {
				hLineWidth: function (i, node) {
					return 1;
				},
				vLineWidth: function (i, node) {
					return 1;
				},
				hLineColor: function (i, node) {
					return 'black';
				},
				vLineColor: function (i, node) {
					return 'black';
				},
				paddingLeft: function (i, node) {
					return 4;
				},
				paddingRight: function (i, node) {
					return 4;
				},
				paddingTop: function (i, node) {
					return 2;
				},
				paddingBottom: function (i, node) {
					return 2;
				},
				fillColor: function (i, node) {
					return null;
				},
				defaultBorder: true
			};

			return pack(defaultLayout, layout);
		}

		function getOffsets(layout) {
			var offsets = [];
			var totalOffset = 0;
			var prevRightPadding = 0;

			for (var i = 0, l = node.table.widths.length; i < l; i++) {
				var lOffset = prevRightPadding + layout.vLineWidth(i, node) + layout.paddingLeft(i, node);
				offsets.push(lOffset);
				totalOffset += lOffset;
				prevRightPadding = layout.paddingRight(i, node);
			}

			totalOffset += prevRightPadding + layout.vLineWidth(node.table.widths.length, node);

			return {
				total: totalOffset,
				offsets: offsets
			};
		}

		function extendWidthsForColSpans() {
			var q, j;

			for (var i = 0, l = colSpans.length; i < l; i++) {
				var span = colSpans[i];

				var currentMinMax = getMinMax(span.col, span.span, node._offsets);
				var minDifference = span.minWidth - currentMinMax.minWidth;
				var maxDifference = span.maxWidth - currentMinMax.maxWidth;

				if (minDifference > 0) {
					q = minDifference / span.span;

					for (j = 0; j < span.span; j++) {
						node.table.widths[span.col + j]._minWidth += q;
					}
				}

				if (maxDifference > 0) {
					q = maxDifference / span.span;

					for (j = 0; j < span.span; j++) {
						node.table.widths[span.col + j]._maxWidth += q;
					}
				}
			}
		}

		function getMinMax(col, span, offsets) {
			var result = {minWidth: 0, maxWidth: 0};

			for (var i = 0; i < span; i++) {
				result.minWidth += node.table.widths[col + i]._minWidth + (i ? offsets.offsets[col + i] : 0);
				result.maxWidth += node.table.widths[col + i]._maxWidth + (i ? offsets.offsets[col + i] : 0);
			}

			return result;
		}

		function markSpans(rowData, col, span) {
			for (var i = 1; i < span; i++) {
				rowData[col + i] = {
					_span: true,
					_minWidth: 0,
					_maxWidth: 0,
					rowSpan: rowData[col].rowSpan
				};
			}
		}

		function markVSpans(table, row, col, span) {
			for (var i = 1; i < span; i++) {
				table.body[row + i][col] = {
					_span: true,
					_minWidth: 0,
					_maxWidth: 0,
					fillColor: table.body[row][col].fillColor
				};
			}
		}

		function extendTableWidths(node) {
			if (!node.table.widths) {
				node.table.widths = 'auto';
			}

			if (typeof node.table.widths === 'string' || node.table.widths instanceof String) {
				node.table.widths = [node.table.widths];

				while (node.table.widths.length < node.table.body[0].length) {
					node.table.widths.push(node.table.widths[node.table.widths.length - 1]);
				}
			}

			for (var i = 0, l = node.table.widths.length; i < l; i++) {
				var w = node.table.widths[i];
				if (typeof w === 'number' || w instanceof Number || typeof w === 'string' || w instanceof String) {
					node.table.widths[i] = {width: w};
				}
			}
		}
	};

	DocMeasure.prototype.measureCanvas = function (node) {
		var w = 0, h = 0;

		for (var i = 0, l = node.canvas.length; i < l; i++) {
			var vector = node.canvas[i];

			switch (vector.type) {
				case 'ellipse':
					w = Math.max(w, vector.x + vector.r1);
					h = Math.max(h, vector.y + vector.r2);
					break;
				case 'rect':
					w = Math.max(w, vector.x + vector.w);
					h = Math.max(h, vector.y + vector.h);
					break;
				case 'line':
					w = Math.max(w, vector.x1, vector.x2);
					h = Math.max(h, vector.y1, vector.y2);
					break;
				case 'polyline':
					for (var i2 = 0, l2 = vector.points.length; i2 < l2; i2++) {
						w = Math.max(w, vector.points[i2].x);
						h = Math.max(h, vector.points[i2].y);
					}
					break;
			}
		}

		node._minWidth = node._maxWidth = w;
		node._minHeight = node._maxHeight = h;

		return node;
	};

	DocMeasure.prototype.measureQr = function (node) {
		node = qrEncoder.measure(node);
		node._alignment = this.styleStack.getProperty('alignment');
		return node;
	};

	module.exports = DocMeasure;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	/* jslint node: true */
	'use strict';

	var LineBreaker = __webpack_require__(16);

	var LEADING = /^(\s)+/g;
	var TRAILING = /(\s)+$/g;

	/**
	 * Creates an instance of TextTools - text measurement utility
	 *
	 * @constructor
	 * @param {FontProvider} fontProvider
	 */
	function TextTools(fontProvider) {
		this.fontProvider = fontProvider;
	}

	/**
	 * Converts an array of strings (or inline-definition-objects) into a collection
	 * of inlines and calculated minWidth/maxWidth.
	 * and their min/max widths
	 * @param  {Object} textArray - an array of inline-definition-objects (or strings)
	 * @param  {Object} styleContextStack current style stack
	 * @return {Object}                   collection of inlines, minWidth, maxWidth
	 */
	TextTools.prototype.buildInlines = function (textArray, styleContextStack) {
		var measured = measure(this.fontProvider, textArray, styleContextStack);

		var minWidth = 0,
			maxWidth = 0,
			currentLineWidth;

		measured.forEach(function (inline) {
			minWidth = Math.max(minWidth, inline.width - inline.leadingCut - inline.trailingCut);

			if (!currentLineWidth) {
				currentLineWidth = {width: 0, leadingCut: inline.leadingCut, trailingCut: 0};
			}

			currentLineWidth.width += inline.width;
			currentLineWidth.trailingCut = inline.trailingCut;

			maxWidth = Math.max(maxWidth, getTrimmedWidth(currentLineWidth));

			if (inline.lineEnd) {
				currentLineWidth = null;
			}
		});

		if (getStyleProperty({}, styleContextStack, 'noWrap', false)) {
			minWidth = maxWidth;
		}

		return {
			items: measured,
			minWidth: minWidth,
			maxWidth: maxWidth
		};

		function getTrimmedWidth(item) {
			return Math.max(0, item.width - item.leadingCut - item.trailingCut);
		}
	};

	/**
	 * Returns size of the specified string (without breaking it) using the current style
	 * @param  {String} text              text to be measured
	 * @param  {Object} styleContextStack current style stack
	 * @return {Object}                   size of the specified string
	 */
	TextTools.prototype.sizeOfString = function (text, styleContextStack) {
		text = text ? text.toString().replace('\t', '    ') : '';

		//TODO: refactor - extract from measure
		var fontName = getStyleProperty({}, styleContextStack, 'font', 'Roboto');
		var fontSize = getStyleProperty({}, styleContextStack, 'fontSize', 12);
		var bold = getStyleProperty({}, styleContextStack, 'bold', false);
		var italics = getStyleProperty({}, styleContextStack, 'italics', false);
		var lineHeight = getStyleProperty({}, styleContextStack, 'lineHeight', 1);
		var characterSpacing = getStyleProperty({}, styleContextStack, 'characterSpacing', 0);

		var font = this.fontProvider.provideFont(fontName, bold, italics);

		return {
			width: widthOfString(text, font, fontSize, characterSpacing),
			height: font.lineHeight(fontSize) * lineHeight,
			fontSize: fontSize,
			lineHeight: lineHeight,
			ascender: font.ascender / 1000 * fontSize,
			descender: font.descender / 1000 * fontSize
		};
	};

	TextTools.prototype.widthOfString = function (text, font, fontSize, characterSpacing) {
		return widthOfString(text, font, fontSize, characterSpacing);
	};

	function splitWords(text, noWrap) {
		var results = [];
		text = text.replace('\t', '    ');

		if (noWrap) {
			results.push({text: text});
			return results;
		}

		var breaker = new LineBreaker(text);
		var last = 0;
		var bk;

		while (bk = breaker.nextBreak()) {
			var word = text.slice(last, bk.position);

			if (bk.required || word.match(/\r?\n$|\r$/)) { // new line
				word = word.replace(/\r?\n$|\r$/, '');
				results.push({text: word, lineEnd: true});
			} else {
				results.push({text: word});
			}

			last = bk.position;
		}

		return results;
	}

	function copyStyle(source, destination) {
		destination = destination || {};
		source = source || {}; //TODO: default style

		for (var key in source) {
			if (key != 'text' && source.hasOwnProperty(key)) {
				destination[key] = source[key];
			}
		}

		return destination;
	}

	function normalizeTextArray(array, styleContextStack) {
		function flatten(array) {
			return array.reduce(function (prev, cur) {
				var current = Array.isArray(cur.text) ? flatten(cur.text) : cur;
				var more = [].concat(current).some(Array.isArray);
				return prev.concat(more ? flatten(current) : current);
			}, []);
		}

		var results = [];

		if (!Array.isArray(array)) {
			array = [array];
		}

		array = flatten(array);

		for (var i = 0, l = array.length; i < l; i++) {
			var item = array[i];
			var style = null;
			var words;

			var noWrap = getStyleProperty(item || {}, styleContextStack, 'noWrap', false);
			if (item !== null && (typeof item === 'object' || item instanceof Object)) {
				words = splitWords(normalizeString(item.text), noWrap);
				style = copyStyle(item);
			} else {
				words = splitWords(normalizeString(item), noWrap);
			}

			for (var i2 = 0, l2 = words.length; i2 < l2; i2++) {
				var result = {
					text: words[i2].text
				};

				if (words[i2].lineEnd) {
					result.lineEnd = true;
				}

				copyStyle(style, result);

				results.push(result);
			}
		}

		return results;
	}

	function normalizeString(value) {
		if (value === undefined || value === null) {
			return '';
		} else if (typeof value === 'number') {
			return value.toString();
		} else if (typeof value === 'string' || value instanceof String) {
			return value;
		} else {
			return value.toString();
		}
	}

	function getStyleProperty(item, styleContextStack, property, defaultValue) {
		var value;

		if (item[property] !== undefined && item[property] !== null) {
			// item defines this property
			return item[property];
		}

		if (!styleContextStack) {
			return defaultValue;
		}

		styleContextStack.auto(item, function () {
			value = styleContextStack.getProperty(property);
		});

		if (value !== null && value !== undefined) {
			return value;
		} else {
			return defaultValue;
		}
	}

	function measure(fontProvider, textArray, styleContextStack) {
		var normalized = normalizeTextArray(textArray, styleContextStack);

		if (normalized.length) {
			var leadingIndent = getStyleProperty(normalized[0], styleContextStack, 'leadingIndent', 0);

			if (leadingIndent) {
				normalized[0].leadingCut = -leadingIndent;
				normalized[0].leadingIndent = leadingIndent;
			}
		}

		normalized.forEach(function (item) {
			var fontName = getStyleProperty(item, styleContextStack, 'font', 'Roboto');
			var fontSize = getStyleProperty(item, styleContextStack, 'fontSize', 12);
			var bold = getStyleProperty(item, styleContextStack, 'bold', false);
			var italics = getStyleProperty(item, styleContextStack, 'italics', false);
			var color = getStyleProperty(item, styleContextStack, 'color', 'black');
			var decoration = getStyleProperty(item, styleContextStack, 'decoration', null);
			var decorationColor = getStyleProperty(item, styleContextStack, 'decorationColor', null);
			var decorationStyle = getStyleProperty(item, styleContextStack, 'decorationStyle', null);
			var background = getStyleProperty(item, styleContextStack, 'background', null);
			var lineHeight = getStyleProperty(item, styleContextStack, 'lineHeight', 1);
			var characterSpacing = getStyleProperty(item, styleContextStack, 'characterSpacing', 0);
			var link = getStyleProperty(item, styleContextStack, 'link', null);
			var linkToPage = getStyleProperty(item, styleContextStack, 'linkToPage', null);
			var noWrap = getStyleProperty(item, styleContextStack, 'noWrap', null);
			var preserveLeadingSpaces = getStyleProperty(item, styleContextStack, 'preserveLeadingSpaces', false);

			var font = fontProvider.provideFont(fontName, bold, italics);

			item.width = widthOfString(item.text, font, fontSize, characterSpacing);
			item.height = font.lineHeight(fontSize) * lineHeight;

			var leadingSpaces = item.text.match(LEADING);

			if (!item.leadingCut) {
				item.leadingCut = 0;
			}

			if (leadingSpaces && !preserveLeadingSpaces) {
				item.leadingCut += widthOfString(leadingSpaces[0], font, fontSize, characterSpacing);
			}

			var trailingSpaces = item.text.match(TRAILING);
			if (trailingSpaces) {
				item.trailingCut = widthOfString(trailingSpaces[0], font, fontSize, characterSpacing);
			} else {
				item.trailingCut = 0;
			}

			item.alignment = getStyleProperty(item, styleContextStack, 'alignment', 'left');
			item.font = font;
			item.fontSize = fontSize;
			item.characterSpacing = characterSpacing;
			item.color = color;
			item.decoration = decoration;
			item.decorationColor = decorationColor;
			item.decorationStyle = decorationStyle;
			item.background = background;
			item.link = link;
			item.linkToPage = linkToPage;
			item.noWrap = noWrap;
		});

		return normalized;
	}

	function widthOfString(text, font, fontSize, characterSpacing) {
		return font.widthOfString(text, fontSize) + ((characterSpacing || 0) * (text.length - 1));
	}

	/****TESTS**** (add a leading '/' to uncomment)
	 TextTools.prototype.splitWords = splitWords;
	 TextTools.prototype.normalizeTextArray = normalizeTextArray;
	 TextTools.prototype.measure = measure;
	 // */


	module.exports = TextTools;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.7.1
	(function() {
	  var AI, AL, BA, BK, CB, CI_BRK, CJ, CP_BRK, CR, DI_BRK, ID, IN_BRK, LF, LineBreaker, NL, NS, PR_BRK, SA, SG, SP, UnicodeTrie, WJ, XX, base64, characterClasses, classTrie, data, fs, pairTable, _ref, _ref1;

	  UnicodeTrie = __webpack_require__(17);

	  

	  base64 = __webpack_require__(19);

	  _ref = __webpack_require__(20), BK = _ref.BK, CR = _ref.CR, LF = _ref.LF, NL = _ref.NL, CB = _ref.CB, BA = _ref.BA, SP = _ref.SP, WJ = _ref.WJ, SP = _ref.SP, BK = _ref.BK, LF = _ref.LF, NL = _ref.NL, AI = _ref.AI, AL = _ref.AL, SA = _ref.SA, SG = _ref.SG, XX = _ref.XX, CJ = _ref.CJ, ID = _ref.ID, NS = _ref.NS, characterClasses = _ref.characterClasses;

	  _ref1 = __webpack_require__(21), DI_BRK = _ref1.DI_BRK, IN_BRK = _ref1.IN_BRK, CI_BRK = _ref1.CI_BRK, CP_BRK = _ref1.CP_BRK, PR_BRK = _ref1.PR_BRK, pairTable = _ref1.pairTable;

	  data = base64.toByteArray("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");

	  classTrie = new UnicodeTrie(data);

	  LineBreaker = (function() {
	    var Break, mapClass, mapFirst;

	    function LineBreaker(string) {
	      this.string = string;
	      this.pos = 0;
	      this.lastPos = 0;
	      this.curClass = null;
	      this.nextClass = null;
	    }

	    LineBreaker.prototype.nextCodePoint = function() {
	      var code, next;
	      code = this.string.charCodeAt(this.pos++);
	      next = this.string.charCodeAt(this.pos);
	      if ((0xd800 <= code && code <= 0xdbff) && (0xdc00 <= next && next <= 0xdfff)) {
	        this.pos++;
	        return ((code - 0xd800) * 0x400) + (next - 0xdc00) + 0x10000;
	      }
	      return code;
	    };

	    mapClass = function(c) {
	      switch (c) {
	        case AI:
	          return AL;
	        case SA:
	        case SG:
	        case XX:
	          return AL;
	        case CJ:
	          return NS;
	        default:
	          return c;
	      }
	    };

	    mapFirst = function(c) {
	      switch (c) {
	        case LF:
	        case NL:
	          return BK;
	        case CB:
	          return BA;
	        case SP:
	          return WJ;
	        default:
	          return c;
	      }
	    };

	    LineBreaker.prototype.nextCharClass = function(first) {
	      if (first == null) {
	        first = false;
	      }
	      return mapClass(classTrie.get(this.nextCodePoint()));
	    };

	    Break = (function() {
	      function Break(position, required) {
	        this.position = position;
	        this.required = required != null ? required : false;
	      }

	      return Break;

	    })();

	    LineBreaker.prototype.nextBreak = function() {
	      var cur, lastClass, shouldBreak;
	      if (this.curClass == null) {
	        this.curClass = mapFirst(this.nextCharClass());
	      }
	      while (this.pos < this.string.length) {
	        this.lastPos = this.pos;
	        lastClass = this.nextClass;
	        this.nextClass = this.nextCharClass();
	        if (this.curClass === BK || (this.curClass === CR && this.nextClass !== LF)) {
	          this.curClass = mapFirst(mapClass(this.nextClass));
	          return new Break(this.lastPos, true);
	        }
	        cur = (function() {
	          switch (this.nextClass) {
	            case SP:
	              return this.curClass;
	            case BK:
	            case LF:
	            case NL:
	              return BK;
	            case CR:
	              return CR;
	            case CB:
	              return BA;
	          }
	        }).call(this);
	        if (cur != null) {
	          this.curClass = cur;
	          if (this.nextClass === CB) {
	            return new Break(this.lastPos);
	          }
	          continue;
	        }
	        shouldBreak = false;
	        switch (pairTable[this.curClass][this.nextClass]) {
	          case DI_BRK:
	            shouldBreak = true;
	            break;
	          case IN_BRK:
	            shouldBreak = lastClass === SP;
	            break;
	          case CI_BRK:
	            shouldBreak = lastClass === SP;
	            if (!shouldBreak) {
	              continue;
	            }
	            break;
	          case CP_BRK:
	            if (lastClass !== SP) {
	              continue;
	            }
	        }
	        this.curClass = this.nextClass;
	        if (shouldBreak) {
	          return new Break(this.lastPos);
	        }
	      }
	      if (this.pos >= this.string.length) {
	        if (this.lastPos < this.string.length) {
	          this.lastPos = this.string.length;
	          return new Break(this.string.length);
	        } else {
	          return null;
	        }
	      }
	    };

	    return LineBreaker;

	  })();

	  module.exports = LineBreaker;

	}).call(this);


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.7.1
	var UnicodeTrie, inflate;

	inflate = __webpack_require__(18);

	UnicodeTrie = (function() {
	  var DATA_BLOCK_LENGTH, DATA_GRANULARITY, DATA_MASK, INDEX_1_OFFSET, INDEX_2_BLOCK_LENGTH, INDEX_2_BMP_LENGTH, INDEX_2_MASK, INDEX_SHIFT, LSCP_INDEX_2_LENGTH, LSCP_INDEX_2_OFFSET, OMITTED_BMP_INDEX_1_LENGTH, SHIFT_1, SHIFT_1_2, SHIFT_2, UTF8_2B_INDEX_2_LENGTH, UTF8_2B_INDEX_2_OFFSET;

	  SHIFT_1 = 6 + 5;

	  SHIFT_2 = 5;

	  SHIFT_1_2 = SHIFT_1 - SHIFT_2;

	  OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> SHIFT_1;

	  INDEX_2_BLOCK_LENGTH = 1 << SHIFT_1_2;

	  INDEX_2_MASK = INDEX_2_BLOCK_LENGTH - 1;

	  INDEX_SHIFT = 2;

	  DATA_BLOCK_LENGTH = 1 << SHIFT_2;

	  DATA_MASK = DATA_BLOCK_LENGTH - 1;

	  LSCP_INDEX_2_OFFSET = 0x10000 >> SHIFT_2;

	  LSCP_INDEX_2_LENGTH = 0x400 >> SHIFT_2;

	  INDEX_2_BMP_LENGTH = LSCP_INDEX_2_OFFSET + LSCP_INDEX_2_LENGTH;

	  UTF8_2B_INDEX_2_OFFSET = INDEX_2_BMP_LENGTH;

	  UTF8_2B_INDEX_2_LENGTH = 0x800 >> 6;

	  INDEX_1_OFFSET = UTF8_2B_INDEX_2_OFFSET + UTF8_2B_INDEX_2_LENGTH;

	  DATA_GRANULARITY = 1 << INDEX_SHIFT;

	  function UnicodeTrie(data) {
	    var isBuffer, uncompressedLength, view;
	    isBuffer = typeof data.readUInt32BE === 'function' && typeof data.slice === 'function';
	    if (isBuffer || data instanceof Uint8Array) {
	      if (isBuffer) {
	        this.highStart = data.readUInt32BE(0);
	        this.errorValue = data.readUInt32BE(4);
	        uncompressedLength = data.readUInt32BE(8);
	        data = data.slice(12);
	      } else {
	        view = new DataView(data.buffer);
	        this.highStart = view.getUint32(0);
	        this.errorValue = view.getUint32(4);
	        uncompressedLength = view.getUint32(8);
	        data = data.subarray(12);
	      }
	      data = inflate(data, new Uint8Array(uncompressedLength));
	      data = inflate(data, new Uint8Array(uncompressedLength));
	      this.data = new Uint32Array(data.buffer);
	    } else {
	      this.data = data.data, this.highStart = data.highStart, this.errorValue = data.errorValue;
	    }
	  }

	  UnicodeTrie.prototype.get = function(codePoint) {
	    var index;
	    if (codePoint < 0 || codePoint > 0x10ffff) {
	      return this.errorValue;
	    }
	    if (codePoint < 0xd800 || (codePoint > 0xdbff && codePoint <= 0xffff)) {
	      index = (this.data[codePoint >> SHIFT_2] << INDEX_SHIFT) + (codePoint & DATA_MASK);
	      return this.data[index];
	    }
	    if (codePoint <= 0xffff) {
	      index = (this.data[LSCP_INDEX_2_OFFSET + ((codePoint - 0xd800) >> SHIFT_2)] << INDEX_SHIFT) + (codePoint & DATA_MASK);
	      return this.data[index];
	    }
	    if (codePoint < this.highStart) {
	      index = this.data[(INDEX_1_OFFSET - OMITTED_BMP_INDEX_1_LENGTH) + (codePoint >> SHIFT_1)];
	      index = this.data[index + ((codePoint >> SHIFT_2) & INDEX_2_MASK)];
	      index = (index << INDEX_SHIFT) + (codePoint & DATA_MASK);
	      return this.data[index];
	    }
	    return this.data[this.data.length - DATA_GRANULARITY];
	  };

	  return UnicodeTrie;

	})();

	module.exports = UnicodeTrie;


/***/ }),
/* 18 */
/***/ (function(module, exports) {

	var TINF_OK = 0;
	var TINF_DATA_ERROR = -3;

	function Tree() {
	  this.table = new Uint16Array(16);   /* table of code length counts */
	  this.trans = new Uint16Array(288);  /* code -> symbol translation table */
	}

	function Data(source, dest) {
	  this.source = source;
	  this.sourceIndex = 0;
	  this.tag = 0;
	  this.bitcount = 0;
	  
	  this.dest = dest;
	  this.destLen = 0;
	  
	  this.ltree = new Tree();  /* dynamic length/symbol tree */
	  this.dtree = new Tree();  /* dynamic distance tree */
	}

	/* --------------------------------------------------- *
	 * -- uninitialized global data (static structures) -- *
	 * --------------------------------------------------- */

	var sltree = new Tree();
	var sdtree = new Tree();

	/* extra bits and base tables for length codes */
	var length_bits = new Uint8Array(30);
	var length_base = new Uint16Array(30);

	/* extra bits and base tables for distance codes */
	var dist_bits = new Uint8Array(30);
	var dist_base = new Uint16Array(30);

	/* special ordering of code length codes */
	var clcidx = new Uint8Array([
	  16, 17, 18, 0, 8, 7, 9, 6,
	  10, 5, 11, 4, 12, 3, 13, 2,
	  14, 1, 15
	]);

	/* used by tinf_decode_trees, avoids allocations every call */
	var code_tree = new Tree();
	var lengths = new Uint8Array(288 + 32);

	/* ----------------------- *
	 * -- utility functions -- *
	 * ----------------------- */

	/* build extra bits and base tables */
	function tinf_build_bits_base(bits, base, delta, first) {
	  var i, sum;

	  /* build bits table */
	  for (i = 0; i < delta; ++i) bits[i] = 0;
	  for (i = 0; i < 30 - delta; ++i) bits[i + delta] = i / delta | 0;

	  /* build base table */
	  for (sum = first, i = 0; i < 30; ++i) {
	    base[i] = sum;
	    sum += 1 << bits[i];
	  }
	}

	/* build the fixed huffman trees */
	function tinf_build_fixed_trees(lt, dt) {
	  var i;

	  /* build fixed length tree */
	  for (i = 0; i < 7; ++i) lt.table[i] = 0;

	  lt.table[7] = 24;
	  lt.table[8] = 152;
	  lt.table[9] = 112;

	  for (i = 0; i < 24; ++i) lt.trans[i] = 256 + i;
	  for (i = 0; i < 144; ++i) lt.trans[24 + i] = i;
	  for (i = 0; i < 8; ++i) lt.trans[24 + 144 + i] = 280 + i;
	  for (i = 0; i < 112; ++i) lt.trans[24 + 144 + 8 + i] = 144 + i;

	  /* build fixed distance tree */
	  for (i = 0; i < 5; ++i) dt.table[i] = 0;

	  dt.table[5] = 32;

	  for (i = 0; i < 32; ++i) dt.trans[i] = i;
	}

	/* given an array of code lengths, build a tree */
	var offs = new Uint16Array(16);

	function tinf_build_tree(t, lengths, off, num) {
	  var i, sum;

	  /* clear code length count table */
	  for (i = 0; i < 16; ++i) t.table[i] = 0;

	  /* scan symbol lengths, and sum code length counts */
	  for (i = 0; i < num; ++i) t.table[lengths[off + i]]++;

	  t.table[0] = 0;

	  /* compute offset table for distribution sort */
	  for (sum = 0, i = 0; i < 16; ++i) {
	    offs[i] = sum;
	    sum += t.table[i];
	  }

	  /* create code->symbol translation table (symbols sorted by code) */
	  for (i = 0; i < num; ++i) {
	    if (lengths[off + i]) t.trans[offs[lengths[off + i]]++] = i;
	  }
	}

	/* ---------------------- *
	 * -- decode functions -- *
	 * ---------------------- */

	/* get one bit from source stream */
	function tinf_getbit(d) {
	  /* check if tag is empty */
	  if (!d.bitcount--) {
	    /* load next tag */
	    d.tag = d.source[d.sourceIndex++];
	    d.bitcount = 7;
	  }

	  /* shift bit out of tag */
	  var bit = d.tag & 1;
	  d.tag >>>= 1;

	  return bit;
	}

	/* read a num bit value from a stream and add base */
	function tinf_read_bits(d, num, base) {
	  if (!num)
	    return base;

	  while (d.bitcount < 24) {
	    d.tag |= d.source[d.sourceIndex++] << d.bitcount;
	    d.bitcount += 8;
	  }

	  var val = d.tag & (0xffff >>> (16 - num));
	  d.tag >>>= num;
	  d.bitcount -= num;
	  return val + base;
	}

	/* given a data stream and a tree, decode a symbol */
	function tinf_decode_symbol(d, t) {
	  while (d.bitcount < 24) {
	    d.tag |= d.source[d.sourceIndex++] << d.bitcount;
	    d.bitcount += 8;
	  }
	  
	  var sum = 0, cur = 0, len = 0;
	  var tag = d.tag;

	  /* get more bits while code value is above sum */
	  do {
	    cur = 2 * cur + (tag & 1);
	    tag >>>= 1;
	    ++len;

	    sum += t.table[len];
	    cur -= t.table[len];
	  } while (cur >= 0);
	  
	  d.tag = tag;
	  d.bitcount -= len;

	  return t.trans[sum + cur];
	}

	/* given a data stream, decode dynamic trees from it */
	function tinf_decode_trees(d, lt, dt) {
	  var hlit, hdist, hclen;
	  var i, num, length;

	  /* get 5 bits HLIT (257-286) */
	  hlit = tinf_read_bits(d, 5, 257);

	  /* get 5 bits HDIST (1-32) */
	  hdist = tinf_read_bits(d, 5, 1);

	  /* get 4 bits HCLEN (4-19) */
	  hclen = tinf_read_bits(d, 4, 4);

	  for (i = 0; i < 19; ++i) lengths[i] = 0;

	  /* read code lengths for code length alphabet */
	  for (i = 0; i < hclen; ++i) {
	    /* get 3 bits code length (0-7) */
	    var clen = tinf_read_bits(d, 3, 0);
	    lengths[clcidx[i]] = clen;
	  }

	  /* build code length tree */
	  tinf_build_tree(code_tree, lengths, 0, 19);

	  /* decode code lengths for the dynamic trees */
	  for (num = 0; num < hlit + hdist;) {
	    var sym = tinf_decode_symbol(d, code_tree);

	    switch (sym) {
	      case 16:
	        /* copy previous code length 3-6 times (read 2 bits) */
	        var prev = lengths[num - 1];
	        for (length = tinf_read_bits(d, 2, 3); length; --length) {
	          lengths[num++] = prev;
	        }
	        break;
	      case 17:
	        /* repeat code length 0 for 3-10 times (read 3 bits) */
	        for (length = tinf_read_bits(d, 3, 3); length; --length) {
	          lengths[num++] = 0;
	        }
	        break;
	      case 18:
	        /* repeat code length 0 for 11-138 times (read 7 bits) */
	        for (length = tinf_read_bits(d, 7, 11); length; --length) {
	          lengths[num++] = 0;
	        }
	        break;
	      default:
	        /* values 0-15 represent the actual code lengths */
	        lengths[num++] = sym;
	        break;
	    }
	  }

	  /* build dynamic trees */
	  tinf_build_tree(lt, lengths, 0, hlit);
	  tinf_build_tree(dt, lengths, hlit, hdist);
	}

	/* ----------------------------- *
	 * -- block inflate functions -- *
	 * ----------------------------- */

	/* given a stream and two trees, inflate a block of data */
	function tinf_inflate_block_data(d, lt, dt) {
	  while (1) {
	    var sym = tinf_decode_symbol(d, lt);

	    /* check for end of block */
	    if (sym === 256) {
	      return TINF_OK;
	    }

	    if (sym < 256) {
	      d.dest[d.destLen++] = sym;
	    } else {
	      var length, dist, offs;
	      var i;

	      sym -= 257;

	      /* possibly get more bits from length code */
	      length = tinf_read_bits(d, length_bits[sym], length_base[sym]);

	      dist = tinf_decode_symbol(d, dt);

	      /* possibly get more bits from distance code */
	      offs = d.destLen - tinf_read_bits(d, dist_bits[dist], dist_base[dist]);

	      /* copy match */
	      for (i = offs; i < offs + length; ++i) {
	        d.dest[d.destLen++] = d.dest[i];
	      }
	    }
	  }
	}

	/* inflate an uncompressed block of data */
	function tinf_inflate_uncompressed_block(d) {
	  var length, invlength;
	  var i;
	  
	  /* unread from bitbuffer */
	  while (d.bitcount > 8) {
	    d.sourceIndex--;
	    d.bitcount -= 8;
	  }

	  /* get length */
	  length = d.source[d.sourceIndex + 1];
	  length = 256 * length + d.source[d.sourceIndex];

	  /* get one's complement of length */
	  invlength = d.source[d.sourceIndex + 3];
	  invlength = 256 * invlength + d.source[d.sourceIndex + 2];

	  /* check length */
	  if (length !== (~invlength & 0x0000ffff))
	    return TINF_DATA_ERROR;

	  d.sourceIndex += 4;

	  /* copy block */
	  for (i = length; i; --i)
	    d.dest[d.destLen++] = d.source[d.sourceIndex++];

	  /* make sure we start next block on a byte boundary */
	  d.bitcount = 0;

	  return TINF_OK;
	}

	/* inflate stream from source to dest */
	function tinf_uncompress(source, dest) {
	  var d = new Data(source, dest);
	  var bfinal, btype, res;

	  do {
	    /* read final block flag */
	    bfinal = tinf_getbit(d);

	    /* read block type (2 bits) */
	    btype = tinf_read_bits(d, 2, 0);

	    /* decompress block */
	    switch (btype) {
	      case 0:
	        /* decompress uncompressed block */
	        res = tinf_inflate_uncompressed_block(d);
	        break;
	      case 1:
	        /* decompress block with fixed huffman trees */
	        res = tinf_inflate_block_data(d, sltree, sdtree);
	        break;
	      case 2:
	        /* decompress block with dynamic huffman trees */
	        tinf_decode_trees(d, d.ltree, d.dtree);
	        res = tinf_inflate_block_data(d, d.ltree, d.dtree);
	        break;
	      default:
	        res = TINF_DATA_ERROR;
	    }

	    if (res !== TINF_OK)
	      throw new Error('Data error');

	  } while (!bfinal);

	  if (d.destLen < d.dest.length) {
	    if (typeof d.dest.slice === 'function')
	      return d.dest.slice(0, d.destLen);
	    else
	      return d.dest.subarray(0, d.destLen);
	  }
	  
	  return d.dest;
	}

	/* -------------------- *
	 * -- initialization -- *
	 * -------------------- */

	/* build fixed huffman trees */
	tinf_build_fixed_trees(sltree, sdtree);

	/* build extra bits and base tables */
	tinf_build_bits_base(length_bits, length_base, 4, 3);
	tinf_build_bits_base(dist_bits, dist_base, 2, 1);

	/* fix a special case */
	length_bits[28] = 0;
	length_base[28] = 258;

	module.exports = tinf_uncompress;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var lookup = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

	;(function (exports) {
		'use strict';

	  var Arr = (typeof Uint8Array !== 'undefined')
	    ? Uint8Array
	    : Array

		var PLUS   = '+'.charCodeAt(0)
		var SLASH  = '/'.charCodeAt(0)
		var NUMBER = '0'.charCodeAt(0)
		var LOWER  = 'a'.charCodeAt(0)
		var UPPER  = 'A'.charCodeAt(0)
		var PLUS_URL_SAFE = '-'.charCodeAt(0)
		var SLASH_URL_SAFE = '_'.charCodeAt(0)

		function decode (elt) {
			var code = elt.charCodeAt(0)
			if (code === PLUS ||
			    code === PLUS_URL_SAFE)
				return 62 // '+'
			if (code === SLASH ||
			    code === SLASH_URL_SAFE)
				return 63 // '/'
			if (code < NUMBER)
				return -1 //no match
			if (code < NUMBER + 10)
				return code - NUMBER + 26 + 26
			if (code < UPPER + 26)
				return code - UPPER
			if (code < LOWER + 26)
				return code - LOWER + 26
		}

		function b64ToByteArray (b64) {
			var i, j, l, tmp, placeHolders, arr

			if (b64.length % 4 > 0) {
				throw new Error('Invalid string. Length must be a multiple of 4')
			}

			// the number of equal signs (place holders)
			// if there are two placeholders, than the two characters before it
			// represent one byte
			// if there is only one, then the three characters before it represent 2 bytes
			// this is just a cheap hack to not do indexOf twice
			var len = b64.length
			placeHolders = '=' === b64.charAt(len - 2) ? 2 : '=' === b64.charAt(len - 1) ? 1 : 0

			// base64 is 4/3 + up to two characters of the original data
			arr = new Arr(b64.length * 3 / 4 - placeHolders)

			// if there are placeholders, only get up to the last complete 4 chars
			l = placeHolders > 0 ? b64.length - 4 : b64.length

			var L = 0

			function push (v) {
				arr[L++] = v
			}

			for (i = 0, j = 0; i < l; i += 4, j += 3) {
				tmp = (decode(b64.charAt(i)) << 18) | (decode(b64.charAt(i + 1)) << 12) | (decode(b64.charAt(i + 2)) << 6) | decode(b64.charAt(i + 3))
				push((tmp & 0xFF0000) >> 16)
				push((tmp & 0xFF00) >> 8)
				push(tmp & 0xFF)
			}

			if (placeHolders === 2) {
				tmp = (decode(b64.charAt(i)) << 2) | (decode(b64.charAt(i + 1)) >> 4)
				push(tmp & 0xFF)
			} else if (placeHolders === 1) {
				tmp = (decode(b64.charAt(i)) << 10) | (decode(b64.charAt(i + 1)) << 4) | (decode(b64.charAt(i + 2)) >> 2)
				push((tmp >> 8) & 0xFF)
				push(tmp & 0xFF)
			}

			return arr
		}

		function uint8ToBase64 (uint8) {
			var i,
				extraBytes = uint8.length % 3, // if we have 1 byte left, pad 2 bytes
				output = "",
				temp, length

			function encode (num) {
				return lookup.charAt(num)
			}

			function tripletToBase64 (num) {
				return encode(num >> 18 & 0x3F) + encode(num >> 12 & 0x3F) + encode(num >> 6 & 0x3F) + encode(num & 0x3F)
			}

			// go through the array every three bytes, we'll deal with trailing stuff later
			for (i = 0, length = uint8.length - extraBytes; i < length; i += 3) {
				temp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
				output += tripletToBase64(temp)
			}

			// pad the end with zeros, but make sure to not forget the extra bytes
			switch (extraBytes) {
				case 1:
					temp = uint8[uint8.length - 1]
					output += encode(temp >> 2)
					output += encode((temp << 4) & 0x3F)
					output += '=='
					break
				case 2:
					temp = (uint8[uint8.length - 2] << 8) + (uint8[uint8.length - 1])
					output += encode(temp >> 10)
					output += encode((temp >> 4) & 0x3F)
					output += encode((temp << 2) & 0x3F)
					output += '='
					break
			}

			return output
		}

		exports.toByteArray = b64ToByteArray
		exports.fromByteArray = uint8ToBase64
	}( false ? (this.base64js = {}) : exports))


/***/ }),
/* 20 */
/***/ (function(module, exports) {

	// Generated by CoffeeScript 1.7.1
	(function() {
	  var AI, AL, B2, BA, BB, BK, CB, CJ, CL, CM, CP, CR, EX, GL, H2, H3, HL, HY, ID, IN, IS, JL, JT, JV, LF, NL, NS, NU, OP, PO, PR, QU, RI, SA, SG, SP, SY, WJ, XX, ZW;

	  exports.OP = OP = 0;

	  exports.CL = CL = 1;

	  exports.CP = CP = 2;

	  exports.QU = QU = 3;

	  exports.GL = GL = 4;

	  exports.NS = NS = 5;

	  exports.EX = EX = 6;

	  exports.SY = SY = 7;

	  exports.IS = IS = 8;

	  exports.PR = PR = 9;

	  exports.PO = PO = 10;

	  exports.NU = NU = 11;

	  exports.AL = AL = 12;

	  exports.HL = HL = 13;

	  exports.ID = ID = 14;

	  exports.IN = IN = 15;

	  exports.HY = HY = 16;

	  exports.BA = BA = 17;

	  exports.BB = BB = 18;

	  exports.B2 = B2 = 19;

	  exports.ZW = ZW = 20;

	  exports.CM = CM = 21;

	  exports.WJ = WJ = 22;

	  exports.H2 = H2 = 23;

	  exports.H3 = H3 = 24;

	  exports.JL = JL = 25;

	  exports.JV = JV = 26;

	  exports.JT = JT = 27;

	  exports.RI = RI = 28;

	  exports.AI = AI = 29;

	  exports.BK = BK = 30;

	  exports.CB = CB = 31;

	  exports.CJ = CJ = 32;

	  exports.CR = CR = 33;

	  exports.LF = LF = 34;

	  exports.NL = NL = 35;

	  exports.SA = SA = 36;

	  exports.SG = SG = 37;

	  exports.SP = SP = 38;

	  exports.XX = XX = 39;

	}).call(this);


/***/ }),
/* 21 */
/***/ (function(module, exports) {

	// Generated by CoffeeScript 1.7.1
	(function() {
	  var CI_BRK, CP_BRK, DI_BRK, IN_BRK, PR_BRK;

	  exports.DI_BRK = DI_BRK = 0;

	  exports.IN_BRK = IN_BRK = 1;

	  exports.CI_BRK = CI_BRK = 2;

	  exports.CP_BRK = CP_BRK = 3;

	  exports.PR_BRK = PR_BRK = 4;

	  exports.pairTable = [[PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, CP_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, CI_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK], [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, CI_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK], [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, DI_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, DI_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, CI_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, PR_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK], [IN_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, CI_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, IN_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, DI_BRK], [DI_BRK, PR_BRK, PR_BRK, IN_BRK, IN_BRK, IN_BRK, PR_BRK, PR_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK, IN_BRK, DI_BRK, DI_BRK, PR_BRK, CI_BRK, PR_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, DI_BRK, IN_BRK]];

	}).call(this);


/***/ }),
/* 22 */
/***/ (function(module, exports) {

	/* jslint node: true */
	'use strict';

	/**
	 * Creates an instance of StyleContextStack used for style inheritance and style overrides
	 *
	 * @constructor
	 * @this {StyleContextStack}
	 * @param {Object} named styles dictionary
	 * @param {Object} optional default style definition
	 */
	function StyleContextStack(styleDictionary, defaultStyle) {
		this.defaultStyle = defaultStyle || {};
		this.styleDictionary = styleDictionary;
		this.styleOverrides = [];
	}

	/**
	 * Creates cloned version of current stack
	 * @return {StyleContextStack} current stack snapshot
	 */
	StyleContextStack.prototype.clone = function () {
		var stack = new StyleContextStack(this.styleDictionary, this.defaultStyle);

		this.styleOverrides.forEach(function (item) {
			stack.styleOverrides.push(item);
		});

		return stack;
	};

	/**
	 * Pushes style-name or style-overrides-object onto the stack for future evaluation
	 *
	 * @param {String|Object} styleNameOrOverride style-name (referring to styleDictionary) or
	 *                                            a new dictionary defining overriding properties
	 */
	StyleContextStack.prototype.push = function (styleNameOrOverride) {
		this.styleOverrides.push(styleNameOrOverride);
	};

	/**
	 * Removes last style-name or style-overrides-object from the stack
	 *
	 * @param {Number} howMany - optional number of elements to be popped (if not specified,
	 *                           one element will be removed from the stack)
	 */
	StyleContextStack.prototype.pop = function (howMany) {
		howMany = howMany || 1;

		while (howMany-- > 0) {
			this.styleOverrides.pop();
		}
	};

	/**
	 * Creates a set of named styles or/and a style-overrides-object based on the item,
	 * pushes those elements onto the stack for future evaluation and returns the number
	 * of elements pushed, so they can be easily poped then.
	 *
	 * @param {Object} item - an object with optional style property and/or style overrides
	 * @return the number of items pushed onto the stack
	 */
	StyleContextStack.prototype.autopush = function (item) {
		if (typeof item === 'string' || item instanceof String) {
			return 0;
		}

		var styleNames = [];

		if (item.style) {
			if (Array.isArray(item.style)) {
				styleNames = item.style;
			} else {
				styleNames = [item.style];
			}
		}

		for (var i = 0, l = styleNames.length; i < l; i++) {
			this.push(styleNames[i]);
		}

		var styleOverrideObject = {};
		var pushSOO = false;

		[
			'font',
			'fontSize',
			'bold',
			'italics',
			'alignment',
			'color',
			'columnGap',
			'fillColor',
			'decoration',
			'decorationStyle',
			'decorationColor',
			'background',
			'lineHeight',
			'characterSpacing',
			'noWrap',
			'markerColor',
			'leadingIndent'
				//'tableCellPadding'
				// 'cellBorder',
				// 'headerCellBorder',
				// 'oddRowCellBorder',
				// 'evenRowCellBorder',
				// 'tableBorder'
		].forEach(function (key) {
			if (item[key] !== undefined && item[key] !== null) {
				styleOverrideObject[key] = item[key];
				pushSOO = true;
			}
		});

		if (pushSOO) {
			this.push(styleOverrideObject);
		}

		return styleNames.length + (pushSOO ? 1 : 0);
	};

	/**
	 * Automatically pushes elements onto the stack, using autopush based on item,
	 * executes callback and then pops elements back. Returns value returned by callback
	 *
	 * @param  {Object}   item - an object with optional style property and/or style overrides
	 * @param  {Function} function to be called between autopush and pop
	 * @return {Object} value returned by callback
	 */
	StyleContextStack.prototype.auto = function (item, callback) {
		var pushedItems = this.autopush(item);
		var result = callback();

		if (pushedItems > 0) {
			this.pop(pushedItems);
		}

		return result;
	};

	/**
	 * Evaluates stack and returns value of a named property
	 *
	 * @param {String} property - property name
	 * @return property value or null if not found
	 */
	StyleContextStack.prototype.getProperty = function (property) {
		if (this.styleOverrides) {
			for (var i = this.styleOverrides.length - 1; i >= 0; i--) {
				var item = this.styleOverrides[i];

				if (typeof item === 'string' || item instanceof String) {
					// named-style-override

					var style = this.styleDictionary[item];
					if (style && style[property] !== null && style[property] !== undefined) {
						return style[property];
					}
				} else {
					// style-overrides-object
					if (item[property] !== undefined && item[property] !== null) {
						return item[property];
					}
				}
			}
		}

		return this.defaultStyle && this.defaultStyle[property];
	};

	module.exports = StyleContextStack;


/***/ }),
/* 23 */
/***/ (function(module, exports) {

	/* jslint node: true */
	'use strict';

	function buildColumnWidths(columns, availableWidth) {
		var autoColumns = [],
			autoMin = 0, autoMax = 0,
			starColumns = [],
			starMaxMin = 0,
			starMaxMax = 0,
			fixedColumns = [],
			initial_availableWidth = availableWidth;

		columns.forEach(function (column) {
			if (isAutoColumn(column)) {
				autoColumns.push(column);
				autoMin += column._minWidth;
				autoMax += column._maxWidth;
			} else if (isStarColumn(column)) {
				starColumns.push(column);
				starMaxMin = Math.max(starMaxMin, column._minWidth);
				starMaxMax = Math.max(starMaxMax, column._maxWidth);
			} else {
				fixedColumns.push(column);
			}
		});

		fixedColumns.forEach(function (col) {
			// width specified as %
			if (typeof col.width === 'string' && /\d+%/.test(col.width)) {
				col.width = parseFloat(col.width) * initial_availableWidth / 100;
			}
			if (col.width < (col._minWidth) && col.elasticWidth) {
				col._calcWidth = col._minWidth;
			} else {
				col._calcWidth = col.width;
			}

			availableWidth -= col._calcWidth;
		});

		// http://www.freesoft.org/CIE/RFC/1942/18.htm
		// http://www.w3.org/TR/CSS2/tables.html#width-layout
		// http://dev.w3.org/csswg/css3-tables-algorithms/Overview.src.htm
		var minW = autoMin + starMaxMin * starColumns.length;
		var maxW = autoMax + starMaxMax * starColumns.length;
		if (minW >= availableWidth) {
			// case 1 - there's no way to fit all columns within available width
			// that's actually pretty bad situation with PDF as we have no horizontal scroll
			// no easy workaround (unless we decide, in the future, to split single words)
			// currently we simply use minWidths for all columns
			autoColumns.forEach(function (col) {
				col._calcWidth = col._minWidth;
			});

			starColumns.forEach(function (col) {
				col._calcWidth = starMaxMin; // starMaxMin already contains padding
			});
		} else {
			if (maxW < availableWidth) {
				// case 2 - we can fit rest of the table within available space
				autoColumns.forEach(function (col) {
					col._calcWidth = col._maxWidth;
					availableWidth -= col._calcWidth;
				});
			} else {
				// maxW is too large, but minW fits within available width
				var W = availableWidth - minW;
				var D = maxW - minW;

				autoColumns.forEach(function (col) {
					var d = col._maxWidth - col._minWidth;
					col._calcWidth = col._minWidth + d * W / D;
					availableWidth -= col._calcWidth;
				});
			}

			if (starColumns.length > 0) {
				var starSize = availableWidth / starColumns.length;

				starColumns.forEach(function (col) {
					col._calcWidth = starSize;
				});
			}
		}
	}

	function isAutoColumn(column) {
		return column.width === 'auto';
	}

	function isStarColumn(column) {
		return column.width === null || column.width === undefined || column.width === '*' || column.width === 'star';
	}

	//TODO: refactor and reuse in measureTable
	function measureMinMax(columns) {
		var result = {min: 0, max: 0};

		var maxStar = {min: 0, max: 0};
		var starCount = 0;

		for (var i = 0, l = columns.length; i < l; i++) {
			var c = columns[i];

			if (isStarColumn(c)) {
				maxStar.min = Math.max(maxStar.min, c._minWidth);
				maxStar.max = Math.max(maxStar.max, c._maxWidth);
				starCount++;
			} else if (isAutoColumn(c)) {
				result.min += c._minWidth;
				result.max += c._maxWidth;
			} else {
				result.min += ((c.width !== undefined && c.width) || c._minWidth);
				result.max += ((c.width !== undefined && c.width) || c._maxWidth);
			}
		}

		if (starCount) {
			result.min += starCount * maxStar.min;
			result.max += starCount * maxStar.max;
		}

		return result;
	}

	/**
	 * Calculates column widths
	 * @private
	 */
	module.exports = {
		buildColumnWidths: buildColumnWidths,
		measureMinMax: measureMinMax,
		isAutoColumn: isAutoColumn,
		isStarColumn: isStarColumn
	};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

	/* jslint node: true */
	'use strict';
	/*jshint -W004 */
	/* qr.js -- QR code generator in Javascript (revision 2011-01-19)
	 * Written by Kang Seonghoon <public+qrjs@mearie.org>.
	 *
	 * This source code is in the public domain; if your jurisdiction does not
	 * recognize the public domain the terms of Creative Commons CC0 license
	 * apply. In the other words, you can always do what you want.
	 */


	// per-version information (cf. JIS X 0510:2004 pp. 30--36, 71)
	//
	// [0]: the degree of generator polynomial by ECC levels
	// [1]: # of code blocks by ECC levels
	// [2]: left-top positions of alignment patterns
	//
	// the number in this table (in particular, [0]) does not exactly match with
	// the numbers in the specficiation. see augumenteccs below for the reason.
	var VERSIONS = [
		null,
		[[10, 7, 17, 13], [1, 1, 1, 1], []],
		[[16, 10, 28, 22], [1, 1, 1, 1], [4, 16]],
		[[26, 15, 22, 18], [1, 1, 2, 2], [4, 20]],
		[[18, 20, 16, 26], [2, 1, 4, 2], [4, 24]],
		[[24, 26, 22, 18], [2, 1, 4, 4], [4, 28]],
		[[16, 18, 28, 24], [4, 2, 4, 4], [4, 32]],
		[[18, 20, 26, 18], [4, 2, 5, 6], [4, 20, 36]],
		[[22, 24, 26, 22], [4, 2, 6, 6], [4, 22, 40]],
		[[22, 30, 24, 20], [5, 2, 8, 8], [4, 24, 44]],
		[[26, 18, 28, 24], [5, 4, 8, 8], [4, 26, 48]],
		[[30, 20, 24, 28], [5, 4, 11, 8], [4, 28, 52]],
		[[22, 24, 28, 26], [8, 4, 11, 10], [4, 30, 56]],
		[[22, 26, 22, 24], [9, 4, 16, 12], [4, 32, 60]],
		[[24, 30, 24, 20], [9, 4, 16, 16], [4, 24, 44, 64]],
		[[24, 22, 24, 30], [10, 6, 18, 12], [4, 24, 46, 68]],
		[[28, 24, 30, 24], [10, 6, 16, 17], [4, 24, 48, 72]],
		[[28, 28, 28, 28], [11, 6, 19, 16], [4, 28, 52, 76]],
		[[26, 30, 28, 28], [13, 6, 21, 18], [4, 28, 54, 80]],
		[[26, 28, 26, 26], [14, 7, 25, 21], [4, 28, 56, 84]],
		[[26, 28, 28, 30], [16, 8, 25, 20], [4, 32, 60, 88]],
		[[26, 28, 30, 28], [17, 8, 25, 23], [4, 26, 48, 70, 92]],
		[[28, 28, 24, 30], [17, 9, 34, 23], [4, 24, 48, 72, 96]],
		[[28, 30, 30, 30], [18, 9, 30, 25], [4, 28, 52, 76, 100]],
		[[28, 30, 30, 30], [20, 10, 32, 27], [4, 26, 52, 78, 104]],
		[[28, 26, 30, 30], [21, 12, 35, 29], [4, 30, 56, 82, 108]],
		[[28, 28, 30, 28], [23, 12, 37, 34], [4, 28, 56, 84, 112]],
		[[28, 30, 30, 30], [25, 12, 40, 34], [4, 32, 60, 88, 116]],
		[[28, 30, 30, 30], [26, 13, 42, 35], [4, 24, 48, 72, 96, 120]],
		[[28, 30, 30, 30], [28, 14, 45, 38], [4, 28, 52, 76, 100, 124]],
		[[28, 30, 30, 30], [29, 15, 48, 40], [4, 24, 50, 76, 102, 128]],
		[[28, 30, 30, 30], [31, 16, 51, 43], [4, 28, 54, 80, 106, 132]],
		[[28, 30, 30, 30], [33, 17, 54, 45], [4, 32, 58, 84, 110, 136]],
		[[28, 30, 30, 30], [35, 18, 57, 48], [4, 28, 56, 84, 112, 140]],
		[[28, 30, 30, 30], [37, 19, 60, 51], [4, 32, 60, 88, 116, 144]],
		[[28, 30, 30, 30], [38, 19, 63, 53], [4, 28, 52, 76, 100, 124, 148]],
		[[28, 30, 30, 30], [40, 20, 66, 56], [4, 22, 48, 74, 100, 126, 152]],
		[[28, 30, 30, 30], [43, 21, 70, 59], [4, 26, 52, 78, 104, 130, 156]],
		[[28, 30, 30, 30], [45, 22, 74, 62], [4, 30, 56, 82, 108, 134, 160]],
		[[28, 30, 30, 30], [47, 24, 77, 65], [4, 24, 52, 80, 108, 136, 164]],
		[[28, 30, 30, 30], [49, 25, 81, 68], [4, 28, 56, 84, 112, 140, 168]]];

	// mode constants (cf. Table 2 in JIS X 0510:2004 p. 16)
	var MODE_TERMINATOR = 0;
	var MODE_NUMERIC = 1, MODE_ALPHANUMERIC = 2, MODE_OCTET = 4, MODE_KANJI = 8;

	// validation regexps
	var NUMERIC_REGEXP = /^\d*$/;
	var ALPHANUMERIC_REGEXP = /^[A-Za-z0-9 $%*+\-./:]*$/;
	var ALPHANUMERIC_OUT_REGEXP = /^[A-Z0-9 $%*+\-./:]*$/;

	// ECC levels (cf. Table 22 in JIS X 0510:2004 p. 45)
	var ECCLEVEL_L = 1, ECCLEVEL_M = 0, ECCLEVEL_Q = 3, ECCLEVEL_H = 2;

	// GF(2^8)-to-integer mapping with a reducing polynomial x^8+x^4+x^3+x^2+1
	// invariant: GF256_MAP[GF256_INVMAP[i]] == i for all i in [1,256)
	var GF256_MAP = [], GF256_INVMAP = [-1];
	for (var i = 0, v = 1; i < 255; ++i) {
		GF256_MAP.push(v);
		GF256_INVMAP[v] = i;
		v = (v * 2) ^ (v >= 128 ? 0x11d : 0);
	}

	// generator polynomials up to degree 30
	// (should match with polynomials in JIS X 0510:2004 Appendix A)
	//
	// generator polynomial of degree K is product of (x-\alpha^0), (x-\alpha^1),
	// ..., (x-\alpha^(K-1)). by convention, we omit the K-th coefficient (always 1)
	// from the result; also other coefficients are written in terms of the exponent
	// to \alpha to avoid the redundant calculation. (see also calculateecc below.)
	var GF256_GENPOLY = [[]];
	for (var i = 0; i < 30; ++i) {
		var prevpoly = GF256_GENPOLY[i], poly = [];
		for (var j = 0; j <= i; ++j) {
			var a = (j < i ? GF256_MAP[prevpoly[j]] : 0);
			var b = GF256_MAP[(i + (prevpoly[j - 1] || 0)) % 255];
			poly.push(GF256_INVMAP[a ^ b]);
		}
		GF256_GENPOLY.push(poly);
	}

	// alphanumeric character mapping (cf. Table 5 in JIS X 0510:2004 p. 19)
	var ALPHANUMERIC_MAP = {};
	for (var i = 0; i < 45; ++i) {
		ALPHANUMERIC_MAP['0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:'.charAt(i)] = i;
	}

	// mask functions in terms of row # and column #
	// (cf. Table 20 in JIS X 0510:2004 p. 42)
	/*jshint unused: false */
	var MASKFUNCS = [
		function (i, j) {
			return (i + j) % 2 === 0;
		},
		function (i, j) {
			return i % 2 === 0;
		},
		function (i, j) {
			return j % 3 === 0;
		},
		function (i, j) {
			return (i + j) % 3 === 0;
		},
		function (i, j) {
			return (((i / 2) | 0) + ((j / 3) | 0)) % 2 === 0;
		},
		function (i, j) {
			return (i * j) % 2 + (i * j) % 3 === 0;
		},
		function (i, j) {
			return ((i * j) % 2 + (i * j) % 3) % 2 === 0;
		},
		function (i, j) {
			return ((i + j) % 2 + (i * j) % 3) % 2 === 0;
		}];

	// returns true when the version information has to be embeded.
	var needsverinfo = function (ver) {
		return ver > 6;
	};

	// returns the size of entire QR code for given version.
	var getsizebyver = function (ver) {
		return 4 * ver + 17;
	};

	// returns the number of bits available for code words in this version.
	var nfullbits = function (ver) {
		/*
		 * |<--------------- n --------------->|
		 * |        |<----- n-17 ---->|        |
		 * +-------+                ///+-------+ ----
		 * |       |                ///|       |    ^
		 * |  9x9  |       @@@@@    ///|  9x8  |    |
		 * |       | # # # @5x5@ # # # |       |    |
		 * +-------+       @@@@@       +-------+    |
		 *       #                               ---|
		 *                                        ^ |
		 *       #                                |
		 *     @@@@@       @@@@@       @@@@@      | n
		 *     @5x5@       @5x5@       @5x5@   n-17
		 *     @@@@@       @@@@@       @@@@@      | |
		 *       #                                | |
		 * //////                                 v |
		 * //////#                               ---|
		 * +-------+       @@@@@       @@@@@        |
		 * |       |       @5x5@       @5x5@        |
		 * |  8x9  |       @@@@@       @@@@@        |
		 * |       |                                v
		 * +-------+                             ----
		 *
		 * when the entire code has n^2 modules and there are m^2-3 alignment
		 * patterns, we have:
		 * - 225 (= 9x9 + 9x8 + 8x9) modules for finder patterns and
		 *   format information;
		 * - 2n-34 (= 2(n-17)) modules for timing patterns;
		 * - 36 (= 3x6 + 6x3) modules for version information, if any;
		 * - 25m^2-75 (= (m^2-3)(5x5)) modules for alignment patterns
		 *   if any, but 10m-20 (= 2(m-2)x5) of them overlaps with
		 *   timing patterns.
		 */
		var v = VERSIONS[ver];
		var nbits = 16 * ver * ver + 128 * ver + 64; // finder, timing and format info.
		if (needsverinfo(ver))
			nbits -= 36; // version information
		if (v[2].length) { // alignment patterns
			nbits -= 25 * v[2].length * v[2].length - 10 * v[2].length - 55;
		}
		return nbits;
	};

	// returns the number of bits available for data portions (i.e. excludes ECC
	// bits but includes mode and length bits) in this version and ECC level.
	var ndatabits = function (ver, ecclevel) {
		var nbits = nfullbits(ver) & ~7; // no sub-octet code words
		var v = VERSIONS[ver];
		nbits -= 8 * v[0][ecclevel] * v[1][ecclevel]; // ecc bits
		return nbits;
	};

	// returns the number of bits required for the length of data.
	// (cf. Table 3 in JIS X 0510:2004 p. 16)
	var ndatalenbits = function (ver, mode) {
		switch (mode) {
			case MODE_NUMERIC:
				return (ver < 10 ? 10 : ver < 27 ? 12 : 14);
			case MODE_ALPHANUMERIC:
				return (ver < 10 ? 9 : ver < 27 ? 11 : 13);
			case MODE_OCTET:
				return (ver < 10 ? 8 : 16);
			case MODE_KANJI:
				return (ver < 10 ? 8 : ver < 27 ? 10 : 12);
		}
	};

	// returns the maximum length of data possible in given configuration.
	var getmaxdatalen = function (ver, mode, ecclevel) {
		var nbits = ndatabits(ver, ecclevel) - 4 - ndatalenbits(ver, mode); // 4 for mode bits
		switch (mode) {
			case MODE_NUMERIC:
				return ((nbits / 10) | 0) * 3 + (nbits % 10 < 4 ? 0 : nbits % 10 < 7 ? 1 : 2);
			case MODE_ALPHANUMERIC:
				return ((nbits / 11) | 0) * 2 + (nbits % 11 < 6 ? 0 : 1);
			case MODE_OCTET:
				return (nbits / 8) | 0;
			case MODE_KANJI:
				return (nbits / 13) | 0;
		}
	};

	// checks if the given data can be encoded in given mode, and returns
	// the converted data for the further processing if possible. otherwise
	// returns null.
	//
	// this function does not check the length of data; it is a duty of
	// encode function below (as it depends on the version and ECC level too).
	var validatedata = function (mode, data) {
		switch (mode) {
			case MODE_NUMERIC:
				if (!data.match(NUMERIC_REGEXP))
					return null;
				return data;

			case MODE_ALPHANUMERIC:
				if (!data.match(ALPHANUMERIC_REGEXP))
					return null;
				return data.toUpperCase();

			case MODE_OCTET:
				if (typeof data === 'string') { // encode as utf-8 string
					var newdata = [];
					for (var i = 0; i < data.length; ++i) {
						var ch = data.charCodeAt(i);
						if (ch < 0x80) {
							newdata.push(ch);
						} else if (ch < 0x800) {
							newdata.push(0xc0 | (ch >> 6),
								0x80 | (ch & 0x3f));
						} else if (ch < 0x10000) {
							newdata.push(0xe0 | (ch >> 12),
								0x80 | ((ch >> 6) & 0x3f),
								0x80 | (ch & 0x3f));
						} else {
							newdata.push(0xf0 | (ch >> 18),
								0x80 | ((ch >> 12) & 0x3f),
								0x80 | ((ch >> 6) & 0x3f),
								0x80 | (ch & 0x3f));
						}
					}
					return newdata;
				} else {
					return data;
				}
		}
	};

	// returns the code words (sans ECC bits) for given data and configurations.
	// requires data to be preprocessed by validatedata. no length check is
	// performed, and everything has to be checked before calling this function.
	var encode = function (ver, mode, data, maxbuflen) {
		var buf = [];
		var bits = 0, remaining = 8;
		var datalen = data.length;

		// this function is intentionally no-op when n=0.
		var pack = function (x, n) {
			if (n >= remaining) {
				buf.push(bits | (x >> (n -= remaining)));
				while (n >= 8)
					buf.push((x >> (n -= 8)) & 255);
				bits = 0;
				remaining = 8;
			}
			if (n > 0)
				bits |= (x & ((1 << n) - 1)) << (remaining -= n);
		};

		var nlenbits = ndatalenbits(ver, mode);
		pack(mode, 4);
		pack(datalen, nlenbits);

		switch (mode) {
			case MODE_NUMERIC:
				for (var i = 2; i < datalen; i += 3) {
					pack(parseInt(data.substring(i - 2, i + 1), 10), 10);
				}
				pack(parseInt(data.substring(i - 2), 10), [0, 4, 7][datalen % 3]);
				break;

			case MODE_ALPHANUMERIC:
				for (var i = 1; i < datalen; i += 2) {
					pack(ALPHANUMERIC_MAP[data.charAt(i - 1)] * 45 +
						ALPHANUMERIC_MAP[data.charAt(i)], 11);
				}
				if (datalen % 2 == 1) {
					pack(ALPHANUMERIC_MAP[data.charAt(i - 1)], 6);
				}
				break;

			case MODE_OCTET:
				for (var i = 0; i < datalen; ++i) {
					pack(data[i], 8);
				}
				break;
		}

		// final bits. it is possible that adding terminator causes the buffer
		// to overflow, but then the buffer truncated to the maximum size will
		// be valid as the truncated terminator mode bits and padding is
		// identical in appearance (cf. JIS X 0510:2004 sec 8.4.8).
		pack(MODE_TERMINATOR, 4);
		if (remaining < 8)
			buf.push(bits);

		// the padding to fill up the remaining space. we should not add any
		// words when the overflow already occurred.
		while (buf.length + 1 < maxbuflen)
			buf.push(0xec, 0x11);
		if (buf.length < maxbuflen)
			buf.push(0xec);
		return buf;
	};

	// calculates ECC code words for given code words and generator polynomial.
	//
	// this is quite similar to CRC calculation as both Reed-Solomon and CRC use
	// the certain kind of cyclic codes, which is effectively the division of
	// zero-augumented polynomial by the generator polynomial. the only difference
	// is that Reed-Solomon uses GF(2^8), instead of CRC's GF(2), and Reed-Solomon
	// uses the different generator polynomial than CRC's.
	var calculateecc = function (poly, genpoly) {
		var modulus = poly.slice(0);
		var polylen = poly.length, genpolylen = genpoly.length;
		for (var i = 0; i < genpolylen; ++i)
			modulus.push(0);
		for (var i = 0; i < polylen; ) {
			var quotient = GF256_INVMAP[modulus[i++]];
			if (quotient >= 0) {
				for (var j = 0; j < genpolylen; ++j) {
					modulus[i + j] ^= GF256_MAP[(quotient + genpoly[j]) % 255];
				}
			}
		}
		return modulus.slice(polylen);
	};

	// auguments ECC code words to given code words. the resulting words are
	// ready to be encoded in the matrix.
	//
	// the much of actual augumenting procedure follows JIS X 0510:2004 sec 8.7.
	// the code is simplified using the fact that the size of each code & ECC
	// blocks is almost same; for example, when we have 4 blocks and 46 data words
	// the number of code words in those blocks are 11, 11, 12, 12 respectively.
	var augumenteccs = function (poly, nblocks, genpoly) {
		var subsizes = [];
		var subsize = (poly.length / nblocks) | 0, subsize0 = 0;
		var pivot = nblocks - poly.length % nblocks;
		for (var i = 0; i < pivot; ++i) {
			subsizes.push(subsize0);
			subsize0 += subsize;
		}
		for (var i = pivot; i < nblocks; ++i) {
			subsizes.push(subsize0);
			subsize0 += subsize + 1;
		}
		subsizes.push(subsize0);

		var eccs = [];
		for (var i = 0; i < nblocks; ++i) {
			eccs.push(calculateecc(poly.slice(subsizes[i], subsizes[i + 1]), genpoly));
		}

		var result = [];
		var nitemsperblock = (poly.length / nblocks) | 0;
		for (var i = 0; i < nitemsperblock; ++i) {
			for (var j = 0; j < nblocks; ++j) {
				result.push(poly[subsizes[j] + i]);
			}
		}
		for (var j = pivot; j < nblocks; ++j) {
			result.push(poly[subsizes[j + 1] - 1]);
		}
		for (var i = 0; i < genpoly.length; ++i) {
			for (var j = 0; j < nblocks; ++j) {
				result.push(eccs[j][i]);
			}
		}
		return result;
	};

	// auguments BCH(p+q,q) code to the polynomial over GF(2), given the proper
	// genpoly. the both input and output are in binary numbers, and unlike
	// calculateecc genpoly should include the 1 bit for the highest degree.
	//
	// actual polynomials used for this procedure are as follows:
	// - p=10, q=5, genpoly=x^10+x^8+x^5+x^4+x^2+x+1 (JIS X 0510:2004 Appendix C)
	// - p=18, q=6, genpoly=x^12+x^11+x^10+x^9+x^8+x^5+x^2+1 (ibid. Appendix D)
	var augumentbch = function (poly, p, genpoly, q) {
		var modulus = poly << q;
		for (var i = p - 1; i >= 0; --i) {
			if ((modulus >> (q + i)) & 1)
				modulus ^= genpoly << i;
		}
		return (poly << q) | modulus;
	};

	// creates the base matrix for given version. it returns two matrices, one of
	// them is the actual one and the another represents the "reserved" portion
	// (e.g. finder and timing patterns) of the matrix.
	//
	// some entries in the matrix may be undefined, rather than 0 or 1. this is
	// intentional (no initialization needed!), and putdata below will fill
	// the remaining ones.
	var makebasematrix = function (ver) {
		var v = VERSIONS[ver], n = getsizebyver(ver);
		var matrix = [], reserved = [];
		for (var i = 0; i < n; ++i) {
			matrix.push([]);
			reserved.push([]);
		}

		var blit = function (y, x, h, w, bits) {
			for (var i = 0; i < h; ++i) {
				for (var j = 0; j < w; ++j) {
					matrix[y + i][x + j] = (bits[i] >> j) & 1;
					reserved[y + i][x + j] = 1;
				}
			}
		};

		// finder patterns and a part of timing patterns
		// will also mark the format information area (not yet written) as reserved.
		blit(0, 0, 9, 9, [0x7f, 0x41, 0x5d, 0x5d, 0x5d, 0x41, 0x17f, 0x00, 0x40]);
		blit(n - 8, 0, 8, 9, [0x100, 0x7f, 0x41, 0x5d, 0x5d, 0x5d, 0x41, 0x7f]);
		blit(0, n - 8, 9, 8, [0xfe, 0x82, 0xba, 0xba, 0xba, 0x82, 0xfe, 0x00, 0x00]);

		// the rest of timing patterns
		for (var i = 9; i < n - 8; ++i) {
			matrix[6][i] = matrix[i][6] = ~i & 1;
			reserved[6][i] = reserved[i][6] = 1;
		}

		// alignment patterns
		var aligns = v[2], m = aligns.length;
		for (var i = 0; i < m; ++i) {
			var minj = (i === 0 || i === m - 1 ? 1 : 0), maxj = (i === 0 ? m - 1 : m);
			for (var j = minj; j < maxj; ++j) {
				blit(aligns[i], aligns[j], 5, 5, [0x1f, 0x11, 0x15, 0x11, 0x1f]);
			}
		}

		// version information
		if (needsverinfo(ver)) {
			var code = augumentbch(ver, 6, 0x1f25, 12);
			var k = 0;
			for (var i = 0; i < 6; ++i) {
				for (var j = 0; j < 3; ++j) {
					matrix[i][(n - 11) + j] = matrix[(n - 11) + j][i] = (code >> k++) & 1;
					reserved[i][(n - 11) + j] = reserved[(n - 11) + j][i] = 1;
				}
			}
		}

		return {matrix: matrix, reserved: reserved};
	};

	// fills the data portion (i.e. unmarked in reserved) of the matrix with given
	// code words. the size of code words should be no more than available bits,
	// and remaining bits are padded to 0 (cf. JIS X 0510:2004 sec 8.7.3).
	var putdata = function (matrix, reserved, buf) {
		var n = matrix.length;
		var k = 0, dir = -1;
		for (var i = n - 1; i >= 0; i -= 2) {
			if (i == 6)
				--i; // skip the entire timing pattern column
			var jj = (dir < 0 ? n - 1 : 0);
			for (var j = 0; j < n; ++j) {
				for (var ii = i; ii > i - 2; --ii) {
					if (!reserved[jj][ii]) {
						// may overflow, but (undefined >> x)
						// is 0 so it will auto-pad to zero.
						matrix[jj][ii] = (buf[k >> 3] >> (~k & 7)) & 1;
						++k;
					}
				}
				jj += dir;
			}
			dir = -dir;
		}
		return matrix;
	};

	// XOR-masks the data portion of the matrix. repeating the call with the same
	// arguments will revert the prior call (convenient in the matrix evaluation).
	var maskdata = function (matrix, reserved, mask) {
		var maskf = MASKFUNCS[mask];
		var n = matrix.length;
		for (var i = 0; i < n; ++i) {
			for (var j = 0; j < n; ++j) {
				if (!reserved[i][j])
					matrix[i][j] ^= maskf(i, j);
			}
		}
		return matrix;
	};

	// puts the format information.
	var putformatinfo = function (matrix, reserved, ecclevel, mask) {
		var n = matrix.length;
		var code = augumentbch((ecclevel << 3) | mask, 5, 0x537, 10) ^ 0x5412;
		for (var i = 0; i < 15; ++i) {
			var r = [0, 1, 2, 3, 4, 5, 7, 8, n - 7, n - 6, n - 5, n - 4, n - 3, n - 2, n - 1][i];
			var c = [n - 1, n - 2, n - 3, n - 4, n - 5, n - 6, n - 7, n - 8, 7, 5, 4, 3, 2, 1, 0][i];
			matrix[r][8] = matrix[8][c] = (code >> i) & 1;
			// we don't have to mark those bits reserved; always done
			// in makebasematrix above.
		}
		return matrix;
	};

	// evaluates the resulting matrix and returns the score (lower is better).
	// (cf. JIS X 0510:2004 sec 8.8.2)
	//
	// the evaluation procedure tries to avoid the problematic patterns naturally
	// occuring from the original matrix. for example, it penaltizes the patterns
	// which just look like the finder pattern which will confuse the decoder.
	// we choose the mask which results in the lowest score among 8 possible ones.
	//
	// note: zxing seems to use the same procedure and in many cases its choice
	// agrees to ours, but sometimes it does not. practically it doesn't matter.
	var evaluatematrix = function (matrix) {
		// N1+(k-5) points for each consecutive row of k same-colored modules,
		// where k >= 5. no overlapping row counts.
		var PENALTY_CONSECUTIVE = 3;
		// N2 points for each 2x2 block of same-colored modules.
		// overlapping block does count.
		var PENALTY_TWOBYTWO = 3;
		// N3 points for each pattern with >4W:1B:1W:3B:1W:1B or
		// 1B:1W:3B:1W:1B:>4W, or their multiples (e.g. highly unlikely,
		// but 13W:3B:3W:9B:3W:3B counts).
		var PENALTY_FINDERLIKE = 40;
		// N4*k points for every (5*k)% deviation from 50% black density.
		// i.e. k=1 for 55~60% and 40~45%, k=2 for 60~65% and 35~40%, etc.
		var PENALTY_DENSITY = 10;

		var evaluategroup = function (groups) { // assumes [W,B,W,B,W,...,B,W]
			var score = 0;
			for (var i = 0; i < groups.length; ++i) {
				if (groups[i] >= 5)
					score += PENALTY_CONSECUTIVE + (groups[i] - 5);
			}
			for (var i = 5; i < groups.length; i += 2) {
				var p = groups[i];
				if (groups[i - 1] == p && groups[i - 2] == 3 * p && groups[i - 3] == p &&
					groups[i - 4] == p && (groups[i - 5] >= 4 * p || groups[i + 1] >= 4 * p)) {
					// this part differs from zxing...
					score += PENALTY_FINDERLIKE;
				}
			}
			return score;
		};

		var n = matrix.length;
		var score = 0, nblacks = 0;
		for (var i = 0; i < n; ++i) {
			var row = matrix[i];
			var groups;

			// evaluate the current row
			groups = [0]; // the first empty group of white
			for (var j = 0; j < n; ) {
				var k;
				for (k = 0; j < n && row[j]; ++k)
					++j;
				groups.push(k);
				for (k = 0; j < n && !row[j]; ++k)
					++j;
				groups.push(k);
			}
			score += evaluategroup(groups);

			// evaluate the current column
			groups = [0];
			for (var j = 0; j < n; ) {
				var k;
				for (k = 0; j < n && matrix[j][i]; ++k)
					++j;
				groups.push(k);
				for (k = 0; j < n && !matrix[j][i]; ++k)
					++j;
				groups.push(k);
			}
			score += evaluategroup(groups);

			// check the 2x2 box and calculate the density
			var nextrow = matrix[i + 1] || [];
			nblacks += row[0];
			for (var j = 1; j < n; ++j) {
				var p = row[j];
				nblacks += p;
				// at least comparison with next row should be strict...
				if (row[j - 1] == p && nextrow[j] === p && nextrow[j - 1] === p) {
					score += PENALTY_TWOBYTWO;
				}
			}
		}

		score += PENALTY_DENSITY * ((Math.abs(nblacks / n / n - 0.5) / 0.05) | 0);
		return score;
	};

	// returns the fully encoded QR code matrix which contains given data.
	// it also chooses the best mask automatically when mask is -1.
	var generate = function (data, ver, mode, ecclevel, mask) {
		var v = VERSIONS[ver];
		var buf = encode(ver, mode, data, ndatabits(ver, ecclevel) >> 3);
		buf = augumenteccs(buf, v[1][ecclevel], GF256_GENPOLY[v[0][ecclevel]]);

		var result = makebasematrix(ver);
		var matrix = result.matrix, reserved = result.reserved;
		putdata(matrix, reserved, buf);

		if (mask < 0) {
			// find the best mask
			maskdata(matrix, reserved, 0);
			putformatinfo(matrix, reserved, ecclevel, 0);
			var bestmask = 0, bestscore = evaluatematrix(matrix);
			maskdata(matrix, reserved, 0);
			for (mask = 1; mask < 8; ++mask) {
				maskdata(matrix, reserved, mask);
				putformatinfo(matrix, reserved, ecclevel, mask);
				var score = evaluatematrix(matrix);
				if (bestscore > score) {
					bestscore = score;
					bestmask = mask;
				}
				maskdata(matrix, reserved, mask);
			}
			mask = bestmask;
		}

		maskdata(matrix, reserved, mask);
		putformatinfo(matrix, reserved, ecclevel, mask);
		return matrix;
	};

	// the public interface is trivial; the options available are as follows:
	//
	// - version: an integer in [1,40]. when omitted (or -1) the smallest possible
	//   version is chosen.
	// - mode: one of 'numeric', 'alphanumeric', 'octet'. when omitted the smallest
	//   possible mode is chosen.
	// - eccLevel: one of 'L', 'M', 'Q', 'H'. defaults to 'L'.
	// - mask: an integer in [0,7]. when omitted (or -1) the best mask is chosen.
	//

	function generateFrame(data, options) {
		var MODES = {'numeric': MODE_NUMERIC, 'alphanumeric': MODE_ALPHANUMERIC,
			'octet': MODE_OCTET};
		var ECCLEVELS = {'L': ECCLEVEL_L, 'M': ECCLEVEL_M, 'Q': ECCLEVEL_Q,
			'H': ECCLEVEL_H};

		options = options || {};
		var ver = options.version || -1;
		var ecclevel = ECCLEVELS[(options.eccLevel || 'L').toUpperCase()];
		var mode = options.mode ? MODES[options.mode.toLowerCase()] : -1;
		var mask = 'mask' in options ? options.mask : -1;

		if (mode < 0) {
			if (typeof data === 'string') {
				if (data.match(NUMERIC_REGEXP)) {
					mode = MODE_NUMERIC;
				} else if (data.match(ALPHANUMERIC_OUT_REGEXP)) {
					// while encode supports case-insensitive encoding, we restrict the data to be uppercased when auto-selecting the mode.
					mode = MODE_ALPHANUMERIC;
				} else {
					mode = MODE_OCTET;
				}
			} else {
				mode = MODE_OCTET;
			}
		} else if (!(mode == MODE_NUMERIC || mode == MODE_ALPHANUMERIC ||
			mode == MODE_OCTET)) {
			throw 'invalid or unsupported mode';
		}

		data = validatedata(mode, data);
		if (data === null)
			throw 'invalid data format';

		if (ecclevel < 0 || ecclevel > 3)
			throw 'invalid ECC level';

		if (ver < 0) {
			for (ver = 1; ver <= 40; ++ver) {
				if (data.length <= getmaxdatalen(ver, mode, ecclevel))
					break;
			}
			if (ver > 40)
				throw 'too large data for the Qr format';
		} else if (ver < 1 || ver > 40) {
			throw 'invalid Qr version! should be between 1 and 40';
		}

		if (mask != -1 && (mask < 0 || mask > 8))
			throw 'invalid mask';
		//console.log('version:', ver, 'mode:', mode, 'ECC:', ecclevel, 'mask:', mask )
		return generate(data, ver, mode, ecclevel, mask);
	}


	// options
	// - modulesize: a number. this is a size of each modules in pixels, and
	//   defaults to 5px.
	// - margin: a number. this is a size of margin in *modules*, and defaults to
	//   4 (white modules). the specficiation mandates the margin no less than 4
	//   modules, so it is better not to alter this value unless you know what
	//   you're doing.
	function buildCanvas(data, options) {

		var canvas = [];
		var background = options.background || '#fff';
		var foreground = options.foreground || '#000';
		//var margin = options.margin || 4;
		var matrix = generateFrame(data, options);
		var n = matrix.length;
		var modSize = Math.floor(options.fit ? options.fit / n : 5);
		var size = n * modSize;

		canvas.push({
			type: 'rect',
			x: 0, y: 0, w: size, h: size, lineWidth: 0, color: background
		});

		for (var i = 0; i < n; ++i) {
			for (var j = 0; j < n; ++j) {
				if (matrix[i][j]) {
					canvas.push({
						type: 'rect',
						x: modSize * j,
						y: modSize * i,
						w: modSize,
						h: modSize,
						lineWidth: 0,
						color: foreground
					});
				}
			}
		}

		return {
			canvas: canvas,
			size: size
		};

	}

	function measure(node) {
		var cd = buildCanvas(node.qr, node);
		node._canvas = cd.canvas;
		node._width = node._height = node._minWidth = node._maxWidth = node._minHeight = node._maxHeight = cd.size;
		return node;
	}

	module.exports = {
		measure: measure
	};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	/* jslint node: true */
	'use strict';

	var TraversalTracker = __webpack_require__(11);

	/**
	 * Creates an instance of DocumentContext - a store for current x, y positions and available width/height.
	 * It facilitates column divisions and vertical sync
	 */
	function DocumentContext(pageSize, pageMargins) {
		this.pages = [];

		this.pageMargins = pageMargins;

		this.x = pageMargins.left;
		this.availableWidth = pageSize.width - pageMargins.left - pageMargins.right;
		this.availableHeight = 0;
		this.page = -1;

		this.snapshots = [];

		this.endingCell = null;

		this.tracker = new TraversalTracker();

		this.addPage(pageSize);
	}

	DocumentContext.prototype.beginColumnGroup = function () {
		this.snapshots.push({
			x: this.x,
			y: this.y,
			availableHeight: this.availableHeight,
			availableWidth: this.availableWidth,
			page: this.page,
			bottomMost: {
				x: this.x,
				y: this.y,
				availableHeight: this.availableHeight,
				availableWidth: this.availableWidth,
				page: this.page
			},
			endingCell: this.endingCell,
			lastColumnWidth: this.lastColumnWidth
		});

		this.lastColumnWidth = 0;
	};

	DocumentContext.prototype.beginColumn = function (width, offset, endingCell) {
		var saved = this.snapshots[this.snapshots.length - 1];

		this.calculateBottomMost(saved);

		this.endingCell = endingCell;
		this.page = saved.page;
		this.x = this.x + this.lastColumnWidth + (offset || 0);
		this.y = saved.y;
		this.availableWidth = width;	//saved.availableWidth - offset;
		this.availableHeight = saved.availableHeight;

		this.lastColumnWidth = width;
	};

	DocumentContext.prototype.calculateBottomMost = function (destContext) {
		if (this.endingCell) {
			this.saveContextInEndingCell(this.endingCell);
			this.endingCell = null;
		} else {
			destContext.bottomMost = bottomMostContext(this, destContext.bottomMost);
		}
	};

	DocumentContext.prototype.markEnding = function (endingCell) {
		this.page = endingCell._columnEndingContext.page;
		this.x = endingCell._columnEndingContext.x;
		this.y = endingCell._columnEndingContext.y;
		this.availableWidth = endingCell._columnEndingContext.availableWidth;
		this.availableHeight = endingCell._columnEndingContext.availableHeight;
		this.lastColumnWidth = endingCell._columnEndingContext.lastColumnWidth;
	};

	DocumentContext.prototype.saveContextInEndingCell = function (endingCell) {
		endingCell._columnEndingContext = {
			page: this.page,
			x: this.x,
			y: this.y,
			availableHeight: this.availableHeight,
			availableWidth: this.availableWidth,
			lastColumnWidth: this.lastColumnWidth
		};
	};

	DocumentContext.prototype.completeColumnGroup = function () {
		var saved = this.snapshots.pop();

		this.calculateBottomMost(saved);

		this.endingCell = null;
		this.x = saved.x;
		this.y = saved.bottomMost.y;
		this.page = saved.bottomMost.page;
		this.availableWidth = saved.availableWidth;
		this.availableHeight = saved.bottomMost.availableHeight;
		this.lastColumnWidth = saved.lastColumnWidth;
	};

	DocumentContext.prototype.addMargin = function (left, right) {
		this.x += left;
		this.availableWidth -= left + (right || 0);
	};

	DocumentContext.prototype.moveDown = function (offset) {
		this.y += offset;
		this.availableHeight -= offset;

		return this.availableHeight > 0;
	};

	DocumentContext.prototype.initializePage = function () {
		this.y = this.pageMargins.top;
		this.availableHeight = this.getCurrentPage().pageSize.height - this.pageMargins.top - this.pageMargins.bottom;
		this.pageSnapshot().availableWidth = this.getCurrentPage().pageSize.width - this.pageMargins.left - this.pageMargins.right;
	};

	DocumentContext.prototype.pageSnapshot = function () {
		if (this.snapshots[0]) {
			return this.snapshots[0];
		} else {
			return this;
		}
	};

	DocumentContext.prototype.moveTo = function (x, y) {
		if (x !== undefined && x !== null) {
			this.x = x;
			this.availableWidth = this.getCurrentPage().pageSize.width - this.x - this.pageMargins.right;
		}
		if (y !== undefined && y !== null) {
			this.y = y;
			this.availableHeight = this.getCurrentPage().pageSize.height - this.y - this.pageMargins.bottom;
		}
	};

	DocumentContext.prototype.beginDetachedBlock = function () {
		this.snapshots.push({
			x: this.x,
			y: this.y,
			availableHeight: this.availableHeight,
			availableWidth: this.availableWidth,
			page: this.page,
			endingCell: this.endingCell,
			lastColumnWidth: this.lastColumnWidth
		});
	};

	DocumentContext.prototype.endDetachedBlock = function () {
		var saved = this.snapshots.pop();

		this.x = saved.x;
		this.y = saved.y;
		this.availableWidth = saved.availableWidth;
		this.availableHeight = saved.availableHeight;
		this.page = saved.page;
		this.endingCell = saved.endingCell;
		this.lastColumnWidth = saved.lastColumnWidth;
	};

	function pageOrientation(pageOrientationString, currentPageOrientation) {
		if (pageOrientationString === undefined) {
			return currentPageOrientation;
		} else if ((typeof pageOrientationString === 'string' || pageOrientationString instanceof String) && (pageOrientationString.toLowerCase() === 'landscape')) {
			return 'landscape';
		} else {
			return 'portrait';
		}
	}

	var getPageSize = function (currentPage, newPageOrientation) {

		newPageOrientation = pageOrientation(newPageOrientation, currentPage.pageSize.orientation);

		if (newPageOrientation !== currentPage.pageSize.orientation) {
			return {
				orientation: newPageOrientation,
				width: currentPage.pageSize.height,
				height: currentPage.pageSize.width
			};
		} else {
			return {
				orientation: currentPage.pageSize.orientation,
				width: currentPage.pageSize.width,
				height: currentPage.pageSize.height
			};
		}

	};


	DocumentContext.prototype.moveToNextPage = function (pageOrientation) {
		var nextPageIndex = this.page + 1;

		var prevPage = this.page;
		var prevY = this.y;

		var createNewPage = nextPageIndex >= this.pages.length;
		if (createNewPage) {
			var currentAvailableWidth = this.availableWidth;
			var currentPageOrientation = this.getCurrentPage().pageSize.orientation;

			var pageSize = getPageSize(this.getCurrentPage(), pageOrientation);
			this.addPage(pageSize);

			if (currentPageOrientation === pageSize.orientation) {
				this.availableWidth = currentAvailableWidth;
			}
		} else {
			this.page = nextPageIndex;
			this.initializePage();
		}

		return {
			newPageCreated: createNewPage,
			prevPage: prevPage,
			prevY: prevY,
			y: this.y
		};
	};


	DocumentContext.prototype.addPage = function (pageSize) {
		var page = {items: [], pageSize: pageSize};
		this.pages.push(page);
		this.page = this.pages.length - 1;
		this.initializePage();

		this.tracker.emit('pageAdded');

		return page;
	};

	DocumentContext.prototype.getCurrentPage = function () {
		if (this.page < 0 || this.page >= this.pages.length) {
			return null;
		}

		return this.pages[this.page];
	};

	DocumentContext.prototype.getCurrentPosition = function () {
		var pageSize = this.getCurrentPage().pageSize;
		var innerHeight = pageSize.height - this.pageMargins.top - this.pageMargins.bottom;
		var innerWidth = pageSize.width - this.pageMargins.left - this.pageMargins.right;

		return {
			pageNumber: this.page + 1,
			pageOrientation: pageSize.orientation,
			pageInnerHeight: innerHeight,
			pageInnerWidth: innerWidth,
			left: this.x,
			top: this.y,
			verticalRatio: ((this.y - this.pageMargins.top) / innerHeight),
			horizontalRatio: ((this.x - this.pageMargins.left) / innerWidth)
		};
	};

	function bottomMostContext(c1, c2) {
		var r;

		if (c1.page > c2.page) {
			r = c1;
		} else if (c2.page > c1.page) {
			r = c2;
		} else {
			r = (c1.y > c2.y) ? c1 : c2;
		}

		return {
			page: r.page,
			x: r.x,
			y: r.y,
			availableHeight: r.availableHeight,
			availableWidth: r.availableWidth
		};
	}

	/****TESTS**** (add a leading '/' to uncomment)
	 DocumentContext.bottomMostContext = bottomMostContext;
	 // */

	module.exports = DocumentContext;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	/* jslint node: true */
	'use strict';

	var ElementWriter = __webpack_require__(27);

	/**
	 * Creates an instance of PageElementWriter - an extended ElementWriter
	 * which can handle:
	 * - page-breaks (it adds new pages when there's not enough space left),
	 * - repeatable fragments (like table-headers, which are repeated everytime
	 *                         a page-break occurs)
	 * - transactions (used for unbreakable-blocks when we want to make sure
	 *                 whole block will be rendered on the same page)
	 */
	function PageElementWriter(context, tracker) {
		this.transactionLevel = 0;
		this.repeatables = [];
		this.tracker = tracker;
		this.writer = new ElementWriter(context, tracker);
	}

	function fitOnPage(self, addFct) {
		var position = addFct(self);
		if (!position) {
			self.moveToNextPage();
			position = addFct(self);
		}
		return position;
	}

	PageElementWriter.prototype.addLine = function (line, dontUpdateContextPosition, index) {
		return fitOnPage(this, function (self) {
			return self.writer.addLine(line, dontUpdateContextPosition, index);
		});
	};

	PageElementWriter.prototype.addImage = function (image, index) {
		return fitOnPage(this, function (self) {
			return self.writer.addImage(image, index);
		});
	};

	PageElementWriter.prototype.addQr = function (qr, index) {
		return fitOnPage(this, function (self) {
			return self.writer.addQr(qr, index);
		});
	};

	PageElementWriter.prototype.addVector = function (vector, ignoreContextX, ignoreContextY, index) {
		return this.writer.addVector(vector, ignoreContextX, ignoreContextY, index);
	};

	PageElementWriter.prototype.addFragment = function (fragment, useBlockXOffset, useBlockYOffset, dontUpdateContextPosition) {
		if (!this.writer.addFragment(fragment, useBlockXOffset, useBlockYOffset, dontUpdateContextPosition)) {
			this.moveToNextPage();
			this.writer.addFragment(fragment, useBlockXOffset, useBlockYOffset, dontUpdateContextPosition);
		}
	};

	PageElementWriter.prototype.moveToNextPage = function (pageOrientation) {

		var nextPage = this.writer.context.moveToNextPage(pageOrientation);

		if (nextPage.newPageCreated) {
			this.repeatables.forEach(function (rep) {
				this.writer.addFragment(rep, true);
			}, this);
		} else {
			this.repeatables.forEach(function (rep) {
				this.writer.context.moveDown(rep.height);
			}, this);
		}

		this.writer.tracker.emit('pageChanged', {
			prevPage: nextPage.prevPage,
			prevY: nextPage.prevY,
			y: nextPage.y
		});
	};

	PageElementWriter.prototype.beginUnbreakableBlock = function (width, height) {
		if (this.transactionLevel++ === 0) {
			this.originalX = this.writer.context.x;
			this.writer.pushContext(width, height);
		}
	};

	PageElementWriter.prototype.commitUnbreakableBlock = function (forcedX, forcedY) {
		if (--this.transactionLevel === 0) {
			var unbreakableContext = this.writer.context;
			this.writer.popContext();

			var nbPages = unbreakableContext.pages.length;
			if (nbPages > 0) {
				// no support for multi-page unbreakableBlocks
				var fragment = unbreakableContext.pages[0];
				fragment.xOffset = forcedX;
				fragment.yOffset = forcedY;

				//TODO: vectors can influence height in some situations
				if (nbPages > 1) {
					// on out-of-context blocs (headers, footers, background) height should be the whole DocumentContext height
					if (forcedX !== undefined || forcedY !== undefined) {
						fragment.height = unbreakableContext.getCurrentPage().pageSize.height - unbreakableContext.pageMargins.top - unbreakableContext.pageMargins.bottom;
					} else {
						fragment.height = this.writer.context.getCurrentPage().pageSize.height - this.writer.context.pageMargins.top - this.writer.context.pageMargins.bottom;
						for (var i = 0, l = this.repeatables.length; i < l; i++) {
							fragment.height -= this.repeatables[i].height;
						}
					}
				} else {
					fragment.height = unbreakableContext.y;
				}

				if (forcedX !== undefined || forcedY !== undefined) {
					this.writer.addFragment(fragment, true, true, true);
				} else {
					this.addFragment(fragment);
				}
			}
		}
	};

	PageElementWriter.prototype.currentBlockToRepeatable = function () {
		var unbreakableContext = this.writer.context;
		var rep = {items: []};

		unbreakableContext.pages[0].items.forEach(function (item) {
			rep.items.push(item);
		});

		rep.xOffset = this.originalX;

		//TODO: vectors can influence height in some situations
		rep.height = unbreakableContext.y;

		return rep;
	};

	PageElementWriter.prototype.pushToRepeatables = function (rep) {
		this.repeatables.push(rep);
	};

	PageElementWriter.prototype.popFromRepeatables = function () {
		this.repeatables.pop();
	};

	PageElementWriter.prototype.context = function () {
		return this.writer.context;
	};

	module.exports = PageElementWriter;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	/* jslint node: true */
	'use strict';

	var Line = __webpack_require__(28);
	var pack = __webpack_require__(13).pack;
	var offsetVector = __webpack_require__(13).offsetVector;
	var DocumentContext = __webpack_require__(25);

	/**
	 * Creates an instance of ElementWriter - a line/vector writer, which adds
	 * elements to current page and sets their positions based on the context
	 */
	function ElementWriter(context, tracker) {
		this.context = context;
		this.contextStack = [];
		this.tracker = tracker;
	}

	function addPageItem(page, item, index) {
		if (index === null || index === undefined || index < 0 || index > page.items.length) {
			page.items.push(item);
		} else {
			page.items.splice(index, 0, item);
		}
	}

	ElementWriter.prototype.addLine = function (line, dontUpdateContextPosition, index) {
		var height = line.getHeight();
		var context = this.context;
		var page = context.getCurrentPage(),
			position = this.getCurrentPositionOnPage();

		if (context.availableHeight < height || !page) {
			return false;
		}

		line.x = context.x + (line.x || 0);
		line.y = context.y + (line.y || 0);

		this.alignLine(line);

		addPageItem(page, {
			type: 'line',
			item: line
		}, index);
		this.tracker.emit('lineAdded', line);

		if (!dontUpdateContextPosition) {
			context.moveDown(height);
		}

		return position;
	};

	ElementWriter.prototype.alignLine = function (line) {
		var width = this.context.availableWidth;
		var lineWidth = line.getWidth();

		var alignment = line.inlines && line.inlines.length > 0 && line.inlines[0].alignment;

		var offset = 0;
		switch (alignment) {
			case 'right':
				offset = width - lineWidth;
				break;
			case 'center':
				offset = (width - lineWidth) / 2;
				break;
		}

		if (offset) {
			line.x = (line.x || 0) + offset;
		}

		if (alignment === 'justify' &&
			!line.newLineForced &&
			!line.lastLineInParagraph &&
			line.inlines.length > 1) {
			var additionalSpacing = (width - lineWidth) / (line.inlines.length - 1);

			for (var i = 1, l = line.inlines.length; i < l; i++) {
				offset = i * additionalSpacing;

				line.inlines[i].x += offset;
				line.inlines[i].justifyShift = additionalSpacing;
			}
		}
	};

	ElementWriter.prototype.addImage = function (image, index) {
		var context = this.context;
		var page = context.getCurrentPage(),
			position = this.getCurrentPositionOnPage();

		if (!page || (context.availableHeight < image._height && page.items.length > 0)) {
			return false;
		}

		if (image._x === undefined) {
			image._x = image.x || 0;
		}

		image.x = context.x + image._x;
		image.y = context.y;

		this.alignImage(image);

		addPageItem(page, {
			type: 'image',
			item: image
		}, index);

		context.moveDown(image._height);

		return position;
	};

	ElementWriter.prototype.addQr = function (qr, index) {
		var context = this.context;
		var page = context.getCurrentPage(),
			position = this.getCurrentPositionOnPage();

		if (context.availableHeight < qr._height || !page) {
			return false;
		}

		if (qr._x === undefined) {
			qr._x = qr.x || 0;
		}

		qr.x = context.x + qr._x;
		qr.y = context.y;

		this.alignImage(qr);

		for (var i = 0, l = qr._canvas.length; i < l; i++) {
			var vector = qr._canvas[i];
			vector.x += qr.x;
			vector.y += qr.y;
			this.addVector(vector, true, true, index);
		}

		context.moveDown(qr._height);

		return position;
	};

	ElementWriter.prototype.alignImage = function (image) {
		var width = this.context.availableWidth;
		var imageWidth = image._minWidth;
		var offset = 0;
		switch (image._alignment) {
			case 'right':
				offset = width - imageWidth;
				break;
			case 'center':
				offset = (width - imageWidth) / 2;
				break;
		}

		if (offset) {
			image.x = (image.x || 0) + offset;
		}
	};

	ElementWriter.prototype.addVector = function (vector, ignoreContextX, ignoreContextY, index) {
		var context = this.context;
		var page = context.getCurrentPage(),
			position = this.getCurrentPositionOnPage();

		if (page) {
			offsetVector(vector, ignoreContextX ? 0 : context.x, ignoreContextY ? 0 : context.y);
			addPageItem(page, {
				type: 'vector',
				item: vector
			}, index);
			return position;
		}
	};

	function cloneLine(line) {
		var result = new Line(line.maxWidth);

		for (var key in line) {
			if (line.hasOwnProperty(key)) {
				result[key] = line[key];
			}
		}

		return result;
	}

	ElementWriter.prototype.addFragment = function (block, useBlockXOffset, useBlockYOffset, dontUpdateContextPosition) {
		var ctx = this.context;
		var page = ctx.getCurrentPage();

		if (!useBlockXOffset && block.height > ctx.availableHeight) {
			return false;
		}

		block.items.forEach(function (item) {
			switch (item.type) {
				case 'line':
					var l = cloneLine(item.item);

					l.x = (l.x || 0) + (useBlockXOffset ? (block.xOffset || 0) : ctx.x);
					l.y = (l.y || 0) + (useBlockYOffset ? (block.yOffset || 0) : ctx.y);

					page.items.push({
						type: 'line',
						item: l
					});
					break;

				case 'vector':
					var v = pack(item.item);

					offsetVector(v, useBlockXOffset ? (block.xOffset || 0) : ctx.x, useBlockYOffset ? (block.yOffset || 0) : ctx.y);
					page.items.push({
						type: 'vector',
						item: v
					});
					break;

				case 'image':
					var img = pack(item.item);

					img.x = (img.x || 0) + (useBlockXOffset ? (block.xOffset || 0) : ctx.x);
					img.y = (img.y || 0) + (useBlockYOffset ? (block.yOffset || 0) : ctx.y);

					page.items.push({
						type: 'image',
						item: img
					});
					break;
			}
		});

		if (!dontUpdateContextPosition) {
			ctx.moveDown(block.height);
		}

		return true;
	};

	/**
	 * Pushes the provided context onto the stack or creates a new one
	 *
	 * pushContext(context) - pushes the provided context and makes it current
	 * pushContext(width, height) - creates and pushes a new context with the specified width and height
	 * pushContext() - creates a new context for unbreakable blocks (with current availableWidth and full-page-height)
	 */
	ElementWriter.prototype.pushContext = function (contextOrWidth, height) {
		if (contextOrWidth === undefined) {
			height = this.context.getCurrentPage().height - this.context.pageMargins.top - this.context.pageMargins.bottom;
			contextOrWidth = this.context.availableWidth;
		}

		if (typeof contextOrWidth === 'number' || contextOrWidth instanceof Number) {
			contextOrWidth = new DocumentContext({width: contextOrWidth, height: height}, {left: 0, right: 0, top: 0, bottom: 0});
		}

		this.contextStack.push(this.context);
		this.context = contextOrWidth;
	};

	ElementWriter.prototype.popContext = function () {
		this.context = this.contextStack.pop();
	};

	ElementWriter.prototype.getCurrentPositionOnPage = function () {
		return (this.contextStack[0] || this.context).getCurrentPosition();
	};


	module.exports = ElementWriter;


/***/ }),
/* 28 */
/***/ (function(module, exports) {

	/* jslint node: true */
	'use strict';

	/**
	 * Creates an instance of Line
	 *
	 * @constructor
	 * @this {Line}
	 * @param {Number} Maximum width this line can have
	 */
	function Line(maxWidth) {
		this.maxWidth = maxWidth;
		this.leadingCut = 0;
		this.trailingCut = 0;
		this.inlineWidths = 0;
		this.inlines = [];
	}

	Line.prototype.getAscenderHeight = function () {
		var y = 0;

		this.inlines.forEach(function (inline) {
			y = Math.max(y, inline.font.ascender / 1000 * inline.fontSize);
		});
		return y;
	};

	Line.prototype.hasEnoughSpaceForInline = function (inline) {
		if (this.inlines.length === 0) {
			return true;
		}
		if (this.newLineForced) {
			return false;
		}

		return this.inlineWidths + inline.width - this.leadingCut - (inline.trailingCut || 0) <= this.maxWidth;
	};

	Line.prototype.addInline = function (inline) {
		if (this.inlines.length === 0) {
			this.leadingCut = inline.leadingCut || 0;
		}
		this.trailingCut = inline.trailingCut || 0;

		inline.x = this.inlineWidths - this.leadingCut;

		this.inlines.push(inline);
		this.inlineWidths += inline.width;

		if (inline.lineEnd) {
			this.newLineForced = true;
		}
	};

	Line.prototype.getWidth = function () {
		return this.inlineWidths - this.leadingCut - this.trailingCut;
	};

	/**
	 * Returns line height
	 * @return {Number}
	 */
	Line.prototype.getHeight = function () {
		var max = 0;

		this.inlines.forEach(function (item) {
			max = Math.max(max, item.height || 0);
		});

		return max;
	};

	module.exports = Line;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	/* jslint node: true */
	'use strict';

	var ColumnCalculator = __webpack_require__(23);

	function TableProcessor(tableNode) {
		this.tableNode = tableNode;
	}

	TableProcessor.prototype.beginTable = function (writer) {
		var tableNode;
		var availableWidth;
		var self = this;

		tableNode = this.tableNode;
		this.offsets = tableNode._offsets;
		this.layout = tableNode._layout;

		availableWidth = writer.context().availableWidth - this.offsets.total;
		ColumnCalculator.buildColumnWidths(tableNode.table.widths, availableWidth);

		this.tableWidth = tableNode._offsets.total + getTableInnerContentWidth();
		this.rowSpanData = prepareRowSpanData();
		this.cleanUpRepeatables = false;

		this.headerRows = tableNode.table.headerRows || 0;
		this.rowsWithoutPageBreak = this.headerRows + (tableNode.table.keepWithHeaderRows || 0);
		this.dontBreakRows = tableNode.table.dontBreakRows || false;

		if (this.rowsWithoutPageBreak) {
			writer.beginUnbreakableBlock();
		}

		// update the border properties of all cells before drawing any lines
		prepareCellBorders(this.tableNode.table.body);

		this.drawHorizontalLine(0, writer);

		function getTableInnerContentWidth() {
			var width = 0;

			tableNode.table.widths.forEach(function (w) {
				width += w._calcWidth;
			});

			return width;
		}

		function prepareRowSpanData() {
			var rsd = [];
			var x = 0;
			var lastWidth = 0;

			rsd.push({left: 0, rowSpan: 0});

			for (var i = 0, l = self.tableNode.table.body[0].length; i < l; i++) {
				var paddings = self.layout.paddingLeft(i, self.tableNode) + self.layout.paddingRight(i, self.tableNode);
				var lBorder = self.layout.vLineWidth(i, self.tableNode);
				lastWidth = paddings + lBorder + self.tableNode.table.widths[i]._calcWidth;
				rsd[rsd.length - 1].width = lastWidth;
				x += lastWidth;
				rsd.push({left: x, rowSpan: 0, width: 0});
			}

			return rsd;
		}

		// Iterate through all cells. If the current cell is the start of a
		// rowSpan/colSpan, update the border property of the cells on its
		// bottom/right accordingly. This is needed since each iteration of the
		// line-drawing loops draws lines for a single cell, not for an entire
		// rowSpan/colSpan.
		function prepareCellBorders(body) {
			for (var rowIndex = 0; rowIndex < body.length; rowIndex++) {
				var row = body[rowIndex];

				for (var colIndex = 0; colIndex < row.length; colIndex++) {
					var cell = row[colIndex];

					if (cell.border) {
						var rowSpan = cell.rowSpan || 1;
						var colSpan = cell.colSpan || 1;

						for (var rowOffset = 0; rowOffset < rowSpan; rowOffset++) {
							// set left border
							if (cell.border[0] !== undefined && rowOffset > 0) {
								setBorder(rowIndex + rowOffset, colIndex, 0, cell.border[0]);
							}

							// set right border
							if (cell.border[2] !== undefined) {
								setBorder(rowIndex + rowOffset, colIndex + colSpan - 1, 2, cell.border[2]);
							}
						}

						for (var colOffset = 0; colOffset < colSpan; colOffset++) {
							// set top border
							if (cell.border[1] !== undefined && colOffset > 0) {
								setBorder(rowIndex, colIndex + colOffset, 1, cell.border[1]);
							}

							// set bottom border
							if (cell.border[3] !== undefined) {
								setBorder(rowIndex + rowSpan - 1, colIndex + colOffset, 3, cell.border[3]);
							}
						}
					}
				}
			}

			// helper function to set the border for a given cell
			function setBorder(rowIndex, colIndex, borderIndex, borderValue) {
				var cell = body[rowIndex][colIndex];
				cell.border = cell.border || {};
				cell.border[borderIndex] = borderValue;
			}
		}
	};

	TableProcessor.prototype.onRowBreak = function (rowIndex, writer) {
		var self = this;
		return function () {
			var offset = self.rowPaddingTop + (!self.headerRows ? self.topLineWidth : 0);
			writer.context().availableHeight -= self.reservedAtBottom;
			writer.context().moveDown(offset);
		};
	};

	TableProcessor.prototype.beginRow = function (rowIndex, writer) {
		this.topLineWidth = this.layout.hLineWidth(rowIndex, this.tableNode);
		this.rowPaddingTop = this.layout.paddingTop(rowIndex, this.tableNode);
		this.bottomLineWidth = this.layout.hLineWidth(rowIndex + 1, this.tableNode);
		this.rowPaddingBottom = this.layout.paddingBottom(rowIndex, this.tableNode);

		this.rowCallback = this.onRowBreak(rowIndex, writer);
		writer.tracker.startTracking('pageChanged', this.rowCallback);
		if (this.dontBreakRows) {
			writer.beginUnbreakableBlock();
		}
		this.rowTopY = writer.context().y;
		this.reservedAtBottom = this.bottomLineWidth + this.rowPaddingBottom;

		writer.context().availableHeight -= this.reservedAtBottom;

		writer.context().moveDown(this.rowPaddingTop);
	};

	TableProcessor.prototype.drawHorizontalLine = function (lineIndex, writer, overrideY) {
		var lineWidth = this.layout.hLineWidth(lineIndex, this.tableNode);
		if (lineWidth) {
			var offset = lineWidth / 2;
			var currentLine = null;
			var body = this.tableNode.table.body;

			for (var i = 0, l = this.rowSpanData.length; i < l; i++) {
				var data = this.rowSpanData[i];
				var shouldDrawLine = !data.rowSpan;

				// draw only if the current cell requires a top border or the cell in the
				// row above requires a bottom border
				if (shouldDrawLine && i < l - 1) {
					var topBorder = false, bottomBorder = false;

					// the current cell
					if (lineIndex < body.length) {
						var cell = body[lineIndex][i];
						topBorder = cell.border ? cell.border[1] : this.layout.defaultBorder;
					}

					// the cell in the row above
					if (lineIndex > 0) {
						var cellAbove = body[lineIndex - 1][i];
						bottomBorder = cellAbove.border ? cellAbove.border[3] : this.layout.defaultBorder;
					}

					shouldDrawLine = topBorder || bottomBorder;
				}

				if (!currentLine && shouldDrawLine) {
					currentLine = {left: data.left, width: 0};
				}

				if (shouldDrawLine) {
					currentLine.width += (data.width || 0);
				}

				var y = (overrideY || 0) + offset;

				if (!shouldDrawLine || i === l - 1) {
					if (currentLine && currentLine.width) {
						writer.addVector({
							type: 'line',
							x1: currentLine.left,
							x2: currentLine.left + currentLine.width,
							y1: y,
							y2: y,
							lineWidth: lineWidth,
							lineColor: typeof this.layout.hLineColor === 'function' ? this.layout.hLineColor(lineIndex, this.tableNode) : this.layout.hLineColor
						}, false, overrideY);
						currentLine = null;
					}
				}
			}

			writer.context().moveDown(lineWidth);
		}
	};

	TableProcessor.prototype.drawVerticalLine = function (x, y0, y1, vLineIndex, writer) {
		var width = this.layout.vLineWidth(vLineIndex, this.tableNode);
		if (width === 0) {
			return;
		}
		writer.addVector({
			type: 'line',
			x1: x + width / 2,
			x2: x + width / 2,
			y1: y0,
			y2: y1,
			lineWidth: width,
			lineColor: typeof this.layout.vLineColor === 'function' ? this.layout.vLineColor(vLineIndex, this.tableNode) : this.layout.vLineColor
		}, false, true);
	};

	TableProcessor.prototype.endTable = function (writer) {
		if (this.cleanUpRepeatables) {
			writer.popFromRepeatables();
			this.headerRepeatableHeight = null;
		}
	};

	TableProcessor.prototype.endRow = function (rowIndex, writer, pageBreaks) {
		var l, i;
		var self = this;
		writer.tracker.stopTracking('pageChanged', this.rowCallback);
		writer.context().moveDown(this.layout.paddingBottom(rowIndex, this.tableNode));
		writer.context().availableHeight += this.reservedAtBottom;

		var endingPage = writer.context().page;
		var endingY = writer.context().y;

		var xs = getLineXs();

		var ys = [];

		var hasBreaks = pageBreaks && pageBreaks.length > 0;
		var body = this.tableNode.table.body;

		ys.push({
			y0: this.rowTopY,
			page: hasBreaks ? pageBreaks[0].prevPage : endingPage
		});

		if (hasBreaks) {
			for (i = 0, l = pageBreaks.length; i < l; i++) {
				var pageBreak = pageBreaks[i];
				ys[ys.length - 1].y1 = pageBreak.prevY;

				ys.push({y0: pageBreak.y, page: pageBreak.prevPage + 1});

				if (this.headerRepeatableHeight) {
					ys[ys.length - 1].y0 += this.headerRepeatableHeight;
				}
			}
		}

		ys[ys.length - 1].y1 = endingY;

		var skipOrphanePadding = (ys[0].y1 - ys[0].y0 === this.rowPaddingTop);
		for (var yi = (skipOrphanePadding ? 1 : 0), yl = ys.length; yi < yl; yi++) {
			var willBreak = yi < ys.length - 1;
			var rowBreakWithoutHeader = (yi > 0 && !this.headerRows);
			var hzLineOffset = rowBreakWithoutHeader ? 0 : this.topLineWidth;
			var y1 = ys[yi].y0;
			var y2 = ys[yi].y1;

			if (willBreak) {
				y2 = y2 + this.rowPaddingBottom;
			}

			if (writer.context().page != ys[yi].page) {
				writer.context().page = ys[yi].page;

				//TODO: buggy, availableHeight should be updated on every pageChanged event
				// TableProcessor should be pageChanged listener, instead of processRow
				this.reservedAtBottom = 0;
			}

			for (i = 0, l = xs.length; i < l; i++) {
				var leftBorder = false, rightBorder = false;
				var colIndex = xs[i].index;

				// the current cell
				if (colIndex < body[rowIndex].length) {
					var cell = body[rowIndex][colIndex];
					leftBorder = cell.border ? cell.border[0] : this.layout.defaultBorder;
				}

				// the cell from before column
				if (colIndex > 0) {
					var cell = body[rowIndex][colIndex - 1];
					rightBorder = cell.border ? cell.border[2] : this.layout.defaultBorder;
				}

				if (leftBorder || rightBorder) {
					this.drawVerticalLine(xs[i].x, y1 - hzLineOffset, y2 + this.bottomLineWidth, xs[i].index, writer);
				}

				if (i < l - 1) {
					var fillColor = body[rowIndex][colIndex].fillColor;
					if (!fillColor) {
						fillColor = typeof this.layout.fillColor === 'function' ? this.layout.fillColor(rowIndex, this.tableNode) : this.layout.fillColor;
					}
					if (fillColor) {
						var wBorder = (leftBorder || rightBorder) ? this.layout.vLineWidth(colIndex, this.tableNode) : 0;
						var xf = xs[i].x + wBorder;
						var yf = this.dontBreakRows ? y1 : y1 - hzLineOffset;
						writer.addVector({
							type: 'rect',
							x: xf,
							y: yf,
							w: xs[i + 1].x - xf,
							h: y2 + this.bottomLineWidth - yf,
							lineWidth: 0,
							color: fillColor
						}, false, true, 0);
					}
				}
			}

			if (willBreak && this.layout.hLineWhenBroken !== false) {
				this.drawHorizontalLine(rowIndex + 1, writer, y2);
			}
			if (rowBreakWithoutHeader && this.layout.hLineWhenBroken !== false) {
				this.drawHorizontalLine(rowIndex, writer, y1);
			}
		}

		writer.context().page = endingPage;
		writer.context().y = endingY;

		var row = this.tableNode.table.body[rowIndex];
		for (i = 0, l = row.length; i < l; i++) {
			if (row[i].rowSpan) {
				this.rowSpanData[i].rowSpan = row[i].rowSpan;

				// fix colSpans
				if (row[i].colSpan && row[i].colSpan > 1) {
					for (var j = 1; j < row[i].rowSpan; j++) {
						this.tableNode.table.body[rowIndex + j][i]._colSpan = row[i].colSpan;
					}
				}
			}

			if (this.rowSpanData[i].rowSpan > 0) {
				this.rowSpanData[i].rowSpan--;
			}
		}

		this.drawHorizontalLine(rowIndex + 1, writer);

		if (this.headerRows && rowIndex === this.headerRows - 1) {
			this.headerRepeatable = writer.currentBlockToRepeatable();
		}

		if (this.dontBreakRows) {
			writer.tracker.auto('pageChanged',
				function () {
					if (!self.headerRows && self.layout.hLineWhenBroken !== false) {
						self.drawHorizontalLine(rowIndex, writer);
					}
				},
				function () {
					writer.commitUnbreakableBlock();
				}
			);
		}

		if (this.headerRepeatable && (rowIndex === (this.rowsWithoutPageBreak - 1) || rowIndex === this.tableNode.table.body.length - 1)) {
			this.headerRepeatableHeight = this.headerRepeatable.height;
			writer.commitUnbreakableBlock();
			writer.pushToRepeatables(this.headerRepeatable);
			this.cleanUpRepeatables = true;
			this.headerRepeatable = null;
		}

		function getLineXs() {
			var result = [];
			var cols = 0;

			for (var i = 0, l = self.tableNode.table.body[rowIndex].length; i < l; i++) {
				if (!cols) {
					result.push({x: self.rowSpanData[i].left, index: i});

					var item = self.tableNode.table.body[rowIndex][i];
					cols = (item._colSpan || item.colSpan || 0);
				}
				if (cols > 0) {
					cols--;
				}
			}

			result.push({x: self.rowSpanData[self.rowSpanData.length - 1].left, index: self.rowSpanData.length - 1});

			return result;
		}
	};

	module.exports = TableProcessor;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Generated by CoffeeScript 1.12.6

	/*
	PDFDocument - represents an entire PDF document
	By Devon Govett
	 */

	(function() {
	  var PDFDocument, PDFObject, PDFPage, PDFReference, fs, stream,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;

	  stream = __webpack_require__(31);

	  fs = __webpack_require__(56);

	  PDFObject = __webpack_require__(57);

	  PDFReference = __webpack_require__(58);

	  PDFPage = __webpack_require__(76);

	  PDFDocument = (function(superClass) {
	    var mixin;

	    extend(PDFDocument, superClass);

	    function PDFDocument(options1) {
	      var key, ref1, ref2, val;
	      this.options = options1 != null ? options1 : {};
	      PDFDocument.__super__.constructor.apply(this, arguments);
	      this.version = 1.3;
	      this.compress = (ref1 = this.options.compress) != null ? ref1 : true;
	      this._pageBuffer = [];
	      this._pageBufferStart = 0;
	      this._offsets = [];
	      this._waiting = 0;
	      this._ended = false;
	      this._offset = 0;
	      this._root = this.ref({
	        Type: 'Catalog',
	        Pages: this.ref({
	          Type: 'Pages',
	          Count: 0,
	          Kids: []
	        })
	      });
	      this.page = null;
	      this.initColor();
	      this.initVector();
	      this.initFonts();
	      this.initText();
	      this.initImages();
	      this.info = {
	        Producer: 'PDFKit',
	        Creator: 'PDFKit',
	        CreationDate: new Date()
	      };
	      if (this.options.info) {
	        ref2 = this.options.info;
	        for (key in ref2) {
	          val = ref2[key];
	          this.info[key] = val;
	        }
	      }
	      this._write("%PDF-" + this.version);
	      this._write("%\xFF\xFF\xFF\xFF");
	      if (this.options.autoFirstPage !== false) {
	        this.addPage();
	      }
	    }

	    mixin = function(methods) {
	      var method, name, results;
	      results = [];
	      for (name in methods) {
	        method = methods[name];
	        results.push(PDFDocument.prototype[name] = method);
	      }
	      return results;
	    };

	    mixin(__webpack_require__(77));

	    mixin(__webpack_require__(79));

	    mixin(__webpack_require__(81));

	    mixin(__webpack_require__(294));

	    mixin(__webpack_require__(296));

	    mixin(__webpack_require__(302));

	    PDFDocument.prototype.addPage = function(options) {
	      var pages;
	      if (options == null) {
	        options = this.options;
	      }
	      if (!this.options.bufferPages) {
	        this.flushPages();
	      }
	      this.page = new PDFPage(this, options);
	      this._pageBuffer.push(this.page);
	      pages = this._root.data.Pages.data;
	      pages.Kids.push(this.page.dictionary);
	      pages.Count++;
	      this.x = this.page.margins.left;
	      this.y = this.page.margins.top;
	      this._ctm = [1, 0, 0, 1, 0, 0];
	      this.transform(1, 0, 0, -1, 0, this.page.height);
	      this.emit('pageAdded');
	      return this;
	    };

	    PDFDocument.prototype.bufferedPageRange = function() {
	      return {
	        start: this._pageBufferStart,
	        count: this._pageBuffer.length
	      };
	    };

	    PDFDocument.prototype.switchToPage = function(n) {
	      var page;
	      if (!(page = this._pageBuffer[n - this._pageBufferStart])) {
	        throw new Error("switchToPage(" + n + ") out of bounds, current buffer covers pages " + this._pageBufferStart + " to " + (this._pageBufferStart + this._pageBuffer.length - 1));
	      }
	      return this.page = page;
	    };

	    PDFDocument.prototype.flushPages = function() {
	      var i, len, page, pages;
	      pages = this._pageBuffer;
	      this._pageBuffer = [];
	      this._pageBufferStart += pages.length;
	      for (i = 0, len = pages.length; i < len; i++) {
	        page = pages[i];
	        page.end();
	      }
	    };

	    PDFDocument.prototype.ref = function(data) {
	      var ref;
	      ref = new PDFReference(this, this._offsets.length + 1, data);
	      this._offsets.push(null);
	      this._waiting++;
	      return ref;
	    };

	    PDFDocument.prototype._read = function() {};

	    PDFDocument.prototype._write = function(data) {
	      if (!Buffer.isBuffer(data)) {
	        data = new Buffer(data + '\n', 'binary');
	      }
	      this.push(data);
	      return this._offset += data.length;
	    };

	    PDFDocument.prototype.addContent = function(data) {
	      this.page.write(data);
	      return this;
	    };

	    PDFDocument.prototype._refEnd = function(ref) {
	      this._offsets[ref.id - 1] = ref.offset;
	      if (--this._waiting === 0 && this._ended) {
	        this._finalize();
	        return this._ended = false;
	      }
	    };

	    PDFDocument.prototype.write = function(filename, fn) {
	      var err;
	      err = new Error('PDFDocument#write is deprecated, and will be removed in a future version of PDFKit. Please pipe the document into a Node stream.');
	      console.warn(err.stack);
	      this.pipe(fs.createWriteStream(filename));
	      this.end();
	      return this.once('end', fn);
	    };

	    PDFDocument.prototype.output = function(fn) {
	      throw new Error('PDFDocument#output is deprecated, and has been removed from PDFKit. Please pipe the document into a Node stream.');
	    };

	    PDFDocument.prototype.end = function() {
	      var font, key, name, ref1, ref2, val;
	      this.flushPages();
	      this._info = this.ref();
	      ref1 = this.info;
	      for (key in ref1) {
	        val = ref1[key];
	        if (typeof val === 'string') {
	          val = new String(val);
	        }
	        this._info.data[key] = val;
	      }
	      this._info.end();
	      ref2 = this._fontFamilies;
	      for (name in ref2) {
	        font = ref2[name];
	        font.finalize();
	      }
	      this._root.end();
	      this._root.data.Pages.end();
	      if (this._waiting === 0) {
	        return this._finalize();
	      } else {
	        return this._ended = true;
	      }
	    };

	    PDFDocument.prototype._finalize = function(fn) {
	      var i, len, offset, ref1, xRefOffset;
	      xRefOffset = this._offset;
	      this._write("xref");
	      this._write("0 " + (this._offsets.length + 1));
	      this._write("0000000000 65535 f ");
	      ref1 = this._offsets;
	      for (i = 0, len = ref1.length; i < len; i++) {
	        offset = ref1[i];
	        offset = ('0000000000' + offset).slice(-10);
	        this._write(offset + ' 00000 n ');
	      }
	      this._write('trailer');
	      this._write(PDFObject.convert({
	        Size: this._offsets.length + 1,
	        Root: this._root,
	        Info: this._info
	      }));
	      this._write('startxref');
	      this._write("" + xRefOffset);
	      this._write('%%EOF');
	      return this.push(null);
	    };

	    PDFDocument.prototype.toString = function() {
	      return "[object PDFDocument]";
	    };

	    return PDFDocument;

	  })(stream.Readable);

	  module.exports = PDFDocument;

	}).call(this);

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	module.exports = Stream;

	var EE = __webpack_require__(32).EventEmitter;
	var inherits = __webpack_require__(33);

	inherits(Stream, EE);
	Stream.Readable = __webpack_require__(34);
	Stream.Writable = __webpack_require__(52);
	Stream.Duplex = __webpack_require__(53);
	Stream.Transform = __webpack_require__(54);
	Stream.PassThrough = __webpack_require__(55);

	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;



	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.

	function Stream() {
	  EE.call(this);
	}

	Stream.prototype.pipe = function(dest, options) {
	  var source = this;

	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }

	  source.on('data', ondata);

	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }

	  dest.on('drain', ondrain);

	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }

	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;

	    dest.end();
	  }


	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;

	    if (typeof dest.destroy === 'function') dest.destroy();
	  }

	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EE.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }

	  source.on('error', onerror);
	  dest.on('error', onerror);

	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);

	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);

	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);

	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);

	    dest.removeListener('close', cleanup);
	  }

	  source.on('end', cleanup);
	  source.on('close', cleanup);

	  dest.on('close', cleanup);

	  dest.emit('pipe', source);

	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};


/***/ }),
/* 32 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;

	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;

	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;

	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;

	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};

	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;

	  if (!this._events)
	    this._events = {};

	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }

	  handler = this._events[type];

	  if (isUndefined(handler))
	    return false;

	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }

	  return true;
	};

	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;

	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');

	  if (!this._events)
	    this._events = {};

	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);

	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];

	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }

	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }

	  return this;
	};

	EventEmitter.prototype.on = EventEmitter.prototype.addListener;

	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');

	  var fired = false;

	  function g() {
	    this.removeListener(type, g);

	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }

	  g.listener = listener;
	  this.on(type, g);

	  return this;
	};

	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;

	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');

	  if (!this._events || !this._events[type])
	    return this;

	  list = this._events[type];
	  length = list.length;
	  position = -1;

	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);

	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }

	    if (position < 0)
	      return this;

	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }

	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }

	  return this;
	};

	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;

	  if (!this._events)
	    return this;

	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }

	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }

	  listeners = this._events[type];

	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];

	  return this;
	};

	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};

	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];

	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};

	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};

	function isFunction(arg) {
	  return typeof arg === 'function';
	}

	function isNumber(arg) {
	  return typeof arg === 'number';
	}

	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}

	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ }),
/* 33 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(35);
	exports.Stream = exports;
	exports.Readable = exports;
	exports.Writable = __webpack_require__(45);
	exports.Duplex = __webpack_require__(44);
	exports.Transform = __webpack_require__(50);
	exports.PassThrough = __webpack_require__(51);


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	'use strict';

	/*<replacement>*/

	var processNextTick = __webpack_require__(37);
	/*</replacement>*/

	module.exports = Readable;

	/*<replacement>*/
	var isArray = __webpack_require__(5);
	/*</replacement>*/

	/*<replacement>*/
	var Duplex;
	/*</replacement>*/

	Readable.ReadableState = ReadableState;

	/*<replacement>*/
	var EE = __webpack_require__(32).EventEmitter;

	var EElistenerCount = function (emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/

	/*<replacement>*/
	var Stream = __webpack_require__(38);
	/*</replacement>*/

	// TODO(bmeurer): Change this back to const once hole checks are
	// properly optimized away early in Ignition+TurboFan.
	/*<replacement>*/
	var Buffer = __webpack_require__(39).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	/*</replacement>*/

	/*<replacement>*/
	var util = __webpack_require__(40);
	util.inherits = __webpack_require__(33);
	/*</replacement>*/

	/*<replacement>*/
	var debugUtil = __webpack_require__(41);
	var debug = void 0;
	if (debugUtil && debugUtil.debuglog) {
	  debug = debugUtil.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/

	var BufferList = __webpack_require__(42);
	var destroyImpl = __webpack_require__(43);
	var StringDecoder;

	util.inherits(Readable, Stream);

	var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

	function prependListener(emitter, event, fn) {
	  // Sadly this is not cacheable as some libraries bundle their own
	  // event emitter implementation with them.
	  if (typeof emitter.prependListener === 'function') {
	    return emitter.prependListener(event, fn);
	  } else {
	    // This is a hack to make sure that our error handler is attached before any
	    // userland ones.  NEVER DO THIS. This is here only because this code needs
	    // to continue to work with older versions of Node.js that do not include
	    // the prependListener() method. The goal is to eventually remove this hack.
	    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
	  }
	}

	function ReadableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(44);

	  options = options || {};

	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;

	  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;

	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);

	  // A linked list is used to store data chunks instead of an array because the
	  // linked list can remove elements from the beginning faster than
	  // array.shift()
	  this.buffer = new BufferList();
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;

	  // a flag to be able to tell if the event 'readable'/'data' is emitted
	  // immediately, or on a later tick.  We set this to true at first, because
	  // any actions that shouldn't happen until "later" should generally also
	  // not happen before the first read call.
	  this.sync = true;

	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	  this.resumeScheduled = false;

	  // has it been destroyed
	  this.destroyed = false;

	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';

	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;

	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;

	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder) StringDecoder = __webpack_require__(49).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}

	function Readable(options) {
	  Duplex = Duplex || __webpack_require__(44);

	  if (!(this instanceof Readable)) return new Readable(options);

	  this._readableState = new ReadableState(options, this);

	  // legacy
	  this.readable = true;

	  if (options) {
	    if (typeof options.read === 'function') this._read = options.read;

	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	  }

	  Stream.call(this);
	}

	Object.defineProperty(Readable.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._readableState) {
	      return;
	    }

	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	  }
	});

	Readable.prototype.destroy = destroyImpl.destroy;
	Readable.prototype._undestroy = destroyImpl.undestroy;
	Readable.prototype._destroy = function (err, cb) {
	  this.push(null);
	  cb(err);
	};

	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function (chunk, encoding) {
	  var state = this._readableState;
	  var skipChunkCheck;

	  if (!state.objectMode) {
	    if (typeof chunk === 'string') {
	      encoding = encoding || state.defaultEncoding;
	      if (encoding !== state.encoding) {
	        chunk = Buffer.from(chunk, encoding);
	        encoding = '';
	      }
	      skipChunkCheck = true;
	    }
	  } else {
	    skipChunkCheck = true;
	  }

	  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
	};

	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function (chunk) {
	  return readableAddChunk(this, chunk, null, true, false);
	};

	function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
	  var state = stream._readableState;
	  if (chunk === null) {
	    state.reading = false;
	    onEofChunk(stream, state);
	  } else {
	    var er;
	    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
	    if (er) {
	      stream.emit('error', er);
	    } else if (state.objectMode || chunk && chunk.length > 0) {
	      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
	        chunk = _uint8ArrayToBuffer(chunk);
	      }

	      if (addToFront) {
	        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
	      } else if (state.ended) {
	        stream.emit('error', new Error('stream.push() after EOF'));
	      } else {
	        state.reading = false;
	        if (state.decoder && !encoding) {
	          chunk = state.decoder.write(chunk);
	          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
	        } else {
	          addChunk(stream, state, chunk, false);
	        }
	      }
	    } else if (!addToFront) {
	      state.reading = false;
	    }
	  }

	  return needMoreData(state);
	}

	function addChunk(stream, state, chunk, addToFront) {
	  if (state.flowing && state.length === 0 && !state.sync) {
	    stream.emit('data', chunk);
	    stream.read(0);
	  } else {
	    // update the buffer info.
	    state.length += state.objectMode ? 1 : chunk.length;
	    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

	    if (state.needReadable) emitReadable(stream);
	  }
	  maybeReadMore(stream, state);
	}

	function chunkInvalid(state, chunk) {
	  var er;
	  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}

	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
	}

	Readable.prototype.isPaused = function () {
	  return this._readableState.flowing === false;
	};

	// backwards compatibility.
	Readable.prototype.setEncoding = function (enc) {
	  if (!StringDecoder) StringDecoder = __webpack_require__(49).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};

	// Don't raise the hwm > 8MB
	var MAX_HWM = 0x800000;
	function computeNewHighWaterMark(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2 to prevent increasing hwm excessively in
	    // tiny amounts
	    n--;
	    n |= n >>> 1;
	    n |= n >>> 2;
	    n |= n >>> 4;
	    n |= n >>> 8;
	    n |= n >>> 16;
	    n++;
	  }
	  return n;
	}

	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function howMuchToRead(n, state) {
	  if (n <= 0 || state.length === 0 && state.ended) return 0;
	  if (state.objectMode) return 1;
	  if (n !== n) {
	    // Only flow one buffer at a time
	    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
	  }
	  // If we're asking for more than the current hwm, then raise the hwm.
	  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	  if (n <= state.length) return n;
	  // Don't have enough
	  if (!state.ended) {
	    state.needReadable = true;
	    return 0;
	  }
	  return state.length;
	}

	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function (n) {
	  debug('read', n);
	  n = parseInt(n, 10);
	  var state = this._readableState;
	  var nOrig = n;

	  if (n !== 0) state.emittedReadable = false;

	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
	    return null;
	  }

	  n = howMuchToRead(n, state);

	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0) endReadable(this);
	    return null;
	  }

	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.

	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);

	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }

	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  } else if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0) state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	    // If _read pushed data synchronously, then `reading` will be false,
	    // and we need to re-evaluate how much data we can return to the user.
	    if (!state.reading) n = howMuchToRead(nOrig, state);
	  }

	  var ret;
	  if (n > 0) ret = fromList(n, state);else ret = null;

	  if (ret === null) {
	    state.needReadable = true;
	    n = 0;
	  } else {
	    state.length -= n;
	  }

	  if (state.length === 0) {
	    // If we have nothing in the buffer, then we want to know
	    // as soon as we *do* get something into the buffer.
	    if (!state.ended) state.needReadable = true;

	    // If we tried to read() past the EOF, then emit end on the next tick.
	    if (nOrig !== n && state.ended) endReadable(this);
	  }

	  if (ret !== null) this.emit('data', ret);

	  return ret;
	};

	function onEofChunk(stream, state) {
	  if (state.ended) return;
	  if (state.decoder) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;

	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}

	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync) processNextTick(emitReadable_, stream);else emitReadable_(stream);
	  }
	}

	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}

	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    processNextTick(maybeReadMore_, stream, state);
	  }
	}

	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;else len = state.length;
	  }
	  state.readingMore = false;
	}

	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function (n) {
	  this.emit('error', new Error('_read() is not implemented'));
	};

	Readable.prototype.pipe = function (dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;

	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

	  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

	  var endFn = doEnd ? onend : unpipe;
	  if (state.endEmitted) processNextTick(endFn);else src.once('end', endFn);

	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable, unpipeInfo) {
	    debug('onunpipe');
	    if (readable === src) {
	      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
	        unpipeInfo.hasUnpiped = true;
	        cleanup();
	      }
	    }
	  }

	  function onend() {
	    debug('onend');
	    dest.end();
	  }

	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);

	  var cleanedUp = false;
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', unpipe);
	    src.removeListener('data', ondata);

	    cleanedUp = true;

	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	  }

	  // If the user pushes more data while we're writing to dest then we'll end up
	  // in ondata again. However, we only want to increase awaitDrain once because
	  // dest will only emit one 'drain' event for the multiple writes.
	  // => Introduce a guard on increasing awaitDrain.
	  var increasedAwaitDrain = false;
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    increasedAwaitDrain = false;
	    var ret = dest.write(chunk);
	    if (false === ret && !increasedAwaitDrain) {
	      // If the user unpiped during `dest.write()`, it is possible
	      // to get stuck in a permanently paused state if that write
	      // also returned false.
	      // => Check whether `dest` is still a piping destination.
	      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
	        debug('false write response, pause', src._readableState.awaitDrain);
	        src._readableState.awaitDrain++;
	        increasedAwaitDrain = true;
	      }
	      src.pause();
	    }
	  }

	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
	  }

	  // Make sure our error handler is attached before userland ones.
	  prependListener(dest, 'error', onerror);

	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);

	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }

	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);

	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }

	  return dest;
	};

	function pipeOnDrain(src) {
	  return function () {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain) state.awaitDrain--;
	    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}

	Readable.prototype.unpipe = function (dest) {
	  var state = this._readableState;
	  var unpipeInfo = { hasUnpiped: false };

	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0) return this;

	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes) return this;

	    if (!dest) dest = state.pipes;

	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest) dest.emit('unpipe', this, unpipeInfo);
	    return this;
	  }

	  // slow case. multiple pipe destinations.

	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;

	    for (var i = 0; i < len; i++) {
	      dests[i].emit('unpipe', this, unpipeInfo);
	    }return this;
	  }

	  // try to find the right one.
	  var index = indexOf(state.pipes, dest);
	  if (index === -1) return this;

	  state.pipes.splice(index, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1) state.pipes = state.pipes[0];

	  dest.emit('unpipe', this, unpipeInfo);

	  return this;
	};

	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function (ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);

	  if (ev === 'data') {
	    // Start flowing on next tick if stream isn't explicitly paused
	    if (this._readableState.flowing !== false) this.resume();
	  } else if (ev === 'readable') {
	    var state = this._readableState;
	    if (!state.endEmitted && !state.readableListening) {
	      state.readableListening = state.needReadable = true;
	      state.emittedReadable = false;
	      if (!state.reading) {
	        processNextTick(nReadingNextTick, this);
	      } else if (state.length) {
	        emitReadable(this);
	      }
	    }
	  }

	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;

	function nReadingNextTick(self) {
	  debug('readable nexttick read 0');
	  self.read(0);
	}

	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function () {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    resume(this, state);
	  }
	  return this;
	};

	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    processNextTick(resume_, stream, state);
	  }
	}

	function resume_(stream, state) {
	  if (!state.reading) {
	    debug('resume read 0');
	    stream.read(0);
	  }

	  state.resumeScheduled = false;
	  state.awaitDrain = 0;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading) stream.read(0);
	}

	Readable.prototype.pause = function () {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};

	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  while (state.flowing && stream.read() !== null) {}
	}

	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function (stream) {
	  var state = this._readableState;
	  var paused = false;

	  var self = this;
	  stream.on('end', function () {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length) self.push(chunk);
	    }

	    self.push(null);
	  });

	  stream.on('data', function (chunk) {
	    debug('wrapped data');
	    if (state.decoder) chunk = state.decoder.write(chunk);

	    // don't skip over falsy values in objectMode
	    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

	    var ret = self.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });

	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (this[i] === undefined && typeof stream[i] === 'function') {
	      this[i] = function (method) {
	        return function () {
	          return stream[method].apply(stream, arguments);
	        };
	      }(i);
	    }
	  }

	  // proxy certain important events.
	  for (var n = 0; n < kProxyEvents.length; n++) {
	    stream.on(kProxyEvents[n], self.emit.bind(self, kProxyEvents[n]));
	  }

	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  self._read = function (n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };

	  return self;
	};

	// exposed for testing purposes only.
	Readable._fromList = fromList;

	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromList(n, state) {
	  // nothing buffered
	  if (state.length === 0) return null;

	  var ret;
	  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
	    // read it all, truncate the list
	    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
	    state.buffer.clear();
	  } else {
	    // read part of list
	    ret = fromListPartial(n, state.buffer, state.decoder);
	  }

	  return ret;
	}

	// Extracts only enough buffered data to satisfy the amount requested.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromListPartial(n, list, hasStrings) {
	  var ret;
	  if (n < list.head.data.length) {
	    // slice is the same for buffers and strings
	    ret = list.head.data.slice(0, n);
	    list.head.data = list.head.data.slice(n);
	  } else if (n === list.head.data.length) {
	    // first chunk is a perfect match
	    ret = list.shift();
	  } else {
	    // result spans more than one buffer
	    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
	  }
	  return ret;
	}

	// Copies a specified amount of characters from the list of buffered data
	// chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBufferString(n, list) {
	  var p = list.head;
	  var c = 1;
	  var ret = p.data;
	  n -= ret.length;
	  while (p = p.next) {
	    var str = p.data;
	    var nb = n > str.length ? str.length : n;
	    if (nb === str.length) ret += str;else ret += str.slice(0, n);
	    n -= nb;
	    if (n === 0) {
	      if (nb === str.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = str.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}

	// Copies a specified amount of bytes from the list of buffered data chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBuffer(n, list) {
	  var ret = Buffer.allocUnsafe(n);
	  var p = list.head;
	  var c = 1;
	  p.data.copy(ret);
	  n -= p.data.length;
	  while (p = p.next) {
	    var buf = p.data;
	    var nb = n > buf.length ? buf.length : n;
	    buf.copy(ret, ret.length - n, 0, nb);
	    n -= nb;
	    if (n === 0) {
	      if (nb === buf.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = buf.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}

	function endReadable(stream) {
	  var state = stream._readableState;

	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

	  if (!state.endEmitted) {
	    state.ended = true;
	    processNextTick(endReadableNT, state, stream);
	  }
	}

	function endReadableNT(state, stream) {
	  // Check that we didn't get one last unshift.
	  if (!state.endEmitted && state.length === 0) {
	    state.endEmitted = true;
	    stream.readable = false;
	    stream.emit('end');
	  }
	}

	function forEach(xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}

	function indexOf(xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(36)))

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};

	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.

	var cachedSetTimeout;
	var cachedClearTimeout;

	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }


	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }



	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;

	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}

	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;

	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}

	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};

	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};

	function noop() {}

	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;

	process.listeners = function (name) { return [] }

	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};

	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';

	if (!process.version ||
	    process.version.indexOf('v0.') === 0 ||
	    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
	  module.exports = nextTick;
	} else {
	  module.exports = process.nextTick;
	}

	function nextTick(fn, arg1, arg2, arg3) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('"callback" argument must be a function');
	  }
	  var len = arguments.length;
	  var args, i;
	  switch (len) {
	  case 0:
	  case 1:
	    return process.nextTick(fn);
	  case 2:
	    return process.nextTick(function afterTickOne() {
	      fn.call(null, arg1);
	    });
	  case 3:
	    return process.nextTick(function afterTickTwo() {
	      fn.call(null, arg1, arg2);
	    });
	  case 4:
	    return process.nextTick(function afterTickThree() {
	      fn.call(null, arg1, arg2, arg3);
	    });
	  default:
	    args = new Array(len - 1);
	    i = 0;
	    while (i < args.length) {
	      args[i++] = arguments[i];
	    }
	    return process.nextTick(function afterTick() {
	      fn.apply(null, args);
	    });
	  }
	}

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(32).EventEmitter;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	/* eslint-disable node/no-deprecated-api */
	var buffer = __webpack_require__(2)
	var Buffer = buffer.Buffer

	// alternative to using Object.keys for old browsers
	function copyProps (src, dst) {
	  for (var key in src) {
	    dst[key] = src[key]
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports)
	  exports.Buffer = SafeBuffer
	}

	function SafeBuffer (arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length)
	}

	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer)

	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number')
	  }
	  return Buffer(arg, encodingOrOffset, length)
	}

	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  var buf = Buffer(size)
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding)
	    } else {
	      buf.fill(fill)
	    }
	  } else {
	    buf.fill(0)
	  }
	  return buf
	}

	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return Buffer(size)
	}

	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return buffer.SlowBuffer(size)
	}


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.

	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;

	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;

	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;

	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;

	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;

	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;

	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;

	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;

	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;

	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;

	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;

	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;

	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;

	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;

	exports.isBuffer = Buffer.isBuffer;

	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	/*<replacement>*/

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var Buffer = __webpack_require__(39).Buffer;
	/*</replacement>*/

	function copyBuffer(src, target, offset) {
	  src.copy(target, offset);
	}

	module.exports = function () {
	  function BufferList() {
	    _classCallCheck(this, BufferList);

	    this.head = null;
	    this.tail = null;
	    this.length = 0;
	  }

	  BufferList.prototype.push = function push(v) {
	    var entry = { data: v, next: null };
	    if (this.length > 0) this.tail.next = entry;else this.head = entry;
	    this.tail = entry;
	    ++this.length;
	  };

	  BufferList.prototype.unshift = function unshift(v) {
	    var entry = { data: v, next: this.head };
	    if (this.length === 0) this.tail = entry;
	    this.head = entry;
	    ++this.length;
	  };

	  BufferList.prototype.shift = function shift() {
	    if (this.length === 0) return;
	    var ret = this.head.data;
	    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
	    --this.length;
	    return ret;
	  };

	  BufferList.prototype.clear = function clear() {
	    this.head = this.tail = null;
	    this.length = 0;
	  };

	  BufferList.prototype.join = function join(s) {
	    if (this.length === 0) return '';
	    var p = this.head;
	    var ret = '' + p.data;
	    while (p = p.next) {
	      ret += s + p.data;
	    }return ret;
	  };

	  BufferList.prototype.concat = function concat(n) {
	    if (this.length === 0) return Buffer.alloc(0);
	    if (this.length === 1) return this.head.data;
	    var ret = Buffer.allocUnsafe(n >>> 0);
	    var p = this.head;
	    var i = 0;
	    while (p) {
	      copyBuffer(p.data, ret, i);
	      i += p.data.length;
	      p = p.next;
	    }
	    return ret;
	  };

	  return BufferList;
	}();

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	/*<replacement>*/

	var processNextTick = __webpack_require__(37);
	/*</replacement>*/

	// undocumented cb() API, needed for core, not for public API
	function destroy(err, cb) {
	  var _this = this;

	  var readableDestroyed = this._readableState && this._readableState.destroyed;
	  var writableDestroyed = this._writableState && this._writableState.destroyed;

	  if (readableDestroyed || writableDestroyed) {
	    if (cb) {
	      cb(err);
	    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
	      processNextTick(emitErrorNT, this, err);
	    }
	    return;
	  }

	  // we set destroyed to true before firing error callbacks in order
	  // to make it re-entrance safe in case destroy() is called within callbacks

	  if (this._readableState) {
	    this._readableState.destroyed = true;
	  }

	  // if this is a duplex stream mark the writable part as destroyed as well
	  if (this._writableState) {
	    this._writableState.destroyed = true;
	  }

	  this._destroy(err || null, function (err) {
	    if (!cb && err) {
	      processNextTick(emitErrorNT, _this, err);
	      if (_this._writableState) {
	        _this._writableState.errorEmitted = true;
	      }
	    } else if (cb) {
	      cb(err);
	    }
	  });
	}

	function undestroy() {
	  if (this._readableState) {
	    this._readableState.destroyed = false;
	    this._readableState.reading = false;
	    this._readableState.ended = false;
	    this._readableState.endEmitted = false;
	  }

	  if (this._writableState) {
	    this._writableState.destroyed = false;
	    this._writableState.ended = false;
	    this._writableState.ending = false;
	    this._writableState.finished = false;
	    this._writableState.errorEmitted = false;
	  }
	}

	function emitErrorNT(self, err) {
	  self.emit('error', err);
	}

	module.exports = {
	  destroy: destroy,
	  undestroy: undestroy
	};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.

	'use strict';

	/*<replacement>*/

	var processNextTick = __webpack_require__(37);
	/*</replacement>*/

	/*<replacement>*/
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    keys.push(key);
	  }return keys;
	};
	/*</replacement>*/

	module.exports = Duplex;

	/*<replacement>*/
	var util = __webpack_require__(40);
	util.inherits = __webpack_require__(33);
	/*</replacement>*/

	var Readable = __webpack_require__(35);
	var Writable = __webpack_require__(45);

	util.inherits(Duplex, Readable);

	var keys = objectKeys(Writable.prototype);
	for (var v = 0; v < keys.length; v++) {
	  var method = keys[v];
	  if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	}

	function Duplex(options) {
	  if (!(this instanceof Duplex)) return new Duplex(options);

	  Readable.call(this, options);
	  Writable.call(this, options);

	  if (options && options.readable === false) this.readable = false;

	  if (options && options.writable === false) this.writable = false;

	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

	  this.once('end', onend);
	}

	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended) return;

	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  processNextTick(onEndNT, this);
	}

	function onEndNT(self) {
	  self.end();
	}

	Object.defineProperty(Duplex.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed && this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return;
	    }

	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	    this._writableState.destroyed = value;
	  }
	});

	Duplex.prototype._destroy = function (err, cb) {
	  this.push(null);
	  this.end();

	  processNextTick(cb, err);
	};

	function forEach(xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	// A bit simpler than readable streams.
	// Implement an async ._write(chunk, encoding, cb), and it'll handle all
	// the drain event emission and buffering.

	'use strict';

	/*<replacement>*/

	var processNextTick = __webpack_require__(37);
	/*</replacement>*/

	module.exports = Writable;

	/* <replacement> */
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	  this.next = null;
	}

	// It seems a linked list but it is not
	// there will be only 2 of these for each stream
	function CorkedRequest(state) {
	  var _this = this;

	  this.next = null;
	  this.entry = null;
	  this.finish = function () {
	    onCorkedFinish(_this, state);
	  };
	}
	/* </replacement> */

	/*<replacement>*/
	var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : processNextTick;
	/*</replacement>*/

	/*<replacement>*/
	var Duplex;
	/*</replacement>*/

	Writable.WritableState = WritableState;

	/*<replacement>*/
	var util = __webpack_require__(40);
	util.inherits = __webpack_require__(33);
	/*</replacement>*/

	/*<replacement>*/
	var internalUtil = {
	  deprecate: __webpack_require__(48)
	};
	/*</replacement>*/

	/*<replacement>*/
	var Stream = __webpack_require__(38);
	/*</replacement>*/

	/*<replacement>*/
	var Buffer = __webpack_require__(39).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	/*</replacement>*/

	var destroyImpl = __webpack_require__(43);

	util.inherits(Writable, Stream);

	function nop() {}

	function WritableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(44);

	  options = options || {};

	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;

	  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;

	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);

	  // if _final has been called
	  this.finalCalled = false;

	  // drain event flag.
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;

	  // has it been destroyed
	  this.destroyed = false;

	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;

	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';

	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;

	  // a flag to see when we're in the middle of a write.
	  this.writing = false;

	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;

	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;

	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;

	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function (er) {
	    onwrite(stream, er);
	  };

	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;

	  // the amount that is being written when _write is called.
	  this.writelen = 0;

	  this.bufferedRequest = null;
	  this.lastBufferedRequest = null;

	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;

	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;

	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;

	  // count buffered requests
	  this.bufferedRequestCount = 0;

	  // allocate the first CorkedRequest, there is always
	  // one allocated and free to use, and we maintain at most two
	  this.corkedRequestsFree = new CorkedRequest(this);
	}

	WritableState.prototype.getBuffer = function getBuffer() {
	  var current = this.bufferedRequest;
	  var out = [];
	  while (current) {
	    out.push(current);
	    current = current.next;
	  }
	  return out;
	};

	(function () {
	  try {
	    Object.defineProperty(WritableState.prototype, 'buffer', {
	      get: internalUtil.deprecate(function () {
	        return this.getBuffer();
	      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
	    });
	  } catch (_) {}
	})();

	// Test _writableState for inheritance to account for Duplex streams,
	// whose prototype chain only points to Readable.
	var realHasInstance;
	if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
	  realHasInstance = Function.prototype[Symbol.hasInstance];
	  Object.defineProperty(Writable, Symbol.hasInstance, {
	    value: function (object) {
	      if (realHasInstance.call(this, object)) return true;

	      return object && object._writableState instanceof WritableState;
	    }
	  });
	} else {
	  realHasInstance = function (object) {
	    return object instanceof this;
	  };
	}

	function Writable(options) {
	  Duplex = Duplex || __webpack_require__(44);

	  // Writable ctor is applied to Duplexes, too.
	  // `realHasInstance` is necessary because using plain `instanceof`
	  // would return false, as no `_writableState` property is attached.

	  // Trying to use the custom `instanceof` for Writable here will also break the
	  // Node.js LazyTransform implementation, which has a non-trivial getter for
	  // `_writableState` that would lead to infinite recursion.
	  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
	    return new Writable(options);
	  }

	  this._writableState = new WritableState(options, this);

	  // legacy.
	  this.writable = true;

	  if (options) {
	    if (typeof options.write === 'function') this._write = options.write;

	    if (typeof options.writev === 'function') this._writev = options.writev;

	    if (typeof options.destroy === 'function') this._destroy = options.destroy;

	    if (typeof options.final === 'function') this._final = options.final;
	  }

	  Stream.call(this);
	}

	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function () {
	  this.emit('error', new Error('Cannot pipe, not readable'));
	};

	function writeAfterEnd(stream, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  processNextTick(cb, er);
	}

	// Checks that a user-supplied chunk is valid, especially for the particular
	// mode the stream is in. Currently this means that `null` is never accepted
	// and undefined/non-string values are only allowed in object mode.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  var er = false;

	  if (chunk === null) {
	    er = new TypeError('May not write null values to stream');
	  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  if (er) {
	    stream.emit('error', er);
	    processNextTick(cb, er);
	    valid = false;
	  }
	  return valid;
	}

	Writable.prototype.write = function (chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	  var isBuf = _isUint8Array(chunk) && !state.objectMode;

	  if (isBuf && !Buffer.isBuffer(chunk)) {
	    chunk = _uint8ArrayToBuffer(chunk);
	  }

	  if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }

	  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

	  if (typeof cb !== 'function') cb = nop;

	  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
	  }

	  return ret;
	};

	Writable.prototype.cork = function () {
	  var state = this._writableState;

	  state.corked++;
	};

	Writable.prototype.uncork = function () {
	  var state = this._writableState;

	  if (state.corked) {
	    state.corked--;

	    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	  }
	};

	Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	  // node::ParseEncoding() requires lower case.
	  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
	  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
	  this._writableState.defaultEncoding = encoding;
	  return this;
	};

	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
	    chunk = Buffer.from(chunk, encoding);
	  }
	  return chunk;
	}

	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
	  if (!isBuf) {
	    var newChunk = decodeChunk(state, chunk, encoding);
	    if (chunk !== newChunk) {
	      isBuf = true;
	      encoding = 'buffer';
	      chunk = newChunk;
	    }
	  }
	  var len = state.objectMode ? 1 : chunk.length;

	  state.length += len;

	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret) state.needDrain = true;

	  if (state.writing || state.corked) {
	    var last = state.lastBufferedRequest;
	    state.lastBufferedRequest = {
	      chunk: chunk,
	      encoding: encoding,
	      isBuf: isBuf,
	      callback: cb,
	      next: null
	    };
	    if (last) {
	      last.next = state.lastBufferedRequest;
	    } else {
	      state.bufferedRequest = state.lastBufferedRequest;
	    }
	    state.bufferedRequestCount += 1;
	  } else {
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	  }

	  return ret;
	}

	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}

	function onwriteError(stream, state, sync, er, cb) {
	  --state.pendingcb;

	  if (sync) {
	    // defer the callback if we are being called synchronously
	    // to avoid piling up things on the stack
	    processNextTick(cb, er);
	    // this can emit finish, and it will always happen
	    // after error
	    processNextTick(finishMaybe, stream, state);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	  } else {
	    // the caller expect this to happen before if
	    // it is async
	    cb(er);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	    // this can emit finish, but finish must
	    // always follow error
	    finishMaybe(stream, state);
	  }
	}

	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}

	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;

	  onwriteStateUpdate(state);

	  if (er) onwriteError(stream, state, sync, er, cb);else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(state);

	    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	      clearBuffer(stream, state);
	    }

	    if (sync) {
	      /*<replacement>*/
	      asyncWrite(afterWrite, stream, state, finished, cb);
	      /*</replacement>*/
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}

	function afterWrite(stream, state, finished, cb) {
	  if (!finished) onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}

	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}

	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	  var entry = state.bufferedRequest;

	  if (stream._writev && entry && entry.next) {
	    // Fast case, write everything using _writev()
	    var l = state.bufferedRequestCount;
	    var buffer = new Array(l);
	    var holder = state.corkedRequestsFree;
	    holder.entry = entry;

	    var count = 0;
	    var allBuffers = true;
	    while (entry) {
	      buffer[count] = entry;
	      if (!entry.isBuf) allBuffers = false;
	      entry = entry.next;
	      count += 1;
	    }
	    buffer.allBuffers = allBuffers;

	    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

	    // doWrite is almost always async, defer these to save a bit of time
	    // as the hot path ends with doWrite
	    state.pendingcb++;
	    state.lastBufferedRequest = null;
	    if (holder.next) {
	      state.corkedRequestsFree = holder.next;
	      holder.next = null;
	    } else {
	      state.corkedRequestsFree = new CorkedRequest(state);
	    }
	  } else {
	    // Slow case, write chunks one-by-one
	    while (entry) {
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;

	      doWrite(stream, state, false, len, chunk, encoding, cb);
	      entry = entry.next;
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        break;
	      }
	    }

	    if (entry === null) state.lastBufferedRequest = null;
	  }

	  state.bufferedRequestCount = 0;
	  state.bufferedRequest = entry;
	  state.bufferProcessing = false;
	}

	Writable.prototype._write = function (chunk, encoding, cb) {
	  cb(new Error('_write() is not implemented'));
	};

	Writable.prototype._writev = null;

	Writable.prototype.end = function (chunk, encoding, cb) {
	  var state = this._writableState;

	  if (typeof chunk === 'function') {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }

	  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }

	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished) endWritable(this, state, cb);
	};

	function needFinish(state) {
	  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	}
	function callFinal(stream, state) {
	  stream._final(function (err) {
	    state.pendingcb--;
	    if (err) {
	      stream.emit('error', err);
	    }
	    state.prefinished = true;
	    stream.emit('prefinish');
	    finishMaybe(stream, state);
	  });
	}
	function prefinish(stream, state) {
	  if (!state.prefinished && !state.finalCalled) {
	    if (typeof stream._final === 'function') {
	      state.pendingcb++;
	      state.finalCalled = true;
	      processNextTick(callFinal, stream, state);
	    } else {
	      state.prefinished = true;
	      stream.emit('prefinish');
	    }
	  }
	}

	function finishMaybe(stream, state) {
	  var need = needFinish(state);
	  if (need) {
	    prefinish(stream, state);
	    if (state.pendingcb === 0) {
	      state.finished = true;
	      stream.emit('finish');
	    }
	  }
	  return need;
	}

	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished) processNextTick(cb);else stream.once('finish', cb);
	  }
	  state.ended = true;
	  stream.writable = false;
	}

	function onCorkedFinish(corkReq, state, err) {
	  var entry = corkReq.entry;
	  corkReq.entry = null;
	  while (entry) {
	    var cb = entry.callback;
	    state.pendingcb--;
	    cb(err);
	    entry = entry.next;
	  }
	  if (state.corkedRequestsFree) {
	    state.corkedRequestsFree.next = corkReq;
	  } else {
	    state.corkedRequestsFree = corkReq;
	  }
	}

	Object.defineProperty(Writable.prototype, 'destroyed', {
	  get: function () {
	    if (this._writableState === undefined) {
	      return false;
	    }
	    return this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._writableState) {
	      return;
	    }

	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._writableState.destroyed = value;
	  }
	});

	Writable.prototype.destroy = destroyImpl.destroy;
	Writable.prototype._undestroy = destroyImpl.undestroy;
	Writable.prototype._destroy = function (err, cb) {
	  this.end();
	  cb(err);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36), __webpack_require__(46).setImmediate, (function() { return this; }())))

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = Function.prototype.apply;

	// DOM APIs, for completeness

	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};

	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};

	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};

	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};

	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);

	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};

	// setimmediate attaches itself to the global object
	__webpack_require__(47);
	exports.setImmediate = setImmediate;
	exports.clearImmediate = clearImmediate;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";

	    if (global.setImmediate) {
	        return;
	    }

	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;

	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }

	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }

	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }

	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }

	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }

	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }

	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };

	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }

	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }

	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };

	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }

	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }

	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }

	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();

	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();

	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();

	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();

	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }

	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(36)))

/***/ }),
/* 48 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module exports.
	 */

	module.exports = deprecate;

	/**
	 * Mark that a method should not be used.
	 * Returns a modified function which warns once by default.
	 *
	 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
	 *
	 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
	 * will throw an Error when invoked.
	 *
	 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
	 * will invoke `console.trace()` instead of `console.error()`.
	 *
	 * @param {Function} fn - the function to deprecate
	 * @param {String} msg - the string to print to the console when `fn` is invoked
	 * @returns {Function} a new "deprecated" version of `fn`
	 * @api public
	 */

	function deprecate (fn, msg) {
	  if (config('noDeprecation')) {
	    return fn;
	  }

	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (config('throwDeprecation')) {
	        throw new Error(msg);
	      } else if (config('traceDeprecation')) {
	        console.trace(msg);
	      } else {
	        console.warn(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }

	  return deprecated;
	}

	/**
	 * Checks `localStorage` for boolean values for the given `name`.
	 *
	 * @param {String} name
	 * @returns {Boolean}
	 * @api private
	 */

	function config (name) {
	  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
	  try {
	    if (!global.localStorage) return false;
	  } catch (_) {
	    return false;
	  }
	  var val = global.localStorage[name];
	  if (null == val) return false;
	  return String(val).toLowerCase() === 'true';
	}

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var Buffer = __webpack_require__(39).Buffer;

	var isEncoding = Buffer.isEncoding || function (encoding) {
	  encoding = '' + encoding;
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};

	function _normalizeEncoding(enc) {
	  if (!enc) return 'utf8';
	  var retried;
	  while (true) {
	    switch (enc) {
	      case 'utf8':
	      case 'utf-8':
	        return 'utf8';
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return 'utf16le';
	      case 'latin1':
	      case 'binary':
	        return 'latin1';
	      case 'base64':
	      case 'ascii':
	      case 'hex':
	        return enc;
	      default:
	        if (retried) return; // undefined
	        enc = ('' + enc).toLowerCase();
	        retried = true;
	    }
	  }
	};

	// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc) {
	  var nenc = _normalizeEncoding(enc);
	  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
	  return nenc || enc;
	}

	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	exports.StringDecoder = StringDecoder;
	function StringDecoder(encoding) {
	  this.encoding = normalizeEncoding(encoding);
	  var nb;
	  switch (this.encoding) {
	    case 'utf16le':
	      this.text = utf16Text;
	      this.end = utf16End;
	      nb = 4;
	      break;
	    case 'utf8':
	      this.fillLast = utf8FillLast;
	      nb = 4;
	      break;
	    case 'base64':
	      this.text = base64Text;
	      this.end = base64End;
	      nb = 3;
	      break;
	    default:
	      this.write = simpleWrite;
	      this.end = simpleEnd;
	      return;
	  }
	  this.lastNeed = 0;
	  this.lastTotal = 0;
	  this.lastChar = Buffer.allocUnsafe(nb);
	}

	StringDecoder.prototype.write = function (buf) {
	  if (buf.length === 0) return '';
	  var r;
	  var i;
	  if (this.lastNeed) {
	    r = this.fillLast(buf);
	    if (r === undefined) return '';
	    i = this.lastNeed;
	    this.lastNeed = 0;
	  } else {
	    i = 0;
	  }
	  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	  return r || '';
	};

	StringDecoder.prototype.end = utf8End;

	// Returns only complete characters in a Buffer
	StringDecoder.prototype.text = utf8Text;

	// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast = function (buf) {
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	  this.lastNeed -= buf.length;
	};

	// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte.
	function utf8CheckByte(byte) {
	  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
	  return -1;
	}

	// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self, buf, i) {
	  var j = buf.length - 1;
	  if (j < i) return 0;
	  var nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 1;
	    return nb;
	  }
	  if (--j < i) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 2;
	    return nb;
	  }
	  if (--j < i) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) {
	      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
	    }
	    return nb;
	  }
	  return 0;
	}

	// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// UTF-8 replacement characters ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self, buf, p) {
	  if ((buf[0] & 0xC0) !== 0x80) {
	    self.lastNeed = 0;
	    return '\ufffd'.repeat(p);
	  }
	  if (self.lastNeed > 1 && buf.length > 1) {
	    if ((buf[1] & 0xC0) !== 0x80) {
	      self.lastNeed = 1;
	      return '\ufffd'.repeat(p + 1);
	    }
	    if (self.lastNeed > 2 && buf.length > 2) {
	      if ((buf[2] & 0xC0) !== 0x80) {
	        self.lastNeed = 2;
	        return '\ufffd'.repeat(p + 2);
	      }
	    }
	  }
	}

	// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf) {
	  var p = this.lastTotal - this.lastNeed;
	  var r = utf8CheckExtraBytes(this, buf, p);
	  if (r !== undefined) return r;
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, p, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, p, 0, buf.length);
	  this.lastNeed -= buf.length;
	}

	// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf, i) {
	  var total = utf8CheckIncomplete(this, buf, i);
	  if (!this.lastNeed) return buf.toString('utf8', i);
	  this.lastTotal = total;
	  var end = buf.length - (total - this.lastNeed);
	  buf.copy(this.lastChar, 0, end);
	  return buf.toString('utf8', i, end);
	}

	// For UTF-8, a replacement character for each buffered byte of a (partial)
	// character needs to be added to the output.
	function utf8End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + '\ufffd'.repeat(this.lastTotal - this.lastNeed);
	  return r;
	}

	// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf, i) {
	  if ((buf.length - i) % 2 === 0) {
	    var r = buf.toString('utf16le', i);
	    if (r) {
	      var c = r.charCodeAt(r.length - 1);
	      if (c >= 0xD800 && c <= 0xDBFF) {
	        this.lastNeed = 2;
	        this.lastTotal = 4;
	        this.lastChar[0] = buf[buf.length - 2];
	        this.lastChar[1] = buf[buf.length - 1];
	        return r.slice(0, -1);
	      }
	    }
	    return r;
	  }
	  this.lastNeed = 1;
	  this.lastTotal = 2;
	  this.lastChar[0] = buf[buf.length - 1];
	  return buf.toString('utf16le', i, buf.length - 1);
	}

	// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) {
	    var end = this.lastTotal - this.lastNeed;
	    return r + this.lastChar.toString('utf16le', 0, end);
	  }
	  return r;
	}

	function base64Text(buf, i) {
	  var n = (buf.length - i) % 3;
	  if (n === 0) return buf.toString('base64', i);
	  this.lastNeed = 3 - n;
	  this.lastTotal = 3;
	  if (n === 1) {
	    this.lastChar[0] = buf[buf.length - 1];
	  } else {
	    this.lastChar[0] = buf[buf.length - 2];
	    this.lastChar[1] = buf[buf.length - 1];
	  }
	  return buf.toString('base64', i, buf.length - n);
	}

	function base64End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
	  return r;
	}

	// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf) {
	  return buf.toString(this.encoding);
	}

	function simpleEnd(buf) {
	  return buf && buf.length ? this.write(buf) : '';
	}

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.

	'use strict';

	module.exports = Transform;

	var Duplex = __webpack_require__(44);

	/*<replacement>*/
	var util = __webpack_require__(40);
	util.inherits = __webpack_require__(33);
	/*</replacement>*/

	util.inherits(Transform, Duplex);

	function TransformState(stream) {
	  this.afterTransform = function (er, data) {
	    return afterTransform(stream, er, data);
	  };

	  this.needTransform = false;
	  this.transforming = false;
	  this.writecb = null;
	  this.writechunk = null;
	  this.writeencoding = null;
	}

	function afterTransform(stream, er, data) {
	  var ts = stream._transformState;
	  ts.transforming = false;

	  var cb = ts.writecb;

	  if (!cb) {
	    return stream.emit('error', new Error('write callback called multiple times'));
	  }

	  ts.writechunk = null;
	  ts.writecb = null;

	  if (data !== null && data !== undefined) stream.push(data);

	  cb(er);

	  var rs = stream._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    stream._read(rs.highWaterMark);
	  }
	}

	function Transform(options) {
	  if (!(this instanceof Transform)) return new Transform(options);

	  Duplex.call(this, options);

	  this._transformState = new TransformState(this);

	  var stream = this;

	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;

	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;

	  if (options) {
	    if (typeof options.transform === 'function') this._transform = options.transform;

	    if (typeof options.flush === 'function') this._flush = options.flush;
	  }

	  // When the writable side finishes, then flush out anything remaining.
	  this.once('prefinish', function () {
	    if (typeof this._flush === 'function') this._flush(function (er, data) {
	      done(stream, er, data);
	    });else done(stream);
	  });
	}

	Transform.prototype.push = function (chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};

	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function (chunk, encoding, cb) {
	  throw new Error('_transform() is not implemented');
	};

	Transform.prototype._write = function (chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	  }
	};

	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function (n) {
	  var ts = this._transformState;

	  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};

	Transform.prototype._destroy = function (err, cb) {
	  var _this = this;

	  Duplex.prototype._destroy.call(this, err, function (err2) {
	    cb(err2);
	    _this.emit('close');
	  });
	};

	function done(stream, er, data) {
	  if (er) return stream.emit('error', er);

	  if (data !== null && data !== undefined) stream.push(data);

	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  var ws = stream._writableState;
	  var ts = stream._transformState;

	  if (ws.length) throw new Error('Calling transform done when ws.length != 0');

	  if (ts.transforming) throw new Error('Calling transform done when still transforming');

	  return stream.push(null);
	}

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.

	'use strict';

	module.exports = PassThrough;

	var Transform = __webpack_require__(50);

	/*<replacement>*/
	var util = __webpack_require__(40);
	util.inherits = __webpack_require__(33);
	/*</replacement>*/

	util.inherits(PassThrough, Transform);

	function PassThrough(options) {
	  if (!(this instanceof PassThrough)) return new PassThrough(options);

	  Transform.call(this, options);
	}

	PassThrough.prototype._transform = function (chunk, encoding, cb) {
	  cb(null, chunk);
	};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(45);


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(44);


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(34).Transform


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(34).PassThrough


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, __dirname) {/* jslint node: true */
	'use strict';

	function VirtualFileSystem() {
		this.fileSystem = {};
		this.baseSystem = {};
	}

	VirtualFileSystem.prototype.readFileSync = function (filename) {
		filename = fixFilename(filename);

		var base64content = this.baseSystem[filename];
		if (base64content) {
			return new Buffer(base64content, 'base64');
		}

		var content = this.fileSystem[filename];
		if (content) {
			return content;
		}

		throw 'File \'' + filename + '\' not found in virtual file system';
	};

	VirtualFileSystem.prototype.writeFileSync = function (filename, content) {
		this.fileSystem[fixFilename(filename)] = content;
	};

	VirtualFileSystem.prototype.bindFS = function (data) {
		this.baseSystem = data || {};
	};


	function fixFilename(filename) {
		if (filename.indexOf(__dirname) === 0) {
			filename = filename.substring(__dirname.length);
		}

		if (filename.indexOf('/') === 0) {
			filename = filename.substring(1);
		}

		return filename;
	}

	module.exports = new VirtualFileSystem();

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer, "/"))

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Generated by CoffeeScript 1.12.6

	/*
	PDFObject - converts JavaScript types into their corrisponding PDF types.
	By Devon Govett
	 */

	(function() {
	  var PDFObject, PDFReference;

	  PDFObject = (function() {
	    var escapable, escapableRe, pad, swapBytes;

	    function PDFObject() {}

	    pad = function(str, length) {
	      return (Array(length + 1).join('0') + str).slice(-length);
	    };

	    escapableRe = /[\n\r\t\b\f\(\)\\]/g;

	    escapable = {
	      '\n': '\\n',
	      '\r': '\\r',
	      '\t': '\\t',
	      '\b': '\\b',
	      '\f': '\\f',
	      '\\': '\\\\',
	      '(': '\\(',
	      ')': '\\)'
	    };

	    swapBytes = function(buff) {
	      var a, i, j, l, ref;
	      l = buff.length;
	      if (l & 0x01) {
	        throw new Error("Buffer length must be even");
	      } else {
	        for (i = j = 0, ref = l - 1; j < ref; i = j += 2) {
	          a = buff[i];
	          buff[i] = buff[i + 1];
	          buff[i + 1] = a;
	        }
	      }
	      return buff;
	    };

	    PDFObject.convert = function(object) {
	      var e, i, isUnicode, items, j, key, out, ref, string, val;
	      if (typeof object === 'string') {
	        return '/' + object;
	      } else if (object instanceof String) {
	        string = object;
	        isUnicode = false;
	        for (i = j = 0, ref = string.length; j < ref; i = j += 1) {
	          if (string.charCodeAt(i) > 0x7f) {
	            isUnicode = true;
	            break;
	          }
	        }
	        if (isUnicode) {
	          string = swapBytes(new Buffer('\ufeff' + string, 'utf16le')).toString('binary');
	        }
	        string = string.replace(escapableRe, function(c) {
	          return escapable[c];
	        });
	        return '(' + string + ')';
	      } else if (Buffer.isBuffer(object)) {
	        return '<' + object.toString('hex') + '>';
	      } else if (object instanceof PDFReference) {
	        return object.toString();
	      } else if (object instanceof Date) {
	        return '(D:' + pad(object.getUTCFullYear(), 4) + pad(object.getUTCMonth() + 1, 2) + pad(object.getUTCDate(), 2) + pad(object.getUTCHours(), 2) + pad(object.getUTCMinutes(), 2) + pad(object.getUTCSeconds(), 2) + 'Z)';
	      } else if (Array.isArray(object)) {
	        items = ((function() {
	          var k, len, results;
	          results = [];
	          for (k = 0, len = object.length; k < len; k++) {
	            e = object[k];
	            results.push(PDFObject.convert(e));
	          }
	          return results;
	        })()).join(' ');
	        return '[' + items + ']';
	      } else if ({}.toString.call(object) === '[object Object]') {
	        out = ['<<'];
	        for (key in object) {
	          val = object[key];
	          out.push('/' + key + ' ' + PDFObject.convert(val));
	        }
	        out.push('>>');
	        return out.join('\n');
	      } else if (typeof object === 'number') {
	        return PDFObject.number(object);
	      } else {
	        return '' + object;
	      }
	    };

	    PDFObject.number = function(n) {
	      if (n > -1e21 && n < 1e21) {
	        return Math.round(n * 1e6) / 1e6;
	      }
	      throw new Error("unsupported number: " + n);
	    };

	    return PDFObject;

	  })();

	  module.exports = PDFObject;

	  PDFReference = __webpack_require__(58);

	}).call(this);

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Generated by CoffeeScript 1.12.6

	/*
	PDFReference - represents a reference to another object in the PDF object heirarchy
	By Devon Govett
	 */

	(function() {
	  var PDFObject, PDFReference, stream, zlib,
	    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;

	  zlib = __webpack_require__(59);

	  stream = __webpack_require__(31);

	  PDFReference = (function(superClass) {
	    extend(PDFReference, superClass);

	    function PDFReference(document, id, data) {
	      this.document = document;
	      this.id = id;
	      this.data = data != null ? data : {};
	      this.finalize = bind(this.finalize, this);
	      PDFReference.__super__.constructor.call(this, {
	        decodeStrings: false
	      });
	      this.gen = 0;
	      this.deflate = null;
	      this.compress = this.document.compress && !this.data.Filter;
	      this.uncompressedLength = 0;
	      this.chunks = [];
	    }

	    PDFReference.prototype.initDeflate = function() {
	      this.data.Filter = 'FlateDecode';
	      this.deflate = zlib.createDeflate();
	      this.deflate.on('data', (function(_this) {
	        return function(chunk) {
	          _this.chunks.push(chunk);
	          return _this.data.Length += chunk.length;
	        };
	      })(this));
	      return this.deflate.on('end', this.finalize);
	    };

	    PDFReference.prototype._write = function(chunk, encoding, callback) {
	      var base;
	      if (!Buffer.isBuffer(chunk)) {
	        chunk = new Buffer(chunk + '\n', 'binary');
	      }
	      this.uncompressedLength += chunk.length;
	      if ((base = this.data).Length == null) {
	        base.Length = 0;
	      }
	      if (this.compress) {
	        if (!this.deflate) {
	          this.initDeflate();
	        }
	        this.deflate.write(chunk);
	      } else {
	        this.chunks.push(chunk);
	        this.data.Length += chunk.length;
	      }
	      return callback();
	    };

	    PDFReference.prototype.end = function(chunk) {
	      PDFReference.__super__.end.apply(this, arguments);
	      if (this.deflate) {
	        return this.deflate.end();
	      } else {
	        return this.finalize();
	      }
	    };

	    PDFReference.prototype.finalize = function() {
	      var chunk, i, len, ref;
	      this.offset = this.document._offset;
	      this.document._write(this.id + " " + this.gen + " obj");
	      this.document._write(PDFObject.convert(this.data));
	      if (this.chunks.length) {
	        this.document._write('stream');
	        ref = this.chunks;
	        for (i = 0, len = ref.length; i < len; i++) {
	          chunk = ref[i];
	          this.document._write(chunk);
	        }
	        this.chunks.length = 0;
	        this.document._write('\nendstream');
	      }
	      this.document._write('endobj');
	      return this.document._refEnd(this);
	    };

	    PDFReference.prototype.toString = function() {
	      return this.id + " " + this.gen + " R";
	    };

	    return PDFReference;

	  })(stream.Writable);

	  module.exports = PDFReference;

	  PDFObject = __webpack_require__(57);

	}).call(this);

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	var Transform = __webpack_require__(54);

	var binding = __webpack_require__(60);
	var util = __webpack_require__(72);
	var assert = __webpack_require__(75).ok;

	// zlib doesn't provide these, so kludge them in following the same
	// const naming scheme zlib uses.
	binding.Z_MIN_WINDOWBITS = 8;
	binding.Z_MAX_WINDOWBITS = 15;
	binding.Z_DEFAULT_WINDOWBITS = 15;

	// fewer than 64 bytes per chunk is stupid.
	// technically it could work with as few as 8, but even 64 bytes
	// is absurdly low.  Usually a MB or more is best.
	binding.Z_MIN_CHUNK = 64;
	binding.Z_MAX_CHUNK = Infinity;
	binding.Z_DEFAULT_CHUNK = (16 * 1024);

	binding.Z_MIN_MEMLEVEL = 1;
	binding.Z_MAX_MEMLEVEL = 9;
	binding.Z_DEFAULT_MEMLEVEL = 8;

	binding.Z_MIN_LEVEL = -1;
	binding.Z_MAX_LEVEL = 9;
	binding.Z_DEFAULT_LEVEL = binding.Z_DEFAULT_COMPRESSION;

	// expose all the zlib constants
	Object.keys(binding).forEach(function(k) {
	  if (k.match(/^Z/)) exports[k] = binding[k];
	});

	// translation table for return codes.
	exports.codes = {
	  Z_OK: binding.Z_OK,
	  Z_STREAM_END: binding.Z_STREAM_END,
	  Z_NEED_DICT: binding.Z_NEED_DICT,
	  Z_ERRNO: binding.Z_ERRNO,
	  Z_STREAM_ERROR: binding.Z_STREAM_ERROR,
	  Z_DATA_ERROR: binding.Z_DATA_ERROR,
	  Z_MEM_ERROR: binding.Z_MEM_ERROR,
	  Z_BUF_ERROR: binding.Z_BUF_ERROR,
	  Z_VERSION_ERROR: binding.Z_VERSION_ERROR
	};

	Object.keys(exports.codes).forEach(function(k) {
	  exports.codes[exports.codes[k]] = k;
	});

	exports.Deflate = Deflate;
	exports.Inflate = Inflate;
	exports.Gzip = Gzip;
	exports.Gunzip = Gunzip;
	exports.DeflateRaw = DeflateRaw;
	exports.InflateRaw = InflateRaw;
	exports.Unzip = Unzip;

	exports.createDeflate = function(o) {
	  return new Deflate(o);
	};

	exports.createInflate = function(o) {
	  return new Inflate(o);
	};

	exports.createDeflateRaw = function(o) {
	  return new DeflateRaw(o);
	};

	exports.createInflateRaw = function(o) {
	  return new InflateRaw(o);
	};

	exports.createGzip = function(o) {
	  return new Gzip(o);
	};

	exports.createGunzip = function(o) {
	  return new Gunzip(o);
	};

	exports.createUnzip = function(o) {
	  return new Unzip(o);
	};


	// Convenience methods.
	// compress/decompress a string or buffer in one step.
	exports.deflate = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new Deflate(opts), buffer, callback);
	};

	exports.deflateSync = function(buffer, opts) {
	  return zlibBufferSync(new Deflate(opts), buffer);
	};

	exports.gzip = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new Gzip(opts), buffer, callback);
	};

	exports.gzipSync = function(buffer, opts) {
	  return zlibBufferSync(new Gzip(opts), buffer);
	};

	exports.deflateRaw = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new DeflateRaw(opts), buffer, callback);
	};

	exports.deflateRawSync = function(buffer, opts) {
	  return zlibBufferSync(new DeflateRaw(opts), buffer);
	};

	exports.unzip = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new Unzip(opts), buffer, callback);
	};

	exports.unzipSync = function(buffer, opts) {
	  return zlibBufferSync(new Unzip(opts), buffer);
	};

	exports.inflate = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new Inflate(opts), buffer, callback);
	};

	exports.inflateSync = function(buffer, opts) {
	  return zlibBufferSync(new Inflate(opts), buffer);
	};

	exports.gunzip = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new Gunzip(opts), buffer, callback);
	};

	exports.gunzipSync = function(buffer, opts) {
	  return zlibBufferSync(new Gunzip(opts), buffer);
	};

	exports.inflateRaw = function(buffer, opts, callback) {
	  if (typeof opts === 'function') {
	    callback = opts;
	    opts = {};
	  }
	  return zlibBuffer(new InflateRaw(opts), buffer, callback);
	};

	exports.inflateRawSync = function(buffer, opts) {
	  return zlibBufferSync(new InflateRaw(opts), buffer);
	};

	function zlibBuffer(engine, buffer, callback) {
	  var buffers = [];
	  var nread = 0;

	  engine.on('error', onError);
	  engine.on('end', onEnd);

	  engine.end(buffer);
	  flow();

	  function flow() {
	    var chunk;
	    while (null !== (chunk = engine.read())) {
	      buffers.push(chunk);
	      nread += chunk.length;
	    }
	    engine.once('readable', flow);
	  }

	  function onError(err) {
	    engine.removeListener('end', onEnd);
	    engine.removeListener('readable', flow);
	    callback(err);
	  }

	  function onEnd() {
	    var buf = Buffer.concat(buffers, nread);
	    buffers = [];
	    callback(null, buf);
	    engine.close();
	  }
	}

	function zlibBufferSync(engine, buffer) {
	  if (typeof buffer === 'string')
	    buffer = new Buffer(buffer);
	  if (!Buffer.isBuffer(buffer))
	    throw new TypeError('Not a string or buffer');

	  var flushFlag = binding.Z_FINISH;

	  return engine._processChunk(buffer, flushFlag);
	}

	// generic zlib
	// minimal 2-byte header
	function Deflate(opts) {
	  if (!(this instanceof Deflate)) return new Deflate(opts);
	  Zlib.call(this, opts, binding.DEFLATE);
	}

	function Inflate(opts) {
	  if (!(this instanceof Inflate)) return new Inflate(opts);
	  Zlib.call(this, opts, binding.INFLATE);
	}



	// gzip - bigger header, same deflate compression
	function Gzip(opts) {
	  if (!(this instanceof Gzip)) return new Gzip(opts);
	  Zlib.call(this, opts, binding.GZIP);
	}

	function Gunzip(opts) {
	  if (!(this instanceof Gunzip)) return new Gunzip(opts);
	  Zlib.call(this, opts, binding.GUNZIP);
	}



	// raw - no header
	function DeflateRaw(opts) {
	  if (!(this instanceof DeflateRaw)) return new DeflateRaw(opts);
	  Zlib.call(this, opts, binding.DEFLATERAW);
	}

	function InflateRaw(opts) {
	  if (!(this instanceof InflateRaw)) return new InflateRaw(opts);
	  Zlib.call(this, opts, binding.INFLATERAW);
	}


	// auto-detect header.
	function Unzip(opts) {
	  if (!(this instanceof Unzip)) return new Unzip(opts);
	  Zlib.call(this, opts, binding.UNZIP);
	}


	// the Zlib class they all inherit from
	// This thing manages the queue of requests, and returns
	// true or false if there is anything in the queue when
	// you call the .write() method.

	function Zlib(opts, mode) {
	  this._opts = opts = opts || {};
	  this._chunkSize = opts.chunkSize || exports.Z_DEFAULT_CHUNK;

	  Transform.call(this, opts);

	  if (opts.flush) {
	    if (opts.flush !== binding.Z_NO_FLUSH &&
	        opts.flush !== binding.Z_PARTIAL_FLUSH &&
	        opts.flush !== binding.Z_SYNC_FLUSH &&
	        opts.flush !== binding.Z_FULL_FLUSH &&
	        opts.flush !== binding.Z_FINISH &&
	        opts.flush !== binding.Z_BLOCK) {
	      throw new Error('Invalid flush flag: ' + opts.flush);
	    }
	  }
	  this._flushFlag = opts.flush || binding.Z_NO_FLUSH;

	  if (opts.chunkSize) {
	    if (opts.chunkSize < exports.Z_MIN_CHUNK ||
	        opts.chunkSize > exports.Z_MAX_CHUNK) {
	      throw new Error('Invalid chunk size: ' + opts.chunkSize);
	    }
	  }

	  if (opts.windowBits) {
	    if (opts.windowBits < exports.Z_MIN_WINDOWBITS ||
	        opts.windowBits > exports.Z_MAX_WINDOWBITS) {
	      throw new Error('Invalid windowBits: ' + opts.windowBits);
	    }
	  }

	  if (opts.level) {
	    if (opts.level < exports.Z_MIN_LEVEL ||
	        opts.level > exports.Z_MAX_LEVEL) {
	      throw new Error('Invalid compression level: ' + opts.level);
	    }
	  }

	  if (opts.memLevel) {
	    if (opts.memLevel < exports.Z_MIN_MEMLEVEL ||
	        opts.memLevel > exports.Z_MAX_MEMLEVEL) {
	      throw new Error('Invalid memLevel: ' + opts.memLevel);
	    }
	  }

	  if (opts.strategy) {
	    if (opts.strategy != exports.Z_FILTERED &&
	        opts.strategy != exports.Z_HUFFMAN_ONLY &&
	        opts.strategy != exports.Z_RLE &&
	        opts.strategy != exports.Z_FIXED &&
	        opts.strategy != exports.Z_DEFAULT_STRATEGY) {
	      throw new Error('Invalid strategy: ' + opts.strategy);
	    }
	  }

	  if (opts.dictionary) {
	    if (!Buffer.isBuffer(opts.dictionary)) {
	      throw new Error('Invalid dictionary: it should be a Buffer instance');
	    }
	  }

	  this._binding = new binding.Zlib(mode);

	  var self = this;
	  this._hadError = false;
	  this._binding.onerror = function(message, errno) {
	    // there is no way to cleanly recover.
	    // continuing only obscures problems.
	    self._binding = null;
	    self._hadError = true;

	    var error = new Error(message);
	    error.errno = errno;
	    error.code = exports.codes[errno];
	    self.emit('error', error);
	  };

	  var level = exports.Z_DEFAULT_COMPRESSION;
	  if (typeof opts.level === 'number') level = opts.level;

	  var strategy = exports.Z_DEFAULT_STRATEGY;
	  if (typeof opts.strategy === 'number') strategy = opts.strategy;

	  this._binding.init(opts.windowBits || exports.Z_DEFAULT_WINDOWBITS,
	                     level,
	                     opts.memLevel || exports.Z_DEFAULT_MEMLEVEL,
	                     strategy,
	                     opts.dictionary);

	  this._buffer = new Buffer(this._chunkSize);
	  this._offset = 0;
	  this._closed = false;
	  this._level = level;
	  this._strategy = strategy;

	  this.once('end', this.close);
	}

	util.inherits(Zlib, Transform);

	Zlib.prototype.params = function(level, strategy, callback) {
	  if (level < exports.Z_MIN_LEVEL ||
	      level > exports.Z_MAX_LEVEL) {
	    throw new RangeError('Invalid compression level: ' + level);
	  }
	  if (strategy != exports.Z_FILTERED &&
	      strategy != exports.Z_HUFFMAN_ONLY &&
	      strategy != exports.Z_RLE &&
	      strategy != exports.Z_FIXED &&
	      strategy != exports.Z_DEFAULT_STRATEGY) {
	    throw new TypeError('Invalid strategy: ' + strategy);
	  }

	  if (this._level !== level || this._strategy !== strategy) {
	    var self = this;
	    this.flush(binding.Z_SYNC_FLUSH, function() {
	      self._binding.params(level, strategy);
	      if (!self._hadError) {
	        self._level = level;
	        self._strategy = strategy;
	        if (callback) callback();
	      }
	    });
	  } else {
	    process.nextTick(callback);
	  }
	};

	Zlib.prototype.reset = function() {
	  return this._binding.reset();
	};

	// This is the _flush function called by the transform class,
	// internally, when the last chunk has been written.
	Zlib.prototype._flush = function(callback) {
	  this._transform(new Buffer(0), '', callback);
	};

	Zlib.prototype.flush = function(kind, callback) {
	  var ws = this._writableState;

	  if (typeof kind === 'function' || (kind === void 0 && !callback)) {
	    callback = kind;
	    kind = binding.Z_FULL_FLUSH;
	  }

	  if (ws.ended) {
	    if (callback)
	      process.nextTick(callback);
	  } else if (ws.ending) {
	    if (callback)
	      this.once('end', callback);
	  } else if (ws.needDrain) {
	    var self = this;
	    this.once('drain', function() {
	      self.flush(callback);
	    });
	  } else {
	    this._flushFlag = kind;
	    this.write(new Buffer(0), '', callback);
	  }
	};

	Zlib.prototype.close = function(callback) {
	  if (callback)
	    process.nextTick(callback);

	  if (this._closed)
	    return;

	  this._closed = true;

	  this._binding.close();

	  var self = this;
	  process.nextTick(function() {
	    self.emit('close');
	  });
	};

	Zlib.prototype._transform = function(chunk, encoding, cb) {
	  var flushFlag;
	  var ws = this._writableState;
	  var ending = ws.ending || ws.ended;
	  var last = ending && (!chunk || ws.length === chunk.length);

	  if (!chunk === null && !Buffer.isBuffer(chunk))
	    return cb(new Error('invalid input'));

	  // If it's the last chunk, or a final flush, we use the Z_FINISH flush flag.
	  // If it's explicitly flushing at some other time, then we use
	  // Z_FULL_FLUSH. Otherwise, use Z_NO_FLUSH for maximum compression
	  // goodness.
	  if (last)
	    flushFlag = binding.Z_FINISH;
	  else {
	    flushFlag = this._flushFlag;
	    // once we've flushed the last of the queue, stop flushing and
	    // go back to the normal behavior.
	    if (chunk.length >= ws.length) {
	      this._flushFlag = this._opts.flush || binding.Z_NO_FLUSH;
	    }
	  }

	  var self = this;
	  this._processChunk(chunk, flushFlag, cb);
	};

	Zlib.prototype._processChunk = function(chunk, flushFlag, cb) {
	  var availInBefore = chunk && chunk.length;
	  var availOutBefore = this._chunkSize - this._offset;
	  var inOff = 0;

	  var self = this;

	  var async = typeof cb === 'function';

	  if (!async) {
	    var buffers = [];
	    var nread = 0;

	    var error;
	    this.on('error', function(er) {
	      error = er;
	    });

	    do {
	      var res = this._binding.writeSync(flushFlag,
	                                        chunk, // in
	                                        inOff, // in_off
	                                        availInBefore, // in_len
	                                        this._buffer, // out
	                                        this._offset, //out_off
	                                        availOutBefore); // out_len
	    } while (!this._hadError && callback(res[0], res[1]));

	    if (this._hadError) {
	      throw error;
	    }

	    var buf = Buffer.concat(buffers, nread);
	    this.close();

	    return buf;
	  }

	  var req = this._binding.write(flushFlag,
	                                chunk, // in
	                                inOff, // in_off
	                                availInBefore, // in_len
	                                this._buffer, // out
	                                this._offset, //out_off
	                                availOutBefore); // out_len

	  req.buffer = chunk;
	  req.callback = callback;

	  function callback(availInAfter, availOutAfter) {
	    if (self._hadError)
	      return;

	    var have = availOutBefore - availOutAfter;
	    assert(have >= 0, 'have should not go down');

	    if (have > 0) {
	      var out = self._buffer.slice(self._offset, self._offset + have);
	      self._offset += have;
	      // serve some output to the consumer.
	      if (async) {
	        self.push(out);
	      } else {
	        buffers.push(out);
	        nread += out.length;
	      }
	    }

	    // exhausted the output buffer, or used all the input create a new one.
	    if (availOutAfter === 0 || self._offset >= self._chunkSize) {
	      availOutBefore = self._chunkSize;
	      self._offset = 0;
	      self._buffer = new Buffer(self._chunkSize);
	    }

	    if (availOutAfter === 0) {
	      // Not actually done.  Need to reprocess.
	      // Also, update the availInBefore to the availInAfter value,
	      // so that if we have to hit it a third (fourth, etc.) time,
	      // it'll have the correct byte counts.
	      inOff += (availInBefore - availInAfter);
	      availInBefore = availInAfter;

	      if (!async)
	        return true;

	      var newReq = self._binding.write(flushFlag,
	                                       chunk,
	                                       inOff,
	                                       availInBefore,
	                                       self._buffer,
	                                       self._offset,
	                                       self._chunkSize);
	      newReq.callback = callback; // this same function
	      newReq.buffer = chunk;
	      return;
	    }

	    if (!async)
	      return false;

	    // finished with the chunk.
	    cb();
	  }
	};

	util.inherits(Deflate, Zlib);
	util.inherits(Inflate, Zlib);
	util.inherits(Gzip, Zlib);
	util.inherits(Gunzip, Zlib);
	util.inherits(DeflateRaw, Zlib);
	util.inherits(InflateRaw, Zlib);
	util.inherits(Unzip, Zlib);

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer, __webpack_require__(36)))

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, Buffer) {var msg = __webpack_require__(61);
	var zstream = __webpack_require__(62);
	var zlib_deflate = __webpack_require__(63);
	var zlib_inflate = __webpack_require__(68);
	var constants = __webpack_require__(71);

	for (var key in constants) {
	  exports[key] = constants[key];
	}

	// zlib modes
	exports.NONE = 0;
	exports.DEFLATE = 1;
	exports.INFLATE = 2;
	exports.GZIP = 3;
	exports.GUNZIP = 4;
	exports.DEFLATERAW = 5;
	exports.INFLATERAW = 6;
	exports.UNZIP = 7;

	/**
	 * Emulate Node's zlib C++ layer for use by the JS layer in index.js
	 */
	function Zlib(mode) {
	  if (mode < exports.DEFLATE || mode > exports.UNZIP)
	    throw new TypeError("Bad argument");
	    
	  this.mode = mode;
	  this.init_done = false;
	  this.write_in_progress = false;
	  this.pending_close = false;
	  this.windowBits = 0;
	  this.level = 0;
	  this.memLevel = 0;
	  this.strategy = 0;
	  this.dictionary = null;
	}

	Zlib.prototype.init = function(windowBits, level, memLevel, strategy, dictionary) {
	  this.windowBits = windowBits;
	  this.level = level;
	  this.memLevel = memLevel;
	  this.strategy = strategy;
	  // dictionary not supported.
	  
	  if (this.mode === exports.GZIP || this.mode === exports.GUNZIP)
	    this.windowBits += 16;
	    
	  if (this.mode === exports.UNZIP)
	    this.windowBits += 32;
	    
	  if (this.mode === exports.DEFLATERAW || this.mode === exports.INFLATERAW)
	    this.windowBits = -this.windowBits;
	    
	  this.strm = new zstream();
	  
	  switch (this.mode) {
	    case exports.DEFLATE:
	    case exports.GZIP:
	    case exports.DEFLATERAW:
	      var status = zlib_deflate.deflateInit2(
	        this.strm,
	        this.level,
	        exports.Z_DEFLATED,
	        this.windowBits,
	        this.memLevel,
	        this.strategy
	      );
	      break;
	    case exports.INFLATE:
	    case exports.GUNZIP:
	    case exports.INFLATERAW:
	    case exports.UNZIP:
	      var status  = zlib_inflate.inflateInit2(
	        this.strm,
	        this.windowBits
	      );
	      break;
	    default:
	      throw new Error("Unknown mode " + this.mode);
	  }
	  
	  if (status !== exports.Z_OK) {
	    this._error(status);
	    return;
	  }
	  
	  this.write_in_progress = false;
	  this.init_done = true;
	};

	Zlib.prototype.params = function() {
	  throw new Error("deflateParams Not supported");
	};

	Zlib.prototype._writeCheck = function() {
	  if (!this.init_done)
	    throw new Error("write before init");
	    
	  if (this.mode === exports.NONE)
	    throw new Error("already finalized");
	    
	  if (this.write_in_progress)
	    throw new Error("write already in progress");
	    
	  if (this.pending_close)
	    throw new Error("close is pending");
	};

	Zlib.prototype.write = function(flush, input, in_off, in_len, out, out_off, out_len) {    
	  this._writeCheck();
	  this.write_in_progress = true;
	  
	  var self = this;
	  process.nextTick(function() {
	    self.write_in_progress = false;
	    var res = self._write(flush, input, in_off, in_len, out, out_off, out_len);
	    self.callback(res[0], res[1]);
	    
	    if (self.pending_close)
	      self.close();
	  });
	  
	  return this;
	};

	// set method for Node buffers, used by pako
	function bufferSet(data, offset) {
	  for (var i = 0; i < data.length; i++) {
	    this[offset + i] = data[i];
	  }
	}

	Zlib.prototype.writeSync = function(flush, input, in_off, in_len, out, out_off, out_len) {
	  this._writeCheck();
	  return this._write(flush, input, in_off, in_len, out, out_off, out_len);
	};

	Zlib.prototype._write = function(flush, input, in_off, in_len, out, out_off, out_len) {
	  this.write_in_progress = true;
	  
	  if (flush !== exports.Z_NO_FLUSH &&
	      flush !== exports.Z_PARTIAL_FLUSH &&
	      flush !== exports.Z_SYNC_FLUSH &&
	      flush !== exports.Z_FULL_FLUSH &&
	      flush !== exports.Z_FINISH &&
	      flush !== exports.Z_BLOCK) {
	    throw new Error("Invalid flush value");
	  }
	  
	  if (input == null) {
	    input = new Buffer(0);
	    in_len = 0;
	    in_off = 0;
	  }
	  
	  if (out._set)
	    out.set = out._set;
	  else
	    out.set = bufferSet;
	  
	  var strm = this.strm;
	  strm.avail_in = in_len;
	  strm.input = input;
	  strm.next_in = in_off;
	  strm.avail_out = out_len;
	  strm.output = out;
	  strm.next_out = out_off;
	  
	  switch (this.mode) {
	    case exports.DEFLATE:
	    case exports.GZIP:
	    case exports.DEFLATERAW:
	      var status = zlib_deflate.deflate(strm, flush);
	      break;
	    case exports.UNZIP:
	    case exports.INFLATE:
	    case exports.GUNZIP:
	    case exports.INFLATERAW:
	      var status = zlib_inflate.inflate(strm, flush);
	      break;
	    default:
	      throw new Error("Unknown mode " + this.mode);
	  }
	  
	  if (status !== exports.Z_STREAM_END && status !== exports.Z_OK) {
	    this._error(status);
	  }
	  
	  this.write_in_progress = false;
	  return [strm.avail_in, strm.avail_out];
	};

	Zlib.prototype.close = function() {
	  if (this.write_in_progress) {
	    this.pending_close = true;
	    return;
	  }
	  
	  this.pending_close = false;
	  
	  if (this.mode === exports.DEFLATE || this.mode === exports.GZIP || this.mode === exports.DEFLATERAW) {
	    zlib_deflate.deflateEnd(this.strm);
	  } else {
	    zlib_inflate.inflateEnd(this.strm);
	  }
	  
	  this.mode = exports.NONE;
	};

	Zlib.prototype.reset = function() {
	  switch (this.mode) {
	    case exports.DEFLATE:
	    case exports.DEFLATERAW:
	      var status = zlib_deflate.deflateReset(this.strm);
	      break;
	    case exports.INFLATE:
	    case exports.INFLATERAW:
	      var status = zlib_inflate.inflateReset(this.strm);
	      break;
	  }
	  
	  if (status !== exports.Z_OK) {
	    this._error(status);
	  }
	};

	Zlib.prototype._error = function(status) {
	  this.onerror(msg[status] + ': ' + this.strm.msg, status);
	  
	  this.write_in_progress = false;
	  if (this.pending_close)
	    this.close();
	};

	exports.Zlib = Zlib;

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36), __webpack_require__(2).Buffer))

/***/ }),
/* 61 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = {
	  2:      'need dictionary',     /* Z_NEED_DICT       2  */
	  1:      'stream end',          /* Z_STREAM_END      1  */
	  0:      '',                    /* Z_OK              0  */
	  '-1':   'file error',          /* Z_ERRNO         (-1) */
	  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
	  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
	  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
	  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
	  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
	};


/***/ }),
/* 62 */
/***/ (function(module, exports) {

	'use strict';


	function ZStream() {
	  /* next input byte */
	  this.input = null; // JS specific, because we have no pointers
	  this.next_in = 0;
	  /* number of bytes available at input */
	  this.avail_in = 0;
	  /* total number of input bytes read so far */
	  this.total_in = 0;
	  /* next output byte should be put there */
	  this.output = null; // JS specific, because we have no pointers
	  this.next_out = 0;
	  /* remaining free space at output */
	  this.avail_out = 0;
	  /* total number of bytes output so far */
	  this.total_out = 0;
	  /* last error message, NULL if no error */
	  this.msg = ''/*Z_NULL*/;
	  /* not visible by applications */
	  this.state = null;
	  /* best guess about the data type: binary or text */
	  this.data_type = 2/*Z_UNKNOWN*/;
	  /* adler32 value of the uncompressed data */
	  this.adler = 0;
	}

	module.exports = ZStream;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var utils   = __webpack_require__(64);
	var trees   = __webpack_require__(65);
	var adler32 = __webpack_require__(66);
	var crc32   = __webpack_require__(67);
	var msg     = __webpack_require__(61);

	/* Public constants ==========================================================*/
	/* ===========================================================================*/


	/* Allowed flush values; see deflate() and inflate() below for details */
	var Z_NO_FLUSH      = 0;
	var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	//var Z_TREES         = 6;


	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	//var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	//var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;


	/* compression levels */
	//var Z_NO_COMPRESSION      = 0;
	//var Z_BEST_SPEED          = 1;
	//var Z_BEST_COMPRESSION    = 9;
	var Z_DEFAULT_COMPRESSION = -1;


	var Z_FILTERED            = 1;
	var Z_HUFFMAN_ONLY        = 2;
	var Z_RLE                 = 3;
	var Z_FIXED               = 4;
	var Z_DEFAULT_STRATEGY    = 0;

	/* Possible values of the data_type field (though see inflate()) */
	//var Z_BINARY              = 0;
	//var Z_TEXT                = 1;
	//var Z_ASCII               = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;


	/* The deflate compression method */
	var Z_DEFLATED  = 8;

	/*============================================================================*/


	var MAX_MEM_LEVEL = 9;
	/* Maximum value for memLevel in deflateInit2 */
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_MEM_LEVEL = 8;


	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	var D_CODES       = 30;
	/* number of distance codes */
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	var HEAP_SIZE     = 2 * L_CODES + 1;
	/* maximum heap size */
	var MAX_BITS  = 15;
	/* All codes must not exceed MAX_BITS bits */

	var MIN_MATCH = 3;
	var MAX_MATCH = 258;
	var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);

	var PRESET_DICT = 0x20;

	var INIT_STATE = 42;
	var EXTRA_STATE = 69;
	var NAME_STATE = 73;
	var COMMENT_STATE = 91;
	var HCRC_STATE = 103;
	var BUSY_STATE = 113;
	var FINISH_STATE = 666;

	var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
	var BS_BLOCK_DONE     = 2; /* block flush performed */
	var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
	var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */

	var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.

	function err(strm, errorCode) {
	  strm.msg = msg[errorCode];
	  return errorCode;
	}

	function rank(f) {
	  return ((f) << 1) - ((f) > 4 ? 9 : 0);
	}

	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }


	/* =========================================================================
	 * Flush as much pending output as possible. All deflate() output goes
	 * through this function so some applications may wish to modify it
	 * to avoid allocating a large strm->output buffer and copying into it.
	 * (See also read_buf()).
	 */
	function flush_pending(strm) {
	  var s = strm.state;

	  //_tr_flush_bits(s);
	  var len = s.pending;
	  if (len > strm.avail_out) {
	    len = strm.avail_out;
	  }
	  if (len === 0) { return; }

	  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
	  strm.next_out += len;
	  s.pending_out += len;
	  strm.total_out += len;
	  strm.avail_out -= len;
	  s.pending -= len;
	  if (s.pending === 0) {
	    s.pending_out = 0;
	  }
	}


	function flush_block_only(s, last) {
	  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
	  s.block_start = s.strstart;
	  flush_pending(s.strm);
	}


	function put_byte(s, b) {
	  s.pending_buf[s.pending++] = b;
	}


	/* =========================================================================
	 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
	 * IN assertion: the stream state is correct and there is enough room in
	 * pending_buf.
	 */
	function putShortMSB(s, b) {
	//  put_byte(s, (Byte)(b >> 8));
	//  put_byte(s, (Byte)(b & 0xff));
	  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
	  s.pending_buf[s.pending++] = b & 0xff;
	}


	/* ===========================================================================
	 * Read a new buffer from the current input stream, update the adler32
	 * and total number of bytes read.  All deflate() input goes through
	 * this function so some applications may wish to modify it to avoid
	 * allocating a large strm->input buffer and copying from it.
	 * (See also flush_pending()).
	 */
	function read_buf(strm, buf, start, size) {
	  var len = strm.avail_in;

	  if (len > size) { len = size; }
	  if (len === 0) { return 0; }

	  strm.avail_in -= len;

	  // zmemcpy(buf, strm->next_in, len);
	  utils.arraySet(buf, strm.input, strm.next_in, len, start);
	  if (strm.state.wrap === 1) {
	    strm.adler = adler32(strm.adler, buf, len, start);
	  }

	  else if (strm.state.wrap === 2) {
	    strm.adler = crc32(strm.adler, buf, len, start);
	  }

	  strm.next_in += len;
	  strm.total_in += len;

	  return len;
	}


	/* ===========================================================================
	 * Set match_start to the longest match starting at the given string and
	 * return its length. Matches shorter or equal to prev_length are discarded,
	 * in which case the result is equal to prev_length and match_start is
	 * garbage.
	 * IN assertions: cur_match is the head of the hash chain for the current
	 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
	 * OUT assertion: the match length is not greater than s->lookahead.
	 */
	function longest_match(s, cur_match) {
	  var chain_length = s.max_chain_length;      /* max hash chain length */
	  var scan = s.strstart; /* current string */
	  var match;                       /* matched string */
	  var len;                           /* length of current match */
	  var best_len = s.prev_length;              /* best match length so far */
	  var nice_match = s.nice_match;             /* stop if match long enough */
	  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
	      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;

	  var _win = s.window; // shortcut

	  var wmask = s.w_mask;
	  var prev  = s.prev;

	  /* Stop when cur_match becomes <= limit. To simplify the code,
	   * we prevent matches with the string of window index 0.
	   */

	  var strend = s.strstart + MAX_MATCH;
	  var scan_end1  = _win[scan + best_len - 1];
	  var scan_end   = _win[scan + best_len];

	  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
	   * It is easy to get rid of this optimization if necessary.
	   */
	  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");

	  /* Do not waste too much time if we already have a good match: */
	  if (s.prev_length >= s.good_match) {
	    chain_length >>= 2;
	  }
	  /* Do not look for matches beyond the end of the input. This is necessary
	   * to make deflate deterministic.
	   */
	  if (nice_match > s.lookahead) { nice_match = s.lookahead; }

	  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");

	  do {
	    // Assert(cur_match < s->strstart, "no future");
	    match = cur_match;

	    /* Skip to next match if the match length cannot increase
	     * or if the match length is less than 2.  Note that the checks below
	     * for insufficient lookahead only occur occasionally for performance
	     * reasons.  Therefore uninitialized memory will be accessed, and
	     * conditional jumps will be made that depend on those values.
	     * However the length of the match is limited to the lookahead, so
	     * the output of deflate is not affected by the uninitialized values.
	     */

	    if (_win[match + best_len]     !== scan_end  ||
	        _win[match + best_len - 1] !== scan_end1 ||
	        _win[match]                !== _win[scan] ||
	        _win[++match]              !== _win[scan + 1]) {
	      continue;
	    }

	    /* The check at best_len-1 can be removed because it will be made
	     * again later. (This heuristic is not always a win.)
	     * It is not necessary to compare scan[2] and match[2] since they
	     * are always equal when the other bytes match, given that
	     * the hash keys are equal and that HASH_BITS >= 8.
	     */
	    scan += 2;
	    match++;
	    // Assert(*scan == *match, "match[2]?");

	    /* We check for insufficient lookahead only every 8th comparison;
	     * the 256th check will be made at strstart+258.
	     */
	    do {
	      /*jshint noempty:false*/
	    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             scan < strend);

	    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");

	    len = MAX_MATCH - (strend - scan);
	    scan = strend - MAX_MATCH;

	    if (len > best_len) {
	      s.match_start = cur_match;
	      best_len = len;
	      if (len >= nice_match) {
	        break;
	      }
	      scan_end1  = _win[scan + best_len - 1];
	      scan_end   = _win[scan + best_len];
	    }
	  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);

	  if (best_len <= s.lookahead) {
	    return best_len;
	  }
	  return s.lookahead;
	}


	/* ===========================================================================
	 * Fill the window when the lookahead becomes insufficient.
	 * Updates strstart and lookahead.
	 *
	 * IN assertion: lookahead < MIN_LOOKAHEAD
	 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
	 *    At least one byte has been read, or avail_in == 0; reads are
	 *    performed for at least two bytes (required for the zip translate_eol
	 *    option -- not supported here).
	 */
	function fill_window(s) {
	  var _w_size = s.w_size;
	  var p, n, m, more, str;

	  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");

	  do {
	    more = s.window_size - s.lookahead - s.strstart;

	    // JS ints have 32 bit, block below not needed
	    /* Deal with !@#$% 64K limit: */
	    //if (sizeof(int) <= 2) {
	    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
	    //        more = wsize;
	    //
	    //  } else if (more == (unsigned)(-1)) {
	    //        /* Very unlikely, but possible on 16 bit machine if
	    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
	    //         */
	    //        more--;
	    //    }
	    //}


	    /* If the window is almost full and there is insufficient lookahead,
	     * move the upper half to the lower one to make room in the upper half.
	     */
	    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {

	      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
	      s.match_start -= _w_size;
	      s.strstart -= _w_size;
	      /* we now have strstart >= MAX_DIST */
	      s.block_start -= _w_size;

	      /* Slide the hash table (could be avoided with 32 bit values
	       at the expense of memory usage). We slide even when level == 0
	       to keep the hash table consistent if we switch back to level > 0
	       later. (Using level 0 permanently is not an optimal usage of
	       zlib, so we don't care about this pathological case.)
	       */

	      n = s.hash_size;
	      p = n;
	      do {
	        m = s.head[--p];
	        s.head[p] = (m >= _w_size ? m - _w_size : 0);
	      } while (--n);

	      n = _w_size;
	      p = n;
	      do {
	        m = s.prev[--p];
	        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
	        /* If n is not on any hash chain, prev[n] is garbage but
	         * its value will never be used.
	         */
	      } while (--n);

	      more += _w_size;
	    }
	    if (s.strm.avail_in === 0) {
	      break;
	    }

	    /* If there was no sliding:
	     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
	     *    more == window_size - lookahead - strstart
	     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
	     * => more >= window_size - 2*WSIZE + 2
	     * In the BIG_MEM or MMAP case (not yet supported),
	     *   window_size == input_size + MIN_LOOKAHEAD  &&
	     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
	     * Otherwise, window_size == 2*WSIZE so more >= 2.
	     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
	     */
	    //Assert(more >= 2, "more < 2");
	    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
	    s.lookahead += n;

	    /* Initialize the hash value now that we have some input: */
	    if (s.lookahead + s.insert >= MIN_MATCH) {
	      str = s.strstart - s.insert;
	      s.ins_h = s.window[str];

	      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
	//#if MIN_MATCH != 3
	//        Call update_hash() MIN_MATCH-3 more times
	//#endif
	      while (s.insert) {
	        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;

	        s.prev[str & s.w_mask] = s.head[s.ins_h];
	        s.head[s.ins_h] = str;
	        str++;
	        s.insert--;
	        if (s.lookahead + s.insert < MIN_MATCH) {
	          break;
	        }
	      }
	    }
	    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
	     * but this is not important since only literal bytes will be emitted.
	     */

	  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);

	  /* If the WIN_INIT bytes after the end of the current data have never been
	   * written, then zero those bytes in order to avoid memory check reports of
	   * the use of uninitialized (or uninitialised as Julian writes) bytes by
	   * the longest match routines.  Update the high water mark for the next
	   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
	   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
	   */
	//  if (s.high_water < s.window_size) {
	//    var curr = s.strstart + s.lookahead;
	//    var init = 0;
	//
	//    if (s.high_water < curr) {
	//      /* Previous high water mark below current data -- zero WIN_INIT
	//       * bytes or up to end of window, whichever is less.
	//       */
	//      init = s.window_size - curr;
	//      if (init > WIN_INIT)
	//        init = WIN_INIT;
	//      zmemzero(s->window + curr, (unsigned)init);
	//      s->high_water = curr + init;
	//    }
	//    else if (s->high_water < (ulg)curr + WIN_INIT) {
	//      /* High water mark at or above current data, but below current data
	//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
	//       * to end of window, whichever is less.
	//       */
	//      init = (ulg)curr + WIN_INIT - s->high_water;
	//      if (init > s->window_size - s->high_water)
	//        init = s->window_size - s->high_water;
	//      zmemzero(s->window + s->high_water, (unsigned)init);
	//      s->high_water += init;
	//    }
	//  }
	//
	//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
	//    "not enough room for search");
	}

	/* ===========================================================================
	 * Copy without compression as much as possible from the input stream, return
	 * the current block state.
	 * This function does not insert new strings in the dictionary since
	 * uncompressible data is probably not useful. This function is used
	 * only for the level=0 compression option.
	 * NOTE: this function should be optimized to avoid extra copying from
	 * window to pending_buf.
	 */
	function deflate_stored(s, flush) {
	  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
	   * to pending_buf_size, and each stored block has a 5 byte header:
	   */
	  var max_block_size = 0xffff;

	  if (max_block_size > s.pending_buf_size - 5) {
	    max_block_size = s.pending_buf_size - 5;
	  }

	  /* Copy as much as possible from input to output: */
	  for (;;) {
	    /* Fill the window as much as possible: */
	    if (s.lookahead <= 1) {

	      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
	      //  s->block_start >= (long)s->w_size, "slide too late");
	//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
	//        s.block_start >= s.w_size)) {
	//        throw  new Error("slide too late");
	//      }

	      fill_window(s);
	      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }

	      if (s.lookahead === 0) {
	        break;
	      }
	      /* flush the current block */
	    }
	    //Assert(s->block_start >= 0L, "block gone");
	//    if (s.block_start < 0) throw new Error("block gone");

	    s.strstart += s.lookahead;
	    s.lookahead = 0;

	    /* Emit a stored block if pending_buf will be full: */
	    var max_start = s.block_start + max_block_size;

	    if (s.strstart === 0 || s.strstart >= max_start) {
	      /* strstart == 0 is possible when wraparound on 16-bit machine */
	      s.lookahead = s.strstart - max_start;
	      s.strstart = max_start;
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/


	    }
	    /* Flush if we may have to slide, otherwise block_start may become
	     * negative and the data will be gone:
	     */
	    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }

	  s.insert = 0;

	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }

	  if (s.strstart > s.block_start) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }

	  return BS_NEED_MORE;
	}

	/* ===========================================================================
	 * Compress as much as possible from the input stream, return the current
	 * block state.
	 * This function does not perform lazy evaluation of matches and inserts
	 * new strings in the dictionary only for unmatched strings or for short
	 * matches. It is used only for the fast compression options.
	 */
	function deflate_fast(s, flush) {
	  var hash_head;        /* head of the hash chain */
	  var bflush;           /* set if current block must be flushed */

	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) {
	        break; /* flush the current block */
	      }
	    }

	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }

	    /* Find the longest match, discarding those <= prev_length.
	     * At this point we have always match_length < MIN_MATCH
	     */
	    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	    }
	    if (s.match_length >= MIN_MATCH) {
	      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only

	      /*** _tr_tally_dist(s, s.strstart - s.match_start,
	                     s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);

	      s.lookahead -= s.match_length;

	      /* Insert new strings in the hash table only if the match length
	       * is not too large. This saves time but degrades compression.
	       */
	      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
	        s.match_length--; /* string at strstart already in table */
	        do {
	          s.strstart++;
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
	           * always MIN_MATCH bytes ahead.
	           */
	        } while (--s.match_length !== 0);
	        s.strstart++;
	      } else
	      {
	        s.strstart += s.match_length;
	        s.match_length = 0;
	        s.ins_h = s.window[s.strstart];
	        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;

	//#if MIN_MATCH != 3
	//                Call UPDATE_HASH() MIN_MATCH-3 more times
	//#endif
	        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
	         * matter since it will be recomputed at next deflate call.
	         */
	      }
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s.window[s.strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}

	/* ===========================================================================
	 * Same as above, but achieves better compression. We use a lazy
	 * evaluation for matches: a match is finally adopted only if there is
	 * no better match at the next window position.
	 */
	function deflate_slow(s, flush) {
	  var hash_head;          /* head of hash chain */
	  var bflush;              /* set if current block must be flushed */

	  var max_insert;

	  /* Process the input block. */
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }

	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }

	    /* Find the longest match, discarding those <= prev_length.
	     */
	    s.prev_length = s.match_length;
	    s.prev_match = s.match_start;
	    s.match_length = MIN_MATCH - 1;

	    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
	        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */

	      if (s.match_length <= 5 &&
	         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {

	        /* If prev_match is also MIN_MATCH, match_start is garbage
	         * but we will ignore the current match anyway.
	         */
	        s.match_length = MIN_MATCH - 1;
	      }
	    }
	    /* If there was a match at the previous step and the current
	     * match is not better, output the previous match:
	     */
	    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
	      max_insert = s.strstart + s.lookahead - MIN_MATCH;
	      /* Do not insert strings in hash table beyond this. */

	      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);

	      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
	                     s.prev_length - MIN_MATCH, bflush);***/
	      bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
	      /* Insert in hash table all strings up to the end of the match.
	       * strstart-1 and strstart are already inserted. If there is not
	       * enough lookahead, the last two strings are not inserted in
	       * the hash table.
	       */
	      s.lookahead -= s.prev_length - 1;
	      s.prev_length -= 2;
	      do {
	        if (++s.strstart <= max_insert) {
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	        }
	      } while (--s.prev_length !== 0);
	      s.match_available = 0;
	      s.match_length = MIN_MATCH - 1;
	      s.strstart++;

	      if (bflush) {
	        /*** FLUSH_BLOCK(s, 0); ***/
	        flush_block_only(s, false);
	        if (s.strm.avail_out === 0) {
	          return BS_NEED_MORE;
	        }
	        /***/
	      }

	    } else if (s.match_available) {
	      /* If there was no match at the previous position, output a
	       * single literal. If there was a match but the current match
	       * is longer, truncate the previous match to a single literal.
	       */
	      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

	      if (bflush) {
	        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
	        flush_block_only(s, false);
	        /***/
	      }
	      s.strstart++;
	      s.lookahead--;
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	    } else {
	      /* There is no previous match to compare with, wait for
	       * the next step to decide.
	       */
	      s.match_available = 1;
	      s.strstart++;
	      s.lookahead--;
	    }
	  }
	  //Assert (flush != Z_NO_FLUSH, "no flush?");
	  if (s.match_available) {
	    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

	    s.match_available = 0;
	  }
	  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }

	  return BS_BLOCK_DONE;
	}


	/* ===========================================================================
	 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
	 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
	 * deflate switches away from Z_RLE.)
	 */
	function deflate_rle(s, flush) {
	  var bflush;            /* set if current block must be flushed */
	  var prev;              /* byte at distance one to match */
	  var scan, strend;      /* scan goes up to strend for length of run */

	  var _win = s.window;

	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the longest run, plus one for the unrolled loop.
	     */
	    if (s.lookahead <= MAX_MATCH) {
	      fill_window(s);
	      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }

	    /* See how many times the previous byte repeats */
	    s.match_length = 0;
	    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
	      scan = s.strstart - 1;
	      prev = _win[scan];
	      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
	        strend = s.strstart + MAX_MATCH;
	        do {
	          /*jshint noempty:false*/
	        } while (prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 scan < strend);
	        s.match_length = MAX_MATCH - (strend - scan);
	        if (s.match_length > s.lookahead) {
	          s.match_length = s.lookahead;
	        }
	      }
	      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
	    }

	    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
	    if (s.match_length >= MIN_MATCH) {
	      //check_match(s, s.strstart, s.strstart - 1, s.match_length);

	      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);

	      s.lookahead -= s.match_length;
	      s.strstart += s.match_length;
	      s.match_length = 0;
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s->window[s->strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}

	/* ===========================================================================
	 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
	 * (It will be regenerated if this run of deflate switches away from Huffman.)
	 */
	function deflate_huff(s, flush) {
	  var bflush;             /* set if current block must be flushed */

	  for (;;) {
	    /* Make sure that we have a literal to write. */
	    if (s.lookahead === 0) {
	      fill_window(s);
	      if (s.lookahead === 0) {
	        if (flush === Z_NO_FLUSH) {
	          return BS_NEED_MORE;
	        }
	        break;      /* flush the current block */
	      }
	    }

	    /* Output a literal byte */
	    s.match_length = 0;
	    //Tracevv((stderr,"%c", s->window[s->strstart]));
	    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	    s.lookahead--;
	    s.strstart++;
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}

	/* Values for max_lazy_match, good_match and max_chain_length, depending on
	 * the desired pack level (0..9). The values given below have been tuned to
	 * exclude worst case performance for pathological files. Better values may be
	 * found for specific files.
	 */
	function Config(good_length, max_lazy, nice_length, max_chain, func) {
	  this.good_length = good_length;
	  this.max_lazy = max_lazy;
	  this.nice_length = nice_length;
	  this.max_chain = max_chain;
	  this.func = func;
	}

	var configuration_table;

	configuration_table = [
	  /*      good lazy nice chain */
	  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
	  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
	  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
	  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */

	  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
	  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
	  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
	  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
	  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
	  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
	];


	/* ===========================================================================
	 * Initialize the "longest match" routines for a new zlib stream
	 */
	function lm_init(s) {
	  s.window_size = 2 * s.w_size;

	  /*** CLEAR_HASH(s); ***/
	  zero(s.head); // Fill with NIL (= 0);

	  /* Set the default configuration parameters:
	   */
	  s.max_lazy_match = configuration_table[s.level].max_lazy;
	  s.good_match = configuration_table[s.level].good_length;
	  s.nice_match = configuration_table[s.level].nice_length;
	  s.max_chain_length = configuration_table[s.level].max_chain;

	  s.strstart = 0;
	  s.block_start = 0;
	  s.lookahead = 0;
	  s.insert = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  s.ins_h = 0;
	}


	function DeflateState() {
	  this.strm = null;            /* pointer back to this zlib stream */
	  this.status = 0;            /* as the name implies */
	  this.pending_buf = null;      /* output still pending */
	  this.pending_buf_size = 0;  /* size of pending_buf */
	  this.pending_out = 0;       /* next pending byte to output to the stream */
	  this.pending = 0;           /* nb of bytes in the pending buffer */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.gzhead = null;         /* gzip header information to write */
	  this.gzindex = 0;           /* where in extra, name, or comment */
	  this.method = Z_DEFLATED; /* can only be DEFLATED */
	  this.last_flush = -1;   /* value of flush param for previous deflate call */

	  this.w_size = 0;  /* LZ77 window size (32K by default) */
	  this.w_bits = 0;  /* log2(w_size)  (8..16) */
	  this.w_mask = 0;  /* w_size - 1 */

	  this.window = null;
	  /* Sliding window. Input bytes are read into the second half of the window,
	   * and move to the first half later to keep a dictionary of at least wSize
	   * bytes. With this organization, matches are limited to a distance of
	   * wSize-MAX_MATCH bytes, but this ensures that IO is always
	   * performed with a length multiple of the block size.
	   */

	  this.window_size = 0;
	  /* Actual size of window: 2*wSize, except when the user input buffer
	   * is directly used as sliding window.
	   */

	  this.prev = null;
	  /* Link to older string with same hash index. To limit the size of this
	   * array to 64K, this link is maintained only for the last 32K strings.
	   * An index in this array is thus a window index modulo 32K.
	   */

	  this.head = null;   /* Heads of the hash chains or NIL. */

	  this.ins_h = 0;       /* hash index of string to be inserted */
	  this.hash_size = 0;   /* number of elements in hash table */
	  this.hash_bits = 0;   /* log2(hash_size) */
	  this.hash_mask = 0;   /* hash_size-1 */

	  this.hash_shift = 0;
	  /* Number of bits by which ins_h must be shifted at each input
	   * step. It must be such that after MIN_MATCH steps, the oldest
	   * byte no longer takes part in the hash key, that is:
	   *   hash_shift * MIN_MATCH >= hash_bits
	   */

	  this.block_start = 0;
	  /* Window position at the beginning of the current output block. Gets
	   * negative when the window is moved backwards.
	   */

	  this.match_length = 0;      /* length of best match */
	  this.prev_match = 0;        /* previous match */
	  this.match_available = 0;   /* set if previous match exists */
	  this.strstart = 0;          /* start of string to insert */
	  this.match_start = 0;       /* start of matching string */
	  this.lookahead = 0;         /* number of valid bytes ahead in window */

	  this.prev_length = 0;
	  /* Length of the best match at previous step. Matches not greater than this
	   * are discarded. This is used in the lazy match evaluation.
	   */

	  this.max_chain_length = 0;
	  /* To speed up deflation, hash chains are never searched beyond this
	   * length.  A higher limit improves compression ratio but degrades the
	   * speed.
	   */

	  this.max_lazy_match = 0;
	  /* Attempt to find a better match only when the current match is strictly
	   * smaller than this value. This mechanism is used only for compression
	   * levels >= 4.
	   */
	  // That's alias to max_lazy_match, don't use directly
	  //this.max_insert_length = 0;
	  /* Insert new strings in the hash table only if the match length is not
	   * greater than this length. This saves time but degrades compression.
	   * max_insert_length is used only for compression levels <= 3.
	   */

	  this.level = 0;     /* compression level (1..9) */
	  this.strategy = 0;  /* favor or force Huffman coding*/

	  this.good_match = 0;
	  /* Use a faster search when the previous match is longer than this */

	  this.nice_match = 0; /* Stop searching when current match exceeds this */

	              /* used by trees.c: */

	  /* Didn't use ct_data typedef below to suppress compiler warning */

	  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
	  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
	  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */

	  // Use flat array of DOUBLE size, with interleaved fata,
	  // because JS does not support effective
	  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
	  this.dyn_dtree  = new utils.Buf16((2 * D_CODES + 1) * 2);
	  this.bl_tree    = new utils.Buf16((2 * BL_CODES + 1) * 2);
	  zero(this.dyn_ltree);
	  zero(this.dyn_dtree);
	  zero(this.bl_tree);

	  this.l_desc   = null;         /* desc. for literal tree */
	  this.d_desc   = null;         /* desc. for distance tree */
	  this.bl_desc  = null;         /* desc. for bit length tree */

	  //ush bl_count[MAX_BITS+1];
	  this.bl_count = new utils.Buf16(MAX_BITS + 1);
	  /* number of codes at each bit length for an optimal tree */

	  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
	  this.heap = new utils.Buf16(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
	  zero(this.heap);

	  this.heap_len = 0;               /* number of elements in the heap */
	  this.heap_max = 0;               /* element of largest frequency */
	  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
	   * The same heap array is used to build all trees.
	   */

	  this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
	  zero(this.depth);
	  /* Depth of each subtree used as tie breaker for trees of equal frequency
	   */

	  this.l_buf = 0;          /* buffer index for literals or lengths */

	  this.lit_bufsize = 0;
	  /* Size of match buffer for literals/lengths.  There are 4 reasons for
	   * limiting lit_bufsize to 64K:
	   *   - frequencies can be kept in 16 bit counters
	   *   - if compression is not successful for the first block, all input
	   *     data is still in the window so we can still emit a stored block even
	   *     when input comes from standard input.  (This can also be done for
	   *     all blocks if lit_bufsize is not greater than 32K.)
	   *   - if compression is not successful for a file smaller than 64K, we can
	   *     even emit a stored file instead of a stored block (saving 5 bytes).
	   *     This is applicable only for zip (not gzip or zlib).
	   *   - creating new Huffman trees less frequently may not provide fast
	   *     adaptation to changes in the input data statistics. (Take for
	   *     example a binary file with poorly compressible code followed by
	   *     a highly compressible string table.) Smaller buffer sizes give
	   *     fast adaptation but have of course the overhead of transmitting
	   *     trees more frequently.
	   *   - I can't count above 4
	   */

	  this.last_lit = 0;      /* running index in l_buf */

	  this.d_buf = 0;
	  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
	   * the same number of elements. To use different lengths, an extra flag
	   * array would be necessary.
	   */

	  this.opt_len = 0;       /* bit length of current block with optimal trees */
	  this.static_len = 0;    /* bit length of current block with static trees */
	  this.matches = 0;       /* number of string matches in current block */
	  this.insert = 0;        /* bytes at end of window left to insert */


	  this.bi_buf = 0;
	  /* Output buffer. bits are inserted starting at the bottom (least
	   * significant bits).
	   */
	  this.bi_valid = 0;
	  /* Number of valid bits in bi_buf.  All bits above the last valid bit
	   * are always zero.
	   */

	  // Used for window memory init. We safely ignore it for JS. That makes
	  // sense only for pointers and memory check tools.
	  //this.high_water = 0;
	  /* High water mark offset in window for initialized bytes -- bytes above
	   * this are set to zero in order to avoid memory check warnings when
	   * longest match routines access bytes past the input.  This is then
	   * updated to the new high water mark.
	   */
	}


	function deflateResetKeep(strm) {
	  var s;

	  if (!strm || !strm.state) {
	    return err(strm, Z_STREAM_ERROR);
	  }

	  strm.total_in = strm.total_out = 0;
	  strm.data_type = Z_UNKNOWN;

	  s = strm.state;
	  s.pending = 0;
	  s.pending_out = 0;

	  if (s.wrap < 0) {
	    s.wrap = -s.wrap;
	    /* was made negative by deflate(..., Z_FINISH); */
	  }
	  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
	  strm.adler = (s.wrap === 2) ?
	    0  // crc32(0, Z_NULL, 0)
	  :
	    1; // adler32(0, Z_NULL, 0)
	  s.last_flush = Z_NO_FLUSH;
	  trees._tr_init(s);
	  return Z_OK;
	}


	function deflateReset(strm) {
	  var ret = deflateResetKeep(strm);
	  if (ret === Z_OK) {
	    lm_init(strm.state);
	  }
	  return ret;
	}


	function deflateSetHeader(strm, head) {
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
	  strm.state.gzhead = head;
	  return Z_OK;
	}


	function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
	  if (!strm) { // === Z_NULL
	    return Z_STREAM_ERROR;
	  }
	  var wrap = 1;

	  if (level === Z_DEFAULT_COMPRESSION) {
	    level = 6;
	  }

	  if (windowBits < 0) { /* suppress zlib wrapper */
	    wrap = 0;
	    windowBits = -windowBits;
	  }

	  else if (windowBits > 15) {
	    wrap = 2;           /* write gzip wrapper instead */
	    windowBits -= 16;
	  }


	  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
	    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
	    strategy < 0 || strategy > Z_FIXED) {
	    return err(strm, Z_STREAM_ERROR);
	  }


	  if (windowBits === 8) {
	    windowBits = 9;
	  }
	  /* until 256-byte window bug fixed */

	  var s = new DeflateState();

	  strm.state = s;
	  s.strm = strm;

	  s.wrap = wrap;
	  s.gzhead = null;
	  s.w_bits = windowBits;
	  s.w_size = 1 << s.w_bits;
	  s.w_mask = s.w_size - 1;

	  s.hash_bits = memLevel + 7;
	  s.hash_size = 1 << s.hash_bits;
	  s.hash_mask = s.hash_size - 1;
	  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);

	  s.window = new utils.Buf8(s.w_size * 2);
	  s.head = new utils.Buf16(s.hash_size);
	  s.prev = new utils.Buf16(s.w_size);

	  // Don't need mem init magic for JS.
	  //s.high_water = 0;  /* nothing written to s->window yet */

	  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */

	  s.pending_buf_size = s.lit_bufsize * 4;

	  //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
	  //s->pending_buf = (uchf *) overlay;
	  s.pending_buf = new utils.Buf8(s.pending_buf_size);

	  // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
	  //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
	  s.d_buf = 1 * s.lit_bufsize;

	  //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
	  s.l_buf = (1 + 2) * s.lit_bufsize;

	  s.level = level;
	  s.strategy = strategy;
	  s.method = method;

	  return deflateReset(strm);
	}

	function deflateInit(strm, level) {
	  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
	}


	function deflate(strm, flush) {
	  var old_flush, s;
	  var beg, val; // for gzip header write only

	  if (!strm || !strm.state ||
	    flush > Z_BLOCK || flush < 0) {
	    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
	  }

	  s = strm.state;

	  if (!strm.output ||
	      (!strm.input && strm.avail_in !== 0) ||
	      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
	    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
	  }

	  s.strm = strm; /* just in case */
	  old_flush = s.last_flush;
	  s.last_flush = flush;

	  /* Write the header */
	  if (s.status === INIT_STATE) {

	    if (s.wrap === 2) { // GZIP header
	      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
	      put_byte(s, 31);
	      put_byte(s, 139);
	      put_byte(s, 8);
	      if (!s.gzhead) { // s->gzhead == Z_NULL
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, OS_CODE);
	        s.status = BUSY_STATE;
	      }
	      else {
	        put_byte(s, (s.gzhead.text ? 1 : 0) +
	                    (s.gzhead.hcrc ? 2 : 0) +
	                    (!s.gzhead.extra ? 0 : 4) +
	                    (!s.gzhead.name ? 0 : 8) +
	                    (!s.gzhead.comment ? 0 : 16)
	                );
	        put_byte(s, s.gzhead.time & 0xff);
	        put_byte(s, (s.gzhead.time >> 8) & 0xff);
	        put_byte(s, (s.gzhead.time >> 16) & 0xff);
	        put_byte(s, (s.gzhead.time >> 24) & 0xff);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, s.gzhead.os & 0xff);
	        if (s.gzhead.extra && s.gzhead.extra.length) {
	          put_byte(s, s.gzhead.extra.length & 0xff);
	          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
	        }
	        if (s.gzhead.hcrc) {
	          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
	        }
	        s.gzindex = 0;
	        s.status = EXTRA_STATE;
	      }
	    }
	    else // DEFLATE header
	    {
	      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
	      var level_flags = -1;

	      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
	        level_flags = 0;
	      } else if (s.level < 6) {
	        level_flags = 1;
	      } else if (s.level === 6) {
	        level_flags = 2;
	      } else {
	        level_flags = 3;
	      }
	      header |= (level_flags << 6);
	      if (s.strstart !== 0) { header |= PRESET_DICT; }
	      header += 31 - (header % 31);

	      s.status = BUSY_STATE;
	      putShortMSB(s, header);

	      /* Save the adler32 of the preset dictionary: */
	      if (s.strstart !== 0) {
	        putShortMSB(s, strm.adler >>> 16);
	        putShortMSB(s, strm.adler & 0xffff);
	      }
	      strm.adler = 1; // adler32(0L, Z_NULL, 0);
	    }
	  }

	//#ifdef GZIP
	  if (s.status === EXTRA_STATE) {
	    if (s.gzhead.extra/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */

	      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            break;
	          }
	        }
	        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
	        s.gzindex++;
	      }
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (s.gzindex === s.gzhead.extra.length) {
	        s.gzindex = 0;
	        s.status = NAME_STATE;
	      }
	    }
	    else {
	      s.status = NAME_STATE;
	    }
	  }
	  if (s.status === NAME_STATE) {
	    if (s.gzhead.name/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;

	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.name.length) {
	          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);

	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.gzindex = 0;
	        s.status = COMMENT_STATE;
	      }
	    }
	    else {
	      s.status = COMMENT_STATE;
	    }
	  }
	  if (s.status === COMMENT_STATE) {
	    if (s.gzhead.comment/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;

	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.comment.length) {
	          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);

	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.status = HCRC_STATE;
	      }
	    }
	    else {
	      s.status = HCRC_STATE;
	    }
	  }
	  if (s.status === HCRC_STATE) {
	    if (s.gzhead.hcrc) {
	      if (s.pending + 2 > s.pending_buf_size) {
	        flush_pending(strm);
	      }
	      if (s.pending + 2 <= s.pending_buf_size) {
	        put_byte(s, strm.adler & 0xff);
	        put_byte(s, (strm.adler >> 8) & 0xff);
	        strm.adler = 0; //crc32(0L, Z_NULL, 0);
	        s.status = BUSY_STATE;
	      }
	    }
	    else {
	      s.status = BUSY_STATE;
	    }
	  }
	//#endif

	  /* Flush as much pending output as possible */
	  if (s.pending !== 0) {
	    flush_pending(strm);
	    if (strm.avail_out === 0) {
	      /* Since avail_out is 0, deflate will be called again with
	       * more output space, but possibly with both pending and
	       * avail_in equal to zero. There won't be anything to do,
	       * but this is not an error situation so make sure we
	       * return OK instead of BUF_ERROR at next call of deflate:
	       */
	      s.last_flush = -1;
	      return Z_OK;
	    }

	    /* Make sure there is something to do and avoid duplicate consecutive
	     * flushes. For repeated and useless calls with Z_FINISH, we keep
	     * returning Z_STREAM_END instead of Z_BUF_ERROR.
	     */
	  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
	    flush !== Z_FINISH) {
	    return err(strm, Z_BUF_ERROR);
	  }

	  /* User must not provide more input after the first FINISH: */
	  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
	    return err(strm, Z_BUF_ERROR);
	  }

	  /* Start a new block or continue the current one.
	   */
	  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
	    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
	    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
	      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
	        configuration_table[s.level].func(s, flush));

	    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
	      s.status = FINISH_STATE;
	    }
	    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
	      if (strm.avail_out === 0) {
	        s.last_flush = -1;
	        /* avoid BUF_ERROR next call, see above */
	      }
	      return Z_OK;
	      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
	       * of deflate should use the same flush parameter to make sure
	       * that the flush is complete. So we don't have to output an
	       * empty block here, this will be done at next call. This also
	       * ensures that for a very small output buffer, we emit at most
	       * one empty block.
	       */
	    }
	    if (bstate === BS_BLOCK_DONE) {
	      if (flush === Z_PARTIAL_FLUSH) {
	        trees._tr_align(s);
	      }
	      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */

	        trees._tr_stored_block(s, 0, 0, false);
	        /* For a full flush, this empty block will be recognized
	         * as a special marker by inflate_sync().
	         */
	        if (flush === Z_FULL_FLUSH) {
	          /*** CLEAR_HASH(s); ***/             /* forget history */
	          zero(s.head); // Fill with NIL (= 0);

	          if (s.lookahead === 0) {
	            s.strstart = 0;
	            s.block_start = 0;
	            s.insert = 0;
	          }
	        }
	      }
	      flush_pending(strm);
	      if (strm.avail_out === 0) {
	        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
	        return Z_OK;
	      }
	    }
	  }
	  //Assert(strm->avail_out > 0, "bug2");
	  //if (strm.avail_out <= 0) { throw new Error("bug2");}

	  if (flush !== Z_FINISH) { return Z_OK; }
	  if (s.wrap <= 0) { return Z_STREAM_END; }

	  /* Write the trailer */
	  if (s.wrap === 2) {
	    put_byte(s, strm.adler & 0xff);
	    put_byte(s, (strm.adler >> 8) & 0xff);
	    put_byte(s, (strm.adler >> 16) & 0xff);
	    put_byte(s, (strm.adler >> 24) & 0xff);
	    put_byte(s, strm.total_in & 0xff);
	    put_byte(s, (strm.total_in >> 8) & 0xff);
	    put_byte(s, (strm.total_in >> 16) & 0xff);
	    put_byte(s, (strm.total_in >> 24) & 0xff);
	  }
	  else
	  {
	    putShortMSB(s, strm.adler >>> 16);
	    putShortMSB(s, strm.adler & 0xffff);
	  }

	  flush_pending(strm);
	  /* If avail_out is zero, the application will call deflate again
	   * to flush the rest.
	   */
	  if (s.wrap > 0) { s.wrap = -s.wrap; }
	  /* write the trailer only once! */
	  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
	}

	function deflateEnd(strm) {
	  var status;

	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }

	  status = strm.state.status;
	  if (status !== INIT_STATE &&
	    status !== EXTRA_STATE &&
	    status !== NAME_STATE &&
	    status !== COMMENT_STATE &&
	    status !== HCRC_STATE &&
	    status !== BUSY_STATE &&
	    status !== FINISH_STATE
	  ) {
	    return err(strm, Z_STREAM_ERROR);
	  }

	  strm.state = null;

	  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
	}


	/* =========================================================================
	 * Initializes the compression dictionary from the given byte
	 * sequence without producing any compressed output.
	 */
	function deflateSetDictionary(strm, dictionary) {
	  var dictLength = dictionary.length;

	  var s;
	  var str, n;
	  var wrap;
	  var avail;
	  var next;
	  var input;
	  var tmpDict;

	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }

	  s = strm.state;
	  wrap = s.wrap;

	  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
	    return Z_STREAM_ERROR;
	  }

	  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
	  if (wrap === 1) {
	    /* adler32(strm->adler, dictionary, dictLength); */
	    strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
	  }

	  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */

	  /* if dictionary would fill window, just replace the history */
	  if (dictLength >= s.w_size) {
	    if (wrap === 0) {            /* already empty otherwise */
	      /*** CLEAR_HASH(s); ***/
	      zero(s.head); // Fill with NIL (= 0);
	      s.strstart = 0;
	      s.block_start = 0;
	      s.insert = 0;
	    }
	    /* use the tail */
	    // dictionary = dictionary.slice(dictLength - s.w_size);
	    tmpDict = new utils.Buf8(s.w_size);
	    utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
	    dictionary = tmpDict;
	    dictLength = s.w_size;
	  }
	  /* insert dictionary into window and hash */
	  avail = strm.avail_in;
	  next = strm.next_in;
	  input = strm.input;
	  strm.avail_in = dictLength;
	  strm.next_in = 0;
	  strm.input = dictionary;
	  fill_window(s);
	  while (s.lookahead >= MIN_MATCH) {
	    str = s.strstart;
	    n = s.lookahead - (MIN_MATCH - 1);
	    do {
	      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;

	      s.prev[str & s.w_mask] = s.head[s.ins_h];

	      s.head[s.ins_h] = str;
	      str++;
	    } while (--n);
	    s.strstart = str;
	    s.lookahead = MIN_MATCH - 1;
	    fill_window(s);
	  }
	  s.strstart += s.lookahead;
	  s.block_start = s.strstart;
	  s.insert = s.lookahead;
	  s.lookahead = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  strm.next_in = next;
	  strm.input = input;
	  strm.avail_in = avail;
	  s.wrap = wrap;
	  return Z_OK;
	}


	exports.deflateInit = deflateInit;
	exports.deflateInit2 = deflateInit2;
	exports.deflateReset = deflateReset;
	exports.deflateResetKeep = deflateResetKeep;
	exports.deflateSetHeader = deflateSetHeader;
	exports.deflate = deflate;
	exports.deflateEnd = deflateEnd;
	exports.deflateSetDictionary = deflateSetDictionary;
	exports.deflateInfo = 'pako deflate (from Nodeca project)';

	/* Not implemented
	exports.deflateBound = deflateBound;
	exports.deflateCopy = deflateCopy;
	exports.deflateParams = deflateParams;
	exports.deflatePending = deflatePending;
	exports.deflatePrime = deflatePrime;
	exports.deflateTune = deflateTune;
	*/


/***/ }),
/* 64 */
/***/ (function(module, exports) {

	'use strict';


	var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
	                (typeof Uint16Array !== 'undefined') &&
	                (typeof Int32Array !== 'undefined');


	exports.assign = function (obj /*from1, from2, from3, ...*/) {
	  var sources = Array.prototype.slice.call(arguments, 1);
	  while (sources.length) {
	    var source = sources.shift();
	    if (!source) { continue; }

	    if (typeof source !== 'object') {
	      throw new TypeError(source + 'must be non-object');
	    }

	    for (var p in source) {
	      if (source.hasOwnProperty(p)) {
	        obj[p] = source[p];
	      }
	    }
	  }

	  return obj;
	};


	// reduce buffer size, avoiding mem copy
	exports.shrinkBuf = function (buf, size) {
	  if (buf.length === size) { return buf; }
	  if (buf.subarray) { return buf.subarray(0, size); }
	  buf.length = size;
	  return buf;
	};


	var fnTyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    if (src.subarray && dest.subarray) {
	      dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
	      return;
	    }
	    // Fallback to ordinary array
	    for (var i = 0; i < len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function (chunks) {
	    var i, l, len, pos, chunk, result;

	    // calculate data length
	    len = 0;
	    for (i = 0, l = chunks.length; i < l; i++) {
	      len += chunks[i].length;
	    }

	    // join chunks
	    result = new Uint8Array(len);
	    pos = 0;
	    for (i = 0, l = chunks.length; i < l; i++) {
	      chunk = chunks[i];
	      result.set(chunk, pos);
	      pos += chunk.length;
	    }

	    return result;
	  }
	};

	var fnUntyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    for (var i = 0; i < len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function (chunks) {
	    return [].concat.apply([], chunks);
	  }
	};


	// Enable/Disable typed arrays use, for testing
	//
	exports.setTyped = function (on) {
	  if (on) {
	    exports.Buf8  = Uint8Array;
	    exports.Buf16 = Uint16Array;
	    exports.Buf32 = Int32Array;
	    exports.assign(exports, fnTyped);
	  } else {
	    exports.Buf8  = Array;
	    exports.Buf16 = Array;
	    exports.Buf32 = Array;
	    exports.assign(exports, fnUntyped);
	  }
	};

	exports.setTyped(TYPED_OK);


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';


	var utils = __webpack_require__(64);

	/* Public constants ==========================================================*/
	/* ===========================================================================*/


	//var Z_FILTERED          = 1;
	//var Z_HUFFMAN_ONLY      = 2;
	//var Z_RLE               = 3;
	var Z_FIXED               = 4;
	//var Z_DEFAULT_STRATEGY  = 0;

	/* Possible values of the data_type field (though see inflate()) */
	var Z_BINARY              = 0;
	var Z_TEXT                = 1;
	//var Z_ASCII             = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;

	/*============================================================================*/


	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }

	// From zutil.h

	var STORED_BLOCK = 0;
	var STATIC_TREES = 1;
	var DYN_TREES    = 2;
	/* The three kinds of block type */

	var MIN_MATCH    = 3;
	var MAX_MATCH    = 258;
	/* The minimum and maximum match lengths */

	// From deflate.h
	/* ===========================================================================
	 * Internal compression state.
	 */

	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */

	var LITERALS      = 256;
	/* number of literal bytes 0..255 */

	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */

	var D_CODES       = 30;
	/* number of distance codes */

	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */

	var HEAP_SIZE     = 2 * L_CODES + 1;
	/* maximum heap size */

	var MAX_BITS      = 15;
	/* All codes must not exceed MAX_BITS bits */

	var Buf_size      = 16;
	/* size of bit buffer in bi_buf */


	/* ===========================================================================
	 * Constants
	 */

	var MAX_BL_BITS = 7;
	/* Bit length codes must not exceed MAX_BL_BITS bits */

	var END_BLOCK   = 256;
	/* end of block literal code */

	var REP_3_6     = 16;
	/* repeat previous bit length 3-6 times (2 bits of repeat count) */

	var REPZ_3_10   = 17;
	/* repeat a zero length 3-10 times  (3 bits of repeat count) */

	var REPZ_11_138 = 18;
	/* repeat a zero length 11-138 times  (7 bits of repeat count) */

	/* eslint-disable comma-spacing,array-bracket-spacing */
	var extra_lbits =   /* extra bits for each length code */
	  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];

	var extra_dbits =   /* extra bits for each distance code */
	  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];

	var extra_blbits =  /* extra bits for each bit length code */
	  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];

	var bl_order =
	  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
	/* eslint-enable comma-spacing,array-bracket-spacing */

	/* The lengths of the bit length codes are sent in order of decreasing
	 * probability, to avoid transmitting the lengths for unused bit length codes.
	 */

	/* ===========================================================================
	 * Local data. These are initialized only once.
	 */

	// We pre-fill arrays with 0 to avoid uninitialized gaps

	var DIST_CODE_LEN = 512; /* see definition of array dist_code below */

	// !!!! Use flat array insdead of structure, Freq = i*2, Len = i*2+1
	var static_ltree  = new Array((L_CODES + 2) * 2);
	zero(static_ltree);
	/* The static literal tree. Since the bit lengths are imposed, there is no
	 * need for the L_CODES extra codes used during heap construction. However
	 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
	 * below).
	 */

	var static_dtree  = new Array(D_CODES * 2);
	zero(static_dtree);
	/* The static distance tree. (Actually a trivial tree since all codes use
	 * 5 bits.)
	 */

	var _dist_code    = new Array(DIST_CODE_LEN);
	zero(_dist_code);
	/* Distance codes. The first 256 values correspond to the distances
	 * 3 .. 258, the last 256 values correspond to the top 8 bits of
	 * the 15 bit distances.
	 */

	var _length_code  = new Array(MAX_MATCH - MIN_MATCH + 1);
	zero(_length_code);
	/* length code for each normalized match length (0 == MIN_MATCH) */

	var base_length   = new Array(LENGTH_CODES);
	zero(base_length);
	/* First normalized length for each code (0 = MIN_MATCH) */

	var base_dist     = new Array(D_CODES);
	zero(base_dist);
	/* First normalized distance for each code (0 = distance of 1) */


	function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {

	  this.static_tree  = static_tree;  /* static tree or NULL */
	  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
	  this.extra_base   = extra_base;   /* base index for extra_bits */
	  this.elems        = elems;        /* max number of elements in the tree */
	  this.max_length   = max_length;   /* max bit length for the codes */

	  // show if `static_tree` has data or dummy - needed for monomorphic objects
	  this.has_stree    = static_tree && static_tree.length;
	}


	var static_l_desc;
	var static_d_desc;
	var static_bl_desc;


	function TreeDesc(dyn_tree, stat_desc) {
	  this.dyn_tree = dyn_tree;     /* the dynamic tree */
	  this.max_code = 0;            /* largest code with non zero frequency */
	  this.stat_desc = stat_desc;   /* the corresponding static tree */
	}



	function d_code(dist) {
	  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
	}


	/* ===========================================================================
	 * Output a short LSB first on the stream.
	 * IN assertion: there is enough room in pendingBuf.
	 */
	function put_short(s, w) {
	//    put_byte(s, (uch)((w) & 0xff));
	//    put_byte(s, (uch)((ush)(w) >> 8));
	  s.pending_buf[s.pending++] = (w) & 0xff;
	  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
	}


	/* ===========================================================================
	 * Send a value on a given number of bits.
	 * IN assertion: length <= 16 and value fits in length bits.
	 */
	function send_bits(s, value, length) {
	  if (s.bi_valid > (Buf_size - length)) {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    put_short(s, s.bi_buf);
	    s.bi_buf = value >> (Buf_size - s.bi_valid);
	    s.bi_valid += length - Buf_size;
	  } else {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    s.bi_valid += length;
	  }
	}


	function send_code(s, c, tree) {
	  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
	}


	/* ===========================================================================
	 * Reverse the first len bits of a code, using straightforward code (a faster
	 * method would use a table)
	 * IN assertion: 1 <= len <= 15
	 */
	function bi_reverse(code, len) {
	  var res = 0;
	  do {
	    res |= code & 1;
	    code >>>= 1;
	    res <<= 1;
	  } while (--len > 0);
	  return res >>> 1;
	}


	/* ===========================================================================
	 * Flush the bit buffer, keeping at most 7 bits in it.
	 */
	function bi_flush(s) {
	  if (s.bi_valid === 16) {
	    put_short(s, s.bi_buf);
	    s.bi_buf = 0;
	    s.bi_valid = 0;

	  } else if (s.bi_valid >= 8) {
	    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
	    s.bi_buf >>= 8;
	    s.bi_valid -= 8;
	  }
	}


	/* ===========================================================================
	 * Compute the optimal bit lengths for a tree and update the total bit length
	 * for the current block.
	 * IN assertion: the fields freq and dad are set, heap[heap_max] and
	 *    above are the tree nodes sorted by increasing frequency.
	 * OUT assertions: the field len is set to the optimal bit length, the
	 *     array bl_count contains the frequencies for each bit length.
	 *     The length opt_len is updated; static_len is also updated if stree is
	 *     not null.
	 */
	function gen_bitlen(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc;    /* the tree descriptor */
	{
	  var tree            = desc.dyn_tree;
	  var max_code        = desc.max_code;
	  var stree           = desc.stat_desc.static_tree;
	  var has_stree       = desc.stat_desc.has_stree;
	  var extra           = desc.stat_desc.extra_bits;
	  var base            = desc.stat_desc.extra_base;
	  var max_length      = desc.stat_desc.max_length;
	  var h;              /* heap index */
	  var n, m;           /* iterate over the tree elements */
	  var bits;           /* bit length */
	  var xbits;          /* extra bits */
	  var f;              /* frequency */
	  var overflow = 0;   /* number of elements with bit length too large */

	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    s.bl_count[bits] = 0;
	  }

	  /* In a first pass, compute the optimal bit lengths (which may
	   * overflow in the case of the bit length tree).
	   */
	  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */

	  for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
	    n = s.heap[h];
	    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
	    if (bits > max_length) {
	      bits = max_length;
	      overflow++;
	    }
	    tree[n * 2 + 1]/*.Len*/ = bits;
	    /* We overwrite tree[n].Dad which is no longer needed */

	    if (n > max_code) { continue; } /* not a leaf node */

	    s.bl_count[bits]++;
	    xbits = 0;
	    if (n >= base) {
	      xbits = extra[n - base];
	    }
	    f = tree[n * 2]/*.Freq*/;
	    s.opt_len += f * (bits + xbits);
	    if (has_stree) {
	      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
	    }
	  }
	  if (overflow === 0) { return; }

	  // Trace((stderr,"\nbit length overflow\n"));
	  /* This happens for example on obj2 and pic of the Calgary corpus */

	  /* Find the first bit length which could increase: */
	  do {
	    bits = max_length - 1;
	    while (s.bl_count[bits] === 0) { bits--; }
	    s.bl_count[bits]--;      /* move one leaf down the tree */
	    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
	    s.bl_count[max_length]--;
	    /* The brother of the overflow item also moves one step up,
	     * but this does not affect bl_count[max_length]
	     */
	    overflow -= 2;
	  } while (overflow > 0);

	  /* Now recompute all bit lengths, scanning in increasing frequency.
	   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
	   * lengths instead of fixing only the wrong ones. This idea is taken
	   * from 'ar' written by Haruhiko Okumura.)
	   */
	  for (bits = max_length; bits !== 0; bits--) {
	    n = s.bl_count[bits];
	    while (n !== 0) {
	      m = s.heap[--h];
	      if (m > max_code) { continue; }
	      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
	        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
	        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
	        tree[m * 2 + 1]/*.Len*/ = bits;
	      }
	      n--;
	    }
	  }
	}


	/* ===========================================================================
	 * Generate the codes for a given tree and bit counts (which need not be
	 * optimal).
	 * IN assertion: the array bl_count contains the bit length statistics for
	 * the given tree and the field len is set for all tree elements.
	 * OUT assertion: the field code is set for all tree elements of non
	 *     zero code length.
	 */
	function gen_codes(tree, max_code, bl_count)
	//    ct_data *tree;             /* the tree to decorate */
	//    int max_code;              /* largest code with non zero frequency */
	//    ushf *bl_count;            /* number of codes at each bit length */
	{
	  var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */
	  var code = 0;              /* running code value */
	  var bits;                  /* bit index */
	  var n;                     /* code index */

	  /* The distribution counts are first used to generate the code values
	   * without bit reversal.
	   */
	  for (bits = 1; bits <= MAX_BITS; bits++) {
	    next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
	  }
	  /* Check that the bit counts in bl_count are consistent. The last code
	   * must be all ones.
	   */
	  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
	  //        "inconsistent bit counts");
	  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));

	  for (n = 0;  n <= max_code; n++) {
	    var len = tree[n * 2 + 1]/*.Len*/;
	    if (len === 0) { continue; }
	    /* Now reverse the bits */
	    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);

	    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
	    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
	  }
	}


	/* ===========================================================================
	 * Initialize the various 'constant' tables.
	 */
	function tr_static_init() {
	  var n;        /* iterates over tree elements */
	  var bits;     /* bit counter */
	  var length;   /* length value */
	  var code;     /* code value */
	  var dist;     /* distance index */
	  var bl_count = new Array(MAX_BITS + 1);
	  /* number of codes at each bit length for an optimal tree */

	  // do check in _tr_init()
	  //if (static_init_done) return;

	  /* For some embedded targets, global variables are not initialized: */
	/*#ifdef NO_INIT_GLOBAL_POINTERS
	  static_l_desc.static_tree = static_ltree;
	  static_l_desc.extra_bits = extra_lbits;
	  static_d_desc.static_tree = static_dtree;
	  static_d_desc.extra_bits = extra_dbits;
	  static_bl_desc.extra_bits = extra_blbits;
	#endif*/

	  /* Initialize the mapping length (0..255) -> length code (0..28) */
	  length = 0;
	  for (code = 0; code < LENGTH_CODES - 1; code++) {
	    base_length[code] = length;
	    for (n = 0; n < (1 << extra_lbits[code]); n++) {
	      _length_code[length++] = code;
	    }
	  }
	  //Assert (length == 256, "tr_static_init: length != 256");
	  /* Note that the length 255 (match length 258) can be represented
	   * in two different ways: code 284 + 5 bits or code 285, so we
	   * overwrite length_code[255] to use the best encoding:
	   */
	  _length_code[length - 1] = code;

	  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
	  dist = 0;
	  for (code = 0; code < 16; code++) {
	    base_dist[code] = dist;
	    for (n = 0; n < (1 << extra_dbits[code]); n++) {
	      _dist_code[dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: dist != 256");
	  dist >>= 7; /* from now on, all distances are divided by 128 */
	  for (; code < D_CODES; code++) {
	    base_dist[code] = dist << 7;
	    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
	      _dist_code[256 + dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: 256+dist != 512");

	  /* Construct the codes of the static literal tree */
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    bl_count[bits] = 0;
	  }

	  n = 0;
	  while (n <= 143) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  while (n <= 255) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 9;
	    n++;
	    bl_count[9]++;
	  }
	  while (n <= 279) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 7;
	    n++;
	    bl_count[7]++;
	  }
	  while (n <= 287) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  /* Codes 286 and 287 do not exist, but we must include them in the
	   * tree construction to get a canonical Huffman tree (longest code
	   * all ones)
	   */
	  gen_codes(static_ltree, L_CODES + 1, bl_count);

	  /* The static distance tree is trivial: */
	  for (n = 0; n < D_CODES; n++) {
	    static_dtree[n * 2 + 1]/*.Len*/ = 5;
	    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
	  }

	  // Now data ready and we can init static trees
	  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
	  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
	  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);

	  //static_init_done = true;
	}


	/* ===========================================================================
	 * Initialize a new block.
	 */
	function init_block(s) {
	  var n; /* iterates over tree elements */

	  /* Initialize the trees. */
	  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
	  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
	  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }

	  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
	  s.opt_len = s.static_len = 0;
	  s.last_lit = s.matches = 0;
	}


	/* ===========================================================================
	 * Flush the bit buffer and align the output on a byte boundary
	 */
	function bi_windup(s)
	{
	  if (s.bi_valid > 8) {
	    put_short(s, s.bi_buf);
	  } else if (s.bi_valid > 0) {
	    //put_byte(s, (Byte)s->bi_buf);
	    s.pending_buf[s.pending++] = s.bi_buf;
	  }
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	}

	/* ===========================================================================
	 * Copy a stored block, storing first the length and its
	 * one's complement if requested.
	 */
	function copy_block(s, buf, len, header)
	//DeflateState *s;
	//charf    *buf;    /* the input data */
	//unsigned len;     /* its length */
	//int      header;  /* true if block header must be written */
	{
	  bi_windup(s);        /* align on byte boundary */

	  if (header) {
	    put_short(s, len);
	    put_short(s, ~len);
	  }
	//  while (len--) {
	//    put_byte(s, *buf++);
	//  }
	  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
	  s.pending += len;
	}

	/* ===========================================================================
	 * Compares to subtrees, using the tree depth as tie breaker when
	 * the subtrees have equal frequency. This minimizes the worst case length.
	 */
	function smaller(tree, n, m, depth) {
	  var _n2 = n * 2;
	  var _m2 = m * 2;
	  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
	         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
	}

	/* ===========================================================================
	 * Restore the heap property by moving down the tree starting at node k,
	 * exchanging a node with the smallest of its two sons if necessary, stopping
	 * when the heap property is re-established (each father smaller than its
	 * two sons).
	 */
	function pqdownheap(s, tree, k)
	//    deflate_state *s;
	//    ct_data *tree;  /* the tree to restore */
	//    int k;               /* node to move down */
	{
	  var v = s.heap[k];
	  var j = k << 1;  /* left son of k */
	  while (j <= s.heap_len) {
	    /* Set j to the smallest of the two sons: */
	    if (j < s.heap_len &&
	      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
	      j++;
	    }
	    /* Exit if v is smaller than both sons */
	    if (smaller(tree, v, s.heap[j], s.depth)) { break; }

	    /* Exchange v with the smallest son */
	    s.heap[k] = s.heap[j];
	    k = j;

	    /* And continue down the tree, setting j to the left son of k */
	    j <<= 1;
	  }
	  s.heap[k] = v;
	}


	// inlined manually
	// var SMALLEST = 1;

	/* ===========================================================================
	 * Send the block data compressed using the given Huffman trees
	 */
	function compress_block(s, ltree, dtree)
	//    deflate_state *s;
	//    const ct_data *ltree; /* literal tree */
	//    const ct_data *dtree; /* distance tree */
	{
	  var dist;           /* distance of matched string */
	  var lc;             /* match length or unmatched char (if dist == 0) */
	  var lx = 0;         /* running index in l_buf */
	  var code;           /* the code to send */
	  var extra;          /* number of extra bits to send */

	  if (s.last_lit !== 0) {
	    do {
	      dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | (s.pending_buf[s.d_buf + lx * 2 + 1]);
	      lc = s.pending_buf[s.l_buf + lx];
	      lx++;

	      if (dist === 0) {
	        send_code(s, lc, ltree); /* send a literal byte */
	        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
	      } else {
	        /* Here, lc is the match length - MIN_MATCH */
	        code = _length_code[lc];
	        send_code(s, code + LITERALS + 1, ltree); /* send the length code */
	        extra = extra_lbits[code];
	        if (extra !== 0) {
	          lc -= base_length[code];
	          send_bits(s, lc, extra);       /* send the extra length bits */
	        }
	        dist--; /* dist is now the match distance - 1 */
	        code = d_code(dist);
	        //Assert (code < D_CODES, "bad d_code");

	        send_code(s, code, dtree);       /* send the distance code */
	        extra = extra_dbits[code];
	        if (extra !== 0) {
	          dist -= base_dist[code];
	          send_bits(s, dist, extra);   /* send the extra distance bits */
	        }
	      } /* literal or match pair ? */

	      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
	      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
	      //       "pendingBuf overflow");

	    } while (lx < s.last_lit);
	  }

	  send_code(s, END_BLOCK, ltree);
	}


	/* ===========================================================================
	 * Construct one Huffman tree and assigns the code bit strings and lengths.
	 * Update the total bit length for the current block.
	 * IN assertion: the field freq is set for all tree elements.
	 * OUT assertions: the fields len and code are set to the optimal bit length
	 *     and corresponding code. The length opt_len is updated; static_len is
	 *     also updated if stree is not null. The field max_code is set.
	 */
	function build_tree(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc; /* the tree descriptor */
	{
	  var tree     = desc.dyn_tree;
	  var stree    = desc.stat_desc.static_tree;
	  var has_stree = desc.stat_desc.has_stree;
	  var elems    = desc.stat_desc.elems;
	  var n, m;          /* iterate over heap elements */
	  var max_code = -1; /* largest code with non zero frequency */
	  var node;          /* new node being created */

	  /* Construct the initial heap, with least frequent element in
	   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
	   * heap[0] is not used.
	   */
	  s.heap_len = 0;
	  s.heap_max = HEAP_SIZE;

	  for (n = 0; n < elems; n++) {
	    if (tree[n * 2]/*.Freq*/ !== 0) {
	      s.heap[++s.heap_len] = max_code = n;
	      s.depth[n] = 0;

	    } else {
	      tree[n * 2 + 1]/*.Len*/ = 0;
	    }
	  }

	  /* The pkzip format requires that at least one distance code exists,
	   * and that at least one bit should be sent even if there is only one
	   * possible code. So to avoid special checks later on we force at least
	   * two codes of non zero frequency.
	   */
	  while (s.heap_len < 2) {
	    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
	    tree[node * 2]/*.Freq*/ = 1;
	    s.depth[node] = 0;
	    s.opt_len--;

	    if (has_stree) {
	      s.static_len -= stree[node * 2 + 1]/*.Len*/;
	    }
	    /* node is 0 or 1 so it does not have extra bits */
	  }
	  desc.max_code = max_code;

	  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
	   * establish sub-heaps of increasing lengths:
	   */
	  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }

	  /* Construct the Huffman tree by repeatedly combining the least two
	   * frequent nodes.
	   */
	  node = elems;              /* next internal node of the tree */
	  do {
	    //pqremove(s, tree, n);  /* n = node of least frequency */
	    /*** pqremove ***/
	    n = s.heap[1/*SMALLEST*/];
	    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	    /***/

	    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */

	    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
	    s.heap[--s.heap_max] = m;

	    /* Create a new node father of n and m */
	    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
	    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
	    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;

	    /* and insert the new node in the heap */
	    s.heap[1/*SMALLEST*/] = node++;
	    pqdownheap(s, tree, 1/*SMALLEST*/);

	  } while (s.heap_len >= 2);

	  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];

	  /* At this point, the fields freq and dad are set. We can now
	   * generate the bit lengths.
	   */
	  gen_bitlen(s, desc);

	  /* The field len is now set, we can generate the bit codes */
	  gen_codes(tree, max_code, s.bl_count);
	}


	/* ===========================================================================
	 * Scan a literal or distance tree to determine the frequencies of the codes
	 * in the bit length tree.
	 */
	function scan_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree;   /* the tree to be scanned */
	//    int max_code;    /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */

	  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */

	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */

	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

	    if (++count < max_count && curlen === nextlen) {
	      continue;

	    } else if (count < min_count) {
	      s.bl_tree[curlen * 2]/*.Freq*/ += count;

	    } else if (curlen !== 0) {

	      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
	      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;

	    } else if (count <= 10) {
	      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;

	    } else {
	      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
	    }

	    count = 0;
	    prevlen = curlen;

	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;

	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;

	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}


	/* ===========================================================================
	 * Send a literal or distance tree in compressed form, using the codes in
	 * bl_tree.
	 */
	function send_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree; /* the tree to be scanned */
	//    int max_code;       /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */

	  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */

	  /* tree[max_code+1].Len = -1; */  /* guard already set */
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }

	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

	    if (++count < max_count && curlen === nextlen) {
	      continue;

	    } else if (count < min_count) {
	      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);

	    } else if (curlen !== 0) {
	      if (curlen !== prevlen) {
	        send_code(s, curlen, s.bl_tree);
	        count--;
	      }
	      //Assert(count >= 3 && count <= 6, " 3_6?");
	      send_code(s, REP_3_6, s.bl_tree);
	      send_bits(s, count - 3, 2);

	    } else if (count <= 10) {
	      send_code(s, REPZ_3_10, s.bl_tree);
	      send_bits(s, count - 3, 3);

	    } else {
	      send_code(s, REPZ_11_138, s.bl_tree);
	      send_bits(s, count - 11, 7);
	    }

	    count = 0;
	    prevlen = curlen;
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;

	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;

	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}


	/* ===========================================================================
	 * Construct the Huffman tree for the bit lengths and return the index in
	 * bl_order of the last bit length code to send.
	 */
	function build_bl_tree(s) {
	  var max_blindex;  /* index of last bit length code of non zero freq */

	  /* Determine the bit length frequencies for literal and distance trees */
	  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
	  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);

	  /* Build the bit length tree: */
	  build_tree(s, s.bl_desc);
	  /* opt_len now includes the length of the tree representations, except
	   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
	   */

	  /* Determine the number of bit length codes to send. The pkzip format
	   * requires that at least 4 bit length codes be sent. (appnote.txt says
	   * 3 but the actual value used is 4.)
	   */
	  for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
	    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
	      break;
	    }
	  }
	  /* Update opt_len to include the bit length tree and counts */
	  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
	  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
	  //        s->opt_len, s->static_len));

	  return max_blindex;
	}


	/* ===========================================================================
	 * Send the header for a block using dynamic Huffman trees: the counts, the
	 * lengths of the bit length codes, the literal tree and the distance tree.
	 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
	 */
	function send_all_trees(s, lcodes, dcodes, blcodes)
	//    deflate_state *s;
	//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
	{
	  var rank;                    /* index in bl_order */

	  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
	  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
	  //        "too many codes");
	  //Tracev((stderr, "\nbl counts: "));
	  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
	  send_bits(s, dcodes - 1,   5);
	  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
	  for (rank = 0; rank < blcodes; rank++) {
	    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
	    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
	  }
	  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));

	  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
	  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));

	  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
	  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
	}


	/* ===========================================================================
	 * Check if the data type is TEXT or BINARY, using the following algorithm:
	 * - TEXT if the two conditions below are satisfied:
	 *    a) There are no non-portable control characters belonging to the
	 *       "black list" (0..6, 14..25, 28..31).
	 *    b) There is at least one printable character belonging to the
	 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
	 * - BINARY otherwise.
	 * - The following partially-portable control characters form a
	 *   "gray list" that is ignored in this detection algorithm:
	 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
	 * IN assertion: the fields Freq of dyn_ltree are set.
	 */
	function detect_data_type(s) {
	  /* black_mask is the bit mask of black-listed bytes
	   * set bits 0..6, 14..25, and 28..31
	   * 0xf3ffc07f = binary 11110011111111111100000001111111
	   */
	  var black_mask = 0xf3ffc07f;
	  var n;

	  /* Check for non-textual ("black-listed") bytes. */
	  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
	    if ((black_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
	      return Z_BINARY;
	    }
	  }

	  /* Check for textual ("white-listed") bytes. */
	  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
	      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
	    return Z_TEXT;
	  }
	  for (n = 32; n < LITERALS; n++) {
	    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
	      return Z_TEXT;
	    }
	  }

	  /* There are no "black-listed" or "white-listed" bytes:
	   * this stream either is empty or has tolerated ("gray-listed") bytes only.
	   */
	  return Z_BINARY;
	}


	var static_init_done = false;

	/* ===========================================================================
	 * Initialize the tree data structures for a new zlib stream.
	 */
	function _tr_init(s)
	{

	  if (!static_init_done) {
	    tr_static_init();
	    static_init_done = true;
	  }

	  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
	  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
	  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);

	  s.bi_buf = 0;
	  s.bi_valid = 0;

	  /* Initialize the first block of the first file: */
	  init_block(s);
	}


	/* ===========================================================================
	 * Send a stored block
	 */
	function _tr_stored_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
	  copy_block(s, buf, stored_len, true); /* with header */
	}


	/* ===========================================================================
	 * Send one empty static block to give enough lookahead for inflate.
	 * This takes 10 bits, of which 7 may remain in the bit buffer.
	 */
	function _tr_align(s) {
	  send_bits(s, STATIC_TREES << 1, 3);
	  send_code(s, END_BLOCK, static_ltree);
	  bi_flush(s);
	}


	/* ===========================================================================
	 * Determine the best encoding for the current block: dynamic trees, static
	 * trees or store, and output the encoded block to the zip file.
	 */
	function _tr_flush_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block, or NULL if too old */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
	  var max_blindex = 0;        /* index of last bit length code of non zero freq */

	  /* Build the Huffman trees unless a stored block is forced */
	  if (s.level > 0) {

	    /* Check if the file is binary or text */
	    if (s.strm.data_type === Z_UNKNOWN) {
	      s.strm.data_type = detect_data_type(s);
	    }

	    /* Construct the literal and distance trees */
	    build_tree(s, s.l_desc);
	    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));

	    build_tree(s, s.d_desc);
	    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	    /* At this point, opt_len and static_len are the total bit lengths of
	     * the compressed block data, excluding the tree representations.
	     */

	    /* Build the bit length tree for the above two trees, and get the index
	     * in bl_order of the last bit length code to send.
	     */
	    max_blindex = build_bl_tree(s);

	    /* Determine the best encoding. Compute the block lengths in bytes. */
	    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
	    static_lenb = (s.static_len + 3 + 7) >>> 3;

	    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
	    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
	    //        s->last_lit));

	    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }

	  } else {
	    // Assert(buf != (char*)0, "lost buf");
	    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
	  }

	  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
	    /* 4: two words for the lengths */

	    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
	     * Otherwise we can't have processed more than WSIZE input bytes since
	     * the last block flush, because compression would have been
	     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
	     * transform a block into a stored block.
	     */
	    _tr_stored_block(s, buf, stored_len, last);

	  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {

	    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
	    compress_block(s, static_ltree, static_dtree);

	  } else {
	    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
	    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
	    compress_block(s, s.dyn_ltree, s.dyn_dtree);
	  }
	  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
	  /* The above check is made mod 2^32, for files larger than 512 MB
	   * and uLong implemented on 32 bits.
	   */
	  init_block(s);

	  if (last) {
	    bi_windup(s);
	  }
	  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
	  //       s->compressed_len-7*last));
	}

	/* ===========================================================================
	 * Save the match info and tally the frequency counts. Return true if
	 * the current block must be flushed.
	 */
	function _tr_tally(s, dist, lc)
	//    deflate_state *s;
	//    unsigned dist;  /* distance of matched string */
	//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
	{
	  //var out_length, in_length, dcode;

	  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
	  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;

	  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
	  s.last_lit++;

	  if (dist === 0) {
	    /* lc is the unmatched char */
	    s.dyn_ltree[lc * 2]/*.Freq*/++;
	  } else {
	    s.matches++;
	    /* Here, lc is the match length - MIN_MATCH */
	    dist--;             /* dist = match distance - 1 */
	    //Assert((ush)dist < (ush)MAX_DIST(s) &&
	    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
	    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");

	    s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]/*.Freq*/++;
	    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
	  }

	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility

	//#ifdef TRUNCATE_BLOCK
	//  /* Try to guess if it is profitable to stop the current block here */
	//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
	//    /* Compute an upper bound for the compressed length */
	//    out_length = s.last_lit*8;
	//    in_length = s.strstart - s.block_start;
	//
	//    for (dcode = 0; dcode < D_CODES; dcode++) {
	//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
	//    }
	//    out_length >>>= 3;
	//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
	//    //       s->last_lit, in_length, out_length,
	//    //       100L - out_length*100L/in_length));
	//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
	//      return true;
	//    }
	//  }
	//#endif

	  return (s.last_lit === s.lit_bufsize - 1);
	  /* We avoid equality with lit_bufsize because of wraparound at 64K
	   * on 16 bit machines and because stored blocks are restricted to
	   * 64K-1 bytes.
	   */
	}

	exports._tr_init  = _tr_init;
	exports._tr_stored_block = _tr_stored_block;
	exports._tr_flush_block  = _tr_flush_block;
	exports._tr_tally = _tr_tally;
	exports._tr_align = _tr_align;


/***/ }),
/* 66 */
/***/ (function(module, exports) {

	'use strict';

	// Note: adler32 takes 12% for level 0 and 2% for level 6.
	// It doesn't worth to make additional optimizationa as in original.
	// Small size is preferable.

	function adler32(adler, buf, len, pos) {
	  var s1 = (adler & 0xffff) |0,
	      s2 = ((adler >>> 16) & 0xffff) |0,
	      n = 0;

	  while (len !== 0) {
	    // Set limit ~ twice less than 5552, to keep
	    // s2 in 31-bits, because we force signed ints.
	    // in other case %= will fail.
	    n = len > 2000 ? 2000 : len;
	    len -= n;

	    do {
	      s1 = (s1 + buf[pos++]) |0;
	      s2 = (s2 + s1) |0;
	    } while (--n);

	    s1 %= 65521;
	    s2 %= 65521;
	  }

	  return (s1 | (s2 << 16)) |0;
	}


	module.exports = adler32;


/***/ }),
/* 67 */
/***/ (function(module, exports) {

	'use strict';

	// Note: we can't get significant speed boost here.
	// So write code to minimize size - no pregenerated tables
	// and array tools dependencies.


	// Use ordinary array, since untyped makes no boost here
	function makeTable() {
	  var c, table = [];

	  for (var n = 0; n < 256; n++) {
	    c = n;
	    for (var k = 0; k < 8; k++) {
	      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
	    }
	    table[n] = c;
	  }

	  return table;
	}

	// Create table on load. Just 255 signed longs. Not a problem.
	var crcTable = makeTable();


	function crc32(crc, buf, len, pos) {
	  var t = crcTable,
	      end = pos + len;

	  crc ^= -1;

	  for (var i = pos; i < end; i++) {
	    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
	  }

	  return (crc ^ (-1)); // >>> 0;
	}


	module.exports = crc32;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';


	var utils         = __webpack_require__(64);
	var adler32       = __webpack_require__(66);
	var crc32         = __webpack_require__(67);
	var inflate_fast  = __webpack_require__(69);
	var inflate_table = __webpack_require__(70);

	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;

	/* Public constants ==========================================================*/
	/* ===========================================================================*/


	/* Allowed flush values; see deflate() and inflate() below for details */
	//var Z_NO_FLUSH      = 0;
	//var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	//var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	var Z_TREES         = 6;


	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;

	/* The deflate compression method */
	var Z_DEFLATED  = 8;


	/* STATES ====================================================================*/
	/* ===========================================================================*/


	var    HEAD = 1;       /* i: waiting for magic header */
	var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
	var    TIME = 3;       /* i: waiting for modification time (gzip) */
	var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
	var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
	var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
	var    NAME = 7;       /* i: waiting for end of file name (gzip) */
	var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
	var    HCRC = 9;       /* i: waiting for header crc (gzip) */
	var    DICTID = 10;    /* i: waiting for dictionary check value */
	var    DICT = 11;      /* waiting for inflateSetDictionary() call */
	var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
	var        STORED = 14;    /* i: waiting for stored size (length and complement) */
	var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
	var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
	var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
	var        LENLENS = 18;   /* i: waiting for code length code lengths */
	var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
	var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
	var            LEN = 21;       /* i: waiting for length/lit/eob code */
	var            LENEXT = 22;    /* i: waiting for length extra bits */
	var            DIST = 23;      /* i: waiting for distance code */
	var            DISTEXT = 24;   /* i: waiting for distance extra bits */
	var            MATCH = 25;     /* o: waiting for output space to copy string */
	var            LIT = 26;       /* o: waiting for output space to write literal */
	var    CHECK = 27;     /* i: waiting for 32-bit check value */
	var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
	var    DONE = 29;      /* finished check, done -- remain here until reset */
	var    BAD = 30;       /* got a data error -- remain here until reset */
	var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
	var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */

	/* ===========================================================================*/



	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);

	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_WBITS = MAX_WBITS;


	function zswap32(q) {
	  return  (((q >>> 24) & 0xff) +
	          ((q >>> 8) & 0xff00) +
	          ((q & 0xff00) << 8) +
	          ((q & 0xff) << 24));
	}


	function InflateState() {
	  this.mode = 0;             /* current inflate mode */
	  this.last = false;          /* true if processing last block */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.havedict = false;      /* true if dictionary provided */
	  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
	  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
	  this.check = 0;             /* protected copy of check value */
	  this.total = 0;             /* protected copy of output count */
	  // TODO: may be {}
	  this.head = null;           /* where to save gzip header information */

	  /* sliding window */
	  this.wbits = 0;             /* log base 2 of requested window size */
	  this.wsize = 0;             /* window size or zero if not using window */
	  this.whave = 0;             /* valid bytes in the window */
	  this.wnext = 0;             /* window write index */
	  this.window = null;         /* allocated sliding window, if needed */

	  /* bit accumulator */
	  this.hold = 0;              /* input bit accumulator */
	  this.bits = 0;              /* number of bits in "in" */

	  /* for string and stored block copying */
	  this.length = 0;            /* literal or length of data to copy */
	  this.offset = 0;            /* distance back to copy string from */

	  /* for table and code decoding */
	  this.extra = 0;             /* extra bits needed */

	  /* fixed and dynamic code tables */
	  this.lencode = null;          /* starting table for length/literal codes */
	  this.distcode = null;         /* starting table for distance codes */
	  this.lenbits = 0;           /* index bits for lencode */
	  this.distbits = 0;          /* index bits for distcode */

	  /* dynamic table building */
	  this.ncode = 0;             /* number of code length code lengths */
	  this.nlen = 0;              /* number of length code lengths */
	  this.ndist = 0;             /* number of distance code lengths */
	  this.have = 0;              /* number of code lengths in lens[] */
	  this.next = null;              /* next available space in codes[] */

	  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
	  this.work = new utils.Buf16(288); /* work area for code table building */

	  /*
	   because we don't have pointers in js, we use lencode and distcode directly
	   as buffers so we don't need codes
	  */
	  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
	  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
	  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
	  this.sane = 0;                   /* if false, allow invalid distance too far */
	  this.back = 0;                   /* bits back of last unprocessed length/lit */
	  this.was = 0;                    /* initial length of match */
	}

	function inflateResetKeep(strm) {
	  var state;

	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  strm.total_in = strm.total_out = state.total = 0;
	  strm.msg = ''; /*Z_NULL*/
	  if (state.wrap) {       /* to support ill-conceived Java test suite */
	    strm.adler = state.wrap & 1;
	  }
	  state.mode = HEAD;
	  state.last = 0;
	  state.havedict = 0;
	  state.dmax = 32768;
	  state.head = null/*Z_NULL*/;
	  state.hold = 0;
	  state.bits = 0;
	  //state.lencode = state.distcode = state.next = state.codes;
	  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
	  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);

	  state.sane = 1;
	  state.back = -1;
	  //Tracev((stderr, "inflate: reset\n"));
	  return Z_OK;
	}

	function inflateReset(strm) {
	  var state;

	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  state.wsize = 0;
	  state.whave = 0;
	  state.wnext = 0;
	  return inflateResetKeep(strm);

	}

	function inflateReset2(strm, windowBits) {
	  var wrap;
	  var state;

	  /* get the state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;

	  /* extract wrap request from windowBits parameter */
	  if (windowBits < 0) {
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	  else {
	    wrap = (windowBits >> 4) + 1;
	    if (windowBits < 48) {
	      windowBits &= 15;
	    }
	  }

	  /* set number of window bits, free window if different */
	  if (windowBits && (windowBits < 8 || windowBits > 15)) {
	    return Z_STREAM_ERROR;
	  }
	  if (state.window !== null && state.wbits !== windowBits) {
	    state.window = null;
	  }

	  /* update state and reset the rest of it */
	  state.wrap = wrap;
	  state.wbits = windowBits;
	  return inflateReset(strm);
	}

	function inflateInit2(strm, windowBits) {
	  var ret;
	  var state;

	  if (!strm) { return Z_STREAM_ERROR; }
	  //strm.msg = Z_NULL;                 /* in case we return an error */

	  state = new InflateState();

	  //if (state === Z_NULL) return Z_MEM_ERROR;
	  //Tracev((stderr, "inflate: allocated\n"));
	  strm.state = state;
	  state.window = null/*Z_NULL*/;
	  ret = inflateReset2(strm, windowBits);
	  if (ret !== Z_OK) {
	    strm.state = null/*Z_NULL*/;
	  }
	  return ret;
	}

	function inflateInit(strm) {
	  return inflateInit2(strm, DEF_WBITS);
	}


	/*
	 Return state with length and distance decoding tables and index sizes set to
	 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
	 If BUILDFIXED is defined, then instead this routine builds the tables the
	 first time it's called, and returns those tables the first time and
	 thereafter.  This reduces the size of the code by about 2K bytes, in
	 exchange for a little execution time.  However, BUILDFIXED should not be
	 used for threaded applications, since the rewriting of the tables and virgin
	 may not be thread-safe.
	 */
	var virgin = true;

	var lenfix, distfix; // We have no pointers in JS, so keep tables separate

	function fixedtables(state) {
	  /* build fixed huffman tables if first call (may not be thread safe) */
	  if (virgin) {
	    var sym;

	    lenfix = new utils.Buf32(512);
	    distfix = new utils.Buf32(32);

	    /* literal/length table */
	    sym = 0;
	    while (sym < 144) { state.lens[sym++] = 8; }
	    while (sym < 256) { state.lens[sym++] = 9; }
	    while (sym < 280) { state.lens[sym++] = 7; }
	    while (sym < 288) { state.lens[sym++] = 8; }

	    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, { bits: 9 });

	    /* distance table */
	    sym = 0;
	    while (sym < 32) { state.lens[sym++] = 5; }

	    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, { bits: 5 });

	    /* do this just once */
	    virgin = false;
	  }

	  state.lencode = lenfix;
	  state.lenbits = 9;
	  state.distcode = distfix;
	  state.distbits = 5;
	}


	/*
	 Update the window with the last wsize (normally 32K) bytes written before
	 returning.  If window does not exist yet, create it.  This is only called
	 when a window is already in use, or when output has been written during this
	 inflate call, but the end of the deflate stream has not been reached yet.
	 It is also called to create a window for dictionary data when a dictionary
	 is loaded.

	 Providing output buffers larger than 32K to inflate() should provide a speed
	 advantage, since only the last 32K of output is copied to the sliding window
	 upon return from inflate(), and since all distances after the first 32K of
	 output will fall in the output data, making match copies simpler and faster.
	 The advantage may be dependent on the size of the processor's data caches.
	 */
	function updatewindow(strm, src, end, copy) {
	  var dist;
	  var state = strm.state;

	  /* if it hasn't been done already, allocate space for the window */
	  if (state.window === null) {
	    state.wsize = 1 << state.wbits;
	    state.wnext = 0;
	    state.whave = 0;

	    state.window = new utils.Buf8(state.wsize);
	  }

	  /* copy state->wsize or less output bytes into the circular window */
	  if (copy >= state.wsize) {
	    utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
	    state.wnext = 0;
	    state.whave = state.wsize;
	  }
	  else {
	    dist = state.wsize - state.wnext;
	    if (dist > copy) {
	      dist = copy;
	    }
	    //zmemcpy(state->window + state->wnext, end - copy, dist);
	    utils.arraySet(state.window, src, end - copy, dist, state.wnext);
	    copy -= dist;
	    if (copy) {
	      //zmemcpy(state->window, end - copy, copy);
	      utils.arraySet(state.window, src, end - copy, copy, 0);
	      state.wnext = copy;
	      state.whave = state.wsize;
	    }
	    else {
	      state.wnext += dist;
	      if (state.wnext === state.wsize) { state.wnext = 0; }
	      if (state.whave < state.wsize) { state.whave += dist; }
	    }
	  }
	  return 0;
	}

	function inflate(strm, flush) {
	  var state;
	  var input, output;          // input/output buffers
	  var next;                   /* next input INDEX */
	  var put;                    /* next output INDEX */
	  var have, left;             /* available input and output */
	  var hold;                   /* bit buffer */
	  var bits;                   /* bits in bit buffer */
	  var _in, _out;              /* save starting available input and output */
	  var copy;                   /* number of stored or match bytes to copy */
	  var from;                   /* where to copy match bytes from */
	  var from_source;
	  var here = 0;               /* current decoding table entry */
	  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
	  //var last;                   /* parent table entry */
	  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
	  var len;                    /* length to copy for repeats, bits to drop */
	  var ret;                    /* return code */
	  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
	  var opts;

	  var n; // temporary var for NEED_BITS

	  var order = /* permutation of code lengths */
	    [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];


	  if (!strm || !strm.state || !strm.output ||
	      (!strm.input && strm.avail_in !== 0)) {
	    return Z_STREAM_ERROR;
	  }

	  state = strm.state;
	  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */


	  //--- LOAD() ---
	  put = strm.next_out;
	  output = strm.output;
	  left = strm.avail_out;
	  next = strm.next_in;
	  input = strm.input;
	  have = strm.avail_in;
	  hold = state.hold;
	  bits = state.bits;
	  //---

	  _in = have;
	  _out = left;
	  ret = Z_OK;

	  inf_leave: // goto emulation
	  for (;;) {
	    switch (state.mode) {
	    case HEAD:
	      if (state.wrap === 0) {
	        state.mode = TYPEDO;
	        break;
	      }
	      //=== NEEDBITS(16);
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
	        state.check = 0/*crc32(0L, Z_NULL, 0)*/;
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//

	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = FLAGS;
	        break;
	      }
	      state.flags = 0;           /* expect zlib header */
	      if (state.head) {
	        state.head.done = false;
	      }
	      if (!(state.wrap & 1) ||   /* check if zlib header allowed */
	        (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
	        strm.msg = 'incorrect header check';
	        state.mode = BAD;
	        break;
	      }
	      if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
	        strm.msg = 'unknown compression method';
	        state.mode = BAD;
	        break;
	      }
	      //--- DROPBITS(4) ---//
	      hold >>>= 4;
	      bits -= 4;
	      //---//
	      len = (hold & 0x0f)/*BITS(4)*/ + 8;
	      if (state.wbits === 0) {
	        state.wbits = len;
	      }
	      else if (len > state.wbits) {
	        strm.msg = 'invalid window size';
	        state.mode = BAD;
	        break;
	      }
	      state.dmax = 1 << len;
	      //Tracev((stderr, "inflate:   zlib header ok\n"));
	      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	      state.mode = hold & 0x200 ? DICTID : TYPE;
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      break;
	    case FLAGS:
	      //=== NEEDBITS(16); */
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.flags = hold;
	      if ((state.flags & 0xff) !== Z_DEFLATED) {
	        strm.msg = 'unknown compression method';
	        state.mode = BAD;
	        break;
	      }
	      if (state.flags & 0xe000) {
	        strm.msg = 'unknown header flags set';
	        state.mode = BAD;
	        break;
	      }
	      if (state.head) {
	        state.head.text = ((hold >> 8) & 1);
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = TIME;
	      /* falls through */
	    case TIME:
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if (state.head) {
	        state.head.time = hold;
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC4(state.check, hold)
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        hbuf[2] = (hold >>> 16) & 0xff;
	        hbuf[3] = (hold >>> 24) & 0xff;
	        state.check = crc32(state.check, hbuf, 4, 0);
	        //===
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = OS;
	      /* falls through */
	    case OS:
	      //=== NEEDBITS(16); */
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if (state.head) {
	        state.head.xflags = (hold & 0xff);
	        state.head.os = (hold >> 8);
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = EXLEN;
	      /* falls through */
	    case EXLEN:
	      if (state.flags & 0x0400) {
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.length = hold;
	        if (state.head) {
	          state.head.extra_len = hold;
	        }
	        if (state.flags & 0x0200) {
	          //=== CRC2(state.check, hold);
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          state.check = crc32(state.check, hbuf, 2, 0);
	          //===//
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	      }
	      else if (state.head) {
	        state.head.extra = null/*Z_NULL*/;
	      }
	      state.mode = EXTRA;
	      /* falls through */
	    case EXTRA:
	      if (state.flags & 0x0400) {
	        copy = state.length;
	        if (copy > have) { copy = have; }
	        if (copy) {
	          if (state.head) {
	            len = state.head.extra_len - state.length;
	            if (!state.head.extra) {
	              // Use untyped array for more conveniend processing later
	              state.head.extra = new Array(state.head.extra_len);
	            }
	            utils.arraySet(
	              state.head.extra,
	              input,
	              next,
	              // extra field is limited to 65536 bytes
	              // - no need for additional size check
	              copy,
	              /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
	              len
	            );
	            //zmemcpy(state.head.extra + len, next,
	            //        len + copy > state.head.extra_max ?
	            //        state.head.extra_max - len : copy);
	          }
	          if (state.flags & 0x0200) {
	            state.check = crc32(state.check, input, copy, next);
	          }
	          have -= copy;
	          next += copy;
	          state.length -= copy;
	        }
	        if (state.length) { break inf_leave; }
	      }
	      state.length = 0;
	      state.mode = NAME;
	      /* falls through */
	    case NAME:
	      if (state.flags & 0x0800) {
	        if (have === 0) { break inf_leave; }
	        copy = 0;
	        do {
	          // TODO: 2 or 1 bytes?
	          len = input[next + copy++];
	          /* use constant limit because in js we should not preallocate memory */
	          if (state.head && len &&
	              (state.length < 65536 /*state.head.name_max*/)) {
	            state.head.name += String.fromCharCode(len);
	          }
	        } while (len && copy < have);

	        if (state.flags & 0x0200) {
	          state.check = crc32(state.check, input, copy, next);
	        }
	        have -= copy;
	        next += copy;
	        if (len) { break inf_leave; }
	      }
	      else if (state.head) {
	        state.head.name = null;
	      }
	      state.length = 0;
	      state.mode = COMMENT;
	      /* falls through */
	    case COMMENT:
	      if (state.flags & 0x1000) {
	        if (have === 0) { break inf_leave; }
	        copy = 0;
	        do {
	          len = input[next + copy++];
	          /* use constant limit because in js we should not preallocate memory */
	          if (state.head && len &&
	              (state.length < 65536 /*state.head.comm_max*/)) {
	            state.head.comment += String.fromCharCode(len);
	          }
	        } while (len && copy < have);
	        if (state.flags & 0x0200) {
	          state.check = crc32(state.check, input, copy, next);
	        }
	        have -= copy;
	        next += copy;
	        if (len) { break inf_leave; }
	      }
	      else if (state.head) {
	        state.head.comment = null;
	      }
	      state.mode = HCRC;
	      /* falls through */
	    case HCRC:
	      if (state.flags & 0x0200) {
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (hold !== (state.check & 0xffff)) {
	          strm.msg = 'header crc mismatch';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	      }
	      if (state.head) {
	        state.head.hcrc = ((state.flags >> 9) & 1);
	        state.head.done = true;
	      }
	      strm.adler = state.check = 0;
	      state.mode = TYPE;
	      break;
	    case DICTID:
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      strm.adler = state.check = zswap32(hold);
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = DICT;
	      /* falls through */
	    case DICT:
	      if (state.havedict === 0) {
	        //--- RESTORE() ---
	        strm.next_out = put;
	        strm.avail_out = left;
	        strm.next_in = next;
	        strm.avail_in = have;
	        state.hold = hold;
	        state.bits = bits;
	        //---
	        return Z_NEED_DICT;
	      }
	      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	      state.mode = TYPE;
	      /* falls through */
	    case TYPE:
	      if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case TYPEDO:
	      if (state.last) {
	        //--- BYTEBITS() ---//
	        hold >>>= bits & 7;
	        bits -= bits & 7;
	        //---//
	        state.mode = CHECK;
	        break;
	      }
	      //=== NEEDBITS(3); */
	      while (bits < 3) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.last = (hold & 0x01)/*BITS(1)*/;
	      //--- DROPBITS(1) ---//
	      hold >>>= 1;
	      bits -= 1;
	      //---//

	      switch ((hold & 0x03)/*BITS(2)*/) {
	      case 0:                             /* stored block */
	        //Tracev((stderr, "inflate:     stored block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = STORED;
	        break;
	      case 1:                             /* fixed block */
	        fixedtables(state);
	        //Tracev((stderr, "inflate:     fixed codes block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = LEN_;             /* decode codes */
	        if (flush === Z_TREES) {
	          //--- DROPBITS(2) ---//
	          hold >>>= 2;
	          bits -= 2;
	          //---//
	          break inf_leave;
	        }
	        break;
	      case 2:                             /* dynamic block */
	        //Tracev((stderr, "inflate:     dynamic codes block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = TABLE;
	        break;
	      case 3:
	        strm.msg = 'invalid block type';
	        state.mode = BAD;
	      }
	      //--- DROPBITS(2) ---//
	      hold >>>= 2;
	      bits -= 2;
	      //---//
	      break;
	    case STORED:
	      //--- BYTEBITS() ---// /* go to byte boundary */
	      hold >>>= bits & 7;
	      bits -= bits & 7;
	      //---//
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
	        strm.msg = 'invalid stored block lengths';
	        state.mode = BAD;
	        break;
	      }
	      state.length = hold & 0xffff;
	      //Tracev((stderr, "inflate:       stored length %u\n",
	      //        state.length));
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = COPY_;
	      if (flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case COPY_:
	      state.mode = COPY;
	      /* falls through */
	    case COPY:
	      copy = state.length;
	      if (copy) {
	        if (copy > have) { copy = have; }
	        if (copy > left) { copy = left; }
	        if (copy === 0) { break inf_leave; }
	        //--- zmemcpy(put, next, copy); ---
	        utils.arraySet(output, input, next, copy, put);
	        //---//
	        have -= copy;
	        next += copy;
	        left -= copy;
	        put += copy;
	        state.length -= copy;
	        break;
	      }
	      //Tracev((stderr, "inflate:       stored end\n"));
	      state.mode = TYPE;
	      break;
	    case TABLE:
	      //=== NEEDBITS(14); */
	      while (bits < 14) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
	      //--- DROPBITS(5) ---//
	      hold >>>= 5;
	      bits -= 5;
	      //---//
	      state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
	      //--- DROPBITS(5) ---//
	      hold >>>= 5;
	      bits -= 5;
	      //---//
	      state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
	      //--- DROPBITS(4) ---//
	      hold >>>= 4;
	      bits -= 4;
	      //---//
	//#ifndef PKZIP_BUG_WORKAROUND
	      if (state.nlen > 286 || state.ndist > 30) {
	        strm.msg = 'too many length or distance symbols';
	        state.mode = BAD;
	        break;
	      }
	//#endif
	      //Tracev((stderr, "inflate:       table sizes ok\n"));
	      state.have = 0;
	      state.mode = LENLENS;
	      /* falls through */
	    case LENLENS:
	      while (state.have < state.ncode) {
	        //=== NEEDBITS(3);
	        while (bits < 3) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
	        //--- DROPBITS(3) ---//
	        hold >>>= 3;
	        bits -= 3;
	        //---//
	      }
	      while (state.have < 19) {
	        state.lens[order[state.have++]] = 0;
	      }
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      //state.next = state.codes;
	      //state.lencode = state.next;
	      // Switch to use dynamic table
	      state.lencode = state.lendyn;
	      state.lenbits = 7;

	      opts = { bits: state.lenbits };
	      ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
	      state.lenbits = opts.bits;

	      if (ret) {
	        strm.msg = 'invalid code lengths set';
	        state.mode = BAD;
	        break;
	      }
	      //Tracev((stderr, "inflate:       code lengths ok\n"));
	      state.have = 0;
	      state.mode = CODELENS;
	      /* falls through */
	    case CODELENS:
	      while (state.have < state.nlen + state.ndist) {
	        for (;;) {
	          here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;

	          if ((here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        if (here_val < 16) {
	          //--- DROPBITS(here.bits) ---//
	          hold >>>= here_bits;
	          bits -= here_bits;
	          //---//
	          state.lens[state.have++] = here_val;
	        }
	        else {
	          if (here_val === 16) {
	            //=== NEEDBITS(here.bits + 2);
	            n = here_bits + 2;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            if (state.have === 0) {
	              strm.msg = 'invalid bit length repeat';
	              state.mode = BAD;
	              break;
	            }
	            len = state.lens[state.have - 1];
	            copy = 3 + (hold & 0x03);//BITS(2);
	            //--- DROPBITS(2) ---//
	            hold >>>= 2;
	            bits -= 2;
	            //---//
	          }
	          else if (here_val === 17) {
	            //=== NEEDBITS(here.bits + 3);
	            n = here_bits + 3;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            len = 0;
	            copy = 3 + (hold & 0x07);//BITS(3);
	            //--- DROPBITS(3) ---//
	            hold >>>= 3;
	            bits -= 3;
	            //---//
	          }
	          else {
	            //=== NEEDBITS(here.bits + 7);
	            n = here_bits + 7;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            len = 0;
	            copy = 11 + (hold & 0x7f);//BITS(7);
	            //--- DROPBITS(7) ---//
	            hold >>>= 7;
	            bits -= 7;
	            //---//
	          }
	          if (state.have + copy > state.nlen + state.ndist) {
	            strm.msg = 'invalid bit length repeat';
	            state.mode = BAD;
	            break;
	          }
	          while (copy--) {
	            state.lens[state.have++] = len;
	          }
	        }
	      }

	      /* handle error breaks in while */
	      if (state.mode === BAD) { break; }

	      /* check for end-of-block code (better have one) */
	      if (state.lens[256] === 0) {
	        strm.msg = 'invalid code -- missing end-of-block';
	        state.mode = BAD;
	        break;
	      }

	      /* build code tables -- note: do not change the lenbits or distbits
	         values here (9 and 6) without reading the comments in inftrees.h
	         concerning the ENOUGH constants, which depend on those values */
	      state.lenbits = 9;

	      opts = { bits: state.lenbits };
	      ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      // state.next_index = opts.table_index;
	      state.lenbits = opts.bits;
	      // state.lencode = state.next;

	      if (ret) {
	        strm.msg = 'invalid literal/lengths set';
	        state.mode = BAD;
	        break;
	      }

	      state.distbits = 6;
	      //state.distcode.copy(state.codes);
	      // Switch to use dynamic table
	      state.distcode = state.distdyn;
	      opts = { bits: state.distbits };
	      ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      // state.next_index = opts.table_index;
	      state.distbits = opts.bits;
	      // state.distcode = state.next;

	      if (ret) {
	        strm.msg = 'invalid distances set';
	        state.mode = BAD;
	        break;
	      }
	      //Tracev((stderr, 'inflate:       codes ok\n'));
	      state.mode = LEN_;
	      if (flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case LEN_:
	      state.mode = LEN;
	      /* falls through */
	    case LEN:
	      if (have >= 6 && left >= 258) {
	        //--- RESTORE() ---
	        strm.next_out = put;
	        strm.avail_out = left;
	        strm.next_in = next;
	        strm.avail_in = have;
	        state.hold = hold;
	        state.bits = bits;
	        //---
	        inflate_fast(strm, _out);
	        //--- LOAD() ---
	        put = strm.next_out;
	        output = strm.output;
	        left = strm.avail_out;
	        next = strm.next_in;
	        input = strm.input;
	        have = strm.avail_in;
	        hold = state.hold;
	        bits = state.bits;
	        //---

	        if (state.mode === TYPE) {
	          state.back = -1;
	        }
	        break;
	      }
	      state.back = 0;
	      for (;;) {
	        here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
	        here_bits = here >>> 24;
	        here_op = (here >>> 16) & 0xff;
	        here_val = here & 0xffff;

	        if (here_bits <= bits) { break; }
	        //--- PULLBYTE() ---//
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	        //---//
	      }
	      if (here_op && (here_op & 0xf0) === 0) {
	        last_bits = here_bits;
	        last_op = here_op;
	        last_val = here_val;
	        for (;;) {
	          here = state.lencode[last_val +
	                  ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;

	          if ((last_bits + here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        //--- DROPBITS(last.bits) ---//
	        hold >>>= last_bits;
	        bits -= last_bits;
	        //---//
	        state.back += last_bits;
	      }
	      //--- DROPBITS(here.bits) ---//
	      hold >>>= here_bits;
	      bits -= here_bits;
	      //---//
	      state.back += here_bits;
	      state.length = here_val;
	      if (here_op === 0) {
	        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	        //        "inflate:         literal '%c'\n" :
	        //        "inflate:         literal 0x%02x\n", here.val));
	        state.mode = LIT;
	        break;
	      }
	      if (here_op & 32) {
	        //Tracevv((stderr, "inflate:         end of block\n"));
	        state.back = -1;
	        state.mode = TYPE;
	        break;
	      }
	      if (here_op & 64) {
	        strm.msg = 'invalid literal/length code';
	        state.mode = BAD;
	        break;
	      }
	      state.extra = here_op & 15;
	      state.mode = LENEXT;
	      /* falls through */
	    case LENEXT:
	      if (state.extra) {
	        //=== NEEDBITS(state.extra);
	        n = state.extra;
	        while (bits < n) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
	        //--- DROPBITS(state.extra) ---//
	        hold >>>= state.extra;
	        bits -= state.extra;
	        //---//
	        state.back += state.extra;
	      }
	      //Tracevv((stderr, "inflate:         length %u\n", state.length));
	      state.was = state.length;
	      state.mode = DIST;
	      /* falls through */
	    case DIST:
	      for (;;) {
	        here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
	        here_bits = here >>> 24;
	        here_op = (here >>> 16) & 0xff;
	        here_val = here & 0xffff;

	        if ((here_bits) <= bits) { break; }
	        //--- PULLBYTE() ---//
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	        //---//
	      }
	      if ((here_op & 0xf0) === 0) {
	        last_bits = here_bits;
	        last_op = here_op;
	        last_val = here_val;
	        for (;;) {
	          here = state.distcode[last_val +
	                  ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;

	          if ((last_bits + here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        //--- DROPBITS(last.bits) ---//
	        hold >>>= last_bits;
	        bits -= last_bits;
	        //---//
	        state.back += last_bits;
	      }
	      //--- DROPBITS(here.bits) ---//
	      hold >>>= here_bits;
	      bits -= here_bits;
	      //---//
	      state.back += here_bits;
	      if (here_op & 64) {
	        strm.msg = 'invalid distance code';
	        state.mode = BAD;
	        break;
	      }
	      state.offset = here_val;
	      state.extra = (here_op) & 15;
	      state.mode = DISTEXT;
	      /* falls through */
	    case DISTEXT:
	      if (state.extra) {
	        //=== NEEDBITS(state.extra);
	        n = state.extra;
	        while (bits < n) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
	        //--- DROPBITS(state.extra) ---//
	        hold >>>= state.extra;
	        bits -= state.extra;
	        //---//
	        state.back += state.extra;
	      }
	//#ifdef INFLATE_STRICT
	      if (state.offset > state.dmax) {
	        strm.msg = 'invalid distance too far back';
	        state.mode = BAD;
	        break;
	      }
	//#endif
	      //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
	      state.mode = MATCH;
	      /* falls through */
	    case MATCH:
	      if (left === 0) { break inf_leave; }
	      copy = _out - left;
	      if (state.offset > copy) {         /* copy from window */
	        copy = state.offset - copy;
	        if (copy > state.whave) {
	          if (state.sane) {
	            strm.msg = 'invalid distance too far back';
	            state.mode = BAD;
	            break;
	          }
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//          Trace((stderr, "inflate.c too far\n"));
	//          copy -= state.whave;
	//          if (copy > state.length) { copy = state.length; }
	//          if (copy > left) { copy = left; }
	//          left -= copy;
	//          state.length -= copy;
	//          do {
	//            output[put++] = 0;
	//          } while (--copy);
	//          if (state.length === 0) { state.mode = LEN; }
	//          break;
	//#endif
	        }
	        if (copy > state.wnext) {
	          copy -= state.wnext;
	          from = state.wsize - copy;
	        }
	        else {
	          from = state.wnext - copy;
	        }
	        if (copy > state.length) { copy = state.length; }
	        from_source = state.window;
	      }
	      else {                              /* copy from output */
	        from_source = output;
	        from = put - state.offset;
	        copy = state.length;
	      }
	      if (copy > left) { copy = left; }
	      left -= copy;
	      state.length -= copy;
	      do {
	        output[put++] = from_source[from++];
	      } while (--copy);
	      if (state.length === 0) { state.mode = LEN; }
	      break;
	    case LIT:
	      if (left === 0) { break inf_leave; }
	      output[put++] = state.length;
	      left--;
	      state.mode = LEN;
	      break;
	    case CHECK:
	      if (state.wrap) {
	        //=== NEEDBITS(32);
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          // Use '|' insdead of '+' to make sure that result is signed
	          hold |= input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        _out -= left;
	        strm.total_out += _out;
	        state.total += _out;
	        if (_out) {
	          strm.adler = state.check =
	              /*UPDATE(state.check, put - _out, _out);*/
	              (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));

	        }
	        _out = left;
	        // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
	        if ((state.flags ? hold : zswap32(hold)) !== state.check) {
	          strm.msg = 'incorrect data check';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        //Tracev((stderr, "inflate:   check matches trailer\n"));
	      }
	      state.mode = LENGTH;
	      /* falls through */
	    case LENGTH:
	      if (state.wrap && state.flags) {
	        //=== NEEDBITS(32);
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (hold !== (state.total & 0xffffffff)) {
	          strm.msg = 'incorrect length check';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        //Tracev((stderr, "inflate:   length matches trailer\n"));
	      }
	      state.mode = DONE;
	      /* falls through */
	    case DONE:
	      ret = Z_STREAM_END;
	      break inf_leave;
	    case BAD:
	      ret = Z_DATA_ERROR;
	      break inf_leave;
	    case MEM:
	      return Z_MEM_ERROR;
	    case SYNC:
	      /* falls through */
	    default:
	      return Z_STREAM_ERROR;
	    }
	  }

	  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"

	  /*
	     Return from inflate(), updating the total counts and the check value.
	     If there was no progress during the inflate() call, return a buffer
	     error.  Call updatewindow() to create and/or update the window state.
	     Note: a memory error from inflate() is non-recoverable.
	   */

	  //--- RESTORE() ---
	  strm.next_out = put;
	  strm.avail_out = left;
	  strm.next_in = next;
	  strm.avail_in = have;
	  state.hold = hold;
	  state.bits = bits;
	  //---

	  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
	                      (state.mode < CHECK || flush !== Z_FINISH))) {
	    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
	      state.mode = MEM;
	      return Z_MEM_ERROR;
	    }
	  }
	  _in -= strm.avail_in;
	  _out -= strm.avail_out;
	  strm.total_in += _in;
	  strm.total_out += _out;
	  state.total += _out;
	  if (state.wrap && _out) {
	    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
	      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
	  }
	  strm.data_type = state.bits + (state.last ? 64 : 0) +
	                    (state.mode === TYPE ? 128 : 0) +
	                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
	  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
	    ret = Z_BUF_ERROR;
	  }
	  return ret;
	}

	function inflateEnd(strm) {

	  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
	    return Z_STREAM_ERROR;
	  }

	  var state = strm.state;
	  if (state.window) {
	    state.window = null;
	  }
	  strm.state = null;
	  return Z_OK;
	}

	function inflateGetHeader(strm, head) {
	  var state;

	  /* check state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }

	  /* save header structure */
	  state.head = head;
	  head.done = false;
	  return Z_OK;
	}

	function inflateSetDictionary(strm, dictionary) {
	  var dictLength = dictionary.length;

	  var state;
	  var dictid;
	  var ret;

	  /* check state */
	  if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) { return Z_STREAM_ERROR; }
	  state = strm.state;

	  if (state.wrap !== 0 && state.mode !== DICT) {
	    return Z_STREAM_ERROR;
	  }

	  /* check for correct dictionary identifier */
	  if (state.mode === DICT) {
	    dictid = 1; /* adler32(0, null, 0)*/
	    /* dictid = adler32(dictid, dictionary, dictLength); */
	    dictid = adler32(dictid, dictionary, dictLength, 0);
	    if (dictid !== state.check) {
	      return Z_DATA_ERROR;
	    }
	  }
	  /* copy dictionary to window using updatewindow(), which will amend the
	   existing dictionary if appropriate */
	  ret = updatewindow(strm, dictionary, dictLength, dictLength);
	  if (ret) {
	    state.mode = MEM;
	    return Z_MEM_ERROR;
	  }
	  state.havedict = 1;
	  // Tracev((stderr, "inflate:   dictionary set\n"));
	  return Z_OK;
	}

	exports.inflateReset = inflateReset;
	exports.inflateReset2 = inflateReset2;
	exports.inflateResetKeep = inflateResetKeep;
	exports.inflateInit = inflateInit;
	exports.inflateInit2 = inflateInit2;
	exports.inflate = inflate;
	exports.inflateEnd = inflateEnd;
	exports.inflateGetHeader = inflateGetHeader;
	exports.inflateSetDictionary = inflateSetDictionary;
	exports.inflateInfo = 'pako inflate (from Nodeca project)';

	/* Not implemented
	exports.inflateCopy = inflateCopy;
	exports.inflateGetDictionary = inflateGetDictionary;
	exports.inflateMark = inflateMark;
	exports.inflatePrime = inflatePrime;
	exports.inflateSync = inflateSync;
	exports.inflateSyncPoint = inflateSyncPoint;
	exports.inflateUndermine = inflateUndermine;
	*/


/***/ }),
/* 69 */
/***/ (function(module, exports) {

	'use strict';

	// See state defs from inflate.js
	var BAD = 30;       /* got a data error -- remain here until reset */
	var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */

	/*
	   Decode literal, length, and distance codes and write out the resulting
	   literal and match bytes until either not enough input or output is
	   available, an end-of-block is encountered, or a data error is encountered.
	   When large enough input and output buffers are supplied to inflate(), for
	   example, a 16K input buffer and a 64K output buffer, more than 95% of the
	   inflate execution time is spent in this routine.

	   Entry assumptions:

	        state.mode === LEN
	        strm.avail_in >= 6
	        strm.avail_out >= 258
	        start >= strm.avail_out
	        state.bits < 8

	   On return, state.mode is one of:

	        LEN -- ran out of enough output space or enough available input
	        TYPE -- reached end of block code, inflate() to interpret next block
	        BAD -- error in block data

	   Notes:

	    - The maximum input bits used by a length/distance pair is 15 bits for the
	      length code, 5 bits for the length extra, 15 bits for the distance code,
	      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
	      Therefore if strm.avail_in >= 6, then there is enough input to avoid
	      checking for available input while decoding.

	    - The maximum bytes that a single length/distance pair can output is 258
	      bytes, which is the maximum length that can be coded.  inflate_fast()
	      requires strm.avail_out >= 258 for each loop to avoid checking for
	      output space.
	 */
	module.exports = function inflate_fast(strm, start) {
	  var state;
	  var _in;                    /* local strm.input */
	  var last;                   /* have enough input while in < last */
	  var _out;                   /* local strm.output */
	  var beg;                    /* inflate()'s initial strm.output */
	  var end;                    /* while out < end, enough space available */
	//#ifdef INFLATE_STRICT
	  var dmax;                   /* maximum distance from zlib header */
	//#endif
	  var wsize;                  /* window size or zero if not using window */
	  var whave;                  /* valid bytes in the window */
	  var wnext;                  /* window write index */
	  // Use `s_window` instead `window`, avoid conflict with instrumentation tools
	  var s_window;               /* allocated sliding window, if wsize != 0 */
	  var hold;                   /* local strm.hold */
	  var bits;                   /* local strm.bits */
	  var lcode;                  /* local strm.lencode */
	  var dcode;                  /* local strm.distcode */
	  var lmask;                  /* mask for first level of length codes */
	  var dmask;                  /* mask for first level of distance codes */
	  var here;                   /* retrieved table entry */
	  var op;                     /* code bits, operation, extra bits, or */
	                              /*  window position, window bytes to copy */
	  var len;                    /* match length, unused bytes */
	  var dist;                   /* match distance */
	  var from;                   /* where to copy match from */
	  var from_source;


	  var input, output; // JS specific, because we have no pointers

	  /* copy state to local variables */
	  state = strm.state;
	  //here = state.here;
	  _in = strm.next_in;
	  input = strm.input;
	  last = _in + (strm.avail_in - 5);
	  _out = strm.next_out;
	  output = strm.output;
	  beg = _out - (start - strm.avail_out);
	  end = _out + (strm.avail_out - 257);
	//#ifdef INFLATE_STRICT
	  dmax = state.dmax;
	//#endif
	  wsize = state.wsize;
	  whave = state.whave;
	  wnext = state.wnext;
	  s_window = state.window;
	  hold = state.hold;
	  bits = state.bits;
	  lcode = state.lencode;
	  dcode = state.distcode;
	  lmask = (1 << state.lenbits) - 1;
	  dmask = (1 << state.distbits) - 1;


	  /* decode literals and length/distances until end-of-block or not enough
	     input data or output space */

	  top:
	  do {
	    if (bits < 15) {
	      hold += input[_in++] << bits;
	      bits += 8;
	      hold += input[_in++] << bits;
	      bits += 8;
	    }

	    here = lcode[hold & lmask];

	    dolen:
	    for (;;) { // Goto emulation
	      op = here >>> 24/*here.bits*/;
	      hold >>>= op;
	      bits -= op;
	      op = (here >>> 16) & 0xff/*here.op*/;
	      if (op === 0) {                          /* literal */
	        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	        //        "inflate:         literal '%c'\n" :
	        //        "inflate:         literal 0x%02x\n", here.val));
	        output[_out++] = here & 0xffff/*here.val*/;
	      }
	      else if (op & 16) {                     /* length base */
	        len = here & 0xffff/*here.val*/;
	        op &= 15;                           /* number of extra bits */
	        if (op) {
	          if (bits < op) {
	            hold += input[_in++] << bits;
	            bits += 8;
	          }
	          len += hold & ((1 << op) - 1);
	          hold >>>= op;
	          bits -= op;
	        }
	        //Tracevv((stderr, "inflate:         length %u\n", len));
	        if (bits < 15) {
	          hold += input[_in++] << bits;
	          bits += 8;
	          hold += input[_in++] << bits;
	          bits += 8;
	        }
	        here = dcode[hold & dmask];

	        dodist:
	        for (;;) { // goto emulation
	          op = here >>> 24/*here.bits*/;
	          hold >>>= op;
	          bits -= op;
	          op = (here >>> 16) & 0xff/*here.op*/;

	          if (op & 16) {                      /* distance base */
	            dist = here & 0xffff/*here.val*/;
	            op &= 15;                       /* number of extra bits */
	            if (bits < op) {
	              hold += input[_in++] << bits;
	              bits += 8;
	              if (bits < op) {
	                hold += input[_in++] << bits;
	                bits += 8;
	              }
	            }
	            dist += hold & ((1 << op) - 1);
	//#ifdef INFLATE_STRICT
	            if (dist > dmax) {
	              strm.msg = 'invalid distance too far back';
	              state.mode = BAD;
	              break top;
	            }
	//#endif
	            hold >>>= op;
	            bits -= op;
	            //Tracevv((stderr, "inflate:         distance %u\n", dist));
	            op = _out - beg;                /* max distance in output */
	            if (dist > op) {                /* see if copy from window */
	              op = dist - op;               /* distance back in window */
	              if (op > whave) {
	                if (state.sane) {
	                  strm.msg = 'invalid distance too far back';
	                  state.mode = BAD;
	                  break top;
	                }

	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//                if (len <= op - whave) {
	//                  do {
	//                    output[_out++] = 0;
	//                  } while (--len);
	//                  continue top;
	//                }
	//                len -= op - whave;
	//                do {
	//                  output[_out++] = 0;
	//                } while (--op > whave);
	//                if (op === 0) {
	//                  from = _out - dist;
	//                  do {
	//                    output[_out++] = output[from++];
	//                  } while (--len);
	//                  continue top;
	//                }
	//#endif
	              }
	              from = 0; // window index
	              from_source = s_window;
	              if (wnext === 0) {           /* very common case */
	                from += wsize - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              else if (wnext < op) {      /* wrap around window */
	                from += wsize + wnext - op;
	                op -= wnext;
	                if (op < len) {         /* some from end of window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = 0;
	                  if (wnext < len) {  /* some from start of window */
	                    op = wnext;
	                    len -= op;
	                    do {
	                      output[_out++] = s_window[from++];
	                    } while (--op);
	                    from = _out - dist;      /* rest from output */
	                    from_source = output;
	                  }
	                }
	              }
	              else {                      /* contiguous in window */
	                from += wnext - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              while (len > 2) {
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                len -= 3;
	              }
	              if (len) {
	                output[_out++] = from_source[from++];
	                if (len > 1) {
	                  output[_out++] = from_source[from++];
	                }
	              }
	            }
	            else {
	              from = _out - dist;          /* copy direct from output */
	              do {                        /* minimum length is three */
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                len -= 3;
	              } while (len > 2);
	              if (len) {
	                output[_out++] = output[from++];
	                if (len > 1) {
	                  output[_out++] = output[from++];
	                }
	              }
	            }
	          }
	          else if ((op & 64) === 0) {          /* 2nd level distance code */
	            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	            continue dodist;
	          }
	          else {
	            strm.msg = 'invalid distance code';
	            state.mode = BAD;
	            break top;
	          }

	          break; // need to emulate goto via "continue"
	        }
	      }
	      else if ((op & 64) === 0) {              /* 2nd level length code */
	        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	        continue dolen;
	      }
	      else if (op & 32) {                     /* end-of-block */
	        //Tracevv((stderr, "inflate:         end of block\n"));
	        state.mode = TYPE;
	        break top;
	      }
	      else {
	        strm.msg = 'invalid literal/length code';
	        state.mode = BAD;
	        break top;
	      }

	      break; // need to emulate goto via "continue"
	    }
	  } while (_in < last && _out < end);

	  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
	  len = bits >> 3;
	  _in -= len;
	  bits -= len << 3;
	  hold &= (1 << bits) - 1;

	  /* update state and return */
	  strm.next_in = _in;
	  strm.next_out = _out;
	  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
	  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
	  state.hold = hold;
	  state.bits = bits;
	  return;
	};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';


	var utils = __webpack_require__(64);

	var MAXBITS = 15;
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);

	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;

	var lbase = [ /* Length codes 257..285 base */
	  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
	  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
	];

	var lext = [ /* Length codes 257..285 extra */
	  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
	  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
	];

	var dbase = [ /* Distance codes 0..29 base */
	  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
	  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
	  8193, 12289, 16385, 24577, 0, 0
	];

	var dext = [ /* Distance codes 0..29 extra */
	  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
	  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
	  28, 28, 29, 29, 64, 64
	];

	module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
	{
	  var bits = opts.bits;
	      //here = opts.here; /* table entry for duplication */

	  var len = 0;               /* a code's length in bits */
	  var sym = 0;               /* index of code symbols */
	  var min = 0, max = 0;          /* minimum and maximum code lengths */
	  var root = 0;              /* number of index bits for root table */
	  var curr = 0;              /* number of index bits for current table */
	  var drop = 0;              /* code bits to drop for sub-table */
	  var left = 0;                   /* number of prefix codes available */
	  var used = 0;              /* code entries in table used */
	  var huff = 0;              /* Huffman code */
	  var incr;              /* for incrementing code, index */
	  var fill;              /* index for replicating entries */
	  var low;               /* low bits for current root entry */
	  var mask;              /* mask for low root bits */
	  var next;             /* next available space in table */
	  var base = null;     /* base value table to use */
	  var base_index = 0;
	//  var shoextra;    /* extra bits table to use */
	  var end;                    /* use base and extra for symbol > end */
	  var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
	  var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
	  var extra = null;
	  var extra_index = 0;

	  var here_bits, here_op, here_val;

	  /*
	   Process a set of code lengths to create a canonical Huffman code.  The
	   code lengths are lens[0..codes-1].  Each length corresponds to the
	   symbols 0..codes-1.  The Huffman code is generated by first sorting the
	   symbols by length from short to long, and retaining the symbol order
	   for codes with equal lengths.  Then the code starts with all zero bits
	   for the first code of the shortest length, and the codes are integer
	   increments for the same length, and zeros are appended as the length
	   increases.  For the deflate format, these bits are stored backwards
	   from their more natural integer increment ordering, and so when the
	   decoding tables are built in the large loop below, the integer codes
	   are incremented backwards.

	   This routine assumes, but does not check, that all of the entries in
	   lens[] are in the range 0..MAXBITS.  The caller must assure this.
	   1..MAXBITS is interpreted as that code length.  zero means that that
	   symbol does not occur in this code.

	   The codes are sorted by computing a count of codes for each length,
	   creating from that a table of starting indices for each length in the
	   sorted table, and then entering the symbols in order in the sorted
	   table.  The sorted table is work[], with that space being provided by
	   the caller.

	   The length counts are used for other purposes as well, i.e. finding
	   the minimum and maximum length codes, determining if there are any
	   codes at all, checking for a valid set of lengths, and looking ahead
	   at length counts to determine sub-table sizes when building the
	   decoding tables.
	   */

	  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
	  for (len = 0; len <= MAXBITS; len++) {
	    count[len] = 0;
	  }
	  for (sym = 0; sym < codes; sym++) {
	    count[lens[lens_index + sym]]++;
	  }

	  /* bound code lengths, force root to be within code lengths */
	  root = bits;
	  for (max = MAXBITS; max >= 1; max--) {
	    if (count[max] !== 0) { break; }
	  }
	  if (root > max) {
	    root = max;
	  }
	  if (max === 0) {                     /* no symbols to code at all */
	    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
	    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
	    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;


	    //table.op[opts.table_index] = 64;
	    //table.bits[opts.table_index] = 1;
	    //table.val[opts.table_index++] = 0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;

	    opts.bits = 1;
	    return 0;     /* no symbols, but wait for decoding to report error */
	  }
	  for (min = 1; min < max; min++) {
	    if (count[min] !== 0) { break; }
	  }
	  if (root < min) {
	    root = min;
	  }

	  /* check for an over-subscribed or incomplete set of lengths */
	  left = 1;
	  for (len = 1; len <= MAXBITS; len++) {
	    left <<= 1;
	    left -= count[len];
	    if (left < 0) {
	      return -1;
	    }        /* over-subscribed */
	  }
	  if (left > 0 && (type === CODES || max !== 1)) {
	    return -1;                      /* incomplete set */
	  }

	  /* generate offsets into symbol table for each length for sorting */
	  offs[1] = 0;
	  for (len = 1; len < MAXBITS; len++) {
	    offs[len + 1] = offs[len] + count[len];
	  }

	  /* sort symbols by length, by symbol order within each length */
	  for (sym = 0; sym < codes; sym++) {
	    if (lens[lens_index + sym] !== 0) {
	      work[offs[lens[lens_index + sym]]++] = sym;
	    }
	  }

	  /*
	   Create and fill in decoding tables.  In this loop, the table being
	   filled is at next and has curr index bits.  The code being used is huff
	   with length len.  That code is converted to an index by dropping drop
	   bits off of the bottom.  For codes where len is less than drop + curr,
	   those top drop + curr - len bits are incremented through all values to
	   fill the table with replicated entries.

	   root is the number of index bits for the root table.  When len exceeds
	   root, sub-tables are created pointed to by the root entry with an index
	   of the low root bits of huff.  This is saved in low to check for when a
	   new sub-table should be started.  drop is zero when the root table is
	   being filled, and drop is root when sub-tables are being filled.

	   When a new sub-table is needed, it is necessary to look ahead in the
	   code lengths to determine what size sub-table is needed.  The length
	   counts are used for this, and so count[] is decremented as codes are
	   entered in the tables.

	   used keeps track of how many table entries have been allocated from the
	   provided *table space.  It is checked for LENS and DIST tables against
	   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
	   the initial root table size constants.  See the comments in inftrees.h
	   for more information.

	   sym increments through all symbols, and the loop terminates when
	   all codes of length max, i.e. all codes, have been processed.  This
	   routine permits incomplete codes, so another loop after this one fills
	   in the rest of the decoding tables with invalid code markers.
	   */

	  /* set up for code type */
	  // poor man optimization - use if-else instead of switch,
	  // to avoid deopts in old v8
	  if (type === CODES) {
	    base = extra = work;    /* dummy value--not used */
	    end = 19;

	  } else if (type === LENS) {
	    base = lbase;
	    base_index -= 257;
	    extra = lext;
	    extra_index -= 257;
	    end = 256;

	  } else {                    /* DISTS */
	    base = dbase;
	    extra = dext;
	    end = -1;
	  }

	  /* initialize opts for loop */
	  huff = 0;                   /* starting code */
	  sym = 0;                    /* starting code symbol */
	  len = min;                  /* starting code length */
	  next = table_index;              /* current table to fill in */
	  curr = root;                /* current table index bits */
	  drop = 0;                   /* current bits to drop from code for index */
	  low = -1;                   /* trigger new sub-table when len > root */
	  used = 1 << root;          /* use root table entries */
	  mask = used - 1;            /* mask for comparing low */

	  /* check available table space */
	  if ((type === LENS && used > ENOUGH_LENS) ||
	    (type === DISTS && used > ENOUGH_DISTS)) {
	    return 1;
	  }

	  var i = 0;
	  /* process all codes and make table entries */
	  for (;;) {
	    i++;
	    /* create table entry */
	    here_bits = len - drop;
	    if (work[sym] < end) {
	      here_op = 0;
	      here_val = work[sym];
	    }
	    else if (work[sym] > end) {
	      here_op = extra[extra_index + work[sym]];
	      here_val = base[base_index + work[sym]];
	    }
	    else {
	      here_op = 32 + 64;         /* end of block */
	      here_val = 0;
	    }

	    /* replicate for those indices with low len bits equal to huff */
	    incr = 1 << (len - drop);
	    fill = 1 << curr;
	    min = fill;                 /* save offset to next table */
	    do {
	      fill -= incr;
	      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
	    } while (fill !== 0);

	    /* backwards increment the len-bit code huff */
	    incr = 1 << (len - 1);
	    while (huff & incr) {
	      incr >>= 1;
	    }
	    if (incr !== 0) {
	      huff &= incr - 1;
	      huff += incr;
	    } else {
	      huff = 0;
	    }

	    /* go to next symbol, update count, len */
	    sym++;
	    if (--count[len] === 0) {
	      if (len === max) { break; }
	      len = lens[lens_index + work[sym]];
	    }

	    /* create new sub-table if needed */
	    if (len > root && (huff & mask) !== low) {
	      /* if first time, transition to sub-tables */
	      if (drop === 0) {
	        drop = root;
	      }

	      /* increment past last table */
	      next += min;            /* here min is 1 << curr */

	      /* determine length of next table */
	      curr = len - drop;
	      left = 1 << curr;
	      while (curr + drop < max) {
	        left -= count[curr + drop];
	        if (left <= 0) { break; }
	        curr++;
	        left <<= 1;
	      }

	      /* check for enough space */
	      used += 1 << curr;
	      if ((type === LENS && used > ENOUGH_LENS) ||
	        (type === DISTS && used > ENOUGH_DISTS)) {
	        return 1;
	      }

	      /* point entry in root table to sub-table */
	      low = huff & mask;
	      /*table.op[low] = curr;
	      table.bits[low] = root;
	      table.val[low] = next - opts.table_index;*/
	      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
	    }
	  }

	  /* fill in remaining table entry if code is incomplete (guaranteed to have
	   at most one remaining entry, since if the code is incomplete, the
	   maximum code length that was allowed to get this far is one bit) */
	  if (huff !== 0) {
	    //table.op[next + huff] = 64;            /* invalid code marker */
	    //table.bits[next + huff] = len - drop;
	    //table.val[next + huff] = 0;
	    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
	  }

	  /* set return parameters */
	  //opts.table_index += used;
	  opts.bits = root;
	  return 0;
	};


/***/ }),
/* 71 */
/***/ (function(module, exports) {

	'use strict';


	module.exports = {

	  /* Allowed flush values; see deflate() and inflate() below for details */
	  Z_NO_FLUSH:         0,
	  Z_PARTIAL_FLUSH:    1,
	  Z_SYNC_FLUSH:       2,
	  Z_FULL_FLUSH:       3,
	  Z_FINISH:           4,
	  Z_BLOCK:            5,
	  Z_TREES:            6,

	  /* Return codes for the compression/decompression functions. Negative values
	  * are errors, positive values are used for special but normal events.
	  */
	  Z_OK:               0,
	  Z_STREAM_END:       1,
	  Z_NEED_DICT:        2,
	  Z_ERRNO:           -1,
	  Z_STREAM_ERROR:    -2,
	  Z_DATA_ERROR:      -3,
	  //Z_MEM_ERROR:     -4,
	  Z_BUF_ERROR:       -5,
	  //Z_VERSION_ERROR: -6,

	  /* compression levels */
	  Z_NO_COMPRESSION:         0,
	  Z_BEST_SPEED:             1,
	  Z_BEST_COMPRESSION:       9,
	  Z_DEFAULT_COMPRESSION:   -1,


	  Z_FILTERED:               1,
	  Z_HUFFMAN_ONLY:           2,
	  Z_RLE:                    3,
	  Z_FIXED:                  4,
	  Z_DEFAULT_STRATEGY:       0,

	  /* Possible values of the data_type field (though see inflate()) */
	  Z_BINARY:                 0,
	  Z_TEXT:                   1,
	  //Z_ASCII:                1, // = Z_TEXT (deprecated)
	  Z_UNKNOWN:                2,

	  /* The deflate compression method */
	  Z_DEFLATED:               8
	  //Z_NULL:                 null // Use -1 or null inline, depending on var type
	};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }

	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};


	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }

	  if (process.noDeprecation === true) {
	    return fn;
	  }

	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }

	  return deprecated;
	};


	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = process.env.NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};


	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;


	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};

	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};


	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];

	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}


	function stylizeNoColor(str, styleType) {
	  return str;
	}


	function arrayToHash(array) {
	  var hash = {};

	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });

	  return hash;
	}


	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }

	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }

	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);

	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }

	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }

	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }

	  var base = '', array = false, braces = ['{', '}'];

	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }

	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }

	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }

	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }

	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }

	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }

	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }

	  ctx.seen.push(value);

	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }

	  ctx.seen.pop();

	  return reduceToSingleString(output, base, braces);
	}


	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}


	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}


	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}


	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }

	  return name + ': ' + str;
	}


	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);

	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }

	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}


	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;

	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;

	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;

	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;

	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;

	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;

	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;

	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;

	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;

	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;

	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;

	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;

	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;

	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;

	exports.isBuffer = __webpack_require__(73);

	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}


	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}


	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];

	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}


	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};


	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(74);

	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;

	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};

	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(36)))

/***/ }),
/* 73 */
/***/ (function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ }),
/* 74 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';

	// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
	// original notice:

	/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	function compare(a, b) {
	  if (a === b) {
	    return 0;
	  }

	  var x = a.length;
	  var y = b.length;

	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i];
	      y = b[i];
	      break;
	    }
	  }

	  if (x < y) {
	    return -1;
	  }
	  if (y < x) {
	    return 1;
	  }
	  return 0;
	}
	function isBuffer(b) {
	  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
	    return global.Buffer.isBuffer(b);
	  }
	  return !!(b != null && b._isBuffer);
	}

	// based on node assert, original notice:

	// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
	//
	// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
	//
	// Originally from narwhal.js (http://narwhaljs.org)
	// Copyright (c) 2009 Thomas Robinson <280north.com>
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the 'Software'), to
	// deal in the Software without restriction, including without limitation the
	// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
	// sell copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

	var util = __webpack_require__(72);
	var hasOwn = Object.prototype.hasOwnProperty;
	var pSlice = Array.prototype.slice;
	var functionsHaveNames = (function () {
	  return function foo() {}.name === 'foo';
	}());
	function pToString (obj) {
	  return Object.prototype.toString.call(obj);
	}
	function isView(arrbuf) {
	  if (isBuffer(arrbuf)) {
	    return false;
	  }
	  if (typeof global.ArrayBuffer !== 'function') {
	    return false;
	  }
	  if (typeof ArrayBuffer.isView === 'function') {
	    return ArrayBuffer.isView(arrbuf);
	  }
	  if (!arrbuf) {
	    return false;
	  }
	  if (arrbuf instanceof DataView) {
	    return true;
	  }
	  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
	    return true;
	  }
	  return false;
	}
	// 1. The assert module provides functions that throw
	// AssertionError's when particular conditions are not met. The
	// assert module must conform to the following interface.

	var assert = module.exports = ok;

	// 2. The AssertionError is defined in assert.
	// new assert.AssertionError({ message: message,
	//                             actual: actual,
	//                             expected: expected })

	var regex = /\s*function\s+([^\(\s]*)\s*/;
	// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
	function getName(func) {
	  if (!util.isFunction(func)) {
	    return;
	  }
	  if (functionsHaveNames) {
	    return func.name;
	  }
	  var str = func.toString();
	  var match = str.match(regex);
	  return match && match[1];
	}
	assert.AssertionError = function AssertionError(options) {
	  this.name = 'AssertionError';
	  this.actual = options.actual;
	  this.expected = options.expected;
	  this.operator = options.operator;
	  if (options.message) {
	    this.message = options.message;
	    this.generatedMessage = false;
	  } else {
	    this.message = getMessage(this);
	    this.generatedMessage = true;
	  }
	  var stackStartFunction = options.stackStartFunction || fail;
	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, stackStartFunction);
	  } else {
	    // non v8 browsers so we can have a stacktrace
	    var err = new Error();
	    if (err.stack) {
	      var out = err.stack;

	      // try to strip useless frames
	      var fn_name = getName(stackStartFunction);
	      var idx = out.indexOf('\n' + fn_name);
	      if (idx >= 0) {
	        // once we have located the function frame
	        // we need to strip out everything before it (and its line)
	        var next_line = out.indexOf('\n', idx + 1);
	        out = out.substring(next_line + 1);
	      }

	      this.stack = out;
	    }
	  }
	};

	// assert.AssertionError instanceof Error
	util.inherits(assert.AssertionError, Error);

	function truncate(s, n) {
	  if (typeof s === 'string') {
	    return s.length < n ? s : s.slice(0, n);
	  } else {
	    return s;
	  }
	}
	function inspect(something) {
	  if (functionsHaveNames || !util.isFunction(something)) {
	    return util.inspect(something);
	  }
	  var rawname = getName(something);
	  var name = rawname ? ': ' + rawname : '';
	  return '[Function' +  name + ']';
	}
	function getMessage(self) {
	  return truncate(inspect(self.actual), 128) + ' ' +
	         self.operator + ' ' +
	         truncate(inspect(self.expected), 128);
	}

	// At present only the three keys mentioned above are used and
	// understood by the spec. Implementations or sub modules can pass
	// other keys to the AssertionError's constructor - they will be
	// ignored.

	// 3. All of the following functions must throw an AssertionError
	// when a corresponding condition is not met, with a message that
	// may be undefined if not provided.  All assertion methods provide
	// both the actual and expected values to the assertion error for
	// display purposes.

	function fail(actual, expected, message, operator, stackStartFunction) {
	  throw new assert.AssertionError({
	    message: message,
	    actual: actual,
	    expected: expected,
	    operator: operator,
	    stackStartFunction: stackStartFunction
	  });
	}

	// EXTENSION! allows for well behaved errors defined elsewhere.
	assert.fail = fail;

	// 4. Pure assertion tests whether a value is truthy, as determined
	// by !!guard.
	// assert.ok(guard, message_opt);
	// This statement is equivalent to assert.equal(true, !!guard,
	// message_opt);. To test strictly for the value true, use
	// assert.strictEqual(true, guard, message_opt);.

	function ok(value, message) {
	  if (!value) fail(value, true, message, '==', assert.ok);
	}
	assert.ok = ok;

	// 5. The equality assertion tests shallow, coercive equality with
	// ==.
	// assert.equal(actual, expected, message_opt);

	assert.equal = function equal(actual, expected, message) {
	  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
	};

	// 6. The non-equality assertion tests for whether two objects are not equal
	// with != assert.notEqual(actual, expected, message_opt);

	assert.notEqual = function notEqual(actual, expected, message) {
	  if (actual == expected) {
	    fail(actual, expected, message, '!=', assert.notEqual);
	  }
	};

	// 7. The equivalence assertion tests a deep equality relation.
	// assert.deepEqual(actual, expected, message_opt);

	assert.deepEqual = function deepEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
	  }
	};

	assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
	  }
	};

	function _deepEqual(actual, expected, strict, memos) {
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	  } else if (isBuffer(actual) && isBuffer(expected)) {
	    return compare(actual, expected) === 0;

	  // 7.2. If the expected value is a Date object, the actual value is
	  // equivalent if it is also a Date object that refers to the same time.
	  } else if (util.isDate(actual) && util.isDate(expected)) {
	    return actual.getTime() === expected.getTime();

	  // 7.3 If the expected value is a RegExp object, the actual value is
	  // equivalent if it is also a RegExp object with the same source and
	  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
	  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
	    return actual.source === expected.source &&
	           actual.global === expected.global &&
	           actual.multiline === expected.multiline &&
	           actual.lastIndex === expected.lastIndex &&
	           actual.ignoreCase === expected.ignoreCase;

	  // 7.4. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if ((actual === null || typeof actual !== 'object') &&
	             (expected === null || typeof expected !== 'object')) {
	    return strict ? actual === expected : actual == expected;

	  // If both values are instances of typed arrays, wrap their underlying
	  // ArrayBuffers in a Buffer each to increase performance
	  // This optimization requires the arrays to have the same type as checked by
	  // Object.prototype.toString (aka pToString). Never perform binary
	  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
	  // bit patterns are not identical.
	  } else if (isView(actual) && isView(expected) &&
	             pToString(actual) === pToString(expected) &&
	             !(actual instanceof Float32Array ||
	               actual instanceof Float64Array)) {
	    return compare(new Uint8Array(actual.buffer),
	                   new Uint8Array(expected.buffer)) === 0;

	  // 7.5 For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else if (isBuffer(actual) !== isBuffer(expected)) {
	    return false;
	  } else {
	    memos = memos || {actual: [], expected: []};

	    var actualIndex = memos.actual.indexOf(actual);
	    if (actualIndex !== -1) {
	      if (actualIndex === memos.expected.indexOf(expected)) {
	        return true;
	      }
	    }

	    memos.actual.push(actual);
	    memos.expected.push(expected);

	    return objEquiv(actual, expected, strict, memos);
	  }
	}

	function isArguments(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	}

	function objEquiv(a, b, strict, actualVisitedObjects) {
	  if (a === null || a === undefined || b === null || b === undefined)
	    return false;
	  // if one is a primitive, the other must be same
	  if (util.isPrimitive(a) || util.isPrimitive(b))
	    return a === b;
	  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
	    return false;
	  var aIsArgs = isArguments(a);
	  var bIsArgs = isArguments(b);
	  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
	    return false;
	  if (aIsArgs) {
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return _deepEqual(a, b, strict);
	  }
	  var ka = objectKeys(a);
	  var kb = objectKeys(b);
	  var key, i;
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length !== kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] !== kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
	      return false;
	  }
	  return true;
	}

	// 8. The non-equivalence assertion tests for any deep inequality.
	// assert.notDeepEqual(actual, expected, message_opt);

	assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
	  }
	};

	assert.notDeepStrictEqual = notDeepStrictEqual;
	function notDeepStrictEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
	  }
	}


	// 9. The strict equality assertion tests strict equality, as determined by ===.
	// assert.strictEqual(actual, expected, message_opt);

	assert.strictEqual = function strictEqual(actual, expected, message) {
	  if (actual !== expected) {
	    fail(actual, expected, message, '===', assert.strictEqual);
	  }
	};

	// 10. The strict non-equality assertion tests for strict inequality, as
	// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);

	assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
	  if (actual === expected) {
	    fail(actual, expected, message, '!==', assert.notStrictEqual);
	  }
	};

	function expectedException(actual, expected) {
	  if (!actual || !expected) {
	    return false;
	  }

	  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
	    return expected.test(actual);
	  }

	  try {
	    if (actual instanceof expected) {
	      return true;
	    }
	  } catch (e) {
	    // Ignore.  The instanceof check doesn't work for arrow functions.
	  }

	  if (Error.isPrototypeOf(expected)) {
	    return false;
	  }

	  return expected.call({}, actual) === true;
	}

	function _tryBlock(block) {
	  var error;
	  try {
	    block();
	  } catch (e) {
	    error = e;
	  }
	  return error;
	}

	function _throws(shouldThrow, block, expected, message) {
	  var actual;

	  if (typeof block !== 'function') {
	    throw new TypeError('"block" argument must be a function');
	  }

	  if (typeof expected === 'string') {
	    message = expected;
	    expected = null;
	  }

	  actual = _tryBlock(block);

	  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
	            (message ? ' ' + message : '.');

	  if (shouldThrow && !actual) {
	    fail(actual, expected, 'Missing expected exception' + message);
	  }

	  var userProvidedMessage = typeof message === 'string';
	  var isUnwantedException = !shouldThrow && util.isError(actual);
	  var isUnexpectedException = !shouldThrow && actual && !expected;

	  if ((isUnwantedException &&
	      userProvidedMessage &&
	      expectedException(actual, expected)) ||
	      isUnexpectedException) {
	    fail(actual, expected, 'Got unwanted exception' + message);
	  }

	  if ((shouldThrow && actual && expected &&
	      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
	    throw actual;
	  }
	}

	// 11. Expected to throw an error:
	// assert.throws(block, Error_opt, message_opt);

	assert.throws = function(block, /*optional*/error, /*optional*/message) {
	  _throws(true, block, error, message);
	};

	// EXTENSION! This is annoying to write outside this module.
	assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
	  _throws(false, block, error, message);
	};

	assert.ifError = function(err) { if (err) throw err; };

	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    if (hasOwn.call(obj, key)) keys.push(key);
	  }
	  return keys;
	};

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 76 */
/***/ (function(module, exports) {

	// Generated by CoffeeScript 1.12.6

	/*
	PDFPage - represents a single page in the PDF document
	By Devon Govett
	 */

	(function() {
	  var PDFPage;

	  PDFPage = (function() {
	    var DEFAULT_MARGINS, SIZES;

	    function PDFPage(document, options) {
	      var dimensions;
	      this.document = document;
	      if (options == null) {
	        options = {};
	      }
	      this.size = options.size || 'letter';
	      this.layout = options.layout || 'portrait';
	      if (typeof options.margin === 'number') {
	        this.margins = {
	          top: options.margin,
	          left: options.margin,
	          bottom: options.margin,
	          right: options.margin
	        };
	      } else {
	        this.margins = options.margins || DEFAULT_MARGINS;
	      }
	      dimensions = Array.isArray(this.size) ? this.size : SIZES[this.size.toUpperCase()];
	      this.width = dimensions[this.layout === 'portrait' ? 0 : 1];
	      this.height = dimensions[this.layout === 'portrait' ? 1 : 0];
	      this.content = this.document.ref();
	      this.resources = this.document.ref({
	        ProcSet: ['PDF', 'Text', 'ImageB', 'ImageC', 'ImageI']
	      });
	      Object.defineProperties(this, {
	        fonts: {
	          get: (function(_this) {
	            return function() {
	              var base;
	              return (base = _this.resources.data).Font != null ? base.Font : base.Font = {};
	            };
	          })(this)
	        },
	        xobjects: {
	          get: (function(_this) {
	            return function() {
	              var base;
	              return (base = _this.resources.data).XObject != null ? base.XObject : base.XObject = {};
	            };
	          })(this)
	        },
	        ext_gstates: {
	          get: (function(_this) {
	            return function() {
	              var base;
	              return (base = _this.resources.data).ExtGState != null ? base.ExtGState : base.ExtGState = {};
	            };
	          })(this)
	        },
	        patterns: {
	          get: (function(_this) {
	            return function() {
	              var base;
	              return (base = _this.resources.data).Pattern != null ? base.Pattern : base.Pattern = {};
	            };
	          })(this)
	        },
	        annotations: {
	          get: (function(_this) {
	            return function() {
	              var base;
	              return (base = _this.dictionary.data).Annots != null ? base.Annots : base.Annots = [];
	            };
	          })(this)
	        }
	      });
	      this.dictionary = this.document.ref({
	        Type: 'Page',
	        Parent: this.document._root.data.Pages,
	        MediaBox: [0, 0, this.width, this.height],
	        Contents: this.content,
	        Resources: this.resources
	      });
	    }

	    PDFPage.prototype.maxY = function() {
	      return this.height - this.margins.bottom;
	    };

	    PDFPage.prototype.write = function(chunk) {
	      return this.content.write(chunk);
	    };

	    PDFPage.prototype.end = function() {
	      this.dictionary.end();
	      this.resources.end();
	      return this.content.end();
	    };

	    DEFAULT_MARGINS = {
	      top: 72,
	      left: 72,
	      bottom: 72,
	      right: 72
	    };

	    SIZES = {
	      '4A0': [4767.87, 6740.79],
	      '2A0': [3370.39, 4767.87],
	      A0: [2383.94, 3370.39],
	      A1: [1683.78, 2383.94],
	      A2: [1190.55, 1683.78],
	      A3: [841.89, 1190.55],
	      A4: [595.28, 841.89],
	      A5: [419.53, 595.28],
	      A6: [297.64, 419.53],
	      A7: [209.76, 297.64],
	      A8: [147.40, 209.76],
	      A9: [104.88, 147.40],
	      A10: [73.70, 104.88],
	      B0: [2834.65, 4008.19],
	      B1: [2004.09, 2834.65],
	      B2: [1417.32, 2004.09],
	      B3: [1000.63, 1417.32],
	      B4: [708.66, 1000.63],
	      B5: [498.90, 708.66],
	      B6: [354.33, 498.90],
	      B7: [249.45, 354.33],
	      B8: [175.75, 249.45],
	      B9: [124.72, 175.75],
	      B10: [87.87, 124.72],
	      C0: [2599.37, 3676.54],
	      C1: [1836.85, 2599.37],
	      C2: [1298.27, 1836.85],
	      C3: [918.43, 1298.27],
	      C4: [649.13, 918.43],
	      C5: [459.21, 649.13],
	      C6: [323.15, 459.21],
	      C7: [229.61, 323.15],
	      C8: [161.57, 229.61],
	      C9: [113.39, 161.57],
	      C10: [79.37, 113.39],
	      RA0: [2437.80, 3458.27],
	      RA1: [1729.13, 2437.80],
	      RA2: [1218.90, 1729.13],
	      RA3: [864.57, 1218.90],
	      RA4: [609.45, 864.57],
	      SRA0: [2551.18, 3628.35],
	      SRA1: [1814.17, 2551.18],
	      SRA2: [1275.59, 1814.17],
	      SRA3: [907.09, 1275.59],
	      SRA4: [637.80, 907.09],
	      EXECUTIVE: [521.86, 756.00],
	      FOLIO: [612.00, 936.00],
	      LEGAL: [612.00, 1008.00],
	      LETTER: [612.00, 792.00],
	      TABLOID: [792.00, 1224.00]
	    };

	    return PDFPage;

	  })();

	  module.exports = PDFPage;

	}).call(this);


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.12.6
	(function() {
	  var PDFGradient, PDFLinearGradient, PDFRadialGradient, namedColors, ref;

	  ref = __webpack_require__(78), PDFGradient = ref.PDFGradient, PDFLinearGradient = ref.PDFLinearGradient, PDFRadialGradient = ref.PDFRadialGradient;

	  module.exports = {
	    initColor: function() {
	      this._opacityRegistry = {};
	      this._opacityCount = 0;
	      return this._gradCount = 0;
	    },
	    _normalizeColor: function(color) {
	      var hex, part;
	      if (color instanceof PDFGradient) {
	        return color;
	      }
	      if (typeof color === 'string') {
	        if (color.charAt(0) === '#') {
	          if (color.length === 4) {
	            color = color.replace(/#([0-9A-F])([0-9A-F])([0-9A-F])/i, "#$1$1$2$2$3$3");
	          }
	          hex = parseInt(color.slice(1), 16);
	          color = [hex >> 16, hex >> 8 & 0xff, hex & 0xff];
	        } else if (namedColors[color]) {
	          color = namedColors[color];
	        }
	      }
	      if (Array.isArray(color)) {
	        if (color.length === 3) {
	          color = (function() {
	            var i, len, results;
	            results = [];
	            for (i = 0, len = color.length; i < len; i++) {
	              part = color[i];
	              results.push(part / 255);
	            }
	            return results;
	          })();
	        } else if (color.length === 4) {
	          color = (function() {
	            var i, len, results;
	            results = [];
	            for (i = 0, len = color.length; i < len; i++) {
	              part = color[i];
	              results.push(part / 100);
	            }
	            return results;
	          })();
	        }
	        return color;
	      }
	      return null;
	    },
	    _setColor: function(color, stroke) {
	      var op, space;
	      color = this._normalizeColor(color);
	      if (!color) {
	        return false;
	      }
	      op = stroke ? 'SCN' : 'scn';
	      if (color instanceof PDFGradient) {
	        this._setColorSpace('Pattern', stroke);
	        color.apply(op);
	      } else {
	        space = color.length === 4 ? 'DeviceCMYK' : 'DeviceRGB';
	        this._setColorSpace(space, stroke);
	        color = color.join(' ');
	        this.addContent(color + " " + op);
	      }
	      return true;
	    },
	    _setColorSpace: function(space, stroke) {
	      var op;
	      op = stroke ? 'CS' : 'cs';
	      return this.addContent("/" + space + " " + op);
	    },
	    fillColor: function(color, opacity) {
	      var set;
	      set = this._setColor(color, false);
	      if (set) {
	        this.fillOpacity(opacity);
	      }
	      this._fillColor = [color, opacity];
	      return this;
	    },
	    strokeColor: function(color, opacity) {
	      var set;
	      set = this._setColor(color, true);
	      if (set) {
	        this.strokeOpacity(opacity);
	      }
	      return this;
	    },
	    opacity: function(opacity) {
	      this._doOpacity(opacity, opacity);
	      return this;
	    },
	    fillOpacity: function(opacity) {
	      this._doOpacity(opacity, null);
	      return this;
	    },
	    strokeOpacity: function(opacity) {
	      this._doOpacity(null, opacity);
	      return this;
	    },
	    _doOpacity: function(fillOpacity, strokeOpacity) {
	      var dictionary, id, key, name, ref1;
	      if (!((fillOpacity != null) || (strokeOpacity != null))) {
	        return;
	      }
	      if (fillOpacity != null) {
	        fillOpacity = Math.max(0, Math.min(1, fillOpacity));
	      }
	      if (strokeOpacity != null) {
	        strokeOpacity = Math.max(0, Math.min(1, strokeOpacity));
	      }
	      key = fillOpacity + "_" + strokeOpacity;
	      if (this._opacityRegistry[key]) {
	        ref1 = this._opacityRegistry[key], dictionary = ref1[0], name = ref1[1];
	      } else {
	        dictionary = {
	          Type: 'ExtGState'
	        };
	        if (fillOpacity != null) {
	          dictionary.ca = fillOpacity;
	        }
	        if (strokeOpacity != null) {
	          dictionary.CA = strokeOpacity;
	        }
	        dictionary = this.ref(dictionary);
	        dictionary.end();
	        id = ++this._opacityCount;
	        name = "Gs" + id;
	        this._opacityRegistry[key] = [dictionary, name];
	      }
	      this.page.ext_gstates[name] = dictionary;
	      return this.addContent("/" + name + " gs");
	    },
	    linearGradient: function(x1, y1, x2, y2) {
	      return new PDFLinearGradient(this, x1, y1, x2, y2);
	    },
	    radialGradient: function(x1, y1, r1, x2, y2, r2) {
	      return new PDFRadialGradient(this, x1, y1, r1, x2, y2, r2);
	    }
	  };

	  namedColors = {
	    aliceblue: [240, 248, 255],
	    antiquewhite: [250, 235, 215],
	    aqua: [0, 255, 255],
	    aquamarine: [127, 255, 212],
	    azure: [240, 255, 255],
	    beige: [245, 245, 220],
	    bisque: [255, 228, 196],
	    black: [0, 0, 0],
	    blanchedalmond: [255, 235, 205],
	    blue: [0, 0, 255],
	    blueviolet: [138, 43, 226],
	    brown: [165, 42, 42],
	    burlywood: [222, 184, 135],
	    cadetblue: [95, 158, 160],
	    chartreuse: [127, 255, 0],
	    chocolate: [210, 105, 30],
	    coral: [255, 127, 80],
	    cornflowerblue: [100, 149, 237],
	    cornsilk: [255, 248, 220],
	    crimson: [220, 20, 60],
	    cyan: [0, 255, 255],
	    darkblue: [0, 0, 139],
	    darkcyan: [0, 139, 139],
	    darkgoldenrod: [184, 134, 11],
	    darkgray: [169, 169, 169],
	    darkgreen: [0, 100, 0],
	    darkgrey: [169, 169, 169],
	    darkkhaki: [189, 183, 107],
	    darkmagenta: [139, 0, 139],
	    darkolivegreen: [85, 107, 47],
	    darkorange: [255, 140, 0],
	    darkorchid: [153, 50, 204],
	    darkred: [139, 0, 0],
	    darksalmon: [233, 150, 122],
	    darkseagreen: [143, 188, 143],
	    darkslateblue: [72, 61, 139],
	    darkslategray: [47, 79, 79],
	    darkslategrey: [47, 79, 79],
	    darkturquoise: [0, 206, 209],
	    darkviolet: [148, 0, 211],
	    deeppink: [255, 20, 147],
	    deepskyblue: [0, 191, 255],
	    dimgray: [105, 105, 105],
	    dimgrey: [105, 105, 105],
	    dodgerblue: [30, 144, 255],
	    firebrick: [178, 34, 34],
	    floralwhite: [255, 250, 240],
	    forestgreen: [34, 139, 34],
	    fuchsia: [255, 0, 255],
	    gainsboro: [220, 220, 220],
	    ghostwhite: [248, 248, 255],
	    gold: [255, 215, 0],
	    goldenrod: [218, 165, 32],
	    gray: [128, 128, 128],
	    grey: [128, 128, 128],
	    green: [0, 128, 0],
	    greenyellow: [173, 255, 47],
	    honeydew: [240, 255, 240],
	    hotpink: [255, 105, 180],
	    indianred: [205, 92, 92],
	    indigo: [75, 0, 130],
	    ivory: [255, 255, 240],
	    khaki: [240, 230, 140],
	    lavender: [230, 230, 250],
	    lavenderblush: [255, 240, 245],
	    lawngreen: [124, 252, 0],
	    lemonchiffon: [255, 250, 205],
	    lightblue: [173, 216, 230],
	    lightcoral: [240, 128, 128],
	    lightcyan: [224, 255, 255],
	    lightgoldenrodyellow: [250, 250, 210],
	    lightgray: [211, 211, 211],
	    lightgreen: [144, 238, 144],
	    lightgrey: [211, 211, 211],
	    lightpink: [255, 182, 193],
	    lightsalmon: [255, 160, 122],
	    lightseagreen: [32, 178, 170],
	    lightskyblue: [135, 206, 250],
	    lightslategray: [119, 136, 153],
	    lightslategrey: [119, 136, 153],
	    lightsteelblue: [176, 196, 222],
	    lightyellow: [255, 255, 224],
	    lime: [0, 255, 0],
	    limegreen: [50, 205, 50],
	    linen: [250, 240, 230],
	    magenta: [255, 0, 255],
	    maroon: [128, 0, 0],
	    mediumaquamarine: [102, 205, 170],
	    mediumblue: [0, 0, 205],
	    mediumorchid: [186, 85, 211],
	    mediumpurple: [147, 112, 219],
	    mediumseagreen: [60, 179, 113],
	    mediumslateblue: [123, 104, 238],
	    mediumspringgreen: [0, 250, 154],
	    mediumturquoise: [72, 209, 204],
	    mediumvioletred: [199, 21, 133],
	    midnightblue: [25, 25, 112],
	    mintcream: [245, 255, 250],
	    mistyrose: [255, 228, 225],
	    moccasin: [255, 228, 181],
	    navajowhite: [255, 222, 173],
	    navy: [0, 0, 128],
	    oldlace: [253, 245, 230],
	    olive: [128, 128, 0],
	    olivedrab: [107, 142, 35],
	    orange: [255, 165, 0],
	    orangered: [255, 69, 0],
	    orchid: [218, 112, 214],
	    palegoldenrod: [238, 232, 170],
	    palegreen: [152, 251, 152],
	    paleturquoise: [175, 238, 238],
	    palevioletred: [219, 112, 147],
	    papayawhip: [255, 239, 213],
	    peachpuff: [255, 218, 185],
	    peru: [205, 133, 63],
	    pink: [255, 192, 203],
	    plum: [221, 160, 221],
	    powderblue: [176, 224, 230],
	    purple: [128, 0, 128],
	    red: [255, 0, 0],
	    rosybrown: [188, 143, 143],
	    royalblue: [65, 105, 225],
	    saddlebrown: [139, 69, 19],
	    salmon: [250, 128, 114],
	    sandybrown: [244, 164, 96],
	    seagreen: [46, 139, 87],
	    seashell: [255, 245, 238],
	    sienna: [160, 82, 45],
	    silver: [192, 192, 192],
	    skyblue: [135, 206, 235],
	    slateblue: [106, 90, 205],
	    slategray: [112, 128, 144],
	    slategrey: [112, 128, 144],
	    snow: [255, 250, 250],
	    springgreen: [0, 255, 127],
	    steelblue: [70, 130, 180],
	    tan: [210, 180, 140],
	    teal: [0, 128, 128],
	    thistle: [216, 191, 216],
	    tomato: [255, 99, 71],
	    turquoise: [64, 224, 208],
	    violet: [238, 130, 238],
	    wheat: [245, 222, 179],
	    white: [255, 255, 255],
	    whitesmoke: [245, 245, 245],
	    yellow: [255, 255, 0],
	    yellowgreen: [154, 205, 50]
	  };

	}).call(this);


/***/ }),
/* 78 */
/***/ (function(module, exports) {

	// Generated by CoffeeScript 1.12.6
	(function() {
	  var PDFGradient, PDFLinearGradient, PDFRadialGradient,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;

	  PDFGradient = (function() {
	    function PDFGradient(doc) {
	      this.doc = doc;
	      this.stops = [];
	      this.embedded = false;
	      this.transform = [1, 0, 0, 1, 0, 0];
	      this._colorSpace = 'DeviceRGB';
	    }

	    PDFGradient.prototype.stop = function(pos, color, opacity) {
	      if (opacity == null) {
	        opacity = 1;
	      }
	      opacity = Math.max(0, Math.min(1, opacity));
	      this.stops.push([pos, this.doc._normalizeColor(color), opacity]);
	      return this;
	    };

	    PDFGradient.prototype.setTransform = function(m11, m12, m21, m22, dx, dy) {
	      this.transform = [m11, m12, m21, m22, dx, dy];
	      return this;
	    };

	    PDFGradient.prototype.embed = function(m) {
	      var bounds, encode, fn, form, grad, gstate, i, j, k, last, len, opacityPattern, pageBBox, pattern, ref, ref1, shader, stop, stops, v;
	      if (this.stops.length === 0) {
	        return;
	      }
	      this.embedded = true;
	      this.matrix = m;
	      last = this.stops[this.stops.length - 1];
	      if (last[0] < 1) {
	        this.stops.push([1, last[1], last[2]]);
	      }
	      bounds = [];
	      encode = [];
	      stops = [];
	      for (i = j = 0, ref = this.stops.length - 1; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        encode.push(0, 1);
	        if (i + 2 !== this.stops.length) {
	          bounds.push(this.stops[i + 1][0]);
	        }
	        fn = this.doc.ref({
	          FunctionType: 2,
	          Domain: [0, 1],
	          C0: this.stops[i + 0][1],
	          C1: this.stops[i + 1][1],
	          N: 1
	        });
	        stops.push(fn);
	        fn.end();
	      }
	      if (stops.length === 1) {
	        fn = stops[0];
	      } else {
	        fn = this.doc.ref({
	          FunctionType: 3,
	          Domain: [0, 1],
	          Functions: stops,
	          Bounds: bounds,
	          Encode: encode
	        });
	        fn.end();
	      }
	      this.id = 'Sh' + (++this.doc._gradCount);
	      shader = this.shader(fn);
	      shader.end();
	      pattern = this.doc.ref({
	        Type: 'Pattern',
	        PatternType: 2,
	        Shading: shader,
	        Matrix: (function() {
	          var k, len, ref1, results;
	          ref1 = this.matrix;
	          results = [];
	          for (k = 0, len = ref1.length; k < len; k++) {
	            v = ref1[k];
	            results.push(+v.toFixed(5));
	          }
	          return results;
	        }).call(this)
	      });
	      pattern.end();
	      if (this.stops.some(function(stop) {
	        return stop[2] < 1;
	      })) {
	        grad = this.opacityGradient();
	        grad._colorSpace = 'DeviceGray';
	        ref1 = this.stops;
	        for (k = 0, len = ref1.length; k < len; k++) {
	          stop = ref1[k];
	          grad.stop(stop[0], [stop[2]]);
	        }
	        grad = grad.embed(this.matrix);
	        pageBBox = [0, 0, this.doc.page.width, this.doc.page.height];
	        form = this.doc.ref({
	          Type: 'XObject',
	          Subtype: 'Form',
	          FormType: 1,
	          BBox: pageBBox,
	          Group: {
	            Type: 'Group',
	            S: 'Transparency',
	            CS: 'DeviceGray'
	          },
	          Resources: {
	            ProcSet: ['PDF', 'Text', 'ImageB', 'ImageC', 'ImageI'],
	            Pattern: {
	              Sh1: grad
	            }
	          }
	        });
	        form.write("/Pattern cs /Sh1 scn");
	        form.end((pageBBox.join(" ")) + " re f");
	        gstate = this.doc.ref({
	          Type: 'ExtGState',
	          SMask: {
	            Type: 'Mask',
	            S: 'Luminosity',
	            G: form
	          }
	        });
	        gstate.end();
	        opacityPattern = this.doc.ref({
	          Type: 'Pattern',
	          PatternType: 1,
	          PaintType: 1,
	          TilingType: 2,
	          BBox: pageBBox,
	          XStep: pageBBox[2],
	          YStep: pageBBox[3],
	          Resources: {
	            ProcSet: ['PDF', 'Text', 'ImageB', 'ImageC', 'ImageI'],
	            Pattern: {
	              Sh1: pattern
	            },
	            ExtGState: {
	              Gs1: gstate
	            }
	          }
	        });
	        opacityPattern.write("/Gs1 gs /Pattern cs /Sh1 scn");
	        opacityPattern.end((pageBBox.join(" ")) + " re f");
	        this.doc.page.patterns[this.id] = opacityPattern;
	      } else {
	        this.doc.page.patterns[this.id] = pattern;
	      }
	      return pattern;
	    };

	    PDFGradient.prototype.apply = function(op) {
	      var dx, dy, m, m0, m1, m11, m12, m2, m21, m22, m3, m4, m5, ref, ref1;
	      ref = this.doc._ctm.slice(), m0 = ref[0], m1 = ref[1], m2 = ref[2], m3 = ref[3], m4 = ref[4], m5 = ref[5];
	      ref1 = this.transform, m11 = ref1[0], m12 = ref1[1], m21 = ref1[2], m22 = ref1[3], dx = ref1[4], dy = ref1[5];
	      m = [m0 * m11 + m2 * m12, m1 * m11 + m3 * m12, m0 * m21 + m2 * m22, m1 * m21 + m3 * m22, m0 * dx + m2 * dy + m4, m1 * dx + m3 * dy + m5];
	      if (!(this.embedded && m.join(" ") === this.matrix.join(" "))) {
	        this.embed(m);
	      }
	      return this.doc.addContent("/" + this.id + " " + op);
	    };

	    return PDFGradient;

	  })();

	  PDFLinearGradient = (function(superClass) {
	    extend(PDFLinearGradient, superClass);

	    function PDFLinearGradient(doc, x1, y1, x2, y2) {
	      this.doc = doc;
	      this.x1 = x1;
	      this.y1 = y1;
	      this.x2 = x2;
	      this.y2 = y2;
	      PDFLinearGradient.__super__.constructor.apply(this, arguments);
	    }

	    PDFLinearGradient.prototype.shader = function(fn) {
	      return this.doc.ref({
	        ShadingType: 2,
	        ColorSpace: this._colorSpace,
	        Coords: [this.x1, this.y1, this.x2, this.y2],
	        Function: fn,
	        Extend: [true, true]
	      });
	    };

	    PDFLinearGradient.prototype.opacityGradient = function() {
	      return new PDFLinearGradient(this.doc, this.x1, this.y1, this.x2, this.y2);
	    };

	    return PDFLinearGradient;

	  })(PDFGradient);

	  PDFRadialGradient = (function(superClass) {
	    extend(PDFRadialGradient, superClass);

	    function PDFRadialGradient(doc, x1, y1, r1, x2, y2, r2) {
	      this.doc = doc;
	      this.x1 = x1;
	      this.y1 = y1;
	      this.r1 = r1;
	      this.x2 = x2;
	      this.y2 = y2;
	      this.r2 = r2;
	      PDFRadialGradient.__super__.constructor.apply(this, arguments);
	    }

	    PDFRadialGradient.prototype.shader = function(fn) {
	      return this.doc.ref({
	        ShadingType: 3,
	        ColorSpace: this._colorSpace,
	        Coords: [this.x1, this.y1, this.r1, this.x2, this.y2, this.r2],
	        Function: fn,
	        Extend: [true, true]
	      });
	    };

	    PDFRadialGradient.prototype.opacityGradient = function() {
	      return new PDFRadialGradient(this.doc, this.x1, this.y1, this.r1, this.x2, this.y2, this.r2);
	    };

	    return PDFRadialGradient;

	  })(PDFGradient);

	  module.exports = {
	    PDFGradient: PDFGradient,
	    PDFLinearGradient: PDFLinearGradient,
	    PDFRadialGradient: PDFRadialGradient
	  };

	}).call(this);


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.12.6
	(function() {
	  var KAPPA, SVGPath, number,
	    slice = [].slice;

	  SVGPath = __webpack_require__(80);

	  number = __webpack_require__(57).number;

	  KAPPA = 4.0 * ((Math.sqrt(2) - 1.0) / 3.0);

	  module.exports = {
	    initVector: function() {
	      this._ctm = [1, 0, 0, 1, 0, 0];
	      return this._ctmStack = [];
	    },
	    save: function() {
	      this._ctmStack.push(this._ctm.slice());
	      return this.addContent('q');
	    },
	    restore: function() {
	      this._ctm = this._ctmStack.pop() || [1, 0, 0, 1, 0, 0];
	      return this.addContent('Q');
	    },
	    closePath: function() {
	      return this.addContent('h');
	    },
	    lineWidth: function(w) {
	      return this.addContent((number(w)) + " w");
	    },
	    _CAP_STYLES: {
	      BUTT: 0,
	      ROUND: 1,
	      SQUARE: 2
	    },
	    lineCap: function(c) {
	      if (typeof c === 'string') {
	        c = this._CAP_STYLES[c.toUpperCase()];
	      }
	      return this.addContent(c + " J");
	    },
	    _JOIN_STYLES: {
	      MITER: 0,
	      ROUND: 1,
	      BEVEL: 2
	    },
	    lineJoin: function(j) {
	      if (typeof j === 'string') {
	        j = this._JOIN_STYLES[j.toUpperCase()];
	      }
	      return this.addContent(j + " j");
	    },
	    miterLimit: function(m) {
	      return this.addContent((number(m)) + " M");
	    },
	    dash: function(length, options) {
	      var phase, ref, space, v;
	      if (options == null) {
	        options = {};
	      }
	      if (length == null) {
	        return this;
	      }
	      if (Array.isArray(length)) {
	        length = ((function() {
	          var i, len, results;
	          results = [];
	          for (i = 0, len = length.length; i < len; i++) {
	            v = length[i];
	            results.push(number(v));
	          }
	          return results;
	        })()).join(' ');
	        phase = options.phase || 0;
	        return this.addContent("[" + length + "] " + (number(phase)) + " d");
	      } else {
	        space = (ref = options.space) != null ? ref : length;
	        phase = options.phase || 0;
	        return this.addContent("[" + (number(length)) + " " + (number(space)) + "] " + (number(phase)) + " d");
	      }
	    },
	    undash: function() {
	      return this.addContent("[] 0 d");
	    },
	    moveTo: function(x, y) {
	      return this.addContent((number(x)) + " " + (number(y)) + " m");
	    },
	    lineTo: function(x, y) {
	      return this.addContent((number(x)) + " " + (number(y)) + " l");
	    },
	    bezierCurveTo: function(cp1x, cp1y, cp2x, cp2y, x, y) {
	      return this.addContent((number(cp1x)) + " " + (number(cp1y)) + " " + (number(cp2x)) + " " + (number(cp2y)) + " " + (number(x)) + " " + (number(y)) + " c");
	    },
	    quadraticCurveTo: function(cpx, cpy, x, y) {
	      return this.addContent((number(cpx)) + " " + (number(cpy)) + " " + (number(x)) + " " + (number(y)) + " v");
	    },
	    rect: function(x, y, w, h) {
	      return this.addContent((number(x)) + " " + (number(y)) + " " + (number(w)) + " " + (number(h)) + " re");
	    },
	    roundedRect: function(x, y, w, h, r) {
	      var c;
	      if (r == null) {
	        r = 0;
	      }
	      r = Math.min(r, 0.5 * w, 0.5 * h);
	      c = r * (1.0 - KAPPA);
	      this.moveTo(x + r, y);
	      this.lineTo(x + w - r, y);
	      this.bezierCurveTo(x + w - c, y, x + w, y + c, x + w, y + r);
	      this.lineTo(x + w, y + h - r);
	      this.bezierCurveTo(x + w, y + h - c, x + w - c, y + h, x + w - r, y + h);
	      this.lineTo(x + r, y + h);
	      this.bezierCurveTo(x + c, y + h, x, y + h - c, x, y + h - r);
	      this.lineTo(x, y + r);
	      this.bezierCurveTo(x, y + c, x + c, y, x + r, y);
	      return this.closePath();
	    },
	    ellipse: function(x, y, r1, r2) {
	      var ox, oy, xe, xm, ye, ym;
	      if (r2 == null) {
	        r2 = r1;
	      }
	      x -= r1;
	      y -= r2;
	      ox = r1 * KAPPA;
	      oy = r2 * KAPPA;
	      xe = x + r1 * 2;
	      ye = y + r2 * 2;
	      xm = x + r1;
	      ym = y + r2;
	      this.moveTo(x, ym);
	      this.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
	      this.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
	      this.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
	      this.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
	      return this.closePath();
	    },
	    circle: function(x, y, radius) {
	      return this.ellipse(x, y, radius);
	    },
	    arc: function(x, y, radius, startAngle, endAngle, anticlockwise) {
	      var HALF_PI, TWO_PI, ax, ay, cp1x, cp1y, cp2x, cp2y, curAng, deltaAng, deltaCx, deltaCy, dir, handleLen, i, numSegs, ref, segAng, segIdx;
	      if (anticlockwise == null) {
	        anticlockwise = false;
	      }
	      TWO_PI = 2.0 * Math.PI;
	      HALF_PI = 0.5 * Math.PI;
	      deltaAng = endAngle - startAngle;
	      if (Math.abs(deltaAng) > TWO_PI) {
	        deltaAng = TWO_PI;
	      } else if (deltaAng !== 0 && anticlockwise !== (deltaAng < 0)) {
	        dir = anticlockwise ? -1 : 1;
	        deltaAng = dir * TWO_PI + deltaAng;
	      }
	      numSegs = Math.ceil(Math.abs(deltaAng) / HALF_PI);
	      segAng = deltaAng / numSegs;
	      handleLen = (segAng / HALF_PI) * KAPPA * radius;
	      curAng = startAngle;
	      deltaCx = -Math.sin(curAng) * handleLen;
	      deltaCy = Math.cos(curAng) * handleLen;
	      ax = x + Math.cos(curAng) * radius;
	      ay = y + Math.sin(curAng) * radius;
	      this.moveTo(ax, ay);
	      for (segIdx = i = 0, ref = numSegs; 0 <= ref ? i < ref : i > ref; segIdx = 0 <= ref ? ++i : --i) {
	        cp1x = ax + deltaCx;
	        cp1y = ay + deltaCy;
	        curAng += segAng;
	        ax = x + Math.cos(curAng) * radius;
	        ay = y + Math.sin(curAng) * radius;
	        deltaCx = -Math.sin(curAng) * handleLen;
	        deltaCy = Math.cos(curAng) * handleLen;
	        cp2x = ax - deltaCx;
	        cp2y = ay - deltaCy;
	        this.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, ax, ay);
	      }
	      return this;
	    },
	    polygon: function() {
	      var i, len, point, points;
	      points = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	      this.moveTo.apply(this, points.shift());
	      for (i = 0, len = points.length; i < len; i++) {
	        point = points[i];
	        this.lineTo.apply(this, point);
	      }
	      return this.closePath();
	    },
	    path: function(path) {
	      SVGPath.apply(this, path);
	      return this;
	    },
	    _windingRule: function(rule) {
	      if (/even-?odd/.test(rule)) {
	        return '*';
	      }
	      return '';
	    },
	    fill: function(color, rule) {
	      if (/(even-?odd)|(non-?zero)/.test(color)) {
	        rule = color;
	        color = null;
	      }
	      if (color) {
	        this.fillColor(color);
	      }
	      return this.addContent('f' + this._windingRule(rule));
	    },
	    stroke: function(color) {
	      if (color) {
	        this.strokeColor(color);
	      }
	      return this.addContent('S');
	    },
	    fillAndStroke: function(fillColor, strokeColor, rule) {
	      var isFillRule;
	      if (strokeColor == null) {
	        strokeColor = fillColor;
	      }
	      isFillRule = /(even-?odd)|(non-?zero)/;
	      if (isFillRule.test(fillColor)) {
	        rule = fillColor;
	        fillColor = null;
	      }
	      if (isFillRule.test(strokeColor)) {
	        rule = strokeColor;
	        strokeColor = fillColor;
	      }
	      if (fillColor) {
	        this.fillColor(fillColor);
	        this.strokeColor(strokeColor);
	      }
	      return this.addContent('B' + this._windingRule(rule));
	    },
	    clip: function(rule) {
	      return this.addContent('W' + this._windingRule(rule) + ' n');
	    },
	    transform: function(m11, m12, m21, m22, dx, dy) {
	      var m, m0, m1, m2, m3, m4, m5, v, values;
	      m = this._ctm;
	      m0 = m[0], m1 = m[1], m2 = m[2], m3 = m[3], m4 = m[4], m5 = m[5];
	      m[0] = m0 * m11 + m2 * m12;
	      m[1] = m1 * m11 + m3 * m12;
	      m[2] = m0 * m21 + m2 * m22;
	      m[3] = m1 * m21 + m3 * m22;
	      m[4] = m0 * dx + m2 * dy + m4;
	      m[5] = m1 * dx + m3 * dy + m5;
	      values = ((function() {
	        var i, len, ref, results;
	        ref = [m11, m12, m21, m22, dx, dy];
	        results = [];
	        for (i = 0, len = ref.length; i < len; i++) {
	          v = ref[i];
	          results.push(number(v));
	        }
	        return results;
	      })()).join(' ');
	      return this.addContent(values + " cm");
	    },
	    translate: function(x, y) {
	      return this.transform(1, 0, 0, 1, x, y);
	    },
	    rotate: function(angle, options) {
	      var cos, rad, ref, sin, x, x1, y, y1;
	      if (options == null) {
	        options = {};
	      }
	      rad = angle * Math.PI / 180;
	      cos = Math.cos(rad);
	      sin = Math.sin(rad);
	      x = y = 0;
	      if (options.origin != null) {
	        ref = options.origin, x = ref[0], y = ref[1];
	        x1 = x * cos - y * sin;
	        y1 = x * sin + y * cos;
	        x -= x1;
	        y -= y1;
	      }
	      return this.transform(cos, sin, -sin, cos, x, y);
	    },
	    scale: function(xFactor, yFactor, options) {
	      var ref, x, y;
	      if (yFactor == null) {
	        yFactor = xFactor;
	      }
	      if (options == null) {
	        options = {};
	      }
	      if (typeof yFactor === "object") {
	        options = yFactor;
	        yFactor = xFactor;
	      }
	      x = y = 0;
	      if (options.origin != null) {
	        ref = options.origin, x = ref[0], y = ref[1];
	        x -= xFactor * x;
	        y -= yFactor * y;
	      }
	      return this.transform(xFactor, 0, 0, yFactor, x, y);
	    }
	  };

	}).call(this);


/***/ }),
/* 80 */
/***/ (function(module, exports) {

	// Generated by CoffeeScript 1.12.6
	(function() {
	  var SVGPath;

	  SVGPath = (function() {
	    var apply, arcToSegments, cx, cy, parameters, parse, px, py, runners, segmentToBezier, solveArc, sx, sy;

	    function SVGPath() {}

	    SVGPath.apply = function(doc, path) {
	      var commands;
	      commands = parse(path);
	      return apply(commands, doc);
	    };

	    parameters = {
	      A: 7,
	      a: 7,
	      C: 6,
	      c: 6,
	      H: 1,
	      h: 1,
	      L: 2,
	      l: 2,
	      M: 2,
	      m: 2,
	      Q: 4,
	      q: 4,
	      S: 4,
	      s: 4,
	      T: 2,
	      t: 2,
	      V: 1,
	      v: 1,
	      Z: 0,
	      z: 0
	    };

	    parse = function(path) {
	      var args, c, cmd, curArg, foundDecimal, j, len, params, ret;
	      ret = [];
	      args = [];
	      curArg = "";
	      foundDecimal = false;
	      params = 0;
	      for (j = 0, len = path.length; j < len; j++) {
	        c = path[j];
	        if (parameters[c] != null) {
	          params = parameters[c];
	          if (cmd) {
	            if (curArg.length > 0) {
	              args[args.length] = +curArg;
	            }
	            ret[ret.length] = {
	              cmd: cmd,
	              args: args
	            };
	            args = [];
	            curArg = "";
	            foundDecimal = false;
	          }
	          cmd = c;
	        } else if ((c === " " || c === ",") || (c === "-" && curArg.length > 0 && curArg[curArg.length - 1] !== 'e') || (c === "." && foundDecimal)) {
	          if (curArg.length === 0) {
	            continue;
	          }
	          if (args.length === params) {
	            ret[ret.length] = {
	              cmd: cmd,
	              args: args
	            };
	            args = [+curArg];
	            if (cmd === "M") {
	              cmd = "L";
	            }
	            if (cmd === "m") {
	              cmd = "l";
	            }
	          } else {
	            args[args.length] = +curArg;
	          }
	          foundDecimal = c === ".";
	          curArg = c === '-' || c === '.' ? c : '';
	        } else {
	          curArg += c;
	          if (c === '.') {
	            foundDecimal = true;
	          }
	        }
	      }
	      if (curArg.length > 0) {
	        if (args.length === params) {
	          ret[ret.length] = {
	            cmd: cmd,
	            args: args
	          };
	          args = [+curArg];
	          if (cmd === "M") {
	            cmd = "L";
	          }
	          if (cmd === "m") {
	            cmd = "l";
	          }
	        } else {
	          args[args.length] = +curArg;
	        }
	      }
	      ret[ret.length] = {
	        cmd: cmd,
	        args: args
	      };
	      return ret;
	    };

	    cx = cy = px = py = sx = sy = 0;

	    apply = function(commands, doc) {
	      var c, i, j, len, name;
	      cx = cy = px = py = sx = sy = 0;
	      for (i = j = 0, len = commands.length; j < len; i = ++j) {
	        c = commands[i];
	        if (typeof runners[name = c.cmd] === "function") {
	          runners[name](doc, c.args);
	        }
	      }
	      return cx = cy = px = py = 0;
	    };

	    runners = {
	      M: function(doc, a) {
	        cx = a[0];
	        cy = a[1];
	        px = py = null;
	        sx = cx;
	        sy = cy;
	        return doc.moveTo(cx, cy);
	      },
	      m: function(doc, a) {
	        cx += a[0];
	        cy += a[1];
	        px = py = null;
	        sx = cx;
	        sy = cy;
	        return doc.moveTo(cx, cy);
	      },
	      C: function(doc, a) {
	        cx = a[4];
	        cy = a[5];
	        px = a[2];
	        py = a[3];
	        return doc.bezierCurveTo.apply(doc, a);
	      },
	      c: function(doc, a) {
	        doc.bezierCurveTo(a[0] + cx, a[1] + cy, a[2] + cx, a[3] + cy, a[4] + cx, a[5] + cy);
	        px = cx + a[2];
	        py = cy + a[3];
	        cx += a[4];
	        return cy += a[5];
	      },
	      S: function(doc, a) {
	        if (px === null) {
	          px = cx;
	          py = cy;
	        }
	        doc.bezierCurveTo(cx - (px - cx), cy - (py - cy), a[0], a[1], a[2], a[3]);
	        px = a[0];
	        py = a[1];
	        cx = a[2];
	        return cy = a[3];
	      },
	      s: function(doc, a) {
	        if (px === null) {
	          px = cx;
	          py = cy;
	        }
	        doc.bezierCurveTo(cx - (px - cx), cy - (py - cy), cx + a[0], cy + a[1], cx + a[2], cy + a[3]);
	        px = cx + a[0];
	        py = cy + a[1];
	        cx += a[2];
	        return cy += a[3];
	      },
	      Q: function(doc, a) {
	        px = a[0];
	        py = a[1];
	        cx = a[2];
	        cy = a[3];
	        return doc.quadraticCurveTo(a[0], a[1], cx, cy);
	      },
	      q: function(doc, a) {
	        doc.quadraticCurveTo(a[0] + cx, a[1] + cy, a[2] + cx, a[3] + cy);
	        px = cx + a[0];
	        py = cy + a[1];
	        cx += a[2];
	        return cy += a[3];
	      },
	      T: function(doc, a) {
	        if (px === null) {
	          px = cx;
	          py = cy;
	        } else {
	          px = cx - (px - cx);
	          py = cy - (py - cy);
	        }
	        doc.quadraticCurveTo(px, py, a[0], a[1]);
	        px = cx - (px - cx);
	        py = cy - (py - cy);
	        cx = a[0];
	        return cy = a[1];
	      },
	      t: function(doc, a) {
	        if (px === null) {
	          px = cx;
	          py = cy;
	        } else {
	          px = cx - (px - cx);
	          py = cy - (py - cy);
	        }
	        doc.quadraticCurveTo(px, py, cx + a[0], cy + a[1]);
	        cx += a[0];
	        return cy += a[1];
	      },
	      A: function(doc, a) {
	        solveArc(doc, cx, cy, a);
	        cx = a[5];
	        return cy = a[6];
	      },
	      a: function(doc, a) {
	        a[5] += cx;
	        a[6] += cy;
	        solveArc(doc, cx, cy, a);
	        cx = a[5];
	        return cy = a[6];
	      },
	      L: function(doc, a) {
	        cx = a[0];
	        cy = a[1];
	        px = py = null;
	        return doc.lineTo(cx, cy);
	      },
	      l: function(doc, a) {
	        cx += a[0];
	        cy += a[1];
	        px = py = null;
	        return doc.lineTo(cx, cy);
	      },
	      H: function(doc, a) {
	        cx = a[0];
	        px = py = null;
	        return doc.lineTo(cx, cy);
	      },
	      h: function(doc, a) {
	        cx += a[0];
	        px = py = null;
	        return doc.lineTo(cx, cy);
	      },
	      V: function(doc, a) {
	        cy = a[0];
	        px = py = null;
	        return doc.lineTo(cx, cy);
	      },
	      v: function(doc, a) {
	        cy += a[0];
	        px = py = null;
	        return doc.lineTo(cx, cy);
	      },
	      Z: function(doc) {
	        doc.closePath();
	        cx = sx;
	        return cy = sy;
	      },
	      z: function(doc) {
	        doc.closePath();
	        cx = sx;
	        return cy = sy;
	      }
	    };

	    solveArc = function(doc, x, y, coords) {
	      var bez, ex, ey, j, large, len, results, rot, rx, ry, seg, segs, sweep;
	      rx = coords[0], ry = coords[1], rot = coords[2], large = coords[3], sweep = coords[4], ex = coords[5], ey = coords[6];
	      segs = arcToSegments(ex, ey, rx, ry, large, sweep, rot, x, y);
	      results = [];
	      for (j = 0, len = segs.length; j < len; j++) {
	        seg = segs[j];
	        bez = segmentToBezier.apply(null, seg);
	        results.push(doc.bezierCurveTo.apply(doc, bez));
	      }
	      return results;
	    };

	    arcToSegments = function(x, y, rx, ry, large, sweep, rotateX, ox, oy) {
	      var a00, a01, a10, a11, cos_th, d, i, j, pl, ref, result, segments, sfactor, sfactor_sq, sin_th, th, th0, th1, th2, th3, th_arc, x0, x1, xc, y0, y1, yc;
	      th = rotateX * (Math.PI / 180);
	      sin_th = Math.sin(th);
	      cos_th = Math.cos(th);
	      rx = Math.abs(rx);
	      ry = Math.abs(ry);
	      px = cos_th * (ox - x) * 0.5 + sin_th * (oy - y) * 0.5;
	      py = cos_th * (oy - y) * 0.5 - sin_th * (ox - x) * 0.5;
	      pl = (px * px) / (rx * rx) + (py * py) / (ry * ry);
	      if (pl > 1) {
	        pl = Math.sqrt(pl);
	        rx *= pl;
	        ry *= pl;
	      }
	      a00 = cos_th / rx;
	      a01 = sin_th / rx;
	      a10 = (-sin_th) / ry;
	      a11 = cos_th / ry;
	      x0 = a00 * ox + a01 * oy;
	      y0 = a10 * ox + a11 * oy;
	      x1 = a00 * x + a01 * y;
	      y1 = a10 * x + a11 * y;
	      d = (x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0);
	      sfactor_sq = 1 / d - 0.25;
	      if (sfactor_sq < 0) {
	        sfactor_sq = 0;
	      }
	      sfactor = Math.sqrt(sfactor_sq);
	      if (sweep === large) {
	        sfactor = -sfactor;
	      }
	      xc = 0.5 * (x0 + x1) - sfactor * (y1 - y0);
	      yc = 0.5 * (y0 + y1) + sfactor * (x1 - x0);
	      th0 = Math.atan2(y0 - yc, x0 - xc);
	      th1 = Math.atan2(y1 - yc, x1 - xc);
	      th_arc = th1 - th0;
	      if (th_arc < 0 && sweep === 1) {
	        th_arc += 2 * Math.PI;
	      } else if (th_arc > 0 && sweep === 0) {
	        th_arc -= 2 * Math.PI;
	      }
	      segments = Math.ceil(Math.abs(th_arc / (Math.PI * 0.5 + 0.001)));
	      result = [];
	      for (i = j = 0, ref = segments; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        th2 = th0 + i * th_arc / segments;
	        th3 = th0 + (i + 1) * th_arc / segments;
	        result[i] = [xc, yc, th2, th3, rx, ry, sin_th, cos_th];
	      }
	      return result;
	    };

	    segmentToBezier = function(cx, cy, th0, th1, rx, ry, sin_th, cos_th) {
	      var a00, a01, a10, a11, t, th_half, x1, x2, x3, y1, y2, y3;
	      a00 = cos_th * rx;
	      a01 = -sin_th * ry;
	      a10 = sin_th * rx;
	      a11 = cos_th * ry;
	      th_half = 0.5 * (th1 - th0);
	      t = (8 / 3) * Math.sin(th_half * 0.5) * Math.sin(th_half * 0.5) / Math.sin(th_half);
	      x1 = cx + Math.cos(th0) - t * Math.sin(th0);
	      y1 = cy + Math.sin(th0) + t * Math.cos(th0);
	      x3 = cx + Math.cos(th1);
	      y3 = cy + Math.sin(th1);
	      x2 = x3 + t * Math.sin(th1);
	      y2 = y3 - t * Math.cos(th1);
	      return [a00 * x1 + a01 * y1, a10 * x1 + a11 * y1, a00 * x2 + a01 * y2, a10 * x2 + a11 * y2, a00 * x3 + a01 * y3, a10 * x3 + a11 * y3];
	    };

	    return SVGPath;

	  })();

	  module.exports = SVGPath;

	}).call(this);


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.12.6
	(function() {
	  var PDFFont;

	  PDFFont = __webpack_require__(82);

	  module.exports = {
	    initFonts: function() {
	      this._fontFamilies = {};
	      this._fontCount = 0;
	      this._fontSize = 12;
	      this._font = null;
	      this._registeredFonts = {};
	      
	    },
	    font: function(src, family, size) {
	      var cacheKey, font, id, ref;
	      if (typeof family === 'number') {
	        size = family;
	        family = null;
	      }
	      if (typeof src === 'string' && this._registeredFonts[src]) {
	        cacheKey = src;
	        ref = this._registeredFonts[src], src = ref.src, family = ref.family;
	      } else {
	        cacheKey = family || src;
	        if (typeof cacheKey !== 'string') {
	          cacheKey = null;
	        }
	      }
	      if (size != null) {
	        this.fontSize(size);
	      }
	      if (font = this._fontFamilies[cacheKey]) {
	        this._font = font;
	        return this;
	      }
	      id = 'F' + (++this._fontCount);
	      this._font = PDFFont.open(this, src, family, id);
	      if (font = this._fontFamilies[this._font.name]) {
	        this._font = font;
	        return this;
	      }
	      if (cacheKey) {
	        this._fontFamilies[cacheKey] = this._font;
	      }
	      if (this._font.name) {
	        this._fontFamilies[this._font.name] = this._font;
	      }
	      return this;
	    },
	    fontSize: function(_fontSize) {
	      this._fontSize = _fontSize;
	      return this;
	    },
	    currentLineHeight: function(includeGap) {
	      if (includeGap == null) {
	        includeGap = false;
	      }
	      return this._font.lineHeight(this._fontSize, includeGap);
	    },
	    registerFont: function(name, src, family) {
	      this._registeredFonts[name] = {
	        src: src,
	        family: family
	      };
	      return this;
	    }
	  };

	}).call(this);


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Generated by CoffeeScript 1.12.6
	(function() {
	  var EmbeddedFont, PDFFont, StandardFont, fontkit;

	  fontkit = __webpack_require__(83);

	  PDFFont = (function() {
	    PDFFont.open = function(document, src, family, id) {
	      var font;
	      if (typeof src === 'string') {
	        if (StandardFont.isStandardFont(src)) {
	          return new StandardFont(document, src, id);
	        }
	        font = fontkit.openSync(src, family);
	      } else if (Buffer.isBuffer(src)) {
	        font = fontkit.create(src, family);
	      } else if (src instanceof Uint8Array) {
	        font = fontkit.create(new Buffer(src), family);
	      } else if (src instanceof ArrayBuffer) {
	        font = fontkit.create(new Buffer(new Uint8Array(src)), family);
	      }
	      if (font == null) {
	        throw new Error('Not a supported font format or standard PDF font.');
	      }
	      return new EmbeddedFont(document, font, id);
	    };

	    function PDFFont() {
	      throw new Error('Cannot construct a PDFFont directly.');
	    }

	    PDFFont.prototype.encode = function(text) {
	      throw new Error('Must be implemented by subclasses');
	    };

	    PDFFont.prototype.widthOfString = function(text) {
	      throw new Error('Must be implemented by subclasses');
	    };

	    PDFFont.prototype.ref = function() {
	      return this.dictionary != null ? this.dictionary : this.dictionary = this.document.ref();
	    };

	    PDFFont.prototype.finalize = function() {
	      if (this.embedded || (this.dictionary == null)) {
	        return;
	      }
	      this.embed();
	      return this.embedded = true;
	    };

	    PDFFont.prototype.embed = function() {
	      throw new Error('Must be implemented by subclasses');
	    };

	    PDFFont.prototype.lineHeight = function(size, includeGap) {
	      var gap;
	      if (includeGap == null) {
	        includeGap = false;
	      }
	      gap = includeGap ? this.lineGap : 0;
	      return (this.ascender + gap - this.descender) / 1000 * size;
	    };

	    return PDFFont;

	  })();

	  module.exports = PDFFont;

	  StandardFont = __webpack_require__(291);

	  EmbeddedFont = __webpack_require__(293);

	}).call(this);

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, process) {'use strict';

	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

	var r = _interopDefault(__webpack_require__(84));
	var _Object$getOwnPropertyDescriptor = _interopDefault(__webpack_require__(122));
	var _getIterator = _interopDefault(__webpack_require__(148));
	var _Object$freeze = _interopDefault(__webpack_require__(181));
	var _Object$keys = _interopDefault(__webpack_require__(185));
	var _typeof = _interopDefault(__webpack_require__(188));
	var _Object$defineProperty = _interopDefault(__webpack_require__(204));
	var _classCallCheck = _interopDefault(__webpack_require__(207));
	var _createClass = _interopDefault(__webpack_require__(208));
	var _Map = _interopDefault(__webpack_require__(209));
	var _possibleConstructorReturn = _interopDefault(__webpack_require__(231));
	var _inherits = _interopDefault(__webpack_require__(232));
	var restructure_src_utils = __webpack_require__(110);
	var _Object$defineProperties = _interopDefault(__webpack_require__(240));
	var isEqual = _interopDefault(__webpack_require__(243));
	var _Object$assign = _interopDefault(__webpack_require__(246));
	var _String$fromCodePoint = _interopDefault(__webpack_require__(250));
	var _Array$from = _interopDefault(__webpack_require__(253));
	var _Set = _interopDefault(__webpack_require__(258));
	var unicode = _interopDefault(__webpack_require__(264));
	var UnicodeTrie = _interopDefault(__webpack_require__(17));
	var StateMachine = _interopDefault(__webpack_require__(266));
	var _Number$EPSILON = _interopDefault(__webpack_require__(275));
	var cloneDeep = _interopDefault(__webpack_require__(278));
	var inflate = _interopDefault(__webpack_require__(18));
	var brotli = _interopDefault(__webpack_require__(279));



	var fontkit = {};
	fontkit.logErrors = false;

	var formats = [];
	fontkit.registerFormat = function (format) {
	  formats.push(format);
	};

	fontkit.openSync = function (filename, postscriptName) {
	  var buffer = __webpack_require__(56).readFileSync(filename);
	  return fontkit.create(buffer, postscriptName);
	};

	fontkit.open = function (filename, postscriptName, callback) {
	  if (typeof postscriptName === 'function') {
	    callback = postscriptName;
	    postscriptName = null;
	  }

	  __webpack_require__(56).readFile(filename, function (err, buffer) {
	    if (err) {
	      return callback(err);
	    }

	    try {
	      var font = fontkit.create(buffer, postscriptName);
	    } catch (e) {
	      return callback(e);
	    }

	    return callback(null, font);
	  });

	  return;
	};

	fontkit.create = function (buffer, postscriptName) {
	  for (var i = 0; i < formats.length; i++) {
	    var format = formats[i];
	    if (format.probe(buffer)) {
	      var font = new format(new r.DecodeStream(buffer));
	      if (postscriptName) {
	        return font.getFont(postscriptName);
	      }

	      return font;
	    }
	  }

	  throw new Error('Unknown font format');
	};

	/**
	 * This decorator caches the results of a getter or method such that
	 * the results are lazily computed once, and then cached.
	 * @private
	 */
	function cache(target, key, descriptor) {
	  if (descriptor.get) {
	    var get = descriptor.get;
	    descriptor.get = function () {
	      var value = get.call(this);
	      _Object$defineProperty(this, key, { value: value });
	      return value;
	    };
	  } else if (typeof descriptor.value === 'function') {
	    var fn = descriptor.value;

	    return {
	      get: function get() {
	        var cache = new _Map();
	        function memoized() {
	          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	          }

	          var key = args.length > 0 ? args[0] : 'value';
	          if (cache.has(key)) {
	            return cache.get(key);
	          }

	          var result = fn.apply(this, args);
	          cache.set(key, result);
	          return result;
	        };

	        _Object$defineProperty(this, key, { value: memoized });
	        return memoized;
	      }
	    };
	  }
	}

	var SubHeader = new r.Struct({
	  firstCode: r.uint16,
	  entryCount: r.uint16,
	  idDelta: r.int16,
	  idRangeOffset: r.uint16
	});

	var CmapGroup = new r.Struct({
	  startCharCode: r.uint32,
	  endCharCode: r.uint32,
	  glyphID: r.uint32
	});

	var UnicodeValueRange = new r.Struct({
	  startUnicodeValue: r.uint24,
	  additionalCount: r.uint8
	});

	var UVSMapping = new r.Struct({
	  unicodeValue: r.uint24,
	  glyphID: r.uint16
	});

	var DefaultUVS = new r.Array(UnicodeValueRange, r.uint32);
	var NonDefaultUVS = new r.Array(UVSMapping, r.uint32);

	var VarSelectorRecord = new r.Struct({
	  varSelector: r.uint24,
	  defaultUVS: new r.Pointer(r.uint32, DefaultUVS, { type: 'parent' }),
	  nonDefaultUVS: new r.Pointer(r.uint32, NonDefaultUVS, { type: 'parent' })
	});

	var CmapSubtable = new r.VersionedStruct(r.uint16, {
	  0: { // Byte encoding
	    length: r.uint16, // Total table length in bytes (set to 262 for format 0)
	    language: r.uint16, // Language code for this encoding subtable, or zero if language-independent
	    codeMap: new r.LazyArray(r.uint8, 256)
	  },

	  2: { // High-byte mapping (CJK)
	    length: r.uint16,
	    language: r.uint16,
	    subHeaderKeys: new r.Array(r.uint16, 256),
	    subHeaderCount: function subHeaderCount(t) {
	      return Math.max.apply(Math, t.subHeaderKeys);
	    },
	    subHeaders: new r.LazyArray(SubHeader, 'subHeaderCount'),
	    glyphIndexArray: new r.LazyArray(r.uint16, 'subHeaderCount')
	  },

	  4: { // Segment mapping to delta values
	    length: r.uint16, // Total table length in bytes
	    language: r.uint16, // Language code
	    segCountX2: r.uint16,
	    segCount: function segCount(t) {
	      return t.segCountX2 >> 1;
	    },
	    searchRange: r.uint16,
	    entrySelector: r.uint16,
	    rangeShift: r.uint16,
	    endCode: new r.LazyArray(r.uint16, 'segCount'),
	    reservedPad: new r.Reserved(r.uint16), // This value should be zero
	    startCode: new r.LazyArray(r.uint16, 'segCount'),
	    idDelta: new r.LazyArray(r.int16, 'segCount'),
	    idRangeOffset: new r.LazyArray(r.uint16, 'segCount'),
	    glyphIndexArray: new r.LazyArray(r.uint16, function (t) {
	      return (t.length - t._currentOffset) / 2;
	    })
	  },

	  6: { // Trimmed table
	    length: r.uint16,
	    language: r.uint16,
	    firstCode: r.uint16,
	    entryCount: r.uint16,
	    glyphIndices: new r.LazyArray(r.uint16, 'entryCount')
	  },

	  8: { // mixed 16-bit and 32-bit coverage
	    reserved: new r.Reserved(r.uint16),
	    length: r.uint32,
	    language: r.uint16,
	    is32: new r.LazyArray(r.uint8, 8192),
	    nGroups: r.uint32,
	    groups: new r.LazyArray(CmapGroup, 'nGroups')
	  },

	  10: { // Trimmed Array
	    reserved: new r.Reserved(r.uint16),
	    length: r.uint32,
	    language: r.uint32,
	    firstCode: r.uint32,
	    entryCount: r.uint32,
	    glyphIndices: new r.LazyArray(r.uint16, 'numChars')
	  },

	  12: { // Segmented coverage
	    reserved: new r.Reserved(r.uint16),
	    length: r.uint32,
	    language: r.uint32,
	    nGroups: r.uint32,
	    groups: new r.LazyArray(CmapGroup, 'nGroups')
	  },

	  13: { // Many-to-one range mappings (same as 12 except for group.startGlyphID)
	    reserved: new r.Reserved(r.uint16),
	    length: r.uint32,
	    language: r.uint32,
	    nGroups: r.uint32,
	    groups: new r.LazyArray(CmapGroup, 'nGroups')
	  },

	  14: { // Unicode Variation Sequences
	    length: r.uint32,
	    numRecords: r.uint32,
	    varSelectors: new r.LazyArray(VarSelectorRecord, 'numRecords')
	  }
	});

	var CmapEntry = new r.Struct({
	  platformID: r.uint16, // Platform identifier
	  encodingID: r.uint16, // Platform-specific encoding identifier
	  table: new r.Pointer(r.uint32, CmapSubtable, { type: 'parent', lazy: true })
	});

	// character to glyph mapping
	var cmap = new r.Struct({
	  version: r.uint16,
	  numSubtables: r.uint16,
	  tables: new r.Array(CmapEntry, 'numSubtables')
	});

	// font header
	var head = new r.Struct({
	  version: r.int32, // 0x00010000 (version 1.0)
	  revision: r.int32, // set by font manufacturer
	  checkSumAdjustment: r.uint32,
	  magicNumber: r.uint32, // set to 0x5F0F3CF5
	  flags: r.uint16,
	  unitsPerEm: r.uint16, // range from 64 to 16384
	  created: new r.Array(r.int32, 2),
	  modified: new r.Array(r.int32, 2),
	  xMin: r.int16, // for all glyph bounding boxes
	  yMin: r.int16, // for all glyph bounding boxes
	  xMax: r.int16, // for all glyph bounding boxes
	  yMax: r.int16, // for all glyph bounding boxes
	  macStyle: new r.Bitfield(r.uint16, ['bold', 'italic', 'underline', 'outline', 'shadow', 'condensed', 'extended']),
	  lowestRecPPEM: r.uint16, // smallest readable size in pixels
	  fontDirectionHint: r.int16,
	  indexToLocFormat: r.int16, // 0 for short offsets, 1 for long
	  glyphDataFormat: r.int16 // 0 for current format
	});

	// horizontal header
	var hhea = new r.Struct({
	  version: r.int32,
	  ascent: r.int16, // Distance from baseline of highest ascender
	  descent: r.int16, // Distance from baseline of lowest descender
	  lineGap: r.int16, // Typographic line gap
	  advanceWidthMax: r.uint16, // Maximum advance width value in 'hmtx' table
	  minLeftSideBearing: r.int16, // Maximum advance width value in 'hmtx' table
	  minRightSideBearing: r.int16, // Minimum right sidebearing value
	  xMaxExtent: r.int16,
	  caretSlopeRise: r.int16, // Used to calculate the slope of the cursor (rise/run); 1 for vertical
	  caretSlopeRun: r.int16, // 0 for vertical
	  caretOffset: r.int16, // Set to 0 for non-slanted fonts
	  reserved: new r.Reserved(r.int16, 4),
	  metricDataFormat: r.int16, // 0 for current format
	  numberOfMetrics: r.uint16 // Number of advance widths in 'hmtx' table
	});

	var HmtxEntry = new r.Struct({
	  advance: r.uint16,
	  bearing: r.int16
	});

	var hmtx = new r.Struct({
	  metrics: new r.LazyArray(HmtxEntry, function (t) {
	    return t.parent.hhea.numberOfMetrics;
	  }),
	  bearings: new r.LazyArray(r.int16, function (t) {
	    return t.parent.maxp.numGlyphs - t.parent.hhea.numberOfMetrics;
	  })
	});

	// maxiumum profile
	var maxp = new r.Struct({
	  version: r.int32,
	  numGlyphs: r.uint16, // The number of glyphs in the font
	  maxPoints: r.uint16, // Maximum points in a non-composite glyph
	  maxContours: r.uint16, // Maximum contours in a non-composite glyph
	  maxComponentPoints: r.uint16, // Maximum points in a composite glyph
	  maxComponentContours: r.uint16, // Maximum contours in a composite glyph
	  maxZones: r.uint16, // 1 if instructions do not use the twilight zone, 2 otherwise
	  maxTwilightPoints: r.uint16, // Maximum points used in Z0
	  maxStorage: r.uint16, // Number of Storage Area locations
	  maxFunctionDefs: r.uint16, // Number of FDEFs
	  maxInstructionDefs: r.uint16, // Number of IDEFs
	  maxStackElements: r.uint16, // Maximum stack depth
	  maxSizeOfInstructions: r.uint16, // Maximum byte count for glyph instructions
	  maxComponentElements: r.uint16, // Maximum number of components referenced at “top level” for any composite glyph
	  maxComponentDepth: r.uint16 // Maximum levels of recursion; 1 for simple components
	});

	/**
	 * Gets an encoding name from platform, encoding, and language ids.
	 * Returned encoding names can be used in iconv-lite to decode text.
	 */
	function getEncoding(platformID, encodingID) {
	  var languageID = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

	  if (platformID === 1 && MAC_LANGUAGE_ENCODINGS[languageID]) {
	    return MAC_LANGUAGE_ENCODINGS[languageID];
	  }

	  return ENCODINGS[platformID][encodingID];
	}

	// Map of platform ids to encoding ids.
	var ENCODINGS = [
	// unicode
	['utf16be', 'utf16be', 'utf16be', 'utf16be', 'utf16be', 'utf16be'],

	// macintosh
	// Mappings available at http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/
	// 0	Roman                 17	Malayalam
	// 1	Japanese	            18	Sinhalese
	// 2	Traditional Chinese	  19	Burmese
	// 3	Korean	              20	Khmer
	// 4	Arabic	              21	Thai
	// 5	Hebrew	              22	Laotian
	// 6	Greek	                23	Georgian
	// 7	Russian	              24	Armenian
	// 8	RSymbol	              25	Simplified Chinese
	// 9	Devanagari	          26	Tibetan
	// 10	Gurmukhi	            27	Mongolian
	// 11	Gujarati	            28	Geez
	// 12	Oriya	                29	Slavic
	// 13	Bengali	              30	Vietnamese
	// 14	Tamil	                31	Sindhi
	// 15	Telugu	              32	(Uninterpreted)
	// 16	Kannada
	['macroman', 'shift-jis', 'big5', 'euc-kr', 'iso-8859-6', 'iso-8859-8', 'macgreek', 'maccyrillic', 'symbol', 'Devanagari', 'Gurmukhi', 'Gujarati', 'Oriya', 'Bengali', 'Tamil', 'Telugu', 'Kannada', 'Malayalam', 'Sinhalese', 'Burmese', 'Khmer', 'macthai', 'Laotian', 'Georgian', 'Armenian', 'gb-2312-80', 'Tibetan', 'Mongolian', 'Geez', 'maccenteuro', 'Vietnamese', 'Sindhi'],

	// ISO (deprecated)
	['ascii'],

	// windows
	// Docs here: http://msdn.microsoft.com/en-us/library/system.text.encoding(v=vs.110).aspx
	['symbol', 'utf16be', 'shift-jis', 'gb18030', 'big5', 'wansung', 'johab', null, null, null, 'utf16be']];

	// Overrides for Mac scripts by language id.
	// See http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/Readme.txt
	var MAC_LANGUAGE_ENCODINGS = {
	  15: 'maciceland',
	  17: 'macturkish',
	  18: 'maccroatian',
	  24: 'maccenteuro',
	  25: 'maccenteuro',
	  26: 'maccenteuro',
	  27: 'maccenteuro',
	  28: 'maccenteuro',
	  30: 'maciceland',
	  37: 'macromania',
	  38: 'maccenteuro',
	  39: 'maccenteuro',
	  40: 'maccenteuro',
	  143: 'macinuit', // Unsupported by iconv-lite
	  146: 'macgaelic' // Unsupported by iconv-lite
	};

	// Map of platform ids to BCP-47 language codes.
	var LANGUAGES = [
	// unicode
	[], { // macintosh
	  0: 'en', 30: 'fo', 60: 'ks', 90: 'rw',
	  1: 'fr', 31: 'fa', 61: 'ku', 91: 'rn',
	  2: 'de', 32: 'ru', 62: 'sd', 92: 'ny',
	  3: 'it', 33: 'zh', 63: 'bo', 93: 'mg',
	  4: 'nl', 34: 'nl-BE', 64: 'ne', 94: 'eo',
	  5: 'sv', 35: 'ga', 65: 'sa', 128: 'cy',
	  6: 'es', 36: 'sq', 66: 'mr', 129: 'eu',
	  7: 'da', 37: 'ro', 67: 'bn', 130: 'ca',
	  8: 'pt', 38: 'cz', 68: 'as', 131: 'la',
	  9: 'no', 39: 'sk', 69: 'gu', 132: 'qu',
	  10: 'he', 40: 'si', 70: 'pa', 133: 'gn',
	  11: 'ja', 41: 'yi', 71: 'or', 134: 'ay',
	  12: 'ar', 42: 'sr', 72: 'ml', 135: 'tt',
	  13: 'fi', 43: 'mk', 73: 'kn', 136: 'ug',
	  14: 'el', 44: 'bg', 74: 'ta', 137: 'dz',
	  15: 'is', 45: 'uk', 75: 'te', 138: 'jv',
	  16: 'mt', 46: 'be', 76: 'si', 139: 'su',
	  17: 'tr', 47: 'uz', 77: 'my', 140: 'gl',
	  18: 'hr', 48: 'kk', 78: 'km', 141: 'af',
	  19: 'zh-Hant', 49: 'az-Cyrl', 79: 'lo', 142: 'br',
	  20: 'ur', 50: 'az-Arab', 80: 'vi', 143: 'iu',
	  21: 'hi', 51: 'hy', 81: 'id', 144: 'gd',
	  22: 'th', 52: 'ka', 82: 'tl', 145: 'gv',
	  23: 'ko', 53: 'mo', 83: 'ms', 146: 'ga',
	  24: 'lt', 54: 'ky', 84: 'ms-Arab', 147: 'to',
	  25: 'pl', 55: 'tg', 85: 'am', 148: 'el-polyton',
	  26: 'hu', 56: 'tk', 86: 'ti', 149: 'kl',
	  27: 'es', 57: 'mn-CN', 87: 'om', 150: 'az',
	  28: 'lv', 58: 'mn', 88: 'so', 151: 'nn',
	  29: 'se', 59: 'ps', 89: 'sw'
	},

	// ISO (deprecated)
	[], { // windows                                        
	  0x0436: 'af', 0x4009: 'en-IN', 0x0487: 'rw', 0x0432: 'tn',
	  0x041C: 'sq', 0x1809: 'en-IE', 0x0441: 'sw', 0x045B: 'si',
	  0x0484: 'gsw', 0x2009: 'en-JM', 0x0457: 'kok', 0x041B: 'sk',
	  0x045E: 'am', 0x4409: 'en-MY', 0x0412: 'ko', 0x0424: 'sl',
	  0x1401: 'ar-DZ', 0x1409: 'en-NZ', 0x0440: 'ky', 0x2C0A: 'es-AR',
	  0x3C01: 'ar-BH', 0x3409: 'en-PH', 0x0454: 'lo', 0x400A: 'es-BO',
	  0x0C01: 'ar', 0x4809: 'en-SG', 0x0426: 'lv', 0x340A: 'es-CL',
	  0x0801: 'ar-IQ', 0x1C09: 'en-ZA', 0x0427: 'lt', 0x240A: 'es-CO',
	  0x2C01: 'ar-JO', 0x2C09: 'en-TT', 0x082E: 'dsb', 0x140A: 'es-CR',
	  0x3401: 'ar-KW', 0x0809: 'en-GB', 0x046E: 'lb', 0x1C0A: 'es-DO',
	  0x3001: 'ar-LB', 0x0409: 'en', 0x042F: 'mk', 0x300A: 'es-EC',
	  0x1001: 'ar-LY', 0x3009: 'en-ZW', 0x083E: 'ms-BN', 0x440A: 'es-SV',
	  0x1801: 'ary', 0x0425: 'et', 0x043E: 'ms', 0x100A: 'es-GT',
	  0x2001: 'ar-OM', 0x0438: 'fo', 0x044C: 'ml', 0x480A: 'es-HN',
	  0x4001: 'ar-QA', 0x0464: 'fil', 0x043A: 'mt', 0x080A: 'es-MX',
	  0x0401: 'ar-SA', 0x040B: 'fi', 0x0481: 'mi', 0x4C0A: 'es-NI',
	  0x2801: 'ar-SY', 0x080C: 'fr-BE', 0x047A: 'arn', 0x180A: 'es-PA',
	  0x1C01: 'aeb', 0x0C0C: 'fr-CA', 0x044E: 'mr', 0x3C0A: 'es-PY',
	  0x3801: 'ar-AE', 0x040C: 'fr', 0x047C: 'moh', 0x280A: 'es-PE',
	  0x2401: 'ar-YE', 0x140C: 'fr-LU', 0x0450: 'mn', 0x500A: 'es-PR',
	  0x042B: 'hy', 0x180C: 'fr-MC', 0x0850: 'mn-CN', 0x0C0A: 'es',
	  0x044D: 'as', 0x100C: 'fr-CH', 0x0461: 'ne', 0x040A: 'es',
	  0x082C: 'az-Cyrl', 0x0462: 'fy', 0x0414: 'nb', 0x540A: 'es-US',
	  0x042C: 'az', 0x0456: 'gl', 0x0814: 'nn', 0x380A: 'es-UY',
	  0x046D: 'ba', 0x0437: 'ka', 0x0482: 'oc', 0x200A: 'es-VE',
	  0x042D: 'eu', 0x0C07: 'de-AT', 0x0448: 'or', 0x081D: 'sv-FI',
	  0x0423: 'be', 0x0407: 'de', 0x0463: 'ps', 0x041D: 'sv',
	  0x0845: 'bn', 0x1407: 'de-LI', 0x0415: 'pl', 0x045A: 'syr',
	  0x0445: 'bn-IN', 0x1007: 'de-LU', 0x0416: 'pt', 0x0428: 'tg',
	  0x201A: 'bs-Cyrl', 0x0807: 'de-CH', 0x0816: 'pt-PT', 0x085F: 'tzm',
	  0x141A: 'bs', 0x0408: 'el', 0x0446: 'pa', 0x0449: 'ta',
	  0x047E: 'br', 0x046F: 'kl', 0x046B: 'qu-BO', 0x0444: 'tt',
	  0x0402: 'bg', 0x0447: 'gu', 0x086B: 'qu-EC', 0x044A: 'te',
	  0x0403: 'ca', 0x0468: 'ha', 0x0C6B: 'qu', 0x041E: 'th',
	  0x0C04: 'zh-HK', 0x040D: 'he', 0x0418: 'ro', 0x0451: 'bo',
	  0x1404: 'zh-MO', 0x0439: 'hi', 0x0417: 'rm', 0x041F: 'tr',
	  0x0804: 'zh', 0x040E: 'hu', 0x0419: 'ru', 0x0442: 'tk',
	  0x1004: 'zh-SG', 0x040F: 'is', 0x243B: 'smn', 0x0480: 'ug',
	  0x0404: 'zh-TW', 0x0470: 'ig', 0x103B: 'smj-NO', 0x0422: 'uk',
	  0x0483: 'co', 0x0421: 'id', 0x143B: 'smj', 0x042E: 'hsb',
	  0x041A: 'hr', 0x045D: 'iu', 0x0C3B: 'se-FI', 0x0420: 'ur',
	  0x101A: 'hr-BA', 0x085D: 'iu-Latn', 0x043B: 'se', 0x0843: 'uz-Cyrl',
	  0x0405: 'cs', 0x083C: 'ga', 0x083B: 'se-SE', 0x0443: 'uz',
	  0x0406: 'da', 0x0434: 'xh', 0x203B: 'sms', 0x042A: 'vi',
	  0x048C: 'prs', 0x0435: 'zu', 0x183B: 'sma-NO', 0x0452: 'cy',
	  0x0465: 'dv', 0x0410: 'it', 0x1C3B: 'sms', 0x0488: 'wo',
	  0x0813: 'nl-BE', 0x0810: 'it-CH', 0x044F: 'sa', 0x0485: 'sah',
	  0x0413: 'nl', 0x0411: 'ja', 0x1C1A: 'sr-Cyrl-BA', 0x0478: 'ii',
	  0x0C09: 'en-AU', 0x044B: 'kn', 0x0C1A: 'sr', 0x046A: 'yo',
	  0x2809: 'en-BZ', 0x043F: 'kk', 0x181A: 'sr-Latn-BA',
	  0x1009: 'en-CA', 0x0453: 'km', 0x081A: 'sr-Latn',
	  0x2409: 'en-029', 0x0486: 'quc', 0x046C: 'nso'
	}];

	var NameRecord = new r.Struct({
	  platformID: r.uint16,
	  encodingID: r.uint16,
	  languageID: r.uint16,
	  nameID: r.uint16,
	  length: r.uint16,
	  string: new r.Pointer(r.uint16, new r.String('length', function (t) {
	    return getEncoding(t.platformID, t.encodingID, t.languageID);
	  }), { type: 'parent', relativeTo: 'parent.stringOffset', allowNull: false })
	});

	var LangTagRecord = new r.Struct({
	  length: r.uint16,
	  tag: new r.Pointer(r.uint16, new r.String('length', 'utf16be'), { type: 'parent', relativeTo: 'stringOffset' })
	});

	var NameTable = new r.VersionedStruct(r.uint16, {
	  0: {
	    count: r.uint16,
	    stringOffset: r.uint16,
	    records: new r.Array(NameRecord, 'count')
	  },
	  1: {
	    count: r.uint16,
	    stringOffset: r.uint16,
	    records: new r.Array(NameRecord, 'count'),
	    langTagCount: r.uint16,
	    langTags: new r.Array(LangTagRecord, 'langTagCount')
	  }
	});

	var NAMES = ['copyright', 'fontFamily', 'fontSubfamily', 'uniqueSubfamily', 'fullName', 'version', 'postscriptName', // Note: A font may have only one PostScript name and that name must be ASCII.
	'trademark', 'manufacturer', 'designer', 'description', 'vendorURL', 'designerURL', 'license', 'licenseURL', null, // reserved
	'preferredFamily', 'preferredSubfamily', 'compatibleFull', 'sampleText', 'postscriptCIDFontName', 'wwsFamilyName', 'wwsSubfamilyName'];

	NameTable.process = function (stream) {
	  var records = {};
	  for (var _iterator = this.records, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	    var _ref;

	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }

	    var record = _ref;

	    // find out what language this is for
	    var language = LANGUAGES[record.platformID][record.languageID];

	    if (language == null && this.langTags != null && record.languageID >= 0x8000) {
	      language = this.langTags[record.languageID - 0x8000].tag;
	    }

	    if (language == null) {
	      language = record.platformID + '-' + record.languageID;
	    }

	    // if the nameID is >= 256, it is a font feature record (AAT)
	    var key = record.nameID >= 256 ? 'fontFeatures' : NAMES[record.nameID] || record.nameID;
	    if (records[key] == null) {
	      records[key] = {};
	    }

	    var obj = records[key];
	    if (record.nameID >= 256) {
	      obj = obj[record.nameID] || (obj[record.nameID] = {});
	    }

	    if (typeof record.string === 'string' || typeof obj[language] !== 'string') {
	      obj[language] = record.string;
	    }
	  }

	  this.records = records;
	};

	NameTable.preEncode = function () {
	  if (Array.isArray(this.records)) return;
	  this.version = 0;

	  var records = [];
	  for (var key in this.records) {
	    var val = this.records[key];
	    if (key === 'fontFeatures') continue;

	    records.push({
	      platformID: 3,
	      encodingID: 1,
	      languageID: 0x409,
	      nameID: NAMES.indexOf(key),
	      length: Buffer.byteLength(val.en, 'utf16le'),
	      string: val.en
	    });

	    if (key === 'postscriptName') {
	      records.push({
	        platformID: 1,
	        encodingID: 0,
	        languageID: 0,
	        nameID: NAMES.indexOf(key),
	        length: val.en.length,
	        string: val.en
	      });
	    }
	  }

	  this.records = records;
	  this.count = records.length;
	  this.stringOffset = NameTable.size(this, null, false);
	};

	var OS2 = new r.VersionedStruct(r.uint16, {
	  header: {
	    xAvgCharWidth: r.int16, // average weighted advance width of lower case letters and space
	    usWeightClass: r.uint16, // visual weight of stroke in glyphs
	    usWidthClass: r.uint16, // relative change from the normal aspect ratio (width to height ratio)
	    fsType: new r.Bitfield(r.uint16, [// Indicates font embedding licensing rights
	    null, 'noEmbedding', 'viewOnly', 'editable', null, null, null, null, 'noSubsetting', 'bitmapOnly']),
	    ySubscriptXSize: r.int16, // recommended horizontal size in pixels for subscripts
	    ySubscriptYSize: r.int16, // recommended vertical size in pixels for subscripts
	    ySubscriptXOffset: r.int16, // recommended horizontal offset for subscripts
	    ySubscriptYOffset: r.int16, // recommended vertical offset form the baseline for subscripts
	    ySuperscriptXSize: r.int16, // recommended horizontal size in pixels for superscripts
	    ySuperscriptYSize: r.int16, // recommended vertical size in pixels for superscripts
	    ySuperscriptXOffset: r.int16, // recommended horizontal offset for superscripts
	    ySuperscriptYOffset: r.int16, // recommended vertical offset from the baseline for superscripts
	    yStrikeoutSize: r.int16, // width of the strikeout stroke
	    yStrikeoutPosition: r.int16, // position of the strikeout stroke relative to the baseline
	    sFamilyClass: r.int16, // classification of font-family design
	    panose: new r.Array(r.uint8, 10), // describe the visual characteristics of a given typeface
	    ulCharRange: new r.Array(r.uint32, 4),
	    vendorID: new r.String(4), // four character identifier for the font vendor
	    fsSelection: new r.Bitfield(r.uint16, [// bit field containing information about the font
	    'italic', 'underscore', 'negative', 'outlined', 'strikeout', 'bold', 'regular', 'useTypoMetrics', 'wws', 'oblique']),
	    usFirstCharIndex: r.uint16, // The minimum Unicode index in this font
	    usLastCharIndex: r.uint16 // The maximum Unicode index in this font
	  },

	  // The Apple version of this table ends here, but the Microsoft one continues on...
	  0: {},

	  1: {
	    typoAscender: r.int16,
	    typoDescender: r.int16,
	    typoLineGap: r.int16,
	    winAscent: r.uint16,
	    winDescent: r.uint16,
	    codePageRange: new r.Array(r.uint32, 2)
	  },

	  2: {
	    // these should be common with version 1 somehow
	    typoAscender: r.int16,
	    typoDescender: r.int16,
	    typoLineGap: r.int16,
	    winAscent: r.uint16,
	    winDescent: r.uint16,
	    codePageRange: new r.Array(r.uint32, 2),

	    xHeight: r.int16,
	    capHeight: r.int16,
	    defaultChar: r.uint16,
	    breakChar: r.uint16,
	    maxContent: r.uint16
	  },

	  5: {
	    typoAscender: r.int16,
	    typoDescender: r.int16,
	    typoLineGap: r.int16,
	    winAscent: r.uint16,
	    winDescent: r.uint16,
	    codePageRange: new r.Array(r.uint32, 2),

	    xHeight: r.int16,
	    capHeight: r.int16,
	    defaultChar: r.uint16,
	    breakChar: r.uint16,
	    maxContent: r.uint16,

	    usLowerOpticalPointSize: r.uint16,
	    usUpperOpticalPointSize: r.uint16
	  }
	});

	var versions = OS2.versions;
	versions[3] = versions[4] = versions[2];

	// PostScript information
	var post = new r.VersionedStruct(r.fixed32, {
	  header: { // these fields exist at the top of all versions
	    italicAngle: r.fixed32, // Italic angle in counter-clockwise degrees from the vertical.
	    underlinePosition: r.int16, // Suggested distance of the top of the underline from the baseline
	    underlineThickness: r.int16, // Suggested values for the underline thickness
	    isFixedPitch: r.uint32, // Whether the font is monospaced
	    minMemType42: r.uint32, // Minimum memory usage when a TrueType font is downloaded as a Type 42 font
	    maxMemType42: r.uint32, // Maximum memory usage when a TrueType font is downloaded as a Type 42 font
	    minMemType1: r.uint32, // Minimum memory usage when a TrueType font is downloaded as a Type 1 font
	    maxMemType1: r.uint32 // Maximum memory usage when a TrueType font is downloaded as a Type 1 font
	  },

	  1: {}, // version 1 has no additional fields

	  2: {
	    numberOfGlyphs: r.uint16,
	    glyphNameIndex: new r.Array(r.uint16, 'numberOfGlyphs'),
	    names: new r.Array(new r.String(r.uint8))
	  },

	  2.5: {
	    numberOfGlyphs: r.uint16,
	    offsets: new r.Array(r.uint8, 'numberOfGlyphs')
	  },

	  3: {}, // version 3 has no additional fields

	  4: {
	    map: new r.Array(r.uint32, function (t) {
	      return t.parent.maxp.numGlyphs;
	    })
	  }
	});

	// An array of predefined values accessible by instructions
	var cvt = new r.Struct({
	  controlValues: new r.Array(r.int16)
	});

	// A list of instructions that are executed once when a font is first used.
	// These instructions are known as the font program. The main use of this table
	// is for the definition of functions that are used in many different glyph programs.
	var fpgm = new r.Struct({
	  instructions: new r.Array(r.uint8)
	});

	var loca = new r.VersionedStruct('head.indexToLocFormat', {
	  0: {
	    offsets: new r.Array(r.uint16)
	  },
	  1: {
	    offsets: new r.Array(r.uint32)
	  }
	});

	loca.process = function () {
	  if (this.version === 0) {
	    for (var i = 0; i < this.offsets.length; i++) {
	      this.offsets[i] <<= 1;
	    }
	  }
	};

	loca.preEncode = function () {
	  if (this.version != null) return;

	  // assume this.offsets is a sorted array
	  this.version = this.offsets[this.offsets.length - 1] > 0xffff ? 1 : 0;

	  if (this.version === 0) {
	    for (var i = 0; i < this.offsets.length; i++) {
	      this.offsets[i] >>>= 1;
	    }
	  }
	};

	// Set of instructions executed whenever the point size or font transformation change
	var prep = new r.Struct({
	  controlValueProgram: new r.Array(r.uint8)
	});

	// only used for encoding
	var glyf = new r.Array(new r.Buffer());

	var CFFIndex = function () {
	  function CFFIndex(type) {
	    _classCallCheck(this, CFFIndex);

	    this.type = type;
	  }

	  CFFIndex.prototype.getCFFVersion = function getCFFVersion(ctx) {
	    while (ctx && !ctx.hdrSize) {
	      ctx = ctx.parent;
	    }

	    return ctx ? ctx.version : -1;
	  };

	  CFFIndex.prototype.decode = function decode(stream, parent) {
	    var version = this.getCFFVersion(parent);
	    var count = version >= 2 ? stream.readUInt32BE() : stream.readUInt16BE();

	    if (count === 0) {
	      return [];
	    }

	    var offSize = stream.readUInt8();
	    var offsetType = void 0;
	    if (offSize === 1) {
	      offsetType = r.uint8;
	    } else if (offSize === 2) {
	      offsetType = r.uint16;
	    } else if (offSize === 3) {
	      offsetType = r.uint24;
	    } else if (offSize === 4) {
	      offsetType = r.uint32;
	    } else {
	      throw new Error("Bad offset size in CFFIndex: " + offSize + " " + stream.pos);
	    }

	    var ret = [];
	    var startPos = stream.pos + (count + 1) * offSize - 1;

	    var start = offsetType.decode(stream);
	    for (var i = 0; i < count; i++) {
	      var end = offsetType.decode(stream);

	      if (this.type != null) {
	        var pos = stream.pos;
	        stream.pos = startPos + start;

	        parent.length = end - start;
	        ret.push(this.type.decode(stream, parent));
	        stream.pos = pos;
	      } else {
	        ret.push({
	          offset: startPos + start,
	          length: end - start
	        });
	      }

	      start = end;
	    }

	    stream.pos = startPos + start;
	    return ret;
	  };

	  CFFIndex.prototype.size = function size(arr, parent) {
	    var size = 2;
	    if (arr.length === 0) {
	      return size;
	    }

	    var type = this.type || new r.Buffer();

	    // find maximum offset to detminine offset type
	    var offset = 1;
	    for (var i = 0; i < arr.length; i++) {
	      var item = arr[i];
	      offset += type.size(item, parent);
	    }

	    var offsetType = void 0;
	    if (offset <= 0xff) {
	      offsetType = r.uint8;
	    } else if (offset <= 0xffff) {
	      offsetType = r.uint16;
	    } else if (offset <= 0xffffff) {
	      offsetType = r.uint24;
	    } else if (offset <= 0xffffffff) {
	      offsetType = r.uint32;
	    } else {
	      throw new Error("Bad offset in CFFIndex");
	    }

	    size += 1 + offsetType.size() * (arr.length + 1);
	    size += offset - 1;

	    return size;
	  };

	  CFFIndex.prototype.encode = function encode(stream, arr, parent) {
	    stream.writeUInt16BE(arr.length);
	    if (arr.length === 0) {
	      return;
	    }

	    var type = this.type || new r.Buffer();

	    // find maximum offset to detminine offset type
	    var sizes = [];
	    var offset = 1;
	    for (var _iterator = arr, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	      var _ref;

	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }

	      var item = _ref;

	      var s = type.size(item, parent);
	      sizes.push(s);
	      offset += s;
	    }

	    var offsetType = void 0;
	    if (offset <= 0xff) {
	      offsetType = r.uint8;
	    } else if (offset <= 0xffff) {
	      offsetType = r.uint16;
	    } else if (offset <= 0xffffff) {
	      offsetType = r.uint24;
	    } else if (offset <= 0xffffffff) {
	      offsetType = r.uint32;
	    } else {
	      throw new Error("Bad offset in CFFIndex");
	    }

	    // write offset size
	    stream.writeUInt8(offsetType.size());

	    // write elements
	    offset = 1;
	    offsetType.encode(stream, offset);

	    for (var _iterator2 = sizes, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
	      var _ref2;

	      if (_isArray2) {
	        if (_i2 >= _iterator2.length) break;
	        _ref2 = _iterator2[_i2++];
	      } else {
	        _i2 = _iterator2.next();
	        if (_i2.done) break;
	        _ref2 = _i2.value;
	      }

	      var size = _ref2;

	      offset += size;
	      offsetType.encode(stream, offset);
	    }

	    for (var _iterator3 = arr, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
	      var _ref3;

	      if (_isArray3) {
	        if (_i3 >= _iterator3.length) break;
	        _ref3 = _iterator3[_i3++];
	      } else {
	        _i3 = _iterator3.next();
	        if (_i3.done) break;
	        _ref3 = _i3.value;
	      }

	      var _item = _ref3;

	      type.encode(stream, _item, parent);
	    }

	    return;
	  };

	  return CFFIndex;
	}();

	var FLOAT_EOF = 0xf;
	var FLOAT_LOOKUP = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', 'E', 'E-', null, '-'];

	var FLOAT_ENCODE_LOOKUP = {
	  '.': 10,
	  'E': 11,
	  'E-': 12,
	  '-': 14
	};

	var CFFOperand = function () {
	  function CFFOperand() {
	    _classCallCheck(this, CFFOperand);
	  }

	  CFFOperand.decode = function decode(stream, value) {
	    if (32 <= value && value <= 246) {
	      return value - 139;
	    }

	    if (247 <= value && value <= 250) {
	      return (value - 247) * 256 + stream.readUInt8() + 108;
	    }

	    if (251 <= value && value <= 254) {
	      return -(value - 251) * 256 - stream.readUInt8() - 108;
	    }

	    if (value === 28) {
	      return stream.readInt16BE();
	    }

	    if (value === 29) {
	      return stream.readInt32BE();
	    }

	    if (value === 30) {
	      var str = '';
	      while (true) {
	        var b = stream.readUInt8();

	        var n1 = b >> 4;
	        if (n1 === FLOAT_EOF) {
	          break;
	        }
	        str += FLOAT_LOOKUP[n1];

	        var n2 = b & 15;
	        if (n2 === FLOAT_EOF) {
	          break;
	        }
	        str += FLOAT_LOOKUP[n2];
	      }

	      return parseFloat(str);
	    }

	    return null;
	  };

	  CFFOperand.size = function size(value) {
	    // if the value needs to be forced to the largest size (32 bit)
	    // e.g. for unknown pointers, set to 32768
	    if (value.forceLarge) {
	      value = 32768;
	    }

	    if ((value | 0) !== value) {
	      // floating point
	      var str = '' + value;
	      return 1 + Math.ceil((str.length + 1) / 2);
	    } else if (-107 <= value && value <= 107) {
	      return 1;
	    } else if (108 <= value && value <= 1131 || -1131 <= value && value <= -108) {
	      return 2;
	    } else if (-32768 <= value && value <= 32767) {
	      return 3;
	    } else {
	      return 5;
	    }
	  };

	  CFFOperand.encode = function encode(stream, value) {
	    // if the value needs to be forced to the largest size (32 bit)
	    // e.g. for unknown pointers, save the old value and set to 32768
	    var val = Number(value);

	    if (value.forceLarge) {
	      stream.writeUInt8(29);
	      return stream.writeInt32BE(val);
	    } else if ((val | 0) !== val) {
	      // floating point
	      stream.writeUInt8(30);

	      var str = '' + val;
	      for (var i = 0; i < str.length; i += 2) {
	        var c1 = str[i];
	        var n1 = FLOAT_ENCODE_LOOKUP[c1] || +c1;

	        if (i === str.length - 1) {
	          var n2 = FLOAT_EOF;
	        } else {
	          var c2 = str[i + 1];
	          var n2 = FLOAT_ENCODE_LOOKUP[c2] || +c2;
	        }

	        stream.writeUInt8(n1 << 4 | n2 & 15);
	      }

	      if (n2 !== FLOAT_EOF) {
	        return stream.writeUInt8(FLOAT_EOF << 4);
	      }
	    } else if (-107 <= val && val <= 107) {
	      return stream.writeUInt8(val + 139);
	    } else if (108 <= val && val <= 1131) {
	      val -= 108;
	      stream.writeUInt8((val >> 8) + 247);
	      return stream.writeUInt8(val & 0xff);
	    } else if (-1131 <= val && val <= -108) {
	      val = -val - 108;
	      stream.writeUInt8((val >> 8) + 251);
	      return stream.writeUInt8(val & 0xff);
	    } else if (-32768 <= val && val <= 32767) {
	      stream.writeUInt8(28);
	      return stream.writeInt16BE(val);
	    } else {
	      stream.writeUInt8(29);
	      return stream.writeInt32BE(val);
	    }
	  };

	  return CFFOperand;
	}();

	var CFFDict = function () {
	  function CFFDict() {
	    var ops = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

	    _classCallCheck(this, CFFDict);

	    this.ops = ops;
	    this.fields = {};
	    for (var _iterator = ops, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	      var _ref;

	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }

	      var field = _ref;

	      var key = Array.isArray(field[0]) ? field[0][0] << 8 | field[0][1] : field[0];
	      this.fields[key] = field;
	    }
	  }

	  CFFDict.prototype.decodeOperands = function decodeOperands(type, stream, ret, operands) {
	    var _this = this;

	    if (Array.isArray(type)) {
	      return operands.map(function (op, i) {
	        return _this.decodeOperands(type[i], stream, ret, [op]);
	      });
	    } else if (type.decode != null) {
	      return type.decode(stream, ret, operands);
	    } else {
	      switch (type) {
	        case 'number':
	        case 'offset':
	        case 'sid':
	          return operands[0];
	        case 'boolean':
	          return !!operands[0];
	        default:
	          return operands;
	      }
	    }
	  };

	  CFFDict.prototype.encodeOperands = function encodeOperands(type, stream, ctx, operands) {
	    var _this2 = this;

	    if (Array.isArray(type)) {
	      return operands.map(function (op, i) {
	        return _this2.encodeOperands(type[i], stream, ctx, op)[0];
	      });
	    } else if (type.encode != null) {
	      return type.encode(stream, operands, ctx);
	    } else if (typeof operands === 'number') {
	      return [operands];
	    } else if (typeof operands === 'boolean') {
	      return [+operands];
	    } else if (Array.isArray(operands)) {
	      return operands;
	    } else {
	      return [operands];
	    }
	  };

	  CFFDict.prototype.decode = function decode(stream, parent) {
	    var end = stream.pos + parent.length;
	    var ret = {};
	    var operands = [];

	    // define hidden properties
	    _Object$defineProperties(ret, {
	      parent: { value: parent },
	      _startOffset: { value: stream.pos }
	    });

	    // fill in defaults
	    for (var key in this.fields) {
	      var field = this.fields[key];
	      ret[field[1]] = field[3];
	    }

	    while (stream.pos < end) {
	      var b = stream.readUInt8();
	      if (b < 28) {
	        if (b === 12) {
	          b = b << 8 | stream.readUInt8();
	        }

	        var _field = this.fields[b];
	        if (!_field) {
	          throw new Error('Unknown operator ' + b);
	        }

	        var val = this.decodeOperands(_field[2], stream, ret, operands);
	        if (val != null) {
	          if (val instanceof restructure_src_utils.PropertyDescriptor) {
	            _Object$defineProperty(ret, _field[1], val);
	          } else {
	            ret[_field[1]] = val;
	          }
	        }

	        operands = [];
	      } else {
	        operands.push(CFFOperand.decode(stream, b));
	      }
	    }

	    return ret;
	  };

	  CFFDict.prototype.size = function size(dict, parent) {
	    var includePointers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

	    var ctx = {
	      parent: parent,
	      val: dict,
	      pointerSize: 0,
	      startOffset: parent.startOffset || 0
	    };

	    var len = 0;

	    for (var k in this.fields) {
	      var field = this.fields[k];
	      var val = dict[field[1]];
	      if (val == null || isEqual(val, field[3])) {
	        continue;
	      }

	      var operands = this.encodeOperands(field[2], null, ctx, val);
	      for (var _iterator2 = operands, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
	        var _ref2;

	        if (_isArray2) {
	          if (_i2 >= _iterator2.length) break;
	          _ref2 = _iterator2[_i2++];
	        } else {
	          _i2 = _iterator2.next();
	          if (_i2.done) break;
	          _ref2 = _i2.value;
	        }

	        var op = _ref2;

	        len += CFFOperand.size(op);
	      }

	      var key = Array.isArray(field[0]) ? field[0] : [field[0]];
	      len += key.length;
	    }

	    if (includePointers) {
	      len += ctx.pointerSize;
	    }

	    return len;
	  };

	  CFFDict.prototype.encode = function encode(stream, dict, parent) {
	    var ctx = {
	      pointers: [],
	      startOffset: stream.pos,
	      parent: parent,
	      val: dict,
	      pointerSize: 0
	    };

	    ctx.pointerOffset = stream.pos + this.size(dict, ctx, false);

	    for (var _iterator3 = this.ops, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
	      var _ref3;

	      if (_isArray3) {
	        if (_i3 >= _iterator3.length) break;
	        _ref3 = _iterator3[_i3++];
	      } else {
	        _i3 = _iterator3.next();
	        if (_i3.done) break;
	        _ref3 = _i3.value;
	      }

	      var field = _ref3;

	      var val = dict[field[1]];
	      if (val == null || isEqual(val, field[3])) {
	        continue;
	      }

	      var operands = this.encodeOperands(field[2], stream, ctx, val);
	      for (var _iterator4 = operands, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _getIterator(_iterator4);;) {
	        var _ref4;

	        if (_isArray4) {
	          if (_i4 >= _iterator4.length) break;
	          _ref4 = _iterator4[_i4++];
	        } else {
	          _i4 = _iterator4.next();
	          if (_i4.done) break;
	          _ref4 = _i4.value;
	        }

	        var op = _ref4;

	        CFFOperand.encode(stream, op);
	      }

	      var key = Array.isArray(field[0]) ? field[0] : [field[0]];
	      for (var _iterator5 = key, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _getIterator(_iterator5);;) {
	        var _ref5;

	        if (_isArray5) {
	          if (_i5 >= _iterator5.length) break;
	          _ref5 = _iterator5[_i5++];
	        } else {
	          _i5 = _iterator5.next();
	          if (_i5.done) break;
	          _ref5 = _i5.value;
	        }

	        var _op = _ref5;

	        stream.writeUInt8(_op);
	      }
	    }

	    var i = 0;
	    while (i < ctx.pointers.length) {
	      var ptr = ctx.pointers[i++];
	      ptr.type.encode(stream, ptr.val, ptr.parent);
	    }

	    return;
	  };

	  return CFFDict;
	}();

	var CFFPointer = function (_r$Pointer) {
	  _inherits(CFFPointer, _r$Pointer);

	  function CFFPointer(type) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	    _classCallCheck(this, CFFPointer);

	    if (options.type == null) {
	      options.type = 'global';
	    }

	    return _possibleConstructorReturn(this, _r$Pointer.call(this, null, type, options));
	  }

	  CFFPointer.prototype.decode = function decode(stream, parent, operands) {
	    this.offsetType = {
	      decode: function decode() {
	        return operands[0];
	      }
	    };

	    return _r$Pointer.prototype.decode.call(this, stream, parent, operands);
	  };

	  CFFPointer.prototype.encode = function encode(stream, value, ctx) {
	    if (!stream) {
	      // compute the size (so ctx.pointerSize is correct)
	      this.offsetType = {
	        size: function size() {
	          return 0;
	        }
	      };

	      this.size(value, ctx);
	      return [new Ptr(0)];
	    }

	    var ptr = null;
	    this.offsetType = {
	      encode: function encode(stream, val) {
	        return ptr = val;
	      }
	    };

	    _r$Pointer.prototype.encode.call(this, stream, value, ctx);
	    return [new Ptr(ptr)];
	  };

	  return CFFPointer;
	}(r.Pointer);

	var Ptr = function () {
	  function Ptr(val) {
	    _classCallCheck(this, Ptr);

	    this.val = val;
	    this.forceLarge = true;
	  }

	  Ptr.prototype.valueOf = function valueOf() {
	    return this.val;
	  };

	  return Ptr;
	}();

	var CFFBlendOp = function () {
	  function CFFBlendOp() {
	    _classCallCheck(this, CFFBlendOp);
	  }

	  CFFBlendOp.decode = function decode(stream, parent, operands) {
	    var numBlends = operands.pop();

	    // TODO: actually blend. For now just consume the deltas
	    // since we don't use any of the values anyway.
	    while (operands.length > numBlends) {
	      operands.pop();
	    }
	  };

	  return CFFBlendOp;
	}();

	var CFFPrivateDict = new CFFDict([
	// key       name                    type                                          default
	[6, 'BlueValues', 'delta', null], [7, 'OtherBlues', 'delta', null], [8, 'FamilyBlues', 'delta', null], [9, 'FamilyOtherBlues', 'delta', null], [[12, 9], 'BlueScale', 'number', 0.039625], [[12, 10], 'BlueShift', 'number', 7], [[12, 11], 'BlueFuzz', 'number', 1], [10, 'StdHW', 'number', null], [11, 'StdVW', 'number', null], [[12, 12], 'StemSnapH', 'delta', null], [[12, 13], 'StemSnapV', 'delta', null], [[12, 14], 'ForceBold', 'boolean', false], [[12, 17], 'LanguageGroup', 'number', 0], [[12, 18], 'ExpansionFactor', 'number', 0.06], [[12, 19], 'initialRandomSeed', 'number', 0], [20, 'defaultWidthX', 'number', 0], [21, 'nominalWidthX', 'number', 0], [22, 'vsindex', 'number', 0], [23, 'blend', CFFBlendOp, null], [19, 'Subrs', new CFFPointer(new CFFIndex(), { type: 'local' }), null]]);

	// Automatically generated from Appendix A of the CFF specification; do
	// not edit. Length should be 391.
	var standardStrings = [".notdef", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quoteright", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "quoteleft", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "exclamdown", "cent", "sterling", "fraction", "yen", "florin", "section", "currency", "quotesingle", "quotedblleft", "guillemotleft", "guilsinglleft", "guilsinglright", "fi", "fl", "endash", "dagger", "daggerdbl", "periodcentered", "paragraph", "bullet", "quotesinglbase", "quotedblbase", "quotedblright", "guillemotright", "ellipsis", "perthousand", "questiondown", "grave", "acute", "circumflex", "tilde", "macron", "breve", "dotaccent", "dieresis", "ring", "cedilla", "hungarumlaut", "ogonek", "caron", "emdash", "AE", "ordfeminine", "Lslash", "Oslash", "OE", "ordmasculine", "ae", "dotlessi", "lslash", "oslash", "oe", "germandbls", "onesuperior", "logicalnot", "mu", "trademark", "Eth", "onehalf", "plusminus", "Thorn", "onequarter", "divide", "brokenbar", "degree", "thorn", "threequarters", "twosuperior", "registered", "minus", "eth", "multiply", "threesuperior", "copyright", "Aacute", "Acircumflex", "Adieresis", "Agrave", "Aring", "Atilde", "Ccedilla", "Eacute", "Ecircumflex", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Ntilde", "Oacute", "Ocircumflex", "Odieresis", "Ograve", "Otilde", "Scaron", "Uacute", "Ucircumflex", "Udieresis", "Ugrave", "Yacute", "Ydieresis", "Zcaron", "aacute", "acircumflex", "adieresis", "agrave", "aring", "atilde", "ccedilla", "eacute", "ecircumflex", "edieresis", "egrave", "iacute", "icircumflex", "idieresis", "igrave", "ntilde", "oacute", "ocircumflex", "odieresis", "ograve", "otilde", "scaron", "uacute", "ucircumflex", "udieresis", "ugrave", "yacute", "ydieresis", "zcaron", "exclamsmall", "Hungarumlautsmall", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "commasuperior", "threequartersemdash", "periodsuperior", "questionsmall", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "isuperior", "lsuperior", "msuperior", "nsuperior", "osuperior", "rsuperior", "ssuperior", "tsuperior", "ff", "ffi", "ffl", "parenleftinferior", "parenrightinferior", "Circumflexsmall", "hyphensuperior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "exclamdownsmall", "centoldstyle", "Lslashsmall", "Scaronsmall", "Zcaronsmall", "Dieresissmall", "Brevesmall", "Caronsmall", "Dotaccentsmall", "Macronsmall", "figuredash", "hypheninferior", "Ogoneksmall", "Ringsmall", "Cedillasmall", "questiondownsmall", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "zerosuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior", "Agravesmall", "Aacutesmall", "Acircumflexsmall", "Atildesmall", "Adieresissmall", "Aringsmall", "AEsmall", "Ccedillasmall", "Egravesmall", "Eacutesmall", "Ecircumflexsmall", "Edieresissmall", "Igravesmall", "Iacutesmall", "Icircumflexsmall", "Idieresissmall", "Ethsmall", "Ntildesmall", "Ogravesmall", "Oacutesmall", "Ocircumflexsmall", "Otildesmall", "Odieresissmall", "OEsmall", "Oslashsmall", "Ugravesmall", "Uacutesmall", "Ucircumflexsmall", "Udieresissmall", "Yacutesmall", "Thornsmall", "Ydieresissmall", "001.000", "001.001", "001.002", "001.003", "Black", "Bold", "Book", "Light", "Medium", "Regular", "Roman", "Semibold"];

	var StandardEncoding = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quoteright', 'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater', 'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore', 'quoteleft', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'exclamdown', 'cent', 'sterling', 'fraction', 'yen', 'florin', 'section', 'currency', 'quotesingle', 'quotedblleft', 'guillemotleft', 'guilsinglleft', 'guilsinglright', 'fi', 'fl', '', 'endash', 'dagger', 'daggerdbl', 'periodcentered', '', 'paragraph', 'bullet', 'quotesinglbase', 'quotedblbase', 'quotedblright', 'guillemotright', 'ellipsis', 'perthousand', '', 'questiondown', '', 'grave', 'acute', 'circumflex', 'tilde', 'macron', 'breve', 'dotaccent', 'dieresis', '', 'ring', 'cedilla', '', 'hungarumlaut', 'ogonek', 'caron', 'emdash', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'AE', '', 'ordfeminine', '', '', '', '', 'Lslash', 'Oslash', 'OE', 'ordmasculine', '', '', '', '', '', 'ae', '', '', '', 'dotlessi', '', '', 'lslash', 'oslash', 'oe', 'germandbls'];

	var ExpertEncoding = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'space', 'exclamsmall', 'Hungarumlautsmall', '', 'dollaroldstyle', 'dollarsuperior', 'ampersandsmall', 'Acutesmall', 'parenleftsuperior', 'parenrightsuperior', 'twodotenleader', 'onedotenleader', 'comma', 'hyphen', 'period', 'fraction', 'zerooldstyle', 'oneoldstyle', 'twooldstyle', 'threeoldstyle', 'fouroldstyle', 'fiveoldstyle', 'sixoldstyle', 'sevenoldstyle', 'eightoldstyle', 'nineoldstyle', 'colon', 'semicolon', 'commasuperior', 'threequartersemdash', 'periodsuperior', 'questionsmall', '', 'asuperior', 'bsuperior', 'centsuperior', 'dsuperior', 'esuperior', '', '', 'isuperior', '', '', 'lsuperior', 'msuperior', 'nsuperior', 'osuperior', '', '', 'rsuperior', 'ssuperior', 'tsuperior', '', 'ff', 'fi', 'fl', 'ffi', 'ffl', 'parenleftinferior', '', 'parenrightinferior', 'Circumflexsmall', 'hyphensuperior', 'Gravesmall', 'Asmall', 'Bsmall', 'Csmall', 'Dsmall', 'Esmall', 'Fsmall', 'Gsmall', 'Hsmall', 'Ismall', 'Jsmall', 'Ksmall', 'Lsmall', 'Msmall', 'Nsmall', 'Osmall', 'Psmall', 'Qsmall', 'Rsmall', 'Ssmall', 'Tsmall', 'Usmall', 'Vsmall', 'Wsmall', 'Xsmall', 'Ysmall', 'Zsmall', 'colonmonetary', 'onefitted', 'rupiah', 'Tildesmall', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'exclamdownsmall', 'centoldstyle', 'Lslashsmall', '', '', 'Scaronsmall', 'Zcaronsmall', 'Dieresissmall', 'Brevesmall', 'Caronsmall', '', 'Dotaccentsmall', '', '', 'Macronsmall', '', '', 'figuredash', 'hypheninferior', '', '', 'Ogoneksmall', 'Ringsmall', 'Cedillasmall', '', '', '', 'onequarter', 'onehalf', 'threequarters', 'questiondownsmall', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'onethird', 'twothirds', '', '', 'zerosuperior', 'onesuperior', 'twosuperior', 'threesuperior', 'foursuperior', 'fivesuperior', 'sixsuperior', 'sevensuperior', 'eightsuperior', 'ninesuperior', 'zeroinferior', 'oneinferior', 'twoinferior', 'threeinferior', 'fourinferior', 'fiveinferior', 'sixinferior', 'seveninferior', 'eightinferior', 'nineinferior', 'centinferior', 'dollarinferior', 'periodinferior', 'commainferior', 'Agravesmall', 'Aacutesmall', 'Acircumflexsmall', 'Atildesmall', 'Adieresissmall', 'Aringsmall', 'AEsmall', 'Ccedillasmall', 'Egravesmall', 'Eacutesmall', 'Ecircumflexsmall', 'Edieresissmall', 'Igravesmall', 'Iacutesmall', 'Icircumflexsmall', 'Idieresissmall', 'Ethsmall', 'Ntildesmall', 'Ogravesmall', 'Oacutesmall', 'Ocircumflexsmall', 'Otildesmall', 'Odieresissmall', 'OEsmall', 'Oslashsmall', 'Ugravesmall', 'Uacutesmall', 'Ucircumflexsmall', 'Udieresissmall', 'Yacutesmall', 'Thornsmall', 'Ydieresissmall'];

	var ISOAdobeCharset = ['.notdef', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quoteright', 'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater', 'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore', 'quoteleft', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', 'exclamdown', 'cent', 'sterling', 'fraction', 'yen', 'florin', 'section', 'currency', 'quotesingle', 'quotedblleft', 'guillemotleft', 'guilsinglleft', 'guilsinglright', 'fi', 'fl', 'endash', 'dagger', 'daggerdbl', 'periodcentered', 'paragraph', 'bullet', 'quotesinglbase', 'quotedblbase', 'quotedblright', 'guillemotright', 'ellipsis', 'perthousand', 'questiondown', 'grave', 'acute', 'circumflex', 'tilde', 'macron', 'breve', 'dotaccent', 'dieresis', 'ring', 'cedilla', 'hungarumlaut', 'ogonek', 'caron', 'emdash', 'AE', 'ordfeminine', 'Lslash', 'Oslash', 'OE', 'ordmasculine', 'ae', 'dotlessi', 'lslash', 'oslash', 'oe', 'germandbls', 'onesuperior', 'logicalnot', 'mu', 'trademark', 'Eth', 'onehalf', 'plusminus', 'Thorn', 'onequarter', 'divide', 'brokenbar', 'degree', 'thorn', 'threequarters', 'twosuperior', 'registered', 'minus', 'eth', 'multiply', 'threesuperior', 'copyright', 'Aacute', 'Acircumflex', 'Adieresis', 'Agrave', 'Aring', 'Atilde', 'Ccedilla', 'Eacute', 'Ecircumflex', 'Edieresis', 'Egrave', 'Iacute', 'Icircumflex', 'Idieresis', 'Igrave', 'Ntilde', 'Oacute', 'Ocircumflex', 'Odieresis', 'Ograve', 'Otilde', 'Scaron', 'Uacute', 'Ucircumflex', 'Udieresis', 'Ugrave', 'Yacute', 'Ydieresis', 'Zcaron', 'aacute', 'acircumflex', 'adieresis', 'agrave', 'aring', 'atilde', 'ccedilla', 'eacute', 'ecircumflex', 'edieresis', 'egrave', 'iacute', 'icircumflex', 'idieresis', 'igrave', 'ntilde', 'oacute', 'ocircumflex', 'odieresis', 'ograve', 'otilde', 'scaron', 'uacute', 'ucircumflex', 'udieresis', 'ugrave', 'yacute', 'ydieresis', 'zcaron'];

	var ExpertCharset = ['.notdef', 'space', 'exclamsmall', 'Hungarumlautsmall', 'dollaroldstyle', 'dollarsuperior', 'ampersandsmall', 'Acutesmall', 'parenleftsuperior', 'parenrightsuperior', 'twodotenleader', 'onedotenleader', 'comma', 'hyphen', 'period', 'fraction', 'zerooldstyle', 'oneoldstyle', 'twooldstyle', 'threeoldstyle', 'fouroldstyle', 'fiveoldstyle', 'sixoldstyle', 'sevenoldstyle', 'eightoldstyle', 'nineoldstyle', 'colon', 'semicolon', 'commasuperior', 'threequartersemdash', 'periodsuperior', 'questionsmall', 'asuperior', 'bsuperior', 'centsuperior', 'dsuperior', 'esuperior', 'isuperior', 'lsuperior', 'msuperior', 'nsuperior', 'osuperior', 'rsuperior', 'ssuperior', 'tsuperior', 'ff', 'fi', 'fl', 'ffi', 'ffl', 'parenleftinferior', 'parenrightinferior', 'Circumflexsmall', 'hyphensuperior', 'Gravesmall', 'Asmall', 'Bsmall', 'Csmall', 'Dsmall', 'Esmall', 'Fsmall', 'Gsmall', 'Hsmall', 'Ismall', 'Jsmall', 'Ksmall', 'Lsmall', 'Msmall', 'Nsmall', 'Osmall', 'Psmall', 'Qsmall', 'Rsmall', 'Ssmall', 'Tsmall', 'Usmall', 'Vsmall', 'Wsmall', 'Xsmall', 'Ysmall', 'Zsmall', 'colonmonetary', 'onefitted', 'rupiah', 'Tildesmall', 'exclamdownsmall', 'centoldstyle', 'Lslashsmall', 'Scaronsmall', 'Zcaronsmall', 'Dieresissmall', 'Brevesmall', 'Caronsmall', 'Dotaccentsmall', 'Macronsmall', 'figuredash', 'hypheninferior', 'Ogoneksmall', 'Ringsmall', 'Cedillasmall', 'onequarter', 'onehalf', 'threequarters', 'questiondownsmall', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'onethird', 'twothirds', 'zerosuperior', 'onesuperior', 'twosuperior', 'threesuperior', 'foursuperior', 'fivesuperior', 'sixsuperior', 'sevensuperior', 'eightsuperior', 'ninesuperior', 'zeroinferior', 'oneinferior', 'twoinferior', 'threeinferior', 'fourinferior', 'fiveinferior', 'sixinferior', 'seveninferior', 'eightinferior', 'nineinferior', 'centinferior', 'dollarinferior', 'periodinferior', 'commainferior', 'Agravesmall', 'Aacutesmall', 'Acircumflexsmall', 'Atildesmall', 'Adieresissmall', 'Aringsmall', 'AEsmall', 'Ccedillasmall', 'Egravesmall', 'Eacutesmall', 'Ecircumflexsmall', 'Edieresissmall', 'Igravesmall', 'Iacutesmall', 'Icircumflexsmall', 'Idieresissmall', 'Ethsmall', 'Ntildesmall', 'Ogravesmall', 'Oacutesmall', 'Ocircumflexsmall', 'Otildesmall', 'Odieresissmall', 'OEsmall', 'Oslashsmall', 'Ugravesmall', 'Uacutesmall', 'Ucircumflexsmall', 'Udieresissmall', 'Yacutesmall', 'Thornsmall', 'Ydieresissmall'];

	var ExpertSubsetCharset = ['.notdef', 'space', 'dollaroldstyle', 'dollarsuperior', 'parenleftsuperior', 'parenrightsuperior', 'twodotenleader', 'onedotenleader', 'comma', 'hyphen', 'period', 'fraction', 'zerooldstyle', 'oneoldstyle', 'twooldstyle', 'threeoldstyle', 'fouroldstyle', 'fiveoldstyle', 'sixoldstyle', 'sevenoldstyle', 'eightoldstyle', 'nineoldstyle', 'colon', 'semicolon', 'commasuperior', 'threequartersemdash', 'periodsuperior', 'asuperior', 'bsuperior', 'centsuperior', 'dsuperior', 'esuperior', 'isuperior', 'lsuperior', 'msuperior', 'nsuperior', 'osuperior', 'rsuperior', 'ssuperior', 'tsuperior', 'ff', 'fi', 'fl', 'ffi', 'ffl', 'parenleftinferior', 'parenrightinferior', 'hyphensuperior', 'colonmonetary', 'onefitted', 'rupiah', 'centoldstyle', 'figuredash', 'hypheninferior', 'onequarter', 'onehalf', 'threequarters', 'oneeighth', 'threeeighths', 'fiveeighths', 'seveneighths', 'onethird', 'twothirds', 'zerosuperior', 'onesuperior', 'twosuperior', 'threesuperior', 'foursuperior', 'fivesuperior', 'sixsuperior', 'sevensuperior', 'eightsuperior', 'ninesuperior', 'zeroinferior', 'oneinferior', 'twoinferior', 'threeinferior', 'fourinferior', 'fiveinferior', 'sixinferior', 'seveninferior', 'eightinferior', 'nineinferior', 'centinferior', 'dollarinferior', 'periodinferior', 'commainferior'];

	//########################
	// Scripts and Languages #
	//########################

	var LangSysTable = new r.Struct({
	  reserved: new r.Reserved(r.uint16),
	  reqFeatureIndex: r.uint16,
	  featureCount: r.uint16,
	  featureIndexes: new r.Array(r.uint16, 'featureCount')
	});

	var LangSysRecord = new r.Struct({
	  tag: new r.String(4),
	  langSys: new r.Pointer(r.uint16, LangSysTable, { type: 'parent' })
	});

	var Script = new r.Struct({
	  defaultLangSys: new r.Pointer(r.uint16, LangSysTable),
	  count: r.uint16,
	  langSysRecords: new r.Array(LangSysRecord, 'count')
	});

	var ScriptRecord = new r.Struct({
	  tag: new r.String(4),
	  script: new r.Pointer(r.uint16, Script, { type: 'parent' })
	});

	var ScriptList = new r.Array(ScriptRecord, r.uint16);

	//#######################
	// Features and Lookups #
	//#######################

	var Feature = new r.Struct({
	  featureParams: r.uint16, // pointer
	  lookupCount: r.uint16,
	  lookupListIndexes: new r.Array(r.uint16, 'lookupCount')
	});

	var FeatureRecord = new r.Struct({
	  tag: new r.String(4),
	  feature: new r.Pointer(r.uint16, Feature, { type: 'parent' })
	});

	var FeatureList = new r.Array(FeatureRecord, r.uint16);

	var LookupFlags = new r.Struct({
	  markAttachmentType: r.uint8,
	  flags: new r.Bitfield(r.uint8, ['rightToLeft', 'ignoreBaseGlyphs', 'ignoreLigatures', 'ignoreMarks', 'useMarkFilteringSet'])
	});

	function LookupList(SubTable) {
	  var Lookup = new r.Struct({
	    lookupType: r.uint16,
	    flags: LookupFlags,
	    subTableCount: r.uint16,
	    subTables: new r.Array(new r.Pointer(r.uint16, SubTable), 'subTableCount'),
	    markFilteringSet: new r.Optional(r.uint16, function (t) {
	      return t.flags.flags.useMarkFilteringSet;
	    })
	  });

	  return new r.LazyArray(new r.Pointer(r.uint16, Lookup), r.uint16);
	}

	//#################
	// Coverage Table #
	//#################

	var RangeRecord = new r.Struct({
	  start: r.uint16,
	  end: r.uint16,
	  startCoverageIndex: r.uint16
	});

	var Coverage = new r.VersionedStruct(r.uint16, {
	  1: {
	    glyphCount: r.uint16,
	    glyphs: new r.Array(r.uint16, 'glyphCount')
	  },
	  2: {
	    rangeCount: r.uint16,
	    rangeRecords: new r.Array(RangeRecord, 'rangeCount')
	  }
	});

	//#########################
	// Class Definition Table #
	//#########################

	var ClassRangeRecord = new r.Struct({
	  start: r.uint16,
	  end: r.uint16,
	  class: r.uint16
	});

	var ClassDef = new r.VersionedStruct(r.uint16, {
	  1: { // Class array
	    startGlyph: r.uint16,
	    glyphCount: r.uint16,
	    classValueArray: new r.Array(r.uint16, 'glyphCount')
	  },
	  2: { // Class ranges
	    classRangeCount: r.uint16,
	    classRangeRecord: new r.Array(ClassRangeRecord, 'classRangeCount')
	  }
	});

	//###############
	// Device Table #
	//###############

	var Device = new r.Struct({
	  a: r.uint16, // startSize for hinting Device, outerIndex for VariationIndex
	  b: r.uint16, // endSize for Device, innerIndex for VariationIndex
	  deltaFormat: r.uint16
	});

	//#############################################
	// Contextual Substitution/Positioning Tables #
	//#############################################

	var LookupRecord = new r.Struct({
	  sequenceIndex: r.uint16,
	  lookupListIndex: r.uint16
	});

	var Rule = new r.Struct({
	  glyphCount: r.uint16,
	  lookupCount: r.uint16,
	  input: new r.Array(r.uint16, function (t) {
	    return t.glyphCount - 1;
	  }),
	  lookupRecords: new r.Array(LookupRecord, 'lookupCount')
	});

	var RuleSet = new r.Array(new r.Pointer(r.uint16, Rule), r.uint16);

	var ClassRule = new r.Struct({
	  glyphCount: r.uint16,
	  lookupCount: r.uint16,
	  classes: new r.Array(r.uint16, function (t) {
	    return t.glyphCount - 1;
	  }),
	  lookupRecords: new r.Array(LookupRecord, 'lookupCount')
	});

	var ClassSet = new r.Array(new r.Pointer(r.uint16, ClassRule), r.uint16);

	var Context = new r.VersionedStruct(r.uint16, {
	  1: { // Simple context
	    coverage: new r.Pointer(r.uint16, Coverage),
	    ruleSetCount: r.uint16,
	    ruleSets: new r.Array(new r.Pointer(r.uint16, RuleSet), 'ruleSetCount')
	  },
	  2: { // Class-based context
	    coverage: new r.Pointer(r.uint16, Coverage),
	    classDef: new r.Pointer(r.uint16, ClassDef),
	    classSetCnt: r.uint16,
	    classSet: new r.Array(new r.Pointer(r.uint16, ClassSet), 'classSetCnt')
	  },
	  3: {
	    glyphCount: r.uint16,
	    lookupCount: r.uint16,
	    coverages: new r.Array(new r.Pointer(r.uint16, Coverage), 'glyphCount'),
	    lookupRecords: new r.Array(LookupRecord, 'lookupCount')
	  }
	});

	//######################################################
	// Chaining Contextual Substitution/Positioning Tables #
	//######################################################

	var ChainRule = new r.Struct({
	  backtrackGlyphCount: r.uint16,
	  backtrack: new r.Array(r.uint16, 'backtrackGlyphCount'),
	  inputGlyphCount: r.uint16,
	  input: new r.Array(r.uint16, function (t) {
	    return t.inputGlyphCount - 1;
	  }),
	  lookaheadGlyphCount: r.uint16,
	  lookahead: new r.Array(r.uint16, 'lookaheadGlyphCount'),
	  lookupCount: r.uint16,
	  lookupRecords: new r.Array(LookupRecord, 'lookupCount')
	});

	var ChainRuleSet = new r.Array(new r.Pointer(r.uint16, ChainRule), r.uint16);

	var ChainingContext = new r.VersionedStruct(r.uint16, {
	  1: { // Simple context glyph substitution
	    coverage: new r.Pointer(r.uint16, Coverage),
	    chainCount: r.uint16,
	    chainRuleSets: new r.Array(new r.Pointer(r.uint16, ChainRuleSet), 'chainCount')
	  },

	  2: { // Class-based chaining context
	    coverage: new r.Pointer(r.uint16, Coverage),
	    backtrackClassDef: new r.Pointer(r.uint16, ClassDef),
	    inputClassDef: new r.Pointer(r.uint16, ClassDef),
	    lookaheadClassDef: new r.Pointer(r.uint16, ClassDef),
	    chainCount: r.uint16,
	    chainClassSet: new r.Array(new r.Pointer(r.uint16, ChainRuleSet), 'chainCount')
	  },

	  3: { // Coverage-based chaining context
	    backtrackGlyphCount: r.uint16,
	    backtrackCoverage: new r.Array(new r.Pointer(r.uint16, Coverage), 'backtrackGlyphCount'),
	    inputGlyphCount: r.uint16,
	    inputCoverage: new r.Array(new r.Pointer(r.uint16, Coverage), 'inputGlyphCount'),
	    lookaheadGlyphCount: r.uint16,
	    lookaheadCoverage: new r.Array(new r.Pointer(r.uint16, Coverage), 'lookaheadGlyphCount'),
	    lookupCount: r.uint16,
	    lookupRecords: new r.Array(LookupRecord, 'lookupCount')
	  }
	});

	var _;

	/*******************
	 * Variation Store *
	 *******************/

	var F2DOT14 = new r.Fixed(16, 'BE', 14);
	var RegionAxisCoordinates = new r.Struct({
	  startCoord: F2DOT14,
	  peakCoord: F2DOT14,
	  endCoord: F2DOT14
	});

	var VariationRegionList = new r.Struct({
	  axisCount: r.uint16,
	  regionCount: r.uint16,
	  variationRegions: new r.Array(new r.Array(RegionAxisCoordinates, 'axisCount'), 'regionCount')
	});

	var DeltaSet = new r.Struct({
	  shortDeltas: new r.Array(r.int16, function (t) {
	    return t.parent.shortDeltaCount;
	  }),
	  regionDeltas: new r.Array(r.int8, function (t) {
	    return t.parent.regionIndexCount - t.parent.shortDeltaCount;
	  }),
	  deltas: function deltas(t) {
	    return t.shortDeltas.concat(t.regionDeltas);
	  }
	});

	var ItemVariationData = new r.Struct({
	  itemCount: r.uint16,
	  shortDeltaCount: r.uint16,
	  regionIndexCount: r.uint16,
	  regionIndexes: new r.Array(r.uint16, 'regionIndexCount'),
	  deltaSets: new r.Array(DeltaSet, 'itemCount')
	});

	var ItemVariationStore = new r.Struct({
	  format: r.uint16,
	  variationRegionList: new r.Pointer(r.uint32, VariationRegionList),
	  variationDataCount: r.uint16,
	  itemVariationData: new r.Array(new r.Pointer(r.uint32, ItemVariationData), 'variationDataCount')
	});

	/**********************
	 * Feature Variations *
	 **********************/

	var ConditionTable = new r.VersionedStruct(r.uint16, {
	  1: (_ = {
	    axisIndex: r.uint16
	  }, _['axisIndex'] = r.uint16, _.filterRangeMinValue = F2DOT14, _.filterRangeMaxValue = F2DOT14, _)
	});

	var ConditionSet = new r.Struct({
	  conditionCount: r.uint16,
	  conditionTable: new r.Array(new r.Pointer(r.uint32, ConditionTable), 'conditionCount')
	});

	var FeatureTableSubstitutionRecord = new r.Struct({
	  featureIndex: r.uint16,
	  alternateFeatureTable: new r.Pointer(r.uint32, Feature, { type: 'parent' })
	});

	var FeatureTableSubstitution = new r.Struct({
	  version: r.fixed32,
	  substitutionCount: r.uint16,
	  substitutions: new r.Array(FeatureTableSubstitutionRecord, 'substitutionCount')
	});

	var FeatureVariationRecord = new r.Struct({
	  conditionSet: new r.Pointer(r.uint32, ConditionSet, { type: 'parent' }),
	  featureTableSubstitution: new r.Pointer(r.uint32, FeatureTableSubstitution, { type: 'parent' })
	});

	var FeatureVariations = new r.Struct({
	  majorVersion: r.uint16,
	  minorVersion: r.uint16,
	  featureVariationRecordCount: r.uint32,
	  featureVariationRecords: new r.Array(FeatureVariationRecord, 'featureVariationRecordCount')
	});

	// Checks if an operand is an index of a predefined value,
	// otherwise delegates to the provided type.

	var PredefinedOp = function () {
	  function PredefinedOp(predefinedOps, type) {
	    _classCallCheck(this, PredefinedOp);

	    this.predefinedOps = predefinedOps;
	    this.type = type;
	  }

	  PredefinedOp.prototype.decode = function decode(stream, parent, operands) {
	    if (this.predefinedOps[operands[0]]) {
	      return this.predefinedOps[operands[0]];
	    }

	    return this.type.decode(stream, parent, operands);
	  };

	  PredefinedOp.prototype.size = function size(value, ctx) {
	    return this.type.size(value, ctx);
	  };

	  PredefinedOp.prototype.encode = function encode(stream, value, ctx) {
	    var index = this.predefinedOps.indexOf(value);
	    if (index !== -1) {
	      return index;
	    }

	    return this.type.encode(stream, value, ctx);
	  };

	  return PredefinedOp;
	}();

	var CFFEncodingVersion = function (_r$Number) {
	  _inherits(CFFEncodingVersion, _r$Number);

	  function CFFEncodingVersion() {
	    _classCallCheck(this, CFFEncodingVersion);

	    return _possibleConstructorReturn(this, _r$Number.call(this, 'UInt8'));
	  }

	  CFFEncodingVersion.prototype.decode = function decode(stream) {
	    return r.uint8.decode(stream) & 0x7f;
	  };

	  return CFFEncodingVersion;
	}(r.Number);

	var Range1 = new r.Struct({
	  first: r.uint16,
	  nLeft: r.uint8
	});

	var Range2 = new r.Struct({
	  first: r.uint16,
	  nLeft: r.uint16
	});

	var CFFCustomEncoding = new r.VersionedStruct(new CFFEncodingVersion(), {
	  0: {
	    nCodes: r.uint8,
	    codes: new r.Array(r.uint8, 'nCodes')
	  },

	  1: {
	    nRanges: r.uint8,
	    ranges: new r.Array(Range1, 'nRanges')
	  }

	  // TODO: supplement?
	});

	var CFFEncoding = new PredefinedOp([StandardEncoding, ExpertEncoding], new CFFPointer(CFFCustomEncoding, { lazy: true }));

	// Decodes an array of ranges until the total
	// length is equal to the provided length.

	var RangeArray = function (_r$Array) {
	  _inherits(RangeArray, _r$Array);

	  function RangeArray() {
	    _classCallCheck(this, RangeArray);

	    return _possibleConstructorReturn(this, _r$Array.apply(this, arguments));
	  }

	  RangeArray.prototype.decode = function decode(stream, parent) {
	    var length = restructure_src_utils.resolveLength(this.length, stream, parent);
	    var count = 0;
	    var res = [];
	    while (count < length) {
	      var range = this.type.decode(stream, parent);
	      range.offset = count;
	      count += range.nLeft + 1;
	      res.push(range);
	    }

	    return res;
	  };

	  return RangeArray;
	}(r.Array);

	var CFFCustomCharset = new r.VersionedStruct(r.uint8, {
	  0: {
	    glyphs: new r.Array(r.uint16, function (t) {
	      return t.parent.CharStrings.length - 1;
	    })
	  },

	  1: {
	    ranges: new RangeArray(Range1, function (t) {
	      return t.parent.CharStrings.length - 1;
	    })
	  },

	  2: {
	    ranges: new RangeArray(Range2, function (t) {
	      return t.parent.CharStrings.length - 1;
	    })
	  }
	});

	var CFFCharset = new PredefinedOp([ISOAdobeCharset, ExpertCharset, ExpertSubsetCharset], new CFFPointer(CFFCustomCharset, { lazy: true }));

	var FDRange3 = new r.Struct({
	  first: r.uint16,
	  fd: r.uint8
	});

	var FDRange4 = new r.Struct({
	  first: r.uint32,
	  fd: r.uint16
	});

	var FDSelect = new r.VersionedStruct(r.uint8, {
	  0: {
	    fds: new r.Array(r.uint8, function (t) {
	      return t.parent.CharStrings.length;
	    })
	  },

	  3: {
	    nRanges: r.uint16,
	    ranges: new r.Array(FDRange3, 'nRanges'),
	    sentinel: r.uint16
	  },

	  4: {
	    nRanges: r.uint32,
	    ranges: new r.Array(FDRange4, 'nRanges'),
	    sentinel: r.uint32
	  }
	});

	var ptr = new CFFPointer(CFFPrivateDict);

	var CFFPrivateOp = function () {
	  function CFFPrivateOp() {
	    _classCallCheck(this, CFFPrivateOp);
	  }

	  CFFPrivateOp.prototype.decode = function decode(stream, parent, operands) {
	    parent.length = operands[0];
	    return ptr.decode(stream, parent, [operands[1]]);
	  };

	  CFFPrivateOp.prototype.size = function size(dict, ctx) {
	    return [CFFPrivateDict.size(dict, ctx, false), ptr.size(dict, ctx)[0]];
	  };

	  CFFPrivateOp.prototype.encode = function encode(stream, dict, ctx) {
	    return [CFFPrivateDict.size(dict, ctx, false), ptr.encode(stream, dict, ctx)[0]];
	  };

	  return CFFPrivateOp;
	}();

	var FontDict = new CFFDict([
	// key       name                   type(s)                                 default
	[18, 'Private', new CFFPrivateOp(), null], [[12, 38], 'FontName', 'sid', null]]);

	var CFFTopDict = new CFFDict([
	// key       name                   type(s)                                 default
	[[12, 30], 'ROS', ['sid', 'sid', 'number'], null], [0, 'version', 'sid', null], [1, 'Notice', 'sid', null], [[12, 0], 'Copyright', 'sid', null], [2, 'FullName', 'sid', null], [3, 'FamilyName', 'sid', null], [4, 'Weight', 'sid', null], [[12, 1], 'isFixedPitch', 'boolean', false], [[12, 2], 'ItalicAngle', 'number', 0], [[12, 3], 'UnderlinePosition', 'number', -100], [[12, 4], 'UnderlineThickness', 'number', 50], [[12, 5], 'PaintType', 'number', 0], [[12, 6], 'CharstringType', 'number', 2], [[12, 7], 'FontMatrix', 'array', [0.001, 0, 0, 0.001, 0, 0]], [13, 'UniqueID', 'number', null], [5, 'FontBBox', 'array', [0, 0, 0, 0]], [[12, 8], 'StrokeWidth', 'number', 0], [14, 'XUID', 'array', null], [15, 'charset', CFFCharset, ISOAdobeCharset], [16, 'Encoding', CFFEncoding, StandardEncoding], [17, 'CharStrings', new CFFPointer(new CFFIndex()), null], [18, 'Private', new CFFPrivateOp(), null], [[12, 20], 'SyntheticBase', 'number', null], [[12, 21], 'PostScript', 'sid', null], [[12, 22], 'BaseFontName', 'sid', null], [[12, 23], 'BaseFontBlend', 'delta', null],

	// CID font specific
	[[12, 31], 'CIDFontVersion', 'number', 0], [[12, 32], 'CIDFontRevision', 'number', 0], [[12, 33], 'CIDFontType', 'number', 0], [[12, 34], 'CIDCount', 'number', 8720], [[12, 35], 'UIDBase', 'number', null], [[12, 37], 'FDSelect', new CFFPointer(FDSelect), null], [[12, 36], 'FDArray', new CFFPointer(new CFFIndex(FontDict)), null], [[12, 38], 'FontName', 'sid', null]]);

	var VariationStore = new r.Struct({
	  length: r.uint16,
	  itemVariationStore: ItemVariationStore
	});

	var CFF2TopDict = new CFFDict([[[12, 7], 'FontMatrix', 'array', [0.001, 0, 0, 0.001, 0, 0]], [17, 'CharStrings', new CFFPointer(new CFFIndex()), null], [[12, 37], 'FDSelect', new CFFPointer(FDSelect), null], [[12, 36], 'FDArray', new CFFPointer(new CFFIndex(FontDict)), null], [24, 'vstore', new CFFPointer(VariationStore), null], [25, 'maxstack', 'number', 193]]);

	var CFFTop = new r.VersionedStruct(r.fixed16, {
	  1: {
	    hdrSize: r.uint8,
	    offSize: r.uint8,
	    nameIndex: new CFFIndex(new r.String('length')),
	    topDictIndex: new CFFIndex(CFFTopDict),
	    stringIndex: new CFFIndex(new r.String('length')),
	    globalSubrIndex: new CFFIndex()
	  },

	  2: {
	    hdrSize: r.uint8,
	    length: r.uint16,
	    topDict: CFF2TopDict,
	    globalSubrIndex: new CFFIndex()
	  }
	});

	var CFFFont = function () {
	  function CFFFont(stream) {
	    _classCallCheck(this, CFFFont);

	    this.stream = stream;
	    this.decode();
	  }

	  CFFFont.decode = function decode(stream) {
	    return new CFFFont(stream);
	  };

	  CFFFont.prototype.decode = function decode() {
	    var start = this.stream.pos;
	    var top = CFFTop.decode(this.stream);
	    for (var key in top) {
	      var val = top[key];
	      this[key] = val;
	    }

	    if (this.version < 2) {
	      if (this.topDictIndex.length !== 1) {
	        throw new Error("Only a single font is allowed in CFF");
	      }

	      this.topDict = this.topDictIndex[0];
	    }

	    this.isCIDFont = this.topDict.ROS != null;
	    return this;
	  };

	  CFFFont.prototype.string = function string(sid) {
	    if (this.version >= 2) {
	      return null;
	    }

	    if (sid < standardStrings.length) {
	      return standardStrings[sid];
	    }

	    return this.stringIndex[sid - standardStrings.length];
	  };

	  CFFFont.prototype.getCharString = function getCharString(glyph) {
	    this.stream.pos = this.topDict.CharStrings[glyph].offset;
	    return this.stream.readBuffer(this.topDict.CharStrings[glyph].length);
	  };

	  CFFFont.prototype.getGlyphName = function getGlyphName(gid) {
	    // CFF2 glyph names are in the post table.
	    if (this.version >= 2) {
	      return null;
	    }

	    // CID-keyed fonts don't have glyph names
	    if (this.isCIDFont) {
	      return null;
	    }

	    var charset = this.topDict.charset;

	    if (Array.isArray(charset)) {
	      return charset[gid];
	    }

	    if (gid === 0) {
	      return '.notdef';
	    }

	    gid -= 1;

	    switch (charset.version) {
	      case 0:
	        return this.string(charset.glyphs[gid]);

	      case 1:
	      case 2:
	        for (var i = 0; i < charset.ranges.length; i++) {
	          var range = charset.ranges[i];
	          if (range.offset <= gid && gid <= range.offset + range.nLeft) {
	            return this.string(range.first + (gid - range.offset));
	          }
	        }
	        break;
	    }

	    return null;
	  };

	  CFFFont.prototype.fdForGlyph = function fdForGlyph(gid) {
	    if (!this.topDict.FDSelect) {
	      return null;
	    }

	    switch (this.topDict.FDSelect.version) {
	      case 0:
	        return this.topDict.FDSelect.fds[gid];

	      case 3:
	      case 4:
	        var ranges = this.topDict.FDSelect.ranges;

	        var low = 0;
	        var high = ranges.length - 1;

	        while (low <= high) {
	          var mid = low + high >> 1;

	          if (gid < ranges[mid].first) {
	            high = mid - 1;
	          } else if (mid < high && gid > ranges[mid + 1].first) {
	            low = mid + 1;
	          } else {
	            return ranges[mid].fd;
	          }
	        }
	      default:
	        throw new Error('Unknown FDSelect version: ' + this.topDict.FDSelect.version);
	    }
	  };

	  CFFFont.prototype.privateDictForGlyph = function privateDictForGlyph(gid) {
	    if (this.topDict.FDSelect) {
	      var fd = this.fdForGlyph(gid);
	      if (this.topDict.FDArray[fd]) {
	        return this.topDict.FDArray[fd].Private;
	      }

	      return null;
	    }

	    if (this.version < 2) {
	      return this.topDict.Private;
	    }

	    return this.topDict.FDArray[0].Private;
	  };

	  _createClass(CFFFont, [{
	    key: 'postscriptName',
	    get: function get() {
	      if (this.version < 2) {
	        return this.nameIndex[0];
	      }

	      return null;
	    }
	  }, {
	    key: 'fullName',
	    get: function get() {
	      return this.string(this.topDict.FullName);
	    }
	  }, {
	    key: 'familyName',
	    get: function get() {
	      return this.string(this.topDict.FamilyName);
	    }
	  }]);

	  return CFFFont;
	}();

	var VerticalOrigin = new r.Struct({
	  glyphIndex: r.uint16,
	  vertOriginY: r.int16
	});

	var VORG = new r.Struct({
	  majorVersion: r.uint16,
	  minorVersion: r.uint16,
	  defaultVertOriginY: r.int16,
	  numVertOriginYMetrics: r.uint16,
	  metrics: new r.Array(VerticalOrigin, 'numVertOriginYMetrics')
	});

	var BigMetrics = new r.Struct({
	  height: r.uint8,
	  width: r.uint8,
	  horiBearingX: r.int8,
	  horiBearingY: r.int8,
	  horiAdvance: r.uint8,
	  vertBearingX: r.int8,
	  vertBearingY: r.int8,
	  vertAdvance: r.uint8
	});

	var SmallMetrics = new r.Struct({
	  height: r.uint8,
	  width: r.uint8,
	  bearingX: r.int8,
	  bearingY: r.int8,
	  advance: r.uint8
	});

	var EBDTComponent = new r.Struct({
	  glyph: r.uint16,
	  xOffset: r.int8,
	  yOffset: r.int8
	});

	var ByteAligned = function ByteAligned() {
	  _classCallCheck(this, ByteAligned);
	};

	var BitAligned = function BitAligned() {
	  _classCallCheck(this, BitAligned);
	};

	var glyph = new r.VersionedStruct('version', {
	  1: {
	    metrics: SmallMetrics,
	    data: ByteAligned
	  },

	  2: {
	    metrics: SmallMetrics,
	    data: BitAligned
	  },

	  // format 3 is deprecated
	  // format 4 is not supported by Microsoft

	  5: {
	    data: BitAligned
	  },

	  6: {
	    metrics: BigMetrics,
	    data: ByteAligned
	  },

	  7: {
	    metrics: BigMetrics,
	    data: BitAligned
	  },

	  8: {
	    metrics: SmallMetrics,
	    pad: new r.Reserved(r.uint8),
	    numComponents: r.uint16,
	    components: new r.Array(EBDTComponent, 'numComponents')
	  },

	  9: {
	    metrics: BigMetrics,
	    pad: new r.Reserved(r.uint8),
	    numComponents: r.uint16,
	    components: new r.Array(EBDTComponent, 'numComponents')
	  },

	  17: {
	    metrics: SmallMetrics,
	    dataLen: r.uint32,
	    data: new r.Buffer('dataLen')
	  },

	  18: {
	    metrics: BigMetrics,
	    dataLen: r.uint32,
	    data: new r.Buffer('dataLen')
	  },

	  19: {
	    dataLen: r.uint32,
	    data: new r.Buffer('dataLen')
	  }
	});

	var SBitLineMetrics = new r.Struct({
	  ascender: r.int8,
	  descender: r.int8,
	  widthMax: r.uint8,
	  caretSlopeNumerator: r.int8,
	  caretSlopeDenominator: r.int8,
	  caretOffset: r.int8,
	  minOriginSB: r.int8,
	  minAdvanceSB: r.int8,
	  maxBeforeBL: r.int8,
	  minAfterBL: r.int8,
	  pad: new r.Reserved(r.int8, 2)
	});

	var CodeOffsetPair = new r.Struct({
	  glyphCode: r.uint16,
	  offset: r.uint16
	});

	var IndexSubtable = new r.VersionedStruct(r.uint16, {
	  header: {
	    imageFormat: r.uint16,
	    imageDataOffset: r.uint32
	  },

	  1: {
	    offsetArray: new r.Array(r.uint32, function (t) {
	      return t.parent.lastGlyphIndex - t.parent.firstGlyphIndex + 1;
	    })
	  },

	  2: {
	    imageSize: r.uint32,
	    bigMetrics: BigMetrics
	  },

	  3: {
	    offsetArray: new r.Array(r.uint16, function (t) {
	      return t.parent.lastGlyphIndex - t.parent.firstGlyphIndex + 1;
	    })
	  },

	  4: {
	    numGlyphs: r.uint32,
	    glyphArray: new r.Array(CodeOffsetPair, function (t) {
	      return t.numGlyphs + 1;
	    })
	  },

	  5: {
	    imageSize: r.uint32,
	    bigMetrics: BigMetrics,
	    numGlyphs: r.uint32,
	    glyphCodeArray: new r.Array(r.uint16, 'numGlyphs')
	  }
	});

	var IndexSubtableArray = new r.Struct({
	  firstGlyphIndex: r.uint16,
	  lastGlyphIndex: r.uint16,
	  subtable: new r.Pointer(r.uint32, IndexSubtable)
	});

	var BitmapSizeTable = new r.Struct({
	  indexSubTableArray: new r.Pointer(r.uint32, new r.Array(IndexSubtableArray, 1), { type: 'parent' }),
	  indexTablesSize: r.uint32,
	  numberOfIndexSubTables: r.uint32,
	  colorRef: r.uint32,
	  hori: SBitLineMetrics,
	  vert: SBitLineMetrics,
	  startGlyphIndex: r.uint16,
	  endGlyphIndex: r.uint16,
	  ppemX: r.uint8,
	  ppemY: r.uint8,
	  bitDepth: r.uint8,
	  flags: new r.Bitfield(r.uint8, ['horizontal', 'vertical'])
	});

	var EBLC = new r.Struct({
	  version: r.uint32, // 0x00020000
	  numSizes: r.uint32,
	  sizes: new r.Array(BitmapSizeTable, 'numSizes')
	});

	var ImageTable = new r.Struct({
	  ppem: r.uint16,
	  resolution: r.uint16,
	  imageOffsets: new r.Array(new r.Pointer(r.uint32, 'void'), function (t) {
	    return t.parent.parent.maxp.numGlyphs + 1;
	  })
	});

	// This is the Apple sbix table, used by the "Apple Color Emoji" font.
	// It includes several image tables with images for each bitmap glyph
	// of several different sizes.
	var sbix = new r.Struct({
	  version: r.uint16,
	  flags: new r.Bitfield(r.uint16, ['renderOutlines']),
	  numImgTables: r.uint32,
	  imageTables: new r.Array(new r.Pointer(r.uint32, ImageTable), 'numImgTables')
	});

	var LayerRecord = new r.Struct({
	  gid: r.uint16, // Glyph ID of layer glyph (must be in z-order from bottom to top).
	  paletteIndex: r.uint16 // Index value to use in the appropriate palette. This value must
	}); // be less than numPaletteEntries in the CPAL table, except for
	// the special case noted below. Each palette entry is 16 bits.
	// A palette index of 0xFFFF is a special case indicating that
	// the text foreground color should be used.

	var BaseGlyphRecord = new r.Struct({
	  gid: r.uint16, // Glyph ID of reference glyph. This glyph is for reference only
	  // and is not rendered for color.
	  firstLayerIndex: r.uint16, // Index (from beginning of the Layer Records) to the layer record.
	  // There will be numLayers consecutive entries for this base glyph.
	  numLayers: r.uint16
	});

	var COLR = new r.Struct({
	  version: r.uint16,
	  numBaseGlyphRecords: r.uint16,
	  baseGlyphRecord: new r.Pointer(r.uint32, new r.Array(BaseGlyphRecord, 'numBaseGlyphRecords')),
	  layerRecords: new r.Pointer(r.uint32, new r.Array(LayerRecord, 'numLayerRecords'), { lazy: true }),
	  numLayerRecords: r.uint16
	});

	var ColorRecord = new r.Struct({
	  blue: r.uint8,
	  green: r.uint8,
	  red: r.uint8,
	  alpha: r.uint8
	});

	var CPAL = new r.VersionedStruct(r.uint16, {
	  header: {
	    numPaletteEntries: r.uint16,
	    numPalettes: r.uint16,
	    numColorRecords: r.uint16,
	    colorRecords: new r.Pointer(r.uint32, new r.Array(ColorRecord, 'numColorRecords')),
	    colorRecordIndices: new r.Array(r.uint16, 'numPalettes')
	  },
	  0: {},
	  1: {
	    offsetPaletteTypeArray: new r.Pointer(r.uint32, new r.Array(r.uint32, 'numPalettes')),
	    offsetPaletteLabelArray: new r.Pointer(r.uint32, new r.Array(r.uint16, 'numPalettes')),
	    offsetPaletteEntryLabelArray: new r.Pointer(r.uint32, new r.Array(r.uint16, 'numPaletteEntries'))
	  }
	});

	var BaseCoord = new r.VersionedStruct(r.uint16, {
	  1: { // Design units only
	    coordinate: r.int16 // X or Y value, in design units
	  },

	  2: { // Design units plus contour point
	    coordinate: r.int16, // X or Y value, in design units
	    referenceGlyph: r.uint16, // GlyphID of control glyph
	    baseCoordPoint: r.uint16 // Index of contour point on the referenceGlyph
	  },

	  3: { // Design units plus Device table
	    coordinate: r.int16, // X or Y value, in design units
	    deviceTable: new r.Pointer(r.uint16, Device) // Device table for X or Y value
	  }
	});

	var BaseValues = new r.Struct({
	  defaultIndex: r.uint16, // Index of default baseline for this script-same index in the BaseTagList
	  baseCoordCount: r.uint16,
	  baseCoords: new r.Array(new r.Pointer(r.uint16, BaseCoord), 'baseCoordCount')
	});

	var FeatMinMaxRecord = new r.Struct({
	  tag: new r.String(4), // 4-byte feature identification tag-must match FeatureTag in FeatureList
	  minCoord: new r.Pointer(r.uint16, BaseCoord, { type: 'parent' }), // May be NULL
	  maxCoord: new r.Pointer(r.uint16, BaseCoord, { type: 'parent' }) // May be NULL
	});

	var MinMax = new r.Struct({
	  minCoord: new r.Pointer(r.uint16, BaseCoord), // May be NULL
	  maxCoord: new r.Pointer(r.uint16, BaseCoord), // May be NULL
	  featMinMaxCount: r.uint16, // May be 0
	  featMinMaxRecords: new r.Array(FeatMinMaxRecord, 'featMinMaxCount') // In alphabetical order
	});

	var BaseLangSysRecord = new r.Struct({
	  tag: new r.String(4), // 4-byte language system identification tag
	  minMax: new r.Pointer(r.uint16, MinMax, { type: 'parent' })
	});

	var BaseScript = new r.Struct({
	  baseValues: new r.Pointer(r.uint16, BaseValues), // May be NULL
	  defaultMinMax: new r.Pointer(r.uint16, MinMax), // May be NULL
	  baseLangSysCount: r.uint16, // May be 0
	  baseLangSysRecords: new r.Array(BaseLangSysRecord, 'baseLangSysCount') // in alphabetical order by BaseLangSysTag
	});

	var BaseScriptRecord = new r.Struct({
	  tag: new r.String(4), // 4-byte script identification tag
	  script: new r.Pointer(r.uint16, BaseScript, { type: 'parent' })
	});

	var BaseScriptList = new r.Array(BaseScriptRecord, r.uint16);

	// Array of 4-byte baseline identification tags-must be in alphabetical order
	var BaseTagList = new r.Array(new r.String(4), r.uint16);

	var Axis = new r.Struct({
	  baseTagList: new r.Pointer(r.uint16, BaseTagList), // May be NULL
	  baseScriptList: new r.Pointer(r.uint16, BaseScriptList)
	});

	var BASE = new r.VersionedStruct(r.uint32, {
	  header: {
	    horizAxis: new r.Pointer(r.uint16, Axis), // May be NULL
	    vertAxis: new r.Pointer(r.uint16, Axis) // May be NULL
	  },

	  0x00010000: {},
	  0x00010001: {
	    itemVariationStore: new r.Pointer(r.uint32, ItemVariationStore)
	  }
	});

	var AttachPoint = new r.Array(r.uint16, r.uint16);
	var AttachList = new r.Struct({
	  coverage: new r.Pointer(r.uint16, Coverage),
	  glyphCount: r.uint16,
	  attachPoints: new r.Array(new r.Pointer(r.uint16, AttachPoint), 'glyphCount')
	});

	var CaretValue = new r.VersionedStruct(r.uint16, {
	  1: { // Design units only
	    coordinate: r.int16
	  },

	  2: { // Contour point
	    caretValuePoint: r.uint16
	  },

	  3: { // Design units plus Device table
	    coordinate: r.int16,
	    deviceTable: new r.Pointer(r.uint16, Device)
	  }
	});

	var LigGlyph = new r.Array(new r.Pointer(r.uint16, CaretValue), r.uint16);

	var LigCaretList = new r.Struct({
	  coverage: new r.Pointer(r.uint16, Coverage),
	  ligGlyphCount: r.uint16,
	  ligGlyphs: new r.Array(new r.Pointer(r.uint16, LigGlyph), 'ligGlyphCount')
	});

	var MarkGlyphSetsDef = new r.Struct({
	  markSetTableFormat: r.uint16,
	  markSetCount: r.uint16,
	  coverage: new r.Array(new r.Pointer(r.uint32, Coverage), 'markSetCount')
	});

	var GDEF = new r.VersionedStruct(r.uint32, {
	  header: {
	    glyphClassDef: new r.Pointer(r.uint16, ClassDef),
	    attachList: new r.Pointer(r.uint16, AttachList),
	    ligCaretList: new r.Pointer(r.uint16, LigCaretList),
	    markAttachClassDef: new r.Pointer(r.uint16, ClassDef)
	  },

	  0x00010000: {},
	  0x00010002: {
	    markGlyphSetsDef: new r.Pointer(r.uint16, MarkGlyphSetsDef)
	  },
	  0x00010003: {
	    markGlyphSetsDef: new r.Pointer(r.uint16, MarkGlyphSetsDef),
	    itemVariationStore: new r.Pointer(r.uint32, ItemVariationStore)
	  }
	});

	var ValueFormat = new r.Bitfield(r.uint16, ['xPlacement', 'yPlacement', 'xAdvance', 'yAdvance', 'xPlaDevice', 'yPlaDevice', 'xAdvDevice', 'yAdvDevice']);

	var types = {
	  xPlacement: r.int16,
	  yPlacement: r.int16,
	  xAdvance: r.int16,
	  yAdvance: r.int16,
	  xPlaDevice: new r.Pointer(r.uint16, Device, { type: 'global', relativeTo: 'rel' }),
	  yPlaDevice: new r.Pointer(r.uint16, Device, { type: 'global', relativeTo: 'rel' }),
	  xAdvDevice: new r.Pointer(r.uint16, Device, { type: 'global', relativeTo: 'rel' }),
	  yAdvDevice: new r.Pointer(r.uint16, Device, { type: 'global', relativeTo: 'rel' })
	};

	var ValueRecord = function () {
	  function ValueRecord() {
	    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'valueFormat';

	    _classCallCheck(this, ValueRecord);

	    this.key = key;
	  }

	  ValueRecord.prototype.buildStruct = function buildStruct(parent) {
	    var struct = parent;
	    while (!struct[this.key] && struct.parent) {
	      struct = struct.parent;
	    }

	    if (!struct[this.key]) return;

	    var fields = {};
	    fields.rel = function () {
	      return struct._startOffset;
	    };

	    var format = struct[this.key];
	    for (var key in format) {
	      if (format[key]) {
	        fields[key] = types[key];
	      }
	    }

	    return new r.Struct(fields);
	  };

	  ValueRecord.prototype.size = function size(val, ctx) {
	    return this.buildStruct(ctx).size(val, ctx);
	  };

	  ValueRecord.prototype.decode = function decode(stream, parent) {
	    var res = this.buildStruct(parent).decode(stream, parent);
	    delete res.rel;
	    return res;
	  };

	  return ValueRecord;
	}();

	var PairValueRecord = new r.Struct({
	  secondGlyph: r.uint16,
	  value1: new ValueRecord('valueFormat1'),
	  value2: new ValueRecord('valueFormat2')
	});

	var PairSet = new r.Array(PairValueRecord, r.uint16);

	var Class2Record = new r.Struct({
	  value1: new ValueRecord('valueFormat1'),
	  value2: new ValueRecord('valueFormat2')
	});

	var Anchor = new r.VersionedStruct(r.uint16, {
	  1: { // Design units only
	    xCoordinate: r.int16,
	    yCoordinate: r.int16
	  },

	  2: { // Design units plus contour point
	    xCoordinate: r.int16,
	    yCoordinate: r.int16,
	    anchorPoint: r.uint16
	  },

	  3: { // Design units plus Device tables
	    xCoordinate: r.int16,
	    yCoordinate: r.int16,
	    xDeviceTable: new r.Pointer(r.uint16, Device),
	    yDeviceTable: new r.Pointer(r.uint16, Device)
	  }
	});

	var EntryExitRecord = new r.Struct({
	  entryAnchor: new r.Pointer(r.uint16, Anchor, { type: 'parent' }),
	  exitAnchor: new r.Pointer(r.uint16, Anchor, { type: 'parent' })
	});

	var MarkRecord = new r.Struct({
	  class: r.uint16,
	  markAnchor: new r.Pointer(r.uint16, Anchor, { type: 'parent' })
	});

	var MarkArray = new r.Array(MarkRecord, r.uint16);

	var BaseRecord = new r.Array(new r.Pointer(r.uint16, Anchor), function (t) {
	  return t.parent.classCount;
	});
	var BaseArray = new r.Array(BaseRecord, r.uint16);

	var ComponentRecord = new r.Array(new r.Pointer(r.uint16, Anchor), function (t) {
	  return t.parent.parent.classCount;
	});
	var LigatureAttach = new r.Array(ComponentRecord, r.uint16);
	var LigatureArray = new r.Array(new r.Pointer(r.uint16, LigatureAttach), r.uint16);

	var GPOSLookup = new r.VersionedStruct('lookupType', {
	  1: new r.VersionedStruct(r.uint16, { // Single Adjustment
	    1: { // Single positioning value
	      coverage: new r.Pointer(r.uint16, Coverage),
	      valueFormat: ValueFormat,
	      value: new ValueRecord()
	    },
	    2: {
	      coverage: new r.Pointer(r.uint16, Coverage),
	      valueFormat: ValueFormat,
	      valueCount: r.uint16,
	      values: new r.LazyArray(new ValueRecord(), 'valueCount')
	    }
	  }),

	  2: new r.VersionedStruct(r.uint16, { // Pair Adjustment Positioning
	    1: { // Adjustments for glyph pairs
	      coverage: new r.Pointer(r.uint16, Coverage),
	      valueFormat1: ValueFormat,
	      valueFormat2: ValueFormat,
	      pairSetCount: r.uint16,
	      pairSets: new r.LazyArray(new r.Pointer(r.uint16, PairSet), 'pairSetCount')
	    },

	    2: { // Class pair adjustment
	      coverage: new r.Pointer(r.uint16, Coverage),
	      valueFormat1: ValueFormat,
	      valueFormat2: ValueFormat,
	      classDef1: new r.Pointer(r.uint16, ClassDef),
	      classDef2: new r.Pointer(r.uint16, ClassDef),
	      class1Count: r.uint16,
	      class2Count: r.uint16,
	      classRecords: new r.LazyArray(new r.LazyArray(Class2Record, 'class2Count'), 'class1Count')
	    }
	  }),

	  3: { // Cursive Attachment Positioning
	    format: r.uint16,
	    coverage: new r.Pointer(r.uint16, Coverage),
	    entryExitCount: r.uint16,
	    entryExitRecords: new r.Array(EntryExitRecord, 'entryExitCount')
	  },

	  4: { // MarkToBase Attachment Positioning
	    format: r.uint16,
	    markCoverage: new r.Pointer(r.uint16, Coverage),
	    baseCoverage: new r.Pointer(r.uint16, Coverage),
	    classCount: r.uint16,
	    markArray: new r.Pointer(r.uint16, MarkArray),
	    baseArray: new r.Pointer(r.uint16, BaseArray)
	  },

	  5: { // MarkToLigature Attachment Positioning
	    format: r.uint16,
	    markCoverage: new r.Pointer(r.uint16, Coverage),
	    ligatureCoverage: new r.Pointer(r.uint16, Coverage),
	    classCount: r.uint16,
	    markArray: new r.Pointer(r.uint16, MarkArray),
	    ligatureArray: new r.Pointer(r.uint16, LigatureArray)
	  },

	  6: { // MarkToMark Attachment Positioning
	    format: r.uint16,
	    mark1Coverage: new r.Pointer(r.uint16, Coverage),
	    mark2Coverage: new r.Pointer(r.uint16, Coverage),
	    classCount: r.uint16,
	    mark1Array: new r.Pointer(r.uint16, MarkArray),
	    mark2Array: new r.Pointer(r.uint16, BaseArray)
	  },

	  7: Context, // Contextual positioning
	  8: ChainingContext, // Chaining contextual positioning

	  9: { // Extension Positioning
	    posFormat: r.uint16,
	    lookupType: r.uint16, // cannot also be 9
	    extension: new r.Pointer(r.uint32, GPOSLookup)
	  }
	});

	// Fix circular reference
	GPOSLookup.versions[9].extension.type = GPOSLookup;

	var GPOS = new r.VersionedStruct(r.uint32, {
	  header: {
	    scriptList: new r.Pointer(r.uint16, ScriptList),
	    featureList: new r.Pointer(r.uint16, FeatureList),
	    lookupList: new r.Pointer(r.uint16, new LookupList(GPOSLookup))
	  },

	  0x00010000: {},
	  0x00010001: {
	    featureVariations: new r.Pointer(r.uint32, FeatureVariations)
	  }
	});

	var Sequence = new r.Array(r.uint16, r.uint16);
	var AlternateSet = Sequence;

	var Ligature = new r.Struct({
	  glyph: r.uint16,
	  compCount: r.uint16,
	  components: new r.Array(r.uint16, function (t) {
	    return t.compCount - 1;
	  })
	});

	var LigatureSet = new r.Array(new r.Pointer(r.uint16, Ligature), r.uint16);

	var GSUBLookup = new r.VersionedStruct('lookupType', {
	  1: new r.VersionedStruct(r.uint16, { // Single Substitution
	    1: {
	      coverage: new r.Pointer(r.uint16, Coverage),
	      deltaGlyphID: r.int16
	    },
	    2: {
	      coverage: new r.Pointer(r.uint16, Coverage),
	      glyphCount: r.uint16,
	      substitute: new r.LazyArray(r.uint16, 'glyphCount')
	    }
	  }),

	  2: { // Multiple Substitution
	    substFormat: r.uint16,
	    coverage: new r.Pointer(r.uint16, Coverage),
	    count: r.uint16,
	    sequences: new r.LazyArray(new r.Pointer(r.uint16, Sequence), 'count')
	  },

	  3: { // Alternate Substitution
	    substFormat: r.uint16,
	    coverage: new r.Pointer(r.uint16, Coverage),
	    count: r.uint16,
	    alternateSet: new r.LazyArray(new r.Pointer(r.uint16, AlternateSet), 'count')
	  },

	  4: { // Ligature Substitution
	    substFormat: r.uint16,
	    coverage: new r.Pointer(r.uint16, Coverage),
	    count: r.uint16,
	    ligatureSets: new r.LazyArray(new r.Pointer(r.uint16, LigatureSet), 'count')
	  },

	  5: Context, // Contextual Substitution
	  6: ChainingContext, // Chaining Contextual Substitution

	  7: { // Extension Substitution
	    substFormat: r.uint16,
	    lookupType: r.uint16, // cannot also be 7
	    extension: new r.Pointer(r.uint32, GSUBLookup)
	  },

	  8: { // Reverse Chaining Contextual Single Substitution
	    substFormat: r.uint16,
	    coverage: new r.Pointer(r.uint16, Coverage),
	    backtrackCoverage: new r.Array(new r.Pointer(r.uint16, Coverage), 'backtrackGlyphCount'),
	    lookaheadGlyphCount: r.uint16,
	    lookaheadCoverage: new r.Array(new r.Pointer(r.uint16, Coverage), 'lookaheadGlyphCount'),
	    glyphCount: r.uint16,
	    substitutes: new r.Array(r.uint16, 'glyphCount')
	  }
	});

	// Fix circular reference
	GSUBLookup.versions[7].extension.type = GSUBLookup;

	var GSUB = new r.VersionedStruct(r.uint32, {
	  header: {
	    scriptList: new r.Pointer(r.uint16, ScriptList),
	    featureList: new r.Pointer(r.uint16, FeatureList),
	    lookupList: new r.Pointer(r.uint16, new LookupList(GSUBLookup))
	  },

	  0x00010000: {},
	  0x00010001: {
	    featureVariations: new r.Pointer(r.uint32, FeatureVariations)
	  }
	});

	var JstfGSUBModList = new r.Array(r.uint16, r.uint16);

	var JstfPriority = new r.Struct({
	  shrinkageEnableGSUB: new r.Pointer(r.uint16, JstfGSUBModList),
	  shrinkageDisableGSUB: new r.Pointer(r.uint16, JstfGSUBModList),
	  shrinkageEnableGPOS: new r.Pointer(r.uint16, JstfGSUBModList),
	  shrinkageDisableGPOS: new r.Pointer(r.uint16, JstfGSUBModList),
	  shrinkageJstfMax: new r.Pointer(r.uint16, new LookupList(GPOSLookup)),
	  extensionEnableGSUB: new r.Pointer(r.uint16, JstfGSUBModList),
	  extensionDisableGSUB: new r.Pointer(r.uint16, JstfGSUBModList),
	  extensionEnableGPOS: new r.Pointer(r.uint16, JstfGSUBModList),
	  extensionDisableGPOS: new r.Pointer(r.uint16, JstfGSUBModList),
	  extensionJstfMax: new r.Pointer(r.uint16, new LookupList(GPOSLookup))
	});

	var JstfLangSys = new r.Array(new r.Pointer(r.uint16, JstfPriority), r.uint16);

	var JstfLangSysRecord = new r.Struct({
	  tag: new r.String(4),
	  jstfLangSys: new r.Pointer(r.uint16, JstfLangSys)
	});

	var JstfScript = new r.Struct({
	  extenderGlyphs: new r.Pointer(r.uint16, new r.Array(r.uint16, r.uint16)), // array of glyphs to extend line length
	  defaultLangSys: new r.Pointer(r.uint16, JstfLangSys),
	  langSysCount: r.uint16,
	  langSysRecords: new r.Array(JstfLangSysRecord, 'langSysCount')
	});

	var JstfScriptRecord = new r.Struct({
	  tag: new r.String(4),
	  script: new r.Pointer(r.uint16, JstfScript, { type: 'parent' })
	});

	var JSTF = new r.Struct({
	  version: r.uint32, // should be 0x00010000
	  scriptCount: r.uint16,
	  scriptList: new r.Array(JstfScriptRecord, 'scriptCount')
	});

	// TODO: add this to restructure

	var VariableSizeNumber = function () {
	  function VariableSizeNumber(size) {
	    _classCallCheck(this, VariableSizeNumber);

	    this._size = size;
	  }

	  VariableSizeNumber.prototype.decode = function decode(stream, parent) {
	    switch (this.size(0, parent)) {
	      case 1:
	        return stream.readUInt8();
	      case 2:
	        return stream.readUInt16BE();
	      case 3:
	        return stream.readUInt24BE();
	      case 4:
	        return stream.readUInt32BE();
	    }
	  };

	  VariableSizeNumber.prototype.size = function size(val, parent) {
	    return restructure_src_utils.resolveLength(this._size, null, parent);
	  };

	  return VariableSizeNumber;
	}();

	var MapDataEntry = new r.Struct({
	  entry: new VariableSizeNumber(function (t) {
	    return ((t.parent.entryFormat & 0x0030) >> 4) + 1;
	  }),
	  outerIndex: function outerIndex(t) {
	    return t.entry >> (t.parent.entryFormat & 0x000F) + 1;
	  },
	  innerIndex: function innerIndex(t) {
	    return t.entry & (1 << (t.parent.entryFormat & 0x000F) + 1) - 1;
	  }
	});

	var DeltaSetIndexMap = new r.Struct({
	  entryFormat: r.uint16,
	  mapCount: r.uint16,
	  mapData: new r.Array(MapDataEntry, 'mapCount')
	});

	var HVAR = new r.Struct({
	  majorVersion: r.uint16,
	  minorVersion: r.uint16,
	  itemVariationStore: new r.Pointer(r.uint32, ItemVariationStore),
	  advanceWidthMapping: new r.Pointer(r.uint32, DeltaSetIndexMap),
	  LSBMapping: new r.Pointer(r.uint32, DeltaSetIndexMap),
	  RSBMapping: new r.Pointer(r.uint32, DeltaSetIndexMap)
	});

	var Signature = new r.Struct({
	  format: r.uint32,
	  length: r.uint32,
	  offset: r.uint32
	});

	var SignatureBlock = new r.Struct({
	  reserved: new r.Reserved(r.uint16, 2),
	  cbSignature: r.uint32, // Length (in bytes) of the PKCS#7 packet in pbSignature
	  signature: new r.Buffer('cbSignature')
	});

	var DSIG = new r.Struct({
	  ulVersion: r.uint32, // Version number of the DSIG table (0x00000001)
	  usNumSigs: r.uint16, // Number of signatures in the table
	  usFlag: r.uint16, // Permission flags
	  signatures: new r.Array(Signature, 'usNumSigs'),
	  signatureBlocks: new r.Array(SignatureBlock, 'usNumSigs')
	});

	var GaspRange = new r.Struct({
	  rangeMaxPPEM: r.uint16, // Upper limit of range, in ppem
	  rangeGaspBehavior: new r.Bitfield(r.uint16, [// Flags describing desired rasterizer behavior
	  'grayscale', 'gridfit', 'symmetricSmoothing', 'symmetricGridfit' // only in version 1, for ClearType
	  ])
	});

	var gasp = new r.Struct({
	  version: r.uint16, // set to 0
	  numRanges: r.uint16,
	  gaspRanges: new r.Array(GaspRange, 'numRanges') // Sorted by ppem
	});

	var DeviceRecord = new r.Struct({
	  pixelSize: r.uint8,
	  maximumWidth: r.uint8,
	  widths: new r.Array(r.uint8, function (t) {
	    return t.parent.parent.maxp.numGlyphs;
	  })
	});

	// The Horizontal Device Metrics table stores integer advance widths scaled to particular pixel sizes
	var hdmx = new r.Struct({
	  version: r.uint16,
	  numRecords: r.int16,
	  sizeDeviceRecord: r.int32,
	  records: new r.Array(DeviceRecord, 'numRecords')
	});

	var KernPair = new r.Struct({
	  left: r.uint16,
	  right: r.uint16,
	  value: r.int16
	});

	var ClassTable = new r.Struct({
	  firstGlyph: r.uint16,
	  nGlyphs: r.uint16,
	  offsets: new r.Array(r.uint16, 'nGlyphs'),
	  max: function max(t) {
	    return t.offsets.length && Math.max.apply(Math, t.offsets);
	  }
	});

	var Kern2Array = new r.Struct({
	  off: function off(t) {
	    return t._startOffset - t.parent.parent._startOffset;
	  },
	  len: function len(t) {
	    return ((t.parent.leftTable.max - t.off) / t.parent.rowWidth + 1) * (t.parent.rowWidth / 2);
	  },
	  values: new r.LazyArray(r.int16, 'len')
	});

	var KernSubtable = new r.VersionedStruct('format', {
	  0: {
	    nPairs: r.uint16,
	    searchRange: r.uint16,
	    entrySelector: r.uint16,
	    rangeShift: r.uint16,
	    pairs: new r.Array(KernPair, 'nPairs')
	  },

	  2: {
	    rowWidth: r.uint16,
	    leftTable: new r.Pointer(r.uint16, ClassTable, { type: 'parent' }),
	    rightTable: new r.Pointer(r.uint16, ClassTable, { type: 'parent' }),
	    array: new r.Pointer(r.uint16, Kern2Array, { type: 'parent' })
	  },

	  3: {
	    glyphCount: r.uint16,
	    kernValueCount: r.uint8,
	    leftClassCount: r.uint8,
	    rightClassCount: r.uint8,
	    flags: r.uint8,
	    kernValue: new r.Array(r.int16, 'kernValueCount'),
	    leftClass: new r.Array(r.uint8, 'glyphCount'),
	    rightClass: new r.Array(r.uint8, 'glyphCount'),
	    kernIndex: new r.Array(r.uint8, function (t) {
	      return t.leftClassCount * t.rightClassCount;
	    })
	  }
	});

	var KernTable = new r.VersionedStruct('version', {
	  0: { // Microsoft uses this format
	    subVersion: r.uint16, // Microsoft has an extra sub-table version number
	    length: r.uint16, // Length of the subtable, in bytes
	    format: r.uint8, // Format of subtable
	    coverage: new r.Bitfield(r.uint8, ['horizontal', // 1 if table has horizontal data, 0 if vertical
	    'minimum', // If set to 1, the table has minimum values. If set to 0, the table has kerning values.
	    'crossStream', // If set to 1, kerning is perpendicular to the flow of the text
	    'override' // If set to 1 the value in this table replaces the accumulated value
	    ]),
	    subtable: KernSubtable,
	    padding: new r.Reserved(r.uint8, function (t) {
	      return t.length - t._currentOffset;
	    })
	  },
	  1: { // Apple uses this format
	    length: r.uint32,
	    coverage: new r.Bitfield(r.uint8, [null, null, null, null, null, 'variation', // Set if table has variation kerning values
	    'crossStream', // Set if table has cross-stream kerning values
	    'vertical' // Set if table has vertical kerning values
	    ]),
	    format: r.uint8,
	    tupleIndex: r.uint16,
	    subtable: KernSubtable,
	    padding: new r.Reserved(r.uint8, function (t) {
	      return t.length - t._currentOffset;
	    })
	  }
	});

	var kern = new r.VersionedStruct(r.uint16, {
	  0: { // Microsoft Version
	    nTables: r.uint16,
	    tables: new r.Array(KernTable, 'nTables')
	  },

	  1: { // Apple Version
	    reserved: new r.Reserved(r.uint16), // the other half of the version number
	    nTables: r.uint32,
	    tables: new r.Array(KernTable, 'nTables')
	  }
	});

	// Linear Threshold table
	// Records the ppem for each glyph at which the scaling becomes linear again,
	// despite instructions effecting the advance width
	var LTSH = new r.Struct({
	  version: r.uint16,
	  numGlyphs: r.uint16,
	  yPels: new r.Array(r.uint8, 'numGlyphs')
	});

	// PCL 5 Table
	// NOTE: The PCLT table is strongly discouraged for OpenType fonts with TrueType outlines
	var PCLT = new r.Struct({
	  version: r.uint16,
	  fontNumber: r.uint32,
	  pitch: r.uint16,
	  xHeight: r.uint16,
	  style: r.uint16,
	  typeFamily: r.uint16,
	  capHeight: r.uint16,
	  symbolSet: r.uint16,
	  typeface: new r.String(16),
	  characterComplement: new r.String(8),
	  fileName: new r.String(6),
	  strokeWeight: new r.String(1),
	  widthType: new r.String(1),
	  serifStyle: r.uint8,
	  reserved: new r.Reserved(r.uint8)
	});

	// VDMX tables contain ascender/descender overrides for certain (usually small)
	// sizes. This is needed in order to match font metrics on Windows.

	var Ratio = new r.Struct({
	  bCharSet: r.uint8, // Character set
	  xRatio: r.uint8, // Value to use for x-Ratio
	  yStartRatio: r.uint8, // Starting y-Ratio value
	  yEndRatio: r.uint8 // Ending y-Ratio value
	});

	var vTable = new r.Struct({
	  yPelHeight: r.uint16, // yPelHeight to which values apply
	  yMax: r.int16, // Maximum value (in pels) for this yPelHeight
	  yMin: r.int16 // Minimum value (in pels) for this yPelHeight
	});

	var VdmxGroup = new r.Struct({
	  recs: r.uint16, // Number of height records in this group
	  startsz: r.uint8, // Starting yPelHeight
	  endsz: r.uint8, // Ending yPelHeight
	  entries: new r.Array(vTable, 'recs') // The VDMX records
	});

	var VDMX = new r.Struct({
	  version: r.uint16, // Version number (0 or 1)
	  numRecs: r.uint16, // Number of VDMX groups present
	  numRatios: r.uint16, // Number of aspect ratio groupings
	  ratioRanges: new r.Array(Ratio, 'numRatios'), // Ratio ranges
	  offsets: new r.Array(r.uint16, 'numRatios'), // Offset to the VDMX group for this ratio range
	  groups: new r.Array(VdmxGroup, 'numRecs') // The actual VDMX groupings
	});

	// Vertical Header Table
	var vhea = new r.Struct({
	  version: r.uint16, // Version number of the Vertical Header Table
	  ascent: r.int16, // The vertical typographic ascender for this font
	  descent: r.int16, // The vertical typographic descender for this font
	  lineGap: r.int16, // The vertical typographic line gap for this font
	  advanceHeightMax: r.int16, // The maximum advance height measurement found in the font
	  minTopSideBearing: r.int16, // The minimum top side bearing measurement found in the font
	  minBottomSideBearing: r.int16, // The minimum bottom side bearing measurement found in the font
	  yMaxExtent: r.int16,
	  caretSlopeRise: r.int16, // Caret slope (rise/run)
	  caretSlopeRun: r.int16,
	  caretOffset: r.int16, // Set value equal to 0 for nonslanted fonts
	  reserved: new r.Reserved(r.int16, 4),
	  metricDataFormat: r.int16, // Set to 0
	  numberOfMetrics: r.uint16 // Number of advance heights in the Vertical Metrics table
	});

	var VmtxEntry = new r.Struct({
	  advance: r.uint16, // The advance height of the glyph
	  bearing: r.int16 // The top sidebearing of the glyph
	});

	// Vertical Metrics Table
	var vmtx = new r.Struct({
	  metrics: new r.LazyArray(VmtxEntry, function (t) {
	    return t.parent.vhea.numberOfMetrics;
	  }),
	  bearings: new r.LazyArray(r.int16, function (t) {
	    return t.parent.maxp.numGlyphs - t.parent.vhea.numberOfMetrics;
	  })
	});

	var shortFrac = new r.Fixed(16, 'BE', 14);

	var Correspondence = new r.Struct({
	  fromCoord: shortFrac,
	  toCoord: shortFrac
	});

	var Segment = new r.Struct({
	  pairCount: r.uint16,
	  correspondence: new r.Array(Correspondence, 'pairCount')
	});

	var avar = new r.Struct({
	  version: r.fixed32,
	  axisCount: r.uint32,
	  segment: new r.Array(Segment, 'axisCount')
	});

	var UnboundedArrayAccessor = function () {
	  function UnboundedArrayAccessor(type, stream, parent) {
	    _classCallCheck(this, UnboundedArrayAccessor);

	    this.type = type;
	    this.stream = stream;
	    this.parent = parent;
	    this.base = this.stream.pos;
	    this._items = [];
	  }

	  UnboundedArrayAccessor.prototype.getItem = function getItem(index) {
	    if (this._items[index] == null) {
	      var pos = this.stream.pos;
	      this.stream.pos = this.base + this.type.size(null, this.parent) * index;
	      this._items[index] = this.type.decode(this.stream, this.parent);
	      this.stream.pos = pos;
	    }

	    return this._items[index];
	  };

	  UnboundedArrayAccessor.prototype.inspect = function inspect() {
	    return '[UnboundedArray ' + this.type.constructor.name + ']';
	  };

	  return UnboundedArrayAccessor;
	}();

	var UnboundedArray = function (_r$Array) {
	  _inherits(UnboundedArray, _r$Array);

	  function UnboundedArray(type) {
	    _classCallCheck(this, UnboundedArray);

	    return _possibleConstructorReturn(this, _r$Array.call(this, type, 0));
	  }

	  UnboundedArray.prototype.decode = function decode(stream, parent) {
	    return new UnboundedArrayAccessor(this.type, stream, parent);
	  };

	  return UnboundedArray;
	}(r.Array);

	var LookupTable = function LookupTable() {
	  var ValueType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : r.uint16;

	  // Helper class that makes internal structures invisible to pointers
	  var Shadow = function () {
	    function Shadow(type) {
	      _classCallCheck(this, Shadow);

	      this.type = type;
	    }

	    Shadow.prototype.decode = function decode(stream, ctx) {
	      ctx = ctx.parent.parent;
	      return this.type.decode(stream, ctx);
	    };

	    Shadow.prototype.size = function size(val, ctx) {
	      ctx = ctx.parent.parent;
	      return this.type.size(val, ctx);
	    };

	    Shadow.prototype.encode = function encode(stream, val, ctx) {
	      ctx = ctx.parent.parent;
	      return this.type.encode(stream, val, ctx);
	    };

	    return Shadow;
	  }();

	  ValueType = new Shadow(ValueType);

	  var BinarySearchHeader = new r.Struct({
	    unitSize: r.uint16,
	    nUnits: r.uint16,
	    searchRange: r.uint16,
	    entrySelector: r.uint16,
	    rangeShift: r.uint16
	  });

	  var LookupSegmentSingle = new r.Struct({
	    lastGlyph: r.uint16,
	    firstGlyph: r.uint16,
	    value: ValueType
	  });

	  var LookupSegmentArray = new r.Struct({
	    lastGlyph: r.uint16,
	    firstGlyph: r.uint16,
	    values: new r.Pointer(r.uint16, new r.Array(ValueType, function (t) {
	      return t.lastGlyph - t.firstGlyph + 1;
	    }), { type: 'parent' })
	  });

	  var LookupSingle = new r.Struct({
	    glyph: r.uint16,
	    value: ValueType
	  });

	  return new r.VersionedStruct(r.uint16, {
	    0: {
	      values: new UnboundedArray(ValueType) // length == number of glyphs maybe?
	    },
	    2: {
	      binarySearchHeader: BinarySearchHeader,
	      segments: new r.Array(LookupSegmentSingle, function (t) {
	        return t.binarySearchHeader.nUnits;
	      })
	    },
	    4: {
	      binarySearchHeader: BinarySearchHeader,
	      segments: new r.Array(LookupSegmentArray, function (t) {
	        return t.binarySearchHeader.nUnits;
	      })
	    },
	    6: {
	      binarySearchHeader: BinarySearchHeader,
	      segments: new r.Array(LookupSingle, function (t) {
	        return t.binarySearchHeader.nUnits;
	      })
	    },
	    8: {
	      firstGlyph: r.uint16,
	      count: r.uint16,
	      values: new r.Array(ValueType, 'count')
	    }
	  });
	};

	function StateTable() {
	  var entryData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var lookupType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : r.uint16;

	  var entry = _Object$assign({
	    newState: r.uint16,
	    flags: r.uint16
	  }, entryData);

	  var Entry = new r.Struct(entry);
	  var StateArray = new UnboundedArray(new r.Array(r.uint16, function (t) {
	    return t.nClasses;
	  }));

	  var StateHeader = new r.Struct({
	    nClasses: r.uint32,
	    classTable: new r.Pointer(r.uint32, new LookupTable(lookupType)),
	    stateArray: new r.Pointer(r.uint32, StateArray),
	    entryTable: new r.Pointer(r.uint32, new UnboundedArray(Entry))
	  });

	  return StateHeader;
	}

	// This is the old version of the StateTable structure
	function StateTable1() {
	  var entryData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var lookupType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : r.uint16;

	  var ClassLookupTable = new r.Struct({
	    version: function version() {
	      return 8;
	    },
	    // simulate LookupTable
	    firstGlyph: r.uint16,
	    values: new r.Array(r.uint8, r.uint16)
	  });

	  var entry = _Object$assign({
	    newStateOffset: r.uint16,
	    // convert offset to stateArray index
	    newState: function newState(t) {
	      return (t.newStateOffset - (t.parent.stateArray.base - t.parent._startOffset)) / t.parent.nClasses;
	    },
	    flags: r.uint16
	  }, entryData);

	  var Entry = new r.Struct(entry);
	  var StateArray = new UnboundedArray(new r.Array(r.uint8, function (t) {
	    return t.nClasses;
	  }));

	  var StateHeader1 = new r.Struct({
	    nClasses: r.uint16,
	    classTable: new r.Pointer(r.uint16, ClassLookupTable),
	    stateArray: new r.Pointer(r.uint16, StateArray),
	    entryTable: new r.Pointer(r.uint16, new UnboundedArray(Entry))
	  });

	  return StateHeader1;
	}

	var BslnSubtable = new r.VersionedStruct('format', {
	  0: { // Distance-based, no mapping
	    deltas: new r.Array(r.int16, 32)
	  },

	  1: { // Distance-based, with mapping
	    deltas: new r.Array(r.int16, 32),
	    mappingData: new LookupTable(r.uint16)
	  },

	  2: { // Control point-based, no mapping
	    standardGlyph: r.uint16,
	    controlPoints: new r.Array(r.uint16, 32)
	  },

	  3: { // Control point-based, with mapping
	    standardGlyph: r.uint16,
	    controlPoints: new r.Array(r.uint16, 32),
	    mappingData: new LookupTable(r.uint16)
	  }
	});

	var bsln = new r.Struct({
	  version: r.fixed32,
	  format: r.uint16,
	  defaultBaseline: r.uint16,
	  subtable: BslnSubtable
	});

	var Setting = new r.Struct({
	  setting: r.uint16,
	  nameIndex: r.int16,
	  name: function name(t) {
	    return t.parent.parent.parent.name.records.fontFeatures[t.nameIndex];
	  }
	});

	var FeatureName = new r.Struct({
	  feature: r.uint16,
	  nSettings: r.uint16,
	  settingTable: new r.Pointer(r.uint32, new r.Array(Setting, 'nSettings'), { type: 'parent' }),
	  featureFlags: new r.Bitfield(r.uint8, [null, null, null, null, null, null, 'hasDefault', 'exclusive']),
	  defaultSetting: r.uint8,
	  nameIndex: r.int16,
	  name: function name(t) {
	    return t.parent.parent.name.records.fontFeatures[t.nameIndex];
	  }
	});

	var feat = new r.Struct({
	  version: r.fixed32,
	  featureNameCount: r.uint16,
	  reserved1: new r.Reserved(r.uint16),
	  reserved2: new r.Reserved(r.uint32),
	  featureNames: new r.Array(FeatureName, 'featureNameCount')
	});

	var Axis$1 = new r.Struct({
	  axisTag: new r.String(4),
	  minValue: r.fixed32,
	  defaultValue: r.fixed32,
	  maxValue: r.fixed32,
	  flags: r.uint16,
	  nameID: r.uint16,
	  name: function name(t) {
	    return t.parent.parent.name.records.fontFeatures[t.nameID];
	  }
	});

	var Instance = new r.Struct({
	  nameID: r.uint16,
	  name: function name(t) {
	    return t.parent.parent.name.records.fontFeatures[t.nameID];
	  },
	  flags: r.uint16,
	  coord: new r.Array(r.fixed32, function (t) {
	    return t.parent.axisCount;
	  }),
	  postscriptNameID: new r.Optional(r.uint16, function (t) {
	    return t.parent.instanceSize - t._currentOffset > 0;
	  })
	});

	var fvar = new r.Struct({
	  version: r.fixed32,
	  offsetToData: r.uint16,
	  countSizePairs: r.uint16,
	  axisCount: r.uint16,
	  axisSize: r.uint16,
	  instanceCount: r.uint16,
	  instanceSize: r.uint16,
	  axis: new r.Array(Axis$1, 'axisCount'),
	  instance: new r.Array(Instance, 'instanceCount')
	});

	var shortFrac$1 = new r.Fixed(16, 'BE', 14);

	var Offset = function () {
	  function Offset() {
	    _classCallCheck(this, Offset);
	  }

	  Offset.decode = function decode(stream, parent) {
	    // In short format, offsets are multiplied by 2.
	    // This doesn't seem to be documented by Apple, but it
	    // is implemented this way in Freetype.
	    return parent.flags ? stream.readUInt32BE() : stream.readUInt16BE() * 2;
	  };

	  return Offset;
	}();

	var gvar = new r.Struct({
	  version: r.uint16,
	  reserved: new r.Reserved(r.uint16),
	  axisCount: r.uint16,
	  globalCoordCount: r.uint16,
	  globalCoords: new r.Pointer(r.uint32, new r.Array(new r.Array(shortFrac$1, 'axisCount'), 'globalCoordCount')),
	  glyphCount: r.uint16,
	  flags: r.uint16,
	  offsetToData: r.uint32,
	  offsets: new r.Array(new r.Pointer(Offset, 'void', { relativeTo: 'offsetToData', allowNull: false }), function (t) {
	    return t.glyphCount + 1;
	  })
	});

	var ClassTable$1 = new r.Struct({
	  length: r.uint16,
	  coverage: r.uint16,
	  subFeatureFlags: r.uint32,
	  stateTable: new StateTable1()
	});

	var WidthDeltaRecord = new r.Struct({
	  justClass: r.uint32,
	  beforeGrowLimit: r.fixed32,
	  beforeShrinkLimit: r.fixed32,
	  afterGrowLimit: r.fixed32,
	  afterShrinkLimit: r.fixed32,
	  growFlags: r.uint16,
	  shrinkFlags: r.uint16
	});

	var WidthDeltaCluster = new r.Array(WidthDeltaRecord, r.uint32);

	var ActionData = new r.VersionedStruct('actionType', {
	  0: { // Decomposition action
	    lowerLimit: r.fixed32,
	    upperLimit: r.fixed32,
	    order: r.uint16,
	    glyphs: new r.Array(r.uint16, r.uint16)
	  },

	  1: { // Unconditional add glyph action
	    addGlyph: r.uint16
	  },

	  2: { // Conditional add glyph action
	    substThreshold: r.fixed32,
	    addGlyph: r.uint16,
	    substGlyph: r.uint16
	  },

	  3: {}, // Stretch glyph action (no data, not supported by CoreText)

	  4: { // Ductile glyph action (not supported by CoreText)
	    variationAxis: r.uint32,
	    minimumLimit: r.fixed32,
	    noStretchValue: r.fixed32,
	    maximumLimit: r.fixed32
	  },

	  5: { // Repeated add glyph action
	    flags: r.uint16,
	    glyph: r.uint16
	  }
	});

	var Action = new r.Struct({
	  actionClass: r.uint16,
	  actionType: r.uint16,
	  actionLength: r.uint32,
	  actionData: ActionData,
	  padding: new r.Reserved(r.uint8, function (t) {
	    return t.actionLength - t._currentOffset;
	  })
	});

	var PostcompensationAction = new r.Array(Action, r.uint32);
	var PostCompensationTable = new r.Struct({
	  lookupTable: new LookupTable(new r.Pointer(r.uint16, PostcompensationAction))
	});

	var JustificationTable = new r.Struct({
	  classTable: new r.Pointer(r.uint16, ClassTable$1, { type: 'parent' }),
	  wdcOffset: r.uint16,
	  postCompensationTable: new r.Pointer(r.uint16, PostCompensationTable, { type: 'parent' }),
	  widthDeltaClusters: new LookupTable(new r.Pointer(r.uint16, WidthDeltaCluster, { type: 'parent', relativeTo: 'wdcOffset' }))
	});

	var just = new r.Struct({
	  version: r.uint32,
	  format: r.uint16,
	  horizontal: new r.Pointer(r.uint16, JustificationTable),
	  vertical: new r.Pointer(r.uint16, JustificationTable)
	});

	var LigatureData = {
	  action: r.uint16
	};

	var ContextualData = {
	  markIndex: r.uint16,
	  currentIndex: r.uint16
	};

	var InsertionData = {
	  currentInsertIndex: r.uint16,
	  markedInsertIndex: r.uint16
	};

	var SubstitutionTable = new r.Struct({
	  items: new UnboundedArray(new r.Pointer(r.uint32, new LookupTable()))
	});

	var SubtableData = new r.VersionedStruct('type', {
	  0: { // Indic Rearrangement Subtable
	    stateTable: new StateTable()
	  },

	  1: { // Contextual Glyph Substitution Subtable
	    stateTable: new StateTable(ContextualData),
	    substitutionTable: new r.Pointer(r.uint32, SubstitutionTable)
	  },

	  2: { // Ligature subtable
	    stateTable: new StateTable(LigatureData),
	    ligatureActions: new r.Pointer(r.uint32, new UnboundedArray(r.uint32)),
	    components: new r.Pointer(r.uint32, new UnboundedArray(r.uint16)),
	    ligatureList: new r.Pointer(r.uint32, new UnboundedArray(r.uint16))
	  },

	  4: { // Non-contextual Glyph Substitution Subtable
	    lookupTable: new LookupTable()
	  },

	  5: { // Glyph Insertion Subtable
	    stateTable: new StateTable(InsertionData),
	    insertionActions: new r.Pointer(r.uint32, new UnboundedArray(r.uint16))
	  }
	});

	var Subtable = new r.Struct({
	  length: r.uint32,
	  coverage: r.uint24,
	  type: r.uint8,
	  subFeatureFlags: r.uint32,
	  table: SubtableData,
	  padding: new r.Reserved(r.uint8, function (t) {
	    return t.length - t._currentOffset;
	  })
	});

	var FeatureEntry = new r.Struct({
	  featureType: r.uint16,
	  featureSetting: r.uint16,
	  enableFlags: r.uint32,
	  disableFlags: r.uint32
	});

	var MorxChain = new r.Struct({
	  defaultFlags: r.uint32,
	  chainLength: r.uint32,
	  nFeatureEntries: r.uint32,
	  nSubtables: r.uint32,
	  features: new r.Array(FeatureEntry, 'nFeatureEntries'),
	  subtables: new r.Array(Subtable, 'nSubtables')
	});

	var morx = new r.Struct({
	  version: r.uint16,
	  unused: new r.Reserved(r.uint16),
	  nChains: r.uint32,
	  chains: new r.Array(MorxChain, 'nChains')
	});

	var OpticalBounds = new r.Struct({
	  left: r.int16,
	  top: r.int16,
	  right: r.int16,
	  bottom: r.int16
	});

	var opbd = new r.Struct({
	  version: r.fixed32,
	  format: r.uint16,
	  lookupTable: new LookupTable(OpticalBounds)
	});

	var tables = {};
	// Required Tables
	tables.cmap = cmap;
	tables.head = head;
	tables.hhea = hhea;
	tables.hmtx = hmtx;
	tables.maxp = maxp;
	tables.name = NameTable;
	tables['OS/2'] = OS2;
	tables.post = post;

	// TrueType Outlines
	tables.fpgm = fpgm;
	tables.loca = loca;
	tables.prep = prep;
	tables['cvt '] = cvt;
	tables.glyf = glyf;

	// PostScript Outlines
	tables['CFF '] = CFFFont;
	tables['CFF2'] = CFFFont;
	tables.VORG = VORG;

	// Bitmap Glyphs
	tables.EBLC = EBLC;
	tables.CBLC = tables.EBLC;
	tables.sbix = sbix;
	tables.COLR = COLR;
	tables.CPAL = CPAL;

	// Advanced OpenType Tables
	tables.BASE = BASE;
	tables.GDEF = GDEF;
	tables.GPOS = GPOS;
	tables.GSUB = GSUB;
	tables.JSTF = JSTF;

	// OpenType variations tables
	tables.HVAR = HVAR;

	// Other OpenType Tables
	tables.DSIG = DSIG;
	tables.gasp = gasp;
	tables.hdmx = hdmx;
	tables.kern = kern;
	tables.LTSH = LTSH;
	tables.PCLT = PCLT;
	tables.VDMX = VDMX;
	tables.vhea = vhea;
	tables.vmtx = vmtx;

	// Apple Advanced Typography Tables
	tables.avar = avar;
	tables.bsln = bsln;
	tables.feat = feat;
	tables.fvar = fvar;
	tables.gvar = gvar;
	tables.just = just;
	tables.morx = morx;
	tables.opbd = opbd;

	var TableEntry = new r.Struct({
	  tag: new r.String(4),
	  checkSum: r.uint32,
	  offset: new r.Pointer(r.uint32, 'void', { type: 'global' }),
	  length: r.uint32
	});

	var Directory = new r.Struct({
	  tag: new r.String(4),
	  numTables: r.uint16,
	  searchRange: r.uint16,
	  entrySelector: r.uint16,
	  rangeShift: r.uint16,
	  tables: new r.Array(TableEntry, 'numTables')
	});

	Directory.process = function () {
	  var tables = {};
	  for (var _iterator = this.tables, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	    var _ref;

	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }

	    var table = _ref;

	    tables[table.tag] = table;
	  }

	  this.tables = tables;
	};

	Directory.preEncode = function (stream) {
	  var tables$$ = [];
	  for (var tag in this.tables) {
	    var table = this.tables[tag];
	    if (table) {
	      tables$$.push({
	        tag: tag,
	        checkSum: 0,
	        offset: new r.VoidPointer(tables[tag], table),
	        length: tables[tag].size(table)
	      });
	    }
	  }

	  this.tag = 'true';
	  this.numTables = tables$$.length;
	  this.tables = tables$$;

	  this.searchRange = Math.floor(Math.log(this.numTables) / Math.LN2) * 16;
	  this.entrySelector = Math.floor(this.searchRange / Math.LN2);
	  this.rangeShift = this.numTables * 16 - this.searchRange;
	};

	function binarySearch(arr, cmp) {
	  var min = 0;
	  var max = arr.length - 1;
	  while (min <= max) {
	    var mid = min + max >> 1;
	    var res = cmp(arr[mid]);

	    if (res < 0) {
	      max = mid - 1;
	    } else if (res > 0) {
	      min = mid + 1;
	    } else {
	      return mid;
	    }
	  }

	  return -1;
	}

	function range(index, end) {
	  var range = [];
	  while (index < end) {
	    range.push(index++);
	  }
	  return range;
	}

	var _class$1;
	function _applyDecoratedDescriptor$1(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;

	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }

	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);

	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }

	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }

	  return desc;
	}

	// iconv-lite is an optional dependency.
	try {
	  var iconv = __webpack_require__(87);
	} catch (err) {}

	var CmapProcessor = (_class$1 = function () {
	  function CmapProcessor(cmapTable) {
	    _classCallCheck(this, CmapProcessor);

	    // Attempt to find a Unicode cmap first
	    this.encoding = null;
	    this.cmap = this.findSubtable(cmapTable, [
	    // 32-bit subtables
	    [3, 10], [0, 6], [0, 4],

	    // 16-bit subtables
	    [3, 1], [0, 3], [0, 2], [0, 1], [0, 0]]);

	    // If not unicode cmap was found, and iconv-lite is installed,
	    // take the first table with a supported encoding.
	    if (!this.cmap && iconv) {
	      for (var _iterator = cmapTable.tables, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	        var _ref;

	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }

	        var cmap = _ref;

	        var encoding = getEncoding(cmap.platformID, cmap.encodingID, cmap.table.language - 1);
	        if (iconv.encodingExists(encoding)) {
	          this.cmap = cmap.table;
	          this.encoding = encoding;
	        }
	      }
	    }

	    if (!this.cmap) {
	      throw new Error("Could not find a supported cmap table");
	    }

	    this.uvs = this.findSubtable(cmapTable, [[0, 5]]);
	    if (this.uvs && this.uvs.version !== 14) {
	      this.uvs = null;
	    }
	  }

	  CmapProcessor.prototype.findSubtable = function findSubtable(cmapTable, pairs) {
	    for (var _iterator2 = pairs, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
	      var _ref2;

	      if (_isArray2) {
	        if (_i2 >= _iterator2.length) break;
	        _ref2 = _iterator2[_i2++];
	      } else {
	        _i2 = _iterator2.next();
	        if (_i2.done) break;
	        _ref2 = _i2.value;
	      }

	      var _ref3 = _ref2,
	          platformID = _ref3[0],
	          encodingID = _ref3[1];

	      for (var _iterator3 = cmapTable.tables, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
	        var _ref4;

	        if (_isArray3) {
	          if (_i3 >= _iterator3.length) break;
	          _ref4 = _iterator3[_i3++];
	        } else {
	          _i3 = _iterator3.next();
	          if (_i3.done) break;
	          _ref4 = _i3.value;
	        }

	        var cmap = _ref4;

	        if (cmap.platformID === platformID && cmap.encodingID === encodingID) {
	          return cmap.table;
	        }
	      }
	    }

	    return null;
	  };

	  CmapProcessor.prototype.lookup = function lookup(codepoint, variationSelector) {
	    // If there is no Unicode cmap in this font, we need to re-encode
	    // the codepoint in the encoding that the cmap supports.
	    if (this.encoding) {
	      var buf = iconv.encode(_String$fromCodePoint(codepoint), this.encoding);
	      codepoint = 0;
	      for (var i = 0; i < buf.length; i++) {
	        codepoint = codepoint << 8 | buf[i];
	      }

	      // Otherwise, try to get a Unicode variation selector for this codepoint if one is provided.
	    } else if (variationSelector) {
	      var gid = this.getVariationSelector(codepoint, variationSelector);
	      if (gid) {
	        return gid;
	      }
	    }

	    var cmap = this.cmap;
	    switch (cmap.version) {
	      case 0:
	        return cmap.codeMap.get(codepoint) || 0;

	      case 4:
	        {
	          var min = 0;
	          var max = cmap.segCount - 1;
	          while (min <= max) {
	            var mid = min + max >> 1;

	            if (codepoint < cmap.startCode.get(mid)) {
	              max = mid - 1;
	            } else if (codepoint > cmap.endCode.get(mid)) {
	              min = mid + 1;
	            } else {
	              var rangeOffset = cmap.idRangeOffset.get(mid);
	              var _gid = void 0;

	              if (rangeOffset === 0) {
	                _gid = codepoint + cmap.idDelta.get(mid);
	              } else {
	                var index = rangeOffset / 2 + (codepoint - cmap.startCode.get(mid)) - (cmap.segCount - mid);
	                _gid = cmap.glyphIndexArray.get(index) || 0;
	                if (_gid !== 0) {
	                  _gid += cmap.idDelta.get(mid);
	                }
	              }

	              return _gid & 0xffff;
	            }
	          }

	          return 0;
	        }

	      case 8:
	        throw new Error('TODO: cmap format 8');

	      case 6:
	      case 10:
	        return cmap.glyphIndices.get(codepoint - cmap.firstCode) || 0;

	      case 12:
	      case 13:
	        {
	          var _min = 0;
	          var _max = cmap.nGroups - 1;
	          while (_min <= _max) {
	            var _mid = _min + _max >> 1;
	            var group = cmap.groups.get(_mid);

	            if (codepoint < group.startCharCode) {
	              _max = _mid - 1;
	            } else if (codepoint > group.endCharCode) {
	              _min = _mid + 1;
	            } else {
	              if (cmap.version === 12) {
	                return group.glyphID + (codepoint - group.startCharCode);
	              } else {
	                return group.glyphID;
	              }
	            }
	          }

	          return 0;
	        }

	      case 14:
	        throw new Error('TODO: cmap format 14');

	      default:
	        throw new Error('Unknown cmap format ' + cmap.version);
	    }
	  };

	  CmapProcessor.prototype.getVariationSelector = function getVariationSelector(codepoint, variationSelector) {
	    if (!this.uvs) {
	      return 0;
	    }

	    var selectors = this.uvs.varSelectors.toArray();
	    var i = binarySearch(selectors, function (x) {
	      return variationSelector - x.varSelector;
	    });
	    var sel = selectors[i];

	    if (i !== -1 && sel.defaultUVS) {
	      i = binarySearch(sel.defaultUVS, function (x) {
	        return codepoint < x.startUnicodeValue ? -1 : codepoint > x.startUnicodeValue + x.additionalCount ? +1 : 0;
	      });
	    }

	    if (i !== -1 && sel.nonDefaultUVS) {
	      i = binarySearch(sel.nonDefaultUVS, function (x) {
	        return codepoint - x.unicodeValue;
	      });
	      if (i !== -1) {
	        return sel.nonDefaultUVS[i].glyphID;
	      }
	    }

	    return 0;
	  };

	  CmapProcessor.prototype.getCharacterSet = function getCharacterSet() {
	    var cmap = this.cmap;
	    switch (cmap.version) {
	      case 0:
	        return range(0, cmap.codeMap.length);

	      case 4:
	        {
	          var res = [];
	          var endCodes = cmap.endCode.toArray();
	          for (var i = 0; i < endCodes.length; i++) {
	            var tail = endCodes[i] + 1;
	            var start = cmap.startCode.get(i);
	            res.push.apply(res, range(start, tail));
	          }

	          return res;
	        }

	      case 8:
	        throw new Error('TODO: cmap format 8');

	      case 6:
	      case 10:
	        return range(cmap.firstCode, cmap.firstCode + cmap.glyphIndices.length);

	      case 12:
	      case 13:
	        {
	          var _res = [];
	          for (var _iterator4 = cmap.groups.toArray(), _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _getIterator(_iterator4);;) {
	            var _ref5;

	            if (_isArray4) {
	              if (_i4 >= _iterator4.length) break;
	              _ref5 = _iterator4[_i4++];
	            } else {
	              _i4 = _iterator4.next();
	              if (_i4.done) break;
	              _ref5 = _i4.value;
	            }

	            var group = _ref5;

	            _res.push.apply(_res, range(group.startCharCode, group.endCharCode + 1));
	          }

	          return _res;
	        }

	      case 14:
	        throw new Error('TODO: cmap format 14');

	      default:
	        throw new Error('Unknown cmap format ' + cmap.version);
	    }
	  };

	  CmapProcessor.prototype.codePointsForGlyph = function codePointsForGlyph(gid) {
	    var cmap = this.cmap;
	    switch (cmap.version) {
	      case 0:
	        {
	          var res = [];
	          for (var i = 0; i < 256; i++) {
	            if (cmap.codeMap.get(i) === gid) {
	              res.push(i);
	            }
	          }

	          return res;
	        }

	      case 4:
	        {
	          var _res2 = [];
	          for (var _i5 = 0; _i5 < cmap.segCount; _i5++) {
	            var end = cmap.endCode.get(_i5);
	            var start = cmap.startCode.get(_i5);
	            var rangeOffset = cmap.idRangeOffset.get(_i5);
	            var delta = cmap.idDelta.get(_i5);

	            for (var c = start; c <= end; c++) {
	              var g = 0;
	              if (rangeOffset === 0) {
	                g = c + delta;
	              } else {
	                var index = rangeOffset / 2 + (c - start) - (cmap.segCount - _i5);
	                g = cmap.glyphIndexArray.get(index) || 0;
	                if (g !== 0) {
	                  g += delta;
	                }
	              }

	              if (g === gid) {
	                _res2.push(c);
	              }
	            }
	          }

	          return _res2;
	        }

	      case 12:
	        {
	          var _res3 = [];
	          for (var _iterator5 = cmap.groups.toArray(), _isArray5 = Array.isArray(_iterator5), _i6 = 0, _iterator5 = _isArray5 ? _iterator5 : _getIterator(_iterator5);;) {
	            var _ref6;

	            if (_isArray5) {
	              if (_i6 >= _iterator5.length) break;
	              _ref6 = _iterator5[_i6++];
	            } else {
	              _i6 = _iterator5.next();
	              if (_i6.done) break;
	              _ref6 = _i6.value;
	            }

	            var group = _ref6;

	            if (gid >= group.glyphID && gid <= group.glyphID + (group.endCharCode - group.startCharCode)) {
	              _res3.push(group.startCharCode + (gid - group.glyphID));
	            }
	          }

	          return _res3;
	        }

	      case 13:
	        {
	          var _res4 = [];
	          for (var _iterator6 = cmap.groups.toArray(), _isArray6 = Array.isArray(_iterator6), _i7 = 0, _iterator6 = _isArray6 ? _iterator6 : _getIterator(_iterator6);;) {
	            var _ref7;

	            if (_isArray6) {
	              if (_i7 >= _iterator6.length) break;
	              _ref7 = _iterator6[_i7++];
	            } else {
	              _i7 = _iterator6.next();
	              if (_i7.done) break;
	              _ref7 = _i7.value;
	            }

	            var _group = _ref7;

	            if (gid === _group.glyphID) {
	              _res4.push.apply(_res4, range(_group.startCharCode, _group.endCharCode + 1));
	            }
	          }

	          return _res4;
	        }

	      default:
	        throw new Error('Unknown cmap format ' + cmap.version);
	    }
	  };

	  return CmapProcessor;
	}(), (_applyDecoratedDescriptor$1(_class$1.prototype, 'getCharacterSet', [cache], _Object$getOwnPropertyDescriptor(_class$1.prototype, 'getCharacterSet'), _class$1.prototype), _applyDecoratedDescriptor$1(_class$1.prototype, 'codePointsForGlyph', [cache], _Object$getOwnPropertyDescriptor(_class$1.prototype, 'codePointsForGlyph'), _class$1.prototype)), _class$1);

	var KernProcessor = function () {
	  function KernProcessor(font) {
	    _classCallCheck(this, KernProcessor);

	    this.kern = font.kern;
	  }

	  KernProcessor.prototype.process = function process(glyphs, positions) {
	    for (var glyphIndex = 0; glyphIndex < glyphs.length - 1; glyphIndex++) {
	      var left = glyphs[glyphIndex].id;
	      var right = glyphs[glyphIndex + 1].id;
	      positions[glyphIndex].xAdvance += this.getKerning(left, right);
	    }
	  };

	  KernProcessor.prototype.getKerning = function getKerning(left, right) {
	    var res = 0;

	    for (var _iterator = this.kern.tables, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	      var _ref;

	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }

	      var table = _ref;

	      if (table.coverage.crossStream) {
	        continue;
	      }

	      switch (table.version) {
	        case 0:
	          if (!table.coverage.horizontal) {
	            continue;
	          }

	          break;
	        case 1:
	          if (table.coverage.vertical || table.coverage.variation) {
	            continue;
	          }

	          break;
	        default:
	          throw new Error('Unsupported kerning table version ' + table.version);
	      }

	      var val = 0;
	      var s = table.subtable;
	      switch (table.format) {
	        case 0:
	          var pairIdx = binarySearch(s.pairs, function (pair) {
	            return left - pair.left || right - pair.right;
	          });

	          if (pairIdx >= 0) {
	            val = s.pairs[pairIdx].value;
	          }

	          break;

	        case 2:
	          var leftOffset = 0,
	              rightOffset = 0;
	          if (left >= s.leftTable.firstGlyph && left < s.leftTable.firstGlyph + s.leftTable.nGlyphs) {
	            leftOffset = s.leftTable.offsets[left - s.leftTable.firstGlyph];
	          } else {
	            leftOffset = s.array.off;
	          }

	          if (right >= s.rightTable.firstGlyph && right < s.rightTable.firstGlyph + s.rightTable.nGlyphs) {
	            rightOffset = s.rightTable.offsets[right - s.rightTable.firstGlyph];
	          }

	          var index = (leftOffset + rightOffset - s.array.off) / 2;
	          val = s.array.values.get(index);
	          break;

	        case 3:
	          if (left >= s.glyphCount || right >= s.glyphCount) {
	            return 0;
	          }

	          val = s.kernValue[s.kernIndex[s.leftClass[left] * s.rightClassCount + s.rightClass[right]]];
	          break;

	        default:
	          throw new Error('Unsupported kerning sub-table format ' + table.format);
	      }

	      // Microsoft supports the override flag, which resets the result
	      // Otherwise, the sum of the results from all subtables is returned
	      if (table.coverage.override) {
	        res = val;
	      } else {
	        res += val;
	      }
	    }

	    return res;
	  };

	  return KernProcessor;
	}();

	/**
	 * This class is used when GPOS does not define 'mark' or 'mkmk' features
	 * for positioning marks relative to base glyphs. It uses the unicode
	 * combining class property to position marks.
	 *
	 * Based on code from Harfbuzz, thanks!
	 * https://github.com/behdad/harfbuzz/blob/master/src/hb-ot-shape-fallback.cc
	 */

	var UnicodeLayoutEngine = function () {
	  function UnicodeLayoutEngine(font) {
	    _classCallCheck(this, UnicodeLayoutEngine);

	    this.font = font;
	  }

	  UnicodeLayoutEngine.prototype.positionGlyphs = function positionGlyphs(glyphs, positions) {
	    // find each base + mark cluster, and position the marks relative to the base
	    var clusterStart = 0;
	    var clusterEnd = 0;
	    for (var index = 0; index < glyphs.length; index++) {
	      var glyph = glyphs[index];
	      if (glyph.isMark) {
	        // TODO: handle ligatures
	        clusterEnd = index;
	      } else {
	        if (clusterStart !== clusterEnd) {
	          this.positionCluster(glyphs, positions, clusterStart, clusterEnd);
	        }

	        clusterStart = clusterEnd = index;
	      }
	    }

	    if (clusterStart !== clusterEnd) {
	      this.positionCluster(glyphs, positions, clusterStart, clusterEnd);
	    }

	    return positions;
	  };

	  UnicodeLayoutEngine.prototype.positionCluster = function positionCluster(glyphs, positions, clusterStart, clusterEnd) {
	    var base = glyphs[clusterStart];
	    var baseBox = base.cbox.copy();

	    // adjust bounding box for ligature glyphs
	    if (base.codePoints.length > 1) {
	      // LTR. TODO: RTL support.
	      baseBox.minX += (base.codePoints.length - 1) * baseBox.width / base.codePoints.length;
	    }

	    var xOffset = -positions[clusterStart].xAdvance;
	    var yOffset = 0;
	    var yGap = this.font.unitsPerEm / 16;

	    // position each of the mark glyphs relative to the base glyph
	    for (var index = clusterStart + 1; index <= clusterEnd; index++) {
	      var mark = glyphs[index];
	      var markBox = mark.cbox;
	      var position = positions[index];

	      var combiningClass = this.getCombiningClass(mark.codePoints[0]);

	      if (combiningClass !== 'Not_Reordered') {
	        position.xOffset = position.yOffset = 0;

	        // x positioning
	        switch (combiningClass) {
	          case 'Double_Above':
	          case 'Double_Below':
	            // LTR. TODO: RTL support.
	            position.xOffset += baseBox.minX - markBox.width / 2 - markBox.minX;
	            break;

	          case 'Attached_Below_Left':
	          case 'Below_Left':
	          case 'Above_Left':
	            // left align
	            position.xOffset += baseBox.minX - markBox.minX;
	            break;

	          case 'Attached_Above_Right':
	          case 'Below_Right':
	          case 'Above_Right':
	            // right align
	            position.xOffset += baseBox.maxX - markBox.width - markBox.minX;
	            break;

	          default:
	            // Attached_Below, Attached_Above, Below, Above, other
	            // center align
	            position.xOffset += baseBox.minX + (baseBox.width - markBox.width) / 2 - markBox.minX;
	        }

	        // y positioning
	        switch (combiningClass) {
	          case 'Double_Below':
	          case 'Below_Left':
	          case 'Below':
	          case 'Below_Right':
	          case 'Attached_Below_Left':
	          case 'Attached_Below':
	            // add a small gap between the glyphs if they are not attached
	            if (combiningClass === 'Attached_Below_Left' || combiningClass === 'Attached_Below') {
	              baseBox.minY += yGap;
	            }

	            position.yOffset = -baseBox.minY - markBox.maxY;
	            baseBox.minY += markBox.height;
	            break;

	          case 'Double_Above':
	          case 'Above_Left':
	          case 'Above':
	          case 'Above_Right':
	          case 'Attached_Above':
	          case 'Attached_Above_Right':
	            // add a small gap between the glyphs if they are not attached
	            if (combiningClass === 'Attached_Above' || combiningClass === 'Attached_Above_Right') {
	              baseBox.maxY += yGap;
	            }

	            position.yOffset = baseBox.maxY - markBox.minY;
	            baseBox.maxY += markBox.height;
	            break;
	        }

	        position.xAdvance = position.yAdvance = 0;
	        position.xOffset += xOffset;
	        position.yOffset += yOffset;
	      } else {
	        xOffset -= position.xAdvance;
	        yOffset -= position.yAdvance;
	      }
	    }

	    return;
	  };

	  UnicodeLayoutEngine.prototype.getCombiningClass = function getCombiningClass(codePoint) {
	    var combiningClass = unicode.getCombiningClass(codePoint);

	    // Thai / Lao need some per-character work
	    if ((codePoint & ~0xff) === 0x0e00) {
	      if (combiningClass === 'Not_Reordered') {
	        switch (codePoint) {
	          case 0x0e31:
	          case 0x0e34:
	          case 0x0e35:
	          case 0x0e36:
	          case 0x0e37:
	          case 0x0e47:
	          case 0x0e4c:
	          case 0x0e3d:
	          case 0x0e4e:
	            return 'Above_Right';

	          case 0x0eb1:
	          case 0x0eb4:
	          case 0x0eb5:
	          case 0x0eb6:
	          case 0x0eb7:
	          case 0x0ebb:
	          case 0x0ecc:
	          case 0x0ecd:
	            return 'Above';

	          case 0x0ebc:
	            return 'Below';
	        }
	      } else if (codePoint === 0x0e3a) {
	        // virama
	        return 'Below_Right';
	      }
	    }

	    switch (combiningClass) {
	      // Hebrew

	      case 'CCC10': // sheva
	      case 'CCC11': // hataf segol
	      case 'CCC12': // hataf patah
	      case 'CCC13': // hataf qamats
	      case 'CCC14': // hiriq
	      case 'CCC15': // tsere
	      case 'CCC16': // segol
	      case 'CCC17': // patah
	      case 'CCC18': // qamats
	      case 'CCC20': // qubuts
	      case 'CCC22':
	        // meteg
	        return 'Below';

	      case 'CCC23':
	        // rafe
	        return 'Attached_Above';

	      case 'CCC24':
	        // shin dot
	        return 'Above_Right';

	      case 'CCC25': // sin dot
	      case 'CCC19':
	        // holam
	        return 'Above_Left';

	      case 'CCC26':
	        // point varika
	        return 'Above';

	      case 'CCC21':
	        // dagesh
	        break;

	      // Arabic and Syriac

	      case 'CCC27': // fathatan
	      case 'CCC28': // dammatan
	      case 'CCC30': // fatha
	      case 'CCC31': // damma
	      case 'CCC33': // shadda
	      case 'CCC34': // sukun
	      case 'CCC35': // superscript alef
	      case 'CCC36':
	        // superscript alaph
	        return 'Above';

	      case 'CCC29': // kasratan
	      case 'CCC32':
	        // kasra
	        return 'Below';

	      // Thai

	      case 'CCC103':
	        // sara u / sara uu
	        return 'Below_Right';

	      case 'CCC107':
	        // mai
	        return 'Above_Right';

	      // Lao

	      case 'CCC118':
	        // sign u / sign uu
	        return 'Below';

	      case 'CCC122':
	        // mai
	        return 'Above';

	      // Tibetan

	      case 'CCC129': // sign aa
	      case 'CCC132':
	        // sign u
	        return 'Below';

	      case 'CCC130':
	        // sign i
	        return 'Above';
	    }

	    return combiningClass;
	  };

	  return UnicodeLayoutEngine;
	}();

	/**
	 * Represents a glyph bounding box
	 */
	var BBox = function () {
	  function BBox() {
	    var minX = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Infinity;
	    var minY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Infinity;
	    var maxX = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -Infinity;
	    var maxY = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : -Infinity;

	    _classCallCheck(this, BBox);

	    /**
	     * The minimum X position in the bounding box
	     * @type {number}
	     */
	    this.minX = minX;

	    /**
	     * The minimum Y position in the bounding box
	     * @type {number}
	     */
	    this.minY = minY;

	    /**
	     * The maxmimum X position in the bounding box
	     * @type {number}
	     */
	    this.maxX = maxX;

	    /**
	     * The maxmimum Y position in the bounding box
	     * @type {number}
	     */
	    this.maxY = maxY;
	  }

	  /**
	   * The width of the bounding box
	   * @type {number}
	   */


	  BBox.prototype.addPoint = function addPoint(x, y) {
	    if (Math.abs(x) !== Infinity) {
	      if (x < this.minX) {
	        this.minX = x;
	      }

	      if (x > this.maxX) {
	        this.maxX = x;
	      }
	    }

	    if (Math.abs(y) !== Infinity) {
	      if (y < this.minY) {
	        this.minY = y;
	      }

	      if (y > this.maxY) {
	        this.maxY = y;
	      }
	    }
	  };

	  BBox.prototype.copy = function copy() {
	    return new BBox(this.minX, this.minY, this.maxX, this.maxY);
	  };

	  _createClass(BBox, [{
	    key: "width",
	    get: function get() {
	      return this.maxX - this.minX;
	    }

	    /**
	     * The height of the bounding box
	     * @type {number}
	     */

	  }, {
	    key: "height",
	    get: function get() {
	      return this.maxY - this.minY;
	    }
	  }]);

	  return BBox;
	}();

	// This maps the Unicode Script property to an OpenType script tag
	// Data from http://www.microsoft.com/typography/otspec/scripttags.htm
	// and http://www.unicode.org/Public/UNIDATA/PropertyValueAliases.txt.
	var UNICODE_SCRIPTS = {
	  Caucasian_Albanian: 'aghb',
	  Arabic: 'arab',
	  Imperial_Aramaic: 'armi',
	  Armenian: 'armn',
	  Avestan: 'avst',
	  Balinese: 'bali',
	  Bamum: 'bamu',
	  Bassa_Vah: 'bass',
	  Batak: 'batk',
	  Bengali: ['bng2', 'beng'],
	  Bopomofo: 'bopo',
	  Brahmi: 'brah',
	  Braille: 'brai',
	  Buginese: 'bugi',
	  Buhid: 'buhd',
	  Chakma: 'cakm',
	  Canadian_Aboriginal: 'cans',
	  Carian: 'cari',
	  Cham: 'cham',
	  Cherokee: 'cher',
	  Coptic: 'copt',
	  Cypriot: 'cprt',
	  Cyrillic: 'cyrl',
	  Devanagari: ['dev2', 'deva'],
	  Deseret: 'dsrt',
	  Duployan: 'dupl',
	  Egyptian_Hieroglyphs: 'egyp',
	  Elbasan: 'elba',
	  Ethiopic: 'ethi',
	  Georgian: 'geor',
	  Glagolitic: 'glag',
	  Gothic: 'goth',
	  Grantha: 'gran',
	  Greek: 'grek',
	  Gujarati: ['gjr2', 'gujr'],
	  Gurmukhi: ['gur2', 'guru'],
	  Hangul: 'hang',
	  Han: 'hani',
	  Hanunoo: 'hano',
	  Hebrew: 'hebr',
	  Hiragana: 'hira',
	  Pahawh_Hmong: 'hmng',
	  Katakana_Or_Hiragana: 'hrkt',
	  Old_Italic: 'ital',
	  Javanese: 'java',
	  Kayah_Li: 'kali',
	  Katakana: 'kana',
	  Kharoshthi: 'khar',
	  Khmer: 'khmr',
	  Khojki: 'khoj',
	  Kannada: ['knd2', 'knda'],
	  Kaithi: 'kthi',
	  Tai_Tham: 'lana',
	  Lao: 'lao ',
	  Latin: 'latn',
	  Lepcha: 'lepc',
	  Limbu: 'limb',
	  Linear_A: 'lina',
	  Linear_B: 'linb',
	  Lisu: 'lisu',
	  Lycian: 'lyci',
	  Lydian: 'lydi',
	  Mahajani: 'mahj',
	  Mandaic: 'mand',
	  Manichaean: 'mani',
	  Mende_Kikakui: 'mend',
	  Meroitic_Cursive: 'merc',
	  Meroitic_Hieroglyphs: 'mero',
	  Malayalam: ['mlm2', 'mlym'],
	  Modi: 'modi',
	  Mongolian: 'mong',
	  Mro: 'mroo',
	  Meetei_Mayek: 'mtei',
	  Myanmar: ['mym2', 'mymr'],
	  Old_North_Arabian: 'narb',
	  Nabataean: 'nbat',
	  Nko: 'nko ',
	  Ogham: 'ogam',
	  Ol_Chiki: 'olck',
	  Old_Turkic: 'orkh',
	  Oriya: ['ory2', 'orya'],
	  Osmanya: 'osma',
	  Palmyrene: 'palm',
	  Pau_Cin_Hau: 'pauc',
	  Old_Permic: 'perm',
	  Phags_Pa: 'phag',
	  Inscriptional_Pahlavi: 'phli',
	  Psalter_Pahlavi: 'phlp',
	  Phoenician: 'phnx',
	  Miao: 'plrd',
	  Inscriptional_Parthian: 'prti',
	  Rejang: 'rjng',
	  Runic: 'runr',
	  Samaritan: 'samr',
	  Old_South_Arabian: 'sarb',
	  Saurashtra: 'saur',
	  Shavian: 'shaw',
	  Sharada: 'shrd',
	  Siddham: 'sidd',
	  Khudawadi: 'sind',
	  Sinhala: 'sinh',
	  Sora_Sompeng: 'sora',
	  Sundanese: 'sund',
	  Syloti_Nagri: 'sylo',
	  Syriac: 'syrc',
	  Tagbanwa: 'tagb',
	  Takri: 'takr',
	  Tai_Le: 'tale',
	  New_Tai_Lue: 'talu',
	  Tamil: ['tml2', 'taml'],
	  Tai_Viet: 'tavt',
	  Telugu: ['tel2', 'telu'],
	  Tifinagh: 'tfng',
	  Tagalog: 'tglg',
	  Thaana: 'thaa',
	  Thai: 'thai',
	  Tibetan: 'tibt',
	  Tirhuta: 'tirh',
	  Ugaritic: 'ugar',
	  Vai: 'vai ',
	  Warang_Citi: 'wara',
	  Old_Persian: 'xpeo',
	  Cuneiform: 'xsux',
	  Yi: 'yi  ',
	  Inherited: 'zinh',
	  Common: 'zyyy',
	  Unknown: 'zzzz'
	};

	var OPENTYPE_SCRIPTS = {};
	for (var script in UNICODE_SCRIPTS) {
	  var tag = UNICODE_SCRIPTS[script];
	  if (Array.isArray(tag)) {
	    for (var _iterator = tag, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	      var _ref;

	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }

	      var t = _ref;

	      OPENTYPE_SCRIPTS[t] = script;
	    }
	  } else {
	    OPENTYPE_SCRIPTS[tag] = script;
	  }
	}

	function fromOpenType(tag) {
	  return OPENTYPE_SCRIPTS[tag];
	}

	function forString(string) {
	  var len = string.length;
	  var idx = 0;
	  while (idx < len) {
	    var code = string.charCodeAt(idx++);

	    // Check if this is a high surrogate
	    if (0xd800 <= code && code <= 0xdbff && idx < len) {
	      var next = string.charCodeAt(idx);

	      // Check if this is a low surrogate
	      if (0xdc00 <= next && next <= 0xdfff) {
	        idx++;
	        code = ((code & 0x3FF) << 10) + (next & 0x3FF) + 0x10000;
	      }
	    }

	    var _script = unicode.getScript(code);
	    if (_script !== 'Common' && _script !== 'Inherited' && _script !== 'Unknown') {
	      return UNICODE_SCRIPTS[_script];
	    }
	  }

	  return UNICODE_SCRIPTS.Unknown;
	}

	function forCodePoints(codePoints) {
	  for (var i = 0; i < codePoints.length; i++) {
	    var codePoint = codePoints[i];
	    var _script2 = unicode.getScript(codePoint);
	    if (_script2 !== 'Common' && _script2 !== 'Inherited' && _script2 !== 'Unknown') {
	      return UNICODE_SCRIPTS[_script2];
	    }
	  }

	  return UNICODE_SCRIPTS.Unknown;
	}

	// The scripts in this map are written from right to left
	var RTL = {
	  arab: true, // Arabic
	  hebr: true, // Hebrew
	  syrc: true, // Syriac
	  thaa: true, // Thaana
	  cprt: true, // Cypriot Syllabary
	  khar: true, // Kharosthi
	  phnx: true, // Phoenician
	  'nko ': true, // N'Ko
	  lydi: true, // Lydian
	  avst: true, // Avestan
	  armi: true, // Imperial Aramaic
	  phli: true, // Inscriptional Pahlavi
	  prti: true, // Inscriptional Parthian
	  sarb: true, // Old South Arabian
	  orkh: true, // Old Turkic, Orkhon Runic
	  samr: true, // Samaritan
	  mand: true, // Mandaic, Mandaean
	  merc: true, // Meroitic Cursive
	  mero: true, // Meroitic Hieroglyphs

	  // Unicode 7.0 (not listed on http://www.microsoft.com/typography/otspec/scripttags.htm)
	  mani: true, // Manichaean
	  mend: true, // Mende Kikakui
	  nbat: true, // Nabataean
	  narb: true, // Old North Arabian
	  palm: true, // Palmyrene
	  phlp: true // Psalter Pahlavi
	};

	function direction(script) {
	  if (RTL[script]) {
	    return 'rtl';
	  }

	  return 'ltr';
	}

	/**
	 * Represents a run of Glyph and GlyphPosition objects.
	 * Returned by the font layout method.
	 */

	var GlyphRun = function () {
	  function GlyphRun(glyphs, features, script, language, direction$$) {
	    _classCallCheck(this, GlyphRun);

	    /**
	     * An array of Glyph objects in the run
	     * @type {Glyph[]}
	     */
	    this.glyphs = glyphs;

	    /**
	     * An array of GlyphPosition objects for each glyph in the run
	     * @type {GlyphPosition[]}
	     */
	    this.positions = null;

	    /**
	     * The script that was requested for shaping. This was either passed in or detected automatically.
	     * @type {string}
	     */
	    this.script = script;

	    /**
	     * The language requested for shaping, as passed in. If `null`, the default language for the
	     * script was used.
	     * @type {string}
	     */
	    this.language = language || null;

	    /**
	     * The direction requested for shaping, as passed in (either ltr or rtl).
	     * If `null`, the default direction of the script is used.
	     * @type {string}
	     */
	    this.direction = direction$$ || direction(script);

	    /**
	     * The features requested during shaping. This is a combination of user
	     * specified features and features chosen by the shaper.
	     * @type {object}
	     */
	    this.features = {};

	    // Convert features to an object
	    if (Array.isArray(features)) {
	      for (var _iterator = features, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	        var _ref;

	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }

	        var tag = _ref;

	        this.features[tag] = true;
	      }
	    } else if ((typeof features === 'undefined' ? 'undefined' : _typeof(features)) === 'object') {
	      this.features = features;
	    }
	  }

	  /**
	   * The total advance width of the run.
	   * @type {number}
	   */


	  _createClass(GlyphRun, [{
	    key: 'advanceWidth',
	    get: function get() {
	      var width = 0;
	      for (var _iterator2 = this.positions, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
	        var _ref2;

	        if (_isArray2) {
	          if (_i2 >= _iterator2.length) break;
	          _ref2 = _iterator2[_i2++];
	        } else {
	          _i2 = _iterator2.next();
	          if (_i2.done) break;
	          _ref2 = _i2.value;
	        }

	        var position = _ref2;

	        width += position.xAdvance;
	      }

	      return width;
	    }

	    /**
	     * The total advance height of the run.
	     * @type {number}
	     */

	  }, {
	    key: 'advanceHeight',
	    get: function get() {
	      var height = 0;
	      for (var _iterator3 = this.positions, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
	        var _ref3;

	        if (_isArray3) {
	          if (_i3 >= _iterator3.length) break;
	          _ref3 = _iterator3[_i3++];
	        } else {
	          _i3 = _iterator3.next();
	          if (_i3.done) break;
	          _ref3 = _i3.value;
	        }

	        var position = _ref3;

	        height += position.yAdvance;
	      }

	      return height;
	    }

	    /**
	     * The bounding box containing all glyphs in the run.
	     * @type {BBox}
	     */

	  }, {
	    key: 'bbox',
	    get: function get() {
	      var bbox = new BBox();

	      var x = 0;
	      var y = 0;
	      for (var index = 0; index < this.glyphs.length; index++) {
	        var glyph = this.glyphs[index];
	        var p = this.positions[index];
	        var b = glyph.bbox;

	        bbox.addPoint(b.minX + x + p.xOffset, b.minY + y + p.yOffset);
	        bbox.addPoint(b.maxX + x + p.xOffset, b.maxY + y + p.yOffset);

	        x += p.xAdvance;
	        y += p.yAdvance;
	      }

	      return bbox;
	    }
	  }]);

	  return GlyphRun;
	}();

	/**
	 * Represents positioning information for a glyph in a GlyphRun.
	 */
	var GlyphPosition = function GlyphPosition() {
	  var xAdvance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	  var yAdvance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  var xOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	  var yOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

	  _classCallCheck(this, GlyphPosition);

	  /**
	   * The amount to move the virtual pen in the X direction after rendering this glyph.
	   * @type {number}
	   */
	  this.xAdvance = xAdvance;

	  /**
	   * The amount to move the virtual pen in the Y direction after rendering this glyph.
	   * @type {number}
	   */
	  this.yAdvance = yAdvance;

	  /**
	   * The offset from the pen position in the X direction at which to render this glyph.
	   * @type {number}
	   */
	  this.xOffset = xOffset;

	  /**
	   * The offset from the pen position in the Y direction at which to render this glyph.
	   * @type {number}
	   */
	  this.yOffset = yOffset;
	};

	// see https://developer.apple.com/fonts/TrueType-Reference-Manual/RM09/AppendixF.html
	// and /System/Library/Frameworks/CoreText.framework/Versions/A/Headers/SFNTLayoutTypes.h on a Mac
	var features = {
	  allTypographicFeatures: {
	    code: 0,
	    exclusive: false,
	    allTypeFeatures: 0
	  },
	  ligatures: {
	    code: 1,
	    exclusive: false,
	    requiredLigatures: 0,
	    commonLigatures: 2,
	    rareLigatures: 4,
	    // logos: 6
	    rebusPictures: 8,
	    diphthongLigatures: 10,
	    squaredLigatures: 12,
	    abbrevSquaredLigatures: 14,
	    symbolLigatures: 16,
	    contextualLigatures: 18,
	    historicalLigatures: 20
	  },
	  cursiveConnection: {
	    code: 2,
	    exclusive: true,
	    unconnected: 0,
	    partiallyConnected: 1,
	    cursive: 2
	  },
	  letterCase: {
	    code: 3,
	    exclusive: true
	  },
	  // upperAndLowerCase: 0          # deprecated
	  // allCaps: 1                    # deprecated
	  // allLowerCase: 2               # deprecated
	  // smallCaps: 3                  # deprecated
	  // initialCaps: 4                # deprecated
	  // initialCapsAndSmallCaps: 5    # deprecated
	  verticalSubstitution: {
	    code: 4,
	    exclusive: false,
	    substituteVerticalForms: 0
	  },
	  linguisticRearrangement: {
	    code: 5,
	    exclusive: false,
	    linguisticRearrangement: 0
	  },
	  numberSpacing: {
	    code: 6,
	    exclusive: true,
	    monospacedNumbers: 0,
	    proportionalNumbers: 1,
	    thirdWidthNumbers: 2,
	    quarterWidthNumbers: 3
	  },
	  smartSwash: {
	    code: 8,
	    exclusive: false,
	    wordInitialSwashes: 0,
	    wordFinalSwashes: 2,
	    // lineInitialSwashes: 4
	    // lineFinalSwashes: 6
	    nonFinalSwashes: 8
	  },
	  diacritics: {
	    code: 9,
	    exclusive: true,
	    showDiacritics: 0,
	    hideDiacritics: 1,
	    decomposeDiacritics: 2
	  },
	  verticalPosition: {
	    code: 10,
	    exclusive: true,
	    normalPosition: 0,
	    superiors: 1,
	    inferiors: 2,
	    ordinals: 3,
	    scientificInferiors: 4
	  },
	  fractions: {
	    code: 11,
	    exclusive: true,
	    noFractions: 0,
	    verticalFractions: 1,
	    diagonalFractions: 2
	  },
	  overlappingCharacters: {
	    code: 13,
	    exclusive: false,
	    preventOverlap: 0
	  },
	  typographicExtras: {
	    code: 14,
	    exclusive: false,
	    // hyphensToEmDash: 0
	    // hyphenToEnDash: 2
	    slashedZero: 4
	  },
	  // formInterrobang: 6
	  // smartQuotes: 8
	  // periodsToEllipsis: 10
	  mathematicalExtras: {
	    code: 15,
	    exclusive: false,
	    // hyphenToMinus: 0
	    // asteristoMultiply: 2
	    // slashToDivide: 4
	    // inequalityLigatures: 6
	    // exponents: 8
	    mathematicalGreek: 10
	  },
	  ornamentSets: {
	    code: 16,
	    exclusive: true,
	    noOrnaments: 0,
	    dingbats: 1,
	    piCharacters: 2,
	    fleurons: 3,
	    decorativeBorders: 4,
	    internationalSymbols: 5,
	    mathSymbols: 6
	  },
	  characterAlternatives: {
	    code: 17,
	    exclusive: true,
	    noAlternates: 0
	  },
	  // user defined options
	  designComplexity: {
	    code: 18,
	    exclusive: true,
	    designLevel1: 0,
	    designLevel2: 1,
	    designLevel3: 2,
	    designLevel4: 3,
	    designLevel5: 4
	  },
	  styleOptions: {
	    code: 19,
	    exclusive: true,
	    noStyleOptions: 0,
	    displayText: 1,
	    engravedText: 2,
	    illuminatedCaps: 3,
	    titlingCaps: 4,
	    tallCaps: 5
	  },
	  characterShape: {
	    code: 20,
	    exclusive: true,
	    traditionalCharacters: 0,
	    simplifiedCharacters: 1,
	    JIS1978Characters: 2,
	    JIS1983Characters: 3,
	    JIS1990Characters: 4,
	    traditionalAltOne: 5,
	    traditionalAltTwo: 6,
	    traditionalAltThree: 7,
	    traditionalAltFour: 8,
	    traditionalAltFive: 9,
	    expertCharacters: 10,
	    JIS2004Characters: 11,
	    hojoCharacters: 12,
	    NLCCharacters: 13,
	    traditionalNamesCharacters: 14
	  },
	  numberCase: {
	    code: 21,
	    exclusive: true,
	    lowerCaseNumbers: 0,
	    upperCaseNumbers: 1
	  },
	  textSpacing: {
	    code: 22,
	    exclusive: true,
	    proportionalText: 0,
	    monospacedText: 1,
	    halfWidthText: 2,
	    thirdWidthText: 3,
	    quarterWidthText: 4,
	    altProportionalText: 5,
	    altHalfWidthText: 6
	  },
	  transliteration: {
	    code: 23,
	    exclusive: true,
	    noTransliteration: 0
	  },
	  // hanjaToHangul: 1
	  // hiraganaToKatakana: 2
	  // katakanaToHiragana: 3
	  // kanaToRomanization: 4
	  // romanizationToHiragana: 5
	  // romanizationToKatakana: 6
	  // hanjaToHangulAltOne: 7
	  // hanjaToHangulAltTwo: 8
	  // hanjaToHangulAltThree: 9
	  annotation: {
	    code: 24,
	    exclusive: true,
	    noAnnotation: 0,
	    boxAnnotation: 1,
	    roundedBoxAnnotation: 2,
	    circleAnnotation: 3,
	    invertedCircleAnnotation: 4,
	    parenthesisAnnotation: 5,
	    periodAnnotation: 6,
	    romanNumeralAnnotation: 7,
	    diamondAnnotation: 8,
	    invertedBoxAnnotation: 9,
	    invertedRoundedBoxAnnotation: 10
	  },
	  kanaSpacing: {
	    code: 25,
	    exclusive: true,
	    fullWidthKana: 0,
	    proportionalKana: 1
	  },
	  ideographicSpacing: {
	    code: 26,
	    exclusive: true,
	    fullWidthIdeographs: 0,
	    proportionalIdeographs: 1,
	    halfWidthIdeographs: 2
	  },
	  unicodeDecomposition: {
	    code: 27,
	    exclusive: false,
	    canonicalComposition: 0,
	    compatibilityComposition: 2,
	    transcodingComposition: 4
	  },
	  rubyKana: {
	    code: 28,
	    exclusive: false,
	    // noRubyKana: 0     # deprecated - use rubyKanaOff instead
	    // rubyKana: 1     # deprecated - use rubyKanaOn instead
	    rubyKana: 2
	  },
	  CJKSymbolAlternatives: {
	    code: 29,
	    exclusive: true,
	    noCJKSymbolAlternatives: 0,
	    CJKSymbolAltOne: 1,
	    CJKSymbolAltTwo: 2,
	    CJKSymbolAltThree: 3,
	    CJKSymbolAltFour: 4,
	    CJKSymbolAltFive: 5
	  },
	  ideographicAlternatives: {
	    code: 30,
	    exclusive: true,
	    noIdeographicAlternatives: 0,
	    ideographicAltOne: 1,
	    ideographicAltTwo: 2,
	    ideographicAltThree: 3,
	    ideographicAltFour: 4,
	    ideographicAltFive: 5
	  },
	  CJKVerticalRomanPlacement: {
	    code: 31,
	    exclusive: true,
	    CJKVerticalRomanCentered: 0,
	    CJKVerticalRomanHBaseline: 1
	  },
	  italicCJKRoman: {
	    code: 32,
	    exclusive: false,
	    // noCJKItalicRoman: 0     # deprecated - use CJKItalicRomanOff instead
	    // CJKItalicRoman: 1     # deprecated - use CJKItalicRomanOn instead
	    CJKItalicRoman: 2
	  },
	  caseSensitiveLayout: {
	    code: 33,
	    exclusive: false,
	    caseSensitiveLayout: 0,
	    caseSensitiveSpacing: 2
	  },
	  alternateKana: {
	    code: 34,
	    exclusive: false,
	    alternateHorizKana: 0,
	    alternateVertKana: 2
	  },
	  stylisticAlternatives: {
	    code: 35,
	    exclusive: false,
	    noStylisticAlternates: 0,
	    stylisticAltOne: 2,
	    stylisticAltTwo: 4,
	    stylisticAltThree: 6,
	    stylisticAltFour: 8,
	    stylisticAltFive: 10,
	    stylisticAltSix: 12,
	    stylisticAltSeven: 14,
	    stylisticAltEight: 16,
	    stylisticAltNine: 18,
	    stylisticAltTen: 20,
	    stylisticAltEleven: 22,
	    stylisticAltTwelve: 24,
	    stylisticAltThirteen: 26,
	    stylisticAltFourteen: 28,
	    stylisticAltFifteen: 30,
	    stylisticAltSixteen: 32,
	    stylisticAltSeventeen: 34,
	    stylisticAltEighteen: 36,
	    stylisticAltNineteen: 38,
	    stylisticAltTwenty: 40
	  },
	  contextualAlternates: {
	    code: 36,
	    exclusive: false,
	    contextualAlternates: 0,
	    swashAlternates: 2,
	    contextualSwashAlternates: 4
	  },
	  lowerCase: {
	    code: 37,
	    exclusive: true,
	    defaultLowerCase: 0,
	    lowerCaseSmallCaps: 1,
	    lowerCasePetiteCaps: 2
	  },
	  upperCase: {
	    code: 38,
	    exclusive: true,
	    defaultUpperCase: 0,
	    upperCaseSmallCaps: 1,
	    upperCasePetiteCaps: 2
	  },
	  languageTag: { // indices into ltag table
	    code: 39,
	    exclusive: true
	  },
	  CJKRomanSpacing: {
	    code: 103,
	    exclusive: true,
	    halfWidthCJKRoman: 0,
	    proportionalCJKRoman: 1,
	    defaultCJKRoman: 2,
	    fullWidthCJKRoman: 3
	  }
	};

	var feature = function feature(name, selector) {
	  return [features[name].code, features[name][selector]];
	};

	var OTMapping = {
	  rlig: feature('ligatures', 'requiredLigatures'),
	  clig: feature('ligatures', 'contextualLigatures'),
	  dlig: feature('ligatures', 'rareLigatures'),
	  hlig: feature('ligatures', 'historicalLigatures'),
	  liga: feature('ligatures', 'commonLigatures'),
	  hist: feature('ligatures', 'historicalLigatures'), // ??

	  smcp: feature('lowerCase', 'lowerCaseSmallCaps'),
	  pcap: feature('lowerCase', 'lowerCasePetiteCaps'),

	  frac: feature('fractions', 'diagonalFractions'),
	  dnom: feature('fractions', 'diagonalFractions'), // ??
	  numr: feature('fractions', 'diagonalFractions'), // ??
	  afrc: feature('fractions', 'verticalFractions'),
	  // aalt
	  // abvf, abvm, abvs, akhn, blwf, blwm, blws, cfar, cjct, cpsp, falt, isol, jalt, ljmo, mset?
	  // ltra, ltrm, nukt, pref, pres, pstf, psts, rand, rkrf, rphf, rtla, rtlm, size, tjmo, tnum?
	  // unic, vatu, vhal, vjmo, vpal, vrt2
	  // dist -> trak table?
	  // kern, vkrn -> kern table
	  // lfbd + opbd + rtbd -> opbd table?
	  // mark, mkmk -> acnt table?
	  // locl -> languageTag + ltag table

	  case: feature('caseSensitiveLayout', 'caseSensitiveLayout'), // also caseSensitiveSpacing
	  ccmp: feature('unicodeDecomposition', 'canonicalComposition'), // compatibilityComposition?
	  cpct: feature('CJKVerticalRomanPlacement', 'CJKVerticalRomanCentered'), // guess..., probably not given below
	  valt: feature('CJKVerticalRomanPlacement', 'CJKVerticalRomanCentered'),
	  swsh: feature('contextualAlternates', 'swashAlternates'),
	  cswh: feature('contextualAlternates', 'contextualSwashAlternates'),
	  curs: feature('cursiveConnection', 'cursive'), // ??
	  c2pc: feature('upperCase', 'upperCasePetiteCaps'),
	  c2sc: feature('upperCase', 'upperCaseSmallCaps'),

	  init: feature('smartSwash', 'wordInitialSwashes'), // ??
	  fin2: feature('smartSwash', 'wordFinalSwashes'), // ??
	  medi: feature('smartSwash', 'nonFinalSwashes'), // ??
	  med2: feature('smartSwash', 'nonFinalSwashes'), // ??
	  fin3: feature('smartSwash', 'wordFinalSwashes'), // ??
	  fina: feature('smartSwash', 'wordFinalSwashes'), // ??

	  pkna: feature('kanaSpacing', 'proportionalKana'),
	  half: feature('textSpacing', 'halfWidthText'), // also HalfWidthCJKRoman, HalfWidthIdeographs?
	  halt: feature('textSpacing', 'altHalfWidthText'),

	  hkna: feature('alternateKana', 'alternateHorizKana'),
	  vkna: feature('alternateKana', 'alternateVertKana'),
	  // hngl: feature 'transliteration', 'hanjaToHangulSelector' # deprecated

	  ital: feature('italicCJKRoman', 'CJKItalicRoman'),
	  lnum: feature('numberCase', 'upperCaseNumbers'),
	  onum: feature('numberCase', 'lowerCaseNumbers'),
	  mgrk: feature('mathematicalExtras', 'mathematicalGreek'),

	  // nalt: not enough info. what type of annotation?
	  // ornm: ditto, which ornament style?

	  calt: feature('contextualAlternates', 'contextualAlternates'), // or more?
	  vrt2: feature('verticalSubstitution', 'substituteVerticalForms'), // oh... below?
	  vert: feature('verticalSubstitution', 'substituteVerticalForms'),
	  tnum: feature('numberSpacing', 'monospacedNumbers'),
	  pnum: feature('numberSpacing', 'proportionalNumbers'),
	  sups: feature('verticalPosition', 'superiors'),
	  subs: feature('verticalPosition', 'inferiors'),
	  ordn: feature('verticalPosition', 'ordinals'),
	  pwid: feature('textSpacing', 'proportionalText'),
	  hwid: feature('textSpacing', 'halfWidthText'),
	  qwid: feature('textSpacing', 'quarterWidthText'), // also QuarterWidthNumbers?
	  twid: feature('textSpacing', 'thirdWidthText'), // also ThirdWidthNumbers?
	  fwid: feature('textSpacing', 'proportionalText'), //??
	  palt: feature('textSpacing', 'altProportionalText'),
	  trad: feature('characterShape', 'traditionalCharacters'),
	  smpl: feature('characterShape', 'simplifiedCharacters'),
	  jp78: feature('characterShape', 'JIS1978Characters'),
	  jp83: feature('characterShape', 'JIS1983Characters'),
	  jp90: feature('characterShape', 'JIS1990Characters'),
	  jp04: feature('characterShape', 'JIS2004Characters'),
	  expt: feature('characterShape', 'expertCharacters'),
	  hojo: feature('characterShape', 'hojoCharacters'),
	  nlck: feature('characterShape', 'NLCCharacters'),
	  tnam: feature('characterShape', 'traditionalNamesCharacters'),
	  ruby: feature('rubyKana', 'rubyKana'),
	  titl: feature('styleOptions', 'titlingCaps'),
	  zero: feature('typographicExtras', 'slashedZero'),

	  ss01: feature('stylisticAlternatives', 'stylisticAltOne'),
	  ss02: feature('stylisticAlternatives', 'stylisticAltTwo'),
	  ss03: feature('stylisticAlternatives', 'stylisticAltThree'),
	  ss04: feature('stylisticAlternatives', 'stylisticAltFour'),
	  ss05: feature('stylisticAlternatives', 'stylisticAltFive'),
	  ss06: feature('stylisticAlternatives', 'stylisticAltSix'),
	  ss07: feature('stylisticAlternatives', 'stylisticAltSeven'),
	  ss08: feature('stylisticAlternatives', 'stylisticAltEight'),
	  ss09: feature('stylisticAlternatives', 'stylisticAltNine'),
	  ss10: feature('stylisticAlternatives', 'stylisticAltTen'),
	  ss11: feature('stylisticAlternatives', 'stylisticAltEleven'),
	  ss12: feature('stylisticAlternatives', 'stylisticAltTwelve'),
	  ss13: feature('stylisticAlternatives', 'stylisticAltThirteen'),
	  ss14: feature('stylisticAlternatives', 'stylisticAltFourteen'),
	  ss15: feature('stylisticAlternatives', 'stylisticAltFifteen'),
	  ss16: feature('stylisticAlternatives', 'stylisticAltSixteen'),
	  ss17: feature('stylisticAlternatives', 'stylisticAltSeventeen'),
	  ss18: feature('stylisticAlternatives', 'stylisticAltEighteen'),
	  ss19: feature('stylisticAlternatives', 'stylisticAltNineteen'),
	  ss20: feature('stylisticAlternatives', 'stylisticAltTwenty')
	};

	// salt: feature 'stylisticAlternatives', 'stylisticAltOne' # hmm, which one to choose

	// Add cv01-cv99 features
	for (var i = 1; i <= 99; i++) {
	  OTMapping['cv' + ('00' + i).slice(-2)] = [features.characterAlternatives.code, i];
	}

	// create inverse mapping
	var AATMapping = {};
	for (var ot in OTMapping) {
	  var aat = OTMapping[ot];
	  if (AATMapping[aat[0]] == null) {
	    AATMapping[aat[0]] = {};
	  }

	  AATMapping[aat[0]][aat[1]] = ot;
	}

	// Maps an array of OpenType features to AAT features
	// in the form of {featureType:{featureSetting:true}}
	function mapOTToAAT(features) {
	  var res = {};
	  for (var k in features) {
	    var r = void 0;
	    if (r = OTMapping[k]) {
	      if (res[r[0]] == null) {
	        res[r[0]] = {};
	      }

	      res[r[0]][r[1]] = features[k];
	    }
	  }

	  return res;
	}

	// Maps strings in a [featureType, featureSetting]
	// to their equivalent number codes
	function mapFeatureStrings(f) {
	  var type = f[0],
	      setting = f[1];

	  if (isNaN(type)) {
	    var typeCode = features[type] && features[type].code;
	  } else {
	    var typeCode = type;
	  }

	  if (isNaN(setting)) {
	    var settingCode = features[type] && features[type][setting];
	  } else {
	    var settingCode = setting;
	  }

	  return [typeCode, settingCode];
	}

	// Maps AAT features to an array of OpenType features
	// Supports both arrays in the form of [[featureType, featureSetting]]
	// and objects in the form of {featureType:{featureSetting:true}}
	// featureTypes and featureSettings can be either strings or number codes
	function mapAATToOT(features) {
	  var res = {};
	  if (Array.isArray(features)) {
	    for (var k = 0; k < features.length; k++) {
	      var r = void 0;
	      var f = mapFeatureStrings(features[k]);
	      if (r = AATMapping[f[0]] && AATMapping[f[0]][f[1]]) {
	        res[r] = true;
	      }
	    }
	  } else if ((typeof features === 'undefined' ? 'undefined' : _typeof(features)) === 'object') {
	    for (var type in features) {
	      var _feature = features[type];
	      for (var setting in _feature) {
	        var _r = void 0;
	        var _f = mapFeatureStrings([type, setting]);
	        if (_feature[setting] && (_r = AATMapping[_f[0]] && AATMapping[_f[0]][_f[1]])) {
	          res[_r] = true;
	        }
	      }
	    }
	  }

	  return _Object$keys(res);
	}

	var _class$3;
	function _applyDecoratedDescriptor$3(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;

	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }

	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);

	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }

	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }

	  return desc;
	}

	var AATLookupTable = (_class$3 = function () {
	  function AATLookupTable(table) {
	    _classCallCheck(this, AATLookupTable);

	    this.table = table;
	  }

	  AATLookupTable.prototype.lookup = function lookup(glyph) {
	    switch (this.table.version) {
	      case 0:
	        // simple array format
	        return this.table.values.getItem(glyph);

	      case 2: // segment format
	      case 4:
	        {
	          var min = 0;
	          var max = this.table.binarySearchHeader.nUnits - 1;

	          while (min <= max) {
	            var mid = min + max >> 1;
	            var seg = this.table.segments[mid];

	            // special end of search value
	            if (seg.firstGlyph === 0xffff) {
	              return null;
	            }

	            if (glyph < seg.firstGlyph) {
	              max = mid - 1;
	            } else if (glyph > seg.lastGlyph) {
	              min = mid + 1;
	            } else {
	              if (this.table.version === 2) {
	                return seg.value;
	              } else {
	                return seg.values[glyph - seg.firstGlyph];
	              }
	            }
	          }

	          return null;
	        }

	      case 6:
	        {
	          // lookup single
	          var _min = 0;
	          var _max = this.table.binarySearchHeader.nUnits - 1;

	          while (_min <= _max) {
	            var mid = _min + _max >> 1;
	            var seg = this.table.segments[mid];

	            // special end of search value
	            if (seg.glyph === 0xffff) {
	              return null;
	            }

	            if (glyph < seg.glyph) {
	              _max = mid - 1;
	            } else if (glyph > seg.glyph) {
	              _min = mid + 1;
	            } else {
	              return seg.value;
	            }
	          }

	          return null;
	        }

	      case 8:
	        // lookup trimmed
	        return this.table.values[glyph - this.table.firstGlyph];

	      default:
	        throw new Error('Unknown lookup table format: ' + this.table.version);
	    }
	  };

	  AATLookupTable.prototype.glyphsForValue = function glyphsForValue(classValue) {
	    var res = [];

	    switch (this.table.version) {
	      case 2: // segment format
	      case 4:
	        {
	          for (var _iterator = this.table.segments, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	            var _ref;

	            if (_isArray) {
	              if (_i >= _iterator.length) break;
	              _ref = _iterator[_i++];
	            } else {
	              _i = _iterator.next();
	              if (_i.done) break;
	              _ref = _i.value;
	            }

	            var segment = _ref;

	            if (this.table.version === 2 && segment.value === classValue) {
	              res.push.apply(res, range(segment.firstGlyph, segment.lastGlyph + 1));
	            } else {
	              for (var index = 0; index < segment.values.length; index++) {
	                if (segment.values[index] === classValue) {
	                  res.push(segment.firstGlyph + index);
	                }
	              }
	            }
	          }

	          break;
	        }

	      case 6:
	        {
	          // lookup single
	          for (var _iterator2 = this.table.segments, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
	            var _ref2;

	            if (_isArray2) {
	              if (_i2 >= _iterator2.length) break;
	              _ref2 = _iterator2[_i2++];
	            } else {
	              _i2 = _iterator2.next();
	              if (_i2.done) break;
	              _ref2 = _i2.value;
	            }

	            var _segment = _ref2;

	            if (_segment.value === classValue) {
	              res.push(_segment.glyph);
	            }
	          }

	          break;
	        }

	      case 8:
	        {
	          // lookup trimmed
	          for (var i = 0; i < this.table.values.length; i++) {
	            if (this.table.values[i] === classValue) {
	              res.push(this.table.firstGlyph + i);
	            }
	          }

	          break;
	        }

	      default:
	        throw new Error('Unknown lookup table format: ' + this.table.version);
	    }

	    return res;
	  };

	  return AATLookupTable;
	}(), (_applyDecoratedDescriptor$3(_class$3.prototype, 'glyphsForValue', [cache], _Object$getOwnPropertyDescriptor(_class$3.prototype, 'glyphsForValue'), _class$3.prototype)), _class$3);

	var START_OF_TEXT_STATE = 0;
	var END_OF_TEXT_CLASS = 0;
	var OUT_OF_BOUNDS_CLASS = 1;
	var DELETED_GLYPH_CLASS = 2;
	var DONT_ADVANCE = 0x4000;

	var AATStateMachine = function () {
	  function AATStateMachine(stateTable) {
	    _classCallCheck(this, AATStateMachine);

	    this.stateTable = stateTable;
	    this.lookupTable = new AATLookupTable(stateTable.classTable);
	  }

	  AATStateMachine.prototype.process = function process(glyphs, reverse, processEntry) {
	    var currentState = START_OF_TEXT_STATE; // START_OF_LINE_STATE is used for kashida glyph insertions sometimes I think?
	    var index = reverse ? glyphs.length - 1 : 0;
	    var dir = reverse ? -1 : 1;

	    while (dir === 1 && index <= glyphs.length || dir === -1 && index >= -1) {
	      var glyph = null;
	      var classCode = OUT_OF_BOUNDS_CLASS;
	      var shouldAdvance = true;

	      if (index === glyphs.length || index === -1) {
	        classCode = END_OF_TEXT_CLASS;
	      } else {
	        glyph = glyphs[index];
	        if (glyph.id === 0xffff) {
	          // deleted glyph
	          classCode = DELETED_GLYPH_CLASS;
	        } else {
	          classCode = this.lookupTable.lookup(glyph.id);
	          if (classCode == null) {
	            classCode = OUT_OF_BOUNDS_CLASS;
	          }
	        }
	      }

	      var row = this.stateTable.stateArray.getItem(currentState);
	      var entryIndex = row[classCode];
	      var entry = this.stateTable.entryTable.getItem(entryIndex);

	      if (classCode !== END_OF_TEXT_CLASS && classCode !== DELETED_GLYPH_CLASS) {
	        processEntry(glyph, entry, index);
	        shouldAdvance = !(entry.flags & DONT_ADVANCE);
	      }

	      currentState = entry.newState;
	      if (shouldAdvance) {
	        index += dir;
	      }
	    }

	    return glyphs;
	  };

	  /**
	   * Performs a depth-first traversal of the glyph strings
	   * represented by the state machine.
	   */


	  AATStateMachine.prototype.traverse = function traverse(opts) {
	    var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    var visited = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new _Set();

	    if (visited.has(state)) {
	      return;
	    }

	    visited.add(state);

	    var _stateTable = this.stateTable,
	        nClasses = _stateTable.nClasses,
	        stateArray = _stateTable.stateArray,
	        entryTable = _stateTable.entryTable;

	    var row = stateArray.getItem(state);

	    // Skip predefined classes
	    for (var classCode = 4; classCode < nClasses; classCode++) {
	      var entryIndex = row[classCode];
	      var entry = entryTable.getItem(entryIndex);

	      // Try all glyphs in the class
	      for (var _iterator = this.lookupTable.glyphsForValue(classCode), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	        var _ref;

	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }

	        var glyph = _ref;

	        if (opts.enter) {
	          opts.enter(glyph, entry);
	        }

	        if (entry.newState !== 0) {
	          this.traverse(opts, entry.newState, visited);
	        }

	        if (opts.exit) {
	          opts.exit(glyph, entry);
	        }
	      }
	    }
	  };

	  return AATStateMachine;
	}();

	var _class$2;
	function _applyDecoratedDescriptor$2(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;

	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }

	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);

	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }

	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }

	  return desc;
	}

	// indic replacement flags
	var MARK_FIRST = 0x8000;
	var MARK_LAST = 0x2000;
	var VERB = 0x000F;

	// contextual substitution and glyph insertion flag
	var SET_MARK = 0x8000;

	// ligature entry flags
	var SET_COMPONENT = 0x8000;
	var PERFORM_ACTION = 0x2000;

	// ligature action masks
	var LAST_MASK = 0x80000000;
	var STORE_MASK = 0x40000000;
	var OFFSET_MASK = 0x3FFFFFFF;

	var REVERSE_DIRECTION = 0x400000;
	var CURRENT_INSERT_BEFORE = 0x0800;
	var MARKED_INSERT_BEFORE = 0x0400;
	var CURRENT_INSERT_COUNT = 0x03E0;
	var MARKED_INSERT_COUNT = 0x001F;

	var AATMorxProcessor = (_class$2 = function () {
	  function AATMorxProcessor(font) {
	    _classCallCheck(this, AATMorxProcessor);

	    this.processIndicRearragement = this.processIndicRearragement.bind(this);
	    this.processContextualSubstitution = this.processContextualSubstitution.bind(this);
	    this.processLigature = this.processLigature.bind(this);
	    this.processNoncontextualSubstitutions = this.processNoncontextualSubstitutions.bind(this);
	    this.processGlyphInsertion = this.processGlyphInsertion.bind(this);
	    this.font = font;
	    this.morx = font.morx;
	    this.inputCache = null;
	  }

	  // Processes an array of glyphs and applies the specified features
	  // Features should be in the form of {featureType:{featureSetting:true}}


	  AATMorxProcessor.prototype.process = function process(glyphs) {
	    var features = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	    for (var _iterator = this.morx.chains, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	      var _ref;

	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }

	      var chain = _ref;

	      var flags = chain.defaultFlags;

	      // enable/disable the requested features
	      for (var _iterator2 = chain.features, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
	        var _ref2;

	        if (_isArray2) {
	          if (_i2 >= _iterator2.length) break;
	          _ref2 = _iterator2[_i2++];
	        } else {
	          _i2 = _iterator2.next();
	          if (_i2.done) break;
	          _ref2 = _i2.value;
	        }

	        var feature = _ref2;

	        var f = void 0;
	        if ((f = features[feature.featureType]) && f[feature.featureSetting]) {
	          flags &= feature.disableFlags;
	          flags |= feature.enableFlags;
	        }
	      }

	      for (var _iterator3 = chain.subtables, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
	        var _ref3;

	        if (_isArray3) {
	          if (_i3 >= _iterator3.length) break;
	          _ref3 = _iterator3[_i3++];
	        } else {
	          _i3 = _iterator3.next();
	          if (_i3.done) break;
	          _ref3 = _i3.value;
	        }

	        var subtable = _ref3;

	        if (subtable.subFeatureFlags & flags) {
	          this.processSubtable(subtable, glyphs);
	        }
	      }
	    }

	    // remove deleted glyphs
	    var index = glyphs.length - 1;
	    while (index >= 0) {
	      if (glyphs[index].id === 0xffff) {
	        glyphs.splice(index, 1);
	      }

	      index--;
	    }

	    return glyphs;
	  };

	  AATMorxProcessor.prototype.processSubtable = function processSubtable(subtable, glyphs) {
	    this.subtable = subtable;
	    this.glyphs = glyphs;
	    if (this.subtable.type === 4) {
	      this.processNoncontextualSubstitutions(this.subtable, this.glyphs);
	      return;
	    }

	    this.ligatureStack = [];
	    this.markedGlyph = null;
	    this.firstGlyph = null;
	    this.lastGlyph = null;
	    this.markedIndex = null;

	    var stateMachine = this.getStateMachine(subtable);
	    var process = this.getProcessor();

	    var reverse = !!(this.subtable.coverage & REVERSE_DIRECTION);
	    return stateMachine.process(this.glyphs, reverse, process);
	  };

	  AATMorxProcessor.prototype.getStateMachine = function getStateMachine(subtable) {
	    return new AATStateMachine(subtable.table.stateTable);
	  };

	  AATMorxProcessor.prototype.getProcessor = function getProcessor() {
	    switch (this.subtable.type) {
	      case 0:
	        return this.processIndicRearragement;
	      case 1:
	        return this.processContextualSubstitution;
	      case 2:
	        return this.processLigature;
	      case 4:
	        return this.processNoncontextualSubstitutions;
	      case 5:
	        return this.processGlyphInsertion;
	      default:
	        throw new Error('Invalid morx subtable type: ' + this.subtable.type);
	    }
	  };

	  AATMorxProcessor.prototype.processIndicRearragement = function processIndicRearragement(glyph, entry, index) {
	    if (entry.flags & MARK_FIRST) {
	      this.firstGlyph = index;
	    }

	    if (entry.flags & MARK_LAST) {
	      this.lastGlyph = index;
	    }

	    reorderGlyphs(this.glyphs, entry.flags & VERB, this.firstGlyph, this.lastGlyph);
	  };

	  AATMorxProcessor.prototype.processContextualSubstitution = function processContextualSubstitution(glyph, entry, index) {
	    var subsitutions = this.subtable.table.substitutionTable.items;
	    if (entry.markIndex !== 0xffff) {
	      var lookup = subsitutions.getItem(entry.markIndex);
	      var lookupTable = new AATLookupTable(lookup);
	      glyph = this.glyphs[this.markedGlyph];
	      var gid = lookupTable.lookup(glyph.id);
	      if (gid) {
	        this.glyphs[this.markedGlyph] = this.font.getGlyph(gid, glyph.codePoints);
	      }
	    }

	    if (entry.currentIndex !== 0xffff) {
	      var _lookup = subsitutions.getItem(entry.currentIndex);
	      var _lookupTable = new AATLookupTable(_lookup);
	      glyph = this.glyphs[index];
	      var gid = _lookupTable.lookup(glyph.id);
	      if (gid) {
	        this.glyphs[index] = this.font.getGlyph(gid, glyph.codePoints);
	      }
	    }

	    if (entry.flags & SET_MARK) {
	      this.markedGlyph = index;
	    }
	  };

	  AATMorxProcessor.prototype.processLigature = function processLigature(glyph, entry, index) {
	    if (entry.flags & SET_COMPONENT) {
	      this.ligatureStack.push(index);
	    }

	    if (entry.flags & PERFORM_ACTION) {
	      var _ligatureStack;

	      var actions = this.subtable.table.ligatureActions;
	      var components = this.subtable.table.components;
	      var ligatureList = this.subtable.table.ligatureList;

	      var actionIndex = entry.action;
	      var last = false;
	      var ligatureIndex = 0;
	      var codePoints = [];
	      var ligatureGlyphs = [];

	      while (!last) {
	        var _codePoints;

	        var componentGlyph = this.ligatureStack.pop();
	        (_codePoints = codePoints).unshift.apply(_codePoints, this.glyphs[componentGlyph].codePoints);

	        var action = actions.getItem(actionIndex++);
	        last = !!(action & LAST_MASK);
	        var store = !!(action & STORE_MASK);
	        var offset = (action & OFFSET_MASK) << 2 >> 2; // sign extend 30 to 32 bits
	        offset += this.glyphs[componentGlyph].id;

	        var component = components.getItem(offset);
	        ligatureIndex += component;

	        if (last || store) {
	          var ligatureEntry = ligatureList.getItem(ligatureIndex);
	          this.glyphs[componentGlyph] = this.font.getGlyph(ligatureEntry, codePoints);
	          ligatureGlyphs.push(componentGlyph);
	          ligatureIndex = 0;
	          codePoints = [];
	        } else {
	          this.glyphs[componentGlyph] = this.font.getGlyph(0xffff);
	        }
	      }

	      // Put ligature glyph indexes back on the stack
	      (_ligatureStack = this.ligatureStack).push.apply(_ligatureStack, ligatureGlyphs);
	    }
	  };

	  AATMorxProcessor.prototype.processNoncontextualSubstitutions = function processNoncontextualSubstitutions(subtable, glyphs, index) {
	    var lookupTable = new AATLookupTable(subtable.table.lookupTable);

	    for (index = 0; index < glyphs.length; index++) {
	      var glyph = glyphs[index];
	      if (glyph.id !== 0xffff) {
	        var gid = lookupTable.lookup(glyph.id);
	        if (gid) {
	          // 0 means do nothing
	          glyphs[index] = this.font.getGlyph(gid, glyph.codePoints);
	        }
	      }
	    }
	  };

	  AATMorxProcessor.prototype._insertGlyphs = function _insertGlyphs(glyphIndex, insertionActionIndex, count, isBefore) {
	    var _glyphs;

	    var insertions = [];
	    while (count--) {
	      var gid = this.subtable.table.insertionActions.getItem(insertionActionIndex++);
	      insertions.push(this.font.getGlyph(gid));
	    }

	    if (!isBefore) {
	      glyphIndex++;
	    }

	    (_glyphs = this.glyphs).splice.apply(_glyphs, [glyphIndex, 0].concat(insertions));
	  };

	  AATMorxProcessor.prototype.processGlyphInsertion = function processGlyphInsertion(glyph, entry, index) {
	    if (entry.flags & SET_MARK) {
	      this.markedIndex = index;
	    }

	    if (entry.markedInsertIndex !== 0xffff) {
	      var count = (entry.flags & MARKED_INSERT_COUNT) >>> 5;
	      var isBefore = !!(entry.flags & MARKED_INSERT_BEFORE);
	      this._insertGlyphs(this.markedIndex, entry.markedInsertIndex, count, isBefore);
	    }

	    if (entry.currentInsertIndex !== 0xffff) {
	      var _count = (entry.flags & CURRENT_INSERT_COUNT) >>> 5;
	      var _isBefore = !!(entry.flags & CURRENT_INSERT_BEFORE);
	      this._insertGlyphs(index, entry.currentInsertIndex, _count, _isBefore);
	    }
	  };

	  AATMorxProcessor.prototype.getSupportedFeatures = function getSupportedFeatures() {
	    var features = [];
	    for (var _iterator4 = this.morx.chains, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _getIterator(_iterator4);;) {
	      var _ref4;

	      if (_isArray4) {
	        if (_i4 >= _iterator4.length) break;
	        _ref4 = _iterator4[_i4++];
	      } else {
	        _i4 = _iterator4.next();
	        if (_i4.done) break;
	        _ref4 = _i4.value;
	      }

	      var chain = _ref4;

	      for (var _iterator5 = chain.features, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _getIterator(_iterator5);;) {
	        var _ref5;

	        if (_isArray5) {
	          if (_i5 >= _iterator5.length) break;
	          _ref5 = _iterator5[_i5++];
	        } else {
	          _i5 = _iterator5.next();
	          if (_i5.done) break;
	          _ref5 = _i5.value;
	        }

	        var feature = _ref5;

	        features.push([feature.featureType, feature.featureSetting]);
	      }
	    }

	    return features;
	  };

	  AATMorxProcessor.prototype.generateInputs = function generateInputs(gid) {
	    if (!this.inputCache) {
	      this.generateInputCache();
	    }

	    return this.inputCache[gid] || [];
	  };

	  AATMorxProcessor.prototype.generateInputCache = function generateInputCache() {
	    this.inputCache = {};

	    for (var _iterator6 = this.morx.chains, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _getIterator(_iterator6);;) {
	      var _ref6;

	      if (_isArray6) {
	        if (_i6 >= _iterator6.length) break;
	        _ref6 = _iterator6[_i6++];
	      } else {
	        _i6 = _iterator6.next();
	        if (_i6.done) break;
	        _ref6 = _i6.value;
	      }

	      var chain = _ref6;

	      var flags = chain.defaultFlags;

	      for (var _iterator7 = chain.subtables, _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : _getIterator(_iterator7);;) {
	        var _ref7;

	        if (_isArray7) {
	          if (_i7 >= _iterator7.length) break;
	          _ref7 = _iterator7[_i7++];
	        } else {
	          _i7 = _iterator7.next();
	          if (_i7.done) break;
	          _ref7 = _i7.value;
	        }

	        var subtable = _ref7;

	        if (subtable.subFeatureFlags & flags) {
	          this.generateInputsForSubtable(subtable);
	        }
	      }
	    }
	  };

	  AATMorxProcessor.prototype.generateInputsForSubtable = function generateInputsForSubtable(subtable) {
	    var _this = this;

	    // Currently, only supporting ligature subtables.
	    if (subtable.type !== 2) {
	      return;
	    }

	    var reverse = !!(subtable.coverage & REVERSE_DIRECTION);
	    if (reverse) {
	      throw new Error('Reverse subtable, not supported.');
	    }

	    this.subtable = subtable;
	    this.ligatureStack = [];

	    var stateMachine = this.getStateMachine(subtable);
	    var process = this.getProcessor();

	    var input = [];
	    var stack = [];
	    this.glyphs = [];

	    stateMachine.traverse({
	      enter: function enter(glyph, entry) {
	        var glyphs = _this.glyphs;
	        stack.push({
	          glyphs: glyphs.slice(),
	          ligatureStack: _this.ligatureStack.slice()
	        });

	        // Add glyph to input and glyphs to process.
	        var g = _this.font.getGlyph(glyph);
	        input.push(g);
	        glyphs.push(input[input.length - 1]);

	        // Process ligature substitution
	        process(glyphs[glyphs.length - 1], entry, glyphs.length - 1);

	        // Add input to result if only one matching (non-deleted) glyph remains.
	        var count = 0;
	        var found = 0;
	        for (var i = 0; i < glyphs.length && count <= 1; i++) {
	          if (glyphs[i].id !== 0xffff) {
	            count++;
	            found = glyphs[i].id;
	          }
	        }

	        if (count === 1) {
	          var result = input.map(function (g) {
	            return g.id;
	          });
	          var _cache = _this.inputCache[found];
	          if (_cache) {
	            _cache.push(result);
	          } else {
	            _this.inputCache[found] = [result];
	          }
	        }
	      },

	      exit: function exit() {
	        var _stack$pop = stack.pop();

	        _this.glyphs = _stack$pop.glyphs;
	        _this.ligatureStack = _stack$pop.ligatureStack;

	        input.pop();
	      }
	    });
	  };

	  return AATMorxProcessor;
	}(), (_applyDecoratedDescriptor$2(_class$2.prototype, 'getStateMachine', [cache], _Object$getOwnPropertyDescriptor(_class$2.prototype, 'getStateMachine'), _class$2.prototype)), _class$2);

	function swap(glyphs, rangeA, rangeB) {
	  var reverseA = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	  var reverseB = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

	  var end = glyphs.splice(rangeB[0] - (rangeB[1] - 1), rangeB[1]);
	  if (reverseB) {
	    end.reverse();
	  }

	  var start = glyphs.splice.apply(glyphs, [rangeA[0], rangeA[1]].concat(end));
	  if (reverseA) {
	    start.reverse();
	  }

	  glyphs.splice.apply(glyphs, [rangeB[0] - (rangeA[1] - 1), 0].concat(start));
	  return glyphs;
	}

	function reorderGlyphs(glyphs, verb, firstGlyph, lastGlyph) {
	  var length = lastGlyph - firstGlyph + 1;
	  switch (verb) {
	    case 0:
	      // no change
	      return glyphs;

	    case 1:
	      // Ax => xA
	      return swap(glyphs, [firstGlyph, 1], [lastGlyph, 0]);

	    case 2:
	      // xD => Dx
	      return swap(glyphs, [firstGlyph, 0], [lastGlyph, 1]);

	    case 3:
	      // AxD => DxA
	      return swap(glyphs, [firstGlyph, 1], [lastGlyph, 1]);

	    case 4:
	      // ABx => xAB
	      return swap(glyphs, [firstGlyph, 2], [lastGlyph, 0]);

	    case 5:
	      // ABx => xBA
	      return swap(glyphs, [firstGlyph, 2], [lastGlyph, 0], true, false);

	    case 6:
	      // xCD => CDx
	      return swap(glyphs, [firstGlyph, 0], [lastGlyph, 2]);

	    case 7:
	      // xCD => DCx
	      return swap(glyphs, [firstGlyph, 0], [lastGlyph, 2], false, true);

	    case 8:
	      // AxCD => CDxA
	      return swap(glyphs, [firstGlyph, 1], [lastGlyph, 2]);

	    case 9:
	      // AxCD => DCxA
	      return swap(glyphs, [firstGlyph, 1], [lastGlyph, 2], false, true);

	    case 10:
	      // ABxD => DxAB
	      return swap(glyphs, [firstGlyph, 2], [lastGlyph, 1]);

	    case 11:
	      // ABxD => DxBA
	      return swap(glyphs, [firstGlyph, 2], [lastGlyph, 1], true, false);

	    case 12:
	      // ABxCD => CDxAB
	      return swap(glyphs, [firstGlyph, 2], [lastGlyph, 2]);

	    case 13:
	      // ABxCD => CDxBA
	      return swap(glyphs, [firstGlyph, 2], [lastGlyph, 2], true, false);

	    case 14:
	      // ABxCD => DCxAB
	      return swap(glyphs, [firstGlyph, 2], [lastGlyph, 2], false, true);

	    case 15:
	      // ABxCD => DCxBA
	      return swap(glyphs, [firstGlyph, 2], [lastGlyph, 2], true, true);

	    default:
	      throw new Error('Unknown verb: ' + verb);
	  }
	}

	var AATLayoutEngine = function () {
	  function AATLayoutEngine(font) {
	    _classCallCheck(this, AATLayoutEngine);

	    this.font = font;
	    this.morxProcessor = new AATMorxProcessor(font);
	    this.fallbackPosition = false;
	  }

	  AATLayoutEngine.prototype.substitute = function substitute(glyphRun) {
	    // AAT expects the glyphs to be in visual order prior to morx processing,
	    // so reverse the glyphs if the script is right-to-left.
	    if (glyphRun.direction === 'rtl') {
	      glyphRun.glyphs.reverse();
	    }

	    this.morxProcessor.process(glyphRun.glyphs, mapOTToAAT(glyphRun.features));
	  };

	  AATLayoutEngine.prototype.getAvailableFeatures = function getAvailableFeatures(script, language) {
	    return mapAATToOT(this.morxProcessor.getSupportedFeatures());
	  };

	  AATLayoutEngine.prototype.stringsForGlyph = function stringsForGlyph(gid) {
	    var glyphStrings = this.morxProcessor.generateInputs(gid);
	    var result = new _Set();

	    for (var _iterator = glyphStrings, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	      var _ref;

	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }

	      var glyphs = _ref;

	      this._addStrings(glyphs, 0, result, '');
	    }

	    return result;
	  };

	  AATLayoutEngine.prototype._addStrings = function _addStrings(glyphs, index, strings, string) {
	    var codePoints = this.font._cmapProcessor.codePointsForGlyph(glyphs[index]);

	    for (var _iterator2 = codePoints, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
	      var _ref2;

	      if (_isArray2) {
	        if (_i2 >= _iterator2.length) break;
	        _ref2 = _iterator2[_i2++];
	      } else {
	        _i2 = _iterator2.next();
	        if (_i2.done) break;
	        _ref2 = _i2.value;
	      }

	      var codePoint = _ref2;

	      var s = string + _String$fromCodePoint(codePoint);
	      if (index < glyphs.length - 1) {
	        this._addStrings(glyphs, index + 1, strings, s);
	      } else {
	        strings.add(s);
	      }
	    }
	  };

	  return AATLayoutEngine;
	}();

	/**
	 * ShapingPlans are used by the OpenType shapers to store which
	 * features should by applied, and in what order to apply them.
	 * The features are applied in groups called stages. A feature
	 * can be applied globally to all glyphs, or locally to only
	 * specific glyphs.
	 *
	 * @private
	 */

	var ShapingPlan = function () {
	  function ShapingPlan(font, script, direction) {
	    _classCallCheck(this, ShapingPlan);

	    this.font = font;
	    this.script = script;
	    this.direction = direction;
	    this.stages = [];
	    this.globalFeatures = {};
	    this.allFeatures = {};
	  }

	  /**
	   * Adds the given features to the last stage.
	   * Ignores features that have already been applied.
	   */


	  ShapingPlan.prototype._addFeatures = function _addFeatures(features, global) {
	    var stageIndex = this.stages.length - 1;
	    var stage = this.stages[stageIndex];
	    for (var _iterator = features, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	      var _ref;

	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }

	      var feature = _ref;

	      if (this.allFeatures[feature] == null) {
	        stage.push(feature);
	        this.allFeatures[feature] = stageIndex;

	        if (global) {
	          this.globalFeatures[feature] = true;
	        }
	      }
	    }
	  };

	  /**
	   * Add features to the last stage
	   */


	  ShapingPlan.prototype.add = function add(arg) {
	    var global = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

	    if (this.stages.length === 0) {
	      this.stages.push([]);
	    }

	    if (typeof arg === 'string') {
	      arg = [arg];
	    }

	    if (Array.isArray(arg)) {
	      this._addFeatures(arg, global);
	    } else if ((typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'object') {
	      this._addFeatures(arg.global || [], true);
	      this._addFeatures(arg.local || [], false);
	    } else {
	      throw new Error("Unsupported argument to ShapingPlan#add");
	    }
	  };

	  /**
	   * Add a new stage
	   */


	  ShapingPlan.prototype.addStage = function addStage(arg, global) {
	    if (typeof arg === 'function') {
	      this.stages.push(arg, []);
	    } else {
	      this.stages.push([]);
	      this.add(arg, global);
	    }
	  };

	  ShapingPlan.prototype.setFeatureOverrides = function setFeatureOverrides(features) {
	    if (Array.isArray(features)) {
	      this.add(features);
	    } else if ((typeof features === 'undefined' ? 'undefined' : _typeof(features)) === 'object') {
	      for (var tag in features) {
	        if (features[tag]) {
	          this.add(tag);
	        } else if (this.allFeatures[tag] != null) {
	          var stage = this.stages[this.allFeatures[tag]];
	          stage.splice(stage.indexOf(tag), 1);
	          delete this.allFeatures[tag];
	          delete this.globalFeatures[tag];
	        }
	      }
	    }
	  };

	  /**
	   * Assigns the global features to the given glyphs
	   */


	  ShapingPlan.prototype.assignGlobalFeatures = function assignGlobalFeatures(glyphs) {
	    for (var _iterator2 = glyphs, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
	      var _ref2;

	      if (_isArray2) {
	        if (_i2 >= _iterator2.length) break;
	        _ref2 = _iterator2[_i2++];
	      } else {
	        _i2 = _iterator2.next();
	        if (_i2.done) break;
	        _ref2 = _i2.value;
	      }

	      var glyph = _ref2;

	      for (var feature in this.globalFeatures) {
	        glyph.features[feature] = true;
	      }
	    }
	  };

	  /**
	   * Executes the planned stages using the given OTProcessor
	   */


	  ShapingPlan.prototype.process = function process(processor, glyphs, positions) {
	    for (var _iterator3 = this.stages, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
	      var _ref3;

	      if (_isArray3) {
	        if (_i3 >= _iterator3.length) break;
	        _ref3 = _iterator3[_i3++];
	      } else {
	        _i3 = _iterator3.next();
	        if (_i3.done) break;
	        _ref3 = _i3.value;
	      }

	      var stage = _ref3;

	      if (typeof stage === 'function') {
	        if (!positions) {
	          stage(this.font, glyphs, this);
	        }
	      } else if (stage.length > 0) {
	        processor.applyFeatures(stage, glyphs, positions);
	      }
	    }
	  };

	  return ShapingPlan;
	}();

	var _class$4;
	var _temp;
	var VARIATION_FEATURES = ['rvrn'];
	var COMMON_FEATURES = ['ccmp', 'locl', 'rlig', 'mark', 'mkmk'];
	var FRACTIONAL_FEATURES = ['frac', 'numr', 'dnom'];
	var HORIZONTAL_FEATURES = ['calt', 'clig', 'liga', 'rclt', 'curs', 'kern'];
	var DIRECTIONAL_FEATURES = {
	  ltr: ['ltra', 'ltrm'],
	  rtl: ['rtla', 'rtlm']
	};

	var DefaultShaper = (_temp = _class$4 = function () {
	  function DefaultShaper() {
	    _classCallCheck(this, DefaultShaper);
	  }

	  DefaultShaper.plan = function plan(_plan, glyphs, features) {
	    // Plan the features we want to apply
	    this.planPreprocessing(_plan);
	    this.planFeatures(_plan);
	    this.planPostprocessing(_plan, features);

	    // Assign the global features to all the glyphs
	    _plan.assignGlobalFeatures(glyphs);

	    // Assign local features to glyphs
	    this.assignFeatures(_plan, glyphs);
	  };

	  DefaultShaper.planPreprocessing = function planPreprocessing(plan) {
	    plan.add({
	      global: [].concat(VARIATION_FEATURES, DIRECTIONAL_FEATURES[plan.direction]),
	      local: FRACTIONAL_FEATURES
	    });
	  };

	  DefaultShaper.planFeatures = function planFeatures(plan) {
	    // Do nothing by default. Let subclasses override this.
	  };

	  DefaultShaper.planPostprocessing = function planPostprocessing(plan, userFeatures) {
	    plan.add([].concat(COMMON_FEATURES, HORIZONTAL_FEATURES));
	    plan.setFeatureOverrides(userFeatures);
	  };

	  DefaultShaper.assignFeatures = function assignFeatures(plan, glyphs) {
	    // Enable contextual fractions
	    for (var i = 0; i < glyphs.length; i++) {
	      var glyph = glyphs[i];
	      if (glyph.codePoints[0] === 0x2044) {
	        // fraction slash
	        var start = i;
	        var end = i + 1;

	        // Apply numerator
	        while (start > 0 && unicode.isDigit(glyphs[start - 1].codePoints[0])) {
	          glyphs[start - 1].features.numr = true;
	          glyphs[start - 1].features.frac = true;
	          start--;
	        }

	        // Apply denominator
	        while (end < glyphs.length && unicode.isDigit(glyphs[end].codePoints[0])) {
	          glyphs[end].features.dnom = true;
	          glyphs[end].features.frac = true;
	          end++;
	        }

	        // Apply fraction slash
	        glyph.features.frac = true;
	        i = end - 1;
	      }
	    }
	  };

	  return DefaultShaper;
	}(), _class$4.zeroMarkWidths = 'AFTER_GPOS', _temp);

	var trie = new UnicodeTrie(Buffer("AAEQAAAAAAAAADGgAZUBav7t2CtPA0EUBeDZB00pin9AJZIEgyUEj0QhweDAgQOJxCBRBElQSBwSicLgkOAwnNKZ5GaY2c7uzj4o5yZfZrrbefbuIx2nSq3CGmzAWH/+K+UO7MIe7MMhHMMpnMMFXMIVXIt2t3CnP088iPqjqNN8e4Ij7Rle4LUH82rLm6i/92A+RERERERERERNmfz/89GDeRARERERzbN8ceps2Iwt9H0C9/AJ6yOlDkbTczcot5VSm8Pm1vcFWfb7+BKOLTuOd2UlTX4wGP85Eg953lWPFbnuN7PkjtLmalOWbNenkHOSa7T3KmR9MVTZ2zZkVj1kHa68MueVKH0R4zqQ44WEXLM8VjcWHP0PtKLfPzQnMtGn3W4QYf6qxFxceVI394r2xnV+1rih0fV1Vzf3fO1n3evL5J78ruvZ5ptX2Rwy92Tfb1wlEqut3U+sZ3HXOeJ7/zDrbyuP6+Zz0fqa6Nv3vhY7Yu1xWnGevmsvsUpTT/RYIe8waUH/rvHMWKFzLfN8L+rTfp645mfX7ftlnfDtYxN59w0=","base64"));
	var FEATURES = ['isol', 'fina', 'fin2', 'fin3', 'medi', 'med2', 'init'];

	var ShapingClasses = {
	  Non_Joining: 0,
	  Left_Joining: 1,
	  Right_Joining: 2,
	  Dual_Joining: 3,
	  Join_Causing: 3,
	  ALAPH: 4,
	  'DALATH RISH': 5,
	  Transparent: 6
	};

	var ISOL = 'isol';
	var FINA = 'fina';
	var FIN2 = 'fin2';
	var FIN3 = 'fin3';
	var MEDI = 'medi';
	var MED2 = 'med2';
	var INIT = 'init';
	var NONE = null;

	// Each entry is [prevAction, curAction, nextState]
	var STATE_TABLE = [
	//   Non_Joining,        Left_Joining,       Right_Joining,     Dual_Joining,           ALAPH,            DALATH RISH
	// State 0: prev was U,  not willing to join.
	[[NONE, NONE, 0], [NONE, ISOL, 2], [NONE, ISOL, 1], [NONE, ISOL, 2], [NONE, ISOL, 1], [NONE, ISOL, 6]],

	// State 1: prev was R or ISOL/ALAPH,  not willing to join.
	[[NONE, NONE, 0], [NONE, ISOL, 2], [NONE, ISOL, 1], [NONE, ISOL, 2], [NONE, FIN2, 5], [NONE, ISOL, 6]],

	// State 2: prev was D/L in ISOL form,  willing to join.
	[[NONE, NONE, 0], [NONE, ISOL, 2], [INIT, FINA, 1], [INIT, FINA, 3], [INIT, FINA, 4], [INIT, FINA, 6]],

	// State 3: prev was D in FINA form,  willing to join.
	[[NONE, NONE, 0], [NONE, ISOL, 2], [MEDI, FINA, 1], [MEDI, FINA, 3], [MEDI, FINA, 4], [MEDI, FINA, 6]],

	// State 4: prev was FINA ALAPH,  not willing to join.
	[[NONE, NONE, 0], [NONE, ISOL, 2], [MED2, ISOL, 1], [MED2, ISOL, 2], [MED2, FIN2, 5], [MED2, ISOL, 6]],

	// State 5: prev was FIN2/FIN3 ALAPH,  not willing to join.
	[[NONE, NONE, 0], [NONE, ISOL, 2], [ISOL, ISOL, 1], [ISOL, ISOL, 2], [ISOL, FIN2, 5], [ISOL, ISOL, 6]],

	// State 6: prev was DALATH/RISH,  not willing to join.
	[[NONE, NONE, 0], [NONE, ISOL, 2], [NONE, ISOL, 1], [NONE, ISOL, 2], [NONE, FIN3, 5], [NONE, ISOL, 6]]];

	/**
	 * This is a shaper for Arabic, and other cursive scripts.
	 * It uses data from ArabicShaping.txt in the Unicode database,
	 * compiled to a UnicodeTrie by generate-data.coffee.
	 *
	 * The shaping state machine was ported from Harfbuzz.
	 * https://github.com/behdad/harfbuzz/blob/master/src/hb-ot-shape-complex-arabic.cc
	 */

	var ArabicShaper = function (_DefaultShaper) {
	  _inherits(ArabicShaper, _DefaultShaper);

	  function ArabicShaper() {
	    _classCallCheck(this, ArabicShaper);

	    return _possibleConstructorReturn(this, _DefaultShaper.apply(this, arguments));
	  }

	  ArabicShaper.planFeatures = function planFeatures(plan) {
	    plan.add(['ccmp', 'locl']);
	    for (var i = 0; i < FEATURES.length; i++) {
	      var feature = FEATURES[i];
	      plan.addStage(feature, false);
	    }

	    plan.addStage('mset');
	  };

	  ArabicShaper.assignFeatures = function assignFeatures(plan, glyphs) {
	    _DefaultShaper.assignFeatures.call(this, plan, glyphs);

	    var prev = -1;
	    var state = 0;
	    var actions = [];

	    // Apply the state machine to map glyphs to features
	    for (var i = 0; i < glyphs.length; i++) {
	      var curAction = void 0,
	          prevAction = void 0;
	      var glyph = glyphs[i];
	      var type = getShapingClass(glyph.codePoints[0]);
	      if (type === ShapingClasses.Transparent) {
	        actions[i] = NONE;
	        continue;
	      }

	      var _STATE_TABLE$state$ty = STATE_TABLE[state][type];
	      prevAction = _STATE_TABLE$state$ty[0];
	      curAction = _STATE_TABLE$state$ty[1];
	      state = _STATE_TABLE$state$ty[2];


	      if (prevAction !== NONE && prev !== -1) {
	        actions[prev] = prevAction;
	      }

	      actions[i] = curAction;
	      prev = i;
	    }

	    // Apply the chosen features to their respective glyphs
	    for (var index = 0; index < glyphs.length; index++) {
	      var feature = void 0;
	      var glyph = glyphs[index];
	      if (feature = actions[index]) {
	        glyph.features[feature] = true;
	      }
	    }
	  };

	  return ArabicShaper;
	}(DefaultShaper);

	function getShapingClass(codePoint) {
	  var res = trie.get(codePoint);
	  if (res) {
	    return res - 1;
	  }

	  var category = unicode.getCategory(codePoint);
	  if (category === 'Mn' || category === 'Me' || category === 'Cf') {
	    return ShapingClasses.Transparent;
	  }

	  return ShapingClasses.Non_Joining;
	}

	var GlyphIterator = function () {
	  function GlyphIterator(glyphs, options) {
	    _classCallCheck(this, GlyphIterator);

	    this.glyphs = glyphs;
	    this.reset(options);
	  }

	  GlyphIterator.prototype.reset = function reset() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

	    this.options = options;
	    this.flags = options.flags || {};
	    this.markAttachmentType = options.markAttachmentType || 0;
	    this.index = index;
	  };

	  GlyphIterator.prototype.shouldIgnore = function shouldIgnore(glyph) {
	    return this.flags.ignoreMarks && glyph.isMark || this.flags.ignoreBaseGlyphs && glyph.isBase || this.flags.ignoreLigatures && glyph.isLigature || this.markAttachmentType && glyph.isMark && glyph.markAttachmentType !== this.markAttachmentType;
	  };

	  GlyphIterator.prototype.move = function move(dir) {
	    this.index += dir;
	    while (0 <= this.index && this.index < this.glyphs.length && this.shouldIgnore(this.glyphs[this.index])) {
	      this.index += dir;
	    }

	    if (0 > this.index || this.index >= this.glyphs.length) {
	      return null;
	    }

	    return this.glyphs[this.index];
	  };

	  GlyphIterator.prototype.next = function next() {
	    return this.move(+1);
	  };

	  GlyphIterator.prototype.prev = function prev() {
	    return this.move(-1);
	  };

	  GlyphIterator.prototype.peek = function peek() {
	    var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

	    var idx = this.index;
	    var res = this.increment(count);
	    this.index = idx;
	    return res;
	  };

	  GlyphIterator.prototype.peekIndex = function peekIndex() {
	    var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

	    var idx = this.index;
	    this.increment(count);
	    var res = this.index;
	    this.index = idx;
	    return res;
	  };

	  GlyphIterator.prototype.increment = function increment() {
	    var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

	    var dir = count < 0 ? -1 : 1;
	    count = Math.abs(count);
	    while (count--) {
	      this.move(dir);
	    }

	    return this.glyphs[this.index];
	  };

	  _createClass(GlyphIterator, [{
	    key: "cur",
	    get: function get() {
	      return this.glyphs[this.index] || null;
	    }
	  }]);

	  return GlyphIterator;
	}();

	var DEFAULT_SCRIPTS = ['DFLT', 'dflt', 'latn'];

	var OTProcessor = function () {
	  function OTProcessor(font, table) {
	    _classCallCheck(this, OTProcessor);

	    this.font = font;
	    this.table = table;

	    this.script = null;
	    this.scriptTag = null;

	    this.language = null;
	    this.languageTag = null;

	    this.features = {};
	    this.lookups = {};

	    // Setup variation substitutions
	    this.variationsIndex = font._variationProcessor ? this.findVariationsIndex(font._variationProcessor.normalizedCoords) : -1;

	    // initialize to default script + language
	    this.selectScript();

	    // current context (set by applyFeatures)
	    this.glyphs = [];
	    this.positions = []; // only used by GPOS
	    this.ligatureID = 1;
	    this.currentFeature = null;
	  }

	  OTProcessor.prototype.findScript = function findScript(script) {
	    if (this.table.scriptList == null) {
	      return null;
	    }

	    if (!Array.isArray(script)) {
	      script = [script];
	    }

	    for (var _iterator = script, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	      var _ref;

	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }

	      var s = _ref;

	      for (var _iterator2 = this.table.scriptList, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
	        var _ref2;

	        if (_isArray2) {
	          if (_i2 >= _iterator2.length) break;
	          _ref2 = _iterator2[_i2++];
	        } else {
	          _i2 = _iterator2.next();
	          if (_i2.done) break;
	          _ref2 = _i2.value;
	        }

	        var entry = _ref2;

	        if (entry.tag === s) {
	          return entry;
	        }
	      }
	    }

	    return null;
	  };

	  OTProcessor.prototype.selectScript = function selectScript(script, language, direction$$) {
	    var changed = false;
	    var entry = void 0;
	    if (!this.script || script !== this.scriptTag) {
	      entry = this.findScript(script);
	      if (!entry) {
	        entry = this.findScript(DEFAULT_SCRIPTS);
	      }

	      if (!entry) {
	        return this.scriptTag;
	      }

	      this.scriptTag = entry.tag;
	      this.script = entry.script;
	      this.language = null;
	      this.languageTag = null;
	      changed = true;
	    }

	    if (!direction$$ || direction$$ !== this.direction) {
	      this.direction = direction$$ || direction(script);
	    }

	    if (language && language.length < 4) {
	      language += ' '.repeat(4 - language.length);
	    }

	    if (!language || language !== this.languageTag) {
	      this.language = null;

	      for (var _iterator3 = this.script.langSysRecords, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
	        var _ref3;

	        if (_isArray3) {
	          if (_i3 >= _iterator3.length) break;
	          _ref3 = _iterator3[_i3++];
	        } else {
	          _i3 = _iterator3.next();
	          if (_i3.done) break;
	          _ref3 = _i3.value;
	        }

	        var lang = _ref3;

	        if (lang.tag === language) {
	          this.language = lang.langSys;
	          this.languageTag = lang.tag;
	          break;
	        }
	      }

	      if (!this.language) {
	        this.language = this.script.defaultLangSys;
	        this.languageTag = null;
	      }

	      changed = true;
	    }

	    // Build a feature lookup table
	    if (changed) {
	      this.features = {};
	      if (this.language) {
	        for (var _iterator4 = this.language.featureIndexes, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _getIterator(_iterator4);;) {
	          var _ref4;

	          if (_isArray4) {
	            if (_i4 >= _iterator4.length) break;
	            _ref4 = _iterator4[_i4++];
	          } else {
	            _i4 = _iterator4.next();
	            if (_i4.done) break;
	            _ref4 = _i4.value;
	          }

	          var featureIndex = _ref4;

	          var record = this.table.featureList[featureIndex];
	          var substituteFeature = this.substituteFeatureForVariations(featureIndex);
	          this.features[record.tag] = substituteFeature || record.feature;
	        }
	      }
	    }

	    return this.scriptTag;
	  };

	  OTProcessor.prototype.lookupsForFeatures = function lookupsForFeatures() {
	    var userFeatures = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var exclude = arguments[1];

	    var lookups = [];
	    for (var _iterator5 = userFeatures, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _getIterator(_iterator5);;) {
	      var _ref5;

	      if (_isArray5) {
	        if (_i5 >= _iterator5.length) break;
	        _ref5 = _iterator5[_i5++];
	      } else {
	        _i5 = _iterator5.next();
	        if (_i5.done) break;
	        _ref5 = _i5.value;
	      }

	      var tag = _ref5;

	      var feature = this.features[tag];
	      if (!feature) {
	        continue;
	      }

	      for (var _iterator6 = feature.lookupListIndexes, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _getIterator(_iterator6);;) {
	        var _ref6;

	        if (_isArray6) {
	          if (_i6 >= _iterator6.length) break;
	          _ref6 = _iterator6[_i6++];
	        } else {
	          _i6 = _iterator6.next();
	          if (_i6.done) break;
	          _ref6 = _i6.value;
	        }

	        var lookupIndex = _ref6;

	        if (exclude && exclude.indexOf(lookupIndex) !== -1) {
	          continue;
	        }

	        lookups.push({
	          feature: tag,
	          index: lookupIndex,
	          lookup: this.table.lookupList.get(lookupIndex)
	        });
	      }
	    }

	    lookups.sort(function (a, b) {
	      return a.index - b.index;
	    });
	    return lookups;
	  };

	  OTProcessor.prototype.substituteFeatureForVariations = function substituteFeatureForVariations(featureIndex) {
	    if (this.variationsIndex === -1) {
	      return null;
	    }

	    var record = this.table.featureVariations.featureVariationRecords[this.variationsIndex];
	    var substitutions = record.featureTableSubstitution.substitutions;
	    for (var _iterator7 = substitutions, _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : _getIterator(_iterator7);;) {
	      var _ref7;

	      if (_isArray7) {
	        if (_i7 >= _iterator7.length) break;
	        _ref7 = _iterator7[_i7++];
	      } else {
	        _i7 = _iterator7.next();
	        if (_i7.done) break;
	        _ref7 = _i7.value;
	      }

	      var substitution = _ref7;

	      if (substitution.featureIndex === featureIndex) {
	        return substitution.alternateFeatureTable;
	      }
	    }

	    return null;
	  };

	  OTProcessor.prototype.findVariationsIndex = function findVariationsIndex(coords) {
	    var variations = this.table.featureVariations;
	    if (!variations) {
	      return -1;
	    }

	    var records = variations.featureVariationRecords;
	    for (var i = 0; i < records.length; i++) {
	      var conditions = records[i].conditionSet.conditionTable;
	      if (this.variationConditionsMatch(conditions, coords)) {
	        return i;
	      }
	    }

	    return -1;
	  };

	  OTProcessor.prototype.variationConditionsMatch = function variationConditionsMatch(conditions, coords) {
	    return conditions.every(function (condition) {
	      var coord = condition.axisIndex < coords.length ? coords[condition.axisIndex] : 0;
	      return condition.filterRangeMinValue <= coord && coord <= condition.filterRangeMaxValue;
	    });
	  };

	  OTProcessor.prototype.applyFeatures = function applyFeatures(userFeatures, glyphs, advances) {
	    var lookups = this.lookupsForFeatures(userFeatures);
	    this.applyLookups(lookups, glyphs, advances);
	  };

	  OTProcessor.prototype.applyLookups = function applyLookups(lookups, glyphs, positions) {
	    this.glyphs = glyphs;
	    this.positions = positions;
	    this.glyphIterator = new GlyphIterator(glyphs);

	    for (var _iterator8 = lookups, _isArray8 = Array.isArray(_iterator8), _i8 = 0, _iterator8 = _isArray8 ? _iterator8 : _getIterator(_iterator8);;) {
	      var _ref8;

	      if (_isArray8) {
	        if (_i8 >= _iterator8.length) break;
	        _ref8 = _iterator8[_i8++];
	      } else {
	        _i8 = _iterator8.next();
	        if (_i8.done) break;
	        _ref8 = _i8.value;
	      }

	      var _ref9 = _ref8,
	          feature = _ref9.feature,
	          lookup = _ref9.lookup;

	      this.currentFeature = feature;
	      this.glyphIterator.reset(lookup.flags);

	      while (this.glyphIterator.index < glyphs.length) {
	        if (!(feature in this.glyphIterator.cur.features)) {
	          this.glyphIterator.next();
	          continue;
	        }

	        for (var _iterator9 = lookup.subTables, _isArray9 = Array.isArray(_iterator9), _i9 = 0, _iterator9 = _isArray9 ? _iterator9 : _getIterator(_iterator9);;) {
	          var _ref10;

	          if (_isArray9) {
	            if (_i9 >= _iterator9.length) break;
	            _ref10 = _iterator9[_i9++];
	          } else {
	            _i9 = _iterator9.next();
	            if (_i9.done) break;
	            _ref10 = _i9.value;
	          }

	          var table = _ref10;

	          var res = this.applyLookup(lookup.lookupType, table);
	          if (res) {
	            break;
	          }
	        }

	        this.glyphIterator.next();
	      }
	    }
	  };

	  OTProcessor.prototype.applyLookup = function applyLookup(lookup, table) {
	    throw new Error("applyLookup must be implemented by subclasses");
	  };

	  OTProcessor.prototype.applyLookupList = function applyLookupList(lookupRecords) {
	    var options = this.glyphIterator.options;
	    var glyphIndex = this.glyphIterator.index;

	    for (var _iterator10 = lookupRecords, _isArray10 = Array.isArray(_iterator10), _i10 = 0, _iterator10 = _isArray10 ? _iterator10 : _getIterator(_iterator10);;) {
	      var _ref11;

	      if (_isArray10) {
	        if (_i10 >= _iterator10.length) break;
	        _ref11 = _iterator10[_i10++];
	      } else {
	        _i10 = _iterator10.next();
	        if (_i10.done) break;
	        _ref11 = _i10.value;
	      }

	      var lookupRecord = _ref11;

	      // Reset flags and find glyph index for this lookup record
	      this.glyphIterator.reset(options, glyphIndex);
	      this.glyphIterator.increment(lookupRecord.sequenceIndex);

	      // Get the lookup and setup flags for subtables
	      var lookup = this.table.lookupList.get(lookupRecord.lookupListIndex);
	      this.glyphIterator.reset(lookup.flags, this.glyphIterator.index);

	      // Apply lookup subtables until one matches
	      for (var _iterator11 = lookup.subTables, _isArray11 = Array.isArray(_iterator11), _i11 = 0, _iterator11 = _isArray11 ? _iterator11 : _getIterator(_iterator11);;) {
	        var _ref12;

	        if (_isArray11) {
	          if (_i11 >= _iterator11.length) break;
	          _ref12 = _iterator11[_i11++];
	        } else {
	          _i11 = _iterator11.next();
	          if (_i11.done) break;
	          _ref12 = _i11.value;
	        }

	        var table = _ref12;

	        if (this.applyLookup(lookup.lookupType, table)) {
	          break;
	        }
	      }
	    }

	    this.glyphIterator.reset(options, glyphIndex);
	    return true;
	  };

	  OTProcessor.prototype.coverageIndex = function coverageIndex(coverage, glyph) {
	    if (glyph == null) {
	      glyph = this.glyphIterator.cur.id;
	    }

	    switch (coverage.version) {
	      case 1:
	        return coverage.glyphs.indexOf(glyph);

	      case 2:
	        for (var _iterator12 = coverage.rangeRecords, _isArray12 = Array.isArray(_iterator12), _i12 = 0, _iterator12 = _isArray12 ? _iterator12 : _getIterator(_iterator12);;) {
	          var _ref13;

	          if (_isArray12) {
	            if (_i12 >= _iterator12.length) break;
	            _ref13 = _iterator12[_i12++];
	          } else {
	            _i12 = _iterator12.next();
	            if (_i12.done) break;
	            _ref13 = _i12.value;
	          }

	          var range = _ref13;

	          if (range.start <= glyph && glyph <= range.end) {
	            return range.startCoverageIndex + glyph - range.start;
	          }
	        }

	        break;
	    }

	    return -1;
	  };

	  OTProcessor.prototype.match = function match(sequenceIndex, sequence, fn, matched) {
	    var pos = this.glyphIterator.index;
	    var glyph = this.glyphIterator.increment(sequenceIndex);
	    var idx = 0;

	    while (idx < sequence.length && glyph && fn(sequence[idx], glyph)) {
	      if (matched) {
	        matched.push(this.glyphIterator.index);
	      }

	      idx++;
	      glyph = this.glyphIterator.next();
	    }

	    this.glyphIterator.index = pos;
	    if (idx < sequence.length) {
	      return false;
	    }

	    return matched || true;
	  };

	  OTProcessor.prototype.sequenceMatches = function sequenceMatches(sequenceIndex, sequence) {
	    return this.match(sequenceIndex, sequence, function (component, glyph) {
	      return component === glyph.id;
	    });
	  };

	  OTProcessor.prototype.sequenceMatchIndices = function sequenceMatchIndices(sequenceIndex, sequence) {
	    var _this = this;

	    return this.match(sequenceIndex, sequence, function (component, glyph) {
	      // If the current feature doesn't apply to this glyph,
	      if (!(_this.currentFeature in glyph.features)) {
	        return false;
	      }

	      return component === glyph.id;
	    }, []);
	  };

	  OTProcessor.prototype.coverageSequenceMatches = function coverageSequenceMatches(sequenceIndex, sequence) {
	    var _this2 = this;

	    return this.match(sequenceIndex, sequence, function (coverage, glyph) {
	      return _this2.coverageIndex(coverage, glyph.id) >= 0;
	    });
	  };

	  OTProcessor.prototype.getClassID = function getClassID(glyph, classDef) {
	    switch (classDef.version) {
	      case 1:
	        // Class array
	        var i = glyph - classDef.startGlyph;
	        if (i >= 0 && i < classDef.classValueArray.length) {
	          return classDef.classValueArray[i];
	        }

	        break;

	      case 2:
	        for (var _iterator13 = classDef.classRangeRecord, _isArray13 = Array.isArray(_iterator13), _i13 = 0, _iterator13 = _isArray13 ? _iterator13 : _getIterator(_iterator13);;) {
	          var _ref14;

	          if (_isArray13) {
	            if (_i13 >= _iterator13.length) break;
	            _ref14 = _iterator13[_i13++];
	          } else {
	            _i13 = _iterator13.next();
	            if (_i13.done) break;
	            _ref14 = _i13.value;
	          }

	          var range = _ref14;

	          if (range.start <= glyph && glyph <= range.end) {
	            return range.class;
	          }
	        }

	        break;
	    }

	    return 0;
	  };

	  OTProcessor.prototype.classSequenceMatches = function classSequenceMatches(sequenceIndex, sequence, classDef) {
	    var _this3 = this;

	    return this.match(sequenceIndex, sequence, function (classID, glyph) {
	      return classID === _this3.getClassID(glyph.id, classDef);
	    });
	  };

	  OTProcessor.prototype.applyContext = function applyContext(table) {
	    switch (table.version) {
	      case 1:
	        var index = this.coverageIndex(table.coverage);
	        if (index === -1) {
	          return false;
	        }

	        var set = table.ruleSets[index];
	        for (var _iterator14 = set, _isArray14 = Array.isArray(_iterator14), _i14 = 0, _iterator14 = _isArray14 ? _iterator14 : _getIterator(_iterator14);;) {
	          var _ref15;

	          if (_isArray14) {
	            if (_i14 >= _iterator14.length) break;
	            _ref15 = _iterator14[_i14++];
	          } else {
	            _i14 = _iterator14.next();
	            if (_i14.done) break;
	            _ref15 = _i14.value;
	          }

	          var rule = _ref15;

	          if (this.sequenceMatches(1, rule.input)) {
	            return this.applyLookupList(rule.lookupRecords);
	          }
	        }

	        break;

	      case 2:
	        if (this.coverageIndex(table.coverage) === -1) {
	          return false;
	        }

	        index = this.getClassID(this.glyphIterator.cur.id, table.classDef);
	        if (index === -1) {
	          return false;
	        }

	        set = table.classSet[index];
	        for (var _iterator15 = set, _isArray15 = Array.isArray(_iterator15), _i15 = 0, _iterator15 = _isArray15 ? _iterator15 : _getIterator(_iterator15);;) {
	          var _ref16;

	          if (_isArray15) {
	            if (_i15 >= _iterator15.length) break;
	            _ref16 = _iterator15[_i15++];
	          } else {
	            _i15 = _iterator15.next();
	            if (_i15.done) break;
	            _ref16 = _i15.value;
	          }

	          var _rule = _ref16;

	          if (this.classSequenceMatches(1, _rule.classes, table.classDef)) {
	            return this.applyLookupList(_rule.lookupRecords);
	          }
	        }

	        break;

	      case 3:
	        if (this.coverageSequenceMatches(0, table.coverages)) {
	          return this.applyLookupList(table.lookupRecords);
	        }

	        break;
	    }

	    return false;
	  };

	  OTProcessor.prototype.applyChainingContext = function applyChainingContext(table) {
	    switch (table.version) {
	      case 1:
	        var index = this.coverageIndex(table.coverage);
	        if (index === -1) {
	          return false;
	        }

	        var set = table.chainRuleSets[index];
	        for (var _iterator16 = set, _isArray16 = Array.isArray(_iterator16), _i16 = 0, _iterator16 = _isArray16 ? _iterator16 : _getIterator(_iterator16);;) {
	          var _ref17;

	          if (_isArray16) {
	            if (_i16 >= _iterator16.length) break;
	            _ref17 = _iterator16[_i16++];
	          } else {
	            _i16 = _iterator16.next();
	            if (_i16.done) break;
	            _ref17 = _i16.value;
	          }

	          var rule = _ref17;

	          if (this.sequenceMatches(-rule.backtrack.length, rule.backtrack) && this.sequenceMatches(1, rule.input) && this.sequenceMatches(1 + rule.input.length, rule.lookahead)) {
	            return this.applyLookupList(rule.lookupRecords);
	          }
	        }

	        break;

	      case 2:
	        if (this.coverageIndex(table.coverage) === -1) {
	          return false;
	        }

	        index = this.getClassID(this.glyphIterator.cur.id, table.inputClassDef);
	        var rules = table.chainClassSet[index];
	        if (!rules) {
	          return false;
	        }

	        for (var _iterator17 = rules, _isArray17 = Array.isArray(_iterator17), _i17 = 0, _iterator17 = _isArray17 ? _iterator17 : _getIterator(_iterator17);;) {
	          var _ref18;

	          if (_isArray17) {
	            if (_i17 >= _iterator17.length) break;
	            _ref18 = _iterator17[_i17++];
	          } else {
	            _i17 = _iterator17.next();
	            if (_i17.done) break;
	            _ref18 = _i17.value;
	          }

	          var _rule2 = _ref18;

	          if (this.classSequenceMatches(-_rule2.backtrack.length, _rule2.backtrack, table.backtrackClassDef) && this.classSequenceMatches(1, _rule2.input, table.inputClassDef) && this.classSequenceMatches(1 + _rule2.input.length, _rule2.lookahead, table.lookaheadClassDef)) {
	            return this.applyLookupList(_rule2.lookupRecords);
	          }
	        }

	        break;

	      case 3:
	        if (this.coverageSequenceMatches(-table.backtrackGlyphCount, table.backtrackCoverage) && this.coverageSequenceMatches(0, table.inputCoverage) && this.coverageSequenceMatches(table.inputGlyphCount, table.lookaheadCoverage)) {
	          return this.applyLookupList(table.lookupRecords);
	        }

	        break;
	    }

	    return false;
	  };

	  return OTProcessor;
	}();

	var GlyphInfo = function () {
	  function GlyphInfo(font, id) {
	    var codePoints = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	    var features = arguments[3];

	    _classCallCheck(this, GlyphInfo);

	    this._font = font;
	    this.codePoints = codePoints;
	    this.id = id;

	    this.features = {};
	    if (Array.isArray(features)) {
	      for (var i = 0; i < features.length; i++) {
	        var feature = features[i];
	        this.features[feature] = true;
	      }
	    } else if ((typeof features === 'undefined' ? 'undefined' : _typeof(features)) === 'object') {
	      _Object$assign(this.features, features);
	    }

	    this.ligatureID = null;
	    this.ligatureComponent = null;
	    this.isLigated = false;
	    this.cursiveAttachment = null;
	    this.markAttachment = null;
	    this.shaperInfo = null;
	    this.substituted = false;
	    this.isMultiplied = false;
	  }

	  GlyphInfo.prototype.copy = function copy() {
	    return new GlyphInfo(this._font, this.id, this.codePoints, this.features);
	  };

	  _createClass(GlyphInfo, [{
	    key: 'id',
	    get: function get() {
	      return this._id;
	    },
	    set: function set(id) {
	      this._id = id;
	      this.substituted = true;

	      var GDEF = this._font.GDEF;
	      if (GDEF && GDEF.glyphClassDef) {
	        // TODO: clean this up
	        var classID = OTProcessor.prototype.getClassID(id, GDEF.glyphClassDef);
	        this.isBase = classID === 1;
	        this.isLigature = classID === 2;
	        this.isMark = classID === 3;
	        this.markAttachmentType = GDEF.markAttachClassDef ? OTProcessor.prototype.getClassID(id, GDEF.markAttachClassDef) : 0;
	      } else {
	        this.isMark = this.codePoints.every(unicode.isMark);
	        this.isBase = !this.isMark;
	        this.isLigature = this.codePoints.length > 1;
	        this.markAttachmentType = 0;
	      }
	    }
	  }]);

	  return GlyphInfo;
	}();

	var _class$5;
	var _temp$1;
	/**
	 * This is a shaper for the Hangul script, used by the Korean language.
	 * It does the following:
	 *   - decompose if unsupported by the font:
	 *     <LV>   -> <L,V>
	 *     <LVT>  -> <L,V,T>
	 *     <LV,T> -> <L,V,T>
	 *
	 *   - compose if supported by the font:
	 *     <L,V>   -> <LV>
	 *     <L,V,T> -> <LVT>
	 *     <LV,T>  -> <LVT>
	 *
	 *   - reorder tone marks (S is any valid syllable):
	 *     <S, M> -> <M, S>
	 *
	 *   - apply ljmo, vjmo, and tjmo OpenType features to decomposed Jamo sequences.
	 *
	 * This logic is based on the following documents:
	 *   - http://www.microsoft.com/typography/OpenTypeDev/hangul/intro.htm
	 *   - http://ktug.org/~nomos/harfbuzz-hangul/hangulshaper.pdf
	 */
	var HangulShaper = (_temp$1 = _class$5 = function (_DefaultShaper) {
	  _inherits(HangulShaper, _DefaultShaper);

	  function HangulShaper() {
	    _classCallCheck(this, HangulShaper);

	    return _possibleConstructorReturn(this, _DefaultShaper.apply(this, arguments));
	  }

	  HangulShaper.planFeatures = function planFeatures(plan) {
	    plan.add(['ljmo', 'vjmo', 'tjmo'], false);
	  };

	  HangulShaper.assignFeatures = function assignFeatures(plan, glyphs) {
	    var state = 0;
	    var i = 0;
	    while (i < glyphs.length) {
	      var action = void 0;
	      var glyph = glyphs[i];
	      var code = glyph.codePoints[0];
	      var type = getType(code);

	      var _STATE_TABLE$state$ty = STATE_TABLE$1[state][type];
	      action = _STATE_TABLE$state$ty[0];
	      state = _STATE_TABLE$state$ty[1];


	      switch (action) {
	        case DECOMPOSE:
	          // Decompose the composed syllable if it is not supported by the font.
	          if (!plan.font.hasGlyphForCodePoint(code)) {
	            i = decompose(glyphs, i, plan.font);
	          }
	          break;

	        case COMPOSE:
	          // Found a decomposed syllable. Try to compose if supported by the font.
	          i = compose(glyphs, i, plan.font);
	          break;

	        case TONE_MARK:
	          // Got a valid syllable, followed by a tone mark. Move the tone mark to the beginning of the syllable.
	          reorderToneMark(glyphs, i, plan.font);
	          break;

	        case INVALID:
	          // Tone mark has no valid syllable to attach to, so insert a dotted circle
	          i = insertDottedCircle(glyphs, i, plan.font);
	          break;
	      }

	      i++;
	    }
	  };

	  return HangulShaper;
	}(DefaultShaper), _class$5.zeroMarkWidths = 'NONE', _temp$1);
	var HANGUL_BASE = 0xac00;
	var HANGUL_END = 0xd7a4;
	var HANGUL_COUNT = HANGUL_END - HANGUL_BASE + 1;
	var L_BASE = 0x1100; // lead
	var V_BASE = 0x1161; // vowel
	var T_BASE = 0x11a7; // trail
	var L_COUNT = 19;
	var V_COUNT = 21;
	var T_COUNT = 28;
	var L_END = L_BASE + L_COUNT - 1;
	var V_END = V_BASE + V_COUNT - 1;
	var T_END = T_BASE + T_COUNT - 1;
	var DOTTED_CIRCLE = 0x25cc;

	var isL = function isL(code) {
	  return 0x1100 <= code && code <= 0x115f || 0xa960 <= code && code <= 0xa97c;
	};
	var isV = function isV(code) {
	  return 0x1160 <= code && code <= 0x11a7 || 0xd7b0 <= code && code <= 0xd7c6;
	};
	var isT = function isT(code) {
	  return 0x11a8 <= code && code <= 0x11ff || 0xd7cb <= code && code <= 0xd7fb;
	};
	var isTone = function isTone(code) {
	  return 0x302e <= code && code <= 0x302f;
	};
	var isLVT = function isLVT(code) {
	  return HANGUL_BASE <= code && code <= HANGUL_END;
	};
	var isLV = function isLV(code) {
	  return code - HANGUL_BASE < HANGUL_COUNT && (code - HANGUL_BASE) % T_COUNT === 0;
	};
	var isCombiningL = function isCombiningL(code) {
	  return L_BASE <= code && code <= L_END;
	};
	var isCombiningV = function isCombiningV(code) {
	  return V_BASE <= code && code <= V_END;
	};
	var isCombiningT = function isCombiningT(code) {
	  return T_BASE + 1 && 1 <= code && code <= T_END;
	};

	// Character categories
	var X = 0; // Other character
	var L = 1; // Leading consonant
	var V = 2; // Medial vowel
	var T = 3; // Trailing consonant
	var LV = 4; // Composed <LV> syllable
	var LVT = 5; // Composed <LVT> syllable
	var M = 6; // Tone mark

	// This function classifies a character using the above categories.
	function getType(code) {
	  if (isL(code)) {
	    return L;
	  }
	  if (isV(code)) {
	    return V;
	  }
	  if (isT(code)) {
	    return T;
	  }
	  if (isLV(code)) {
	    return LV;
	  }
	  if (isLVT(code)) {
	    return LVT;
	  }
	  if (isTone(code)) {
	    return M;
	  }
	  return X;
	}

	// State machine actions
	var NO_ACTION = 0;
	var DECOMPOSE = 1;
	var COMPOSE = 2;
	var TONE_MARK = 4;
	var INVALID = 5;

	// Build a state machine that accepts valid syllables, and applies actions along the way.
	// The logic this is implementing is documented at the top of the file.
	var STATE_TABLE$1 = [
	//       X                 L                 V                T                  LV                LVT               M
	// State 0: start state
	[[NO_ACTION, 0], [NO_ACTION, 1], [NO_ACTION, 0], [NO_ACTION, 0], [DECOMPOSE, 2], [DECOMPOSE, 3], [INVALID, 0]],

	// State 1: <L>
	[[NO_ACTION, 0], [NO_ACTION, 1], [COMPOSE, 2], [NO_ACTION, 0], [DECOMPOSE, 2], [DECOMPOSE, 3], [INVALID, 0]],

	// State 2: <L,V> or <LV>
	[[NO_ACTION, 0], [NO_ACTION, 1], [NO_ACTION, 0], [COMPOSE, 3], [DECOMPOSE, 2], [DECOMPOSE, 3], [TONE_MARK, 0]],

	// State 3: <L,V,T> or <LVT>
	[[NO_ACTION, 0], [NO_ACTION, 1], [NO_ACTION, 0], [NO_ACTION, 0], [DECOMPOSE, 2], [DECOMPOSE, 3], [TONE_MARK, 0]]];

	function getGlyph(font, code, features) {
	  return new GlyphInfo(font, font.glyphForCodePoint(code).id, [code], features);
	}

	function decompose(glyphs, i, font) {
	  var glyph = glyphs[i];
	  var code = glyph.codePoints[0];

	  var s = code - HANGUL_BASE;
	  var t = T_BASE + s % T_COUNT;
	  s = s / T_COUNT | 0;
	  var l = L_BASE + s / V_COUNT | 0;
	  var v = V_BASE + s % V_COUNT;

	  // Don't decompose if all of the components are not available
	  if (!font.hasGlyphForCodePoint(l) || !font.hasGlyphForCodePoint(v) || t !== T_BASE && !font.hasGlyphForCodePoint(t)) {
	    return i;
	  }

	  // Replace the current glyph with decomposed L, V, and T glyphs,
	  // and apply the proper OpenType features to each component.
	  var ljmo = getGlyph(font, l, glyph.features);
	  ljmo.features.ljmo = true;

	  var vjmo = getGlyph(font, v, glyph.features);
	  vjmo.features.vjmo = true;

	  var insert = [ljmo, vjmo];

	  if (t > T_BASE) {
	    var tjmo = getGlyph(font, t, glyph.features);
	    tjmo.features.tjmo = true;
	    insert.push(tjmo);
	  }

	  glyphs.splice.apply(glyphs, [i, 1].concat(insert));
	  return i + insert.length - 1;
	}

	function compose(glyphs, i, font) {
	  var glyph = glyphs[i];
	  var code = glyphs[i].codePoints[0];
	  var type = getType(code);

	  var prev = glyphs[i - 1].codePoints[0];
	  var prevType = getType(prev);

	  // Figure out what type of syllable we're dealing with
	  var lv = void 0,
	      ljmo = void 0,
	      vjmo = void 0,
	      tjmo = void 0;
	  if (prevType === LV && type === T) {
	    // <LV,T>
	    lv = prev;
	    tjmo = glyph;
	  } else {
	    if (type === V) {
	      // <L,V>
	      ljmo = glyphs[i - 1];
	      vjmo = glyph;
	    } else {
	      // <L,V,T>
	      ljmo = glyphs[i - 2];
	      vjmo = glyphs[i - 1];
	      tjmo = glyph;
	    }

	    var l = ljmo.codePoints[0];
	    var v = vjmo.codePoints[0];

	    // Make sure L and V are combining characters
	    if (isCombiningL(l) && isCombiningV(v)) {
	      lv = HANGUL_BASE + ((l - L_BASE) * V_COUNT + (v - V_BASE)) * T_COUNT;
	    }
	  }

	  var t = tjmo && tjmo.codePoints[0] || T_BASE;
	  if (lv != null && (t === T_BASE || isCombiningT(t))) {
	    var s = lv + (t - T_BASE);

	    // Replace with a composed glyph if supported by the font,
	    // otherwise apply the proper OpenType features to each component.
	    if (font.hasGlyphForCodePoint(s)) {
	      var del = prevType === V ? 3 : 2;
	      glyphs.splice(i - del + 1, del, getGlyph(font, s, glyph.features));
	      return i - del + 1;
	    }
	  }

	  // Didn't compose (either a non-combining component or unsupported by font).
	  if (ljmo) {
	    ljmo.features.ljmo = true;
	  }
	  if (vjmo) {
	    vjmo.features.vjmo = true;
	  }
	  if (tjmo) {
	    tjmo.features.tjmo = true;
	  }

	  if (prevType === LV) {
	    // Sequence was originally <L,V>, which got combined earlier.
	    // Either the T was non-combining, or the LVT glyph wasn't supported.
	    // Decompose the glyph again and apply OT features.
	    decompose(glyphs, i - 1, font);
	    return i + 1;
	  }

	  return i;
	}

	function getLength(code) {
	  switch (getType(code)) {
	    case LV:
	    case LVT:
	      return 1;
	    case V:
	      return 2;
	    case T:
	      return 3;
	  }
	}

	function reorderToneMark(glyphs, i, font) {
	  var glyph = glyphs[i];
	  var code = glyphs[i].codePoints[0];

	  // Move tone mark to the beginning of the previous syllable, unless it is zero width
	  if (font.glyphForCodePoint(code).advanceWidth === 0) {
	    return;
	  }

	  var prev = glyphs[i - 1].codePoints[0];
	  var len = getLength(prev);

	  glyphs.splice(i, 1);
	  return glyphs.splice(i - len, 0, glyph);
	}

	function insertDottedCircle(glyphs, i, font) {
	  var glyph = glyphs[i];
	  var code = glyphs[i].codePoints[0];

	  if (font.hasGlyphForCodePoint(DOTTED_CIRCLE)) {
	    var dottedCircle = getGlyph(font, DOTTED_CIRCLE, glyph.features);

	    // If the tone mark is zero width, insert the dotted circle before, otherwise after
	    var idx = font.glyphForCodePoint(code).advanceWidth === 0 ? i : i + 1;
	    glyphs.splice(idx, 0, dottedCircle);
	    i++;
	  }

	  return i;
	}

	var stateTable = [[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 2, 3, 4, 5, 6, 7, 8, 9, 0, 10, 11, 11, 12, 13, 14, 15, 16, 17], [0, 0, 0, 18, 19, 20, 21, 22, 23, 0, 24, 0, 0, 25, 26, 0, 0, 27, 0], [0, 0, 0, 28, 29, 30, 31, 32, 33, 0, 34, 0, 0, 35, 36, 0, 0, 37, 0], [0, 0, 0, 38, 5, 7, 7, 8, 9, 0, 10, 0, 0, 0, 13, 0, 0, 16, 0], [0, 39, 0, 0, 0, 40, 41, 0, 9, 0, 10, 0, 0, 0, 42, 0, 39, 0, 0], [0, 0, 0, 0, 43, 44, 44, 8, 9, 0, 0, 0, 0, 12, 43, 0, 0, 0, 0], [0, 0, 0, 0, 43, 44, 44, 8, 9, 0, 0, 0, 0, 0, 43, 0, 0, 0, 0], [0, 0, 0, 45, 46, 47, 48, 49, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 50, 0, 0, 51, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 52, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 53, 54, 55, 56, 57, 58, 0, 59, 0, 0, 60, 61, 0, 0, 62, 0], [0, 0, 0, 4, 5, 7, 7, 8, 9, 0, 10, 0, 0, 0, 13, 0, 0, 16, 0], [0, 63, 64, 0, 0, 40, 41, 0, 9, 0, 10, 0, 0, 0, 42, 0, 63, 0, 0], [0, 2, 3, 4, 5, 6, 7, 8, 9, 0, 10, 11, 11, 12, 13, 0, 2, 16, 0], [0, 0, 0, 18, 65, 20, 21, 22, 23, 0, 24, 0, 0, 25, 26, 0, 0, 27, 0], [0, 0, 0, 0, 66, 67, 67, 8, 9, 0, 10, 0, 0, 0, 68, 0, 0, 0, 0], [0, 0, 0, 69, 0, 70, 70, 0, 71, 0, 72, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 73, 19, 74, 74, 22, 23, 0, 24, 0, 0, 0, 26, 0, 0, 27, 0], [0, 75, 0, 0, 0, 76, 77, 0, 23, 0, 24, 0, 0, 0, 78, 0, 75, 0, 0], [0, 0, 0, 0, 79, 80, 80, 22, 23, 0, 0, 0, 0, 25, 79, 0, 0, 0, 0], [0, 0, 0, 18, 19, 20, 74, 22, 23, 0, 24, 0, 0, 25, 26, 0, 0, 27, 0], [0, 0, 0, 81, 82, 83, 84, 85, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 86, 0, 0, 87, 0, 24, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 88, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 18, 19, 74, 74, 22, 23, 0, 24, 0, 0, 0, 26, 0, 0, 27, 0], [0, 89, 90, 0, 0, 76, 77, 0, 23, 0, 24, 0, 0, 0, 78, 0, 89, 0, 0], [0, 0, 0, 0, 91, 92, 92, 22, 23, 0, 24, 0, 0, 0, 93, 0, 0, 0, 0], [0, 0, 0, 94, 29, 95, 31, 32, 33, 0, 34, 0, 0, 0, 36, 0, 0, 37, 0], [0, 96, 0, 0, 0, 97, 98, 0, 33, 0, 34, 0, 0, 0, 99, 0, 96, 0, 0], [0, 0, 0, 0, 100, 101, 101, 32, 33, 0, 0, 0, 0, 35, 100, 0, 0, 0, 0], [0, 0, 0, 0, 100, 101, 101, 32, 33, 0, 0, 0, 0, 0, 100, 0, 0, 0, 0], [0, 0, 0, 102, 103, 104, 105, 106, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 107, 0, 0, 108, 0, 34, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 109, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 28, 29, 95, 31, 32, 33, 0, 34, 0, 0, 0, 36, 0, 0, 37, 0], [0, 110, 111, 0, 0, 97, 98, 0, 33, 0, 34, 0, 0, 0, 99, 0, 110, 0, 0], [0, 0, 0, 0, 112, 113, 113, 32, 33, 0, 34, 0, 0, 0, 114, 0, 0, 0, 0], [0, 0, 0, 0, 5, 7, 7, 8, 9, 0, 10, 0, 0, 0, 13, 0, 0, 16, 0], [0, 0, 0, 115, 116, 117, 118, 8, 9, 0, 10, 0, 0, 119, 120, 0, 0, 16, 0], [0, 0, 0, 0, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 39, 0, 122, 0, 123, 123, 8, 9, 0, 10, 0, 0, 0, 42, 0, 39, 0, 0], [0, 124, 64, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 124, 0, 0], [0, 39, 0, 0, 0, 121, 125, 0, 9, 0, 10, 0, 0, 0, 42, 0, 39, 0, 0], [0, 0, 0, 0, 0, 126, 126, 8, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 46, 47, 48, 49, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 47, 47, 49, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 127, 127, 49, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 128, 127, 127, 49, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 129, 130, 131, 132, 133, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 50, 0, 0, 0, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 134, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 135, 54, 56, 56, 57, 58, 0, 59, 0, 0, 0, 61, 0, 0, 62, 0], [0, 136, 0, 0, 0, 137, 138, 0, 58, 0, 59, 0, 0, 0, 139, 0, 136, 0, 0], [0, 0, 0, 0, 140, 141, 141, 57, 58, 0, 0, 0, 0, 60, 140, 0, 0, 0, 0], [0, 0, 0, 0, 140, 141, 141, 57, 58, 0, 0, 0, 0, 0, 140, 0, 0, 0, 0], [0, 0, 0, 142, 143, 144, 145, 146, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 147, 0, 0, 148, 0, 59, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 149, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 53, 54, 56, 56, 57, 58, 0, 59, 0, 0, 0, 61, 0, 0, 62, 0], [0, 150, 151, 0, 0, 137, 138, 0, 58, 0, 59, 0, 0, 0, 139, 0, 150, 0, 0], [0, 0, 0, 0, 152, 153, 153, 57, 58, 0, 59, 0, 0, 0, 154, 0, 0, 0, 0], [0, 0, 0, 155, 116, 156, 157, 8, 9, 0, 10, 0, 0, 158, 120, 0, 0, 16, 0], [0, 0, 0, 0, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0], [0, 75, 3, 4, 5, 159, 160, 8, 161, 0, 162, 0, 11, 12, 163, 0, 75, 16, 0], [0, 0, 0, 0, 0, 40, 164, 0, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 165, 44, 44, 8, 9, 0, 0, 0, 0, 0, 165, 0, 0, 0, 0], [0, 124, 64, 0, 0, 40, 164, 0, 9, 0, 10, 0, 0, 0, 42, 0, 124, 0, 0], [0, 0, 0, 0, 0, 70, 70, 0, 71, 0, 72, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 71, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 166, 0, 0, 167, 0, 72, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 168, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 19, 74, 74, 22, 23, 0, 24, 0, 0, 0, 26, 0, 0, 27, 0], [0, 0, 0, 0, 79, 80, 80, 22, 23, 0, 0, 0, 0, 0, 79, 0, 0, 0, 0], [0, 0, 0, 169, 170, 171, 172, 22, 23, 0, 24, 0, 0, 173, 174, 0, 0, 27, 0], [0, 0, 0, 0, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 75, 0, 176, 0, 177, 177, 22, 23, 0, 24, 0, 0, 0, 78, 0, 75, 0, 0], [0, 178, 90, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 178, 0, 0], [0, 75, 0, 0, 0, 175, 179, 0, 23, 0, 24, 0, 0, 0, 78, 0, 75, 0, 0], [0, 0, 0, 0, 0, 180, 180, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 82, 83, 84, 85, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 83, 83, 85, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 181, 181, 85, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 182, 181, 181, 85, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 183, 184, 185, 186, 187, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 24, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 86, 0, 0, 0, 0, 24, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 188, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 189, 170, 190, 191, 22, 23, 0, 24, 0, 0, 192, 174, 0, 0, 27, 0], [0, 0, 0, 0, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 76, 193, 0, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 194, 80, 80, 22, 23, 0, 0, 0, 0, 0, 194, 0, 0, 0, 0], [0, 178, 90, 0, 0, 76, 193, 0, 23, 0, 24, 0, 0, 0, 78, 0, 178, 0, 0], [0, 0, 0, 0, 29, 95, 31, 32, 33, 0, 34, 0, 0, 0, 36, 0, 0, 37, 0], [0, 0, 0, 0, 100, 101, 101, 32, 33, 0, 0, 0, 0, 0, 100, 0, 0, 0, 0], [0, 0, 0, 195, 196, 197, 198, 32, 33, 0, 34, 0, 0, 199, 200, 0, 0, 37, 0], [0, 0, 0, 0, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 96, 0, 202, 0, 203, 203, 32, 33, 0, 34, 0, 0, 0, 99, 0, 96, 0, 0], [0, 204, 111, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 204, 0, 0], [0, 96, 0, 0, 0, 201, 205, 0, 33, 0, 34, 0, 0, 0, 99, 0, 96, 0, 0], [0, 0, 0, 0, 0, 206, 206, 32, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 103, 104, 105, 106, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 104, 104, 106, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 207, 207, 106, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 208, 207, 207, 106, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 209, 210, 211, 212, 213, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 34, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 107, 0, 0, 0, 0, 34, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 214, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 215, 196, 216, 217, 32, 33, 0, 34, 0, 0, 218, 200, 0, 0, 37, 0], [0, 0, 0, 0, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 97, 219, 0, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 220, 101, 101, 32, 33, 0, 0, 0, 0, 0, 220, 0, 0, 0, 0], [0, 204, 111, 0, 0, 97, 219, 0, 33, 0, 34, 0, 0, 0, 99, 0, 204, 0, 0], [0, 0, 0, 221, 116, 222, 222, 8, 9, 0, 10, 0, 0, 0, 120, 0, 0, 16, 0], [0, 223, 0, 0, 0, 40, 224, 0, 9, 0, 10, 0, 0, 0, 42, 0, 223, 0, 0], [0, 0, 0, 0, 225, 44, 44, 8, 9, 0, 0, 0, 0, 119, 225, 0, 0, 0, 0], [0, 0, 0, 115, 116, 117, 222, 8, 9, 0, 10, 0, 0, 119, 120, 0, 0, 16, 0], [0, 0, 0, 115, 116, 222, 222, 8, 9, 0, 10, 0, 0, 0, 120, 0, 0, 16, 0], [0, 226, 64, 0, 0, 40, 224, 0, 9, 0, 10, 0, 0, 0, 42, 0, 226, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 39, 0, 0, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 39, 0, 0], [0, 0, 0, 0, 0, 44, 44, 8, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 227, 0, 228, 229, 0, 9, 0, 10, 0, 0, 230, 0, 0, 0, 0, 0], [0, 39, 0, 122, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 39, 0, 0], [0, 0, 0, 0, 0, 0, 0, 8, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 231, 231, 49, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 232, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 130, 131, 132, 133, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 131, 131, 133, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 233, 233, 133, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 234, 233, 233, 133, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 235, 236, 237, 238, 239, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 54, 56, 56, 57, 58, 0, 59, 0, 0, 0, 61, 0, 0, 62, 0], [0, 0, 0, 240, 241, 242, 243, 57, 58, 0, 59, 0, 0, 244, 245, 0, 0, 62, 0], [0, 0, 0, 0, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 136, 0, 247, 0, 248, 248, 57, 58, 0, 59, 0, 0, 0, 139, 0, 136, 0, 0], [0, 249, 151, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 249, 0, 0], [0, 136, 0, 0, 0, 246, 250, 0, 58, 0, 59, 0, 0, 0, 139, 0, 136, 0, 0], [0, 0, 0, 0, 0, 251, 251, 57, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 143, 144, 145, 146, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 144, 144, 146, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 252, 252, 146, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 253, 252, 252, 146, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 254, 255, 256, 257, 258, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 59, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 147, 0, 0, 0, 0, 59, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 259, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 260, 241, 261, 262, 57, 58, 0, 59, 0, 0, 263, 245, 0, 0, 62, 0], [0, 0, 0, 0, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 137, 264, 0, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 265, 141, 141, 57, 58, 0, 0, 0, 0, 0, 265, 0, 0, 0, 0], [0, 249, 151, 0, 0, 137, 264, 0, 58, 0, 59, 0, 0, 0, 139, 0, 249, 0, 0], [0, 0, 0, 221, 116, 222, 222, 8, 9, 0, 10, 0, 0, 0, 120, 0, 0, 16, 0], [0, 0, 0, 0, 225, 44, 44, 8, 9, 0, 0, 0, 0, 158, 225, 0, 0, 0, 0], [0, 0, 0, 155, 116, 156, 222, 8, 9, 0, 10, 0, 0, 158, 120, 0, 0, 16, 0], [0, 0, 0, 155, 116, 222, 222, 8, 9, 0, 10, 0, 0, 0, 120, 0, 0, 16, 0], [0, 0, 0, 0, 43, 266, 266, 8, 161, 0, 24, 0, 0, 12, 267, 0, 0, 0, 0], [0, 75, 0, 176, 43, 268, 268, 269, 161, 0, 24, 0, 0, 0, 267, 0, 75, 0, 0], [0, 0, 0, 0, 0, 270, 0, 0, 271, 0, 162, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 272, 0, 0, 0, 0, 0, 0, 0, 0], [0, 273, 274, 0, 0, 40, 41, 0, 9, 0, 10, 0, 0, 0, 42, 0, 273, 0, 0], [0, 0, 0, 40, 0, 123, 123, 8, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 121, 275, 0, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 72, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 166, 0, 0, 0, 0, 72, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 276, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 277, 170, 278, 278, 22, 23, 0, 24, 0, 0, 0, 174, 0, 0, 27, 0], [0, 279, 0, 0, 0, 76, 280, 0, 23, 0, 24, 0, 0, 0, 78, 0, 279, 0, 0], [0, 0, 0, 0, 281, 80, 80, 22, 23, 0, 0, 0, 0, 173, 281, 0, 0, 0, 0], [0, 0, 0, 169, 170, 171, 278, 22, 23, 0, 24, 0, 0, 173, 174, 0, 0, 27, 0], [0, 0, 0, 169, 170, 278, 278, 22, 23, 0, 24, 0, 0, 0, 174, 0, 0, 27, 0], [0, 282, 90, 0, 0, 76, 280, 0, 23, 0, 24, 0, 0, 0, 78, 0, 282, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 75, 0, 0, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 75, 0, 0], [0, 0, 0, 0, 0, 80, 80, 22, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 283, 0, 284, 285, 0, 23, 0, 24, 0, 0, 286, 0, 0, 0, 0, 0], [0, 75, 0, 176, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 75, 0, 0], [0, 0, 0, 0, 0, 0, 0, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 287, 287, 85, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 288, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 184, 185, 186, 187, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 185, 185, 187, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 289, 289, 187, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 290, 289, 289, 187, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 291, 292, 293, 294, 295, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 277, 170, 278, 278, 22, 23, 0, 24, 0, 0, 0, 174, 0, 0, 27, 0], [0, 0, 0, 0, 281, 80, 80, 22, 23, 0, 0, 0, 0, 192, 281, 0, 0, 0, 0], [0, 0, 0, 189, 170, 190, 278, 22, 23, 0, 24, 0, 0, 192, 174, 0, 0, 27, 0], [0, 0, 0, 189, 170, 278, 278, 22, 23, 0, 24, 0, 0, 0, 174, 0, 0, 27, 0], [0, 0, 0, 76, 0, 177, 177, 22, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 175, 296, 0, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 297, 196, 298, 298, 32, 33, 0, 34, 0, 0, 0, 200, 0, 0, 37, 0], [0, 299, 0, 0, 0, 97, 300, 0, 33, 0, 34, 0, 0, 0, 99, 0, 299, 0, 0], [0, 0, 0, 0, 301, 101, 101, 32, 33, 0, 0, 0, 0, 199, 301, 0, 0, 0, 0], [0, 0, 0, 195, 196, 197, 298, 32, 33, 0, 34, 0, 0, 199, 200, 0, 0, 37, 0], [0, 0, 0, 195, 196, 298, 298, 32, 33, 0, 34, 0, 0, 0, 200, 0, 0, 37, 0], [0, 302, 111, 0, 0, 97, 300, 0, 33, 0, 34, 0, 0, 0, 99, 0, 302, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 96, 0, 0, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 96, 0, 0], [0, 0, 0, 0, 0, 101, 101, 32, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 303, 0, 304, 305, 0, 33, 0, 34, 0, 0, 306, 0, 0, 0, 0, 0], [0, 96, 0, 202, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 96, 0, 0], [0, 0, 0, 0, 0, 0, 0, 32, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 307, 307, 106, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 308, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 210, 211, 212, 213, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 211, 211, 213, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 309, 309, 213, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 310, 309, 309, 213, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 311, 312, 313, 314, 315, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 297, 196, 298, 298, 32, 33, 0, 34, 0, 0, 0, 200, 0, 0, 37, 0], [0, 0, 0, 0, 301, 101, 101, 32, 33, 0, 0, 0, 0, 218, 301, 0, 0, 0, 0], [0, 0, 0, 215, 196, 216, 298, 32, 33, 0, 34, 0, 0, 218, 200, 0, 0, 37, 0], [0, 0, 0, 215, 196, 298, 298, 32, 33, 0, 34, 0, 0, 0, 200, 0, 0, 37, 0], [0, 0, 0, 97, 0, 203, 203, 32, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 201, 316, 0, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 116, 222, 222, 8, 9, 0, 10, 0, 0, 0, 120, 0, 0, 16, 0], [0, 0, 0, 0, 225, 44, 44, 8, 9, 0, 0, 0, 0, 0, 225, 0, 0, 0, 0], [0, 0, 0, 317, 318, 319, 320, 8, 9, 0, 10, 0, 0, 321, 322, 0, 0, 16, 0], [0, 223, 0, 323, 0, 123, 123, 8, 9, 0, 10, 0, 0, 0, 42, 0, 223, 0, 0], [0, 223, 0, 0, 0, 121, 324, 0, 9, 0, 10, 0, 0, 0, 42, 0, 223, 0, 0], [0, 0, 0, 325, 318, 326, 327, 8, 9, 0, 10, 0, 0, 328, 322, 0, 0, 16, 0], [0, 0, 0, 64, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 9, 0, 0, 0, 0, 230, 0, 0, 0, 0, 0], [0, 0, 0, 227, 0, 228, 121, 0, 9, 0, 10, 0, 0, 230, 0, 0, 0, 0, 0], [0, 0, 0, 227, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 49, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 46, 0, 0], [0, 0, 0, 0, 0, 329, 329, 133, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 330, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 236, 237, 238, 239, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 237, 237, 239, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 331, 331, 239, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 332, 331, 331, 239, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 333, 40, 121, 334, 0, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 335, 241, 336, 336, 57, 58, 0, 59, 0, 0, 0, 245, 0, 0, 62, 0], [0, 337, 0, 0, 0, 137, 338, 0, 58, 0, 59, 0, 0, 0, 139, 0, 337, 0, 0], [0, 0, 0, 0, 339, 141, 141, 57, 58, 0, 0, 0, 0, 244, 339, 0, 0, 0, 0], [0, 0, 0, 240, 241, 242, 336, 57, 58, 0, 59, 0, 0, 244, 245, 0, 0, 62, 0], [0, 0, 0, 240, 241, 336, 336, 57, 58, 0, 59, 0, 0, 0, 245, 0, 0, 62, 0], [0, 340, 151, 0, 0, 137, 338, 0, 58, 0, 59, 0, 0, 0, 139, 0, 340, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 136, 0, 0, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 136, 0, 0], [0, 0, 0, 0, 0, 141, 141, 57, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 341, 0, 342, 343, 0, 58, 0, 59, 0, 0, 344, 0, 0, 0, 0, 0], [0, 136, 0, 247, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 136, 0, 0], [0, 0, 0, 0, 0, 0, 0, 57, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 345, 345, 146, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 346, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 255, 256, 257, 258, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 256, 256, 258, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 347, 347, 258, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 348, 347, 347, 258, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 349, 350, 351, 352, 353, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 335, 241, 336, 336, 57, 58, 0, 59, 0, 0, 0, 245, 0, 0, 62, 0], [0, 0, 0, 0, 339, 141, 141, 57, 58, 0, 0, 0, 0, 263, 339, 0, 0, 0, 0], [0, 0, 0, 260, 241, 261, 336, 57, 58, 0, 59, 0, 0, 263, 245, 0, 0, 62, 0], [0, 0, 0, 260, 241, 336, 336, 57, 58, 0, 59, 0, 0, 0, 245, 0, 0, 62, 0], [0, 0, 0, 137, 0, 248, 248, 57, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 246, 354, 0, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 126, 126, 8, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 355, 90, 0, 0, 121, 125, 0, 9, 0, 10, 0, 0, 0, 42, 0, 355, 0, 0], [0, 0, 0, 0, 0, 356, 356, 269, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 357, 358, 359, 360, 361, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 162, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 270, 0, 0, 0, 0, 162, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 363, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 364, 116, 365, 366, 8, 161, 0, 162, 0, 0, 367, 120, 0, 0, 16, 0], [0, 0, 0, 0, 0, 368, 368, 0, 161, 0, 162, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 40, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 170, 278, 278, 22, 23, 0, 24, 0, 0, 0, 174, 0, 0, 27, 0], [0, 0, 0, 0, 281, 80, 80, 22, 23, 0, 0, 0, 0, 0, 281, 0, 0, 0, 0], [0, 0, 0, 369, 370, 371, 372, 22, 23, 0, 24, 0, 0, 373, 374, 0, 0, 27, 0], [0, 279, 0, 375, 0, 177, 177, 22, 23, 0, 24, 0, 0, 0, 78, 0, 279, 0, 0], [0, 279, 0, 0, 0, 175, 376, 0, 23, 0, 24, 0, 0, 0, 78, 0, 279, 0, 0], [0, 0, 0, 377, 370, 378, 379, 22, 23, 0, 24, 0, 0, 380, 374, 0, 0, 27, 0], [0, 0, 0, 90, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 23, 0, 0, 0, 0, 286, 0, 0, 0, 0, 0], [0, 0, 0, 283, 0, 284, 175, 0, 23, 0, 24, 0, 0, 286, 0, 0, 0, 0, 0], [0, 0, 0, 283, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 85, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 82, 0, 0], [0, 0, 0, 0, 0, 381, 381, 187, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 382, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 292, 293, 294, 295, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 293, 293, 295, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 0, 383, 383, 295, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 384, 383, 383, 295, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 385, 76, 175, 386, 0, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 76, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 196, 298, 298, 32, 33, 0, 34, 0, 0, 0, 200, 0, 0, 37, 0], [0, 0, 0, 0, 301, 101, 101, 32, 33, 0, 0, 0, 0, 0, 301, 0, 0, 0, 0], [0, 0, 0, 387, 388, 389, 390, 32, 33, 0, 34, 0, 0, 391, 392, 0, 0, 37, 0], [0, 299, 0, 393, 0, 203, 203, 32, 33, 0, 34, 0, 0, 0, 99, 0, 299, 0, 0], [0, 299, 0, 0, 0, 201, 394, 0, 33, 0, 34, 0, 0, 0, 99, 0, 299, 0, 0], [0, 0, 0, 395, 388, 396, 397, 32, 33, 0, 34, 0, 0, 398, 392, 0, 0, 37, 0], [0, 0, 0, 111, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 33, 0, 0, 0, 0, 306, 0, 0, 0, 0, 0], [0, 0, 0, 303, 0, 304, 201, 0, 33, 0, 34, 0, 0, 306, 0, 0, 0, 0, 0], [0, 0, 0, 303, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 106, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 103, 0, 0], [0, 0, 0, 0, 0, 399, 399, 213, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 400, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 312, 313, 314, 315, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 313, 313, 315, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 0, 401, 401, 315, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 402, 401, 401, 315, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 403, 97, 201, 404, 0, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 97, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 405, 318, 406, 406, 8, 9, 0, 10, 0, 0, 0, 322, 0, 0, 16, 0], [0, 407, 0, 0, 0, 40, 408, 0, 9, 0, 10, 0, 0, 0, 42, 0, 407, 0, 0], [0, 0, 0, 0, 409, 44, 44, 8, 9, 0, 0, 0, 0, 321, 409, 0, 0, 0, 0], [0, 0, 0, 317, 318, 319, 406, 8, 9, 0, 10, 0, 0, 321, 322, 0, 0, 16, 0], [0, 0, 0, 317, 318, 406, 406, 8, 9, 0, 10, 0, 0, 0, 322, 0, 0, 16, 0], [0, 410, 64, 0, 0, 40, 408, 0, 9, 0, 10, 0, 0, 0, 42, 0, 410, 0, 0], [0, 223, 0, 0, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 223, 0, 0], [0, 223, 0, 323, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 223, 0, 0], [0, 0, 0, 405, 318, 406, 406, 8, 9, 0, 10, 0, 0, 0, 322, 0, 0, 16, 0], [0, 0, 0, 0, 409, 44, 44, 8, 9, 0, 0, 0, 0, 328, 409, 0, 0, 0, 0], [0, 0, 0, 325, 318, 326, 406, 8, 9, 0, 10, 0, 0, 328, 322, 0, 0, 16, 0], [0, 0, 0, 325, 318, 406, 406, 8, 9, 0, 10, 0, 0, 0, 322, 0, 0, 16, 0], [0, 0, 0, 0, 0, 0, 0, 133, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 130, 0, 0], [0, 0, 0, 0, 0, 411, 411, 239, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 412, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 40, 121, 334, 0, 9, 0, 10, 0, 0, 0, 42, 0, 0, 0, 0], [0, 0, 0, 0, 413, 0, 0, 0, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 241, 336, 336, 57, 58, 0, 59, 0, 0, 0, 245, 0, 0, 62, 0], [0, 0, 0, 0, 339, 141, 141, 57, 58, 0, 0, 0, 0, 0, 339, 0, 0, 0, 0], [0, 0, 0, 414, 415, 416, 417, 57, 58, 0, 59, 0, 0, 418, 419, 0, 0, 62, 0], [0, 337, 0, 420, 0, 248, 248, 57, 58, 0, 59, 0, 0, 0, 139, 0, 337, 0, 0], [0, 337, 0, 0, 0, 246, 421, 0, 58, 0, 59, 0, 0, 0, 139, 0, 337, 0, 0], [0, 0, 0, 422, 415, 423, 424, 57, 58, 0, 59, 0, 0, 425, 419, 0, 0, 62, 0], [0, 0, 0, 151, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 58, 0, 0, 0, 0, 344, 0, 0, 0, 0, 0], [0, 0, 0, 341, 0, 342, 246, 0, 58, 0, 59, 0, 0, 344, 0, 0, 0, 0, 0], [0, 0, 0, 341, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 146, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 143, 0, 0], [0, 0, 0, 0, 0, 426, 426, 258, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 427, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 350, 351, 352, 353, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 351, 351, 353, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 0, 428, 428, 353, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 429, 428, 428, 353, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 430, 137, 246, 431, 0, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 137, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 432, 116, 433, 434, 8, 161, 0, 162, 0, 0, 435, 120, 0, 0, 16, 0], [0, 0, 0, 0, 0, 180, 180, 269, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 358, 359, 360, 361, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 0, 359, 359, 361, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 0, 436, 436, 361, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 437, 436, 436, 361, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 438, 439, 440, 441, 442, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 443, 274, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 443, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 444, 116, 445, 445, 8, 161, 0, 162, 0, 0, 0, 120, 0, 0, 16, 0], [0, 0, 0, 0, 225, 44, 44, 8, 161, 0, 0, 0, 0, 367, 225, 0, 0, 0, 0], [0, 0, 0, 364, 116, 365, 445, 8, 161, 0, 162, 0, 0, 367, 120, 0, 0, 16, 0], [0, 0, 0, 364, 116, 445, 445, 8, 161, 0, 162, 0, 0, 0, 120, 0, 0, 16, 0], [0, 0, 0, 0, 0, 0, 0, 0, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 446, 370, 447, 447, 22, 23, 0, 24, 0, 0, 0, 374, 0, 0, 27, 0], [0, 448, 0, 0, 0, 76, 449, 0, 23, 0, 24, 0, 0, 0, 78, 0, 448, 0, 0], [0, 0, 0, 0, 450, 80, 80, 22, 23, 0, 0, 0, 0, 373, 450, 0, 0, 0, 0], [0, 0, 0, 369, 370, 371, 447, 22, 23, 0, 24, 0, 0, 373, 374, 0, 0, 27, 0], [0, 0, 0, 369, 370, 447, 447, 22, 23, 0, 24, 0, 0, 0, 374, 0, 0, 27, 0], [0, 451, 90, 0, 0, 76, 449, 0, 23, 0, 24, 0, 0, 0, 78, 0, 451, 0, 0], [0, 279, 0, 0, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 279, 0, 0], [0, 279, 0, 375, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 279, 0, 0], [0, 0, 0, 446, 370, 447, 447, 22, 23, 0, 24, 0, 0, 0, 374, 0, 0, 27, 0], [0, 0, 0, 0, 450, 80, 80, 22, 23, 0, 0, 0, 0, 380, 450, 0, 0, 0, 0], [0, 0, 0, 377, 370, 378, 447, 22, 23, 0, 24, 0, 0, 380, 374, 0, 0, 27, 0], [0, 0, 0, 377, 370, 447, 447, 22, 23, 0, 24, 0, 0, 0, 374, 0, 0, 27, 0], [0, 0, 0, 0, 0, 0, 0, 187, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 184, 0, 0], [0, 0, 0, 0, 0, 452, 452, 295, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 453, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 76, 175, 386, 0, 23, 0, 24, 0, 0, 0, 78, 0, 0, 0, 0], [0, 0, 0, 0, 454, 0, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 455, 388, 456, 456, 32, 33, 0, 34, 0, 0, 0, 392, 0, 0, 37, 0], [0, 457, 0, 0, 0, 97, 458, 0, 33, 0, 34, 0, 0, 0, 99, 0, 457, 0, 0], [0, 0, 0, 0, 459, 101, 101, 32, 33, 0, 0, 0, 0, 391, 459, 0, 0, 0, 0], [0, 0, 0, 387, 388, 389, 456, 32, 33, 0, 34, 0, 0, 391, 392, 0, 0, 37, 0], [0, 0, 0, 387, 388, 456, 456, 32, 33, 0, 34, 0, 0, 0, 392, 0, 0, 37, 0], [0, 460, 111, 0, 0, 97, 458, 0, 33, 0, 34, 0, 0, 0, 99, 0, 460, 0, 0], [0, 299, 0, 0, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 299, 0, 0], [0, 299, 0, 393, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 299, 0, 0], [0, 0, 0, 455, 388, 456, 456, 32, 33, 0, 34, 0, 0, 0, 392, 0, 0, 37, 0], [0, 0, 0, 0, 459, 101, 101, 32, 33, 0, 0, 0, 0, 398, 459, 0, 0, 0, 0], [0, 0, 0, 395, 388, 396, 456, 32, 33, 0, 34, 0, 0, 398, 392, 0, 0, 37, 0], [0, 0, 0, 395, 388, 456, 456, 32, 33, 0, 34, 0, 0, 0, 392, 0, 0, 37, 0], [0, 0, 0, 0, 0, 0, 0, 213, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 210, 0, 0], [0, 0, 0, 0, 0, 461, 461, 315, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 462, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 97, 201, 404, 0, 33, 0, 34, 0, 0, 0, 99, 0, 0, 0, 0], [0, 0, 0, 0, 463, 0, 0, 0, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 318, 406, 406, 8, 9, 0, 10, 0, 0, 0, 322, 0, 0, 16, 0], [0, 0, 0, 0, 409, 44, 44, 8, 9, 0, 0, 0, 0, 0, 409, 0, 0, 0, 0], [0, 0, 0, 464, 465, 466, 467, 8, 9, 0, 10, 0, 0, 468, 469, 0, 0, 16, 0], [0, 407, 0, 470, 0, 123, 123, 8, 9, 0, 10, 0, 0, 0, 42, 0, 407, 0, 0], [0, 407, 0, 0, 0, 121, 471, 0, 9, 0, 10, 0, 0, 0, 42, 0, 407, 0, 0], [0, 0, 0, 472, 465, 473, 474, 8, 9, 0, 10, 0, 0, 475, 469, 0, 0, 16, 0], [0, 0, 0, 0, 0, 0, 0, 239, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 236, 0, 0], [0, 0, 0, 0, 0, 0, 476, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 477, 415, 478, 478, 57, 58, 0, 59, 0, 0, 0, 419, 0, 0, 62, 0], [0, 479, 0, 0, 0, 137, 480, 0, 58, 0, 59, 0, 0, 0, 139, 0, 479, 0, 0], [0, 0, 0, 0, 481, 141, 141, 57, 58, 0, 0, 0, 0, 418, 481, 0, 0, 0, 0], [0, 0, 0, 414, 415, 416, 478, 57, 58, 0, 59, 0, 0, 418, 419, 0, 0, 62, 0], [0, 0, 0, 414, 415, 478, 478, 57, 58, 0, 59, 0, 0, 0, 419, 0, 0, 62, 0], [0, 482, 151, 0, 0, 137, 480, 0, 58, 0, 59, 0, 0, 0, 139, 0, 482, 0, 0], [0, 337, 0, 0, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 337, 0, 0], [0, 337, 0, 420, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 337, 0, 0], [0, 0, 0, 477, 415, 478, 478, 57, 58, 0, 59, 0, 0, 0, 419, 0, 0, 62, 0], [0, 0, 0, 0, 481, 141, 141, 57, 58, 0, 0, 0, 0, 425, 481, 0, 0, 0, 0], [0, 0, 0, 422, 415, 423, 478, 57, 58, 0, 59, 0, 0, 425, 419, 0, 0, 62, 0], [0, 0, 0, 422, 415, 478, 478, 57, 58, 0, 59, 0, 0, 0, 419, 0, 0, 62, 0], [0, 0, 0, 0, 0, 0, 0, 258, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 255, 0, 0], [0, 0, 0, 0, 0, 483, 483, 353, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 484, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 137, 246, 431, 0, 58, 0, 59, 0, 0, 0, 139, 0, 0, 0, 0], [0, 0, 0, 0, 485, 0, 0, 0, 58, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 444, 116, 445, 445, 8, 161, 0, 162, 0, 0, 0, 120, 0, 0, 16, 0], [0, 0, 0, 0, 225, 44, 44, 8, 161, 0, 0, 0, 0, 435, 225, 0, 0, 0, 0], [0, 0, 0, 432, 116, 433, 445, 8, 161, 0, 162, 0, 0, 435, 120, 0, 0, 16, 0], [0, 0, 0, 432, 116, 445, 445, 8, 161, 0, 162, 0, 0, 0, 120, 0, 0, 16, 0], [0, 0, 0, 0, 0, 486, 486, 361, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 487, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 439, 440, 441, 442, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 0, 440, 440, 442, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 0, 488, 488, 442, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 489, 488, 488, 442, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 490, 491, 492, 493, 494, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 495, 0, 496, 497, 0, 161, 0, 162, 0, 0, 498, 0, 0, 0, 0, 0], [0, 0, 0, 0, 116, 445, 445, 8, 161, 0, 162, 0, 0, 0, 120, 0, 0, 16, 0], [0, 0, 0, 0, 225, 44, 44, 8, 161, 0, 0, 0, 0, 0, 225, 0, 0, 0, 0], [0, 0, 0, 0, 370, 447, 447, 22, 23, 0, 24, 0, 0, 0, 374, 0, 0, 27, 0], [0, 0, 0, 0, 450, 80, 80, 22, 23, 0, 0, 0, 0, 0, 450, 0, 0, 0, 0], [0, 0, 0, 499, 500, 501, 502, 22, 23, 0, 24, 0, 0, 503, 504, 0, 0, 27, 0], [0, 448, 0, 505, 0, 177, 177, 22, 23, 0, 24, 0, 0, 0, 78, 0, 448, 0, 0], [0, 448, 0, 0, 0, 175, 506, 0, 23, 0, 24, 0, 0, 0, 78, 0, 448, 0, 0], [0, 0, 0, 507, 500, 508, 509, 22, 23, 0, 24, 0, 0, 510, 504, 0, 0, 27, 0], [0, 0, 0, 0, 0, 0, 0, 295, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 292, 0, 0], [0, 0, 0, 0, 0, 0, 511, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 388, 456, 456, 32, 33, 0, 34, 0, 0, 0, 392, 0, 0, 37, 0], [0, 0, 0, 0, 459, 101, 101, 32, 33, 0, 0, 0, 0, 0, 459, 0, 0, 0, 0], [0, 0, 0, 512, 513, 514, 515, 32, 33, 0, 34, 0, 0, 516, 517, 0, 0, 37, 0], [0, 457, 0, 518, 0, 203, 203, 32, 33, 0, 34, 0, 0, 0, 99, 0, 457, 0, 0], [0, 457, 0, 0, 0, 201, 519, 0, 33, 0, 34, 0, 0, 0, 99, 0, 457, 0, 0], [0, 0, 0, 520, 513, 521, 522, 32, 33, 0, 34, 0, 0, 523, 517, 0, 0, 37, 0], [0, 0, 0, 0, 0, 0, 0, 315, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 312, 0, 0], [0, 0, 0, 0, 0, 0, 524, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 525, 465, 526, 526, 8, 9, 0, 10, 0, 0, 0, 469, 0, 0, 16, 0], [0, 527, 0, 0, 0, 40, 528, 0, 9, 0, 10, 0, 0, 0, 42, 0, 527, 0, 0], [0, 0, 0, 0, 529, 44, 44, 8, 9, 0, 0, 0, 0, 468, 529, 0, 0, 0, 0], [0, 0, 0, 464, 465, 466, 526, 8, 9, 0, 10, 0, 0, 468, 469, 0, 0, 16, 0], [0, 0, 0, 464, 465, 526, 526, 8, 9, 0, 10, 0, 0, 0, 469, 0, 0, 16, 0], [0, 530, 64, 0, 0, 40, 528, 0, 9, 0, 10, 0, 0, 0, 42, 0, 530, 0, 0], [0, 407, 0, 0, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 407, 0, 0], [0, 407, 0, 470, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 407, 0, 0], [0, 0, 0, 525, 465, 526, 526, 8, 9, 0, 10, 0, 0, 0, 469, 0, 0, 16, 0], [0, 0, 0, 0, 529, 44, 44, 8, 9, 0, 0, 0, 0, 475, 529, 0, 0, 0, 0], [0, 0, 0, 472, 465, 473, 526, 8, 9, 0, 10, 0, 0, 475, 469, 0, 0, 16, 0], [0, 0, 0, 472, 465, 526, 526, 8, 9, 0, 10, 0, 0, 0, 469, 0, 0, 16, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 40, 0, 0], [0, 0, 0, 0, 415, 478, 478, 57, 58, 0, 59, 0, 0, 0, 419, 0, 0, 62, 0], [0, 0, 0, 0, 481, 141, 141, 57, 58, 0, 0, 0, 0, 0, 481, 0, 0, 0, 0], [0, 0, 0, 531, 532, 533, 534, 57, 58, 0, 59, 0, 0, 535, 536, 0, 0, 62, 0], [0, 479, 0, 537, 0, 248, 248, 57, 58, 0, 59, 0, 0, 0, 139, 0, 479, 0, 0], [0, 479, 0, 0, 0, 246, 538, 0, 58, 0, 59, 0, 0, 0, 139, 0, 479, 0, 0], [0, 0, 0, 539, 532, 540, 541, 57, 58, 0, 59, 0, 0, 542, 536, 0, 0, 62, 0], [0, 0, 0, 0, 0, 0, 0, 353, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 350, 0, 0], [0, 0, 0, 0, 0, 0, 543, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 361, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 358, 0, 0], [0, 0, 0, 0, 0, 544, 544, 442, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 545, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 491, 492, 493, 494, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 0, 492, 492, 494, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 0, 546, 546, 494, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 547, 546, 546, 494, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 548, 549, 368, 550, 0, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 274, 0, 368, 368, 0, 161, 0, 162, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 161, 0, 0, 0, 0, 498, 0, 0, 0, 0, 0], [0, 0, 0, 495, 0, 496, 368, 0, 161, 0, 162, 0, 0, 498, 0, 0, 0, 0, 0], [0, 0, 0, 495, 0, 368, 368, 0, 161, 0, 162, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 551, 500, 552, 552, 22, 23, 0, 24, 0, 0, 0, 504, 0, 0, 27, 0], [0, 553, 0, 0, 0, 76, 554, 0, 23, 0, 24, 0, 0, 0, 78, 0, 553, 0, 0], [0, 0, 0, 0, 555, 80, 80, 22, 23, 0, 0, 0, 0, 503, 555, 0, 0, 0, 0], [0, 0, 0, 499, 500, 501, 552, 22, 23, 0, 24, 0, 0, 503, 504, 0, 0, 27, 0], [0, 0, 0, 499, 500, 552, 552, 22, 23, 0, 24, 0, 0, 0, 504, 0, 0, 27, 0], [0, 556, 90, 0, 0, 76, 554, 0, 23, 0, 24, 0, 0, 0, 78, 0, 556, 0, 0], [0, 448, 0, 0, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 448, 0, 0], [0, 448, 0, 505, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 448, 0, 0], [0, 0, 0, 551, 500, 552, 552, 22, 23, 0, 24, 0, 0, 0, 504, 0, 0, 27, 0], [0, 0, 0, 0, 555, 80, 80, 22, 23, 0, 0, 0, 0, 510, 555, 0, 0, 0, 0], [0, 0, 0, 507, 500, 508, 552, 22, 23, 0, 24, 0, 0, 510, 504, 0, 0, 27, 0], [0, 0, 0, 507, 500, 552, 552, 22, 23, 0, 24, 0, 0, 0, 504, 0, 0, 27, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 76, 0, 0], [0, 0, 0, 557, 513, 558, 558, 32, 33, 0, 34, 0, 0, 0, 517, 0, 0, 37, 0], [0, 559, 0, 0, 0, 97, 560, 0, 33, 0, 34, 0, 0, 0, 99, 0, 559, 0, 0], [0, 0, 0, 0, 561, 101, 101, 32, 33, 0, 0, 0, 0, 516, 561, 0, 0, 0, 0], [0, 0, 0, 512, 513, 514, 558, 32, 33, 0, 34, 0, 0, 516, 517, 0, 0, 37, 0], [0, 0, 0, 512, 513, 558, 558, 32, 33, 0, 34, 0, 0, 0, 517, 0, 0, 37, 0], [0, 562, 111, 0, 0, 97, 560, 0, 33, 0, 34, 0, 0, 0, 99, 0, 562, 0, 0], [0, 457, 0, 0, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 457, 0, 0], [0, 457, 0, 518, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 457, 0, 0], [0, 0, 0, 557, 513, 558, 558, 32, 33, 0, 34, 0, 0, 0, 517, 0, 0, 37, 0], [0, 0, 0, 0, 561, 101, 101, 32, 33, 0, 0, 0, 0, 523, 561, 0, 0, 0, 0], [0, 0, 0, 520, 513, 521, 558, 32, 33, 0, 34, 0, 0, 523, 517, 0, 0, 37, 0], [0, 0, 0, 520, 513, 558, 558, 32, 33, 0, 34, 0, 0, 0, 517, 0, 0, 37, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 97, 0, 0], [0, 0, 0, 0, 465, 526, 526, 8, 9, 0, 10, 0, 0, 0, 469, 0, 0, 16, 0], [0, 0, 0, 0, 529, 44, 44, 8, 9, 0, 0, 0, 0, 0, 529, 0, 0, 0, 0], [0, 0, 0, 563, 66, 564, 565, 8, 9, 0, 10, 0, 0, 566, 68, 0, 0, 16, 0], [0, 527, 0, 567, 0, 123, 123, 8, 9, 0, 10, 0, 0, 0, 42, 0, 527, 0, 0], [0, 527, 0, 0, 0, 121, 568, 0, 9, 0, 10, 0, 0, 0, 42, 0, 527, 0, 0], [0, 0, 0, 569, 66, 570, 571, 8, 9, 0, 10, 0, 0, 572, 68, 0, 0, 16, 0], [0, 0, 0, 573, 532, 574, 574, 57, 58, 0, 59, 0, 0, 0, 536, 0, 0, 62, 0], [0, 575, 0, 0, 0, 137, 576, 0, 58, 0, 59, 0, 0, 0, 139, 0, 575, 0, 0], [0, 0, 0, 0, 577, 141, 141, 57, 58, 0, 0, 0, 0, 535, 577, 0, 0, 0, 0], [0, 0, 0, 531, 532, 533, 574, 57, 58, 0, 59, 0, 0, 535, 536, 0, 0, 62, 0], [0, 0, 0, 531, 532, 574, 574, 57, 58, 0, 59, 0, 0, 0, 536, 0, 0, 62, 0], [0, 578, 151, 0, 0, 137, 576, 0, 58, 0, 59, 0, 0, 0, 139, 0, 578, 0, 0], [0, 479, 0, 0, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 479, 0, 0], [0, 479, 0, 537, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 479, 0, 0], [0, 0, 0, 573, 532, 574, 574, 57, 58, 0, 59, 0, 0, 0, 536, 0, 0, 62, 0], [0, 0, 0, 0, 577, 141, 141, 57, 58, 0, 0, 0, 0, 542, 577, 0, 0, 0, 0], [0, 0, 0, 539, 532, 540, 574, 57, 58, 0, 59, 0, 0, 542, 536, 0, 0, 62, 0], [0, 0, 0, 539, 532, 574, 574, 57, 58, 0, 59, 0, 0, 0, 536, 0, 0, 62, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 137, 0, 0], [0, 0, 0, 0, 0, 0, 0, 442, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 439, 0, 0], [0, 0, 0, 0, 0, 579, 579, 494, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 580, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 549, 368, 550, 0, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 0, 368, 368, 0, 161, 0, 162, 0, 0, 0, 362, 0, 0, 0, 0], [0, 0, 0, 0, 581, 0, 0, 0, 161, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 500, 552, 552, 22, 23, 0, 24, 0, 0, 0, 504, 0, 0, 27, 0], [0, 0, 0, 0, 555, 80, 80, 22, 23, 0, 0, 0, 0, 0, 555, 0, 0, 0, 0], [0, 0, 0, 582, 91, 583, 584, 22, 23, 0, 24, 0, 0, 585, 93, 0, 0, 27, 0], [0, 553, 0, 586, 0, 177, 177, 22, 23, 0, 24, 0, 0, 0, 78, 0, 553, 0, 0], [0, 553, 0, 0, 0, 175, 587, 0, 23, 0, 24, 0, 0, 0, 78, 0, 553, 0, 0], [0, 0, 0, 588, 91, 589, 590, 22, 23, 0, 24, 0, 0, 591, 93, 0, 0, 27, 0], [0, 0, 0, 0, 513, 558, 558, 32, 33, 0, 34, 0, 0, 0, 517, 0, 0, 37, 0], [0, 0, 0, 0, 561, 101, 101, 32, 33, 0, 0, 0, 0, 0, 561, 0, 0, 0, 0], [0, 0, 0, 592, 112, 593, 594, 32, 33, 0, 34, 0, 0, 595, 114, 0, 0, 37, 0], [0, 559, 0, 596, 0, 203, 203, 32, 33, 0, 34, 0, 0, 0, 99, 0, 559, 0, 0], [0, 559, 0, 0, 0, 201, 597, 0, 33, 0, 34, 0, 0, 0, 99, 0, 559, 0, 0], [0, 0, 0, 598, 112, 599, 600, 32, 33, 0, 34, 0, 0, 601, 114, 0, 0, 37, 0], [0, 0, 0, 602, 66, 67, 67, 8, 9, 0, 10, 0, 0, 0, 68, 0, 0, 16, 0], [0, 0, 0, 0, 165, 44, 44, 8, 9, 0, 0, 0, 0, 566, 165, 0, 0, 0, 0], [0, 0, 0, 563, 66, 564, 67, 8, 9, 0, 10, 0, 0, 566, 68, 0, 0, 16, 0], [0, 0, 0, 563, 66, 67, 67, 8, 9, 0, 10, 0, 0, 0, 68, 0, 0, 16, 0], [0, 527, 0, 0, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 527, 0, 0], [0, 527, 0, 567, 0, 121, 121, 0, 9, 0, 10, 0, 0, 0, 42, 0, 527, 0, 0], [0, 0, 0, 602, 66, 67, 67, 8, 9, 0, 10, 0, 0, 0, 68, 0, 0, 16, 0], [0, 0, 0, 0, 165, 44, 44, 8, 9, 0, 0, 0, 0, 572, 165, 0, 0, 0, 0], [0, 0, 0, 569, 66, 570, 67, 8, 9, 0, 10, 0, 0, 572, 68, 0, 0, 16, 0], [0, 0, 0, 569, 66, 67, 67, 8, 9, 0, 10, 0, 0, 0, 68, 0, 0, 16, 0], [0, 0, 0, 0, 532, 574, 574, 57, 58, 0, 59, 0, 0, 0, 536, 0, 0, 62, 0], [0, 0, 0, 0, 577, 141, 141, 57, 58, 0, 0, 0, 0, 0, 577, 0, 0, 0, 0], [0, 0, 0, 603, 152, 604, 605, 57, 58, 0, 59, 0, 0, 606, 154, 0, 0, 62, 0], [0, 575, 0, 607, 0, 248, 248, 57, 58, 0, 59, 0, 0, 0, 139, 0, 575, 0, 0], [0, 575, 0, 0, 0, 246, 608, 0, 58, 0, 59, 0, 0, 0, 139, 0, 575, 0, 0], [0, 0, 0, 609, 152, 610, 611, 57, 58, 0, 59, 0, 0, 612, 154, 0, 0, 62, 0], [0, 0, 0, 0, 0, 0, 0, 494, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 491, 0, 0], [0, 0, 0, 0, 0, 0, 613, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 614, 91, 92, 92, 22, 23, 0, 24, 0, 0, 0, 93, 0, 0, 27, 0], [0, 0, 0, 0, 194, 80, 80, 22, 23, 0, 0, 0, 0, 585, 194, 0, 0, 0, 0], [0, 0, 0, 582, 91, 583, 92, 22, 23, 0, 24, 0, 0, 585, 93, 0, 0, 27, 0], [0, 0, 0, 582, 91, 92, 92, 22, 23, 0, 24, 0, 0, 0, 93, 0, 0, 27, 0], [0, 553, 0, 0, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 553, 0, 0], [0, 553, 0, 586, 0, 175, 175, 0, 23, 0, 24, 0, 0, 0, 78, 0, 553, 0, 0], [0, 0, 0, 614, 91, 92, 92, 22, 23, 0, 24, 0, 0, 0, 93, 0, 0, 27, 0], [0, 0, 0, 0, 194, 80, 80, 22, 23, 0, 0, 0, 0, 591, 194, 0, 0, 0, 0], [0, 0, 0, 588, 91, 589, 92, 22, 23, 0, 24, 0, 0, 591, 93, 0, 0, 27, 0], [0, 0, 0, 588, 91, 92, 92, 22, 23, 0, 24, 0, 0, 0, 93, 0, 0, 27, 0], [0, 0, 0, 615, 112, 113, 113, 32, 33, 0, 34, 0, 0, 0, 114, 0, 0, 37, 0], [0, 0, 0, 0, 220, 101, 101, 32, 33, 0, 0, 0, 0, 595, 220, 0, 0, 0, 0], [0, 0, 0, 592, 112, 593, 113, 32, 33, 0, 34, 0, 0, 595, 114, 0, 0, 37, 0], [0, 0, 0, 592, 112, 113, 113, 32, 33, 0, 34, 0, 0, 0, 114, 0, 0, 37, 0], [0, 559, 0, 0, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 559, 0, 0], [0, 559, 0, 596, 0, 201, 201, 0, 33, 0, 34, 0, 0, 0, 99, 0, 559, 0, 0], [0, 0, 0, 615, 112, 113, 113, 32, 33, 0, 34, 0, 0, 0, 114, 0, 0, 37, 0], [0, 0, 0, 0, 220, 101, 101, 32, 33, 0, 0, 0, 0, 601, 220, 0, 0, 0, 0], [0, 0, 0, 598, 112, 599, 113, 32, 33, 0, 34, 0, 0, 601, 114, 0, 0, 37, 0], [0, 0, 0, 598, 112, 113, 113, 32, 33, 0, 34, 0, 0, 0, 114, 0, 0, 37, 0], [0, 0, 0, 0, 66, 67, 67, 8, 9, 0, 10, 0, 0, 0, 68, 0, 0, 16, 0], [0, 0, 0, 616, 152, 153, 153, 57, 58, 0, 59, 0, 0, 0, 154, 0, 0, 62, 0], [0, 0, 0, 0, 265, 141, 141, 57, 58, 0, 0, 0, 0, 606, 265, 0, 0, 0, 0], [0, 0, 0, 603, 152, 604, 153, 57, 58, 0, 59, 0, 0, 606, 154, 0, 0, 62, 0], [0, 0, 0, 603, 152, 153, 153, 57, 58, 0, 59, 0, 0, 0, 154, 0, 0, 62, 0], [0, 575, 0, 0, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 575, 0, 0], [0, 575, 0, 607, 0, 246, 246, 0, 58, 0, 59, 0, 0, 0, 139, 0, 575, 0, 0], [0, 0, 0, 616, 152, 153, 153, 57, 58, 0, 59, 0, 0, 0, 154, 0, 0, 62, 0], [0, 0, 0, 0, 265, 141, 141, 57, 58, 0, 0, 0, 0, 612, 265, 0, 0, 0, 0], [0, 0, 0, 609, 152, 610, 153, 57, 58, 0, 59, 0, 0, 612, 154, 0, 0, 62, 0], [0, 0, 0, 609, 152, 153, 153, 57, 58, 0, 59, 0, 0, 0, 154, 0, 0, 62, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 549, 0, 0], [0, 0, 0, 0, 91, 92, 92, 22, 23, 0, 24, 0, 0, 0, 93, 0, 0, 27, 0], [0, 0, 0, 0, 112, 113, 113, 32, 33, 0, 34, 0, 0, 0, 114, 0, 0, 37, 0], [0, 0, 0, 0, 152, 153, 153, 57, 58, 0, 59, 0, 0, 0, 154, 0, 0, 62, 0]];
	var accepting = [false, true, true, true, true, true, false, false, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, true, true, true, true, true, false, true, false, true, true, false, false, true, true, true, true, true, true, false, false, true, true, true, true, true, true, true, true, true, true, false, true, true, false, true, true, true, false, true, true, true, false, true, false, true, true, false, false, true, true, true, true, true, true, true, false, true, true, false, true, true, true, false, true, false, true, true, false, false, true, true, true, true, true, true, true, false, true, true, true, false, true, true, true, false, true, false, true, true, false, false, false, true, true, false, false, true, true, true, true, true, true, false, true, false, true, true, false, false, true, true, true, true, true, true, true, false, true, true, false, true, true, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, true, false, true, false, true, true, false, false, false, true, true, false, false, true, true, true, false, true, true, true, true, true, true, false, true, true, true, false, true, false, true, true, false, false, false, true, true, false, false, true, true, true, false, true, true, true, true, true, false, true, true, true, true, true, false, true, true, false, false, false, false, true, true, false, false, true, true, true, false, true, true, true, false, true, false, true, true, false, false, false, true, true, false, false, true, true, true, false, true, true, true, true, false, true, false, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, false, true, true, false, false, false, false, true, true, false, false, true, true, true, false, true, true, true, true, true, false, true, true, false, false, false, false, true, true, false, false, true, true, true, true, false, true, true, true, true, true, true, false, true, true, false, false, false, false, true, false, true, false, true, true, true, true, true, false, true, true, false, false, false, false, true, true, false, false, true, true, true, false, true, true, false, false, true, false, true, true, false, true, true, false, true, true, false, true, true, true, true, true, true, false, true, true, false, false, false, false, true, false, true, true, false, true, true, true, true, true, true, false, true, true, false, false, false, false, true, false, true, false, true, true, true, true, false, false, false, true, true, false, true, true, true, true, true, true, false, true, true, false, false, false, false, true, false, true, false, true, true, false, false, true, true, false, false, true, true, true, false, true, false, true, true, true, true, false, false, false, true, false, true, true, true, true, false, false, false, true, true, false, true, true, true, true, true, true, false, true, true, false, true, false, true, true, true, true, false, false, false, false, false, false, false, true, true, false, false, true, true, false, true, true, true, true, false, true, true, true, true, true, true, false, true, true, false, true, true, false, true, true, true, true, true, true, false, true, true, false, true, false, true, true, true, true, true, true, false, true, true, true, true, true, true, false, true, true, false, false, false, false, false, true, true, false, true, false, true, true, true, true, true, false, true, true, true, true, true, false, true, true, true, true, true, false, true, true, true, false, true, true, true, true, false, false, false, true, false, true, true, true, true, true, false, true, true, true, false, true, true, true, true, true, false, true, true, true, true, false, true, true, true, true, true, false, true, true, false, true, true, true];
	var tags = [[], ["broken_cluster"], ["consonant_syllable"], ["vowel_syllable"], ["broken_cluster"], ["broken_cluster"], [], [], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["standalone_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["consonant_syllable"], ["broken_cluster"], ["symbol_cluster"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], [], [], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["broken_cluster"], ["broken_cluster"], ["consonant_syllable", "broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], ["symbol_cluster"], [], ["symbol_cluster"], ["symbol_cluster"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], [], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], [], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], [], [], [], ["broken_cluster"], ["broken_cluster"], [], [], ["broken_cluster"], ["broken_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], [], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["symbol_cluster"], ["symbol_cluster"], ["symbol_cluster"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], [], [], [], ["consonant_syllable"], ["consonant_syllable"], [], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], [], [], [], ["vowel_syllable"], ["vowel_syllable"], [], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], [], [], [], [], ["broken_cluster"], ["broken_cluster"], [], [], ["broken_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], [], [], [], ["standalone_cluster"], ["standalone_cluster"], [], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["broken_cluster"], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], ["broken_cluster"], ["symbol_cluster"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], [], [], [], [], ["consonant_syllable"], ["consonant_syllable"], [], [], ["consonant_syllable"], ["consonant_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], [], [], [], [], ["vowel_syllable"], ["vowel_syllable"], [], [], ["vowel_syllable"], ["vowel_syllable"], ["broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], [], [], [], [], ["broken_cluster"], [], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], [], [], [], [], ["standalone_cluster"], ["standalone_cluster"], [], [], ["standalone_cluster"], ["standalone_cluster"], ["consonant_syllable", "broken_cluster"], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], [], [], ["consonant_syllable", "broken_cluster"], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], [], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], [], [], [], [], ["consonant_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], [], [], [], [], ["vowel_syllable"], [], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], [], [], [], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], [], [], [], [], ["standalone_cluster"], [], ["consonant_syllable", "broken_cluster"], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], [], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], [], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], [], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], [], [], [], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], [], [], ["broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], [], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], [], [], [], [], [], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], [], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], [], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], [], [], [], [], [], ["consonant_syllable", "broken_cluster"], ["consonant_syllable", "broken_cluster"], [], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], [], [], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], ["consonant_syllable"], [], ["consonant_syllable"], ["consonant_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], ["vowel_syllable"], [], ["vowel_syllable"], ["vowel_syllable"], ["broken_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], ["standalone_cluster"], [], ["standalone_cluster"], ["standalone_cluster"], [], ["consonant_syllable"], ["vowel_syllable"], ["standalone_cluster"]];
	var indicMachine = {
		stateTable: stateTable,
		accepting: accepting,
		tags: tags
	};

	var categories = ["O", "IND", "S", "GB", "B", "FM", "CGJ", "VMAbv", "VMPst", "VAbv", "VPst", "CMBlw", "VPre", "VBlw", "H", "VMBlw", "CMAbv", "MBlw", "CS", "R", "SUB", "MPst", "MPre", "FAbv", "FPst", "FBlw", "SMAbv", "SMBlw", "VMPre", "ZWNJ", "ZWJ", "WJ", "VS", "N", "HN", "MAbv"];
	var decompositions$1 = { "2507": [2503, 2494], "2508": [2503, 2519], "2888": [2887, 2902], "2891": [2887, 2878], "2892": [2887, 2903], "3018": [3014, 3006], "3019": [3015, 3006], "3020": [3014, 3031], "3144": [3142, 3158], "3264": [3263, 3285], "3271": [3270, 3285], "3272": [3270, 3286], "3274": [3270, 3266], "3275": [3270, 3266, 3285], "3402": [3398, 3390], "3403": [3399, 3390], "3404": [3398, 3415], "3546": [3545, 3530], "3548": [3545, 3535], "3549": [3545, 3535, 3530], "3550": [3545, 3551], "3635": [3661, 3634], "3763": [3789, 3762], "3955": [3953, 3954], "3957": [3953, 3956], "3958": [4018, 3968], "3959": [4018, 3953, 3968], "3960": [4019, 3968], "3961": [4019, 3953, 3968], "3969": [3953, 3968], "6971": [6970, 6965], "6973": [6972, 6965], "6976": [6974, 6965], "6977": [6975, 6965], "6979": [6978, 6965], "69934": [69937, 69927], "69935": [69938, 69927], "70475": [70471, 70462], "70476": [70471, 70487], "70843": [70841, 70842], "70844": [70841, 70832], "70846": [70841, 70845], "71098": [71096, 71087], "71099": [71097, 71087] };
	var stateTable$1 = [[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [2, 2, 3, 4, 4, 5, 0, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 0, 17, 18, 11, 19, 20, 21, 22, 0, 0, 23, 0, 0, 2, 0, 24, 0, 25], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 26, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 27, 28, 0, 0, 0, 0, 27, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 0, 0, 41, 35, 42, 43, 44, 45, 0, 0, 46, 0, 0, 0, 39, 0, 0, 47], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 0, 0, 0, 0, 0, 0, 14, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 0, 7, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 0, 0, 12, 0, 14, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 0, 9, 0, 0, 0, 0, 14, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 10, 11, 12, 13, 14, 0, 16, 0, 0, 18, 11, 19, 20, 21, 22, 0, 0, 23, 0, 0, 0, 0, 0, 0, 25], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 0, 11, 12, 0, 14, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 0, 9, 0, 0, 12, 0, 14, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 18, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 0, 7, 0, 0, 0, 0, 0, 0, 14, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 0, 0, 18, 11, 19, 20, 21, 22, 0, 0, 23, 0, 0, 0, 0, 0, 0, 25], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 0, 11, 12, 0, 14, 0, 0, 0, 0, 0, 11, 0, 20, 21, 22, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 4, 4, 5, 0, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 0, 0, 18, 11, 19, 20, 21, 22, 0, 0, 23, 0, 0, 0, 0, 0, 0, 25], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 48, 11, 12, 13, 14, 48, 16, 0, 0, 18, 11, 19, 20, 21, 22, 0, 0, 23, 0, 0, 0, 49, 0, 0, 25], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 0, 11, 12, 0, 14, 0, 16, 0, 0, 0, 11, 0, 20, 21, 22, 0, 0, 23, 0, 0, 0, 0, 0, 0, 25], [0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 21, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 21, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 0, 0, 0, 0, 0, 0, 14, 0, 0, 0, 0, 0, 0, 0, 20, 21, 22, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 50, 0, 51, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 0, 11, 12, 0, 14, 0, 16, 0, 0, 0, 11, 0, 20, 21, 22, 0, 0, 23, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 27, 28, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 28, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 0, 0, 0, 0, 0, 0, 38, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 0, 31, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 0, 0, 36, 0, 38, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 0, 33, 0, 0, 0, 0, 38, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 34, 35, 36, 37, 38, 0, 40, 0, 0, 41, 35, 42, 43, 44, 45, 0, 0, 46, 0, 0, 0, 0, 0, 0, 47], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 0, 35, 36, 0, 38, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 0, 33, 0, 0, 36, 0, 38, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 41, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 0, 31, 0, 0, 0, 0, 0, 0, 38, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 0, 0, 41, 35, 42, 43, 44, 45, 0, 0, 46, 0, 0, 0, 0, 0, 0, 47], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 0, 35, 36, 0, 38, 0, 0, 0, 0, 0, 35, 0, 43, 44, 45, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 52, 35, 36, 37, 38, 52, 40, 0, 0, 41, 35, 42, 43, 44, 45, 0, 0, 46, 0, 0, 0, 53, 0, 0, 47], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 0, 35, 36, 0, 38, 0, 40, 0, 0, 0, 35, 0, 43, 44, 45, 0, 0, 46, 0, 0, 0, 0, 0, 0, 47], [0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 44, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 44, 45, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 0, 0, 0, 0, 0, 0, 38, 0, 0, 0, 0, 0, 0, 0, 43, 44, 45, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 0, 35, 36, 0, 38, 0, 40, 0, 0, 0, 35, 0, 43, 44, 45, 0, 0, 46, 0, 0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 48, 11, 12, 13, 14, 0, 16, 0, 0, 18, 11, 19, 20, 21, 22, 0, 0, 23, 0, 0, 0, 0, 0, 0, 25], [0, 0, 0, 0, 0, 5, 0, 6, 7, 8, 9, 48, 11, 12, 13, 14, 48, 16, 0, 0, 18, 11, 19, 20, 21, 22, 0, 0, 23, 0, 0, 0, 0, 0, 0, 25], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 51, 0], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 54, 0, 0], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 52, 35, 36, 37, 38, 0, 40, 0, 0, 41, 35, 42, 43, 44, 45, 0, 0, 46, 0, 0, 0, 0, 0, 0, 47], [0, 0, 0, 0, 0, 29, 0, 30, 31, 32, 33, 52, 35, 36, 37, 38, 52, 40, 0, 0, 41, 35, 42, 43, 44, 45, 0, 0, 46, 0, 0, 0, 0, 0, 0, 47], [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 50, 0, 51, 0]];
	var accepting$1 = [false, true, true, true, true, true, true, true, true, true, true, true, true, false, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true];
	var tags$1 = [[], ["broken_cluster"], ["independent_cluster"], ["symbol_cluster"], ["standard_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], [], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["broken_cluster"], ["numeral_cluster"], ["broken_cluster"], ["independent_cluster"], ["symbol_cluster"], ["symbol_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["virama_terminated_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["standard_cluster"], ["broken_cluster"], ["broken_cluster"], ["numeral_cluster"], ["number_joiner_terminated_cluster"], ["standard_cluster"], ["standard_cluster"], ["numeral_cluster"]];
	var useData = {
		categories: categories,
		decompositions: decompositions$1,
		stateTable: stateTable$1,
		accepting: accepting$1,
		tags: tags$1
	};

	// Cateories used in the OpenType spec:
	// https://www.microsoft.com/typography/otfntdev/devanot/shaping.aspx
	var CATEGORIES = {
	  X: 1 << 0,
	  C: 1 << 1,
	  V: 1 << 2,
	  N: 1 << 3,
	  H: 1 << 4,
	  ZWNJ: 1 << 5,
	  ZWJ: 1 << 6,
	  M: 1 << 7,
	  SM: 1 << 8,
	  VD: 1 << 9,
	  A: 1 << 10,
	  Placeholder: 1 << 11,
	  Dotted_Circle: 1 << 12,
	  RS: 1 << 13, // Register Shifter, used in Khmer OT spec.
	  Coeng: 1 << 14, // Khmer-style Virama.
	  Repha: 1 << 15, // Atomically-encoded logical or visual repha.
	  Ra: 1 << 16,
	  CM: 1 << 17, // Consonant-Medial.
	  Symbol: 1 << 18 // Avagraha, etc that take marks (SM,A,VD).
	};

	// Visual positions in a syllable from left to right.
	var POSITIONS = {
	  Start: 1 << 0,

	  Ra_To_Become_Reph: 1 << 1,
	  Pre_M: 1 << 2,
	  Pre_C: 1 << 3,

	  Base_C: 1 << 4,
	  After_Main: 1 << 5,

	  Above_C: 1 << 6,

	  Before_Sub: 1 << 7,
	  Below_C: 1 << 8,
	  After_Sub: 1 << 9,

	  Before_Post: 1 << 10,
	  Post_C: 1 << 11,
	  After_Post: 1 << 12,

	  Final_C: 1 << 13,
	  SMVD: 1 << 14,

	  End: 1 << 15
	};

	var CONSONANT_FLAGS = CATEGORIES.C | CATEGORIES.Ra | CATEGORIES.CM | CATEGORIES.V | CATEGORIES.Placeholder | CATEGORIES.Dotted_Circle;
	var JOINER_FLAGS = CATEGORIES.ZWJ | CATEGORIES.ZWNJ;
	var HALANT_OR_COENG_FLAGS = CATEGORIES.H | CATEGORIES.Coeng;

	var INDIC_CONFIGS = {
	  Default: {
	    hasOldSpec: false,
	    virama: 0,
	    basePos: 'Last',
	    rephPos: POSITIONS.Before_Post,
	    rephMode: 'Implicit',
	    blwfMode: 'Pre_And_Post'
	  },

	  Devanagari: {
	    hasOldSpec: true,
	    virama: 0x094D,
	    basePos: 'Last',
	    rephPos: POSITIONS.Before_Post,
	    rephMode: 'Implicit',
	    blwfMode: 'Pre_And_Post'
	  },

	  Bengali: {
	    hasOldSpec: true,
	    virama: 0x09CD,
	    basePos: 'Last',
	    rephPos: POSITIONS.After_Sub,
	    rephMode: 'Implicit',
	    blwfMode: 'Pre_And_Post'
	  },

	  Gurmukhi: {
	    hasOldSpec: true,
	    virama: 0x0A4D,
	    basePos: 'Last',
	    rephPos: POSITIONS.Before_Sub,
	    rephMode: 'Implicit',
	    blwfMode: 'Pre_And_Post'
	  },

	  Gujarati: {
	    hasOldSpec: true,
	    virama: 0x0ACD,
	    basePos: 'Last',
	    rephPos: POSITIONS.Before_Post,
	    rephMode: 'Implicit',
	    blwfMode: 'Pre_And_Post'
	  },

	  Oriya: {
	    hasOldSpec: true,
	    virama: 0x0B4D,
	    basePos: 'Last',
	    rephPos: POSITIONS.After_Main,
	    rephMode: 'Implicit',
	    blwfMode: 'Pre_And_Post'
	  },

	  Tamil: {
	    hasOldSpec: true,
	    virama: 0x0BCD,
	    basePos: 'Last',
	    rephPos: POSITIONS.After_Post,
	    rephMode: 'Implicit',
	    blwfMode: 'Pre_And_Post'
	  },

	  Telugu: {
	    hasOldSpec: true,
	    virama: 0x0C4D,
	    basePos: 'Last',
	    rephPos: POSITIONS.After_Post,
	    rephMode: 'Explicit',
	    blwfMode: 'Post_Only'
	  },

	  Kannada: {
	    hasOldSpec: true,
	    virama: 0x0CCD,
	    basePos: 'Last',
	    rephPos: POSITIONS.After_Post,
	    rephMode: 'Implicit',
	    blwfMode: 'Post_Only'
	  },

	  Malayalam: {
	    hasOldSpec: true,
	    virama: 0x0D4D,
	    basePos: 'Last',
	    rephPos: POSITIONS.After_Main,
	    rephMode: 'Log_Repha',
	    blwfMode: 'Pre_And_Post'
	  },

	  // Handled by UniversalShaper
	  // Sinhala: {
	  //   hasOldSpec: false,
	  //   virama: 0x0DCA,
	  //   basePos: 'Last_Sinhala',
	  //   rephPos: POSITIONS.After_Main,
	  //   rephMode: 'Explicit',
	  //   blwfMode: 'Pre_And_Post'
	  // },

	  Khmer: {
	    hasOldSpec: false,
	    virama: 0x17D2,
	    basePos: 'First',
	    rephPos: POSITIONS.Ra_To_Become_Reph,
	    rephMode: 'Vis_Repha',
	    blwfMode: 'Pre_And_Post'
	  }
	};

	// Additional decompositions that aren't in Unicode
	var INDIC_DECOMPOSITIONS = {
	  // Khmer
	  0x17BE: [0x17C1, 0x17BE],
	  0x17BF: [0x17C1, 0x17BF],
	  0x17C0: [0x17C1, 0x17C0],
	  0x17C4: [0x17C1, 0x17C4],
	  0x17C5: [0x17C1, 0x17C5]
	};

	var _class$6;
	var _temp$2;
	var decompositions = useData.decompositions;

	var trie$1 = new UnicodeTrie(Buffer("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","base64"));
	var stateMachine = new StateMachine(indicMachine);

	/**
	 * The IndicShaper supports indic scripts e.g. Devanagari, Kannada, etc.
	 * Based on code from Harfbuzz: https://github.com/behdad/harfbuzz/blob/master/src/hb-ot-shape-complex-indic.cc
	 */
	var IndicShaper = (_temp$2 = _class$6 = function (_DefaultShaper) {
	  _inherits(IndicShaper, _DefaultShaper);

	  function IndicShaper() {
	    _classCallCheck(this, IndicShaper);

	    return _possibleConstructorReturn(this, _DefaultShaper.apply(this, arguments));
	  }

	  IndicShaper.planFeatures = function planFeatures(plan) {
	    plan.addStage(setupSyllables);

	    plan.addStage(['locl', 'ccmp']);

	    plan.addStage(initialReordering);

	    plan.addStage('nukt');
	    plan.addStage('akhn');
	    plan.addStage('rphf', false);
	    plan.addStage('rkrf');
	    plan.addStage('pref', false);
	    plan.addStage('blwf', false);
	    plan.addStage('abvf', false);
	    plan.addStage('half', false);
	    plan.addStage('pstf', false);
	    plan.addStage('vatu');
	    plan.addStage('cjct');
	    plan.addStage('cfar', false);

	    plan.addStage(finalReordering);

	    plan.addStage({
	      local: ['init'],
	      global: ['pres', 'abvs', 'blws', 'psts', 'haln', 'dist', 'abvm', 'blwm', 'calt', 'clig']
	    });

	    // Setup the indic config for the selected script
	    plan.unicodeScript = fromOpenType(plan.script);
	    plan.indicConfig = INDIC_CONFIGS[plan.unicodeScript] || INDIC_CONFIGS.Default;
	    plan.isOldSpec = plan.indicConfig.hasOldSpec && plan.script[plan.script.length - 1] !== '2';

	    // TODO: turn off kern (Khmer) and liga features.
	  };

	  IndicShaper.assignFeatures = function assignFeatures(plan, glyphs) {
	    var _loop = function _loop(i) {
	      var codepoint = glyphs[i].codePoints[0];
	      var d = INDIC_DECOMPOSITIONS[codepoint] || decompositions[codepoint];
	      if (d) {
	        var decomposed = d.map(function (c) {
	          var g = plan.font.glyphForCodePoint(c);
	          return new GlyphInfo(plan.font, g.id, [c], glyphs[i].features);
	        });

	        glyphs.splice.apply(glyphs, [i, 1].concat(decomposed));
	      }
	    };

	    // Decompose split matras
	    // TODO: do this in a more general unicode normalizer
	    for (var i = glyphs.length - 1; i >= 0; i--) {
	      _loop(i);
	    }
	  };

	  return IndicShaper;
	}(DefaultShaper), _class$6.zeroMarkWidths = 'NONE', _temp$2);
	function indicCategory(glyph) {
	  return trie$1.get(glyph.codePoints[0]) >> 8;
	}

	function indicPosition(glyph) {
	  return 1 << (trie$1.get(glyph.codePoints[0]) & 0xff);
	}

	var IndicInfo = function IndicInfo(category, position, syllableType, syllable) {
	  _classCallCheck(this, IndicInfo);

	  this.category = category;
	  this.position = position;
	  this.syllableType = syllableType;
	  this.syllable = syllable;
	};

	function setupSyllables(font, glyphs) {
	  var syllable = 0;
	  var last = 0;
	  for (var _iterator = stateMachine.match(glyphs.map(indicCategory)), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	    var _ref;

	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }

	    var _ref2 = _ref,
	        start = _ref2[0],
	        end = _ref2[1],
	        tags = _ref2[2];

	    if (start > last) {
	      ++syllable;
	      for (var _i2 = last; _i2 < start; _i2++) {
	        glyphs[_i2].shaperInfo = new IndicInfo(CATEGORIES.X, POSITIONS.End, 'non_indic_cluster', syllable);
	      }
	    }

	    ++syllable;

	    // Create shaper info
	    for (var _i3 = start; _i3 <= end; _i3++) {
	      glyphs[_i3].shaperInfo = new IndicInfo(1 << indicCategory(glyphs[_i3]), indicPosition(glyphs[_i3]), tags[0], syllable);
	    }

	    last = end + 1;
	  }

	  if (last < glyphs.length) {
	    ++syllable;
	    for (var i = last; i < glyphs.length; i++) {
	      glyphs[i].shaperInfo = new IndicInfo(CATEGORIES.X, POSITIONS.End, 'non_indic_cluster', syllable);
	    }
	  }
	}

	function isConsonant(glyph) {
	  return glyph.shaperInfo.category & CONSONANT_FLAGS;
	}

	function isJoiner(glyph) {
	  return glyph.shaperInfo.category & JOINER_FLAGS;
	}

	function isHalantOrCoeng(glyph) {
	  return glyph.shaperInfo.category & HALANT_OR_COENG_FLAGS;
	}

	function wouldSubstitute(glyphs, feature) {
	  for (var _iterator2 = glyphs, _isArray2 = Array.isArray(_iterator2), _i4 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
	    var _glyph$features;

	    var _ref3;

	    if (_isArray2) {
	      if (_i4 >= _iterator2.length) break;
	      _ref3 = _iterator2[_i4++];
	    } else {
	      _i4 = _iterator2.next();
	      if (_i4.done) break;
	      _ref3 = _i4.value;
	    }

	    var glyph = _ref3;

	    glyph.features = (_glyph$features = {}, _glyph$features[feature] = true, _glyph$features);
	  }

	  var GSUB = glyphs[0]._font._layoutEngine.engine.GSUBProcessor;
	  GSUB.applyFeatures([feature], glyphs);

	  return glyphs.length === 1;
	}

	function consonantPosition(font, consonant, virama) {
	  var glyphs = [virama, consonant, virama];
	  if (wouldSubstitute(glyphs.slice(0, 2), 'blwf') || wouldSubstitute(glyphs.slice(1, 3), 'blwf')) {
	    return POSITIONS.Below_C;
	  } else if (wouldSubstitute(glyphs.slice(0, 2), 'pstf') || wouldSubstitute(glyphs.slice(1, 3), 'pstf')) {
	    return POSITIONS.Post_C;
	  } else if (wouldSubstitute(glyphs.slice(0, 2), 'pref') || wouldSubstitute(glyphs.slice(1, 3), 'pref')) {
	    return POSITIONS.Post_C;
	  }

	  return POSITIONS.Base_C;
	}

	function initialReordering(font, glyphs, plan) {
	  var indicConfig = plan.indicConfig;
	  var features = font._layoutEngine.engine.GSUBProcessor.features;

	  var dottedCircle = font.glyphForCodePoint(0x25cc).id;
	  var virama = font.glyphForCodePoint(indicConfig.virama).id;
	  if (virama) {
	    var info = new GlyphInfo(font, virama, [indicConfig.virama]);
	    for (var i = 0; i < glyphs.length; i++) {
	      if (glyphs[i].shaperInfo.position === POSITIONS.Base_C) {
	        glyphs[i].shaperInfo.position = consonantPosition(font, glyphs[i].copy(), info);
	      }
	    }
	  }

	  for (var start = 0, end = nextSyllable(glyphs, 0); start < glyphs.length; start = end, end = nextSyllable(glyphs, start)) {
	    var _glyphs$start$shaperI = glyphs[start].shaperInfo,
	        category = _glyphs$start$shaperI.category,
	        syllableType = _glyphs$start$shaperI.syllableType;


	    if (syllableType === 'symbol_cluster' || syllableType === 'non_indic_cluster') {
	      continue;
	    }

	    if (syllableType === 'broken_cluster' && dottedCircle) {
	      var g = new GlyphInfo(font, dottedCircle, [0x25cc]);
	      g.shaperInfo = new IndicInfo(1 << indicCategory(g), indicPosition(g), glyphs[start].shaperInfo.syllableType, glyphs[start].shaperInfo.syllable);

	      // Insert after possible Repha.
	      var _i5 = start;
	      while (_i5 < end && glyphs[_i5].shaperInfo.category === CATEGORIES.Repha) {
	        _i5++;
	      }

	      glyphs.splice(_i5++, 0, g);
	      end++;
	    }

	    // 1. Find base consonant:
	    //
	    // The shaping engine finds the base consonant of the syllable, using the
	    // following algorithm: starting from the end of the syllable, move backwards
	    // until a consonant is found that does not have a below-base or post-base
	    // form (post-base forms have to follow below-base forms), or that is not a
	    // pre-base reordering Ra, or arrive at the first consonant. The consonant
	    // stopped at will be the base.

	    var base = end;
	    var limit = start;
	    var hasReph = false;

	    // If the syllable starts with Ra + Halant (in a script that has Reph)
	    // and has more than one consonant, Ra is excluded from candidates for
	    // base consonants.
	    if (indicConfig.rephPos !== POSITIONS.Ra_To_Become_Reph && features.rphf && start + 3 <= end && (indicConfig.rephMode === 'Implicit' && !isJoiner(glyphs[start + 2]) || indicConfig.rephMode === 'Explicit' && glyphs[start + 2].shaperInfo.category === CATEGORIES.ZWJ)) {
	      // See if it matches the 'rphf' feature.
	      var _g = [glyphs[start].copy(), glyphs[start + 1].copy(), glyphs[start + 2].copy()];
	      if (wouldSubstitute(_g.slice(0, 2), 'rphf') || indicConfig.rephMode === 'Explicit' && wouldSubstitute(_g, 'rphf')) {
	        limit += 2;
	        while (limit < end && isJoiner(glyphs[limit])) {
	          limit++;
	        }
	        base = start;
	        hasReph = true;
	      }
	    } else if (indicConfig.rephMode === 'Log_Repha' && glyphs[start].shaperInfo.category === CATEGORIES.Repha) {
	      limit++;
	      while (limit < end && isJoiner(glyphs[limit])) {
	        limit++;
	      }
	      base = start;
	      hasReph = true;
	    }

	    switch (indicConfig.basePos) {
	      case 'Last':
	        {
	          // starting from the end of the syllable, move backwards
	          var _i6 = end;
	          var seenBelow = false;

	          do {
	            var _info = glyphs[--_i6].shaperInfo;

	            // until a consonant is found
	            if (isConsonant(glyphs[_i6])) {
	              // that does not have a below-base or post-base form
	              // (post-base forms have to follow below-base forms),
	              if (_info.position !== POSITIONS.Below_C && (_info.position !== POSITIONS.Post_C || seenBelow)) {
	                base = _i6;
	                break;
	              }

	              // or that is not a pre-base reordering Ra,
	              //
	              // IMPLEMENTATION NOTES:
	              //
	              // Our pre-base reordering Ra's are marked POS_POST_C, so will be skipped
	              // by the logic above already.
	              //

	              // or arrive at the first consonant. The consonant stopped at will
	              // be the base.
	              if (_info.position === POSITIONS.Below_C) {
	                seenBelow = true;
	              }

	              base = _i6;
	            } else if (start < _i6 && _info.category === CATEGORIES.ZWJ && glyphs[_i6 - 1].shaperInfo.category === CATEGORIES.H) {
	              // A ZWJ after a Halant stops the base search, and requests an explicit
	              // half form.
	              // A ZWJ before a Halant, requests a subjoined form instead, and hence
	              // search continues.  This is particularly important for Bengali
	              // sequence Ra,H,Ya that should form Ya-Phalaa by subjoining Ya.
	              break;
	            }
	          } while (_i6 > limit);
	          break;
	        }

	      case 'First':
	        {
	          // The first consonant is always the base.
	          base = start;

	          // Mark all subsequent consonants as below.
	          for (var _i7 = base + 1; _i7 < end; _i7++) {
	            if (isConsonant(glyphs[_i7])) {
	              glyphs[_i7].shaperInfo.position = POSITIONS.Below_C;
	            }
	          }
	        }
	    }

	    // If the syllable starts with Ra + Halant (in a script that has Reph)
	    // and has more than one consonant, Ra is excluded from candidates for
	    // base consonants.
	    //
	    //  Only do this for unforced Reph. (ie. not for Ra,H,ZWJ)
	    if (hasReph && base === start && limit - base <= 2) {
	      hasReph = false;
	    }

	    // 2. Decompose and reorder Matras:
	    //
	    // Each matra and any syllable modifier sign in the cluster are moved to the
	    // appropriate position relative to the consonant(s) in the cluster. The
	    // shaping engine decomposes two- or three-part matras into their constituent
	    // parts before any repositioning. Matra characters are classified by which
	    // consonant in a conjunct they have affinity for and are reordered to the
	    // following positions:
	    //
	    //   o Before first half form in the syllable
	    //   o After subjoined consonants
	    //   o After post-form consonant
	    //   o After main consonant (for above marks)
	    //
	    // IMPLEMENTATION NOTES:
	    //
	    // The normalize() routine has already decomposed matras for us, so we don't
	    // need to worry about that.

	    // 3.  Reorder marks to canonical order:
	    //
	    // Adjacent nukta and halant or nukta and vedic sign are always repositioned
	    // if necessary, so that the nukta is first.
	    //
	    // IMPLEMENTATION NOTES:
	    //
	    // We don't need to do this: the normalize() routine already did this for us.

	    // Reorder characters

	    for (var _i8 = start; _i8 < base; _i8++) {
	      var _info2 = glyphs[_i8].shaperInfo;
	      _info2.position = Math.min(POSITIONS.Pre_C, _info2.position);
	    }

	    if (base < end) {
	      glyphs[base].shaperInfo.position = POSITIONS.Base_C;
	    }

	    // Mark final consonants.  A final consonant is one appearing after a matra,
	    // like in Khmer.
	    for (var _i9 = base + 1; _i9 < end; _i9++) {
	      if (glyphs[_i9].shaperInfo.category === CATEGORIES.M) {
	        for (var j = _i9 + 1; j < end; j++) {
	          if (isConsonant(glyphs[j])) {
	            glyphs[j].shaperInfo.position = POSITIONS.Final_C;
	            break;
	          }
	        }
	        break;
	      }
	    }

	    // Handle beginning Ra
	    if (hasReph) {
	      glyphs[start].shaperInfo.position = POSITIONS.Ra_To_Become_Reph;
	    }

	    // For old-style Indic script tags, move the first post-base Halant after
	    // last consonant.
	    //
	    // Reports suggest that in some scripts Uniscribe does this only if there
	    // is *not* a Halant after last consonant already (eg. Kannada), while it
	    // does it unconditionally in other scripts (eg. Malayalam).  We don't
	    // currently know about other scripts, so we single out Malayalam for now.
	    //
	    // Kannada test case:
	    // U+0C9A,U+0CCD,U+0C9A,U+0CCD
	    // With some versions of Lohit Kannada.
	    // https://bugs.freedesktop.org/show_bug.cgi?id=59118
	    //
	    // Malayalam test case:
	    // U+0D38,U+0D4D,U+0D31,U+0D4D,U+0D31,U+0D4D
	    // With lohit-ttf-20121122/Lohit-Malayalam.ttf
	    if (plan.isOldSpec) {
	      var disallowDoubleHalants = plan.unicodeScript !== 'Malayalam';
	      for (var _i10 = base + 1; _i10 < end; _i10++) {
	        if (glyphs[_i10].shaperInfo.category === CATEGORIES.H) {
	          var _j = void 0;
	          for (_j = end - 1; _j > _i10; _j--) {
	            if (isConsonant(glyphs[_j]) || disallowDoubleHalants && glyphs[_j].shaperInfo.category === CATEGORIES.H) {
	              break;
	            }
	          }

	          if (glyphs[_j].shaperInfo.category !== CATEGORIES.H && _j > _i10) {
	            // Move Halant to after last consonant.
	            var t = glyphs[_i10];
	            glyphs.splice.apply(glyphs, [_i10, 0].concat(glyphs.splice(_i10 + 1, _j - _i10)));
	            glyphs[_j] = t;
	          }

	          break;
	        }
	      }
	    }

	    // Attach misc marks to previous char to move with them.
	    var lastPos = POSITIONS.Start;
	    for (var _i11 = start; _i11 < end; _i11++) {
	      var _info3 = glyphs[_i11].shaperInfo;
	      if (_info3.category & (JOINER_FLAGS | CATEGORIES.N | CATEGORIES.RS | CATEGORIES.CM | HALANT_OR_COENG_FLAGS & _info3.category)) {
	        _info3.position = lastPos;
	        if (_info3.category === CATEGORIES.H && _info3.position === POSITIONS.Pre_M) {
	          // Uniscribe doesn't move the Halant with Left Matra.
	          // TEST: U+092B,U+093F,U+094DE
	          // We follow.  This is important for the Sinhala
	          // U+0DDA split matra since it decomposes to U+0DD9,U+0DCA
	          // where U+0DD9 is a left matra and U+0DCA is the virama.
	          // We don't want to move the virama with the left matra.
	          // TEST: U+0D9A,U+0DDA
	          for (var _j2 = _i11; _j2 > start; _j2--) {
	            if (glyphs[_j2 - 1].shaperInfo.position !== POSITIONS.Pre_M) {
	              _info3.position = glyphs[_j2 - 1].shaperInfo.position;
	              break;
	            }
	          }
	        }
	      } else if (_info3.position !== POSITIONS.SMVD) {
	        lastPos = _info3.position;
	      }
	    }

	    // For post-base consonants let them own anything before them
	    // since the last consonant or matra.
	    var last = base;
	    for (var _i12 = base + 1; _i12 < end; _i12++) {
	      if (isConsonant(glyphs[_i12])) {
	        for (var _j3 = last + 1; _j3 < _i12; _j3++) {
	          if (glyphs[_j3].shaperInfo.position < POSITIONS.SMVD) {
	            glyphs[_j3].shaperInfo.position = glyphs[_i12].shaperInfo.position;
	          }
	        }
	        last = _i12;
	      } else if (glyphs[_i12].shaperInfo.category === CATEGORIES.M) {
	        last = _i12;
	      }
	    }

	    var arr = glyphs.slice(start, end);
	    arr.sort(function (a, b) {
	      return a.shaperInfo.position - b.shaperInfo.position;
	    });
	    glyphs.splice.apply(glyphs, [start, arr.length].concat(arr));

	    // Find base again
	    for (var _i13 = start; _i13 < end; _i13++) {
	      if (glyphs[_i13].shaperInfo.position === POSITIONS.Base_C) {
	        base = _i13;
	        break;
	      }
	    }

	    // Setup features now

	    // Reph
	    for (var _i14 = start; _i14 < end && glyphs[_i14].shaperInfo.position === POSITIONS.Ra_To_Become_Reph; _i14++) {
	      glyphs[_i14].features.rphf = true;
	    }

	    // Pre-base
	    var blwf = !plan.isOldSpec && indicConfig.blwfMode === 'Pre_And_Post';
	    for (var _i15 = start; _i15 < base; _i15++) {
	      glyphs[_i15].features.half = true;
	      if (blwf) {
	        glyphs[_i15].features.blwf = true;
	      }
	    }

	    // Post-base
	    for (var _i16 = base + 1; _i16 < end; _i16++) {
	      glyphs[_i16].features.abvf = true;
	      glyphs[_i16].features.pstf = true;
	      glyphs[_i16].features.blwf = true;
	    }

	    if (plan.isOldSpec && plan.unicodeScript === 'Devanagari') {
	      // Old-spec eye-lash Ra needs special handling.  From the
	      // spec:
	      //
	      // "The feature 'below-base form' is applied to consonants
	      // having below-base forms and following the base consonant.
	      // The exception is vattu, which may appear below half forms
	      // as well as below the base glyph. The feature 'below-base
	      // form' will be applied to all such occurrences of Ra as well."
	      //
	      // Test case: U+0924,U+094D,U+0930,U+094d,U+0915
	      // with Sanskrit 2003 font.
	      //
	      // However, note that Ra,Halant,ZWJ is the correct way to
	      // request eyelash form of Ra, so we wouldbn't inhibit it
	      // in that sequence.
	      //
	      // Test case: U+0924,U+094D,U+0930,U+094d,U+200D,U+0915
	      for (var _i17 = start; _i17 + 1 < base; _i17++) {
	        if (glyphs[_i17].shaperInfo.category === CATEGORIES.Ra && glyphs[_i17 + 1].shaperInfo.category === CATEGORIES.H && (_i17 + 1 === base || glyphs[_i17 + 2].shaperInfo.category === CATEGORIES.ZWJ)) {
	          glyphs[_i17].features.blwf = true;
	          glyphs[_i17 + 1].features.blwf = true;
	        }
	      }
	    }

	    var prefLen = 2;
	    if (features.pref && base + prefLen < end) {
	      // Find a Halant,Ra sequence and mark it for pre-base reordering processing.
	      for (var _i18 = base + 1; _i18 + prefLen - 1 < end; _i18++) {
	        var _g2 = [glyphs[_i18].copy(), glyphs[_i18 + 1].copy()];
	        if (wouldSubstitute(_g2, 'pref')) {
	          for (var _j4 = 0; _j4 < prefLen; _j4++) {
	            glyphs[_i18++].features.pref = true;
	          }

	          // Mark the subsequent stuff with 'cfar'.  Used in Khmer.
	          // Read the feature spec.
	          // This allows distinguishing the following cases with MS Khmer fonts:
	          // U+1784,U+17D2,U+179A,U+17D2,U+1782
	          // U+1784,U+17D2,U+1782,U+17D2,U+179A
	          if (features.cfar) {
	            for (; _i18 < end; _i18++) {
	              glyphs[_i18].features.cfar = true;
	            }
	          }

	          break;
	        }
	      }
	    }

	    // Apply ZWJ/ZWNJ effects
	    for (var _i19 = start + 1; _i19 < end; _i19++) {
	      if (isJoiner(glyphs[_i19])) {
	        var nonJoiner = glyphs[_i19].shaperInfo.category === CATEGORIES.ZWNJ;
	        var _j5 = _i19;

	        do {
	          _j5--;

	          // ZWJ/ZWNJ should disable CJCT.  They do that by simply
	          // being there, since we don't skip them for the CJCT
	          // feature (ie. F_MANUAL_ZWJ)

	          // A ZWNJ disables HALF.
	          if (nonJoiner) {
	            delete glyphs[_j5].features.half;
	          }
	        } while (_j5 > start && !isConsonant(glyphs[_j5]));
	      }
	    }
	  }
	}

	function finalReordering(font, glyphs, plan) {
	  var indicConfig = plan.indicConfig;
	  var features = font._layoutEngine.engine.GSUBProcessor.features;

	  for (var start = 0, end = nextSyllable(glyphs, 0); start < glyphs.length; start = end, end = nextSyllable(glyphs, start)) {
	    // 4. Final reordering:
	    //
	    // After the localized forms and basic shaping forms GSUB features have been
	    // applied (see below), the shaping engine performs some final glyph
	    // reordering before applying all the remaining font features to the entire
	    // cluster.

	    var tryPref = !!features.pref;

	    // Find base again
	    var base = start;
	    for (; base < end; base++) {
	      if (glyphs[base].shaperInfo.position >= POSITIONS.Base_C) {
	        if (tryPref && base + 1 < end) {
	          for (var i = base + 1; i < end; i++) {
	            if (glyphs[i].features.pref) {
	              if (!(glyphs[i].substituted && glyphs[i].isLigated && !glyphs[i].isMultiplied)) {
	                // Ok, this was a 'pref' candidate but didn't form any.
	                // Base is around here...
	                base = i;
	                while (base < end && isHalantOrCoeng(glyphs[base])) {
	                  base++;
	                }
	                glyphs[base].shaperInfo.position = POSITIONS.BASE_C;
	                tryPref = false;
	              }
	              break;
	            }
	          }
	        }

	        // For Malayalam, skip over unformed below- (but NOT post-) forms.
	        if (plan.unicodeScript === 'Malayalam') {
	          for (var _i20 = base + 1; _i20 < end; _i20++) {
	            while (_i20 < end && isJoiner(glyphs[_i20])) {
	              _i20++;
	            }

	            if (_i20 === end || !isHalantOrCoeng(glyphs[_i20])) {
	              break;
	            }

	            _i20++; // Skip halant.
	            while (_i20 < end && isJoiner(glyphs[_i20])) {
	              _i20++;
	            }

	            if (_i20 < end && isConsonant(glyphs[_i20]) && glyphs[_i20].shaperInfo.position === POSITIONS.Below_C) {
	              base = _i20;
	              glyphs[base].shaperInfo.position = POSITIONS.Base_C;
	            }
	          }
	        }

	        if (start < base && glyphs[base].shaperInfo.position > POSITIONS.Base_C) {
	          base--;
	        }
	        break;
	      }
	    }

	    if (base === end && start < base && glyphs[base - 1].shaperInfo.category === CATEGORIES.ZWJ) {
	      base--;
	    }

	    if (base < end) {
	      while (start < base && glyphs[base].shaperInfo.category & (CATEGORIES.N | HALANT_OR_COENG_FLAGS)) {
	        base--;
	      }
	    }

	    // o Reorder matras:
	    //
	    // If a pre-base matra character had been reordered before applying basic
	    // features, the glyph can be moved closer to the main consonant based on
	    // whether half-forms had been formed. Actual position for the matra is
	    // defined as “after last standalone halant glyph, after initial matra
	    // position and before the main consonant”. If ZWJ or ZWNJ follow this
	    // halant, position is moved after it.
	    //

	    if (start + 1 < end && start < base) {
	      // Otherwise there can't be any pre-base matra characters.
	      // If we lost track of base, alas, position before last thingy.
	      var newPos = base === end ? base - 2 : base - 1;

	      // Malayalam / Tamil do not have "half" forms or explicit virama forms.
	      // The glyphs formed by 'half' are Chillus or ligated explicit viramas.
	      // We want to position matra after them.
	      if (plan.unicodeScript !== 'Malayalam' && plan.unicodeScript !== 'Tamil') {
	        while (newPos > start && !(glyphs[newPos].shaperInfo.category & (CATEGORIES.M | HALANT_OR_COENG_FLAGS))) {
	          newPos--;
	        }

	        // If we found no Halant we are done.
	        // Otherwise only proceed if the Halant does
	        // not belong to the Matra itself!
	        if (isHalantOrCoeng(glyphs[newPos]) && glyphs[newPos].shaperInfo.position !== POSITIONS.Pre_M) {
	          // If ZWJ or ZWNJ follow this halant, position is moved after it.
	          if (newPos + 1 < end && isJoiner(glyphs[newPos + 1])) {
	            newPos++;
	          }
	        } else {
	          newPos = start; // No move.
	        }
	      }

	      if (start < newPos && glyphs[newPos].shaperInfo.position !== POSITIONS.Pre_M) {
	        // Now go see if there's actually any matras...
	        for (var _i21 = newPos; _i21 > start; _i21--) {
	          if (glyphs[_i21 - 1].shaperInfo.position === POSITIONS.Pre_M) {
	            var oldPos = _i21 - 1;
	            if (oldPos < base && base <= newPos) {
	              // Shouldn't actually happen.
	              base--;
	            }

	            var tmp = glyphs[oldPos];
	            glyphs.splice.apply(glyphs, [oldPos, 0].concat(glyphs.splice(oldPos + 1, newPos - oldPos)));
	            glyphs[newPos] = tmp;

	            newPos--;
	          }
	        }
	      }
	    }

	    // o Reorder reph:
	    //
	    // Reph’s original position is always at the beginning of the syllable,
	    // (i.e. it is not reordered at the character reordering stage). However,
	    // it will be reordered according to the basic-forms shaping results.
	    // Possible positions for reph, depending on the script, are; after main,
	    // before post-base consonant forms, and after post-base consonant forms.

	    // Two cases:
	    //
	    // - If repha is encoded as a sequence of characters (Ra,H or Ra,H,ZWJ), then
	    //   we should only move it if the sequence ligated to the repha form.
	    //
	    // - If repha is encoded separately and in the logical position, we should only
	    //   move it if it did NOT ligate.  If it ligated, it's probably the font trying
	    //   to make it work without the reordering.
	    if (start + 1 < end && glyphs[start].shaperInfo.position === POSITIONS.Ra_To_Become_Reph && glyphs[start].shaperInfo.category === CATEGORIES.Repha !== (glyphs[start].isLigated && !glyphs[start].isMultiplied)) {
	      var newRephPos = void 0;
	      var rephPos = indicConfig.rephPos;
	      var found = false;

	      // 1. If reph should be positioned after post-base consonant forms,
	      //    proceed to step 5.
	      if (rephPos !== POSITIONS.After_Post) {
	        //  2. If the reph repositioning class is not after post-base: target
	        //     position is after the first explicit halant glyph between the
	        //     first post-reph consonant and last main consonant. If ZWJ or ZWNJ
	        //     are following this halant, position is moved after it. If such
	        //     position is found, this is the target position. Otherwise,
	        //     proceed to the next step.
	        //
	        //     Note: in old-implementation fonts, where classifications were
	        //     fixed in shaping engine, there was no case where reph position
	        //     will be found on this step.
	        newRephPos = start + 1;
	        while (newRephPos < base && !isHalantOrCoeng(glyphs[newRephPos])) {
	          newRephPos++;
	        }

	        if (newRephPos < base && isHalantOrCoeng(glyphs[newRephPos])) {
	          // ->If ZWJ or ZWNJ are following this halant, position is moved after it.
	          if (newRephPos + 1 < base && isJoiner(glyphs[newRephPos + 1])) {
	            newRephPos++;
	          }

	          found = true;
	        }

	        // 3. If reph should be repositioned after the main consonant: find the
	        //    first consonant not ligated with main, or find the first
	        //    consonant that is not a potential pre-base reordering Ra.
	        if (!found && rephPos === POSITIONS.After_Main) {
	          newRephPos = base;
	          while (newRephPos + 1 < end && glyphs[newRephPos + 1].shaperInfo.position <= POSITIONS.After_Main) {
	            newRephPos++;
	          }

	          found = newRephPos < end;
	        }

	        // 4. If reph should be positioned before post-base consonant, find
	        //    first post-base classified consonant not ligated with main. If no
	        //    consonant is found, the target position should be before the
	        //    first matra, syllable modifier sign or vedic sign.
	        //
	        // This is our take on what step 4 is trying to say (and failing, BADLY).
	        if (!found && rephPos === POSITIONS.After_Sub) {
	          newRephPos = base;
	          while (newRephPos + 1 < end && !(glyphs[newRephPos + 1].shaperInfo.position & (POSITIONS.Post_C | POSITIONS.After_Post | POSITIONS.SMVD))) {
	            newRephPos++;
	          }

	          found = newRephPos < end;
	        }
	      }

	      //  5. If no consonant is found in steps 3 or 4, move reph to a position
	      //     immediately before the first post-base matra, syllable modifier
	      //     sign or vedic sign that has a reordering class after the intended
	      //     reph position. For example, if the reordering position for reph
	      //     is post-main, it will skip above-base matras that also have a
	      //     post-main position.
	      if (!found) {
	        // Copied from step 2.
	        newRephPos = start + 1;
	        while (newRephPos < base && !isHalantOrCoeng(glyphs[newRephPos])) {
	          newRephPos++;
	        }

	        if (newRephPos < base && isHalantOrCoeng(glyphs[newRephPos])) {
	          // ->If ZWJ or ZWNJ are following this halant, position is moved after it.
	          if (newRephPos + 1 < base && isJoiner(glyphs[newRephPos + 1])) {
	            newRephPos++;
	          }

	          found = true;
	        }
	      }

	      // 6. Otherwise, reorder reph to the end of the syllable.
	      if (!found) {
	        newRephPos = end - 1;
	        while (newRephPos > start && glyphs[newRephPos].shaperInfo.position === POSITIONS.SMVD) {
	          newRephPos--;
	        }

	        // If the Reph is to be ending up after a Matra,Halant sequence,
	        // position it before that Halant so it can interact with the Matra.
	        // However, if it's a plain Consonant,Halant we shouldn't do that.
	        // Uniscribe doesn't do this.
	        // TEST: U+0930,U+094D,U+0915,U+094B,U+094D
	        if (isHalantOrCoeng(glyphs[newRephPos])) {
	          for (var _i22 = base + 1; _i22 < newRephPos; _i22++) {
	            if (glyphs[_i22].shaperInfo.category === CATEGORIES.M) {
	              newRephPos--;
	            }
	          }
	        }
	      }

	      var reph = glyphs[start];
	      glyphs.splice.apply(glyphs, [start, 0].concat(glyphs.splice(start + 1, newRephPos - start)));
	      glyphs[newRephPos] = reph;

	      if (start < base && base <= newRephPos) {
	        base--;
	      }
	    }

	    // o Reorder pre-base reordering consonants:
	    //
	    // If a pre-base reordering consonant is found, reorder it according to
	    // the following rules:
	    if (tryPref && base + 1 < end) {
	      for (var _i23 = base + 1; _i23 < end; _i23++) {
	        if (glyphs[_i23].features.pref) {
	          // 1. Only reorder a glyph produced by substitution during application
	          //    of the <pref> feature. (Note that a font may shape a Ra consonant with
	          //    the feature generally but block it in certain contexts.)

	          // Note: We just check that something got substituted.  We don't check that
	          // the <pref> feature actually did it...
	          //
	          // Reorder pref only if it ligated.
	          if (glyphs[_i23].isLigated && !glyphs[_i23].isMultiplied) {
	            // 2. Try to find a target position the same way as for pre-base matra.
	            //    If it is found, reorder pre-base consonant glyph.
	            //
	            // 3. If position is not found, reorder immediately before main
	            //    consonant.
	            var _newPos = base;

	            // Malayalam / Tamil do not have "half" forms or explicit virama forms.
	            // The glyphs formed by 'half' are Chillus or ligated explicit viramas.
	            // We want to position matra after them.
	            if (plan.unicodeScript !== 'Malayalam' && plan.unicodeScript !== 'Tamil') {
	              while (_newPos > start && !(glyphs[_newPos - 1].shaperInfo.category & (CATEGORIES.M | HALANT_OR_COENG_FLAGS))) {
	                _newPos--;
	              }

	              // In Khmer coeng model, a H,Ra can go *after* matras.  If it goes after a
	              // split matra, it should be reordered to *before* the left part of such matra.
	              if (_newPos > start && glyphs[_newPos - 1].shaperInfo.category === CATEGORIES.M) {
	                var _oldPos2 = _i23;
	                for (var j = base + 1; j < _oldPos2; j++) {
	                  if (glyphs[j].shaperInfo.category === CATEGORIES.M) {
	                    _newPos--;
	                    break;
	                  }
	                }
	              }
	            }

	            if (_newPos > start && isHalantOrCoeng(glyphs[_newPos - 1])) {
	              // -> If ZWJ or ZWNJ follow this halant, position is moved after it.
	              if (_newPos < end && isJoiner(glyphs[_newPos])) {
	                _newPos++;
	              }
	            }

	            var _oldPos = _i23;
	            var _tmp = glyphs[_oldPos];
	            glyphs.splice.apply(glyphs, [_newPos + 1, 0].concat(glyphs.splice(_newPos, _oldPos - _newPos)));
	            glyphs[_newPos] = _tmp;

	            if (_newPos <= base && base < _oldPos) {
	              base++;
	            }
	          }

	          break;
	        }
	      }
	    }

	    // Apply 'init' to the Left Matra if it's a word start.
	    if (glyphs[start].shaperInfo.position === POSITIONS.Pre_M && (!start || !/Cf|Mn/.test(unicode.getCategory(glyphs[start - 1].codePoints[0])))) {
	      glyphs[start].features.init = true;
	    }
	  }
	}

	function nextSyllable(glyphs, start) {
	  if (start >= glyphs.length) return start;
	  var syllable = glyphs[start].shaperInfo.syllable;
	  while (++start < glyphs.length && glyphs[start].shaperInfo.syllable === syllable) {}
	  return start;
	}

	var _class$7;
	var _temp$3;
	var categories$1 = useData.categories;
	var decompositions$2 = useData.decompositions;
	var trie$2 = new UnicodeTrie(Buffer("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","base64"));
	var stateMachine$1 = new StateMachine(useData);

	/**
	 * This shaper is an implementation of the Universal Shaping Engine, which
	 * uses Unicode data to shape a number of scripts without a dedicated shaping engine.
	 * See https://www.microsoft.com/typography/OpenTypeDev/USE/intro.htm.
	 */
	var UniversalShaper = (_temp$3 = _class$7 = function (_DefaultShaper) {
	  _inherits(UniversalShaper, _DefaultShaper);

	  function UniversalShaper() {
	    _classCallCheck(this, UniversalShaper);

	    return _possibleConstructorReturn(this, _DefaultShaper.apply(this, arguments));
	  }

	  UniversalShaper.planFeatures = function planFeatures(plan) {
	    plan.addStage(setupSyllables$1);

	    // Default glyph pre-processing group
	    plan.addStage(['locl', 'ccmp', 'nukt', 'akhn']);

	    // Reordering group
	    plan.addStage(clearSubstitutionFlags);
	    plan.addStage(['rphf'], false);
	    plan.addStage(recordRphf);
	    plan.addStage(clearSubstitutionFlags);
	    plan.addStage(['pref']);
	    plan.addStage(recordPref);

	    // Orthographic unit shaping group
	    plan.addStage(['rkrf', 'abvf', 'blwf', 'half', 'pstf', 'vatu', 'cjct']);
	    plan.addStage(reorder);

	    // Topographical features
	    // Scripts that need this are handled by the Arabic shaper, not implemented here for now.
	    // plan.addStage(['isol', 'init', 'medi', 'fina', 'med2', 'fin2', 'fin3'], false);

	    // Standard topographic presentation and positional feature application
	    plan.addStage(['abvs', 'blws', 'pres', 'psts', 'dist', 'abvm', 'blwm']);
	  };

	  UniversalShaper.assignFeatures = function assignFeatures(plan, glyphs) {
	    var _loop = function _loop(i) {
	      var codepoint = glyphs[i].codePoints[0];
	      if (decompositions$2[codepoint]) {
	        var decomposed = decompositions$2[codepoint].map(function (c) {
	          var g = plan.font.glyphForCodePoint(c);
	          return new GlyphInfo(plan.font, g.id, [c], glyphs[i].features);
	        });

	        glyphs.splice.apply(glyphs, [i, 1].concat(decomposed));
	      }
	    };

	    // Decompose split vowels
	    // TODO: do this in a more general unicode normalizer
	    for (var i = glyphs.length - 1; i >= 0; i--) {
	      _loop(i);
	    }
	  };

	  return UniversalShaper;
	}(DefaultShaper), _class$7.zeroMarkWidths = 'BEFORE_GPOS', _temp$3);
	function useCategory(glyph) {
	  return trie$2.get(glyph.codePoints[0]);
	}

	var USEInfo = function USEInfo(category, syllableType, syllable) {
	  _classCallCheck(this, USEInfo);

	  this.category = category;
	  this.syllableType = syllableType;
	  this.syllable = syllable;
	};

	function setupSyllables$1(font, glyphs) {
	  var syllable = 0;
	  for (var _iterator = stateMachine$1.match(glyphs.map(useCategory)), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	    var _ref;

	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }

	    var _ref2 = _ref,
	        start = _ref2[0],
	        end = _ref2[1],
	        tags = _ref2[2];

	    ++syllable;

	    // Create shaper info
	    for (var i = start; i <= end; i++) {
	      glyphs[i].shaperInfo = new USEInfo(categories$1[useCategory(glyphs[i])], tags[0], syllable);
	    }

	    // Assign rphf feature
	    var limit = glyphs[start].shaperInfo.category === 'R' ? 1 : Math.min(3, end - start);
	    for (var _i2 = start; _i2 < start + limit; _i2++) {
	      glyphs[_i2].features.rphf = true;
	    }
	  }
	}

	function clearSubstitutionFlags(font, glyphs) {
	  for (var _iterator2 = glyphs, _isArray2 = Array.isArray(_iterator2), _i3 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
	    var _ref3;

	    if (_isArray2) {
	      if (_i3 >= _iterator2.length) break;
	      _ref3 = _iterator2[_i3++];
	    } else {
	      _i3 = _iterator2.next();
	      if (_i3.done) break;
	      _ref3 = _i3.value;
	    }

	    var glyph = _ref3;

	    glyph.substituted = false;
	  }
	}

	function recordRphf(font, glyphs) {
	  for (var _iterator3 = glyphs, _isArray3 = Array.isArray(_iterator3), _i4 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
	    var _ref4;

	    if (_isArray3) {
	      if (_i4 >= _iterator3.length) break;
	      _ref4 = _iterator3[_i4++];
	    } else {
	      _i4 = _iterator3.next();
	      if (_i4.done) break;
	      _ref4 = _i4.value;
	    }

	    var glyph = _ref4;

	    if (glyph.substituted && glyph.features.rphf) {
	      // Mark a substituted repha.
	      glyph.shaperInfo.category = 'R';
	    }
	  }
	}

	function recordPref(font, glyphs) {
	  for (var _iterator4 = glyphs, _isArray4 = Array.isArray(_iterator4), _i5 = 0, _iterator4 = _isArray4 ? _iterator4 : _getIterator(_iterator4);;) {
	    var _ref5;

	    if (_isArray4) {
	      if (_i5 >= _iterator4.length) break;
	      _ref5 = _iterator4[_i5++];
	    } else {
	      _i5 = _iterator4.next();
	      if (_i5.done) break;
	      _ref5 = _i5.value;
	    }

	    var glyph = _ref5;

	    if (glyph.substituted) {
	      // Mark a substituted pref as VPre, as they behave the same way.
	      glyph.shaperInfo.category = 'VPre';
	    }
	  }
	}

	function reorder(font, glyphs) {
	  var dottedCircle = font.glyphForCodePoint(0x25cc).id;

	  for (var start = 0, end = nextSyllable$1(glyphs, 0); start < glyphs.length; start = end, end = nextSyllable$1(glyphs, start)) {
	    var i = void 0,
	        j = void 0;
	    var info = glyphs[start].shaperInfo;
	    var type = info.syllableType;

	    // Only a few syllable types need reordering.
	    if (type !== 'virama_terminated_cluster' && type !== 'standard_cluster' && type !== 'broken_cluster') {
	      continue;
	    }

	    // Insert a dotted circle glyph in broken clusters.
	    if (type === 'broken_cluster' && dottedCircle) {
	      var g = new GlyphInfo(font, dottedCircle, [0x25cc]);
	      g.shaperInfo = info;

	      // Insert after possible Repha.
	      for (i = start; i < end && glyphs[i].shaperInfo.category === 'R'; i++) {}
	      glyphs.splice(++i, 0, g);
	      end++;
	    }

	    // Move things forward.
	    if (info.category === 'R' && end - start > 1) {
	      // Got a repha. Reorder it to after first base, before first halant.
	      for (i = start + 1; i < end; i++) {
	        info = glyphs[i].shaperInfo;
	        if (isBase(info) || isHalant(glyphs[i])) {
	          // If we hit a halant, move before it; otherwise it's a base: move to it's
	          // place, and shift things in between backward.
	          if (isHalant(glyphs[i])) {
	            i--;
	          }

	          glyphs.splice.apply(glyphs, [start, 0].concat(glyphs.splice(start + 1, i - start), [glyphs[i]]));
	          break;
	        }
	      }
	    }

	    // Move things back.
	    for (i = start, j = end; i < end; i++) {
	      info = glyphs[i].shaperInfo;
	      if (isBase(info) || isHalant(glyphs[i])) {
	        // If we hit a halant, move after it; otherwise it's a base: move to it's
	        // place, and shift things in between backward.
	        j = isHalant(glyphs[i]) ? i + 1 : i;
	      } else if ((info.category === 'VPre' || info.category === 'VMPre') && j < i) {
	        glyphs.splice.apply(glyphs, [j, 1, glyphs[i]].concat(glyphs.splice(j, i - j)));
	      }
	    }
	  }
	}

	function nextSyllable$1(glyphs, start) {
	  if (start >= glyphs.length) return start;
	  var syllable = glyphs[start].shaperInfo.syllable;
	  while (++start < glyphs.length && glyphs[start].shaperInfo.syllable === syllable) {}
	  return start;
	}

	function isHalant(glyph) {
	  return glyph.shaperInfo.category === 'H' && !glyph.isLigated;
	}

	function isBase(info) {
	  return info.category === 'B' || info.category === 'GB';
	}

	var SHAPERS = {
	  arab: ArabicShaper, // Arabic
	  mong: ArabicShaper, // Mongolian
	  syrc: ArabicShaper, // Syriac
	  'nko ': ArabicShaper, // N'Ko
	  phag: ArabicShaper, // Phags Pa
	  mand: ArabicShaper, // Mandaic
	  mani: ArabicShaper, // Manichaean
	  phlp: ArabicShaper, // Psalter Pahlavi

	  hang: HangulShaper, // Hangul

	  bng2: IndicShaper, // Bengali
	  beng: IndicShaper, // Bengali
	  dev2: IndicShaper, // Devanagari
	  deva: IndicShaper, // Devanagari
	  gjr2: IndicShaper, // Gujarati
	  gujr: IndicShaper, // Gujarati
	  guru: IndicShaper, // Gurmukhi
	  gur2: IndicShaper, // Gurmukhi
	  knda: IndicShaper, // Kannada
	  knd2: IndicShaper, // Kannada
	  mlm2: IndicShaper, // Malayalam
	  mlym: IndicShaper, // Malayalam
	  ory2: IndicShaper, // Oriya
	  orya: IndicShaper, // Oriya
	  taml: IndicShaper, // Tamil
	  tml2: IndicShaper, // Tamil
	  telu: IndicShaper, // Telugu
	  tel2: IndicShaper, // Telugu
	  khmr: IndicShaper, // Khmer

	  bali: UniversalShaper, // Balinese
	  batk: UniversalShaper, // Batak
	  brah: UniversalShaper, // Brahmi
	  bugi: UniversalShaper, // Buginese
	  buhd: UniversalShaper, // Buhid
	  cakm: UniversalShaper, // Chakma
	  cham: UniversalShaper, // Cham
	  dupl: UniversalShaper, // Duployan
	  egyp: UniversalShaper, // Egyptian Hieroglyphs
	  gran: UniversalShaper, // Grantha
	  hano: UniversalShaper, // Hanunoo
	  java: UniversalShaper, // Javanese
	  kthi: UniversalShaper, // Kaithi
	  kali: UniversalShaper, // Kayah Li
	  khar: UniversalShaper, // Kharoshthi
	  khoj: UniversalShaper, // Khojki
	  sind: UniversalShaper, // Khudawadi
	  lepc: UniversalShaper, // Lepcha
	  limb: UniversalShaper, // Limbu
	  mahj: UniversalShaper, // Mahajani
	  // mand: UniversalShaper, // Mandaic
	  // mani: UniversalShaper, // Manichaean
	  mtei: UniversalShaper, // Meitei Mayek
	  modi: UniversalShaper, // Modi
	  // mong: UniversalShaper, // Mongolian
	  // 'nko ': UniversalShaper, // N’Ko
	  hmng: UniversalShaper, // Pahawh Hmong
	  // phag: UniversalShaper, // Phags-pa
	  // phlp: UniversalShaper, // Psalter Pahlavi
	  rjng: UniversalShaper, // Rejang
	  saur: UniversalShaper, // Saurashtra
	  shrd: UniversalShaper, // Sharada
	  sidd: UniversalShaper, // Siddham
	  sinh: UniversalShaper, // Sinhala
	  sund: UniversalShaper, // Sundanese
	  sylo: UniversalShaper, // Syloti Nagri
	  tglg: UniversalShaper, // Tagalog
	  tagb: UniversalShaper, // Tagbanwa
	  tale: UniversalShaper, // Tai Le
	  lana: UniversalShaper, // Tai Tham
	  tavt: UniversalShaper, // Tai Viet
	  takr: UniversalShaper, // Takri
	  tibt: UniversalShaper, // Tibetan
	  tfng: UniversalShaper, // Tifinagh
	  tirh: UniversalShaper, // Tirhuta

	  latn: DefaultShaper, // Latin
	  DFLT: DefaultShaper // Default
	};

	function choose(script) {
	  if (!Array.isArray(script)) {
	    script = [script];
	  }

	  for (var _iterator = script, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	    var _ref;

	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }

	    var s = _ref;

	    var shaper = SHAPERS[s];
	    if (shaper) {
	      return shaper;
	    }
	  }

	  return DefaultShaper;
	}

	var GSUBProcessor = function (_OTProcessor) {
	  _inherits(GSUBProcessor, _OTProcessor);

	  function GSUBProcessor() {
	    _classCallCheck(this, GSUBProcessor);

	    return _possibleConstructorReturn(this, _OTProcessor.apply(this, arguments));
	  }

	  GSUBProcessor.prototype.applyLookup = function applyLookup(lookupType, table) {
	    var _this2 = this;

	    switch (lookupType) {
	      case 1:
	        {
	          // Single Substitution
	          var index = this.coverageIndex(table.coverage);
	          if (index === -1) {
	            return false;
	          }

	          var glyph = this.glyphIterator.cur;
	          switch (table.version) {
	            case 1:
	              glyph.id = glyph.id + table.deltaGlyphID & 0xffff;
	              break;

	            case 2:
	              glyph.id = table.substitute.get(index);
	              break;
	          }

	          return true;
	        }

	      case 2:
	        {
	          // Multiple Substitution
	          var _index = this.coverageIndex(table.coverage);
	          if (_index !== -1) {
	            var _glyphs;

	            var sequence = table.sequences.get(_index);
	            this.glyphIterator.cur.id = sequence[0];
	            this.glyphIterator.cur.ligatureComponent = 0;

	            var features = this.glyphIterator.cur.features;
	            var curGlyph = this.glyphIterator.cur;
	            var replacement = sequence.slice(1).map(function (gid, i) {
	              var glyph = new GlyphInfo(_this2.font, gid, undefined, features);
	              glyph.shaperInfo = curGlyph.shaperInfo;
	              glyph.isLigated = curGlyph.isLigated;
	              glyph.ligatureComponent = i + 1;
	              glyph.substituted = true;
	              glyph.isMultiplied = true;
	              return glyph;
	            });

	            (_glyphs = this.glyphs).splice.apply(_glyphs, [this.glyphIterator.index + 1, 0].concat(replacement));
	            return true;
	          }

	          return false;
	        }

	      case 3:
	        {
	          // Alternate Substitution
	          var _index2 = this.coverageIndex(table.coverage);
	          if (_index2 !== -1) {
	            var USER_INDEX = 0; // TODO
	            this.glyphIterator.cur.id = table.alternateSet.get(_index2)[USER_INDEX];
	            return true;
	          }

	          return false;
	        }

	      case 4:
	        {
	          // Ligature Substitution
	          var _index3 = this.coverageIndex(table.coverage);
	          if (_index3 === -1) {
	            return false;
	          }

	          for (var _iterator = table.ligatureSets.get(_index3), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	            var _ref;

	            if (_isArray) {
	              if (_i >= _iterator.length) break;
	              _ref = _iterator[_i++];
	            } else {
	              _i = _iterator.next();
	              if (_i.done) break;
	              _ref = _i.value;
	            }

	            var ligature = _ref;

	            var matched = this.sequenceMatchIndices(1, ligature.components);
	            if (!matched) {
	              continue;
	            }

	            var _curGlyph = this.glyphIterator.cur;

	            // Concatenate all of the characters the new ligature will represent
	            var characters = _curGlyph.codePoints.slice();
	            for (var _iterator2 = matched, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
	              var _ref2;

	              if (_isArray2) {
	                if (_i2 >= _iterator2.length) break;
	                _ref2 = _iterator2[_i2++];
	              } else {
	                _i2 = _iterator2.next();
	                if (_i2.done) break;
	                _ref2 = _i2.value;
	              }

	              var _index4 = _ref2;

	              characters.push.apply(characters, this.glyphs[_index4].codePoints);
	            }

	            // Create the replacement ligature glyph
	            var ligatureGlyph = new GlyphInfo(this.font, ligature.glyph, characters, _curGlyph.features);
	            ligatureGlyph.shaperInfo = _curGlyph.shaperInfo;
	            ligatureGlyph.isLigated = true;
	            ligatureGlyph.substituted = true;

	            // From Harfbuzz:
	            // - If it *is* a mark ligature, we don't allocate a new ligature id, and leave
	            //   the ligature to keep its old ligature id.  This will allow it to attach to
	            //   a base ligature in GPOS.  Eg. if the sequence is: LAM,LAM,SHADDA,FATHA,HEH,
	            //   and LAM,LAM,HEH for a ligature, they will leave SHADDA and FATHA with a
	            //   ligature id and component value of 2.  Then if SHADDA,FATHA form a ligature
	            //   later, we don't want them to lose their ligature id/component, otherwise
	            //   GPOS will fail to correctly position the mark ligature on top of the
	            //   LAM,LAM,HEH ligature. See https://bugzilla.gnome.org/show_bug.cgi?id=676343
	            //
	            // - If a ligature is formed of components that some of which are also ligatures
	            //   themselves, and those ligature components had marks attached to *their*
	            //   components, we have to attach the marks to the new ligature component
	            //   positions!  Now *that*'s tricky!  And these marks may be following the
	            //   last component of the whole sequence, so we should loop forward looking
	            //   for them and update them.
	            //
	            //   Eg. the sequence is LAM,LAM,SHADDA,FATHA,HEH, and the font first forms a
	            //   'calt' ligature of LAM,HEH, leaving the SHADDA and FATHA with a ligature
	            //   id and component == 1.  Now, during 'liga', the LAM and the LAM-HEH ligature
	            //   form a LAM-LAM-HEH ligature.  We need to reassign the SHADDA and FATHA to
	            //   the new ligature with a component value of 2.
	            //
	            //   This in fact happened to a font...  See https://bugzilla.gnome.org/show_bug.cgi?id=437633
	            var isMarkLigature = _curGlyph.isMark;
	            for (var i = 0; i < matched.length && isMarkLigature; i++) {
	              isMarkLigature = this.glyphs[matched[i]].isMark;
	            }

	            ligatureGlyph.ligatureID = isMarkLigature ? null : this.ligatureID++;

	            var lastLigID = _curGlyph.ligatureID;
	            var lastNumComps = _curGlyph.codePoints.length;
	            var curComps = lastNumComps;
	            var idx = this.glyphIterator.index + 1;

	            // Set ligatureID and ligatureComponent on glyphs that were skipped in the matched sequence.
	            // This allows GPOS to attach marks to the correct ligature components.
	            for (var _iterator3 = matched, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
	              var _ref3;

	              if (_isArray3) {
	                if (_i3 >= _iterator3.length) break;
	                _ref3 = _iterator3[_i3++];
	              } else {
	                _i3 = _iterator3.next();
	                if (_i3.done) break;
	                _ref3 = _i3.value;
	              }

	              var matchIndex = _ref3;

	              // Don't assign new ligature components for mark ligatures (see above)
	              if (isMarkLigature) {
	                idx = matchIndex;
	              } else {
	                while (idx < matchIndex) {
	                  var ligatureComponent = curComps - lastNumComps + Math.min(this.glyphs[idx].ligatureComponent || 1, lastNumComps);
	                  this.glyphs[idx].ligatureID = ligatureGlyph.ligatureID;
	                  this.glyphs[idx].ligatureComponent = ligatureComponent;
	                  idx++;
	                }
	              }

	              lastLigID = this.glyphs[idx].ligatureID;
	              lastNumComps = this.glyphs[idx].codePoints.length;
	              curComps += lastNumComps;
	              idx++; // skip base glyph
	            }

	            // Adjust ligature components for any marks following
	            if (lastLigID && !isMarkLigature) {
	              for (var _i4 = idx; _i4 < this.glyphs.length; _i4++) {
	                if (this.glyphs[_i4].ligatureID === lastLigID) {
	                  var ligatureComponent = curComps - lastNumComps + Math.min(this.glyphs[_i4].ligatureComponent || 1, lastNumComps);
	                  this.glyphs[_i4].ligatureComponent = ligatureComponent;
	                } else {
	                  break;
	                }
	              }
	            }

	            // Delete the matched glyphs, and replace the current glyph with the ligature glyph
	            for (var _i5 = matched.length - 1; _i5 >= 0; _i5--) {
	              this.glyphs.splice(matched[_i5], 1);
	            }

	            this.glyphs[this.glyphIterator.index] = ligatureGlyph;
	            return true;
	          }

	          return false;
	        }

	      case 5:
	        // Contextual Substitution
	        return this.applyContext(table);

	      case 6:
	        // Chaining Contextual Substitution
	        return this.applyChainingContext(table);

	      case 7:
	        // Extension Substitution
	        return this.applyLookup(table.lookupType, table.extension);

	      default:
	        throw new Error('GSUB lookupType ' + lookupType + ' is not supported');
	    }
	  };

	  return GSUBProcessor;
	}(OTProcessor);

	var GPOSProcessor = function (_OTProcessor) {
	  _inherits(GPOSProcessor, _OTProcessor);

	  function GPOSProcessor() {
	    _classCallCheck(this, GPOSProcessor);

	    return _possibleConstructorReturn(this, _OTProcessor.apply(this, arguments));
	  }

	  GPOSProcessor.prototype.applyPositionValue = function applyPositionValue(sequenceIndex, value) {
	    var position = this.positions[this.glyphIterator.peekIndex(sequenceIndex)];
	    if (value.xAdvance != null) {
	      position.xAdvance += value.xAdvance;
	    }

	    if (value.yAdvance != null) {
	      position.yAdvance += value.yAdvance;
	    }

	    if (value.xPlacement != null) {
	      position.xOffset += value.xPlacement;
	    }

	    if (value.yPlacement != null) {
	      position.yOffset += value.yPlacement;
	    }

	    // Adjustments for font variations
	    var variationProcessor = this.font._variationProcessor;
	    var variationStore = this.font.GDEF && this.font.GDEF.itemVariationStore;
	    if (variationProcessor && variationStore) {
	      if (value.xPlaDevice) {
	        position.xOffset += variationProcessor.getDelta(variationStore, value.xPlaDevice.a, value.xPlaDevice.b);
	      }

	      if (value.yPlaDevice) {
	        position.yOffset += variationProcessor.getDelta(variationStore, value.yPlaDevice.a, value.yPlaDevice.b);
	      }

	      if (value.xAdvDevice) {
	        position.xAdvance += variationProcessor.getDelta(variationStore, value.xAdvDevice.a, value.xAdvDevice.b);
	      }

	      if (value.yAdvDevice) {
	        position.yAdvance += variationProcessor.getDelta(variationStore, value.yAdvDevice.a, value.yAdvDevice.b);
	      }
	    }

	    // TODO: device tables
	  };

	  GPOSProcessor.prototype.applyLookup = function applyLookup(lookupType, table) {
	    switch (lookupType) {
	      case 1:
	        {
	          // Single positioning value
	          var index = this.coverageIndex(table.coverage);
	          if (index === -1) {
	            return false;
	          }

	          switch (table.version) {
	            case 1:
	              this.applyPositionValue(0, table.value);
	              break;

	            case 2:
	              this.applyPositionValue(0, table.values.get(index));
	              break;
	          }

	          return true;
	        }

	      case 2:
	        {
	          // Pair Adjustment Positioning
	          var nextGlyph = this.glyphIterator.peek();
	          if (!nextGlyph) {
	            return false;
	          }

	          var _index = this.coverageIndex(table.coverage);
	          if (_index === -1) {
	            return false;
	          }

	          switch (table.version) {
	            case 1:
	              // Adjustments for glyph pairs
	              var set = table.pairSets.get(_index);

	              for (var _iterator = set, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	                var _ref;

	                if (_isArray) {
	                  if (_i >= _iterator.length) break;
	                  _ref = _iterator[_i++];
	                } else {
	                  _i = _iterator.next();
	                  if (_i.done) break;
	                  _ref = _i.value;
	                }

	                var _pair = _ref;

	                if (_pair.secondGlyph === nextGlyph.id) {
	                  this.applyPositionValue(0, _pair.value1);
	                  this.applyPositionValue(1, _pair.value2);
	                  return true;
	                }
	              }

	              return false;

	            case 2:
	              // Class pair adjustment
	              var class1 = this.getClassID(this.glyphIterator.cur.id, table.classDef1);
	              var class2 = this.getClassID(nextGlyph.id, table.classDef2);
	              if (class1 === -1 || class2 === -1) {
	                return false;
	              }

	              var pair = table.classRecords.get(class1).get(class2);
	              this.applyPositionValue(0, pair.value1);
	              this.applyPositionValue(1, pair.value2);
	              return true;
	          }
	        }

	      case 3:
	        {
	          // Cursive Attachment Positioning
	          var nextIndex = this.glyphIterator.peekIndex();
	          var _nextGlyph = this.glyphs[nextIndex];
	          if (!_nextGlyph) {
	            return false;
	          }

	          var curRecord = table.entryExitRecords[this.coverageIndex(table.coverage)];
	          if (!curRecord || !curRecord.exitAnchor) {
	            return false;
	          }

	          var nextRecord = table.entryExitRecords[this.coverageIndex(table.coverage, _nextGlyph.id)];
	          if (!nextRecord || !nextRecord.entryAnchor) {
	            return false;
	          }

	          var entry = this.getAnchor(nextRecord.entryAnchor);
	          var exit = this.getAnchor(curRecord.exitAnchor);

	          var cur = this.positions[this.glyphIterator.index];
	          var next = this.positions[nextIndex];

	          switch (this.direction) {
	            case 'ltr':
	              cur.xAdvance = exit.x + cur.xOffset;

	              var d = entry.x + next.xOffset;
	              next.xAdvance -= d;
	              next.xOffset -= d;
	              break;

	            case 'rtl':
	              d = exit.x + cur.xOffset;
	              cur.xAdvance -= d;
	              cur.xOffset -= d;
	              next.xAdvance = entry.x + next.xOffset;
	              break;
	          }

	          if (this.glyphIterator.flags.rightToLeft) {
	            this.glyphIterator.cur.cursiveAttachment = nextIndex;
	            cur.yOffset = entry.y - exit.y;
	          } else {
	            _nextGlyph.cursiveAttachment = this.glyphIterator.index;
	            cur.yOffset = exit.y - entry.y;
	          }

	          return true;
	        }

	      case 4:
	        {
	          // Mark to base positioning
	          var markIndex = this.coverageIndex(table.markCoverage);
	          if (markIndex === -1) {
	            return false;
	          }

	          // search backward for a base glyph
	          var baseGlyphIndex = this.glyphIterator.index;
	          while (--baseGlyphIndex >= 0 && (this.glyphs[baseGlyphIndex].isMark || this.glyphs[baseGlyphIndex].ligatureComponent > 0)) {}

	          if (baseGlyphIndex < 0) {
	            return false;
	          }

	          var baseIndex = this.coverageIndex(table.baseCoverage, this.glyphs[baseGlyphIndex].id);
	          if (baseIndex === -1) {
	            return false;
	          }

	          var markRecord = table.markArray[markIndex];
	          var baseAnchor = table.baseArray[baseIndex][markRecord.class];
	          this.applyAnchor(markRecord, baseAnchor, baseGlyphIndex);
	          return true;
	        }

	      case 5:
	        {
	          // Mark to ligature positioning
	          var _markIndex = this.coverageIndex(table.markCoverage);
	          if (_markIndex === -1) {
	            return false;
	          }

	          // search backward for a base glyph
	          var _baseGlyphIndex = this.glyphIterator.index;
	          while (--_baseGlyphIndex >= 0 && this.glyphs[_baseGlyphIndex].isMark) {}

	          if (_baseGlyphIndex < 0) {
	            return false;
	          }

	          var ligIndex = this.coverageIndex(table.ligatureCoverage, this.glyphs[_baseGlyphIndex].id);
	          if (ligIndex === -1) {
	            return false;
	          }

	          var ligAttach = table.ligatureArray[ligIndex];
	          var markGlyph = this.glyphIterator.cur;
	          var ligGlyph = this.glyphs[_baseGlyphIndex];
	          var compIndex = ligGlyph.ligatureID && ligGlyph.ligatureID === markGlyph.ligatureID && markGlyph.ligatureComponent > 0 ? Math.min(markGlyph.ligatureComponent, ligGlyph.codePoints.length) - 1 : ligGlyph.codePoints.length - 1;

	          var _markRecord = table.markArray[_markIndex];
	          var _baseAnchor = ligAttach[compIndex][_markRecord.class];
	          this.applyAnchor(_markRecord, _baseAnchor, _baseGlyphIndex);
	          return true;
	        }

	      case 6:
	        {
	          // Mark to mark positioning
	          var mark1Index = this.coverageIndex(table.mark1Coverage);
	          if (mark1Index === -1) {
	            return false;
	          }

	          // get the previous mark to attach to
	          var prevIndex = this.glyphIterator.peekIndex(-1);
	          var prev = this.glyphs[prevIndex];
	          if (!prev || !prev.isMark) {
	            return false;
	          }

	          var _cur = this.glyphIterator.cur;

	          // The following logic was borrowed from Harfbuzz
	          var good = false;
	          if (_cur.ligatureID === prev.ligatureID) {
	            if (!_cur.ligatureID) {
	              // Marks belonging to the same base
	              good = true;
	            } else if (_cur.ligatureComponent === prev.ligatureComponent) {
	              // Marks belonging to the same ligature component
	              good = true;
	            }
	          } else {
	            // If ligature ids don't match, it may be the case that one of the marks
	            // itself is a ligature, in which case match.
	            if (_cur.ligatureID && !_cur.ligatureComponent || prev.ligatureID && !prev.ligatureComponent) {
	              good = true;
	            }
	          }

	          if (!good) {
	            return false;
	          }

	          var mark2Index = this.coverageIndex(table.mark2Coverage, prev.id);
	          if (mark2Index === -1) {
	            return false;
	          }

	          var _markRecord2 = table.mark1Array[mark1Index];
	          var _baseAnchor2 = table.mark2Array[mark2Index][_markRecord2.class];
	          this.applyAnchor(_markRecord2, _baseAnchor2, prevIndex);
	          return true;
	        }

	      case 7:
	        // Contextual positioning
	        return this.applyContext(table);

	      case 8:
	        // Chaining contextual positioning
	        return this.applyChainingContext(table);

	      case 9:
	        // Extension positioning
	        return this.applyLookup(table.lookupType, table.extension);

	      default:
	        throw new Error('Unsupported GPOS table: ' + lookupType);
	    }
	  };

	  GPOSProcessor.prototype.applyAnchor = function applyAnchor(markRecord, baseAnchor, baseGlyphIndex) {
	    var baseCoords = this.getAnchor(baseAnchor);
	    var markCoords = this.getAnchor(markRecord.markAnchor);

	    var basePos = this.positions[baseGlyphIndex];
	    var markPos = this.positions[this.glyphIterator.index];

	    markPos.xOffset = baseCoords.x - markCoords.x;
	    markPos.yOffset = baseCoords.y - markCoords.y;
	    this.glyphIterator.cur.markAttachment = baseGlyphIndex;
	  };

	  GPOSProcessor.prototype.getAnchor = function getAnchor(anchor) {
	    // TODO: contour point, device tables
	    var x = anchor.xCoordinate;
	    var y = anchor.yCoordinate;

	    // Adjustments for font variations
	    var variationProcessor = this.font._variationProcessor;
	    var variationStore = this.font.GDEF && this.font.GDEF.itemVariationStore;
	    if (variationProcessor && variationStore) {
	      if (anchor.xDeviceTable) {
	        x += variationProcessor.getDelta(variationStore, anchor.xDeviceTable.a, anchor.xDeviceTable.b);
	      }

	      if (anchor.yDeviceTable) {
	        y += variationProcessor.getDelta(variationStore, anchor.yDeviceTable.a, anchor.yDeviceTable.b);
	      }
	    }

	    return { x: x, y: y };
	  };

	  GPOSProcessor.prototype.applyFeatures = function applyFeatures(userFeatures, glyphs, advances) {
	    _OTProcessor.prototype.applyFeatures.call(this, userFeatures, glyphs, advances);

	    for (var i = 0; i < this.glyphs.length; i++) {
	      this.fixCursiveAttachment(i);
	    }

	    this.fixMarkAttachment();
	  };

	  GPOSProcessor.prototype.fixCursiveAttachment = function fixCursiveAttachment(i) {
	    var glyph = this.glyphs[i];
	    if (glyph.cursiveAttachment != null) {
	      var j = glyph.cursiveAttachment;

	      glyph.cursiveAttachment = null;
	      this.fixCursiveAttachment(j);

	      this.positions[i].yOffset += this.positions[j].yOffset;
	    }
	  };

	  GPOSProcessor.prototype.fixMarkAttachment = function fixMarkAttachment() {
	    for (var i = 0; i < this.glyphs.length; i++) {
	      var glyph = this.glyphs[i];
	      if (glyph.markAttachment != null) {
	        var j = glyph.markAttachment;

	        this.positions[i].xOffset += this.positions[j].xOffset;
	        this.positions[i].yOffset += this.positions[j].yOffset;

	        if (this.direction === 'ltr') {
	          for (var k = j; k < i; k++) {
	            this.positions[i].xOffset -= this.positions[k].xAdvance;
	            this.positions[i].yOffset -= this.positions[k].yAdvance;
	          }
	        } else {
	          for (var _k = j + 1; _k < i + 1; _k++) {
	            this.positions[i].xOffset += this.positions[_k].xAdvance;
	            this.positions[i].yOffset += this.positions[_k].yAdvance;
	          }
	        }
	      }
	    }
	  };

	  return GPOSProcessor;
	}(OTProcessor);

	var OTLayoutEngine = function () {
	  function OTLayoutEngine(font) {
	    _classCallCheck(this, OTLayoutEngine);

	    this.font = font;
	    this.glyphInfos = null;
	    this.plan = null;
	    this.GSUBProcessor = null;
	    this.GPOSProcessor = null;
	    this.fallbackPosition = true;

	    if (font.GSUB) {
	      this.GSUBProcessor = new GSUBProcessor(font, font.GSUB);
	    }

	    if (font.GPOS) {
	      this.GPOSProcessor = new GPOSProcessor(font, font.GPOS);
	    }
	  }

	  OTLayoutEngine.prototype.setup = function setup(glyphRun) {
	    var _this = this;

	    // Map glyphs to GlyphInfo objects so data can be passed between
	    // GSUB and GPOS without mutating the real (shared) Glyph objects.
	    this.glyphInfos = glyphRun.glyphs.map(function (glyph) {
	      return new GlyphInfo(_this.font, glyph.id, [].concat(glyph.codePoints));
	    });

	    // Select a script based on what is available in GSUB/GPOS.
	    var script = null;
	    if (this.GPOSProcessor) {
	      script = this.GPOSProcessor.selectScript(glyphRun.script, glyphRun.language, glyphRun.direction);
	    }

	    if (this.GSUBProcessor) {
	      script = this.GSUBProcessor.selectScript(glyphRun.script, glyphRun.language, glyphRun.direction);
	    }

	    // Choose a shaper based on the script, and setup a shaping plan.
	    // This determines which features to apply to which glyphs.
	    this.shaper = choose(script);
	    this.plan = new ShapingPlan(this.font, script, glyphRun.direction);
	    this.shaper.plan(this.plan, this.glyphInfos, glyphRun.features);

	    // Assign chosen features to output glyph run
	    for (var key in this.plan.allFeatures) {
	      glyphRun.features[key] = true;
	    }
	  };

	  OTLayoutEngine.prototype.substitute = function substitute(glyphRun) {
	    var _this2 = this;

	    if (this.GSUBProcessor) {
	      this.plan.process(this.GSUBProcessor, this.glyphInfos);

	      // Map glyph infos back to normal Glyph objects
	      glyphRun.glyphs = this.glyphInfos.map(function (glyphInfo) {
	        return _this2.font.getGlyph(glyphInfo.id, glyphInfo.codePoints);
	      });
	    }
	  };

	  OTLayoutEngine.prototype.position = function position(glyphRun) {
	    if (this.shaper.zeroMarkWidths === 'BEFORE_GPOS') {
	      this.zeroMarkAdvances(glyphRun.positions);
	    }

	    if (this.GPOSProcessor) {
	      this.plan.process(this.GPOSProcessor, this.glyphInfos, glyphRun.positions);
	    }

	    if (this.shaper.zeroMarkWidths === 'AFTER_GPOS') {
	      this.zeroMarkAdvances(glyphRun.positions);
	    }

	    // Reverse the glyphs and positions if the script is right-to-left
	    if (glyphRun.direction === 'rtl') {
	      glyphRun.glyphs.reverse();
	      glyphRun.positions.reverse();
	    }

	    return this.GPOSProcessor && this.GPOSProcessor.features;
	  };

	  OTLayoutEngine.prototype.zeroMarkAdvances = function zeroMarkAdvances(positions) {
	    for (var i = 0; i < this.glyphInfos.length; i++) {
	      if (this.glyphInfos[i].isMark) {
	        positions[i].xAdvance = 0;
	        positions[i].yAdvance = 0;
	      }
	    }
	  };

	  OTLayoutEngine.prototype.cleanup = function cleanup() {
	    this.glyphInfos = null;
	    this.plan = null;
	    this.shaper = null;
	  };

	  OTLayoutEngine.prototype.getAvailableFeatures = function getAvailableFeatures(script, language) {
	    var features = [];

	    if (this.GSUBProcessor) {
	      this.GSUBProcessor.selectScript(script, language);
	      features.push.apply(features, _Object$keys(this.GSUBProcessor.features));
	    }

	    if (this.GPOSProcessor) {
	      this.GPOSProcessor.selectScript(script, language);
	      features.push.apply(features, _Object$keys(this.GPOSProcessor.features));
	    }

	    return features;
	  };

	  return OTLayoutEngine;
	}();

	var LayoutEngine = function () {
	  function LayoutEngine(font) {
	    _classCallCheck(this, LayoutEngine);

	    this.font = font;
	    this.unicodeLayoutEngine = null;
	    this.kernProcessor = null;

	    // Choose an advanced layout engine. We try the AAT morx table first since more
	    // scripts are currently supported because the shaping logic is built into the font.
	    if (this.font.morx) {
	      this.engine = new AATLayoutEngine(this.font);
	    } else if (this.font.GSUB || this.font.GPOS) {
	      this.engine = new OTLayoutEngine(this.font);
	    }
	  }

	  LayoutEngine.prototype.layout = function layout(string, features, script, language, direction) {
	    // Make the features parameter optional
	    if (typeof features === 'string') {
	      direction = language;
	      language = script;
	      script = features;
	      features = [];
	    }

	    // Map string to glyphs if needed
	    if (typeof string === 'string') {
	      // Attempt to detect the script from the string if not provided.
	      if (script == null) {
	        script = forString(string);
	      }

	      var glyphs = this.font.glyphsForString(string);
	    } else {
	      // Attempt to detect the script from the glyph code points if not provided.
	      if (script == null) {
	        var codePoints = [];
	        for (var _iterator = string, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	          var _ref;

	          if (_isArray) {
	            if (_i >= _iterator.length) break;
	            _ref = _iterator[_i++];
	          } else {
	            _i = _iterator.next();
	            if (_i.done) break;
	            _ref = _i.value;
	          }

	          var glyph = _ref;

	          codePoints.push.apply(codePoints, glyph.codePoints);
	        }

	        script = forCodePoints(codePoints);
	      }

	      var glyphs = string;
	    }

	    var glyphRun = new GlyphRun(glyphs, features, script, language, direction);

	    // Return early if there are no glyphs
	    if (glyphs.length === 0) {
	      glyphRun.positions = [];
	      return glyphRun;
	    }

	    // Setup the advanced layout engine
	    if (this.engine && this.engine.setup) {
	      this.engine.setup(glyphRun);
	    }

	    // Substitute and position the glyphs
	    this.substitute(glyphRun);
	    this.position(glyphRun);

	    this.hideDefaultIgnorables(glyphRun.glyphs, glyphRun.positions);

	    // Let the layout engine clean up any state it might have
	    if (this.engine && this.engine.cleanup) {
	      this.engine.cleanup();
	    }

	    return glyphRun;
	  };

	  LayoutEngine.prototype.substitute = function substitute(glyphRun) {
	    // Call the advanced layout engine to make substitutions
	    if (this.engine && this.engine.substitute) {
	      this.engine.substitute(glyphRun);
	    }
	  };

	  LayoutEngine.prototype.position = function position(glyphRun) {
	    // Get initial glyph positions
	    glyphRun.positions = glyphRun.glyphs.map(function (glyph) {
	      return new GlyphPosition(glyph.advanceWidth);
	    });
	    var positioned = null;

	    // Call the advanced layout engine. Returns the features applied.
	    if (this.engine && this.engine.position) {
	      positioned = this.engine.position(glyphRun);
	    }

	    // if there is no GPOS table, use unicode properties to position marks.
	    if (!positioned && (!this.engine || this.engine.fallbackPosition)) {
	      if (!this.unicodeLayoutEngine) {
	        this.unicodeLayoutEngine = new UnicodeLayoutEngine(this.font);
	      }

	      this.unicodeLayoutEngine.positionGlyphs(glyphRun.glyphs, glyphRun.positions);
	    }

	    // if kerning is not supported by GPOS, do kerning with the TrueType/AAT kern table
	    if ((!positioned || !positioned.kern) && glyphRun.features.kern !== false && this.font.kern) {
	      if (!this.kernProcessor) {
	        this.kernProcessor = new KernProcessor(this.font);
	      }

	      this.kernProcessor.process(glyphRun.glyphs, glyphRun.positions);
	      glyphRun.features.kern = true;
	    }
	  };

	  LayoutEngine.prototype.hideDefaultIgnorables = function hideDefaultIgnorables(glyphs, positions) {
	    var space = this.font.glyphForCodePoint(0x20);
	    for (var i = 0; i < glyphs.length; i++) {
	      if (this.isDefaultIgnorable(glyphs[i].codePoints[0])) {
	        glyphs[i] = space;
	        positions[i].xAdvance = 0;
	        positions[i].yAdvance = 0;
	      }
	    }
	  };

	  LayoutEngine.prototype.isDefaultIgnorable = function isDefaultIgnorable(ch) {
	    // From DerivedCoreProperties.txt in the Unicode database,
	    // minus U+115F, U+1160, U+3164 and U+FFA0, which is what
	    // Harfbuzz and Uniscribe do.
	    var plane = ch >> 16;
	    if (plane === 0) {
	      // BMP
	      switch (ch >> 8) {
	        case 0x00:
	          return ch === 0x00AD;
	        case 0x03:
	          return ch === 0x034F;
	        case 0x06:
	          return ch === 0x061C;
	        case 0x17:
	          return 0x17B4 <= ch && ch <= 0x17B5;
	        case 0x18:
	          return 0x180B <= ch && ch <= 0x180E;
	        case 0x20:
	          return 0x200B <= ch && ch <= 0x200F || 0x202A <= ch && ch <= 0x202E || 0x2060 <= ch && ch <= 0x206F;
	        case 0xFE:
	          return 0xFE00 <= ch && ch <= 0xFE0F || ch === 0xFEFF;
	        case 0xFF:
	          return 0xFFF0 <= ch && ch <= 0xFFF8;
	        default:
	          return false;
	      }
	    } else {
	      // Other planes
	      switch (plane) {
	        case 0x01:
	          return 0x1BCA0 <= ch && ch <= 0x1BCA3 || 0x1D173 <= ch && ch <= 0x1D17A;
	        case 0x0E:
	          return 0xE0000 <= ch && ch <= 0xE0FFF;
	        default:
	          return false;
	      }
	    }
	  };

	  LayoutEngine.prototype.getAvailableFeatures = function getAvailableFeatures(script, language) {
	    var features = [];

	    if (this.engine) {
	      features.push.apply(features, this.engine.getAvailableFeatures(script, language));
	    }

	    if (this.font.kern && features.indexOf('kern') === -1) {
	      features.push('kern');
	    }

	    return features;
	  };

	  LayoutEngine.prototype.stringsForGlyph = function stringsForGlyph(gid) {
	    var result = new _Set();

	    var codePoints = this.font._cmapProcessor.codePointsForGlyph(gid);
	    for (var _iterator2 = codePoints, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
	      var _ref2;

	      if (_isArray2) {
	        if (_i2 >= _iterator2.length) break;
	        _ref2 = _iterator2[_i2++];
	      } else {
	        _i2 = _iterator2.next();
	        if (_i2.done) break;
	        _ref2 = _i2.value;
	      }

	      var codePoint = _ref2;

	      result.add(_String$fromCodePoint(codePoint));
	    }

	    if (this.engine && this.engine.stringsForGlyph) {
	      for (var _iterator3 = this.engine.stringsForGlyph(gid), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
	        var _ref3;

	        if (_isArray3) {
	          if (_i3 >= _iterator3.length) break;
	          _ref3 = _iterator3[_i3++];
	        } else {
	          _i3 = _iterator3.next();
	          if (_i3.done) break;
	          _ref3 = _i3.value;
	        }

	        var string = _ref3;

	        result.add(string);
	      }
	    }

	    return _Array$from(result);
	  };

	  return LayoutEngine;
	}();

	var SVG_COMMANDS = {
	  moveTo: 'M',
	  lineTo: 'L',
	  quadraticCurveTo: 'Q',
	  bezierCurveTo: 'C',
	  closePath: 'Z'
	};

	/**
	 * Path objects are returned by glyphs and represent the actual
	 * vector outlines for each glyph in the font. Paths can be converted
	 * to SVG path data strings, or to functions that can be applied to
	 * render the path to a graphics context.
	 */

	var Path = function () {
	  function Path() {
	    _classCallCheck(this, Path);

	    this.commands = [];
	    this._bbox = null;
	    this._cbox = null;
	  }

	  /**
	   * Compiles the path to a JavaScript function that can be applied with
	   * a graphics context in order to render the path.
	   * @return {string}
	   */


	  Path.prototype.toFunction = function toFunction() {
	    var cmds = this.commands.map(function (c) {
	      return '  ctx.' + c.command + '(' + c.args.join(', ') + ');';
	    });
	    return new Function('ctx', cmds.join('\n'));
	  };

	  /**
	   * Converts the path to an SVG path data string
	   * @return {string}
	   */


	  Path.prototype.toSVG = function toSVG() {
	    var cmds = this.commands.map(function (c) {
	      var args = c.args.map(function (arg) {
	        return Math.round(arg * 100) / 100;
	      });
	      return '' + SVG_COMMANDS[c.command] + args.join(' ');
	    });

	    return cmds.join('');
	  };

	  /**
	   * Gets the "control box" of a path.
	   * This is like the bounding box, but it includes all points including
	   * control points of bezier segments and is much faster to compute than
	   * the real bounding box.
	   * @type {BBox}
	   */


	  /**
	   * Applies a mapping function to each point in the path.
	   * @param {function} fn
	   * @return {Path}
	   */
	  Path.prototype.mapPoints = function mapPoints(fn) {
	    var path = new Path();

	    for (var _iterator = this.commands, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	      var _ref;

	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }

	      var c = _ref;

	      var args = [];
	      for (var _i2 = 0; _i2 < c.args.length; _i2 += 2) {
	        var _fn = fn(c.args[_i2], c.args[_i2 + 1]),
	            x = _fn[0],
	            y = _fn[1];

	        args.push(x, y);
	      }

	      path[c.command].apply(path, args);
	    }

	    return path;
	  };

	  /**
	   * Transforms the path by the given matrix.
	   */


	  Path.prototype.transform = function transform(m0, m1, m2, m3, m4, m5) {
	    return this.mapPoints(function (x, y) {
	      x = m0 * x + m2 * y + m4;
	      y = m1 * x + m3 * y + m5;
	      return [x, y];
	    });
	  };

	  /**
	   * Translates the path by the given offset.
	   */


	  Path.prototype.translate = function translate(x, y) {
	    return this.transform(1, 0, 0, 1, x, y);
	  };

	  /**
	   * Rotates the path by the given angle (in radians).
	   */


	  Path.prototype.rotate = function rotate(angle) {
	    var cos = Math.cos(angle);
	    var sin = Math.sin(angle);
	    return this.transform(cos, sin, -sin, cos, 0, 0);
	  };

	  /**
	   * Scales the path.
	   */


	  Path.prototype.scale = function scale(scaleX) {
	    var scaleY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : scaleX;

	    return this.transform(scaleX, 0, 0, scaleY, 0, 0);
	  };

	  _createClass(Path, [{
	    key: 'cbox',
	    get: function get() {
	      if (!this._cbox) {
	        var cbox = new BBox();
	        for (var _iterator2 = this.commands, _isArray2 = Array.isArray(_iterator2), _i3 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
	          var _ref2;

	          if (_isArray2) {
	            if (_i3 >= _iterator2.length) break;
	            _ref2 = _iterator2[_i3++];
	          } else {
	            _i3 = _iterator2.next();
	            if (_i3.done) break;
	            _ref2 = _i3.value;
	          }

	          var command = _ref2;

	          for (var _i4 = 0; _i4 < command.args.length; _i4 += 2) {
	            cbox.addPoint(command.args[_i4], command.args[_i4 + 1]);
	          }
	        }

	        this._cbox = _Object$freeze(cbox);
	      }

	      return this._cbox;
	    }

	    /**
	     * Gets the exact bounding box of the path by evaluating curve segments.
	     * Slower to compute than the control box, but more accurate.
	     * @type {BBox}
	     */

	  }, {
	    key: 'bbox',
	    get: function get() {
	      if (this._bbox) {
	        return this._bbox;
	      }

	      var bbox = new BBox();
	      var cx = 0,
	          cy = 0;

	      var f = function f(t) {
	        return Math.pow(1 - t, 3) * p0[i] + 3 * Math.pow(1 - t, 2) * t * p1[i] + 3 * (1 - t) * Math.pow(t, 2) * p2[i] + Math.pow(t, 3) * p3[i];
	      };

	      for (var _iterator3 = this.commands, _isArray3 = Array.isArray(_iterator3), _i5 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
	        var _ref3;

	        if (_isArray3) {
	          if (_i5 >= _iterator3.length) break;
	          _ref3 = _iterator3[_i5++];
	        } else {
	          _i5 = _iterator3.next();
	          if (_i5.done) break;
	          _ref3 = _i5.value;
	        }

	        var c = _ref3;

	        switch (c.command) {
	          case 'moveTo':
	          case 'lineTo':
	            var _c$args = c.args,
	                x = _c$args[0],
	                y = _c$args[1];

	            bbox.addPoint(x, y);
	            cx = x;
	            cy = y;
	            break;

	          case 'quadraticCurveTo':
	          case 'bezierCurveTo':
	            if (c.command === 'quadraticCurveTo') {
	              // http://fontforge.org/bezier.html
	              var _c$args2 = c.args,
	                  qp1x = _c$args2[0],
	                  qp1y = _c$args2[1],
	                  p3x = _c$args2[2],
	                  p3y = _c$args2[3];

	              var cp1x = cx + 2 / 3 * (qp1x - cx); // CP1 = QP0 + 2/3 * (QP1-QP0)
	              var cp1y = cy + 2 / 3 * (qp1y - cy);
	              var cp2x = p3x + 2 / 3 * (qp1x - p3x); // CP2 = QP2 + 2/3 * (QP1-QP2)
	              var cp2y = p3y + 2 / 3 * (qp1y - p3y);
	            } else {
	              var _c$args3 = c.args,
	                  cp1x = _c$args3[0],
	                  cp1y = _c$args3[1],
	                  cp2x = _c$args3[2],
	                  cp2y = _c$args3[3],
	                  p3x = _c$args3[4],
	                  p3y = _c$args3[5];
	            }

	            // http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
	            bbox.addPoint(p3x, p3y);

	            var p0 = [cx, cy];
	            var p1 = [cp1x, cp1y];
	            var p2 = [cp2x, cp2y];
	            var p3 = [p3x, p3y];

	            for (var i = 0; i <= 1; i++) {
	              var b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
	              var a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
	              c = 3 * p1[i] - 3 * p0[i];

	              if (a === 0) {
	                if (b === 0) {
	                  continue;
	                }

	                var t = -c / b;
	                if (0 < t && t < 1) {
	                  if (i === 0) {
	                    bbox.addPoint(f(t), bbox.maxY);
	                  } else if (i === 1) {
	                    bbox.addPoint(bbox.maxX, f(t));
	                  }
	                }

	                continue;
	              }

	              var b2ac = Math.pow(b, 2) - 4 * c * a;
	              if (b2ac < 0) {
	                continue;
	              }

	              var t1 = (-b + Math.sqrt(b2ac)) / (2 * a);
	              if (0 < t1 && t1 < 1) {
	                if (i === 0) {
	                  bbox.addPoint(f(t1), bbox.maxY);
	                } else if (i === 1) {
	                  bbox.addPoint(bbox.maxX, f(t1));
	                }
	              }

	              var t2 = (-b - Math.sqrt(b2ac)) / (2 * a);
	              if (0 < t2 && t2 < 1) {
	                if (i === 0) {
	                  bbox.addPoint(f(t2), bbox.maxY);
	                } else if (i === 1) {
	                  bbox.addPoint(bbox.maxX, f(t2));
	                }
	              }
	            }

	            cx = p3x;
	            cy = p3y;
	            break;
	        }
	      }

	      return this._bbox = _Object$freeze(bbox);
	    }
	  }]);

	  return Path;
	}();

	var _arr = ['moveTo', 'lineTo', 'quadraticCurveTo', 'bezierCurveTo', 'closePath'];

	var _loop = function _loop() {
	  var command = _arr[_i6];
	  Path.prototype[command] = function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }

	    this._bbox = this._cbox = null;
	    this.commands.push({
	      command: command,
	      args: args
	    });

	    return this;
	  };
	};

	for (var _i6 = 0; _i6 < _arr.length; _i6++) {
	  _loop();
	}

	var StandardNames = ['.notdef', '.null', 'nonmarkingreturn', 'space', 'exclam', 'quotedbl', 'numbersign', 'dollar', 'percent', 'ampersand', 'quotesingle', 'parenleft', 'parenright', 'asterisk', 'plus', 'comma', 'hyphen', 'period', 'slash', 'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'colon', 'semicolon', 'less', 'equal', 'greater', 'question', 'at', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'bracketleft', 'backslash', 'bracketright', 'asciicircum', 'underscore', 'grave', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'braceleft', 'bar', 'braceright', 'asciitilde', 'Adieresis', 'Aring', 'Ccedilla', 'Eacute', 'Ntilde', 'Odieresis', 'Udieresis', 'aacute', 'agrave', 'acircumflex', 'adieresis', 'atilde', 'aring', 'ccedilla', 'eacute', 'egrave', 'ecircumflex', 'edieresis', 'iacute', 'igrave', 'icircumflex', 'idieresis', 'ntilde', 'oacute', 'ograve', 'ocircumflex', 'odieresis', 'otilde', 'uacute', 'ugrave', 'ucircumflex', 'udieresis', 'dagger', 'degree', 'cent', 'sterling', 'section', 'bullet', 'paragraph', 'germandbls', 'registered', 'copyright', 'trademark', 'acute', 'dieresis', 'notequal', 'AE', 'Oslash', 'infinity', 'plusminus', 'lessequal', 'greaterequal', 'yen', 'mu', 'partialdiff', 'summation', 'product', 'pi', 'integral', 'ordfeminine', 'ordmasculine', 'Omega', 'ae', 'oslash', 'questiondown', 'exclamdown', 'logicalnot', 'radical', 'florin', 'approxequal', 'Delta', 'guillemotleft', 'guillemotright', 'ellipsis', 'nonbreakingspace', 'Agrave', 'Atilde', 'Otilde', 'OE', 'oe', 'endash', 'emdash', 'quotedblleft', 'quotedblright', 'quoteleft', 'quoteright', 'divide', 'lozenge', 'ydieresis', 'Ydieresis', 'fraction', 'currency', 'guilsinglleft', 'guilsinglright', 'fi', 'fl', 'daggerdbl', 'periodcentered', 'quotesinglbase', 'quotedblbase', 'perthousand', 'Acircumflex', 'Ecircumflex', 'Aacute', 'Edieresis', 'Egrave', 'Iacute', 'Icircumflex', 'Idieresis', 'Igrave', 'Oacute', 'Ocircumflex', 'apple', 'Ograve', 'Uacute', 'Ucircumflex', 'Ugrave', 'dotlessi', 'circumflex', 'tilde', 'macron', 'breve', 'dotaccent', 'ring', 'cedilla', 'hungarumlaut', 'ogonek', 'caron', 'Lslash', 'lslash', 'Scaron', 'scaron', 'Zcaron', 'zcaron', 'brokenbar', 'Eth', 'eth', 'Yacute', 'yacute', 'Thorn', 'thorn', 'minus', 'multiply', 'onesuperior', 'twosuperior', 'threesuperior', 'onehalf', 'onequarter', 'threequarters', 'franc', 'Gbreve', 'gbreve', 'Idotaccent', 'Scedilla', 'scedilla', 'Cacute', 'cacute', 'Ccaron', 'ccaron', 'dcroat'];

	var _class$8;
	function _applyDecoratedDescriptor$4(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;

	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }

	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);

	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }

	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }

	  return desc;
	}

	/**
	 * Glyph objects represent a glyph in the font. They have various properties for accessing metrics and
	 * the actual vector path the glyph represents, and methods for rendering the glyph to a graphics context.
	 *
	 * You do not create glyph objects directly. They are created by various methods on the font object.
	 * There are several subclasses of the base Glyph class internally that may be returned depending
	 * on the font format, but they all inherit from this class.
	 */
	var Glyph = (_class$8 = function () {
	  function Glyph(id, codePoints, font) {
	    _classCallCheck(this, Glyph);

	    /**
	     * The glyph id in the font
	     * @type {number}
	     */
	    this.id = id;

	    /**
	     * An array of unicode code points that are represented by this glyph.
	     * There can be multiple code points in the case of ligatures and other glyphs
	     * that represent multiple visual characters.
	     * @type {number[]}
	     */
	    this.codePoints = codePoints;
	    this._font = font;

	    // TODO: get this info from GDEF if available
	    this.isMark = this.codePoints.every(unicode.isMark);
	    this.isLigature = this.codePoints.length > 1;
	  }

	  Glyph.prototype._getPath = function _getPath() {
	    return new Path();
	  };

	  Glyph.prototype._getCBox = function _getCBox() {
	    return this.path.cbox;
	  };

	  Glyph.prototype._getBBox = function _getBBox() {
	    return this.path.bbox;
	  };

	  Glyph.prototype._getTableMetrics = function _getTableMetrics(table) {
	    if (this.id < table.metrics.length) {
	      return table.metrics.get(this.id);
	    }

	    var metric = table.metrics.get(table.metrics.length - 1);
	    var res = {
	      advance: metric ? metric.advance : 0,
	      bearing: table.bearings.get(this.id - table.metrics.length) || 0
	    };

	    return res;
	  };

	  Glyph.prototype._getMetrics = function _getMetrics(cbox) {
	    if (this._metrics) {
	      return this._metrics;
	    }

	    var _getTableMetrics2 = this._getTableMetrics(this._font.hmtx),
	        advanceWidth = _getTableMetrics2.advance,
	        leftBearing = _getTableMetrics2.bearing;

	    // For vertical metrics, use vmtx if available, or fall back to global data from OS/2 or hhea


	    if (this._font.vmtx) {
	      var _getTableMetrics3 = this._getTableMetrics(this._font.vmtx),
	          advanceHeight = _getTableMetrics3.advance,
	          topBearing = _getTableMetrics3.bearing;
	    } else {
	      var os2 = void 0;
	      if (typeof cbox === 'undefined' || cbox === null) {
	        cbox = this.cbox;
	      }

	      if ((os2 = this._font['OS/2']) && os2.version > 0) {
	        var advanceHeight = Math.abs(os2.typoAscender - os2.typoDescender);
	        var topBearing = os2.typoAscender - cbox.maxY;
	      } else {
	        var hhea = this._font.hhea;

	        var advanceHeight = Math.abs(hhea.ascent - hhea.descent);
	        var topBearing = hhea.ascent - cbox.maxY;
	      }
	    }

	    if (this._font._variationProcessor && this._font.HVAR) {
	      advanceWidth += this._font._variationProcessor.getAdvanceAdjustment(this.id, this._font.HVAR);
	    }

	    return this._metrics = { advanceWidth: advanceWidth, advanceHeight: advanceHeight, leftBearing: leftBearing, topBearing: topBearing };
	  };

	  /**
	   * The glyph’s control box.
	   * This is often the same as the bounding box, but is faster to compute.
	   * Because of the way bezier curves are defined, some of the control points
	   * can be outside of the bounding box. Where `bbox` takes this into account,
	   * `cbox` does not. Thus, cbox is less accurate, but faster to compute.
	   * See [here](http://www.freetype.org/freetype2/docs/glyphs/glyphs-6.html#section-2)
	   * for a more detailed description.
	   *
	   * @type {BBox}
	   */


	  /**
	   * Returns a path scaled to the given font size.
	   * @param {number} size
	   * @return {Path}
	   */
	  Glyph.prototype.getScaledPath = function getScaledPath(size) {
	    var scale = 1 / this._font.unitsPerEm * size;
	    return this.path.scale(scale);
	  };

	  /**
	   * The glyph's advance width.
	   * @type {number}
	   */


	  Glyph.prototype._getName = function _getName() {
	    var post = this._font.post;

	    if (!post) {
	      return null;
	    }

	    switch (post.version) {
	      case 1:
	        return StandardNames[this.id];

	      case 2:
	        var id = post.glyphNameIndex[this.id];
	        if (id < StandardNames.length) {
	          return StandardNames[id];
	        }

	        return post.names[id - StandardNames.length];

	      case 2.5:
	        return StandardNames[this.id + post.offsets[this.id]];

	      case 4:
	        return String.fromCharCode(post.map[this.id]);
	    }
	  };

	  /**
	   * The glyph's name
	   * @type {string}
	   */


	  /**
	   * Renders the glyph to the given graphics context, at the specified font size.
	   * @param {CanvasRenderingContext2d} ctx
	   * @param {number} size
	   */
	  Glyph.prototype.render = function render(ctx, size) {
	    ctx.save();

	    var scale = 1 / this._font.head.unitsPerEm * size;
	    ctx.scale(scale, scale);

	    var fn = this.path.toFunction();
	    fn(ctx);
	    ctx.fill();

	    ctx.restore();
	  };

	  _createClass(Glyph, [{
	    key: 'cbox',
	    get: function get() {
	      return this._getCBox();
	    }

	    /**
	     * The glyph’s bounding box, i.e. the rectangle that encloses the
	     * glyph outline as tightly as possible.
	     * @type {BBox}
	     */

	  }, {
	    key: 'bbox',
	    get: function get() {
	      return this._getBBox();
	    }

	    /**
	     * A vector Path object representing the glyph outline.
	     * @type {Path}
	     */

	  }, {
	    key: 'path',
	    get: function get() {
	      // Cache the path so we only decode it once
	      // Decoding is actually performed by subclasses
	      return this._getPath();
	    }
	  }, {
	    key: 'advanceWidth',
	    get: function get() {
	      return this._getMetrics().advanceWidth;
	    }

	    /**
	     * The glyph's advance height.
	     * @type {number}
	     */

	  }, {
	    key: 'advanceHeight',
	    get: function get() {
	      return this._getMetrics().advanceHeight;
	    }
	  }, {
	    key: 'ligatureCaretPositions',
	    get: function get() {}
	  }, {
	    key: 'name',
	    get: function get() {
	      return this._getName();
	    }
	  }]);

	  return Glyph;
	}(), (_applyDecoratedDescriptor$4(_class$8.prototype, 'cbox', [cache], _Object$getOwnPropertyDescriptor(_class$8.prototype, 'cbox'), _class$8.prototype), _applyDecoratedDescriptor$4(_class$8.prototype, 'bbox', [cache], _Object$getOwnPropertyDescriptor(_class$8.prototype, 'bbox'), _class$8.prototype), _applyDecoratedDescriptor$4(_class$8.prototype, 'path', [cache], _Object$getOwnPropertyDescriptor(_class$8.prototype, 'path'), _class$8.prototype), _applyDecoratedDescriptor$4(_class$8.prototype, 'advanceWidth', [cache], _Object$getOwnPropertyDescriptor(_class$8.prototype, 'advanceWidth'), _class$8.prototype), _applyDecoratedDescriptor$4(_class$8.prototype, 'advanceHeight', [cache], _Object$getOwnPropertyDescriptor(_class$8.prototype, 'advanceHeight'), _class$8.prototype), _applyDecoratedDescriptor$4(_class$8.prototype, 'name', [cache], _Object$getOwnPropertyDescriptor(_class$8.prototype, 'name'), _class$8.prototype)), _class$8);

	// The header for both simple and composite glyphs
	var GlyfHeader = new r.Struct({
	  numberOfContours: r.int16, // if negative, this is a composite glyph
	  xMin: r.int16,
	  yMin: r.int16,
	  xMax: r.int16,
	  yMax: r.int16
	});

	// Flags for simple glyphs
	var ON_CURVE = 1 << 0;
	var X_SHORT_VECTOR = 1 << 1;
	var Y_SHORT_VECTOR = 1 << 2;
	var REPEAT = 1 << 3;
	var SAME_X = 1 << 4;
	var SAME_Y = 1 << 5;

	// Flags for composite glyphs
	var ARG_1_AND_2_ARE_WORDS = 1 << 0;
	var WE_HAVE_A_SCALE = 1 << 3;
	var MORE_COMPONENTS = 1 << 5;
	var WE_HAVE_AN_X_AND_Y_SCALE = 1 << 6;
	var WE_HAVE_A_TWO_BY_TWO = 1 << 7;
	var WE_HAVE_INSTRUCTIONS = 1 << 8;
	// Represents a point in a simple glyph
	var Point = function () {
	  function Point(onCurve, endContour) {
	    var x = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	    var y = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

	    _classCallCheck(this, Point);

	    this.onCurve = onCurve;
	    this.endContour = endContour;
	    this.x = x;
	    this.y = y;
	  }

	  Point.prototype.copy = function copy() {
	    return new Point(this.onCurve, this.endContour, this.x, this.y);
	  };

	  return Point;
	}();

	// Represents a component in a composite glyph

	var Component = function Component(glyphID, dx, dy) {
	  _classCallCheck(this, Component);

	  this.glyphID = glyphID;
	  this.dx = dx;
	  this.dy = dy;
	  this.pos = 0;
	  this.scaleX = this.scaleY = 1;
	  this.scale01 = this.scale10 = 0;
	};

	/**
	 * Represents a TrueType glyph.
	 */


	var TTFGlyph = function (_Glyph) {
	  _inherits(TTFGlyph, _Glyph);

	  function TTFGlyph() {
	    _classCallCheck(this, TTFGlyph);

	    return _possibleConstructorReturn(this, _Glyph.apply(this, arguments));
	  }

	  // Parses just the glyph header and returns the bounding box
	  TTFGlyph.prototype._getCBox = function _getCBox(internal) {
	    // We need to decode the glyph if variation processing is requested,
	    // so it's easier just to recompute the path's cbox after decoding.
	    if (this._font._variationProcessor && !internal) {
	      return this.path.cbox;
	    }

	    var stream = this._font._getTableStream('glyf');
	    stream.pos += this._font.loca.offsets[this.id];
	    var glyph = GlyfHeader.decode(stream);

	    var cbox = new BBox(glyph.xMin, glyph.yMin, glyph.xMax, glyph.yMax);
	    return _Object$freeze(cbox);
	  };

	  // Parses a single glyph coordinate


	  TTFGlyph.prototype._parseGlyphCoord = function _parseGlyphCoord(stream, prev, short, same) {
	    if (short) {
	      var val = stream.readUInt8();
	      if (!same) {
	        val = -val;
	      }

	      val += prev;
	    } else {
	      if (same) {
	        var val = prev;
	      } else {
	        var val = prev + stream.readInt16BE();
	      }
	    }

	    return val;
	  };

	  // Decodes the glyph data into points for simple glyphs,
	  // or components for composite glyphs


	  TTFGlyph.prototype._decode = function _decode() {
	    var glyfPos = this._font.loca.offsets[this.id];
	    var nextPos = this._font.loca.offsets[this.id + 1];

	    // Nothing to do if there is no data for this glyph
	    if (glyfPos === nextPos) {
	      return null;
	    }

	    var stream = this._font._getTableStream('glyf');
	    stream.pos += glyfPos;
	    var startPos = stream.pos;

	    var glyph = GlyfHeader.decode(stream);

	    if (glyph.numberOfContours > 0) {
	      this._decodeSimple(glyph, stream);
	    } else if (glyph.numberOfContours < 0) {
	      this._decodeComposite(glyph, stream, startPos);
	    }

	    return glyph;
	  };

	  TTFGlyph.prototype._decodeSimple = function _decodeSimple(glyph, stream) {
	    // this is a simple glyph
	    glyph.points = [];

	    var endPtsOfContours = new r.Array(r.uint16, glyph.numberOfContours).decode(stream);
	    glyph.instructions = new r.Array(r.uint8, r.uint16).decode(stream);

	    var flags = [];
	    var numCoords = endPtsOfContours[endPtsOfContours.length - 1] + 1;

	    while (flags.length < numCoords) {
	      var flag = stream.readUInt8();
	      flags.push(flag);

	      // check for repeat flag
	      if (flag & REPEAT) {
	        var count = stream.readUInt8();
	        for (var j = 0; j < count; j++) {
	          flags.push(flag);
	        }
	      }
	    }

	    for (var i = 0; i < flags.length; i++) {
	      var flag = flags[i];
	      var point = new Point(!!(flag & ON_CURVE), endPtsOfContours.indexOf(i) >= 0, 0, 0);
	      glyph.points.push(point);
	    }

	    var px = 0;
	    for (var i = 0; i < flags.length; i++) {
	      var flag = flags[i];
	      glyph.points[i].x = px = this._parseGlyphCoord(stream, px, flag & X_SHORT_VECTOR, flag & SAME_X);
	    }

	    var py = 0;
	    for (var i = 0; i < flags.length; i++) {
	      var flag = flags[i];
	      glyph.points[i].y = py = this._parseGlyphCoord(stream, py, flag & Y_SHORT_VECTOR, flag & SAME_Y);
	    }

	    if (this._font._variationProcessor) {
	      var points = glyph.points.slice();
	      points.push.apply(points, this._getPhantomPoints(glyph));

	      this._font._variationProcessor.transformPoints(this.id, points);
	      glyph.phantomPoints = points.slice(-4);
	    }

	    return;
	  };

	  TTFGlyph.prototype._decodeComposite = function _decodeComposite(glyph, stream) {
	    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

	    // this is a composite glyph
	    glyph.components = [];
	    var haveInstructions = false;
	    var flags = MORE_COMPONENTS;

	    while (flags & MORE_COMPONENTS) {
	      flags = stream.readUInt16BE();
	      var gPos = stream.pos - offset;
	      var glyphID = stream.readUInt16BE();
	      if (!haveInstructions) {
	        haveInstructions = (flags & WE_HAVE_INSTRUCTIONS) !== 0;
	      }

	      if (flags & ARG_1_AND_2_ARE_WORDS) {
	        var dx = stream.readInt16BE();
	        var dy = stream.readInt16BE();
	      } else {
	        var dx = stream.readInt8();
	        var dy = stream.readInt8();
	      }

	      var component = new Component(glyphID, dx, dy);
	      component.pos = gPos;

	      if (flags & WE_HAVE_A_SCALE) {
	        // fixed number with 14 bits of fraction
	        component.scaleX = component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
	      } else if (flags & WE_HAVE_AN_X_AND_Y_SCALE) {
	        component.scaleX = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
	        component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
	      } else if (flags & WE_HAVE_A_TWO_BY_TWO) {
	        component.scaleX = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
	        component.scale01 = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
	        component.scale10 = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
	        component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
	      }

	      glyph.components.push(component);
	    }

	    if (this._font._variationProcessor) {
	      var points = [];
	      for (var j = 0; j < glyph.components.length; j++) {
	        var component = glyph.components[j];
	        points.push(new Point(true, true, component.dx, component.dy));
	      }

	      points.push.apply(points, this._getPhantomPoints(glyph));

	      this._font._variationProcessor.transformPoints(this.id, points);
	      glyph.phantomPoints = points.splice(-4, 4);

	      for (var i = 0; i < points.length; i++) {
	        var point = points[i];
	        glyph.components[i].dx = point.x;
	        glyph.components[i].dy = point.y;
	      }
	    }

	    return haveInstructions;
	  };

	  TTFGlyph.prototype._getPhantomPoints = function _getPhantomPoints(glyph) {
	    var cbox = this._getCBox(true);
	    if (this._metrics == null) {
	      this._metrics = Glyph.prototype._getMetrics.call(this, cbox);
	    }

	    var _metrics = this._metrics,
	        advanceWidth = _metrics.advanceWidth,
	        advanceHeight = _metrics.advanceHeight,
	        leftBearing = _metrics.leftBearing,
	        topBearing = _metrics.topBearing;


	    return [new Point(false, true, glyph.xMin - leftBearing, 0), new Point(false, true, glyph.xMin - leftBearing + advanceWidth, 0), new Point(false, true, 0, glyph.yMax + topBearing), new Point(false, true, 0, glyph.yMax + topBearing + advanceHeight)];
	  };

	  // Decodes font data, resolves composite glyphs, and returns an array of contours


	  TTFGlyph.prototype._getContours = function _getContours() {
	    var glyph = this._decode();
	    if (!glyph) {
	      return [];
	    }

	    var points = [];

	    if (glyph.numberOfContours < 0) {
	      // resolve composite glyphs
	      for (var _iterator = glyph.components, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	        var _ref;

	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }

	        var component = _ref;

	        var _contours = this._font.getGlyph(component.glyphID)._getContours();
	        for (var i = 0; i < _contours.length; i++) {
	          var contour = _contours[i];
	          for (var j = 0; j < contour.length; j++) {
	            var _point = contour[j];
	            var x = _point.x * component.scaleX + _point.y * component.scale01 + component.dx;
	            var y = _point.y * component.scaleY + _point.x * component.scale10 + component.dy;
	            points.push(new Point(_point.onCurve, _point.endContour, x, y));
	          }
	        }
	      }
	    } else {
	      points = glyph.points || [];
	    }

	    // Recompute and cache metrics if we performed variation processing, and don't have an HVAR table
	    if (glyph.phantomPoints && !this._font.directory.tables.HVAR) {
	      this._metrics.advanceWidth = glyph.phantomPoints[1].x - glyph.phantomPoints[0].x;
	      this._metrics.advanceHeight = glyph.phantomPoints[3].y - glyph.phantomPoints[2].y;
	      this._metrics.leftBearing = glyph.xMin - glyph.phantomPoints[0].x;
	      this._metrics.topBearing = glyph.phantomPoints[2].y - glyph.yMax;
	    }

	    var contours = [];
	    var cur = [];
	    for (var k = 0; k < points.length; k++) {
	      var point = points[k];
	      cur.push(point);
	      if (point.endContour) {
	        contours.push(cur);
	        cur = [];
	      }
	    }

	    return contours;
	  };

	  TTFGlyph.prototype._getMetrics = function _getMetrics() {
	    if (this._metrics) {
	      return this._metrics;
	    }

	    var cbox = this._getCBox(true);
	    _Glyph.prototype._getMetrics.call(this, cbox);

	    if (this._font._variationProcessor && !this._font.HVAR) {
	      // No HVAR table, decode the glyph. This triggers recomputation of metrics.
	      this.path;
	    }

	    return this._metrics;
	  };

	  // Converts contours to a Path object that can be rendered


	  TTFGlyph.prototype._getPath = function _getPath() {
	    var contours = this._getContours();
	    var path = new Path();

	    for (var i = 0; i < contours.length; i++) {
	      var contour = contours[i];
	      var firstPt = contour[0];
	      var lastPt = contour[contour.length - 1];
	      var start = 0;

	      if (firstPt.onCurve) {
	        // The first point will be consumed by the moveTo command, so skip in the loop
	        var curvePt = null;
	        start = 1;
	      } else {
	        if (lastPt.onCurve) {
	          // Start at the last point if the first point is off curve and the last point is on curve
	          firstPt = lastPt;
	        } else {
	          // Start at the middle if both the first and last points are off curve
	          firstPt = new Point(false, false, (firstPt.x + lastPt.x) / 2, (firstPt.y + lastPt.y) / 2);
	        }

	        var curvePt = firstPt;
	      }

	      path.moveTo(firstPt.x, firstPt.y);

	      for (var j = start; j < contour.length; j++) {
	        var pt = contour[j];
	        var prevPt = j === 0 ? firstPt : contour[j - 1];

	        if (prevPt.onCurve && pt.onCurve) {
	          path.lineTo(pt.x, pt.y);
	        } else if (prevPt.onCurve && !pt.onCurve) {
	          var curvePt = pt;
	        } else if (!prevPt.onCurve && !pt.onCurve) {
	          var midX = (prevPt.x + pt.x) / 2;
	          var midY = (prevPt.y + pt.y) / 2;
	          path.quadraticCurveTo(prevPt.x, prevPt.y, midX, midY);
	          var curvePt = pt;
	        } else if (!prevPt.onCurve && pt.onCurve) {
	          path.quadraticCurveTo(curvePt.x, curvePt.y, pt.x, pt.y);
	          var curvePt = null;
	        } else {
	          throw new Error("Unknown TTF path state");
	        }
	      }

	      // Connect the first and last points
	      if (curvePt) {
	        path.quadraticCurveTo(curvePt.x, curvePt.y, firstPt.x, firstPt.y);
	      }

	      path.closePath();
	    }

	    return path;
	  };

	  return TTFGlyph;
	}(Glyph);

	/**
	 * Represents an OpenType PostScript glyph, in the Compact Font Format.
	 */

	var CFFGlyph = function (_Glyph) {
	  _inherits(CFFGlyph, _Glyph);

	  function CFFGlyph() {
	    _classCallCheck(this, CFFGlyph);

	    return _possibleConstructorReturn(this, _Glyph.apply(this, arguments));
	  }

	  CFFGlyph.prototype._getName = function _getName() {
	    if (this._font.CFF2) {
	      return _Glyph.prototype._getName.call(this);
	    }

	    return this._font['CFF '].getGlyphName(this.id);
	  };

	  CFFGlyph.prototype.bias = function bias(s) {
	    if (s.length < 1240) {
	      return 107;
	    } else if (s.length < 33900) {
	      return 1131;
	    } else {
	      return 32768;
	    }
	  };

	  CFFGlyph.prototype._getPath = function _getPath() {
	    var stream = this._font.stream;
	    var pos = stream.pos;


	    var cff = this._font.CFF2 || this._font['CFF '];
	    var str = cff.topDict.CharStrings[this.id];
	    var end = str.offset + str.length;
	    stream.pos = str.offset;

	    var path = new Path();
	    var stack = [];
	    var trans = [];

	    var width = null;
	    var nStems = 0;
	    var x = 0,
	        y = 0;
	    var usedGsubrs = void 0;
	    var usedSubrs = void 0;
	    var open = false;

	    this._usedGsubrs = usedGsubrs = {};
	    this._usedSubrs = usedSubrs = {};

	    var gsubrs = cff.globalSubrIndex || [];
	    var gsubrsBias = this.bias(gsubrs);

	    var privateDict = cff.privateDictForGlyph(this.id);
	    var subrs = privateDict.Subrs || [];
	    var subrsBias = this.bias(subrs);

	    var vstore = cff.topDict.vstore && cff.topDict.vstore.itemVariationStore;
	    var vsindex = privateDict.vsindex;
	    var variationProcessor = this._font._variationProcessor;

	    function checkWidth() {
	      if (width == null) {
	        width = stack.shift() + privateDict.nominalWidthX;
	      }
	    }

	    function parseStems() {
	      if (stack.length % 2 !== 0) {
	        checkWidth();
	      }

	      nStems += stack.length >> 1;
	      return stack.length = 0;
	    }

	    function moveTo(x, y) {
	      if (open) {
	        path.closePath();
	      }

	      path.moveTo(x, y);
	      open = true;
	    }

	    var parse = function parse() {
	      while (stream.pos < end) {
	        var op = stream.readUInt8();
	        if (op < 32) {
	          switch (op) {
	            case 1: // hstem
	            case 3: // vstem
	            case 18: // hstemhm
	            case 23:
	              // vstemhm
	              parseStems();
	              break;

	            case 4:
	              // vmoveto
	              if (stack.length > 1) {
	                checkWidth();
	              }

	              y += stack.shift();
	              moveTo(x, y);
	              break;

	            case 5:
	              // rlineto
	              while (stack.length >= 2) {
	                x += stack.shift();
	                y += stack.shift();
	                path.lineTo(x, y);
	              }
	              break;

	            case 6: // hlineto
	            case 7:
	              // vlineto
	              var phase = op === 6;
	              while (stack.length >= 1) {
	                if (phase) {
	                  x += stack.shift();
	                } else {
	                  y += stack.shift();
	                }

	                path.lineTo(x, y);
	                phase = !phase;
	              }
	              break;

	            case 8:
	              // rrcurveto
	              while (stack.length > 0) {
	                var c1x = x + stack.shift();
	                var c1y = y + stack.shift();
	                var c2x = c1x + stack.shift();
	                var c2y = c1y + stack.shift();
	                x = c2x + stack.shift();
	                y = c2y + stack.shift();
	                path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
	              }
	              break;

	            case 10:
	              // callsubr
	              var index = stack.pop() + subrsBias;
	              var subr = subrs[index];
	              if (subr) {
	                usedSubrs[index] = true;
	                var p = stream.pos;
	                var e = end;
	                stream.pos = subr.offset;
	                end = subr.offset + subr.length;
	                parse();
	                stream.pos = p;
	                end = e;
	              }
	              break;

	            case 11:
	              // return
	              if (cff.version >= 2) {
	                break;
	              }
	              return;

	            case 14:
	              // endchar
	              if (cff.version >= 2) {
	                break;
	              }

	              if (stack.length > 0) {
	                checkWidth();
	              }

	              if (open) {
	                path.closePath();
	                open = false;
	              }
	              break;

	            case 15:
	              {
	                // vsindex
	                if (cff.version < 2) {
	                  throw new Error('vsindex operator not supported in CFF v1');
	                }

	                vsindex = stack.pop();
	                break;
	              }

	            case 16:
	              {
	                // blend
	                if (cff.version < 2) {
	                  throw new Error('blend operator not supported in CFF v1');
	                }

	                if (!variationProcessor) {
	                  throw new Error('blend operator in non-variation font');
	                }

	                var blendVector = variationProcessor.getBlendVector(vstore, vsindex);
	                var numBlends = stack.pop();
	                var numOperands = numBlends * blendVector.length;
	                var delta = stack.length - numOperands;
	                var base = delta - numBlends;

	                for (var i = 0; i < numBlends; i++) {
	                  var sum = stack[base + i];
	                  for (var j = 0; j < blendVector.length; j++) {
	                    sum += blendVector[j] * stack[delta++];
	                  }

	                  stack[base + i] = sum;
	                }

	                while (numOperands--) {
	                  stack.pop();
	                }

	                break;
	              }

	            case 19: // hintmask
	            case 20:
	              // cntrmask
	              parseStems();
	              stream.pos += nStems + 7 >> 3;
	              break;

	            case 21:
	              // rmoveto
	              if (stack.length > 2) {
	                checkWidth();
	              }

	              x += stack.shift();
	              y += stack.shift();
	              moveTo(x, y);
	              break;

	            case 22:
	              // hmoveto
	              if (stack.length > 1) {
	                checkWidth();
	              }

	              x += stack.shift();
	              moveTo(x, y);
	              break;

	            case 24:
	              // rcurveline
	              while (stack.length >= 8) {
	                var c1x = x + stack.shift();
	                var c1y = y + stack.shift();
	                var c2x = c1x + stack.shift();
	                var c2y = c1y + stack.shift();
	                x = c2x + stack.shift();
	                y = c2y + stack.shift();
	                path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
	              }

	              x += stack.shift();
	              y += stack.shift();
	              path.lineTo(x, y);
	              break;

	            case 25:
	              // rlinecurve
	              while (stack.length >= 8) {
	                x += stack.shift();
	                y += stack.shift();
	                path.lineTo(x, y);
	              }

	              var c1x = x + stack.shift();
	              var c1y = y + stack.shift();
	              var c2x = c1x + stack.shift();
	              var c2y = c1y + stack.shift();
	              x = c2x + stack.shift();
	              y = c2y + stack.shift();
	              path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
	              break;

	            case 26:
	              // vvcurveto
	              if (stack.length % 2) {
	                x += stack.shift();
	              }

	              while (stack.length >= 4) {
	                c1x = x;
	                c1y = y + stack.shift();
	                c2x = c1x + stack.shift();
	                c2y = c1y + stack.shift();
	                x = c2x;
	                y = c2y + stack.shift();
	                path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
	              }
	              break;

	            case 27:
	              // hhcurveto
	              if (stack.length % 2) {
	                y += stack.shift();
	              }

	              while (stack.length >= 4) {
	                c1x = x + stack.shift();
	                c1y = y;
	                c2x = c1x + stack.shift();
	                c2y = c1y + stack.shift();
	                x = c2x + stack.shift();
	                y = c2y;
	                path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
	              }
	              break;

	            case 28:
	              // shortint
	              stack.push(stream.readInt16BE());
	              break;

	            case 29:
	              // callgsubr
	              index = stack.pop() + gsubrsBias;
	              subr = gsubrs[index];
	              if (subr) {
	                usedGsubrs[index] = true;
	                var p = stream.pos;
	                var e = end;
	                stream.pos = subr.offset;
	                end = subr.offset + subr.length;
	                parse();
	                stream.pos = p;
	                end = e;
	              }
	              break;

	            case 30: // vhcurveto
	            case 31:
	              // hvcurveto
	              phase = op === 31;
	              while (stack.length >= 4) {
	                if (phase) {
	                  c1x = x + stack.shift();
	                  c1y = y;
	                  c2x = c1x + stack.shift();
	                  c2y = c1y + stack.shift();
	                  y = c2y + stack.shift();
	                  x = c2x + (stack.length === 1 ? stack.shift() : 0);
	                } else {
	                  c1x = x;
	                  c1y = y + stack.shift();
	                  c2x = c1x + stack.shift();
	                  c2y = c1y + stack.shift();
	                  x = c2x + stack.shift();
	                  y = c2y + (stack.length === 1 ? stack.shift() : 0);
	                }

	                path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
	                phase = !phase;
	              }
	              break;

	            case 12:
	              op = stream.readUInt8();
	              switch (op) {
	                case 3:
	                  // and
	                  var a = stack.pop();
	                  var b = stack.pop();
	                  stack.push(a && b ? 1 : 0);
	                  break;

	                case 4:
	                  // or
	                  a = stack.pop();
	                  b = stack.pop();
	                  stack.push(a || b ? 1 : 0);
	                  break;

	                case 5:
	                  // not
	                  a = stack.pop();
	                  stack.push(a ? 0 : 1);
	                  break;

	                case 9:
	                  // abs
	                  a = stack.pop();
	                  stack.push(Math.abs(a));
	                  break;

	                case 10:
	                  // add
	                  a = stack.pop();
	                  b = stack.pop();
	                  stack.push(a + b);
	                  break;

	                case 11:
	                  // sub
	                  a = stack.pop();
	                  b = stack.pop();
	                  stack.push(a - b);
	                  break;

	                case 12:
	                  // div
	                  a = stack.pop();
	                  b = stack.pop();
	                  stack.push(a / b);
	                  break;

	                case 14:
	                  // neg
	                  a = stack.pop();
	                  stack.push(-a);
	                  break;

	                case 15:
	                  // eq
	                  a = stack.pop();
	                  b = stack.pop();
	                  stack.push(a === b ? 1 : 0);
	                  break;

	                case 18:
	                  // drop
	                  stack.pop();
	                  break;

	                case 20:
	                  // put
	                  var val = stack.pop();
	                  var idx = stack.pop();
	                  trans[idx] = val;
	                  break;

	                case 21:
	                  // get
	                  idx = stack.pop();
	                  stack.push(trans[idx] || 0);
	                  break;

	                case 22:
	                  // ifelse
	                  var s1 = stack.pop();
	                  var s2 = stack.pop();
	                  var v1 = stack.pop();
	                  var v2 = stack.pop();
	                  stack.push(v1 <= v2 ? s1 : s2);
	                  break;

	                case 23:
	                  // random
	                  stack.push(Math.random());
	                  break;

	                case 24:
	                  // mul
	                  a = stack.pop();
	                  b = stack.pop();
	                  stack.push(a * b);
	                  break;

	                case 26:
	                  // sqrt
	                  a = stack.pop();
	                  stack.push(Math.sqrt(a));
	                  break;

	                case 27:
	                  // dup
	                  a = stack.pop();
	                  stack.push(a, a);
	                  break;

	                case 28:
	                  // exch
	                  a = stack.pop();
	                  b = stack.pop();
	                  stack.push(b, a);
	                  break;

	                case 29:
	                  // index
	                  idx = stack.pop();
	                  if (idx < 0) {
	                    idx = 0;
	                  } else if (idx > stack.length - 1) {
	                    idx = stack.length - 1;
	                  }

	                  stack.push(stack[idx]);
	                  break;

	                case 30:
	                  // roll
	                  var n = stack.pop();
	                  var _j = stack.pop();

	                  if (_j >= 0) {
	                    while (_j > 0) {
	                      var t = stack[n - 1];
	                      for (var _i = n - 2; _i >= 0; _i--) {
	                        stack[_i + 1] = stack[_i];
	                      }

	                      stack[0] = t;
	                      _j--;
	                    }
	                  } else {
	                    while (_j < 0) {
	                      var t = stack[0];
	                      for (var _i2 = 0; _i2 <= n; _i2++) {
	                        stack[_i2] = stack[_i2 + 1];
	                      }

	                      stack[n - 1] = t;
	                      _j++;
	                    }
	                  }
	                  break;

	                case 34:
	                  // hflex
	                  c1x = x + stack.shift();
	                  c1y = y;
	                  c2x = c1x + stack.shift();
	                  c2y = c1y + stack.shift();
	                  var c3x = c2x + stack.shift();
	                  var c3y = c2y;
	                  var c4x = c3x + stack.shift();
	                  var c4y = c3y;
	                  var c5x = c4x + stack.shift();
	                  var c5y = c4y;
	                  var c6x = c5x + stack.shift();
	                  var c6y = c5y;
	                  x = c6x;
	                  y = c6y;

	                  path.bezierCurveTo(c1x, c1y, c2x, c2y, c3x, c3y);
	                  path.bezierCurveTo(c4x, c4y, c5x, c5y, c6x, c6y);
	                  break;

	                case 35:
	                  // flex
	                  var pts = [];

	                  for (var _i3 = 0; _i3 <= 5; _i3++) {
	                    x += stack.shift();
	                    y += stack.shift();
	                    pts.push(x, y);
	                  }

	                  path.bezierCurveTo.apply(path, pts.slice(0, 6));
	                  path.bezierCurveTo.apply(path, pts.slice(6));
	                  stack.shift(); // fd
	                  break;

	                case 36:
	                  // hflex1
	                  c1x = x + stack.shift();
	                  c1y = y + stack.shift();
	                  c2x = c1x + stack.shift();
	                  c2y = c1y + stack.shift();
	                  c3x = c2x + stack.shift();
	                  c3y = c2y;
	                  c4x = c3x + stack.shift();
	                  c4y = c3y;
	                  c5x = c4x + stack.shift();
	                  c5y = c4y + stack.shift();
	                  c6x = c5x + stack.shift();
	                  c6y = c5y;
	                  x = c6x;
	                  y = c6y;

	                  path.bezierCurveTo(c1x, c1y, c2x, c2y, c3x, c3y);
	                  path.bezierCurveTo(c4x, c4y, c5x, c5y, c6x, c6y);
	                  break;

	                case 37:
	                  // flex1
	                  var startx = x;
	                  var starty = y;

	                  pts = [];
	                  for (var _i4 = 0; _i4 <= 4; _i4++) {
	                    x += stack.shift();
	                    y += stack.shift();
	                    pts.push(x, y);
	                  }

	                  if (Math.abs(x - startx) > Math.abs(y - starty)) {
	                    // horizontal
	                    x += stack.shift();
	                    y = starty;
	                  } else {
	                    x = startx;
	                    y += stack.shift();
	                  }

	                  pts.push(x, y);
	                  path.bezierCurveTo.apply(path, pts.slice(0, 6));
	                  path.bezierCurveTo.apply(path, pts.slice(6));
	                  break;

	                default:
	                  throw new Error('Unknown op: 12 ' + op);
	              }
	              break;

	            default:
	              throw new Error('Unknown op: ' + op);
	          }
	        } else if (op < 247) {
	          stack.push(op - 139);
	        } else if (op < 251) {
	          var b1 = stream.readUInt8();
	          stack.push((op - 247) * 256 + b1 + 108);
	        } else if (op < 255) {
	          var b1 = stream.readUInt8();
	          stack.push(-(op - 251) * 256 - b1 - 108);
	        } else {
	          stack.push(stream.readInt32BE() / 65536);
	        }
	      }
	    };

	    parse();

	    if (open) {
	      path.closePath();
	    }

	    return path;
	  };

	  return CFFGlyph;
	}(Glyph);

	var SBIXImage = new r.Struct({
	  originX: r.uint16,
	  originY: r.uint16,
	  type: new r.String(4),
	  data: new r.Buffer(function (t) {
	    return t.parent.buflen - t._currentOffset;
	  })
	});

	/**
	 * Represents a color (e.g. emoji) glyph in Apple's SBIX format.
	 */

	var SBIXGlyph = function (_TTFGlyph) {
	  _inherits(SBIXGlyph, _TTFGlyph);

	  function SBIXGlyph() {
	    _classCallCheck(this, SBIXGlyph);

	    return _possibleConstructorReturn(this, _TTFGlyph.apply(this, arguments));
	  }

	  /**
	   * Returns an object representing a glyph image at the given point size.
	   * The object has a data property with a Buffer containing the actual image data,
	   * along with the image type, and origin.
	   *
	   * @param {number} size
	   * @return {object}
	   */
	  SBIXGlyph.prototype.getImageForSize = function getImageForSize(size) {
	    for (var i = 0; i < this._font.sbix.imageTables.length; i++) {
	      var table = this._font.sbix.imageTables[i];
	      if (table.ppem >= size) {
	        break;
	      }
	    }

	    var offsets = table.imageOffsets;
	    var start = offsets[this.id];
	    var end = offsets[this.id + 1];

	    if (start === end) {
	      return null;
	    }

	    this._font.stream.pos = start;
	    return SBIXImage.decode(this._font.stream, { buflen: end - start });
	  };

	  SBIXGlyph.prototype.render = function render(ctx, size) {
	    var img = this.getImageForSize(size);
	    if (img != null) {
	      var scale = size / this._font.unitsPerEm;
	      ctx.image(img.data, { height: size, x: img.originX, y: (this.bbox.minY - img.originY) * scale });
	    }

	    if (this._font.sbix.flags.renderOutlines) {
	      _TTFGlyph.prototype.render.call(this, ctx, size);
	    }
	  };

	  return SBIXGlyph;
	}(TTFGlyph);

	var COLRLayer = function COLRLayer(glyph, color) {
	  _classCallCheck(this, COLRLayer);

	  this.glyph = glyph;
	  this.color = color;
	};

	/**
	 * Represents a color (e.g. emoji) glyph in Microsoft's COLR format.
	 * Each glyph in this format contain a list of colored layers, each
	 * of which  is another vector glyph.
	 */


	var COLRGlyph = function (_Glyph) {
	  _inherits(COLRGlyph, _Glyph);

	  function COLRGlyph() {
	    _classCallCheck(this, COLRGlyph);

	    return _possibleConstructorReturn(this, _Glyph.apply(this, arguments));
	  }

	  COLRGlyph.prototype._getBBox = function _getBBox() {
	    var bbox = new BBox();
	    for (var i = 0; i < this.layers.length; i++) {
	      var layer = this.layers[i];
	      var b = layer.glyph.bbox;
	      bbox.addPoint(b.minX, b.minY);
	      bbox.addPoint(b.maxX, b.maxY);
	    }

	    return bbox;
	  };

	  /**
	   * Returns an array of objects containing the glyph and color for
	   * each layer in the composite color glyph.
	   * @type {object[]}
	   */


	  COLRGlyph.prototype.render = function render(ctx, size) {
	    for (var _iterator = this.layers, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	      var _ref;

	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }

	      var _ref2 = _ref,
	          glyph = _ref2.glyph,
	          color = _ref2.color;

	      ctx.fillColor([color.red, color.green, color.blue], color.alpha / 255 * 100);
	      glyph.render(ctx, size);
	    }

	    return;
	  };

	  _createClass(COLRGlyph, [{
	    key: 'layers',
	    get: function get() {
	      var cpal = this._font.CPAL;
	      var colr = this._font.COLR;
	      var low = 0;
	      var high = colr.baseGlyphRecord.length - 1;

	      while (low <= high) {
	        var mid = low + high >> 1;
	        var rec = colr.baseGlyphRecord[mid];

	        if (this.id < rec.gid) {
	          high = mid - 1;
	        } else if (this.id > rec.gid) {
	          low = mid + 1;
	        } else {
	          var baseLayer = rec;
	          break;
	        }
	      }

	      // if base glyph not found in COLR table,
	      // default to normal glyph from glyf or CFF
	      if (baseLayer == null) {
	        var g = this._font._getBaseGlyph(this.id);
	        var color = {
	          red: 0,
	          green: 0,
	          blue: 0,
	          alpha: 255
	        };

	        return [new COLRLayer(g, color)];
	      }

	      // otherwise, return an array of all the layers
	      var layers = [];
	      for (var i = baseLayer.firstLayerIndex; i < baseLayer.firstLayerIndex + baseLayer.numLayers; i++) {
	        var rec = colr.layerRecords[i];
	        var color = cpal.colorRecords[rec.paletteIndex];
	        var g = this._font._getBaseGlyph(rec.gid);
	        layers.push(new COLRLayer(g, color));
	      }

	      return layers;
	    }
	  }]);

	  return COLRGlyph;
	}(Glyph);

	var TUPLES_SHARE_POINT_NUMBERS = 0x8000;
	var TUPLE_COUNT_MASK = 0x0fff;
	var EMBEDDED_TUPLE_COORD = 0x8000;
	var INTERMEDIATE_TUPLE = 0x4000;
	var PRIVATE_POINT_NUMBERS = 0x2000;
	var TUPLE_INDEX_MASK = 0x0fff;
	var POINTS_ARE_WORDS = 0x80;
	var POINT_RUN_COUNT_MASK = 0x7f;
	var DELTAS_ARE_ZERO = 0x80;
	var DELTAS_ARE_WORDS = 0x40;
	var DELTA_RUN_COUNT_MASK = 0x3f;

	/**
	 * This class is transforms TrueType glyphs according to the data from
	 * the Apple Advanced Typography variation tables (fvar, gvar, and avar).
	 * These tables allow infinite adjustments to glyph weight, width, slant,
	 * and optical size without the designer needing to specify every exact style.
	 *
	 * Apple's documentation for these tables is not great, so thanks to the
	 * Freetype project for figuring much of this out.
	 *
	 * @private
	 */

	var GlyphVariationProcessor = function () {
	  function GlyphVariationProcessor(font, coords) {
	    _classCallCheck(this, GlyphVariationProcessor);

	    this.font = font;
	    this.normalizedCoords = this.normalizeCoords(coords);
	    this.blendVectors = new _Map();
	  }

	  GlyphVariationProcessor.prototype.normalizeCoords = function normalizeCoords(coords) {
	    // the default mapping is linear along each axis, in two segments:
	    // from the minValue to defaultValue, and from defaultValue to maxValue.
	    var normalized = [];
	    for (var i = 0; i < this.font.fvar.axis.length; i++) {
	      var axis = this.font.fvar.axis[i];
	      if (coords[i] < axis.defaultValue) {
	        normalized.push((coords[i] - axis.defaultValue + _Number$EPSILON) / (axis.defaultValue - axis.minValue + _Number$EPSILON));
	      } else {
	        normalized.push((coords[i] - axis.defaultValue + _Number$EPSILON) / (axis.maxValue - axis.defaultValue + _Number$EPSILON));
	      }
	    }

	    // if there is an avar table, the normalized value is calculated
	    // by interpolating between the two nearest mapped values.
	    if (this.font.avar) {
	      for (var i = 0; i < this.font.avar.segment.length; i++) {
	        var segment = this.font.avar.segment[i];
	        for (var j = 0; j < segment.correspondence.length; j++) {
	          var pair = segment.correspondence[j];
	          if (j >= 1 && normalized[i] < pair.fromCoord) {
	            var prev = segment.correspondence[j - 1];
	            normalized[i] = ((normalized[i] - prev.fromCoord) * (pair.toCoord - prev.toCoord) + _Number$EPSILON) / (pair.fromCoord - prev.fromCoord + _Number$EPSILON) + prev.toCoord;

	            break;
	          }
	        }
	      }
	    }

	    return normalized;
	  };

	  GlyphVariationProcessor.prototype.transformPoints = function transformPoints(gid, glyphPoints) {
	    if (!this.font.fvar || !this.font.gvar) {
	      return;
	    }

	    var gvar = this.font.gvar;

	    if (gid >= gvar.glyphCount) {
	      return;
	    }

	    var offset = gvar.offsets[gid];
	    if (offset === gvar.offsets[gid + 1]) {
	      return;
	    }

	    // Read the gvar data for this glyph
	    var stream = this.font.stream;

	    stream.pos = offset;
	    if (stream.pos >= stream.length) {
	      return;
	    }

	    var tupleCount = stream.readUInt16BE();
	    var offsetToData = offset + stream.readUInt16BE();

	    if (tupleCount & TUPLES_SHARE_POINT_NUMBERS) {
	      var here = stream.pos;
	      stream.pos = offsetToData;
	      var sharedPoints = this.decodePoints();
	      offsetToData = stream.pos;
	      stream.pos = here;
	    }

	    var origPoints = glyphPoints.map(function (pt) {
	      return pt.copy();
	    });

	    tupleCount &= TUPLE_COUNT_MASK;
	    for (var i = 0; i < tupleCount; i++) {
	      var tupleDataSize = stream.readUInt16BE();
	      var tupleIndex = stream.readUInt16BE();

	      if (tupleIndex & EMBEDDED_TUPLE_COORD) {
	        var tupleCoords = [];
	        for (var a = 0; a < gvar.axisCount; a++) {
	          tupleCoords.push(stream.readInt16BE() / 16384);
	        }
	      } else {
	        if ((tupleIndex & TUPLE_INDEX_MASK) >= gvar.globalCoordCount) {
	          throw new Error('Invalid gvar table');
	        }

	        var tupleCoords = gvar.globalCoords[tupleIndex & TUPLE_INDEX_MASK];
	      }

	      if (tupleIndex & INTERMEDIATE_TUPLE) {
	        var startCoords = [];
	        for (var _a = 0; _a < gvar.axisCount; _a++) {
	          startCoords.push(stream.readInt16BE() / 16384);
	        }

	        var endCoords = [];
	        for (var _a2 = 0; _a2 < gvar.axisCount; _a2++) {
	          endCoords.push(stream.readInt16BE() / 16384);
	        }
	      }

	      // Get the factor at which to apply this tuple
	      var factor = this.tupleFactor(tupleIndex, tupleCoords, startCoords, endCoords);
	      if (factor === 0) {
	        offsetToData += tupleDataSize;
	        continue;
	      }

	      var here = stream.pos;
	      stream.pos = offsetToData;

	      if (tupleIndex & PRIVATE_POINT_NUMBERS) {
	        var points = this.decodePoints();
	      } else {
	        var points = sharedPoints;
	      }

	      // points.length = 0 means there are deltas for all points
	      var nPoints = points.length === 0 ? glyphPoints.length : points.length;
	      var xDeltas = this.decodeDeltas(nPoints);
	      var yDeltas = this.decodeDeltas(nPoints);

	      if (points.length === 0) {
	        // all points
	        for (var _i = 0; _i < glyphPoints.length; _i++) {
	          var point = glyphPoints[_i];
	          point.x += Math.round(xDeltas[_i] * factor);
	          point.y += Math.round(yDeltas[_i] * factor);
	        }
	      } else {
	        var outPoints = origPoints.map(function (pt) {
	          return pt.copy();
	        });
	        var hasDelta = glyphPoints.map(function () {
	          return false;
	        });

	        for (var _i2 = 0; _i2 < points.length; _i2++) {
	          var idx = points[_i2];
	          if (idx < glyphPoints.length) {
	            var _point = outPoints[idx];
	            hasDelta[idx] = true;

	            _point.x += Math.round(xDeltas[_i2] * factor);
	            _point.y += Math.round(yDeltas[_i2] * factor);
	          }
	        }

	        this.interpolateMissingDeltas(outPoints, origPoints, hasDelta);

	        for (var _i3 = 0; _i3 < glyphPoints.length; _i3++) {
	          var deltaX = outPoints[_i3].x - origPoints[_i3].x;
	          var deltaY = outPoints[_i3].y - origPoints[_i3].y;

	          glyphPoints[_i3].x += deltaX;
	          glyphPoints[_i3].y += deltaY;
	        }
	      }

	      offsetToData += tupleDataSize;
	      stream.pos = here;
	    }
	  };

	  GlyphVariationProcessor.prototype.decodePoints = function decodePoints() {
	    var stream = this.font.stream;
	    var count = stream.readUInt8();

	    if (count & POINTS_ARE_WORDS) {
	      count = (count & POINT_RUN_COUNT_MASK) << 8 | stream.readUInt8();
	    }

	    var points = new Uint16Array(count);
	    var i = 0;
	    var point = 0;
	    while (i < count) {
	      var run = stream.readUInt8();
	      var runCount = (run & POINT_RUN_COUNT_MASK) + 1;
	      var fn = run & POINTS_ARE_WORDS ? stream.readUInt16 : stream.readUInt8;

	      for (var j = 0; j < runCount && i < count; j++) {
	        point += fn.call(stream);
	        points[i++] = point;
	      }
	    }

	    return points;
	  };

	  GlyphVariationProcessor.prototype.decodeDeltas = function decodeDeltas(count) {
	    var stream = this.font.stream;
	    var i = 0;
	    var deltas = new Int16Array(count);

	    while (i < count) {
	      var run = stream.readUInt8();
	      var runCount = (run & DELTA_RUN_COUNT_MASK) + 1;

	      if (run & DELTAS_ARE_ZERO) {
	        i += runCount;
	      } else {
	        var fn = run & DELTAS_ARE_WORDS ? stream.readInt16BE : stream.readInt8;
	        for (var j = 0; j < runCount && i < count; j++) {
	          deltas[i++] = fn.call(stream);
	        }
	      }
	    }

	    return deltas;
	  };

	  GlyphVariationProcessor.prototype.tupleFactor = function tupleFactor(tupleIndex, tupleCoords, startCoords, endCoords) {
	    var normalized = this.normalizedCoords;
	    var gvar = this.font.gvar;

	    var factor = 1;

	    for (var i = 0; i < gvar.axisCount; i++) {
	      if (tupleCoords[i] === 0) {
	        continue;
	      }

	      if (normalized[i] === 0) {
	        return 0;
	      }

	      if ((tupleIndex & INTERMEDIATE_TUPLE) === 0) {
	        if (normalized[i] < Math.min(0, tupleCoords[i]) || normalized[i] > Math.max(0, tupleCoords[i])) {
	          return 0;
	        }

	        factor = (factor * normalized[i] + _Number$EPSILON) / (tupleCoords[i] + _Number$EPSILON);
	      } else {
	        if (normalized[i] < startCoords[i] || normalized[i] > endCoords[i]) {
	          return 0;
	        } else if (normalized[i] < tupleCoords[i]) {
	          factor = factor * (normalized[i] - startCoords[i] + _Number$EPSILON) / (tupleCoords[i] - startCoords[i] + _Number$EPSILON);
	        } else {
	          factor = factor * (endCoords[i] - normalized[i] + _Number$EPSILON) / (endCoords[i] - tupleCoords[i] + _Number$EPSILON);
	        }
	      }
	    }

	    return factor;
	  };

	  // Interpolates points without delta values.
	  // Needed for the Ø and Q glyphs in Skia.
	  // Algorithm from Freetype.


	  GlyphVariationProcessor.prototype.interpolateMissingDeltas = function interpolateMissingDeltas(points, inPoints, hasDelta) {
	    if (points.length === 0) {
	      return;
	    }

	    var point = 0;
	    while (point < points.length) {
	      var firstPoint = point;

	      // find the end point of the contour
	      var endPoint = point;
	      var pt = points[endPoint];
	      while (!pt.endContour) {
	        pt = points[++endPoint];
	      }

	      // find the first point that has a delta
	      while (point <= endPoint && !hasDelta[point]) {
	        point++;
	      }

	      if (point > endPoint) {
	        continue;
	      }

	      var firstDelta = point;
	      var curDelta = point;
	      point++;

	      while (point <= endPoint) {
	        // find the next point with a delta, and interpolate intermediate points
	        if (hasDelta[point]) {
	          this.deltaInterpolate(curDelta + 1, point - 1, curDelta, point, inPoints, points);
	          curDelta = point;
	        }

	        point++;
	      }

	      // shift contour if we only have a single delta
	      if (curDelta === firstDelta) {
	        this.deltaShift(firstPoint, endPoint, curDelta, inPoints, points);
	      } else {
	        // otherwise, handle the remaining points at the end and beginning of the contour
	        this.deltaInterpolate(curDelta + 1, endPoint, curDelta, firstDelta, inPoints, points);

	        if (firstDelta > 0) {
	          this.deltaInterpolate(firstPoint, firstDelta - 1, curDelta, firstDelta, inPoints, points);
	        }
	      }

	      point = endPoint + 1;
	    }
	  };

	  GlyphVariationProcessor.prototype.deltaInterpolate = function deltaInterpolate(p1, p2, ref1, ref2, inPoints, outPoints) {
	    if (p1 > p2) {
	      return;
	    }

	    var iterable = ['x', 'y'];
	    for (var i = 0; i < iterable.length; i++) {
	      var k = iterable[i];
	      if (inPoints[ref1][k] > inPoints[ref2][k]) {
	        var p = ref1;
	        ref1 = ref2;
	        ref2 = p;
	      }

	      var in1 = inPoints[ref1][k];
	      var in2 = inPoints[ref2][k];
	      var out1 = outPoints[ref1][k];
	      var out2 = outPoints[ref2][k];

	      // If the reference points have the same coordinate but different
	      // delta, inferred delta is zero.  Otherwise interpolate.
	      if (in1 !== in2 || out1 === out2) {
	        var scale = in1 === in2 ? 0 : (out2 - out1) / (in2 - in1);

	        for (var _p = p1; _p <= p2; _p++) {
	          var out = inPoints[_p][k];

	          if (out <= in1) {
	            out += out1 - in1;
	          } else if (out >= in2) {
	            out += out2 - in2;
	          } else {
	            out = out1 + (out - in1) * scale;
	          }

	          outPoints[_p][k] = out;
	        }
	      }
	    }
	  };

	  GlyphVariationProcessor.prototype.deltaShift = function deltaShift(p1, p2, ref, inPoints, outPoints) {
	    var deltaX = outPoints[ref].x - inPoints[ref].x;
	    var deltaY = outPoints[ref].y - inPoints[ref].y;

	    if (deltaX === 0 && deltaY === 0) {
	      return;
	    }

	    for (var p = p1; p <= p2; p++) {
	      if (p !== ref) {
	        outPoints[p].x += deltaX;
	        outPoints[p].y += deltaY;
	      }
	    }
	  };

	  GlyphVariationProcessor.prototype.getAdvanceAdjustment = function getAdvanceAdjustment(gid, table) {
	    var outerIndex = void 0,
	        innerIndex = void 0;

	    if (table.advanceWidthMapping) {
	      var idx = gid;
	      if (idx >= table.advanceWidthMapping.mapCount) {
	        idx = table.advanceWidthMapping.mapCount - 1;
	      }

	      var entryFormat = table.advanceWidthMapping.entryFormat;
	      var _table$advanceWidthMa = table.advanceWidthMapping.mapData[idx];
	      outerIndex = _table$advanceWidthMa.outerIndex;
	      innerIndex = _table$advanceWidthMa.innerIndex;
	    } else {
	      outerIndex = 0;
	      innerIndex = gid;
	    }

	    return this.getDelta(table.itemVariationStore, outerIndex, innerIndex);
	  };

	  // See pseudo code from `Font Variations Overview'
	  // in the OpenType specification.


	  GlyphVariationProcessor.prototype.getDelta = function getDelta(itemStore, outerIndex, innerIndex) {
	    if (outerIndex >= itemStore.itemVariationData.length) {
	      return 0;
	    }

	    var varData = itemStore.itemVariationData[outerIndex];
	    if (innerIndex >= varData.deltaSets.length) {
	      return 0;
	    }

	    var deltaSet = varData.deltaSets[innerIndex];
	    var blendVector = this.getBlendVector(itemStore, outerIndex);
	    var netAdjustment = 0;

	    for (var master = 0; master < varData.regionIndexCount; master++) {
	      netAdjustment += deltaSet.deltas[master] * blendVector[master];
	    }

	    return netAdjustment;
	  };

	  GlyphVariationProcessor.prototype.getBlendVector = function getBlendVector(itemStore, outerIndex) {
	    var varData = itemStore.itemVariationData[outerIndex];
	    if (this.blendVectors.has(varData)) {
	      return this.blendVectors.get(varData);
	    }

	    var normalizedCoords = this.normalizedCoords;
	    var blendVector = [];

	    // outer loop steps through master designs to be blended
	    for (var master = 0; master < varData.regionIndexCount; master++) {
	      var scalar = 1;
	      var regionIndex = varData.regionIndexes[master];
	      var axes = itemStore.variationRegionList.variationRegions[regionIndex];

	      // inner loop steps through axes in this region
	      for (var j = 0; j < axes.length; j++) {
	        var axis = axes[j];
	        var axisScalar = void 0;

	        // compute the scalar contribution of this axis
	        // ignore invalid ranges
	        if (axis.startCoord > axis.peakCoord || axis.peakCoord > axis.endCoord) {
	          axisScalar = 1;
	        } else if (axis.startCoord < 0 && axis.endCoord > 0 && axis.peakCoord !== 0) {
	          axisScalar = 1;

	          // peak of 0 means ignore this axis
	        } else if (axis.peakCoord === 0) {
	          axisScalar = 1;

	          // ignore this region if coords are out of range
	        } else if (normalizedCoords[j] < axis.startCoord || normalizedCoords[j] > axis.endCoord) {
	          axisScalar = 0;

	          // calculate a proportional factor
	        } else {
	          if (normalizedCoords[j] === axis.peakCoord) {
	            axisScalar = 1;
	          } else if (normalizedCoords[j] < axis.peakCoord) {
	            axisScalar = (normalizedCoords[j] - axis.startCoord + _Number$EPSILON) / (axis.peakCoord - axis.startCoord + _Number$EPSILON);
	          } else {
	            axisScalar = (axis.endCoord - normalizedCoords[j] + _Number$EPSILON) / (axis.endCoord - axis.peakCoord + _Number$EPSILON);
	          }
	        }

	        // take product of all the axis scalars
	        scalar *= axisScalar;
	      }

	      blendVector[master] = scalar;
	    }

	    this.blendVectors.set(varData, blendVector);
	    return blendVector;
	  };

	  return GlyphVariationProcessor;
	}();

	var Subset = function () {
	  function Subset(font) {
	    _classCallCheck(this, Subset);

	    this.font = font;
	    this.glyphs = [];
	    this.mapping = {};

	    // always include the missing glyph
	    this.includeGlyph(0);
	  }

	  Subset.prototype.includeGlyph = function includeGlyph(glyph) {
	    if ((typeof glyph === 'undefined' ? 'undefined' : _typeof(glyph)) === 'object') {
	      glyph = glyph.id;
	    }

	    if (this.mapping[glyph] == null) {
	      this.glyphs.push(glyph);
	      this.mapping[glyph] = this.glyphs.length - 1;
	    }

	    return this.mapping[glyph];
	  };

	  Subset.prototype.encodeStream = function encodeStream() {
	    var _this = this;

	    var s = new r.EncodeStream();

	    process.nextTick(function () {
	      _this.encode(s);
	      return s.end();
	    });

	    return s;
	  };

	  return Subset;
	}();

	// Flags for simple glyphs
	var ON_CURVE$1 = 1 << 0;
	var X_SHORT_VECTOR$1 = 1 << 1;
	var Y_SHORT_VECTOR$1 = 1 << 2;
	var REPEAT$1 = 1 << 3;
	var SAME_X$1 = 1 << 4;
	var SAME_Y$1 = 1 << 5;

	var Point$1 = function () {
	  function Point() {
	    _classCallCheck(this, Point);
	  }

	  Point.size = function size(val) {
	    return val >= 0 && val <= 255 ? 1 : 2;
	  };

	  Point.encode = function encode(stream, value) {
	    if (value >= 0 && value <= 255) {
	      stream.writeUInt8(value);
	    } else {
	      stream.writeInt16BE(value);
	    }
	  };

	  return Point;
	}();

	var Glyf = new r.Struct({
	  numberOfContours: r.int16, // if negative, this is a composite glyph
	  xMin: r.int16,
	  yMin: r.int16,
	  xMax: r.int16,
	  yMax: r.int16,
	  endPtsOfContours: new r.Array(r.uint16, 'numberOfContours'),
	  instructions: new r.Array(r.uint8, r.uint16),
	  flags: new r.Array(r.uint8, 0),
	  xPoints: new r.Array(Point$1, 0),
	  yPoints: new r.Array(Point$1, 0)
	});

	/**
	 * Encodes TrueType glyph outlines
	 */

	var TTFGlyphEncoder = function () {
	  function TTFGlyphEncoder() {
	    _classCallCheck(this, TTFGlyphEncoder);
	  }

	  TTFGlyphEncoder.prototype.encodeSimple = function encodeSimple(path) {
	    var instructions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

	    var endPtsOfContours = [];
	    var xPoints = [];
	    var yPoints = [];
	    var flags = [];
	    var same = 0;
	    var lastX = 0,
	        lastY = 0,
	        lastFlag = 0;
	    var pointCount = 0;

	    for (var i = 0; i < path.commands.length; i++) {
	      var c = path.commands[i];

	      for (var j = 0; j < c.args.length; j += 2) {
	        var x = c.args[j];
	        var y = c.args[j + 1];
	        var flag = 0;

	        // If the ending point of a quadratic curve is the midpoint
	        // between the control point and the control point of the next
	        // quadratic curve, we can omit the ending point.
	        if (c.command === 'quadraticCurveTo' && j === 2) {
	          var next = path.commands[i + 1];
	          if (next && next.command === 'quadraticCurveTo') {
	            var midX = (lastX + next.args[0]) / 2;
	            var midY = (lastY + next.args[1]) / 2;

	            if (x === midX && y === midY) {
	              continue;
	            }
	          }
	        }

	        // All points except control points are on curve.
	        if (!(c.command === 'quadraticCurveTo' && j === 0)) {
	          flag |= ON_CURVE$1;
	        }

	        flag = this._encodePoint(x, lastX, xPoints, flag, X_SHORT_VECTOR$1, SAME_X$1);
	        flag = this._encodePoint(y, lastY, yPoints, flag, Y_SHORT_VECTOR$1, SAME_Y$1);

	        if (flag === lastFlag && same < 255) {
	          flags[flags.length - 1] |= REPEAT$1;
	          same++;
	        } else {
	          if (same > 0) {
	            flags.push(same);
	            same = 0;
	          }

	          flags.push(flag);
	          lastFlag = flag;
	        }

	        lastX = x;
	        lastY = y;
	        pointCount++;
	      }

	      if (c.command === 'closePath') {
	        endPtsOfContours.push(pointCount - 1);
	      }
	    }

	    // Close the path if the last command didn't already
	    if (path.commands.length > 1 && path.commands[path.commands.length - 1].command !== 'closePath') {
	      endPtsOfContours.push(pointCount - 1);
	    }

	    var bbox = path.bbox;
	    var glyf = {
	      numberOfContours: endPtsOfContours.length,
	      xMin: bbox.minX,
	      yMin: bbox.minY,
	      xMax: bbox.maxX,
	      yMax: bbox.maxY,
	      endPtsOfContours: endPtsOfContours,
	      instructions: instructions,
	      flags: flags,
	      xPoints: xPoints,
	      yPoints: yPoints
	    };

	    var size = Glyf.size(glyf);
	    var tail = 4 - size % 4;

	    var stream = new r.EncodeStream(size + tail);
	    Glyf.encode(stream, glyf);

	    // Align to 4-byte length
	    if (tail !== 0) {
	      stream.fill(0, tail);
	    }

	    return stream.buffer;
	  };

	  TTFGlyphEncoder.prototype._encodePoint = function _encodePoint(value, last, points, flag, shortFlag, sameFlag) {
	    var diff = value - last;

	    if (value === last) {
	      flag |= sameFlag;
	    } else {
	      if (-255 <= diff && diff <= 255) {
	        flag |= shortFlag;
	        if (diff < 0) {
	          diff = -diff;
	        } else {
	          flag |= sameFlag;
	        }
	      }

	      points.push(diff);
	    }

	    return flag;
	  };

	  return TTFGlyphEncoder;
	}();

	var TTFSubset = function (_Subset) {
	  _inherits(TTFSubset, _Subset);

	  function TTFSubset(font) {
	    _classCallCheck(this, TTFSubset);

	    var _this = _possibleConstructorReturn(this, _Subset.call(this, font));

	    _this.glyphEncoder = new TTFGlyphEncoder();
	    return _this;
	  }

	  TTFSubset.prototype._addGlyph = function _addGlyph(gid) {
	    var glyph = this.font.getGlyph(gid);
	    var glyf = glyph._decode();

	    // get the offset to the glyph from the loca table
	    var curOffset = this.font.loca.offsets[gid];
	    var nextOffset = this.font.loca.offsets[gid + 1];

	    var stream = this.font._getTableStream('glyf');
	    stream.pos += curOffset;

	    var buffer = stream.readBuffer(nextOffset - curOffset);

	    // if it is a compound glyph, include its components
	    if (glyf && glyf.numberOfContours < 0) {
	      buffer = new Buffer(buffer);
	      for (var _iterator = glyf.components, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	        var _ref;

	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }

	        var component = _ref;

	        gid = this.includeGlyph(component.glyphID);
	        buffer.writeUInt16BE(gid, component.pos);
	      }
	    } else if (glyf && this.font._variationProcessor) {
	      // If this is a TrueType variation glyph, re-encode the path
	      buffer = this.glyphEncoder.encodeSimple(glyph.path, glyf.instructions);
	    }

	    this.glyf.push(buffer);
	    this.loca.offsets.push(this.offset);

	    this.hmtx.metrics.push({
	      advance: glyph.advanceWidth,
	      bearing: glyph._getMetrics().leftBearing
	    });

	    this.offset += buffer.length;
	    return this.glyf.length - 1;
	  };

	  TTFSubset.prototype.encode = function encode(stream) {
	    // tables required by PDF spec:
	    //   head, hhea, loca, maxp, cvt , prep, glyf, hmtx, fpgm
	    //
	    // additional tables required for standalone fonts:
	    //   name, cmap, OS/2, post

	    this.glyf = [];
	    this.offset = 0;
	    this.loca = {
	      offsets: []
	    };

	    this.hmtx = {
	      metrics: [],
	      bearings: []
	    };

	    // include all the glyphs
	    // not using a for loop because we need to support adding more
	    // glyphs to the array as we go, and CoffeeScript caches the length.
	    var i = 0;
	    while (i < this.glyphs.length) {
	      this._addGlyph(this.glyphs[i++]);
	    }

	    var maxp = cloneDeep(this.font.maxp);
	    maxp.numGlyphs = this.glyf.length;

	    this.loca.offsets.push(this.offset);
	    tables.loca.preEncode.call(this.loca);

	    var head = cloneDeep(this.font.head);
	    head.indexToLocFormat = this.loca.version;

	    var hhea = cloneDeep(this.font.hhea);
	    hhea.numberOfMetrics = this.hmtx.metrics.length;

	    // map = []
	    // for index in [0...256]
	    //     if index < @numGlyphs
	    //         map[index] = index
	    //     else
	    //         map[index] = 0
	    //
	    // cmapTable =
	    //     version: 0
	    //     length: 262
	    //     language: 0
	    //     codeMap: map
	    //
	    // cmap =
	    //     version: 0
	    //     numSubtables: 1
	    //     tables: [
	    //         platformID: 1
	    //         encodingID: 0
	    //         table: cmapTable
	    //     ]

	    // TODO: subset prep, cvt, fpgm?
	    Directory.encode(stream, {
	      tables: {
	        head: head,
	        hhea: hhea,
	        loca: this.loca,
	        maxp: maxp,
	        'cvt ': this.font['cvt '],
	        prep: this.font.prep,
	        glyf: this.glyf,
	        hmtx: this.hmtx,
	        fpgm: this.font.fpgm

	        // name: clone @font.name
	        // 'OS/2': clone @font['OS/2']
	        // post: clone @font.post
	        // cmap: cmap
	      }
	    });
	  };

	  return TTFSubset;
	}(Subset);

	var CFFSubset = function (_Subset) {
	  _inherits(CFFSubset, _Subset);

	  function CFFSubset(font) {
	    _classCallCheck(this, CFFSubset);

	    var _this = _possibleConstructorReturn(this, _Subset.call(this, font));

	    _this.cff = _this.font['CFF '];
	    if (!_this.cff) {
	      throw new Error('Not a CFF Font');
	    }
	    return _this;
	  }

	  CFFSubset.prototype.subsetCharstrings = function subsetCharstrings() {
	    this.charstrings = [];
	    var gsubrs = {};

	    for (var _iterator = this.glyphs, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	      var _ref;

	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }

	      var gid = _ref;

	      this.charstrings.push(this.cff.getCharString(gid));

	      var glyph = this.font.getGlyph(gid);
	      var path = glyph.path; // this causes the glyph to be parsed

	      for (var subr in glyph._usedGsubrs) {
	        gsubrs[subr] = true;
	      }
	    }

	    this.gsubrs = this.subsetSubrs(this.cff.globalSubrIndex, gsubrs);
	  };

	  CFFSubset.prototype.subsetSubrs = function subsetSubrs(subrs, used) {
	    var res = [];
	    for (var i = 0; i < subrs.length; i++) {
	      var subr = subrs[i];
	      if (used[i]) {
	        this.cff.stream.pos = subr.offset;
	        res.push(this.cff.stream.readBuffer(subr.length));
	      } else {
	        res.push(new Buffer([11])); // return
	      }
	    }

	    return res;
	  };

	  CFFSubset.prototype.subsetFontdict = function subsetFontdict(topDict) {
	    topDict.FDArray = [];
	    topDict.FDSelect = {
	      version: 0,
	      fds: []
	    };

	    var used_fds = {};
	    var used_subrs = [];
	    for (var _iterator2 = this.glyphs, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
	      var _ref2;

	      if (_isArray2) {
	        if (_i2 >= _iterator2.length) break;
	        _ref2 = _iterator2[_i2++];
	      } else {
	        _i2 = _iterator2.next();
	        if (_i2.done) break;
	        _ref2 = _i2.value;
	      }

	      var gid = _ref2;

	      var fd = this.cff.fdForGlyph(gid);
	      if (fd == null) {
	        continue;
	      }

	      if (!used_fds[fd]) {
	        topDict.FDArray.push(_Object$assign({}, this.cff.topDict.FDArray[fd]));
	        used_subrs.push({});
	      }

	      used_fds[fd] = true;
	      topDict.FDSelect.fds.push(topDict.FDArray.length - 1);

	      var glyph = this.font.getGlyph(gid);
	      var path = glyph.path; // this causes the glyph to be parsed
	      for (var subr in glyph._usedSubrs) {
	        used_subrs[used_subrs.length - 1][subr] = true;
	      }
	    }

	    for (var i = 0; i < topDict.FDArray.length; i++) {
	      var dict = topDict.FDArray[i];
	      delete dict.FontName;
	      if (dict.Private && dict.Private.Subrs) {
	        dict.Private = _Object$assign({}, dict.Private);
	        dict.Private.Subrs = this.subsetSubrs(dict.Private.Subrs, used_subrs[i]);
	      }
	    }

	    return;
	  };

	  CFFSubset.prototype.createCIDFontdict = function createCIDFontdict(topDict) {
	    var used_subrs = {};
	    for (var _iterator3 = this.glyphs, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
	      var _ref3;

	      if (_isArray3) {
	        if (_i3 >= _iterator3.length) break;
	        _ref3 = _iterator3[_i3++];
	      } else {
	        _i3 = _iterator3.next();
	        if (_i3.done) break;
	        _ref3 = _i3.value;
	      }

	      var gid = _ref3;

	      var glyph = this.font.getGlyph(gid);
	      var path = glyph.path; // this causes the glyph to be parsed

	      for (var subr in glyph._usedSubrs) {
	        used_subrs[subr] = true;
	      }
	    }

	    var privateDict = _Object$assign({}, this.cff.topDict.Private);
	    privateDict.Subrs = this.subsetSubrs(this.cff.topDict.Private.Subrs, used_subrs);

	    topDict.FDArray = [{ Private: privateDict }];
	    return topDict.FDSelect = {
	      version: 3,
	      nRanges: 1,
	      ranges: [{ first: 0, fd: 0 }],
	      sentinel: this.charstrings.length
	    };
	  };

	  CFFSubset.prototype.addString = function addString(string) {
	    if (!string) {
	      return null;
	    }

	    if (!this.strings) {
	      this.strings = [];
	    }

	    this.strings.push(string);
	    return standardStrings.length + this.strings.length - 1;
	  };

	  CFFSubset.prototype.encode = function encode(stream) {
	    this.subsetCharstrings();

	    var charset = {
	      version: this.charstrings.length > 255 ? 2 : 1,
	      ranges: [{ first: 1, nLeft: this.charstrings.length - 2 }]
	    };

	    var topDict = _Object$assign({}, this.cff.topDict);
	    topDict.Private = null;
	    topDict.charset = charset;
	    topDict.Encoding = null;
	    topDict.CharStrings = this.charstrings;

	    var _arr = ['version', 'Notice', 'Copyright', 'FullName', 'FamilyName', 'Weight', 'PostScript', 'BaseFontName', 'FontName'];
	    for (var _i4 = 0; _i4 < _arr.length; _i4++) {
	      var key = _arr[_i4];
	      topDict[key] = this.addString(this.cff.string(topDict[key]));
	    }

	    topDict.ROS = [this.addString('Adobe'), this.addString('Identity'), 0];
	    topDict.CIDCount = this.charstrings.length;

	    if (this.cff.isCIDFont) {
	      this.subsetFontdict(topDict);
	    } else {
	      this.createCIDFontdict(topDict);
	    }

	    var top = {
	      version: 1,
	      hdrSize: this.cff.hdrSize,
	      offSize: this.cff.length,
	      header: this.cff.header,
	      nameIndex: [this.cff.postscriptName],
	      topDictIndex: [topDict],
	      stringIndex: this.strings,
	      globalSubrIndex: this.gsubrs
	    };

	    CFFTop.encode(stream, top);
	  };

	  return CFFSubset;
	}(Subset);

	var _class;
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;

	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }

	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);

	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }

	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }

	  return desc;
	}

	/**
	 * This is the base class for all SFNT-based font formats in fontkit.
	 * It supports TrueType, and PostScript glyphs, and several color glyph formats.
	 */
	var TTFFont = (_class = function () {
	  TTFFont.probe = function probe(buffer) {
	    var format = buffer.toString('ascii', 0, 4);
	    return format === 'true' || format === 'OTTO' || format === String.fromCharCode(0, 1, 0, 0);
	  };

	  function TTFFont(stream) {
	    var variationCoords = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	    _classCallCheck(this, TTFFont);

	    this.stream = stream;
	    this.variationCoords = variationCoords;

	    this._directoryPos = this.stream.pos;
	    this._tables = {};
	    this._glyphs = {};
	    this._decodeDirectory();

	    // define properties for each table to lazily parse
	    for (var tag in this.directory.tables) {
	      var table = this.directory.tables[tag];
	      if (tables[tag] && table.length > 0) {
	        _Object$defineProperty(this, tag, {
	          get: this._getTable.bind(this, table)
	        });
	      }
	    }
	  }

	  TTFFont.prototype._getTable = function _getTable(table) {
	    if (!(table.tag in this._tables)) {
	      try {
	        this._tables[table.tag] = this._decodeTable(table);
	      } catch (e) {
	        if (fontkit.logErrors) {
	          console.error('Error decoding table ' + table.tag);
	          console.error(e.stack);
	        }
	      }
	    }

	    return this._tables[table.tag];
	  };

	  TTFFont.prototype._getTableStream = function _getTableStream(tag) {
	    var table = this.directory.tables[tag];
	    if (table) {
	      this.stream.pos = table.offset;
	      return this.stream;
	    }

	    return null;
	  };

	  TTFFont.prototype._decodeDirectory = function _decodeDirectory() {
	    return this.directory = Directory.decode(this.stream, { _startOffset: 0 });
	  };

	  TTFFont.prototype._decodeTable = function _decodeTable(table) {
	    var pos = this.stream.pos;

	    var stream = this._getTableStream(table.tag);
	    var result = tables[table.tag].decode(stream, this, table.length);

	    this.stream.pos = pos;
	    return result;
	  };

	  /**
	   * The unique PostScript name for this font
	   * @type {string}
	   */


	  /**
	   * Gets a string from the font's `name` table
	   * `lang` is a BCP-47 language code.
	   * @return {string}
	   */
	  TTFFont.prototype.getName = function getName(key) {
	    var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';

	    var record = this.name.records[key];
	    if (record) {
	      return record[lang];
	    }

	    return null;
	  };

	  /**
	   * The font's full name, e.g. "Helvetica Bold"
	   * @type {string}
	   */


	  /**
	   * Returns whether there is glyph in the font for the given unicode code point.
	   *
	   * @param {number} codePoint
	   * @return {boolean}
	   */
	  TTFFont.prototype.hasGlyphForCodePoint = function hasGlyphForCodePoint(codePoint) {
	    return !!this._cmapProcessor.lookup(codePoint);
	  };

	  /**
	   * Maps a single unicode code point to a Glyph object.
	   * Does not perform any advanced substitutions (there is no context to do so).
	   *
	   * @param {number} codePoint
	   * @return {Glyph}
	   */


	  TTFFont.prototype.glyphForCodePoint = function glyphForCodePoint(codePoint) {
	    return this.getGlyph(this._cmapProcessor.lookup(codePoint), [codePoint]);
	  };

	  /**
	   * Returns an array of Glyph objects for the given string.
	   * This is only a one-to-one mapping from characters to glyphs.
	   * For most uses, you should use font.layout (described below), which
	   * provides a much more advanced mapping supporting AAT and OpenType shaping.
	   *
	   * @param {string} string
	   * @return {Glyph[]}
	   */


	  TTFFont.prototype.glyphsForString = function glyphsForString(string) {
	    var glyphs = [];
	    var len = string.length;
	    var idx = 0;
	    var last = -1;
	    var state = -1;

	    while (idx <= len) {
	      var code = 0;
	      var nextState = 0;

	      if (idx < len) {
	        // Decode the next codepoint from UTF 16
	        code = string.charCodeAt(idx++);
	        if (0xd800 <= code && code <= 0xdbff && idx < len) {
	          var next = string.charCodeAt(idx);
	          if (0xdc00 <= next && next <= 0xdfff) {
	            idx++;
	            code = ((code & 0x3ff) << 10) + (next & 0x3ff) + 0x10000;
	          }
	        }

	        // Compute the next state: 1 if the next codepoint is a variation selector, 0 otherwise.
	        nextState = 0xfe00 <= code && code <= 0xfe0f || 0xe0100 <= code && code <= 0xe01ef ? 1 : 0;
	      } else {
	        idx++;
	      }

	      if (state === 0 && nextState === 1) {
	        // Variation selector following normal codepoint.
	        glyphs.push(this.getGlyph(this._cmapProcessor.lookup(last, code), [last, code]));
	      } else if (state === 0 && nextState === 0) {
	        // Normal codepoint following normal codepoint.
	        glyphs.push(this.glyphForCodePoint(last));
	      }

	      last = code;
	      state = nextState;
	    }

	    return glyphs;
	  };

	  /**
	   * Returns a GlyphRun object, which includes an array of Glyphs and GlyphPositions for the given string.
	   *
	   * @param {string} string
	   * @param {string[]} [userFeatures]
	   * @param {string} [script]
	   * @param {string} [language]
	   * @param {string} [direction]
	   * @return {GlyphRun}
	   */
	  TTFFont.prototype.layout = function layout(string, userFeatures, script, language, direction) {
	    return this._layoutEngine.layout(string, userFeatures, script, language, direction);
	  };

	  /**
	   * Returns an array of strings that map to the given glyph id.
	   * @param {number} gid - glyph id
	   */


	  TTFFont.prototype.stringsForGlyph = function stringsForGlyph(gid) {
	    return this._layoutEngine.stringsForGlyph(gid);
	  };

	  /**
	   * An array of all [OpenType feature tags](https://www.microsoft.com/typography/otspec/featuretags.htm)
	   * (or mapped AAT tags) supported by the font.
	   * The features parameter is an array of OpenType feature tags to be applied in addition to the default set.
	   * If this is an AAT font, the OpenType feature tags are mapped to AAT features.
	   *
	   * @type {string[]}
	   */


	  TTFFont.prototype.getAvailableFeatures = function getAvailableFeatures(script, language) {
	    return this._layoutEngine.getAvailableFeatures(script, language);
	  };

	  TTFFont.prototype._getBaseGlyph = function _getBaseGlyph(glyph) {
	    var characters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

	    if (!this._glyphs[glyph]) {
	      if (this.directory.tables.glyf) {
	        this._glyphs[glyph] = new TTFGlyph(glyph, characters, this);
	      } else if (this.directory.tables['CFF '] || this.directory.tables.CFF2) {
	        this._glyphs[glyph] = new CFFGlyph(glyph, characters, this);
	      }
	    }

	    return this._glyphs[glyph] || null;
	  };

	  /**
	   * Returns a glyph object for the given glyph id.
	   * You can pass the array of code points this glyph represents for
	   * your use later, and it will be stored in the glyph object.
	   *
	   * @param {number} glyph
	   * @param {number[]} characters
	   * @return {Glyph}
	   */


	  TTFFont.prototype.getGlyph = function getGlyph(glyph) {
	    var characters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

	    if (!this._glyphs[glyph]) {
	      if (this.directory.tables.sbix) {
	        this._glyphs[glyph] = new SBIXGlyph(glyph, characters, this);
	      } else if (this.directory.tables.COLR && this.directory.tables.CPAL) {
	        this._glyphs[glyph] = new COLRGlyph(glyph, characters, this);
	      } else {
	        this._getBaseGlyph(glyph, characters);
	      }
	    }

	    return this._glyphs[glyph] || null;
	  };

	  /**
	   * Returns a Subset for this font.
	   * @return {Subset}
	   */


	  TTFFont.prototype.createSubset = function createSubset() {
	    if (this.directory.tables['CFF ']) {
	      return new CFFSubset(this);
	    }

	    return new TTFSubset(this);
	  };

	  /**
	   * Returns an object describing the available variation axes
	   * that this font supports. Keys are setting tags, and values
	   * contain the axis name, range, and default value.
	   *
	   * @type {object}
	   */


	  /**
	   * Returns a new font with the given variation settings applied.
	   * Settings can either be an instance name, or an object containing
	   * variation tags as specified by the `variationAxes` property.
	   *
	   * @param {object} settings
	   * @return {TTFFont}
	   */
	  TTFFont.prototype.getVariation = function getVariation(settings) {
	    if (!(this.directory.tables.fvar && (this.directory.tables.gvar && this.directory.tables.glyf || this.directory.tables.CFF2))) {
	      throw new Error('Variations require a font with the fvar, gvar and glyf, or CFF2 tables.');
	    }

	    if (typeof settings === 'string') {
	      settings = this.namedVariations[settings];
	    }

	    if ((typeof settings === 'undefined' ? 'undefined' : _typeof(settings)) !== 'object') {
	      throw new Error('Variation settings must be either a variation name or settings object.');
	    }

	    // normalize the coordinates
	    var coords = this.fvar.axis.map(function (axis, i) {
	      var axisTag = axis.axisTag.trim();
	      if (axisTag in settings) {
	        return Math.max(axis.minValue, Math.min(axis.maxValue, settings[axisTag]));
	      } else {
	        return axis.defaultValue;
	      }
	    });

	    var stream = new r.DecodeStream(this.stream.buffer);
	    stream.pos = this._directoryPos;

	    var font = new TTFFont(stream, coords);
	    font._tables = this._tables;

	    return font;
	  };

	  // Standardized format plugin API
	  TTFFont.prototype.getFont = function getFont(name) {
	    return this.getVariation(name);
	  };

	  _createClass(TTFFont, [{
	    key: 'postscriptName',
	    get: function get() {
	      var name = this.name.records.postscriptName;
	      if (name) {
	        var lang = _Object$keys(name)[0];
	        return name[lang];
	      }

	      return null;
	    }
	  }, {
	    key: 'fullName',
	    get: function get() {
	      return this.getName('fullName');
	    }

	    /**
	     * The font's family name, e.g. "Helvetica"
	     * @type {string}
	     */

	  }, {
	    key: 'familyName',
	    get: function get() {
	      return this.getName('fontFamily');
	    }

	    /**
	     * The font's sub-family, e.g. "Bold".
	     * @type {string}
	     */

	  }, {
	    key: 'subfamilyName',
	    get: function get() {
	      return this.getName('fontSubfamily');
	    }

	    /**
	     * The font's copyright information
	     * @type {string}
	     */

	  }, {
	    key: 'copyright',
	    get: function get() {
	      return this.getName('copyright');
	    }

	    /**
	     * The font's version number
	     * @type {string}
	     */

	  }, {
	    key: 'version',
	    get: function get() {
	      return this.getName('version');
	    }

	    /**
	     * The font’s [ascender](https://en.wikipedia.org/wiki/Ascender_(typography))
	     * @type {number}
	     */

	  }, {
	    key: 'ascent',
	    get: function get() {
	      return this.hhea.ascent;
	    }

	    /**
	     * The font’s [descender](https://en.wikipedia.org/wiki/Descender)
	     * @type {number}
	     */

	  }, {
	    key: 'descent',
	    get: function get() {
	      return this.hhea.descent;
	    }

	    /**
	     * The amount of space that should be included between lines
	     * @type {number}
	     */

	  }, {
	    key: 'lineGap',
	    get: function get() {
	      return this.hhea.lineGap;
	    }

	    /**
	     * The offset from the normal underline position that should be used
	     * @type {number}
	     */

	  }, {
	    key: 'underlinePosition',
	    get: function get() {
	      return this.post.underlinePosition;
	    }

	    /**
	     * The weight of the underline that should be used
	     * @type {number}
	     */

	  }, {
	    key: 'underlineThickness',
	    get: function get() {
	      return this.post.underlineThickness;
	    }

	    /**
	     * If this is an italic font, the angle the cursor should be drawn at to match the font design
	     * @type {number}
	     */

	  }, {
	    key: 'italicAngle',
	    get: function get() {
	      return this.post.italicAngle;
	    }

	    /**
	     * The height of capital letters above the baseline.
	     * See [here](https://en.wikipedia.org/wiki/Cap_height) for more details.
	     * @type {number}
	     */

	  }, {
	    key: 'capHeight',
	    get: function get() {
	      var os2 = this['OS/2'];
	      return os2 ? os2.capHeight : this.ascent;
	    }

	    /**
	     * The height of lower case letters in the font.
	     * See [here](https://en.wikipedia.org/wiki/X-height) for more details.
	     * @type {number}
	     */

	  }, {
	    key: 'xHeight',
	    get: function get() {
	      var os2 = this['OS/2'];
	      return os2 ? os2.xHeight : 0;
	    }

	    /**
	     * The number of glyphs in the font.
	     * @type {number}
	     */

	  }, {
	    key: 'numGlyphs',
	    get: function get() {
	      return this.maxp.numGlyphs;
	    }

	    /**
	     * The size of the font’s internal coordinate grid
	     * @type {number}
	     */

	  }, {
	    key: 'unitsPerEm',
	    get: function get() {
	      return this.head.unitsPerEm;
	    }

	    /**
	     * The font’s bounding box, i.e. the box that encloses all glyphs in the font.
	     * @type {BBox}
	     */

	  }, {
	    key: 'bbox',
	    get: function get() {
	      return _Object$freeze(new BBox(this.head.xMin, this.head.yMin, this.head.xMax, this.head.yMax));
	    }
	  }, {
	    key: '_cmapProcessor',
	    get: function get() {
	      return new CmapProcessor(this.cmap);
	    }

	    /**
	     * An array of all of the unicode code points supported by the font.
	     * @type {number[]}
	     */

	  }, {
	    key: 'characterSet',
	    get: function get() {
	      return this._cmapProcessor.getCharacterSet();
	    }
	  }, {
	    key: '_layoutEngine',
	    get: function get() {
	      return new LayoutEngine(this);
	    }
	  }, {
	    key: 'availableFeatures',
	    get: function get() {
	      return this._layoutEngine.getAvailableFeatures();
	    }
	  }, {
	    key: 'variationAxes',
	    get: function get() {
	      var res = {};
	      if (!this.fvar) {
	        return res;
	      }

	      for (var _iterator = this.fvar.axis, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	        var _ref;

	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }

	        var axis = _ref;

	        res[axis.axisTag.trim()] = {
	          name: axis.name.en,
	          min: axis.minValue,
	          default: axis.defaultValue,
	          max: axis.maxValue
	        };
	      }

	      return res;
	    }

	    /**
	     * Returns an object describing the named variation instances
	     * that the font designer has specified. Keys are variation names
	     * and values are the variation settings for this instance.
	     *
	     * @type {object}
	     */

	  }, {
	    key: 'namedVariations',
	    get: function get() {
	      var res = {};
	      if (!this.fvar) {
	        return res;
	      }

	      for (var _iterator2 = this.fvar.instance, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
	        var _ref2;

	        if (_isArray2) {
	          if (_i2 >= _iterator2.length) break;
	          _ref2 = _iterator2[_i2++];
	        } else {
	          _i2 = _iterator2.next();
	          if (_i2.done) break;
	          _ref2 = _i2.value;
	        }

	        var instance = _ref2;

	        var settings = {};
	        for (var i = 0; i < this.fvar.axis.length; i++) {
	          var axis = this.fvar.axis[i];
	          settings[axis.axisTag.trim()] = instance.coord[i];
	        }

	        res[instance.name.en] = settings;
	      }

	      return res;
	    }
	  }, {
	    key: '_variationProcessor',
	    get: function get() {
	      if (!this.fvar) {
	        return null;
	      }

	      var variationCoords = this.variationCoords;

	      // Ignore if no variation coords and not CFF2
	      if (!variationCoords && !this.CFF2) {
	        return null;
	      }

	      if (!variationCoords) {
	        variationCoords = this.fvar.axis.map(function (axis) {
	          return axis.defaultValue;
	        });
	      }

	      return new GlyphVariationProcessor(this, variationCoords);
	    }
	  }]);

	  return TTFFont;
	}(), (_applyDecoratedDescriptor(_class.prototype, 'bbox', [cache], _Object$getOwnPropertyDescriptor(_class.prototype, 'bbox'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_cmapProcessor', [cache], _Object$getOwnPropertyDescriptor(_class.prototype, '_cmapProcessor'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'characterSet', [cache], _Object$getOwnPropertyDescriptor(_class.prototype, 'characterSet'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_layoutEngine', [cache], _Object$getOwnPropertyDescriptor(_class.prototype, '_layoutEngine'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'variationAxes', [cache], _Object$getOwnPropertyDescriptor(_class.prototype, 'variationAxes'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'namedVariations', [cache], _Object$getOwnPropertyDescriptor(_class.prototype, 'namedVariations'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_variationProcessor', [cache], _Object$getOwnPropertyDescriptor(_class.prototype, '_variationProcessor'), _class.prototype)), _class);

	var WOFFDirectoryEntry = new r.Struct({
	  tag: new r.String(4),
	  offset: new r.Pointer(r.uint32, 'void', { type: 'global' }),
	  compLength: r.uint32,
	  length: r.uint32,
	  origChecksum: r.uint32
	});

	var WOFFDirectory = new r.Struct({
	  tag: new r.String(4), // should be 'wOFF'
	  flavor: r.uint32,
	  length: r.uint32,
	  numTables: r.uint16,
	  reserved: new r.Reserved(r.uint16),
	  totalSfntSize: r.uint32,
	  majorVersion: r.uint16,
	  minorVersion: r.uint16,
	  metaOffset: r.uint32,
	  metaLength: r.uint32,
	  metaOrigLength: r.uint32,
	  privOffset: r.uint32,
	  privLength: r.uint32,
	  tables: new r.Array(WOFFDirectoryEntry, 'numTables')
	});

	WOFFDirectory.process = function () {
	  var tables = {};
	  for (var _iterator = this.tables, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	    var _ref;

	    if (_isArray) {
	      if (_i >= _iterator.length) break;
	      _ref = _iterator[_i++];
	    } else {
	      _i = _iterator.next();
	      if (_i.done) break;
	      _ref = _i.value;
	    }

	    var table = _ref;

	    tables[table.tag] = table;
	  }

	  this.tables = tables;
	};

	var WOFFFont = function (_TTFFont) {
	  _inherits(WOFFFont, _TTFFont);

	  function WOFFFont() {
	    _classCallCheck(this, WOFFFont);

	    return _possibleConstructorReturn(this, _TTFFont.apply(this, arguments));
	  }

	  WOFFFont.probe = function probe(buffer) {
	    return buffer.toString('ascii', 0, 4) === 'wOFF';
	  };

	  WOFFFont.prototype._decodeDirectory = function _decodeDirectory() {
	    this.directory = WOFFDirectory.decode(this.stream, { _startOffset: 0 });
	  };

	  WOFFFont.prototype._getTableStream = function _getTableStream(tag) {
	    var table = this.directory.tables[tag];
	    if (table) {
	      this.stream.pos = table.offset;

	      if (table.compLength < table.length) {
	        this.stream.pos += 2; // skip deflate header
	        var outBuffer = new Buffer(table.length);
	        var buf = inflate(this.stream.readBuffer(table.compLength - 2), outBuffer);
	        return new r.DecodeStream(buf);
	      } else {
	        return this.stream;
	      }
	    }

	    return null;
	  };

	  return WOFFFont;
	}(TTFFont);

	/**
	 * Represents a TrueType glyph in the WOFF2 format, which compresses glyphs differently.
	 */

	var WOFF2Glyph = function (_TTFGlyph) {
	  _inherits(WOFF2Glyph, _TTFGlyph);

	  function WOFF2Glyph() {
	    _classCallCheck(this, WOFF2Glyph);

	    return _possibleConstructorReturn(this, _TTFGlyph.apply(this, arguments));
	  }

	  WOFF2Glyph.prototype._decode = function _decode() {
	    // We have to decode in advance (in WOFF2Font), so just return the pre-decoded data.
	    return this._font._transformedGlyphs[this.id];
	  };

	  WOFF2Glyph.prototype._getCBox = function _getCBox() {
	    return this.path.bbox;
	  };

	  return WOFF2Glyph;
	}(TTFGlyph);

	var Base128 = {
	  decode: function decode(stream) {
	    var result = 0;
	    var iterable = [0, 1, 2, 3, 4];
	    for (var j = 0; j < iterable.length; j++) {
	      var i = iterable[j];
	      var code = stream.readUInt8();

	      // If any of the top seven bits are set then we're about to overflow.
	      if (result & 0xe0000000) {
	        throw new Error('Overflow');
	      }

	      result = result << 7 | code & 0x7f;
	      if ((code & 0x80) === 0) {
	        return result;
	      }
	    }

	    throw new Error('Bad base 128 number');
	  }
	};

	var knownTags = ['cmap', 'head', 'hhea', 'hmtx', 'maxp', 'name', 'OS/2', 'post', 'cvt ', 'fpgm', 'glyf', 'loca', 'prep', 'CFF ', 'VORG', 'EBDT', 'EBLC', 'gasp', 'hdmx', 'kern', 'LTSH', 'PCLT', 'VDMX', 'vhea', 'vmtx', 'BASE', 'GDEF', 'GPOS', 'GSUB', 'EBSC', 'JSTF', 'MATH', 'CBDT', 'CBLC', 'COLR', 'CPAL', 'SVG ', 'sbix', 'acnt', 'avar', 'bdat', 'bloc', 'bsln', 'cvar', 'fdsc', 'feat', 'fmtx', 'fvar', 'gvar', 'hsty', 'just', 'lcar', 'mort', 'morx', 'opbd', 'prop', 'trak', 'Zapf', 'Silf', 'Glat', 'Gloc', 'Feat', 'Sill'];

	var WOFF2DirectoryEntry = new r.Struct({
	  flags: r.uint8,
	  customTag: new r.Optional(new r.String(4), function (t) {
	    return (t.flags & 0x3f) === 0x3f;
	  }),
	  tag: function tag(t) {
	    return t.customTag || knownTags[t.flags & 0x3f];
	  }, // || (() => { throw new Error(`Bad tag: ${flags & 0x3f}`); })(); },
	  length: Base128,
	  transformVersion: function transformVersion(t) {
	    return t.flags >>> 6 & 0x03;
	  },
	  transformed: function transformed(t) {
	    return t.tag === 'glyf' || t.tag === 'loca' ? t.transformVersion === 0 : t.transformVersion !== 0;
	  },
	  transformLength: new r.Optional(Base128, function (t) {
	    return t.transformed;
	  })
	});

	var WOFF2Directory = new r.Struct({
	  tag: new r.String(4), // should be 'wOF2'
	  flavor: r.uint32,
	  length: r.uint32,
	  numTables: r.uint16,
	  reserved: new r.Reserved(r.uint16),
	  totalSfntSize: r.uint32,
	  totalCompressedSize: r.uint32,
	  majorVersion: r.uint16,
	  minorVersion: r.uint16,
	  metaOffset: r.uint32,
	  metaLength: r.uint32,
	  metaOrigLength: r.uint32,
	  privOffset: r.uint32,
	  privLength: r.uint32,
	  tables: new r.Array(WOFF2DirectoryEntry, 'numTables')
	});

	WOFF2Directory.process = function () {
	  var tables = {};
	  for (var i = 0; i < this.tables.length; i++) {
	    var table = this.tables[i];
	    tables[table.tag] = table;
	  }

	  return this.tables = tables;
	};

	/**
	 * Subclass of TTFFont that represents a TTF/OTF font compressed by WOFF2
	 * See spec here: http://www.w3.org/TR/WOFF2/
	 */

	var WOFF2Font = function (_TTFFont) {
	  _inherits(WOFF2Font, _TTFFont);

	  function WOFF2Font() {
	    _classCallCheck(this, WOFF2Font);

	    return _possibleConstructorReturn(this, _TTFFont.apply(this, arguments));
	  }

	  WOFF2Font.probe = function probe(buffer) {
	    return buffer.toString('ascii', 0, 4) === 'wOF2';
	  };

	  WOFF2Font.prototype._decodeDirectory = function _decodeDirectory() {
	    this.directory = WOFF2Directory.decode(this.stream);
	    this._dataPos = this.stream.pos;
	  };

	  WOFF2Font.prototype._decompress = function _decompress() {
	    // decompress data and setup table offsets if we haven't already
	    if (!this._decompressed) {
	      this.stream.pos = this._dataPos;
	      var buffer = this.stream.readBuffer(this.directory.totalCompressedSize);

	      var decompressedSize = 0;
	      for (var tag in this.directory.tables) {
	        var entry = this.directory.tables[tag];
	        entry.offset = decompressedSize;
	        decompressedSize += entry.transformLength != null ? entry.transformLength : entry.length;
	      }

	      var decompressed = brotli(buffer, decompressedSize);
	      if (!decompressed) {
	        throw new Error('Error decoding compressed data in WOFF2');
	      }

	      this.stream = new r.DecodeStream(new Buffer(decompressed));
	      this._decompressed = true;
	    }
	  };

	  WOFF2Font.prototype._decodeTable = function _decodeTable(table) {
	    this._decompress();
	    return _TTFFont.prototype._decodeTable.call(this, table);
	  };

	  // Override this method to get a glyph and return our
	  // custom subclass if there is a glyf table.


	  WOFF2Font.prototype._getBaseGlyph = function _getBaseGlyph(glyph) {
	    var characters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

	    if (!this._glyphs[glyph]) {
	      if (this.directory.tables.glyf && this.directory.tables.glyf.transformed) {
	        if (!this._transformedGlyphs) {
	          this._transformGlyfTable();
	        }
	        return this._glyphs[glyph] = new WOFF2Glyph(glyph, characters, this);
	      } else {
	        return _TTFFont.prototype._getBaseGlyph.call(this, glyph, characters);
	      }
	    }
	  };

	  WOFF2Font.prototype._transformGlyfTable = function _transformGlyfTable() {
	    this._decompress();
	    this.stream.pos = this.directory.tables.glyf.offset;
	    var table = GlyfTable.decode(this.stream);
	    var glyphs = [];

	    for (var index = 0; index < table.numGlyphs; index++) {
	      var glyph = {};
	      var nContours = table.nContours.readInt16BE();
	      glyph.numberOfContours = nContours;

	      if (nContours > 0) {
	        // simple glyph
	        var nPoints = [];
	        var totalPoints = 0;

	        for (var i = 0; i < nContours; i++) {
	          var _r = read255UInt16(table.nPoints);
	          totalPoints += _r;
	          nPoints.push(totalPoints);
	        }

	        glyph.points = decodeTriplet(table.flags, table.glyphs, totalPoints);
	        for (var _i = 0; _i < nContours; _i++) {
	          glyph.points[nPoints[_i] - 1].endContour = true;
	        }

	        var instructionSize = read255UInt16(table.glyphs);
	      } else if (nContours < 0) {
	        // composite glyph
	        var haveInstructions = TTFGlyph.prototype._decodeComposite.call({ _font: this }, glyph, table.composites);
	        if (haveInstructions) {
	          var instructionSize = read255UInt16(table.glyphs);
	        }
	      }

	      glyphs.push(glyph);
	    }

	    this._transformedGlyphs = glyphs;
	  };

	  return WOFF2Font;
	}(TTFFont);

	var Substream = function () {
	  function Substream(length) {
	    _classCallCheck(this, Substream);

	    this.length = length;
	    this._buf = new r.Buffer(length);
	  }

	  Substream.prototype.decode = function decode(stream, parent) {
	    return new r.DecodeStream(this._buf.decode(stream, parent));
	  };

	  return Substream;
	}();

	// This struct represents the entire glyf table


	var GlyfTable = new r.Struct({
	  version: r.uint32,
	  numGlyphs: r.uint16,
	  indexFormat: r.uint16,
	  nContourStreamSize: r.uint32,
	  nPointsStreamSize: r.uint32,
	  flagStreamSize: r.uint32,
	  glyphStreamSize: r.uint32,
	  compositeStreamSize: r.uint32,
	  bboxStreamSize: r.uint32,
	  instructionStreamSize: r.uint32,
	  nContours: new Substream('nContourStreamSize'),
	  nPoints: new Substream('nPointsStreamSize'),
	  flags: new Substream('flagStreamSize'),
	  glyphs: new Substream('glyphStreamSize'),
	  composites: new Substream('compositeStreamSize'),
	  bboxes: new Substream('bboxStreamSize'),
	  instructions: new Substream('instructionStreamSize')
	});

	var WORD_CODE = 253;
	var ONE_MORE_BYTE_CODE2 = 254;
	var ONE_MORE_BYTE_CODE1 = 255;
	var LOWEST_U_CODE = 253;

	function read255UInt16(stream) {
	  var code = stream.readUInt8();

	  if (code === WORD_CODE) {
	    return stream.readUInt16BE();
	  }

	  if (code === ONE_MORE_BYTE_CODE1) {
	    return stream.readUInt8() + LOWEST_U_CODE;
	  }

	  if (code === ONE_MORE_BYTE_CODE2) {
	    return stream.readUInt8() + LOWEST_U_CODE * 2;
	  }

	  return code;
	}

	function withSign(flag, baseval) {
	  return flag & 1 ? baseval : -baseval;
	}

	function decodeTriplet(flags, glyphs, nPoints) {
	  var y = void 0;
	  var x = y = 0;
	  var res = [];

	  for (var i = 0; i < nPoints; i++) {
	    var dx = 0,
	        dy = 0;
	    var flag = flags.readUInt8();
	    var onCurve = !(flag >> 7);
	    flag &= 0x7f;

	    if (flag < 10) {
	      dx = 0;
	      dy = withSign(flag, ((flag & 14) << 7) + glyphs.readUInt8());
	    } else if (flag < 20) {
	      dx = withSign(flag, ((flag - 10 & 14) << 7) + glyphs.readUInt8());
	      dy = 0;
	    } else if (flag < 84) {
	      var b0 = flag - 20;
	      var b1 = glyphs.readUInt8();
	      dx = withSign(flag, 1 + (b0 & 0x30) + (b1 >> 4));
	      dy = withSign(flag >> 1, 1 + ((b0 & 0x0c) << 2) + (b1 & 0x0f));
	    } else if (flag < 120) {
	      var b0 = flag - 84;
	      dx = withSign(flag, 1 + (b0 / 12 << 8) + glyphs.readUInt8());
	      dy = withSign(flag >> 1, 1 + (b0 % 12 >> 2 << 8) + glyphs.readUInt8());
	    } else if (flag < 124) {
	      var b1 = glyphs.readUInt8();
	      var b2 = glyphs.readUInt8();
	      dx = withSign(flag, (b1 << 4) + (b2 >> 4));
	      dy = withSign(flag >> 1, ((b2 & 0x0f) << 8) + glyphs.readUInt8());
	    } else {
	      dx = withSign(flag, glyphs.readUInt16BE());
	      dy = withSign(flag >> 1, glyphs.readUInt16BE());
	    }

	    x += dx;
	    y += dy;
	    res.push(new Point(onCurve, false, x, y));
	  }

	  return res;
	}

	var TTCHeader = new r.VersionedStruct(r.uint32, {
	  0x00010000: {
	    numFonts: r.uint32,
	    offsets: new r.Array(r.uint32, 'numFonts')
	  },
	  0x00020000: {
	    numFonts: r.uint32,
	    offsets: new r.Array(r.uint32, 'numFonts'),
	    dsigTag: r.uint32,
	    dsigLength: r.uint32,
	    dsigOffset: r.uint32
	  }
	});

	var TrueTypeCollection = function () {
	  TrueTypeCollection.probe = function probe(buffer) {
	    return buffer.toString('ascii', 0, 4) === 'ttcf';
	  };

	  function TrueTypeCollection(stream) {
	    _classCallCheck(this, TrueTypeCollection);

	    this.stream = stream;
	    if (stream.readString(4) !== 'ttcf') {
	      throw new Error('Not a TrueType collection');
	    }

	    this.header = TTCHeader.decode(stream);
	  }

	  TrueTypeCollection.prototype.getFont = function getFont(name) {
	    for (var _iterator = this.header.offsets, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	      var _ref;

	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }

	      var offset = _ref;

	      var stream = new r.DecodeStream(this.stream.buffer);
	      stream.pos = offset;
	      var font = new TTFFont(stream);
	      if (font.postscriptName === name) {
	        return font;
	      }
	    }

	    return null;
	  };

	  _createClass(TrueTypeCollection, [{
	    key: 'fonts',
	    get: function get() {
	      var fonts = [];
	      for (var _iterator2 = this.header.offsets, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
	        var _ref2;

	        if (_isArray2) {
	          if (_i2 >= _iterator2.length) break;
	          _ref2 = _iterator2[_i2++];
	        } else {
	          _i2 = _iterator2.next();
	          if (_i2.done) break;
	          _ref2 = _i2.value;
	        }

	        var offset = _ref2;

	        var stream = new r.DecodeStream(this.stream.buffer);
	        stream.pos = offset;
	        fonts.push(new TTFFont(stream));
	      }

	      return fonts;
	    }
	  }]);

	  return TrueTypeCollection;
	}();

	var DFontName = new r.String(r.uint8);
	var DFontData = new r.Struct({
	  len: r.uint32,
	  buf: new r.Buffer('len')
	});

	var Ref = new r.Struct({
	  id: r.uint16,
	  nameOffset: r.int16,
	  attr: r.uint8,
	  dataOffset: r.uint24,
	  handle: r.uint32
	});

	var Type = new r.Struct({
	  name: new r.String(4),
	  maxTypeIndex: r.uint16,
	  refList: new r.Pointer(r.uint16, new r.Array(Ref, function (t) {
	    return t.maxTypeIndex + 1;
	  }), { type: 'parent' })
	});

	var TypeList = new r.Struct({
	  length: r.uint16,
	  types: new r.Array(Type, function (t) {
	    return t.length + 1;
	  })
	});

	var DFontMap = new r.Struct({
	  reserved: new r.Reserved(r.uint8, 24),
	  typeList: new r.Pointer(r.uint16, TypeList),
	  nameListOffset: new r.Pointer(r.uint16, 'void')
	});

	var DFontHeader = new r.Struct({
	  dataOffset: r.uint32,
	  map: new r.Pointer(r.uint32, DFontMap),
	  dataLength: r.uint32,
	  mapLength: r.uint32
	});

	var DFont = function () {
	  DFont.probe = function probe(buffer) {
	    var stream = new r.DecodeStream(buffer);

	    try {
	      var header = DFontHeader.decode(stream);
	    } catch (e) {
	      return false;
	    }

	    for (var _iterator = header.map.typeList.types, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
	      var _ref;

	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }

	      var type = _ref;

	      if (type.name === 'sfnt') {
	        return true;
	      }
	    }

	    return false;
	  };

	  function DFont(stream) {
	    _classCallCheck(this, DFont);

	    this.stream = stream;
	    this.header = DFontHeader.decode(this.stream);

	    for (var _iterator2 = this.header.map.typeList.types, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _getIterator(_iterator2);;) {
	      var _ref2;

	      if (_isArray2) {
	        if (_i2 >= _iterator2.length) break;
	        _ref2 = _iterator2[_i2++];
	      } else {
	        _i2 = _iterator2.next();
	        if (_i2.done) break;
	        _ref2 = _i2.value;
	      }

	      var type = _ref2;

	      for (var _iterator3 = type.refList, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _getIterator(_iterator3);;) {
	        var _ref3;

	        if (_isArray3) {
	          if (_i3 >= _iterator3.length) break;
	          _ref3 = _iterator3[_i3++];
	        } else {
	          _i3 = _iterator3.next();
	          if (_i3.done) break;
	          _ref3 = _i3.value;
	        }

	        var ref = _ref3;

	        if (ref.nameOffset >= 0) {
	          this.stream.pos = ref.nameOffset + this.header.map.nameListOffset;
	          ref.name = DFontName.decode(this.stream);
	        } else {
	          ref.name = null;
	        }
	      }

	      if (type.name === 'sfnt') {
	        this.sfnt = type;
	      }
	    }
	  }

	  DFont.prototype.getFont = function getFont(name) {
	    if (!this.sfnt) {
	      return null;
	    }

	    for (var _iterator4 = this.sfnt.refList, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _getIterator(_iterator4);;) {
	      var _ref4;

	      if (_isArray4) {
	        if (_i4 >= _iterator4.length) break;
	        _ref4 = _iterator4[_i4++];
	      } else {
	        _i4 = _iterator4.next();
	        if (_i4.done) break;
	        _ref4 = _i4.value;
	      }

	      var ref = _ref4;

	      var pos = this.header.dataOffset + ref.dataOffset + 4;
	      var stream = new r.DecodeStream(this.stream.buffer.slice(pos));
	      var font = new TTFFont(stream);
	      if (font.postscriptName === name) {
	        return font;
	      }
	    }

	    return null;
	  };

	  _createClass(DFont, [{
	    key: 'fonts',
	    get: function get() {
	      var fonts = [];
	      for (var _iterator5 = this.sfnt.refList, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _getIterator(_iterator5);;) {
	        var _ref5;

	        if (_isArray5) {
	          if (_i5 >= _iterator5.length) break;
	          _ref5 = _iterator5[_i5++];
	        } else {
	          _i5 = _iterator5.next();
	          if (_i5.done) break;
	          _ref5 = _i5.value;
	        }

	        var ref = _ref5;

	        var pos = this.header.dataOffset + ref.dataOffset + 4;
	        var stream = new r.DecodeStream(this.stream.buffer.slice(pos));
	        fonts.push(new TTFFont(stream));
	      }

	      return fonts;
	    }
	  }]);

	  return DFont;
	}();

	// Register font formats
	fontkit.registerFormat(TTFFont);
	fontkit.registerFormat(WOFFFont);
	fontkit.registerFormat(WOFF2Font);
	fontkit.registerFormat(TrueTypeCollection);
	fontkit.registerFormat(DFont);

	module.exports = fontkit;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer, __webpack_require__(36)))

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.7.1
	(function() {
	  var key, val, _ref, _ref1;

	  exports.EncodeStream = __webpack_require__(85);

	  exports.DecodeStream = __webpack_require__(86);

	  exports.Array = __webpack_require__(108);

	  exports.LazyArray = __webpack_require__(111);

	  exports.Bitfield = __webpack_require__(112);

	  exports.Boolean = __webpack_require__(113);

	  exports.Buffer = __webpack_require__(114);

	  exports.Enum = __webpack_require__(115);

	  exports.Optional = __webpack_require__(116);

	  exports.Reserved = __webpack_require__(117);

	  exports.String = __webpack_require__(118);

	  exports.Struct = __webpack_require__(119);

	  exports.VersionedStruct = __webpack_require__(120);

	  _ref = __webpack_require__(109);
	  for (key in _ref) {
	    val = _ref[key];
	    exports[key] = val;
	  }

	  _ref1 = __webpack_require__(121);
	  for (key in _ref1) {
	    val = _ref1[key];
	    exports[key] = val;
	  }

	}).call(this);


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Generated by CoffeeScript 1.7.1
	(function() {
	  var DecodeStream, EncodeStream, iconv, stream,
	    __hasProp = {}.hasOwnProperty,
	    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

	  stream = __webpack_require__(31);

	  DecodeStream = __webpack_require__(86);

	  try {
	    iconv = __webpack_require__(87);
	  } catch (_error) {}

	  EncodeStream = (function(_super) {
	    var key;

	    __extends(EncodeStream, _super);

	    function EncodeStream(bufferSize) {
	      if (bufferSize == null) {
	        bufferSize = 65536;
	      }
	      EncodeStream.__super__.constructor.apply(this, arguments);
	      this.buffer = new Buffer(bufferSize);
	      this.bufferOffset = 0;
	      this.pos = 0;
	    }

	    for (key in Buffer.prototype) {
	      if (key.slice(0, 5) === 'write') {
	        (function(key) {
	          var bytes;
	          bytes = +DecodeStream.TYPES[key.replace(/write|[BL]E/g, '')];
	          return EncodeStream.prototype[key] = function(value) {
	            this.ensure(bytes);
	            this.buffer[key](value, this.bufferOffset);
	            this.bufferOffset += bytes;
	            return this.pos += bytes;
	          };
	        })(key);
	      }
	    }

	    EncodeStream.prototype._read = function() {};

	    EncodeStream.prototype.ensure = function(bytes) {
	      if (this.bufferOffset + bytes > this.buffer.length) {
	        return this.flush();
	      }
	    };

	    EncodeStream.prototype.flush = function() {
	      if (this.bufferOffset > 0) {
	        this.push(new Buffer(this.buffer.slice(0, this.bufferOffset)));
	        return this.bufferOffset = 0;
	      }
	    };

	    EncodeStream.prototype.writeBuffer = function(buffer) {
	      this.flush();
	      this.push(buffer);
	      return this.pos += buffer.length;
	    };

	    EncodeStream.prototype.writeString = function(string, encoding) {
	      var buf, byte, i, _i, _ref;
	      if (encoding == null) {
	        encoding = 'ascii';
	      }
	      switch (encoding) {
	        case 'utf16le':
	        case 'ucs2':
	        case 'utf8':
	        case 'ascii':
	          return this.writeBuffer(new Buffer(string, encoding));
	        case 'utf16be':
	          buf = new Buffer(string, 'utf16le');
	          for (i = _i = 0, _ref = buf.length - 1; _i < _ref; i = _i += 2) {
	            byte = buf[i];
	            buf[i] = buf[i + 1];
	            buf[i + 1] = byte;
	          }
	          return this.writeBuffer(buf);
	        default:
	          if (iconv) {
	            return this.writeBuffer(iconv.encode(string, encoding));
	          } else {
	            throw new Error('Install iconv-lite to enable additional string encodings.');
	          }
	      }
	    };

	    EncodeStream.prototype.writeUInt24BE = function(val) {
	      this.ensure(3);
	      this.buffer[this.bufferOffset++] = val >>> 16 & 0xff;
	      this.buffer[this.bufferOffset++] = val >>> 8 & 0xff;
	      this.buffer[this.bufferOffset++] = val & 0xff;
	      return this.pos += 3;
	    };

	    EncodeStream.prototype.writeUInt24LE = function(val) {
	      this.ensure(3);
	      this.buffer[this.bufferOffset++] = val & 0xff;
	      this.buffer[this.bufferOffset++] = val >>> 8 & 0xff;
	      this.buffer[this.bufferOffset++] = val >>> 16 & 0xff;
	      return this.pos += 3;
	    };

	    EncodeStream.prototype.writeInt24BE = function(val) {
	      if (val >= 0) {
	        return this.writeUInt24BE(val);
	      } else {
	        return this.writeUInt24BE(val + 0xffffff + 1);
	      }
	    };

	    EncodeStream.prototype.writeInt24LE = function(val) {
	      if (val >= 0) {
	        return this.writeUInt24LE(val);
	      } else {
	        return this.writeUInt24LE(val + 0xffffff + 1);
	      }
	    };

	    EncodeStream.prototype.fill = function(val, length) {
	      var buf;
	      if (length < this.buffer.length) {
	        this.ensure(length);
	        this.buffer.fill(val, this.bufferOffset, this.bufferOffset + length);
	        this.bufferOffset += length;
	        return this.pos += length;
	      } else {
	        buf = new Buffer(length);
	        buf.fill(val);
	        return this.writeBuffer(buf);
	      }
	    };

	    EncodeStream.prototype.end = function() {
	      this.flush();
	      return this.push(null);
	    };

	    return EncodeStream;

	  })(stream.Readable);

	  module.exports = EncodeStream;

	}).call(this);

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Generated by CoffeeScript 1.7.1
	(function() {
	  var DecodeStream, iconv;

	  try {
	    iconv = __webpack_require__(87);
	  } catch (_error) {}

	  DecodeStream = (function() {
	    var key;

	    function DecodeStream(buffer) {
	      this.buffer = buffer;
	      this.pos = 0;
	      this.length = this.buffer.length;
	    }

	    DecodeStream.TYPES = {
	      UInt8: 1,
	      UInt16: 2,
	      UInt24: 3,
	      UInt32: 4,
	      Int8: 1,
	      Int16: 2,
	      Int24: 3,
	      Int32: 4,
	      Float: 4,
	      Double: 8
	    };

	    for (key in Buffer.prototype) {
	      if (key.slice(0, 4) === 'read') {
	        (function(key) {
	          var bytes;
	          bytes = DecodeStream.TYPES[key.replace(/read|[BL]E/g, '')];
	          return DecodeStream.prototype[key] = function() {
	            var ret;
	            ret = this.buffer[key](this.pos);
	            this.pos += bytes;
	            return ret;
	          };
	        })(key);
	      }
	    }

	    DecodeStream.prototype.readString = function(length, encoding) {
	      var buf, byte, i, _i, _ref;
	      if (encoding == null) {
	        encoding = 'ascii';
	      }
	      switch (encoding) {
	        case 'utf16le':
	        case 'ucs2':
	        case 'utf8':
	        case 'ascii':
	          return this.buffer.toString(encoding, this.pos, this.pos += length);
	        case 'utf16be':
	          buf = new Buffer(this.readBuffer(length));
	          for (i = _i = 0, _ref = buf.length - 1; _i < _ref; i = _i += 2) {
	            byte = buf[i];
	            buf[i] = buf[i + 1];
	            buf[i + 1] = byte;
	          }
	          return buf.toString('utf16le');
	        default:
	          buf = this.readBuffer(length);
	          if (iconv) {
	            try {
	              return iconv.decode(buf, encoding);
	            } catch (_error) {}
	          }
	          return buf;
	      }
	    };

	    DecodeStream.prototype.readBuffer = function(length) {
	      return this.buffer.slice(this.pos, this.pos += length);
	    };

	    DecodeStream.prototype.readUInt24BE = function() {
	      return (this.readUInt16BE() << 8) + this.readUInt8();
	    };

	    DecodeStream.prototype.readUInt24LE = function() {
	      return this.readUInt16LE() + (this.readUInt8() << 16);
	    };

	    DecodeStream.prototype.readInt24BE = function() {
	      return (this.readInt16BE() << 8) + this.readUInt8();
	    };

	    DecodeStream.prototype.readInt24LE = function() {
	      return this.readUInt16LE() + (this.readInt8() << 16);
	    };

	    return DecodeStream;

	  })();

	  module.exports = DecodeStream;

	}).call(this);

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";

	// Some environments don't have global Buffer (e.g. React Native).
	// Solution would be installing npm modules "buffer" and "stream" explicitly.
	var Buffer = __webpack_require__(2).Buffer;

	var bomHandling = __webpack_require__(88),
	    iconv = module.exports;

	// All codecs and aliases are kept here, keyed by encoding name/alias.
	// They are lazy loaded in `iconv.getCodec` from `encodings/index.js`.
	iconv.encodings = null;

	// Characters emitted in case of error.
	iconv.defaultCharUnicode = '�';
	iconv.defaultCharSingleByte = '?';

	// Public API.
	iconv.encode = function encode(str, encoding, options) {
	    str = "" + (str || ""); // Ensure string.

	    var encoder = iconv.getEncoder(encoding, options);

	    var res = encoder.write(str);
	    var trail = encoder.end();
	    
	    return (trail && trail.length > 0) ? Buffer.concat([res, trail]) : res;
	}

	iconv.decode = function decode(buf, encoding, options) {
	    if (typeof buf === 'string') {
	        if (!iconv.skipDecodeWarning) {
	            console.error('Iconv-lite warning: decode()-ing strings is deprecated. Refer to https://github.com/ashtuchkin/iconv-lite/wiki/Use-Buffers-when-decoding');
	            iconv.skipDecodeWarning = true;
	        }

	        buf = new Buffer("" + (buf || ""), "binary"); // Ensure buffer.
	    }

	    var decoder = iconv.getDecoder(encoding, options);

	    var res = decoder.write(buf);
	    var trail = decoder.end();

	    return trail ? (res + trail) : res;
	}

	iconv.encodingExists = function encodingExists(enc) {
	    try {
	        iconv.getCodec(enc);
	        return true;
	    } catch (e) {
	        return false;
	    }
	}

	// Legacy aliases to convert functions
	iconv.toEncoding = iconv.encode;
	iconv.fromEncoding = iconv.decode;

	// Search for a codec in iconv.encodings. Cache codec data in iconv._codecDataCache.
	iconv._codecDataCache = {};
	iconv.getCodec = function getCodec(encoding) {
	    if (!iconv.encodings)
	        iconv.encodings = __webpack_require__(89); // Lazy load all encoding definitions.
	    
	    // Canonicalize encoding name: strip all non-alphanumeric chars and appended year.
	    var enc = (''+encoding).toLowerCase().replace(/[^0-9a-z]|:\d{4}$/g, "");

	    // Traverse iconv.encodings to find actual codec.
	    var codecOptions = {};
	    while (true) {
	        var codec = iconv._codecDataCache[enc];
	        if (codec)
	            return codec;

	        var codecDef = iconv.encodings[enc];

	        switch (typeof codecDef) {
	            case "string": // Direct alias to other encoding.
	                enc = codecDef;
	                break;

	            case "object": // Alias with options. Can be layered.
	                for (var key in codecDef)
	                    codecOptions[key] = codecDef[key];

	                if (!codecOptions.encodingName)
	                    codecOptions.encodingName = enc;
	                
	                enc = codecDef.type;
	                break;

	            case "function": // Codec itself.
	                if (!codecOptions.encodingName)
	                    codecOptions.encodingName = enc;

	                // The codec function must load all tables and return object with .encoder and .decoder methods.
	                // It'll be called only once (for each different options object).
	                codec = new codecDef(codecOptions, iconv);

	                iconv._codecDataCache[codecOptions.encodingName] = codec; // Save it to be reused later.
	                return codec;

	            default:
	                throw new Error("Encoding not recognized: '" + encoding + "' (searched as: '"+enc+"')");
	        }
	    }
	}

	iconv.getEncoder = function getEncoder(encoding, options) {
	    var codec = iconv.getCodec(encoding),
	        encoder = new codec.encoder(options, codec);

	    if (codec.bomAware && options && options.addBOM)
	        encoder = new bomHandling.PrependBOM(encoder, options);

	    return encoder;
	}

	iconv.getDecoder = function getDecoder(encoding, options) {
	    var codec = iconv.getCodec(encoding),
	        decoder = new codec.decoder(options, codec);

	    if (codec.bomAware && !(options && options.stripBOM === false))
	        decoder = new bomHandling.StripBOM(decoder, options);

	    return decoder;
	}


	// Load extensions in Node. All of them are omitted in Browserify build via 'browser' field in package.json.
	var nodeVer = typeof process !== 'undefined' && process.versions && process.versions.node;
	if (nodeVer) {

	    // Load streaming support in Node v0.10+
	    var nodeVerArr = nodeVer.split(".").map(Number);
	    if (nodeVerArr[0] > 0 || nodeVerArr[1] >= 10) {
	        __webpack_require__(106)(iconv);
	    }

	    // Load Node primitive extensions.
	    __webpack_require__(107)(iconv);
	}

	if (false) {
	    console.error("iconv-lite warning: javascript files use encoding different from utf-8. See https://github.com/ashtuchkin/iconv-lite/wiki/Javascript-source-file-encodings for more info.");
	}

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ }),
/* 88 */
/***/ (function(module, exports) {

	"use strict";

	var BOMChar = '\uFEFF';

	exports.PrependBOM = PrependBOMWrapper
	function PrependBOMWrapper(encoder, options) {
	    this.encoder = encoder;
	    this.addBOM = true;
	}

	PrependBOMWrapper.prototype.write = function(str) {
	    if (this.addBOM) {
	        str = BOMChar + str;
	        this.addBOM = false;
	    }

	    return this.encoder.write(str);
	}

	PrependBOMWrapper.prototype.end = function() {
	    return this.encoder.end();
	}


	//------------------------------------------------------------------------------

	exports.StripBOM = StripBOMWrapper;
	function StripBOMWrapper(decoder, options) {
	    this.decoder = decoder;
	    this.pass = false;
	    this.options = options || {};
	}

	StripBOMWrapper.prototype.write = function(buf) {
	    var res = this.decoder.write(buf);
	    if (this.pass || !res)
	        return res;

	    if (res[0] === BOMChar) {
	        res = res.slice(1);
	        if (typeof this.options.stripBOM === 'function')
	            this.options.stripBOM();
	    }

	    this.pass = true;
	    return res;
	}

	StripBOMWrapper.prototype.end = function() {
	    return this.decoder.end();
	}



/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	// Update this array if you add/rename/remove files in this directory.
	// We support Browserify by skipping automatic module discovery and requiring modules directly.
	var modules = [
	    __webpack_require__(90),
	    __webpack_require__(91),
	    __webpack_require__(92),
	    __webpack_require__(93),
	    __webpack_require__(94),
	    __webpack_require__(95),
	    __webpack_require__(96),
	    __webpack_require__(97),
	];

	// Put all encoding/alias/codec definitions to single object and export it. 
	for (var i = 0; i < modules.length; i++) {
	    var module = modules[i];
	    for (var enc in module)
	        if (Object.prototype.hasOwnProperty.call(module, enc))
	            exports[enc] = module[enc];
	}


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Buffer = __webpack_require__(2).Buffer;

	// Export Node.js internal encodings.

	module.exports = {
	    // Encodings
	    utf8:   { type: "_internal", bomAware: true},
	    cesu8:  { type: "_internal", bomAware: true},
	    unicode11utf8: "utf8",

	    ucs2:   { type: "_internal", bomAware: true},
	    utf16le: "ucs2",

	    binary: { type: "_internal" },
	    base64: { type: "_internal" },
	    hex:    { type: "_internal" },

	    // Codec.
	    _internal: InternalCodec,
	};

	//------------------------------------------------------------------------------

	function InternalCodec(codecOptions, iconv) {
	    this.enc = codecOptions.encodingName;
	    this.bomAware = codecOptions.bomAware;

	    if (this.enc === "base64")
	        this.encoder = InternalEncoderBase64;
	    else if (this.enc === "cesu8") {
	        this.enc = "utf8"; // Use utf8 for decoding.
	        this.encoder = InternalEncoderCesu8;

	        // Add decoder for versions of Node not supporting CESU-8
	        if (new Buffer('eda0bdedb2a9', 'hex').toString() !== '💩') {
	            this.decoder = InternalDecoderCesu8;
	            this.defaultCharUnicode = iconv.defaultCharUnicode;
	        }
	    }
	}

	InternalCodec.prototype.encoder = InternalEncoder;
	InternalCodec.prototype.decoder = InternalDecoder;

	//------------------------------------------------------------------------------

	// We use node.js internal decoder. Its signature is the same as ours.
	var StringDecoder = __webpack_require__(49).StringDecoder;

	if (!StringDecoder.prototype.end) // Node v0.8 doesn't have this method.
	    StringDecoder.prototype.end = function() {};


	function InternalDecoder(options, codec) {
	    StringDecoder.call(this, codec.enc);
	}

	InternalDecoder.prototype = StringDecoder.prototype;


	//------------------------------------------------------------------------------
	// Encoder is mostly trivial

	function InternalEncoder(options, codec) {
	    this.enc = codec.enc;
	}

	InternalEncoder.prototype.write = function(str) {
	    return new Buffer(str, this.enc);
	}

	InternalEncoder.prototype.end = function() {
	}


	//------------------------------------------------------------------------------
	// Except base64 encoder, which must keep its state.

	function InternalEncoderBase64(options, codec) {
	    this.prevStr = '';
	}

	InternalEncoderBase64.prototype.write = function(str) {
	    str = this.prevStr + str;
	    var completeQuads = str.length - (str.length % 4);
	    this.prevStr = str.slice(completeQuads);
	    str = str.slice(0, completeQuads);

	    return new Buffer(str, "base64");
	}

	InternalEncoderBase64.prototype.end = function() {
	    return new Buffer(this.prevStr, "base64");
	}


	//------------------------------------------------------------------------------
	// CESU-8 encoder is also special.

	function InternalEncoderCesu8(options, codec) {
	}

	InternalEncoderCesu8.prototype.write = function(str) {
	    var buf = new Buffer(str.length * 3), bufIdx = 0;
	    for (var i = 0; i < str.length; i++) {
	        var charCode = str.charCodeAt(i);
	        // Naive implementation, but it works because CESU-8 is especially easy
	        // to convert from UTF-16 (which all JS strings are encoded in).
	        if (charCode < 0x80)
	            buf[bufIdx++] = charCode;
	        else if (charCode < 0x800) {
	            buf[bufIdx++] = 0xC0 + (charCode >>> 6);
	            buf[bufIdx++] = 0x80 + (charCode & 0x3f);
	        }
	        else { // charCode will always be < 0x10000 in javascript.
	            buf[bufIdx++] = 0xE0 + (charCode >>> 12);
	            buf[bufIdx++] = 0x80 + ((charCode >>> 6) & 0x3f);
	            buf[bufIdx++] = 0x80 + (charCode & 0x3f);
	        }
	    }
	    return buf.slice(0, bufIdx);
	}

	InternalEncoderCesu8.prototype.end = function() {
	}

	//------------------------------------------------------------------------------
	// CESU-8 decoder is not implemented in Node v4.0+

	function InternalDecoderCesu8(options, codec) {
	    this.acc = 0;
	    this.contBytes = 0;
	    this.accBytes = 0;
	    this.defaultCharUnicode = codec.defaultCharUnicode;
	}

	InternalDecoderCesu8.prototype.write = function(buf) {
	    var acc = this.acc, contBytes = this.contBytes, accBytes = this.accBytes, 
	        res = '';
	    for (var i = 0; i < buf.length; i++) {
	        var curByte = buf[i];
	        if ((curByte & 0xC0) !== 0x80) { // Leading byte
	            if (contBytes > 0) { // Previous code is invalid
	                res += this.defaultCharUnicode;
	                contBytes = 0;
	            }

	            if (curByte < 0x80) { // Single-byte code
	                res += String.fromCharCode(curByte);
	            } else if (curByte < 0xE0) { // Two-byte code
	                acc = curByte & 0x1F;
	                contBytes = 1; accBytes = 1;
	            } else if (curByte < 0xF0) { // Three-byte code
	                acc = curByte & 0x0F;
	                contBytes = 2; accBytes = 1;
	            } else { // Four or more are not supported for CESU-8.
	                res += this.defaultCharUnicode;
	            }
	        } else { // Continuation byte
	            if (contBytes > 0) { // We're waiting for it.
	                acc = (acc << 6) | (curByte & 0x3f);
	                contBytes--; accBytes++;
	                if (contBytes === 0) {
	                    // Check for overlong encoding, but support Modified UTF-8 (encoding NULL as C0 80)
	                    if (accBytes === 2 && acc < 0x80 && acc > 0)
	                        res += this.defaultCharUnicode;
	                    else if (accBytes === 3 && acc < 0x800)
	                        res += this.defaultCharUnicode;
	                    else
	                        // Actually add character.
	                        res += String.fromCharCode(acc);
	                }
	            } else { // Unexpected continuation byte
	                res += this.defaultCharUnicode;
	            }
	        }
	    }
	    this.acc = acc; this.contBytes = contBytes; this.accBytes = accBytes;
	    return res;
	}

	InternalDecoderCesu8.prototype.end = function() {
	    var res = 0;
	    if (this.contBytes > 0)
	        res += this.defaultCharUnicode;
	    return res;
	}


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Buffer = __webpack_require__(2).Buffer;

	// Note: UTF16-LE (or UCS2) codec is Node.js native. See encodings/internal.js

	// == UTF16-BE codec. ==========================================================

	exports.utf16be = Utf16BECodec;
	function Utf16BECodec() {
	}

	Utf16BECodec.prototype.encoder = Utf16BEEncoder;
	Utf16BECodec.prototype.decoder = Utf16BEDecoder;
	Utf16BECodec.prototype.bomAware = true;


	// -- Encoding

	function Utf16BEEncoder() {
	}

	Utf16BEEncoder.prototype.write = function(str) {
	    var buf = new Buffer(str, 'ucs2');
	    for (var i = 0; i < buf.length; i += 2) {
	        var tmp = buf[i]; buf[i] = buf[i+1]; buf[i+1] = tmp;
	    }
	    return buf;
	}

	Utf16BEEncoder.prototype.end = function() {
	}


	// -- Decoding

	function Utf16BEDecoder() {
	    this.overflowByte = -1;
	}

	Utf16BEDecoder.prototype.write = function(buf) {
	    if (buf.length == 0)
	        return '';

	    var buf2 = new Buffer(buf.length + 1),
	        i = 0, j = 0;

	    if (this.overflowByte !== -1) {
	        buf2[0] = buf[0];
	        buf2[1] = this.overflowByte;
	        i = 1; j = 2;
	    }

	    for (; i < buf.length-1; i += 2, j+= 2) {
	        buf2[j] = buf[i+1];
	        buf2[j+1] = buf[i];
	    }

	    this.overflowByte = (i == buf.length-1) ? buf[buf.length-1] : -1;

	    return buf2.slice(0, j).toString('ucs2');
	}

	Utf16BEDecoder.prototype.end = function() {
	}


	// == UTF-16 codec =============================================================
	// Decoder chooses automatically from UTF-16LE and UTF-16BE using BOM and space-based heuristic.
	// Defaults to UTF-16LE, as it's prevalent and default in Node.
	// http://en.wikipedia.org/wiki/UTF-16 and http://encoding.spec.whatwg.org/#utf-16le
	// Decoder default can be changed: iconv.decode(buf, 'utf16', {defaultEncoding: 'utf-16be'});

	// Encoder uses UTF-16LE and prepends BOM (which can be overridden with addBOM: false).

	exports.utf16 = Utf16Codec;
	function Utf16Codec(codecOptions, iconv) {
	    this.iconv = iconv;
	}

	Utf16Codec.prototype.encoder = Utf16Encoder;
	Utf16Codec.prototype.decoder = Utf16Decoder;


	// -- Encoding (pass-through)

	function Utf16Encoder(options, codec) {
	    options = options || {};
	    if (options.addBOM === undefined)
	        options.addBOM = true;
	    this.encoder = codec.iconv.getEncoder('utf-16le', options);
	}

	Utf16Encoder.prototype.write = function(str) {
	    return this.encoder.write(str);
	}

	Utf16Encoder.prototype.end = function() {
	    return this.encoder.end();
	}


	// -- Decoding

	function Utf16Decoder(options, codec) {
	    this.decoder = null;
	    this.initialBytes = [];
	    this.initialBytesLen = 0;

	    this.options = options || {};
	    this.iconv = codec.iconv;
	}

	Utf16Decoder.prototype.write = function(buf) {
	    if (!this.decoder) {
	        // Codec is not chosen yet. Accumulate initial bytes.
	        this.initialBytes.push(buf);
	        this.initialBytesLen += buf.length;
	        
	        if (this.initialBytesLen < 16) // We need more bytes to use space heuristic (see below)
	            return '';

	        // We have enough bytes -> detect endianness.
	        var buf = Buffer.concat(this.initialBytes),
	            encoding = detectEncoding(buf, this.options.defaultEncoding);
	        this.decoder = this.iconv.getDecoder(encoding, this.options);
	        this.initialBytes.length = this.initialBytesLen = 0;
	    }

	    return this.decoder.write(buf);
	}

	Utf16Decoder.prototype.end = function() {
	    if (!this.decoder) {
	        var buf = Buffer.concat(this.initialBytes),
	            encoding = detectEncoding(buf, this.options.defaultEncoding);
	        this.decoder = this.iconv.getDecoder(encoding, this.options);

	        var res = this.decoder.write(buf),
	            trail = this.decoder.end();

	        return trail ? (res + trail) : res;
	    }
	    return this.decoder.end();
	}

	function detectEncoding(buf, defaultEncoding) {
	    var enc = defaultEncoding || 'utf-16le';

	    if (buf.length >= 2) {
	        // Check BOM.
	        if (buf[0] == 0xFE && buf[1] == 0xFF) // UTF-16BE BOM
	            enc = 'utf-16be';
	        else if (buf[0] == 0xFF && buf[1] == 0xFE) // UTF-16LE BOM
	            enc = 'utf-16le';
	        else {
	            // No BOM found. Try to deduce encoding from initial content.
	            // Most of the time, the content has ASCII chars (U+00**), but the opposite (U+**00) is uncommon.
	            // So, we count ASCII as if it was LE or BE, and decide from that.
	            var asciiCharsLE = 0, asciiCharsBE = 0, // Counts of chars in both positions
	                _len = Math.min(buf.length - (buf.length % 2), 64); // Len is always even.

	            for (var i = 0; i < _len; i += 2) {
	                if (buf[i] === 0 && buf[i+1] !== 0) asciiCharsBE++;
	                if (buf[i] !== 0 && buf[i+1] === 0) asciiCharsLE++;
	            }

	            if (asciiCharsBE > asciiCharsLE)
	                enc = 'utf-16be';
	            else if (asciiCharsBE < asciiCharsLE)
	                enc = 'utf-16le';
	        }
	    }

	    return enc;
	}




/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Buffer = __webpack_require__(2).Buffer;

	// UTF-7 codec, according to https://tools.ietf.org/html/rfc2152
	// See also below a UTF-7-IMAP codec, according to http://tools.ietf.org/html/rfc3501#section-5.1.3

	exports.utf7 = Utf7Codec;
	exports.unicode11utf7 = 'utf7'; // Alias UNICODE-1-1-UTF-7
	function Utf7Codec(codecOptions, iconv) {
	    this.iconv = iconv;
	};

	Utf7Codec.prototype.encoder = Utf7Encoder;
	Utf7Codec.prototype.decoder = Utf7Decoder;
	Utf7Codec.prototype.bomAware = true;


	// -- Encoding

	var nonDirectChars = /[^A-Za-z0-9'\(\),-\.\/:\? \n\r\t]+/g;

	function Utf7Encoder(options, codec) {
	    this.iconv = codec.iconv;
	}

	Utf7Encoder.prototype.write = function(str) {
	    // Naive implementation.
	    // Non-direct chars are encoded as "+<base64>-"; single "+" char is encoded as "+-".
	    return new Buffer(str.replace(nonDirectChars, function(chunk) {
	        return "+" + (chunk === '+' ? '' : 
	            this.iconv.encode(chunk, 'utf16-be').toString('base64').replace(/=+$/, '')) 
	            + "-";
	    }.bind(this)));
	}

	Utf7Encoder.prototype.end = function() {
	}


	// -- Decoding

	function Utf7Decoder(options, codec) {
	    this.iconv = codec.iconv;
	    this.inBase64 = false;
	    this.base64Accum = '';
	}

	var base64Regex = /[A-Za-z0-9\/+]/;
	var base64Chars = [];
	for (var i = 0; i < 256; i++)
	    base64Chars[i] = base64Regex.test(String.fromCharCode(i));

	var plusChar = '+'.charCodeAt(0), 
	    minusChar = '-'.charCodeAt(0),
	    andChar = '&'.charCodeAt(0);

	Utf7Decoder.prototype.write = function(buf) {
	    var res = "", lastI = 0,
	        inBase64 = this.inBase64,
	        base64Accum = this.base64Accum;

	    // The decoder is more involved as we must handle chunks in stream.

	    for (var i = 0; i < buf.length; i++) {
	        if (!inBase64) { // We're in direct mode.
	            // Write direct chars until '+'
	            if (buf[i] == plusChar) {
	                res += this.iconv.decode(buf.slice(lastI, i), "ascii"); // Write direct chars.
	                lastI = i+1;
	                inBase64 = true;
	            }
	        } else { // We decode base64.
	            if (!base64Chars[buf[i]]) { // Base64 ended.
	                if (i == lastI && buf[i] == minusChar) {// "+-" -> "+"
	                    res += "+";
	                } else {
	                    var b64str = base64Accum + buf.slice(lastI, i).toString();
	                    res += this.iconv.decode(new Buffer(b64str, 'base64'), "utf16-be");
	                }

	                if (buf[i] != minusChar) // Minus is absorbed after base64.
	                    i--;

	                lastI = i+1;
	                inBase64 = false;
	                base64Accum = '';
	            }
	        }
	    }

	    if (!inBase64) {
	        res += this.iconv.decode(buf.slice(lastI), "ascii"); // Write direct chars.
	    } else {
	        var b64str = base64Accum + buf.slice(lastI).toString();

	        var canBeDecoded = b64str.length - (b64str.length % 8); // Minimal chunk: 2 quads -> 2x3 bytes -> 3 chars.
	        base64Accum = b64str.slice(canBeDecoded); // The rest will be decoded in future.
	        b64str = b64str.slice(0, canBeDecoded);

	        res += this.iconv.decode(new Buffer(b64str, 'base64'), "utf16-be");
	    }

	    this.inBase64 = inBase64;
	    this.base64Accum = base64Accum;

	    return res;
	}

	Utf7Decoder.prototype.end = function() {
	    var res = "";
	    if (this.inBase64 && this.base64Accum.length > 0)
	        res = this.iconv.decode(new Buffer(this.base64Accum, 'base64'), "utf16-be");

	    this.inBase64 = false;
	    this.base64Accum = '';
	    return res;
	}


	// UTF-7-IMAP codec.
	// RFC3501 Sec. 5.1.3 Modified UTF-7 (http://tools.ietf.org/html/rfc3501#section-5.1.3)
	// Differences:
	//  * Base64 part is started by "&" instead of "+"
	//  * Direct characters are 0x20-0x7E, except "&" (0x26)
	//  * In Base64, "," is used instead of "/"
	//  * Base64 must not be used to represent direct characters.
	//  * No implicit shift back from Base64 (should always end with '-')
	//  * String must end in non-shifted position.
	//  * "-&" while in base64 is not allowed.


	exports.utf7imap = Utf7IMAPCodec;
	function Utf7IMAPCodec(codecOptions, iconv) {
	    this.iconv = iconv;
	};

	Utf7IMAPCodec.prototype.encoder = Utf7IMAPEncoder;
	Utf7IMAPCodec.prototype.decoder = Utf7IMAPDecoder;
	Utf7IMAPCodec.prototype.bomAware = true;


	// -- Encoding

	function Utf7IMAPEncoder(options, codec) {
	    this.iconv = codec.iconv;
	    this.inBase64 = false;
	    this.base64Accum = new Buffer(6);
	    this.base64AccumIdx = 0;
	}

	Utf7IMAPEncoder.prototype.write = function(str) {
	    var inBase64 = this.inBase64,
	        base64Accum = this.base64Accum,
	        base64AccumIdx = this.base64AccumIdx,
	        buf = new Buffer(str.length*5 + 10), bufIdx = 0;

	    for (var i = 0; i < str.length; i++) {
	        var uChar = str.charCodeAt(i);
	        if (0x20 <= uChar && uChar <= 0x7E) { // Direct character or '&'.
	            if (inBase64) {
	                if (base64AccumIdx > 0) {
	                    bufIdx += buf.write(base64Accum.slice(0, base64AccumIdx).toString('base64').replace(/\//g, ',').replace(/=+$/, ''), bufIdx);
	                    base64AccumIdx = 0;
	                }

	                buf[bufIdx++] = minusChar; // Write '-', then go to direct mode.
	                inBase64 = false;
	            }

	            if (!inBase64) {
	                buf[bufIdx++] = uChar; // Write direct character

	                if (uChar === andChar)  // Ampersand -> '&-'
	                    buf[bufIdx++] = minusChar;
	            }

	        } else { // Non-direct character
	            if (!inBase64) {
	                buf[bufIdx++] = andChar; // Write '&', then go to base64 mode.
	                inBase64 = true;
	            }
	            if (inBase64) {
	                base64Accum[base64AccumIdx++] = uChar >> 8;
	                base64Accum[base64AccumIdx++] = uChar & 0xFF;

	                if (base64AccumIdx == base64Accum.length) {
	                    bufIdx += buf.write(base64Accum.toString('base64').replace(/\//g, ','), bufIdx);
	                    base64AccumIdx = 0;
	                }
	            }
	        }
	    }

	    this.inBase64 = inBase64;
	    this.base64AccumIdx = base64AccumIdx;

	    return buf.slice(0, bufIdx);
	}

	Utf7IMAPEncoder.prototype.end = function() {
	    var buf = new Buffer(10), bufIdx = 0;
	    if (this.inBase64) {
	        if (this.base64AccumIdx > 0) {
	            bufIdx += buf.write(this.base64Accum.slice(0, this.base64AccumIdx).toString('base64').replace(/\//g, ',').replace(/=+$/, ''), bufIdx);
	            this.base64AccumIdx = 0;
	        }

	        buf[bufIdx++] = minusChar; // Write '-', then go to direct mode.
	        this.inBase64 = false;
	    }

	    return buf.slice(0, bufIdx);
	}


	// -- Decoding

	function Utf7IMAPDecoder(options, codec) {
	    this.iconv = codec.iconv;
	    this.inBase64 = false;
	    this.base64Accum = '';
	}

	var base64IMAPChars = base64Chars.slice();
	base64IMAPChars[','.charCodeAt(0)] = true;

	Utf7IMAPDecoder.prototype.write = function(buf) {
	    var res = "", lastI = 0,
	        inBase64 = this.inBase64,
	        base64Accum = this.base64Accum;

	    // The decoder is more involved as we must handle chunks in stream.
	    // It is forgiving, closer to standard UTF-7 (for example, '-' is optional at the end).

	    for (var i = 0; i < buf.length; i++) {
	        if (!inBase64) { // We're in direct mode.
	            // Write direct chars until '&'
	            if (buf[i] == andChar) {
	                res += this.iconv.decode(buf.slice(lastI, i), "ascii"); // Write direct chars.
	                lastI = i+1;
	                inBase64 = true;
	            }
	        } else { // We decode base64.
	            if (!base64IMAPChars[buf[i]]) { // Base64 ended.
	                if (i == lastI && buf[i] == minusChar) { // "&-" -> "&"
	                    res += "&";
	                } else {
	                    var b64str = base64Accum + buf.slice(lastI, i).toString().replace(/,/g, '/');
	                    res += this.iconv.decode(new Buffer(b64str, 'base64'), "utf16-be");
	                }

	                if (buf[i] != minusChar) // Minus may be absorbed after base64.
	                    i--;

	                lastI = i+1;
	                inBase64 = false;
	                base64Accum = '';
	            }
	        }
	    }

	    if (!inBase64) {
	        res += this.iconv.decode(buf.slice(lastI), "ascii"); // Write direct chars.
	    } else {
	        var b64str = base64Accum + buf.slice(lastI).toString().replace(/,/g, '/');

	        var canBeDecoded = b64str.length - (b64str.length % 8); // Minimal chunk: 2 quads -> 2x3 bytes -> 3 chars.
	        base64Accum = b64str.slice(canBeDecoded); // The rest will be decoded in future.
	        b64str = b64str.slice(0, canBeDecoded);

	        res += this.iconv.decode(new Buffer(b64str, 'base64'), "utf16-be");
	    }

	    this.inBase64 = inBase64;
	    this.base64Accum = base64Accum;

	    return res;
	}

	Utf7IMAPDecoder.prototype.end = function() {
	    var res = "";
	    if (this.inBase64 && this.base64Accum.length > 0)
	        res = this.iconv.decode(new Buffer(this.base64Accum, 'base64'), "utf16-be");

	    this.inBase64 = false;
	    this.base64Accum = '';
	    return res;
	}




/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Buffer = __webpack_require__(2).Buffer;

	// Single-byte codec. Needs a 'chars' string parameter that contains 256 or 128 chars that
	// correspond to encoded bytes (if 128 - then lower half is ASCII). 

	exports._sbcs = SBCSCodec;
	function SBCSCodec(codecOptions, iconv) {
	    if (!codecOptions)
	        throw new Error("SBCS codec is called without the data.")
	    
	    // Prepare char buffer for decoding.
	    if (!codecOptions.chars || (codecOptions.chars.length !== 128 && codecOptions.chars.length !== 256))
	        throw new Error("Encoding '"+codecOptions.type+"' has incorrect 'chars' (must be of len 128 or 256)");
	    
	    if (codecOptions.chars.length === 128) {
	        var asciiString = "";
	        for (var i = 0; i < 128; i++)
	            asciiString += String.fromCharCode(i);
	        codecOptions.chars = asciiString + codecOptions.chars;
	    }

	    this.decodeBuf = new Buffer(codecOptions.chars, 'ucs2');
	    
	    // Encoding buffer.
	    var encodeBuf = new Buffer(65536);
	    encodeBuf.fill(iconv.defaultCharSingleByte.charCodeAt(0));

	    for (var i = 0; i < codecOptions.chars.length; i++)
	        encodeBuf[codecOptions.chars.charCodeAt(i)] = i;

	    this.encodeBuf = encodeBuf;
	}

	SBCSCodec.prototype.encoder = SBCSEncoder;
	SBCSCodec.prototype.decoder = SBCSDecoder;


	function SBCSEncoder(options, codec) {
	    this.encodeBuf = codec.encodeBuf;
	}

	SBCSEncoder.prototype.write = function(str) {
	    var buf = new Buffer(str.length);
	    for (var i = 0; i < str.length; i++)
	        buf[i] = this.encodeBuf[str.charCodeAt(i)];
	    
	    return buf;
	}

	SBCSEncoder.prototype.end = function() {
	}


	function SBCSDecoder(options, codec) {
	    this.decodeBuf = codec.decodeBuf;
	}

	SBCSDecoder.prototype.write = function(buf) {
	    // Strings are immutable in JS -> we use ucs2 buffer to speed up computations.
	    var decodeBuf = this.decodeBuf;
	    var newBuf = new Buffer(buf.length*2);
	    var idx1 = 0, idx2 = 0;
	    for (var i = 0; i < buf.length; i++) {
	        idx1 = buf[i]*2; idx2 = i*2;
	        newBuf[idx2] = decodeBuf[idx1];
	        newBuf[idx2+1] = decodeBuf[idx1+1];
	    }
	    return newBuf.toString('ucs2');
	}

	SBCSDecoder.prototype.end = function() {
	}


/***/ }),
/* 94 */
/***/ (function(module, exports) {

	"use strict";

	// Manually added data to be used by sbcs codec in addition to generated one.

	module.exports = {
	    // Not supported by iconv, not sure why.
	    "10029": "maccenteuro",
	    "maccenteuro": {
	        "type": "_sbcs",
	        "chars": "ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ"
	    },

	    "808": "cp808",
	    "ibm808": "cp808",
	    "cp808": {
	        "type": "_sbcs",
	        "chars": "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёЄєЇїЎў°∙·√№€■ "
	    },

	    // Aliases of generated encodings.
	    "ascii8bit": "ascii",
	    "usascii": "ascii",
	    "ansix34": "ascii",
	    "ansix341968": "ascii",
	    "ansix341986": "ascii",
	    "csascii": "ascii",
	    "cp367": "ascii",
	    "ibm367": "ascii",
	    "isoir6": "ascii",
	    "iso646us": "ascii",
	    "iso646irv": "ascii",
	    "us": "ascii",

	    "latin1": "iso88591",
	    "latin2": "iso88592",
	    "latin3": "iso88593",
	    "latin4": "iso88594",
	    "latin5": "iso88599",
	    "latin6": "iso885910",
	    "latin7": "iso885913",
	    "latin8": "iso885914",
	    "latin9": "iso885915",
	    "latin10": "iso885916",

	    "csisolatin1": "iso88591",
	    "csisolatin2": "iso88592",
	    "csisolatin3": "iso88593",
	    "csisolatin4": "iso88594",
	    "csisolatincyrillic": "iso88595",
	    "csisolatinarabic": "iso88596",
	    "csisolatingreek" : "iso88597",
	    "csisolatinhebrew": "iso88598",
	    "csisolatin5": "iso88599",
	    "csisolatin6": "iso885910",

	    "l1": "iso88591",
	    "l2": "iso88592",
	    "l3": "iso88593",
	    "l4": "iso88594",
	    "l5": "iso88599",
	    "l6": "iso885910",
	    "l7": "iso885913",
	    "l8": "iso885914",
	    "l9": "iso885915",
	    "l10": "iso885916",

	    "isoir14": "iso646jp",
	    "isoir57": "iso646cn",
	    "isoir100": "iso88591",
	    "isoir101": "iso88592",
	    "isoir109": "iso88593",
	    "isoir110": "iso88594",
	    "isoir144": "iso88595",
	    "isoir127": "iso88596",
	    "isoir126": "iso88597",
	    "isoir138": "iso88598",
	    "isoir148": "iso88599",
	    "isoir157": "iso885910",
	    "isoir166": "tis620",
	    "isoir179": "iso885913",
	    "isoir199": "iso885914",
	    "isoir203": "iso885915",
	    "isoir226": "iso885916",

	    "cp819": "iso88591",
	    "ibm819": "iso88591",

	    "cyrillic": "iso88595",

	    "arabic": "iso88596",
	    "arabic8": "iso88596",
	    "ecma114": "iso88596",
	    "asmo708": "iso88596",

	    "greek" : "iso88597",
	    "greek8" : "iso88597",
	    "ecma118" : "iso88597",
	    "elot928" : "iso88597",

	    "hebrew": "iso88598",
	    "hebrew8": "iso88598",

	    "turkish": "iso88599",
	    "turkish8": "iso88599",

	    "thai": "iso885911",
	    "thai8": "iso885911",

	    "celtic": "iso885914",
	    "celtic8": "iso885914",
	    "isoceltic": "iso885914",

	    "tis6200": "tis620",
	    "tis62025291": "tis620",
	    "tis62025330": "tis620",

	    "10000": "macroman",
	    "10006": "macgreek",
	    "10007": "maccyrillic",
	    "10079": "maciceland",
	    "10081": "macturkish",

	    "cspc8codepage437": "cp437",
	    "cspc775baltic": "cp775",
	    "cspc850multilingual": "cp850",
	    "cspcp852": "cp852",
	    "cspc862latinhebrew": "cp862",
	    "cpgr": "cp869",

	    "msee": "cp1250",
	    "mscyrl": "cp1251",
	    "msansi": "cp1252",
	    "msgreek": "cp1253",
	    "msturk": "cp1254",
	    "mshebr": "cp1255",
	    "msarab": "cp1256",
	    "winbaltrim": "cp1257",

	    "cp20866": "koi8r",
	    "20866": "koi8r",
	    "ibm878": "koi8r",
	    "cskoi8r": "koi8r",

	    "cp21866": "koi8u",
	    "21866": "koi8u",
	    "ibm1168": "koi8u",

	    "strk10482002": "rk1048",

	    "tcvn5712": "tcvn",
	    "tcvn57121": "tcvn",

	    "gb198880": "iso646cn",
	    "cn": "iso646cn",

	    "csiso14jisc6220ro": "iso646jp",
	    "jisc62201969ro": "iso646jp",
	    "jp": "iso646jp",

	    "cshproman8": "hproman8",
	    "r8": "hproman8",
	    "roman8": "hproman8",
	    "xroman8": "hproman8",
	    "ibm1051": "hproman8",

	    "mac": "macintosh",
	    "csmacintosh": "macintosh",
	};



/***/ }),
/* 95 */
/***/ (function(module, exports) {

	"use strict";

	// Generated data for sbcs codec. Don't edit manually. Regenerate using generation/gen-sbcs.js script.
	module.exports = {
	  "437": "cp437",
	  "737": "cp737",
	  "775": "cp775",
	  "850": "cp850",
	  "852": "cp852",
	  "855": "cp855",
	  "856": "cp856",
	  "857": "cp857",
	  "858": "cp858",
	  "860": "cp860",
	  "861": "cp861",
	  "862": "cp862",
	  "863": "cp863",
	  "864": "cp864",
	  "865": "cp865",
	  "866": "cp866",
	  "869": "cp869",
	  "874": "windows874",
	  "922": "cp922",
	  "1046": "cp1046",
	  "1124": "cp1124",
	  "1125": "cp1125",
	  "1129": "cp1129",
	  "1133": "cp1133",
	  "1161": "cp1161",
	  "1162": "cp1162",
	  "1163": "cp1163",
	  "1250": "windows1250",
	  "1251": "windows1251",
	  "1252": "windows1252",
	  "1253": "windows1253",
	  "1254": "windows1254",
	  "1255": "windows1255",
	  "1256": "windows1256",
	  "1257": "windows1257",
	  "1258": "windows1258",
	  "28591": "iso88591",
	  "28592": "iso88592",
	  "28593": "iso88593",
	  "28594": "iso88594",
	  "28595": "iso88595",
	  "28596": "iso88596",
	  "28597": "iso88597",
	  "28598": "iso88598",
	  "28599": "iso88599",
	  "28600": "iso885910",
	  "28601": "iso885911",
	  "28603": "iso885913",
	  "28604": "iso885914",
	  "28605": "iso885915",
	  "28606": "iso885916",
	  "windows874": {
	    "type": "_sbcs",
	    "chars": "€����…�����������‘’“”•–—�������� กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����"
	  },
	  "win874": "windows874",
	  "cp874": "windows874",
	  "windows1250": {
	    "type": "_sbcs",
	    "chars": "€�‚�„…†‡�‰Š‹ŚŤŽŹ�‘’“”•–—�™š›śťžź ˇ˘Ł¤Ą¦§¨©Ş«¬­®Ż°±˛ł´µ¶·¸ąş»Ľ˝ľżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖ×ŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőö÷řůúűüýţ˙"
	  },
	  "win1250": "windows1250",
	  "cp1250": "windows1250",
	  "windows1251": {
	    "type": "_sbcs",
	    "chars": "ЂЃ‚ѓ„…†‡€‰Љ‹ЊЌЋЏђ‘’“”•–—�™љ›њќћџ ЎўЈ¤Ґ¦§Ё©Є«¬­®Ї°±Ііґµ¶·ё№є»јЅѕїАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя"
	  },
	  "win1251": "windows1251",
	  "cp1251": "windows1251",
	  "windows1252": {
	    "type": "_sbcs",
	    "chars": "€�‚ƒ„…†‡ˆ‰Š‹Œ�Ž��‘’“”•–—˜™š›œ�žŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ"
	  },
	  "win1252": "windows1252",
	  "cp1252": "windows1252",
	  "windows1253": {
	    "type": "_sbcs",
	    "chars": "€�‚ƒ„…†‡�‰�‹�����‘’“”•–—�™�›���� ΅Ά£¤¥¦§¨©�«¬­®―°±²³΄µ¶·ΈΉΊ»Ό½ΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡ�ΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώ�"
	  },
	  "win1253": "windows1253",
	  "cp1253": "windows1253",
	  "windows1254": {
	    "type": "_sbcs",
	    "chars": "€�‚ƒ„…†‡ˆ‰Š‹Œ����‘’“”•–—˜™š›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏĞÑÒÓÔÕÖ×ØÙÚÛÜİŞßàáâãäåæçèéêëìíîïğñòóôõö÷øùúûüışÿ"
	  },
	  "win1254": "windows1254",
	  "cp1254": "windows1254",
	  "windows1255": {
	    "type": "_sbcs",
	    "chars": "€�‚ƒ„…†‡ˆ‰�‹�����‘’“”•–—˜™�›���� ¡¢£₪¥¦§¨©×«¬­®¯°±²³´µ¶·¸¹÷»¼½¾¿ְֱֲֳִֵֶַָֹֺֻּֽ־ֿ׀ׁׂ׃װױײ׳״�������אבגדהוזחטיךכלםמןנסעףפץצקרשת��‎‏�"
	  },
	  "win1255": "windows1255",
	  "cp1255": "windows1255",
	  "windows1256": {
	    "type": "_sbcs",
	    "chars": "€پ‚ƒ„…†‡ˆ‰ٹ‹Œچژڈگ‘’“”•–—ک™ڑ›œ‌‍ں ،¢£¤¥¦§¨©ھ«¬­®¯°±²³´µ¶·¸¹؛»¼½¾؟ہءآأؤإئابةتثجحخدذرزسشصض×طظعغـفقكàلâمنهوçèéêëىيîïًٌٍَôُِ÷ّùْûü‎‏ے"
	  },
	  "win1256": "windows1256",
	  "cp1256": "windows1256",
	  "windows1257": {
	    "type": "_sbcs",
	    "chars": "€�‚�„…†‡�‰�‹�¨ˇ¸�‘’“”•–—�™�›�¯˛� �¢£¤�¦§Ø©Ŗ«¬­®Æ°±²³´µ¶·ø¹ŗ»¼½¾æĄĮĀĆÄÅĘĒČÉŹĖĢĶĪĻŠŃŅÓŌÕÖ×ŲŁŚŪÜŻŽßąįāćäåęēčéźėģķīļšńņóōõö÷ųłśūüżž˙"
	  },
	  "win1257": "windows1257",
	  "cp1257": "windows1257",
	  "windows1258": {
	    "type": "_sbcs",
	    "chars": "€�‚ƒ„…†‡ˆ‰�‹Œ����‘’“”•–—˜™�›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ"
	  },
	  "win1258": "windows1258",
	  "cp1258": "windows1258",
	  "iso88591": {
	    "type": "_sbcs",
	    "chars": " ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ"
	  },
	  "cp28591": "iso88591",
	  "iso88592": {
	    "type": "_sbcs",
	    "chars": " Ą˘Ł¤ĽŚ§¨ŠŞŤŹ­ŽŻ°ą˛ł´ľśˇ¸šşťź˝žżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖ×ŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőö÷řůúűüýţ˙"
	  },
	  "cp28592": "iso88592",
	  "iso88593": {
	    "type": "_sbcs",
	    "chars": " Ħ˘£¤�Ĥ§¨İŞĞĴ­�Ż°ħ²³´µĥ·¸ışğĵ½�żÀÁÂ�ÄĊĈÇÈÉÊËÌÍÎÏ�ÑÒÓÔĠÖ×ĜÙÚÛÜŬŜßàáâ�äċĉçèéêëìíîï�ñòóôġö÷ĝùúûüŭŝ˙"
	  },
	  "cp28593": "iso88593",
	  "iso88594": {
	    "type": "_sbcs",
	    "chars": " ĄĸŖ¤ĨĻ§¨ŠĒĢŦ­Ž¯°ą˛ŗ´ĩļˇ¸šēģŧŊžŋĀÁÂÃÄÅÆĮČÉĘËĖÍÎĪĐŅŌĶÔÕÖ×ØŲÚÛÜŨŪßāáâãäåæįčéęëėíîīđņōķôõö÷øųúûüũū˙"
	  },
	  "cp28594": "iso88594",
	  "iso88595": {
	    "type": "_sbcs",
	    "chars": " ЁЂЃЄЅІЇЈЉЊЋЌ­ЎЏАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя№ёђѓєѕіїјљњћќ§ўџ"
	  },
	  "cp28595": "iso88595",
	  "iso88596": {
	    "type": "_sbcs",
	    "chars": " ���¤�������،­�������������؛���؟�ءآأؤإئابةتثجحخدذرزسشصضطظعغ�����ـفقكلمنهوىيًٌٍَُِّْ�������������"
	  },
	  "cp28596": "iso88596",
	  "iso88597": {
	    "type": "_sbcs",
	    "chars": " ‘’£€₯¦§¨©ͺ«¬­�―°±²³΄΅Ά·ΈΉΊ»Ό½ΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡ�ΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώ�"
	  },
	  "cp28597": "iso88597",
	  "iso88598": {
	    "type": "_sbcs",
	    "chars": " �¢£¤¥¦§¨©×«¬­®¯°±²³´µ¶·¸¹÷»¼½¾��������������������������������‗אבגדהוזחטיךכלםמןנסעףפץצקרשת��‎‏�"
	  },
	  "cp28598": "iso88598",
	  "iso88599": {
	    "type": "_sbcs",
	    "chars": " ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏĞÑÒÓÔÕÖ×ØÙÚÛÜİŞßàáâãäåæçèéêëìíîïğñòóôõö÷øùúûüışÿ"
	  },
	  "cp28599": "iso88599",
	  "iso885910": {
	    "type": "_sbcs",
	    "chars": " ĄĒĢĪĨĶ§ĻĐŠŦŽ­ŪŊ°ąēģīĩķ·ļđšŧž―ūŋĀÁÂÃÄÅÆĮČÉĘËĖÍÎÏÐŅŌÓÔÕÖŨØŲÚÛÜÝÞßāáâãäåæįčéęëėíîïðņōóôõöũøųúûüýþĸ"
	  },
	  "cp28600": "iso885910",
	  "iso885911": {
	    "type": "_sbcs",
	    "chars": " กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����"
	  },
	  "cp28601": "iso885911",
	  "iso885913": {
	    "type": "_sbcs",
	    "chars": " ”¢£¤„¦§Ø©Ŗ«¬­®Æ°±²³“µ¶·ø¹ŗ»¼½¾æĄĮĀĆÄÅĘĒČÉŹĖĢĶĪĻŠŃŅÓŌÕÖ×ŲŁŚŪÜŻŽßąįāćäåęēčéźėģķīļšńņóōõö÷ųłśūüżž’"
	  },
	  "cp28603": "iso885913",
	  "iso885914": {
	    "type": "_sbcs",
	    "chars": " Ḃḃ£ĊċḊ§Ẁ©ẂḋỲ­®ŸḞḟĠġṀṁ¶ṖẁṗẃṠỳẄẅṡÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏŴÑÒÓÔÕÖṪØÙÚÛÜÝŶßàáâãäåæçèéêëìíîïŵñòóôõöṫøùúûüýŷÿ"
	  },
	  "cp28604": "iso885914",
	  "iso885915": {
	    "type": "_sbcs",
	    "chars": " ¡¢£€¥Š§š©ª«¬­®¯°±²³Žµ¶·ž¹º»ŒœŸ¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ"
	  },
	  "cp28605": "iso885915",
	  "iso885916": {
	    "type": "_sbcs",
	    "chars": " ĄąŁ€„Š§š©Ș«Ź­źŻ°±ČłŽ”¶·žčș»ŒœŸżÀÁÂĂÄĆÆÇÈÉÊËÌÍÎÏĐŃÒÓÔŐÖŚŰÙÚÛÜĘȚßàáâăäćæçèéêëìíîïđńòóôőöśűùúûüęțÿ"
	  },
	  "cp28606": "iso885916",
	  "cp437": {
	    "type": "_sbcs",
	    "chars": "ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜ¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
	  },
	  "ibm437": "cp437",
	  "csibm437": "cp437",
	  "cp737": {
	    "type": "_sbcs",
	    "chars": "ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρσςτυφχψ░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀ωάέήϊίόύϋώΆΈΉΊΌΎΏ±≥≤ΪΫ÷≈°∙·√ⁿ²■ "
	  },
	  "ibm737": "cp737",
	  "csibm737": "cp737",
	  "cp775": {
	    "type": "_sbcs",
	    "chars": "ĆüéāäģåćłēŖŗīŹÄÅÉæÆōöĢ¢ŚśÖÜø£Ø×¤ĀĪóŻżź”¦©®¬½¼Ł«»░▒▓│┤ĄČĘĖ╣║╗╝ĮŠ┐└┴┬├─┼ŲŪ╚╔╩╦╠═╬Žąčęėįšųūž┘┌█▄▌▐▀ÓßŌŃõÕµńĶķĻļņĒŅ’­±“¾¶§÷„°∙·¹³²■ "
	  },
	  "ibm775": "cp775",
	  "csibm775": "cp775",
	  "cp850": {
	    "type": "_sbcs",
	    "chars": "ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø×ƒáíóúñÑªº¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ðÐÊËÈıÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµþÞÚÛÙýÝ¯´­±‗¾¶§÷¸°¨·¹³²■ "
	  },
	  "ibm850": "cp850",
	  "csibm850": "cp850",
	  "cp852": {
	    "type": "_sbcs",
	    "chars": "ÇüéâäůćçłëŐőîŹÄĆÉĹĺôöĽľŚśÖÜŤťŁ×čáíóúĄąŽžĘę¬źČş«»░▒▓│┤ÁÂĚŞ╣║╗╝Żż┐└┴┬├─┼Ăă╚╔╩╦╠═╬¤đĐĎËďŇÍÎě┘┌█▄ŢŮ▀ÓßÔŃńňŠšŔÚŕŰýÝţ´­˝˛ˇ˘§÷¸°¨˙űŘř■ "
	  },
	  "ibm852": "cp852",
	  "csibm852": "cp852",
	  "cp855": {
	    "type": "_sbcs",
	    "chars": "ђЂѓЃёЁєЄѕЅіІїЇјЈљЉњЊћЋќЌўЎџЏюЮъЪаАбБцЦдДеЕфФгГ«»░▒▓│┤хХиИ╣║╗╝йЙ┐└┴┬├─┼кК╚╔╩╦╠═╬¤лЛмМнНоОп┘┌█▄Пя▀ЯрРсСтТуУжЖвВьЬ№­ыЫзЗшШэЭщЩчЧ§■ "
	  },
	  "ibm855": "cp855",
	  "csibm855": "cp855",
	  "cp856": {
	    "type": "_sbcs",
	    "chars": "אבגדהוזחטיךכלםמןנסעףפץצקרשת�£�×����������®¬½¼�«»░▒▓│┤���©╣║╗╝¢¥┐└┴┬├─┼��╚╔╩╦╠═╬¤���������┘┌█▄¦�▀������µ�������¯´­±‗¾¶§÷¸°¨·¹³²■ "
	  },
	  "ibm856": "cp856",
	  "csibm856": "cp856",
	  "cp857": {
	    "type": "_sbcs",
	    "chars": "ÇüéâäàåçêëèïîıÄÅÉæÆôöòûùİÖÜø£ØŞşáíóúñÑĞğ¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ºªÊËÈ�ÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµ�×ÚÛÙìÿ¯´­±�¾¶§÷¸°¨·¹³²■ "
	  },
	  "ibm857": "cp857",
	  "csibm857": "cp857",
	  "cp858": {
	    "type": "_sbcs",
	    "chars": "ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø×ƒáíóúñÑªº¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ðÐÊËÈ€ÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµþÞÚÛÙýÝ¯´­±‗¾¶§÷¸°¨·¹³²■ "
	  },
	  "ibm858": "cp858",
	  "csibm858": "cp858",
	  "cp860": {
	    "type": "_sbcs",
	    "chars": "ÇüéâãàÁçêÊèÍÔìÃÂÉÀÈôõòÚùÌÕÜ¢£Ù₧ÓáíóúñÑªº¿Ò¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
	  },
	  "ibm860": "cp860",
	  "csibm860": "cp860",
	  "cp861": {
	    "type": "_sbcs",
	    "chars": "ÇüéâäàåçêëèÐðÞÄÅÉæÆôöþûÝýÖÜø£Ø₧ƒáíóúÁÍÓÚ¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
	  },
	  "ibm861": "cp861",
	  "csibm861": "cp861",
	  "cp862": {
	    "type": "_sbcs",
	    "chars": "אבגדהוזחטיךכלםמןנסעףפץצקרשת¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
	  },
	  "ibm862": "cp862",
	  "csibm862": "cp862",
	  "cp863": {
	    "type": "_sbcs",
	    "chars": "ÇüéâÂà¶çêëèïî‗À§ÉÈÊôËÏûù¤ÔÜ¢£ÙÛƒ¦´óú¨¸³¯Î⌐¬½¼¾«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
	  },
	  "ibm863": "cp863",
	  "csibm863": "cp863",
	  "cp864": {
	    "type": "_sbcs",
	    "chars": "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$٪&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~°·∙√▒─│┼┤┬├┴┐┌└┘β∞φ±½¼≈«»ﻷﻸ��ﻻﻼ� ­ﺂ£¤ﺄ��ﺎﺏﺕﺙ،ﺝﺡﺥ٠١٢٣٤٥٦٧٨٩ﻑ؛ﺱﺵﺹ؟¢ﺀﺁﺃﺅﻊﺋﺍﺑﺓﺗﺛﺟﺣﺧﺩﺫﺭﺯﺳﺷﺻﺿﻁﻅﻋﻏ¦¬÷×ﻉـﻓﻗﻛﻟﻣﻧﻫﻭﻯﻳﺽﻌﻎﻍﻡﹽّﻥﻩﻬﻰﻲﻐﻕﻵﻶﻝﻙﻱ■�"
	  },
	  "ibm864": "cp864",
	  "csibm864": "cp864",
	  "cp865": {
	    "type": "_sbcs",
	    "chars": "ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø₧ƒáíóúñÑªº¿⌐¬½¼¡«¤░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ "
	  },
	  "ibm865": "cp865",
	  "csibm865": "cp865",
	  "cp866": {
	    "type": "_sbcs",
	    "chars": "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёЄєЇїЎў°∙·√№¤■ "
	  },
	  "ibm866": "cp866",
	  "csibm866": "cp866",
	  "cp869": {
	    "type": "_sbcs",
	    "chars": "������Ά�·¬¦‘’Έ―ΉΊΪΌ��ΎΫ©Ώ²³ά£έήίϊΐόύΑΒΓΔΕΖΗ½ΘΙ«»░▒▓│┤ΚΛΜΝ╣║╗╝ΞΟ┐└┴┬├─┼ΠΡ╚╔╩╦╠═╬ΣΤΥΦΧΨΩαβγ┘┌█▄δε▀ζηθικλμνξοπρσςτ΄­±υφχ§ψ΅°¨ωϋΰώ■ "
	  },
	  "ibm869": "cp869",
	  "csibm869": "cp869",
	  "cp922": {
	    "type": "_sbcs",
	    "chars": " ¡¢£¤¥¦§¨©ª«¬­®‾°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏŠÑÒÓÔÕÖ×ØÙÚÛÜÝŽßàáâãäåæçèéêëìíîïšñòóôõö÷øùúûüýžÿ"
	  },
	  "ibm922": "cp922",
	  "csibm922": "cp922",
	  "cp1046": {
	    "type": "_sbcs",
	    "chars": "ﺈ×÷ﹱ■│─┐┌└┘ﹹﹻﹽﹿﹷﺊﻰﻳﻲﻎﻏﻐﻶﻸﻺﻼ ¤ﺋﺑﺗﺛﺟﺣ،­ﺧﺳ٠١٢٣٤٥٦٧٨٩ﺷ؛ﺻﺿﻊ؟ﻋءآأؤإئابةتثجحخدذرزسشصضطﻇعغﻌﺂﺄﺎﻓـفقكلمنهوىيًٌٍَُِّْﻗﻛﻟﻵﻷﻹﻻﻣﻧﻬﻩ�"
	  },
	  "ibm1046": "cp1046",
	  "csibm1046": "cp1046",
	  "cp1124": {
	    "type": "_sbcs",
	    "chars": " ЁЂҐЄЅІЇЈЉЊЋЌ­ЎЏАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя№ёђґєѕіїјљњћќ§ўџ"
	  },
	  "ibm1124": "cp1124",
	  "csibm1124": "cp1124",
	  "cp1125": {
	    "type": "_sbcs",
	    "chars": "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёҐґЄєІіЇї·√№¤■ "
	  },
	  "ibm1125": "cp1125",
	  "csibm1125": "cp1125",
	  "cp1129": {
	    "type": "_sbcs",
	    "chars": " ¡¢£¤¥¦§œ©ª«¬­®¯°±²³Ÿµ¶·Œ¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ"
	  },
	  "ibm1129": "cp1129",
	  "csibm1129": "cp1129",
	  "cp1133": {
	    "type": "_sbcs",
	    "chars": " ກຂຄງຈສຊຍດຕຖທນບປຜຝພຟມຢຣລວຫອຮ���ຯະາຳິີຶືຸູຼັົຽ���ເແໂໃໄ່້໊໋໌ໍໆ�ໜໝ₭����������������໐໑໒໓໔໕໖໗໘໙��¢¬¦�"
	  },
	  "ibm1133": "cp1133",
	  "csibm1133": "cp1133",
	  "cp1161": {
	    "type": "_sbcs",
	    "chars": "��������������������������������่กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู้๊๋€฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛¢¬¦ "
	  },
	  "ibm1161": "cp1161",
	  "csibm1161": "cp1161",
	  "cp1162": {
	    "type": "_sbcs",
	    "chars": "€…‘’“”•–— กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����"
	  },
	  "ibm1162": "cp1162",
	  "csibm1162": "cp1162",
	  "cp1163": {
	    "type": "_sbcs",
	    "chars": " ¡¢£€¥¦§œ©ª«¬­®¯°±²³Ÿµ¶·Œ¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ"
	  },
	  "ibm1163": "cp1163",
	  "csibm1163": "cp1163",
	  "maccroatian": {
	    "type": "_sbcs",
	    "chars": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®Š™´¨≠ŽØ∞±≤≥∆µ∂∑∏š∫ªºΩžø¿¡¬√ƒ≈Ć«Č… ÀÃÕŒœĐ—“”‘’÷◊�©⁄¤‹›Æ»–·‚„‰ÂćÁčÈÍÎÏÌÓÔđÒÚÛÙıˆ˜¯πË˚¸Êæˇ"
	  },
	  "maccyrillic": {
	    "type": "_sbcs",
	    "chars": "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°¢£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµ∂ЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю¤"
	  },
	  "macgreek": {
	    "type": "_sbcs",
	    "chars": "Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦­ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩάΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ�"
	  },
	  "maciceland": {
	    "type": "_sbcs",
	    "chars": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ"
	  },
	  "macroman": {
	    "type": "_sbcs",
	    "chars": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ"
	  },
	  "macromania": {
	    "type": "_sbcs",
	    "chars": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ĂŞ∞±≤≥¥µ∂∑∏π∫ªºΩăş¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›Ţţ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ"
	  },
	  "macthai": {
	    "type": "_sbcs",
	    "chars": "«»…“”�•‘’� กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู﻿​–—฿เแโใไๅๆ็่้๊๋์ํ™๏๐๑๒๓๔๕๖๗๘๙®©����"
	  },
	  "macturkish": {
	    "type": "_sbcs",
	    "chars": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙ�ˆ˜¯˘˙˚¸˝˛ˇ"
	  },
	  "macukraine": {
	    "type": "_sbcs",
	    "chars": "АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°Ґ£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµґЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю¤"
	  },
	  "koi8r": {
	    "type": "_sbcs",
	    "chars": "─│┌┐└┘├┤┬┴┼▀▄█▌▐░▒▓⌠■∙√≈≤≥ ⌡°²·÷═║╒ё╓╔╕╖╗╘╙╚╛╜╝╞╟╠╡Ё╢╣╤╥╦╧╨╩╪╫╬©юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ"
	  },
	  "koi8u": {
	    "type": "_sbcs",
	    "chars": "─│┌┐└┘├┤┬┴┼▀▄█▌▐░▒▓⌠■∙√≈≤≥ ⌡°²·÷═║╒ёє╔ії╗╘╙╚╛ґ╝╞╟╠╡ЁЄ╣ІЇ╦╧╨╩╪Ґ╬©юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ"
	  },
	  "koi8ru": {
	    "type": "_sbcs",
	    "chars": "─│┌┐└┘├┤┬┴┼▀▄█▌▐░▒▓⌠■∙√≈≤≥ ⌡°²·÷═║╒ёє╔ії╗╘╙╚╛ґў╞╟╠╡ЁЄ╣ІЇ╦╧╨╩╪ҐЎ©юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ"
	  },
	  "koi8t": {
	    "type": "_sbcs",
	    "chars": "қғ‚Ғ„…†‡�‰ҳ‹ҲҷҶ�Қ‘’“”•–—�™�›�����ӯӮё¤ӣ¦§���«¬­®�°±²Ё�Ӣ¶·�№�»���©юабцдефгхийклмнопярстужвьызшэщчъЮАБЦДЕФГХИЙКЛМНОПЯРСТУЖВЬЫЗШЭЩЧЪ"
	  },
	  "armscii8": {
	    "type": "_sbcs",
	    "chars": " �և։)(»«—.՝,-֊…՜՛՞ԱաԲբԳգԴդԵեԶզԷէԸըԹթԺժԻիԼլԽխԾծԿկՀհՁձՂղՃճՄմՅյՆնՇշՈոՉչՊպՋջՌռՍսՎվՏտՐրՑցՒւՓփՔքՕօՖֆ՚�"
	  },
	  "rk1048": {
	    "type": "_sbcs",
	    "chars": "ЂЃ‚ѓ„…†‡€‰Љ‹ЊҚҺЏђ‘’“”•–—�™љ›њқһџ ҰұӘ¤Ө¦§Ё©Ғ«¬­®Ү°±Ііөµ¶·ё№ғ»әҢңүАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя"
	  },
	  "tcvn": {
	    "type": "_sbcs",
	    "chars": "\u0000ÚỤ\u0003ỪỬỮ\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010ỨỰỲỶỸÝỴ\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÀẢÃÁẠẶẬÈẺẼÉẸỆÌỈĨÍỊÒỎÕÓỌỘỜỞỠỚỢÙỦŨ ĂÂÊÔƠƯĐăâêôơưđẶ̀̀̉̃́àảãáạẲằẳẵắẴẮẦẨẪẤỀặầẩẫấậèỂẻẽéẹềểễếệìỉỄẾỒĩíịòỔỏõóọồổỗốộờởỡớợùỖủũúụừửữứựỳỷỹýỵỐ"
	  },
	  "georgianacademy": {
	    "type": "_sbcs",
	    "chars": "‚ƒ„…†‡ˆ‰Š‹Œ‘’“”•–—˜™š›œŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿აბგდევზთიკლმნოპჟრსტუფქღყშჩცძწჭხჯჰჱჲჳჴჵჶçèéêëìíîïðñòóôõö÷øùúûüýþÿ"
	  },
	  "georgianps": {
	    "type": "_sbcs",
	    "chars": "‚ƒ„…†‡ˆ‰Š‹Œ‘’“”•–—˜™š›œŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿აბგდევზჱთიკლმნჲოპჟრსტჳუფქღყშჩცძწჭხჴჯჰჵæçèéêëìíîïðñòóôõö÷øùúûüýþÿ"
	  },
	  "pt154": {
	    "type": "_sbcs",
	    "chars": "ҖҒӮғ„…ҶҮҲүҠӢҢҚҺҸҗ‘’“”•–—ҳҷҡӣңқһҹ ЎўЈӨҘҰ§Ё©Ә«¬ӯ®Ҝ°ұІіҙө¶·ё№ә»јҪҫҝАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя"
	  },
	  "viscii": {
	    "type": "_sbcs",
	    "chars": "\u0000\u0001Ẳ\u0003\u0004ẴẪ\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013Ỷ\u0015\u0016\u0017\u0018Ỹ\u001a\u001b\u001c\u001dỴ\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ẠẮẰẶẤẦẨẬẼẸẾỀỂỄỆỐỒỔỖỘỢỚỜỞỊỎỌỈỦŨỤỲÕắằặấầẩậẽẹếềểễệốồổỗỠƠộờởịỰỨỪỬơớƯÀÁÂÃẢĂẳẵÈÉÊẺÌÍĨỳĐứÒÓÔạỷừửÙÚỹỵÝỡưàáâãảăữẫèéêẻìíĩỉđựòóôõỏọụùúũủýợỮ"
	  },
	  "iso646cn": {
	    "type": "_sbcs",
	    "chars": "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#¥%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}‾��������������������������������������������������������������������������������������������������������������������������������"
	  },
	  "iso646jp": {
	    "type": "_sbcs",
	    "chars": "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[¥]^_`abcdefghijklmnopqrstuvwxyz{|}‾��������������������������������������������������������������������������������������������������������������������������������"
	  },
	  "hproman8": {
	    "type": "_sbcs",
	    "chars": " ÀÂÈÊËÎÏ´ˋˆ¨˜ÙÛ₤¯Ýý°ÇçÑñ¡¿¤£¥§ƒ¢âêôûáéóúàèòùäëöüÅîØÆåíøæÄìÖÜÉïßÔÁÃãÐðÍÌÓÒÕõŠšÚŸÿÞþ·µ¶¾—¼½ªº«■»±�"
	  },
	  "macintosh": {
	    "type": "_sbcs",
	    "chars": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ"
	  },
	  "ascii": {
	    "type": "_sbcs",
	    "chars": "��������������������������������������������������������������������������������������������������������������������������������"
	  },
	  "tis620": {
	    "type": "_sbcs",
	    "chars": "���������������������������������กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����"
	  }
	}

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Buffer = __webpack_require__(2).Buffer;

	// Multibyte codec. In this scheme, a character is represented by 1 or more bytes.
	// Our codec supports UTF-16 surrogates, extensions for GB18030 and unicode sequences.
	// To save memory and loading time, we read table files only when requested.

	exports._dbcs = DBCSCodec;

	var UNASSIGNED = -1,
	    GB18030_CODE = -2,
	    SEQ_START  = -10,
	    NODE_START = -1000,
	    UNASSIGNED_NODE = new Array(0x100),
	    DEF_CHAR = -1;

	for (var i = 0; i < 0x100; i++)
	    UNASSIGNED_NODE[i] = UNASSIGNED;


	// Class DBCSCodec reads and initializes mapping tables.
	function DBCSCodec(codecOptions, iconv) {
	    this.encodingName = codecOptions.encodingName;
	    if (!codecOptions)
	        throw new Error("DBCS codec is called without the data.")
	    if (!codecOptions.table)
	        throw new Error("Encoding '" + this.encodingName + "' has no data.");

	    // Load tables.
	    var mappingTable = codecOptions.table();


	    // Decode tables: MBCS -> Unicode.

	    // decodeTables is a trie, encoded as an array of arrays of integers. Internal arrays are trie nodes and all have len = 256.
	    // Trie root is decodeTables[0].
	    // Values: >=  0 -> unicode character code. can be > 0xFFFF
	    //         == UNASSIGNED -> unknown/unassigned sequence.
	    //         == GB18030_CODE -> this is the end of a GB18030 4-byte sequence.
	    //         <= NODE_START -> index of the next node in our trie to process next byte.
	    //         <= SEQ_START  -> index of the start of a character code sequence, in decodeTableSeq.
	    this.decodeTables = [];
	    this.decodeTables[0] = UNASSIGNED_NODE.slice(0); // Create root node.

	    // Sometimes a MBCS char corresponds to a sequence of unicode chars. We store them as arrays of integers here. 
	    this.decodeTableSeq = [];

	    // Actual mapping tables consist of chunks. Use them to fill up decode tables.
	    for (var i = 0; i < mappingTable.length; i++)
	        this._addDecodeChunk(mappingTable[i]);

	    this.defaultCharUnicode = iconv.defaultCharUnicode;

	    
	    // Encode tables: Unicode -> DBCS.

	    // `encodeTable` is array mapping from unicode char to encoded char. All its values are integers for performance.
	    // Because it can be sparse, it is represented as array of buckets by 256 chars each. Bucket can be null.
	    // Values: >=  0 -> it is a normal char. Write the value (if <=256 then 1 byte, if <=65536 then 2 bytes, etc.).
	    //         == UNASSIGNED -> no conversion found. Output a default char.
	    //         <= SEQ_START  -> it's an index in encodeTableSeq, see below. The character starts a sequence.
	    this.encodeTable = [];
	    
	    // `encodeTableSeq` is used when a sequence of unicode characters is encoded as a single code. We use a tree of
	    // objects where keys correspond to characters in sequence and leafs are the encoded dbcs values. A special DEF_CHAR key
	    // means end of sequence (needed when one sequence is a strict subsequence of another).
	    // Objects are kept separately from encodeTable to increase performance.
	    this.encodeTableSeq = [];

	    // Some chars can be decoded, but need not be encoded.
	    var skipEncodeChars = {};
	    if (codecOptions.encodeSkipVals)
	        for (var i = 0; i < codecOptions.encodeSkipVals.length; i++) {
	            var val = codecOptions.encodeSkipVals[i];
	            if (typeof val === 'number')
	                skipEncodeChars[val] = true;
	            else
	                for (var j = val.from; j <= val.to; j++)
	                    skipEncodeChars[j] = true;
	        }
	        
	    // Use decode trie to recursively fill out encode tables.
	    this._fillEncodeTable(0, 0, skipEncodeChars);

	    // Add more encoding pairs when needed.
	    if (codecOptions.encodeAdd) {
	        for (var uChar in codecOptions.encodeAdd)
	            if (Object.prototype.hasOwnProperty.call(codecOptions.encodeAdd, uChar))
	                this._setEncodeChar(uChar.charCodeAt(0), codecOptions.encodeAdd[uChar]);
	    }

	    this.defCharSB  = this.encodeTable[0][iconv.defaultCharSingleByte.charCodeAt(0)];
	    if (this.defCharSB === UNASSIGNED) this.defCharSB = this.encodeTable[0]['?'];
	    if (this.defCharSB === UNASSIGNED) this.defCharSB = "?".charCodeAt(0);


	    // Load & create GB18030 tables when needed.
	    if (typeof codecOptions.gb18030 === 'function') {
	        this.gb18030 = codecOptions.gb18030(); // Load GB18030 ranges.

	        // Add GB18030 decode tables.
	        var thirdByteNodeIdx = this.decodeTables.length;
	        var thirdByteNode = this.decodeTables[thirdByteNodeIdx] = UNASSIGNED_NODE.slice(0);

	        var fourthByteNodeIdx = this.decodeTables.length;
	        var fourthByteNode = this.decodeTables[fourthByteNodeIdx] = UNASSIGNED_NODE.slice(0);

	        for (var i = 0x81; i <= 0xFE; i++) {
	            var secondByteNodeIdx = NODE_START - this.decodeTables[0][i];
	            var secondByteNode = this.decodeTables[secondByteNodeIdx];
	            for (var j = 0x30; j <= 0x39; j++)
	                secondByteNode[j] = NODE_START - thirdByteNodeIdx;
	        }
	        for (var i = 0x81; i <= 0xFE; i++)
	            thirdByteNode[i] = NODE_START - fourthByteNodeIdx;
	        for (var i = 0x30; i <= 0x39; i++)
	            fourthByteNode[i] = GB18030_CODE
	    }        
	}

	DBCSCodec.prototype.encoder = DBCSEncoder;
	DBCSCodec.prototype.decoder = DBCSDecoder;

	// Decoder helpers
	DBCSCodec.prototype._getDecodeTrieNode = function(addr) {
	    var bytes = [];
	    for (; addr > 0; addr >>= 8)
	        bytes.push(addr & 0xFF);
	    if (bytes.length == 0)
	        bytes.push(0);

	    var node = this.decodeTables[0];
	    for (var i = bytes.length-1; i > 0; i--) { // Traverse nodes deeper into the trie.
	        var val = node[bytes[i]];

	        if (val == UNASSIGNED) { // Create new node.
	            node[bytes[i]] = NODE_START - this.decodeTables.length;
	            this.decodeTables.push(node = UNASSIGNED_NODE.slice(0));
	        }
	        else if (val <= NODE_START) { // Existing node.
	            node = this.decodeTables[NODE_START - val];
	        }
	        else
	            throw new Error("Overwrite byte in " + this.encodingName + ", addr: " + addr.toString(16));
	    }
	    return node;
	}


	DBCSCodec.prototype._addDecodeChunk = function(chunk) {
	    // First element of chunk is the hex mbcs code where we start.
	    var curAddr = parseInt(chunk[0], 16);

	    // Choose the decoding node where we'll write our chars.
	    var writeTable = this._getDecodeTrieNode(curAddr);
	    curAddr = curAddr & 0xFF;

	    // Write all other elements of the chunk to the table.
	    for (var k = 1; k < chunk.length; k++) {
	        var part = chunk[k];
	        if (typeof part === "string") { // String, write as-is.
	            for (var l = 0; l < part.length;) {
	                var code = part.charCodeAt(l++);
	                if (0xD800 <= code && code < 0xDC00) { // Decode surrogate
	                    var codeTrail = part.charCodeAt(l++);
	                    if (0xDC00 <= codeTrail && codeTrail < 0xE000)
	                        writeTable[curAddr++] = 0x10000 + (code - 0xD800) * 0x400 + (codeTrail - 0xDC00);
	                    else
	                        throw new Error("Incorrect surrogate pair in "  + this.encodingName + " at chunk " + chunk[0]);
	                }
	                else if (0x0FF0 < code && code <= 0x0FFF) { // Character sequence (our own encoding used)
	                    var len = 0xFFF - code + 2;
	                    var seq = [];
	                    for (var m = 0; m < len; m++)
	                        seq.push(part.charCodeAt(l++)); // Simple variation: don't support surrogates or subsequences in seq.

	                    writeTable[curAddr++] = SEQ_START - this.decodeTableSeq.length;
	                    this.decodeTableSeq.push(seq);
	                }
	                else
	                    writeTable[curAddr++] = code; // Basic char
	            }
	        } 
	        else if (typeof part === "number") { // Integer, meaning increasing sequence starting with prev character.
	            var charCode = writeTable[curAddr - 1] + 1;
	            for (var l = 0; l < part; l++)
	                writeTable[curAddr++] = charCode++;
	        }
	        else
	            throw new Error("Incorrect type '" + typeof part + "' given in "  + this.encodingName + " at chunk " + chunk[0]);
	    }
	    if (curAddr > 0xFF)
	        throw new Error("Incorrect chunk in "  + this.encodingName + " at addr " + chunk[0] + ": too long" + curAddr);
	}

	// Encoder helpers
	DBCSCodec.prototype._getEncodeBucket = function(uCode) {
	    var high = uCode >> 8; // This could be > 0xFF because of astral characters.
	    if (this.encodeTable[high] === undefined)
	        this.encodeTable[high] = UNASSIGNED_NODE.slice(0); // Create bucket on demand.
	    return this.encodeTable[high];
	}

	DBCSCodec.prototype._setEncodeChar = function(uCode, dbcsCode) {
	    var bucket = this._getEncodeBucket(uCode);
	    var low = uCode & 0xFF;
	    if (bucket[low] <= SEQ_START)
	        this.encodeTableSeq[SEQ_START-bucket[low]][DEF_CHAR] = dbcsCode; // There's already a sequence, set a single-char subsequence of it.
	    else if (bucket[low] == UNASSIGNED)
	        bucket[low] = dbcsCode;
	}

	DBCSCodec.prototype._setEncodeSequence = function(seq, dbcsCode) {
	    
	    // Get the root of character tree according to first character of the sequence.
	    var uCode = seq[0];
	    var bucket = this._getEncodeBucket(uCode);
	    var low = uCode & 0xFF;

	    var node;
	    if (bucket[low] <= SEQ_START) {
	        // There's already a sequence with  - use it.
	        node = this.encodeTableSeq[SEQ_START-bucket[low]];
	    }
	    else {
	        // There was no sequence object - allocate a new one.
	        node = {};
	        if (bucket[low] !== UNASSIGNED) node[DEF_CHAR] = bucket[low]; // If a char was set before - make it a single-char subsequence.
	        bucket[low] = SEQ_START - this.encodeTableSeq.length;
	        this.encodeTableSeq.push(node);
	    }

	    // Traverse the character tree, allocating new nodes as needed.
	    for (var j = 1; j < seq.length-1; j++) {
	        var oldVal = node[uCode];
	        if (typeof oldVal === 'object')
	            node = oldVal;
	        else {
	            node = node[uCode] = {}
	            if (oldVal !== undefined)
	                node[DEF_CHAR] = oldVal
	        }
	    }

	    // Set the leaf to given dbcsCode.
	    uCode = seq[seq.length-1];
	    node[uCode] = dbcsCode;
	}

	DBCSCodec.prototype._fillEncodeTable = function(nodeIdx, prefix, skipEncodeChars) {
	    var node = this.decodeTables[nodeIdx];
	    for (var i = 0; i < 0x100; i++) {
	        var uCode = node[i];
	        var mbCode = prefix + i;
	        if (skipEncodeChars[mbCode])
	            continue;

	        if (uCode >= 0)
	            this._setEncodeChar(uCode, mbCode);
	        else if (uCode <= NODE_START)
	            this._fillEncodeTable(NODE_START - uCode, mbCode << 8, skipEncodeChars);
	        else if (uCode <= SEQ_START)
	            this._setEncodeSequence(this.decodeTableSeq[SEQ_START - uCode], mbCode);
	    }
	}



	// == Encoder ==================================================================

	function DBCSEncoder(options, codec) {
	    // Encoder state
	    this.leadSurrogate = -1;
	    this.seqObj = undefined;
	    
	    // Static data
	    this.encodeTable = codec.encodeTable;
	    this.encodeTableSeq = codec.encodeTableSeq;
	    this.defaultCharSingleByte = codec.defCharSB;
	    this.gb18030 = codec.gb18030;
	}

	DBCSEncoder.prototype.write = function(str) {
	    var newBuf = new Buffer(str.length * (this.gb18030 ? 4 : 3)), 
	        leadSurrogate = this.leadSurrogate,
	        seqObj = this.seqObj, nextChar = -1,
	        i = 0, j = 0;

	    while (true) {
	        // 0. Get next character.
	        if (nextChar === -1) {
	            if (i == str.length) break;
	            var uCode = str.charCodeAt(i++);
	        }
	        else {
	            var uCode = nextChar;
	            nextChar = -1;    
	        }

	        // 1. Handle surrogates.
	        if (0xD800 <= uCode && uCode < 0xE000) { // Char is one of surrogates.
	            if (uCode < 0xDC00) { // We've got lead surrogate.
	                if (leadSurrogate === -1) {
	                    leadSurrogate = uCode;
	                    continue;
	                } else {
	                    leadSurrogate = uCode;
	                    // Double lead surrogate found.
	                    uCode = UNASSIGNED;
	                }
	            } else { // We've got trail surrogate.
	                if (leadSurrogate !== -1) {
	                    uCode = 0x10000 + (leadSurrogate - 0xD800) * 0x400 + (uCode - 0xDC00);
	                    leadSurrogate = -1;
	                } else {
	                    // Incomplete surrogate pair - only trail surrogate found.
	                    uCode = UNASSIGNED;
	                }
	                
	            }
	        }
	        else if (leadSurrogate !== -1) {
	            // Incomplete surrogate pair - only lead surrogate found.
	            nextChar = uCode; uCode = UNASSIGNED; // Write an error, then current char.
	            leadSurrogate = -1;
	        }

	        // 2. Convert uCode character.
	        var dbcsCode = UNASSIGNED;
	        if (seqObj !== undefined && uCode != UNASSIGNED) { // We are in the middle of the sequence
	            var resCode = seqObj[uCode];
	            if (typeof resCode === 'object') { // Sequence continues.
	                seqObj = resCode;
	                continue;

	            } else if (typeof resCode == 'number') { // Sequence finished. Write it.
	                dbcsCode = resCode;

	            } else if (resCode == undefined) { // Current character is not part of the sequence.

	                // Try default character for this sequence
	                resCode = seqObj[DEF_CHAR];
	                if (resCode !== undefined) {
	                    dbcsCode = resCode; // Found. Write it.
	                    nextChar = uCode; // Current character will be written too in the next iteration.

	                } else {
	                    // TODO: What if we have no default? (resCode == undefined)
	                    // Then, we should write first char of the sequence as-is and try the rest recursively.
	                    // Didn't do it for now because no encoding has this situation yet.
	                    // Currently, just skip the sequence and write current char.
	                }
	            }
	            seqObj = undefined;
	        }
	        else if (uCode >= 0) {  // Regular character
	            var subtable = this.encodeTable[uCode >> 8];
	            if (subtable !== undefined)
	                dbcsCode = subtable[uCode & 0xFF];
	            
	            if (dbcsCode <= SEQ_START) { // Sequence start
	                seqObj = this.encodeTableSeq[SEQ_START-dbcsCode];
	                continue;
	            }

	            if (dbcsCode == UNASSIGNED && this.gb18030) {
	                // Use GB18030 algorithm to find character(s) to write.
	                var idx = findIdx(this.gb18030.uChars, uCode);
	                if (idx != -1) {
	                    var dbcsCode = this.gb18030.gbChars[idx] + (uCode - this.gb18030.uChars[idx]);
	                    newBuf[j++] = 0x81 + Math.floor(dbcsCode / 12600); dbcsCode = dbcsCode % 12600;
	                    newBuf[j++] = 0x30 + Math.floor(dbcsCode / 1260); dbcsCode = dbcsCode % 1260;
	                    newBuf[j++] = 0x81 + Math.floor(dbcsCode / 10); dbcsCode = dbcsCode % 10;
	                    newBuf[j++] = 0x30 + dbcsCode;
	                    continue;
	                }
	            }
	        }

	        // 3. Write dbcsCode character.
	        if (dbcsCode === UNASSIGNED)
	            dbcsCode = this.defaultCharSingleByte;
	        
	        if (dbcsCode < 0x100) {
	            newBuf[j++] = dbcsCode;
	        }
	        else if (dbcsCode < 0x10000) {
	            newBuf[j++] = dbcsCode >> 8;   // high byte
	            newBuf[j++] = dbcsCode & 0xFF; // low byte
	        }
	        else {
	            newBuf[j++] = dbcsCode >> 16;
	            newBuf[j++] = (dbcsCode >> 8) & 0xFF;
	            newBuf[j++] = dbcsCode & 0xFF;
	        }
	    }

	    this.seqObj = seqObj;
	    this.leadSurrogate = leadSurrogate;
	    return newBuf.slice(0, j);
	}

	DBCSEncoder.prototype.end = function() {
	    if (this.leadSurrogate === -1 && this.seqObj === undefined)
	        return; // All clean. Most often case.

	    var newBuf = new Buffer(10), j = 0;

	    if (this.seqObj) { // We're in the sequence.
	        var dbcsCode = this.seqObj[DEF_CHAR];
	        if (dbcsCode !== undefined) { // Write beginning of the sequence.
	            if (dbcsCode < 0x100) {
	                newBuf[j++] = dbcsCode;
	            }
	            else {
	                newBuf[j++] = dbcsCode >> 8;   // high byte
	                newBuf[j++] = dbcsCode & 0xFF; // low byte
	            }
	        } else {
	            // See todo above.
	        }
	        this.seqObj = undefined;
	    }

	    if (this.leadSurrogate !== -1) {
	        // Incomplete surrogate pair - only lead surrogate found.
	        newBuf[j++] = this.defaultCharSingleByte;
	        this.leadSurrogate = -1;
	    }
	    
	    return newBuf.slice(0, j);
	}

	// Export for testing
	DBCSEncoder.prototype.findIdx = findIdx;


	// == Decoder ==================================================================

	function DBCSDecoder(options, codec) {
	    // Decoder state
	    this.nodeIdx = 0;
	    this.prevBuf = new Buffer(0);

	    // Static data
	    this.decodeTables = codec.decodeTables;
	    this.decodeTableSeq = codec.decodeTableSeq;
	    this.defaultCharUnicode = codec.defaultCharUnicode;
	    this.gb18030 = codec.gb18030;
	}

	DBCSDecoder.prototype.write = function(buf) {
	    var newBuf = new Buffer(buf.length*2),
	        nodeIdx = this.nodeIdx, 
	        prevBuf = this.prevBuf, prevBufOffset = this.prevBuf.length,
	        seqStart = -this.prevBuf.length, // idx of the start of current parsed sequence.
	        uCode;

	    if (prevBufOffset > 0) // Make prev buf overlap a little to make it easier to slice later.
	        prevBuf = Buffer.concat([prevBuf, buf.slice(0, 10)]);
	    
	    for (var i = 0, j = 0; i < buf.length; i++) {
	        var curByte = (i >= 0) ? buf[i] : prevBuf[i + prevBufOffset];

	        // Lookup in current trie node.
	        var uCode = this.decodeTables[nodeIdx][curByte];

	        if (uCode >= 0) { 
	            // Normal character, just use it.
	        }
	        else if (uCode === UNASSIGNED) { // Unknown char.
	            // TODO: Callback with seq.
	            //var curSeq = (seqStart >= 0) ? buf.slice(seqStart, i+1) : prevBuf.slice(seqStart + prevBufOffset, i+1 + prevBufOffset);
	            i = seqStart; // Try to parse again, after skipping first byte of the sequence ('i' will be incremented by 'for' cycle).
	            uCode = this.defaultCharUnicode.charCodeAt(0);
	        }
	        else if (uCode === GB18030_CODE) {
	            var curSeq = (seqStart >= 0) ? buf.slice(seqStart, i+1) : prevBuf.slice(seqStart + prevBufOffset, i+1 + prevBufOffset);
	            var ptr = (curSeq[0]-0x81)*12600 + (curSeq[1]-0x30)*1260 + (curSeq[2]-0x81)*10 + (curSeq[3]-0x30);
	            var idx = findIdx(this.gb18030.gbChars, ptr);
	            uCode = this.gb18030.uChars[idx] + ptr - this.gb18030.gbChars[idx];
	        }
	        else if (uCode <= NODE_START) { // Go to next trie node.
	            nodeIdx = NODE_START - uCode;
	            continue;
	        }
	        else if (uCode <= SEQ_START) { // Output a sequence of chars.
	            var seq = this.decodeTableSeq[SEQ_START - uCode];
	            for (var k = 0; k < seq.length - 1; k++) {
	                uCode = seq[k];
	                newBuf[j++] = uCode & 0xFF;
	                newBuf[j++] = uCode >> 8;
	            }
	            uCode = seq[seq.length-1];
	        }
	        else
	            throw new Error("iconv-lite internal error: invalid decoding table value " + uCode + " at " + nodeIdx + "/" + curByte);

	        // Write the character to buffer, handling higher planes using surrogate pair.
	        if (uCode > 0xFFFF) { 
	            uCode -= 0x10000;
	            var uCodeLead = 0xD800 + Math.floor(uCode / 0x400);
	            newBuf[j++] = uCodeLead & 0xFF;
	            newBuf[j++] = uCodeLead >> 8;

	            uCode = 0xDC00 + uCode % 0x400;
	        }
	        newBuf[j++] = uCode & 0xFF;
	        newBuf[j++] = uCode >> 8;

	        // Reset trie node.
	        nodeIdx = 0; seqStart = i+1;
	    }

	    this.nodeIdx = nodeIdx;
	    this.prevBuf = (seqStart >= 0) ? buf.slice(seqStart) : prevBuf.slice(seqStart + prevBufOffset);
	    return newBuf.slice(0, j).toString('ucs2');
	}

	DBCSDecoder.prototype.end = function() {
	    var ret = '';

	    // Try to parse all remaining chars.
	    while (this.prevBuf.length > 0) {
	        // Skip 1 character in the buffer.
	        ret += this.defaultCharUnicode;
	        var buf = this.prevBuf.slice(1);

	        // Parse remaining as usual.
	        this.prevBuf = new Buffer(0);
	        this.nodeIdx = 0;
	        if (buf.length > 0)
	            ret += this.write(buf);
	    }

	    this.nodeIdx = 0;
	    return ret;
	}

	// Binary search for GB18030. Returns largest i such that table[i] <= val.
	function findIdx(table, val) {
	    if (table[0] > val)
	        return -1;

	    var l = 0, r = table.length;
	    while (l < r-1) { // always table[l] <= val < table[r]
	        var mid = l + Math.floor((r-l+1)/2);
	        if (table[mid] <= val)
	            l = mid;
	        else
	            r = mid;
	    }
	    return l;
	}



/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	// Description of supported double byte encodings and aliases.
	// Tables are not require()-d until they are needed to speed up library load.
	// require()-s are direct to support Browserify.

	module.exports = {
	    
	    // == Japanese/ShiftJIS ====================================================
	    // All japanese encodings are based on JIS X set of standards:
	    // JIS X 0201 - Single-byte encoding of ASCII + ¥ + Kana chars at 0xA1-0xDF.
	    // JIS X 0208 - Main set of 6879 characters, placed in 94x94 plane, to be encoded by 2 bytes. 
	    //              Has several variations in 1978, 1983, 1990 and 1997.
	    // JIS X 0212 - Supplementary plane of 6067 chars in 94x94 plane. 1990. Effectively dead.
	    // JIS X 0213 - Extension and modern replacement of 0208 and 0212. Total chars: 11233.
	    //              2 planes, first is superset of 0208, second - revised 0212.
	    //              Introduced in 2000, revised 2004. Some characters are in Unicode Plane 2 (0x2xxxx)

	    // Byte encodings are:
	    //  * Shift_JIS: Compatible with 0201, uses not defined chars in top half as lead bytes for double-byte
	    //               encoding of 0208. Lead byte ranges: 0x81-0x9F, 0xE0-0xEF; Trail byte ranges: 0x40-0x7E, 0x80-0x9E, 0x9F-0xFC.
	    //               Windows CP932 is a superset of Shift_JIS. Some companies added more chars, notably KDDI.
	    //  * EUC-JP:    Up to 3 bytes per character. Used mostly on *nixes.
	    //               0x00-0x7F       - lower part of 0201
	    //               0x8E, 0xA1-0xDF - upper part of 0201
	    //               (0xA1-0xFE)x2   - 0208 plane (94x94).
	    //               0x8F, (0xA1-0xFE)x2 - 0212 plane (94x94).
	    //  * JIS X 208: 7-bit, direct encoding of 0208. Byte ranges: 0x21-0x7E (94 values). Uncommon.
	    //               Used as-is in ISO2022 family.
	    //  * ISO2022-JP: Stateful encoding, with escape sequences to switch between ASCII, 
	    //                0201-1976 Roman, 0208-1978, 0208-1983.
	    //  * ISO2022-JP-1: Adds esc seq for 0212-1990.
	    //  * ISO2022-JP-2: Adds esc seq for GB2313-1980, KSX1001-1992, ISO8859-1, ISO8859-7.
	    //  * ISO2022-JP-3: Adds esc seq for 0201-1976 Kana set, 0213-2000 Planes 1, 2.
	    //  * ISO2022-JP-2004: Adds 0213-2004 Plane 1.
	    //
	    // After JIS X 0213 appeared, Shift_JIS-2004, EUC-JISX0213 and ISO2022-JP-2004 followed, with just changing the planes.
	    //
	    // Overall, it seems that it's a mess :( http://www8.plala.or.jp/tkubota1/unicode-symbols-map2.html

	    'shiftjis': {
	        type: '_dbcs',
	        table: function() { return __webpack_require__(98) },
	        encodeAdd: {'\u00a5': 0x5C, '\u203E': 0x7E},
	        encodeSkipVals: [{from: 0xED40, to: 0xF940}],
	    },
	    'csshiftjis': 'shiftjis',
	    'mskanji': 'shiftjis',
	    'sjis': 'shiftjis',
	    'windows31j': 'shiftjis',
	    'ms31j': 'shiftjis',
	    'xsjis': 'shiftjis',
	    'windows932': 'shiftjis',
	    'ms932': 'shiftjis',
	    '932': 'shiftjis',
	    'cp932': 'shiftjis',

	    'eucjp': {
	        type: '_dbcs',
	        table: function() { return __webpack_require__(99) },
	        encodeAdd: {'\u00a5': 0x5C, '\u203E': 0x7E},
	    },

	    // TODO: KDDI extension to Shift_JIS
	    // TODO: IBM CCSID 942 = CP932, but F0-F9 custom chars and other char changes.
	    // TODO: IBM CCSID 943 = Shift_JIS = CP932 with original Shift_JIS lower 128 chars.


	    // == Chinese/GBK ==========================================================
	    // http://en.wikipedia.org/wiki/GBK
	    // We mostly implement W3C recommendation: https://www.w3.org/TR/encoding/#gbk-encoder

	    // Oldest GB2312 (1981, ~7600 chars) is a subset of CP936
	    'gb2312': 'cp936',
	    'gb231280': 'cp936',
	    'gb23121980': 'cp936',
	    'csgb2312': 'cp936',
	    'csiso58gb231280': 'cp936',
	    'euccn': 'cp936',

	    // Microsoft's CP936 is a subset and approximation of GBK.
	    'windows936': 'cp936',
	    'ms936': 'cp936',
	    '936': 'cp936',
	    'cp936': {
	        type: '_dbcs',
	        table: function() { return __webpack_require__(100) },
	    },

	    // GBK (~22000 chars) is an extension of CP936 that added user-mapped chars and some other.
	    'gbk': {
	        type: '_dbcs',
	        table: function() { return __webpack_require__(100).concat(__webpack_require__(101)) },
	    },
	    'xgbk': 'gbk',
	    'isoir58': 'gbk',

	    // GB18030 is an algorithmic extension of GBK.
	    // Main source: https://www.w3.org/TR/encoding/#gbk-encoder
	    // http://icu-project.org/docs/papers/gb18030.html
	    // http://source.icu-project.org/repos/icu/data/trunk/charset/data/xml/gb-18030-2000.xml
	    // http://www.khngai.com/chinese/charmap/tblgbk.php?page=0
	    'gb18030': {
	        type: '_dbcs',
	        table: function() { return __webpack_require__(100).concat(__webpack_require__(101)) },
	        gb18030: function() { return __webpack_require__(102) },
	        encodeSkipVals: [0x80],
	        encodeAdd: {'€': 0xA2E3},
	    },

	    'chinese': 'gb18030',


	    // == Korean ===============================================================
	    // EUC-KR, KS_C_5601 and KS X 1001 are exactly the same.
	    'windows949': 'cp949',
	    'ms949': 'cp949',
	    '949': 'cp949',
	    'cp949': {
	        type: '_dbcs',
	        table: function() { return __webpack_require__(103) },
	    },

	    'cseuckr': 'cp949',
	    'csksc56011987': 'cp949',
	    'euckr': 'cp949',
	    'isoir149': 'cp949',
	    'korean': 'cp949',
	    'ksc56011987': 'cp949',
	    'ksc56011989': 'cp949',
	    'ksc5601': 'cp949',


	    // == Big5/Taiwan/Hong Kong ================================================
	    // There are lots of tables for Big5 and cp950. Please see the following links for history:
	    // http://moztw.org/docs/big5/  http://www.haible.de/bruno/charsets/conversion-tables/Big5.html
	    // Variations, in roughly number of defined chars:
	    //  * Windows CP 950: Microsoft variant of Big5. Canonical: http://www.unicode.org/Public/MAPPINGS/VENDORS/MICSFT/WINDOWS/CP950.TXT
	    //  * Windows CP 951: Microsoft variant of Big5-HKSCS-2001. Seems to be never public. http://me.abelcheung.org/articles/research/what-is-cp951/
	    //  * Big5-2003 (Taiwan standard) almost superset of cp950.
	    //  * Unicode-at-on (UAO) / Mozilla 1.8. Falling out of use on the Web. Not supported by other browsers.
	    //  * Big5-HKSCS (-2001, -2004, -2008). Hong Kong standard. 
	    //    many unicode code points moved from PUA to Supplementary plane (U+2XXXX) over the years.
	    //    Plus, it has 4 combining sequences.
	    //    Seems that Mozilla refused to support it for 10 yrs. https://bugzilla.mozilla.org/show_bug.cgi?id=162431 https://bugzilla.mozilla.org/show_bug.cgi?id=310299
	    //    because big5-hkscs is the only encoding to include astral characters in non-algorithmic way.
	    //    Implementations are not consistent within browsers; sometimes labeled as just big5.
	    //    MS Internet Explorer switches from big5 to big5-hkscs when a patch applied.
	    //    Great discussion & recap of what's going on https://bugzilla.mozilla.org/show_bug.cgi?id=912470#c31
	    //    In the encoder, it might make sense to support encoding old PUA mappings to Big5 bytes seq-s.
	    //    Official spec: http://www.ogcio.gov.hk/en/business/tech_promotion/ccli/terms/doc/2003cmp_2008.txt
	    //                   http://www.ogcio.gov.hk/tc/business/tech_promotion/ccli/terms/doc/hkscs-2008-big5-iso.txt
	    // 
	    // Current understanding of how to deal with Big5(-HKSCS) is in the Encoding Standard, http://encoding.spec.whatwg.org/#big5-encoder
	    // Unicode mapping (http://www.unicode.org/Public/MAPPINGS/OBSOLETE/EASTASIA/OTHER/BIG5.TXT) is said to be wrong.

	    'windows950': 'cp950',
	    'ms950': 'cp950',
	    '950': 'cp950',
	    'cp950': {
	        type: '_dbcs',
	        table: function() { return __webpack_require__(104) },
	    },

	    // Big5 has many variations and is an extension of cp950. We use Encoding Standard's as a consensus.
	    'big5': 'big5hkscs',
	    'big5hkscs': {
	        type: '_dbcs',
	        table: function() { return __webpack_require__(104).concat(__webpack_require__(105)) },
	        encodeSkipVals: [0xa2cc],
	    },

	    'cnbig5': 'big5hkscs',
	    'csbig5': 'big5hkscs',
	    'xxbig5': 'big5hkscs',
	};


/***/ }),
/* 98 */
/***/ (function(module, exports) {

	module.exports = [["0","\u0000",128],["a1","｡",62],["8140","　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈",9,"＋－±×"],["8180","÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇◆□■△▲▽▼※〒→←↑↓〓"],["81b8","∈∋⊆⊇⊂⊃∪∩"],["81c8","∧∨￢⇒⇔∀∃"],["81da","∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬"],["81f0","Å‰♯♭♪†‡¶"],["81fc","◯"],["824f","０",9],["8260","Ａ",25],["8281","ａ",25],["829f","ぁ",82],["8340","ァ",62],["8380","ム",22],["839f","Α",16,"Σ",6],["83bf","α",16,"σ",6],["8440","А",5,"ЁЖ",25],["8470","а",5,"ёж",7],["8480","о",17],["849f","─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂"],["8740","①",19,"Ⅰ",9],["875f","㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡"],["877e","㍻"],["8780","〝〟№㏍℡㊤",4,"㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪"],["889f","亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭"],["8940","院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円"],["8980","園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改"],["8a40","魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫"],["8a80","橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄"],["8b40","機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救"],["8b80","朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈"],["8c40","掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨"],["8c80","劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向"],["8d40","后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降"],["8d80","項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷"],["8e40","察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止"],["8e80","死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周"],["8f40","宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳"],["8f80","準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾"],["9040","拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨"],["9080","逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線"],["9140","繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻"],["9180","操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只"],["9240","叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄"],["9280","逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓"],["9340","邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬"],["9380","凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入"],["9440","如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅"],["9480","楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美"],["9540","鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷"],["9580","斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋"],["9640","法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆"],["9680","摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒"],["9740","諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲"],["9780","沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯"],["9840","蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕"],["989f","弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲"],["9940","僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭"],["9980","凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨"],["9a40","咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸"],["9a80","噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩"],["9b40","奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀"],["9b80","它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏"],["9c40","廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠"],["9c80","怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛"],["9d40","戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫"],["9d80","捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼"],["9e40","曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎"],["9e80","梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣"],["9f40","檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯"],["9f80","麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌"],["e040","漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝"],["e080","烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱"],["e140","瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿"],["e180","痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬"],["e240","磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰"],["e280","窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆"],["e340","紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷"],["e380","縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋"],["e440","隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤"],["e480","艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈"],["e540","蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬"],["e580","蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞"],["e640","襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧"],["e680","諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊"],["e740","蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜"],["e780","轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮"],["e840","錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙"],["e880","閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰"],["e940","顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃"],["e980","騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈"],["ea40","鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯"],["ea80","黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠堯槇遙瑤凜熙"],["ed40","纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏"],["ed80","塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱"],["ee40","犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙"],["ee80","蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑"],["eeef","ⅰ",9,"￢￤＇＂"],["f040","",62],["f080","",124],["f140","",62],["f180","",124],["f240","",62],["f280","",124],["f340","",62],["f380","",124],["f440","",62],["f480","",124],["f540","",62],["f580","",124],["f640","",62],["f680","",124],["f740","",62],["f780","",124],["f840","",62],["f880","",124],["f940",""],["fa40","ⅰ",9,"Ⅰ",9,"￢￤＇＂㈱№℡∵纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊"],["fa80","兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯"],["fb40","涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神"],["fb80","祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙"],["fc40","髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑"]]

/***/ }),
/* 99 */
/***/ (function(module, exports) {

	module.exports = [["0","\u0000",127],["8ea1","｡",62],["a1a1","　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈",9,"＋－±×÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇"],["a2a1","◆□■△▲▽▼※〒→←↑↓〓"],["a2ba","∈∋⊆⊇⊂⊃∪∩"],["a2ca","∧∨￢⇒⇔∀∃"],["a2dc","∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬"],["a2f2","Å‰♯♭♪†‡¶"],["a2fe","◯"],["a3b0","０",9],["a3c1","Ａ",25],["a3e1","ａ",25],["a4a1","ぁ",82],["a5a1","ァ",85],["a6a1","Α",16,"Σ",6],["a6c1","α",16,"σ",6],["a7a1","А",5,"ЁЖ",25],["a7d1","а",5,"ёж",25],["a8a1","─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂"],["ada1","①",19,"Ⅰ",9],["adc0","㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡"],["addf","㍻〝〟№㏍℡㊤",4,"㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪"],["b0a1","亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭"],["b1a1","院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応"],["b2a1","押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改"],["b3a1","魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱"],["b4a1","粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄"],["b5a1","機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京"],["b6a1","供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈"],["b7a1","掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲"],["b8a1","検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向"],["b9a1","后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込"],["baa1","此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷"],["bba1","察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時"],["bca1","次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周"],["bda1","宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償"],["bea1","勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾"],["bfa1","拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾"],["c0a1","澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線"],["c1a1","繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎"],["c2a1","臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只"],["c3a1","叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵"],["c4a1","帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓"],["c5a1","邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到"],["c6a1","董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入"],["c7a1","如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦"],["c8a1","函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美"],["c9a1","鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服"],["caa1","福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋"],["cba1","法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満"],["cca1","漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒"],["cda1","諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃"],["cea1","痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯"],["cfa1","蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕"],["d0a1","弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲"],["d1a1","僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨"],["d2a1","辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨"],["d3a1","咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉"],["d4a1","圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩"],["d5a1","奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓"],["d6a1","屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏"],["d7a1","廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚"],["d8a1","悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛"],["d9a1","戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼"],["daa1","據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼"],["dba1","曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍"],["dca1","棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣"],["dda1","檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾"],["dea1","沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌"],["dfa1","漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼"],["e0a1","燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱"],["e1a1","瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰"],["e2a1","癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬"],["e3a1","磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐"],["e4a1","筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆"],["e5a1","紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺"],["e6a1","罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋"],["e7a1","隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙"],["e8a1","茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈"],["e9a1","蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙"],["eaa1","蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞"],["eba1","襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫"],["eca1","譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊"],["eda1","蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸"],["eea1","遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮"],["efa1","錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞"],["f0a1","陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰"],["f1a1","顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷"],["f2a1","髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈"],["f3a1","鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠"],["f4a1","堯槇遙瑤凜熙"],["f9a1","纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德"],["faa1","忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱"],["fba1","犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚"],["fca1","釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑"],["fcf1","ⅰ",9,"￢￤＇＂"],["8fa2af","˘ˇ¸˙˝¯˛˚～΄΅"],["8fa2c2","¡¦¿"],["8fa2eb","ºª©®™¤№"],["8fa6e1","ΆΈΉΊΪ"],["8fa6e7","Ό"],["8fa6e9","ΎΫ"],["8fa6ec","Ώ"],["8fa6f1","άέήίϊΐόςύϋΰώ"],["8fa7c2","Ђ",10,"ЎЏ"],["8fa7f2","ђ",10,"ўџ"],["8fa9a1","ÆĐ"],["8fa9a4","Ħ"],["8fa9a6","Ĳ"],["8fa9a8","ŁĿ"],["8fa9ab","ŊØŒ"],["8fa9af","ŦÞ"],["8fa9c1","æđðħıĳĸłŀŉŋøœßŧþ"],["8faaa1","ÁÀÄÂĂǍĀĄÅÃĆĈČÇĊĎÉÈËÊĚĖĒĘ"],["8faaba","ĜĞĢĠĤÍÌÏÎǏİĪĮĨĴĶĹĽĻŃŇŅÑÓÒÖÔǑŐŌÕŔŘŖŚŜŠŞŤŢÚÙÜÛŬǓŰŪŲŮŨǗǛǙǕŴÝŸŶŹŽŻ"],["8faba1","áàäâăǎāąåãćĉčçċďéèëêěėēęǵĝğ"],["8fabbd","ġĥíìïîǐ"],["8fabc5","īįĩĵķĺľļńňņñóòöôǒőōõŕřŗśŝšşťţúùüûŭǔűūųůũǘǜǚǖŵýÿŷźžż"],["8fb0a1","丂丄丅丌丒丟丣两丨丫丮丯丰丵乀乁乄乇乑乚乜乣乨乩乴乵乹乿亍亖亗亝亯亹仃仐仚仛仠仡仢仨仯仱仳仵份仾仿伀伂伃伈伋伌伒伕伖众伙伮伱你伳伵伷伹伻伾佀佂佈佉佋佌佒佔佖佘佟佣佪佬佮佱佷佸佹佺佽佾侁侂侄"],["8fb1a1","侅侉侊侌侎侐侒侓侔侗侙侚侞侟侲侷侹侻侼侽侾俀俁俅俆俈俉俋俌俍俏俒俜俠俢俰俲俼俽俿倀倁倄倇倊倌倎倐倓倗倘倛倜倝倞倢倧倮倰倲倳倵偀偁偂偅偆偊偌偎偑偒偓偗偙偟偠偢偣偦偧偪偭偰偱倻傁傃傄傆傊傎傏傐"],["8fb2a1","傒傓傔傖傛傜傞",4,"傪傯傰傹傺傽僀僃僄僇僌僎僐僓僔僘僜僝僟僢僤僦僨僩僯僱僶僺僾儃儆儇儈儋儌儍儎僲儐儗儙儛儜儝儞儣儧儨儬儭儯儱儳儴儵儸儹兂兊兏兓兕兗兘兟兤兦兾冃冄冋冎冘冝冡冣冭冸冺冼冾冿凂"],["8fb3a1","凈减凑凒凓凕凘凞凢凥凮凲凳凴凷刁刂刅划刓刕刖刘刢刨刱刲刵刼剅剉剕剗剘剚剜剟剠剡剦剮剷剸剹劀劂劅劊劌劓劕劖劗劘劚劜劤劥劦劧劯劰劶劷劸劺劻劽勀勄勆勈勌勏勑勔勖勛勜勡勥勨勩勪勬勰勱勴勶勷匀匃匊匋"],["8fb4a1","匌匑匓匘匛匜匞匟匥匧匨匩匫匬匭匰匲匵匼匽匾卂卌卋卙卛卡卣卥卬卭卲卹卾厃厇厈厎厓厔厙厝厡厤厪厫厯厲厴厵厷厸厺厽叀叅叏叒叓叕叚叝叞叠另叧叵吂吓吚吡吧吨吪启吱吴吵呃呄呇呍呏呞呢呤呦呧呩呫呭呮呴呿"],["8fb5a1","咁咃咅咈咉咍咑咕咖咜咟咡咦咧咩咪咭咮咱咷咹咺咻咿哆哊响哎哠哪哬哯哶哼哾哿唀唁唅唈唉唌唍唎唕唪唫唲唵唶唻唼唽啁啇啉啊啍啐啑啘啚啛啞啠啡啤啦啿喁喂喆喈喎喏喑喒喓喔喗喣喤喭喲喿嗁嗃嗆嗉嗋嗌嗎嗑嗒"],["8fb6a1","嗓嗗嗘嗛嗞嗢嗩嗶嗿嘅嘈嘊嘍",5,"嘙嘬嘰嘳嘵嘷嘹嘻嘼嘽嘿噀噁噃噄噆噉噋噍噏噔噞噠噡噢噣噦噩噭噯噱噲噵嚄嚅嚈嚋嚌嚕嚙嚚嚝嚞嚟嚦嚧嚨嚩嚫嚬嚭嚱嚳嚷嚾囅囉囊囋囏囐囌囍囙囜囝囟囡囤",4,"囱囫园"],["8fb7a1","囶囷圁圂圇圊圌圑圕圚圛圝圠圢圣圤圥圩圪圬圮圯圳圴圽圾圿坅坆坌坍坒坢坥坧坨坫坭",4,"坳坴坵坷坹坺坻坼坾垁垃垌垔垗垙垚垜垝垞垟垡垕垧垨垩垬垸垽埇埈埌埏埕埝埞埤埦埧埩埭埰埵埶埸埽埾埿堃堄堈堉埡"],["8fb8a1","堌堍堛堞堟堠堦堧堭堲堹堿塉塌塍塏塐塕塟塡塤塧塨塸塼塿墀墁墇墈墉墊墌墍墏墐墔墖墝墠墡墢墦墩墱墲壄墼壂壈壍壎壐壒壔壖壚壝壡壢壩壳夅夆夋夌夒夓夔虁夝夡夣夤夨夯夰夳夵夶夿奃奆奒奓奙奛奝奞奟奡奣奫奭"],["8fb9a1","奯奲奵奶她奻奼妋妌妎妒妕妗妟妤妧妭妮妯妰妳妷妺妼姁姃姄姈姊姍姒姝姞姟姣姤姧姮姯姱姲姴姷娀娄娌娍娎娒娓娞娣娤娧娨娪娭娰婄婅婇婈婌婐婕婞婣婥婧婭婷婺婻婾媋媐媓媖媙媜媞媟媠媢媧媬媱媲媳媵媸媺媻媿"],["8fbaa1","嫄嫆嫈嫏嫚嫜嫠嫥嫪嫮嫵嫶嫽嬀嬁嬈嬗嬴嬙嬛嬝嬡嬥嬭嬸孁孋孌孒孖孞孨孮孯孼孽孾孿宁宄宆宊宎宐宑宓宔宖宨宩宬宭宯宱宲宷宺宼寀寁寍寏寖",4,"寠寯寱寴寽尌尗尞尟尣尦尩尫尬尮尰尲尵尶屙屚屜屢屣屧屨屩"],["8fbba1","屭屰屴屵屺屻屼屽岇岈岊岏岒岝岟岠岢岣岦岪岲岴岵岺峉峋峒峝峗峮峱峲峴崁崆崍崒崫崣崤崦崧崱崴崹崽崿嵂嵃嵆嵈嵕嵑嵙嵊嵟嵠嵡嵢嵤嵪嵭嵰嵹嵺嵾嵿嶁嶃嶈嶊嶒嶓嶔嶕嶙嶛嶟嶠嶧嶫嶰嶴嶸嶹巃巇巋巐巎巘巙巠巤"],["8fbca1","巩巸巹帀帇帍帒帔帕帘帟帠帮帨帲帵帾幋幐幉幑幖幘幛幜幞幨幪",4,"幰庀庋庎庢庤庥庨庪庬庱庳庽庾庿廆廌廋廎廑廒廔廕廜廞廥廫异弆弇弈弎弙弜弝弡弢弣弤弨弫弬弮弰弴弶弻弽弿彀彄彅彇彍彐彔彘彛彠彣彤彧"],["8fbda1","彯彲彴彵彸彺彽彾徉徍徏徖徜徝徢徧徫徤徬徯徰徱徸忄忇忈忉忋忐",4,"忞忡忢忨忩忪忬忭忮忯忲忳忶忺忼怇怊怍怓怔怗怘怚怟怤怭怳怵恀恇恈恉恌恑恔恖恗恝恡恧恱恾恿悂悆悈悊悎悑悓悕悘悝悞悢悤悥您悰悱悷"],["8fbea1","悻悾惂惄惈惉惊惋惎惏惔惕惙惛惝惞惢惥惲惵惸惼惽愂愇愊愌愐",4,"愖愗愙愜愞愢愪愫愰愱愵愶愷愹慁慅慆慉慞慠慬慲慸慻慼慿憀憁憃憄憋憍憒憓憗憘憜憝憟憠憥憨憪憭憸憹憼懀懁懂懎懏懕懜懝懞懟懡懢懧懩懥"],["8fbfa1","懬懭懯戁戃戄戇戓戕戜戠戢戣戧戩戫戹戽扂扃扄扆扌扐扑扒扔扖扚扜扤扭扯扳扺扽抍抎抏抐抦抨抳抶抷抺抾抿拄拎拕拖拚拪拲拴拼拽挃挄挊挋挍挐挓挖挘挩挪挭挵挶挹挼捁捂捃捄捆捊捋捎捒捓捔捘捛捥捦捬捭捱捴捵"],["8fc0a1","捸捼捽捿掂掄掇掊掐掔掕掙掚掞掤掦掭掮掯掽揁揅揈揎揑揓揔揕揜揠揥揪揬揲揳揵揸揹搉搊搐搒搔搘搞搠搢搤搥搩搪搯搰搵搽搿摋摏摑摒摓摔摚摛摜摝摟摠摡摣摭摳摴摻摽撅撇撏撐撑撘撙撛撝撟撡撣撦撨撬撳撽撾撿"],["8fc1a1","擄擉擊擋擌擎擐擑擕擗擤擥擩擪擭擰擵擷擻擿攁攄攈攉攊攏攓攔攖攙攛攞攟攢攦攩攮攱攺攼攽敃敇敉敐敒敔敟敠敧敫敺敽斁斅斊斒斕斘斝斠斣斦斮斲斳斴斿旂旈旉旎旐旔旖旘旟旰旲旴旵旹旾旿昀昄昈昉昍昑昒昕昖昝"],["8fc2a1","昞昡昢昣昤昦昩昪昫昬昮昰昱昳昹昷晀晅晆晊晌晑晎晗晘晙晛晜晠晡曻晪晫晬晾晳晵晿晷晸晹晻暀晼暋暌暍暐暒暙暚暛暜暟暠暤暭暱暲暵暻暿曀曂曃曈曌曎曏曔曛曟曨曫曬曮曺朅朇朎朓朙朜朠朢朳朾杅杇杈杌杔杕杝"],["8fc3a1","杦杬杮杴杶杻极构枎枏枑枓枖枘枙枛枰枱枲枵枻枼枽柹柀柂柃柅柈柉柒柗柙柜柡柦柰柲柶柷桒栔栙栝栟栨栧栬栭栯栰栱栳栻栿桄桅桊桌桕桗桘桛桫桮",4,"桵桹桺桻桼梂梄梆梈梖梘梚梜梡梣梥梩梪梮梲梻棅棈棌棏"],["8fc4a1","棐棑棓棖棙棜棝棥棨棪棫棬棭棰棱棵棶棻棼棽椆椉椊椐椑椓椖椗椱椳椵椸椻楂楅楉楎楗楛楣楤楥楦楨楩楬楰楱楲楺楻楿榀榍榒榖榘榡榥榦榨榫榭榯榷榸榺榼槅槈槑槖槗槢槥槮槯槱槳槵槾樀樁樃樏樑樕樚樝樠樤樨樰樲"],["8fc5a1","樴樷樻樾樿橅橆橉橊橎橐橑橒橕橖橛橤橧橪橱橳橾檁檃檆檇檉檋檑檛檝檞檟檥檫檯檰檱檴檽檾檿櫆櫉櫈櫌櫐櫔櫕櫖櫜櫝櫤櫧櫬櫰櫱櫲櫼櫽欂欃欆欇欉欏欐欑欗欛欞欤欨欫欬欯欵欶欻欿歆歊歍歒歖歘歝歠歧歫歮歰歵歽"],["8fc6a1","歾殂殅殗殛殟殠殢殣殨殩殬殭殮殰殸殹殽殾毃毄毉毌毖毚毡毣毦毧毮毱毷毹毿氂氄氅氉氍氎氐氒氙氟氦氧氨氬氮氳氵氶氺氻氿汊汋汍汏汒汔汙汛汜汫汭汯汴汶汸汹汻沅沆沇沉沔沕沗沘沜沟沰沲沴泂泆泍泏泐泑泒泔泖"],["8fc7a1","泚泜泠泧泩泫泬泮泲泴洄洇洊洎洏洑洓洚洦洧洨汧洮洯洱洹洼洿浗浞浟浡浥浧浯浰浼涂涇涑涒涔涖涗涘涪涬涴涷涹涽涿淄淈淊淎淏淖淛淝淟淠淢淥淩淯淰淴淶淼渀渄渞渢渧渲渶渹渻渼湄湅湈湉湋湏湑湒湓湔湗湜湝湞"],["8fc8a1","湢湣湨湳湻湽溍溓溙溠溧溭溮溱溳溻溿滀滁滃滇滈滊滍滎滏滫滭滮滹滻滽漄漈漊漌漍漖漘漚漛漦漩漪漯漰漳漶漻漼漭潏潑潒潓潗潙潚潝潞潡潢潨潬潽潾澃澇澈澋澌澍澐澒澓澔澖澚澟澠澥澦澧澨澮澯澰澵澶澼濅濇濈濊"],["8fc9a1","濚濞濨濩濰濵濹濼濽瀀瀅瀆瀇瀍瀗瀠瀣瀯瀴瀷瀹瀼灃灄灈灉灊灋灔灕灝灞灎灤灥灬灮灵灶灾炁炅炆炔",4,"炛炤炫炰炱炴炷烊烑烓烔烕烖烘烜烤烺焃",4,"焋焌焏焞焠焫焭焯焰焱焸煁煅煆煇煊煋煐煒煗煚煜煞煠"],["8fcaa1","煨煹熀熅熇熌熒熚熛熠熢熯熰熲熳熺熿燀燁燄燋燌燓燖燙燚燜燸燾爀爇爈爉爓爗爚爝爟爤爫爯爴爸爹牁牂牃牅牎牏牐牓牕牖牚牜牞牠牣牨牫牮牯牱牷牸牻牼牿犄犉犍犎犓犛犨犭犮犱犴犾狁狇狉狌狕狖狘狟狥狳狴狺狻"],["8fcba1","狾猂猄猅猇猋猍猒猓猘猙猞猢猤猧猨猬猱猲猵猺猻猽獃獍獐獒獖獘獝獞獟獠獦獧獩獫獬獮獯獱獷獹獼玀玁玃玅玆玎玐玓玕玗玘玜玞玟玠玢玥玦玪玫玭玵玷玹玼玽玿珅珆珉珋珌珏珒珓珖珙珝珡珣珦珧珩珴珵珷珹珺珻珽"],["8fcca1","珿琀琁琄琇琊琑琚琛琤琦琨",9,"琹瑀瑃瑄瑆瑇瑋瑍瑑瑒瑗瑝瑢瑦瑧瑨瑫瑭瑮瑱瑲璀璁璅璆璇璉璏璐璑璒璘璙璚璜璟璠璡璣璦璨璩璪璫璮璯璱璲璵璹璻璿瓈瓉瓌瓐瓓瓘瓚瓛瓞瓟瓤瓨瓪瓫瓯瓴瓺瓻瓼瓿甆"],["8fcda1","甒甖甗甠甡甤甧甩甪甯甶甹甽甾甿畀畃畇畈畎畐畒畗畞畟畡畯畱畹",5,"疁疅疐疒疓疕疙疜疢疤疴疺疿痀痁痄痆痌痎痏痗痜痟痠痡痤痧痬痮痯痱痹瘀瘂瘃瘄瘇瘈瘊瘌瘏瘒瘓瘕瘖瘙瘛瘜瘝瘞瘣瘥瘦瘩瘭瘲瘳瘵瘸瘹"],["8fcea1","瘺瘼癊癀癁癃癄癅癉癋癕癙癟癤癥癭癮癯癱癴皁皅皌皍皕皛皜皝皟皠皢",6,"皪皭皽盁盅盉盋盌盎盔盙盠盦盨盬盰盱盶盹盼眀眆眊眎眒眔眕眗眙眚眜眢眨眭眮眯眴眵眶眹眽眾睂睅睆睊睍睎睏睒睖睗睜睞睟睠睢"],["8fcfa1","睤睧睪睬睰睲睳睴睺睽瞀瞄瞌瞍瞔瞕瞖瞚瞟瞢瞧瞪瞮瞯瞱瞵瞾矃矉矑矒矕矙矞矟矠矤矦矪矬矰矱矴矸矻砅砆砉砍砎砑砝砡砢砣砭砮砰砵砷硃硄硇硈硌硎硒硜硞硠硡硣硤硨硪确硺硾碊碏碔碘碡碝碞碟碤碨碬碭碰碱碲碳"],["8fd0a1","碻碽碿磇磈磉磌磎磒磓磕磖磤磛磟磠磡磦磪磲磳礀磶磷磺磻磿礆礌礐礚礜礞礟礠礥礧礩礭礱礴礵礻礽礿祄祅祆祊祋祏祑祔祘祛祜祧祩祫祲祹祻祼祾禋禌禑禓禔禕禖禘禛禜禡禨禩禫禯禱禴禸离秂秄秇秈秊秏秔秖秚秝秞"],["8fd1a1","秠秢秥秪秫秭秱秸秼稂稃稇稉稊稌稑稕稛稞稡稧稫稭稯稰稴稵稸稹稺穄穅穇穈穌穕穖穙穜穝穟穠穥穧穪穭穵穸穾窀窂窅窆窊窋窐窑窔窞窠窣窬窳窵窹窻窼竆竉竌竎竑竛竨竩竫竬竱竴竻竽竾笇笔笟笣笧笩笪笫笭笮笯笰"],["8fd2a1","笱笴笽笿筀筁筇筎筕筠筤筦筩筪筭筯筲筳筷箄箉箎箐箑箖箛箞箠箥箬箯箰箲箵箶箺箻箼箽篂篅篈篊篔篖篗篙篚篛篨篪篲篴篵篸篹篺篼篾簁簂簃簄簆簉簋簌簎簏簙簛簠簥簦簨簬簱簳簴簶簹簺籆籊籕籑籒籓籙",5],["8fd3a1","籡籣籧籩籭籮籰籲籹籼籽粆粇粏粔粞粠粦粰粶粷粺粻粼粿糄糇糈糉糍糏糓糔糕糗糙糚糝糦糩糫糵紃紇紈紉紏紑紒紓紖紝紞紣紦紪紭紱紼紽紾絀絁絇絈絍絑絓絗絙絚絜絝絥絧絪絰絸絺絻絿綁綂綃綅綆綈綋綌綍綑綖綗綝"],["8fd4a1","綞綦綧綪綳綶綷綹緂",4,"緌緍緎緗緙縀緢緥緦緪緫緭緱緵緶緹緺縈縐縑縕縗縜縝縠縧縨縬縭縯縳縶縿繄繅繇繎繐繒繘繟繡繢繥繫繮繯繳繸繾纁纆纇纊纍纑纕纘纚纝纞缼缻缽缾缿罃罄罇罏罒罓罛罜罝罡罣罤罥罦罭"],["8fd5a1","罱罽罾罿羀羋羍羏羐羑羖羗羜羡羢羦羪羭羴羼羿翀翃翈翎翏翛翟翣翥翨翬翮翯翲翺翽翾翿耇耈耊耍耎耏耑耓耔耖耝耞耟耠耤耦耬耮耰耴耵耷耹耺耼耾聀聄聠聤聦聭聱聵肁肈肎肜肞肦肧肫肸肹胈胍胏胒胔胕胗胘胠胭胮"],["8fd6a1","胰胲胳胶胹胺胾脃脋脖脗脘脜脞脠脤脧脬脰脵脺脼腅腇腊腌腒腗腠腡腧腨腩腭腯腷膁膐膄膅膆膋膎膖膘膛膞膢膮膲膴膻臋臃臅臊臎臏臕臗臛臝臞臡臤臫臬臰臱臲臵臶臸臹臽臿舀舃舏舓舔舙舚舝舡舢舨舲舴舺艃艄艅艆"],["8fd7a1","艋艎艏艑艖艜艠艣艧艭艴艻艽艿芀芁芃芄芇芉芊芎芑芔芖芘芚芛芠芡芣芤芧芨芩芪芮芰芲芴芷芺芼芾芿苆苐苕苚苠苢苤苨苪苭苯苶苷苽苾茀茁茇茈茊茋荔茛茝茞茟茡茢茬茭茮茰茳茷茺茼茽荂荃荄荇荍荎荑荕荖荗荰荸"],["8fd8a1","荽荿莀莂莄莆莍莒莔莕莘莙莛莜莝莦莧莩莬莾莿菀菇菉菏菐菑菔菝荓菨菪菶菸菹菼萁萆萊萏萑萕萙莭萯萹葅葇葈葊葍葏葑葒葖葘葙葚葜葠葤葥葧葪葰葳葴葶葸葼葽蒁蒅蒒蒓蒕蒞蒦蒨蒩蒪蒯蒱蒴蒺蒽蒾蓀蓂蓇蓈蓌蓏蓓"],["8fd9a1","蓜蓧蓪蓯蓰蓱蓲蓷蔲蓺蓻蓽蔂蔃蔇蔌蔎蔐蔜蔞蔢蔣蔤蔥蔧蔪蔫蔯蔳蔴蔶蔿蕆蕏",4,"蕖蕙蕜",6,"蕤蕫蕯蕹蕺蕻蕽蕿薁薅薆薉薋薌薏薓薘薝薟薠薢薥薧薴薶薷薸薼薽薾薿藂藇藊藋藎薭藘藚藟藠藦藨藭藳藶藼"],["8fdaa1","藿蘀蘄蘅蘍蘎蘐蘑蘒蘘蘙蘛蘞蘡蘧蘩蘶蘸蘺蘼蘽虀虂虆虒虓虖虗虘虙虝虠",4,"虩虬虯虵虶虷虺蚍蚑蚖蚘蚚蚜蚡蚦蚧蚨蚭蚱蚳蚴蚵蚷蚸蚹蚿蛀蛁蛃蛅蛑蛒蛕蛗蛚蛜蛠蛣蛥蛧蚈蛺蛼蛽蜄蜅蜇蜋蜎蜏蜐蜓蜔蜙蜞蜟蜡蜣"],["8fdba1","蜨蜮蜯蜱蜲蜹蜺蜼蜽蜾蝀蝃蝅蝍蝘蝝蝡蝤蝥蝯蝱蝲蝻螃",6,"螋螌螐螓螕螗螘螙螞螠螣螧螬螭螮螱螵螾螿蟁蟈蟉蟊蟎蟕蟖蟙蟚蟜蟟蟢蟣蟤蟪蟫蟭蟱蟳蟸蟺蟿蠁蠃蠆蠉蠊蠋蠐蠙蠒蠓蠔蠘蠚蠛蠜蠞蠟蠨蠭蠮蠰蠲蠵"],["8fdca1","蠺蠼衁衃衅衈衉衊衋衎衑衕衖衘衚衜衟衠衤衩衱衹衻袀袘袚袛袜袟袠袨袪袺袽袾裀裊",4,"裑裒裓裛裞裧裯裰裱裵裷褁褆褍褎褏褕褖褘褙褚褜褠褦褧褨褰褱褲褵褹褺褾襀襂襅襆襉襏襒襗襚襛襜襡襢襣襫襮襰襳襵襺"],["8fdda1","襻襼襽覉覍覐覔覕覛覜覟覠覥覰覴覵覶覷覼觔",4,"觥觩觫觭觱觳觶觹觽觿訄訅訇訏訑訒訔訕訞訠訢訤訦訫訬訯訵訷訽訾詀詃詅詇詉詍詎詓詖詗詘詜詝詡詥詧詵詶詷詹詺詻詾詿誀誃誆誋誏誐誒誖誗誙誟誧誩誮誯誳"],["8fdea1","誶誷誻誾諃諆諈諉諊諑諓諔諕諗諝諟諬諰諴諵諶諼諿謅謆謋謑謜謞謟謊謭謰謷謼譂",4,"譈譒譓譔譙譍譞譣譭譶譸譹譼譾讁讄讅讋讍讏讔讕讜讞讟谸谹谽谾豅豇豉豋豏豑豓豔豗豘豛豝豙豣豤豦豨豩豭豳豵豶豻豾貆"],["8fdfa1","貇貋貐貒貓貙貛貜貤貹貺賅賆賉賋賏賖賕賙賝賡賨賬賯賰賲賵賷賸賾賿贁贃贉贒贗贛赥赩赬赮赿趂趄趈趍趐趑趕趞趟趠趦趫趬趯趲趵趷趹趻跀跅跆跇跈跊跎跑跔跕跗跙跤跥跧跬跰趼跱跲跴跽踁踄踅踆踋踑踔踖踠踡踢"],["8fe0a1","踣踦踧踱踳踶踷踸踹踽蹀蹁蹋蹍蹎蹏蹔蹛蹜蹝蹞蹡蹢蹩蹬蹭蹯蹰蹱蹹蹺蹻躂躃躉躐躒躕躚躛躝躞躢躧躩躭躮躳躵躺躻軀軁軃軄軇軏軑軔軜軨軮軰軱軷軹軺軭輀輂輇輈輏輐輖輗輘輞輠輡輣輥輧輨輬輭輮輴輵輶輷輺轀轁"],["8fe1a1","轃轇轏轑",4,"轘轝轞轥辝辠辡辤辥辦辵辶辸达迀迁迆迊迋迍运迒迓迕迠迣迤迨迮迱迵迶迻迾适逄逈逌逘逛逨逩逯逪逬逭逳逴逷逿遃遄遌遛遝遢遦遧遬遰遴遹邅邈邋邌邎邐邕邗邘邙邛邠邡邢邥邰邲邳邴邶邽郌邾郃"],["8fe2a1","郄郅郇郈郕郗郘郙郜郝郟郥郒郶郫郯郰郴郾郿鄀鄄鄅鄆鄈鄍鄐鄔鄖鄗鄘鄚鄜鄞鄠鄥鄢鄣鄧鄩鄮鄯鄱鄴鄶鄷鄹鄺鄼鄽酃酇酈酏酓酗酙酚酛酡酤酧酭酴酹酺酻醁醃醅醆醊醎醑醓醔醕醘醞醡醦醨醬醭醮醰醱醲醳醶醻醼醽醿"],["8fe3a1","釂釃釅釓釔釗釙釚釞釤釥釩釪釬",5,"釷釹釻釽鈀鈁鈄鈅鈆鈇鈉鈊鈌鈐鈒鈓鈖鈘鈜鈝鈣鈤鈥鈦鈨鈮鈯鈰鈳鈵鈶鈸鈹鈺鈼鈾鉀鉂鉃鉆鉇鉊鉍鉎鉏鉑鉘鉙鉜鉝鉠鉡鉥鉧鉨鉩鉮鉯鉰鉵",4,"鉻鉼鉽鉿銈銉銊銍銎銒銗"],["8fe4a1","銙銟銠銤銥銧銨銫銯銲銶銸銺銻銼銽銿",4,"鋅鋆鋇鋈鋋鋌鋍鋎鋐鋓鋕鋗鋘鋙鋜鋝鋟鋠鋡鋣鋥鋧鋨鋬鋮鋰鋹鋻鋿錀錂錈錍錑錔錕錜錝錞錟錡錤錥錧錩錪錳錴錶錷鍇鍈鍉鍐鍑鍒鍕鍗鍘鍚鍞鍤鍥鍧鍩鍪鍭鍯鍰鍱鍳鍴鍶"],["8fe5a1","鍺鍽鍿鎀鎁鎂鎈鎊鎋鎍鎏鎒鎕鎘鎛鎞鎡鎣鎤鎦鎨鎫鎴鎵鎶鎺鎩鏁鏄鏅鏆鏇鏉",4,"鏓鏙鏜鏞鏟鏢鏦鏧鏹鏷鏸鏺鏻鏽鐁鐂鐄鐈鐉鐍鐎鐏鐕鐖鐗鐟鐮鐯鐱鐲鐳鐴鐻鐿鐽鑃鑅鑈鑊鑌鑕鑙鑜鑟鑡鑣鑨鑫鑭鑮鑯鑱鑲钄钃镸镹"],["8fe6a1","镾閄閈閌閍閎閝閞閟閡閦閩閫閬閴閶閺閽閿闆闈闉闋闐闑闒闓闙闚闝闞闟闠闤闦阝阞阢阤阥阦阬阱阳阷阸阹阺阼阽陁陒陔陖陗陘陡陮陴陻陼陾陿隁隂隃隄隉隑隖隚隝隟隤隥隦隩隮隯隳隺雊雒嶲雘雚雝雞雟雩雯雱雺霂"],["8fe7a1","霃霅霉霚霛霝霡霢霣霨霱霳靁靃靊靎靏靕靗靘靚靛靣靧靪靮靳靶靷靸靻靽靿鞀鞉鞕鞖鞗鞙鞚鞞鞟鞢鞬鞮鞱鞲鞵鞶鞸鞹鞺鞼鞾鞿韁韄韅韇韉韊韌韍韎韐韑韔韗韘韙韝韞韠韛韡韤韯韱韴韷韸韺頇頊頙頍頎頔頖頜頞頠頣頦"],["8fe8a1","頫頮頯頰頲頳頵頥頾顄顇顊顑顒顓顖顗顙顚顢顣顥顦顪顬颫颭颮颰颴颷颸颺颻颿飂飅飈飌飡飣飥飦飧飪飳飶餂餇餈餑餕餖餗餚餛餜餟餢餦餧餫餱",4,"餹餺餻餼饀饁饆饇饈饍饎饔饘饙饛饜饞饟饠馛馝馟馦馰馱馲馵"],["8fe9a1","馹馺馽馿駃駉駓駔駙駚駜駞駧駪駫駬駰駴駵駹駽駾騂騃騄騋騌騐騑騖騞騠騢騣騤騧騭騮騳騵騶騸驇驁驄驊驋驌驎驑驔驖驝骪骬骮骯骲骴骵骶骹骻骾骿髁髃髆髈髎髐髒髕髖髗髛髜髠髤髥髧髩髬髲髳髵髹髺髽髿",4],["8feaa1","鬄鬅鬈鬉鬋鬌鬍鬎鬐鬒鬖鬙鬛鬜鬠鬦鬫鬭鬳鬴鬵鬷鬹鬺鬽魈魋魌魕魖魗魛魞魡魣魥魦魨魪",4,"魳魵魷魸魹魿鮀鮄鮅鮆鮇鮉鮊鮋鮍鮏鮐鮔鮚鮝鮞鮦鮧鮩鮬鮰鮱鮲鮷鮸鮻鮼鮾鮿鯁鯇鯈鯎鯐鯗鯘鯝鯟鯥鯧鯪鯫鯯鯳鯷鯸"],["8feba1","鯹鯺鯽鯿鰀鰂鰋鰏鰑鰖鰘鰙鰚鰜鰞鰢鰣鰦",4,"鰱鰵鰶鰷鰽鱁鱃鱄鱅鱉鱊鱎鱏鱐鱓鱔鱖鱘鱛鱝鱞鱟鱣鱩鱪鱜鱫鱨鱮鱰鱲鱵鱷鱻鳦鳲鳷鳹鴋鴂鴑鴗鴘鴜鴝鴞鴯鴰鴲鴳鴴鴺鴼鵅鴽鵂鵃鵇鵊鵓鵔鵟鵣鵢鵥鵩鵪鵫鵰鵶鵷鵻"],["8feca1","鵼鵾鶃鶄鶆鶊鶍鶎鶒鶓鶕鶖鶗鶘鶡鶪鶬鶮鶱鶵鶹鶼鶿鷃鷇鷉鷊鷔鷕鷖鷗鷚鷞鷟鷠鷥鷧鷩鷫鷮鷰鷳鷴鷾鸊鸂鸇鸎鸐鸑鸒鸕鸖鸙鸜鸝鹺鹻鹼麀麂麃麄麅麇麎麏麖麘麛麞麤麨麬麮麯麰麳麴麵黆黈黋黕黟黤黧黬黭黮黰黱黲黵"],["8feda1","黸黿鼂鼃鼉鼏鼐鼑鼒鼔鼖鼗鼙鼚鼛鼟鼢鼦鼪鼫鼯鼱鼲鼴鼷鼹鼺鼼鼽鼿齁齃",4,"齓齕齖齗齘齚齝齞齨齩齭",4,"齳齵齺齽龏龐龑龒龔龖龗龞龡龢龣龥"]]

/***/ }),
/* 100 */
/***/ (function(module, exports) {

	module.exports = [["0","\u0000",127,"€"],["8140","丂丄丅丆丏丒丗丟丠両丣並丩丮丯丱丳丵丷丼乀乁乂乄乆乊乑乕乗乚乛乢乣乤乥乧乨乪",5,"乲乴",9,"乿",6,"亇亊"],["8180","亐亖亗亙亜亝亞亣亪亯亰亱亴亶亷亸亹亼亽亾仈仌仏仐仒仚仛仜仠仢仦仧仩仭仮仯仱仴仸仹仺仼仾伀伂",6,"伋伌伒",4,"伜伝伡伣伨伩伬伭伮伱伳伵伷伹伻伾",4,"佄佅佇",5,"佒佔佖佡佢佦佨佪佫佭佮佱佲併佷佸佹佺佽侀侁侂侅來侇侊侌侎侐侒侓侕侖侘侙侚侜侞侟価侢"],["8240","侤侫侭侰",4,"侶",8,"俀俁係俆俇俈俉俋俌俍俒",4,"俙俛俠俢俤俥俧俫俬俰俲俴俵俶俷俹俻俼俽俿",11],["8280","個倎倐們倓倕倖倗倛倝倞倠倢倣値倧倫倯",10,"倻倽倿偀偁偂偄偅偆偉偊偋偍偐",4,"偖偗偘偙偛偝",7,"偦",5,"偭",8,"偸偹偺偼偽傁傂傃傄傆傇傉傊傋傌傎",20,"傤傦傪傫傭",4,"傳",6,"傼"],["8340","傽",17,"僐",5,"僗僘僙僛",10,"僨僩僪僫僯僰僱僲僴僶",4,"僼",9,"儈"],["8380","儉儊儌",5,"儓",13,"儢",28,"兂兇兊兌兎兏児兒兓兗兘兙兛兝",4,"兣兤兦內兩兪兯兲兺兾兿冃冄円冇冊冋冎冏冐冑冓冔冘冚冝冞冟冡冣冦",4,"冭冮冴冸冹冺冾冿凁凂凃凅凈凊凍凎凐凒",5],["8440","凘凙凚凜凞凟凢凣凥",5,"凬凮凱凲凴凷凾刄刅刉刋刌刏刐刓刔刕刜刞刟刡刢刣別刦刧刪刬刯刱刲刴刵刼刾剄",5,"剋剎剏剒剓剕剗剘"],["8480","剙剚剛剝剟剠剢剣剤剦剨剫剬剭剮剰剱剳",9,"剾劀劃",4,"劉",6,"劑劒劔",6,"劜劤劥劦劧劮劯劰労",9,"勀勁勂勄勅勆勈勊勌勍勎勏勑勓勔動勗務",5,"勠勡勢勣勥",10,"勱",7,"勻勼勽匁匂匃匄匇匉匊匋匌匎"],["8540","匑匒匓匔匘匛匜匞匟匢匤匥匧匨匩匫匬匭匯",9,"匼匽區卂卄卆卋卌卍卐協単卙卛卝卥卨卪卬卭卲卶卹卻卼卽卾厀厁厃厇厈厊厎厏"],["8580","厐",4,"厖厗厙厛厜厞厠厡厤厧厪厫厬厭厯",6,"厷厸厹厺厼厽厾叀參",4,"収叏叐叒叓叕叚叜叝叞叡叢叧叴叺叾叿吀吂吅吇吋吔吘吙吚吜吢吤吥吪吰吳吶吷吺吽吿呁呂呄呅呇呉呌呍呎呏呑呚呝",4,"呣呥呧呩",7,"呴呹呺呾呿咁咃咅咇咈咉咊咍咑咓咗咘咜咞咟咠咡"],["8640","咢咥咮咰咲咵咶咷咹咺咼咾哃哅哊哋哖哘哛哠",4,"哫哬哯哰哱哴",5,"哻哾唀唂唃唄唅唈唊",4,"唒唓唕",5,"唜唝唞唟唡唥唦"],["8680","唨唩唫唭唲唴唵唶唸唹唺唻唽啀啂啅啇啈啋",4,"啑啒啓啔啗",4,"啝啞啟啠啢啣啨啩啫啯",5,"啹啺啽啿喅喆喌喍喎喐喒喓喕喖喗喚喛喞喠",6,"喨",8,"喲喴営喸喺喼喿",4,"嗆嗇嗈嗊嗋嗎嗏嗐嗕嗗",4,"嗞嗠嗢嗧嗩嗭嗮嗰嗱嗴嗶嗸",4,"嗿嘂嘃嘄嘅"],["8740","嘆嘇嘊嘋嘍嘐",7,"嘙嘚嘜嘝嘠嘡嘢嘥嘦嘨嘩嘪嘫嘮嘯嘰嘳嘵嘷嘸嘺嘼嘽嘾噀",11,"噏",4,"噕噖噚噛噝",4],["8780","噣噥噦噧噭噮噯噰噲噳噴噵噷噸噹噺噽",7,"嚇",6,"嚐嚑嚒嚔",14,"嚤",10,"嚰",6,"嚸嚹嚺嚻嚽",12,"囋",8,"囕囖囘囙囜団囥",5,"囬囮囯囲図囶囷囸囻囼圀圁圂圅圇國",6],["8840","園",9,"圝圞圠圡圢圤圥圦圧圫圱圲圴",4,"圼圽圿坁坃坄坅坆坈坉坋坒",4,"坘坙坢坣坥坧坬坮坰坱坲坴坵坸坹坺坽坾坿垀"],["8880","垁垇垈垉垊垍",4,"垔",6,"垜垝垞垟垥垨垪垬垯垰垱垳垵垶垷垹",8,"埄",6,"埌埍埐埑埓埖埗埛埜埞埡埢埣埥",7,"埮埰埱埲埳埵埶執埻埼埾埿堁堃堄堅堈堉堊堌堎堏堐堒堓堔堖堗堘堚堛堜堝堟堢堣堥",4,"堫",4,"報堲堳場堶",7],["8940","堾",5,"塅",6,"塎塏塐塒塓塕塖塗塙",4,"塟",5,"塦",4,"塭",16,"塿墂墄墆墇墈墊墋墌"],["8980","墍",4,"墔",4,"墛墜墝墠",7,"墪",17,"墽墾墿壀壂壃壄壆",10,"壒壓壔壖",13,"壥",5,"壭壯壱売壴壵壷壸壺",7,"夃夅夆夈",4,"夎夐夑夒夓夗夘夛夝夞夠夡夢夣夦夨夬夰夲夳夵夶夻"],["8a40","夽夾夿奀奃奅奆奊奌奍奐奒奓奙奛",4,"奡奣奤奦",12,"奵奷奺奻奼奾奿妀妅妉妋妌妎妏妐妑妔妕妘妚妛妜妝妟妠妡妢妦"],["8a80","妧妬妭妰妱妳",5,"妺妼妽妿",6,"姇姈姉姌姍姎姏姕姖姙姛姞",4,"姤姦姧姩姪姫姭",11,"姺姼姽姾娀娂娊娋娍娎娏娐娒娔娕娖娗娙娚娛娝娞娡娢娤娦娧娨娪",6,"娳娵娷",4,"娽娾娿婁",4,"婇婈婋",9,"婖婗婘婙婛",5],["8b40","婡婣婤婥婦婨婩婫",8,"婸婹婻婼婽婾媀",17,"媓",6,"媜",13,"媫媬"],["8b80","媭",4,"媴媶媷媹",4,"媿嫀嫃",5,"嫊嫋嫍",4,"嫓嫕嫗嫙嫚嫛嫝嫞嫟嫢嫤嫥嫧嫨嫪嫬",4,"嫲",22,"嬊",11,"嬘",25,"嬳嬵嬶嬸",7,"孁",6],["8c40","孈",7,"孒孖孞孠孡孧孨孫孭孮孯孲孴孶孷學孹孻孼孾孿宂宆宊宍宎宐宑宒宔宖実宧宨宩宬宭宮宯宱宲宷宺宻宼寀寁寃寈寉寊寋寍寎寏"],["8c80","寑寔",8,"寠寢寣實寧審",4,"寯寱",6,"寽対尀専尃尅將專尋尌對導尐尒尓尗尙尛尞尟尠尡尣尦尨尩尪尫尭尮尯尰尲尳尵尶尷屃屄屆屇屌屍屒屓屔屖屗屘屚屛屜屝屟屢層屧",6,"屰屲",6,"屻屼屽屾岀岃",4,"岉岊岋岎岏岒岓岕岝",4,"岤",4],["8d40","岪岮岯岰岲岴岶岹岺岻岼岾峀峂峃峅",5,"峌",5,"峓",5,"峚",6,"峢峣峧峩峫峬峮峯峱",9,"峼",4],["8d80","崁崄崅崈",5,"崏",4,"崕崗崘崙崚崜崝崟",4,"崥崨崪崫崬崯",4,"崵",7,"崿",7,"嵈嵉嵍",10,"嵙嵚嵜嵞",10,"嵪嵭嵮嵰嵱嵲嵳嵵",12,"嶃",21,"嶚嶛嶜嶞嶟嶠"],["8e40","嶡",21,"嶸",12,"巆",6,"巎",12,"巜巟巠巣巤巪巬巭"],["8e80","巰巵巶巸",4,"巿帀帄帇帉帊帋帍帎帒帓帗帞",7,"帨",4,"帯帰帲",4,"帹帺帾帿幀幁幃幆",5,"幍",6,"幖",4,"幜幝幟幠幣",14,"幵幷幹幾庁庂広庅庈庉庌庍庎庒庘庛庝庡庢庣庤庨",4,"庮",4,"庴庺庻庼庽庿",6],["8f40","廆廇廈廋",5,"廔廕廗廘廙廚廜",11,"廩廫",8,"廵廸廹廻廼廽弅弆弇弉弌弍弎弐弒弔弖弙弚弜弝弞弡弢弣弤"],["8f80","弨弫弬弮弰弲",6,"弻弽弾弿彁",14,"彑彔彙彚彛彜彞彟彠彣彥彧彨彫彮彯彲彴彵彶彸彺彽彾彿徃徆徍徎徏徑従徔徖徚徛徝從徟徠徢",5,"復徫徬徯",5,"徶徸徹徺徻徾",4,"忇忈忊忋忎忓忔忕忚忛応忞忟忢忣忥忦忨忩忬忯忰忲忳忴忶忷忹忺忼怇"],["9040","怈怉怋怌怐怑怓怗怘怚怞怟怢怣怤怬怭怮怰",4,"怶",4,"怽怾恀恄",6,"恌恎恏恑恓恔恖恗恘恛恜恞恟恠恡恥恦恮恱恲恴恵恷恾悀"],["9080","悁悂悅悆悇悈悊悋悎悏悐悑悓悕悗悘悙悜悞悡悢悤悥悧悩悪悮悰悳悵悶悷悹悺悽",7,"惇惈惉惌",4,"惒惓惔惖惗惙惛惞惡",4,"惪惱惲惵惷惸惻",4,"愂愃愄愅愇愊愋愌愐",4,"愖愗愘愙愛愜愝愞愡愢愥愨愩愪愬",18,"慀",6],["9140","慇慉態慍慏慐慒慓慔慖",6,"慞慟慠慡慣慤慥慦慩",6,"慱慲慳慴慶慸",18,"憌憍憏",4,"憕"],["9180","憖",6,"憞",8,"憪憫憭",9,"憸",5,"憿懀懁懃",4,"應懌",4,"懓懕",16,"懧",13,"懶",8,"戀",5,"戇戉戓戔戙戜戝戞戠戣戦戧戨戩戫戭戯戰戱戲戵戶戸",4,"扂扄扅扆扊"],["9240","扏扐払扖扗扙扚扜",6,"扤扥扨扱扲扴扵扷扸扺扻扽抁抂抃抅抆抇抈抋",5,"抔抙抜抝択抣抦抧抩抪抭抮抯抰抲抳抴抶抷抸抺抾拀拁"],["9280","拃拋拏拑拕拝拞拠拡拤拪拫拰拲拵拸拹拺拻挀挃挄挅挆挊挋挌挍挏挐挒挓挔挕挗挘挙挜挦挧挩挬挭挮挰挱挳",5,"挻挼挾挿捀捁捄捇捈捊捑捒捓捔捖",7,"捠捤捥捦捨捪捫捬捯捰捲捳捴捵捸捹捼捽捾捿掁掃掄掅掆掋掍掑掓掔掕掗掙",6,"採掤掦掫掯掱掲掵掶掹掻掽掿揀"],["9340","揁揂揃揅揇揈揊揋揌揑揓揔揕揗",6,"揟揢揤",4,"揫揬揮揯揰揱揳揵揷揹揺揻揼揾搃搄搆",4,"損搎搑搒搕",5,"搝搟搢搣搤"],["9380","搥搧搨搩搫搮",5,"搵",4,"搻搼搾摀摂摃摉摋",6,"摓摕摖摗摙",4,"摟",7,"摨摪摫摬摮",9,"摻",6,"撃撆撈",8,"撓撔撗撘撚撛撜撝撟",4,"撥撦撧撨撪撫撯撱撲撳撴撶撹撻撽撾撿擁擃擄擆",6,"擏擑擓擔擕擖擙據"],["9440","擛擜擝擟擠擡擣擥擧",24,"攁",7,"攊",7,"攓",4,"攙",8],["9480","攢攣攤攦",4,"攬攭攰攱攲攳攷攺攼攽敀",4,"敆敇敊敋敍敎敐敒敓敔敗敘敚敜敟敠敡敤敥敧敨敩敪敭敮敯敱敳敵敶數",14,"斈斉斊斍斎斏斒斔斕斖斘斚斝斞斠斢斣斦斨斪斬斮斱",7,"斺斻斾斿旀旂旇旈旉旊旍旐旑旓旔旕旘",7,"旡旣旤旪旫"],["9540","旲旳旴旵旸旹旻",4,"昁昄昅昇昈昉昋昍昐昑昒昖昗昘昚昛昜昞昡昢昣昤昦昩昪昫昬昮昰昲昳昷",4,"昽昿晀時晄",6,"晍晎晐晑晘"],["9580","晙晛晜晝晞晠晢晣晥晧晩",4,"晱晲晳晵晸晹晻晼晽晿暀暁暃暅暆暈暉暊暋暍暎暏暐暒暓暔暕暘",4,"暞",8,"暩",4,"暯",4,"暵暶暷暸暺暻暼暽暿",25,"曚曞",7,"曧曨曪",5,"曱曵曶書曺曻曽朁朂會"],["9640","朄朅朆朇朌朎朏朑朒朓朖朘朙朚朜朞朠",5,"朧朩朮朰朲朳朶朷朸朹朻朼朾朿杁杄杅杇杊杋杍杒杔杕杗",4,"杝杢杣杤杦杧杫杬杮東杴杶"],["9680","杸杹杺杻杽枀枂枃枅枆枈枊枌枍枎枏枑枒枓枔枖枙枛枟枠枡枤枦枩枬枮枱枲枴枹",7,"柂柅",9,"柕柖柗柛柟柡柣柤柦柧柨柪柫柭柮柲柵",7,"柾栁栂栃栄栆栍栐栒栔栕栘",4,"栞栟栠栢",6,"栫",6,"栴栵栶栺栻栿桇桋桍桏桒桖",5],["9740","桜桝桞桟桪桬",7,"桵桸",8,"梂梄梇",7,"梐梑梒梔梕梖梘",9,"梣梤梥梩梪梫梬梮梱梲梴梶梷梸"],["9780","梹",6,"棁棃",5,"棊棌棎棏棐棑棓棔棖棗棙棛",4,"棡棢棤",9,"棯棲棳棴棶棷棸棻棽棾棿椀椂椃椄椆",4,"椌椏椑椓",11,"椡椢椣椥",7,"椮椯椱椲椳椵椶椷椸椺椻椼椾楀楁楃",16,"楕楖楘楙楛楜楟"],["9840","楡楢楤楥楧楨楩楪楬業楯楰楲",4,"楺楻楽楾楿榁榃榅榊榋榌榎",5,"榖榗榙榚榝",9,"榩榪榬榮榯榰榲榳榵榶榸榹榺榼榽"],["9880","榾榿槀槂",7,"構槍槏槑槒槓槕",5,"槜槝槞槡",11,"槮槯槰槱槳",9,"槾樀",9,"樋",11,"標",5,"樠樢",5,"権樫樬樭樮樰樲樳樴樶",6,"樿",4,"橅橆橈",7,"橑",6,"橚"],["9940","橜",4,"橢橣橤橦",10,"橲",6,"橺橻橽橾橿檁檂檃檅",8,"檏檒",4,"檘",7,"檡",5],["9980","檧檨檪檭",114,"欥欦欨",6],["9a40","欯欰欱欳欴欵欶欸欻欼欽欿歀歁歂歄歅歈歊歋歍",11,"歚",7,"歨歩歫",13,"歺歽歾歿殀殅殈"],["9a80","殌殎殏殐殑殔殕殗殘殙殜",4,"殢",7,"殫",7,"殶殸",6,"毀毃毄毆",4,"毌毎毐毑毘毚毜",4,"毢",7,"毬毭毮毰毱毲毴毶毷毸毺毻毼毾",6,"氈",4,"氎氒気氜氝氞氠氣氥氫氬氭氱氳氶氷氹氺氻氼氾氿汃汄汅汈汋",4,"汑汒汓汖汘"],["9b40","汙汚汢汣汥汦汧汫",4,"汱汳汵汷汸決汻汼汿沀沄沇沊沋沍沎沑沒沕沖沗沘沚沜沝沞沠沢沨沬沯沰沴沵沶沷沺泀況泂泃泆泇泈泋泍泎泏泑泒泘"],["9b80","泙泚泜泝泟泤泦泧泩泬泭泲泴泹泿洀洂洃洅洆洈洉洊洍洏洐洑洓洔洕洖洘洜洝洟",5,"洦洨洩洬洭洯洰洴洶洷洸洺洿浀浂浄浉浌浐浕浖浗浘浛浝浟浡浢浤浥浧浨浫浬浭浰浱浲浳浵浶浹浺浻浽",4,"涃涄涆涇涊涋涍涏涐涒涖",4,"涜涢涥涬涭涰涱涳涴涶涷涹",5,"淁淂淃淈淉淊"],["9c40","淍淎淏淐淒淓淔淕淗淚淛淜淟淢淣淥淧淨淩淪淭淯淰淲淴淵淶淸淺淽",7,"渆渇済渉渋渏渒渓渕渘渙減渜渞渟渢渦渧渨渪測渮渰渱渳渵"],["9c80","渶渷渹渻",7,"湅",7,"湏湐湑湒湕湗湙湚湜湝湞湠",10,"湬湭湯",14,"満溁溂溄溇溈溊",4,"溑",6,"溙溚溛溝溞溠溡溣溤溦溨溩溫溬溭溮溰溳溵溸溹溼溾溿滀滃滄滅滆滈滉滊滌滍滎滐滒滖滘滙滛滜滝滣滧滪",5],["9d40","滰滱滲滳滵滶滷滸滺",7,"漃漄漅漇漈漊",4,"漐漑漒漖",9,"漡漢漣漥漦漧漨漬漮漰漲漴漵漷",6,"漿潀潁潂"],["9d80","潃潄潅潈潉潊潌潎",9,"潙潚潛潝潟潠潡潣潤潥潧",5,"潯潰潱潳潵潶潷潹潻潽",6,"澅澆澇澊澋澏",12,"澝澞澟澠澢",4,"澨",10,"澴澵澷澸澺",5,"濁濃",5,"濊",6,"濓",10,"濟濢濣濤濥"],["9e40","濦",7,"濰",32,"瀒",7,"瀜",6,"瀤",6],["9e80","瀫",9,"瀶瀷瀸瀺",17,"灍灎灐",13,"灟",11,"灮灱灲灳灴灷灹灺灻災炁炂炃炄炆炇炈炋炌炍炏炐炑炓炗炘炚炛炞",12,"炰炲炴炵炶為炾炿烄烅烆烇烉烋",12,"烚"],["9f40","烜烝烞烠烡烢烣烥烪烮烰",6,"烸烺烻烼烾",10,"焋",4,"焑焒焔焗焛",10,"焧",7,"焲焳焴"],["9f80","焵焷",13,"煆煇煈煉煋煍煏",12,"煝煟",4,"煥煩",4,"煯煰煱煴煵煶煷煹煻煼煾",5,"熅",4,"熋熌熍熎熐熑熒熓熕熖熗熚",4,"熡",6,"熩熪熫熭",5,"熴熶熷熸熺",8,"燄",9,"燏",4],["a040","燖",9,"燡燢燣燤燦燨",5,"燯",9,"燺",11,"爇",19],["a080","爛爜爞",9,"爩爫爭爮爯爲爳爴爺爼爾牀",6,"牉牊牋牎牏牐牑牓牔牕牗牘牚牜牞牠牣牤牥牨牪牫牬牭牰牱牳牴牶牷牸牻牼牽犂犃犅",4,"犌犎犐犑犓",11,"犠",11,"犮犱犲犳犵犺",6,"狅狆狇狉狊狋狌狏狑狓狔狕狖狘狚狛"],["a1a1","　、。·ˉˇ¨〃々—～‖…‘’“”〔〕〈",7,"〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓"],["a2a1","ⅰ",9],["a2b1","⒈",19,"⑴",19,"①",9],["a2e5","㈠",9],["a2f1","Ⅰ",11],["a3a1","！＂＃￥％",88,"￣"],["a4a1","ぁ",82],["a5a1","ァ",85],["a6a1","Α",16,"Σ",6],["a6c1","α",16,"σ",6],["a6e0","︵︶︹︺︿﹀︽︾﹁﹂﹃﹄"],["a6ee","︻︼︷︸︱"],["a6f4","︳︴"],["a7a1","А",5,"ЁЖ",25],["a7d1","а",5,"ёж",25],["a840","ˊˋ˙–―‥‵℅℉↖↗↘↙∕∟∣≒≦≧⊿═",35,"▁",6],["a880","█",7,"▓▔▕▼▽◢◣◤◥☉⊕〒〝〞"],["a8a1","āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüêɑ"],["a8bd","ńň"],["a8c0","ɡ"],["a8c5","ㄅ",36],["a940","〡",8,"㊣㎎㎏㎜㎝㎞㎡㏄㏎㏑㏒㏕︰￢￤"],["a959","℡㈱"],["a95c","‐"],["a960","ー゛゜ヽヾ〆ゝゞ﹉",9,"﹔﹕﹖﹗﹙",8],["a980","﹢",4,"﹨﹩﹪﹫"],["a996","〇"],["a9a4","─",75],["aa40","狜狝狟狢",5,"狪狫狵狶狹狽狾狿猀猂猄",5,"猋猌猍猏猐猑猒猔猘猙猚猟猠猣猤猦猧猨猭猯猰猲猳猵猶猺猻猼猽獀",8],["aa80","獉獊獋獌獎獏獑獓獔獕獖獘",7,"獡",10,"獮獰獱"],["ab40","獲",11,"獿",4,"玅玆玈玊玌玍玏玐玒玓玔玕玗玘玙玚玜玝玞玠玡玣",5,"玪玬玭玱玴玵玶玸玹玼玽玾玿珁珃",4],["ab80","珋珌珎珒",6,"珚珛珜珝珟珡珢珣珤珦珨珪珫珬珮珯珰珱珳",4],["ac40","珸",10,"琄琇琈琋琌琍琎琑",8,"琜",5,"琣琤琧琩琫琭琯琱琲琷",4,"琽琾琿瑀瑂",11],["ac80","瑎",6,"瑖瑘瑝瑠",12,"瑮瑯瑱",4,"瑸瑹瑺"],["ad40","瑻瑼瑽瑿璂璄璅璆璈璉璊璌璍璏璑",10,"璝璟",7,"璪",15,"璻",12],["ad80","瓈",9,"瓓",8,"瓝瓟瓡瓥瓧",6,"瓰瓱瓲"],["ae40","瓳瓵瓸",6,"甀甁甂甃甅",7,"甎甐甒甔甕甖甗甛甝甞甠",4,"甦甧甪甮甴甶甹甼甽甿畁畂畃畄畆畇畉畊畍畐畑畒畓畕畖畗畘"],["ae80","畝",7,"畧畨畩畫",6,"畳畵當畷畺",4,"疀疁疂疄疅疇"],["af40","疈疉疊疌疍疎疐疓疕疘疛疜疞疢疦",4,"疭疶疷疺疻疿痀痁痆痋痌痎痏痐痑痓痗痙痚痜痝痟痠痡痥痩痬痭痮痯痲痳痵痶痷痸痺痻痽痾瘂瘄瘆瘇"],["af80","瘈瘉瘋瘍瘎瘏瘑瘒瘓瘔瘖瘚瘜瘝瘞瘡瘣瘧瘨瘬瘮瘯瘱瘲瘶瘷瘹瘺瘻瘽癁療癄"],["b040","癅",6,"癎",5,"癕癗",4,"癝癟癠癡癢癤",6,"癬癭癮癰",7,"癹発發癿皀皁皃皅皉皊皌皍皏皐皒皔皕皗皘皚皛"],["b080","皜",7,"皥",8,"皯皰皳皵",9,"盀盁盃啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥"],["b140","盄盇盉盋盌盓盕盙盚盜盝盞盠",4,"盦",7,"盰盳盵盶盷盺盻盽盿眀眂眃眅眆眊県眎",10,"眛眜眝眞眡眣眤眥眧眪眫"],["b180","眬眮眰",4,"眹眻眽眾眿睂睄睅睆睈",7,"睒",7,"睜薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳"],["b240","睝睞睟睠睤睧睩睪睭",11,"睺睻睼瞁瞂瞃瞆",5,"瞏瞐瞓",11,"瞡瞣瞤瞦瞨瞫瞭瞮瞯瞱瞲瞴瞶",4],["b280","瞼瞾矀",12,"矎",8,"矘矙矚矝",4,"矤病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖"],["b340","矦矨矪矯矰矱矲矴矵矷矹矺矻矼砃",5,"砊砋砎砏砐砓砕砙砛砞砠砡砢砤砨砪砫砮砯砱砲砳砵砶砽砿硁硂硃硄硆硈硉硊硋硍硏硑硓硔硘硙硚"],["b380","硛硜硞",11,"硯",7,"硸硹硺硻硽",6,"场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚"],["b440","碄碅碆碈碊碋碏碐碒碔碕碖碙碝碞碠碢碤碦碨",7,"碵碶碷碸確碻碼碽碿磀磂磃磄磆磇磈磌磍磎磏磑磒磓磖磗磘磚",9],["b480","磤磥磦磧磩磪磫磭",4,"磳磵磶磸磹磻",5,"礂礃礄礆",6,"础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮"],["b540","礍",5,"礔",9,"礟",4,"礥",14,"礵",4,"礽礿祂祃祄祅祇祊",8,"祔祕祘祙祡祣"],["b580","祤祦祩祪祫祬祮祰",6,"祹祻",4,"禂禃禆禇禈禉禋禌禍禎禐禑禒怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠"],["b640","禓",6,"禛",11,"禨",10,"禴",4,"禼禿秂秄秅秇秈秊秌秎秏秐秓秔秖秗秙",5,"秠秡秢秥秨秪"],["b680","秬秮秱",6,"秹秺秼秾秿稁稄稅稇稈稉稊稌稏",4,"稕稖稘稙稛稜丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二"],["b740","稝稟稡稢稤",14,"稴稵稶稸稺稾穀",5,"穇",9,"穒",4,"穘",16],["b780","穩",6,"穱穲穳穵穻穼穽穾窂窅窇窉窊窋窌窎窏窐窓窔窙窚窛窞窡窢贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服"],["b840","窣窤窧窩窪窫窮",4,"窴",10,"竀",10,"竌",9,"竗竘竚竛竜竝竡竢竤竧",5,"竮竰竱竲竳"],["b880","竴",4,"竻竼竾笀笁笂笅笇笉笌笍笎笐笒笓笖笗笘笚笜笝笟笡笢笣笧笩笭浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹"],["b940","笯笰笲笴笵笶笷笹笻笽笿",5,"筆筈筊筍筎筓筕筗筙筜筞筟筡筣",10,"筯筰筳筴筶筸筺筼筽筿箁箂箃箄箆",6,"箎箏"],["b980","箑箒箓箖箘箙箚箛箞箟箠箣箤箥箮箯箰箲箳箵箶箷箹",7,"篂篃範埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈"],["ba40","篅篈築篊篋篍篎篏篐篒篔",4,"篛篜篞篟篠篢篣篤篧篨篩篫篬篭篯篰篲",4,"篸篹篺篻篽篿",7,"簈簉簊簍簎簐",5,"簗簘簙"],["ba80","簚",4,"簠",5,"簨簩簫",12,"簹",5,"籂骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖"],["bb40","籃",9,"籎",36,"籵",5,"籾",9],["bb80","粈粊",6,"粓粔粖粙粚粛粠粡粣粦粧粨粩粫粬粭粯粰粴",4,"粺粻弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕"],["bc40","粿糀糂糃糄糆糉糋糎",6,"糘糚糛糝糞糡",6,"糩",5,"糰",7,"糹糺糼",13,"紋",5],["bc80","紑",14,"紡紣紤紥紦紨紩紪紬紭紮細",6,"肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件"],["bd40","紷",54,"絯",7],["bd80","絸",32,"健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸"],["be40","継",12,"綧",6,"綯",42],["be80","線",32,"尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻"],["bf40","緻",62],["bf80","縺縼",4,"繂",4,"繈",21,"俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀"],["c040","繞",35,"纃",23,"纜纝纞"],["c080","纮纴纻纼绖绤绬绹缊缐缞缷缹缻",6,"罃罆",9,"罒罓馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐"],["c140","罖罙罛罜罝罞罠罣",4,"罫罬罭罯罰罳罵罶罷罸罺罻罼罽罿羀羂",7,"羋羍羏",4,"羕",4,"羛羜羠羢羣羥羦羨",6,"羱"],["c180","羳",4,"羺羻羾翀翂翃翄翆翇翈翉翋翍翏",4,"翖翗翙",5,"翢翣痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿"],["c240","翤翧翨翪翫翬翭翯翲翴",6,"翽翾翿耂耇耈耉耊耎耏耑耓耚耛耝耞耟耡耣耤耫",5,"耲耴耹耺耼耾聀聁聄聅聇聈聉聎聏聐聑聓聕聖聗"],["c280","聙聛",13,"聫",5,"聲",11,"隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫"],["c340","聾肁肂肅肈肊肍",5,"肔肕肗肙肞肣肦肧肨肬肰肳肵肶肸肹肻胅胇",4,"胏",6,"胘胟胠胢胣胦胮胵胷胹胻胾胿脀脁脃脄脅脇脈脋"],["c380","脌脕脗脙脛脜脝脟",12,"脭脮脰脳脴脵脷脹",4,"脿谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸"],["c440","腀",5,"腇腉腍腎腏腒腖腗腘腛",4,"腡腢腣腤腦腨腪腫腬腯腲腳腵腶腷腸膁膃",4,"膉膋膌膍膎膐膒",5,"膙膚膞",4,"膤膥"],["c480","膧膩膫",7,"膴",5,"膼膽膾膿臄臅臇臈臉臋臍",6,"摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁"],["c540","臔",14,"臤臥臦臨臩臫臮",4,"臵",5,"臽臿舃與",4,"舎舏舑舓舕",5,"舝舠舤舥舦舧舩舮舲舺舼舽舿"],["c580","艀艁艂艃艅艆艈艊艌艍艎艐",7,"艙艛艜艝艞艠",7,"艩拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗"],["c640","艪艫艬艭艱艵艶艷艸艻艼芀芁芃芅芆芇芉芌芐芓芔芕芖芚芛芞芠芢芣芧芲芵芶芺芻芼芿苀苂苃苅苆苉苐苖苙苚苝苢苧苨苩苪苬苭苮苰苲苳苵苶苸"],["c680","苺苼",4,"茊茋茍茐茒茓茖茘茙茝",9,"茩茪茮茰茲茷茻茽啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐"],["c740","茾茿荁荂荄荅荈荊",4,"荓荕",4,"荝荢荰",6,"荹荺荾",6,"莇莈莊莋莌莍莏莐莑莔莕莖莗莙莚莝莟莡",6,"莬莭莮"],["c780","莯莵莻莾莿菂菃菄菆菈菉菋菍菎菐菑菒菓菕菗菙菚菛菞菢菣菤菦菧菨菫菬菭恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠"],["c840","菮華菳",4,"菺菻菼菾菿萀萂萅萇萈萉萊萐萒",5,"萙萚萛萞",5,"萩",7,"萲",5,"萹萺萻萾",7,"葇葈葉"],["c880","葊",6,"葒",4,"葘葝葞葟葠葢葤",4,"葪葮葯葰葲葴葷葹葻葼取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁"],["c940","葽",4,"蒃蒄蒅蒆蒊蒍蒏",7,"蒘蒚蒛蒝蒞蒟蒠蒢",12,"蒰蒱蒳蒵蒶蒷蒻蒼蒾蓀蓂蓃蓅蓆蓇蓈蓋蓌蓎蓏蓒蓔蓕蓗"],["c980","蓘",4,"蓞蓡蓢蓤蓧",4,"蓭蓮蓯蓱",10,"蓽蓾蔀蔁蔂伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳"],["ca40","蔃",8,"蔍蔎蔏蔐蔒蔔蔕蔖蔘蔙蔛蔜蔝蔞蔠蔢",8,"蔭",9,"蔾",4,"蕄蕅蕆蕇蕋",10],["ca80","蕗蕘蕚蕛蕜蕝蕟",4,"蕥蕦蕧蕩",8,"蕳蕵蕶蕷蕸蕼蕽蕿薀薁省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱"],["cb40","薂薃薆薈",6,"薐",10,"薝",6,"薥薦薧薩薫薬薭薱",5,"薸薺",6,"藂",6,"藊",4,"藑藒"],["cb80","藔藖",5,"藝",6,"藥藦藧藨藪",14,"恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔"],["cc40","藹藺藼藽藾蘀",4,"蘆",10,"蘒蘓蘔蘕蘗",15,"蘨蘪",13,"蘹蘺蘻蘽蘾蘿虀"],["cc80","虁",11,"虒虓處",4,"虛虜虝號虠虡虣",7,"獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃"],["cd40","虭虯虰虲",6,"蚃",6,"蚎",4,"蚔蚖",5,"蚞",4,"蚥蚦蚫蚭蚮蚲蚳蚷蚸蚹蚻",4,"蛁蛂蛃蛅蛈蛌蛍蛒蛓蛕蛖蛗蛚蛜"],["cd80","蛝蛠蛡蛢蛣蛥蛦蛧蛨蛪蛫蛬蛯蛵蛶蛷蛺蛻蛼蛽蛿蜁蜄蜅蜆蜋蜌蜎蜏蜐蜑蜔蜖汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威"],["ce40","蜙蜛蜝蜟蜠蜤蜦蜧蜨蜪蜫蜬蜭蜯蜰蜲蜳蜵蜶蜸蜹蜺蜼蜽蝀",6,"蝊蝋蝍蝏蝐蝑蝒蝔蝕蝖蝘蝚",5,"蝡蝢蝦",7,"蝯蝱蝲蝳蝵"],["ce80","蝷蝸蝹蝺蝿螀螁螄螆螇螉螊螌螎",4,"螔螕螖螘",6,"螠",4,"巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺"],["cf40","螥螦螧螩螪螮螰螱螲螴螶螷螸螹螻螼螾螿蟁",4,"蟇蟈蟉蟌",4,"蟔",6,"蟜蟝蟞蟟蟡蟢蟣蟤蟦蟧蟨蟩蟫蟬蟭蟯",9],["cf80","蟺蟻蟼蟽蟿蠀蠁蠂蠄",5,"蠋",7,"蠔蠗蠘蠙蠚蠜",4,"蠣稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓"],["d040","蠤",13,"蠳",5,"蠺蠻蠽蠾蠿衁衂衃衆",5,"衎",5,"衕衖衘衚",6,"衦衧衪衭衯衱衳衴衵衶衸衹衺"],["d080","衻衼袀袃袆袇袉袊袌袎袏袐袑袓袔袕袗",4,"袝",4,"袣袥",5,"小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄"],["d140","袬袮袯袰袲",4,"袸袹袺袻袽袾袿裀裃裄裇裈裊裋裌裍裏裐裑裓裖裗裚",4,"裠裡裦裧裩",6,"裲裵裶裷裺裻製裿褀褁褃",5],["d180","褉褋",4,"褑褔",4,"褜",4,"褢褣褤褦褧褨褩褬褭褮褯褱褲褳褵褷选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶"],["d240","褸",8,"襂襃襅",24,"襠",5,"襧",19,"襼"],["d280","襽襾覀覂覄覅覇",26,"摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐"],["d340","覢",30,"觃觍觓觔觕觗觘觙觛觝觟觠觡觢觤觧觨觩觪觬觭觮觰觱觲觴",6],["d380","觻",4,"訁",5,"計",21,"印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉"],["d440","訞",31,"訿",8,"詉",21],["d480","詟",25,"詺",6,"浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧"],["d540","誁",7,"誋",7,"誔",46],["d580","諃",32,"铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政"],["d640","諤",34,"謈",27],["d680","謤謥謧",30,"帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑"],["d740","譆",31,"譧",4,"譭",25],["d780","讇",24,"讬讱讻诇诐诪谉谞住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座"],["d840","谸",8,"豂豃豄豅豈豊豋豍",7,"豖豗豘豙豛",5,"豣",6,"豬",6,"豴豵豶豷豻",6,"貃貄貆貇"],["d880","貈貋貍",6,"貕貖貗貙",20,"亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝"],["d940","貮",62],["d980","賭",32,"佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼"],["da40","贎",14,"贠赑赒赗赟赥赨赩赪赬赮赯赱赲赸",8,"趂趃趆趇趈趉趌",4,"趒趓趕",9,"趠趡"],["da80","趢趤",12,"趲趶趷趹趻趽跀跁跂跅跇跈跉跊跍跐跒跓跔凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺"],["db40","跕跘跙跜跠跡跢跥跦跧跩跭跮跰跱跲跴跶跼跾",6,"踆踇踈踋踍踎踐踑踒踓踕",7,"踠踡踤",4,"踫踭踰踲踳踴踶踷踸踻踼踾"],["db80","踿蹃蹅蹆蹌",4,"蹓",5,"蹚",11,"蹧蹨蹪蹫蹮蹱邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝"],["dc40","蹳蹵蹷",4,"蹽蹾躀躂躃躄躆躈",6,"躑躒躓躕",6,"躝躟",11,"躭躮躰躱躳",6,"躻",7],["dc80","軃",10,"軏",21,"堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥"],["dd40","軥",62],["dd80","輤",32,"荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺"],["de40","轅",32,"轪辀辌辒辝辠辡辢辤辥辦辧辪辬辭辮辯農辳辴辵辷辸辺辻込辿迀迃迆"],["de80","迉",4,"迏迒迖迗迚迠迡迣迧迬迯迱迲迴迵迶迺迻迼迾迿逇逈逌逎逓逕逘蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖"],["df40","這逜連逤逥逧",5,"逰",4,"逷逹逺逽逿遀遃遅遆遈",4,"過達違遖遙遚遜",5,"遤遦遧適遪遫遬遯",4,"遶",6,"遾邁"],["df80","還邅邆邇邉邊邌",4,"邒邔邖邘邚邜邞邟邠邤邥邧邨邩邫邭邲邷邼邽邿郀摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼"],["e040","郂郃郆郈郉郋郌郍郒郔郕郖郘郙郚郞郟郠郣郤郥郩郪郬郮郰郱郲郳郵郶郷郹郺郻郼郿鄀鄁鄃鄅",19,"鄚鄛鄜"],["e080","鄝鄟鄠鄡鄤",10,"鄰鄲",6,"鄺",8,"酄唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼"],["e140","酅酇酈酑酓酔酕酖酘酙酛酜酟酠酦酧酨酫酭酳酺酻酼醀",4,"醆醈醊醎醏醓",6,"醜",5,"醤",5,"醫醬醰醱醲醳醶醷醸醹醻"],["e180","醼",10,"釈釋釐釒",9,"針",8,"帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺"],["e240","釦",62],["e280","鈥",32,"狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧",5,"饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂"],["e340","鉆",45,"鉵",16],["e380","銆",7,"銏",24,"恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾"],["e440","銨",5,"銯",24,"鋉",31],["e480","鋩",32,"洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑"],["e540","錊",51,"錿",10],["e580","鍊",31,"鍫濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣"],["e640","鍬",34,"鎐",27],["e680","鎬",29,"鏋鏌鏍妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩"],["e740","鏎",7,"鏗",54],["e780","鐎",32,"纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡",6,"缪缫缬缭缯",4,"缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬"],["e840","鐯",14,"鐿",43,"鑬鑭鑮鑯"],["e880","鑰",20,"钑钖钘铇铏铓铔铚铦铻锜锠琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹"],["e940","锧锳锽镃镈镋镕镚镠镮镴镵長",7,"門",42],["e980","閫",32,"椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋"],["ea40","闌",27,"闬闿阇阓阘阛阞阠阣",6,"阫阬阭阯阰阷阸阹阺阾陁陃陊陎陏陑陒陓陖陗"],["ea80","陘陙陚陜陝陞陠陣陥陦陫陭",4,"陳陸",12,"隇隉隊辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰"],["eb40","隌階隑隒隓隕隖隚際隝",9,"隨",7,"隱隲隴隵隷隸隺隻隿雂雃雈雊雋雐雑雓雔雖",9,"雡",6,"雫"],["eb80","雬雭雮雰雱雲雴雵雸雺電雼雽雿霂霃霅霊霋霌霐霑霒霔霕霗",4,"霝霟霠搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻"],["ec40","霡",8,"霫霬霮霯霱霳",4,"霺霻霼霽霿",18,"靔靕靗靘靚靜靝靟靣靤靦靧靨靪",7],["ec80","靲靵靷",4,"靽",7,"鞆",4,"鞌鞎鞏鞐鞓鞕鞖鞗鞙",4,"臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐"],["ed40","鞞鞟鞡鞢鞤",6,"鞬鞮鞰鞱鞳鞵",46],["ed80","韤韥韨韮",4,"韴韷",23,"怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨"],["ee40","頏",62],["ee80","顎",32,"睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶",4,"钼钽钿铄铈",6,"铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪"],["ef40","顯",5,"颋颎颒颕颙颣風",37,"飏飐飔飖飗飛飜飝飠",4],["ef80","飥飦飩",30,"铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒",4,"锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤",8,"镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔"],["f040","餈",4,"餎餏餑",28,"餯",26],["f080","饊",9,"饖",12,"饤饦饳饸饹饻饾馂馃馉稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨",4,"鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦",6,"鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙"],["f140","馌馎馚",10,"馦馧馩",47],["f180","駙",32,"瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃"],["f240","駺",62],["f280","騹",32,"颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒"],["f340","驚",17,"驲骃骉骍骎骔骕骙骦骩",6,"骲骳骴骵骹骻骽骾骿髃髄髆",4,"髍髎髏髐髒體髕髖髗髙髚髛髜"],["f380","髝髞髠髢髣髤髥髧髨髩髪髬髮髰",8,"髺髼",6,"鬄鬅鬆蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋"],["f440","鬇鬉",5,"鬐鬑鬒鬔",10,"鬠鬡鬢鬤",10,"鬰鬱鬳",7,"鬽鬾鬿魀魆魊魋魌魎魐魒魓魕",5],["f480","魛",32,"簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤"],["f540","魼",62],["f580","鮻",32,"酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜"],["f640","鯜",62],["f680","鰛",32,"觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅",5,"龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞",5,"鲥",4,"鲫鲭鲮鲰",7,"鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋"],["f740","鰼",62],["f780","鱻鱽鱾鲀鲃鲄鲉鲊鲌鲏鲓鲖鲗鲘鲙鲝鲪鲬鲯鲹鲾",4,"鳈鳉鳑鳒鳚鳛鳠鳡鳌",4,"鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄"],["f840","鳣",62],["f880","鴢",32],["f940","鵃",62],["f980","鶂",32],["fa40","鶣",62],["fa80","鷢",32],["fb40","鸃",27,"鸤鸧鸮鸰鸴鸻鸼鹀鹍鹐鹒鹓鹔鹖鹙鹝鹟鹠鹡鹢鹥鹮鹯鹲鹴",9,"麀"],["fb80","麁麃麄麅麆麉麊麌",5,"麔",8,"麞麠",5,"麧麨麩麪"],["fc40","麫",8,"麵麶麷麹麺麼麿",4,"黅黆黇黈黊黋黌黐黒黓黕黖黗黙黚點黡黣黤黦黨黫黬黭黮黰",8,"黺黽黿",6],["fc80","鼆",4,"鼌鼏鼑鼒鼔鼕鼖鼘鼚",5,"鼡鼣",8,"鼭鼮鼰鼱"],["fd40","鼲",4,"鼸鼺鼼鼿",4,"齅",10,"齒",38],["fd80","齹",5,"龁龂龍",11,"龜龝龞龡",4,"郎凉秊裏隣"],["fe40","兀嗀﨎﨏﨑﨓﨔礼﨟蘒﨡﨣﨤﨧﨨﨩"]]

/***/ }),
/* 101 */
/***/ (function(module, exports) {

	module.exports = [["a140","",62],["a180","",32],["a240","",62],["a280","",32],["a2ab","",5],["a2e3","€"],["a2ef",""],["a2fd",""],["a340","",62],["a380","",31,"　"],["a440","",62],["a480","",32],["a4f4","",10],["a540","",62],["a580","",32],["a5f7","",7],["a640","",62],["a680","",32],["a6b9","",7],["a6d9","",6],["a6ec",""],["a6f3",""],["a6f6","",8],["a740","",62],["a780","",32],["a7c2","",14],["a7f2","",12],["a896","",10],["a8bc",""],["a8bf","ǹ"],["a8c1",""],["a8ea","",20],["a958",""],["a95b",""],["a95d",""],["a989","〾⿰",11],["a997","",12],["a9f0","",14],["aaa1","",93],["aba1","",93],["aca1","",93],["ada1","",93],["aea1","",93],["afa1","",93],["d7fa","",4],["f8a1","",93],["f9a1","",93],["faa1","",93],["fba1","",93],["fca1","",93],["fda1","",93],["fe50","⺁⺄㑳㑇⺈⺋㖞㘚㘎⺌⺗㥮㤘㧏㧟㩳㧐㭎㱮㳠⺧⺪䁖䅟⺮䌷⺳⺶⺷䎱䎬⺻䏝䓖䙡䙌"],["fe80","䜣䜩䝼䞍⻊䥇䥺䥽䦂䦃䦅䦆䦟䦛䦷䦶䲣䲟䲠䲡䱷䲢䴓",6,"䶮",93]]

/***/ }),
/* 102 */
/***/ (function(module, exports) {

	module.exports = {"uChars":[128,165,169,178,184,216,226,235,238,244,248,251,253,258,276,284,300,325,329,334,364,463,465,467,469,471,473,475,477,506,594,610,712,716,730,930,938,962,970,1026,1104,1106,8209,8215,8218,8222,8231,8241,8244,8246,8252,8365,8452,8454,8458,8471,8482,8556,8570,8596,8602,8713,8720,8722,8726,8731,8737,8740,8742,8748,8751,8760,8766,8777,8781,8787,8802,8808,8816,8854,8858,8870,8896,8979,9322,9372,9548,9588,9616,9622,9634,9652,9662,9672,9676,9680,9702,9735,9738,9793,9795,11906,11909,11913,11917,11928,11944,11947,11951,11956,11960,11964,11979,12284,12292,12312,12319,12330,12351,12436,12447,12535,12543,12586,12842,12850,12964,13200,13215,13218,13253,13263,13267,13270,13384,13428,13727,13839,13851,14617,14703,14801,14816,14964,15183,15471,15585,16471,16736,17208,17325,17330,17374,17623,17997,18018,18212,18218,18301,18318,18760,18811,18814,18820,18823,18844,18848,18872,19576,19620,19738,19887,40870,59244,59336,59367,59413,59417,59423,59431,59437,59443,59452,59460,59478,59493,63789,63866,63894,63976,63986,64016,64018,64021,64025,64034,64037,64042,65074,65093,65107,65112,65127,65132,65375,65510,65536],"gbChars":[0,36,38,45,50,81,89,95,96,100,103,104,105,109,126,133,148,172,175,179,208,306,307,308,309,310,311,312,313,341,428,443,544,545,558,741,742,749,750,805,819,820,7922,7924,7925,7927,7934,7943,7944,7945,7950,8062,8148,8149,8152,8164,8174,8236,8240,8262,8264,8374,8380,8381,8384,8388,8390,8392,8393,8394,8396,8401,8406,8416,8419,8424,8437,8439,8445,8482,8485,8496,8521,8603,8936,8946,9046,9050,9063,9066,9076,9092,9100,9108,9111,9113,9131,9162,9164,9218,9219,11329,11331,11334,11336,11346,11361,11363,11366,11370,11372,11375,11389,11682,11686,11687,11692,11694,11714,11716,11723,11725,11730,11736,11982,11989,12102,12336,12348,12350,12384,12393,12395,12397,12510,12553,12851,12962,12973,13738,13823,13919,13933,14080,14298,14585,14698,15583,15847,16318,16434,16438,16481,16729,17102,17122,17315,17320,17402,17418,17859,17909,17911,17915,17916,17936,17939,17961,18664,18703,18814,18962,19043,33469,33470,33471,33484,33485,33490,33497,33501,33505,33513,33520,33536,33550,37845,37921,37948,38029,38038,38064,38065,38066,38069,38075,38076,38078,39108,39109,39113,39114,39115,39116,39265,39394,189000]}

/***/ }),
/* 103 */
/***/ (function(module, exports) {

	module.exports = [["0","\u0000",127],["8141","갂갃갅갆갋",4,"갘갞갟갡갢갣갥",6,"갮갲갳갴"],["8161","갵갶갷갺갻갽갾갿걁",9,"걌걎",5,"걕"],["8181","걖걗걙걚걛걝",18,"걲걳걵걶걹걻",4,"겂겇겈겍겎겏겑겒겓겕",6,"겞겢",5,"겫겭겮겱",6,"겺겾겿곀곂곃곅곆곇곉곊곋곍",7,"곖곘",7,"곢곣곥곦곩곫곭곮곲곴곷",4,"곾곿괁괂괃괅괇",4,"괎괐괒괓"],["8241","괔괕괖괗괙괚괛괝괞괟괡",7,"괪괫괮",5],["8261","괶괷괹괺괻괽",6,"굆굈굊",5,"굑굒굓굕굖굗"],["8281","굙",7,"굢굤",7,"굮굯굱굲굷굸굹굺굾궀궃",4,"궊궋궍궎궏궑",10,"궞",5,"궥",17,"궸",7,"귂귃귅귆귇귉",6,"귒귔",7,"귝귞귟귡귢귣귥",18],["8341","귺귻귽귾긂",5,"긊긌긎",5,"긕",7],["8361","긝",18,"긲긳긵긶긹긻긼"],["8381","긽긾긿깂깄깇깈깉깋깏깑깒깓깕깗",4,"깞깢깣깤깦깧깪깫깭깮깯깱",6,"깺깾",5,"꺆",5,"꺍",46,"꺿껁껂껃껅",6,"껎껒",5,"껚껛껝",8],["8441","껦껧껩껪껬껮",5,"껵껶껷껹껺껻껽",8],["8461","꼆꼉꼊꼋꼌꼎꼏꼑",18],["8481","꼤",7,"꼮꼯꼱꼳꼵",6,"꼾꽀꽄꽅꽆꽇꽊",5,"꽑",10,"꽞",5,"꽦",18,"꽺",5,"꾁꾂꾃꾅꾆꾇꾉",6,"꾒꾓꾔꾖",5,"꾝",26,"꾺꾻꾽꾾"],["8541","꾿꿁",5,"꿊꿌꿏",4,"꿕",6,"꿝",4],["8561","꿢",5,"꿪",5,"꿲꿳꿵꿶꿷꿹",6,"뀂뀃"],["8581","뀅",6,"뀍뀎뀏뀑뀒뀓뀕",6,"뀞",9,"뀩",26,"끆끇끉끋끍끏끐끑끒끖끘끚끛끜끞",29,"끾끿낁낂낃낅",6,"낎낐낒",5,"낛낝낞낣낤"],["8641","낥낦낧낪낰낲낶낷낹낺낻낽",6,"냆냊",5,"냒"],["8661","냓냕냖냗냙",6,"냡냢냣냤냦",10],["8681","냱",22,"넊넍넎넏넑넔넕넖넗넚넞",4,"넦넧넩넪넫넭",6,"넶넺",5,"녂녃녅녆녇녉",6,"녒녓녖녗녙녚녛녝녞녟녡",22,"녺녻녽녾녿놁놃",4,"놊놌놎놏놐놑놕놖놗놙놚놛놝"],["8741","놞",9,"놩",15],["8761","놹",18,"뇍뇎뇏뇑뇒뇓뇕"],["8781","뇖",5,"뇞뇠",7,"뇪뇫뇭뇮뇯뇱",7,"뇺뇼뇾",5,"눆눇눉눊눍",6,"눖눘눚",5,"눡",18,"눵",6,"눽",26,"뉙뉚뉛뉝뉞뉟뉡",6,"뉪",4],["8841","뉯",4,"뉶",5,"뉽",6,"늆늇늈늊",4],["8861","늏늒늓늕늖늗늛",4,"늢늤늧늨늩늫늭늮늯늱늲늳늵늶늷"],["8881","늸",15,"닊닋닍닎닏닑닓",4,"닚닜닞닟닠닡닣닧닩닪닰닱닲닶닼닽닾댂댃댅댆댇댉",6,"댒댖",5,"댝",54,"덗덙덚덝덠덡덢덣"],["8941","덦덨덪덬덭덯덲덳덵덶덷덹",6,"뎂뎆",5,"뎍"],["8961","뎎뎏뎑뎒뎓뎕",10,"뎢",5,"뎩뎪뎫뎭"],["8981","뎮",21,"돆돇돉돊돍돏돑돒돓돖돘돚돜돞돟돡돢돣돥돦돧돩",18,"돽",18,"됑",6,"됙됚됛됝됞됟됡",6,"됪됬",7,"됵",15],["8a41","둅",10,"둒둓둕둖둗둙",6,"둢둤둦"],["8a61","둧",4,"둭",18,"뒁뒂"],["8a81","뒃",4,"뒉",19,"뒞",5,"뒥뒦뒧뒩뒪뒫뒭",7,"뒶뒸뒺",5,"듁듂듃듅듆듇듉",6,"듑듒듓듔듖",5,"듞듟듡듢듥듧",4,"듮듰듲",5,"듹",26,"딖딗딙딚딝"],["8b41","딞",5,"딦딫",4,"딲딳딵딶딷딹",6,"땂땆"],["8b61","땇땈땉땊땎땏땑땒땓땕",6,"땞땢",8],["8b81","땫",52,"떢떣떥떦떧떩떬떭떮떯떲떶",4,"떾떿뗁뗂뗃뗅",6,"뗎뗒",5,"뗙",18,"뗭",18],["8c41","똀",15,"똒똓똕똖똗똙",4],["8c61","똞",6,"똦",5,"똭",6,"똵",5],["8c81","똻",12,"뙉",26,"뙥뙦뙧뙩",50,"뚞뚟뚡뚢뚣뚥",5,"뚭뚮뚯뚰뚲",16],["8d41","뛃",16,"뛕",8],["8d61","뛞",17,"뛱뛲뛳뛵뛶뛷뛹뛺"],["8d81","뛻",4,"뜂뜃뜄뜆",33,"뜪뜫뜭뜮뜱",6,"뜺뜼",7,"띅띆띇띉띊띋띍",6,"띖",9,"띡띢띣띥띦띧띩",6,"띲띴띶",5,"띾띿랁랂랃랅",6,"랎랓랔랕랚랛랝랞"],["8e41","랟랡",6,"랪랮",5,"랶랷랹",8],["8e61","럂",4,"럈럊",19],["8e81","럞",13,"럮럯럱럲럳럵",6,"럾렂",4,"렊렋렍렎렏렑",6,"렚렜렞",5,"렦렧렩렪렫렭",6,"렶렺",5,"롁롂롃롅",11,"롒롔",7,"롞롟롡롢롣롥",6,"롮롰롲",5,"롹롺롻롽",7],["8f41","뢅",7,"뢎",17],["8f61","뢠",7,"뢩",6,"뢱뢲뢳뢵뢶뢷뢹",4],["8f81","뢾뢿룂룄룆",5,"룍룎룏룑룒룓룕",7,"룞룠룢",5,"룪룫룭룮룯룱",6,"룺룼룾",5,"뤅",18,"뤙",6,"뤡",26,"뤾뤿륁륂륃륅",6,"륍륎륐륒",5],["9041","륚륛륝륞륟륡",6,"륪륬륮",5,"륶륷륹륺륻륽"],["9061","륾",5,"릆릈릋릌릏",15],["9081","릟",12,"릮릯릱릲릳릵",6,"릾맀맂",5,"맊맋맍맓",4,"맚맜맟맠맢맦맧맩맪맫맭",6,"맶맻",4,"먂",5,"먉",11,"먖",33,"먺먻먽먾먿멁멃멄멅멆"],["9141","멇멊멌멏멐멑멒멖멗멙멚멛멝",6,"멦멪",5],["9161","멲멳멵멶멷멹",9,"몆몈몉몊몋몍",5],["9181","몓",20,"몪몭몮몯몱몳",4,"몺몼몾",5,"뫅뫆뫇뫉",14,"뫚",33,"뫽뫾뫿묁묂묃묅",7,"묎묐묒",5,"묙묚묛묝묞묟묡",6],["9241","묨묪묬",7,"묷묹묺묿",4,"뭆뭈뭊뭋뭌뭎뭑뭒"],["9261","뭓뭕뭖뭗뭙",7,"뭢뭤",7,"뭭",4],["9281","뭲",21,"뮉뮊뮋뮍뮎뮏뮑",18,"뮥뮦뮧뮩뮪뮫뮭",6,"뮵뮶뮸",7,"믁믂믃믅믆믇믉",6,"믑믒믔",35,"믺믻믽믾밁"],["9341","밃",4,"밊밎밐밒밓밙밚밠밡밢밣밦밨밪밫밬밮밯밲밳밵"],["9361","밶밷밹",6,"뱂뱆뱇뱈뱊뱋뱎뱏뱑",8],["9381","뱚뱛뱜뱞",37,"벆벇벉벊벍벏",4,"벖벘벛",4,"벢벣벥벦벩",6,"벲벶",5,"벾벿볁볂볃볅",7,"볎볒볓볔볖볗볙볚볛볝",22,"볷볹볺볻볽"],["9441","볾",5,"봆봈봊",5,"봑봒봓봕",8],["9461","봞",5,"봥",6,"봭",12],["9481","봺",5,"뵁",6,"뵊뵋뵍뵎뵏뵑",6,"뵚",9,"뵥뵦뵧뵩",22,"붂붃붅붆붋",4,"붒붔붖붗붘붛붝",6,"붥",10,"붱",6,"붹",24],["9541","뷒뷓뷖뷗뷙뷚뷛뷝",11,"뷪",5,"뷱"],["9561","뷲뷳뷵뷶뷷뷹",6,"븁븂븄븆",5,"븎븏븑븒븓"],["9581","븕",6,"븞븠",35,"빆빇빉빊빋빍빏",4,"빖빘빜빝빞빟빢빣빥빦빧빩빫",4,"빲빶",4,"빾빿뺁뺂뺃뺅",6,"뺎뺒",5,"뺚",13,"뺩",14],["9641","뺸",23,"뻒뻓"],["9661","뻕뻖뻙",6,"뻡뻢뻦",5,"뻭",8],["9681","뻶",10,"뼂",5,"뼊",13,"뼚뼞",33,"뽂뽃뽅뽆뽇뽉",6,"뽒뽓뽔뽖",44],["9741","뾃",16,"뾕",8],["9761","뾞",17,"뾱",7],["9781","뾹",11,"뿆",5,"뿎뿏뿑뿒뿓뿕",6,"뿝뿞뿠뿢",89,"쀽쀾쀿"],["9841","쁀",16,"쁒",5,"쁙쁚쁛"],["9861","쁝쁞쁟쁡",6,"쁪",15],["9881","쁺",21,"삒삓삕삖삗삙",6,"삢삤삦",5,"삮삱삲삷",4,"삾샂샃샄샆샇샊샋샍샎샏샑",6,"샚샞",5,"샦샧샩샪샫샭",6,"샶샸샺",5,"섁섂섃섅섆섇섉",6,"섑섒섓섔섖",5,"섡섢섥섨섩섪섫섮"],["9941","섲섳섴섵섷섺섻섽섾섿셁",6,"셊셎",5,"셖셗"],["9961","셙셚셛셝",6,"셦셪",5,"셱셲셳셵셶셷셹셺셻"],["9981","셼",8,"솆",5,"솏솑솒솓솕솗",4,"솞솠솢솣솤솦솧솪솫솭솮솯솱",11,"솾",5,"쇅쇆쇇쇉쇊쇋쇍",6,"쇕쇖쇙",6,"쇡쇢쇣쇥쇦쇧쇩",6,"쇲쇴",7,"쇾쇿숁숂숃숅",6,"숎숐숒",5,"숚숛숝숞숡숢숣"],["9a41","숤숥숦숧숪숬숮숰숳숵",16],["9a61","쉆쉇쉉",6,"쉒쉓쉕쉖쉗쉙",6,"쉡쉢쉣쉤쉦"],["9a81","쉧",4,"쉮쉯쉱쉲쉳쉵",6,"쉾슀슂",5,"슊",5,"슑",6,"슙슚슜슞",5,"슦슧슩슪슫슮",5,"슶슸슺",33,"싞싟싡싢싥",5,"싮싰싲싳싴싵싷싺싽싾싿쌁",6,"쌊쌋쌎쌏"],["9b41","쌐쌑쌒쌖쌗쌙쌚쌛쌝",6,"쌦쌧쌪",8],["9b61","쌳",17,"썆",7],["9b81","썎",25,"썪썫썭썮썯썱썳",4,"썺썻썾",5,"쎅쎆쎇쎉쎊쎋쎍",50,"쏁",22,"쏚"],["9c41","쏛쏝쏞쏡쏣",4,"쏪쏫쏬쏮",5,"쏶쏷쏹",5],["9c61","쏿",8,"쐉",6,"쐑",9],["9c81","쐛",8,"쐥",6,"쐭쐮쐯쐱쐲쐳쐵",6,"쐾",9,"쑉",26,"쑦쑧쑩쑪쑫쑭",6,"쑶쑷쑸쑺",5,"쒁",18,"쒕",6,"쒝",12],["9d41","쒪",13,"쒹쒺쒻쒽",8],["9d61","쓆",25],["9d81","쓠",8,"쓪",5,"쓲쓳쓵쓶쓷쓹쓻쓼쓽쓾씂",9,"씍씎씏씑씒씓씕",6,"씝",10,"씪씫씭씮씯씱",6,"씺씼씾",5,"앆앇앋앏앐앑앒앖앚앛앜앟앢앣앥앦앧앩",6,"앲앶",5,"앾앿얁얂얃얅얆얈얉얊얋얎얐얒얓얔"],["9e41","얖얙얚얛얝얞얟얡",7,"얪",9,"얶"],["9e61","얷얺얿",4,"엋엍엏엒엓엕엖엗엙",6,"엢엤엦엧"],["9e81","엨엩엪엫엯엱엲엳엵엸엹엺엻옂옃옄옉옊옋옍옎옏옑",6,"옚옝",6,"옦옧옩옪옫옯옱옲옶옸옺옼옽옾옿왂왃왅왆왇왉",6,"왒왖",5,"왞왟왡",10,"왭왮왰왲",5,"왺왻왽왾왿욁",6,"욊욌욎",5,"욖욗욙욚욛욝",6,"욦"],["9f41","욨욪",5,"욲욳욵욶욷욻",4,"웂웄웆",5,"웎"],["9f61","웏웑웒웓웕",6,"웞웟웢",5,"웪웫웭웮웯웱웲"],["9f81","웳",4,"웺웻웼웾",5,"윆윇윉윊윋윍",6,"윖윘윚",5,"윢윣윥윦윧윩",6,"윲윴윶윸윹윺윻윾윿읁읂읃읅",4,"읋읎읐읙읚읛읝읞읟읡",6,"읩읪읬",7,"읶읷읹읺읻읿잀잁잂잆잋잌잍잏잒잓잕잙잛",4,"잢잧",4,"잮잯잱잲잳잵잶잷"],["a041","잸잹잺잻잾쟂",5,"쟊쟋쟍쟏쟑",6,"쟙쟚쟛쟜"],["a061","쟞",5,"쟥쟦쟧쟩쟪쟫쟭",13],["a081","쟻",4,"젂젃젅젆젇젉젋",4,"젒젔젗",4,"젞젟젡젢젣젥",6,"젮젰젲",5,"젹젺젻젽젾젿졁",6,"졊졋졎",5,"졕",26,"졲졳졵졶졷졹졻",4,"좂좄좈좉좊좎",5,"좕",7,"좞좠좢좣좤"],["a141","좥좦좧좩",18,"좾좿죀죁"],["a161","죂죃죅죆죇죉죊죋죍",6,"죖죘죚",5,"죢죣죥"],["a181","죦",14,"죶",5,"죾죿줁줂줃줇",4,"줎　、。·‥…¨〃­―∥＼∼‘’“”〔〕〈",9,"±×÷≠≤≥∞∴°′″℃Å￠￡￥♂♀∠⊥⌒∂∇≡≒§※☆★○●◎◇◆□■△▲▽▼→←↑↓↔〓≪≫√∽∝∵∫∬∈∋⊆⊇⊂⊃∪∩∧∨￢"],["a241","줐줒",5,"줙",18],["a261","줭",6,"줵",18],["a281","쥈",7,"쥒쥓쥕쥖쥗쥙",6,"쥢쥤",7,"쥭쥮쥯⇒⇔∀∃´～ˇ˘˝˚˙¸˛¡¿ː∮∑∏¤℉‰◁◀▷▶♤♠♡♥♧♣⊙◈▣◐◑▒▤▥▨▧▦▩♨☏☎☜☞¶†‡↕↗↙↖↘♭♩♪♬㉿㈜№㏇™㏂㏘℡€®"],["a341","쥱쥲쥳쥵",6,"쥽",10,"즊즋즍즎즏"],["a361","즑",6,"즚즜즞",16],["a381","즯",16,"짂짃짅짆짉짋",4,"짒짔짗짘짛！",58,"￦］",32,"￣"],["a441","짞짟짡짣짥짦짨짩짪짫짮짲",5,"짺짻짽짾짿쨁쨂쨃쨄"],["a461","쨅쨆쨇쨊쨎",5,"쨕쨖쨗쨙",12],["a481","쨦쨧쨨쨪",28,"ㄱ",93],["a541","쩇",4,"쩎쩏쩑쩒쩓쩕",6,"쩞쩢",5,"쩩쩪"],["a561","쩫",17,"쩾",5,"쪅쪆"],["a581","쪇",16,"쪙",14,"ⅰ",9],["a5b0","Ⅰ",9],["a5c1","Α",16,"Σ",6],["a5e1","α",16,"σ",6],["a641","쪨",19,"쪾쪿쫁쫂쫃쫅"],["a661","쫆",5,"쫎쫐쫒쫔쫕쫖쫗쫚",5,"쫡",6],["a681","쫨쫩쫪쫫쫭",6,"쫵",18,"쬉쬊─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂┒┑┚┙┖┕┎┍┞┟┡┢┦┧┩┪┭┮┱┲┵┶┹┺┽┾╀╁╃",7],["a741","쬋",4,"쬑쬒쬓쬕쬖쬗쬙",6,"쬢",7],["a761","쬪",22,"쭂쭃쭄"],["a781","쭅쭆쭇쭊쭋쭍쭎쭏쭑",6,"쭚쭛쭜쭞",5,"쭥",7,"㎕㎖㎗ℓ㎘㏄㎣㎤㎥㎦㎙",9,"㏊㎍㎎㎏㏏㎈㎉㏈㎧㎨㎰",9,"㎀",4,"㎺",5,"㎐",4,"Ω㏀㏁㎊㎋㎌㏖㏅㎭㎮㎯㏛㎩㎪㎫㎬㏝㏐㏓㏃㏉㏜㏆"],["a841","쭭",10,"쭺",14],["a861","쮉",18,"쮝",6],["a881","쮤",19,"쮹",11,"ÆÐªĦ"],["a8a6","Ĳ"],["a8a8","ĿŁØŒºÞŦŊ"],["a8b1","㉠",27,"ⓐ",25,"①",14,"½⅓⅔¼¾⅛⅜⅝⅞"],["a941","쯅",14,"쯕",10],["a961","쯠쯡쯢쯣쯥쯦쯨쯪",18],["a981","쯽",14,"찎찏찑찒찓찕",6,"찞찟찠찣찤æđðħıĳĸŀłøœßþŧŋŉ㈀",27,"⒜",25,"⑴",14,"¹²³⁴ⁿ₁₂₃₄"],["aa41","찥찦찪찫찭찯찱",6,"찺찿",4,"챆챇챉챊챋챍챎"],["aa61","챏",4,"챖챚",5,"챡챢챣챥챧챩",6,"챱챲"],["aa81","챳챴챶",29,"ぁ",82],["ab41","첔첕첖첗첚첛첝첞첟첡",6,"첪첮",5,"첶첷첹"],["ab61","첺첻첽",6,"쳆쳈쳊",5,"쳑쳒쳓쳕",5],["ab81","쳛",8,"쳥",6,"쳭쳮쳯쳱",12,"ァ",85],["ac41","쳾쳿촀촂",5,"촊촋촍촎촏촑",6,"촚촜촞촟촠"],["ac61","촡촢촣촥촦촧촩촪촫촭",11,"촺",4],["ac81","촿",28,"쵝쵞쵟А",5,"ЁЖ",25],["acd1","а",5,"ёж",25],["ad41","쵡쵢쵣쵥",6,"쵮쵰쵲",5,"쵹",7],["ad61","춁",6,"춉",10,"춖춗춙춚춛춝춞춟"],["ad81","춠춡춢춣춦춨춪",5,"춱",18,"췅"],["ae41","췆",5,"췍췎췏췑",16],["ae61","췢",5,"췩췪췫췭췮췯췱",6,"췺췼췾",4],["ae81","츃츅츆츇츉츊츋츍",6,"츕츖츗츘츚",5,"츢츣츥츦츧츩츪츫"],["af41","츬츭츮츯츲츴츶",19],["af61","칊",13,"칚칛칝칞칢",5,"칪칬"],["af81","칮",5,"칶칷칹칺칻칽",6,"캆캈캊",5,"캒캓캕캖캗캙"],["b041","캚",5,"캢캦",5,"캮",12],["b061","캻",5,"컂",19],["b081","컖",13,"컦컧컩컪컭",6,"컶컺",5,"가각간갇갈갉갊감",7,"같",4,"갠갤갬갭갯갰갱갸갹갼걀걋걍걔걘걜거걱건걷걸걺검겁것겄겅겆겉겊겋게겐겔겜겝겟겠겡겨격겪견겯결겸겹겻겼경곁계곈곌곕곗고곡곤곧골곪곬곯곰곱곳공곶과곽관괄괆"],["b141","켂켃켅켆켇켉",6,"켒켔켖",5,"켝켞켟켡켢켣"],["b161","켥",6,"켮켲",5,"켹",11],["b181","콅",14,"콖콗콙콚콛콝",6,"콦콨콪콫콬괌괍괏광괘괜괠괩괬괭괴괵괸괼굄굅굇굉교굔굘굡굣구국군굳굴굵굶굻굼굽굿궁궂궈궉권궐궜궝궤궷귀귁귄귈귐귑귓규균귤그극근귿글긁금급긋긍긔기긱긴긷길긺김깁깃깅깆깊까깍깎깐깔깖깜깝깟깠깡깥깨깩깬깰깸"],["b241","콭콮콯콲콳콵콶콷콹",6,"쾁쾂쾃쾄쾆",5,"쾍"],["b261","쾎",18,"쾢",5,"쾩"],["b281","쾪",5,"쾱",18,"쿅",6,"깹깻깼깽꺄꺅꺌꺼꺽꺾껀껄껌껍껏껐껑께껙껜껨껫껭껴껸껼꼇꼈꼍꼐꼬꼭꼰꼲꼴꼼꼽꼿꽁꽂꽃꽈꽉꽐꽜꽝꽤꽥꽹꾀꾄꾈꾐꾑꾕꾜꾸꾹꾼꿀꿇꿈꿉꿋꿍꿎꿔꿜꿨꿩꿰꿱꿴꿸뀀뀁뀄뀌뀐뀔뀜뀝뀨끄끅끈끊끌끎끓끔끕끗끙"],["b341","쿌",19,"쿢쿣쿥쿦쿧쿩"],["b361","쿪",5,"쿲쿴쿶",5,"쿽쿾쿿퀁퀂퀃퀅",5],["b381","퀋",5,"퀒",5,"퀙",19,"끝끼끽낀낄낌낍낏낑나낙낚난낟날낡낢남납낫",4,"낱낳내낵낸낼냄냅냇냈냉냐냑냔냘냠냥너넉넋넌널넒넓넘넙넛넜넝넣네넥넨넬넴넵넷넸넹녀녁년녈념녑녔녕녘녜녠노녹논놀놂놈놉놋농높놓놔놘놜놨뇌뇐뇔뇜뇝"],["b441","퀮",5,"퀶퀷퀹퀺퀻퀽",6,"큆큈큊",5],["b461","큑큒큓큕큖큗큙",6,"큡",10,"큮큯"],["b481","큱큲큳큵",6,"큾큿킀킂",18,"뇟뇨뇩뇬뇰뇹뇻뇽누눅눈눋눌눔눕눗눙눠눴눼뉘뉜뉠뉨뉩뉴뉵뉼늄늅늉느늑는늘늙늚늠늡늣능늦늪늬늰늴니닉닌닐닒님닙닛닝닢다닥닦단닫",4,"닳담답닷",4,"닿대댁댄댈댐댑댓댔댕댜더덕덖던덛덜덞덟덤덥"],["b541","킕",14,"킦킧킩킪킫킭",5],["b561","킳킶킸킺",5,"탂탃탅탆탇탊",5,"탒탖",4],["b581","탛탞탟탡탢탣탥",6,"탮탲",5,"탹",11,"덧덩덫덮데덱덴델뎀뎁뎃뎄뎅뎌뎐뎔뎠뎡뎨뎬도독돈돋돌돎돐돔돕돗동돛돝돠돤돨돼됐되된될됨됩됫됴두둑둔둘둠둡둣둥둬뒀뒈뒝뒤뒨뒬뒵뒷뒹듀듄듈듐듕드득든듣들듦듬듭듯등듸디딕딘딛딜딤딥딧딨딩딪따딱딴딸"],["b641","턅",7,"턎",17],["b661","턠",15,"턲턳턵턶턷턹턻턼턽턾"],["b681","턿텂텆",5,"텎텏텑텒텓텕",6,"텞텠텢",5,"텩텪텫텭땀땁땃땄땅땋때땍땐땔땜땝땟땠땡떠떡떤떨떪떫떰떱떳떴떵떻떼떽뗀뗄뗌뗍뗏뗐뗑뗘뗬또똑똔똘똥똬똴뙈뙤뙨뚜뚝뚠뚤뚫뚬뚱뛔뛰뛴뛸뜀뜁뜅뜨뜩뜬뜯뜰뜸뜹뜻띄띈띌띔띕띠띤띨띰띱띳띵라락란랄람랍랏랐랑랒랖랗"],["b741","텮",13,"텽",6,"톅톆톇톉톊"],["b761","톋",20,"톢톣톥톦톧"],["b781","톩",6,"톲톴톶톷톸톹톻톽톾톿퇁",14,"래랙랜랠램랩랫랬랭랴략랸럇량러럭런럴럼럽럿렀렁렇레렉렌렐렘렙렛렝려력련렬렴렵렷렸령례롄롑롓로록론롤롬롭롯롱롸롼뢍뢨뢰뢴뢸룀룁룃룅료룐룔룝룟룡루룩룬룰룸룹룻룽뤄뤘뤠뤼뤽륀륄륌륏륑류륙륜률륨륩"],["b841","퇐",7,"퇙",17],["b861","퇫",8,"퇵퇶퇷퇹",13],["b881","툈툊",5,"툑",24,"륫륭르륵른를름릅릇릉릊릍릎리릭린릴림립릿링마막만많",4,"맘맙맛망맞맡맣매맥맨맬맴맵맷맸맹맺먀먁먈먕머먹먼멀멂멈멉멋멍멎멓메멕멘멜멤멥멧멨멩며멱면멸몃몄명몇몌모목몫몬몰몲몸몹못몽뫄뫈뫘뫙뫼"],["b941","툪툫툮툯툱툲툳툵",6,"툾퉀퉂",5,"퉉퉊퉋퉌"],["b961","퉍",14,"퉝",6,"퉥퉦퉧퉨"],["b981","퉩",22,"튂튃튅튆튇튉튊튋튌묀묄묍묏묑묘묜묠묩묫무묵묶문묻물묽묾뭄뭅뭇뭉뭍뭏뭐뭔뭘뭡뭣뭬뮈뮌뮐뮤뮨뮬뮴뮷므믄믈믐믓미믹민믿밀밂밈밉밋밌밍및밑바",4,"받",4,"밤밥밧방밭배백밴밸뱀뱁뱃뱄뱅뱉뱌뱍뱐뱝버벅번벋벌벎범법벗"],["ba41","튍튎튏튒튓튔튖",5,"튝튞튟튡튢튣튥",6,"튭"],["ba61","튮튯튰튲",5,"튺튻튽튾틁틃",4,"틊틌",5],["ba81","틒틓틕틖틗틙틚틛틝",6,"틦",9,"틲틳틵틶틷틹틺벙벚베벡벤벧벨벰벱벳벴벵벼벽변별볍볏볐병볕볘볜보복볶본볼봄봅봇봉봐봔봤봬뵀뵈뵉뵌뵐뵘뵙뵤뵨부북분붇불붉붊붐붑붓붕붙붚붜붤붰붸뷔뷕뷘뷜뷩뷰뷴뷸븀븃븅브븍븐블븜븝븟비빅빈빌빎빔빕빗빙빚빛빠빡빤"],["bb41","틻",4,"팂팄팆",5,"팏팑팒팓팕팗",4,"팞팢팣"],["bb61","팤팦팧팪팫팭팮팯팱",6,"팺팾",5,"퍆퍇퍈퍉"],["bb81","퍊",31,"빨빪빰빱빳빴빵빻빼빽뺀뺄뺌뺍뺏뺐뺑뺘뺙뺨뻐뻑뻔뻗뻘뻠뻣뻤뻥뻬뼁뼈뼉뼘뼙뼛뼜뼝뽀뽁뽄뽈뽐뽑뽕뾔뾰뿅뿌뿍뿐뿔뿜뿟뿡쀼쁑쁘쁜쁠쁨쁩삐삑삔삘삠삡삣삥사삭삯산삳살삵삶삼삽삿샀상샅새색샌샐샘샙샛샜생샤"],["bc41","퍪",17,"퍾퍿펁펂펃펅펆펇"],["bc61","펈펉펊펋펎펒",5,"펚펛펝펞펟펡",6,"펪펬펮"],["bc81","펯",4,"펵펶펷펹펺펻펽",6,"폆폇폊",5,"폑",5,"샥샨샬샴샵샷샹섀섄섈섐섕서",4,"섣설섦섧섬섭섯섰성섶세섹센셀셈셉셋셌셍셔셕션셜셤셥셧셨셩셰셴셸솅소속솎손솔솖솜솝솟송솥솨솩솬솰솽쇄쇈쇌쇔쇗쇘쇠쇤쇨쇰쇱쇳쇼쇽숀숄숌숍숏숑수숙순숟술숨숩숫숭"],["bd41","폗폙",7,"폢폤",7,"폮폯폱폲폳폵폶폷"],["bd61","폸폹폺폻폾퐀퐂",5,"퐉",13],["bd81","퐗",5,"퐞",25,"숯숱숲숴쉈쉐쉑쉔쉘쉠쉥쉬쉭쉰쉴쉼쉽쉿슁슈슉슐슘슛슝스슥슨슬슭슴습슷승시식신싣실싫심십싯싱싶싸싹싻싼쌀쌈쌉쌌쌍쌓쌔쌕쌘쌜쌤쌥쌨쌩썅써썩썬썰썲썸썹썼썽쎄쎈쎌쏀쏘쏙쏜쏟쏠쏢쏨쏩쏭쏴쏵쏸쐈쐐쐤쐬쐰"],["be41","퐸",7,"푁푂푃푅",14],["be61","푔",7,"푝푞푟푡푢푣푥",7,"푮푰푱푲"],["be81","푳",4,"푺푻푽푾풁풃",4,"풊풌풎",5,"풕",8,"쐴쐼쐽쑈쑤쑥쑨쑬쑴쑵쑹쒀쒔쒜쒸쒼쓩쓰쓱쓴쓸쓺쓿씀씁씌씐씔씜씨씩씬씰씸씹씻씽아악안앉않알앍앎앓암압앗았앙앝앞애액앤앨앰앱앳앴앵야약얀얄얇얌얍얏양얕얗얘얜얠얩어억언얹얻얼얽얾엄",6,"엌엎"],["bf41","풞",10,"풪",14],["bf61","풹",18,"퓍퓎퓏퓑퓒퓓퓕"],["bf81","퓖",5,"퓝퓞퓠",7,"퓩퓪퓫퓭퓮퓯퓱",6,"퓹퓺퓼에엑엔엘엠엡엣엥여역엮연열엶엷염",5,"옅옆옇예옌옐옘옙옛옜오옥온올옭옮옰옳옴옵옷옹옻와왁완왈왐왑왓왔왕왜왝왠왬왯왱외왹왼욀욈욉욋욍요욕욘욜욤욥욧용우욱운울욹욺움웁웃웅워웍원월웜웝웠웡웨"],["c041","퓾",5,"픅픆픇픉픊픋픍",6,"픖픘",5],["c061","픞",25],["c081","픸픹픺픻픾픿핁핂핃핅",6,"핎핐핒",5,"핚핛핝핞핟핡핢핣웩웬웰웸웹웽위윅윈윌윔윕윗윙유육윤율윰윱윳융윷으윽은을읊음읍읏응",7,"읜읠읨읫이익인일읽읾잃임입잇있잉잊잎자작잔잖잗잘잚잠잡잣잤장잦재잭잰잴잼잽잿쟀쟁쟈쟉쟌쟎쟐쟘쟝쟤쟨쟬저적전절젊"],["c141","핤핦핧핪핬핮",5,"핶핷핹핺핻핽",6,"햆햊햋"],["c161","햌햍햎햏햑",19,"햦햧"],["c181","햨",31,"점접젓정젖제젝젠젤젬젭젯젱져젼졀졈졉졌졍졔조족존졸졺좀좁좃종좆좇좋좌좍좔좝좟좡좨좼좽죄죈죌죔죕죗죙죠죡죤죵주죽준줄줅줆줌줍줏중줘줬줴쥐쥑쥔쥘쥠쥡쥣쥬쥰쥴쥼즈즉즌즐즘즙즛증지직진짇질짊짐집짓"],["c241","헊헋헍헎헏헑헓",4,"헚헜헞",5,"헦헧헩헪헫헭헮"],["c261","헯",4,"헶헸헺",5,"혂혃혅혆혇혉",6,"혒"],["c281","혖",5,"혝혞혟혡혢혣혥",7,"혮",9,"혺혻징짖짙짚짜짝짠짢짤짧짬짭짯짰짱째짹짼쨀쨈쨉쨋쨌쨍쨔쨘쨩쩌쩍쩐쩔쩜쩝쩟쩠쩡쩨쩽쪄쪘쪼쪽쫀쫄쫌쫍쫏쫑쫓쫘쫙쫠쫬쫴쬈쬐쬔쬘쬠쬡쭁쭈쭉쭌쭐쭘쭙쭝쭤쭸쭹쮜쮸쯔쯤쯧쯩찌찍찐찔찜찝찡찢찧차착찬찮찰참찹찻"],["c341","혽혾혿홁홂홃홄홆홇홊홌홎홏홐홒홓홖홗홙홚홛홝",4],["c361","홢",4,"홨홪",5,"홲홳홵",11],["c381","횁횂횄횆",5,"횎횏횑횒횓횕",7,"횞횠횢",5,"횩횪찼창찾채책챈챌챔챕챗챘챙챠챤챦챨챰챵처척천철첨첩첫첬청체첵첸첼쳄쳅쳇쳉쳐쳔쳤쳬쳰촁초촉촌촐촘촙촛총촤촨촬촹최쵠쵤쵬쵭쵯쵱쵸춈추축춘출춤춥춧충춰췄췌췐취췬췰췸췹췻췽츄츈츌츔츙츠측츤츨츰츱츳층"],["c441","횫횭횮횯횱",7,"횺횼",7,"훆훇훉훊훋"],["c461","훍훎훏훐훒훓훕훖훘훚",5,"훡훢훣훥훦훧훩",4],["c481","훮훯훱훲훳훴훶",5,"훾훿휁휂휃휅",11,"휒휓휔치칙친칟칠칡침칩칫칭카칵칸칼캄캅캇캉캐캑캔캘캠캡캣캤캥캬캭컁커컥컨컫컬컴컵컷컸컹케켁켄켈켐켑켓켕켜켠켤켬켭켯켰켱켸코콕콘콜콤콥콧콩콰콱콴콸쾀쾅쾌쾡쾨쾰쿄쿠쿡쿤쿨쿰쿱쿳쿵쿼퀀퀄퀑퀘퀭퀴퀵퀸퀼"],["c541","휕휖휗휚휛휝휞휟휡",6,"휪휬휮",5,"휶휷휹"],["c561","휺휻휽",6,"흅흆흈흊",5,"흒흓흕흚",4],["c581","흟흢흤흦흧흨흪흫흭흮흯흱흲흳흵",6,"흾흿힀힂",5,"힊힋큄큅큇큉큐큔큘큠크큭큰클큼큽킁키킥킨킬킴킵킷킹타탁탄탈탉탐탑탓탔탕태택탠탤탬탭탯탰탱탸턍터턱턴털턺텀텁텃텄텅테텍텐텔템텝텟텡텨텬텼톄톈토톡톤톨톰톱톳통톺톼퇀퇘퇴퇸툇툉툐투툭툰툴툼툽툿퉁퉈퉜"],["c641","힍힎힏힑",6,"힚힜힞",5],["c6a1","퉤튀튁튄튈튐튑튕튜튠튤튬튱트특튼튿틀틂틈틉틋틔틘틜틤틥티틱틴틸팀팁팃팅파팍팎판팔팖팜팝팟팠팡팥패팩팬팰팸팹팻팼팽퍄퍅퍼퍽펀펄펌펍펏펐펑페펙펜펠펨펩펫펭펴편펼폄폅폈평폐폘폡폣포폭폰폴폼폽폿퐁"],["c7a1","퐈퐝푀푄표푠푤푭푯푸푹푼푿풀풂품풉풋풍풔풩퓌퓐퓔퓜퓟퓨퓬퓰퓸퓻퓽프픈플픔픕픗피픽핀필핌핍핏핑하학한할핥함합핫항해핵핸핼햄햅햇했행햐향허헉헌헐헒험헙헛헝헤헥헨헬헴헵헷헹혀혁현혈혐협혓혔형혜혠"],["c8a1","혤혭호혹혼홀홅홈홉홋홍홑화확환활홧황홰홱홴횃횅회획횐횔횝횟횡효횬횰횹횻후훅훈훌훑훔훗훙훠훤훨훰훵훼훽휀휄휑휘휙휜휠휨휩휫휭휴휵휸휼흄흇흉흐흑흔흖흗흘흙흠흡흣흥흩희흰흴흼흽힁히힉힌힐힘힙힛힝"],["caa1","伽佳假價加可呵哥嘉嫁家暇架枷柯歌珂痂稼苛茄街袈訶賈跏軻迦駕刻却各恪慤殼珏脚覺角閣侃刊墾奸姦干幹懇揀杆柬桿澗癎看磵稈竿簡肝艮艱諫間乫喝曷渴碣竭葛褐蝎鞨勘坎堪嵌感憾戡敢柑橄減甘疳監瞰紺邯鑑鑒龕"],["cba1","匣岬甲胛鉀閘剛堈姜岡崗康强彊慷江畺疆糠絳綱羌腔舡薑襁講鋼降鱇介价個凱塏愷愾慨改槪漑疥皆盖箇芥蓋豈鎧開喀客坑更粳羹醵倨去居巨拒据據擧渠炬祛距踞車遽鉅鋸乾件健巾建愆楗腱虔蹇鍵騫乞傑杰桀儉劍劒檢"],["cca1","瞼鈐黔劫怯迲偈憩揭擊格檄激膈覡隔堅牽犬甄絹繭肩見譴遣鵑抉決潔結缺訣兼慊箝謙鉗鎌京俓倞傾儆勁勍卿坰境庚徑慶憬擎敬景暻更梗涇炅烱璟璥瓊痙硬磬竟競絅經耕耿脛莖警輕逕鏡頃頸驚鯨係啓堺契季屆悸戒桂械"],["cda1","棨溪界癸磎稽系繫繼計誡谿階鷄古叩告呱固姑孤尻庫拷攷故敲暠枯槁沽痼皐睾稿羔考股膏苦苽菰藁蠱袴誥賈辜錮雇顧高鼓哭斛曲梏穀谷鵠困坤崑昆梱棍滾琨袞鯤汨滑骨供公共功孔工恐恭拱控攻珙空蚣貢鞏串寡戈果瓜"],["cea1","科菓誇課跨過鍋顆廓槨藿郭串冠官寬慣棺款灌琯瓘管罐菅觀貫關館刮恝括适侊光匡壙廣曠洸炚狂珖筐胱鑛卦掛罫乖傀塊壞怪愧拐槐魁宏紘肱轟交僑咬喬嬌嶠巧攪敎校橋狡皎矯絞翹膠蕎蛟較轎郊餃驕鮫丘久九仇俱具勾"],["cfa1","區口句咎嘔坵垢寇嶇廐懼拘救枸柩構歐毆毬求溝灸狗玖球瞿矩究絿耉臼舅舊苟衢謳購軀逑邱鉤銶駒驅鳩鷗龜國局菊鞠鞫麴君窘群裙軍郡堀屈掘窟宮弓穹窮芎躬倦券勸卷圈拳捲權淃眷厥獗蕨蹶闕机櫃潰詭軌饋句晷歸貴"],["d0a1","鬼龜叫圭奎揆槻珪硅窺竅糾葵規赳逵閨勻均畇筠菌鈞龜橘克剋劇戟棘極隙僅劤勤懃斤根槿瑾筋芹菫覲謹近饉契今妗擒昑檎琴禁禽芩衾衿襟金錦伋及急扱汲級給亘兢矜肯企伎其冀嗜器圻基埼夔奇妓寄岐崎己幾忌技旗旣"],["d1a1","朞期杞棋棄機欺氣汽沂淇玘琦琪璂璣畸畿碁磯祁祇祈祺箕紀綺羈耆耭肌記譏豈起錡錤飢饑騎騏驥麒緊佶吉拮桔金喫儺喇奈娜懦懶拏拿癩",5,"那樂",4,"諾酪駱亂卵暖欄煖爛蘭難鸞捏捺南嵐枏楠湳濫男藍襤拉"],["d2a1","納臘蠟衲囊娘廊",4,"乃來內奈柰耐冷女年撚秊念恬拈捻寧寗努勞奴弩怒擄櫓爐瑙盧",5,"駑魯",10,"濃籠聾膿農惱牢磊腦賂雷尿壘",7,"嫩訥杻紐勒",5,"能菱陵尼泥匿溺多茶"],["d3a1","丹亶但單團壇彖斷旦檀段湍短端簞緞蛋袒鄲鍛撻澾獺疸達啖坍憺擔曇淡湛潭澹痰聃膽蕁覃談譚錟沓畓答踏遝唐堂塘幢戇撞棠當糖螳黨代垈坮大對岱帶待戴擡玳臺袋貸隊黛宅德悳倒刀到圖堵塗導屠島嶋度徒悼挑掉搗桃"],["d4a1","棹櫂淘渡滔濤燾盜睹禱稻萄覩賭跳蹈逃途道都鍍陶韜毒瀆牘犢獨督禿篤纛讀墩惇敦旽暾沌焞燉豚頓乭突仝冬凍動同憧東桐棟洞潼疼瞳童胴董銅兜斗杜枓痘竇荳讀豆逗頭屯臀芚遁遯鈍得嶝橙燈登等藤謄鄧騰喇懶拏癩羅"],["d5a1","蘿螺裸邏樂洛烙珞絡落諾酪駱丹亂卵欄欒瀾爛蘭鸞剌辣嵐擥攬欖濫籃纜藍襤覽拉臘蠟廊朗浪狼琅瑯螂郞來崍徠萊冷掠略亮倆兩凉梁樑粮粱糧良諒輛量侶儷勵呂廬慮戾旅櫚濾礪藜蠣閭驢驪麗黎力曆歷瀝礫轢靂憐戀攣漣"],["d6a1","煉璉練聯蓮輦連鍊冽列劣洌烈裂廉斂殮濂簾獵令伶囹寧岺嶺怜玲笭羚翎聆逞鈴零靈領齡例澧禮醴隷勞怒撈擄櫓潞瀘爐盧老蘆虜路輅露魯鷺鹵碌祿綠菉錄鹿麓論壟弄朧瀧瓏籠聾儡瀨牢磊賂賚賴雷了僚寮廖料燎療瞭聊蓼"],["d7a1","遼鬧龍壘婁屢樓淚漏瘻累縷蔞褸鏤陋劉旒柳榴流溜瀏琉瑠留瘤硫謬類六戮陸侖倫崙淪綸輪律慄栗率隆勒肋凜凌楞稜綾菱陵俚利厘吏唎履悧李梨浬犁狸理璃異痢籬罹羸莉裏裡里釐離鯉吝潾燐璘藺躪隣鱗麟林淋琳臨霖砬"],["d8a1","立笠粒摩瑪痲碼磨馬魔麻寞幕漠膜莫邈万卍娩巒彎慢挽晩曼滿漫灣瞞萬蔓蠻輓饅鰻唜抹末沫茉襪靺亡妄忘忙望網罔芒茫莽輞邙埋妹媒寐昧枚梅每煤罵買賣邁魅脈貊陌驀麥孟氓猛盲盟萌冪覓免冕勉棉沔眄眠綿緬面麵滅"],["d9a1","蔑冥名命明暝椧溟皿瞑茗蓂螟酩銘鳴袂侮冒募姆帽慕摸摹暮某模母毛牟牡瑁眸矛耗芼茅謀謨貌木沐牧目睦穆鶩歿沒夢朦蒙卯墓妙廟描昴杳渺猫竗苗錨務巫憮懋戊拇撫无楙武毋無珷畝繆舞茂蕪誣貿霧鵡墨默們刎吻問文"],["daa1","汶紊紋聞蚊門雯勿沕物味媚尾嵋彌微未梶楣渼湄眉米美薇謎迷靡黴岷悶愍憫敏旻旼民泯玟珉緡閔密蜜謐剝博拍搏撲朴樸泊珀璞箔粕縛膊舶薄迫雹駁伴半反叛拌搬攀斑槃泮潘班畔瘢盤盼磐磻礬絆般蟠返頒飯勃拔撥渤潑"],["dba1","發跋醱鉢髮魃倣傍坊妨尨幇彷房放方旁昉枋榜滂磅紡肪膀舫芳蒡蚌訪謗邦防龐倍俳北培徘拜排杯湃焙盃背胚裴裵褙賠輩配陪伯佰帛柏栢白百魄幡樊煩燔番磻繁蕃藩飜伐筏罰閥凡帆梵氾汎泛犯範范法琺僻劈壁擘檗璧癖"],["dca1","碧蘗闢霹便卞弁變辨辯邊別瞥鱉鼈丙倂兵屛幷昞昺柄棅炳甁病秉竝輧餠騈保堡報寶普步洑湺潽珤甫菩補褓譜輔伏僕匐卜宓復服福腹茯蔔複覆輹輻馥鰒本乶俸奉封峯峰捧棒烽熢琫縫蓬蜂逢鋒鳳不付俯傅剖副否咐埠夫婦"],["dda1","孚孵富府復扶敷斧浮溥父符簿缶腐腑膚艀芙莩訃負賦賻赴趺部釜阜附駙鳧北分吩噴墳奔奮忿憤扮昐汾焚盆粉糞紛芬賁雰不佛弗彿拂崩朋棚硼繃鵬丕備匕匪卑妃婢庇悲憊扉批斐枇榧比毖毗毘沸泌琵痺砒碑秕秘粃緋翡肥"],["dea1","脾臂菲蜚裨誹譬費鄙非飛鼻嚬嬪彬斌檳殯浜濱瀕牝玭貧賓頻憑氷聘騁乍事些仕伺似使俟僿史司唆嗣四士奢娑寫寺射巳師徙思捨斜斯柶査梭死沙泗渣瀉獅砂社祀祠私篩紗絲肆舍莎蓑蛇裟詐詞謝賜赦辭邪飼駟麝削數朔索"],["dfa1","傘刪山散汕珊産疝算蒜酸霰乷撒殺煞薩三參杉森渗芟蔘衫揷澁鈒颯上傷像償商喪嘗孀尙峠常床庠廂想桑橡湘爽牀狀相祥箱翔裳觴詳象賞霜塞璽賽嗇塞穡索色牲生甥省笙墅壻嶼序庶徐恕抒捿敍暑曙書栖棲犀瑞筮絮緖署"],["e0a1","胥舒薯西誓逝鋤黍鼠夕奭席惜昔晳析汐淅潟石碩蓆釋錫仙僊先善嬋宣扇敾旋渲煽琁瑄璇璿癬禪線繕羨腺膳船蘚蟬詵跣選銑鐥饍鮮卨屑楔泄洩渫舌薛褻設說雪齧剡暹殲纖蟾贍閃陝攝涉燮葉城姓宬性惺成星晟猩珹盛省筬"],["e1a1","聖聲腥誠醒世勢歲洗稅笹細說貰召嘯塑宵小少巢所掃搔昭梳沼消溯瀟炤燒甦疏疎瘙笑篠簫素紹蔬蕭蘇訴逍遡邵銷韶騷俗屬束涑粟續謖贖速孫巽損蓀遜飡率宋悚松淞訟誦送頌刷殺灑碎鎖衰釗修受嗽囚垂壽嫂守岫峀帥愁"],["e2a1","戍手授搜收數樹殊水洙漱燧狩獸琇璲瘦睡秀穗竪粹綏綬繡羞脩茱蒐蓚藪袖誰讐輸遂邃酬銖銹隋隧隨雖需須首髓鬚叔塾夙孰宿淑潚熟琡璹肅菽巡徇循恂旬栒楯橓殉洵淳珣盾瞬筍純脣舜荀蓴蕣詢諄醇錞順馴戌術述鉥崇崧"],["e3a1","嵩瑟膝蝨濕拾習褶襲丞乘僧勝升承昇繩蠅陞侍匙嘶始媤尸屎屍市弑恃施是時枾柴猜矢示翅蒔蓍視試詩諡豕豺埴寔式息拭植殖湜熄篒蝕識軾食飾伸侁信呻娠宸愼新晨燼申神紳腎臣莘薪藎蜃訊身辛辰迅失室實悉審尋心沁"],["e4a1","沈深瀋甚芯諶什十拾雙氏亞俄兒啞娥峨我牙芽莪蛾衙訝阿雅餓鴉鵝堊岳嶽幄惡愕握樂渥鄂鍔顎鰐齷安岸按晏案眼雁鞍顔鮟斡謁軋閼唵岩巖庵暗癌菴闇壓押狎鴨仰央怏昻殃秧鴦厓哀埃崖愛曖涯碍艾隘靄厄扼掖液縊腋額"],["e5a1","櫻罌鶯鸚也倻冶夜惹揶椰爺耶若野弱掠略約若葯蒻藥躍亮佯兩凉壤孃恙揚攘敭暘梁楊樣洋瀁煬痒瘍禳穰糧羊良襄諒讓釀陽量養圄御於漁瘀禦語馭魚齬億憶抑檍臆偃堰彦焉言諺孼蘖俺儼嚴奄掩淹嶪業円予余勵呂女如廬"],["e6a1","旅歟汝濾璵礖礪與艅茹輿轝閭餘驪麗黎亦力域役易曆歷疫繹譯轢逆驛嚥堧姸娟宴年延憐戀捐挻撚椽沇沿涎涓淵演漣烟然煙煉燃燕璉硏硯秊筵緣練縯聯衍軟輦蓮連鉛鍊鳶列劣咽悅涅烈熱裂說閱厭廉念捻染殮炎焰琰艶苒"],["e7a1","簾閻髥鹽曄獵燁葉令囹塋寧嶺嶸影怜映暎楹榮永泳渶潁濚瀛瀯煐營獰玲瑛瑩瓔盈穎纓羚聆英詠迎鈴鍈零霙靈領乂倪例刈叡曳汭濊猊睿穢芮藝蘂禮裔詣譽豫醴銳隸霓預五伍俉傲午吾吳嗚塢墺奧娛寤悟惡懊敖旿晤梧汚澳"],["e8a1","烏熬獒筽蜈誤鰲鼇屋沃獄玉鈺溫瑥瘟穩縕蘊兀壅擁瓮甕癰翁邕雍饔渦瓦窩窪臥蛙蝸訛婉完宛梡椀浣玩琓琬碗緩翫脘腕莞豌阮頑曰往旺枉汪王倭娃歪矮外嵬巍猥畏了僚僥凹堯夭妖姚寥寮尿嶢拗搖撓擾料曜樂橈燎燿瑤療"],["e9a1","窈窯繇繞耀腰蓼蟯要謠遙遼邀饒慾欲浴縟褥辱俑傭冗勇埇墉容庸慂榕涌湧溶熔瑢用甬聳茸蓉踊鎔鏞龍于佑偶優又友右宇寓尤愚憂旴牛玗瑀盂祐禑禹紆羽芋藕虞迂遇郵釪隅雨雩勖彧旭昱栯煜稶郁頊云暈橒殞澐熉耘芸蕓"],["eaa1","運隕雲韻蔚鬱亐熊雄元原員圓園垣媛嫄寃怨愿援沅洹湲源爰猿瑗苑袁轅遠阮院願鴛月越鉞位偉僞危圍委威尉慰暐渭爲瑋緯胃萎葦蔿蝟衛褘謂違韋魏乳侑儒兪劉唯喩孺宥幼幽庾悠惟愈愉揄攸有杻柔柚柳楡楢油洧流游溜"],["eba1","濡猶猷琉瑜由留癒硫紐維臾萸裕誘諛諭踰蹂遊逾遺酉釉鍮類六堉戮毓肉育陸倫允奫尹崙淪潤玧胤贇輪鈗閏律慄栗率聿戎瀜絨融隆垠恩慇殷誾銀隱乙吟淫蔭陰音飮揖泣邑凝應膺鷹依倚儀宜意懿擬椅毅疑矣義艤薏蟻衣誼"],["eca1","議醫二以伊利吏夷姨履已弛彛怡易李梨泥爾珥理異痍痢移罹而耳肄苡荑裏裡貽貳邇里離飴餌匿溺瀷益翊翌翼謚人仁刃印吝咽因姻寅引忍湮燐璘絪茵藺蚓認隣靭靷鱗麟一佚佾壹日溢逸鎰馹任壬妊姙恁林淋稔臨荏賃入卄"],["eda1","立笠粒仍剩孕芿仔刺咨姉姿子字孜恣慈滋炙煮玆瓷疵磁紫者自茨蔗藉諮資雌作勺嚼斫昨灼炸爵綽芍酌雀鵲孱棧殘潺盞岑暫潛箴簪蠶雜丈仗匠場墻壯奬將帳庄張掌暲杖樟檣欌漿牆狀獐璋章粧腸臟臧莊葬蔣薔藏裝贓醬長"],["eea1","障再哉在宰才材栽梓渽滓災縡裁財載齋齎爭箏諍錚佇低儲咀姐底抵杵楮樗沮渚狙猪疽箸紵苧菹著藷詛貯躇這邸雎齟勣吊嫡寂摘敵滴狄炙的積笛籍績翟荻謫賊赤跡蹟迪迹適鏑佃佺傳全典前剪塡塼奠專展廛悛戰栓殿氈澱"],["efa1","煎琠田甸畑癲筌箋箭篆纏詮輾轉鈿銓錢鐫電顚顫餞切截折浙癤竊節絶占岾店漸点粘霑鮎點接摺蝶丁井亭停偵呈姃定幀庭廷征情挺政整旌晶晸柾楨檉正汀淀淨渟湞瀞炡玎珽町睛碇禎程穽精綎艇訂諪貞鄭酊釘鉦鋌錠霆靖"],["f0a1","靜頂鼎制劑啼堤帝弟悌提梯濟祭第臍薺製諸蹄醍除際霽題齊俎兆凋助嘲弔彫措操早晁曺曹朝條棗槽漕潮照燥爪璪眺祖祚租稠窕粗糟組繰肇藻蚤詔調趙躁造遭釣阻雕鳥族簇足鏃存尊卒拙猝倧宗從悰慫棕淙琮種終綜縱腫"],["f1a1","踪踵鍾鐘佐坐左座挫罪主住侏做姝胄呪周嗾奏宙州廚晝朱柱株注洲湊澍炷珠疇籌紂紬綢舟蛛註誅走躊輳週酎酒鑄駐竹粥俊儁准埈寯峻晙樽浚準濬焌畯竣蠢逡遵雋駿茁中仲衆重卽櫛楫汁葺增憎曾拯烝甑症繒蒸證贈之只"],["f2a1","咫地址志持指摯支旨智枝枳止池沚漬知砥祉祗紙肢脂至芝芷蜘誌識贄趾遲直稙稷織職唇嗔塵振搢晉晋桭榛殄津溱珍瑨璡畛疹盡眞瞋秦縉縝臻蔯袗診賑軫辰進鎭陣陳震侄叱姪嫉帙桎瓆疾秩窒膣蛭質跌迭斟朕什執潗緝輯"],["f3a1","鏶集徵懲澄且侘借叉嗟嵯差次此磋箚茶蹉車遮捉搾着窄錯鑿齪撰澯燦璨瓚竄簒纂粲纘讚贊鑽餐饌刹察擦札紮僭參塹慘慙懺斬站讒讖倉倡創唱娼廠彰愴敞昌昶暢槍滄漲猖瘡窓脹艙菖蒼債埰寀寨彩採砦綵菜蔡采釵冊柵策"],["f4a1","責凄妻悽處倜刺剔尺慽戚拓擲斥滌瘠脊蹠陟隻仟千喘天川擅泉淺玔穿舛薦賤踐遷釧闡阡韆凸哲喆徹撤澈綴輟轍鐵僉尖沾添甛瞻簽籤詹諂堞妾帖捷牒疊睫諜貼輒廳晴淸聽菁請靑鯖切剃替涕滯締諦逮遞體初剿哨憔抄招梢"],["f5a1","椒楚樵炒焦硝礁礎秒稍肖艸苕草蕉貂超酢醋醮促囑燭矗蜀觸寸忖村邨叢塚寵悤憁摠總聰蔥銃撮催崔最墜抽推椎楸樞湫皺秋芻萩諏趨追鄒酋醜錐錘鎚雛騶鰍丑畜祝竺筑築縮蓄蹙蹴軸逐春椿瑃出朮黜充忠沖蟲衝衷悴膵萃"],["f6a1","贅取吹嘴娶就炊翠聚脆臭趣醉驟鷲側仄厠惻測層侈値嗤峙幟恥梔治淄熾痔痴癡稚穉緇緻置致蚩輜雉馳齒則勅飭親七柒漆侵寢枕沈浸琛砧針鍼蟄秤稱快他咤唾墮妥惰打拖朶楕舵陀馱駝倬卓啄坼度托拓擢晫柝濁濯琢琸託"],["f7a1","鐸呑嘆坦彈憚歎灘炭綻誕奪脫探眈耽貪塔搭榻宕帑湯糖蕩兌台太怠態殆汰泰笞胎苔跆邰颱宅擇澤撑攄兎吐土討慟桶洞痛筒統通堆槌腿褪退頹偸套妬投透鬪慝特闖坡婆巴把播擺杷波派爬琶破罷芭跛頗判坂板版瓣販辦鈑"],["f8a1","阪八叭捌佩唄悖敗沛浿牌狽稗覇貝彭澎烹膨愎便偏扁片篇編翩遍鞭騙貶坪平枰萍評吠嬖幣廢弊斃肺蔽閉陛佈包匍匏咆哺圃布怖抛抱捕暴泡浦疱砲胞脯苞葡蒲袍褒逋鋪飽鮑幅暴曝瀑爆輻俵剽彪慓杓標漂瓢票表豹飇飄驃"],["f9a1","品稟楓諷豊風馮彼披疲皮被避陂匹弼必泌珌畢疋筆苾馝乏逼下何厦夏廈昰河瑕荷蝦賀遐霞鰕壑學虐謔鶴寒恨悍旱汗漢澣瀚罕翰閑閒限韓割轄函含咸啣喊檻涵緘艦銜陷鹹合哈盒蛤閤闔陜亢伉姮嫦巷恒抗杭桁沆港缸肛航"],["faa1","行降項亥偕咳垓奚孩害懈楷海瀣蟹解該諧邂駭骸劾核倖幸杏荇行享向嚮珦鄕響餉饗香噓墟虛許憲櫶獻軒歇險驗奕爀赫革俔峴弦懸晛泫炫玄玹現眩睍絃絢縣舷衒見賢鉉顯孑穴血頁嫌俠協夾峽挾浹狹脅脇莢鋏頰亨兄刑型"],["fba1","形泂滎瀅灐炯熒珩瑩荊螢衡逈邢鎣馨兮彗惠慧暳蕙蹊醯鞋乎互呼壕壺好岵弧戶扈昊晧毫浩淏湖滸澔濠濩灝狐琥瑚瓠皓祜糊縞胡芦葫蒿虎號蝴護豪鎬頀顥惑或酷婚昏混渾琿魂忽惚笏哄弘汞泓洪烘紅虹訌鴻化和嬅樺火畵"],["fca1","禍禾花華話譁貨靴廓擴攫確碻穫丸喚奐宦幻患換歡晥桓渙煥環紈還驩鰥活滑猾豁闊凰幌徨恍惶愰慌晃晄榥況湟滉潢煌璜皇篁簧荒蝗遑隍黃匯回廻徊恢悔懷晦會檜淮澮灰獪繪膾茴蛔誨賄劃獲宖橫鐄哮嚆孝效斅曉梟涍淆"],["fda1","爻肴酵驍侯候厚后吼喉嗅帿後朽煦珝逅勛勳塤壎焄熏燻薰訓暈薨喧暄煊萱卉喙毁彙徽揮暉煇諱輝麾休携烋畦虧恤譎鷸兇凶匈洶胸黑昕欣炘痕吃屹紇訖欠欽歆吸恰洽翕興僖凞喜噫囍姬嬉希憙憘戱晞曦熙熹熺犧禧稀羲詰"]]

/***/ }),
/* 104 */
/***/ (function(module, exports) {

	module.exports = [["0","\u0000",127],["a140","　，、。．‧；：？！︰…‥﹐﹑﹒·﹔﹕﹖﹗｜–︱—︳╴︴﹏（）︵︶｛｝︷︸〔〕︹︺【】︻︼《》︽︾〈〉︿﹀「」﹁﹂『』﹃﹄﹙﹚"],["a1a1","﹛﹜﹝﹞‘’“”〝〞‵′＃＆＊※§〃○●△▲◎☆★◇◆□■▽▼㊣℅¯￣＿ˍ﹉﹊﹍﹎﹋﹌﹟﹠﹡＋－×÷±√＜＞＝≦≧≠∞≒≡﹢",4,"～∩∪⊥∠∟⊿㏒㏑∫∮∵∴♀♂⊕⊙↑↓←→↖↗↙↘∥∣／"],["a240","＼∕﹨＄￥〒￠￡％＠℃℉﹩﹪﹫㏕㎜㎝㎞㏎㎡㎎㎏㏄°兙兛兞兝兡兣嗧瓩糎▁",7,"▏▎▍▌▋▊▉┼┴┬┤├▔─│▕┌┐└┘╭"],["a2a1","╮╰╯═╞╪╡◢◣◥◤╱╲╳０",9,"Ⅰ",9,"〡",8,"十卄卅Ａ",25,"ａ",21],["a340","ｗｘｙｚΑ",16,"Σ",6,"α",16,"σ",6,"ㄅ",10],["a3a1","ㄐ",25,"˙ˉˊˇˋ"],["a3e1","€"],["a440","一乙丁七乃九了二人儿入八几刀刁力匕十卜又三下丈上丫丸凡久么也乞于亡兀刃勺千叉口土士夕大女子孑孓寸小尢尸山川工己已巳巾干廾弋弓才"],["a4a1","丑丐不中丰丹之尹予云井互五亢仁什仃仆仇仍今介仄元允內六兮公冗凶分切刈勻勾勿化匹午升卅卞厄友及反壬天夫太夭孔少尤尺屯巴幻廿弔引心戈戶手扎支文斗斤方日曰月木欠止歹毋比毛氏水火爪父爻片牙牛犬王丙"],["a540","世丕且丘主乍乏乎以付仔仕他仗代令仙仞充兄冉冊冬凹出凸刊加功包匆北匝仟半卉卡占卯卮去可古右召叮叩叨叼司叵叫另只史叱台句叭叻四囚外"],["a5a1","央失奴奶孕它尼巨巧左市布平幼弁弘弗必戊打扔扒扑斥旦朮本未末札正母民氐永汁汀氾犯玄玉瓜瓦甘生用甩田由甲申疋白皮皿目矛矢石示禾穴立丞丟乒乓乩亙交亦亥仿伉伙伊伕伍伐休伏仲件任仰仳份企伋光兇兆先全"],["a640","共再冰列刑划刎刖劣匈匡匠印危吉吏同吊吐吁吋各向名合吃后吆吒因回囝圳地在圭圬圯圩夙多夷夸妄奸妃好她如妁字存宇守宅安寺尖屹州帆并年"],["a6a1","式弛忙忖戎戌戍成扣扛托收早旨旬旭曲曳有朽朴朱朵次此死氖汝汗汙江池汐汕污汛汍汎灰牟牝百竹米糸缶羊羽老考而耒耳聿肉肋肌臣自至臼舌舛舟艮色艾虫血行衣西阡串亨位住佇佗佞伴佛何估佐佑伽伺伸佃佔似但佣"],["a740","作你伯低伶余佝佈佚兌克免兵冶冷別判利刪刨劫助努劬匣即卵吝吭吞吾否呎吧呆呃吳呈呂君吩告吹吻吸吮吵吶吠吼呀吱含吟听囪困囤囫坊坑址坍"],["a7a1","均坎圾坐坏圻壯夾妝妒妨妞妣妙妖妍妤妓妊妥孝孜孚孛完宋宏尬局屁尿尾岐岑岔岌巫希序庇床廷弄弟彤形彷役忘忌志忍忱快忸忪戒我抄抗抖技扶抉扭把扼找批扳抒扯折扮投抓抑抆改攻攸旱更束李杏材村杜杖杞杉杆杠"],["a840","杓杗步每求汞沙沁沈沉沅沛汪決沐汰沌汨沖沒汽沃汲汾汴沆汶沍沔沘沂灶灼災灸牢牡牠狄狂玖甬甫男甸皂盯矣私秀禿究系罕肖肓肝肘肛肚育良芒"],["a8a1","芋芍見角言谷豆豕貝赤走足身車辛辰迂迆迅迄巡邑邢邪邦那酉釆里防阮阱阪阬並乖乳事些亞享京佯依侍佳使佬供例來侃佰併侈佩佻侖佾侏侑佺兔兒兕兩具其典冽函刻券刷刺到刮制剁劾劻卒協卓卑卦卷卸卹取叔受味呵"],["a940","咖呸咕咀呻呷咄咒咆呼咐呱呶和咚呢周咋命咎固垃坷坪坩坡坦坤坼夜奉奇奈奄奔妾妻委妹妮姑姆姐姍始姓姊妯妳姒姅孟孤季宗定官宜宙宛尚屈居"],["a9a1","屆岷岡岸岩岫岱岳帘帚帖帕帛帑幸庚店府底庖延弦弧弩往征彿彼忝忠忽念忿怏怔怯怵怖怪怕怡性怩怫怛或戕房戾所承拉拌拄抿拂抹拒招披拓拔拋拈抨抽押拐拙拇拍抵拚抱拘拖拗拆抬拎放斧於旺昔易昌昆昂明昀昏昕昊"],["aa40","昇服朋杭枋枕東果杳杷枇枝林杯杰板枉松析杵枚枓杼杪杲欣武歧歿氓氛泣注泳沱泌泥河沽沾沼波沫法泓沸泄油況沮泗泅泱沿治泡泛泊沬泯泜泖泠"],["aaa1","炕炎炒炊炙爬爭爸版牧物狀狎狙狗狐玩玨玟玫玥甽疝疙疚的盂盲直知矽社祀祁秉秈空穹竺糾罔羌羋者肺肥肢肱股肫肩肴肪肯臥臾舍芳芝芙芭芽芟芹花芬芥芯芸芣芰芾芷虎虱初表軋迎返近邵邸邱邶采金長門阜陀阿阻附"],["ab40","陂隹雨青非亟亭亮信侵侯便俠俑俏保促侶俘俟俊俗侮俐俄係俚俎俞侷兗冒冑冠剎剃削前剌剋則勇勉勃勁匍南卻厚叛咬哀咨哎哉咸咦咳哇哂咽咪品"],["aba1","哄哈咯咫咱咻咩咧咿囿垂型垠垣垢城垮垓奕契奏奎奐姜姘姿姣姨娃姥姪姚姦威姻孩宣宦室客宥封屎屏屍屋峙峒巷帝帥帟幽庠度建弈弭彥很待徊律徇後徉怒思怠急怎怨恍恰恨恢恆恃恬恫恪恤扁拜挖按拼拭持拮拽指拱拷"],["ac40","拯括拾拴挑挂政故斫施既春昭映昧是星昨昱昤曷柿染柱柔某柬架枯柵柩柯柄柑枴柚查枸柏柞柳枰柙柢柝柒歪殃殆段毒毗氟泉洋洲洪流津洌洱洞洗"],["aca1","活洽派洶洛泵洹洧洸洩洮洵洎洫炫為炳炬炯炭炸炮炤爰牲牯牴狩狠狡玷珊玻玲珍珀玳甚甭畏界畎畋疫疤疥疢疣癸皆皇皈盈盆盃盅省盹相眉看盾盼眇矜砂研砌砍祆祉祈祇禹禺科秒秋穿突竿竽籽紂紅紀紉紇約紆缸美羿耄"],["ad40","耐耍耑耶胖胥胚胃胄背胡胛胎胞胤胝致舢苧范茅苣苛苦茄若茂茉苒苗英茁苜苔苑苞苓苟苯茆虐虹虻虺衍衫要觔計訂訃貞負赴赳趴軍軌述迦迢迪迥"],["ada1","迭迫迤迨郊郎郁郃酋酊重閂限陋陌降面革韋韭音頁風飛食首香乘亳倌倍倣俯倦倥俸倩倖倆值借倚倒們俺倀倔倨俱倡個候倘俳修倭倪俾倫倉兼冤冥冢凍凌准凋剖剜剔剛剝匪卿原厝叟哨唐唁唷哼哥哲唆哺唔哩哭員唉哮哪"],["ae40","哦唧唇哽唏圃圄埂埔埋埃堉夏套奘奚娑娘娜娟娛娓姬娠娣娩娥娌娉孫屘宰害家宴宮宵容宸射屑展屐峭峽峻峪峨峰島崁峴差席師庫庭座弱徒徑徐恙"],["aea1","恣恥恐恕恭恩息悄悟悚悍悔悌悅悖扇拳挈拿捎挾振捕捂捆捏捉挺捐挽挪挫挨捍捌效敉料旁旅時晉晏晃晒晌晅晁書朔朕朗校核案框桓根桂桔栩梳栗桌桑栽柴桐桀格桃株桅栓栘桁殊殉殷氣氧氨氦氤泰浪涕消涇浦浸海浙涓"],["af40","浬涉浮浚浴浩涌涊浹涅浥涔烊烘烤烙烈烏爹特狼狹狽狸狷玆班琉珮珠珪珞畔畝畜畚留疾病症疲疳疽疼疹痂疸皋皰益盍盎眩真眠眨矩砰砧砸砝破砷"],["afa1","砥砭砠砟砲祕祐祠祟祖神祝祗祚秤秣秧租秦秩秘窄窈站笆笑粉紡紗紋紊素索純紐紕級紜納紙紛缺罟羔翅翁耆耘耕耙耗耽耿胱脂胰脅胭胴脆胸胳脈能脊胼胯臭臬舀舐航舫舨般芻茫荒荔荊茸荐草茵茴荏茲茹茶茗荀茱茨荃"],["b040","虔蚊蚪蚓蚤蚩蚌蚣蚜衰衷袁袂衽衹記訐討訌訕訊託訓訖訏訑豈豺豹財貢起躬軒軔軏辱送逆迷退迺迴逃追逅迸邕郡郝郢酒配酌釘針釗釜釙閃院陣陡"],["b0a1","陛陝除陘陞隻飢馬骨高鬥鬲鬼乾偺偽停假偃偌做偉健偶偎偕偵側偷偏倏偯偭兜冕凰剪副勒務勘動匐匏匙匿區匾參曼商啪啦啄啞啡啃啊唱啖問啕唯啤唸售啜唬啣唳啁啗圈國圉域堅堊堆埠埤基堂堵執培夠奢娶婁婉婦婪婀"],["b140","娼婢婚婆婊孰寇寅寄寂宿密尉專將屠屜屝崇崆崎崛崖崢崑崩崔崙崤崧崗巢常帶帳帷康庸庶庵庾張強彗彬彩彫得徙從徘御徠徜恿患悉悠您惋悴惦悽"],["b1a1","情悻悵惜悼惘惕惆惟悸惚惇戚戛扈掠控捲掖探接捷捧掘措捱掩掉掃掛捫推掄授掙採掬排掏掀捻捩捨捺敝敖救教敗啟敏敘敕敔斜斛斬族旋旌旎晝晚晤晨晦晞曹勗望梁梯梢梓梵桿桶梱梧梗械梃棄梭梆梅梔條梨梟梡梂欲殺"],["b240","毫毬氫涎涼淳淙液淡淌淤添淺清淇淋涯淑涮淞淹涸混淵淅淒渚涵淚淫淘淪深淮淨淆淄涪淬涿淦烹焉焊烽烯爽牽犁猜猛猖猓猙率琅琊球理現琍瓠瓶"],["b2a1","瓷甜產略畦畢異疏痔痕疵痊痍皎盔盒盛眷眾眼眶眸眺硫硃硎祥票祭移窒窕笠笨笛第符笙笞笮粒粗粕絆絃統紮紹紼絀細紳組累終紲紱缽羞羚翌翎習耜聊聆脯脖脣脫脩脰脤舂舵舷舶船莎莞莘荸莢莖莽莫莒莊莓莉莠荷荻荼"],["b340","莆莧處彪蛇蛀蚶蛄蚵蛆蛋蚱蚯蛉術袞袈被袒袖袍袋覓規訪訝訣訥許設訟訛訢豉豚販責貫貨貪貧赧赦趾趺軛軟這逍通逗連速逝逐逕逞造透逢逖逛途"],["b3a1","部郭都酗野釵釦釣釧釭釩閉陪陵陳陸陰陴陶陷陬雀雪雩章竟頂頃魚鳥鹵鹿麥麻傢傍傅備傑傀傖傘傚最凱割剴創剩勞勝勛博厥啻喀喧啼喊喝喘喂喜喪喔喇喋喃喳單喟唾喲喚喻喬喱啾喉喫喙圍堯堪場堤堰報堡堝堠壹壺奠"],["b440","婷媚婿媒媛媧孳孱寒富寓寐尊尋就嵌嵐崴嵇巽幅帽幀幃幾廊廁廂廄弼彭復循徨惑惡悲悶惠愜愣惺愕惰惻惴慨惱愎惶愉愀愒戟扉掣掌描揀揩揉揆揍"],["b4a1","插揣提握揖揭揮捶援揪換摒揚揹敞敦敢散斑斐斯普晰晴晶景暑智晾晷曾替期朝棺棕棠棘棗椅棟棵森棧棹棒棲棣棋棍植椒椎棉棚楮棻款欺欽殘殖殼毯氮氯氬港游湔渡渲湧湊渠渥渣減湛湘渤湖湮渭渦湯渴湍渺測湃渝渾滋"],["b540","溉渙湎湣湄湲湩湟焙焚焦焰無然煮焜牌犄犀猶猥猴猩琺琪琳琢琥琵琶琴琯琛琦琨甥甦畫番痢痛痣痙痘痞痠登發皖皓皴盜睏短硝硬硯稍稈程稅稀窘"],["b5a1","窗窖童竣等策筆筐筒答筍筋筏筑粟粥絞結絨絕紫絮絲絡給絢絰絳善翔翕耋聒肅腕腔腋腑腎脹腆脾腌腓腴舒舜菩萃菸萍菠菅萋菁華菱菴著萊菰萌菌菽菲菊萸萎萄菜萇菔菟虛蛟蛙蛭蛔蛛蛤蛐蛞街裁裂袱覃視註詠評詞証詁"],["b640","詔詛詐詆訴診訶詖象貂貯貼貳貽賁費賀貴買貶貿貸越超趁跎距跋跚跑跌跛跆軻軸軼辜逮逵週逸進逶鄂郵鄉郾酣酥量鈔鈕鈣鈉鈞鈍鈐鈇鈑閔閏開閑"],["b6a1","間閒閎隊階隋陽隅隆隍陲隄雁雅雄集雇雯雲韌項順須飧飪飯飩飲飭馮馭黃黍黑亂傭債傲傳僅傾催傷傻傯僇剿剷剽募勦勤勢勣匯嗟嗨嗓嗦嗎嗜嗇嗑嗣嗤嗯嗚嗡嗅嗆嗥嗉園圓塞塑塘塗塚塔填塌塭塊塢塒塋奧嫁嫉嫌媾媽媼"],["b740","媳嫂媲嵩嵯幌幹廉廈弒彙徬微愚意慈感想愛惹愁愈慎慌慄慍愾愴愧愍愆愷戡戢搓搾搞搪搭搽搬搏搜搔損搶搖搗搆敬斟新暗暉暇暈暖暄暘暍會榔業"],["b7a1","楚楷楠楔極椰概楊楨楫楞楓楹榆楝楣楛歇歲毀殿毓毽溢溯滓溶滂源溝滇滅溥溘溼溺溫滑準溜滄滔溪溧溴煎煙煩煤煉照煜煬煦煌煥煞煆煨煖爺牒猷獅猿猾瑯瑚瑕瑟瑞瑁琿瑙瑛瑜當畸瘀痰瘁痲痱痺痿痴痳盞盟睛睫睦睞督"],["b840","睹睪睬睜睥睨睢矮碎碰碗碘碌碉硼碑碓硿祺祿禁萬禽稜稚稠稔稟稞窟窠筷節筠筮筧粱粳粵經絹綑綁綏絛置罩罪署義羨群聖聘肆肄腱腰腸腥腮腳腫"],["b8a1","腹腺腦舅艇蒂葷落萱葵葦葫葉葬葛萼萵葡董葩葭葆虞虜號蛹蜓蜈蜇蜀蛾蛻蜂蜃蜆蜊衙裟裔裙補裘裝裡裊裕裒覜解詫該詳試詩詰誇詼詣誠話誅詭詢詮詬詹詻訾詨豢貊貉賊資賈賄貲賃賂賅跡跟跨路跳跺跪跤跦躲較載軾輊"],["b940","辟農運遊道遂達逼違遐遇遏過遍遑逾遁鄒鄗酬酪酩釉鈷鉗鈸鈽鉀鈾鉛鉋鉤鉑鈴鉉鉍鉅鈹鈿鉚閘隘隔隕雍雋雉雊雷電雹零靖靴靶預頑頓頊頒頌飼飴"],["b9a1","飽飾馳馱馴髡鳩麂鼎鼓鼠僧僮僥僖僭僚僕像僑僱僎僩兢凳劃劂匱厭嗾嘀嘛嘗嗽嘔嘆嘉嘍嘎嗷嘖嘟嘈嘐嗶團圖塵塾境墓墊塹墅塽壽夥夢夤奪奩嫡嫦嫩嫗嫖嫘嫣孵寞寧寡寥實寨寢寤察對屢嶄嶇幛幣幕幗幔廓廖弊彆彰徹慇"],["ba40","愿態慷慢慣慟慚慘慵截撇摘摔撤摸摟摺摑摧搴摭摻敲斡旗旖暢暨暝榜榨榕槁榮槓構榛榷榻榫榴槐槍榭槌榦槃榣歉歌氳漳演滾漓滴漩漾漠漬漏漂漢"],["baa1","滿滯漆漱漸漲漣漕漫漯澈漪滬漁滲滌滷熔熙煽熊熄熒爾犒犖獄獐瑤瑣瑪瑰瑭甄疑瘧瘍瘋瘉瘓盡監瞄睽睿睡磁碟碧碳碩碣禎福禍種稱窪窩竭端管箕箋筵算箝箔箏箸箇箄粹粽精綻綰綜綽綾綠緊綴網綱綺綢綿綵綸維緒緇綬"],["bb40","罰翠翡翟聞聚肇腐膀膏膈膊腿膂臧臺與舔舞艋蓉蒿蓆蓄蒙蒞蒲蒜蓋蒸蓀蓓蒐蒼蓑蓊蜿蜜蜻蜢蜥蜴蜘蝕蜷蜩裳褂裴裹裸製裨褚裯誦誌語誣認誡誓誤"],["bba1","說誥誨誘誑誚誧豪貍貌賓賑賒赫趙趕跼輔輒輕輓辣遠遘遜遣遙遞遢遝遛鄙鄘鄞酵酸酷酴鉸銀銅銘銖鉻銓銜銨鉼銑閡閨閩閣閥閤隙障際雌雒需靼鞅韶頗領颯颱餃餅餌餉駁骯骰髦魁魂鳴鳶鳳麼鼻齊億儀僻僵價儂儈儉儅凜"],["bc40","劇劈劉劍劊勰厲嘮嘻嘹嘲嘿嘴嘩噓噎噗噴嘶嘯嘰墀墟增墳墜墮墩墦奭嬉嫻嬋嫵嬌嬈寮寬審寫層履嶝嶔幢幟幡廢廚廟廝廣廠彈影德徵慶慧慮慝慕憂"],["bca1","慼慰慫慾憧憐憫憎憬憚憤憔憮戮摩摯摹撞撲撈撐撰撥撓撕撩撒撮播撫撚撬撙撢撳敵敷數暮暫暴暱樣樟槨樁樞標槽模樓樊槳樂樅槭樑歐歎殤毅毆漿潼澄潑潦潔澆潭潛潸潮澎潺潰潤澗潘滕潯潠潟熟熬熱熨牖犛獎獗瑩璋璃"],["bd40","瑾璀畿瘠瘩瘟瘤瘦瘡瘢皚皺盤瞎瞇瞌瞑瞋磋磅確磊碾磕碼磐稿稼穀稽稷稻窯窮箭箱範箴篆篇篁箠篌糊締練緯緻緘緬緝編緣線緞緩綞緙緲緹罵罷羯"],["bda1","翩耦膛膜膝膠膚膘蔗蔽蔚蓮蔬蔭蔓蔑蔣蔡蔔蓬蔥蓿蔆螂蝴蝶蝠蝦蝸蝨蝙蝗蝌蝓衛衝褐複褒褓褕褊誼諒談諄誕請諸課諉諂調誰論諍誶誹諛豌豎豬賠賞賦賤賬賭賢賣賜質賡赭趟趣踫踐踝踢踏踩踟踡踞躺輝輛輟輩輦輪輜輞"],["be40","輥適遮遨遭遷鄰鄭鄧鄱醇醉醋醃鋅銻銷鋪銬鋤鋁銳銼鋒鋇鋰銲閭閱霄霆震霉靠鞍鞋鞏頡頫頜颳養餓餒餘駝駐駟駛駑駕駒駙骷髮髯鬧魅魄魷魯鴆鴉"],["bea1","鴃麩麾黎墨齒儒儘儔儐儕冀冪凝劑劓勳噙噫噹噩噤噸噪器噥噱噯噬噢噶壁墾壇壅奮嬝嬴學寰導彊憲憑憩憊懍憶憾懊懈戰擅擁擋撻撼據擄擇擂操撿擒擔撾整曆曉暹曄曇暸樽樸樺橙橫橘樹橄橢橡橋橇樵機橈歙歷氅濂澱澡"],["bf40","濃澤濁澧澳激澹澶澦澠澴熾燉燐燒燈燕熹燎燙燜燃燄獨璜璣璘璟璞瓢甌甍瘴瘸瘺盧盥瞠瞞瞟瞥磨磚磬磧禦積穎穆穌穋窺篙簑築篤篛篡篩篦糕糖縊"],["bfa1","縑縈縛縣縞縝縉縐罹羲翰翱翮耨膳膩膨臻興艘艙蕊蕙蕈蕨蕩蕃蕉蕭蕪蕞螃螟螞螢融衡褪褲褥褫褡親覦諦諺諫諱謀諜諧諮諾謁謂諷諭諳諶諼豫豭貓賴蹄踱踴蹂踹踵輻輯輸輳辨辦遵遴選遲遼遺鄴醒錠錶鋸錳錯錢鋼錫錄錚"],["c040","錐錦錡錕錮錙閻隧隨險雕霎霑霖霍霓霏靛靜靦鞘頰頸頻頷頭頹頤餐館餞餛餡餚駭駢駱骸骼髻髭鬨鮑鴕鴣鴦鴨鴒鴛默黔龍龜優償儡儲勵嚎嚀嚐嚅嚇"],["c0a1","嚏壕壓壑壎嬰嬪嬤孺尷屨嶼嶺嶽嶸幫彌徽應懂懇懦懋戲戴擎擊擘擠擰擦擬擱擢擭斂斃曙曖檀檔檄檢檜櫛檣橾檗檐檠歜殮毚氈濘濱濟濠濛濤濫濯澀濬濡濩濕濮濰燧營燮燦燥燭燬燴燠爵牆獰獲璩環璦璨癆療癌盪瞳瞪瞰瞬"],["c140","瞧瞭矯磷磺磴磯礁禧禪穗窿簇簍篾篷簌篠糠糜糞糢糟糙糝縮績繆縷縲繃縫總縱繅繁縴縹繈縵縿縯罄翳翼聱聲聰聯聳臆臃膺臂臀膿膽臉膾臨舉艱薪"],["c1a1","薄蕾薜薑薔薯薛薇薨薊虧蟀蟑螳蟒蟆螫螻螺蟈蟋褻褶襄褸褽覬謎謗謙講謊謠謝謄謐豁谿豳賺賽購賸賻趨蹉蹋蹈蹊轄輾轂轅輿避遽還邁邂邀鄹醣醞醜鍍鎂錨鍵鍊鍥鍋錘鍾鍬鍛鍰鍚鍔闊闋闌闈闆隱隸雖霜霞鞠韓顆颶餵騁"],["c240","駿鮮鮫鮪鮭鴻鴿麋黏點黜黝黛鼾齋叢嚕嚮壙壘嬸彝懣戳擴擲擾攆擺擻擷斷曜朦檳檬櫃檻檸櫂檮檯歟歸殯瀉瀋濾瀆濺瀑瀏燻燼燾燸獷獵璧璿甕癖癘"],["c2a1","癒瞽瞿瞻瞼礎禮穡穢穠竄竅簫簧簪簞簣簡糧織繕繞繚繡繒繙罈翹翻職聶臍臏舊藏薩藍藐藉薰薺薹薦蟯蟬蟲蟠覆覲觴謨謹謬謫豐贅蹙蹣蹦蹤蹟蹕軀轉轍邇邃邈醫醬釐鎔鎊鎖鎢鎳鎮鎬鎰鎘鎚鎗闔闖闐闕離雜雙雛雞霤鞣鞦"],["c340","鞭韹額顏題顎顓颺餾餿餽餮馥騎髁鬃鬆魏魎魍鯊鯉鯽鯈鯀鵑鵝鵠黠鼕鼬儳嚥壞壟壢寵龐廬懲懷懶懵攀攏曠曝櫥櫝櫚櫓瀛瀟瀨瀚瀝瀕瀘爆爍牘犢獸"],["c3a1","獺璽瓊瓣疇疆癟癡矇礙禱穫穩簾簿簸簽簷籀繫繭繹繩繪羅繳羶羹羸臘藩藝藪藕藤藥藷蟻蠅蠍蟹蟾襠襟襖襞譁譜識證譚譎譏譆譙贈贊蹼蹲躇蹶蹬蹺蹴轔轎辭邊邋醱醮鏡鏑鏟鏃鏈鏜鏝鏖鏢鏍鏘鏤鏗鏨關隴難霪霧靡韜韻類"],["c440","願顛颼饅饉騖騙鬍鯨鯧鯖鯛鶉鵡鵲鵪鵬麒麗麓麴勸嚨嚷嚶嚴嚼壤孀孃孽寶巉懸懺攘攔攙曦朧櫬瀾瀰瀲爐獻瓏癢癥礦礪礬礫竇競籌籃籍糯糰辮繽繼"],["c4a1","纂罌耀臚艦藻藹蘑藺蘆蘋蘇蘊蠔蠕襤覺觸議譬警譯譟譫贏贍躉躁躅躂醴釋鐘鐃鏽闡霰飄饒饑馨騫騰騷騵鰓鰍鹹麵黨鼯齟齣齡儷儸囁囀囂夔屬巍懼懾攝攜斕曩櫻欄櫺殲灌爛犧瓖瓔癩矓籐纏續羼蘗蘭蘚蠣蠢蠡蠟襪襬覽譴"],["c540","護譽贓躊躍躋轟辯醺鐮鐳鐵鐺鐸鐲鐫闢霸霹露響顧顥饗驅驃驀騾髏魔魑鰭鰥鶯鶴鷂鶸麝黯鼙齜齦齧儼儻囈囊囉孿巔巒彎懿攤權歡灑灘玀瓤疊癮癬"],["c5a1","禳籠籟聾聽臟襲襯觼讀贖贗躑躓轡酈鑄鑑鑒霽霾韃韁顫饕驕驍髒鬚鱉鰱鰾鰻鷓鷗鼴齬齪龔囌巖戀攣攫攪曬欐瓚竊籤籣籥纓纖纔臢蘸蘿蠱變邐邏鑣鑠鑤靨顯饜驚驛驗髓體髑鱔鱗鱖鷥麟黴囑壩攬灞癱癲矗罐羈蠶蠹衢讓讒"],["c640","讖艷贛釀鑪靂靈靄韆顰驟鬢魘鱟鷹鷺鹼鹽鼇齷齲廳欖灣籬籮蠻觀躡釁鑲鑰顱饞髖鬣黌灤矚讚鑷韉驢驥纜讜躪釅鑽鑾鑼鱷鱸黷豔鑿鸚爨驪鬱鸛鸞籲"],["c940","乂乜凵匚厂万丌乇亍囗兀屮彳丏冇与丮亓仂仉仈冘勼卬厹圠夃夬尐巿旡殳毌气爿丱丼仨仜仩仡仝仚刌匜卌圢圣夗夯宁宄尒尻屴屳帄庀庂忉戉扐氕"],["c9a1","氶汃氿氻犮犰玊禸肊阞伎优伬仵伔仱伀价伈伝伂伅伢伓伄仴伒冱刓刉刐劦匢匟卍厊吇囡囟圮圪圴夼妀奼妅奻奾奷奿孖尕尥屼屺屻屾巟幵庄异弚彴忕忔忏扜扞扤扡扦扢扙扠扚扥旯旮朾朹朸朻机朿朼朳氘汆汒汜汏汊汔汋"],["ca40","汌灱牞犴犵玎甪癿穵网艸艼芀艽艿虍襾邙邗邘邛邔阢阤阠阣佖伻佢佉体佤伾佧佒佟佁佘伭伳伿佡冏冹刜刞刡劭劮匉卣卲厎厏吰吷吪呔呅吙吜吥吘"],["caa1","吽呏呁吨吤呇囮囧囥坁坅坌坉坋坒夆奀妦妘妠妗妎妢妐妏妧妡宎宒尨尪岍岏岈岋岉岒岊岆岓岕巠帊帎庋庉庌庈庍弅弝彸彶忒忑忐忭忨忮忳忡忤忣忺忯忷忻怀忴戺抃抌抎抏抔抇扱扻扺扰抁抈扷扽扲扴攷旰旴旳旲旵杅杇"],["cb40","杙杕杌杈杝杍杚杋毐氙氚汸汧汫沄沋沏汱汯汩沚汭沇沕沜汦汳汥汻沎灴灺牣犿犽狃狆狁犺狅玕玗玓玔玒町甹疔疕皁礽耴肕肙肐肒肜芐芏芅芎芑芓"],["cba1","芊芃芄豸迉辿邟邡邥邞邧邠阰阨阯阭丳侘佼侅佽侀侇佶佴侉侄佷佌侗佪侚佹侁佸侐侜侔侞侒侂侕佫佮冞冼冾刵刲刳剆刱劼匊匋匼厒厔咇呿咁咑咂咈呫呺呾呥呬呴呦咍呯呡呠咘呣呧呤囷囹坯坲坭坫坱坰坶垀坵坻坳坴坢"],["cc40","坨坽夌奅妵妺姏姎妲姌姁妶妼姃姖妱妽姀姈妴姇孢孥宓宕屄屇岮岤岠岵岯岨岬岟岣岭岢岪岧岝岥岶岰岦帗帔帙弨弢弣弤彔徂彾彽忞忥怭怦怙怲怋"],["cca1","怴怊怗怳怚怞怬怢怍怐怮怓怑怌怉怜戔戽抭抴拑抾抪抶拊抮抳抯抻抩抰抸攽斨斻昉旼昄昒昈旻昃昋昍昅旽昑昐曶朊枅杬枎枒杶杻枘枆构杴枍枌杺枟枑枙枃杽极杸杹枔欥殀歾毞氝沓泬泫泮泙沶泔沭泧沷泐泂沺泃泆泭泲"],["cd40","泒泝沴沊沝沀泞泀洰泍泇沰泹泏泩泑炔炘炅炓炆炄炑炖炂炚炃牪狖狋狘狉狜狒狔狚狌狑玤玡玭玦玢玠玬玝瓝瓨甿畀甾疌疘皯盳盱盰盵矸矼矹矻矺"],["cda1","矷祂礿秅穸穻竻籵糽耵肏肮肣肸肵肭舠芠苀芫芚芘芛芵芧芮芼芞芺芴芨芡芩苂芤苃芶芢虰虯虭虮豖迒迋迓迍迖迕迗邲邴邯邳邰阹阽阼阺陃俍俅俓侲俉俋俁俔俜俙侻侳俛俇俖侺俀侹俬剄剉勀勂匽卼厗厖厙厘咺咡咭咥哏"],["ce40","哃茍咷咮哖咶哅哆咠呰咼咢咾呲哞咰垵垞垟垤垌垗垝垛垔垘垏垙垥垚垕壴复奓姡姞姮娀姱姝姺姽姼姶姤姲姷姛姩姳姵姠姾姴姭宨屌峐峘峌峗峋峛"],["cea1","峞峚峉峇峊峖峓峔峏峈峆峎峟峸巹帡帢帣帠帤庰庤庢庛庣庥弇弮彖徆怷怹恔恲恞恅恓恇恉恛恌恀恂恟怤恄恘恦恮扂扃拏挍挋拵挎挃拫拹挏挌拸拶挀挓挔拺挕拻拰敁敃斪斿昶昡昲昵昜昦昢昳昫昺昝昴昹昮朏朐柁柲柈枺"],["cf40","柜枻柸柘柀枷柅柫柤柟枵柍枳柷柶柮柣柂枹柎柧柰枲柼柆柭柌枮柦柛柺柉柊柃柪柋欨殂殄殶毖毘毠氠氡洨洴洭洟洼洿洒洊泚洳洄洙洺洚洑洀洝浂"],["cfa1","洁洘洷洃洏浀洇洠洬洈洢洉洐炷炟炾炱炰炡炴炵炩牁牉牊牬牰牳牮狊狤狨狫狟狪狦狣玅珌珂珈珅玹玶玵玴珫玿珇玾珃珆玸珋瓬瓮甮畇畈疧疪癹盄眈眃眄眅眊盷盻盺矧矨砆砑砒砅砐砏砎砉砃砓祊祌祋祅祄秕种秏秖秎窀"],["d040","穾竑笀笁籺籸籹籿粀粁紃紈紁罘羑羍羾耇耎耏耔耷胘胇胠胑胈胂胐胅胣胙胜胊胕胉胏胗胦胍臿舡芔苙苾苹茇苨茀苕茺苫苖苴苬苡苲苵茌苻苶苰苪"],["d0a1","苤苠苺苳苭虷虴虼虳衁衎衧衪衩觓訄訇赲迣迡迮迠郱邽邿郕郅邾郇郋郈釔釓陔陏陑陓陊陎倞倅倇倓倢倰倛俵俴倳倷倬俶俷倗倜倠倧倵倯倱倎党冔冓凊凄凅凈凎剡剚剒剞剟剕剢勍匎厞唦哢唗唒哧哳哤唚哿唄唈哫唑唅哱"],["d140","唊哻哷哸哠唎唃唋圁圂埌堲埕埒垺埆垽垼垸垶垿埇埐垹埁夎奊娙娖娭娮娕娏娗娊娞娳孬宧宭宬尃屖屔峬峿峮峱峷崀峹帩帨庨庮庪庬弳弰彧恝恚恧"],["d1a1","恁悢悈悀悒悁悝悃悕悛悗悇悜悎戙扆拲挐捖挬捄捅挶捃揤挹捋捊挼挩捁挴捘捔捙挭捇挳捚捑挸捗捀捈敊敆旆旃旄旂晊晟晇晑朒朓栟栚桉栲栳栻桋桏栖栱栜栵栫栭栯桎桄栴栝栒栔栦栨栮桍栺栥栠欬欯欭欱欴歭肂殈毦毤"],["d240","毨毣毢毧氥浺浣浤浶洍浡涒浘浢浭浯涑涍淯浿涆浞浧浠涗浰浼浟涂涘洯浨涋浾涀涄洖涃浻浽浵涐烜烓烑烝烋缹烢烗烒烞烠烔烍烅烆烇烚烎烡牂牸"],["d2a1","牷牶猀狺狴狾狶狳狻猁珓珙珥珖玼珧珣珩珜珒珛珔珝珚珗珘珨瓞瓟瓴瓵甡畛畟疰痁疻痄痀疿疶疺皊盉眝眛眐眓眒眣眑眕眙眚眢眧砣砬砢砵砯砨砮砫砡砩砳砪砱祔祛祏祜祓祒祑秫秬秠秮秭秪秜秞秝窆窉窅窋窌窊窇竘笐"],["d340","笄笓笅笏笈笊笎笉笒粄粑粊粌粈粍粅紞紝紑紎紘紖紓紟紒紏紌罜罡罞罠罝罛羖羒翃翂翀耖耾耹胺胲胹胵脁胻脀舁舯舥茳茭荄茙荑茥荖茿荁茦茜茢"],["d3a1","荂荎茛茪茈茼荍茖茤茠茷茯茩荇荅荌荓茞茬荋茧荈虓虒蚢蚨蚖蚍蚑蚞蚇蚗蚆蚋蚚蚅蚥蚙蚡蚧蚕蚘蚎蚝蚐蚔衃衄衭衵衶衲袀衱衿衯袃衾衴衼訒豇豗豻貤貣赶赸趵趷趶軑軓迾迵适迿迻逄迼迶郖郠郙郚郣郟郥郘郛郗郜郤酐"],["d440","酎酏釕釢釚陜陟隼飣髟鬯乿偰偪偡偞偠偓偋偝偲偈偍偁偛偊偢倕偅偟偩偫偣偤偆偀偮偳偗偑凐剫剭剬剮勖勓匭厜啵啶唼啍啐唴唪啑啢唶唵唰啒啅"],["d4a1","唌唲啥啎唹啈唭唻啀啋圊圇埻堔埢埶埜埴堀埭埽堈埸堋埳埏堇埮埣埲埥埬埡堎埼堐埧堁堌埱埩埰堍堄奜婠婘婕婧婞娸娵婭婐婟婥婬婓婤婗婃婝婒婄婛婈媎娾婍娹婌婰婩婇婑婖婂婜孲孮寁寀屙崞崋崝崚崠崌崨崍崦崥崏"],["d540","崰崒崣崟崮帾帴庱庴庹庲庳弶弸徛徖徟悊悐悆悾悰悺惓惔惏惤惙惝惈悱惛悷惊悿惃惍惀挲捥掊掂捽掽掞掭掝掗掫掎捯掇掐据掯捵掜捭掮捼掤挻掟"],["d5a1","捸掅掁掑掍捰敓旍晥晡晛晙晜晢朘桹梇梐梜桭桮梮梫楖桯梣梬梩桵桴梲梏桷梒桼桫桲梪梀桱桾梛梖梋梠梉梤桸桻梑梌梊桽欶欳欷欸殑殏殍殎殌氪淀涫涴涳湴涬淩淢涷淶淔渀淈淠淟淖涾淥淜淝淛淴淊涽淭淰涺淕淂淏淉"],["d640","淐淲淓淽淗淍淣涻烺焍烷焗烴焌烰焄烳焐烼烿焆焓焀烸烶焋焂焎牾牻牼牿猝猗猇猑猘猊猈狿猏猞玈珶珸珵琄琁珽琇琀珺珼珿琌琋珴琈畤畣痎痒痏"],["d6a1","痋痌痑痐皏皉盓眹眯眭眱眲眴眳眽眥眻眵硈硒硉硍硊硌砦硅硐祤祧祩祪祣祫祡离秺秸秶秷窏窔窐笵筇笴笥笰笢笤笳笘笪笝笱笫笭笯笲笸笚笣粔粘粖粣紵紽紸紶紺絅紬紩絁絇紾紿絊紻紨罣羕羜羝羛翊翋翍翐翑翇翏翉耟"],["d740","耞耛聇聃聈脘脥脙脛脭脟脬脞脡脕脧脝脢舑舸舳舺舴舲艴莐莣莨莍荺荳莤荴莏莁莕莙荵莔莩荽莃莌莝莛莪莋荾莥莯莈莗莰荿莦莇莮荶莚虙虖蚿蚷"],["d7a1","蛂蛁蛅蚺蚰蛈蚹蚳蚸蛌蚴蚻蚼蛃蚽蚾衒袉袕袨袢袪袚袑袡袟袘袧袙袛袗袤袬袌袓袎覂觖觙觕訰訧訬訞谹谻豜豝豽貥赽赻赹趼跂趹趿跁軘軞軝軜軗軠軡逤逋逑逜逌逡郯郪郰郴郲郳郔郫郬郩酖酘酚酓酕釬釴釱釳釸釤釹釪"],["d840","釫釷釨釮镺閆閈陼陭陫陱陯隿靪頄飥馗傛傕傔傞傋傣傃傌傎傝偨傜傒傂傇兟凔匒匑厤厧喑喨喥喭啷噅喢喓喈喏喵喁喣喒喤啽喌喦啿喕喡喎圌堩堷"],["d8a1","堙堞堧堣堨埵塈堥堜堛堳堿堶堮堹堸堭堬堻奡媯媔媟婺媢媞婸媦婼媥媬媕媮娷媄媊媗媃媋媩婻婽媌媜媏媓媝寪寍寋寔寑寊寎尌尰崷嵃嵫嵁嵋崿崵嵑嵎嵕崳崺嵒崽崱嵙嵂崹嵉崸崼崲崶嵀嵅幄幁彘徦徥徫惉悹惌惢惎惄愔"],["d940","惲愊愖愅惵愓惸惼惾惁愃愘愝愐惿愄愋扊掔掱掰揎揥揨揯揃撝揳揊揠揶揕揲揵摡揟掾揝揜揄揘揓揂揇揌揋揈揰揗揙攲敧敪敤敜敨敥斌斝斞斮旐旒"],["d9a1","晼晬晻暀晱晹晪晲朁椌棓椄棜椪棬棪棱椏棖棷棫棤棶椓椐棳棡椇棌椈楰梴椑棯棆椔棸棐棽棼棨椋椊椗棎棈棝棞棦棴棑椆棔棩椕椥棇欹欻欿欼殔殗殙殕殽毰毲毳氰淼湆湇渟湉溈渼渽湅湢渫渿湁湝湳渜渳湋湀湑渻渃渮湞"],["da40","湨湜湡渱渨湠湱湫渹渢渰湓湥渧湸湤湷湕湹湒湦渵渶湚焠焞焯烻焮焱焣焥焢焲焟焨焺焛牋牚犈犉犆犅犋猒猋猰猢猱猳猧猲猭猦猣猵猌琮琬琰琫琖"],["daa1","琚琡琭琱琤琣琝琩琠琲瓻甯畯畬痧痚痡痦痝痟痤痗皕皒盚睆睇睄睍睅睊睎睋睌矞矬硠硤硥硜硭硱硪确硰硩硨硞硢祴祳祲祰稂稊稃稌稄窙竦竤筊笻筄筈筌筎筀筘筅粢粞粨粡絘絯絣絓絖絧絪絏絭絜絫絒絔絩絑絟絎缾缿罥"],["db40","罦羢羠羡翗聑聏聐胾胔腃腊腒腏腇脽腍脺臦臮臷臸臹舄舼舽舿艵茻菏菹萣菀菨萒菧菤菼菶萐菆菈菫菣莿萁菝菥菘菿菡菋菎菖菵菉萉萏菞萑萆菂菳"],["dba1","菕菺菇菑菪萓菃菬菮菄菻菗菢萛菛菾蛘蛢蛦蛓蛣蛚蛪蛝蛫蛜蛬蛩蛗蛨蛑衈衖衕袺裗袹袸裀袾袶袼袷袽袲褁裉覕覘覗觝觚觛詎詍訹詙詀詗詘詄詅詒詈詑詊詌詏豟貁貀貺貾貰貹貵趄趀趉跘跓跍跇跖跜跏跕跙跈跗跅軯軷軺"],["dc40","軹軦軮軥軵軧軨軶軫軱軬軴軩逭逴逯鄆鄬鄄郿郼鄈郹郻鄁鄀鄇鄅鄃酡酤酟酢酠鈁鈊鈥鈃鈚鈦鈏鈌鈀鈒釿釽鈆鈄鈧鈂鈜鈤鈙鈗鈅鈖镻閍閌閐隇陾隈"],["dca1","隉隃隀雂雈雃雱雰靬靰靮頇颩飫鳦黹亃亄亶傽傿僆傮僄僊傴僈僂傰僁傺傱僋僉傶傸凗剺剸剻剼嗃嗛嗌嗐嗋嗊嗝嗀嗔嗄嗩喿嗒喍嗏嗕嗢嗖嗈嗲嗍嗙嗂圔塓塨塤塏塍塉塯塕塎塝塙塥塛堽塣塱壼嫇嫄嫋媺媸媱媵媰媿嫈媻嫆"],["dd40","媷嫀嫊媴媶嫍媹媐寖寘寙尟尳嵱嵣嵊嵥嵲嵬嵞嵨嵧嵢巰幏幎幊幍幋廅廌廆廋廇彀徯徭惷慉慊愫慅愶愲愮慆愯慏愩慀戠酨戣戥戤揅揱揫搐搒搉搠搤"],["dda1","搳摃搟搕搘搹搷搢搣搌搦搰搨摁搵搯搊搚摀搥搧搋揧搛搮搡搎敯斒旓暆暌暕暐暋暊暙暔晸朠楦楟椸楎楢楱椿楅楪椹楂楗楙楺楈楉椵楬椳椽楥棰楸椴楩楀楯楄楶楘楁楴楌椻楋椷楜楏楑椲楒椯楻椼歆歅歃歂歈歁殛嗀毻毼"],["de40","毹毷毸溛滖滈溏滀溟溓溔溠溱溹滆滒溽滁溞滉溷溰滍溦滏溲溾滃滜滘溙溒溎溍溤溡溿溳滐滊溗溮溣煇煔煒煣煠煁煝煢煲煸煪煡煂煘煃煋煰煟煐煓"],["dea1","煄煍煚牏犍犌犑犐犎猼獂猻猺獀獊獉瑄瑊瑋瑒瑑瑗瑀瑏瑐瑎瑂瑆瑍瑔瓡瓿瓾瓽甝畹畷榃痯瘏瘃痷痾痼痹痸瘐痻痶痭痵痽皙皵盝睕睟睠睒睖睚睩睧睔睙睭矠碇碚碔碏碄碕碅碆碡碃硹碙碀碖硻祼禂祽祹稑稘稙稒稗稕稢稓"],["df40","稛稐窣窢窞竫筦筤筭筴筩筲筥筳筱筰筡筸筶筣粲粴粯綈綆綀綍絿綅絺綎絻綃絼綌綔綄絽綒罭罫罧罨罬羦羥羧翛翜耡腤腠腷腜腩腛腢腲朡腞腶腧腯"],["dfa1","腄腡舝艉艄艀艂艅蓱萿葖葶葹蒏蒍葥葑葀蒆葧萰葍葽葚葙葴葳葝蔇葞萷萺萴葺葃葸萲葅萩菙葋萯葂萭葟葰萹葎葌葒葯蓅蒎萻葇萶萳葨葾葄萫葠葔葮葐蜋蜄蛷蜌蛺蛖蛵蝍蛸蜎蜉蜁蛶蜍蜅裖裋裍裎裞裛裚裌裐覅覛觟觥觤"],["e040","觡觠觢觜触詶誆詿詡訿詷誂誄詵誃誁詴詺谼豋豊豥豤豦貆貄貅賌赨赩趑趌趎趏趍趓趔趐趒跰跠跬跱跮跐跩跣跢跧跲跫跴輆軿輁輀輅輇輈輂輋遒逿"],["e0a1","遄遉逽鄐鄍鄏鄑鄖鄔鄋鄎酮酯鉈鉒鈰鈺鉦鈳鉥鉞銃鈮鉊鉆鉭鉬鉏鉠鉧鉯鈶鉡鉰鈱鉔鉣鉐鉲鉎鉓鉌鉖鈲閟閜閞閛隒隓隑隗雎雺雽雸雵靳靷靸靲頏頍頎颬飶飹馯馲馰馵骭骫魛鳪鳭鳧麀黽僦僔僗僨僳僛僪僝僤僓僬僰僯僣僠"],["e140","凘劀劁勩勫匰厬嘧嘕嘌嘒嗼嘏嘜嘁嘓嘂嗺嘝嘄嗿嗹墉塼墐墘墆墁塿塴墋塺墇墑墎塶墂墈塻墔墏壾奫嫜嫮嫥嫕嫪嫚嫭嫫嫳嫢嫠嫛嫬嫞嫝嫙嫨嫟孷寠"],["e1a1","寣屣嶂嶀嵽嶆嵺嶁嵷嶊嶉嶈嵾嵼嶍嵹嵿幘幙幓廘廑廗廎廜廕廙廒廔彄彃彯徶愬愨慁慞慱慳慒慓慲慬憀慴慔慺慛慥愻慪慡慖戩戧戫搫摍摛摝摴摶摲摳摽摵摦撦摎撂摞摜摋摓摠摐摿搿摬摫摙摥摷敳斠暡暠暟朅朄朢榱榶槉"],["e240","榠槎榖榰榬榼榑榙榎榧榍榩榾榯榿槄榽榤槔榹槊榚槏榳榓榪榡榞槙榗榐槂榵榥槆歊歍歋殞殟殠毃毄毾滎滵滱漃漥滸漷滻漮漉潎漙漚漧漘漻漒滭漊"],["e2a1","漶潳滹滮漭潀漰漼漵滫漇漎潃漅滽滶漹漜滼漺漟漍漞漈漡熇熐熉熀熅熂熏煻熆熁熗牄牓犗犕犓獃獍獑獌瑢瑳瑱瑵瑲瑧瑮甀甂甃畽疐瘖瘈瘌瘕瘑瘊瘔皸瞁睼瞅瞂睮瞀睯睾瞃碲碪碴碭碨硾碫碞碥碠碬碢碤禘禊禋禖禕禔禓"],["e340","禗禈禒禐稫穊稰稯稨稦窨窫窬竮箈箜箊箑箐箖箍箌箛箎箅箘劄箙箤箂粻粿粼粺綧綷緂綣綪緁緀緅綝緎緄緆緋緌綯綹綖綼綟綦綮綩綡緉罳翢翣翥翞"],["e3a1","耤聝聜膉膆膃膇膍膌膋舕蒗蒤蒡蒟蒺蓎蓂蒬蒮蒫蒹蒴蓁蓍蒪蒚蒱蓐蒝蒧蒻蒢蒔蓇蓌蒛蒩蒯蒨蓖蒘蒶蓏蒠蓗蓔蓒蓛蒰蒑虡蜳蜣蜨蝫蝀蜮蜞蜡蜙蜛蝃蜬蝁蜾蝆蜠蜲蜪蜭蜼蜒蜺蜱蜵蝂蜦蜧蜸蜤蜚蜰蜑裷裧裱裲裺裾裮裼裶裻"],["e440","裰裬裫覝覡覟覞觩觫觨誫誙誋誒誏誖谽豨豩賕賏賗趖踉踂跿踍跽踊踃踇踆踅跾踀踄輐輑輎輍鄣鄜鄠鄢鄟鄝鄚鄤鄡鄛酺酲酹酳銥銤鉶銛鉺銠銔銪銍"],["e4a1","銦銚銫鉹銗鉿銣鋮銎銂銕銢鉽銈銡銊銆銌銙銧鉾銇銩銝銋鈭隞隡雿靘靽靺靾鞃鞀鞂靻鞄鞁靿韎韍頖颭颮餂餀餇馝馜駃馹馻馺駂馽駇骱髣髧鬾鬿魠魡魟鳱鳲鳵麧僿儃儰僸儆儇僶僾儋儌僽儊劋劌勱勯噈噂噌嘵噁噊噉噆噘"],["e540","噚噀嘳嘽嘬嘾嘸嘪嘺圚墫墝墱墠墣墯墬墥墡壿嫿嫴嫽嫷嫶嬃嫸嬂嫹嬁嬇嬅嬏屧嶙嶗嶟嶒嶢嶓嶕嶠嶜嶡嶚嶞幩幝幠幜緳廛廞廡彉徲憋憃慹憱憰憢憉"],["e5a1","憛憓憯憭憟憒憪憡憍慦憳戭摮摰撖撠撅撗撜撏撋撊撌撣撟摨撱撘敶敺敹敻斲斳暵暰暩暲暷暪暯樀樆樗槥槸樕槱槤樠槿槬槢樛樝槾樧槲槮樔槷槧橀樈槦槻樍槼槫樉樄樘樥樏槶樦樇槴樖歑殥殣殢殦氁氀毿氂潁漦潾澇濆澒"],["e640","澍澉澌潢潏澅潚澖潶潬澂潕潲潒潐潗澔澓潝漀潡潫潽潧澐潓澋潩潿澕潣潷潪潻熲熯熛熰熠熚熩熵熝熥熞熤熡熪熜熧熳犘犚獘獒獞獟獠獝獛獡獚獙"],["e6a1","獢璇璉璊璆璁瑽璅璈瑼瑹甈甇畾瘥瘞瘙瘝瘜瘣瘚瘨瘛皜皝皞皛瞍瞏瞉瞈磍碻磏磌磑磎磔磈磃磄磉禚禡禠禜禢禛歶稹窲窴窳箷篋箾箬篎箯箹篊箵糅糈糌糋緷緛緪緧緗緡縃緺緦緶緱緰緮緟罶羬羰羭翭翫翪翬翦翨聤聧膣膟"],["e740","膞膕膢膙膗舖艏艓艒艐艎艑蔤蔻蔏蔀蔩蔎蔉蔍蔟蔊蔧蔜蓻蔫蓺蔈蔌蓴蔪蓲蔕蓷蓫蓳蓼蔒蓪蓩蔖蓾蔨蔝蔮蔂蓽蔞蓶蔱蔦蓧蓨蓰蓯蓹蔘蔠蔰蔋蔙蔯虢"],["e7a1","蝖蝣蝤蝷蟡蝳蝘蝔蝛蝒蝡蝚蝑蝞蝭蝪蝐蝎蝟蝝蝯蝬蝺蝮蝜蝥蝏蝻蝵蝢蝧蝩衚褅褌褔褋褗褘褙褆褖褑褎褉覢覤覣觭觰觬諏諆誸諓諑諔諕誻諗誾諀諅諘諃誺誽諙谾豍貏賥賟賙賨賚賝賧趠趜趡趛踠踣踥踤踮踕踛踖踑踙踦踧"],["e840","踔踒踘踓踜踗踚輬輤輘輚輠輣輖輗遳遰遯遧遫鄯鄫鄩鄪鄲鄦鄮醅醆醊醁醂醄醀鋐鋃鋄鋀鋙銶鋏鋱鋟鋘鋩鋗鋝鋌鋯鋂鋨鋊鋈鋎鋦鋍鋕鋉鋠鋞鋧鋑鋓"],["e8a1","銵鋡鋆銴镼閬閫閮閰隤隢雓霅霈霂靚鞊鞎鞈韐韏頞頝頦頩頨頠頛頧颲餈飺餑餔餖餗餕駜駍駏駓駔駎駉駖駘駋駗駌骳髬髫髳髲髱魆魃魧魴魱魦魶魵魰魨魤魬鳼鳺鳽鳿鳷鴇鴀鳹鳻鴈鴅鴄麃黓鼏鼐儜儓儗儚儑凞匴叡噰噠噮"],["e940","噳噦噣噭噲噞噷圜圛壈墽壉墿墺壂墼壆嬗嬙嬛嬡嬔嬓嬐嬖嬨嬚嬠嬞寯嶬嶱嶩嶧嶵嶰嶮嶪嶨嶲嶭嶯嶴幧幨幦幯廩廧廦廨廥彋徼憝憨憖懅憴懆懁懌憺"],["e9a1","憿憸憌擗擖擐擏擉撽撉擃擛擳擙攳敿敼斢曈暾曀曊曋曏暽暻暺曌朣樴橦橉橧樲橨樾橝橭橶橛橑樨橚樻樿橁橪橤橐橏橔橯橩橠樼橞橖橕橍橎橆歕歔歖殧殪殫毈毇氄氃氆澭濋澣濇澼濎濈潞濄澽澞濊澨瀄澥澮澺澬澪濏澿澸"],["ea40","澢濉澫濍澯澲澰燅燂熿熸燖燀燁燋燔燊燇燏熽燘熼燆燚燛犝犞獩獦獧獬獥獫獪瑿璚璠璔璒璕璡甋疀瘯瘭瘱瘽瘳瘼瘵瘲瘰皻盦瞚瞝瞡瞜瞛瞢瞣瞕瞙"],["eaa1","瞗磝磩磥磪磞磣磛磡磢磭磟磠禤穄穈穇窶窸窵窱窷篞篣篧篝篕篥篚篨篹篔篪篢篜篫篘篟糒糔糗糐糑縒縡縗縌縟縠縓縎縜縕縚縢縋縏縖縍縔縥縤罃罻罼罺羱翯耪耩聬膱膦膮膹膵膫膰膬膴膲膷膧臲艕艖艗蕖蕅蕫蕍蕓蕡蕘"],["eb40","蕀蕆蕤蕁蕢蕄蕑蕇蕣蔾蕛蕱蕎蕮蕵蕕蕧蕠薌蕦蕝蕔蕥蕬虣虥虤螛螏螗螓螒螈螁螖螘蝹螇螣螅螐螑螝螄螔螜螚螉褞褦褰褭褮褧褱褢褩褣褯褬褟觱諠"],["eba1","諢諲諴諵諝謔諤諟諰諈諞諡諨諿諯諻貑貒貐賵賮賱賰賳赬赮趥趧踳踾踸蹀蹅踶踼踽蹁踰踿躽輶輮輵輲輹輷輴遶遹遻邆郺鄳鄵鄶醓醐醑醍醏錧錞錈錟錆錏鍺錸錼錛錣錒錁鍆錭錎錍鋋錝鋺錥錓鋹鋷錴錂錤鋿錩錹錵錪錔錌"],["ec40","錋鋾錉錀鋻錖閼闍閾閹閺閶閿閵閽隩雔霋霒霐鞙鞗鞔韰韸頵頯頲餤餟餧餩馞駮駬駥駤駰駣駪駩駧骹骿骴骻髶髺髹髷鬳鮀鮅鮇魼魾魻鮂鮓鮒鮐魺鮕"],["eca1","魽鮈鴥鴗鴠鴞鴔鴩鴝鴘鴢鴐鴙鴟麈麆麇麮麭黕黖黺鼒鼽儦儥儢儤儠儩勴嚓嚌嚍嚆嚄嚃噾嚂噿嚁壖壔壏壒嬭嬥嬲嬣嬬嬧嬦嬯嬮孻寱寲嶷幬幪徾徻懃憵憼懧懠懥懤懨懞擯擩擣擫擤擨斁斀斶旚曒檍檖檁檥檉檟檛檡檞檇檓檎"],["ed40","檕檃檨檤檑橿檦檚檅檌檒歛殭氉濌澩濴濔濣濜濭濧濦濞濲濝濢濨燡燱燨燲燤燰燢獳獮獯璗璲璫璐璪璭璱璥璯甐甑甒甏疄癃癈癉癇皤盩瞵瞫瞲瞷瞶"],["eda1","瞴瞱瞨矰磳磽礂磻磼磲礅磹磾礄禫禨穜穛穖穘穔穚窾竀竁簅簏篲簀篿篻簎篴簋篳簂簉簃簁篸篽簆篰篱簐簊糨縭縼繂縳顈縸縪繉繀繇縩繌縰縻縶繄縺罅罿罾罽翴翲耬膻臄臌臊臅臇膼臩艛艚艜薃薀薏薧薕薠薋薣蕻薤薚薞"],["ee40","蕷蕼薉薡蕺蕸蕗薎薖薆薍薙薝薁薢薂薈薅蕹蕶薘薐薟虨螾螪螭蟅螰螬螹螵螼螮蟉蟃蟂蟌螷螯蟄蟊螴螶螿螸螽蟞螲褵褳褼褾襁襒褷襂覭覯覮觲觳謞"],["eea1","謘謖謑謅謋謢謏謒謕謇謍謈謆謜謓謚豏豰豲豱豯貕貔賹赯蹎蹍蹓蹐蹌蹇轃轀邅遾鄸醚醢醛醙醟醡醝醠鎡鎃鎯鍤鍖鍇鍼鍘鍜鍶鍉鍐鍑鍠鍭鎏鍌鍪鍹鍗鍕鍒鍏鍱鍷鍻鍡鍞鍣鍧鎀鍎鍙闇闀闉闃闅閷隮隰隬霠霟霘霝霙鞚鞡鞜"],["ef40","鞞鞝韕韔韱顁顄顊顉顅顃餥餫餬餪餳餲餯餭餱餰馘馣馡騂駺駴駷駹駸駶駻駽駾駼騃骾髾髽鬁髼魈鮚鮨鮞鮛鮦鮡鮥鮤鮆鮢鮠鮯鴳鵁鵧鴶鴮鴯鴱鴸鴰"],["efa1","鵅鵂鵃鴾鴷鵀鴽翵鴭麊麉麍麰黈黚黻黿鼤鼣鼢齔龠儱儭儮嚘嚜嚗嚚嚝嚙奰嬼屩屪巀幭幮懘懟懭懮懱懪懰懫懖懩擿攄擽擸攁攃擼斔旛曚曛曘櫅檹檽櫡櫆檺檶檷櫇檴檭歞毉氋瀇瀌瀍瀁瀅瀔瀎濿瀀濻瀦濼濷瀊爁燿燹爃燽獶"],["f040","璸瓀璵瓁璾璶璻瓂甔甓癜癤癙癐癓癗癚皦皽盬矂瞺磿礌礓礔礉礐礒礑禭禬穟簜簩簙簠簟簭簝簦簨簢簥簰繜繐繖繣繘繢繟繑繠繗繓羵羳翷翸聵臑臒"],["f0a1","臐艟艞薴藆藀藃藂薳薵薽藇藄薿藋藎藈藅薱薶藒蘤薸薷薾虩蟧蟦蟢蟛蟫蟪蟥蟟蟳蟤蟔蟜蟓蟭蟘蟣螤蟗蟙蠁蟴蟨蟝襓襋襏襌襆襐襑襉謪謧謣謳謰謵譇謯謼謾謱謥謷謦謶謮謤謻謽謺豂豵貙貘貗賾贄贂贀蹜蹢蹠蹗蹖蹞蹥蹧"],["f140","蹛蹚蹡蹝蹩蹔轆轇轈轋鄨鄺鄻鄾醨醥醧醯醪鎵鎌鎒鎷鎛鎝鎉鎧鎎鎪鎞鎦鎕鎈鎙鎟鎍鎱鎑鎲鎤鎨鎴鎣鎥闒闓闑隳雗雚巂雟雘雝霣霢霥鞬鞮鞨鞫鞤鞪"],["f1a1","鞢鞥韗韙韖韘韺顐顑顒颸饁餼餺騏騋騉騍騄騑騊騅騇騆髀髜鬈鬄鬅鬩鬵魊魌魋鯇鯆鯃鮿鯁鮵鮸鯓鮶鯄鮹鮽鵜鵓鵏鵊鵛鵋鵙鵖鵌鵗鵒鵔鵟鵘鵚麎麌黟鼁鼀鼖鼥鼫鼪鼩鼨齌齕儴儵劖勷厴嚫嚭嚦嚧嚪嚬壚壝壛夒嬽嬾嬿巃幰"],["f240","徿懻攇攐攍攉攌攎斄旞旝曞櫧櫠櫌櫑櫙櫋櫟櫜櫐櫫櫏櫍櫞歠殰氌瀙瀧瀠瀖瀫瀡瀢瀣瀩瀗瀤瀜瀪爌爊爇爂爅犥犦犤犣犡瓋瓅璷瓃甖癠矉矊矄矱礝礛"],["f2a1","礡礜礗礞禰穧穨簳簼簹簬簻糬糪繶繵繸繰繷繯繺繲繴繨罋罊羃羆羷翽翾聸臗臕艤艡艣藫藱藭藙藡藨藚藗藬藲藸藘藟藣藜藑藰藦藯藞藢蠀蟺蠃蟶蟷蠉蠌蠋蠆蟼蠈蟿蠊蠂襢襚襛襗襡襜襘襝襙覈覷覶觶譐譈譊譀譓譖譔譋譕"],["f340","譑譂譒譗豃豷豶貚贆贇贉趬趪趭趫蹭蹸蹳蹪蹯蹻軂轒轑轏轐轓辴酀鄿醰醭鏞鏇鏏鏂鏚鏐鏹鏬鏌鏙鎩鏦鏊鏔鏮鏣鏕鏄鏎鏀鏒鏧镽闚闛雡霩霫霬霨霦"],["f3a1","鞳鞷鞶韝韞韟顜顙顝顗颿颽颻颾饈饇饃馦馧騚騕騥騝騤騛騢騠騧騣騞騜騔髂鬋鬊鬎鬌鬷鯪鯫鯠鯞鯤鯦鯢鯰鯔鯗鯬鯜鯙鯥鯕鯡鯚鵷鶁鶊鶄鶈鵱鶀鵸鶆鶋鶌鵽鵫鵴鵵鵰鵩鶅鵳鵻鶂鵯鵹鵿鶇鵨麔麑黀黼鼭齀齁齍齖齗齘匷嚲"],["f440","嚵嚳壣孅巆巇廮廯忀忁懹攗攖攕攓旟曨曣曤櫳櫰櫪櫨櫹櫱櫮櫯瀼瀵瀯瀷瀴瀱灂瀸瀿瀺瀹灀瀻瀳灁爓爔犨獽獼璺皫皪皾盭矌矎矏矍矲礥礣礧礨礤礩"],["f4a1","禲穮穬穭竷籉籈籊籇籅糮繻繾纁纀羺翿聹臛臙舋艨艩蘢藿蘁藾蘛蘀藶蘄蘉蘅蘌藽蠙蠐蠑蠗蠓蠖襣襦覹觷譠譪譝譨譣譥譧譭趮躆躈躄轙轖轗轕轘轚邍酃酁醷醵醲醳鐋鐓鏻鐠鐏鐔鏾鐕鐐鐨鐙鐍鏵鐀鏷鐇鐎鐖鐒鏺鐉鏸鐊鏿"],["f540","鏼鐌鏶鐑鐆闞闠闟霮霯鞹鞻韽韾顠顢顣顟飁飂饐饎饙饌饋饓騲騴騱騬騪騶騩騮騸騭髇髊髆鬐鬒鬑鰋鰈鯷鰅鰒鯸鱀鰇鰎鰆鰗鰔鰉鶟鶙鶤鶝鶒鶘鶐鶛"],["f5a1","鶠鶔鶜鶪鶗鶡鶚鶢鶨鶞鶣鶿鶩鶖鶦鶧麙麛麚黥黤黧黦鼰鼮齛齠齞齝齙龑儺儹劘劗囃嚽嚾孈孇巋巏廱懽攛欂櫼欃櫸欀灃灄灊灈灉灅灆爝爚爙獾甗癪矐礭礱礯籔籓糲纊纇纈纋纆纍罍羻耰臝蘘蘪蘦蘟蘣蘜蘙蘧蘮蘡蘠蘩蘞蘥"],["f640","蠩蠝蠛蠠蠤蠜蠫衊襭襩襮襫觺譹譸譅譺譻贐贔趯躎躌轞轛轝酆酄酅醹鐿鐻鐶鐩鐽鐼鐰鐹鐪鐷鐬鑀鐱闥闤闣霵霺鞿韡顤飉飆飀饘饖騹騽驆驄驂驁騺"],["f6a1","騿髍鬕鬗鬘鬖鬺魒鰫鰝鰜鰬鰣鰨鰩鰤鰡鶷鶶鶼鷁鷇鷊鷏鶾鷅鷃鶻鶵鷎鶹鶺鶬鷈鶱鶭鷌鶳鷍鶲鹺麜黫黮黭鼛鼘鼚鼱齎齥齤龒亹囆囅囋奱孋孌巕巑廲攡攠攦攢欋欈欉氍灕灖灗灒爞爟犩獿瓘瓕瓙瓗癭皭礵禴穰穱籗籜籙籛籚"],["f740","糴糱纑罏羇臞艫蘴蘵蘳蘬蘲蘶蠬蠨蠦蠪蠥襱覿覾觻譾讄讂讆讅譿贕躕躔躚躒躐躖躗轠轢酇鑌鑐鑊鑋鑏鑇鑅鑈鑉鑆霿韣顪顩飋饔饛驎驓驔驌驏驈驊"],["f7a1","驉驒驐髐鬙鬫鬻魖魕鱆鱈鰿鱄鰹鰳鱁鰼鰷鰴鰲鰽鰶鷛鷒鷞鷚鷋鷐鷜鷑鷟鷩鷙鷘鷖鷵鷕鷝麶黰鼵鼳鼲齂齫龕龢儽劙壨壧奲孍巘蠯彏戁戃戄攩攥斖曫欑欒欏毊灛灚爢玂玁玃癰矔籧籦纕艬蘺虀蘹蘼蘱蘻蘾蠰蠲蠮蠳襶襴襳觾"],["f840","讌讎讋讈豅贙躘轤轣醼鑢鑕鑝鑗鑞韄韅頀驖驙鬞鬟鬠鱒鱘鱐鱊鱍鱋鱕鱙鱌鱎鷻鷷鷯鷣鷫鷸鷤鷶鷡鷮鷦鷲鷰鷢鷬鷴鷳鷨鷭黂黐黲黳鼆鼜鼸鼷鼶齃齏"],["f8a1","齱齰齮齯囓囍孎屭攭曭曮欓灟灡灝灠爣瓛瓥矕礸禷禶籪纗羉艭虃蠸蠷蠵衋讔讕躞躟躠躝醾醽釂鑫鑨鑩雥靆靃靇韇韥驞髕魙鱣鱧鱦鱢鱞鱠鸂鷾鸇鸃鸆鸅鸀鸁鸉鷿鷽鸄麠鼞齆齴齵齶囔攮斸欘欙欗欚灢爦犪矘矙礹籩籫糶纚"],["f940","纘纛纙臠臡虆虇虈襹襺襼襻觿讘讙躥躤躣鑮鑭鑯鑱鑳靉顲饟鱨鱮鱭鸋鸍鸐鸏鸒鸑麡黵鼉齇齸齻齺齹圞灦籯蠼趲躦釃鑴鑸鑶鑵驠鱴鱳鱱鱵鸔鸓黶鼊"],["f9a1","龤灨灥糷虪蠾蠽蠿讞貜躩軉靋顳顴飌饡馫驤驦驧鬤鸕鸗齈戇欞爧虌躨钂钀钁驩驨鬮鸙爩虋讟钃鱹麷癵驫鱺鸝灩灪麤齾齉龘碁銹裏墻恒粧嫺╔╦╗╠╬╣╚╩╝╒╤╕╞╪╡╘╧╛╓╥╖╟╫╢╙╨╜║═╭╮╰╯▓"]]

/***/ }),
/* 105 */
/***/ (function(module, exports) {

	module.exports = [["8740","䏰䰲䘃䖦䕸𧉧䵷䖳𧲱䳢𧳅㮕䜶䝄䱇䱀𤊿𣘗𧍒𦺋𧃒䱗𪍑䝏䗚䲅𧱬䴇䪤䚡𦬣爥𥩔𡩣𣸆𣽡晍囻"],["8767","綕夝𨮹㷴霴𧯯寛𡵞媤㘥𩺰嫑宷峼杮薓𩥅瑡璝㡵𡵓𣚞𦀡㻬"],["87a1","𥣞㫵竼龗𤅡𨤍𣇪𠪊𣉞䌊蒄龖鐯䤰蘓墖靊鈘秐稲晠権袝瑌篅枂稬剏遆㓦珄𥶹瓆鿇垳䤯呌䄱𣚎堘穲𧭥讏䚮𦺈䆁𥶙箮𢒼鿈𢓁𢓉𢓌鿉蔄𣖻䂴鿊䓡𪷿拁灮鿋"],["8840","㇀",4,"𠄌㇅𠃑𠃍㇆㇇𠃋𡿨㇈𠃊㇉㇊㇋㇌𠄎㇍㇎ĀÁǍÀĒÉĚÈŌÓǑÒ࿿Ê̄Ế࿿Ê̌ỀÊāáǎàɑēéěèīíǐìōóǒòūúǔùǖǘǚ"],["88a1","ǜü࿿ê̄ế࿿ê̌ềêɡ⏚⏛"],["8940","𪎩𡅅"],["8943","攊"],["8946","丽滝鵎釟"],["894c","𧜵撑会伨侨兖兴农凤务动医华发变团声处备夲头学实実岚庆总斉柾栄桥济炼电纤纬纺织经统缆缷艺苏药视设询车轧轮"],["89a1","琑糼緍楆竉刧"],["89ab","醌碸酞肼"],["89b0","贋胶𠧧"],["89b5","肟黇䳍鷉鸌䰾𩷶𧀎鸊𪄳㗁"],["89c1","溚舾甙"],["89c5","䤑马骏龙禇𨑬𡷊𠗐𢫦两亁亀亇亿仫伷㑌侽㹈倃傈㑽㒓㒥円夅凛凼刅争剹劐匧㗇厩㕑厰㕓参吣㕭㕲㚁咓咣咴咹哐哯唘唣唨㖘唿㖥㖿嗗㗅"],["8a40","𧶄唥"],["8a43","𠱂𠴕𥄫喐𢳆㧬𠍁蹆𤶸𩓥䁓𨂾睺𢰸㨴䟕𨅝𦧲𤷪擝𠵼𠾴𠳕𡃴撍蹾𠺖𠰋𠽤𢲩𨉖𤓓"],["8a64","𠵆𩩍𨃩䟴𤺧𢳂骲㩧𩗴㿭㔆𥋇𩟔𧣈𢵄鵮頕"],["8a76","䏙𦂥撴哣𢵌𢯊𡁷㧻𡁯"],["8aa1","𦛚𦜖𧦠擪𥁒𠱃蹨𢆡𨭌𠜱"],["8aac","䠋𠆩㿺塳𢶍"],["8ab2","𤗈𠓼𦂗𠽌𠶖啹䂻䎺"],["8abb","䪴𢩦𡂝膪飵𠶜捹㧾𢝵跀嚡摼㹃"],["8ac9","𪘁𠸉𢫏𢳉"],["8ace","𡃈𣧂㦒㨆𨊛㕸𥹉𢃇噒𠼱𢲲𩜠㒼氽𤸻"],["8adf","𧕴𢺋𢈈𪙛𨳍𠹺𠰴𦠜羓𡃏𢠃𢤹㗻𥇣𠺌𠾍𠺪㾓𠼰𠵇𡅏𠹌"],["8af6","𠺫𠮩𠵈𡃀𡄽㿹𢚖搲𠾭"],["8b40","𣏴𧘹𢯎𠵾𠵿𢱑𢱕㨘𠺘𡃇𠼮𪘲𦭐𨳒𨶙𨳊閪哌苄喹"],["8b55","𩻃鰦骶𧝞𢷮煀腭胬尜𦕲脴㞗卟𨂽醶𠻺𠸏𠹷𠻻㗝𤷫㘉𠳖嚯𢞵𡃉𠸐𠹸𡁸𡅈𨈇𡑕𠹹𤹐𢶤婔𡀝𡀞𡃵𡃶垜𠸑"],["8ba1","𧚔𨋍𠾵𠹻𥅾㜃𠾶𡆀𥋘𪊽𤧚𡠺𤅷𨉼墙剨㘚𥜽箲孨䠀䬬鼧䧧鰟鮍𥭴𣄽嗻㗲嚉丨夂𡯁屮靑𠂆乛亻㔾尣彑忄㣺扌攵歺氵氺灬爫丬犭𤣩罒礻糹罓𦉪㓁"],["8bde","𦍋耂肀𦘒𦥑卝衤见𧢲讠贝钅镸长门𨸏韦页风飞饣𩠐鱼鸟黄歯龜丷𠂇阝户钢"],["8c40","倻淾𩱳龦㷉袏𤅎灷峵䬠𥇍㕙𥴰愢𨨲辧釶熑朙玺𣊁𪄇㲋𡦀䬐磤琂冮𨜏䀉橣𪊺䈣蘏𠩯稪𩥇𨫪靕灍匤𢁾鏴盙𨧣龧矝亣俰傼丯众龨吴綋墒壐𡶶庒庙忂𢜒斋"],["8ca1","𣏹椙橃𣱣泿"],["8ca7","爀𤔅玌㻛𤨓嬕璹讃𥲤𥚕窓篬糃繬苸薗龩袐龪躹龫迏蕟駠鈡龬𨶹𡐿䁱䊢娚"],["8cc9","顨杫䉶圽"],["8cce","藖𤥻芿𧄍䲁𦵴嵻𦬕𦾾龭龮宖龯曧繛湗秊㶈䓃𣉖𢞖䎚䔶"],["8ce6","峕𣬚諹屸㴒𣕑嵸龲煗䕘𤃬𡸣䱷㥸㑊𠆤𦱁諌侴𠈹妿腬顖𩣺弻"],["8d40","𠮟"],["8d42","𢇁𨥭䄂䚻𩁹㼇龳𪆵䃸㟖䛷𦱆䅼𨚲𧏿䕭㣔𥒚䕡䔛䶉䱻䵶䗪㿈𤬏㙡䓞䒽䇭崾嵈嵖㷼㠏嶤嶹㠠㠸幂庽弥徃㤈㤔㤿㥍惗愽峥㦉憷憹懏㦸戬抐拥挘㧸嚱"],["8da1","㨃揢揻搇摚㩋擀崕嘡龟㪗斆㪽旿晓㫲暒㬢朖㭂枤栀㭘桊梄㭲㭱㭻椉楃牜楤榟榅㮼槖㯝橥橴橱檂㯬檙㯲檫檵櫔櫶殁毁毪汵沪㳋洂洆洦涁㳯涤涱渕渘温溆𨧀溻滢滚齿滨滩漤漴㵆𣽁澁澾㵪㵵熷岙㶊瀬㶑灐灔灯灿炉𠌥䏁㗱𠻘"],["8e40","𣻗垾𦻓焾𥟠㙎榢𨯩孴穉𥣡𩓙穥穽𥦬窻窰竂竃燑𦒍䇊竚竝竪䇯咲𥰁笋筕笩𥌎𥳾箢筯莜𥮴𦱿篐萡箒箸𥴠㶭𥱥蒒篺簆簵𥳁籄粃𤢂粦晽𤕸糉糇糦籴糳糵糎"],["8ea1","繧䔝𦹄絝𦻖璍綉綫焵綳緒𤁗𦀩緤㴓緵𡟹緥𨍭縝𦄡𦅚繮纒䌫鑬縧罀罁罇礶𦋐駡羗𦍑羣𡙡𠁨䕜𣝦䔃𨌺翺𦒉者耈耝耨耯𪂇𦳃耻耼聡𢜔䦉𦘦𣷣𦛨朥肧𨩈脇脚墰𢛶汿𦒘𤾸擧𡒊舘𡡞橓𤩥𤪕䑺舩𠬍𦩒𣵾俹𡓽蓢荢𦬊𤦧𣔰𡝳𣷸芪椛芳䇛"],["8f40","蕋苐茚𠸖𡞴㛁𣅽𣕚艻苢茘𣺋𦶣𦬅𦮗𣗎㶿茝嗬莅䔋𦶥莬菁菓㑾𦻔橗蕚㒖𦹂𢻯葘𥯤葱㷓䓤檧葊𣲵祘蒨𦮖𦹷𦹃蓞萏莑䒠蒓蓤𥲑䉀𥳀䕃蔴嫲𦺙䔧蕳䔖枿蘖"],["8fa1","𨘥𨘻藁𧂈蘂𡖂𧃍䕫䕪蘨㙈𡢢号𧎚虾蝱𪃸蟮𢰧螱蟚蠏噡虬桖䘏衅衆𧗠𣶹𧗤衞袜䙛袴袵揁装睷𧜏覇覊覦覩覧覼𨨥觧𧤤𧪽誜瞓釾誐𧩙竩𧬺𣾏䜓𧬸煼謌謟𥐰𥕥謿譌譍誩𤩺讐讛誯𡛟䘕衏貛𧵔𧶏貫㜥𧵓賖𧶘𧶽贒贃𡤐賛灜贑𤳉㻐起"],["9040","趩𨀂𡀔𤦊㭼𨆼𧄌竧躭躶軃鋔輙輭𨍥𨐒辥錃𪊟𠩐辳䤪𨧞𨔽𣶻廸𣉢迹𪀔𨚼𨔁𢌥㦀𦻗逷𨔼𧪾遡𨕬𨘋邨𨜓郄𨛦邮都酧㫰醩釄粬𨤳𡺉鈎沟鉁鉢𥖹銹𨫆𣲛𨬌𥗛"],["90a1","𠴱錬鍫𨫡𨯫炏嫃𨫢𨫥䥥鉄𨯬𨰹𨯿鍳鑛躼閅閦鐦閠濶䊹𢙺𨛘𡉼𣸮䧟氜陻隖䅬隣𦻕懚隶磵𨫠隽双䦡𦲸𠉴𦐐𩂯𩃥𤫑𡤕𣌊霱虂霶䨏䔽䖅𤫩灵孁霛靜𩇕靗孊𩇫靟鐥僐𣂷𣂼鞉鞟鞱鞾韀韒韠𥑬韮琜𩐳響韵𩐝𧥺䫑頴頳顋顦㬎𧅵㵑𠘰𤅜"],["9140","𥜆飊颷飈飇䫿𦴧𡛓喰飡飦飬鍸餹𤨩䭲𩡗𩤅駵騌騻騐驘𥜥㛄𩂱𩯕髠髢𩬅髴䰎鬔鬭𨘀倴鬴𦦨㣃𣁽魐魀𩴾婅𡡣鮎𤉋鰂鯿鰌𩹨鷔𩾷𪆒𪆫𪃡𪄣𪇟鵾鶃𪄴鸎梈"],["91a1","鷄𢅛𪆓𪈠𡤻𪈳鴹𪂹𪊴麐麕麞麢䴴麪麯𤍤黁㭠㧥㴝伲㞾𨰫鼂鼈䮖鐤𦶢鼗鼖鼹嚟嚊齅馸𩂋韲葿齢齩竜龎爖䮾𤥵𤦻煷𤧸𤍈𤩑玞𨯚𡣺禟𨥾𨸶鍩鏳𨩄鋬鎁鏋𨥬𤒹爗㻫睲穃烐𤑳𤏸煾𡟯炣𡢾𣖙㻇𡢅𥐯𡟸㜢𡛻𡠹㛡𡝴𡣑𥽋㜣𡛀坛𤨥𡏾𡊨"],["9240","𡏆𡒶蔃𣚦蔃葕𤦔𧅥𣸱𥕜𣻻𧁒䓴𣛮𩦝𦼦柹㜳㰕㷧塬𡤢栐䁗𣜿𤃡𤂋𤄏𦰡哋嚞𦚱嚒𠿟𠮨𠸍鏆𨬓鎜仸儫㠙𤐶亼𠑥𠍿佋侊𥙑婨𠆫𠏋㦙𠌊𠐔㐵伩𠋀𨺳𠉵諚𠈌亘"],["92a1","働儍侢伃𤨎𣺊佂倮偬傁俌俥偘僼兙兛兝兞湶𣖕𣸹𣺿浲𡢄𣺉冨凃𠗠䓝𠒣𠒒𠒑赺𨪜𠜎剙劤𠡳勡鍮䙺熌𤎌𠰠𤦬𡃤槑𠸝瑹㻞璙琔瑖玘䮎𤪼𤂍叐㖄爏𤃉喴𠍅响𠯆圝鉝雴鍦埝垍坿㘾壋媙𨩆𡛺𡝯𡜐娬妸銏婾嫏娒𥥆𡧳𡡡𤊕㛵洅瑃娡𥺃"],["9340","媁𨯗𠐓鏠璌𡌃焅䥲鐈𨧻鎽㞠尞岞幞幈𡦖𡥼𣫮廍孏𡤃𡤄㜁𡢠㛝𡛾㛓脪𨩇𡶺𣑲𨦨弌弎𡤧𡞫婫𡜻孄蘔𧗽衠恾𢡠𢘫忛㺸𢖯𢖾𩂈𦽳懀𠀾𠁆𢘛憙憘恵𢲛𢴇𤛔𩅍"],["93a1","摱𤙥𢭪㨩𢬢𣑐𩣪𢹸挷𪑛撶挱揑𤧣𢵧护𢲡搻敫楲㯴𣂎𣊭𤦉𣊫唍𣋠𡣙𩐿曎𣊉𣆳㫠䆐𥖄𨬢𥖏𡛼𥕛𥐥磮𣄃𡠪𣈴㑤𣈏𣆂𤋉暎𦴤晫䮓昰𧡰𡷫晣𣋒𣋡昞𥡲㣑𣠺𣞼㮙𣞢𣏾瓐㮖枏𤘪梶栞㯄檾㡣𣟕𤒇樳橒櫉欅𡤒攑梘橌㯗橺歗𣿀𣲚鎠鋲𨯪𨫋"],["9440","銉𨀞𨧜鑧涥漋𤧬浧𣽿㶏渄𤀼娽渊塇洤硂焻𤌚𤉶烱牐犇犔𤞏𤜥兹𤪤𠗫瑺𣻸𣙟𤩊𤤗𥿡㼆㺱𤫟𨰣𣼵悧㻳瓌琼鎇琷䒟𦷪䕑疃㽣𤳙𤴆㽘畕癳𪗆㬙瑨𨫌𤦫𤦎㫻"],["94a1","㷍𤩎㻿𤧅𤣳釺圲鍂𨫣𡡤僟𥈡𥇧睸𣈲眎眏睻𤚗𣞁㩞𤣰琸璛㺿𤪺𤫇䃈𤪖𦆮錇𥖁砞碍碈磒珐祙𧝁𥛣䄎禛蒖禥樭𣻺稺秴䅮𡛦䄲鈵秱𠵌𤦌𠊙𣶺𡝮㖗啫㕰㚪𠇔𠰍竢婙𢛵𥪯𥪜娍𠉛磰娪𥯆竾䇹籝籭䈑𥮳𥺼𥺦糍𤧹𡞰粎籼粮檲緜縇緓罎𦉡"],["9540","𦅜𧭈綗𥺂䉪𦭵𠤖柖𠁎𣗏埄𦐒𦏸𤥢翝笧𠠬𥫩𥵃笌𥸎駦虅驣樜𣐿㧢𤧷𦖭騟𦖠蒀𧄧𦳑䓪脷䐂胆脉腂𦞴飃𦩂艢艥𦩑葓𦶧蘐𧈛媆䅿𡡀嬫𡢡嫤𡣘蚠蜨𣶏蠭𧐢娂"],["95a1","衮佅袇袿裦襥襍𥚃襔𧞅𧞄𨯵𨯙𨮜𨧹㺭蒣䛵䛏㟲訽訜𩑈彍鈫𤊄旔焩烄𡡅鵭貟賩𧷜妚矃姰䍮㛔踪躧𤰉輰轊䋴汘澻𢌡䢛潹溋𡟚鯩㚵𤤯邻邗啱䤆醻鐄𨩋䁢𨫼鐧𨰝𨰻蓥訫閙閧閗閖𨴴瑅㻂𤣿𤩂𤏪㻧𣈥随𨻧𨹦𨹥㻌𤧭𤩸𣿮琒瑫㻼靁𩂰"],["9640","桇䨝𩂓𥟟靝鍨𨦉𨰦𨬯𦎾銺嬑譩䤼珹𤈛鞛靱餸𠼦巁𨯅𤪲頟𩓚鋶𩗗釥䓀𨭐𤩧𨭤飜𨩅㼀鈪䤥萔餻饍𧬆㷽馛䭯馪驜𨭥𥣈檏騡嫾騯𩣱䮐𩥈馼䮽䮗鍽塲𡌂堢𤦸"],["96a1","𡓨硄𢜟𣶸棅㵽鑘㤧慐𢞁𢥫愇鱏鱓鱻鰵鰐魿鯏𩸭鮟𪇵𪃾鴡䲮𤄄鸘䲰鴌𪆴𪃭𪃳𩤯鶥蒽𦸒𦿟𦮂藼䔳𦶤𦺄𦷰萠藮𦸀𣟗𦁤秢𣖜𣙀䤭𤧞㵢鏛銾鍈𠊿碹鉷鑍俤㑀遤𥕝砽硔碶硋𡝗𣇉𤥁㚚佲濚濙瀞瀞吔𤆵垻壳垊鴖埗焴㒯𤆬燫𦱀𤾗嬨𡞵𨩉"],["9740","愌嫎娋䊼𤒈㜬䭻𨧼鎻鎸𡣖𠼝葲𦳀𡐓𤋺𢰦𤏁妔𣶷𦝁綨𦅛𦂤𤦹𤦋𨧺鋥珢㻩璴𨭣𡢟㻡𤪳櫘珳珻㻖𤨾𤪔𡟙𤩦𠎧𡐤𤧥瑈𤤖炥𤥶銄珦鍟𠓾錱𨫎𨨖鎆𨯧𥗕䤵𨪂煫"],["97a1","𤥃𠳿嚤𠘚𠯫𠲸唂秄𡟺緾𡛂𤩐𡡒䔮鐁㜊𨫀𤦭妰𡢿𡢃𧒄媡㛢𣵛㚰鉟婹𨪁𡡢鍴㳍𠪴䪖㦊僴㵩㵌𡎜煵䋻𨈘渏𩃤䓫浗𧹏灧沯㳖𣿭𣸭渂漌㵯𠏵畑㚼㓈䚀㻚䡱姄鉮䤾轁𨰜𦯀堒埈㛖𡑒烾𤍢𤩱𢿣𡊰𢎽梹楧𡎘𣓥𧯴𣛟𨪃𣟖𣏺𤲟樚𣚭𦲷萾䓟䓎"],["9840","𦴦𦵑𦲂𦿞漗𧄉茽𡜺菭𦲀𧁓𡟛妉媂𡞳婡婱𡤅𤇼㜭姯𡜼㛇熎鎐暚𤊥婮娫𤊓樫𣻹𧜶𤑛𤋊焝𤉙𨧡侰𦴨峂𤓎𧹍𤎽樌𤉖𡌄炦焳𤏩㶥泟勇𤩏繥姫崯㷳彜𤩝𡟟綤萦"],["98a1","咅𣫺𣌀𠈔坾𠣕𠘙㿥𡾞𪊶瀃𩅛嵰玏糓𨩙𩐠俈翧狍猐𧫴猸猹𥛶獁獈㺩𧬘遬燵𤣲珡臶㻊県㻑沢国琙琞琟㻢㻰㻴㻺瓓㼎㽓畂畭畲疍㽼痈痜㿀癍㿗癴㿜発𤽜熈嘣覀塩䀝睃䀹条䁅㗛瞘䁪䁯属瞾矋売砘点砜䂨砹硇硑硦葈𥔵礳栃礲䄃"],["9940","䄉禑禙辻稆込䅧窑䆲窼艹䇄竏竛䇏両筢筬筻簒簛䉠䉺类粜䊌粸䊔糭输烀𠳏総緔緐緽羮羴犟䎗耠耥笹耮耱联㷌垴炠肷胩䏭脌猪脎脒畠脔䐁㬹腖腙腚"],["99a1","䐓堺腼膄䐥膓䐭膥埯臁臤艔䒏芦艶苊苘苿䒰荗险榊萅烵葤惣蒈䔄蒾蓡蓸蔐蔸蕒䔻蕯蕰藠䕷虲蚒蚲蛯际螋䘆䘗袮裿褤襇覑𧥧訩訸誔誴豑賔賲贜䞘塟跃䟭仮踺嗘坔蹱嗵躰䠷軎転軤軭軲辷迁迊迌逳駄䢭飠鈓䤞鈨鉘鉫銱銮銿"],["9a40","鋣鋫鋳鋴鋽鍃鎄鎭䥅䥑麿鐗匁鐝鐭鐾䥪鑔鑹锭関䦧间阳䧥枠䨤靀䨵鞲韂噔䫤惨颹䬙飱塄餎餙冴餜餷饂饝饢䭰駅䮝騼鬏窃魩鮁鯝鯱鯴䱭鰠㝯𡯂鵉鰺"],["9aa1","黾噐鶓鶽鷀鷼银辶鹻麬麱麽黆铜黢黱黸竈齄𠂔𠊷𠎠椚铃妬𠓗塀铁㞹𠗕𠘕𠙶𡚺块煳𠫂𠫍𠮿呪吆𠯋咞𠯻𠰻𠱓𠱥𠱼惧𠲍噺𠲵𠳝𠳭𠵯𠶲𠷈楕鰯螥𠸄𠸎𠻗𠾐𠼭𠹳尠𠾼帋𡁜𡁏𡁶朞𡁻𡂈𡂖㙇𡂿𡃓𡄯𡄻卤蒭𡋣𡍵𡌶讁𡕷𡘙𡟃𡟇乸炻𡠭𡥪"],["9b40","𡨭𡩅𡰪𡱰𡲬𡻈拃𡻕𡼕熘桕𢁅槩㛈𢉼𢏗𢏺𢜪𢡱𢥏苽𢥧𢦓𢫕覥𢫨辠𢬎鞸𢬿顇骽𢱌"],["9b62","𢲈𢲷𥯨𢴈𢴒𢶷𢶕𢹂𢽴𢿌𣀳𣁦𣌟𣏞徱晈暿𧩹𣕧𣗳爁𤦺矗𣘚𣜖纇𠍆墵朎"],["9ba1","椘𣪧𧙗𥿢𣸑𣺹𧗾𢂚䣐䪸𤄙𨪚𤋮𤌍𤀻𤌴𤎖𤩅𠗊凒𠘑妟𡺨㮾𣳿𤐄𤓖垈𤙴㦛𤜯𨗨𩧉㝢𢇃譞𨭎駖𤠒𤣻𤨕爉𤫀𠱸奥𤺥𤾆𠝹軚𥀬劏圿煱𥊙𥐙𣽊𤪧喼𥑆𥑮𦭒釔㑳𥔿𧘲𥕞䜘𥕢𥕦𥟇𤤿𥡝偦㓻𣏌惞𥤃䝼𨥈𥪮𥮉𥰆𡶐垡煑澶𦄂𧰒遖𦆲𤾚譢𦐂𦑊"],["9c40","嵛𦯷輶𦒄𡤜諪𤧶𦒈𣿯𦔒䯀𦖿𦚵𢜛鑥𥟡憕娧晉侻嚹𤔡𦛼乪𤤴陖涏𦲽㘘襷𦞙𦡮𦐑𦡞營𦣇筂𩃀𠨑𦤦鄄𦤹穅鷰𦧺騦𦨭㙟𦑩𠀡禃𦨴𦭛崬𣔙菏𦮝䛐𦲤画补𦶮墶"],["9ca1","㜜𢖍𧁋𧇍㱔𧊀𧊅銁𢅺𧊋錰𧋦𤧐氹钟𧑐𠻸蠧裵𢤦𨑳𡞱溸𤨪𡠠㦤㚹尐秣䔿暶𩲭𩢤襃𧟌𧡘囖䃟𡘊㦡𣜯𨃨𡏅熭荦𧧝𩆨婧䲷𧂯𨦫𧧽𧨊𧬋𧵦𤅺筃祾𨀉澵𪋟樃𨌘厢𦸇鎿栶靝𨅯𨀣𦦵𡏭𣈯𨁈嶅𨰰𨂃圕頣𨥉嶫𤦈斾槕叒𤪥𣾁㰑朶𨂐𨃴𨄮𡾡𨅏"],["9d40","𨆉𨆯𨈚𨌆𨌯𨎊㗊𨑨𨚪䣺揦𨥖砈鉕𨦸䏲𨧧䏟𨧨𨭆𨯔姸𨰉輋𨿅𩃬筑𩄐𩄼㷷𩅞𤫊运犏嚋𩓧𩗩𩖰𩖸𩜲𩣑𩥉𩥪𩧃𩨨𩬎𩵚𩶛纟𩻸𩼣䲤镇𪊓熢𪋿䶑递𪗋䶜𠲜达嗁"],["9da1","辺𢒰边𤪓䔉繿潖檱仪㓤𨬬𧢝㜺躀𡟵𨀤𨭬𨮙𧨾𦚯㷫𧙕𣲷𥘵𥥖亚𥺁𦉘嚿𠹭踎孭𣺈𤲞揞拐𡟶𡡻攰嘭𥱊吚𥌑㷆𩶘䱽嘢嘞罉𥻘奵𣵀蝰东𠿪𠵉𣚺脗鵞贘瘻鱅癎瞹鍅吲腈苷嘥脲萘肽嗪祢噃吖𠺝㗎嘅嗱曱𨋢㘭甴嗰喺咗啲𠱁𠲖廐𥅈𠹶𢱢"],["9e40","𠺢麫絚嗞𡁵抝靭咔賍燶酶揼掹揾啩𢭃鱲𢺳冚㓟𠶧冧呍唞唓癦踭𦢊疱肶蠄螆裇膶萜𡃁䓬猄𤜆宐茋𦢓噻𢛴𧴯𤆣𧵳𦻐𧊶酰𡇙鈈𣳼𪚩𠺬𠻹牦𡲢䝎𤿂𧿹𠿫䃺"],["9ea1","鱝攟𢶠䣳𤟠𩵼𠿬𠸊恢𧖣𠿭"],["9ead","𦁈𡆇熣纎鵐业丄㕷嬍沲卧㚬㧜卽㚥𤘘墚𤭮舭呋垪𥪕𠥹"],["9ec5","㩒𢑥獴𩺬䴉鯭𣳾𩼰䱛𤾩𩖞𩿞葜𣶶𧊲𦞳𣜠挮紥𣻷𣸬㨪逈勌㹴㙺䗩𠒎癀嫰𠺶硺𧼮墧䂿噼鮋嵴癔𪐴麅䳡痹㟻愙𣃚𤏲"],["9ef5","噝𡊩垧𤥣𩸆刴𧂮㖭汊鵼"],["9f40","籖鬹埞𡝬屓擓𩓐𦌵𧅤蚭𠴨𦴢𤫢𠵱"],["9f4f","凾𡼏嶎霃𡷑麁遌笟鬂峑箣扨挵髿篏鬪籾鬮籂粆鰕篼鬉鼗鰛𤤾齚啳寃俽麘俲剠㸆勑坧偖妷帒韈鶫轜呩鞴饀鞺匬愰"],["9fa1","椬叚鰊鴂䰻陁榀傦畆𡝭駚剳"],["9fae","酙隁酜"],["9fb2","酑𨺗捿𦴣櫊嘑醎畺抅𠏼獏籰𥰡𣳽"],["9fc1","𤤙盖鮝个𠳔莾衂"],["9fc9","届槀僭坺刟巵从氱𠇲伹咜哚劚趂㗾弌㗳"],["9fdb","歒酼龥鮗頮颴骺麨麄煺笔"],["9fe7","毺蠘罸"],["9feb","嘠𪙊蹷齓"],["9ff0","跔蹏鸜踁抂𨍽踨蹵竓𤩷稾磘泪詧瘇"],["a040","𨩚鼦泎蟖痃𪊲硓咢贌狢獱謭猂瓱賫𤪻蘯徺袠䒷"],["a055","𡠻𦸅"],["a058","詾𢔛"],["a05b","惽癧髗鵄鍮鮏蟵"],["a063","蠏賷猬霡鮰㗖犲䰇籑饊𦅙慙䰄麖慽"],["a073","坟慯抦戹拎㩜懢厪𣏵捤栂㗒"],["a0a1","嵗𨯂迚𨸹"],["a0a6","僙𡵆礆匲阸𠼻䁥"],["a0ae","矾"],["a0b0","糂𥼚糚稭聦聣絍甅瓲覔舚朌聢𧒆聛瓰脃眤覉𦟌畓𦻑螩蟎臈螌詉貭譃眫瓸蓚㘵榲趦"],["a0d4","覩瑨涹蟁𤀑瓧㷛煶悤憜㳑煢恷"],["a0e2","罱𨬭牐惩䭾删㰘𣳇𥻗𧙖𥔱𡥄𡋾𩤃𦷜𧂭峁𦆭𨨏𣙷𠃮𦡆𤼎䕢嬟𦍌齐麦𦉫"],["a3c0","␀",31,"␡"],["c6a1","①",9,"⑴",9,"ⅰ",9,"丶丿亅亠冂冖冫勹匸卩厶夊宀巛⼳广廴彐彡攴无疒癶辵隶¨ˆヽヾゝゞ〃仝々〆〇ー［］✽ぁ",23],["c740","す",58,"ァアィイ"],["c7a1","ゥ",81,"А",5,"ЁЖ",4],["c840","Л",26,"ёж",25,"⇧↸↹㇏𠃌乚𠂊刂䒑"],["c8a1","龰冈龱𧘇"],["c8cd","￢￤＇＂㈱№℡゛゜⺀⺄⺆⺇⺈⺊⺌⺍⺕⺜⺝⺥⺧⺪⺬⺮⺶⺼⺾⻆⻊⻌⻍⻏⻖⻗⻞⻣"],["c8f5","ʃɐɛɔɵœøŋʊɪ"],["f9fe","￭"],["fa40","𠕇鋛𠗟𣿅蕌䊵珯况㙉𤥂𨧤鍄𡧛苮𣳈砼杄拟𤤳𨦪𠊠𦮳𡌅侫𢓭倈𦴩𧪄𣘀𤪱𢔓倩𠍾徤𠎀𠍇滛𠐟偽儁㑺儎顬㝃萖𤦤𠒇兠𣎴兪𠯿𢃼𠋥𢔰𠖎𣈳𡦃宂蝽𠖳𣲙冲冸"],["faa1","鴴凉减凑㳜凓𤪦决凢卂凭菍椾𣜭彻刋刦刼劵剗劔効勅簕蕂勠蘍𦬓包𨫞啉滙𣾀𠥔𣿬匳卄𠯢泋𡜦栛珕恊㺪㣌𡛨燝䒢卭却𨚫卾卿𡖖𡘓矦厓𨪛厠厫厮玧𥝲㽙玜叁叅汉义埾叙㪫𠮏叠𣿫𢶣叶𠱷吓灹唫晗浛呭𦭓𠵴啝咏咤䞦𡜍𠻝㶴𠵍"],["fb40","𨦼𢚘啇䳭启琗喆喩嘅𡣗𤀺䕒𤐵暳𡂴嘷曍𣊊暤暭噍噏磱囱鞇叾圀囯园𨭦㘣𡉏坆𤆥汮炋坂㚱𦱾埦𡐖堃𡑔𤍣堦𤯵塜墪㕡壠壜𡈼壻寿坃𪅐𤉸鏓㖡够梦㛃湙"],["fba1","𡘾娤啓𡚒蔅姉𠵎𦲁𦴪𡟜姙𡟻𡞲𦶦浱𡠨𡛕姹𦹅媫婣㛦𤦩婷㜈媖瑥嫓𦾡𢕔㶅𡤑㜲𡚸広勐孶斈孼𧨎䀄䡝𠈄寕慠𡨴𥧌𠖥寳宝䴐尅𡭄尓珎尔𡲥𦬨屉䣝岅峩峯嶋𡷹𡸷崐崘嵆𡺤岺巗苼㠭𤤁𢁉𢅳芇㠶㯂帮檊幵幺𤒼𠳓厦亷廐厨𡝱帉廴𨒂"],["fc40","廹廻㢠廼栾鐛弍𠇁弢㫞䢮𡌺强𦢈𢏐彘𢑱彣鞽𦹮彲鍀𨨶徧嶶㵟𥉐𡽪𧃸𢙨釖𠊞𨨩怱暅𡡷㥣㷇㘹垐𢞴祱㹀悞悤悳𤦂𤦏𧩓璤僡媠慤萤慂慈𦻒憁凴𠙖憇宪𣾷"],["fca1","𢡟懓𨮝𩥝懐㤲𢦀𢣁怣慜攞掋𠄘担𡝰拕𢸍捬𤧟㨗搸揸𡎎𡟼撐澊𢸶頔𤂌𥜝擡擥鑻㩦携㩗敍漖𤨨𤨣斅敭敟𣁾斵𤥀䬷旑䃘𡠩无旣忟𣐀昘𣇷𣇸晄𣆤𣆥晋𠹵晧𥇦晳晴𡸽𣈱𨗴𣇈𥌓矅𢣷馤朂𤎜𤨡㬫槺𣟂杞杧杢𤇍𩃭柗䓩栢湐鈼栁𣏦𦶠桝"],["fd40","𣑯槡樋𨫟楳棃𣗍椁椀㴲㨁𣘼㮀枬楡𨩊䋼椶榘㮡𠏉荣傐槹𣙙𢄪橅𣜃檝㯳枱櫈𩆜㰍欝𠤣惞欵歴𢟍溵𣫛𠎵𡥘㝀吡𣭚毡𣻼毜氷𢒋𤣱𦭑汚舦汹𣶼䓅𣶽𤆤𤤌𤤀"],["fda1","𣳉㛥㳫𠴲鮃𣇹𢒑羏样𦴥𦶡𦷫涖浜湼漄𤥿𤂅𦹲蔳𦽴凇沜渝萮𨬡港𣸯瑓𣾂秌湏媑𣁋濸㜍澝𣸰滺𡒗𤀽䕕鏰潄潜㵎潴𩅰㴻澟𤅄濓𤂑𤅕𤀹𣿰𣾴𤄿凟𤅖𤅗𤅀𦇝灋灾炧炁烌烕烖烟䄄㷨熴熖𤉷焫煅媈煊煮岜𤍥煏鍢𤋁焬𤑚𤨧𤨢熺𨯨炽爎"],["fe40","鑂爕夑鑃爤鍁𥘅爮牀𤥴梽牕牗㹕𣁄栍漽犂猪猫𤠣𨠫䣭𨠄猨献珏玪𠰺𦨮珉瑉𤇢𡛧𤨤昣㛅𤦷𤦍𤧻珷琕椃𤨦琹𠗃㻗瑜𢢭瑠𨺲瑇珤瑶莹瑬㜰瑴鏱樬璂䥓𤪌"],["fea1","𤅟𤩹𨮏孆𨰃𡢞瓈𡦈甎瓩甞𨻙𡩋寗𨺬鎅畍畊畧畮𤾂㼄𤴓疎瑝疞疴瘂瘬癑癏癯癶𦏵皐臯㟸𦤑𦤎皡皥皷盌𦾟葢𥂝𥅽𡸜眞眦着撯𥈠睘𣊬瞯𨥤𨥨𡛁矴砉𡍶𤨒棊碯磇磓隥礮𥗠磗礴碱𧘌辸袄𨬫𦂃𢘜禆褀椂禀𥡗禝𧬹礼禩渪𧄦㺨秆𩄍秔"]]

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	var Buffer = __webpack_require__(2).Buffer,
	    Transform = __webpack_require__(31).Transform;


	// == Exports ==================================================================
	module.exports = function(iconv) {
	    
	    // Additional Public API.
	    iconv.encodeStream = function encodeStream(encoding, options) {
	        return new IconvLiteEncoderStream(iconv.getEncoder(encoding, options), options);
	    }

	    iconv.decodeStream = function decodeStream(encoding, options) {
	        return new IconvLiteDecoderStream(iconv.getDecoder(encoding, options), options);
	    }

	    iconv.supportsStreams = true;


	    // Not published yet.
	    iconv.IconvLiteEncoderStream = IconvLiteEncoderStream;
	    iconv.IconvLiteDecoderStream = IconvLiteDecoderStream;
	    iconv._collect = IconvLiteDecoderStream.prototype.collect;
	};


	// == Encoder stream =======================================================
	function IconvLiteEncoderStream(conv, options) {
	    this.conv = conv;
	    options = options || {};
	    options.decodeStrings = false; // We accept only strings, so we don't need to decode them.
	    Transform.call(this, options);
	}

	IconvLiteEncoderStream.prototype = Object.create(Transform.prototype, {
	    constructor: { value: IconvLiteEncoderStream }
	});

	IconvLiteEncoderStream.prototype._transform = function(chunk, encoding, done) {
	    if (typeof chunk != 'string')
	        return done(new Error("Iconv encoding stream needs strings as its input."));
	    try {
	        var res = this.conv.write(chunk);
	        if (res && res.length) this.push(res);
	        done();
	    }
	    catch (e) {
	        done(e);
	    }
	}

	IconvLiteEncoderStream.prototype._flush = function(done) {
	    try {
	        var res = this.conv.end();
	        if (res && res.length) this.push(res);
	        done();
	    }
	    catch (e) {
	        done(e);
	    }
	}

	IconvLiteEncoderStream.prototype.collect = function(cb) {
	    var chunks = [];
	    this.on('error', cb);
	    this.on('data', function(chunk) { chunks.push(chunk); });
	    this.on('end', function() {
	        cb(null, Buffer.concat(chunks));
	    });
	    return this;
	}


	// == Decoder stream =======================================================
	function IconvLiteDecoderStream(conv, options) {
	    this.conv = conv;
	    options = options || {};
	    options.encoding = this.encoding = 'utf8'; // We output strings.
	    Transform.call(this, options);
	}

	IconvLiteDecoderStream.prototype = Object.create(Transform.prototype, {
	    constructor: { value: IconvLiteDecoderStream }
	});

	IconvLiteDecoderStream.prototype._transform = function(chunk, encoding, done) {
	    if (!Buffer.isBuffer(chunk))
	        return done(new Error("Iconv decoding stream needs buffers as its input."));
	    try {
	        var res = this.conv.write(chunk);
	        if (res && res.length) this.push(res, this.encoding);
	        done();
	    }
	    catch (e) {
	        done(e);
	    }
	}

	IconvLiteDecoderStream.prototype._flush = function(done) {
	    try {
	        var res = this.conv.end();
	        if (res && res.length) this.push(res, this.encoding);                
	        done();
	    }
	    catch (e) {
	        done(e);
	    }
	}

	IconvLiteDecoderStream.prototype.collect = function(cb) {
	    var res = '';
	    this.on('error', cb);
	    this.on('data', function(chunk) { res += chunk; });
	    this.on('end', function() {
	        cb(null, res);
	    });
	    return this;
	}



/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var Buffer = __webpack_require__(2).Buffer;

	// == Extend Node primitives to use iconv-lite =================================

	module.exports = function (iconv) {
	    var original = undefined; // Place to keep original methods.

	    // Node authors rewrote Buffer internals to make it compatible with
	    // Uint8Array and we cannot patch key functions since then.
	    iconv.supportsNodeEncodingsExtension = !(new Buffer(0) instanceof Uint8Array);

	    iconv.extendNodeEncodings = function extendNodeEncodings() {
	        if (original) return;
	        original = {};

	        if (!iconv.supportsNodeEncodingsExtension) {
	            console.error("ACTION NEEDED: require('iconv-lite').extendNodeEncodings() is not supported in your version of Node");
	            console.error("See more info at https://github.com/ashtuchkin/iconv-lite/wiki/Node-v4-compatibility");
	            return;
	        }

	        var nodeNativeEncodings = {
	            'hex': true, 'utf8': true, 'utf-8': true, 'ascii': true, 'binary': true, 
	            'base64': true, 'ucs2': true, 'ucs-2': true, 'utf16le': true, 'utf-16le': true,
	        };

	        Buffer.isNativeEncoding = function(enc) {
	            return enc && nodeNativeEncodings[enc.toLowerCase()];
	        }

	        // -- SlowBuffer -----------------------------------------------------------
	        var SlowBuffer = __webpack_require__(2).SlowBuffer;

	        original.SlowBufferToString = SlowBuffer.prototype.toString;
	        SlowBuffer.prototype.toString = function(encoding, start, end) {
	            encoding = String(encoding || 'utf8').toLowerCase();

	            // Use native conversion when possible
	            if (Buffer.isNativeEncoding(encoding))
	                return original.SlowBufferToString.call(this, encoding, start, end);

	            // Otherwise, use our decoding method.
	            if (typeof start == 'undefined') start = 0;
	            if (typeof end == 'undefined') end = this.length;
	            return iconv.decode(this.slice(start, end), encoding);
	        }

	        original.SlowBufferWrite = SlowBuffer.prototype.write;
	        SlowBuffer.prototype.write = function(string, offset, length, encoding) {
	            // Support both (string, offset, length, encoding)
	            // and the legacy (string, encoding, offset, length)
	            if (isFinite(offset)) {
	                if (!isFinite(length)) {
	                    encoding = length;
	                    length = undefined;
	                }
	            } else {  // legacy
	                var swap = encoding;
	                encoding = offset;
	                offset = length;
	                length = swap;
	            }

	            offset = +offset || 0;
	            var remaining = this.length - offset;
	            if (!length) {
	                length = remaining;
	            } else {
	                length = +length;
	                if (length > remaining) {
	                    length = remaining;
	                }
	            }
	            encoding = String(encoding || 'utf8').toLowerCase();

	            // Use native conversion when possible
	            if (Buffer.isNativeEncoding(encoding))
	                return original.SlowBufferWrite.call(this, string, offset, length, encoding);

	            if (string.length > 0 && (length < 0 || offset < 0))
	                throw new RangeError('attempt to write beyond buffer bounds');

	            // Otherwise, use our encoding method.
	            var buf = iconv.encode(string, encoding);
	            if (buf.length < length) length = buf.length;
	            buf.copy(this, offset, 0, length);
	            return length;
	        }

	        // -- Buffer ---------------------------------------------------------------

	        original.BufferIsEncoding = Buffer.isEncoding;
	        Buffer.isEncoding = function(encoding) {
	            return Buffer.isNativeEncoding(encoding) || iconv.encodingExists(encoding);
	        }

	        original.BufferByteLength = Buffer.byteLength;
	        Buffer.byteLength = SlowBuffer.byteLength = function(str, encoding) {
	            encoding = String(encoding || 'utf8').toLowerCase();

	            // Use native conversion when possible
	            if (Buffer.isNativeEncoding(encoding))
	                return original.BufferByteLength.call(this, str, encoding);

	            // Slow, I know, but we don't have a better way yet.
	            return iconv.encode(str, encoding).length;
	        }

	        original.BufferToString = Buffer.prototype.toString;
	        Buffer.prototype.toString = function(encoding, start, end) {
	            encoding = String(encoding || 'utf8').toLowerCase();

	            // Use native conversion when possible
	            if (Buffer.isNativeEncoding(encoding))
	                return original.BufferToString.call(this, encoding, start, end);

	            // Otherwise, use our decoding method.
	            if (typeof start == 'undefined') start = 0;
	            if (typeof end == 'undefined') end = this.length;
	            return iconv.decode(this.slice(start, end), encoding);
	        }

	        original.BufferWrite = Buffer.prototype.write;
	        Buffer.prototype.write = function(string, offset, length, encoding) {
	            var _offset = offset, _length = length, _encoding = encoding;
	            // Support both (string, offset, length, encoding)
	            // and the legacy (string, encoding, offset, length)
	            if (isFinite(offset)) {
	                if (!isFinite(length)) {
	                    encoding = length;
	                    length = undefined;
	                }
	            } else {  // legacy
	                var swap = encoding;
	                encoding = offset;
	                offset = length;
	                length = swap;
	            }

	            encoding = String(encoding || 'utf8').toLowerCase();

	            // Use native conversion when possible
	            if (Buffer.isNativeEncoding(encoding))
	                return original.BufferWrite.call(this, string, _offset, _length, _encoding);

	            offset = +offset || 0;
	            var remaining = this.length - offset;
	            if (!length) {
	                length = remaining;
	            } else {
	                length = +length;
	                if (length > remaining) {
	                    length = remaining;
	                }
	            }

	            if (string.length > 0 && (length < 0 || offset < 0))
	                throw new RangeError('attempt to write beyond buffer bounds');

	            // Otherwise, use our encoding method.
	            var buf = iconv.encode(string, encoding);
	            if (buf.length < length) length = buf.length;
	            buf.copy(this, offset, 0, length);
	            return length;

	            // TODO: Set _charsWritten.
	        }


	        // -- Readable -------------------------------------------------------------
	        if (iconv.supportsStreams) {
	            var Readable = __webpack_require__(31).Readable;

	            original.ReadableSetEncoding = Readable.prototype.setEncoding;
	            Readable.prototype.setEncoding = function setEncoding(enc, options) {
	                // Use our own decoder, it has the same interface.
	                // We cannot use original function as it doesn't handle BOM-s.
	                this._readableState.decoder = iconv.getDecoder(enc, options);
	                this._readableState.encoding = enc;
	            }

	            Readable.prototype.collect = iconv._collect;
	        }
	    }

	    // Remove iconv-lite Node primitive extensions.
	    iconv.undoExtendNodeEncodings = function undoExtendNodeEncodings() {
	        if (!iconv.supportsNodeEncodingsExtension)
	            return;
	        if (!original)
	            throw new Error("require('iconv-lite').undoExtendNodeEncodings(): Nothing to undo; extendNodeEncodings() is not called.")

	        delete Buffer.isNativeEncoding;

	        var SlowBuffer = __webpack_require__(2).SlowBuffer;

	        SlowBuffer.prototype.toString = original.SlowBufferToString;
	        SlowBuffer.prototype.write = original.SlowBufferWrite;

	        Buffer.isEncoding = original.BufferIsEncoding;
	        Buffer.byteLength = original.BufferByteLength;
	        Buffer.prototype.toString = original.BufferToString;
	        Buffer.prototype.write = original.BufferWrite;

	        if (iconv.supportsStreams) {
	            var Readable = __webpack_require__(31).Readable;

	            Readable.prototype.setEncoding = original.ReadableSetEncoding;
	            delete Readable.prototype.collect;
	        }

	        original = undefined;
	    }
	}


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.7.1
	(function() {
	  var ArrayT, NumberT, utils;

	  NumberT = __webpack_require__(109).Number;

	  utils = __webpack_require__(110);

	  ArrayT = (function() {
	    function ArrayT(type, length, lengthType) {
	      this.type = type;
	      this.length = length;
	      this.lengthType = lengthType != null ? lengthType : 'count';
	    }

	    ArrayT.prototype.decode = function(stream, parent) {
	      var ctx, i, length, pos, res, target, _i;
	      pos = stream.pos;
	      res = [];
	      ctx = parent;
	      if (this.length != null) {
	        length = utils.resolveLength(this.length, stream, parent);
	      }
	      if (this.length instanceof NumberT) {
	        Object.defineProperties(res, {
	          parent: {
	            value: parent
	          },
	          _startOffset: {
	            value: pos
	          },
	          _currentOffset: {
	            value: 0,
	            writable: true
	          },
	          _length: {
	            value: length
	          }
	        });
	        ctx = res;
	      }
	      if ((length == null) || this.lengthType === 'bytes') {
	        target = length != null ? stream.pos + length : (parent != null ? parent._length : void 0) ? parent._startOffset + parent._length : stream.length;
	        while (stream.pos < target) {
	          res.push(this.type.decode(stream, ctx));
	        }
	      } else {
	        for (i = _i = 0; _i < length; i = _i += 1) {
	          res.push(this.type.decode(stream, ctx));
	        }
	      }
	      return res;
	    };

	    ArrayT.prototype.size = function(array, ctx) {
	      var item, size, _i, _len;
	      if (!array) {
	        return this.type.size(null, ctx) * utils.resolveLength(this.length, null, ctx);
	      }
	      size = 0;
	      if (this.length instanceof NumberT) {
	        size += this.length.size();
	        ctx = {
	          parent: ctx
	        };
	      }
	      for (_i = 0, _len = array.length; _i < _len; _i++) {
	        item = array[_i];
	        size += this.type.size(item, ctx);
	      }
	      return size;
	    };

	    ArrayT.prototype.encode = function(stream, array, parent) {
	      var ctx, i, item, ptr, _i, _len;
	      ctx = parent;
	      if (this.length instanceof NumberT) {
	        ctx = {
	          pointers: [],
	          startOffset: stream.pos,
	          parent: parent
	        };
	        ctx.pointerOffset = stream.pos + this.size(array, ctx);
	        this.length.encode(stream, array.length);
	      }
	      for (_i = 0, _len = array.length; _i < _len; _i++) {
	        item = array[_i];
	        this.type.encode(stream, item, ctx);
	      }
	      if (this.length instanceof NumberT) {
	        i = 0;
	        while (i < ctx.pointers.length) {
	          ptr = ctx.pointers[i++];
	          ptr.type.encode(stream, ptr.val);
	        }
	      }
	    };

	    return ArrayT;

	  })();

	  module.exports = ArrayT;

	}).call(this);


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.7.1
	(function() {
	  var DecodeStream, Fixed, NumberT,
	    __hasProp = {}.hasOwnProperty,
	    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

	  DecodeStream = __webpack_require__(86);

	  NumberT = (function() {
	    function NumberT(type, endian) {
	      this.type = type;
	      this.endian = endian != null ? endian : 'BE';
	      this.fn = this.type;
	      if (this.type[this.type.length - 1] !== '8') {
	        this.fn += this.endian;
	      }
	    }

	    NumberT.prototype.size = function() {
	      return DecodeStream.TYPES[this.type];
	    };

	    NumberT.prototype.decode = function(stream) {
	      return stream['read' + this.fn]();
	    };

	    NumberT.prototype.encode = function(stream, val) {
	      return stream['write' + this.fn](val);
	    };

	    return NumberT;

	  })();

	  exports.Number = NumberT;

	  exports.uint8 = new NumberT('UInt8');

	  exports.uint16be = exports.uint16 = new NumberT('UInt16', 'BE');

	  exports.uint16le = new NumberT('UInt16', 'LE');

	  exports.uint24be = exports.uint24 = new NumberT('UInt24', 'BE');

	  exports.uint24le = new NumberT('UInt24', 'LE');

	  exports.uint32be = exports.uint32 = new NumberT('UInt32', 'BE');

	  exports.uint32le = new NumberT('UInt32', 'LE');

	  exports.int8 = new NumberT('Int8');

	  exports.int16be = exports.int16 = new NumberT('Int16', 'BE');

	  exports.int16le = new NumberT('Int16', 'LE');

	  exports.int24be = exports.int24 = new NumberT('Int24', 'BE');

	  exports.int24le = new NumberT('Int24', 'LE');

	  exports.int32be = exports.int32 = new NumberT('Int32', 'BE');

	  exports.int32le = new NumberT('Int32', 'LE');

	  exports.floatbe = exports.float = new NumberT('Float', 'BE');

	  exports.floatle = new NumberT('Float', 'LE');

	  exports.doublebe = exports.double = new NumberT('Double', 'BE');

	  exports.doublele = new NumberT('Double', 'LE');

	  Fixed = (function(_super) {
	    __extends(Fixed, _super);

	    function Fixed(size, endian, fracBits) {
	      if (fracBits == null) {
	        fracBits = size >> 1;
	      }
	      Fixed.__super__.constructor.call(this, "Int" + size, endian);
	      this._point = 1 << fracBits;
	    }

	    Fixed.prototype.decode = function(stream) {
	      return Fixed.__super__.decode.call(this, stream) / this._point;
	    };

	    Fixed.prototype.encode = function(stream, val) {
	      return Fixed.__super__.encode.call(this, stream, val * this._point | 0);
	    };

	    return Fixed;

	  })(NumberT);

	  exports.Fixed = Fixed;

	  exports.fixed16be = exports.fixed16 = new Fixed(16, 'BE');

	  exports.fixed16le = new Fixed(16, 'LE');

	  exports.fixed32be = exports.fixed32 = new Fixed(32, 'BE');

	  exports.fixed32le = new Fixed(32, 'LE');

	}).call(this);


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.7.1
	(function() {
	  var NumberT, PropertyDescriptor;

	  NumberT = __webpack_require__(109).Number;

	  exports.resolveLength = function(length, stream, parent) {
	    var res;
	    if (typeof length === 'number') {
	      res = length;
	    } else if (typeof length === 'function') {
	      res = length.call(parent, parent);
	    } else if (parent && typeof length === 'string') {
	      res = parent[length];
	    } else if (stream && length instanceof NumberT) {
	      res = length.decode(stream);
	    }
	    if (isNaN(res)) {
	      throw new Error('Not a fixed size');
	    }
	    return res;
	  };

	  PropertyDescriptor = (function() {
	    function PropertyDescriptor(opts) {
	      var key, val;
	      if (opts == null) {
	        opts = {};
	      }
	      this.enumerable = true;
	      this.configurable = true;
	      for (key in opts) {
	        val = opts[key];
	        this[key] = val;
	      }
	    }

	    return PropertyDescriptor;

	  })();

	  exports.PropertyDescriptor = PropertyDescriptor;

	}).call(this);


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.7.1
	(function() {
	  var ArrayT, LazyArray, LazyArrayT, NumberT, inspect, utils,
	    __hasProp = {}.hasOwnProperty,
	    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

	  ArrayT = __webpack_require__(108);

	  NumberT = __webpack_require__(109).Number;

	  utils = __webpack_require__(110);

	  inspect = __webpack_require__(72).inspect;

	  LazyArrayT = (function(_super) {
	    __extends(LazyArrayT, _super);

	    function LazyArrayT() {
	      return LazyArrayT.__super__.constructor.apply(this, arguments);
	    }

	    LazyArrayT.prototype.decode = function(stream, parent) {
	      var length, pos, res;
	      pos = stream.pos;
	      length = utils.resolveLength(this.length, stream, parent);
	      if (this.length instanceof NumberT) {
	        parent = {
	          parent: parent,
	          _startOffset: pos,
	          _currentOffset: 0,
	          _length: length
	        };
	      }
	      res = new LazyArray(this.type, length, stream, parent);
	      stream.pos += length * this.type.size(null, parent);
	      return res;
	    };

	    LazyArrayT.prototype.size = function(val, ctx) {
	      if (val instanceof LazyArray) {
	        val = val.toArray();
	      }
	      return LazyArrayT.__super__.size.call(this, val, ctx);
	    };

	    LazyArrayT.prototype.encode = function(stream, val, ctx) {
	      if (val instanceof LazyArray) {
	        val = val.toArray();
	      }
	      return LazyArrayT.__super__.encode.call(this, stream, val, ctx);
	    };

	    return LazyArrayT;

	  })(ArrayT);

	  LazyArray = (function() {
	    function LazyArray(type, length, stream, ctx) {
	      this.type = type;
	      this.length = length;
	      this.stream = stream;
	      this.ctx = ctx;
	      this.base = this.stream.pos;
	      this.items = [];
	    }

	    LazyArray.prototype.get = function(index) {
	      var pos;
	      if (index < 0 || index >= this.length) {
	        return void 0;
	      }
	      if (this.items[index] == null) {
	        pos = this.stream.pos;
	        this.stream.pos = this.base + this.type.size(null, this.ctx) * index;
	        this.items[index] = this.type.decode(this.stream, this.ctx);
	        this.stream.pos = pos;
	      }
	      return this.items[index];
	    };

	    LazyArray.prototype.toArray = function() {
	      var i, _i, _ref, _results;
	      _results = [];
	      for (i = _i = 0, _ref = this.length; _i < _ref; i = _i += 1) {
	        _results.push(this.get(i));
	      }
	      return _results;
	    };

	    LazyArray.prototype.inspect = function() {
	      return inspect(this.toArray());
	    };

	    return LazyArray;

	  })();

	  module.exports = LazyArrayT;

	}).call(this);


/***/ }),
/* 112 */
/***/ (function(module, exports) {

	// Generated by CoffeeScript 1.7.1
	(function() {
	  var Bitfield;

	  Bitfield = (function() {
	    function Bitfield(type, flags) {
	      this.type = type;
	      this.flags = flags != null ? flags : [];
	    }

	    Bitfield.prototype.decode = function(stream) {
	      var flag, i, res, val, _i, _len, _ref;
	      val = this.type.decode(stream);
	      res = {};
	      _ref = this.flags;
	      for (i = _i = 0, _len = _ref.length; _i < _len; i = ++_i) {
	        flag = _ref[i];
	        if (flag != null) {
	          res[flag] = !!(val & (1 << i));
	        }
	      }
	      return res;
	    };

	    Bitfield.prototype.size = function() {
	      return this.type.size();
	    };

	    Bitfield.prototype.encode = function(stream, keys) {
	      var flag, i, val, _i, _len, _ref;
	      val = 0;
	      _ref = this.flags;
	      for (i = _i = 0, _len = _ref.length; _i < _len; i = ++_i) {
	        flag = _ref[i];
	        if (flag != null) {
	          if (keys[flag]) {
	            val |= 1 << i;
	          }
	        }
	      }
	      return this.type.encode(stream, val);
	    };

	    return Bitfield;

	  })();

	  module.exports = Bitfield;

	}).call(this);


/***/ }),
/* 113 */
/***/ (function(module, exports) {

	// Generated by CoffeeScript 1.7.1
	(function() {
	  var BooleanT;

	  BooleanT = (function() {
	    function BooleanT(type) {
	      this.type = type;
	    }

	    BooleanT.prototype.decode = function(stream, parent) {
	      return !!this.type.decode(stream, parent);
	    };

	    BooleanT.prototype.size = function(val, parent) {
	      return this.type.size(val, parent);
	    };

	    BooleanT.prototype.encode = function(stream, val, parent) {
	      return this.type.encode(stream, +val, parent);
	    };

	    return BooleanT;

	  })();

	  module.exports = BooleanT;

	}).call(this);


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.7.1
	(function() {
	  var BufferT, NumberT, utils;

	  utils = __webpack_require__(110);

	  NumberT = __webpack_require__(109).Number;

	  BufferT = (function() {
	    function BufferT(length) {
	      this.length = length;
	    }

	    BufferT.prototype.decode = function(stream, parent) {
	      var length;
	      length = utils.resolveLength(this.length, stream, parent);
	      return stream.readBuffer(length);
	    };

	    BufferT.prototype.size = function(val, parent) {
	      if (!val) {
	        return utils.resolveLength(this.length, null, parent);
	      }
	      return val.length;
	    };

	    BufferT.prototype.encode = function(stream, buf, parent) {
	      if (this.length instanceof NumberT) {
	        this.length.encode(stream, buf.length);
	      }
	      return stream.writeBuffer(buf);
	    };

	    return BufferT;

	  })();

	  module.exports = BufferT;

	}).call(this);


/***/ }),
/* 115 */
/***/ (function(module, exports) {

	// Generated by CoffeeScript 1.7.1
	(function() {
	  var Enum;

	  Enum = (function() {
	    function Enum(type, options) {
	      this.type = type;
	      this.options = options != null ? options : [];
	    }

	    Enum.prototype.decode = function(stream) {
	      var index;
	      index = this.type.decode(stream);
	      return this.options[index] || index;
	    };

	    Enum.prototype.size = function() {
	      return this.type.size();
	    };

	    Enum.prototype.encode = function(stream, val) {
	      var index;
	      index = this.options.indexOf(val);
	      if (index === -1) {
	        throw new Error("Unknown option in enum: " + val);
	      }
	      return this.type.encode(stream, index);
	    };

	    return Enum;

	  })();

	  module.exports = Enum;

	}).call(this);


/***/ }),
/* 116 */
/***/ (function(module, exports) {

	// Generated by CoffeeScript 1.7.1
	(function() {
	  var Optional;

	  Optional = (function() {
	    function Optional(type, condition) {
	      this.type = type;
	      this.condition = condition != null ? condition : true;
	    }

	    Optional.prototype.decode = function(stream, parent) {
	      var condition;
	      condition = this.condition;
	      if (typeof condition === 'function') {
	        condition = condition.call(parent, parent);
	      }
	      if (condition) {
	        return this.type.decode(stream, parent);
	      }
	    };

	    Optional.prototype.size = function(val, parent) {
	      var condition;
	      condition = this.condition;
	      if (typeof condition === 'function') {
	        condition = condition.call(parent, parent);
	      }
	      if (condition) {
	        return this.type.size(val, parent);
	      } else {
	        return 0;
	      }
	    };

	    Optional.prototype.encode = function(stream, val, parent) {
	      var condition;
	      condition = this.condition;
	      if (typeof condition === 'function') {
	        condition = condition.call(parent, parent);
	      }
	      if (condition) {
	        return this.type.encode(stream, val, parent);
	      }
	    };

	    return Optional;

	  })();

	  module.exports = Optional;

	}).call(this);


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.7.1
	(function() {
	  var Reserved, utils;

	  utils = __webpack_require__(110);

	  Reserved = (function() {
	    function Reserved(type, count) {
	      this.type = type;
	      this.count = count != null ? count : 1;
	    }

	    Reserved.prototype.decode = function(stream, parent) {
	      stream.pos += this.size(null, parent);
	      return void 0;
	    };

	    Reserved.prototype.size = function(data, parent) {
	      var count;
	      count = utils.resolveLength(this.count, null, parent);
	      return this.type.size() * count;
	    };

	    Reserved.prototype.encode = function(stream, val, parent) {
	      return stream.fill(0, this.size(val, parent));
	    };

	    return Reserved;

	  })();

	  module.exports = Reserved;

	}).call(this);


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Generated by CoffeeScript 1.7.1
	(function() {
	  var NumberT, StringT, utils;

	  NumberT = __webpack_require__(109).Number;

	  utils = __webpack_require__(110);

	  StringT = (function() {
	    function StringT(length, encoding) {
	      this.length = length;
	      this.encoding = encoding != null ? encoding : 'ascii';
	    }

	    StringT.prototype.decode = function(stream, parent) {
	      var buffer, encoding, length, pos, string;
	      length = (function() {
	        if (this.length != null) {
	          return utils.resolveLength(this.length, stream, parent);
	        } else {
	          buffer = stream.buffer, length = stream.length, pos = stream.pos;
	          while (pos < length && buffer[pos] !== 0x00) {
	            ++pos;
	          }
	          return pos - stream.pos;
	        }
	      }).call(this);
	      encoding = this.encoding;
	      if (typeof encoding === 'function') {
	        encoding = encoding.call(parent, parent) || 'ascii';
	      }
	      string = stream.readString(length, encoding);
	      if ((this.length == null) && stream.pos < stream.length) {
	        stream.pos++;
	      }
	      return string;
	    };

	    StringT.prototype.size = function(val, parent) {
	      var encoding, size;
	      if (!val) {
	        return utils.resolveLength(this.length, null, parent);
	      }
	      encoding = this.encoding;
	      if (typeof encoding === 'function') {
	        encoding = encoding.call(parent != null ? parent.val : void 0, parent != null ? parent.val : void 0) || 'ascii';
	      }
	      if (encoding === 'utf16be') {
	        encoding = 'utf16le';
	      }
	      size = Buffer.byteLength(val, encoding);
	      if (this.length instanceof NumberT) {
	        size += this.length.size();
	      }
	      if (this.length == null) {
	        size++;
	      }
	      return size;
	    };

	    StringT.prototype.encode = function(stream, val, parent) {
	      var encoding;
	      encoding = this.encoding;
	      if (typeof encoding === 'function') {
	        encoding = encoding.call(parent != null ? parent.val : void 0, parent != null ? parent.val : void 0) || 'ascii';
	      }
	      if (this.length instanceof NumberT) {
	        this.length.encode(stream, Buffer.byteLength(val, encoding));
	      }
	      stream.writeString(val, encoding);
	      if (this.length == null) {
	        return stream.writeUInt8(0x00);
	      }
	    };

	    return StringT;

	  })();

	  module.exports = StringT;

	}).call(this);

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.7.1
	(function() {
	  var Struct, utils;

	  utils = __webpack_require__(110);

	  Struct = (function() {
	    function Struct(fields) {
	      this.fields = fields != null ? fields : {};
	    }

	    Struct.prototype.decode = function(stream, parent, length) {
	      var res, _ref;
	      if (length == null) {
	        length = 0;
	      }
	      res = this._setup(stream, parent, length);
	      this._parseFields(stream, res, this.fields);
	      if ((_ref = this.process) != null) {
	        _ref.call(res, stream);
	      }
	      return res;
	    };

	    Struct.prototype._setup = function(stream, parent, length) {
	      var res;
	      res = {};
	      Object.defineProperties(res, {
	        parent: {
	          value: parent
	        },
	        _startOffset: {
	          value: stream.pos
	        },
	        _currentOffset: {
	          value: 0,
	          writable: true
	        },
	        _length: {
	          value: length
	        }
	      });
	      return res;
	    };

	    Struct.prototype._parseFields = function(stream, res, fields) {
	      var key, type, val;
	      for (key in fields) {
	        type = fields[key];
	        if (typeof type === 'function') {
	          val = type.call(res, res);
	        } else {
	          val = type.decode(stream, res);
	        }
	        if (val !== void 0) {
	          if (val instanceof utils.PropertyDescriptor) {
	            Object.defineProperty(res, key, val);
	          } else {
	            res[key] = val;
	          }
	        }
	        res._currentOffset = stream.pos - res._startOffset;
	      }
	    };

	    Struct.prototype.size = function(val, parent, includePointers) {
	      var ctx, key, size, type, _ref;
	      if (val == null) {
	        val = {};
	      }
	      if (includePointers == null) {
	        includePointers = true;
	      }
	      ctx = {
	        parent: parent,
	        val: val,
	        pointerSize: 0
	      };
	      size = 0;
	      _ref = this.fields;
	      for (key in _ref) {
	        type = _ref[key];
	        if (type.size != null) {
	          size += type.size(val[key], ctx);
	        }
	      }
	      if (includePointers) {
	        size += ctx.pointerSize;
	      }
	      return size;
	    };

	    Struct.prototype.encode = function(stream, val, parent) {
	      var ctx, i, key, ptr, type, _ref, _ref1;
	      if ((_ref = this.preEncode) != null) {
	        _ref.call(val, stream);
	      }
	      ctx = {
	        pointers: [],
	        startOffset: stream.pos,
	        parent: parent,
	        val: val,
	        pointerSize: 0
	      };
	      ctx.pointerOffset = stream.pos + this.size(val, ctx, false);
	      _ref1 = this.fields;
	      for (key in _ref1) {
	        type = _ref1[key];
	        if (type.encode != null) {
	          type.encode(stream, val[key], ctx);
	        }
	      }
	      i = 0;
	      while (i < ctx.pointers.length) {
	        ptr = ctx.pointers[i++];
	        ptr.type.encode(stream, ptr.val, ptr.parent);
	      }
	    };

	    return Struct;

	  })();

	  module.exports = Struct;

	}).call(this);


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.7.1
	(function() {
	  var Struct, VersionedStruct,
	    __hasProp = {}.hasOwnProperty,
	    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

	  Struct = __webpack_require__(119);

	  VersionedStruct = (function(_super) {
	    __extends(VersionedStruct, _super);

	    function VersionedStruct(type, versions) {
	      this.type = type;
	      this.versions = versions != null ? versions : {};
	      if (typeof this.type === 'string') {
	        this.versionGetter = new Function('parent', "return parent." + this.type);
	        this.versionSetter = new Function('parent', 'version', "return parent." + this.type + " = version");
	      }
	    }

	    VersionedStruct.prototype.decode = function(stream, parent, length) {
	      var fields, res, _ref;
	      if (length == null) {
	        length = 0;
	      }
	      res = this._setup(stream, parent, length);
	      if (typeof this.type === 'string') {
	        res.version = this.versionGetter(parent);
	      } else {
	        res.version = this.type.decode(stream);
	      }
	      if (this.versions.header) {
	        this._parseFields(stream, res, this.versions.header);
	      }
	      fields = this.versions[res.version];
	      if (fields == null) {
	        throw new Error("Unknown version " + res.version);
	      }
	      if (fields instanceof VersionedStruct) {
	        return fields.decode(stream, parent);
	      }
	      this._parseFields(stream, res, fields);
	      if ((_ref = this.process) != null) {
	        _ref.call(res, stream);
	      }
	      return res;
	    };

	    VersionedStruct.prototype.size = function(val, parent, includePointers) {
	      var ctx, fields, key, size, type, _ref;
	      if (includePointers == null) {
	        includePointers = true;
	      }
	      if (!val) {
	        throw new Error('Not a fixed size');
	      }
	      ctx = {
	        parent: parent,
	        val: val,
	        pointerSize: 0
	      };
	      size = 0;
	      if (typeof this.type !== 'string') {
	        size += this.type.size(val.version, ctx);
	      }
	      if (this.versions.header) {
	        _ref = this.versions.header;
	        for (key in _ref) {
	          type = _ref[key];
	          if (type.size != null) {
	            size += type.size(val[key], ctx);
	          }
	        }
	      }
	      fields = this.versions[val.version];
	      if (fields == null) {
	        throw new Error("Unknown version " + val.version);
	      }
	      for (key in fields) {
	        type = fields[key];
	        if (type.size != null) {
	          size += type.size(val[key], ctx);
	        }
	      }
	      if (includePointers) {
	        size += ctx.pointerSize;
	      }
	      return size;
	    };

	    VersionedStruct.prototype.encode = function(stream, val, parent) {
	      var ctx, fields, i, key, ptr, type, _ref, _ref1;
	      if ((_ref = this.preEncode) != null) {
	        _ref.call(val, stream);
	      }
	      ctx = {
	        pointers: [],
	        startOffset: stream.pos,
	        parent: parent,
	        val: val,
	        pointerSize: 0
	      };
	      ctx.pointerOffset = stream.pos + this.size(val, ctx, false);
	      if (typeof this.type !== 'string') {
	        this.type.encode(stream, val.version);
	      }
	      if (this.versions.header) {
	        _ref1 = this.versions.header;
	        for (key in _ref1) {
	          type = _ref1[key];
	          if (type.encode != null) {
	            type.encode(stream, val[key], ctx);
	          }
	        }
	      }
	      fields = this.versions[val.version];
	      for (key in fields) {
	        type = fields[key];
	        if (type.encode != null) {
	          type.encode(stream, val[key], ctx);
	        }
	      }
	      i = 0;
	      while (i < ctx.pointers.length) {
	        ptr = ctx.pointers[i++];
	        ptr.type.encode(stream, ptr.val, ptr.parent);
	      }
	    };

	    return VersionedStruct;

	  })(Struct);

	  module.exports = VersionedStruct;

	}).call(this);


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.7.1
	(function() {
	  var Pointer, VoidPointer, utils;

	  utils = __webpack_require__(110);

	  Pointer = (function() {
	    function Pointer(offsetType, type, options) {
	      var _base, _base1, _base2, _base3;
	      this.offsetType = offsetType;
	      this.type = type;
	      this.options = options != null ? options : {};
	      if (this.type === 'void') {
	        this.type = null;
	      }
	      if ((_base = this.options).type == null) {
	        _base.type = 'local';
	      }
	      if ((_base1 = this.options).allowNull == null) {
	        _base1.allowNull = true;
	      }
	      if ((_base2 = this.options).nullValue == null) {
	        _base2.nullValue = 0;
	      }
	      if ((_base3 = this.options).lazy == null) {
	        _base3.lazy = false;
	      }
	      if (this.options.relativeTo) {
	        this.relativeToGetter = new Function('ctx', "return ctx." + this.options.relativeTo);
	      }
	    }

	    Pointer.prototype.decode = function(stream, ctx) {
	      var c, decodeValue, offset, ptr, relative, val;
	      offset = this.offsetType.decode(stream, ctx);
	      if (offset === this.options.nullValue && this.options.allowNull) {
	        return null;
	      }
	      relative = (function() {
	        switch (this.options.type) {
	          case 'local':
	            return ctx._startOffset;
	          case 'immediate':
	            return stream.pos - this.offsetType.size();
	          case 'parent':
	            return ctx.parent._startOffset;
	          default:
	            c = ctx;
	            while (c.parent) {
	              c = c.parent;
	            }
	            return c._startOffset || 0;
	        }
	      }).call(this);
	      if (this.options.relativeTo) {
	        relative += this.relativeToGetter(ctx);
	      }
	      ptr = offset + relative;
	      if (this.type != null) {
	        val = null;
	        decodeValue = (function(_this) {
	          return function() {
	            var pos;
	            if (val != null) {
	              return val;
	            }
	            pos = stream.pos;
	            stream.pos = ptr;
	            val = _this.type.decode(stream, ctx);
	            stream.pos = pos;
	            return val;
	          };
	        })(this);
	        if (this.options.lazy) {
	          return new utils.PropertyDescriptor({
	            get: decodeValue
	          });
	        }
	        return decodeValue();
	      } else {
	        return ptr;
	      }
	    };

	    Pointer.prototype.size = function(val, ctx) {
	      var parent, type;
	      parent = ctx;
	      switch (this.options.type) {
	        case 'local':
	        case 'immediate':
	          break;
	        case 'parent':
	          ctx = ctx.parent;
	          break;
	        default:
	          while (ctx.parent) {
	            ctx = ctx.parent;
	          }
	      }
	      type = this.type;
	      if (type == null) {
	        if (!(val instanceof VoidPointer)) {
	          throw new Error("Must be a VoidPointer");
	        }
	        type = val.type;
	        val = val.value;
	      }
	      if (val && ctx) {
	        ctx.pointerSize += type.size(val, parent);
	      }
	      return this.offsetType.size();
	    };

	    Pointer.prototype.encode = function(stream, val, ctx) {
	      var parent, relative, type;
	      parent = ctx;
	      if (val == null) {
	        this.offsetType.encode(stream, this.options.nullValue);
	        return;
	      }
	      switch (this.options.type) {
	        case 'local':
	          relative = ctx.startOffset;
	          break;
	        case 'immediate':
	          relative = stream.pos + this.offsetType.size(val, parent);
	          break;
	        case 'parent':
	          ctx = ctx.parent;
	          relative = ctx.startOffset;
	          break;
	        default:
	          relative = 0;
	          while (ctx.parent) {
	            ctx = ctx.parent;
	          }
	      }
	      if (this.options.relativeTo) {
	        relative += this.relativeToGetter(parent.val);
	      }
	      this.offsetType.encode(stream, ctx.pointerOffset - relative);
	      type = this.type;
	      if (type == null) {
	        if (!(val instanceof VoidPointer)) {
	          throw new Error("Must be a VoidPointer");
	        }
	        type = val.type;
	        val = val.value;
	      }
	      ctx.pointers.push({
	        type: type,
	        val: val,
	        parent: parent
	      });
	      return ctx.pointerOffset += type.size(val, parent);
	    };

	    return Pointer;

	  })();

	  VoidPointer = (function() {
	    function VoidPointer(type, value) {
	      this.type = type;
	      this.value = value;
	    }

	    return VoidPointer;

	  })();

	  exports.Pointer = Pointer;

	  exports.VoidPointer = VoidPointer;

	}).call(this);


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(123), __esModule: true };

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(124);
	var $Object = __webpack_require__(142).Object;
	module.exports = function getOwnPropertyDescriptor(it, key) {
	  return $Object.getOwnPropertyDescriptor(it, key);
	};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(125);
	var $getOwnPropertyDescriptor = __webpack_require__(129).f;

	__webpack_require__(140)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(126);
	var defined = __webpack_require__(128);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(127);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 127 */
/***/ (function(module, exports) {

	var toString = {}.toString;

	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 128 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(130);
	var createDesc = __webpack_require__(131);
	var toIObject = __webpack_require__(125);
	var toPrimitive = __webpack_require__(132);
	var has = __webpack_require__(134);
	var IE8_DOM_DEFINE = __webpack_require__(135);
	var gOPD = Object.getOwnPropertyDescriptor;

	exports.f = __webpack_require__(136) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 130 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 131 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(133);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 133 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 134 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(136) && !__webpack_require__(137)(function () {
	  return Object.defineProperty(__webpack_require__(138)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(137)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 137 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(133);
	var document = __webpack_require__(139).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 139 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(141);
	var core = __webpack_require__(142);
	var fails = __webpack_require__(137);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(139);
	var core = __webpack_require__(142);
	var ctx = __webpack_require__(143);
	var hide = __webpack_require__(145);
	var PROTOTYPE = 'prototype';

	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && key in exports) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 142 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.1' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(144);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 144 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(146);
	var createDesc = __webpack_require__(131);
	module.exports = __webpack_require__(136) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(147);
	var IE8_DOM_DEFINE = __webpack_require__(135);
	var toPrimitive = __webpack_require__(132);
	var dP = Object.defineProperty;

	exports.f = __webpack_require__(136) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(133);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(149), __esModule: true };

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(150);
	__webpack_require__(176);
	module.exports = __webpack_require__(178);


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(151);
	var global = __webpack_require__(139);
	var hide = __webpack_require__(145);
	var Iterators = __webpack_require__(154);
	var TO_STRING_TAG = __webpack_require__(173)('toStringTag');

	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');

	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(152);
	var step = __webpack_require__(153);
	var Iterators = __webpack_require__(154);
	var toIObject = __webpack_require__(125);

	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(155)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');

	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;

	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 152 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 153 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 154 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(156);
	var $export = __webpack_require__(141);
	var redefine = __webpack_require__(157);
	var hide = __webpack_require__(145);
	var has = __webpack_require__(134);
	var Iterators = __webpack_require__(154);
	var $iterCreate = __webpack_require__(158);
	var setToStringTag = __webpack_require__(172);
	var getPrototypeOf = __webpack_require__(174);
	var ITERATOR = __webpack_require__(173)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';

	var returnThis = function () { return this; };

	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 156 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(145);


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(159);
	var descriptor = __webpack_require__(131);
	var setToStringTag = __webpack_require__(172);
	var IteratorPrototype = {};

	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(145)(IteratorPrototype, __webpack_require__(173)('iterator'), function () { return this; });

	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(147);
	var dPs = __webpack_require__(160);
	var enumBugKeys = __webpack_require__(170);
	var IE_PROTO = __webpack_require__(167)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';

	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(138)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(171).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};

	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(146);
	var anObject = __webpack_require__(147);
	var getKeys = __webpack_require__(161);

	module.exports = __webpack_require__(136) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(162);
	var enumBugKeys = __webpack_require__(170);

	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(134);
	var toIObject = __webpack_require__(125);
	var arrayIndexOf = __webpack_require__(163)(false);
	var IE_PROTO = __webpack_require__(167)('IE_PROTO');

	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(125);
	var toLength = __webpack_require__(164);
	var toAbsoluteIndex = __webpack_require__(166);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(165);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 165 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(165);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(168)('keys');
	var uid = __webpack_require__(169);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(139);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ }),
/* 169 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 170 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(139).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(146).f;
	var has = __webpack_require__(134);
	var TAG = __webpack_require__(173)('toStringTag');

	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(168)('wks');
	var uid = __webpack_require__(169);
	var Symbol = __webpack_require__(139).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';

	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};

	$exports.store = store;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(134);
	var toObject = __webpack_require__(175);
	var IE_PROTO = __webpack_require__(167)('IE_PROTO');
	var ObjectProto = Object.prototype;

	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(128);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(177)(true);

	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(155)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(165);
	var defined = __webpack_require__(128);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(147);
	var get = __webpack_require__(179);
	module.exports = __webpack_require__(142).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(180);
	var ITERATOR = __webpack_require__(173)('iterator');
	var Iterators = __webpack_require__(154);
	module.exports = __webpack_require__(142).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(127);
	var TAG = __webpack_require__(173)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';

	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};

	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(182), __esModule: true };

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(183);
	module.exports = __webpack_require__(142).Object.freeze;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(133);
	var meta = __webpack_require__(184).onFreeze;

	__webpack_require__(140)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(169)('meta');
	var isObject = __webpack_require__(133);
	var has = __webpack_require__(134);
	var setDesc = __webpack_require__(146).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(137)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(186), __esModule: true };

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(187);
	module.exports = __webpack_require__(142).Object.keys;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(175);
	var $keys = __webpack_require__(161);

	__webpack_require__(140)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _iterator = __webpack_require__(189);

	var _iterator2 = _interopRequireDefault(_iterator);

	var _symbol = __webpack_require__(192);

	var _symbol2 = _interopRequireDefault(_symbol);

	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(190), __esModule: true };

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(176);
	__webpack_require__(150);
	module.exports = __webpack_require__(191).f('iterator');


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(173);


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(193), __esModule: true };

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(194);
	__webpack_require__(201);
	__webpack_require__(202);
	__webpack_require__(203);
	module.exports = __webpack_require__(142).Symbol;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(139);
	var has = __webpack_require__(134);
	var DESCRIPTORS = __webpack_require__(136);
	var $export = __webpack_require__(141);
	var redefine = __webpack_require__(157);
	var META = __webpack_require__(184).KEY;
	var $fails = __webpack_require__(137);
	var shared = __webpack_require__(168);
	var setToStringTag = __webpack_require__(172);
	var uid = __webpack_require__(169);
	var wks = __webpack_require__(173);
	var wksExt = __webpack_require__(191);
	var wksDefine = __webpack_require__(195);
	var enumKeys = __webpack_require__(196);
	var isArray = __webpack_require__(198);
	var anObject = __webpack_require__(147);
	var toIObject = __webpack_require__(125);
	var toPrimitive = __webpack_require__(132);
	var createDesc = __webpack_require__(131);
	var _create = __webpack_require__(159);
	var gOPNExt = __webpack_require__(199);
	var $GOPD = __webpack_require__(129);
	var $DP = __webpack_require__(146);
	var $keys = __webpack_require__(161);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;

	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};

	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};

	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};

	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });

	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(200).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(130).f = $propertyIsEnumerable;
	  __webpack_require__(197).f = $getOwnPropertySymbols;

	  if (DESCRIPTORS && !__webpack_require__(156)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }

	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}

	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});

	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});

	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    replacer = args[1];
	    if (typeof replacer == 'function') $replacer = replacer;
	    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
	      if ($replacer) value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});

	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(145)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(139);
	var core = __webpack_require__(142);
	var LIBRARY = __webpack_require__(156);
	var wksExt = __webpack_require__(191);
	var defineProperty = __webpack_require__(146).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(161);
	var gOPS = __webpack_require__(197);
	var pIE = __webpack_require__(130);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 197 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(127);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(125);
	var gOPN = __webpack_require__(200).f;
	var toString = {}.toString;

	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];

	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};

	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(162);
	var hiddenKeys = __webpack_require__(170).concat('length', 'prototype');

	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 201 */
/***/ (function(module, exports) {

	

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(195)('asyncIterator');


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(195)('observable');


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(205), __esModule: true };

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(206);
	var $Object = __webpack_require__(142).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(141);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(136), 'Object', { defineProperty: __webpack_require__(146).f });


/***/ }),
/* 207 */
/***/ (function(module, exports) {

	"use strict";

	exports.__esModule = true;

	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _defineProperty = __webpack_require__(204);

	var _defineProperty2 = _interopRequireDefault(_defineProperty);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }

	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(210), __esModule: true };

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(201);
	__webpack_require__(176);
	__webpack_require__(150);
	__webpack_require__(211);
	__webpack_require__(224);
	__webpack_require__(227);
	__webpack_require__(229);
	module.exports = __webpack_require__(142).Map;


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(212);
	var validate = __webpack_require__(219);
	var MAP = 'Map';

	// 23.1 Map Objects
	module.exports = __webpack_require__(220)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(146).f;
	var create = __webpack_require__(159);
	var redefineAll = __webpack_require__(213);
	var ctx = __webpack_require__(143);
	var anInstance = __webpack_require__(214);
	var forOf = __webpack_require__(215);
	var $iterDefine = __webpack_require__(155);
	var step = __webpack_require__(153);
	var setSpecies = __webpack_require__(218);
	var DESCRIPTORS = __webpack_require__(136);
	var fastKey = __webpack_require__(184).fastKey;
	var validate = __webpack_require__(219);
	var SIZE = DESCRIPTORS ? '_s' : 'size';

	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};

	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(145);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};


/***/ }),
/* 214 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(143);
	var call = __webpack_require__(216);
	var isArrayIter = __webpack_require__(217);
	var anObject = __webpack_require__(147);
	var toLength = __webpack_require__(164);
	var getIterFn = __webpack_require__(179);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(147);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(154);
	var ITERATOR = __webpack_require__(173)('iterator');
	var ArrayProto = Array.prototype;

	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(139);
	var core = __webpack_require__(142);
	var dP = __webpack_require__(146);
	var DESCRIPTORS = __webpack_require__(136);
	var SPECIES = __webpack_require__(173)('species');

	module.exports = function (KEY) {
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(133);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(139);
	var $export = __webpack_require__(141);
	var meta = __webpack_require__(184);
	var fails = __webpack_require__(137);
	var hide = __webpack_require__(145);
	var redefineAll = __webpack_require__(213);
	var forOf = __webpack_require__(215);
	var anInstance = __webpack_require__(214);
	var isObject = __webpack_require__(133);
	var setToStringTag = __webpack_require__(172);
	var dP = __webpack_require__(146).f;
	var each = __webpack_require__(221)(0);
	var DESCRIPTORS = __webpack_require__(136);

	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    C = wrapper(function (target, iterable) {
	      anInstance(target, C, NAME, '_c');
	      target._c = new Base();
	      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
	    });
	    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
	      var IS_ADDER = KEY == 'add' || KEY == 'set';
	      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
	        anInstance(this, C, KEY);
	        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
	        var result = this._c[KEY](a === 0 ? 0 : a, b);
	        return IS_ADDER ? this : result;
	      });
	    });
	    IS_WEAK || dP(C.prototype, 'size', {
	      get: function () {
	        return this._c.size;
	      }
	    });
	  }

	  setToStringTag(C, NAME);

	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F, O);

	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

	  return C;
	};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(143);
	var IObject = __webpack_require__(126);
	var toObject = __webpack_require__(175);
	var toLength = __webpack_require__(164);
	var asc = __webpack_require__(222);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(223);

	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(133);
	var isArray = __webpack_require__(198);
	var SPECIES = __webpack_require__(173)('species');

	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(141);

	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(225)('Map') });


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(180);
	var from = __webpack_require__(226);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(215);

	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(228)('Map');


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(141);

	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(230)('Map');


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(141);
	var aFunction = __webpack_require__(144);
	var ctx = __webpack_require__(143);
	var forOf = __webpack_require__(215);

	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _typeof2 = __webpack_require__(188);

	var _typeof3 = _interopRequireDefault(_typeof2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }

	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _setPrototypeOf = __webpack_require__(233);

	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

	var _create = __webpack_require__(237);

	var _create2 = _interopRequireDefault(_create);

	var _typeof2 = __webpack_require__(188);

	var _typeof3 = _interopRequireDefault(_typeof2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }

	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(234), __esModule: true };

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(235);
	module.exports = __webpack_require__(142).Object.setPrototypeOf;


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(141);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(236).set });


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(133);
	var anObject = __webpack_require__(147);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(143)(Function.call, __webpack_require__(129).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(238), __esModule: true };

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(239);
	var $Object = __webpack_require__(142).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(141);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(159) });


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(241), __esModule: true };

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(242);
	var $Object = __webpack_require__(142).Object;
	module.exports = function defineProperties(T, D) {
	  return $Object.defineProperties(T, D);
	};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(141);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(136), 'Object', { defineProperties: __webpack_require__(160) });


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(244);
	var isArguments = __webpack_require__(245);

	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;

	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();

	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;

	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}

	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}

	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}

	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),
/* 244 */
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;

	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),
/* 245 */
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';

	exports = module.exports = supportsArgumentsClass ? supported : unsupported;

	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};

	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(247), __esModule: true };

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(248);
	module.exports = __webpack_require__(142).Object.assign;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(141);

	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(249) });


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(161);
	var gOPS = __webpack_require__(197);
	var pIE = __webpack_require__(130);
	var toObject = __webpack_require__(175);
	var IObject = __webpack_require__(126);
	var $assign = Object.assign;

	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(137)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(251), __esModule: true };

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(252);
	module.exports = __webpack_require__(142).String.fromCodePoint;


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(141);
	var toAbsoluteIndex = __webpack_require__(166);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;

	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(254), __esModule: true };

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(176);
	__webpack_require__(255);
	module.exports = __webpack_require__(142).Array.from;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(143);
	var $export = __webpack_require__(141);
	var toObject = __webpack_require__(175);
	var call = __webpack_require__(216);
	var isArrayIter = __webpack_require__(217);
	var toLength = __webpack_require__(164);
	var createProperty = __webpack_require__(256);
	var getIterFn = __webpack_require__(179);

	$export($export.S + $export.F * !__webpack_require__(257)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(146);
	var createDesc = __webpack_require__(131);

	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(173)('iterator');
	var SAFE_CLOSING = false;

	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }

	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(259), __esModule: true };

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(201);
	__webpack_require__(176);
	__webpack_require__(150);
	__webpack_require__(260);
	__webpack_require__(261);
	__webpack_require__(262);
	__webpack_require__(263);
	module.exports = __webpack_require__(142).Set;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(212);
	var validate = __webpack_require__(219);
	var SET = 'Set';

	// 23.2 Set Objects
	module.exports = __webpack_require__(220)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(141);

	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(225)('Set') });


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(228)('Set');


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(230)('Set');


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Generated by CoffeeScript 1.9.1
	var CATEGORY_BITS, CATEGORY_MASK, CATEGORY_SHIFT, COMBINING_BITS, COMBINING_MASK, COMBINING_SHIFT, EAW_BITS, EAW_MASK, EAW_SHIFT, NUMBER_BITS, NUMBER_MASK, SCRIPT_BITS, SCRIPT_MASK, SCRIPT_SHIFT, UnicodeTrie, bits, data, fs, log2, trie;

	UnicodeTrie = __webpack_require__(17);

	data = __webpack_require__(265);



	trie = new UnicodeTrie(Buffer("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","base64"));

	log2 = Math.log2 || function(n) {
	  return Math.log(n) / Math.LN2;
	};

	bits = function(n) {
	  return (log2(n) + 1) | 0;
	};

	CATEGORY_BITS = bits(data.categories.length - 1);

	COMBINING_BITS = bits(data.combiningClasses.length - 1);

	SCRIPT_BITS = bits(data.scripts.length - 1);

	EAW_BITS = bits(data.eaw.length - 1);

	NUMBER_BITS = 10;

	CATEGORY_SHIFT = COMBINING_BITS + SCRIPT_BITS + EAW_BITS + NUMBER_BITS;

	COMBINING_SHIFT = SCRIPT_BITS + EAW_BITS + NUMBER_BITS;

	SCRIPT_SHIFT = EAW_BITS + NUMBER_BITS;

	EAW_SHIFT = NUMBER_BITS;

	CATEGORY_MASK = (1 << CATEGORY_BITS) - 1;

	COMBINING_MASK = (1 << COMBINING_BITS) - 1;

	SCRIPT_MASK = (1 << SCRIPT_BITS) - 1;

	EAW_MASK = (1 << EAW_BITS) - 1;

	NUMBER_MASK = (1 << NUMBER_BITS) - 1;

	exports.getCategory = function(codePoint) {
	  var val;
	  val = trie.get(codePoint);
	  return data.categories[(val >> CATEGORY_SHIFT) & CATEGORY_MASK];
	};

	exports.getCombiningClass = function(codePoint) {
	  var val;
	  val = trie.get(codePoint);
	  return data.combiningClasses[(val >> COMBINING_SHIFT) & COMBINING_MASK];
	};

	exports.getScript = function(codePoint) {
	  var val;
	  val = trie.get(codePoint);
	  return data.scripts[(val >> SCRIPT_SHIFT) & SCRIPT_MASK];
	};

	exports.getEastAsianWidth = function(codePoint) {
	  var val;
	  val = trie.get(codePoint);
	  return data.eaw[(val >> EAW_SHIFT) & EAW_MASK];
	};

	exports.getNumericValue = function(codePoint) {
	  var denominator, exp, num, numerator, val;
	  val = trie.get(codePoint);
	  num = val & NUMBER_MASK;
	  if (num === 0) {
	    return null;
	  } else if (num <= 50) {
	    return num - 1;
	  } else if (num < 0x1e0) {
	    numerator = (num >> 4) - 12;
	    denominator = (num & 0xf) + 1;
	    return numerator / denominator;
	  } else if (num < 0x300) {
	    val = (num >> 5) - 14;
	    exp = (num & 0x1f) + 2;
	    while (exp > 0) {
	      val *= 10;
	      exp--;
	    }
	    return val;
	  } else {
	    val = (num >> 2) - 0xbf;
	    exp = (num & 3) + 1;
	    while (exp > 0) {
	      val *= 60;
	      exp--;
	    }
	    return val;
	  }
	};

	exports.isAlphabetic = function(codePoint) {
	  var ref;
	  return (ref = exports.getCategory(codePoint)) === 'Lu' || ref === 'Ll' || ref === 'Lt' || ref === 'Lm' || ref === 'Lo' || ref === 'Nl';
	};

	exports.isDigit = function(codePoint) {
	  return exports.getCategory(codePoint) === 'Nd';
	};

	exports.isPunctuation = function(codePoint) {
	  var ref;
	  return (ref = exports.getCategory(codePoint)) === 'Pc' || ref === 'Pd' || ref === 'Pe' || ref === 'Pf' || ref === 'Pi' || ref === 'Po' || ref === 'Ps';
	};

	exports.isLowerCase = function(codePoint) {
	  return exports.getCategory(codePoint) === 'Ll';
	};

	exports.isUpperCase = function(codePoint) {
	  return exports.getCategory(codePoint) === 'Lu';
	};

	exports.isTitleCase = function(codePoint) {
	  return exports.getCategory(codePoint) === 'Lt';
	};

	exports.isWhiteSpace = function(codePoint) {
	  var ref;
	  return (ref = exports.getCategory(codePoint)) === 'Zs' || ref === 'Zl' || ref === 'Zp';
	};

	exports.isBaseForm = function(codePoint) {
	  var ref;
	  return (ref = exports.getCategory(codePoint)) === 'Nd' || ref === 'No' || ref === 'Nl' || ref === 'Lu' || ref === 'Ll' || ref === 'Lt' || ref === 'Lm' || ref === 'Lo' || ref === 'Me' || ref === 'Mc';
	};

	exports.isMark = function(codePoint) {
	  var ref;
	  return (ref = exports.getCategory(codePoint)) === 'Mn' || ref === 'Me' || ref === 'Mc';
	};

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ }),
/* 265 */
/***/ (function(module, exports) {

	module.exports = {"categories":["Cc","Zs","Po","Sc","Ps","Pe","Sm","Pd","Nd","Lu","Sk","Pc","Ll","So","Lo","Pi","Cf","No","Pf","Lt","Lm","Mn","Me","Mc","Nl","Zl","Zp","Cs","Co"],"combiningClasses":["Not_Reordered","Above","Above_Right","Below","Attached_Above_Right","Attached_Below","Overlay","Iota_Subscript","Double_Below","Double_Above","Below_Right","Above_Left","CCC10","CCC11","CCC12","CCC13","CCC14","CCC15","CCC16","CCC17","CCC18","CCC19","CCC20","CCC21","CCC22","CCC23","CCC24","CCC25","CCC30","CCC31","CCC32","CCC27","CCC28","CCC29","CCC33","CCC34","CCC35","CCC36","Nukta","Virama","CCC84","CCC91","CCC103","CCC107","CCC118","CCC122","CCC129","CCC130","CCC132","Attached_Above","Below_Left","Left","Kana_Voicing","CCC26","Right"],"scripts":["Common","Latin","Bopomofo","Inherited","Greek","Coptic","Cyrillic","Armenian","Hebrew","Arabic","Syriac","Thaana","Nko","Samaritan","Mandaic","Devanagari","Bengali","Gurmukhi","Gujarati","Oriya","Tamil","Telugu","Kannada","Malayalam","Sinhala","Thai","Lao","Tibetan","Myanmar","Georgian","Hangul","Ethiopic","Cherokee","Canadian_Aboriginal","Ogham","Runic","Tagalog","Hanunoo","Buhid","Tagbanwa","Khmer","Mongolian","Limbu","Tai_Le","New_Tai_Lue","Buginese","Tai_Tham","Balinese","Sundanese","Batak","Lepcha","Ol_Chiki","Braille","Glagolitic","Tifinagh","Han","Hiragana","Katakana","Yi","Lisu","Vai","Bamum","Syloti_Nagri","Phags_Pa","Saurashtra","Kayah_Li","Rejang","Javanese","Cham","Tai_Viet","Meetei_Mayek","null","Linear_B","Lycian","Carian","Old_Italic","Gothic","Old_Permic","Ugaritic","Old_Persian","Deseret","Shavian","Osmanya","Elbasan","Caucasian_Albanian","Linear_A","Cypriot","Imperial_Aramaic","Palmyrene","Nabataean","Hatran","Phoenician","Lydian","Meroitic_Hieroglyphs","Meroitic_Cursive","Kharoshthi","Old_South_Arabian","Old_North_Arabian","Manichaean","Avestan","Inscriptional_Parthian","Inscriptional_Pahlavi","Psalter_Pahlavi","Old_Turkic","Old_Hungarian","Brahmi","Kaithi","Sora_Sompeng","Chakma","Mahajani","Sharada","Khojki","Multani","Khudawadi","Grantha","Tirhuta","Siddham","Modi","Takri","Ahom","Warang_Citi","Pau_Cin_Hau","Cuneiform","Egyptian_Hieroglyphs","Anatolian_Hieroglyphs","Mro","Bassa_Vah","Pahawh_Hmong","Miao","Duployan","SignWriting","Mende_Kikakui"],"eaw":["N","Na","A","W","H","F"]}

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

	var _slicedToArray = _interopDefault(__webpack_require__(267));
	var _getIterator = _interopDefault(__webpack_require__(148));
	var _defineProperty = _interopDefault(__webpack_require__(271));
	var _regeneratorRuntime = _interopDefault(__webpack_require__(272));
	var _Symbol$iterator = _interopDefault(__webpack_require__(189));
	var _classCallCheck = _interopDefault(__webpack_require__(207));
	var _createClass = _interopDefault(__webpack_require__(208));

	var INITIAL_STATE = 1;
	var FAIL_STATE = 0;

	/**
	 * A StateMachine represents a deterministic finite automaton.
	 * It can perform matches over a sequence of values, similar to a regular expression.
	 */

	var StateMachine = function () {
	  function StateMachine(dfa) {
	    _classCallCheck(this, StateMachine);

	    this.stateTable = dfa.stateTable;
	    this.accepting = dfa.accepting;
	    this.tags = dfa.tags;
	  }

	  /**
	   * Returns an iterable object that yields pattern matches over the input sequence.
	   * Matches are of the form [startIndex, endIndex, tags].
	   */


	  _createClass(StateMachine, [{
	    key: 'match',
	    value: function match(str) {
	      var self = this;
	      return _defineProperty({}, _Symbol$iterator, _regeneratorRuntime.mark(function _callee() {
	        var state, startRun, lastAccepting, lastState, p, c;
	        return _regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                state = INITIAL_STATE;
	                startRun = null;
	                lastAccepting = null;
	                lastState = null;
	                p = 0;

	              case 5:
	                if (!(p < str.length)) {
	                  _context.next = 21;
	                  break;
	                }

	                c = str[p];


	                lastState = state;
	                state = self.stateTable[state][c];

	                if (!(state === FAIL_STATE)) {
	                  _context.next = 15;
	                  break;
	                }

	                if (!(startRun != null && lastAccepting != null && lastAccepting >= startRun)) {
	                  _context.next = 13;
	                  break;
	                }

	                _context.next = 13;
	                return [startRun, lastAccepting, self.tags[lastState]];

	              case 13:

	                // reset the state as if we started over from the initial state
	                state = self.stateTable[INITIAL_STATE][c];
	                startRun = null;

	              case 15:

	                // start a run if not in the failure state
	                if (state !== FAIL_STATE && startRun == null) {
	                  startRun = p;
	                }

	                // if accepting, mark the potential match end
	                if (self.accepting[state]) {
	                  lastAccepting = p;
	                }

	                // reset the state to the initial state if we get into the failure state
	                if (state === FAIL_STATE) {
	                  state = INITIAL_STATE;
	                }

	              case 18:
	                p++;
	                _context.next = 5;
	                break;

	              case 21:
	                if (!(startRun != null && lastAccepting != null && lastAccepting >= startRun)) {
	                  _context.next = 24;
	                  break;
	                }

	                _context.next = 24;
	                return [startRun, lastAccepting, self.tags[state]];

	              case 24:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	    }

	    /**
	     * For each match over the input sequence, action functions matching
	     * the tag definitions in the input pattern are called with the startIndex,
	     * endIndex, and sub-match sequence.
	     */

	  }, {
	    key: 'apply',
	    value: function apply(str, actions) {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;

	      try {
	        for (var _iterator = _getIterator(this.match(str)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var _step$value = _slicedToArray(_step.value, 3);

	          var start = _step$value[0];
	          var end = _step$value[1];
	          var tags = _step$value[2];
	          var _iteratorNormalCompletion2 = true;
	          var _didIteratorError2 = false;
	          var _iteratorError2 = undefined;

	          try {
	            for (var _iterator2 = _getIterator(tags), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	              var tag = _step2.value;

	              if (typeof actions[tag] === 'function') {
	                actions[tag](start, end, str.slice(start, end + 1));
	              }
	            }
	          } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	              }
	            } finally {
	              if (_didIteratorError2) {
	                throw _iteratorError2;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }]);

	  return StateMachine;
	}();

	module.exports = StateMachine;
	

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _isIterable2 = __webpack_require__(268);

	var _isIterable3 = _interopRequireDefault(_isIterable2);

	var _getIterator2 = __webpack_require__(148);

	var _getIterator3 = _interopRequireDefault(_getIterator2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;

	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);

	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }

	    return _arr;
	  }

	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(269), __esModule: true };

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(150);
	__webpack_require__(176);
	module.exports = __webpack_require__(270);


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(180);
	var ITERATOR = __webpack_require__(173)('iterator');
	var Iterators = __webpack_require__(154);
	module.exports = __webpack_require__(142).isIterable = function (it) {
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    // eslint-disable-next-line no-prototype-builtins
	    || Iterators.hasOwnProperty(classof(O));
	};


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _defineProperty = __webpack_require__(204);

	var _defineProperty2 = _interopRequireDefault(_defineProperty);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }

	  return obj;
	};

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(273);


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g = (function() { return this })() || Function("return this")();

	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;

	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;

	module.exports = __webpack_require__(274);

	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}


/***/ }),
/* 274 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */

	!(function(global) {
	  "use strict";

	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }

	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);

	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);

	    return generator;
	  }
	  runtime.wrap = wrap;

	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }

	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";

	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};

	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}

	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };

	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }

	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";

	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }

	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };

	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };

	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };

	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }

	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }

	    var previousPromise;

	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }

	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }

	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }

	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;

	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );

	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };

	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;

	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }

	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }

	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }

	      context.method = method;
	      context.arg = arg;

	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }

	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;

	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }

	          context.dispatchException(context.arg);

	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }

	        state = GenStateExecuting;

	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;

	          if (record.arg === ContinueSentinel) {
	            continue;
	          }

	          return {
	            value: record.arg,
	            done: context.done
	          };

	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }

	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;

	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);

	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }

	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }

	      return ContinueSentinel;
	    }

	    var record = tryCatch(method, delegate.iterator, context.arg);

	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }

	    var info = record.arg;

	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }

	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;

	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;

	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }

	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }

	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }

	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);

	  Gp[toStringTagSymbol] = "Generator";

	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };

	  Gp.toString = function() {
	    return "[object Generator]";
	  };

	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };

	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }

	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }

	    this.tryEntries.push(entry);
	  }

	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }

	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }

	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();

	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }

	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };

	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }

	      if (typeof iterable.next === "function") {
	        return iterable;
	      }

	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }

	          next.value = undefined;
	          next.done = true;

	          return next;
	        };

	        return next.next = next;
	      }
	    }

	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;

	  function doneResult() {
	    return { value: undefined, done: true };
	  }

	  Context.prototype = {
	    constructor: Context,

	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;

	      this.method = "next";
	      this.arg = undefined;

	      this.tryEntries.forEach(resetTryEntry);

	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },

	    stop: function() {
	      this.done = true;

	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }

	      return this.rval;
	    },

	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }

	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;

	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }

	        return !! caught;
	      }

	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;

	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }

	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");

	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }

	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }

	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }

	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },

	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }

	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }

	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;

	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }

	      return this.complete(record);
	    },

	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }

	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }

	      return ContinueSentinel;
	    },

	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },

	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }

	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },

	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };

	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }

	      return ContinueSentinel;
	    }
	  };
	})(
	  // In sloppy mode, unbound `this` refers to the global object, fallback to
	  // Function constructor if we're in global strict mode. That is sadly a form
	  // of indirect eval which violates Content Security Policy.
	  (function() { return this })() || Function("return this")()
	);


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(276), __esModule: true };

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(277);
	module.exports = Math.pow(2, -52);


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(141);

	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var clone = (function() {
	'use strict';

	/**
	 * Clones (copies) an Object using deep copying.
	 *
	 * This function supports circular references by default, but if you are certain
	 * there are no circular references in your object, you can save some CPU time
	 * by calling clone(obj, false).
	 *
	 * Caution: if `circular` is false and `parent` contains circular references,
	 * your program may enter an infinite loop and crash.
	 *
	 * @param `parent` - the object to be cloned
	 * @param `circular` - set to true if the object to be cloned may contain
	 *    circular references. (optional - true by default)
	 * @param `depth` - set to a number if the object is only to be cloned to
	 *    a particular depth. (optional - defaults to Infinity)
	 * @param `prototype` - sets the prototype to be used when cloning an object.
	 *    (optional - defaults to parent prototype).
	*/
	function clone(parent, circular, depth, prototype) {
	  var filter;
	  if (typeof circular === 'object') {
	    depth = circular.depth;
	    prototype = circular.prototype;
	    filter = circular.filter;
	    circular = circular.circular
	  }
	  // maintain two arrays for circular references, where corresponding parents
	  // and children have the same index
	  var allParents = [];
	  var allChildren = [];

	  var useBuffer = typeof Buffer != 'undefined';

	  if (typeof circular == 'undefined')
	    circular = true;

	  if (typeof depth == 'undefined')
	    depth = Infinity;

	  // recurse this function so we don't reset allParents and allChildren
	  function _clone(parent, depth) {
	    // cloning null always returns null
	    if (parent === null)
	      return null;

	    if (depth == 0)
	      return parent;

	    var child;
	    var proto;
	    if (typeof parent != 'object') {
	      return parent;
	    }

	    if (clone.__isArray(parent)) {
	      child = [];
	    } else if (clone.__isRegExp(parent)) {
	      child = new RegExp(parent.source, __getRegExpFlags(parent));
	      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
	    } else if (clone.__isDate(parent)) {
	      child = new Date(parent.getTime());
	    } else if (useBuffer && Buffer.isBuffer(parent)) {
	      child = new Buffer(parent.length);
	      parent.copy(child);
	      return child;
	    } else {
	      if (typeof prototype == 'undefined') {
	        proto = Object.getPrototypeOf(parent);
	        child = Object.create(proto);
	      }
	      else {
	        child = Object.create(prototype);
	        proto = prototype;
	      }
	    }

	    if (circular) {
	      var index = allParents.indexOf(parent);

	      if (index != -1) {
	        return allChildren[index];
	      }
	      allParents.push(parent);
	      allChildren.push(child);
	    }

	    for (var i in parent) {
	      var attrs;
	      if (proto) {
	        attrs = Object.getOwnPropertyDescriptor(proto, i);
	      }

	      if (attrs && attrs.set == null) {
	        continue;
	      }
	      child[i] = _clone(parent[i], depth - 1);
	    }

	    return child;
	  }

	  return _clone(parent, depth);
	}

	/**
	 * Simple flat clone using prototype, accepts only objects, usefull for property
	 * override on FLAT configuration object (no nested props).
	 *
	 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
	 * works.
	 */
	clone.clonePrototype = function clonePrototype(parent) {
	  if (parent === null)
	    return null;

	  var c = function () {};
	  c.prototype = parent;
	  return new c();
	};

	// private utility functions

	function __objToStr(o) {
	  return Object.prototype.toString.call(o);
	};
	clone.__objToStr = __objToStr;

	function __isDate(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Date]';
	};
	clone.__isDate = __isDate;

	function __isArray(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Array]';
	};
	clone.__isArray = __isArray;

	function __isRegExp(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
	};
	clone.__isRegExp = __isRegExp;

	function __getRegExpFlags(re) {
	  var flags = '';
	  if (re.global) flags += 'g';
	  if (re.ignoreCase) flags += 'i';
	  if (re.multiline) flags += 'm';
	  return flags;
	};
	clone.__getRegExpFlags = __getRegExpFlags;

	return clone;
	})();

	if (typeof module === 'object' && module.exports) {
	  module.exports = clone;
	}

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(280).BrotliDecompressBuffer;


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	/* Copyright 2013 Google Inc. All Rights Reserved.

	   Licensed under the Apache License, Version 2.0 (the "License");
	   you may not use this file except in compliance with the License.
	   You may obtain a copy of the License at

	   http://www.apache.org/licenses/LICENSE-2.0

	   Unless required by applicable law or agreed to in writing, software
	   distributed under the License is distributed on an "AS IS" BASIS,
	   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   See the License for the specific language governing permissions and
	   limitations under the License.
	*/

	var BrotliInput = __webpack_require__(281).BrotliInput;
	var BrotliOutput = __webpack_require__(281).BrotliOutput;
	var BrotliBitReader = __webpack_require__(282);
	var BrotliDictionary = __webpack_require__(283);
	var HuffmanCode = __webpack_require__(287).HuffmanCode;
	var BrotliBuildHuffmanTable = __webpack_require__(287).BrotliBuildHuffmanTable;
	var Context = __webpack_require__(288);
	var Prefix = __webpack_require__(289);
	var Transform = __webpack_require__(290);

	var kDefaultCodeLength = 8;
	var kCodeLengthRepeatCode = 16;
	var kNumLiteralCodes = 256;
	var kNumInsertAndCopyCodes = 704;
	var kNumBlockLengthCodes = 26;
	var kLiteralContextBits = 6;
	var kDistanceContextBits = 2;

	var HUFFMAN_TABLE_BITS = 8;
	var HUFFMAN_TABLE_MASK = 0xff;
	/* Maximum possible Huffman table size for an alphabet size of 704, max code
	 * length 15 and root table bits 8. */
	var HUFFMAN_MAX_TABLE_SIZE = 1080;

	var CODE_LENGTH_CODES = 18;
	var kCodeLengthCodeOrder = new Uint8Array([
	  1, 2, 3, 4, 0, 5, 17, 6, 16, 7, 8, 9, 10, 11, 12, 13, 14, 15,
	]);

	var NUM_DISTANCE_SHORT_CODES = 16;
	var kDistanceShortCodeIndexOffset = new Uint8Array([
	  3, 2, 1, 0, 3, 3, 3, 3, 3, 3, 2, 2, 2, 2, 2, 2
	]);

	var kDistanceShortCodeValueOffset = new Int8Array([
	  0, 0, 0, 0, -1, 1, -2, 2, -3, 3, -1, 1, -2, 2, -3, 3
	]);

	var kMaxHuffmanTableSize = new Uint16Array([
	  256, 402, 436, 468, 500, 534, 566, 598, 630, 662, 694, 726, 758, 790, 822,
	  854, 886, 920, 952, 984, 1016, 1048, 1080
	]);

	function DecodeWindowBits(br) {
	  var n;
	  if (br.readBits(1) === 0) {
	    return 16;
	  }
	  
	  n = br.readBits(3);
	  if (n > 0) {
	    return 17 + n;
	  }
	  
	  n = br.readBits(3);
	  if (n > 0) {
	    return 8 + n;
	  }
	  
	  return 17;
	}

	/* Decodes a number in the range [0..255], by reading 1 - 11 bits. */
	function DecodeVarLenUint8(br) {
	  if (br.readBits(1)) {
	    var nbits = br.readBits(3);
	    if (nbits === 0) {
	      return 1;
	    } else {
	      return br.readBits(nbits) + (1 << nbits);
	    }
	  }
	  return 0;
	}

	function MetaBlockLength() {
	  this.meta_block_length = 0;
	  this.input_end = 0;
	  this.is_uncompressed = 0;
	  this.is_metadata = false;
	}

	function DecodeMetaBlockLength(br) {
	  var out = new MetaBlockLength;  
	  var size_nibbles;
	  var size_bytes;
	  var i;
	  
	  out.input_end = br.readBits(1);
	  if (out.input_end && br.readBits(1)) {
	    return out;
	  }
	  
	  size_nibbles = br.readBits(2) + 4;
	  if (size_nibbles === 7) {
	    out.is_metadata = true;
	    
	    if (br.readBits(1) !== 0)
	      throw new Error('Invalid reserved bit');
	    
	    size_bytes = br.readBits(2);
	    if (size_bytes === 0)
	      return out;
	    
	    for (i = 0; i < size_bytes; i++) {
	      var next_byte = br.readBits(8);
	      if (i + 1 === size_bytes && size_bytes > 1 && next_byte === 0)
	        throw new Error('Invalid size byte');
	      
	      out.meta_block_length |= next_byte << (i * 8);
	    }
	  } else {
	    for (i = 0; i < size_nibbles; ++i) {
	      var next_nibble = br.readBits(4);
	      if (i + 1 === size_nibbles && size_nibbles > 4 && next_nibble === 0)
	        throw new Error('Invalid size nibble');
	      
	      out.meta_block_length |= next_nibble << (i * 4);
	    }
	  }
	  
	  ++out.meta_block_length;
	  
	  if (!out.input_end && !out.is_metadata) {
	    out.is_uncompressed = br.readBits(1);
	  }
	  
	  return out;
	}

	/* Decodes the next Huffman code from bit-stream. */
	function ReadSymbol(table, index, br) {
	  var start_index = index;
	  
	  var nbits;
	  br.fillBitWindow();
	  index += (br.val_ >>> br.bit_pos_) & HUFFMAN_TABLE_MASK;
	  nbits = table[index].bits - HUFFMAN_TABLE_BITS;
	  if (nbits > 0) {
	    br.bit_pos_ += HUFFMAN_TABLE_BITS;
	    index += table[index].value;
	    index += (br.val_ >>> br.bit_pos_) & ((1 << nbits) - 1);
	  }
	  br.bit_pos_ += table[index].bits;
	  return table[index].value;
	}

	function ReadHuffmanCodeLengths(code_length_code_lengths, num_symbols, code_lengths, br) {
	  var symbol = 0;
	  var prev_code_len = kDefaultCodeLength;
	  var repeat = 0;
	  var repeat_code_len = 0;
	  var space = 32768;
	  
	  var table = [];
	  for (var i = 0; i < 32; i++)
	    table.push(new HuffmanCode(0, 0));
	  
	  BrotliBuildHuffmanTable(table, 0, 5, code_length_code_lengths, CODE_LENGTH_CODES);

	  while (symbol < num_symbols && space > 0) {
	    var p = 0;
	    var code_len;
	    
	    br.readMoreInput();
	    br.fillBitWindow();
	    p += (br.val_ >>> br.bit_pos_) & 31;
	    br.bit_pos_ += table[p].bits;
	    code_len = table[p].value & 0xff;
	    if (code_len < kCodeLengthRepeatCode) {
	      repeat = 0;
	      code_lengths[symbol++] = code_len;
	      if (code_len !== 0) {
	        prev_code_len = code_len;
	        space -= 32768 >> code_len;
	      }
	    } else {
	      var extra_bits = code_len - 14;
	      var old_repeat;
	      var repeat_delta;
	      var new_len = 0;
	      if (code_len === kCodeLengthRepeatCode) {
	        new_len = prev_code_len;
	      }
	      if (repeat_code_len !== new_len) {
	        repeat = 0;
	        repeat_code_len = new_len;
	      }
	      old_repeat = repeat;
	      if (repeat > 0) {
	        repeat -= 2;
	        repeat <<= extra_bits;
	      }
	      repeat += br.readBits(extra_bits) + 3;
	      repeat_delta = repeat - old_repeat;
	      if (symbol + repeat_delta > num_symbols) {
	        throw new Error('[ReadHuffmanCodeLengths] symbol + repeat_delta > num_symbols');
	      }
	      
	      for (var x = 0; x < repeat_delta; x++)
	        code_lengths[symbol + x] = repeat_code_len;
	      
	      symbol += repeat_delta;
	      
	      if (repeat_code_len !== 0) {
	        space -= repeat_delta << (15 - repeat_code_len);
	      }
	    }
	  }
	  if (space !== 0) {
	    throw new Error("[ReadHuffmanCodeLengths] space = " + space);
	  }
	  
	  for (; symbol < num_symbols; symbol++)
	    code_lengths[symbol] = 0;
	}

	function ReadHuffmanCode(alphabet_size, tables, table, br) {
	  var table_size = 0;
	  var simple_code_or_skip;
	  var code_lengths = new Uint8Array(alphabet_size);
	  
	  br.readMoreInput();
	  
	  /* simple_code_or_skip is used as follows:
	     1 for simple code;
	     0 for no skipping, 2 skips 2 code lengths, 3 skips 3 code lengths */
	  simple_code_or_skip = br.readBits(2);
	  if (simple_code_or_skip === 1) {
	    /* Read symbols, codes & code lengths directly. */
	    var i;
	    var max_bits_counter = alphabet_size - 1;
	    var max_bits = 0;
	    var symbols = new Int32Array(4);
	    var num_symbols = br.readBits(2) + 1;
	    while (max_bits_counter) {
	      max_bits_counter >>= 1;
	      ++max_bits;
	    }

	    for (i = 0; i < num_symbols; ++i) {
	      symbols[i] = br.readBits(max_bits) % alphabet_size;
	      code_lengths[symbols[i]] = 2;
	    }
	    code_lengths[symbols[0]] = 1;
	    switch (num_symbols) {
	      case 1:
	        break;
	      case 3:
	        if ((symbols[0] === symbols[1]) ||
	            (symbols[0] === symbols[2]) ||
	            (symbols[1] === symbols[2])) {
	          throw new Error('[ReadHuffmanCode] invalid symbols');
	        }
	        break;
	      case 2:
	        if (symbols[0] === symbols[1]) {
	          throw new Error('[ReadHuffmanCode] invalid symbols');
	        }
	        
	        code_lengths[symbols[1]] = 1;
	        break;
	      case 4:
	        if ((symbols[0] === symbols[1]) ||
	            (symbols[0] === symbols[2]) ||
	            (symbols[0] === symbols[3]) ||
	            (symbols[1] === symbols[2]) ||
	            (symbols[1] === symbols[3]) ||
	            (symbols[2] === symbols[3])) {
	          throw new Error('[ReadHuffmanCode] invalid symbols');
	        }
	        
	        if (br.readBits(1)) {
	          code_lengths[symbols[2]] = 3;
	          code_lengths[symbols[3]] = 3;
	        } else {
	          code_lengths[symbols[0]] = 2;
	        }
	        break;
	    }
	  } else {  /* Decode Huffman-coded code lengths. */
	    var i;
	    var code_length_code_lengths = new Uint8Array(CODE_LENGTH_CODES);
	    var space = 32;
	    var num_codes = 0;
	    /* Static Huffman code for the code length code lengths */
	    var huff = [
	      new HuffmanCode(2, 0), new HuffmanCode(2, 4), new HuffmanCode(2, 3), new HuffmanCode(3, 2), 
	      new HuffmanCode(2, 0), new HuffmanCode(2, 4), new HuffmanCode(2, 3), new HuffmanCode(4, 1),
	      new HuffmanCode(2, 0), new HuffmanCode(2, 4), new HuffmanCode(2, 3), new HuffmanCode(3, 2), 
	      new HuffmanCode(2, 0), new HuffmanCode(2, 4), new HuffmanCode(2, 3), new HuffmanCode(4, 5)
	    ];
	    for (i = simple_code_or_skip; i < CODE_LENGTH_CODES && space > 0; ++i) {
	      var code_len_idx = kCodeLengthCodeOrder[i];
	      var p = 0;
	      var v;
	      br.fillBitWindow();
	      p += (br.val_ >>> br.bit_pos_) & 15;
	      br.bit_pos_ += huff[p].bits;
	      v = huff[p].value;
	      code_length_code_lengths[code_len_idx] = v;
	      if (v !== 0) {
	        space -= (32 >> v);
	        ++num_codes;
	      }
	    }
	    
	    if (!(num_codes === 1 || space === 0))
	      throw new Error('[ReadHuffmanCode] invalid num_codes or space');
	    
	    ReadHuffmanCodeLengths(code_length_code_lengths, alphabet_size, code_lengths, br);
	  }
	  
	  table_size = BrotliBuildHuffmanTable(tables, table, HUFFMAN_TABLE_BITS, code_lengths, alphabet_size);
	  
	  if (table_size === 0) {
	    throw new Error("[ReadHuffmanCode] BuildHuffmanTable failed: ");
	  }
	  
	  return table_size;
	}

	function ReadBlockLength(table, index, br) {
	  var code;
	  var nbits;
	  code = ReadSymbol(table, index, br);
	  nbits = Prefix.kBlockLengthPrefixCode[code].nbits;
	  return Prefix.kBlockLengthPrefixCode[code].offset + br.readBits(nbits);
	}

	function TranslateShortCodes(code, ringbuffer, index) {
	  var val;
	  if (code < NUM_DISTANCE_SHORT_CODES) {
	    index += kDistanceShortCodeIndexOffset[code];
	    index &= 3;
	    val = ringbuffer[index] + kDistanceShortCodeValueOffset[code];
	  } else {
	    val = code - NUM_DISTANCE_SHORT_CODES + 1;
	  }
	  return val;
	}

	function MoveToFront(v, index) {
	  var value = v[index];
	  var i = index;
	  for (; i; --i) v[i] = v[i - 1];
	  v[0] = value;
	}

	function InverseMoveToFrontTransform(v, v_len) {
	  var mtf = new Uint8Array(256);
	  var i;
	  for (i = 0; i < 256; ++i) {
	    mtf[i] = i;
	  }
	  for (i = 0; i < v_len; ++i) {
	    var index = v[i];
	    v[i] = mtf[index];
	    if (index) MoveToFront(mtf, index);
	  }
	}

	/* Contains a collection of huffman trees with the same alphabet size. */
	function HuffmanTreeGroup(alphabet_size, num_htrees) {
	  this.alphabet_size = alphabet_size;
	  this.num_htrees = num_htrees;
	  this.codes = new Array(num_htrees + num_htrees * kMaxHuffmanTableSize[(alphabet_size + 31) >>> 5]);  
	  this.htrees = new Uint32Array(num_htrees);
	}

	HuffmanTreeGroup.prototype.decode = function(br) {
	  var i;
	  var table_size;
	  var next = 0;
	  for (i = 0; i < this.num_htrees; ++i) {
	    this.htrees[i] = next;
	    table_size = ReadHuffmanCode(this.alphabet_size, this.codes, next, br);
	    next += table_size;
	  }
	};

	function DecodeContextMap(context_map_size, br) {
	  var out = { num_htrees: null, context_map: null };
	  var use_rle_for_zeros;
	  var max_run_length_prefix = 0;
	  var table;
	  var i;
	  
	  br.readMoreInput();
	  var num_htrees = out.num_htrees = DecodeVarLenUint8(br) + 1;

	  var context_map = out.context_map = new Uint8Array(context_map_size);
	  if (num_htrees <= 1) {
	    return out;
	  }

	  use_rle_for_zeros = br.readBits(1);
	  if (use_rle_for_zeros) {
	    max_run_length_prefix = br.readBits(4) + 1;
	  }
	  
	  table = [];
	  for (i = 0; i < HUFFMAN_MAX_TABLE_SIZE; i++) {
	    table[i] = new HuffmanCode(0, 0);
	  }
	  
	  ReadHuffmanCode(num_htrees + max_run_length_prefix, table, 0, br);
	  
	  for (i = 0; i < context_map_size;) {
	    var code;

	    br.readMoreInput();
	    code = ReadSymbol(table, 0, br);
	    if (code === 0) {
	      context_map[i] = 0;
	      ++i;
	    } else if (code <= max_run_length_prefix) {
	      var reps = 1 + (1 << code) + br.readBits(code);
	      while (--reps) {
	        if (i >= context_map_size) {
	          throw new Error("[DecodeContextMap] i >= context_map_size");
	        }
	        context_map[i] = 0;
	        ++i;
	      }
	    } else {
	      context_map[i] = code - max_run_length_prefix;
	      ++i;
	    }
	  }
	  if (br.readBits(1)) {
	    InverseMoveToFrontTransform(context_map, context_map_size);
	  }
	  
	  return out;
	}

	function DecodeBlockType(max_block_type, trees, tree_type, block_types, ringbuffers, indexes, br) {
	  var ringbuffer = tree_type * 2;
	  var index = tree_type;
	  var type_code = ReadSymbol(trees, tree_type * HUFFMAN_MAX_TABLE_SIZE, br);
	  var block_type;
	  if (type_code === 0) {
	    block_type = ringbuffers[ringbuffer + (indexes[index] & 1)];
	  } else if (type_code === 1) {
	    block_type = ringbuffers[ringbuffer + ((indexes[index] - 1) & 1)] + 1;
	  } else {
	    block_type = type_code - 2;
	  }
	  if (block_type >= max_block_type) {
	    block_type -= max_block_type;
	  }
	  block_types[tree_type] = block_type;
	  ringbuffers[ringbuffer + (indexes[index] & 1)] = block_type;
	  ++indexes[index];
	}

	function CopyUncompressedBlockToOutput(output, len, pos, ringbuffer, ringbuffer_mask, br) {
	  var rb_size = ringbuffer_mask + 1;
	  var rb_pos = pos & ringbuffer_mask;
	  var br_pos = br.pos_ & BrotliBitReader.IBUF_MASK;
	  var nbytes;

	  /* For short lengths copy byte-by-byte */
	  if (len < 8 || br.bit_pos_ + (len << 3) < br.bit_end_pos_) {
	    while (len-- > 0) {
	      br.readMoreInput();
	      ringbuffer[rb_pos++] = br.readBits(8);
	      if (rb_pos === rb_size) {
	        output.write(ringbuffer, rb_size);
	        rb_pos = 0;
	      }
	    }
	    return;
	  }

	  if (br.bit_end_pos_ < 32) {
	    throw new Error('[CopyUncompressedBlockToOutput] br.bit_end_pos_ < 32');
	  }

	  /* Copy remaining 0-4 bytes from br.val_ to ringbuffer. */
	  while (br.bit_pos_ < 32) {
	    ringbuffer[rb_pos] = (br.val_ >>> br.bit_pos_);
	    br.bit_pos_ += 8;
	    ++rb_pos;
	    --len;
	  }

	  /* Copy remaining bytes from br.buf_ to ringbuffer. */
	  nbytes = (br.bit_end_pos_ - br.bit_pos_) >> 3;
	  if (br_pos + nbytes > BrotliBitReader.IBUF_MASK) {
	    var tail = BrotliBitReader.IBUF_MASK + 1 - br_pos;
	    for (var x = 0; x < tail; x++)
	      ringbuffer[rb_pos + x] = br.buf_[br_pos + x];
	    
	    nbytes -= tail;
	    rb_pos += tail;
	    len -= tail;
	    br_pos = 0;
	  }

	  for (var x = 0; x < nbytes; x++)
	    ringbuffer[rb_pos + x] = br.buf_[br_pos + x];
	  
	  rb_pos += nbytes;
	  len -= nbytes;

	  /* If we wrote past the logical end of the ringbuffer, copy the tail of the
	     ringbuffer to its beginning and flush the ringbuffer to the output. */
	  if (rb_pos >= rb_size) {
	    output.write(ringbuffer, rb_size);
	    rb_pos -= rb_size;    
	    for (var x = 0; x < rb_pos; x++)
	      ringbuffer[x] = ringbuffer[rb_size + x];
	  }

	  /* If we have more to copy than the remaining size of the ringbuffer, then we
	     first fill the ringbuffer from the input and then flush the ringbuffer to
	     the output */
	  while (rb_pos + len >= rb_size) {
	    nbytes = rb_size - rb_pos;
	    if (br.input_.read(ringbuffer, rb_pos, nbytes) < nbytes) {
	      throw new Error('[CopyUncompressedBlockToOutput] not enough bytes');
	    }
	    output.write(ringbuffer, rb_size);
	    len -= nbytes;
	    rb_pos = 0;
	  }

	  /* Copy straight from the input onto the ringbuffer. The ringbuffer will be
	     flushed to the output at a later time. */
	  if (br.input_.read(ringbuffer, rb_pos, len) < len) {
	    throw new Error('[CopyUncompressedBlockToOutput] not enough bytes');
	  }

	  /* Restore the state of the bit reader. */
	  br.reset();
	}

	/* Advances the bit reader position to the next byte boundary and verifies
	   that any skipped bits are set to zero. */
	function JumpToByteBoundary(br) {
	  var new_bit_pos = (br.bit_pos_ + 7) & ~7;
	  var pad_bits = br.readBits(new_bit_pos - br.bit_pos_);
	  return pad_bits == 0;
	}

	function BrotliDecompressedSize(buffer) {
	  var input = new BrotliInput(buffer);
	  var br = new BrotliBitReader(input);
	  DecodeWindowBits(br);
	  var out = DecodeMetaBlockLength(br);
	  return out.meta_block_length;
	}

	exports.BrotliDecompressedSize = BrotliDecompressedSize;

	function BrotliDecompressBuffer(buffer, output_size) {
	  var input = new BrotliInput(buffer);
	  
	  if (output_size == null) {
	    output_size = BrotliDecompressedSize(buffer);
	  }
	  
	  var output_buffer = new Uint8Array(output_size);
	  var output = new BrotliOutput(output_buffer);
	  
	  BrotliDecompress(input, output);
	  
	  if (output.pos < output.buffer.length) {
	    output.buffer = output.buffer.subarray(0, output.pos);
	  }
	  
	  return output.buffer;
	}

	exports.BrotliDecompressBuffer = BrotliDecompressBuffer;

	function BrotliDecompress(input, output) {
	  var i;
	  var pos = 0;
	  var input_end = 0;
	  var window_bits = 0;
	  var max_backward_distance;
	  var max_distance = 0;
	  var ringbuffer_size;
	  var ringbuffer_mask;
	  var ringbuffer;
	  var ringbuffer_end;
	  /* This ring buffer holds a few past copy distances that will be used by */
	  /* some special distance codes. */
	  var dist_rb = [ 16, 15, 11, 4 ];
	  var dist_rb_idx = 0;
	  /* The previous 2 bytes used for context. */
	  var prev_byte1 = 0;
	  var prev_byte2 = 0;
	  var hgroup = [new HuffmanTreeGroup(0, 0), new HuffmanTreeGroup(0, 0), new HuffmanTreeGroup(0, 0)];
	  var block_type_trees;
	  var block_len_trees;
	  var br;

	  /* We need the slack region for the following reasons:
	       - always doing two 8-byte copies for fast backward copying
	       - transforms
	       - flushing the input ringbuffer when decoding uncompressed blocks */
	  var kRingBufferWriteAheadSlack = 128 + BrotliBitReader.READ_SIZE;

	  br = new BrotliBitReader(input);

	  /* Decode window size. */
	  window_bits = DecodeWindowBits(br);
	  max_backward_distance = (1 << window_bits) - 16;

	  ringbuffer_size = 1 << window_bits;
	  ringbuffer_mask = ringbuffer_size - 1;
	  ringbuffer = new Uint8Array(ringbuffer_size + kRingBufferWriteAheadSlack + BrotliDictionary.maxDictionaryWordLength);
	  ringbuffer_end = ringbuffer_size;

	  block_type_trees = [];
	  block_len_trees = [];
	  for (var x = 0; x < 3 * HUFFMAN_MAX_TABLE_SIZE; x++) {
	    block_type_trees[x] = new HuffmanCode(0, 0);
	    block_len_trees[x] = new HuffmanCode(0, 0);
	  }

	  while (!input_end) {
	    var meta_block_remaining_len = 0;
	    var is_uncompressed;
	    var block_length = [ 1 << 28, 1 << 28, 1 << 28 ];
	    var block_type = [ 0 ];
	    var num_block_types = [ 1, 1, 1 ];
	    var block_type_rb = [ 0, 1, 0, 1, 0, 1 ];
	    var block_type_rb_index = [ 0 ];
	    var distance_postfix_bits;
	    var num_direct_distance_codes;
	    var distance_postfix_mask;
	    var num_distance_codes;
	    var context_map = null;
	    var context_modes = null;
	    var num_literal_htrees;
	    var dist_context_map = null;
	    var num_dist_htrees;
	    var context_offset = 0;
	    var context_map_slice = null;
	    var literal_htree_index = 0;
	    var dist_context_offset = 0;
	    var dist_context_map_slice = null;
	    var dist_htree_index = 0;
	    var context_lookup_offset1 = 0;
	    var context_lookup_offset2 = 0;
	    var context_mode;
	    var htree_command;

	    for (i = 0; i < 3; ++i) {
	      hgroup[i].codes = null;
	      hgroup[i].htrees = null;
	    }

	    br.readMoreInput();
	    
	    var _out = DecodeMetaBlockLength(br);
	    meta_block_remaining_len = _out.meta_block_length;
	    if (pos + meta_block_remaining_len > output.buffer.length) {
	      /* We need to grow the output buffer to fit the additional data. */
	      var tmp = new Uint8Array( pos + meta_block_remaining_len );
	      tmp.set( output.buffer );
	      output.buffer = tmp;
	    }    
	    input_end = _out.input_end;
	    is_uncompressed = _out.is_uncompressed;
	    
	    if (_out.is_metadata) {
	      JumpToByteBoundary(br);
	      
	      for (; meta_block_remaining_len > 0; --meta_block_remaining_len) {
	        br.readMoreInput();
	        /* Read one byte and ignore it. */
	        br.readBits(8);
	      }
	      
	      continue;
	    }
	    
	    if (meta_block_remaining_len === 0) {
	      continue;
	    }
	    
	    if (is_uncompressed) {
	      br.bit_pos_ = (br.bit_pos_ + 7) & ~7;
	      CopyUncompressedBlockToOutput(output, meta_block_remaining_len, pos,
	                                    ringbuffer, ringbuffer_mask, br);
	      pos += meta_block_remaining_len;
	      continue;
	    }
	    
	    for (i = 0; i < 3; ++i) {
	      num_block_types[i] = DecodeVarLenUint8(br) + 1;
	      if (num_block_types[i] >= 2) {
	        ReadHuffmanCode(num_block_types[i] + 2, block_type_trees, i * HUFFMAN_MAX_TABLE_SIZE, br);
	        ReadHuffmanCode(kNumBlockLengthCodes, block_len_trees, i * HUFFMAN_MAX_TABLE_SIZE, br);
	        block_length[i] = ReadBlockLength(block_len_trees, i * HUFFMAN_MAX_TABLE_SIZE, br);
	        block_type_rb_index[i] = 1;
	      }
	    }
	    
	    br.readMoreInput();
	    
	    distance_postfix_bits = br.readBits(2);
	    num_direct_distance_codes = NUM_DISTANCE_SHORT_CODES + (br.readBits(4) << distance_postfix_bits);
	    distance_postfix_mask = (1 << distance_postfix_bits) - 1;
	    num_distance_codes = (num_direct_distance_codes + (48 << distance_postfix_bits));
	    context_modes = new Uint8Array(num_block_types[0]);

	    for (i = 0; i < num_block_types[0]; ++i) {
	       br.readMoreInput();
	       context_modes[i] = (br.readBits(2) << 1);
	    }
	    
	    var _o1 = DecodeContextMap(num_block_types[0] << kLiteralContextBits, br);
	    num_literal_htrees = _o1.num_htrees;
	    context_map = _o1.context_map;
	    
	    var _o2 = DecodeContextMap(num_block_types[2] << kDistanceContextBits, br);
	    num_dist_htrees = _o2.num_htrees;
	    dist_context_map = _o2.context_map;
	    
	    hgroup[0] = new HuffmanTreeGroup(kNumLiteralCodes, num_literal_htrees);
	    hgroup[1] = new HuffmanTreeGroup(kNumInsertAndCopyCodes, num_block_types[1]);
	    hgroup[2] = new HuffmanTreeGroup(num_distance_codes, num_dist_htrees);

	    for (i = 0; i < 3; ++i) {
	      hgroup[i].decode(br);
	    }

	    context_map_slice = 0;
	    dist_context_map_slice = 0;
	    context_mode = context_modes[block_type[0]];
	    context_lookup_offset1 = Context.lookupOffsets[context_mode];
	    context_lookup_offset2 = Context.lookupOffsets[context_mode + 1];
	    htree_command = hgroup[1].htrees[0];

	    while (meta_block_remaining_len > 0) {
	      var cmd_code;
	      var range_idx;
	      var insert_code;
	      var copy_code;
	      var insert_length;
	      var copy_length;
	      var distance_code;
	      var distance;
	      var context;
	      var j;
	      var copy_dst;

	      br.readMoreInput();
	      
	      if (block_length[1] === 0) {
	        DecodeBlockType(num_block_types[1],
	                        block_type_trees, 1, block_type, block_type_rb,
	                        block_type_rb_index, br);
	        block_length[1] = ReadBlockLength(block_len_trees, HUFFMAN_MAX_TABLE_SIZE, br);
	        htree_command = hgroup[1].htrees[block_type[1]];
	      }
	      --block_length[1];
	      cmd_code = ReadSymbol(hgroup[1].codes, htree_command, br);
	      range_idx = cmd_code >> 6;
	      if (range_idx >= 2) {
	        range_idx -= 2;
	        distance_code = -1;
	      } else {
	        distance_code = 0;
	      }
	      insert_code = Prefix.kInsertRangeLut[range_idx] + ((cmd_code >> 3) & 7);
	      copy_code = Prefix.kCopyRangeLut[range_idx] + (cmd_code & 7);
	      insert_length = Prefix.kInsertLengthPrefixCode[insert_code].offset +
	          br.readBits(Prefix.kInsertLengthPrefixCode[insert_code].nbits);
	      copy_length = Prefix.kCopyLengthPrefixCode[copy_code].offset +
	          br.readBits(Prefix.kCopyLengthPrefixCode[copy_code].nbits);
	      prev_byte1 = ringbuffer[pos-1 & ringbuffer_mask];
	      prev_byte2 = ringbuffer[pos-2 & ringbuffer_mask];
	      for (j = 0; j < insert_length; ++j) {
	        br.readMoreInput();

	        if (block_length[0] === 0) {
	          DecodeBlockType(num_block_types[0],
	                          block_type_trees, 0, block_type, block_type_rb,
	                          block_type_rb_index, br);
	          block_length[0] = ReadBlockLength(block_len_trees, 0, br);
	          context_offset = block_type[0] << kLiteralContextBits;
	          context_map_slice = context_offset;
	          context_mode = context_modes[block_type[0]];
	          context_lookup_offset1 = Context.lookupOffsets[context_mode];
	          context_lookup_offset2 = Context.lookupOffsets[context_mode + 1];
	        }
	        context = (Context.lookup[context_lookup_offset1 + prev_byte1] |
	                   Context.lookup[context_lookup_offset2 + prev_byte2]);
	        literal_htree_index = context_map[context_map_slice + context];
	        --block_length[0];
	        prev_byte2 = prev_byte1;
	        prev_byte1 = ReadSymbol(hgroup[0].codes, hgroup[0].htrees[literal_htree_index], br);
	        ringbuffer[pos & ringbuffer_mask] = prev_byte1;
	        if ((pos & ringbuffer_mask) === ringbuffer_mask) {
	          output.write(ringbuffer, ringbuffer_size);
	        }
	        ++pos;
	      }
	      meta_block_remaining_len -= insert_length;
	      if (meta_block_remaining_len <= 0) break;

	      if (distance_code < 0) {
	        var context;
	        
	        br.readMoreInput();
	        if (block_length[2] === 0) {
	          DecodeBlockType(num_block_types[2],
	                          block_type_trees, 2, block_type, block_type_rb,
	                          block_type_rb_index, br);
	          block_length[2] = ReadBlockLength(block_len_trees, 2 * HUFFMAN_MAX_TABLE_SIZE, br);
	          dist_context_offset = block_type[2] << kDistanceContextBits;
	          dist_context_map_slice = dist_context_offset;
	        }
	        --block_length[2];
	        context = (copy_length > 4 ? 3 : copy_length - 2) & 0xff;
	        dist_htree_index = dist_context_map[dist_context_map_slice + context];
	        distance_code = ReadSymbol(hgroup[2].codes, hgroup[2].htrees[dist_htree_index], br);
	        if (distance_code >= num_direct_distance_codes) {
	          var nbits;
	          var postfix;
	          var offset;
	          distance_code -= num_direct_distance_codes;
	          postfix = distance_code & distance_postfix_mask;
	          distance_code >>= distance_postfix_bits;
	          nbits = (distance_code >> 1) + 1;
	          offset = ((2 + (distance_code & 1)) << nbits) - 4;
	          distance_code = num_direct_distance_codes +
	              ((offset + br.readBits(nbits)) <<
	               distance_postfix_bits) + postfix;
	        }
	      }

	      /* Convert the distance code to the actual distance by possibly looking */
	      /* up past distnaces from the ringbuffer. */
	      distance = TranslateShortCodes(distance_code, dist_rb, dist_rb_idx);
	      if (distance < 0) {
	        throw new Error('[BrotliDecompress] invalid distance');
	      }

	      if (pos < max_backward_distance &&
	          max_distance !== max_backward_distance) {
	        max_distance = pos;
	      } else {
	        max_distance = max_backward_distance;
	      }

	      copy_dst = pos & ringbuffer_mask;

	      if (distance > max_distance) {
	        if (copy_length >= BrotliDictionary.minDictionaryWordLength &&
	            copy_length <= BrotliDictionary.maxDictionaryWordLength) {
	          var offset = BrotliDictionary.offsetsByLength[copy_length];
	          var word_id = distance - max_distance - 1;
	          var shift = BrotliDictionary.sizeBitsByLength[copy_length];
	          var mask = (1 << shift) - 1;
	          var word_idx = word_id & mask;
	          var transform_idx = word_id >> shift;
	          offset += word_idx * copy_length;
	          if (transform_idx < Transform.kNumTransforms) {
	            var len = Transform.transformDictionaryWord(ringbuffer, copy_dst, offset, copy_length, transform_idx);
	            copy_dst += len;
	            pos += len;
	            meta_block_remaining_len -= len;
	            if (copy_dst >= ringbuffer_end) {
	              output.write(ringbuffer, ringbuffer_size);
	              
	              for (var _x = 0; _x < (copy_dst - ringbuffer_end); _x++)
	                ringbuffer[_x] = ringbuffer[ringbuffer_end + _x];
	            }
	          } else {
	            throw new Error("Invalid backward reference. pos: " + pos + " distance: " + distance +
	              " len: " + copy_length + " bytes left: " + meta_block_remaining_len);
	          }
	        } else {
	          throw new Error("Invalid backward reference. pos: " + pos + " distance: " + distance +
	            " len: " + copy_length + " bytes left: " + meta_block_remaining_len);
	        }
	      } else {
	        if (distance_code > 0) {
	          dist_rb[dist_rb_idx & 3] = distance;
	          ++dist_rb_idx;
	        }

	        if (copy_length > meta_block_remaining_len) {
	          throw new Error("Invalid backward reference. pos: " + pos + " distance: " + distance +
	            " len: " + copy_length + " bytes left: " + meta_block_remaining_len);
	        }

	        for (j = 0; j < copy_length; ++j) {
	          ringbuffer[pos & ringbuffer_mask] = ringbuffer[(pos - distance) & ringbuffer_mask];
	          if ((pos & ringbuffer_mask) === ringbuffer_mask) {
	            output.write(ringbuffer, ringbuffer_size);
	          }
	          ++pos;
	          --meta_block_remaining_len;
	        }
	      }

	      /* When we get here, we must have inserted at least one literal and */
	      /* made a copy of at least length two, therefore accessing the last 2 */
	      /* bytes is valid. */
	      prev_byte1 = ringbuffer[(pos - 1) & ringbuffer_mask];
	      prev_byte2 = ringbuffer[(pos - 2) & ringbuffer_mask];
	    }

	    /* Protect pos from overflow, wrap it around at every GB of input data */
	    pos &= 0x3fffffff;
	  }

	  output.write(ringbuffer, pos & ringbuffer_mask);
	}

	exports.BrotliDecompress = BrotliDecompress;

	BrotliDictionary.init();


/***/ }),
/* 281 */
/***/ (function(module, exports) {

	function BrotliInput(buffer) {
	  this.buffer = buffer;
	  this.pos = 0;
	}

	BrotliInput.prototype.read = function(buf, i, count) {
	  if (this.pos + count > this.buffer.length) {
	    count = this.buffer.length - this.pos;
	  }
	  
	  for (var p = 0; p < count; p++)
	    buf[i + p] = this.buffer[this.pos + p];
	  
	  this.pos += count;
	  return count;
	}

	exports.BrotliInput = BrotliInput;

	function BrotliOutput(buf) {
	  this.buffer = buf;
	  this.pos = 0;
	}

	BrotliOutput.prototype.write = function(buf, count) {
	  if (this.pos + count > this.buffer.length)
	    throw new Error('Output buffer is not large enough');
	  
	  this.buffer.set(buf.subarray(0, count), this.pos);
	  this.pos += count;
	  return count;
	};

	exports.BrotliOutput = BrotliOutput;


/***/ }),
/* 282 */
/***/ (function(module, exports) {

	/* Copyright 2013 Google Inc. All Rights Reserved.

	   Licensed under the Apache License, Version 2.0 (the "License");
	   you may not use this file except in compliance with the License.
	   You may obtain a copy of the License at

	   http://www.apache.org/licenses/LICENSE-2.0

	   Unless required by applicable law or agreed to in writing, software
	   distributed under the License is distributed on an "AS IS" BASIS,
	   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   See the License for the specific language governing permissions and
	   limitations under the License.

	   Bit reading helpers
	*/

	var BROTLI_READ_SIZE = 4096;
	var BROTLI_IBUF_SIZE =  (2 * BROTLI_READ_SIZE + 32);
	var BROTLI_IBUF_MASK =  (2 * BROTLI_READ_SIZE - 1);

	var kBitMask = new Uint32Array([
	  0, 1, 3, 7, 15, 31, 63, 127, 255, 511, 1023, 2047, 4095, 8191, 16383, 32767,
	  65535, 131071, 262143, 524287, 1048575, 2097151, 4194303, 8388607, 16777215
	]);

	/* Input byte buffer, consist of a ringbuffer and a "slack" region where */
	/* bytes from the start of the ringbuffer are copied. */
	function BrotliBitReader(input) {
	  this.buf_ = new Uint8Array(BROTLI_IBUF_SIZE);
	  this.input_ = input;    /* input callback */
	  
	  this.reset();
	}

	BrotliBitReader.READ_SIZE = BROTLI_READ_SIZE;
	BrotliBitReader.IBUF_MASK = BROTLI_IBUF_MASK;

	BrotliBitReader.prototype.reset = function() {
	  this.buf_ptr_ = 0;      /* next input will write here */
	  this.val_ = 0;          /* pre-fetched bits */
	  this.pos_ = 0;          /* byte position in stream */
	  this.bit_pos_ = 0;      /* current bit-reading position in val_ */
	  this.bit_end_pos_ = 0;  /* bit-reading end position from LSB of val_ */
	  this.eos_ = 0;          /* input stream is finished */
	  
	  this.readMoreInput();
	  for (var i = 0; i < 4; i++) {
	    this.val_ |= this.buf_[this.pos_] << (8 * i);
	    ++this.pos_;
	  }
	  
	  return this.bit_end_pos_ > 0;
	};

	/* Fills up the input ringbuffer by calling the input callback.

	   Does nothing if there are at least 32 bytes present after current position.

	   Returns 0 if either:
	    - the input callback returned an error, or
	    - there is no more input and the position is past the end of the stream.

	   After encountering the end of the input stream, 32 additional zero bytes are
	   copied to the ringbuffer, therefore it is safe to call this function after
	   every 32 bytes of input is read.
	*/
	BrotliBitReader.prototype.readMoreInput = function() {
	  if (this.bit_end_pos_ > 256) {
	    return;
	  } else if (this.eos_) {
	    if (this.bit_pos_ > this.bit_end_pos_)
	      throw new Error('Unexpected end of input ' + this.bit_pos_ + ' ' + this.bit_end_pos_);
	  } else {
	    var dst = this.buf_ptr_;
	    var bytes_read = this.input_.read(this.buf_, dst, BROTLI_READ_SIZE);
	    if (bytes_read < 0) {
	      throw new Error('Unexpected end of input');
	    }
	    
	    if (bytes_read < BROTLI_READ_SIZE) {
	      this.eos_ = 1;
	      /* Store 32 bytes of zero after the stream end. */
	      for (var p = 0; p < 32; p++)
	        this.buf_[dst + bytes_read + p] = 0;
	    }
	    
	    if (dst === 0) {
	      /* Copy the head of the ringbuffer to the slack region. */
	      for (var p = 0; p < 32; p++)
	        this.buf_[(BROTLI_READ_SIZE << 1) + p] = this.buf_[p];

	      this.buf_ptr_ = BROTLI_READ_SIZE;
	    } else {
	      this.buf_ptr_ = 0;
	    }
	    
	    this.bit_end_pos_ += bytes_read << 3;
	  }
	};

	/* Guarantees that there are at least 24 bits in the buffer. */
	BrotliBitReader.prototype.fillBitWindow = function() {    
	  while (this.bit_pos_ >= 8) {
	    this.val_ >>>= 8;
	    this.val_ |= this.buf_[this.pos_ & BROTLI_IBUF_MASK] << 24;
	    ++this.pos_;
	    this.bit_pos_ = this.bit_pos_ - 8 >>> 0;
	    this.bit_end_pos_ = this.bit_end_pos_ - 8 >>> 0;
	  }
	};

	/* Reads the specified number of bits from Read Buffer. */
	BrotliBitReader.prototype.readBits = function(n_bits) {
	  if (32 - this.bit_pos_ < n_bits) {
	    this.fillBitWindow();
	  }
	  
	  var val = ((this.val_ >>> this.bit_pos_) & kBitMask[n_bits]);
	  this.bit_pos_ += n_bits;
	  return val;
	};

	module.exports = BrotliBitReader;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	/* Copyright 2013 Google Inc. All Rights Reserved.

	   Licensed under the Apache License, Version 2.0 (the "License");
	   you may not use this file except in compliance with the License.
	   You may obtain a copy of the License at

	   http://www.apache.org/licenses/LICENSE-2.0

	   Unless required by applicable law or agreed to in writing, software
	   distributed under the License is distributed on an "AS IS" BASIS,
	   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   See the License for the specific language governing permissions and
	   limitations under the License.

	   Collection of static dictionary words.
	*/

	var data = __webpack_require__(284);
	exports.init = function() {
	  exports.dictionary = data.init();
	};

	exports.offsetsByLength = new Uint32Array([
	     0,     0,     0,     0,     0,  4096,  9216, 21504, 35840, 44032,
	 53248, 63488, 74752, 87040, 93696, 100864, 104704, 106752, 108928, 113536,
	 115968, 118528, 119872, 121280, 122016,
	]);

	exports.sizeBitsByLength = new Uint8Array([
	  0,  0,  0,  0, 10, 10, 11, 11, 10, 10,
	 10, 10, 10,  9,  9,  8,  7,  7,  8,  7,
	  7,  6,  6,  5,  5,
	]);

	exports.minDictionaryWordLength = 4;
	exports.maxDictionaryWordLength = 24;


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	var base64 = __webpack_require__(285);
	var fs = __webpack_require__(56);

	/**
	 * The normal dictionary-data.js is quite large, which makes it 
	 * unsuitable for browser usage. In order to make it smaller, 
	 * we read dictionary.bin, which is a compressed version of
	 * the dictionary, and on initial load, Brotli decompresses 
	 * it's own dictionary. 😜
	 */
	exports.init = function() {
	  var BrotliDecompressBuffer = __webpack_require__(280).BrotliDecompressBuffer;
	  var compressed = base64.toByteArray(__webpack_require__(286));
	  return BrotliDecompressBuffer(compressed);
	};


/***/ }),
/* 285 */
/***/ (function(module, exports) {

	'use strict'

	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray

	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}

	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63

	function placeHoldersCount (b64) {
	  var len = b64.length
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }

	  // the number of equal signs (place holders)
	  // if there are two placeholders, than the two characters before it
	  // represent one byte
	  // if there is only one, then the three characters before it represent 2 bytes
	  // this is just a cheap hack to not do indexOf twice
	  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
	}

	function byteLength (b64) {
	  // base64 is 4/3 + up to two characters of the original data
	  return (b64.length * 3 / 4) - placeHoldersCount(b64)
	}

	function toByteArray (b64) {
	  var i, l, tmp, placeHolders, arr
	  var len = b64.length
	  placeHolders = placeHoldersCount(b64)

	  arr = new Arr((len * 3 / 4) - placeHolders)

	  // if there are placeholders, only get up to the last complete 4 chars
	  l = placeHolders > 0 ? len - 4 : len

	  var L = 0

	  for (i = 0; i < l; i += 4) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
	    arr[L++] = (tmp >> 16) & 0xFF
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }

	  if (placeHolders === 2) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[L++] = tmp & 0xFF
	  } else if (placeHolders === 1) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }

	  return arr
	}

	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
	}

	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}

	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var output = ''
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3

	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }

	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    output += lookup[tmp >> 2]
	    output += lookup[(tmp << 4) & 0x3F]
	    output += '=='
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
	    output += lookup[tmp >> 10]
	    output += lookup[(tmp >> 4) & 0x3F]
	    output += lookup[(tmp << 2) & 0x3F]
	    output += '='
	  }

	  parts.push(output)

	  return parts.join('')
	}


/***/ }),
/* 286 */
/***/ (function(module, exports) {

	module.exports="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";


/***/ }),
/* 287 */
/***/ (function(module, exports) {

	function HuffmanCode(bits, value) {
	  this.bits = bits;   /* number of bits used for this symbol */
	  this.value = value; /* symbol value or table offset */
	}

	exports.HuffmanCode = HuffmanCode;

	var MAX_LENGTH = 15;

	/* Returns reverse(reverse(key, len) + 1, len), where reverse(key, len) is the
	   bit-wise reversal of the len least significant bits of key. */
	function GetNextKey(key, len) {
	  var step = 1 << (len - 1);
	  while (key & step) {
	    step >>= 1;
	  }
	  return (key & (step - 1)) + step;
	}

	/* Stores code in table[0], table[step], table[2*step], ..., table[end] */
	/* Assumes that end is an integer multiple of step */
	function ReplicateValue(table, i, step, end, code) {
	  do {
	    end -= step;
	    table[i + end] = new HuffmanCode(code.bits, code.value);
	  } while (end > 0);
	}

	/* Returns the table width of the next 2nd level table. count is the histogram
	   of bit lengths for the remaining symbols, len is the code length of the next
	   processed symbol */
	function NextTableBitSize(count, len, root_bits) {
	  var left = 1 << (len - root_bits);
	  while (len < MAX_LENGTH) {
	    left -= count[len];
	    if (left <= 0) break;
	    ++len;
	    left <<= 1;
	  }
	  return len - root_bits;
	}

	exports.BrotliBuildHuffmanTable = function(root_table, table, root_bits, code_lengths, code_lengths_size) {
	  var start_table = table;
	  var code;            /* current table entry */
	  var len;             /* current code length */
	  var symbol;          /* symbol index in original or sorted table */
	  var key;             /* reversed prefix code */
	  var step;            /* step size to replicate values in current table */
	  var low;             /* low bits for current root entry */
	  var mask;            /* mask for low bits */
	  var table_bits;      /* key length of current table */
	  var table_size;      /* size of current table */
	  var total_size;      /* sum of root table size and 2nd level table sizes */
	  var sorted;          /* symbols sorted by code length */
	  var count = new Int32Array(MAX_LENGTH + 1);  /* number of codes of each length */
	  var offset = new Int32Array(MAX_LENGTH + 1);  /* offsets in sorted table for each length */

	  sorted = new Int32Array(code_lengths_size);

	  /* build histogram of code lengths */
	  for (symbol = 0; symbol < code_lengths_size; symbol++) {
	    count[code_lengths[symbol]]++;
	  }

	  /* generate offsets into sorted symbol table by code length */
	  offset[1] = 0;
	  for (len = 1; len < MAX_LENGTH; len++) {
	    offset[len + 1] = offset[len] + count[len];
	  }

	  /* sort symbols by length, by symbol order within each length */
	  for (symbol = 0; symbol < code_lengths_size; symbol++) {
	    if (code_lengths[symbol] !== 0) {
	      sorted[offset[code_lengths[symbol]]++] = symbol;
	    }
	  }
	  
	  table_bits = root_bits;
	  table_size = 1 << table_bits;
	  total_size = table_size;

	  /* special case code with only one value */
	  if (offset[MAX_LENGTH] === 1) {
	    for (key = 0; key < total_size; ++key) {
	      root_table[table + key] = new HuffmanCode(0, sorted[0] & 0xffff);
	    }
	    
	    return total_size;
	  }

	  /* fill in root table */
	  key = 0;
	  symbol = 0;
	  for (len = 1, step = 2; len <= root_bits; ++len, step <<= 1) {
	    for (; count[len] > 0; --count[len]) {
	      code = new HuffmanCode(len & 0xff, sorted[symbol++] & 0xffff);
	      ReplicateValue(root_table, table + key, step, table_size, code);
	      key = GetNextKey(key, len);
	    }
	  }

	  /* fill in 2nd level tables and add pointers to root table */
	  mask = total_size - 1;
	  low = -1;
	  for (len = root_bits + 1, step = 2; len <= MAX_LENGTH; ++len, step <<= 1) {
	    for (; count[len] > 0; --count[len]) {
	      if ((key & mask) !== low) {
	        table += table_size;
	        table_bits = NextTableBitSize(count, len, root_bits);
	        table_size = 1 << table_bits;
	        total_size += table_size;
	        low = key & mask;
	        root_table[start_table + low] = new HuffmanCode((table_bits + root_bits) & 0xff, ((table - start_table) - low) & 0xffff);
	      }
	      code = new HuffmanCode((len - root_bits) & 0xff, sorted[symbol++] & 0xffff);
	      ReplicateValue(root_table, table + (key >> root_bits), step, table_size, code);
	      key = GetNextKey(key, len);
	    }
	  }
	  
	  return total_size;
	}


/***/ }),
/* 288 */
/***/ (function(module, exports) {

	/* Copyright 2013 Google Inc. All Rights Reserved.

	   Licensed under the Apache License, Version 2.0 (the "License");
	   you may not use this file except in compliance with the License.
	   You may obtain a copy of the License at

	   http://www.apache.org/licenses/LICENSE-2.0

	   Unless required by applicable law or agreed to in writing, software
	   distributed under the License is distributed on an "AS IS" BASIS,
	   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   See the License for the specific language governing permissions and
	   limitations under the License.

	   Lookup table to map the previous two bytes to a context id.

	   There are four different context modeling modes defined here:
	     CONTEXT_LSB6: context id is the least significant 6 bits of the last byte,
	     CONTEXT_MSB6: context id is the most significant 6 bits of the last byte,
	     CONTEXT_UTF8: second-order context model tuned for UTF8-encoded text,
	     CONTEXT_SIGNED: second-order context model tuned for signed integers.

	   The context id for the UTF8 context model is calculated as follows. If p1
	   and p2 are the previous two bytes, we calcualte the context as

	     context = kContextLookup[p1] | kContextLookup[p2 + 256].

	   If the previous two bytes are ASCII characters (i.e. < 128), this will be
	   equivalent to

	     context = 4 * context1(p1) + context2(p2),

	   where context1 is based on the previous byte in the following way:

	     0  : non-ASCII control
	     1  : \t, \n, \r
	     2  : space
	     3  : other punctuation
	     4  : " '
	     5  : %
	     6  : ( < [ {
	     7  : ) > ] }
	     8  : , ; :
	     9  : .
	     10 : =
	     11 : number
	     12 : upper-case vowel
	     13 : upper-case consonant
	     14 : lower-case vowel
	     15 : lower-case consonant

	   and context2 is based on the second last byte:

	     0 : control, space
	     1 : punctuation
	     2 : upper-case letter, number
	     3 : lower-case letter

	   If the last byte is ASCII, and the second last byte is not (in a valid UTF8
	   stream it will be a continuation byte, value between 128 and 191), the
	   context is the same as if the second last byte was an ASCII control or space.

	   If the last byte is a UTF8 lead byte (value >= 192), then the next byte will
	   be a continuation byte and the context id is 2 or 3 depending on the LSB of
	   the last byte and to a lesser extent on the second last byte if it is ASCII.

	   If the last byte is a UTF8 continuation byte, the second last byte can be:
	     - continuation byte: the next byte is probably ASCII or lead byte (assuming
	       4-byte UTF8 characters are rare) and the context id is 0 or 1.
	     - lead byte (192 - 207): next byte is ASCII or lead byte, context is 0 or 1
	     - lead byte (208 - 255): next byte is continuation byte, context is 2 or 3

	   The possible value combinations of the previous two bytes, the range of
	   context ids and the type of the next byte is summarized in the table below:

	   |--------\-----------------------------------------------------------------|
	   |         \                         Last byte                              |
	   | Second   \---------------------------------------------------------------|
	   | last byte \    ASCII            |   cont. byte        |   lead byte      |
	   |            \   (0-127)          |   (128-191)         |   (192-)         |
	   |=============|===================|=====================|==================|
	   |  ASCII      | next: ASCII/lead  |  not valid          |  next: cont.     |
	   |  (0-127)    | context: 4 - 63   |                     |  context: 2 - 3  |
	   |-------------|-------------------|---------------------|------------------|
	   |  cont. byte | next: ASCII/lead  |  next: ASCII/lead   |  next: cont.     |
	   |  (128-191)  | context: 4 - 63   |  context: 0 - 1     |  context: 2 - 3  |
	   |-------------|-------------------|---------------------|------------------|
	   |  lead byte  | not valid         |  next: ASCII/lead   |  not valid       |
	   |  (192-207)  |                   |  context: 0 - 1     |                  |
	   |-------------|-------------------|---------------------|------------------|
	   |  lead byte  | not valid         |  next: cont.        |  not valid       |
	   |  (208-)     |                   |  context: 2 - 3     |                  |
	   |-------------|-------------------|---------------------|------------------|

	   The context id for the signed context mode is calculated as:

	     context = (kContextLookup[512 + p1] << 3) | kContextLookup[512 + p2].

	   For any context modeling modes, the context ids can be calculated by |-ing
	   together two lookups from one table using context model dependent offsets:

	     context = kContextLookup[offset1 + p1] | kContextLookup[offset2 + p2].

	   where offset1 and offset2 are dependent on the context mode.
	*/

	var CONTEXT_LSB6         = 0;
	var CONTEXT_MSB6         = 1;
	var CONTEXT_UTF8         = 2;
	var CONTEXT_SIGNED       = 3;

	/* Common context lookup table for all context modes. */
	exports.lookup = new Uint8Array([
	  /* CONTEXT_UTF8, last byte. */
	  /* ASCII range. */
	   0,  0,  0,  0,  0,  0,  0,  0,  0,  4,  4,  0,  0,  4,  0,  0,
	   0,  0,  0,  0,  0,  0,  0,  0,  0,  0,  0,  0,  0,  0,  0,  0,
	   8, 12, 16, 12, 12, 20, 12, 16, 24, 28, 12, 12, 32, 12, 36, 12,
	  44, 44, 44, 44, 44, 44, 44, 44, 44, 44, 32, 32, 24, 40, 28, 12,
	  12, 48, 52, 52, 52, 48, 52, 52, 52, 48, 52, 52, 52, 52, 52, 48,
	  52, 52, 52, 52, 52, 48, 52, 52, 52, 52, 52, 24, 12, 28, 12, 12,
	  12, 56, 60, 60, 60, 56, 60, 60, 60, 56, 60, 60, 60, 60, 60, 56,
	  60, 60, 60, 60, 60, 56, 60, 60, 60, 60, 60, 24, 12, 28, 12,  0,
	  /* UTF8 continuation byte range. */
	  0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1,
	  0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1,
	  0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1,
	  0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1,
	  /* UTF8 lead byte range. */
	  2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3,
	  2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3,
	  2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3,
	  2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3, 2, 3,
	  /* CONTEXT_UTF8 second last byte. */
	  /* ASCII range. */
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
	  2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1,
	  1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
	  2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1,
	  1, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
	  3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 1, 1, 1, 1, 0,
	  /* UTF8 continuation byte range. */
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  /* UTF8 lead byte range. */
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
	  2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
	  /* CONTEXT_SIGNED, second last byte. */
	  0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
	  2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
	  2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
	  2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
	  3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
	  3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
	  3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
	  3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
	  4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4,
	  4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4,
	  4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4,
	  4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4,
	  5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5,
	  5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5,
	  5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5,
	  6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 7,
	  /* CONTEXT_SIGNED, last byte, same as the above values shifted by 3 bits. */
	   0, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
	  16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16,
	  16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16,
	  16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16,
	  24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
	  24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
	  24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
	  24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
	  32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32,
	  32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32,
	  32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32,
	  32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32,
	  40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40,
	  40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40,
	  40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40,
	  48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 48, 56,
	  /* CONTEXT_LSB6, last byte. */
	   0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	  16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
	  32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47,
	  48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63,
	   0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	  16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
	  32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47,
	  48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63,
	   0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	  16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
	  32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47,
	  48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63,
	   0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	  16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
	  32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47,
	  48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63,
	  /* CONTEXT_MSB6, last byte. */
	   0,  0,  0,  0,  1,  1,  1,  1,  2,  2,  2,  2,  3,  3,  3,  3,
	   4,  4,  4,  4,  5,  5,  5,  5,  6,  6,  6,  6,  7,  7,  7,  7,
	   8,  8,  8,  8,  9,  9,  9,  9, 10, 10, 10, 10, 11, 11, 11, 11,
	  12, 12, 12, 12, 13, 13, 13, 13, 14, 14, 14, 14, 15, 15, 15, 15,
	  16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19,
	  20, 20, 20, 20, 21, 21, 21, 21, 22, 22, 22, 22, 23, 23, 23, 23,
	  24, 24, 24, 24, 25, 25, 25, 25, 26, 26, 26, 26, 27, 27, 27, 27,
	  28, 28, 28, 28, 29, 29, 29, 29, 30, 30, 30, 30, 31, 31, 31, 31,
	  32, 32, 32, 32, 33, 33, 33, 33, 34, 34, 34, 34, 35, 35, 35, 35,
	  36, 36, 36, 36, 37, 37, 37, 37, 38, 38, 38, 38, 39, 39, 39, 39,
	  40, 40, 40, 40, 41, 41, 41, 41, 42, 42, 42, 42, 43, 43, 43, 43,
	  44, 44, 44, 44, 45, 45, 45, 45, 46, 46, 46, 46, 47, 47, 47, 47,
	  48, 48, 48, 48, 49, 49, 49, 49, 50, 50, 50, 50, 51, 51, 51, 51,
	  52, 52, 52, 52, 53, 53, 53, 53, 54, 54, 54, 54, 55, 55, 55, 55,
	  56, 56, 56, 56, 57, 57, 57, 57, 58, 58, 58, 58, 59, 59, 59, 59,
	  60, 60, 60, 60, 61, 61, 61, 61, 62, 62, 62, 62, 63, 63, 63, 63,
	  /* CONTEXT_{M,L}SB6, second last byte, */
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
	]);

	exports.lookupOffsets = new Uint16Array([
	  /* CONTEXT_LSB6 */
	  1024, 1536,
	  /* CONTEXT_MSB6 */
	  1280, 1536,
	  /* CONTEXT_UTF8 */
	  0, 256,
	  /* CONTEXT_SIGNED */
	  768, 512,
	]);


/***/ }),
/* 289 */
/***/ (function(module, exports) {

	/* Copyright 2013 Google Inc. All Rights Reserved.

	   Licensed under the Apache License, Version 2.0 (the "License");
	   you may not use this file except in compliance with the License.
	   You may obtain a copy of the License at

	   http://www.apache.org/licenses/LICENSE-2.0

	   Unless required by applicable law or agreed to in writing, software
	   distributed under the License is distributed on an "AS IS" BASIS,
	   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   See the License for the specific language governing permissions and
	   limitations under the License.

	   Lookup tables to map prefix codes to value ranges. This is used during
	   decoding of the block lengths, literal insertion lengths and copy lengths.
	*/

	/* Represents the range of values belonging to a prefix code: */
	/* [offset, offset + 2^nbits) */
	function PrefixCodeRange(offset, nbits) {
	  this.offset = offset;
	  this.nbits = nbits;
	}

	exports.kBlockLengthPrefixCode = [
	  new PrefixCodeRange(1, 2), new PrefixCodeRange(5, 2), new PrefixCodeRange(9, 2), new PrefixCodeRange(13, 2),
	  new PrefixCodeRange(17, 3), new PrefixCodeRange(25, 3), new PrefixCodeRange(33, 3), new PrefixCodeRange(41, 3),
	  new PrefixCodeRange(49, 4), new PrefixCodeRange(65, 4), new PrefixCodeRange(81, 4), new PrefixCodeRange(97, 4),
	  new PrefixCodeRange(113, 5), new PrefixCodeRange(145, 5), new PrefixCodeRange(177, 5), new PrefixCodeRange(209, 5),
	  new PrefixCodeRange(241, 6), new PrefixCodeRange(305, 6), new PrefixCodeRange(369, 7), new PrefixCodeRange(497, 8),
	  new PrefixCodeRange(753, 9), new PrefixCodeRange(1265, 10), new PrefixCodeRange(2289, 11), new PrefixCodeRange(4337, 12),
	  new PrefixCodeRange(8433, 13), new PrefixCodeRange(16625, 24)
	];

	exports.kInsertLengthPrefixCode = [
	  new PrefixCodeRange(0, 0), new PrefixCodeRange(1, 0), new PrefixCodeRange(2, 0), new PrefixCodeRange(3, 0),
	  new PrefixCodeRange(4, 0), new PrefixCodeRange(5, 0), new PrefixCodeRange(6, 1), new PrefixCodeRange(8, 1),
	  new PrefixCodeRange(10, 2), new PrefixCodeRange(14, 2), new PrefixCodeRange(18, 3), new PrefixCodeRange(26, 3),
	  new PrefixCodeRange(34, 4), new PrefixCodeRange(50, 4), new PrefixCodeRange(66, 5), new PrefixCodeRange(98, 5),
	  new PrefixCodeRange(130, 6), new PrefixCodeRange(194, 7), new PrefixCodeRange(322, 8), new PrefixCodeRange(578, 9),
	  new PrefixCodeRange(1090, 10), new PrefixCodeRange(2114, 12), new PrefixCodeRange(6210, 14), new PrefixCodeRange(22594, 24),
	];

	exports.kCopyLengthPrefixCode = [
	  new PrefixCodeRange(2, 0), new PrefixCodeRange(3, 0), new PrefixCodeRange(4, 0), new PrefixCodeRange(5, 0),
	  new PrefixCodeRange(6, 0), new PrefixCodeRange(7, 0), new PrefixCodeRange(8, 0), new PrefixCodeRange(9, 0),
	  new PrefixCodeRange(10, 1), new PrefixCodeRange(12, 1), new PrefixCodeRange(14, 2), new PrefixCodeRange(18, 2),
	  new PrefixCodeRange(22, 3), new PrefixCodeRange(30, 3), new PrefixCodeRange(38, 4), new PrefixCodeRange(54, 4),
	  new PrefixCodeRange(70, 5), new PrefixCodeRange(102, 5), new PrefixCodeRange(134, 6), new PrefixCodeRange(198, 7),
	  new PrefixCodeRange(326, 8), new PrefixCodeRange(582, 9), new PrefixCodeRange(1094, 10), new PrefixCodeRange(2118, 24),
	];

	exports.kInsertRangeLut = [
	  0, 0, 8, 8, 0, 16, 8, 16, 16,
	];

	exports.kCopyRangeLut = [
	  0, 8, 0, 8, 16, 0, 16, 8, 16,
	];


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	/* Copyright 2013 Google Inc. All Rights Reserved.

	   Licensed under the Apache License, Version 2.0 (the "License");
	   you may not use this file except in compliance with the License.
	   You may obtain a copy of the License at

	   http://www.apache.org/licenses/LICENSE-2.0

	   Unless required by applicable law or agreed to in writing, software
	   distributed under the License is distributed on an "AS IS" BASIS,
	   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	   See the License for the specific language governing permissions and
	   limitations under the License.

	   Transformations on dictionary words.
	*/

	var BrotliDictionary = __webpack_require__(283);

	var kIdentity       = 0;
	var kOmitLast1      = 1;
	var kOmitLast2      = 2;
	var kOmitLast3      = 3;
	var kOmitLast4      = 4;
	var kOmitLast5      = 5;
	var kOmitLast6      = 6;
	var kOmitLast7      = 7;
	var kOmitLast8      = 8;
	var kOmitLast9      = 9;
	var kUppercaseFirst = 10;
	var kUppercaseAll   = 11;
	var kOmitFirst1     = 12;
	var kOmitFirst2     = 13;
	var kOmitFirst3     = 14;
	var kOmitFirst4     = 15;
	var kOmitFirst5     = 16;
	var kOmitFirst6     = 17;
	var kOmitFirst7     = 18;
	var kOmitFirst8     = 19;
	var kOmitFirst9     = 20;

	function Transform(prefix, transform, suffix) {
	  this.prefix = new Uint8Array(prefix.length);
	  this.transform = transform;
	  this.suffix = new Uint8Array(suffix.length);
	  
	  for (var i = 0; i < prefix.length; i++)
	    this.prefix[i] = prefix.charCodeAt(i);
	  
	  for (var i = 0; i < suffix.length; i++)
	    this.suffix[i] = suffix.charCodeAt(i);
	}

	var kTransforms = [
	     new Transform(         "", kIdentity,       ""           ),
	     new Transform(         "", kIdentity,       " "          ),
	     new Transform(        " ", kIdentity,       " "          ),
	     new Transform(         "", kOmitFirst1,     ""           ),
	     new Transform(         "", kUppercaseFirst, " "          ),
	     new Transform(         "", kIdentity,       " the "      ),
	     new Transform(        " ", kIdentity,       ""           ),
	     new Transform(       "s ", kIdentity,       " "          ),
	     new Transform(         "", kIdentity,       " of "       ),
	     new Transform(         "", kUppercaseFirst, ""           ),
	     new Transform(         "", kIdentity,       " and "      ),
	     new Transform(         "", kOmitFirst2,     ""           ),
	     new Transform(         "", kOmitLast1,      ""           ),
	     new Transform(       ", ", kIdentity,       " "          ),
	     new Transform(         "", kIdentity,       ", "         ),
	     new Transform(        " ", kUppercaseFirst, " "          ),
	     new Transform(         "", kIdentity,       " in "       ),
	     new Transform(         "", kIdentity,       " to "       ),
	     new Transform(       "e ", kIdentity,       " "          ),
	     new Transform(         "", kIdentity,       "\""         ),
	     new Transform(         "", kIdentity,       "."          ),
	     new Transform(         "", kIdentity,       "\">"        ),
	     new Transform(         "", kIdentity,       "\n"         ),
	     new Transform(         "", kOmitLast3,      ""           ),
	     new Transform(         "", kIdentity,       "]"          ),
	     new Transform(         "", kIdentity,       " for "      ),
	     new Transform(         "", kOmitFirst3,     ""           ),
	     new Transform(         "", kOmitLast2,      ""           ),
	     new Transform(         "", kIdentity,       " a "        ),
	     new Transform(         "", kIdentity,       " that "     ),
	     new Transform(        " ", kUppercaseFirst, ""           ),
	     new Transform(         "", kIdentity,       ". "         ),
	     new Transform(        ".", kIdentity,       ""           ),
	     new Transform(        " ", kIdentity,       ", "         ),
	     new Transform(         "", kOmitFirst4,     ""           ),
	     new Transform(         "", kIdentity,       " with "     ),
	     new Transform(         "", kIdentity,       "'"          ),
	     new Transform(         "", kIdentity,       " from "     ),
	     new Transform(         "", kIdentity,       " by "       ),
	     new Transform(         "", kOmitFirst5,     ""           ),
	     new Transform(         "", kOmitFirst6,     ""           ),
	     new Transform(    " the ", kIdentity,       ""           ),
	     new Transform(         "", kOmitLast4,      ""           ),
	     new Transform(         "", kIdentity,       ". The "     ),
	     new Transform(         "", kUppercaseAll,   ""           ),
	     new Transform(         "", kIdentity,       " on "       ),
	     new Transform(         "", kIdentity,       " as "       ),
	     new Transform(         "", kIdentity,       " is "       ),
	     new Transform(         "", kOmitLast7,      ""           ),
	     new Transform(         "", kOmitLast1,      "ing "       ),
	     new Transform(         "", kIdentity,       "\n\t"       ),
	     new Transform(         "", kIdentity,       ":"          ),
	     new Transform(        " ", kIdentity,       ". "         ),
	     new Transform(         "", kIdentity,       "ed "        ),
	     new Transform(         "", kOmitFirst9,     ""           ),
	     new Transform(         "", kOmitFirst7,     ""           ),
	     new Transform(         "", kOmitLast6,      ""           ),
	     new Transform(         "", kIdentity,       "("          ),
	     new Transform(         "", kUppercaseFirst, ", "         ),
	     new Transform(         "", kOmitLast8,      ""           ),
	     new Transform(         "", kIdentity,       " at "       ),
	     new Transform(         "", kIdentity,       "ly "        ),
	     new Transform(    " the ", kIdentity,       " of "       ),
	     new Transform(         "", kOmitLast5,      ""           ),
	     new Transform(         "", kOmitLast9,      ""           ),
	     new Transform(        " ", kUppercaseFirst, ", "         ),
	     new Transform(         "", kUppercaseFirst, "\""         ),
	     new Transform(        ".", kIdentity,       "("          ),
	     new Transform(         "", kUppercaseAll,   " "          ),
	     new Transform(         "", kUppercaseFirst, "\">"        ),
	     new Transform(         "", kIdentity,       "=\""        ),
	     new Transform(        " ", kIdentity,       "."          ),
	     new Transform(    ".com/", kIdentity,       ""           ),
	     new Transform(    " the ", kIdentity,       " of the "   ),
	     new Transform(         "", kUppercaseFirst, "'"          ),
	     new Transform(         "", kIdentity,       ". This "    ),
	     new Transform(         "", kIdentity,       ","          ),
	     new Transform(        ".", kIdentity,       " "          ),
	     new Transform(         "", kUppercaseFirst, "("          ),
	     new Transform(         "", kUppercaseFirst, "."          ),
	     new Transform(         "", kIdentity,       " not "      ),
	     new Transform(        " ", kIdentity,       "=\""        ),
	     new Transform(         "", kIdentity,       "er "        ),
	     new Transform(        " ", kUppercaseAll,   " "          ),
	     new Transform(         "", kIdentity,       "al "        ),
	     new Transform(        " ", kUppercaseAll,   ""           ),
	     new Transform(         "", kIdentity,       "='"         ),
	     new Transform(         "", kUppercaseAll,   "\""         ),
	     new Transform(         "", kUppercaseFirst, ". "         ),
	     new Transform(        " ", kIdentity,       "("          ),
	     new Transform(         "", kIdentity,       "ful "       ),
	     new Transform(        " ", kUppercaseFirst, ". "         ),
	     new Transform(         "", kIdentity,       "ive "       ),
	     new Transform(         "", kIdentity,       "less "      ),
	     new Transform(         "", kUppercaseAll,   "'"          ),
	     new Transform(         "", kIdentity,       "est "       ),
	     new Transform(        " ", kUppercaseFirst, "."          ),
	     new Transform(         "", kUppercaseAll,   "\">"        ),
	     new Transform(        " ", kIdentity,       "='"         ),
	     new Transform(         "", kUppercaseFirst, ","          ),
	     new Transform(         "", kIdentity,       "ize "       ),
	     new Transform(         "", kUppercaseAll,   "."          ),
	     new Transform( "\xc2\xa0", kIdentity,       ""           ),
	     new Transform(        " ", kIdentity,       ","          ),
	     new Transform(         "", kUppercaseFirst, "=\""        ),
	     new Transform(         "", kUppercaseAll,   "=\""        ),
	     new Transform(         "", kIdentity,       "ous "       ),
	     new Transform(         "", kUppercaseAll,   ", "         ),
	     new Transform(         "", kUppercaseFirst, "='"         ),
	     new Transform(        " ", kUppercaseFirst, ","          ),
	     new Transform(        " ", kUppercaseAll,   "=\""        ),
	     new Transform(        " ", kUppercaseAll,   ", "         ),
	     new Transform(         "", kUppercaseAll,   ","          ),
	     new Transform(         "", kUppercaseAll,   "("          ),
	     new Transform(         "", kUppercaseAll,   ". "         ),
	     new Transform(        " ", kUppercaseAll,   "."          ),
	     new Transform(         "", kUppercaseAll,   "='"         ),
	     new Transform(        " ", kUppercaseAll,   ". "         ),
	     new Transform(        " ", kUppercaseFirst, "=\""        ),
	     new Transform(        " ", kUppercaseAll,   "='"         ),
	     new Transform(        " ", kUppercaseFirst, "='"         )
	];

	exports.kTransforms = kTransforms;
	exports.kNumTransforms = kTransforms.length;

	function ToUpperCase(p, i) {
	  if (p[i] < 0xc0) {
	    if (p[i] >= 97 && p[i] <= 122) {
	      p[i] ^= 32;
	    }
	    return 1;
	  }
	  
	  /* An overly simplified uppercasing model for utf-8. */
	  if (p[i] < 0xe0) {
	    p[i + 1] ^= 32;
	    return 2;
	  }
	  
	  /* An arbitrary transform for three byte characters. */
	  p[i + 2] ^= 5;
	  return 3;
	}

	exports.transformDictionaryWord = function(dst, idx, word, len, transform) {
	  var prefix = kTransforms[transform].prefix;
	  var suffix = kTransforms[transform].suffix;
	  var t = kTransforms[transform].transform;
	  var skip = t < kOmitFirst1 ? 0 : t - (kOmitFirst1 - 1);
	  var i = 0;
	  var start_idx = idx;
	  var uppercase;
	  
	  if (skip > len) {
	    skip = len;
	  }
	  
	  var prefix_pos = 0;
	  while (prefix_pos < prefix.length) {
	    dst[idx++] = prefix[prefix_pos++];
	  }
	  
	  word += skip;
	  len -= skip;
	  
	  if (t <= kOmitLast9) {
	    len -= t;
	  }
	  
	  for (i = 0; i < len; i++) {
	    dst[idx++] = BrotliDictionary.dictionary[word + i];
	  }
	  
	  uppercase = idx - len;
	  
	  if (t === kUppercaseFirst) {
	    ToUpperCase(dst, uppercase);
	  } else if (t === kUppercaseAll) {
	    while (len > 0) {
	      var step = ToUpperCase(dst, uppercase);
	      uppercase += step;
	      len -= step;
	    }
	  }
	  
	  var suffix_pos = 0;
	  while (suffix_pos < suffix.length) {
	    dst[idx++] = suffix[suffix_pos++];
	  }
	  
	  return idx - start_idx;
	}


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {// Generated by CoffeeScript 1.12.6
	(function() {
	  var AFMFont, PDFFont, StandardFont, fs,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;

	  AFMFont = __webpack_require__(292);

	  PDFFont = __webpack_require__(82);

	  fs = __webpack_require__(56);

	  StandardFont = (function(superClass) {
	    var STANDARD_FONTS;

	    extend(StandardFont, superClass);

	    function StandardFont(document, name1, id) {
	      var ref;
	      this.document = document;
	      this.name = name1;
	      this.id = id;
	      this.font = new AFMFont(STANDARD_FONTS[this.name]());
	      ref = this.font, this.ascender = ref.ascender, this.descender = ref.descender, this.bbox = ref.bbox, this.lineGap = ref.lineGap;
	    }

	    StandardFont.prototype.embed = function() {
	      this.dictionary.data = {
	        Type: 'Font',
	        BaseFont: this.name,
	        Subtype: 'Type1',
	        Encoding: 'WinAnsiEncoding'
	      };
	      return this.dictionary.end();
	    };

	    StandardFont.prototype.encode = function(text) {
	      var advances, encoded, glyph, glyphs, i, j, len, positions;
	      encoded = this.font.encodeText(text);
	      glyphs = this.font.glyphsForString('' + text);
	      advances = this.font.advancesForGlyphs(glyphs);
	      positions = [];
	      for (i = j = 0, len = glyphs.length; j < len; i = ++j) {
	        glyph = glyphs[i];
	        positions.push({
	          xAdvance: advances[i],
	          yAdvance: 0,
	          xOffset: 0,
	          yOffset: 0,
	          advanceWidth: this.font.widthOfGlyph(glyph)
	        });
	      }
	      return [encoded, positions];
	    };

	    StandardFont.prototype.widthOfString = function(string, size) {
	      var advance, advances, glyphs, j, len, scale, width;
	      glyphs = this.font.glyphsForString('' + string);
	      advances = this.font.advancesForGlyphs(glyphs);
	      width = 0;
	      for (j = 0, len = advances.length; j < len; j++) {
	        advance = advances[j];
	        width += advance;
	      }
	      scale = size / 1000;
	      return width * scale;
	    };

	    StandardFont.isStandardFont = function(name) {
	      return name in STANDARD_FONTS;
	    };

	    STANDARD_FONTS = {
	      "Courier": function() {
	        return fs.readFileSync(__dirname + "/../font/data/Courier.afm", 'utf8');
	      },
	      "Courier-Bold": function() {
	        return fs.readFileSync(__dirname + "/../font/data/Courier-Bold.afm", 'utf8');
	      },
	      "Courier-Oblique": function() {
	        return fs.readFileSync(__dirname + "/../font/data/Courier-Oblique.afm", 'utf8');
	      },
	      "Courier-BoldOblique": function() {
	        return fs.readFileSync(__dirname + "/../font/data/Courier-BoldOblique.afm", 'utf8');
	      },
	      "Helvetica": function() {
	        return fs.readFileSync(__dirname + "/../font/data/Helvetica.afm", 'utf8');
	      },
	      "Helvetica-Bold": function() {
	        return fs.readFileSync(__dirname + "/../font/data/Helvetica-Bold.afm", 'utf8');
	      },
	      "Helvetica-Oblique": function() {
	        return fs.readFileSync(__dirname + "/../font/data/Helvetica-Oblique.afm", 'utf8');
	      },
	      "Helvetica-BoldOblique": function() {
	        return fs.readFileSync(__dirname + "/../font/data/Helvetica-BoldOblique.afm", 'utf8');
	      },
	      "Times-Roman": function() {
	        return fs.readFileSync(__dirname + "/../font/data/Times-Roman.afm", 'utf8');
	      },
	      "Times-Bold": function() {
	        return fs.readFileSync(__dirname + "/../font/data/Times-Bold.afm", 'utf8');
	      },
	      "Times-Italic": function() {
	        return fs.readFileSync(__dirname + "/../font/data/Times-Italic.afm", 'utf8');
	      },
	      "Times-BoldItalic": function() {
	        return fs.readFileSync(__dirname + "/../font/data/Times-BoldItalic.afm", 'utf8');
	      },
	      "Symbol": function() {
	        return fs.readFileSync(__dirname + "/../font/data/Symbol.afm", 'utf8');
	      },
	      "ZapfDingbats": function() {
	        return fs.readFileSync(__dirname + "/../font/data/ZapfDingbats.afm", 'utf8');
	      }
	    };

	    return StandardFont;

	  })(PDFFont);

	  module.exports = StandardFont;

	}).call(this);

	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.12.6
	(function() {
	  var AFMFont, fs;

	  fs = __webpack_require__(56);

	  AFMFont = (function() {
	    var WIN_ANSI_MAP, characters;

	    AFMFont.open = function(filename) {
	      return new AFMFont(fs.readFileSync(filename, 'utf8'));
	    };

	    function AFMFont(contents) {
	      var e, i;
	      this.contents = contents;
	      this.attributes = {};
	      this.glyphWidths = {};
	      this.boundingBoxes = {};
	      this.kernPairs = {};
	      this.parse();
	      this.charWidths = (function() {
	        var j, results;
	        results = [];
	        for (i = j = 0; j <= 255; i = ++j) {
	          results.push(this.glyphWidths[characters[i]]);
	        }
	        return results;
	      }).call(this);
	      this.bbox = (function() {
	        var j, len, ref, results;
	        ref = this.attributes['FontBBox'].split(/\s+/);
	        results = [];
	        for (j = 0, len = ref.length; j < len; j++) {
	          e = ref[j];
	          results.push(+e);
	        }
	        return results;
	      }).call(this);
	      this.ascender = +(this.attributes['Ascender'] || 0);
	      this.descender = +(this.attributes['Descender'] || 0);
	      this.lineGap = (this.bbox[3] - this.bbox[1]) - (this.ascender - this.descender);
	    }

	    AFMFont.prototype.parse = function() {
	      var a, j, key, len, line, match, name, ref, section, value;
	      section = '';
	      ref = this.contents.split('\n');
	      for (j = 0, len = ref.length; j < len; j++) {
	        line = ref[j];
	        if (match = line.match(/^Start(\w+)/)) {
	          section = match[1];
	          continue;
	        } else if (match = line.match(/^End(\w+)/)) {
	          section = '';
	          continue;
	        }
	        switch (section) {
	          case 'FontMetrics':
	            match = line.match(/(^\w+)\s+(.*)/);
	            key = match[1];
	            value = match[2];
	            if (a = this.attributes[key]) {
	              if (!Array.isArray(a)) {
	                a = this.attributes[key] = [a];
	              }
	              a.push(value);
	            } else {
	              this.attributes[key] = value;
	            }
	            break;
	          case 'CharMetrics':
	            if (!/^CH?\s/.test(line)) {
	              continue;
	            }
	            name = line.match(/\bN\s+(\.?\w+)\s*;/)[1];
	            this.glyphWidths[name] = +line.match(/\bWX\s+(\d+)\s*;/)[1];
	            break;
	          case 'KernPairs':
	            match = line.match(/^KPX\s+(\.?\w+)\s+(\.?\w+)\s+(-?\d+)/);
	            if (match) {
	              this.kernPairs[match[1] + '\0' + match[2]] = parseInt(match[3]);
	            }
	        }
	      }
	    };

	    WIN_ANSI_MAP = {
	      402: 131,
	      8211: 150,
	      8212: 151,
	      8216: 145,
	      8217: 146,
	      8218: 130,
	      8220: 147,
	      8221: 148,
	      8222: 132,
	      8224: 134,
	      8225: 135,
	      8226: 149,
	      8230: 133,
	      8364: 128,
	      8240: 137,
	      8249: 139,
	      8250: 155,
	      710: 136,
	      8482: 153,
	      338: 140,
	      339: 156,
	      732: 152,
	      352: 138,
	      353: 154,
	      376: 159,
	      381: 142,
	      382: 158
	    };

	    AFMFont.prototype.encodeText = function(text) {
	      var char, i, j, ref, res;
	      res = [];
	      for (i = j = 0, ref = text.length; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        char = text.charCodeAt(i);
	        char = WIN_ANSI_MAP[char] || char;
	        res.push(char.toString(16));
	      }
	      return res;
	    };

	    AFMFont.prototype.glyphsForString = function(string) {
	      var charCode, glyphs, i, j, ref;
	      glyphs = [];
	      for (i = j = 0, ref = string.length; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        charCode = string.charCodeAt(i);
	        glyphs.push(this.characterToGlyph(charCode));
	      }
	      return glyphs;
	    };

	    AFMFont.prototype.characterToGlyph = function(character) {
	      return characters[WIN_ANSI_MAP[character] || character] || '.notdef';
	    };

	    AFMFont.prototype.widthOfGlyph = function(glyph) {
	      return this.glyphWidths[glyph] || 0;
	    };

	    AFMFont.prototype.getKernPair = function(left, right) {
	      return this.kernPairs[left + '\0' + right] || 0;
	    };

	    AFMFont.prototype.advancesForGlyphs = function(glyphs) {
	      var advances, index, j, left, len, right;
	      advances = [];
	      for (index = j = 0, len = glyphs.length; j < len; index = ++j) {
	        left = glyphs[index];
	        right = glyphs[index + 1];
	        advances.push(this.widthOfGlyph(left) + this.getKernPair(left, right));
	      }
	      return advances;
	    };

	    characters = '.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n\nspace         exclam         quotedbl       numbersign\ndollar        percent        ampersand      quotesingle\nparenleft     parenright     asterisk       plus\ncomma         hyphen         period         slash\nzero          one            two            three\nfour          five           six            seven\neight         nine           colon          semicolon\nless          equal          greater        question\n\nat            A              B              C\nD             E              F              G\nH             I              J              K\nL             M              N              O\nP             Q              R              S\nT             U              V              W\nX             Y              Z              bracketleft\nbackslash     bracketright   asciicircum    underscore\n\ngrave         a              b              c\nd             e              f              g\nh             i              j              k\nl             m              n              o\np             q              r              s\nt             u              v              w\nx             y              z              braceleft\nbar           braceright     asciitilde     .notdef\n\nEuro          .notdef        quotesinglbase florin\nquotedblbase  ellipsis       dagger         daggerdbl\ncircumflex    perthousand    Scaron         guilsinglleft\nOE            .notdef        Zcaron         .notdef\n.notdef       quoteleft      quoteright     quotedblleft\nquotedblright bullet         endash         emdash\ntilde         trademark      scaron         guilsinglright\noe            .notdef        zcaron         ydieresis\n\nspace         exclamdown     cent           sterling\ncurrency      yen            brokenbar      section\ndieresis      copyright      ordfeminine    guillemotleft\nlogicalnot    hyphen         registered     macron\ndegree        plusminus      twosuperior    threesuperior\nacute         mu             paragraph      periodcentered\ncedilla       onesuperior    ordmasculine   guillemotright\nonequarter    onehalf        threequarters  questiondown\n\nAgrave        Aacute         Acircumflex    Atilde\nAdieresis     Aring          AE             Ccedilla\nEgrave        Eacute         Ecircumflex    Edieresis\nIgrave        Iacute         Icircumflex    Idieresis\nEth           Ntilde         Ograve         Oacute\nOcircumflex   Otilde         Odieresis      multiply\nOslash        Ugrave         Uacute         Ucircumflex\nUdieresis     Yacute         Thorn          germandbls\n\nagrave        aacute         acircumflex    atilde\nadieresis     aring          ae             ccedilla\negrave        eacute         ecircumflex    edieresis\nigrave        iacute         icircumflex    idieresis\neth           ntilde         ograve         oacute\nocircumflex   otilde         odieresis      divide\noslash        ugrave         uacute         ucircumflex\nudieresis     yacute         thorn          ydieresis'.split(/\s+/);

	    return AFMFont;

	  })();

	  module.exports = AFMFont;

	}).call(this);


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.12.6
	(function() {
	  var EmbeddedFont, PDFFont, PDFObject,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty,
	    slice = [].slice;

	  PDFFont = __webpack_require__(82);

	  PDFObject = __webpack_require__(57);

	  EmbeddedFont = (function(superClass) {
	    var toHex;

	    extend(EmbeddedFont, superClass);

	    function EmbeddedFont(document, font, id) {
	      this.document = document;
	      this.font = font;
	      this.id = id;
	      this.subset = this.font.createSubset();
	      this.unicode = [[0]];
	      this.widths = [this.font.getGlyph(0).advanceWidth];
	      this.name = this.font.postscriptName;
	      this.scale = 1000 / this.font.unitsPerEm;
	      this.ascender = this.font.ascent * this.scale;
	      this.descender = this.font.descent * this.scale;
	      this.lineGap = this.font.lineGap * this.scale;
	      this.bbox = this.font.bbox;
	      this.layoutCache = Object.create(null);
	    }

	    EmbeddedFont.prototype.layoutRun = function(text, features) {
	      var i, j, key, len, position, ref, run;
	      run = this.font.layout(text, features);
	      ref = run.positions;
	      for (i = j = 0, len = ref.length; j < len; i = ++j) {
	        position = ref[i];
	        for (key in position) {
	          position[key] *= this.scale;
	        }
	        position.advanceWidth = run.glyphs[i].advanceWidth * this.scale;
	      }
	      return run;
	    };

	    EmbeddedFont.prototype.layoutCached = function(text) {
	      var cached, run;
	      if (cached = this.layoutCache[text]) {
	        return cached;
	      }
	      run = this.layoutRun(text);
	      this.layoutCache[text] = run;
	      return run;
	    };

	    EmbeddedFont.prototype.layout = function(text, features, onlyWidth) {
	      var advanceWidth, glyphs, index, last, positions, ref, run;
	      if (onlyWidth == null) {
	        onlyWidth = false;
	      }
	      if (features) {
	        return this.layoutRun(text, features);
	      }
	      glyphs = onlyWidth ? null : [];
	      positions = onlyWidth ? null : [];
	      advanceWidth = 0;
	      last = 0;
	      index = 0;
	      while (index <= text.length) {
	        if ((index === text.length && last < index) || ((ref = text.charAt(index)) === ' ' || ref === '\t')) {
	          run = this.layoutCached(text.slice(last, ++index));
	          if (!onlyWidth) {
	            glyphs.push.apply(glyphs, run.glyphs);
	            positions.push.apply(positions, run.positions);
	          }
	          advanceWidth += run.advanceWidth;
	          last = index;
	        } else {
	          index++;
	        }
	      }
	      return {
	        glyphs: glyphs,
	        positions: positions,
	        advanceWidth: advanceWidth
	      };
	    };

	    EmbeddedFont.prototype.encode = function(text, features) {
	      var base, base1, gid, glyph, glyphs, i, j, len, positions, ref, res;
	      ref = this.layout(text, features), glyphs = ref.glyphs, positions = ref.positions;
	      res = [];
	      for (i = j = 0, len = glyphs.length; j < len; i = ++j) {
	        glyph = glyphs[i];
	        gid = this.subset.includeGlyph(glyph.id);
	        res.push(('0000' + gid.toString(16)).slice(-4));
	        if ((base = this.widths)[gid] == null) {
	          base[gid] = glyph.advanceWidth * this.scale;
	        }
	        if ((base1 = this.unicode)[gid] == null) {
	          base1[gid] = glyph.codePoints;
	        }
	      }
	      return [res, positions];
	    };

	    EmbeddedFont.prototype.widthOfString = function(string, size, features) {
	      var scale, width;
	      width = this.layout(string, features, true).advanceWidth;
	      scale = size / 1000;
	      return width * scale;
	    };

	    EmbeddedFont.prototype.embed = function() {
	      var bbox, descendantFont, descriptor, familyClass, flags, fontFile, i, isCFF, name, ref, tag;
	      isCFF = this.subset.cff != null;
	      fontFile = this.document.ref();
	      if (isCFF) {
	        fontFile.data.Subtype = 'CIDFontType0C';
	      }
	      this.subset.encodeStream().pipe(fontFile);
	      familyClass = (((ref = this.font['OS/2']) != null ? ref.sFamilyClass : void 0) || 0) >> 8;
	      flags = 0;
	      if (this.font.post.isFixedPitch) {
	        flags |= 1 << 0;
	      }
	      if ((1 <= familyClass && familyClass <= 7)) {
	        flags |= 1 << 1;
	      }
	      flags |= 1 << 2;
	      if (familyClass === 10) {
	        flags |= 1 << 3;
	      }
	      if (this.font.head.macStyle.italic) {
	        flags |= 1 << 6;
	      }
	      tag = ((function() {
	        var j, results;
	        results = [];
	        for (i = j = 0; j < 6; i = ++j) {
	          results.push(String.fromCharCode(Math.random() * 26 + 65));
	        }
	        return results;
	      })()).join('');
	      name = tag + '+' + this.font.postscriptName;
	      bbox = this.font.bbox;
	      descriptor = this.document.ref({
	        Type: 'FontDescriptor',
	        FontName: name,
	        Flags: flags,
	        FontBBox: [bbox.minX * this.scale, bbox.minY * this.scale, bbox.maxX * this.scale, bbox.maxY * this.scale],
	        ItalicAngle: this.font.italicAngle,
	        Ascent: this.ascender,
	        Descent: this.descender,
	        CapHeight: (this.font.capHeight || this.font.ascent) * this.scale,
	        XHeight: (this.font.xHeight || 0) * this.scale,
	        StemV: 0
	      });
	      if (isCFF) {
	        descriptor.data.FontFile3 = fontFile;
	      } else {
	        descriptor.data.FontFile2 = fontFile;
	      }
	      descriptor.end();
	      descendantFont = this.document.ref({
	        Type: 'Font',
	        Subtype: isCFF ? 'CIDFontType0' : 'CIDFontType2',
	        BaseFont: name,
	        CIDSystemInfo: {
	          Registry: new String('Adobe'),
	          Ordering: new String('Identity'),
	          Supplement: 0
	        },
	        FontDescriptor: descriptor,
	        W: [0, this.widths]
	      });
	      descendantFont.end();
	      this.dictionary.data = {
	        Type: 'Font',
	        Subtype: 'Type0',
	        BaseFont: name,
	        Encoding: 'Identity-H',
	        DescendantFonts: [descendantFont],
	        ToUnicode: this.toUnicodeCmap()
	      };
	      return this.dictionary.end();
	    };

	    toHex = function() {
	      var code, codePoints, codes;
	      codePoints = 1 <= arguments.length ? slice.call(arguments, 0) : [];
	      codes = (function() {
	        var j, len, results;
	        results = [];
	        for (j = 0, len = codePoints.length; j < len; j++) {
	          code = codePoints[j];
	          results.push(('0000' + code.toString(16)).slice(-4));
	        }
	        return results;
	      })();
	      return codes.join('');
	    };

	    EmbeddedFont.prototype.toUnicodeCmap = function() {
	      var cmap, codePoints, encoded, entries, j, k, len, len1, ref, value;
	      cmap = this.document.ref();
	      entries = [];
	      ref = this.unicode;
	      for (j = 0, len = ref.length; j < len; j++) {
	        codePoints = ref[j];
	        encoded = [];
	        for (k = 0, len1 = codePoints.length; k < len1; k++) {
	          value = codePoints[k];
	          if (value > 0xffff) {
	            value -= 0x10000;
	            encoded.push(toHex(value >>> 10 & 0x3ff | 0xd800));
	            value = 0xdc00 | value & 0x3ff;
	          }
	          encoded.push(toHex(value));
	        }
	        entries.push("<" + (encoded.join(' ')) + ">");
	      }
	      cmap.end("/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange\n1 beginbfrange\n<0000> <" + (toHex(entries.length - 1)) + "> [" + (entries.join(' ')) + "]\nendbfrange\nendcmap\nCMapName currentdict /CMap defineresource pop\nend\nend");
	      return cmap;
	    };

	    return EmbeddedFont;

	  })(PDFFont);

	  module.exports = EmbeddedFont;

	}).call(this);


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.12.6
	(function() {
	  var LineWrapper, number;

	  LineWrapper = __webpack_require__(295);

	  number = __webpack_require__(57).number;

	  module.exports = {
	    initText: function() {
	      this.x = 0;
	      this.y = 0;
	      return this._lineGap = 0;
	    },
	    lineGap: function(_lineGap) {
	      this._lineGap = _lineGap;
	      return this;
	    },
	    moveDown: function(lines) {
	      if (lines == null) {
	        lines = 1;
	      }
	      this.y += this.currentLineHeight(true) * lines + this._lineGap;
	      return this;
	    },
	    moveUp: function(lines) {
	      if (lines == null) {
	        lines = 1;
	      }
	      this.y -= this.currentLineHeight(true) * lines + this._lineGap;
	      return this;
	    },
	    _text: function(text, x, y, options, lineCallback) {
	      var j, len, line, ref, wrapper;
	      options = this._initOptions(x, y, options);
	      text = text == null ? '' : '' + text;
	      if (options.wordSpacing) {
	        text = text.replace(/\s{2,}/g, ' ');
	      }
	      if (options.width) {
	        wrapper = this._wrapper;
	        if (!wrapper) {
	          wrapper = new LineWrapper(this, options);
	          wrapper.on('line', lineCallback);
	        }
	        this._wrapper = options.continued ? wrapper : null;
	        this._textOptions = options.continued ? options : null;
	        wrapper.wrap(text, options);
	      } else {
	        ref = text.split('\n');
	        for (j = 0, len = ref.length; j < len; j++) {
	          line = ref[j];
	          lineCallback(line, options);
	        }
	      }
	      return this;
	    },
	    text: function(text, x, y, options) {
	      return this._text(text, x, y, options, this._line.bind(this));
	    },
	    widthOfString: function(string, options) {
	      if (options == null) {
	        options = {};
	      }
	      return this._font.widthOfString(string, this._fontSize, options.features) + (options.characterSpacing || 0) * (string.length - 1);
	    },
	    heightOfString: function(text, options) {
	      var height, lineGap, ref, x, y;
	      if (options == null) {
	        options = {};
	      }
	      ref = this, x = ref.x, y = ref.y;
	      options = this._initOptions(options);
	      options.height = 2e308;
	      lineGap = options.lineGap || this._lineGap || 0;
	      this._text(text, this.x, this.y, options, (function(_this) {
	        return function(line, options) {
	          return _this.y += _this.currentLineHeight(true) + lineGap;
	        };
	      })(this));
	      height = this.y - y;
	      this.x = x;
	      this.y = y;
	      return height;
	    },
	    list: function(list, x, y, options, wrapper) {
	      var flatten, i, indent, itemIndent, items, level, levels, midLine, r;
	      options = this._initOptions(x, y, options);
	      midLine = Math.round((this._font.ascender / 1000 * this._fontSize) / 2);
	      r = options.bulletRadius || Math.round((this._font.ascender / 1000 * this._fontSize) / 3);
	      indent = options.textIndent || r * 5;
	      itemIndent = options.bulletIndent || r * 8;
	      level = 1;
	      items = [];
	      levels = [];
	      flatten = function(list) {
	        var i, item, j, len, results;
	        results = [];
	        for (i = j = 0, len = list.length; j < len; i = ++j) {
	          item = list[i];
	          if (Array.isArray(item)) {
	            level++;
	            flatten(item);
	            results.push(level--);
	          } else {
	            items.push(item);
	            results.push(levels.push(level));
	          }
	        }
	        return results;
	      };
	      flatten(list);
	      wrapper = new LineWrapper(this, options);
	      wrapper.on('line', this._line.bind(this));
	      level = 1;
	      i = 0;
	      wrapper.on('firstLine', (function(_this) {
	        return function() {
	          var diff, l;
	          if ((l = levels[i++]) !== level) {
	            diff = itemIndent * (l - level);
	            _this.x += diff;
	            wrapper.lineWidth -= diff;
	            level = l;
	          }
	          _this.circle(_this.x - indent + r, _this.y + midLine, r);
	          return _this.fill();
	        };
	      })(this));
	      wrapper.on('sectionStart', (function(_this) {
	        return function() {
	          var pos;
	          pos = indent + itemIndent * (level - 1);
	          _this.x += pos;
	          return wrapper.lineWidth -= pos;
	        };
	      })(this));
	      wrapper.on('sectionEnd', (function(_this) {
	        return function() {
	          var pos;
	          pos = indent + itemIndent * (level - 1);
	          _this.x -= pos;
	          return wrapper.lineWidth += pos;
	        };
	      })(this));
	      wrapper.wrap(items.join('\n'), options);
	      return this;
	    },
	    _initOptions: function(x, y, options) {
	      var key, ref, val;
	      if (x == null) {
	        x = {};
	      }
	      if (options == null) {
	        options = {};
	      }
	      if (typeof x === 'object') {
	        options = x;
	        x = null;
	      }
	      options = (function() {
	        var k, opts, v;
	        opts = {};
	        for (k in options) {
	          v = options[k];
	          opts[k] = v;
	        }
	        return opts;
	      })();
	      if (this._textOptions) {
	        ref = this._textOptions;
	        for (key in ref) {
	          val = ref[key];
	          if (key !== 'continued') {
	            if (options[key] == null) {
	              options[key] = val;
	            }
	          }
	        }
	      }
	      if (x != null) {
	        this.x = x;
	      }
	      if (y != null) {
	        this.y = y;
	      }
	      if (options.lineBreak !== false) {
	        if (options.width == null) {
	          options.width = this.page.width - this.x - this.page.margins.right;
	        }
	      }
	      options.columns || (options.columns = 0);
	      if (options.columnGap == null) {
	        options.columnGap = 18;
	      }
	      return options;
	    },
	    _line: function(text, options, wrapper) {
	      var lineGap;
	      if (options == null) {
	        options = {};
	      }
	      this._fragment(text, this.x, this.y, options);
	      lineGap = options.lineGap || this._lineGap || 0;
	      if (!wrapper) {
	        return this.x += this.widthOfString(text);
	      } else {
	        return this.y += this.currentLineHeight(true) + lineGap;
	      }
	    },
	    _fragment: function(text, x, y, options) {
	      var addSegment, align, base, characterSpacing, commands, d, encoded, encodedWord, flush, hadOffset, i, j, key, last, len, len1, lineWidth, lineY, m, mode, name, pos, positions, positionsWord, ref, ref1, ref2, renderedWidth, scale, space, spaceWidth, textWidth, val, word, wordSpacing, words;
	      text = ('' + text).replace(/\n/g, '');
	      if (text.length === 0) {
	        return;
	      }
	      align = options.align || 'left';
	      wordSpacing = options.wordSpacing || 0;
	      characterSpacing = options.characterSpacing || 0;
	      if (options.width) {
	        switch (align) {
	          case 'right':
	            textWidth = this.widthOfString(text.replace(/\s+$/, ''), options);
	            x += options.lineWidth - textWidth;
	            break;
	          case 'center':
	            x += options.lineWidth / 2 - options.textWidth / 2;
	            break;
	          case 'justify':
	            words = text.trim().split(/\s+/);
	            textWidth = this.widthOfString(text.replace(/\s+/g, ''), options);
	            spaceWidth = this.widthOfString(' ') + characterSpacing;
	            wordSpacing = Math.max(0, (options.lineWidth - textWidth) / Math.max(1, words.length - 1) - spaceWidth);
	        }
	      }
	      renderedWidth = options.textWidth + (wordSpacing * (options.wordCount - 1)) + (characterSpacing * (text.length - 1));
	      if (options.link) {
	        this.link(x, y, renderedWidth, this.currentLineHeight(), options.link);
	      }
	      if (options.underline || options.strike) {
	        this.save();
	        if (!options.stroke) {
	          this.strokeColor.apply(this, this._fillColor);
	        }
	        lineWidth = this._fontSize < 10 ? 0.5 : Math.floor(this._fontSize / 10);
	        this.lineWidth(lineWidth);
	        d = options.underline ? 1 : 2;
	        lineY = y + this.currentLineHeight() / d;
	        if (options.underline) {
	          lineY -= lineWidth;
	        }
	        this.moveTo(x, lineY);
	        this.lineTo(x + renderedWidth, lineY);
	        this.stroke();
	        this.restore();
	      }
	      this.save();
	      this.transform(1, 0, 0, -1, 0, this.page.height);
	      y = this.page.height - y - (this._font.ascender / 1000 * this._fontSize);
	      if ((base = this.page.fonts)[name = this._font.id] == null) {
	        base[name] = this._font.ref();
	      }
	      this.addContent("BT");
	      this.addContent("1 0 0 1 " + (number(x)) + " " + (number(y)) + " Tm");
	      this.addContent("/" + this._font.id + " " + (number(this._fontSize)) + " Tf");
	      mode = options.fill && options.stroke ? 2 : options.stroke ? 1 : 0;
	      if (mode) {
	        this.addContent(mode + " Tr");
	      }
	      if (characterSpacing) {
	        this.addContent((number(characterSpacing)) + " Tc");
	      }
	      if (wordSpacing) {
	        words = text.trim().split(/\s+/);
	        wordSpacing += this.widthOfString(' ') + characterSpacing;
	        wordSpacing *= 1000 / this._fontSize;
	        encoded = [];
	        positions = [];
	        for (j = 0, len = words.length; j < len; j++) {
	          word = words[j];
	          ref = this._font.encode(word, options.features), encodedWord = ref[0], positionsWord = ref[1];
	          encoded.push.apply(encoded, encodedWord);
	          positions.push.apply(positions, positionsWord);
	          space = {};
	          ref1 = positions[positions.length - 1];
	          for (key in ref1) {
	            val = ref1[key];
	            space[key] = val;
	          }
	          space.xAdvance += wordSpacing;
	          positions[positions.length - 1] = space;
	        }
	      } else {
	        ref2 = this._font.encode(text, options.features), encoded = ref2[0], positions = ref2[1];
	      }
	      scale = this._fontSize / 1000;
	      commands = [];
	      last = 0;
	      hadOffset = false;
	      addSegment = (function(_this) {
	        return function(cur) {
	          var advance, hex;
	          if (last < cur) {
	            hex = encoded.slice(last, cur).join('');
	            advance = positions[cur - 1].xAdvance - positions[cur - 1].advanceWidth;
	            commands.push("<" + hex + "> " + (number(-advance)));
	          }
	          return last = cur;
	        };
	      })(this);
	      flush = (function(_this) {
	        return function(i) {
	          addSegment(i);
	          if (commands.length > 0) {
	            _this.addContent("[" + (commands.join(' ')) + "] TJ");
	            return commands.length = 0;
	          }
	        };
	      })(this);
	      for (i = m = 0, len1 = positions.length; m < len1; i = ++m) {
	        pos = positions[i];
	        if (pos.xOffset || pos.yOffset) {
	          flush(i);
	          this.addContent("1 0 0 1 " + (number(x + pos.xOffset * scale)) + " " + (number(y + pos.yOffset * scale)) + " Tm");
	          flush(i + 1);
	          hadOffset = true;
	        } else {
	          if (hadOffset) {
	            this.addContent("1 0 0 1 " + (number(x)) + " " + (number(y)) + " Tm");
	            hadOffset = false;
	          }
	          if (pos.xAdvance - pos.advanceWidth !== 0) {
	            addSegment(i + 1);
	          }
	        }
	        x += pos.xAdvance * scale;
	      }
	      flush(i);
	      this.addContent("ET");
	      return this.restore();
	    }
	  };

	}).call(this);


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.12.6
	(function() {
	  var EventEmitter, LineBreaker, LineWrapper,
	    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    hasProp = {}.hasOwnProperty;

	  EventEmitter = __webpack_require__(32).EventEmitter;

	  LineBreaker = __webpack_require__(16);

	  LineWrapper = (function(superClass) {
	    extend(LineWrapper, superClass);

	    function LineWrapper(document, options) {
	      var ref;
	      this.document = document;
	      this.indent = options.indent || 0;
	      this.characterSpacing = options.characterSpacing || 0;
	      this.wordSpacing = options.wordSpacing === 0;
	      this.columns = options.columns || 1;
	      this.columnGap = (ref = options.columnGap) != null ? ref : 18;
	      this.lineWidth = (options.width - (this.columnGap * (this.columns - 1))) / this.columns;
	      this.spaceLeft = this.lineWidth;
	      this.startX = this.document.x;
	      this.startY = this.document.y;
	      this.column = 1;
	      this.ellipsis = options.ellipsis;
	      this.continuedX = 0;
	      this.features = options.features;
	      if (options.height != null) {
	        this.height = options.height;
	        this.maxY = this.startY + options.height;
	      } else {
	        this.maxY = this.document.page.maxY();
	      }
	      this.on('firstLine', (function(_this) {
	        return function(options) {
	          var indent;
	          indent = _this.continuedX || _this.indent;
	          _this.document.x += indent;
	          _this.lineWidth -= indent;
	          return _this.once('line', function() {
	            _this.document.x -= indent;
	            _this.lineWidth += indent;
	            if (options.continued && !_this.continuedX) {
	              _this.continuedX = _this.indent;
	            }
	            if (!options.continued) {
	              return _this.continuedX = 0;
	            }
	          });
	        };
	      })(this));
	      this.on('lastLine', (function(_this) {
	        return function(options) {
	          var align;
	          align = options.align;
	          if (align === 'justify') {
	            options.align = 'left';
	          }
	          _this.lastLine = true;
	          return _this.once('line', function() {
	            _this.document.y += options.paragraphGap || 0;
	            options.align = align;
	            return _this.lastLine = false;
	          });
	        };
	      })(this));
	    }

	    LineWrapper.prototype.wordWidth = function(word) {
	      return this.document.widthOfString(word, this) + this.characterSpacing + this.wordSpacing;
	    };

	    LineWrapper.prototype.eachWord = function(text, fn) {
	      var bk, breaker, fbk, l, last, lbk, shouldContinue, w, word, wordWidths;
	      breaker = new LineBreaker(text);
	      last = null;
	      wordWidths = Object.create(null);
	      while (bk = breaker.nextBreak()) {
	        word = text.slice((last != null ? last.position : void 0) || 0, bk.position);
	        w = wordWidths[word] != null ? wordWidths[word] : wordWidths[word] = this.wordWidth(word);
	        if (w > this.lineWidth + this.continuedX) {
	          lbk = last;
	          fbk = {};
	          while (word.length) {
	            l = word.length;
	            while (w > this.spaceLeft) {
	              w = this.wordWidth(word.slice(0, --l));
	            }
	            fbk.required = l < word.length;
	            shouldContinue = fn(word.slice(0, l), w, fbk, lbk);
	            lbk = {
	              required: false
	            };
	            word = word.slice(l);
	            w = this.wordWidth(word);
	            if (shouldContinue === false) {
	              break;
	            }
	          }
	        } else {
	          shouldContinue = fn(word, w, bk, last);
	        }
	        if (shouldContinue === false) {
	          break;
	        }
	        last = bk;
	      }
	    };

	    LineWrapper.prototype.wrap = function(text, options) {
	      var buffer, emitLine, lc, nextY, textWidth, wc, y;
	      if (options.indent != null) {
	        this.indent = options.indent;
	      }
	      if (options.characterSpacing != null) {
	        this.characterSpacing = options.characterSpacing;
	      }
	      if (options.wordSpacing != null) {
	        this.wordSpacing = options.wordSpacing;
	      }
	      if (options.ellipsis != null) {
	        this.ellipsis = options.ellipsis;
	      }
	      nextY = this.document.y + this.document.currentLineHeight(true);
	      if (this.document.y > this.maxY || nextY > this.maxY) {
	        this.nextSection();
	      }
	      buffer = '';
	      textWidth = 0;
	      wc = 0;
	      lc = 0;
	      y = this.document.y;
	      emitLine = (function(_this) {
	        return function() {
	          options.textWidth = textWidth + _this.wordSpacing * (wc - 1);
	          options.wordCount = wc;
	          options.lineWidth = _this.lineWidth;
	          y = _this.document.y;
	          _this.emit('line', buffer, options, _this);
	          return lc++;
	        };
	      })(this);
	      this.emit('sectionStart', options, this);
	      this.eachWord(text, (function(_this) {
	        return function(word, w, bk, last) {
	          var lh, shouldContinue;
	          if ((last == null) || last.required) {
	            _this.emit('firstLine', options, _this);
	            _this.spaceLeft = _this.lineWidth;
	          }
	          if (w <= _this.spaceLeft) {
	            buffer += word;
	            textWidth += w;
	            wc++;
	          }
	          if (bk.required || w > _this.spaceLeft) {
	            if (bk.required) {
	              _this.emit('lastLine', options, _this);
	            }
	            lh = _this.document.currentLineHeight(true);
	            if ((_this.height != null) && _this.ellipsis && _this.document.y + lh * 2 > _this.maxY && _this.column >= _this.columns) {
	              if (_this.ellipsis === true) {
	                _this.ellipsis = '…';
	              }
	              buffer = buffer.replace(/\s+$/, '');
	              textWidth = _this.wordWidth(buffer + _this.ellipsis);
	              while (textWidth > _this.lineWidth) {
	                buffer = buffer.slice(0, -1).replace(/\s+$/, '');
	                textWidth = _this.wordWidth(buffer + _this.ellipsis);
	              }
	              buffer = buffer + _this.ellipsis;
	            }
	            if (bk.required && w > _this.spaceLeft) {
	              buffer = word;
	              textWidth = w;
	              wc = 1;
	            }
	            emitLine();
	            if (_this.document.y + lh > _this.maxY) {
	              shouldContinue = _this.nextSection();
	              if (!shouldContinue) {
	                wc = 0;
	                buffer = '';
	                return false;
	              }
	            }
	            if (bk.required) {
	              _this.spaceLeft = _this.lineWidth;
	              buffer = '';
	              textWidth = 0;
	              return wc = 0;
	            } else {
	              _this.spaceLeft = _this.lineWidth - w;
	              buffer = word;
	              textWidth = w;
	              return wc = 1;
	            }
	          } else {
	            return _this.spaceLeft -= w;
	          }
	        };
	      })(this));
	      if (wc > 0) {
	        this.emit('lastLine', options, this);
	        emitLine();
	      }
	      this.emit('sectionEnd', options, this);
	      if (options.continued === true) {
	        if (lc > 1) {
	          this.continuedX = 0;
	        }
	        this.continuedX += options.textWidth;
	        return this.document.y = y;
	      } else {
	        return this.document.x = this.startX;
	      }
	    };

	    LineWrapper.prototype.nextSection = function(options) {
	      var ref;
	      this.emit('sectionEnd', options, this);
	      if (++this.column > this.columns) {
	        if (this.height != null) {
	          return false;
	        }
	        this.document.addPage();
	        this.column = 1;
	        this.startY = this.document.page.margins.top;
	        this.maxY = this.document.page.maxY();
	        this.document.x = this.startX;
	        if (this.document._fillColor) {
	          (ref = this.document).fillColor.apply(ref, this.document._fillColor);
	        }
	        this.emit('pageBreak', options, this);
	      } else {
	        this.document.x += this.lineWidth + this.columnGap;
	        this.document.y = this.startY;
	        this.emit('columnBreak', options, this);
	      }
	      this.emit('sectionStart', options, this);
	      return true;
	    };

	    return LineWrapper;

	  })(EventEmitter);

	  module.exports = LineWrapper;

	}).call(this);


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.12.6
	(function() {
	  var PDFImage;

	  PDFImage = __webpack_require__(297);

	  module.exports = {
	    initImages: function() {
	      this._imageRegistry = {};
	      return this._imageCount = 0;
	    },
	    image: function(src, x, y, options) {
	      var base, bh, bp, bw, h, hp, image, ip, name, ref, ref1, ref2, ref3, w, wp;
	      if (options == null) {
	        options = {};
	      }
	      if (typeof x === 'object') {
	        options = x;
	        x = null;
	      }
	      x = (ref = x != null ? x : options.x) != null ? ref : this.x;
	      y = (ref1 = y != null ? y : options.y) != null ? ref1 : this.y;
	      if (typeof src === 'string') {
	        image = this._imageRegistry[src];
	      }
	      if (!image) {
	        if (src.width && src.height) {
	          image = src;
	        } else {
	          image = this.openImage(src);
	        }
	      }
	      if (!image.obj) {
	        image.embed(this);
	      }
	      if ((base = this.page.xobjects)[name = image.label] == null) {
	        base[name] = image.obj;
	      }
	      w = options.width || image.width;
	      h = options.height || image.height;
	      if (options.width && !options.height) {
	        wp = w / image.width;
	        w = image.width * wp;
	        h = image.height * wp;
	      } else if (options.height && !options.width) {
	        hp = h / image.height;
	        w = image.width * hp;
	        h = image.height * hp;
	      } else if (options.scale) {
	        w = image.width * options.scale;
	        h = image.height * options.scale;
	      } else if (options.fit) {
	        ref2 = options.fit, bw = ref2[0], bh = ref2[1];
	        bp = bw / bh;
	        ip = image.width / image.height;
	        if (ip > bp) {
	          w = bw;
	          h = bw / ip;
	        } else {
	          h = bh;
	          w = bh * ip;
	        }
	      } else if (options.cover) {
	        ref3 = options.cover, bw = ref3[0], bh = ref3[1];
	        bp = bw / bh;
	        ip = image.width / image.height;
	        if (ip > bp) {
	          h = bh;
	          w = bh * ip;
	        } else {
	          w = bw;
	          h = bw / ip;
	        }
	      }
	      if (options.fit || options.cover) {
	        if (options.align === 'center') {
	          x = x + bw / 2 - w / 2;
	        } else if (options.align === 'right') {
	          x = x + bw - w;
	        }
	        if (options.valign === 'center') {
	          y = y + bh / 2 - h / 2;
	        } else if (options.valign === 'bottom') {
	          y = y + bh - h;
	        }
	      }
	      if (this.y === y) {
	        this.y += h;
	      }
	      this.save();
	      this.transform(w, 0, 0, -h, x, y + h);
	      this.addContent("/" + image.label + " Do");
	      this.restore();
	      return this;
	    },
	    openImage: function(src) {
	      var image;
	      if (typeof src === 'string') {
	        image = this._imageRegistry[src];
	      }
	      if (!image) {
	        image = PDFImage.open(src, 'I' + (++this._imageCount));
	        if (typeof src === 'string') {
	          this._imageRegistry[src] = image;
	        }
	      }
	      return image;
	    }
	  };

	}).call(this);


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Generated by CoffeeScript 1.12.6

	/*
	PDFImage - embeds images in PDF documents
	By Devon Govett
	 */

	(function() {
	  var Data, JPEG, PDFImage, PNG, fs;

	  fs = __webpack_require__(56);

	  Data = __webpack_require__(298);

	  JPEG = __webpack_require__(299);

	  PNG = __webpack_require__(300);

	  PDFImage = (function() {
	    function PDFImage() {}

	    PDFImage.open = function(src, label) {
	      var data, match;
	      if (Buffer.isBuffer(src)) {
	        data = src;
	      } else if (src instanceof ArrayBuffer) {
	        data = new Buffer(new Uint8Array(src));
	      } else {
	        if (match = /^data:.+;base64,(.*)$/.exec(src)) {
	          data = new Buffer(match[1], 'base64');
	        } else {
	          data = fs.readFileSync(src);
	          if (!data) {
	            return;
	          }
	        }
	      }
	      if (data[0] === 0xff && data[1] === 0xd8) {
	        return new JPEG(data, label);
	      } else if (data[0] === 0x89 && data.toString('ascii', 1, 4) === 'PNG') {
	        return new PNG(data, label);
	      } else {
	        throw new Error('Unknown image format.');
	      }
	    };

	    return PDFImage;

	  })();

	  module.exports = PDFImage;

	}).call(this);

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ }),
/* 298 */
/***/ (function(module, exports) {

	// Generated by CoffeeScript 1.12.6
	(function() {
	  var Data;

	  Data = (function() {
	    function Data(data) {
	      this.data = data != null ? data : [];
	      this.pos = 0;
	      this.length = this.data.length;
	    }

	    Data.prototype.readByte = function() {
	      return this.data[this.pos++];
	    };

	    Data.prototype.writeByte = function(byte) {
	      return this.data[this.pos++] = byte;
	    };

	    Data.prototype.byteAt = function(index) {
	      return this.data[index];
	    };

	    Data.prototype.readBool = function() {
	      return !!this.readByte();
	    };

	    Data.prototype.writeBool = function(val) {
	      return this.writeByte(val ? 1 : 0);
	    };

	    Data.prototype.readUInt32 = function() {
	      var b1, b2, b3, b4;
	      b1 = this.readByte() * 0x1000000;
	      b2 = this.readByte() << 16;
	      b3 = this.readByte() << 8;
	      b4 = this.readByte();
	      return b1 + b2 + b3 + b4;
	    };

	    Data.prototype.writeUInt32 = function(val) {
	      this.writeByte((val >>> 24) & 0xff);
	      this.writeByte((val >> 16) & 0xff);
	      this.writeByte((val >> 8) & 0xff);
	      return this.writeByte(val & 0xff);
	    };

	    Data.prototype.readInt32 = function() {
	      var int;
	      int = this.readUInt32();
	      if (int >= 0x80000000) {
	        return int - 0x100000000;
	      } else {
	        return int;
	      }
	    };

	    Data.prototype.writeInt32 = function(val) {
	      if (val < 0) {
	        val += 0x100000000;
	      }
	      return this.writeUInt32(val);
	    };

	    Data.prototype.readUInt16 = function() {
	      var b1, b2;
	      b1 = this.readByte() << 8;
	      b2 = this.readByte();
	      return b1 | b2;
	    };

	    Data.prototype.writeUInt16 = function(val) {
	      this.writeByte((val >> 8) & 0xff);
	      return this.writeByte(val & 0xff);
	    };

	    Data.prototype.readInt16 = function() {
	      var int;
	      int = this.readUInt16();
	      if (int >= 0x8000) {
	        return int - 0x10000;
	      } else {
	        return int;
	      }
	    };

	    Data.prototype.writeInt16 = function(val) {
	      if (val < 0) {
	        val += 0x10000;
	      }
	      return this.writeUInt16(val);
	    };

	    Data.prototype.readString = function(length) {
	      var i, j, ref, ret;
	      ret = [];
	      for (i = j = 0, ref = length; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        ret[i] = String.fromCharCode(this.readByte());
	      }
	      return ret.join('');
	    };

	    Data.prototype.writeString = function(val) {
	      var i, j, ref, results;
	      results = [];
	      for (i = j = 0, ref = val.length; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        results.push(this.writeByte(val.charCodeAt(i)));
	      }
	      return results;
	    };

	    Data.prototype.stringAt = function(pos, length) {
	      this.pos = pos;
	      return this.readString(length);
	    };

	    Data.prototype.readShort = function() {
	      return this.readInt16();
	    };

	    Data.prototype.writeShort = function(val) {
	      return this.writeInt16(val);
	    };

	    Data.prototype.readLongLong = function() {
	      var b1, b2, b3, b4, b5, b6, b7, b8;
	      b1 = this.readByte();
	      b2 = this.readByte();
	      b3 = this.readByte();
	      b4 = this.readByte();
	      b5 = this.readByte();
	      b6 = this.readByte();
	      b7 = this.readByte();
	      b8 = this.readByte();
	      if (b1 & 0x80) {
	        return ((b1 ^ 0xff) * 0x100000000000000 + (b2 ^ 0xff) * 0x1000000000000 + (b3 ^ 0xff) * 0x10000000000 + (b4 ^ 0xff) * 0x100000000 + (b5 ^ 0xff) * 0x1000000 + (b6 ^ 0xff) * 0x10000 + (b7 ^ 0xff) * 0x100 + (b8 ^ 0xff) + 1) * -1;
	      }
	      return b1 * 0x100000000000000 + b2 * 0x1000000000000 + b3 * 0x10000000000 + b4 * 0x100000000 + b5 * 0x1000000 + b6 * 0x10000 + b7 * 0x100 + b8;
	    };

	    Data.prototype.writeLongLong = function(val) {
	      var high, low;
	      high = Math.floor(val / 0x100000000);
	      low = val & 0xffffffff;
	      this.writeByte((high >> 24) & 0xff);
	      this.writeByte((high >> 16) & 0xff);
	      this.writeByte((high >> 8) & 0xff);
	      this.writeByte(high & 0xff);
	      this.writeByte((low >> 24) & 0xff);
	      this.writeByte((low >> 16) & 0xff);
	      this.writeByte((low >> 8) & 0xff);
	      return this.writeByte(low & 0xff);
	    };

	    Data.prototype.readInt = function() {
	      return this.readInt32();
	    };

	    Data.prototype.writeInt = function(val) {
	      return this.writeInt32(val);
	    };

	    Data.prototype.slice = function(start, end) {
	      return this.data.slice(start, end);
	    };

	    Data.prototype.read = function(bytes) {
	      var buf, i, j, ref;
	      buf = [];
	      for (i = j = 0, ref = bytes; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	        buf.push(this.readByte());
	      }
	      return buf;
	    };

	    Data.prototype.write = function(bytes) {
	      var byte, j, len, results;
	      results = [];
	      for (j = 0, len = bytes.length; j < len; j++) {
	        byte = bytes[j];
	        results.push(this.writeByte(byte));
	      }
	      return results;
	    };

	    return Data;

	  })();

	  module.exports = Data;

	}).call(this);


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.12.6
	(function() {
	  var JPEG, fs,
	    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

	  fs = __webpack_require__(56);

	  JPEG = (function() {
	    var MARKERS;

	    MARKERS = [0xFFC0, 0xFFC1, 0xFFC2, 0xFFC3, 0xFFC5, 0xFFC6, 0xFFC7, 0xFFC8, 0xFFC9, 0xFFCA, 0xFFCB, 0xFFCC, 0xFFCD, 0xFFCE, 0xFFCF];

	    function JPEG(data, label) {
	      var channels, marker, pos;
	      this.data = data;
	      this.label = label;
	      if (this.data.readUInt16BE(0) !== 0xFFD8) {
	        throw "SOI not found in JPEG";
	      }
	      pos = 2;
	      while (pos < this.data.length) {
	        marker = this.data.readUInt16BE(pos);
	        pos += 2;
	        if (indexOf.call(MARKERS, marker) >= 0) {
	          break;
	        }
	        pos += this.data.readUInt16BE(pos);
	      }
	      if (indexOf.call(MARKERS, marker) < 0) {
	        throw "Invalid JPEG.";
	      }
	      pos += 2;
	      this.bits = this.data[pos++];
	      this.height = this.data.readUInt16BE(pos);
	      pos += 2;
	      this.width = this.data.readUInt16BE(pos);
	      pos += 2;
	      channels = this.data[pos++];
	      this.colorSpace = (function() {
	        switch (channels) {
	          case 1:
	            return 'DeviceGray';
	          case 3:
	            return 'DeviceRGB';
	          case 4:
	            return 'DeviceCMYK';
	        }
	      })();
	      this.obj = null;
	    }

	    JPEG.prototype.embed = function(document) {
	      if (this.obj) {
	        return;
	      }
	      this.obj = document.ref({
	        Type: 'XObject',
	        Subtype: 'Image',
	        BitsPerComponent: this.bits,
	        Width: this.width,
	        Height: this.height,
	        ColorSpace: this.colorSpace,
	        Filter: 'DCTDecode'
	      });
	      if (this.colorSpace === 'DeviceCMYK') {
	        this.obj.data['Decode'] = [1.0, 0.0, 1.0, 0.0, 1.0, 0.0, 1.0, 0.0];
	      }
	      this.obj.end(this.data);
	      return this.data = null;
	    };

	    return JPEG;

	  })();

	  module.exports = JPEG;

	}).call(this);


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Generated by CoffeeScript 1.12.6
	(function() {
	  var PNG, PNGImage, zlib;

	  zlib = __webpack_require__(59);

	  PNG = __webpack_require__(301);

	  PNGImage = (function() {
	    function PNGImage(data, label) {
	      this.label = label;
	      this.image = new PNG(data);
	      this.width = this.image.width;
	      this.height = this.image.height;
	      this.imgData = this.image.imgData;
	      this.obj = null;
	    }

	    PNGImage.prototype.embed = function(document) {
	      var k, len1, mask, palette, params, rgb, val, x;
	      this.document = document;
	      if (this.obj) {
	        return;
	      }
	      this.obj = this.document.ref({
	        Type: 'XObject',
	        Subtype: 'Image',
	        BitsPerComponent: this.image.bits,
	        Width: this.width,
	        Height: this.height,
	        Filter: 'FlateDecode'
	      });
	      if (!this.image.hasAlphaChannel) {
	        params = this.document.ref({
	          Predictor: 15,
	          Colors: this.image.colors,
	          BitsPerComponent: this.image.bits,
	          Columns: this.width
	        });
	        this.obj.data['DecodeParms'] = params;
	        params.end();
	      }
	      if (this.image.palette.length === 0) {
	        this.obj.data['ColorSpace'] = this.image.colorSpace;
	      } else {
	        palette = this.document.ref();
	        palette.end(new Buffer(this.image.palette));
	        this.obj.data['ColorSpace'] = ['Indexed', 'DeviceRGB', (this.image.palette.length / 3) - 1, palette];
	      }
	      if (this.image.transparency.grayscale) {
	        val = this.image.transparency.greyscale;
	        return this.obj.data['Mask'] = [val, val];
	      } else if (this.image.transparency.rgb) {
	        rgb = this.image.transparency.rgb;
	        mask = [];
	        for (k = 0, len1 = rgb.length; k < len1; k++) {
	          x = rgb[k];
	          mask.push(x, x);
	        }
	        return this.obj.data['Mask'] = mask;
	      } else if (this.image.transparency.indexed) {
	        return this.loadIndexedAlphaChannel();
	      } else if (this.image.hasAlphaChannel) {
	        return this.splitAlphaChannel();
	      } else {
	        return this.finalize();
	      }
	    };

	    PNGImage.prototype.finalize = function() {
	      var sMask;
	      if (this.alphaChannel) {
	        sMask = this.document.ref({
	          Type: 'XObject',
	          Subtype: 'Image',
	          Height: this.height,
	          Width: this.width,
	          BitsPerComponent: 8,
	          Filter: 'FlateDecode',
	          ColorSpace: 'DeviceGray',
	          Decode: [0, 1]
	        });
	        sMask.end(this.alphaChannel);
	        this.obj.data['SMask'] = sMask;
	      }
	      this.obj.end(this.imgData);
	      this.image = null;
	      return this.imgData = null;
	    };

	    PNGImage.prototype.splitAlphaChannel = function() {
	      return this.image.decodePixels((function(_this) {
	        return function(pixels) {
	          var a, alphaChannel, colorByteSize, done, i, imgData, len, p, pixelCount;
	          colorByteSize = _this.image.colors * _this.image.bits / 8;
	          pixelCount = _this.width * _this.height;
	          imgData = new Buffer(pixelCount * colorByteSize);
	          alphaChannel = new Buffer(pixelCount);
	          i = p = a = 0;
	          len = pixels.length;
	          while (i < len) {
	            imgData[p++] = pixels[i++];
	            imgData[p++] = pixels[i++];
	            imgData[p++] = pixels[i++];
	            alphaChannel[a++] = pixels[i++];
	          }
	          done = 0;
	          zlib.deflate(imgData, function(err, imgData1) {
	            _this.imgData = imgData1;
	            if (err) {
	              throw err;
	            }
	            if (++done === 2) {
	              return _this.finalize();
	            }
	          });
	          return zlib.deflate(alphaChannel, function(err, alphaChannel1) {
	            _this.alphaChannel = alphaChannel1;
	            if (err) {
	              throw err;
	            }
	            if (++done === 2) {
	              return _this.finalize();
	            }
	          });
	        };
	      })(this));
	    };

	    PNGImage.prototype.loadIndexedAlphaChannel = function(fn) {
	      var transparency;
	      transparency = this.image.transparency.indexed;
	      return this.image.decodePixels((function(_this) {
	        return function(pixels) {
	          var alphaChannel, i, j, k, ref;
	          alphaChannel = new Buffer(_this.width * _this.height);
	          i = 0;
	          for (j = k = 0, ref = pixels.length; k < ref; j = k += 1) {
	            alphaChannel[i++] = transparency[pixels[j]];
	          }
	          return zlib.deflate(alphaChannel, function(err, alphaChannel1) {
	            _this.alphaChannel = alphaChannel1;
	            if (err) {
	              throw err;
	            }
	            return _this.finalize();
	          });
	        };
	      })(this));
	    };

	    return PNGImage;

	  })();

	  module.exports = PNGImage;

	}).call(this);

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Generated by CoffeeScript 1.4.0

	/*
	# MIT LICENSE
	# Copyright (c) 2011 Devon Govett
	# 
	# Permission is hereby granted, free of charge, to any person obtaining a copy of this 
	# software and associated documentation files (the "Software"), to deal in the Software 
	# without restriction, including without limitation the rights to use, copy, modify, merge, 
	# publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons 
	# to whom the Software is furnished to do so, subject to the following conditions:
	# 
	# The above copyright notice and this permission notice shall be included in all copies or 
	# substantial portions of the Software.
	# 
	# THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING 
	# BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND 
	# NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, 
	# DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, 
	# OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	*/


	(function() {
	  var PNG, fs, zlib;

	  fs = __webpack_require__(56);

	  zlib = __webpack_require__(59);

	  module.exports = PNG = (function() {

	    PNG.decode = function(path, fn) {
	      return fs.readFile(path, function(err, file) {
	        var png;
	        png = new PNG(file);
	        return png.decode(function(pixels) {
	          return fn(pixels);
	        });
	      });
	    };

	    PNG.load = function(path) {
	      var file;
	      file = fs.readFileSync(path);
	      return new PNG(file);
	    };

	    function PNG(data) {
	      var chunkSize, colors, i, index, key, section, short, text, _i, _j, _ref;
	      this.data = data;
	      this.pos = 8;
	      this.palette = [];
	      this.imgData = [];
	      this.transparency = {};
	      this.text = {};
	      while (true) {
	        chunkSize = this.readUInt32();
	        section = ((function() {
	          var _i, _results;
	          _results = [];
	          for (i = _i = 0; _i < 4; i = ++_i) {
	            _results.push(String.fromCharCode(this.data[this.pos++]));
	          }
	          return _results;
	        }).call(this)).join('');
	        switch (section) {
	          case 'IHDR':
	            this.width = this.readUInt32();
	            this.height = this.readUInt32();
	            this.bits = this.data[this.pos++];
	            this.colorType = this.data[this.pos++];
	            this.compressionMethod = this.data[this.pos++];
	            this.filterMethod = this.data[this.pos++];
	            this.interlaceMethod = this.data[this.pos++];
	            break;
	          case 'PLTE':
	            this.palette = this.read(chunkSize);
	            break;
	          case 'IDAT':
	            for (i = _i = 0; _i < chunkSize; i = _i += 1) {
	              this.imgData.push(this.data[this.pos++]);
	            }
	            break;
	          case 'tRNS':
	            this.transparency = {};
	            switch (this.colorType) {
	              case 3:
	                this.transparency.indexed = this.read(chunkSize);
	                short = 255 - this.transparency.indexed.length;
	                if (short > 0) {
	                  for (i = _j = 0; 0 <= short ? _j < short : _j > short; i = 0 <= short ? ++_j : --_j) {
	                    this.transparency.indexed.push(255);
	                  }
	                }
	                break;
	              case 0:
	                this.transparency.grayscale = this.read(chunkSize)[0];
	                break;
	              case 2:
	                this.transparency.rgb = this.read(chunkSize);
	            }
	            break;
	          case 'tEXt':
	            text = this.read(chunkSize);
	            index = text.indexOf(0);
	            key = String.fromCharCode.apply(String, text.slice(0, index));
	            this.text[key] = String.fromCharCode.apply(String, text.slice(index + 1));
	            break;
	          case 'IEND':
	            this.colors = (function() {
	              switch (this.colorType) {
	                case 0:
	                case 3:
	                case 4:
	                  return 1;
	                case 2:
	                case 6:
	                  return 3;
	              }
	            }).call(this);
	            this.hasAlphaChannel = (_ref = this.colorType) === 4 || _ref === 6;
	            colors = this.colors + (this.hasAlphaChannel ? 1 : 0);
	            this.pixelBitlength = this.bits * colors;
	            this.colorSpace = (function() {
	              switch (this.colors) {
	                case 1:
	                  return 'DeviceGray';
	                case 3:
	                  return 'DeviceRGB';
	              }
	            }).call(this);
	            this.imgData = new Buffer(this.imgData);
	            return;
	          default:
	            this.pos += chunkSize;
	        }
	        this.pos += 4;
	        if (this.pos > this.data.length) {
	          throw new Error("Incomplete or corrupt PNG file");
	        }
	      }
	      return;
	    }

	    PNG.prototype.read = function(bytes) {
	      var i, _i, _results;
	      _results = [];
	      for (i = _i = 0; 0 <= bytes ? _i < bytes : _i > bytes; i = 0 <= bytes ? ++_i : --_i) {
	        _results.push(this.data[this.pos++]);
	      }
	      return _results;
	    };

	    PNG.prototype.readUInt32 = function() {
	      var b1, b2, b3, b4;
	      b1 = this.data[this.pos++] << 24;
	      b2 = this.data[this.pos++] << 16;
	      b3 = this.data[this.pos++] << 8;
	      b4 = this.data[this.pos++];
	      return b1 | b2 | b3 | b4;
	    };

	    PNG.prototype.readUInt16 = function() {
	      var b1, b2;
	      b1 = this.data[this.pos++] << 8;
	      b2 = this.data[this.pos++];
	      return b1 | b2;
	    };

	    PNG.prototype.decodePixels = function(fn) {
	      var _this = this;
	      return zlib.inflate(this.imgData, function(err, data) {
	        var byte, c, col, i, left, length, p, pa, paeth, pb, pc, pixelBytes, pixels, pos, row, scanlineLength, upper, upperLeft, _i, _j, _k, _l, _m;
	        if (err) {
	          throw err;
	        }
	        pixelBytes = _this.pixelBitlength / 8;
	        scanlineLength = pixelBytes * _this.width;
	        pixels = new Buffer(scanlineLength * _this.height);
	        length = data.length;
	        row = 0;
	        pos = 0;
	        c = 0;
	        while (pos < length) {
	          switch (data[pos++]) {
	            case 0:
	              for (i = _i = 0; _i < scanlineLength; i = _i += 1) {
	                pixels[c++] = data[pos++];
	              }
	              break;
	            case 1:
	              for (i = _j = 0; _j < scanlineLength; i = _j += 1) {
	                byte = data[pos++];
	                left = i < pixelBytes ? 0 : pixels[c - pixelBytes];
	                pixels[c++] = (byte + left) % 256;
	              }
	              break;
	            case 2:
	              for (i = _k = 0; _k < scanlineLength; i = _k += 1) {
	                byte = data[pos++];
	                col = (i - (i % pixelBytes)) / pixelBytes;
	                upper = row && pixels[(row - 1) * scanlineLength + col * pixelBytes + (i % pixelBytes)];
	                pixels[c++] = (upper + byte) % 256;
	              }
	              break;
	            case 3:
	              for (i = _l = 0; _l < scanlineLength; i = _l += 1) {
	                byte = data[pos++];
	                col = (i - (i % pixelBytes)) / pixelBytes;
	                left = i < pixelBytes ? 0 : pixels[c - pixelBytes];
	                upper = row && pixels[(row - 1) * scanlineLength + col * pixelBytes + (i % pixelBytes)];
	                pixels[c++] = (byte + Math.floor((left + upper) / 2)) % 256;
	              }
	              break;
	            case 4:
	              for (i = _m = 0; _m < scanlineLength; i = _m += 1) {
	                byte = data[pos++];
	                col = (i - (i % pixelBytes)) / pixelBytes;
	                left = i < pixelBytes ? 0 : pixels[c - pixelBytes];
	                if (row === 0) {
	                  upper = upperLeft = 0;
	                } else {
	                  upper = pixels[(row - 1) * scanlineLength + col * pixelBytes + (i % pixelBytes)];
	                  upperLeft = col && pixels[(row - 1) * scanlineLength + (col - 1) * pixelBytes + (i % pixelBytes)];
	                }
	                p = left + upper - upperLeft;
	                pa = Math.abs(p - left);
	                pb = Math.abs(p - upper);
	                pc = Math.abs(p - upperLeft);
	                if (pa <= pb && pa <= pc) {
	                  paeth = left;
	                } else if (pb <= pc) {
	                  paeth = upper;
	                } else {
	                  paeth = upperLeft;
	                }
	                pixels[c++] = (byte + paeth) % 256;
	              }
	              break;
	            default:
	              throw new Error("Invalid filter algorithm: " + data[pos - 1]);
	          }
	          row++;
	        }
	        return fn(pixels);
	      });
	    };

	    PNG.prototype.decodePalette = function() {
	      var c, i, length, palette, pos, ret, transparency, _i, _ref, _ref1;
	      palette = this.palette;
	      transparency = this.transparency.indexed || [];
	      ret = new Buffer(transparency.length + palette.length);
	      pos = 0;
	      length = palette.length;
	      c = 0;
	      for (i = _i = 0, _ref = palette.length; _i < _ref; i = _i += 3) {
	        ret[pos++] = palette[i];
	        ret[pos++] = palette[i + 1];
	        ret[pos++] = palette[i + 2];
	        ret[pos++] = (_ref1 = transparency[c++]) != null ? _ref1 : 255;
	      }
	      return ret;
	    };

	    PNG.prototype.copyToImageData = function(imageData, pixels) {
	      var alpha, colors, data, i, input, j, k, length, palette, v, _ref;
	      colors = this.colors;
	      palette = null;
	      alpha = this.hasAlphaChannel;
	      if (this.palette.length) {
	        palette = (_ref = this._decodedPalette) != null ? _ref : this._decodedPalette = this.decodePalette();
	        colors = 4;
	        alpha = true;
	      }
	      data = (imageData != null ? imageData.data : void 0) || imageData;
	      length = data.length;
	      input = palette || pixels;
	      i = j = 0;
	      if (colors === 1) {
	        while (i < length) {
	          k = palette ? pixels[i / 4] * 4 : j;
	          v = input[k++];
	          data[i++] = v;
	          data[i++] = v;
	          data[i++] = v;
	          data[i++] = alpha ? input[k++] : 255;
	          j = k;
	        }
	      } else {
	        while (i < length) {
	          k = palette ? pixels[i / 4] * 4 : j;
	          data[i++] = input[k++];
	          data[i++] = input[k++];
	          data[i++] = input[k++];
	          data[i++] = alpha ? input[k++] : 255;
	          j = k;
	        }
	      }
	    };

	    PNG.prototype.decode = function(fn) {
	      var ret,
	        _this = this;
	      ret = new Buffer(this.width * this.height * 4);
	      return this.decodePixels(function(pixels) {
	        _this.copyToImageData(ret, pixels);
	        return fn(ret);
	      });
	    };

	    return PNG;

	  })();

	}).call(this);

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ }),
/* 302 */
/***/ (function(module, exports) {

	// Generated by CoffeeScript 1.12.6
	(function() {
	  module.exports = {
	    annotate: function(x, y, w, h, options) {
	      var key, ref, val;
	      options.Type = 'Annot';
	      options.Rect = this._convertRect(x, y, w, h);
	      options.Border = [0, 0, 0];
	      if (options.Subtype !== 'Link') {
	        if (options.C == null) {
	          options.C = this._normalizeColor(options.color || [0, 0, 0]);
	        }
	      }
	      delete options.color;
	      if (typeof options.Dest === 'string') {
	        options.Dest = new String(options.Dest);
	      }
	      for (key in options) {
	        val = options[key];
	        options[key[0].toUpperCase() + key.slice(1)] = val;
	      }
	      ref = this.ref(options);
	      this.page.annotations.push(ref);
	      ref.end();
	      return this;
	    },
	    note: function(x, y, w, h, contents, options) {
	      if (options == null) {
	        options = {};
	      }
	      options.Subtype = 'Text';
	      options.Contents = new String(contents);
	      options.Name = 'Comment';
	      if (options.color == null) {
	        options.color = [243, 223, 92];
	      }
	      return this.annotate(x, y, w, h, options);
	    },
	    link: function(x, y, w, h, url, options) {
	      if (options == null) {
	        options = {};
	      }
	      options.Subtype = 'Link';
	      options.A = this.ref({
	        S: 'URI',
	        URI: new String(url)
	      });
	      options.A.end();
	      return this.annotate(x, y, w, h, options);
	    },
	    _markup: function(x, y, w, h, options) {
	      var ref1, x1, x2, y1, y2;
	      if (options == null) {
	        options = {};
	      }
	      ref1 = this._convertRect(x, y, w, h), x1 = ref1[0], y1 = ref1[1], x2 = ref1[2], y2 = ref1[3];
	      options.QuadPoints = [x1, y2, x2, y2, x1, y1, x2, y1];
	      options.Contents = new String;
	      return this.annotate(x, y, w, h, options);
	    },
	    highlight: function(x, y, w, h, options) {
	      if (options == null) {
	        options = {};
	      }
	      options.Subtype = 'Highlight';
	      if (options.color == null) {
	        options.color = [241, 238, 148];
	      }
	      return this._markup(x, y, w, h, options);
	    },
	    underline: function(x, y, w, h, options) {
	      if (options == null) {
	        options = {};
	      }
	      options.Subtype = 'Underline';
	      return this._markup(x, y, w, h, options);
	    },
	    strike: function(x, y, w, h, options) {
	      if (options == null) {
	        options = {};
	      }
	      options.Subtype = 'StrikeOut';
	      return this._markup(x, y, w, h, options);
	    },
	    lineAnnotation: function(x1, y1, x2, y2, options) {
	      if (options == null) {
	        options = {};
	      }
	      options.Subtype = 'Line';
	      options.Contents = new String;
	      options.L = [x1, this.page.height - y1, x2, this.page.height - y2];
	      return this.annotate(x1, y1, x2, y2, options);
	    },
	    rectAnnotation: function(x, y, w, h, options) {
	      if (options == null) {
	        options = {};
	      }
	      options.Subtype = 'Square';
	      options.Contents = new String;
	      return this.annotate(x, y, w, h, options);
	    },
	    ellipseAnnotation: function(x, y, w, h, options) {
	      if (options == null) {
	        options = {};
	      }
	      options.Subtype = 'Circle';
	      options.Contents = new String;
	      return this.annotate(x, y, w, h, options);
	    },
	    textAnnotation: function(x, y, w, h, text, options) {
	      if (options == null) {
	        options = {};
	      }
	      options.Subtype = 'FreeText';
	      options.Contents = new String(text);
	      options.DA = new String;
	      return this.annotate(x, y, w, h, options);
	    },
	    _convertRect: function(x1, y1, w, h) {
	      var m0, m1, m2, m3, m4, m5, ref1, x2, y2;
	      y2 = y1;
	      y1 += h;
	      x2 = x1 + w;
	      ref1 = this._ctm, m0 = ref1[0], m1 = ref1[1], m2 = ref1[2], m3 = ref1[3], m4 = ref1[4], m5 = ref1[5];
	      x1 = m0 * x1 + m2 * y1 + m4;
	      y1 = m1 * x1 + m3 * y1 + m5;
	      x2 = m0 * x2 + m2 * y2 + m4;
	      y2 = m1 * x2 + m3 * y2 + m5;
	      return [x1, y1, x2, y2];
	    }
	  };

	}).call(this);


/***/ }),
/* 303 */
/***/ (function(module, exports) {

	/* jslint node: true */
	'use strict';

	module.exports = {
		'4A0': [4767.87, 6740.79],
		'2A0': [3370.39, 4767.87],
		A0: [2383.94, 3370.39],
		A1: [1683.78, 2383.94],
		A2: [1190.55, 1683.78],
		A3: [841.89, 1190.55],
		A4: [595.28, 841.89],
		A5: [419.53, 595.28],
		A6: [297.64, 419.53],
		A7: [209.76, 297.64],
		A8: [147.40, 209.76],
		A9: [104.88, 147.40],
		A10: [73.70, 104.88],
		B0: [2834.65, 4008.19],
		B1: [2004.09, 2834.65],
		B2: [1417.32, 2004.09],
		B3: [1000.63, 1417.32],
		B4: [708.66, 1000.63],
		B5: [498.90, 708.66],
		B6: [354.33, 498.90],
		B7: [249.45, 354.33],
		B8: [175.75, 249.45],
		B9: [124.72, 175.75],
		B10: [87.87, 124.72],
		C0: [2599.37, 3676.54],
		C1: [1836.85, 2599.37],
		C2: [1298.27, 1836.85],
		C3: [918.43, 1298.27],
		C4: [649.13, 918.43],
		C5: [459.21, 649.13],
		C6: [323.15, 459.21],
		C7: [229.61, 323.15],
		C8: [161.57, 229.61],
		C9: [113.39, 161.57],
		C10: [79.37, 113.39],
		RA0: [2437.80, 3458.27],
		RA1: [1729.13, 2437.80],
		RA2: [1218.90, 1729.13],
		RA3: [864.57, 1218.90],
		RA4: [609.45, 864.57],
		SRA0: [2551.18, 3628.35],
		SRA1: [1814.17, 2551.18],
		SRA2: [1275.59, 1814.17],
		SRA3: [907.09, 1275.59],
		SRA4: [637.80, 907.09],
		EXECUTIVE: [521.86, 756.00],
		FOLIO: [612.00, 936.00],
		LEGAL: [612.00, 1008.00],
		LETTER: [612.00, 792.00],
		TABLOID: [792.00, 1224.00]
	};


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/* jslint node: true */
	'use strict';

	var PDFImage = __webpack_require__(297);

	function ImageMeasure(pdfKitDoc, imageDictionary) {
		this.pdfKitDoc = pdfKitDoc;
		this.imageDictionary = imageDictionary || {};
	}

	ImageMeasure.prototype.measureImage = function (src) {
		var image, label;
		var that = this;

		if (!this.pdfKitDoc._imageRegistry[src]) {
			label = 'I' + (++this.pdfKitDoc._imageCount);
			try {
				image = PDFImage.open(realImageSrc(src), label);
			} catch (error) {
				image = null;
			}
			if (image === null || image === undefined) {
				throw 'invalid image, images dictionary should contain dataURL entries (or local file paths in node.js)';
			}
			image.embed(this.pdfKitDoc);
			this.pdfKitDoc._imageRegistry[src] = image;
		} else {
			image = this.pdfKitDoc._imageRegistry[src];
		}

		return {width: image.width, height: image.height};

		function realImageSrc(src) {
			var img = that.imageDictionary[src];

			if (!img) {
				return src;
			}

			var index = img.indexOf('base64,');
			if (index < 0) {
				return that.imageDictionary[src];
			}

			return new Buffer(img.substring(index + 7), 'base64');
		}
	};

	module.exports = ImageMeasure;

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ }),
/* 305 */
/***/ (function(module, exports) {

	/* jslint node: true */
	'use strict';

	function groupDecorations(line) {
		var groups = [], curGroup = null;
		for (var i = 0, l = line.inlines.length; i < l; i++) {
			var inline = line.inlines[i];
			var decoration = inline.decoration;
			if (!decoration) {
				curGroup = null;
				continue;
			}
			var color = inline.decorationColor || inline.color || 'black';
			var style = inline.decorationStyle || 'solid';
			decoration = Array.isArray(decoration) ? decoration : [decoration];
			for (var ii = 0, ll = decoration.length; ii < ll; ii++) {
				var deco = decoration[ii];
				if (!curGroup || deco !== curGroup.decoration ||
					style !== curGroup.decorationStyle || color !== curGroup.decorationColor ||
					deco === 'lineThrough') {

					curGroup = {
						line: line,
						decoration: deco,
						decorationColor: color,
						decorationStyle: style,
						inlines: [inline]
					};
					groups.push(curGroup);
				} else {
					curGroup.inlines.push(inline);
				}
			}
		}

		return groups;
	}

	function drawDecoration(group, x, y, pdfKitDoc) {
		function maxInline() {
			var max = 0;
			for (var i = 0, l = group.inlines.length; i < l; i++) {
				var inl = group.inlines[i];
				max = inl.fontSize > max ? i : max;
			}
			return group.inlines[max];
		}
		function width() {
			var sum = 0;
			for (var i = 0, l = group.inlines.length; i < l; i++) {
				sum += group.inlines[i].width;
			}
			return sum;
		}
		var firstInline = group.inlines[0],
			biggerInline = maxInline(),
			totalWidth = width(),
			lineAscent = group.line.getAscenderHeight(),
			ascent = biggerInline.font.ascender / 1000 * biggerInline.fontSize,
			height = biggerInline.height,
			descent = height - ascent;

		var lw = 0.5 + Math.floor(Math.max(biggerInline.fontSize - 8, 0) / 2) * 0.12;

		switch (group.decoration) {
			case 'underline':
				y += lineAscent + descent * 0.45;
				break;
			case 'overline':
				y += lineAscent - (ascent * 0.85);
				break;
			case 'lineThrough':
				y += lineAscent - (ascent * 0.25);
				break;
			default:
				throw 'Unkown decoration : ' + group.decoration;
		}
		pdfKitDoc.save();

		if (group.decorationStyle === 'double') {
			var gap = Math.max(0.5, lw * 2);
			pdfKitDoc.fillColor(group.decorationColor)
				.rect(x + firstInline.x, y - lw / 2, totalWidth, lw / 2).fill()
				.rect(x + firstInline.x, y + gap - lw / 2, totalWidth, lw / 2).fill();
		} else if (group.decorationStyle === 'dashed') {
			var nbDashes = Math.ceil(totalWidth / (3.96 + 2.84));
			var rdx = x + firstInline.x;
			pdfKitDoc.rect(rdx, y, totalWidth, lw).clip();
			pdfKitDoc.fillColor(group.decorationColor);
			for (var i = 0; i < nbDashes; i++) {
				pdfKitDoc.rect(rdx, y - lw / 2, 3.96, lw).fill();
				rdx += 3.96 + 2.84;
			}
		} else if (group.decorationStyle === 'dotted') {
			var nbDots = Math.ceil(totalWidth / (lw * 3));
			var rx = x + firstInline.x;
			pdfKitDoc.rect(rx, y, totalWidth, lw).clip();
			pdfKitDoc.fillColor(group.decorationColor);
			for (var ii = 0; ii < nbDots; ii++) {
				pdfKitDoc.rect(rx, y - lw / 2, lw, lw).fill();
				rx += (lw * 3);
			}
		} else if (group.decorationStyle === 'wavy') {
			var sh = 0.7, sv = 1;
			var nbWaves = Math.ceil(totalWidth / (sh * 2)) + 1;
			var rwx = x + firstInline.x - 1;
			pdfKitDoc.rect(x + firstInline.x, y - sv, totalWidth, y + sv).clip();
			pdfKitDoc.lineWidth(0.24);
			pdfKitDoc.moveTo(rwx, y);
			for (var iii = 0; iii < nbWaves; iii++) {
				pdfKitDoc.bezierCurveTo(rwx + sh, y - sv, rwx + sh * 2, y - sv, rwx + sh * 3, y)
					.bezierCurveTo(rwx + sh * 4, y + sv, rwx + sh * 5, y + sv, rwx + sh * 6, y);
				rwx += sh * 6;
			}
			pdfKitDoc.stroke(group.decorationColor);

		} else {
			pdfKitDoc.fillColor(group.decorationColor)
				.rect(x + firstInline.x, y - lw / 2, totalWidth, lw)
				.fill();
		}
		pdfKitDoc.restore();
	}

	function drawDecorations(line, x, y, pdfKitDoc) {
		var groups = groupDecorations(line);
		for (var i = 0, l = groups.length; i < l; i++) {
			drawDecoration(groups[i], x, y, pdfKitDoc);
		}
	}

	function drawBackground(line, x, y, pdfKitDoc) {
		var height = line.getHeight();
		for (var i = 0, l = line.inlines.length; i < l; i++) {
			var inline = line.inlines[i];
			if (inline.background) {
				var justifyShift = (inline.justifyShift || 0);
				pdfKitDoc.fillColor(inline.background)
					.rect(x + inline.x - justifyShift, y, inline.width + justifyShift, height)
					.fill();
			}
		}
	}

	module.exports = {
		drawBackground: drawBackground,
		drawDecorations: drawDecorations
	};

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* FileSaver.js
	 * A saveAs() FileSaver implementation.
	 * 1.3.2
	 * 2016-06-16 18:25:19
	 *
	 * By Eli Grey, http://eligrey.com
	 * License: MIT
	 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
	 */

	/*global self */
	/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */

	/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */

	var saveAs = saveAs || (function(view) {
		"use strict";
		// IE <10 is explicitly unsupported
		if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
			return;
		}
		var
			  doc = view.document
			  // only get URL when necessary in case Blob.js hasn't overridden it yet
			, get_URL = function() {
				return view.URL || view.webkitURL || view;
			}
			, save_link = doc ? doc.createElementNS("http://www.w3.org/1999/xhtml", "a") : []
			, can_use_save_link = "download" in save_link
			, click = function(node) {
				var event = new MouseEvent("click");
				node.dispatchEvent(event);
			}
			, is_safari = /constructor/i.test(view.HTMLElement) || view.safari
			, is_chrome_ios =/CriOS\/[\d]+/.test(navigator.userAgent)
			, throw_outside = function(ex) {
				(view.setImmediate || view.setTimeout)(function() {
					throw ex;
				}, 0);
			}
			, force_saveable_type = "application/octet-stream"
			// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
			, arbitrary_revoke_timeout = 1000 * 40 // in ms
			, revoke = function(file) {
				var revoker = function() {
					if (typeof file === "string") { // file is an object URL
						get_URL().revokeObjectURL(file);
					} else { // file is a File
						file.remove();
					}
				};
				setTimeout(revoker, arbitrary_revoke_timeout);
			}
			, dispatch = function(filesaver, event_types, event) {
				event_types = [].concat(event_types);
				var i = event_types.length;
				while (i--) {
					var listener = filesaver["on" + event_types[i]];
					if (typeof listener === "function") {
						try {
							listener.call(filesaver, event || filesaver);
						} catch (ex) {
							throw_outside(ex);
						}
					}
				}
			}
			, auto_bom = function(blob) {
				// prepend BOM for UTF-8 XML and text/* types (including HTML)
				// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
				if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
					return new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type});
				}
				return blob;
			}
			, FileSaver = function(blob, name, no_auto_bom) {
				if (!no_auto_bom) {
					blob = auto_bom(blob);
				}
				// First try a.download, then web filesystem, then object URLs
				var
					  filesaver = this
					, type = blob.type
					, force = type === force_saveable_type
					, object_url
					, dispatch_all = function() {
						dispatch(filesaver, "writestart progress write writeend".split(" "));
					}
					// on any filesys errors revert to saving with object URLs
					, fs_error = function() {
						if ((is_chrome_ios || (force && is_safari)) && view.FileReader) {
							// Safari doesn't allow downloading of blob urls
							var reader = new FileReader();
							reader.onloadend = function() {
								var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
								var popup = view.open(url, '_blank');
								if(!popup) view.location.href = url;
								url=undefined; // release reference before dispatching
								filesaver.readyState = filesaver.DONE;
								dispatch_all();
							};
							reader.readAsDataURL(blob);
							filesaver.readyState = filesaver.INIT;
							return;
						}
						// don't create more object URLs than needed
						if (!object_url) {
							object_url = get_URL().createObjectURL(blob);
						}
						if (force) {
							view.location.href = object_url;
						} else {
							var opened = view.open(object_url, "_blank");
							if (!opened) {
								// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
								view.location.href = object_url;
							}
						}
						filesaver.readyState = filesaver.DONE;
						dispatch_all();
						revoke(object_url);
					}
				;
				filesaver.readyState = filesaver.INIT;

				if (can_use_save_link) {
					object_url = get_URL().createObjectURL(blob);
					setTimeout(function() {
						save_link.href = object_url;
						save_link.download = name;
						click(save_link);
						dispatch_all();
						revoke(object_url);
						filesaver.readyState = filesaver.DONE;
					});
					return;
				}

				fs_error();
			}
			, FS_proto = FileSaver.prototype
			, saveAs = function(blob, name, no_auto_bom) {
				return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
			}
		;
		// IE 10+ (native saveAs)
		if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
			return function(blob, name, no_auto_bom) {
				name = name || blob.name || "download";

				if (!no_auto_bom) {
					blob = auto_bom(blob);
				}
				return navigator.msSaveOrOpenBlob(blob, name);
			};
		}

		FS_proto.abort = function(){};
		FS_proto.readyState = FS_proto.INIT = 0;
		FS_proto.WRITING = 1;
		FS_proto.DONE = 2;

		FS_proto.error =
		FS_proto.onwritestart =
		FS_proto.onprogress =
		FS_proto.onwrite =
		FS_proto.onabort =
		FS_proto.onerror =
		FS_proto.onwriteend =
			null;

		return saveAs;
	}(
		   typeof self !== "undefined" && self
		|| typeof window !== "undefined" && window
		|| this.content
	));
	// `self` is undefined in Firefox for Android content script context
	// while `this` is nsIContentFrameMessageManager
	// with an attribute `content` that corresponds to the window

	if (typeof module !== "undefined" && module.exports) {
	  module.exports.saveAs = saveAs;
	} else if (("function" !== "undefined" && __webpack_require__(307) !== null) && (__webpack_require__(308) !== null)) {
	  !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    return saveAs;
	  }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}


/***/ }),
/* 307 */
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),
/* 308 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;

	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ })
/******/ ])
});
;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(155).setImmediate, __webpack_require__(155).clearImmediate))

/***/ }),
/* 212 */
/***/ (function(module, exports) {

this.pdfMake = this.pdfMake || {}; this.pdfMake.vfs = {
  "Roboto-Italic.ttf": "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",
  "Roboto-Medium.ttf": "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",
  "Roboto-MediumItalic.ttf": "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",
  "Roboto-Regular.ttf": "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",
  "sampleImage.jpg": "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"
};

/***/ }),
/* 213 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parseCode__ = __webpack_require__(1197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__extend__ = __webpack_require__(1195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__projections__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__deriveConstants__ = __webpack_require__(1194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_Datum__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__datum__ = __webpack_require__(1191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__match__ = __webpack_require__(219);








function Projection(srsCode,callback) {
  if (!(this instanceof Projection)) {
    return new Projection(srsCode);
  }
  callback = callback || function(error){
    if(error){
      throw error;
    }
  };
  var json = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__parseCode__["a" /* default */])(srsCode);
  if(typeof json !== 'object'){
    callback(srsCode);
    return;
  }
  var ourProj = Projection.projections.get(json.projName);
  if(!ourProj){
    callback(srsCode);
    return;
  }
  if (json.datumCode && json.datumCode !== 'none') {
    var datumDef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__match__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__constants_Datum__["a" /* default */], json.datumCode);
    if (datumDef) {
      json.datum_params = datumDef.towgs84 ? datumDef.towgs84.split(',') : null;
      json.ellps = datumDef.ellipse;
      json.datumName = datumDef.datumName ? datumDef.datumName : json.datumCode;
    }
  }
  json.k0 = json.k0 || 1.0;
  json.axis = json.axis || 'enu';
  json.ellps = json.ellps || 'wgs84';
  var sphere_ = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__deriveConstants__["a" /* sphere */])(json.a, json.b, json.rf, json.ellps, json.sphere);
  var ecc = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__deriveConstants__["b" /* eccentricity */])(sphere_.a, sphere_.b, sphere_.rf, json.R_A);
  var datumObj = json.datum || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__datum__["a" /* default */])(json.datumCode, json.datum_params, sphere_.a, sphere_.b, ecc.es, ecc.ep2);

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__extend__["a" /* default */])(this, json); // transfer everything over from the projection because we don't know what we'll need
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__extend__["a" /* default */])(this, ourProj); // transfer all the methods from the projection

  // copy the 4 things over we calulated in deriveConstants.sphere
  this.a = sphere_.a;
  this.b = sphere_.b;
  this.rf = sphere_.rf;
  this.sphere = sphere_.sphere;

  // copy the 3 things we calculated in deriveConstants.eccentricity
  this.es = ecc.es;
  this.e = ecc.e;
  this.ep2 = ecc.ep2;

  // add in the datum object
  this.datum = datumObj;

  // init the projection
  this.init();

  // legecy callback from back in the day when it went to spatialreference.org
  callback(null, this);

}
Projection.projections = __WEBPACK_IMPORTED_MODULE_2__projections__["a" /* default */];
Projection.projections.start();
/* harmony default export */ __webpack_exports__["a"] = (Projection);


/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, e, sinphi) {
  var temp = e * sinphi;
  return a / Math.sqrt(1 - temp * temp);
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(ml, e0, e1, e2, e3) {
  var phi;
  var dphi;

  phi = ml / e0;
  for (var i = 0; i < 15; i++) {
    dphi = (ml - (e0 * phi - e1 * Math.sin(2 * phi) + e2 * Math.sin(4 * phi) - e3 * Math.sin(6 * phi))) / (e0 - 2 * e1 * Math.cos(2 * phi) + 4 * e2 * Math.cos(4 * phi) - 6 * e3 * Math.cos(6 * phi));
    phi += dphi;
    if (Math.abs(dphi) <= 0.0000000001) {
      return phi;
    }
  }

  //..reportError("IMLFN-CONV:Latitude failed to converge after 15 iterations");
  return NaN;
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(phi, sphi, cphi, en) {
  cphi *= sphi;
  sphi *= sphi;
  return (en[0] * phi - cphi * (en[1] + sphi * (en[2] + sphi * (en[3] + sphi * en[4]))));
});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(eccent, sinphi) {
  var con;
  if (eccent > 1.0e-7) {
    con = eccent * sinphi;
    return ((1 - eccent * eccent) * (sinphi / (1 - con * con) - (0.5 / eccent) * Math.log((1 - con) / (1 + con))));
  }
  else {
    return (2 * sinphi);
  }
});

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = match;
var ignoredChar = /[\s_\-\/\(\)]/g;
function match(obj, key) {
  if (obj[key]) {
    return obj[key];
  }
  var keys = Object.keys(obj);
  var lkey = key.toLowerCase().replace(ignoredChar, '');
  var i = -1;
  var testkey, processedKey;
  while (++i < keys.length) {
    testkey = keys[i];
    processedKey = testkey.toLowerCase().replace(ignoredChar, '');
    if (processedKey === lkey) {
      return obj[testkey];
    }
  }
}


/***/ }),
/* 220 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
	}),
	getHeadElement = memoize(function () {
		return document.head || document.getElementsByTagName("head")[0];
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [];

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the bottom of <head>.
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
}

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var head = getHeadElement();
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			head.insertBefore(styleElement, head.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			head.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		head.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	styleElement.type = "text/css";
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	linkElement.rel = "stylesheet";
	insertStyleElement(options, linkElement);
	return linkElement;
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(519),
  /* template */
  __webpack_require__(2180),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
Mixin for objects that are mounted by Google Maps
Javascript API.

These are objects that are sensitive to element resize
operations so it exposes a property which accepts a bus

*/

exports.default = {
  props: ['resizeBus'],

  data: function data() {
    return {
      _actualResizeBus: null
    };
  },
  created: function created() {
    if (typeof this.resizeBus === 'undefined') {
      this.$data._actualResizeBus = this.$gmapDefaultResizeBus;
    } else {
      this.$data._actualResizeBus = this.resizeBus;
    }
  },


  methods: {
    _resizeCallback: function _resizeCallback() {
      this.resize();
    },
    _delayedResizeCallback: function _delayedResizeCallback() {
      var _this = this;

      this.$nextTick(function () {
        return _this._resizeCallback();
      });
    }
  },

  watch: {
    resizeBus: function resizeBus(newVal, oldVal) {
      // eslint-disable-line no-unused-vars
      this.$data._actualResizeBus = newVal;
    },
    '$data._actualResizeBus': function $data_actualResizeBus(newVal, oldVal) {
      if (oldVal) {
        oldVal.$off('resize', this._delayedResizeCallback);
      }
      if (newVal) {
        newVal.$on('resize', this._delayedResizeCallback);
      }
    }
  },

  destroyed: function destroyed() {
    if (this.$data._actualResizeBus) {
      this.$data._actualResizeBus.$off('resize', this._delayedResizeCallback);
    }
  }
};

/***/ }),
/* 223 */
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(117)
  , TAG = __webpack_require__(48)('toStringTag')
  // ES3 wrong here
  , ARG = cof(function(){ return arguments; }()) == 'Arguments';

module.exports = function(it){
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = (O = Object(it))[TAG]) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),
/* 225 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 226 */
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),
/* 227 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var $          = __webpack_require__(53)
  , createDesc = __webpack_require__(230);
module.exports = __webpack_require__(158) ? function(object, key, value){
  return $.setDesc(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),
/* 229 */
/***/ (function(module, exports) {

module.exports = true;

/***/ }),
/* 230 */
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(228);

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at  = __webpack_require__(2268)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(473)(String, 'String', function(iterated){
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , index = this._i
    , point;
  if(index >= O.length)return {value: undefined, done: true};
  point = $at(O, index);
  this._i += point.length;
  return {value: point, done: false};
});

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2274);
var Iterators = __webpack_require__(100);
Iterators.NodeList = Iterators.HTMLCollection = Iterators.Array;

/***/ }),
/* 234 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(2197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_lodash_dist_vue_lodash_min__ = __webpack_require__(2196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_lodash_dist_vue_lodash_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_lodash_dist_vue_lodash_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_i18n__ = __webpack_require__(2278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_i18n___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuex_i18n__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__translations_ca_json__ = __webpack_require__(2281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__translations_ca_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__translations_ca_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__translations_en_json__ = __webpack_require__(2282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__translations_en_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__translations_en_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__translations_es_json__ = __webpack_require__(2283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__translations_es_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__translations_es_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_auth__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_nv__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_ad_ad__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_ad_ad_municipalities__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_appraisalfiles__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_appraiser_appraiser__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_supervisor_supervisor__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modules_realestate_realestate__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modules_appraisal_appraisal__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modules_appraisal_appraisal_bec_prices__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modules_appraisal_appraisal_bec_properties__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__modules_appraisal_appraisal_rooms__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__modules_appraisal_appraisal_covered_outdoors__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__modules_appraisal_appraisal_uncovered_outdoors__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__modules_appraisal_appraisal_constraints__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__modules_appraisal_appraisal_warnings__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__modules_appraisal_appraisal_notes__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__modules_appraisal_appraisal_photographs__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__modules_appraisal_appraisal_registryannexes__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__modules_appraisal_appraisal_cadasterannexes__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__modules_appraisal_appraisal_urbanannexes__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__modules_appraisal_appraisal_planannexes__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__modules_appraisal_appraisal_cessionannexes__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__modules_appraisal_appraisal_otherannexes__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__modules_emailaddress_emailaddress__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__modules_telephonenumber_telephonenumber__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__modules_realestate_realestate_appraisals__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__modules_realestate_realestate_marketstudies__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__modules_realestate_realestate_municipalities__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__modules_realestate_realestate_projects__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__modules_ad_comparable_ad_comparable__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__modules_contact_contact__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__modules_appraisalfile_appraisalfile__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__modules_appraisalfile_appraisalfile_appraisalreports__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__modules_appraisalreport_appraisalreport__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__modules_appraisalreport_appraisalreport_realestates__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__modules_appraisalreport_appraisalreport_petitioners__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__modules_appraisalfile_appraisalfile_appraisalquotes__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__modules_appraisalquote_appraisalquote__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__modules_appraisalquote_appraisalquote_petitioners__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__modules_appraisalquote_appraisalquote_realestates__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__modules_appraisalquote_appraisalquote_requireddocs__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__modules_appraisalfile_appraisalfile_appraisalinvoices__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__modules_appraisalinvoice_appraisalinvoice__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__modules_appraisalinvoice_appraisalinvoice_lines__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__modules_appraisalinvoice_appraisalinvoice_petitioners__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__modules_appraisalinvoice_appraisalinvoice_appraisalquotes__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__modules_becprice_becprice__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__modules_becproperty_becproperty__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__modules_becproperty_becproperty_becprices__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__modules_contact_contact_addresses__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__modules_contact_contact_emailaddresses__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__modules_contact_contact_telephonenumbers__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__modules_contact_contact_appraisalinvoices__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__modules_contact_contact_appraisalquotes__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__modules_contact_contact_appraisalreports__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__modules_entity_entity__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__modules_marketstudy_marketstudy__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__modules_marketstudy_marketstudy_ads__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__modules_marketstudy_marketstudy_ad_comparables__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__modules_room_room__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__modules_line_line__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__modules_covered_outdoor_covered_outdoor__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__modules_uncovered_outdoor_uncovered_outdoor__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__modules_constraint_constraint__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__modules_warning_warning__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__modules_note_note__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__modules_photograph_photograph__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__modules_project_project__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__modules_registryannex_registryannex__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__modules_cadasterannex_cadasterannex__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__modules_urbanannex_urbanannex__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__modules_planannex_planannex__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__modules_cessionannex_cessionannex__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__modules_otherannex_otherannex__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_vue_lodash_dist_vue_lodash_min___default.a, __WEBPACK_IMPORTED_MODULE_3_lodash___default.a);


























































































__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: {
        query: '',
        resultIndex: -1,
        renamingId: null,
        editingId: null
    },

    modules: {
        auth: __WEBPACK_IMPORTED_MODULE_10__modules_auth__["a" /* default */],
        ad: __WEBPACK_IMPORTED_MODULE_12__modules_ad_ad__["a" /* default */],
        ad_municipalities: __WEBPACK_IMPORTED_MODULE_13__modules_ad_ad_municipalities__["a" /* default */],
        appraisal: __WEBPACK_IMPORTED_MODULE_18__modules_appraisal_appraisal__["a" /* default */],
        appraisal_bec_prices: __WEBPACK_IMPORTED_MODULE_19__modules_appraisal_appraisal_bec_prices__["a" /* default */],
        appraisal_bec_properties: __WEBPACK_IMPORTED_MODULE_20__modules_appraisal_appraisal_bec_properties__["a" /* default */],
        appraisal_rooms: __WEBPACK_IMPORTED_MODULE_21__modules_appraisal_appraisal_rooms__["a" /* default */],
        appraisal_covered_outdoors: __WEBPACK_IMPORTED_MODULE_22__modules_appraisal_appraisal_covered_outdoors__["a" /* default */],
        appraisal_uncovered_outdoors: __WEBPACK_IMPORTED_MODULE_23__modules_appraisal_appraisal_uncovered_outdoors__["a" /* default */],
        appraisal_constraints: __WEBPACK_IMPORTED_MODULE_24__modules_appraisal_appraisal_constraints__["a" /* default */],
        appraisal_warnings: __WEBPACK_IMPORTED_MODULE_25__modules_appraisal_appraisal_warnings__["a" /* default */],
        appraisal_notes: __WEBPACK_IMPORTED_MODULE_26__modules_appraisal_appraisal_notes__["a" /* default */],
        appraisal_photographs: __WEBPACK_IMPORTED_MODULE_27__modules_appraisal_appraisal_photographs__["a" /* default */],
        appraisal_registryannexes: __WEBPACK_IMPORTED_MODULE_28__modules_appraisal_appraisal_registryannexes__["a" /* default */],
        appraisal_cadasterannexes: __WEBPACK_IMPORTED_MODULE_29__modules_appraisal_appraisal_cadasterannexes__["a" /* default */],
        appraisal_urbanannexes: __WEBPACK_IMPORTED_MODULE_30__modules_appraisal_appraisal_urbanannexes__["a" /* default */],
        appraisal_planannexes: __WEBPACK_IMPORTED_MODULE_31__modules_appraisal_appraisal_planannexes__["a" /* default */],
        appraisal_cessionannexes: __WEBPACK_IMPORTED_MODULE_32__modules_appraisal_appraisal_cessionannexes__["a" /* default */],
        appraisal_otherannexes: __WEBPACK_IMPORTED_MODULE_33__modules_appraisal_appraisal_otherannexes__["a" /* default */],
        appraisalfile: __WEBPACK_IMPORTED_MODULE_42__modules_appraisalfile_appraisalfile__["a" /* default */],
        appraisalfile_appraisalreports: __WEBPACK_IMPORTED_MODULE_43__modules_appraisalfile_appraisalfile_appraisalreports__["a" /* default */],
        appraisalfile_appraisalquotes: __WEBPACK_IMPORTED_MODULE_47__modules_appraisalfile_appraisalfile_appraisalquotes__["a" /* default */],
        appraisalfile_appraisalinvoices: __WEBPACK_IMPORTED_MODULE_52__modules_appraisalfile_appraisalfile_appraisalinvoices__["a" /* default */],
        appraisalfiles: __WEBPACK_IMPORTED_MODULE_14__modules_appraisalfiles__["a" /* default */],
        appraisalreport: __WEBPACK_IMPORTED_MODULE_44__modules_appraisalreport_appraisalreport__["a" /* default */],
        appraisalquote: __WEBPACK_IMPORTED_MODULE_48__modules_appraisalquote_appraisalquote__["a" /* default */],
        appraisalinvoice: __WEBPACK_IMPORTED_MODULE_53__modules_appraisalinvoice_appraisalinvoice__["a" /* default */],
        appraiser: __WEBPACK_IMPORTED_MODULE_15__modules_appraiser_appraiser__["a" /* default */],
        supervisor: __WEBPACK_IMPORTED_MODULE_16__modules_supervisor_supervisor__["a" /* default */],
        becprice: __WEBPACK_IMPORTED_MODULE_57__modules_becprice_becprice__["a" /* default */],
        becproperty: __WEBPACK_IMPORTED_MODULE_58__modules_becproperty_becproperty__["a" /* default */],
        becproperty_becprices: __WEBPACK_IMPORTED_MODULE_59__modules_becproperty_becproperty_becprices__["a" /* default */],
        comparable: __WEBPACK_IMPORTED_MODULE_40__modules_ad_comparable_ad_comparable__["a" /* default */],
        contact: __WEBPACK_IMPORTED_MODULE_41__modules_contact_contact__["a" /* default */],
        appraisalreport_realestates: __WEBPACK_IMPORTED_MODULE_45__modules_appraisalreport_appraisalreport_realestates__["a" /* default */],
        appraisalreport_petitioners: __WEBPACK_IMPORTED_MODULE_46__modules_appraisalreport_appraisalreport_petitioners__["a" /* default */],
        appraisalquote_petitioners: __WEBPACK_IMPORTED_MODULE_49__modules_appraisalquote_appraisalquote_petitioners__["a" /* default */],
        appraisalquote_realestates: __WEBPACK_IMPORTED_MODULE_50__modules_appraisalquote_appraisalquote_realestates__["a" /* default */],
        appraisalquote_requireddocs: __WEBPACK_IMPORTED_MODULE_51__modules_appraisalquote_appraisalquote_requireddocs__["a" /* default */],
        appraisalinvoice_lines: __WEBPACK_IMPORTED_MODULE_54__modules_appraisalinvoice_appraisalinvoice_lines__["a" /* default */],
        appraisalinvoice_appraisalquotes: __WEBPACK_IMPORTED_MODULE_56__modules_appraisalinvoice_appraisalinvoice_appraisalquotes__["a" /* default */],
        appraisalinvoice_petitioners: __WEBPACK_IMPORTED_MODULE_55__modules_appraisalinvoice_appraisalinvoice_petitioners__["a" /* default */],
        contact_addresses: __WEBPACK_IMPORTED_MODULE_60__modules_contact_contact_addresses__["a" /* default */],
        contact_emailaddresses: __WEBPACK_IMPORTED_MODULE_61__modules_contact_contact_emailaddresses__["a" /* default */],
        contact_telephonenumbers: __WEBPACK_IMPORTED_MODULE_62__modules_contact_contact_telephonenumbers__["a" /* default */],
        contact_appraisalinvoices: __WEBPACK_IMPORTED_MODULE_63__modules_contact_contact_appraisalinvoices__["a" /* default */],
        contact_appraisalquotes: __WEBPACK_IMPORTED_MODULE_64__modules_contact_contact_appraisalquotes__["a" /* default */],
        contact_appraisalreports: __WEBPACK_IMPORTED_MODULE_65__modules_contact_contact_appraisalreports__["a" /* default */],
        emailaddress: __WEBPACK_IMPORTED_MODULE_34__modules_emailaddress_emailaddress__["a" /* default */],
        entity: __WEBPACK_IMPORTED_MODULE_66__modules_entity_entity__["a" /* default */],
        marketstudy: __WEBPACK_IMPORTED_MODULE_67__modules_marketstudy_marketstudy__["a" /* default */],
        marketstudy_ads: __WEBPACK_IMPORTED_MODULE_68__modules_marketstudy_marketstudy_ads__["a" /* default */],
        marketstudy_ad_comparables: __WEBPACK_IMPORTED_MODULE_69__modules_marketstudy_marketstudy_ad_comparables__["a" /* default */],
        realestate: __WEBPACK_IMPORTED_MODULE_17__modules_realestate_realestate__["a" /* default */],
        realestate_appraisals: __WEBPACK_IMPORTED_MODULE_36__modules_realestate_realestate_appraisals__["a" /* default */],
        realestate_marketstudies: __WEBPACK_IMPORTED_MODULE_37__modules_realestate_realestate_marketstudies__["a" /* default */],
        realestate_municipalities: __WEBPACK_IMPORTED_MODULE_38__modules_realestate_realestate_municipalities__["a" /* default */],
        realestate_projects: __WEBPACK_IMPORTED_MODULE_39__modules_realestate_realestate_projects__["a" /* default */],
        room: __WEBPACK_IMPORTED_MODULE_70__modules_room_room__["a" /* default */],
        line: __WEBPACK_IMPORTED_MODULE_71__modules_line_line__["a" /* default */],
        covered_outdoor: __WEBPACK_IMPORTED_MODULE_72__modules_covered_outdoor_covered_outdoor__["a" /* default */],
        uncovered_outdoor: __WEBPACK_IMPORTED_MODULE_73__modules_uncovered_outdoor_uncovered_outdoor__["a" /* default */],
        telephonenumber: __WEBPACK_IMPORTED_MODULE_35__modules_telephonenumber_telephonenumber__["a" /* default */],
        nv: __WEBPACK_IMPORTED_MODULE_11__modules_nv__["a" /* default */],
        constraint: __WEBPACK_IMPORTED_MODULE_74__modules_constraint_constraint__["a" /* default */],
        warning: __WEBPACK_IMPORTED_MODULE_75__modules_warning_warning__["a" /* default */],
        note: __WEBPACK_IMPORTED_MODULE_76__modules_note_note__["a" /* default */],
        photograph: __WEBPACK_IMPORTED_MODULE_77__modules_photograph_photograph__["a" /* default */],
        project: __WEBPACK_IMPORTED_MODULE_78__modules_project_project__["a" /* default */],
        registryannex: __WEBPACK_IMPORTED_MODULE_79__modules_registryannex_registryannex__["a" /* default */],
        cadasterannex: __WEBPACK_IMPORTED_MODULE_80__modules_cadasterannex_cadasterannex__["a" /* default */],
        urbanannex: __WEBPACK_IMPORTED_MODULE_81__modules_urbanannex_urbanannex__["a" /* default */],
        planannex: __WEBPACK_IMPORTED_MODULE_82__modules_planannex_planannex__["a" /* default */],
        cessionannex: __WEBPACK_IMPORTED_MODULE_83__modules_cessionannex_cessionannex__["a" /* default */],
        otherannex: __WEBPACK_IMPORTED_MODULE_84__modules_otherannex_otherannex__["a" /* default */]
    },

    actions: {
        RESET_ACTIVE_CONTACT: function RESET_ACTIVE_CONTACT(_ref) {
            var state = _ref.state,
                commit = _ref.commit,
                rootState = _ref.rootState;

            commit(__WEBPACK_IMPORTED_MODULE_85__constants__["a" /* SET_RESULT_INDEX */], -1);
            commit(__WEBPACK_IMPORTED_MODULE_85__constants__["b" /* SET_ACTIVE_CONTACT */], null);
            commit(__WEBPACK_IMPORTED_MODULE_85__constants__["c" /* SET_ACTIVE_KEY */], null);
        },
        RESET_ACTIVE_NOTE: function RESET_ACTIVE_NOTE(_ref2) {
            var state = _ref2.state,
                commit = _ref2.commit,
                rootState = _ref2.rootState;

            commit(__WEBPACK_IMPORTED_MODULE_85__constants__["a" /* SET_RESULT_INDEX */], -1);
            commit(__WEBPACK_IMPORTED_MODULE_85__constants__["d" /* SET_ACTIVE_NOTE */], null);
            commit(__WEBPACK_IMPORTED_MODULE_85__constants__["c" /* SET_ACTIVE_KEY */], null);
        },
        RESET_APP: function RESET_APP(_ref3) {
            var state = _ref3.state,
                commit = _ref3.commit,
                rootState = _ref3.rootState;

            commit(__WEBPACK_IMPORTED_MODULE_85__constants__["e" /* SET_LANGUAGE */], 'es');
            commit(__WEBPACK_IMPORTED_MODULE_85__constants__["f" /* SET_THEME */], 'light');
            commit(__WEBPACK_IMPORTED_MODULE_85__constants__["g" /* SET_QUERY */], '');
            commit(__WEBPACK_IMPORTED_MODULE_85__constants__["a" /* SET_RESULT_INDEX */], -1);
            commit(__WEBPACK_IMPORTED_MODULE_85__constants__["h" /* SET_NOTES */], []);
            commit(__WEBPACK_IMPORTED_MODULE_85__constants__["d" /* SET_ACTIVE_NOTE */], null);
            commit(__WEBPACK_IMPORTED_MODULE_85__constants__["c" /* SET_ACTIVE_KEY */], null);
        },
        SET_VALUE: function SET_VALUE(_ref4, data) {
            var state = _ref4.state,
                commit = _ref4.commit,
                rootState = _ref4.rootState;

            return new Promise(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */].set_value({
                    value: data.object,
                    path: data.path,
                    save_timestamp: false
                }).then(function (res) {
                    return resolve({});
                });
            });
        },
        DELETE: function DELETE(_ref5, data) {
            var state = _ref5.state,
                commit = _ref5.commit,
                rootState = _ref5.rootState;

            return new Promise(function (resolve, reject) {

                console.log('delete path: ' + data.path);
                __WEBPACK_IMPORTED_MODULE_9__api__["a" /* default */].delete({ key: data.key, path: data.path }).then(function (res) {
                    resolve({});
                });
            });
        }
    },

    mutations: (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_85__constants__["g" /* SET_QUERY */], function (state, query) {
        state.query = query;
    }), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_85__constants__["a" /* SET_RESULT_INDEX */], function (state, resultIndex) {
        state.resultIndex = resultIndex;
    }), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_85__constants__["i" /* SET_RENAMING_ID */], function (state, renamingId) {
        state.renamingId = renamingId;
    }), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_85__constants__["j" /* SET_EDITING_ID */], function (state, editingId) {
        state.editingId = editingId;
    }), _mutations),

    getters: {
        query: function query(state) {
            return state.query;
        },

        resultIndex: function resultIndex(state) {
            return state.resultIndex;
        },

        renamingId: function renamingId(state) {
            return state.renamingId;
        },

        editingId: function editingId(state) {
            return state.editingId;
        },

        currentLocale: function currentLocale(state) {
            return state.i18n.locale;
        }
    }
});

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_5_vuex_i18n___default.a.plugin, store);

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.i18n.add('ca', __WEBPACK_IMPORTED_MODULE_6__translations_ca_json__);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.i18n.add('en', __WEBPACK_IMPORTED_MODULE_7__translations_en_json__);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.i18n.add('es', __WEBPACK_IMPORTED_MODULE_8__translations_es_json__);

var userLang = navigator.language || navigator.userLanguage;

console.log('userLang: ');
console.log(userLang);

if (userLang === 'ca' || userLang === 'ca-ES') {
    __WEBPACK_IMPORTED_MODULE_0_vue___default.a.i18n.set('ca');
} else if (userLang === 'es' || userLang === 'es-ES') {
    __WEBPACK_IMPORTED_MODULE_0_vue___default.a.i18n.set('es');
} else if (userLang === 'en' || userLang === 'en-GB' || userLang === 'en-US') {
    __WEBPACK_IMPORTED_MODULE_0_vue___default.a.i18n.set('en');
} else {
    __WEBPACK_IMPORTED_MODULE_0_vue___default.a.i18n.set('es');
}

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 236 */
/***/ (function(module, exports) {

var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * Implements ES5 [`Array#forEach()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach) method.<br><br>
 * Executes the provided callback once for each element.<br>
 * Callbacks are run concurrently,
 * and are only invoked for properties of the array that have been initialized (including those initialized with *undefined*), for unassigned ones `callback` is not run.<br>
 * @param {Array} array - Array to iterate over.
 * @param {Function} callback - Function to apply each item in `array`. Accepts three arguments: `currentValue`, `index` and `array`.
 * @param {Object} [thisArg] - Value to use as *this* when executing the `callback`.
 * @return {Promise} - Returns a Promise with undefined value.
 */
exports.forEach = function () {
  var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(array, callback, thisArg) {
    var promiseArray, _loop, i;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            promiseArray = [];

            _loop = function _loop(i) {
              if (i in array) {
                var p = Promise.resolve(array[i]).then(function (currentValue) {
                  return callback.call(thisArg || _this, currentValue, i, array);
                });
                promiseArray.push(p);
              }
            };

            for (i = 0; i < array.length; i++) {
              _loop(i);
            }
            _context.next = 5;
            return Promise.all(promiseArray);

          case 5:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Same functionality as [`forEach()`](global.html#forEach), but runs only one callback at a time.
 * @param {Array} array - Array to iterate over.
 * @param {Function} callback - Function to apply each item in `array`. Accepts three arguments: `currentValue`, `index` and `array`.
 * @param {Object} [thisArg] - Value to use as *this* when executing the `callback`.
 * @return {Promise} - Returns a Promise with undefined value.
 */
exports.forEachSeries = function () {
  var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(array, callback, thisArg) {
    var i;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            i = 0;

          case 1:
            if (!(i < array.length)) {
              _context2.next = 15;
              break;
            }

            if (!(i in array)) {
              _context2.next = 12;
              break;
            }

            _context2.t0 = callback;
            _context2.t1 = thisArg || _this;
            _context2.next = 7;
            return array[i];

          case 7:
            _context2.t2 = _context2.sent;
            _context2.t3 = i;
            _context2.t4 = array;
            _context2.next = 12;
            return _context2.t0.call.call(_context2.t0, _context2.t1, _context2.t2, _context2.t3, _context2.t4);

          case 12:
            i++;
            _context2.next = 1;
            break;

          case 15:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function (_x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * Implements ES5 [`Array#map()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map) method.<br><br>
 * Creates a new array with the results of calling the provided callback once for each element.<br>
 * Callbacks are run concurrently,
 * and are only invoked for properties of the array that have been initialized (including those initialized with *undefined*), for unassigned ones`callback` is not run.<br>
 * Resultant *Array* is always the same *length* as the original one.
 * @param {Array} array - Array to iterate over.
 * @param {Function} callback - Function to apply each item in `array`. Accepts three arguments: `currentValue`, `index` and `array`.
 * @param {Object} [thisArg] - Value to use as *this* when executing the `callback`.
 * @return {Promise} - Returns a Promise with the resultant *Array* as value.
 */
exports.map = function () {
  var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(array, callback, thisArg) {
    var promiseArray, _loop2, i;

    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            promiseArray = [];

            _loop2 = function _loop2(i) {
              if (i in array) {
                promiseArray[i] = Promise.resolve(array[i]).then(function (currentValue) {
                  return callback.call(thisArg || _this, currentValue, i, array);
                });
              }
            };

            for (i = 0; i < array.length; i++) {
              _loop2(i);
            }
            return _context3.abrupt('return', Promise.all(promiseArray));

          case 4:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this);
  }));

  return function (_x7, _x8, _x9) {
    return _ref3.apply(this, arguments);
  };
}();

/**
 * Same functionality as [`map()`](global.html#map), but runs only one callback at a time.
 * @param {Array} array - Array to iterate over.
 * @param {Function} callback - Function to apply each item in `array`. Accepts three arguments: `currentValue`, `index` and `array`.
 * @param {Object} [thisArg] - Value to use as *this* when executing the `callback`.
 * @return {Promise} - Returns a Promise with the resultant *Array* as value.
 */
exports.mapSeries = function () {
  var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee4(array, callback, thisArg) {
    var result, i;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            result = [];
            i = 0;

          case 2:
            if (!(i < array.length)) {
              _context4.next = 17;
              break;
            }

            if (!(i in array)) {
              _context4.next = 14;
              break;
            }

            _context4.t0 = callback;
            _context4.t1 = thisArg || _this;
            _context4.next = 8;
            return array[i];

          case 8:
            _context4.t2 = _context4.sent;
            _context4.t3 = i;
            _context4.t4 = array;
            _context4.next = 13;
            return _context4.t0.call.call(_context4.t0, _context4.t1, _context4.t2, _context4.t3, _context4.t4);

          case 13:
            result[i] = _context4.sent;

          case 14:
            i++;
            _context4.next = 2;
            break;

          case 17:
            return _context4.abrupt('return', result);

          case 18:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this);
  }));

  return function (_x10, _x11, _x12) {
    return _ref4.apply(this, arguments);
  };
}();

/**
 * Implements ES5 [`Array#find()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find) method.<br><br>
 * Returns the value of the element that satisfies the provided `callback`. The value returned is the one found first.<br>
 * Callbacks are run concurrently, meaning that all the callbacks are going to run even if the returned value is found in one of the first elements of `array`,
 * depending on the async calls you are going to use, consider using instead [`findSeries()`](global.html#findSeries).<br>
 * @param {Array} array - Array to iterate over.
 * @param {Function} callback - Function to apply each item in `array`. Accepts three arguments: `currentValue`, `index` and `array`.
 * @param {Object} [thisArg] - Value to use as *this* when executing the `callback`.
 * @return {Promise} - Returns a Promise with the element that passed the test as value, otherwise *undefined*.
 */
exports.find = function (array, callback, thisArg) {
  return new Promise(function (resolve, reject) {
    if (array.length === 0) {
      return resolve();
    }
    var counter = 1;

    var _loop3 = function _loop3(i) {
      var check = function check(found) {
        if (found) {
          resolve(array[i]);
        } else if (counter === array.length) {
          resolve();
        }
        counter++;
      };
      Promise.resolve(array[i]).then(function (elem) {
        return callback.call(thisArg || _this, elem, i, array);
      }).then(check).catch(reject);
    };

    for (var i = 0; i < array.length; i++) {
      _loop3(i);
    }
  });
};

/**
 * Same functionality as [`find()`](global.html#find), but runs only one callback at a time.
 * @param {Array} array - Array to iterate over.
 * @param {Function} callback - Function to apply each item in `array`. Accepts three arguments: `currentValue`, `index` and `array`.
 * @param {Object} [thisArg] - Value to use as *this* when executing the `callback`.
 * @return {Promise} - Returns a Promise with the element that passed the test as value, otherwise *undefined*.
 */
exports.findSeries = function () {
  var _ref5 = _asyncToGenerator(regeneratorRuntime.mark(function _callee5(array, callback, thisArg) {
    var i;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            i = 0;

          case 1:
            if (!(i < array.length)) {
              _context5.next = 16;
              break;
            }

            _context5.t0 = callback;
            _context5.t1 = thisArg || _this;
            _context5.next = 6;
            return array[i];

          case 6:
            _context5.t2 = _context5.sent;
            _context5.t3 = i;
            _context5.t4 = array;
            _context5.next = 11;
            return _context5.t0.call.call(_context5.t0, _context5.t1, _context5.t2, _context5.t3, _context5.t4);

          case 11:
            if (!_context5.sent) {
              _context5.next = 13;
              break;
            }

            return _context5.abrupt('return', array[i]);

          case 13:
            i++;
            _context5.next = 1;
            break;

          case 16:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, _this);
  }));

  return function (_x13, _x14, _x15) {
    return _ref5.apply(this, arguments);
  };
}();

/**
 * Implements ES5 [`Array#findIndex()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex) method.<br><br>
 * Returns the index of the element that satisfies the provided `callback`. The index returned is the one found first.<br>
 * Callbacks are run concurrently, meaning that all the callbacks are going to run even if the returned index is found in one of the first elements of `array`,
 * depending on the async calls you are going to use, consider using instead [`findSeries()`](global.html#findSeries).<br>
 * @param {Array} array - Array to iterate over.
 * @param {Function} callback - Function to apply each item in `array`. Accepts three arguments: `currentValue`, `index` and `array`.
 * @param {Object} [thisArg] - Value to use as *this* when executing the `callback`.
 * @return {Promise} - Returns a Promise with the index that passed the test as value, otherwise *-1*.
 */
exports.findIndex = function (array, callback, thisArg) {
  return new Promise(function (resolve, reject) {
    if (array.length === 0) {
      return resolve(-1);
    }
    var counter = 1;

    var _loop4 = function _loop4(i) {
      var check = function check(found) {
        if (found) {
          resolve(i);
        } else if (counter === array.length) {
          resolve(-1);
        }
        counter++;
      };
      Promise.resolve(array[i]).then(function (elem) {
        return callback.call(thisArg || _this, elem, i, array);
      }).then(check).catch(reject);
    };

    for (var i = 0; i < array.length; i++) {
      _loop4(i);
    }
  });
};

/**
 * Same functionality as [`findIndex()`](global.html#findIndex), but runs only one callback at a time.
 * @param {Array} array - Array to iterate over.
 * @param {Function} callback - Function to apply each item in `array`. Accepts three arguments: `currentValue`, `index` and `array`.
 * @param {Object} [thisArg] - Value to use as *this* when executing the `callback`.
 * @return {Promise} - Returns a Promise with the index that passed the test, otherwise *-1*.
 */
exports.findIndexSeries = function () {
  var _ref6 = _asyncToGenerator(regeneratorRuntime.mark(function _callee6(array, callback, thisArg) {
    var i;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            i = 0;

          case 1:
            if (!(i < array.length)) {
              _context6.next = 16;
              break;
            }

            _context6.t0 = callback;
            _context6.t1 = thisArg || _this;
            _context6.next = 6;
            return array[i];

          case 6:
            _context6.t2 = _context6.sent;
            _context6.t3 = i;
            _context6.t4 = array;
            _context6.next = 11;
            return _context6.t0.call.call(_context6.t0, _context6.t1, _context6.t2, _context6.t3, _context6.t4);

          case 11:
            if (!_context6.sent) {
              _context6.next = 13;
              break;
            }

            return _context6.abrupt('return', i);

          case 13:
            i++;
            _context6.next = 1;
            break;

          case 16:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, _this);
  }));

  return function (_x16, _x17, _x18) {
    return _ref6.apply(this, arguments);
  };
}();

/**
 * Implements ES5 [`Array#some()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/some) method.<br><br>
 * Test if some element in `array` passes the test implemented in `callback`.<br>
 * Callbacks are run concurrently, meaning that all the callbacks are going to run even if some of the first elements pass the test,
 * depending on the async calls you are going to use, consider using instead [`someSeries()`](global.html#someSeries).<br>
 * @param {Array} array - Array to iterate over.
 * @param {Function} callback - Function to apply each item in `array`. Accepts three arguments: `currentValue`, `index` and `array`.
 * @param {Object} [thisArg] - Value to use as *this* when executing the `callback`.
 * @return {Promise} - Returns a Promise with *true* as value if some element passed the test, otherwise *false*.
 */
exports.some = function (array, callback, thisArg) {
  return new Promise(function (resolve, reject) {
    if (array.length === 0) {
      return resolve(false);
    }
    var counter = 1;

    var _loop5 = function _loop5(i) {
      if (!(i in array)) {
        counter++;
        return 'continue';
      }
      var check = function check(found) {
        if (found) {
          resolve(true);
        } else if (counter === array.length) {
          resolve(false);
        }
        counter++;
      };
      Promise.resolve(array[i]).then(function (elem) {
        return callback.call(thisArg || _this, elem, i, array);
      }).then(check).catch(reject);
    };

    for (var i = 0; i < array.length; i++) {
      var _ret5 = _loop5(i);

      if (_ret5 === 'continue') continue;
    }
  });
};

/**
 * Same functionality as [`some()`](global.html#some), but runs only one callback at a time.
 * @param {Array} array - Array to iterate over.
 * @param {Function} callback - Function to apply each item in `array`. Accepts three arguments: `currentValue`, `index` and `array`.
 * @param {Object} [thisArg] - Value to use as *this* when executing the `callback`.
 * @return {Promise} - Returns a Promise with *true* as value if some element passed the test, otherwise *false*.
 */
exports.someSeries = function () {
  var _ref7 = _asyncToGenerator(regeneratorRuntime.mark(function _callee7(array, callback, thisArg) {
    var i;
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            i = 0;

          case 1:
            if (!(i < array.length)) {
              _context7.next = 19;
              break;
            }

            _context7.t0 = i in array;

            if (!_context7.t0) {
              _context7.next = 14;
              break;
            }

            _context7.t1 = callback;
            _context7.t2 = thisArg || _this;
            _context7.next = 8;
            return array[i];

          case 8:
            _context7.t3 = _context7.sent;
            _context7.t4 = i;
            _context7.t5 = array;
            _context7.next = 13;
            return _context7.t1.call.call(_context7.t1, _context7.t2, _context7.t3, _context7.t4, _context7.t5);

          case 13:
            _context7.t0 = _context7.sent;

          case 14:
            if (!_context7.t0) {
              _context7.next = 16;
              break;
            }

            return _context7.abrupt('return', true);

          case 16:
            i++;
            _context7.next = 1;
            break;

          case 19:
            return _context7.abrupt('return', false);

          case 20:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, _this);
  }));

  return function (_x19, _x20, _x21) {
    return _ref7.apply(this, arguments);
  };
}();

/**
 * Implements ES5 [`Array#every()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/every) method.<br><br>
 * Test if all elements in `array` pass the test implemented in `callback`.<br>
 * Callbacks are run concurrently, meaning that all the callbacks are going to run even if any of the first elements do not pass the test,
 * depending on the async calls you are going to use, consider using instead [`everySeries()`](global.html#everySeries).<br>
 * @param {Array} array - Array to iterate over.
 * @param {Function} callback - Function to apply each item in `array`. Accepts three arguments: `currentValue`, `index` and `array`.
 * @param {Object} [thisArg] - Value to use as *this* when executing the `callback`.
 * @return {Promise} - Returns a Promise with *true* as value if all elements passed the test, otherwise *false*.
 */
exports.every = function (array, callback, thisArg) {
  return new Promise(function (resolve, reject) {
    if (array.length === 0) {
      return resolve(true);
    }
    var counter = 1;

    var _loop6 = function _loop6(i) {
      if (!(i in array)) {
        counter++;
        return 'continue';
      }
      var check = function check(found) {
        if (!found) {
          resolve(false);
        } else if (counter === array.length) {
          resolve(true);
        }
        counter++;
      };
      Promise.resolve(array[i]).then(function (elem) {
        return callback.call(thisArg || _this, elem, i, array);
      }).then(check).catch(reject);
    };

    for (var i = 0; i < array.length; i++) {
      var _ret6 = _loop6(i);

      if (_ret6 === 'continue') continue;
    }
  });
};

/**
 * Same functionality as [`every()`](global.html#every), but runs only one callback at a time.<br><br>
 * @param {Array} array - Array to iterate over.
 * @param {Function} callback - Function to apply each item in `array`. Accepts three arguments: `currentValue`, `index` and `array`.
 * @param {Object} [thisArg] - Value to use as *this* when executing the `callback`.
 * @return {Promise} - Returns a Promise with *true* as value if all elements passed the test, otherwise *false*.
 */
exports.everySeries = function () {
  var _ref8 = _asyncToGenerator(regeneratorRuntime.mark(function _callee8(array, callback, thisArg) {
    var i;
    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            i = 0;

          case 1:
            if (!(i < array.length)) {
              _context8.next = 19;
              break;
            }

            _context8.t0 = i in array;

            if (!_context8.t0) {
              _context8.next = 14;
              break;
            }

            _context8.t1 = callback;
            _context8.t2 = thisArg || _this;
            _context8.next = 8;
            return array[i];

          case 8:
            _context8.t3 = _context8.sent;
            _context8.t4 = i;
            _context8.t5 = array;
            _context8.next = 13;
            return _context8.t1.call.call(_context8.t1, _context8.t2, _context8.t3, _context8.t4, _context8.t5);

          case 13:
            _context8.t0 = !_context8.sent;

          case 14:
            if (!_context8.t0) {
              _context8.next = 16;
              break;
            }

            return _context8.abrupt('return', false);

          case 16:
            i++;
            _context8.next = 1;
            break;

          case 19:
            return _context8.abrupt('return', true);

          case 20:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, _this);
  }));

  return function (_x22, _x23, _x24) {
    return _ref8.apply(this, arguments);
  };
}();

/**
 * Implements ES5 [`Array#filter()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter) method.<br><br>
 * Creates a new array with the elements that passed the test implemented in `callback`.<br>
 * Callbacks are run concurrently.<br>
 * @param {Array} array - Array to iterate over.
 * @param {Function} callback - Function to apply each item in `array`. Accepts three arguments: `currentValue`, `index` and `array`.
 * @param {Object} [thisArg] - Value to use as *this* when executing the `callback`.
 * @return {Promise} - Returns a Promise with the resultant filtered *Array* as value.
 */
exports.filter = function (array, callback, thisArg) {
  /* two loops are necessary in order to do the filtering concurrently
   * while keeping the order of the elements
   * (if you find a better way to do it please send a PR!)
   */
  return new Promise(function () {
    var _ref9 = _asyncToGenerator(regeneratorRuntime.mark(function _callee9(resolve, reject) {
      var promiseArray, _loop7, i, filteredArray;

      return regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              promiseArray = [];

              _loop7 = function _loop7(i) {
                if (i in array) {
                  promiseArray[i] = Promise.resolve(array[i]).then(function (currentValue) {
                    return callback.call(thisArg || _this, currentValue, i, array);
                  }).catch(reject);
                }
              };

              for (i = 0; i < array.length; i++) {
                _loop7(i);
              }
              filteredArray = [];
              i = 0;

            case 5:
              if (!(i < promiseArray.length)) {
                _context9.next = 17;
                break;
              }

              _context9.next = 8;
              return promiseArray[i];

            case 8:
              if (!_context9.sent) {
                _context9.next = 14;
                break;
              }

              _context9.t0 = filteredArray;
              _context9.next = 12;
              return array[i];

            case 12:
              _context9.t1 = _context9.sent;

              _context9.t0.push.call(_context9.t0, _context9.t1);

            case 14:
              i++;
              _context9.next = 5;
              break;

            case 17:
              resolve(filteredArray);

            case 18:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this);
    }));

    return function (_x25, _x26) {
      return _ref9.apply(this, arguments);
    };
  }());
};

/**
 * Same functionality as [`filter()`](global.html#filter), but runs only one callback at a time.
 * @param {Array} array - Array to iterate over.
 * @param {Function} callback - Function to apply each item in `array`. Accepts three arguments: `currentValue`, `index` and `array`.
 * @return {Promise} - Returns a Promise with the resultant filtered *Array* as value.
 */
exports.filterSeries = function () {
  var _ref10 = _asyncToGenerator(regeneratorRuntime.mark(function _callee10(array, callback, thisArg) {
    var result, i;
    return regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            result = [];
            i = 0;

          case 2:
            if (!(i < array.length)) {
              _context10.next = 24;
              break;
            }

            _context10.t0 = i in array;

            if (!_context10.t0) {
              _context10.next = 15;
              break;
            }

            _context10.t1 = callback;
            _context10.t2 = thisArg || _this;
            _context10.next = 9;
            return array[i];

          case 9:
            _context10.t3 = _context10.sent;
            _context10.t4 = i;
            _context10.t5 = array;
            _context10.next = 14;
            return _context10.t1.call.call(_context10.t1, _context10.t2, _context10.t3, _context10.t4, _context10.t5);

          case 14:
            _context10.t0 = _context10.sent;

          case 15:
            if (!_context10.t0) {
              _context10.next = 21;
              break;
            }

            _context10.t6 = result;
            _context10.next = 19;
            return array[i];

          case 19:
            _context10.t7 = _context10.sent;

            _context10.t6.push.call(_context10.t6, _context10.t7);

          case 21:
            i++;
            _context10.next = 2;
            break;

          case 24:
            return _context10.abrupt('return', result);

          case 25:
          case 'end':
            return _context10.stop();
        }
      }
    }, _callee10, _this);
  }));

  return function (_x27, _x28, _x29) {
    return _ref10.apply(this, arguments);
  };
}();

/**
 * Implements ES5 [`Array#reduce()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce) method.<br><br>
 * Applies a `callback` against an accumulator and each element in `array`.
 * @param {Array} array - Array to iterate over.
 * @param {Function} callback - Function to apply each item in `array`. Accepts four arguments: `accumulator`, `currentValue`, `currentIndex` and `array`.
 * @param {Object} [initialValue] - Used as first argument to the first call of `callback`.
 * @return {Promise} - Returns a Promise with the resultant value from the reduction.
 */
exports.reduce = function () {
  var _ref11 = _asyncToGenerator(regeneratorRuntime.mark(function _callee11(array, callback, initialValue) {
    var i, previousValue;
    return regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            if (!(array.length === 0 && initialValue === undefined)) {
              _context11.next = 2;
              break;
            }

            throw TypeError('Reduce of empty array with no initial value');

          case 2:
            i = void 0;
            previousValue = void 0;

            if (initialValue !== undefined) {
              previousValue = initialValue;
              i = 0;
            } else {
              previousValue = array[0];
              i = 1;
            }
            i;

          case 6:
            if (!(i < array.length)) {
              _context11.next = 23;
              break;
            }

            if (!(i in array)) {
              _context11.next = 20;
              break;
            }

            _context11.t0 = callback;
            _context11.next = 11;
            return previousValue;

          case 11:
            _context11.t1 = _context11.sent;
            _context11.next = 14;
            return array[i];

          case 14:
            _context11.t2 = _context11.sent;
            _context11.t3 = i;
            _context11.t4 = array;
            _context11.next = 19;
            return (0, _context11.t0)(_context11.t1, _context11.t2, _context11.t3, _context11.t4);

          case 19:
            previousValue = _context11.sent;

          case 20:
            i++;
            _context11.next = 6;
            break;

          case 23:
            return _context11.abrupt('return', previousValue);

          case 24:
          case 'end':
            return _context11.stop();
        }
      }
    }, _callee11, _this);
  }));

  return function (_x30, _x31, _x32) {
    return _ref11.apply(this, arguments);
  };
}();

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {var ENV = {
    firebase: {
        apiKey: 'AIzaSyDlifvDfA5vvblTswPeSyprmN1lMjsjez4',
        authDomain: 'bonelldoriga-81418.firebaseapp.com',
        databaseURL: 'https://bonelldoriga-81418.firebaseio.com',
        projectId: 'bonelldoriga-81418',
        storageBucket: 'bonelldoriga-81418.appspot.com',
        messagingSenderId: '450792076555',
        appId: '1:450792076555:web:38d31d03267ba541'
    }
};

/* unused harmony default export */ var _unused_webpack_default_export = (ENV);
global.ENV = ENV;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(38)))

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Habitatges',
    name_en: 'Housing',
    name_es: 'Viviendas',
    name_db: 'residential'
}, {
    id: 2,
    name_ca: 'Oficines',
    name_en: 'Office',
    name_es: 'Oficinas',
    name_db: 'office'
}, {
    id: 3,
    name_ca: 'Locals i Naus',
    name_en: 'Retail and Industrial',
    name_es: 'Locales y Naves',
    name_db: 'retail_and_industrial'
}, {
    id: 4,
    name_ca: 'Aparcaments',
    name_en: 'Parking',
    name_es: 'Garajes',
    name_db: 'parking'
}, {
    id: 5,
    name_ca: 'Trasters',
    name_en: 'Storage',
    name_es: 'Trasteros',
    name_db: 'storage'
}, {
    id: 6,
    name_ca: 'Edificis',
    name_en: 'Buildings',
    name_es: 'Edificios',
    name_db: 'entire_buildings'
}, {
    id: 7,
    name_ca: 'Terrenys',
    name_en: 'Land',
    name_es: 'Terrenos',
    name_db: 'land'
}]);

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    acc_eco_decree: { id: 1, code_bde: 'S', name_ca: 'Sí', name_en: 'Yes', name_es: 'Sí' },
    acc_mortgage_market_law: { id: 1, code_bde: 'S', name_ca: 'Sí', name_en: 'Yes', name_es: 'Sí' },
    code_bde: 'A',
    id: 1,
    name_ca: 'Garantia hipotecària de crèdits o préstecs (ECO 2a)',
    name_en: 'Mortgage-secured loan guarantees (ECO 2a)',
    name_es: 'Garantía hipotecaria de créditos o préstamos (ECO 2a)',
    default_notes: {
        name_ca: 'La taxació SÍ és vàlida per a fins hipotecaris perquè s\'utilitza el criteri de valor garantit en el temps mitjançant un ajust del valor de mercat',
        name_en: 'The appraisal IS valid for mortgage guarantees since the criteria for the value-over-time-guarantee is applied through an adjustment of the market value',
        name_es: 'La tasación SÍ es válida para fines hipotecarios porque se utiliza el criterio del valor garantizado en el tiempo mediante ajuste del valor de mercado'
    },
    default_reduction_pct: -15
}, {
    acc_eco_decree: { id: 1, code_bde: 'S', name_ca: 'Sí', name_en: 'Yes', name_es: 'Sí' },
    acc_mortgage_market_law: { id: 1, code_bde: 'S', name_ca: 'Sí', name_en: 'Yes', name_es: 'Sí' },
    code_bde: 'B',
    id: 2,
    name_ca: 'Cobertura de provisions tècniques de les entitats asseguradores (ECO 2b)',
    name_en: 'Insurance companies technical provision coverage (ECO 2b)',
    name_es: 'Cobertura de provisiones técnicas de las entidades aseguradoras (ECO 2b)',
    default_notes: {
        name_ca: 'La taxació SÍ és vàlida per a fins hipotecaris perquè s\'utilitza el criteri de valor garantit en el temps mitjançant un ajust del valor de mercat',
        name_en: 'The appraisal IS valid for mortgage guarantees since the criteria for the value-over-time-guarantee is applied through an adjustment of the market value',
        name_es: 'La tasación SÍ es válida para fines hipotecarios porque se utiliza el criterio del valor garantizado en el tiempo mediante ajuste del valor de mercado'
    },
    default_reduction_pct: -15
}, {
    acc_eco_decree: { id: 1, code_bde: 'S', name_ca: 'Sí', name_en: 'Yes', name_es: 'Sí' },
    acc_mortgage_market_law: { id: 1, code_bde: 'S', name_ca: 'Sí', name_en: 'Yes', name_es: 'Sí' },
    code_bde: 'C',
    id: 3,
    name_ca: 'Determinació del patrimoni de les institucions d\'inversió col·lectiva immobiliàries (ECO 2c)',
    name_en: 'Net worth determination of collective investment institutions (ECO 2c)',
    name_es: 'Determinación del patrimonio de las instituciones de inversión colectiva inmobiliarias  (ECO 2c)',
    default_notes: {
        name_ca: 'La taxació SÍ és vàlida per a fins hipotecaris perquè s\'utilitza el criteri de valor garantit en el temps mitjançant un ajust del valor de mercat',
        name_en: 'The appraisal IS valid for mortgage guarantees since the criteria for the value-over-time-guarantee is applied through an adjustment of the market value',
        name_es: 'La tasación SÍ es válida para fines hipotecarios porque se utiliza el criterio del valor garantizado en el tiempo mediante ajuste del valor de mercado'
    },
    default_reduction_pct: -15
}, {
    acc_eco_decree: { id: 1, code_bde: 'S', name_ca: 'Sí', name_en: 'Yes', name_es: 'Sí' },
    acc_mortgage_market_law: { id: 1, code_bde: 'S', name_ca: 'Sí', name_en: 'Yes', name_es: 'Sí' },
    code_bde: 'D',
    id: 4,
    name_ca: 'Determinació del patrimoni immobiliari dels Fons de Pensions (ECO 2d)',
    name_en: 'Net worth determination of the state pension fund property holdings (ECO 2d)',
    name_es: 'Determinación del patrimonio inmobiliario del Fondo de Pensiones (ECO 2d)',
    default_notes: {
        name_ca: 'La taxació SÍ és vàlida per a fins hipotecaris perquè s\'utilitza el criteri de valor garantit en el temps mitjançant un ajust del valor de mercat',
        name_en: 'The appraisal IS valid for mortgage guarantees since the criteria for the value-over-time-guarantee is applied through an adjustment of the market value',
        name_es: 'La tasación SÍ es válida para fines hipotecarios porque se utiliza el criterio del valor garantizado en el tiempo mediante ajuste del valor de mercado'
    },
    default_reduction_pct: -15
}, {
    acc_eco_decree: { id: 2, code_bde: 'N', name_ca: 'No', name_en: 'No', name_es: 'No' },
    acc_mortgage_market_law: { id: 2, code_bde: 'N', name_ca: 'No', name_en: 'No', name_es: 'No' },
    code_bde: 'O',
    id: 5,
    name_ca: 'Adquisició o venda',
    name_en: 'Purchase or sale',
    name_es: 'Adquisición o venta',
    default_notes: {
        name_ca: 'La taxació NO és vàlida per a fins hipotecaris perquè no s\'utilitza el criteri de valor garantit en el temps, si més no el valor en el dia de la data consignada',
        name_en: 'The appraisal is NOT valid for mortgage guarantees since the criteria for the value-over-time-guarantee is not applied',
        name_es: 'La tasación NO es válida para fines hipotecarios porque no se utiliza el criterio del valor garantizado en el tiempo, sino el valor en el día de la fecha consignada'
    },
    default_reduction_pct: 0
}, {
    acc_eco_decree: { id: 2, code_bde: 'N', name_ca: 'No', name_en: 'No', name_es: 'No' },
    acc_mortgage_market_law: { id: 2, code_bde: 'N', name_ca: 'No', name_en: 'No', name_es: 'No' },
    code_bde: 'O',
    id: 6,
    name_ca: 'Expedients expropiatoris',
    name_en: 'Expropriation proceedings',
    name_es: 'Expedientes expropiatorios',
    obs_ca: 'La taxació NO és vàlida per a fins hipotecaris perquè no s\'utilitza el criteri de valor garantit en el temps, si més no el valor en el dia de la data consignada',
    obs_en: 'The appraisal is NOT valid for mortgage guarantees since the criteria for the value-over-time-guarantee is not applied',
    obs_es: 'La tasación NO es válida para fines hipotecarios porque no se utiliza el criterio del valor garantizado en el tiempo, sino el valor en el día de la fecha consignada',
    default_reduction_pct: 0
}, {
    acc_eco_decree: { id: 2, code_bde: 'N', name_ca: 'No', name_en: 'No', name_es: 'No' },
    acc_mortgage_market_law: { id: 2, code_bde: 'N', name_ca: 'No', name_en: 'No', name_es: 'No' },
    code_bde: 'O',
    id: 7,
    name_ca: 'Assegurament de danys',
    name_en: 'Damage insuring',
    name_es: 'Aseguramiento de daños',
    default_notes: {
        name_ca: 'La taxació NO és vàlida per a fins hipotecaris perquè no s\'utilitza el criteri de valor garantit en el temps, si més no el valor en el dia de la data consignada',
        name_en: 'The appraisal is NOT valid for mortgage guarantees since the criteria for the value-over-time-guarantee is not applied',
        name_es: 'La tasación NO es válida para fines hipotecarios porque no se utiliza el criterio del valor garantizado en el tiempo, sino el valor en el día de la fecha consignada'
    },
    default_reduction_pct: 0
}, {
    acc_eco_decree: { id: 2, code_bde: 'N', name_ca: 'No', name_en: 'No', name_es: 'No' },
    acc_mortgage_market_law: { id: 2, code_bde: 'N', name_ca: 'No', name_en: 'No', name_es: 'No' },
    code_bde: 'O',
    id: 8,
    name_ca: 'Determinació possible lloguer',
    name_en: 'Possible rent determination',
    name_es: 'Determinación posible alquiler',
    default_notes: {
        name_ca: 'La taxació NO és vàlida per a fins hipotecaris perquè no s\'utilitza el criteri de valor garantit en el temps, si més no el valor en el dia de la data consignada',
        name_en: 'The appraisal is NOT valid for mortgage guarantees since the criteria for the value-over-time-guarantee is not applied',
        name_es: 'La tasación NO es válida para fines hipotecarios porque no se utiliza el criterio del valor garantizado en el tiempo, sino el valor en el día de la fecha consignada'
    },
    default_reduction_pct: 0
}]);

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Acabat',
    name_es: 'Terminado',
    name_en: 'Finished',
    code_bde: 'U00'
}, {
    id: 2,
    name_ca: 'En construcció: obra actualment en procés d\'execució (inclou els edificis en procés de rehabilitació)',
    name_es: 'En construcción: obra en marcha (incluye los edificios en proceso de rehabilitación)',
    name_en: 'Under construction: work in process (including buildings being renovated)',
    code_bde: 'U01'
}, {
    id: 3,
    name_ca: 'En construcció: obra parada (inclou els edificis en procés de rehabilitació)',
    name_es: 'En construcción: obra parada (incluye los edificios en proceso de rehabilitación)',
    name_en: 'Under construction: work stopped (including buildings being renovated)',
    code_bde: 'U02'
}, {
    id: 4,
    name_ca: 'Inmoble en projecte. L\'obra no ha començat',
    name_es: 'Inmueble en proyecto. La obra no ha empezado',
    name_en: 'Planned. The construction has not started.',
    code_bde: 'U03'
}, {
    id: 5,
    name_ca: 'No aplicable',
    name_es: 'No aplicable',
    name_en: 'Not applicable',
    code_bde: 'ZZZ'
}]);

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Balcó',
    name_en: 'Balcony',
    name_es: 'Balcón'
}, {
    id: 2,
    name_ca: 'Porxo',
    name_en: 'Veranda',
    name_es: 'Porcho'
}, {
    id: 3,
    name_ca: 'Terrassa',
    name_en: 'Terrace',
    name_es: 'Terraza'
}, {
    id: 4,
    name_ca: 'Galeria',
    name_en: 'Gallery',
    name_es: 'Galería'
}, {
    id: 5,
    name_ca: 'Altres',
    name_en: 'Others',
    name_es: 'Otros'
}]);

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 0,
    bde_code: 0,
    name_ca: '0 - No s\'aplica, al no tractar-se d\'habitatge',
    name_en: '0 - Not applicable, the real estate is not a housing type',
    name_es: '0 - No se aplica, al no tratarse de vivienda'
}, {
    id: 1,
    bde_code: 1,
    name_ca: '1 - Habitatge unifamiliar aïllat',
    name_en: '1 - Detached single-family house',
    name_es: '1 - Vivienda unifamiliar aislada'
}, {
    id: 2,
    bde_code: 2,
    name_ca: '2 - Habitatge unifamiliar adossat',
    name_en: '2 - Terraced single-family house',
    name_es: '2 - Vivienda unifamiliar adosada'
}, {
    id: 3,
    bde_code: 3,
    name_ca: '3 - Habitatge en bloc plurifamiliar',
    name_en: '3 - Dwelling in a multi-family block',
    name_es: '3 - Vivienda en bloque plurifamiliar'
}]);

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 0,
    bde_code: '  ',
    name_ca: 'No aplicable (planta sense tipologia especial)',
    name_en: 'Not applicable (normal floor)',
    name_es: 'No aplicable (planta sin tipología especial)'
}, {
    id: 1,
    bde_code: 'SM',
    name_ca: 'Semisoterrani',
    name_en: 'Offer data',
    name_es: 'Semisótano'
}, {
    id: 2,
    bde_code: 'EN',
    name_ca: 'Entresòl',
    name_en: 'Mezzanine',
    name_es: 'Entresuelo'
}, {
    id: 3,
    bde_code: 'AT',
    name_ca: 'Àtic',
    name_en: 'Attic',
    name_es: 'Ático'
}, {
    id: 4,
    bde_code: 'OT',
    name_ca: 'Altres tipologies',
    name_en: 'Other tipologies',
    name_es: 'Otras tipologías'
}]);

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    code_bde: 'L',
    name_ca: 'Lliure',
    name_es: 'Libre',
    name_en: 'Free'
}, {
    id: 2,
    code_bde: 'A',
    name_ca: 'En lloguer o sota altre títol legal',
    name_es: 'En alquiler o bajo otro título legal',
    name_en: 'Rented or under any other legal title'
}, {
    id: 3,
    code_bde: 'O',
    name_ca: 'Ocupat sense títol',
    name_es: 'Ocupado sin título',
    name_en: 'Occupied without title'
}, {
    id: 4,
    code_bde: 'Z',
    name_ca: 'No aplicable',
    name_es: 'No aplicable',
    name_en: 'Not applicable'
}]);

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Jardí o zones verdes',
    name_en: 'Garden, green areas',
    name_es: 'Jardín, zonas verdes'
}, {
    id: 2,
    name_ca: 'Piscina, jardins',
    name_en: 'Swimming-pool, gardens',
    name_es: 'Piscina, jardines'
}, {
    id: 3,
    name_ca: 'Vials d\'accés, aparcament, maniobra de càrrega i descàrrega',
    name_en: 'Acces ways, parking, loading areas',
    name_es: 'Viales de acceso, aparcamiento, maniobra de carga y descarga'
}, {
    id: 4,
    name_ca: 'Zona infantil',
    name_en: 'Children\'s area',
    name_es: 'Zona infantil'
}, {
    id: 4,
    name_ca: 'Zones esportives',
    name_en: 'Sports areas',
    name_es: 'Zonas deportivas'
}, {
    id: 5,
    name_ca: 'No n\'hi ha',
    name_en: 'There is none',
    name_es: 'No hay'
}, {
    id: 999,
    name_ca: 'Altra',
    name_en: 'Other',
    name_es: 'Otra'
}]);

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Immoble centrat en la parcel·la',
    name_en: 'Building centered on plot',
    name_es: 'Inmueble centrado en la parcela'
}, {
    id: 2,
    name_ca: 'Lliure',
    name_en: 'Free',
    name_es: 'Libre'
}, {
    id: 3,
    name_ca: 'L\'immoble ocupa la totalitat de la parcel·la',
    name_en: 'Building occupies the whole plot',
    name_es: 'El inmueble ocupa la totalidad de la parcela'
}, {
    id: 4,
    name_ca: 'L\'immoble deixa un pati posterior',
    name_en: 'Building with a backyard',
    name_es: 'El inmueble deja un patio posterior'
}, {
    id: 999,
    name_ca: 'Altra',
    name_en: 'Other',
    name_es: 'Otra'
}]);

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Molt alta',
    name_en: 'Very high',
    name_es: 'Muy alta'
}, {
    id: 2,
    name_ca: 'Alta',
    name_en: 'High',
    name_es: 'Alta'
}, {
    id: 3,
    name_ca: 'Mitjana-alta',
    name_en: 'Medium-high',
    name_es: 'Media alta'
}, {
    id: 4,
    name_ca: 'Mitjana',
    name_en: 'Medium',
    name_es: 'Media'
}, {
    id: 5,
    name_ca: 'Mitjana-baixa',
    name_en: 'Medium-low',
    name_es: 'Media baja'
}, {
    id: 6,
    name_ca: 'Baixa',
    name_en: 'Low',
    name_es: 'Baja'
}, {
    id: 7,
    name_ca: 'Molt baixa',
    name_en: 'Very low',
    name_es: 'Muy baja'
}]);

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Estar (E)',
    name_en: 'Living (E)',
    name_es: 'Estar (E)',
    code_ca: 'E'
}, {
    id: 2,
    name_ca: 'Estar / Menjador (E-M)',
    name_en: 'Living / Dinning (L-D)',
    name_es: 'Estar / Comedor (E-C)',
    code_ca: 'E-M'
}, {
    id: 3,
    name_ca: 'Estar / Menjador / Cuina (E-M-C)',
    name_en: 'Living / Dinning / Kitchen (L-D-K)',
    name_es: 'Estar / Comedor / Cocina',
    code_ca: 'E-M-C'
}, {
    id: 4,
    name_ca: 'Menjador (M)',
    name_en: 'Dinning (D)',
    name_es: 'Comedor (C)',
    code_ca: 'M'
}, {
    id: 5,
    name_ca: 'Cuina (C)',
    name_en: 'Kitchen (K)',
    name_es: 'Cocina (C)',
    code_ca: 'C'
}, {
    id: 6,
    name_ca: 'Habitació (H)',
    name_en: 'Room (R)',
    name_es: 'Habitación (H)',
    code_ca: 'H'
}, {
    id: 7,
    name_ca: 'Cambra Higiènica (CH)',
    name_en: 'Bathroom (B)',
    name_es: 'Baño (B)',
    code_ca: 'CH'
}, {
    id: 8,
    name_ca: 'Emmagatzematge Personal (EP)',
    name_en: 'Personal Storage (PS)',
    name_es: 'Almacenamiento Personal (AP)',
    code_ca: 'EP'
}, {
    id: 9,
    name_ca: 'Emmagatzematge General (EG)',
    name_en: 'General Storage (GS)',
    name_es: 'Almacenamiento General (AG)',
    code_ca: 'EG'
}, {
    id: 10,
    name_ca: 'Espais intermedis amb l\'exterior (EI)',
    name_en: 'Indoor-Outdoor intermediate spaces (IS)',
    name_es: 'Espacios intermedios con el exterior (EI)',
    code_ca: 'EI'
}, {
    id: 11,
    name_ca: 'Altres (A)',
    name_en: 'Others (O)',
    name_es: 'Otros (O)',
    code_ca: 'A'
}]);

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Auto',
    name_en: 'Auto',
    name_es: 'Auto'
}, {
    id: 2,
    name_ca: 'Registral',
    name_en: 'Registry',
    name_es: 'Registral'
}, {
    id: 3,
    name_ca: 'Cadastral',
    name_en: 'Cadastral',
    name_es: 'Catastral'
}, {
    id: 4,
    name_ca: 'Comprovada',
    name_en: 'Checked',
    name_es: 'Comprobada'
}]);

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Balcó',
    name_en: 'Balcony',
    name_es: 'Balcón'
}, {
    id: 2,
    name_ca: 'Jardí',
    name_en: 'Garden',
    name_es: 'Jardín'
}, {
    id: 3,
    name_ca: 'Terrassa',
    name_en: 'Terrace',
    name_es: 'Terraza'
}, {
    id: 4,
    name_ca: 'Pati',
    name_en: 'Courtyard',
    name_es: 'Patio'
}, {
    id: 5,
    name_ca: 'Altres',
    name_en: 'Others',
    name_es: 'Otros'
}]);

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = averageOf;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__total_of__ = __webpack_require__(256);


function averageOf(array, callback) {
    var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__total_of__["a" /* default */])(array, callback);

    return value ? value / array.length : false;
}

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type_validator__ = __webpack_require__(253);


var floatTest = /^(\-|\+)?([0-9]+(\.[0-9]+)?|Infinity)$/;

var evaluators = [{
    test: function test(value) {
        return __WEBPACK_IMPORTED_MODULE_0__type_validator__["b" /* isNumber */](value) ? true : floatTest.test(value);
    },
    toNumber: parseFloat
}, {
    test: function test(value) {
        if (__WEBPACK_IMPORTED_MODULE_0__type_validator__["c" /* isDate */](value)) {
            return true;
        }

        var date = new Date(value);
        return __WEBPACK_IMPORTED_MODULE_0__type_validator__["c" /* isDate */](date);
    },
    toNumber: function toNumber(value) {
        return new Date(value).getTime();
    }
}];

function toNumber(value) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {

        for (var _iterator = evaluators[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var evaluator = _step.value;

            var result = evaluator.test(value);

            if (result) {
                return evaluator.toNumber;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return function (value) {
        return value;
    };
}

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isAny */
/* unused harmony export isArray */
/* unused harmony export isBoolean */
/* harmony export (immutable) */ __webpack_exports__["c"] = isDate;
/* unused harmony export isNull */
/* harmony export (immutable) */ __webpack_exports__["b"] = isNumber;
/* unused harmony export isObject */
/* unused harmony export isString */
/* unused harmony export isUndefined */
/* unused harmony export isPrimitive */
/* harmony export (immutable) */ __webpack_exports__["a"] = isCollection;

var types = {
    array: "[object Array]",
    boolean: "[object Boolean]",
    date: "[object Date]",
    null: "[object Null]",
    number: "[object Number]",
    object: "[object Object]",
    string: "[object String]",
    undefined: "[object Undefined]"
};

function isType(value, type) {
    return type === Object.prototype.toString.call(value);
}

function isAny(value) {
    var any = false;
    var index = 0;

    for (var _len = arguments.length, validators = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        validators[_key - 1] = arguments[_key];
    }

    while (!any && index < validators.length) {
        any = validators[index].call(this, value);
        index++;
    }

    return any;
}

function isArray(value) {
    return isType(value, types.array);
}

function isBoolean(value) {
    return isType(value, types.boolean);
}

function isDate(value) {
    return isType(value, types.date) && !isNaN(value.getTime());
}

function isNull(value) {
    return isType(value, types.null);
}

function isNumber(value) {
    return isType(value, types.number);
}

function isObject(value) {
    return isType(value, types.object);
}

function isString(value) {
    return isType(value, types.string);
}

function isUndefined(value) {
    return isType(value, types.undefined);
}

function isPrimitive(value) {
    return !isAny(value, isArray, isDate, isObject);
}

function isCollection(value) {
    return isAny(value, isArray, isObject);
}

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = filterBy;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// Need to add support for searching dates
var SEARCHABLE_TYPES = ["string", "number", "boolean"];

/**
 * Filter an array of objects by the given phrase
 * 
 * @export
 * @param {Array} array
 * @param {String} filter
 * @returns Array
 */
function filterBy(array, filter) {
    if (!filter) {
        return array;
    }

    var filtered = [];

    for (var i = 0; i < array.length; i++) {
        var item = array[i];

        for (var prop in item) {
            var value = item[prop];

            // Ensure the value is of a searchable type 
            // This will automatically handle null values
            if (SEARCHABLE_TYPES.indexOf(typeof value === "undefined" ? "undefined" : _typeof(value)) < 0) {
                continue;
            }

            // Normalise the value to get a consistent match
            var normalised = value.toString().toLowerCase();

            if (normalised.indexOf(filter.toLowerCase()) > -1) {
                filtered.push(item);
                break;
            }
        }
    }

    return filtered;
}

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sortBy;
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// Consider making this immutable. I'm undecided at the moment.
/**
 * Sort an array of objects by the given key and direction
 * 
 * @export
 * @param {Array} array The array to be sorted
 * @param {Function} callback The callback function to invoke to receive the key to sort on
 * @param {Number} direction The direction of the sort
 */
function sortBy(array, callback, direction) {

    direction = direction || 1;
    callback = callback || function (item) {
        return item;
    };

    if (Math.abs(direction) !== 1) {
        throw new Error("Sort direction must be either 1 (ascending) or -1 (descending)");
    }

    var sortArray = [].concat(_toConsumableArray(array));

    sortArray.sort(function (a, b) {
        var valueA = callback.call(array, a);
        var valueB = callback.call(array, b);

        var outcome = valueA < valueB ? -1 : valueA > valueB ? 1 : 0;

        return outcome * direction;
    });

    return sortArray;
}

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = totalOf;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_aggregator__ = __webpack_require__(124);


function total(accumulator, value) {
    var num = parseFloat(value);

    return isNaN(num) ? false : accumulator + num;
}

function totalOf(array, callback) {

    callback = callback || function (item) {
        return item;
    };

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__base_aggregator__["a" /* default */])(array, function (accumulator, item, array) {
        var value = callback.call(array, item);

        return total.call(array, accumulator, value);
    });
}

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = varianceOf;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_aggregator__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__average_of__ = __webpack_require__(251);



function varianceOf(array, callback) {
    var count = array.length;
    var average = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__average_of__["a" /* default */])(array, callback);

    var totalVariance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__base_aggregator__["a" /* default */])(array, function (accumulator, item, array) {
        var value = callback.call(array, item);

        return accumulator + Math.pow(value - average, 2);
    });

    return totalVariance ? totalVariance / count : false;
}

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(49);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(37);
var toAbsoluteIndex = __webpack_require__(87);
var toLength = __webpack_require__(36);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(79);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(39);
var toObject = __webpack_require__(37);
var IObject = __webpack_require__(104);
var toLength = __webpack_require__(36);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(39);
var isObject = __webpack_require__(30);
var invoke = __webpack_require__(268);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(35).f;
var create = __webpack_require__(81);
var redefineAll = __webpack_require__(85);
var ctx = __webpack_require__(50);
var anInstance = __webpack_require__(78);
var forOf = __webpack_require__(79);
var $iterDefine = __webpack_require__(180);
var step = __webpack_require__(271);
var setSpecies = __webpack_require__(86);
var DESCRIPTORS = __webpack_require__(34);
var fastKey = __webpack_require__(72).fastKey;
var validate = __webpack_require__(96);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(103);
var from = __webpack_require__(260);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(85);
var getWeak = __webpack_require__(72).getWeak;
var anObject = __webpack_require__(24);
var isObject = __webpack_require__(30);
var anInstance = __webpack_require__(78);
var forOf = __webpack_require__(79);
var createArrayMethod = __webpack_require__(55);
var $has = __webpack_require__(41);
var validate = __webpack_require__(96);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(129);
var isObject = __webpack_require__(30);
var toLength = __webpack_require__(36);
var ctx = __webpack_require__(50);
var IS_CONCAT_SPREADABLE = __webpack_require__(32)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(34) && !__webpack_require__(29)(function () {
  return Object.defineProperty(__webpack_require__(173)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 268 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(30);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(24);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 271 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(182);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 273 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 274 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(83);
var gOPS = __webpack_require__(133);
var pIE = __webpack_require__(105);
var toObject = __webpack_require__(37);
var IObject = __webpack_require__(104);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(29)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(35);
var anObject = __webpack_require__(24);
var getKeys = __webpack_require__(83);

module.exports = __webpack_require__(34) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(47);
var gOPN = __webpack_require__(82).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(41);
var toIObject = __webpack_require__(47);
var arrayIndexOf = __webpack_require__(125)(false);
var IE_PROTO = __webpack_require__(186)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(83);
var toIObject = __webpack_require__(47);
var isEnum = __webpack_require__(105).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(82);
var gOPS = __webpack_require__(133);
var anObject = __webpack_require__(24);
var Reflect = __webpack_require__(26).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(26).parseFloat;
var $trim = __webpack_require__(95).trim;

module.exports = 1 / $parseFloat(__webpack_require__(190) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(26).parseInt;
var $trim = __webpack_require__(95).trim;
var ws = __webpack_require__(190);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 283 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(24);
var isObject = __webpack_require__(30);
var newPromiseCapability = __webpack_require__(184);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(36);
var repeat = __webpack_require__(189);
var defined = __webpack_require__(57);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(59);
var toLength = __webpack_require__(36);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(32);


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(263);
var validate = __webpack_require__(96);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(126)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(34) && /./g.flags != 'g') __webpack_require__(35).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(128)
});


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(263);
var validate = __webpack_require__(96);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(126)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each = __webpack_require__(55)(0);
var redefine = __webpack_require__(43);
var meta = __webpack_require__(72);
var assign = __webpack_require__(275);
var weak = __webpack_require__(265);
var isObject = __webpack_require__(30);
var fails = __webpack_require__(29);
var validate = __webpack_require__(96);
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(126)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(931), __webpack_require__(1235), __webpack_require__(1145)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('./clipboard-action'), require('tiny-emitter'), require('good-listener'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.clipboardAction, global.tinyEmitter, global.goodListener);
        global.clipboard = mod.exports;
    }
})(this, function (module, _clipboardAction, _tinyEmitter, _goodListener) {
    'use strict';

    var _clipboardAction2 = _interopRequireDefault(_clipboardAction);

    var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);

    var _goodListener2 = _interopRequireDefault(_goodListener);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    function _possibleConstructorReturn(self, call) {
        if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var Clipboard = function (_Emitter) {
        _inherits(Clipboard, _Emitter);

        /**
         * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
         * @param {Object} options
         */
        function Clipboard(trigger, options) {
            _classCallCheck(this, Clipboard);

            var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this));

            _this.resolveOptions(options);
            _this.listenClick(trigger);
            return _this;
        }

        /**
         * Defines if attributes would be resolved using internal setter functions
         * or custom functions that were passed in the constructor.
         * @param {Object} options
         */


        _createClass(Clipboard, [{
            key: 'resolveOptions',
            value: function resolveOptions() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
                this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
                this.text = typeof options.text === 'function' ? options.text : this.defaultText;
                this.container = _typeof(options.container) === 'object' ? options.container : document.body;
            }
        }, {
            key: 'listenClick',
            value: function listenClick(trigger) {
                var _this2 = this;

                this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {
                    return _this2.onClick(e);
                });
            }
        }, {
            key: 'onClick',
            value: function onClick(e) {
                var trigger = e.delegateTarget || e.currentTarget;

                if (this.clipboardAction) {
                    this.clipboardAction = null;
                }

                this.clipboardAction = new _clipboardAction2.default({
                    action: this.action(trigger),
                    target: this.target(trigger),
                    text: this.text(trigger),
                    container: this.container,
                    trigger: trigger,
                    emitter: this
                });
            }
        }, {
            key: 'defaultAction',
            value: function defaultAction(trigger) {
                return getAttributeValue('action', trigger);
            }
        }, {
            key: 'defaultTarget',
            value: function defaultTarget(trigger) {
                var selector = getAttributeValue('target', trigger);

                if (selector) {
                    return document.querySelector(selector);
                }
            }
        }, {
            key: 'defaultText',
            value: function defaultText(trigger) {
                return getAttributeValue('text', trigger);
            }
        }, {
            key: 'destroy',
            value: function destroy() {
                this.listener.destroy();

                if (this.clipboardAction) {
                    this.clipboardAction.destroy();
                    this.clipboardAction = null;
                }
            }
        }], [{
            key: 'isSupported',
            value: function isSupported() {
                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];

                var actions = typeof action === 'string' ? [action] : action;
                var support = !!document.queryCommandSupported;

                actions.forEach(function (action) {
                    support = support && !!document.queryCommandSupported(action);
                });

                return support;
            }
        }]);

        return Clipboard;
    }(_tinyEmitter2.default);

    /**
     * Helper function to retrieve attribute value.
     * @param {String} suffix
     * @param {Element} element
     */
    function getAttributeValue(suffix, element) {
        var attribute = 'data-clipboard-' + suffix;

        if (!element.hasAttribute(attribute)) {
            return;
        }

        return element.getAttribute(attribute);
    }

    module.exports = Clipboard;
});

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var addMilliseconds = __webpack_require__(107)

var MILLISECONDS_IN_HOUR = 3600000

/**
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be added
 * @returns {Date} the new date with the hours added
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * var result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */
function addHours (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_HOUR)
}

module.exports = addHours


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__(89)
var setISOYear = __webpack_require__(320)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Add the specified number of ISO week-numbering years to the given date.
 *
 * @description
 * Add the specified number of ISO week-numbering years to the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of ISO week-numbering years to be added
 * @returns {Date} the new date with the ISO week-numbering years added
 *
 * @example
 * // Add 5 ISO week-numbering years to 2 July 2010:
 * var result = addISOYears(new Date(2010, 6, 2), 5)
 * //=> Fri Jun 26 2015 00:00:00
 */
function addISOYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return setISOYear(dirtyDate, getISOYear(dirtyDate) + amount)
}

module.exports = addISOYears


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var addMilliseconds = __webpack_require__(107)

var MILLISECONDS_IN_MINUTE = 60000

/**
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be added
 * @returns {Date} the new date with the minutes added
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * var result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */
function addMinutes (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE)
}

module.exports = addMinutes


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var addMonths = __webpack_require__(139)

/**
 * @category Quarter Helpers
 * @summary Add the specified number of year quarters to the given date.
 *
 * @description
 * Add the specified number of year quarters to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of quarters to be added
 * @returns {Date} the new date with the quarters added
 *
 * @example
 * // Add 1 quarter to 1 September 2014:
 * var result = addQuarters(new Date(2014, 8, 1), 1)
 * //=> Mon Dec 01 2014 00:00:00
 */
function addQuarters (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  var months = amount * 3
  return addMonths(dirtyDate, months)
}

module.exports = addQuarters


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var addMilliseconds = __webpack_require__(107)

/**
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of seconds to be added
 * @returns {Date} the new date with the seconds added
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * var result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */
function addSeconds (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMilliseconds(dirtyDate, amount * 1000)
}

module.exports = addSeconds


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var addMonths = __webpack_require__(139)

/**
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added
 * @returns {Date} the new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * var result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */
function addYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMonths(dirtyDate, amount * 12)
}

module.exports = addYears


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__(89)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of calendar ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of calendar ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar ISO week-numbering years
 *
 * @example
 * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
 * var result = differenceInCalendarISOYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 2
 */
function differenceInCalendarISOYears (dirtyDateLeft, dirtyDateRight) {
  return getISOYear(dirtyDateLeft) - getISOYear(dirtyDateRight)
}

module.exports = differenceInCalendarISOYears


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */
function differenceInCalendarMonths (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear()
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth()

  return yearDiff * 12 + monthDiff
}

module.exports = differenceInCalendarMonths


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar years
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * var result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */
function differenceInCalendarYears (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  return dateLeft.getFullYear() - dateRight.getFullYear()
}

module.exports = differenceInCalendarYears


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)
var differenceInCalendarDays = __webpack_require__(140)
var compareAsc = __webpack_require__(108)

/**
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full days between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full days
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 */
function differenceInDays (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarDays(dateLeft, dateRight))
  dateLeft.setDate(dateLeft.getDate() - sign * difference)

  // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastDayNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastDayNotFull)
}

module.exports = differenceInDays


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var compareDesc = __webpack_require__(197)
var parse = __webpack_require__(4)
var differenceInSeconds = __webpack_require__(199)
var differenceInMonths = __webpack_require__(198)
var enLocale = __webpack_require__(205)

var MINUTES_IN_DAY = 1440
var MINUTES_IN_ALMOST_TWO_DAYS = 2520
var MINUTES_IN_MONTH = 43200
var MINUTES_IN_TWO_MONTHS = 86400

/**
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words.
 *
 * | Distance between dates                                            | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance between dates | Result               |
 * |------------------------|----------------------|
 * | 0 secs ... 5 secs      | less than 5 seconds  |
 * | 5 secs ... 10 secs     | less than 10 seconds |
 * | 10 secs ... 20 secs    | less than 20 seconds |
 * | 20 secs ... 40 secs    | half a minute        |
 * | 40 secs ... 60 secs    | less than a minute   |
 * | 60 secs ... 90 secs    | 1 minute             |
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date|String|Number} date - the other date
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the distance in words
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * var result = distanceInWords(
 *   new Date(2014, 6, 2),
 *   new Date(2015, 0, 1)
 * )
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00, including seconds?
 * var result = distanceInWords(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * var result = distanceInWords(
 *   new Date(2016, 0, 1),
 *   new Date(2015, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'about 1 year ago'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * var eoLocale = require('date-fns/locale/eo')
 * var result = distanceInWords(
 *   new Date(2016, 7, 1),
 *   new Date(2015, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */
function distanceInWords (dirtyDateToCompare, dirtyDate, dirtyOptions) {
  var options = dirtyOptions || {}

  var comparison = compareDesc(dirtyDateToCompare, dirtyDate)

  var locale = options.locale
  var localize = enLocale.distanceInWords.localize
  if (locale && locale.distanceInWords && locale.distanceInWords.localize) {
    localize = locale.distanceInWords.localize
  }

  var localizeOptions = {
    addSuffix: Boolean(options.addSuffix),
    comparison: comparison
  }

  var dateLeft, dateRight
  if (comparison > 0) {
    dateLeft = parse(dirtyDateToCompare)
    dateRight = parse(dirtyDate)
  } else {
    dateLeft = parse(dirtyDate)
    dateRight = parse(dirtyDateToCompare)
  }

  var seconds = differenceInSeconds(dateRight, dateLeft)
  var offset = dateRight.getTimezoneOffset() - dateLeft.getTimezoneOffset()
  var minutes = Math.round(seconds / 60) - offset
  var months

  // 0 up to 2 mins
  if (minutes < 2) {
    if (options.includeSeconds) {
      if (seconds < 5) {
        return localize('lessThanXSeconds', 5, localizeOptions)
      } else if (seconds < 10) {
        return localize('lessThanXSeconds', 10, localizeOptions)
      } else if (seconds < 20) {
        return localize('lessThanXSeconds', 20, localizeOptions)
      } else if (seconds < 40) {
        return localize('halfAMinute', null, localizeOptions)
      } else if (seconds < 60) {
        return localize('lessThanXMinutes', 1, localizeOptions)
      } else {
        return localize('xMinutes', 1, localizeOptions)
      }
    } else {
      if (minutes === 0) {
        return localize('lessThanXMinutes', 1, localizeOptions)
      } else {
        return localize('xMinutes', minutes, localizeOptions)
      }
    }

  // 2 mins up to 0.75 hrs
  } else if (minutes < 45) {
    return localize('xMinutes', minutes, localizeOptions)

  // 0.75 hrs up to 1.5 hrs
  } else if (minutes < 90) {
    return localize('aboutXHours', 1, localizeOptions)

  // 1.5 hrs up to 24 hrs
  } else if (minutes < MINUTES_IN_DAY) {
    var hours = Math.round(minutes / 60)
    return localize('aboutXHours', hours, localizeOptions)

  // 1 day up to 1.75 days
  } else if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) {
    return localize('xDays', 1, localizeOptions)

  // 1.75 days up to 30 days
  } else if (minutes < MINUTES_IN_MONTH) {
    var days = Math.round(minutes / MINUTES_IN_DAY)
    return localize('xDays', days, localizeOptions)

  // 1 month up to 2 months
  } else if (minutes < MINUTES_IN_TWO_MONTHS) {
    months = Math.round(minutes / MINUTES_IN_MONTH)
    return localize('aboutXMonths', months, localizeOptions)
  }

  months = differenceInMonths(dateRight, dateLeft)

  // 2 months up to 12 months
  if (months < 12) {
    var nearestMonth = Math.round(minutes / MINUTES_IN_MONTH)
    return localize('xMonths', nearestMonth, localizeOptions)

  // 1 year up to max Date
  } else {
    var monthsSinceStartOfYear = months % 12
    var years = Math.floor(months / 12)

    // N years up to 1 years 3 months
    if (monthsSinceStartOfYear < 3) {
      return localize('aboutXYears', years, localizeOptions)

    // N years 3 months up to N years 9 months
    } else if (monthsSinceStartOfYear < 9) {
      return localize('overXYears', years, localizeOptions)

    // N years 9 months up to N year 12 months
    } else {
      return localize('almostXYears', years + 1, localizeOptions)
    }
  }
}

module.exports = distanceInWords


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a month
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * var result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var month = date.getMonth()
  date.setFullYear(date.getFullYear(), month + 1, 0)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfMonth


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the end of a week
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

  var date = parse(dirtyDate)
  var day = date.getDay()
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn)

  date.setDate(date.getDate() + diff)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfWeek


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)
var startOfYear = __webpack_require__(326)
var differenceInCalendarDays = __webpack_require__(140)

/**
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * var result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */
function getDayOfYear (dirtyDate) {
  var date = parse(dirtyDate)
  var diff = differenceInCalendarDays(date, startOfYear(date))
  var dayOfYear = diff + 1
  return dayOfYear
}

module.exports = getDayOfYear


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Weekday Helpers
 * @summary Get the day of the ISO week of the given date.
 *
 * @description
 * Get the day of the ISO week of the given date,
 * which is 7 for Sunday, 1 for Monday etc.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of ISO week
 *
 * @example
 * // Which day of the ISO week is 26 February 2012?
 * var result = getISODay(new Date(2012, 1, 26))
 * //=> 7
 */
function getISODay (dirtyDate) {
  var date = parse(dirtyDate)
  var day = date.getDay()

  if (day === 0) {
    day = 7
  }

  return day
}

module.exports = getISODay


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the quarter
 *
 * @example
 * // Which quarter is 2 July 2014?
 * var result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */
function getQuarter (dirtyDate) {
  var date = parse(dirtyDate)
  var quarter = Math.floor(date.getMonth() / 3) + 1
  return quarter
}

module.exports = getQuarter


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Year Helpers
 * @summary Is the given date in the leap year?
 *
 * @description
 * Is the given date in the leap year?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in the leap year
 *
 * @example
 * // Is 1 September 2012 in the leap year?
 * var result = isLeapYear(new Date(2012, 8, 1))
 * //=> true
 */
function isLeapYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0
}

module.exports = isLeapYear


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var startOfHour = __webpack_require__(322)

/**
 * @category Hour Helpers
 * @summary Are the given dates in the same hour?
 *
 * @description
 * Are the given dates in the same hour?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same hour
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
 * var result = isSameHour(
 *   new Date(2014, 8, 4, 6, 0),
 *   new Date(2014, 8, 4, 6, 30)
 * )
 * //=> true
 */
function isSameHour (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfHour = startOfHour(dirtyDateLeft)
  var dateRightStartOfHour = startOfHour(dirtyDateRight)

  return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime()
}

module.exports = isSameHour


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var isSameWeek = __webpack_require__(204)

/**
 * @category ISO Week Helpers
 * @summary Are the given dates in the same ISO week?
 *
 * @description
 * Are the given dates in the same ISO week?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same ISO week
 *
 * @example
 * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
 * var result = isSameISOWeek(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 8, 7)
 * )
 * //=> true
 */
function isSameISOWeek (dirtyDateLeft, dirtyDateRight) {
  return isSameWeek(dirtyDateLeft, dirtyDateRight, {weekStartsOn: 1})
}

module.exports = isSameISOWeek


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var startOfISOYear = __webpack_require__(109)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Are the given dates in the same ISO week-numbering year?
 *
 * @description
 * Are the given dates in the same ISO week-numbering year?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same ISO week-numbering year
 *
 * @example
 * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
 * var result = isSameISOYear(
 *   new Date(2003, 11, 29),
 *   new Date(2005, 0, 2)
 * )
 * //=> true
 */
function isSameISOYear (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfYear = startOfISOYear(dirtyDateLeft)
  var dateRightStartOfYear = startOfISOYear(dirtyDateRight)

  return dateLeftStartOfYear.getTime() === dateRightStartOfYear.getTime()
}

module.exports = isSameISOYear


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var startOfMinute = __webpack_require__(323)

/**
 * @category Minute Helpers
 * @summary Are the given dates in the same minute?
 *
 * @description
 * Are the given dates in the same minute?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same minute
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15
 * // in the same minute?
 * var result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 4, 6, 30, 15)
 * )
 * //=> true
 */
function isSameMinute (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfMinute = startOfMinute(dirtyDateLeft)
  var dateRightStartOfMinute = startOfMinute(dirtyDateRight)

  return dateLeftStartOfMinute.getTime() === dateRightStartOfMinute.getTime()
}

module.exports = isSameMinute


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Month Helpers
 * @summary Are the given dates in the same month?
 *
 * @description
 * Are the given dates in the same month?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * var result = isSameMonth(
 *   new Date(2014, 8, 2),
 *   new Date(2014, 8, 25)
 * )
 * //=> true
 */
function isSameMonth (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)
  return dateLeft.getFullYear() === dateRight.getFullYear() &&
    dateLeft.getMonth() === dateRight.getMonth()
}

module.exports = isSameMonth


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var startOfQuarter = __webpack_require__(324)

/**
 * @category Quarter Helpers
 * @summary Are the given dates in the same year quarter?
 *
 * @description
 * Are the given dates in the same year quarter?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same quarter
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * var result = isSameQuarter(
 *   new Date(2014, 0, 1),
 *   new Date(2014, 2, 8)
 * )
 * //=> true
 */
function isSameQuarter (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfQuarter = startOfQuarter(dirtyDateLeft)
  var dateRightStartOfQuarter = startOfQuarter(dirtyDateRight)

  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime()
}

module.exports = isSameQuarter


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var startOfSecond = __webpack_require__(325)

/**
 * @category Second Helpers
 * @summary Are the given dates in the same second?
 *
 * @description
 * Are the given dates in the same second?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same second
 *
 * @example
 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500
 * // in the same second?
 * var result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 30, 15),
 *   new Date(2014, 8, 4, 6, 30, 15, 500)
 * )
 * //=> true
 */
function isSameSecond (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfSecond = startOfSecond(dirtyDateLeft)
  var dateRightStartOfSecond = startOfSecond(dirtyDateRight)

  return dateLeftStartOfSecond.getTime() === dateRightStartOfSecond.getTime()
}

module.exports = isSameSecond


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same year
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * var result = isSameYear(
 *   new Date(2014, 8, 2),
 *   new Date(2014, 8, 25)
 * )
 * //=> true
 */
function isSameYear (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)
  return dateLeft.getFullYear() === dateRight.getFullYear()
}

module.exports = isSameYear


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var isDate = __webpack_require__(203)

/**
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {Date} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} argument must be an instance of Date
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */
function isValid (dirtyDate) {
  if (isDate(dirtyDate)) {
    return !isNaN(dirtyDate)
  } else {
    throw new TypeError(toString.call(dirtyDate) + ' is not an instance of Date')
  }
}

module.exports = isValid


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Week Helpers
 * @summary Return the last day of a week for the given date.
 *
 * @description
 * Return the last day of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the last day of a week
 *
 * @example
 * // The last day of a week for 2 September 2014 11:55:00:
 * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
 * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Sun Sep 07 2014 00:00:00
 */
function lastDayOfWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

  var date = parse(dirtyDate)
  var day = date.getDay()
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn)

  date.setHours(0, 0, 0, 0)
  date.setDate(date.getDate() + diff)
  return date
}

module.exports = lastDayOfWeek


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)
var startOfISOYear = __webpack_require__(109)
var differenceInCalendarDays = __webpack_require__(140)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Set the ISO week-numbering year to the given date.
 *
 * @description
 * Set the ISO week-numbering year to the given date,
 * saving the week number and the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} isoYear - the ISO week-numbering year of the new date
 * @returns {Date} the new date with the ISO week-numbering year setted
 *
 * @example
 * // Set ISO week-numbering year 2007 to 29 December 2008:
 * var result = setISOYear(new Date(2008, 11, 29), 2007)
 * //=> Mon Jan 01 2007 00:00:00
 */
function setISOYear (dirtyDate, dirtyISOYear) {
  var date = parse(dirtyDate)
  var isoYear = Number(dirtyISOYear)
  var diff = differenceInCalendarDays(date, startOfISOYear(date))
  var fourthOfJanuary = new Date(0)
  fourthOfJanuary.setFullYear(isoYear, 0, 4)
  fourthOfJanuary.setHours(0, 0, 0, 0)
  date = startOfISOYear(fourthOfJanuary)
  date.setDate(date.getDate() + diff)
  return date
}

module.exports = setISOYear


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)
var getDaysInMonth = __webpack_require__(201)

/**
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @returns {Date} the new date with the month setted
 *
 * @example
 * // Set February to 1 September 2014:
 * var result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */
function setMonth (dirtyDate, dirtyMonth) {
  var date = parse(dirtyDate)
  var month = Number(dirtyMonth)
  var year = date.getFullYear()
  var day = date.getDate()

  var dateWithDesiredMonth = new Date(0)
  dateWithDesiredMonth.setFullYear(year, month, 15)
  dateWithDesiredMonth.setHours(0, 0, 0, 0)
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth)
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  date.setMonth(month, Math.min(day, daysInMonth))
  return date
}

module.exports = setMonth


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Hour Helpers
 * @summary Return the start of an hour for the given date.
 *
 * @description
 * Return the start of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an hour
 *
 * @example
 * // The start of an hour for 2 September 2014 11:55:00:
 * var result = startOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:00:00
 */
function startOfHour (dirtyDate) {
  var date = parse(dirtyDate)
  date.setMinutes(0, 0, 0)
  return date
}

module.exports = startOfHour


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Minute Helpers
 * @summary Return the start of a minute for the given date.
 *
 * @description
 * Return the start of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a minute
 *
 * @example
 * // The start of a minute for 1 December 2014 22:15:45.400:
 * var result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:00
 */
function startOfMinute (dirtyDate) {
  var date = parse(dirtyDate)
  date.setSeconds(0, 0)
  return date
}

module.exports = startOfMinute


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a quarter
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * var result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */
function startOfQuarter (dirtyDate) {
  var date = parse(dirtyDate)
  var currentMonth = date.getMonth()
  var month = currentMonth - currentMonth % 3
  date.setMonth(month, 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfQuarter


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Second Helpers
 * @summary Return the start of a second for the given date.
 *
 * @description
 * Return the start of a second for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a second
 *
 * @example
 * // The start of a second for 1 December 2014 22:15:45.400:
 * var result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.000
 */
function startOfSecond (dirtyDate) {
  var date = parse(dirtyDate)
  date.setMilliseconds(0)
  return date
}

module.exports = startOfSecond


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * var result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear (dirtyDate) {
  var cleanDate = parse(dirtyDate)
  var date = new Date(0)
  date.setFullYear(cleanDate.getFullYear(), 0, 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfYear


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var addISOYears = __webpack_require__(294)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Subtract the specified number of ISO week-numbering years from the given date.
 *
 * @description
 * Subtract the specified number of ISO week-numbering years from the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of ISO week-numbering years to be subtracted
 * @returns {Date} the new date with the ISO week-numbering years subtracted
 *
 * @example
 * // Subtract 5 ISO week-numbering years from 1 September 2014:
 * var result = subISOYears(new Date(2014, 8, 1), 5)
 * //=> Mon Aug 31 2009 00:00:00
 */
function subISOYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addISOYears(dirtyDate, -amount)
}

module.exports = subISOYears


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FontMetrics = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Util = __webpack_require__(111);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SAMPLE_TEXT = 'Hidden Text';

var FontMetrics = exports.FontMetrics = function () {
    function FontMetrics(document) {
        _classCallCheck(this, FontMetrics);

        this._data = {};
        this._document = document;
    }

    _createClass(FontMetrics, [{
        key: '_parseMetrics',
        value: function _parseMetrics(font) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');

            var body = this._document.body;
            if (!body) {
                throw new Error( false ? 'No document found for font metrics' : '');
            }

            container.style.visibility = 'hidden';
            container.style.fontFamily = font.fontFamily;
            container.style.fontSize = font.fontSize;
            container.style.margin = '0';
            container.style.padding = '0';

            body.appendChild(container);

            img.src = _Util.SMALL_IMAGE;
            img.width = 1;
            img.height = 1;

            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';

            span.style.fontFamily = font.fontFamily;
            span.style.fontSize = font.fontSize;
            span.style.margin = '0';
            span.style.padding = '0';

            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;

            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));

            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';

            var middle = img.offsetTop - container.offsetTop + 2;

            body.removeChild(container);

            return { baseline: baseline, middle: middle };
        }
    }, {
        key: 'getMetrics',
        value: function getMetrics(font) {
            var key = font.fontFamily + ' ' + font.fontSize;
            if (this._data[key] === undefined) {
                this._data[key] = this._parseMetrics(font);
            }

            return this._data[key];
        }
    }]);

    return FontMetrics;
}();

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.reformatInputBounds = exports.inlineSelectElement = exports.inlineTextAreaElement = exports.inlineInputElement = exports.getInputBorderRadius = exports.INPUT_BACKGROUND = exports.INPUT_BORDERS = exports.INPUT_COLOR = undefined;

var _TextContainer = __webpack_require__(206);

var _TextContainer2 = _interopRequireDefault(_TextContainer);

var _background = __webpack_require__(147);

var _border = __webpack_require__(207);

var _Circle = __webpack_require__(1155);

var _Circle2 = _interopRequireDefault(_Circle);

var _Vector = __webpack_require__(146);

var _Vector2 = _interopRequireDefault(_Vector);

var _Color = __webpack_require__(74);

var _Color2 = _interopRequireDefault(_Color);

var _Length = __webpack_require__(97);

var _Length2 = _interopRequireDefault(_Length);

var _Bounds = __webpack_require__(73);

var _TextBounds = __webpack_require__(332);

var _Util = __webpack_require__(111);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INPUT_COLOR = exports.INPUT_COLOR = new _Color2.default([42, 42, 42]);
var INPUT_BORDER_COLOR = new _Color2.default([165, 165, 165]);
var INPUT_BACKGROUND_COLOR = new _Color2.default([222, 222, 222]);
var INPUT_BORDER = {
    borderWidth: 1,
    borderColor: INPUT_BORDER_COLOR,
    borderStyle: _border.BORDER_STYLE.SOLID
};
var INPUT_BORDERS = exports.INPUT_BORDERS = [INPUT_BORDER, INPUT_BORDER, INPUT_BORDER, INPUT_BORDER];
var INPUT_BACKGROUND = exports.INPUT_BACKGROUND = {
    backgroundColor: INPUT_BACKGROUND_COLOR,
    backgroundImage: [],
    backgroundClip: _background.BACKGROUND_CLIP.PADDING_BOX,
    backgroundOrigin: _background.BACKGROUND_ORIGIN.PADDING_BOX
};

var RADIO_BORDER_RADIUS = new _Length2.default('50%');
var RADIO_BORDER_RADIUS_TUPLE = [RADIO_BORDER_RADIUS, RADIO_BORDER_RADIUS];
var INPUT_RADIO_BORDER_RADIUS = [RADIO_BORDER_RADIUS_TUPLE, RADIO_BORDER_RADIUS_TUPLE, RADIO_BORDER_RADIUS_TUPLE, RADIO_BORDER_RADIUS_TUPLE];

var CHECKBOX_BORDER_RADIUS = new _Length2.default('3px');
var CHECKBOX_BORDER_RADIUS_TUPLE = [CHECKBOX_BORDER_RADIUS, CHECKBOX_BORDER_RADIUS];
var INPUT_CHECKBOX_BORDER_RADIUS = [CHECKBOX_BORDER_RADIUS_TUPLE, CHECKBOX_BORDER_RADIUS_TUPLE, CHECKBOX_BORDER_RADIUS_TUPLE, CHECKBOX_BORDER_RADIUS_TUPLE];

var getInputBorderRadius = exports.getInputBorderRadius = function getInputBorderRadius(node) {
    return node.type === 'radio' ? INPUT_RADIO_BORDER_RADIUS : INPUT_CHECKBOX_BORDER_RADIUS;
};

var inlineInputElement = exports.inlineInputElement = function inlineInputElement(node, container) {
    if (node.type === 'radio' || node.type === 'checkbox') {
        if (node.checked) {
            var size = Math.min(container.bounds.width, container.bounds.height);
            container.childNodes.push(node.type === 'checkbox' ? [new _Vector2.default(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79), new _Vector2.default(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549), new _Vector2.default(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071), new _Vector2.default(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649), new _Vector2.default(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23), new _Vector2.default(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085), new _Vector2.default(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)] : new _Circle2.default(container.bounds.left + size / 4, container.bounds.top + size / 4, size / 4));
        }
    } else {
        inlineFormElement(getInputValue(node), node, container, false);
    }
};

var inlineTextAreaElement = exports.inlineTextAreaElement = function inlineTextAreaElement(node, container) {
    inlineFormElement(node.value, node, container, true);
};

var inlineSelectElement = exports.inlineSelectElement = function inlineSelectElement(node, container) {
    var option = node.options[node.selectedIndex || 0];
    inlineFormElement(option ? option.text || '' : '', node, container, false);
};

var reformatInputBounds = exports.reformatInputBounds = function reformatInputBounds(bounds) {
    if (bounds.width > bounds.height) {
        bounds.left += (bounds.width - bounds.height) / 2;
        bounds.width = bounds.height;
    } else if (bounds.width < bounds.height) {
        bounds.top += (bounds.height - bounds.width) / 2;
        bounds.height = bounds.width;
    }
    return bounds;
};

var inlineFormElement = function inlineFormElement(value, node, container, allowLinebreak) {
    var body = node.ownerDocument.body;
    if (value.length > 0 && body) {
        var wrapper = node.ownerDocument.createElement('html2canvaswrapper');
        (0, _Util.copyCSSStyles)(node.ownerDocument.defaultView.getComputedStyle(node, null), wrapper);
        wrapper.style.position = 'fixed';
        wrapper.style.left = container.bounds.left + 'px';
        wrapper.style.top = container.bounds.top + 'px';
        if (!allowLinebreak) {
            wrapper.style.whiteSpace = 'nowrap';
        }
        var text = node.ownerDocument.createTextNode(value);
        wrapper.appendChild(text);
        body.appendChild(wrapper);
        container.childNodes.push(_TextContainer2.default.fromTextNode(text, container));
        body.removeChild(wrapper);
    }
};

var getInputValue = function getInputValue(node) {
    var value = node.type === 'password' ? new Array(node.value.length + 1).join('\u2022') : node.value;

    return value.length === 0 ? node.placeholder || '' : value;
};

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Logger = function () {
    function Logger(enabled, id, start) {
        _classCallCheck(this, Logger);

        this.enabled = enabled;
        this.start = start ? start : Date.now();
        this.id = id;
    }

    _createClass(Logger, [{
        key: 'child',
        value: function child(id) {
            return new Logger(this.enabled, id, this.start);
        }

        // eslint-disable-next-line flowtype/no-weak-types

    }, {
        key: 'log',
        value: function log() {
            if (this.enabled && window.console && window.console.log) {
                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }

                Function.prototype.bind.call(window.console.log, window.console).apply(window.console, [Date.now() - this.start + 'ms', this.id ? 'html2canvas (' + this.id + '):' : 'html2canvas:'].concat([].slice.call(args, 0)));
            }
        }

        // eslint-disable-next-line flowtype/no-weak-types

    }, {
        key: 'error',
        value: function error() {
            if (this.enabled && window.console && window.console.error) {
                for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    args[_key2] = arguments[_key2];
                }

                Function.prototype.bind.call(window.console.error, window.console).apply(window.console, [Date.now() - this.start + 'ms', this.id ? 'html2canvas (' + this.id + '):' : 'html2canvas:'].concat([].slice.call(args, 0)));
            }
        }
    }]);

    return Logger;
}();

exports.default = Logger;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Proxy = undefined;

var _Feature = __webpack_require__(143);

var _Feature2 = _interopRequireDefault(_Feature);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Proxy = exports.Proxy = function Proxy(src, options) {
    if (!options.proxy) {
        return Promise.reject( false ? 'No proxy defined' : null);
    }
    var proxy = options.proxy;

    return new Promise(function (resolve, reject) {
        var responseType = _Feature2.default.SUPPORT_CORS_XHR && _Feature2.default.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
        var xhr = _Feature2.default.SUPPORT_CORS_XHR ? new XMLHttpRequest() : new XDomainRequest();
        xhr.onload = function () {
            if (xhr instanceof XMLHttpRequest) {
                if (xhr.status === 200) {
                    if (responseType === 'text') {
                        resolve(xhr.response);
                    } else {
                        var reader = new FileReader();
                        // $FlowFixMe
                        reader.addEventListener('load', function () {
                            return resolve(reader.result);
                        }, false);
                        // $FlowFixMe
                        reader.addEventListener('error', function (e) {
                            return reject(e);
                        }, false);
                        reader.readAsDataURL(xhr.response);
                    }
                } else {
                    reject( false ? 'Failed to proxy resource ' + src.substring(0, 256) + ' with status code ' + xhr.status : '');
                }
            } else {
                resolve(xhr.responseText);
            }
        };

        xhr.onerror = reject;
        xhr.open('GET', proxy + '?url=' + encodeURIComponent(src) + '&responseType=' + responseType);

        if (responseType !== 'text' && xhr instanceof XMLHttpRequest) {
            xhr.responseType = responseType;
        }

        if (options.imageTimeout) {
            var timeout = options.imageTimeout;
            xhr.timeout = timeout;
            xhr.ontimeout = function () {
                return reject( false ? 'Timed out (' + timeout + 'ms) proxying ' + src.substring(0, 256) : '');
            };
        }

        xhr.send();
    });
};

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseTextBounds = exports.TextBounds = undefined;

var _punycode = __webpack_require__(1229);

var _Bounds = __webpack_require__(73);

var _textDecoration = __webpack_require__(208);

var _Feature = __webpack_require__(143);

var _Feature2 = _interopRequireDefault(_Feature);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UNICODE = /[^\u0000-\u00ff]/;

var hasUnicodeCharacters = function hasUnicodeCharacters(text) {
    return UNICODE.test(text);
};

var encodeCodePoint = function encodeCodePoint(codePoint) {
    return _punycode.ucs2.encode([codePoint]);
};

var TextBounds = exports.TextBounds = function TextBounds(text, bounds) {
    _classCallCheck(this, TextBounds);

    this.text = text;
    this.bounds = bounds;
};

var parseTextBounds = exports.parseTextBounds = function parseTextBounds(value, parent, node) {
    var codePoints = _punycode.ucs2.decode(value);
    var letterRendering = parent.style.letterSpacing !== 0 || hasUnicodeCharacters(value);
    var textList = letterRendering ? codePoints.map(encodeCodePoint) : splitWords(codePoints);
    var length = textList.length;
    var defaultView = node.parentNode ? node.parentNode.ownerDocument.defaultView : null;
    var scrollX = defaultView ? defaultView.pageXOffset : 0;
    var scrollY = defaultView ? defaultView.pageYOffset : 0;
    var textBounds = [];
    var offset = 0;
    for (var i = 0; i < length; i++) {
        var text = textList[i];
        if (parent.style.textDecoration !== _textDecoration.TEXT_DECORATION.NONE || text.trim().length > 0) {
            if (_Feature2.default.SUPPORT_RANGE_BOUNDS) {
                textBounds.push(new TextBounds(text, getRangeBounds(node, offset, text.length, scrollX, scrollY)));
            } else {
                var replacementNode = node.splitText(text.length);
                textBounds.push(new TextBounds(text, getWrapperBounds(node, scrollX, scrollY)));
                node = replacementNode;
            }
        } else if (!_Feature2.default.SUPPORT_RANGE_BOUNDS) {
            node = node.splitText(text.length);
        }
        offset += text.length;
    }
    return textBounds;
};

var getWrapperBounds = function getWrapperBounds(node, scrollX, scrollY) {
    var wrapper = node.ownerDocument.createElement('html2canvaswrapper');
    wrapper.appendChild(node.cloneNode(true));
    var parentNode = node.parentNode;
    if (parentNode) {
        parentNode.replaceChild(wrapper, node);
        var bounds = (0, _Bounds.parseBounds)(wrapper, scrollX, scrollY);
        if (wrapper.firstChild) {
            parentNode.replaceChild(wrapper.firstChild, wrapper);
        }
        return bounds;
    }
    return new _Bounds.Bounds(0, 0, 0, 0);
};

var getRangeBounds = function getRangeBounds(node, offset, length, scrollX, scrollY) {
    var range = node.ownerDocument.createRange();
    range.setStart(node, offset);
    range.setEnd(node, offset + length);
    return _Bounds.Bounds.fromClientRect(range.getBoundingClientRect(), scrollX, scrollY);
};

var splitWords = function splitWords(codePoints) {
    var words = [];
    var i = 0;
    var onWordBoundary = false;
    var word = void 0;
    while (codePoints.length) {
        if (isWordBoundary(codePoints[i]) === onWordBoundary) {
            word = codePoints.splice(0, i);
            if (word.length) {
                words.push(_punycode.ucs2.encode(word));
            }
            onWordBoundary = !onWordBoundary;
            i = 0;
        } else {
            i++;
        }

        if (i >= codePoints.length) {
            word = codePoints.splice(0, i);
            if (word.length) {
                words.push(_punycode.ucs2.encode(word));
            }
        }
    }
    return words;
};

var isWordBoundary = function isWordBoundary(characterCode) {
    return [32, // <space>
    13, // \r
    10, // \n
    9, // \t
    45 // -
    ].indexOf(characterCode) !== -1;
};

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parsePadding = exports.PADDING_SIDES = undefined;

var _Length = __webpack_require__(97);

var _Length2 = _interopRequireDefault(_Length);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PADDING_SIDES = exports.PADDING_SIDES = {
    TOP: 0,
    RIGHT: 1,
    BOTTOM: 2,
    LEFT: 3
};

var SIDES = ['top', 'right', 'bottom', 'left'];

var parsePadding = exports.parsePadding = function parsePadding(style) {
    return SIDES.map(function (side) {
        return new _Length2.default(style.getPropertyValue('padding-' + side));
    });
};

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var POSITION = exports.POSITION = {
    STATIC: 0,
    RELATIVE: 1,
    ABSOLUTE: 2,
    FIXED: 3,
    STICKY: 4
};

var parsePosition = exports.parsePosition = function parsePosition(position) {
    switch (position) {
        case 'relative':
            return POSITION.RELATIVE;
        case 'absolute':
            return POSITION.ABSOLUTE;
        case 'fixed':
            return POSITION.FIXED;
        case 'sticky':
            return POSITION.STICKY;
    }

    return POSITION.STATIC;
};

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var TEXT_TRANSFORM = exports.TEXT_TRANSFORM = {
    NONE: 0,
    LOWERCASE: 1,
    UPPERCASE: 2,
    CAPITALIZE: 3
};

var parseTextTransform = exports.parseTextTransform = function parseTextTransform(textTransform) {
    switch (textTransform) {
        case 'uppercase':
            return TEXT_TRANSFORM.UPPERCASE;
        case 'lowercase':
            return TEXT_TRANSFORM.LOWERCASE;
        case 'capitalize':
            return TEXT_TRANSFORM.CAPITALIZE;
    }

    return TEXT_TRANSFORM.NONE;
};

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Path = __webpack_require__(145);

var _textDecoration = __webpack_require__(208);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var addColorStops = function addColorStops(gradient, canvasGradient) {
    var maxStop = Math.max.apply(null, gradient.colorStops.map(function (colorStop) {
        return colorStop.stop;
    }));
    var f = 1 / Math.max(1, maxStop);
    gradient.colorStops.forEach(function (colorStop) {
        canvasGradient.addColorStop(f * colorStop.stop, colorStop.color.toString());
    });
};

var CanvasRenderer = function () {
    function CanvasRenderer(canvas) {
        _classCallCheck(this, CanvasRenderer);

        this.canvas = canvas ? canvas : document.createElement('canvas');
    }

    _createClass(CanvasRenderer, [{
        key: 'render',
        value: function render(options) {
            this.ctx = this.canvas.getContext('2d');
            this.options = options;
            this.canvas.width = Math.floor(options.width * options.scale);
            this.canvas.height = Math.floor(options.height * options.scale);
            this.canvas.style.width = options.width + 'px';
            this.canvas.style.height = options.height + 'px';

            this.ctx.scale(this.options.scale, this.options.scale);
            this.ctx.translate(-options.x, -options.y);
            this.ctx.textBaseline = 'bottom';
            options.logger.log('Canvas renderer initialized (' + options.width + 'x' + options.height + ' at ' + options.x + ',' + options.y + ') with scale ' + this.options.scale);
        }
    }, {
        key: 'clip',
        value: function clip(clipPaths, callback) {
            var _this = this;

            if (clipPaths.length) {
                this.ctx.save();
                clipPaths.forEach(function (path) {
                    _this.path(path);
                    _this.ctx.clip();
                });
            }

            callback();

            if (clipPaths.length) {
                this.ctx.restore();
            }
        }
    }, {
        key: 'drawImage',
        value: function drawImage(image, source, destination) {
            this.ctx.drawImage(image, source.left, source.top, source.width, source.height, destination.left, destination.top, destination.width, destination.height);
        }
    }, {
        key: 'drawShape',
        value: function drawShape(path, color) {
            this.path(path);
            this.ctx.fillStyle = color.toString();
            this.ctx.fill();
        }
    }, {
        key: 'fill',
        value: function fill(color) {
            this.ctx.fillStyle = color.toString();
            this.ctx.fill();
        }
    }, {
        key: 'getTarget',
        value: function getTarget() {
            return Promise.resolve(this.canvas);
        }
    }, {
        key: 'path',
        value: function path(_path) {
            var _this2 = this;

            this.ctx.beginPath();
            if (Array.isArray(_path)) {
                _path.forEach(function (point, index) {
                    var start = point.type === _Path.PATH.VECTOR ? point : point.start;
                    if (index === 0) {
                        _this2.ctx.moveTo(start.x, start.y);
                    } else {
                        _this2.ctx.lineTo(start.x, start.y);
                    }

                    if (point.type === _Path.PATH.BEZIER_CURVE) {
                        _this2.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
                    }
                });
            } else {
                this.ctx.arc(_path.x + _path.radius, _path.y + _path.radius, _path.radius, 0, Math.PI * 2, true);
            }

            this.ctx.closePath();
        }
    }, {
        key: 'rectangle',
        value: function rectangle(x, y, width, height, color) {
            this.ctx.fillStyle = color.toString();
            this.ctx.fillRect(x, y, width, height);
        }
    }, {
        key: 'renderLinearGradient',
        value: function renderLinearGradient(bounds, gradient) {
            var linearGradient = this.ctx.createLinearGradient(bounds.left + gradient.direction.x1, bounds.top + gradient.direction.y1, bounds.left + gradient.direction.x0, bounds.top + gradient.direction.y0);

            addColorStops(gradient, linearGradient);
            this.ctx.fillStyle = linearGradient;
            this.ctx.fillRect(bounds.left, bounds.top, bounds.width, bounds.height);
        }
    }, {
        key: 'renderRadialGradient',
        value: function renderRadialGradient(bounds, gradient) {
            var _this3 = this;

            var x = bounds.left + gradient.center.x;
            var y = bounds.top + gradient.center.y;

            var radialGradient = this.ctx.createRadialGradient(x, y, 0, x, y, gradient.radius.x);
            if (!radialGradient) {
                return;
            }

            addColorStops(gradient, radialGradient);
            this.ctx.fillStyle = radialGradient;

            if (gradient.radius.x !== gradient.radius.y) {
                // transforms for elliptical radial gradient
                var midX = bounds.left + 0.5 * bounds.width;
                var midY = bounds.top + 0.5 * bounds.height;
                var f = gradient.radius.y / gradient.radius.x;
                var invF = 1 / f;

                this.transform(midX, midY, [1, 0, 0, f, 0, 0], function () {
                    return _this3.ctx.fillRect(bounds.left, invF * (bounds.top - midY) + midY, bounds.width, bounds.height * invF);
                });
            } else {
                this.ctx.fillRect(bounds.left, bounds.top, bounds.width, bounds.height);
            }
        }
    }, {
        key: 'renderRepeat',
        value: function renderRepeat(path, image, imageSize, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = this.ctx.createPattern(this.resizeImage(image, imageSize), 'repeat');
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        }
    }, {
        key: 'renderTextNode',
        value: function renderTextNode(textBounds, color, font, textDecoration, textShadows) {
            var _this4 = this;

            this.ctx.font = [font.fontStyle, font.fontVariant, font.fontWeight, font.fontSize, font.fontFamily].join(' ');

            textBounds.forEach(function (text) {
                _this4.ctx.fillStyle = color.toString();
                if (textShadows && text.text.trim().length) {
                    textShadows.slice(0).reverse().forEach(function (textShadow) {
                        _this4.ctx.shadowColor = textShadow.color.toString();
                        _this4.ctx.shadowOffsetX = textShadow.offsetX * _this4.options.scale;
                        _this4.ctx.shadowOffsetY = textShadow.offsetY * _this4.options.scale;
                        _this4.ctx.shadowBlur = textShadow.blur;

                        _this4.ctx.fillText(text.text, text.bounds.left, text.bounds.top + text.bounds.height);
                    });
                } else {
                    _this4.ctx.fillText(text.text, text.bounds.left, text.bounds.top + text.bounds.height);
                }

                if (textDecoration !== null) {
                    var textDecorationColor = textDecoration.textDecorationColor || color;
                    textDecoration.textDecorationLine.forEach(function (textDecorationLine) {
                        switch (textDecorationLine) {
                            case _textDecoration.TEXT_DECORATION_LINE.UNDERLINE:
                                // Draws a line at the baseline of the font
                                // TODO As some browsers display the line as more than 1px if the font-size is big,
                                // need to take that into account both in position and size
                                var _options$fontMetrics$ = _this4.options.fontMetrics.getMetrics(font),
                                    baseline = _options$fontMetrics$.baseline;

                                _this4.rectangle(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1, textDecorationColor);
                                break;
                            case _textDecoration.TEXT_DECORATION_LINE.OVERLINE:
                                _this4.rectangle(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1, textDecorationColor);
                                break;
                            case _textDecoration.TEXT_DECORATION_LINE.LINE_THROUGH:
                                // TODO try and find exact position for line-through
                                var _options$fontMetrics$2 = _this4.options.fontMetrics.getMetrics(font),
                                    middle = _options$fontMetrics$2.middle;

                                _this4.rectangle(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1, textDecorationColor);
                                break;
                        }
                    });
                }
            });
        }
    }, {
        key: 'resizeImage',
        value: function resizeImage(image, size) {
            if (image.width === size.width && image.height === size.height) {
                return image;
            }

            var canvas = this.canvas.ownerDocument.createElement('canvas');
            canvas.width = size.width;
            canvas.height = size.height;
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, size.width, size.height);
            return canvas;
        }
    }, {
        key: 'setOpacity',
        value: function setOpacity(opacity) {
            this.ctx.globalAlpha = opacity;
        }
    }, {
        key: 'transform',
        value: function transform(offsetX, offsetY, matrix, callback) {
            this.ctx.save();
            this.ctx.translate(offsetX, offsetY);
            this.ctx.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
            this.ctx.translate(-offsetX, -offsetY);

            callback();

            this.ctx.restore();
        }
    }]);

    return CanvasRenderer;
}();

exports.default = CanvasRenderer;

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ForeignObjectRenderer = function () {
    function ForeignObjectRenderer(element) {
        _classCallCheck(this, ForeignObjectRenderer);

        this.element = element;
    }

    _createClass(ForeignObjectRenderer, [{
        key: 'render',
        value: function render(options) {
            var _this = this;

            this.options = options;
            this.canvas = document.createElement('canvas');
            this.ctx = this.canvas.getContext('2d');
            this.canvas.width = Math.floor(options.width) * options.scale;
            this.canvas.height = Math.floor(options.height) * options.scale;
            this.canvas.style.width = options.width + 'px';
            this.canvas.style.height = options.height + 'px';

            options.logger.log('ForeignObject renderer initialized (' + options.width + 'x' + options.height + ' at ' + options.x + ',' + options.y + ') with scale ' + options.scale);
            var svg = createForeignObjectSVG(Math.max(options.windowWidth, options.width) * options.scale, Math.max(options.windowHeight, options.height) * options.scale, options.scrollX * options.scale, options.scrollY * options.scale, this.element);

            return loadSerializedSVG(svg).then(function (img) {
                if (options.backgroundColor) {
                    _this.ctx.fillStyle = options.backgroundColor.toString();
                    _this.ctx.fillRect(0, 0, options.width * options.scale, options.height * options.scale);
                }

                _this.ctx.drawImage(img, -options.x * options.scale, -options.y * options.scale);
                return _this.canvas;
            });
        }
    }]);

    return ForeignObjectRenderer;
}();

exports.default = ForeignObjectRenderer;
var createForeignObjectSVG = exports.createForeignObjectSVG = function createForeignObjectSVG(width, height, x, y, node) {
    var xmlns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(xmlns, 'svg');
    var foreignObject = document.createElementNS(xmlns, 'foreignObject');
    svg.setAttributeNS(null, 'width', width);
    svg.setAttributeNS(null, 'height', height);

    foreignObject.setAttributeNS(null, 'width', '100%');
    foreignObject.setAttributeNS(null, 'height', '100%');
    foreignObject.setAttributeNS(null, 'x', x);
    foreignObject.setAttributeNS(null, 'y', y);
    foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
    svg.appendChild(foreignObject);

    foreignObject.appendChild(node);

    return svg;
};

var loadSerializedSVG = exports.loadSerializedSVG = function loadSerializedSVG(svg) {
    return new Promise(function (resolve, reject) {
        var img = new Image();
        img.onload = function () {
            return resolve(img);
        };
        img.onerror = reject;

        img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(new XMLSerializer().serializeToString(svg));
    });
};

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {


var KeyCombo = __webpack_require__(209);


function Locale(name) {
  this.localeName     = name;
  this.pressedKeys    = [];
  this._appliedMacros = [];
  this._keyMap        = {};
  this._killKeyCodes  = [];
  this._macros        = [];
}

Locale.prototype.bindKeyCode = function(keyCode, keyNames) {
  if (typeof keyNames === 'string') {
    keyNames = [keyNames];
  }

  this._keyMap[keyCode] = keyNames;
};

Locale.prototype.bindMacro = function(keyComboStr, keyNames) {
  if (typeof keyNames === 'string') {
    keyNames = [ keyNames ];
  }

  var handler = null;
  if (typeof keyNames === 'function') {
    handler = keyNames;
    keyNames = null;
  }

  var macro = {
    keyCombo : new KeyCombo(keyComboStr),
    keyNames : keyNames,
    handler  : handler
  };

  this._macros.push(macro);
};

Locale.prototype.getKeyCodes = function(keyName) {
  var keyCodes = [];
  for (var keyCode in this._keyMap) {
    var index = this._keyMap[keyCode].indexOf(keyName);
    if (index > -1) { keyCodes.push(keyCode|0); }
  }
  return keyCodes;
};

Locale.prototype.getKeyNames = function(keyCode) {
  return this._keyMap[keyCode] || [];
};

Locale.prototype.setKillKey = function(keyCode) {
  if (typeof keyCode === 'string') {
    var keyCodes = this.getKeyCodes(keyCode);
    for (var i = 0; i < keyCodes.length; i += 1) {
      this.setKillKey(keyCodes[i]);
    }
    return;
  }

  this._killKeyCodes.push(keyCode);
};

Locale.prototype.pressKey = function(keyCode) {
  if (typeof keyCode === 'string') {
    var keyCodes = this.getKeyCodes(keyCode);
    for (var i = 0; i < keyCodes.length; i += 1) {
      this.pressKey(keyCodes[i]);
    }
    return;
  }

  var keyNames = this.getKeyNames(keyCode);
  for (var i = 0; i < keyNames.length; i += 1) {
    if (this.pressedKeys.indexOf(keyNames[i]) === -1) {
      this.pressedKeys.push(keyNames[i]);
    }
  }

  this._applyMacros();
};

Locale.prototype.releaseKey = function(keyCode) {
  if (typeof keyCode === 'string') {
    var keyCodes = this.getKeyCodes(keyCode);
    for (var i = 0; i < keyCodes.length; i += 1) {
      this.releaseKey(keyCodes[i]);
    }
  }

  else {
    var keyNames         = this.getKeyNames(keyCode);
    var killKeyCodeIndex = this._killKeyCodes.indexOf(keyCode);
    
    if (killKeyCodeIndex > -1) {
      this.pressedKeys.length = 0;
    } else {
      for (var i = 0; i < keyNames.length; i += 1) {
        var index = this.pressedKeys.indexOf(keyNames[i]);
        if (index > -1) {
          this.pressedKeys.splice(index, 1);
        }
      }
    }

    this._clearMacros();
  }
};

Locale.prototype._applyMacros = function() {
  var macros = this._macros.slice(0);
  for (var i = 0; i < macros.length; i += 1) {
    var macro = macros[i];
    if (macro.keyCombo.check(this.pressedKeys)) {
      if (macro.handler) {
        macro.keyNames = macro.handler(this.pressedKeys);
      }
      for (var j = 0; j < macro.keyNames.length; j += 1) {
        if (this.pressedKeys.indexOf(macro.keyNames[j]) === -1) {
          this.pressedKeys.push(macro.keyNames[j]);
        }
      }
      this._appliedMacros.push(macro);
    }
  }
};

Locale.prototype._clearMacros = function() {
  for (var i = 0; i < this._appliedMacros.length; i += 1) {
    var macro = this._appliedMacros[i];
    if (!macro.keyCombo.check(this.pressedKeys)) {
      for (var j = 0; j < macro.keyNames.length; j += 1) {
        var index = this.pressedKeys.indexOf(macro.keyNames[j]);
        if (index > -1) {
          this.pressedKeys.splice(index, 1);
        }
      }
      if (macro.handler) {
        macro.keyNames = null;
      }
      this._appliedMacros.splice(i, 1);
      i -= 1;
    }
  }
};


module.exports = Locale;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var stub = __webpack_require__(1170);
var tracking = __webpack_require__(1171);
var ls = 'localStorage' in global && global.localStorage ? global.localStorage : stub;

function accessor (key, value) {
  if (arguments.length === 1) {
    return get(key);
  }
  return set(key, value);
}

function get (key) {
  return JSON.parse(ls.getItem(key));
}

function set (key, value) {
  try {
    ls.setItem(key, JSON.stringify(value));
    return true;
  } catch (e) {
    return false;
  }
}

function remove (key) {
  return ls.removeItem(key);
}

function clear () {
  return ls.clear();
}

accessor.set = set;
accessor.get = get;
accessor.remove = remove;
accessor.clear = clear;
accessor.on = tracking.on;
accessor.off = tracking.off;

module.exports = accessor;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = forward;
/* unused harmony export inverse */
/* harmony export (immutable) */ __webpack_exports__["b"] = toPoint;



/**
 * UTM zones are grouped, and assigned to one of a group of 6
 * sets.
 *
 * {int} @private
 */
var NUM_100K_SETS = 6;

/**
 * The column letters (for easting) of the lower left value, per
 * set.
 *
 * {string} @private
 */
var SET_ORIGIN_COLUMN_LETTERS = 'AJSAJS';

/**
 * The row letters (for northing) of the lower left value, per
 * set.
 *
 * {string} @private
 */
var SET_ORIGIN_ROW_LETTERS = 'AFAFAF';

var A = 65; // A
var I = 73; // I
var O = 79; // O
var V = 86; // V
var Z = 90; // Z
/* harmony default export */ __webpack_exports__["a"] = ({
  forward: forward,
  inverse: inverse,
  toPoint: toPoint
});
/**
 * Conversion of lat/lon to MGRS.
 *
 * @param {object} ll Object literal with lat and lon properties on a
 *     WGS84 ellipsoid.
 * @param {int} accuracy Accuracy in digits (5 for 1 m, 4 for 10 m, 3 for
 *      100 m, 2 for 1000 m or 1 for 10000 m). Optional, default is 5.
 * @return {string} the MGRS string for the given location and accuracy.
 */
function forward(ll, accuracy) {
  accuracy = accuracy || 5; // default accuracy 1m
  return encode(LLtoUTM({
    lat: ll[1],
    lon: ll[0]
  }), accuracy);
};

/**
 * Conversion of MGRS to lat/lon.
 *
 * @param {string} mgrs MGRS string.
 * @return {array} An array with left (longitude), bottom (latitude), right
 *     (longitude) and top (latitude) values in WGS84, representing the
 *     bounding box for the provided MGRS reference.
 */
function inverse(mgrs) {
  var bbox = UTMtoLL(decode(mgrs.toUpperCase()));
  if (bbox.lat && bbox.lon) {
    return [bbox.lon, bbox.lat, bbox.lon, bbox.lat];
  }
  return [bbox.left, bbox.bottom, bbox.right, bbox.top];
};

function toPoint(mgrs) {
  var bbox = UTMtoLL(decode(mgrs.toUpperCase()));
  if (bbox.lat && bbox.lon) {
    return [bbox.lon, bbox.lat];
  }
  return [(bbox.left + bbox.right) / 2, (bbox.top + bbox.bottom) / 2];
};
/**
 * Conversion from degrees to radians.
 *
 * @private
 * @param {number} deg the angle in degrees.
 * @return {number} the angle in radians.
 */
function degToRad(deg) {
  return (deg * (Math.PI / 180.0));
}

/**
 * Conversion from radians to degrees.
 *
 * @private
 * @param {number} rad the angle in radians.
 * @return {number} the angle in degrees.
 */
function radToDeg(rad) {
  return (180.0 * (rad / Math.PI));
}

/**
 * Converts a set of Longitude and Latitude co-ordinates to UTM
 * using the WGS84 ellipsoid.
 *
 * @private
 * @param {object} ll Object literal with lat and lon properties
 *     representing the WGS84 coordinate to be converted.
 * @return {object} Object literal containing the UTM value with easting,
 *     northing, zoneNumber and zoneLetter properties, and an optional
 *     accuracy property in digits. Returns null if the conversion failed.
 */
function LLtoUTM(ll) {
  var Lat = ll.lat;
  var Long = ll.lon;
  var a = 6378137.0; //ellip.radius;
  var eccSquared = 0.00669438; //ellip.eccsq;
  var k0 = 0.9996;
  var LongOrigin;
  var eccPrimeSquared;
  var N, T, C, A, M;
  var LatRad = degToRad(Lat);
  var LongRad = degToRad(Long);
  var LongOriginRad;
  var ZoneNumber;
  // (int)
  ZoneNumber = Math.floor((Long + 180) / 6) + 1;

  //Make sure the longitude 180.00 is in Zone 60
  if (Long === 180) {
    ZoneNumber = 60;
  }

  // Special zone for Norway
  if (Lat >= 56.0 && Lat < 64.0 && Long >= 3.0 && Long < 12.0) {
    ZoneNumber = 32;
  }

  // Special zones for Svalbard
  if (Lat >= 72.0 && Lat < 84.0) {
    if (Long >= 0.0 && Long < 9.0) {
      ZoneNumber = 31;
    }
    else if (Long >= 9.0 && Long < 21.0) {
      ZoneNumber = 33;
    }
    else if (Long >= 21.0 && Long < 33.0) {
      ZoneNumber = 35;
    }
    else if (Long >= 33.0 && Long < 42.0) {
      ZoneNumber = 37;
    }
  }

  LongOrigin = (ZoneNumber - 1) * 6 - 180 + 3; //+3 puts origin
  // in middle of
  // zone
  LongOriginRad = degToRad(LongOrigin);

  eccPrimeSquared = (eccSquared) / (1 - eccSquared);

  N = a / Math.sqrt(1 - eccSquared * Math.sin(LatRad) * Math.sin(LatRad));
  T = Math.tan(LatRad) * Math.tan(LatRad);
  C = eccPrimeSquared * Math.cos(LatRad) * Math.cos(LatRad);
  A = Math.cos(LatRad) * (LongRad - LongOriginRad);

  M = a * ((1 - eccSquared / 4 - 3 * eccSquared * eccSquared / 64 - 5 * eccSquared * eccSquared * eccSquared / 256) * LatRad - (3 * eccSquared / 8 + 3 * eccSquared * eccSquared / 32 + 45 * eccSquared * eccSquared * eccSquared / 1024) * Math.sin(2 * LatRad) + (15 * eccSquared * eccSquared / 256 + 45 * eccSquared * eccSquared * eccSquared / 1024) * Math.sin(4 * LatRad) - (35 * eccSquared * eccSquared * eccSquared / 3072) * Math.sin(6 * LatRad));

  var UTMEasting = (k0 * N * (A + (1 - T + C) * A * A * A / 6.0 + (5 - 18 * T + T * T + 72 * C - 58 * eccPrimeSquared) * A * A * A * A * A / 120.0) + 500000.0);

  var UTMNorthing = (k0 * (M + N * Math.tan(LatRad) * (A * A / 2 + (5 - T + 9 * C + 4 * C * C) * A * A * A * A / 24.0 + (61 - 58 * T + T * T + 600 * C - 330 * eccPrimeSquared) * A * A * A * A * A * A / 720.0)));
  if (Lat < 0.0) {
    UTMNorthing += 10000000.0; //10000000 meter offset for
    // southern hemisphere
  }

  return {
    northing: Math.round(UTMNorthing),
    easting: Math.round(UTMEasting),
    zoneNumber: ZoneNumber,
    zoneLetter: getLetterDesignator(Lat)
  };
}

/**
 * Converts UTM coords to lat/long, using the WGS84 ellipsoid. This is a convenience
 * class where the Zone can be specified as a single string eg."60N" which
 * is then broken down into the ZoneNumber and ZoneLetter.
 *
 * @private
 * @param {object} utm An object literal with northing, easting, zoneNumber
 *     and zoneLetter properties. If an optional accuracy property is
 *     provided (in meters), a bounding box will be returned instead of
 *     latitude and longitude.
 * @return {object} An object literal containing either lat and lon values
 *     (if no accuracy was provided), or top, right, bottom and left values
 *     for the bounding box calculated according to the provided accuracy.
 *     Returns null if the conversion failed.
 */
function UTMtoLL(utm) {

  var UTMNorthing = utm.northing;
  var UTMEasting = utm.easting;
  var zoneLetter = utm.zoneLetter;
  var zoneNumber = utm.zoneNumber;
  // check the ZoneNummber is valid
  if (zoneNumber < 0 || zoneNumber > 60) {
    return null;
  }

  var k0 = 0.9996;
  var a = 6378137.0; //ellip.radius;
  var eccSquared = 0.00669438; //ellip.eccsq;
  var eccPrimeSquared;
  var e1 = (1 - Math.sqrt(1 - eccSquared)) / (1 + Math.sqrt(1 - eccSquared));
  var N1, T1, C1, R1, D, M;
  var LongOrigin;
  var mu, phi1Rad;

  // remove 500,000 meter offset for longitude
  var x = UTMEasting - 500000.0;
  var y = UTMNorthing;

  // We must know somehow if we are in the Northern or Southern
  // hemisphere, this is the only time we use the letter So even
  // if the Zone letter isn't exactly correct it should indicate
  // the hemisphere correctly
  if (zoneLetter < 'N') {
    y -= 10000000.0; // remove 10,000,000 meter offset used
    // for southern hemisphere
  }

  // There are 60 zones with zone 1 being at West -180 to -174
  LongOrigin = (zoneNumber - 1) * 6 - 180 + 3; // +3 puts origin
  // in middle of
  // zone

  eccPrimeSquared = (eccSquared) / (1 - eccSquared);

  M = y / k0;
  mu = M / (a * (1 - eccSquared / 4 - 3 * eccSquared * eccSquared / 64 - 5 * eccSquared * eccSquared * eccSquared / 256));

  phi1Rad = mu + (3 * e1 / 2 - 27 * e1 * e1 * e1 / 32) * Math.sin(2 * mu) + (21 * e1 * e1 / 16 - 55 * e1 * e1 * e1 * e1 / 32) * Math.sin(4 * mu) + (151 * e1 * e1 * e1 / 96) * Math.sin(6 * mu);
  // double phi1 = ProjMath.radToDeg(phi1Rad);

  N1 = a / Math.sqrt(1 - eccSquared * Math.sin(phi1Rad) * Math.sin(phi1Rad));
  T1 = Math.tan(phi1Rad) * Math.tan(phi1Rad);
  C1 = eccPrimeSquared * Math.cos(phi1Rad) * Math.cos(phi1Rad);
  R1 = a * (1 - eccSquared) / Math.pow(1 - eccSquared * Math.sin(phi1Rad) * Math.sin(phi1Rad), 1.5);
  D = x / (N1 * k0);

  var lat = phi1Rad - (N1 * Math.tan(phi1Rad) / R1) * (D * D / 2 - (5 + 3 * T1 + 10 * C1 - 4 * C1 * C1 - 9 * eccPrimeSquared) * D * D * D * D / 24 + (61 + 90 * T1 + 298 * C1 + 45 * T1 * T1 - 252 * eccPrimeSquared - 3 * C1 * C1) * D * D * D * D * D * D / 720);
  lat = radToDeg(lat);

  var lon = (D - (1 + 2 * T1 + C1) * D * D * D / 6 + (5 - 2 * C1 + 28 * T1 - 3 * C1 * C1 + 8 * eccPrimeSquared + 24 * T1 * T1) * D * D * D * D * D / 120) / Math.cos(phi1Rad);
  lon = LongOrigin + radToDeg(lon);

  var result;
  if (utm.accuracy) {
    var topRight = UTMtoLL({
      northing: utm.northing + utm.accuracy,
      easting: utm.easting + utm.accuracy,
      zoneLetter: utm.zoneLetter,
      zoneNumber: utm.zoneNumber
    });
    result = {
      top: topRight.lat,
      right: topRight.lon,
      bottom: lat,
      left: lon
    };
  }
  else {
    result = {
      lat: lat,
      lon: lon
    };
  }
  return result;
}

/**
 * Calculates the MGRS letter designator for the given latitude.
 *
 * @private
 * @param {number} lat The latitude in WGS84 to get the letter designator
 *     for.
 * @return {char} The letter designator.
 */
function getLetterDesignator(lat) {
  //This is here as an error flag to show that the Latitude is
  //outside MGRS limits
  var LetterDesignator = 'Z';

  if ((84 >= lat) && (lat >= 72)) {
    LetterDesignator = 'X';
  }
  else if ((72 > lat) && (lat >= 64)) {
    LetterDesignator = 'W';
  }
  else if ((64 > lat) && (lat >= 56)) {
    LetterDesignator = 'V';
  }
  else if ((56 > lat) && (lat >= 48)) {
    LetterDesignator = 'U';
  }
  else if ((48 > lat) && (lat >= 40)) {
    LetterDesignator = 'T';
  }
  else if ((40 > lat) && (lat >= 32)) {
    LetterDesignator = 'S';
  }
  else if ((32 > lat) && (lat >= 24)) {
    LetterDesignator = 'R';
  }
  else if ((24 > lat) && (lat >= 16)) {
    LetterDesignator = 'Q';
  }
  else if ((16 > lat) && (lat >= 8)) {
    LetterDesignator = 'P';
  }
  else if ((8 > lat) && (lat >= 0)) {
    LetterDesignator = 'N';
  }
  else if ((0 > lat) && (lat >= -8)) {
    LetterDesignator = 'M';
  }
  else if ((-8 > lat) && (lat >= -16)) {
    LetterDesignator = 'L';
  }
  else if ((-16 > lat) && (lat >= -24)) {
    LetterDesignator = 'K';
  }
  else if ((-24 > lat) && (lat >= -32)) {
    LetterDesignator = 'J';
  }
  else if ((-32 > lat) && (lat >= -40)) {
    LetterDesignator = 'H';
  }
  else if ((-40 > lat) && (lat >= -48)) {
    LetterDesignator = 'G';
  }
  else if ((-48 > lat) && (lat >= -56)) {
    LetterDesignator = 'F';
  }
  else if ((-56 > lat) && (lat >= -64)) {
    LetterDesignator = 'E';
  }
  else if ((-64 > lat) && (lat >= -72)) {
    LetterDesignator = 'D';
  }
  else if ((-72 > lat) && (lat >= -80)) {
    LetterDesignator = 'C';
  }
  return LetterDesignator;
}

/**
 * Encodes a UTM location as MGRS string.
 *
 * @private
 * @param {object} utm An object literal with easting, northing,
 *     zoneLetter, zoneNumber
 * @param {number} accuracy Accuracy in digits (1-5).
 * @return {string} MGRS string for the given UTM location.
 */
function encode(utm, accuracy) {
  // prepend with leading zeroes
  var seasting = "00000" + utm.easting,
    snorthing = "00000" + utm.northing;

  return utm.zoneNumber + utm.zoneLetter + get100kID(utm.easting, utm.northing, utm.zoneNumber) + seasting.substr(seasting.length - 5, accuracy) + snorthing.substr(snorthing.length - 5, accuracy);
}

/**
 * Get the two letter 100k designator for a given UTM easting,
 * northing and zone number value.
 *
 * @private
 * @param {number} easting
 * @param {number} northing
 * @param {number} zoneNumber
 * @return the two letter 100k designator for the given UTM location.
 */
function get100kID(easting, northing, zoneNumber) {
  var setParm = get100kSetForZone(zoneNumber);
  var setColumn = Math.floor(easting / 100000);
  var setRow = Math.floor(northing / 100000) % 20;
  return getLetter100kID(setColumn, setRow, setParm);
}

/**
 * Given a UTM zone number, figure out the MGRS 100K set it is in.
 *
 * @private
 * @param {number} i An UTM zone number.
 * @return {number} the 100k set the UTM zone is in.
 */
function get100kSetForZone(i) {
  var setParm = i % NUM_100K_SETS;
  if (setParm === 0) {
    setParm = NUM_100K_SETS;
  }

  return setParm;
}

/**
 * Get the two-letter MGRS 100k designator given information
 * translated from the UTM northing, easting and zone number.
 *
 * @private
 * @param {number} column the column index as it relates to the MGRS
 *        100k set spreadsheet, created from the UTM easting.
 *        Values are 1-8.
 * @param {number} row the row index as it relates to the MGRS 100k set
 *        spreadsheet, created from the UTM northing value. Values
 *        are from 0-19.
 * @param {number} parm the set block, as it relates to the MGRS 100k set
 *        spreadsheet, created from the UTM zone. Values are from
 *        1-60.
 * @return two letter MGRS 100k code.
 */
function getLetter100kID(column, row, parm) {
  // colOrigin and rowOrigin are the letters at the origin of the set
  var index = parm - 1;
  var colOrigin = SET_ORIGIN_COLUMN_LETTERS.charCodeAt(index);
  var rowOrigin = SET_ORIGIN_ROW_LETTERS.charCodeAt(index);

  // colInt and rowInt are the letters to build to return
  var colInt = colOrigin + column - 1;
  var rowInt = rowOrigin + row;
  var rollover = false;

  if (colInt > Z) {
    colInt = colInt - Z + A - 1;
    rollover = true;
  }

  if (colInt === I || (colOrigin < I && colInt > I) || ((colInt > I || colOrigin < I) && rollover)) {
    colInt++;
  }

  if (colInt === O || (colOrigin < O && colInt > O) || ((colInt > O || colOrigin < O) && rollover)) {
    colInt++;

    if (colInt === I) {
      colInt++;
    }
  }

  if (colInt > Z) {
    colInt = colInt - Z + A - 1;
  }

  if (rowInt > V) {
    rowInt = rowInt - V + A - 1;
    rollover = true;
  }
  else {
    rollover = false;
  }

  if (((rowInt === I) || ((rowOrigin < I) && (rowInt > I))) || (((rowInt > I) || (rowOrigin < I)) && rollover)) {
    rowInt++;
  }

  if (((rowInt === O) || ((rowOrigin < O) && (rowInt > O))) || (((rowInt > O) || (rowOrigin < O)) && rollover)) {
    rowInt++;

    if (rowInt === I) {
      rowInt++;
    }
  }

  if (rowInt > V) {
    rowInt = rowInt - V + A - 1;
  }

  var twoLetter = String.fromCharCode(colInt) + String.fromCharCode(rowInt);
  return twoLetter;
}

/**
 * Decode the UTM parameters from a MGRS string.
 *
 * @private
 * @param {string} mgrsString an UPPERCASE coordinate string is expected.
 * @return {object} An object literal with easting, northing, zoneLetter,
 *     zoneNumber and accuracy (in meters) properties.
 */
function decode(mgrsString) {

  if (mgrsString && mgrsString.length === 0) {
    throw ("MGRSPoint coverting from nothing");
  }

  var length = mgrsString.length;

  var hunK = null;
  var sb = "";
  var testChar;
  var i = 0;

  // get Zone number
  while (!(/[A-Z]/).test(testChar = mgrsString.charAt(i))) {
    if (i >= 2) {
      throw ("MGRSPoint bad conversion from: " + mgrsString);
    }
    sb += testChar;
    i++;
  }

  var zoneNumber = parseInt(sb, 10);

  if (i === 0 || i + 3 > length) {
    // A good MGRS string has to be 4-5 digits long,
    // ##AAA/#AAA at least.
    throw ("MGRSPoint bad conversion from: " + mgrsString);
  }

  var zoneLetter = mgrsString.charAt(i++);

  // Should we check the zone letter here? Why not.
  if (zoneLetter <= 'A' || zoneLetter === 'B' || zoneLetter === 'Y' || zoneLetter >= 'Z' || zoneLetter === 'I' || zoneLetter === 'O') {
    throw ("MGRSPoint zone letter " + zoneLetter + " not handled: " + mgrsString);
  }

  hunK = mgrsString.substring(i, i += 2);

  var set = get100kSetForZone(zoneNumber);

  var east100k = getEastingFromChar(hunK.charAt(0), set);
  var north100k = getNorthingFromChar(hunK.charAt(1), set);

  // We have a bug where the northing may be 2000000 too low.
  // How
  // do we know when to roll over?

  while (north100k < getMinNorthing(zoneLetter)) {
    north100k += 2000000;
  }

  // calculate the char index for easting/northing separator
  var remainder = length - i;

  if (remainder % 2 !== 0) {
    throw ("MGRSPoint has to have an even number \nof digits after the zone letter and two 100km letters - front \nhalf for easting meters, second half for \nnorthing meters" + mgrsString);
  }

  var sep = remainder / 2;

  var sepEasting = 0.0;
  var sepNorthing = 0.0;
  var accuracyBonus, sepEastingString, sepNorthingString, easting, northing;
  if (sep > 0) {
    accuracyBonus = 100000.0 / Math.pow(10, sep);
    sepEastingString = mgrsString.substring(i, i + sep);
    sepEasting = parseFloat(sepEastingString) * accuracyBonus;
    sepNorthingString = mgrsString.substring(i + sep);
    sepNorthing = parseFloat(sepNorthingString) * accuracyBonus;
  }

  easting = sepEasting + east100k;
  northing = sepNorthing + north100k;

  return {
    easting: easting,
    northing: northing,
    zoneLetter: zoneLetter,
    zoneNumber: zoneNumber,
    accuracy: accuracyBonus
  };
}

/**
 * Given the first letter from a two-letter MGRS 100k zone, and given the
 * MGRS table set for the zone number, figure out the easting value that
 * should be added to the other, secondary easting value.
 *
 * @private
 * @param {char} e The first letter from a two-letter MGRS 100´k zone.
 * @param {number} set The MGRS table set for the zone number.
 * @return {number} The easting value for the given letter and set.
 */
function getEastingFromChar(e, set) {
  // colOrigin is the letter at the origin of the set for the
  // column
  var curCol = SET_ORIGIN_COLUMN_LETTERS.charCodeAt(set - 1);
  var eastingValue = 100000.0;
  var rewindMarker = false;

  while (curCol !== e.charCodeAt(0)) {
    curCol++;
    if (curCol === I) {
      curCol++;
    }
    if (curCol === O) {
      curCol++;
    }
    if (curCol > Z) {
      if (rewindMarker) {
        throw ("Bad character: " + e);
      }
      curCol = A;
      rewindMarker = true;
    }
    eastingValue += 100000.0;
  }

  return eastingValue;
}

/**
 * Given the second letter from a two-letter MGRS 100k zone, and given the
 * MGRS table set for the zone number, figure out the northing value that
 * should be added to the other, secondary northing value. You have to
 * remember that Northings are determined from the equator, and the vertical
 * cycle of letters mean a 2000000 additional northing meters. This happens
 * approx. every 18 degrees of latitude. This method does *NOT* count any
 * additional northings. You have to figure out how many 2000000 meters need
 * to be added for the zone letter of the MGRS coordinate.
 *
 * @private
 * @param {char} n Second letter of the MGRS 100k zone
 * @param {number} set The MGRS table set number, which is dependent on the
 *     UTM zone number.
 * @return {number} The northing value for the given letter and set.
 */
function getNorthingFromChar(n, set) {

  if (n > 'V') {
    throw ("MGRSPoint given invalid Northing " + n);
  }

  // rowOrigin is the letter at the origin of the set for the
  // column
  var curRow = SET_ORIGIN_ROW_LETTERS.charCodeAt(set - 1);
  var northingValue = 0.0;
  var rewindMarker = false;

  while (curRow !== n.charCodeAt(0)) {
    curRow++;
    if (curRow === I) {
      curRow++;
    }
    if (curRow === O) {
      curRow++;
    }
    // fixing a bug making whole application hang in this loop
    // when 'n' is a wrong character
    if (curRow > V) {
      if (rewindMarker) { // making sure that this loop ends
        throw ("Bad character: " + n);
      }
      curRow = A;
      rewindMarker = true;
    }
    northingValue += 100000.0;
  }

  return northingValue;
}

/**
 * The function getMinNorthing returns the minimum northing value of a MGRS
 * zone.
 *
 * Ported from Geotrans' c Lattitude_Band_Value structure table.
 *
 * @private
 * @param {char} zoneLetter The MGRS zone to get the min northing for.
 * @return {number}
 */
function getMinNorthing(zoneLetter) {
  var northing;
  switch (zoneLetter) {
  case 'C':
    northing = 1100000.0;
    break;
  case 'D':
    northing = 2000000.0;
    break;
  case 'E':
    northing = 2800000.0;
    break;
  case 'F':
    northing = 3700000.0;
    break;
  case 'G':
    northing = 4600000.0;
    break;
  case 'H':
    northing = 5500000.0;
    break;
  case 'J':
    northing = 6400000.0;
    break;
  case 'K':
    northing = 7300000.0;
    break;
  case 'L':
    northing = 8200000.0;
    break;
  case 'M':
    northing = 9100000.0;
    break;
  case 'N':
    northing = 0.0;
    break;
  case 'P':
    northing = 800000.0;
    break;
  case 'Q':
    northing = 1700000.0;
    break;
  case 'R':
    northing = 2600000.0;
    break;
  case 'S':
    northing = 3500000.0;
    break;
  case 'T':
    northing = 4400000.0;
    break;
  case 'U':
    northing = 5300000.0;
    break;
  case 'V':
    northing = 6200000.0;
    break;
  case 'W':
    northing = 7000000.0;
    break;
  case 'X':
    northing = 7900000.0;
    break;
  default:
    northing = -1.0;
  }
  if (northing >= 0.0) {
    return northing;
  }
  else {
    throw ("Invalid zone letter: " + zoneLetter);
  }

}


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var af = moment.defineLocale('af', {
    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
    meridiemParse: /vm|nm/i,
    isPM : function (input) {
        return /^nm$/i.test(input);
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower ? 'vm' : 'VM';
        } else {
            return isLower ? 'nm' : 'NM';
        }
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Vandag om] LT',
        nextDay : '[Môre om] LT',
        nextWeek : 'dddd [om] LT',
        lastDay : '[Gister om] LT',
        lastWeek : '[Laas] dddd [om] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'oor %s',
        past : '%s gelede',
        s : '\'n paar sekondes',
        m : '\'n minuut',
        mm : '%d minute',
        h : '\'n uur',
        hh : '%d ure',
        d : '\'n dag',
        dd : '%d dae',
        M : '\'n maand',
        MM : '%d maande',
        y : '\'n jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
    },
    week : {
        dow : 1, // Maandag is die eerste dag van die week.
        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
    }
});

return af;

})));


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arDz = moment.defineLocale('ar-dz', {
    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 4  // The week that contains Jan 1st is the first week of the year.
    }
});

return arDz;

})));


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arKw = moment.defineLocale('ar-kw', {
    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arKw;

})));


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Lybia) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    '0': '0'
};
var pluralForm = function (n) {
    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
};
var plurals = {
    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
};
var pluralize = function (u) {
    return function (number, withoutSuffix, string, isFuture) {
        var f = pluralForm(number),
            str = plurals[u][pluralForm(number)];
        if (f === 2) {
            str = str[withoutSuffix ? 0 : 1];
        }
        return str.replace(/%d/i, number);
    };
};
var months = [
    'يناير',
    'فبراير',
    'مارس',
    'أبريل',
    'مايو',
    'يونيو',
    'يوليو',
    'أغسطس',
    'سبتمبر',
    'أكتوبر',
    'نوفمبر',
    'ديسمبر'
];

var arLy = moment.defineLocale('ar-ly', {
    months : months,
    monthsShort : months,
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/\u200FM/\u200FYYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم عند الساعة] LT',
        nextDay: '[غدًا عند الساعة] LT',
        nextWeek: 'dddd [عند الساعة] LT',
        lastDay: '[أمس عند الساعة] LT',
        lastWeek: 'dddd [عند الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'بعد %s',
        past : 'منذ %s',
        s : pluralize('s'),
        m : pluralize('m'),
        mm : pluralize('m'),
        h : pluralize('h'),
        hh : pluralize('h'),
        d : pluralize('d'),
        dd : pluralize('d'),
        M : pluralize('M'),
        MM : pluralize('M'),
        y : pluralize('y'),
        yy : pluralize('y')
    },
    preparse: function (string) {
        return string.replace(/\u200f/g, '').replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arLy;

})));


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arMa = moment.defineLocale('ar-ma', {
    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arMa;

})));


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '١',
    '2': '٢',
    '3': '٣',
    '4': '٤',
    '5': '٥',
    '6': '٦',
    '7': '٧',
    '8': '٨',
    '9': '٩',
    '0': '٠'
};
var numberMap = {
    '١': '1',
    '٢': '2',
    '٣': '3',
    '٤': '4',
    '٥': '5',
    '٦': '6',
    '٧': '7',
    '٨': '8',
    '٩': '9',
    '٠': '0'
};

var arSa = moment.defineLocale('ar-sa', {
    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    preparse: function (string) {
        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return arSa;

})));


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arTn = moment.defineLocale('ar-tn', {
    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'في %s',
        past: 'منذ %s',
        s: 'ثوان',
        m: 'دقيقة',
        mm: '%d دقائق',
        h: 'ساعة',
        hh: '%d ساعات',
        d: 'يوم',
        dd: '%d أيام',
        M: 'شهر',
        MM: '%d أشهر',
        y: 'سنة',
        yy: '%d سنوات'
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return arTn;

})));


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '١',
    '2': '٢',
    '3': '٣',
    '4': '٤',
    '5': '٥',
    '6': '٦',
    '7': '٧',
    '8': '٨',
    '9': '٩',
    '0': '٠'
};
var numberMap = {
    '١': '1',
    '٢': '2',
    '٣': '3',
    '٤': '4',
    '٥': '5',
    '٦': '6',
    '٧': '7',
    '٨': '8',
    '٩': '9',
    '٠': '0'
};
var pluralForm = function (n) {
    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
};
var plurals = {
    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
};
var pluralize = function (u) {
    return function (number, withoutSuffix, string, isFuture) {
        var f = pluralForm(number),
            str = plurals[u][pluralForm(number)];
        if (f === 2) {
            str = str[withoutSuffix ? 0 : 1];
        }
        return str.replace(/%d/i, number);
    };
};
var months = [
    'كانون الثاني يناير',
    'شباط فبراير',
    'آذار مارس',
    'نيسان أبريل',
    'أيار مايو',
    'حزيران يونيو',
    'تموز يوليو',
    'آب أغسطس',
    'أيلول سبتمبر',
    'تشرين الأول أكتوبر',
    'تشرين الثاني نوفمبر',
    'كانون الأول ديسمبر'
];

var ar = moment.defineLocale('ar', {
    months : months,
    monthsShort : months,
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/\u200FM/\u200FYYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم عند الساعة] LT',
        nextDay: '[غدًا عند الساعة] LT',
        nextWeek: 'dddd [عند الساعة] LT',
        lastDay: '[أمس عند الساعة] LT',
        lastWeek: 'dddd [عند الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'بعد %s',
        past : 'منذ %s',
        s : pluralize('s'),
        m : pluralize('m'),
        mm : pluralize('m'),
        h : pluralize('h'),
        hh : pluralize('h'),
        d : pluralize('d'),
        dd : pluralize('d'),
        M : pluralize('M'),
        MM : pluralize('M'),
        y : pluralize('y'),
        yy : pluralize('y')
    },
    preparse: function (string) {
        return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return ar;

})));


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    1: '-inci',
    5: '-inci',
    8: '-inci',
    70: '-inci',
    80: '-inci',
    2: '-nci',
    7: '-nci',
    20: '-nci',
    50: '-nci',
    3: '-üncü',
    4: '-üncü',
    100: '-üncü',
    6: '-ncı',
    9: '-uncu',
    10: '-uncu',
    30: '-uncu',
    60: '-ıncı',
    90: '-ıncı'
};

var az = moment.defineLocale('az', {
    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[bugün saat] LT',
        nextDay : '[sabah saat] LT',
        nextWeek : '[gələn həftə] dddd [saat] LT',
        lastDay : '[dünən] LT',
        lastWeek : '[keçən həftə] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s sonra',
        past : '%s əvvəl',
        s : 'birneçə saniyyə',
        m : 'bir dəqiqə',
        mm : '%d dəqiqə',
        h : 'bir saat',
        hh : '%d saat',
        d : 'bir gün',
        dd : '%d gün',
        M : 'bir ay',
        MM : '%d ay',
        y : 'bir il',
        yy : '%d il'
    },
    meridiemParse: /gecə|səhər|gündüz|axşam/,
    isPM : function (input) {
        return /^(gündüz|axşam)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'gecə';
        } else if (hour < 12) {
            return 'səhər';
        } else if (hour < 17) {
            return 'gündüz';
        } else {
            return 'axşam';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
    ordinal : function (number) {
        if (number === 0) {  // special case for zero
            return number + '-ıncı';
        }
        var a = number % 10,
            b = number % 100 - a,
            c = number >= 100 ? 100 : null;
        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return az;

})));


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
        'dd': 'дзень_дні_дзён',
        'MM': 'месяц_месяцы_месяцаў',
        'yy': 'год_гады_гадоў'
    };
    if (key === 'm') {
        return withoutSuffix ? 'хвіліна' : 'хвіліну';
    }
    else if (key === 'h') {
        return withoutSuffix ? 'гадзіна' : 'гадзіну';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}

var be = moment.defineLocale('be', {
    months : {
        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
    },
    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
    weekdays : {
        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
    },
    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY г.',
        LLL : 'D MMMM YYYY г., HH:mm',
        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
    },
    calendar : {
        sameDay: '[Сёння ў] LT',
        nextDay: '[Заўтра ў] LT',
        lastDay: '[Учора ў] LT',
        nextWeek: function () {
            return '[У] dddd [ў] LT';
        },
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 5:
                case 6:
                    return '[У мінулую] dddd [ў] LT';
                case 1:
                case 2:
                case 4:
                    return '[У мінулы] dddd [ў] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'праз %s',
        past : '%s таму',
        s : 'некалькі секунд',
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : relativeTimeWithPlural,
        hh : relativeTimeWithPlural,
        d : 'дзень',
        dd : relativeTimeWithPlural,
        M : 'месяц',
        MM : relativeTimeWithPlural,
        y : 'год',
        yy : relativeTimeWithPlural
    },
    meridiemParse: /ночы|раніцы|дня|вечара/,
    isPM : function (input) {
        return /^(дня|вечара)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночы';
        } else if (hour < 12) {
            return 'раніцы';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечара';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
            case 'w':
            case 'W':
                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
            case 'D':
                return number + '-га';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return be;

})));


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var bg = moment.defineLocale('bg', {
    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'D.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay : '[Днес в] LT',
        nextDay : '[Утре в] LT',
        nextWeek : 'dddd [в] LT',
        lastDay : '[Вчера в] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 6:
                    return '[В изминалата] dddd [в] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[В изминалия] dddd [в] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'след %s',
        past : 'преди %s',
        s : 'няколко секунди',
        m : 'минута',
        mm : '%d минути',
        h : 'час',
        hh : '%d часа',
        d : 'ден',
        dd : '%d дни',
        M : 'месец',
        MM : '%d месеца',
        y : 'година',
        yy : '%d години'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
    ordinal : function (number) {
        var lastDigit = number % 10,
            last2Digits = number % 100;
        if (number === 0) {
            return number + '-ев';
        } else if (last2Digits === 0) {
            return number + '-ен';
        } else if (last2Digits > 10 && last2Digits < 20) {
            return number + '-ти';
        } else if (lastDigit === 1) {
            return number + '-ви';
        } else if (lastDigit === 2) {
            return number + '-ри';
        } else if (lastDigit === 7 || lastDigit === 8) {
            return number + '-ми';
        } else {
            return number + '-ти';
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return bg;

})));


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '১',
    '2': '২',
    '3': '৩',
    '4': '৪',
    '5': '৫',
    '6': '৬',
    '7': '৭',
    '8': '৮',
    '9': '৯',
    '0': '০'
};
var numberMap = {
    '১': '1',
    '২': '2',
    '৩': '3',
    '৪': '4',
    '৫': '5',
    '৬': '6',
    '৭': '7',
    '৮': '8',
    '৯': '9',
    '০': '0'
};

var bn = moment.defineLocale('bn', {
    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
    longDateFormat : {
        LT : 'A h:mm সময়',
        LTS : 'A h:mm:ss সময়',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm সময়',
        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
    },
    calendar : {
        sameDay : '[আজ] LT',
        nextDay : '[আগামীকাল] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[গতকাল] LT',
        lastWeek : '[গত] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s পরে',
        past : '%s আগে',
        s : 'কয়েক সেকেন্ড',
        m : 'এক মিনিট',
        mm : '%d মিনিট',
        h : 'এক ঘন্টা',
        hh : '%d ঘন্টা',
        d : 'এক দিন',
        dd : '%d দিন',
        M : 'এক মাস',
        MM : '%d মাস',
        y : 'এক বছর',
        yy : '%d বছর'
    },
    preparse: function (string) {
        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'রাত';
        } else if (hour < 10) {
            return 'সকাল';
        } else if (hour < 17) {
            return 'দুপুর';
        } else if (hour < 20) {
            return 'বিকাল';
        } else {
            return 'রাত';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return bn;

})));


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '༡',
    '2': '༢',
    '3': '༣',
    '4': '༤',
    '5': '༥',
    '6': '༦',
    '7': '༧',
    '8': '༨',
    '9': '༩',
    '0': '༠'
};
var numberMap = {
    '༡': '1',
    '༢': '2',
    '༣': '3',
    '༤': '4',
    '༥': '5',
    '༦': '6',
    '༧': '7',
    '༨': '8',
    '༩': '9',
    '༠': '0'
};

var bo = moment.defineLocale('bo', {
    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[དི་རིང] LT',
        nextDay : '[སང་ཉིན] LT',
        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
        lastDay : '[ཁ་སང] LT',
        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ལ་',
        past : '%s སྔན་ལ',
        s : 'ལམ་སང',
        m : 'སྐར་མ་གཅིག',
        mm : '%d སྐར་མ',
        h : 'ཆུ་ཚོད་གཅིག',
        hh : '%d ཆུ་ཚོད',
        d : 'ཉིན་གཅིག',
        dd : '%d ཉིན་',
        M : 'ཟླ་བ་གཅིག',
        MM : '%d ཟླ་བ',
        y : 'ལོ་གཅིག',
        yy : '%d ལོ'
    },
    preparse: function (string) {
        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'མཚན་མོ';
        } else if (hour < 10) {
            return 'ཞོགས་ཀས';
        } else if (hour < 17) {
            return 'ཉིན་གུང';
        } else if (hour < 20) {
            return 'དགོང་དག';
        } else {
            return 'མཚན་མོ';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return bo;

})));


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function relativeTimeWithMutation(number, withoutSuffix, key) {
    var format = {
        'mm': 'munutenn',
        'MM': 'miz',
        'dd': 'devezh'
    };
    return number + ' ' + mutation(format[key], number);
}
function specialMutationForYears(number) {
    switch (lastNumber(number)) {
        case 1:
        case 3:
        case 4:
        case 5:
        case 9:
            return number + ' bloaz';
        default:
            return number + ' vloaz';
    }
}
function lastNumber(number) {
    if (number > 9) {
        return lastNumber(number % 10);
    }
    return number;
}
function mutation(text, number) {
    if (number === 2) {
        return softMutation(text);
    }
    return text;
}
function softMutation(text) {
    var mutationTable = {
        'm': 'v',
        'b': 'v',
        'd': 'z'
    };
    if (mutationTable[text.charAt(0)] === undefined) {
        return text;
    }
    return mutationTable[text.charAt(0)] + text.substring(1);
}

var br = moment.defineLocale('br', {
    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h[e]mm A',
        LTS : 'h[e]mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D [a viz] MMMM YYYY',
        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
    },
    calendar : {
        sameDay : '[Hiziv da] LT',
        nextDay : '[Warc\'hoazh da] LT',
        nextWeek : 'dddd [da] LT',
        lastDay : '[Dec\'h da] LT',
        lastWeek : 'dddd [paset da] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'a-benn %s',
        past : '%s \'zo',
        s : 'un nebeud segondennoù',
        m : 'ur vunutenn',
        mm : relativeTimeWithMutation,
        h : 'un eur',
        hh : '%d eur',
        d : 'un devezh',
        dd : relativeTimeWithMutation,
        M : 'ur miz',
        MM : relativeTimeWithMutation,
        y : 'ur bloaz',
        yy : specialMutationForYears
    },
    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
    ordinal : function (number) {
        var output = (number === 1) ? 'añ' : 'vet';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return br;

})));


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'm':
            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
        case 'mm':
            if (number === 1) {
                result += 'minuta';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'minute';
            } else {
                result += 'minuta';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'jedan sat' : 'jednog sata';
        case 'hh':
            if (number === 1) {
                result += 'sat';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sata';
            } else {
                result += 'sati';
            }
            return result;
        case 'dd':
            if (number === 1) {
                result += 'dan';
            } else {
                result += 'dana';
            }
            return result;
        case 'MM':
            if (number === 1) {
                result += 'mjesec';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'mjeseca';
            } else {
                result += 'mjeseci';
            }
            return result;
        case 'yy':
            if (number === 1) {
                result += 'godina';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'godine';
            } else {
                result += 'godina';
            }
            return result;
    }
}

var bs = moment.defineLocale('bs', {
    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danas u] LT',
        nextDay  : '[sutra u] LT',
        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[jučer u] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                    return '[prošlu] dddd [u] LT';
                case 6:
                    return '[prošle] [subote] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prošli] dddd [u] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'par sekundi',
        m      : translate,
        mm     : translate,
        h      : translate,
        hh     : translate,
        d      : 'dan',
        dd     : translate,
        M      : 'mjesec',
        MM     : translate,
        y      : 'godinu',
        yy     : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return bs;

})));


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
function plural(n) {
    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':  // a few seconds / in a few seconds / a few seconds ago
            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
        case 'm':  // a minute / in a minute / a minute ago
            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'minuty' : 'minut');
            } else {
                return result + 'minutami';
            }
            break;
        case 'h':  // an hour / in an hour / an hour ago
            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
        case 'hh': // 9 hours / in 9 hours / 9 hours ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'hodiny' : 'hodin');
            } else {
                return result + 'hodinami';
            }
            break;
        case 'd':  // a day / in a day / a day ago
            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
        case 'dd': // 9 days / in 9 days / 9 days ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'dny' : 'dní');
            } else {
                return result + 'dny';
            }
            break;
        case 'M':  // a month / in a month / a month ago
            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
        case 'MM': // 9 months / in 9 months / 9 months ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'měsíce' : 'měsíců');
            } else {
                return result + 'měsíci';
            }
            break;
        case 'y':  // a year / in a year / a year ago
            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
        case 'yy': // 9 years / in 9 years / 9 years ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'roky' : 'let');
            } else {
                return result + 'lety';
            }
            break;
    }
}

var cs = moment.defineLocale('cs', {
    months : months,
    monthsShort : monthsShort,
    monthsParse : (function (months, monthsShort) {
        var i, _monthsParse = [];
        for (i = 0; i < 12; i++) {
            // use custom parser to solve problem with July (červenec)
            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
        }
        return _monthsParse;
    }(months, monthsShort)),
    shortMonthsParse : (function (monthsShort) {
        var i, _shortMonthsParse = [];
        for (i = 0; i < 12; i++) {
            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
        }
        return _shortMonthsParse;
    }(monthsShort)),
    longMonthsParse : (function (months) {
        var i, _longMonthsParse = [];
        for (i = 0; i < 12; i++) {
            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
        }
        return _longMonthsParse;
    }(months)),
    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
    longDateFormat : {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd D. MMMM YYYY H:mm',
        l : 'D. M. YYYY'
    },
    calendar : {
        sameDay: '[dnes v] LT',
        nextDay: '[zítra v] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[v neděli v] LT';
                case 1:
                case 2:
                    return '[v] dddd [v] LT';
                case 3:
                    return '[ve středu v] LT';
                case 4:
                    return '[ve čtvrtek v] LT';
                case 5:
                    return '[v pátek v] LT';
                case 6:
                    return '[v sobotu v] LT';
            }
        },
        lastDay: '[včera v] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[minulou neděli v] LT';
                case 1:
                case 2:
                    return '[minulé] dddd [v] LT';
                case 3:
                    return '[minulou středu v] LT';
                case 4:
                case 5:
                    return '[minulý] dddd [v] LT';
                case 6:
                    return '[minulou sobotu v] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : 'před %s',
        s : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse : /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return cs;

})));


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var cv = moment.defineLocale('cv', {
    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
    },
    calendar : {
        sameDay: '[Паян] LT [сехетре]',
        nextDay: '[Ыран] LT [сехетре]',
        lastDay: '[Ӗнер] LT [сехетре]',
        nextWeek: '[Ҫитес] dddd LT [сехетре]',
        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
        sameElse: 'L'
    },
    relativeTime : {
        future : function (output) {
            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
            return output + affix;
        },
        past : '%s каялла',
        s : 'пӗр-ик ҫеккунт',
        m : 'пӗр минут',
        mm : '%d минут',
        h : 'пӗр сехет',
        hh : '%d сехет',
        d : 'пӗр кун',
        dd : '%d кун',
        M : 'пӗр уйӑх',
        MM : '%d уйӑх',
        y : 'пӗр ҫул',
        yy : '%d ҫул'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
    ordinal : '%d-мӗш',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return cv;

})));


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var cy = moment.defineLocale('cy', {
    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
    weekdaysParseExact : true,
    // time formats are the same as en-gb
    longDateFormat: {
        LT: 'HH:mm',
        LTS : 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[Heddiw am] LT',
        nextDay: '[Yfory am] LT',
        nextWeek: 'dddd [am] LT',
        lastDay: '[Ddoe am] LT',
        lastWeek: 'dddd [diwethaf am] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'mewn %s',
        past: '%s yn ôl',
        s: 'ychydig eiliadau',
        m: 'munud',
        mm: '%d munud',
        h: 'awr',
        hh: '%d awr',
        d: 'diwrnod',
        dd: '%d diwrnod',
        M: 'mis',
        MM: '%d mis',
        y: 'blwyddyn',
        yy: '%d flynedd'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
    ordinal: function (number) {
        var b = number,
            output = '',
            lookup = [
                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
            ];
        if (b > 20) {
            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                output = 'fed'; // not 30ain, 70ain or 90ain
            } else {
                output = 'ain';
            }
        } else if (b > 0) {
            output = lookup[b];
        }
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return cy;

})));


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var da = moment.defineLocale('da', {
    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay : '[i dag kl.] LT',
        nextDay : '[i morgen kl.] LT',
        nextWeek : 'på dddd [kl.] LT',
        lastDay : '[i går kl.] LT',
        lastWeek : '[i] dddd[s kl.] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s siden',
        s : 'få sekunder',
        m : 'et minut',
        mm : '%d minutter',
        h : 'en time',
        hh : '%d timer',
        d : 'en dag',
        dd : '%d dage',
        M : 'en måned',
        MM : '%d måneder',
        y : 'et år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return da;

})));


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var deAt = moment.defineLocale('de-at', {
    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return deAt;

})));


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#

function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var deCh = moment.defineLocale('de-ch', {
    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jan._Febr._März_April_Mai_Juni_Juli_Aug._Sept._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH.mm',
        LTS: 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH.mm',
        LLLL : 'dddd, D. MMMM YYYY HH.mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return deCh;

})));


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var de = moment.defineLocale('de', {
    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return de;

})));


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'ޖެނުއަރީ',
    'ފެބްރުއަރީ',
    'މާރިޗު',
    'އޭޕްރީލު',
    'މޭ',
    'ޖޫން',
    'ޖުލައި',
    'އޯގަސްޓު',
    'ސެޕްޓެމްބަރު',
    'އޮކްޓޯބަރު',
    'ނޮވެމްބަރު',
    'ޑިސެމްބަރު'
];
var weekdays = [
    'އާދިއްތަ',
    'ހޯމަ',
    'އަންގާރަ',
    'ބުދަ',
    'ބުރާސްފަތި',
    'ހުކުރު',
    'ހޮނިހިރު'
];

var dv = moment.defineLocale('dv', {
    months : months,
    monthsShort : months,
    weekdays : weekdays,
    weekdaysShort : weekdays,
    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
    longDateFormat : {

        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/M/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /މކ|މފ/,
    isPM : function (input) {
        return 'މފ' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'މކ';
        } else {
            return 'މފ';
        }
    },
    calendar : {
        sameDay : '[މިއަދު] LT',
        nextDay : '[މާދަމާ] LT',
        nextWeek : 'dddd LT',
        lastDay : '[އިއްޔެ] LT',
        lastWeek : '[ފާއިތުވި] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ތެރޭގައި %s',
        past : 'ކުރިން %s',
        s : 'ސިކުންތުކޮޅެއް',
        m : 'މިނިޓެއް',
        mm : 'މިނިޓު %d',
        h : 'ގަޑިއިރެއް',
        hh : 'ގަޑިއިރު %d',
        d : 'ދުވަހެއް',
        dd : 'ދުވަސް %d',
        M : 'މަހެއް',
        MM : 'މަސް %d',
        y : 'އަހަރެއް',
        yy : 'އަހަރު %d'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 7,  // Sunday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return dv;

})));


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}


var el = moment.defineLocale('el', {
    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
    months : function (momentToFormat, format) {
        if (!momentToFormat) {
            return this._monthsNominativeEl;
        } else if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
            return this._monthsGenitiveEl[momentToFormat.month()];
        } else {
            return this._monthsNominativeEl[momentToFormat.month()];
        }
    },
    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'μμ' : 'ΜΜ';
        } else {
            return isLower ? 'πμ' : 'ΠΜ';
        }
    },
    isPM : function (input) {
        return ((input + '').toLowerCase()[0] === 'μ');
    },
    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendarEl : {
        sameDay : '[Σήμερα {}] LT',
        nextDay : '[Αύριο {}] LT',
        nextWeek : 'dddd [{}] LT',
        lastDay : '[Χθες {}] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 6:
                    return '[το προηγούμενο] dddd [{}] LT';
                default:
                    return '[την προηγούμενη] dddd [{}] LT';
            }
        },
        sameElse : 'L'
    },
    calendar : function (key, mom) {
        var output = this._calendarEl[key],
            hours = mom && mom.hours();
        if (isFunction(output)) {
            output = output.apply(mom);
        }
        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
    },
    relativeTime : {
        future : 'σε %s',
        past : '%s πριν',
        s : 'λίγα δευτερόλεπτα',
        m : 'ένα λεπτό',
        mm : '%d λεπτά',
        h : 'μία ώρα',
        hh : '%d ώρες',
        d : 'μία μέρα',
        dd : '%d μέρες',
        M : 'ένας μήνας',
        MM : '%d μήνες',
        y : 'ένας χρόνος',
        yy : '%d χρόνια'
    },
    dayOfMonthOrdinalParse: /\d{1,2}η/,
    ordinal: '%dη',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4st is the first week of the year.
    }
});

return el;

})));


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enAu = moment.defineLocale('en-au', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enAu;

})));


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enCa = moment.defineLocale('en-ca', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'YYYY-MM-DD',
        LL : 'MMMM D, YYYY',
        LLL : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

return enCa;

})));


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enGb = moment.defineLocale('en-gb', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enGb;

})));


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enIe = moment.defineLocale('en-ie', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enIe;

})));


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enNz = moment.defineLocale('en-nz', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enNz;

})));


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var eo = moment.defineLocale('eo', {
    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D[-a de] MMMM, YYYY',
        LLL : 'D[-a de] MMMM, YYYY HH:mm',
        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
    },
    meridiemParse: /[ap]\.t\.m/i,
    isPM: function (input) {
        return input.charAt(0).toLowerCase() === 'p';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'p.t.m.' : 'P.T.M.';
        } else {
            return isLower ? 'a.t.m.' : 'A.T.M.';
        }
    },
    calendar : {
        sameDay : '[Hodiaŭ je] LT',
        nextDay : '[Morgaŭ je] LT',
        nextWeek : 'dddd [je] LT',
        lastDay : '[Hieraŭ je] LT',
        lastWeek : '[pasinta] dddd [je] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'post %s',
        past : 'antaŭ %s',
        s : 'sekundoj',
        m : 'minuto',
        mm : '%d minutoj',
        h : 'horo',
        hh : '%d horoj',
        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
        dd : '%d tagoj',
        M : 'monato',
        MM : '%d monatoj',
        y : 'jaro',
        yy : '%d jaroj'
    },
    dayOfMonthOrdinalParse: /\d{1,2}a/,
    ordinal : '%da',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return eo;

})));


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var esDo = moment.defineLocale('es-do', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY h:mm A',
        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return esDo;

})));


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var es = moment.defineLocale('es', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY H:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return es;

})));


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
        'm' : ['ühe minuti', 'üks minut'],
        'mm': [number + ' minuti', number + ' minutit'],
        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
        'hh': [number + ' tunni', number + ' tundi'],
        'd' : ['ühe päeva', 'üks päev'],
        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
        'MM': [number + ' kuu', number + ' kuud'],
        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
        'yy': [number + ' aasta', number + ' aastat']
    };
    if (withoutSuffix) {
        return format[key][2] ? format[key][2] : format[key][1];
    }
    return isFuture ? format[key][0] : format[key][1];
}

var et = moment.defineLocale('et', {
    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
    longDateFormat : {
        LT   : 'H:mm',
        LTS : 'H:mm:ss',
        L    : 'DD.MM.YYYY',
        LL   : 'D. MMMM YYYY',
        LLL  : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[Täna,] LT',
        nextDay  : '[Homme,] LT',
        nextWeek : '[Järgmine] dddd LT',
        lastDay  : '[Eile,] LT',
        lastWeek : '[Eelmine] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s pärast',
        past   : '%s tagasi',
        s      : processRelativeTime,
        m      : processRelativeTime,
        mm     : processRelativeTime,
        h      : processRelativeTime,
        hh     : processRelativeTime,
        d      : processRelativeTime,
        dd     : '%d päeva',
        M      : processRelativeTime,
        MM     : processRelativeTime,
        y      : processRelativeTime,
        yy     : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return et;

})));


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var eu = moment.defineLocale('eu', {
    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
    monthsParseExact : true,
    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'YYYY[ko] MMMM[ren] D[a]',
        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
        l : 'YYYY-M-D',
        ll : 'YYYY[ko] MMM D[a]',
        lll : 'YYYY[ko] MMM D[a] HH:mm',
        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
    },
    calendar : {
        sameDay : '[gaur] LT[etan]',
        nextDay : '[bihar] LT[etan]',
        nextWeek : 'dddd LT[etan]',
        lastDay : '[atzo] LT[etan]',
        lastWeek : '[aurreko] dddd LT[etan]',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s barru',
        past : 'duela %s',
        s : 'segundo batzuk',
        m : 'minutu bat',
        mm : '%d minutu',
        h : 'ordu bat',
        hh : '%d ordu',
        d : 'egun bat',
        dd : '%d egun',
        M : 'hilabete bat',
        MM : '%d hilabete',
        y : 'urte bat',
        yy : '%d urte'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return eu;

})));


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '۱',
    '2': '۲',
    '3': '۳',
    '4': '۴',
    '5': '۵',
    '6': '۶',
    '7': '۷',
    '8': '۸',
    '9': '۹',
    '0': '۰'
};
var numberMap = {
    '۱': '1',
    '۲': '2',
    '۳': '3',
    '۴': '4',
    '۵': '5',
    '۶': '6',
    '۷': '7',
    '۸': '8',
    '۹': '9',
    '۰': '0'
};

var fa = moment.defineLocale('fa', {
    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    meridiemParse: /قبل از ظهر|بعد از ظهر/,
    isPM: function (input) {
        return /بعد از ظهر/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'قبل از ظهر';
        } else {
            return 'بعد از ظهر';
        }
    },
    calendar : {
        sameDay : '[امروز ساعت] LT',
        nextDay : '[فردا ساعت] LT',
        nextWeek : 'dddd [ساعت] LT',
        lastDay : '[دیروز ساعت] LT',
        lastWeek : 'dddd [پیش] [ساعت] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'در %s',
        past : '%s پیش',
        s : 'چند ثانیه',
        m : 'یک دقیقه',
        mm : '%d دقیقه',
        h : 'یک ساعت',
        hh : '%d ساعت',
        d : 'یک روز',
        dd : '%d روز',
        M : 'یک ماه',
        MM : '%d ماه',
        y : 'یک سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/[۰-۹]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    dayOfMonthOrdinalParse: /\d{1,2}م/,
    ordinal : '%dم',
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12 // The week that contains Jan 1st is the first week of the year.
    }
});

return fa;

})));


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
var numbersFuture = [
        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
        numbersPast[7], numbersPast[8], numbersPast[9]
    ];
function translate(number, withoutSuffix, key, isFuture) {
    var result = '';
    switch (key) {
        case 's':
            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
        case 'm':
            return isFuture ? 'minuutin' : 'minuutti';
        case 'mm':
            result = isFuture ? 'minuutin' : 'minuuttia';
            break;
        case 'h':
            return isFuture ? 'tunnin' : 'tunti';
        case 'hh':
            result = isFuture ? 'tunnin' : 'tuntia';
            break;
        case 'd':
            return isFuture ? 'päivän' : 'päivä';
        case 'dd':
            result = isFuture ? 'päivän' : 'päivää';
            break;
        case 'M':
            return isFuture ? 'kuukauden' : 'kuukausi';
        case 'MM':
            result = isFuture ? 'kuukauden' : 'kuukautta';
            break;
        case 'y':
            return isFuture ? 'vuoden' : 'vuosi';
        case 'yy':
            result = isFuture ? 'vuoden' : 'vuotta';
            break;
    }
    result = verbalNumber(number, isFuture) + ' ' + result;
    return result;
}
function verbalNumber(number, isFuture) {
    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
}

var fi = moment.defineLocale('fi', {
    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'Do MMMM[ta] YYYY',
        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
        l : 'D.M.YYYY',
        ll : 'Do MMM YYYY',
        lll : 'Do MMM YYYY, [klo] HH.mm',
        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
    },
    calendar : {
        sameDay : '[tänään] [klo] LT',
        nextDay : '[huomenna] [klo] LT',
        nextWeek : 'dddd [klo] LT',
        lastDay : '[eilen] [klo] LT',
        lastWeek : '[viime] dddd[na] [klo] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s päästä',
        past : '%s sitten',
        s : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fi;

})));


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var fo = moment.defineLocale('fo', {
    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D. MMMM, YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Í dag kl.] LT',
        nextDay : '[Í morgin kl.] LT',
        nextWeek : 'dddd [kl.] LT',
        lastDay : '[Í gjár kl.] LT',
        lastWeek : '[síðstu] dddd [kl] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'um %s',
        past : '%s síðani',
        s : 'fá sekund',
        m : 'ein minutt',
        mm : '%d minuttir',
        h : 'ein tími',
        hh : '%d tímar',
        d : 'ein dagur',
        dd : '%d dagar',
        M : 'ein mánaði',
        MM : '%d mánaðir',
        y : 'eitt ár',
        yy : '%d ár'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fo;

})));


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var frCa = moment.defineLocale('fr-ca', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
    ordinal : function (number, period) {
        switch (period) {
            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'D':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    }
});

return frCa;

})));


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var frCh = moment.defineLocale('fr-ch', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
    ordinal : function (number, period) {
        switch (period) {
            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'D':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return frCh;

})));


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var fr = moment.defineLocale('fr', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
    ordinal : function (number, period) {
        switch (period) {
            // TODO: Return 'e' when day of month > 1. Move this case inside
            // block for masculine words below.
            // See https://github.com/moment/moment/issues/3375
            case 'D':
                return number + (number === 1 ? 'er' : '');

            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fr;

})));


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

var fy = moment.defineLocale('fy', {
    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[hjoed om] LT',
        nextDay: '[moarn om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[juster om] LT',
        lastWeek: '[ôfrûne] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'oer %s',
        past : '%s lyn',
        s : 'in pear sekonden',
        m : 'ien minút',
        mm : '%d minuten',
        h : 'ien oere',
        hh : '%d oeren',
        d : 'ien dei',
        dd : '%d dagen',
        M : 'ien moanne',
        MM : '%d moannen',
        y : 'ien jier',
        yy : '%d jierren'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fy;

})));


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
];

var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];

var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];

var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];

var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

var gd = moment.defineLocale('gd', {
    months : months,
    monthsShort : monthsShort,
    monthsParseExact : true,
    weekdays : weekdays,
    weekdaysShort : weekdaysShort,
    weekdaysMin : weekdaysMin,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[An-diugh aig] LT',
        nextDay : '[A-màireach aig] LT',
        nextWeek : 'dddd [aig] LT',
        lastDay : '[An-dè aig] LT',
        lastWeek : 'dddd [seo chaidh] [aig] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ann an %s',
        past : 'bho chionn %s',
        s : 'beagan diogan',
        m : 'mionaid',
        mm : '%d mionaidean',
        h : 'uair',
        hh : '%d uairean',
        d : 'latha',
        dd : '%d latha',
        M : 'mìos',
        MM : '%d mìosan',
        y : 'bliadhna',
        yy : '%d bliadhna'
    },
    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
    ordinal : function (number) {
        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return gd;

})));


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var gl = moment.defineLocale('gl', {
    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY H:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
        },
        nextDay : function () {
            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
        },
        lastDay : function () {
            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
        },
        lastWeek : function () {
            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : function (str) {
            if (str.indexOf('un') === 0) {
                return 'n' + str;
            }
            return 'en ' + str;
        },
        past : 'hai %s',
        s : 'uns segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'unha hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return gl;

})));


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's': ['thodde secondanim', 'thodde second'],
        'm': ['eka mintan', 'ek minute'],
        'mm': [number + ' mintanim', number + ' mintam'],
        'h': ['eka horan', 'ek hor'],
        'hh': [number + ' horanim', number + ' hor'],
        'd': ['eka disan', 'ek dis'],
        'dd': [number + ' disanim', number + ' dis'],
        'M': ['eka mhoinean', 'ek mhoino'],
        'MM': [number + ' mhoineanim', number + ' mhoine'],
        'y': ['eka vorsan', 'ek voros'],
        'yy': [number + ' vorsanim', number + ' vorsam']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var gomLatn = moment.defineLocale('gom-latn', {
    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'A h:mm [vazta]',
        LTS : 'A h:mm:ss [vazta]',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY A h:mm [vazta]',
        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
    },
    calendar : {
        sameDay: '[Aiz] LT',
        nextDay: '[Faleam] LT',
        nextWeek: '[Ieta to] dddd[,] LT',
        lastDay: '[Kal] LT',
        lastWeek: '[Fatlo] dddd[,] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s',
        past : '%s adim',
        s : processRelativeTime,
        m : processRelativeTime,
        mm : processRelativeTime,
        h : processRelativeTime,
        hh : processRelativeTime,
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
    ordinal : function (number, period) {
        switch (period) {
            // the ordinal 'er' only applies to day of the month
            case 'D':
                return number + 'er';
            default:
            case 'M':
            case 'Q':
            case 'DDD':
            case 'd':
            case 'w':
            case 'W':
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    },
    meridiemParse: /rati|sokalli|donparam|sanje/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'rati') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'sokalli') {
            return hour;
        } else if (meridiem === 'donparam') {
            return hour > 12 ? hour : hour + 12;
        } else if (meridiem === 'sanje') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'rati';
        } else if (hour < 12) {
            return 'sokalli';
        } else if (hour < 16) {
            return 'donparam';
        } else if (hour < 20) {
            return 'sanje';
        } else {
            return 'rati';
        }
    }
});

return gomLatn;

})));


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var he = moment.defineLocale('he', {
    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [ב]MMMM YYYY',
        LLL : 'D [ב]MMMM YYYY HH:mm',
        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
        l : 'D/M/YYYY',
        ll : 'D MMM YYYY',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd, D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[היום ב־]LT',
        nextDay : '[מחר ב־]LT',
        nextWeek : 'dddd [בשעה] LT',
        lastDay : '[אתמול ב־]LT',
        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'בעוד %s',
        past : 'לפני %s',
        s : 'מספר שניות',
        m : 'דקה',
        mm : '%d דקות',
        h : 'שעה',
        hh : function (number) {
            if (number === 2) {
                return 'שעתיים';
            }
            return number + ' שעות';
        },
        d : 'יום',
        dd : function (number) {
            if (number === 2) {
                return 'יומיים';
            }
            return number + ' ימים';
        },
        M : 'חודש',
        MM : function (number) {
            if (number === 2) {
                return 'חודשיים';
            }
            return number + ' חודשים';
        },
        y : 'שנה',
        yy : function (number) {
            if (number === 2) {
                return 'שנתיים';
            } else if (number % 10 === 0 && number !== 10) {
                return number + ' שנה';
            }
            return number + ' שנים';
        }
    },
    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
    isPM : function (input) {
        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 5) {
            return 'לפנות בוקר';
        } else if (hour < 10) {
            return 'בבוקר';
        } else if (hour < 12) {
            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
        } else if (hour < 18) {
            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
        } else {
            return 'בערב';
        }
    }
});

return he;

})));


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

var hi = moment.defineLocale('hi', {
    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
    monthsParseExact: true,
    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
    longDateFormat : {
        LT : 'A h:mm बजे',
        LTS : 'A h:mm:ss बजे',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm बजे',
        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[कल] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[कल] LT',
        lastWeek : '[पिछले] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s में',
        past : '%s पहले',
        s : 'कुछ ही क्षण',
        m : 'एक मिनट',
        mm : '%d मिनट',
        h : 'एक घंटा',
        hh : '%d घंटे',
        d : 'एक दिन',
        dd : '%d दिन',
        M : 'एक महीने',
        MM : '%d महीने',
        y : 'एक वर्ष',
        yy : '%d वर्ष'
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
    meridiemParse: /रात|सुबह|दोपहर|शाम/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'रात') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'सुबह') {
            return hour;
        } else if (meridiem === 'दोपहर') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'शाम') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'रात';
        } else if (hour < 10) {
            return 'सुबह';
        } else if (hour < 17) {
            return 'दोपहर';
        } else if (hour < 20) {
            return 'शाम';
        } else {
            return 'रात';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return hi;

})));


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'm':
            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
        case 'mm':
            if (number === 1) {
                result += 'minuta';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'minute';
            } else {
                result += 'minuta';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'jedan sat' : 'jednog sata';
        case 'hh':
            if (number === 1) {
                result += 'sat';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sata';
            } else {
                result += 'sati';
            }
            return result;
        case 'dd':
            if (number === 1) {
                result += 'dan';
            } else {
                result += 'dana';
            }
            return result;
        case 'MM':
            if (number === 1) {
                result += 'mjesec';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'mjeseca';
            } else {
                result += 'mjeseci';
            }
            return result;
        case 'yy':
            if (number === 1) {
                result += 'godina';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'godine';
            } else {
                result += 'godina';
            }
            return result;
    }
}

var hr = moment.defineLocale('hr', {
    months : {
        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
    },
    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danas u] LT',
        nextDay  : '[sutra u] LT',
        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[jučer u] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                    return '[prošlu] dddd [u] LT';
                case 6:
                    return '[prošle] [subote] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prošli] dddd [u] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'par sekundi',
        m      : translate,
        mm     : translate,
        h      : translate,
        hh     : translate,
        d      : 'dan',
        dd     : translate,
        M      : 'mjesec',
        MM     : translate,
        y      : 'godinu',
        yy     : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return hr;

})));


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
function translate(number, withoutSuffix, key, isFuture) {
    var num = number,
        suffix;
    switch (key) {
        case 's':
            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
        case 'm':
            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
        case 'mm':
            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
        case 'h':
            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
        case 'hh':
            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
        case 'd':
            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
        case 'dd':
            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
        case 'M':
            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
        case 'MM':
            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
        case 'y':
            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
        case 'yy':
            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
    }
    return '';
}
function week(isFuture) {
    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
}

var hu = moment.defineLocale('hu', {
    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'YYYY.MM.DD.',
        LL : 'YYYY. MMMM D.',
        LLL : 'YYYY. MMMM D. H:mm',
        LLLL : 'YYYY. MMMM D., dddd H:mm'
    },
    meridiemParse: /de|du/i,
    isPM: function (input) {
        return input.charAt(1).toLowerCase() === 'u';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower === true ? 'de' : 'DE';
        } else {
            return isLower === true ? 'du' : 'DU';
        }
    },
    calendar : {
        sameDay : '[ma] LT[-kor]',
        nextDay : '[holnap] LT[-kor]',
        nextWeek : function () {
            return week.call(this, true);
        },
        lastDay : '[tegnap] LT[-kor]',
        lastWeek : function () {
            return week.call(this, false);
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s múlva',
        past : '%s',
        s : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return hu;

})));


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var hyAm = moment.defineLocale('hy-am', {
    months : {
        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
    },
    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY թ.',
        LLL : 'D MMMM YYYY թ., HH:mm',
        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
    },
    calendar : {
        sameDay: '[այսօր] LT',
        nextDay: '[վաղը] LT',
        lastDay: '[երեկ] LT',
        nextWeek: function () {
            return 'dddd [օրը ժամը] LT';
        },
        lastWeek: function () {
            return '[անցած] dddd [օրը ժամը] LT';
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s հետո',
        past : '%s առաջ',
        s : 'մի քանի վայրկյան',
        m : 'րոպե',
        mm : '%d րոպե',
        h : 'ժամ',
        hh : '%d ժամ',
        d : 'օր',
        dd : '%d օր',
        M : 'ամիս',
        MM : '%d ամիս',
        y : 'տարի',
        yy : '%d տարի'
    },
    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
    isPM: function (input) {
        return /^(ցերեկվա|երեկոյան)$/.test(input);
    },
    meridiem : function (hour) {
        if (hour < 4) {
            return 'գիշերվա';
        } else if (hour < 12) {
            return 'առավոտվա';
        } else if (hour < 17) {
            return 'ցերեկվա';
        } else {
            return 'երեկոյան';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'DDD':
            case 'w':
            case 'W':
            case 'DDDo':
                if (number === 1) {
                    return number + '-ին';
                }
                return number + '-րդ';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return hyAm;

})));


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var id = moment.defineLocale('id', {
    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|siang|sore|malam/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'siang') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'sore' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'siang';
        } else if (hours < 19) {
            return 'sore';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Besok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kemarin pukul] LT',
        lastWeek : 'dddd [lalu pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lalu',
        s : 'beberapa detik',
        m : 'semenit',
        mm : '%d menit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return id;

})));


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(n) {
    if (n % 100 === 11) {
        return true;
    } else if (n % 10 === 1) {
        return false;
    }
    return true;
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':
            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
        case 'm':
            return withoutSuffix ? 'mínúta' : 'mínútu';
        case 'mm':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
            } else if (withoutSuffix) {
                return result + 'mínúta';
            }
            return result + 'mínútu';
        case 'hh':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
            }
            return result + 'klukkustund';
        case 'd':
            if (withoutSuffix) {
                return 'dagur';
            }
            return isFuture ? 'dag' : 'degi';
        case 'dd':
            if (plural(number)) {
                if (withoutSuffix) {
                    return result + 'dagar';
                }
                return result + (isFuture ? 'daga' : 'dögum');
            } else if (withoutSuffix) {
                return result + 'dagur';
            }
            return result + (isFuture ? 'dag' : 'degi');
        case 'M':
            if (withoutSuffix) {
                return 'mánuður';
            }
            return isFuture ? 'mánuð' : 'mánuði';
        case 'MM':
            if (plural(number)) {
                if (withoutSuffix) {
                    return result + 'mánuðir';
                }
                return result + (isFuture ? 'mánuði' : 'mánuðum');
            } else if (withoutSuffix) {
                return result + 'mánuður';
            }
            return result + (isFuture ? 'mánuð' : 'mánuði');
        case 'y':
            return withoutSuffix || isFuture ? 'ár' : 'ári';
        case 'yy':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
            }
            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
    }
}

var is = moment.defineLocale('is', {
    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] H:mm',
        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
    },
    calendar : {
        sameDay : '[í dag kl.] LT',
        nextDay : '[á morgun kl.] LT',
        nextWeek : 'dddd [kl.] LT',
        lastDay : '[í gær kl.] LT',
        lastWeek : '[síðasta] dddd [kl.] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'eftir %s',
        past : 'fyrir %s síðan',
        s : translate,
        m : translate,
        mm : translate,
        h : 'klukkustund',
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return is;

})));


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var it = moment.defineLocale('it', {
    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Oggi alle] LT',
        nextDay: '[Domani alle] LT',
        nextWeek: 'dddd [alle] LT',
        lastDay: '[Ieri alle] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[la scorsa] dddd [alle] LT';
                default:
                    return '[lo scorso] dddd [alle] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : function (s) {
            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
        },
        past : '%s fa',
        s : 'alcuni secondi',
        m : 'un minuto',
        mm : '%d minuti',
        h : 'un\'ora',
        hh : '%d ore',
        d : 'un giorno',
        dd : '%d giorni',
        M : 'un mese',
        MM : '%d mesi',
        y : 'un anno',
        yy : '%d anni'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return it;

})));


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ja = moment.defineLocale('ja', {
    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日 HH:mm',
        LLLL : 'YYYY年M月D日 HH:mm dddd',
        l : 'YYYY/MM/DD',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日 HH:mm dddd'
    },
    meridiemParse: /午前|午後/i,
    isPM : function (input) {
        return input === '午後';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return '午前';
        } else {
            return '午後';
        }
    },
    calendar : {
        sameDay : '[今日] LT',
        nextDay : '[明日] LT',
        nextWeek : '[来週]dddd LT',
        lastDay : '[昨日] LT',
        lastWeek : '[前週]dddd LT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse : /\d{1,2}日/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '日';
            default:
                return number;
        }
    },
    relativeTime : {
        future : '%s後',
        past : '%s前',
        s : '数秒',
        m : '1分',
        mm : '%d分',
        h : '1時間',
        hh : '%d時間',
        d : '1日',
        dd : '%d日',
        M : '1ヶ月',
        MM : '%dヶ月',
        y : '1年',
        yy : '%d年'
    }
});

return ja;

})));


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var jv = moment.defineLocale('jv', {
    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /enjing|siyang|sonten|ndalu/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'enjing') {
            return hour;
        } else if (meridiem === 'siyang') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'enjing';
        } else if (hours < 15) {
            return 'siyang';
        } else if (hours < 19) {
            return 'sonten';
        } else {
            return 'ndalu';
        }
    },
    calendar : {
        sameDay : '[Dinten puniko pukul] LT',
        nextDay : '[Mbenjang pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kala wingi pukul] LT',
        lastWeek : 'dddd [kepengker pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'wonten ing %s',
        past : '%s ingkang kepengker',
        s : 'sawetawis detik',
        m : 'setunggal menit',
        mm : '%d menit',
        h : 'setunggal jam',
        hh : '%d jam',
        d : 'sedinten',
        dd : '%d dinten',
        M : 'sewulan',
        MM : '%d wulan',
        y : 'setaun',
        yy : '%d taun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return jv;

})));


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ka = moment.defineLocale('ka', {
    months : {
        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
    },
    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
    weekdays : {
        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
        isFormat: /(წინა|შემდეგ)/
    },
    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[დღეს] LT[-ზე]',
        nextDay : '[ხვალ] LT[-ზე]',
        lastDay : '[გუშინ] LT[-ზე]',
        nextWeek : '[შემდეგ] dddd LT[-ზე]',
        lastWeek : '[წინა] dddd LT-ზე',
        sameElse : 'L'
    },
    relativeTime : {
        future : function (s) {
            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
                s.replace(/ი$/, 'ში') :
                s + 'ში';
        },
        past : function (s) {
            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
                return s.replace(/(ი|ე)$/, 'ის უკან');
            }
            if ((/წელი/).test(s)) {
                return s.replace(/წელი$/, 'წლის უკან');
            }
        },
        s : 'რამდენიმე წამი',
        m : 'წუთი',
        mm : '%d წუთი',
        h : 'საათი',
        hh : '%d საათი',
        d : 'დღე',
        dd : '%d დღე',
        M : 'თვე',
        MM : '%d თვე',
        y : 'წელი',
        yy : '%d წელი'
    },
    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
    ordinal : function (number) {
        if (number === 0) {
            return number;
        }
        if (number === 1) {
            return number + '-ლი';
        }
        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
            return 'მე-' + number;
        }
        return number + '-ე';
    },
    week : {
        dow : 1,
        doy : 7
    }
});

return ka;

})));


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    0: '-ші',
    1: '-ші',
    2: '-ші',
    3: '-ші',
    4: '-ші',
    5: '-ші',
    6: '-шы',
    7: '-ші',
    8: '-ші',
    9: '-шы',
    10: '-шы',
    20: '-шы',
    30: '-шы',
    40: '-шы',
    50: '-ші',
    60: '-шы',
    70: '-ші',
    80: '-ші',
    90: '-шы',
    100: '-ші'
};

var kk = moment.defineLocale('kk', {
    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Бүгін сағат] LT',
        nextDay : '[Ертең сағат] LT',
        nextWeek : 'dddd [сағат] LT',
        lastDay : '[Кеше сағат] LT',
        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ішінде',
        past : '%s бұрын',
        s : 'бірнеше секунд',
        m : 'бір минут',
        mm : '%d минут',
        h : 'бір сағат',
        hh : '%d сағат',
        d : 'бір күн',
        dd : '%d күн',
        M : 'бір ай',
        MM : '%d ай',
        y : 'бір жыл',
        yy : '%d жыл'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
    ordinal : function (number) {
        var a = number % 10,
            b = number >= 100 ? 100 : null;
        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return kk;

})));


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var km = moment.defineLocale('km', {
    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    longDateFormat: {
        LT: 'HH:mm',
        LTS : 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
        nextDay: '[ស្អែក ម៉ោង] LT',
        nextWeek: 'dddd [ម៉ោង] LT',
        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: '%sទៀត',
        past: '%sមុន',
        s: 'ប៉ុន្មានវិនាទី',
        m: 'មួយនាទី',
        mm: '%d នាទី',
        h: 'មួយម៉ោង',
        hh: '%d ម៉ោង',
        d: 'មួយថ្ងៃ',
        dd: '%d ថ្ងៃ',
        M: 'មួយខែ',
        MM: '%d ខែ',
        y: 'មួយឆ្នាំ',
        yy: '%d ឆ្នាំ'
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return km;

})));


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '೧',
    '2': '೨',
    '3': '೩',
    '4': '೪',
    '5': '೫',
    '6': '೬',
    '7': '೭',
    '8': '೮',
    '9': '೯',
    '0': '೦'
};
var numberMap = {
    '೧': '1',
    '೨': '2',
    '೩': '3',
    '೪': '4',
    '೫': '5',
    '೬': '6',
    '೭': '7',
    '೮': '8',
    '೯': '9',
    '೦': '0'
};

var kn = moment.defineLocale('kn', {
    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
    monthsParseExact: true,
    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[ಇಂದು] LT',
        nextDay : '[ನಾಳೆ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ನಿನ್ನೆ] LT',
        lastWeek : '[ಕೊನೆಯ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ನಂತರ',
        past : '%s ಹಿಂದೆ',
        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
        m : 'ಒಂದು ನಿಮಿಷ',
        mm : '%d ನಿಮಿಷ',
        h : 'ಒಂದು ಗಂಟೆ',
        hh : '%d ಗಂಟೆ',
        d : 'ಒಂದು ದಿನ',
        dd : '%d ದಿನ',
        M : 'ಒಂದು ತಿಂಗಳು',
        MM : '%d ತಿಂಗಳು',
        y : 'ಒಂದು ವರ್ಷ',
        yy : '%d ವರ್ಷ'
    },
    preparse: function (string) {
        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ರಾತ್ರಿ') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
            return hour;
        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'ಸಂಜೆ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ರಾತ್ರಿ';
        } else if (hour < 10) {
            return 'ಬೆಳಿಗ್ಗೆ';
        } else if (hour < 17) {
            return 'ಮಧ್ಯಾಹ್ನ';
        } else if (hour < 20) {
            return 'ಸಂಜೆ';
        } else {
            return 'ರಾತ್ರಿ';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
    ordinal : function (number) {
        return number + 'ನೇ';
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return kn;

})));


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ko = moment.defineLocale('ko', {
    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'YYYY.MM.DD',
        LL : 'YYYY년 MMMM D일',
        LLL : 'YYYY년 MMMM D일 A h:mm',
        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
        l : 'YYYY.MM.DD',
        ll : 'YYYY년 MMMM D일',
        lll : 'YYYY년 MMMM D일 A h:mm',
        llll : 'YYYY년 MMMM D일 dddd A h:mm'
    },
    calendar : {
        sameDay : '오늘 LT',
        nextDay : '내일 LT',
        nextWeek : 'dddd LT',
        lastDay : '어제 LT',
        lastWeek : '지난주 dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s 후',
        past : '%s 전',
        s : '몇 초',
        ss : '%d초',
        m : '1분',
        mm : '%d분',
        h : '한 시간',
        hh : '%d시간',
        d : '하루',
        dd : '%d일',
        M : '한 달',
        MM : '%d달',
        y : '일 년',
        yy : '%d년'
    },
    dayOfMonthOrdinalParse : /\d{1,2}일/,
    ordinal : '%d일',
    meridiemParse : /오전|오후/,
    isPM : function (token) {
        return token === '오후';
    },
    meridiem : function (hour, minute, isUpper) {
        return hour < 12 ? '오전' : '오후';
    }
});

return ko;

})));


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var suffixes = {
    0: '-чү',
    1: '-чи',
    2: '-чи',
    3: '-чү',
    4: '-чү',
    5: '-чи',
    6: '-чы',
    7: '-чи',
    8: '-чи',
    9: '-чу',
    10: '-чу',
    20: '-чы',
    30: '-чу',
    40: '-чы',
    50: '-чү',
    60: '-чы',
    70: '-чи',
    80: '-чи',
    90: '-чу',
    100: '-чү'
};

var ky = moment.defineLocale('ky', {
    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Бүгүн саат] LT',
        nextDay : '[Эртең саат] LT',
        nextWeek : 'dddd [саат] LT',
        lastDay : '[Кече саат] LT',
        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ичинде',
        past : '%s мурун',
        s : 'бирнече секунд',
        m : 'бир мүнөт',
        mm : '%d мүнөт',
        h : 'бир саат',
        hh : '%d саат',
        d : 'бир күн',
        dd : '%d күн',
        M : 'бир ай',
        MM : '%d ай',
        y : 'бир жыл',
        yy : '%d жыл'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
    ordinal : function (number) {
        var a = number % 10,
            b = number >= 100 ? 100 : null;
        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ky;

})));


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eng Minutt', 'enger Minutt'],
        'h': ['eng Stonn', 'enger Stonn'],
        'd': ['een Dag', 'engem Dag'],
        'M': ['ee Mount', 'engem Mount'],
        'y': ['ee Joer', 'engem Joer']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}
function processFutureTime(string) {
    var number = string.substr(0, string.indexOf(' '));
    if (eifelerRegelAppliesToNumber(number)) {
        return 'a ' + string;
    }
    return 'an ' + string;
}
function processPastTime(string) {
    var number = string.substr(0, string.indexOf(' '));
    if (eifelerRegelAppliesToNumber(number)) {
        return 'viru ' + string;
    }
    return 'virun ' + string;
}
/**
 * Returns true if the word before the given number loses the '-n' ending.
 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
 *
 * @param number {integer}
 * @returns {boolean}
 */
function eifelerRegelAppliesToNumber(number) {
    number = parseInt(number, 10);
    if (isNaN(number)) {
        return false;
    }
    if (number < 0) {
        // Negative Number --> always true
        return true;
    } else if (number < 10) {
        // Only 1 digit
        if (4 <= number && number <= 7) {
            return true;
        }
        return false;
    } else if (number < 100) {
        // 2 digits
        var lastDigit = number % 10, firstDigit = number / 10;
        if (lastDigit === 0) {
            return eifelerRegelAppliesToNumber(firstDigit);
        }
        return eifelerRegelAppliesToNumber(lastDigit);
    } else if (number < 10000) {
        // 3 or 4 digits --> recursively check first digit
        while (number >= 10) {
            number = number / 10;
        }
        return eifelerRegelAppliesToNumber(number);
    } else {
        // Anything larger than 4 digits: recursively check first n-3 digits
        number = number / 1000;
        return eifelerRegelAppliesToNumber(number);
    }
}

var lb = moment.defineLocale('lb', {
    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm [Auer]',
        LTS: 'H:mm:ss [Auer]',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm [Auer]',
        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
    },
    calendar: {
        sameDay: '[Haut um] LT',
        sameElse: 'L',
        nextDay: '[Muer um] LT',
        nextWeek: 'dddd [um] LT',
        lastDay: '[Gëschter um] LT',
        lastWeek: function () {
            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
            switch (this.day()) {
                case 2:
                case 4:
                    return '[Leschten] dddd [um] LT';
                default:
                    return '[Leschte] dddd [um] LT';
            }
        }
    },
    relativeTime : {
        future : processFutureTime,
        past : processPastTime,
        s : 'e puer Sekonnen',
        m : processRelativeTime,
        mm : '%d Minutten',
        h : processRelativeTime,
        hh : '%d Stonnen',
        d : processRelativeTime,
        dd : '%d Deeg',
        M : processRelativeTime,
        MM : '%d Méint',
        y : processRelativeTime,
        yy : '%d Joer'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: '%d.',
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lb;

})));


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var lo = moment.defineLocale('lo', {
    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
    isPM: function (input) {
        return input === 'ຕອນແລງ';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ຕອນເຊົ້າ';
        } else {
            return 'ຕອນແລງ';
        }
    },
    calendar : {
        sameDay : '[ມື້ນີ້ເວລາ] LT',
        nextDay : '[ມື້ອື່ນເວລາ] LT',
        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ອີກ %s',
        past : '%sຜ່ານມາ',
        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
        m : '1 ນາທີ',
        mm : '%d ນາທີ',
        h : '1 ຊົ່ວໂມງ',
        hh : '%d ຊົ່ວໂມງ',
        d : '1 ມື້',
        dd : '%d ມື້',
        M : '1 ເດືອນ',
        MM : '%d ເດືອນ',
        y : '1 ປີ',
        yy : '%d ປີ'
    },
    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
    ordinal : function (number) {
        return 'ທີ່' + number;
    }
});

return lo;

})));


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var units = {
    'm' : 'minutė_minutės_minutę',
    'mm': 'minutės_minučių_minutes',
    'h' : 'valanda_valandos_valandą',
    'hh': 'valandos_valandų_valandas',
    'd' : 'diena_dienos_dieną',
    'dd': 'dienos_dienų_dienas',
    'M' : 'mėnuo_mėnesio_mėnesį',
    'MM': 'mėnesiai_mėnesių_mėnesius',
    'y' : 'metai_metų_metus',
    'yy': 'metai_metų_metus'
};
function translateSeconds(number, withoutSuffix, key, isFuture) {
    if (withoutSuffix) {
        return 'kelios sekundės';
    } else {
        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
    }
}
function translateSingular(number, withoutSuffix, key, isFuture) {
    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
}
function special(number) {
    return number % 10 === 0 || (number > 10 && number < 20);
}
function forms(key) {
    return units[key].split('_');
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    if (number === 1) {
        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
    } else if (withoutSuffix) {
        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
    } else {
        if (isFuture) {
            return result + forms(key)[1];
        } else {
            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
        }
    }
}
var lt = moment.defineLocale('lt', {
    months : {
        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
    },
    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
    weekdays : {
        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
        isFormat: /dddd HH:mm/
    },
    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'YYYY [m.] MMMM D [d.]',
        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
        l : 'YYYY-MM-DD',
        ll : 'YYYY [m.] MMMM D [d.]',
        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
    },
    calendar : {
        sameDay : '[Šiandien] LT',
        nextDay : '[Rytoj] LT',
        nextWeek : 'dddd LT',
        lastDay : '[Vakar] LT',
        lastWeek : '[Praėjusį] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'po %s',
        past : 'prieš %s',
        s : translateSeconds,
        m : translateSingular,
        mm : translate,
        h : translateSingular,
        hh : translate,
        d : translateSingular,
        dd : translate,
        M : translateSingular,
        MM : translate,
        y : translateSingular,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
    ordinal : function (number) {
        return number + '-oji';
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lt;

})));


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var units = {
    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
    'h': 'stundas_stundām_stunda_stundas'.split('_'),
    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
    'd': 'dienas_dienām_diena_dienas'.split('_'),
    'dd': 'dienas_dienām_diena_dienas'.split('_'),
    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
    'y': 'gada_gadiem_gads_gadi'.split('_'),
    'yy': 'gada_gadiem_gads_gadi'.split('_')
};
/**
 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
 */
function format(forms, number, withoutSuffix) {
    if (withoutSuffix) {
        // E.g. "21 minūte", "3 minūtes".
        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
    } else {
        // E.g. "21 minūtes" as in "pēc 21 minūtes".
        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
    }
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    return number + ' ' + format(units[key], number, withoutSuffix);
}
function relativeTimeWithSingular(number, withoutSuffix, key) {
    return format(units[key], number, withoutSuffix);
}
function relativeSeconds(number, withoutSuffix) {
    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
}

var lv = moment.defineLocale('lv', {
    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY.',
        LL : 'YYYY. [gada] D. MMMM',
        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
    },
    calendar : {
        sameDay : '[Šodien pulksten] LT',
        nextDay : '[Rīt pulksten] LT',
        nextWeek : 'dddd [pulksten] LT',
        lastDay : '[Vakar pulksten] LT',
        lastWeek : '[Pagājušā] dddd [pulksten] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'pēc %s',
        past : 'pirms %s',
        s : relativeSeconds,
        m : relativeTimeWithSingular,
        mm : relativeTimeWithPlural,
        h : relativeTimeWithSingular,
        hh : relativeTimeWithPlural,
        d : relativeTimeWithSingular,
        dd : relativeTimeWithPlural,
        M : relativeTimeWithSingular,
        MM : relativeTimeWithPlural,
        y : relativeTimeWithSingular,
        yy : relativeTimeWithPlural
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lv;

})));


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        m: ['jedan minut', 'jednog minuta'],
        mm: ['minut', 'minuta', 'minuta'],
        h: ['jedan sat', 'jednog sata'],
        hh: ['sat', 'sata', 'sati'],
        dd: ['dan', 'dana', 'dana'],
        MM: ['mjesec', 'mjeseca', 'mjeseci'],
        yy: ['godina', 'godine', 'godina']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var me = moment.defineLocale('me', {
    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact : true,
    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[danas u] LT',
        nextDay: '[sjutra u] LT',

        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[juče u] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[prošle] [nedjelje] [u] LT',
                '[prošlog] [ponedjeljka] [u] LT',
                '[prošlog] [utorka] [u] LT',
                '[prošle] [srijede] [u] LT',
                '[prošlog] [četvrtka] [u] LT',
                '[prošlog] [petka] [u] LT',
                '[prošle] [subote] [u] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'nekoliko sekundi',
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'dan',
        dd     : translator.translate,
        M      : 'mjesec',
        MM     : translator.translate,
        y      : 'godinu',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return me;

})));


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mi = moment.defineLocale('mi', {
    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY [i] HH:mm',
        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
    },
    calendar: {
        sameDay: '[i teie mahana, i] LT',
        nextDay: '[apopo i] LT',
        nextWeek: 'dddd [i] LT',
        lastDay: '[inanahi i] LT',
        lastWeek: 'dddd [whakamutunga i] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'i roto i %s',
        past: '%s i mua',
        s: 'te hēkona ruarua',
        m: 'he meneti',
        mm: '%d meneti',
        h: 'te haora',
        hh: '%d haora',
        d: 'he ra',
        dd: '%d ra',
        M: 'he marama',
        MM: '%d marama',
        y: 'he tau',
        yy: '%d tau'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return mi;

})));


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mk = moment.defineLocale('mk', {
    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'D.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay : '[Денес во] LT',
        nextDay : '[Утре во] LT',
        nextWeek : '[Во] dddd [во] LT',
        lastDay : '[Вчера во] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 6:
                    return '[Изминатата] dddd [во] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[Изминатиот] dddd [во] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'после %s',
        past : 'пред %s',
        s : 'неколку секунди',
        m : 'минута',
        mm : '%d минути',
        h : 'час',
        hh : '%d часа',
        d : 'ден',
        dd : '%d дена',
        M : 'месец',
        MM : '%d месеци',
        y : 'година',
        yy : '%d години'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
    ordinal : function (number) {
        var lastDigit = number % 10,
            last2Digits = number % 100;
        if (number === 0) {
            return number + '-ев';
        } else if (last2Digits === 0) {
            return number + '-ен';
        } else if (last2Digits > 10 && last2Digits < 20) {
            return number + '-ти';
        } else if (lastDigit === 1) {
            return number + '-ви';
        } else if (lastDigit === 2) {
            return number + '-ри';
        } else if (lastDigit === 7 || lastDigit === 8) {
            return number + '-ми';
        } else {
            return number + '-ти';
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return mk;

})));


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ml = moment.defineLocale('ml', {
    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
    monthsParseExact : true,
    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm -നു',
        LTS : 'A h:mm:ss -നു',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm -നു',
        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
    },
    calendar : {
        sameDay : '[ഇന്ന്] LT',
        nextDay : '[നാളെ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ഇന്നലെ] LT',
        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s കഴിഞ്ഞ്',
        past : '%s മുൻപ്',
        s : 'അൽപ നിമിഷങ്ങൾ',
        m : 'ഒരു മിനിറ്റ്',
        mm : '%d മിനിറ്റ്',
        h : 'ഒരു മണിക്കൂർ',
        hh : '%d മണിക്കൂർ',
        d : 'ഒരു ദിവസം',
        dd : '%d ദിവസം',
        M : 'ഒരു മാസം',
        MM : '%d മാസം',
        y : 'ഒരു വർഷം',
        yy : '%d വർഷം'
    },
    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'രാത്രി';
        } else if (hour < 12) {
            return 'രാവിലെ';
        } else if (hour < 17) {
            return 'ഉച്ച കഴിഞ്ഞ്';
        } else if (hour < 20) {
            return 'വൈകുന്നേരം';
        } else {
            return 'രാത്രി';
        }
    }
});

return ml;

})));


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

function relativeTimeMr(number, withoutSuffix, string, isFuture)
{
    var output = '';
    if (withoutSuffix) {
        switch (string) {
            case 's': output = 'काही सेकंद'; break;
            case 'm': output = 'एक मिनिट'; break;
            case 'mm': output = '%d मिनिटे'; break;
            case 'h': output = 'एक तास'; break;
            case 'hh': output = '%d तास'; break;
            case 'd': output = 'एक दिवस'; break;
            case 'dd': output = '%d दिवस'; break;
            case 'M': output = 'एक महिना'; break;
            case 'MM': output = '%d महिने'; break;
            case 'y': output = 'एक वर्ष'; break;
            case 'yy': output = '%d वर्षे'; break;
        }
    }
    else {
        switch (string) {
            case 's': output = 'काही सेकंदां'; break;
            case 'm': output = 'एका मिनिटा'; break;
            case 'mm': output = '%d मिनिटां'; break;
            case 'h': output = 'एका तासा'; break;
            case 'hh': output = '%d तासां'; break;
            case 'd': output = 'एका दिवसा'; break;
            case 'dd': output = '%d दिवसां'; break;
            case 'M': output = 'एका महिन्या'; break;
            case 'MM': output = '%d महिन्यां'; break;
            case 'y': output = 'एका वर्षा'; break;
            case 'yy': output = '%d वर्षां'; break;
        }
    }
    return output.replace(/%d/i, number);
}

var mr = moment.defineLocale('mr', {
    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
    monthsParseExact : true,
    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
    longDateFormat : {
        LT : 'A h:mm वाजता',
        LTS : 'A h:mm:ss वाजता',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm वाजता',
        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[उद्या] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[काल] LT',
        lastWeek: '[मागील] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future: '%sमध्ये',
        past: '%sपूर्वी',
        s: relativeTimeMr,
        m: relativeTimeMr,
        mm: relativeTimeMr,
        h: relativeTimeMr,
        hh: relativeTimeMr,
        d: relativeTimeMr,
        dd: relativeTimeMr,
        M: relativeTimeMr,
        MM: relativeTimeMr,
        y: relativeTimeMr,
        yy: relativeTimeMr
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'रात्री') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'सकाळी') {
            return hour;
        } else if (meridiem === 'दुपारी') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'सायंकाळी') {
            return hour + 12;
        }
    },
    meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
            return 'रात्री';
        } else if (hour < 10) {
            return 'सकाळी';
        } else if (hour < 17) {
            return 'दुपारी';
        } else if (hour < 20) {
            return 'सायंकाळी';
        } else {
            return 'रात्री';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return mr;

})));


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var msMy = moment.defineLocale('ms-my', {
    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|tengahari|petang|malam/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'tengahari') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'petang' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'tengahari';
        } else if (hours < 19) {
            return 'petang';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Esok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kelmarin pukul] LT',
        lastWeek : 'dddd [lepas pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lepas',
        s : 'beberapa saat',
        m : 'seminit',
        mm : '%d minit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return msMy;

})));


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ms = moment.defineLocale('ms', {
    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|tengahari|petang|malam/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'tengahari') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'petang' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'tengahari';
        } else if (hours < 19) {
            return 'petang';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Esok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kelmarin pukul] LT',
        lastWeek : 'dddd [lepas pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lepas',
        s : 'beberapa saat',
        m : 'seminit',
        mm : '%d minit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ms;

})));


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '၁',
    '2': '၂',
    '3': '၃',
    '4': '၄',
    '5': '၅',
    '6': '၆',
    '7': '၇',
    '8': '၈',
    '9': '၉',
    '0': '၀'
};
var numberMap = {
    '၁': '1',
    '၂': '2',
    '၃': '3',
    '၄': '4',
    '၅': '5',
    '၆': '6',
    '၇': '7',
    '၈': '8',
    '၉': '9',
    '၀': '0'
};

var my = moment.defineLocale('my', {
    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[ယနေ.] LT [မှာ]',
        nextDay: '[မနက်ဖြန်] LT [မှာ]',
        nextWeek: 'dddd LT [မှာ]',
        lastDay: '[မနေ.က] LT [မှာ]',
        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'လာမည့် %s မှာ',
        past: 'လွန်ခဲ့သော %s က',
        s: 'စက္ကန်.အနည်းငယ်',
        m: 'တစ်မိနစ်',
        mm: '%d မိနစ်',
        h: 'တစ်နာရီ',
        hh: '%d နာရီ',
        d: 'တစ်ရက်',
        dd: '%d ရက်',
        M: 'တစ်လ',
        MM: '%d လ',
        y: 'တစ်နှစ်',
        yy: '%d နှစ်'
    },
    preparse: function (string) {
        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 1st is the first week of the year.
    }
});

return my;

})));


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var nb = moment.defineLocale('nb', {
    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
    monthsParseExact : true,
    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] HH:mm',
        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay: '[i dag kl.] LT',
        nextDay: '[i morgen kl.] LT',
        nextWeek: 'dddd [kl.] LT',
        lastDay: '[i går kl.] LT',
        lastWeek: '[forrige] dddd [kl.] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s siden',
        s : 'noen sekunder',
        m : 'ett minutt',
        mm : '%d minutter',
        h : 'en time',
        hh : '%d timer',
        d : 'en dag',
        dd : '%d dager',
        M : 'en måned',
        MM : '%d måneder',
        y : 'ett år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nb;

})));


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

var ne = moment.defineLocale('ne', {
    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
    monthsParseExact : true,
    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'Aको h:mm बजे',
        LTS : 'Aको h:mm:ss बजे',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, Aको h:mm बजे',
        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'राति') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'बिहान') {
            return hour;
        } else if (meridiem === 'दिउँसो') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'साँझ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 3) {
            return 'राति';
        } else if (hour < 12) {
            return 'बिहान';
        } else if (hour < 16) {
            return 'दिउँसो';
        } else if (hour < 20) {
            return 'साँझ';
        } else {
            return 'राति';
        }
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[भोलि] LT',
        nextWeek : '[आउँदो] dddd[,] LT',
        lastDay : '[हिजो] LT',
        lastWeek : '[गएको] dddd[,] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%sमा',
        past : '%s अगाडि',
        s : 'केही क्षण',
        m : 'एक मिनेट',
        mm : '%d मिनेट',
        h : 'एक घण्टा',
        hh : '%d घण्टा',
        d : 'एक दिन',
        dd : '%d दिन',
        M : 'एक महिना',
        MM : '%d महिना',
        y : 'एक बर्ष',
        yy : '%d बर्ष'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return ne;

})));


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

var nlBe = moment.defineLocale('nl-be', {
    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },

    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[vandaag om] LT',
        nextDay: '[morgen om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[gisteren om] LT',
        lastWeek: '[afgelopen] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'over %s',
        past : '%s geleden',
        s : 'een paar seconden',
        m : 'één minuut',
        mm : '%d minuten',
        h : 'één uur',
        hh : '%d uur',
        d : 'één dag',
        dd : '%d dagen',
        M : 'één maand',
        MM : '%d maanden',
        y : 'één jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nlBe;

})));


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

var nl = moment.defineLocale('nl', {
    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },

    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[vandaag om] LT',
        nextDay: '[morgen om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[gisteren om] LT',
        lastWeek: '[afgelopen] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'over %s',
        past : '%s geleden',
        s : 'een paar seconden',
        m : 'één minuut',
        mm : '%d minuten',
        h : 'één uur',
        hh : '%d uur',
        d : 'één dag',
        dd : '%d dagen',
        M : 'één maand',
        MM : '%d maanden',
        y : 'één jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nl;

})));


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! author : https://github.com/mechuwind

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var nn = moment.defineLocale('nn', {
    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] H:mm',
        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay: '[I dag klokka] LT',
        nextDay: '[I morgon klokka] LT',
        nextWeek: 'dddd [klokka] LT',
        lastDay: '[I går klokka] LT',
        lastWeek: '[Føregåande] dddd [klokka] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s sidan',
        s : 'nokre sekund',
        m : 'eit minutt',
        mm : '%d minutt',
        h : 'ein time',
        hh : '%d timar',
        d : 'ein dag',
        dd : '%d dagar',
        M : 'ein månad',
        MM : '%d månader',
        y : 'eit år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nn;

})));


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '੧',
    '2': '੨',
    '3': '੩',
    '4': '੪',
    '5': '੫',
    '6': '੬',
    '7': '੭',
    '8': '੮',
    '9': '੯',
    '0': '੦'
};
var numberMap = {
    '੧': '1',
    '੨': '2',
    '੩': '3',
    '੪': '4',
    '੫': '5',
    '੬': '6',
    '੭': '7',
    '੮': '8',
    '੯': '9',
    '੦': '0'
};

var paIn = moment.defineLocale('pa-in', {
    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm ਵਜੇ',
        LTS : 'A h:mm:ss ਵਜੇ',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
    },
    calendar : {
        sameDay : '[ਅਜ] LT',
        nextDay : '[ਕਲ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ਕਲ] LT',
        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ਵਿੱਚ',
        past : '%s ਪਿਛਲੇ',
        s : 'ਕੁਝ ਸਕਿੰਟ',
        m : 'ਇਕ ਮਿੰਟ',
        mm : '%d ਮਿੰਟ',
        h : 'ਇੱਕ ਘੰਟਾ',
        hh : '%d ਘੰਟੇ',
        d : 'ਇੱਕ ਦਿਨ',
        dd : '%d ਦਿਨ',
        M : 'ਇੱਕ ਮਹੀਨਾ',
        MM : '%d ਮਹੀਨੇ',
        y : 'ਇੱਕ ਸਾਲ',
        yy : '%d ਸਾਲ'
    },
    preparse: function (string) {
        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ਰਾਤ') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ਸਵੇਰ') {
            return hour;
        } else if (meridiem === 'ਦੁਪਹਿਰ') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'ਸ਼ਾਮ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ਰਾਤ';
        } else if (hour < 10) {
            return 'ਸਵੇਰ';
        } else if (hour < 17) {
            return 'ਦੁਪਹਿਰ';
        } else if (hour < 20) {
            return 'ਸ਼ਾਮ';
        } else {
            return 'ਰਾਤ';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return paIn;

})));


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
function plural(n) {
    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
}
function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'm':
            return withoutSuffix ? 'minuta' : 'minutę';
        case 'mm':
            return result + (plural(number) ? 'minuty' : 'minut');
        case 'h':
            return withoutSuffix  ? 'godzina'  : 'godzinę';
        case 'hh':
            return result + (plural(number) ? 'godziny' : 'godzin');
        case 'MM':
            return result + (plural(number) ? 'miesiące' : 'miesięcy');
        case 'yy':
            return result + (plural(number) ? 'lata' : 'lat');
    }
}

var pl = moment.defineLocale('pl', {
    months : function (momentToFormat, format) {
        if (!momentToFormat) {
            return monthsNominative;
        } else if (format === '') {
            // Hack: if format empty we know this is used to generate
            // RegExp by moment. Give then back both valid forms of months
            // in RegExp ready format.
            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
        } else if (/D MMMM/.test(format)) {
            return monthsSubjective[momentToFormat.month()];
        } else {
            return monthsNominative[momentToFormat.month()];
        }
    },
    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Dziś o] LT',
        nextDay: '[Jutro o] LT',
        nextWeek: '[W] dddd [o] LT',
        lastDay: '[Wczoraj o] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[W zeszłą niedzielę o] LT';
                case 3:
                    return '[W zeszłą środę o] LT';
                case 6:
                    return '[W zeszłą sobotę o] LT';
                default:
                    return '[W zeszły] dddd [o] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : '%s temu',
        s : 'kilka sekund',
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : '1 dzień',
        dd : '%d dni',
        M : 'miesiąc',
        MM : translate,
        y : 'rok',
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return pl;

})));


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ptBr = moment.defineLocale('pt-br', {
    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
    },
    calendar : {
        sameDay: '[Hoje às] LT',
        nextDay: '[Amanhã às] LT',
        nextWeek: 'dddd [às] LT',
        lastDay: '[Ontem às] LT',
        lastWeek: function () {
            return (this.day() === 0 || this.day() === 6) ?
                '[Último] dddd [às] LT' : // Saturday + Sunday
                '[Última] dddd [às] LT'; // Monday - Friday
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'em %s',
        past : '%s atrás',
        s : 'poucos segundos',
        m : 'um minuto',
        mm : '%d minutos',
        h : 'uma hora',
        hh : '%d horas',
        d : 'um dia',
        dd : '%d dias',
        M : 'um mês',
        MM : '%d meses',
        y : 'um ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal : '%dº'
});

return ptBr;

})));


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var pt = moment.defineLocale('pt', {
    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
    weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY HH:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Hoje às] LT',
        nextDay: '[Amanhã às] LT',
        nextWeek: 'dddd [às] LT',
        lastDay: '[Ontem às] LT',
        lastWeek: function () {
            return (this.day() === 0 || this.day() === 6) ?
                '[Último] dddd [às] LT' : // Saturday + Sunday
                '[Última] dddd [às] LT'; // Monday - Friday
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'em %s',
        past : 'há %s',
        s : 'segundos',
        m : 'um minuto',
        mm : '%d minutos',
        h : 'uma hora',
        hh : '%d horas',
        d : 'um dia',
        dd : '%d dias',
        M : 'um mês',
        MM : '%d meses',
        y : 'um ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return pt;

})));


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
            'mm': 'minute',
            'hh': 'ore',
            'dd': 'zile',
            'MM': 'luni',
            'yy': 'ani'
        },
        separator = ' ';
    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
        separator = ' de ';
    }
    return number + separator + format[key];
}

var ro = moment.defineLocale('ro', {
    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay: '[azi la] LT',
        nextDay: '[mâine la] LT',
        nextWeek: 'dddd [la] LT',
        lastDay: '[ieri la] LT',
        lastWeek: '[fosta] dddd [la] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'peste %s',
        past : '%s în urmă',
        s : 'câteva secunde',
        m : 'un minut',
        mm : relativeTimeWithPlural,
        h : 'o oră',
        hh : relativeTimeWithPlural,
        d : 'o zi',
        dd : relativeTimeWithPlural,
        M : 'o lună',
        MM : relativeTimeWithPlural,
        y : 'un an',
        yy : relativeTimeWithPlural
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ro;

})));


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! Author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
        'hh': 'час_часа_часов',
        'dd': 'день_дня_дней',
        'MM': 'месяц_месяца_месяцев',
        'yy': 'год_года_лет'
    };
    if (key === 'm') {
        return withoutSuffix ? 'минута' : 'минуту';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}
var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];

// http://new.gramota.ru/spravka/rules/139-prop : § 103
// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
var ru = moment.defineLocale('ru', {
    months : {
        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
    },
    monthsShort : {
        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
    },
    weekdays : {
        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
    },
    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

    // копия предыдущего
    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

    // полные названия с падежами
    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

    // Выражение, которое соотвествует только сокращённым формам
    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY г.',
        LLL : 'D MMMM YYYY г., HH:mm',
        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
    },
    calendar : {
        sameDay: '[Сегодня в] LT',
        nextDay: '[Завтра в] LT',
        lastDay: '[Вчера в] LT',
        nextWeek: function (now) {
            if (now.week() !== this.week()) {
                switch (this.day()) {
                    case 0:
                        return '[В следующее] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[В следующий] dddd [в] LT';
                    case 3:
                    case 5:
                    case 6:
                        return '[В следующую] dddd [в] LT';
                }
            } else {
                if (this.day() === 2) {
                    return '[Во] dddd [в] LT';
                } else {
                    return '[В] dddd [в] LT';
                }
            }
        },
        lastWeek: function (now) {
            if (now.week() !== this.week()) {
                switch (this.day()) {
                    case 0:
                        return '[В прошлое] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[В прошлый] dddd [в] LT';
                    case 3:
                    case 5:
                    case 6:
                        return '[В прошлую] dddd [в] LT';
                }
            } else {
                if (this.day() === 2) {
                    return '[Во] dddd [в] LT';
                } else {
                    return '[В] dddd [в] LT';
                }
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'через %s',
        past : '%s назад',
        s : 'несколько секунд',
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : 'час',
        hh : relativeTimeWithPlural,
        d : 'день',
        dd : relativeTimeWithPlural,
        M : 'месяц',
        MM : relativeTimeWithPlural,
        y : 'год',
        yy : relativeTimeWithPlural
    },
    meridiemParse: /ночи|утра|дня|вечера/i,
    isPM : function (input) {
        return /^(дня|вечера)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночи';
        } else if (hour < 12) {
            return 'утра';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечера';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
                return number + '-й';
            case 'D':
                return number + '-го';
            case 'w':
            case 'W':
                return number + '-я';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ru;

})));


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'جنوري',
    'فيبروري',
    'مارچ',
    'اپريل',
    'مئي',
    'جون',
    'جولاءِ',
    'آگسٽ',
    'سيپٽمبر',
    'آڪٽوبر',
    'نومبر',
    'ڊسمبر'
];
var days = [
    'آچر',
    'سومر',
    'اڱارو',
    'اربع',
    'خميس',
    'جمع',
    'ڇنڇر'
];

var sd = moment.defineLocale('sd', {
    months : months,
    monthsShort : months,
    weekdays : days,
    weekdaysShort : days,
    weekdaysMin : days,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd، D MMMM YYYY HH:mm'
    },
    meridiemParse: /صبح|شام/,
    isPM : function (input) {
        return 'شام' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'صبح';
        }
        return 'شام';
    },
    calendar : {
        sameDay : '[اڄ] LT',
        nextDay : '[سڀاڻي] LT',
        nextWeek : 'dddd [اڳين هفتي تي] LT',
        lastDay : '[ڪالهه] LT',
        lastWeek : '[گزريل هفتي] dddd [تي] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s پوء',
        past : '%s اڳ',
        s : 'چند سيڪنڊ',
        m : 'هڪ منٽ',
        mm : '%d منٽ',
        h : 'هڪ ڪلاڪ',
        hh : '%d ڪلاڪ',
        d : 'هڪ ڏينهن',
        dd : '%d ڏينهن',
        M : 'هڪ مهينو',
        MM : '%d مهينا',
        y : 'هڪ سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sd;

})));


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var se = moment.defineLocale('se', {
    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'MMMM D. [b.] YYYY',
        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
    },
    calendar : {
        sameDay: '[otne ti] LT',
        nextDay: '[ihttin ti] LT',
        nextWeek: 'dddd [ti] LT',
        lastDay: '[ikte ti] LT',
        lastWeek: '[ovddit] dddd [ti] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s geažes',
        past : 'maŋit %s',
        s : 'moadde sekunddat',
        m : 'okta minuhta',
        mm : '%d minuhtat',
        h : 'okta diimmu',
        hh : '%d diimmut',
        d : 'okta beaivi',
        dd : '%d beaivvit',
        M : 'okta mánnu',
        MM : '%d mánut',
        y : 'okta jahki',
        yy : '%d jagit'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return se;

})));


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


/*jshint -W100*/
var si = moment.defineLocale('si', {
    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'a h:mm',
        LTS : 'a h:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY MMMM D',
        LLL : 'YYYY MMMM D, a h:mm',
        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
    },
    calendar : {
        sameDay : '[අද] LT[ට]',
        nextDay : '[හෙට] LT[ට]',
        nextWeek : 'dddd LT[ට]',
        lastDay : '[ඊයේ] LT[ට]',
        lastWeek : '[පසුගිය] dddd LT[ට]',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%sකින්',
        past : '%sකට පෙර',
        s : 'තත්පර කිහිපය',
        m : 'මිනිත්තුව',
        mm : 'මිනිත්තු %d',
        h : 'පැය',
        hh : 'පැය %d',
        d : 'දිනය',
        dd : 'දින %d',
        M : 'මාසය',
        MM : 'මාස %d',
        y : 'වසර',
        yy : 'වසර %d'
    },
    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
    ordinal : function (number) {
        return number + ' වැනි';
    },
    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
    isPM : function (input) {
        return input === 'ප.ව.' || input === 'පස් වරු';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'ප.ව.' : 'පස් වරු';
        } else {
            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
        }
    }
});

return si;

})));


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
function plural(n) {
    return (n > 1) && (n < 5);
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':  // a few seconds / in a few seconds / a few seconds ago
            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
        case 'm':  // a minute / in a minute / a minute ago
            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'minúty' : 'minút');
            } else {
                return result + 'minútami';
            }
            break;
        case 'h':  // an hour / in an hour / an hour ago
            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
        case 'hh': // 9 hours / in 9 hours / 9 hours ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'hodiny' : 'hodín');
            } else {
                return result + 'hodinami';
            }
            break;
        case 'd':  // a day / in a day / a day ago
            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
        case 'dd': // 9 days / in 9 days / 9 days ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'dni' : 'dní');
            } else {
                return result + 'dňami';
            }
            break;
        case 'M':  // a month / in a month / a month ago
            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
        case 'MM': // 9 months / in 9 months / 9 months ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'mesiace' : 'mesiacov');
            } else {
                return result + 'mesiacmi';
            }
            break;
        case 'y':  // a year / in a year / a year ago
            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
        case 'yy': // 9 years / in 9 years / 9 years ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'roky' : 'rokov');
            } else {
                return result + 'rokmi';
            }
            break;
    }
}

var sk = moment.defineLocale('sk', {
    months : months,
    monthsShort : monthsShort,
    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
    longDateFormat : {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay: '[dnes o] LT',
        nextDay: '[zajtra o] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[v nedeľu o] LT';
                case 1:
                case 2:
                    return '[v] dddd [o] LT';
                case 3:
                    return '[v stredu o] LT';
                case 4:
                    return '[vo štvrtok o] LT';
                case 5:
                    return '[v piatok o] LT';
                case 6:
                    return '[v sobotu o] LT';
            }
        },
        lastDay: '[včera o] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[minulú nedeľu o] LT';
                case 1:
                case 2:
                    return '[minulý] dddd [o] LT';
                case 3:
                    return '[minulú stredu o] LT';
                case 4:
                case 5:
                    return '[minulý] dddd [o] LT';
                case 6:
                    return '[minulú sobotu o] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : 'pred %s',
        s : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sk;

})));


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':
            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
        case 'm':
            return withoutSuffix ? 'ena minuta' : 'eno minuto';
        case 'mm':
            if (number === 1) {
                result += withoutSuffix ? 'minuta' : 'minuto';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
            } else {
                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'ena ura' : 'eno uro';
        case 'hh':
            if (number === 1) {
                result += withoutSuffix ? 'ura' : 'uro';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'uri' : 'urama';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'ure' : 'urami';
            } else {
                result += withoutSuffix || isFuture ? 'ur' : 'urami';
            }
            return result;
        case 'd':
            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
        case 'dd':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
            } else {
                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
            }
            return result;
        case 'M':
            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
        case 'MM':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
            } else {
                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
            }
            return result;
        case 'y':
            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
        case 'yy':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'leto' : 'letom';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'leta' : 'leti';
            } else {
                result += withoutSuffix || isFuture ? 'let' : 'leti';
            }
            return result;
    }
}

var sl = moment.defineLocale('sl', {
    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danes ob] LT',
        nextDay  : '[jutri ob] LT',

        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[v] [nedeljo] [ob] LT';
                case 3:
                    return '[v] [sredo] [ob] LT';
                case 6:
                    return '[v] [soboto] [ob] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[v] dddd [ob] LT';
            }
        },
        lastDay  : '[včeraj ob] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[prejšnjo] [nedeljo] [ob] LT';
                case 3:
                    return '[prejšnjo] [sredo] [ob] LT';
                case 6:
                    return '[prejšnjo] [soboto] [ob] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prejšnji] dddd [ob] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'čez %s',
        past   : 'pred %s',
        s      : processRelativeTime,
        m      : processRelativeTime,
        mm     : processRelativeTime,
        h      : processRelativeTime,
        hh     : processRelativeTime,
        d      : processRelativeTime,
        dd     : processRelativeTime,
        M      : processRelativeTime,
        MM     : processRelativeTime,
        y      : processRelativeTime,
        yy     : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sl;

})));


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sq = moment.defineLocale('sq', {
    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
    weekdaysParseExact : true,
    meridiemParse: /PD|MD/,
    isPM: function (input) {
        return input.charAt(0) === 'M';
    },
    meridiem : function (hours, minutes, isLower) {
        return hours < 12 ? 'PD' : 'MD';
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Sot në] LT',
        nextDay : '[Nesër në] LT',
        nextWeek : 'dddd [në] LT',
        lastDay : '[Dje në] LT',
        lastWeek : 'dddd [e kaluar në] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'në %s',
        past : '%s më parë',
        s : 'disa sekonda',
        m : 'një minutë',
        mm : '%d minuta',
        h : 'një orë',
        hh : '%d orë',
        d : 'një ditë',
        dd : '%d ditë',
        M : 'një muaj',
        MM : '%d muaj',
        y : 'një vit',
        yy : '%d vite'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sq;

})));


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        m: ['један минут', 'једне минуте'],
        mm: ['минут', 'минуте', 'минута'],
        h: ['један сат', 'једног сата'],
        hh: ['сат', 'сата', 'сати'],
        dd: ['дан', 'дана', 'дана'],
        MM: ['месец', 'месеца', 'месеци'],
        yy: ['година', 'године', 'година']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var srCyrl = moment.defineLocale('sr-cyrl', {
    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
    monthsParseExact: true,
    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[данас у] LT',
        nextDay: '[сутра у] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[у] [недељу] [у] LT';
                case 3:
                    return '[у] [среду] [у] LT';
                case 6:
                    return '[у] [суботу] [у] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[у] dddd [у] LT';
            }
        },
        lastDay  : '[јуче у] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[прошле] [недеље] [у] LT',
                '[прошлог] [понедељка] [у] LT',
                '[прошлог] [уторка] [у] LT',
                '[прошле] [среде] [у] LT',
                '[прошлог] [четвртка] [у] LT',
                '[прошлог] [петка] [у] LT',
                '[прошле] [суботе] [у] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'за %s',
        past   : 'пре %s',
        s      : 'неколико секунди',
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'дан',
        dd     : translator.translate,
        M      : 'месец',
        MM     : translator.translate,
        y      : 'годину',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return srCyrl;

})));


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        m: ['jedan minut', 'jedne minute'],
        mm: ['minut', 'minute', 'minuta'],
        h: ['jedan sat', 'jednog sata'],
        hh: ['sat', 'sata', 'sati'],
        dd: ['dan', 'dana', 'dana'],
        MM: ['mesec', 'meseca', 'meseci'],
        yy: ['godina', 'godine', 'godina']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var sr = moment.defineLocale('sr', {
    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[danas u] LT',
        nextDay: '[sutra u] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedelju] [u] LT';
                case 3:
                    return '[u] [sredu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[juče u] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[prošle] [nedelje] [u] LT',
                '[prošlog] [ponedeljka] [u] LT',
                '[prošlog] [utorka] [u] LT',
                '[prošle] [srede] [u] LT',
                '[prošlog] [četvrtka] [u] LT',
                '[prošlog] [petka] [u] LT',
                '[prošle] [subote] [u] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'pre %s',
        s      : 'nekoliko sekundi',
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'dan',
        dd     : translator.translate,
        M      : 'mesec',
        MM     : translator.translate,
        y      : 'godinu',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sr;

})));


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var ss = moment.defineLocale('ss', {
    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Namuhla nga] LT',
        nextDay : '[Kusasa nga] LT',
        nextWeek : 'dddd [nga] LT',
        lastDay : '[Itolo nga] LT',
        lastWeek : 'dddd [leliphelile] [nga] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'nga %s',
        past : 'wenteka nga %s',
        s : 'emizuzwana lomcane',
        m : 'umzuzu',
        mm : '%d emizuzu',
        h : 'lihora',
        hh : '%d emahora',
        d : 'lilanga',
        dd : '%d emalanga',
        M : 'inyanga',
        MM : '%d tinyanga',
        y : 'umnyaka',
        yy : '%d iminyaka'
    },
    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'ekuseni';
        } else if (hours < 15) {
            return 'emini';
        } else if (hours < 19) {
            return 'entsambama';
        } else {
            return 'ebusuku';
        }
    },
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ekuseni') {
            return hour;
        } else if (meridiem === 'emini') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
            if (hour === 0) {
                return 0;
            }
            return hour + 12;
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : '%d',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ss;

})));


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sv = moment.defineLocale('sv', {
    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [kl.] HH:mm',
        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Idag] LT',
        nextDay: '[Imorgon] LT',
        lastDay: '[Igår] LT',
        nextWeek: '[På] dddd LT',
        lastWeek: '[I] dddd[s] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : 'för %s sedan',
        s : 'några sekunder',
        m : 'en minut',
        mm : '%d minuter',
        h : 'en timme',
        hh : '%d timmar',
        d : 'en dag',
        dd : '%d dagar',
        M : 'en månad',
        MM : '%d månader',
        y : 'ett år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'e' :
            (b === 1) ? 'a' :
            (b === 2) ? 'a' :
            (b === 3) ? 'e' : 'e';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sv;

})));


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sw = moment.defineLocale('sw', {
    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[leo saa] LT',
        nextDay : '[kesho saa] LT',
        nextWeek : '[wiki ijayo] dddd [saat] LT',
        lastDay : '[jana] LT',
        lastWeek : '[wiki iliyopita] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s baadaye',
        past : 'tokea %s',
        s : 'hivi punde',
        m : 'dakika moja',
        mm : 'dakika %d',
        h : 'saa limoja',
        hh : 'masaa %d',
        d : 'siku moja',
        dd : 'masiku %d',
        M : 'mwezi mmoja',
        MM : 'miezi %d',
        y : 'mwaka mmoja',
        yy : 'miaka %d'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sw;

})));


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '௧',
    '2': '௨',
    '3': '௩',
    '4': '௪',
    '5': '௫',
    '6': '௬',
    '7': '௭',
    '8': '௮',
    '9': '௯',
    '0': '௦'
};
var numberMap = {
    '௧': '1',
    '௨': '2',
    '௩': '3',
    '௪': '4',
    '௫': '5',
    '௬': '6',
    '௭': '7',
    '௮': '8',
    '௯': '9',
    '௦': '0'
};

var ta = moment.defineLocale('ta', {
    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, HH:mm',
        LLLL : 'dddd, D MMMM YYYY, HH:mm'
    },
    calendar : {
        sameDay : '[இன்று] LT',
        nextDay : '[நாளை] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[நேற்று] LT',
        lastWeek : '[கடந்த வாரம்] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s இல்',
        past : '%s முன்',
        s : 'ஒரு சில விநாடிகள்',
        m : 'ஒரு நிமிடம்',
        mm : '%d நிமிடங்கள்',
        h : 'ஒரு மணி நேரம்',
        hh : '%d மணி நேரம்',
        d : 'ஒரு நாள்',
        dd : '%d நாட்கள்',
        M : 'ஒரு மாதம்',
        MM : '%d மாதங்கள்',
        y : 'ஒரு வருடம்',
        yy : '%d ஆண்டுகள்'
    },
    dayOfMonthOrdinalParse: /\d{1,2}வது/,
    ordinal : function (number) {
        return number + 'வது';
    },
    preparse: function (string) {
        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // refer http://ta.wikipedia.org/s/1er1
    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
    meridiem : function (hour, minute, isLower) {
        if (hour < 2) {
            return ' யாமம்';
        } else if (hour < 6) {
            return ' வைகறை';  // வைகறை
        } else if (hour < 10) {
            return ' காலை'; // காலை
        } else if (hour < 14) {
            return ' நண்பகல்'; // நண்பகல்
        } else if (hour < 18) {
            return ' எற்பாடு'; // எற்பாடு
        } else if (hour < 22) {
            return ' மாலை'; // மாலை
        } else {
            return ' யாமம்';
        }
    },
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'யாமம்') {
            return hour < 2 ? hour : hour + 12;
        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
            return hour;
        } else if (meridiem === 'நண்பகல்') {
            return hour >= 10 ? hour : hour + 12;
        } else {
            return hour + 12;
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return ta;

})));


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var te = moment.defineLocale('te', {
    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
    monthsParseExact : true,
    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[నేడు] LT',
        nextDay : '[రేపు] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[నిన్న] LT',
        lastWeek : '[గత] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s లో',
        past : '%s క్రితం',
        s : 'కొన్ని క్షణాలు',
        m : 'ఒక నిమిషం',
        mm : '%d నిమిషాలు',
        h : 'ఒక గంట',
        hh : '%d గంటలు',
        d : 'ఒక రోజు',
        dd : '%d రోజులు',
        M : 'ఒక నెల',
        MM : '%d నెలలు',
        y : 'ఒక సంవత్సరం',
        yy : '%d సంవత్సరాలు'
    },
    dayOfMonthOrdinalParse : /\d{1,2}వ/,
    ordinal : '%dవ',
    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'రాత్రి') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ఉదయం') {
            return hour;
        } else if (meridiem === 'మధ్యాహ్నం') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'సాయంత్రం') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'రాత్రి';
        } else if (hour < 10) {
            return 'ఉదయం';
        } else if (hour < 17) {
            return 'మధ్యాహ్నం';
        } else if (hour < 20) {
            return 'సాయంత్రం';
        } else {
            return 'రాత్రి';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return te;

})));


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tet = moment.defineLocale('tet', {
    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Ohin iha] LT',
        nextDay: '[Aban iha] LT',
        nextWeek: 'dddd [iha] LT',
        lastDay: '[Horiseik iha] LT',
        lastWeek: 'dddd [semana kotuk] [iha] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'iha %s',
        past : '%s liuba',
        s : 'minutu balun',
        m : 'minutu ida',
        mm : 'minutus %d',
        h : 'horas ida',
        hh : 'horas %d',
        d : 'loron ida',
        dd : 'loron %d',
        M : 'fulan ida',
        MM : 'fulan %d',
        y : 'tinan ida',
        yy : 'tinan %d'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tet;

})));


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var th = moment.defineLocale('th', {
    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
    monthsParseExact: true,
    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY เวลา H:mm',
        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
    },
    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
    isPM: function (input) {
        return input === 'หลังเที่ยง';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ก่อนเที่ยง';
        } else {
            return 'หลังเที่ยง';
        }
    },
    calendar : {
        sameDay : '[วันนี้ เวลา] LT',
        nextDay : '[พรุ่งนี้ เวลา] LT',
        nextWeek : 'dddd[หน้า เวลา] LT',
        lastDay : '[เมื่อวานนี้ เวลา] LT',
        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'อีก %s',
        past : '%sที่แล้ว',
        s : 'ไม่กี่วินาที',
        m : '1 นาที',
        mm : '%d นาที',
        h : '1 ชั่วโมง',
        hh : '%d ชั่วโมง',
        d : '1 วัน',
        dd : '%d วัน',
        M : '1 เดือน',
        MM : '%d เดือน',
        y : '1 ปี',
        yy : '%d ปี'
    }
});

return th;

})));


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tlPh = moment.defineLocale('tl-ph', {
    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'MM/D/YYYY',
        LL : 'MMMM D, YYYY',
        LLL : 'MMMM D, YYYY HH:mm',
        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
    },
    calendar : {
        sameDay: 'LT [ngayong araw]',
        nextDay: '[Bukas ng] LT',
        nextWeek: 'LT [sa susunod na] dddd',
        lastDay: 'LT [kahapon]',
        lastWeek: 'LT [noong nakaraang] dddd',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'sa loob ng %s',
        past : '%s ang nakalipas',
        s : 'ilang segundo',
        m : 'isang minuto',
        mm : '%d minuto',
        h : 'isang oras',
        hh : '%d oras',
        d : 'isang araw',
        dd : '%d araw',
        M : 'isang buwan',
        MM : '%d buwan',
        y : 'isang taon',
        yy : '%d taon'
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : function (number) {
        return number;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tlPh;

})));


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

function translateFuture(output) {
    var time = output;
    time = (output.indexOf('jaj') !== -1) ?
    time.slice(0, -3) + 'leS' :
    (output.indexOf('jar') !== -1) ?
    time.slice(0, -3) + 'waQ' :
    (output.indexOf('DIS') !== -1) ?
    time.slice(0, -3) + 'nem' :
    time + ' pIq';
    return time;
}

function translatePast(output) {
    var time = output;
    time = (output.indexOf('jaj') !== -1) ?
    time.slice(0, -3) + 'Hu’' :
    (output.indexOf('jar') !== -1) ?
    time.slice(0, -3) + 'wen' :
    (output.indexOf('DIS') !== -1) ?
    time.slice(0, -3) + 'ben' :
    time + ' ret';
    return time;
}

function translate(number, withoutSuffix, string, isFuture) {
    var numberNoun = numberAsNoun(number);
    switch (string) {
        case 'mm':
            return numberNoun + ' tup';
        case 'hh':
            return numberNoun + ' rep';
        case 'dd':
            return numberNoun + ' jaj';
        case 'MM':
            return numberNoun + ' jar';
        case 'yy':
            return numberNoun + ' DIS';
    }
}

function numberAsNoun(number) {
    var hundred = Math.floor((number % 1000) / 100),
    ten = Math.floor((number % 100) / 10),
    one = number % 10,
    word = '';
    if (hundred > 0) {
        word += numbersNouns[hundred] + 'vatlh';
    }
    if (ten > 0) {
        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
    }
    if (one > 0) {
        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
    }
    return (word === '') ? 'pagh' : word;
}

var tlh = moment.defineLocale('tlh', {
    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
    monthsParseExact : true,
    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[DaHjaj] LT',
        nextDay: '[wa’leS] LT',
        nextWeek: 'LLL',
        lastDay: '[wa’Hu’] LT',
        lastWeek: 'LLL',
        sameElse: 'L'
    },
    relativeTime : {
        future : translateFuture,
        past : translatePast,
        s : 'puS lup',
        m : 'wa’ tup',
        mm : translate,
        h : 'wa’ rep',
        hh : translate,
        d : 'wa’ jaj',
        dd : translate,
        M : 'wa’ jar',
        MM : translate,
        y : 'wa’ DIS',
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tlh;

})));


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    1: '\'inci',
    5: '\'inci',
    8: '\'inci',
    70: '\'inci',
    80: '\'inci',
    2: '\'nci',
    7: '\'nci',
    20: '\'nci',
    50: '\'nci',
    3: '\'üncü',
    4: '\'üncü',
    100: '\'üncü',
    6: '\'ncı',
    9: '\'uncu',
    10: '\'uncu',
    30: '\'uncu',
    60: '\'ıncı',
    90: '\'ıncı'
};

var tr = moment.defineLocale('tr', {
    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[bugün saat] LT',
        nextDay : '[yarın saat] LT',
        nextWeek : '[haftaya] dddd [saat] LT',
        lastDay : '[dün] LT',
        lastWeek : '[geçen hafta] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s sonra',
        past : '%s önce',
        s : 'birkaç saniye',
        m : 'bir dakika',
        mm : '%d dakika',
        h : 'bir saat',
        hh : '%d saat',
        d : 'bir gün',
        dd : '%d gün',
        M : 'bir ay',
        MM : '%d ay',
        y : 'bir yıl',
        yy : '%d yıl'
    },
    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
    ordinal : function (number) {
        if (number === 0) {  // special case for zero
            return number + '\'ıncı';
        }
        var a = number % 10,
            b = number % 100 - a,
            c = number >= 100 ? 100 : null;
        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return tr;

})));


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
// This is currently too difficult (maybe even impossible) to add.
var tzl = moment.defineLocale('tzl', {
    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM [dallas] YYYY',
        LLL : 'D. MMMM [dallas] YYYY HH.mm',
        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
    },
    meridiemParse: /d\'o|d\'a/i,
    isPM : function (input) {
        return 'd\'o' === input.toLowerCase();
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'd\'o' : 'D\'O';
        } else {
            return isLower ? 'd\'a' : 'D\'A';
        }
    },
    calendar : {
        sameDay : '[oxhi à] LT',
        nextDay : '[demà à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[ieiri à] LT',
        lastWeek : '[sür el] dddd [lasteu à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'osprei %s',
        past : 'ja%s',
        s : processRelativeTime,
        m : processRelativeTime,
        mm : processRelativeTime,
        h : processRelativeTime,
        hh : processRelativeTime,
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's': ['viensas secunds', '\'iensas secunds'],
        'm': ['\'n míut', '\'iens míut'],
        'mm': [number + ' míuts', '' + number + ' míuts'],
        'h': ['\'n þora', '\'iensa þora'],
        'hh': [number + ' þoras', '' + number + ' þoras'],
        'd': ['\'n ziua', '\'iensa ziua'],
        'dd': [number + ' ziuas', '' + number + ' ziuas'],
        'M': ['\'n mes', '\'iens mes'],
        'MM': [number + ' mesen', '' + number + ' mesen'],
        'y': ['\'n ar', '\'iens ar'],
        'yy': [number + ' ars', '' + number + ' ars']
    };
    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
}

return tzl;

})));


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tzmLatn = moment.defineLocale('tzm-latn', {
    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[asdkh g] LT',
        nextDay: '[aska g] LT',
        nextWeek: 'dddd [g] LT',
        lastDay: '[assant g] LT',
        lastWeek: 'dddd [g] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'dadkh s yan %s',
        past : 'yan %s',
        s : 'imik',
        m : 'minuḍ',
        mm : '%d minuḍ',
        h : 'saɛa',
        hh : '%d tassaɛin',
        d : 'ass',
        dd : '%d ossan',
        M : 'ayowr',
        MM : '%d iyyirn',
        y : 'asgas',
        yy : '%d isgasn'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return tzmLatn;

})));


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tzm = moment.defineLocale('tzm', {
    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
        nextWeek: 'dddd [ⴴ] LT',
        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
        lastWeek: 'dddd [ⴴ] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
        past : 'ⵢⴰⵏ %s',
        s : 'ⵉⵎⵉⴽ',
        m : 'ⵎⵉⵏⵓⴺ',
        mm : '%d ⵎⵉⵏⵓⴺ',
        h : 'ⵙⴰⵄⴰ',
        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
        d : 'ⴰⵙⵙ',
        dd : '%d oⵙⵙⴰⵏ',
        M : 'ⴰⵢoⵓⵔ',
        MM : '%d ⵉⵢⵢⵉⵔⵏ',
        y : 'ⴰⵙⴳⴰⵙ',
        yy : '%d ⵉⵙⴳⴰⵙⵏ'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return tzm;

})));


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
        'dd': 'день_дні_днів',
        'MM': 'місяць_місяці_місяців',
        'yy': 'рік_роки_років'
    };
    if (key === 'm') {
        return withoutSuffix ? 'хвилина' : 'хвилину';
    }
    else if (key === 'h') {
        return withoutSuffix ? 'година' : 'годину';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}
function weekdaysCaseReplace(m, format) {
    var weekdays = {
        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
    };

    if (!m) {
        return weekdays['nominative'];
    }

    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
        'accusative' :
        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
            'genitive' :
            'nominative');
    return weekdays[nounCase][m.day()];
}
function processHoursFunction(str) {
    return function () {
        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
    };
}

var uk = moment.defineLocale('uk', {
    months : {
        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
    },
    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
    weekdays : weekdaysCaseReplace,
    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY р.',
        LLL : 'D MMMM YYYY р., HH:mm',
        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
    },
    calendar : {
        sameDay: processHoursFunction('[Сьогодні '),
        nextDay: processHoursFunction('[Завтра '),
        lastDay: processHoursFunction('[Вчора '),
        nextWeek: processHoursFunction('[У] dddd ['),
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 5:
                case 6:
                    return processHoursFunction('[Минулої] dddd [').call(this);
                case 1:
                case 2:
                case 4:
                    return processHoursFunction('[Минулого] dddd [').call(this);
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'за %s',
        past : '%s тому',
        s : 'декілька секунд',
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : 'годину',
        hh : relativeTimeWithPlural,
        d : 'день',
        dd : relativeTimeWithPlural,
        M : 'місяць',
        MM : relativeTimeWithPlural,
        y : 'рік',
        yy : relativeTimeWithPlural
    },
    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
    meridiemParse: /ночі|ранку|дня|вечора/,
    isPM: function (input) {
        return /^(дня|вечора)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночі';
        } else if (hour < 12) {
            return 'ранку';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечора';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
            case 'w':
            case 'W':
                return number + '-й';
            case 'D':
                return number + '-го';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return uk;

})));


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'جنوری',
    'فروری',
    'مارچ',
    'اپریل',
    'مئی',
    'جون',
    'جولائی',
    'اگست',
    'ستمبر',
    'اکتوبر',
    'نومبر',
    'دسمبر'
];
var days = [
    'اتوار',
    'پیر',
    'منگل',
    'بدھ',
    'جمعرات',
    'جمعہ',
    'ہفتہ'
];

var ur = moment.defineLocale('ur', {
    months : months,
    monthsShort : months,
    weekdays : days,
    weekdaysShort : days,
    weekdaysMin : days,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd، D MMMM YYYY HH:mm'
    },
    meridiemParse: /صبح|شام/,
    isPM : function (input) {
        return 'شام' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'صبح';
        }
        return 'شام';
    },
    calendar : {
        sameDay : '[آج بوقت] LT',
        nextDay : '[کل بوقت] LT',
        nextWeek : 'dddd [بوقت] LT',
        lastDay : '[گذشتہ روز بوقت] LT',
        lastWeek : '[گذشتہ] dddd [بوقت] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s بعد',
        past : '%s قبل',
        s : 'چند سیکنڈ',
        m : 'ایک منٹ',
        mm : '%d منٹ',
        h : 'ایک گھنٹہ',
        hh : '%d گھنٹے',
        d : 'ایک دن',
        dd : '%d دن',
        M : 'ایک ماہ',
        MM : '%d ماہ',
        y : 'ایک سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ur;

})));


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var uzLatn = moment.defineLocale('uz-latn', {
    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'D MMMM YYYY, dddd HH:mm'
    },
    calendar : {
        sameDay : '[Bugun soat] LT [da]',
        nextDay : '[Ertaga] LT [da]',
        nextWeek : 'dddd [kuni soat] LT [da]',
        lastDay : '[Kecha soat] LT [da]',
        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'Yaqin %s ichida',
        past : 'Bir necha %s oldin',
        s : 'soniya',
        m : 'bir daqiqa',
        mm : '%d daqiqa',
        h : 'bir soat',
        hh : '%d soat',
        d : 'bir kun',
        dd : '%d kun',
        M : 'bir oy',
        MM : '%d oy',
        y : 'bir yil',
        yy : '%d yil'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return uzLatn;

})));


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var uz = moment.defineLocale('uz', {
    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'D MMMM YYYY, dddd HH:mm'
    },
    calendar : {
        sameDay : '[Бугун соат] LT [да]',
        nextDay : '[Эртага] LT [да]',
        nextWeek : 'dddd [куни соат] LT [да]',
        lastDay : '[Кеча соат] LT [да]',
        lastWeek : '[Утган] dddd [куни соат] LT [да]',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'Якин %s ичида',
        past : 'Бир неча %s олдин',
        s : 'фурсат',
        m : 'бир дакика',
        mm : '%d дакика',
        h : 'бир соат',
        hh : '%d соат',
        d : 'бир кун',
        dd : '%d кун',
        M : 'бир ой',
        MM : '%d ой',
        y : 'бир йил',
        yy : '%d йил'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 4th is the first week of the year.
    }
});

return uz;

})));


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var vi = moment.defineLocale('vi', {
    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
    monthsParseExact : true,
    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
    weekdaysParseExact : true,
    meridiemParse: /sa|ch/i,
    isPM : function (input) {
        return /^ch$/i.test(input);
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower ? 'sa' : 'SA';
        } else {
            return isLower ? 'ch' : 'CH';
        }
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM [năm] YYYY',
        LLL : 'D MMMM [năm] YYYY HH:mm',
        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
        l : 'DD/M/YYYY',
        ll : 'D MMM YYYY',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd, D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Hôm nay lúc] LT',
        nextDay: '[Ngày mai lúc] LT',
        nextWeek: 'dddd [tuần tới lúc] LT',
        lastDay: '[Hôm qua lúc] LT',
        lastWeek: 'dddd [tuần rồi lúc] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s tới',
        past : '%s trước',
        s : 'vài giây',
        m : 'một phút',
        mm : '%d phút',
        h : 'một giờ',
        hh : '%d giờ',
        d : 'một ngày',
        dd : '%d ngày',
        M : 'một tháng',
        MM : '%d tháng',
        y : 'một năm',
        yy : '%d năm'
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : function (number) {
        return number;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return vi;

})));


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var xPseudo = moment.defineLocale('x-pseudo', {
    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
    monthsParseExact : true,
    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[T~ódá~ý át] LT',
        nextDay : '[T~ómó~rró~w át] LT',
        nextWeek : 'dddd [át] LT',
        lastDay : '[Ý~ést~érdá~ý át] LT',
        lastWeek : '[L~ást] dddd [át] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'í~ñ %s',
        past : '%s á~gó',
        s : 'á ~féw ~sécó~ñds',
        m : 'á ~míñ~úté',
        mm : '%d m~íñú~tés',
        h : 'á~ñ hó~úr',
        hh : '%d h~óúrs',
        d : 'á ~dáý',
        dd : '%d d~áýs',
        M : 'á ~móñ~th',
        MM : '%d m~óñt~hs',
        y : 'á ~ýéár',
        yy : '%d ý~éárs'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return xPseudo;

})));


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var yo = moment.defineLocale('yo', {
    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Ònì ni] LT',
        nextDay : '[Ọ̀la ni] LT',
        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
        lastDay : '[Àna ni] LT',
        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ní %s',
        past : '%s kọjá',
        s : 'ìsẹjú aayá die',
        m : 'ìsẹjú kan',
        mm : 'ìsẹjú %d',
        h : 'wákati kan',
        hh : 'wákati %d',
        d : 'ọjọ́ kan',
        dd : 'ọjọ́ %d',
        M : 'osù kan',
        MM : 'osù %d',
        y : 'ọdún kan',
        yy : 'ọdún %d'
    },
    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
    ordinal : 'ọjọ́ %d',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return yo;

})));


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhCn = moment.defineLocale('zh-cn', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY年MMMD日',
        LL : 'YYYY年MMMD日',
        LLL : 'YYYY年MMMD日Ah点mm分',
        LLLL : 'YYYY年MMMD日ddddAh点mm分',
        l : 'YYYY年MMMD日',
        ll : 'YYYY年MMMD日',
        lll : 'YYYY年MMMD日 HH:mm',
        llll : 'YYYY年MMMD日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' ||
                meridiem === '上午') {
            return hour;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        } else {
            // '中午'
            return hour >= 11 ? hour : hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '日';
            case 'M':
                return number + '月';
            case 'w':
            case 'W':
                return number + '周';
            default:
                return number;
        }
    },
    relativeTime : {
        future : '%s内',
        past : '%s前',
        s : '几秒',
        m : '1 分钟',
        mm : '%d 分钟',
        h : '1 小时',
        hh : '%d 小时',
        d : '1 天',
        dd : '%d 天',
        M : '1 个月',
        MM : '%d 个月',
        y : '1 年',
        yy : '%d 年'
    },
    week : {
        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return zhCn;

})));


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhHk = moment.defineLocale('zh-hk', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY年MMMD日',
        LL : 'YYYY年MMMD日',
        LLL : 'YYYY年MMMD日 HH:mm',
        LLLL : 'YYYY年MMMD日dddd HH:mm',
        l : 'YYYY年MMMD日',
        ll : 'YYYY年MMMD日',
        lll : 'YYYY年MMMD日 HH:mm',
        llll : 'YYYY年MMMD日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
            return hour;
        } else if (meridiem === '中午') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd' :
            case 'D' :
            case 'DDD' :
                return number + '日';
            case 'M' :
                return number + '月';
            case 'w' :
            case 'W' :
                return number + '週';
            default :
                return number;
        }
    },
    relativeTime : {
        future : '%s內',
        past : '%s前',
        s : '幾秒',
        m : '1 分鐘',
        mm : '%d 分鐘',
        h : '1 小時',
        hh : '%d 小時',
        d : '1 天',
        dd : '%d 天',
        M : '1 個月',
        MM : '%d 個月',
        y : '1 年',
        yy : '%d 年'
    }
});

return zhHk;

})));


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__(1)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhTw = moment.defineLocale('zh-tw', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY年MMMD日',
        LL : 'YYYY年MMMD日',
        LLL : 'YYYY年MMMD日 HH:mm',
        LLLL : 'YYYY年MMMD日dddd HH:mm',
        l : 'YYYY年MMMD日',
        ll : 'YYYY年MMMD日',
        lll : 'YYYY年MMMD日 HH:mm',
        llll : 'YYYY年MMMD日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
            return hour;
        } else if (meridiem === '中午') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd' :
            case 'D' :
            case 'DDD' :
                return number + '日';
            case 'M' :
                return number + '月';
            case 'w' :
            case 'W' :
                return number + '週';
            default :
                return number;
        }
    },
    relativeTime : {
        future : '%s內',
        past : '%s前',
        s : '幾秒',
        m : '1 分鐘',
        mm : '%d 分鐘',
        h : '1 小時',
        hh : '%d 小時',
        d : '1 天',
        dd : '%d 天',
        M : '1 個月',
        MM : '%d 個月',
        y : '1 年',
        yy : '%d 年'
    }
});

return zhTw;

})));


/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, y) {
  x = Math.abs(x);
  y = Math.abs(y);
  var a = Math.max(x, y);
  var b = Math.min(x, y) / (a ? a : 1);

  return a * Math.sqrt(1 + Math.pow(b, 2));
});


/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var C00 = 1;
var C02 = 0.25;
var C04 = 0.046875;
var C06 = 0.01953125;
var C08 = 0.01068115234375;
var C22 = 0.75;
var C44 = 0.46875;
var C46 = 0.01302083333333333333;
var C48 = 0.00712076822916666666;
var C66 = 0.36458333333333333333;
var C68 = 0.00569661458333333333;
var C88 = 0.3076171875;

/* harmony default export */ __webpack_exports__["a"] = (function(es) {
  var en = [];
  en[0] = C00 - es * (C02 + es * (C04 + es * (C06 + es * C08)));
  en[1] = es * (C22 - es * (C04 + es * (C06 + es * C08)));
  var t = es * es;
  en[2] = t * (C44 - es * (C46 + es * C48));
  t *= es;
  en[3] = t * (C66 - es * C68);
  en[4] = t * es * C88;
  return en;
});

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pj_mlfn__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_values__ = __webpack_require__(28);



var MAX_ITER = 20;

/* harmony default export */ __webpack_exports__["a"] = (function(arg, es, en) {
  var k = 1 / (1 - es);
  var phi = arg;
  for (var i = MAX_ITER; i; --i) { /* rarely goes over 2 iterations */
    var s = Math.sin(phi);
    var t = 1 - es * s * s;
    //t = this.pj_mlfn(phi, s, Math.cos(phi), en) - arg;
    //phi -= t * (t * Math.sqrt(t)) * k;
    t = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__pj_mlfn__["a" /* default */])(phi, s, Math.cos(phi), en) - arg) * (t * Math.sqrt(t)) * k;
    phi -= t;
    if (Math.abs(t) < __WEBPACK_IMPORTED_MODULE_1__constants_values__["d" /* EPSLN */]) {
      return phi;
    }
  }
  //..reportError("cass:pj_inv_mlfn: Convergence error");
  return phi;
});


/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  var r = Math.exp(x);
  r = (r - 1 / r) / 2;
  return r;
});

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (array){
  var out = {
    x: array[0],
    y: array[1]
  };
  if (array.length>2) {
    out.z = array[2];
  }
  if (array.length>3) {
    out.m = array[3];
  }
  return out;
});

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global__ = __webpack_require__(1196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__projString__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_wkt_parser__ = __webpack_require__(479);




function defs(name) {
  /*global console*/
  var that = this;
  if (arguments.length === 2) {
    var def = arguments[1];
    if (typeof def === 'string') {
      if (def.charAt(0) === '+') {
        defs[name] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__projString__["a" /* default */])(arguments[1]);
      }
      else {
        defs[name] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_wkt_parser__["a" /* default */])(arguments[1]);
      }
    } else {
      defs[name] = def;
    }
  }
  else if (arguments.length === 1) {
    if (Array.isArray(name)) {
      return name.map(function(v) {
        if (Array.isArray(v)) {
          defs.apply(that, v);
        }
        else {
          defs(v);
        }
      });
    }
    else if (typeof name === 'string') {
      if (name in defs) {
        return defs[name];
      }
    }
    else if ('EPSG' in name) {
      defs['EPSG:' + name.EPSG] = name;
    }
    else if ('ESRI' in name) {
      defs['ESRI:' + name.ESRI] = name;
    }
    else if ('IAU2000' in name) {
      defs['IAU2000:' + name.IAU2000] = name;
    }
    else {
      console.log(name);
    }
    return;
  }


}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__global__["a" /* default */])(defs);
/* harmony default export */ __webpack_exports__["a"] = (defs);


/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core__ = __webpack_require__(1190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Proj__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Point__ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_toPoint__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__defs__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__transform__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mgrs__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__version__ = __webpack_require__(1226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__projs__ = __webpack_require__(1228);










__WEBPACK_IMPORTED_MODULE_0__core__["a" /* default */].defaultDatum = 'WGS84'; //default datum
__WEBPACK_IMPORTED_MODULE_0__core__["a" /* default */].Proj = __WEBPACK_IMPORTED_MODULE_1__Proj__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__core__["a" /* default */].WGS84 = new __WEBPACK_IMPORTED_MODULE_0__core__["a" /* default */].Proj('WGS84');
__WEBPACK_IMPORTED_MODULE_0__core__["a" /* default */].Point = __WEBPACK_IMPORTED_MODULE_2__Point__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__core__["a" /* default */].toPoint = __WEBPACK_IMPORTED_MODULE_3__common_toPoint__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__core__["a" /* default */].defs = __WEBPACK_IMPORTED_MODULE_4__defs__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__core__["a" /* default */].transform = __WEBPACK_IMPORTED_MODULE_5__transform__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__core__["a" /* default */].mgrs = __WEBPACK_IMPORTED_MODULE_6_mgrs__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__core__["a" /* default */].version = __WEBPACK_IMPORTED_MODULE_7__version__["a" /* default */];
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__projs__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__core__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__core__["a" /* default */]);


/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_values__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_PrimeMeridian__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_units__ = __webpack_require__(1189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__match__ = __webpack_require__(219);





/* harmony default export */ __webpack_exports__["a"] = (function(defData) {
  var self = {};
  var paramObj = defData.split('+').map(function(v) {
    return v.trim();
  }).filter(function(a) {
    return a;
  }).reduce(function(p, a) {
    var split = a.split('=');
    split.push(true);
    p[split[0].toLowerCase()] = split[1];
    return p;
  }, {});
  var paramName, paramVal, paramOutname;
  var params = {
    proj: 'projName',
    datum: 'datumCode',
    rf: function(v) {
      self.rf = parseFloat(v);
    },
    lat_0: function(v) {
      self.lat0 = v * __WEBPACK_IMPORTED_MODULE_0__constants_values__["g" /* D2R */];
    },
    lat_1: function(v) {
      self.lat1 = v * __WEBPACK_IMPORTED_MODULE_0__constants_values__["g" /* D2R */];
    },
    lat_2: function(v) {
      self.lat2 = v * __WEBPACK_IMPORTED_MODULE_0__constants_values__["g" /* D2R */];
    },
    lat_ts: function(v) {
      self.lat_ts = v * __WEBPACK_IMPORTED_MODULE_0__constants_values__["g" /* D2R */];
    },
    lon_0: function(v) {
      self.long0 = v * __WEBPACK_IMPORTED_MODULE_0__constants_values__["g" /* D2R */];
    },
    lon_1: function(v) {
      self.long1 = v * __WEBPACK_IMPORTED_MODULE_0__constants_values__["g" /* D2R */];
    },
    lon_2: function(v) {
      self.long2 = v * __WEBPACK_IMPORTED_MODULE_0__constants_values__["g" /* D2R */];
    },
    alpha: function(v) {
      self.alpha = parseFloat(v) * __WEBPACK_IMPORTED_MODULE_0__constants_values__["g" /* D2R */];
    },
    lonc: function(v) {
      self.longc = v * __WEBPACK_IMPORTED_MODULE_0__constants_values__["g" /* D2R */];
    },
    x_0: function(v) {
      self.x0 = parseFloat(v);
    },
    y_0: function(v) {
      self.y0 = parseFloat(v);
    },
    k_0: function(v) {
      self.k0 = parseFloat(v);
    },
    k: function(v) {
      self.k0 = parseFloat(v);
    },
    a: function(v) {
      self.a = parseFloat(v);
    },
    b: function(v) {
      self.b = parseFloat(v);
    },
    r_a: function() {
      self.R_A = true;
    },
    zone: function(v) {
      self.zone = parseInt(v, 10);
    },
    south: function() {
      self.utmSouth = true;
    },
    towgs84: function(v) {
      self.datum_params = v.split(",").map(function(a) {
        return parseFloat(a);
      });
    },
    to_meter: function(v) {
      self.to_meter = parseFloat(v);
    },
    units: function(v) {
      self.units = v;
      var unit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__match__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__constants_units__["a" /* default */], v);
      if (unit) {
        self.to_meter = unit.to_meter;
      }
    },
    from_greenwich: function(v) {
      self.from_greenwich = v * __WEBPACK_IMPORTED_MODULE_0__constants_values__["g" /* D2R */];
    },
    pm: function(v) {
      var pm = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__match__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__constants_PrimeMeridian__["a" /* default */], v);
      self.from_greenwich = (pm ? pm : parseFloat(v)) * __WEBPACK_IMPORTED_MODULE_0__constants_values__["g" /* D2R */];
    },
    nadgrids: function(v) {
      if (v === '@null') {
        self.datumCode = 'none';
      }
      else {
        self.nadgrids = v;
      }
    },
    axis: function(v) {
      var legalAxis = "ewnsud";
      if (v.length === 3 && legalAxis.indexOf(v.substr(0, 1)) !== -1 && legalAxis.indexOf(v.substr(1, 1)) !== -1 && legalAxis.indexOf(v.substr(2, 1)) !== -1) {
        self.axis = v;
      }
    }
  };
  for (paramName in paramObj) {
    paramVal = paramObj[paramName];
    if (paramName in params) {
      paramOutname = params[paramName];
      if (typeof paramOutname === 'function') {
        paramOutname(paramVal);
      }
      else {
        self[paramOutname] = paramVal;
      }
    }
    else {
      self[paramName] = paramVal;
    }
  }
  if(typeof self.datumCode === 'string' && self.datumCode !== "WGS84"){
    self.datumCode = self.datumCode.toLowerCase();
  }
  return self;
});


/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export init */
/* unused harmony export forward */
/* unused harmony export inverse */
/* unused harmony export names */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_sinh__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_hypot__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_asinhy__ = __webpack_require__(1178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_gatg__ = __webpack_require__(1182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_clens__ = __webpack_require__(1179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_clens_cmplx__ = __webpack_require__(1180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_adjust_lon__ = __webpack_require__(33);
// Heavily based on this etmerc projection implementation
// https://github.com/mbloch/mapshaper-proj/blob/master/src/projections/etmerc.js









function init() {
  if (this.es === undefined || this.es <= 0) {
    throw new Error('incorrect elliptical usage');
  }

  this.x0 = this.x0 !== undefined ? this.x0 : 0;
  this.y0 = this.y0 !== undefined ? this.y0 : 0;
  this.long0 = this.long0 !== undefined ? this.long0 : 0;
  this.lat0 = this.lat0 !== undefined ? this.lat0 : 0;

  this.cgb = [];
  this.cbg = [];
  this.utg = [];
  this.gtu = [];

  var f = this.es / (1 + Math.sqrt(1 - this.es));
  var n = f / (2 - f);
  var np = n;

  this.cgb[0] = n * (2 + n * (-2 / 3 + n * (-2 + n * (116 / 45 + n * (26 / 45 + n * (-2854 / 675 ))))));
  this.cbg[0] = n * (-2 + n * ( 2 / 3 + n * ( 4 / 3 + n * (-82 / 45 + n * (32 / 45 + n * (4642 / 4725))))));

  np = np * n;
  this.cgb[1] = np * (7 / 3 + n * (-8 / 5 + n * (-227 / 45 + n * (2704 / 315 + n * (2323 / 945)))));
  this.cbg[1] = np * (5 / 3 + n * (-16 / 15 + n * ( -13 / 9 + n * (904 / 315 + n * (-1522 / 945)))));

  np = np * n;
  this.cgb[2] = np * (56 / 15 + n * (-136 / 35 + n * (-1262 / 105 + n * (73814 / 2835))));
  this.cbg[2] = np * (-26 / 15 + n * (34 / 21 + n * (8 / 5 + n * (-12686 / 2835))));

  np = np * n;
  this.cgb[3] = np * (4279 / 630 + n * (-332 / 35 + n * (-399572 / 14175)));
  this.cbg[3] = np * (1237 / 630 + n * (-12 / 5 + n * ( -24832 / 14175)));

  np = np * n;
  this.cgb[4] = np * (4174 / 315 + n * (-144838 / 6237));
  this.cbg[4] = np * (-734 / 315 + n * (109598 / 31185));

  np = np * n;
  this.cgb[5] = np * (601676 / 22275);
  this.cbg[5] = np * (444337 / 155925);

  np = Math.pow(n, 2);
  this.Qn = this.k0 / (1 + n) * (1 + np * (1 / 4 + np * (1 / 64 + np / 256)));

  this.utg[0] = n * (-0.5 + n * ( 2 / 3 + n * (-37 / 96 + n * ( 1 / 360 + n * (81 / 512 + n * (-96199 / 604800))))));
  this.gtu[0] = n * (0.5 + n * (-2 / 3 + n * (5 / 16 + n * (41 / 180 + n * (-127 / 288 + n * (7891 / 37800))))));

  this.utg[1] = np * (-1 / 48 + n * (-1 / 15 + n * (437 / 1440 + n * (-46 / 105 + n * (1118711 / 3870720)))));
  this.gtu[1] = np * (13 / 48 + n * (-3 / 5 + n * (557 / 1440 + n * (281 / 630 + n * (-1983433 / 1935360)))));

  np = np * n;
  this.utg[2] = np * (-17 / 480 + n * (37 / 840 + n * (209 / 4480 + n * (-5569 / 90720 ))));
  this.gtu[2] = np * (61 / 240 + n * (-103 / 140 + n * (15061 / 26880 + n * (167603 / 181440))));

  np = np * n;
  this.utg[3] = np * (-4397 / 161280 + n * (11 / 504 + n * (830251 / 7257600)));
  this.gtu[3] = np * (49561 / 161280 + n * (-179 / 168 + n * (6601661 / 7257600)));

  np = np * n;
  this.utg[4] = np * (-4583 / 161280 + n * (108847 / 3991680));
  this.gtu[4] = np * (34729 / 80640 + n * (-3418889 / 1995840));

  np = np * n;
  this.utg[5] = np * (-20648693 / 638668800);
  this.gtu[5] = np * (212378941 / 319334400);

  var Z = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_gatg__["a" /* default */])(this.cbg, this.lat0);
  this.Zb = -this.Qn * (Z + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_clens__["a" /* default */])(this.gtu, 2 * Z));
}

function forward(p) {
  var Ce = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_adjust_lon__["a" /* default */])(p.x - this.long0);
  var Cn = p.y;

  Cn = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_gatg__["a" /* default */])(this.cbg, Cn);
  var sin_Cn = Math.sin(Cn);
  var cos_Cn = Math.cos(Cn);
  var sin_Ce = Math.sin(Ce);
  var cos_Ce = Math.cos(Ce);

  Cn = Math.atan2(sin_Cn, cos_Ce * cos_Cn);
  Ce = Math.atan2(sin_Ce * cos_Cn, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_hypot__["a" /* default */])(sin_Cn, cos_Cn * cos_Ce));
  Ce = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_asinhy__["a" /* default */])(Math.tan(Ce));

  var tmp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_clens_cmplx__["a" /* default */])(this.gtu, 2 * Cn, 2 * Ce);

  Cn = Cn + tmp[0];
  Ce = Ce + tmp[1];

  var x;
  var y;

  if (Math.abs(Ce) <= 2.623395162778) {
    x = this.a * (this.Qn * Ce) + this.x0;
    y = this.a * (this.Qn * Cn + this.Zb) + this.y0;
  }
  else {
    x = Infinity;
    y = Infinity;
  }

  p.x = x;
  p.y = y;

  return p;
}

function inverse(p) {
  var Ce = (p.x - this.x0) * (1 / this.a);
  var Cn = (p.y - this.y0) * (1 / this.a);

  Cn = (Cn - this.Zb) / this.Qn;
  Ce = Ce / this.Qn;

  var lon;
  var lat;

  if (Math.abs(Ce) <= 2.623395162778) {
    var tmp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_clens_cmplx__["a" /* default */])(this.utg, 2 * Cn, 2 * Ce);

    Cn = Cn + tmp[0];
    Ce = Ce + tmp[1];
    Ce = Math.atan(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_sinh__["a" /* default */])(Ce));

    var sin_Cn = Math.sin(Cn);
    var cos_Cn = Math.cos(Cn);
    var sin_Ce = Math.sin(Ce);
    var cos_Ce = Math.cos(Ce);

    Cn = Math.atan2(sin_Cn * cos_Ce, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_hypot__["a" /* default */])(sin_Ce, cos_Ce * cos_Cn));
    Ce = Math.atan2(sin_Ce, cos_Ce * cos_Cn);

    lon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_adjust_lon__["a" /* default */])(Ce + this.long0);
    lat = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_gatg__["a" /* default */])(this.cgb, Cn);
  }
  else {
    lon = Infinity;
    lat = Infinity;
  }

  p.x = lon;
  p.y = lat;

  return p;
}

var names = ["Extended_Transverse_Mercator", "Extended Transverse Mercator", "etmerc"];
/* harmony default export */ __webpack_exports__["a"] = ({
  init: init,
  forward: forward,
  inverse: inverse,
  names: names
});


/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = transform;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_values__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__datum_transform__ = __webpack_require__(1193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__adjust_axis__ = __webpack_require__(1175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Proj__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_toPoint__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__checkSanity__ = __webpack_require__(1176);







function checkNotWGS(source, dest) {
  return ((source.datum.datum_type === __WEBPACK_IMPORTED_MODULE_0__constants_values__["h" /* PJD_3PARAM */] || source.datum.datum_type === __WEBPACK_IMPORTED_MODULE_0__constants_values__["i" /* PJD_7PARAM */]) && dest.datumCode !== 'WGS84') || ((dest.datum.datum_type === __WEBPACK_IMPORTED_MODULE_0__constants_values__["h" /* PJD_3PARAM */] || dest.datum.datum_type === __WEBPACK_IMPORTED_MODULE_0__constants_values__["i" /* PJD_7PARAM */]) && source.datumCode !== 'WGS84');
}

function transform(source, dest, point) {
  var wgs84;
  if (Array.isArray(point)) {
    point = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_toPoint__["a" /* default */])(point);
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__checkSanity__["a" /* default */])(point);
  // Workaround for datum shifts towgs84, if either source or destination projection is not wgs84
  if (source.datum && dest.datum && checkNotWGS(source, dest)) {
    wgs84 = new __WEBPACK_IMPORTED_MODULE_3__Proj__["a" /* default */]('WGS84');
    point = transform(source, wgs84, point);
    source = wgs84;
  }
  // DGR, 2010/11/12
  if (source.axis !== 'enu') {
    point = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__adjust_axis__["a" /* default */])(source, false, point);
  }
  // Transform source points to long/lat, if they aren't already.
  if (source.projName === 'longlat') {
    point = {
      x: point.x * __WEBPACK_IMPORTED_MODULE_0__constants_values__["g" /* D2R */],
      y: point.y * __WEBPACK_IMPORTED_MODULE_0__constants_values__["g" /* D2R */]
    };
  }
  else {
    if (source.to_meter) {
      point = {
        x: point.x * source.to_meter,
        y: point.y * source.to_meter
      };
    }
    point = source.inverse(point); // Convert Cartesian to longlat
  }
  // Adjust for the prime meridian if necessary
  if (source.from_greenwich) {
    point.x += source.from_greenwich;
  }

  // Convert datums if needed, and if possible.
  point = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__datum_transform__["a" /* default */])(source.datum, dest.datum, point);

  // Adjust for the prime meridian if necessary
  if (dest.from_greenwich) {
    point = {
      x: point.x - dest.from_greenwich,
      y: point.y
    };
  }

  if (dest.projName === 'longlat') {
    // convert radians to decimal degrees
    point = {
      x: point.x * __WEBPACK_IMPORTED_MODULE_0__constants_values__["j" /* R2D */],
      y: point.y * __WEBPACK_IMPORTED_MODULE_0__constants_values__["j" /* R2D */]
    };
  } else { // else project
    point = dest.forward(point);
    if (dest.to_meter) {
      point = {
        x: point.x / dest.to_meter,
        y: point.y / dest.to_meter
      };
    }
  }

  // DGR, 2010/11/12
  if (dest.axis !== 'enu') {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__adjust_axis__["a" /* default */])(dest, true, point);
  }

  return point;
}


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(932);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(220)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js!./swiper.css", function() {
			var newContent = require("!!../../../css-loader/index.js!./swiper.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Swiper 3.4.2
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * 
 * http://www.idangero.us/swiper/
 * 
 * Copyright 2017, Vladimir Kharlampidi
 * The iDangero.us
 * http://www.idangero.us/
 * 
 * Licensed under MIT
 * 
 * Released on: March 10, 2017
 */
(function () {
    'use strict';
    var $;

    /*===========================
    Swiper
    ===========================*/
    var Swiper = function (container, params) {
        if (!(this instanceof Swiper)) return new Swiper(container, params);
    

        var defaults = {
            direction: 'horizontal',
            touchEventsTarget: 'container',
            initialSlide: 0,
            speed: 300,
            // autoplay
            autoplay: false,
            autoplayDisableOnInteraction: true,
            autoplayStopOnLast: false,
            // To support iOS's swipe-to-go-back gesture (when being used in-app, with UIWebView).
            iOSEdgeSwipeDetection: false,
            iOSEdgeSwipeThreshold: 20,
            // Free mode
            freeMode: false,
            freeModeMomentum: true,
            freeModeMomentumRatio: 1,
            freeModeMomentumBounce: true,
            freeModeMomentumBounceRatio: 1,
            freeModeMomentumVelocityRatio: 1,
            freeModeSticky: false,
            freeModeMinimumVelocity: 0.02,
            // Autoheight
            autoHeight: false,
            // Set wrapper width
            setWrapperSize: false,
            // Virtual Translate
            virtualTranslate: false,
            // Effects
            effect: 'slide', // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
            coverflow: {
                rotate: 50,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows : true
            },
            flip: {
                slideShadows : true,
                limitRotation: true
            },
            cube: {
                slideShadows: true,
                shadow: true,
                shadowOffset: 20,
                shadowScale: 0.94
            },
            fade: {
                crossFade: false
            },
            // Parallax
            parallax: false,
            // Zoom
            zoom: false,
            zoomMax: 3,
            zoomMin: 1,
            zoomToggle: true,
            // Scrollbar
            scrollbar: null,
            scrollbarHide: true,
            scrollbarDraggable: false,
            scrollbarSnapOnRelease: false,
            // Keyboard Mousewheel
            keyboardControl: false,
            mousewheelControl: false,
            mousewheelReleaseOnEdges: false,
            mousewheelInvert: false,
            mousewheelForceToAxis: false,
            mousewheelSensitivity: 1,
            mousewheelEventsTarged: 'container',
            // Hash Navigation
            hashnav: false,
            hashnavWatchState: false,
            // History
            history: false,
            // Commong Nav State
            replaceState: false,
            // Breakpoints
            breakpoints: undefined,
            // Slides grid
            spaceBetween: 0,
            slidesPerView: 1,
            slidesPerColumn: 1,
            slidesPerColumnFill: 'column',
            slidesPerGroup: 1,
            centeredSlides: false,
            slidesOffsetBefore: 0, // in px
            slidesOffsetAfter: 0, // in px
            // Round length
            roundLengths: false,
            // Touches
            touchRatio: 1,
            touchAngle: 45,
            simulateTouch: true,
            shortSwipes: true,
            longSwipes: true,
            longSwipesRatio: 0.5,
            longSwipesMs: 300,
            followFinger: true,
            onlyExternal: false,
            threshold: 0,
            touchMoveStopPropagation: true,
            touchReleaseOnEdges: false,
            // Unique Navigation Elements
            uniqueNavElements: true,
            // Pagination
            pagination: null,
            paginationElement: 'span',
            paginationClickable: false,
            paginationHide: false,
            paginationBulletRender: null,
            paginationProgressRender: null,
            paginationFractionRender: null,
            paginationCustomRender: null,
            paginationType: 'bullets', // 'bullets' or 'progress' or 'fraction' or 'custom'
            // Resistance
            resistance: true,
            resistanceRatio: 0.85,
            // Next/prev buttons
            nextButton: null,
            prevButton: null,
            // Progress
            watchSlidesProgress: false,
            watchSlidesVisibility: false,
            // Cursor
            grabCursor: false,
            // Clicks
            preventClicks: true,
            preventClicksPropagation: true,
            slideToClickedSlide: false,
            // Lazy Loading
            lazyLoading: false,
            lazyLoadingInPrevNext: false,
            lazyLoadingInPrevNextAmount: 1,
            lazyLoadingOnTransitionStart: false,
            // Images
            preloadImages: true,
            updateOnImagesReady: true,
            // loop
            loop: false,
            loopAdditionalSlides: 0,
            loopedSlides: null,
            // Control
            control: undefined,
            controlInverse: false,
            controlBy: 'slide', //or 'container'
            normalizeSlideIndex: true,
            // Swiping/no swiping
            allowSwipeToPrev: true,
            allowSwipeToNext: true,
            swipeHandler: null, //'.swipe-handler',
            noSwiping: true,
            noSwipingClass: 'swiper-no-swiping',
            // Passive Listeners
            passiveListeners: true,
            // NS
            containerModifierClass: 'swiper-container-', // NEW
            slideClass: 'swiper-slide',
            slideActiveClass: 'swiper-slide-active',
            slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
            slideVisibleClass: 'swiper-slide-visible',
            slideDuplicateClass: 'swiper-slide-duplicate',
            slideNextClass: 'swiper-slide-next',
            slideDuplicateNextClass: 'swiper-slide-duplicate-next',
            slidePrevClass: 'swiper-slide-prev',
            slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
            wrapperClass: 'swiper-wrapper',
            bulletClass: 'swiper-pagination-bullet',
            bulletActiveClass: 'swiper-pagination-bullet-active',
            buttonDisabledClass: 'swiper-button-disabled',
            paginationCurrentClass: 'swiper-pagination-current',
            paginationTotalClass: 'swiper-pagination-total',
            paginationHiddenClass: 'swiper-pagination-hidden',
            paginationProgressbarClass: 'swiper-pagination-progressbar',
            paginationClickableClass: 'swiper-pagination-clickable', // NEW
            paginationModifierClass: 'swiper-pagination-', // NEW
            lazyLoadingClass: 'swiper-lazy',
            lazyStatusLoadingClass: 'swiper-lazy-loading',
            lazyStatusLoadedClass: 'swiper-lazy-loaded',
            lazyPreloaderClass: 'swiper-lazy-preloader',
            notificationClass: 'swiper-notification',
            preloaderClass: 'preloader',
            zoomContainerClass: 'swiper-zoom-container',
        
            // Observer
            observer: false,
            observeParents: false,
            // Accessibility
            a11y: false,
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            // Callbacks
            runCallbacksOnInit: true
            /*
            Callbacks:
            onInit: function (swiper)
            onDestroy: function (swiper)
            onBeforeResize: function (swiper)
            onAfterResize: function (swiper)
            onClick: function (swiper, e)
            onTap: function (swiper, e)
            onDoubleTap: function (swiper, e)
            onSliderMove: function (swiper, e)
            onSlideChangeStart: function (swiper)
            onSlideChangeEnd: function (swiper)
            onTransitionStart: function (swiper)
            onTransitionEnd: function (swiper)
            onImagesReady: function (swiper)
            onProgress: function (swiper, progress)
            onTouchStart: function (swiper, e)
            onTouchMove: function (swiper, e)
            onTouchMoveOpposite: function (swiper, e)
            onTouchEnd: function (swiper, e)
            onReachBeginning: function (swiper)
            onReachEnd: function (swiper)
            onSetTransition: function (swiper, duration)
            onSetTranslate: function (swiper, translate)
            onAutoplayStart: function (swiper)
            onAutoplayStop: function (swiper),
            onLazyImageLoad: function (swiper, slide, image)
            onLazyImageReady: function (swiper, slide, image)
            onKeyPress: function (swiper, keyCode)
            */
        
        };
        var initialVirtualTranslate = params && params.virtualTranslate;
        
        params = params || {};
        var originalParams = {};
        for (var param in params) {
            if (typeof params[param] === 'object' && params[param] !== null && !(params[param].nodeType || params[param] === window || params[param] === document || (typeof Dom7 !== 'undefined' && params[param] instanceof Dom7) || (typeof jQuery !== 'undefined' && params[param] instanceof jQuery))) {
                originalParams[param] = {};
                for (var deepParam in params[param]) {
                    originalParams[param][deepParam] = params[param][deepParam];
                }
            }
            else {
                originalParams[param] = params[param];
            }
        }
        for (var def in defaults) {
            if (typeof params[def] === 'undefined') {
                params[def] = defaults[def];
            }
            else if (typeof params[def] === 'object') {
                for (var deepDef in defaults[def]) {
                    if (typeof params[def][deepDef] === 'undefined') {
                        params[def][deepDef] = defaults[def][deepDef];
                    }
                }
            }
        }
        
        // Swiper
        var s = this;
        
        // Params
        s.params = params;
        s.originalParams = originalParams;
        
        // Classname
        s.classNames = [];
        /*=========================
          Dom Library and plugins
          ===========================*/
        if (typeof $ !== 'undefined' && typeof Dom7 !== 'undefined'){
            $ = Dom7;
        }
        if (typeof $ === 'undefined') {
            if (typeof Dom7 === 'undefined') {
                $ = window.Dom7 || window.Zepto || window.jQuery;
            }
            else {
                $ = Dom7;
            }
            if (!$) return;
        }
        // Export it to Swiper instance
        s.$ = $;
        
        /*=========================
          Breakpoints
          ===========================*/
        s.currentBreakpoint = undefined;
        s.getActiveBreakpoint = function () {
            //Get breakpoint for window width
            if (!s.params.breakpoints) return false;
            var breakpoint = false;
            var points = [], point;
            for ( point in s.params.breakpoints ) {
                if (s.params.breakpoints.hasOwnProperty(point)) {
                    points.push(point);
                }
            }
            points.sort(function (a, b) {
                return parseInt(a, 10) > parseInt(b, 10);
            });
            for (var i = 0; i < points.length; i++) {
                point = points[i];
                if (point >= window.innerWidth && !breakpoint) {
                    breakpoint = point;
                }
            }
            return breakpoint || 'max';
        };
        s.setBreakpoint = function () {
            //Set breakpoint for window width and update parameters
            var breakpoint = s.getActiveBreakpoint();
            if (breakpoint && s.currentBreakpoint !== breakpoint) {
                var breakPointsParams = breakpoint in s.params.breakpoints ? s.params.breakpoints[breakpoint] : s.originalParams;
                var needsReLoop = s.params.loop && (breakPointsParams.slidesPerView !== s.params.slidesPerView);
                for ( var param in breakPointsParams ) {
                    s.params[param] = breakPointsParams[param];
                }
                s.currentBreakpoint = breakpoint;
                if(needsReLoop && s.destroyLoop) {
                    s.reLoop(true);
                }
            }
        };
        // Set breakpoint on load
        if (s.params.breakpoints) {
            s.setBreakpoint();
        }
        
        /*=========================
          Preparation - Define Container, Wrapper and Pagination
          ===========================*/
        s.container = $(container);
        if (s.container.length === 0) return;
        if (s.container.length > 1) {
            var swipers = [];
            s.container.each(function () {
                var container = this;
                swipers.push(new Swiper(this, params));
            });
            return swipers;
        }
        
        // Save instance in container HTML Element and in data
        s.container[0].swiper = s;
        s.container.data('swiper', s);
        
        s.classNames.push(s.params.containerModifierClass + s.params.direction);
        
        if (s.params.freeMode) {
            s.classNames.push(s.params.containerModifierClass + 'free-mode');
        }
        if (!s.support.flexbox) {
            s.classNames.push(s.params.containerModifierClass + 'no-flexbox');
            s.params.slidesPerColumn = 1;
        }
        if (s.params.autoHeight) {
            s.classNames.push(s.params.containerModifierClass + 'autoheight');
        }
        // Enable slides progress when required
        if (s.params.parallax || s.params.watchSlidesVisibility) {
            s.params.watchSlidesProgress = true;
        }
        // Max resistance when touchReleaseOnEdges
        if (s.params.touchReleaseOnEdges) {
            s.params.resistanceRatio = 0;
        }
        // Coverflow / 3D
        if (['cube', 'coverflow', 'flip'].indexOf(s.params.effect) >= 0) {
            if (s.support.transforms3d) {
                s.params.watchSlidesProgress = true;
                s.classNames.push(s.params.containerModifierClass + '3d');
            }
            else {
                s.params.effect = 'slide';
            }
        }
        if (s.params.effect !== 'slide') {
            s.classNames.push(s.params.containerModifierClass + s.params.effect);
        }
        if (s.params.effect === 'cube') {
            s.params.resistanceRatio = 0;
            s.params.slidesPerView = 1;
            s.params.slidesPerColumn = 1;
            s.params.slidesPerGroup = 1;
            s.params.centeredSlides = false;
            s.params.spaceBetween = 0;
            s.params.virtualTranslate = true;
        }
        if (s.params.effect === 'fade' || s.params.effect === 'flip') {
            s.params.slidesPerView = 1;
            s.params.slidesPerColumn = 1;
            s.params.slidesPerGroup = 1;
            s.params.watchSlidesProgress = true;
            s.params.spaceBetween = 0;
            if (typeof initialVirtualTranslate === 'undefined') {
                s.params.virtualTranslate = true;
            }
        }
        
        // Grab Cursor
        if (s.params.grabCursor && s.support.touch) {
            s.params.grabCursor = false;
        }
        
        // Wrapper
        s.wrapper = s.container.children('.' + s.params.wrapperClass);
        
        // Pagination
        if (s.params.pagination) {
            s.paginationContainer = $(s.params.pagination);
            if (s.params.uniqueNavElements && typeof s.params.pagination === 'string' && s.paginationContainer.length > 1 && s.container.find(s.params.pagination).length === 1) {
                s.paginationContainer = s.container.find(s.params.pagination);
            }
        
            if (s.params.paginationType === 'bullets' && s.params.paginationClickable) {
                s.paginationContainer.addClass(s.params.paginationModifierClass + 'clickable');
            }
            else {
                s.params.paginationClickable = false;
            }
            s.paginationContainer.addClass(s.params.paginationModifierClass + s.params.paginationType);
        }
        // Next/Prev Buttons
        if (s.params.nextButton || s.params.prevButton) {
            if (s.params.nextButton) {
                s.nextButton = $(s.params.nextButton);
                if (s.params.uniqueNavElements && typeof s.params.nextButton === 'string' && s.nextButton.length > 1 && s.container.find(s.params.nextButton).length === 1) {
                    s.nextButton = s.container.find(s.params.nextButton);
                }
            }
            if (s.params.prevButton) {
                s.prevButton = $(s.params.prevButton);
                if (s.params.uniqueNavElements && typeof s.params.prevButton === 'string' && s.prevButton.length > 1 && s.container.find(s.params.prevButton).length === 1) {
                    s.prevButton = s.container.find(s.params.prevButton);
                }
            }
        }
        
        // Is Horizontal
        s.isHorizontal = function () {
            return s.params.direction === 'horizontal';
        };
        // s.isH = isH;
        
        // RTL
        s.rtl = s.isHorizontal() && (s.container[0].dir.toLowerCase() === 'rtl' || s.container.css('direction') === 'rtl');
        if (s.rtl) {
            s.classNames.push(s.params.containerModifierClass + 'rtl');
        }
        
        // Wrong RTL support
        if (s.rtl) {
            s.wrongRTL = s.wrapper.css('display') === '-webkit-box';
        }
        
        // Columns
        if (s.params.slidesPerColumn > 1) {
            s.classNames.push(s.params.containerModifierClass + 'multirow');
        }
        
        // Check for Android
        if (s.device.android) {
            s.classNames.push(s.params.containerModifierClass + 'android');
        }
        
        // Add classes
        s.container.addClass(s.classNames.join(' '));
        
        // Translate
        s.translate = 0;
        
        // Progress
        s.progress = 0;
        
        // Velocity
        s.velocity = 0;
        
        /*=========================
          Locks, unlocks
          ===========================*/
        s.lockSwipeToNext = function () {
            s.params.allowSwipeToNext = false;
            if (s.params.allowSwipeToPrev === false && s.params.grabCursor) {
                s.unsetGrabCursor();
            }
        };
        s.lockSwipeToPrev = function () {
            s.params.allowSwipeToPrev = false;
            if (s.params.allowSwipeToNext === false && s.params.grabCursor) {
                s.unsetGrabCursor();
            }
        };
        s.lockSwipes = function () {
            s.params.allowSwipeToNext = s.params.allowSwipeToPrev = false;
            if (s.params.grabCursor) s.unsetGrabCursor();
        };
        s.unlockSwipeToNext = function () {
            s.params.allowSwipeToNext = true;
            if (s.params.allowSwipeToPrev === true && s.params.grabCursor) {
                s.setGrabCursor();
            }
        };
        s.unlockSwipeToPrev = function () {
            s.params.allowSwipeToPrev = true;
            if (s.params.allowSwipeToNext === true && s.params.grabCursor) {
                s.setGrabCursor();
            }
        };
        s.unlockSwipes = function () {
            s.params.allowSwipeToNext = s.params.allowSwipeToPrev = true;
            if (s.params.grabCursor) s.setGrabCursor();
        };
        
        /*=========================
          Round helper
          ===========================*/
        function round(a) {
            return Math.floor(a);
        }
        /*=========================
          Set grab cursor
          ===========================*/
        s.setGrabCursor = function(moving) {
            s.container[0].style.cursor = 'move';
            s.container[0].style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
            s.container[0].style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
            s.container[0].style.cursor = moving ? 'grabbing': 'grab';
        };
        s.unsetGrabCursor = function () {
            s.container[0].style.cursor = '';
        };
        if (s.params.grabCursor) {
            s.setGrabCursor();
        }
        /*=========================
          Update on Images Ready
          ===========================*/
        s.imagesToLoad = [];
        s.imagesLoaded = 0;
        
        s.loadImage = function (imgElement, src, srcset, sizes, checkForComplete, callback) {
            var image;
            function onReady () {
                if (callback) callback();
            }
            if (!imgElement.complete || !checkForComplete) {
                if (src) {
                    image = new window.Image();
                    image.onload = onReady;
                    image.onerror = onReady;
                    if (sizes) {
                        image.sizes = sizes;
                    }
                    if (srcset) {
                        image.srcset = srcset;
                    }
                    if (src) {
                        image.src = src;
                    }
                } else {
                    onReady();
                }
        
            } else {//image already loaded...
                onReady();
            }
        };
        s.preloadImages = function () {
            s.imagesToLoad = s.container.find('img');
            function _onReady() {
                if (typeof s === 'undefined' || s === null || !s) return;
                if (s.imagesLoaded !== undefined) s.imagesLoaded++;
                if (s.imagesLoaded === s.imagesToLoad.length) {
                    if (s.params.updateOnImagesReady) s.update();
                    s.emit('onImagesReady', s);
                }
            }
            for (var i = 0; i < s.imagesToLoad.length; i++) {
                s.loadImage(s.imagesToLoad[i], (s.imagesToLoad[i].currentSrc || s.imagesToLoad[i].getAttribute('src')), (s.imagesToLoad[i].srcset || s.imagesToLoad[i].getAttribute('srcset')), s.imagesToLoad[i].sizes || s.imagesToLoad[i].getAttribute('sizes'), true, _onReady);
            }
        };
        
        /*=========================
          Autoplay
          ===========================*/
        s.autoplayTimeoutId = undefined;
        s.autoplaying = false;
        s.autoplayPaused = false;
        function autoplay() {
            var autoplayDelay = s.params.autoplay;
            var activeSlide = s.slides.eq(s.activeIndex);
            if (activeSlide.attr('data-swiper-autoplay')) {
                autoplayDelay = activeSlide.attr('data-swiper-autoplay') || s.params.autoplay;
            }
            s.autoplayTimeoutId = setTimeout(function () {
                if (s.params.loop) {
                    s.fixLoop();
                    s._slideNext();
                    s.emit('onAutoplay', s);
                }
                else {
                    if (!s.isEnd) {
                        s._slideNext();
                        s.emit('onAutoplay', s);
                    }
                    else {
                        if (!params.autoplayStopOnLast) {
                            s._slideTo(0);
                            s.emit('onAutoplay', s);
                        }
                        else {
                            s.stopAutoplay();
                        }
                    }
                }
            }, autoplayDelay);
        }
        s.startAutoplay = function () {
            if (typeof s.autoplayTimeoutId !== 'undefined') return false;
            if (!s.params.autoplay) return false;
            if (s.autoplaying) return false;
            s.autoplaying = true;
            s.emit('onAutoplayStart', s);
            autoplay();
        };
        s.stopAutoplay = function (internal) {
            if (!s.autoplayTimeoutId) return;
            if (s.autoplayTimeoutId) clearTimeout(s.autoplayTimeoutId);
            s.autoplaying = false;
            s.autoplayTimeoutId = undefined;
            s.emit('onAutoplayStop', s);
        };
        s.pauseAutoplay = function (speed) {
            if (s.autoplayPaused) return;
            if (s.autoplayTimeoutId) clearTimeout(s.autoplayTimeoutId);
            s.autoplayPaused = true;
            if (speed === 0) {
                s.autoplayPaused = false;
                autoplay();
            }
            else {
                s.wrapper.transitionEnd(function () {
                    if (!s) return;
                    s.autoplayPaused = false;
                    if (!s.autoplaying) {
                        s.stopAutoplay();
                    }
                    else {
                        autoplay();
                    }
                });
            }
        };
        /*=========================
          Min/Max Translate
          ===========================*/
        s.minTranslate = function () {
            return (-s.snapGrid[0]);
        };
        s.maxTranslate = function () {
            return (-s.snapGrid[s.snapGrid.length - 1]);
        };
        /*=========================
          Slider/slides sizes
          ===========================*/
        s.updateAutoHeight = function () {
            var activeSlides = [];
            var newHeight = 0;
            var i;
        
            // Find slides currently in view
            if(s.params.slidesPerView !== 'auto' && s.params.slidesPerView > 1) {
                for (i = 0; i < Math.ceil(s.params.slidesPerView); i++) {
                    var index = s.activeIndex + i;
                    if(index > s.slides.length) break;
                    activeSlides.push(s.slides.eq(index)[0]);
                }
            } else {
                activeSlides.push(s.slides.eq(s.activeIndex)[0]);
            }
        
            // Find new height from heighest slide in view
            for (i = 0; i < activeSlides.length; i++) {
                if (typeof activeSlides[i] !== 'undefined') {
                    var height = activeSlides[i].offsetHeight;
                    newHeight = height > newHeight ? height : newHeight;
                }
            }
        
            // Update Height
            if (newHeight) s.wrapper.css('height', newHeight + 'px');
        };
        s.updateContainerSize = function () {
            var width, height;
            if (typeof s.params.width !== 'undefined') {
                width = s.params.width;
            }
            else {
                width = s.container[0].clientWidth;
            }
            if (typeof s.params.height !== 'undefined') {
                height = s.params.height;
            }
            else {
                height = s.container[0].clientHeight;
            }
            if (width === 0 && s.isHorizontal() || height === 0 && !s.isHorizontal()) {
                return;
            }
        
            //Subtract paddings
            width = width - parseInt(s.container.css('padding-left'), 10) - parseInt(s.container.css('padding-right'), 10);
            height = height - parseInt(s.container.css('padding-top'), 10) - parseInt(s.container.css('padding-bottom'), 10);
        
            // Store values
            s.width = width;
            s.height = height;
            s.size = s.isHorizontal() ? s.width : s.height;
        };
        
        s.updateSlidesSize = function () {
            s.slides = s.wrapper.children('.' + s.params.slideClass);
            s.snapGrid = [];
            s.slidesGrid = [];
            s.slidesSizesGrid = [];
        
            var spaceBetween = s.params.spaceBetween,
                slidePosition = -s.params.slidesOffsetBefore,
                i,
                prevSlideSize = 0,
                index = 0;
            if (typeof s.size === 'undefined') return;
            if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
                spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * s.size;
            }
        
            s.virtualSize = -spaceBetween;
            // reset margins
            if (s.rtl) s.slides.css({marginLeft: '', marginTop: ''});
            else s.slides.css({marginRight: '', marginBottom: ''});
        
            var slidesNumberEvenToRows;
            if (s.params.slidesPerColumn > 1) {
                if (Math.floor(s.slides.length / s.params.slidesPerColumn) === s.slides.length / s.params.slidesPerColumn) {
                    slidesNumberEvenToRows = s.slides.length;
                }
                else {
                    slidesNumberEvenToRows = Math.ceil(s.slides.length / s.params.slidesPerColumn) * s.params.slidesPerColumn;
                }
                if (s.params.slidesPerView !== 'auto' && s.params.slidesPerColumnFill === 'row') {
                    slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, s.params.slidesPerView * s.params.slidesPerColumn);
                }
            }
        
            // Calc slides
            var slideSize;
            var slidesPerColumn = s.params.slidesPerColumn;
            var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
            var numFullColumns = slidesPerRow - (s.params.slidesPerColumn * slidesPerRow - s.slides.length);
            for (i = 0; i < s.slides.length; i++) {
                slideSize = 0;
                var slide = s.slides.eq(i);
                if (s.params.slidesPerColumn > 1) {
                    // Set slides order
                    var newSlideOrderIndex;
                    var column, row;
                    if (s.params.slidesPerColumnFill === 'column') {
                        column = Math.floor(i / slidesPerColumn);
                        row = i - column * slidesPerColumn;
                        if (column > numFullColumns || (column === numFullColumns && row === slidesPerColumn-1)) {
                            if (++row >= slidesPerColumn) {
                                row = 0;
                                column++;
                            }
                        }
                        newSlideOrderIndex = column + row * slidesNumberEvenToRows / slidesPerColumn;
                        slide
                            .css({
                                '-webkit-box-ordinal-group': newSlideOrderIndex,
                                '-moz-box-ordinal-group': newSlideOrderIndex,
                                '-ms-flex-order': newSlideOrderIndex,
                                '-webkit-order': newSlideOrderIndex,
                                'order': newSlideOrderIndex
                            });
                    }
                    else {
                        row = Math.floor(i / slidesPerRow);
                        column = i - row * slidesPerRow;
                    }
                    slide
                        .css(
                            'margin-' + (s.isHorizontal() ? 'top' : 'left'),
                            (row !== 0 && s.params.spaceBetween) && (s.params.spaceBetween + 'px')
                        )
                        .attr('data-swiper-column', column)
                        .attr('data-swiper-row', row);
        
                }
                if (slide.css('display') === 'none') continue;
                if (s.params.slidesPerView === 'auto') {
                    slideSize = s.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
                    if (s.params.roundLengths) slideSize = round(slideSize);
                }
                else {
                    slideSize = (s.size - (s.params.slidesPerView - 1) * spaceBetween) / s.params.slidesPerView;
                    if (s.params.roundLengths) slideSize = round(slideSize);
        
                    if (s.isHorizontal()) {
                        s.slides[i].style.width = slideSize + 'px';
                    }
                    else {
                        s.slides[i].style.height = slideSize + 'px';
                    }
                }
                s.slides[i].swiperSlideSize = slideSize;
                s.slidesSizesGrid.push(slideSize);
        
        
                if (s.params.centeredSlides) {
                    slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
                    if(prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - s.size / 2 - spaceBetween;
                    if (i === 0) slidePosition = slidePosition - s.size / 2 - spaceBetween;
                    if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
                    if ((index) % s.params.slidesPerGroup === 0) s.snapGrid.push(slidePosition);
                    s.slidesGrid.push(slidePosition);
                }
                else {
                    if ((index) % s.params.slidesPerGroup === 0) s.snapGrid.push(slidePosition);
                    s.slidesGrid.push(slidePosition);
                    slidePosition = slidePosition + slideSize + spaceBetween;
                }
        
                s.virtualSize += slideSize + spaceBetween;
        
                prevSlideSize = slideSize;
        
                index ++;
            }
            s.virtualSize = Math.max(s.virtualSize, s.size) + s.params.slidesOffsetAfter;
            var newSlidesGrid;
        
            if (
                s.rtl && s.wrongRTL && (s.params.effect === 'slide' || s.params.effect === 'coverflow')) {
                s.wrapper.css({width: s.virtualSize + s.params.spaceBetween + 'px'});
            }
            if (!s.support.flexbox || s.params.setWrapperSize) {
                if (s.isHorizontal()) s.wrapper.css({width: s.virtualSize + s.params.spaceBetween + 'px'});
                else s.wrapper.css({height: s.virtualSize + s.params.spaceBetween + 'px'});
            }
        
            if (s.params.slidesPerColumn > 1) {
                s.virtualSize = (slideSize + s.params.spaceBetween) * slidesNumberEvenToRows;
                s.virtualSize = Math.ceil(s.virtualSize / s.params.slidesPerColumn) - s.params.spaceBetween;
                if (s.isHorizontal()) s.wrapper.css({width: s.virtualSize + s.params.spaceBetween + 'px'});
                else s.wrapper.css({height: s.virtualSize + s.params.spaceBetween + 'px'});
                if (s.params.centeredSlides) {
                    newSlidesGrid = [];
                    for (i = 0; i < s.snapGrid.length; i++) {
                        if (s.snapGrid[i] < s.virtualSize + s.snapGrid[0]) newSlidesGrid.push(s.snapGrid[i]);
                    }
                    s.snapGrid = newSlidesGrid;
                }
            }
        
            // Remove last grid elements depending on width
            if (!s.params.centeredSlides) {
                newSlidesGrid = [];
                for (i = 0; i < s.snapGrid.length; i++) {
                    if (s.snapGrid[i] <= s.virtualSize - s.size) {
                        newSlidesGrid.push(s.snapGrid[i]);
                    }
                }
                s.snapGrid = newSlidesGrid;
                if (Math.floor(s.virtualSize - s.size) - Math.floor(s.snapGrid[s.snapGrid.length - 1]) > 1) {
                    s.snapGrid.push(s.virtualSize - s.size);
                }
            }
            if (s.snapGrid.length === 0) s.snapGrid = [0];
        
            if (s.params.spaceBetween !== 0) {
                if (s.isHorizontal()) {
                    if (s.rtl) s.slides.css({marginLeft: spaceBetween + 'px'});
                    else s.slides.css({marginRight: spaceBetween + 'px'});
                }
                else s.slides.css({marginBottom: spaceBetween + 'px'});
            }
            if (s.params.watchSlidesProgress) {
                s.updateSlidesOffset();
            }
        };
        s.updateSlidesOffset = function () {
            for (var i = 0; i < s.slides.length; i++) {
                s.slides[i].swiperSlideOffset = s.isHorizontal() ? s.slides[i].offsetLeft : s.slides[i].offsetTop;
            }
        };
        
        /*=========================
          Dynamic Slides Per View
          ===========================*/
        s.currentSlidesPerView = function () {
            var spv = 1, i, j;
            if (s.params.centeredSlides) {
                var size = s.slides[s.activeIndex].swiperSlideSize;
                var breakLoop;
                for (i = s.activeIndex + 1; i < s.slides.length; i++) {
                    if (s.slides[i] && !breakLoop) {
                        size += s.slides[i].swiperSlideSize;
                        spv ++;
                        if (size > s.size) breakLoop = true;
                    }
                }
                for (j = s.activeIndex - 1; j >= 0; j--) {
                    if (s.slides[j] && !breakLoop) {
                        size += s.slides[j].swiperSlideSize;
                        spv ++;
                        if (size > s.size) breakLoop = true;
                    }
                }
            }
            else {
                for (i = s.activeIndex + 1; i < s.slides.length; i++) {
                    if (s.slidesGrid[i] - s.slidesGrid[s.activeIndex] < s.size) {
                        spv++;
                    }
                }
            }
            return spv;
        };
        /*=========================
          Slider/slides progress
          ===========================*/
        s.updateSlidesProgress = function (translate) {
            if (typeof translate === 'undefined') {
                translate = s.translate || 0;
            }
            if (s.slides.length === 0) return;
            if (typeof s.slides[0].swiperSlideOffset === 'undefined') s.updateSlidesOffset();
        
            var offsetCenter = -translate;
            if (s.rtl) offsetCenter = translate;
        
            // Visible Slides
            s.slides.removeClass(s.params.slideVisibleClass);
            for (var i = 0; i < s.slides.length; i++) {
                var slide = s.slides[i];
                var slideProgress = (offsetCenter + (s.params.centeredSlides ? s.minTranslate() : 0) - slide.swiperSlideOffset) / (slide.swiperSlideSize + s.params.spaceBetween);
                if (s.params.watchSlidesVisibility) {
                    var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
                    var slideAfter = slideBefore + s.slidesSizesGrid[i];
                    var isVisible =
                        (slideBefore >= 0 && slideBefore < s.size) ||
                        (slideAfter > 0 && slideAfter <= s.size) ||
                        (slideBefore <= 0 && slideAfter >= s.size);
                    if (isVisible) {
                        s.slides.eq(i).addClass(s.params.slideVisibleClass);
                    }
                }
                slide.progress = s.rtl ? -slideProgress : slideProgress;
            }
        };
        s.updateProgress = function (translate) {
            if (typeof translate === 'undefined') {
                translate = s.translate || 0;
            }
            var translatesDiff = s.maxTranslate() - s.minTranslate();
            var wasBeginning = s.isBeginning;
            var wasEnd = s.isEnd;
            if (translatesDiff === 0) {
                s.progress = 0;
                s.isBeginning = s.isEnd = true;
            }
            else {
                s.progress = (translate - s.minTranslate()) / (translatesDiff);
                s.isBeginning = s.progress <= 0;
                s.isEnd = s.progress >= 1;
            }
            if (s.isBeginning && !wasBeginning) s.emit('onReachBeginning', s);
            if (s.isEnd && !wasEnd) s.emit('onReachEnd', s);
        
            if (s.params.watchSlidesProgress) s.updateSlidesProgress(translate);
            s.emit('onProgress', s, s.progress);
        };
        s.updateActiveIndex = function () {
            var translate = s.rtl ? s.translate : -s.translate;
            var newActiveIndex, i, snapIndex;
            for (i = 0; i < s.slidesGrid.length; i ++) {
                if (typeof s.slidesGrid[i + 1] !== 'undefined') {
                    if (translate >= s.slidesGrid[i] && translate < s.slidesGrid[i + 1] - (s.slidesGrid[i + 1] - s.slidesGrid[i]) / 2) {
                        newActiveIndex = i;
                    }
                    else if (translate >= s.slidesGrid[i] && translate < s.slidesGrid[i + 1]) {
                        newActiveIndex = i + 1;
                    }
                }
                else {
                    if (translate >= s.slidesGrid[i]) {
                        newActiveIndex = i;
                    }
                }
            }
            // Normalize slideIndex
            if(s.params.normalizeSlideIndex){
                if (newActiveIndex < 0 || typeof newActiveIndex === 'undefined') newActiveIndex = 0;
            }
            // for (i = 0; i < s.slidesGrid.length; i++) {
                // if (- translate >= s.slidesGrid[i]) {
                    // newActiveIndex = i;
                // }
            // }
            snapIndex = Math.floor(newActiveIndex / s.params.slidesPerGroup);
            if (snapIndex >= s.snapGrid.length) snapIndex = s.snapGrid.length - 1;
        
            if (newActiveIndex === s.activeIndex) {
                return;
            }
            s.snapIndex = snapIndex;
            s.previousIndex = s.activeIndex;
            s.activeIndex = newActiveIndex;
            s.updateClasses();
            s.updateRealIndex();
        };
        s.updateRealIndex = function(){
            s.realIndex = parseInt(s.slides.eq(s.activeIndex).attr('data-swiper-slide-index') || s.activeIndex, 10);
        };
        
        /*=========================
          Classes
          ===========================*/
        s.updateClasses = function () {
            s.slides.removeClass(s.params.slideActiveClass + ' ' + s.params.slideNextClass + ' ' + s.params.slidePrevClass + ' ' + s.params.slideDuplicateActiveClass + ' ' + s.params.slideDuplicateNextClass + ' ' + s.params.slideDuplicatePrevClass);
            var activeSlide = s.slides.eq(s.activeIndex);
            // Active classes
            activeSlide.addClass(s.params.slideActiveClass);
            if (params.loop) {
                // Duplicate to all looped slides
                if (activeSlide.hasClass(s.params.slideDuplicateClass)) {
                    s.wrapper.children('.' + s.params.slideClass + ':not(.' + s.params.slideDuplicateClass + ')[data-swiper-slide-index="' + s.realIndex + '"]').addClass(s.params.slideDuplicateActiveClass);
                }
                else {
                    s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass + '[data-swiper-slide-index="' + s.realIndex + '"]').addClass(s.params.slideDuplicateActiveClass);
                }
            }
            // Next Slide
            var nextSlide = activeSlide.next('.' + s.params.slideClass).addClass(s.params.slideNextClass);
            if (s.params.loop && nextSlide.length === 0) {
                nextSlide = s.slides.eq(0);
                nextSlide.addClass(s.params.slideNextClass);
            }
            // Prev Slide
            var prevSlide = activeSlide.prev('.' + s.params.slideClass).addClass(s.params.slidePrevClass);
            if (s.params.loop && prevSlide.length === 0) {
                prevSlide = s.slides.eq(-1);
                prevSlide.addClass(s.params.slidePrevClass);
            }
            if (params.loop) {
                // Duplicate to all looped slides
                if (nextSlide.hasClass(s.params.slideDuplicateClass)) {
                    s.wrapper.children('.' + s.params.slideClass + ':not(.' + s.params.slideDuplicateClass + ')[data-swiper-slide-index="' + nextSlide.attr('data-swiper-slide-index') + '"]').addClass(s.params.slideDuplicateNextClass);
                }
                else {
                    s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass + '[data-swiper-slide-index="' + nextSlide.attr('data-swiper-slide-index') + '"]').addClass(s.params.slideDuplicateNextClass);
                }
                if (prevSlide.hasClass(s.params.slideDuplicateClass)) {
                    s.wrapper.children('.' + s.params.slideClass + ':not(.' + s.params.slideDuplicateClass + ')[data-swiper-slide-index="' + prevSlide.attr('data-swiper-slide-index') + '"]').addClass(s.params.slideDuplicatePrevClass);
                }
                else {
                    s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass + '[data-swiper-slide-index="' + prevSlide.attr('data-swiper-slide-index') + '"]').addClass(s.params.slideDuplicatePrevClass);
                }
            }
        
            // Pagination
            if (s.paginationContainer && s.paginationContainer.length > 0) {
                // Current/Total
                var current,
                    total = s.params.loop ? Math.ceil((s.slides.length - s.loopedSlides * 2) / s.params.slidesPerGroup) : s.snapGrid.length;
                if (s.params.loop) {
                    current = Math.ceil((s.activeIndex - s.loopedSlides)/s.params.slidesPerGroup);
                    if (current > s.slides.length - 1 - s.loopedSlides * 2) {
                        current = current - (s.slides.length - s.loopedSlides * 2);
                    }
                    if (current > total - 1) current = current - total;
                    if (current < 0 && s.params.paginationType !== 'bullets') current = total + current;
                }
                else {
                    if (typeof s.snapIndex !== 'undefined') {
                        current = s.snapIndex;
                    }
                    else {
                        current = s.activeIndex || 0;
                    }
                }
                // Types
                if (s.params.paginationType === 'bullets' && s.bullets && s.bullets.length > 0) {
                    s.bullets.removeClass(s.params.bulletActiveClass);
                    if (s.paginationContainer.length > 1) {
                        s.bullets.each(function () {
                            if ($(this).index() === current) $(this).addClass(s.params.bulletActiveClass);
                        });
                    }
                    else {
                        s.bullets.eq(current).addClass(s.params.bulletActiveClass);
                    }
                }
                if (s.params.paginationType === 'fraction') {
                    s.paginationContainer.find('.' + s.params.paginationCurrentClass).text(current + 1);
                    s.paginationContainer.find('.' + s.params.paginationTotalClass).text(total);
                }
                if (s.params.paginationType === 'progress') {
                    var scale = (current + 1) / total,
                        scaleX = scale,
                        scaleY = 1;
                    if (!s.isHorizontal()) {
                        scaleY = scale;
                        scaleX = 1;
                    }
                    s.paginationContainer.find('.' + s.params.paginationProgressbarClass).transform('translate3d(0,0,0) scaleX(' + scaleX + ') scaleY(' + scaleY + ')').transition(s.params.speed);
                }
                if (s.params.paginationType === 'custom' && s.params.paginationCustomRender) {
                    s.paginationContainer.html(s.params.paginationCustomRender(s, current + 1, total));
                    s.emit('onPaginationRendered', s, s.paginationContainer[0]);
                }
            }
        
            // Next/active buttons
            if (!s.params.loop) {
                if (s.params.prevButton && s.prevButton && s.prevButton.length > 0) {
                    if (s.isBeginning) {
                        s.prevButton.addClass(s.params.buttonDisabledClass);
                        if (s.params.a11y && s.a11y) s.a11y.disable(s.prevButton);
                    }
                    else {
                        s.prevButton.removeClass(s.params.buttonDisabledClass);
                        if (s.params.a11y && s.a11y) s.a11y.enable(s.prevButton);
                    }
                }
                if (s.params.nextButton && s.nextButton && s.nextButton.length > 0) {
                    if (s.isEnd) {
                        s.nextButton.addClass(s.params.buttonDisabledClass);
                        if (s.params.a11y && s.a11y) s.a11y.disable(s.nextButton);
                    }
                    else {
                        s.nextButton.removeClass(s.params.buttonDisabledClass);
                        if (s.params.a11y && s.a11y) s.a11y.enable(s.nextButton);
                    }
                }
            }
        };
        
        /*=========================
          Pagination
          ===========================*/
        s.updatePagination = function () {
            if (!s.params.pagination) return;
            if (s.paginationContainer && s.paginationContainer.length > 0) {
                var paginationHTML = '';
                if (s.params.paginationType === 'bullets') {
                    var numberOfBullets = s.params.loop ? Math.ceil((s.slides.length - s.loopedSlides * 2) / s.params.slidesPerGroup) : s.snapGrid.length;
                    for (var i = 0; i < numberOfBullets; i++) {
                        if (s.params.paginationBulletRender) {
                            paginationHTML += s.params.paginationBulletRender(s, i, s.params.bulletClass);
                        }
                        else {
                            paginationHTML += '<' + s.params.paginationElement+' class="' + s.params.bulletClass + '"></' + s.params.paginationElement + '>';
                        }
                    }
                    s.paginationContainer.html(paginationHTML);
                    s.bullets = s.paginationContainer.find('.' + s.params.bulletClass);
                    if (s.params.paginationClickable && s.params.a11y && s.a11y) {
                        s.a11y.initPagination();
                    }
                }
                if (s.params.paginationType === 'fraction') {
                    if (s.params.paginationFractionRender) {
                        paginationHTML = s.params.paginationFractionRender(s, s.params.paginationCurrentClass, s.params.paginationTotalClass);
                    }
                    else {
                        paginationHTML =
                            '<span class="' + s.params.paginationCurrentClass + '"></span>' +
                            ' / ' +
                            '<span class="' + s.params.paginationTotalClass+'"></span>';
                    }
                    s.paginationContainer.html(paginationHTML);
                }
                if (s.params.paginationType === 'progress') {
                    if (s.params.paginationProgressRender) {
                        paginationHTML = s.params.paginationProgressRender(s, s.params.paginationProgressbarClass);
                    }
                    else {
                        paginationHTML = '<span class="' + s.params.paginationProgressbarClass + '"></span>';
                    }
                    s.paginationContainer.html(paginationHTML);
                }
                if (s.params.paginationType !== 'custom') {
                    s.emit('onPaginationRendered', s, s.paginationContainer[0]);
                }
            }
        };
        /*=========================
          Common update method
          ===========================*/
        s.update = function (updateTranslate) {
            if (!s) return;
            s.updateContainerSize();
            s.updateSlidesSize();
            s.updateProgress();
            s.updatePagination();
            s.updateClasses();
            if (s.params.scrollbar && s.scrollbar) {
                s.scrollbar.set();
            }
            var newTranslate;
            function forceSetTranslate() {
                var translate = s.rtl ? -s.translate : s.translate;
                newTranslate = Math.min(Math.max(s.translate, s.maxTranslate()), s.minTranslate());
                s.setWrapperTranslate(newTranslate);
                s.updateActiveIndex();
                s.updateClasses();
            }
            if (updateTranslate) {
                var translated;
                if (s.controller && s.controller.spline) {
                    s.controller.spline = undefined;
                }
                if (s.params.freeMode) {
                    forceSetTranslate();
                    if (s.params.autoHeight) {
                        s.updateAutoHeight();
                    }
                }
                else {
                    if ((s.params.slidesPerView === 'auto' || s.params.slidesPerView > 1) && s.isEnd && !s.params.centeredSlides) {
                        translated = s.slideTo(s.slides.length - 1, 0, false, true);
                    }
                    else {
                        translated = s.slideTo(s.activeIndex, 0, false, true);
                    }
                    if (!translated) {
                        forceSetTranslate();
                    }
                }
            }
            else if (s.params.autoHeight) {
                s.updateAutoHeight();
            }
        };
        
        /*=========================
          Resize Handler
          ===========================*/
        s.onResize = function (forceUpdatePagination) {
            if (s.params.onBeforeResize) s.params.onBeforeResize(s);
            //Breakpoints
            if (s.params.breakpoints) {
                s.setBreakpoint();
            }
        
            // Disable locks on resize
            var allowSwipeToPrev = s.params.allowSwipeToPrev;
            var allowSwipeToNext = s.params.allowSwipeToNext;
            s.params.allowSwipeToPrev = s.params.allowSwipeToNext = true;
        
            s.updateContainerSize();
            s.updateSlidesSize();
            if (s.params.slidesPerView === 'auto' || s.params.freeMode || forceUpdatePagination) s.updatePagination();
            if (s.params.scrollbar && s.scrollbar) {
                s.scrollbar.set();
            }
            if (s.controller && s.controller.spline) {
                s.controller.spline = undefined;
            }
            var slideChangedBySlideTo = false;
            if (s.params.freeMode) {
                var newTranslate = Math.min(Math.max(s.translate, s.maxTranslate()), s.minTranslate());
                s.setWrapperTranslate(newTranslate);
                s.updateActiveIndex();
                s.updateClasses();
        
                if (s.params.autoHeight) {
                    s.updateAutoHeight();
                }
            }
            else {
                s.updateClasses();
                if ((s.params.slidesPerView === 'auto' || s.params.slidesPerView > 1) && s.isEnd && !s.params.centeredSlides) {
                    slideChangedBySlideTo = s.slideTo(s.slides.length - 1, 0, false, true);
                }
                else {
                    slideChangedBySlideTo = s.slideTo(s.activeIndex, 0, false, true);
                }
            }
            if (s.params.lazyLoading && !slideChangedBySlideTo && s.lazy) {
                s.lazy.load();
            }
            // Return locks after resize
            s.params.allowSwipeToPrev = allowSwipeToPrev;
            s.params.allowSwipeToNext = allowSwipeToNext;
            if (s.params.onAfterResize) s.params.onAfterResize(s);
        };
        
        /*=========================
          Events
          ===========================*/
        
        //Define Touch Events
        s.touchEventsDesktop = {start: 'mousedown', move: 'mousemove', end: 'mouseup'};
        if (window.navigator.pointerEnabled) s.touchEventsDesktop = {start: 'pointerdown', move: 'pointermove', end: 'pointerup'};
        else if (window.navigator.msPointerEnabled) s.touchEventsDesktop = {start: 'MSPointerDown', move: 'MSPointerMove', end: 'MSPointerUp'};
        s.touchEvents = {
            start : s.support.touch || !s.params.simulateTouch  ? 'touchstart' : s.touchEventsDesktop.start,
            move : s.support.touch || !s.params.simulateTouch ? 'touchmove' : s.touchEventsDesktop.move,
            end : s.support.touch || !s.params.simulateTouch ? 'touchend' : s.touchEventsDesktop.end
        };
        
        
        // WP8 Touch Events Fix
        if (window.navigator.pointerEnabled || window.navigator.msPointerEnabled) {
            (s.params.touchEventsTarget === 'container' ? s.container : s.wrapper).addClass('swiper-wp8-' + s.params.direction);
        }
        
        // Attach/detach events
        s.initEvents = function (detach) {
            var actionDom = detach ? 'off' : 'on';
            var action = detach ? 'removeEventListener' : 'addEventListener';
            var touchEventsTarget = s.params.touchEventsTarget === 'container' ? s.container[0] : s.wrapper[0];
            var target = s.support.touch ? touchEventsTarget : document;
        
            var moveCapture = s.params.nested ? true : false;
        
            //Touch Events
            if (s.browser.ie) {
                touchEventsTarget[action](s.touchEvents.start, s.onTouchStart, false);
                target[action](s.touchEvents.move, s.onTouchMove, moveCapture);
                target[action](s.touchEvents.end, s.onTouchEnd, false);
            }
            else {
                if (s.support.touch) {
                    var passiveListener = s.touchEvents.start === 'touchstart' && s.support.passiveListener && s.params.passiveListeners ? {passive: true, capture: false} : false;
                    touchEventsTarget[action](s.touchEvents.start, s.onTouchStart, passiveListener);
                    touchEventsTarget[action](s.touchEvents.move, s.onTouchMove, moveCapture);
                    touchEventsTarget[action](s.touchEvents.end, s.onTouchEnd, passiveListener);
                }
                if ((params.simulateTouch && !s.device.ios && !s.device.android) || (params.simulateTouch && !s.support.touch && s.device.ios)) {
                    touchEventsTarget[action]('mousedown', s.onTouchStart, false);
                    document[action]('mousemove', s.onTouchMove, moveCapture);
                    document[action]('mouseup', s.onTouchEnd, false);
                }
            }
            window[action]('resize', s.onResize);
        
            // Next, Prev, Index
            if (s.params.nextButton && s.nextButton && s.nextButton.length > 0) {
                s.nextButton[actionDom]('click', s.onClickNext);
                if (s.params.a11y && s.a11y) s.nextButton[actionDom]('keydown', s.a11y.onEnterKey);
            }
            if (s.params.prevButton && s.prevButton && s.prevButton.length > 0) {
                s.prevButton[actionDom]('click', s.onClickPrev);
                if (s.params.a11y && s.a11y) s.prevButton[actionDom]('keydown', s.a11y.onEnterKey);
            }
            if (s.params.pagination && s.params.paginationClickable) {
                s.paginationContainer[actionDom]('click', '.' + s.params.bulletClass, s.onClickIndex);
                if (s.params.a11y && s.a11y) s.paginationContainer[actionDom]('keydown', '.' + s.params.bulletClass, s.a11y.onEnterKey);
            }
        
            // Prevent Links Clicks
            if (s.params.preventClicks || s.params.preventClicksPropagation) touchEventsTarget[action]('click', s.preventClicks, true);
        };
        s.attachEvents = function () {
            s.initEvents();
        };
        s.detachEvents = function () {
            s.initEvents(true);
        };
        
        /*=========================
          Handle Clicks
          ===========================*/
        // Prevent Clicks
        s.allowClick = true;
        s.preventClicks = function (e) {
            if (!s.allowClick) {
                if (s.params.preventClicks) e.preventDefault();
                if (s.params.preventClicksPropagation && s.animating) {
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                }
            }
        };
        // Clicks
        s.onClickNext = function (e) {
            e.preventDefault();
            if (s.isEnd && !s.params.loop) return;
            s.slideNext();
        };
        s.onClickPrev = function (e) {
            e.preventDefault();
            if (s.isBeginning && !s.params.loop) return;
            s.slidePrev();
        };
        s.onClickIndex = function (e) {
            e.preventDefault();
            var index = $(this).index() * s.params.slidesPerGroup;
            if (s.params.loop) index = index + s.loopedSlides;
            s.slideTo(index);
        };
        
        /*=========================
          Handle Touches
          ===========================*/
        function findElementInEvent(e, selector) {
            var el = $(e.target);
            if (!el.is(selector)) {
                if (typeof selector === 'string') {
                    el = el.parents(selector);
                }
                else if (selector.nodeType) {
                    var found;
                    el.parents().each(function (index, _el) {
                        if (_el === selector) found = selector;
                    });
                    if (!found) return undefined;
                    else return selector;
                }
            }
            if (el.length === 0) {
                return undefined;
            }
            return el[0];
        }
        s.updateClickedSlide = function (e) {
            var slide = findElementInEvent(e, '.' + s.params.slideClass);
            var slideFound = false;
            if (slide) {
                for (var i = 0; i < s.slides.length; i++) {
                    if (s.slides[i] === slide) slideFound = true;
                }
            }
        
            if (slide && slideFound) {
                s.clickedSlide = slide;
                s.clickedIndex = $(slide).index();
            }
            else {
                s.clickedSlide = undefined;
                s.clickedIndex = undefined;
                return;
            }
            if (s.params.slideToClickedSlide && s.clickedIndex !== undefined && s.clickedIndex !== s.activeIndex) {
                var slideToIndex = s.clickedIndex,
                    realIndex,
                    duplicatedSlides,
                    slidesPerView = s.params.slidesPerView === 'auto' ? s.currentSlidesPerView() : s.params.slidesPerView;
                if (s.params.loop) {
                    if (s.animating) return;
                    realIndex = parseInt($(s.clickedSlide).attr('data-swiper-slide-index'), 10);
                    if (s.params.centeredSlides) {
                        if ((slideToIndex < s.loopedSlides - slidesPerView/2) || (slideToIndex > s.slides.length - s.loopedSlides + slidesPerView/2)) {
                            s.fixLoop();
                            slideToIndex = s.wrapper.children('.' + s.params.slideClass + '[data-swiper-slide-index="' + realIndex + '"]:not(.' + s.params.slideDuplicateClass + ')').eq(0).index();
                            setTimeout(function () {
                                s.slideTo(slideToIndex);
                            }, 0);
                        }
                        else {
                            s.slideTo(slideToIndex);
                        }
                    }
                    else {
                        if (slideToIndex > s.slides.length - slidesPerView) {
                            s.fixLoop();
                            slideToIndex = s.wrapper.children('.' + s.params.slideClass + '[data-swiper-slide-index="' + realIndex + '"]:not(.' + s.params.slideDuplicateClass + ')').eq(0).index();
                            setTimeout(function () {
                                s.slideTo(slideToIndex);
                            }, 0);
                        }
                        else {
                            s.slideTo(slideToIndex);
                        }
                    }
                }
                else {
                    s.slideTo(slideToIndex);
                }
            }
        };
        
        var isTouched,
            isMoved,
            allowTouchCallbacks,
            touchStartTime,
            isScrolling,
            currentTranslate,
            startTranslate,
            allowThresholdMove,
            // Form elements to match
            formElements = 'input, select, textarea, button, video',
            // Last click time
            lastClickTime = Date.now(), clickTimeout,
            //Velocities
            velocities = [],
            allowMomentumBounce;
        
        // Animating Flag
        s.animating = false;
        
        // Touches information
        s.touches = {
            startX: 0,
            startY: 0,
            currentX: 0,
            currentY: 0,
            diff: 0
        };
        
        // Touch handlers
        var isTouchEvent, startMoving;
        s.onTouchStart = function (e) {
            if (e.originalEvent) e = e.originalEvent;
            isTouchEvent = e.type === 'touchstart';
            if (!isTouchEvent && 'which' in e && e.which === 3) return;
            if (s.params.noSwiping && findElementInEvent(e, '.' + s.params.noSwipingClass)) {
                s.allowClick = true;
                return;
            }
            if (s.params.swipeHandler) {
                if (!findElementInEvent(e, s.params.swipeHandler)) return;
            }
        
            var startX = s.touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
            var startY = s.touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
        
            // Do NOT start if iOS edge swipe is detected. Otherwise iOS app (UIWebView) cannot swipe-to-go-back anymore
            if(s.device.ios && s.params.iOSEdgeSwipeDetection && startX <= s.params.iOSEdgeSwipeThreshold) {
                return;
            }
        
            isTouched = true;
            isMoved = false;
            allowTouchCallbacks = true;
            isScrolling = undefined;
            startMoving = undefined;
            s.touches.startX = startX;
            s.touches.startY = startY;
            touchStartTime = Date.now();
            s.allowClick = true;
            s.updateContainerSize();
            s.swipeDirection = undefined;
            if (s.params.threshold > 0) allowThresholdMove = false;
            if (e.type !== 'touchstart') {
                var preventDefault = true;
                if ($(e.target).is(formElements)) preventDefault = false;
                if (document.activeElement && $(document.activeElement).is(formElements)) {
                    document.activeElement.blur();
                }
                if (preventDefault) {
                    e.preventDefault();
                }
            }
            s.emit('onTouchStart', s, e);
        };
        
        s.onTouchMove = function (e) {
            if (e.originalEvent) e = e.originalEvent;
            if (isTouchEvent && e.type === 'mousemove') return;
            if (e.preventedByNestedSwiper) {
                s.touches.startX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
                s.touches.startY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
                return;
            }
            if (s.params.onlyExternal) {
                // isMoved = true;
                s.allowClick = false;
                if (isTouched) {
                    s.touches.startX = s.touches.currentX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
                    s.touches.startY = s.touches.currentY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
                    touchStartTime = Date.now();
                }
                return;
            }
            if (isTouchEvent && s.params.touchReleaseOnEdges && !s.params.loop) {
                if (!s.isHorizontal()) {
                    // Vertical
                    if (
                        (s.touches.currentY < s.touches.startY && s.translate <= s.maxTranslate()) ||
                        (s.touches.currentY > s.touches.startY && s.translate >= s.minTranslate())
                        ) {
                        return;
                    }
                }
                else {
                    if (
                        (s.touches.currentX < s.touches.startX && s.translate <= s.maxTranslate()) ||
                        (s.touches.currentX > s.touches.startX && s.translate >= s.minTranslate())
                        ) {
                        return;
                    }
                }
            }
            if (isTouchEvent && document.activeElement) {
                if (e.target === document.activeElement && $(e.target).is(formElements)) {
                    isMoved = true;
                    s.allowClick = false;
                    return;
                }
            }
            if (allowTouchCallbacks) {
                s.emit('onTouchMove', s, e);
            }
            if (e.targetTouches && e.targetTouches.length > 1) return;
        
            s.touches.currentX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
            s.touches.currentY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
        
            if (typeof isScrolling === 'undefined') {
                var touchAngle;
                if (s.isHorizontal() && s.touches.currentY === s.touches.startY || !s.isHorizontal() && s.touches.currentX === s.touches.startX) {
                    isScrolling = false;
                }
                else {
                    touchAngle = Math.atan2(Math.abs(s.touches.currentY - s.touches.startY), Math.abs(s.touches.currentX - s.touches.startX)) * 180 / Math.PI;
                    isScrolling = s.isHorizontal() ? touchAngle > s.params.touchAngle : (90 - touchAngle > s.params.touchAngle);
                }
            }
            if (isScrolling) {
                s.emit('onTouchMoveOpposite', s, e);
            }
            if (typeof startMoving === 'undefined') {
                if (s.touches.currentX !== s.touches.startX || s.touches.currentY !== s.touches.startY) {
                    startMoving = true;
                }
            }
            if (!isTouched) return;
            if (isScrolling)  {
                isTouched = false;
                return;
            }
            if (!startMoving) {
                return;
            }
            s.allowClick = false;
            s.emit('onSliderMove', s, e);
            e.preventDefault();
            if (s.params.touchMoveStopPropagation && !s.params.nested) {
                e.stopPropagation();
            }
        
            if (!isMoved) {
                if (params.loop) {
                    s.fixLoop();
                }
                startTranslate = s.getWrapperTranslate();
                s.setWrapperTransition(0);
                if (s.animating) {
                    s.wrapper.trigger('webkitTransitionEnd transitionend oTransitionEnd MSTransitionEnd msTransitionEnd');
                }
                if (s.params.autoplay && s.autoplaying) {
                    if (s.params.autoplayDisableOnInteraction) {
                        s.stopAutoplay();
                    }
                    else {
                        s.pauseAutoplay();
                    }
                }
                allowMomentumBounce = false;
                //Grab Cursor
                if (s.params.grabCursor && (s.params.allowSwipeToNext === true || s.params.allowSwipeToPrev === true)) {
                    s.setGrabCursor(true);
                }
            }
            isMoved = true;
        
            var diff = s.touches.diff = s.isHorizontal() ? s.touches.currentX - s.touches.startX : s.touches.currentY - s.touches.startY;
        
            diff = diff * s.params.touchRatio;
            if (s.rtl) diff = -diff;
        
            s.swipeDirection = diff > 0 ? 'prev' : 'next';
            currentTranslate = diff + startTranslate;
        
            var disableParentSwiper = true;
            if ((diff > 0 && currentTranslate > s.minTranslate())) {
                disableParentSwiper = false;
                if (s.params.resistance) currentTranslate = s.minTranslate() - 1 + Math.pow(-s.minTranslate() + startTranslate + diff, s.params.resistanceRatio);
            }
            else if (diff < 0 && currentTranslate < s.maxTranslate()) {
                disableParentSwiper = false;
                if (s.params.resistance) currentTranslate = s.maxTranslate() + 1 - Math.pow(s.maxTranslate() - startTranslate - diff, s.params.resistanceRatio);
            }
        
            if (disableParentSwiper) {
                e.preventedByNestedSwiper = true;
            }
        
            // Directions locks
            if (!s.params.allowSwipeToNext && s.swipeDirection === 'next' && currentTranslate < startTranslate) {
                currentTranslate = startTranslate;
            }
            if (!s.params.allowSwipeToPrev && s.swipeDirection === 'prev' && currentTranslate > startTranslate) {
                currentTranslate = startTranslate;
            }
        
        
            // Threshold
            if (s.params.threshold > 0) {
                if (Math.abs(diff) > s.params.threshold || allowThresholdMove) {
                    if (!allowThresholdMove) {
                        allowThresholdMove = true;
                        s.touches.startX = s.touches.currentX;
                        s.touches.startY = s.touches.currentY;
                        currentTranslate = startTranslate;
                        s.touches.diff = s.isHorizontal() ? s.touches.currentX - s.touches.startX : s.touches.currentY - s.touches.startY;
                        return;
                    }
                }
                else {
                    currentTranslate = startTranslate;
                    return;
                }
            }
        
            if (!s.params.followFinger) return;
        
            // Update active index in free mode
            if (s.params.freeMode || s.params.watchSlidesProgress) {
                s.updateActiveIndex();
            }
            if (s.params.freeMode) {
                //Velocity
                if (velocities.length === 0) {
                    velocities.push({
                        position: s.touches[s.isHorizontal() ? 'startX' : 'startY'],
                        time: touchStartTime
                    });
                }
                velocities.push({
                    position: s.touches[s.isHorizontal() ? 'currentX' : 'currentY'],
                    time: (new window.Date()).getTime()
                });
            }
            // Update progress
            s.updateProgress(currentTranslate);
            // Update translate
            s.setWrapperTranslate(currentTranslate);
        };
        s.onTouchEnd = function (e) {
            if (e.originalEvent) e = e.originalEvent;
            if (allowTouchCallbacks) {
                s.emit('onTouchEnd', s, e);
            }
            allowTouchCallbacks = false;
            if (!isTouched) return;
            //Return Grab Cursor
            if (s.params.grabCursor && isMoved && isTouched  && (s.params.allowSwipeToNext === true || s.params.allowSwipeToPrev === true)) {
                s.setGrabCursor(false);
            }
        
            // Time diff
            var touchEndTime = Date.now();
            var timeDiff = touchEndTime - touchStartTime;
        
            // Tap, doubleTap, Click
            if (s.allowClick) {
                s.updateClickedSlide(e);
                s.emit('onTap', s, e);
                if (timeDiff < 300 && (touchEndTime - lastClickTime) > 300) {
                    if (clickTimeout) clearTimeout(clickTimeout);
                    clickTimeout = setTimeout(function () {
                        if (!s) return;
                        if (s.params.paginationHide && s.paginationContainer.length > 0 && !$(e.target).hasClass(s.params.bulletClass)) {
                            s.paginationContainer.toggleClass(s.params.paginationHiddenClass);
                        }
                        s.emit('onClick', s, e);
                    }, 300);
        
                }
                if (timeDiff < 300 && (touchEndTime - lastClickTime) < 300) {
                    if (clickTimeout) clearTimeout(clickTimeout);
                    s.emit('onDoubleTap', s, e);
                }
            }
        
            lastClickTime = Date.now();
            setTimeout(function () {
                if (s) s.allowClick = true;
            }, 0);
        
            if (!isTouched || !isMoved || !s.swipeDirection || s.touches.diff === 0 || currentTranslate === startTranslate) {
                isTouched = isMoved = false;
                return;
            }
            isTouched = isMoved = false;
        
            var currentPos;
            if (s.params.followFinger) {
                currentPos = s.rtl ? s.translate : -s.translate;
            }
            else {
                currentPos = -currentTranslate;
            }
            if (s.params.freeMode) {
                if (currentPos < -s.minTranslate()) {
                    s.slideTo(s.activeIndex);
                    return;
                }
                else if (currentPos > -s.maxTranslate()) {
                    if (s.slides.length < s.snapGrid.length) {
                        s.slideTo(s.snapGrid.length - 1);
                    }
                    else {
                        s.slideTo(s.slides.length - 1);
                    }
                    return;
                }
        
                if (s.params.freeModeMomentum) {
                    if (velocities.length > 1) {
                        var lastMoveEvent = velocities.pop(), velocityEvent = velocities.pop();
        
                        var distance = lastMoveEvent.position - velocityEvent.position;
                        var time = lastMoveEvent.time - velocityEvent.time;
                        s.velocity = distance / time;
                        s.velocity = s.velocity / 2;
                        if (Math.abs(s.velocity) < s.params.freeModeMinimumVelocity) {
                            s.velocity = 0;
                        }
                        // this implies that the user stopped moving a finger then released.
                        // There would be no events with distance zero, so the last event is stale.
                        if (time > 150 || (new window.Date().getTime() - lastMoveEvent.time) > 300) {
                            s.velocity = 0;
                        }
                    } else {
                        s.velocity = 0;
                    }
                    s.velocity = s.velocity * s.params.freeModeMomentumVelocityRatio;
        
                    velocities.length = 0;
                    var momentumDuration = 1000 * s.params.freeModeMomentumRatio;
                    var momentumDistance = s.velocity * momentumDuration;
        
                    var newPosition = s.translate + momentumDistance;
                    if (s.rtl) newPosition = - newPosition;
                    var doBounce = false;
                    var afterBouncePosition;
                    var bounceAmount = Math.abs(s.velocity) * 20 * s.params.freeModeMomentumBounceRatio;
                    if (newPosition < s.maxTranslate()) {
                        if (s.params.freeModeMomentumBounce) {
                            if (newPosition + s.maxTranslate() < -bounceAmount) {
                                newPosition = s.maxTranslate() - bounceAmount;
                            }
                            afterBouncePosition = s.maxTranslate();
                            doBounce = true;
                            allowMomentumBounce = true;
                        }
                        else {
                            newPosition = s.maxTranslate();
                        }
                    }
                    else if (newPosition > s.minTranslate()) {
                        if (s.params.freeModeMomentumBounce) {
                            if (newPosition - s.minTranslate() > bounceAmount) {
                                newPosition = s.minTranslate() + bounceAmount;
                            }
                            afterBouncePosition = s.minTranslate();
                            doBounce = true;
                            allowMomentumBounce = true;
                        }
                        else {
                            newPosition = s.minTranslate();
                        }
                    }
                    else if (s.params.freeModeSticky) {
                        var j = 0,
                            nextSlide;
                        for (j = 0; j < s.snapGrid.length; j += 1) {
                            if (s.snapGrid[j] > -newPosition) {
                                nextSlide = j;
                                break;
                            }
        
                        }
                        if (Math.abs(s.snapGrid[nextSlide] - newPosition) < Math.abs(s.snapGrid[nextSlide - 1] - newPosition) || s.swipeDirection === 'next') {
                            newPosition = s.snapGrid[nextSlide];
                        } else {
                            newPosition = s.snapGrid[nextSlide - 1];
                        }
                        if (!s.rtl) newPosition = - newPosition;
                    }
                    //Fix duration
                    if (s.velocity !== 0) {
                        if (s.rtl) {
                            momentumDuration = Math.abs((-newPosition - s.translate) / s.velocity);
                        }
                        else {
                            momentumDuration = Math.abs((newPosition - s.translate) / s.velocity);
                        }
                    }
                    else if (s.params.freeModeSticky) {
                        s.slideReset();
                        return;
                    }
        
                    if (s.params.freeModeMomentumBounce && doBounce) {
                        s.updateProgress(afterBouncePosition);
                        s.setWrapperTransition(momentumDuration);
                        s.setWrapperTranslate(newPosition);
                        s.onTransitionStart();
                        s.animating = true;
                        s.wrapper.transitionEnd(function () {
                            if (!s || !allowMomentumBounce) return;
                            s.emit('onMomentumBounce', s);
        
                            s.setWrapperTransition(s.params.speed);
                            s.setWrapperTranslate(afterBouncePosition);
                            s.wrapper.transitionEnd(function () {
                                if (!s) return;
                                s.onTransitionEnd();
                            });
                        });
                    } else if (s.velocity) {
                        s.updateProgress(newPosition);
                        s.setWrapperTransition(momentumDuration);
                        s.setWrapperTranslate(newPosition);
                        s.onTransitionStart();
                        if (!s.animating) {
                            s.animating = true;
                            s.wrapper.transitionEnd(function () {
                                if (!s) return;
                                s.onTransitionEnd();
                            });
                        }
        
                    } else {
                        s.updateProgress(newPosition);
                    }
        
                    s.updateActiveIndex();
                }
                if (!s.params.freeModeMomentum || timeDiff >= s.params.longSwipesMs) {
                    s.updateProgress();
                    s.updateActiveIndex();
                }
                return;
            }
        
            // Find current slide
            var i, stopIndex = 0, groupSize = s.slidesSizesGrid[0];
            for (i = 0; i < s.slidesGrid.length; i += s.params.slidesPerGroup) {
                if (typeof s.slidesGrid[i + s.params.slidesPerGroup] !== 'undefined') {
                    if (currentPos >= s.slidesGrid[i] && currentPos < s.slidesGrid[i + s.params.slidesPerGroup]) {
                        stopIndex = i;
                        groupSize = s.slidesGrid[i + s.params.slidesPerGroup] - s.slidesGrid[i];
                    }
                }
                else {
                    if (currentPos >= s.slidesGrid[i]) {
                        stopIndex = i;
                        groupSize = s.slidesGrid[s.slidesGrid.length - 1] - s.slidesGrid[s.slidesGrid.length - 2];
                    }
                }
            }
        
            // Find current slide size
            var ratio = (currentPos - s.slidesGrid[stopIndex]) / groupSize;
        
            if (timeDiff > s.params.longSwipesMs) {
                // Long touches
                if (!s.params.longSwipes) {
                    s.slideTo(s.activeIndex);
                    return;
                }
                if (s.swipeDirection === 'next') {
                    if (ratio >= s.params.longSwipesRatio) s.slideTo(stopIndex + s.params.slidesPerGroup);
                    else s.slideTo(stopIndex);
        
                }
                if (s.swipeDirection === 'prev') {
                    if (ratio > (1 - s.params.longSwipesRatio)) s.slideTo(stopIndex + s.params.slidesPerGroup);
                    else s.slideTo(stopIndex);
                }
            }
            else {
                // Short swipes
                if (!s.params.shortSwipes) {
                    s.slideTo(s.activeIndex);
                    return;
                }
                if (s.swipeDirection === 'next') {
                    s.slideTo(stopIndex + s.params.slidesPerGroup);
        
                }
                if (s.swipeDirection === 'prev') {
                    s.slideTo(stopIndex);
                }
            }
        };
        /*=========================
          Transitions
          ===========================*/
        s._slideTo = function (slideIndex, speed) {
            return s.slideTo(slideIndex, speed, true, true);
        };
        s.slideTo = function (slideIndex, speed, runCallbacks, internal) {
            if (typeof runCallbacks === 'undefined') runCallbacks = true;
            if (typeof slideIndex === 'undefined') slideIndex = 0;
            if (slideIndex < 0) slideIndex = 0;
            s.snapIndex = Math.floor(slideIndex / s.params.slidesPerGroup);
            if (s.snapIndex >= s.snapGrid.length) s.snapIndex = s.snapGrid.length - 1;
        
            var translate = - s.snapGrid[s.snapIndex];
            // Stop autoplay
            if (s.params.autoplay && s.autoplaying) {
                if (internal || !s.params.autoplayDisableOnInteraction) {
                    s.pauseAutoplay(speed);
                }
                else {
                    s.stopAutoplay();
                }
            }
            // Update progress
            s.updateProgress(translate);
        
            // Normalize slideIndex
            if(s.params.normalizeSlideIndex){
                for (var i = 0; i < s.slidesGrid.length; i++) {
                    if (- Math.floor(translate * 100) >= Math.floor(s.slidesGrid[i] * 100)) {
                        slideIndex = i;
                    }
                }
            }
        
            // Directions locks
            if (!s.params.allowSwipeToNext && translate < s.translate && translate < s.minTranslate()) {
                return false;
            }
            if (!s.params.allowSwipeToPrev && translate > s.translate && translate > s.maxTranslate()) {
                if ((s.activeIndex || 0) !== slideIndex ) return false;
            }
        
            // Update Index
            if (typeof speed === 'undefined') speed = s.params.speed;
            s.previousIndex = s.activeIndex || 0;
            s.activeIndex = slideIndex;
            s.updateRealIndex();
            if ((s.rtl && -translate === s.translate) || (!s.rtl && translate === s.translate)) {
                // Update Height
                if (s.params.autoHeight) {
                    s.updateAutoHeight();
                }
                s.updateClasses();
                if (s.params.effect !== 'slide') {
                    s.setWrapperTranslate(translate);
                }
                return false;
            }
            s.updateClasses();
            s.onTransitionStart(runCallbacks);
        
            if (speed === 0 || s.browser.lteIE9) {
                s.setWrapperTranslate(translate);
                s.setWrapperTransition(0);
                s.onTransitionEnd(runCallbacks);
            }
            else {
                s.setWrapperTranslate(translate);
                s.setWrapperTransition(speed);
                if (!s.animating) {
                    s.animating = true;
                    s.wrapper.transitionEnd(function () {
                        if (!s) return;
                        s.onTransitionEnd(runCallbacks);
                    });
                }
        
            }
        
            return true;
        };
        
        s.onTransitionStart = function (runCallbacks) {
            if (typeof runCallbacks === 'undefined') runCallbacks = true;
            if (s.params.autoHeight) {
                s.updateAutoHeight();
            }
            if (s.lazy) s.lazy.onTransitionStart();
            if (runCallbacks) {
                s.emit('onTransitionStart', s);
                if (s.activeIndex !== s.previousIndex) {
                    s.emit('onSlideChangeStart', s);
                    if (s.activeIndex > s.previousIndex) {
                        s.emit('onSlideNextStart', s);
                    }
                    else {
                        s.emit('onSlidePrevStart', s);
                    }
                }
        
            }
        };
        s.onTransitionEnd = function (runCallbacks) {
            s.animating = false;
            s.setWrapperTransition(0);
            if (typeof runCallbacks === 'undefined') runCallbacks = true;
            if (s.lazy) s.lazy.onTransitionEnd();
            if (runCallbacks) {
                s.emit('onTransitionEnd', s);
                if (s.activeIndex !== s.previousIndex) {
                    s.emit('onSlideChangeEnd', s);
                    if (s.activeIndex > s.previousIndex) {
                        s.emit('onSlideNextEnd', s);
                    }
                    else {
                        s.emit('onSlidePrevEnd', s);
                    }
                }
            }
            if (s.params.history && s.history) {
                s.history.setHistory(s.params.history, s.activeIndex);
            }
            if (s.params.hashnav && s.hashnav) {
                s.hashnav.setHash();
            }
        
        };
        s.slideNext = function (runCallbacks, speed, internal) {
            if (s.params.loop) {
                if (s.animating) return false;
                s.fixLoop();
                var clientLeft = s.container[0].clientLeft;
                return s.slideTo(s.activeIndex + s.params.slidesPerGroup, speed, runCallbacks, internal);
            }
            else return s.slideTo(s.activeIndex + s.params.slidesPerGroup, speed, runCallbacks, internal);
        };
        s._slideNext = function (speed) {
            return s.slideNext(true, speed, true);
        };
        s.slidePrev = function (runCallbacks, speed, internal) {
            if (s.params.loop) {
                if (s.animating) return false;
                s.fixLoop();
                var clientLeft = s.container[0].clientLeft;
                return s.slideTo(s.activeIndex - 1, speed, runCallbacks, internal);
            }
            else return s.slideTo(s.activeIndex - 1, speed, runCallbacks, internal);
        };
        s._slidePrev = function (speed) {
            return s.slidePrev(true, speed, true);
        };
        s.slideReset = function (runCallbacks, speed, internal) {
            return s.slideTo(s.activeIndex, speed, runCallbacks);
        };
        
        s.disableTouchControl = function () {
            s.params.onlyExternal = true;
            return true;
        };
        s.enableTouchControl = function () {
            s.params.onlyExternal = false;
            return true;
        };
        
        /*=========================
          Translate/transition helpers
          ===========================*/
        s.setWrapperTransition = function (duration, byController) {
            s.wrapper.transition(duration);
            if (s.params.effect !== 'slide' && s.effects[s.params.effect]) {
                s.effects[s.params.effect].setTransition(duration);
            }
            if (s.params.parallax && s.parallax) {
                s.parallax.setTransition(duration);
            }
            if (s.params.scrollbar && s.scrollbar) {
                s.scrollbar.setTransition(duration);
            }
            if (s.params.control && s.controller) {
                s.controller.setTransition(duration, byController);
            }
            s.emit('onSetTransition', s, duration);
        };
        s.setWrapperTranslate = function (translate, updateActiveIndex, byController) {
            var x = 0, y = 0, z = 0;
            if (s.isHorizontal()) {
                x = s.rtl ? -translate : translate;
            }
            else {
                y = translate;
            }
        
            if (s.params.roundLengths) {
                x = round(x);
                y = round(y);
            }
        
            if (!s.params.virtualTranslate) {
                if (s.support.transforms3d) s.wrapper.transform('translate3d(' + x + 'px, ' + y + 'px, ' + z + 'px)');
                else s.wrapper.transform('translate(' + x + 'px, ' + y + 'px)');
            }
        
            s.translate = s.isHorizontal() ? x : y;
        
            // Check if we need to update progress
            var progress;
            var translatesDiff = s.maxTranslate() - s.minTranslate();
            if (translatesDiff === 0) {
                progress = 0;
            }
            else {
                progress = (translate - s.minTranslate()) / (translatesDiff);
            }
            if (progress !== s.progress) {
                s.updateProgress(translate);
            }
        
            if (updateActiveIndex) s.updateActiveIndex();
            if (s.params.effect !== 'slide' && s.effects[s.params.effect]) {
                s.effects[s.params.effect].setTranslate(s.translate);
            }
            if (s.params.parallax && s.parallax) {
                s.parallax.setTranslate(s.translate);
            }
            if (s.params.scrollbar && s.scrollbar) {
                s.scrollbar.setTranslate(s.translate);
            }
            if (s.params.control && s.controller) {
                s.controller.setTranslate(s.translate, byController);
            }
            s.emit('onSetTranslate', s, s.translate);
        };
        
        s.getTranslate = function (el, axis) {
            var matrix, curTransform, curStyle, transformMatrix;
        
            // automatic axis detection
            if (typeof axis === 'undefined') {
                axis = 'x';
            }
        
            if (s.params.virtualTranslate) {
                return s.rtl ? -s.translate : s.translate;
            }
        
            curStyle = window.getComputedStyle(el, null);
            if (window.WebKitCSSMatrix) {
                curTransform = curStyle.transform || curStyle.webkitTransform;
                if (curTransform.split(',').length > 6) {
                    curTransform = curTransform.split(', ').map(function(a){
                        return a.replace(',','.');
                    }).join(', ');
                }
                // Some old versions of Webkit choke when 'none' is passed; pass
                // empty string instead in this case
                transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
            }
            else {
                transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform  || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
                matrix = transformMatrix.toString().split(',');
            }
        
            if (axis === 'x') {
                //Latest Chrome and webkits Fix
                if (window.WebKitCSSMatrix)
                    curTransform = transformMatrix.m41;
                //Crazy IE10 Matrix
                else if (matrix.length === 16)
                    curTransform = parseFloat(matrix[12]);
                //Normal Browsers
                else
                    curTransform = parseFloat(matrix[4]);
            }
            if (axis === 'y') {
                //Latest Chrome and webkits Fix
                if (window.WebKitCSSMatrix)
                    curTransform = transformMatrix.m42;
                //Crazy IE10 Matrix
                else if (matrix.length === 16)
                    curTransform = parseFloat(matrix[13]);
                //Normal Browsers
                else
                    curTransform = parseFloat(matrix[5]);
            }
            if (s.rtl && curTransform) curTransform = -curTransform;
            return curTransform || 0;
        };
        s.getWrapperTranslate = function (axis) {
            if (typeof axis === 'undefined') {
                axis = s.isHorizontal() ? 'x' : 'y';
            }
            return s.getTranslate(s.wrapper[0], axis);
        };
        
        /*=========================
          Observer
          ===========================*/
        s.observers = [];
        function initObserver(target, options) {
            options = options || {};
            // create an observer instance
            var ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
            var observer = new ObserverFunc(function (mutations) {
                mutations.forEach(function (mutation) {
                    s.onResize(true);
                    s.emit('onObserverUpdate', s, mutation);
                });
            });
        
            observer.observe(target, {
                attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
                childList: typeof options.childList === 'undefined' ? true : options.childList,
                characterData: typeof options.characterData === 'undefined' ? true : options.characterData
            });
        
            s.observers.push(observer);
        }
        s.initObservers = function () {
            if (s.params.observeParents) {
                var containerParents = s.container.parents();
                for (var i = 0; i < containerParents.length; i++) {
                    initObserver(containerParents[i]);
                }
            }
        
            // Observe container
            initObserver(s.container[0], {childList: false});
        
            // Observe wrapper
            initObserver(s.wrapper[0], {attributes: false});
        };
        s.disconnectObservers = function () {
            for (var i = 0; i < s.observers.length; i++) {
                s.observers[i].disconnect();
            }
            s.observers = [];
        };
        /*=========================
          Loop
          ===========================*/
        // Create looped slides
        s.createLoop = function () {
            // Remove duplicated slides
            s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass).remove();
        
            var slides = s.wrapper.children('.' + s.params.slideClass);
        
            if(s.params.slidesPerView === 'auto' && !s.params.loopedSlides) s.params.loopedSlides = slides.length;
        
            s.loopedSlides = parseInt(s.params.loopedSlides || s.params.slidesPerView, 10);
            s.loopedSlides = s.loopedSlides + s.params.loopAdditionalSlides;
            if (s.loopedSlides > slides.length) {
                s.loopedSlides = slides.length;
            }
        
            var prependSlides = [], appendSlides = [], i;
            slides.each(function (index, el) {
                var slide = $(this);
                if (index < s.loopedSlides) appendSlides.push(el);
                if (index < slides.length && index >= slides.length - s.loopedSlides) prependSlides.push(el);
                slide.attr('data-swiper-slide-index', index);
            });
            for (i = 0; i < appendSlides.length; i++) {
                s.wrapper.append($(appendSlides[i].cloneNode(true)).addClass(s.params.slideDuplicateClass));
            }
            for (i = prependSlides.length - 1; i >= 0; i--) {
                s.wrapper.prepend($(prependSlides[i].cloneNode(true)).addClass(s.params.slideDuplicateClass));
            }
        };
        s.destroyLoop = function () {
            s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass).remove();
            s.slides.removeAttr('data-swiper-slide-index');
        };
        s.reLoop = function (updatePosition) {
            var oldIndex = s.activeIndex - s.loopedSlides;
            s.destroyLoop();
            s.createLoop();
            s.updateSlidesSize();
            if (updatePosition) {
                s.slideTo(oldIndex + s.loopedSlides, 0, false);
            }
        
        };
        s.fixLoop = function () {
            var newIndex;
            //Fix For Negative Oversliding
            if (s.activeIndex < s.loopedSlides) {
                newIndex = s.slides.length - s.loopedSlides * 3 + s.activeIndex;
                newIndex = newIndex + s.loopedSlides;
                s.slideTo(newIndex, 0, false, true);
            }
            //Fix For Positive Oversliding
            else if ((s.params.slidesPerView === 'auto' && s.activeIndex >= s.loopedSlides * 2) || (s.activeIndex > s.slides.length - s.params.slidesPerView * 2)) {
                newIndex = -s.slides.length + s.activeIndex + s.loopedSlides;
                newIndex = newIndex + s.loopedSlides;
                s.slideTo(newIndex, 0, false, true);
            }
        };
        /*=========================
          Append/Prepend/Remove Slides
          ===========================*/
        s.appendSlide = function (slides) {
            if (s.params.loop) {
                s.destroyLoop();
            }
            if (typeof slides === 'object' && slides.length) {
                for (var i = 0; i < slides.length; i++) {
                    if (slides[i]) s.wrapper.append(slides[i]);
                }
            }
            else {
                s.wrapper.append(slides);
            }
            if (s.params.loop) {
                s.createLoop();
            }
            if (!(s.params.observer && s.support.observer)) {
                s.update(true);
            }
        };
        s.prependSlide = function (slides) {
            if (s.params.loop) {
                s.destroyLoop();
            }
            var newActiveIndex = s.activeIndex + 1;
            if (typeof slides === 'object' && slides.length) {
                for (var i = 0; i < slides.length; i++) {
                    if (slides[i]) s.wrapper.prepend(slides[i]);
                }
                newActiveIndex = s.activeIndex + slides.length;
            }
            else {
                s.wrapper.prepend(slides);
            }
            if (s.params.loop) {
                s.createLoop();
            }
            if (!(s.params.observer && s.support.observer)) {
                s.update(true);
            }
            s.slideTo(newActiveIndex, 0, false);
        };
        s.removeSlide = function (slidesIndexes) {
            if (s.params.loop) {
                s.destroyLoop();
                s.slides = s.wrapper.children('.' + s.params.slideClass);
            }
            var newActiveIndex = s.activeIndex,
                indexToRemove;
            if (typeof slidesIndexes === 'object' && slidesIndexes.length) {
                for (var i = 0; i < slidesIndexes.length; i++) {
                    indexToRemove = slidesIndexes[i];
                    if (s.slides[indexToRemove]) s.slides.eq(indexToRemove).remove();
                    if (indexToRemove < newActiveIndex) newActiveIndex--;
                }
                newActiveIndex = Math.max(newActiveIndex, 0);
            }
            else {
                indexToRemove = slidesIndexes;
                if (s.slides[indexToRemove]) s.slides.eq(indexToRemove).remove();
                if (indexToRemove < newActiveIndex) newActiveIndex--;
                newActiveIndex = Math.max(newActiveIndex, 0);
            }
        
            if (s.params.loop) {
                s.createLoop();
            }
        
            if (!(s.params.observer && s.support.observer)) {
                s.update(true);
            }
            if (s.params.loop) {
                s.slideTo(newActiveIndex + s.loopedSlides, 0, false);
            }
            else {
                s.slideTo(newActiveIndex, 0, false);
            }
        
        };
        s.removeAllSlides = function () {
            var slidesIndexes = [];
            for (var i = 0; i < s.slides.length; i++) {
                slidesIndexes.push(i);
            }
            s.removeSlide(slidesIndexes);
        };
        

        /*=========================
          Effects
          ===========================*/
        s.effects = {
            fade: {
                setTranslate: function () {
                    for (var i = 0; i < s.slides.length; i++) {
                        var slide = s.slides.eq(i);
                        var offset = slide[0].swiperSlideOffset;
                        var tx = -offset;
                        if (!s.params.virtualTranslate) tx = tx - s.translate;
                        var ty = 0;
                        if (!s.isHorizontal()) {
                            ty = tx;
                            tx = 0;
                        }
                        var slideOpacity = s.params.fade.crossFade ?
                                Math.max(1 - Math.abs(slide[0].progress), 0) :
                                1 + Math.min(Math.max(slide[0].progress, -1), 0);
                        slide
                            .css({
                                opacity: slideOpacity
                            })
                            .transform('translate3d(' + tx + 'px, ' + ty + 'px, 0px)');
        
                    }
        
                },
                setTransition: function (duration) {
                    s.slides.transition(duration);
                    if (s.params.virtualTranslate && duration !== 0) {
                        var eventTriggered = false;
                        s.slides.transitionEnd(function () {
                            if (eventTriggered) return;
                            if (!s) return;
                            eventTriggered = true;
                            s.animating = false;
                            var triggerEvents = ['webkitTransitionEnd', 'transitionend', 'oTransitionEnd', 'MSTransitionEnd', 'msTransitionEnd'];
                            for (var i = 0; i < triggerEvents.length; i++) {
                                s.wrapper.trigger(triggerEvents[i]);
                            }
                        });
                    }
                }
            },
            flip: {
                setTranslate: function () {
                    for (var i = 0; i < s.slides.length; i++) {
                        var slide = s.slides.eq(i);
                        var progress = slide[0].progress;
                        if (s.params.flip.limitRotation) {
                            progress = Math.max(Math.min(slide[0].progress, 1), -1);
                        }
                        var offset = slide[0].swiperSlideOffset;
                        var rotate = -180 * progress,
                            rotateY = rotate,
                            rotateX = 0,
                            tx = -offset,
                            ty = 0;
                        if (!s.isHorizontal()) {
                            ty = tx;
                            tx = 0;
                            rotateX = -rotateY;
                            rotateY = 0;
                        }
                        else if (s.rtl) {
                            rotateY = -rotateY;
                        }
        
                        slide[0].style.zIndex = -Math.abs(Math.round(progress)) + s.slides.length;
        
                        if (s.params.flip.slideShadows) {
                            //Set shadows
                            var shadowBefore = s.isHorizontal() ? slide.find('.swiper-slide-shadow-left') : slide.find('.swiper-slide-shadow-top');
                            var shadowAfter = s.isHorizontal() ? slide.find('.swiper-slide-shadow-right') : slide.find('.swiper-slide-shadow-bottom');
                            if (shadowBefore.length === 0) {
                                shadowBefore = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'left' : 'top') + '"></div>');
                                slide.append(shadowBefore);
                            }
                            if (shadowAfter.length === 0) {
                                shadowAfter = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'right' : 'bottom') + '"></div>');
                                slide.append(shadowAfter);
                            }
                            if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
                            if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
                        }
        
                        slide
                            .transform('translate3d(' + tx + 'px, ' + ty + 'px, 0px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)');
                    }
                },
                setTransition: function (duration) {
                    s.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
                    if (s.params.virtualTranslate && duration !== 0) {
                        var eventTriggered = false;
                        s.slides.eq(s.activeIndex).transitionEnd(function () {
                            if (eventTriggered) return;
                            if (!s) return;
                            if (!$(this).hasClass(s.params.slideActiveClass)) return;
                            eventTriggered = true;
                            s.animating = false;
                            var triggerEvents = ['webkitTransitionEnd', 'transitionend', 'oTransitionEnd', 'MSTransitionEnd', 'msTransitionEnd'];
                            for (var i = 0; i < triggerEvents.length; i++) {
                                s.wrapper.trigger(triggerEvents[i]);
                            }
                        });
                    }
                }
            },
            cube: {
                setTranslate: function () {
                    var wrapperRotate = 0, cubeShadow;
                    if (s.params.cube.shadow) {
                        if (s.isHorizontal()) {
                            cubeShadow = s.wrapper.find('.swiper-cube-shadow');
                            if (cubeShadow.length === 0) {
                                cubeShadow = $('<div class="swiper-cube-shadow"></div>');
                                s.wrapper.append(cubeShadow);
                            }
                            cubeShadow.css({height: s.width + 'px'});
                        }
                        else {
                            cubeShadow = s.container.find('.swiper-cube-shadow');
                            if (cubeShadow.length === 0) {
                                cubeShadow = $('<div class="swiper-cube-shadow"></div>');
                                s.container.append(cubeShadow);
                            }
                        }
                    }
                    for (var i = 0; i < s.slides.length; i++) {
                        var slide = s.slides.eq(i);
                        var slideAngle = i * 90;
                        var round = Math.floor(slideAngle / 360);
                        if (s.rtl) {
                            slideAngle = -slideAngle;
                            round = Math.floor(-slideAngle / 360);
                        }
                        var progress = Math.max(Math.min(slide[0].progress, 1), -1);
                        var tx = 0, ty = 0, tz = 0;
                        if (i % 4 === 0) {
                            tx = - round * 4 * s.size;
                            tz = 0;
                        }
                        else if ((i - 1) % 4 === 0) {
                            tx = 0;
                            tz = - round * 4 * s.size;
                        }
                        else if ((i - 2) % 4 === 0) {
                            tx = s.size + round * 4 * s.size;
                            tz = s.size;
                        }
                        else if ((i - 3) % 4 === 0) {
                            tx = - s.size;
                            tz = 3 * s.size + s.size * 4 * round;
                        }
                        if (s.rtl) {
                            tx = -tx;
                        }
        
                        if (!s.isHorizontal()) {
                            ty = tx;
                            tx = 0;
                        }
        
                        var transform = 'rotateX(' + (s.isHorizontal() ? 0 : -slideAngle) + 'deg) rotateY(' + (s.isHorizontal() ? slideAngle : 0) + 'deg) translate3d(' + tx + 'px, ' + ty + 'px, ' + tz + 'px)';
                        if (progress <= 1 && progress > -1) {
                            wrapperRotate = i * 90 + progress * 90;
                            if (s.rtl) wrapperRotate = -i * 90 - progress * 90;
                        }
                        slide.transform(transform);
                        if (s.params.cube.slideShadows) {
                            //Set shadows
                            var shadowBefore = s.isHorizontal() ? slide.find('.swiper-slide-shadow-left') : slide.find('.swiper-slide-shadow-top');
                            var shadowAfter = s.isHorizontal() ? slide.find('.swiper-slide-shadow-right') : slide.find('.swiper-slide-shadow-bottom');
                            if (shadowBefore.length === 0) {
                                shadowBefore = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'left' : 'top') + '"></div>');
                                slide.append(shadowBefore);
                            }
                            if (shadowAfter.length === 0) {
                                shadowAfter = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'right' : 'bottom') + '"></div>');
                                slide.append(shadowAfter);
                            }
                            if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
                            if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
                        }
                    }
                    s.wrapper.css({
                        '-webkit-transform-origin': '50% 50% -' + (s.size / 2) + 'px',
                        '-moz-transform-origin': '50% 50% -' + (s.size / 2) + 'px',
                        '-ms-transform-origin': '50% 50% -' + (s.size / 2) + 'px',
                        'transform-origin': '50% 50% -' + (s.size / 2) + 'px'
                    });
        
                    if (s.params.cube.shadow) {
                        if (s.isHorizontal()) {
                            cubeShadow.transform('translate3d(0px, ' + (s.width / 2 + s.params.cube.shadowOffset) + 'px, ' + (-s.width / 2) + 'px) rotateX(90deg) rotateZ(0deg) scale(' + (s.params.cube.shadowScale) + ')');
                        }
                        else {
                            var shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                            var multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                            var scale1 = s.params.cube.shadowScale,
                                scale2 = s.params.cube.shadowScale / multiplier,
                                offset = s.params.cube.shadowOffset;
                            cubeShadow.transform('scale3d(' + scale1 + ', 1, ' + scale2 + ') translate3d(0px, ' + (s.height / 2 + offset) + 'px, ' + (-s.height / 2 / scale2) + 'px) rotateX(-90deg)');
                        }
                    }
                    var zFactor = (s.isSafari || s.isUiWebView) ? (-s.size / 2) : 0;
                    s.wrapper.transform('translate3d(0px,0,' + zFactor + 'px) rotateX(' + (s.isHorizontal() ? 0 : wrapperRotate) + 'deg) rotateY(' + (s.isHorizontal() ? -wrapperRotate : 0) + 'deg)');
                },
                setTransition: function (duration) {
                    s.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
                    if (s.params.cube.shadow && !s.isHorizontal()) {
                        s.container.find('.swiper-cube-shadow').transition(duration);
                    }
                }
            },
            coverflow: {
                setTranslate: function () {
                    var transform = s.translate;
                    var center = s.isHorizontal() ? -transform + s.width / 2 : -transform + s.height / 2;
                    var rotate = s.isHorizontal() ? s.params.coverflow.rotate: -s.params.coverflow.rotate;
                    var translate = s.params.coverflow.depth;
                    //Each slide offset from center
                    for (var i = 0, length = s.slides.length; i < length; i++) {
                        var slide = s.slides.eq(i);
                        var slideSize = s.slidesSizesGrid[i];
                        var slideOffset = slide[0].swiperSlideOffset;
                        var offsetMultiplier = (center - slideOffset - slideSize / 2) / slideSize * s.params.coverflow.modifier;
        
                        var rotateY = s.isHorizontal() ? rotate * offsetMultiplier : 0;
                        var rotateX = s.isHorizontal() ? 0 : rotate * offsetMultiplier;
                        // var rotateZ = 0
                        var translateZ = -translate * Math.abs(offsetMultiplier);
        
                        var translateY = s.isHorizontal() ? 0 : s.params.coverflow.stretch * (offsetMultiplier);
                        var translateX = s.isHorizontal() ? s.params.coverflow.stretch * (offsetMultiplier) : 0;
        
                        //Fix for ultra small values
                        if (Math.abs(translateX) < 0.001) translateX = 0;
                        if (Math.abs(translateY) < 0.001) translateY = 0;
                        if (Math.abs(translateZ) < 0.001) translateZ = 0;
                        if (Math.abs(rotateY) < 0.001) rotateY = 0;
                        if (Math.abs(rotateX) < 0.001) rotateX = 0;
        
                        var slideTransform = 'translate3d(' + translateX + 'px,' + translateY + 'px,' + translateZ + 'px)  rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)';
        
                        slide.transform(slideTransform);
                        slide[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
                        if (s.params.coverflow.slideShadows) {
                            //Set shadows
                            var shadowBefore = s.isHorizontal() ? slide.find('.swiper-slide-shadow-left') : slide.find('.swiper-slide-shadow-top');
                            var shadowAfter = s.isHorizontal() ? slide.find('.swiper-slide-shadow-right') : slide.find('.swiper-slide-shadow-bottom');
                            if (shadowBefore.length === 0) {
                                shadowBefore = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'left' : 'top') + '"></div>');
                                slide.append(shadowBefore);
                            }
                            if (shadowAfter.length === 0) {
                                shadowAfter = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'right' : 'bottom') + '"></div>');
                                slide.append(shadowAfter);
                            }
                            if (shadowBefore.length) shadowBefore[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                            if (shadowAfter.length) shadowAfter[0].style.opacity = (-offsetMultiplier) > 0 ? -offsetMultiplier : 0;
                        }
                    }
        
                    //Set correct perspective for IE10
                    if (s.browser.ie) {
                        var ws = s.wrapper[0].style;
                        ws.perspectiveOrigin = center + 'px 50%';
                    }
                },
                setTransition: function (duration) {
                    s.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
                }
            }
        };
        

        /*=========================
          Images Lazy Loading
          ===========================*/
        s.lazy = {
            initialImageLoaded: false,
            loadImageInSlide: function (index, loadInDuplicate) {
                if (typeof index === 'undefined') return;
                if (typeof loadInDuplicate === 'undefined') loadInDuplicate = true;
                if (s.slides.length === 0) return;
        
                var slide = s.slides.eq(index);
                var img = slide.find('.' + s.params.lazyLoadingClass + ':not(.' + s.params.lazyStatusLoadedClass + '):not(.' + s.params.lazyStatusLoadingClass + ')');
                if (slide.hasClass(s.params.lazyLoadingClass) && !slide.hasClass(s.params.lazyStatusLoadedClass) && !slide.hasClass(s.params.lazyStatusLoadingClass)) {
                    img = img.add(slide[0]);
                }
                if (img.length === 0) return;
        
                img.each(function () {
                    var _img = $(this);
                    _img.addClass(s.params.lazyStatusLoadingClass);
                    var background = _img.attr('data-background');
                    var src = _img.attr('data-src'),
                        srcset = _img.attr('data-srcset'),
                        sizes = _img.attr('data-sizes');
                    s.loadImage(_img[0], (src || background), srcset, sizes, false, function () {
                        if (typeof s === 'undefined' || s === null || !s) return;
                        if (background) {
                            _img.css('background-image', 'url("' + background + '")');
                            _img.removeAttr('data-background');
                        }
                        else {
                            if (srcset) {
                                _img.attr('srcset', srcset);
                                _img.removeAttr('data-srcset');
                            }
                            if (sizes) {
                                _img.attr('sizes', sizes);
                                _img.removeAttr('data-sizes');
                            }
                            if (src) {
                                _img.attr('src', src);
                                _img.removeAttr('data-src');
                            }
        
                        }
        
                        _img.addClass(s.params.lazyStatusLoadedClass).removeClass(s.params.lazyStatusLoadingClass);
                        slide.find('.' + s.params.lazyPreloaderClass + ', .' + s.params.preloaderClass).remove();
                        if (s.params.loop && loadInDuplicate) {
                            var slideOriginalIndex = slide.attr('data-swiper-slide-index');
                            if (slide.hasClass(s.params.slideDuplicateClass)) {
                                var originalSlide = s.wrapper.children('[data-swiper-slide-index="' + slideOriginalIndex + '"]:not(.' + s.params.slideDuplicateClass + ')');
                                s.lazy.loadImageInSlide(originalSlide.index(), false);
                            }
                            else {
                                var duplicatedSlide = s.wrapper.children('.' + s.params.slideDuplicateClass + '[data-swiper-slide-index="' + slideOriginalIndex + '"]');
                                s.lazy.loadImageInSlide(duplicatedSlide.index(), false);
                            }
                        }
                        s.emit('onLazyImageReady', s, slide[0], _img[0]);
                    });
        
                    s.emit('onLazyImageLoad', s, slide[0], _img[0]);
                });
        
            },
            load: function () {
                var i;
                var slidesPerView = s.params.slidesPerView;
                if (slidesPerView === 'auto') {
                    slidesPerView = 0;
                }
                if (!s.lazy.initialImageLoaded) s.lazy.initialImageLoaded = true;
                if (s.params.watchSlidesVisibility) {
                    s.wrapper.children('.' + s.params.slideVisibleClass).each(function () {
                        s.lazy.loadImageInSlide($(this).index());
                    });
                }
                else {
                    if (slidesPerView > 1) {
                        for (i = s.activeIndex; i < s.activeIndex + slidesPerView ; i++) {
                            if (s.slides[i]) s.lazy.loadImageInSlide(i);
                        }
                    }
                    else {
                        s.lazy.loadImageInSlide(s.activeIndex);
                    }
                }
                if (s.params.lazyLoadingInPrevNext) {
                    if (slidesPerView > 1 || (s.params.lazyLoadingInPrevNextAmount && s.params.lazyLoadingInPrevNextAmount > 1)) {
                        var amount = s.params.lazyLoadingInPrevNextAmount;
                        var spv = slidesPerView;
                        var maxIndex = Math.min(s.activeIndex + spv + Math.max(amount, spv), s.slides.length);
                        var minIndex = Math.max(s.activeIndex - Math.max(spv, amount), 0);
                        // Next Slides
                        for (i = s.activeIndex + slidesPerView; i < maxIndex; i++) {
                            if (s.slides[i]) s.lazy.loadImageInSlide(i);
                        }
                        // Prev Slides
                        for (i = minIndex; i < s.activeIndex ; i++) {
                            if (s.slides[i]) s.lazy.loadImageInSlide(i);
                        }
                    }
                    else {
                        var nextSlide = s.wrapper.children('.' + s.params.slideNextClass);
                        if (nextSlide.length > 0) s.lazy.loadImageInSlide(nextSlide.index());
        
                        var prevSlide = s.wrapper.children('.' + s.params.slidePrevClass);
                        if (prevSlide.length > 0) s.lazy.loadImageInSlide(prevSlide.index());
                    }
                }
            },
            onTransitionStart: function () {
                if (s.params.lazyLoading) {
                    if (s.params.lazyLoadingOnTransitionStart || (!s.params.lazyLoadingOnTransitionStart && !s.lazy.initialImageLoaded)) {
                        s.lazy.load();
                    }
                }
            },
            onTransitionEnd: function () {
                if (s.params.lazyLoading && !s.params.lazyLoadingOnTransitionStart) {
                    s.lazy.load();
                }
            }
        };
        

        /*=========================
          Scrollbar
          ===========================*/
        s.scrollbar = {
            isTouched: false,
            setDragPosition: function (e) {
                var sb = s.scrollbar;
                var x = 0, y = 0;
                var translate;
                var pointerPosition = s.isHorizontal() ?
                    ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageX : e.pageX || e.clientX) :
                    ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageY : e.pageY || e.clientY) ;
                var position = (pointerPosition) - sb.track.offset()[s.isHorizontal() ? 'left' : 'top'] - sb.dragSize / 2;
                var positionMin = -s.minTranslate() * sb.moveDivider;
                var positionMax = -s.maxTranslate() * sb.moveDivider;
                if (position < positionMin) {
                    position = positionMin;
                }
                else if (position > positionMax) {
                    position = positionMax;
                }
                position = -position / sb.moveDivider;
                s.updateProgress(position);
                s.setWrapperTranslate(position, true);
            },
            dragStart: function (e) {
                var sb = s.scrollbar;
                sb.isTouched = true;
                e.preventDefault();
                e.stopPropagation();
        
                sb.setDragPosition(e);
                clearTimeout(sb.dragTimeout);
        
                sb.track.transition(0);
                if (s.params.scrollbarHide) {
                    sb.track.css('opacity', 1);
                }
                s.wrapper.transition(100);
                sb.drag.transition(100);
                s.emit('onScrollbarDragStart', s);
            },
            dragMove: function (e) {
                var sb = s.scrollbar;
                if (!sb.isTouched) return;
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
                sb.setDragPosition(e);
                s.wrapper.transition(0);
                sb.track.transition(0);
                sb.drag.transition(0);
                s.emit('onScrollbarDragMove', s);
            },
            dragEnd: function (e) {
                var sb = s.scrollbar;
                if (!sb.isTouched) return;
                sb.isTouched = false;
                if (s.params.scrollbarHide) {
                    clearTimeout(sb.dragTimeout);
                    sb.dragTimeout = setTimeout(function () {
                        sb.track.css('opacity', 0);
                        sb.track.transition(400);
                    }, 1000);
        
                }
                s.emit('onScrollbarDragEnd', s);
                if (s.params.scrollbarSnapOnRelease) {
                    s.slideReset();
                }
            },
            draggableEvents: (function () {
                if ((s.params.simulateTouch === false && !s.support.touch)) return s.touchEventsDesktop;
                else return s.touchEvents;
            })(),
            enableDraggable: function () {
                var sb = s.scrollbar;
                var target = s.support.touch ? sb.track : document;
                $(sb.track).on(sb.draggableEvents.start, sb.dragStart);
                $(target).on(sb.draggableEvents.move, sb.dragMove);
                $(target).on(sb.draggableEvents.end, sb.dragEnd);
            },
            disableDraggable: function () {
                var sb = s.scrollbar;
                var target = s.support.touch ? sb.track : document;
                $(sb.track).off(sb.draggableEvents.start, sb.dragStart);
                $(target).off(sb.draggableEvents.move, sb.dragMove);
                $(target).off(sb.draggableEvents.end, sb.dragEnd);
            },
            set: function () {
                if (!s.params.scrollbar) return;
                var sb = s.scrollbar;
                sb.track = $(s.params.scrollbar);
                if (s.params.uniqueNavElements && typeof s.params.scrollbar === 'string' && sb.track.length > 1 && s.container.find(s.params.scrollbar).length === 1) {
                    sb.track = s.container.find(s.params.scrollbar);
                }
                sb.drag = sb.track.find('.swiper-scrollbar-drag');
                if (sb.drag.length === 0) {
                    sb.drag = $('<div class="swiper-scrollbar-drag"></div>');
                    sb.track.append(sb.drag);
                }
                sb.drag[0].style.width = '';
                sb.drag[0].style.height = '';
                sb.trackSize = s.isHorizontal() ? sb.track[0].offsetWidth : sb.track[0].offsetHeight;
        
                sb.divider = s.size / s.virtualSize;
                sb.moveDivider = sb.divider * (sb.trackSize / s.size);
                sb.dragSize = sb.trackSize * sb.divider;
        
                if (s.isHorizontal()) {
                    sb.drag[0].style.width = sb.dragSize + 'px';
                }
                else {
                    sb.drag[0].style.height = sb.dragSize + 'px';
                }
        
                if (sb.divider >= 1) {
                    sb.track[0].style.display = 'none';
                }
                else {
                    sb.track[0].style.display = '';
                }
                if (s.params.scrollbarHide) {
                    sb.track[0].style.opacity = 0;
                }
            },
            setTranslate: function () {
                if (!s.params.scrollbar) return;
                var diff;
                var sb = s.scrollbar;
                var translate = s.translate || 0;
                var newPos;
        
                var newSize = sb.dragSize;
                newPos = (sb.trackSize - sb.dragSize) * s.progress;
                if (s.rtl && s.isHorizontal()) {
                    newPos = -newPos;
                    if (newPos > 0) {
                        newSize = sb.dragSize - newPos;
                        newPos = 0;
                    }
                    else if (-newPos + sb.dragSize > sb.trackSize) {
                        newSize = sb.trackSize + newPos;
                    }
                }
                else {
                    if (newPos < 0) {
                        newSize = sb.dragSize + newPos;
                        newPos = 0;
                    }
                    else if (newPos + sb.dragSize > sb.trackSize) {
                        newSize = sb.trackSize - newPos;
                    }
                }
                if (s.isHorizontal()) {
                    if (s.support.transforms3d) {
                        sb.drag.transform('translate3d(' + (newPos) + 'px, 0, 0)');
                    }
                    else {
                        sb.drag.transform('translateX(' + (newPos) + 'px)');
                    }
                    sb.drag[0].style.width = newSize + 'px';
                }
                else {
                    if (s.support.transforms3d) {
                        sb.drag.transform('translate3d(0px, ' + (newPos) + 'px, 0)');
                    }
                    else {
                        sb.drag.transform('translateY(' + (newPos) + 'px)');
                    }
                    sb.drag[0].style.height = newSize + 'px';
                }
                if (s.params.scrollbarHide) {
                    clearTimeout(sb.timeout);
                    sb.track[0].style.opacity = 1;
                    sb.timeout = setTimeout(function () {
                        sb.track[0].style.opacity = 0;
                        sb.track.transition(400);
                    }, 1000);
                }
            },
            setTransition: function (duration) {
                if (!s.params.scrollbar) return;
                s.scrollbar.drag.transition(duration);
            }
        };
        

        /*=========================
          Controller
          ===========================*/
        s.controller = {
            LinearSpline: function (x, y) {
                var binarySearch = (function() {
                    var maxIndex, minIndex, guess;
                    return function(array, val) {
                        minIndex = -1;
                        maxIndex = array.length;
                        while (maxIndex - minIndex > 1)
                            if (array[guess = maxIndex + minIndex >> 1] <= val) {
                                minIndex = guess;
                            } else {
                                maxIndex = guess;
                            }
                        return maxIndex;
                    };
                })();
                this.x = x;
                this.y = y;
                this.lastIndex = x.length - 1;
                // Given an x value (x2), return the expected y2 value:
                // (x1,y1) is the known point before given value,
                // (x3,y3) is the known point after given value.
                var i1, i3;
                var l = this.x.length;
        
                this.interpolate = function (x2) {
                    if (!x2) return 0;
        
                    // Get the indexes of x1 and x3 (the array indexes before and after given x2):
                    i3 = binarySearch(this.x, x2);
                    i1 = i3 - 1;
        
                    // We have our indexes i1 & i3, so we can calculate already:
                    // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
                    return ((x2 - this.x[i1]) * (this.y[i3] - this.y[i1])) / (this.x[i3] - this.x[i1]) + this.y[i1];
                };
            },
            //xxx: for now i will just save one spline function to to
            getInterpolateFunction: function(c){
                if(!s.controller.spline) s.controller.spline = s.params.loop ?
                    new s.controller.LinearSpline(s.slidesGrid, c.slidesGrid) :
                    new s.controller.LinearSpline(s.snapGrid, c.snapGrid);
            },
            setTranslate: function (translate, byController) {
               var controlled = s.params.control;
               var multiplier, controlledTranslate;
               function setControlledTranslate(c) {
                    // this will create an Interpolate function based on the snapGrids
                    // x is the Grid of the scrolled scroller and y will be the controlled scroller
                    // it makes sense to create this only once and recall it for the interpolation
                    // the function does a lot of value caching for performance
                    translate = c.rtl && c.params.direction === 'horizontal' ? -s.translate : s.translate;
                    if (s.params.controlBy === 'slide') {
                        s.controller.getInterpolateFunction(c);
                        // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                        // but it did not work out
                        controlledTranslate = -s.controller.spline.interpolate(-translate);
                    }
        
                    if(!controlledTranslate || s.params.controlBy === 'container'){
                        multiplier = (c.maxTranslate() - c.minTranslate()) / (s.maxTranslate() - s.minTranslate());
                        controlledTranslate = (translate - s.minTranslate()) * multiplier + c.minTranslate();
                    }
        
                    if (s.params.controlInverse) {
                        controlledTranslate = c.maxTranslate() - controlledTranslate;
                    }
                    c.updateProgress(controlledTranslate);
                    c.setWrapperTranslate(controlledTranslate, false, s);
                    c.updateActiveIndex();
               }
               if (Array.isArray(controlled)) {
                   for (var i = 0; i < controlled.length; i++) {
                       if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
                           setControlledTranslate(controlled[i]);
                       }
                   }
               }
               else if (controlled instanceof Swiper && byController !== controlled) {
        
                   setControlledTranslate(controlled);
               }
            },
            setTransition: function (duration, byController) {
                var controlled = s.params.control;
                var i;
                function setControlledTransition(c) {
                    c.setWrapperTransition(duration, s);
                    if (duration !== 0) {
                        c.onTransitionStart();
                        c.wrapper.transitionEnd(function(){
                            if (!controlled) return;
                            if (c.params.loop && s.params.controlBy === 'slide') {
                                c.fixLoop();
                            }
                            c.onTransitionEnd();
        
                        });
                    }
                }
                if (Array.isArray(controlled)) {
                    for (i = 0; i < controlled.length; i++) {
                        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
                            setControlledTransition(controlled[i]);
                        }
                    }
                }
                else if (controlled instanceof Swiper && byController !== controlled) {
                    setControlledTransition(controlled);
                }
            }
        };
        

        /*=========================
          Hash Navigation
          ===========================*/
        s.hashnav = {
            onHashCange: function (e, a) {
                var newHash = document.location.hash.replace('#', '');
                var activeSlideHash = s.slides.eq(s.activeIndex).attr('data-hash');
                if (newHash !== activeSlideHash) {
                    s.slideTo(s.wrapper.children('.' + s.params.slideClass + '[data-hash="' + (newHash) + '"]').index());
                }
            },
            attachEvents: function (detach) {
                var action = detach ? 'off' : 'on';
                $(window)[action]('hashchange', s.hashnav.onHashCange);
            },
            setHash: function () {
                if (!s.hashnav.initialized || !s.params.hashnav) return;
                if (s.params.replaceState && window.history && window.history.replaceState) {
                    window.history.replaceState(null, null, ('#' + s.slides.eq(s.activeIndex).attr('data-hash') || ''));
                } else {
                    var slide = s.slides.eq(s.activeIndex);
                    var hash = slide.attr('data-hash') || slide.attr('data-history');
                    document.location.hash = hash || '';
                }
            },
            init: function () {
                if (!s.params.hashnav || s.params.history) return;
                s.hashnav.initialized = true;
                var hash = document.location.hash.replace('#', '');
                if (hash) {
                    var speed = 0;
                    for (var i = 0, length = s.slides.length; i < length; i++) {
                        var slide = s.slides.eq(i);
                        var slideHash = slide.attr('data-hash') || slide.attr('data-history');
                        if (slideHash === hash && !slide.hasClass(s.params.slideDuplicateClass)) {
                            var index = slide.index();
                            s.slideTo(index, speed, s.params.runCallbacksOnInit, true);
                        }
                    }
                }
                if (s.params.hashnavWatchState) s.hashnav.attachEvents();
            },
            destroy: function () {
                if (s.params.hashnavWatchState) s.hashnav.attachEvents(true);
            }
        };
        

        /*=========================
          History Api with fallback to Hashnav
          ===========================*/
        s.history = {
            init: function () {
                if (!s.params.history) return;
                if (!window.history || !window.history.pushState) {
                    s.params.history = false;
                    s.params.hashnav = true;
                    return;
                }
                s.history.initialized = true;
                this.paths = this.getPathValues();
                if (!this.paths.key && !this.paths.value) return;
                this.scrollToSlide(0, this.paths.value, s.params.runCallbacksOnInit);
                if (!s.params.replaceState) {
                    window.addEventListener('popstate', this.setHistoryPopState);
                }
            },
            setHistoryPopState: function() {
                s.history.paths = s.history.getPathValues();
                s.history.scrollToSlide(s.params.speed, s.history.paths.value, false);
            },
            getPathValues: function() {
                var pathArray = window.location.pathname.slice(1).split('/');
                var total = pathArray.length;
                var key = pathArray[total - 2];
                var value = pathArray[total - 1];
                return { key: key, value: value };
            },
            setHistory: function (key, index) {
                if (!s.history.initialized || !s.params.history) return;
                var slide = s.slides.eq(index);
                var value = this.slugify(slide.attr('data-history'));
                if (!window.location.pathname.includes(key)) {
                    value = key + '/' + value;
                }
                if (s.params.replaceState) {
                    window.history.replaceState(null, null, value);
                } else {
                    window.history.pushState(null, null, value);
                }
            },
            slugify: function(text) {
                return text.toString().toLowerCase()
                    .replace(/\s+/g, '-')
                    .replace(/[^\w\-]+/g, '')
                    .replace(/\-\-+/g, '-')
                    .replace(/^-+/, '')
                    .replace(/-+$/, '');
            },
            scrollToSlide: function(speed, value, runCallbacks) {
                if (value) {
                    for (var i = 0, length = s.slides.length; i < length; i++) {
                        var slide = s.slides.eq(i);
                        var slideHistory = this.slugify(slide.attr('data-history'));
                        if (slideHistory === value && !slide.hasClass(s.params.slideDuplicateClass)) {
                            var index = slide.index();
                            s.slideTo(index, speed, runCallbacks);
                        }
                    }
                } else {
                    s.slideTo(0, speed, runCallbacks);
                }
            }
        };
        

        /*=========================
          Keyboard Control
          ===========================*/
        function handleKeyboard(e) {
            if (e.originalEvent) e = e.originalEvent; //jquery fix
            var kc = e.keyCode || e.charCode;
            // Directions locks
            if (!s.params.allowSwipeToNext && (s.isHorizontal() && kc === 39 || !s.isHorizontal() && kc === 40)) {
                return false;
            }
            if (!s.params.allowSwipeToPrev && (s.isHorizontal() && kc === 37 || !s.isHorizontal() && kc === 38)) {
                return false;
            }
            if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
                return;
            }
            if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea')) {
                return;
            }
            if (kc === 37 || kc === 39 || kc === 38 || kc === 40) {
                var inView = false;
                //Check that swiper should be inside of visible area of window
                if (s.container.parents('.' + s.params.slideClass).length > 0 && s.container.parents('.' + s.params.slideActiveClass).length === 0) {
                    return;
                }
                var windowScroll = {
                    left: window.pageXOffset,
                    top: window.pageYOffset
                };
                var windowWidth = window.innerWidth;
                var windowHeight = window.innerHeight;
                var swiperOffset = s.container.offset();
                if (s.rtl) swiperOffset.left = swiperOffset.left - s.container[0].scrollLeft;
                var swiperCoord = [
                    [swiperOffset.left, swiperOffset.top],
                    [swiperOffset.left + s.width, swiperOffset.top],
                    [swiperOffset.left, swiperOffset.top + s.height],
                    [swiperOffset.left + s.width, swiperOffset.top + s.height]
                ];
                for (var i = 0; i < swiperCoord.length; i++) {
                    var point = swiperCoord[i];
                    if (
                        point[0] >= windowScroll.left && point[0] <= windowScroll.left + windowWidth &&
                        point[1] >= windowScroll.top && point[1] <= windowScroll.top + windowHeight
                    ) {
                        inView = true;
                    }
        
                }
                if (!inView) return;
            }
            if (s.isHorizontal()) {
                if (kc === 37 || kc === 39) {
                    if (e.preventDefault) e.preventDefault();
                    else e.returnValue = false;
                }
                if ((kc === 39 && !s.rtl) || (kc === 37 && s.rtl)) s.slideNext();
                if ((kc === 37 && !s.rtl) || (kc === 39 && s.rtl)) s.slidePrev();
            }
            else {
                if (kc === 38 || kc === 40) {
                    if (e.preventDefault) e.preventDefault();
                    else e.returnValue = false;
                }
                if (kc === 40) s.slideNext();
                if (kc === 38) s.slidePrev();
            }
            s.emit('onKeyPress', s, kc);
        }
        s.disableKeyboardControl = function () {
            s.params.keyboardControl = false;
            $(document).off('keydown', handleKeyboard);
        };
        s.enableKeyboardControl = function () {
            s.params.keyboardControl = true;
            $(document).on('keydown', handleKeyboard);
        };
        

        /*=========================
          Mousewheel Control
          ===========================*/
        s.mousewheel = {
            event: false,
            lastScrollTime: (new window.Date()).getTime()
        };
        function isEventSupported() {
            var eventName = 'onwheel';
            var isSupported = eventName in document;
        
            if (!isSupported) {
                var element = document.createElement('div');
                element.setAttribute(eventName, 'return;');
                isSupported = typeof element[eventName] === 'function';
            }
        
            if (!isSupported &&
                document.implementation &&
                document.implementation.hasFeature &&
                    // always returns true in newer browsers as per the standard.
                    // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
                document.implementation.hasFeature('', '') !== true ) {
                // This is the only way to test support for the `wheel` event in IE9+.
                isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
            }
        
            return isSupported;
        }
        /**
         * Mouse wheel (and 2-finger trackpad) support on the web sucks.  It is
         * complicated, thus this doc is long and (hopefully) detailed enough to answer
         * your questions.
         *
         * If you need to react to the mouse wheel in a predictable way, this code is
         * like your bestest friend. * hugs *
         *
         * As of today, there are 4 DOM event types you can listen to:
         *
         *   'wheel'                -- Chrome(31+), FF(17+), IE(9+)
         *   'mousewheel'           -- Chrome, IE(6+), Opera, Safari
         *   'MozMousePixelScroll'  -- FF(3.5 only!) (2010-2013) -- don't bother!
         *   'DOMMouseScroll'       -- FF(0.9.7+) since 2003
         *
         * So what to do?  The is the best:
         *
         *   normalizeWheel.getEventType();
         *
         * In your event callback, use this code to get sane interpretation of the
         * deltas.  This code will return an object with properties:
         *
         *   spinX   -- normalized spin speed (use for zoom) - x plane
         *   spinY   -- " - y plane
         *   pixelX  -- normalized distance (to pixels) - x plane
         *   pixelY  -- " - y plane
         *
         * Wheel values are provided by the browser assuming you are using the wheel to
         * scroll a web page by a number of lines or pixels (or pages).  Values can vary
         * significantly on different platforms and browsers, forgetting that you can
         * scroll at different speeds.  Some devices (like trackpads) emit more events
         * at smaller increments with fine granularity, and some emit massive jumps with
         * linear speed or acceleration.
         *
         * This code does its best to normalize the deltas for you:
         *
         *   - spin is trying to normalize how far the wheel was spun (or trackpad
         *     dragged).  This is super useful for zoom support where you want to
         *     throw away the chunky scroll steps on the PC and make those equal to
         *     the slow and smooth tiny steps on the Mac. Key data: This code tries to
         *     resolve a single slow step on a wheel to 1.
         *
         *   - pixel is normalizing the desired scroll delta in pixel units.  You'll
         *     get the crazy differences between browsers, but at least it'll be in
         *     pixels!
         *
         *   - positive value indicates scrolling DOWN/RIGHT, negative UP/LEFT.  This
         *     should translate to positive value zooming IN, negative zooming OUT.
         *     This matches the newer 'wheel' event.
         *
         * Why are there spinX, spinY (or pixels)?
         *
         *   - spinX is a 2-finger side drag on the trackpad, and a shift + wheel turn
         *     with a mouse.  It results in side-scrolling in the browser by default.
         *
         *   - spinY is what you expect -- it's the classic axis of a mouse wheel.
         *
         *   - I dropped spinZ/pixelZ.  It is supported by the DOM 3 'wheel' event and
         *     probably is by browsers in conjunction with fancy 3D controllers .. but
         *     you know.
         *
         * Implementation info:
         *
         * Examples of 'wheel' event if you scroll slowly (down) by one step with an
         * average mouse:
         *
         *   OS X + Chrome  (mouse)     -    4   pixel delta  (wheelDelta -120)
         *   OS X + Safari  (mouse)     -  N/A   pixel delta  (wheelDelta  -12)
         *   OS X + Firefox (mouse)     -    0.1 line  delta  (wheelDelta  N/A)
         *   Win8 + Chrome  (mouse)     -  100   pixel delta  (wheelDelta -120)
         *   Win8 + Firefox (mouse)     -    3   line  delta  (wheelDelta -120)
         *
         * On the trackpad:
         *
         *   OS X + Chrome  (trackpad)  -    2   pixel delta  (wheelDelta   -6)
         *   OS X + Firefox (trackpad)  -    1   pixel delta  (wheelDelta  N/A)
         *
         * On other/older browsers.. it's more complicated as there can be multiple and
         * also missing delta values.
         *
         * The 'wheel' event is more standard:
         *
         * http://www.w3.org/TR/DOM-Level-3-Events/#events-wheelevents
         *
         * The basics is that it includes a unit, deltaMode (pixels, lines, pages), and
         * deltaX, deltaY and deltaZ.  Some browsers provide other values to maintain
         * backward compatibility with older events.  Those other values help us
         * better normalize spin speed.  Example of what the browsers provide:
         *
         *                          | event.wheelDelta | event.detail
         *        ------------------+------------------+--------------
         *          Safari v5/OS X  |       -120       |       0
         *          Safari v5/Win7  |       -120       |       0
         *         Chrome v17/OS X  |       -120       |       0
         *         Chrome v17/Win7  |       -120       |       0
         *                IE9/Win7  |       -120       |   undefined
         *         Firefox v4/OS X  |     undefined    |       1
         *         Firefox v4/Win7  |     undefined    |       3
         *
         */
        function normalizeWheel( /*object*/ event ) /*object*/ {
            // Reasonable defaults
            var PIXEL_STEP = 10;
            var LINE_HEIGHT = 40;
            var PAGE_HEIGHT = 800;
        
            var sX = 0, sY = 0,       // spinX, spinY
                pX = 0, pY = 0;       // pixelX, pixelY
        
            // Legacy
            if( 'detail' in event ) {
                sY = event.detail;
            }
            if( 'wheelDelta' in event ) {
                sY = -event.wheelDelta / 120;
            }
            if( 'wheelDeltaY' in event ) {
                sY = -event.wheelDeltaY / 120;
            }
            if( 'wheelDeltaX' in event ) {
                sX = -event.wheelDeltaX / 120;
            }
        
            // side scrolling on FF with DOMMouseScroll
            if( 'axis' in event && event.axis === event.HORIZONTAL_AXIS ) {
                sX = sY;
                sY = 0;
            }
        
            pX = sX * PIXEL_STEP;
            pY = sY * PIXEL_STEP;
        
            if( 'deltaY' in event ) {
                pY = event.deltaY;
            }
            if( 'deltaX' in event ) {
                pX = event.deltaX;
            }
        
            if( (pX || pY) && event.deltaMode ) {
                if( event.deltaMode === 1 ) {          // delta in LINE units
                    pX *= LINE_HEIGHT;
                    pY *= LINE_HEIGHT;
                } else {                             // delta in PAGE units
                    pX *= PAGE_HEIGHT;
                    pY *= PAGE_HEIGHT;
                }
            }
        
            // Fall-back if spin cannot be determined
            if( pX && !sX ) {
                sX = (pX < 1) ? -1 : 1;
            }
            if( pY && !sY ) {
                sY = (pY < 1) ? -1 : 1;
            }
        
            return {
                spinX: sX,
                spinY: sY,
                pixelX: pX,
                pixelY: pY
            };
        }
        if (s.params.mousewheelControl) {
            /**
             * The best combination if you prefer spinX + spinY normalization.  It favors
             * the older DOMMouseScroll for Firefox, as FF does not include wheelDelta with
             * 'wheel' event, making spin speed determination impossible.
             */
            s.mousewheel.event = (navigator.userAgent.indexOf('firefox') > -1) ?
                'DOMMouseScroll' :
                isEventSupported() ?
                    'wheel' : 'mousewheel';
        }
        function handleMousewheel(e) {
            if (e.originalEvent) e = e.originalEvent; //jquery fix
            var delta = 0;
            var rtlFactor = s.rtl ? -1 : 1;
        
            var data = normalizeWheel( e );
        
            if (s.params.mousewheelForceToAxis) {
                if (s.isHorizontal()) {
                    if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = data.pixelX * rtlFactor;
                    else return;
                }
                else {
                    if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = data.pixelY;
                    else return;
                }
            }
            else {
                delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? - data.pixelX * rtlFactor : - data.pixelY;
            }
        
            if (delta === 0) return;
        
            if (s.params.mousewheelInvert) delta = -delta;
        
            if (!s.params.freeMode) {
                if ((new window.Date()).getTime() - s.mousewheel.lastScrollTime > 60) {
                    if (delta < 0) {
                        if ((!s.isEnd || s.params.loop) && !s.animating) {
                            s.slideNext();
                            s.emit('onScroll', s, e);
                        }
                        else if (s.params.mousewheelReleaseOnEdges) return true;
                    }
                    else {
                        if ((!s.isBeginning || s.params.loop) && !s.animating) {
                            s.slidePrev();
                            s.emit('onScroll', s, e);
                        }
                        else if (s.params.mousewheelReleaseOnEdges) return true;
                    }
                }
                s.mousewheel.lastScrollTime = (new window.Date()).getTime();
        
            }
            else {
                //Freemode or scrollContainer:
                var position = s.getWrapperTranslate() + delta * s.params.mousewheelSensitivity;
                var wasBeginning = s.isBeginning,
                    wasEnd = s.isEnd;
        
                if (position >= s.minTranslate()) position = s.minTranslate();
                if (position <= s.maxTranslate()) position = s.maxTranslate();
        
                s.setWrapperTransition(0);
                s.setWrapperTranslate(position);
                s.updateProgress();
                s.updateActiveIndex();
        
                if (!wasBeginning && s.isBeginning || !wasEnd && s.isEnd) {
                    s.updateClasses();
                }
        
                if (s.params.freeModeSticky) {
                    clearTimeout(s.mousewheel.timeout);
                    s.mousewheel.timeout = setTimeout(function () {
                        s.slideReset();
                    }, 300);
                }
                else {
                    if (s.params.lazyLoading && s.lazy) {
                        s.lazy.load();
                    }
                }
                // Emit event
                s.emit('onScroll', s, e);
        
                // Stop autoplay
                if (s.params.autoplay && s.params.autoplayDisableOnInteraction) s.stopAutoplay();
        
                // Return page scroll on edge positions
                if (position === 0 || position === s.maxTranslate()) return;
            }
        
            if (e.preventDefault) e.preventDefault();
            else e.returnValue = false;
            return false;
        }
        s.disableMousewheelControl = function () {
            if (!s.mousewheel.event) return false;
            var target = s.container;
            if (s.params.mousewheelEventsTarged !== 'container') {
                target = $(s.params.mousewheelEventsTarged);
            }
            target.off(s.mousewheel.event, handleMousewheel);
            s.params.mousewheelControl = false;
            return true;
        };
        
        s.enableMousewheelControl = function () {
            if (!s.mousewheel.event) return false;
            var target = s.container;
            if (s.params.mousewheelEventsTarged !== 'container') {
                target = $(s.params.mousewheelEventsTarged);
            }
            target.on(s.mousewheel.event, handleMousewheel);
            s.params.mousewheelControl = true;
            return true;
        };
        

        /*=========================
          Parallax
          ===========================*/
        function setParallaxTransform(el, progress) {
            el = $(el);
            var p, pX, pY;
            var rtlFactor = s.rtl ? -1 : 1;
        
            p = el.attr('data-swiper-parallax') || '0';
            pX = el.attr('data-swiper-parallax-x');
            pY = el.attr('data-swiper-parallax-y');
            if (pX || pY) {
                pX = pX || '0';
                pY = pY || '0';
            }
            else {
                if (s.isHorizontal()) {
                    pX = p;
                    pY = '0';
                }
                else {
                    pY = p;
                    pX = '0';
                }
            }
        
            if ((pX).indexOf('%') >= 0) {
                pX = parseInt(pX, 10) * progress * rtlFactor + '%';
            }
            else {
                pX = pX * progress * rtlFactor + 'px' ;
            }
            if ((pY).indexOf('%') >= 0) {
                pY = parseInt(pY, 10) * progress + '%';
            }
            else {
                pY = pY * progress + 'px' ;
            }
        
            el.transform('translate3d(' + pX + ', ' + pY + ',0px)');
        }
        s.parallax = {
            setTranslate: function () {
                s.container.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]').each(function(){
                    setParallaxTransform(this, s.progress);
        
                });
                s.slides.each(function () {
                    var slide = $(this);
                    slide.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]').each(function () {
                        var progress = Math.min(Math.max(slide[0].progress, -1), 1);
                        setParallaxTransform(this, progress);
                    });
                });
            },
            setTransition: function (duration) {
                if (typeof duration === 'undefined') duration = s.params.speed;
                s.container.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]').each(function(){
                    var el = $(this);
                    var parallaxDuration = parseInt(el.attr('data-swiper-parallax-duration'), 10) || duration;
                    if (duration === 0) parallaxDuration = 0;
                    el.transition(parallaxDuration);
                });
            }
        };
        

        /*=========================
          Zoom
          ===========================*/
        s.zoom = {
            // "Global" Props
            scale: 1,
            currentScale: 1,
            isScaling: false,
            gesture: {
                slide: undefined,
                slideWidth: undefined,
                slideHeight: undefined,
                image: undefined,
                imageWrap: undefined,
                zoomMax: s.params.zoomMax
            },
            image: {
                isTouched: undefined,
                isMoved: undefined,
                currentX: undefined,
                currentY: undefined,
                minX: undefined,
                minY: undefined,
                maxX: undefined,
                maxY: undefined,
                width: undefined,
                height: undefined,
                startX: undefined,
                startY: undefined,
                touchesStart: {},
                touchesCurrent: {}
            },
            velocity: {
                x: undefined,
                y: undefined,
                prevPositionX: undefined,
                prevPositionY: undefined,
                prevTime: undefined
            },
            // Calc Scale From Multi-touches
            getDistanceBetweenTouches: function (e) {
                if (e.targetTouches.length < 2) return 1;
                var x1 = e.targetTouches[0].pageX,
                    y1 = e.targetTouches[0].pageY,
                    x2 = e.targetTouches[1].pageX,
                    y2 = e.targetTouches[1].pageY;
                var distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
                return distance;
            },
            // Events
            onGestureStart: function (e) {
                var z = s.zoom;
                if (!s.support.gestures) {
                    if (e.type !== 'touchstart' || e.type === 'touchstart' && e.targetTouches.length < 2) {
                        return;
                    }
                    z.gesture.scaleStart = z.getDistanceBetweenTouches(e);
                }
                if (!z.gesture.slide || !z.gesture.slide.length) {
                    z.gesture.slide = $(this);
                    if (z.gesture.slide.length === 0) z.gesture.slide = s.slides.eq(s.activeIndex);
                    z.gesture.image = z.gesture.slide.find('img, svg, canvas');
                    z.gesture.imageWrap = z.gesture.image.parent('.' + s.params.zoomContainerClass);
                    z.gesture.zoomMax = z.gesture.imageWrap.attr('data-swiper-zoom') || s.params.zoomMax ;
                    if (z.gesture.imageWrap.length === 0) {
                        z.gesture.image = undefined;
                        return;
                    }
                }
                z.gesture.image.transition(0);
                z.isScaling = true;
            },
            onGestureChange: function (e) {
                var z = s.zoom;
                if (!s.support.gestures) {
                    if (e.type !== 'touchmove' || e.type === 'touchmove' && e.targetTouches.length < 2) {
                        return;
                    }
                    z.gesture.scaleMove = z.getDistanceBetweenTouches(e);
                }
                if (!z.gesture.image || z.gesture.image.length === 0) return;
                if (s.support.gestures) {
                    z.scale = e.scale * z.currentScale;
                }
                else {
                    z.scale = (z.gesture.scaleMove / z.gesture.scaleStart) * z.currentScale;
                }
                if (z.scale > z.gesture.zoomMax) {
                    z.scale = z.gesture.zoomMax - 1 + Math.pow((z.scale - z.gesture.zoomMax + 1), 0.5);
                }
                if (z.scale < s.params.zoomMin) {
                    z.scale =  s.params.zoomMin + 1 - Math.pow((s.params.zoomMin - z.scale + 1), 0.5);
                }
                z.gesture.image.transform('translate3d(0,0,0) scale(' + z.scale + ')');
            },
            onGestureEnd: function (e) {
                var z = s.zoom;
                if (!s.support.gestures) {
                    if (e.type !== 'touchend' || e.type === 'touchend' && e.changedTouches.length < 2) {
                        return;
                    }
                }
                if (!z.gesture.image || z.gesture.image.length === 0) return;
                z.scale = Math.max(Math.min(z.scale, z.gesture.zoomMax), s.params.zoomMin);
                z.gesture.image.transition(s.params.speed).transform('translate3d(0,0,0) scale(' + z.scale + ')');
                z.currentScale = z.scale;
                z.isScaling = false;
                if (z.scale === 1) z.gesture.slide = undefined;
            },
            onTouchStart: function (s, e) {
                var z = s.zoom;
                if (!z.gesture.image || z.gesture.image.length === 0) return;
                if (z.image.isTouched) return;
                if (s.device.os === 'android') e.preventDefault();
                z.image.isTouched = true;
                z.image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
                z.image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
            },
            onTouchMove: function (e) {
                var z = s.zoom;
                if (!z.gesture.image || z.gesture.image.length === 0) return;
                s.allowClick = false;
                if (!z.image.isTouched || !z.gesture.slide) return;
        
                if (!z.image.isMoved) {
                    z.image.width = z.gesture.image[0].offsetWidth;
                    z.image.height = z.gesture.image[0].offsetHeight;
                    z.image.startX = s.getTranslate(z.gesture.imageWrap[0], 'x') || 0;
                    z.image.startY = s.getTranslate(z.gesture.imageWrap[0], 'y') || 0;
                    z.gesture.slideWidth = z.gesture.slide[0].offsetWidth;
                    z.gesture.slideHeight = z.gesture.slide[0].offsetHeight;
                    z.gesture.imageWrap.transition(0);
                    if (s.rtl) z.image.startX = -z.image.startX;
                    if (s.rtl) z.image.startY = -z.image.startY;
                }
                // Define if we need image drag
                var scaledWidth = z.image.width * z.scale;
                var scaledHeight = z.image.height * z.scale;
        
                if (scaledWidth < z.gesture.slideWidth && scaledHeight < z.gesture.slideHeight) return;
        
                z.image.minX = Math.min((z.gesture.slideWidth / 2 - scaledWidth / 2), 0);
                z.image.maxX = -z.image.minX;
                z.image.minY = Math.min((z.gesture.slideHeight / 2 - scaledHeight / 2), 0);
                z.image.maxY = -z.image.minY;
        
                z.image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
                z.image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
        
                if (!z.image.isMoved && !z.isScaling) {
                    if (s.isHorizontal() &&
                        (Math.floor(z.image.minX) === Math.floor(z.image.startX) && z.image.touchesCurrent.x < z.image.touchesStart.x) ||
                        (Math.floor(z.image.maxX) === Math.floor(z.image.startX) && z.image.touchesCurrent.x > z.image.touchesStart.x)
                        ) {
                        z.image.isTouched = false;
                        return;
                    }
                    else if (!s.isHorizontal() &&
                        (Math.floor(z.image.minY) === Math.floor(z.image.startY) && z.image.touchesCurrent.y < z.image.touchesStart.y) ||
                        (Math.floor(z.image.maxY) === Math.floor(z.image.startY) && z.image.touchesCurrent.y > z.image.touchesStart.y)
                        ) {
                        z.image.isTouched = false;
                        return;
                    }
                }
                e.preventDefault();
                e.stopPropagation();
        
                z.image.isMoved = true;
                z.image.currentX = z.image.touchesCurrent.x - z.image.touchesStart.x + z.image.startX;
                z.image.currentY = z.image.touchesCurrent.y - z.image.touchesStart.y + z.image.startY;
        
                if (z.image.currentX < z.image.minX) {
                    z.image.currentX =  z.image.minX + 1 - Math.pow((z.image.minX - z.image.currentX + 1), 0.8);
                }
                if (z.image.currentX > z.image.maxX) {
                    z.image.currentX = z.image.maxX - 1 + Math.pow((z.image.currentX - z.image.maxX + 1), 0.8);
                }
        
                if (z.image.currentY < z.image.minY) {
                    z.image.currentY =  z.image.minY + 1 - Math.pow((z.image.minY - z.image.currentY + 1), 0.8);
                }
                if (z.image.currentY > z.image.maxY) {
                    z.image.currentY = z.image.maxY - 1 + Math.pow((z.image.currentY - z.image.maxY + 1), 0.8);
                }
        
                //Velocity
                if (!z.velocity.prevPositionX) z.velocity.prevPositionX = z.image.touchesCurrent.x;
                if (!z.velocity.prevPositionY) z.velocity.prevPositionY = z.image.touchesCurrent.y;
                if (!z.velocity.prevTime) z.velocity.prevTime = Date.now();
                z.velocity.x = (z.image.touchesCurrent.x - z.velocity.prevPositionX) / (Date.now() - z.velocity.prevTime) / 2;
                z.velocity.y = (z.image.touchesCurrent.y - z.velocity.prevPositionY) / (Date.now() - z.velocity.prevTime) / 2;
                if (Math.abs(z.image.touchesCurrent.x - z.velocity.prevPositionX) < 2) z.velocity.x = 0;
                if (Math.abs(z.image.touchesCurrent.y - z.velocity.prevPositionY) < 2) z.velocity.y = 0;
                z.velocity.prevPositionX = z.image.touchesCurrent.x;
                z.velocity.prevPositionY = z.image.touchesCurrent.y;
                z.velocity.prevTime = Date.now();
        
                z.gesture.imageWrap.transform('translate3d(' + z.image.currentX + 'px, ' + z.image.currentY + 'px,0)');
            },
            onTouchEnd: function (s, e) {
                var z = s.zoom;
                if (!z.gesture.image || z.gesture.image.length === 0) return;
                if (!z.image.isTouched || !z.image.isMoved) {
                    z.image.isTouched = false;
                    z.image.isMoved = false;
                    return;
                }
                z.image.isTouched = false;
                z.image.isMoved = false;
                var momentumDurationX = 300;
                var momentumDurationY = 300;
                var momentumDistanceX = z.velocity.x * momentumDurationX;
                var newPositionX = z.image.currentX + momentumDistanceX;
                var momentumDistanceY = z.velocity.y * momentumDurationY;
                var newPositionY = z.image.currentY + momentumDistanceY;
        
                //Fix duration
                if (z.velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - z.image.currentX) / z.velocity.x);
                if (z.velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - z.image.currentY) / z.velocity.y);
                var momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        
                z.image.currentX = newPositionX;
                z.image.currentY = newPositionY;
        
                // Define if we need image drag
                var scaledWidth = z.image.width * z.scale;
                var scaledHeight = z.image.height * z.scale;
                z.image.minX = Math.min((z.gesture.slideWidth / 2 - scaledWidth / 2), 0);
                z.image.maxX = -z.image.minX;
                z.image.minY = Math.min((z.gesture.slideHeight / 2 - scaledHeight / 2), 0);
                z.image.maxY = -z.image.minY;
                z.image.currentX = Math.max(Math.min(z.image.currentX, z.image.maxX), z.image.minX);
                z.image.currentY = Math.max(Math.min(z.image.currentY, z.image.maxY), z.image.minY);
        
                z.gesture.imageWrap.transition(momentumDuration).transform('translate3d(' + z.image.currentX + 'px, ' + z.image.currentY + 'px,0)');
            },
            onTransitionEnd: function (s) {
                var z = s.zoom;
                if (z.gesture.slide && s.previousIndex !== s.activeIndex) {
                    z.gesture.image.transform('translate3d(0,0,0) scale(1)');
                    z.gesture.imageWrap.transform('translate3d(0,0,0)');
                    z.gesture.slide = z.gesture.image = z.gesture.imageWrap = undefined;
                    z.scale = z.currentScale = 1;
                }
            },
            // Toggle Zoom
            toggleZoom: function (s, e) {
                var z = s.zoom;
                if (!z.gesture.slide) {
                    z.gesture.slide = s.clickedSlide ? $(s.clickedSlide) : s.slides.eq(s.activeIndex);
                    z.gesture.image = z.gesture.slide.find('img, svg, canvas');
                    z.gesture.imageWrap = z.gesture.image.parent('.' + s.params.zoomContainerClass);
                }
                if (!z.gesture.image || z.gesture.image.length === 0) return;
        
                var touchX, touchY, offsetX, offsetY, diffX, diffY, translateX, translateY, imageWidth, imageHeight, scaledWidth, scaledHeight, translateMinX, translateMinY, translateMaxX, translateMaxY, slideWidth, slideHeight;
        
                if (typeof z.image.touchesStart.x === 'undefined' && e) {
                    touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
                    touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
                }
                else {
                    touchX = z.image.touchesStart.x;
                    touchY = z.image.touchesStart.y;
                }
        
                if (z.scale && z.scale !== 1) {
                    // Zoom Out
                    z.scale = z.currentScale = 1;
                    z.gesture.imageWrap.transition(300).transform('translate3d(0,0,0)');
                    z.gesture.image.transition(300).transform('translate3d(0,0,0) scale(1)');
                    z.gesture.slide = undefined;
                }
                else {
                    // Zoom In
                    z.scale = z.currentScale = z.gesture.imageWrap.attr('data-swiper-zoom') || s.params.zoomMax;
                    if (e) {
                        slideWidth = z.gesture.slide[0].offsetWidth;
                        slideHeight = z.gesture.slide[0].offsetHeight;
                        offsetX = z.gesture.slide.offset().left;
                        offsetY = z.gesture.slide.offset().top;
                        diffX = offsetX + slideWidth/2 - touchX;
                        diffY = offsetY + slideHeight/2 - touchY;
        
                        imageWidth = z.gesture.image[0].offsetWidth;
                        imageHeight = z.gesture.image[0].offsetHeight;
                        scaledWidth = imageWidth * z.scale;
                        scaledHeight = imageHeight * z.scale;
        
                        translateMinX = Math.min((slideWidth / 2 - scaledWidth / 2), 0);
                        translateMinY = Math.min((slideHeight / 2 - scaledHeight / 2), 0);
                        translateMaxX = -translateMinX;
                        translateMaxY = -translateMinY;
        
                        translateX = diffX * z.scale;
                        translateY = diffY * z.scale;
        
                        if (translateX < translateMinX) {
                            translateX =  translateMinX;
                        }
                        if (translateX > translateMaxX) {
                            translateX = translateMaxX;
                        }
        
                        if (translateY < translateMinY) {
                            translateY =  translateMinY;
                        }
                        if (translateY > translateMaxY) {
                            translateY = translateMaxY;
                        }
                    }
                    else {
                        translateX = 0;
                        translateY = 0;
                    }
                    z.gesture.imageWrap.transition(300).transform('translate3d(' + translateX + 'px, ' + translateY + 'px,0)');
                    z.gesture.image.transition(300).transform('translate3d(0,0,0) scale(' + z.scale + ')');
                }
            },
            // Attach/Detach Events
            attachEvents: function (detach) {
                var action = detach ? 'off' : 'on';
        
                if (s.params.zoom) {
                    var target = s.slides;
                    var passiveListener = s.touchEvents.start === 'touchstart' && s.support.passiveListener && s.params.passiveListeners ? {passive: true, capture: false} : false;
                    // Scale image
                    if (s.support.gestures) {
                        s.slides[action]('gesturestart', s.zoom.onGestureStart, passiveListener);
                        s.slides[action]('gesturechange', s.zoom.onGestureChange, passiveListener);
                        s.slides[action]('gestureend', s.zoom.onGestureEnd, passiveListener);
                    }
                    else if (s.touchEvents.start === 'touchstart') {
                        s.slides[action](s.touchEvents.start, s.zoom.onGestureStart, passiveListener);
                        s.slides[action](s.touchEvents.move, s.zoom.onGestureChange, passiveListener);
                        s.slides[action](s.touchEvents.end, s.zoom.onGestureEnd, passiveListener);
                    }
        
                    // Move image
                    s[action]('touchStart', s.zoom.onTouchStart);
                    s.slides.each(function (index, slide){
                        if ($(slide).find('.' + s.params.zoomContainerClass).length > 0) {
                            $(slide)[action](s.touchEvents.move, s.zoom.onTouchMove);
                        }
                    });
                    s[action]('touchEnd', s.zoom.onTouchEnd);
        
                    // Scale Out
                    s[action]('transitionEnd', s.zoom.onTransitionEnd);
                    if (s.params.zoomToggle) {
                        s.on('doubleTap', s.zoom.toggleZoom);
                    }
                }
            },
            init: function () {
                s.zoom.attachEvents();
            },
            destroy: function () {
                s.zoom.attachEvents(true);
            }
        };
        

        /*=========================
          Plugins API. Collect all and init all plugins
          ===========================*/
        s._plugins = [];
        for (var plugin in s.plugins) {
            var p = s.plugins[plugin](s, s.params[plugin]);
            if (p) s._plugins.push(p);
        }
        // Method to call all plugins event/method
        s.callPlugins = function (eventName) {
            for (var i = 0; i < s._plugins.length; i++) {
                if (eventName in s._plugins[i]) {
                    s._plugins[i][eventName](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
                }
            }
        };
        

        /*=========================
          Events/Callbacks/Plugins Emitter
          ===========================*/
        function normalizeEventName (eventName) {
            if (eventName.indexOf('on') !== 0) {
                if (eventName[0] !== eventName[0].toUpperCase()) {
                    eventName = 'on' + eventName[0].toUpperCase() + eventName.substring(1);
                }
                else {
                    eventName = 'on' + eventName;
                }
            }
            return eventName;
        }
        s.emitterEventListeners = {
        
        };
        s.emit = function (eventName) {
            // Trigger callbacks
            if (s.params[eventName]) {
                s.params[eventName](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
            }
            var i;
            // Trigger events
            if (s.emitterEventListeners[eventName]) {
                for (i = 0; i < s.emitterEventListeners[eventName].length; i++) {
                    s.emitterEventListeners[eventName][i](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
                }
            }
            // Trigger plugins
            if (s.callPlugins) s.callPlugins(eventName, arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
        };
        s.on = function (eventName, handler) {
            eventName = normalizeEventName(eventName);
            if (!s.emitterEventListeners[eventName]) s.emitterEventListeners[eventName] = [];
            s.emitterEventListeners[eventName].push(handler);
            return s;
        };
        s.off = function (eventName, handler) {
            var i;
            eventName = normalizeEventName(eventName);
            if (typeof handler === 'undefined') {
                // Remove all handlers for such event
                s.emitterEventListeners[eventName] = [];
                return s;
            }
            if (!s.emitterEventListeners[eventName] || s.emitterEventListeners[eventName].length === 0) return;
            for (i = 0; i < s.emitterEventListeners[eventName].length; i++) {
                if(s.emitterEventListeners[eventName][i] === handler) s.emitterEventListeners[eventName].splice(i, 1);
            }
            return s;
        };
        s.once = function (eventName, handler) {
            eventName = normalizeEventName(eventName);
            var _handler = function () {
                handler(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4]);
                s.off(eventName, _handler);
            };
            s.on(eventName, _handler);
            return s;
        };
        

        // Accessibility tools
        s.a11y = {
            makeFocusable: function ($el) {
                $el.attr('tabIndex', '0');
                return $el;
            },
            addRole: function ($el, role) {
                $el.attr('role', role);
                return $el;
            },
        
            addLabel: function ($el, label) {
                $el.attr('aria-label', label);
                return $el;
            },
        
            disable: function ($el) {
                $el.attr('aria-disabled', true);
                return $el;
            },
        
            enable: function ($el) {
                $el.attr('aria-disabled', false);
                return $el;
            },
        
            onEnterKey: function (event) {
                if (event.keyCode !== 13) return;
                if ($(event.target).is(s.params.nextButton)) {
                    s.onClickNext(event);
                    if (s.isEnd) {
                        s.a11y.notify(s.params.lastSlideMessage);
                    }
                    else {
                        s.a11y.notify(s.params.nextSlideMessage);
                    }
                }
                else if ($(event.target).is(s.params.prevButton)) {
                    s.onClickPrev(event);
                    if (s.isBeginning) {
                        s.a11y.notify(s.params.firstSlideMessage);
                    }
                    else {
                        s.a11y.notify(s.params.prevSlideMessage);
                    }
                }
                if ($(event.target).is('.' + s.params.bulletClass)) {
                    $(event.target)[0].click();
                }
            },
        
            liveRegion: $('<span class="' + s.params.notificationClass + '" aria-live="assertive" aria-atomic="true"></span>'),
        
            notify: function (message) {
                var notification = s.a11y.liveRegion;
                if (notification.length === 0) return;
                notification.html('');
                notification.html(message);
            },
            init: function () {
                // Setup accessibility
                if (s.params.nextButton && s.nextButton && s.nextButton.length > 0) {
                    s.a11y.makeFocusable(s.nextButton);
                    s.a11y.addRole(s.nextButton, 'button');
                    s.a11y.addLabel(s.nextButton, s.params.nextSlideMessage);
                }
                if (s.params.prevButton && s.prevButton && s.prevButton.length > 0) {
                    s.a11y.makeFocusable(s.prevButton);
                    s.a11y.addRole(s.prevButton, 'button');
                    s.a11y.addLabel(s.prevButton, s.params.prevSlideMessage);
                }
        
                $(s.container).append(s.a11y.liveRegion);
            },
            initPagination: function () {
                if (s.params.pagination && s.params.paginationClickable && s.bullets && s.bullets.length) {
                    s.bullets.each(function () {
                        var bullet = $(this);
                        s.a11y.makeFocusable(bullet);
                        s.a11y.addRole(bullet, 'button');
                        s.a11y.addLabel(bullet, s.params.paginationBulletMessage.replace(/{{index}}/, bullet.index() + 1));
                    });
                }
            },
            destroy: function () {
                if (s.a11y.liveRegion && s.a11y.liveRegion.length > 0) s.a11y.liveRegion.remove();
            }
        };
        

        /*=========================
          Init/Destroy
          ===========================*/
        s.init = function () {
            if (s.params.loop) s.createLoop();
            s.updateContainerSize();
            s.updateSlidesSize();
            s.updatePagination();
            if (s.params.scrollbar && s.scrollbar) {
                s.scrollbar.set();
                if (s.params.scrollbarDraggable) {
                    s.scrollbar.enableDraggable();
                }
            }
            if (s.params.effect !== 'slide' && s.effects[s.params.effect]) {
                if (!s.params.loop) s.updateProgress();
                s.effects[s.params.effect].setTranslate();
            }
            if (s.params.loop) {
                s.slideTo(s.params.initialSlide + s.loopedSlides, 0, s.params.runCallbacksOnInit);
            }
            else {
                s.slideTo(s.params.initialSlide, 0, s.params.runCallbacksOnInit);
                if (s.params.initialSlide === 0) {
                    if (s.parallax && s.params.parallax) s.parallax.setTranslate();
                    if (s.lazy && s.params.lazyLoading) {
                        s.lazy.load();
                        s.lazy.initialImageLoaded = true;
                    }
                }
            }
            s.attachEvents();
            if (s.params.observer && s.support.observer) {
                s.initObservers();
            }
            if (s.params.preloadImages && !s.params.lazyLoading) {
                s.preloadImages();
            }
            if (s.params.zoom && s.zoom) {
                s.zoom.init();
            }
            if (s.params.autoplay) {
                s.startAutoplay();
            }
            if (s.params.keyboardControl) {
                if (s.enableKeyboardControl) s.enableKeyboardControl();
            }
            if (s.params.mousewheelControl) {
                if (s.enableMousewheelControl) s.enableMousewheelControl();
            }
            // Deprecated hashnavReplaceState changed to replaceState for use in hashnav and history
            if (s.params.hashnavReplaceState) {
                s.params.replaceState = s.params.hashnavReplaceState;
            }
            if (s.params.history) {
                if (s.history) s.history.init();
            }
            if (s.params.hashnav) {
                if (s.hashnav) s.hashnav.init();
            }
            if (s.params.a11y && s.a11y) s.a11y.init();
            s.emit('onInit', s);
        };
        
        // Cleanup dynamic styles
        s.cleanupStyles = function () {
            // Container
            s.container.removeClass(s.classNames.join(' ')).removeAttr('style');
        
            // Wrapper
            s.wrapper.removeAttr('style');
        
            // Slides
            if (s.slides && s.slides.length) {
                s.slides
                    .removeClass([
                      s.params.slideVisibleClass,
                      s.params.slideActiveClass,
                      s.params.slideNextClass,
                      s.params.slidePrevClass
                    ].join(' '))
                    .removeAttr('style')
                    .removeAttr('data-swiper-column')
                    .removeAttr('data-swiper-row');
            }
        
            // Pagination/Bullets
            if (s.paginationContainer && s.paginationContainer.length) {
                s.paginationContainer.removeClass(s.params.paginationHiddenClass);
            }
            if (s.bullets && s.bullets.length) {
                s.bullets.removeClass(s.params.bulletActiveClass);
            }
        
            // Buttons
            if (s.params.prevButton) $(s.params.prevButton).removeClass(s.params.buttonDisabledClass);
            if (s.params.nextButton) $(s.params.nextButton).removeClass(s.params.buttonDisabledClass);
        
            // Scrollbar
            if (s.params.scrollbar && s.scrollbar) {
                if (s.scrollbar.track && s.scrollbar.track.length) s.scrollbar.track.removeAttr('style');
                if (s.scrollbar.drag && s.scrollbar.drag.length) s.scrollbar.drag.removeAttr('style');
            }
        };
        
        // Destroy
        s.destroy = function (deleteInstance, cleanupStyles) {
            // Detach evebts
            s.detachEvents();
            // Stop autoplay
            s.stopAutoplay();
            // Disable draggable
            if (s.params.scrollbar && s.scrollbar) {
                if (s.params.scrollbarDraggable) {
                    s.scrollbar.disableDraggable();
                }
            }
            // Destroy loop
            if (s.params.loop) {
                s.destroyLoop();
            }
            // Cleanup styles
            if (cleanupStyles) {
                s.cleanupStyles();
            }
            // Disconnect observer
            s.disconnectObservers();
        
            // Destroy zoom
            if (s.params.zoom && s.zoom) {
                s.zoom.destroy();
            }
            // Disable keyboard/mousewheel
            if (s.params.keyboardControl) {
                if (s.disableKeyboardControl) s.disableKeyboardControl();
            }
            if (s.params.mousewheelControl) {
                if (s.disableMousewheelControl) s.disableMousewheelControl();
            }
            // Disable a11y
            if (s.params.a11y && s.a11y) s.a11y.destroy();
            // Delete history popstate
            if (s.params.history && !s.params.replaceState) {
                window.removeEventListener('popstate', s.history.setHistoryPopState);
            }
            if (s.params.hashnav && s.hashnav)  {
                s.hashnav.destroy();
            }
            // Destroy callback
            s.emit('onDestroy');
            // Delete instance
            if (deleteInstance !== false) s = null;
        };
        
        s.init();
        

    
        // Return swiper instance
        return s;
    };
    

    /*==================================================
        Prototype
    ====================================================*/
    Swiper.prototype = {
        isSafari: (function () {
            var ua = window.navigator.userAgent.toLowerCase();
            return (ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0);
        })(),
        isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent),
        isArray: function (arr) {
            return Object.prototype.toString.apply(arr) === '[object Array]';
        },
        /*==================================================
        Browser
        ====================================================*/
        browser: {
            ie: window.navigator.pointerEnabled || window.navigator.msPointerEnabled,
            ieTouch: (window.navigator.msPointerEnabled && window.navigator.msMaxTouchPoints > 1) || (window.navigator.pointerEnabled && window.navigator.maxTouchPoints > 1),
            lteIE9: (function() {
                // create temporary DIV
                var div = document.createElement('div');
                // add content to tmp DIV which is wrapped into the IE HTML conditional statement
                div.innerHTML = '<!--[if lte IE 9]><i></i><![endif]-->';
                // return true / false value based on what will browser render
                return div.getElementsByTagName('i').length === 1;
            })()
        },
        /*==================================================
        Devices
        ====================================================*/
        device: (function () {
            var ua = window.navigator.userAgent;
            var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
            var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
            var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
            var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
            return {
                ios: ipad || iphone || ipod,
                android: android
            };
        })(),
        /*==================================================
        Feature Detection
        ====================================================*/
        support: {
            touch : (window.Modernizr && Modernizr.touch === true) || (function () {
                return !!(('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch);
            })(),
    
            transforms3d : (window.Modernizr && Modernizr.csstransforms3d === true) || (function () {
                var div = document.createElement('div').style;
                return ('webkitPerspective' in div || 'MozPerspective' in div || 'OPerspective' in div || 'MsPerspective' in div || 'perspective' in div);
            })(),
    
            flexbox: (function () {
                var div = document.createElement('div').style;
                var styles = ('alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient').split(' ');
                for (var i = 0; i < styles.length; i++) {
                    if (styles[i] in div) return true;
                }
            })(),
    
            observer: (function () {
                return ('MutationObserver' in window || 'WebkitMutationObserver' in window);
            })(),
    
            passiveListener: (function () {
                var supportsPassive = false;
                try {
                    var opts = Object.defineProperty({}, 'passive', {
                        get: function() {
                            supportsPassive = true;
                        }
                    });
                    window.addEventListener('testPassiveListener', null, opts);
                } catch (e) {}
                return supportsPassive;
            })(),
    
            gestures: (function () {
                return 'ongesturestart' in window;
            })()
        },
        /*==================================================
        Plugins
        ====================================================*/
        plugins: {}
    };
    

    /*===========================
    Dom7 Library
    ===========================*/
    var Dom7 = (function () {
        var Dom7 = function (arr) {
            var _this = this, i = 0;
            // Create array-like object
            for (i = 0; i < arr.length; i++) {
                _this[i] = arr[i];
            }
            _this.length = arr.length;
            // Return collection with methods
            return this;
        };
        var $ = function (selector, context) {
            var arr = [], i = 0;
            if (selector && !context) {
                if (selector instanceof Dom7) {
                    return selector;
                }
            }
            if (selector) {
                // String
                if (typeof selector === 'string') {
                    var els, tempParent, html = selector.trim();
                    if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
                        var toCreate = 'div';
                        if (html.indexOf('<li') === 0) toCreate = 'ul';
                        if (html.indexOf('<tr') === 0) toCreate = 'tbody';
                        if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
                        if (html.indexOf('<tbody') === 0) toCreate = 'table';
                        if (html.indexOf('<option') === 0) toCreate = 'select';
                        tempParent = document.createElement(toCreate);
                        tempParent.innerHTML = selector;
                        for (i = 0; i < tempParent.childNodes.length; i++) {
                            arr.push(tempParent.childNodes[i]);
                        }
                    }
                    else {
                        if (!context && selector[0] === '#' && !selector.match(/[ .<>:~]/)) {
                            // Pure ID selector
                            els = [document.getElementById(selector.split('#')[1])];
                        }
                        else {
                            // Other selectors
                            els = (context || document).querySelectorAll(selector);
                        }
                        for (i = 0; i < els.length; i++) {
                            if (els[i]) arr.push(els[i]);
                        }
                    }
                }
                // Node/element
                else if (selector.nodeType || selector === window || selector === document) {
                    arr.push(selector);
                }
                //Array of elements or instance of Dom
                else if (selector.length > 0 && selector[0].nodeType) {
                    for (i = 0; i < selector.length; i++) {
                        arr.push(selector[i]);
                    }
                }
            }
            return new Dom7(arr);
        };
        Dom7.prototype = {
            // Classes and attriutes
            addClass: function (className) {
                if (typeof className === 'undefined') {
                    return this;
                }
                var classes = className.split(' ');
                for (var i = 0; i < classes.length; i++) {
                    for (var j = 0; j < this.length; j++) {
                        this[j].classList.add(classes[i]);
                    }
                }
                return this;
            },
            removeClass: function (className) {
                var classes = className.split(' ');
                for (var i = 0; i < classes.length; i++) {
                    for (var j = 0; j < this.length; j++) {
                        this[j].classList.remove(classes[i]);
                    }
                }
                return this;
            },
            hasClass: function (className) {
                if (!this[0]) return false;
                else return this[0].classList.contains(className);
            },
            toggleClass: function (className) {
                var classes = className.split(' ');
                for (var i = 0; i < classes.length; i++) {
                    for (var j = 0; j < this.length; j++) {
                        this[j].classList.toggle(classes[i]);
                    }
                }
                return this;
            },
            attr: function (attrs, value) {
                if (arguments.length === 1 && typeof attrs === 'string') {
                    // Get attr
                    if (this[0]) return this[0].getAttribute(attrs);
                    else return undefined;
                }
                else {
                    // Set attrs
                    for (var i = 0; i < this.length; i++) {
                        if (arguments.length === 2) {
                            // String
                            this[i].setAttribute(attrs, value);
                        }
                        else {
                            // Object
                            for (var attrName in attrs) {
                                this[i][attrName] = attrs[attrName];
                                this[i].setAttribute(attrName, attrs[attrName]);
                            }
                        }
                    }
                    return this;
                }
            },
            removeAttr: function (attr) {
                for (var i = 0; i < this.length; i++) {
                    this[i].removeAttribute(attr);
                }
                return this;
            },
            data: function (key, value) {
                if (typeof value === 'undefined') {
                    // Get value
                    if (this[0]) {
                        var dataKey = this[0].getAttribute('data-' + key);
                        if (dataKey) return dataKey;
                        else if (this[0].dom7ElementDataStorage && (key in this[0].dom7ElementDataStorage)) return this[0].dom7ElementDataStorage[key];
                        else return undefined;
                    }
                    else return undefined;
                }
                else {
                    // Set value
                    for (var i = 0; i < this.length; i++) {
                        var el = this[i];
                        if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
                        el.dom7ElementDataStorage[key] = value;
                    }
                    return this;
                }
            },
            // Transforms
            transform : function (transform) {
                for (var i = 0; i < this.length; i++) {
                    var elStyle = this[i].style;
                    elStyle.webkitTransform = elStyle.MsTransform = elStyle.msTransform = elStyle.MozTransform = elStyle.OTransform = elStyle.transform = transform;
                }
                return this;
            },
            transition: function (duration) {
                if (typeof duration !== 'string') {
                    duration = duration + 'ms';
                }
                for (var i = 0; i < this.length; i++) {
                    var elStyle = this[i].style;
                    elStyle.webkitTransitionDuration = elStyle.MsTransitionDuration = elStyle.msTransitionDuration = elStyle.MozTransitionDuration = elStyle.OTransitionDuration = elStyle.transitionDuration = duration;
                }
                return this;
            },
            //Events
            on: function (eventName, targetSelector, listener, capture) {
                function handleLiveEvent(e) {
                    var target = e.target;
                    if ($(target).is(targetSelector)) listener.call(target, e);
                    else {
                        var parents = $(target).parents();
                        for (var k = 0; k < parents.length; k++) {
                            if ($(parents[k]).is(targetSelector)) listener.call(parents[k], e);
                        }
                    }
                }
                var events = eventName.split(' ');
                var i, j;
                for (i = 0; i < this.length; i++) {
                    if (typeof targetSelector === 'function' || targetSelector === false) {
                        // Usual events
                        if (typeof targetSelector === 'function') {
                            listener = arguments[1];
                            capture = arguments[2] || false;
                        }
                        for (j = 0; j < events.length; j++) {
                            this[i].addEventListener(events[j], listener, capture);
                        }
                    }
                    else {
                        //Live events
                        for (j = 0; j < events.length; j++) {
                            if (!this[i].dom7LiveListeners) this[i].dom7LiveListeners = [];
                            this[i].dom7LiveListeners.push({listener: listener, liveListener: handleLiveEvent});
                            this[i].addEventListener(events[j], handleLiveEvent, capture);
                        }
                    }
                }
    
                return this;
            },
            off: function (eventName, targetSelector, listener, capture) {
                var events = eventName.split(' ');
                for (var i = 0; i < events.length; i++) {
                    for (var j = 0; j < this.length; j++) {
                        if (typeof targetSelector === 'function' || targetSelector === false) {
                            // Usual events
                            if (typeof targetSelector === 'function') {
                                listener = arguments[1];
                                capture = arguments[2] || false;
                            }
                            this[j].removeEventListener(events[i], listener, capture);
                        }
                        else {
                            // Live event
                            if (this[j].dom7LiveListeners) {
                                for (var k = 0; k < this[j].dom7LiveListeners.length; k++) {
                                    if (this[j].dom7LiveListeners[k].listener === listener) {
                                        this[j].removeEventListener(events[i], this[j].dom7LiveListeners[k].liveListener, capture);
                                    }
                                }
                            }
                        }
                    }
                }
                return this;
            },
            once: function (eventName, targetSelector, listener, capture) {
                var dom = this;
                if (typeof targetSelector === 'function') {
                    targetSelector = false;
                    listener = arguments[1];
                    capture = arguments[2];
                }
                function proxy(e) {
                    listener(e);
                    dom.off(eventName, targetSelector, proxy, capture);
                }
                dom.on(eventName, targetSelector, proxy, capture);
            },
            trigger: function (eventName, eventData) {
                for (var i = 0; i < this.length; i++) {
                    var evt;
                    try {
                        evt = new window.CustomEvent(eventName, {detail: eventData, bubbles: true, cancelable: true});
                    }
                    catch (e) {
                        evt = document.createEvent('Event');
                        evt.initEvent(eventName, true, true);
                        evt.detail = eventData;
                    }
                    this[i].dispatchEvent(evt);
                }
                return this;
            },
            transitionEnd: function (callback) {
                var events = ['webkitTransitionEnd', 'transitionend', 'oTransitionEnd', 'MSTransitionEnd', 'msTransitionEnd'],
                    i, j, dom = this;
                function fireCallBack(e) {
                    /*jshint validthis:true */
                    if (e.target !== this) return;
                    callback.call(this, e);
                    for (i = 0; i < events.length; i++) {
                        dom.off(events[i], fireCallBack);
                    }
                }
                if (callback) {
                    for (i = 0; i < events.length; i++) {
                        dom.on(events[i], fireCallBack);
                    }
                }
                return this;
            },
            // Sizing/Styles
            width: function () {
                if (this[0] === window) {
                    return window.innerWidth;
                }
                else {
                    if (this.length > 0) {
                        return parseFloat(this.css('width'));
                    }
                    else {
                        return null;
                    }
                }
            },
            outerWidth: function (includeMargins) {
                if (this.length > 0) {
                    if (includeMargins)
                        return this[0].offsetWidth + parseFloat(this.css('margin-right')) + parseFloat(this.css('margin-left'));
                    else
                        return this[0].offsetWidth;
                }
                else return null;
            },
            height: function () {
                if (this[0] === window) {
                    return window.innerHeight;
                }
                else {
                    if (this.length > 0) {
                        return parseFloat(this.css('height'));
                    }
                    else {
                        return null;
                    }
                }
            },
            outerHeight: function (includeMargins) {
                if (this.length > 0) {
                    if (includeMargins)
                        return this[0].offsetHeight + parseFloat(this.css('margin-top')) + parseFloat(this.css('margin-bottom'));
                    else
                        return this[0].offsetHeight;
                }
                else return null;
            },
            offset: function () {
                if (this.length > 0) {
                    var el = this[0];
                    var box = el.getBoundingClientRect();
                    var body = document.body;
                    var clientTop  = el.clientTop  || body.clientTop  || 0;
                    var clientLeft = el.clientLeft || body.clientLeft || 0;
                    var scrollTop  = window.pageYOffset || el.scrollTop;
                    var scrollLeft = window.pageXOffset || el.scrollLeft;
                    return {
                        top: box.top  + scrollTop  - clientTop,
                        left: box.left + scrollLeft - clientLeft
                    };
                }
                else {
                    return null;
                }
            },
            css: function (props, value) {
                var i;
                if (arguments.length === 1) {
                    if (typeof props === 'string') {
                        if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
                    }
                    else {
                        for (i = 0; i < this.length; i++) {
                            for (var prop in props) {
                                this[i].style[prop] = props[prop];
                            }
                        }
                        return this;
                    }
                }
                if (arguments.length === 2 && typeof props === 'string') {
                    for (i = 0; i < this.length; i++) {
                        this[i].style[props] = value;
                    }
                    return this;
                }
                return this;
            },
    
            //Dom manipulation
            each: function (callback) {
                for (var i = 0; i < this.length; i++) {
                    callback.call(this[i], i, this[i]);
                }
                return this;
            },
            html: function (html) {
                if (typeof html === 'undefined') {
                    return this[0] ? this[0].innerHTML : undefined;
                }
                else {
                    for (var i = 0; i < this.length; i++) {
                        this[i].innerHTML = html;
                    }
                    return this;
                }
            },
            text: function (text) {
                if (typeof text === 'undefined') {
                    if (this[0]) {
                        return this[0].textContent.trim();
                    }
                    else return null;
                }
                else {
                    for (var i = 0; i < this.length; i++) {
                        this[i].textContent = text;
                    }
                    return this;
                }
            },
            is: function (selector) {
                if (!this[0]) return false;
                var compareWith, i;
                if (typeof selector === 'string') {
                    var el = this[0];
                    if (el === document) return selector === document;
                    if (el === window) return selector === window;
    
                    if (el.matches) return el.matches(selector);
                    else if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
                    else if (el.mozMatchesSelector) return el.mozMatchesSelector(selector);
                    else if (el.msMatchesSelector) return el.msMatchesSelector(selector);
                    else {
                        compareWith = $(selector);
                        for (i = 0; i < compareWith.length; i++) {
                            if (compareWith[i] === this[0]) return true;
                        }
                        return false;
                    }
                }
                else if (selector === document) return this[0] === document;
                else if (selector === window) return this[0] === window;
                else {
                    if (selector.nodeType || selector instanceof Dom7) {
                        compareWith = selector.nodeType ? [selector] : selector;
                        for (i = 0; i < compareWith.length; i++) {
                            if (compareWith[i] === this[0]) return true;
                        }
                        return false;
                    }
                    return false;
                }
    
            },
            index: function () {
                if (this[0]) {
                    var child = this[0];
                    var i = 0;
                    while ((child = child.previousSibling) !== null) {
                        if (child.nodeType === 1) i++;
                    }
                    return i;
                }
                else return undefined;
            },
            eq: function (index) {
                if (typeof index === 'undefined') return this;
                var length = this.length;
                var returnIndex;
                if (index > length - 1) {
                    return new Dom7([]);
                }
                if (index < 0) {
                    returnIndex = length + index;
                    if (returnIndex < 0) return new Dom7([]);
                    else return new Dom7([this[returnIndex]]);
                }
                return new Dom7([this[index]]);
            },
            append: function (newChild) {
                var i, j;
                for (i = 0; i < this.length; i++) {
                    if (typeof newChild === 'string') {
                        var tempDiv = document.createElement('div');
                        tempDiv.innerHTML = newChild;
                        while (tempDiv.firstChild) {
                            this[i].appendChild(tempDiv.firstChild);
                        }
                    }
                    else if (newChild instanceof Dom7) {
                        for (j = 0; j < newChild.length; j++) {
                            this[i].appendChild(newChild[j]);
                        }
                    }
                    else {
                        this[i].appendChild(newChild);
                    }
                }
                return this;
            },
            prepend: function (newChild) {
                var i, j;
                for (i = 0; i < this.length; i++) {
                    if (typeof newChild === 'string') {
                        var tempDiv = document.createElement('div');
                        tempDiv.innerHTML = newChild;
                        for (j = tempDiv.childNodes.length - 1; j >= 0; j--) {
                            this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
                        }
                        // this[i].insertAdjacentHTML('afterbegin', newChild);
                    }
                    else if (newChild instanceof Dom7) {
                        for (j = 0; j < newChild.length; j++) {
                            this[i].insertBefore(newChild[j], this[i].childNodes[0]);
                        }
                    }
                    else {
                        this[i].insertBefore(newChild, this[i].childNodes[0]);
                    }
                }
                return this;
            },
            insertBefore: function (selector) {
                var before = $(selector);
                for (var i = 0; i < this.length; i++) {
                    if (before.length === 1) {
                        before[0].parentNode.insertBefore(this[i], before[0]);
                    }
                    else if (before.length > 1) {
                        for (var j = 0; j < before.length; j++) {
                            before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
                        }
                    }
                }
            },
            insertAfter: function (selector) {
                var after = $(selector);
                for (var i = 0; i < this.length; i++) {
                    if (after.length === 1) {
                        after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
                    }
                    else if (after.length > 1) {
                        for (var j = 0; j < after.length; j++) {
                            after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
                        }
                    }
                }
            },
            next: function (selector) {
                if (this.length > 0) {
                    if (selector) {
                        if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) return new Dom7([this[0].nextElementSibling]);
                        else return new Dom7([]);
                    }
                    else {
                        if (this[0].nextElementSibling) return new Dom7([this[0].nextElementSibling]);
                        else return new Dom7([]);
                    }
                }
                else return new Dom7([]);
            },
            nextAll: function (selector) {
                var nextEls = [];
                var el = this[0];
                if (!el) return new Dom7([]);
                while (el.nextElementSibling) {
                    var next = el.nextElementSibling;
                    if (selector) {
                        if($(next).is(selector)) nextEls.push(next);
                    }
                    else nextEls.push(next);
                    el = next;
                }
                return new Dom7(nextEls);
            },
            prev: function (selector) {
                if (this.length > 0) {
                    if (selector) {
                        if (this[0].previousElementSibling && $(this[0].previousElementSibling).is(selector)) return new Dom7([this[0].previousElementSibling]);
                        else return new Dom7([]);
                    }
                    else {
                        if (this[0].previousElementSibling) return new Dom7([this[0].previousElementSibling]);
                        else return new Dom7([]);
                    }
                }
                else return new Dom7([]);
            },
            prevAll: function (selector) {
                var prevEls = [];
                var el = this[0];
                if (!el) return new Dom7([]);
                while (el.previousElementSibling) {
                    var prev = el.previousElementSibling;
                    if (selector) {
                        if($(prev).is(selector)) prevEls.push(prev);
                    }
                    else prevEls.push(prev);
                    el = prev;
                }
                return new Dom7(prevEls);
            },
            parent: function (selector) {
                var parents = [];
                for (var i = 0; i < this.length; i++) {
                    if (selector) {
                        if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
                    }
                    else {
                        parents.push(this[i].parentNode);
                    }
                }
                return $($.unique(parents));
            },
            parents: function (selector) {
                var parents = [];
                for (var i = 0; i < this.length; i++) {
                    var parent = this[i].parentNode;
                    while (parent) {
                        if (selector) {
                            if ($(parent).is(selector)) parents.push(parent);
                        }
                        else {
                            parents.push(parent);
                        }
                        parent = parent.parentNode;
                    }
                }
                return $($.unique(parents));
            },
            find : function (selector) {
                var foundElements = [];
                for (var i = 0; i < this.length; i++) {
                    var found = this[i].querySelectorAll(selector);
                    for (var j = 0; j < found.length; j++) {
                        foundElements.push(found[j]);
                    }
                }
                return new Dom7(foundElements);
            },
            children: function (selector) {
                var children = [];
                for (var i = 0; i < this.length; i++) {
                    var childNodes = this[i].childNodes;
    
                    for (var j = 0; j < childNodes.length; j++) {
                        if (!selector) {
                            if (childNodes[j].nodeType === 1) children.push(childNodes[j]);
                        }
                        else {
                            if (childNodes[j].nodeType === 1 && $(childNodes[j]).is(selector)) children.push(childNodes[j]);
                        }
                    }
                }
                return new Dom7($.unique(children));
            },
            remove: function () {
                for (var i = 0; i < this.length; i++) {
                    if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
                }
                return this;
            },
            add: function () {
                var dom = this;
                var i, j;
                for (i = 0; i < arguments.length; i++) {
                    var toAdd = $(arguments[i]);
                    for (j = 0; j < toAdd.length; j++) {
                        dom[dom.length] = toAdd[j];
                        dom.length++;
                    }
                }
                return dom;
            }
        };
        $.fn = Dom7.prototype;
        $.unique = function (arr) {
            var unique = [];
            for (var i = 0; i < arr.length; i++) {
                if (unique.indexOf(arr[i]) === -1) unique.push(arr[i]);
            }
            return unique;
        };
    
        return $;
    })();
    

    /*===========================
     Get Dom libraries
     ===========================*/
    var swiperDomPlugins = ['jQuery', 'Zepto', 'Dom7'];
    for (var i = 0; i < swiperDomPlugins.length; i++) {
    	if (window[swiperDomPlugins[i]]) {
    		addLibraryPlugin(window[swiperDomPlugins[i]]);
    	}
    }
    // Required DOM Plugins
    var domLib;
    if (typeof Dom7 === 'undefined') {
    	domLib = window.Dom7 || window.Zepto || window.jQuery;
    }
    else {
    	domLib = Dom7;
    }
    

    /*===========================
    Add .swiper plugin from Dom libraries
    ===========================*/
    function addLibraryPlugin(lib) {
        lib.fn.swiper = function (params) {
            var firstInstance;
            lib(this).each(function () {
                var s = new Swiper(this, params);
                if (!firstInstance) firstInstance = s;
            });
            return firstInstance;
        };
    }
    
    if (domLib) {
        if (!('transitionEnd' in domLib.fn)) {
            domLib.fn.transitionEnd = function (callback) {
                var events = ['webkitTransitionEnd', 'transitionend', 'oTransitionEnd', 'MSTransitionEnd', 'msTransitionEnd'],
                    i, j, dom = this;
                function fireCallBack(e) {
                    /*jshint validthis:true */
                    if (e.target !== this) return;
                    callback.call(this, e);
                    for (i = 0; i < events.length; i++) {
                        dom.off(events[i], fireCallBack);
                    }
                }
                if (callback) {
                    for (i = 0; i < events.length; i++) {
                        dom.on(events[i], fireCallBack);
                    }
                }
                return this;
            };
        }
        if (!('transform' in domLib.fn)) {
            domLib.fn.transform = function (transform) {
                for (var i = 0; i < this.length; i++) {
                    var elStyle = this[i].style;
                    elStyle.webkitTransform = elStyle.MsTransform = elStyle.msTransform = elStyle.MozTransform = elStyle.OTransform = elStyle.transform = transform;
                }
                return this;
            };
        }
        if (!('transition' in domLib.fn)) {
            domLib.fn.transition = function (duration) {
                if (typeof duration !== 'string') {
                    duration = duration + 'ms';
                }
                for (var i = 0; i < this.length; i++) {
                    var elStyle = this[i].style;
                    elStyle.webkitTransitionDuration = elStyle.MsTransitionDuration = elStyle.msTransitionDuration = elStyle.MozTransitionDuration = elStyle.OTransitionDuration = elStyle.transitionDuration = duration;
                }
                return this;
            };
        }
        if (!('outerWidth' in domLib.fn)) {
            domLib.fn.outerWidth = function (includeMargins) {
                if (this.length > 0) {
                    if (includeMargins)
                        return this[0].offsetWidth + parseFloat(this.css('margin-right')) + parseFloat(this.css('margin-left'));
                    else
                        return this[0].offsetWidth;
                }
                else return null;
            };
        }
    }
    

    window.Swiper = Swiper;
})();

/*===========================
Swiper AMD Export
===========================*/
if (true)
{
    module.exports = window.Swiper;
}
else if (typeof define === 'function' && define.amd) {
    define([], function () {
        'use strict';
        return window.Swiper;
    });
}

//# sourceMappingURL=maps/swiper.js.map


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports=function(modules){function __webpack_require__(moduleId){if(installedModules[moduleId])return installedModules[moduleId].exports;var module=installedModules[moduleId]={i:moduleId,l:!1,exports:{}};return modules[moduleId].call(module.exports,module,module.exports,__webpack_require__),module.l=!0,module.exports}var installedModules={};return __webpack_require__.m=modules,__webpack_require__.c=installedModules,__webpack_require__.i=function(value){return value},__webpack_require__.d=function(exports,name,getter){__webpack_require__.o(exports,name)||Object.defineProperty(exports,name,{configurable:!1,enumerable:!0,get:getter})},__webpack_require__.n=function(module){var getter=module&&module.__esModule?function(){return module.default}:function(){return module};return __webpack_require__.d(getter,"a",getter),getter},__webpack_require__.o=function(object,property){return Object.prototype.hasOwnProperty.call(object,property)},__webpack_require__.p="",__webpack_require__(__webpack_require__.s=1)}([function(module,exports,__webpack_require__){var Component=__webpack_require__(5)(__webpack_require__(4),__webpack_require__(6),null,null);module.exports=Component.exports},function(module,__webpack_exports__,__webpack_require__){"use strict";function install(Vue){Vue.component("circle-slider",__WEBPACK_IMPORTED_MODULE_0__components_CircleSlider_vue___default.a)}Object.defineProperty(__webpack_exports__,"__esModule",{value:!0}),__webpack_exports__.install=install;var __WEBPACK_IMPORTED_MODULE_0__components_CircleSlider_vue__=__webpack_require__(0),__WEBPACK_IMPORTED_MODULE_0__components_CircleSlider_vue___default=__webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_CircleSlider_vue__);__webpack_require__.d(__webpack_exports__,"CircleSlider",function(){return __WEBPACK_IMPORTED_MODULE_0__components_CircleSlider_vue___default.a});var plugin={version:"1.0.0",install:install};__webpack_exports__.default=plugin;var GlobalVue=null;"undefined"!=typeof window?GlobalVue=window.Vue:"undefined"!=typeof global&&(GlobalVue=global.Vue),GlobalVue&&GlobalVue.use(plugin)},function(module,__webpack_exports__,__webpack_require__){"use strict";function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError("Cannot call a class as a function")}var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,"value"in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),CircleSliderState=function(){function CircleSliderState(steps,offset,initialValue){_classCallCheck(this,CircleSliderState),this.steps=steps,this.offset=offset,this.currentStepIndex=0;for(var stepIndex in this.steps)if(this.steps[stepIndex]===initialValue){this.currentStepIndex=stepIndex;break}this.firstStep=this.steps[0],this.lastStep=this.steps[this.steps.length-1],this.length=this.steps.length}return _createClass(CircleSliderState,[{key:"updateCurrentStepFromValue",value:function(value){for(var i=0;i<this.length;i++)if(value<=this.steps[i])return void(this.currentStepIndex=i);this.currentStepIndex=this.length-1}},{key:"updateCurrentStepFromAngle",value:function(angle){var stepIndex=Math.floor((angle-this.offset)/this.angleUnit);this.currentStepIndex=Math.min(Math.max(stepIndex,0),this.length-1)}},{key:"angleUnit",get:function(){return(2*Math.PI-this.offset)/this.length}},{key:"angleValue",get:function(){return Math.min(this.offset+this.angleUnit*this.currentStepIndex,2*Math.PI-Number.EPSILON)}},{key:"currentStep",get:function(){return this.steps[this.currentStepIndex]}}]),CircleSliderState}();__webpack_exports__.a=CircleSliderState},function(module,__webpack_exports__,__webpack_require__){"use strict";function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError("Cannot call a class as a function")}var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,"value"in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),TouchPosition=function(){function TouchPosition(containerElement,sliderRadius,sliderTolerance){_classCallCheck(this,TouchPosition),this.containerElement=containerElement,this.sliderRadius=sliderRadius,this.sliderTolerance=sliderTolerance,this.setNewPosition({x:0,y:0})}return _createClass(TouchPosition,[{key:"setNewPosition",value:function(e){var dimensions=this.containerElement.getBoundingClientRect(),side=dimensions.width;this.center=side/2,this.relativeX=e.x-dimensions.left,this.relativeY=e.y-dimensions.top}},{key:"sliderAngle",get:function(){return(Math.atan2(this.relativeY-this.center,this.relativeX-this.center)+3*Math.PI/2)%(2*Math.PI)}},{key:"isTouchWithinSliderRange",get:function(){var touchOffset=Math.sqrt(Math.pow(Math.abs(this.relativeX-this.center),2)+Math.pow(Math.abs(this.relativeY-this.center),2));return Math.abs(touchOffset-this.sliderRadius)<=this.sliderTolerance}}]),TouchPosition}();__webpack_exports__.a=TouchPosition},function(module,__webpack_exports__,__webpack_require__){"use strict";Object.defineProperty(__webpack_exports__,"__esModule",{value:!0});var __WEBPACK_IMPORTED_MODULE_0__modules_touch_position_js__=__webpack_require__(3),__WEBPACK_IMPORTED_MODULE_1__modules_circle_slider_state_js__=__webpack_require__(2);__webpack_exports__.default={name:"CircleSlider",created:function(){var _this=this;this.stepsCount=1+(this.max-this.min)/this.stepSize,this.steps=Array.from({length:this.stepsCount},function(_,i){return _this.min+i*_this.stepSize}),this.circleSliderState=new __WEBPACK_IMPORTED_MODULE_1__modules_circle_slider_state_js__.a(this.steps,this.startAngleOffset,this.value),this.angle=this.circleSliderState.angleValue,this.currentStepValue=this.circleSliderState.currentStep;var maxCurveWidth=Math.max(this.cpMainCircleStrokeWidth,this.cpPathStrokeWidth);this.radius=this.side/2-Math.max(maxCurveWidth,2*this.cpKnobRadius)/2,this.updateFromPropValue(this.value)},mounted:function(){this.touchPosition=new __WEBPACK_IMPORTED_MODULE_0__modules_touch_position_js__.a(this.$refs._svg,this.radius,this.radius/2)},props:{startAngleOffset:{type:Number,required:!1,default:function(){return 0}},value:{type:Number,required:!1,default:0},side:{type:Number,required:!1,default:100},stepSize:{type:Number,required:!1,default:1},min:{type:Number,required:!1,default:0},max:{type:Number,required:!1,default:100},circleColor:{type:String,required:!1,default:"#334860"},progressColor:{type:String,required:!1,default:"#00be7e"},knobColor:{type:String,required:!1,default:"#00be7e"},knobRadius:{type:Number,required:!1,default:null},knobRadiusRel:{type:Number,required:!1,default:7},circleWidth:{type:Number,required:!1,default:null},circleWidthRel:{type:Number,required:!1,default:20},progressWidth:{type:Number,required:!1,default:null},progressWidthRel:{type:Number,required:!1,default:10}},data:function(){return{steps:null,stepsCount:null,radius:0,angle:0,currentStepValue:0,mousePressed:!1,circleSliderState:null,mousemoveTicks:0}},computed:{cpCenter:function(){return this.side/2},cpAngle:function(){return this.angle+Math.PI/2},cpMainCircleStrokeWidth:function(){return this.circleWidth||this.side/2/this.circleWidthRel},cpPathDirection:function(){return this.cpAngle<1.5*Math.PI?0:1},cpPathX:function(){return this.cpCenter+this.radius*Math.cos(this.cpAngle)},cpPathY:function(){return this.cpCenter+this.radius*Math.sin(this.cpAngle)},cpPathStrokeWidth:function(){return this.progressWidth||this.side/2/this.progressWidthRel},cpKnobRadius:function(){return this.knobRadius||this.side/2/this.knobRadiusRel},cpPathD:function(){var parts=[];return parts.push("M"+this.cpCenter),parts.push(this.cpCenter+this.radius),parts.push("A"),parts.push(this.radius),parts.push(this.radius),parts.push(0),parts.push(this.cpPathDirection),parts.push(1),parts.push(this.cpPathX),parts.push(this.cpPathY),parts.join(" ")}},methods:{fitToStep:function(val){return Math.round(val/this.stepSize)*this.stepSize},handleClick:function(e){if(this.touchPosition.setNewPosition(e),this.touchPosition.isTouchWithinSliderRange){var newAngle=this.touchPosition.sliderAngle;this.animateSlider(this.angle,newAngle)}},handleMouseDown:function(e){e.preventDefault(),this.mousePressed=!0,window.addEventListener("mousemove",this.handleWindowMouseMove),window.addEventListener("mouseup",this.handleMouseUp)},handleMouseUp:function(e){e.preventDefault(),this.mousePressed=!1,window.removeEventListener("mousemove",this.handleWindowMouseMove),window.removeEventListener("mouseup",this.handleMouseUp),this.mousemoveTicks=0},handleWindowMouseMove:function(e){if(e.preventDefault(),this.mousemoveTicks<5)return void this.mousemoveTicks++;this.touchPosition.setNewPosition(e),this.updateSlider()},handleTouchMove:function(e){if(this.$emit("touchmove"),e.targetTouches.length>1||e.changedTouches.length>1||e.touches.length>1)return!0;var lastTouch=e.targetTouches.item(e.targetTouches.length-1);this.touchPosition.setNewPosition(lastTouch),this.touchPosition.isTouchWithinSliderRange&&(e.preventDefault(),this.updateSlider())},updateAngle:function(angle){this.circleSliderState.updateCurrentStepFromAngle(angle),this.angle=this.circleSliderState.angleValue,this.currentStepValue=this.circleSliderState.currentStep,this.$emit("input",this.currentStepValue)},updateFromPropValue:function(value){var stepValue=this.fitToStep(value);this.circleSliderState.updateCurrentStepFromValue(stepValue),this.angle=this.circleSliderState.angleValue,this.currentStepValue=stepValue,this.$emit("input",this.currentStepValue)},updateSlider:function(){var angle=this.touchPosition.sliderAngle;Math.abs(angle-this.angle)<Math.PI&&this.updateAngle(angle)},animateSlider:function(startAngle,endAngle){var _this2=this,direction=startAngle<endAngle?1:-1,curveAngleMovementUnit=direction*this.circleSliderState.angleUnit*2,animate=function(){if(Math.abs(endAngle-startAngle)<Math.abs(2*curveAngleMovementUnit))_this2.updateAngle(endAngle);else{var newAngle=startAngle+curveAngleMovementUnit;_this2.updateAngle(newAngle),_this2.animateSlider(newAngle,endAngle)}};window.requestAnimationFrame(animate)}},watch:{value:function(val){this.updateFromPropValue(val)}}}},function(module,exports){module.exports=function(rawScriptExports,compiledTemplate,scopeId,cssModules){var esModule,scriptExports=rawScriptExports=rawScriptExports||{},type=typeof rawScriptExports.default;"object"!==type&&"function"!==type||(esModule=rawScriptExports,scriptExports=rawScriptExports.default);var options="function"==typeof scriptExports?scriptExports.options:scriptExports;if(compiledTemplate&&(options.render=compiledTemplate.render,options.staticRenderFns=compiledTemplate.staticRenderFns),scopeId&&(options._scopeId=scopeId),cssModules){var computed=options.computed||(options.computed={});Object.keys(cssModules).forEach(function(key){var module=cssModules[key];computed[key]=function(){return module}})}return{esModule:esModule,exports:scriptExports,options:options}}},function(module,exports){module.exports={render:function(){var _vm=this,_h=_vm.$createElement,_c=_vm._self._c||_h;return _c("div",[_c("svg",{ref:"_svg",attrs:{width:_vm.side+"px",height:_vm.side+"px",viewBox:"0 0 "+_vm.side+" "+_vm.side},on:{touchmove:_vm.handleTouchMove,click:_vm.handleClick,mousedown:_vm.handleMouseDown,mouseup:_vm.handleMouseUp}},[_c("g",[_c("circle",{attrs:{stroke:_vm.circleColor,fill:"none","stroke-width":_vm.cpMainCircleStrokeWidth,cx:_vm.cpCenter,cy:_vm.cpCenter,r:_vm.radius}}),_vm._v(" "),_c("path",{attrs:{stroke:_vm.progressColor,fill:"none","stroke-width":_vm.cpPathStrokeWidth,d:_vm.cpPathD}}),_vm._v(" "),_c("circle",{attrs:{fill:_vm.knobColor,r:_vm.cpKnobRadius,cx:_vm.cpPathX,cy:_vm.cpPathY}})])])])},staticRenderFns:[]}}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(505),
  /* template */
  __webpack_require__(2140),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(511),
  /* template */
  __webpack_require__(2117),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(518),
  /* template */
  __webpack_require__(2150),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

//This piece of code was orignally written by amirnissim and can be seen here
//http://stackoverflow.com/a/11703018/2694653
//This has been ported to Vanilla.js by GuillaumeLeclerc
exports.default = function (input) {
  var _addEventListener = input.addEventListener ? input.addEventListener : input.attachEvent;

  function addEventListenerWrapper(type, listener) {
    // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected,
    // and then trigger the original listener.
    if (type == 'keydown') {
      var orig_listener = listener;
      listener = function listener(event) {
        var suggestion_selected = document.getElementsByClassName('pac-item-selected').length > 0;
        if (event.which == 13 && !suggestion_selected) {
          var simulatedEvent = document.createEvent('Event');
          simulatedEvent.keyCode = 40;
          simulatedEvent.which = 40;
          orig_listener.apply(input, [simulatedEvent]);
        }
        orig_listener.apply(input, [event]);
      };
    }
    _addEventListener.apply(input, [type, listener]);
  }

  input.addEventListener = addEventListenerWrapper;
  input.attachEvent = addEventListenerWrapper;
};

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(2236);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(2235);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY        = __webpack_require__(229)
  , $export        = __webpack_require__(159)
  , redefine       = __webpack_require__(231)
  , hide           = __webpack_require__(228)
  , has            = __webpack_require__(227)
  , Iterators      = __webpack_require__(100)
  , $iterCreate    = __webpack_require__(2256)
  , setToStringTag = __webpack_require__(161)
  , getProto       = __webpack_require__(53).getProto
  , ITERATOR       = __webpack_require__(48)('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , methods, key;
  // Fix native
  if($native){
    var IteratorPrototype = getProto($default.call(new Base));
    // Set @@toStringTag to native iterators
    setToStringTag(IteratorPrototype, TAG, true);
    // FF fix
    if(!LIBRARY && has(proto, FF_ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    // fix Array#{values, @@iterator}.name in V8 / FF
    if(DEF_VALUES && $native.name !== VALUES){
      VALUES_BUG = true;
      $default = function values(){ return $native.call(this); };
    }
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES  ? $default : getMethod(VALUES),
      keys:    IS_SET      ? $default : getMethod(KEYS),
      entries: !DEF_VALUES ? $default : getMethod('entries')
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(70)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};

/***/ }),
/* 475 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 476 */
/***/ (function(module, exports) {

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

var classof   = __webpack_require__(224)
  , ITERATOR  = __webpack_require__(48)('iterator')
  , Iterators = __webpack_require__(100);
module.exports = __webpack_require__(65).getIteratorMethod = function(it){
  if(it != undefined)return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

/***/ }),
/* 478 */
/***/ (function(module, exports) {



/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parser__ = __webpack_require__(2279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__process__ = __webpack_require__(2280);
var D2R = 0.01745329251994329577;





function rename(obj, params) {
  var outName = params[0];
  var inName = params[1];
  if (!(outName in obj) && (inName in obj)) {
    obj[outName] = obj[inName];
    if (params.length === 3) {
      obj[outName] = params[2](obj[outName]);
    }
  }
}

function d2r(input) {
  return input * D2R;
}

function cleanWKT(wkt) {
  if (wkt.type === 'GEOGCS') {
    wkt.projName = 'longlat';
  } else if (wkt.type === 'LOCAL_CS') {
    wkt.projName = 'identity';
    wkt.local = true;
  } else {
    if (typeof wkt.PROJECTION === 'object') {
      wkt.projName = Object.keys(wkt.PROJECTION)[0];
    } else {
      wkt.projName = wkt.PROJECTION;
    }
  }
  if (wkt.UNIT) {
    wkt.units = wkt.UNIT.name.toLowerCase();
    if (wkt.units === 'metre') {
      wkt.units = 'meter';
    }
    if (wkt.UNIT.convert) {
      if (wkt.type === 'GEOGCS') {
        if (wkt.DATUM && wkt.DATUM.SPHEROID) {
          wkt.to_meter = wkt.UNIT.convert*wkt.DATUM.SPHEROID.a;
        }
      } else {
        wkt.to_meter = wkt.UNIT.convert, 10;
      }
    }
  }
  var geogcs = wkt.GEOGCS;
  if (wkt.type === 'GEOGCS') {
    geogcs = wkt;
  }
  if (geogcs) {
    //if(wkt.GEOGCS.PRIMEM&&wkt.GEOGCS.PRIMEM.convert){
    //  wkt.from_greenwich=wkt.GEOGCS.PRIMEM.convert*D2R;
    //}
    if (geogcs.DATUM) {
      wkt.datumCode = geogcs.DATUM.name.toLowerCase();
    } else {
      wkt.datumCode = geogcs.name.toLowerCase();
    }
    if (wkt.datumCode.slice(0, 2) === 'd_') {
      wkt.datumCode = wkt.datumCode.slice(2);
    }
    if (wkt.datumCode === 'new_zealand_geodetic_datum_1949' || wkt.datumCode === 'new_zealand_1949') {
      wkt.datumCode = 'nzgd49';
    }
    if (wkt.datumCode === 'wgs_1984') {
      if (wkt.PROJECTION === 'Mercator_Auxiliary_Sphere') {
        wkt.sphere = true;
      }
      wkt.datumCode = 'wgs84';
    }
    if (wkt.datumCode.slice(-6) === '_ferro') {
      wkt.datumCode = wkt.datumCode.slice(0, - 6);
    }
    if (wkt.datumCode.slice(-8) === '_jakarta') {
      wkt.datumCode = wkt.datumCode.slice(0, - 8);
    }
    if (~wkt.datumCode.indexOf('belge')) {
      wkt.datumCode = 'rnb72';
    }
    if (geogcs.DATUM && geogcs.DATUM.SPHEROID) {
      wkt.ellps = geogcs.DATUM.SPHEROID.name.replace('_19', '').replace(/[Cc]larke\_18/, 'clrk');
      if (wkt.ellps.toLowerCase().slice(0, 13) === 'international') {
        wkt.ellps = 'intl';
      }

      wkt.a = geogcs.DATUM.SPHEROID.a;
      wkt.rf = parseFloat(geogcs.DATUM.SPHEROID.rf, 10);
    }
    if (~wkt.datumCode.indexOf('osgb_1936')) {
      wkt.datumCode = 'osgb36';
    }
    if (~wkt.datumCode.indexOf('osni_1952')) {
      wkt.datumCode = 'osni52';
    }
    if (~wkt.datumCode.indexOf('tm65')
      || ~wkt.datumCode.indexOf('geodetic_datum_of_1965')) {
      wkt.datumCode = 'ire65';
    }
  }
  if (wkt.b && !isFinite(wkt.b)) {
    wkt.b = wkt.a;
  }

  function toMeter(input) {
    var ratio = wkt.to_meter || 1;
    return input * ratio;
  }
  var renamer = function(a) {
    return rename(wkt, a);
  };
  var list = [
    ['standard_parallel_1', 'Standard_Parallel_1'],
    ['standard_parallel_2', 'Standard_Parallel_2'],
    ['false_easting', 'False_Easting'],
    ['false_northing', 'False_Northing'],
    ['central_meridian', 'Central_Meridian'],
    ['latitude_of_origin', 'Latitude_Of_Origin'],
    ['latitude_of_origin', 'Central_Parallel'],
    ['scale_factor', 'Scale_Factor'],
    ['k0', 'scale_factor'],
    ['latitude_of_center', 'Latitude_of_center'],
    ['lat0', 'latitude_of_center', d2r],
    ['longitude_of_center', 'Longitude_Of_Center'],
    ['longc', 'longitude_of_center', d2r],
    ['x0', 'false_easting', toMeter],
    ['y0', 'false_northing', toMeter],
    ['long0', 'central_meridian', d2r],
    ['lat0', 'latitude_of_origin', d2r],
    ['lat0', 'standard_parallel_1', d2r],
    ['lat1', 'standard_parallel_1', d2r],
    ['lat2', 'standard_parallel_2', d2r],
    ['alpha', 'azimuth', d2r],
    ['srsCode', 'name']
  ];
  list.forEach(renamer);
  if (!wkt.long0 && wkt.longc && (wkt.projName === 'Albers_Conic_Equal_Area' || wkt.projName === 'Lambert_Azimuthal_Equal_Area')) {
    wkt.long0 = wkt.longc;
  }
  if (!wkt.lat_ts && wkt.lat1 && (wkt.projName === 'Stereographic_South_Pole' || wkt.projName === 'Polar Stereographic (variant B)')) {
    wkt.lat0 = d2r(wkt.lat1 > 0 ? 90 : -90);
    wkt.lat_ts = wkt.lat1;
  }
}
/* harmony default export */ __webpack_exports__["a"] = (function(wkt) {
  var lisp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__parser__["a" /* default */])(wkt);
  var type = lisp.shift();
  var name = lisp.shift();
  lisp.unshift(['name', name]);
  lisp.unshift(['type', type]);
  var obj = {};
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__process__["a" /* sExpr */])(lisp, obj);
  cleanWKT(obj);
  return obj;
});


/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__v_drag__ = __webpack_require__(598);



__WEBPACK_IMPORTED_MODULE_0_vue___default.a.directive('focus', {
    inserted: function inserted(el, binding) {
        if (binding.value) {
            el.focus();
        }
    }
});

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.directive('click-outside', {
    bind: function bind(el, binding, vnode) {
        el.event = function (event) {
            if (!(el == event.target || el.contains(event.target))) {
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener('click', el.event);
    },
    unbind: function unbind(el) {
        document.body.removeEventListener('click', el.event);
    }
});

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.directive('drag', {
    Drag: __WEBPACK_IMPORTED_MODULE_1__v_drag__["a" /* default */]
});

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["prettyDate"] = prettyDate;
/* harmony export (immutable) */ __webpack_exports__["wordCount"] = wordCount;
/* harmony export (immutable) */ __webpack_exports__["charCount"] = charCount;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


function prettyDate(dateString) {
	return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.parseZone(dateString, 'ddd MMM DD YYYY HH:mm:ss ZZ').local().fromNow();
}

function wordCount(string) {
	return string ? (string.replace(/['";:,.?¿\-!¡]+/g, '').match(/\S+/g) || []).length : 0;
}

function charCount(string) {
	return string ? string.replace(/\s/g, '').length : 0;
}

/***/ }),
/* 482 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(946);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(220)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js!./vue-tabs.css", function() {
			var newContent = require("!!../../css-loader/index.js!./vue-tabs.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__500px__ = __webpack_require__(1239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__address_book_o__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__address_book__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__address_card_o__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__address_card__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__adjust__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__adn__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__align_center__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__align_justify__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__align_left__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__align_right__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__amazon__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ambulance__ = __webpack_require__(1251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__american_sign_language_interpreting__ = __webpack_require__(1252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__anchor__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__android__ = __webpack_require__(1254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__angellist__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__angle_double_down__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__angle_double_left__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__angle_double_right__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__angle_double_up__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__angle_down__ = __webpack_require__(1260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__angle_left__ = __webpack_require__(1261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__angle_right__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__angle_up__ = __webpack_require__(1263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__apple__ = __webpack_require__(1264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__archive__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__area_chart__ = __webpack_require__(1266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__arrow_circle_down__ = __webpack_require__(1267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__arrow_circle_left__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__arrow_circle_o_down__ = __webpack_require__(1269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__arrow_circle_o_left__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__arrow_circle_o_right__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__arrow_circle_o_up__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__arrow_circle_right__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__arrow_circle_up__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__arrow_down__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__arrow_left__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__arrow_right__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__arrow_up__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__arrows_alt__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__arrows_h__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__arrows_v__ = __webpack_require__(1281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__arrows__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__asl_interpreting__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__assistive_listening_systems__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__asterisk__ = __webpack_require__(1285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__at__ = __webpack_require__(1286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__audio_description__ = __webpack_require__(1287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__automobile__ = __webpack_require__(1288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__backward__ = __webpack_require__(1289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__balance_scale__ = __webpack_require__(1290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__ban__ = __webpack_require__(1291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__bandcamp__ = __webpack_require__(1292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__bank__ = __webpack_require__(1293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__bar_chart_o__ = __webpack_require__(1294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__bar_chart__ = __webpack_require__(1295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__barcode__ = __webpack_require__(1296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__bars__ = __webpack_require__(1297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__bath__ = __webpack_require__(1298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__bathtub__ = __webpack_require__(1299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__battery_0__ = __webpack_require__(1300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__battery_1__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__battery_2__ = __webpack_require__(1302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__battery_3__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__battery_4__ = __webpack_require__(1304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__battery_empty__ = __webpack_require__(1305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__battery_full__ = __webpack_require__(1306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__battery_half__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__battery_quarter__ = __webpack_require__(1308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__battery_three_quarters__ = __webpack_require__(1309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__battery__ = __webpack_require__(1310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__bed__ = __webpack_require__(1311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__beer__ = __webpack_require__(1312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__behance_square__ = __webpack_require__(1313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__behance__ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__bell_o__ = __webpack_require__(1315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__bell_slash_o__ = __webpack_require__(1316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__bell_slash__ = __webpack_require__(1317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__bell__ = __webpack_require__(1318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__bicycle__ = __webpack_require__(1319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__binoculars__ = __webpack_require__(1320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__birthday_cake__ = __webpack_require__(1321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__bitbucket_square__ = __webpack_require__(1322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__bitbucket__ = __webpack_require__(1323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__bitcoin__ = __webpack_require__(1324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__black_tie__ = __webpack_require__(1325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__blind__ = __webpack_require__(1326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__bluetooth_b__ = __webpack_require__(1327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__bluetooth__ = __webpack_require__(1328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__bold__ = __webpack_require__(1329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__bolt__ = __webpack_require__(1330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__bomb__ = __webpack_require__(1331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__book__ = __webpack_require__(1332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__bookmark_o__ = __webpack_require__(1333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__bookmark__ = __webpack_require__(1334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__braille__ = __webpack_require__(1335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__briefcase__ = __webpack_require__(1336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__btc__ = __webpack_require__(1337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__bug__ = __webpack_require__(1338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__building_o__ = __webpack_require__(1339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__building__ = __webpack_require__(1340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__bullhorn__ = __webpack_require__(1341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__bullseye__ = __webpack_require__(1342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__bus__ = __webpack_require__(1343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__buysellads__ = __webpack_require__(1344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__cab__ = __webpack_require__(1345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__calculator__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__calendar_check_o__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__calendar_minus_o__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__calendar_o__ = __webpack_require__(1349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__calendar_plus_o__ = __webpack_require__(1350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__calendar_times_o__ = __webpack_require__(1351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__calendar__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__camera_retro__ = __webpack_require__(1353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__camera__ = __webpack_require__(1354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__car__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__caret_down__ = __webpack_require__(1356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__caret_left__ = __webpack_require__(1357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__caret_right__ = __webpack_require__(1358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__caret_square_o_down__ = __webpack_require__(1359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__caret_square_o_left__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__caret_square_o_right__ = __webpack_require__(1361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__caret_square_o_up__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__caret_up__ = __webpack_require__(1363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__cart_arrow_down__ = __webpack_require__(1364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__cart_plus__ = __webpack_require__(1365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__cc_amex__ = __webpack_require__(1366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__cc_diners_club__ = __webpack_require__(1367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__cc_discover__ = __webpack_require__(1368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__cc_jcb__ = __webpack_require__(1369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__cc_mastercard__ = __webpack_require__(1370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__cc_paypal__ = __webpack_require__(1371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__cc_stripe__ = __webpack_require__(1372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__cc_visa__ = __webpack_require__(1373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__cc__ = __webpack_require__(1374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__certificate__ = __webpack_require__(1375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__chain_broken__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__chain__ = __webpack_require__(1377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__check_circle_o__ = __webpack_require__(1378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__check_circle__ = __webpack_require__(1379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__check_square_o__ = __webpack_require__(1380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__check_square__ = __webpack_require__(1381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__check__ = __webpack_require__(1382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144__chevron_circle_down__ = __webpack_require__(1383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145__chevron_circle_left__ = __webpack_require__(1384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146__chevron_circle_right__ = __webpack_require__(1385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147__chevron_circle_up__ = __webpack_require__(1386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148__chevron_down__ = __webpack_require__(1387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_149__chevron_left__ = __webpack_require__(1388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_150__chevron_right__ = __webpack_require__(1389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_151__chevron_up__ = __webpack_require__(1390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_152__child__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_153__chrome__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_154__circle_o_notch__ = __webpack_require__(1393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_155__circle_o__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_156__circle_thin__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_157__circle__ = __webpack_require__(1396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_158__clipboard__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_159__clock_o__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_160__clone__ = __webpack_require__(1399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_161__close__ = __webpack_require__(1400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_162__cloud_download__ = __webpack_require__(1401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_163__cloud_upload__ = __webpack_require__(1402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_164__cloud__ = __webpack_require__(1403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_165__cny__ = __webpack_require__(1404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_166__code_fork__ = __webpack_require__(1405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_167__code__ = __webpack_require__(1406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_168__codepen__ = __webpack_require__(1407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_169__codiepie__ = __webpack_require__(1408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_170__coffee__ = __webpack_require__(1409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_171__cog__ = __webpack_require__(1410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_172__cogs__ = __webpack_require__(1411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_173__columns__ = __webpack_require__(1412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_174__comment_o__ = __webpack_require__(1413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_175__comment__ = __webpack_require__(1414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_176__commenting_o__ = __webpack_require__(1415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_177__commenting__ = __webpack_require__(1416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_178__comments_o__ = __webpack_require__(1417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_179__comments__ = __webpack_require__(1418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_180__compass__ = __webpack_require__(1419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_181__compress__ = __webpack_require__(1420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_182__connectdevelop__ = __webpack_require__(1421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_183__contao__ = __webpack_require__(1422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_184__copy__ = __webpack_require__(1423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_185__copyright__ = __webpack_require__(1424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_186__creative_commons__ = __webpack_require__(1425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_187__credit_card_alt__ = __webpack_require__(1426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_188__credit_card__ = __webpack_require__(1427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_189__crop__ = __webpack_require__(1428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_190__crosshairs__ = __webpack_require__(1429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_191__css3__ = __webpack_require__(1430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_192__cube__ = __webpack_require__(1431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_193__cubes__ = __webpack_require__(1432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_194__cut__ = __webpack_require__(1433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_195__cutlery__ = __webpack_require__(1434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_196__dashboard__ = __webpack_require__(1435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_197__dashcube__ = __webpack_require__(1436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_198__database__ = __webpack_require__(1437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_199__deaf__ = __webpack_require__(1438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_200__deafness__ = __webpack_require__(1439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_201__dedent__ = __webpack_require__(1440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_202__delicious__ = __webpack_require__(1441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_203__desktop__ = __webpack_require__(1442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_204__deviantart__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_205__diamond__ = __webpack_require__(1444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_206__digg__ = __webpack_require__(1445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_207__dollar__ = __webpack_require__(1446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_208__dot_circle_o__ = __webpack_require__(1447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_209__download__ = __webpack_require__(1448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_210__dribbble__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_211__drivers_license_o__ = __webpack_require__(1450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_212__drivers_license__ = __webpack_require__(1451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_213__dropbox__ = __webpack_require__(1452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_214__drupal__ = __webpack_require__(1453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_215__edge__ = __webpack_require__(1454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_216__edit__ = __webpack_require__(1455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_217__eercast__ = __webpack_require__(1456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_218__eject__ = __webpack_require__(1457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_219__ellipsis_h__ = __webpack_require__(1458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_220__ellipsis_v__ = __webpack_require__(1459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_221__empire__ = __webpack_require__(1460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_222__envelope_o__ = __webpack_require__(1461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_223__envelope_open_o__ = __webpack_require__(1462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_224__envelope_open__ = __webpack_require__(1463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_225__envelope_square__ = __webpack_require__(1464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_226__envelope__ = __webpack_require__(1465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_227__envira__ = __webpack_require__(1466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_228__eraser__ = __webpack_require__(1467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_229__etsy__ = __webpack_require__(1468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_230__eur__ = __webpack_require__(1469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_231__euro__ = __webpack_require__(1470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_232__exchange__ = __webpack_require__(1471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_233__exclamation_circle__ = __webpack_require__(1472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_234__exclamation_triangle__ = __webpack_require__(1473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_235__exclamation__ = __webpack_require__(1474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_236__expand__ = __webpack_require__(1475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_237__expeditedssl__ = __webpack_require__(1476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_238__external_link_square__ = __webpack_require__(1477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_239__external_link__ = __webpack_require__(1478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_240__eye_slash__ = __webpack_require__(1479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_241__eye__ = __webpack_require__(1480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_242__eyedropper__ = __webpack_require__(1481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_243__fa__ = __webpack_require__(1482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_244__facebook_f__ = __webpack_require__(1483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_245__facebook_official__ = __webpack_require__(1484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_246__facebook_square__ = __webpack_require__(1485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_247__facebook__ = __webpack_require__(1486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_248__fast_backward__ = __webpack_require__(1487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_249__fast_forward__ = __webpack_require__(1488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_250__fax__ = __webpack_require__(1489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_251__feed__ = __webpack_require__(1490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_252__female__ = __webpack_require__(1491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_253__fighter_jet__ = __webpack_require__(1492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_254__file_archive_o__ = __webpack_require__(1493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_255__file_audio_o__ = __webpack_require__(1494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_256__file_code_o__ = __webpack_require__(1495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_257__file_excel_o__ = __webpack_require__(1496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_258__file_image_o__ = __webpack_require__(1497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_259__file_movie_o__ = __webpack_require__(1498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_260__file_o__ = __webpack_require__(1499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_261__file_pdf_o__ = __webpack_require__(1500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_262__file_photo_o__ = __webpack_require__(1501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_263__file_picture_o__ = __webpack_require__(1502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_264__file_powerpoint_o__ = __webpack_require__(1503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_265__file_sound_o__ = __webpack_require__(1504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_266__file_text_o__ = __webpack_require__(1505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_267__file_text__ = __webpack_require__(1506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_268__file_video_o__ = __webpack_require__(1507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_269__file_word_o__ = __webpack_require__(1508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_270__file_zip_o__ = __webpack_require__(1509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_271__file__ = __webpack_require__(1510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_272__files_o__ = __webpack_require__(1511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_273__film__ = __webpack_require__(1512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_274__filter__ = __webpack_require__(1513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_275__fire_extinguisher__ = __webpack_require__(1514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_276__fire__ = __webpack_require__(1515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_277__firefox__ = __webpack_require__(1516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_278__first_order__ = __webpack_require__(1517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_279__flag_checkered__ = __webpack_require__(1518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_280__flag_o__ = __webpack_require__(1519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_281__flag__ = __webpack_require__(1520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_282__flash__ = __webpack_require__(1521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_283__flask__ = __webpack_require__(1522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_284__flickr__ = __webpack_require__(1523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_285__floppy_o__ = __webpack_require__(1524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_286__folder_o__ = __webpack_require__(1525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_287__folder_open_o__ = __webpack_require__(1526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_288__folder_open__ = __webpack_require__(1527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_289__folder__ = __webpack_require__(1528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_290__font_awesome__ = __webpack_require__(1529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_291__font__ = __webpack_require__(1530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_292__fonticons__ = __webpack_require__(1531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_293__fort_awesome__ = __webpack_require__(1532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_294__forumbee__ = __webpack_require__(1533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_295__forward__ = __webpack_require__(1534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_296__foursquare__ = __webpack_require__(1535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_297__free_code_camp__ = __webpack_require__(1536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_298__frown_o__ = __webpack_require__(1537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_299__futbol_o__ = __webpack_require__(1538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_300__gamepad__ = __webpack_require__(1539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_301__gavel__ = __webpack_require__(1540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_302__gbp__ = __webpack_require__(1541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_303__ge__ = __webpack_require__(1542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_304__gear__ = __webpack_require__(1543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_305__gears__ = __webpack_require__(1544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_306__genderless__ = __webpack_require__(1545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_307__get_pocket__ = __webpack_require__(1546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_308__gg_circle__ = __webpack_require__(1547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_309__gg__ = __webpack_require__(1548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_310__gift__ = __webpack_require__(1549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_311__git_square__ = __webpack_require__(1550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_312__git__ = __webpack_require__(1551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_313__github_alt__ = __webpack_require__(1552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_314__github_square__ = __webpack_require__(1553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_315__github__ = __webpack_require__(1554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_316__gitlab__ = __webpack_require__(1555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_317__gittip__ = __webpack_require__(1556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_318__glass__ = __webpack_require__(1557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_319__glide_g__ = __webpack_require__(1558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_320__glide__ = __webpack_require__(1559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_321__globe__ = __webpack_require__(1560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_322__google_plus_circle__ = __webpack_require__(1561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_323__google_plus_official__ = __webpack_require__(1562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_324__google_plus_square__ = __webpack_require__(1563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_325__google_plus__ = __webpack_require__(1564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_326__google_wallet__ = __webpack_require__(1565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_327__google__ = __webpack_require__(1566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_328__graduation_cap__ = __webpack_require__(1567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_329__gratipay__ = __webpack_require__(1568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_330__grav__ = __webpack_require__(1569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_331__group__ = __webpack_require__(1570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_332__h_square__ = __webpack_require__(1571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_333__hacker_news__ = __webpack_require__(1572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_334__hand_grab_o__ = __webpack_require__(1573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_335__hand_lizard_o__ = __webpack_require__(1574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_336__hand_o_down__ = __webpack_require__(1575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_337__hand_o_left__ = __webpack_require__(1576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_338__hand_o_right__ = __webpack_require__(1577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_339__hand_o_up__ = __webpack_require__(1578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_340__hand_paper_o__ = __webpack_require__(1579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_341__hand_peace_o__ = __webpack_require__(1580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_342__hand_pointer_o__ = __webpack_require__(1581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_343__hand_rock_o__ = __webpack_require__(1582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_344__hand_scissors_o__ = __webpack_require__(1583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_345__hand_spock_o__ = __webpack_require__(1584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_346__hand_stop_o__ = __webpack_require__(1585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_347__handshake_o__ = __webpack_require__(1586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_348__hard_of_hearing__ = __webpack_require__(1587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_349__hashtag__ = __webpack_require__(1588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_350__hdd_o__ = __webpack_require__(1589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_351__header__ = __webpack_require__(1590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_352__headphones__ = __webpack_require__(1591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_353__heart_o__ = __webpack_require__(1592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_354__heart__ = __webpack_require__(1593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_355__heartbeat__ = __webpack_require__(1594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_356__history__ = __webpack_require__(1595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_357__home__ = __webpack_require__(1596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_358__hospital_o__ = __webpack_require__(1597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_359__hotel__ = __webpack_require__(1598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_360__hourglass_1__ = __webpack_require__(1599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_361__hourglass_2__ = __webpack_require__(1600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_362__hourglass_3__ = __webpack_require__(1601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_363__hourglass_end__ = __webpack_require__(1602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_364__hourglass_half__ = __webpack_require__(1603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_365__hourglass_o__ = __webpack_require__(1604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_366__hourglass_start__ = __webpack_require__(1605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_367__hourglass__ = __webpack_require__(1606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_368__houzz__ = __webpack_require__(1607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_369__html5__ = __webpack_require__(1608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_370__i_cursor__ = __webpack_require__(1609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_371__id_badge__ = __webpack_require__(1610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_372__id_card_o__ = __webpack_require__(1611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_373__id_card__ = __webpack_require__(1612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_374__ils__ = __webpack_require__(1613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_375__image__ = __webpack_require__(1614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_376__imdb__ = __webpack_require__(1615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_377__inbox__ = __webpack_require__(1616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_378__indent__ = __webpack_require__(1617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_379__industry__ = __webpack_require__(1618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_380__info_circle__ = __webpack_require__(1619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_381__info__ = __webpack_require__(1620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_382__inr__ = __webpack_require__(1621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_383__instagram__ = __webpack_require__(1622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_384__institution__ = __webpack_require__(1623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_385__internet_explorer__ = __webpack_require__(1624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_386__intersex__ = __webpack_require__(1625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_387__ioxhost__ = __webpack_require__(1626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_388__italic__ = __webpack_require__(1627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_389__joomla__ = __webpack_require__(1628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_390__jpy__ = __webpack_require__(1629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_391__jsfiddle__ = __webpack_require__(1630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_392__key__ = __webpack_require__(1631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_393__keyboard_o__ = __webpack_require__(1632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_394__krw__ = __webpack_require__(1633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_395__language__ = __webpack_require__(1634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_396__laptop__ = __webpack_require__(1635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_397__lastfm_square__ = __webpack_require__(1636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_398__lastfm__ = __webpack_require__(1637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_399__leaf__ = __webpack_require__(1638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_400__leanpub__ = __webpack_require__(1639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_401__legal__ = __webpack_require__(1640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_402__lemon_o__ = __webpack_require__(1641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_403__level_down__ = __webpack_require__(1642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_404__level_up__ = __webpack_require__(1643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_405__life_bouy__ = __webpack_require__(1644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_406__life_buoy__ = __webpack_require__(1645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_407__life_ring__ = __webpack_require__(1646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_408__life_saver__ = __webpack_require__(1647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_409__lightbulb_o__ = __webpack_require__(1648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_410__line_chart__ = __webpack_require__(1649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_411__link__ = __webpack_require__(1650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_412__linkedin_square__ = __webpack_require__(1651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_413__linkedin__ = __webpack_require__(1652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_414__linode__ = __webpack_require__(1653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_415__linux__ = __webpack_require__(1654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_416__list_alt__ = __webpack_require__(1655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_417__list_ol__ = __webpack_require__(1656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_418__list_ul__ = __webpack_require__(1657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_419__list__ = __webpack_require__(1658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_420__location_arrow__ = __webpack_require__(1659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_421__lock__ = __webpack_require__(1660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_422__long_arrow_down__ = __webpack_require__(1661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_423__long_arrow_left__ = __webpack_require__(1662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_424__long_arrow_right__ = __webpack_require__(1663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_425__long_arrow_up__ = __webpack_require__(1664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_426__low_vision__ = __webpack_require__(1665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_427__magic__ = __webpack_require__(1666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_428__magnet__ = __webpack_require__(1667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_429__mail_forward__ = __webpack_require__(1668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_430__mail_reply_all__ = __webpack_require__(1669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_431__mail_reply__ = __webpack_require__(1670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_432__male__ = __webpack_require__(1671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_433__map_marker__ = __webpack_require__(1672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_434__map_o__ = __webpack_require__(1673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_435__map_pin__ = __webpack_require__(1674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_436__map_signs__ = __webpack_require__(1675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_437__map__ = __webpack_require__(1676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_438__mars_double__ = __webpack_require__(1677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_439__mars_stroke_h__ = __webpack_require__(1678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_440__mars_stroke_v__ = __webpack_require__(1679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_441__mars_stroke__ = __webpack_require__(1680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_442__mars__ = __webpack_require__(1681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_443__maxcdn__ = __webpack_require__(1682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_444__meanpath__ = __webpack_require__(1683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_445__medium__ = __webpack_require__(1684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_446__medkit__ = __webpack_require__(1685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_447__meetup__ = __webpack_require__(1686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_448__meh_o__ = __webpack_require__(1687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_449__mercury__ = __webpack_require__(1688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_450__microchip__ = __webpack_require__(1689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_451__microphone_slash__ = __webpack_require__(1690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_452__microphone__ = __webpack_require__(1691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_453__minus_circle__ = __webpack_require__(1692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_454__minus_square_o__ = __webpack_require__(1693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_455__minus_square__ = __webpack_require__(1694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_456__minus__ = __webpack_require__(1695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_457__mixcloud__ = __webpack_require__(1696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_458__mobile_phone__ = __webpack_require__(1697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_459__mobile__ = __webpack_require__(1698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_460__modx__ = __webpack_require__(1699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_461__money__ = __webpack_require__(1700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_462__moon_o__ = __webpack_require__(1701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_463__mortar_board__ = __webpack_require__(1702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_464__motorcycle__ = __webpack_require__(1703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_465__mouse_pointer__ = __webpack_require__(1704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_466__music__ = __webpack_require__(1705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_467__navicon__ = __webpack_require__(1706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_468__neuter__ = __webpack_require__(1707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_469__newspaper_o__ = __webpack_require__(1708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_470__object_group__ = __webpack_require__(1709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_471__object_ungroup__ = __webpack_require__(1710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_472__odnoklassniki_square__ = __webpack_require__(1711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_473__odnoklassniki__ = __webpack_require__(1712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_474__opencart__ = __webpack_require__(1713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_475__openid__ = __webpack_require__(1714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_476__opera__ = __webpack_require__(1715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_477__optin_monster__ = __webpack_require__(1716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_478__outdent__ = __webpack_require__(1717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_479__pagelines__ = __webpack_require__(1718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_480__paint_brush__ = __webpack_require__(1719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_481__paper_plane_o__ = __webpack_require__(1720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_482__paper_plane__ = __webpack_require__(1721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_483__paperclip__ = __webpack_require__(1722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_484__paragraph__ = __webpack_require__(1723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_485__paste__ = __webpack_require__(1724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_486__pause_circle_o__ = __webpack_require__(1725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_487__pause_circle__ = __webpack_require__(1726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_488__pause__ = __webpack_require__(1727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_489__paw__ = __webpack_require__(1728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_490__paypal__ = __webpack_require__(1729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_491__pencil_square_o__ = __webpack_require__(1730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_492__pencil_square__ = __webpack_require__(1731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_493__pencil__ = __webpack_require__(1732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_494__percent__ = __webpack_require__(1733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_495__phone_square__ = __webpack_require__(1734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_496__phone__ = __webpack_require__(1735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_497__photo__ = __webpack_require__(1736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_498__picture_o__ = __webpack_require__(1737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_499__pie_chart__ = __webpack_require__(1738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_500__pied_piper_alt__ = __webpack_require__(1739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_501__pied_piper_pp__ = __webpack_require__(1740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_502__pied_piper__ = __webpack_require__(1741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_503__pinterest_p__ = __webpack_require__(1742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_504__pinterest_square__ = __webpack_require__(1743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_505__pinterest__ = __webpack_require__(1744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_506__plane__ = __webpack_require__(1745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_507__play_circle_o__ = __webpack_require__(1746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_508__play_circle__ = __webpack_require__(1747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_509__play__ = __webpack_require__(1748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_510__plug__ = __webpack_require__(1749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_511__plus_circle__ = __webpack_require__(1750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_512__plus_square_o__ = __webpack_require__(1751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_513__plus_square__ = __webpack_require__(1752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_514__plus__ = __webpack_require__(1753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_515__podcast__ = __webpack_require__(1754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_516__power_off__ = __webpack_require__(1755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_517__print__ = __webpack_require__(1756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_518__product_hunt__ = __webpack_require__(1757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_519__puzzle_piece__ = __webpack_require__(1758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_520__qq__ = __webpack_require__(1759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_521__qrcode__ = __webpack_require__(1760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_522__question_circle_o__ = __webpack_require__(1761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_523__question_circle__ = __webpack_require__(1762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_524__question__ = __webpack_require__(1763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_525__quora__ = __webpack_require__(1764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_526__quote_left__ = __webpack_require__(1765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_527__quote_right__ = __webpack_require__(1766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_528__ra__ = __webpack_require__(1767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_529__random__ = __webpack_require__(1768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_530__ravelry__ = __webpack_require__(1769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_531__rebel__ = __webpack_require__(1770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_532__recycle__ = __webpack_require__(1771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_533__reddit_alien__ = __webpack_require__(1772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_534__reddit_square__ = __webpack_require__(1773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_535__reddit__ = __webpack_require__(1774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_536__refresh__ = __webpack_require__(1775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_537__registered__ = __webpack_require__(1776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_538__remove__ = __webpack_require__(1777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_539__renren__ = __webpack_require__(1778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_540__reorder__ = __webpack_require__(1779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_541__repeat__ = __webpack_require__(1780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_542__reply_all__ = __webpack_require__(1781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_543__reply__ = __webpack_require__(1782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_544__resistance__ = __webpack_require__(1783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_545__retweet__ = __webpack_require__(1784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_546__rmb__ = __webpack_require__(1785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_547__road__ = __webpack_require__(1786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_548__rocket__ = __webpack_require__(1787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_549__rotate_left__ = __webpack_require__(1788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_550__rotate_right__ = __webpack_require__(1789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_551__rouble__ = __webpack_require__(1790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_552__rss_square__ = __webpack_require__(1791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_553__rss__ = __webpack_require__(1792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_554__rub__ = __webpack_require__(1793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_555__ruble__ = __webpack_require__(1794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_556__rupee__ = __webpack_require__(1795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_557__s15__ = __webpack_require__(1796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_558__safari__ = __webpack_require__(1797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_559__save__ = __webpack_require__(1798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_560__scissors__ = __webpack_require__(1799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_561__scribd__ = __webpack_require__(1800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_562__search_minus__ = __webpack_require__(1801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_563__search_plus__ = __webpack_require__(1802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_564__search__ = __webpack_require__(1803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_565__sellsy__ = __webpack_require__(1804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_566__send_o__ = __webpack_require__(1805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_567__send__ = __webpack_require__(1806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_568__server__ = __webpack_require__(1807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_569__share_alt_square__ = __webpack_require__(1808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_570__share_alt__ = __webpack_require__(1809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_571__share_square_o__ = __webpack_require__(1810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_572__share_square__ = __webpack_require__(1811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_573__share__ = __webpack_require__(1812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_574__shekel__ = __webpack_require__(1813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_575__sheqel__ = __webpack_require__(1814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_576__shield__ = __webpack_require__(1815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_577__ship__ = __webpack_require__(1816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_578__shirtsinbulk__ = __webpack_require__(1817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_579__shopping_bag__ = __webpack_require__(1818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_580__shopping_basket__ = __webpack_require__(1819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_581__shopping_cart__ = __webpack_require__(1820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_582__shower__ = __webpack_require__(1821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_583__sign_in__ = __webpack_require__(1822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_584__sign_language__ = __webpack_require__(1823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_585__sign_out__ = __webpack_require__(1824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_586__signal__ = __webpack_require__(1825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_587__signing__ = __webpack_require__(1826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_588__simplybuilt__ = __webpack_require__(1827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_589__sitemap__ = __webpack_require__(1828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_590__skyatlas__ = __webpack_require__(1829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_591__skype__ = __webpack_require__(1830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_592__slack__ = __webpack_require__(1831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_593__sliders__ = __webpack_require__(1832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_594__slideshare__ = __webpack_require__(1833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_595__smile_o__ = __webpack_require__(1834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_596__snapchat_ghost__ = __webpack_require__(1835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_597__snapchat_square__ = __webpack_require__(1836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_598__snapchat__ = __webpack_require__(1837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_599__snowflake_o__ = __webpack_require__(1838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_600__soccer_ball_o__ = __webpack_require__(1839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_601__sort_alpha_asc__ = __webpack_require__(1840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_602__sort_alpha_desc__ = __webpack_require__(1841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_603__sort_amount_asc__ = __webpack_require__(1842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_604__sort_amount_desc__ = __webpack_require__(1843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_605__sort_asc__ = __webpack_require__(1844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_606__sort_desc__ = __webpack_require__(1845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_607__sort_down__ = __webpack_require__(1846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_608__sort_numeric_asc__ = __webpack_require__(1847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_609__sort_numeric_desc__ = __webpack_require__(1848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_610__sort_up__ = __webpack_require__(1849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_611__sort__ = __webpack_require__(1850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_612__soundcloud__ = __webpack_require__(1851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_613__space_shuttle__ = __webpack_require__(1852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_614__spinner__ = __webpack_require__(1853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_615__spoon__ = __webpack_require__(1854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_616__spotify__ = __webpack_require__(1855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_617__square_o__ = __webpack_require__(1856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_618__square__ = __webpack_require__(1857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_619__stack_exchange__ = __webpack_require__(1858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_620__stack_overflow__ = __webpack_require__(1859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_621__star_half_empty__ = __webpack_require__(1860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_622__star_half_full__ = __webpack_require__(1861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_623__star_half_o__ = __webpack_require__(1862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_624__star_half__ = __webpack_require__(1863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_625__star_o__ = __webpack_require__(1864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_626__star__ = __webpack_require__(1865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_627__steam_square__ = __webpack_require__(1866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_628__steam__ = __webpack_require__(1867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_629__step_backward__ = __webpack_require__(1868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_630__step_forward__ = __webpack_require__(1869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_631__stethoscope__ = __webpack_require__(1870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_632__sticky_note_o__ = __webpack_require__(1871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_633__sticky_note__ = __webpack_require__(1872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_634__stop_circle_o__ = __webpack_require__(1873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_635__stop_circle__ = __webpack_require__(1874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_636__stop__ = __webpack_require__(1875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_637__street_view__ = __webpack_require__(1876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_638__strikethrough__ = __webpack_require__(1877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_639__stumbleupon_circle__ = __webpack_require__(1878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_640__stumbleupon__ = __webpack_require__(1879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_641__subscript__ = __webpack_require__(1880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_642__subway__ = __webpack_require__(1881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_643__suitcase__ = __webpack_require__(1882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_644__sun_o__ = __webpack_require__(1883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_645__superpowers__ = __webpack_require__(1884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_646__superscript__ = __webpack_require__(1885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_647__support__ = __webpack_require__(1886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_648__table__ = __webpack_require__(1887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_649__tablet__ = __webpack_require__(1888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_650__tachometer__ = __webpack_require__(1889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_651__tag__ = __webpack_require__(1890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_652__tags__ = __webpack_require__(1891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_653__tasks__ = __webpack_require__(1892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_654__taxi__ = __webpack_require__(1893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_655__telegram__ = __webpack_require__(1894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_656__television__ = __webpack_require__(1895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_657__tencent_weibo__ = __webpack_require__(1896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_658__terminal__ = __webpack_require__(1897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_659__text_height__ = __webpack_require__(1898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_660__text_width__ = __webpack_require__(1899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_661__th_large__ = __webpack_require__(1900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_662__th_list__ = __webpack_require__(1901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_663__th__ = __webpack_require__(1902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_664__themeisle__ = __webpack_require__(1903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_665__thermometer_0__ = __webpack_require__(1904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_666__thermometer_1__ = __webpack_require__(1905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_667__thermometer_2__ = __webpack_require__(1906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_668__thermometer_3__ = __webpack_require__(1907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_669__thermometer_4__ = __webpack_require__(1908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_670__thermometer_empty__ = __webpack_require__(1909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_671__thermometer_full__ = __webpack_require__(1910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_672__thermometer_half__ = __webpack_require__(1911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_673__thermometer_quarter__ = __webpack_require__(1912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_674__thermometer_three_quarters__ = __webpack_require__(1913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_675__thermometer__ = __webpack_require__(1914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_676__thumb_tack__ = __webpack_require__(1915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_677__thumbs_down__ = __webpack_require__(1916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_678__thumbs_o_down__ = __webpack_require__(1917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_679__thumbs_o_up__ = __webpack_require__(1918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_680__thumbs_up__ = __webpack_require__(1919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_681__ticket__ = __webpack_require__(1920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_682__times_circle_o__ = __webpack_require__(1921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_683__times_circle__ = __webpack_require__(1922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_684__times_rectangle_o__ = __webpack_require__(1923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_685__times_rectangle__ = __webpack_require__(1924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_686__times__ = __webpack_require__(1925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_687__tint__ = __webpack_require__(1926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_688__toggle_down__ = __webpack_require__(1927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_689__toggle_left__ = __webpack_require__(1928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_690__toggle_off__ = __webpack_require__(1929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_691__toggle_on__ = __webpack_require__(1930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_692__toggle_right__ = __webpack_require__(1931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_693__toggle_up__ = __webpack_require__(1932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_694__trademark__ = __webpack_require__(1933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_695__train__ = __webpack_require__(1934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_696__transgender_alt__ = __webpack_require__(1935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_697__transgender__ = __webpack_require__(1936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_698__trash_o__ = __webpack_require__(1937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_699__trash__ = __webpack_require__(1938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_700__tree__ = __webpack_require__(1939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_701__trello__ = __webpack_require__(1940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_702__tripadvisor__ = __webpack_require__(1941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_703__trophy__ = __webpack_require__(1942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_704__truck__ = __webpack_require__(1943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_705__try__ = __webpack_require__(1944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_706__tty__ = __webpack_require__(1945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_707__tumblr_square__ = __webpack_require__(1946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_708__tumblr__ = __webpack_require__(1947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_709__turkish_lira__ = __webpack_require__(1948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_710__tv__ = __webpack_require__(1949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_711__twitch__ = __webpack_require__(1950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_712__twitter_square__ = __webpack_require__(1951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_713__twitter__ = __webpack_require__(1952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_714__umbrella__ = __webpack_require__(1953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_715__underline__ = __webpack_require__(1954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_716__undo__ = __webpack_require__(1955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_717__universal_access__ = __webpack_require__(1956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_718__university__ = __webpack_require__(1957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_719__unlink__ = __webpack_require__(1958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_720__unlock_alt__ = __webpack_require__(1959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_721__unlock__ = __webpack_require__(1960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_722__unsorted__ = __webpack_require__(1961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_723__upload__ = __webpack_require__(1962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_724__usb__ = __webpack_require__(1963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_725__usd__ = __webpack_require__(1964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_726__user_circle_o__ = __webpack_require__(1965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_727__user_circle__ = __webpack_require__(1966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_728__user_md__ = __webpack_require__(1967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_729__user_o__ = __webpack_require__(1968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_730__user_plus__ = __webpack_require__(1969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_731__user_secret__ = __webpack_require__(1970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_732__user_times__ = __webpack_require__(1971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_733__user__ = __webpack_require__(1972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_734__users__ = __webpack_require__(1973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_735__vcard_o__ = __webpack_require__(1974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_736__vcard__ = __webpack_require__(1975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_737__venus_double__ = __webpack_require__(1976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_738__venus_mars__ = __webpack_require__(1977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_739__venus__ = __webpack_require__(1978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_740__viacoin__ = __webpack_require__(1979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_741__viadeo_square__ = __webpack_require__(1980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_742__viadeo__ = __webpack_require__(1981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_743__video_camera__ = __webpack_require__(1982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_744__vimeo_square__ = __webpack_require__(1983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_745__vimeo__ = __webpack_require__(1984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_746__vine__ = __webpack_require__(1985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_747__vk__ = __webpack_require__(1986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_748__volume_control_phone__ = __webpack_require__(1987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_749__volume_down__ = __webpack_require__(1988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_750__volume_off__ = __webpack_require__(1989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_751__volume_up__ = __webpack_require__(1990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_752__warning__ = __webpack_require__(1991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_753__wechat__ = __webpack_require__(1992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_754__weibo__ = __webpack_require__(1993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_755__weixin__ = __webpack_require__(1994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_756__whatsapp__ = __webpack_require__(1995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_757__wheelchair_alt__ = __webpack_require__(1996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_758__wheelchair__ = __webpack_require__(1997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_759__wifi__ = __webpack_require__(1998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_760__wikipedia_w__ = __webpack_require__(1999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_761__window_close_o__ = __webpack_require__(2000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_762__window_close__ = __webpack_require__(2001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_763__window_maximize__ = __webpack_require__(2002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_764__window_minimize__ = __webpack_require__(2003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_765__window_restore__ = __webpack_require__(2004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_766__windows__ = __webpack_require__(2005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_767__won__ = __webpack_require__(2006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_768__wordpress__ = __webpack_require__(2007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_769__wpbeginner__ = __webpack_require__(2008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_770__wpexplorer__ = __webpack_require__(2009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_771__wpforms__ = __webpack_require__(2010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_772__wrench__ = __webpack_require__(2011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_773__xing_square__ = __webpack_require__(2012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_774__xing__ = __webpack_require__(2013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_775__y_combinator_square__ = __webpack_require__(2014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_776__y_combinator__ = __webpack_require__(2015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_777__yahoo__ = __webpack_require__(2016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_778__yc_square__ = __webpack_require__(2017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_779__yc__ = __webpack_require__(2018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_780__yelp__ = __webpack_require__(2019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_781__yen__ = __webpack_require__(2020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_782__yoast__ = __webpack_require__(2021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_783__youtube_play__ = __webpack_require__(2022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_784__youtube_square__ = __webpack_require__(2023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_785__youtube__ = __webpack_require__(2024);




















































































































































































































































































































































































































































































































































































































































































































































































































/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * vue-charts v0.2.1
 * (c) 2016 Hayden Bickerton
 * Released under the MIT License.
 */


var _ = __webpack_require__(9);
_ = 'default' in _ ? _['default'] : _;

/*
    This lets us resolve the promise outside the
    promise function itself.
 */
function makeDeferred() {
  var resolvePromise = null;
  var rejectPromise = null;

  var promise = new Promise(function (resolve, reject) {
    resolvePromise = resolve;
    rejectPromise = reject;
  });

  return {
    promise: promise,
    resolve: resolvePromise,
    reject: rejectPromise
  };
}

function eventsBinder(vue, googleChart, events) {
  // Loop through our events, create a listener for them, and
  // attach our callback function to that event.
  for (var event in events) {
    var eventName = event;
    var eventCallback = events[event];

    if (eventName === 'ready') {
      // The chart is already ready, so this event missed it's chance.
      // We'll call it manually.
      eventCallback();
    } else {
      google.visualization.events.addListener(googleChart, eventName, eventCallback);
    }
  }
}

var isLoading = false;
var isLoaded = false;

// Our main promise
var googlePromise = makeDeferred();

function googleChartsLoader() {
  var packages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['corechart'];
  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'current';
  var mapsApiKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (!Array.isArray(packages)) {
    throw new TypeError('packages must be an array');
  }

  if (version !== 'current' && typeof version !== 'number' && version !== 'upcoming') {
    throw new TypeError('version must be a number, "upcoming" or "current"');
  }

  // Google only lets you load it once, so we'll only run once.
  if (isLoading || isLoaded) {
    return googlePromise.promise;
  }

  isLoading = true;

  var script = document.createElement('script');
  script.setAttribute('src', 'https://www.gstatic.com/charts/loader.js');

  script.onreadystatechange = script.onload = function () {
    // After the 'loader.js' is loaded, load our version and packages
    var options = {
      packages: packages
    };

    if (mapsApiKey) {
      options['mapsApiKey'] = mapsApiKey;
    }

    google.charts.load(version, options);

    // After we've loaded Google Charts, resolve our promise
    google.charts.setOnLoadCallback(function () {
      isLoading = false;
      isLoaded = true;
      googlePromise.resolve();
    });
  };

  // Insert our script into the DOM
  document.getElementsByTagName('head')[0].appendChild(script);

  return googlePromise.promise;
}

function propsWatcher(vue, props) {
  /*
    Watch our props. Every time they change, redraw the chart.
   */
  _.each(props, function (_ref, attribute) {
    var type = _ref.type;

    vue.$watch(attribute, function () {
      vue.drawChart();
    }, {
      deep: _.isObject(type)
    });
  });
}

var chartDeferred = makeDeferred();

var props = {
  packages: {
    type: Array,
    default: function _default() {
      return ['corechart'];
    }
  },
  version: {
    default: 'current'
  },
  mapsApiKey: {
    default: false
  },
  chartType: {
    type: String,
    default: function _default() {
      return 'LineChart';
    }
  },
  chartEvents: {
    type: Object,
    default: function _default() {
      return {};
    }
  },
  columns: {
    required: true,
    type: Array
  },
  rows: {
    type: Array,
    default: function _default() {
      return [];
    }
  },
  options: {
    type: Object,
    default: function _default() {
      return {
        chart: {
          title: 'Chart Title',
          subtitle: 'Subtitle'
        },
        hAxis: {
          title: 'X Label'
        },
        vAxis: {
          title: 'Y Label'
        },
        width: '400px',
        height: '300px',
        animation: {
          duration: 500,
          easing: 'out'
        }
      };
    }
  }
};

var Chart = {
  name: 'vue-chart',
  props: props,
  render: function render(h) {
    var self = this;
    return h('div', { class: 'vue-chart-container' }, [h('div', {
      attrs: {
        id: self.chartId,
        class: 'vue-chart'
      }
    })]);
  },
  data: function data() {
    return {
      chart: null,
      /*
          We put the uid in the DOM element so the component can be used multiple
          times in the same view. Otherwise Google Charts will only make one chart.
           The X is prepended because there must be at least
          1 character in id - https://www.w3.org/TR/html5/dom.html#the-id-attribute
      */
      chartId: 'X' + this._uid,
      wrapper: null,
      dataTable: [],
      hiddenColumns: []
    };
  },

  events: {
    redrawChart: function redrawChart() {
      this.drawChart();
    }
  },
  mounted: function mounted() {
    var self = this;
    googleChartsLoader(self.packages, self.version, self.mapsApiKey).then(self.drawChart).then(function () {
      // we don't want to bind props because it's a kind of "computed" property
      var watchProps = props;
      delete watchProps.bounds;

      // watching properties
      propsWatcher(self, watchProps);

      // binding events
      eventsBinder(self, self.chart, self.chartEvents);
    }).catch(function (error) {
      throw error;
    });
  },

  methods: {
    /**
     * Initialize the datatable and add the initial data.
     *
     * @link https://developers.google.com/chart/interactive/docs/reference#DataTable
     * @return object
     */
    buildDataTable: function buildDataTable() {
      var self = this;

      var dataTable = new google.visualization.DataTable();

      _.each(self.columns, function (value) {
        dataTable.addColumn(value);
      });

      if (!_.isEmpty(self.rows)) {
        dataTable.addRows(self.rows);
      }

      return dataTable;
    },


    /**
     * Update the datatable.
     *
     * @return void
     */
    updateDataTable: function updateDataTable() {
      var self = this;

      // Remove all data from the datatable.
      self.dataTable.removeRows(0, self.dataTable.getNumberOfRows());
      self.dataTable.removeColumns(0, self.dataTable.getNumberOfColumns());

      // Add
      _.each(self.columns, function (value) {
        self.dataTable.addColumn(value);
      });

      if (!_.isEmpty(self.rows)) {
        self.dataTable.addRows(self.rows);
      }
    },


    /**
     * Initialize the wrapper
     *
     * @link https://developers.google.com/chart/interactive/docs/reference#chartwrapper-class
     *
     * @return object
     */
    buildWrapper: function buildWrapper(chartType, dataTable, options, containerId) {
      var wrapper = new google.visualization.ChartWrapper({
        chartType: chartType,
        dataTable: dataTable,
        options: options,
        containerId: containerId
      });

      return wrapper;
    },


    /**
     * Build the chart.
     *
     * @return void
     */
    buildChart: function buildChart() {
      var self = this;

      // If dataTable isn't set, build it
      var dataTable = _.isEmpty(self.dataTable) ? self.buildDataTable() : self.dataTable;

      self.wrapper = self.buildWrapper(self.chartType, dataTable, self.options, self.chartId);

      // Set the datatable on this instance
      self.dataTable = self.wrapper.getDataTable();

      // After chart is built, set it on this instance and resolve the promise.
      google.visualization.events.addOneTimeListener(self.wrapper, 'ready', function () {
        self.chart = self.wrapper.getChart();
        chartDeferred.resolve();
      });
    },


    /**
     * Draw the chart.
     *
     * @return Promise
     */
    drawChart: function drawChart() {
      var self = this;

      // We don't have any (usable) data, or we don't have columns. We can't draw a chart without those.
      if (!_.isEmpty(self.rows) && !_.isObjectLike(self.rows) || _.isEmpty(self.columns)) {
        return;
      }

      if (_.isNull(self.chart)) {
        // We haven't built the chart yet, so JUST. DO. IT!
        self.buildChart();
      } else {
        // Chart already exists, just update the data
        self.updateDataTable();
      }

      // Chart has been built/Data has been updated, draw the chart.
      self.wrapper.draw();

      // Return promise. Resolves when chart finishes loading.
      return chartDeferred.promise;
    }
  }
};

function install(Vue) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  Vue.component('vue-chart', Chart);
}

module.exports = install;

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dist_vue_circle_slider_common_js__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dist_vue_circle_slider_common_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__dist_vue_circle_slider_common_js__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dist_vue_circle_slider_css__ = __webpack_require__(1234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dist_vue_circle_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__dist_vue_circle_slider_css__);

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__dist_vue_circle_slider_common_js___default.a);




/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(2205)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(495),
  /* template */
  __webpack_require__(2161),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.VueMultiselect=e():t.VueMultiselect=e()}(this,function(){return function(t){function e(n){if(i[n])return i[n].exports;var s=i[n]={i:n,l:!1,exports:{}};return t[n].call(s.exports,s,s.exports,e),s.l=!0,s.exports}var i={};return e.m=t,e.c=i,e.i=function(t){return t},e.d=function(t,i,n){e.o(t,i)||Object.defineProperty(t,i,{configurable:!1,enumerable:!0,get:n})},e.n=function(t){var i=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(i,"a",i),i},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="/",e(e.s=4)}([function(t,e,i){"use strict";function n(t,e,i){return e in t?Object.defineProperty(t,e,{value:i,enumerable:!0,configurable:!0,writable:!0}):t[e]=i,t}function s(t){return 0!==t&&(!(!Array.isArray(t)||0!==t.length)||!t)}function l(t,e){return void 0===t&&(t="undefined"),null===t&&(t="null"),!1===t&&(t="false"),-1!==t.toString().toLowerCase().indexOf(e.trim())}function o(t,e,i,n){return t.filter(function(t){return l(n(t,i),e)})}function r(t){return t.filter(function(t){return!t.$isLabel})}function a(t,e){return function(i){return i.reduce(function(i,n){return n[t]&&n[t].length?(i.push({$groupLabel:n[e],$isLabel:!0}),i.concat(n[t])):i},[])}}function u(t,e,i,s,l){return function(r){return r.map(function(r){var a;if(!r[i])return console.warn("Options passed to vue-multiselect do not contain groups, despite the config."),[];var u=o(r[i],t,e,l);return u.length?(a={},n(a,s,r[s]),n(a,i,u),a):[]})}}Object.defineProperty(e,"__esModule",{value:!0});var c="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},h=i(2),p=function(t){return t&&t.__esModule?t:{default:t}}(h),d=function(){for(var t=arguments.length,e=Array(t),i=0;i<t;i++)e[i]=arguments[i];return function(t){return e.reduce(function(t,e){return e(t)},t)}};e.default={data:function(){return{search:"",isOpen:!1,prefferedOpenDirection:"below",optimizedHeight:this.maxHeight,internalValue:this.value||0===this.value?(0,p.default)(Array.isArray(this.value)?this.value:[this.value]):[]}},props:{internalSearch:{type:Boolean,default:!0},options:{type:Array,required:!0},multiple:{type:Boolean,default:!1},value:{type:null,default:function(){return[]}},trackBy:{type:String},label:{type:String},searchable:{type:Boolean,default:!0},clearOnSelect:{type:Boolean,default:!0},hideSelected:{type:Boolean,default:!1},placeholder:{type:String,default:"Select option"},allowEmpty:{type:Boolean,default:!0},resetAfter:{type:Boolean,default:!1},closeOnSelect:{type:Boolean,default:!0},customLabel:{type:Function,default:function(t,e){return s(t)?"":e?t[e]:t}},taggable:{type:Boolean,default:!1},tagPlaceholder:{type:String,default:"Press enter to create a tag"},max:{type:Number},id:{default:null},optionsLimit:{type:Number,default:1e3},groupValues:{type:String},groupLabel:{type:String},blockKeys:{type:Array,default:function(){return[]}},preserveSearch:{type:Boolean,default:!1}},mounted:function(){this.multiple||this.clearOnSelect||console.warn("[Vue-Multiselect warn]: ClearOnSelect and Multiple props can’t be both set to false.")},computed:{filteredOptions:function(){var t=this.search||"",e=t.toLowerCase(),i=this.options.concat();return this.internalSearch?(i=this.groupValues?this.filterAndFlat(i,e,this.label):o(i,e,this.label,this.customLabel),i=this.hideSelected?i.filter(this.isNotSelected):i):i=this.groupValues?a(this.groupValues,this.groupLabel)(i):i,this.taggable&&e.length&&!this.isExistingOption(e)&&i.unshift({isTag:!0,label:t}),i.slice(0,this.optionsLimit)},valueKeys:function(){var t=this;return this.trackBy?this.internalValue.map(function(e){return e[t.trackBy]}):this.internalValue},optionKeys:function(){var t=this;return(this.groupValues?this.flatAndStrip(this.options):this.options).map(function(e){return t.customLabel(e,t.label).toString().toLowerCase()})},currentOptionLabel:function(){return this.multiple?this.searchable?"":this.placeholder:this.internalValue[0]?this.getOptionLabel(this.internalValue[0]):this.searchable?"":this.placeholder}},watch:{internalValue:function(t,e){this.resetAfter&&this.internalValue.length&&(this.search="",this.internalValue=[])},search:function(){this.$emit("search-change",this.search,this.id)},value:function(t){this.internalValue=this.getInternalValue(t)}},methods:{getValue:function(){return this.multiple?(0,p.default)(this.internalValue):0===this.internalValue.length?null:(0,p.default)(this.internalValue[0])},getInternalValue:function(t){return null===t||void 0===t?[]:this.multiple?(0,p.default)(t):(0,p.default)([t])},filterAndFlat:function(t,e,i){return d(u(e,i,this.groupValues,this.groupLabel,this.customLabel),a(this.groupValues,this.groupLabel))(t)},flatAndStrip:function(t){return d(a(this.groupValues,this.groupLabel),r)(t)},updateSearch:function(t){this.search=t},isExistingOption:function(t){return!!this.options&&this.optionKeys.indexOf(t)>-1},isSelected:function(t){var e=this.trackBy?t[this.trackBy]:t;return this.valueKeys.indexOf(e)>-1},isNotSelected:function(t){return!this.isSelected(t)},getOptionLabel:function(t){return s(t)?"":t.isTag?t.label:t.$isLabel?t.$groupLabel:this.customLabel(t,this.label)||""},select:function(t,e){if(!(-1!==this.blockKeys.indexOf(e)||this.disabled||t.$isLabel||t.$isDisabled||this.max&&this.multiple&&this.internalValue.length===this.max)){if(t.isTag)this.$emit("tag",t.label,this.id),this.search="",this.closeOnSelect&&!this.multiple&&this.deactivate();else{if(this.isSelected(t))return void("Tab"!==e&&this.removeElement(t));this.multiple?this.internalValue.push(t):this.internalValue=[t],this.$emit("select",(0,p.default)(t),this.id),this.$emit("input",this.getValue(),this.id),this.clearOnSelect&&(this.search="")}this.closeOnSelect&&this.deactivate()}},removeElement:function(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];if(!this.disabled){if(!this.allowEmpty&&this.internalValue.length<=1)return void this.deactivate();var i="object"===(void 0===t?"undefined":c(t))?this.valueKeys.indexOf(t[this.trackBy]):this.valueKeys.indexOf(t);this.internalValue.splice(i,1),this.$emit("remove",(0,p.default)(t),this.id),this.$emit("input",this.getValue(),this.id),this.closeOnSelect&&e&&this.deactivate()}},removeLastElement:function(){-1===this.blockKeys.indexOf("Delete")&&0===this.search.length&&Array.isArray(this.internalValue)&&this.removeElement(this.internalValue[this.internalValue.length-1],!1)},activate:function(){var t=this;this.isOpen||this.disabled||(this.adjustPosition(),this.groupValues&&0===this.pointer&&this.filteredOptions.length&&(this.pointer=1),this.isOpen=!0,this.searchable?(this.preserveSearch||(this.search=""),this.$nextTick(function(){return t.$refs.search.focus()})):this.$el.focus(),this.$emit("open",this.id))},deactivate:function(){this.isOpen&&(this.isOpen=!1,this.searchable?this.$refs.search.blur():this.$el.blur(),this.preserveSearch||(this.search=""),this.$emit("close",this.getValue(),this.id))},toggle:function(){this.isOpen?this.deactivate():this.activate()},adjustPosition:function(){if("undefined"!=typeof window){var t=this.$el.getBoundingClientRect().top,e=window.innerHeight-this.$el.getBoundingClientRect().bottom;e>this.maxHeight||e>t||"below"===this.openDirection||"bottom"===this.openDirection?(this.prefferedOpenDirection="below",this.optimizedHeight=Math.min(e,this.maxHeight)-40):(this.prefferedOpenDirection="above",this.optimizedHeight=Math.min(t,this.maxHeight)-40)}}}}},function(t,e,i){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default={data:function(){return{pointer:0,visibleElements:this.maxHeight/this.optionHeight}},props:{showPointer:{type:Boolean,default:!0},optionHeight:{type:Number,default:40}},computed:{pointerPosition:function(){return this.pointer*this.optionHeight}},watch:{filteredOptions:function(){this.pointerAdjust()}},methods:{optionHighlight:function(t,e){return{"multiselect__option--highlight":t===this.pointer&&this.showPointer,"multiselect__option--selected":this.isSelected(e)}},addPointerElement:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"Enter",e=t.key;this.filteredOptions.length>0&&this.select(this.filteredOptions[this.pointer],e),this.pointerReset()},pointerForward:function(){this.pointer<this.filteredOptions.length-1&&(this.pointer++,this.$refs.list.scrollTop<=this.pointerPosition-this.visibleElements*this.optionHeight&&(this.$refs.list.scrollTop=this.pointerPosition-(this.visibleElements-1)*this.optionHeight),this.filteredOptions[this.pointer].$isLabel&&this.pointerForward())},pointerBackward:function(){this.pointer>0?(this.pointer--,this.$refs.list.scrollTop>=this.pointerPosition&&(this.$refs.list.scrollTop=this.pointerPosition),this.filteredOptions[this.pointer].$isLabel&&this.pointerBackward()):this.filteredOptions[0].$isLabel&&this.pointerForward()},pointerReset:function(){this.closeOnSelect&&(this.pointer=0,this.$refs.list&&(this.$refs.list.scrollTop=0))},pointerAdjust:function(){this.pointer>=this.filteredOptions.length-1&&(this.pointer=this.filteredOptions.length?this.filteredOptions.length-1:0)},pointerSet:function(t){this.pointer=t}}}},function(t,e,i){"use strict";function n(t){if(Array.isArray(t))return t.map(n);if(t&&"object"===(void 0===t?"undefined":s(t))){for(var e={},i=Object.keys(t),l=0,o=i.length;l<o;l++){var r=i[l];e[r]=n(t[r])}return e}return t}Object.defineProperty(e,"__esModule",{value:!0});var s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};e.default=n},function(t,e,i){i(6);var n=i(7)(i(5),i(8),null,null);t.exports=n.exports},function(t,e,i){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0}),e.deepClone=e.pointerMixin=e.multiselectMixin=e.Multiselect=void 0;var s=i(3),l=n(s),o=i(0),r=n(o),a=i(1),u=n(a),c=i(2),h=n(c);e.default=l.default,e.Multiselect=l.default,e.multiselectMixin=r.default,e.pointerMixin=u.default,e.deepClone=h.default},function(t,e,i){"use strict";function n(t){return t&&t.__esModule?t:{default:t}}Object.defineProperty(e,"__esModule",{value:!0});var s=i(0),l=n(s),o=i(1),r=n(o);e.default={name:"vue-multiselect",mixins:[l.default,r.default],props:{name:{type:String,default:""},selectLabel:{type:String,default:"Press enter to select"},selectedLabel:{type:String,default:"Selected"},deselectLabel:{type:String,default:"Press enter to remove"},showLabels:{type:Boolean,default:!0},limit:{type:Number,default:99999},maxHeight:{type:Number,default:300},limitText:{type:Function,default:function(t){return"and "+t+" more"}},loading:{type:Boolean,default:!1},disabled:{type:Boolean,default:!1},openDirection:{type:String,default:""},showNoResults:{type:Boolean,default:!0},tabindex:{type:Number,default:0}},computed:{visibleValue:function(){return this.multiple?this.internalValue.slice(0,this.limit):[]},deselectLabelText:function(){return this.showLabels?this.deselectLabel:""},selectLabelText:function(){return this.showLabels?this.selectLabel:""},selectedLabelText:function(){return this.showLabels?this.selectedLabel:""},inputStyle:function(){if(this.multiple&&this.value&&this.value.length)return this.isOpen?{width:"auto"}:{display:"none"}},contentStyle:function(){return this.options.length?{display:"inline-block"}:{display:"block"}},isAbove:function(){return"above"===this.openDirection||"top"===this.openDirection||"below"!==this.openDirection&&"bottom"!==this.openDirection&&"above"===this.prefferedOpenDirection}}}},function(t,e){},function(t,e){t.exports=function(t,e,i,n){var s,l=t=t||{},o=typeof t.default;"object"!==o&&"function"!==o||(s=t,l=t.default);var r="function"==typeof l?l.options:l;if(e&&(r.render=e.render,r.staticRenderFns=e.staticRenderFns),i&&(r._scopeId=i),n){var a=Object.create(r.computed||null);Object.keys(n).forEach(function(t){var e=n[t];a[t]=function(){return e}}),r.computed=a}return{esModule:s,exports:l,options:r}}},function(t,e){t.exports={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("div",{staticClass:"multiselect",class:{"multiselect--active":t.isOpen,"multiselect--disabled":t.disabled,"multiselect--above":t.isAbove},attrs:{tabindex:t.tabindex},on:{focus:function(e){t.activate()},blur:function(e){!t.searchable&&t.deactivate()},keydown:[function(e){return"button"in e||!t._k(e.keyCode,"down",40)?e.target!==e.currentTarget?null:(e.preventDefault(),void t.pointerForward()):null},function(e){return"button"in e||!t._k(e.keyCode,"up",38)?e.target!==e.currentTarget?null:(e.preventDefault(),void t.pointerBackward()):null},function(e){return"button"in e||!t._k(e.keyCode,"enter",13)||!t._k(e.keyCode,"tab",9)?(e.stopPropagation(),e.target!==e.currentTarget?null:void t.addPointerElement(e)):null}],keyup:function(e){if(!("button"in e)&&t._k(e.keyCode,"esc",27))return null;t.deactivate()}}},[t._t("carret",[i("div",{staticClass:"multiselect__select",on:{mousedown:function(e){e.preventDefault(),e.stopPropagation(),t.toggle()}}})]),t._v(" "),t._t("clear",null,{search:t.search}),t._v(" "),i("div",{ref:"tags",staticClass:"multiselect__tags"},[i("div",{directives:[{name:"show",rawName:"v-show",value:t.visibleValue.length>0,expression:"visibleValue.length > 0"}],staticClass:"multiselect__tags-wrap"},[t._l(t.visibleValue,function(e){return[t._t("tag",[i("span",{staticClass:"multiselect__tag"},[i("span",{domProps:{textContent:t._s(t.getOptionLabel(e))}}),t._v(" "),i("i",{staticClass:"multiselect__tag-icon",attrs:{"aria-hidden":"true",tabindex:"1"},on:{keydown:function(i){if(!("button"in i)&&t._k(i.keyCode,"enter",13))return null;i.preventDefault(),t.removeElement(e)},mousedown:function(i){i.preventDefault(),t.removeElement(e)}}})])],{option:e,search:t.search,remove:t.removeElement})]})],2),t._v(" "),t.internalValue&&t.internalValue.length>t.limit?[i("strong",{staticClass:"multiselect__strong",domProps:{textContent:t._s(t.limitText(t.internalValue.length-t.limit))}})]:t._e(),t._v(" "),i("transition",{attrs:{name:"multiselect__loading"}},[t._t("loading",[i("div",{directives:[{name:"show",rawName:"v-show",value:t.loading,expression:"loading"}],staticClass:"multiselect__spinner"})])],2),t._v(" "),t.searchable?i("input",{ref:"search",staticClass:"multiselect__input",style:t.inputStyle,attrs:{name:t.name,id:t.id,type:"text",autocomplete:"off",placeholder:t.placeholder,disabled:t.disabled},domProps:{value:t.isOpen?t.search:t.currentOptionLabel},on:{input:function(e){t.updateSearch(e.target.value)},focus:function(e){e.preventDefault(),t.activate()},blur:function(e){e.preventDefault(),t.deactivate()},keyup:function(e){if(!("button"in e)&&t._k(e.keyCode,"esc",27))return null;t.deactivate()},keydown:[function(e){if(!("button"in e)&&t._k(e.keyCode,"down",40))return null;e.preventDefault(),t.pointerForward()},function(e){if(!("button"in e)&&t._k(e.keyCode,"up",38))return null;e.preventDefault(),t.pointerBackward()},function(e){return"button"in e||!t._k(e.keyCode,"enter",13)?(e.preventDefault(),e.stopPropagation(),e.target!==e.currentTarget?null:void t.addPointerElement(e)):null},function(e){if(!("button"in e)&&t._k(e.keyCode,"delete",[8,46]))return null;e.stopPropagation(),t.removeLastElement()}]}}):t._e(),t._v(" "),t.searchable?t._e():i("span",{staticClass:"multiselect__single",domProps:{textContent:t._s(t.currentOptionLabel)}})],2),t._v(" "),i("transition",{attrs:{name:"multiselect"}},[i("div",{directives:[{name:"show",rawName:"v-show",value:t.isOpen,expression:"isOpen"}],ref:"list",staticClass:"multiselect__content-wrapper",style:{maxHeight:t.optimizedHeight+"px"},on:{mousedown:function(t){t.preventDefault()}}},[i("ul",{staticClass:"multiselect__content",style:t.contentStyle},[t._t("beforeList"),t._v(" "),t.multiple&&t.max===t.internalValue.length?i("li",[i("span",{staticClass:"multiselect__option"},[t._t("maxElements",[t._v("Maximum of "+t._s(t.max)+" options selected. First remove a selected option to select another.")])],2)]):t._e(),t._v(" "),!t.max||t.internalValue.length<t.max?t._l(t.filteredOptions,function(e,n){return i("li",{key:n,staticClass:"multiselect__element"},[e&&(e.$isLabel||e.$isDisabled)?t._e():i("span",{staticClass:"multiselect__option",class:t.optionHighlight(n,e),attrs:{"data-select":e&&e.isTag?t.tagPlaceholder:t.selectLabelText,"data-selected":t.selectedLabelText,"data-deselect":t.deselectLabelText},on:{click:function(i){i.stopPropagation(),t.select(e)},mouseenter:function(e){if(e.target!==e.currentTarget)return null;t.pointerSet(n)}}},[t._t("option",[i("span",[t._v(t._s(t.getOptionLabel(e)))])],{option:e,search:t.search})],2),t._v(" "),e&&(e.$isLabel||e.$isDisabled)?i("span",{staticClass:"multiselect__option multiselect__option--disabled",class:t.optionHighlight(n,e)},[t._t("option",[i("span",[t._v(t._s(t.getOptionLabel(e)))])],{option:e,search:t.search})],2):t._e()])}):t._e(),t._v(" "),i("li",{directives:[{name:"show",rawName:"v-show",value:t.showNoResults&&0===t.filteredOptions.length&&t.search&&!t.loading,expression:"showNoResults && (filteredOptions.length === 0 && search && !loading)"}]},[i("span",{staticClass:"multiselect__option"},[t._t("noResult",[t._v("No elements found. Consider changing the search query.")])],2)]),t._v(" "),t._t("afterList")],2)])])],2)},staticRenderFns:[]}}])});

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * vue-nav-tabs v0.5.2
 * (c) 2017-present cristij <joracristi@gmail.com>
 * Released under the MIT License.
 */


Object.defineProperty(exports, '__esModule', { value: true });

var VueTabs = {
    name: 'vue-tabs',
    props: {
        activeTabColor: String,
        activeTextColor: String,
        /**
         * Tab title position: center | bottom | top
         */
        textPosition: {
            type: String,
            default: 'center'
        },
        /**
         * Tab type: tabs | pills
         */
        type: {
            type: String,
            default: 'tabs'
        },
        direction: {
            type: String,
            default: 'horizontal'
        },
        /**
         * Centers the tabs and makes the container div full width
         */
        centered: Boolean,
        value: [String, Number, Object]
    },
    data: function data() {
        return {
            activeTabIndex: 0,
            tabs: []
        };
    },

    computed: {
        isTabShape: function isTabShape() {
            return this.type === 'tabs';
        },
        isStacked: function isStacked() {
            return this.direction === 'vertical';
        },
        classList: function classList() {
            var navType = this.isTabShape ? 'nav-tabs' : 'nav-pills';
            var centerClass = this.centered ? 'nav-justified' : '';
            var isStacked = this.isStacked ? 'nav-stacked' : '';
            return 'nav ' + navType + ' ' + centerClass + ' ' + isStacked;
        },
        stackedClass: function stackedClass() {
            return this.isStacked ? 'stacked' : '';
        },
        activeTabStyle: function activeTabStyle() {
            return {
                backgroundColor: this.activeTabColor,
                color: this.activeTextColor
            };
        }
    },
    methods: {
        navigateToTab: function navigateToTab(index, route) {
            this.changeTab(this.activeTabIndex, index, route);
        },
        activateTab: function activateTab(index) {
            this.activeTabIndex = index;
            var tab = this.tabs[index];
            tab.active = true;
            this.$emit('input', tab.title);
        },
        changeTab: function changeTab(oldIndex, newIndex, route) {
            this.activeTabIndex = newIndex;
            var oldTab = this.tabs[oldIndex];
            var newTab = this.tabs[newIndex];
            oldTab.active = false;
            newTab.active = true;
            this.$emit('input', this.tabs[newIndex].title);
            this.$emit('tab-change', newIndex, newTab, oldTab);
            this.tryChangeRoute(route);
        },
        tryChangeRoute: function tryChangeRoute(route) {
            if (this.$router && route) {
                this.$router.push(route);
            }
        },
        addTab: function addTab(item) {
            var index = this.$slots.default.indexOf(item.$vnode);
            this.tabs.splice(index, 0, item);
        },
        removeTab: function removeTab(item) {
            var tabs = this.tabs;
            var index = tabs.indexOf(item);
            if (index > -1) {
                tabs.splice(index, 1);
            }
        },
        getTabs: function getTabs() {
            if (this.$slots.default) {
                return this.$slots.default.filter(function (comp) {
                    return comp.componentOptions;
                });
            }
            return [];
        },
        findTabAndActivate: function findTabAndActivate(tabNameOrIndex) {
            var indexToActivate = this.tabs.findIndex(function (tab, index) {
                return tab.title === tabNameOrIndex || index === tabNameOrIndex;
            });
            if (indexToActivate != -1) {
                this.changeTab(this.activeTabIndex, indexToActivate);
            } else {
                this.changeTab(this.activeTabIndex, 0);
            }
        },
        renderTabTitle: function renderTabTitle(index) {
            var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
            var h = this.$createElement;

            if (this.tabs.length === 0) return;
            var tab = this.tabs[index];
            var active = tab.active,
                title = tab.title;

            var titleStyles = { color: this.activeTabColor };
            if (position === 'center') titleStyles.color = this.activeTextColor;
            var simpleTitle = h(
                'span',
                { 'class': 'title title_' + position, style: active ? titleStyles : {} },
                [position === 'center' && this.renderIcon(index), title]
            );

            if (tab.$slots.title) return tab.$slots.title;
            return simpleTitle;
        },
        renderIcon: function renderIcon(index) {
            var h = this.$createElement;

            if (this.tabs.length === 0) return;
            var tab = this.tabs[index];
            var icon = tab.icon;

            var simpleIcon = h(
                'i',
                { 'class': icon },
                ['\xA0']
            );
            if (!tab.$slots.title && icon) return simpleIcon;
        },
        renderTabs: function renderTabs() {
            var _this = this;

            var h = this.$createElement;

            return this.tabs.map(function (tab, index) {
                if (!tab) return;
                var route = tab.route,
                    id = tab.id,
                    title = tab.title,
                    icon = tab.icon;

                var active = _this.activeTabIndex === index;
                return h(
                    'li',
                    {
                        attrs: { name: 'tab',
                            role: 'presentation' },
                        on: {
                            'click': function click() {
                                return _this.navigateToTab(index, route);
                            }
                        },
                        'class': ['tab', { active: active }],
                        key: title },
                    [_this.textPosition === 'top' && _this.renderTabTitle(index, _this.textPosition), h(
                        'a',
                        {
                            attrs: { href: 'javascript:void(0)',

                                'aria-selected': active,
                                'aria-controls': '#' + id,
                                role: 'tab' },
                            on: {
                                'click': function click() {
                                    return _this.navigateToTab(index);
                                }
                            },

                            style: active ? _this.activeTabStyle : {},
                            'class': { 'active_tab': active } },
                        [_this.textPosition !== 'center' && !tab.$slots.title && _this.renderIcon(index), _this.textPosition === 'center' && _this.renderTabTitle(index, _this.textPosition)]
                    ), _this.textPosition === 'bottom' && _this.renderTabTitle(index, _this.textPosition)]
                );
            });
        }
    },
    render: function render() {
        var h = arguments[0];

        var tabList = this.renderTabs();
        return h(
            'div',
            { 'class': ['vue-tabs', this.stackedClass] },
            [h(
                'div',
                { 'class': [{ 'nav-tabs-navigation': !this.isStacked }, { 'left-vertical-tabs': this.isStacked }] },
                [h(
                    'div',
                    { 'class': ['nav-tabs-wrapper', this.stackedClass] },
                    [h(
                        'ul',
                        { 'class': this.classList, attrs: { role: 'tablist' }
                        },
                        [tabList]
                    )]
                )]
            ), h(
                'div',
                { 'class': ['tab-content', { 'right-text-tabs': this.isStacked }] },
                [this.$slots.default]
            )]
        );
    },

    watch: {
        tabs: function tabs(newList) {
            if (newList.length > 0 && !this.value) {
                this.activateTab(this.activeTabIndex);
            }
            if (newList.length > 0 && this.value) {
                this.findTabAndActivate(this.value);
            }
        },
        value: function value(newVal) {
            this.findTabAndActivate(newVal);
        }
    }
};

var VTab = {
    name: 'v-tab',
    props: {
        title: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
            default: ''
        },
        /***
         * Function to execute before tab switch. Return value must be boolean
         * If the return result is false, tab switch is restricted
         */
        beforeChange: {
            type: Function
        },
        id: String,
        route: {
            type: [String, Object]
        },
        transitionName: String,
        transitionMode: String
    },
    computed: {
        isValidParent: function isValidParent() {
            return this.$parent.$options.name === 'vue-tabs';
        },
        hash: function hash() {
            return '#' + this.id;
        }
    },
    data: function data() {
        return {
            active: false,
            validationError: null
        };
    },
    mounted: function mounted() {
        this.$parent.addTab(this);
    },
    destroyed: function destroyed() {
        if (this.$el && this.$el.parentNode) {
            this.$el.parentNode.removeChild(this.$el);
        }
        this.$parent.removeTab(this);
    },
    render: function render() {
        var h = arguments[0];

        return h(
            'section',
            { 'class': 'tab-container',
                attrs: { role: 'tabpanel' },
                directives: [{
                    name: 'show',
                    value: this.active
                }]
            },
            [this.$slots.default]
        );
    }
};

var VueTabsPlugin = {
  install: function install(Vue) {
    Vue.component('vue-tabs', VueTabs);
    Vue.component('v-tab', VTab);
  }
};
// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(VueTabsPlugin);
  window.VueTabs = VueTabsPlugin;
}

exports['default'] = VueTabsPlugin;
exports.VueTabs = VueTabs;
exports.VTab = VTab;


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MountableMixin = exports.Autocomplete = exports.MapElementMixin = exports.PlaceInput = exports.Map = exports.InfoWindow = exports.Rectangle = exports.Circle = exports.Polygon = exports.Polyline = exports.Cluster = exports.Marker = exports.loaded = exports.load = undefined;
exports.install = install;

var _manager = __webpack_require__(116);

var _marker = __webpack_require__(2231);

var _marker2 = _interopRequireDefault(_marker);

var _cluster = __webpack_require__(2230);

var _cluster2 = _interopRequireDefault(_cluster);

var _polyline = __webpack_require__(2233);

var _polyline2 = _interopRequireDefault(_polyline);

var _polygon = __webpack_require__(2232);

var _polygon2 = _interopRequireDefault(_polygon);

var _circle = __webpack_require__(2229);

var _circle2 = _interopRequireDefault(_circle);

var _rectangle = __webpack_require__(2234);

var _rectangle2 = _interopRequireDefault(_rectangle);

var _lodash = __webpack_require__(9);

var _lodash2 = _interopRequireDefault(_lodash);

var _infoWindow = __webpack_require__(2029);

var _infoWindow2 = _interopRequireDefault(_infoWindow);

var _map = __webpack_require__(2030);

var _map2 = _interopRequireDefault(_map);

var _streetViewPanorama = __webpack_require__(2032);

var _streetViewPanorama2 = _interopRequireDefault(_streetViewPanorama);

var _placeInput = __webpack_require__(2031);

var _placeInput2 = _interopRequireDefault(_placeInput);

var _autocomplete = __webpack_require__(2028);

var _autocomplete2 = _interopRequireDefault(_autocomplete);

var _mapElementMixin = __webpack_require__(76);

var _mapElementMixin2 = _interopRequireDefault(_mapElementMixin);

var _mountableMixin = __webpack_require__(222);

var _mountableMixin2 = _interopRequireDefault(_mountableMixin);

var _deferredReady = __webpack_require__(156);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// export everything


// Vue component imports
exports.load = _manager.load;
exports.loaded = _manager.loaded;
exports.Marker = _marker2.default;
exports.Cluster = _cluster2.default;
exports.Polyline = _polyline2.default;
exports.Polygon = _polygon2.default;
exports.Circle = _circle2.default;
exports.Rectangle = _rectangle2.default;
exports.InfoWindow = _infoWindow2.default;
exports.Map = _map2.default;
exports.PlaceInput = _placeInput2.default;
exports.MapElementMixin = _mapElementMixin2.default;
exports.Autocomplete = _autocomplete2.default;
exports.MountableMixin = _mountableMixin2.default;
function install(Vue, options) {
  options = _lodash2.default.defaults(options, {
    installComponents: true
  });

  Vue.use(_deferredReady.DeferredReady);

  var defaultResizeBus = new Vue();
  Vue.$gmapDefaultResizeBus = defaultResizeBus;
  Vue.mixin({
    created: function created() {
      this.$gmapDefaultResizeBus = defaultResizeBus;
    }
  });

  if (options.load) {
    (0, _manager.load)(options.load);
  }

  if (options.installComponents) {
    Vue.component('GmapMap', _map2.default);
    Vue.component('GmapMarker', _marker2.default);
    Vue.component('GmapCluster', _cluster2.default);
    Vue.component('GmapInfoWindow', _infoWindow2.default);
    Vue.component('GmapPolyline', _polyline2.default);
    Vue.component('GmapPolygon', _polygon2.default);
    Vue.component('GmapCircle', _circle2.default);
    Vue.component('GmapRectangle', _rectangle2.default);
    Vue.component('GmapAutocomplete', _autocomplete2.default);
    Vue.component('GmapPlaceInput', _placeInput2.default);
    Vue.component('GmapStreetViewPanorama', _streetViewPanorama2.default);
  }
}

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var staticMethods = __webpack_require__(236);

Object.keys(staticMethods).forEach(function (methodName) {
  var instaceMethodName = methodName.charAt(0).toUpperCase() + methodName.slice(1);
  exports['async' + instaceMethodName] = function () {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', staticMethods[methodName].apply(staticMethods, [this].concat(args)));

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function () {
      return _ref.apply(this, arguments);
    };
  }();
});

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper-slide',
  data: function data() {
    return {
      slideClass: 'swiper-slide'
    };
  },
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
    if (this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass;
    }
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },
  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
});

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

var browser = typeof window !== 'undefined';
if (browser) window.Swiper = __webpack_require__(466);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    },
    notNextTick: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    };
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function () {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        var setClassName = false;
        for (var className in self.defaultSwiperClasses) {
          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
            if (self.options[className]) {
              setClassName = true;
              self.defaultSwiperClasses[className] = self.options[className];
            }
          }
        }
        var mountInstance = function mountInstance() {
          self.swiper = new Swiper(self.$el, self.options);
        };
        setClassName ? self.$nextTick(mountInstance) : mountInstance();
      }
    }(this.options.notNextTick || this.notNextTick) ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
});

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var icons = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val) {
          if (!(val in icons)) {
            __WEBPACK_IMPORTED_MODULE_0_vue___default.a.util.warn('Invalid prop: prop "icon" is referring to an unregistered icon "' + val + '".' + '\nPlesase make sure you have imported this icon before using it.', this);
            return false;
          }
          return true;
        }
        return null;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        __WEBPACK_IMPORTED_MODULE_0_vue___default.a.util.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    clazz: function clazz() {
      return {
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse
      };
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.icon) {
      return;
    }
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;
    });
    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'app'
});

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dropdown_vue__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dropdown_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Dropdown_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'bar-actions',

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['activeNote', 'theme', 'user'])),

    components: {
        Dropdown: __WEBPACK_IMPORTED_MODULE_1__Dropdown_vue___default.a
    },

    data: function data() {
        return {
            lastIndex: 0,
            quotes: ['BONELL+DORIGA']
        };
    },

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['UPDATE_THEME', 'UPDATE_LANGUAGE']), {
        goTo: function goTo(location) {
            this.$router.push({ name: location });
        },
        setLanguage: function setLanguage(data) {
            var _this = this;

            this.UPDATE_LANGUAGE(data).then(function () {
                console.log(data);
            }).catch(function (error) {
                _this.error = error.message;
            });
        },
        onUpdateTheme: function onUpdateTheme() {
            var theme = this.theme === 'dark' ? 'light' : 'dark';
            this.UPDATE_THEME(theme);
        },
        randomQuote: function randomQuote() {
            var index = _.random(0, this.quotes.length - 1);
            return this.quotes[index];
        }
    })

});

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clipboard__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'bar-share-note',

  data: function data() {
    return {
      copyButtonText: 'Copy'
    };
  },

  mounted: function mounted() {
    var _this = this;

    var id = '#clipboardjs';
    var button = this.selectElement(id);
    var clipboard = new __WEBPACK_IMPORTED_MODULE_1_clipboard___default.a(button);
    clipboard.on('success', function (e) {
      _this.copyButtonText = 'Copied!';
    });
    clipboard.on('error', function (e) {
      _this.copyButtonText = 'Error';
    });
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["c" /* utilsMixin */]],

  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['activeKey', 'activeNote']), {
    noteUrl: function noteUrl() {
      return 'https://notational.co/n/' + this.activeKey;
    }
  }),

  methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['TOGGLE_IS_PUBLIC']), {
    selectUrl: function selectUrl() {
      var id = "#share-note-url";
      var input = this.selectElement(id);
      input.select();
    },
    onCopyLink: function onCopyLink() {
      var _this2 = this;

      setTimeout(function () {
        _this2.copyButtonText = 'Copy';
      }, 800);
    },
    onTogglePermission: function onTogglePermission() {
      this.TOGGLE_IS_PUBLIC(this.activeNote);
    },
    onDone: function onDone() {
      this.$emit('onDone');
    }
  })

});

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BarActions_vue__ = __webpack_require__(2033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BarActions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__BarActions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BarShareNote_vue__ = __webpack_require__(2034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BarShareNote_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__BarShareNote_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'bar',

  data: function data() {
    return {
      showShareNote: false
    };
  },

  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['activeNote'])),

  components: {
    BarActions: __WEBPACK_IMPORTED_MODULE_1__BarActions_vue___default.a,
    BarShareNote: __WEBPACK_IMPORTED_MODULE_2__BarShareNote_vue___default.a
  },

  watch: {
    activeNote: function activeNote() {
      this.showShareNote = false;
    }
  },

  methods: {
    onShareNote: function onShareNote() {
      this.showShareNote = !this.showShareNote;
    }
  }

});

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_keyboardjs__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_keyboardjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_keyboardjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SearchInfo_vue__ = __webpack_require__(2035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SearchInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SearchInfo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SearchResult_vue__ = __webpack_require__(2036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SearchResult_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SearchResult_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'search',

    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["b" /* noteMixin */], __WEBPACK_IMPORTED_MODULE_2__mixins__["c" /* utilsMixin */]],

    props: {
        preview: { type: Boolean, default: false }
    },

    data: function data() {
        return {
            query: '',
            isSearchFocused: true
        };
    },

    created: function created() {
        this.setUpHotKeys();
    },
    beforeDestroy: function beforeDestroy() {
        __WEBPACK_IMPORTED_MODULE_1_keyboardjs___default.a.reset();
    },


    components: {
        SearchInfo: __WEBPACK_IMPORTED_MODULE_3__SearchInfo_vue___default.a,
        SearchResult: __WEBPACK_IMPORTED_MODULE_4__SearchResult_vue___default.a
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['activeContact', 'activeNote', 'contacts', 'notes', 'user', 'resultIndex', 'renamingId', 'editingId']), {
        filteredContacts: function filteredContacts() {
            var contacts = void 0;
            if (this.query.length === 0) {
                contacts = this.contacts;
                return this.sortContacts(contacts);
            }

            contacts = this.filterContactsForQuery(this.query, this.contacts);
            contacts = this.sortContacts(contacts, true);

            console.log('the contacs in filteredcontacts...');
            console.log(contacts);
            return contacts;
        },
        filteredNotes: function filteredNotes() {
            var notes = void 0;
            if (this.query.length == 0) {
                notes = this.notes;
                return this.sortNotes(notes);
            }

            notes = this.filterNotesForQuery(this.query, this.notes);
            notes = this.sortNotes(notes, true);

            return notes;
        }
    }),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['CREATE_NOTE', 'RESET_ACTIVE_NOTE']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["d" /* mapMutations */])(['SET_ACTIVE_NOTE', 'SET_ACTIVE_KEY', 'SET_QUERY', 'SET_RESULT_INDEX']), {
        setUpHotKeys: function setUpHotKeys() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_1_keyboardjs___default.a.bind('ctrl + enter', function () {
                return _this.onCreate();
            });
            __WEBPACK_IMPORTED_MODULE_1_keyboardjs___default.a.bind('esc', function () {
                return _this.onEscape();
            });
            __WEBPACK_IMPORTED_MODULE_1_keyboardjs___default.a.bind('up', function (e) {
                if (!_this.editingId && !_this.renamingId) {
                    e.preventDefault();
                    _this.onUp();
                }
            });
            __WEBPACK_IMPORTED_MODULE_1_keyboardjs___default.a.bind('down', function (e) {
                if (!_this.editingId && !_this.renamingId) {
                    e.preventDefault();
                    _this.onDown();
                }
            });
        },
        onCreate: function onCreate() {
            var id = this.nextIdForNotes(this.notes);
            var name = this.query.length > 0 ? this.query : 'Untitled Note';
            var note = this.createNote(id, name);

            this.CREATE_NOTE(note);
        },
        onSearch: function onSearch() {
            if (this.activeNote) {
                var id = '#editor-textarea';
                this.focusElement(id);
            }
        },
        onEscape: function onEscape() {
            if (!this.editingId && !this.renamingId) {
                this.query = '';
                this.SET_QUERY('');
                this.RESET_ACTIVE_NOTE();
            }
            this.$refs.input.focus();
        },
        onUp: function onUp() {
            if (this.resultIndex > 0) {
                var index = this.resultIndex - 1;
                this.SET_RESULT_INDEX(index);

                var note = this.filteredNotes[index];
                this.SET_ACTIVE_NOTE(note);

                var key = this.findKeyForNoteId(note.id, this.notes);
                this.SET_ACTIVE_KEY(key);

                this.scrollToNoteId(note.id, false);
            }
        },
        onDown: function onDown() {
            if (this.resultIndex != this.filteredNotes.length - 1) {
                var index = this.resultIndex + 1;
                this.SET_RESULT_INDEX(index);

                var note = this.filteredNotes[index];
                this.SET_ACTIVE_NOTE(note);

                var key = this.findKeyForNoteId(note.id, this.notes);
                this.SET_ACTIVE_KEY(key);

                this.scrollToNoteId(note.id, true);
            }
        },
        scrollToNoteId: function scrollToNoteId(noteId, alignToTop) {
            var container = this.selectElement('.search__results');
            var containerViewTop = container.scrollTop;
            var containerViewBottom = containerViewTop + container.offsetHeight;

            var element = this.selectElement('#result_' + noteId);
            var elementTop = element.offsetTop - 104;
            var elementBottom = elementTop + element.offsetHeight;

            var isVisible = elementBottom <= containerViewBottom && elementTop >= containerViewTop;
            if (!isVisible) {
                element.scrollIntoView(alignToTop);
            }
        },
        onSelect: function onSelect(note) {
            if (this.resultIndex == -1 || note.id != this.activeNote.id) {
                var index = this.filteredNotes.indexOf(note);
                this.SET_RESULT_INDEX(index);
                this.SET_ACTIVE_NOTE(note);

                var key = this.findKeyForNoteId(note.id, this.notes);
                this.SET_ACTIVE_KEY(key);
            }
        },
        onRenameBlur: function onRenameBlur() {
            this.$refs.input.focus();
        },
        updateQuery: function updateQuery() {
            var hasSearchResults = this.filteredContacts.length > 0;
            var contact = hasSearchResults ? this.filteredContacts[0] : null;
            var key = hasSearchResults ? this.findKeyForContactId(contact.id, this.contacts) : null;
            var resultIndex = hasSearchResults ? 0 : -1;

            this.SET_ACTIVE_CONTACT(contact);
            this.SET_ACTIVE_KEY(key);
            this.SET_RESULT_INDEX(resultIndex);
            this.SET_QUERY(this.query);
        }
    })
});

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
        name: 'search-info',

        props: ['resultsCount', 'queryLength', 'selected', 'searching', 'renaming', 'editing']
});

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_keyboardjs__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_keyboardjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_keyboardjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'search-result',

  props: ['contact', 'isActive', 'renaming'],

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["c" /* utilsMixin */]],

  data: function data() {
    return {
      oldName: null,
      isRenamed: false,
      showDelete: false
    };
  },

  created: function created() {
    this.setUpHotKeys();
  },


  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['query', 'activeContact']), {
    name: function name() {
      if (this.query.length > 0) {
        var regexString = this.query.replace(/\s/g, '|');
        var re = new RegExp(regexString, 'gi');
        return this.contact.name.replace(/\n$/g, '\n\n').replace(re, '<mark>$&</mark>');
      }
      return this.contact.name;
    }
  }),

  methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['UPDATE_CONTACT', 'DELETE_CONTACT', 'RESET_ACTIVE_CONTACT']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["d" /* mapMutations */])(['SET_RESULT_INDEX', 'SET_RENAMING_ID']), {
    setUpHotKeys: function setUpHotKeys() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_keyboardjs___default.a.bind('alt + ctrl + r', function () {
        if (_this.activeContact) {
          _this.onRenameFocus();
        }
      });
      __WEBPACK_IMPORTED_MODULE_1_keyboardjs___default.a.bind('alt + ctrl + d', function () {
        if (_this.activeContact) _this.onDelete();
      });
    },
    onResultSelect: function onResultSelect() {
      this.$emit('onResultSelect', this.contact);
    },
    onRenameFocus: function onRenameFocus() {
      var _this2 = this;

      this.oldName = this.contact.name;
      this.SET_RENAMING_ID(this.activeContact.id);
      this.$nextTick(function () {
        var id = '#search-result-editor-' + _this2.activeContact.id;
        _this2.focusElement(id);
      });
    },
    onRenameBlur: function onRenameBlur() {
      if (this.oldName != null && this.name !== this.oldName && !this.isRenamed) {
        this.contact.name = this.oldName;
      }
      this.isRenamed = false;

      this.SET_RENAMING_ID(null);
      this.$emit('onRenameBlur');
    },
    onRenameSave: function onRenameSave() {
      this.UPDATE_CONTACT();
      this.oldName = null;
      this.isRenamed = true;
      this.SET_RESULT_INDEX(0);
      this.onRenameBlur();
    },
    onSearchFocus: function onSearchFocus() {
      var id = '#search-input';
      this.focusElement(id);
    },
    onDelete: function onDelete() {
      var _this3 = this;

      this.DELETE_CONTACT().then(function () {
        return _this3.RESET_ACTIVE_CONTACT();
      });
    }
  })

});

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datatable_cell_js__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_group_by_js__ = __webpack_require__(724);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    name: "datatable-collection",

    props: {

        rows: {
            type: Array,
            required: true
        },

        columns: {
            type: Array,
            required: true
        },

        groupingColumns: {
            type: Array
        },

        groupingIndex: {
            type: Number,
            default: 0
        },

        striped: {
            type: Boolean,
            default: true
        },

        editable: {
            type: Boolean,
            default: false
        },

        lineNumbers: {
            type: Boolean,
            default: false
        },

        aggregated: {
            type: Boolean,
            default: false
        },

        margin: {
            type: String,
            default: "1.5em"
        },

        collectionIndex: {
            type: Number,
            default: 0
        },

        optimize: {
            type: Boolean,
            default: false
        },

        message: {
            type: String,
            default: "No results",
            required: false
        }

    },

    computed: {
        groupable: function groupable() {
            return this.groupingIndex < this.groupingColumns.length;
        },
        groupingColumn: function groupingColumn() {
            var columnId = this.groupingColumns[this.groupingIndex];
            return this.columns.find(function (column) {
                return column.id === columnId;
            });
        },
        groups: function groups() {
            var columnId = this.groupingColumn.id;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utilities_group_by_js__["a" /* default */])(this.rows, function (row) {
                return row[columnId];
            });
        },
        columnSpan: function columnSpan() {
            return this.columns.length + (this.lineNumbers ? 1 : 0);
        },
        indentStyle: function indentStyle() {
            var margin = this.groupingIndex * 1.5;

            return {
                "margin-left": margin + "rem"
            };
        }
    },

    components: {
        datatableCell: __WEBPACK_IMPORTED_MODULE_0__datatable_cell_js__["a" /* default */]
    }

});

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//


var alignments = ["left", "center", "right", "auto"];

var sortClassMap = {
    "1": "asc",
    "-1": "desc"
};

/* harmony default export */ __webpack_exports__["default"] = ({

    props: {

        id: {
            type: String,
            required: true
        },

        label: {
            type: String
        },

        width: {
            type: [Number, String]
        },

        alignment: {
            type: String,
            default: "left",
            validator: function validator(value) {
                return alignments.indexOf(value) > -1;
            }
        },

        formatter: {
            type: Function
        },

        sortable: {
            type: Boolean,
            default: true
        },

        groupable: {
            type: Boolean,
            default: true
        },

        aggregators: {
            type: Array
        }
    },

    data: function data() {
        return {
            sortingDirection: 1
        };
    },


    computed: {

        sorting: {
            get: function get() {
                return this.$parent.sortingId === this.id && this.sortable;
            },
            set: function set(value) {
                if (value && this.sortable) {
                    this.$parent.sortingId = this.id;
                }
            }
        },

        grouping: {
            get: function get() {
                return this.$parent.groupingColumnIds.indexOf(this.id) > -1;
            }
        },

        columnWidth: function columnWidth() {
            if (!this.width) {
                return;
            }

            var suffix = isNaN(this.width) ? "" : "%";

            return this.width + suffix;
        },
        columnLayout: function columnLayout() {
            var direction = this.alignment !== "right" ? "row" : "row-reverse";

            return direction + " center-justify";
        },
        columnStyles: function columnStyles() {
            var alignment = this.alignment === "left" ? null : this.alignment;

            return {
                width: this.columnWidth,
                textAlign: alignment
            };
        },
        sortArrowClass: function sortArrowClass() {
            var direction = sortClassMap[this.sortingDirection];
            return "datatable-sort-arrow-" + direction;
        },
        template: function template() {
            return this.$parent.$scopedSlots[this.id];
        }
    },

    methods: {
        sort: function sort() {
            if (this.sorting) {
                this.sortingDirection *= -1;
                return;
            }

            this.sorting = true;
        },
        formatData: function formatData(value) {
            if (!this.formatter) {
                return value;
            }

            return this.formatter(value);
        },
        dragStart: function dragStart(event) {
            event.stopPropagation();
            event.dataTransfer.dropEffect = "copy";
            event.dataTransfer.setData("text", this.id);
        }
    },

    created: function created() {
        var addColumn = this.$parent.addColumn;

        if (!addColumn) {
            console.warn("A datatable-column must be registered within a datatable component.");
            return;
        }

        addColumn(this);
    },
    destroyed: function destroyed() {
        this.$parent.removeColumn(this);
    }
});

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datatable_collection_vue__ = __webpack_require__(2037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datatable_collection_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__datatable_collection_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_filter_by_js__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_sort_by_js__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_base_type_validator_js__ = __webpack_require__(253);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({

    props: {

        fixed: {
            type: Boolean,
            default: true
        },

        striped: {
            type: Boolean,
            default: true
        },

        source: {
            type: Array,
            default: function _default() {
                return [];
            }
        },

        editable: {
            type: Boolean,
            default: false
        },

        filterable: {
            type: Boolean,
            default: true
        },

        lineNumbers: {
            type: Boolean,
            default: false
        },

        threshold: {
            type: Number,
            default: 50
        },

        message: {
            type: String,
            default: "-"
        },

        showHeader: {
            type: Boolean,
            default: true
        }

    },

    data: function data() {
        return {
            columns: [],
            filter: null,
            sortingId: null,
            groupingColumnIds: [],
            groupingDropzoneActive: false
        };
    },


    computed: {
        sortingColumn: function sortingColumn() {
            var _this = this;

            return this.columns.find(function (column) {
                return column.id === _this.sortingId;
            });
        },
        groupingColumns: function groupingColumns() {
            var _this2 = this;

            return this.groupingColumnIds.map(function (columnId) {
                return _this2.columns.find(function (column) {
                    return column.id === columnId;
                });
            });
        },
        tableClasses: function tableClasses() {
            return {
                "datatable-editable": this.editable,
                "table-fixed": this.fixed
            };
        },
        groupableColumns: function groupableColumns() {
            return this.columns.filter(function (column) {
                return column.groupable;
            });
        },
        rows: function rows() {
            var _this3 = this;

            var rows = this.source;

            // Filter the rows first to reduce the set (if a filter is supplied) we need to sort
            if (this.filter) {
                rows = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utilities_filter_by_js__["a" /* default */])(rows, this.filter);
            }

            // Sort the filtered set
            if (this.sortingColumn) {
                rows = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utilities_sort_by_js__["a" /* default */])(rows, function (row) {
                    return row[_this3.sortingColumn.id];
                }, this.sortingColumn.sortingDirection);
            }

            return rows;
        },
        columnSpan: function columnSpan() {
            var columnSpan = this.columns.length;

            if (this.lineNumbers) {
                columnSpan++;
            }

            if (this.aggregated) {
                columnSpan++;
            }

            return columnSpan;
        },
        lineColumnWidth: function lineColumnWidth() {
            var count = this.source.length;
            return count.toString().length + 2 + "em";
        },
        aggregators: function aggregators() {
            var aggregators = [];

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this.columns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var column = _step.value;

                    if (!column.aggregators) {
                        continue;
                    }

                    aggregators = aggregators.concat(column.aggregators);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return aggregators.filter(function (item, index, arr) {
                return index === arr.indexOf(item);
            });
        },
        aggregated: function aggregated() {
            return this.aggregators && this.aggregators.length > 0;
        },
        optimize: function optimize() {
            return this.source.length >= this.threshold;
        }
    },

    methods: {
        addColumn: function addColumn(column) {
            this.columns.push(column);
        },
        removeColumn: function removeColumn(column) {
            var index = this.columns.indexOf(column);
            this.columns.splice(index, 1);
        },
        groupColumn: function groupColumn(column) {
            this.groupingColumnIds.push(column.id);
        },
        degroupColumn: function degroupColumn(column) {
            var index = this.groupingColumnIds.indexOf(column.id);
            this.groupingColumnIds.splice(index, 1);
        },
        aggregate: function aggregate(column, aggregator) {
            var noResult = " ";

            if (!column.aggregators || column.aggregators.indexOf(aggregator) === -1) {
                return noResult;
            }

            var result = aggregator.callback.call(column, this.rows, function (row) {
                return row[column.id];
            });

            if (!result || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utilities_base_type_validator_js__["a" /* isCollection */])(result)) {
                return noResult;
            }

            return aggregator.format ? column.formatData(result) : result;
        },
        dragDrop: function dragDrop(event) {
            event.preventDefault();

            var columnId = event.dataTransfer.getData("text");

            var column = this.groupableColumns.find(function (item) {
                return item.id === columnId;
            });

            if (column && !column.grouping) {
                this.groupColumn(column);
            }
        },
        dragOver: function dragOver(event) {
            event.preventDefault();
        },
        dragEnter: function dragEnter(event) {
            event.preventDefault();
            this.groupingDropzoneActive = true;
        },
        dragLeave: function dragLeave(event) {
            event.preventDefault();
            this.groupingDropzoneActive = false;
        }
    },

    components: {
        datatableCollection: __WEBPACK_IMPORTED_MODULE_0__datatable_collection_vue___default.a
    }

});

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'dropdown',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["a" /* localStorageMixin */]],

  props: ['data'],

  data: function data() {
    return {
      isActive: false
    };
  },

  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['user', 'activeNote', 'theme'])),

  methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['RESET_APP', 'LOG_OUT_USER']), {
    hideDropdown: function hideDropdown() {
      this.isActive = false;
    },
    onFeedback: function onFeedback() {
      var url = 'https://meagher.typeform.com/to/EXwPlY';
      this.hideDropdown();
      window.open(url);
    },
    onLogOut: function onLogOut() {
      var _this = this;

      this.hideDropdown();
      this.RESET_APP();

      this.LOG_OUT_USER().then(function () {
        _this.ls_logOut();
        _this.$router.push({ name: 'login' });
      });
    },
    onSignUp: function onSignUp() {
      this.$router.push({ name: 'signup' });
    },
    onLogIn: function onLogIn() {
      this.$router.push({ name: 'login' });
    }
  })

});

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'editor-highlight',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["c" /* utilsMixin */]],

  props: ['body'],

  updated: function updated() {
    var textarea = this.selectElement('#editor-textarea');
    if (textarea) textarea.onscroll = this.onScroll;
  },


  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['query']), {
    content: function content() {
      var body = this.body;
      if (this.query.length > 0) {
        var regexString = this.query.replace(/\s/g, '|');
        var re = new RegExp(regexString, 'gi');
        body = this.body.replace(/\n$/g, '\n\n').replace(re, '<mark>$&</mark>');
      }
      return body;
    }
  }),

  methods: {
    onScroll: function onScroll() {
      var textarea = this.selectElement('#editor-textarea');
      var highlights = this.selectElement('#highlights');
      highlights.scrollTop = textarea.scrollTop;
    }
  }

});

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_keyboardjs__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_keyboardjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_keyboardjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EditorHighlight_vue__ = __webpack_require__(2038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EditorHighlight_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__EditorHighlight_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'editor',

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["c" /* utilsMixin */]],

  props: ['isPreview'],

  components: {
    EditorHighlight: __WEBPACK_IMPORTED_MODULE_3__EditorHighlight_vue___default.a
  },

  created: function created() {
    if (!this.isPreview) {
      this.setUpHotKeys();
    }
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1_keyboardjs___default.a.reset();
  },


  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['activeNote', 'query', 'editingId'])),

  methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['UPDATE_NOTE']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["d" /* mapMutations */])(['SET_RESULT_INDEX', 'SET_EDITING_ID']), {
    setUpHotKeys: function setUpHotKeys() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_keyboardjs___default.a.bind('tab', function (e) {
        e.preventDefault();
        if (_this.activeNote) {
          _this.onEditorFocus();
        }
      });
    },
    onEditorFocus: function onEditorFocus() {
      var id = '#editor-textarea';
      this.focusElement(id);
    },
    onInput: function onInput() {
      this.UPDATE_NOTE(this.activeNote);

      if (this.activeNote.id != this.editingId) this.SET_RESULT_INDEX(0);
    },
    onFocus: function onFocus() {
      if (this.activeNote.id != this.editingId) this.SET_EDITING_ID(this.activeNote.id);
    },
    onBlur: function onBlur() {
      this.SET_EDITING_ID(null);
    }
  })

});

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'field',

    props: ['name', 'value', 'type', 'placeholder', 'autofocus'],

    data: function data() {
        return {
            isActive: false
        };
    },

    methods: {
        onClick: function onClick() {
            var input = this.$el.children[1];
            input.focus();
        },
        onInput: function onInput(value) {
            this.$emit('input', value);
        }
    }

});

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dropdown_vue__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dropdown_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Dropdown_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'foot-actions',

  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['activeNote', 'theme', 'user'])),

  components: {
    Dropdown: __WEBPACK_IMPORTED_MODULE_1__Dropdown_vue___default.a
  },

  data: function data() {
    return {
      lastIndex: 0,
      quotes: ['Stay present.', 'Praise specifically, criticize generally.', 'Good artists borrow, great artists steal.', 'Simplicity is the ultimate sophistication.', 'This is your moment of glory.', 'Even elephants do slip.', 'Be yourself; everyone else is already taken.', 'True will is wishing backed by power.', 'I never learned anything while I was talking.', 'Do things that have never been done.', 'The details are not the details. They make the design.', 'Love all, trust a few, do wrong to none.', 'Everything you can imagine is real.']
    };
  },

  methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['UPDATE_THEME']), {
    onShareNote: function onShareNote() {
      this.$emit('onShareNote');
    },
    onUpdateTheme: function onUpdateTheme() {
      var theme = this.theme === 'dark' ? 'light' : 'dark';
      this.UPDATE_THEME(theme);
    },
    randomQuote: function randomQuote() {
      var index = _.random(0, this.quotes.length - 1);
      return this.quotes[index];
    }
  })

});

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clipboard__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'foot-share-note',

  data: function data() {
    return {
      copyButtonText: 'Copy'
    };
  },

  mounted: function mounted() {
    var _this = this;

    var id = '#clipboardjs';
    var button = this.selectElement(id);
    var clipboard = new __WEBPACK_IMPORTED_MODULE_1_clipboard___default.a(button);
    clipboard.on('success', function (e) {
      _this.copyButtonText = 'Copied!';
    });
    clipboard.on('error', function (e) {
      _this.copyButtonText = 'Error';
    });
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["c" /* utilsMixin */]],

  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['activeKey', 'activeNote']), {
    noteUrl: function noteUrl() {
      return 'https://notational.co/n/' + this.activeKey;
    }
  }),

  methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['TOGGLE_IS_PUBLIC']), {
    selectUrl: function selectUrl() {
      var id = "#share-note-url";
      var input = this.selectElement(id);
      input.select();
    },
    onCopyLink: function onCopyLink() {
      var _this2 = this;

      setTimeout(function () {
        _this2.copyButtonText = 'Copy';
      }, 800);
    },
    onTogglePermission: function onTogglePermission() {
      this.TOGGLE_IS_PUBLIC(this.activeNote);
    },
    onDone: function onDone() {
      this.$emit('onDone');
    }
  })

});

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FootActions_vue__ = __webpack_require__(2039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FootActions_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__FootActions_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FootShareNote_vue__ = __webpack_require__(2040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FootShareNote_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__FootShareNote_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'foot',

  data: function data() {
    return {
      showShareNote: false
    };
  },

  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['activeNote'])),

  components: {
    FootActions: __WEBPACK_IMPORTED_MODULE_1__FootActions_vue___default.a,
    FootShareNote: __WEBPACK_IMPORTED_MODULE_2__FootShareNote_vue___default.a
  },

  watch: {
    activeNote: function activeNote() {
      this.showShareNote = false;
    }
  },

  methods: {
    onShareNote: function onShareNote() {
      this.showShareNote = !this.showShareNote;
    }
  }

});

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'footer-bar',

    head: {
        title: {
            inner: 'Barnatasa'
        }
    }

});

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'search',

    props: {
        disabled: { type: Boolean, default: false },
        icon: { type: String, default: "plus-circle" },
        text: { type: String, default: "action" },
        icon_color: { type: String, default: "black" },
        text_color: { type: String, default: "black" },
        border_color: { type: String, default: "black" },
        background_color: { type: String, default: "white" },
        min_width: { type: String, default: "250px" },
        max_width: { type: String, default: "250px" }

    }

});

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'logo-bar',

    head: {
        title: {
            inner: 'Barnatasa'
        }
    }

});

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'message',

    props: {
        icon_name: { type: String, default: "plus-circle" },
        text: { type: String, default: "message" },
        icon_color: { type: String, default: "black" },
        text_color: { type: String, default: "black" },
        border_color: { type: String, default: "black" },
        background_color: { type: String, default: "white" }

    },

    methods: {
        closeMessage: function closeMessage() {
            this.$emit('closeMessage');
        }
    }
});

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'nav-bar',

    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["a" /* localStorageMixin */]],

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['user'])),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['UPDATE_LANGUAGE', 'SIGN_UP_USER', 'INIT_NOTES']), {
        onLogIn: function onLogIn() {
            this.$router.push({ name: 'login' });
        },
        setLanguage: function setLanguage(data) {
            var _this = this;

            this.UPDATE_LANGUAGE(data).then(function () {
                console.log(data);
            }).catch(function (error) {
                _this.error = error.message;
            });
        }
    }),

    head: {
        title: {
            inner: 'Barnatasa'
        }
    }

});

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_filter_by_js__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_page_js__ = __webpack_require__(728);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({

    props: {

        source: {
            type: Array,
            default: function _default() {
                return [];
            }
        },

        pageSize: {
            type: Number,
            default: 25
        },

        filter: {
            type: String
        }

    },

    data: function data() {
        return {
            index: 0
        };
    },


    computed: {
        pages: function pages() {
            var data = this.source;

            if (this.filter) {
                data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_filter_by_js__["a" /* default */])(data, this.filter);
            }

            var pages = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utilities_page_js__["a" /* default */])(data, this.pageSize);

            // need to reset the page number if the data length changes
            // otherwise the index will be outside the bounds of the data
            if (this.pageNumber > pages.length) {
                this.pageNumber = 1;
            }

            return pages;
        },


        pageNumber: {
            get: function get() {
                return this.index + 1;
            },
            set: function set(value) {
                this.index = value - 1;
                this.$emit("page-changed", value);
            }
        },

        data: function data() {
            return this.pages[this.index];
        }
    },

    methods: {
        movePrevious: function movePrevious() {
            this.pageNumber -= this.pageNumber > 1 ? 1 : 0;
        },
        moveNext: function moveNext() {
            this.pageNumber += this.pageNumber != this.pages.length ? 1 : 0;
        },
        moveTo: function moveTo(pageNumber) {
            if (pageNumber > 0 && pageNumber <= this.pages.length) {
                this.pageNumber = pageNumber;
            }
        }
    }

});

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Search_Index_vue__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Search_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Search_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Foot_Index_vue__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Foot_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Foot_Index_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'preview',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["a" /* localStorageMixin */]],

  data: function data() {
    return {
      loading: true
    };
  },

  created: function created() {
    var _this = this;

    this.FETCH_PREVIEW_DATA().then(function () {
      _this.loading = false;
    });
  },


  components: {
    Editor: __WEBPACK_IMPORTED_MODULE_4__Editor_Index_vue___default.a,
    Foot: __WEBPACK_IMPORTED_MODULE_5__Foot_Index_vue___default.a,
    Search: __WEBPACK_IMPORTED_MODULE_3__Search_Index_vue___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_2__Spinner_vue___default.a
  },

  methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['FETCH_PREVIEW_DATA']))

});

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_keyboardjs__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_keyboardjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_keyboardjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SearchInfo_vue__ = __webpack_require__(2041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SearchInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SearchInfo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SearchResult_vue__ = __webpack_require__(2042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SearchResult_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SearchResult_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'search',

    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["b" /* noteMixin */], __WEBPACK_IMPORTED_MODULE_2__mixins__["c" /* utilsMixin */]],

    props: {
        preview: { type: Boolean, default: false }
    },

    data: function data() {
        return {
            query: '',
            isSearchFocused: true
        };
    },

    created: function created() {
        this.setUpHotKeys();
    },
    beforeDestroy: function beforeDestroy() {
        __WEBPACK_IMPORTED_MODULE_1_keyboardjs___default.a.reset();
    },


    components: {
        SearchInfo: __WEBPACK_IMPORTED_MODULE_3__SearchInfo_vue___default.a,
        SearchResult: __WEBPACK_IMPORTED_MODULE_4__SearchResult_vue___default.a
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['activeNote', 'contacts', 'notes', 'user', 'resultIndex', 'renamingId', 'editingId']), {
        filteredContacts: function filteredContacts() {
            var contacts = void 0;
            if (this.query.length === 0) {
                contacts = this.contacts;
                return this.sortContacts(contacts);
            }

            contacts = this.filterContactsForQuery(this.query, this.contacts);
            contacts = this.sortContacts(contacts, true);

            return contacts;
        },
        filteredNotes: function filteredNotes() {
            var notes = void 0;
            if (this.query.length == 0) {
                notes = this.notes;
                return this.sortNotes(notes);
            }

            notes = this.filterNotesForQuery(this.query, this.notes);
            notes = this.sortNotes(notes, true);

            return notes;
        }
    }),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['CREATE_NOTE', 'RESET_ACTIVE_NOTE']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["d" /* mapMutations */])(['SET_ACTIVE_NOTE', 'SET_ACTIVE_KEY', 'SET_QUERY', 'SET_RESULT_INDEX']), {
        setUpHotKeys: function setUpHotKeys() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_1_keyboardjs___default.a.bind('ctrl + enter', function () {
                return _this.onCreate();
            });
            __WEBPACK_IMPORTED_MODULE_1_keyboardjs___default.a.bind('esc', function () {
                return _this.onEscape();
            });
            __WEBPACK_IMPORTED_MODULE_1_keyboardjs___default.a.bind('up', function (e) {
                if (!_this.editingId && !_this.renamingId) {
                    e.preventDefault();
                    _this.onUp();
                }
            });
            __WEBPACK_IMPORTED_MODULE_1_keyboardjs___default.a.bind('down', function (e) {
                if (!_this.editingId && !_this.renamingId) {
                    e.preventDefault();
                    _this.onDown();
                }
            });
        },
        onCreate: function onCreate() {
            var id = this.nextIdForNotes(this.notes);
            var name = this.query.length > 0 ? this.query : 'Untitled Note';
            var note = this.createNote(id, name);

            this.CREATE_NOTE(note);
        },
        onSearch: function onSearch() {
            if (this.activeNote) {
                var id = '#editor-textarea';
                this.focusElement(id);
            }
        },
        onEscape: function onEscape() {
            if (!this.editingId && !this.renamingId) {
                this.query = '';
                this.SET_QUERY('');
                this.RESET_ACTIVE_NOTE();
            }
            this.$refs.input.focus();
        },
        onUp: function onUp() {
            if (this.resultIndex > 0) {
                var index = this.resultIndex - 1;
                this.SET_RESULT_INDEX(index);

                var note = this.filteredNotes[index];
                this.SET_ACTIVE_NOTE(note);

                var key = this.findKeyForNoteId(note.id, this.notes);
                this.SET_ACTIVE_KEY(key);

                this.scrollToNoteId(note.id, false);
            }
        },
        onDown: function onDown() {
            if (this.resultIndex != this.filteredNotes.length - 1) {
                var index = this.resultIndex + 1;
                this.SET_RESULT_INDEX(index);

                var note = this.filteredNotes[index];
                this.SET_ACTIVE_NOTE(note);

                var key = this.findKeyForNoteId(note.id, this.notes);
                this.SET_ACTIVE_KEY(key);

                this.scrollToNoteId(note.id, true);
            }
        },
        scrollToNoteId: function scrollToNoteId(noteId, alignToTop) {
            var container = this.selectElement('.search__results');
            var containerViewTop = container.scrollTop;
            var containerViewBottom = containerViewTop + container.offsetHeight;

            var element = this.selectElement('#result_' + noteId);
            var elementTop = element.offsetTop - 104;
            var elementBottom = elementTop + element.offsetHeight;

            var isVisible = elementBottom <= containerViewBottom && elementTop >= containerViewTop;
            if (!isVisible) {
                element.scrollIntoView(alignToTop);
            }
        },
        onSelect: function onSelect(note) {
            if (this.resultIndex == -1 || note.id != this.activeNote.id) {
                var index = this.filteredNotes.indexOf(note);
                this.SET_RESULT_INDEX(index);
                this.SET_ACTIVE_NOTE(note);

                var key = this.findKeyForNoteId(note.id, this.notes);
                this.SET_ACTIVE_KEY(key);
            }
        },
        onRenameBlur: function onRenameBlur() {
            this.$refs.input.focus();
        },
        updateQuery: function updateQuery() {
            var hasSearchResults = this.filteredNotes.length > 0;
            var note = hasSearchResults ? this.filteredNotes[0] : null;
            var key = hasSearchResults ? this.findKeyForNoteId(note.id, this.notes) : null;
            var resultIndex = hasSearchResults ? 0 : -1;

            this.SET_ACTIVE_NOTE(note);
            this.SET_ACTIVE_KEY(key);
            this.SET_RESULT_INDEX(resultIndex);
            this.SET_QUERY(this.query);
        }
    })
});

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
        name: 'search-info',

        props: ['resultsCount', 'queryLength', 'selected', 'searching', 'renaming', 'editing']
});

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_keyboardjs__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_keyboardjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_keyboardjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(8);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'search-result',

  props: ['note', 'isActive', 'renaming'],

  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["c" /* utilsMixin */]],

  data: function data() {
    return {
      oldName: null,
      isRenamed: false,
      showDelete: false
    };
  },

  created: function created() {
    this.setUpHotKeys();
  },


  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['query', 'activeNote']), {
    name: function name() {
      if (this.query.length > 0) {
        var regexString = this.query.replace(/\s/g, '|');
        var re = new RegExp(regexString, 'gi');
        return this.note.name.replace(/\n$/g, '\n\n').replace(re, '<mark>$&</mark>');
      }
      return this.note.name;
    }
  }),

  methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['UPDATE_NOTE', 'DELETE_NOTE', 'RESET_ACTIVE_NOTE']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["d" /* mapMutations */])(['SET_RESULT_INDEX', 'SET_RENAMING_ID']), {
    setUpHotKeys: function setUpHotKeys() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_keyboardjs___default.a.bind('alt + ctrl + r', function () {
        if (_this.activeNote) {
          _this.onRenameFocus();
        }
      });
      __WEBPACK_IMPORTED_MODULE_1_keyboardjs___default.a.bind('alt + ctrl + d', function () {
        if (_this.activeNote) _this.onDelete();
      });
    },
    onResultSelect: function onResultSelect() {
      this.$emit('onResultSelect', this.note);
    },
    onRenameFocus: function onRenameFocus() {
      var _this2 = this;

      this.oldName = this.note.name;
      this.SET_RENAMING_ID(this.activeNote.id);
      this.$nextTick(function () {
        var id = '#search-result-editor-' + _this2.activeNote.id;
        _this2.focusElement(id);
      });
    },
    onRenameBlur: function onRenameBlur() {
      if (this.oldName != null && this.name !== this.oldName && !this.isRenamed) {
        this.note.name = this.oldName;
      }
      this.isRenamed = false;

      this.SET_RENAMING_ID(null);
      this.$emit('onRenameBlur');
    },
    onRenameSave: function onRenameSave() {
      this.UPDATE_NOTE();
      this.oldName = null;
      this.isRenamed = true;
      this.SET_RESULT_INDEX(0);
      this.onRenameBlur();
    },
    onSearchFocus: function onSearchFocus() {
      var id = '#search-input';
      this.focusElement(id);
    },
    onDelete: function onDelete() {
      var _this3 = this;

      this.DELETE_NOTE().then(function () {
        return _this3.RESET_ACTIVE_NOTE();
      });
    }
  })

});

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'side-nav-bar',

    data: function data() {
        return {
            showShareNote: false
        };
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['currentLocale'])),
    props: {
        fileOpen: { type: Boolean, default: false },
        filesOpen: { type: Boolean, default: false },
        fileId: { type: String, default: '' },
        fileNumber: { type: Number, default: 0 },
        filePath: { type: String, default: 'appraisalfiles/' },
        realEstateId: { type: String, default: '' },
        realEstates: { type: Object, default: function _default() {
                return {};
            } },
        reportId: { type: String, default: '' },
        reportNumber: { type: Number, default: 0 },
        reportOpen: { type: Boolean, default: false },
        versionNumber: { type: Number, default: 0 },
        full_number: { type: String, default: '' }
    },

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['SET_APPRAISALREPORT', 'SET_REALESTATE']), {
        goTo: function goTo(location) {
            this.$router.push({ name: location });
        },
        goToFile: function goToFile() {
            this.$router.push({ name: 'appraisalfile-editor', query: { id: this.fileId } });
        },
        goToReport: function goToReport(id) {
            var _this = this;

            this.SET_APPRAISALREPORT({ path: 'appraisalreports' + '/' + id + '/' }).then(function (res) {
                _this.$router.push({ name: 'appraisalreport-editor', query: { id: id } });
            });
        },
        goToRealEstate: function goToRealEstate(id) {
            var _this2 = this;

            this.SET_REALESTATE({ path: 'realestates' + '/' + id + '/' }).then(function (res) {
                _this2.$router.push({ name: 'realestate-editor', query: { id: id } });
            });
        }
    })

});

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'spinner'
});

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'message',

    props: ['text'],

    methods: {
        closeMessage: function closeMessage() {
            this.$emit('closeMessage');
        }
    }
});

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_checkable_js__ = __webpack_require__(604);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({

    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_checkable_js__["a" /* default */]],

    methods: {
        update: function update(event) {
            this.$emit('toggle_flag');
        }

    }

});

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FooterBar_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FooterBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_FooterBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_LogoBar_vue__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_LogoBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_LogoBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_NavBar_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_NavBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_NavBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_swiper__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_awesome_swiper__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'about',

    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["a" /* localStorageMixin */]],

    components: {
        Message: __WEBPACK_IMPORTED_MODULE_3__components_Message_vue___default.a,
        FooterBar: __WEBPACK_IMPORTED_MODULE_4__components_FooterBar_vue___default.a,
        LogoBar: __WEBPACK_IMPORTED_MODULE_5__components_LogoBar_vue___default.a,
        NavBar: __WEBPACK_IMPORTED_MODULE_6__components_NavBar_vue___default.a,
        swiper: __WEBPACK_IMPORTED_MODULE_7_vue_awesome_swiper__["swiper"],
        swiperSlide: __WEBPACK_IMPORTED_MODULE_7_vue_awesome_swiper__["swiperSlide"]
    },

    data: function data() {
        return {

            error: null,
            swiperOption: {
                spaceBetween: 30,
                centeredSlides: true,
                autoplay: 4000,
                autoplayDisableOnInteraction: false,
                effect: 'fade',
                speed: 2000
            }
        };
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['user', 'theme'])),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['LOG_IN_USER']), {
        closeMessage: function closeMessage() {
            this.error = null;
        }
    }),

    head: {
        title: {
            inner: 'Services'
        }
    }

});

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FooterBar_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FooterBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_FooterBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_NavBar_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_NavBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_NavBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_LogoBar_vue__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_LogoBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_LogoBar_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/*
   import * as VueGoogleMaps from 'vue2-google-maps'
    Vue.use(VueGoogleMaps, {
       load: {
           key: 'AIzaSyB__K_9Sk2AOlY8rJKWPy7XYuWRASaWxDU',
           v: '3.28',
           libraries: 'places'
       }
   })
   */

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'contact',

    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["a" /* localStorageMixin */]],

    components: {
        Message: __WEBPACK_IMPORTED_MODULE_3__components_Message_vue___default.a,
        FooterBar: __WEBPACK_IMPORTED_MODULE_4__components_FooterBar_vue___default.a,
        LogoBar: __WEBPACK_IMPORTED_MODULE_6__components_LogoBar_vue___default.a,
        NavBar: __WEBPACK_IMPORTED_MODULE_5__components_NavBar_vue___default.a
    },

    data: function data() {
        return {

            error: null,
            center: { lat: 41.3891238, lng: 2.1497487 },
            markers: [{
                position: { lat: 41.3891238, lng: 2.1497487 }
            }],
            mapStyles: [{
                elementType: 'labels',
                stylers: [{
                    visibility: 'off'
                }]
            }, { elementType: 'geometry', stylers: [{ color: '#242f3e' }] }, { elementType: 'labels.text.stroke', stylers: [{ color: '#242f3e' }] }, { elementType: 'labels.text.fill', stylers: [{ color: '#746855' }] }, {
                featureType: 'administrative.locality',
                elementType: 'labels.text.fill',
                stylers: [{ color: '#d59563' }]
            }, {
                featureType: 'poi',
                elementType: 'labels.text.fill',
                stylers: [{ color: '#d59563' }]
            }, {
                featureType: 'poi.park',
                elementType: 'geometry',
                stylers: [{ color: '#263c3f' }]
            }, {
                featureType: 'poi.park',
                elementType: 'labels.text.fill',
                stylers: [{ color: '#6b9a76' }]
            }, {
                featureType: 'road',
                elementType: 'geometry',
                stylers: [{ color: '#38414e' }]
            }, {
                featureType: 'road',
                elementType: 'geometry.stroke',
                stylers: [{ color: '#212a37' }]
            }, {
                featureType: 'road',
                elementType: 'labels.text.fill',
                stylers: [{ color: '#9ca5b3' }]
            }, {
                featureType: 'road.highway',
                elementType: 'geometry',
                stylers: [{ color: '#746855' }]
            }, {
                featureType: 'road.highway',
                elementType: 'geometry.stroke',
                stylers: [{ color: '#1f2835' }]
            }, {
                featureType: 'road.highway',
                elementType: 'labels.text.fill',
                stylers: [{ color: '#f3d19c' }]
            }, {
                featureType: 'transit',
                elementType: 'geometry',
                stylers: [{ color: '#2f3948' }]
            }, {
                featureType: 'transit.station',
                elementType: 'labels.text.fill',
                stylers: [{ color: '#d59563' }]
            }, {
                featureType: 'water',
                elementType: 'geometry',
                stylers: [{ color: '#17263c' }]
            }, {
                featureType: 'water',
                elementType: 'labels.text.fill',
                stylers: [{ color: '#515c6d' }]
            }, {
                featureType: 'water',
                elementType: 'labels.text.stroke',
                stylers: [{ color: '#17263c' }]
            }]
        };
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['user', 'theme'])),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['LOG_IN_USER']), {
        closeMessage: function closeMessage() {
            this.error = null;
        }
    }),

    head: {
        title: {
            inner: 'Services'
        }
    }

});

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FooterBar_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FooterBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_FooterBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_NavBar_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_NavBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_NavBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_swiper__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_LogoBar_vue__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_LogoBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_LogoBar_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'customer-service',

    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["a" /* localStorageMixin */]],

    components: {
        Message: __WEBPACK_IMPORTED_MODULE_3__components_Message_vue___default.a,
        FooterBar: __WEBPACK_IMPORTED_MODULE_4__components_FooterBar_vue___default.a,
        LogoBar: __WEBPACK_IMPORTED_MODULE_7__components_LogoBar_vue___default.a,
        NavBar: __WEBPACK_IMPORTED_MODULE_5__components_NavBar_vue___default.a,
        swiper: __WEBPACK_IMPORTED_MODULE_6_vue_awesome_swiper__["swiper"],
        swiperSlide: __WEBPACK_IMPORTED_MODULE_6_vue_awesome_swiper__["swiperSlide"]
    },

    data: function data() {
        return {
            error: null,
            swiperOption: {
                spaceBetween: 30,
                centeredSlides: true,
                autoplay: 4000,
                autoplayDisableOnInteraction: false,
                effect: 'fade',
                speed: 2000
            }
        };
    },
    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['user', 'theme'])),
    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['LOG_IN_USER']), {
        closeMessage: function closeMessage() {
            this.error = null;
        }
    }),
    head: {
        title: {
            inner: 'Services'
        }
    }
});

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FooterBar_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FooterBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_FooterBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_LogoBar_vue__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_LogoBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_LogoBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_NavBar_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_NavBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_NavBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Field_vue__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Field_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Field_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Preview_vue__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Preview_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Preview_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_awesome_swiper__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_swiper_dist_css_swiper_css__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_swiper_dist_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_swiper_dist_css_swiper_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'home',

    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["a" /* localStorageMixin */]],

    components: {
        FooterBar: __WEBPACK_IMPORTED_MODULE_3__components_FooterBar_vue___default.a,
        LogoBar: __WEBPACK_IMPORTED_MODULE_4__components_LogoBar_vue___default.a,
        Field: __WEBPACK_IMPORTED_MODULE_6__components_Field_vue___default.a,
        Message: __WEBPACK_IMPORTED_MODULE_7__components_Message_vue___default.a,
        NavBar: __WEBPACK_IMPORTED_MODULE_5__components_NavBar_vue___default.a,
        Preview: __WEBPACK_IMPORTED_MODULE_8__components_Preview_vue___default.a,
        swiper: __WEBPACK_IMPORTED_MODULE_9_vue_awesome_swiper__["swiper"],
        swiperSlide: __WEBPACK_IMPORTED_MODULE_9_vue_awesome_swiper__["swiperSlide"]

    },

    data: function data() {
        return {
            logoUrl: '../assets/img/bonelldoriga_wh_nm_3.png',
            logoNormalUrl: '../assets/img/bonelldoriga_wh_nm_3.png',
            logoHighlightUrl: '../assets/img/bonelldoriga_wh_hg_3.png',
            fontSize: '',
            fields: {
                email: {
                    name: 'Email Address',
                    value: '',
                    type: 'text',
                    placeholder: 'monica@raviga.com',
                    autofocus: false
                },
                password: {
                    name: 'Password',
                    value: '',
                    type: 'password',
                    placeholder: 'Super, secret',
                    autofocus: false
                }
            },
            error: null,
            swiperOption: {
                centeredSlides: true,
                slidesPerView: 1
            }
        };
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['user', 'theme'])),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['SIGN_UP_USER', 'INIT_NOTES']), {
        onCreateAccount: function onCreateAccount() {
            var _this = this;

            if (this.fields.email.value.length == 0) {
                this.error = 'Please enter an email realestate.';
                return;
            }

            if (this.fields.password.value.length == 0) {
                this.error = 'Please enter a password.';
                return;
            }

            var data = {
                email: this.fields.email.value,
                password: this.fields.password.value
            };

            this.SIGN_UP_USER(data).then(function () {
                _this.ls_pushUser(_this.user);
                console.log();
                _this.INIT_NOTES().then(function () {
                    return _this.$router.push({ name: 'app' });
                }).catch(function (error) {
                    return _this.error = error.message;
                });
            }).catch(function (error) {
                _this.error = error.message;
            });
        },
        onQuoteRequest: function onQuoteRequest() {
            this.$router.push({ name: 'quote-request', query: { email: this.fields.email.value } });
        },
        onSignUp: function onSignUp() {
            this.$router.push({ name: 'signup', query: { email: this.fields.email.value } });
        },
        onLogIn: function onLogIn() {
            this.$router.push({ name: 'login' });
        },
        goTo: function goTo(location) {
            this.$router.push({ name: location });
        },
        closeMessage: function closeMessage() {
            this.error = null;
        }
    }),

    head: {
        title: {
            inner: 'Home'
        }
    }

});

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FooterBar_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FooterBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_FooterBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_LogoBar_vue__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_LogoBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_LogoBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_NavBar_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_NavBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_NavBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Field_vue__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Field_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Field_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Preview_vue__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Preview_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Preview_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_awesome_swiper__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_swiper_dist_css_swiper_css__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_swiper_dist_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_swiper_dist_css_swiper_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'main',

    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["a" /* localStorageMixin */]],

    components: {

        FooterBar: __WEBPACK_IMPORTED_MODULE_3__components_FooterBar_vue___default.a,
        LogoBar: __WEBPACK_IMPORTED_MODULE_4__components_LogoBar_vue___default.a,
        Field: __WEBPACK_IMPORTED_MODULE_6__components_Field_vue___default.a,
        Message: __WEBPACK_IMPORTED_MODULE_7__components_Message_vue___default.a,
        NavBar: __WEBPACK_IMPORTED_MODULE_5__components_NavBar_vue___default.a,
        Preview: __WEBPACK_IMPORTED_MODULE_8__components_Preview_vue___default.a,
        swiper: __WEBPACK_IMPORTED_MODULE_9_vue_awesome_swiper__["swiper"],
        swiperSlide: __WEBPACK_IMPORTED_MODULE_9_vue_awesome_swiper__["swiperSlide"]

    },

    data: function data() {
        return {
            logoUrl: '../assets/img/bonelldoriga_wh_nm_3.png',
            logoNormalUrl: '../assets/img/bonelldoriga_wh_nm_3.png',
            logoHighlightUrl: '../assets/img/bonelldoriga_wh_hg_3.png',
            fontSize: '',
            fields: {
                email: {
                    name: 'Email Address',
                    value: '',
                    type: 'text',
                    placeholder: 'monica@raviga.com',
                    autofocus: false
                },
                password: {
                    name: 'Password',
                    value: '',
                    type: 'password',
                    placeholder: 'Super, secret',
                    autofocus: false
                }
            },
            error: null,
            swiperOption: {
                centeredSlides: true,
                pagination: '.swiper-pagination',
                nextButton: '.swiper-button-next',
                prevButton: '.swiper-button-prev',
                slidesPerView: 1,
                // effect: 'fade',
                paginationClickable: true,
                spaceBetween: 0,
                loop: true
            }
        };
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['user', 'theme'])),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['SIGN_UP_USER', 'INIT_NOTES']), {
        onCreateAccount: function onCreateAccount() {
            var _this = this;

            if (this.fields.email.value.length == 0) {
                this.error = 'Please enter an email realestate.';
                return;
            }

            if (this.fields.password.value.length == 0) {
                this.error = 'Please enter a password.';
                return;
            }

            var data = {
                email: this.fields.email.value,
                password: this.fields.password.value
            };

            this.SIGN_UP_USER(data).then(function () {
                _this.ls_pushUser(_this.user);
                console.log();
                _this.INIT_NOTES().then(function () {
                    return _this.$router.push({ name: 'app' });
                }).catch(function (error) {
                    return _this.error = error.message;
                });
            }).catch(function (error) {
                _this.error = error.message;
            });
        },
        onQuoteRequest: function onQuoteRequest() {
            this.$router.push({ name: 'quote-request', query: { email: this.fields.email.value } });
        },
        onSignUp: function onSignUp() {
            this.$router.push({ name: 'signup', query: { email: this.fields.email.value } });
        },
        onLogIn: function onLogIn() {
            this.$router.push({ name: 'login' });
        },
        closeMessage: function closeMessage() {
            this.error = null;
        }
    }),

    head: {
        title: {
            inner: 'Projects'
        }
    }

});

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'notfound',

  head: {
    title: {
      inner: 'Merp! Not Found'
    }
  }
});

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FooterBar_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FooterBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_FooterBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_NavBar_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_NavBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_NavBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_swiper__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_LogoBar_vue__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_LogoBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_LogoBar_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'our-clients',

    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["a" /* localStorageMixin */]],

    components: {
        Message: __WEBPACK_IMPORTED_MODULE_3__components_Message_vue___default.a,
        FooterBar: __WEBPACK_IMPORTED_MODULE_4__components_FooterBar_vue___default.a,
        LogoBar: __WEBPACK_IMPORTED_MODULE_7__components_LogoBar_vue___default.a,
        NavBar: __WEBPACK_IMPORTED_MODULE_5__components_NavBar_vue___default.a,
        swiper: __WEBPACK_IMPORTED_MODULE_6_vue_awesome_swiper__["swiper"],
        swiperSlide: __WEBPACK_IMPORTED_MODULE_6_vue_awesome_swiper__["swiperSlide"]
    },

    data: function data() {
        return {

            error: null,
            swiperOption: {
                spaceBetween: 30,
                centeredSlides: true,
                autoplay: 4000,
                autoplayDisableOnInteraction: false,
                effect: 'fade',
                speed: 2000
            }
        };
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['user', 'theme'])),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['LOG_IN_USER']), {
        closeMessage: function closeMessage() {
            this.error = null;
        }
    }),

    head: {
        title: {
            inner: 'Services'
        }
    }

});

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FooterBar_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FooterBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_FooterBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_LogoBar_vue__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_LogoBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_LogoBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_NavBar_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_NavBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_NavBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_swiper__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_awesome_swiper__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'philosophy',

    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["a" /* localStorageMixin */]],

    components: {
        Message: __WEBPACK_IMPORTED_MODULE_3__components_Message_vue___default.a,
        FooterBar: __WEBPACK_IMPORTED_MODULE_4__components_FooterBar_vue___default.a,
        LogoBar: __WEBPACK_IMPORTED_MODULE_5__components_LogoBar_vue___default.a,
        NavBar: __WEBPACK_IMPORTED_MODULE_6__components_NavBar_vue___default.a,
        swiper: __WEBPACK_IMPORTED_MODULE_7_vue_awesome_swiper__["swiper"],
        swiperSlide: __WEBPACK_IMPORTED_MODULE_7_vue_awesome_swiper__["swiperSlide"]
    },

    data: function data() {
        return {

            error: null,
            swiperOption: {
                spaceBetween: 30,
                centeredSlides: true,
                autoplay: 4000,
                autoplayDisableOnInteraction: false,
                effect: 'fade',
                speed: 2000
            }
        };
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['user', 'theme'])),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['LOG_IN_USER']), {
        closeMessage: function closeMessage() {
            this.error = null;
        }
    }),

    head: {
        title: {
            inner: 'Services'
        }
    }

});

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FooterBar_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FooterBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_FooterBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_LogoBar_vue__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_LogoBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_LogoBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_NavBar_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_NavBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_NavBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_swiper__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_awesome_swiper__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'pricing',

    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["a" /* localStorageMixin */]],

    components: {
        Message: __WEBPACK_IMPORTED_MODULE_3__components_Message_vue___default.a,
        FooterBar: __WEBPACK_IMPORTED_MODULE_4__components_FooterBar_vue___default.a,
        LogoBar: __WEBPACK_IMPORTED_MODULE_5__components_LogoBar_vue___default.a,
        NavBar: __WEBPACK_IMPORTED_MODULE_6__components_NavBar_vue___default.a,
        swiper: __WEBPACK_IMPORTED_MODULE_7_vue_awesome_swiper__["swiper"],
        swiperSlide: __WEBPACK_IMPORTED_MODULE_7_vue_awesome_swiper__["swiperSlide"]
    },

    data: function data() {
        return {
            error: null,
            swiperOption: {
                spaceBetween: 30,
                centeredSlides: true,
                autoplay: 4000,
                autoplayDisableOnInteraction: false,
                effect: 'fade',
                speed: 2000
            }
        };
    },

    created: function created() {
        var _this = this;

        this.FETCH_VALUATION_PRICES().then(function () {
            _this.loading = false;
        });
    },


    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['user', 'theme', 'valuation_prices'])),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['LOG_IN_USER', 'FETCH_VALUATION_PRICES']), {
        closeMessage: function closeMessage() {
            this.error = null;
        }
    }),

    head: {
        title: {
            inner: 'Services'
        }
    }

});

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Field_vue__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Field_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Field_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SuccessMessage_vue__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SuccessMessage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_SuccessMessage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_FooterBar_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_FooterBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_FooterBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_NavBar_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_NavBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_NavBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_LogoBar_vue__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_LogoBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_LogoBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_awesome_swiper__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_awesome_swiper__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'quote-request',

    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["a" /* localStorageMixin */]],

    components: {
        Field: __WEBPACK_IMPORTED_MODULE_3__components_Field_vue___default.a,
        Message: __WEBPACK_IMPORTED_MODULE_4__components_Message_vue___default.a,
        SuccessMessage: __WEBPACK_IMPORTED_MODULE_5__components_SuccessMessage_vue___default.a,
        FooterBar: __WEBPACK_IMPORTED_MODULE_6__components_FooterBar_vue___default.a,
        LogoBar: __WEBPACK_IMPORTED_MODULE_8__components_LogoBar_vue___default.a,
        NavBar: __WEBPACK_IMPORTED_MODULE_7__components_NavBar_vue___default.a,
        swiper: __WEBPACK_IMPORTED_MODULE_9_vue_awesome_swiper__["swiper"],
        swiperSlide: __WEBPACK_IMPORTED_MODULE_9_vue_awesome_swiper__["swiperSlide"]
    },

    data: function data() {
        return {
            petitioner_fields: {
                name: {
                    name: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Name') + ' *',
                    value: '',
                    type: 'text',
                    placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Name'),
                    autofocus: true
                },
                surnames: {
                    name: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Surnames') + ' *',
                    value: '',
                    type: 'text',
                    placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Surnames'),
                    autofocus: false
                },
                company: {
                    name: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Company_or_business_name'),
                    value: '',
                    type: 'text',
                    placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Company_or_business_name'),
                    autofocus: false
                },
                email: {
                    name: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Email_Address') + ' *',
                    value: '',
                    type: 'email',
                    placeholder: 'email@email.com',
                    autofocus: false
                },
                telephone: {
                    name: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Telephone_contact') + ' *',
                    value: '',
                    type: 'text',
                    placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Telephone_contact'),
                    autofocus: false
                }
            },
            property_fields: {
                property_type: {
                    name: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type_of_property') + ' *',
                    value: '',
                    type: 'text',
                    placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type_of_property'),
                    autofocus: false
                },
                address: {
                    name: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Address') + ' *',
                    value: '',
                    type: 'text',
                    placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Address'),
                    autofocus: false
                },
                postal_code: {
                    name: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Postal_code') + ' *',
                    value: '',
                    type: 'text',
                    placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Postal_code'),
                    autofocus: false
                },
                municipality: {
                    name: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Municipality') + ' *',
                    value: '',
                    type: 'text',
                    placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Municipality'),
                    autofocus: false
                },
                province: {
                    name: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Province'),
                    value: '',
                    type: 'text',
                    placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Province'),
                    autofocus: false
                },
                property_area: {
                    name: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Approximate_property_area') + ' *',
                    value: '',
                    type: 'text',
                    placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Approximate_property_area'),
                    autofocus: false
                },
                cadastral_reference: {
                    name: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cadastral_reference'),
                    value: '',
                    type: 'text',
                    placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cadastral_reference'),
                    autofocus: false
                },
                appraisal_purpose: {
                    name: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Appraisal_purpose') + ' *',
                    value: '',
                    type: 'text',
                    placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Appraisal_purpose'),
                    autofocus: false
                },
                notes: {
                    name: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Notes'),
                    value: '',
                    type: 'textarea',
                    placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Notes'),
                    autofocus: false
                }
            },
            error: null,
            success_message: null,
            swiperOption: {
                spaceBetween: 30,
                centeredSlides: true,
                autoplay: 4000,
                autoplayDisableOnInteraction: false,
                effect: 'fade',
                speed: 2000
            }
        };
    },

    created: function created() {
        if (this.$route.query.email) {
            this.petitioner_fields.email.value = this.$route.query.email;
        }
    },


    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['user', 'theme'])),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['LOG_IN_USER', 'UPDATE_BUDGET_REQUEST']), {
        onSend: function onSend() {
            var _this = this;

            if (this.petitioner_fields.email.value.length === 0) {
                this.error = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Please_enter_an_email_address') + '.';
                return;
            }

            var email_regex = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

            if (email_regex.test(this.petitioner_fields.email.value) === false) {
                this.error = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Invalid_email_address') + '.';
                return false;
            }

            if (this.petitioner_fields.name.value.length === 0) {
                this.error = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Please_enter_a_name') + '.';
                return;
            }

            if (this.petitioner_fields.surnames.value.length === 0) {
                this.error = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Please_enter_a_surname') + '.';
                return;
            }

            if (this.petitioner_fields.telephone.value.length === 0) {
                this.error = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Please_enter_a_telephone_number') + '.';
                return;
            }

            if (this.property_fields.property_type.value.length === 0) {
                this.error = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Please_enter_the_type_of_property') + '.';
                return;
            }

            if (this.property_fields.address.value.length === 0) {
                this.error = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Please_enter_the_address_of_the_property') + '.';
                return;
            }

            if (this.property_fields.postal_code.value.length === 0) {
                this.error = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Please_enter_the_postal_code') + '.';
                return;
            }

            if (this.property_fields.municipality.value.length === 0) {
                this.error = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Please_enter_the_municipality') + '.';
                return;
            }

            if (this.property_fields.property_area.value.length === 0) {
                this.error = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Please_enter_the_area_of_the_property') + '.';
                return;
            }

            if (this.property_fields.appraisal_purpose.value.length === 0) {
                this.error = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Please_enter_the_purpose_of_the_appraisal') + '.';
                return;
            }

            var data = {
                petitioner_name: this.petitioner_fields.name.value,
                petitioner_surnames: this.petitioner_fields.surnames.value,
                petitioner_company: this.petitioner_fields.company.value,
                petitioner_email: this.petitioner_fields.email.value,
                petitioner_telephone: this.petitioner_fields.telephone.value,
                property_type: this.property_fields.property_type.value,
                property_address: this.property_fields.address.value,
                property_postal_code: this.property_fields.postal_code.value,
                property_municipality: this.property_fields.municipality.value,
                property_province: this.property_fields.province.value,
                property_area: this.property_fields.property_area.value,
                property_cadastral_reference: this.property_fields.cadastral_reference.value,
                property_appraisal_purpose: this.property_fields.appraisal_purpose.value,
                property_notes: this.property_fields.notes.value
            };

            this.UPDATE_BUDGET_REQUEST(data).then(function () {
                console.log('update_budget_request from onSend() at QuoteRequest');
                _this.error = null;
                _this.success_message = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Request_successfully_sent');
            }).catch(function (error) {
                _this.error = error.message;
            });
        },
        onLogIn: function onLogIn() {
            var _this2 = this;

            if (this.petitioner_fields.email.value.length === 0) {
                this.error = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Please_enter_an_email_address') + '.';
                return;
            }

            if (this.petitioner_fields.password.value.length === 0) {
                this.error = 'Please enter a password.';
                return;
            }

            var data = {
                email: this.petitioner_fields.email.value
                // password: this.fields.password.value
            };
            this.LOG_IN_USER(data).then(function () {
                _this2.ls_pushUser(_this2.user);
                _this2.$router.push({ name: 'app' });
            }).catch(function (error) {
                _this2.error = error.message;
            });
        },
        closeMessage: function closeMessage() {
            this.error = null;
        }
    }),

    head: {
        title: {
            inner: 'Request a quote'
        }
    }

});

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'notfound',

  head: {
    title: {
      inner: 'Merp! Not Found'
    }
  }
});

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FooterBar_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FooterBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_FooterBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_NavBar_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_NavBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_NavBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_swiper__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_LogoBar_vue__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_LogoBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_LogoBar_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'services',

    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["a" /* localStorageMixin */]],

    components: {
        Message: __WEBPACK_IMPORTED_MODULE_3__components_Message_vue___default.a,
        FooterBar: __WEBPACK_IMPORTED_MODULE_4__components_FooterBar_vue___default.a,
        LogoBar: __WEBPACK_IMPORTED_MODULE_7__components_LogoBar_vue___default.a,
        NavBar: __WEBPACK_IMPORTED_MODULE_5__components_NavBar_vue___default.a,
        swiper: __WEBPACK_IMPORTED_MODULE_6_vue_awesome_swiper__["swiper"],
        swiperSlide: __WEBPACK_IMPORTED_MODULE_6_vue_awesome_swiper__["swiperSlide"]
    },

    data: function data() {
        return {

            error: null,
            swiperOption: {
                spaceBetween: 30,
                centeredSlides: true,
                autoplay: 4000,
                autoplayDisableOnInteraction: false,
                effect: 'fade',
                speed: 2000
            }
        };
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['user', 'theme'])),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['LOG_IN_USER']), {
        closeMessage: function closeMessage() {
            this.error = null;
        }
    }),

    head: {
        title: {
            inner: 'Services'
        }
    }

});

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Search_Index_vue__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Search_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Search_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_SideNavBar_Index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_SideNavBar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_SideNavBar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router_index_js__ = __webpack_require__(11);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'dashboard',

    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["a" /* localStorageMixin */]],

    data: function data() {
        return {
            master_loading: true
        };
    },

    created: function created() {
        var _this = this;

        var user = this.ls_pullUser();
        this.SET_USER(user);
        this.FETCH_USER_DATA().then(function () {
            _this.FETCH_STATS_CURRENT().then(function () {
                _this.master_loading = false;
            });
        });
    },


    components: {
        Editor: __WEBPACK_IMPORTED_MODULE_4__components_Editor_Index_vue___default.a,
        Bar: __WEBPACK_IMPORTED_MODULE_5__components_Bar_Index_vue___default.a,
        Search: __WEBPACK_IMPORTED_MODULE_3__components_Search_Index_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue___default.a,
        IconButton: __WEBPACK_IMPORTED_MODULE_6__components_IconButton_Index_vue___default.a,
        SideNavBar: __WEBPACK_IMPORTED_MODULE_7__components_SideNavBar_Index_vue___default.a
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['theme', 'user_role', 'stats_current', 'user'])),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['FETCH_USER_DATA', 'FETCH_STATS_CURRENT']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["d" /* mapMutations */])(['SET_USER']), {
        checkAppBarPermissions: function checkAppBarPermissions() {
            return this.user_role !== 'guest';
        }
    }),

    head: {
        title: {
            inner: 'App'
        }
    }

});

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Search_Index_vue__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Search_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Search_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Foot_Index_vue__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Foot_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Foot_Index_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'nv',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["a" /* localStorageMixin */]],

  data: function data() {
    return {
      loading: true
    };
  },

  created: function created() {
    var _this = this;

    var user = this.ls_pullUser();
    this.SET_USER(user);
    this.FETCH_USER_DATA().then(function () {
      _this.loading = false;
    });
  },


  components: {
    Editor: __WEBPACK_IMPORTED_MODULE_4__components_Editor_Index_vue___default.a,
    Foot: __WEBPACK_IMPORTED_MODULE_5__components_Foot_Index_vue___default.a,
    Search: __WEBPACK_IMPORTED_MODULE_3__components_Search_Index_vue___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue___default.a
  },

  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['theme'])),

  methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['FETCH_USER_DATA']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["d" /* mapMutations */])(['SET_USER'])),

  head: {
    title: {
      inner: 'App'
    }
  }

});

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Spinner_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'public',

  data: function data() {
    return {
      loading: true
    };
  },

  created: function created() {
    if (this.$route.params.id) {
      this.getNote();
    }
  },


  components: {
    Spinner: __WEBPACK_IMPORTED_MODULE_1__components_Spinner_vue___default.a
  },

  computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['activeNote']), {
    body: function body() {
      return this.activeNote.body.replace('\n', '<br/>');
    }
  }),

  methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['FETCH_PUBLIC_NOTE_FOR_ID']), {
    getNote: function getNote() {
      var _this = this;

      this.FETCH_PUBLIC_NOTE_FOR_ID(this.$route.params.id).then(function () {
        return _this.loading = false;
      }).catch(function () {
        return _this.$router.push({ name: 'home' });
      });
    }
  }),

  watch: {
    '$route': 'getNote'
  }

});

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__router_index_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__options_countries__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__options_spanish_provinces__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__options_ad_types__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__options_ad_data_types__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__options_dwelling_types__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__options_floor_types__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__options_property_types__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__options_quality_of_neighbourhood__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__options_quality_of_situation__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__options_quality_of_construction__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__options_quality_of_realestate__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__options_conservation_statuses__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Datatable_datatable_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Datatable_datatable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_Datatable_datatable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_Datatable_datatable_column_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_Datatable_datatable_column_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_Datatable_datatable_column_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__aggregators_aggregators_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__formatters_formatters_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_Toggles_checkbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_Toggles_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_Toggles_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_Paginator_paginator_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_Paginator_paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_Paginator_paginator_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





































/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ad-editor',

    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins__["d" /* dateMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["a" /* localStorageMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["f" /* mathMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["e" /* objectsMixin */]],

    data: function data() {
        return {
            master_loading: true,
            manually_creating_new_ad: false,
            filesOpen: true,
            fileOpen: true,
            reportOpen: true,
            cadaster_ref_loading: false,
            icc_census_section_loading: false,
            google_geocode_loading: false,
            error: null,
            success_message: null,
            metadata_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Metadata'),
            epsg_missing_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('EPSG_missing_text') + '.',
            identification_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Identification'),
            marketstudies_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Market_studies'),
            appraisals_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Appraisals'),
            filter_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type_here_to_filter_paginated_data'),
            new_appraisal_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_appraisal'),
            new_marketstudy_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_market_study'),
            open_ad_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Open') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Ad'),
            cancel_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cancel'),
            goback_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_back') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            goup_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_up') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            go_to_market_study_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_back_to_market_study'),
            save_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save'),
            upload_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Upload_to_database'),
            save_and_go_up_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('go_up'),
            cad_ref_error_text_01: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cadastral_Reference_less_20_positions_error_text'),
            page_dirty_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('The_page_contains_unsaved_changes'),
            actions_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Actions'),
            duplicate_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Duplicate'),
            edit_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Edit'),
            delete_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Delete'),
            countryOptions: __WEBPACK_IMPORTED_MODULE_13__options_countries__["a" /* default */],
            spanishProvinceOptions: __WEBPACK_IMPORTED_MODULE_14__options_spanish_provinces__["a" /* default */],
            ad_typeOptions: __WEBPACK_IMPORTED_MODULE_15__options_ad_types__["a" /* default */],
            ad_data_typeOptions: __WEBPACK_IMPORTED_MODULE_16__options_ad_data_types__["a" /* default */],
            dwelling_typeOptions: __WEBPACK_IMPORTED_MODULE_17__options_dwelling_types__["a" /* default */],
            floor_typeOptions: __WEBPACK_IMPORTED_MODULE_18__options_floor_types__["a" /* default */],
            property_typeOptions: __WEBPACK_IMPORTED_MODULE_19__options_property_types__["a" /* default */],
            quality_of_neighbourhoodOptions: __WEBPACK_IMPORTED_MODULE_20__options_quality_of_neighbourhood__["a" /* default */],
            quality_of_situationOptions: __WEBPACK_IMPORTED_MODULE_21__options_quality_of_situation__["a" /* default */],
            quality_of_constructionOptions: __WEBPACK_IMPORTED_MODULE_22__options_quality_of_construction__["a" /* default */],
            quality_of_realestateOptions: __WEBPACK_IMPORTED_MODULE_23__options_quality_of_realestate__["a" /* default */],
            conservation_statusOptions: __WEBPACK_IMPORTED_MODULE_24__options_conservation_statuses__["a" /* default */],
            countryValue: null,
            municipalityValue: null,
            provinceValue: null,
            ad_typeValue: null,
            ad_data_typeValue: null,
            dwelling_typeValue: null,
            floor_typeValue: null,
            property_typeValue: null,
            quality_of_neighbourhoodValue: null,
            quality_of_situationValue: null,
            quality_of_constructionValue: null,
            quality_of_realestateValue: null,
            conservation_statusValue: null,
            appraisal_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [{
                    id: 'description',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Description'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'date_modified',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Last_modified'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format('DD/MM/YYYY HH:mm:ss');
                    }
                }],
                selected: []
            },
            marketstudy_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [{
                    id: 'description',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Description'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'date_modified',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Last_modified'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format('DD/MM/YYYY HH:mm:ss');
                    }
                }],
                selected: []
            }

        };
    },

    created: function created() {
        var _this = this;

        if (this.$route.query.mcna) {
            if (this.$route.query.mcna === 'y') {
                this.manually_creating_new_ad = true;
            }
        }

        if (this.ad.province && !this.ad_municipalities.municipalities) {

            if (this.ad.province.ine_province_code) {
                console.log('fetching...');
                this.FETCH_AD_MUNICIPALITIES({ path: 'municipalities' + '/' + 'province_' + this.ad.province.ine_province_code + '/' }).then(function () {
                    _this.master_loading = false;
                });
            } else {
                this.master_loading = false;
            }
        } else {
            this.master_loading = false;
        }
    },


    components: {
        Bar: __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default.a,
        Message: __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default.a,
        IconButton: __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default.a,
        Checkbox: __WEBPACK_IMPORTED_MODULE_29__components_Toggles_checkbox_vue___default.a,
        Datatable: __WEBPACK_IMPORTED_MODULE_25__components_Datatable_datatable_vue___default.a,
        DatatableColumn: __WEBPACK_IMPORTED_MODULE_26__components_Datatable_datatable_column_vue___default.a,
        Paginator: __WEBPACK_IMPORTED_MODULE_30__components_Paginator_paginator_vue___default.a,
        SideNavBar: __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default.a
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['theme', 'tags_display', 'appraisal', 'appraisalfile', 'appraisalreport', 'currentLocale', 'marketstudy', 'ad', 'ad_municipalities']), {
        formatted_ad_date: function formatted_ad_date() {
            return __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.ad.ad_date).format('DD/MM/YYYY');
        }
    }),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['FETCH_AD_MUNICIPALITIES', 'GEOLOCATE_AD', 'REQUEST_CADASTRAL_REFERENCE_BY_COORDINATES', 'REQUEST_CENSUS_SECTION_INFO', 'SET_AD_CADASTRAL_REFERENCE', 'SET_AD_CENSUS_SECTION_CODE', 'SET_AD_COUNTRY', 'SET_AD_DESCRIPTION', 'SET_AD_DOOR', 'SET_AD_EPSG25831_X', 'SET_AD_EPSG25831_Y', 'SET_AD_FLOOR', 'SET_AD_GOOGLE_FORMATTED_ADDRESS', 'SET_AD_LAT', 'SET_AD_LNG', 'SET_AD_MUNICIPALITY', 'SET_AD_POSTAL_CODE', 'SET_AD_REGISTRY_NAME', 'SET_AD_PROVINCE', 'SET_AD_STAIRCASE', 'SET_AD_STREET_NAME', 'SET_AD_STREET_NUMBER', 'UPDATE_AD', 'SET_AD_REGISTRY_IDUFIR', 'SET_AD_AD_ADDRESS', 'SET_AD_AD_CODE', 'SET_AD_CONTACT_TELEPHONE', 'SET_AD_ORIENTATION', 'SET_AD_SOURCE', 'SET_AD_URL', 'SET_AD_CADASTRAL_AREA', 'SET_AD_AD_YEAR', 'SET_AD_ADOPTED_AREA', 'SET_AD_ADOPTED_AGE', 'SET_AD_BATHROOMS_NUMBER', 'SET_AD_BEDROOMS_NUMBER', 'SET_AD_CONSERVATION_STATUS', 'SET_AD_COVERED_OUTDOOR_AREA', 'SET_AD_UNCOVERED_OUTDOOR_AREA', 'SET_AD_CONSTRUCTION_YEAR', 'SET_AD_ESTIMATED_SALE_PRICE', 'SET_AD_FLOOR_NUMBER', 'SET_AD_LAST_RENOVATION_YEAR', 'SET_AD_OFFER_PRICE', 'SET_AD_PARKING_LOTS_NUMBER', 'SET_AD_BUILT_AREA', 'SET_AD_LAND_AREA', 'SET_AD_NET_AREA', 'SET_AD_AD_DATE', 'SET_AD_CAPTURE_DATE', 'SET_AD_AIR_CONDITIONING', 'SET_AD_EXTERNAL_STORAGE_ROOM', 'SET_AD_GREEN_AREAS', 'SET_AD_HEATING', 'SET_AD_LIFT', 'SET_AD_SPORTS_FACILITIES', 'SET_AD_SWIMMING_POOL', 'SET_AD_INTERIOR_VISIT_CHECK', 'SET_AD_CADASTRAL_DATA_CHECK', 'SET_AD_NOTES_1', 'SET_AD_NOTES_2', 'SET_AD_AD_TYPE', 'SET_AD_AD_DATA_TYPE', 'SET_AD_DWELLING_TYPE', 'SET_AD_FLOOR_TYPE', 'SET_AD_PROPERTY_TYPE', 'SET_AD_QUALITY_OF_NEIGHBOURHOOD', 'SET_AD_QUALITY_OF_SITUATION', 'SET_AD_QUALITY_OF_CONSTRUCTION', 'SET_AD_QUALITY_OF_REALESTATE', 'SET_AD_BLOCK', 'SET_AD_CONTACT_NAME', 'SET_AD_OFFER_UNIT_PRICE', 'SET_AD_CONSERVATION_STATUS', 'SET_AD_OFFER_PRICE_REDUCTION_PCT', 'SET_AD_ESTIMATED_UNIT_SALE_PRICE']), {
        set_ad_cadastral_reference: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_CADASTRAL_REFERENCE(e.target.value);
        }, 1000),
        set_ad_census_section_code: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_CENSUS_SECTION_CODE(e.target.value);
        }, 1000),
        set_ad_country_option: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            console.log('set_ad_country e: ');
            console.log(e);
            this.SET_AD_COUNTRY(e);

            this.SET_AD_PROVINCE(null);
            this.ad.province = null;

            this.SET_AD_MUNICIPALITY(null);
            this.ad.municipality = null;

            this.SET_AD_LAT(null);
            this.ad.lat = null;

            this.SET_AD_LNG(null);
            this.ad.lng = null;

            this.SET_AD_EPSG25831_X(null);
            this.ad.epsg25831_x = null;

            this.SET_AD_EPSG25831_Y(null);
            this.ad.epsg25831_y = null;

            this.SET_AD_CADASTRAL_REFERENCE(null);
            this.ad.cadastral_reference = null;

            this.SET_AD_CENSUS_SECTION_CODE(null);
            this.ad.census_section_code = null;

            this.SET_AD_POSTAL_CODE(null);
            this.ad.postal_code = null;

            this.SET_AD_GOOGLE_FORMATTED_ADDRESS(null);
            this.ad.google_formatted_address = null;
        }, 1000),
        set_ad_description: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_DESCRIPTION(e.target.value);
        }, 1000),
        set_ad_door: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_DOOR(e.target.value);
        }, 1000),
        set_ad_epsg25831_x: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_EPSG25831_X(e.target.value);
        }, 1000),
        set_ad_epsg25831_y: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_EPSG25831_Y(e.target.value);
        }, 1000),
        set_ad_floor: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_FLOOR(e.target.value);
        }, 1000),
        set_ad_lat: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_LAT(e.target.value);
        }, 1000),
        set_ad_lng: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_LNG(e.target.value);
        }, 1000),
        set_ad_municipality: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_MUNICIPALITY(e.target.value);
        }, 1000),
        set_ad_municipality_option: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_MUNICIPALITY(e);
        }, 1000),
        set_ad_postal_code: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_POSTAL_CODE(e.target.value);
        }, 1000),
        set_ad_province: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this2 = this;

            this.SET_AD_PROVINCE(e.target.value).then(function (res) {
                _this2.SET_AD_MUNICIPALITY(null);
                _this2.ad.municipality = null;
            });
        }, 1000),
        set_ad_province_option: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this3 = this;

            this.SET_AD_PROVINCE(e).then(function (res) {
                _this3.FETCH_AD_MUNICIPALITIES({ path: 'municipalities' + '/' + 'province_' + _this3.ad.province.ine_province_code + '/' });
                _this3.SET_AD_MUNICIPALITY(null);
                _this3.ad.municipality = null;
            });
        }, 1000),
        set_ad_registry_name: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_REGISTRY_NAME(e.target.value);
        }, 1000),
        set_ad_staircase: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_STAIRCASE(e.target.value);
        }, 1000),
        set_ad_street_name: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_STREET_NAME(e.target.value);
            if (!e.target.value || e.target.value.length === 0) {
                // console.log('no street name')

                this.SET_AD_LAT(null);
                this.ad.lat = null;

                this.SET_AD_LNG(null);
                this.ad.lng = null;

                this.SET_AD_EPSG25831_X(null);
                this.ad.epsg25831_x = null;

                this.SET_AD_EPSG25831_Y(null);
                this.ad.epsg25831_y = null;

                this.SET_AD_CADASTRAL_REFERENCE(null);
                this.ad.cadastral_reference = null;

                this.SET_AD_CENSUS_SECTION_CODE(null);
                this.ad.census_section_code = null;

                this.SET_AD_POSTAL_CODE(null);
                this.ad.postal_code = null;

                this.SET_AD_GOOGLE_FORMATTED_ADDRESS(null);
                this.ad.google_formatted_address = null;
            }
        }, 1000),
        set_ad_street_number: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_STREET_NUMBER(e.target.value);
        }, 1000),
        set_ad_registry_idufir: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_REGISTRY_IDUFIR(e.target.value);
        }, 1000),
        set_ad_ad_address: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_AD_ADDRESS(e.target.value);
        }, 1000),
        set_ad_ad_code: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_AD_CODE(e.target.value);
        }, 1000),
        set_ad_contact_telephone: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_CONTACT_TELEPHONE(e.target.value);
        }, 1000),
        set_ad_orientation: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_ORIENTATION(e.target.value);
        }, 1000),
        set_ad_source: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_SOURCE(e.target.value);
        }, 1000),
        set_ad_url: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_URL(e.target.value);
        }, 1000),
        set_ad_cadastral_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_CADASTRAL_AREA(e.target.value);
        }, 1000),
        set_ad_ad_year: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_AD_YEAR(e.target.value);
        }, 1000),
        set_ad_adopted_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            console.log('dins');
            var area = Number(e.target.value);

            var reduction_pct = this.ad.offer_price_reduction_pct;
            var offer_price = this.ad.offer_price;
            var estimated_sale_price = this.roundToTwo(offer_price * (1 - reduction_pct));

            var offer_unit_price = this.roundToTwo(offer_price / area);
            var estimated_unit_sale_price = this.roundToTwo(estimated_sale_price / area);

            console.log('estimated_sale_price: ');
            console.log(estimated_sale_price);

            this.SET_AD_ADOPTED_AREA(area);
            this.SET_AD_OFFER_UNIT_PRICE(offer_unit_price);

            this.SET_AD_ESTIMATED_SALE_PRICE(estimated_sale_price);
            this.SET_AD_ESTIMATED_UNIT_SALE_PRICE(estimated_unit_sale_price);
        }, 1000),
        set_ad_adopted_age: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_ADOPTED_AGE(e.target.value);
        }, 1000),
        set_ad_bathrooms_number: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_BATHROOMS_NUMBER(e.target.value);
        }, 1000),
        set_ad_bedrooms_number: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_BEDROOMS_NUMBER(e.target.value);
        }, 1000),
        set_ad_covered_outdoor_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_COVERED_OUTDOOR_AREA(e.target.value);
        }, 1000),
        set_ad_uncovered_outdoor_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_UNCOVERED_OUTDOOR_AREA(e.target.value);
        }, 1000),
        set_ad_construction_year: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {

            var construction_year = Number(e.target.value);
            this.SET_AD_CONSTRUCTION_YEAR(construction_year);

            var last_renovation_year = construction_year;

            if (this.ad.last_renovation_year) {
                last_renovation_year = this.ad.last_renovation_year;

                if (last_renovation_year < construction_year) {
                    last_renovation_year = construction_year;
                }
            }

            this.SET_AD_LAST_RENOVATION_YEAR(last_renovation_year);

            var average = Math.round((construction_year + last_renovation_year) / 2);
            this.SET_AD_ADOPTED_AGE(average).then(function () {});
        }, 500),
        set_ad_offer_price_reduction_pct: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {

            var reduction_pct = this.roundToTwo(Number(e.target.value));

            var offer_price = this.ad.offer_price;
            var offer_unit_price = this.ad.offer_unit_price;
            var estimated_sale_price = this.roundToTwo(offer_price * (1 - reduction_pct));
            var estimated_unit_sale_price = this.roundToTwo(offer_unit_price * (1 - reduction_pct));

            this.SET_AD_OFFER_PRICE_REDUCTION_PCT(reduction_pct);
            this.SET_AD_ESTIMATED_SALE_PRICE(estimated_sale_price);
            this.SET_AD_ESTIMATED_UNIT_SALE_PRICE(estimated_unit_sale_price);
        }, 500),
        set_ad_estimated_sale_price: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_ESTIMATED_SALE_PRICE(e.target.value);
        }, 1000),
        set_ad_floor_number: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_FLOOR_NUMBER(e.target.value);
        }, 1000),
        set_ad_last_renovation_year: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {

            var last_renovation_year = Number(e.target.value);
            this.SET_AD_LAST_RENOVATION_YEAR(last_renovation_year);

            var construction_year = 1900;

            if (this.ad.construction_year) {
                construction_year = this.ad.construction_year;
            }

            this.SET_AD_CONSTRUCTION_YEAR(construction_year);

            var average = Math.round((construction_year + last_renovation_year) / 2);
            this.SET_AD_ADOPTED_AGE(average).then(function () {});
        }, 500),
        set_ad_offer_price: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {

            var offer_price = Number(e.target.value);
            var area = this.ad.adopted_area;
            var reduction_pct = this.ad.offer_price_reduction_pct;

            var offer_unit_price = this.roundToTwo(offer_price / area);
            var estimated_sale_price = this.roundToTwo(offer_price * (1 - reduction_pct));
            var estimated_unit_sale_price = this.roundToTwo(offer_unit_price * (1 - reduction_pct));

            this.SET_AD_OFFER_PRICE(offer_price);
            this.SET_AD_OFFER_UNIT_PRICE(offer_unit_price);
            this.SET_AD_ESTIMATED_SALE_PRICE(estimated_sale_price);
            this.SET_AD_ESTIMATED_UNIT_SALE_PRICE(estimated_unit_sale_price);
        }, 500),
        set_ad_parking_lots_number: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_PARKING_LOTS_NUMBER(e.target.value);
        }, 1000),
        set_ad_built_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_BUILT_AREA(e.target.value);
        }, 1000),
        set_ad_land_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_LAND_AREA(e.target.value);
        }, 1000),
        set_ad_net_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_NET_AREA(e.target.value);
        }, 1000),
        set_ad_ad_date: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_AD_DATE(e.target.value);
        }, 1000),
        set_ad_capture_date: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_CAPTURE_DATE(e.target.value);
        }, 1000),
        set_ad_air_conditioning: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_AIR_CONDITIONING(e.target.value);
        }, 1000),
        set_ad_external_storage_room: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_EXTERNAL_STORAGE_ROOM(e.target.value);
        }, 1000),
        set_ad_green_areas: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_GREEN_AREAS(e.target.value);
        }, 1000),
        set_ad_heating: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_HEATING(e.target.value);
        }, 1000),
        set_ad_lift: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_LIFT(e.target.value);
        }, 1000),
        set_ad_sports_facilities: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_SPORTS_FACILITIES(e.target.value);
        }, 1000),
        set_ad_swimming_pool: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_SWIMMING_POOL(e.target.value);
        }, 1000),
        set_ad_interior_visit_check: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_INTERIOR_VISIT_CHECK(e.target.value);
        }, 1000),
        set_ad_cadastral_data_check: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_CADASTRAL_DATA_CHECK(e.target.value);
        }, 1000),
        set_ad_notes_1: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_NOTES_1(e.target.value);
        }, 1000),
        set_ad_notes_2: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_NOTES_2(e.target.value);
        }, 1000),
        set_ad_ad_type: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_AD_TYPE(e);
        }, 1000),
        set_ad_ad_data_type: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_AD_DATA_TYPE(e);
        }, 1000),
        set_ad_dwelling_type: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_DWELLING_TYPE(e);
        }, 1000),
        set_ad_floor_type: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_FLOOR_TYPE(e);
        }, 1000),
        set_ad_property_type: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_PROPERTY_TYPE(e);
        }, 1000),
        set_ad_quality_of_neighbourhood: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_QUALITY_OF_NEIGHBOURHOOD(e);
        }, 1000),
        set_ad_quality_of_situation: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_QUALITY_OF_SITUATION(e);
        }, 1000),
        set_ad_quality_of_construction: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_QUALITY_OF_CONSTRUCTION(e);
        }, 1000),
        set_ad_quality_of_realestate: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_QUALITY_OF_REALESTATE(e);
        }, 1000),
        set_ad_block: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_BLOCK(e.target.value);
        }, 1000),
        set_ad_contact_name: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_CONTACT_NAME(e.target.value);
        }, 1000),
        set_ad_offer_unit_price: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_OFFER_UNIT_PRICE(e.target.value);
        }, 1000),
        set_ad_conservation_status: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_CONSERVATION_STATUS(e);
        }, 1000),
        set_ad_estimated_unit_sale_price: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_AD_ESTIMATED_UNIT_SALE_PRICE(Number(e.target.value));
        }, 1000),
        onSaveCurrentAd: function onSaveCurrentAd(data) {
            var _this4 = this;

            this.UPDATE_AD({
                key: this.ad.id,
                object: this.ad,
                //parent_path: this.ad.parent_path + this.ad.id,
                path: this.ad.path + this.ad.id,
                path_ad_locations: 'ad_locations' + '/' + this.ad.ad_type.name_db + '/' + __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.ad.ad_date).format('YYYY') + '/' + this.ad.geohash[0] + '/' + this.ad.geohash[1] + '/' + this.ad.geohash[2] + '/' + this.ad.geohash[3] + '/' + this.ad.geohash[4] + '/' + this.ad.geohash[5] + '/' + this.ad.geohash[6] + '/' + this.ad.geohash[7] + '/' + this.ad.geohash[8] + '/' + this.ad.geohash[9] + '/' + this.ad.geohash[10] + '/' + this.ad.geohash[11] + '/' + this.ad.id,
                path_ads: 'ads' + '/' + this.ad.ad_type.name_db + '/' + __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.ad.ad_date).format('YYYY') + '/' + this.ad.geohash[0] + '/' + this.ad.geohash[1] + '/' + this.ad.geohash[2] + '/' + this.ad.geohash[3] + '/' + this.ad.geohash[4] + '/' + this.ad.geohash[5] + '/' + this.ad.geohash[6] + '/' + this.ad.geohash[7] + '/' + this.ad.geohash[8] + '/' + this.ad.geohash[9] + '/' + this.ad.geohash[10] + '/' + this.ad.geohash[11] + '/' + this.ad.id
                //file_id: this.appraisalfile.id,
                //report_id: this.appraisalreport.id
            }).then(function (res) {
                if (data.go_up) {
                    _this4.onGoUp();
                }
            });
        },
        onUploadCurrentAd: function onUploadCurrentAd(data) {
            var _this5 = this;

            console.log('path_ads: ');
            console.log('ads' + '/' + this.ad.ad_type.name_db + '/' + __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.ad.ad_date).format('YYYY') + '/' + this.ad.geohash[0] + '/' + this.ad.geohash[1] + '/' + this.ad.geohash[2] + '/' + this.ad.geohash[3] + '/' + this.ad.geohash[4] + '/' + this.ad.geohash[5] + '/' + this.ad.geohash[6] + '/' + this.ad.geohash[7] + '/' + this.ad.geohash[8] + '/' + this.ad.geohash[9] + '/' + this.ad.geohash[10] + '/' + this.ad.geohash[11] + '/' + this.ad.id);

            this.UPDATE_AD({
                key: this.ad.id,
                object: this.ad,
                path: this.ad.path + this.ad.id,
                path_ad_locations: 'ad_locations' + '/' + this.ad.ad_type.name_db + '/' + __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.ad.ad_date).format('YYYY') + '/' + this.ad.geohash[0] + '/' + this.ad.geohash[1] + '/' + this.ad.geohash[2] + '/' + this.ad.geohash[3] + '/' + this.ad.geohash[4] + '/' + this.ad.geohash[5] + '/' + this.ad.geohash[6] + '/' + this.ad.geohash[7] + '/' + this.ad.geohash[8] + '/' + this.ad.geohash[9] + '/' + this.ad.geohash[10] + '/' + this.ad.geohash[11] + '/' + this.ad.id,
                path_ads: 'ads' + '/' + this.ad.ad_type.name_db + '/' + __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.ad.ad_date).format('YYYY') + '/' + this.ad.geohash[0] + '/' + this.ad.geohash[1] + '/' + this.ad.geohash[2] + '/' + this.ad.geohash[3] + '/' + this.ad.geohash[4] + '/' + this.ad.geohash[5] + '/' + this.ad.geohash[6] + '/' + this.ad.geohash[7] + '/' + this.ad.geohash[8] + '/' + this.ad.geohash[9] + '/' + this.ad.geohash[10] + '/' + this.ad.geohash[11] + '/' + this.ad.id
            }).then(function (res) {

                _this5.$router.push({ name: 'ads-index' });
            });
        },
        onGoBack: function onGoBack() {
            // console.log('yeah back')
            __WEBPACK_IMPORTED_MODULE_11__router_index_js__["a" /* default */].go(-1);
        },
        onGoUp: function onGoUp() {
            // console.log('yeah back')
            this.$router.push({ name: 'marketstudy-editor', query: { appraisal_id: this.appraisal.id } });
        },
        onGoToMarketStudy: function onGoToMarketStudy() {
            console.log('yeah back');
            // console.log(this.appraisal.id)
            this.$router.push({ name: 'marketstudy-editor', query: { appraisal_id: this.appraisal.id } });
        },
        onCancelAll: function onCancelAll() {
            var result = window.confirm(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Changes_will_be_lost_p_continue_q'));

            if (result) {
                __WEBPACK_IMPORTED_MODULE_11__router_index_js__["a" /* default */].go(-1);
            } else {
                return false;
            }
        },
        onGeolocate: function onGeolocate() {
            var _this6 = this;

            this.google_geocode_loading = true;
            this.GEOLOCATE_AD({
                id: this.ad.id,
                old_geohash: this.ad.geohash,
                street_name: this.ad.street_name,
                street_number: this.ad.street_number,
                municipality: this.ad.municipality
            }).then(function (res) {
                //
                _this6.google_geocode_loading = false;
            });
        },
        onRequestCensusSectionInfo: function onRequestCensusSectionInfo() {
            var _this7 = this;

            console.log('requesting census section info...');
            this.icc_census_section_loading = true;
            this.REQUEST_CENSUS_SECTION_INFO({
                x: this.ad.epsg25831_x,
                y: this.ad.epsg25831_y
            }).then(function (res) {
                //
                _this7.icc_census_section_loading = false;
            });
        },
        onRequestCadastralReferenceSuggestion: function onRequestCadastralReferenceSuggestion() {
            var _this8 = this;

            console.log('requesting cadastral reference suggestion...');
            this.cadaster_ref_loading = true;
            this.REQUEST_CADASTRAL_REFERENCE_BY_COORDINATES({
                x: this.ad.epsg25831_x,
                y: this.ad.epsg25831_y
            }).then(function (res) {
                //
                _this8.cadaster_ref_loading = false;
            });
        },
        onOpenAd: function onOpenAd() {
            var url = this.ad.url;
            var win = window.open(url, '_blank');
            win.focus();
        },
        onOpenCadastralList: function onOpenCadastralList() {
            // console.log('opening cadastral map...')
            // const url = 'https://www.whatismyreferer.com/'
            var refcat = this.ad.cadastral_reference;
            var rc1 = refcat.substring(0, 7);
            var rc2 = refcat.substring(7, 14);
            var url = 'https://www1.sedecatastro.gob.es/CYCBienInmueble/OVCListaBienes.aspx?del=' + this.ad.municipality.cadaster_province_code + '&muni=' + this.ad.municipality.cadaster_municipality_code + '&rc1=' + rc1 + '&rc2=' + rc2;
            var win = window.open(url, '_blank');
            win.focus();
        },
        onOpenCadastralMap: function onOpenCadastralMap() {
            // console.log('opening cadastral map...')

            var url = 'https://www1.sedecatastro.gob.es/Cartografia/mapa.aspx?del=' + this.ad.municipality.cadaster_province_code + '&mun=' + this.ad.municipality.cadaster_municipality_code + '&refcat=' + this.ad.cadastral_reference + '&final=';
            var win = window.open(url, '_blank');
            win.focus();
        }

    }),
    head: {
        title: {
            //inner: Vue.i18n.translate('New_contact')
            inner: 'Edit ad'
        }
    }

});

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__router_index_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__aggregators_aggregators_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__formatters_formatters_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
























/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ads-index',

    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins__["d" /* dateMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["a" /* localStorageMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["e" /* objectsMixin */]],

    data: function data() {
        return {
            master_loading: true,
            loading: true,
            query_comparables_loading: false,
            adsOpen: false,
            adOpen: false,
            editabletrue: true,
            error: null,
            success_message: null,
            queryComparableTypeValue: null,
            new_ad_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_ad_manually'),
            add_ad_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_ad'),
            query_ads_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Query_ads'),
            ads_index_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Ads_index'),
            ads_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Ads'),
            filter_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type_here_to_filter_paginated_data'),
            cancel_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cancel'),
            goback_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_back') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            goup_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_up') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            save_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('go_up'),
            lat_lng_error_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Lat_lng_missing_error_text'),
            actions_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Actions'),
            duplicate_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Duplicate'),
            edit_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Edit'),
            delete_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Delete'),
            countryValue: null,
            municipalityValue: null,
            provinceValue: null,
            ad_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [{
                    id: 'address',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Address'),
                    width: 30,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'appraisalfiles',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Files'),
                    width: 10,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                },
                /*
                {
                id: 'street_number',
                label: Vue.i18n.translate('Street_number'),
                width: null,
                sortable: true,
                groupable: false,
                aggregators: []
                },
                {
                id: 'floor',
                label: Vue.i18n.translate('Floor'),
                width: null,
                sortable: true,
                groupable: false,
                aggregators: []
                },
                {
                id: 'door',
                label: Vue.i18n.translate('door'),
                width: null,
                sortable: true,
                groupable: false,
                aggregators: []
                },
                {
                id: 'postal_code',
                label: Vue.i18n.translate('Postal_code'),
                width: null,
                sortable: true,
                groupable: false,
                aggregators: []
                },
                {
                id: 'municipality',
                label: Vue.i18n.translate('Municipality'),
                width: null,
                sortable: true,
                groupable: false,
                aggregators: []
                },
                */
                {
                    id: 'description',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Description'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'date_modified',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Last_modified'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format('DD/MM/YYYY HH:mm:ss');
                    }
                }],
                selected: []
            }

        };
    },

    created: function created() {
        /*
        this.FETCH_ADS({path: 'ads'})
            .then(() => {
                this.master_loading = false
             })
            */
        this.master_loading = false;
    },


    components: {
        Bar: __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default.a,
        Message: __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default.a,
        IconButton: __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default.a,
        Checkbox: __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue___default.a,
        Datatable: __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue___default.a,
        DatatableColumn: __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue___default.a,
        Paginator: __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue___default.a,
        SideNavBar: __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default.a
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['theme', 'currentLocale', 'ads'])),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['CREATE_NEW_AD', 'FETCH_ADS', 'RESET_AD', 'SET_AD', 'SET_APPRAISALFILE']), {
        onCreateNewAd: function onCreateNewAd() {
            var _this = this;

            // console.log('hey')
            // console.log('ad: ')
            // console.log(this.ad)
            this.RESET_AD().then(function (res) {
                _this.CREATE_NEW_AD({
                    path: 'temp_ads' + '/'
                }).then(function (res) {
                    _this.$router.push({ name: 'ad-editor', query: { id: res.key, mcna: 'y' } });
                });
            });
        },
        editAd: function editAd(entity) {
            var _this2 = this;

            // console.log('edit ad...')
            this.SET_AD({ path: 'ads' + '/' + entity.id + '/' }).then(function (res) {
                _this2.$router.push({ name: 'ad-editor', query: { id: entity.id } });
            });
        }
    }),
    head: {
        title: {
            //inner: Vue.i18n.translate('New_contact')
            inner: 'Ads'
        }

    }
});

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__router_index_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__options_petitioner_types__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__options_status_invoices__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__options_honorific_titles__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__options_person_types__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Datatable_datatable_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Datatable_datatable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Datatable_datatable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Datatable_datatable_column_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Datatable_datatable_column_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Datatable_datatable_column_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__aggregators_aggregators_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__formatters_formatters_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Toggles_checkbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Toggles_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_Toggles_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Paginator_paginator_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Paginator_paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_Paginator_paginator_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





























var numeral = __webpack_require__(119);

var _require = __webpack_require__(40),
    map = _require.map;

var _require2 = __webpack_require__(40),
    forEach = _require2.forEach;

var pdfMake = __webpack_require__(211);
var pdfFonts = __webpack_require__(212);
pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.tableLayouts = {
    hLineWidth: {
        hLineWidth: function hLineWidth(i, node) {
            return 0.5;
        }
    }
};

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'appraisalinvoice-editor',

    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins__["d" /* dateMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["a" /* localStorageMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["f" /* mathMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["e" /* objectsMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["j" /* dataURLMixin */]],

    data: function data() {
        return {
            value: null,
            cover_photo_dataURL: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==',
            no_result_color: 'black',
            loading: true,
            master_loading: true,
            selecting_line: false,
            creating_contact: false,
            filesOpen: true,
            fileOpen: true,
            invoiceOpen: true,
            error: null,
            quoteValue: null,
            success_message: null,
            editing_line: false,
            editing_line_text_color: 'black',
            editing_line_border_color: 'lightgray',
            metadata_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Version'),
            invoicecontent_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Invoice_content'),
            invoice_title_error_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Invoice_title_missing_error_text'),
            new_real_estate_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Create_new_real_estate'),
            petitioners_missing_error_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Petitioners_missing_error_text'),
            add_petitioner_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_client'),
            lines_missing_error_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Lines_missing_error_text'),
            import_quote_concepts_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Import_quote_concepts'),
            select_real_estate_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_real_estate'),
            add_line_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_invoice_line'),
            cancel_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cancel'),
            goup_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_up') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            pdf_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Print_invoice_in_PDF'),
            save_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save'),
            save_and_go_up_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('go_up'),
            page_dirty_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('The_page_contains_unsaved_changes'),
            actions_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Actions'),
            filter_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type_here_to_filter_paginated_data'),
            line_appraisaldateValue: null,
            duplicate_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Duplicate'),
            edit_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Edit'),
            delete_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Delete'),
            discard_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Discard'),
            openlink_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Open_link_in_new_tab'),
            petitionerValue: null,
            entityValue: null,
            appraiserValue: null,
            supervisorValue: null,
            importLineValue: null,
            petitioner_typeValue: null,
            statusValue: null,
            petitioner_typeOptions: __WEBPACK_IMPORTED_MODULE_13__options_petitioner_types__["a" /* default */],
            status_invoicesOptions: __WEBPACK_IMPORTED_MODULE_14__options_status_invoices__["a" /* default */],
            honorificTitleOptions: __WEBPACK_IMPORTED_MODULE_15__options_honorific_titles__["a" /* default */],
            personTypeOptions: __WEBPACK_IMPORTED_MODULE_16__options_person_types__["a" /* default */],
            line_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [{
                    id: 'description',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Description'),
                    width: 120,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'unit_price',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Unit_price'),
                    width: 40,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'units',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Units'),
                    width: 40,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'price',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Price'),
                    width: 20,
                    sortable: true,
                    groupable: false,
                    aggregators: [__WEBPACK_IMPORTED_MODULE_19__aggregators_aggregators_js__["a" /* default */].total]
                }],
                selected: []
            },
            petitioner_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [{
                    id: 'complete_name',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Client'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'tin',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('TIN'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'complete_fiscal_address',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Fiscal_address'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'main_email',
                    label: 'E-mail',
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }],
                selected: []
            }
        };
    },

    created: function created() {
        var _this = this;

        this.FETCH_APPRAISALINVOICE_LINES({
            path: 'appraisalinvoices' + '/' + this.$route.query.id + '/' + 'lines',
            appraisalinvoice_id: this.$route.query.id
        }).then(function () {
            _this.FETCH_CONTACTS({ path: 'contacts' + '/' + _this.$route.query.id + '/' }).then(function () {

                _this.FETCH_APPRAISALINVOICE_APPRAISALQUOTES({ path: 'appraisalfiles' + '/' + _this.$route.query.file_id + '/' + 'appraisalquotes' + '/' }).then(function () {

                    _this.FETCH_APPRAISALINVOICE_PETITIONERS({
                        path: 'appraisalinvoices' + '/' + _this.$route.query.id + '/' + 'petitioners',
                        appraisalinvoice_id: _this.$route.query.id
                    }).then(function () {

                        if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(_this.appraisalinvoice_lines) > 0) {
                            _this.calc_final_price();
                        }

                        _this.master_loading = false;
                    });
                });
            });
        });
    },


    components: {
        Bar: __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default.a,
        Message: __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default.a,
        IconButton: __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default.a,
        SideNavBar: __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default.a,
        Checkbox: __WEBPACK_IMPORTED_MODULE_21__components_Toggles_checkbox_vue___default.a,
        Datatable: __WEBPACK_IMPORTED_MODULE_17__components_Datatable_datatable_vue___default.a,
        DatatableColumn: __WEBPACK_IMPORTED_MODULE_18__components_Datatable_datatable_column_vue___default.a,
        Paginator: __WEBPACK_IMPORTED_MODULE_22__components_Paginator_paginator_vue___default.a
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['theme', 'tags_display', 'contacts', 'currentLocale', 'appraisal', 'entities', 'supervisors', 'appraisers', 'appraisalfile', 'appraisalinvoice', 'appraisalinvoice_lines', 'appraisalinvoice_appraisalquotes', 'appraisalinvoice_petitioners', 'appraisalquotes', 'line', 'lines', 'contact', 'user'])),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['CHECK_APPRAISALINVOICE_LINE_APPRAISALS', 'CREATE_NEW_LINE', 'CREATE_NEW_CONTACT', 'UPDATE_CONTACT', 'DELETE_LINE', 'DELETE', 'FETCH_APPRAISALINVOICE_LINES', 'FETCH_APPRAISALINVOICE_APPRAISALQUOTES', 'FETCH_APPRAISALINVOICE_PETITIONERS', 'FETCH_CONTACTS', 'FETCH_ENTITIES', 'FETCH_LINE', 'FETCH_LINES', 'FETCH_APPRAISALQUOTES', 'FETCH', 'GET', 'RESET_MARKETSTUDY', 'RESET_LINE', 'SET_LINE', 'SET_VALUE', 'UPDATE_LINE', 'RESET_CONTACT', 'SET_CONTACT', 'SET_CONTACT_MAIN_EMAIL', 'SET_CONTACT_NAME', 'SET_CONTACT_ORGANIZATION', 'SET_CONTACT_PERSON_TYPE', 'SET_CONTACT_REPRESENTATIVE', 'SET_CONTACT_REPRESENTATIVE_TIN', 'SET_CONTACT_SURNAMES', 'SET_CONTACT_TIN', 'SET_CONTACT_TITLE', 'SET_CONTACT_COMPLETE_NAME', 'SET_CONTACT_COMPLETE_FISCAL_ADDRESS', 'SET_APPRAISALINVOICE_LINE_APPRAISAL_ID', 'SET_APPRAISALINVOICE_INVOICEDATE', 'SET_APPRAISALINVOICE_SEND_TO_BDE', 'SET_APPRAISALINVOICE_DESCRIPTION', 'SET_APPRAISALINVOICE_TITLE', 'SET_APPRAISALINVOICE_NUMBER', 'SET_APPRAISALINVOICE_VERSION', 'SET_APPRAISALINVOICE_ENTITY', 'SET_APPRAISALINVOICE_SUPERVISOR', 'SET_APPRAISALINVOICE_APPRAISER', 'SET_APPRAISALINVOICE_PETITIONER', 'SET_APPRAISALINVOICE_PETITIONER_TYPE', 'SET_APPRAISALINVOICE_VAT_PCT', 'SET_APPRAISALINVOICE_STATUS', 'SET_APPRAISALINVOICE_QUOTE', 'SET_APPRAISALINVOICE_FULL_NUMBER', 'SET_LINE_DESCRIPTION', 'SET_LINE_UNITS', 'SET_LINE_UNIT_PRICE', 'SET_LINE_PRICE', 'UPDATE_APPRAISALINVOICE', 'UPDATE_APPRAISALINVOICE_LINES', 'SET_APPRAISALINVOICE_BASE_PRICE', 'SET_APPRAISALINVOICE_DISCOUNT_PCT', 'SET_APPRAISALINVOICE_FINAL_PRICE', 'SET_APPRAISALINVOICE_FINAL_PRICE_INCL_VAT', 'SET_APPRAISALINVOICE_DISCOUNT_NOTES', 'SET_APPRAISALINVOICE_BANK_NAME', 'SET_APPRAISALINVOICE_IBAN', 'SET_APPRAISALINVOICE_FISCAL_NUMBER', 'SET_APPRAISALINVOICE_SIGNATURE_NAME', 'SET_APPRAISALINVOICE_SIGNATURE_BASE64', 'SET_APPRAISALINVOICE_SIGNATURE_DATE', 'SET_APPRAISALINVOICE_SIGNATURE_EMAIL', 'SET_APPRAISALINVOICE_SIGNATURE_UID', 'SET_APPRAISALINVOICE_IS_SIGNED']), {

        set_appraisalinvoice_description: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALINVOICE_DESCRIPTION(e.target.value);
        }, 1000),
        set_appraisalinvoice_invoicedate: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALINVOICE_INVOICEDATE(e.target.value);
        }, 1000),
        set_appraisalinvoice_number: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALINVOICE_NUMBER(Number(e.target.value));

            var filenumber = '';
            filenumber = this.appraisalfile.number;

            var s = Number(e.target.value) + '';
            while (s.length < 2) {
                s = '0' + s;
            }var invoicenumber = s;

            var p = this.appraisalinvoice.version + '';
            while (p.length < 2) {
                p = '0' + p;
            }var invoiceversion = p;

            var fullnumber = filenumber + '/' + invoicenumber + '/' + invoiceversion;

            this.SET_APPRAISALINVOICE_FULL_NUMBER(fullnumber);
        }, 1000),
        set_appraisalinvoice_send_to_bde: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALINVOICE_SEND_TO_BDE(e.target.value);
        }, 1000),
        set_appraisalinvoice_title: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALINVOICE_TITLE(e.target.value);
        }, 1000),
        set_appraisalinvoice_version: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALINVOICE_VERSION(Number(e.target.value));

            var filenumber = '';
            filenumber = this.appraisalfile.number;

            var s = this.appraisalinvoice.number + '';
            while (s.length < 2) {
                s = '0' + s;
            }var invoicenumber = s;

            var p = Number(e.target.value) + '';
            while (p.length < 2) {
                p = '0' + p;
            }var invoiceversion = p;

            var fullnumber = filenumber + '/' + invoicenumber + '/' + invoiceversion;

            this.SET_APPRAISALINVOICE_FULL_NUMBER(fullnumber);
        }, 1000),
        set_appraisalinvoice_petitioner: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALINVOICE_PETITIONER(e);
        }, 1000),
        set_appraisalinvoice_petitioner_type: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALINVOICE_PETITIONER_TYPE(e);
        }, 1000),
        set_appraisalinvoice_entity: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALINVOICE_ENTITY(e);
        }, 1000),
        set_appraisalinvoice_supervisor: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALINVOICE_SUPERVISOR(e);
        }, 1000),
        set_appraisalinvoice_appraiser: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALINVOICE_APPRAISER(e);
        }, 1000),
        set_appraisalinvoice_vat_pct: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALINVOICE_VAT_PCT(Number(e.target.value));
        }, 1000),
        set_appraisalinvoice_status: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALINVOICE_STATUS(e);
        }, 1000),
        set_appraisalinvoice_quote: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALINVOICE_QUOTE(e);
        }, 500),
        set_appraisalinvoice_base_price: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALINVOICE_BASE_PRICE(Number(e.target.value));
        }, 500),
        set_appraisalinvoice_discount_pct: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALINVOICE_DISCOUNT_PCT(Number(e.target.value));
            this.calc_final_price();
        }, 500),
        set_appraisalinvoice_final_price: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALINVOICE_FINAL_PRICE(Number(e.target.value));
        }, 500),
        set_appraisalinvoice_final_price_incl_vat: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALINVOICE_FINAL_PRICE_INCL_VAT(Number(e.target.value));
        }, 500),
        set_appraisalinvoice_discount_notes: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALINVOICE_DISCOUNT_NOTES(e.target.value);
        }, 500),
        set_appraisalinvoice_fiscal_number: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALINVOICE_FISCAL_NUMBER(Number(e.target.value));
        }, 500),
        set_contact_name: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var name = e.target.value;
            var surnames = '';
            if (this.contact.surnames) {
                surnames = this.contact.surnames;
            }

            var complete_name = surnames + ', ' + name;
            if (!surnames) {
                complete_name = name;
            }
            this.SET_CONTACT_NAME(name);
            this.SET_CONTACT_COMPLETE_NAME(complete_name);
        }, 500),
        set_contact_main_email: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_CONTACT_MAIN_EMAIL(e.target.value);
        }, 500),
        set_contact_organization: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_CONTACT_ORGANIZATION(e.target.value);
        }, 500),
        set_contact_person_type: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_CONTACT_PERSON_TYPE(e);
        }, 500),
        set_contact_representative: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_CONTACT_REPRESENTATIVE(e.target.value);
        }, 500),
        set_contact_representative_tin: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_CONTACT_REPRESENTATIVE_TIN(e.target.value);
        }, 500),
        set_contact_surnames: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var surnames = e.target.value;
            var name = '';
            if (this.contact.name) {
                name = this.contact.name;
            }
            var complete_name = surnames + ', ' + name;
            if (!surnames) {
                complete_name = name;
            }
            this.SET_CONTACT_SURNAMES(surnames);
            this.SET_CONTACT_COMPLETE_NAME(complete_name);
        }, 500),
        set_contact_tin: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_CONTACT_TIN(e.target.value);
        }, 500),
        set_contact_title: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_CONTACT_TITLE(e);
        }, 500),
        set_contact_complete_fiscal_address: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_CONTACT_COMPLETE_FISCAL_ADDRESS(e.target.value);
        }, 500),
        /*
        set_line_description: _.debounce(function(e){
        this.SET_LINE_DESCRIPTION(Number(e.target.value))
        }, 500),
        */
        set_line_description: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e, f) {
            var _this2 = this;

            // console.log('e: ')
            // console.log(e)
            // console.log('f: ')
            // console.log(f)

            // this.master_loading = true
            this.editing_line = true;
            this.editing_line_text_color = 'whitesmoke';
            this.editing_line_border_color = 'whitesmoke';
            var description = e.target.value;
            var obj = this.appraisalinvoice_lines;
            var id = f['id'];
            obj[id]['description'] = description;

            this.UPDATE_APPRAISALINVOICE_LINES({
                appraisalinvoice_id: this.appraisalinvoice.id,
                object: obj
            }).then(function (res) {
                _this2.master_loading = false;
                _this2.editing_line = false;
                _this2.editing_line_text_color = 'black';
                _this2.editing_line_border_color = 'lightgray';
            });
        }, 0),
        set_line_unit_price: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e, f) {
            var _this3 = this;

            // this.master_loading = true
            this.editing_line = true;
            this.editing_line_text_color = 'whitesmoke';
            this.editing_line_border_color = 'whitesmoke';
            var value = e.target.value;
            if (!value) {
                value = 0;
            }
            var unit_price = Number(value);
            var obj = this.appraisalinvoice_lines;
            var id = f['id'];
            var units = obj[id]['units'];
            if (!units) {
                units = 0;
            }
            obj[id]['unit_price'] = unit_price;
            obj[id]['price'] = this.roundToTwo(units * unit_price);

            this.UPDATE_APPRAISALINVOICE_LINES({
                appraisalinvoice_id: this.appraisalinvoice.id,
                object: obj
            }).then(function (res) {
                _this3.calc_total_base_price(_this3.object_to_array(obj));
                _this3.master_loading = false;
                _this3.editing_line = false;
                _this3.editing_line_text_color = 'black';
                _this3.editing_line_border_color = 'lightgray';
            });
        }, 0),
        calc_total_base_price: function calc_total_base_price(lines_array) {

            var partial = 0;
            var total_checked = 0;

            for (var i = 0; i < lines_array.length; i++) {

                partial = lines_array[i].price;
                total_checked = total_checked + partial;
            }
            console.log('invoice total base price: ');
            console.log(total_checked);
            this.SET_APPRAISALINVOICE_BASE_PRICE(total_checked);
            this.calc_final_price();
        },
        set_line_units: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e, f) {
            var _this4 = this;

            // this.master_loading = true
            this.editing_line = true;
            this.editing_line_text_color = 'whitesmoke';
            this.editing_line_border_color = 'whitesmoke';
            var value = e.target.value;
            if (!value) {
                value = 0;
            }
            var units = Number(value);
            var obj = this.appraisalinvoice_lines;
            var id = f['id'];
            obj[id]['units'] = units;

            var unit_price = obj[id]['unit_price'];
            if (!unit_price) {
                unit_price = 0;
            }
            obj[id]['price'] = this.roundToTwo(units * unit_price);

            this.UPDATE_APPRAISALINVOICE_LINES({
                appraisalinvoice_id: this.appraisalinvoice.id,
                object: obj
            }).then(function (res) {
                _this4.calc_total_base_price(_this4.object_to_array(obj));
                _this4.master_loading = false;
                _this4.editing_line = false;
                _this4.editing_line_text_color = 'black';
                _this4.editing_line_border_color = 'lightgray';
            });
        }, 0),

        set_line_price: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_LINE_PRICE(Number(e.target.value));
        }, 500),
        set_appraisalinvoice_bank_name: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALINVOICE_BANK_NAME(e.target.value);
        }, 500),
        set_appraisalinvoice_iban: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALINVOICE_IBAN(e.target.value);
        }, 500),
        set_appraisalinvoice_signature_name: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALINVOICE_SIGNATURE_NAME(e.target.value);
        }, 500),
        set_appraisalinvoice_signature_base64: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALINVOICE_SIGNATURE_BASE64(e.target.value);
        }, 500),
        set_appraisalinvoice_signature_date: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALINVOICE_SIGNATURE_DATE(e.target.value);
        }, 500),
        set_appraisalinvoice_is_signed: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            if (this.appraisalinvoice.is_signed) {
                var s = this.user.s ? this.user.s : null;
                var email = this.user.email ? this.user.email : '';
                var name = this.user.name + ' ' + this.user.surnames;
                var id = this.user.id ? this.user.id : null;
                //console.log(id)
                if (!id) {
                    alert('Manca uid. Contactar amb l\'administrador del l\'app.');
                }
                this.SET_APPRAISALINVOICE_SIGNATURE_BASE64(s);
                this.SET_APPRAISALINVOICE_SIGNATURE_NAME(name);
                this.SET_APPRAISALINVOICE_SIGNATURE_EMAIL(email);
                this.SET_APPRAISALINVOICE_SIGNATURE_UID(id);
                // unix seconds
                this.SET_APPRAISALINVOICE_SIGNATURE_DATE(__WEBPACK_IMPORTED_MODULE_3_moment___default()().format('X'));
                this.onSaveCurrentAppraisalInvoice({ go_up: false });
            } else {
                this.SET_APPRAISALINVOICE_SIGNATURE_BASE64(null);
                this.SET_APPRAISALINVOICE_SIGNATURE_NAME(null);
                this.SET_APPRAISALINVOICE_SIGNATURE_EMAIL(null);
                this.SET_APPRAISALINVOICE_SIGNATURE_UID(null);
                this.SET_APPRAISALINVOICE_SIGNATURE_DATE(null);
                this.onSaveCurrentAppraisalInvoice({ go_up: false });
            }
            this.$forceUpdate();
        }, 0),
        set_appraisalinvoice_signature_email: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALINVOICE_SIGNATURE_EMAIL(e.target.value);
        }, 500),
        set_appraisalinvoice_signature_uid: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALINVOICE_SIGNATURE_UID(e.target.value);
        }, 500),
        set_import_line: function set_import_line() {
            console.log('set_import_line');
            /*
            this.master_loading = true
            this.FETCH_TEMP_REALESTATE_MARKETSTUDIES({path: 'line_marketstudies' + '/' + this.marketstudy.importLine.id + '/'})
            .then(() => {
            this.master_loading = false
            })
            */
        },
        onCancelImportNewLine: function onCancelImportNewLine() {
            this.selecting_line = false;
        },
        onImportQuoteConcepts: function onImportQuoteConcepts() {
            var _this5 = this;

            var quote_id = this.appraisalinvoice.quote.id;
            console.log(quote_id);

            var obj = {};

            var intro_description_0 = '';
            var intro_description_1 = '';
            if (this.currentLocale === 'ca') {
                intro_description_0 = 'Valoració de ';
                intro_description_1 = 'ubicat a';
            } else if (this.currentLocale === 'en') {
                intro_description_0 = 'Valuation of ';
                intro_description_1 = 'situated in';
            } else {
                intro_description_0 = 'Valoración de ';
                intro_description_1 = 'ubicado en';
            }

            this.FETCH({
                path: 'appraisalquotes' + '/' + quote_id + '/',
                appraisalquote_id: quote_id
            }).then(function (res) {

                console.log('&%&%&%&% FETCH res: ');
                console.log(res);

                var realestates = res['realestates'];

                var discount_pct = res['discount_pct'];
                if (!discount_pct) {
                    discount_pct = 0;
                }
                var discount_notes = res['discount_notes'];

                if (!discount_notes) {
                    discount_notes = null;
                }

                if (!discount_pct) {
                    discount_pct = 0;
                }

                if (!realestates) {
                    realestates = null;
                }

                _this5.appraisalinvoice.discount_pct = discount_pct;
                _this5.appraisalinvoice.discount_notes = discount_notes;

                if (_this5.appraisalinvoice_lines) {
                    obj = _this5.appraisalinvoice_lines;
                }

                var tempCurrentLocale = function tempCurrentLocale() {
                    return _this5.currentLocale;
                };

                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(realestates, function (value) {
                    console.log('hop: ');
                    console.log(value);

                    var property_usage = '';
                    if (tempCurrentLocale() === 'ca') {
                        property_usage = value['property_type']['usage_type_ca'];
                    } else if (tempCurrentLocale() === 'en') {
                        property_usage = value['property_type']['usage_type_en'];
                    } else {
                        property_usage = value['property_type']['usage_type_es'];
                    }

                    if (tempCurrentLocale() === 'ca' && property_usage[0] === 'H' || property_usage[0] === 'A' || property_usage[0] === 'E' || property_usage[0] === 'I' || property_usage[0] === 'O' || property_usage[0] === 'U') {
                        intro_description_0 = 'Valoració d\'';
                    }

                    var id = value['id'];
                    obj[id] = {};
                    obj[id] = value;
                    obj[id]['description'] = intro_description_0 + property_usage.toLowerCase() + ' ' + intro_description_1 + ' ' + value['full_address'];
                    obj[id]['units'] = 1;
                    obj[id]['unit_price'] = value['quote_price_incl_travel_expenses'];
                    obj[id]['price'] = value['quote_price_incl_travel_expenses'];
                });

                _this5.UPDATE_APPRAISALINVOICE_LINES({
                    appraisalinvoice_id: _this5.appraisalinvoice.id,
                    object: obj
                }).then(function (res) {
                    _this5.calc_total_base_price(_this5.object_to_array(obj));
                    _this5.FETCH_APPRAISALINVOICE_LINES({ path: 'appraisalinvoices' + '/' + _this5.$route.query.id + '/' + 'lines' + '/' }).then(function () {
                        _this5.calc_final_price();
                        _this5.master_loading = false;
                    });
                });
            });
        },
        calc_final_price: function calc_final_price() {
            var final_price = 0;
            console.log('calculating final price (invoice) --->:');
            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(this.appraisalinvoice_lines, function (value) {
                console.log(value);
                final_price = final_price + value['price'];
            });

            console.log('this.appraisalinvoice.discount_pct: ');
            console.log(this.appraisalinvoice.discount_pct);

            var discount_coef = 1 - this.appraisalinvoice.discount_pct / 100;

            final_price = this.roundToTwo(final_price * discount_coef);
            console.log('final_price: ');
            console.log(final_price);
            this.SET_APPRAISALINVOICE_FINAL_PRICE(final_price);
        },
        onCreateNewLine: function onCreateNewLine() {
            var _this6 = this;

            this.selecting_line = false;
            this.master_loading = true;

            this.RESET_LINE().then(function (res) {
                _this6.CREATE_NEW_LINE({
                    invoice_id: _this6.appraisalinvoice.id,
                    file_id: _this6.appraisalfile.id,
                    file_number: _this6.appraisalfile.number,
                    invoice_number: _this6.appraisalinvoice.number,
                    invoice_version: _this6.appraisalinvoice.version,
                    path: 'lines' + '/',
                    parent_path: 'appraisalinvoices' + '/' + _this6.$route.query.id + '/' + 'lines' + '/'
                }).then(function (res) {
                    _this6.FETCH_APPRAISALINVOICE_LINES({ path: 'appraisalinvoices' + '/' + _this6.$route.query.id + '/' + 'lines' + '/' }).then(function () {
                        _this6.calc_final_price();
                        _this6.master_loading = false;
                    });
                });
            });
        },
        checkCreateNewLine: function checkCreateNewLine() {
            if (this.appraisalinvoice.dirty) {
                var result = window.confirm(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('There_are_unsaved_changes') + '. ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Unsaved_data_will_be_lost') + '. ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Continue_q'));
                if (result) {
                    this.onCreateNewLine();
                }
            } else {
                this.onCreateNewLine();
            }
        },
        set_appraisalinvoice_line_appraisal_id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e, line_id) {
            var _this7 = this;

            this.SET_APPRAISALINVOICE_LINE_APPRAISAL_ID({
                path: 'appraisalinvoices' + '/' + this.$route.query.id + '/' + 'lines' + '/' + line_id + '/' + 'appraisal_id',
                value: e
            }).then(function (res) {
                _this7.$forceUpdate();
            });
        }, 1000),
        set_appraisalinvoice_petitioner_tin: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this8 = this;

            var tin = '';
            if (e.target.value) {
                tin = e.target.value;
            }
            console.log('the tin: ');
            console.log(tin);
            this.SET_VALUE({
                path: 'appraisalinvoices' + '/' + this.$route.query.id + '/' + 'petitioner' + '/' + 'tin' + '/',
                object: tin
            }).then(function (res) {

                _this8.SET_VALUE({
                    path: 'contacts' + '/' + _this8.appraisalinvoice.petitioner.id + '/' + 'tin' + '/',
                    object: tin
                }).then(function (res) {});
            });
        }, 1000),
        onAddNewPetitioner: function onAddNewPetitioner() {
            var _this9 = this;

            this.master_loading = true;

            var filenumber = '';
            filenumber = this.appraisalfile.number;

            var s = this.appraisalinvoice.number + '';
            while (s.length < 2) {
                s = '0' + s;
            }var invoicenumber = s;

            var p = this.appraisalinvoice.version + '';
            while (p.length < 2) {
                p = '0' + p;
            }var invoiceversion = p;

            var obj = {};

            if (this.appraisalinvoice_petitioners) {
                obj = this.appraisalinvoice_petitioners;
            }

            var parent_obj = {};

            parent_obj['full_number'] = filenumber + '/' + invoicenumber + '/' + invoiceversion;
            parent_obj['invoicedate'] = this.appraisalinvoice.invoicedate;
            parent_obj['id'] = this.appraisalinvoice.id;

            // console.log('heypppppppp')
            // console.log(obj)

            var contact_id = this.appraisalinvoice.petitioner.id;
            obj[contact_id] = this.appraisalinvoice.petitioner;

            this.SET_VALUE({
                object: obj,
                path: 'appraisalinvoices' + '/' + this.$route.query.id + '/' + 'petitioners'
            }).then(function (res) {

                _this9.SET_VALUE({
                    object: parent_obj,
                    path: 'contacts' + '/' + contact_id + '/' + 'appraisalinvoices' + '/' + _this9.$route.query.id
                }).then(function (res) {

                    _this9.FETCH_APPRAISALINVOICE_PETITIONERS({
                        path: 'appraisalinvoices' + '/' + _this9.$route.query.id + '/' + 'petitioners',
                        appraisalinvoice_id: _this9.$route.query.id
                    }).then(function () {
                        _this9.master_loading = false;
                    });
                });
            });
        },
        onAddNewContact: function onAddNewContact() {
            var _this10 = this;

            this.RESET_CONTACT().then(function (res) {
                _this10.creating_contact = true;
            });
        },
        onCreateNewContact: function onCreateNewContact() {
            var _this11 = this;

            // vigilar, que no es guarda la id, date_created, path
            // al crear contacte d'empreses --> title amb gender neutral?

            var obj_copy = JSON.parse(JSON.stringify(this.contact));
            console.log('!!! --->');
            console.log(obj_copy);

            this.creating_contact = false;
            this.master_loading = true;

            this.CREATE_NEW_CONTACT({ path: 'contacts', creating_from_main: false }).then(function (res) {

                obj_copy['id'] = _this11.contact.id;
                obj_copy['date_created'] = _this11.contact.date_created;
                obj_copy['path'] = _this11.contact.path;

                _this11.UPDATE_CONTACT({
                    object: obj_copy,
                    path: 'contacts' + '/' + res.key
                }).then(function (res) {
                    _this11.FETCH_CONTACTS({ path: 'contacts' + '/' }).then(function () {
                        _this11.SET_APPRAISALINVOICE_PETITIONER(_this11.contact);
                        _this11.master_loading = false;
                    });
                });
            });
        },
        onCancelCreateNewContact: function onCancelCreateNewContact() {
            this.creating_contact = false;
        },
        numFormat: function numFormat(value, symbol) {
            if (!value || value === 0 || value === '' || value === '-') {
                return '-';
            } else {
                return numeral(value).format('0,0.00') + ' ' + symbol;
            }
        },
        intFormat: function intFormat(value, symbol) {
            if (!value || value === 0 || value === '' || value === '-') {
                return '-';
            } else {
                return numeral(value).format('0,0') + ' ' + symbol;
            }
        },
        onCreatePdf: function onCreatePdf(data) {
            var _this12 = this;

            this.master_loading = true;

            // guardar automàticament
            this.onSaveCurrentAppraisalInvoice({ go_up: false });

            // TODO: comprovar que totes les appraisals incloses en el appraisalinvoice tinguin la mateixa finalitat declarada, sinó fer apareixèr un warning message

            var lines = [];
            var appraisals = [];
            var marketstudies = [];

            var tempNumFormat = function tempNumFormat(value, symbol) {
                return _this12.numFormat(value, symbol);
            };

            var tempIntFormat = function tempIntFormat(value, symbol) {
                return _this12.intFormat(value, symbol);
            };

            var tempCurrentLocale = function tempCurrentLocale() {
                return _this12.currentLocale;
            };

            var fetchAppraisal = function fetchAppraisal(data) {
                return new Promise(function (resolve, reject) {
                    _this12.$store.dispatch('FETCH_APPRAISAL', data).then(function (res) {
                        appraisals.push(res);
                        resolve(res);
                    });
                });
            };

            var fetchLine = function fetchLine(data) {
                return new Promise(function (resolve, reject) {
                    _this12.$store.dispatch('FETCH_REALESTATE', data).then(function (res) {
                        console.log('fetching line...');
                        lines.push(res);
                        resolve(res);
                    });
                });
            };

            var database_fetch = function database_fetch(data) {
                return new Promise(function (resolve, reject) {
                    _this12.$store.dispatch('FETCH', data).then(function (res) {
                        console.log('fetching...');
                        lines.push(res);
                        resolve(res);
                    });
                });
            };

            var canvas_to_data_url = function canvas_to_data_url(data) {
                return new Promise(function (resolve, reject) {

                    // fetch from the WHATWG fetch api:
                    var toDataURL = function toDataURL(url) {
                        return fetch(url).then(function (response) {
                            return response.blob();
                        }).then(function (blob) {
                            return new Promise(function (resolve, reject) {
                                var reader = new FileReader();
                                reader.onloadend = function () {
                                    return resolve(reader.result);
                                };
                                reader.onerror = reject;
                                reader.readAsDataURL(blob);
                            });
                        });
                    };

                    toDataURL(data.src).then(function (dataUrl) {
                        // console.log('RESULT:', dataUrl)
                        resolve({ data_url: dataUrl, footer: data.footer, is_cover_photo: data.is_cover_photo });
                    });
                });
            };

            var google_canvas_to_data_url = function google_canvas_to_data_url(data) {
                console.log('google_canvas_to_data_url data!: ');
                console.log(data);
                return new Promise(function (resolve, reject) {

                    // fetch from the WHATWG fetch api:
                    var toDataURL = function toDataURL(url) {
                        return fetch(url).then(function (response) {
                            return response.blob();
                        }).then(function (blob) {
                            return new Promise(function (resolve, reject) {
                                var reader = new FileReader();
                                reader.onloadend = function () {
                                    return resolve(reader.result);
                                };
                                reader.onerror = reject;
                                reader.readAsDataURL(blob);
                            });
                        });
                    };

                    if (data.src) {
                        toDataURL(data.src).then(function (dataUrl) {
                            // console.log('RESULT:', dataUrl)
                            resolve({ data_url: dataUrl, footer: data.footer });
                        });
                    } else {

                        resolve();
                    }
                });
            };

            // address_table portada
            var address_table = [];

            // taula identificació i localització
            var appraised_id_table = [];

            // layour d'elements
            var elements_layout = {};

            var appraisal_review_table = [];
            var line_review_table = [];
            var comparable_review_table = [];
            var marketstudy_review_table = [];
            var appraisalfile_review_table = [];
            var appraisalinvoice_review_table = [];

            // variables

            var property_type = '';
            var address_street_name = '';
            var address_number = '';
            var address_floor = '';
            var address_door = '';
            var address_block = '';
            var address_staircase = '';
            var address_postal_code = '';
            var address_postal_code_only = '';
            var address_municipality = '';
            var address_province = '';
            var address_long = '';
            var address_short = '';
            var cad_ref = '';
            var reg_est_num = '';
            var purpose_notes = '';
            var appraisaldate = '';
            var invoicedate = '';
            var filenumber = '';
            var invoicenumber = '';
            var invoiceversion = '';
            var petitioner = '';
            var petitioner_type = '';
            var mandatary = '';
            var appraisal_purpose = '';
            var acc_mortgage_market_law = '';
            var acc_eco_decree = '';
            var appraiser = '';
            var appraiser_name = '';
            var appraiser_surnames = '';
            var appraiser_pa_number = '';
            var supervisor = '';
            var supervisor_name = '';
            var supervisor_surnames = '';
            var supervisor_pa_number = '';
            var technician_visiting = '';

            var full_number = this.appraisalinvoice.full_number;

            var total_invoice_fees_without_vat = 0;
            var invoice_vat = 0;
            var total_invoice_fees_incl_vat = 0;

            lines = this.appraisalinvoice_lines;
            console.log('lines: ');
            console.log(lines);

            // console.log('map result: ')
            // console.log(result)

            // console.log('result.length: ')
            // console.log(result.length)

            var docDefinition = {
                // settings
                pageSize: 'A4',
                pageOrientation: 'portrait',
                // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
                pageMargins: [40, 45, 20, 20],
                // metadata
                info: {
                    title: 'BARNA-TASA, S.A.',
                    author: 'BARNA-TASA, S.A.',
                    subject: 'BARNA-TASA, S.A.',
                    keywords: 'BARNA-TASA, S.A.',
                    creator: 'BARNA-TASA, S.A.',
                    producer: 'BARNA-TASA, S.A.'
                },
                styles: {
                    header_small: {
                        fontSize: 8,
                        bold: false
                    },
                    header_title: {
                        fontSize: 12,
                        bold: true
                    },
                    small: {
                        fontSize: 8,
                        bold: false
                    },
                    small_bold: {
                        fontSize: 8,
                        bold: true
                    },
                    small_bold_center: {
                        fontSize: 8,
                        bold: true,
                        alignment: 'center'
                    },
                    plain: {
                        fontSize: 9,
                        bold: false
                    },
                    plain_blue: {
                        fontSize: 9,
                        color: '#1a3856',
                        bold: false
                    },
                    plain_blue_bold: {
                        fontSize: 9,
                        color: '#1a3856',
                        bold: true
                    },
                    plain_green_bold: {
                        fontSize: 9,
                        color: '#009900',
                        bold: true
                    },
                    plain_bold: {
                        fontSize: 9,
                        bold: true
                    },
                    plain_bold_center: {
                        fontSize: 9,
                        bold: true,
                        alignment: 'center'
                    },
                    plain_bold_left: {
                        fontSize: 9,
                        bold: true,
                        alignment: 'left'
                    },
                    plain_bold_right: {
                        fontSize: 9,
                        bold: true,
                        alignment: 'right'
                    },
                    cover_brand: {
                        fontSize: 32,
                        color: '#1a3856',
                        bold: true
                    },
                    cover_title: {
                        fontSize: 20,
                        color: '#1a3856',
                        bold: true,
                        alignment: 'center'
                    },
                    cover_subtitle: {
                        fontSize: 14,
                        color: '#1a3856',
                        bold: true,
                        alignment: 'center'
                    },
                    cover_header: {
                        fontSize: 12,
                        color: '#1a3856',
                        bold: true,
                        alignment: 'center'
                    },
                    h1: {
                        fontSize: 18,
                        bold: true
                    },
                    h2: {
                        fontSize: 16,
                        bold: true
                    },
                    h2_center: {
                        fontSize: 16,
                        bold: true,
                        alignment: 'center'
                    },
                    h3: {
                        fontSize: 12,
                        bold: true

                    },
                    h3_blue: {
                        fontSize: 12,
                        bold: true,
                        color: '#1a3856'
                    },
                    h3_lightblue: {
                        fontSize: 12,
                        bold: true,
                        color: '#0088f7'
                    },
                    h4: {
                        fontSize: 11,
                        bold: true
                    },
                    h5: {
                        fontSize: 10,
                        bold: true
                    },
                    h5_underline: {
                        fontSize: 10,
                        decoration: 'underline',
                        bold: true
                    },
                    h6: {
                        fontSize: 9,
                        bold: true
                    }
                },
                //header & footer
                header: function header(currentPage, pageCount, pageSize) {
                    // apply any logic and return any valid pdfmake element
                    return [{
                        text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Barnatasa_header'),
                        // alignment: (currentPage % 2) ? 'left' : 'right'
                        alignment: 'center',
                        margin: [0, 10],
                        style: 'header_small'
                    }, {
                        columns: [{
                            width: 200,
                            border: [false, false, false, true],
                            text: 'BARNA-TASA, S.A.',
                            style: 'header_title_blue',
                            alignment: 'left',
                            margin: [40, 0]

                        }, {
                            width: '*',
                            border: [false, false, false, true],
                            text: 'EXP. ' + full_number,
                            style: 'plain_blue',
                            alignment: 'right',
                            margin: [40, 0]

                        }]
                    }];
                },
                footer: function footer(currentPage, pageCount, pageSize) {
                    // apply any logic and return any valid pdfmake element
                    return [{
                        layout: 'noBorders',
                        margin: [30, 0, 30, 30],
                        table: {
                            headerRows: 0,
                            widths: ['*', 20],
                            body: [[{
                                border: [false, false, false, false],
                                //fillColor: 'whitesmoke',
                                text: 'Carrer de Còrsega, 168, 1º 1ª, 08036, Barcelona | NIF: A60840543 | tel. (+34) 93 410 05 32 | info@barnatasa.com ',
                                style: 'plain_bold',
                                alignment: 'center'
                            }, {
                                text: currentPage + ' / ' + pageCount,
                                //fillColor: 'whitesmoke',
                                style: 'plain',
                                alignment: 'right'

                            }]]
                        }
                    }];
                },
                // content
                content: []

                // expedient
            };filenumber = '';
            if (this.appraisalfile.number) {
                filenumber = this.appraisalfile.number;
            } else {

                appraisalfile_review_table.push([{
                    text: '',
                    style: 'plain_bold'
                }, {
                    text: 'Manca introduir el número d\'expedient.',
                    style: 'plain',
                    alignment: 'left'
                }]);
            }

            // invoicenumber
            invoicenumber = '';
            if (this.appraisalinvoice.number) {
                // pad, zero fill ->2
                var s = this.appraisalinvoice.number + '';
                while (s.length < 2) {
                    s = '0' + s;
                }invoicenumber = s;
            } else {
                appraisalinvoice_review_table.push([{
                    text: this.appraisalinvoice.id,
                    style: 'plain_bold'
                }, {
                    text: 'Manca introduir el número de factura.',
                    style: 'plain',
                    alignment: 'left'
                }]);
            }

            // invoiceversion
            invoiceversion = '';
            if (this.appraisalinvoice.version) {
                // pad, zero fill ->2
                var _s = this.appraisalinvoice.version + '';
                while (_s.length < 2) {
                    _s = '0' + _s;
                }invoiceversion = _s;
            } else {
                appraisalinvoice_review_table.push([{
                    text: this.appraisalinvoice.id,
                    style: 'plain_bold'
                }, {
                    text: 'Manca introduir la versió de la factura.',
                    style: 'plain',
                    alignment: 'left'
                }]);
            }

            docDefinition.content.push({
                text: '',
                margin: [0, 8]
            }, {
                image: 'data:image/png;base64,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',
                width: 100,
                //margin: [0, 0],
                alignment: 'left'
            }, {
                text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Invoice'),
                margin: [10, 8],
                style: 'h1',
                alignment: 'right'
            }, {
                text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Emmission_date') + ':  ' + __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('DD/MM/YYYY'),
                margin: [10, 4],
                style: 'plain_bold',
                alignment: 'right'
            }, {
                text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Invoice_number') + ':  ' + this.appraisalinvoice.fiscal_number,
                margin: [10, 4],
                style: 'plain_bold',
                alignment: 'right'
            }, {
                text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Reference') + ':  ' + this.appraisalinvoice.full_number,
                margin: [10, 4],
                style: 'plain_bold',
                alignment: 'right'
            }, {
                text: '',
                margin: [0, 8],
                style: 'plain'
            });

            var petitioners_arr = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(this.appraisalinvoice_petitioners);

            petitioners_arr = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(petitioners_arr, 'surnames');

            var currentLocale = this.currentLocale;

            var columns = [];

            counter = 0;

            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(petitioners_arr, function (value, index) {
                //counter = counter + 1;
                //console.log('---> counter: ')
                //console.log(counter)
                console.log(index);

                var name = value['name'] ? value['name'] : '';
                var surnames = value['surnames'] ? value['surnames'] : '';
                // let address = value['full_address
                var address = value['complete_fiscal_address'] ? value['complete_fiscal_address'] : '';
                var tin = value['tin'] ? value['tin'] : '';
                var email = value['main_email'] ? value['main_email'] : '';

                var petitioner_name = name + ' ' + surnames;

                columns.push({
                    layout: 'noBorders',
                    table: {

                        headerRows: 1,
                        widths: [160],
                        margin: [0, 8],
                        body: [[{
                            text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Invoice_to') + ': ',
                            style: 'plain_bold'
                        }], [{
                            text: petitioner_name,
                            style: 'plain'
                        }], [{
                            text: 'NIF: ' + tin,
                            style: 'plain'
                        }], [{
                            text: address,
                            style: 'plain'
                        }], [{
                            text: email,
                            style: 'plain'
                        }]]
                    }
                });

                if (index >= __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(petitioners_arr) - 1) {
                    console.log('about to push column');
                    columns.push({
                        layout: 'noBorders',
                        table: {

                            headerRows: 1,
                            widths: [160],
                            margin: [0, 8],
                            body: [[{
                                text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Emited_by') + ': ',
                                style: 'plain_bold'
                            }], [{
                                text: 'BARNA-TASA, S.A.',
                                style: 'plain'
                            }], [{
                                text: 'NIF: A60840543',
                                style: 'plain'
                            }], [{
                                text: 'Carrer de Còrsega, 168, 1-1, 08036 - Barcelona',
                                style: 'plain'
                            }], [{
                                text: 'info@barnatasa.com',
                                style: 'plain'
                            }]]
                        }
                    });
                }

                // petitioners_emails = petitioners_emails + email
            });

            docDefinition.content.push({
                columns: columns
            }, {
                text: '',
                margin: [0, 20]
            });

            var line_table = {
                layout: 'hLineWidth',
                table: {

                    headerRows: 1,
                    widths: [320, 120, 60],
                    margin: [0, 8],
                    body: [[{
                        text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Concept'),
                        style: 'plain_bold',
                        border: [false, false, false, true]
                    }, {
                        text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cadastral_reference'),
                        style: 'plain_bold',
                        border: [false, false, false, true]
                    }, {
                        text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Amount_money'),
                        style: 'plain_bold',
                        border: [false, false, false, true]
                    }]]
                }

            };

            var counter = 0;

            var endlineborder = [false, true, false, false];
            var noborder = [false, false, false, false];
            var linessize = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(this.appraisalinvoice_lines);

            var fprice = this.appraisalinvoice.final_price;

            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(this.appraisalinvoice_lines, function (value) {
                counter = +1;

                var border = noborder;
                if (counter > linessize - 1) {
                    border = endlineborder;
                }

                console.log('**** --- >');
                console.log(value);

                var type = '';
                if (value.property_type) {
                    if (tempCurrentLocale() === 'ca') {
                        type = value.property_type.usage_type_ca;
                    } else if (tempCurrentLocale() === 'en') {
                        type = value.property_type.usage_type_en;
                    } else {
                        type = value.property_type.usage_type_es;
                    }
                } else {

                    line_review_table.push([{
                        text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Line') + ' nº ' + (counter + 1).toString(),
                        style: 'plain_bold'
                    }, {
                        text: 'Manca introduir el tipus d\'immoble',
                        style: 'plain',
                        alignment: 'left'
                    }]);
                }

                var desc = value.description ? value.description : ' ';
                var cadref = value.cadastral_reference ? value.cadastral_reference : ' ';
                var qprice = value.quote_price_incl_travel_expenses ? tempNumFormat(value.quote_price_incl_travel_expenses, '€') : fprice ? fprice : ' ';

                line_table['table']['body'].push(
                //// PAGE-BREAK
                [{
                    text: '- ' + desc,
                    style: 'plain',
                    border: border
                }, {
                    text: cadref,
                    style: 'plain',
                    border: border
                }, {
                    text: qprice,
                    style: 'plain',
                    border: border
                }]);

                total_invoice_fees_without_vat = value.quote_price_incl_travel_expenses ? total_invoice_fees_without_vat + value.quote_price_incl_travel_expenses : fprice ? fprice : ' ';
            });

            docDefinition.content.push(
            //// PAGE-BREAK
            line_table);

            // final_price includes the discount, but not yet the VAT
            var final_price = 0;
            if (this.appraisalinvoice.final_price) {
                final_price = this.appraisalinvoice.final_price;
            }

            invoice_vat = this.roundToTwo(final_price * (this.appraisalinvoice.vat_pct / 100));

            total_invoice_fees_incl_vat = final_price + invoice_vat;

            docDefinition.content.push({
                text: '',
                margin: [0, 10]
            }, {
                text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Fees') + ': ' + this.numFormat(total_invoice_fees_without_vat, '€'),
                margin: [15, 4],
                style: 'plain_bold',
                alignment: 'right'
            });
            if (this.appraisalinvoice.discount_pct && this.appraisalinvoice.discount_pct > 0) {
                docDefinition.content.push({
                    text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Discount') + '* (' + this.appraisalinvoice.discount_pct + '%): ' + this.numFormat(final_price - total_invoice_fees_without_vat, '€'),
                    margin: [15, 4],
                    style: 'plain_green_bold',
                    alignment: 'right'
                }, {
                    text: '',
                    margin: [15, 4]
                }, {
                    text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Fees_incl_discount') + ': ' + this.numFormat(final_price, '€'),
                    margin: [15, 4],
                    style: 'plain_bold',
                    alignment: 'right'
                });
            }

            docDefinition.content.push({
                text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('VAT') + ' (' + this.appraisalinvoice.vat_pct + '%): ' + this.numFormat(invoice_vat, '€'),
                margin: [15, 4],
                style: 'plain_bold',
                alignment: 'right'
            }, {
                text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Invoice_Total') + ': ' + this.numFormat(total_invoice_fees_incl_vat, '€'),
                margin: [15, 12],
                style: 'h3_blue',
                alignment: 'right'
            }, {
                text: '',
                margin: [15, 10]
            });

            if (this.appraisalinvoice.discount_pct && this.appraisalinvoice.discount_pct > 0 && this.appraisalinvoice.discount_notes) {
                docDefinition.content.push({
                    text: '* ' + this.appraisalinvoice.discount_notes,
                    margin: [15, 4],
                    style: 'plain',
                    alignment: 'left'
                }, {
                    text: '',
                    margin: [15, 4]
                });
            }

            var s_name = this.appraisalinvoice.signature_name ? this.appraisalinvoice.signature_name : '';

            docDefinition.content.push({
                image: this.appraisalinvoice.signature_base64 ? this.appraisalinvoice.signature_base64 : 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAIBAQIBAQICAgICAgICAwUDAwMDAwYEBAMFBwYHBwcGBwcICQsJCAgKCAcHCg0KCgsMDAwMBwkODw0MDgsMDAz/2wBDAQICAgMDAwYDAwYMCAcIDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAz/wAARCAABAAEDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD9/KKKKAP/2Q==',
                width: 164,
                margin: [0, 0]
            }, {
                text: s_name,
                margin: [0, 0],
                style: 'plain'
            }, {
                text: 'BARNA-TASA, S.A.',
                margin: [0, 0],
                style: 'plain_bold'
            }, {
                text: '',
                margin: [0, 10]
            }, {
                text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quote_sentence_03') + ' (' + this.appraisalinvoice.bank_name + '): ',
                margin: [0, 4],
                style: 'plain'
            }, {
                text: 'IBAN ' + this.appraisalinvoice.iban,
                margin: [0, 4],
                style: 'plain_bold'
            });

            //////// Check empty review tables

            var no_error_text = 'Sense errors detectats.';

            if (line_review_table.length === 0) {

                line_review_table = [[{
                    text: no_error_text,
                    style: 'plain'
                }]];
            }

            if (comparable_review_table.length === 0) {

                comparable_review_table = [[{
                    text: no_error_text,
                    style: 'plain'
                }]];
            }

            if (marketstudy_review_table.length === 0) {

                marketstudy_review_table = [[{
                    text: no_error_text,
                    style: 'plain'
                }]];
            }

            if (appraisal_review_table.length === 0) {

                appraisal_review_table = [[{
                    text: no_error_text,
                    style: 'plain'
                }]];
            }

            if (appraisalfile_review_table.length === 0) {

                appraisalfile_review_table = [[{
                    text: no_error_text,
                    style: 'plain'
                }]];
            }

            if (appraisalinvoice_review_table.length === 0) {

                appraisalinvoice_review_table = [[{
                    text: no_error_text,
                    style: 'plain'
                }]];
            }

            //////// End of check empty review tables

            var reviewDocDefinition = {
                // settings
                pageSize: 'A4',
                pageOrientation: 'portrait',
                // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
                pageMargins: [40, 60, 20, 20],
                // metadata
                info: {
                    title: 'BARNA-TASA, S.A.',
                    author: 'BARNA-TASA, S.A.',
                    subject: 'BARNA-TASA, S.A.',
                    keywords: 'BARNA-TASA, S.A.',
                    creator: 'BARNA-TASA, S.A.',
                    producer: 'BARNA-TASA, S.A.'
                },
                styles: {
                    small: {
                        fontSize: 8,
                        bold: false
                    },
                    small_bold: {
                        fontSize: 8,
                        bold: true
                    },
                    plain: {
                        fontSize: 9,
                        bold: false
                    },
                    plain_bold: {
                        fontSize: 9,
                        bold: true
                    },
                    h2: {
                        fontSize: 16,
                        bold: true
                    },
                    h3: {
                        fontSize: 12,
                        bold: true
                    }
                },
                // content
                content: [{
                    text: 'Informe automàtic de revisió de Factura ' + full_number,
                    style: 'h2'
                }, {
                    text: '',
                    margin: [0, 15]
                },
                //// END OF BLOCK
                //// BLOCK START
                {
                    text: '',
                    margin: [0, 10]
                }, {
                    text: 'Expedient:',
                    style: 'h3'
                }, {
                    text: '',
                    margin: [0, 5]
                }, {
                    layout: 'noBorders',
                    margin: [50, 0],
                    table: {

                        headerRows: 0,
                        widths: [160, '*'],
                        body: appraisalfile_review_table
                    }
                },
                //// END OF BLOCK
                //// BLOCK START
                {
                    text: '',
                    margin: [0, 10]
                }, {
                    text: 'Factura:',
                    style: 'h3'
                }, {
                    text: '',
                    margin: [0, 5]
                }, {
                    layout: 'noBorders',
                    margin: [50, 0],
                    table: {

                        headerRows: 0,
                        widths: [160, '*'],
                        body: appraisalinvoice_review_table
                    }
                },
                //// END OF BLOCK
                //// BLOCK START
                {
                    text: '',
                    margin: [0, 10]
                }, {
                    text: 'Línies de factura:',
                    style: 'h3'
                }, {
                    text: '',
                    margin: [0, 5]
                }, {
                    layout: 'noBorders',
                    margin: [50, 0],
                    table: {

                        headerRows: 0,
                        widths: [160, '*'],
                        body: line_review_table
                    }
                }]
            };

            pdfMake.createPdf(docDefinition).open();
            pdfMake.createPdf(reviewDocDefinition).open();
            // pdfMake.createPdf(docDefinition).download()
            console.log('yeah finished!');
            this.master_loading = false;
        },
        onSaveCurrentAppraisalInvoice: function onSaveCurrentAppraisalInvoice(data) {
            var _this13 = this;

            this.UPDATE_APPRAISALINVOICE({
                object: this.appraisalinvoice,
                path: this.appraisalinvoice.path,
                parent_path: this.appraisalinvoice.parent_path,
                key: this.appraisalinvoice.id
            }).then(function (res) {
                // router.go(-1)
                if (data.go_up) {
                    _this13.onGoUp();
                }
            });
        },

        editLine: function editLine(entity) {
            var _this14 = this;

            // console.log('edit line...')
            this.SET_LINE({ path: 'lines' + '/' + entity.id + '/' }).then(function (res) {
                _this14.$router.push({ name: 'line-editor', query: { id: entity.id } });
            });
        },

        deleteLine: function deleteLine(entity) {
            var _this15 = this;

            var result = window.confirm(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('You_are_about_to_delete') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('line') + '. ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Continue_q'));

            if (result) {

                this.DELETE_LINE({
                    path: 'lines' + '/' + entity.id,
                    key: entity.id,
                    parent_path: 'appraisalinvoices' + '/' + this.appraisalinvoice.id + '/' + 'lines' + '/' + entity.id
                }).then(function (res) {
                    //
                    _this15.master_loading = true;
                    _this15.FETCH_APPRAISALINVOICE_LINES({ path: 'appraisalinvoices' + '/' + _this15.$route.query.id + '/' + 'lines' + '/' }).then(function () {
                        _this15.calc_final_price();
                        _this15.master_loading = false;
                    });
                });
            }
        },

        editContact: function editContact(entity) {
            var _this16 = this;

            // console.log('edit realestate...')
            this.SET_CONTACT({ path: 'contacts' + '/' + entity.id + '/' }).then(function (res) {
                _this16.$router.push({ name: 'contact-editor', query: { id: entity.id } });
            });
        },
        discardPetitioner: function discardPetitioner(entity) {
            var _this17 = this;

            this.master_loading = true;

            this.DELETE({
                path: 'appraisalinvoices' + '/' + this.appraisalinvoice.id + '/' + 'petitioners' + '/' + entity.id,
                key: entity.id
            }).then(function (res) {

                _this17.DELETE({
                    path: 'contacts' + '/' + entity.id + '/' + 'appraisalinvoices' + '/' + _this17.appraisalinvoice.id,
                    key: entity.id
                }).then(function (res) {

                    _this17.FETCH_APPRAISALINVOICE_PETITIONERS({ path: 'appraisalinvoices' + '/' + _this17.$route.query.id + '/' + 'petitioners' + '/' }).then(function () {
                        _this17.master_loading = false;
                    });
                });
            });
        },
        onGoBack: function onGoBack() {
            __WEBPACK_IMPORTED_MODULE_11__router_index_js__["a" /* default */].go(-1);
        },

        onGoUp: function onGoUp() {
            this.$router.push({ name: 'appraisalfile-editor', query: { id: this.appraisalinvoice.file_id } });
        }
    }),
    head: {
        title: {
            inner: 'Edit appraisalinvoice'
        }
    }

});

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ContactsSearch_Index_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ContactsSearch_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_ContactsSearch_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_SideNavBar_Index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_SideNavBar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_SideNavBar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Datatable_datatable_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Datatable_datatable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Datatable_datatable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_column_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_column_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_column_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__aggregators_aggregators_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__formatters_formatters_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Toggles_checkbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Toggles_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_Toggles_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Paginator_paginator_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Paginator_paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Paginator_paginator_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'appraisalinvoices-index',

    mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins__["a" /* localStorageMixin */]],

    data: function data() {
        return {
            master_loading: true,
            invoicesOpen: true,
            filter_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type_here_to_filter_paginated_data'),
            new_appraisalinvoice_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_appraisal_invoice'),
            appraisalinvoice_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [{
                    id: 'fiscal_number',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Invoice_fiscal_number'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'full_number',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Version'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'date_modified',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Last_modified'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format('DD/MM/YYYY HH:mm:ss');
                    }
                }],
                selected: []
            }

        };
    },

    created: function created() {
        var _this = this;

        this.FETCH_APPRAISALINVOICES().then(function () {
            _this.master_loading = false;
        });
    },


    components: {
        Bar: __WEBPACK_IMPORTED_MODULE_9__components_Bar_Index_vue___default.a,
        Checkbox: __WEBPACK_IMPORTED_MODULE_16__components_Toggles_checkbox_vue___default.a,
        Datatable: __WEBPACK_IMPORTED_MODULE_12__components_Datatable_datatable_vue___default.a,
        DatatableColumn: __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_column_vue___default.a,
        IconButton: __WEBPACK_IMPORTED_MODULE_10__components_IconButton_Index_vue___default.a,
        Paginator: __WEBPACK_IMPORTED_MODULE_17__components_Paginator_paginator_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_6__components_Spinner_vue___default.a,
        SideNavBar: __WEBPACK_IMPORTED_MODULE_11__components_SideNavBar_Index_vue___default.a
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['appraisalinvoices', 'theme'])),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['CREATE_NEW_APPRAISALINVOICE', 'DELETE_APPRAISALINVOICE', 'EDIT_APPRAISALINVOICE', 'FETCH_APPRAISALINVOICES', 'SET_APPRAISALINVOICE', 'SET_APPRAISALFILE']), {
        onCreateNewAppraisalInvoice: function onCreateNewAppraisalInvoice() {
            var _this2 = this;

            this.master_loading = true;

            var appraisalinvoices_size = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(this.appraisalinvoices);

            var new_invoicenumber = 1;

            if (appraisalinvoices_size > 0) {

                var invoicenumbers = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.reverse(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(this.appraisalinvoices, 'number'));
                new_invoicenumber = invoicenumbers[0] + 1;
                console.log('map invoicenumbers: ');
                console.log(invoicenumbers);
            }
            this.CREATE_NEW_APPRAISALINVOICE({
                path: 'appraisalinvoices',
                number: new_invoicenumber,
                size: appraisalinvoices_size
            }).then(function (res) {
                _this2.$router.push({ name: 'appraisalinvoice-editor' });
            });
        },
        appraisalinvoices_to_array: function appraisalinvoices_to_array(object) {
            return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(object);
        },
        editAppraisalInvoice: function editAppraisalInvoice(entity) {
            var _this3 = this;

            console.log('edit...');
            this.SET_APPRAISALFILE({ path: 'appraisalfiles' + '/' + entity.file_id }).then(function (res) {
                _this3.SET_APPRAISALINVOICE({ path: 'appraisalinvoices' + '/' + entity.id }).then(function (res) {
                    _this3.$router.push({
                        name: 'appraisalinvoice-editor',
                        query: { id: entity.id, file_id: entity.file_id }
                    });
                });
            });
        },
        deleteAppraisalInvoice: function deleteAppraisalInvoice(entity) {
            var _this4 = this;

            var result = window.confirm(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('You_are_about_to_delete') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('invoice') + ' "' + entity.number + '". ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Continue_q'));

            if (result) {

                this.DELETE_APPRAISALINVOICE({
                    path: 'appraisalinvoices' + '/' + entity.id,
                    key: entity.id,
                    appraisalreports: entity.appraisalreports
                }).then(function (res) {
                    //
                    _this4.master_loading = true;
                    _this4.FETCH_APPRAISALINVOICES().then(function () {
                        _this4.master_loading = false;
                    });
                });
            }
        },
        goToInvoice: function goToInvoice(key, file_id) {
            var _this5 = this;

            this.SET_APPRAISALFILE({ path: 'appraisalfiles' + '/' + file_id }).then(function (res) {
                _this5.SET_APPRAISALINVOICE({ path: 'appraisalinvoices' + '/' + key }).then(function (res) {
                    _this5.$router.push({ name: 'appraisalinvoice-editor', query: { id: key, file_id: file_id } });
                });
            });
        }
    }),
    head: {
        title: {
            inner: 'Appraisal-Invoices Index'
        }
    }

});

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__router_index_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__options_petitioner_types__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__options_status_quotes__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__options_honorific_titles__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__options_person_types__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__options_requireddocs__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__options_appraisal_purposes__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Datatable_datatable_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Datatable_datatable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_Datatable_datatable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Datatable_datatable_column_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Datatable_datatable_column_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_Datatable_datatable_column_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__aggregators_aggregators_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__formatters_formatters_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Toggles_checkbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Toggles_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_Toggles_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Paginator_paginator_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Paginator_paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_Paginator_paginator_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//































var numeral = __webpack_require__(119);

var _require = __webpack_require__(40),
    map = _require.map;

var _require2 = __webpack_require__(40),
    forEach = _require2.forEach;

var pdfMake = __webpack_require__(211);
var pdfFonts = __webpack_require__(212);
pdfMake.vfs = pdfFonts.pdfMake.vfs;

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'appraisalquote-editor',

    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins__["d" /* dateMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["a" /* localStorageMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["f" /* mathMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["e" /* objectsMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["j" /* dataURLMixin */]],

    data: function data() {
        return {
            value: null,
            purposeValue: null,
            no_result_color: 'black',
            cover_photo_dataURL: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==',
            loading: true,
            master_loading: true,
            selecting_realestate: false,
            creating_contact: false,
            filesOpen: true,
            fileOpen: true,
            quoteOpen: true,
            error: null,
            success_message: null,
            metadata_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Version'),
            quotecontent_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quote_content'),
            quote_title_error_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quote_title_missing_error_text'),
            petitioners_missing_error_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Petitioners_missing_error_text'),
            realestates_missing_error_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Realestates_missing_error_text'),
            requireddocs_missing_error_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Requireddocs_missing_error_text'),
            new_real_estate_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Create_new_real_estate'),
            select_real_estate_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_real_estate'),
            add_petitioner_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_petitioner'),
            add_requireddoc_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_required_doc'),
            cancel_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cancel'),
            goup_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_up') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            pdf_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Print_quote_in_PDF'),
            save_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save'),
            save_and_go_up_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('go_up'),
            page_dirty_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('The_page_contains_unsaved_changes'),
            actions_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Actions'),
            filter_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type_here_to_filter_paginated_data'),
            realestate_appraisaldateValue: null,
            duplicate_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Duplicate'),
            edit_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Edit'),
            delete_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Delete'),
            discard_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Discard'),
            openlink_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Open_link_in_new_tab'),
            petitionerValue: null,
            entityValue: null,
            appraiserValue: null,
            supervisorValue: null,
            importRealEstateValue: null,
            petitioner_typeValue: null,
            statusValue: null,
            requireddocValue: null,
            petitioner_typeOptions: __WEBPACK_IMPORTED_MODULE_13__options_petitioner_types__["a" /* default */],
            status_quotesOptions: __WEBPACK_IMPORTED_MODULE_14__options_status_quotes__["a" /* default */],
            honorificTitleOptions: __WEBPACK_IMPORTED_MODULE_15__options_honorific_titles__["a" /* default */],
            personTypeOptions: __WEBPACK_IMPORTED_MODULE_16__options_person_types__["a" /* default */],
            requireddocOptions: __WEBPACK_IMPORTED_MODULE_17__options_requireddocs__["a" /* default */],
            purposeOptions: __WEBPACK_IMPORTED_MODULE_18__options_appraisal_purposes__["a" /* default */],
            realestate_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [{
                    id: 'property_type',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Property_type'),
                    width: '80px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'full_address',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Address'),
                    width: '240px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'cadastral_reference',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cadastral_reference'),
                    width: '140px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'total_travel_fees',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Travel_expenses'),
                    width: '80px',
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    alignment: 'right',
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_22__formatters_formatters_js__["a" /* default */].currency(value, 0, 'EUR');
                    }
                }, {
                    id: 'quote_base_price',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Fees'),
                    width: '80px',
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    alignment: 'right',
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_22__formatters_formatters_js__["a" /* default */].currency(value, 0, 'EUR');
                    }
                }, {
                    id: 'quote_price_incl_travel_expenses',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Fees') + ' + ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Travel_expenses'),
                    width: '120px',
                    sortable: true,
                    groupable: false,
                    aggregators: [__WEBPACK_IMPORTED_MODULE_21__aggregators_aggregators_js__["a" /* default */].total],
                    alignment: 'right',
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_22__formatters_formatters_js__["a" /* default */].currency(value, 0, 'EUR');
                    }
                    /*
                    {
                    id: 'street_name',
                    label: Vue.i18n.translate('Street_name'),
                    width: '160px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                    },
                    {
                    id: 'street_number',
                    label: Vue.i18n.translate('Street_number'),
                    width: '80px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                    },
                    {
                    id: 'floor',
                    label: Vue.i18n.translate('Floor'),
                    width: '80px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                    },
                    {
                    id: 'door',
                    label: Vue.i18n.translate('Door'),
                    width: '80px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                    },
                    {
                    id: 'municipality',
                    label: Vue.i18n.translate('Municipality'),
                    width: '160px',
                    sortable: true,
                    groupable: false,
                    alignment: 'right',
                    aggregators: []
                    },
                    {
                    id: 'appraisal_id',
                    label: Vue.i18n.translate('Appraisal') + ' Id',
                    width: '240px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                    },
                    {
                    id: 'appraisaldate',
                    label: Vue.i18n.translate('Appraisal_date'),
                    width: '160px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                    },
                    {
                    id: 'realestate_total_adopted_value',
                    label: Vue.i18n.translate('Appraisal_value'),
                    width: '160px',
                    sortable: true,
                    groupable: false,
                    aggregators: [
                    aggregators.total
                    ],
                    alignment: 'right',
                    formatter: function (value) {
                    return formatters.currency(value, 0, 'EUR')
                    }
                    }
                    */
                }],
                selected: []
            },
            petitioner_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [{
                    id: 'complete_name',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Petitioner'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                },
                /*
                 {
                    id: 'surnames',
                    label: Vue.i18n.translate('Surnames'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                },
                {
                    id: 'name',
                    label: Vue.i18n.translate('Name'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                },
                */
                /*
                {
                    id: 'tin',
                    label: Vue.i18n.translate('TIN'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }
                */
                {
                    id: 'main_email',
                    label: 'E-mail',
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }],
                selected: []
            },
            requireddoc_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [{
                    id: 'name_ca',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Document'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }],
                selected: []
            }
        };
    },

    created: function created() {
        var _this = this;

        this.FETCH_APPRAISALQUOTE_REALESTATES({
            path: 'appraisalquotes' + '/' + this.$route.query.id + '/' + 'realestates',
            appraisalquote_id: this.$route.query.id
        }).then(function () {

            _this.FETCH_CONTACTS({ path: 'contacts' + '/' + _this.$route.query.id + '/' }).then(function () {

                _this.FETCH_APPRAISALQUOTE_PETITIONERS({
                    path: 'appraisalquotes' + '/' + _this.$route.query.id + '/' + 'petitioners',
                    appraisalquote_id: _this.$route.query.id
                }).then(function () {

                    _this.FETCH_APPRAISALQUOTE_REQUIREDDOCS({
                        path: 'appraisalquotes' + '/' + _this.$route.query.id + '/' + 'requireddocs',
                        appraisalquote_id: _this.$route.query.id
                    }).then(function () {
                        _this.calc_final_price();
                        _this.master_loading = false;
                    });
                });
            });
        });
    },


    components: {
        Bar: __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default.a,
        Message: __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default.a,
        IconButton: __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default.a,
        SideNavBar: __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default.a,
        Checkbox: __WEBPACK_IMPORTED_MODULE_23__components_Toggles_checkbox_vue___default.a,
        Datatable: __WEBPACK_IMPORTED_MODULE_19__components_Datatable_datatable_vue___default.a,
        DatatableColumn: __WEBPACK_IMPORTED_MODULE_20__components_Datatable_datatable_column_vue___default.a,
        Paginator: __WEBPACK_IMPORTED_MODULE_24__components_Paginator_paginator_vue___default.a
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['theme', 'tags_display', 'contacts', 'currentLocale', 'appraisal', 'appraisalfile', 'appraisalquote', 'appraisalquote_petitioners', 'appraisalquote_realestates', 'appraisalquote_requireddocs', 'petitioners', 'realestate', 'realestates', 'contact', 'user'])),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['CHECK_APPRAISALQUOTE_REALESTATE_APPRAISALS', 'CREATE_NEW_REALESTATE', 'CREATE_NEW_APPRAISAL', 'CREATE_NEW_MARKETSTUDY', 'CREATE_NEW_CONTACT', 'DELETE', 'DELETE_REALESTATE', 'FETCH_APPRAISAL', 'FETCH_APPRAISALQUOTE_PETITIONERS', 'FETCH_APPRAISALQUOTE_REALESTATES', 'FETCH_APPRAISALQUOTE_REQUIREDDOCS', 'FETCH_CONTACTS', 'FETCH_REALESTATE', 'FETCH_REALESTATES', 'FETCH', 'GET', 'RESET_APPRAISAL', 'RESET_MARKETSTUDY', 'RESET_REALESTATE', 'RESET_CONTACT', 'SET_REALESTATE', 'UPDATE_REALESTATE', 'SET_APPRAISALQUOTE_REALESTATE_APPRAISAL_ID', 'SET_APPRAISALQUOTE_QUOTEDATE', 'SET_APPRAISALQUOTE_SEND_TO_BDE', 'SET_APPRAISALQUOTE_DESCRIPTION', 'SET_APPRAISALQUOTE_TITLE', 'SET_APPRAISALQUOTE_NUMBER', 'SET_APPRAISALQUOTE_VERSION', 'SET_APPRAISALQUOTE_ENTITY', 'SET_APPRAISALQUOTE_SUPERVISOR', 'SET_APPRAISALQUOTE_APPRAISER', 'SET_APPRAISALQUOTE_PETITIONER', 'SET_APPRAISALQUOTE_PETITIONER_TYPE', 'SET_APPRAISALQUOTE_VAT_PCT', 'SET_APPRAISALQUOTE_STATUS', 'SET_CONTACT', 'SET_CONTACT_MAIN_EMAIL', 'SET_CONTACT_NAME', 'SET_CONTACT_ORGANIZATION', 'SET_CONTACT_PERSON_TYPE', 'SET_CONTACT_REPRESENTATIVE', 'SET_CONTACT_REPRESENTATIVE_TIN', 'SET_CONTACT_SURNAMES', 'SET_CONTACT_TIN', 'SET_CONTACT_TITLE', 'SET_CONTACT_COMPLETE_NAME', 'SET_VALUE', 'SET_APPRAISALQUOTE_BANK_NAME', 'SET_APPRAISALQUOTE_IBAN', 'SET_APPRAISALQUOTE_COURT_ASSISTANCE_FEES', 'SET_APPRAISALQUOTE_DISCOUNT_PCT', 'SET_APPRAISALQUOTE_FINAL_PRICE', 'SET_APPRAISALQUOTE_DISCOUNT_NOTES', 'SET_APPRAISALQUOTE_REQUIREDDOC', 'SET_APPRAISALQUOTE_FULL_NUMBER', 'SET_APPRAISALQUOTE_SIGNATURE_NAME', 'SET_APPRAISALQUOTE_SIGNATURE_BASE64', 'SET_APPRAISALQUOTE_SIGNATURE_DATE', 'SET_APPRAISALQUOTE_IS_SIGNED', 'SET_APPRAISALQUOTE_SIGNATURE_EMAIL', 'SET_APPRAISALQUOTE_SIGNATURE_UID', 'SET_APPRAISALQUOTE_PURPOSE', 'UPDATE_APPRAISAL', 'UPDATE_APPRAISALQUOTE', 'UPDATE_APPRAISALQUOTE_REALESTATE_APPRAISAL_ID', 'UPDATE_CONTACT']), {

        set_appraisalquote_description: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALQUOTE_DESCRIPTION(e.target.value);
        }, 1000),
        set_appraisalquote_quotedate: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALQUOTE_QUOTEDATE(e.target.value);
        }, 1000),
        set_appraisalquote_number: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALQUOTE_NUMBER(Number(e.target.value));

            var filenumber = '';
            filenumber = this.appraisalfile.number;

            var s = Number(e.target.value) + '';
            while (s.length < 2) {
                s = '0' + s;
            }var quotenumber = s;

            var p = this.appraisalquote.version + '';
            while (p.length < 2) {
                p = '0' + p;
            }var quoteversion = p;

            var fullnumber = filenumber + '/' + quotenumber + '/' + quoteversion;

            this.SET_APPRAISALQUOTE_FULL_NUMBER(fullnumber);
        }, 500),
        set_appraisalquote_send_to_bde: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALQUOTE_SEND_TO_BDE(e.target.value);
        }, 1000),
        set_appraisalquote_title: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALQUOTE_TITLE(e.target.value);
        }, 1000),
        set_appraisalquote_version: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {

            this.SET_APPRAISALQUOTE_VERSION(Number(e.target.value));

            var filenumber = '';
            filenumber = this.appraisalfile.number;

            var s = this.appraisalquote.number + '';
            while (s.length < 2) {
                s = '0' + s;
            }var quotenumber = s;

            var p = Number(e.target.value) + '';
            while (p.length < 2) {
                p = '0' + p;
            }var quoteversion = p;

            var fullnumber = filenumber + '/' + quotenumber + '/' + quoteversion;

            this.SET_APPRAISALQUOTE_FULL_NUMBER(fullnumber);
        }, 500),
        set_appraisalquote_petitioner: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALQUOTE_PETITIONER(e);
        }, 1000),
        set_appraisalquote_petitioner_type: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALQUOTE_PETITIONER_TYPE(e);
        }, 1000),
        set_appraisalquote_vat_pct: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALQUOTE_VAT_PCT(Number(e.target.value));
        }, 1000),
        set_appraisalquote_status: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALQUOTE_STATUS(e);
        }, 500),
        set_contact_name: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var name = e.target.value;
            var surnames = '';
            if (this.contact.surnames) {
                surnames = this.contact.surnames;
            }

            var complete_name = surnames + ', ' + name;
            if (!surnames) {
                complete_name = name;
            }
            this.SET_CONTACT_NAME(name);
            this.SET_CONTACT_COMPLETE_NAME(complete_name);
        }, 500),
        set_contact_main_email: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_CONTACT_MAIN_EMAIL(e.target.value);
        }, 500),
        set_contact_organization: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_CONTACT_ORGANIZATION(e.target.value);
        }, 500),
        set_contact_person_type: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_CONTACT_PERSON_TYPE(e);
        }, 500),
        set_contact_representative: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_CONTACT_REPRESENTATIVE(e.target.value);
        }, 500),
        set_contact_representative_tin: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_CONTACT_REPRESENTATIVE_TIN(e.target.value);
        }, 500),
        set_contact_surnames: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var surnames = e.target.value;
            var name = '';
            if (this.contact.name) {
                name = this.contact.name;
            }
            var complete_name = surnames + ', ' + name;
            if (!surnames) {
                complete_name = name;
            }
            this.SET_CONTACT_SURNAMES(surnames);
            this.SET_CONTACT_COMPLETE_NAME(complete_name);
        }, 500),
        set_contact_tin: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_CONTACT_TIN(e.target.value);
        }, 500),
        set_contact_title: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_CONTACT_TITLE(e);
        }, 500),
        set_import_realestate: function set_import_realestate() {
            console.log('set_import_realestate');
            /*
            this.master_loading = true
            this.FETCH_TEMP_REALESTATE_MARKETSTUDIES({path: 'realestate_marketstudies' + '/' + this.marketstudy.importRealEstate.id + '/'})
            .then(() => {
            this.master_loading = false
            })
            */
        },
        set_appraisalquote_bank_name: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALQUOTE_BANK_NAME(e.target.value);
        }, 500),
        set_appraisalquote_iban: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALQUOTE_IBAN(e.target.value);
        }, 500),
        set_appraisalquote_court_assistance_fees: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALQUOTE_COURT_ASSISTANCE_FEES(Number(e.target.value));
        }, 500),
        set_appraisalquote_discount_pct: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALQUOTE_DISCOUNT_PCT(Number(e.target.value));
            this.calc_final_price();
        }, 500),
        set_appraisalquote_final_price: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALQUOTE_FINAL_PRICE(Number(e.target.value));
        }, 500),
        set_appraisalquote_discount_notes: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALQUOTE_DISCOUNT_NOTES(e.target.value);
        }, 500),
        set_appraisalquote_requireddoc: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALQUOTE_REQUIREDDOC(e);
        }, 500),
        set_appraisalquote_full_number: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALQUOTE_FULL_NUMBER(e.target.value);
        }, 500),
        set_appraisalquote_signature_name: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALQUOTE_SIGNATURE_NAME(e.target.value);
        }, 500),
        set_appraisalquote_signature_base64: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALQUOTE_SIGNATURE_BASE64(e.target.value);
        }, 500),
        set_appraisalquote_signature_date: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALQUOTE_SIGNATURE_DATE(e.target.value);
        }, 500),
        set_appraisalquote_is_signed: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            if (this.appraisalquote.is_signed) {
                var s = this.user.s ? this.user.s : null;
                var email = this.user.email ? this.user.email : '';
                var name = this.user.name + ' ' + this.user.surnames;
                var id = this.user.id ? this.user.id : null;
                //console.log(id)
                if (!id) {
                    alert('Manca uid. Contactar amb l\'administrador del l\'app.');
                }
                this.SET_APPRAISALQUOTE_SIGNATURE_BASE64(s);
                this.SET_APPRAISALQUOTE_SIGNATURE_NAME(name);
                this.SET_APPRAISALQUOTE_SIGNATURE_EMAIL(email);
                this.SET_APPRAISALQUOTE_SIGNATURE_UID(id);
                // unix seconds
                this.SET_APPRAISALQUOTE_SIGNATURE_DATE(__WEBPACK_IMPORTED_MODULE_3_moment___default()().format('X'));
                this.onSaveCurrentAppraisalQuote({ go_up: false });
            } else {
                this.SET_APPRAISALQUOTE_SIGNATURE_BASE64(null);
                this.SET_APPRAISALQUOTE_SIGNATURE_NAME(null);
                this.SET_APPRAISALQUOTE_SIGNATURE_EMAIL(null);
                this.SET_APPRAISALQUOTE_SIGNATURE_UID(null);
                this.SET_APPRAISALQUOTE_SIGNATURE_DATE(null);
                this.onSaveCurrentAppraisalQuote({ go_up: false });
            }
            this.$forceUpdate();
        }, 0),
        set_appraisalquote_signature_email: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALQUOTE_SIGNATURE_EMAIL(e.target.value);
        }, 500),
        set_appraisalquote_signature_uid: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALQUOTE_SIGNATURE_UID(e.target.value);
        }, 500),
        set_appraisalquote_purpose: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISALQUOTE_PURPOSE(e);
        }, 1000),
        onSelectNewRealEstate: function onSelectNewRealEstate() {
            var _this2 = this;

            this.master_loading = true;
            this.FETCH_REALESTATES({ path: 'realestates' }).then(function () {
                _this2.master_loading = false;
                _this2.selecting_realestate = true;
            });
        },
        onImportNewRealEstate: function onImportNewRealEstate(data) {
            var _this3 = this;

            this.selecting_realestate = false;
            this.master_loading = true;

            this.GET({ path: 'realestates' + '/' + data.id }).then(function (res) {

                // console.log(' *^*^*^*^*^*^*^*^*^*^ get realestate res: ')
                // console.log(res)

                var new_object = res;

                new_object['quote_id'] = _this3.appraisalquote.id;
                new_object['file_id'] = _this3.appraisalfile.id;
                new_object['file_number'] = _this3.appraisalfile.number;
                new_object['quote_number'] = _this3.appraisalquote.number;
                new_object['quote_version'] = _this3.appraisalquote.version;

                _this3.UPDATE_REALESTATE({
                    object: new_object,
                    path: 'realestates' + '/' + new_object.id,
                    quote_id: _this3.appraisalquote.id,
                    // parent_path: 'appraisalquotes' + '/' + this.appraisalquote.id + '/' + 'realestates' + '/',
                    key: new_object.id
                }).then(function (res) {

                    _this3.master_loading = true;
                    _this3.FETCH_APPRAISALQUOTE_REALESTATES({
                        path: 'appraisalquotes' + '/' + _this3.appraisalquote.id + '/' + 'realestates' + '/',
                        appraisalquote_id: _this3.appraisalquote.id
                    }).then(function () {

                        _this3.calc_final_price();

                        _this3.master_loading = false;
                    });
                });
            });
        },
        onCancelImportNewRealEstate: function onCancelImportNewRealEstate() {
            this.selecting_realestate = false;
        },
        onCreateNewRealEstate: function onCreateNewRealEstate() {
            var _this4 = this;

            this.selecting_realestate = false;
            this.master_loading = true;

            this.onSaveCurrentAppraisalQuote({ go_up: false });

            this.RESET_REALESTATE().then(function (res) {
                _this4.CREATE_NEW_REALESTATE({
                    quote_id: _this4.appraisalquote.id,
                    file_id: _this4.appraisalfile.id,
                    file_number: _this4.appraisalfile.number,
                    quote_number: _this4.appraisalquote.number,
                    quote_version: _this4.appraisalquote.version,
                    path: 'realestates' + '/'
                }).then(function (res) {

                    _this4.RESET_APPRAISAL().then(function (res) {
                        _this4.CREATE_NEW_APPRAISAL({
                            path: 'realestate_appraisals' + '/' + _this4.realestate.id + '/',
                            parent_path: 'realestates' + '/' + _this4.realestate.id + '/' + 'appraisals' + '/',
                            file_id: _this4.appraisalfile.id,
                            realestate_id: _this4.realestate.id
                        }).then(function (res) {
                            _this4.UPDATE_APPRAISALQUOTE_REALESTATE_APPRAISAL_ID({
                                appraisal_id: _this4.appraisal.id,
                                appraisaldate: _this4.appraisal.appraisaldate,
                                appraisalquote_id: _this4.appraisalquote.id,
                                realestate_id: _this4.realestate.id
                            });

                            _this4.UPDATE_APPRAISAL({
                                key: _this4.appraisal.id,
                                object: _this4.appraisal,
                                parent_path: 'realestates/' + _this4.realestate.id + '/' + 'appraisals' + '/',
                                path: _this4.appraisal.path + _this4.appraisal.id,
                                realestate_id: _this4.realestate.id
                            });

                            _this4.RESET_MARKETSTUDY().then(function (res) {
                                _this4.CREATE_NEW_MARKETSTUDY({
                                    path: 'realestate_marketstudies' + '/' + _this4.realestate.id + '/',
                                    parent_path: 'realestates' + '/' + _this4.realestate.id + '/' + 'marketstudies' + '/',
                                    file_id: _this4.appraisalfile.id,
                                    realestate_id: _this4.realestate.id,
                                    appraisal_id: _this4.appraisal.id
                                }).then(function (res) {
                                    // this.$router.push({name: 'marketstudy-editor', query: {id: this.appraisal.id}})
                                    _this4.master_loading = false;
                                    _this4.$router.push({ name: 'realestate-editor', query: { id: _this4.realestate.id } });
                                });
                            });
                        });
                    });
                });
            });
        },
        checkCreateNewRealEstate: function checkCreateNewRealEstate() {
            if (this.appraisalquote.dirty) {
                var result = window.confirm(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('There_are_unsaved_changes') + '. ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Unsaved_data_will_be_lost') + '. ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Continue_q'));
                if (result) {
                    this.onCreateNewRealEstate();
                }
            } else {
                this.onCreateNewRealEstate();
            }
        },
        onAddNewPetitioner: function onAddNewPetitioner() {
            var _this5 = this;

            this.master_loading = true;

            var filenumber = '';
            filenumber = this.appraisalfile.number;

            var s = this.appraisalquote.number + '';
            while (s.length < 2) {
                s = '0' + s;
            }var quotenumber = s;

            var p = this.appraisalquote.version + '';
            while (p.length < 2) {
                p = '0' + p;
            }var quoteversion = p;

            var obj = {};

            if (this.appraisalquote_petitioners) {
                obj = this.appraisalquote_petitioners;
            }

            var parent_obj = {};

            parent_obj['full_number'] = filenumber + '/' + quotenumber + '/' + quoteversion;
            parent_obj['quotedate'] = this.appraisalquote.quotedate;
            parent_obj['id'] = this.appraisalquote.id;

            // console.log('heypppppppp')
            // console.log(obj)
            var contact_id = this.appraisalquote.petitioner.id;
            obj[contact_id] = this.appraisalquote.petitioner;

            this.SET_VALUE({
                object: obj,
                path: 'appraisalquotes' + '/' + this.$route.query.id + '/' + 'petitioners'
            }).then(function (res) {

                _this5.SET_VALUE({
                    object: parent_obj,
                    path: 'contacts' + '/' + contact_id + '/' + 'appraisalquotes' + '/' + _this5.$route.query.id
                }).then(function (res) {

                    _this5.FETCH_APPRAISALQUOTE_PETITIONERS({
                        path: 'appraisalquotes' + '/' + _this5.$route.query.id + '/' + 'petitioners',
                        appraisalquote_id: _this5.$route.query.id
                    }).then(function () {
                        _this5.master_loading = false;
                    });
                });
            });
        },
        onAddNewRequiredDoc: function onAddNewRequiredDoc() {
            var _this6 = this;

            this.master_loading = true;

            var obj = {};

            if (this.appraisalquote_requireddocs) {
                obj = this.appraisalquote_requireddocs;
            }

            var id = __WEBPACK_IMPORTED_MODULE_3_moment___default()().unix().toString();

            if (this.appraisalquote.requireddoc) {
                obj[id] = this.appraisalquote.requireddoc;
                obj[id]['id'] = id;

                // console.log('heypppppppp')
                // console.log(obj)

                this.SET_VALUE({
                    object: obj,
                    path: 'appraisalquotes' + '/' + this.$route.query.id + '/' + 'requireddocs'
                }).then(function (res) {
                    _this6.FETCH_APPRAISALQUOTE_REQUIREDDOCS({
                        path: 'appraisalquotes' + '/' + _this6.$route.query.id + '/' + 'requireddocs',
                        appraisalquote_id: _this6.$route.query.id
                    }).then(function () {
                        _this6.master_loading = false;
                    });
                });
            } else {
                alert('S\'ha d\'escollir un element de la llista abans d\'ésser afegit');
            }
        },
        discardRequiredDoc: function discardRequiredDoc(entity) {
            var _this7 = this;

            this.master_loading = true;

            this.DELETE({
                key: entity.id,
                path: 'appraisalquotes' + '/' + this.appraisalquote.id + '/' + 'requireddocs' + '/' + entity.id
            }).then(function (res) {

                _this7.FETCH_APPRAISALQUOTE_REQUIREDDOCS({
                    path: 'appraisalquotes' + '/' + _this7.$route.query.id + '/' + 'requireddocs',
                    appraisalquote_id: _this7.$route.query.id
                }).then(function () {
                    _this7.master_loading = false;
                });
            });
        },
        onAddNewContact: function onAddNewContact() {
            var _this8 = this;

            this.RESET_CONTACT().then(function (res) {
                _this8.creating_contact = true;
            });
        },
        onCreateNewContact: function onCreateNewContact() {
            var _this9 = this;

            // vigilar, que no es guarda la id, date_created, path
            // al crear contacte d'empreses --> title amb gender neutral?

            var obj_copy = JSON.parse(JSON.stringify(this.contact));
            console.log('!!! --->');
            console.log(obj_copy);

            this.creating_contact = false;
            this.master_loading = true;

            this.CREATE_NEW_CONTACT({ path: 'contacts', creating_from_main: false }).then(function (res) {

                obj_copy['id'] = _this9.contact.id;
                obj_copy['date_created'] = _this9.contact.date_created;
                obj_copy['path'] = _this9.contact.path;

                _this9.UPDATE_CONTACT({
                    object: obj_copy,
                    path: 'contacts' + '/' + res.key
                }).then(function (res) {
                    _this9.FETCH_CONTACTS({ path: 'contacts' + '/' }).then(function () {
                        _this9.SET_APPRAISALQUOTE_PETITIONER(_this9.contact);
                        _this9.master_loading = false;
                    });
                });
            });
        },
        onCancelCreateNewContact: function onCancelCreateNewContact() {
            this.creating_contact = false;
        },
        calc_final_price: function calc_final_price() {
            var final_price = 0;
            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(this.appraisalquote_realestates, function (value) {
                final_price = final_price + value['quote_price_incl_travel_expenses'];
            });

            var discount_coef = 1 - this.appraisalquote.discount_pct / 100;

            final_price = this.roundToTwo(final_price * discount_coef);
            this.SET_APPRAISALQUOTE_FINAL_PRICE(final_price);
        },
        set_appraisalquote_realestate_appraisal_id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e, realestate_id) {
            var _this10 = this;

            this.SET_APPRAISALQUOTE_REALESTATE_APPRAISAL_ID({
                path: 'appraisalquotes' + '/' + this.$route.query.id + '/' + 'realestates' + '/' + realestate_id + '/' + 'appraisal_id',
                value: e
            }).then(function (res) {
                _this10.$forceUpdate();
            });
        }, 1000),
        numFormat: function numFormat(value, symbol) {
            if (!value || value === 0 || value === '' || value === '-') {
                return '-';
            } else {
                return numeral(value).format('0,0.00') + ' ' + symbol;
            }
        },
        intFormat: function intFormat(value, symbol) {
            if (!value || value === 0 || value === '' || value === '-') {
                return '-';
            } else {
                return numeral(value).format('0,0') + ' ' + symbol;
            }
        },
        onCreatePdf: function onCreatePdf(data) {
            var _this11 = this;

            this.master_loading = true;

            // guardar automàticament
            this.onSaveCurrentAppraisalQuote({ go_up: false });

            // TODO: comprovar que totes les appraisals incloses en el appraisalquote tinguin la mateixa finalitat declarada, sinó fer apareixèr un warning message

            var realestates = [];
            var appraisals = [];
            var marketstudies = [];

            var fetchAppraisal = function fetchAppraisal(data) {
                return new Promise(function (resolve, reject) {
                    _this11.$store.dispatch('FETCH_APPRAISAL', data).then(function (res) {
                        appraisals.push(res);
                        resolve(res);
                    });
                });
            };

            var fetchRealEstate = function fetchRealEstate(data) {
                return new Promise(function (resolve, reject) {
                    _this11.$store.dispatch('FETCH_REALESTATE', data).then(function (res) {
                        console.log('fetching realestate...');
                        realestates.push(res);
                        resolve(res);
                    });
                });
            };

            var database_fetch = function database_fetch(data) {
                return new Promise(function (resolve, reject) {
                    _this11.$store.dispatch('FETCH', data).then(function (res) {
                        console.log('fetching...');
                        realestates.push(res);
                        resolve(res);
                    });
                });
            };

            var canvas_to_data_url = function canvas_to_data_url(data) {
                return new Promise(function (resolve, reject) {

                    // fetch from the WHATWG fetch api:
                    var toDataURL = function toDataURL(url) {
                        return fetch(url).then(function (response) {
                            return response.blob();
                        }).then(function (blob) {
                            return new Promise(function (resolve, reject) {
                                var reader = new FileReader();
                                reader.onloadend = function () {
                                    return resolve(reader.result);
                                };
                                reader.onerror = reject;
                                reader.readAsDataURL(blob);
                            });
                        });
                    };

                    toDataURL(data.src).then(function (dataUrl) {
                        // console.log('RESULT:', dataUrl)
                        resolve({ data_url: dataUrl, footer: data.footer, is_cover_photo: data.is_cover_photo });
                    });
                });
            };

            var google_canvas_to_data_url = function google_canvas_to_data_url(data) {
                console.log('google_canvas_to_data_url data!: ');
                console.log(data);
                return new Promise(function (resolve, reject) {

                    // fetch from the WHATWG fetch api:
                    var toDataURL = function toDataURL(url) {
                        return fetch(url).then(function (response) {
                            return response.blob();
                        }).then(function (blob) {
                            return new Promise(function (resolve, reject) {
                                var reader = new FileReader();
                                reader.onloadend = function () {
                                    return resolve(reader.result);
                                };
                                reader.onerror = reject;
                                reader.readAsDataURL(blob);
                            });
                        });
                    };

                    if (data.src) {
                        toDataURL(data.src).then(function (dataUrl) {
                            // console.log('RESULT:', dataUrl)
                            resolve({ data_url: dataUrl, footer: data.footer });
                        });
                    } else {

                        resolve();
                    }
                });
            };

            // address_table portada
            var address_table = [];

            // taula identificació i localització
            var appraised_id_table = [];

            // layour d'elements
            var elements_layout = {};

            var appraisal_review_table = [];
            var realestate_review_table = [];
            var comparable_review_table = [];
            var marketstudy_review_table = [];
            var appraisalfile_review_table = [];
            var appraisalquote_review_table = [];

            // variables

            var property_type = '';
            var address_street_name = '';
            var address_number = '';
            var address_floor = '';
            var address_door = '';
            var address_block = '';
            var address_staircase = '';
            var address_postal_code = '';
            var address_postal_code_only = '';
            var address_municipality = '';
            var address_province = '';
            var address_long = '';
            var address_short = '';
            var cad_ref = '';
            var reg_est_num = '';
            var purpose_notes = '';
            var appraisaldate = '';
            var quotedate = '';
            var filenumber = '';
            var quotenumber = '';
            var quoteversion = '';
            var petitioner = '';
            var petitioner_type = '';
            var mandatary = '';
            var appraisal_purpose = '';
            var acc_mortgage_market_law = '';
            var acc_eco_decree = '';
            var appraiser = '';
            var appraiser_name = '';
            var appraiser_surnames = '';
            var appraiser_pa_number = '';
            var supervisor = '';
            var supervisor_name = '';
            var supervisor_surnames = '';
            var supervisor_pa_number = '';
            var technician_visiting = '';
            var full_number = this.appraisalquote.full_number;

            var total_quote_fees_without_vat = 0;
            var quote_vat = 0;
            var total_quote_fees_incl_vat = 0;

            // constant "map" from the 'p-iteration' plugin
            map(this.object_to_array(this.appraisalquote_realestates), function (realestate) {
                return database_fetch({ path: 'realestates' + '/' + realestate.id });
            }).then(function (result) {

                realestates = result;
                console.log('realestates result: ');
                console.log(realestates);

                // console.log('map result: ')
                // console.log(result)

                // console.log('result.length: ')
                // console.log(result.length)

                var docDefinition = {
                    // settings
                    pageSize: 'A4',
                    pageOrientation: 'portrait',
                    // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
                    pageMargins: [40, 80, 20, 20],
                    // metadata
                    info: {
                        title: 'BARNA-TASA, S.A.',
                        author: 'BARNA-TASA, S.A.',
                        subject: 'BARNA-TASA, S.A.',
                        keywords: 'BARNA-TASA, S.A.',
                        creator: 'BARNA-TASA, S.A.',
                        producer: 'BARNA-TASA, S.A.'
                    },
                    styles: {
                        header_small: {
                            fontSize: 8,
                            bold: false
                        },
                        header_title: {
                            fontSize: 12,
                            bold: true
                        },
                        small: {
                            fontSize: 8,
                            bold: false
                        },
                        small_bold: {
                            fontSize: 8,
                            bold: true
                        },
                        small_bold_center: {
                            fontSize: 8,
                            bold: true,
                            alignment: 'center'
                        },
                        plain: {
                            fontSize: 9,
                            bold: false
                        },
                        plain_bold: {
                            fontSize: 9,
                            bold: true
                        },
                        plain_bold_underline: {
                            fontSize: 9,
                            bold: true,
                            decoration: 'underline'
                        },
                        plain_bold_center: {
                            fontSize: 9,
                            bold: true,
                            alignment: 'center'
                        },
                        plain_bold_left: {
                            fontSize: 9,
                            bold: true,
                            alignment: 'left'
                        },
                        plain_bold_right: {
                            fontSize: 9,
                            bold: true,
                            alignment: 'right'
                        },
                        cover_brand: {
                            fontSize: 32,
                            color: '#1a3856',
                            bold: true
                        },
                        cover_title: {
                            fontSize: 20,
                            color: '#1a3856',
                            bold: true,
                            alignment: 'center'
                        },
                        cover_subtitle: {
                            fontSize: 14,
                            color: '#1a3856',
                            bold: true,
                            alignment: 'center'
                        },
                        cover_header: {
                            fontSize: 12,
                            color: '#1a3856',
                            bold: true,
                            alignment: 'center'
                        },
                        plain_blue: {
                            fontSize: 9,
                            color: '#1a3856',
                            bold: false
                        },
                        plain_blue_bold: {
                            fontSize: 9,
                            color: '#1a3856',
                            bold: true
                        },
                        plain_green_bold: {
                            fontSize: 9,
                            color: '#009900',
                            bold: true
                        },
                        h2: {
                            fontSize: 16,
                            bold: true
                        },
                        h2_center: {
                            fontSize: 16,
                            bold: true,
                            alignment: 'center'
                        },
                        h3: {
                            fontSize: 12,
                            bold: true

                        },
                        h3_blue: {
                            fontSize: 12,
                            bold: true,
                            color: '#1a3856'
                        },
                        h3_lightblue: {
                            fontSize: 12,
                            bold: true,
                            color: '#0088f7'
                        },
                        h4: {
                            fontSize: 11,
                            bold: true
                        },
                        h5: {
                            fontSize: 10,
                            bold: true
                        },
                        h5_underline: {
                            fontSize: 10,
                            decoration: 'underline',
                            bold: true
                        },
                        h6: {
                            fontSize: 9,
                            bold: true
                        }
                    },
                    //header & footer
                    header: function header(currentPage, pageCount, pageSize) {
                        // apply any logic and return any valid pdfmake element
                        return [{
                            text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Barnatasa_header'),
                            // alignment: (currentPage % 2) ? 'left' : 'right'
                            alignment: 'center',
                            margin: [0, 10],
                            style: 'header_small'
                        }, {
                            columns: [{
                                image: 'data:image/png;base64,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',
                                width: 16,
                                margin: [40, 0]
                            }, {
                                width: 200,
                                border: [false, false, false, true],
                                text: 'BARNA-TASA, S.A.',
                                style: 'header_title_blue',
                                alignment: 'left',
                                margin: [48, 0]

                            }, {
                                width: '*',
                                border: [false, false, false, true],
                                text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Appraisal_quote').toUpperCase(),
                                style: 'header_medium_blue',
                                alignment: 'right',
                                margin: [40, 0]

                            }]
                        }];
                    },
                    footer: function footer(currentPage, pageCount, pageSize) {
                        // apply any logic and return any valid pdfmake element
                        return [{
                            layout: 'noBorders',
                            margin: [30, 0, 30, 30],
                            table: {
                                headerRows: 0,
                                widths: ['*', 20],
                                body: [[{
                                    border: [false, false, false, false],
                                    // fillColor: 'whitesmoke',
                                    text: 'Carrer de Còrsega, 168, 1º 1ª, 08036, Barcelona | tel. (+34) 93 410 05 32 | info@barnatasa.com | www.barnatasa.com',
                                    style: 'plain_bold',
                                    alignment: 'center'
                                }, {
                                    text: currentPage + ' / ' + pageCount,
                                    // fillColor: 'whitesmoke',
                                    style: 'plain',
                                    alignment: 'right'

                                }]]
                            }
                        }];
                    },
                    // content
                    content: []
                    /*
                     let greeting = ''
                    let greet_a = ''
                    let greet_b = ''
                     if (this.appraisalquote.petitioner.title.gender === 'male') {
                        greet_a = Vue.i18n.translate('Dear_m')
                    } else if (this.appraisalquote.petitioner.title.gender === 'female') {
                        greet_a = Vue.i18n.translate('Dear_f')
                    }
                     if (this.currentLocale === 'ca') {
                        greet_b = this.appraisalquote.petitioner.title.abb_ca
                    } else if (this.currentLocale === 'en') {
                        greet_b = this.appraisalquote.petitioner.title.abb_en
                    } else {
                        greet_b = this.appraisalquote.petitioner.title.abb_es
                    }
                     greeting = greet_a + ' ' + greet_b + ' ' + this.appraisalquote.petitioner.surnames + ', '
                    */

                    // expedient
                };filenumber = '';
                if (_this11.appraisalfile.number) {
                    filenumber = _this11.appraisalfile.number;
                } else {
                    appraisalfile_review_table.push([{
                        text: _this11.appraisalfile.id,
                        style: 'plain_bold'
                    }, {
                        text: 'Manca introduir el número d\'expedient.',
                        style: 'plain',
                        alignment: 'left'
                    }]);
                }

                // quotenumber
                quotenumber = '';
                if (_this11.appraisalquote.number) {
                    // pad, zero fill ->2
                    var s = _this11.appraisalquote.number + '';
                    while (s.length < 2) {
                        s = '0' + s;
                    }quotenumber = s;
                } else {
                    appraisalquote_review_table.push([{
                        text: _this11.appraisalquote.id,
                        style: 'plain_bold'
                    }, {
                        text: 'Manca introduir el número d\'informe.',
                        style: 'plain',
                        alignment: 'left'
                    }]);
                }

                // quoteversion
                quoteversion = '';
                if (_this11.appraisalquote.version) {
                    // pad, zero fill ->2
                    var _s = _this11.appraisalquote.version + '';
                    while (_s.length < 2) {
                        _s = '0' + _s;
                    }quoteversion = _s;
                } else {
                    appraisalquote_review_table.push([{
                        text: _this11.appraisalquote.id,
                        style: 'plain_bold'
                    }, {
                        text: 'Manca introduir la versió de l\'informe.',
                        style: 'plain',
                        alignment: 'left'
                    }]);
                }

                // data de l'informe
                quotedate = '';
                if (_this11.appraisalquote.quotedate) {
                    quotedate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(_this11.appraisalquote.quotedate).format('DD/MM/YYYY');

                    var today = __WEBPACK_IMPORTED_MODULE_3_moment___default()();
                    var diff = __WEBPACK_IMPORTED_MODULE_3_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_3_moment___default()(_this11.appraisalquote.quotedate), 'days');
                    if (diff > 0) {
                        appraisalquote_review_table.push([{
                            text: filenumber + '/' + quoteversion + '/' + quotenumber,
                            style: 'plain_bold'
                        }, {
                            text: 'La data del pressupost és diferent a la data d\'avui. Cal actualitzar la data del pressupost?',
                            style: 'plain',
                            alignment: 'left'
                        }]);
                    }
                } else {
                    appraisalquote_review_table.push([{
                        text: _this11.appraisalquote.id,
                        style: 'plain_bold'
                    }, {
                        text: 'Manca introduir la data de l\'informe.',
                        style: 'plain',
                        alignment: 'left'
                    }]);
                }

                docDefinition.content.push({
                    text: '',
                    margin: [0, 8]
                }, {
                    image: 'data:image/png;base64,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',
                    width: 100,
                    margin: [8, 8],
                    alignment: 'right'
                }, {
                    text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quote') + ' nº ' + filenumber + '/' + quotenumber + '/' + quoteversion,
                    margin: [10, 8],
                    style: 'h3',
                    alignment: 'right'
                }, {
                    //text: 'Barcelona, ' + Vue.i18n.translate('at') + ' ' + moment().format('DD/MM/YYYY'),
                    text: 'Barcelona, ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at') + ' ' + quotedate,
                    margin: [10, 4],
                    style: 'plain',
                    alignment: 'right'
                });

                var petitioners_names = '';
                var petitioners_emails = '';

                var male_counter = 0;
                var female_counter = 0;
                var unknown_counter = 0;

                var greeting_call = '';
                var greeting_intro = '';

                var petitioners_arr = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(_this11.appraisalquote_petitioners);

                petitioners_arr = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(petitioners_arr, 'surnames');

                var currentLocale = _this11.currentLocale;
                var purpose = '';

                if (currentLocale === 'ca') {
                    purpose = _this11.appraisalquote.purpose ? _this11.appraisalquote.purpose.name_ca : '';
                } else if (currentLocale === 'en') {
                    purpose = _this11.appraisalquote.purpose ? _this11.appraisalquote.purpose.name_en : '';
                } else {
                    purpose = _this11.appraisalquote.purpose ? _this11.appraisalquote.purpose.name_es : '';
                }

                //console.log('petitioners_arr: ')
                //console.log(petitioners_arr)

                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(petitioners_arr, function (value) {

                    // let email = value['emailaddresses'] ? '(' + value['emailaddresses'][0]['address'] + ')' : ''

                    var name = value['name'] ? value['name'] : '';
                    var surnames = value['surnames'] ? value['surnames'] : '';
                    var email = value['main_email'] ? value['main_email'] : '';
                    var company = value['organization'] ? ' - ' + value['organization'] : '';

                    var petitioner_name = name + ' ' + surnames + company + ' (' + email + ')';

                    // petitioners_names = petitioners_names + value['name'] + ' ' + value['surnames'] + email + ', '

                    if (value['title']) {

                        if (value['title']['gender']) {

                            if (value['title']['gender'] === 'male') {
                                male_counter = male_counter + 1;
                            } else if (value['title']['gender'] === 'female') {
                                female_counter = female_counter + 1;
                            } else {
                                unknown_counter = unknown_counter + 1;
                            }

                            if (currentLocale === 'ca') {
                                greeting_call = greeting_call + value['title']['abb_ca'] + ' ' + surnames + ', ';
                            } else if (currentLocale === 'en') {
                                greeting_call = greeting_call + value['title']['abb_en'] + ' ' + surnames + ', ';
                            } else {
                                greeting_call = greeting_call + value['title']['abb_es'] + ' ' + surnames + ', ';
                            }
                        } else {
                            unknown_counter = unknown_counter + 1;
                        }
                    } else {

                        unknown_counter = unknown_counter + 1;

                        // greeting_call = value['name'] + ', '
                    }

                    docDefinition.content.push({
                        text: petitioner_name,
                        margin: [0, 4],
                        style: 'plain_bold'
                    });

                    // petitioners_emails = petitioners_emails + email
                });

                // to remove last trailing ' , '
                greeting_call = greeting_call.substring(0, greeting_call.length - 2);

                /*
                if (male_counter > 0 && female_counter > 0) {
                greeting = Vue.i18n.translate('Dear_madams_and_sirs')
                }
                if (male_counter === 0 && female_counter === 1) {
                greeting = Vue.i18n.translate('Dear_madam')
                } else if (male_counter === 0 && female_counter > 1) {
                greeting = Vue.i18n.translate('Dear_madams')
                }
                if (female_counter === 0 && male_counter === 1) {
                greeting = Vue.i18n.translate('Dear_sir')
                } else if (female_counter === 0 && male_counter > 1) {
                greeting = Vue.i18n.translate('Dear_sirs')
                }
                if (female_counter > 1 && male_counter > 1) {
                greeting = Vue.i18n.translate('Dear_madams_and_sirs')
                } else if (female_counter === 1 && male_counter === 1) {
                greeting = Vue.i18n.translate('Dear_madam_and_sir')
                }
                if (unknown_counter > 0) {
                greeting = Vue.i18n.translate('Dear_sir_or_madam')
                }
                if (unknown_counter === 1 && female_counter > 0) {
                greeting = Vue.i18n.translate('Dear_sirs_or_madams')
                }
                if (unknown_counter === 1 && male_counter > 0) {
                greeting = Vue.i18n.translate('Dear_sirs_or_madams')
                }
                if (unknown_counter > 1) {
                greeting = Vue.i18n.translate('Dear_sirs_or_madams')
                }
                if (_.size(this.appraisalquote_petitioners) > 1) {
                Vue.i18n.translate('Dear_sirs_or_madams')
                }
                */

                if (petitioners_arr.length > 1) {

                    if (male_counter > 0 && female_counter > 0) {
                        greeting_intro = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Dear_pl');
                    }

                    if (male_counter === 0) {
                        greeting_intro = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Dear_pl_f');
                    }

                    if (female_counter === 0) {
                        greeting_intro = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Dear_pl_m');
                    }
                } else {

                    // console.log("petitioners_arr[0]['title']['gender']: ")
                    // console.log(petitioners_arr[0]['title']['gender'])

                    if (petitioners_arr[0]['title']) {
                        if (petitioners_arr[0]['title']['gender'] === 'male') {
                            greeting_intro = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Dear_m') + ' ';
                        } else if (petitioners_arr[0]['title']['gender'] === 'female') {
                            greeting_intro = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Dear_f') + ' ';
                        } else {
                            greeting_intro = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Dear_m') + ' ';
                        }
                    } else {
                        greeting_intro = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Dear_m') + ' ';
                    }

                    if (unknown_counter > 0) {
                        greeting_intro = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Dear_sir_or_madam');
                    }

                    if (unknown_counter > 1) {
                        greeting_intro = '';
                    }
                }

                docDefinition.content.push({
                    text: '',
                    margin: [0, 8],
                    style: 'plain'
                });

                if (greeting_intro.length > 0) {
                    docDefinition.content.push({
                        text: greeting_intro + ' ' + greeting_call + ', ',
                        margin: [0, 8],
                        style: 'plain'
                    });
                }

                docDefinition.content.push({
                    text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quote_sentence_01') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('with_purpose') + ' ' + purpose + ': ',
                    margin: [0, 8],
                    style: 'plain'
                }, {
                    text: '',
                    margin: [0, 8]
                });

                var realestate_table = {
                    layout: 'noBorders',
                    table: {

                        headerRows: 1,
                        widths: [15, 65, 200, 120, 50, 50],
                        margin: [0, 8],
                        body: [[{
                            text: '',
                            style: 'plain'
                        }, {
                            text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type'),
                            style: 'plain_bold'
                        }, {
                            text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Address'),
                            style: 'plain_bold'
                        }, {
                            text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cadastral_reference'),
                            style: 'plain_bold'
                        }, {
                            text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Area'),
                            style: 'plain_bold'
                        }, {
                            text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Amount_money'),
                            style: 'plain_bold'
                        }]]
                    }

                };

                for (var i = 0; i < realestates.length; i++) {

                    console.log('**** --- >');
                    console.log(realestates[i]);

                    if (!realestates[i]) {
                        alert('Error: Falta informació d\'un dels immobles o no està present a la base de dades.');
                    } else {

                        var type = '';
                        if (realestates[i].property_type) {
                            if (_this11.currentLocale === 'ca') {
                                type = realestates[i].property_type.usage_type_ca;
                            } else if (_this11.currentLocale === 'en') {
                                type = realestates[i].property_type.usage_type_en;
                            } else {
                                type = realestates[i].property_type.usage_type_es;
                            }
                        } else {

                            realestate_review_table.push([{
                                text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate') + ' nº ' + (i + 1).toString(),
                                style: 'plain_bold'
                            }, {
                                text: 'Manca introduir el tipus d\'immoble',
                                style: 'plain',
                                alignment: 'left'
                            }]);
                        }

                        realestate_table['table']['body'].push(
                        //// PAGE-BREAK
                        [{
                            text: (i + 1).toString() + '- ',
                            style: 'plain'
                        }, {
                            text: type,
                            style: 'plain'
                        }, {
                            text: realestates[i].full_address,
                            style: 'plain'
                        }, {
                            text: realestates[i].cadastral_reference,
                            style: 'plain'
                        }, {
                            text: _this11.intFormat(realestates[i].estimated_built_area, 'm²'),
                            style: 'plain'
                        }, {
                            text: _this11.numFormat(realestates[i].quote_price_incl_travel_expenses, '€'),
                            style: 'plain'
                        }]);

                        total_quote_fees_without_vat = total_quote_fees_without_vat + realestates[i].quote_price_incl_travel_expenses;
                    }
                }

                docDefinition.content.push(
                //// PAGE-BREAK
                realestate_table);

                // final_price includes the discount, but not yet the VAT
                var final_price = 0;
                if (_this11.appraisalquote.final_price) {
                    final_price = _this11.appraisalquote.final_price;
                }

                quote_vat = _this11.roundToTwo(final_price * (_this11.appraisalquote.vat_pct / 100));

                total_quote_fees_incl_vat = final_price + quote_vat;

                docDefinition.content.push({
                    text: '',
                    margin: [0, 10]
                }, {
                    text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Fees') + ': ' + _this11.numFormat(total_quote_fees_without_vat, '€'),
                    margin: [10, 4],
                    style: 'plain_bold',
                    alignment: 'right'
                });
                if (_this11.appraisalquote.discount_pct && _this11.appraisalquote.discount_pct > 0) {
                    docDefinition.content.push({
                        text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Discount') + '* (' + _this11.appraisalquote.discount_pct + '%): ' + _this11.numFormat(final_price - total_quote_fees_without_vat, '€'),
                        margin: [10, 4],
                        style: 'plain_green_bold',
                        alignment: 'right'
                    }, {
                        text: '',
                        margin: [0, 4]
                    }, {
                        text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Fees_incl_discount') + ': ' + _this11.numFormat(final_price, '€'),
                        margin: [10, 4],
                        style: 'plain_bold',
                        alignment: 'right'
                    });
                }

                docDefinition.content.push({
                    text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('VAT') + ' (' + _this11.appraisalquote.vat_pct + '%): ' + _this11.numFormat(quote_vat, '€'),
                    margin: [10, 4],
                    style: 'plain_bold',
                    alignment: 'right'
                }, {
                    text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Total_cost_including_VAT') + ': ' + _this11.numFormat(total_quote_fees_incl_vat, '€'),
                    margin: [10, 4],
                    style: 'h3_blue',
                    alignment: 'right'
                }, {
                    text: '',
                    margin: [0, 10]
                });

                if (_this11.appraisalquote.discount_pct && _this11.appraisalquote.discount_pct > 0 && _this11.appraisalquote.discount_notes) {
                    docDefinition.content.push({
                        text: '* ' + _this11.appraisalquote.discount_notes,
                        margin: [10, 4],
                        style: 'plain',
                        alignment: 'left'
                    }, {
                        text: '',
                        margin: [0, 4]
                    });
                }
                docDefinition.content.push({
                    text: '',
                    pageBreak: 'after'
                }, {
                    text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Payment_conditions').toUpperCase() + ': ',
                    margin: [0, 8],
                    style: 'h3_blue',
                    alignment: 'left'
                }, {
                    text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quote_sentence_02') + '. ',
                    margin: [0, 4],
                    style: 'plain'
                }, {
                    text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quote_sentence_03') + ' (' + _this11.appraisalquote.bank_name + '): ',
                    margin: [0, 4],
                    style: 'plain'
                }, {
                    text: 'IBAN ' + _this11.appraisalquote.iban,
                    margin: [0, 4],
                    style: 'plain_bold'
                }, {
                    text: '',
                    margin: [0, 10]
                }, {
                    text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Note_w') + ': ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quote_sentence_17') + ' ' + _this11.appraisalquote.court_assistance_fees + ' € + IVA. ',
                    margin: [0, 4],
                    style: 'plain_bold_underline'
                }, {
                    text: '',
                    margin: [0, 10]
                }, {
                    text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quote_sentence_04').toUpperCase(),
                    margin: [0, 4],
                    style: 'h3_blue'
                }, {
                    text: '1. ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quote_sentence_05') + '. ',
                    margin: [0, 4],
                    style: 'plain'
                }, {
                    text: '2. ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quote_sentence_06') + ': ',
                    margin: [0, 4],
                    style: 'plain'
                }, {
                    text: '- ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Report_content_text_02'),
                    margin: [10, 4],
                    style: 'plain'
                }, {
                    text: '- ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Report_content_text_03'),
                    margin: [10, 4],
                    style: 'plain'
                }, {
                    text: '- ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Report_content_text_04'),
                    margin: [10, 4],
                    style: 'plain'
                }, {
                    text: '3. ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quote_sentence_07') + '.',
                    margin: [0, 4],
                    style: 'plain'
                }, {
                    text: '',
                    margin: [0, 10]
                }, {
                    text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Required_documentation').toUpperCase(),
                    margin: [0, 8],
                    style: 'h3_blue',
                    alignment: 'left'
                });
                /*
                docDefinition.content.push(
                {
                text: '- ' + Vue.i18n.translate('Quote_sentence_09'),
                margin: [10, 4],
                style: 'plain',
                },
                {
                text: '- ' + Vue.i18n.translate('Quote_sentence_10'),
                margin: [10, 4],
                style: 'plain',
                },
                {
                text: '- ' + Vue.i18n.translate('Quote_sentence_11'),
                margin: [10, 4],
                style: 'plain',
                },
                {
                text: '- ' + Vue.i18n.translate('Quote_sentence_12'),
                margin: [10, 4],
                style: 'plain',
                },
                {
                text: '- ' + Vue.i18n.translate('Quote_sentence_13'),
                margin: [10, 4],
                style: 'plain',
                },
                {
                text: '- ' + Vue.i18n.translate('Quote_sentence_14'),
                margin: [10, 4],
                style: 'plain',
                },
                {
                text: '- ' + Vue.i18n.translate('Quote_sentence_15'),
                margin: [10, 4],
                style: 'plain',
                },
                {
                text: '- ' + Vue.i18n.translate('Quote_sentence_16'),
                margin: [10, 4],
                style: 'plain',
                })
                */

                if (_this11.appraisalquote_requireddocs) {
                    var _currentLocale = _this11.currentLocale;
                    __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(_this11.appraisalquote_requireddocs, function (value) {

                        if (_currentLocale === 'ca') {
                            docDefinition.content.push({
                                text: '- ' + value['name_ca'],
                                margin: [10, 4],
                                style: 'plain'
                            });
                        } else if (_currentLocale === 'en') {

                            docDefinition.content.push({
                                text: '- ' + value['name_en'],
                                margin: [10, 4],
                                style: 'plain'
                            });
                        } else {

                            docDefinition.content.push({
                                text: '- ' + value['name_es'],
                                margin: [10, 4],
                                style: 'plain'
                            });
                        }
                    });
                } else {

                    appraisalquote_review_table.push([{
                        text: _this11.appraisalquote.id,
                        style: 'plain_bold'
                    }, {
                        text: 'Manca introduir el llistat de documentació necessària',
                        style: 'plain',
                        alignment: 'left'
                    }]);
                }

                var s_name = _this11.appraisalquote.signature_name ? _this11.appraisalquote.signature_name : '';

                docDefinition.content.push({
                    text: '',
                    margin: [0, 10]
                }, {
                    text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('At_your_disposal_for_any_clarification') + '. ',
                    margin: [0, 4],
                    style: 'plain'
                }, {
                    text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Kindest_regards') + ', ',
                    margin: [0, 4],
                    style: 'plain'
                }, {
                    image: _this11.appraisalquote.signature_base64 ? _this11.appraisalquote.signature_base64 : 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAIBAQIBAQICAgICAgICAwUDAwMDAwYEBAMFBwYHBwcGBwcICQsJCAgKCAcHCg0KCgsMDAwMBwkODw0MDgsMDAz/2wBDAQICAgMDAwYDAwYMCAcIDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAz/wAARCAABAAEDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD9/KKKKAP/2Q==',
                    width: 164,
                    margin: [0, 4]
                }, {
                    text: s_name,
                    margin: [0, 4],
                    style: 'plain'
                }, {
                    text: 'BARNA-TASA, S.A.',
                    margin: [0, 4],
                    style: 'plain_bold'
                }, {
                    text: _this11.appraisalquote.signature_email ? _this11.appraisalquote.signature_email : '',
                    margin: [0, 4],
                    style: 'plain'
                }, {
                    text: '93 410 05 32',
                    margin: [0, 4],
                    style: 'plain'
                });

                //////// Check empty review tables

                var no_error_text = 'Sense errors detectats.';

                if (realestate_review_table.length === 0) {

                    realestate_review_table = [[{
                        text: no_error_text,
                        style: 'plain'
                    }]];
                }

                if (comparable_review_table.length === 0) {

                    comparable_review_table = [[{
                        text: no_error_text,
                        style: 'plain'
                    }]];
                }

                if (marketstudy_review_table.length === 0) {

                    marketstudy_review_table = [[{
                        text: no_error_text,
                        style: 'plain'
                    }]];
                }

                if (appraisal_review_table.length === 0) {

                    appraisal_review_table = [[{
                        text: no_error_text,
                        style: 'plain'
                    }]];
                }

                if (appraisalfile_review_table.length === 0) {

                    appraisalfile_review_table = [[{
                        text: no_error_text,
                        style: 'plain'
                    }]];
                }

                if (appraisalquote_review_table.length === 0) {

                    appraisalquote_review_table = [[{
                        text: no_error_text,
                        style: 'plain'
                    }]];
                }

                //////// End of check empty review tables

                var reviewDocDefinition = {
                    // settings
                    pageSize: 'A4',
                    pageOrientation: 'portrait',
                    // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
                    pageMargins: [40, 60, 20, 20],
                    // metadata
                    info: {
                        title: 'BARNA-TASA, S.A.',
                        author: 'BARNA-TASA, S.A.',
                        subject: 'BARNA-TASA, S.A.',
                        keywords: 'BARNA-TASA, S.A.',
                        creator: 'BARNA-TASA, S.A.',
                        producer: 'BARNA-TASA, S.A.'
                    },
                    styles: {
                        small: {
                            fontSize: 8,
                            bold: false
                        },
                        small_bold: {
                            fontSize: 8,
                            bold: true
                        },
                        plain: {
                            fontSize: 9,
                            bold: false
                        },
                        plain_bold: {
                            fontSize: 9,
                            bold: true
                        },
                        h2: {
                            fontSize: 16,
                            bold: true
                        },
                        h3: {
                            fontSize: 12,
                            bold: true
                        }
                    },
                    // content
                    content: [{
                        text: 'Informe automàtic de revisió del pressupost ' + full_number,
                        style: 'h2'
                    }, {
                        text: '',
                        margin: [0, 15]
                    },
                    //// END OF BLOCK
                    //// BLOCK START
                    {
                        text: '',
                        margin: [0, 10]
                    }, {
                        text: 'Expedient:',
                        style: 'h3'
                    }, {
                        text: '',
                        margin: [0, 5]
                    }, {
                        layout: 'noBorders',
                        margin: [50, 0],
                        table: {

                            headerRows: 0,
                            widths: [160, '*'],
                            body: appraisalfile_review_table
                        }
                    },
                    //// END OF BLOCK
                    //// BLOCK START
                    {
                        text: '',
                        margin: [0, 10]
                    }, {
                        text: 'Pressupost:',
                        style: 'h3'
                    }, {
                        text: '',
                        margin: [0, 5]
                    }, {
                        layout: 'noBorders',
                        margin: [50, 0],
                        table: {

                            headerRows: 0,
                            widths: [160, '*'],
                            body: appraisalquote_review_table
                        }
                    },
                    //// END OF BLOCK
                    //// BLOCK START
                    {
                        text: '',
                        margin: [0, 10]
                    }, {
                        text: 'Immobles:',
                        style: 'h3'
                    }, {
                        text: '',
                        margin: [0, 5]
                    }, {
                        layout: 'noBorders',
                        margin: [50, 0],
                        table: {

                            headerRows: 0,
                            widths: [160, '*'],
                            body: realestate_review_table
                        }
                    }]
                };

                pdfMake.createPdf(docDefinition).open();
                pdfMake.createPdf(reviewDocDefinition).open();
                // pdfMake.createPdf(docDefinition).download()
                console.log('yeah finished!');
                _this11.master_loading = false;
            });
        },
        onSaveCurrentAppraisalQuote: function onSaveCurrentAppraisalQuote(data) {
            var _this12 = this;

            this.UPDATE_APPRAISALQUOTE({
                object: this.appraisalquote,
                path: this.appraisalquote.path,
                parent_path: this.appraisalquote.parent_path,
                key: this.appraisalquote.id
            }).then(function (res) {
                // router.go(-1)
                if (data.go_up) {
                    _this12.onGoUp();
                }
            });
        },

        editRealEstate: function editRealEstate(entity) {
            var _this13 = this;

            // console.log('edit realestate...')
            this.SET_REALESTATE({ path: 'realestates' + '/' + entity.id + '/' }).then(function (res) {
                _this13.$router.push({ name: 'realestate-editor', query: { id: entity.id } });
            });
        },

        discardRealEstate: function discardRealEstate(entity) {
            var _this14 = this;

            this.master_loading = true;

            this.DELETE({
                key: entity.id,
                path: 'appraisalquotes' + '/' + this.appraisalquote.id + '/' + 'realestates' + '/' + entity.id
            }).then(function (res) {

                _this14.FETCH_APPRAISALQUOTE_REALESTATES({ path: 'appraisalquotes' + '/' + _this14.$route.query.id + '/' + 'realestates' + '/' }).then(function () {
                    _this14.master_loading = false;
                });
            });
        },
        editContact: function editContact(entity) {
            var _this15 = this;

            // console.log('edit realestate...')
            this.SET_CONTACT({ path: 'contacts' + '/' + entity.id + '/' }).then(function (res) {
                _this15.$router.push({ name: 'contact-editor', query: { id: entity.id } });
            });
        },
        discardPetitioner: function discardPetitioner(entity) {
            var _this16 = this;

            this.master_loading = true;

            this.DELETE({
                path: 'appraisalquotes' + '/' + this.appraisalquote.id + '/' + 'petitioners' + '/' + entity.id,
                key: entity.id
            }).then(function (res) {

                _this16.DELETE({
                    path: 'contacts' + '/' + entity.id + '/' + 'appraisalquotes' + '/' + _this16.appraisalquote.id,
                    key: entity.id
                }).then(function (res) {

                    _this16.FETCH_APPRAISALQUOTE_PETITIONERS({ path: 'appraisalquotes' + '/' + _this16.$route.query.id + '/' + 'petitioners' + '/' }).then(function () {
                        _this16.master_loading = false;
                    });
                });
            });
        },
        onGoBack: function onGoBack() {
            __WEBPACK_IMPORTED_MODULE_11__router_index_js__["a" /* default */].go(-1);
        },

        onGoUp: function onGoUp() {
            this.$router.push({ name: 'appraisalfile-editor', query: { id: this.appraisalquote.file_id } });
        }
    }),
    head: {
        title: {
            inner: 'Edit appraisalquote'
        }
    }

});

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__router_index_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__options_petitioner_types__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__options_status_reports__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__options_honorific_titles__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__options_person_types__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Datatable_datatable_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Datatable_datatable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Datatable_datatable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Datatable_datatable_column_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Datatable_datatable_column_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Datatable_datatable_column_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__aggregators_aggregators_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__formatters_formatters_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Toggles_checkbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Toggles_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_Toggles_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Paginator_paginator_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Paginator_paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_Paginator_paginator_vue__);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var numeral=__webpack_require__(119);var _require=__webpack_require__(40),map=_require.map;var _require2=__webpack_require__(40),forEach=_require2.forEach;var pdfMake=__webpack_require__(211);var pdfFonts=__webpack_require__(212);pdfMake.vfs=pdfFonts.pdfMake.vfs;pdfMake.tableLayouts={exampleLayout:{hLineWidth:function hLineWidth(i,node){if(i===0||i===node.table.body.length){return 0;}return i===node.table.headerRows?2:1;},vLineWidth:function vLineWidth(i){return 0;},hLineColor:function hLineColor(i){return i===1?'black':'#aaa';},paddingLeft:function paddingLeft(i){return i===0?0:8;},paddingRight:function paddingRight(i,node){return i===node.table.widths.length-1?0:8;}// paddingLeft: function(i, node) { return 4; },
// paddingRight: function(i, node) { return 4; },
// paddingTop: function(i, node) { return 2; },
// paddingBottom: function(i, node) { return 2; },
// fillColor: function (i, node) { return null; }
},tocSectionLevel2:{hLineWidth:function hLineWidth(i,node){return 0.5;}},width0:{hLineWidth:function hLineWidth(i,node){return 0.5;}},width1:{hLineWidth:function hLineWidth(i,node){return 1;}},width2:{hLineWidth:function hLineWidth(i,node){return 2;}}};/* harmony default export */ __webpack_exports__["default"] = ({name:'appraisalreport-editor',mixins:[__WEBPACK_IMPORTED_MODULE_4__mixins__["d" /* dateMixin */],__WEBPACK_IMPORTED_MODULE_4__mixins__["a" /* localStorageMixin */],__WEBPACK_IMPORTED_MODULE_4__mixins__["f" /* mathMixin */],__WEBPACK_IMPORTED_MODULE_4__mixins__["e" /* objectsMixin */],__WEBPACK_IMPORTED_MODULE_4__mixins__["j" /* dataURLMixin */],__WEBPACK_IMPORTED_MODULE_4__mixins__["c" /* utilsMixin */]],data:function data(){return{cover_photo_dataURL:'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==',loading:true,value:null,no_result_color:'black',master_loading:true,selecting_realestate:false,creating_contact:false,filesOpen:true,fileOpen:true,reportOpen:true,error:null,success_message:null,metadata_text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Version'),reportcontent_text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Report_content'),add_petitioner_button_text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_petitioner'),report_title_error_text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Report_title_missing_error_text'),realestates_missing_error_text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estates_missing_error_text'),new_real_estate_button_text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_real_estate'),select_real_estate_button_text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_real_estate'),cancel_button_text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cancel'),goup_button_text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_up')+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),pdf_button_text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Print_report_s_certificate_in_PDF'),save_button_text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save'),save_and_go_up_button_text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save')+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and')+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('go_up'),page_dirty_text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('The_page_contains_unsaved_changes'),actions_text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Actions'),filter_placeholder:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type_here_to_filter_paginated_data'),realestate_appraisaldateValue:null,duplicate_text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Duplicate'),edit_text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Edit'),delete_text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Delete'),discard_text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Discard'),openlink_text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Open_link_in_new_tab'),petitionerValue:null,entityValue:null,appraiserValue:null,supervisorValue:null,importRealEstateValue:null,petitioner_typeValue:null,statusValue:null,status_reportsOptions:__WEBPACK_IMPORTED_MODULE_14__options_status_reports__["a" /* default */],petitioner_typeOptions:__WEBPACK_IMPORTED_MODULE_13__options_petitioner_types__["a" /* default */],honorificTitleOptions:__WEBPACK_IMPORTED_MODULE_15__options_honorific_titles__["a" /* default */],personTypeOptions:__WEBPACK_IMPORTED_MODULE_16__options_person_types__["a" /* default */],realestate_table:{striped:true,editable:false,lineNumbers:true,filter:null,currency:'EUR',dateFormat:'DD/MM/YYYY',columns:[{id:'index',label:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Index'),width:'80px',sortable:true,groupable:false,aggregators:[]},{id:'property_type',label:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Property_type'),width:'160px',sortable:true,groupable:false,aggregators:[]},{id:'street_name',label:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Street_name'),width:'160px',sortable:true,groupable:false,aggregators:[]},{id:'street_number',label:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Street_number'),width:'80px',sortable:true,groupable:false,aggregators:[]},{id:'floor',label:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Floor'),width:'80px',sortable:true,groupable:false,aggregators:[]},{id:'door',label:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Door'),width:'80px',sortable:true,groupable:false,aggregators:[]},{id:'municipality',label:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Municipality'),width:'160px',sortable:true,groupable:false,alignment:'right',aggregators:[]},{id:'appraisal_id',label:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Appraisal')+' Id',width:'240px',sortable:true,groupable:false,aggregators:[]},{id:'appraisaldate',label:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Appraisal_date'),width:'160px',sortable:true,groupable:false,aggregators:[]},{id:'realestate_total_adopted_value',label:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Appraisal_value'),width:'160px',sortable:true,groupable:false,aggregators:[__WEBPACK_IMPORTED_MODULE_19__aggregators_aggregators_js__["a" /* default */].total],alignment:'right',formatter:function formatter(value){return __WEBPACK_IMPORTED_MODULE_20__formatters_formatters_js__["a" /* default */].currency(value,0,'EUR');}}],selected:[]},petitioner_table:{striped:true,editable:false,lineNumbers:true,filter:null,currency:'EUR',dateFormat:'DD/MM/YYYY',columns:[{id:'complete_name',label:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Petitioner'),width:null,sortable:true,groupable:false,aggregators:[]},{id:'tin',label:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('TIN'),width:null,sortable:true,groupable:false,aggregators:[]},{id:'complete_fiscal_address',label:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Fiscal_address'),width:null,sortable:true,groupable:false,aggregators:[]}],selected:[]}};},created:function created(){var _this=this;this.FETCH_APPRAISALREPORT_REALESTATES({path:'appraisalreports'+'/'+this.$route.query.id+'/'+'realestates',appraisalreport_id:this.$route.query.id}).then(function(){_this.FETCH_CONTACTS({path:'contacts'+'/'+_this.$route.query.id+'/'}).then(function(){_this.FETCH_APPRAISALREPORT_PETITIONERS({path:'appraisalreports'+'/'+_this.$route.query.id+'/'+'petitioners',appraisalreport_id:_this.$route.query.id}).then(function(){_this.FETCH_ENTITIES().then(function(){_this.FETCH_APPRAISERS().then(function(){_this.FETCH_SUPERVISORS().then(function(){_this.master_loading=false;});});});});});});},components:{Bar:__WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default.a,Message:__WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default.a,IconButton:__WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default.a,Spinner:__WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default.a,SideNavBar:__WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default.a,Checkbox:__WEBPACK_IMPORTED_MODULE_21__components_Toggles_checkbox_vue___default.a,Datatable:__WEBPACK_IMPORTED_MODULE_17__components_Datatable_datatable_vue___default.a,DatatableColumn:__WEBPACK_IMPORTED_MODULE_18__components_Datatable_datatable_column_vue___default.a,Paginator:__WEBPACK_IMPORTED_MODULE_22__components_Paginator_paginator_vue___default.a},computed:_extends({},__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['theme','tags_display','contacts','currentLocale','appraisal','entities','supervisors','appraisers','appraisalfile','appraisalreport','appraisalreport_realestates','appraisalreport_petitioners','realestate','realestates','contact','user'])),methods:_extends({},__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['CHECK_APPRAISALREPORT_REALESTATE_APPRAISALS','CREATE_NEW_REALESTATE','CREATE_NEW_APPRAISAL','CREATE_NEW_MARKETSTUDY','CREATE_NEW_CONTACT','RESET_CONTACT','DELETE','DELETE_REALESTATE','FETCH_APPRAISAL','FETCH_APPRAISAL_PHOTOGRAPHS','FETCH_APPRAISALREPORT_REALESTATES','FETCH_APPRAISALREPORT_PETITIONERS','FETCH_CONTACTS','FETCH_ENTITIES','FETCH_REALESTATE','FETCH_REALESTATES','FETCH_APPRAISERS','FETCH_SUPERVISORS','FETCH','GET','RESET_APPRAISAL','RESET_MARKETSTUDY','RESET_REALESTATE','SET_REALESTATE','SET_VALUE','UPDATE_REALESTATE','SET_APPRAISALREPORT_REALESTATE_APPRAISAL_ID','SET_APPRAISALREPORT_REPORTDATE','SET_APPRAISALREPORT_SEND_TO_BDE','SET_APPRAISALREPORT_DESCRIPTION','SET_APPRAISALREPORT_TITLE','SET_APPRAISALREPORT_NUMBER','SET_APPRAISALREPORT_VERSION','SET_APPRAISALREPORT_ENTITY','SET_APPRAISALREPORT_SUPERVISOR','SET_APPRAISALREPORT_APPRAISER','SET_APPRAISALREPORT_PETITIONER','SET_APPRAISALREPORT_PETITIONER_TYPE','SET_APPRAISALREPORT_STATUS','SET_APPRAISALREPORT_FULL_NUMBER','UPDATE_APPRAISAL','UPDATE_APPRAISALREPORT','UPDATE_APPRAISALREPORT_REALESTATE_APPRAISAL_ID','SET_APPRAISALREPORT_SIGNATURE_SV_NAME','SET_APPRAISALREPORT_SIGNATURE_SV_BASE64','SET_APPRAISALREPORT_SIGNATURE_SV_DATE','SET_APPRAISALREPORT_SIGNATURE_SV_EMAIL','SET_APPRAISALREPORT_SIGNATURE_SV_UID','SET_APPRAISALREPORT_SIGNATURE_AP_NAME','SET_APPRAISALREPORT_SIGNATURE_AP_BASE64','SET_APPRAISALREPORT_SIGNATURE_AP_DATE','SET_APPRAISALREPORT_SIGNATURE_AP_EMAIL','SET_APPRAISALREPORT_SIGNATURE_AP_UID','SET_APPRAISALREPORT_IS_SIGNED','SET_APPRAISALREPORT_IS_SV_SIGNED','SET_APPRAISALREPORT_IS_AP_SIGNED','SET_CONTACT','SET_CONTACT_MAIN_EMAIL','SET_CONTACT_NAME','SET_CONTACT_ORGANIZATION','SET_CONTACT_PERSON_TYPE','SET_CONTACT_REPRESENTATIVE','SET_CONTACT_REPRESENTATIVE_TIN','SET_CONTACT_SURNAMES','SET_CONTACT_TIN','SET_CONTACT_TITLE','SET_CONTACT_COMPLETE_NAME','SET_CONTACT_COMPLETE_FISCAL_ADDRESS','UPDATE_CONTACT']),{set_appraisalreport_description:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function(e){this.SET_APPRAISALREPORT_DESCRIPTION(e.target.value);},1000),set_appraisalreport_reportdate:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function(e){this.SET_APPRAISALREPORT_REPORTDATE(e.target.value);},1000),set_appraisalreport_number:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function(e){this.SET_APPRAISALREPORT_NUMBER(Number(e.target.value));var filenumber='';filenumber=this.appraisalfile.number;var s=Number(e.target.value)+'';while(s.length<2){s='0'+s;}var reportnumber=s;var p=this.appraisalreport.version+'';while(p.length<2){p='0'+p;}var reportversion=p;var fullnumber=filenumber+'/'+reportnumber+'/'+reportversion;this.SET_APPRAISALREPORT_FULL_NUMBER(fullnumber);},1000),set_appraisalreport_send_to_bde:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function(e){this.SET_APPRAISALREPORT_SEND_TO_BDE(e.target.value);},1000),set_appraisalreport_title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function(e){this.SET_APPRAISALREPORT_TITLE(e.target.value);},1000),set_appraisalreport_version:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function(e){this.SET_APPRAISALREPORT_VERSION(Number(e.target.value));var filenumber='';filenumber=this.appraisalfile.number;var s=this.appraisalreport.number+'';while(s.length<2){s='0'+s;}var reportnumber=s;var p=Number(e.target.value)+'';while(p.length<2){p='0'+p;}var reportversion=p;var fullnumber=filenumber+'/'+reportnumber+'/'+reportversion;this.SET_APPRAISALREPORT_FULL_NUMBER(fullnumber);},1000),set_appraisalreport_petitioner:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function(e){this.SET_APPRAISALREPORT_PETITIONER(e);},1000),set_appraisalreport_petitioner_type:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function(e){this.SET_APPRAISALREPORT_PETITIONER_TYPE(e);},1000),set_appraisalreport_entity:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function(e){this.SET_APPRAISALREPORT_ENTITY(e);},1000),set_appraisalreport_supervisor:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function(e){this.SET_APPRAISALREPORT_SUPERVISOR(e);},1000),set_appraisalreport_appraiser:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function(e){this.SET_APPRAISALREPORT_APPRAISER(e);},1000),set_appraisalreport_status:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function(e){this.SET_APPRAISALREPORT_STATUS(e);},1000),set_appraisalreport_signature_sv_name:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function(e){this.SET_APPRAISALREPORT_SIGNATURE_SV_NAME(e.target.value);},1000),set_appraisalreport_signature_sv_base64:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function(e){this.SET_APPRAISALREPORT_SIGNATURE_SV_BASE64(e.target.value);},1000),set_appraisalreport_signature_sv_date:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function(e){this.SET_APPRAISALREPORT_SIGNATURE_SV_DATE(e.target.value);},1000),set_appraisalreport_signature_sv_email:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function(e){this.SET_APPRAISALREPORT_SIGNATURE_SV_EMAIL(e.target.value);},1000),set_appraisalreport_signature_sv_uid:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function(e){this.SET_APPRAISALREPORT_SIGNATURE_SV_UID(e.target.value);},1000),set_appraisalreport_signature_ap_name:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function(e){this.SET_APPRAISALREPORT_SIGNATURE_AP_NAME(e.target.value);},1000),set_appraisalreport_signature_ap_base64:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function(e){this.SET_APPRAISALREPORT_SIGNATURE_AP_BASE64(e.target.value);},1000),set_appraisalreport_signature_ap_date:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function(e){this.SET_APPRAISALREPORT_SIGNATURE_AP_DATE(e.target.value);},1000),set_appraisalreport_signature_ap_email:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function(e){this.SET_APPRAISALREPORT_SIGNATURE_AP_EMAIL(e.target.value);},1000),set_appraisalreport_signature_ap_uid:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function(e){this.SET_APPRAISALREPORT_SIGNATURE_AP_UID(e.target.value);},1000),set_appraisalreport_is_signed:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function(e){},0),set_appraisalreport_is_sv_signed:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function(e){if(this.appraisalreport.is_sv_signed){var s=this.user.s?this.user.s:null;var email=this.user.email?this.user.email:'';var name=this.user.name+' '+this.user.surnames;var id=this.user.id?this.user.id:null;//console.log(id)
if(!id){alert('Manca uid. Contactar amb l\'administrador del l\'app.');}this.SET_APPRAISALREPORT_SIGNATURE_SV_BASE64(s);this.SET_APPRAISALREPORT_SIGNATURE_SV_NAME(name);this.SET_APPRAISALREPORT_SIGNATURE_SV_EMAIL(email);this.SET_APPRAISALREPORT_SIGNATURE_SV_UID(id);// unix seconds
this.SET_APPRAISALREPORT_SIGNATURE_SV_DATE(__WEBPACK_IMPORTED_MODULE_3_moment___default()().format('X'));this.onSaveCurrentAppraisalReport({go_up:false});}else{this.SET_APPRAISALREPORT_SIGNATURE_SV_BASE64(null);this.SET_APPRAISALREPORT_SIGNATURE_SV_NAME(null);this.SET_APPRAISALREPORT_SIGNATURE_SV_EMAIL(null);this.SET_APPRAISALREPORT_SIGNATURE_SV_UID(null);this.SET_APPRAISALREPORT_SIGNATURE_SV_DATE(null);this.onSaveCurrentAppraisalReport({go_up:false});}this.$forceUpdate();},0),set_appraisalreport_is_ap_signed:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function(e){if(this.appraisalreport.is_ap_signed){var s=this.user.s?this.user.s:null;var email=this.user.email?this.user.email:'';var name=this.user.name+' '+this.user.surnames;var id=this.user.id?this.user.id:null;//console.log(id)
if(!id){alert('Manca uid. Contactar amb l\'administrador del l\'app.');}this.SET_APPRAISALREPORT_SIGNATURE_AP_BASE64(s);this.SET_APPRAISALREPORT_SIGNATURE_AP_NAME(name);this.SET_APPRAISALREPORT_SIGNATURE_AP_EMAIL(email);this.SET_APPRAISALREPORT_SIGNATURE_AP_UID(id);// unix seconds
this.SET_APPRAISALREPORT_SIGNATURE_AP_DATE(__WEBPACK_IMPORTED_MODULE_3_moment___default()().format('X'));this.onSaveCurrentAppraisalReport({go_up:false});}else{this.SET_APPRAISALREPORT_SIGNATURE_AP_BASE64(null);this.SET_APPRAISALREPORT_SIGNATURE_AP_NAME(null);this.SET_APPRAISALREPORT_SIGNATURE_AP_EMAIL(null);this.SET_APPRAISALREPORT_SIGNATURE_AP_UID(null);this.SET_APPRAISALREPORT_SIGNATURE_AP_DATE(null);this.onSaveCurrentAppraisalReport({go_up:false});}this.$forceUpdate();},0),set_contact_name:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function(e){var name=e.target.value;var surnames='';if(this.contact.surnames){surnames=this.contact.surnames;}var complete_name=surnames+', '+name;if(!surnames){complete_name=name;}this.SET_CONTACT_NAME(name);this.SET_CONTACT_COMPLETE_NAME(complete_name);},500),set_contact_main_email:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function(e){this.SET_CONTACT_MAIN_EMAIL(e.target.value);},500),set_contact_organization:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function(e){this.SET_CONTACT_ORGANIZATION(e.target.value);},500),set_contact_person_type:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function(e){this.SET_CONTACT_PERSON_TYPE(e);},500),set_contact_representative:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function(e){this.SET_CONTACT_REPRESENTATIVE(e.target.value);},500),set_contact_representative_tin:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function(e){this.SET_CONTACT_REPRESENTATIVE_TIN(e.target.value);},500),set_contact_surnames:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function(e){var surnames=e.target.value;var name='';if(this.contact.name){name=this.contact.name;}var complete_name=surnames+', '+name;if(!surnames){complete_name=name;}this.SET_CONTACT_SURNAMES(surnames);this.SET_CONTACT_COMPLETE_NAME(complete_name);},500),set_contact_tin:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function(e){this.SET_CONTACT_TIN(e.target.value);},500),set_contact_title:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function(e){this.SET_CONTACT_TITLE(e);},500),set_contact_complete_fiscal_address:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function(e){this.SET_CONTACT_COMPLETE_FISCAL_ADDRESS(e.target.value);},500),set_entity_index:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function(e,f){//this.master_loading = true
var realestate_index=e.target.value;console.log('index: ');console.log(realestate_index);//
//                console.log('e: ')
//                console.log(e)
//
//                console.log('f: ')
//                console.log(f)
this.SET_VALUE({object:realestate_index,path:'appraisalreports'+'/'+this.appraisalreport.id+'/'+'realestates'+'/'+f.id+'/'+'index'+'/',report_id:this.appraisalreport.id,key:f.id}).then(function(res){});this.SET_VALUE({object:realestate_index,path:'realestates'+'/'+f.id+'/'+'index'+'/',key:f.id}).then(function(res){});/*
                this.SET_VALUE({
                    object: realestate_index,
                    path: 'appraisalreports' + '/' + this.appraisalreport.id + '/' + 'realestates' + '/' + f.id + '/' + 'index' + '/',
                    report_id: this.appraisalreport.id,
                    key: f.id
                }).then((res) => {


                    this.FETCH_APPRAISALREPORT_REALESTATES({
                        path: 'appraisalreports' + '/' + this.appraisalreport.id + '/' + 'realestates' + '/',
                        appraisalreport_id: this.appraisalreport.id
                    })
                        .then(() => {
                            this.$forceUpdate()
                            this.master_loading = false
                        })

                })
                */},500),set_import_realestate:function set_import_realestate(){console.log('set_import_realestate');/*
				this.master_loading = true
				this.FETCH_TEMP_REALESTATE_MARKETSTUDIES({path: 'realestate_marketstudies' + '/' + this.marketstudy.importRealEstate.id + '/'})
					.then(() => {
						this.master_loading = false
					})
					*/},onSelectNewRealEstate:function onSelectNewRealEstate(){var _this2=this;this.master_loading=true;this.onSaveCurrentAppraisalReport({go_up:false});this.FETCH_REALESTATES({path:'realestates'}).then(function(){_this2.master_loading=false;_this2.selecting_realestate=true;});},onImportNewRealEstate:function onImportNewRealEstate(data){var _this3=this;this.selecting_realestate=false;this.master_loading=true;this.GET({path:'realestates'+'/'+data.id}).then(function(res){console.log(' *^*^*^*^*^*^*^*^*^*^ get realestate res: ');console.log(res);var new_object=res;new_object['report_id']=_this3.appraisalreport.id;new_object['file_id']=_this3.appraisalfile.id;new_object['file_number']=_this3.appraisalfile.number;new_object['report_number']=_this3.appraisalreport.number;new_object['report_version']=_this3.appraisalreport.version;var realestate_index=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(_this3.appraisalreport_realestates)+1;console.log('realestate_index: ');console.log(realestate_index);_this3.UPDATE_REALESTATE({object:new_object,path:'realestates'+'/'+new_object.id,report_id:_this3.appraisalreport.id,// parent_path: 'appraisalreports' + '/' + this.appraisalreport.id + '/' + 'realestates' + '/',
key:new_object.id}).then(function(res){_this3.SET_VALUE({object:realestate_index,path:'appraisalreports'+'/'+_this3.appraisalreport.id+'/'+'realestates'+'/'+new_object.id+'/'+'index'+'/',report_id:_this3.appraisalreport.id,key:new_object.id}).then(function(res){_this3.master_loading=true;_this3.FETCH_APPRAISALREPORT_REALESTATES({path:'appraisalreports'+'/'+_this3.appraisalreport.id+'/'+'realestates'+'/',appraisalreport_id:_this3.appraisalreport.id}).then(function(){_this3.$forceUpdate();_this3.master_loading=false;});});});});},onCancelImportNewRealEstate:function onCancelImportNewRealEstate(){this.selecting_realestate=false;},onCreateNewRealEstate:function onCreateNewRealEstate(){var _this4=this;this.selecting_realestate=false;this.master_loading=true;this.RESET_REALESTATE().then(function(res){_this4.CREATE_NEW_REALESTATE({report_id:_this4.appraisalreport.id,file_id:_this4.appraisalfile.id,file_number:_this4.appraisalfile.number,report_number:_this4.appraisalreport.number,report_version:_this4.appraisalreport.version,path:'realestates'+'/'}).then(function(res){_this4.RESET_APPRAISAL().then(function(res){_this4.CREATE_NEW_APPRAISAL({path:'realestate_appraisals'+'/'+_this4.realestate.id+'/',parent_path:'realestates'+'/'+_this4.realestate.id+'/'+'appraisals'+'/',file_id:_this4.appraisalfile.id,realestate_id:_this4.realestate.id}).then(function(res){_this4.UPDATE_APPRAISALREPORT_REALESTATE_APPRAISAL_ID({appraisal_id:_this4.appraisal.id,appraisaldate:_this4.appraisal.appraisaldate,appraisalreport_id:_this4.appraisalreport.id,realestate_id:_this4.realestate.id});_this4.UPDATE_APPRAISAL({key:_this4.appraisal.id,object:_this4.appraisal,parent_path:'realestates/'+_this4.realestate.id+'/'+'appraisals'+'/',path:_this4.appraisal.path+_this4.appraisal.id,realestate_id:_this4.realestate.id});_this4.RESET_MARKETSTUDY().then(function(res){_this4.CREATE_NEW_MARKETSTUDY({path:'realestate_marketstudies'+'/'+_this4.realestate.id+'/',parent_path:'realestates'+'/'+_this4.realestate.id+'/'+'marketstudies'+'/',file_id:_this4.appraisalfile.id,realestate_id:_this4.realestate.id,appraisal_id:_this4.appraisal.id}).then(function(res){// this.$router.push({name: 'marketstudy-editor', query: {id: this.appraisal.id}})
_this4.master_loading=false;_this4.$router.push({name:'realestate-editor',query:{id:_this4.realestate.id}});});});});});});});},checkCreateNewRealEstate:function checkCreateNewRealEstate(){if(this.appraisalreport.dirty){var result=window.confirm(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('There_are_unsaved_changes')+'. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Unsaved_data_will_be_lost')+'. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Continue_q'));if(result){this.onCreateNewRealEstate();}}else{this.onCreateNewRealEstate();}},onAddNewPetitioner:function onAddNewPetitioner(){var _this5=this;this.master_loading=true;var filenumber='';filenumber=this.appraisalfile.number;var s=this.appraisalreport.number+'';while(s.length<2){s='0'+s;}var reportnumber=s;var p=this.appraisalreport.version+'';while(p.length<2){p='0'+p;}var reportversion=p;var obj={};if(this.appraisalreport_petitioners){obj=this.appraisalreport_petitioners;}var parent_obj={};parent_obj['full_number']=filenumber+'/'+reportnumber+'/'+reportversion;parent_obj['reportdate']=this.appraisalreport.reportdate;parent_obj['id']=this.appraisalreport.id;// console.log('heypppppppp')
// console.log(obj)
var contact_id=this.appraisalreport.petitioner.id;obj[contact_id]=this.appraisalreport.petitioner;this.SET_VALUE({object:obj,path:'appraisalreports'+'/'+this.$route.query.id+'/'+'petitioners'}).then(function(res){_this5.SET_VALUE({object:parent_obj,path:'contacts'+'/'+contact_id+'/'+'appraisalreports'+'/'+_this5.$route.query.id}).then(function(res){_this5.FETCH_APPRAISALREPORT_PETITIONERS({path:'appraisalreports'+'/'+_this5.$route.query.id+'/'+'petitioners',appraisalreport_id:_this5.$route.query.id}).then(function(){_this5.master_loading=false;});});});},editContact:function editContact(entity){var _this6=this;// console.log('edit realestate...')
this.SET_CONTACT({path:'contacts'+'/'+entity.id+'/'}).then(function(res){_this6.$router.push({name:'contact-editor',query:{id:entity.id}});});},discardPetitioner:function discardPetitioner(entity){var _this7=this;this.master_loading=true;this.DELETE({path:'appraisalreports'+'/'+this.appraisalreport.id+'/'+'petitioners'+'/'+entity.id,key:entity.id}).then(function(res){_this7.DELETE({path:'contacts'+'/'+entity.id+'/'+'appraisalreports'+'/'+_this7.appraisalreport.id,key:entity.id}).then(function(res){_this7.FETCH_APPRAISALREPORT_PETITIONERS({path:'appraisalreports'+'/'+_this7.$route.query.id+'/'+'petitioners'+'/'}).then(function(){_this7.master_loading=false;});});});},onAddNewContact:function onAddNewContact(){var _this8=this;this.RESET_CONTACT().then(function(res){_this8.creating_contact=true;});},onCreateNewContact:function onCreateNewContact(){var _this9=this;// vigilar, que no es guarda la id, date_created, path
// al crear contacte d'empreses --> title amb gender neutral?
var obj_copy=JSON.parse(JSON.stringify(this.contact));console.log('!!! --->');console.log(obj_copy);this.creating_contact=false;this.master_loading=true;this.CREATE_NEW_CONTACT({path:'contacts',creating_from_main:false}).then(function(res){obj_copy['id']=_this9.contact.id;obj_copy['date_created']=_this9.contact.date_created;obj_copy['path']=_this9.contact.path;_this9.UPDATE_CONTACT({object:obj_copy,path:'contacts'+'/'+res.key}).then(function(res){_this9.FETCH_CONTACTS({path:'contacts'+'/'}).then(function(){_this9.SET_APPRAISALREPORT_PETITIONER(_this9.contact);_this9.master_loading=false;});});});},onCancelCreateNewContact:function onCancelCreateNewContact(){this.creating_contact=false;},set_appraisalreport_realestate_appraisal_id:__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function(e,realestate_id){var _this10=this;this.SET_APPRAISALREPORT_REALESTATE_APPRAISAL_ID({path:'appraisalreports'+'/'+this.$route.query.id+'/'+'realestates'+'/'+realestate_id+'/'+'appraisal_id',value:e}).then(function(res){_this10.$forceUpdate();});},1000),numFormat:function numFormat(value,symbol){if(!value||value===0||value===''||value==='-'){return'-';}else{return numeral(value).format('0,0.00')+' '+symbol;}},intFormat:function intFormat(value,symbol){if(!value||value===0||value===''||value==='-'){return'-';}else{return numeral(value).format('0,0')+' '+symbol;}},checkBeforeOnCreatePdf:function checkBeforeOnCreatePdf(data){var any_has_no_id=false;__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(this.appraisalreport_realestates,function(value){if(!value['appraisal_id']){any_has_no_id=true;}});if(!any_has_no_id){this.onCreatePdf(data);}else{alert('Revisar la taula "Immobles valorats en aquest informe". Manca indicar la ID de taxació d\'algun immoble.');}},onCreatePdf:function onCreatePdf(data){var _this11=this;this.master_loading=true;// guardar automàticament
this.onSaveCurrentAppraisalReport({go_up:false});// TODO: comprovar que totes les appraisals incloses en el appraisalreport tinguin la mateixa finalitat declarada, sinó fer apareixèr un warning message
var realestates=[];var appraisals=[];var marketstudies=[];var fetchAppraisal=function fetchAppraisal(data){return new Promise(function(resolve,reject){_this11.$store.dispatch('FETCH_APPRAISAL',data).then(function(res){appraisals.push(res);resolve(res);});});};var fetchRealEstate=function fetchRealEstate(data){return new Promise(function(resolve,reject){_this11.$store.dispatch('FETCH_REALESTATE',data).then(function(res){console.log('fetching realestate...');realestates.push(res);resolve(res);});});};var database_fetch=function database_fetch(data){return new Promise(function(resolve,reject){_this11.$store.dispatch('FETCH',data).then(function(res){console.log('fetching...');realestates.push(res);resolve(res);});});};var canvas_to_data_url=function canvas_to_data_url(data){return new Promise(function(resolve,reject){// fetch from the WHATWG fetch api:
var toDataURL=function toDataURL(url){return fetch(url).then(function(response){return response.blob();}).then(function(blob){return new Promise(function(resolve,reject){var reader=new FileReader();reader.onloadend=function(){return resolve(reader.result);};reader.onerror=reject;reader.readAsDataURL(blob);});});};toDataURL(data.src).then(function(dataUrl){// console.log('RESULT:', dataUrl)
resolve({data_url:dataUrl,footer:data.footer,is_cover_photo:data.is_cover_photo});});/*
                        console.log('***** src: ')
                        console.log(data.src)
                        let img = new Image()
                        img.crossOrigin = 'Anonymous'
                        img.onload = function () {
                            let canvas = document.createElement('CANVAS')
                            let ctx = canvas.getContext('2d')
                            let dataURL
                            canvas.height = this.naturalHeight
                            canvas.width = this.naturalWidth
                            ctx.drawImage(this, 0, 0)
                            dataURL = canvas.toDataURL()
							// console.log(dataURL)
                            resolve(dataURL)
                        }
                        img.src = data.src
                        if (img.complete || img.complete === undefined) {
                            img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw=='
                            img.src = data.src
                        }
                        */});};var google_canvas_to_data_url=function google_canvas_to_data_url(data){console.log('google_canvas_to_data_url data!: ');console.log(data);return new Promise(function(resolve,reject){// fetch from the WHATWG fetch api:
var toDataURL=function toDataURL(url){return fetch(url).then(function(response){return response.blob();}).then(function(blob){return new Promise(function(resolve,reject){var reader=new FileReader();reader.onloadend=function(){return resolve(reader.result);};reader.onerror=reject;reader.readAsDataURL(blob);});});};if(data.src){toDataURL(data.src).then(function(dataUrl){// console.log('RESULT:', dataUrl)
resolve({data_url:dataUrl,footer:data.footer});});}else{resolve();}});};// address_table portada
var address_table=[];// taula identificació i localització
var appraised_id_table=[];// layour d'elements
var elements_layout={};var appraisal_review_table=[];var realestate_review_table=[];var comparable_review_table=[];var marketstudy_review_table=[];var appraisalfile_review_table=[];var appraisalreport_review_table=[];var certificate_review_table=[];// variables
var property_type='';var property_usage='';var address_street_name='';var address_number='';var address_floor='';var address_door='';var address_block='';var address_staircase='';var address_postal_code='';var address_postal_code_only='';var address_municipality='';var address_province='';var address_long='';var address_short='';var cad_ref='';var reg_est_num='';var purpose_notes='';var appraisaldate='';var reportdate='';var filenumber='';var full_number=this.appraisalreport.full_number?this.appraisalreport.full_number:'';var reportnumber='';var reportversion='';var petitioner='';var petitioner_tin='';var petitioner_address='';var petitioner_type='';var mandatary='';var appraisal_purpose='';var acc_mortgage_market_law='';var acc_eco_decree='';var appraiser='';var appraiser_name='';var appraiser_surnames='';var appraiser_pa_number='';var appraiser_title='';var supervisor='';var supervisor_name='';var supervisor_surnames='';var supervisor_pa_number='';var supervisor_title='';var supervisor_position='';var technician_visiting='';var final_appraisal_value_str='';var certificate_content_obj={};// constant "map" from the 'p-iteration' plugin
map(this.object_to_array(this.appraisalreport_realestates),function(realestate){return database_fetch({path:'realestates'+'/'+realestate.id});}).then(function(result){realestates=result;console.log('realestates before sort: ');console.log(realestates);realestates=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(realestates,'index');console.log('realestates after sort: ');console.log(realestates);// console.log('map result: ')
// console.log(result)
// console.log('result.length: ')
// console.log(result.length)
map(_this11.object_to_array(_this11.appraisalreport_realestates),function(realestate){return database_fetch({path:'realestate_appraisals'+'/'+realestate.id+'/'+realestate.appraisal_id.id});}).then(function(result){appraisals=result;console.log('appraisals result: ');console.log(appraisals);var rooms=[];var covered_outdoors=[];var uncovered_outdoors=[];var comparables=[];var constraints=[];var warnings=[];var notes=[];var photograph_sets=[];var photo_data_urls=[];var content_photo_annexes=[];var content_portrait_photo=[];var registryannex_sets=[];var registryannex_data_urls=[];var content_registryannex=[];var cadasterannex_sets=[];var cadasterannex_data_urls=[];var content_cadasterannex=[];var urbanannex_sets=[];var urbanannex_data_urls=[];var content_urbanannex=[];var planannex_sets=[];var planannex_data_urls=[];var content_planannex=[];var cessionannex_sets=[];var cessionannex_data_urls=[];var content_cessionannex=[];var otherannex_sets=[];var otherannex_data_urls=[];var content_otherannex=[];var map_google_01_data_urls=[];var content_map_google_01=[];var map_google_02_data_urls=[];var content_map_google_02=[];var map_google_03_data_urls=[];var content_map_google_03=[];map(appraisals,function(appraisal){return database_fetch({path:'appraisal_rooms'+'/'+appraisal.id});}).then(function(result){rooms=result;console.log('rooms: ');console.log(rooms);map(appraisals,function(appraisal){return database_fetch({path:'appraisal_covered_outdoors'+'/'+appraisal.id});}).then(function(result){covered_outdoors=result;console.log('covered_outdoors: ');console.log(covered_outdoors);map(appraisals,function(appraisal){return database_fetch({path:'appraisal_uncovered_outdoors'+'/'+appraisal.id});}).then(function(result){uncovered_outdoors=result;console.log('uncovered_outdoors: ');console.log(uncovered_outdoors);map(appraisals,function(appraisal){return database_fetch({path:'marketstudy_ad_comparables'+'/'+appraisal.marketstudy_id});}).then(function(result){comparables=result;console.log('comparables: ');console.log(comparables);map(appraisals,function(appraisal){return database_fetch({path:'appraisal_constraints'+'/'+appraisal.id});}).then(function(result){constraints=result;console.log('constraints: ');console.log(constraints);map(appraisals,function(appraisal){return database_fetch({path:'appraisal_warnings'+'/'+appraisal.id});}).then(function(result){warnings=result;console.log('warnings: ');console.log(warnings);map(appraisals,function(appraisal){return database_fetch({path:'appraisal_notes'+'/'+appraisal.id});}).then(function(result){notes=result;console.log('notes: ');console.log(notes);map(appraisals,function(appraisal){return database_fetch({path:'realestate_marketstudies'+'/'+appraisal.realestate_id+'/'+appraisal.marketstudy_id});}).then(function(result){marketstudies=result;console.log('marketstudies: ');console.log(marketstudies);// path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'photographs'
map(appraisals,function(appraisal){return database_fetch({path:'realestate_appraisals'+'/'+appraisal.realestate_id+'/'+appraisal.id+'/'+'photographs'});}).then(function(result){photograph_sets=result;console.log('photograph_sets: ');console.log(photograph_sets);// path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'registryannexes'
map(appraisals,function(appraisal){return database_fetch({path:'realestate_appraisals'+'/'+appraisal.realestate_id+'/'+appraisal.id+'/'+'registryannexes'});}).then(function(result){registryannex_sets=result;console.log('registryannex_sets: ');console.log(registryannex_sets);// path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'cadasterannexes'
map(appraisals,function(appraisal){return database_fetch({path:'realestate_appraisals'+'/'+appraisal.realestate_id+'/'+appraisal.id+'/'+'cadasterannexes'});}).then(function(result){cadasterannex_sets=result;console.log('cadasterannex_sets: ');console.log(cadasterannex_sets);// path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'urbanannexes'
map(appraisals,function(appraisal){return database_fetch({path:'realestate_appraisals'+'/'+appraisal.realestate_id+'/'+appraisal.id+'/'+'urbanannexes'});}).then(function(result){urbanannex_sets=result;console.log('urbanannex_sets: ');console.log(urbanannex_sets);// path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'planannexes'
map(appraisals,function(appraisal){return database_fetch({path:'realestate_appraisals'+'/'+appraisal.realestate_id+'/'+appraisal.id+'/'+'planannexes'});}).then(function(result){planannex_sets=result;console.log('planannex_sets: ');console.log(planannex_sets);// path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'cessionannexes'
map(appraisals,function(appraisal){return database_fetch({path:'realestate_appraisals'+'/'+appraisal.realestate_id+'/'+appraisal.id+'/'+'cessionannexes'});}).then(function(result){cessionannex_sets=result;console.log('cessionannex_sets: ');console.log(cessionannex_sets);// path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'otherannexes'
map(appraisals,function(appraisal){return database_fetch({path:'realestate_appraisals'+'/'+appraisal.realestate_id+'/'+appraisal.id+'/'+'otherannexes'});}).then(function(result){otherannex_sets=result;console.log('otherannex_sets: ');console.log(otherannex_sets);map(realestates,function(realestate){return google_canvas_to_data_url({src:realestate?realestate.map_google_01_url:null,footer:realestate?realestate.google_formatted_address:null});}).then(function(result){map_google_01_data_urls=result;//console.log('map_google_01_data_urls: ')
//console.log(map_google_01_data_urls)
var b_arr=map_google_01_data_urls.filter(Boolean);console.log('b_arr: ');console.log(b_arr);b_arr=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqWith(b_arr,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEqual);console.log('b_arr afer uniq: ');console.log(b_arr);__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(b_arr,function(value){console.log('value: ');console.log(value);var obj={'image':value.data_url,'width':400,'margin':[60,0]};var obj2={'text':'','margin':[60,2]};var obj3={'text':value.footer?value.footer:'','style':'small','margin':[60,0]};var obj4={'text':'','margin':[60,8]};if(value){content_map_google_01.push(obj);content_map_google_01.push(obj2);content_map_google_01.push(obj3);content_map_google_01.push(obj4);}});map(realestates,function(realestate){return google_canvas_to_data_url({src:realestate?realestate.map_google_02_url:null,footer:realestate?realestate.google_formatted_address:null});}).then(function(result){map_google_02_data_urls=result;// console.log('map_google_02_data_urls: ')
// console.log(map_google_02_data_urls)
var b_arr=map_google_02_data_urls.filter(Boolean);console.log('b_arr: ');console.log(b_arr);b_arr=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqWith(b_arr,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEqual);console.log('b_arr afer uniq: ');console.log(b_arr);__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(b_arr,function(value){console.log('value: ');console.log(value);var obj={'image':value.data_url,'width':400,'margin':[60,0]};var obj2={'text':'','margin':[60,2]};var obj3={'text':value.footer?value.footer:'','style':'small','margin':[60,0]};var obj4={'text':'','margin':[60,8]};if(value){content_map_google_02.push(obj);content_map_google_02.push(obj2);content_map_google_02.push(obj3);content_map_google_02.push(obj4);}});map(realestates,function(realestate){return google_canvas_to_data_url({src:realestate?realestate.map_google_03_url:null,footer:realestate?realestate.google_formatted_address:null});}).then(function(result){map_google_03_data_urls=result;// console.log('map_google_03_data_urls: ')
// console.log(map_google_03_data_urls)
var b_arr=map_google_03_data_urls.filter(Boolean);console.log('b_arr: ');console.log(b_arr);b_arr=__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqWith(b_arr,__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isEqual);console.log('b_arr afer uniq: ');console.log(b_arr);__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(b_arr,function(value){console.log('value: ');console.log(value);var obj={'image':value.data_url,'width':400,'margin':[60,0]};var obj2={'text':'','margin':[60,2]};var obj3={'text':value.footer?value.footer:'','style':'small','margin':[60,0]};var obj4={'text':'','margin':[60,8]};if(value){content_map_google_03.push(obj);content_map_google_03.push(obj2);content_map_google_03.push(obj3);content_map_google_03.push(obj4);}});map(_this11.object_to_array(photograph_sets),function(photograph_set){return map(_this11.object_to_array(photograph_set),function(photograph){return canvas_to_data_url({src:photograph.url,footer:_this11.currentLocale==='ca'?photograph.name_ca:_this11.currentLocale==='en'?photograph.name_en:photograph.name_es,is_cover_photo:photograph.is_cover_photo});});}).then(function(result){photo_data_urls=result;console.log('photo_data_urls: ');console.log(photo_data_urls);__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(photo_data_urls,function(value,key){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(value,function(value2){var obj={'image':value2.data_url,'width':400,'margin':[60,0]};var obj_portrait={'image':value2.data_url,// fotos de la laura verticals són força allargades, llavors ha de fer width 300 o salta de pàgina (amplada original: 400)
'width':300,'margin':[110,80]};var obj2={'text':'','margin':[60,2]};var obj3={'text':value2.footer?value2.footer:'','style':'small','margin':[60,0]};var obj4={'text':'','margin':[60,8]};content_photo_annexes.push(obj);content_photo_annexes.push(obj2);content_photo_annexes.push(obj3);content_photo_annexes.push(obj4);if(value2.is_cover_photo){content_portrait_photo.push(obj_portrait);content_portrait_photo.push(obj4);}});});map(_this11.object_to_array(registryannex_sets),function(registryannex_set){return map(_this11.object_to_array(registryannex_set),function(registryannex){return canvas_to_data_url({src:registryannex.url,footer:_this11.currentLocale==='ca'?registryannex.name_ca:_this11.currentLocale==='en'?registryannex.name_en:registryannex.name_es});});}).then(function(result){registryannex_data_urls=result;console.log('registryannex_data_urls: ');console.log(registryannex_data_urls);__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(registryannex_data_urls,function(value,key){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(value,function(value2){var obj={'image':value2.data_url,'width':400,'margin':[60,0]};var obj2={'text':'','margin':[60,2]};var obj3={'text':value2.footer?value2.footer:'','style':'small','margin':[60,0]};var obj4={'text':'','margin':[60,8]};content_registryannex.push(obj);content_registryannex.push(obj2);content_registryannex.push(obj3);content_registryannex.push(obj4);});});map(_this11.object_to_array(cadasterannex_sets),function(cadasterannex_set){return map(_this11.object_to_array(cadasterannex_set),function(cadasterannex){return canvas_to_data_url({src:cadasterannex.url,footer:_this11.currentLocale==='ca'?cadasterannex.name_ca:_this11.currentLocale==='en'?cadasterannex.name_en:cadasterannex.name_es});});}).then(function(result){cadasterannex_data_urls=result;console.log('cadasterannex_data_urls: ');console.log(cadasterannex_data_urls);__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(cadasterannex_data_urls,function(value,key){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(value,function(value2){var obj={'image':value2.data_url,'width':400,'margin':[60,0]};var obj2={'text':'','margin':[60,2]};var obj3={'text':value2.footer?value2.footer:'','style':'small','margin':[60,0]};var obj4={'text':'','margin':[60,8]};content_cadasterannex.push(obj);content_cadasterannex.push(obj2);content_cadasterannex.push(obj3);content_cadasterannex.push(obj4);});});map(_this11.object_to_array(urbanannex_sets),function(urbanannex_set){return map(_this11.object_to_array(urbanannex_set),function(urbanannex){return canvas_to_data_url({src:urbanannex.url,footer:_this11.currentLocale==='ca'?urbanannex.name_ca:_this11.currentLocale==='en'?urbanannex.name_en:urbanannex.name_es});});}).then(function(result){urbanannex_data_urls=result;console.log('urbanannex_data_urls: ');console.log(urbanannex_data_urls);__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(urbanannex_data_urls,function(value,key){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(value,function(value2){var obj={'image':value2.data_url,'width':400,'margin':[60,0]};var obj2={'text':'','margin':[60,2]};var obj3={'text':value2.footer?value2.footer:'','style':'small','margin':[60,0]};var obj4={'text':'','margin':[60,8]};content_urbanannex.push(obj);content_urbanannex.push(obj2);content_urbanannex.push(obj3);content_urbanannex.push(obj4);});});map(_this11.object_to_array(planannex_sets),function(planannex_set){return map(_this11.object_to_array(planannex_set),function(planannex){return canvas_to_data_url({src:planannex.url,footer:_this11.currentLocale==='ca'?planannex.name_ca:_this11.currentLocale==='en'?planannex.name_en:planannex.name_es});});}).then(function(result){planannex_data_urls=result;console.log('planannex_data_urls: ');console.log(planannex_data_urls);__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(planannex_data_urls,function(value,key){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(value,function(value2){var obj={'image':value2.data_url,'width':400,'margin':[60,0]};var obj2={'text':'','margin':[60,2]};var obj3={'text':value2.footer?value2.footer:'','style':'small','margin':[60,0]};var obj4={'text':'','margin':[60,8]};content_planannex.push(obj);content_planannex.push(obj2);content_planannex.push(obj3);content_planannex.push(obj4);});});map(_this11.object_to_array(cessionannex_sets),function(cessionannex_set){return map(_this11.object_to_array(cessionannex_set),function(cessionannex){return canvas_to_data_url({src:cessionannex.url,footer:_this11.currentLocale==='ca'?cessionannex.name_ca:_this11.currentLocale==='en'?cessionannex.name_en:cessionannex.name_es});});}).then(function(result){cessionannex_data_urls=result;console.log('cessionannex_data_urls: ');console.log(cessionannex_data_urls);__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(cessionannex_data_urls,function(value,key){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(value,function(value2){var obj={'image':value2.data_url,'width':400,'margin':[60,0]};var obj2={'text':'','margin':[60,2]};var obj3={'text':value2.footer?value2.footer:'','style':'small','margin':[60,0]};var obj4={'text':'','margin':[60,8]};content_cessionannex.push(obj);content_cessionannex.push(obj2);content_cessionannex.push(obj3);content_cessionannex.push(obj4);});});map(_this11.object_to_array(otherannex_sets),function(otherannex_set){return map(_this11.object_to_array(otherannex_set),function(otherannex){return canvas_to_data_url({src:otherannex.url,footer:_this11.currentLocale==='ca'?otherannex.name_ca:_this11.currentLocale==='en'?otherannex.name_en:otherannex.name_es});});}).then(function(result){otherannex_data_urls=result;console.log('otherannex_data_urls: ');console.log(otherannex_data_urls);__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(otherannex_data_urls,function(value,key){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(value,function(value2){var obj={'image':value2.data_url,'width':400,'margin':[60,0]};var obj2={'text':'','margin':[60,2]};var obj3={'text':value2.footer?value2.footer:'','style':'small','margin':[60,0]};var obj4={'text':'','margin':[60,8]};content_otherannex.push(obj);content_otherannex.push(obj2);content_otherannex.push(obj3);content_otherannex.push(obj4);});});// finalitat de taxació
appraisal_purpose='';acc_mortgage_market_law='';acc_eco_decree='';if(appraisals[0].purpose){if(_this11.currentLocale==='ca'){appraisal_purpose=appraisals[0].purpose.name_ca;acc_mortgage_market_law=appraisals[0].purpose.acc_mortgage_market_law.name_ca;acc_eco_decree=appraisals[0].purpose.acc_eco_decree.name_ca;}else if(_this11.currentLocale==='en'){appraisal_purpose=appraisals[0].purpose.name_en;acc_mortgage_market_law=appraisals[0].purpose.acc_mortgage_market_law.name_en;acc_eco_decree=appraisals[0].purpose.acc_eco_decree.name_en;}else{appraisal_purpose=appraisals[0].purpose.name_es;acc_mortgage_market_law=appraisals[0].purpose.acc_mortgage_market_law.name_es;acc_eco_decree=appraisals[0].purpose.acc_eco_decree.name_es;}}else{appraisal_review_table.push([{text:appraisals[0].id,style:'plain_bold'},{text:'Manca introduir la finalitat de taxació.',style:'plain',alignment:'left'}]);}// purpose_notes
purpose_notes='';if(appraisals[0].purpose_notes){purpose_notes=appraisals[0].purpose_notes;}else{appraisal_review_table.push([{text:appraisals[0].id,style:'plain_bold'},{text:'Manca introduir les observacions sobre la finalitat de taxació.',style:'plain',alignment:'left'}]);}// data del valor
appraisaldate='';if(appraisals[0].appraisaldate){appraisaldate=__WEBPACK_IMPORTED_MODULE_3_moment___default()(appraisals[0].appraisaldate).format('DD/MM/YYYY');}else{appraisal_review_table.push([{text:appraisals[0].id,style:'plain_bold'},{text:'Manca introduir la data de taxació.',style:'plain',alignment:'left'}]);}// data de l'informe
reportdate='';if(_this11.appraisalreport.reportdate){reportdate=__WEBPACK_IMPORTED_MODULE_3_moment___default()(_this11.appraisalreport.reportdate).format('DD/MM/YYYY');var today=__WEBPACK_IMPORTED_MODULE_3_moment___default()();var diff=__WEBPACK_IMPORTED_MODULE_3_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_3_moment___default()(_this11.appraisalreport.reportdate),'days');if(diff>0){appraisalreport_review_table.push([{text:'Informe',style:'plain_bold'},{text:'La data de l\'informe és diferent a la data d\'avui. Cal actualitzar la data de l\'informe?',style:'plain',alignment:'left'}]);}}else{appraisalreport_review_table.push([{text:'Informe',style:'plain_bold'},{text:'Manca introduir la data de l\'informe.',style:'plain',alignment:'left'}]);}// appraiser
appraiser='';appraiser_name='';appraiser_surnames='';appraiser_pa_number='';appraiser_title='';if(_this11.appraisalreport.appraiser){appraiser=_this11.appraisalreport.appraiser.complete_name;appraiser_name=_this11.appraisalreport.appraiser.name;appraiser_surnames=_this11.appraisalreport.appraiser.surnames;appraiser_pa_number=_this11.appraisalreport.appraiser.prof_assoc_reg_number;if(_this11.currentLocale==='ca'){appraiser_title=_this11.appraisalreport.appraiser.title_ca;}else if(_this11.currentLocale==='en'){appraiser_title=_this11.appraisalreport.appraiser.title_en;}else{appraiser_title=_this11.appraisalreport.appraiser.title_es;}}else{appraisalreport_review_table.push([{text:'Informe',style:'plain_bold'},{text:'Manca indicar el taxador',style:'plain',alignment:'left'}]);}// supervisor
supervisor='';supervisor_name='';supervisor_surnames='';supervisor_pa_number='';supervisor_title='';supervisor_position='';if(_this11.appraisalreport.supervisor){supervisor=_this11.appraisalreport.supervisor.complete_name;supervisor_name=_this11.appraisalreport.supervisor.name;supervisor_surnames=_this11.appraisalreport.supervisor.surnames;supervisor_pa_number=_this11.appraisalreport.supervisor.prof_assoc_reg_number;if(_this11.currentLocale==='ca'){supervisor_title=_this11.appraisalreport.supervisor.title_ca;supervisor_position=_this11.appraisalreport.supervisor.position_ca;}else if(_this11.currentLocale==='en'){supervisor_title=_this11.appraisalreport.supervisor.title_en;supervisor_position=_this11.appraisalreport.supervisor.position_en;}else{supervisor_title=_this11.appraisalreport.supervisor.title_es;supervisor_position=_this11.appraisalreport.supervisor.position_es;}}else{appraisalreport_review_table.push([{text:'Informe',style:'plain_bold'},{text:'Manca indicar el supervisor',style:'plain',alignment:'left'}]);}// expedient
filenumber='';if(_this11.appraisalfile.number){filenumber=_this11.appraisalfile.number;}else{appraisalfile_review_table.push([{text:_this11.appraisalfile.id,style:'plain_bold'},{text:'Manca introduir el número d\'expedient.',style:'plain',alignment:'left'}]);}// reportnumber
reportnumber='';if(_this11.appraisalreport.number){// pad, zero fill ->2
var s=_this11.appraisalreport.number+'';while(s.length<2){s='0'+s;}reportnumber=s;}else{appraisalreport_review_table.push([{text:'Informe',style:'plain_bold'},{text:'Manca introduir el número d\'informe.',style:'plain',alignment:'left'}]);}// reportversion
reportversion='';if(_this11.appraisalreport.version){// pad, zero fill ->2
var _s=_this11.appraisalreport.version+'';while(_s.length<2){_s='0'+_s;}reportversion=_s;}else{appraisalreport_review_table.push([{text:'Informe',style:'plain_bold'},{text:'Manca introduir la versió de l\'informe.',style:'plain',alignment:'left'}]);}// petitioner
petitioner='';petitioner_tin='';petitioner_address='';console.log('ççç! this.appraisalreport_petitioners: ');console.log(_this11.appraisalreport_petitioners);if(_this11.appraisalreport_petitioners){// està definit dues vegades? petitioner = també surt més abaix
__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(_this11.appraisalreport_petitioners,function(value,key){var name=value.name?value.name:'';var surnames=value.surnames?value.surnames:'';petitioner=petitioner+' & '+name+' '+surnames;if(value.tin){petitioner_tin=petitioner_tin+' & '+value.tin;}else{appraisalreport_review_table.push([{text:'Informe',style:'plain_bold'},{text:'Manca el NIF del sol·licitant.',style:'plain',alignment:'left'}]);certificate_review_table.push([{text:'Certificat',style:'plain_bold'},{text:'Manca el NIF del sol·licitant.',style:'plain',alignment:'left'}]);}if(value.complete_fiscal_address){petitioner_address=petitioner_address+' & '+value.complete_fiscal_address;}else{appraisalreport_review_table.push([{text:'Informe',style:'plain_bold'},{text:'Manca l\'adreça del sol·licitant.',style:'plain',alignment:'left'}]);certificate_review_table.push([{text:'Certificat',style:'plain_bold'},{text:'Manca l\'adreça del sol·licitant.',style:'plain',alignment:'left'}]);}});petitioner=petitioner.substr(3);petitioner_tin=petitioner_tin.substr(3);petitioner_address=petitioner_address.substr(3);}else{appraisalreport_review_table.push([{text:'Informe',style:'plain_bold'},{text:'Manca introduir el sol·licitant.',style:'plain',alignment:'left'}]);}// petitioner_type
//com que ara és dinàmic i hi poden haver més d'ns
/*
																																																										petitioner_type = ''
																																																										if (this.appraisalreport.petitioner_type) {
																																																											petitioner_type = (this.currentLocale === 'ca') ? this.appraisalreport.petitioner_type.name_ca : (this.currentLocale === 'en') ? this.appraisalreport.petitioner_type.name_en : this.appraisalreport.petitioner_type.name_es
																																																										} else {
																																																											appraisalreport_review_table.push([
																																																													{
																																																														text: 'Informe',
																																																														style: 'plain_bold'
																																																													},
																																																													{
																																																														text: 'Manca introduir el tipus de sol·licitant.',
																																																														style: 'plain',
																																																														alignment: 'left'
																																																													}
																																																												]
																																																											)
																																																										}
																																																										*/// mandatary (optional)
mandatary='-';if(_this11.appraisalreport.entity){mandatary=_this11.appraisalreport.entity.name;}else{certificate_review_table.push([{text:'Informe',style:'plain_bold'},{text:'Manca introduir el Mandatari',style:'plain',alignment:'left'}]);}var docDefinition={// settings
pageSize:'A4',pageOrientation:'portrait',// [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
pageMargins:[40,80,20,20],// metadata
info:{title:'BARNA-TASA, S.A.',author:'BARNA-TASA, S.A.',subject:'BARNA-TASA, S.A.',keywords:'BARNA-TASA, S.A.',creator:'BARNA-TASA, S.A.',producer:'BARNA-TASA, S.A.'},styles:{header_small:{fontSize:8,bold:false},header_small_blue:{fontSize:8,color:'#1a3856',bold:false},header_medium_blue:{fontSize:10,color:'#1a3856',bold:false},header_title:{fontSize:12,bold:true},header_title_blue:{fontSize:12,color:'#1a3856',bold:true},small:{fontSize:8,bold:false},small_bold:{fontSize:8,bold:true},small_bold_center:{fontSize:8,bold:true,alignment:'center'},plain:{fontSize:9,bold:false},plain_bold:{fontSize:9,bold:true},plain_bold_underline:{fontSize:9,bold:true,decoration:'underline'},plain_bold_center:{fontSize:9,bold:true,alignment:'center'},plain_bold_left:{fontSize:9,bold:true,alignment:'left'},plain_bold_right:{fontSize:9,bold:true,alignment:'right'},cover_brand:{fontSize:32,color:'#1a3856',bold:true},cover_title:{fontSize:20,color:'#1a3856',bold:true,alignment:'center'},cover_subtitle:{fontSize:14,color:'#1a3856',bold:true,alignment:'center'},cover_header:{fontSize:12,color:'#1a3856',bold:true,alignment:'center'},plain_blue:{fontSize:9,color:'#1a3856',bold:false},plain_blue_bold:{fontSize:9,color:'#1a3856',bold:true},h2:{fontSize:16,bold:true},h2_center:{fontSize:16,bold:true,alignment:'center'},h3:{fontSize:12,bold:true},h4:{fontSize:11,bold:true},h5:{fontSize:10,bold:true},h5_underline:{fontSize:10,decoration:'underline',bold:true},h6:{fontSize:9,bold:true}},//header & footer
header:function header(currentPage,pageCount,pageSize){// apply any logic and return any valid pdfmake element
var chapterText='';var realEstateText='';for(var l=0;l<docDefinition.content.length;l++){if(docDefinition.content[l].pageHeaderChapterText&&currentPage>=docDefinition.content[l].positions[0].pageNumber){chapterText=docDefinition.content[l].pageHeaderChapterText;}if(docDefinition.content[l].pageHeaderRealEstateText&&currentPage>=docDefinition.content[l].positions[0].pageNumber){realEstateText=docDefinition.content[l].pageHeaderRealEstateText;}}var header=[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Barnatasa_header'),// alignment: (currentPage % 2) ? 'left' : 'right'
alignment:'center',margin:[0,10],style:'header_small'},{columns:[{image:'data:image/png;base64,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',width:16,margin:[40,0]},{width:200,border:[false,false,false,true],text:'BARNA-TASA, S.A.',style:'header_title_blue',alignment:'left',margin:[48,0]},{width:'*',border:[false,false,false,true],// text: 'Exp. ' + filenumber + '/' + reportnumber + '/' + reportversion,
text:chapterText,style:'header_medium_blue',alignment:'right',margin:[40,0]}]},{text:realEstateText,// alignment: (currentPage % 2) ? 'left' : 'right'
alignment:'right',margin:[40,4],style:'small'}];return header;},footer:function footer(currentPage,pageCount,pageSize){// apply any logic and return any valid pdfmake element
return[{layout:'tocSectionLevel2',margin:[30,0,30,30],table:{headerRows:0,widths:[100,'*',60],body:[[{border:[false,true,false,false],// text: moment().format('DD/MM/YYYY'),
text:'Exp. '+filenumber+'/'+reportnumber+'/'+reportversion,style:'header_small',alignment:'left'},{border:[false,true,false,false],text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Barnatasa_footer'),style:'header_small',alignment:'center'},{border:[false,true,false,false],text:currentPage+' / '+pageCount,style:'plain',alignment:'right'}]]}}];},// background
background:function background(currentPage){if(currentPage===1){return[{text:'',margin:[40,50,20,30]},{margin:[40,0,20,0],table:{layout:'noBorders',headerRows:0,widths:['*'],body:[[{border:[false,false,false,false],fillColor:'whitesmoke',text:'',style:'cover_header',alignment:'center',margin:[0,58]}]]}},{text:'',margin:[40,500,40,30]},{margin:[40,0,20,0],table:{layout:'noBorders',headerRows:0,widths:['*'],body:[[{border:[false,false,false,false],fillColor:'whitesmoke',text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Barnatasa_cover_short_description'),style:'cover_header',alignment:'center'}],[{border:[false,false,false,false],fillColor:'whitesmoke',text:'Carrer de Còrsega, 168, 1º 1ª, 08036, Barcelona, Tel. 934100532',style:'plain_blue',alignment:'center'}],[{border:[false,false,false,false],fillColor:'whitesmoke',text:'e-mail: info@barnatasa.com | www.barnatasa.com',style:'plain_blue',alignment:'center'}]]}}];}},// content
content:[]};var certificateDefinition={// settings
pageSize:'A4',pageOrientation:'portrait',// [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
pageMargins:[40,160,20,20],// metadata
info:{title:'BARNA-TASA, S.A.',author:'BARNA-TASA, S.A.',subject:'BARNA-TASA, S.A.',keywords:'BARNA-TASA, S.A.',creator:'BARNA-TASA, S.A.',producer:'BARNA-TASA, S.A.'},styles:{header_small:{fontSize:8,bold:false},header_small_blue:{fontSize:8,color:'#1a3856',bold:false},header_medium_blue:{fontSize:10,color:'#1a3856',bold:false},header_title:{fontSize:12,bold:true},header_title_blue:{fontSize:12,color:'#1a3856',bold:true},small:{fontSize:8,bold:false},small_bold:{fontSize:8,bold:true},small_bold_center:{fontSize:8,bold:true,alignment:'center'},plain:{fontSize:9,bold:false},plain_bold:{fontSize:9,bold:true},plain_bold_center:{fontSize:9,bold:true,alignment:'center'},plain_bold_underline:{fontSize:9,bold:true,decoration:'underline'},plain_bold_left:{fontSize:9,bold:true,alignment:'left'},plain_bold_right:{fontSize:9,bold:true,alignment:'right'},cover_brand:{fontSize:32,color:'#1a3856',bold:true},cover_title:{fontSize:20,color:'#1a3856',bold:true,alignment:'center'},cover_subtitle:{fontSize:14,color:'#1a3856',bold:true,alignment:'center'},cover_header:{fontSize:12,color:'#1a3856',bold:true,alignment:'center'},plain_blue:{fontSize:9,color:'#1a3856',bold:false},plain_blue_bold:{fontSize:9,color:'#1a3856',bold:true},h1:{fontSize:20,bold:true},h2:{fontSize:16,bold:true},h2_center:{fontSize:16,bold:true,alignment:'center'},h3:{fontSize:12,bold:true},h4:{fontSize:11,bold:true},h5:{fontSize:10,bold:true},h5_underline:{fontSize:10,decoration:'underline',bold:true},h6:{fontSize:9,bold:true}},//header & footer
header:function header(currentPage,pageCount,pageSize){var header=[/*
                                                                                                                                                                                                                                                        {
                                                                                                                                                                                                                                                            text: Vue.i18n.translate('Barnatasa_header'),
                                                                                                                                                                                                                                                            // alignment: (currentPage % 2) ? 'left' : 'right'
                                                                                                                                                                                                                                                            alignment: 'center',
                                                                                                                                                                                                                                                            margin: [0, 10],
                                                                                                                                                                                                                                                            style: 'header_small'
                                                                                                                                                                                                                                                        },
                                                                                                                                                                                                                                                        */{columns:[{layout:'noBorders',margin:[30,20,20,30],table:{headerRows:0,widths:[130],body:[[{width:130,border:[false,false,false,true],text:'BARNA-TASA, S.A.',style:'header_title_blue',alignment:'left',margin:[10,0]}],[{image:'data:image/png;base64,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',width:100,margin:[10,0]}]]}},{width:220,border:[false,false,false,true],// text: 'Exp. ' + filenumber + '/' + reportnumber + '/' + reportversion,
text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Barnatasa_header_portrait'),style:'small',alignment:'right',margin:[30,40]}]}];return header;},footer:function footer(currentPage,pageCount,pageSize){// apply any logic and return any valid pdfmake element
return[{layout:'width0',margin:[40,0,20,20],table:{headerRows:0,widths:[100,'*',60],body:[[{border:[false,true,false,false],// text: moment().format('DD/MM/YYYY'),
text:'Exp. '+filenumber+'/'+reportnumber+'/'+reportversion,style:'header_small',alignment:'left'},{border:[false,true,false,false],text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Barnatasa_footer'),style:'header_small',alignment:'center'},{border:[false,true,false,false],text:currentPage+' / '+pageCount,style:'plain',alignment:'right'}]]}}];},// content
content:[]};certificate_content_obj={layout:'width0',table:{headerRows:0,widths:['*'],body:[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Certificate_text_01'),margin:[30,10],border:[true,false,true,false],alignment:'left',style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('certifies').toUpperCase()+': ',margin:[30,0],border:[true,false,true,false],alignment:'center',style:'h3'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Certificate_text_02')+' '+full_number+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Certificate_text_03')+' '+reportdate+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Certificate_text_04')+': ',margin:[30,10],border:[true,false,true,false],alignment:'left',style:'plain'}],[{layout:'noBorders',border:[true,false,true,false],table:{headerRows:0,widths:[160,280],body:[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Mandatary')+': ',margin:[30,0],//border: [true, false, true, false],
alignment:'left',style:'plain_bold'},{text:mandatary,margin:[30,0],//border: [true, false, true, false],
alignment:'left',style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Appraisal_petitioner')+': ',margin:[30,0],//border: [true, false, true, false],
alignment:'left',style:'plain_bold'},{text:petitioner,margin:[30,0],//border: [true, false, true, false],
alignment:'left',style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Petitioner_TIN')+': ',margin:[30,0],//border: [true, false, true, false],
alignment:'left',style:'plain_bold'},{text:petitioner_tin,margin:[30,0],//border: [true, false, true, false],
alignment:'left',style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Petitioner_address')+': ',margin:[30,0],//border: [true, false, true, false],
alignment:'left',style:'plain_bold'},{text:petitioner_address,margin:[30,0],//border: [true, false, true, false],
alignment:'left',style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Appraisal_purpose')+': ',margin:[30,0],//border: [true, false, true, false],
alignment:'left',style:'plain_bold'},{text:appraisal_purpose,margin:[30,0],//border: [true, false, true, false],
alignment:'left',style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Appraised_real_estates')+': ',margin:[30,0],//border: [true, false, true, false],
alignment:'left',style:'plain_bold'},{text:'',margin:[30,0],//border: [true, false, true, false],
alignment:'left',style:'plain_bold'}]]}}]]}// Total Values
};var tv_widths=[180,40,8,60,8,70];// land_value_repercussion_method_table
var land_value_repercussion_method_table=[];var land_value_repercussion_method_table_widths=tv_widths;var repercussion_method_land_values=[];var construction_value_cost_method_crb_table=[];var construction_value_cost_method_crb_table_widths=tv_widths;var cost_method_construction_crb_values=[];var construction_value_cost_method_crn_table=[];var construction_value_cost_method_crn_table_widths=tv_widths;var cost_method_construction_crn_values=[];var realestate_value_cost_method_crb_table=[];var realestate_value_cost_method_crb_table_widths=tv_widths;var cost_method_realestate_crb_values=[];var realestate_value_cost_method_crn_table=[];var realestate_value_cost_method_crn_table_widths=tv_widths;var cost_method_realestate_crn_values=[];var unfinished_realestate_value_cost_method_crn_table=[];var unfinished_realestate_value_cost_method_crn_table_widths=tv_widths;var cost_method_unfinished_realestate_crn_values=[];var realestate_value_comparison_method_table=[];var realestate_value_comparison_method_table_widths=tv_widths;var comparison_methods=[];var realestate_value_max_legal_method_table=[];var realestate_value_max_legal_method_table_widths=tv_widths;var max_legal_methods=[];var realestate_value_expected_future_income_update_method_table=[];var realestate_value_expected_future_income_update_method_table_widths=tv_widths;var contract_foreseeable_remaining_period_table=[];var contract_foreseeable_remaining_period_table_widths=[140,45,40,40,40,40,40];var real_estates_residual_value_table=[];var real_estates_residual_value_table_widths=[140,45,40,40,40,40,40];var real_estates_residual_value_at_the_end_of_the_contracts_useful_life_table=[];var current_reversion_value_calculation_table_widths=[140,45,40,40,40,40,40,40];var current_value_of_future_rents_table=[];var current_value_of_future_rents_table_widths=[140,45,40,40,40,40,40,40];var current_reversion_value_table=[];var current_reversion_value_table_widths=[140,60,60,60,60,60];var update_value_table=[];var update_value_table_widths=[140,60,60,60];var right_of_use_value_table=[];var right_of_use_value_table_widths=[140,80,80,80,80];var usufruct_values=[];var bare_ownership_values=[];var insurance_value_table=[];var insurance_value_table_rd_1982=[];var insurance_value_table_rd_2009=[];var insurance_value_table_widths=[180,70,8,70,8,70];var insurance_values=[];var insurance_values_rd_1982=[];var insurance_values_rd_2009=[];var appraisal_value_determination_table=[];var appraisal_value_determination_table_widths=[160,60,60,60,60,60];var appraisal_value_determination_table_min=[];var appraisal_value_determination_table_min_widths=[160,150,150];var appraisal_value_determination_table_ceded=[];var appraisal_value_determination_table_ceded_widths=[160,100,100,100];var appraisal_value_determination_table_under_construction=[];var appraisal_value_determination_table_under_construction_widths=[160,100,100,100];var appraisal_value_determination_table_ceded_eco=[];var appraisal_value_determination_table_ceded_eco_widths=[160,75,75,75,75];var appraisal_value_determination_table_eco=[];var appraisal_value_determination_table_eco_widths=[160,100,100,100];var appraisal_value_determination_table_eco_protected=[];var appraisal_value_determination_table_eco_protected_widths=[160,75,75,75,75];var appraisal_value_determination_table_protected=[];var appraisal_value_determination_table_protected_widths=[160,100,100,100];var realestate_total_adopted_values=[];var final_id_table=[];var final_id_table_widths=[220,100,80,100];var final_appraisal_value_table=[];var final_appraisal_value_table_widths=[508];var final_values_table=[];var final_values_table_widths=[250,250];var date_of_issue_table=[];var date_of_issue_table_widths=[130,250];var annexes_table=[];var annexes_table_widths=[500];date_of_issue_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Report_date_of_issue'),style:'plain_bold'},{text:reportdate,style:'plain_bold'}]);var visit_table=[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Date_of_visit')+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and')+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('technician')+': ',style:'plain_bold'}]];var visit_table_widths=[130];var signatures_table=[[{text:'',style:'plain_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Appraiser')+': ',style:'plain_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('by')+' BARNA-TASA, S.A. : ',style:'plain_bold'}],[{text:'',style:'plain_bold'},{text:'',style:'plain_bold'},{text:'',style:'plain_bold'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Signed'),style:'plain_bold'},{image:_this11.appraisalreport.signature_ap_base64?_this11.appraisalreport.signature_ap_base64:'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAIBAQIBAQICAgICAgICAwUDAwMDAwYEBAMFBwYHBwcGBwcICQsJCAgKCAcHCg0KCgsMDAwMBwkODw0MDgsMDAz/2wBDAQICAgMDAwYDAwYMCAcIDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAz/wAARCAABAAEDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD9/KKKKAP/2Q==',width:164,margin:[0,4]},{image:_this11.appraisalreport.signature_sv_base64?_this11.appraisalreport.signature_sv_base64:'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAIBAQIBAQICAgICAgICAwUDAwMDAwYEBAMFBwYHBwcGBwcICQsJCAgKCAcHCg0KCgsMDAwMBwkODw0MDgsMDAz/2wBDAQICAgMDAwYDAwYMCAcIDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAz/wAARCAABAAEDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD9/KKKKAP/2Q==',width:140,margin:[0,4]}],[{text:'',style:'plain_bold'},{text:appraiser_name+' '+appraiser_surnames,style:'plain_bold'},{text:supervisor_name+' '+supervisor_surnames,style:'plain_bold'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Title'),style:'plain_bold'},{text:appraiser_title,//text: 'a',
style:'plain'},{text:supervisor_title,//text: 'b',
style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('PA_number'),style:'plain_bold'},{text:appraiser_pa_number,style:'plain'},{text:supervisor_pa_number,style:'plain'}]];var signatures_table_widths=[100,200,200];var constraints_table=[[{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[]}}]];var warnings_table=[[{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[]}}]];var notes_table=[[{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[]}}]];var notes_default_table=[];var any_is_ceded=false;var any_is_under_construction=false;var any_is_protected=false;var any_has_right_of_use_ceded=false;var any_is_eco=false;var any_notes=false;var any_constraints=false;var any_warnings=false;land_value_repercussion_method_table.push([{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Area'),style:'small_bold'},{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Unit_value'),style:'small_bold'},{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Total_value'),style:'small_bold'}]);construction_value_cost_method_crb_table.push([{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Area'),style:'small_bold'},{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Unit_value'),style:'small_bold'},{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Total_value'),style:'small_bold'}]);construction_value_cost_method_crn_table.push([{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Area'),style:'small_bold'},{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Unit_value'),style:'small_bold'},{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Total_value'),style:'small_bold'}]);realestate_value_cost_method_crb_table.push([{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Area'),style:'small_bold'},{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Unit_value'),style:'small_bold'},{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Total_value'),style:'small_bold'}]);realestate_value_cost_method_crn_table.push([{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Area'),style:'small_bold'},{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Unit_value'),style:'small_bold'},{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Total_value'),style:'small_bold'}]);unfinished_realestate_value_cost_method_crn_table.push([{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Area'),style:'small_bold'},{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Unit_value'),style:'small_bold'},{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Total_value'),style:'small_bold'}]);realestate_value_comparison_method_table.push([{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Area'),style:'small_bold'},{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Unit_value'),style:'small_bold'},{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Total_value'),style:'small_bold'}]);realestate_value_max_legal_method_table.push([{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Maximum_legal_computable_area'),style:'small_bold'},{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Maximum_legal_sale_price'),style:'small_bold'},{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Total_value'),style:'small_bold'}]);contract_foreseeable_remaining_period_table.push([{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cession_contract_start_date'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cession_contract_period_years'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cession_contract_remaining_years'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Realestates_remaining_useful_life'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Tenant_remaining_life_expectancy_years'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Contracts_foreseeable_remaining_period'),style:'small_bold'}]);real_estates_residual_value_table.push([{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Market_value'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Construction_cost_by_contract'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Buildings_useful_life'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Remaining_contract_years'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Residual_depreciation'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estates_residual_value_at_the_end_of_the_contracts_useful_life'),style:'small_bold'}]);current_value_of_future_rents_table.push([{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Gross_yearly_rent_income'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Landlord_expenses_pct'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Net_yearly_rent_income'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Remaining_contract_years'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Update_type'),style:'small_bold'},{text:'Coef. 1: [(1 + i) ^ n - 1] / [(1 + i) ^ n * i]',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Current_value_of_future_rents'),style:'small_bold'}]);current_reversion_value_table.push([{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estates_residual_value_at_the_end_of_the_contracts_useful_life'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Remaining_contract_years'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Update_type'),style:'small_bold'},{text:'Coef. 2: ((1 + i) ^ n )',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Updated_reversion_value')+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Residual_value')+' / coef. 2',style:'small_bold'}]);update_value_table.push([{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Current_value_of_future_rents')+' (A)',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Updated_reversion_value')+' (B)',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Update_value')+' (A+B)',style:'small_bold'}]);insurance_value_table.push([{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Area'),style:'small_bold'},{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Unit_value'),style:'small_bold'},{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Total_value'),style:'small_bold'}]);insurance_value_table_rd_1982.push([{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Gross_Replacement_Cost'),style:'small_bold'},{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Land_value'),style:'small_bold'},{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Total_value'),style:'small_bold'}]);insurance_value_table_rd_2009.push([{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Appraisal_value'),style:'small_bold'},{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Land_value'),style:'small_bold'},{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Total_value'),style:'small_bold'}]);right_of_use_value_table.push([{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Usufructuary_age_years')+' (n)',style:'small_bold'},{text:'Coef. Vu (max: 10% vs. 0,7 - 0,01 * ( n - 20))',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Usufruct_value')+' (VM * Coef. Vu)',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Bare_ownership_value')+' (VM * (1 - Coef. Vu)',style:'small_bold'}]);appraisal_value_determination_table.push([{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Comparison_Method'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Adjusted_Comparison_Method'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Maximum_Legal_Method'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Expected_Income_Update_Method'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Adopted_value'),style:'small_bold'}]);appraisal_value_determination_table_min.push([{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Comparison_Method'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Adopted_value'),style:'small_bold'}]);appraisal_value_determination_table_ceded.push([{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Comparison_Method'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Expected_Income_Update_Method'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Adopted_value'),style:'small_bold'}]);appraisal_value_determination_table_under_construction.push([{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Comparison_Method'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Net_Replacement_Cost')+' (CRN) '+'('+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('real_estate_under_construction')+')',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Adopted_value'),style:'small_bold'}]);appraisal_value_determination_table_ceded_eco.push([{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Comparison_Method'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Adjusted_Comparison_Method'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Expected_Income_Update_Method'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Adopted_value'),style:'small_bold'}]);appraisal_value_determination_table_eco.push([{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Comparison_Method'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Adjusted_Comparison_Method'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Adopted_value'),style:'small_bold'}]);appraisal_value_determination_table_eco_protected.push([{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Comparison_Method'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Adjusted_Comparison_Method'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Maximum_Legal_Method'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Adopted_value'),style:'small_bold'}]);appraisal_value_determination_table_protected.push([{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Comparison_Method'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Maximum_Legal_Method'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Adopted_value'),style:'small_bold'}]);final_id_table.push([{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Registry'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Registry_real_estate_number'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cadastral_reference'),style:'small_bold'}]);// canvas_to_data_url({src: photograph.url, footer: (this.currentLocale === 'ca') ? photograph.name_ca : (this.currentLocale === 'en') ? photograph.name_en : photograph.name_es})
var _loop=function _loop(i){// console.log('hey i: ')
// console.log(i)
property_type=_this11.currentLocale==='ca'?realestates[i].property_type.name_ca:_this11.currentLocale==='en'?realestates[i].property_type.name_en:realestates[i].property_type.name_es;property_usage=_this11.currentLocale==='ca'?realestates[i].property_type.usage_type_ca:_this11.currentLocale==='en'?realestates[i].property_type.usage_type_en:realestates[i].property_type.usage_type_es;address_street_name=realestates[i].street_name;address_number=realestates[i].street_number?', '+realestates[i].street_number:'';address_floor=realestates[i].floor?', '+realestates[i].floor:'';address_door=realestates[i].door?' '+realestates[i].door:'';address_block=realestates[i].block?', '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('block')+' '+realestates[i].block:'';address_staircase=realestates[i].staircase?', '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('staircase')+' '+realestates[i].staircase:'';address_postal_code=realestates[i].postal_code?', '+realestates[i].postal_code:'';address_postal_code_only=realestates[i].postal_code?realestates[i].postal_code:'';address_municipality=realestates[i].municipality?', '+realestates[i].municipality.name_ine:'';address_province=realestates[i].province?', '+realestates[i].province.name_ine:'';address_short=address_street_name+address_number+address_floor+address_door+address_block+address_staircase;address_long=address_street_name+address_number+address_floor+address_door+address_block+address_staircase+address_postal_code+address_municipality;// cadastral reference
cad_ref='-';if(realestates[i].cadastral_reference){cad_ref=realestates[i].cadastral_reference;}else{appraisalreport_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la Referència Cadastral.',style:'plain',alignment:'left'}]);}// registry real estate nº
reg_est_num='-';// console.log('appraisals[' + i.toString() +']: ')
// console.log(appraisals[i])
if(appraisals[i].registry_real_estate_number){reg_est_num=appraisals[i].registry_real_estate_number;}else{appraisalreport_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir el nº de Finca Registral',style:'plain',alignment:'left'}]);}// visitdate
var visitdate='';if(appraisals[i].visitdate){visitdate=__WEBPACK_IMPORTED_MODULE_3_moment___default()(appraisals[i].visitdate).format('DD/MM/YYYY');}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca indicar la data de la visita',style:'plain',alignment:'left'}]);}// technician_visiting
var technician_visiting='';if(appraisals[i].technician_visiting){technician_visiting=appraisals[i].technician_visiting.complete_name;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca indicar el tècnic que va realitzar la visita',style:'plain',alignment:'left'}]);}visit_table[0].push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Registry_property')+' '+reg_est_num+':',style:'small_bold'},{text:visitdate+' ('+technician_visiting+') ',style:'small'}]);visit_table_widths.push('*');/*
                                                                                                    annexes_table.push(
																										[

																										{
																											text: visitdate + ' (' + technician_visiting + ') ',
																											style: 'plain_bold'
																										}

                                                                                                        ]
                                                                                                    )
                                                                                                    */// cadastral construction year
var cadastral_construction_year='';if(appraisals[i].cadastral_construction_year){cadastral_construction_year=appraisals[i].cadastral_construction_year;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir l\'any de construcció segons Cadastre.',style:'plain',alignment:'left'}]);}// latitude
var latitude='-';if(realestates[i].lat){latitude=realestates[i].lat;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca la coordenada latitud de l\'immoble',style:'plain',alignment:'left'}]);}// longitude
var longitude='-';if(realestates[i].lng){longitude=realestates[i].lng;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca la coordenada longitud de l\'immoble',style:'plain',alignment:'left'}]);}// cadastral usage
var cadastral_usage='-';if(appraisals[i].cadastral_usage){cadastral_usage=appraisals[i].cadastral_usage;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir l\'ús de l\'element segons Cadastre.',style:'plain',alignment:'left'}]);}// cadastral floor
var cadastral_floor='-';if(appraisals[i].cadastral_floor){cadastral_floor=appraisals[i].cadastral_floor;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la planta de l\'element segons Cadastre.',style:'plain',alignment:'left'}]);}// cadastral door
var cadastral_door='-';if(appraisals[i].cadastral_door){cadastral_door=appraisals[i].cadastral_door;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la porta de l\'element segons Cadastre.',style:'plain',alignment:'left'}]);}// cadastral staircase
var cadastral_staircase='-';if(appraisals[i].cadastral_staircase){cadastral_staircase=appraisals[i].cadastral_staircase;}else{}// cadastral block
var cadastral_block='-';if(appraisals[i].cadastral_block){cadastral_block=appraisals[i].cadastral_block;}else{}// built_cadastral_area
var built_cadastral_area='-';if(appraisals[i].built_cadastral_area){built_cadastral_area=appraisals[i].built_cadastral_area;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la superfície const. segons Cadastre.',style:'plain',alignment:'left'}]);}// built_plus_common_elements_cadastral_area
var built_plus_common_elements_cadastral_area='-';if(appraisals[i].built_plus_common_elements_cadastral_area){built_plus_common_elements_cadastral_area=appraisals[i].built_plus_common_elements_cadastral_area;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la superfície const. + elem. com. segons Cadastre.',style:'plain',alignment:'left'}]);}// registry_name
var registry_name='-';if(appraisals[i].registry_name){registry_name=appraisals[i].registry_name;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir el nom del Registre.',style:'plain',alignment:'left'}]);}// registry_section
var registry_section='-';if(appraisals[i].registry_section){registry_section=appraisals[i].registry_section;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la secció del Registre.',style:'plain',alignment:'left'}]);}// registry_volume
var registry_volume='-';if(appraisals[i].registry_volume){registry_volume=appraisals[i].registry_volume;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir el volum del Registre.',style:'plain',alignment:'left'}]);}// registry_book
var registry_book='-';if(appraisals[i].registry_book){registry_book=appraisals[i].registry_book;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir el llibre del Registre.',style:'plain',alignment:'left'}]);}// registry_page
var registry_page='-';if(appraisals[i].registry_page){registry_page=appraisals[i].registry_page;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la pàgina del Registre.',style:'plain',alignment:'left'}]);}// registry_real_estate_number
var registry_real_estate_number='-';if(appraisals[i].registry_real_estate_number){registry_real_estate_number=appraisals[i].registry_real_estate_number;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir el nº de Finca Registral.',style:'plain',alignment:'left'}]);}// registry_idufir
var registry_idufir='-';if(appraisals[i].registry_idufir){registry_idufir=appraisals[i].registry_idufir;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir l\'IDUFIR.',style:'plain',alignment:'left'}]);}// registry_owner
var registry_owner='-';if(appraisals[i].registry_owner){registry_owner=appraisals[i].registry_owner;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir el titular registral.',style:'plain',alignment:'left'}]);}// registry_property_coef
var registry_property_coef='-';if(appraisals[i].registry_property_coef){registry_property_coef=appraisals[i].registry_property_coef;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir Coeficient de Propietat segons Registre.',style:'plain',alignment:'left'}]);}// net_registry_area
var net_registry_area='-';if(appraisals[i].net_registry_area){net_registry_area=appraisals[i].net_registry_area;}else{}// enclosed_registry_area
var enclosed_registry_area='-';if(appraisals[i].enclosed_registry_area){enclosed_registry_area=appraisals[i].enclosed_registry_area;}else{}// covered_terraces_total_registry_area
var covered_terraces_total_registry_area='-';if(appraisals[i].covered_terraces_total_registry_area){covered_terraces_total_registry_area=appraisals[i].covered_terraces_total_registry_area;}else{}// uncovered_terraces_total_registry_area
var uncovered_terraces_total_registry_area='-';if(appraisals[i].uncovered_terraces_total_registry_area){uncovered_terraces_total_registry_area=appraisals[i].uncovered_terraces_total_registry_area;}else{}// built_registry_area
var built_registry_area='-';if(appraisals[i].built_registry_area){built_registry_area=appraisals[i].built_registry_area;}else{}certificate_content_obj.table.body.push([{text:(i+1).toString()+'- '+property_usage+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_long+', '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cadastral_reference')+' '+cad_ref+', '+'IDUFIR'+' '+registry_idufir+', '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Registry_property')+' mº '+registry_real_estate_number+', '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('registered_in')+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Volume').toLowerCase()+' '+registry_volume+', '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Book').toLowerCase()+' '+registry_book+', '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Page').toLowerCase()+' '+registry_page+', '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('from_the')+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Register')+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('of')+' '+registry_name+', '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Section').toLowerCase()+' '+registry_section+': ',margin:[30,10],border:[true,false,true,false],alignment:'left',style:'plain'}]);// built_plus_common_elements_registry_area
var built_plus_common_elements_registry_area='-';if(appraisals[i].built_plus_common_elements_registry_area){built_plus_common_elements_registry_area=appraisals[i].built_plus_common_elements_registry_area;}else{}// nucleus_type
var nucleus_type='-';if(appraisals[i].nucleus_type){nucleus_type=appraisals[i].nucleus_type;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir el tipus de nucli (entorn)',style:'plain',alignment:'left'}]);}// nucleus_population
var nucleus_population='-';if(appraisals[i].nucleus_population){nucleus_population=appraisals[i].nucleus_population;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la població del nucli (entorn)',style:'plain',alignment:'left'}]);}// nucleus_population_growth
var nucleus_population_growth='-';if(appraisals[i].nucleus_population_growth){nucleus_population_growth=appraisals[i].nucleus_population_growth;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir el creixement del nucli (entorn)',style:'plain',alignment:'left'}]);}// nucleus_area
var nucleus_area='-';if(appraisals[i].nucleus_area){nucleus_area=appraisals[i].nucleus_area;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la superfície del nucli (entorn)',style:'plain',alignment:'left'}]);}// nucleus_population_density
var nucleus_population_density='-';if(appraisals[i].nucleus_population_density){nucleus_population_density=appraisals[i].nucleus_population_density;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la densitat del nucli (entorn)',style:'plain',alignment:'left'}]);}// occupation_description
var occupation_description='-';if(appraisals[i].occupation_description){occupation_description=appraisals[i].occupation_description;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la descripció de l\'ocupació laboral (entorn)',style:'plain',alignment:'left'}]);}// surrounding_territorial_feature
var surrounding_territorial_feature='-';if(appraisals[i].surrounding_territorial_feature){if(_this11.currentLocale==='ca'){surrounding_territorial_feature=appraisals[i].surrounding_territorial_feature.name_ca;}else if(_this11.currentLocale==='en'){surrounding_territorial_feature=appraisals[i].surrounding_territorial_feature.name_en;}else{surrounding_territorial_feature=appraisals[i].surrounding_territorial_feature.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la característica territorial (entorn)',style:'plain',alignment:'left'}]);}// surrounding_income_level
var surrounding_income_level='-';if(appraisals[i].surrounding_income_level){if(_this11.currentLocale==='ca'){surrounding_income_level=appraisals[i].surrounding_income_level.name_ca;}else if(_this11.currentLocale==='en'){surrounding_income_level=appraisals[i].surrounding_income_level.name_en;}else{surrounding_income_level=appraisals[i].surrounding_income_level.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir el nivell de la renda (entorn)',style:'plain',alignment:'left'}]);}// surrounding_homogeneity_feature
var surrounding_homogeneity_feature='-';if(appraisals[i].surrounding_homogeneity_feature){if(_this11.currentLocale==='ca'){surrounding_homogeneity_feature=appraisals[i].surrounding_homogeneity_feature.name_ca;}else if(_this11.currentLocale==='en'){surrounding_homogeneity_feature=appraisals[i].surrounding_homogeneity_feature.name_en;}else{surrounding_homogeneity_feature=appraisals[i].surrounding_homogeneity_feature.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir els trets d\'homogeneïtat (entorn)',style:'plain',alignment:'left'}]);}// surrounding_main_uses
var surrounding_main_uses='-';if(appraisals[i].surrounding_main_uses){if(_this11.currentLocale==='ca'){surrounding_main_uses=appraisals[i].surrounding_main_uses.name_ca;}else if(_this11.currentLocale==='en'){surrounding_main_uses=appraisals[i].surrounding_main_uses.name_en;}else{surrounding_main_uses=appraisals[i].surrounding_main_uses.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir els úsos dominants (entorn)',style:'plain',alignment:'left'}]);}// surrounding_density
var surrounding_density='-';if(appraisals[i].surrounding_density){if(_this11.currentLocale==='ca'){surrounding_density=appraisals[i].surrounding_density.name_ca;}else if(_this11.currentLocale==='en'){surrounding_density=appraisals[i].surrounding_density.name_en;}else{surrounding_density=appraisals[i].surrounding_density.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la densitat de l\'entorn',style:'plain',alignment:'left'}]);}// surrounding_accessibility
var surrounding_accessibility='-';if(appraisals[i].surrounding_accessibility){if(_this11.currentLocale==='ca'){surrounding_accessibility=appraisals[i].surrounding_accessibility.name_ca;}else if(_this11.currentLocale==='en'){surrounding_accessibility=appraisals[i].surrounding_accessibility.name_en;}else{surrounding_accessibility=appraisals[i].surrounding_accessibility.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir l\'accessibilitat (entorn)',style:'plain',alignment:'left'}]);}// surrounding_consolidation_degree
var surrounding_consolidation_degree='-';if(appraisals[i].surrounding_consolidation_degree){if(_this11.currentLocale==='ca'){surrounding_consolidation_degree=appraisals[i].surrounding_consolidation_degree.name_ca;}else if(_this11.currentLocale==='en'){surrounding_consolidation_degree=appraisals[i].surrounding_consolidation_degree.name_en;}else{surrounding_consolidation_degree=appraisals[i].surrounding_consolidation_degree.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir el grau de consolidació(entorn)',style:'plain',alignment:'left'}]);}// surrounding_occupation_degree
var surrounding_occupation_degree='-';if(appraisals[i].surrounding_occupation_degree){if(_this11.currentLocale==='ca'){surrounding_occupation_degree=appraisals[i].surrounding_occupation_degree.name_ca;}else if(_this11.currentLocale==='en'){surrounding_occupation_degree=appraisals[i].surrounding_occupation_degree.name_en;}else{surrounding_occupation_degree=appraisals[i].surrounding_occupation_degree.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir el grau d\'ocupació (entorn)',style:'plain',alignment:'left'}]);}// surrounding_evolution_speed
var surrounding_evolution_speed='-';if(appraisals[i].surrounding_evolution_speed){if(_this11.currentLocale==='ca'){surrounding_evolution_speed=appraisals[i].surrounding_evolution_speed.name_ca;}else if(_this11.currentLocale==='en'){surrounding_evolution_speed=appraisals[i].surrounding_evolution_speed.name_en;}else{surrounding_evolution_speed=appraisals[i].surrounding_evolution_speed.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir l\'evolució (entorn)',style:'plain',alignment:'left'}]);}// surrounding_average_age
var surrounding_average_age='-';if(appraisals[i].surrounding_average_age){if(_this11.currentLocale==='ca'){surrounding_average_age=appraisals[i].surrounding_average_age.name_ca;}else if(_this11.currentLocale==='en'){surrounding_average_age=appraisals[i].surrounding_average_age.name_en;}else{surrounding_average_age=appraisals[i].surrounding_average_age.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir l\'antiguitat característica(entorn)',style:'plain',alignment:'left'}]);}// surrounding_conservation_status
var surrounding_conservation_status='-';if(appraisals[i].surrounding_conservation_status){if(_this11.currentLocale==='ca'){surrounding_conservation_status=appraisals[i].surrounding_conservation_status.name_ca;}else if(_this11.currentLocale==='en'){surrounding_conservation_status=appraisals[i].surrounding_conservation_status.name_en;}else{surrounding_conservation_status=appraisals[i].surrounding_conservation_status.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir l\'estat de conservació (entorn)',style:'plain',alignment:'left'}]);}// surrounding_commercial_facilities
var surrounding_commercial_facilities='-';if(appraisals[i].surrounding_commercial_facilities){if(_this11.currentLocale==='ca'){surrounding_commercial_facilities=appraisals[i].surrounding_commercial_facilities.name_ca;}else if(_this11.currentLocale==='en'){surrounding_commercial_facilities=appraisals[i].surrounding_commercial_facilities.name_en;}else{surrounding_commercial_facilities=appraisals[i].surrounding_commercial_facilities.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la descripció sobre l\'equipament comercial (entorn)',style:'plain',alignment:'left'}]);}// surrounding_educational_facilities
var surrounding_educational_facilities='-';if(appraisals[i].surrounding_educational_facilities){if(_this11.currentLocale==='ca'){surrounding_educational_facilities=appraisals[i].surrounding_educational_facilities.name_ca;}else if(_this11.currentLocale==='en'){surrounding_educational_facilities=appraisals[i].surrounding_educational_facilities.name_en;}else{surrounding_educational_facilities=appraisals[i].surrounding_educational_facilities.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la descripció sobre l\'equipament educacional (entorn)',style:'plain',alignment:'left'}]);}// surrounding_public_parking
var surrounding_public_parking='-';if(appraisals[i].surrounding_public_parking){if(_this11.currentLocale==='ca'){surrounding_public_parking=appraisals[i].surrounding_public_parking.name_ca;}else if(_this11.currentLocale==='en'){surrounding_public_parking=appraisals[i].surrounding_public_parking.name_en;}else{surrounding_public_parking=appraisals[i].surrounding_public_parking.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la descripció sobre l\'aparcament públic (entorn)',style:'plain',alignment:'left'}]);}// surrounding_medical_assistance
var surrounding_medical_assistance='-';if(appraisals[i].surrounding_medical_assistance){if(_this11.currentLocale==='ca'){surrounding_medical_assistance=appraisals[i].surrounding_medical_assistance.name_ca;}else if(_this11.currentLocale==='en'){surrounding_medical_assistance=appraisals[i].surrounding_medical_assistance.name_en;}else{surrounding_medical_assistance=appraisals[i].surrounding_medical_assistance.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la descripció sobre l\'assistència mèdica (entorn)',style:'plain',alignment:'left'}]);}// surrounding_leisure
var surrounding_leisure='-';if(appraisals[i].surrounding_leisure){if(_this11.currentLocale==='ca'){surrounding_leisure=appraisals[i].surrounding_leisure.name_ca;}else if(_this11.currentLocale==='en'){surrounding_leisure=appraisals[i].surrounding_leisure.name_en;}else{surrounding_leisure=appraisals[i].surrounding_leisure.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la descripció sobre l\'oci (entorn)',style:'plain',alignment:'left'}]);}// surrounding_facilities_notes
var surrounding_facilities_notes='-';if(appraisals[i].surrounding_facilities_notes){surrounding_facilities_notes=appraisals[i].surrounding_facilities_notes;}else{surrounding_facilities_notes='-';}// communications_airport
var communications_airport='-';if(appraisals[i].communications_airport){communications_airport=appraisals[i].communications_airport;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la descripció sobre aeroport a comunicacions (entorn)',style:'plain',alignment:'left'}]);}// communications_harbour
var communications_harbour='-';if(appraisals[i].communications_harbour){communications_harbour=appraisals[i].communications_harbour;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la descripció sobre port a comunicacions (entorn)',style:'plain',alignment:'left'}]);}// communications_train
var communications_train='-';if(appraisals[i].communications_train){communications_train=appraisals[i].communications_train;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la descripció sobre tren a comunicacions (entorn)',style:'plain',alignment:'left'}]);}// public_transport_urban_underground
var public_transport_urban_underground='-';if(appraisals[i].public_transport_urban_underground){public_transport_urban_underground=appraisals[i].public_transport_urban_underground;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la descripció sobre transports públics urbans subterranis (entorn)',style:'plain',alignment:'left'}]);}// public_transport_interurban
var public_transport_interurban='-';if(appraisals[i].public_transport_interurban){public_transport_interurban=appraisals[i].public_transport_interurban;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la descripció sobre transports públics interurbans (entorn)',style:'plain',alignment:'left'}]);}// quality_of_neighbourhood
var quality_of_neighbourhood='-';if(appraisals[i].quality_of_neighbourhood){if(_this11.currentLocale==='ca'){quality_of_neighbourhood=appraisals[i].quality_of_neighbourhood.name_ca;}else if(_this11.currentLocale==='en'){quality_of_neighbourhood=appraisals[i].quality_of_neighbourhood.name_en;}else{quality_of_neighbourhood=appraisals[i].quality_of_neighbourhood.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la qualitat del barri',style:'plain',alignment:'left'}]);}// quality_of_situation
var quality_of_situation='-';if(appraisals[i].quality_of_situation){if(_this11.currentLocale==='ca'){quality_of_situation=appraisals[i].quality_of_situation.name_ca;}else if(_this11.currentLocale==='en'){quality_of_situation=appraisals[i].quality_of_situation.name_en;}else{quality_of_situation=appraisals[i].quality_of_situation.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la qualitat de la situació',style:'plain',alignment:'left'}]);}// quality_of_construction
var quality_of_construction='-';if(appraisals[i].quality_of_construction){if(_this11.currentLocale==='ca'){quality_of_construction=appraisals[i].quality_of_construction.name_ca;}else if(_this11.currentLocale==='en'){quality_of_construction=appraisals[i].quality_of_construction.name_en;}else{quality_of_construction=appraisals[i].quality_of_construction.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la qualitat de la construcció',style:'plain',alignment:'left'}]);}// quality_of_realestate
var quality_of_realestate='-';if(appraisals[i].quality_of_realestate){if(_this11.currentLocale==='ca'){quality_of_realestate=appraisals[i].quality_of_realestate.name_ca;}else if(_this11.currentLocale==='en'){quality_of_realestate=appraisals[i].quality_of_realestate.name_en;}else{quality_of_realestate=appraisals[i].quality_of_realestate.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la qualitat de l\'immoble',style:'plain',alignment:'left'}]);}// floor_number
var floor_number='-';if(realestates[i].floor_number){floor_number=realestates[i].floor_number;}else{realestate_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la situació en alçada',style:'plain',alignment:'left'}]);}// urban_planning_type
var urban_planning_type='-';if(appraisals[i].urban_planning_type){urban_planning_type=appraisals[i].urban_planning_type;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir el tipus de pla (urbanisme)',style:'plain',alignment:'left'}]);}// urban_planning_file
var urban_planning_file='-';if(appraisals[i].urban_planning_file){urban_planning_file=appraisals[i].urban_planning_file;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir expedient urbanístic (urbanisme)',style:'plain',alignment:'left'}]);}// urban_planning_council_qualification
var urban_planning_council_qualification='-';if(appraisals[i].urban_planning_council_qualification){urban_planning_council_qualification=appraisals[i].urban_planning_council_qualification;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir qualificació ajuntament (urbanisme)',style:'plain',alignment:'left'}]);}// urban_planning_council_qualification_description
var urban_planning_council_qualification_description='-';if(appraisals[i].urban_planning_council_qualification_description){urban_planning_council_qualification_description=appraisals[i].urban_planning_council_qualification_description;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir descripció qualificació ajuntament (urbanisme)',style:'plain',alignment:'left'}]);}// urban_planning_council_classification
var urban_planning_council_classification='-';if(appraisals[i].urban_planning_council_classification){urban_planning_council_classification=appraisals[i].urban_planning_council_classification;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir classificació segons ajuntament (urbanisme)',style:'plain',alignment:'left'}]);}// urban_planning_council_classification_description
var urban_planning_council_classification_description='-';if(appraisals[i].urban_planning_council_classification_description){urban_planning_council_classification_description=appraisals[i].urban_planning_council_classification_description;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir descripció de classificació segons ajuntament (urbanisme)',style:'plain',alignment:'left'}]);}// urban_planning_regional_qualification
var urban_planning_regional_qualification='-';if(appraisals[i].urban_planning_regional_qualification){urban_planning_regional_qualification=appraisals[i].urban_planning_regional_qualification;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir qualificació segons muc (urbanisme)',style:'plain',alignment:'left'}]);}// urban_planning_regional_qualification_description
var urban_planning_regional_qualification_description='-';if(appraisals[i].urban_planning_regional_qualification_description){urban_planning_regional_qualification_description=appraisals[i].urban_planning_regional_qualification_description;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir descripció de qualificació segons muc (urbanisme)',style:'plain',alignment:'left'}]);}// urban_planning_regional_classification
var urban_planning_regional_classification='-';if(appraisals[i].urban_planning_regional_classification){urban_planning_regional_classification=appraisals[i].urban_planning_regional_classification;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir classificació segons muc (urbanisme)',style:'plain',alignment:'left'}]);}// urban_planning_regional_classification_description
var urban_planning_regional_classification_description='-';if(appraisals[i].urban_planning_regional_classification_description){urban_planning_regional_classification_description=appraisals[i].urban_planning_regional_classification_description;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir descripció de classificació segons muc (urbanisme)',style:'plain',alignment:'left'}]);}// land_registry_area
var land_registry_area='-';if(appraisals[i].land_registry_area){land_registry_area=appraisals[i].land_registry_area;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la superfície registral del terreny',style:'plain',alignment:'left'}]);}// land_cadastral_area
var land_cadastral_area='-';if(appraisals[i].land_cadastral_area){land_cadastral_area=appraisals[i].land_cadastral_area;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la superfície cadastral del terreny',style:'plain',alignment:'left'}]);}// land_checked_area
var land_checked_area='-';if(appraisals[i].land_checked_area||appraisals[i].land_checked_area===0){land_checked_area=appraisals[i].land_checked_area;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la superfície comprovada del terreny',style:'plain',alignment:'left'}]);}// land_adopted_area
var land_adopted_area='-';if(appraisals[i].land_adopted_area){land_adopted_area=appraisals[i].land_adopted_area;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la superfície adoptada del terreny',style:'plain',alignment:'left'}]);}// land_area_notes
var land_area_notes='-';if(appraisals[i].land_area_notes){land_area_notes=appraisals[i].land_area_notes;}else{}// land_infrastructure_paving
var land_infrastructure_paving='-';if(appraisals[i].land_infrastructure_paving){if(_this11.currentLocale==='ca'){land_infrastructure_paving='Sí';}else if(_this11.currentLocale==='en'){land_infrastructure_paving='Yes';}else{land_infrastructure_paving='Sí';}}else{if(_this11.currentLocale==='ca'){land_infrastructure_paving='No';}else if(_this11.currentLocale==='en'){land_infrastructure_paving='No';}else{land_infrastructure_paving='No';}}// land_infrastructure_paving_execution_pct
var land_infrastructure_paving_execution_pct='-';if(appraisals[i].land_infrastructure_paving_execution_pct){land_infrastructure_paving_execution_pct=appraisals[i].land_infrastructure_paving_execution_pct;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir el percentatge d\'execució de pavimentació del terreny',style:'plain',alignment:'left'}]);}// land_infrastructure_sewage
var land_infrastructure_sewage='-';if(appraisals[i].land_infrastructure_sewage){if(_this11.currentLocale==='ca'){land_infrastructure_sewage='Sí';}else if(_this11.currentLocale==='en'){land_infrastructure_sewage='Yes';}else{land_infrastructure_sewage='Sí';}}else{if(_this11.currentLocale==='ca'){land_infrastructure_sewage='No';}else if(_this11.currentLocale==='en'){land_infrastructure_sewage='No';}else{land_infrastructure_sewage='No';}}// land_infrastructure_sewage_execution_pct
var land_infrastructure_sewage_execution_pct='-';if(appraisals[i].land_infrastructure_sewage_execution_pct){land_infrastructure_sewage_execution_pct=appraisals[i].land_infrastructure_sewage_execution_pct;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir el percentatge d\'execució de clavegueram del terreny',style:'plain',alignment:'left'}]);}// land_infrastructure_public_lighting
var land_infrastructure_public_lighting='-';if(appraisals[i].land_infrastructure_public_lighting){if(_this11.currentLocale==='ca'){land_infrastructure_public_lighting='Sí';}else if(_this11.currentLocale==='en'){land_infrastructure_public_lighting='Yes';}else{land_infrastructure_public_lighting='Sí';}}else{if(_this11.currentLocale==='ca'){land_infrastructure_public_lighting='No';}else if(_this11.currentLocale==='en'){land_infrastructure_public_lighting='No';}else{land_infrastructure_public_lighting='No';}}// land_infrastructure_public_lighting_execution_pct
var land_infrastructure_public_lighting_execution_pct='-';if(appraisals[i].land_infrastructure_public_lighting_execution_pct){land_infrastructure_public_lighting_execution_pct=appraisals[i].land_infrastructure_public_lighting_execution_pct;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir el percentatge d\'execució d\'enllumenat públic del terreny',style:'plain',alignment:'left'}]);}// land_infrastructure_water_supply
var land_infrastructure_water_supply='-';if(appraisals[i].land_infrastructure_water_supply){if(_this11.currentLocale==='ca'){land_infrastructure_water_supply='Sí';}else if(_this11.currentLocale==='en'){land_infrastructure_water_supply='Yes';}else{land_infrastructure_water_supply='Sí';}}else{if(_this11.currentLocale==='ca'){land_infrastructure_water_supply='No';}else if(_this11.currentLocale==='en'){land_infrastructure_water_supply='No';}else{land_infrastructure_water_supply='No';}}// land_infrastructure_water_supply_execution_pct
var land_infrastructure_water_supply_execution_pct='-';if(appraisals[i].land_infrastructure_water_supply_execution_pct){land_infrastructure_water_supply_execution_pct=appraisals[i].land_infrastructure_water_supply_execution_pct;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir el percentatge d\'execució de suministrament d\'aigua del terreny',style:'plain',alignment:'left'}]);}// land_infrastructure_electricity_supply
var land_infrastructure_electricity_supply='-';if(appraisals[i].land_infrastructure_electricity_supply){if(_this11.currentLocale==='ca'){land_infrastructure_electricity_supply='Sí';}else if(_this11.currentLocale==='en'){land_infrastructure_electricity_supply='Yes';}else{land_infrastructure_electricity_supply='Sí';}}else{if(_this11.currentLocale==='ca'){land_infrastructure_electricity_supply='No';}else if(_this11.currentLocale==='en'){land_infrastructure_electricity_supply='No';}else{land_infrastructure_electricity_supply='No';}}// land_infrastructure_electricity_supply_execution_pct
var land_infrastructure_electricity_supply_execution_pct='-';if(appraisals[i].land_infrastructure_electricity_supply_execution_pct){land_infrastructure_electricity_supply_execution_pct=appraisals[i].land_infrastructure_electricity_supply_execution_pct;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir el percentatge d\'execució d\'eleectricitat del terreny',style:'plain',alignment:'left'}]);}// land_infrastructure_piped_gas
var land_infrastructure_piped_gas='-';if(appraisals[i].land_infrastructure_piped_gas){if(_this11.currentLocale==='ca'){land_infrastructure_piped_gas='Sí';}else if(_this11.currentLocale==='en'){land_infrastructure_piped_gas='Yes';}else{land_infrastructure_piped_gas='Sí';}}else{if(_this11.currentLocale==='ca'){land_infrastructure_piped_gas='No';}else if(_this11.currentLocale==='en'){land_infrastructure_piped_gas='No';}else{land_infrastructure_piped_gas='No';}}// land_infrastructure_piped_gas_execution_pct
var land_infrastructure_piped_gas_execution_pct='-';if(appraisals[i].land_infrastructure_piped_gas_execution_pct){land_infrastructure_piped_gas_execution_pct=appraisals[i].land_infrastructure_piped_gas_execution_pct;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir el percentatge d\'execució de gas canalitzat del terreny',style:'plain',alignment:'left'}]);}// land_infrastructure_telephone_service
var land_infrastructure_telephone_service='-';if(appraisals[i].land_infrastructure_telephone_service){if(_this11.currentLocale==='ca'){land_infrastructure_telephone_service='Sí';}else if(_this11.currentLocale==='en'){land_infrastructure_telephone_service='Yes';}else{land_infrastructure_telephone_service='Sí';}}else{if(_this11.currentLocale==='ca'){land_infrastructure_telephone_service='No';}else if(_this11.currentLocale==='en'){land_infrastructure_telephone_service='No';}else{land_infrastructure_telephone_service='No';}}// land_infrastructure_telephone_service_execution_pct
var land_infrastructure_telephone_service_execution_pct='-';if(appraisals[i].land_infrastructure_telephone_service_execution_pct){land_infrastructure_telephone_service_execution_pct=appraisals[i].land_infrastructure_telephone_service_execution_pct;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir el percentatge d\'execució de servei telefonia del terreny',style:'plain',alignment:'left'}]);}// land_infrastructure_gardened_areas
var land_infrastructure_gardened_areas='-';if(appraisals[i].land_infrastructure_gardened_areas){if(_this11.currentLocale==='ca'){land_infrastructure_gardened_areas='Sí';}else if(_this11.currentLocale==='en'){land_infrastructure_gardened_areas='Yes';}else{land_infrastructure_gardened_areas='Sí';}}else{if(_this11.currentLocale==='ca'){land_infrastructure_gardened_areas='No';}else if(_this11.currentLocale==='en'){land_infrastructure_gardened_areas='No';}else{land_infrastructure_gardened_areas='No';}}// land_infrastructure_gardened_areas_execution_pct
var land_infrastructure_gardened_areas_execution_pct='-';if(appraisals[i].land_infrastructure_gardened_areas_execution_pct){land_infrastructure_gardened_areas_execution_pct=appraisals[i].land_infrastructure_gardened_areas_execution_pct;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir el percentatge d\'execució de zones enjardinades del terreny',style:'plain',alignment:'left'}]);}// land_is_plot_according_to_law
var land_is_plot_according_to_law='-';if(appraisals[i].land_is_plot_according_to_law){if(_this11.currentLocale==='ca'){land_is_plot_according_to_law='Sí';}else if(_this11.currentLocale==='en'){land_is_plot_according_to_law='Yes';}else{land_is_plot_according_to_law='Sí';}}else{if(_this11.currentLocale==='ca'){land_is_plot_according_to_law='No';}else if(_this11.currentLocale==='en'){land_is_plot_according_to_law='No';}else{land_is_plot_according_to_law='No';}}// land_infrastructure_conservation_status
var land_infrastructure_conservation_status='-';if(appraisals[i].land_infrastructure_conservation_status){if(_this11.currentLocale==='ca'){land_infrastructure_conservation_status=appraisals[i].land_infrastructure_conservation_status.name_ca;}else if(_this11.currentLocale==='en'){land_infrastructure_conservation_status=appraisals[i].land_infrastructure_conservation_status.name_en;}else{land_infrastructure_conservation_status=appraisals[i].land_infrastructure_conservation_status.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir l\'estat de conervació de les infraestructures del terreny',style:'plain',alignment:'left'}]);}// land_infrastructure_pending_investment
var land_infrastructure_pending_investment='-';if(appraisals[i].land_infrastructure_pending_investment){land_infrastructure_pending_investment=appraisals[i].land_infrastructure_pending_investment;}else{}// plot_occupation
var plot_occupation='-';if(appraisals[i].plot_occupation){// plot_occupation = appraisals[i].plot_occupation
if(_this11.currentLocale==='ca'){plot_occupation=appraisals[i].plot_occupation.name_ca;}else if(_this11.currentLocale==='en'){plot_occupation=appraisals[i].plot_occupation.name_en;}else{plot_occupation=appraisals[i].plot_occupation.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir el tipus d\'ocupació de parcel·la',style:'plain',alignment:'left'}]);}// plot_free_area_usage
var plot_free_area_usage='-';if(appraisals[i].plot_free_area_usage){// plot_free_area_usage = appraisals[i].plot_free_area_usage
if(_this11.currentLocale==='ca'){plot_free_area_usage=appraisals[i].plot_free_area_usage.name_ca;}else if(_this11.currentLocale==='en'){plot_free_area_usage=appraisals[i].plot_free_area_usage.name_en;}else{plot_free_area_usage=appraisals[i].plot_free_area_usage.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir l\'ús de superfície lliure de parcel·la',style:'plain',alignment:'left'}]);}// floors_number_underground
var floors_number_underground='-';if(appraisals[i].floors_number_underground){floors_number_underground=appraisals[i].floors_number_underground;}else{if(appraisals[i].floors_number_underground===0){}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir el nº de plantes sota rasant de l\'edifici',style:'plain',alignment:'left'}]);}}// floors_usage_underground
var floors_usage_underground='-';if(appraisals[i].floors_number_underground===0){}else{if(appraisals[i].floors_usage_underground){if(_this11.currentLocale==='ca'){floors_usage_underground=appraisals[i].floors_usage_underground.name_ca;}else if(_this11.currentLocale==='en'){floors_usage_underground=appraisals[i].floors_usage_underground.name_en;}else{floors_usage_underground=appraisals[i].floors_usage_underground.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir l\'ús de la planta sota rasant de l\'edifici',style:'plain',alignment:'left'}]);}}// groundfloor_usage
var groundfloor_usage='-';if(appraisals[i].groundfloor_usage){if(_this11.currentLocale==='ca'){groundfloor_usage=appraisals[i].groundfloor_usage.name_ca;}else if(_this11.currentLocale==='en'){groundfloor_usage=appraisals[i].groundfloor_usage.name_en;}else{groundfloor_usage=appraisals[i].groundfloor_usage.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir l\'ús de la planta a nivell rasant de l\'edifici',style:'plain',alignment:'left'}]);}// floors_number_overground
var floors_number_overground='-';if(appraisals[i].floors_number_overground){floors_number_overground=appraisals[i].floors_number_overground;}else{if(appraisals[i].floors_number_overground===0){}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir el nº de plantes sobre rasant de l\'edifici',style:'plain',alignment:'left'}]);}}// floors_usage_overground
var floors_usage_overground='-';if(appraisals[i].floors_number_overground===0){}else{if(appraisals[i].floors_usage_overground){if(_this11.currentLocale==='ca'){floors_usage_overground=appraisals[i].floors_usage_overground.name_ca;}else if(_this11.currentLocale==='en'){floors_usage_overground=appraisals[i].floors_usage_overground.name_en;}else{floors_usage_overground=appraisals[i].floors_usage_overground.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir l\'ús de la planta sobre rasant de l\'edifici',style:'plain',alignment:'left'}]);}}// entrance_hall
var entrance_hall='-';if(appraisals[i].entrance_hall){if(_this11.currentLocale==='ca'){entrance_hall='Sí';}else if(_this11.currentLocale==='en'){entrance_hall='Yes';}else{entrance_hall='Sí';}}else{if(_this11.currentLocale==='ca'){entrance_hall='No';}else if(_this11.currentLocale==='en'){entrance_hall='No';}else{entrance_hall='No';}}// doorman_space
var doorman_space='-';if(appraisals[i].doorman_space){if(_this11.currentLocale==='ca'){doorman_space='Sí';}else if(_this11.currentLocale==='en'){doorman_space='Yes';}else{doorman_space='Sí';}}else{if(_this11.currentLocale==='ca'){doorman_space='No';}else if(_this11.currentLocale==='en'){doorman_space='No';}else{doorman_space='No';}}// staircase
var staircase='-';if(appraisals[i].staircase){if(_this11.currentLocale==='ca'){staircase='Sí';}else if(_this11.currentLocale==='en'){staircase='Yes';}else{staircase='Sí';}}else{if(_this11.currentLocale==='ca'){staircase='No';}else if(_this11.currentLocale==='en'){staircase='No';}else{staircase='No';}}// lift
var lift='-';if(appraisals[i].lift){if(_this11.currentLocale==='ca'){lift='Sí';}else if(_this11.currentLocale==='en'){lift='Yes';}else{lift='Sí';}}else{if(_this11.currentLocale==='ca'){lift='No';}else if(_this11.currentLocale==='en'){lift='No';}else{lift='No';}}// swimming_pool
var swimming_pool='-';if(appraisals[i].swimming_pool){if(_this11.currentLocale==='ca'){swimming_pool='Sí';}else if(_this11.currentLocale==='en'){swimming_pool='Yes';}else{swimming_pool='Sí';}}else{if(_this11.currentLocale==='ca'){swimming_pool='No';}else if(_this11.currentLocale==='en'){swimming_pool='No';}else{swimming_pool='No';}}// gardened_areas
var gardened_areas='-';if(appraisals[i].gardened_areas){if(_this11.currentLocale==='ca'){gardened_areas='Sí';}else if(_this11.currentLocale==='en'){gardened_areas='Yes';}else{gardened_areas='Sí';}}else{if(_this11.currentLocale==='ca'){gardened_areas='No';}else if(_this11.currentLocale==='en'){gardened_areas='No';}else{gardened_areas='No';}}// sports_facilities
var sports_facilities='-';if(appraisals[i].sports_facilities){if(_this11.currentLocale==='ca'){sports_facilities='Sí';}else if(_this11.currentLocale==='en'){sports_facilities='Yes';}else{sports_facilities='Sí';}}else{if(_this11.currentLocale==='ca'){sports_facilities='No';}else if(_this11.currentLocale==='en'){sports_facilities='No';}else{sports_facilities='No';}}// community_room
var community_room='-';if(appraisals[i].community_room){if(_this11.currentLocale==='ca'){community_room='Sí';}else if(_this11.currentLocale==='en'){community_room='Yes';}else{community_room='Sí';}}else{if(_this11.currentLocale==='ca'){community_room='No';}else if(_this11.currentLocale==='en'){community_room='No';}else{community_room='No';}}// community_parking
var community_parking='-';if(appraisals[i].community_parking){if(_this11.currentLocale==='ca'){community_parking='Sí';}else if(_this11.currentLocale==='en'){community_parking='Yes';}else{community_parking='Sí';}}else{if(_this11.currentLocale==='ca'){community_parking='No';}else if(_this11.currentLocale==='en'){community_parking='No';}else{community_parking='No';}}// checks_interior_visit
var checks_interior_visit='-';if(appraisals[i].checks_interior_visit){if(_this11.currentLocale==='ca'){checks_interior_visit='Sí';}else if(_this11.currentLocale==='en'){checks_interior_visit='Yes';}else{checks_interior_visit='Sí';}}else{if(_this11.currentLocale==='ca'){checks_interior_visit='No';}else if(_this11.currentLocale==='en'){checks_interior_visit='No';}else{checks_interior_visit='No';}}// checks_cadastral_data
var checks_cadastral_data='-';if(appraisals[i].checks_cadastral_data){if(_this11.currentLocale==='ca'){checks_cadastral_data='Sí';}else if(_this11.currentLocale==='en'){checks_cadastral_data='Yes';}else{checks_cadastral_data='Sí';}}else{if(_this11.currentLocale==='ca'){checks_cadastral_data='No';}else if(_this11.currentLocale==='en'){checks_cadastral_data='No';}else{checks_cadastral_data='No';}}// checks_conservation_status
var checks_conservation_status='-';if(appraisals[i].checks_conservation_status){if(_this11.currentLocale==='ca'){checks_conservation_status='Sí';}else if(_this11.currentLocale==='en'){checks_conservation_status='Yes';}else{checks_conservation_status='Sí';}}else{if(_this11.currentLocale==='ca'){checks_conservation_status='No';}else if(_this11.currentLocale==='en'){checks_conservation_status='No';}else{checks_conservation_status='No';}}// checks_expropriation_procedure
var checks_expropriation_procedure='-';if(appraisals[i].checks_expropriation_procedure){if(_this11.currentLocale==='ca'){checks_expropriation_procedure='Sí';}else if(_this11.currentLocale==='en'){checks_expropriation_procedure='Yes';}else{checks_expropriation_procedure='Sí';}}else{if(_this11.currentLocale==='ca'){checks_expropriation_procedure='No';}else if(_this11.currentLocale==='en'){checks_expropriation_procedure='No';}else{checks_expropriation_procedure='No';}}// checks_expropriation_plan
var checks_expropriation_plan='-';if(appraisals[i].checks_expropriation_plan){if(_this11.currentLocale==='ca'){checks_expropriation_plan='Sí';}else if(_this11.currentLocale==='en'){checks_expropriation_plan='Yes';}else{checks_expropriation_plan='Sí';}}else{if(_this11.currentLocale==='ca'){checks_expropriation_plan='No';}else if(_this11.currentLocale==='en'){checks_expropriation_plan='No';}else{checks_expropriation_plan='No';}}// checks_expropriation_admin_ruling
var checks_expropriation_admin_ruling='-';if(appraisals[i].checks_expropriation_admin_ruling){if(_this11.currentLocale==='ca'){checks_expropriation_admin_ruling='Sí';}else if(_this11.currentLocale==='en'){checks_expropriation_admin_ruling='Yes';}else{checks_expropriation_admin_ruling='Sí';}}else{if(_this11.currentLocale==='ca'){checks_expropriation_admin_ruling='No';}else if(_this11.currentLocale==='en'){checks_expropriation_admin_ruling='No';}else{checks_expropriation_admin_ruling='No';}}// checks_expropriation_file
var checks_expropriation_file='-';if(appraisals[i].checks_expropriation_file){if(_this11.currentLocale==='ca'){checks_expropriation_file='Sí';}else if(_this11.currentLocale==='en'){checks_expropriation_file='Yes';}else{checks_expropriation_file='Sí';}}else{if(_this11.currentLocale==='ca'){checks_expropriation_file='No';}else if(_this11.currentLocale==='en'){checks_expropriation_file='No';}else{checks_expropriation_file='No';}}// checks_occupancy
var checks_occupancy='-';if(appraisals[i].checks_occupancy){if(_this11.currentLocale==='ca'){checks_occupancy='Sí';}else if(_this11.currentLocale==='en'){checks_occupancy='Yes';}else{checks_occupancy='Sí';}}else{if(_this11.currentLocale==='ca'){checks_occupancy='No';}else if(_this11.currentLocale==='en'){checks_occupancy='No';}else{checks_occupancy='No';}}// checks_registry_data
var checks_registry_data='-';if(appraisals[i].checks_registry_data){if(_this11.currentLocale==='ca'){checks_registry_data='Sí';}else if(_this11.currentLocale==='en'){checks_registry_data='Yes';}else{checks_registry_data='Sí';}}else{if(_this11.currentLocale==='ca'){checks_registry_data='No';}else if(_this11.currentLocale==='en'){checks_registry_data='No';}else{checks_registry_data='No';}}// checks_servitudes
var checks_servitudes='-';if(appraisals[i].checks_servitudes){if(_this11.currentLocale==='ca'){checks_servitudes='Sí';}else if(_this11.currentLocale==='en'){checks_servitudes='Yes';}else{checks_servitudes='Sí';}}else{if(_this11.currentLocale==='ca'){checks_servitudes='No';}else if(_this11.currentLocale==='en'){checks_servitudes='No';}else{checks_servitudes='No';}}// checks_subsidy_status
var checks_subsidy_status='-';if(appraisals[i].checks_subsidy_status){if(_this11.currentLocale==='ca'){checks_subsidy_status='Sí';}else if(_this11.currentLocale==='en'){checks_subsidy_status='Yes';}else{checks_subsidy_status='Sí';}}else{if(_this11.currentLocale==='ca'){checks_subsidy_status='No';}else if(_this11.currentLocale==='en'){checks_subsidy_status='No';}else{checks_subsidy_status='No';}}// checks_urban_planning
var checks_urban_planning='-';if(appraisals[i].checks_urban_planning){if(_this11.currentLocale==='ca'){checks_urban_planning='Sí';}else if(_this11.currentLocale==='en'){checks_urban_planning='Yes';}else{checks_urban_planning='Sí';}}else{if(_this11.currentLocale==='ca'){checks_urban_planning='No';}else if(_this11.currentLocale==='en'){checks_urban_planning='No';}else{checks_urban_planning='No';}}// checks_other
var checks_other='-';if(appraisals[i].checks_other){checks_other=appraisals[i].checks_other;}else{}// community_parking
var docs_approved_project='-';if(appraisals[i].docs_approved_project){if(_this11.currentLocale==='ca'){docs_approved_project='Sí';}else if(_this11.currentLocale==='en'){docs_approved_project='Yes';}else{docs_approved_project='Sí';}}else{if(_this11.currentLocale==='ca'){docs_approved_project='No';}else if(_this11.currentLocale==='en'){docs_approved_project='No';}else{docs_approved_project='No';}}// docs_cadastral_data
var docs_cadastral_data='-';if(appraisals[i].docs_cadastral_data){if(_this11.currentLocale==='ca'){docs_cadastral_data='Sí';}else if(_this11.currentLocale==='en'){docs_cadastral_data='Yes';}else{docs_cadastral_data='Sí';}}else{if(_this11.currentLocale==='ca'){docs_cadastral_data='No';}else if(_this11.currentLocale==='en'){docs_cadastral_data='No';}else{docs_cadastral_data='No';}}// docs_construction_license
var docs_construction_license='-';if(appraisals[i].docs_construction_license){if(_this11.currentLocale==='ca'){docs_construction_license='Sí';}else if(_this11.currentLocale==='en'){docs_construction_license='Yes';}else{docs_construction_license='Sí';}}else{if(_this11.currentLocale==='ca'){docs_construction_license='No';}else if(_this11.currentLocale==='en'){docs_construction_license='No';}else{docs_construction_license='No';}}// docs_construction_last_certificate
var docs_construction_last_certificate='-';if(appraisals[i].docs_construction_last_certificate){if(_this11.currentLocale==='ca'){docs_construction_last_certificate='Sí';}else if(_this11.currentLocale==='en'){docs_construction_last_certificate='Yes';}else{docs_construction_last_certificate='Sí';}}else{if(_this11.currentLocale==='ca'){docs_construction_last_certificate='No';}else if(_this11.currentLocale==='en'){docs_construction_last_certificate='No';}else{docs_construction_last_certificate='No';}}// docs_construction_contract
var docs_construction_contract='-';if(appraisals[i].docs_construction_contract){if(_this11.currentLocale==='ca'){docs_construction_contract='Sí';}else if(_this11.currentLocale==='en'){docs_construction_contract='Yes';}else{docs_construction_contract='Sí';}}else{if(_this11.currentLocale==='ca'){docs_construction_contract='No';}else if(_this11.currentLocale==='en'){docs_construction_contract='No';}else{docs_construction_contract='No';}}// docs_occupancy_status
var docs_occupancy_status='-';if(appraisals[i].docs_occupancy_status){if(_this11.currentLocale==='ca'){docs_occupancy_status='Sí';}else if(_this11.currentLocale==='en'){docs_occupancy_status='Yes';}else{docs_occupancy_status='Sí';}}else{if(_this11.currentLocale==='ca'){docs_occupancy_status='No';}else if(_this11.currentLocale==='en'){docs_occupancy_status='No';}else{docs_occupancy_status='No';}}// docs_photographic_report
var docs_photographic_report='-';if(appraisals[i].docs_photographic_report){if(_this11.currentLocale==='ca'){docs_photographic_report='Sí';}else if(_this11.currentLocale==='en'){docs_photographic_report='Yes';}else{docs_photographic_report='Sí';}}else{if(_this11.currentLocale==='ca'){docs_photographic_report='No';}else if(_this11.currentLocale==='en'){docs_photographic_report='No';}else{docs_photographic_report='No';}}// docs_property_sketch
var docs_property_sketch='-';if(appraisals[i].docs_property_sketch){if(_this11.currentLocale==='ca'){docs_property_sketch='Sí';}else if(_this11.currentLocale==='en'){docs_property_sketch='Yes';}else{docs_property_sketch='Sí';}}else{if(_this11.currentLocale==='ca'){docs_property_sketch='No';}else if(_this11.currentLocale==='en'){docs_property_sketch='No';}else{docs_property_sketch='No';}}// docs_property_titles
var docs_property_titles='-';if(appraisals[i].docs_property_titles){if(_this11.currentLocale==='ca'){docs_property_titles='Sí';}else if(_this11.currentLocale==='en'){docs_property_titles='Yes';}else{docs_property_titles='Sí';}}else{if(_this11.currentLocale==='ca'){docs_property_titles='No';}else if(_this11.currentLocale==='en'){docs_property_titles='No';}else{docs_property_titles='No';}}// docs_situation_plan
var docs_situation_plan='-';if(appraisals[i].docs_situation_plan){if(_this11.currentLocale==='ca'){docs_situation_plan='Sí';}else if(_this11.currentLocale==='en'){docs_situation_plan='Yes';}else{docs_situation_plan='Sí';}}else{if(_this11.currentLocale==='ca'){docs_situation_plan='No';}else if(_this11.currentLocale==='en'){docs_situation_plan='No';}else{docs_situation_plan='No';}}// docs_subsidy_status
var docs_subsidy_status='-';if(appraisals[i].docs_subsidy_status){if(_this11.currentLocale==='ca'){docs_subsidy_status='Sí';}else if(_this11.currentLocale==='en'){docs_subsidy_status='Yes';}else{docs_subsidy_status='Sí';}}else{if(_this11.currentLocale==='ca'){docs_subsidy_status='No';}else if(_this11.currentLocale==='en'){docs_subsidy_status='No';}else{docs_subsidy_status='No';}}// docs_tenyear_insurance
var docs_tenyear_insurance='-';if(appraisals[i].docs_tenyear_insurance){if(_this11.currentLocale==='ca'){docs_tenyear_insurance='Sí';}else if(_this11.currentLocale==='en'){docs_tenyear_insurance='Yes';}else{docs_tenyear_insurance='Sí';}}else{if(_this11.currentLocale==='ca'){docs_tenyear_insurance='No';}else if(_this11.currentLocale==='en'){docs_tenyear_insurance='No';}else{docs_tenyear_insurance='No';}}// docs_urban_plan
var docs_urban_plan='-';if(appraisals[i].docs_urban_plan){if(_this11.currentLocale==='ca'){docs_urban_plan='Sí';}else if(_this11.currentLocale==='en'){docs_urban_plan='Yes';}else{docs_urban_plan='Sí';}}else{if(_this11.currentLocale==='ca'){docs_urban_plan='No';}else if(_this11.currentLocale==='en'){docs_urban_plan='No';}else{docs_urban_plan='No';}}// docs_other
var docs_other='-';if(appraisals[i].docs_other){docs_other=appraisals[i].docs_other;}else{}// realestate_interior_paving_living
var realestate_interior_paving_living='-';if(appraisals[i].realestate_interior_paving_living){if(_this11.currentLocale==='ca'){realestate_interior_paving_living=appraisals[i].realestate_interior_paving_living.name_ca;}else if(_this11.currentLocale==='en'){realestate_interior_paving_living=appraisals[i].realestate_interior_paving_living.name_en;}else{realestate_interior_paving_living=appraisals[i].realestate_interior_paving_living.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir els acabats interiors paviment estar',style:'plain',alignment:'left'}]);}// realestate_interior_paving_corridor
var realestate_interior_paving_corridor='-';if(appraisals[i].realestate_interior_paving_corridor){if(_this11.currentLocale==='ca'){realestate_interior_paving_corridor=appraisals[i].realestate_interior_paving_corridor.name_ca;}else if(_this11.currentLocale==='en'){realestate_interior_paving_corridor=appraisals[i].realestate_interior_paving_corridor.name_en;}else{realestate_interior_paving_corridor=appraisals[i].realestate_interior_paving_corridor.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir els acabats interiors paviment circulacions',style:'plain',alignment:'left'}]);}// realestate_interior_paving_bedroom
var realestate_interior_paving_bedroom='-';if(appraisals[i].realestate_interior_paving_bedroom){if(_this11.currentLocale==='ca'){realestate_interior_paving_bedroom=appraisals[i].realestate_interior_paving_bedroom.name_ca;}else if(_this11.currentLocale==='en'){realestate_interior_paving_bedroom=appraisals[i].realestate_interior_paving_bedroom.name_en;}else{realestate_interior_paving_bedroom=appraisals[i].realestate_interior_paving_bedroom.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir els acabats interiors paviment banys',style:'plain',alignment:'left'}]);}// realestate_interior_paving_kitchen
var realestate_interior_paving_kitchen='-';if(appraisals[i].realestate_interior_paving_kitchen){if(_this11.currentLocale==='ca'){realestate_interior_paving_kitchen=appraisals[i].realestate_interior_paving_kitchen.name_ca;}else if(_this11.currentLocale==='en'){realestate_interior_paving_kitchen=appraisals[i].realestate_interior_paving_kitchen.name_en;}else{realestate_interior_paving_kitchen=appraisals[i].realestate_interior_paving_kitchen.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir els acabats interiors paviment cuina',style:'plain',alignment:'left'}]);}// realestate_interior_paving_bathroom
var realestate_interior_paving_bathroom='-';if(appraisals[i].realestate_interior_paving_bathroom){if(_this11.currentLocale==='ca'){realestate_interior_paving_bathroom=appraisals[i].realestate_interior_paving_bathroom.name_ca;}else if(_this11.currentLocale==='en'){realestate_interior_paving_bathroom=appraisals[i].realestate_interior_paving_bathroom.name_en;}else{realestate_interior_paving_bathroom=appraisals[i].realestate_interior_paving_bathroom.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir els acabats interiors paviment bany',style:'plain',alignment:'left'}]);}// realestate_interior_paving_quality
var realestate_interior_paving_quality='-';if(appraisals[i].realestate_interior_paving_quality){if(_this11.currentLocale==='ca'){realestate_interior_paving_quality=appraisals[i].realestate_interior_paving_quality.name_ca;}else if(_this11.currentLocale==='en'){realestate_interior_paving_quality=appraisals[i].realestate_interior_paving_quality.name_en;}else{realestate_interior_paving_quality=appraisals[i].realestate_interior_paving_quality.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir qualitat acabats interiors paviment',style:'plain',alignment:'left'}]);}// realestate_interior_walls_living
var realestate_interior_walls_living='-';if(appraisals[i].realestate_interior_walls_living){if(_this11.currentLocale==='ca'){realestate_interior_walls_living=appraisals[i].realestate_interior_walls_living.name_ca;}else if(_this11.currentLocale==='en'){realestate_interior_walls_living=appraisals[i].realestate_interior_walls_living.name_en;}else{realestate_interior_walls_living=appraisals[i].realestate_interior_walls_living.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir els acabats interiors parets estar',style:'plain',alignment:'left'}]);}// realestate_interior_walls_corridor
var realestate_interior_walls_corridor='-';if(appraisals[i].realestate_interior_walls_corridor){if(_this11.currentLocale==='ca'){realestate_interior_walls_corridor=appraisals[i].realestate_interior_walls_corridor.name_ca;}else if(_this11.currentLocale==='en'){realestate_interior_walls_corridor=appraisals[i].realestate_interior_walls_corridor.name_en;}else{realestate_interior_walls_corridor=appraisals[i].realestate_interior_walls_corridor.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir els acabats interiors parets circulacions',style:'plain',alignment:'left'}]);}// realestate_interior_walls_bedroom
var realestate_interior_walls_bedroom='-';if(appraisals[i].realestate_interior_walls_bedroom){if(_this11.currentLocale==='ca'){realestate_interior_walls_bedroom=appraisals[i].realestate_interior_walls_bedroom.name_ca;}else if(_this11.currentLocale==='en'){realestate_interior_walls_bedroom=appraisals[i].realestate_interior_walls_bedroom.name_en;}else{realestate_interior_walls_bedroom=appraisals[i].realestate_interior_walls_bedroom.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir els acabats interiors parets banys',style:'plain',alignment:'left'}]);}// realestate_interior_walls_kitchen
var realestate_interior_walls_kitchen='-';if(appraisals[i].realestate_interior_walls_kitchen){if(_this11.currentLocale==='ca'){realestate_interior_walls_kitchen=appraisals[i].realestate_interior_walls_kitchen.name_ca;}else if(_this11.currentLocale==='en'){realestate_interior_walls_kitchen=appraisals[i].realestate_interior_walls_kitchen.name_en;}else{realestate_interior_walls_kitchen=appraisals[i].realestate_interior_walls_kitchen.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir els acabats interiors parets cuina',style:'plain',alignment:'left'}]);}// realestate_interior_walls_bathroom
var realestate_interior_walls_bathroom='-';if(appraisals[i].realestate_interior_walls_bathroom){if(_this11.currentLocale==='ca'){realestate_interior_walls_bathroom=appraisals[i].realestate_interior_walls_bathroom.name_ca;}else if(_this11.currentLocale==='en'){realestate_interior_walls_bathroom=appraisals[i].realestate_interior_walls_bathroom.name_en;}else{realestate_interior_walls_bathroom=appraisals[i].realestate_interior_walls_bathroom.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir els acabats interiors parets bany',style:'plain',alignment:'left'}]);}// realestate_interior_walls_quality
var realestate_interior_walls_quality='-';if(appraisals[i].realestate_interior_walls_quality){if(_this11.currentLocale==='ca'){realestate_interior_walls_quality=appraisals[i].realestate_interior_walls_quality.name_ca;}else if(_this11.currentLocale==='en'){realestate_interior_walls_quality=appraisals[i].realestate_interior_walls_quality.name_en;}else{realestate_interior_walls_quality=appraisals[i].realestate_interior_walls_quality.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir qualitat acabats interiors parets',style:'plain',alignment:'left'}]);}// realestate_interior_ceilings_living
var realestate_interior_ceilings_living='-';if(appraisals[i].realestate_interior_ceilings_living){if(_this11.currentLocale==='ca'){realestate_interior_ceilings_living=appraisals[i].realestate_interior_ceilings_living.name_ca;}else if(_this11.currentLocale==='en'){realestate_interior_ceilings_living=appraisals[i].realestate_interior_ceilings_living.name_en;}else{realestate_interior_ceilings_living=appraisals[i].realestate_interior_ceilings_living.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir els acabats interiors sostres estar',style:'plain',alignment:'left'}]);}// realestate_interior_ceilings_corridor
var realestate_interior_ceilings_corridor='-';if(appraisals[i].realestate_interior_ceilings_corridor){if(_this11.currentLocale==='ca'){realestate_interior_ceilings_corridor=appraisals[i].realestate_interior_ceilings_corridor.name_ca;}else if(_this11.currentLocale==='en'){realestate_interior_ceilings_corridor=appraisals[i].realestate_interior_ceilings_corridor.name_en;}else{realestate_interior_ceilings_corridor=appraisals[i].realestate_interior_ceilings_corridor.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir els acabats interiors sostres circulacions',style:'plain',alignment:'left'}]);}// realestate_interior_ceilings_bedroom
var realestate_interior_ceilings_bedroom='-';if(appraisals[i].realestate_interior_ceilings_bedroom){if(_this11.currentLocale==='ca'){realestate_interior_ceilings_bedroom=appraisals[i].realestate_interior_ceilings_bedroom.name_ca;}else if(_this11.currentLocale==='en'){realestate_interior_ceilings_bedroom=appraisals[i].realestate_interior_ceilings_bedroom.name_en;}else{realestate_interior_ceilings_bedroom=appraisals[i].realestate_interior_ceilings_bedroom.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir els acabats interiors sostres banys',style:'plain',alignment:'left'}]);}// realestate_interior_ceilings_kitchen
var realestate_interior_ceilings_kitchen='-';if(appraisals[i].realestate_interior_ceilings_kitchen){if(_this11.currentLocale==='ca'){realestate_interior_ceilings_kitchen=appraisals[i].realestate_interior_ceilings_kitchen.name_ca;}else if(_this11.currentLocale==='en'){realestate_interior_ceilings_kitchen=appraisals[i].realestate_interior_ceilings_kitchen.name_en;}else{realestate_interior_ceilings_kitchen=appraisals[i].realestate_interior_ceilings_kitchen.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir els acabats interiors sostres cuina',style:'plain',alignment:'left'}]);}// realestate_interior_ceilings_bathroom
var realestate_interior_ceilings_bathroom='-';if(appraisals[i].realestate_interior_ceilings_bathroom){if(_this11.currentLocale==='ca'){realestate_interior_ceilings_bathroom=appraisals[i].realestate_interior_ceilings_bathroom.name_ca;}else if(_this11.currentLocale==='en'){realestate_interior_ceilings_bathroom=appraisals[i].realestate_interior_ceilings_bathroom.name_en;}else{realestate_interior_ceilings_bathroom=appraisals[i].realestate_interior_ceilings_bathroom.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir els acabats interiors sostres bany',style:'plain',alignment:'left'}]);}// realestate_interior_ceilings_quality
var realestate_interior_ceilings_quality='-';if(appraisals[i].realestate_interior_ceilings_quality){if(_this11.currentLocale==='ca'){realestate_interior_ceilings_quality=appraisals[i].realestate_interior_ceilings_quality.name_ca;}else if(_this11.currentLocale==='en'){realestate_interior_ceilings_quality=appraisals[i].realestate_interior_ceilings_quality.name_en;}else{realestate_interior_ceilings_quality=appraisals[i].realestate_interior_ceilings_quality.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir qualitat acabats interiors sostres',style:'plain',alignment:'left'}]);}// realestate_interior_carpentry_living
var realestate_interior_carpentry_living='-';if(appraisals[i].realestate_interior_carpentry_living){if(_this11.currentLocale==='ca'){realestate_interior_carpentry_living=appraisals[i].realestate_interior_carpentry_living.name_ca;}else if(_this11.currentLocale==='en'){realestate_interior_carpentry_living=appraisals[i].realestate_interior_carpentry_living.name_en;}else{realestate_interior_carpentry_living=appraisals[i].realestate_interior_carpentry_living.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir els acabats interiors fusteria estar',style:'plain',alignment:'left'}]);}// realestate_interior_carpentry_corridor
var realestate_interior_carpentry_corridor='-';if(appraisals[i].realestate_interior_carpentry_corridor){if(_this11.currentLocale==='ca'){realestate_interior_carpentry_corridor=appraisals[i].realestate_interior_carpentry_corridor.name_ca;}else if(_this11.currentLocale==='en'){realestate_interior_carpentry_corridor=appraisals[i].realestate_interior_carpentry_corridor.name_en;}else{realestate_interior_carpentry_corridor=appraisals[i].realestate_interior_carpentry_corridor.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir els acabats interiors fusteria circulacions',style:'plain',alignment:'left'}]);}// realestate_interior_carpentry_bedroom
var realestate_interior_carpentry_bedroom='-';if(appraisals[i].realestate_interior_carpentry_bedroom){if(_this11.currentLocale==='ca'){realestate_interior_carpentry_bedroom=appraisals[i].realestate_interior_carpentry_bedroom.name_ca;}else if(_this11.currentLocale==='en'){realestate_interior_carpentry_bedroom=appraisals[i].realestate_interior_carpentry_bedroom.name_en;}else{realestate_interior_carpentry_bedroom=appraisals[i].realestate_interior_carpentry_bedroom.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir els acabats interiors fusteria banys',style:'plain',alignment:'left'}]);}// realestate_interior_carpentry_kitchen
var realestate_interior_carpentry_kitchen='-';if(appraisals[i].realestate_interior_carpentry_kitchen){if(_this11.currentLocale==='ca'){realestate_interior_carpentry_kitchen=appraisals[i].realestate_interior_carpentry_kitchen.name_ca;}else if(_this11.currentLocale==='en'){realestate_interior_carpentry_kitchen=appraisals[i].realestate_interior_carpentry_kitchen.name_en;}else{realestate_interior_carpentry_kitchen=appraisals[i].realestate_interior_carpentry_kitchen.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir els acabats interiors fusteria cuina',style:'plain',alignment:'left'}]);}// realestate_interior_carpentry_bathroom
var realestate_interior_carpentry_bathroom='-';if(appraisals[i].realestate_interior_carpentry_bathroom){if(_this11.currentLocale==='ca'){realestate_interior_carpentry_bathroom=appraisals[i].realestate_interior_carpentry_bathroom.name_ca;}else if(_this11.currentLocale==='en'){realestate_interior_carpentry_bathroom=appraisals[i].realestate_interior_carpentry_bathroom.name_en;}else{realestate_interior_carpentry_bathroom=appraisals[i].realestate_interior_carpentry_bathroom.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir els acabats interiors fusteria bany',style:'plain',alignment:'left'}]);}// realestate_interior_carpentry_quality
var realestate_interior_carpentry_quality='-';if(appraisals[i].realestate_interior_carpentry_quality){if(_this11.currentLocale==='ca'){realestate_interior_carpentry_quality=appraisals[i].realestate_interior_carpentry_quality.name_ca;}else if(_this11.currentLocale==='en'){realestate_interior_carpentry_quality=appraisals[i].realestate_interior_carpentry_quality.name_en;}else{realestate_interior_carpentry_quality=appraisals[i].realestate_interior_carpentry_quality.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir qualitat acabats interiors fusteria',style:'plain',alignment:'left'}]);}// realestate_rooms_to_exterior_number
var realestate_rooms_to_exterior_number='-';if(appraisals[i].realestate_rooms_to_exterior_number){realestate_rooms_to_exterior_number=appraisals[i].realestate_rooms_to_exterior_number;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir el nº d\'habitacions a exterior en condicions d\'habitabilitat',style:'plain',alignment:'left'}]);}// realestate_main_orientation
var realestate_main_orientation='-';if(appraisals[i].realestate_main_orientation){if(_this11.currentLocale==='ca'){realestate_main_orientation=appraisals[i].realestate_main_orientation.name_ca;}else if(_this11.currentLocale==='en'){realestate_main_orientation=appraisals[i].realestate_main_orientation.name_en;}else{realestate_main_orientation=appraisals[i].realestate_main_orientation.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la orientació principal (condicions d\'habitabilitat)',style:'plain',alignment:'left'}]);}// realestate_main_views
var realestate_main_views='-';if(appraisals[i].realestate_main_views){if(_this11.currentLocale==='ca'){realestate_main_views=appraisals[i].realestate_main_views.name_ca;}else if(_this11.currentLocale==='en'){realestate_main_views=appraisals[i].realestate_main_views.name_en;}else{realestate_main_views=appraisals[i].realestate_main_views.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir les vistes (condicions d\'habitabilitat)',style:'plain',alignment:'left'}]);}// realestate_windows_size_and_quantity
var realestate_windows_size_and_quantity='-';if(appraisals[i].realestate_windows_size_and_quantity){if(_this11.currentLocale==='ca'){realestate_windows_size_and_quantity=appraisals[i].realestate_windows_size_and_quantity.name_ca;}else if(_this11.currentLocale==='en'){realestate_windows_size_and_quantity=appraisals[i].realestate_windows_size_and_quantity.name_en;}else{realestate_windows_size_and_quantity=appraisals[i].realestate_windows_size_and_quantity.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la descripció sobre tamany i nº de finestres (condicions d\'habitabilitat)',style:'plain',alignment:'left'}]);}// realestate_noise_facade
var realestate_noise_facade='-';if(appraisals[i].realestate_noise_facade){if(_this11.currentLocale==='ca'){realestate_noise_facade=appraisals[i].realestate_noise_facade.name_ca;}else if(_this11.currentLocale==='en'){realestate_noise_facade=appraisals[i].realestate_noise_facade.name_en;}else{realestate_noise_facade=appraisals[i].realestate_noise_facade.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir el nivell de soroll en façana (condicions d\'habitabilitat)',style:'plain',alignment:'left'}]);}// realestate_day_night_zoning
var realestate_day_night_zoning='-';if(appraisals[i].realestate_day_night_zoning){if(_this11.currentLocale==='ca'){realestate_day_night_zoning='Sí';}else if(_this11.currentLocale==='en'){realestate_day_night_zoning='Yes';}else{realestate_day_night_zoning='Sí';}}else{if(_this11.currentLocale==='ca'){realestate_day_night_zoning='No';}else if(_this11.currentLocale==='en'){realestate_day_night_zoning='No';}else{realestate_day_night_zoning='No';}}// construction_year
var construction_year='-';if(appraisals[i].construction_year){construction_year=appraisals[i].construction_year;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir l\'any de construcció',style:'plain',alignment:'left'}]);}// last_renovation_year
var last_renovation_year='-';if(appraisals[i].last_renovation_year){last_renovation_year=appraisals[i].last_renovation_year;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir l\'any de l\'última rehabilitació',style:'plain',alignment:'left'}]);}// adopted_age
var adopted_age='-';if(appraisals[i].adopted_age){adopted_age=appraisals[i].adopted_age;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir l\'any de l\'última rehabilitació',style:'plain',alignment:'left'}]);}// adopted_age_years_old
var adopted_age_years_old='-';if(appraisals[i].adopted_age_years_old){adopted_age_years_old=appraisals[i].adopted_age_years_old+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('years');}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir l\'anitguetat considerada',style:'plain',alignment:'left'}]);}// useful_life_years
var useful_life_years='-';if(appraisals[i].useful_life_years){useful_life_years=appraisals[i].useful_life_years+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('years');}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la vida útil total estimada per a l\'immoble',style:'plain',alignment:'left'}]);}// remaining_useful_life_years
var remaining_useful_life_years='-';if(appraisals[i].remaining_useful_life_years){remaining_useful_life_years=appraisals[i].remaining_useful_life_years+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('years');}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la vida útil restant per a l\'immoble',style:'plain',alignment:'left'}]);}// conservation_status
var conservation_status='-';if(appraisals[i].conservation_status){if(_this11.currentLocale==='ca'){conservation_status=appraisals[i].conservation_status.name_ca;}else if(_this11.currentLocale==='en'){conservation_status=appraisals[i].conservation_status.name_en;}else{conservation_status=appraisals[i].conservation_status.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir l\'estat de conservació',style:'plain',alignment:'left'}]);}var tempNumFormat=function tempNumFormat(value,symbol){return _this11.numFormat(value,symbol);};var tempCurrentLocale=_this11.currentLocale;var net_areas_table=[];var covered_outdoors_table=[];var uncovered_outdoors_table=[];if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(rooms[i])>0){net_areas_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Description'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Net_area'),style:'small_bold'}]);}else{net_areas_table.push([{text:'-',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'}]);}__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(rooms[i],function(value,key){var value_type='';var value_description='';var value_netarea=0;if(value.type){value_type=tempCurrentLocale==='ca'?value.type.name_ca:tempCurrentLocale==='en'?value.type.name_en:value.type.name_es;}else{}if(value.description){value_description=value.description;}else{}if(value.netarea){value_netarea=tempNumFormat(value.netarea,'m²');}else{}net_areas_table.push([{text:value_type,style:'small'},{text:value_description,style:'small'},{text:value_netarea,style:'small'}]);});if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(rooms[i])>0){net_areas_table.push([{text:'Total',style:'small_bold'},{text:'',style:'small_bold'},{text:tempNumFormat(appraisals[i].net_checked_area,'m²'),style:'small_bold'}]);}// console.log('net_areas_table: ')
// console.log(net_areas_table)
if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(covered_outdoors[i])>0){covered_outdoors_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Description'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Net_area'),style:'small_bold'}]);}else{covered_outdoors_table.push([{text:'-',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'}]);}__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(covered_outdoors[i],function(value,key){var value_type='';var value_description='';var value_netarea=0;if(value.type){value_type=tempCurrentLocale==='ca'?value.type.name_ca:tempCurrentLocale==='en'?value.type.name_en:value.type.name_es;}else{}if(value.description){value_description=value.description;}else{}if(value.netarea){value_netarea=tempNumFormat(value.netarea,'m²');}else{}covered_outdoors_table.push([{text:value_type,style:'small'},{text:value_description,style:'small'},{text:value_netarea,style:'small'}]);});if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(covered_outdoors[i])>0){covered_outdoors_table.push([{text:'Total',style:'small_bold'},{text:'',style:'small_bold'},{text:tempNumFormat(appraisals[i].covered_terraces_total_checked_area,'m²'),style:'small_bold'}]);}// console.log('covered_outdoors_table: ')
// console.log(covered_outdoors_table)
if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(uncovered_outdoors[i])>0){uncovered_outdoors_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Description'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Net_area'),style:'small_bold'}]);}else{uncovered_outdoors_table.push([{text:'-',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'}]);}__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(uncovered_outdoors[i],function(value,key){var value_type='';var value_description='';var value_netarea=0;if(value.type){value_type=tempCurrentLocale==='ca'?value.type.name_ca:tempCurrentLocale==='en'?value.type.name_en:value.type.name_es;}else{}if(value.description){value_description=value.description;}else{}if(value.netarea){value_netarea=tempNumFormat(value.netarea,'m²');}else{}uncovered_outdoors_table.push([{text:value_type,style:'small'},{text:value_description,style:'small'},{text:value_netarea,style:'small'}]);});if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(uncovered_outdoors[i])>0){uncovered_outdoors_table.push([{text:'Total',style:'small_bold'},{text:'',style:'small_bold'},{text:tempNumFormat(appraisals[i].uncovered_terraces_total_checked_area,'m²'),style:'small_bold'}]);}// console.log('uncovered_outdoors_table: ')
// console.log(uncovered_outdoors_table)
// net_cadastral_area
var net_cadastral_area='-';if(appraisals[i].net_cadastral_area){net_cadastral_area=appraisals[i].net_cadastral_area;}else{}// net_checked_area
var net_checked_area='-';if(appraisals[i].net_checked_area){net_checked_area=appraisals[i].net_checked_area;}else{}// net_adopted_area
var net_adopted_area='-';if(appraisals[i].net_adopted_area){net_adopted_area=appraisals[i].net_adopted_area;}else{}// enclosed_cadastral_area
var enclosed_cadastral_area='-';if(appraisals[i].enclosed_cadastral_area){enclosed_cadastral_area=appraisals[i].enclosed_cadastral_area;}else{}// enclosed_checked_area
var enclosed_checked_area='-';if(appraisals[i].enclosed_checked_area){enclosed_checked_area=appraisals[i].enclosed_checked_area;}else{}// enclosed_adopted_area
var enclosed_adopted_area='-';if(appraisals[i].enclosed_adopted_area){enclosed_adopted_area=appraisals[i].enclosed_adopted_area;}else{}// covered_terraces_total_cadastral_area
var covered_terraces_total_cadastral_area='-';if(appraisals[i].covered_terraces_total_cadastral_area){covered_terraces_total_cadastral_area=appraisals[i].covered_terraces_total_cadastral_area;}else{}// covered_terraces_total_checked_area
var covered_terraces_total_checked_area='-';if(appraisals[i].covered_terraces_total_checked_area){covered_terraces_total_checked_area=appraisals[i].covered_terraces_total_checked_area;}else{}// covered_terraces_total_adopted_area
var covered_terraces_total_adopted_area='-';if(appraisals[i].covered_terraces_total_adopted_area){covered_terraces_total_adopted_area=appraisals[i].covered_terraces_total_adopted_area;}else{}// built_checked_area
var built_checked_area='-';if(appraisals[i].built_checked_area){built_checked_area=appraisals[i].built_checked_area;}else{}// built_adopted_area
var built_adopted_area='-';if(appraisals[i].built_adopted_area){built_adopted_area=appraisals[i].built_adopted_area;}else{}// built_plus_common_elements_checked_area
var built_plus_common_elements_checked_area='-';if(appraisals[i].built_plus_common_elements_checked_area){built_plus_common_elements_checked_area=appraisals[i].built_plus_common_elements_checked_area;}else{}// built_plus_common_elements_adopted_area
var built_plus_common_elements_adopted_area='-';if(appraisals[i].built_plus_common_elements_adopted_area){built_plus_common_elements_adopted_area=appraisals[i].built_plus_common_elements_adopted_area;}else{}// adopted_area
var adopted_area='-';if(appraisals[i].adopted_area){adopted_area=appraisals[i].adopted_area;}else{}// realestate_systems_door_opener
var realestate_systems_door_opener='-';if(appraisals[i].realestate_systems_door_opener){if(_this11.currentLocale==='ca'){realestate_systems_door_opener='Sí';}else if(_this11.currentLocale==='en'){realestate_systems_door_opener='Yes';}else{realestate_systems_door_opener='Sí';}}else{if(_this11.currentLocale==='ca'){realestate_systems_door_opener='No';}else if(_this11.currentLocale==='en'){realestate_systems_door_opener='No';}else{realestate_systems_door_opener='No';}}// realestate_systems_fitted_cupboards
var realestate_systems_fitted_cupboards='-';if(appraisals[i].realestate_systems_fitted_cupboards){if(_this11.currentLocale==='ca'){realestate_systems_fitted_cupboards='Sí';}else if(_this11.currentLocale==='en'){realestate_systems_fitted_cupboards='Yes';}else{realestate_systems_fitted_cupboards='Sí';}}else{if(_this11.currentLocale==='ca'){realestate_systems_fitted_cupboards='No';}else if(_this11.currentLocale==='en'){realestate_systems_fitted_cupboards='No';}else{realestate_systems_fitted_cupboards='No';}}// realestate_systems_gas
var realestate_systems_gas='-';if(appraisals[i].realestate_systems_gas){if(_this11.currentLocale==='ca'){realestate_systems_gas='Sí';}else if(_this11.currentLocale==='en'){realestate_systems_gas='Yes';}else{realestate_systems_gas='Sí';}}else{if(_this11.currentLocale==='ca'){realestate_systems_gas='No';}else if(_this11.currentLocale==='en'){realestate_systems_gas='No';}else{realestate_systems_gas='No';}}// realestate_systems_sanitary_fittings
var realestate_systems_sanitary_fittings='-';if(appraisals[i].realestate_systems_sanitary_fittings){if(_this11.currentLocale==='ca'){realestate_systems_sanitary_fittings='Sí';}else if(_this11.currentLocale==='en'){realestate_systems_sanitary_fittings='Yes';}else{realestate_systems_sanitary_fittings='Sí';}}else{if(_this11.currentLocale==='ca'){realestate_systems_sanitary_fittings='No';}else if(_this11.currentLocale==='en'){realestate_systems_sanitary_fittings='No';}else{realestate_systems_sanitary_fittings='No';}}// realestate_systems_taps
var realestate_systems_taps='-';if(appraisals[i].realestate_systems_taps){if(_this11.currentLocale==='ca'){realestate_systems_taps='Sí';}else if(_this11.currentLocale==='en'){realestate_systems_taps='Yes';}else{realestate_systems_taps='Sí';}}else{if(_this11.currentLocale==='ca'){realestate_systems_taps='No';}else if(_this11.currentLocale==='en'){realestate_systems_taps='No';}else{realestate_systems_taps='No';}}// realestate_systems_hot_water
var realestate_systems_hot_water='-';if(appraisals[i].realestate_systems_hot_water){if(_this11.currentLocale==='ca'){realestate_systems_hot_water='Sí';}else if(_this11.currentLocale==='en'){realestate_systems_hot_water='Yes';}else{realestate_systems_hot_water='Sí';}}else{if(_this11.currentLocale==='ca'){realestate_systems_hot_water='No';}else if(_this11.currentLocale==='en'){realestate_systems_hot_water='No';}else{realestate_systems_hot_water='No';}}// realestate_systems_heating
var realestate_systems_heating='-';if(appraisals[i].realestate_systems_heating){if(_this11.currentLocale==='ca'){realestate_systems_heating='Sí';}else if(_this11.currentLocale==='en'){realestate_systems_heating='Yes';}else{realestate_systems_heating='Sí';}}else{if(_this11.currentLocale==='ca'){realestate_systems_heating='No';}else if(_this11.currentLocale==='en'){realestate_systems_heating='No';}else{realestate_systems_heating='No';}}// realestate_systems_air_conditioning
var realestate_systems_air_conditioning='-';if(appraisals[i].realestate_systems_air_conditioning){if(_this11.currentLocale==='ca'){realestate_systems_air_conditioning='Sí';}else if(_this11.currentLocale==='en'){realestate_systems_air_conditioning='Yes';}else{realestate_systems_air_conditioning='Sí';}}else{if(_this11.currentLocale==='ca'){realestate_systems_air_conditioning='No';}else if(_this11.currentLocale==='en'){realestate_systems_air_conditioning='No';}else{realestate_systems_air_conditioning='No';}}// realestate_systems_tv
var realestate_systems_tv='-';if(appraisals[i].realestate_systems_tv){if(_this11.currentLocale==='ca'){realestate_systems_tv='Sí';}else if(_this11.currentLocale==='en'){realestate_systems_tv='Yes';}else{realestate_systems_tv='Sí';}}else{if(_this11.currentLocale==='ca'){realestate_systems_tv='No';}else if(_this11.currentLocale==='en'){realestate_systems_tv='No';}else{realestate_systems_tv='No';}}// realestate_systems_telephone
var realestate_systems_telephone='-';if(appraisals[i].realestate_systems_telephone){if(_this11.currentLocale==='ca'){realestate_systems_telephone='Sí';}else if(_this11.currentLocale==='en'){realestate_systems_telephone='Yes';}else{realestate_systems_telephone='Sí';}}else{if(_this11.currentLocale==='ca'){realestate_systems_telephone='No';}else if(_this11.currentLocale==='en'){realestate_systems_telephone='No';}else{realestate_systems_telephone='No';}}// realestate_systems_fire_prevention
var realestate_systems_fire_prevention='-';if(appraisals[i].realestate_systems_fire_prevention){if(_this11.currentLocale==='ca'){realestate_systems_fire_prevention='Sí';}else if(_this11.currentLocale==='en'){realestate_systems_fire_prevention='Yes';}else{realestate_systems_fire_prevention='Sí';}}else{if(_this11.currentLocale==='ca'){realestate_systems_fire_prevention='No';}else if(_this11.currentLocale==='en'){realestate_systems_fire_prevention='No';}else{realestate_systems_fire_prevention='No';}}// realestate_systems_intrusion_prevention
var realestate_systems_intrusion_prevention='-';if(appraisals[i].realestate_systems_intrusion_prevention){if(_this11.currentLocale==='ca'){realestate_systems_intrusion_prevention='Sí';}else if(_this11.currentLocale==='en'){realestate_systems_intrusion_prevention='Yes';}else{realestate_systems_intrusion_prevention='Sí';}}else{if(_this11.currentLocale==='ca'){realestate_systems_intrusion_prevention='No';}else if(_this11.currentLocale==='en'){realestate_systems_intrusion_prevention='No';}else{realestate_systems_intrusion_prevention='No';}}// protection_type
var protection_type='-';if(appraisals[i].protection_type){if(_this11.currentLocale==='ca'){protection_type=appraisals[i].protection_type.name_ca;}else if(_this11.currentLocale==='en'){protection_type=appraisals[i].protection_type.name_en;}else{protection_type=appraisals[i].protection_type.name_es;}}// protection_regime
var protection_regime='-';if(appraisals[i].protection_regime){if(_this11.currentLocale==='ca'){protection_regime=appraisals[i].protection_regime.name_ca;}else if(_this11.currentLocale==='en'){protection_regime=appraisals[i].protection_regime.name_en;}else{protection_regime=appraisals[i].protection_regime.name_es;}}// protection_zone
var protection_zone='-';if(appraisals[i].protection_zone){if(_this11.currentLocale==='ca'){protection_zone=appraisals[i].protection_zone.name_ca;}else if(_this11.currentLocale==='en'){protection_zone=appraisals[i].protection_zone.name_en;}else{protection_zone=appraisals[i].protection_zone.name_es;}}// max_legal_price
var max_legal_price='-';if(appraisals[i].max_legal_price){max_legal_price=appraisals[i].max_legal_price;}// max_legal_area
var max_legal_area='-';if(appraisals[i].max_legal_area){max_legal_area=appraisals[i].max_legal_area;}// Protection
var is_protected='';var protection_table=[];if(appraisals[i].protection_boolean){any_is_protected=true;protection_table=[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Protection_type'),style:'plain_bold'},{text:protection_type,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Protection_regime'),style:'plain_bold'},{text:protection_regime,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Protection_zone'),style:'plain_bold'},{text:protection_zone,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Maximum_legal_sale_price'),style:'plain_bold'},{text:_this11.numFormat(max_legal_price,'€'),style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Maximum_legal_computable_area'),style:'plain_bold'},{text:_this11.numFormat(max_legal_area,'m²'),style:'plain'}]];}else{if(_this11.currentLocale==='ca'){is_protected='A partir de la documentació aportada no es desprèn que la finca sigui de protecció oficial, pel que considerem que té preu de venda lliure';}else if(_this11.currentLocale==='en'){is_protected='From the documentation provided it does not look like the property is publicly protected, therefore it is considered to have a free market price';}else{is_protected='A partir de la documentación aportada no se desprende que la finca sea de protección oficial, por lo que consideramos que tiene precio de venta libre';}protection_table=[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Protection_type'),style:'plain_bold'},{text:is_protected,style:'plain'}]];}// property_title
var property_title='-';if(appraisals[i].property_title){property_title=appraisals[i].property_title;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir el títol de propietat (ocupació)',style:'plain',alignment:'left'}]);}// occupancy_status
var occupancy_status='-';if(appraisals[i].occupancy_status){if(_this11.currentLocale==='ca'){occupancy_status=appraisals[i].occupancy_status.name_ca;}else if(_this11.currentLocale==='en'){occupancy_status=appraisals[i].occupancy_status.name_en;}else{occupancy_status=appraisals[i].occupancy_status.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir l\'estat d\'ocupació (ocupació)',style:'plain',alignment:'left'}]);}// usage_assigned
var usage_assigned='-';if(appraisals[i].usage_assigned){usage_assigned=appraisals[i].usage_assigned;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir l\'ús assignat per la propietat (ocupació)',style:'plain',alignment:'left'}]);}// inspection_realized
var inspection_realized='-';if(appraisals[i].inspection_realized){inspection_realized=appraisals[i].inspection_realized;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la inspecció realitzada (ocupació)',style:'plain',alignment:'left'}]);}// economical_activity
var economical_activity='-';if(appraisals[i].economical_activity){economical_activity=appraisals[i].economical_activity;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir l\'activitat econòmica (ocupació)',style:'plain',alignment:'left'}]);}// cession_contract_start_date
var cession_contract_start_date='-';if(appraisals[i].cession_contract_start_date){cession_contract_start_date=__WEBPACK_IMPORTED_MODULE_3_moment___default()(appraisals[i].cession_contract_start_date).format('DD/MM/YYYY');}else{if(appraisals[i].cession_boolean){appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la data d\'inici de contracte (cessió)',style:'plain',alignment:'left'}]);}}// cession_contract_period_years
var cession_contract_period_years='-';if(appraisals[i].cession_contract_period_years){cession_contract_period_years=appraisals[i].cession_contract_period_years+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('years');}else{if(appraisals[i].cession_boolean){appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la data d\'inici de contracte (cessió)',style:'plain',alignment:'left'}]);}}// cession_contract_remaining_years
var cession_contract_remaining_years='-';if(appraisals[i].cession_contract_remaining_years){cession_contract_remaining_years=_this11.numFormat(appraisals[i].cession_contract_remaining_years,__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('years'));}else{if(appraisals[i].cession_boolean){appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir els anys restants de contracte (cessió)',style:'plain',alignment:'left'}]);}}// realestates_remaining_useful_life
var realestates_remaining_useful_life='-';if(appraisals[i].remaining_useful_life_years){realestates_remaining_useful_life=appraisals[i].remaining_useful_life_years+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('years');}else{if(appraisals[i].cession_boolean){appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir els anys restants de vida útil de l\'immoble',style:'plain',alignment:'left'}]);}}// tenant_remaining_life_expectancy_years
var tenant_remaining_life_expectancy_years='-';if(appraisals[i].tenant_remaining_life_expectancy_years){tenant_remaining_life_expectancy_years=appraisals[i].tenant_remaining_life_expectancy_years+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('years');}else{if(appraisals[i].cession_boolean){appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir els anys restants esperança vida del llogater (cessió)',style:'plain',alignment:'left'}]);}}// cession_gross_yearly_income
var cession_gross_yearly_income='-';if(appraisals[i].cession_gross_yearly_income){cession_gross_yearly_income=_this11.numFormat(appraisals[i].cession_gross_yearly_income,'€/'+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('year'));}else{if(appraisals[i].cession_boolean){appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la renda anual bruta (cessió)',style:'plain',alignment:'left'}]);}}// contracts_foreseeable_remaining_period
var contracts_foreseeable_remaining_period='-';if(appraisals[i].u){contracts_foreseeable_remaining_period=_this11.numFormat(appraisals[i].u,__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('years'));}else{if(appraisals[i].cession_boolean){appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir els anys restants de contracte (cessió)',style:'plain',alignment:'left'}]);}}// eco?
if(appraisals[i].purpose.code_bde&&appraisals[i].purpose.code_bde!=='O'){any_is_eco=true;}// Construction status
if(appraisals[i].total_construction_progress_pct<100){any_is_under_construction=true;}// Cession
var is_ceded='';var cession_table=[];if(appraisals[i].cession_boolean){any_is_ceded=true;cession_table=[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cession_contract_start_date'),style:'plain_bold'},{text:cession_contract_start_date,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cession_contract_period_years'),style:'plain_bold'},{text:cession_contract_period_years,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cession_contract_remaining_years'),style:'plain_bold'},{text:cession_contract_remaining_years,style:'plain'}],/*
                                                                    [
                                                                        {
                                                                            text: Vue.i18n.translate('Cession_gross_monthly_income'),
                                                                            style: 'plain_bold'
                                                                        },
                                                                        {
                                                                            text: cession_gross_monthly_income,
                                                                            style: 'plain'
                                                                        }
                                                                    ],
                                                                    */[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cession_gross_yearly_income'),style:'plain_bold'},{text:_this11.numFormat(cession_gross_yearly_income,'€/'+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('year')),style:'plain'}]];}else{if(_this11.currentLocale==='ca'){is_ceded='A partir de la documentació aportada no es desprèn que la finca sigui estigui llogada';}else if(_this11.currentLocale==='en'){is_ceded='From the documentation provided it does not look like the property is rented';}else{is_ceded='A partir de la documentación aportada no se desprende que la finca esté alquilada';}cession_table=[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cession_type'),style:'plain_bold'},{text:is_ceded,style:'plain'}]];}// usufructuary_age_years
var usufructuary_age_years='-';if(appraisals[i].usufructuary_age_years){usufructuary_age_years=appraisals[i].usufructuary_age_years;}else{if(appraisals[i].right_of_use_boolean){appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir l\'edat de l\'usufructuari (dret d\'ús)',style:'plain',alignment:'left'}]);}}// Real rights
var is_the_right_of_use_ceded='';var right_of_use_table=[];if(appraisals[i].right_of_use_boolean){any_has_right_of_use_ceded=true;if(_this11.currentLocale==='ca'){is_the_right_of_use_ceded='A partir de la documentació aportada es desprèn que el dret real d\'ús o usufructe de l\'immoble està cedit';}else if(_this11.currentLocale==='en'){is_the_right_of_use_ceded='From the documentation provided it can be stated that the real right of use or usufruct of the property is ceded';}else{is_the_right_of_use_ceded='A partir de la documentación aportada se desprende que el derecho real de uso o usufructo del inmueble está cedido';}right_of_use_table=[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_right_type'),style:'plain_bold'},{text:is_the_right_of_use_ceded,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Usufructuary_age_years'),style:'plain_bold'},{text:usufructuary_age_years+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('years'),style:'plain'}]];}else{if(_this11.currentLocale==='ca'){is_the_right_of_use_ceded='A partir de la documentació aportada no es desprèn que el dret real d\'ús o usufructe de l\'immoble estigui cedit';}else if(_this11.currentLocale==='en'){is_the_right_of_use_ceded='From the documentation provided it does not look like the property real right of use or usufruct is ceded';}else{is_the_right_of_use_ceded='A partir de la documentación aportada no se desprende que el derecho real de uso o usufructo del inmeuble esté cedido';}right_of_use_table=[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Is_the_right_of_use_ceded_q'),style:'plain_bold'},{text:is_the_right_of_use_ceded,style:'plain'}]];}// bec_property_type
var bec_property_type='-';if(appraisals[i].bec_property_type){if(_this11.currentLocale==='ca'){bec_property_type=appraisals[i].bec_property_type.name_ca;}else if(_this11.currentLocale==='en'){bec_property_type=appraisals[i].bec_property_type.name_en;}else{bec_property_type=appraisals[i].bec_property_type.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir el tipus d\'immoble del B.E.C. (Cost de construcció)',style:'plain',alignment:'left'}]);}// bec_number
var bec_number='-';if(appraisals[i].bec_number){bec_number=appraisals[i].bec_number.number;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir el nº del butlletí del B.E.C. (Cost de construcció)',style:'plain',alignment:'left'}]);}// bec_year
var bec_year='-';if(appraisals[i].bec_number){bec_year=appraisals[i].bec_number.year;}// bec_quarter
var bec_quarter='-';if(appraisals[i].bec_number){bec_quarter=appraisals[i].bec_number.quarter;}// adjusted_bec_price
var adjusted_bec_price='-';if(appraisals[i].bec_number){adjusted_bec_price=appraisals[i].adjusted_bec_price;}// expenses_and_industrial_benefit_bec_pct
var expenses_and_industrial_benefit_bec_pct='-';if(appraisals[i].bec_number){expenses_and_industrial_benefit_bec_pct=appraisals[i].expenses_and_industrial_benefit_bec_pct;}// adopted_material_execution_cost
var adopted_material_execution_cost='-';if(appraisals[i].adopted_material_execution_cost){adopted_material_execution_cost=appraisals[i].adopted_material_execution_cost;}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir el cost d\'execució material adoptat',style:'plain',alignment:'left'}]);}// construction_cost_notes
var construction_cost_notes='-';if(appraisals[i].construction_cost_notes){construction_cost_notes=appraisals[i].construction_cost_notes;}// construction_status
var construction_status='-';if(appraisals[i].construction_status){if(_this11.currentLocale==='ca'){construction_status=appraisals[i].construction_status.name_ca;}else if(_this11.currentLocale==='en'){construction_status=appraisals[i].construction_status.name_en;}else{construction_status=appraisals[i].construction_status.name_es;}}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir l\'estat de construcció',style:'plain',alignment:'left'}]);}// total_construction_progress_pct
var total_construction_progress_pct='-';if(appraisals[i].total_construction_progress_pct){total_construction_progress_pct=_this11.numFormat(appraisals[i].total_construction_progress_pct,'%');}else{appraisal_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir el percentatge d\'obres realitzades',style:'plain',alignment:'left'}]);}// univ_sample_n
var univ_sample_n='-';if(marketstudies[i].universal_sample_typical_deviation['0'].n){univ_sample_n=marketstudies[i].universal_sample_typical_deviation['0'].n;}// repr_sample_n
var repr_sample_n='-';if(marketstudies[i].representative_sample_typical_deviation['0'].n){repr_sample_n=marketstudies[i].representative_sample_typical_deviation['0'].n;}// univ_sample_summation_Vu2_n
var univ_sample_summation_Vu2_n='-';if(marketstudies[i].universal_sample_typical_deviation['0'].summation_Vu2_n){univ_sample_summation_Vu2_n=_this11.numFormat(marketstudies[i].universal_sample_typical_deviation['0'].summation_Vu2_n,'');}// repr_sample_summation_Vu2_n
var repr_sample_summation_Vu2_n='-';if(marketstudies[i].representative_sample_typical_deviation['0'].summation_Vu2_n){repr_sample_summation_Vu2_n=_this11.numFormat(marketstudies[i].representative_sample_typical_deviation['0'].summation_Vu2_n,'');}// univ_sample_summation_Vu_n_2
var univ_sample_summation_Vu_n_2='-';if(marketstudies[i].universal_sample_typical_deviation['0'].summation_Vu_n_2){univ_sample_summation_Vu_n_2=_this11.numFormat(marketstudies[i].universal_sample_typical_deviation['0'].summation_Vu_n_2,'');}// repr_sample_summation_Vu_n_2
var repr_sample_summation_Vu_n_2='-';if(marketstudies[i].representative_sample_typical_deviation['0'].summation_Vu_n_2){repr_sample_summation_Vu_n_2=_this11.numFormat(marketstudies[i].representative_sample_typical_deviation['0'].summation_Vu_n_2,'');}// univ_sample_g2
var univ_sample_g2='-';if(marketstudies[i].universal_sample_typical_deviation['0'].g2){univ_sample_g2=_this11.numFormat(marketstudies[i].universal_sample_typical_deviation['0'].g2,'(€/m²)²');}// repr_sample_g2
var repr_sample_g2='-';if(marketstudies[i].representative_sample_typical_deviation['0'].g2){repr_sample_g2=_this11.numFormat(marketstudies[i].representative_sample_typical_deviation['0'].g2,'(€/m²)²');}// univ_sample_g
var univ_sample_g='-';if(marketstudies[i].universal_sample_typical_deviation['0'].g){univ_sample_g=_this11.numFormat(marketstudies[i].universal_sample_typical_deviation['0'].g,'€/m²');}// repr_sample_g
var repr_sample_g='-';if(marketstudies[i].representative_sample_typical_deviation['0'].g){repr_sample_g=_this11.numFormat(marketstudies[i].representative_sample_typical_deviation['0'].g,'€/m²');}// univ_sample_t
var univ_sample_t='-';if(marketstudies[i].universal_sample_typical_deviation['0'].t){univ_sample_t=_this11.numFormat(marketstudies[i].universal_sample_typical_deviation['0'].t,'');}// repr_sample_t
var repr_sample_t='-';if(marketstudies[i].representative_sample_typical_deviation['0'].t){repr_sample_t=_this11.numFormat(marketstudies[i].representative_sample_typical_deviation['0'].t,'');}// univ_sample_s
var univ_sample_s='-';if(marketstudies[i].universal_sample_typical_deviation['0'].s){univ_sample_s=_this11.numFormat(marketstudies[i].universal_sample_typical_deviation['0'].s,'');}// repr_sample_s
var repr_sample_s='-';if(marketstudies[i].representative_sample_typical_deviation['0'].s){repr_sample_s=_this11.numFormat(marketstudies[i].representative_sample_typical_deviation['0'].s,'');}// univ_sample_s2
var univ_sample_s2='-';if(marketstudies[i].universal_sample_typical_deviation['0'].s2){univ_sample_s2=_this11.numFormat(marketstudies[i].universal_sample_typical_deviation['0'].s2,'');}// repr_sample_s2
var repr_sample_s2='-';if(marketstudies[i].representative_sample_typical_deviation['0'].s2){repr_sample_s2=_this11.numFormat(marketstudies[i].representative_sample_typical_deviation['0'].s2,'');}// univ_sample_r
var univ_sample_r='-';if(marketstudies[i].universal_sample_typical_deviation['0'].r){univ_sample_r=_this11.numFormat(marketstudies[i].universal_sample_typical_deviation['0'].r,'');}// repr_sample_r
var repr_sample_r='-';if(marketstudies[i].representative_sample_typical_deviation['0'].r){repr_sample_r=_this11.numFormat(marketstudies[i].representative_sample_typical_deviation['0'].r,'');}// univ_sample_m
var univ_sample_m='-';if(marketstudies[i].universal_sample_typical_deviation['0'].m){univ_sample_m=_this11.numFormat(marketstudies[i].universal_sample_typical_deviation['0'].m,'');}// repr_sample_m
var repr_sample_m='-';if(marketstudies[i].representative_sample_typical_deviation['0'].m){repr_sample_m=_this11.numFormat(marketstudies[i].representative_sample_typical_deviation['0'].m,'');}// univ_sample_na
var univ_sample_na='-';if(marketstudies[i].universal_sample_typical_deviation['0'].na){univ_sample_na=_this11.numFormat(marketstudies[i].universal_sample_typical_deviation['0'].na,'');}// repr_sample_na
var repr_sample_na='-';if(marketstudies[i].representative_sample_typical_deviation['0'].na){repr_sample_na=_this11.numFormat(marketstudies[i].representative_sample_typical_deviation['0'].na,'');}// univ_sample_t_ms
var univ_sample_t_ms='-';if(marketstudies[i].universal_sample_typical_deviation['0'].t_ms){univ_sample_t_ms=_this11.numFormat(marketstudies[i].universal_sample_typical_deviation['0'].t_ms,'');}// repr_sample_t_ms
var repr_sample_t_ms='-';if(marketstudies[i].representative_sample_typical_deviation['0'].t_ms){repr_sample_t_ms=_this11.numFormat(marketstudies[i].representative_sample_typical_deviation['0'].t_ms,'');}// univ_sample_s2_nas
var univ_sample_s2_nas='-';if(marketstudies[i].universal_sample_typical_deviation['0'].s2_nas){univ_sample_s2_nas=_this11.numFormat(marketstudies[i].universal_sample_typical_deviation['0'].s2_nas,'');}// repr_sample_s2_nas
var repr_sample_s2_nas='-';if(marketstudies[i].representative_sample_typical_deviation['0'].s2_nas){repr_sample_s2_nas=_this11.numFormat(marketstudies[i].representative_sample_typical_deviation['0'].s2_nas,'');}// univ_sample_a
var univ_sample_a='-';if(marketstudies[i].universal_sample_typical_deviation['0'].a){univ_sample_a=_this11.numFormat(marketstudies[i].universal_sample_typical_deviation['0'].a,'');}// repr_sample_a
var repr_sample_a='-';if(marketstudies[i].representative_sample_typical_deviation['0'].a){repr_sample_a=_this11.numFormat(marketstudies[i].representative_sample_typical_deviation['0'].a,'');}// univ_sample_b
var univ_sample_b='-';if(marketstudies[i].universal_sample_typical_deviation['0'].b){univ_sample_b=_this11.numFormat(marketstudies[i].universal_sample_typical_deviation['0'].b,'');}// repr_sample_b
var repr_sample_b='-';if(marketstudies[i].representative_sample_typical_deviation['0'].b){repr_sample_b=_this11.numFormat(marketstudies[i].representative_sample_typical_deviation['0'].b,'');}var comparables_table=[];var datatabulation_table=[];var datatabulation_appraised_table=[];var qualities_comparison_table=[];var homogenisation_table=[];var values_correction_table=[];var regression_calc_table=[];var deviations_table=[];datatabulation_table.push([{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Date'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Neighbourhood'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Situation'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Construction'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Adopted_age'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Conservation_status'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Floor_number'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Built_area'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Lift'),style:'small_bold'}]);datatabulation_appraised_table.push([{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Date'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Neighbourhood'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Situation'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Construction'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Adopted_age'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Conservation_status'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Floor_number'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Built_area'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Lift'),style:'small_bold'}],[{text:'T',style:'small'},{text:appraisaldate,style:'small'},{text:property_type,style:'small'},{text:quality_of_neighbourhood,style:'small'},{text:quality_of_situation,style:'small'},{text:quality_of_construction,style:'small'},{text:quality_of_realestate,style:'small'},{text:adopted_age,style:'small'},{text:conservation_status,style:'small'},{text:floor_number,style:'small'},{text:adopted_area,style:'small'},{text:lift,style:'small'}]);qualities_comparison_table.push([{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Neighbourhood'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Situation'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Construction'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Adopted_age'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Conservation_status'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Floor_number'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Built_area'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Lift'),style:'small_bold'/*,
																					{
                                                                                        text: Vue.i18n.translate('Similarities'),
                                                                                        style: 'small_bold'
                                                                                    }
                                                                                    */}]);homogenisation_table.push([{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Neighbourhood'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Situation'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Construction'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Adopted_age'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Conservation_status'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Floor_number'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Built_area'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Lift'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Total'),style:'small_bold'}]);values_correction_table.push([{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Initial_unit_price'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Correction'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Final_unit_price'),style:'small_bold'}]);regression_calc_table.push([{text:'',style:'small_bold'},{text:'Xi',style:'small_bold'},{text:'Vi',style:'small_bold'},{text:'Vu',style:'small_bold'},{text:'Vu²',style:'small_bold'},{text:'Xi·Vi',style:'small_bold'},{text:'Xi²',style:'small_bold'},{text:'Vi²',style:'small_bold'}]);deviations_table.push([{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Universal_sample'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Representative_sample'),style:'small_bold'}],[{text:'n',style:'small_bold'},{text:univ_sample_n,style:'small'},{text:repr_sample_n,style:'small'}],[{text:'e = ∑ ((Vu)² / n)',style:'small_bold'},{text:univ_sample_summation_Vu2_n,style:'small'},{text:repr_sample_summation_Vu2_n,style:'small'}],[{text:'f = (∑ (Vᵤ / n))²',style:'small_bold'},{text:univ_sample_summation_Vu_n_2,style:'small'},{text:repr_sample_summation_Vu_n_2,style:'small'}],[{text:'Dt ('+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Typical_deviation_of_the_sample')+'= e-f)',style:'small_bold'},{text:univ_sample_g2,style:'small'},{text:repr_sample_g2,style:'small'}],[{text:'De ('+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Standard_deviation_of_the_sample')+' = √ Dt)',style:'small_bold'},{text:univ_sample_g,style:'small'},{text:repr_sample_g,style:'small'}],[{text:'T',style:'small_bold'},{text:univ_sample_t,style:'small'},{text:repr_sample_t,style:'small'}],[{text:'S',style:'small_bold'},{text:univ_sample_s,style:'small'},{text:repr_sample_s,style:'small'}],[{text:'S²',style:'small_bold'},{text:univ_sample_s2,style:'small'},{text:repr_sample_s2,style:'small'}],[{text:'R',style:'small_bold'},{text:univ_sample_r,style:'small'},{text:repr_sample_r,style:'small'}],[{text:'m',style:'small_bold'},{text:univ_sample_m,style:'small'},{text:repr_sample_m,style:'small'}],[{text:'n·a',style:'small_bold'},{text:univ_sample_na,style:'small'},{text:repr_sample_na,style:'small'}],[{text:'T - m·S',style:'small_bold'},{text:univ_sample_t_ms,style:'small'},{text:repr_sample_t_ms,style:'small'}],[{text:'S² - n·a·S',style:'small_bold'},{text:univ_sample_s2_nas,style:'small'},{text:repr_sample_s2_nas,style:'small'}],[{text:'a',style:'small_bold'},{text:univ_sample_a,style:'small'},{text:repr_sample_a,style:'small'}],[{text:'b',style:'small_bold'},{text:univ_sample_b,style:'small'},{text:repr_sample_b,style:'small'}]);var comparable_counter=0;__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(comparables[i],function(value,key){comparable_counter=comparable_counter+1;var comparable_table={layout:'lightHorizontalLines',margin:[0,4],table:{headerRows:1,widths:[80,100,80,220],body:[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Sample')+' nº '+comparable_counter.toString(),style:'small_bold'},{text:'',style:'small'},{text:'',style:'small_bold'},{text:'',style:'small'}]]}// comparable_property_type
};var comparable_property_type='-';if(value.property_type){if(tempCurrentLocale==='ca'){comparable_property_type=value.property_type.name_ca;}else if(tempCurrentLocale==='en'){comparable_property_type=value.property_type.name_en;}else{comparable_property_type=value.property_type.name_es;}}else{comparable_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString()+', '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Comparable')+' nº '+comparable_counter.toString(),style:'small_bold'},{text:'Manca introduir el tipus de propietat del comparable',style:'small',alignment:'left'}]);}// comparable_google_formatted_address
var comparable_google_formatted_address='-';if(value.google_formatted_address){comparable_google_formatted_address=value.google_formatted_address;}else{comparable_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString()+', '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Comparable')+' nº '+comparable_counter.toString(),style:'small_bold'},{text:'Manca l\'adreça formatejada del comparable',style:'small',alignment:'left'}]);}// comparable_municipality
var comparable_municipality='-';if(value.municipality){comparable_municipality=value.municipality.name_ine;}else{comparable_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString()+', '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Comparable')+' nº '+comparable_counter.toString(),style:'small_bold'},{text:'Manca el municipi del comparable',style:'small',alignment:'left'}]);}// comparable_ad_date
var comparable_ad_date='-';if(value.ad_date){comparable_ad_date=__WEBPACK_IMPORTED_MODULE_3_moment___default()(value.ad_date).format('DD/MM/YYYY');}else{comparable_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString()+', '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Comparable')+' nº '+comparable_counter.toString(),style:'small_bold'},{text:'Manca la data de l\'anunci del comparable',style:'small',alignment:'left'}]);}// comparable_postal_code
var comparable_postal_code='-';if(value.postal_code){comparable_postal_code=value.postal_code;}else{comparable_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString()+', '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Comparable')+' nº '+comparable_counter.toString(),style:'small_bold'},{text:'Manca el codi postal del comparable',style:'small',alignment:'left'}]);}// comparable_adopted_area
var comparable_adopted_area='-';if(value.adopted_area){comparable_adopted_area=tempNumFormat(value.adopted_area,'m²');}else{comparable_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString()+', '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Comparable')+' nº '+comparable_counter.toString(),style:'small_bold'},{text:'Manca la superfície construïda del comparable',style:'small',alignment:'left'}]);}// comparable_construction_year
var comparable_construction_year='-';if(value.construction_year){comparable_construction_year=value.construction_year;}else{comparable_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString()+', '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Comparable')+' nº '+comparable_counter.toString(),style:'small_bold'},{text:'Manca l\'any de construcció del comparable',style:'small',alignment:'left'}]);}// comparable_conservation_status
var comparable_conservation_status='-';if(value.conservation_status){if(tempCurrentLocale==='ca'){comparable_conservation_status=value.conservation_status.name_ca;}else if(tempCurrentLocale==='en'){comparable_conservation_status=value.conservation_status.name_en;}else{comparable_conservation_status=value.conservation_status.name_es;}}else{comparable_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString()+', '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Comparable')+' nº '+comparable_counter.toString(),style:'small_bold'},{text:'Manca introduir l\'estat de conservació del comparable',style:'small',alignment:'left'}]);}// comparable_bedrooms_number
var comparable_bedrooms_number='-';if(value.bedrooms_number){comparable_bedrooms_number=value.bedrooms_number;}else{comparable_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString()+', '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Comparable')+' nº '+comparable_counter.toString(),style:'small_bold'},{text:'Manca el nº de dormitoris del comparable',style:'small',alignment:'left'}]);}// comparable_bathrooms_number
var comparable_bathrooms_number='-';if(value.bathrooms_number){comparable_bathrooms_number=value.bathrooms_number;}else{comparable_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString()+', '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Comparable')+' nº '+comparable_counter.toString(),style:'small_bold'},{text:'Manca el nº de banys del comparable',style:'small',alignment:'left'}]);}// comparable_offer_price
var comparable_offer_price='-';if(value.offer_price){comparable_offer_price=tempNumFormat(value.offer_price,'€');}else{comparable_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString()+', '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Comparable')+' nº '+comparable_counter.toString(),style:'small_bold'},{text:'Manca el preu d\'oferta de l\'anunci del comparable',style:'small',alignment:'left'}]);}// comparable_estimated_sale_price
var comparable_estimated_sale_price='-';if(value.estimated_sale_price){comparable_estimated_sale_price=tempNumFormat(value.estimated_sale_price,'€');}else{comparable_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString()+', '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Comparable')+' nº '+comparable_counter.toString(),style:'small_bold'},{text:'Manca el preu de venta estimat del comparable',style:'small',alignment:'left'}]);}// comparable_lift
var comparable_lift='-';if(value.lift){if(tempCurrentLocale==='ca'){comparable_lift='Sí';}else if(tempCurrentLocale==='en'){comparable_lift='Yes';}else{comparable_lift='Sí';}}else{if(tempCurrentLocale==='ca'){comparable_lift='No';}else if(tempCurrentLocale==='en'){comparable_lift='No';}else{comparable_lift='No';}}// comparable_census_section_code
var comparable_census_section_code='-';if(value.census_section_code){comparable_census_section_code=value.census_section_code;}else{comparable_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString()+', '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Comparable')+' nº '+comparable_counter.toString(),style:'small_bold'},{text:'Manca el codi de secció censal del comparable',style:'small',alignment:'left'}]);}// comparable_source
var comparable_source='-';if(value.source){comparable_source=value.source;}else{comparable_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString()+', '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Comparable')+' nº '+comparable_counter.toString(),style:'small_bold'},{text:'Manca la font de l\'anunci del comparable',style:'small',alignment:'left'}]);}// comparable_contact_telephone
var comparable_contact_telephone='-';if(value.contact_telephone){comparable_contact_telephone=value.contact_telephone;}else{comparable_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString()+', '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Comparable')+' nº '+comparable_counter.toString(),style:'small_bold'},{text:'Manca el telèfon de contacte del comparable',style:'small',alignment:'left'}]);}// comparable_notes_1
var comparable_notes_1='-';if(value.notes_1){comparable_notes_1=value.notes_1;}else{}// comparable_quality_of_neighbourhood
var comparable_quality_of_neighbourhood='-';if(value.quality_of_neighbourhood){if(tempCurrentLocale==='ca'){comparable_quality_of_neighbourhood=value.quality_of_neighbourhood.name_ca;}else if(tempCurrentLocale==='en'){comparable_quality_of_neighbourhood=value.quality_of_neighbourhood.name_en;}else{comparable_quality_of_neighbourhood=value.quality_of_neighbourhood.name_es;}}else{comparable_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString()+', '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Comparable')+' nº '+comparable_counter.toString(),style:'small_bold'},{text:'Manca introduir la qualitat del barri',style:'small',alignment:'left'}]);}// comparable_quality_of_situation
var comparable_quality_of_situation='-';if(value.quality_of_situation){if(tempCurrentLocale==='ca'){comparable_quality_of_situation=value.quality_of_situation.name_ca;}else if(tempCurrentLocale==='en'){comparable_quality_of_situation=value.quality_of_situation.name_en;}else{comparable_quality_of_situation=value.quality_of_situation.name_es;}}else{comparable_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString()+', '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Comparable')+' nº '+comparable_counter.toString(),style:'small_bold'},{text:'Manca introduir la qualitat de la situació',style:'small',alignment:'left'}]);}// comparable_quality_of_construction
var comparable_quality_of_construction='-';if(value.quality_of_construction){if(tempCurrentLocale==='ca'){comparable_quality_of_construction=value.quality_of_construction.name_ca;}else if(tempCurrentLocale==='en'){comparable_quality_of_construction=value.quality_of_construction.name_en;}else{comparable_quality_of_construction=value.quality_of_construction.name_es;}}else{comparable_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString()+', '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Comparable')+' nº '+comparable_counter.toString(),style:'small_bold'},{text:'Manca introduir la qualitat de la construcció',style:'small',alignment:'left'}]);}// comparable_quality_of_realestate
var comparable_quality_of_realestate='-';if(value.quality_of_realestate){if(tempCurrentLocale==='ca'){comparable_quality_of_realestate=value.quality_of_realestate.name_ca;}else if(tempCurrentLocale==='en'){comparable_quality_of_realestate=value.quality_of_realestate.name_en;}else{comparable_quality_of_realestate=value.quality_of_realestate.name_es;}}else{comparable_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString()+', '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Comparable')+' nº '+comparable_counter.toString(),style:'small_bold'},{text:'Manca introduir la qualitat de l\'immoble',style:'small',alignment:'left'}]);}// comparable_adopted_age
var comparable_adopted_age='-';if(value.adopted_age){comparable_adopted_age=value.adopted_age;}else{comparable_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString()+', '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Comparable')+' nº '+comparable_counter.toString(),style:'small_bold'},{text:'Manca introduir l\'antiguetat adoptada',style:'small',alignment:'left'}]);}// comparable_floor_number
var comparable_floor_number='-';if(value.floor_number){comparable_floor_number=value.floor_number;}else{comparable_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString()+', '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Comparable')+' nº '+comparable_counter.toString(),style:'small_bold'},{text:'Manca introduir el nº de planta',style:'small',alignment:'left'}]);}// TODO: falta comprovar que no faltin altres variables dels comparables que apareixen a les fitxes del BdE, com la ref cadastral
// comparable_comp_ad_date
var comparable_comp_ad_date='-';if(value.comp_ad_date==='S'){comparable_comp_ad_date=value.comp_ad_date;}else{comparable_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString()+', '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Comparable')+' nº '+comparable_counter.toString(),style:'small_bold'},{text:'Manca la data del comparable o està fora de plaç!',style:'small',alignment:'left'}]);}// comparable_comp_property_type
var comparable_comp_property_type='-';if(value.comp_property_type){comparable_comp_property_type=value.comp_property_type;}// comparable_comp_quality_of_neighbourhood
var comparable_comp_quality_of_neighbourhood='-';if(value.comp_quality_of_neighbourhood){comparable_comp_quality_of_neighbourhood=value.comp_quality_of_neighbourhood;}// comparable_comp_quality_of_situation
var comparable_comp_quality_of_situation='-';if(value.comp_quality_of_situation){comparable_comp_quality_of_situation=value.comp_quality_of_situation;}// comparable_comp_quality_of_construction
var comparable_comp_quality_of_construction='-';if(value.comp_quality_of_construction){comparable_comp_quality_of_construction=value.comp_quality_of_construction;}// comparable_comp_quality_of_realestate
var comparable_comp_quality_of_realestate='-';if(value.comp_quality_of_realestate){comparable_comp_quality_of_realestate=value.comp_quality_of_realestate;}// comparable_comp_adopted_age
var comparable_comp_adopted_age='-';if(value.comp_adopted_age){comparable_comp_adopted_age=value.comp_adopted_age;}// comparable_comp_conservation_status
var comparable_comp_conservation_status='-';if(value.comp_conservation_status){comparable_comp_conservation_status=value.comp_conservation_status;}// comparable_comp_floor_number
var comparable_comp_floor_number='-';if(value.comp_floor_number){comparable_comp_floor_number=value.comp_floor_number;}// comparable_comp_adopted_area
var comparable_comp_adopted_area='-';if(value.comp_adopted_area){comparable_comp_adopted_area=value.comp_adopted_area;}// comparable_comp_lift
var comparable_comp_lift='-';if(value.comp_lift){comparable_comp_lift=value.comp_lift;}// comparable_homg_property_type
var comparable_homg_property_type='-';if(value.homg_property_type){var symbol='';if(value.homg_property_type>0){symbol='+';}comparable_homg_property_type=symbol+value.homg_property_type+' %';}// comparable_homg_quality_of_neighbourhood
var comparable_homg_quality_of_neighbourhood='-';if(value.homg_quality_of_neighbourhood){var _symbol='';if(value.homg_quality_of_neighbourhood>0){_symbol='+';}comparable_homg_quality_of_neighbourhood=_symbol+value.homg_quality_of_neighbourhood+' %';}// comparable_homg_quality_of_situation
var comparable_homg_quality_of_situation='-';if(value.homg_quality_of_situation){var _symbol2='';if(value.homg_quality_of_situation>0){_symbol2='+';}comparable_homg_quality_of_situation=_symbol2+value.homg_quality_of_situation+' %';}// comparable_homg_quality_of_construction
var comparable_homg_quality_of_construction='-';if(value.homg_quality_of_construction){var _symbol3='';if(value.quality_of_construction>0){_symbol3='+';}comparable_homg_quality_of_construction=_symbol3+value.homg_quality_of_construction+' %';}// comparable_homg_quality_of_realestate
var comparable_homg_quality_of_realestate='-';if(value.homg_quality_of_realestate){var _symbol4='';if(value.homg_quality_of_realestate>0){_symbol4='+';}comparable_homg_quality_of_realestate=_symbol4+value.homg_quality_of_realestate+' %';}// comparable_homg_adopted_age
var comparable_homg_adopted_age='-';if(value.homg_adopted_age){var _symbol5='';if(value.homg_adopted_age>0){_symbol5='+';}comparable_homg_adopted_age=_symbol5+value.homg_adopted_age+' %';}// comparable_homg_conservation_status
var comparable_homg_conservation_status='-';if(value.homg_conservation_status){var _symbol6='';if(value.homg_conservation_status>0){_symbol6='+';}comparable_homg_conservation_status=_symbol6+value.homg_conservation_status+' %';}// comparable_homg_floor_number
var comparable_homg_floor_number='-';if(value.homg_floor_number){var _symbol7='';if(value.homg_floor_number>0){_symbol7='+';}comparable_homg_floor_number=_symbol7+value.homg_floor_number+' %';}// comparable_homg_adopted_area
var comparable_homg_adopted_area='-';if(value.homg_adopted_area){var _symbol8='';if(value.homg_adopted_area>0){_symbol8='+';}comparable_homg_adopted_area=_symbol8+value.homg_adopted_area+' %';}// comparable_homg_lift
var comparable_homg_lift='-';if(value.homg_lift){var _symbol9='';if(value.homg_lift>0){_symbol9='+';}comparable_homg_lift=_symbol9+value.homg_lift+' %';}// comparable_homg_total
var comparable_homg_total='-';if(value.homg_total){var _symbol10='';if(value.homg_total>0){_symbol10='+';}comparable_homg_total=_symbol10+value.homg_total+' %';}// comparable_calc_initial_unit_price
var comparable_calc_initial_unit_price='-';if(value.calc_initial_unit_price){comparable_calc_initial_unit_price=tempNumFormat(value.calc_initial_unit_price,'€/m²');}// comparable_calc_correction_pct
var comparable_calc_correction_pct='-';if(value.calc_correction_pct){var _symbol11='';if(value.calc_correction_pct>0){_symbol11='+';}comparable_calc_correction_pct=_symbol11+value.calc_correction_pct+' %';}// comparable_calc_final_unit_price
var comparable_calc_final_unit_price='-';if(value.calc_final_unit_price){comparable_calc_final_unit_price=tempNumFormat(value.calc_final_unit_price,'€/m²');}// comparable_calc_Xi
var comparable_calc_Xi='-';if(value.calc_Xi){comparable_calc_Xi=tempNumFormat(value.calc_Xi,'m²');}// comparable_calc_Vi
var comparable_calc_Vi='-';if(value.calc_Vi){comparable_calc_Vi=tempNumFormat(value.calc_Vi,'€');}// comparable_calc_Vu
var comparable_calc_Vu='-';if(value.calc_Vu){comparable_calc_Vu=tempNumFormat(value.calc_Vu,'€/m²');}// comparable_calc_Vu2
var comparable_calc_Vu2='-';if(value.calc_Vu2){comparable_calc_Vu2=tempNumFormat(value.calc_Vu2,'');}// comparable_calc_XiVi
var comparable_calc_XiVi='-';if(value.calc_XiVi){comparable_calc_XiVi=tempNumFormat(value.calc_XiVi,'');}// comparable_calc_Xi2
var comparable_calc_Xi2='-';if(value.calc_Xi2){comparable_calc_Xi2=tempNumFormat(value.calc_Xi2,'');}// comparable_calc_Vi2
var comparable_calc_Vi2='-';if(value.calc_Vi2){comparable_calc_Vi2=tempNumFormat(value.calc_Vi2,'');}comparable_table.table.body.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Typology'),style:'small_bold'},{text:comparable_property_type,style:'small'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Address'),style:'small_bold'},{text:comparable_google_formatted_address,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Municipality'),style:'small_bold'},{text:comparable_municipality,style:'small'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Offer_date'),style:'small_bold'},{text:comparable_ad_date,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Postal_code'),style:'small_bold'},{text:comparable_postal_code,style:'small'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Area'),style:'small_bold'},{text:comparable_adopted_area,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Construction_year'),style:'small_bold'},{text:comparable_construction_year,style:'small'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Conservation_status'),style:'small_bold'},{text:comparable_conservation_status,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Bedrooms_number'),style:'small_bold'},{text:comparable_bedrooms_number,style:'small'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Bathrooms_number'),style:'small_bold'},{text:comparable_bathrooms_number,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Offer_price'),style:'small_bold'},{text:comparable_offer_price,style:'small'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Estimated_sale_price'),style:'small_bold'},{text:comparable_estimated_sale_price,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Lift'),style:'small_bold'},{text:comparable_lift,style:'small'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Census_section_code'),style:'small_bold'},{text:comparable_census_section_code,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Source'),style:'small_bold'},{text:comparable_source,style:'small'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Contact_telephone'),style:'small_bold'},{text:comparable_contact_telephone,style:'small'}]);// cada 8 (4 anuncis i 4 margins) + 1 del pageBreak
if(comparables_table.length==8||comparables_table.length==17||comparables_table.length==26){// n is a multiple of 8
comparables_table.push([{text:'',pageBreak:'after'}]);}comparables_table.push([comparable_table],[{text:'',margin:[0,4]}]);datatabulation_table.push([{text:comparable_counter,style:'small_bold'},{text:comparable_ad_date,style:'small'},{text:comparable_property_type,style:'small'},{text:comparable_quality_of_neighbourhood,style:'small'},{text:comparable_quality_of_situation,style:'small'},{text:comparable_quality_of_construction,style:'small'},{text:comparable_quality_of_realestate,style:'small'},{text:comparable_adopted_age,style:'small'},{text:comparable_conservation_status,style:'small'},{text:comparable_floor_number,style:'small'},{text:comparable_adopted_area,style:'small'},{text:comparable_lift,style:'small'}]);qualities_comparison_table.push([{text:comparable_counter,style:'small_bold'},{text:comparable_comp_property_type,style:'small'},{text:comparable_comp_quality_of_neighbourhood,style:'small'},{text:comparable_comp_quality_of_situation,style:'small'},{text:comparable_comp_quality_of_construction,style:'small'},{text:comparable_comp_quality_of_realestate,style:'small'},{text:comparable_comp_adopted_age,style:'small'},{text:comparable_comp_conservation_status,style:'small'},{text:comparable_comp_floor_number,style:'small'},{text:comparable_comp_adopted_area,style:'small'},{text:comparable_comp_lift,style:'small'}]);homogenisation_table.push([{text:comparable_counter,style:'small_bold'},{text:comparable_homg_property_type,style:'small'},{text:comparable_homg_quality_of_neighbourhood,style:'small'},{text:comparable_homg_quality_of_situation,style:'small'},{text:comparable_homg_quality_of_construction,style:'small'},{text:comparable_homg_quality_of_realestate,style:'small'},{text:comparable_homg_adopted_age,style:'small'},{text:comparable_homg_conservation_status,style:'small'},{text:comparable_homg_floor_number,style:'small'},{text:comparable_homg_adopted_area,style:'small'},{text:comparable_homg_lift,style:'small'},{text:comparable_homg_total,style:'small_bold'}]);values_correction_table.push([{text:comparable_counter,style:'small_bold'},{text:comparable_calc_initial_unit_price,style:'small'},{text:comparable_calc_correction_pct,style:'small'},{text:comparable_calc_final_unit_price,style:'small'}]);regression_calc_table.push([{text:comparable_counter,style:'small_bold'},{text:comparable_calc_Xi,style:'small'},{text:comparable_calc_Vi,style:'small'},{text:comparable_calc_Vu,style:'small'},{text:comparable_calc_Vu2,style:'small'},{text:comparable_calc_XiVi,style:'small'},{text:comparable_calc_Xi2,style:'small'},{text:comparable_calc_Vi2,style:'small'}]);});// console.log('comparables_table: ')
// console.log(comparables_table)
// offer_production
var offer_production='-';if(marketstudies[i].offer_production){if(_this11.currentLocale==='ca'){offer_production=marketstudies[i].offer_production.name_ca;}else if(_this11.currentLocale==='en'){offer_production=marketstudies[i].offer_production.name_en;}else{offer_production=marketstudies[i].offer_production.name_es;}}else{marketstudy_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Market_study')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir el nivell de producció de oferta (anàlisi de mercat)',style:'plain',alignment:'left'}]);}// offer_yearly_stock
var offer_yearly_stock='-';if(marketstudies[i].offer_yearly_stock){if(_this11.currentLocale==='ca'){offer_yearly_stock=marketstudies[i].offer_yearly_stock.name_ca;}else if(_this11.currentLocale==='en'){offer_yearly_stock=marketstudies[i].offer_yearly_stock.name_en;}else{offer_yearly_stock=marketstudies[i].offer_yearly_stock.name_es;}}else{marketstudy_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Market_study')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir estoc anual oferta (anàlisi de mercat)',style:'plain',alignment:'left'}]);}// offer_trend
var offer_trend='-';if(marketstudies[i].offer_trend){if(_this11.currentLocale==='ca'){offer_trend=marketstudies[i].offer_trend.name_ca;}else if(_this11.currentLocale==='en'){offer_trend=marketstudies[i].offer_trend.name_en;}else{offer_trend=marketstudies[i].offer_trend.name_es;}}else{marketstudy_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Market_study')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir el tendència de oferta (anàlisi de mercat)',style:'plain',alignment:'left'}]);}// demand_level
var demand_level='-';if(marketstudies[i].demand_level){if(_this11.currentLocale==='ca'){demand_level=marketstudies[i].demand_level.name_ca;}else if(_this11.currentLocale==='en'){demand_level=marketstudies[i].demand_level.name_en;}else{demand_level=marketstudies[i].demand_level.name_es;}}else{marketstudy_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Market_study')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir el nivell de demanda (anàlisi de mercat)',style:'plain',alignment:'left'}]);}// demand_speed_of_sales
var demand_speed_of_sales='-';if(marketstudies[i].demand_speed_of_sales){if(_this11.currentLocale==='ca'){demand_speed_of_sales=marketstudies[i].demand_speed_of_sales.name_ca;}else if(_this11.currentLocale==='en'){demand_speed_of_sales=marketstudies[i].demand_speed_of_sales.name_en;}else{demand_speed_of_sales=marketstudies[i].demand_speed_of_sales.name_es;}}else{marketstudy_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Market_study')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la velocitat de vendes de demanda (anàlisi de mercat)',style:'plain',alignment:'left'}]);}// demand_trend
var demand_trend='-';if(marketstudies[i].demand_trend){if(_this11.currentLocale==='ca'){demand_trend=marketstudies[i].demand_trend.name_ca;}else if(_this11.currentLocale==='en'){demand_trend=marketstudies[i].demand_trend.name_en;}else{demand_trend=marketstudies[i].demand_trend.name_es;}}else{marketstudy_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Market_study')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la tendència de demanda (anàlisi de mercat)',style:'plain',alignment:'left'}]);}// prices_max
var prices_max='-';if(marketstudies[i].prices_max){prices_max=_this11.numFormat(marketstudies[i].prices_max,'€/m²');}else{marketstudy_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Market_study')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca el càlcul de preus màxim? (anàlisi de mercat)',style:'plain',alignment:'left'}]);}// prices_mean
var prices_mean='-';if(marketstudies[i].prices_mean){prices_mean=_this11.numFormat(marketstudies[i].prices_mean,'€/m²');}else{marketstudy_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Market_study')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca el càlcul de preus mitjana? (anàlisi de mercat)',style:'plain',alignment:'left'}]);}// prices_median
var prices_median='-';if(marketstudies[i].prices_median){prices_median=_this11.numFormat(marketstudies[i].prices_median,'€/m²');}else{marketstudy_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Market_study')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca el càlcul de preus mediana? (anàlisi de mercat)',style:'plain',alignment:'left'}]);}// prices_min
var prices_min='-';if(marketstudies[i].prices_min){prices_min=_this11.numFormat(marketstudies[i].prices_min,'€/m²');}else{marketstudy_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Market_study')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca el càlcul de preus mínim? (anàlisi de mercat)',style:'plain',alignment:'left'}]);}// prices_estimated_yearly_evolution_pct
var prices_estimated_yearly_evolution_pct='-';if(marketstudies[i].prices_estimated_yearly_evolution_pct){prices_estimated_yearly_evolution_pct=_this11.numFormat(marketstudies[i].prices_estimated_yearly_evolution_pct,'%');}else{marketstudy_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Market_study')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca l\'estimació de l\'evolució anual de preus (%) (anàlisi de mercat)',style:'plain',alignment:'left'}]);}// prices_expectancy
var prices_expectancy='-';if(marketstudies[i].prices_expectancy){if(_this11.currentLocale==='ca'){prices_expectancy=marketstudies[i].prices_expectancy.name_ca;}else if(_this11.currentLocale==='en'){prices_expectancy=marketstudies[i].prices_expectancy.name_en;}else{prices_expectancy=marketstudies[i].prices_expectancy.name_es;}}else{marketstudy_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Market_study')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir expectativa de preus (anàlisi de mercat)',style:'plain',alignment:'left'}]);}// prices_past_cicles_volatility
var prices_past_cicles_volatility='-';if(marketstudies[i].prices_past_cicles_volatility){if(_this11.currentLocale==='ca'){prices_past_cicles_volatility=marketstudies[i].prices_past_cicles_volatility.name_ca;}else if(_this11.currentLocale==='en'){prices_past_cicles_volatility=marketstudies[i].prices_past_cicles_volatility.name_en;}else{prices_past_cicles_volatility=marketstudies[i].prices_past_cicles_volatility.name_es;}}else{marketstudy_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Market_study')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la volatilitat de preus en cicles passats (anàlisi de mercat)',style:'plain',alignment:'left'}]);}// market_conjuncture
var market_conjuncture='-';if(marketstudies[i].market_conjuncture){if(_this11.currentLocale==='ca'){market_conjuncture=marketstudies[i].market_conjuncture.name_ca;}else if(_this11.currentLocale==='en'){market_conjuncture=marketstudies[i].market_conjuncture.name_en;}else{market_conjuncture=marketstudies[i].market_conjuncture.name_es;}}else{marketstudy_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Market_study')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir la conjunctura de mercat (anàlisi de mercat)',style:'plain',alignment:'left'}]);}// market_value_reduction_probability_expectancy
var market_value_reduction_probability_expectancy='-';if(marketstudies[i].market_value_reduction_probability_expectancy){if(_this11.currentLocale==='ca'){market_value_reduction_probability_expectancy=marketstudies[i].market_value_reduction_probability_expectancy.name_ca;}else if(_this11.currentLocale==='en'){market_value_reduction_probability_expectancy=marketstudies[i].market_value_reduction_probability_expectancy.name_en;}else{market_value_reduction_probability_expectancy=marketstudies[i].market_value_reduction_probability_expectancy.name_es;}}else{marketstudy_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Market_study')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca introduir expectativa de probabilitat de reducció del valor (anàlisi de mercat)',style:'plain',alignment:'left'}]);}// market_value_evolution_probability_pct
var market_value_evolution_probability_pct='-';if(marketstudies[i].market_value_evolution_probability_pct){market_value_evolution_probability_pct=_this11.numFormat(marketstudies[i].market_value_evolution_probability_pct,'%');}else{marketstudy_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Market_study')+' nº '+(i+1).toString(),style:'plain_bold'},{text:'Manca la probabilitat evolució valor de comparació (%) (anàlisi de mercat)',style:'plain',alignment:'left'}]);}// material_execution_cost
var material_execution_cost='-';if(appraisals[i].material_execution_cost){material_execution_cost=_this11.numFormat(appraisals[i].material_execution_cost,'€/m²');}// total_depreciation_pct
var total_depreciation_pct='-';if(appraisals[i].total_depreciation_pct){total_depreciation_pct=_this11.numFormat(appraisals[i].total_depreciation_pct,'%');}// deprecated_material_execution_cost
var deprecated_material_execution_cost='-';if(appraisals[i].deprecated_material_execution_cost){deprecated_material_execution_cost=_this11.numFormat(appraisals[i].deprecated_material_execution_cost,'€/m²');}// bc_pct
var bc_pct='-';if(appraisals[i].bc_pct){bc_pct=_this11.numFormat(appraisals[i].bc_pct,'%');}// bc
var bc='-';if(appraisals[i].bc){bc=_this11.numFormat(appraisals[i].bc,'€/m²');}// gc_pct
var gc_pct='-';if(appraisals[i].gc_pct){gc_pct=_this11.numFormat(appraisals[i].gc_pct,'%');}// gc
var gc='-';if(appraisals[i].gc){gc=_this11.numFormat(appraisals[i].gc,'€/m²');}// bc_and_gc_pct
var bc_and_gc_pct='-';if(appraisals[i].bc_and_gc_pct){bc_and_gc_pct=_this11.numFormat(appraisals[i].bc_and_gc_pct,'%');}// bc_and_gc
var bc_and_gc='-';if(appraisals[i].bc_and_gc){bc_and_gc=_this11.numFormat(appraisals[i].bc_and_gc,'€/m²');}// cc
var cc='-';if(appraisals[i].cc){cc=_this11.numFormat(appraisals[i].cc,'€/m²');}// ccb
var ccb='-';if(appraisals[i].ccb){ccb=_this11.numFormat(appraisals[i].ccb,'€/m²');}// htl_pct
var htl_pct='-';if(appraisals[i].htl_pct){htl_pct=_this11.numFormat(appraisals[i].htl_pct,'%');}// htl
var htl='-';if(appraisals[i].htl){htl=_this11.numFormat(appraisals[i].htl,'€/m²');}// inr_pct
var inr_pct='-';if(appraisals[i].inr_pct){inr_pct=_this11.numFormat(appraisals[i].inr_pct,'%');}// inr
var inr='-';if(appraisals[i].inr){inr=_this11.numFormat(appraisals[i].inr,'€/m²');}// ga_pct
var ga_pct='-';if(appraisals[i].ga_pct){ga_pct=_this11.numFormat(appraisals[i].ga_pct,'%');}// ga
var ga='-';if(appraisals[i].ga){ga=_this11.numFormat(appraisals[i].ga,'€/m²');}// gar
var gar='-';if(appraisals[i].gar){gar=_this11.numFormat(appraisals[i].gar,'€/m²');}// gpd_pct
var gpd_pct='-';if(appraisals[i].gpd_pct){gpd_pct=_this11.numFormat(appraisals[i].gpd_pct,'%');}// gpd
var gpd='-';if(appraisals[i].gpd){gpd=_this11.numFormat(appraisals[i].gpd,'€/m²');}// oct_pct
var oct_pct='-';if(appraisals[i].oct_pct){oct_pct=_this11.numFormat(appraisals[i].oct_pct,'%');}// oct
var oct='-';if(appraisals[i].oct){oct=_this11.numFormat(appraisals[i].oct,'€/m²');}// gp_pct
var gp_pct='-';if(appraisals[i].gp_pct){gp_pct=_this11.numFormat(appraisals[i].gp_pct,'%');}// gp
var gp='-';if(appraisals[i].gp){gp=_this11.numFormat(appraisals[i].gp,'€/m²');}// gpb
var gpb='-';if(appraisals[i].gpb){gpb=_this11.numFormat(appraisals[i].gpb,'€/m²');}// cc_and_gp
var cc_and_gp='-';if(appraisals[i].cc_and_gp){cc_and_gp=_this11.numFormat(appraisals[i].cc_and_gp,'€/m²');}// ccb_and_gpb
var ccb_and_gpb='-';if(appraisals[i].ccb_and_gpb){ccb_and_gpb=_this11.numFormat(appraisals[i].ccb_and_gpb,'€/m²');}// tlr_pct
var tlr_pct='-';if(appraisals[i].tlr_pct){tlr_pct=_this11.numFormat(appraisals[i].tlr_pct,'%');}// pr_pct
var pr_pct='-';if(appraisals[i].pr_pct){pr_pct=_this11.numFormat(appraisals[i].pr_pct,'%');}// am_coef
var am_coef='-';if(appraisals[i].am_coef){am_coef=_this11.numFormat(appraisals[i].am_coef,'');}// b1_pct
var b1_pct='-';if(appraisals[i].b1_pct){b1_pct=_this11.numFormat(appraisals[i].b1_pct,'%');}// b2_pct
var b2_pct='-';if(appraisals[i].b2_pct){b2_pct=_this11.numFormat(appraisals[i].b2_pct,'%');}// b_pct
var b_pct='-';if(appraisals[i].b_pct){b_pct=_this11.numFormat(appraisals[i].b_pct,'%');}// adopted_market_unit_value
var adopted_market_unit_value='-';if(appraisals[i].adopted_market_unit_value){adopted_market_unit_value=_this11.numFormat(appraisals[i].adopted_market_unit_value,'€/m²');}// b_remaining_pct
var b_remaining_pct='-';if(appraisals[i].b_remaining_pct){b_remaining_pct=_this11.numFormat(appraisals[i].b_remaining_pct,'%');}// f
var f='-';if(appraisals[i].f){f=_this11.numFormat(appraisals[i].f,'€/m²');}// crb
var crb='-';if(appraisals[i].crb){crb=_this11.numFormat(appraisals[i].crb,'€/m²');}// physical_depreciation_pct
var physical_depreciation_pct='-';if(appraisals[i].physical_depreciation_pct){physical_depreciation_pct=_this11.numFormat(appraisals[i].physical_depreciation_pct,'%');}// functional_depreciation_pct
var functional_depreciation_pct='-';if(appraisals[i].functional_depreciation_pct){functional_depreciation_pct=_this11.numFormat(appraisals[i].functional_depreciation_pct,'%');}// deprecated_land_and_ccd
var deprecated_land_and_ccd='-';if(appraisals[i].deprecated_land_and_ccd){deprecated_land_and_ccd=_this11.numFormat(appraisals[i].deprecated_land_and_ccd,'€/m²');}// finished_realestate_crn
var finished_realestate_crn='-';if(appraisals[i].finished_realestate_crn){finished_realestate_crn=_this11.numFormat(appraisals[i].finished_realestate_crn,'€/m²');}// total_construcion_progress_pct
var total_construcion_progress_pct='-';if(appraisals[i].total_construcion_progress_pct){total_construcion_progress_pct=_this11.numFormat(appraisals[i].total_construcion_progress_pct,'%');}// under_construction_realestate_crn
var under_construction_realestate_crn='-';if(appraisals[i].under_construction_realestate_crn){under_construction_realestate_crn=_this11.numFormat(appraisals[i].under_construction_realestate_crn,'€/m²');}// ccd
var ccd='-';if(appraisals[i].ccd){ccd=_this11.numFormat(appraisals[i].ccd,'€/m²');}// ccr
var ccr='-';if(appraisals[i].ccr){ccr=_this11.numFormat(appraisals[i].ccr,'€/m²');}// executed_construction_cost
var executed_construction_cost='-';if(appraisals[i].executed_construction_cost){executed_construction_cost=_this11.numFormat(appraisals[i].executed_construction_cost,'€/m²');}// k
var k='-';if(appraisals[i].k){k=_this11.numFormat(appraisals[i].k,'');}// repercussion_method_land_value
var repercussion_method_land_value='-';if(appraisals[i].repercussion_method_land_value){repercussion_method_land_value=_this11.numFormat(appraisals[i].repercussion_method_land_value,'€');repercussion_method_land_values.push(appraisals[i].repercussion_method_land_value);}if(repercussion_method_land_value<0){appraisal_review_table.push([{text:appraisals[0].id,style:'plain_bold'},{text:'El valor del sòl dóna negatiu. Revisar! Potser el valor de construcció + despeses és superior al valor de mercat?',style:'plain',alignment:'left'}]);}// cost_method_construction_crb_value
var cost_method_construction_crb_value='-';if(appraisals[i].cost_method_construction_crb_value){cost_method_construction_crb_value=_this11.numFormat(appraisals[i].cost_method_construction_crb_value,'€');cost_method_construction_crb_values.push(appraisals[i].cost_method_construction_crb_value);}// cost_method_construction_crn_value
var cost_method_construction_crn_value='-';if(appraisals[i].cost_method_construction_crn_value){cost_method_construction_crn_value=_this11.numFormat(appraisals[i].cost_method_construction_crn_value,'€');cost_method_construction_crn_values.push(appraisals[i].cost_method_construction_crn_value);}// cost_method_realestate_crb_value
var cost_method_realestate_crb_value='-';if(appraisals[i].cost_method_realestate_crb_value){cost_method_realestate_crb_value=_this11.numFormat(appraisals[i].cost_method_realestate_crb_value,'€');cost_method_realestate_crb_values.push(appraisals[i].cost_method_realestate_crb_value);}// cost_method_realestate_crn_value
var cost_method_realestate_crn_value='-';if(appraisals[i].cost_method_realestate_crn_value){cost_method_realestate_crn_value=_this11.numFormat(appraisals[i].cost_method_realestate_crn_value,'€');if(appraisals[i].total_construction_progress_pct===100){cost_method_realestate_crn_values.push(appraisals[i].cost_method_realestate_crn_value);}}// cost_method_unfinished_realestate_crn_value
var cost_method_unfinished_realestate_crn_value='-';if(appraisals[i].cost_method_unfinished_realestate_crn_value){cost_method_unfinished_realestate_crn_value=_this11.numFormat(appraisals[i].cost_method_unfinished_realestate_crn_value,'€');if(appraisals[i].total_construction_progress_pct<100){cost_method_unfinished_realestate_crn_values.push(appraisals[i].cost_method_unfinished_realestate_crn_value);}}// comparison_method
var comparison_method='-';if(appraisals[i].comparison_method){comparison_method=_this11.numFormat(appraisals[i].comparison_method,'€');comparison_methods.push(appraisals[i].comparison_method);}// max_legal_method
var max_legal_method='-';if(appraisals[i].max_legal_method){max_legal_method=_this11.numFormat(appraisals[i].max_legal_method,'€');max_legal_methods.push(appraisals[i].max_legal_method);}land_value_repercussion_method_table.push([{text:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,style:'small_bold'},{text:_this11.numFormat(adopted_area,'m²'),style:'small'},{text:'x',style:'small'},{text:f,style:'small'},{text:'=',style:'small'},{text:repercussion_method_land_value,style:'small'}]);construction_value_cost_method_crb_table.push([{text:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,style:'small_bold'},{text:_this11.numFormat(adopted_area,'m²'),style:'small'},{text:'x',style:'small'},{text:ccb_and_gpb,style:'small'},{text:'=',style:'small'},{text:cost_method_construction_crb_value,style:'small'}]);construction_value_cost_method_crn_table.push([{text:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,style:'small_bold'},{text:_this11.numFormat(adopted_area,'m²'),style:'small'},{text:'x',style:'small'},{text:ccd,style:'small'},{text:'=',style:'small'},{text:cost_method_construction_crn_value,style:'small'}]);realestate_value_cost_method_crb_table.push([{text:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,style:'small_bold'},{text:_this11.numFormat(adopted_area,'m²'),style:'small'},{text:'x',style:'small'},{text:crb,style:'small'},{text:'=',style:'small'},{text:cost_method_realestate_crb_value,style:'small'}]);if(appraisals[i].total_construction_progress_pct===100){realestate_value_cost_method_crn_table.push([{text:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,style:'small_bold'},{text:_this11.numFormat(adopted_area,'m²'),style:'small'},{text:'x',style:'small'},{text:finished_realestate_crn,style:'small'},{text:'=',style:'small'},{text:cost_method_realestate_crn_value,style:'small'}]);}if(appraisals[i].total_construction_progress_pct<100){unfinished_realestate_value_cost_method_crn_table.push([{text:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,style:'small_bold'},{text:_this11.numFormat(adopted_area,'m²'),style:'small'},{text:'x',style:'small'},{text:under_construction_realestate_crn,style:'small'},{text:'=',style:'small'},{text:cost_method_unfinished_realestate_crn_value,style:'small'}]);}realestate_value_comparison_method_table.push([{text:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,style:'small_bold'},{text:_this11.numFormat(adopted_area,'m²'),style:'small'},{text:'x',style:'small'},{text:adopted_market_unit_value,style:'small'},{text:'=',style:'small'},{text:comparison_method,style:'small'}]);// console.log('max_legal_price: ')
// console.log(max_legal_price)
realestate_value_max_legal_method_table.push([{text:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,style:'small_bold'},{text:_this11.numFormat(max_legal_area,'m²'),style:'small'},{text:'x',style:'small'},{text:_this11.numFormat(max_legal_price,'€/m²'),style:'small'},{text:'=',style:'small'},{text:max_legal_method,style:'small'}]);contract_foreseeable_remaining_period_table.push([{text:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,style:'small_bold'},{text:cession_contract_start_date,style:'small'},{text:cession_contract_period_years,style:'small'},{text:cession_contract_remaining_years,style:'small'},{text:realestates_remaining_useful_life,style:'small'},{text:tenant_remaining_life_expectancy_years,style:'small'},{text:contracts_foreseeable_remaining_period,style:'small'}]);// insurance_value
var insurance_value='-';if(appraisals[i].insurance_value){insurance_value=_this11.numFormat(appraisals[i].insurance_value,'€');insurance_values.push(appraisals[i].insurance_value);}insurance_value_table.push([{text:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,style:'small_bold'},{text:_this11.numFormat(adopted_area,'m²'),style:'small'},{text:'x',style:'small'},{text:ccb_and_gpb,style:'small'},{text:'=',style:'small'},{text:insurance_value,style:'small'}]);// insurance_value_rd_1982
var insurance_value_rd_1982='-';if(appraisals[i].insurance_value_rd_685_1982){insurance_value_rd_1982=_this11.numFormat(appraisals[i].insurance_value_rd_685_1982,'€');insurance_values_rd_1982.push(appraisals[i].insurance_value_rd_685_1982);}// insurance_value_rd_2009
var insurance_value_rd_2009='-';if(appraisals[i].insurance_value_rd_716_2009){insurance_value_rd_2009=_this11.numFormat(appraisals[i].insurance_value_rd_716_2009,'€');insurance_values_rd_2009.push(appraisals[i].insurance_value_rd_716_2009);}// right of use value
var usufruct_value='-';var bare_ownership_value='-';var vu_coef='-';if(appraisals[i].usufruct_value){usufruct_value=_this11.numFormat(appraisals[i].usufruct_value,'€');usufruct_values.push(appraisals[i].usufruct_value);}if(appraisals[i].bare_ownership_value){bare_ownership_value=_this11.numFormat(appraisals[i].bare_ownership_value,'€');bare_ownership_values.push(appraisals[i].bare_ownership_value);}if(appraisals[i].vu_coef){vu_coef=_this11.numFormat(appraisals[i].vu_coef,'');}right_of_use_value_table.push([{text:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,style:'small_bold'},{text:usufructuary_age_years,style:'small'},{text:vu_coef,style:'small'},{text:usufruct_value,style:'small'},{text:bare_ownership_value,style:'small'}]);// adopted_market_value
var adopted_market_value='-';if(appraisals[i].adopted_market_value){adopted_market_value=_this11.numFormat(appraisals[i].adopted_market_value,'€');}// residual_depreciation
var residual_depreciation='-';if(appraisals[i].residual_depreciation){residual_depreciation=_this11.numFormat(appraisals[i].residual_depreciation,'€');}// realestate_residual_value
var realestate_residual_value='-';if(appraisals[i].realestate_residual_value){realestate_residual_value=_this11.numFormat(appraisals[i].realestate_residual_value,'€');}real_estates_residual_value_table.push([{text:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,style:'small_bold'},{text:comparison_method,style:'small'},{text:cost_method_construction_crb_value,style:'small'},{text:useful_life_years,style:'small'},{text:contracts_foreseeable_remaining_period,style:'small'},{text:residual_depreciation,style:'small'},{text:realestate_residual_value,style:'small'}]);// landlord_expenses_pct
var landlord_expenses_pct='-';if(appraisals[i].landlord_expenses_pct){landlord_expenses_pct=_this11.numFormat(appraisals[i].landlord_expenses_pct,'%');}// cession_net_yearly_income
var cession_net_yearly_income='-';if(appraisals[i].cession_net_yearly_income){cession_net_yearly_income=_this11.numFormat(appraisals[i].cession_net_yearly_income,'€/'+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('year'));}// i_pct
var i_pct='-';if(appraisals[i].i_pct){i_pct=_this11.numFormat(appraisals[i].i_pct,'%');}// coef_1
var coef_1='-';if(appraisals[i].coef_1){coef_1=_this11.numFormat(appraisals[i].coef_1,'');}// current_future_income_value
var current_future_income_value='-';if(appraisals[i].current_future_income_value){current_future_income_value=_this11.numFormat(appraisals[i].current_future_income_value,'€');}current_value_of_future_rents_table.push([{text:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,style:'small_bold'},{text:cession_gross_yearly_income,style:'small'},{text:landlord_expenses_pct,style:'small'},{text:cession_net_yearly_income,style:'small'},{text:contracts_foreseeable_remaining_period,style:'small'},{text:i_pct,style:'small'},{text:coef_1,style:'small'},{text:current_future_income_value,style:'small'}]);// coef_2
var coef_2='-';if(appraisals[i].coef_2){coef_2=_this11.numFormat(appraisals[i].coef_2,'');}// updated_reversion_value
var updated_reversion_value='-';if(appraisals[i].updated_reversion_value){updated_reversion_value=_this11.numFormat(appraisals[i].updated_reversion_value,'€');}current_reversion_value_table.push([{text:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,style:'small_bold'},{text:cession_gross_yearly_income,style:'small'},{text:contracts_foreseeable_remaining_period,style:'small'},{text:i_pct,style:'small'},{text:coef_2,style:'small'},{text:updated_reversion_value,style:'small'}]);// update_value
var update_value='-';if(appraisals[i].update_value){update_value=_this11.numFormat(appraisals[i].update_value,'€');}update_value_table.push([{text:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,style:'small_bold'},{text:current_future_income_value,style:'small'},{text:updated_reversion_value,style:'small'},{text:update_value,style:'small'}]);// cc_by_contract_table
var cc_by_contract_table=[];var cc_by_contract_table_widths=[300,120];cc_by_contract_table.push([{text:'',style:'small_bold'},{text:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,style:'small_bold'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Material_execution_cost_as_new'),style:'small_bold'},{text:material_execution_cost,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Integrity')+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('or')+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('remaining')+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('of')+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Depreciation_by_antiquity')+' (da = 100 - d)',style:'small_bold'},{text:total_depreciation_pct,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Adopted_material_execution_cost_deprecated_by_antiquity')+' (Cem)',style:'small_bold'},{text:deprecated_material_execution_cost,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Builders_industrial_benefit_percentage')+' (% Bc)',style:'small_bold'},{text:bc_pct,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Builders_industrial_benefit')+' (Bc)',style:'small_bold'},{text:bc,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Builders_general_expenses_percentage')+' (% Gc)',style:'small_bold'},{text:gc_pct,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Builders_general_expenses')+' (Gc)',style:'small_bold'},{text:gc,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Builders_expenses_and_benefit_percentage')+' (% Bc + % Gc)',style:'small_bold'},{text:bc_and_gc_pct,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Builders_expenses_and_benefit')+' (Bc + Gc)',style:'small_bold'},{text:bc_and_gc,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Construction_costs')+' (Cc = Cem + Bc + Gc)',style:'small_bold'},{text:cc,style:'small'}]);// dev_expenses_table
var dev_expenses_table=[];var dev_expenses_table_widths=[300,120];dev_expenses_table.push([{text:'',style:'small_bold'},{text:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,style:'small_bold'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Honorarium_c_taxes_and_licenses_percentage')+' (% HTL)',style:'small_bold'},{text:htl_pct,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Honorarium_c_taxes_and_licenses')+' (HTL)',style:'small_bold'},{text:htl,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Non_recoverable_taxes_percentage')+' (% INR)',style:'small_bold'},{text:inr_pct,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Non_recoverable_taxes')+' (INR)',style:'small_bold'},{text:inr,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Developers_administrative_expenses_percentage')+' (% Ga)',style:'small_bold'},{text:ga_pct,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Developers_administrative_expenses')+' (Ga)',style:'small_bold'},{text:ga,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Decennial_insurance_policy_expenses_percentage')+' (% Gpd)',style:'small_bold'},{text:gpd_pct,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Decennial_insurance_policy_expenses')+' (Gpd)',style:'small_bold'},{text:gpd,style:'small'}],[{text:'% OCT',style:'small_bold'},{text:oct_pct,style:'small'}],[{text:'OCT',style:'small_bold'},{text:oct,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Development_expenses_percentage')+' (% Gp = % HTL + % INR + % Ga + % Gpd + % OCT)',style:'small_bold'},{text:gp_pct,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Development_expenses')+' (Gp = HTL + INR + Ga + Gpd + OCT)',style:'small_bold'},{text:gp,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Construction_costs')+' (Cc)',style:'small_bold'},{text:cc,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Construction_replacement_cost')+' (Cc + Gp)',style:'small_bold'},{text:cc_and_gp,style:'small'}]);// dev_benefit_table
var dev_benefit_table=[];var dev_benefit_table_widths=[300,120];dev_benefit_table.push([{text:'',style:'small_bold'},{text:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,style:'small_bold'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Riskfree_rate')+' (TLR)',style:'small_bold'},{text:tlr_pct,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Risk_premium')+' (PR)',style:'small_bold'},{text:pr_pct,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Agravation_or_improvement_coeficient')+' (Coef. AM)',style:'small_bold'},{text:am_coef,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Freemarket_benefit')+' (b1 = (TLR + PR) * Coef. AM)',style:'small_bold'},{text:b1_pct,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Minimum_benefit_acc_to_regulation')+' (b2)',style:'small_bold'},{text:b2_pct,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Developers_benefit')+' (max: b1 vs b2)',style:'small_bold'},{text:b_pct,style:'small_bold'}]);// land_mv_table
var land_mv_table=[];var land_mv_table_widths=[300,120];land_mv_table.push([{text:'',style:'small_bold'},{text:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,style:'small_bold'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Building_market_value')+' (VM)',style:'small_bold'},{text:adopted_market_unit_value,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Construction_costs')+' (Cc)',style:'small_bold'},{text:cc,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Development_expenses')+' (Gp)',style:'small_bold'},{text:gp,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Remaining_of_the_developers_benefit')+' (1-b)',style:'small_bold'},{text:b_remaining_pct,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Land_value')+' (F = Vm * (1-b) - (Cc + Gp))',style:'small_bold'},{text:f,style:'small_bold'}]);// crb_fb_table
var crb_fb_table=[];var crb_fb_table_widths=[300,120];crb_fb_table.push([{text:'',style:'small_bold'},{text:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,style:'small_bold'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Land_market_value')+' (F)',style:'small_bold'},{text:f,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('As_new_construction_cost')+' (Ccb)',style:'small_bold'},{text:ccb,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Development_expenses')+' (Gpb)',style:'small_bold'},{text:gpb,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Gross_Replacement_Cost')+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('finished_building')+' (CRB)',style:'small_bold'},{text:crb,style:'small'}]);// crn_fb_table
var crn_fb_table=[];var crn_fb_table_widths=[300,120];crn_fb_table.push([{text:'',style:'small_bold'},{text:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,style:'small_bold'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Land_market_value')+' (F)',style:'small_bold'},{text:f,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('As_new_construction_cost')+' (Ccb)',style:'small_bold'},{text:ccb,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Development_expenses')+' (Gpb)',style:'small_bold'},{text:gpb,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Construction_cost_and_development_expenses')+' (Ccb + Gpb)',style:'small_bold'},{text:ccb_and_gpb,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Adopted_age')+' (A)',style:'small_bold'},{text:adopted_age_years_old,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Estimated_useful_life')+' (Vu)',style:'small_bold'},{text:useful_life_years,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Physical_depreciation')+' (DFI = A * Vu)',style:'small_bold'},{text:physical_depreciation_pct,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Functional_depreciation')+' (DFU)',style:'small_bold'},{text:functional_depreciation_pct,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Total_depreciation')+' (D = (1 - DFI) * (1 - DFU))',style:'small_bold'},{text:total_depreciation_pct,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Deprecated_construction_cost')+' (CCD = (Ccb + Gpb) * D)',style:'small_bold'},{text:ccd,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Developers_administrative_expenses')+' (Ga)',style:'small_bold'},{text:ga,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Land_value_plus_deprecated_construction_cost')+' ((F + Ccd))',style:'small_bold'},{text:deprecated_land_and_ccd,style:'small'}],[{text:'CRN: '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Net_Replacement_Cost')+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('finished_building'),style:'small_bold'},{text:finished_realestate_crn,style:'small'}]);// crn_ub_table
var crn_ub_table=[];var crn_ub_table_widths=[300,120];crn_ub_table.push([{text:'',style:'small_bold'},{text:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,style:'small_bold'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Land_market_value')+' (F)',style:'small_bold'},{text:f,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('As_new_construction_cost')+' (Ccb)',style:'small_bold'},{text:ccb,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Development_expenses')+' (Gpb)',style:'small_bold'},{text:gpb,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Construction_cost_and_development_expenses')+' (Ccb + Gpb)',style:'small_bold'},{text:ccb_and_gpb,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Construction_progress_percentage'),style:'small_bold'},{text:total_construcion_progress_pct,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Executed_construction_cost')+' (Ccr)',style:'small_bold'},{text:ccr,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Developers_administrative_expenses')+' ('+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('executed_construction')+') '+' (Gar)',style:'small_bold'},{text:gar,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Land_value_plus_executed_construction_cost')+' (F + Ccr)',style:'small_bold'},{text:executed_construction_cost,style:'small'}],[{text:'CRN: '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Net_Replacement_Cost')+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('real_estate_under_construction')+' (F + Ccr + Gar)',style:'small_bold'},{text:under_construction_realestate_crn,style:'small'}]);// mv_table
var mv_table=[];var mv_table_widths=[300,120];mv_table.push([{text:'',style:'small_bold'},{text:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,style:'small_bold'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Finished_building_market_value')+' (VM)',style:'small_bold'},{text:adopted_market_unit_value,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Market_coeficient')+' (K)',style:'small_bold'},{text:k,style:'small'}]);// adjusted_market_value
var adjusted_market_value='-';if(appraisals[i].adjusted_market_value){adjusted_market_value=_this11.numFormat(appraisals[i].adjusted_market_value,'€');}// realestate_total_adopted_value
var realestate_total_adopted_value='-';if(appraisals[i].realestate_total_adopted_value){realestate_total_adopted_value=_this11.numFormat(appraisals[i].realestate_total_adopted_value,'€');realestate_total_adopted_values.push(appraisals[i].realestate_total_adopted_value);}insurance_value_table_rd_1982.push([{text:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,style:'small_bold'},{text:_this11.numFormat(cost_method_realestate_crb_value,'€'),style:'small'},{text:'-',style:'small'},{text:_this11.numFormat(repercussion_method_land_value,'€'),style:'small'},{text:'=',style:'small'},{text:_this11.numFormat(insurance_value_rd_1982,'€'),style:'small'}]);insurance_value_table_rd_2009.push([{text:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,style:'small_bold'},{text:_this11.numFormat(realestate_total_adopted_value,'€'),style:'small'},{text:'-',style:'small'},{text:_this11.numFormat(repercussion_method_land_value,'€'),style:'small'},{text:'=',style:'small'},{text:_this11.numFormat(insurance_value_rd_2009,'€'),style:'small'}]);//realestate_adopted_appraisal_method
var realestate_adopted_appraisal_method='-';if(appraisals[i].realestate_adopted_appraisal_method){realestate_adopted_appraisal_method=appraisals[i].realestate_adopted_appraisal_method;}appraisal_value_determination_table.push([{text:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,style:'small_bold'},{text:comparison_method,style:'small'},{text:adjusted_market_value,style:'small'},{text:max_legal_method,style:'small'},{text:update_value,style:'small'},{text:realestate_total_adopted_value,style:'small_bold'}]);appraisal_value_determination_table_min.push([{text:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,style:'small_bold'},{text:comparison_method,style:'small'},{text:realestate_total_adopted_value,style:'small_bold'}]);appraisal_value_determination_table_ceded.push([{text:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,style:'small_bold'},{text:comparison_method,style:'small'},{text:update_value,style:'small'},{text:realestate_total_adopted_value,style:'small_bold'}]);appraisal_value_determination_table_under_construction.push([{text:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,style:'small_bold'},{text:comparison_method,style:'small'},{text:cost_method_unfinished_realestate_crn_value,style:'small'},{text:realestate_total_adopted_value,style:'small_bold'}]);appraisal_value_determination_table_ceded_eco.push([{text:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,style:'small_bold'},{text:comparison_method,style:'small'},{text:adjusted_market_value,style:'small'},{text:update_value,style:'small'},{text:realestate_total_adopted_value,style:'small_bold'}]);appraisal_value_determination_table_eco.push([{text:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,style:'small_bold'},{text:comparison_method,style:'small'},{text:adjusted_market_value,style:'small'},{text:realestate_total_adopted_value,style:'small_bold'}]);appraisal_value_determination_table_eco_protected.push([{text:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,style:'small_bold'},{text:comparison_method,style:'small'},{text:adjusted_market_value,style:'small'},{text:max_legal_method,style:'small'},{text:realestate_total_adopted_value,style:'small_bold'}]);appraisal_value_determination_table_protected.push([{text:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,style:'small_bold'},{text:comparison_method,style:'small'},{text:max_legal_method,style:'small'},{text:realestate_total_adopted_value,style:'small_bold'}]);final_id_table.push([{text:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,style:'small_bold'},{text:registry_name,style:'small'},{text:registry_real_estate_number,style:'small'},{text:cad_ref,style:'small'}]);final_values_table.push([{border:[false,false,false,false],fillColor:'#dddddd',hLineWidth:3,text:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short+':',style:'plain_bold_right'},{border:[false,false,false,false],fillColor:'#dddddd',hLineWidth:3,text:realestate_total_adopted_value,style:'plain_bold_left'}]);certificate_content_obj.table.body.push([{layout:'noBorders',border:[true,false,true,false],table:{headerRows:0,widths:[340,160],body:[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Date_of_visit')+': ',margin:[60,0],border:[true,false,true,false],alignment:'left',style:'plain_bold'},{text:visitdate,margin:[10,0],border:[true,false,true,false],alignment:'left',style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Usage_assigned_by_the_owner')+': ',margin:[60,0],border:[true,false,true,false],alignment:'left',style:'plain_bold'},{text:usage_assigned,margin:[10,0],border:[true,false,true,false],alignment:'left',style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Method_used_to_calculate_the_value')+': ',margin:[60,0],border:[true,false,true,false],alignment:'left',style:'plain_bold'},{text:realestate_adopted_appraisal_method.name_ca,//text:  '',
margin:[10,0],border:[true,false,true,false],alignment:'left',style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Land_value')+': ',margin:[60,0],border:[true,false,true,false],alignment:'left',style:'plain_bold'},{text:repercussion_method_land_value,//text:  '',
margin:[10,0],border:[true,false,true,false],alignment:'left',style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Insurance_value')+' s/ R. D. 685/1982: ',margin:[60,0],border:[true,false,true,false],alignment:'left',style:'plain_bold'},{text:insurance_value_rd_1982,//text:  '',
margin:[10,0],border:[true,false,true,false],alignment:'left',style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Insurance_value')+' s/ R. D. 246/1998, 716/2009: ',margin:[60,0],border:[true,false,true,false],alignment:'left',style:'plain_bold'},{text:insurance_value_rd_2009,//text:  '',
margin:[10,0],border:[true,false,true,false],alignment:'left',style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cost_value_current_state')+': ',margin:[60,0],border:[true,false,true,false],alignment:'left',style:'plain_bold'},{text:cost_method_realestate_crn_value,//text:  '',
margin:[10,0],border:[true,false,true,false],alignment:'left',style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Comparison_value')+': ',margin:[60,0],border:[true,false,true,false],alignment:'left',style:'plain_bold'},{text:comparison_method,//text:  '',
margin:[10,0],border:[true,false,true,false],alignment:'left',style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Maximum_legal_value')+': ',margin:[60,0],border:[true,false,true,false],alignment:'left',style:'plain_bold'},{text:max_legal_method,//text:  '',
margin:[10,0],border:[true,false,true,false],alignment:'left',style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Update_value')+': ',margin:[60,0],border:[true,false,true,false],alignment:'left',style:'plain_bold'},{text:appraisals[i].cession_boolean?update_value:'-',//text:  '',
margin:[10,0],border:[true,false,true,false],alignment:'left',style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Adjusted_market_value')+': ',margin:[60,0],border:[true,false,true,false],alignment:'left',style:'plain_bold'},{text:adjusted_market_value,//text:  '',
margin:[10,0],border:[true,false,true,false],alignment:'left',style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Adopted_value').toUpperCase()+': ',margin:[60,0],border:[true,false,true,false],alignment:'left',style:'plain_bold_underline'},{text:realestate_total_adopted_value,//text:  '',
margin:[10,0],border:[true,false,true,false],alignment:'left',style:'plain_bold_underline'}]]}}]);var no_constraints_text='';if(_this11.currentLocale==='ca'){no_constraints_text='En base a la documentació obtinguda no s\'ha considerat que existeixin condicionants a assenyalar';}else if(_this11.currentLocale==='en'){no_constraints_text='En base a la documentació obtinguda no s\'ha considerat que existeixin condicionants a assenyalar';}else{no_constraints_text='En base a la documentación obtenida no se ha considerado que existan condicionantes a señalar';}var no_warnings_text='';if(_this11.currentLocale==='ca'){no_warnings_text='En base a la documentació obtinguda no s\'ha considerat que existeixin advertiments a assenyalar';}else if(_this11.currentLocale==='en'){no_warnings_text='En base a la documentació obtinguda no s\'ha considerat que existeixin advertiments a assenyalar';}else{no_warnings_text='En base a la documentación obtenida no se ha considerado que existan advertencias a señalar';}var constraints_list=[];var constraint_count=0;if(_this11.currentLocale==='ca'){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(constraints[i],function(value,key){constraint_count=+1;var constraint=value.name_ca;if(!constraint||constraint==='translation missing'){constraint='';realestate_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString()+', Condicionant nº '+constraint_count,style:'plain_bold'},{text:'El condicionant està en blanc, revisar. Potser falta la seva traducció a l\'idioma actual?',style:'plain',alignment:'left'}]);}constraints_list.push([{text:constraint,style:'plain',margin:[40,0]}]);});}else if(_this11.currentLocale==='en'){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(constraints[i],function(value,key){constraint_count=+1;var constraint=value.name_en;if(!constraint||constraint==='translation missing'){constraint='';realestate_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString()+', Condicionant nº '+constraint_count,style:'plain_bold'},{text:'El condicionant  està en blanc, revisar. Potser falta la seva traducció a l\'idioma actual?',style:'plain',alignment:'left'}]);}constraints_list.push([{text:constraint,style:'plain',margin:[40,0]}]);});}else{__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(constraints[i],function(value,key){constraint_count=+1;var constraint=value.name_es;if(!constraint||constraint==='translation missing'){constraint='';realestate_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString()+', Condicionant nº '+constraint_count,style:'plain_bold'},{text:'El condicionant està en blanc, revisar. Potser falta la seva traducció a l\'idioma actual?',style:'plain',alignment:'left'}]);}constraints_list.push([{text:constraint,style:'plain',margin:[40,0]}]);});}console.log('constraints_list: ');console.log(constraints_list);if(constraints_list.length===0){constraints_list.push([{text:no_constraints_text+'. ',style:'plain',margin:[40,0]}]);}else{any_constraints=true;}constraints_table[0][0].table.body.push([{text:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short+': ',style:'plain_bold'}]);constraints_table[0][0].table.body.push([{layout:'noBorders',table:{headerRows:0,widths:['*'],body:constraints_list,margin:[0,40]}}]);constraints_table[0][0].table.body.push([{text:'',style:'plain'}]);var warnings_list=[];var warning_count=0;if(_this11.currentLocale==='ca'){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(warnings[i],function(value,key){warning_count=+1;var warning=value.name_ca;if(!warning||warning==='translation missing'){warning='';realestate_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString()+', Advertiment nº '+warning_count,style:'plain_bold'},{text:'L\'advertiment està en blanc, revisar. Potser falta la seva traducció a l\'idioma actual?',style:'plain',alignment:'left'}]);}warnings_list.push([{text:warning,style:'plain',margin:[40,0]}]);});}else if(_this11.currentLocale==='en'){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(warnings[i],function(value,key){warning_count=+1;var warning=value.name_en;if(!warning||warning==='translation missing'){warning='';realestate_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString()+', Advertiment nº '+warning_count,style:'plain_bold'},{text:'L\'advertiment està en blanc, revisar. Potser falta la seva traducció a l\'idioma actual?',style:'plain',alignment:'left'}]);}warnings_list.push([{text:warning,style:'plain',margin:[40,0]}]);});}else{__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(warnings[i],function(value,key){warning_count=+1;var warning=value.name_es;if(!warning||warning==='translation missing'){warning='';realestate_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString()+', Advertiment nº '+warning_count,style:'plain_bold'},{text:'L\'advertiment està en blanc, revisar. Potser falta la seva traducció a l\'idioma actual?',style:'plain',alignment:'left'}]);}warnings_list.push([{text:warning,style:'plain',margin:[40,0]}]);});}console.log('warnings_list: ');console.log(warnings_list);if(warnings_list.length===0){warnings_list.push([{text:no_warnings_text+'. ',style:'plain',margin:[40,0]}]);}else{any_warnings=true;}warnings_table[0][0].table.body.push([{text:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short+': ',style:'plain_bold'}]);warnings_table[0][0].table.body.push([{layout:'noBorders',table:{headerRows:0,widths:['*'],body:warnings_list,margin:[0,40]}}]);warnings_table[0][0].table.body.push([{text:'',style:'plain'}]);var notes_list=[];var note_count=0;if(_this11.currentLocale==='ca'){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(notes[i],function(value,key){note_count=+1;var note=value.name_ca;if(!note||note==='translation missing'){note='';realestate_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString()+', Observació nº '+note_count,style:'plain_bold'},{text:'L\'observació està en blanc, revisar. Potser falta la seva traducció a l\'idioma actual?',style:'plain',alignment:'left'}]);}notes_list.push([{text:note,style:'plain',margin:[40,0]}]);});}else if(_this11.currentLocale==='en'){__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(notes[i],function(value,key){note_count=+1;var note=value.name_en;if(!note||note==='translation missing'){note='';realestate_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString()+', Observació nº '+note_count,style:'plain_bold'},{text:'L\'observació està en blanc, revisar. Potser falta la seva traducció a l\'idioma actual?',style:'plain',alignment:'left'}]);}notes_list.push([{text:note,style:'plain',margin:[40,0]}]);});}else{__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(notes[i],function(value,key){note_count=+1;var note=value.name_es;if(!note||note==='translation missing'){note='';realestate_review_table.push([{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate')+' nº '+(i+1).toString()+', Observació nº '+note_count,style:'plain_bold'},{text:'L\'observació està en blanc, revisar. Potser falta la seva traducció a l\'idioma actual?',style:'plain',alignment:'left'}]);}notes_list.push([{text:note,style:'plain',margin:[40,0]}]);});}console.log('notes_list: ');console.log(notes_list);if(notes_list.length===0){notes_list.push([{text:'-',style:'plain'}]);}else{any_notes=true;}notes_table[0][0].table.body.push([{text:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short+': ',style:'plain_bold'}]);notes_table[0][0].table.body.push([{layout:'noBorders',table:{headerRows:0,widths:[440],body:notes_list,margin:[0,40]}}]);notes_table[0][0].table.body.push([{text:'',style:'plain'}]);if(i===0){docDefinition.content=[{columns:[{image:'data:image/png;base64,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',width:120},{width:'*',text:'BARNA-TASA',style:'cover_brand',alignment:'right',margin:[0,70,30,0]}]},//// END OF BLOCK
//// BLOCK START
{text:'',margin:[0,80]},{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{fillColor:'lightgray',text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Valuation').toUpperCase(),style:'cover_title',margin:[0,4]}],[{fillColor:'lightgray',text:_this11.appraisalreport.title,style:'cover_subtitle',margin:[0,4]}]]}},//// END OF BLOCK
//// BLOCK START
{layout:'noBorders',table:{headerRows:0,widths:[50,120,'*'],body:address_table}},{layout:'noBorders',pageBreak:'after',table:{headerRows:0,widths:[50,120,'*'],body:[[{fillColor:'whitesmoke',text:'',style:'plain_blue_bold'},{fillColor:'whitesmoke',text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Appraisal_purpose').toUpperCase(),style:'plain_blue_bold'},{fillColor:'whitesmoke',text:appraisal_purpose,style:'plain_blue'}],[{fillColor:'whitesmoke',text:'',style:'plain_blue_bold'},{fillColor:'whitesmoke',text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Value_date').toUpperCase(),style:'plain_blue_bold'},{fillColor:'whitesmoke',text:appraisaldate,style:'plain_blue'}],[{fillColor:'whitesmoke',text:'',style:'plain_blue_bold'},{fillColor:'whitesmoke',text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Report_date').toUpperCase(),style:'plain_blue_bold'},{fillColor:'whitesmoke',text:reportdate,style:'plain_blue'}],[{fillColor:'whitesmoke',text:'',style:'plain_blue_bold'},{fillColor:'whitesmoke',text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('File').toUpperCase(),style:'plain_blue_bold'},{fillColor:'whitesmoke',text:filenumber,style:'plain_blue'}],// End row
[{fillColor:'whitesmoke',text:'',margin:[0,4],style:'plain_blue_bold'},{fillColor:'whitesmoke',text:'',margin:[0,4],style:'plain_blue_bold'},{fillColor:'whitesmoke',text:'',margin:[0,4],style:'plain_blue'}]]}},//// PAGE-BREAK
//// BLOCK START
{layout:'noBorders',table:{headerRows:0,widths:[320,200],body:[[{text:'',style:'plain_bold_right'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Barnatasa_header_portrait'),style:'plain_bold_right'}]]}},{text:'',style:'plain',margin:[0,8]},{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{fillColor:'lightgray',text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Valuation').toUpperCase(),style:'cover_title',margin:[0,4]}],[{fillColor:'lightgray',text:_this11.appraisalreport.title,style:'cover_subtitle',margin:[0,4]}]]}},//// END OF BLOCK
//// BLOCK START
{layout:'noBorders',table:{headerRows:0,widths:[50,120,'*'],body:address_table}},{layout:'noBorders',table:{headerRows:0,widths:[50,120,'*'],margin:[0,80],body:[[{fillColor:'whitesmoke',text:'',style:'plain_blue_bold'},{fillColor:'whitesmoke',text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Appraisal_purpose').toUpperCase(),style:'plain_blue_bold'},{fillColor:'whitesmoke',text:appraisal_purpose,style:'plain_blue'}],[{fillColor:'whitesmoke',text:'',style:'plain_blue_bold'},{fillColor:'whitesmoke',text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Value_date').toUpperCase(),style:'plain_blue_bold'},{fillColor:'whitesmoke',text:appraisaldate,style:'plain_blue'}],[{fillColor:'whitesmoke',text:'',style:'plain_blue_bold'},{fillColor:'whitesmoke',text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Report_date').toUpperCase(),style:'plain_blue_bold'},{fillColor:'whitesmoke',text:reportdate,style:'plain_blue'}],[{fillColor:'whitesmoke',text:'',style:'plain_blue_bold'},{fillColor:'whitesmoke',text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('File').toUpperCase(),style:'plain_blue_bold'},{fillColor:'whitesmoke',text:filenumber,style:'plain_blue'}],// End row
[{fillColor:'whitesmoke',text:'',margin:[0,4],style:'plain_blue_bold'},{fillColor:'whitesmoke',text:'',margin:[0,4],style:'plain_blue_bold'},{fillColor:'whitesmoke',text:'',margin:[0,4],style:'plain_blue'}]]}}];if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(content_portrait_photo)>0){docDefinition.content.push(content_portrait_photo[0]);}else{appraisalreport_review_table.push([{text:'Informe',style:'plain_bold'},{text:'Manca indicar la foto de portada',style:'plain',alignment:'left'}]);}docDefinition.content.push(//// PAGE-BREAK
{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Index').toUpperCase(),margin:[0,12],pageBreak:'before'},{toc:{id:'mainTocA',textMargin:[0,0,10,0],textStyle:'plain_bold',numberStyle:'plain_bold'}});for(var _i=0;_i<appraisals.length;_i++){docDefinition.content.push({toc:{id:'appraisalTocTitle'+_i.toString(),textMargin:[0,0,10,0],textStyle:'plain_bold',numberStyle:'plain_bold'}},{toc:{id:'appraisalTocSub'+_i.toString(),textMargin:[20,0,10,0],textStyle:'plain',numberStyle:'plain_bold'}});}docDefinition.content.push({toc:{id:'mainTocB',textMargin:[0,0,10,0],textStyle:'plain_bold',numberStyle:'plain_bold'}});docDefinition.content.push({toc:{id:'annexTocSub',textMargin:[20,0,10,0],textStyle:'plain',numberStyle:'plain_bold'}});docDefinition.content.push({text:'',pageBreak:'after'},//// PAGE-BREAK
{layout:'noBorders',pageHeaderChapterText:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Appraisal_petitioner').toUpperCase(),pageHeaderRealEstateText:' ',table:{headerRows:0,widths:['*'],body:[[{fillColor:'whitesmoke',text:'1. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Appraisal_petitioner').toUpperCase()+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and').toUpperCase()+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('purpose').toUpperCase(),style:'h4',margin:[0,1],tocItem:'mainTocA'}]]}},{layout:'noBorders',margin:[40,4],table:{headerRows:0,widths:['*'],body:[[{text:'1.1. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Commission').toUpperCase(),style:'h5_underline'}]]}},{layout:'noBorders',margin:[80,4],table:{headerRows:0,widths:[180,'*'],body:[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Appraisal_petitioner').toUpperCase(),style:'plain_bold'},{text:petitioner,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Petitioner_type').toUpperCase(),style:'plain_bold'},{text:petitioner_type,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Mandatary_entity').toUpperCase(),style:'plain_bold'},{text:mandatary,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Appraisal_purpose').toUpperCase(),style:'plain_bold'},{text:appraisal_purpose,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Acc_mortgage_market_law_q').toUpperCase(),style:'plain_bold'},{text:acc_mortgage_market_law,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Acc_eco_decree_q').toUpperCase(),style:'plain_bold'},{text:acc_eco_decree,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Notes').toUpperCase(),style:'plain_bold'},{text:purpose_notes,style:'plain'}]]}},{text:'',margin:[0,10]},{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{fillColor:'whitesmoke',text:'2. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Appraised_real_estates_in_this_report').toUpperCase(),style:'h4',margin:[0,1],tocItem:'mainTocA'}]]}},{text:'',margin:[0,4]},{layout:'lightHorizontalLines',margin:[0,4],widths:[60,'*','*','*','*'],table:{headerRows:0,body:appraised_id_table}},{text:'',margin:[0,10]},{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{fillColor:'whitesmoke',text:'',style:'h4',margin:[0,7]}]]}},//// PAGE-BREAK
// keep appending dynamically below....
{text:'',pageBreak:'after'});address_table.push([{fillColor:'whitesmoke',text:'',margin:[0,4],style:'plain_blue_bold'},{fillColor:'whitesmoke',text:'',margin:[0,4],style:'plain_blue_bold'},{fillColor:'whitesmoke',text:'',margin:[0,4],style:'plain_blue'}],[{fillColor:'whitesmoke',text:'',style:'plain_blue_bold'},{fillColor:'whitesmoke',text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Appraised_real_estates').toUpperCase(),style:'plain_blue_bold'},{fillColor:'whitesmoke',// text: '• ' + property_type + ' ' + Vue.i18n.translate('at') + ' ' + address_long,
text:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_long,style:'plain_blue'}]);appraised_id_table.push([{text:'',style:'plain_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Property_type'),style:'plain_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Address'),style:'plain_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cadastral_reference'),style:'plain_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Registry_property'),style:'plain_bold'}],[{text:(i+1).toString(),style:'plain_bold'},{text:property_type,style:'plain'},{text:address_long,style:'plain'},{text:cad_ref,style:'plain'},{text:reg_est_num,style:'plain'}]);}else{// console.log(i)
address_table.push([{fillColor:'whitesmoke',text:'',style:'plain_blue_bold'},{fillColor:'whitesmoke',text:'',style:'plain_blue_bold'},{fillColor:'whitesmoke',// text: '• ' + property_type + ' ' + Vue.i18n.translate('at') + ' ' + address_long,
text:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_long,style:'plain_blue'}]);appraised_id_table.push([{text:(i+1).toString(),style:'plain_bold'},{text:property_type,style:'plain'},{text:address_long,style:'plain'},{text:cad_ref,style:'plain'},{text:reg_est_num,style:'plain'}]);}docDefinition.content.push({layout:'tocSectionLevel2',pageHeaderChapterText:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Identification').toUpperCase(),pageHeaderRealEstateText:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,table:{headerRows:0,widths:['*'],body:[[{fillColor:'whitesmoke',text:(i+1+2).toString()+'. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Appraised_real_estate').toUpperCase()+' Nº '+(i+1).toString()+' - '+property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,border:[true,true,true,true],style:'h4',margin:[0,1],tocItem:'appraisalTocTitle'+i.toString()}]]}},{text:'',margin:[0,4]},// Identification
{layout:'tocSectionLevel2',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 1. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Identification').toUpperCase()+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and').toUpperCase()+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('location').toUpperCase(),border:[false,false,false,true],style:'h5',margin:[0,1],tocItem:'appraisalTocSub'+i.toString()}]]}},{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 1. 1. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Address').toUpperCase(),border:[false,false,false,true],style:'h5_underline',margin:[40,10]// tocItem: 'appraisalTocSub' + i.toString()
}]]}},{text:'',margin:[0,4]},{layout:'noBorders',margin:[80,4],table:{headerRows:0,widths:[180,'*'],body:[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Property_type').toUpperCase(),style:'plain_bold'},{text:property_type,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Address').toUpperCase(),style:'plain_bold'},{text:address_short,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Postal_code').toUpperCase()+' - '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Municipality').toUpperCase(),style:'plain_bold'},{text:address_postal_code_only+address_municipality,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Latitude').toUpperCase()+' (EPSG:4326)',style:'plain_bold'},{text:latitude,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Longitude').toUpperCase()+' (EPSG:4326)',style:'plain_bold'},{text:longitude,style:'plain'}]]}},{text:'',margin:[0,4]},// Cadastral data
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 1. 2. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cadastral_data').toUpperCase(),style:'h5_underline',margin:[40,1]// tocItem: 'appraisalTocSub' + i.toString()
}]]}},{text:'',margin:[0,4]},{layout:'noBorders',margin:[80,4],table:{headerRows:0,widths:[180,'*'],body:[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cadastral_reference').toUpperCase(),style:'plain_bold'},{text:cad_ref,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Construction_year').toUpperCase(),style:'plain_bold'},{text:cadastral_construction_year,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Usage').toUpperCase(),style:'plain_bold'},{text:cadastral_usage,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Floor').toUpperCase(),style:'plain_bold'},{text:cadastral_floor,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Door').toUpperCase(),style:'plain_bold'},{text:cadastral_door,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Staircase').toUpperCase(),style:'plain_bold'},{text:cadastral_staircase,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Block').toUpperCase(),style:'plain_bold'},{text:cadastral_block,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Built_area').toUpperCase(),style:'plain_bold'},{text:_this11.numFormat(built_cadastral_area,'m²'),style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Built_plus_common_elements_area').toUpperCase(),style:'plain_bold'},{text:_this11.numFormat(built_plus_common_elements_cadastral_area,'m²'),style:'plain'}]]}},{text:'',margin:[0,4]},// Registry data
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 1. 3. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Registry_data').toUpperCase(),style:'h5_underline',margin:[40,1]// tocItem: 'appraisalTocSub' + i.toString()
}]]}},{text:'',margin:[0,4]},{layout:'noBorders',margin:[80,4],table:{headerRows:0,widths:[180,'*'],body:[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Register').toUpperCase(),style:'plain_bold'},{text:registry_name,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Section').toUpperCase(),style:'plain_bold'},{text:registry_section,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Volume').toUpperCase(),style:'plain_bold'},{text:registry_volume,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Book').toUpperCase(),style:'plain_bold'},{text:registry_book,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Page').toUpperCase(),style:'plain_bold'},{text:registry_page,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Registry_real_estate_number').toUpperCase(),style:'plain_bold'},{text:registry_real_estate_number,style:'plain'}],[{text:'IDUFIR',style:'plain_bold'},{text:registry_idufir,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Holder').toUpperCase(),style:'plain_bold'},{text:registry_owner,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Property_coef').toUpperCase(),style:'plain_bold'},{text:_this11.numFormat(registry_property_coef,'%'),style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Net_area').toUpperCase(),style:'plain_bold'},{text:_this11.numFormat(net_registry_area,'m²'),style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Enclosed_area').toUpperCase(),style:'plain_bold'},{text:_this11.numFormat(enclosed_registry_area,'m²'),style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Covered_outdoors_area').toUpperCase(),style:'plain_bold'},{text:_this11.numFormat(covered_terraces_total_registry_area,'m²'),style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Uncovered_outdoors_area').toUpperCase(),style:'plain_bold'},{text:_this11.numFormat(uncovered_terraces_total_registry_area,'m²'),style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Built_area').toUpperCase(),style:'plain_bold'},{text:_this11.numFormat(built_registry_area,'m²'),style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Built_plus_common_elements_area').toUpperCase(),style:'plain_bold'},{text:_this11.numFormat(built_plus_common_elements_registry_area,'m²'),style:'plain'}]]}},{text:'',pageBreak:'after'},{layout:'tocSectionLevel2',pageHeaderChapterText:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Checkings_realized').toUpperCase(),pageHeaderRealEstateText:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 2. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Checkings_realized').toUpperCase()+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and').toUpperCase()+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Documents_used').toUpperCase(),border:[false,false,false,true],style:'h5',margin:[0,1],tocItem:'appraisalTocSub'+i.toString()}]]}},// Checkings_realized
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 2. 1. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Checkings_realized').toUpperCase(),style:'h5_underline',margin:[40,10]// tocItem: 'appraisalTocSub' + i.toString()
}]]}},{text:'',margin:[0,4]},{layout:'noBorders',margin:[80,4],table:{headerRows:0,widths:[180,'*'],body:[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Interior_visit'),style:'plain_bold'},{text:checks_interior_visit,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cadastral_data'),style:'plain_bold'},{text:checks_cadastral_data,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Conservation_status'),style:'plain_bold'},{text:checks_conservation_status,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Expropriation_procedure'),style:'plain_bold'},{text:checks_expropriation_procedure,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Expropriation_plan'),style:'plain_bold'},{text:checks_expropriation_plan,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Expropriation_admin_ruling'),style:'plain_bold'},{text:checks_expropriation_admin_ruling,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Expropriation_file'),style:'plain_bold'},{text:checks_expropriation_file,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Occupancy'),style:'plain_bold'},{text:checks_occupancy,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Registry_data'),style:'plain_bold'},{text:checks_registry_data,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Servitudes'),style:'plain_bold'},{text:checks_servitudes,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Public_protection_regime'),style:'plain_bold'},{text:checks_subsidy_status,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Urban_parameters_suitability'),style:'plain_bold'},{text:checks_urban_planning,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Another'),style:'plain_bold'},{text:checks_other,style:'plain'}]]}},{text:'',margin:[0,4]},// Documents used
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 2. 2. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Documents_used').toUpperCase(),style:'h5_underline',margin:[40,1]// tocItem: 'appraisalTocSub' + i.toString()
}]]}},{text:'',margin:[0,4]},{layout:'noBorders',margin:[80,4],table:{headerRows:0,widths:[180,'*'],body:[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Approved_project_by_professional_association'),style:'plain_bold'},{text:docs_approved_project,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cadastral_documents'),style:'plain_bold'},{text:docs_cadastral_data,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Construction_license'),style:'plain_bold'},{text:docs_construction_license,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Construction_last_certificate'),style:'plain_bold'},{text:docs_construction_last_certificate,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Construction_contract'),style:'plain_bold'},{text:docs_construction_contract,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Occupancy_status'),style:'plain_bold'},{text:docs_occupancy_status,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Photographic_report'),style:'plain_bold'},{text:docs_photographic_report,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Property_sketch'),style:'plain_bold'},{text:docs_property_sketch,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Property_titles'),style:'plain_bold'},{text:docs_property_titles,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Situation_plan'),style:'plain_bold'},{text:docs_situation_plan,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Public_protection_regime'),style:'plain_bold'},{text:docs_subsidy_status,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Ten_year_insurance'),style:'plain_bold'},{text:docs_tenyear_insurance,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Urban_plan'),style:'plain_bold'},{text:docs_urban_plan,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Another'),style:'plain_bold'},{text:docs_other,style:'plain'}]]}},{text:'',pageBreak:'after'},// Site
{layout:'tocSectionLevel2',pageHeaderChapterText:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Site').toUpperCase(),pageHeaderRealEstateText:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 3. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Site').toUpperCase(),border:[false,false,false,true],style:'h5',margin:[0,1],tocItem:'appraisalTocSub'+i.toString()}]]}},// Locality
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 3. 1. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Locality').toUpperCase(),style:'h5_underline',margin:[40,10]// tocItem: 'appraisalTocSub' + i.toString()
}]]}},{text:'',margin:[0,1]},{layout:'noBorders',margin:[80,4],table:{headerRows:0,widths:[180,280],body:[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Nucleus_type').toUpperCase(),style:'plain_bold'},{text:nucleus_type,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Population').toUpperCase(),style:'plain_bold'},{text:_this11.intFormat(nucleus_population,'hab'),style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Population_growth').toUpperCase()+' ('+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Gross_tax_per_1000_inhabitants').toUpperCase()+')',style:'plain_bold'},{text:_this11.numFormat(nucleus_population_growth,''),style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Nucleus_area').toUpperCase(),style:'plain_bold'},{text:_this11.numFormat(nucleus_area,'km²'),style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Population_density').toUpperCase(),style:'plain_bold'},{text:_this11.numFormat(nucleus_population_density,'hab/km²'),style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Employment_occupation').toUpperCase(),style:'plain_bold'},{text:occupation_description,style:'plain'}]]}},// Surroundings
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 3. 2. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Surroundings').toUpperCase(),style:'h5_underline',margin:[40,1]// tocItem: 'appraisalTocSub' + i.toString()
}]]}},{text:'',margin:[0,1]},{layout:'noBorders',margin:[80,4],table:{headerRows:0,widths:[180,'*'],body:[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Territorial_feature').toUpperCase(),style:'plain_bold'},{text:surrounding_territorial_feature,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Income_level').toUpperCase(),style:'plain_bold'},{text:surrounding_income_level,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Homogeneity_feature').toUpperCase(),style:'plain_bold'},{text:surrounding_homogeneity_feature,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Main_uses').toUpperCase(),style:'plain_bold'},{text:surrounding_main_uses,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Density').toUpperCase(),style:'plain_bold'},{text:surrounding_density,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Accessibility').toUpperCase(),style:'plain_bold'},{text:surrounding_accessibility,style:'plain'}]]}},{text:'',margin:[0,4]},// Building development level
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 3. 3. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Building_development_level').toUpperCase(),style:'h5_underline',margin:[40,1]// tocItem: 'appraisalTocSub' + i.toString()
}]]}},{text:'',margin:[0,1]},{layout:'noBorders',margin:[80,4],table:{headerRows:0,widths:[180,'*'],body:[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Consolidation_degree').toUpperCase(),style:'plain_bold'},{text:surrounding_consolidation_degree,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Occupation_degree').toUpperCase(),style:'plain_bold'},{text:surrounding_occupation_degree,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Evolution').toUpperCase(),style:'plain_bold'},{text:surrounding_evolution_speed,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Average_age').toUpperCase(),style:'plain_bold'},{text:surrounding_average_age,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Conservation_status').toUpperCase(),style:'plain_bold'},{text:surrounding_conservation_status,style:'plain'}]]}},{text:'',margin:[0,4]},// Facilities
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 3. 4. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Facilities').toUpperCase(),style:'h5_underline',margin:[40,1]// tocItem: 'appraisalTocSub' + i.toString()
}]]}},{text:'',margin:[0,1]},{layout:'noBorders',margin:[80,4],table:{headerRows:0,widths:[180,'*'],body:[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Commercial').toUpperCase(),style:'plain_bold'},{text:surrounding_commercial_facilities,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Educational').toUpperCase(),style:'plain_bold'},{text:surrounding_educational_facilities,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Public_parking').toUpperCase(),style:'plain_bold'},{text:surrounding_public_parking,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Medical_assistance').toUpperCase(),style:'plain_bold'},{text:surrounding_medical_assistance,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Leisure').toUpperCase(),style:'plain_bold'},{text:surrounding_leisure,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Notes').toUpperCase(),style:'plain_bold'},{text:surrounding_facilities_notes,style:'plain'}]]}},{text:'',margin:[0,4]},// Communications
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 3. 5. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Communications').toUpperCase(),style:'h5_underline',margin:[40,1]// tocItem: 'appraisalTocSub' + i.toString()
}]]}},{text:'',margin:[0,1]},{layout:'noBorders',margin:[80,4],table:{headerRows:0,widths:[180,'*'],body:[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Airport').toUpperCase(),style:'plain_bold'},{text:communications_airport,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Harbour').toUpperCase(),style:'plain_bold'},{text:communications_harbour,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Train').toUpperCase(),style:'plain_bold'},{text:communications_train,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Public_transport').toUpperCase()+' - '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Urban_underground').toUpperCase(),style:'plain_bold'},{text:public_transport_urban_underground,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Public_transport').toUpperCase()+' - '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Interurban').toUpperCase(),style:'plain_bold'},{text:public_transport_interurban,style:'plain'}]]}},{text:'',margin:[0,4]},/*
																																																													// Public transport
																																																													{
																																																														layout: 'noBorders',
																																																														table: {

																																																															headerRows: 0,
																																																															widths: ['*'],
																																																															body: [
																																																																[
																																																																	{
																																																																		text: (i + 1 + 2).toString() + '. 2. 6. ' + Vue.i18n.translate('Public_transport').toUpperCase(),
																																																																		style: 'h5_underline',
																																																																		margin: [40, 1],
																																																																		// tocItem: 'appraisalTocSub' + i.toString()
																																																																	}
																																																																]
																																																															]
																																																														}
																																																													},
																																																													{
																																																														text: '',
																																																														margin: [0, 4]
																																																													},
																																																													{
																																																														layout: 'noBorders',
																																																														margin: [80, 4],
																																																														table: {
																																																															headerRows: 0,
																																																															widths: [180, '*'],
																																																															body: [
																																																																[
																																																																	{
																																																																		text: Vue.i18n.translate('Urban_underground').toUpperCase(),
																																																																		style: 'plain_bold'
																																																																	},
																																																																	{
																																																																		text: public_transport_urban_underground,
																																																																		style: 'plain'
																																																																	}
																																																																],
																																																																[
																																																																	{
																																																																		text: Vue.i18n.translate('Interurban').toUpperCase(),
																																																																		style: 'plain_bold'
																																																																	},
																																																																	{
																																																																		text: public_transport_interurban,
																																																																		style: 'plain'
																																																																	}
																																																																],

																																																															]
																																																														}
																																																													},
																																																													*/{text:'',margin:[0,4]},// Site_quality
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 3. 6. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Site_quality').toUpperCase(),style:'h5_underline',margin:[40,1]// tocItem: 'appraisalTocSub' + i.toString()
}]]}},{text:'',margin:[0,1]},{layout:'noBorders',margin:[80,4],table:{headerRows:0,widths:[180,'*'],body:[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quality_of_neighbourhood').toUpperCase(),style:'plain_bold'},{text:quality_of_neighbourhood,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quality_of_situation').toUpperCase(),style:'plain_bold'},{text:quality_of_situation,style:'plain'}]]}},{text:'',pageBreak:'after'},// Urban_planning
{layout:'tocSectionLevel2',pageHeaderChapterText:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Urban_planning').toUpperCase(),pageHeaderRealEstateText:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 4. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Urban_planning').toUpperCase(),border:[false,false,false,true],style:'h5',margin:[0,1],tocItem:'appraisalTocSub'+i.toString()}]]}},{text:'',margin:[0,10]},// Urban planning parameters
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 4. 1. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Urban_planning_parameters').toUpperCase(),style:'h5_underline',margin:[40,1]// tocItem: 'appraisalTocSub' + i.toString()
}]]}},{text:'',margin:[0,4]},{layout:'noBorders',margin:[80,4],table:{headerRows:0,widths:[180,'*'],body:[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Plan_type').toUpperCase(),style:'plain_bold'},{text:urban_planning_type,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('File').toUpperCase(),style:'plain_bold'},{text:urban_planning_file,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Council_qualification').toUpperCase(),style:'plain_bold'},{text:urban_planning_council_qualification,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Council_qualification_description').toUpperCase(),style:'plain_bold'},{text:urban_planning_council_qualification_description,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Council_classification').toUpperCase(),style:'plain_bold'},{text:urban_planning_council_classification,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Council_classification_description').toUpperCase(),style:'plain_bold'},{text:urban_planning_council_classification_description,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Regional_qualification').toUpperCase(),style:'plain_bold'},{text:urban_planning_regional_qualification,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Regional_qualification_description').toUpperCase(),style:'plain_bold'},{text:urban_planning_regional_qualification_description,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Regional_classification').toUpperCase(),style:'plain_bold'},{text:urban_planning_regional_classification,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Regional_classification_description').toUpperCase(),style:'plain_bold'},{text:urban_planning_regional_classification_description,style:'plain'}]]}},{text:'',pageBreak:'after'},// Terrain description
{layout:'tocSectionLevel2',pageHeaderChapterText:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Terrain_description').toUpperCase(),pageHeaderRealEstateText:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 5. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Terrain_description').toUpperCase(),border:[false,false,false,true],style:'h5',margin:[0,1],tocItem:'appraisalTocSub'+i.toString()}]]}},{text:'',margin:[0,10]},// Terrain area
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 5. 1. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Terrain_area').toUpperCase(),style:'h5_underline',margin:[60,1]}]]}},{text:'',margin:[0,4]},{layout:'noBorders',margin:[80,4],table:{headerRows:0,widths:[180,'*'],body:[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Registry_area').toUpperCase(),style:'plain_bold'},{text:_this11.numFormat(land_registry_area,'m²'),style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cadastral_area').toUpperCase(),style:'plain_bold'},{text:_this11.numFormat(land_cadastral_area,'m²'),style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Checked_area').toUpperCase(),style:'plain_bold'},{text:_this11.numFormat(land_checked_area,'m²'),style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Adopted_area').toUpperCase(),style:'plain_bold'},{text:_this11.numFormat(land_adopted_area,'m²'),style:'plain_bold'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Notes').toUpperCase(),style:'plain_bold'},{text:land_area_notes,style:'plain'}]]}},{text:'',margin:[0,4]},// Terrain infrastructures
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 5. 2. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Terrain_infrastructures').toUpperCase(),style:'h5_underline',margin:[60,1]}]]}},{text:'',margin:[0,4]},{layout:'noBorders',margin:[80,4],table:{headerRows:0,widths:[180,40,'*'],body:[[{text:'',style:'plain_bold'},{text:'',style:'plain'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Execution'),style:'plain_bold'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Paving').toUpperCase(),style:'plain_bold'},{text:land_infrastructure_paving,style:'plain'},{text:_this11.numFormat(land_infrastructure_paving_execution_pct,'%'),style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Sewage').toUpperCase(),style:'plain_bold'},{text:land_infrastructure_sewage,style:'plain'},{text:_this11.numFormat(land_infrastructure_sewage_execution_pct,'%'),style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Public_lighting').toUpperCase(),style:'plain_bold'},{text:land_infrastructure_public_lighting,style:'plain'},{text:_this11.numFormat(land_infrastructure_public_lighting_execution_pct,'%'),style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Water_supply').toUpperCase(),style:'plain_bold'},{text:land_infrastructure_water_supply,style:'plain'},{text:_this11.numFormat(land_infrastructure_water_supply_execution_pct,'%'),style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Electricity_supply').toUpperCase(),style:'plain_bold'},{text:land_infrastructure_electricity_supply,style:'plain'},{text:_this11.numFormat(land_infrastructure_electricity_supply_execution_pct,'%'),style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Piped_gas').toUpperCase(),style:'plain_bold'},{text:land_infrastructure_piped_gas,style:'plain'},{text:_this11.numFormat(land_infrastructure_piped_gas_execution_pct,'%'),style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Telephone_service').toUpperCase(),style:'plain_bold'},{text:land_infrastructure_telephone_service,style:'plain'},{text:_this11.numFormat(land_infrastructure_telephone_service_execution_pct,'%'),style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Gardened_areas').toUpperCase(),style:'plain_bold'},{text:land_infrastructure_gardened_areas,style:'plain'},{text:_this11.numFormat(land_infrastructure_gardened_areas_execution_pct,'%'),style:'plain'}]]}},{text:'',margin:[0,4]},{layout:'noBorders',margin:[80,4],table:{headerRows:0,widths:[180,'*'],body:[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Land_is_plot_according_to_law').toUpperCase(),style:'plain_bold'},{text:land_is_plot_according_to_law,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Conservation_status').toUpperCase(),style:'plain_bold'},{text:land_infrastructure_conservation_status,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Pending_investment').toUpperCase(),style:'plain_bold'},{text:_this11.numFormat(land_infrastructure_pending_investment,'€/m²'),style:'plain'}]]}},{text:'',pageBreak:'after'},// Building description
{layout:'tocSectionLevel2',pageHeaderChapterText:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Construction_description').toUpperCase(),pageHeaderRealEstateText:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 6. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Construction_description').toUpperCase(),border:[false,false,false,true],style:'h5',margin:[0,1],tocItem:'appraisalTocSub'+i.toString()}]]}},{text:'',margin:[0,10]},// Plot occupation
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 6. 1. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Plot_occupation').toUpperCase(),style:'h5_underline',margin:[60,1]}]]}},{text:'',margin:[0,4]},{layout:'noBorders',margin:[80,4],table:{headerRows:0,widths:[180,'*'],body:[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Plot_occupation').toUpperCase(),style:'plain_bold'},{text:plot_occupation,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Plot_free_area_usage').toUpperCase(),style:'plain_bold'},{text:plot_free_area_usage,style:'plain'}]]}},{text:'',margin:[0,4]},// Nº of floors and usage
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 6. 2. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Number_of_floors_and_use').toUpperCase(),style:'h5_underline',margin:[60,1]}]]}},{text:'',margin:[0,4]},{layout:'noBorders',margin:[80,4],table:{headerRows:0,widths:[180,40,'*'],body:[[{text:'',style:'plain_bold'},{text:'nº',style:'plain_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Usage'),style:'plain_bold'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Underground_levels').toUpperCase(),style:'plain_bold'},{text:floors_number_underground,style:'plain'},{text:floors_usage_underground,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Ground_level').toUpperCase(),style:'plain_bold'},{text:'PB',style:'plain'},{text:groundfloor_usage,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Overground_levels').toUpperCase(),style:'plain_bold'},{text:floors_number_overground,style:'plain'},{text:floors_usage_overground,style:'plain'}]]}},{text:'',margin:[0,4]},// Common elements
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 6. 3. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Common_elements').toUpperCase(),style:'h5_underline',margin:[60,1]}]]}},{text:'',margin:[0,4]},{layout:'noBorders',margin:[80,4],table:{headerRows:0,widths:[180,'*'],body:[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Entrance_hall'),style:'plain_bold'},{text:entrance_hall,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Doorman_space'),style:'plain_bold'},{text:doorman_space,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Staircase'),style:'plain_bold'},{text:staircase,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Lift'),style:'plain_bold'},{text:lift,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Swimming_pool'),style:'plain_bold'},{text:swimming_pool,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Gardened_areas'),style:'plain_bold'},{text:gardened_areas,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Sports_facilities'),style:'plain_bold'},{text:sports_facilities,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Community_room'),style:'plain_bold'},{text:community_room,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Community_parking'),style:'plain_bold'},{text:community_parking,style:'plain'}]]}},{text:'',margin:[0,4]},// Interior finishes
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 6. 4. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Interior_finishes').toUpperCase(),style:'h5_underline',margin:[60,1]// tocItem: 'appraisalTocSub' + i.toString()
}]]}},{text:'',margin:[0,4]});if(appraisals[i].property_type.name_db==='residential'){docDefinition.content.push({layout:'lightHorizontalLines',margin:[0,4],table:{headerRows:1,widths:[60,60,60,60,60,60,60],body:[[{text:'',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Living'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Circulations'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Bedrooms'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Kitchen'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Bathrooms'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quality'),style:'small_bold'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Paving'),style:'small_bold'},{text:realestate_interior_paving_living,style:'small'},{text:realestate_interior_paving_corridor,style:'small'},{text:realestate_interior_paving_bedroom,style:'small'},{text:realestate_interior_paving_kitchen,style:'small'},{text:realestate_interior_paving_bathroom,style:'small'},{text:realestate_interior_paving_quality,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Walls'),style:'small_bold'},{text:realestate_interior_walls_living,style:'small'},{text:realestate_interior_walls_corridor,style:'small'},{text:realestate_interior_walls_bedroom,style:'small'},{text:realestate_interior_walls_kitchen,style:'small'},{text:realestate_interior_walls_bathroom,style:'small'},{text:realestate_interior_walls_quality,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Ceilings'),style:'small_bold'},{text:realestate_interior_ceilings_living,style:'small'},{text:realestate_interior_ceilings_corridor,style:'small'},{text:realestate_interior_ceilings_bedroom,style:'small'},{text:realestate_interior_ceilings_kitchen,style:'small'},{text:realestate_interior_ceilings_bathroom,style:'small'},{text:realestate_interior_ceilings_quality,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Interior_carpentry'),style:'small_bold'},{text:realestate_interior_carpentry_living,style:'small'},{text:realestate_interior_carpentry_corridor,style:'small'},{text:realestate_interior_carpentry_bedroom,style:'small'},{text:realestate_interior_carpentry_kitchen,style:'small'},{text:realestate_interior_carpentry_bathroom,style:'small'},{text:realestate_interior_carpentry_quality,style:'small'}]]}});}else if(appraisals[i].property_type.name_db==='retail_and_industrial'||appraisals[i].property_type.name_db==='office'){docDefinition.content.push({layout:'lightHorizontalLines',margin:[0,4],table:{headerRows:1,widths:[60,60,60,60,60,60,60],body:[[{text:'',style:'small_bold'},{text:'General',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Bathrooms'),style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quality'),style:'small_bold'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Paving'),style:'small_bold'},{text:realestate_interior_paving_living,style:'small'},{text:realestate_interior_paving_bathroom,style:'small'},{text:realestate_interior_paving_quality,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Walls'),style:'small_bold'},{text:realestate_interior_walls_living,style:'small'},{text:realestate_interior_walls_bathroom,style:'small'},{text:realestate_interior_walls_quality,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Ceilings'),style:'small_bold'},{text:realestate_interior_ceilings_living,style:'small'},{text:realestate_interior_ceilings_bathroom,style:'small'},{text:realestate_interior_ceilings_quality,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Interior_carpentry'),style:'small_bold'},{text:realestate_interior_carpentry_living,style:'small'},{text:realestate_interior_carpentry_bathroom,style:'small'},{text:realestate_interior_carpentry_quality,style:'small'}]]}});}else{docDefinition.content.push({layout:'lightHorizontalLines',margin:[0,4],table:{headerRows:1,widths:[60,60,60,60,60,60,60],body:[[{text:'',style:'small_bold'},{text:'General',style:'small_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quality'),style:'small_bold'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Paving'),style:'small_bold'},{text:realestate_interior_paving_living,style:'small'},{text:realestate_interior_paving_quality,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Walls'),style:'small_bold'},{text:realestate_interior_walls_living,style:'small'},{text:realestate_interior_walls_quality,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Ceilings'),style:'small_bold'},{text:realestate_interior_ceilings_living,style:'small'},{text:realestate_interior_ceilings_quality,style:'small'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Interior_carpentry'),style:'small_bold'},{text:realestate_interior_carpentry_living,style:'small'},{text:realestate_interior_carpentry_quality,style:'small'}]]}});}if(appraisals[i].property_type.name_db==='residential'){docDefinition.content.push({text:'',margin:[0,4]},// Habitability conditions
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 6. 5. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Habitability_conditions').toUpperCase(),style:'h5_underline',margin:[40,1]// // tocItem: 'appraisalTocSub' + i.toString()
}]]}},{text:'',margin:[0,4]},{layout:'noBorders',margin:[80,4],table:{headerRows:0,widths:[180,'*'],body:[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Number_of_rooms_to_exterior'),style:'plain_bold'},{text:realestate_rooms_to_exterior_number,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Main_orientation'),style:'plain_bold'},{text:realestate_main_orientation,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Views'),style:'plain_bold'},{text:realestate_main_views,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Windows_size_and_quantity'),style:'plain_bold'},{text:realestate_windows_size_and_quantity,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Noise_facade'),style:'plain_bold'},{text:realestate_noise_facade,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Day_night_zoning'),style:'plain_bold'},{text:realestate_day_night_zoning,style:'plain'}]]}});}docDefinition.content.push({text:'',pageBreak:'after'},// Net areas
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 6. 6. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Net_areas').toUpperCase(),style:'h5_underline',margin:[0,1]// tocItem: 'appraisalTocSub' + i.toString()
}]]}},{text:'',margin:[0,4]},{layout:'lightHorizontalLines',margin:[0,4],table:{headerRows:1,widths:[160,200,120],body:net_areas_table}},{text:'',margin:[0,4]},// Covered_outdoors
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 6. 7. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Covered_outdoors_area').toUpperCase(),style:'h5_underline',margin:[0,1]// tocItem: 'appraisalTocSub' + i.toString()
}]]}},{layout:'lightHorizontalLines',margin:[0,4],table:{headerRows:1,widths:[160,200,120],body:covered_outdoors_table}},{text:'',margin:[0,4]},// Uncovered_outdoors
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 6. 8. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Uncovered_outdoors_area').toUpperCase(),style:'h5_underline',margin:[0,1]// tocItem: 'appraisalTocSub' + i.toString()
}]]}},{layout:'lightHorizontalLines',margin:[0,4],table:{headerRows:1,widths:[160,200,120],body:uncovered_outdoors_table}},{text:'',margin:[0,4]},// Total areas
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 6. 9. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Total_areas_summary_table').toUpperCase(),style:'h5_underline',margin:[0,1]}]]}},{layout:'lightHorizontalLines',margin:[0,4],table:{headerRows:1,widths:[150,75,75,75,75],body:[[{text:'',style:'plain_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Registry'),style:'plain_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cadastral'),style:'plain_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Checked'),style:'plain_bold'},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Adopted'),style:'plain_bold'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Net_area'),style:'plain_bold'},{text:_this11.numFormat(net_registry_area,'m²'),style:'plain'},{text:_this11.numFormat(net_cadastral_area,'m²'),style:'plain'},{text:_this11.numFormat(net_checked_area,'m²'),style:'plain'},{text:_this11.numFormat(net_adopted_area,'m²'),style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Enclosed_area'),style:'plain_bold'},{text:_this11.numFormat(enclosed_registry_area,'m²'),style:'plain'},{text:_this11.numFormat(enclosed_cadastral_area,'m²'),style:'plain'},{text:_this11.numFormat(enclosed_checked_area,'m²'),style:'plain'},{text:_this11.numFormat(enclosed_adopted_area,'m²'),style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Covered_outdoor_area'),style:'plain_bold'},{text:_this11.numFormat(covered_terraces_total_registry_area,'m²'),style:'plain'},{text:_this11.numFormat(covered_terraces_total_cadastral_area,'m²'),style:'plain'},{text:_this11.numFormat(covered_terraces_total_checked_area,'m²'),style:'plain'},{text:_this11.numFormat(covered_terraces_total_adopted_area,'m²'),style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Built_area'),style:'plain_bold'},{text:_this11.numFormat(built_registry_area,'m²'),style:'plain'},{text:_this11.numFormat(built_cadastral_area,'m²'),style:'plain'},{text:_this11.numFormat(built_checked_area,'m²'),style:'plain'},{text:_this11.numFormat(built_adopted_area,'m²'),style:'plain_bold'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Built_plus_common_elements_area'),style:'plain_bold'},{text:_this11.numFormat(built_plus_common_elements_registry_area,'m²'),style:'plain'},{text:_this11.numFormat(built_plus_common_elements_cadastral_area,'m²'),style:'plain'},{text:_this11.numFormat(built_plus_common_elements_checked_area,'m²'),style:'plain'},{text:_this11.numFormat(built_plus_common_elements_adopted_area,'m²'),style:'plain'}]]}},{text:'',pageBreak:'after'},// Systems
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 6. 10. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Systems').toUpperCase(),style:'h5_underline',margin:[40,1]// tocItem: 'appraisalTocSub' + i.toString()
}]]}},{layout:'noBorders',margin:[80,4],table:{headerRows:1,widths:[120,'*'],body:[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Door_opener'),style:'plain_bold'},{text:realestate_systems_door_opener,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Fitted_cupboards'),style:'plain_bold'},{text:realestate_systems_fitted_cupboards,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Gas'),style:'plain_bold'},{text:realestate_systems_gas,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Sanitary_fittings'),style:'plain_bold'},{text:realestate_systems_sanitary_fittings,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Taps'),style:'plain_bold'},{text:realestate_systems_taps,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Hot_water'),style:'plain_bold'},{text:realestate_systems_hot_water,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Heating'),style:'plain_bold'},{text:realestate_systems_heating,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Air_conditioning'),style:'plain_bold'},{text:realestate_systems_air_conditioning,style:'plain'}],[{text:'Tv',style:'plain_bold'},{text:realestate_systems_tv,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Telephone'),style:'plain_bold'},{text:realestate_systems_telephone,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Fire_prevention'),style:'plain_bold'},{text:realestate_systems_fire_prevention,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Intrusion_prevention'),style:'plain_bold'},{text:realestate_systems_intrusion_prevention,style:'plain'}]]}},{text:'',margin:[0,4]},// Systems
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 6. 11. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Age').toUpperCase()+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and').toUpperCase()+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('conservation_status').toUpperCase(),style:'h5_underline',margin:[40,1]// tocItem: 'appraisalTocSub' + i.toString()
}]]}},{layout:'noBorders',margin:[80,4],table:{headerRows:1,widths:[120,'*'],body:[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Construction_year'),style:'plain_bold'},{text:construction_year,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Last_renovation_year'),style:'plain_bold'},{text:last_renovation_year,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Adopted'),style:'plain_bold'},{text:adopted_age,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Appraisal_date'),style:'plain_bold'},{text:appraisaldate,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Adopted_age'),style:'plain_bold'},{text:adopted_age_years_old,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estates_total_useful_life'),style:'plain_bold'},{text:useful_life_years,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Remaining_useful_life_years'),style:'plain_bold'},{text:remaining_useful_life_years,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Conservation_status'),style:'plain_bold'},{text:conservation_status,style:'plain'}]]}},{text:'',margin:[0,4]},// Construction_cost
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 6. 12. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Construction_cost').toUpperCase(),style:'h5_underline',margin:[40,1]// tocItem: 'appraisalTocSub' + i.toString()
}]]}},{text:'',margin:[0,4]},{layout:'noBorders',margin:[80,4],table:{headerRows:1,widths:[120,240],body:[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Source').toUpperCase(),style:'plain_bold'},{text:'Boletín Económico de la Construcción (B.E.C.)',style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Property_type').toUpperCase(),style:'plain_bold'},{text:bec_property_type,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Bulletin_number').toUpperCase(),style:'plain_bold'},{text:bec_number,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Year').toUpperCase(),style:'plain_bold'},{text:bec_year,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quarter').toUpperCase(),style:'plain_bold'},{text:bec_quarter,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Construction_cost').toUpperCase(),style:'plain_bold'},{text:_this11.numFormat(adjusted_bec_price,'€/m²'),style:'plain'}],/*
                                                                            [
                                                                                {
                                                                                    text: Vue.i18n.translate('Expenses_and_industrial_benefit_bec_pct').toUpperCase(),
                                                                                    style: 'plain_bold'
                                                                                },
                                                                                {
                                                                                    text: this.numFormat(expenses_and_industrial_benefit_bec_pct, '%'),
                                                                                    style: 'plain'
                                                                                }
                                                                            ],
                                                                            */[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Material_execution_cost').toUpperCase(),style:'plain_bold'},{text:_this11.numFormat(adopted_material_execution_cost,'€/m²'),style:'plain_bold'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Notes').toUpperCase(),style:'plain_bold'},{text:construction_cost_notes,style:'plain'}]]}},{text:'',margin:[0,4]},// Construction_status
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 6. 13. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Construction_status').toUpperCase(),style:'h5_underline',margin:[40,1]// tocItem: 'appraisalTocSub' + i.toString()
}]]}},{text:'',margin:[0,4]},{layout:'noBorders',margin:[80,4],table:{headerRows:1,widths:[120,240],body:[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Construction_status').toUpperCase(),style:'plain_bold'},{text:construction_status,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Construction_progress_percentage').toUpperCase(),style:'plain_bold'},{text:total_construction_progress_pct,style:'plain'}]]}},{text:'',margin:[0,4]},{text:'',pageBreak:'after'},// Protection regime
{layout:'tocSectionLevel2',pageHeaderChapterText:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_rights_protection_and_occupation').toUpperCase(),pageHeaderRealEstateText:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 7. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_rights_protection_and_occupation').toUpperCase(),border:[false,false,false,true],style:'h5',margin:[0,1],tocItem:'appraisalTocSub'+i.toString()}]]}},{text:'',margin:[0,10]},{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 7. 1. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Protection_regime').toUpperCase(),style:'h5_underline',margin:[40,1]// tocItem: 'appraisalTocSub' + i.toString()
}]]}},{layout:'noBorders',margin:[80,4],table:{headerRows:1,widths:[120,240],body:protection_table}},{text:'',margin:[0,4]},// Occupancy
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 7. 2. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Occupancy').toUpperCase(),style:'h5_underline',margin:[40,1]// tocItem: 'appraisalTocSub' + i.toString()
}]]}},{layout:'noBorders',margin:[80,4],table:{headerRows:1,widths:[120,240],body:[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Property_title').toUpperCase(),style:'plain_bold'},{text:property_title,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Occupancy_status').toUpperCase(),style:'plain_bold'},{text:occupancy_status,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Usage_assigned_by_the_owner').toUpperCase(),style:'plain_bold'},{text:usage_assigned,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Inspection_realized').toUpperCase(),style:'plain_bold'},{text:inspection_realized,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Economical_activity').toUpperCase(),style:'plain_bold'},{text:economical_activity,style:'plain'}]]}},{text:'',margin:[0,4]},// Cession
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 7. 3. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cession').toUpperCase(),style:'h5_underline',margin:[40,1]// tocItem: 'appraisalTocSub' + i.toString()
}]]}},{layout:'noBorders',margin:[80,4],table:{headerRows:1,widths:[120,240],body:cession_table}},{text:'',margin:[0,4]},// Real_rights
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 7. 4. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_rights').toUpperCase(),style:'h5_underline',margin:[40,1]// tocItem: 'appraisalTocSub' + i.toString()
}]]}},{layout:'noBorders',margin:[80,4],table:{headerRows:1,widths:[120,240],body:right_of_use_table}});var tech_values_chapter_number='8';if(realestates[i].property_type.name_db!=='storage'){tech_values_chapter_number='9';docDefinition.content.push({text:'',pageBreak:'after'},{layout:'tocSectionLevel2',pageHeaderChapterText:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Market_study').toUpperCase(),pageHeaderRealEstateText:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 8. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Market_study').toUpperCase(),border:[false,false,false,true],style:'h5',margin:[0,1],tocItem:'appraisalTocSub'+i.toString()}]]}},{text:'',margin:[0,10]},// Market data
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 8. 1. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Market_data').toUpperCase(),style:'h5_underline',margin:[0,1]// tocItem: 'appraisalTocSub' + i.toString()
}]]}},{layout:'noBorders',margin:[0,4],table:{headerRows:0,widths:[480],body:comparables_table}},{text:'',margin:[0,4]},{text:'',pageBreak:'after'},// Market data
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 8. 2. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Market_analysis').toUpperCase(),style:'h5_underline',margin:[40,1]// tocItem: 'appraisalTocSub' + i.toString()
}]]}},{text:'',margin:[0,4]},// Offer
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 8. 2. 1. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Offer').toUpperCase(),style:'h5_underline',margin:[60,1]}]]}},{text:'',margin:[0,4]},{layout:'noBorders',margin:[80,4],table:{headerRows:0,widths:[180,'*'],body:[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Offer_production').toUpperCase(),style:'plain_bold'},{text:offer_production,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Offer_yearly_stock').toUpperCase(),style:'plain_bold'},{text:offer_yearly_stock,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Offer_trend').toUpperCase(),style:'plain_bold'},{text:offer_trend,style:'plain'}]]}},{text:'',margin:[0,4]},// Demand
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 8. 2. 2. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Demand').toUpperCase(),style:'h5_underline',margin:[60,1]}]]}},{text:'',margin:[0,4]},{layout:'noBorders',margin:[80,4],table:{headerRows:0,widths:[180,'*'],body:[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Demand_level').toUpperCase(),style:'plain_bold'},{text:demand_level,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Demand_speed_of_sales').toUpperCase(),style:'plain_bold'},{text:demand_speed_of_sales,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Demand_trend').toUpperCase(),style:'plain_bold'},{text:demand_trend,style:'plain'}]]}},{text:'',margin:[0,4]},// Current_prices
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 8. 2. 3. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Market_prices').toUpperCase(),style:'h5_underline',margin:[60,1]}]]}},{text:'',margin:[0,4]},{layout:'noBorders',margin:[80,4],table:{headerRows:0,widths:[180,'*'],body:[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Maximum').toUpperCase(),style:'plain_bold'},{text:prices_max,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Average').toUpperCase(),style:'plain_bold'},{text:prices_mean,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Median').toUpperCase(),style:'plain_bold'},{text:prices_median,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Minimum').toUpperCase(),style:'plain'},{text:prices_min,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Prices_estimated_yearly_evolution_pct').toUpperCase(),style:'plain_bold'},{text:prices_estimated_yearly_evolution_pct,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Prices_expectancy').toUpperCase(),style:'plain_bold'},{text:prices_expectancy,style:'plain'}]]}},{text:'',margin:[0,4]},// Expectation
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 8. 2. 4. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Expectation').toUpperCase(),style:'h5_underline',margin:[60,1]}]]}},{text:'',margin:[0,4]},{layout:'noBorders',margin:[80,4],table:{headerRows:0,widths:[180,'*'],body:[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Prices_past_cicles_volatility').toUpperCase(),style:'plain_bold'},{text:prices_past_cicles_volatility,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Market_conjuncture').toUpperCase(),style:'plain_bold'},{text:market_conjuncture,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Market_value_reduction_probability_expectancy').toUpperCase(),style:'plain_bold'},{text:market_value_reduction_probability_expectancy,style:'plain'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Market_value_evolution_probability_pct').toUpperCase(),style:'plain_bold'},{text:market_value_evolution_probability_pct,style:'plain'}]]}},{text:'',pageBreak:'after'},// Data Tabulation (Samples)
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 8. 3. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Data_tabulation').toUpperCase(),style:'h5_underline',margin:[40,1]// tocItem: 'appraisalTocSub' + i.toString()
}]]}},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Samples')+': ',style:'plain_bold',margin:[0,8]},{layout:'lightHorizontalLines',margin:[0,4],table:{headerRows:1,widths:[10,45,30,30,30,30,30,30,30,20,40,20],body:datatabulation_table}},// Data Tabulation (Appraised)
{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Appraised')+': ',style:'plain_bold',margin:[0,8]},{layout:'lightHorizontalLines',margin:[0,4],table:{headerRows:1,widths:[10,45,30,30,30,30,30,30,30,20,40,20],body:datatabulation_appraised_table}},{text:'',pageBreak:'after'},// Qualities comparison
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 8. 4. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Qualities_comparison').toUpperCase(),style:'h5_underline',margin:[40,1]// tocItem: 'appraisalTocSub' + i.toString()
}]]}},{text:'',margin:[0,4]},{layout:'lightHorizontalLines',margin:[0,4],table:{headerRows:1,widths:[10,35,35,35,35,35,35,35,35,35,35,35],body:qualities_comparison_table}},{text:'',margin:[0,8]},// Homogenisation of values
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 8. 5. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Homogenisation_of_values').toUpperCase(),style:'h5_underline',margin:[40,1]// tocItem: 'appraisalTocSub' + i.toString()
}]]}},{text:'',margin:[0,4]},{layout:'lightHorizontalLines',margin:[0,4],table:{headerRows:1,widths:[10,30,30,30,30,30,30,30,30,30,30,30,30],body:homogenisation_table}},{text:'',pageBreak:'after'},// Correction_of_values
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 8. 6. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Correction_of_values').toUpperCase(),style:'h5_underline',margin:[40,1]// tocItem: 'appraisalTocSub' + i.toString()
}]]}},{text:'',margin:[0,4]},{layout:'lightHorizontalLines',margin:[80,4],table:{headerRows:1,widths:[40,120,120,120],body:values_correction_table}},{text:'',margin:[0,4]},// Regression_line_calculation
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 8. 7. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Regression_line_calculation').toUpperCase(),style:'h5_underline',margin:[40,1]// tocItem: 'appraisalTocSub' + i.toString()
}]]}},{text:'',margin:[0,4]},{layout:'lightHorizontalLines',margin:[0,4],table:{headerRows:1,widths:[10,40,55,55,55,55,55,80],body:regression_calc_table}},{text:'',pageBreak:'after'},// Statistical deviations
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. 8. 12. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Statistical_deviations').toUpperCase(),style:'h5_underline',margin:[40,1]// tocItem: 'appraisalTocSub' + i.toString()
}]]}},{text:'',margin:[0,4]},{layout:'lightHorizontalLines',margin:[80,4],table:{headerRows:1,widths:[160,120,120],body:deviations_table}},{text:'',margin:[0,8]}// Regression line
/*
																																																														{
																																																															layout: 'noBorders',
																																																															table: {

																																																																headerRows: 0,
																																																																widths: ['*'],
																																																																body: [
																																																																	[
																																																																		{
																																																																			text: (i + 1 + 2).toString() + '. 8. 13. ' + Vue.i18n.translate('Regression_line').toUpperCase(),
																																																																			style: 'h5_underline',
																																																																			margin: [40, 1],
																																																																			// tocItem: 'appraisalTocSub' + i.toString()
																																																																		}
																																																																	]
																																																																]
																																																															}
																																																														}*/);}docDefinition.content.push({text:'',pageBreak:'after'},{layout:'tocSectionLevel2',pageHeaderChapterText:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Technical_values_calculation').toUpperCase(),pageHeaderRealEstateText:property_type+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('at')+' '+address_short,table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. '+tech_values_chapter_number+'. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Technical_values_calculation').toUpperCase(),border:[false,false,false,true],style:'h5',margin:[0,1],tocItem:'appraisalTocSub'+i.toString()}]]}},{text:'',margin:[0,10]},// Construction_cost_by_contract
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. '+tech_values_chapter_number+'. 1. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Construction_cost_by_contract').toUpperCase(),style:'h5_underline',margin:[60,1]}]]}},{text:'',margin:[0,4]},{layout:'lightHorizontalLines',margin:[80,4],table:{headerRows:1,widths:cc_by_contract_table_widths,body:cc_by_contract_table}},{text:'',margin:[0,8]},// Development_expenses
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. '+tech_values_chapter_number+'. 2. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Development_expenses').toUpperCase(),style:'h5_underline',margin:[60,1]}]]}},{text:'',margin:[0,4]},{layout:'lightHorizontalLines',margin:[80,4],table:{headerRows:1,widths:dev_expenses_table_widths,body:dev_expenses_table}},{text:'',margin:[0,8]},// Developers_benefit
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. '+tech_values_chapter_number+'. 3. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Developers_benefit').toUpperCase(),style:'h5_underline',margin:[60,1]}]]}},{text:'',margin:[0,4]},{layout:'lightHorizontalLines',margin:[80,4],table:{headerRows:1,widths:dev_benefit_table_widths,body:dev_benefit_table}},{text:'',pageBreak:'after'},// Land_market_value
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. '+tech_values_chapter_number+'. 4. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Land_market_value').toUpperCase(),style:'h5_underline',margin:[60,1]}]]}},{text:'',margin:[0,4]},{layout:'lightHorizontalLines',margin:[80,4],table:{headerRows:1,widths:land_mv_table_widths,body:land_mv_table}},{text:'',margin:[0,8]},// Gross_Replacement_Cost finished_building
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. '+tech_values_chapter_number+'. 5. '+'CRB: '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Gross_Replacement_Cost').toUpperCase()+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('finished_building').toUpperCase(),style:'h5_underline',margin:[60,1]}]]}},{text:'',margin:[0,4]},{layout:'lightHorizontalLines',margin:[80,4],table:{headerRows:1,widths:crb_fb_table_widths,body:crb_fb_table}},{text:'',margin:[0,8]},// Net_Replacement_Cost finished_building
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. '+tech_values_chapter_number+'. 6. '+'CRN: '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Net_Replacement_Cost').toUpperCase()+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('finished_building').toUpperCase(),style:'h5_underline',margin:[60,1]}]]}},{text:'',margin:[0,4]},{layout:'lightHorizontalLines',margin:[80,4],table:{headerRows:1,widths:crn_fb_table_widths,body:crn_fb_table}},{text:'',margin:[0,8]},// Net_Replacement_Cost real_estate_under_construction
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. '+tech_values_chapter_number+'. 7. '+'CRN: '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Net_Replacement_Cost').toUpperCase()+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('real_estate_under_construction').toUpperCase(),style:'h5_underline',margin:[60,1]}]]}},{text:'',margin:[0,4]},{layout:'lightHorizontalLines',margin:[80,4],table:{headerRows:1,widths:crn_ub_table_widths,body:crn_ub_table}},{text:'',margin:[0,8]},// Market_value
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(i+1+2).toString()+'. '+tech_values_chapter_number+'. 8. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Market_value').toUpperCase(),style:'h5_underline',margin:[60,1]}]]}},{text:'',margin:[0,4]},{layout:'lightHorizontalLines',margin:[80,4],table:{headerRows:1,widths:mv_table_widths,body:mv_table}},{text:'',margin:[0,8]},///// END OF ELEMENT BLOCK
{text:'',pageBreak:'after'});};for(var i=0;i<appraisals.length;i++){_loop(i);}land_value_repercussion_method_table.push([{text:'Total',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:_this11.numFormat(_this11.calcSum(repercussion_method_land_values),'€'),style:'small_bold'}]);construction_value_cost_method_crb_table.push([{text:'Total',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:_this11.numFormat(_this11.calcSum(cost_method_construction_crb_values),'€'),style:'small_bold'}]);construction_value_cost_method_crn_table.push([{text:'Total',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:_this11.numFormat(_this11.calcSum(cost_method_construction_crn_values),'€'),style:'small_bold'}]);realestate_value_cost_method_crb_table.push([{text:'Total',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:_this11.numFormat(_this11.calcSum(cost_method_realestate_crb_values),'€'),style:'small_bold'}]);realestate_value_cost_method_crn_table.push([{text:'Total',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:_this11.numFormat(_this11.calcSum(cost_method_realestate_crn_values),'€'),style:'small_bold'}]);unfinished_realestate_value_cost_method_crn_table.push([{text:'Total',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:_this11.numFormat(_this11.calcSum(cost_method_unfinished_realestate_crn_values),'€'),style:'small_bold'}]);realestate_value_comparison_method_table.push([{text:'Total',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:_this11.numFormat(_this11.calcSum(comparison_methods),'€'),style:'small_bold'}]);realestate_value_max_legal_method_table.push([{text:'Total',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:_this11.numFormat(_this11.calcSum(max_legal_methods),'€'),style:'small_bold'}]);insurance_value_table.push([{text:'Total',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:_this11.numFormat(_this11.calcSum(insurance_values),'€'),style:'small_bold'}]);insurance_value_table_rd_1982.push([{text:'Total',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:_this11.numFormat(_this11.calcSum(insurance_values_rd_1982),'€'),style:'small_bold'}]);insurance_value_table_rd_2009.push([{text:'Total',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:_this11.numFormat(_this11.calcSum(insurance_values_rd_2009),'€'),style:'small_bold'}]);appraisal_value_determination_table.push([{text:'Total',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:_this11.numFormat(_this11.calcSum(realestate_total_adopted_values),'€'),style:'small_bold'}]);appraisal_value_determination_table_min.push([{text:'Total',style:'small_bold'},{text:' ',style:'small_bold'},{text:_this11.numFormat(_this11.calcSum(realestate_total_adopted_values),'€'),style:'small_bold'}]);appraisal_value_determination_table_ceded.push([{text:'Total',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:_this11.numFormat(_this11.calcSum(realestate_total_adopted_values),'€'),style:'small_bold'}]);appraisal_value_determination_table_ceded_eco.push([{text:'Total',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:_this11.numFormat(_this11.calcSum(realestate_total_adopted_values),'€'),style:'small_bold'}]);appraisal_value_determination_table_eco.push([{text:'Total',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:_this11.numFormat(_this11.calcSum(realestate_total_adopted_values),'€'),style:'small_bold'}]);appraisal_value_determination_table_eco_protected.push([{text:'Total',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:_this11.numFormat(_this11.calcSum(realestate_total_adopted_values),'€'),style:'small_bold'}]);appraisal_value_determination_table_protected.push([{text:'Total',style:'small_bold'},{text:'',style:'small_bold'},{text:'',style:'small_bold'},{text:_this11.numFormat(_this11.calcSum(realestate_total_adopted_values),'€'),style:'small_bold'}]);final_appraisal_value_table.push([{border:[false,true,false,false],hLineWidth:6,fillColor:'#dddddd',text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Appraisal_value').toUpperCase()+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('with_date').toUpperCase()+': '+appraisaldate,style:'plain_bold_center',margin:[0,4,0,2]}]);final_appraisal_value_table.push([{border:[false,false,false,true],fillColor:'#dddddd',hLineWidth:3,text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Appraisal_purpose').toUpperCase()+': '+appraisal_purpose,style:'plain_bold_center',margin:[0,2,0,4]}]);final_appraisal_value_str=_this11.numFormat(_this11.calcSum(realestate_total_adopted_values),'€'),final_appraisal_value_table.push([{border:[false,false,false,false],fillColor:'#dddddd',hLineWidth:6,text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Total_value').toUpperCase()+': '+_this11.numFormat(_this11.calcSum(realestate_total_adopted_values),'€'),style:'h2_center',margin:[0,8,0,8]}]);/* TODO: quina data de valor estem agafant? la de la última taxació? revisar i avisar de que no siguin diferents!! idem amb la finalitat*/final_values_table.push([{border:[false,false,false,true],fillColor:'#dddddd',hLineWidth:3,text:'',style:'small_bold'},{border:[false,false,false,true],fillColor:'#dddddd',hLineWidth:3,text:'',style:'small_bold'}]);docDefinition.content.push(// Total_values_calculation
{layout:'noBorders',pageHeaderChapterText:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Total_values_calculation').toUpperCase(),pageHeaderRealEstateText:' ',table:{headerRows:0,widths:['*'],body:[[{text:(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(appraisals)+2+1).toString()+'. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Total_values_calculation').toUpperCase(),style:'h5_underline',margin:[0,1],tocItem:'mainTocB'}]]}},{text:'',margin:[0,4]},// Land value
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(appraisals)+2+1).toString()+'. 1. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Land_value').toUpperCase(),style:'h5_underline',margin:[40,1]}]]}},{text:'',margin:[0,4]},// Repercussion method
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(appraisals)+2+1).toString()+'. 1. 1. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Repercussion_method').toUpperCase(),style:'h5_underline',margin:[60,1]}]]}},{text:'',margin:[0,4]},{layout:'lightHorizontalLines',margin:[60,4],table:{headerRows:1,widths:land_value_repercussion_method_table_widths,body:land_value_repercussion_method_table}},{text:'',margin:[0,8]},// Construction value
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(appraisals)+2+1).toString()+'. 2. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Construction_value').toUpperCase(),style:'h5_underline',margin:[40,1]}]]}},{text:'',margin:[0,4]},// Cost method
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(appraisals)+2+1).toString()+'. 2. 1. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cost_method').toUpperCase(),style:'h5_underline',margin:[60,1]}]]}},{text:'',margin:[0,4]},// CRB
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(appraisals)+2+1).toString()+'. 2. 1. 1. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Gross_Replacement_Cost').toUpperCase()+' (CRB)',style:'h5_underline',margin:[60,1]}]]}},{text:'',margin:[0,4]},{layout:'lightHorizontalLines',margin:[60,4],table:{headerRows:1,widths:construction_value_cost_method_crb_table_widths,body:construction_value_cost_method_crb_table}},{text:'',margin:[0,8]},// CRN
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(appraisals)+2+1).toString()+'. 2. 1. 2. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Net_Replacement_Cost').toUpperCase()+' (CRN)',style:'h5_underline',margin:[60,1]}]]}},{text:'',margin:[0,4]},{layout:'lightHorizontalLines',margin:[60,4],table:{headerRows:1,widths:construction_value_cost_method_crn_table_widths,body:construction_value_cost_method_crn_table}},{text:'',pageBreak:'after'},// Real Estate value (construction + land)
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(appraisals)+2+1).toString()+'. 3. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estate_value').toUpperCase()+' ('+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Construction').toUpperCase()+' + '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Land').toUpperCase()+')',style:'h5_underline',margin:[40,1]}]]}},{text:'',margin:[0,4]},// Cost method
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(appraisals)+2+1).toString()+'. 3. 1. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cost_method').toUpperCase(),style:'h5_underline',margin:[60,1]}]]}},{text:'',margin:[0,4]},// CRB
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(appraisals)+2+1).toString()+'. 3. 1. 1. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Gross_Replacement_Cost').toUpperCase()+' (CRB)',style:'h5_underline',margin:[60,1]}]]}},{text:'',margin:[0,4]},{layout:'lightHorizontalLines',margin:[60,4],table:{headerRows:1,widths:realestate_value_cost_method_crb_table_widths,body:realestate_value_cost_method_crb_table}},{text:'',margin:[0,8]},// CRN (immoble acabat)
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(appraisals)+2+1).toString()+'. 3. 1. 2. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Net_Replacement_Cost').toUpperCase()+' ('+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('finished_building').toUpperCase()+') '+' (CRN)',style:'h5_underline',margin:[60,1]}]]}},{text:'',margin:[0,4]},{layout:'lightHorizontalLines',margin:[60,4],table:{headerRows:1,widths:realestate_value_cost_method_crn_table_widths,body:realestate_value_cost_method_crn_table}},{text:'',margin:[0,8]});if(any_is_under_construction){docDefinition.content.push(// CRN (immoble en construcció)
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(appraisals)+2+1).toString()+'. 3. 1. 3. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Net_Replacement_Cost').toUpperCase()+' ('+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('real_estate_under_construction').toUpperCase()+') '+' (CRN)',style:'h5_underline',margin:[60,1]}]]}},{text:'',margin:[0,4]},{layout:'lightHorizontalLines',margin:[60,4],table:{headerRows:1,widths:unfinished_realestate_value_cost_method_crn_table_widths,body:unfinished_realestate_value_cost_method_crn_table}},{text:'',margin:[0,8]});}docDefinition.content.push(// Comparison method
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(appraisals)+2+1).toString()+'. 3. 2. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Comparison_Method').toUpperCase(),style:'h5_underline',margin:[60,1]}]]}},{text:'',margin:[0,4]},{layout:'lightHorizontalLines',margin:[60,4],table:{headerRows:1,widths:realestate_value_comparison_method_table_widths,body:realestate_value_comparison_method_table}});if(any_is_protected){docDefinition.content.push(// Max legal method
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(appraisals)+2+1).toString()+'. 3. 3. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Maximum_Legal_Method').toUpperCase(),style:'h5_underline',margin:[60,1]}]]}},{text:'',margin:[0,4]},{layout:'lightHorizontalLines',margin:[60,4],table:{headerRows:1,widths:realestate_value_max_legal_method_table_widths,body:realestate_value_max_legal_method_table}},{text:'',margin:[0,8]});}var notes_default=[];var word='';if(_this11.currentLocale==='ca'){word='NO';}else if(_this11.currentLocale==='en'){word='IS NOT';}else{word='NO';}if(any_is_eco===true){if(_this11.currentLocale==='ca'){word='SÍ';}else if(_this11.currentLocale==='en'){word='IS';}else{word='SÍ';}}if(_this11.currentLocale==='ca'){notes_default.push([{text:'Aquesta taxació s\'ha realitzat d\'acord amb els requisits recollits a l\'Ordre ECO-805-2003 DE 27 DE MARÇ del Ministeri d\'Economia i Hisenda, sobre Valoració de Béns per a determinades entitats financeres, excepte pel que fa al que assenyala l\'apartat condicionants i advertiments generals.',style:'plain',margin:[10,4]}]);notes_default.push([{text:'La present taxació '+word+' és vàlida a efectes de constituir garanties hipotecàries, de provisions de fons de les companyies d\'assegurances i de fons d\'inversió Immobiliàries.',style:'plain',margin:[10,4]}]);notes_default.push([{text:'Aquesta taxació té una validesa de SIS mesos a partir de la data de la seva expedició.',style:'plain',margin:[10,4]}]);notes_default.push([{text:'Tant BARNA-TASA, S.A. Com els professionals que hem intervingut en l\'elaboració del present informe de taxació, declarem que coneixem i hem tingut en consideració de manera estricta i fidel les incompatibilitats establertes en els articles 6 i 13 del Reial decret 775/1997 de 30 de maig, referents tant a la Societat com als seus professionals i així ho subscrivim.',style:'plain',margin:[10,4]}]);notes_default.push([{text:'El valor de taxació expressat és el que resulta tenint en compte l\'objecte i finalitat de la valoració.',style:'plain',margin:[10,4]}]);notes_default.push([{text:'La taxació s\'ha efectuat suposada la finca lliure de càrregues i gravàmens.',style:'plain',margin:[10,4]}]);}else if(_this11.currentLocale==='en'){notes_default.push([{text:'This appraisal has been realized according to the ECO-805-2003 fromn 27th March regukations.',style:'plain',margin:[10,4]}]);notes_default.push([{text:'This valuation report  '+word+'  valid for the purpose of constituting guarantees for mortgage loans, provision of funds from insurance companies and real estate investment funds.',style:'plain',margin:[10,4]}]);notes_default.push([{text:'This appraisal is valid for SIX months from the date of issue.',style:'plain',margin:[10,4]}]);notes_default.push([{text:'Both BARNA-TASA, S.A. and the professionals who have been involved in the preparation of the valuation report, we declare that we know and have in consideration strictly and faithfully the incompatibilities established in articles 6 and 13 of Royal Decree 775/1997 of 30 May, concerning both the Company and its professionals and thus subscribe them.',style:'plain',margin:[10,4]}]);notes_default.push([{text:'The appraisal value is expressed considering the scope and purpose of the valuation.',style:'plain',margin:[10,4]}]);notes_default.push([{text:'The valuation has been made considering the property is free of charges and liens.',style:'plain',margin:[10,4]}]);}else{notes_default.push([{text:'Esta tasación se ha realizado de acuerdo con los requisitos recogidos en la Orden ECO-805-2003 DE 27 DE MARZO del Ministerio de Economía y Hacienda, sobre Valoración de Bienes para determinadas entidades financieras, excepto en cuanto a lo que señala el apartado condicionantes y advertencias.',style:'plain',margin:[10,4]}]);notes_default.push([{text:'La presente tasación '+word+' es válida a efectos de constituir garantías hipotecarias, de provisiones de fondos de las compañías de seguros y de fondos de inversión Inmobiliarias.',style:'plain',margin:[10,4]}]);notes_default.push([{text:'Esta tasación tiene una validez de SEIS meses a partir de la fecha de su expedición.',style:'plain',margin:[10,4]}]);notes_default.push([{text:'Tanto BARNA-TASA, S.A. Como los profesionales que hemos intervenido en la elaboración del presente informe de tasación, declaramos que conocemos y hemos tenido en consideración de manera estricta y fiel las incompatibilidades establecidas en los artículos 6 y 13 del Real Decreto 775/1997 de 30 de mayo, referentes tanto a la Sociedad como a sus profesionales y así lo suscribimos.',style:'plain',margin:[10,4]}]);notes_default.push([{text:'El valor de tasación expresado es el que resulta teniendo en cuenta el objeto y finalidad de la valoración.',style:'plain',margin:[10,4]}]);notes_default.push([{text:'La tasación se ha efectuado supuesta la finca libre de cargas y gravámenes.',style:'plain',margin:[10,4]}]);}console.log('constraints_table: ');console.log(constraints_table);if(any_is_ceded){docDefinition.content.push(// Max legal method
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(appraisals)+2+1).toString()+'. 3. 4. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Expected_Income_Update_Method').toUpperCase(),style:'h5_underline',margin:[60,1]}]]}},{text:'',margin:[0,4]},{layout:'lightHorizontalLines',margin:[0,4],table:{headerRows:1,widths:contract_foreseeable_remaining_period_table_widths,body:contract_foreseeable_remaining_period_table}},{text:'',margin:[0,8]},{text:'',margin:[0,4]},{layout:'lightHorizontalLines',margin:[0,4],table:{headerRows:1,widths:real_estates_residual_value_table_widths,body:real_estates_residual_value_table}},{text:'',margin:[0,8]},{layout:'lightHorizontalLines',margin:[0,4],table:{headerRows:1,widths:current_value_of_future_rents_table_widths,body:current_value_of_future_rents_table}},{text:'',margin:[0,8]},{layout:'lightHorizontalLines',margin:[0,4],table:{headerRows:1,widths:current_reversion_value_table_widths,body:current_reversion_value_table}},{text:'',margin:[0,8]},{layout:'lightHorizontalLines',margin:[0,4],table:{headerRows:1,widths:update_value_table_widths,body:update_value_table}},{text:'',margin:[0,8]});}docDefinition.content.push({text:'',pageBreak:'after'},// Other values
{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(appraisals)+2+1).toString()+'. 4. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Other_values').toUpperCase(),style:'h5_underline',margin:[0,1]}]]}},{text:'',margin:[0,4]});var other_values_counter=1;if(any_has_right_of_use_ceded){docDefinition.content.push({layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(appraisals)+2+1).toString()+'. 4. '+other_values_counter.toString()+'. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Right_of_use_value').toUpperCase(),style:'h5_underline',margin:[0,1]}]]}},{text:'',margin:[0,4]},{layout:'lightHorizontalLines',margin:[0,4],table:{headerRows:1,widths:right_of_use_value_table_widths,body:right_of_use_value_table}},{text:'',margin:[0,4]});other_values_counter=other_values_counter+1;}docDefinition.content.push({layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(appraisals)+2+1).toString()+'. 4. '+other_values_counter.toString()+'. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Insurance_value').toUpperCase(),style:'h5_underline',margin:[0,1]}]]}},{text:'',margin:[0,4]},{text:(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(appraisals)+2+1).toString()+'. 4. '+other_values_counter.toString()+'. 1. '+'Valor s/ R. D. 685/1982:',style:'h5_underline',margin:[0,1]},{text:'',margin:[0,4]},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Insurance_value_rd_1982_text')+':',style:'small',margin:[0,4]},{text:'',margin:[0,2]},{layout:'lightHorizontalLines',margin:[0,4],table:{headerRows:1,widths:insurance_value_table_widths,body:insurance_value_table_rd_1982}},{text:'',margin:[0,4]},{text:(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(appraisals)+2+1).toString()+'. 4. '+other_values_counter.toString()+'. 2. '+'Valor s/ R. D. 246/1998, 716/2009:',style:'h5_underline',margin:[0,1]},{text:'',margin:[0,4]},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Insurance_value_rd_2009_text')+':',style:'small',margin:[0,4]},{text:'',margin:[0,2]},{layout:'lightHorizontalLines',margin:[0,4],table:{headerRows:1,widths:insurance_value_table_widths,body:insurance_value_table_rd_2009}},{text:'',margin:[0,8]},{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(appraisals)+2+1).toString()+'. 5. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Appraisal_total_value_determination').toUpperCase(),style:'h5_underline',margin:[0,1]}]]}},{text:'',margin:[0,4]},{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Appraisal_value_determination_text'),style:'small',margin:[0,4]},{text:'',margin:[0,4]});console.log('hey dt');if(any_is_ceded){console.log('dt 1.');if(any_is_eco){console.log('dt 1.1');if(any_is_protected){console.log('dt 1.1.1.');docDefinition.content.push({layout:'lightHorizontalLines',margin:[0,4],table:{headerRows:1,widths:appraisal_value_determination_table_widths,body:appraisal_value_determination_table}});}else{console.log('dt 1.1.2.');docDefinition.content.push({layout:'lightHorizontalLines',margin:[0,4],table:{headerRows:1,widths:appraisal_value_determination_table_ceded_eco_widths,body:appraisal_value_determination_table_ceded_eco}});}}else{console.log('dt 1.2.');docDefinition.content.push({layout:'lightHorizontalLines',margin:[0,4],table:{headerRows:1,widths:appraisal_value_determination_table_ceded_widths,body:appraisal_value_determination_table_ceded}});}}else{console.log('dt 2.');if(any_is_eco){console.log('dt 2.1.');if(any_is_protected){console.log('dt 2.1.1.');docDefinition.content.push({layout:'lightHorizontalLines',margin:[0,4],table:{headerRows:1,widths:appraisal_value_determination_table_eco_protected_widths,body:appraisal_value_determination_table_eco_protected}});}else{console.log('dt 2.1.2.');docDefinition.content.push({layout:'lightHorizontalLines',margin:[0,4],table:{headerRows:1,widths:appraisal_value_determination_table_eco_widths,body:appraisal_value_determination_table_eco}});}}else{console.log('dt 2.2.');if(any_is_protected){console.log('dt 2.2.1.');docDefinition.content.push({layout:'lightHorizontalLines',margin:[0,4],table:{headerRows:1,widths:appraisal_value_determination_table_protected_widths,body:appraisal_value_determination_table_protected}});}else{if(any_is_under_construction){console.log('dt 2.2.2.1.');docDefinition.content.push({layout:'lightHorizontalLines',margin:[0,4],table:{headerRows:1,widths:appraisal_value_determination_table_under_construction_widths,body:appraisal_value_determination_table_under_construction}});}else{console.log('dt 2.2.2.2.');console.log('appraisal_value_determination_table_min: ');console.log(appraisal_value_determination_table_min);docDefinition.content.push({layout:'lightHorizontalLines',margin:[0,4],table:{headerRows:1,widths:appraisal_value_determination_table_min_widths,body:appraisal_value_determination_table_min}});}}}}docDefinition.content.push({text:'',margin:[0,8]},//////// PAGE BREAK
{text:'',pageBreak:'after'},{layout:'noBorders',pageHeaderChapterText:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Constraints').toUpperCase(),pageHeaderRealEstateText:' ',table:{headerRows:0,widths:['*'],body:[[{text:(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(appraisals)+3+1).toString()+'. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Constraints').toUpperCase(),style:'h5_underline',margin:[0,1],tocItem:'mainTocB'}]]}},{text:'',margin:[0,8]},{layout:'lightHorizontalLines',margin:[0,4],table:{headerRows:0,widths:[480],body:[constraints_table]}},{text:'',margin:[0,8]},{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(appraisals)+4+1).toString()+'. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Warnings').toUpperCase(),style:'h5_underline',margin:[0,1],tocItem:'mainTocB'}]]}},{text:'',margin:[0,8]},{layout:'lightHorizontalLines',margin:[0,4],table:{headerRows:0,widths:[480],body:[warnings_table]}},{text:'',margin:[0,8]},{layout:'noBorders',table:{headerRows:0,widths:[480],body:[[{text:(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(appraisals)+5+1).toString()+'. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Notes').toUpperCase(),style:'h5_underline',margin:[0,1],tocItem:'mainTocB'}]]}},{text:'',margin:[0,8]},{layout:'noBorders',margin:[0,4],table:{headerRows:0,widths:['*'],body:notes_default}});if(any_notes){docDefinition.content.push({text:'',margin:[0,8]},{layout:'lightHorizontalLines',margin:[0,4],table:{headerRows:0,widths:['*'],body:[notes_table]}});}docDefinition.content.push(//////// PAGE BREAK
{text:'',pageBreak:'after'},{layout:'noBorders',pageHeaderChapterText:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Appraisal_value').toUpperCase(),pageHeaderRealEstateText:' ',table:{headerRows:0,widths:[480],body:[[{text:(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(appraisals)+6+1).toString()+'. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Appraisal_value').toUpperCase(),style:'h5_underline',margin:[0,1],tocItem:'mainTocB'}]]}},{text:'',margin:[0,8]},{layout:'noBorders',margin:[0,4],table:{headerRows:1,widths:final_id_table_widths,body:final_id_table}},{text:'',margin:[0,12]},{// layout: 'noBorders',
margin:[0,0],table:{headerRows:1,widths:final_appraisal_value_table_widths,body:final_appraisal_value_table}},{// layout: 'noBorders',
margin:[0,0],table:{headerRows:1,widths:final_values_table_widths,body:final_values_table}},{text:'',margin:[0,12]},{layout:'noBorders',table:{headerRows:0,widths:[480],body:[[{text:(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(appraisals)+7+1).toString()+'. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Date_of_issue').toUpperCase()+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and').toUpperCase()+' '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Signatures').toUpperCase(),style:'h5_underline',margin:[0,1],tocItem:'mainTocB'}]]}},{layout:'noBorders',margin:[0,4],table:{headerRows:1,widths:date_of_issue_table_widths,body:date_of_issue_table}},{layout:'noBorders',margin:[0,4],table:{headerRows:1,widths:visit_table_widths,body:visit_table}},/*
																																																												{
																																																													text: '',
																																																													margin: [0, 8]
																																																												},
																																																												{
																																																													text: Vue.i18n.translate('Report_of') + ' ' + Vue.i18n.translate('correlated_pages_numbered_from') + ' 1 ' + Vue.i18n.translate('to') + ' ',
																																																													style: 'plain',
																																																													margin: [0, 4]
																																																												},
																																																												*/{text:'',margin:[0,8]},{layout:'noBorders',margin:[0,4],table:{headerRows:1,widths:signatures_table_widths,body:signatures_table}},{text:'',pageBreak:'after'},{layout:'noBorders',pageHeaderChapterText:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Annexed_documents').toUpperCase(),pageHeaderRealEstateText:' ',table:{headerRows:0,widths:[480],body:[[{text:(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(appraisals)+8+1).toString()+'. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Annexed_documents').toUpperCase(),style:'h3',margin:[0,1],tocItem:'mainTocB'}]]}},{toc:{id:'annexTocSubEnd',textMargin:[20,0,10,0],textStyle:'plain',numberStyle:'plain_bold'}},{text:'',pageBreak:'after'});var annex_counter=0;// content_map_google_01
if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(content_map_google_01)>0||__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(content_map_google_02)>0||__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(content_map_google_03)>0){annex_counter+=1;docDefinition.content.push({layout:'noBorders',table:{headerRows:0,widths:[480],body:[[{text:(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(appraisals)+8+1).toString()+'. '+annex_counter.toString()+'. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Situation_maps').toUpperCase(),style:'h5',margin:[0,1],tocItem:['annexTocSub','annexTocSubEnd']}]]}},{text:'',pageBreak:'after'});if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(content_map_google_01)>0){docDefinition.content.push(content_map_google_01);docDefinition.content.push({text:'',pageBreak:'after'});}if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(content_map_google_02)>0){docDefinition.content.push(content_map_google_02);docDefinition.content.push({text:'',pageBreak:'after'});}if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(content_map_google_03)>0){docDefinition.content.push(content_map_google_03);docDefinition.content.push({text:'',pageBreak:'after'});}}else{appraisalreport_review_table.push([{text:'Informe',style:'plain_bold'},{text:'Documentació Annexa: manquen els mapes d\'emplaçament',style:'plain',alignment:'left'}]);}if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(content_photo_annexes)>0){annex_counter+=1;docDefinition.content.push({layout:'noBorders',table:{headerRows:0,widths:[480],body:[[{text:(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(appraisals)+8+1).toString()+'. '+annex_counter.toString()+'. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Photographic_report').toUpperCase(),style:'h5',margin:[0,1],tocItem:['annexTocSub','annexTocSubEnd']}]]}},{text:'',pageBreak:'after'});docDefinition.content.push(content_photo_annexes);docDefinition.content.push({text:'',pageBreak:'after'});}else{appraisalreport_review_table.push([{text:'Informe',style:'plain_bold'},{text:'Documentació Annexa: manca el reportatge fotogràfic',style:'plain',alignment:'left'}]);}if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(content_registryannex)>0){annex_counter+=1;docDefinition.content.push({layout:'noBorders',table:{headerRows:0,widths:[480],body:[[{text:(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(appraisals)+8+1).toString()+'. '+annex_counter.toString()+'. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Registry_Documents').toUpperCase(),style:'h5',margin:[0,1],tocItem:['annexTocSub','annexTocSubEnd']}]]}},{text:'',pageBreak:'after'});docDefinition.content.push(content_registryannex);docDefinition.content.push({text:'',pageBreak:'after'});}else{appraisalreport_review_table.push([{text:'Informe',style:'plain_bold'},{text:'Documentació Annexa: manca la documentació registral',style:'plain',alignment:'left'}]);}if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(content_cadasterannex)>0){annex_counter+=1;docDefinition.content.push({layout:'noBorders',table:{headerRows:0,widths:[480],body:[[{text:(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(appraisals)+8+1).toString()+'. '+annex_counter.toString()+'. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cadastral_Documents').toUpperCase(),style:'h5',margin:[0,1],tocItem:['annexTocSub','annexTocSubEnd']}]]}},{text:'',pageBreak:'after'});docDefinition.content.push(content_cadasterannex);docDefinition.content.push({text:'',pageBreak:'after'});}else{appraisalreport_review_table.push([{text:'Informe',style:'plain_bold'},{text:'Documentació Annexa: manca la documentació cadastral',style:'plain',alignment:'left'}]);}if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(content_urbanannex)>0){annex_counter+=1;docDefinition.content.push({layout:'noBorders',table:{headerRows:0,widths:[480],body:[[{text:(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(appraisals)+8+1).toString()+'. '+annex_counter.toString()+'. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Urban_Planning_Documents').toUpperCase(),style:'h5',margin:[0,1],tocItem:['annexTocSub','annexTocSubEnd']}]]}},{text:'',pageBreak:'after'});docDefinition.content.push(content_urbanannex);docDefinition.content.push({text:'',pageBreak:'after'});}else{appraisalreport_review_table.push([{text:'Informe',style:'plain_bold'},{text:'Documentació Annexa: manca la documentació urbanística',style:'plain',alignment:'left'}]);}if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(content_planannex)>0){annex_counter+=1;docDefinition.content.push({layout:'noBorders',table:{headerRows:0,widths:[480],body:[[{text:(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(appraisals)+8+1).toString()+'. '+annex_counter.toString()+'. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Plans').toUpperCase(),style:'h5',margin:[0,1],tocItem:['annexTocSub','annexTocSubEnd']}]]}},{text:'',pageBreak:'after'});docDefinition.content.push(content_planannex);docDefinition.content.push({text:'',pageBreak:'after'});}else{appraisalreport_review_table.push([{text:'Informe',style:'plain_bold'},{text:'Documentació Annexa: manca el croquis o plànol',style:'plain',alignment:'left'}]);}if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(content_cessionannex)>0){annex_counter+=1;docDefinition.content.push({layout:'noBorders',table:{headerRows:0,widths:[480],body:[[{text:(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(appraisals)+8+1).toString()+'. '+annex_counter.toString()+'. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cession_files').toUpperCase(),style:'h5',margin:[0,1],tocItem:['annexTocSub','annexTocSubEnd']}]]}},{text:'',pageBreak:'after'});docDefinition.content.push(content_cessionannex);docDefinition.content.push({text:'',pageBreak:'after'});}else{if(any_is_ceded){appraisalreport_review_table.push([{text:'Informe',style:'plain_bold'},{text:'Documentació Annexa: manca la documentació de cessió o lloguer',style:'plain',alignment:'left'}]);}}if(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(content_otherannex)>0){annex_counter+=1;docDefinition.content.push({layout:'noBorders',table:{headerRows:0,widths:[480],body:[[{text:(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(appraisals)+8+1).toString()+'. '+annex_counter.toString()+'. '+__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Other_files').toUpperCase(),style:'h5',margin:[0,1],tocItem:['annexTocSub','annexTocSubEnd']}]]}},{text:'',pageBreak:'after'});docDefinition.content.push(content_otherannex);docDefinition.content.push({text:'',pageBreak:'after'});}//////// Check empty review tables
var no_error_text='Sense errors detectats.';if(realestate_review_table.length===0){realestate_review_table=[[{text:no_error_text,style:'plain'}]];}if(comparable_review_table.length===0){comparable_review_table=[[{text:no_error_text,style:'plain'}]];}if(marketstudy_review_table.length===0){marketstudy_review_table=[[{text:no_error_text,style:'plain'}]];}if(appraisal_review_table.length===0){appraisal_review_table=[[{text:no_error_text,style:'plain'}]];}if(appraisalfile_review_table.length===0){appraisalfile_review_table=[[{text:no_error_text,style:'plain'}]];}if(appraisalreport_review_table.length===0){appraisalreport_review_table=[[{text:no_error_text,style:'plain'}]];}if(certificate_review_table.length===0){certificate_review_table=[[{text:no_error_text,style:'plain'}]];}certificate_content_obj.table.body.push([{text:'',style:'plain',margin:[0,30],border:[true,false,true,false]}],[{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Total_appraisal_value').toUpperCase()+':  '+final_appraisal_value_str,//border: [true, true, true, true],
//fillColor: 'whitesmoke',
style:'h2',margin:[30,10],alignment:'center'}]]}}],[{text:'',border:[true,false,true,false],style:'plain',margin:[30,30],alignment:'center'}]);if(any_constraints){certificate_content_obj.table.body.push([{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Constraints').toUpperCase(),border:[true,false,true,false],style:'plain',margin:[30,20],alignment:'center'}]]}}],[{text:'',margin:[0,8]}],[{layout:'lightHorizontalLines',margin:[0,4],table:{headerRows:0,widths:[480],body:[constraints_table]}}]);}if(any_warnings){certificate_content_obj.table.body.push([{layout:'noBorders',table:{headerRows:0,widths:['*'],body:[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Warnings').toUpperCase(),border:[true,false,true,false],style:'plain',margin:[30,20],alignment:'center'}]]}}],[{text:'',border:[true,false,true,false],margin:[0,8]}],[{layout:'lightHorizontalLines',margin:[0,4],table:{headerRows:0,widths:[480],body:[warnings_table]}}]);}certificate_content_obj.table.body.push([{text:'',border:[true,false,true,true],pageBreak:'before',margin:[0,0]}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Notes').toUpperCase(),border:[true,false,true,false],style:'plain',margin:[30,20],alignment:'center'}],[{layout:'noBorders',margin:[10,4],table:{headerRows:0,widths:['*'],body:notes_default}}],[{layout:'noBorders',margin:[0,4],table:{headerRows:0,widths:['*'],body:[[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Report_date')+': '+reportdate,style:'plain_bold',margin:[20,0],alignment:'left'}],[{text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Certificate_text_05')+__WEBPACK_IMPORTED_MODULE_3_moment___default()().format('LLLL')+'.',style:'plain',margin:[20,0],alignment:'left'}],[{image:_this11.appraisalreport.signature_sv_base64?_this11.appraisalreport.signature_sv_base64:'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAIBAQIBAQICAgICAgICAwUDAwMDAwYEBAMFBwYHBwcGBwcICQsJCAgKCAcHCg0KCgsMDAwMBwkODw0MDgsMDAz/2wBDAQICAgMDAwYDAwYMCAcIDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAz/wAARCAABAAEDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD9/KKKKAP/2Q==',width:140,margin:[20,4]}],[{text:supervisor_name+' '+supervisor_surnames,style:'plain_bold',margin:[20,0],alignment:'left'}],[{text:supervisor_title,style:'plain',margin:[20,0],alignment:'left'}],[{text:supervisor_position,style:'plain',margin:[20,0],alignment:'left'}]]}}]);certificateDefinition.content.push({layout:'width1',table:{headerRows:0,widths:['*'],body:[[{fillColor:'whitesmoke',text:__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Appraisal_certificate').toUpperCase(),border:[false,true,false,true],style:'h1',margin:[0,4],alignment:'center'}]]}},certificate_content_obj);//////// End of check empty review tables
var reviewDocDefinition={// settings
pageSize:'A4',pageOrientation:'portrait',// [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
pageMargins:[40,40,20,20],// metadata
info:{title:'BARNA-TASA, S.A.',author:'BARNA-TASA, S.A.',subject:'BARNA-TASA, S.A.',keywords:'BARNA-TASA, S.A.',creator:'BARNA-TASA, S.A.',producer:'BARNA-TASA, S.A.'},styles:{small:{fontSize:8,bold:false},small_bold:{fontSize:8,bold:true},plain:{fontSize:9,bold:false},plain_bold:{fontSize:9,bold:true},h2:{fontSize:16,bold:true},h3:{fontSize:12,bold:true}},// content
content:[{text:'Informe automàtic de revisió de taxació/certificat',style:'h2'},{text:'',margin:[0,15]},//// END OF BLOCK
//// BLOCK START
{text:'',margin:[0,10]},{text:'Expedient:',style:'h3'},{text:'',margin:[0,5]},{layout:'noBorders',margin:[50,0],table:{headerRows:0,widths:[160,'*'],body:appraisalfile_review_table}},//// END OF BLOCK
//// BLOCK START
{text:'',margin:[0,10]},{text:'Informe:',style:'h3'},{text:'',margin:[0,5]},{layout:'noBorders',margin:[50,0],table:{headerRows:0,widths:[160,'*'],body:appraisalreport_review_table}},//// END OF BLOCK
//// BLOCK START
{text:'',margin:[0,10]},{text:'Immobles:',style:'h3'},{text:'',margin:[0,5]},{layout:'noBorders',margin:[50,0],table:{headerRows:0,widths:[160,'*'],body:realestate_review_table}},//// END OF BLOCK
//// BLOCK START
{text:'',margin:[0,10]},{text:'Comparables:',style:'h3'},{text:'',margin:[0,5]},{layout:'noBorders',margin:[50,0],table:{headerRows:0,widths:[160,'*'],body:comparable_review_table}},//// END OF BLOCK
//// BLOCK START
{text:'',margin:[0,10]},{text:'Estudis de Mercat:',style:'h3'},{text:'',margin:[0,5]},{layout:'noBorders',margin:[50,0],table:{headerRows:0,widths:[160,'*'],body:marketstudy_review_table}},//// END OF BLOCK
//// BLOCK START
{text:'',margin:[0,10]},{text:'Taxacions:',style:'h3'},{text:'',margin:[0,5]},{layout:'noBorders',margin:[50,0],table:{headerRows:0,widths:[160,'*'],body:appraisal_review_table}}]};if(any_is_eco){reviewDocDefinition.content.push(//// BLOCK START
{text:'',margin:[0,10]},{text:'Certificat:',style:'h3'},{text:'',margin:[0,5]},{layout:'noBorders',margin:[50,0],table:{headerRows:0,widths:[160,'*'],body:certificate_review_table}//// END OF BLOCK
});}// treiem última pàgina en blanc
docDefinition.content.splice(-1,1);// imprimim per comprovar el'estructura abans de trure el pdf
//console.log('docDefinition: ')
//console.log(JSON.stringify(docDefinition))
pdfMake.createPdf(docDefinition).open();if(any_is_eco===true){pdfMake.createPdf(certificateDefinition).open();}pdfMake.createPdf(reviewDocDefinition).open();// pdfMake.createPdf(docDefinition).download()
console.log('yeah finished!');_this11.master_loading=false;});});});});});});});});});});});});});});});});});});});});});});});});});});});},onSaveCurrentAppraisalReport:function onSaveCurrentAppraisalReport(data){var _this12=this;this.UPDATE_APPRAISALREPORT({object:this.appraisalreport,path:this.appraisalreport.path,parent_path:this.appraisalreport.parent_path,key:this.appraisalreport.id}).then(function(res){// router.go(-1)
if(data.go_up){_this12.onGoUp();}});},editRealEstate:function editRealEstate(entity){var _this13=this;// console.log('edit realestate...')
this.SET_REALESTATE({path:'realestates'+'/'+entity.id+'/'}).then(function(res){_this13.$router.push({name:'realestate-editor',query:{id:entity.id}});});},discardRealEstate:function discardRealEstate(entity){var _this14=this;this.master_loading=true;this.DELETE({key:entity.id,path:'appraisalreports'+'/'+this.appraisalreport.id+'/'+'realestates'+'/'}).then(function(res){_this14.DELETE({key:entity.id,path:'realestates'+'/'+entity.id+'/'+'appraisalreports'+_this14.appraisalreport.id}).then(function(res){//
_this14.FETCH_APPRAISALREPORT_REALESTATES({path:'appraisalreports'+'/'+_this14.$route.query.id+'/'+'realestates'+'/'}).then(function(){_this14.master_loading=false;});});});},onGoBack:function onGoBack(){__WEBPACK_IMPORTED_MODULE_11__router_index_js__["a" /* default */].go(-1);},onGoUp:function onGoUp(){this.$router.push({name:'appraisalfile-editor',query:{id:this.appraisalreport.file_id}});}}),head:{title:{inner:'Edit appraisalreport'}}});

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ContactsSearch_Index_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ContactsSearch_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ContactsSearch_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_SideNavBar_Index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_SideNavBar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_SideNavBar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__router_index_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Message_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'appraisal-container',

    mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins__["d" /* dateMixin */], __WEBPACK_IMPORTED_MODULE_3__mixins__["a" /* localStorageMixin */]],

    data: function data() {
        return {
            loading: true,
            filesOpen: true,
            fileOpen: true,
            reportOpen: true,
            error: null,
            success_message: null

        };
    },

    created: function created() {

        this.loading = false;
    },


    components: {
        Bar: __WEBPACK_IMPORTED_MODULE_7__components_Bar_Index_vue___default.a,
        Message: __WEBPACK_IMPORTED_MODULE_11__components_Message_vue___default.a,
        IconButton: __WEBPACK_IMPORTED_MODULE_8__components_IconButton_Index_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_4__components_Spinner_vue___default.a,
        SideNavBar: __WEBPACK_IMPORTED_MODULE_9__components_SideNavBar_Index_vue___default.a
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['theme', 'appraisal', 'appraisalfile', 'appraisalreport', 'appraisalreport_realestates', 'realestate'])),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])([]), {

        onGoBack: function onGoBack() {
            // console.log('yeah back')
            __WEBPACK_IMPORTED_MODULE_10__router_index_js__["a" /* default */].go(-1);
        },
        onGoUp: function onGoUp() {
            // console.log('yeah up')
            this.$router.push({ name: 'realestate-editor', query: { id: this.realestate.id } });
        }
    }),
    head: {
        title: {
            //inner: Vue.i18n.translate('New_contact')
            inner: 'Appraisal'
        }
    }

});

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__router_index_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__options_appraisal_purposes__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__options_appraisal_types__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__options_countries__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__options_spanish_provinces__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__options_property_types__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__options_quality_of_neighbourhood__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__options_quality_of_situation__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__options_quality_of_construction__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__options_quality_of_realestate__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__options_conservation_statuses__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__options_protection_types__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__options_protection_regimes__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__options_protection_zones__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__options_usage_types__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__options_room_types__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__options_covered_outdoor_types__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__options_uncovered_outdoor_types__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__options_selected_areas__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__options_plot_occupations__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__options_plot_free_area_usages__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__options_foundations__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__options_structures__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__options_roofs__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__options_external_enclosures__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__options_insulations__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__options_external_carpentry_types__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__options_glazings__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__options_quality_of_finishes__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__options_pavings__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__options_walls__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__options_ceilings__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__options_interior_carpentry_types__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__options_orientations__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__options_views__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__options_windows_size_and_quantities__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__options_noise_levels__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__options_territorial_features__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__options_quality_levels__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__options_homogeneity_features__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__options_accessibility_types__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__options_degree_types__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__options_evolution_speeds__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__options_average_ages__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__options_level_options__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__options_construction_statuses__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__options_usage_types_bde__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_Datatable_datatable_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_Datatable_datatable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__components_Datatable_datatable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_Datatable_datatable_column_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_Datatable_datatable_column_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__components_Datatable_datatable_column_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__aggregators_aggregators_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__formatters_formatters_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_Toggles_checkbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_Toggles_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63__components_Toggles_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_Paginator_paginator_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_Paginator_paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__components_Paginator_paginator_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__options_occupancy_statuses__ = __webpack_require__(244);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












































































var fonts = {
    Roboto: {
        normal: 'fonts/Roboto-Regular.ttf',
        bold: 'fonts/Roboto-Medium.ttf',
        italics: 'fonts/Roboto-Italic.ttf',
        bolditalics: 'fonts/Roboto-MediumItalic.ttf'
    }
};

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'appraisal-editor',

    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins__["h" /* appraisalCalcMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["d" /* dateMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["a" /* localStorageMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["f" /* mathMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["e" /* objectsMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["g" /* typeCheckMixin */]],

    data: function data() {
        var _ref;

        return _ref = {
            tabName: '',
            currentTabTitle: '',
            master_loading: true,
            urban_map_offset: 5,
            urban_map_size: '640x480',
            urban_map_width: 640,
            urban_map_height: 480,
            urban_map_zoom_factor: 0.1,
            editing_room: false,
            editing_room_text_color: 'black',
            editing_room_border_color: 'lightgray',
            editing_covered_outdoor: false,
            editing_covered_outdoor_text_color: 'black',
            editing_covered_outdoor_border_color: 'lightgray',
            editing_uncovered_outdoor: false,
            editing_uncovered_outdoor_text_color: 'black',
            editing_uncovered_outdoor_border_color: 'lightgray',
            creatingCoveredOutdoor: false,
            creatingUncoveredOutdoor: false,
            loadingAppraisalPurpose: false,
            filesOpen: true,
            fileOpen: true,
            reportOpen: true,
            editabletrue: true,
            cadaster_ref_loading: false,
            idescat_info_loading: false,
            muc_info_loading: false,
            muc_map_01_loading: false,
            muc_map_02_loading: false,
            muc_map_03_loading: false,
            google_geocode_loading: false,
            error: null,
            success_message: null,
            urban_and_surroundings_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Urban_and_surroundings_text'),
            cession_and_rights_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cession') + ', ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('rights') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('protection'),
            surroundings_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Surroundings'),
            technical_values_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Technical_values'),
            total_values_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Total_values'),
            warnings_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Warnings') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('notes'),
            annexes_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Annexes'),
            land_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Terrain'),
            checks_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Checks'),
            General_data_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('General_data'),
            Areas_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Areas'),
            Market_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Market'),
            features_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Features'),
            metadata_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Version'),
            quote_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quote'),
            appraisal_cost_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Appraisal_cost'),
            filter_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type_here_to_filter_paginated_data'),
            upload_photographs_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Upload_photographs'),
            new_room_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_room'),
            new_constraint_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_constraint'),
            new_warning_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_warning'),
            new_note_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_note'),
            new_covered_outdoor_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_covered_outdoor'),
            new_uncovered_outdoor_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_uncovered_outdoor'),
            cancel_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cancel'),
            goback_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_back') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            goup_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_up') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            save_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save'),
            save_and_go_up_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('go_up'),
            cad_ref_error_text_01: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cadastral_Reference_less_20_positions_error_text'),
            enclosed_checked_area_error_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Low_enclosed_checked_area_error_text'),
            page_dirty_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('The_page_contains_unsaved_changes'),
            actions_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Actions'),
            duplicate_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Duplicate'),
            edit_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Edit'),
            delete_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Delete'),
            cover_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cover'),
            appraisalPurposeValue: null,
            appraisalTypeValue: null,
            land_infrastructure_conservation_statusValue: null,
            occupancy_statusValue: null,
            marketstudy_idValue: null,
            technician_visitingValue: null,
            plot_occupationValue: null,
            plot_free_area_usageValue: null,
            usage_typeValue: null,
            appraisalPurposeOptions: __WEBPACK_IMPORTED_MODULE_13__options_appraisal_purposes__["a" /* default */],
            appraisalTypeOptions: __WEBPACK_IMPORTED_MODULE_14__options_appraisal_types__["a" /* default */],
            countryOptions: __WEBPACK_IMPORTED_MODULE_15__options_countries__["a" /* default */],
            spanishProvinceOptions: __WEBPACK_IMPORTED_MODULE_16__options_spanish_provinces__["a" /* default */],
            property_typeOptions: __WEBPACK_IMPORTED_MODULE_17__options_property_types__["a" /* default */],
            quality_of_neighbourhoodOptions: __WEBPACK_IMPORTED_MODULE_18__options_quality_of_neighbourhood__["a" /* default */],
            quality_of_situationOptions: __WEBPACK_IMPORTED_MODULE_19__options_quality_of_situation__["a" /* default */],
            quality_of_constructionOptions: __WEBPACK_IMPORTED_MODULE_20__options_quality_of_construction__["a" /* default */],
            quality_of_realestateOptions: __WEBPACK_IMPORTED_MODULE_21__options_quality_of_realestate__["a" /* default */],
            conservation_statusOptions: __WEBPACK_IMPORTED_MODULE_22__options_conservation_statuses__["a" /* default */],
            protection_typeOptions: __WEBPACK_IMPORTED_MODULE_23__options_protection_types__["a" /* default */],
            protection_regimeOptions: __WEBPACK_IMPORTED_MODULE_24__options_protection_regimes__["a" /* default */],
            protection_zoneOptions: __WEBPACK_IMPORTED_MODULE_25__options_protection_zones__["a" /* default */],
            usage_typeOptions: __WEBPACK_IMPORTED_MODULE_26__options_usage_types__["a" /* default */],
            territorial_featureOptions: __WEBPACK_IMPORTED_MODULE_49__options_territorial_features__["a" /* default */],
            quality_levelOptions: __WEBPACK_IMPORTED_MODULE_50__options_quality_levels__["a" /* default */],
            homogeneity_featureOptions: __WEBPACK_IMPORTED_MODULE_51__options_homogeneity_features__["a" /* default */],
            accessibility_typeOptions: __WEBPACK_IMPORTED_MODULE_52__options_accessibility_types__["a" /* default */],
            degree_typeOptions: __WEBPACK_IMPORTED_MODULE_53__options_degree_types__["a" /* default */],
            evolution_speedOptions: __WEBPACK_IMPORTED_MODULE_54__options_evolution_speeds__["a" /* default */],
            average_ageOptions: __WEBPACK_IMPORTED_MODULE_55__options_average_ages__["a" /* default */],
            levelOptions: __WEBPACK_IMPORTED_MODULE_56__options_level_options__["a" /* default */],
            room_typeOptions: __WEBPACK_IMPORTED_MODULE_27__options_room_types__["a" /* default */],
            covered_outdoor_typeOptions: __WEBPACK_IMPORTED_MODULE_28__options_covered_outdoor_types__["a" /* default */],
            uncovered_outdoor_typeOptions: __WEBPACK_IMPORTED_MODULE_29__options_uncovered_outdoor_types__["a" /* default */],
            selected_areaOptions: __WEBPACK_IMPORTED_MODULE_30__options_selected_areas__["a" /* default */],
            plot_occupationOptions: __WEBPACK_IMPORTED_MODULE_31__options_plot_occupations__["a" /* default */],
            plot_free_area_usageOptions: __WEBPACK_IMPORTED_MODULE_32__options_plot_free_area_usages__["a" /* default */],

            foundationOptions: __WEBPACK_IMPORTED_MODULE_33__options_foundations__["a" /* default */],
            structureOptions: __WEBPACK_IMPORTED_MODULE_34__options_structures__["a" /* default */],
            roofOptions: __WEBPACK_IMPORTED_MODULE_35__options_roofs__["a" /* default */],
            external_enclosuresOptions: __WEBPACK_IMPORTED_MODULE_36__options_external_enclosures__["a" /* default */],
            insulationOptions: __WEBPACK_IMPORTED_MODULE_37__options_insulations__["a" /* default */],
            external_carpentry_typeOptions: __WEBPACK_IMPORTED_MODULE_38__options_external_carpentry_types__["a" /* default */],
            glazingOptions: __WEBPACK_IMPORTED_MODULE_39__options_glazings__["a" /* default */],
            quality_of_finishesOptions: __WEBPACK_IMPORTED_MODULE_40__options_quality_of_finishes__["a" /* default */],
            pavingOptions: __WEBPACK_IMPORTED_MODULE_41__options_pavings__["a" /* default */],
            wallsOptions: __WEBPACK_IMPORTED_MODULE_42__options_walls__["a" /* default */],
            ceilingsOptions: __WEBPACK_IMPORTED_MODULE_43__options_ceilings__["a" /* default */],
            interior_carpentry_typeOptions: __WEBPACK_IMPORTED_MODULE_44__options_interior_carpentry_types__["a" /* default */],
            main_orientationOptions: __WEBPACK_IMPORTED_MODULE_45__options_orientations__["a" /* default */],
            main_viewsOptions: __WEBPACK_IMPORTED_MODULE_46__options_views__["a" /* default */],
            windows_size_and_quantityOptions: __WEBPACK_IMPORTED_MODULE_47__options_windows_size_and_quantities__["a" /* default */],
            noise_levelOptions: __WEBPACK_IMPORTED_MODULE_48__options_noise_levels__["a" /* default */],

            construction_statusOptions: __WEBPACK_IMPORTED_MODULE_57__options_construction_statuses__["a" /* default */],

            occupancy_statusOptions: __WEBPACK_IMPORTED_MODULE_65__options_occupancy_statuses__["a" /* default */]

        }, _defineProperty(_ref, 'usage_typeOptions', __WEBPACK_IMPORTED_MODULE_26__options_usage_types__["a" /* default */]), _defineProperty(_ref, 'usage_typeBdEOptions', __WEBPACK_IMPORTED_MODULE_58__options_usage_types_bde__["a" /* default */]), _defineProperty(_ref, 'usage_typeBdEValue', null), _defineProperty(_ref, 'countryValue', null), _defineProperty(_ref, 'municipalityValue', null), _defineProperty(_ref, 'provinceValue', null), _defineProperty(_ref, 'property_typeValue', null), _defineProperty(_ref, 'quality_of_neighbourhoodValue', null), _defineProperty(_ref, 'quality_of_situationValue', null), _defineProperty(_ref, 'quality_of_constructionValue', null), _defineProperty(_ref, 'quality_of_realestateValue', null), _defineProperty(_ref, 'conservation_statusValue', null), _defineProperty(_ref, 'protection_typeValue', null), _defineProperty(_ref, 'protection_regimeValue', null), _defineProperty(_ref, 'protection_zoneValue', null), _defineProperty(_ref, 'floors_usage_undergroundValue', null), _defineProperty(_ref, 'floors_usage_overgroundValue', null), _defineProperty(_ref, 'groundfloor_usageValue', null), _defineProperty(_ref, 'surrounding_territorial_featureValue', null), _defineProperty(_ref, 'surrounding_income_levelValue', null), _defineProperty(_ref, 'surrounding_homogeneity_featureValue', null), _defineProperty(_ref, 'surrounding_main_usesValue', null), _defineProperty(_ref, 'surrounding_densityValue', null), _defineProperty(_ref, 'surrounding_accessibilityValue', null), _defineProperty(_ref, 'surrounding_consolidation_degreeValue', null), _defineProperty(_ref, 'surrounding_occupation_degreeValue', null), _defineProperty(_ref, 'surrounding_evolution_speedValue', null), _defineProperty(_ref, 'surrounding_average_ageValue', null), _defineProperty(_ref, 'surrounding_conservation_statusValue', null), _defineProperty(_ref, 'surrounding_commercial_facilitiesValue', null), _defineProperty(_ref, 'surrounding_educational_facilitiesValue', null), _defineProperty(_ref, 'surrounding_public_parkingValue', null), _defineProperty(_ref, 'surrounding_medical_assistanceValue', null), _defineProperty(_ref, 'surrounding_leisureValue', null), _defineProperty(_ref, 'room_typeValue', null), _defineProperty(_ref, 'covered_outdoor_typeValue', null), _defineProperty(_ref, 'uncovered_outdoor_typeValue', null), _defineProperty(_ref, 'net_selected_areaValue', null), _defineProperty(_ref, 'enclosed_selected_areaValue', null), _defineProperty(_ref, 'covered_outdoors_selected_areaValue', null), _defineProperty(_ref, 'built_selected_areaValue', null), _defineProperty(_ref, 'common_elements_selected_areaValue', null), _defineProperty(_ref, 'built_plus_common_elements_selected_areaValue', null), _defineProperty(_ref, 'land_selected_areaValue', null), _defineProperty(_ref, 'realestate_foundationValue', null), _defineProperty(_ref, 'realestate_structureValue', null), _defineProperty(_ref, 'realestate_roofValue', null), _defineProperty(_ref, 'realestate_external_enclosuresValue', null), _defineProperty(_ref, 'realestate_insulationValue', null), _defineProperty(_ref, 'realestate_external_carpentryValue', null), _defineProperty(_ref, 'realestate_glazingValue', null), _defineProperty(_ref, 'realestate_interior_paving_livingValue', null), _defineProperty(_ref, 'realestate_interior_paving_corridorValue', null), _defineProperty(_ref, 'realestate_interior_paving_bedroomValue', null), _defineProperty(_ref, 'realestate_interior_paving_kitchenValue', null), _defineProperty(_ref, 'realestate_interior_paving_bathroomValue', null), _defineProperty(_ref, 'realestate_interior_paving_qualityValue', null), _defineProperty(_ref, 'realestate_interior_walls_livingValue', null), _defineProperty(_ref, 'realestate_interior_walls_corridorValue', null), _defineProperty(_ref, 'realestate_interior_walls_bedroomValue', null), _defineProperty(_ref, 'realestate_interior_walls_kitchenValue', null), _defineProperty(_ref, 'realestate_interior_walls_bathroomValue', null), _defineProperty(_ref, 'realestate_interior_walls_qualityValue', null), _defineProperty(_ref, 'realestate_interior_ceilings_livingValue', null), _defineProperty(_ref, 'realestate_interior_ceilings_corridorValue', null), _defineProperty(_ref, 'realestate_interior_ceilings_bedroomValue', null), _defineProperty(_ref, 'realestate_interior_ceilings_kitchenValue', null), _defineProperty(_ref, 'realestate_interior_ceilings_bathroomValue', null), _defineProperty(_ref, 'realestate_interior_ceilings_qualityValue', null), _defineProperty(_ref, 'realestate_interior_carpentry_livingValue', null), _defineProperty(_ref, 'realestate_interior_carpentry_corridorValue', null), _defineProperty(_ref, 'realestate_interior_carpentry_bedroomValue', null), _defineProperty(_ref, 'realestate_interior_carpentry_kitchenValue', null), _defineProperty(_ref, 'realestate_interior_carpentry_bathroomValue', null), _defineProperty(_ref, 'realestate_interior_carpentry_qualityValue', null), _defineProperty(_ref, 'realestate_main_orientationValue', null), _defineProperty(_ref, 'realestate_main_viewsValue', null), _defineProperty(_ref, 'realestate_windows_size_and_quantityValue', null), _defineProperty(_ref, 'realestate_noise_facadeValue', null), _defineProperty(_ref, 'realestate_systems_sanitary_fittings_qualityValue', null), _defineProperty(_ref, 'realestate_systems_taps_qualityValue', null), _defineProperty(_ref, 'bec_property_typeValue', null), _defineProperty(_ref, 'bec_numberValue', null), _defineProperty(_ref, 'construction_statusValue', null), _defineProperty(_ref, 'room_table', {
            striped: true,
            editable: false,
            lineNumbers: true,
            filter: null,
            currency: 'EUR',
            dateFormat: 'DD/MM/YYYY',
            columns: [{
                id: 'type',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type'),
                width: 30,
                sortable: true,
                groupable: false,
                aggregators: []
            }, {
                id: 'description',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Description'),
                width: 30,
                sortable: true,
                groupable: false,
                aggregators: []
            }, {
                id: 'netarea',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Net_area'),
                width: 30,
                sortable: true,
                groupable: false,
                aggregators: [__WEBPACK_IMPORTED_MODULE_61__aggregators_aggregators_js__["a" /* default */].total]
            }],
            selected: []
        }), _defineProperty(_ref, 'constraint_table_ca', {
            striped: true,
            editable: false,
            lineNumbers: true,
            filter: null,
            currency: 'EUR',
            dateFormat: 'DD/MM/YYYY',
            columns: [{
                id: 'name_ca',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Constraint'),
                width: 30,
                sortable: true,
                groupable: false,
                aggregators: []
            }],
            selected: []
        }), _defineProperty(_ref, 'constraint_table_en', {
            striped: true,
            editable: false,
            lineNumbers: true,
            filter: null,
            currency: 'EUR',
            dateFormat: 'DD/MM/YYYY',
            columns: [{
                id: 'name_en',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Constraint'),
                width: 30,
                sortable: true,
                groupable: false,
                aggregators: []
            }],
            selected: []
        }), _defineProperty(_ref, 'constraint_table_es', {
            striped: true,
            editable: false,
            lineNumbers: true,
            filter: null,
            currency: 'EUR',
            dateFormat: 'DD/MM/YYYY',
            columns: [{
                id: 'name_es',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Constraint'),
                width: 30,
                sortable: true,
                groupable: false,
                aggregators: []
            }],
            selected: []
        }), _defineProperty(_ref, 'warning_table_ca', {
            striped: true,
            editable: false,
            lineNumbers: true,
            filter: null,
            currency: 'EUR',
            dateFormat: 'DD/MM/YYYY',
            columns: [{
                id: 'name_ca',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Warning'),
                width: 30,
                sortable: true,
                groupable: false,
                aggregators: []
            }],
            selected: []
        }), _defineProperty(_ref, 'warning_table_en', {
            striped: true,
            editable: false,
            lineNumbers: true,
            filter: null,
            currency: 'EUR',
            dateFormat: 'DD/MM/YYYY',
            columns: [{
                id: 'name_en',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Warning'),
                width: 30,
                sortable: true,
                groupable: false,
                aggregators: []
            }],
            selected: []
        }), _defineProperty(_ref, 'warning_table_es', {
            striped: true,
            editable: false,
            lineNumbers: true,
            filter: null,
            currency: 'EUR',
            dateFormat: 'DD/MM/YYYY',
            columns: [{
                id: 'name_es',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Warning'),
                width: 30,
                sortable: true,
                groupable: false,
                aggregators: []
            }],
            selected: []
        }), _defineProperty(_ref, 'note_table_ca', {
            striped: true,
            editable: false,
            lineNumbers: true,
            filter: null,
            currency: 'EUR',
            dateFormat: 'DD/MM/YYYY',
            columns: [{
                id: 'name_ca',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Note'),
                width: 30,
                sortable: true,
                groupable: false,
                aggregators: []
            }],
            selected: []
        }), _defineProperty(_ref, 'note_table_en', {
            striped: true,
            editable: false,
            lineNumbers: true,
            filter: null,
            currency: 'EUR',
            dateFormat: 'DD/MM/YYYY',
            columns: [{
                id: 'name_ca',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Note'),
                width: 30,
                sortable: true,
                groupable: false,
                aggregators: []
            }],
            selected: []
        }), _defineProperty(_ref, 'note_table_es', {
            striped: true,
            editable: false,
            lineNumbers: true,
            filter: null,
            currency: 'EUR',
            dateFormat: 'DD/MM/YYYY',
            columns: [{
                id: 'name_ca',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Note'),
                width: 30,
                sortable: true,
                groupable: false,
                aggregators: []
            }],
            selected: []
        }), _defineProperty(_ref, 'covered_outdoor_table', {
            striped: true,
            editable: false,
            lineNumbers: true,
            filter: null,
            currency: 'EUR',
            dateFormat: 'DD/MM/YYYY',
            columns: [{
                id: 'type',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type'),
                width: 30,
                sortable: true,
                groupable: false,
                aggregators: []
            }, {
                id: 'description',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Description'),
                width: 30,
                sortable: true,
                groupable: false,
                aggregators: []
            }, {
                id: 'netarea',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Net_area'),
                width: 30,
                sortable: true,
                groupable: false,
                aggregators: [__WEBPACK_IMPORTED_MODULE_61__aggregators_aggregators_js__["a" /* default */].total]
            }],
            selected: []
        }), _defineProperty(_ref, 'uncovered_outdoor_table', {
            striped: true,
            editable: false,
            lineNumbers: true,
            filter: null,
            currency: 'EUR',
            dateFormat: 'DD/MM/YYYY',
            columns: [{
                id: 'type',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type'),
                width: 30,
                sortable: true,
                groupable: false,
                aggregators: []
            }, {
                id: 'description',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Description'),
                width: 30,
                sortable: true,
                groupable: false,
                aggregators: []
            }, {
                id: 'netarea',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Net_area'),
                width: 30,
                sortable: true,
                groupable: false,
                aggregators: [__WEBPACK_IMPORTED_MODULE_61__aggregators_aggregators_js__["a" /* default */].total]
            }],
            selected: []
        }), _defineProperty(_ref, 'photograph_table_ca', {
            striped: true,
            editable: false,
            lineNumbers: true,
            filter: null,
            currency: 'EUR',
            dateFormat: 'DD/MM/YYYY',
            columns: [{
                id: 'name_ca',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Image_footer'),
                width: 30,
                sortable: true,
                groupable: false,
                aggregators: []
            }, {
                id: 'filename',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('File_name'),
                width: 60,
                sortable: true,
                groupable: false,
                aggregators: []
            }],
            selected: []
        }), _defineProperty(_ref, 'photograph_table_en', {
            striped: true,
            editable: false,
            lineNumbers: true,
            filter: null,
            currency: 'EUR',
            dateFormat: 'DD/MM/YYYY',
            columns: [{
                id: 'name_en',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Image_footer'),
                width: 30,
                sortable: true,
                groupable: false,
                aggregators: []
            }, {
                id: 'filename',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('File_name'),
                width: 60,
                sortable: true,
                groupable: false,
                aggregators: []
            }],
            selected: []
        }), _defineProperty(_ref, 'photograph_table_es', {
            striped: true,
            editable: false,
            lineNumbers: true,
            filter: null,
            currency: 'EUR',
            dateFormat: 'DD/MM/YYYY',
            columns: [{
                id: 'name_es',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Image_footer'),
                width: 30,
                sortable: true,
                groupable: false,
                aggregators: []
            }, {
                id: 'filename',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('File_name'),
                width: 60,
                sortable: true,
                groupable: false,
                aggregators: []
            }],
            selected: []
        }), _defineProperty(_ref, 'registryannex_table_ca', {
            striped: true,
            editable: false,
            lineNumbers: true,
            filter: null,
            currency: 'EUR',
            dateFormat: 'DD/MM/YYYY',
            columns: [{
                id: 'name_ca',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Image_footer'),
                width: 30,
                sortable: true,
                groupable: false,
                aggregators: []
            }, {
                id: 'filename',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('File_name'),
                width: 60,
                sortable: true,
                groupable: false,
                aggregators: []
            }],
            selected: []
        }), _defineProperty(_ref, 'registryannex_table_en', {
            striped: true,
            editable: false,
            lineNumbers: true,
            filter: null,
            currency: 'EUR',
            dateFormat: 'DD/MM/YYYY',
            columns: [{
                id: 'name_en',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Image_footer'),
                width: 30,
                sortable: true,
                groupable: false,
                aggregators: []
            }, {
                id: 'filename',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('File_name'),
                width: 60,
                sortable: true,
                groupable: false,
                aggregators: []
            }],
            selected: []
        }), _defineProperty(_ref, 'registryannex_table_es', {
            striped: true,
            editable: false,
            lineNumbers: true,
            filter: null,
            currency: 'EUR',
            dateFormat: 'DD/MM/YYYY',
            columns: [{
                id: 'name_es',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Image_footer'),
                width: 30,
                sortable: true,
                groupable: false,
                aggregators: []
            }, {
                id: 'filename',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('File_name'),
                width: 60,
                sortable: true,
                groupable: false,
                aggregators: []
            }],
            selected: []
        }), _defineProperty(_ref, 'urbanannex_table_ca', {
            striped: true,
            editable: false,
            lineNumbers: true,
            filter: null,
            currency: 'EUR',
            dateFormat: 'DD/MM/YYYY',
            columns: [{
                id: 'name_ca',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Image_footer'),
                width: 30,
                sortable: true,
                groupable: false,
                aggregators: []
            }, {
                id: 'filename',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('File_name'),
                width: 60,
                sortable: true,
                groupable: false,
                aggregators: []
            }],
            selected: []
        }), _defineProperty(_ref, 'urbanannex_table_en', {
            striped: true,
            editable: false,
            lineNumbers: true,
            filter: null,
            currency: 'EUR',
            dateFormat: 'DD/MM/YYYY',
            columns: [{
                id: 'name_en',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Image_footer'),
                width: 30,
                sortable: true,
                groupable: false,
                aggregators: []
            }, {
                id: 'filename',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('File_name'),
                width: 60,
                sortable: true,
                groupable: false,
                aggregators: []
            }],
            selected: []
        }), _defineProperty(_ref, 'urbanannex_table_es', {
            striped: true,
            editable: false,
            lineNumbers: true,
            filter: null,
            currency: 'EUR',
            dateFormat: 'DD/MM/YYYY',
            columns: [{
                id: 'name_es',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Image_footer'),
                width: 30,
                sortable: true,
                groupable: false,
                aggregators: []
            }, {
                id: 'filename',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('File_name'),
                width: 60,
                sortable: true,
                groupable: false,
                aggregators: []
            }],
            selected: []
        }), _defineProperty(_ref, 'cadasterannex_table_ca', {
            striped: true,
            editable: false,
            lineNumbers: true,
            filter: null,
            currency: 'EUR',
            dateFormat: 'DD/MM/YYYY',
            columns: [{
                id: 'name_ca',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Image_footer'),
                width: 30,
                sortable: true,
                groupable: false,
                aggregators: []
            }, {
                id: 'filename',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('File_name'),
                width: 60,
                sortable: true,
                groupable: false,
                aggregators: []
            }],
            selected: []
        }), _defineProperty(_ref, 'cadasterannex_table_en', {
            striped: true,
            editable: false,
            lineNumbers: true,
            filter: null,
            currency: 'EUR',
            dateFormat: 'DD/MM/YYYY',
            columns: [{
                id: 'name_en',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Image_footer'),
                width: 30,
                sortable: true,
                groupable: false,
                aggregators: []
            }, {
                id: 'filename',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('File_name'),
                width: 60,
                sortable: true,
                groupable: false,
                aggregators: []
            }],
            selected: []
        }), _defineProperty(_ref, 'cadasterannex_table_es', {
            striped: true,
            editable: false,
            lineNumbers: true,
            filter: null,
            currency: 'EUR',
            dateFormat: 'DD/MM/YYYY',
            columns: [{
                id: 'name_es',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Image_footer'),
                width: 30,
                sortable: true,
                groupable: false,
                aggregators: []
            }, {
                id: 'filename',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('File_name'),
                width: 60,
                sortable: true,
                groupable: false,
                aggregators: []
            }],
            selected: []
        }), _defineProperty(_ref, 'planannex_table_ca', {
            striped: true,
            editable: false,
            lineNumbers: true,
            filter: null,
            currency: 'EUR',
            dateFormat: 'DD/MM/YYYY',
            columns: [{
                id: 'name_ca',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Image_footer'),
                width: 30,
                sortable: true,
                groupable: false,
                aggregators: []
            }, {
                id: 'filename',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('File_name'),
                width: 60,
                sortable: true,
                groupable: false,
                aggregators: []
            }],
            selected: []
        }), _defineProperty(_ref, 'planannex_table_en', {
            striped: true,
            editable: false,
            lineNumbers: true,
            filter: null,
            currency: 'EUR',
            dateFormat: 'DD/MM/YYYY',
            columns: [{
                id: 'name_en',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Image_footer'),
                width: 30,
                sortable: true,
                groupable: false,
                aggregators: []
            }, {
                id: 'filename',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('File_name'),
                width: 60,
                sortable: true,
                groupable: false,
                aggregators: []
            }],
            selected: []
        }), _defineProperty(_ref, 'planannex_table_es', {
            striped: true,
            editable: false,
            lineNumbers: true,
            filter: null,
            currency: 'EUR',
            dateFormat: 'DD/MM/YYYY',
            columns: [{
                id: 'name_es',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Image_footer'),
                width: 30,
                sortable: true,
                groupable: false,
                aggregators: []
            }, {
                id: 'filename',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('File_name'),
                width: 60,
                sortable: true,
                groupable: false,
                aggregators: []
            }],
            selected: []
        }), _defineProperty(_ref, 'cessionannex_table_ca', {
            striped: true,
            editable: false,
            lineNumbers: true,
            filter: null,
            currency: 'EUR',
            dateFormat: 'DD/MM/YYYY',
            columns: [{
                id: 'name_ca',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Image_footer'),
                width: 30,
                sortable: true,
                groupable: false,
                aggregators: []
            }, {
                id: 'filename',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('File_name'),
                width: 60,
                sortable: true,
                groupable: false,
                aggregators: []
            }],
            selected: []
        }), _defineProperty(_ref, 'cessionannex_table_en', {
            striped: true,
            editable: false,
            lineNumbers: true,
            filter: null,
            currency: 'EUR',
            dateFormat: 'DD/MM/YYYY',
            columns: [{
                id: 'name_en',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Image_footer'),
                width: 30,
                sortable: true,
                groupable: false,
                aggregators: []
            }, {
                id: 'filename',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('File_name'),
                width: 60,
                sortable: true,
                groupable: false,
                aggregators: []
            }],
            selected: []
        }), _defineProperty(_ref, 'cessionannex_table_es', {
            striped: true,
            editable: false,
            lineNumbers: true,
            filter: null,
            currency: 'EUR',
            dateFormat: 'DD/MM/YYYY',
            columns: [{
                id: 'name_es',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Image_footer'),
                width: 30,
                sortable: true,
                groupable: false,
                aggregators: []
            }, {
                id: 'filename',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('File_name'),
                width: 60,
                sortable: true,
                groupable: false,
                aggregators: []
            }],
            selected: []
        }), _defineProperty(_ref, 'otherannex_table_ca', {
            striped: true,
            editable: false,
            lineNumbers: true,
            filter: null,
            currency: 'EUR',
            dateFormat: 'DD/MM/YYYY',
            columns: [{
                id: 'name_ca',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Image_footer'),
                width: 30,
                sortable: true,
                groupable: false,
                aggregators: []
            }, {
                id: 'filename',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('File_name'),
                width: 60,
                sortable: true,
                groupable: false,
                aggregators: []
            }],
            selected: []
        }), _defineProperty(_ref, 'otherannex_table_en', {
            striped: true,
            editable: false,
            lineNumbers: true,
            filter: null,
            currency: 'EUR',
            dateFormat: 'DD/MM/YYYY',
            columns: [{
                id: 'name_en',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Image_footer'),
                width: 30,
                sortable: true,
                groupable: false,
                aggregators: []
            }, {
                id: 'filename',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('File_name'),
                width: 60,
                sortable: true,
                groupable: false,
                aggregators: []
            }],
            selected: []
        }), _defineProperty(_ref, 'otherannex_table_es', {
            striped: true,
            editable: false,
            lineNumbers: true,
            filter: null,
            currency: 'EUR',
            dateFormat: 'DD/MM/YYYY',
            columns: [{
                id: 'name_es',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Image_footer'),
                width: 30,
                sortable: true,
                groupable: false,
                aggregators: []
            }, {
                id: 'filename',
                label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('File_name'),
                width: 60,
                sortable: true,
                groupable: false,
                aggregators: []
            }],
            selected: []
        }), _ref;
    },

    created: function created() {
        var _this = this;

        this.FETCH_APPRAISAL_ROOMS({ path: 'appraisal_rooms' + '/' + this.appraisal.id + '/' }).then(function () {
            _this.FETCH_APPRAISAL_COVERED_OUTDOORS({ path: 'appraisal_covered_outdoors' + '/' + _this.appraisal.id + '/' }).then(function () {
                _this.FETCH_APPRAISAL_UNCOVERED_OUTDOORS({ path: 'appraisal_uncovered_outdoors' + '/' + _this.appraisal.id + '/' }).then(function () {
                    _this.FETCH_APPRAISAL_BEC_PROPERTIES({ path: 'becproperties' + '/' }).then(function () {
                        _this.FETCH_APPRAISAL_CONSTRAINTS({ path: 'appraisal_constraints' + '/' + _this.appraisal.id + '/' }).then(function () {
                            _this.FETCH_APPRAISAL_WARNINGS({ path: 'appraisal_warnings' + '/' + _this.appraisal.id + '/' }).then(function () {
                                _this.FETCH_APPRAISAL_NOTES({ path: 'appraisal_notes' + '/' + _this.appraisal.id + '/' }).then(function () {
                                    _this.FETCH_APPRAISAL_PHOTOGRAPHS({ path: 'realestate_appraisals' + '/' + _this.realestate.id + '/' + _this.appraisal.id + '/' + 'photographs' }).then(function () {
                                        _this.FETCH_APPRAISAL_REGISTRYANNEXES({ path: 'realestate_appraisals' + '/' + _this.realestate.id + '/' + _this.appraisal.id + '/' + 'registryannexes' }).then(function () {
                                            _this.FETCH_APPRAISAL_CADASTERANNEXES({ path: 'realestate_appraisals' + '/' + _this.realestate.id + '/' + _this.appraisal.id + '/' + 'cadasterannexes' }).then(function () {
                                                _this.FETCH_APPRAISAL_URBANANNEXES({ path: 'realestate_appraisals' + '/' + _this.realestate.id + '/' + _this.appraisal.id + '/' + 'urbanannexes' }).then(function () {
                                                    _this.FETCH_APPRAISAL_PLANANNEXES({ path: 'realestate_appraisals' + '/' + _this.realestate.id + '/' + _this.appraisal.id + '/' + 'planannexes' }).then(function () {
                                                        _this.FETCH_APPRAISAL_CESSIONANNEXES({ path: 'realestate_appraisals' + '/' + _this.realestate.id + '/' + _this.appraisal.id + '/' + 'cessionannexes' }).then(function () {
                                                            _this.FETCH_APPRAISAL_OTHERANNEXES({ path: 'realestate_appraisals' + '/' + _this.realestate.id + '/' + _this.appraisal.id + '/' + 'otherannexes' }).then(function () {
                                                                _this.FETCH_REALESTATE_MARKETSTUDIES({ path: 'realestate_marketstudies' + '/' + _this.realestate.id + '/' }).then(function () {
                                                                    _this.FETCH_APPRAISERS().then(function () {
                                                                        _this.master_loading = false;
                                                                    });
                                                                });
                                                            });
                                                        });
                                                    });
                                                });
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    });
                });
            });
        });
        // Agafem el mateix que hi hagi a realestate
        this.SET_APPRAISAL_PROPERTY_TYPE(this.realestate.property_type);
    },


    components: {
        Bar: __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default.a,
        Message: __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default.a,
        IconButton: __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default.a,
        Checkbox: __WEBPACK_IMPORTED_MODULE_63__components_Toggles_checkbox_vue___default.a,
        Datatable: __WEBPACK_IMPORTED_MODULE_59__components_Datatable_datatable_vue___default.a,
        DatatableColumn: __WEBPACK_IMPORTED_MODULE_60__components_Datatable_datatable_column_vue___default.a,
        Paginator: __WEBPACK_IMPORTED_MODULE_64__components_Paginator_paginator_vue___default.a,
        SideNavBar: __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default.a
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['theme', 'tags_display', 'appraisal', 'appraisal_bec_prices', 'appraisal_bec_properties', 'appraisal_rooms', 'appraisal_covered_outdoors', 'appraisal_uncovered_outdoors', 'appraisalfile', 'appraisers', 'appraisalreport', 'appraisalreport_realestates', 'appraisal_rooms', 'currentLocale', 'realestate', 'realestate_appraisals', 'appraisal_constraints', 'appraisal_warnings', 'appraisal_notes', 'appraisal_photographs', 'appraisal_registryannexes', 'appraisal_cadasterannexes', 'appraisal_urbanannexes', 'appraisal_planannexes', 'appraisal_cessionannexes', 'appraisal_otherannexes', 'realestate_marketstudies', 'photograph', 'valuation_prices'])),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['CREATE_NEW_APPRAISAL', 'CREATE_NEW_ROOM', 'CREATE_NEW_COVERED_OUTDOOR', 'CREATE_NEW_UNCOVERED_OUTDOOR', 'FETCH_APPRAISAL_BEC_PRICES', 'FETCH_APPRAISAL_BEC_PROPERTIES', 'FETCH_APPRAISAL_ROOMS', 'FETCH_APPRAISAL_COVERED_OUTDOORS', 'FETCH_APPRAISAL_UNCOVERED_OUTDOORS', 'FETCH_APPRAISAL_CONSTRAINTS', 'FETCH_APPRAISAL_WARNINGS', 'FETCH_APPRAISAL_NOTES', 'FETCH_APPRAISERS', 'FETCH_REALESTATE_MARKETSTUDIES', 'REQUEST_MUC_INFO', 'REQUEST_IDESCAT_INFO_BY_CODE_INE', 'REQUEST_MAP_URBAN_MUC_LAND_COLORS_BY_BBOX', 'REQUEST_MAP_URBAN_MUC_COUNCIL_QUAL_BY_BBOX', 'REQUEST_MAP_URBAN_ICC_TOPO_BY_BBOX', 'RESET_APPRAISAL', 'RESET_ROOM', 'RESET_COVERED_OUTDOOR', 'RESET_UNCOVERED_OUTDOOR', 'RESET_CONSTRAINT', 'RESET_WARNING', 'RESET_NOTE', 'CREATE_NEW_CONSTRAINT', 'CREATE_NEW_WARNING', 'CREATE_NEW_NOTE', 'DELETE_CONSTRAINT', 'DELETE_WARNING', 'DELETE_NOTE', 'DELETE_ROOM', 'DELETE_COVERED_OUTDOOR', 'DELETE_UNCOVERED_OUTDOOR', 'SET_CONSTRAINT', 'SET_WARNING', 'SET_NOTE', 'SET_APPRAISAL', 'SET_APPRAISAL_APPRAISALDATE', 'SET_APPRAISAL_VISITDATE', 'SET_APPRAISAL_DESCRIPTION', 'SET_APPRAISAL_PURPOSE', 'SET_APPRAISAL_PURPOSE_NOTES', 'SET_APPRAISAL_REDUCTION_PCT', 'SET_APPRAISAL_TYPE', 'SET_APPRAISAL_ADOPTED_AREA', 'SET_APPRAISAL_LIFT', 'SET_APPRAISAL_ADOPTED_AGE', 'SET_APPRAISAL_PROPERTY_TYPE', 'SET_APPRAISAL_QUALITY_OF_NEIGHBOURHOOD', 'SET_APPRAISAL_QUALITY_OF_SITUATION', 'SET_APPRAISAL_QUALITY_OF_CONSTRUCTION', 'SET_APPRAISAL_QUALITY_OF_REALESTATE', 'SET_APPRAISAL_CONSERVATION_STATUS', 'SET_APPRAISAL_MATERIAL_EXECUTION_COST', 'SET_APPRAISAL_MEC_ADJUSTMENT_COEF', 'SET_APPRAISAL_MARKET_VALUE_APPRAISER_ADJUSTMENT_PCT', 'SET_APPRAISAL_BC_PCT', 'SET_APPRAISAL_GC_PCT', 'SET_APPRAISAL_TOTAL_CONSTRUCTION_PROGRESS_PCT', 'UPDATE_APPRAISAL', 'UPDATE_APPRAISALREPORT', 'UPDATE_REALESTATE', 'SET_APPRAISAL_CESSION_BOOLEAN', 'SET_APPRAISAL_CESSION_GROSS_MONTHLY_INCOME', 'SET_APPRAISAL_CESSION_GROSS_YEARLY_INCOME', 'SET_APPRAISAL_CESSION_NET_YEARLY_INCOME', 'SET_APPRAISAL_CESSION_CONTRACT_PERIOD_YEARS', 'SET_APPRAISAL_CESSION_CONTRACT_REMAINING_YEARS', 'SET_APPRAISAL_CESSION_CONTRACT_START_DATE', 'SET_APPRAISAL_LANDLORD_EXPENSES_PCT', 'SET_APPRAISAL_TENANT_AGE_YEARS', 'SET_APPRAISAL_TENANT_LIFE_EXPECTANCY_YEARS', 'SET_APPRAISAL_TENANT_REMAINING_LIFE_EXPECTANCY_YEARS', 'SET_APPRAISAL_RIGHT_OF_USE_BOOLEAN', 'SET_APPRAISAL_USUFRUCTUARY_AGE_YEARS', 'SET_APPRAISAL_PROTECTION_BOOLEAN', 'SET_APPRAISAL_PROTECTION_TYPE', 'SET_APPRAISAL_PROTECTION_REGIME', 'SET_APPRAISAL_PROTECTION_ZONE', 'SET_APPRAISAL_MAX_LEGAL_PRICE', 'SET_APPRAISAL_MAX_LEGAL_AREA', 'SET_APPRAISAL_URBAN_PLANNING_TYPE', 'SET_APPRAISAL_URBAN_PLANNING_FILE', 'SET_APPRAISAL_URBAN_PLANNING_COUNCIL_QUALIFICATION', 'SET_APPRAISAL_URBAN_PLANNING_COUNCIL_QUALIFICATION_DESCRIPTION', 'SET_APPRAISAL_URBAN_PLANNING_COUNCIL_CLASSIFICATION', 'SET_APPRAISAL_URBAN_PLANNING_COUNCIL_CLASSIFICATION_DESCRIPTION', 'SET_APPRAISAL_URBAN_PLANNING_REGIONAL_QUALIFICATION', 'SET_APPRAISAL_URBAN_PLANNING_REGIONAL_QUALIFICATION_DESCRIPTION', 'SET_APPRAISAL_URBAN_PLANNING_REGIONAL_CLASSIFICATION', 'SET_APPRAISAL_URBAN_PLANNING_REGIONAL_CLASSIFICATION_DESCRIPTION', 'SET_APPRAISAL_LAND_REGISTRY_AREA', 'SET_APPRAISAL_LAND_CADASTRAL_AREA', 'SET_APPRAISAL_LAND_CHECKED_AREA', 'SET_APPRAISAL_LAND_ADOPTED_AREA', 'SET_APPRAISAL_LAND_INFRASTRUCTURE_PAVING_EXECUTION_PCT', 'SET_APPRAISAL_LAND_INFRASTRUCTURE_SEWAGE_EXECUTION_PCT', 'SET_APPRAISAL_LAND_INFRASTRUCTURE_PUBLIC_LIGHTING_EXECUTION_PCT', 'SET_APPRAISAL_LAND_INFRASTRUCTURE_ELECTRICITY_SUPPLY_EXECUTION_PCT', 'SET_APPRAISAL_LAND_INFRASTRUCTURE_PIPED_GAS_EXECUTION_PCT', 'SET_APPRAISAL_LAND_INFRASTRUCTURE_TELEPHONE_SERVICE_EXECUTION_PCT', 'SET_APPRAISAL_LAND_INFRASTRUCTURE_GARDENED_AREAS_EXECUTION_PCT', 'SET_APPRAISAL_LAND_INFRASTRUCTURE_TOTAL_EXECUTION_PCT', 'SET_APPRAISAL_LAND_INFRASTRUCTURE_REPERCUSSION_COST', 'SET_APPRAISAL_LAND_INFRASTRUCTURE_PENDING_INVESTMENT', 'SET_APPRAISAL_LAND_INFRASTRUCTURE_PAVING', 'SET_APPRAISAL_LAND_INFRASTRUCTURE_SEWAGE', 'SET_APPRAISAL_LAND_INFRASTRUCTURE_PUBLIC_LIGHTING', 'SET_APPRAISAL_LAND_INFRASTRUCTURE_ELECTRICITY_SUPPLY', 'SET_APPRAISAL_LAND_INFRASTRUCTURE_PIPED_GAS', 'SET_APPRAISAL_LAND_INFRASTRUCTURE_TELEPHONE_SERVICE', 'SET_APPRAISAL_LAND_INFRASTRUCTURE_GARDENED_AREAS', 'SET_APPRAISAL_LAND_IS_PLOT_ACCORDING_TO_LAW', 'SET_APPRAISAL_LAND_AREA_NOTES', 'SET_APPRAISAL_LAND_INFRASTRUCTURE_NOTES', 'SET_APPRAISAL_LAND_INFRASTRUCTURE_CONSERVATION_STATUS', 'SET_APPRAISAL_LAND_INFRASTRUCTURE_WATER_SUPPLY_EXECUTION_PCT', 'SET_APPRAISAL_LAND_INFRASTRUCTURE_WATER_SUPPLY', 'SET_APPRAISAL_PLOT_OCCUPATION', 'SET_APPRAISAL_PLOT_FREE_AREA_USAGE', 'SET_APPRAISAL_FLOORS_NUMBER_UNDERGROUND', 'SET_APPRAISAL_FLOORS_NUMBER_OVERGROUND', 'SET_APPRAISAL_PARKING_SLOTS_INCLUDED_IN_APPRAISAL_NUMBER', 'SET_APPRAISAL_ENTRANCE_HALL', 'SET_APPRAISAL_DOORMAN_SPACE', 'SET_APPRAISAL_STAIRCASE', 'SET_APPRAISAL_SWIMMING_POOL', 'SET_APPRAISAL_GARDENED_AREAS', 'SET_APPRAISAL_SPORTS_FACILITIES', 'SET_APPRAISAL_COMMUNITY_ROOM', 'SET_APPRAISAL_STORAGE_ROOM', 'SET_APPRAISAL_COMMUNITY_PARKING', 'SET_APPRAISAL_FACILITIES_OTHERS', 'SET_APPRAISAL_FLOORS_USAGE_UNDERGROUND', 'SET_APPRAISAL_FLOORS_USAGE_OVERGROUND', 'SET_APPRAISAL_GROUNDFLOOR_USAGE', 'SET_APPRAISAL_COMMUNICATIONS_AIRPORT', 'SET_APPRAISAL_COMMUNICATIONS_HARBOUR', 'SET_APPRAISAL_COMMUNICATIONS_TRAIN', 'SET_APPRAISAL_PUBLIC_TRANSPORT_URBAN_UNDERGROUND', 'SET_APPRAISAL_PUBLIC_TRANSPORT_INTERURBAN', 'SET_APPRAISAL_SURROUNDING_FACILITIES_NOTES', 'SET_APPRAISAL_SURROUNDING_TERRITORIAL_FEATURE', 'SET_APPRAISAL_SURROUNDING_INCOME_LEVEL', 'SET_APPRAISAL_SURROUNDING_HOMOGENEITY_FEATURE', 'SET_APPRAISAL_SURROUNDING_MAIN_USES', 'SET_APPRAISAL_SURROUNDING_DENSITY', 'SET_APPRAISAL_SURROUNDING_ACCESSIBILITY', 'SET_APPRAISAL_SURROUNDING_CONSOLIDATION_DEGREE', 'SET_APPRAISAL_SURROUNDING_OCCUPATION_DEGREE', 'SET_APPRAISAL_SURROUNDING_EVOLUTION_SPEED', 'SET_APPRAISAL_SURROUNDING_AVERAGE_AGE', 'SET_APPRAISAL_SURROUNDING_CONSERVATION_STATUS', 'SET_APPRAISAL_SURROUNDING_COMMERCIAL_FACILITIES', 'SET_APPRAISAL_SURROUNDING_EDUCATIONAL_FACILITIES', 'SET_APPRAISAL_SURROUNDING_PUBLIC_PARKING', 'SET_APPRAISAL_SURROUNDING_MEDICAL_ASSISTANCE', 'SET_APPRAISAL_SURROUNDING_LEISURE', 'SET_APPRAISAL_CADASTRAL_USAGE', 'SET_APPRAISAL_CADASTRAL_FLOOR', 'SET_APPRAISAL_CADASTRAL_DOOR', 'SET_APPRAISAL_CADASTRAL_BLOCK', 'SET_APPRAISAL_CADASTRAL_STAIRCASE', 'SET_APPRAISAL_REGISTRY_NAME', 'SET_APPRAISAL_REGISTRY_SECTION', 'SET_APPRAISAL_REGISTRY_VOLUME', 'SET_APPRAISAL_REGISTRY_BOOK', 'SET_APPRAISAL_REGISTRY_PAGE', 'SET_APPRAISAL_REGISTRY_REAL_ESTATE_NUMBER', 'SET_APPRAISAL_REGISTRY_IDUFIR', 'SET_APPRAISAL_REGISTRY_OWNER', 'SET_APPRAISAL_REGISTRY_PROPERTY_COEF', 'SET_APPRAISAL_NET_CADASTRAL_AREA', 'SET_APPRAISAL_NET_REGISTRY_AREA', 'SET_APPRAISAL_NET_CHECKED_AREA', 'SET_APPRAISAL_NET_ADOPTED_AREA', 'SET_APPRAISAL_ENCLOSED_CADASTRAL_AREA', 'SET_APPRAISAL_ENCLOSED_REGISTRY_AREA', 'SET_APPRAISAL_ENCLOSED_CHECKED_AREA', 'SET_APPRAISAL_ENCLOSED_ADOPTED_AREA', 'SET_APPRAISAL_COVERED_TERRACES_TOTAL_CADASTRAL_AREA', 'SET_APPRAISAL_COVERED_TERRACES_TOTAL_REGISTRY_AREA', 'SET_APPRAISAL_COVERED_TERRACES_TOTAL_CHECKED_AREA', 'SET_APPRAISAL_COVERED_TERRACES_TOTAL_ADOPTED_AREA', 'SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_CADASTRAL_AREA', 'SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_REGISTRY_AREA', 'SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_CHECKED_AREA', 'SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_ADOPTED_AREA', 'SET_APPRAISAL_BUILT_CADASTRAL_AREA', 'SET_APPRAISAL_BUILT_REGISTRY_AREA', 'SET_APPRAISAL_BUILT_CHECKED_AREA', 'SET_APPRAISAL_BUILT_ADOPTED_AREA', 'SET_APPRAISAL_COMMON_ELEMENTS_CADASTRAL_AREA', 'SET_APPRAISAL_COMMON_ELEMENTS_REGISTRY_AREA', 'SET_APPRAISAL_COMMON_ELEMENTS_CHECKED_AREA', 'SET_APPRAISAL_COMMON_ELEMENTS_ADOPTED_AREA', 'SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_CADASTRAL_AREA', 'SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_REGISTRY_AREA', 'SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_CHECKED_AREA', 'SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_ADOPTED_AREA', 'SET_APPRAISAL_ROOMS', 'UPDATE_APPRAISAL_ROOMS', 'SET_APPRAISAL_COVERED_OUTDOORS', 'UPDATE_APPRAISAL_COVERED_OUTDOORS', 'SET_APPRAISAL_UNCOVERED_OUTDOORS', 'UPDATE_APPRAISAL_UNCOVERED_OUTDOORS', 'SET_APPRAISAL_BATHROOMS_NUMBER', 'SET_APPRAISAL_BEDROOMS_NUMBER', 'SET_APPRAISAL_NET_SELECTED_AREA', 'SET_APPRAISAL_ENCLOSED_SELECTED_AREA', 'SET_APPRAISAL_COVERED_OUTDOORS_SELECTED_AREA', 'SET_APPRAISAL_BUILT_SELECTED_AREA', 'SET_APPRAISAL_COMMON_ELEMENTS_SELECTED_AREA', 'SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_SELECTED_AREA', 'SET_APPRAISAL_LAND_SELECTED_AREA', 'SET_APPRAISAL_REALESTATE_ROOMS_TO_EXTERIOR_NUMBER', 'SET_APPRAISAL_REALESTATE_DAY_NIGHT_ZONING', 'SET_APPRAISAL_REALESTATE_SYSTEMS_DOOR_OPENER', 'SET_APPRAISAL_REALESTATE_SYSTEMS_FITTED_CUPBOARDS', 'SET_APPRAISAL_REALESTATE_SYSTEMS_GAS', 'SET_APPRAISAL_REALESTATE_SYSTEMS_SANITARY_FITTINGS', 'SET_APPRAISAL_REALESTATE_SYSTEMS_TAPS', 'SET_APPRAISAL_REALESTATE_SYSTEMS_HOT_WATER', 'SET_APPRAISAL_REALESTATE_SYSTEMS_HEATING', 'SET_APPRAISAL_REALESTATE_SYSTEMS_AIR_CONDITIONING', 'SET_APPRAISAL_REALESTATE_SYSTEMS_TV', 'SET_APPRAISAL_REALESTATE_SYSTEMS_TELEPHONE', 'SET_APPRAISAL_REALESTATE_SYSTEMS_FIRE_PREVENTION', 'SET_APPRAISAL_REALESTATE_SYSTEMS_INTRUSION_PREVENTION', 'SET_APPRAISAL_REALESTATE_FOUNDATION', 'SET_APPRAISAL_REALESTATE_STRUCTURE', 'SET_APPRAISAL_REALESTATE_ROOF', 'SET_APPRAISAL_REALESTATE_EXTERNAL_ENCLOSURES', 'SET_APPRAISAL_REALESTATE_INSULATION', 'SET_APPRAISAL_REALESTATE_EXTERNAL_CARPENTRY', 'SET_APPRAISAL_REALESTATE_GLAZING', 'SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_LIVING', 'SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_CORRIDOR', 'SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_BEDROOM', 'SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_KITCHEN', 'SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_BATHROOM', 'SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_QUALITY', 'SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_LIVING', 'SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_CORRIDOR', 'SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_BEDROOM', 'SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_KITCHEN', 'SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_BATHROOM', 'SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_QUALITY', 'SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_LIVING', 'SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_CORRIDOR', 'SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_BEDROOM', 'SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_KITCHEN', 'SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_BATHROOM', 'SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_QUALITY', 'SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_LIVING', 'SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_CORRIDOR', 'SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_BEDROOM', 'SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_KITCHEN', 'SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_BATHROOM', 'SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_QUALITY', 'SET_APPRAISAL_REALESTATE_MAIN_ORIENTATION', 'SET_APPRAISAL_REALESTATE_MAIN_VIEWS', 'SET_APPRAISAL_REALESTATE_WINDOWS_SIZE_AND_QUANTITY', 'SET_APPRAISAL_REALESTATE_NOISE_FACADE', 'SET_APPRAISAL_REALESTATE_SYSTEMS_SANITARY_FITTINGS_QUALITY', 'SET_APPRAISAL_REALESTATE_SYSTEMS_TAPS_QUALITY', 'SET_APPRAISAL_BEC_ADJUSTMENT_COEF', 'SET_APPRAISAL_BEC_PROPERTY_TYPE', 'SET_APPRAISAL_BEC_NUMBER', 'SET_APPRAISAL_CONSTRUCTION_STATUS', 'SET_APPRAISAL_ADJUSTED_BEC_PRICE', 'SET_APPRAISAL_EXPENSES_AND_INDUSTRIAL_BENEFIT_BEC_PCT', 'SET_APPRAISAL_ADOPTED_MATERIAL_EXECUTION_COST', 'SET_APPRAISAL_CONSTRUCTION_COST_NOTES', 'SET_APPRAISAL_CADASTRAL_CONSTRUCTION_YEAR', 'SET_APPRAISAL_CONSTRUCTION_YEAR', 'SET_APPRAISAL_LAST_RENOVATION_YEAR', 'SET_APPRAISAL_NUCLEUS_POPULATION', 'SET_APPRAISAL_NUCLEUS_POPULATION_DENSITY', 'SET_APPRAISAL_NUCLEUS_POPULATION_GROWTH', 'SET_APPRAISAL_OCCUPATION_AGRICULTURE_PCT', 'SET_APPRAISAL_OCCUPATION_INDUSTRY_PCT', 'SET_APPRAISAL_OCCUPATION_CONSTRUCTION_PCT', 'SET_APPRAISAL_OCCUPATION_SERVICES_PCT', 'SET_APPRAISAL_OCCUPATION_TOTAL_PCT', 'SET_APPRAISAL_NUCLEUS_TYPE', 'SET_APPRAISAL_OCCUPATION_DESCRIPTION', 'SET_APPRAISAL_NUCLEUS_AREA', 'SET_APPRAISAL_CHECKS_OTHER', 'SET_APPRAISAL_DOCS_OTHER', 'SET_APPRAISAL_CHECKS_CADASTRAL_DATA', 'SET_APPRAISAL_CHECKS_CONSERVATION_STATUS', 'SET_APPRAISAL_CHECKS_EXPROPRIATION_PROCEDURE', 'SET_APPRAISAL_CHECKS_EXPROPRIATION_PLAN', 'SET_APPRAISAL_CHECKS_EXPROPRIATION_ADMIN_RULING', 'SET_APPRAISAL_CHECKS_EXPROPRIATION_FILE', 'SET_APPRAISAL_CHECKS_INTERIOR_VISIT', 'SET_APPRAISAL_CHECKS_OCCUPANCY', 'SET_APPRAISAL_CHECKS_REGISTRY_DATA', 'SET_APPRAISAL_CHECKS_SERVITUDES', 'SET_APPRAISAL_CHECKS_SUBSIDY_STATUS', 'SET_APPRAISAL_CHECKS_URBAN_PLANNING', 'SET_APPRAISAL_DOCS_APPROVED_PROJECT', 'SET_APPRAISAL_DOCS_CADASTRAL_DATA', 'SET_APPRAISAL_DOCS_CONSTRUCTION_LICENSE', 'SET_APPRAISAL_DOCS_CONSTRUCTION_LAST_CERTIFICATE', 'SET_APPRAISAL_DOCS_CONSTRUCTION_CONTRACT', 'SET_APPRAISAL_DOCS_OCCUPANCY_STATUS', 'SET_APPRAISAL_DOCS_PHOTOGRAPHIC_REPORT', 'SET_APPRAISAL_DOCS_PROPERTY_SKETCH', 'SET_APPRAISAL_DOCS_PROPERTY_TITLES', 'SET_APPRAISAL_DOCS_SITUATION_PLAN', 'SET_APPRAISAL_DOCS_SUBSIDY_STATUS', 'SET_APPRAISAL_DOCS_TENYEAR_INSURANCE', 'SET_APPRAISAL_DOCS_URBAN_PLAN', 'SET_APPRAISAL_USEFUL_LIFE_YEARS', 'SET_APPRAISAL_PROPERTY_TITLE', 'SET_APPRAISAL_USAGE_ASSIGNED', 'SET_APPRAISAL_INSPECTION_REALIZED', 'SET_APPRAISAL_ECONOMICAL_ACTIVITY', 'SET_APPRAISAL_OCCUPANCY_STATUS', 'SET_APPRAISAL_MARKETSTUDY_ID', 'SET_APPRAISAL_TECHNICIAN_VISITING', 'DELETE_PHOTOGRAPH', 'FETCH_APPRAISAL_PHOTOGRAPHS', 'SET_PHOTOGRAPH', 'SET_PHOTOGRAPH_IS_COVER_PHOTO', 'UPDATE_PHOTOGRAPH', 'UPLOAD_PHOTOGRAPH_FILE', 'UPLOAD_PHOTOGRAPH_FILES', 'DELETE_REGISTRYANNEX', 'FETCH_APPRAISAL_REGISTRYANNEXES', 'SET_REGISTRYANNEX', 'UPLOAD_REGISTRYANNEX_FILE', 'UPLOAD_REGISTRYANNEX_FILES', 'DELETE_CADASTERANNEX', 'FETCH_APPRAISAL_CADASTERANNEXES', 'SET_CADASTERANNEX', 'UPLOAD_CADASTERANNEX_FILE', 'UPLOAD_CADASTERANNEX_FILES', 'DELETE_URBANANNEX', 'FETCH_APPRAISAL_URBANANNEXES', 'SET_URBANANNEX', 'UPLOAD_URBANANNEX_FILE', 'UPLOAD_URBANANNEX_FILES', 'DELETE_PLANANNEX', 'FETCH_APPRAISAL_PLANANNEXES', 'SET_PLANANNEX', 'UPLOAD_PLANANNEX_FILE', 'UPLOAD_PLANANNEX_FILES', 'DELETE_CESSIONANNEX', 'FETCH_APPRAISAL_CESSIONANNEXES', 'SET_CESSIONANNEX', 'UPLOAD_CESSIONANNEX_FILE', 'UPLOAD_CESSIONANNEX_FILES', 'DELETE_OTHERANNEX', 'FETCH_APPRAISAL_OTHERANNEXES', 'SET_OTHERANNEX', 'UPLOAD_OTHERANNEX_FILE', 'UPLOAD_OTHERANNEX_FILES', 'SET_APPRAISALREPORT_COVER_PHOTO_URL', 'SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_OFFSET_X', 'SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_OFFSET_Y', 'SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_ZOOM', 'SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_OFFSET_X', 'SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_OFFSET_Y', 'SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_ZOOM', 'SET_APPRAISAL_MAP_URBAN_ICC_TOPO_OFFSET_X', 'SET_APPRAISAL_MAP_URBAN_ICC_TOPO_OFFSET_Y', 'SET_APPRAISAL_MAP_URBAN_ICC_TOPO_ZOOM', 'SET_APPRAISAL_QUOTE_TRAVEL_ONE_WAY_HOURS', 'SET_APPRAISAL_QUOTE_TRAVEL_BOTH_WAYS_HOURS', 'SET_APPRAISAL_QUOTE_TRAVEL_FEES_PER_HOUR', 'SET_APPRAISAL_QUOTE_CAR_EXPENSES_ONE_WAY', 'SET_APPRAISAL_QUOTE_CAR_EXPENSES_BOTH_WAYS', 'SET_APPRAISAL_QUOTE_TOTAL_TRAVEL_FEES', 'SET_APPRAISAL_QUOTE_AREA_AVERAGE_UNIT_PRICE', 'SET_APPRAISAL_QUOTE_BASE_FEES', 'SET_APPRAISAL_QUOTE_EXCESS_PCT', 'SET_APPRAISAL_QUOTE_BASE_PRICE', 'SET_APPRAISAL_QUOTE_BASE_PRICE_COEF', 'SET_APPRAISAL_I_PCT', 'SET_REALESTATE_INVOICE_BASE_FEES', 'SET_REALESTATE_INVOICE_EXCESS_PCT', 'SET_REALESTATE_INVOICE_BASE_PRICE', 'SET_REALESTATE_INVOICE_BASE_PRICE_COEF', 'SET_REALESTATE_INVOICE_APPRAISAL_TYPE_IS_ECO', 'SET_REALESTATE_INVOICE_PRICE_INCL_TRAVEL_EXPENSES', 'SET_APPRAISAL_USAGE_TYPE', 'SET_APPRAISAL_PARKING_SPOTS_INCLUDED_NUMBER']), {
        set_appraisal_i_pct: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_I_PCT(Number(e.target.value));
            this.recalcAppraisal();
        }, 500),
        set_appraisal_bc_pct: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_BC_PCT(Number(e.target.value));
            this.recalcAppraisal();
        }, 1000),
        set_appraisal_gc_pct: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_GC_PCT(Number(e.target.value));
            this.recalcAppraisal();
        }, 1000),
        set_appraisal_appraisaldate: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this2 = this;

            this.SET_APPRAISAL_APPRAISALDATE(e.target.value).then(function () {
                _this2.recalcMarketAndAppraisals();
            });
        }, 1000),
        set_appraisal_visitdate: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_VISITDATE(e.target.value).then(function () {});
        }, 1000),
        set_appraisal_technician_visiting: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_TECHNICIAN_VISITING(e);
        }, 1000),
        set_appraisal_description: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_DESCRIPTION(e.target.value);
        }, 1000),
        set_appraisal_reduction_pct: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this3 = this;

            this.SET_APPRAISAL_REDUCTION_PCT(Number(e.target.value)).then(function () {
                _this3.recalcMarketAndAppraisals();
                _this3.recalcAppraisal();
            });
        }, 1000),
        set_appraisal_total_construction_progress_pct: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this4 = this;

            this.SET_APPRAISAL_TOTAL_CONSTRUCTION_PROGRESS_PCT(Number(e.target.value)).then(function () {
                // this.recalcMarketAndAppraisals()
                _this4.recalcAppraisal();
            });
        }, 1000),
        set_appraisal_purpose: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this5 = this;

            this.master_loading = true;
            var reduction_pct = e.default_reduction_pct;
            /*
            if(this.appraisal.adjustment_coef){
            reduction_pct = this.appraisal.adjustment_coef
            }
            */
            this.SET_APPRAISAL_REDUCTION_PCT(reduction_pct).then(this.SET_APPRAISAL_PURPOSE(e).then(function (res) {
                _this5.SET_APPRAISAL_PURPOSE_NOTES(e.default_notes.name_ca).then(function (res) {
                    _this5.master_loading = false;
                    _this5.recalcMarketAndAppraisals();
                    _this5.recalcAppraisal();
                });
            }));
        }, 0),
        set_appraisal_purpose_notes: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_PURPOSE_NOTES(e.target.value);
        }, 1000),
        set_appraisal_type: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_TYPE(e);
        }, 1000),
        set_appraisal_adopted_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this6 = this;

            this.SET_APPRAISAL_ADOPTED_AREA(Number(e.target.value)).then(function () {
                _this6.recalcMarketAndAppraisals();
            });
        }, 1000),
        set_appraisal_landlord_expenses_pct: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this7 = this;

            var expenses_pct = Number(e.target.value);
            if (expenses_pct > 100) {
                expenses_pct = 100;
            } else if (expenses_pct < 0) {
                expenses_pct = 0;
            } else if (!expenses_pct) {
                expenses_pct = 70;
            }
            var yearly_income = this.appraisal.cession_gross_yearly_income;
            if (!yearly_income) {
                yearly_income = 0;
            }
            var net_yearly_income = this.roundToTwo(yearly_income * (expenses_pct / 100));
            this.SET_APPRAISAL_LANDLORD_EXPENSES_PCT(expenses_pct).then(function () {
                _this7.SET_APPRAISAL_CESSION_NET_YEARLY_INCOME(net_yearly_income).then(function () {
                    _this7.recalcAppraisal();
                });
            });
        }, 1000),
        set_appraisal_market_value_appraiser_adjustment_pct: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_MARKET_VALUE_APPRAISER_ADJUSTMENT_PCT(Number(e.target.value));
            this.recalcAppraisal();
        }, 1000),
        set_appraisal_lift: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this8 = this;

            this.SET_APPRAISAL_LIFT(e.target.value).then(function () {
                _this8.recalcMarketAndAppraisals();
            });
        }, 1000),
        set_appraisal_adopted_age: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this9 = this;

            this.SET_APPRAISAL_ADOPTED_AGE(Number(e.target.value)).then(function () {
                _this9.recalcMarketAndAppraisals();
            });
        }, 1000),
        set_appraisal_property_type: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this10 = this;

            this.SET_APPRAISAL_PROPERTY_TYPE(e).then(function () {
                _this10.recalcMarketAndAppraisals();
            });
        }, 1000),
        set_appraisal_quality_of_neighbourhood: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this11 = this;

            this.SET_APPRAISAL_QUALITY_OF_NEIGHBOURHOOD(e).then(function () {
                _this11.recalcMarketAndAppraisals();
            });
        }, 1000),
        set_appraisal_quality_of_situation: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this12 = this;

            this.SET_APPRAISAL_QUALITY_OF_SITUATION(e).then(function () {
                _this12.recalcMarketAndAppraisals();
            });
        }, 1000),
        set_appraisal_quality_of_construction: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this13 = this;

            this.SET_APPRAISAL_QUALITY_OF_CONSTRUCTION(e).then(function () {
                _this13.recalcMarketAndAppraisals();
            });
        }, 1000),
        set_appraisal_quality_of_realestate: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this14 = this;

            this.SET_APPRAISAL_QUALITY_OF_REALESTATE(e).then(function () {
                _this14.recalcMarketAndAppraisals();
            });
        }, 1000),
        set_appraisal_conservation_status: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this15 = this;

            this.SET_APPRAISAL_CONSERVATION_STATUS(e).then(function () {
                _this15.recalcMarketAndAppraisals();
            });
        }, 1000),
        set_appraisal_material_execution_cost: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this16 = this;

            this.SET_APPRAISAL_MATERIAL_EXECUTION_COST(e.target.value).then(function () {
                _this16.calc_construction_cost();
                _this16.recalcAppraisal();
            });
        }, 1000),
        set_appraisal_mec_adjustment_coef: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this17 = this;

            this.SET_APPRAISAL_MEC_ADJUSTMENT_COEF(e.target.value).then(function () {
                _this17.calc_construction_cost();
                _this17.recalcAppraisal();
            });
        }, 1000),
        set_appraisal_cession_boolean: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this18 = this;

            this.SET_APPRAISAL_CESSION_BOOLEAN(this.appraisal.cession_boolean).then(function () {
                _this18.recalcAppraisal();
            });
        }, 0),
        set_appraisal_right_of_use_boolean: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this19 = this;

            this.SET_APPRAISAL_RIGHT_OF_USE_BOOLEAN(this.appraisal.right_of_use_boolean).then(function () {
                _this19.recalcAppraisal();
            });
        }, 0),
        set_appraisal_cession_gross_monthly_income: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this20 = this;

            var monthly_income = Number(e.target.value);
            var yearly_income = this.roundToTwo(monthly_income * 12);
            var expenses_pct = this.appraisal.landlord_expenses_pct;
            if (!expenses_pct) {
                expenses_pct = 70;
            }
            var net_yearly_income = this.roundToTwo(yearly_income * (expenses_pct / 100));
            this.SET_APPRAISAL_CESSION_GROSS_MONTHLY_INCOME(monthly_income).then(function () {
                _this20.SET_APPRAISAL_CESSION_GROSS_YEARLY_INCOME(yearly_income);
                _this20.SET_APPRAISAL_CESSION_NET_YEARLY_INCOME(net_yearly_income).then(function () {
                    _this20.recalcAppraisal();
                });
            });
        }, 500),
        set_appraisal_cession_gross_yearly_income: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this21 = this;

            var yearly_income = Number(e.target.value);
            var monthly_income = this.roundToTwo(yearly_income / 12);
            var expenses_pct = this.appraisal.landlord_expenses_pct;
            if (!expenses_pct) {
                expenses_pct = 70;
            }
            var net_yearly_income = this.roundToTwo(yearly_income * (expenses_pct / 100));
            this.SET_APPRAISAL_CESSION_GROSS_YEARLY_INCOME(Number(yearly_income)).then(function () {
                _this21.SET_APPRAISAL_CESSION_GROSS_MONTHLY_INCOME(monthly_income);
                _this21.SET_APPRAISAL_CESSION_NET_YEARLY_INCOME(net_yearly_income).then(function () {
                    _this21.recalcAppraisal();
                });
            });
        }, 500),
        set_appraisal_cession_net_yearly_income: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this22 = this;

            this.SET_APPRAISAL_CESSION_NET_YEARLY_INCOME(Number(e.target.value)).then(function () {
                _this22.recalcAppraisal();
            });
        }, 500),
        set_appraisal_cession_contract_period_years: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this23 = this;

            this.SET_APPRAISAL_CESSION_CONTRACT_PERIOD_YEARS(Number(e.target.value)).then(function () {
                _this23.set_appraisal_cession_contract_remaining_years();
            });
        }, 500),
        set_appraisal_cession_contract_remaining_years: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this24 = this;

            var a = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.appraisal.appraisaldate);
            var b = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.appraisal.cession_contract_start_date).add(this.appraisal.cession_contract_period_years, 'years');
            var diff_years = this.roundToTwo(b.diff(a, 'years', true));
            this.SET_APPRAISAL_CESSION_CONTRACT_REMAINING_YEARS(diff_years).then(function () {
                _this24.recalcAppraisal();
            });
        }, 500),
        set_appraisal_cession_contract_start_date: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this25 = this;

            this.SET_APPRAISAL_CESSION_CONTRACT_START_DATE(e.target.value).then(function () {
                _this25.set_appraisal_cession_contract_remaining_years();
            });
        }, 500),
        set_appraisal_tenant_age_years: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this26 = this;

            var age = Number(e.target.value);
            var life_expectancy = this.appraisal.tenant_life_expectancy_years;
            if (!life_expectancy) {
                life_expectancy = 80;
            }
            var remaining_years = life_expectancy - age;

            this.SET_APPRAISAL_TENANT_LIFE_EXPECTANCY_YEARS(life_expectancy);
            this.SET_APPRAISAL_TENANT_AGE_YEARS(age);
            this.SET_APPRAISAL_TENANT_REMAINING_LIFE_EXPECTANCY_YEARS(remaining_years).then(function () {
                _this26.recalcAppraisal();
            });
        }, 500),
        set_appraisal_tenant_life_expectancy_years: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this27 = this;

            var life_expectancy = Number(e.target.value);

            console.log('life_expectancy: ');
            console.log(life_expectancy);

            var age = this.appraisal.tenant_age_years;
            if (!age) {
                age = 35;
            }

            console.log('age: ');
            console.log(age);

            var remaining_years = life_expectancy - age;

            console.log('remaining_years: ');
            console.log(remaining_years);

            this.SET_APPRAISAL_TENANT_LIFE_EXPECTANCY_YEARS(life_expectancy);
            this.SET_APPRAISAL_TENANT_AGE_YEARS(age);
            this.SET_APPRAISAL_TENANT_REMAINING_LIFE_EXPECTANCY_YEARS(remaining_years).then(function () {
                _this27.recalcAppraisal();
            });
        }, 500),
        set_appraisal_tenant_remaining_life_expectancy_years: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this28 = this;

            this.SET_APPRAISAL_TENANT_REMAINING_LIFE_EXPECTANCY_YEARS(Number(e.target.value)).then(function () {
                _this28.recalcAppraisal();
            });
        }, 500),
        set_appraisal_useful_life_years: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this29 = this;

            this.SET_APPRAISAL_USEFUL_LIFE_YEARS(Number(e.target.value)).then(function () {
                _this29.recalcAppraisal();
            });
        }, 1000),
        set_appraisal_remaining_useful_life_years: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this30 = this;

            this.SET_APPRAISAL_REMAINING_USEFUL_LIFE_YEARS(Number(e.target.value)).then(function () {
                _this30.recalcAppraisal();
            });
        }, 1000),
        set_appraisal_usufructuary_age_years: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this31 = this;

            this.SET_APPRAISAL_USUFRUCTUARY_AGE_YEARS(Number(e.target.value)).then(function () {
                _this31.recalcAppraisal();
            });
        }, 1000),
        set_appraisal_protection_boolean: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this32 = this;

            this.SET_APPRAISAL_PROTECTION_BOOLEAN(this.appraisal.protection_boolean).then(function () {
                _this32.recalcAppraisal();
            });
        }, 0),
        set_appraisal_protection_type: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_PROTECTION_TYPE(e);
        }, 1000),
        set_appraisal_protection_regime: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_PROTECTION_REGIME(e);
        }, 1000),
        set_appraisal_protection_zone: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_PROTECTION_ZONE(e);
        }, 1000),
        set_appraisal_max_legal_price: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this33 = this;

            this.SET_APPRAISAL_MAX_LEGAL_PRICE(Number(e.target.value)).then(function () {
                _this33.recalcAppraisal();
            });
        }, 1000),
        set_appraisal_max_legal_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this34 = this;

            this.SET_APPRAISAL_MAX_LEGAL_AREA(Number(e.target.value)).then(function () {
                _this34.recalcAppraisal();
            });
        }, 1000),
        set_appraisal_urban_planning_type: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_URBAN_PLANNING_TYPE(e.target.value);
        }, 1000),
        set_appraisal_urban_planning_file: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_URBAN_PLANNING_FILE(e.target.value);
        }, 1000),
        set_appraisal_urban_planning_council_qualification: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_URBAN_PLANNING_COUNCIL_QUALIFICATION(e.target.value);
        }, 1000),
        set_appraisal_urban_planning_council_qualification_description: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_URBAN_PLANNING_COUNCIL_QUALIFICATION_DESCRIPTION(e.target.value);
        }, 1000),
        set_appraisal_urban_planning_council_classification: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_URBAN_PLANNING_COUNCIL_CLASSIFICATION(e.target.value);
        }, 1000),
        set_appraisal_urban_planning_council_classification_description: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_URBAN_PLANNING_COUNCIL_CLASSIFICATION_DESCRIPTION(e.target.value);
        }, 1000),
        set_appraisal_urban_planning_regional_qualification: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_URBAN_PLANNING_REGIONAL_QUALIFICATION(e.target.value);
        }, 1000),
        set_appraisal_urban_planning_regional_qualification_description: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_URBAN_PLANNING_REGIONAL_QUALIFICATION_DESCRIPTION(e.target.value);
        }, 1000),
        set_appraisal_urban_planning_regional_classification: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_URBAN_PLANNING_REGIONAL_CLASSIFICATION(e.target.value);
        }, 1000),
        set_appraisal_urban_planning_regional_classification_description: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_URBAN_PLANNING_REGIONAL_CLASSIFICATION_DESCRIPTION(e.target.value);
        }, 1000),
        set_appraisal_land_registry_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var registry_area = Number(e.target.value);
            var cadastral_area = this.appraisal.land_cadastral_area;
            var checked_area = this.appraisal.land_checked_area;
            var adopted_area = this.calc_land_adopted_area(registry_area, cadastral_area, checked_area);

            this.SET_APPRAISAL_LAND_REGISTRY_AREA(registry_area);
            this.SET_APPRAISAL_LAND_ADOPTED_AREA(adopted_area);
        }, 1000),
        set_appraisal_land_cadastral_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var registry_area = this.appraisal.land_registry_area;
            var cadastral_area = Number(e.target.value);
            var checked_area = this.appraisal.land_checked_area;
            var adopted_area = this.calc_land_adopted_area(registry_area, cadastral_area, checked_area);

            this.SET_APPRAISAL_LAND_CADASTRAL_AREA(cadastral_area);
            this.SET_APPRAISAL_LAND_ADOPTED_AREA(adopted_area);
        }, 1000),
        set_appraisal_land_checked_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var registry_area = this.appraisal.land_registry_area;
            var cadastral_area = this.appraisal.land_cadastral_area;
            var checked_area = Number(e.target.value);
            var adopted_area = this.calc_land_adopted_area(registry_area, cadastral_area, checked_area);

            this.SET_APPRAISAL_LAND_CHECKED_AREA(checked_area);
            this.SET_APPRAISAL_LAND_ADOPTED_AREA(adopted_area);
        }, 1000),
        set_appraisal_land_adopted_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_LAND_ADOPTED_AREA(Number(e.target.value));
        }, 1000),
        set_room_description: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e, f) {
            var _this35 = this;

            // this.master_loading = true
            this.editing_room = true;
            this.editing_room_text_color = 'whitesmoke';
            this.editing_room_border_color = 'whitesmoke';
            var description = e.target.value;
            var obj = this.appraisal_rooms;
            var id = f['id'];
            obj[id]['description'] = description;

            this.UPDATE_APPRAISAL_ROOMS({ appraisal_id: this.appraisal.id, object: obj }).then(function (res) {
                _this35.master_loading = false;
                _this35.editing_room = false;
                _this35.editing_room_text_color = 'black';
                _this35.editing_room_border_color = 'lightgray';
            });
        }, 0),
        set_room_type: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e, f) {
            var _this36 = this;

            // this.master_loading = true
            this.editing_room = true;
            this.editing_room_text_color = 'whitesmoke';
            this.editing_room_border_color = 'whitesmoke';
            var type = e;
            var obj = this.appraisal_rooms;
            var id = f['id'];
            obj[id]['type'] = type;

            this.UPDATE_APPRAISAL_ROOMS({ appraisal_id: this.appraisal.id, object: obj }).then(function (res) {
                _this36.calc_rooms_number(_this36.object_to_array(obj));
                _this36.master_loading = false;
                _this36.editing_room = false;
                _this36.editing_room_text_color = 'black';
                _this36.editing_room_border_color = 'lightgray';
            });
        }, 0),
        set_room_netarea: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e, f) {
            var _this37 = this;

            // this.master_loading = true
            this.editing_room = true;
            this.editing_room_text_color = 'whitesmoke';
            this.editing_room_border_color = 'whitesmoke';
            var value = e.target.value;
            if (!value) {
                value = 0;
            }
            var netarea = Number(value);
            var obj = this.appraisal_rooms;
            var id = f['id'];
            obj[id]['netarea'] = netarea;

            this.UPDATE_APPRAISAL_ROOMS({ appraisal_id: this.appraisal.id, object: obj }).then(function (res) {
                _this37.calc_net_area(_this37.object_to_array(obj));
                _this37.calc_adopted_areas();
                _this37.master_loading = false;
                _this37.editing_room = false;
                _this37.editing_room_text_color = 'black';
                _this37.editing_room_border_color = 'lightgray';
            });
        }, 0),
        set_covered_outdoor_description: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e, f) {
            var _this38 = this;

            this.editing_covered_outdoor = true;
            this.editing_covered_outdoor_text_color = 'whitesmoke';
            this.editing_covered_outdoor_border_color = 'whitesmoke';

            var description = e.target.value;
            var obj = this.appraisal_covered_outdoors;
            var id = f['id'];
            obj[id]['description'] = description;

            this.UPDATE_APPRAISAL_COVERED_OUTDOORS({ appraisal_id: this.appraisal.id, object: obj }).then(function (res) {
                _this38.master_loading = false;
                _this38.editing_covered_outdoor = false;
                _this38.editing_covered_outdoor_text_color = 'black';
                _this38.editing_covered_outdoor_border_color = 'lightgray';
            });
        }, 0),
        set_covered_outdoor_type: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e, f) {
            this.editing_covered_outdoor = true;
            this.editing_covered_outdoor_text_color = 'whitesmoke';
            this.editing_covered_outdoor_border_color = 'whitesmoke';

            var type = e;
            var obj = this.appraisal_covered_outdoors;
            var id = f['id'];
            obj[id]['type'] = type;

            this.SET_APPRAISAL_COVERED_OUTDOORS(obj).then(function (res) {});
        }, 0),
        set_covered_outdoor_netarea: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e, f) {
            var _this39 = this;

            this.editing_covered_outdoor = true;
            this.editing_covered_outdoor_text_color = 'whitesmoke';
            this.editing_covered_outdoor_border_color = 'whitesmoke';

            var value = e.target.value;
            if (!value) {
                value = 0;
            }
            var netarea = Number(value);
            var obj = this.appraisal_covered_outdoors;
            var id = f['id'];
            obj[id]['netarea'] = netarea;

            this.UPDATE_APPRAISAL_COVERED_OUTDOORS({ appraisal_id: this.appraisal.id, object: obj }).then(function (res) {
                _this39.calc_covered_outdoors_net_area(_this39.object_to_array(obj));
                _this39.calc_adopted_areas();
                _this39.master_loading = false;
                _this39.editing_covered_outdoor = false;
                _this39.editing_covered_outdoor_text_color = 'black';
                _this39.editing_covered_outdoor_border_color = 'lightgray';
            });
        }, 0),
        set_uncovered_outdoor_description: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e, f) {
            var _this40 = this;

            this.editing_uncovered_outdoor = true;
            this.editing_uncovered_outdoor_text_color = 'whitesmoke';
            this.editing_uncovered_outdoor_border_color = 'whitesmoke';

            var description = e.target.value;
            var obj = this.appraisal_uncovered_outdoors;
            var id = f['id'];
            obj[id]['description'] = description;

            this.UPDATE_APPRAISAL_UNCOVERED_OUTDOORS({ appraisal_id: this.appraisal.id, object: obj }).then(function (res) {
                _this40.master_loading = false;
                _this40.editing_uncovered_outdoor = false;
                _this40.editing_uncovered_outdoor_text_color = 'black';
                _this40.editing_uncovered_outdoor_border_color = 'lightgray';
            });
        }, 0),
        set_uncovered_outdoor_type: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e, f) {
            var _this41 = this;

            this.editing_uncovered_outdoor = true;
            this.editing_uncovered_outdoor_text_color = 'whitesmoke';
            this.editing_uncovered_outdoor_border_color = 'whitesmoke';

            var type = e;
            var obj = this.appraisal_uncovered_outdoors;
            var id = f['id'];
            obj[id]['type'] = type;

            this.UPDATE_APPRAISAL_UNCOVERED_OUTDOORS({ appraisal_id: this.appraisal.id, object: obj }).then(function (res) {
                _this41.master_loading = false;
                _this41.editing_uncovered_outdoor = false;
                _this41.editing_uncovered_outdoor_text_color = 'black';
                _this41.editing_uncovered_outdoor_border_color = 'lightgray';
            });
        }, 0),
        set_uncovered_outdoor_netarea: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e, f) {
            var _this42 = this;

            this.editing_uncovered_outdoor = true;
            this.editing_uncovered_outdoor_text_color = 'whitesmoke';
            this.editing_uncovered_outdoor_border_color = 'whitesmoke';

            var value = e.target.value;
            if (!value) {
                value = 0;
            }
            var netarea = Number(value);
            var obj = this.appraisal_uncovered_outdoors;
            var id = f['id'];
            obj[id]['netarea'] = netarea;

            this.UPDATE_APPRAISAL_UNCOVERED_OUTDOORS({ appraisal_id: this.appraisal.id, object: obj }).then(function (res) {
                _this42.calc_uncovered_outdoors_net_area(_this42.object_to_array(obj));
                _this42.calc_adopted_areas();
                _this42.master_loading = false;
                _this42.editing_uncovered_outdoor = false;
                _this42.editing_uncovered_outdoor_text_color = 'black';
                _this42.editing_uncovered_outdoor_border_color = 'lightgray';
            });
        }, 0),
        set_appraisal_bathrooms_number: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_BATHROOMS_NUMBER(Number(e.target.value));
        }, 1000),
        set_appraisal_bedrooms_number: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_BEDROOMS_NUMBER(Number(e.target.value));
        }, 1000),
        set_appraisal_net_selected_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_NET_SELECTED_AREA(e);
            this.calc_adopted_areas();
        }, 1000),
        set_appraisal_enclosed_selected_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_ENCLOSED_SELECTED_AREA(e);
            this.calc_adopted_areas();
        }, 1000),
        set_appraisal_covered_outdoors_selected_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_COVERED_OUTDOORS_SELECTED_AREA(e);
            this.calc_adopted_areas();
        }, 1000),
        set_appraisal_built_selected_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_BUILT_SELECTED_AREA(e);
            this.calc_adopted_areas();
        }, 1000),
        set_appraisal_common_elements_selected_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_COMMON_ELEMENTS_SELECTED_AREA(e);
            this.calc_adopted_areas();
        }, 1000),
        set_appraisal_built_plus_common_elements_selected_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_SELECTED_AREA(e);
            this.calc_adopted_areas();
        }, 1000),
        set_appraisal_land_selected_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_LAND_SELECTED_AREA(e);

            var registry_area = this.appraisal.land_registry_area;
            var cadastral_area = this.appraisal.land_cadastral_area;
            var checked_area = this.appraisal.land_checked_area;
            var adopted_area = this.calc_land_adopted_area(registry_area, cadastral_area, checked_area);
            this.SET_APPRAISAL_LAND_ADOPTED_AREA(adopted_area);
        }, 0),
        set_appraisal_bec_adjustment_coef: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this43 = this;

            var bec_price = this.appraisal.bec_number.total;
            var coef = Number(e.target.value);
            var adjusted_bec_price = this.roundToTwo(bec_price * coef);
            var desp_pct = this.appraisal.expenses_and_industrial_benefit_bec_pct;
            var mec = this.roundToTwo(adjusted_bec_price / (1 + desp_pct / 100));
            var mec_coef = this.appraisal.mec_adjustment_coef;
            var adopted_mec = this.roundToTwo(mec * mec_coef);

            this.SET_APPRAISAL_ADJUSTED_BEC_PRICE(adjusted_bec_price);
            this.SET_APPRAISAL_MATERIAL_EXECUTION_COST(mec);
            this.SET_APPRAISAL_ADOPTED_MATERIAL_EXECUTION_COST(adopted_mec);

            this.SET_APPRAISAL_BEC_ADJUSTMENT_COEF(coef).then(function () {
                _this43.calc_construction_cost();
                _this43.recalcAppraisal();
            });
        }, 1000),
        set_appraisal_bec_property_type: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this44 = this;

            this.SET_APPRAISAL_BEC_NUMBER(null);
            this.master_loading = true;
            this.SET_APPRAISAL_BEC_PROPERTY_TYPE(e).then(function () {
                _this44.FETCH_APPRAISAL_BEC_PRICES({ path: 'becproperty_becprices' + '/' + _this44.appraisal.bec_property_type.id }).then(function () {
                    _this44.master_loading = false;
                });
            });
        }, 0),
        set_appraisal_bec_number: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this45 = this;

            this.SET_APPRAISAL_BEC_NUMBER(e).then(function () {
                _this45.calc_construction_cost();
                _this45.recalcAppraisal();
            });
        }, 1000),
        set_appraisal_construction_status: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_CONSTRUCTION_STATUS(e);
        }, 1000),
        set_appraisal_quote_travel_one_way_hours: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {

            var hours = Number(e.target.value);
            this.SET_APPRAISAL_QUOTE_TRAVEL_ONE_WAY_HOURS(hours);

            if (hours > 0) {
                this.SET_APPRAISAL_QUOTE_TRAVEL_BOTH_WAYS_HOURS(hours * 2);
            } else if (hours === 0 || !hours) {
                this.SET_APPRAISAL_QUOTE_TRAVEL_BOTH_WAYS_HOURS(0);
            }
            this.set_appraisal_quote_total_travel_fees();
        }, 1000),
        set_appraisal_quote_travel_both_ways_hours: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_QUOTE_TRAVEL_BOTH_WAYS_HOURS(Number(e.target.value));
        }, 1000),
        set_appraisal_quote_travel_fees_per_hour: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_QUOTE_TRAVEL_FEES_PER_HOUR(Number(e.target.value));
            this.set_appraisal_quote_total_travel_fees();
        }, 1000),
        set_appraisal_quote_car_expenses_one_way: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {

            var expenses = Number(e.target.value);
            this.SET_APPRAISAL_QUOTE_CAR_EXPENSES_ONE_WAY(expenses);

            if (expenses > 0) {
                this.SET_APPRAISAL_QUOTE_CAR_EXPENSES_BOTH_WAYS(expenses * 2);
            } else if (expenses === 0 || !expenses) {
                this.SET_APPRAISAL_QUOTE_CAR_EXPENSES_BOTH_WAYS(0);
            }

            this.set_appraisal_quote_total_travel_fees();
        }, 1000),
        set_appraisal_quote_car_expenses_both_ways: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_QUOTE_CAR_EXPENSES_BOTH_WAYS(Number(e.target.value));
        }, 1000),
        set_appraisal_quote_total_travel_fees: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {

            var travel_expenses = this.appraisal.quote_car_expenses_both_ways;

            var hours = this.appraisal.quote_travel_both_ways_hours;

            if (!this.appraisal.quote_travel_both_ways_hours) {
                hours = 0;
            }

            var hourly_fees = this.appraisal.quote_travel_fees_per_hour;

            if (!this.appraisal.quote_travel_fees_per_hour) {
                hourly_fees = 0;
            }
            var travel_fees = hours * hourly_fees;
            var total = travel_expenses + travel_fees;

            this.SET_APPRAISAL_QUOTE_TOTAL_TRAVEL_FEES(total);
        }, 1000),
        set_appraisal_quote_area_average_unit_price: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_QUOTE_AREA_AVERAGE_UNIT_PRICE(Number(e.target.value));
        }, 1000),
        set_appraisal_quote_base_fees: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_QUOTE_BASE_FEES(Number(e.target.value));
        }, 1000),
        set_appraisal_quote_excess_pct: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_QUOTE_EXCESS_PCT(Number(e.target.value));
        }, 1000),
        set_appraisal_quote_base_price: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_QUOTE_BASE_PRICE(Number(e.target.value));
        }, 1000),
        set_appraisal_quote_base_price_coef: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_QUOTE_BASE_PRICE_COEF(Number(e.target.value));
        }, 1000),
        onOpenCadastralFile: function onOpenCadastralFile() {
            console.log('opening cadastral file...');
            // const url = 'https://www.whatismyreferer.com/'
            var refcat = this.realestate.cadastral_reference;
            if (refcat.length < 20) {
                alert('La referència cadastral té menys de 20 posicions. Revisar');
            }
            var url = 'https://www1.sedecatastro.gob.es/CYCBienInmueble/OVCConCiud.aspx?del=' + this.realestate.municipality.cadaster_province_code + '&mun=' + this.realestate.municipality.cadaster_municipality_code + '&UrbRus=U&RefC=' + refcat + '&Apenom=&esBice=&RCBice1=&RCBice2=&DenoBice=';
            console.log(url);
            var win = window.open(url, '_blank');
            win.focus();
        },
        onOpenMarketStudy: function onOpenMarketStudy() {
            if (this.appraisal.dirty) {
                var result = window.confirm(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Changes_will_be_lost_p_continue_q'));

                if (result) {
                    this.$router.push({
                        name: 'marketstudy-editor',
                        query: { id: this.appraisal.marketstudy_id, appraisal_id: this.appraisal.id }
                    });
                } else {
                    return false;
                }
            } else {
                this.$router.push({
                    name: 'marketstudy-editor',
                    query: { id: this.appraisal.marketstudy_id, appraisal_id: this.appraisal.id }
                });
            }
        },
        calc_construction_cost: function calc_construction_cost() {
            var bec_price = this.appraisal.bec_number.total;
            var coef = this.appraisal.bec_adjustment_coef;
            var adjusted_bec_price = this.roundToTwo(bec_price * coef);
            var desp_pct = this.appraisal.expenses_and_industrial_benefit_bec_pct;
            var mec = this.roundToTwo(adjusted_bec_price / (1 + desp_pct / 100));
            var mec_coef = this.appraisal.mec_adjustment_coef;
            var adopted_mec = this.roundToTwo(mec * mec_coef);

            this.SET_APPRAISAL_ADJUSTED_BEC_PRICE(adjusted_bec_price);
            this.SET_APPRAISAL_MATERIAL_EXECUTION_COST(mec);
            this.SET_APPRAISAL_ADOPTED_MATERIAL_EXECUTION_COST(adopted_mec);
        },
        calc_rooms_number: function calc_rooms_number(rooms_array) {

            var total_bathrooms = 0;
            var total_bedrooms = 0;

            for (var i = 0; i < rooms_array.length; i++) {
                if (rooms_array[i].type) {
                    var type = rooms_array[i].type.code_ca;
                    if (type === 'CH') {
                        total_bathrooms = total_bathrooms + 1;
                    } else if (type === 'H') {
                        total_bedrooms = total_bedrooms + 1;
                    }
                }
            }
            this.SET_APPRAISAL_BATHROOMS_NUMBER(total_bathrooms);
            this.SET_APPRAISAL_BEDROOMS_NUMBER(total_bedrooms);
        },
        check_adopted_area: function check_adopted_area(registry_area, cadastral_area, checked_area, selected_area) {

            var adopted_area = 0;

            if (selected_area === 'Registral') {
                // console.log('A')
                adopted_area = registry_area;
            } else if (selected_area === 'Cadastral') {
                // console.log('B')
                adopted_area = cadastral_area;
            } else if (selected_area === 'Comprovada') {
                // console.log('C')
                adopted_area = checked_area;
            } else {
                if (!checked_area) {
                    checked_area = 0;
                }

                if (!registry_area) {
                    registry_area = 0;
                }

                if (!checked_area) {
                    checked_area = 0;
                }

                if (registry_area > 0 && registry_area < checked_area * 0.8) {
                    if (cadastral_area > 0 && cadastral_area < checked_area * 0.8) {
                        if (registry_area < cadastral_area) {
                            // console.log('D11')
                            adopted_area = registry_area;
                        } else {
                            // console.log('D12')
                            adopted_area = cadastral_area;
                        }
                    }
                    // console.log('D1')
                    adopted_area = registry_area;
                } else if (cadastral_area > 0 && cadastral_area < checked_area * 0.8) {
                    // console.log('D2')
                    adopted_area = cadastral_area;
                } else if (checked_area === 0) {
                    if (cadastral_area > 0 && registry_area > 0) {
                        if (cadastral_area < registry_area) {
                            // console.log('D31')

                            adopted_area = cadastral_area;
                        } else {
                            // console.log('D32')

                            adopted_area = registry_area;
                        }
                    } else if (cadastral_area > 0 && registry_area === 0) {
                        // console.log('D4')

                        adopted_area = cadastral_area;
                    } else if (registry_area > 0 && cadastral_area === 0) {
                        // console.log('D5')

                        adopted_area = registry_area;
                    }
                    // console.log('D6')
                    adopted_area = cadastral_area;
                } else {
                    // console.log('D7')
                    adopted_area = checked_area;
                }
            }
            // console.log('-----')
            // console.log('///***/// adopted_area:')
            // console.log(adopted_area)
            return adopted_area;
        },

        calc_adopted_areas: function calc_adopted_areas() {
            var net_registry_area = this.appraisal.net_registry_area;
            var net_cadastral_area = this.appraisal.net_cadastral_area;
            var net_checked_area = this.appraisal.net_checked_area;
            var net_selected_area = 'Auto';
            if (this.appraisal.net_selected_area) {
                net_selected_area = this.appraisal.net_selected_area.name_ca;
            }
            var net_adopted_area = this.check_adopted_area(net_registry_area, net_cadastral_area, net_checked_area, net_selected_area);

            var enclosed_registry_area = this.appraisal.enclosed_registry_area;
            var enclosed_cadastral_area = this.appraisal.enclosed_cadastral_area;
            var enclosed_checked_area = this.appraisal.enclosed_checked_area;
            var enclosed_selected_area = 'Auto';
            if (this.appraisal.enclosed_selected_area) {
                enclosed_selected_area = this.appraisal.enclosed_selected_area.name_ca;
            }
            var enclosed_adopted_area = this.check_adopted_area(enclosed_registry_area, enclosed_cadastral_area, enclosed_checked_area, enclosed_selected_area);

            var covered_terraces_total_registry_area = this.appraisal.covered_terraces_total_registry_area;
            var covered_terraces_total_cadastral_area = this.appraisal.covered_terraces_total_cadastral_area;
            var covered_terraces_total_checked_area = this.appraisal.covered_terraces_total_checked_area;
            var covered_terraces_total_selected_area = 'Auto';
            if (this.appraisal.covered_outdoors_selected_area) {
                covered_terraces_total_selected_area = this.appraisal.covered_outdoors_selected_area.name_ca;
            }
            var covered_terraces_total_adopted_area = this.check_adopted_area(covered_terraces_total_registry_area, covered_terraces_total_cadastral_area, covered_terraces_total_checked_area, covered_terraces_total_selected_area);

            var built_registry_area = this.appraisal.built_registry_area;
            var built_cadastral_area = this.appraisal.built_cadastral_area;
            var built_checked_area = this.roundToTwo(this.appraisal.enclosed_checked_area + this.appraisal.covered_terraces_total_checked_area / 2);

            this.SET_APPRAISAL_BUILT_CHECKED_AREA(built_checked_area);

            var built_selected_area = 'Auto';
            if (this.appraisal.built_selected_area) {
                built_selected_area = this.appraisal.built_selected_area.name_ca;
            }
            var built_adopted_area = this.check_adopted_area(built_registry_area, built_cadastral_area, built_checked_area, built_selected_area);

            var common_elements_registry_area = this.appraisal.common_elements_registry_area;
            var common_elements_cadastral_area = this.appraisal.common_elements_cadastral_area;
            var common_elements_checked_area = this.appraisal.common_elements_checked_area;
            var common_elements_selected_area = 'Auto';
            if (this.appraisal.common_elements_selected_area) {
                common_elements_selected_area = this.appraisal.common_elements_selected_area.name_ca;
            }
            var common_elements_adopted_area = this.check_adopted_area(common_elements_registry_area, common_elements_cadastral_area, common_elements_checked_area, common_elements_selected_area);

            var built_plus_common_elements_registry_area = this.appraisal.built_plus_common_elements_registry_area;
            var built_plus_common_elements_cadastral_area = this.appraisal.built_plus_common_elements_cadastral_area;
            var built_plus_common_elements_checked_area = this.appraisal.built_plus_common_elements_checked_area;
            var built_plus_common_elements_selected_area = 'Auto';
            if (this.appraisal.built_plus_common_elements_selected_area) {
                built_plus_common_elements_selected_area = this.appraisal.built_plus_common_elements_selected_area.name_ca;
            }

            var built_plus_common_elements_adopted_area = 0;

            if (built_plus_common_elements_selected_area === 'Auto') {
                built_plus_common_elements_adopted_area = built_adopted_area + common_elements_adopted_area;
            } else {
                built_plus_common_elements_adopted_area = this.check_adopted_area(built_plus_common_elements_registry_area, built_plus_common_elements_cadastral_area, built_plus_common_elements_checked_area, built_plus_common_elements_selected_area);
            }

            this.SET_APPRAISAL_NET_ADOPTED_AREA(net_adopted_area);
            this.SET_APPRAISAL_ENCLOSED_ADOPTED_AREA(enclosed_adopted_area);
            this.SET_APPRAISAL_COVERED_TERRACES_TOTAL_ADOPTED_AREA(covered_terraces_total_adopted_area);
            this.SET_APPRAISAL_BUILT_ADOPTED_AREA(built_adopted_area);
            this.SET_APPRAISAL_COMMON_ELEMENTS_ADOPTED_AREA(common_elements_adopted_area);
            this.SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_ADOPTED_AREA(built_plus_common_elements_adopted_area);

            this.SET_APPRAISAL_ADOPTED_AREA(built_adopted_area);

            this.recalcAppraisal();
        },
        calc_net_area: function calc_net_area(rooms_array) {
            var partial = 0;
            var total_checked = 0;

            for (var i = 0; i < rooms_array.length; i++) {

                partial = rooms_array[i].netarea;
                total_checked = total_checked + partial;
            }
            console.log('net areas total: ');
            console.log(total_checked);
            this.SET_APPRAISAL_NET_CHECKED_AREA(total_checked);
        },
        calc_covered_outdoors_net_area: function calc_covered_outdoors_net_area(rooms_array) {
            var partial = 0;
            var total_checked = 0;

            for (var i = 0; i < rooms_array.length; i++) {

                partial = rooms_array[i].netarea;
                total_checked = total_checked + partial;
            }
            console.log('covered outdoors total: ');
            console.log(total_checked);
            this.SET_APPRAISAL_COVERED_TERRACES_TOTAL_CHECKED_AREA(total_checked);
        },
        calc_uncovered_outdoors_net_area: function calc_uncovered_outdoors_net_area(rooms_array) {
            var partial = 0;
            var total_checked = 0;

            for (var i = 0; i < rooms_array.length; i++) {

                partial = rooms_array[i].netarea;
                total_checked = total_checked + partial;
            }

            console.log('uncovered outdoors total: ');
            console.log(total_checked);
            this.SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_CHECKED_AREA(total_checked);
        },
        calc_land_adopted_area: function calc_land_adopted_area(registry_area, cadastral_area, checked_area) {

            var method = this.appraisal.land_selected_area;
            var adopted_area = 0;

            if (method.name_en === 'Auto') {
                if (!registry_area) {
                    registry_area = 0;
                }

                if (!cadastral_area) {
                    cadastral_area = 0;
                }

                if (!checked_area) {
                    checked_area = 0;
                }

                if (registry_area === 0) {
                    adopted_area = checked_area;
                } else if (checked_area === 0) {
                    adopted_area = registry_area;
                } else if (registry_area < checked_area * 0.8) {
                    adopted_area = registry_area;
                } else {
                    adopted_area = checked_area;
                }

                if (checked_area === 0) {

                    if (registry_area <= cadastral_area && registry_area > 0) {
                        adopted_area = registry_area;
                    } else if (cadastral_area < registry_area && cadastral_area > 0) {
                        adopted_area = cadastral_area;
                    } else if (cadastral_area > registry_area) {
                        adopted_area = cadastral_area;
                    } else {
                        adopted_area = registry_area;
                    }
                } else {
                    if (registry_area < checked_area * 0.8) {
                        adopted_area = registry_area;
                    } else if (cadastral_area < checked_area * 0.8) {
                        adopted_area = cadastral_area;
                    } else {
                        adopted_area = checked_area;
                    }
                }
            } else if (method.name_en === 'Registry') {
                adopted_area = registry_area;
            } else if (method.name_en === 'Cadastral') {
                adopted_area = cadastral_area;
            } else if (method.name_en === 'Checked') {
                adopted_area = checked_area;
            }

            return adopted_area;
        },
        set_appraisal_land_infrastructure_paving_execution_pct: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_LAND_INFRASTRUCTURE_PAVING_EXECUTION_PCT(Number(e.target.value));
            if (Number(e.target.value) > 0) {
                this.appraisal.land_infrastructure_paving = true;
            }
            this.calc_land_infrastructure_total_execution_pct();
        }, 1000),
        set_appraisal_land_infrastructure_sewage_execution_pct: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_LAND_INFRASTRUCTURE_SEWAGE_EXECUTION_PCT(Number(e.target.value));
            if (Number(e.target.value) > 0) {
                this.appraisal.land_infrastructure_sewage = true;
            }
            this.calc_land_infrastructure_total_execution_pct();
        }, 1000),
        set_appraisal_land_infrastructure_public_lighting_execution_pct: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_LAND_INFRASTRUCTURE_PUBLIC_LIGHTING_EXECUTION_PCT(Number(e.target.value));
            if (Number(e.target.value) > 0) {
                this.appraisal.land_infrastructure_public_lighting = true;
            }
            this.calc_land_infrastructure_total_execution_pct();
        }, 1000),
        set_appraisal_land_infrastructure_water_supply_execution_pct: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_LAND_INFRASTRUCTURE_WATER_SUPPLY_EXECUTION_PCT(Number(e.target.value));
            if (Number(e.target.value) > 0) {
                this.appraisal.land_infrastructure_water_supply = true;
            }
            this.calc_land_infrastructure_total_execution_pct();
        }, 1000),
        set_appraisal_land_infrastructure_electricity_supply_execution_pct: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_LAND_INFRASTRUCTURE_ELECTRICITY_SUPPLY_EXECUTION_PCT(Number(e.target.value));
            if (Number(e.target.value) > 0) {
                this.appraisal.land_infrastructure_electricity_supply = true;
            }
            this.calc_land_infrastructure_total_execution_pct();
        }, 1000),
        set_appraisal_land_infrastructure_piped_gas_execution_pct: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_LAND_INFRASTRUCTURE_PIPED_GAS_EXECUTION_PCT(Number(e.target.value));
            if (Number(e.target.value) > 0) {
                this.appraisal.land_infrastructure_piped_gas = true;
            }
            this.calc_land_infrastructure_total_execution_pct();
        }, 1000),
        set_appraisal_land_infrastructure_telephone_service_execution_pct: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_LAND_INFRASTRUCTURE_TELEPHONE_SERVICE_EXECUTION_PCT(Number(e.target.value));
            if (Number(e.target.value) > 0) {
                this.appraisal.land_infrastructure_telephone_service = true;
            }
            this.calc_land_infrastructure_total_execution_pct();
        }, 1000),
        set_appraisal_land_infrastructure_gardened_areas_execution_pct: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_LAND_INFRASTRUCTURE_GARDENED_AREAS_EXECUTION_PCT(Number(e.target.value));
            if (Number(e.target.value) > 0) {
                this.appraisal.land_infrastructure_gardened_areas = true;
            }
            this.calc_land_infrastructure_total_execution_pct();
        }, 1000),
        calc_land_infrastructure_total_execution_pct: function calc_land_infrastructure_total_execution_pct() {
            var values = [];
            var paving = this.appraisal.land_infrastructure_paving_execution_pct;
            if (!paving) {
                paving = 0;
            }
            var sewage = this.appraisal.land_infrastructure_sewage_execution_pct;
            if (!sewage) {
                sewage = 0;
            }
            var public_lighting = this.appraisal.land_infrastructure_public_lighting_execution_pct;
            if (!public_lighting) {
                public_lighting = 0;
            }
            var water_supply = this.appraisal.land_infrastructure_water_supply_execution_pct;
            if (!water_supply) {
                water_supply = 0;
            }
            var electricity_supply = this.appraisal.land_infrastructure_electricity_supply_execution_pct;
            if (!electricity_supply) {
                electricity_supply = 0;
            }
            var piped_gas = this.appraisal.land_infrastructure_piped_gas_execution_pct;
            if (!piped_gas) {
                piped_gas = 0;
            }
            var telephone_service = this.appraisal.land_infrastructure_telephone_service_execution_pct;
            if (!telephone_service) {
                telephone_service = 0;
            }
            var gardened_areas = this.appraisal.land_infrastructure_gardened_areas_execution_pct;
            if (!gardened_areas) {
                gardened_areas = 0;
            }
            values.push(paving, sewage, public_lighting, water_supply, electricity_supply, piped_gas, telephone_service, gardened_areas);

            var sum = 0;
            for (var i = 0; i < values.length; i++) {
                sum += Number(values[i]);
            }

            var average = this.roundToTwo(sum / values.length);

            this.SET_APPRAISAL_LAND_INFRASTRUCTURE_TOTAL_EXECUTION_PCT(average);

            var repercussion_cost = this.appraisal.land_infrastructure_repercussion_cost;

            if (!repercussion_cost) {
                repercussion_cost = 150;
                this.SET_APPRAISAL_LAND_INFRASTRUCTURE_REPERCUSSION_COST(repercussion_cost);
            }

            var pending = this.roundToTwo(repercussion_cost * ((100 - average) / 100));

            this.SET_APPRAISAL_LAND_INFRASTRUCTURE_PENDING_INVESTMENT(pending);
        },
        set_appraisal_land_infrastructure_total_execution_pct: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_LAND_INFRASTRUCTURE_TOTAL_EXECUTION_PCT(Number(e.target.value));
        }, 1000),
        set_appraisal_land_infrastructure_repercussion_cost: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_LAND_INFRASTRUCTURE_REPERCUSSION_COST(Number(e.target.value));
        }, 1000),
        set_appraisal_land_infrastructure_pending_investment: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_LAND_INFRASTRUCTURE_PENDING_INVESTMENT(Number(e.target.value));
        }, 1000),
        set_appraisal_land_infrastructure_paving: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var existing = this.appraisal.land_infrastructure_paving;
            if (!existing) {
                this.SET_APPRAISAL_LAND_INFRASTRUCTURE_PAVING_EXECUTION_PCT(0);
            } else {
                if (this.appraisal.land_infrastructure_paving_execution_pct === 0) {
                    this.appraisal.land_infrastructure_paving_execution_pct = 100;
                }
            }
            this.calc_land_infrastructure_total_execution_pct();
        }, 0),
        set_appraisal_land_infrastructure_sewage: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var existing = this.appraisal.land_infrastructure_sewage;
            if (!existing) {
                this.SET_APPRAISAL_LAND_INFRASTRUCTURE_SEWAGE_EXECUTION_PCT(0);
            } else {
                if (this.appraisal.land_infrastructure_sewage_execution_pct === 0) {
                    this.appraisal.land_infrastructure_sewage_execution_pct = 100;
                }
            }
            this.calc_land_infrastructure_total_execution_pct();
        }, 0),
        set_appraisal_land_infrastructure_public_lighting: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var existing = this.appraisal.land_infrastructure_public_lighting;
            if (!existing) {
                this.SET_APPRAISAL_LAND_INFRASTRUCTURE_PUBLIC_LIGHTING_EXECUTION_PCT(0);
            } else {
                if (this.appraisal.land_infrastructure_public_lighting_execution_pct === 0) {
                    this.appraisal.land_infrastructure_public_lighting_execution_pct = 100;
                }
            }
            this.calc_land_infrastructure_total_execution_pct();
        }, 0),
        set_appraisal_land_infrastructure_water_supply: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var existing = this.appraisal.land_infrastructure_water_supply;
            if (!existing) {
                this.SET_APPRAISAL_LAND_INFRASTRUCTURE_WATER_SUPPLY_EXECUTION_PCT(0);
            } else {
                if (this.appraisal.land_infrastructure_water_supply_execution_pct === 0) {
                    this.appraisal.land_infrastructure_water_supply_execution_pct = 100;
                }
            }
            this.calc_land_infrastructure_total_execution_pct();
        }, 0),
        set_appraisal_land_infrastructure_electricity_supply: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var existing = this.appraisal.land_infrastructure_electricity_supply;
            if (!existing) {
                this.SET_APPRAISAL_LAND_INFRASTRUCTURE_ELECTRICITY_SUPPLY_EXECUTION_PCT(0);
            } else {
                if (this.appraisal.land_infrastructure_electricity_supply_execution_pct === 0) {
                    this.appraisal.land_infrastructure_electricity_supply_execution_pct = 100;
                }
            }
            this.calc_land_infrastructure_total_execution_pct();
        }, 0),
        set_appraisal_land_infrastructure_piped_gas: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var existing = this.appraisal.land_infrastructure_piped_gas;
            if (!existing) {
                this.SET_APPRAISAL_LAND_INFRASTRUCTURE_PIPED_GAS_EXECUTION_PCT(0);
            } else {
                if (this.appraisal.land_infrastructure_piped_gas_execution_pct === 0) {
                    this.appraisal.land_infrastructure_piped_gas_execution_pct = 100;
                }
            }
            this.calc_land_infrastructure_total_execution_pct();
        }, 0),
        set_appraisal_land_infrastructure_telephone_service: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var existing = this.appraisal.land_infrastructure_telephone_service;
            if (!existing) {
                this.SET_APPRAISAL_LAND_INFRASTRUCTURE_TELEPHONE_SERVICE_EXECUTION_PCT(0);
            } else {
                if (this.appraisal.land_infrastructure_telephone_service_execution_pct === 0) {
                    this.appraisal.land_infrastructure_telephone_service_execution_pct = 100;
                }
            }
            this.calc_land_infrastructure_total_execution_pct();
        }, 0),
        set_appraisal_land_infrastructure_gardened_areas: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var existing = this.appraisal.land_infrastructure_gardened_areas;
            if (!existing) {
                this.SET_APPRAISAL_LAND_INFRASTRUCTURE_GARDENED_AREAS_EXECUTION_PCT(0);
            } else {
                if (this.appraisal.land_infrastructure_gardened_areas_execution_pct === 0) {
                    this.appraisal.land_infrastructure_gardened_areas_execution_pct = 100;
                }
            }
            this.calc_land_infrastructure_total_execution_pct();
        }, 0),
        set_appraisal_land_is_plot_according_to_law: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_LAND_IS_PLOT_ACCORDING_TO_LAW(e.target.value);
        }, 0),
        set_appraisal_land_area_notes: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_LAND_AREA_NOTES(e.target.value);
        }, 1000),
        set_appraisal_land_infrastructure_notes: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_LAND_INFRASTRUCTURE_NOTES(e.target.value);
        }, 1000),
        set_appraisal_land_infrastructure_conservation_status: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_LAND_INFRASTRUCTURE_CONSERVATION_STATUS(e);
        }, 1000),
        set_appraisal_plot_occupation: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            // this.SET_APPRAISAL_PLOT_OCCUPATION(e.target.value)
            this.SET_APPRAISAL_PLOT_OCCUPATION(e);
        }, 1000),
        set_appraisal_plot_free_area_usage: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            // this.SET_APPRAISAL_PLOT_FREE_AREA_USAGE(e.target.value)
            this.SET_APPRAISAL_PLOT_FREE_AREA_USAGE(e);
        }, 1000),
        set_appraisal_floors_number_underground: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_FLOORS_NUMBER_UNDERGROUND(Number(e.target.value));
        }, 1000),
        set_appraisal_floors_number_overground: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_FLOORS_NUMBER_OVERGROUND(Number(e.target.value));
        }, 1000),
        set_appraisal_parking_spots_included_number: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_PARKING_SPOTS_INCLUDED_NUMBER(Number(e.target.value));
        }, 1000),
        set_appraisal_entrance_hall: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_doorman_space: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_staircase: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_swimming_pool: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_gardened_areas: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_sports_facilities: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_community_room: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_storage_room: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_community_parking: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_facilities_others: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_FACILITIES_OTHERS(e.target.value);
        }, 1000),
        set_appraisal_floors_usage_underground: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_FLOORS_USAGE_UNDERGROUND(e);
        }, 1000),
        set_appraisal_floors_usage_overground: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_FLOORS_USAGE_OVERGROUND(e);
        }, 1000),
        set_appraisal_groundfloor_usage: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_GROUNDFLOOR_USAGE(e);
        }, 1000),
        set_appraisal_communications_airport: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_COMMUNICATIONS_AIRPORT(e.target.value);
        }, 1000),
        set_appraisal_communications_harbour: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_COMMUNICATIONS_HARBOUR(e.target.value);
        }, 1000),
        set_appraisal_communications_train: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_COMMUNICATIONS_TRAIN(e.target.value);
        }, 1000),
        set_appraisal_public_transport_urban_underground: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_PUBLIC_TRANSPORT_URBAN_UNDERGROUND(e.target.value);
        }, 1000),
        set_appraisal_public_transport_interurban: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_PUBLIC_TRANSPORT_INTERURBAN(e.target.value);
        }, 1000),
        set_appraisal_surrounding_facilities_notes: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_SURROUNDING_FACILITIES_NOTES(e.target.value);
        }, 1000),
        set_appraisal_surrounding_territorial_feature: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_SURROUNDING_TERRITORIAL_FEATURE(e);
        }, 1000),
        set_appraisal_surrounding_income_level: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_SURROUNDING_INCOME_LEVEL(e);
        }, 1000),
        set_appraisal_surrounding_homogeneity_feature: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_SURROUNDING_HOMOGENEITY_FEATURE(e);
        }, 1000),
        set_appraisal_surrounding_main_uses: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_SURROUNDING_MAIN_USES(e);
        }, 1000),
        set_appraisal_surrounding_density: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_SURROUNDING_DENSITY(e);
        }, 1000),
        set_appraisal_surrounding_accessibility: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_SURROUNDING_ACCESSIBILITY(e);
        }, 1000),
        set_appraisal_surrounding_consolidation_degree: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_SURROUNDING_CONSOLIDATION_DEGREE(e);
        }, 1000),
        set_appraisal_surrounding_occupation_degree: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_SURROUNDING_OCCUPATION_DEGREE(e);
        }, 1000),
        set_appraisal_surrounding_evolution_speed: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_SURROUNDING_EVOLUTION_SPEED(e);
        }, 1000),
        set_appraisal_surrounding_average_age: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_SURROUNDING_AVERAGE_AGE(e);
        }, 1000),
        set_appraisal_surrounding_conservation_status: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_SURROUNDING_CONSERVATION_STATUS(e);
        }, 1000),
        set_appraisal_surrounding_commercial_facilities: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_SURROUNDING_COMMERCIAL_FACILITIES(e);
        }, 1000),
        set_appraisal_surrounding_educational_facilities: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_SURROUNDING_EDUCATIONAL_FACILITIES(e);
        }, 1000),
        set_appraisal_surrounding_public_parking: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_SURROUNDING_PUBLIC_PARKING(e);
        }, 1000),
        set_appraisal_surrounding_medical_assistance: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_SURROUNDING_MEDICAL_ASSISTANCE(e);
        }, 1000),
        set_appraisal_surrounding_leisure: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_SURROUNDING_LEISURE(e);
        }, 1000),
        set_appraisal_cadastral_usage: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_CADASTRAL_USAGE(e.target.value);
        }, 1000),
        set_appraisal_cadastral_floor: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_CADASTRAL_FLOOR(e.target.value);
        }, 1000),
        set_appraisal_cadastral_door: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_CADASTRAL_DOOR(e.target.value);
        }, 1000),
        set_appraisal_cadastral_block: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_CADASTRAL_BLOCK(e.target.value);
        }, 1000),
        set_appraisal_cadastral_staircase: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_CADASTRAL_STAIRCASE(e.target.value);
        }, 1000),
        set_appraisal_registry_name: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REGISTRY_NAME(e.target.value);
        }, 1000),
        set_appraisal_registry_section: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REGISTRY_SECTION(e.target.value);
        }, 1000),
        set_appraisal_registry_volume: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REGISTRY_VOLUME(e.target.value);
        }, 1000),
        set_appraisal_registry_book: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REGISTRY_BOOK(e.target.value);
        }, 1000),
        set_appraisal_registry_page: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REGISTRY_PAGE(e.target.value);
        }, 1000),
        set_appraisal_registry_real_estate_number: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REGISTRY_REAL_ESTATE_NUMBER(e.target.value);
        }, 1000),
        set_appraisal_registry_idufir: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REGISTRY_IDUFIR(e.target.value);
        }, 1000),
        set_appraisal_registry_owner: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REGISTRY_OWNER(e.target.value);
        }, 1000),
        set_appraisal_registry_property_coef: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REGISTRY_PROPERTY_COEF(Number(e.target.value));
        }, 1000),
        set_appraisal_net_cadastral_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_NET_CADASTRAL_AREA(Number(e.target.value));
            this.calc_adopted_areas();
        }, 1000),
        set_appraisal_net_registry_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_NET_REGISTRY_AREA(Number(e.target.value));
            this.calc_adopted_areas();
        }, 1000),
        set_appraisal_net_checked_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_NET_CHECKED_AREA(Number(e.target.value));
            this.calc_adopted_areas();
        }, 1000),
        set_appraisal_net_adopted_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_NET_ADOPTED_AREA(Number(e.target.value));
            this.calc_adopted_areas();
        }, 1000),
        set_appraisal_enclosed_cadastral_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_ENCLOSED_CADASTRAL_AREA(Number(e.target.value));
            this.calc_adopted_areas();
        }, 1000),
        set_appraisal_enclosed_registry_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_ENCLOSED_REGISTRY_AREA(Number(e.target.value));
            this.calc_adopted_areas();
        }, 1000),
        set_appraisal_enclosed_checked_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_ENCLOSED_CHECKED_AREA(Number(e.target.value));
            this.calc_adopted_areas();
        }, 1000),
        set_appraisal_enclosed_adopted_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_ENCLOSED_ADOPTED_AREA(Number(e.target.value));
            this.calc_adopted_areas();
        }, 1000),
        set_appraisal_covered_terraces_total_cadastral_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_COVERED_TERRACES_TOTAL_CADASTRAL_AREA(Number(e.target.value));
            this.calc_adopted_areas();
        }, 1000),
        set_appraisal_covered_terraces_total_registry_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_COVERED_TERRACES_TOTAL_REGISTRY_AREA(Number(e.target.value));
            this.calc_adopted_areas();
        }, 1000),
        set_appraisal_covered_terraces_total_checked_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_COVERED_TERRACES_TOTAL_CHECKED_AREA(Number(e.target.value));
            this.calc_adopted_areas();
        }, 1000),
        set_appraisal_covered_terraces_total_adopted_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_COVERED_TERRACES_TOTAL_ADOPTED_AREA(Number(e.target.value));
            this.calc_adopted_areas();
        }, 1000),
        set_appraisal_uncovered_terraces_total_cadastral_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_CADASTRAL_AREA(Number(e.target.value));
        }, 1000),
        set_appraisal_uncovered_terraces_total_registry_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_REGISTRY_AREA(Number(e.target.value));
        }, 1000),
        set_appraisal_uncovered_terraces_total_checked_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_CHECKED_AREA(Number(e.target.value));
        }, 1000),
        set_appraisal_uncovered_terraces_total_adopted_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_ADOPTED_AREA(Number(e.target.value));
        }, 1000),
        set_appraisal_built_cadastral_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_BUILT_CADASTRAL_AREA(Number(e.target.value));
            this.calc_adopted_areas();
        }, 1000),
        set_appraisal_built_registry_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_BUILT_REGISTRY_AREA(Number(e.target.value));
            this.calc_adopted_areas();
        }, 1000),
        set_appraisal_built_checked_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_BUILT_CHECKED_AREA(Number(e.target.value));
            this.calc_adopted_areas();
        }, 1000),
        set_appraisal_built_adopted_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_BUILT_ADOPTED_AREA(Number(e.target.value));
            this.calc_adopted_areas();
        }, 1000),
        set_appraisal_common_elements_cadastral_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var ce_area = Number(e.target.value);
            var b_area = this.appraisal.built_cadastral_area;
            var b_plus_ce_area = ce_area + b_area;
            this.SET_APPRAISAL_COMMON_ELEMENTS_CADASTRAL_AREA(ce_area);
            this.SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_CADASTRAL_AREA(b_plus_ce_area);
            this.calc_adopted_areas();
        }, 1000),
        set_appraisal_common_elements_registry_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_COMMON_ELEMENTS_REGISTRY_AREA(Number(e.target.value));
            this.calc_adopted_areas();
        }, 1000),
        set_appraisal_common_elements_checked_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_COMMON_ELEMENTS_CHECKED_AREA(Number(e.target.value));
            this.calc_adopted_areas();
        }, 1000),
        set_appraisal_common_elements_adopted_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_COMMON_ELEMENTS_ADOPTED_AREA(Number(e.target.value));
            this.calc_adopted_areas();
        }, 1000),
        set_appraisal_built_plus_common_elements_cadastral_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_CADASTRAL_AREA(Number(e.target.value));
            this.calc_adopted_areas();
        }, 1000),
        set_appraisal_built_plus_common_elements_registry_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_REGISTRY_AREA(Number(e.target.value));
            this.calc_adopted_areas();
        }, 1000),
        set_appraisal_built_plus_common_elements_checked_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_CHECKED_AREA(Number(e.target.value));
            this.calc_adopted_areas();
        }, 1000),
        set_appraisal_built_plus_common_elements_adopted_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_ADOPTED_AREA(Number(e.target.value));
            this.calc_adopted_areas();
        }, 1000),
        set_appraisal_realestate_rooms_to_exterior_number: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REALESTATE_ROOMS_TO_EXTERIOR_NUMBER(Number(e.target.value));
        }, 1000),
        set_appraisal_realestate_day_night_zoning: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_realestate_systems_door_opener: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_realestate_systems_fitted_cupboards: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_realestate_systems_gas: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_realestate_systems_sanitary_fittings: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_realestate_systems_taps: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_realestate_systems_hot_water: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_realestate_systems_heating: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_realestate_systems_air_conditioning: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_realestate_systems_tv: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_realestate_systems_telephone: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_realestate_systems_fire_prevention: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_realestate_systems_intrusion_prevention: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_realestate_foundation: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REALESTATE_FOUNDATION(e);
        }, 0),
        set_appraisal_realestate_structure: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REALESTATE_STRUCTURE(e);
        }, 0),
        set_appraisal_realestate_roof: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REALESTATE_ROOF(e);
        }, 0),
        set_appraisal_realestate_external_enclosures: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REALESTATE_EXTERNAL_ENCLOSURES(e);
        }, 0),
        set_appraisal_realestate_insulation: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REALESTATE_INSULATION(e);
        }, 0),
        set_appraisal_realestate_external_carpentry: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REALESTATE_EXTERNAL_CARPENTRY(e);
        }, 0),
        set_appraisal_realestate_glazing: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REALESTATE_GLAZING(e);
        }, 0),
        set_appraisal_realestate_interior_paving_living: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_LIVING(e);

            if (!this.appraisal.realestate_interior_paving_corridor) {
                this.SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_CORRIDOR(e);
            }
            if (!this.appraisal.realestate_interior_paving_bedroom) {
                this.SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_BEDROOM(e);
            }
            if (!this.appraisal.realestate_interior_paving_kitchen) {
                this.SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_KITCHEN(e);
            }
            if (!this.appraisal.realestate_interior_paving_bathroom) {
                this.SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_BATHROOM(e);
            }
        }, 0),
        set_appraisal_realestate_interior_paving_corridor: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_CORRIDOR(e);
        }, 0),
        set_appraisal_realestate_interior_paving_bedroom: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_BEDROOM(e);
        }, 0),
        set_appraisal_realestate_interior_paving_kitchen: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_KITCHEN(e);
        }, 0),
        set_appraisal_realestate_interior_paving_bathroom: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_BATHROOM(e);
        }, 0),
        set_appraisal_realestate_interior_paving_quality: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_QUALITY(e);
        }, 0),
        set_appraisal_realestate_interior_walls_living: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_LIVING(e);

            if (!this.appraisal.realestate_interior_walls_corridor) {
                this.SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_CORRIDOR(e);
            }
            if (!this.appraisal.realestate_interior_walls_bedroom) {
                this.SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_BEDROOM(e);
            }
            if (!this.appraisal.realestate_interior_walls_kitchen) {
                this.SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_KITCHEN(e);
            }
            if (!this.appraisal.realestate_interior_walls_bathroom) {
                this.SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_BATHROOM(e);
            }
        }, 0),
        set_appraisal_realestate_interior_walls_corridor: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_CORRIDOR(e);
        }, 0),
        set_appraisal_realestate_interior_walls_bedroom: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_BEDROOM(e);
        }, 0),
        set_appraisal_realestate_interior_walls_kitchen: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_KITCHEN(e);
        }, 0),
        set_appraisal_realestate_interior_walls_bathroom: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_BATHROOM(e);
        }, 0),
        set_appraisal_realestate_interior_walls_quality: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_QUALITY(e);
        }, 0),
        set_appraisal_realestate_interior_ceilings_living: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_LIVING(e);

            if (!this.appraisal.realestate_interior_ceilings_corridor) {
                this.SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_CORRIDOR(e);
            }
            if (!this.appraisal.realestate_interior_ceilings_bedroom) {
                this.SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_BEDROOM(e);
            }
            if (!this.appraisal.realestate_interior_ceilings_kitchen) {
                this.SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_KITCHEN(e);
            }
            if (!this.appraisal.realestate_interior_ceilings_bathroom) {
                this.SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_BATHROOM(e);
            }
        }, 0),
        set_appraisal_realestate_interior_ceilings_corridor: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_CORRIDOR(e);
        }, 0),
        set_appraisal_realestate_interior_ceilings_bedroom: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_BEDROOM(e);
        }, 0),
        set_appraisal_realestate_interior_ceilings_kitchen: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_KITCHEN(e);
        }, 0),
        set_appraisal_realestate_interior_ceilings_bathroom: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_BATHROOM(e);
        }, 0),
        set_appraisal_realestate_interior_ceilings_quality: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_QUALITY(e);
        }, 0),
        set_appraisal_realestate_interior_carpentry_living: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_LIVING(e);

            if (!this.appraisal.realestate_interior_carpentry_corridor) {
                this.SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_CORRIDOR(e);
            }
            if (!this.appraisal.realestate_interior_carpentry_bedroom) {
                this.SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_BEDROOM(e);
            }
            if (!this.appraisal.realestate_interior_carpentry_kitchen) {
                this.SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_KITCHEN(e);
            }
            if (!this.appraisal.realestate_interior_carpentry_bathroom) {
                this.SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_BATHROOM(e);
            }
        }, 0),
        set_appraisal_realestate_interior_carpentry_corridor: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_CORRIDOR(e);
        }, 0),
        set_appraisal_realestate_interior_carpentry_bedroom: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_BEDROOM(e);
        }, 0),
        set_appraisal_realestate_interior_carpentry_kitchen: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_KITCHEN(e);
        }, 0),
        set_appraisal_realestate_interior_carpentry_bathroom: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_BATHROOM(e);
        }, 0),
        set_appraisal_realestate_interior_carpentry_quality: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_QUALITY(e);
        }, 0),
        set_appraisal_realestate_main_orientation: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REALESTATE_MAIN_ORIENTATION(e);
        }, 0),
        set_appraisal_realestate_main_views: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REALESTATE_MAIN_VIEWS(e);
        }, 0),
        set_appraisal_realestate_windows_size_and_quantity: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REALESTATE_WINDOWS_SIZE_AND_QUANTITY(e);
        }, 0),
        set_appraisal_realestate_noise_facade: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REALESTATE_NOISE_FACADE(e);
        }, 0),
        set_appraisal_realestate_systems_sanitary_fittings_quality: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REALESTATE_SYSTEMS_SANITARY_FITTINGS_QUALITY(e);
        }, 0),
        set_appraisal_realestate_systems_taps_quality: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_REALESTATE_SYSTEMS_TAPS_QUALITY(e);
        }, 0),
        set_appraisal_adjusted_bec_price: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_ADJUSTED_BEC_PRICE(Number(e.target.value));
        }, 1000),
        set_appraisal_expenses_and_industrial_benefit_bec_pct: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this46 = this;

            console.log('hola! ');
            var bec_price = this.appraisal.bec_number.total;
            var coef = this.appraisal.bec_adjustment_coef;
            var adjusted_bec_price = this.roundToTwo(bec_price * coef);
            var desp_pct = Number(e.target.value);
            var mec = this.roundToTwo(adjusted_bec_price / (1 + desp_pct / 100));
            var mec_coef = this.appraisal.mec_adjustment_coef;
            var adopted_mec = this.roundToTwo(mec * mec_coef);

            this.SET_APPRAISAL_EXPENSES_AND_INDUSTRIAL_BENEFIT_BEC_PCT(desp_pct);

            this.SET_APPRAISAL_ADJUSTED_BEC_PRICE(adjusted_bec_price);
            this.SET_APPRAISAL_MATERIAL_EXECUTION_COST(mec);
            this.SET_APPRAISAL_ADOPTED_MATERIAL_EXECUTION_COST(adopted_mec);

            this.SET_APPRAISAL_BEC_ADJUSTMENT_COEF(coef).then(function () {
                _this46.calc_construction_cost();
                _this46.recalcAppraisal();
            });
        }, 1000),
        set_appraisal_adopted_material_execution_cost: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_ADOPTED_MATERIAL_EXECUTION_COST(Number(e.target.value));
        }, 1000),
        set_appraisal_construction_cost_notes: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_CONSTRUCTION_COST_NOTES(e.target.value);
        }, 1000),
        set_appraisal_cadastral_construction_year: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this47 = this;

            var cadastral_construction_year = Number(e.target.value);
            this.SET_APPRAISAL_CADASTRAL_CONSTRUCTION_YEAR(cadastral_construction_year);

            var construction_year = null;
            var last_renovation_year = null;

            if (!this.appraisal.construction_year) {
                construction_year = cadastral_construction_year;
            } else {
                construction_year = this.appraisal.construction_year;
            }

            this.SET_APPRAISAL_CONSTRUCTION_YEAR(construction_year);

            if (this.appraisal.last_renovation_year) {
                last_renovation_year = this.appraisal.last_renovation_year;

                if (last_renovation_year < construction_year) {
                    last_renovation_year = construction_year;
                }
            } else {
                last_renovation_year = construction_year;
            }

            this.SET_APPRAISAL_LAST_RENOVATION_YEAR(last_renovation_year);

            var average = Math.round((construction_year + last_renovation_year) / 2);
            this.SET_APPRAISAL_ADOPTED_AGE(average).then(function () {
                _this47.recalcMarketAndAppraisals();
            });
        }, 1000),
        set_appraisal_construction_year: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this48 = this;

            var construction_year = Number(e.target.value);
            this.SET_APPRAISAL_CONSTRUCTION_YEAR(construction_year);

            var last_renovation_year = construction_year;

            if (this.appraisal.last_renovation_year) {
                last_renovation_year = this.appraisal.last_renovation_year;

                if (last_renovation_year < construction_year) {
                    last_renovation_year = construction_year;
                }
            }

            this.SET_APPRAISAL_LAST_RENOVATION_YEAR(last_renovation_year);

            var average = Math.round((construction_year + last_renovation_year) / 2);
            this.SET_APPRAISAL_ADOPTED_AGE(average).then(function () {
                _this48.recalcMarketAndAppraisals();
            });
        }, 1000),
        set_appraisal_last_renovation_year: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this49 = this;

            var last_renovation_year = Number(e.target.value);
            this.SET_APPRAISAL_LAST_RENOVATION_YEAR(last_renovation_year);

            var construction_year = null;
            var cadastral_construction_year = this.appraisal.cadastral_construction_year;

            if (this.appraisal.construction_year) {
                construction_year = this.appraisal.construction_year;
            } else {
                construction_year = cadastral_construction_year;
            }

            this.SET_APPRAISAL_CONSTRUCTION_YEAR(construction_year);

            var average = Math.round((construction_year + last_renovation_year) / 2);
            this.SET_APPRAISAL_ADOPTED_AGE(average).then(function () {
                _this49.recalcMarketAndAppraisals();
            });
        }, 1000),
        set_appraisal_nucleus_population: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_NUCLEUS_POPULATION(Number(e.target.value));
        }, 1000),
        set_appraisal_nucleus_population_density: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_NUCLEUS_POPULATION_DENSITY(Number(e.target.value));
        }, 1000),
        set_appraisal_nucleus_population_growth: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_NUCLEUS_POPULATION_GROWTH(Number(e.target.value));
        }, 1000),
        set_appraisal_occupation_agriculture_pct: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_OCCUPATION_AGRICULTURE_PCT(Number(e.target.value));
        }, 1000),
        set_appraisal_occupation_industry_pct: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_OCCUPATION_INDUSTRY_PCT(Number(e.target.value));
        }, 1000),
        set_appraisal_occupation_construction_pct: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_OCCUPATION_CONSTRUCTION_PCT(Number(e.target.value));
        }, 1000),
        set_appraisal_occupation_services_pct: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_OCCUPATION_SERVICES_PCT(Number(e.target.value));
        }, 1000),
        set_appraisal_occupation_total_pct: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_OCCUPATION_TOTAL_PCT(Number(e.target.value));
        }, 1000),
        set_appraisal_nucleus_type: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_NUCLEUS_TYPE(e.target.value);
        }, 1000),
        set_appraisal_occupation_description: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_OCCUPATION_DESCRIPTION(e.target.value);
        }, 1000),
        set_appraisal_nucleus_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_NUCLEUS_AREA(Number(e.target.value));
        }, 1000),
        set_appraisal_checks_other: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_CHECKS_OTHER(e.target.value);
        }, 1000),
        set_appraisal_docs_other: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_DOCS_OTHER(e.target.value);
        }, 1000),
        set_appraisal_checks_cadastral_data: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_checks_conservation_status: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_checks_expropriation_procedure: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_checks_expropriation_plan: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_checks_expropriation_admin_ruling: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_checks_expropriation_file: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_checks_interior_visit: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_checks_occupancy: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_checks_registry_data: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_checks_servitudes: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_checks_subsidy_status: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_checks_urban_planning: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_docs_approved_project: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_docs_cadastral_data: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_docs_construction_license: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_docs_construction_last_certificate: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_docs_construction_contract: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_docs_occupancy_status: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_docs_photographic_report: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_docs_property_sketch: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_docs_property_titles: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_docs_situation_plan: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_docs_subsidy_status: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_docs_tenyear_insurance: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_docs_urban_plan: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        set_appraisal_property_title: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_PROPERTY_TITLE(e.target.value);
        }, 1000),
        set_appraisal_usage_assigned: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_USAGE_ASSIGNED(e.target.value);
        }, 1000),
        set_appraisal_inspection_realized: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_INSPECTION_REALIZED(e.target.value);
        }, 1000),
        set_appraisal_economical_activity: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_ECONOMICAL_ACTIVITY(e.target.value);
        }, 1000),
        set_appraisal_occupancy_status: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_OCCUPANCY_STATUS(e);
        }, 1000),
        set_appraisal_marketstudy_id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this50 = this;

            var marketstudy_id = e.id;
            var market_value = this.check_undefined_get_number(e.market_value);
            var market_unit_value = this.check_undefined_get_number(e.market_unit_value);
            this.SET_APPRAISAL_MARKETSTUDY_ID(marketstudy_id).then(function () {
                console.log('selected marketstudy: ');
                console.log(_this50.realestate_marketstudies[marketstudy_id]);
                _this50.appraisal = _this50.calcAppraisal(_this50.appraisal, marketstudy_id, market_value, market_unit_value);
            });
        }, 1000),
        set_appraisal_cover_photo: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e, f) {
            var _this51 = this;

            var boolean = e;
            var photo_id = f['id'];
            var photo_url = f['url'];

            var appraisal_photographs = this.appraisal_photographs;

            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(appraisal_photographs, function (value, key) {
                appraisal_photographs[key].is_cover_photo = false;
            });

            if (boolean === true) {
                appraisal_photographs[photo_id].is_cover_photo = true;
            } else {
                photo_url = null;
            }

            this.SET_APPRAISALREPORT_COVER_PHOTO_URL(photo_url);

            // TODO: hi h a la possibilitat de que al guardar aquí actualitzem un appraisalreport incorrecte?
            this.UPDATE_APPRAISALREPORT({
                object: this.appraisalreport,
                path: this.appraisalreport.path,
                parent_path: this.appraisalreport.parent_path,
                key: this.appraisalreport.id
            }).then(function (res) {});

            // console.log('appraisal_photographs: ')
            // console.log(appraisal_photographs)
            this.appraisal_photographs = appraisal_photographs;
            this.$forceUpdate();

            this.SET_PHOTOGRAPH({ path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'photographs' + '/' + photo_id + '/' }).then(function (res) {
                if (boolean === true) {
                    _this51.SET_PHOTOGRAPH_IS_COVER_PHOTO(true);
                } else {
                    _this51.SET_PHOTOGRAPH_IS_COVER_PHOTO(false);
                }

                _this51.UPDATE_PHOTOGRAPH({
                    object: _this51.photograph,
                    path: _this51.photograph.path,
                    parent_path: _this51.photograph.parent_path,
                    key: _this51.photograph.id
                }).then(function (res) {});
            });
        }, 0),
        set_appraisal_usage_type: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_APPRAISAL_USAGE_TYPE(e);
        }, 500),
        recalcAppraisal: function recalcAppraisal() {
            this.appraisal = this.calcAppraisal(this.appraisal, this.appraisal.marketstudy_id, this.appraisal.market_value, this.appraisal.market_unit_value);
        },
        set_base_fees: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (adjusted_market_value) {

            var base_fees = 0;
            var bp_coef = 1;
            if (this.realestate.invoice_base_price_coef) {
                bp_coef = this.realestate.invoice_base_price_coef;
            }
            var invoice_excess_pct = 0;
            var base_price = 0;

            var is_eco = this.realestate.invoice_appraisal_type_is_eco;

            var roundToTwoTemp = function roundToTwoTemp(num) {
                return +(Math.round(num + 'e+2') + 'e-2');
            };

            if (this.realestate.property_type.name_db === 'residential' || this.realestate.property_type.name_db === 'parking' || this.realestate.property_type.name_db === 'storage') {
                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(this.valuation_prices.group_A, function (range, key) {
                    // console.log('adjusted_market_value: ')
                    // console.log(adjusted_market_value)
                    // console.log('range.ceil: ')
                    // console.log(range.ceil)
                    // console.log('range.floor: ')
                    // console.log(range.floor)

                    if (adjusted_market_value >= range.floor && adjusted_market_value < range.ceil) {

                        if (is_eco) {

                            base_fees = range.mortgage_valuation_fee;
                            // console.log('base_fees: ')
                            // console.log(base_fees)


                            invoice_excess_pct = range.increment_pct_mortgage_valuation;
                            base_price = roundToTwoTemp((base_fees + base_fees * (invoice_excess_pct / 100)) * bp_coef);
                        } else {
                            base_fees = range.standard_valuation_fee;
                            // console.log('base_fees: ')
                            // console.log(base_fees)

                            invoice_excess_pct = range.increment_pct_standard_valuation;
                            base_price = roundToTwoTemp((base_fees + base_fees * (invoice_excess_pct / 100)) * bp_coef);
                        }
                    }
                });
            } else if (this.realestate.property_type.name_db === 'retail_and_industrial' || this.realestate.property_type.name_db === 'office') {

                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(this.valuation_prices.group_B, function (range, key) {

                    // console.log('adjusted_market_value: ')
                    // console.log(adjusted_market_value)
                    // console.log('range.ceil: ')
                    // console.log(range.ceil)
                    // console.log('range.floor: ')
                    // console.log(range.floor)

                    if (adjusted_market_value >= range.floor && adjusted_market_value < range.ceil) {

                        if (is_eco) {

                            base_fees = range.mortgage_valuation_fee;
                            // console.log('base_fees: ')
                            // console.log(base_fees)


                            invoice_excess_pct = range.increment_pct_mortgage_valuation;
                            base_price = roundToTwoTemp((base_fees + base_fees * (invoice_excess_pct / 100)) * bp_coef);
                        } else {
                            base_fees = range.standard_valuation_fee;
                            // console.log('base_fees: ')
                            // console.log(base_fees)

                            invoice_excess_pct = range.increment_pct_standard_valuation;
                            base_price = roundToTwoTemp((base_fees + base_fees * (invoice_excess_pct / 100)) * bp_coef);
                        }
                    }
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(this.valuation_prices.group_C, function (range, key) {
                    // console.log('adjusted_market_value: ')
                    // console.log(adjusted_market_value)
                    // console.log('range.ceil: ')
                    // console.log(range.ceil)
                    // console.log('range.floor: ')
                    // console.log(range.floor)

                    if (adjusted_market_value >= range.floor && adjusted_market_value < range.ceil) {

                        base_fees = range.standard_valuation_fee;
                        // console.log('base_fees: ')
                        // console.log(base_fees)

                        invoice_excess_pct = range.increment_pct_standard_valuation;
                        base_price = roundToTwoTemp((base_fees + base_fees * (invoice_excess_pct / 100)) * bp_coef);
                    }
                });
            }
            /*
            else if(this.realestate.property_type.name_db === 'entire_buildings' || this.realestate.property_type.name_db === 'land'){
            }
            */

            this.SET_REALESTATE_INVOICE_BASE_FEES(base_fees);
            this.SET_REALESTATE_INVOICE_EXCESS_PCT(invoice_excess_pct);
            this.SET_REALESTATE_INVOICE_BASE_PRICE(base_price);
            this.SET_REALESTATE_INVOICE_BASE_PRICE_COEF(bp_coef);

            this.SET_REALESTATE_INVOICE_BASE_FEES(base_fees);

            var total_travel_fees = this.realestate.total_travel_fees;
            this.calc_invoice_base_price(base_fees, invoice_excess_pct, bp_coef, total_travel_fees);
        }, 0),
        calc_invoice_base_price: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (base_fees, invoice_excess_pct, bp_coef, total_travel_fees) {
            var base_price = this.roundToTwo((base_fees + base_fees * (invoice_excess_pct / 100)) * bp_coef);
            this.SET_REALESTATE_INVOICE_BASE_PRICE(base_price);

            var invoice_price_incl_travel_expenses = base_price + total_travel_fees;
            this.SET_REALESTATE_INVOICE_PRICE_INCL_TRAVEL_EXPENSES(invoice_price_incl_travel_expenses);
        }, 0),
        set_realestate_invoice_base_fees: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_REALESTATE_INVOICE_BASE_FEES(Number(e.target.value));
        }, 1000),
        set_realestate_invoice_excess_pct: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_REALESTATE_INVOICE_EXCESS_PCT(Number(e.target.value));
        }, 1000),
        set_realestate_invoice_base_price: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_REALESTATE_INVOICE_BASE_PRICE(Number(e.target.value));
        }, 1000),
        set_realestate_invoice_base_price_coef: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_REALESTATE_INVOICE_BASE_PRICE_COEF(Number(e.target.value));
        }, 1000),
        set_realestate_invoice_appraisal_type_is_eco: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {}, 0),
        recalcMarketAndAppraisals: function recalcMarketAndAppraisals() {
            // TODO: recalcular mercat (si és que està vinculat a un) i amb el nou valor de mercat actualitzar i recalcular les taxacions que estiguin lligades a aquell estudi
            // this.appraisal = this.calcAppraisal(this.appraisal, this.appraisal.market_value, this.appraisal.market_unit_value)
        },
        onRequestIdescatInfoByCodeIne: function onRequestIdescatInfoByCodeIne() {
            var _this52 = this;

            // TODO: missatge d'error quan el MUC no funciona
            // TODO: link directe a la pàgina del MUC
            // TODO: afegir BCN PIC i Àrea Metropolitana

            console.log('requesting MUC info...');
            this.idescat_info_loading = true;
            this.REQUEST_IDESCAT_INFO_BY_CODE_INE({
                code_ine: this.realestate.municipality.ine_province_code + this.realestate.municipality.ine_municipality_code + this.realestate.municipality.ine_control_digit
            }).then(function (res) {
                //
                _this52.idescat_info_loading = false;
            });
        },
        onRequestMucInfo: function onRequestMucInfo() {
            var _this53 = this;

            console.log('requesting MUC info...');
            this.muc_info_loading = true;
            this.REQUEST_MUC_INFO({
                x: this.realestate.epsg25831_x,
                y: this.realestate.epsg25831_y
            }).then(function (res) {
                //
                _this53.muc_info_loading = false;
            });
        },
        onRequestMucMap: function onRequestMucMap() {
            var _this54 = this;

            console.log('requesting MUC maps...');
            this.muc_map_01_loading = true;
            this.muc_map_02_loading = true;
            this.muc_map_03_loading = true;

            if (isNaN(this.appraisal.map_urban_muc_land_colors_zoom)) {
                this.appraisal.map_urban_muc_land_colors_zoom = 1;
            }

            if (isNaN(this.appraisal.map_urban_muc_council_qual_zoom)) {
                this.appraisal.map_urban_muc_council_qual_zoom = 1;
            }

            if (isNaN(this.appraisal.map_urban_icc_topo_zoom)) {
                this.appraisal.map_urban_icc_topo_zoom = 1;
            }

            if (this.appraisal.map_urban_muc_land_colors_zoom === 0) {
                this.appraisal.map_urban_muc_land_colors_zoom = 1;
            }

            if (this.appraisal.map_urban_muc_council_qual_zoom === 0) {
                this.appraisal.map_urban_muc_council_qual_zoom = 1;
            }

            if (this.appraisal.map_urban_icc_topo_zoom === 0) {
                this.appraisal.map_urban_icc_topo_zoom = 1;
            }

            if (!this.appraisal.map_urban_muc_land_colors_zoom) {
                this.appraisal.map_urban_muc_land_colors_zoom = 1;
            }

            if (!this.appraisal.map_urban_muc_council_qual_zoom) {
                this.appraisal.map_urban_muc_council_qual_zoom = 1;
            }

            if (!this.appraisal.map_urban_icc_topo_zoom) {
                this.appraisal.map_urban_icc_topo_zoom = 1;
            }

            this.REQUEST_MAP_URBAN_MUC_LAND_COLORS_BY_BBOX({
                x: this.realestate.epsg25831_x + this.appraisal.map_urban_muc_land_colors_offset_x,
                y: this.realestate.epsg25831_y + this.appraisal.map_urban_muc_land_colors_offset_y,
                width: this.urban_map_width,
                height: this.urban_map_height,
                zoom: this.appraisal.map_urban_muc_land_colors_zoom,
                realestate_id: this.realestate.id,
                appraisal_id: this.appraisal.id
            }).then(function (res) {
                //
                console.log('res in AppraisalEditor.vue: ');
                console.log(res);
                _this54.appraisal.map_urban_muc_land_colors = res;
                _this54.muc_map_01_loading = false;
            });
            this.REQUEST_MAP_URBAN_MUC_COUNCIL_QUAL_BY_BBOX({
                x: this.realestate.epsg25831_x + this.appraisal.map_urban_muc_council_qual_offset_x,
                y: this.realestate.epsg25831_y + this.appraisal.map_urban_muc_council_qual_offset_y,
                width: this.urban_map_width,
                height: this.urban_map_height,
                zoom: this.appraisal.map_urban_muc_council_qual_zoom,
                realestate_id: this.realestate.id,
                appraisal_id: this.appraisal.id
            }).then(function (res) {
                //
                console.log('res in AppraisalEditor.vue: ');
                console.log(res);
                _this54.appraisal.map_urban_muc_council_qual = res;
                _this54.muc_map_02_loading = false;
            });
            this.REQUEST_MAP_URBAN_ICC_TOPO_BY_BBOX({
                x: this.realestate.epsg25831_x + this.appraisal.map_urban_icc_topo_offset_x,
                y: this.realestate.epsg25831_y + this.appraisal.map_urban_icc_topo_offset_y,
                width: this.urban_map_width,
                height: this.urban_map_height,
                zoom: this.appraisal.map_urban_icc_topo_zoom,
                realestate_id: this.realestate.id,
                appraisal_id: this.appraisal.id
            }).then(function (res) {
                //
                console.log('res in AppraisalEditor.vue: ');
                console.log(res);
                _this54.appraisal.map_urban_icc_topo = res;
                _this54.muc_map_03_loading = false;
            });
        },
        onSaveCurrentAppraisal: function onSaveCurrentAppraisal(data) {
            var _this55 = this;

            this.UPDATE_APPRAISAL_ROOMS({
                appraisal_id: this.appraisal.id,
                object: this.appraisal_rooms
            });
            this.UPDATE_APPRAISAL_COVERED_OUTDOORS({
                appraisal_id: this.appraisal.id,
                object: this.appraisal_covered_outdoors
            });
            this.UPDATE_APPRAISAL_UNCOVERED_OUTDOORS({
                appraisal_id: this.appraisal.id,
                object: this.appraisal_uncovered_outdoors
            });
            this.UPDATE_APPRAISAL({
                key: this.appraisal.id,
                object: this.appraisal,
                parent_path: 'realestates/' + this.realestate.id + '/' + 'appraisals' + '/',
                path: this.appraisal.path + this.appraisal.id,
                realestate_id: this.realestate.id
            }).then(function (res) {
                if (data.go_up) {
                    _this55.onGoUp();
                } else {
                    _this55.setCurrentTab(_this55.currentTabTitle);
                    window.scroll(0, 0);
                }
            });

            this.UPDATE_REALESTATE({
                key: this.realestate.id,
                object: this.realestate,
                // parent_path: 'appraisalreports/' + this.appraisalreport.id + '/' + 'realestates' + '/',
                path: this.realestate.path + this.realestate.id,
                file_id: this.appraisalfile.id,
                report_id: this.appraisalreport.id
            }).then(function (res) {});
        },
        setCurrentTabTitle: function setCurrentTabTitle(tabTitle) {
            console.log('hey, current Tab Title: ' + tabTitle);
            this.currentTabTitle = tabTitle;
        },
        setCurrentTab: function setCurrentTab(tabTitle) {
            console.log('hey, current Tab: ' + tabTitle);
            this.tabName = tabTitle;
        },
        onGoBack: function onGoBack() {
            // console.log('yeah back')
            __WEBPACK_IMPORTED_MODULE_11__router_index_js__["a" /* default */].go(-1);
        },
        onGoUp: function onGoUp() {
            // console.log('yeah up')
            this.$router.push({ name: 'realestate-editor', query: { id: this.realestate.id } });
        },
        onCancelAll: function onCancelAll() {
            var result = window.confirm(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Changes_will_be_lost_p_continue_q'));

            if (result) {
                __WEBPACK_IMPORTED_MODULE_11__router_index_js__["a" /* default */].go(-1);
            } else {
                return false;
            }
        },
        onCreateNewRoom: function onCreateNewRoom() {
            var _this56 = this;

            this.master_loading = true;

            this.RESET_ROOM().then(function (res) {
                _this56.CREATE_NEW_ROOM({
                    path: 'appraisal_rooms' + '/' + _this56.appraisal.id + '/',
                    parent_path: 'realestate_appraisals' + '/' + _this56.realestate.id + '/' + _this56.appraisal.id + '/' + 'rooms' + '/',
                    appraisal_id: _this56.appraisal.id
                }).then(function (res) {
                    // this.$router.push({name: 'room-editor', query: {id: this.appraisal.id}})
                    _this56.FETCH_APPRAISAL_ROOMS({ path: 'appraisal_rooms' + '/' + _this56.appraisal.id + '/' }).then(function () {
                        _this56.master_loading = false;
                    });
                });
            });
        },
        onCreateNewConstraint: function onCreateNewConstraint() {
            var _this57 = this;

            // this.master_loading = true

            this.RESET_CONSTRAINT().then(function (res) {
                _this57.CREATE_NEW_CONSTRAINT({
                    path: 'appraisal_constraints' + '/' + _this57.appraisal.id + '/',
                    parent_path: 'realestate_appraisals' + '/' + _this57.realestate.id + '/' + _this57.appraisal.id + '/' + 'constraints' + '/',
                    appraisal_id: _this57.appraisal.id
                }).then(function (res) {
                    _this57.$router.push({ name: 'constraint-editor', query: { id: _this57.appraisal.id } });
                });
            });
        },
        onCreateNewWarning: function onCreateNewWarning() {
            var _this58 = this;

            // this.master_loading = true

            this.RESET_WARNING().then(function (res) {
                _this58.CREATE_NEW_WARNING({
                    path: 'appraisal_warnings' + '/' + _this58.appraisal.id + '/',
                    parent_path: 'realestate_appraisals' + '/' + _this58.realestate.id + '/' + _this58.appraisal.id + '/' + 'warnings' + '/',
                    appraisal_id: _this58.appraisal.id
                }).then(function (res) {
                    _this58.$router.push({ name: 'warning-editor', query: { id: _this58.appraisal.id } });
                });
            });
        },
        onCreateNewNote: function onCreateNewNote() {
            var _this59 = this;

            // this.master_loading = true

            this.RESET_NOTE().then(function (res) {
                _this59.CREATE_NEW_NOTE({
                    path: 'appraisal_notes' + '/' + _this59.appraisal.id + '/',
                    parent_path: 'realestate_appraisals' + '/' + _this59.realestate.id + '/' + _this59.appraisal.id + '/' + 'notes' + '/',
                    appraisal_id: _this59.appraisal.id
                }).then(function (res) {
                    _this59.$router.push({ name: 'note-editor', query: { id: _this59.appraisal.id } });
                });
            });
        },
        onCreateNewCoveredOutdoor: function onCreateNewCoveredOutdoor() {
            var _this60 = this;

            this.master_loading = true;
            this.RESET_COVERED_OUTDOOR().then(function (res) {
                _this60.CREATE_NEW_COVERED_OUTDOOR({
                    path: 'appraisal_covered_outdoors' + '/' + _this60.appraisal.id + '/',
                    parent_path: 'realestate_appraisals' + '/' + _this60.realestate.id + '/' + _this60.appraisal.id + '/' + 'covered_outdoors' + '/',
                    appraisal_id: _this60.appraisal.id
                }).then(function (res) {
                    // this.$router.push({name: 'covered_outdoor-editor', query: {id: this.appraisal.id}})
                    _this60.FETCH_APPRAISAL_COVERED_OUTDOORS({ path: 'appraisal_covered_outdoors' + '/' + _this60.appraisal.id + '/' }).then(function () {
                        _this60.master_loading = false;
                    });
                });
            });
        },
        onCreateNewUncoveredOutdoor: function onCreateNewUncoveredOutdoor() {
            var _this61 = this;

            this.master_loading = true;
            this.RESET_UNCOVERED_OUTDOOR().then(function (res) {
                _this61.CREATE_NEW_UNCOVERED_OUTDOOR({
                    path: 'appraisal_uncovered_outdoors' + '/' + _this61.appraisal.id + '/',
                    parent_path: 'realestate_appraisals' + '/' + _this61.realestate.id + '/' + _this61.appraisal.id + '/' + 'uncovered_outdoors' + '/',
                    appraisal_id: _this61.appraisal.id
                }).then(function (res) {
                    // this.$router.push({name: 'uncovered_outdoor-editor', query: {id: this.appraisal.id}})
                    _this61.FETCH_APPRAISAL_UNCOVERED_OUTDOORS({ path: 'appraisal_uncovered_outdoors' + '/' + _this61.appraisal.id + '/' }).then(function () {
                        _this61.master_loading = false;
                    });
                });
            });
        },
        onDecreaseZoomMapUrbanMuc: function onDecreaseZoomMapUrbanMuc() {
            // console.log('decreasing Maps Zoom...')

            if (isNaN(this.appraisal.map_urban_muc_land_colors_zoom)) {
                this.appraisal.map_urban_muc_land_colors_zoom = 1;
            }

            if (isNaN(this.appraisal.map_urban_muc_council_qual_zoom)) {
                this.appraisal.map_urban_muc_council_qual_zoom = 1;
            }

            if (isNaN(this.appraisal.map_urban_icc_topo_zoom)) {
                this.appraisal.map_urban_icc_topo_zoom = 1;
            }

            if (this.appraisal.map_urban_muc_land_colors_zoom === 0) {
                this.appraisal.map_urban_muc_land_colors_zoom = 1;
            }

            if (this.appraisal.map_urban_muc_council_qual_zoom === 0) {
                this.appraisal.map_urban_muc_council_qual_zoom = 1;
            }

            if (this.appraisal.map_urban_icc_topo_zoom === 0) {
                this.appraisal.map_urban_icc_topo_zoom = 1;
            }

            var map_urban_muc_land_colors_zoom = Number(this.appraisal.map_urban_muc_land_colors_zoom) + this.urban_map_zoom_factor;
            this.appraisal.map_urban_muc_land_colors_zoom = map_urban_muc_land_colors_zoom;
            this.SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_ZOOM(map_urban_muc_land_colors_zoom);

            var map_urban_muc_council_qual_zoom = Number(this.appraisal.map_urban_muc_council_qual_zoom) + this.urban_map_zoom_factor;
            this.appraisal.map_urban_muc_council_qual_zoom = map_urban_muc_council_qual_zoom;
            this.SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_ZOOM(map_urban_muc_council_qual_zoom);

            var map_urban_icc_topo_zoom = Number(this.appraisal.map_urban_icc_topo_zoom) + this.urban_map_zoom_factor;
            this.appraisal.map_urban_icc_topo_zoom = map_urban_icc_topo_zoom;
            this.SET_APPRAISAL_MAP_URBAN_ICC_TOPO_ZOOM(map_urban_icc_topo_zoom);

            console.log('map_urban_muc_land_colors_zoom: ');
            console.log(map_urban_muc_land_colors_zoom);

            console.log('map_urban_muc_council_qual_zoom: ');
            console.log(map_urban_muc_council_qual_zoom);

            console.log('map_urban_icc_topo_zoom: ');
            console.log(map_urban_icc_topo_zoom);

            this.onRequestMucMap();
        },
        onIncreaseZoomMapUrbanMuc: function onIncreaseZoomMapUrbanMuc() {
            // console.log('increasing Maps Zoom...')

            if (isNaN(this.appraisal.map_urban_muc_land_colors_zoom)) {
                this.appraisal.map_urban_muc_land_colors_zoom = 1;
            }

            if (isNaN(this.appraisal.map_urban_muc_council_qual_zoom)) {
                this.appraisal.map_urban_muc_council_qual_zoom = 1;
            }

            if (isNaN(this.appraisal.map_urban_icc_topo_zoom)) {
                this.appraisal.map_urban_icc_topo_zoom = 1;
            }

            if (this.appraisal.map_urban_muc_land_colors_zoom === 0) {
                this.appraisal.map_urban_muc_land_colors_zoom = 1;
            }

            if (this.appraisal.map_urban_muc_council_qual_zoom === 0) {
                this.appraisal.map_urban_muc_council_qual_zoom = 1;
            }

            if (this.appraisal.map_urban_icc_topo_zoom === 0) {
                this.appraisal.map_urban_icc_topo_zoom = 1;
            }

            var map_urban_muc_land_colors_zoom = Number(this.appraisal.map_urban_muc_land_colors_zoom) - this.urban_map_zoom_factor;
            this.appraisal.map_urban_muc_land_colors_zoom = map_urban_muc_land_colors_zoom;
            this.SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_ZOOM(map_urban_muc_land_colors_zoom);

            var map_urban_muc_council_qual_zoom = Number(this.appraisal.map_urban_muc_council_qual_zoom) - this.urban_map_zoom_factor;
            this.appraisal.map_urban_muc_council_qual_zoom = map_urban_muc_council_qual_zoom;
            this.SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_ZOOM(map_urban_muc_council_qual_zoom);

            var map_urban_icc_topo_zoom = Number(this.appraisal.map_urban_icc_topo_zoom) - this.urban_map_zoom_factor;
            this.appraisal.map_urban_icc_topo_zoom = map_urban_icc_topo_zoom;
            this.SET_APPRAISAL_MAP_URBAN_ICC_TOPO_ZOOM(map_urban_icc_topo_zoom);

            console.log('map_urban_muc_land_colors_zoom: ');
            console.log(map_urban_muc_land_colors_zoom);

            console.log('map_urban_muc_council_qual_zoom: ');
            console.log(map_urban_muc_council_qual_zoom);

            console.log('map_urban_icc_topo_zoom: ');
            console.log(map_urban_icc_topo_zoom);

            this.onRequestMucMap();
        },
        onGoUpMapUrbanMuc: function onGoUpMapUrbanMuc() {
            // console.log('going up Maps Zoom...')

            var map_urban_muc_land_colors_offset_y = this.appraisal.map_urban_muc_land_colors_offset_y + this.urban_map_offset;
            this.appraisal.map_urban_muc_land_colors_offset_y = map_urban_muc_land_colors_offset_y;
            this.SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_OFFSET_X(map_urban_muc_land_colors_offset_y);

            var map_urban_muc_council_qual_offset_y = this.appraisal.map_urban_muc_council_qual_offset_y + this.urban_map_offset;
            this.appraisal.map_urban_muc_council_qual_offset_y = map_urban_muc_council_qual_offset_y;
            this.SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_OFFSET_X(map_urban_muc_council_qual_offset_y);

            var map_urban_icc_topo_offset_y = this.appraisal.map_urban_icc_topo_offset_y + this.urban_map_offset;
            this.appraisal.map_urban_icc_topo_offset_y = map_urban_icc_topo_offset_y;
            this.SET_APPRAISAL_MAP_URBAN_ICC_TOPO_OFFSET_X(map_urban_icc_topo_offset_y);

            this.onRequestMucMap();
        },
        onGoLeftMapUrbanMuc: function onGoLeftMapUrbanMuc() {
            // console.log('going left Maps Zoom...')

            var map_urban_muc_land_colors_offset_x = this.appraisal.map_urban_muc_land_colors_offset_x - this.urban_map_offset;
            this.appraisal.map_urban_muc_land_colors_offset_x = map_urban_muc_land_colors_offset_x;
            this.SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_OFFSET_Y(map_urban_muc_land_colors_offset_x);

            var map_urban_muc_council_qual_offset_x = this.appraisal.map_urban_muc_council_qual_offset_x - this.urban_map_offset;
            this.appraisal.map_urban_muc_council_qual_offset_x = map_urban_muc_council_qual_offset_x;
            this.SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_OFFSET_Y(map_urban_muc_council_qual_offset_x);

            var map_urban_icc_topo_offset_x = this.appraisal.map_urban_icc_topo_offset_x - this.urban_map_offset;
            this.appraisal.map_urban_icc_topo_offset_x = map_urban_icc_topo_offset_x;
            this.SET_APPRAISAL_MAP_URBAN_ICC_TOPO_OFFSET_Y(map_urban_icc_topo_offset_x);

            this.onRequestMucMap();
        },
        onGoRightMapUrbanMuc: function onGoRightMapUrbanMuc() {
            // console.log('going right Maps Zoom...')

            var map_urban_muc_land_colors_offset_x = this.appraisal.map_urban_muc_land_colors_offset_x + this.urban_map_offset;
            this.appraisal.map_urban_muc_land_colors_offset_x = map_urban_muc_land_colors_offset_x;
            this.SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_OFFSET_Y(map_urban_muc_land_colors_offset_x);

            var map_urban_muc_council_qual_offset_x = this.appraisal.map_urban_muc_council_qual_offset_x + this.urban_map_offset;
            this.appraisal.map_urban_muc_council_qual_offset_x = map_urban_muc_council_qual_offset_x;
            this.SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_OFFSET_Y(map_urban_muc_council_qual_offset_x);

            var map_urban_icc_topo_offset_x = this.appraisal.map_urban_icc_topo_offset_x + this.urban_map_offset;
            this.appraisal.map_urban_icc_topo_offset_x = map_urban_icc_topo_offset_x;
            this.SET_APPRAISAL_MAP_URBAN_ICC_TOPO_OFFSET_Y(map_urban_icc_topo_offset_x);

            this.onRequestMucMap();
        },
        onGoDownMapUrbanMuc: function onGoDownMapUrbanMuc() {
            // console.log('going down Maps Zoom...')

            var map_urban_muc_land_colors_offset_y = this.appraisal.map_urban_muc_land_colors_offset_y - this.urban_map_offset;
            this.appraisal.map_urban_muc_land_colors_offset_y = map_urban_muc_land_colors_offset_y;
            this.SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_OFFSET_X(map_urban_muc_land_colors_offset_y);

            var map_urban_muc_council_qual_offset_y = this.appraisal.map_urban_muc_council_qual_offset_y - this.urban_map_offset;
            this.appraisal.map_urban_muc_council_qual_offset_y = map_urban_muc_council_qual_offset_y;
            this.SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_OFFSET_X(map_urban_muc_council_qual_offset_y);

            var map_urban_icc_topo_offset_y = this.appraisal.map_urban_icc_topo_offset_y - this.urban_map_offset;
            this.appraisal.map_urban_icc_topo_offset_y = map_urban_icc_topo_offset_y;
            this.SET_APPRAISAL_MAP_URBAN_ICC_TOPO_OFFSET_X(map_urban_icc_topo_offset_y);

            this.onRequestMucMap();
        },

        duplicateRoom: function duplicateRoom(entity) {
            /*
            this.master_loading = true
            const new_versionnumber = entity.version + 1
            this.RESET_APPRAISALREPORT().then((res) => {
            this.CREATE_NEW_APPRAISALREPORT({
            path: 'appraisalreports' + '/',
            parent_path: 'appraisalfiles' + '/' + this.appraisalfile.id + '/' + 'appraisalreports' + '/',
            file_id: this.appraisalfile.id,
            number: entity.number,
            version: new_versionnumber
            }).then((res) => {
            console.log('duplicateAppraisalReport then res:')
            console.log(res)
            const new_object_id = res.key
            const new_object_version = new_versionnumber
            this.GET_APPRAISALREPORT({ path: 'appraisalreports' + '/' + entity.id }).then((res) => {
            console.log(' *^*^*^*^*^*^*^*^*^*^get appraisal report res: ')
            console.log(res)
            let new_object = res
            new_object.id = new_object_id
            new_object.version = new_object_version
            this.UPDATE_APPRAISALREPORT({
            object: new_object,
            path: 'appraisalreports/',
            parent_path: 'appraisalfiles' + '/' + this.appraisalfile.id + '/' + 'appraisalreports' + '/',
            key: new_object_id
            }).then((res) => {
            this.master_loading = true
            this.FETCH_APPRAISALFILE_APPRAISALREPORTS({path: 'appraisalfiles' + '/' + this.$route.query.id + '/' + 'appraisalreports'})
            .then(() => {
            this.master_loading = false
            })
            })
            })
            })
            })
            */

        },
        editRoom: function editRoom(entity) {

            /*
            this.SET_APPRAISAL({path: 'appraisals' + '/' + entity.id + '/'}).then((res) => {
            this.$router.push({name: 'appraisal-editor', query: {id: entity.id}})
            })
            */

        },
        deleteRoom: function deleteRoom(entity) {
            var _this62 = this;

            this.master_loading = true;
            this.DELETE_ROOM({
                path: 'appraisal_rooms' + '/' + this.appraisal.id + '/' + entity.id,
                parent_path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'rooms' + '/' + entity.id,
                appraisal_id: this.appraisal.id
            }).then(function (res) {
                // this.$router.push({name: 'room-editor', query: {id: this.appraisal.id}})
                _this62.FETCH_APPRAISAL_ROOMS({ path: 'appraisal_rooms' + '/' + _this62.appraisal.id + '/' }).then(function () {
                    _this62.calc_net_area(_this62.object_to_array(_this62.appraisal_rooms));
                    _this62.calc_adopted_areas();
                    _this62.master_loading = false;
                });
            });
        },
        deleteCoveredOutdoor: function deleteCoveredOutdoor(entity) {
            var _this63 = this;

            this.master_loading = true;
            this.DELETE_COVERED_OUTDOOR({
                path: 'appraisal_covered_outdoors' + '/' + this.appraisal.id + '/' + entity.id,
                parent_path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'covered_outdoors' + '/' + entity.id,
                appraisal_id: this.appraisal.id
            }).then(function (res) {
                _this63.FETCH_APPRAISAL_COVERED_OUTDOORS({ path: 'appraisal_covered_outdoors' + '/' + _this63.appraisal.id + '/' }).then(function () {
                    _this63.calc_covered_outdoors_net_area(_this63.object_to_array(_this63.appraisal_covered_outdoors));
                    _this63.calc_adopted_areas();
                    _this63.master_loading = false;
                });
            });
        },
        deleteUncoveredOutdoor: function deleteUncoveredOutdoor(entity) {
            var _this64 = this;

            this.master_loading = true;
            this.DELETE_UNCOVERED_OUTDOOR({
                path: 'appraisal_uncovered_outdoors' + '/' + this.appraisal.id + '/' + entity.id,
                parent_path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'uncovered_outdoors' + '/' + entity.id,
                appraisal_id: this.appraisal.id
            }).then(function (res) {
                _this64.FETCH_APPRAISAL_UNCOVERED_OUTDOORS({ path: 'appraisal_uncovered_outdoors' + '/' + _this64.appraisal.id + '/' }).then(function () {
                    _this64.calc_uncovered_outdoors_net_area(_this64.object_to_array(_this64.appraisal.uncovered_outdoors));
                    _this64.calc_adopted_areas();
                    _this64.master_loading = false;
                });
            });
        },
        editConstraint: function editConstraint(entity) {
            var _this65 = this;

            // console.log('edit constraint...')
            this.SET_CONSTRAINT({ path: 'appraisal_constraints' + '/' + this.appraisal.id + '/' + entity.id + '/' }).then(function (res) {
                _this65.$router.push({ name: 'constraint-editor', query: { id: entity.id } });
            });
        },
        deleteConstraint: function deleteConstraint(entity) {
            var _this66 = this;

            var result = window.confirm(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('You_are_about_to_delete ') + entity.id + '. ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Continue_q'));

            if (result) {

                this.DELETE_CONSTRAINT({
                    path: 'appraisal_constraints' + '/' + this.appraisal.id + '/' + entity.id,
                    key: entity.id,
                    parent_path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'constraints' + '/'
                }).then(function (res) {
                    //
                    _this66.master_loading = true;
                    _this66.FETCH_APPRAISAL_CONSTRAINTS({ path: 'appraisal_constraints' + '/' + _this66.appraisal.id + '/' }).then(function () {
                        _this66.master_loading = false;
                    });
                });
            }
        },
        editWarning: function editWarning(entity) {
            var _this67 = this;

            // console.log('edit warning...')
            this.SET_WARNING({ path: 'appraisal_warnings' + '/' + this.appraisal.id + '/' + entity.id + '/' }).then(function (res) {
                _this67.$router.push({ name: 'warning-editor', query: { id: entity.id } });
            });
        },
        deleteWarning: function deleteWarning(entity) {
            var _this68 = this;

            var result = window.confirm(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('You_are_about_to_delete ') + entity.id + '. ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Continue_q'));

            if (result) {

                this.DELETE_WARNING({
                    path: 'appraisal_warnings' + '/' + this.appraisal.id + '/' + entity.id,
                    key: entity.id,
                    parent_path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'warnings' + '/'
                }).then(function (res) {
                    //
                    _this68.master_loading = true;
                    _this68.FETCH_APPRAISAL_WARNINGS({ path: 'appraisal_warnings' + '/' + _this68.appraisal.id + '/' }).then(function () {
                        _this68.master_loading = false;
                    });
                });
            }
        },
        editNote: function editNote(entity) {
            var _this69 = this;

            // console.log('edit note...')
            this.SET_NOTE({ path: 'appraisal_notes' + '/' + this.appraisal.id + '/' + entity.id + '/' }).then(function (res) {
                _this69.$router.push({ name: 'note-editor', query: { id: entity.id } });
            });
        },
        deleteNote: function deleteNote(entity) {
            var _this70 = this;

            var result = window.confirm(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('You_are_about_to_delete ') + entity.id + '. ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Continue_q'));

            if (result) {

                this.DELETE_NOTE({
                    path: 'appraisal_notes' + '/' + this.appraisal.id + '/' + entity.id,
                    key: entity.id,
                    parent_path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'notes' + '/'
                }).then(function (res) {
                    //
                    _this70.master_loading = true;
                    _this70.FETCH_APPRAISAL_NOTES({ path: 'appraisal_notes' + '/' + _this70.appraisal.id + '/' }).then(function () {
                        _this70.master_loading = false;
                    });
                });
            }
        },

        uploadPhotographFiles: function uploadPhotographFiles(e) {
            var _this71 = this;

            // console.log(e)
            this.master_loading = true;
            var data = {
                files: e.target.files,
                path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'photographs' + '/'
            };
            this.UPLOAD_PHOTOGRAPH_FILES(data).then(function () {
                _this71.FETCH_APPRAISAL_PHOTOGRAPHS({ path: 'realestate_appraisals' + '/' + _this71.realestate.id + '/' + _this71.appraisal.id + '/' + 'photographs' }).then(function () {
                    _this71.$forceUpdate();
                    _this71.master_loading = false;
                });
            });
        },
        editPhotograph: function editPhotograph(entity) {
            var _this72 = this;

            this.SET_PHOTOGRAPH({ path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'photographs' + '/' + entity.id + '/' }).then(function (res) {
                _this72.$router.push({ name: 'photograph-editor', query: { id: entity.id } });
            });
        },
        deletePhotograph: function deletePhotograph(entity) {
            var _this73 = this;

            var result = window.confirm(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('You_are_about_to_delete the photograph "') + entity.filename + '". ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Continue_q'));

            if (result) {
                this.DELETE_PHOTOGRAPH({
                    path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'photographs' + '/' + entity.id + '/',
                    filename: entity.filename,
                    key: entity.id
                }).then(function (res) {
                    //
                    _this73.master_loading = true;
                    _this73.FETCH_APPRAISAL_PHOTOGRAPHS({ path: 'realestate_appraisals' + '/' + _this73.realestate.id + '/' + _this73.appraisal.id + '/' + 'photographs' }).then(function () {
                        _this73.master_loading = false;
                    });
                });
            }
        },

        uploadRegistryAnnexFiles: function uploadRegistryAnnexFiles(e) {
            var _this74 = this;

            // console.log(e)
            this.master_loading = true;
            var data = {
                files: e.target.files,
                path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'registryannexes' + '/'
            };
            this.UPLOAD_REGISTRYANNEX_FILES(data).then(function () {
                _this74.FETCH_APPRAISAL_REGISTRYANNEXES({ path: 'realestate_appraisals' + '/' + _this74.realestate.id + '/' + _this74.appraisal.id + '/' + 'registryannexes' }).then(function () {
                    _this74.master_loading = false;
                });
            });
        },
        editRegistryAnnex: function editRegistryAnnex(entity) {
            var _this75 = this;

            this.SET_REGISTRYANNEX({ path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'registryannexes' + '/' + entity.id + '/' }).then(function (res) {
                _this75.$router.push({ name: 'registry-annex-editor', query: { id: entity.id } });
            });
        },
        deleteRegistryAnnex: function deleteRegistryAnnex(entity) {
            var _this76 = this;

            var result = window.confirm(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('You_are_about_to_delete the photograph "') + entity.filename + '". ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Continue_q'));

            if (result) {
                this.DELETE_REGISTRYANNEX({
                    path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'registryannexes' + '/' + entity.id + '/',
                    filename: entity.filename,
                    key: entity.id
                }).then(function (res) {
                    //
                    _this76.master_loading = true;
                    _this76.FETCH_APPRAISAL_REGISTRYANNEXES({ path: 'realestate_appraisals' + '/' + _this76.realestate.id + '/' + _this76.appraisal.id + '/' + 'registryannexes' }).then(function () {
                        _this76.master_loading = false;
                    });
                });
            }
        },

        uploadCadasterAnnexFiles: function uploadCadasterAnnexFiles(e) {
            var _this77 = this;

            // console.log(e)
            this.master_loading = true;
            var data = {
                files: e.target.files,
                path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'cadasterannexes' + '/'
            };
            this.UPLOAD_CADASTERANNEX_FILES(data).then(function () {
                _this77.FETCH_APPRAISAL_CADASTERANNEXES({ path: 'realestate_appraisals' + '/' + _this77.realestate.id + '/' + _this77.appraisal.id + '/' + 'cadasterannexes' }).then(function () {
                    _this77.master_loading = false;
                });
            });
        },
        editCadasterAnnex: function editCadasterAnnex(entity) {
            var _this78 = this;

            this.SET_CADASTERANNEX({ path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'cadasterannexes' + '/' + entity.id + '/' }).then(function (res) {
                _this78.$router.push({ name: 'cadaster-annex-editor', query: { id: entity.id } });
            });
        },
        deleteCadasterAnnex: function deleteCadasterAnnex(entity) {
            var _this79 = this;

            var result = window.confirm(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('You_are_about_to_delete the photograph "') + entity.filename + '". ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Continue_q'));

            if (result) {
                this.DELETE_CADASTERANNEX({
                    path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'cadasterannexes' + '/' + entity.id + '/',
                    filename: entity.filename,
                    key: entity.id
                }).then(function (res) {
                    //
                    _this79.master_loading = true;
                    _this79.FETCH_APPRAISAL_CADASTERANNEXES({ path: 'realestate_appraisals' + '/' + _this79.realestate.id + '/' + _this79.appraisal.id + '/' + 'cadasterannexes' }).then(function () {
                        _this79.master_loading = false;
                    });
                });
            }
        },

        uploadUrbanAnnexFiles: function uploadUrbanAnnexFiles(e) {
            var _this80 = this;

            // console.log(e)
            this.master_loading = true;
            var data = {
                files: e.target.files,
                path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'urbanannexes' + '/'
            };
            this.UPLOAD_URBANANNEX_FILES(data).then(function () {
                _this80.FETCH_APPRAISAL_URBANANNEXES({ path: 'realestate_appraisals' + '/' + _this80.realestate.id + '/' + _this80.appraisal.id + '/' + 'urbanannexes' }).then(function () {
                    _this80.master_loading = false;
                });
            });
        },
        editUrbanAnnex: function editUrbanAnnex(entity) {
            var _this81 = this;

            this.SET_URBANANNEX({ path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'urbanannexes' + '/' + entity.id + '/' }).then(function (res) {
                _this81.$router.push({ name: 'urban-annex-editor', query: { id: entity.id } });
            });
        },
        deleteUrbanAnnex: function deleteUrbanAnnex(entity) {
            var _this82 = this;

            var result = window.confirm(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('You_are_about_to_delete the photograph "') + entity.filename + '". ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Continue_q'));

            if (result) {
                this.DELETE_URBANANNEX({
                    path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'urbanannexes' + '/' + entity.id + '/',
                    filename: entity.filename,
                    key: entity.id
                }).then(function (res) {
                    //
                    _this82.master_loading = true;
                    _this82.FETCH_APPRAISAL_URBANANNEXES({ path: 'realestate_appraisals' + '/' + _this82.realestate.id + '/' + _this82.appraisal.id + '/' + 'urbanannexes' }).then(function () {
                        _this82.master_loading = false;
                    });
                });
            }
        },

        uploadPlanAnnexFiles: function uploadPlanAnnexFiles(e) {
            var _this83 = this;

            // console.log(e)
            this.master_loading = true;
            var data = {
                files: e.target.files,
                path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'planannexes' + '/'
            };
            this.UPLOAD_PLANANNEX_FILES(data).then(function () {
                _this83.FETCH_APPRAISAL_PLANANNEXES({ path: 'realestate_appraisals' + '/' + _this83.realestate.id + '/' + _this83.appraisal.id + '/' + 'planannexes' }).then(function () {
                    _this83.master_loading = false;
                });
            });
        },
        editPlanAnnex: function editPlanAnnex(entity) {
            var _this84 = this;

            this.SET_PLANANNEX({ path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'planannexes' + '/' + entity.id + '/' }).then(function (res) {
                _this84.$router.push({ name: 'plan-annex-editor', query: { id: entity.id } });
            });
        },
        deletePlanAnnex: function deletePlanAnnex(entity) {
            var _this85 = this;

            var result = window.confirm(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('You_are_about_to_delete the photograph "') + entity.filename + '". ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Continue_q'));

            if (result) {
                this.DELETE_PLANANNEX({
                    path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'planannexes' + '/' + entity.id + '/',
                    filename: entity.filename,
                    key: entity.id
                }).then(function (res) {
                    //
                    _this85.master_loading = true;
                    _this85.FETCH_APPRAISAL_PLANANNEXES({ path: 'realestate_appraisals' + '/' + _this85.realestate.id + '/' + _this85.appraisal.id + '/' + 'planannexes' }).then(function () {
                        _this85.master_loading = false;
                    });
                });
            }
        },

        uploadCessionAnnexFiles: function uploadCessionAnnexFiles(e) {
            var _this86 = this;

            // console.log(e)
            this.master_loading = true;
            var data = {
                files: e.target.files,
                path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'cessionannexes' + '/'
            };
            this.UPLOAD_CESSIONANNEX_FILES(data).then(function () {
                _this86.FETCH_APPRAISAL_CESSIONANNEXES({ path: 'realestate_appraisals' + '/' + _this86.realestate.id + '/' + _this86.appraisal.id + '/' + 'cessionannexes' }).then(function () {
                    _this86.master_loading = false;
                });
            });
        },
        editCessionAnnex: function editCessionAnnex(entity) {
            var _this87 = this;

            this.SET_CESSIONANNEX({ path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'cessionannexes' + '/' + entity.id + '/' }).then(function (res) {
                _this87.$router.push({ name: 'cession-annex-editor', query: { id: entity.id } });
            });
        },
        deleteCessionAnnex: function deleteCessionAnnex(entity) {
            var _this88 = this;

            var result = window.confirm(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('You_are_about_to_delete the photograph "') + entity.filename + '". ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Continue_q'));

            if (result) {
                this.DELETE_CESSIONANNEX({
                    path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'cessionannexes' + '/' + entity.id + '/',
                    filename: entity.filename,
                    key: entity.id
                }).then(function (res) {
                    //
                    _this88.master_loading = true;
                    _this88.FETCH_APPRAISAL_CESSIONANNEXES({ path: 'realestate_appraisals' + '/' + _this88.realestate.id + '/' + _this88.appraisal.id + '/' + 'cessionannexes' }).then(function () {
                        _this88.master_loading = false;
                    });
                });
            }
        },

        uploadOtherAnnexFiles: function uploadOtherAnnexFiles(e) {
            var _this89 = this;

            // console.log(e)
            this.master_loading = true;
            var data = {
                files: e.target.files,
                path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'otherannexes' + '/'
            };
            this.UPLOAD_OTHERANNEX_FILES(data).then(function () {
                _this89.FETCH_APPRAISAL_OTHERANNEXES({ path: 'realestate_appraisals' + '/' + _this89.realestate.id + '/' + _this89.appraisal.id + '/' + 'otherannexes' }).then(function () {
                    _this89.master_loading = false;
                });
            });
        },
        editOtherAnnex: function editOtherAnnex(entity) {
            var _this90 = this;

            this.SET_OTHERANNEX({ path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'otherannexes' + '/' + entity.id + '/' }).then(function (res) {
                _this90.$router.push({ name: 'other-annex-editor', query: { id: entity.id } });
            });
        },
        deleteOtherAnnex: function deleteOtherAnnex(entity) {
            var _this91 = this;

            var result = window.confirm(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('You_are_about_to_delete the photograph "') + entity.filename + '". ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Continue_q'));

            if (result) {
                this.DELETE_OTHERANNEX({
                    path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.appraisal.id + '/' + 'otherannexes' + '/' + entity.id + '/',
                    filename: entity.filename,
                    key: entity.id
                }).then(function (res) {
                    //
                    _this91.master_loading = true;
                    _this91.FETCH_APPRAISAL_OTHERANNEXES({ path: 'realestate_appraisals' + '/' + _this91.realestate.id + '/' + _this91.appraisal.id + '/' + 'otherannexes' }).then(function () {
                        _this91.master_loading = false;
                    });
                });
            }
        }
    }),
    head: {
        title: {
            //inner: Vue.i18n.translate('New_contact')
            inner: 'Edit appraisal'
        }
    }

});

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ContactsSearch_Index_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ContactsSearch_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_ContactsSearch_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_SideNavBar_Index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_SideNavBar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_SideNavBar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_SuccessMessage_vue__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_SuccessMessage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_SuccessMessage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__options_honorific_titles__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__options_person_types__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Datatable_datatable_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Datatable_datatable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_Datatable_datatable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Datatable_datatable_column_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Datatable_datatable_column_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Datatable_datatable_column_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__aggregators_aggregators_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__formatters_formatters_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Toggles_checkbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Toggles_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_Toggles_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Paginator_paginator_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Paginator_paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_Paginator_paginator_vue__);
var _name$mixins$data$cre;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



























/* harmony default export */ __webpack_exports__["default"] = (_name$mixins$data$cre = {
    name: 'appraisals-index',

    mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins__["d" /* dateMixin */], __WEBPACK_IMPORTED_MODULE_5__mixins__["a" /* localStorageMixin */], __WEBPACK_IMPORTED_MODULE_5__mixins__["e" /* objectsMixin */]],

    data: function data() {
        return {
            loading: false,
            fileOpen: false,
            filter_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type_here_to_filter_paginated_data'),
            new_appraisalreport_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_appraisal_report'),
            cancel_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cancel'),
            goback_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_back') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            goup_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_up') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            save_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('go_up'),
            cad_ref_error_text_01: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cadastral_Reference_less_20_positions_error_text'),
            page_dirty_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('The_page_contains_unsaved_changes'),
            actions_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Actions'),
            duplicate_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Duplicate'),
            edit_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Edit'),
            delete_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Delete'),
            value: null,
            ms_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Pick_an_option'),
            error: null,
            success_message: null,
            honorificTitleOptions: __WEBPACK_IMPORTED_MODULE_14__options_honorific_titles__["a" /* default */],
            personTypeOptions: __WEBPACK_IMPORTED_MODULE_15__options_person_types__["a" /* default */],
            all_real_estate_appraisals_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: "EUR",
                dateFormat: "DD/MM/YYYY",
                columns: [{
                    id: "number",
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Report_number'),
                    width: 14,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: "version",
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Version'),
                    width: 8,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: "description",
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Description'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: "date_modified",
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Last_modified'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format('DD/MM/YYYY HH:mm:ss');
                    }
                }],
                selected: []
            }
        };
    },

    created: function created() {},


    components: {
        Bar: __WEBPACK_IMPORTED_MODULE_9__components_Bar_Index_vue___default.a,
        Message: __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default.a,
        SuccessMessage: __WEBPACK_IMPORTED_MODULE_13__components_SuccessMessage_vue___default.a,
        IconButton: __WEBPACK_IMPORTED_MODULE_10__components_IconButton_Index_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_6__components_Spinner_vue___default.a,
        Checkbox: __WEBPACK_IMPORTED_MODULE_20__components_Toggles_checkbox_vue___default.a,
        Datatable: __WEBPACK_IMPORTED_MODULE_16__components_Datatable_datatable_vue___default.a,
        DatatableColumn: __WEBPACK_IMPORTED_MODULE_17__components_Datatable_datatable_column_vue___default.a,
        Paginator: __WEBPACK_IMPORTED_MODULE_21__components_Paginator_paginator_vue___default.a,
        SideNavBar: __WEBPACK_IMPORTED_MODULE_11__components_SideNavBar_Index_vue___default.a
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['theme', 'currentLocale', 'all_realestate_appraisals']))

}, _defineProperty(_name$mixins$data$cre, 'created', function created() {
    var _this = this;

    this.FETCH_ALL_REALESTATE_APPRAISALS({ path: 'realestate_appraisals' + '/' }).then(function () {
        _this.loading = false;
    });
}), _defineProperty(_name$mixins$data$cre, 'methods', _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['CREATE_NEW_APPRAISALREPORT', 'DELETE_APPRAISALREPORT', 'FETCH_ALL_REALESTATE_APPRAISALS', 'FETCH_APPRAISALFILE_APPRAISALREPORTS', 'RESET_APPRAISALREPORT', 'GET_APPRAISALREPORT', 'SET_APPRAISALREPORT', 'SET_APPRAISALFILE_DESCRIPTION', 'SET_APPRAISALFILE_NUMBER', 'UPDATE_APPRAISALFILE', 'UPDATE_APPRAISALREPORT']), {

    set_appraisalfile_description: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
        this.SET_APPRAISALFILE_DESCRIPTION(e.target.value);
    }, 1000),
    set_appraisalfile_number: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
        this.SET_APPRAISALFILE_NUMBER(Number(e.target.value));
    }, 1000),

    onCreateNewAppraisalReport: function onCreateNewAppraisalReport() {

        /*
         this.loading = true
        // console.log('hey')
        // console.log('appraisalfile: ')
        // console.log(this.appraisalfile)
         const appraisalreports_size = _.size(this.appraisalfile_appraisalreports)
         let new_reportnumber = 1
        let new_versionnumber = 1
         if (appraisalreports_size > 0) {
             const reportnumbers = _.reverse(_.map(this.appraisalfile_appraisalreports, 'number'))
            new_reportnumber = reportnumbers[0] + 1
            // console.log('map reportnumbers: ')
            // console.log(reportnumbers)
         }
         this.RESET_APPRAISALREPORT().then((res) => {
            this.CREATE_NEW_APPRAISALREPORT({
                path: 'appraisalreports' + '/',
                parent_path: 'appraisalfiles' + '/' + this.appraisalfile.id + '/' + 'appraisalreports' + '/',
                file_id: this.appraisalfile.id,
                number: new_reportnumber,
                version: new_versionnumber
            }).then((res) => {
                this.$router.push({name: 'appraisalreport-editor', query: {id: this.appraisalreport.id}})
            })
        })
        */

    },
    duplicateAppraisalReport: function duplicateAppraisalReport(entity) {

        /*
         this.loading = true
         const new_versionnumber = entity.version + 1
         this.RESET_APPRAISALREPORT().then((res) => {
            this.CREATE_NEW_APPRAISALREPORT({
                path: 'appraisalreports' + '/',
                parent_path: 'appraisalfiles' + '/' + this.appraisalfile.id + '/' + 'appraisalreports' + '/',
                file_id: this.appraisalfile.id,
                number: entity.number,
                version: new_versionnumber
            }).then((res) => {
                 console.log('duplicateAppraisalReport then res:')
        console.log(res)
                 const new_object_id = res.key
                const new_object_version = new_versionnumber
                 this.GET_APPRAISALREPORT({ path: 'appraisalreports' + '/' + entity.id }).then((res) => {
                     console.log(' *^*^*^*^*^*^*^*^*^*^get appraisal report res: ')
        console.log(res)
                     let new_object = res
        new_object.id = new_object_id
        new_object.version = new_object_version
                      this.UPDATE_APPRAISALREPORT({
                        object: new_object,
                        path: 'appraisalreports/',
                        parent_path: 'appraisalfiles' + '/' + this.appraisalfile.id + '/' + 'appraisalreports' + '/',
                        key: new_object_id
                    }).then((res) => {
                         this.loading = true
                        this.FETCH_APPRAISALFILE_APPRAISALREPORTS({path: 'appraisalfiles' + '/' + this.$route.query.id + '/' + 'appraisalreports'})
                            .then(() => {
                                this.loading = false
                            })
                     })
        })
              })
        })
        */

    },
    onGoBack: function onGoBack() {
        // console.log('yeah back')
        __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].go(-1);
    },
    onGoUp: function onGoUp() {
        // console.log('yeah back')
        this.$router.push({ name: 'appraisalfiles-index' });
    },
    onSaveCurrentAppraisalFile: function onSaveCurrentAppraisalFile(data) {

        /*
        console.log('appraisalfile.id: ')
        console.log(this.appraisalfile.id)
        this.UPDATE_APPRAISALFILE({
            object: this.appraisalfile,
            path: 'appraisalfiles' + '/' + this.appraisalfile.id
        }).then((res) => {
            if (data.goback) {
                this.$router.push({name: 'appraisalfiles-index'})
            }
        })
        */
    },
    editAppraisalReport: function editAppraisalReport(entity) {

        /*
        this.SET_APPRAISALREPORT({path: 'appraisalreports' + '/' + entity.id + '/'}).then((res) => {
            this.$router.push({name: 'appraisalreport-editor', query: {id: entity.id}})
         })
        */
    },
    deleteAppraisalReport: function deleteAppraisalReport(entity) {

        /*
         const result = window.confirm(Vue.i18n.translate("You_are_about_to_delete ") + entity.filenumber + ', ' + entity.filedescription + ". " + Vue.i18n.translate("Continue_q"))
         if (result) {
             this.DELETE_APPRAISALREPORT({
                file_id: this.appraisalfile.id,
                path: 'appraisalreports' + '/' + entity.id,
                key: entity.id,
                parent_path: 'appraisalfiles' + '/' + this.appraisalfile.id + '/' + 'appraisalreports' + '/' + entity.id
            }).then((res) => {
                //
                this.loading = true
                this.FETCH_APPRAISALFILE_APPRAISALREPORTS({path: 'appraisalfiles' + '/' + this.$route.query.id + '/' + 'appraisalreports'})
                    .then(() => {
                        this.loading = false
                    })
            })
         }
        */

    }
})), _defineProperty(_name$mixins$data$cre, 'head', {
    title: {
        //inner: Vue.i18n.translate('New_appraisalfile')
        inner: 'Edit Appraisal-File'
    }
}), _name$mixins$data$cre);

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_SideNavBar_Index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_SideNavBar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_SideNavBar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_SuccessMessage_vue__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_SuccessMessage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_SuccessMessage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__options_honorific_titles__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__aggregators_aggregators_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__formatters_formatters_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue__);
var _name$mixins$data$cre;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
























/* harmony default export */ __webpack_exports__["default"] = (_name$mixins$data$cre = {
    name: 'appraiser-editor',

    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins__["d" /* dateMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["a" /* localStorageMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["e" /* objectsMixin */]],

    data: function data() {
        return {
            master_loading: false,
            filesOpen: true,
            fileOpen: true,
            reportOpen: true,
            filter_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type_here_to_filter_paginated_data'),
            new_address_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_address'),
            new_email_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_email'),
            new_telephone_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_telephone_number'),
            cancel_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cancel'),
            goback_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_back') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            save_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('go_back'),
            cad_ref_error_text_01: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cadastral_Reference_less_20_positions_error_text'),
            page_dirty_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('The_page_contains_unsaved_changes'),
            actions_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Actions'),
            value: null,
            ms_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Pick_an_option'),
            error: null,
            success_message: null,
            honorificTitleOptions: __WEBPACK_IMPORTED_MODULE_12__options_honorific_titles__["a" /* default */]
        };
    },

    created: function created() {},


    components: {
        Bar: __WEBPACK_IMPORTED_MODULE_7__components_Bar_Index_vue___default.a,
        Message: __WEBPACK_IMPORTED_MODULE_10__components_Message_vue___default.a,
        SuccessMessage: __WEBPACK_IMPORTED_MODULE_11__components_SuccessMessage_vue___default.a,
        IconButton: __WEBPACK_IMPORTED_MODULE_8__components_IconButton_Index_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default.a,
        Checkbox: __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue___default.a,
        Datatable: __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue___default.a,
        DatatableColumn: __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue___default.a,
        Paginator: __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue___default.a,
        SideNavBar: __WEBPACK_IMPORTED_MODULE_9__components_SideNavBar_Index_vue___default.a
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['theme', 'currentLocale', 'address', 'emailaddress', 'telephonenumber', 'appraiser', 'appraiser_addresses', 'appraiser_emailaddresses', 'appraiser_telephonenumbers']))

}, _defineProperty(_name$mixins$data$cre, 'created', function created() {

    this.master_loading = false;
}), _defineProperty(_name$mixins$data$cre, 'methods', _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['SET_APPRAISER_ADDRESSES', 'SET_APPRAISER_NAME', 'SET_APPRAISER_SURNAMES', 'SET_APPRAISER_TIN', 'SET_APPRAISER_PROF_ASSOC_REG_NUMBER', 'SET_APPRAISER_TITLE', 'SET_APPRAISER_COMPLETE_NAME', 'UPDATE_APPRAISER']), {
    set_appraiser_name: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
        var name = e.target.value;
        var surnames = '';
        if (this.appraiser.surnames) {
            surnames = this.appraiser.surnames;
        }
        var complete_name = surnames + ', ' + name;
        this.SET_APPRAISER_NAME(name);
        this.SET_APPRAISER_COMPLETE_NAME(complete_name);
    }, 1000),
    set_appraiser_surnames: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
        var surnames = e.target.value;
        var name = '';
        if (this.appraiser.name) {
            name = this.appraiser.name;
        }
        var complete_name = surnames + ', ' + name;
        this.SET_APPRAISER_SURNAMES(surnames);
        this.SET_APPRAISER_COMPLETE_NAME(complete_name);
    }, 1000),
    set_appraiser_tin: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
        this.SET_APPRAISER_TIN(e.target.value);
    }, 1000),
    set_appraiser_prof_assoc_reg_number: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
        this.SET_APPRAISER_PROF_ASSOC_REG_NUMBER(e.target.value);
    }, 1000),
    set_appraiser_title: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
        this.SET_APPRAISER_TITLE(e);
    }, 1000),
    onGoBack: function onGoBack() {
        // console.log('yeah back')
        __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].go(-1);
    },
    onSaveCurrentAppraiser: function onSaveCurrentAppraiser(data) {
        console.log('appraiser.id: ');
        console.log(this.appraiser.id);
        this.UPDATE_APPRAISER({
            object: this.appraiser,
            path: 'appraisers' + '/' + this.appraiser.id
        }).then(function (res) {
            if (data.goback) {
                __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].go(-1);
            }
        });
    }
})), _defineProperty(_name$mixins$data$cre, 'head', {
    title: {
        //inner: Vue.i18n.translate('New_appraiser')
        inner: 'Edit appraiser'
    }
}), _name$mixins$data$cre);

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_SideNavBar_Index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_SideNavBar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_SideNavBar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Datatable_datatable_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Datatable_datatable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Datatable_datatable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Datatable_datatable_column_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Datatable_datatable_column_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Datatable_datatable_column_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__aggregators_aggregators_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__formatters_formatters_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Toggles_checkbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Toggles_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Toggles_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Paginator_paginator_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Paginator_paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_Paginator_paginator_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














// import DatatableCell from '../../../components/Datatable/datatable-cell.js'





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'appraisers-index',

    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins__["a" /* localStorageMixin */]],

    data: function data() {
        return {
            master_loading: true,
            filesOpen: false,
            fileOpen: false,
            reportOpen: false,
            error: null,
            filter_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type_here_to_filter_paginated_data'),
            new_appraiser_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_appraiser'),
            customers: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,

                currency: 'USD',
                dateFormat: 'D MMMM YYYY',

                columns: [{
                    id: 'name',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Name'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'surnames',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Surnames'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }],

                rows: [{
                    id: '0584e8d2-984c-4ce0-a20f-8b9e21cd2c00',
                    name: 'Nancy Fuller',
                    purchasor_email: 'nfuller0@about.me',
                    purchase_date: '2002-01-02T04:45:48Z',
                    purchase_amount: 1166.14
                }, {
                    id: 'f4769183-38af-4c22-8383-6dea302466fd',
                    name: 'Melissa Meyer',
                    purchasor_email: 'mmeyer1@angelfire.com',
                    purchase_date: '2010-05-15T08:13:59Z',
                    purchase_amount: 6123.50
                }, {
                    id: 'e171c9fb-2438-4f23-8d0d-011b2d8e95bc',
                    name: 'Larry Rose',
                    purchasor_email: 'lrose2@cdbaby.com',
                    purchase_date: '2014-11-23T09:18:18Z',
                    purchase_amount: 8288.27
                }, {
                    id: '3cad078d-083b-416e-9dd4-2f1470c3458d',
                    name: 'Jack Simpson',
                    purchasor_email: 'jsimpson3@mayoclinic.com',
                    purchase_date: '2002-01-02T04:45:48Z',
                    purchase_amount: 1215.03
                }, {
                    id: 'ef7ff12c-90e5-4bfb-8fdd-9f20e4206afa',
                    name: 'Ernest Watson',
                    purchasor_email: 'ewatson4@nytimes.com',
                    purchase_date: '2002-01-02T04:45:48Z',
                    purchase_amount: 9455.16
                }, {
                    id: 'b243be08-6b9c-4ebd-bb8b-b59256ad4956',
                    name: 'Adam Castillo',
                    purchasor_email: 'acastillo5@dailymotion.com',
                    purchase_date: '2014-08-22T08:14:28Z',
                    purchase_amount: 9988.45
                }, {
                    id: 'a491adf5-8129-4f93-9442-98522fbd1e90',
                    name: 'Wayne Wilson',
                    purchasor_email: 'wwilson6@indiegogo.com',
                    purchase_date: '2012-03-07T22:16:08Z',
                    purchase_amount: 4563.87
                }, {
                    id: '497a6cca-5c9c-4b93-af8e-63c93de3eacf',
                    name: 'Roy Coleman',
                    purchasor_email: 'rcoleman7@independent.co.uk',
                    purchase_date: '2010-09-14T05:05:17Z',
                    purchase_amount: 4563.87
                }, {
                    id: 'ea34a698-fb86-44a5-b80e-57087d48737c',
                    name: 'Betty Diaz',
                    purchasor_email: 'bdiaz8@dropbox.com',
                    purchase_date: '2012-03-07T22:16:08Z',
                    purchase_amount: 7527.62
                }, {
                    id: 'c48e5e68-cae5-4a2e-96b2-8509fca19ddb',
                    name: 'Sharon Gardner',
                    purchasor_email: 'sgardner9@seesaa.net',
                    purchase_date: '2004-10-14T14:59:00Z',
                    purchase_amount: 1166.14
                }],

                selected: []
            }
        };
    },

    created: function created() {
        var _this = this;

        this.FETCH_APPRAISERS().then(function () {
            _this.master_loading = false;
        });
    },


    components: {
        Bar: __WEBPACK_IMPORTED_MODULE_7__components_Bar_Index_vue___default.a,
        Checkbox: __WEBPACK_IMPORTED_MODULE_14__components_Toggles_checkbox_vue___default.a,
        Datatable: __WEBPACK_IMPORTED_MODULE_10__components_Datatable_datatable_vue___default.a,
        DatatableColumn: __WEBPACK_IMPORTED_MODULE_11__components_Datatable_datatable_column_vue___default.a,
        IconButton: __WEBPACK_IMPORTED_MODULE_8__components_IconButton_Index_vue___default.a,
        Paginator: __WEBPACK_IMPORTED_MODULE_15__components_Paginator_paginator_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default.a,
        SideNavBar: __WEBPACK_IMPORTED_MODULE_9__components_SideNavBar_Index_vue___default.a
    },
    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['appraisers', 'theme']), {
        selectAll: {
            get: function get() {
                return this.customers.selected.length === this.customers.rows.length;
            },
            set: function set(value) {
                this.customers.selected = value ? this.customers.rows : [];
            }
        }
    }),
    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['CREATE_NEW_APPRAISER', 'DELETE_APPRAISER', 'EDIT_APPRAISER', 'FETCH_APPRAISERS', 'SET_APPRAISER']), {
        onCreateNewAppraiser: function onCreateNewAppraiser() {
            var _this2 = this;

            this.CREATE_NEW_APPRAISER({ path: 'appraisers' }).then(function (res) {
                _this2.$router.push({ name: 'appraiser-editor' });
            });
        },
        appraisers_to_array: function appraisers_to_array(object) {
            return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(object);
        },
        editAppraiser: function editAppraiser(appraiser) {
            var _this3 = this;

            console.log('edit...');
            this.SET_APPRAISER({ path: 'appraisers' + '/' + appraiser.id }).then(function (res) {
                _this3.$router.push({ name: 'appraiser-editor', query: { id: appraiser.id } });
            });
        },
        deleteAppraiser: function deleteAppraiser(entity) {
            var _this4 = this;

            var result = window.confirm(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('You_are_about_to_delete ') + entity.name + '. ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Continue_q'));
            if (result) {
                this.DELETE_APPRAISER({
                    path: 'appraisers' + '/' + entity.id,
                    key: entity.id
                }).then(function (res) {
                    //
                    _this4.master_loading = true;
                    _this4.FETCH_APPRAISERS().then(function () {
                        _this4.master_loading = false;
                    });
                });
            }
        }
    }),

    head: {
        title: {
            //inner: Vue.i18n.translate('Appraisers_Index')
            inner: 'Appraisers Index'
        }
    }

});

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__router_index_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__aggregators_aggregators_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__formatters_formatters_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var _require = __webpack_require__(40),
    map = _require.map;

var _require2 = __webpack_require__(40),
    forEach = _require2.forEach;












/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'bdefiles-editor',

    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins__["d" /* dateMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["a" /* localStorageMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["e" /* objectsMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["c" /* utilsMixin */]],

    data: function data() {
        return {
            master_loading: true,
            loading: true,
            query_comparables_loading: false,
            bdefilesOpen: false,
            adOpen: false,
            editabletrue: true,
            error: null,
            separator: false,
            success_message: null,
            queryComparableTypeValue: null,
            new_ad_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_ad_manually'),
            add_ad_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_ad'),
            query_bdefiles_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Query_bdefiles'),
            bdefiles_index_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('BDE_files_index'),
            bdefiles_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Ads'),
            //bde_appraisal_files_text: Vue.i18n.translate('BdE_appraisal_files'),
            //bde_realestate_files_text: Vue.i18n.translate('BdE_realestate_files'),
            //bde_comparable_files_text: Vue.i18n.translate('BdE_comparable_files'),
            //bde_relationships_files_text: Vue.i18n.translate('BdE_relationships_files'),
            bde_appraisal_files_text: 'Tasaciones',
            bde_realestate_files_text: 'Inmuebles',
            bde_comparable_files_text: 'Comparables',
            bde_relationships_files_text: 'Relaciones',
            filter_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type_here_to_filter_paginated_data'),
            cancel_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cancel'),
            goback_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_back') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            goup_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_up') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            save_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('go_up'),
            lat_lng_error_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Lat_lng_missing_error_text'),
            actions_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Actions'),
            duplicate_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Duplicate'),
            edit_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Edit'),
            delete_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Delete'),
            countryValue: null,
            municipalityValue: null,
            provinceValue: null,
            bdefiles_by_years: null,
            filesyear: null,
            numtasaciones: null,
            valortasaciones: null,
            numinmuebles: null,
            valorinmuebles: null,
            numcomparables: null,
            numrelaciones: null

        };
    },

    created: function created() {

        this.filesyear = this.$route.query.filesyear;

        this.numtasaciones = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(this.bde_appraisal_files[this.filesyear]);
        this.valortasaciones = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sumBy(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(this.bde_appraisal_files[this.filesyear]), function (value) {
            if (value.c11_valor_tasacion) {
                if (isNaN(Number(value.c11_valor_tasacion))) {
                    return 0;
                } else {
                    return Number(value.c11_valor_tasacion);
                }
            } else {
                return 0;
            }
        });
        this.numinmuebles = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(this.bde_realestate_files[this.filesyear]);
        this.valorinmuebles = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sumBy(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(this.bde_realestate_files[this.filesyear]), function (value) {
            if (value.c14_inm_valor_tasacion) {
                if (isNaN(Number(value.c14_inm_valor_tasacion))) {
                    return 0;
                } else {
                    return Number(value.c14_inm_valor_tasacion);
                }
            } else {
                return 0;
            }
        });

        this.numcomparables = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(this.bde_comparable_files[this.filesyear]);

        this.numrelaciones = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(this.bde_relationships_files[this.filesyear]);

        this.master_loading = false;
    },


    components: {
        Bar: __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default.a,
        Message: __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default.a,
        IconButton: __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default.a,
        Checkbox: __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue___default.a,
        Datatable: __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue___default.a,
        DatatableColumn: __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue___default.a,
        Paginator: __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue___default.a,
        SideNavBar: __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default.a
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['theme', 'currentLocale', 'appraisalreports', 'appraisalinvoices', 'appraisalfiles', 'appraisals', 'realestates', 'marketstudies', 'ad_comparables', 'realestates', 'warnings', 'constraints', 'bde_appraisal_files', 'bde_realestate_files', 'bde_comparable_files', 'bde_relationships_files'])),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['FETCH_APPRAISALREPORTS', 'FETCH_APPRAISALS', 'FETCH_APPRAISALFILES', 'FETCH_MARKETSTUDIES', 'FETCH_AD_COMPARABLES', 'FETCH_APPRAISALINVOICES', 'FETCH_REALESTATES', 'FETCH_WARNINGS', 'FETCH_CONSTRAINTS', 'SET_BDE_APPRAISAL_FILES', 'SET_BDE_REALESTATE_FILES', 'SET_BDE_COMPARABLE_FILES', 'SET_BDE_RELATIONSHIPS_FILES']), {
        onOpenAppraisalFile: function onOpenAppraisalFile(data) {

            var sep_char = '';

            if (this.separator === true) {
                console.log("separant!");
                sep_char = ";";
            }

            var formatHtml = function formatHtml(string) {
                var s = string;
                //non breaking space
                s = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.replace(s, new RegExp(' ', 'g'), '&nbsp;');
                //non breaking hyphen
                s = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.replace(s, new RegExp('-', 'g'), '&#8209;');
                //non breaking hyphen type2
                s = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.replace(s, new RegExp('/\u2013', 'g'), '&#8209;');
                //non breaking hyphen type3
                s = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.replace(s, new RegExp('/\u2014', 'g'), '&#8209;');
                //
                s = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.replace(s, new RegExp('‑', 'g'), '&#8209;');
                //
                s = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.replace(s, new RegExp('‑', 'g'), '&#8209;');

                // Ja haurien de venir sense tabs ni newlines
                //s = _.replace(s, new RegExp('\t', 'g'), ' ')
                //s = _.replace(s, new RegExp('\n', 'g'), '')

                return s;
            };
            //
            var win = window.open('', 'Tasaciones', 'toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,top=' + screen.height + ',left=' + (screen.width - 768));

            var wrapper_pre1 = '<html><head><title>Ficha de Tasaciones ' + this.filesyear;
            var wrapper_pre2 = '</title><style>span {font-family: consolas; font-size: 10px;} .oddcol {color: dodgerblue;} .paircol {color: indianred;} .pairrow {background: whitesmoke;} .oddrow {background: white;} </style></head><body bgcolor=\'white\'>';
            var wrapper_post = '</body></html>';

            win.document.write(wrapper_pre1);
            win.document.write(wrapper_pre2);

            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(this.bde_appraisal_files[this.filesyear], function (value) {

                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c01_cod_sociedad) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c02_fecha_ref) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c03_num_tasacion) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c04_fecha_tasacion) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c05_tipo_tasacion) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c06_finalidad_tasacion) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c07_sigue_leymh) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c08_sigue_eco) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c09_hay_advertencias) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c10_hay_condicionantes) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c11_valor_tasacion) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c12_importe_facturado) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c13_nif_mandatario) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c14_nombre_mandatario) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c15_codigo_mandatario) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c16_nif_solicitante) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c17_nombre_solicitante) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c18_nif_tasador) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c19_nombre_tasador) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c20_nif_supervisor) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c21_nombre_supervisor) + sep_char + '</span>');

                win.document.write('<br>');
            });

            win.document.write(wrapper_post);
        },
        set_separator: function set_separator(e) {

            console.log('ahi va, separator: ');
            console.log(this.separator);
        },
        onOpenRealestateFile: function onOpenRealestateFile(data) {

            var sep_char = '';

            if (this.separator === true) {
                console.log("separant!");
                sep_char = ";";
            }

            var formatHtml = function formatHtml(string) {
                var s = string;
                //non breaking space
                s = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.replace(s, new RegExp(' ', 'g'), '&nbsp;');
                //non breaking hyphen
                s = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.replace(s, new RegExp('-', 'g'), '&#8209;');
                //non breaking hyphen type2
                s = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.replace(s, new RegExp('/\u2013', 'g'), '&#8209;');
                //non breaking hyphen type3
                s = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.replace(s, new RegExp('/\u2014', 'g'), '&#8209;');
                //
                s = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.replace(s, new RegExp('‑', 'g'), '&#8209;');
                //
                s = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.replace(s, new RegExp('‑', 'g'), '&#8209;');

                // Ja haurien de venir sense tabs ni newlines
                //s = _.replace(s, new RegExp('\t', 'g'), ' ')
                //s = _.replace(s, new RegExp('\n', 'g'), '')

                return s;
            };
            //
            var win = window.open('', 'Inmuebles', 'toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,top=' + screen.height + ',left=' + (screen.width - 768));

            var wrapper_pre1 = '<html><head><title>Ficha de Inmuebles ' + this.filesyear;
            var wrapper_pre2 = '</title><style>span {font-family: consolas; font-size: 10px;} .oddcol {color: dodgerblue;} .paircol {color: indianred;} .pairrow {background: whitesmoke;} .oddrow {background: white;} </style></head><body bgcolor=\'white\'>';
            var wrapper_post = '</body></html>';

            win.document.write(wrapper_pre1);
            win.document.write(wrapper_pre2);

            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(this.bde_realestate_files[this.filesyear], function (value) {

                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c01_inm_cod_sociedad) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c02_inm_fecha_ref) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c03_inm_num_tasacion) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c04_inm_num_elemento) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c05_inm_tipo_activo) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c06_inm_tipo_vivienda) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c07_inm_tipo_uso) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c08_inm_estado_ocupacion) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c09_inm_visita_interior) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c10_inm_estado_construccion) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c11_inm_ano_construccion) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c12_inm_ano_ultima_rehab) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c13_inm_metodo_valoracion) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c14_inm_valor_tasacion) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c15_inm_valor_hipotesis_edif_terminado) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c16_inm_valor_reemplazamiento_neto) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c17_inm_valor_max_legal) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c18_inm_valor_actualizacion) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c19_inm_valor_comparacion) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c20_inm_ajuste_valor_comparacion) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c21_inm_valor_hipotecario) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c22_inm_pais) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c23_inm_codigo_ine) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c24_inm_nombre_municipio) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c25_inm_direccion) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c26_inm_codigo_postal) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c27_inm_ref_catastral) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c28_inm_idufir) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c29_inm_seccion_censal) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c30_inm_longitud_geolocalizacion) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c31_inm_latitud_geolocalizacion) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c32_inm_supf_const) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c33_inm_supf_const_con_zc) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c34_inm_supf_util) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c35_inm_supf_catastral) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c36_inm_supf_adoptada) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c37_inm_supf_parcela) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c38_inm_valor_unitario) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c39_inm_costes_construccion) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c40_inm_otros_gastos_unitarios) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c41_inm_num_banos) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c42_inm_num_dormitorios) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c43_inm_zonas_verdes) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c44_inm_piscina) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c45_inm_zonas_deportivas) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c46_inm_calefaccion) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c47_inm_aire_acondicionado) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c48_inm_calidad_construccion) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c49_estado_conservacion) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c50_inm_m2_terraza_cubierta) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c51_inm_m2_terraza_descubierta) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c52_inm_ascensor) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c53_inm_num_planta) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c54_inm_tipo_planta) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c55_inm_plazas_garaje) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c56_inm_trastero) + sep_char + '</span>');

                win.document.write('<br>');
            });

            win.document.write(wrapper_post);
        },
        onOpenComparableFile: function onOpenComparableFile(data) {

            var sep_char = '';

            if (this.separator === true) {
                console.log("separant!");
                sep_char = ";";
            }

            var formatHtml = function formatHtml(string) {
                var s = string;
                //non breaking space
                s = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.replace(s, new RegExp(' ', 'g'), '&nbsp;');
                //non breaking hyphen
                s = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.replace(s, new RegExp('-', 'g'), '&#8209;');
                //non breaking hyphen type2
                s = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.replace(s, new RegExp('/\u2013', 'g'), '&#8209;');
                //non breaking hyphen type3
                s = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.replace(s, new RegExp('/\u2014', 'g'), '&#8209;');
                //
                s = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.replace(s, new RegExp('‑', 'g'), '&#8209;');
                //
                s = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.replace(s, new RegExp('‑', 'g'), '&#8209;');

                // Ja haurien de venir sense tabs ni newlines
                //s = _.replace(s, new RegExp('\t', 'g'), ' ')
                //s = _.replace(s, new RegExp('\n', 'g'), '')

                return s;
            };
            //
            var win = window.open('', 'Inmuebles', 'toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,top=' + screen.height + ',left=' + (screen.width - 768));

            var wrapper_pre1 = '<html><head><title>Ficha de Comparables ' + this.filesyear;
            var wrapper_pre2 = '</title><style>span {font-family: consolas; font-size: 10px;} .oddcol {color: dodgerblue;} .paircol {color: indianred;} .pairrow {background: whitesmoke;} .oddrow {background: white;} </style></head><body bgcolor=\'white\'>';
            var wrapper_post = '</body></html>';

            win.document.write(wrapper_pre1);
            win.document.write(wrapper_pre2);

            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(this.bde_comparable_files[this.filesyear], function (value) {

                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c01_comp_cod_sociedad) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c02_comp_fecha_ref) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c03_comp_identificador) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c04_comp_fecha_captura) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c05_comp_tipo_datos) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c06_comp_visita_interior) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c07_comp_contraste_catastro) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c08_comp_datos_contacto) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c09_comp_pais) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c10_comp_codigo_ine) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c11_comp_municipio) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c12_comp_direccion) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c13_comp_codigo_postal) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c14_comp_ref_catastral) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c15_comp_idufir) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c16_comp_seccion_censal) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c17_comp_longitud) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c18_comp_latitud) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c19_comp_precio_oferta) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c20_comp_precio_venta) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c21_comp_supf_catastral) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c22_comp_supf_estimada) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c23_comp_supf_parcela) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c24_comp_precio_unitario) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c25_comp_ano_construccion) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c26_comp_ano_ultima_rehab) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c27_comp_tipo_vivienda) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c28_comp_num_banos) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c29_comp_num_dormitorios) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c30_comp_zonas_verdes) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c31_comp_piscina) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c32_comp_zonas_deportivas) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c33_comp_calefaccion) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c34_comp_aire_acondicionado) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c35_comp_calidad_construccion) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c36_comp_estado_conservacion) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c37_comp_m2_terraza_cubierta) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c38_comp_m2_terraza_descubierta) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c39_comp_ascensor) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c40_comp_num_planta) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c41_comp_tipo_planta) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c42_comp_num_plazas_garaje) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c43_comp_trastero) + sep_char + '</span>');

                win.document.write('<br>');
            });

            win.document.write(wrapper_post);
        },
        onOpenRelationshipsFile: function onOpenRelationshipsFile(data) {

            var sep_char = '';

            if (this.separator === true) {
                console.log("separant!");
                sep_char = ";";
            }

            var formatHtml = function formatHtml(string) {
                var s = string;
                //non breaking space
                s = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.replace(s, new RegExp(' ', 'g'), '&nbsp;');
                //non breaking hyphen
                s = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.replace(s, new RegExp('-', 'g'), '&#8209;');
                //non breaking hyphen type2
                s = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.replace(s, new RegExp('/\u2013', 'g'), '&#8209;');
                //non breaking hyphen type3
                s = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.replace(s, new RegExp('/\u2014', 'g'), '&#8209;');
                //
                s = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.replace(s, new RegExp('‑', 'g'), '&#8209;');
                //
                s = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.replace(s, new RegExp('‑', 'g'), '&#8209;');

                // Ja haurien de venir sense tabs ni newlines
                //s = _.replace(s, new RegExp('\t', 'g'), ' ')
                //s = _.replace(s, new RegExp('\n', 'g'), '')

                return s;
            };
            //
            var win = window.open('', 'Relaciones', 'toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,top=' + screen.height + ',left=' + (screen.width - 768));

            var wrapper_pre1 = '<html><head><title>Ficha de Relaciones ' + this.filesyear;
            var wrapper_pre2 = '</title><style>span {font-family: consolas; font-size: 10px;} .oddcol {color: dodgerblue;} .paircol {color: indianred;} .pairrow {background: whitesmoke;} .oddrow {background: white;} </style></head><body bgcolor=\'white\'>';
            var wrapper_post = '</body></html>';

            win.document.write(wrapper_pre1);
            win.document.write(wrapper_pre2);

            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(this.bde_relationships_files[this.filesyear], function (value) {

                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c01_rel_cod_sociedad) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c02_rel_fecha_ref) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c03_rel_num_tasacion) + sep_char + '</span>');
                win.document.write('<span class=\'paircol\'>' + formatHtml(value.c04_rel_num_elemento) + sep_char + '</span>');
                win.document.write('<span class=\'oddcol\'>' + formatHtml(value.c05_rel_codigoidcomparable) + sep_char + '</span>');

                win.document.write('<br>');
            });

            win.document.write(wrapper_post);
        }

    }),
    head: {
        title: {
            //inner: Vue.i18n.translate('New_contact')
            inner: 'BDE files'
        }

    }
});

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__router_index_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__aggregators_aggregators_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__formatters_formatters_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var _require = __webpack_require__(40),
    map = _require.map;

var _require2 = __webpack_require__(40),
    forEach = _require2.forEach;












/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'bdefiles-index',

    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins__["d" /* dateMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["a" /* localStorageMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["e" /* objectsMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["c" /* utilsMixin */]],

    data: function data() {
        return {
            master_loading: true,
            loading: true,
            query_comparables_loading: false,
            bdefilesOpen: false,
            adOpen: false,
            editabletrue: true,
            error: null,
            success_message: null,
            queryComparableTypeValue: null,
            new_ad_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_ad_manually'),
            add_ad_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_ad'),
            query_bdefiles_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Query_bdefiles'),
            bdefiles_index_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('BDE_files_index'),
            bdefiles_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Ads'),
            filter_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type_here_to_filter_paginated_data'),
            cancel_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cancel'),
            goback_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_back') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            goup_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_up') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            save_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('go_up'),
            lat_lng_error_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Lat_lng_missing_error_text'),
            actions_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Actions'),
            duplicate_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Duplicate'),
            edit_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Edit'),
            delete_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Delete'),
            countryValue: null,
            municipalityValue: null,
            provinceValue: null,
            bdefiles_by_years: null

        };
    },

    created: function created() {
        var _this = this;

        // fichero de tasaciones = "informes de tasaciones"
        var tasaciones = {};
        var tasaciones_errors = {};

        // fichero inmuebles
        var inmuebles = {};
        var inmuebles_errors = {};

        // fichero comparables
        var comparables = {};
        var comparables_errors = {};

        // fichero relaciones
        var relaciones = {};
        var relaciones_errors = {};

        this.FETCH_APPRAISALREPORTS().then(function () {

            _this.FETCH_REALESTATES().then(function () {

                var realestates_obj = _this.realestates;
                console.log('realestates_obj: ');
                console.log(realestates_obj);

                _this.FETCH_APPRAISALS().then(function () {

                    var appraisals_obj = _this.appraisals;
                    console.log('appraisals_obj: ');
                    console.log(appraisals_obj);

                    _this.FETCH_APPRAISALFILES().then(function () {

                        var appraisalfiles_obj = _this.appraisalfiles;
                        console.log('appraisalfiles_obj: ');
                        console.log(appraisalfiles_obj);

                        _this.FETCH_MARKETSTUDIES().then(function () {

                            _this.FETCH_AD_COMPARABLES().then(function () {

                                var ad_comparables_obj = _this.ad_comparables;
                                console.log('ad_comparables_obj: ');
                                console.log(ad_comparables_obj);

                                _this.FETCH_APPRAISALQUOTES().then(function () {

                                    var appraisalquotes_obj = _this.appraisalquotes;
                                    console.log('appraisalquotes_obj: ');
                                    console.log(appraisalquotes_obj);

                                    _this.FETCH_APPRAISALINVOICES().then(function () {

                                        var appraisalinvoices_obj = _this.appraisalinvoices;
                                        console.log('appraisalinvoices_obj: ');
                                        console.log(appraisalinvoices_obj);

                                        _this.FETCH_WARNINGS().then(function () {
                                            var warnings_obj = _this.warnings;
                                            console.log('warnings_obj: ');
                                            console.log(warnings_obj);

                                            _this.FETCH_CONSTRAINTS().then(function () {
                                                var constraints_obj = _this.constraints;
                                                console.log('constraints_obj: ');
                                                console.log(constraints_obj);

                                                var padchar = function padchar(input, positions, char) {

                                                    if (positions === 0) {
                                                        //console.log('hey positions are zero')
                                                        return '';
                                                    } else {
                                                        var input_checked = '';
                                                        if (input) {
                                                            if (input === input.toString()) {
                                                                // it's a string
                                                                input_checked = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.replace(input_checked, new RegExp('\t', 'g'), ' ');
                                                                input_checked = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.replace(input_checked, new RegExp('\n', 'g'), '');
                                                                input_checked = input.trim();
                                                            } else {
                                                                // it isn't
                                                                input_checked = input;
                                                            }
                                                        }
                                                        var pad_char = typeof char !== 'undefined' ? char : '_';
                                                        var pad = new Array(1 + positions).join(pad_char);
                                                        var output = (pad + input_checked).slice(-pad.length);
                                                        //console.log('output:' + output);
                                                        return output;
                                                    }
                                                };

                                                var paddecimals_bde = function paddecimals_bde(input, integerpositions, decimalpositions, char, withposnegsign) {

                                                    var input_parts = input.toString().split('.');

                                                    //console.log('input_parts: ')
                                                    //console.log(input_parts)

                                                    var integers = '';
                                                    var decimals = '';

                                                    if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isArray(input_parts)) {
                                                        if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(input_parts) > 1) {
                                                            integers = input_parts[0];

                                                            decimals = input_parts[1];
                                                        } else {
                                                            integers = input_parts[0];
                                                        }
                                                    } else {
                                                        integers = input_parts;
                                                    }

                                                    integers = integers.replace('-', '');

                                                    //console.log('integers: ')
                                                    //console.log(integers)

                                                    //console.log('decimals: ')
                                                    //console.log(decimals)

                                                    var sign = '';
                                                    if (Number(input) >= 0) {
                                                        sign = '+';
                                                    } else {
                                                        sign = '-';
                                                    }

                                                    var output = '';

                                                    if (withposnegsign) {
                                                        output = output + sign;
                                                    }

                                                    output = output + padchar(integers.toString(), integerpositions, char) + padchar(decimals.toString(), decimalpositions, char);

                                                    //console.log('output: ')
                                                    //console.log(output)

                                                    return output;
                                                };

                                                var database_fetch = function database_fetch(data) {
                                                    return new Promise(function (resolve, reject) {
                                                        _this.$store.dispatch('FETCH', data).then(function (res) {
                                                            console.log('fetching...');
                                                            resolve(res);
                                                        });
                                                    });
                                                };

                                                // let appraisalreports = this.appraisalreports

                                                var bdefiles_by_years = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.groupBy(_this.appraisalreports, function (o) {
                                                    return o.reportdate ? o.reportdate.substring(0, 4) : 'nd';
                                                });

                                                _this.bdefiles_by_years = bdefiles_by_years;

                                                console.log('bdefiles_by_years: ');
                                                console.log(bdefiles_by_years);

                                                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(bdefiles_by_years, function (value, key) {

                                                    var reports_year = key.toString();

                                                    tasaciones[reports_year] = {};
                                                    tasaciones_errors[reports_year] = {};

                                                    inmuebles[reports_year] = {};
                                                    inmuebles_errors[reports_year] = {};

                                                    comparables[reports_year] = {};
                                                    comparables_errors[reports_year] = {};

                                                    relaciones[reports_year] = {};
                                                    relaciones_errors[reports_year] = {};

                                                    var files_by_send_to_bde = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.groupBy(value, function (o) {
                                                        return o.send_to_bde ? o.send_to_bde : null;
                                                    });
                                                    console.log('files_by_send_to_bde (' + reports_year + '): ');
                                                    console.log(files_by_send_to_bde);

                                                    if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.has(files_by_send_to_bde, 'true')) {

                                                        var number_of_reports = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(files_by_send_to_bde['true']);

                                                        console.log('number of reports (' + reports_year + '): ');
                                                        console.log(number_of_reports);

                                                        var tas_count = 0;
                                                        var inm_count = 0;

                                                        var appraisals = [];

                                                        __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(files_by_send_to_bde['true'], function (value) {

                                                            var appraisalreport_obj = value;

                                                            // value = files_by_send_to_bde['true'][i]
                                                            tas_count = tas_count + 1;
                                                            var tas_count_str = tas_count.toString();

                                                            tasaciones[reports_year][tas_count_str] = {};
                                                            tasaciones_errors[reports_year][tas_count_str] = {};

                                                            if (value.realestates) {

                                                                var report_realestates_arr = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(value.realestates);

                                                                console.log('**ici**');
                                                                console.log(report_realestates_arr);
                                                                var first_realestate = report_realestates_arr[0];

                                                                var length = 0;
                                                                console.log('first_realestate: ');
                                                                console.log(first_realestate);

                                                                var first_realestate_appraisal = {};

                                                                if (first_realestate.appraisal_id) {
                                                                    first_realestate_appraisal = appraisals_obj[first_realestate.id][first_realestate.appraisal_id.id];
                                                                }

                                                                //console.log('first_realestate_appraisal: ')
                                                                //console.log(first_realestate_appraisal)

                                                                console.log('appraisals result for informe de tasación nº ' + tas_count_str + ' de ' + reports_year);
                                                                console.log(appraisals);

                                                                tasaciones[reports_year][tas_count_str]['_id'] = value.id;
                                                                tasaciones[reports_year][tas_count_str]['_index'] = tas_count_str;

                                                                // Código identificador de sociedad de tasación 1 9(04) Código identificador
                                                                tasaciones[reports_year][tas_count_str]['c01_cod_sociedad'] = '4470';

                                                                // Fecha de referencia 2 9(6) AAAAMM
                                                                tasaciones[reports_year][tas_count_str]['c02_fecha_ref'] = reports_year.toString() + '12';

                                                                // Número de tasación 3 9(20)
                                                                var c03_num_tasacion = '';
                                                                if (value.full_number) {
                                                                    c03_num_tasacion = value.full_number;
                                                                    c03_num_tasacion = c03_num_tasacion.replace(/[\/]/g, '');
                                                                } else {
                                                                    tasaciones_errors[reports_year][tas_count_str]['c03_num_tasacion'] = 'Manca el número de taxació';
                                                                }
                                                                tasaciones[reports_year][tas_count_str]['c03_num_tasacion'] = padchar(c03_num_tasacion, 20, '0');

                                                                // Fecha de tasación 4 9(8) Formato AAAAMMDD
                                                                var c04_fecha_tasacion = '';
                                                                if (value.reportdate) {
                                                                    c04_fecha_tasacion = value.reportdate;
                                                                    c04_fecha_tasacion = c04_fecha_tasacion.replace(/-/g, '');
                                                                } else {
                                                                    tasaciones_errors[reports_year][tas_count_str]['c04_fecha_tasacion'] = 'Manca la data de taxació';
                                                                }
                                                                tasaciones[reports_year][tas_count_str]['c04_fecha_tasacion'] = padchar(c04_fecha_tasacion, 8, '0');

                                                                // Tipo de tasación 5 X(1) Lista valores
                                                                var c05_tipo_tasacion = '';
                                                                var positions = 1;
                                                                var char = ' ';

                                                                if (first_realestate_appraisal) {
                                                                    if (first_realestate_appraisal['type']) {

                                                                        c05_tipo_tasacion = first_realestate_appraisal['type']['bde_code'];
                                                                    } else {
                                                                        tasaciones_errors[reports_year][tas_count_str]['c05_tipo_tasacion'] = 'Manca el tipus de taxació';
                                                                    }
                                                                }
                                                                //console.log('c05_tipo_tasacion: ')
                                                                //console.log(c05_tipo_tasacion)

                                                                tasaciones[reports_year][tas_count_str]['c05_tipo_tasacion'] = padchar(c05_tipo_tasacion, positions, char);
                                                                length = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(c05_tipo_tasacion);
                                                                if (length > positions || length < positions) {
                                                                    tasaciones_errors[reports_year][tas_count_str]['c05_tipo_tasacion'] = 'Nº de caràcters incorrecte';
                                                                }

                                                                // Finalidad de la tasación 6 X(1) Lista valores
                                                                var c06_finalidad_tasacion = '';
                                                                positions = 1;
                                                                char = ' ';

                                                                if (first_realestate_appraisal) {

                                                                    if (first_realestate_appraisal['purpose']) {
                                                                        if (c06_finalidad_tasacion = first_realestate_appraisal['purpose']['bde_code']) {
                                                                            c06_finalidad_tasacion = first_realestate_appraisal['purpose']['bde_code'];
                                                                        } else if (c06_finalidad_tasacion = first_realestate_appraisal['purpose']['code_bde']) {
                                                                            c06_finalidad_tasacion = first_realestate_appraisal['purpose']['code_bde'];
                                                                        } else {
                                                                            tasaciones_errors[reports_year][tas_count_str]['c06_finalidad_tasacion'] = 'Manca la finalitat de taxació';
                                                                        }
                                                                    } else {
                                                                        tasaciones_errors[reports_year][tas_count_str]['c06_finalidad_tasacion'] = 'Manca la finalitat de taxació';
                                                                    }
                                                                }
                                                                //console.log('c06_finalidad_tasacion: ')
                                                                //console.log(c06_finalidad_tasacion)

                                                                tasaciones[reports_year][tas_count_str]['c06_finalidad_tasacion'] = padchar(c06_finalidad_tasacion, positions, char);
                                                                length = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(c06_finalidad_tasacion);
                                                                if (length > positions || length < positions) {
                                                                    tasaciones_errors[reports_year][tas_count_str]['c06_finalidad_tasacion'] = 'Nº de caràcters incorrecte';
                                                                }

                                                                // Indicador de tasación conforme a la Ley del Mercado Hipotecario. 7 X(1) S (Sí) o N(No)
                                                                var c07_sigue_leymh = '';
                                                                positions = 1;
                                                                char = ' ';

                                                                if (first_realestate_appraisal) {
                                                                    if (first_realestate_appraisal['purpose']) {

                                                                        if (c07_sigue_leymh = first_realestate_appraisal['purpose']['acc_mortgage_market_law']['code_bde']) {
                                                                            c07_sigue_leymh = first_realestate_appraisal['purpose']['acc_mortgage_market_law']['code_bde'];
                                                                        } else if (c07_sigue_leymh = first_realestate_appraisal['purpose']['acc_mortgage_market_law']['bde_code']) {
                                                                            c07_sigue_leymh = first_realestate_appraisal['purpose']['acc_mortgage_market_law']['bde_code'];
                                                                        } else {
                                                                            tasaciones_errors[reports_year][tas_count_str]['c07_sigue_leymh'] = 'Manca si segueix la llei del mercat hipotecari';
                                                                        }
                                                                    } else {
                                                                        tasaciones_errors[reports_year][tas_count_str]['c07_sigue_leymh'] = 'Manca si segueix la llei del mercat hipotecari';
                                                                    }
                                                                }
                                                                //console.log('c07_sigue_leymh: ')
                                                                //console.log(c07_sigue_leymh)

                                                                tasaciones[reports_year][tas_count_str]['c07_sigue_leymh'] = padchar(c07_sigue_leymh, positions, char);
                                                                length = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(c07_sigue_leymh);
                                                                if (length > positions || length < positions) {
                                                                    tasaciones_errors[reports_year][tas_count_str]['c07_sigue_leymh'] = 'Nº de caràcters incorrecte';
                                                                }

                                                                // Indicador de cumplimiento O.M. ECO/805/2003 8 X(1) S (Sí) o N(No)
                                                                var c08_sigue_eco = '';
                                                                positions = 1;
                                                                char = ' ';

                                                                if (first_realestate_appraisal) {
                                                                    if (first_realestate_appraisal['purpose']) {
                                                                        if (c08_sigue_eco = first_realestate_appraisal['purpose']['acc_mortgage_market_law']['code_bde']) {
                                                                            c08_sigue_eco = first_realestate_appraisal['purpose']['acc_mortgage_market_law']['code_bde'];
                                                                        } else if (c08_sigue_eco = first_realestate_appraisal['purpose']['acc_mortgage_market_law']['bde_code']) {
                                                                            c08_sigue_eco = first_realestate_appraisal['purpose']['acc_mortgage_market_law']['bde_code'];
                                                                        } else {
                                                                            tasaciones_errors[reports_year][tas_count_str]['c08_sigue_eco'] = 'Manca si segueix la ECO';
                                                                        }
                                                                    } else {
                                                                        tasaciones_errors[reports_year][tas_count_str]['c08_sigue_eco'] = 'Manca si segueix la ECO';
                                                                    }
                                                                }
                                                                //console.log('c08_sigue_eco: ')
                                                                //console.log(c08_sigue_eco)

                                                                tasaciones[reports_year][tas_count_str]['c08_sigue_eco'] = padchar(c08_sigue_eco, positions, char);
                                                                length = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(c08_sigue_eco);
                                                                if (length > positions || length < positions) {
                                                                    tasaciones_errors[reports_year][tas_count_str]['c08_sigue_eco'] = 'Nº de caràcters incorrecte';
                                                                }

                                                                // Indicador de advertencias en la tasación 9 X(1) S (Sí) o N(No)
                                                                // Indicador de condicionantes en la tasación 10 X(1) S (Sí) o N(No)

                                                                var c09_hay_advertencias = 'N';
                                                                positions = 1;
                                                                char = ' ';

                                                                var c10_hay_condicionantes = 'N';
                                                                positions = 1;
                                                                char = ' ';

                                                                var num_elemento = 0;

                                                                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(report_realestates_arr, function (realestate) {

                                                                    // només incorporem a la fitxa els immobles que són habitatges o edificis
                                                                    if (realestates_obj[realestate.id]) {

                                                                        if (realestates_obj[realestate.id]['dwelling_type']) {

                                                                            if (realestates_obj[realestate.id]['dwelling_type']['bde_code'] === 1 || realestates_obj[realestate.id]['dwelling_type']['bde_code'] === 2 || realestates_obj[realestate.id]['dwelling_type']['bde_code'] === 3) {

                                                                                num_elemento = num_elemento + 1;

                                                                                console.log('realestate in: ' + realestate.full_address);
                                                                                if (warnings_obj) {

                                                                                    if (realestate.appraisal_id) {
                                                                                        if (warnings_obj[realestate.appraisal_id.id]) {
                                                                                            c09_hay_advertencias = 'S';
                                                                                        }
                                                                                    }
                                                                                }

                                                                                if (constraints_obj) {

                                                                                    if (realestate.appraisal_id) {
                                                                                        if (constraints_obj[realestate.appraisal_id.id]) {
                                                                                            c10_hay_condicionantes = 'S';
                                                                                        }
                                                                                    }
                                                                                }

                                                                                inm_count = inm_count + 1;
                                                                                var inm_count_str = inm_count.toString();
                                                                                inmuebles[reports_year][realestate.id] = {};

                                                                                inmuebles[reports_year][realestate.id]['_index'] = inm_count_str;

                                                                                inmuebles[reports_year][realestate.id]['c01_inm_cod_sociedad'] = '4470';

                                                                                // INM - Fecha de referencia 2 9(6) AAAAMM
                                                                                //let atest = reports_year.toString() + '12'
                                                                                //console.log('iuiuiu: ')
                                                                                //console.log(atest)
                                                                                inmuebles[reports_year][realestate.id]['c02_inm_fecha_ref'] = reports_year.toString() + '12';

                                                                                // INM - Número de tasación 3 9(20)
                                                                                inmuebles[reports_year][realestate.id]['c03_inm_num_tasacion'] = padchar(c03_num_tasacion, 20, '0');

                                                                                // INM - Número de elemento dentro del mismo informe de tasación 4 9(3)
                                                                                inmuebles[reports_year][realestate.id]['c04_inm_num_elemento'] = padchar(num_elemento.toString(), 3, '0');

                                                                                // INM Uso
                                                                                var c07_inm_tipo_uso = '';

                                                                                // INM Estado Ocupación
                                                                                var c08_inm_estado_ocupacion = '';

                                                                                // INM Visita Interior
                                                                                var c09_inm_visita_interior = '';

                                                                                // INM Estado Construcción
                                                                                var c10_inm_estado_construccion = '';

                                                                                // INM Año de la construcción
                                                                                var c11_inm_ano_construccion = '';

                                                                                // INM Año de la última rehabilitación
                                                                                var c12_inm_ano_ultima_rehab = '';

                                                                                // INM Método de Valoración
                                                                                var c13_inm_metodo_valoracion = '';

                                                                                // INM Valor tasación
                                                                                var c14_inm_valor_tasacion = '';

                                                                                // INM Valor tasación en hipótesis de edificio terminado
                                                                                var c15_inm_valor_hipotesis_edif_terminado = '';

                                                                                // INM Valor de reemplazamiento neto
                                                                                var c16_inm_valor_reemplazamiento_neto = '';

                                                                                // INM Valor máximo legal
                                                                                var c17_inm_valor_max_legal = '';

                                                                                // INM Valor de actualización
                                                                                var c18_inm_valor_actualizacion = '';

                                                                                // INM Valor por comparación
                                                                                var c19_inm_valor_comparacion = '';

                                                                                // INM Ajuste valor comparación
                                                                                var c20_inm_ajuste_valor_comparacion = '';

                                                                                // INM Valor hipotecario
                                                                                var c21_inm_valor_hipotecario = '';

                                                                                // INM Pais
                                                                                var c22_inm_pais = '';

                                                                                // INM Codigo INE
                                                                                var c23_inm_codigo_ine = '';

                                                                                // INM Nombre Municipio
                                                                                var c24_inm_nombre_municipio = '';

                                                                                // INM Dirección
                                                                                var c25_inm_direccion = '';

                                                                                // INM Código Postal
                                                                                var c26_inm_codigo_postal = '';

                                                                                // INM Referencia Catastral
                                                                                var c27_inm_ref_catastral = '';

                                                                                // INM IDUFIR
                                                                                var c28_inm_idufir = '';

                                                                                // INM Código de sección censal
                                                                                var c29_inm_seccion_censal = '';

                                                                                // INM Longitud geolocalización
                                                                                var c30_inm_longitud_geolocalizacion = '';

                                                                                // INM Latitud geolocalización
                                                                                var c31_inm_latitud_geolocalizacion = '';

                                                                                // INM Superficie Construida
                                                                                var c32_inm_supf_const = '';

                                                                                // INM Superficie Construida con zonas comunes
                                                                                var c33_inm_supf_const_con_zc = '';

                                                                                // INM Superficie Útil
                                                                                var c34_inm_supf_util = '';

                                                                                // INM Superficie Catastral
                                                                                var c35_inm_supf_catastral = '';

                                                                                // INM Superficie Adoptada
                                                                                var c36_inm_supf_adoptada = '';

                                                                                // INM Superficie Parcela
                                                                                var c37_inm_supf_parcela = '';

                                                                                // check
                                                                                var property_type = '';

                                                                                // INM Valor Unitario
                                                                                var c38_inm_valor_unitario = '';

                                                                                // INM Costes de construcción estimados
                                                                                var c39_inm_costes_construccion = '';

                                                                                // INM Otros gastos necessarios unitarios
                                                                                var c40_inm_otros_gastos_unitarios = '';

                                                                                // INM Número de baños
                                                                                var c41_inm_num_banos = '';

                                                                                // INM Número de dormitorios
                                                                                var c42_inm_num_dormitorios = '';

                                                                                // INM Zonas Verdes
                                                                                var c43_inm_zonas_verdes = '';

                                                                                // INM Piscina
                                                                                var c44_inm_piscina = '';

                                                                                // INM Zonas Deportivas
                                                                                var c45_inm_zonas_deportivas = '';

                                                                                // INM Calefacción
                                                                                var c46_inm_calefaccion = '';

                                                                                // INM Aire Acondicionado
                                                                                var c47_inm_aire_acondicionado = '';

                                                                                // INM Calidad Construcción
                                                                                var c48_inm_calidad_construccion = '';

                                                                                // INM Estado conservación
                                                                                var c49_estado_conservacion = '';

                                                                                // INM Metros terraza cubierta
                                                                                var c50_inm_m2_terraza_cubierta = '';

                                                                                // INM Metros terraza descubierta
                                                                                var c51_inm_m2_terraza_descubierta = '';

                                                                                // INM Ascensor
                                                                                var c52_inm_ascensor = '';

                                                                                // INM Nº planta
                                                                                var c53_inm_num_planta = '';

                                                                                // INM Tipo de planta
                                                                                var c54_inm_tipo_planta = '';

                                                                                // INM Nº de plazas de garaje
                                                                                var c55_inm_plazas_garaje = '';

                                                                                // INM Trastero
                                                                                var c56_inm_trastero = '';

                                                                                if (realestates_obj[realestate.id]) {

                                                                                    if (realestates_obj[realestate.id]['country']) {
                                                                                        c22_inm_pais = realestates_obj[realestate.id]['country']['iso_3166_alpha2_code'];
                                                                                    }

                                                                                    if (realestates_obj[realestate.id]['municipality']) {
                                                                                        var cprov = realestates_obj[realestate.id]['municipality']['ine_province_code'];
                                                                                        var cmun = realestates_obj[realestate.id]['municipality']['ine_municipality_code'];
                                                                                        c23_inm_codigo_ine = cprov + cmun;

                                                                                        c24_inm_nombre_municipio = realestates_obj[realestate.id]['municipality']['name_ine'];
                                                                                    }

                                                                                    var street_name = '';
                                                                                    var street_number = '';
                                                                                    var door = '';
                                                                                    var floor = '';
                                                                                    var staircase = '';

                                                                                    if (realestates_obj[realestate.id]['street_name']) {
                                                                                        street_name = realestates_obj[realestate.id]['street_name'];
                                                                                    }

                                                                                    if (realestates_obj[realestate.id]['street_number']) {
                                                                                        street_number = realestates_obj[realestate.id]['street_number'];
                                                                                    }

                                                                                    if (realestates_obj[realestate.id]['floor']) {
                                                                                        floor = realestates_obj[realestate.id]['floor'];
                                                                                    }

                                                                                    if (realestates_obj[realestate.id]['door']) {
                                                                                        door = realestates_obj[realestate.id]['door'];
                                                                                    }

                                                                                    if (realestates_obj[realestate.id]['staircase']) {
                                                                                        staircase = realestates_obj[realestate.id]['staircase'];
                                                                                    }

                                                                                    c25_inm_direccion = street_name;

                                                                                    if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(street_number.toString()) > 0) {
                                                                                        c25_inm_direccion = c25_inm_direccion + ' nº ' + street_number.toString();
                                                                                    }

                                                                                    if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(floor) > 0) {
                                                                                        c25_inm_direccion = c25_inm_direccion + ', ' + floor;
                                                                                    }

                                                                                    if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(door) > 0) {
                                                                                        c25_inm_direccion = c25_inm_direccion + ', puerta ' + door;
                                                                                    }

                                                                                    if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(staircase) > 0) {
                                                                                        c25_inm_direccion = c25_inm_direccion + ', esc. ' + staircase;
                                                                                    }

                                                                                    if (realestates_obj[realestate.id]['postal_code']) {
                                                                                        c26_inm_codigo_postal = realestates_obj[realestate.id]['postal_code'];
                                                                                    }

                                                                                    if (realestates_obj[realestate.id]['cadastral_reference']) {
                                                                                        c27_inm_ref_catastral = realestates_obj[realestate.id]['cadastral_reference'].toUpperCase();
                                                                                    }

                                                                                    if (realestates_obj[realestate.id]['census_section_code']) {
                                                                                        c29_inm_seccion_censal = realestates_obj[realestate.id]['census_section_code'];
                                                                                    }

                                                                                    if (realestates_obj[realestate.id]['lng']) {
                                                                                        c30_inm_longitud_geolocalizacion = paddecimals_bde(realestates_obj[realestate.id]['lng'], 3, 7, '0', true);
                                                                                    }

                                                                                    if (realestates_obj[realestate.id]['lat']) {
                                                                                        c31_inm_latitud_geolocalizacion = paddecimals_bde(realestates_obj[realestate.id]['lat'], 3, 7, '0', true);
                                                                                    }

                                                                                    if (realestates_obj[realestate.id]['property_type']) {
                                                                                        property_type = realestates_obj[realestate.id]['property_type']['name_es'];
                                                                                    }

                                                                                    if (realestates_obj[realestate.id]['floor_type']) {
                                                                                        c54_inm_tipo_planta = realestates_obj[realestate.id]['floor_type']['bde_code'];
                                                                                    }
                                                                                }

                                                                                if (realestate.appraisal_id) {

                                                                                    if (appraisals_obj[realestate.id]) {

                                                                                        //console.log('wey u u:')
                                                                                        //console.log(appraisals_obj[realestate.id])

                                                                                        var appraisal_id = '';

                                                                                        // a vegades surt la id dins d'un objecte i avegades directament com a string? revisar....
                                                                                        // mentrestant....

                                                                                        if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isObject(realestate.appraisal_id)) {
                                                                                            appraisal_id = realestate.appraisal_id.id;
                                                                                        } else if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.isString(realestate.appraisal_id)) {
                                                                                            appraisal_id = realestate.appraisal_id;
                                                                                        }

                                                                                        //console.log('appraisal_id: ')
                                                                                        //console.log(appraisal_id)

                                                                                        if (appraisals_obj[realestate.id][appraisal_id]) {
                                                                                            // INM - Tipo de uso 7 X(1)
                                                                                            //console.log('whatsinthere:')
                                                                                            //console.log(appraisals_obj[realestate.id][appraisal_id])
                                                                                            if (appraisals_obj[realestate.id][appraisal_id]['usage_type']) {
                                                                                                c07_inm_tipo_uso = appraisals_obj[realestate.id][appraisal_id]['usage_type']['bde_code'];
                                                                                            }
                                                                                            //console.log('c07_inm_tipo_uso: ')
                                                                                            //console.log(c07_inm_tipo_uso)

                                                                                            if (appraisals_obj[realestate.id][appraisal_id]['occupancy_status']) {
                                                                                                c08_inm_estado_ocupacion = appraisals_obj[realestate.id][appraisal_id]['occupancy_status']['code_bde'];
                                                                                            }

                                                                                            if (appraisals_obj[realestate.id][appraisal_id]['checks_interior_visit'] === true) {
                                                                                                c09_inm_visita_interior = 'S';
                                                                                            } else {
                                                                                                c09_inm_visita_interior = 'N';
                                                                                            }

                                                                                            if (appraisals_obj[realestate.id][appraisal_id]['construction_status']) {
                                                                                                c10_inm_estado_construccion = appraisals_obj[realestate.id][appraisal_id]['construction_status']['code_bde'];
                                                                                            }

                                                                                            if (appraisals_obj[realestate.id][appraisal_id]['construction_year']) {
                                                                                                c11_inm_ano_construccion = appraisals_obj[realestate.id][appraisal_id]['construction_year'];
                                                                                            }

                                                                                            if (appraisals_obj[realestate.id][appraisal_id]['last_renovation_year']) {
                                                                                                c12_inm_ano_ultima_rehab = appraisals_obj[realestate.id][appraisal_id]['last_renovation_year'];
                                                                                            }

                                                                                            if (appraisals_obj[realestate.id][appraisal_id]['realestate_adopted_appraisal_method']) {
                                                                                                if (appraisals_obj[realestate.id][appraisal_id]['realestate_adopted_appraisal_method']['bde_code']) {
                                                                                                    c13_inm_metodo_valoracion = appraisals_obj[realestate.id][appraisal_id]['realestate_adopted_appraisal_method']['bde_code'];
                                                                                                } else if (appraisals_obj[realestate.id][appraisal_id]['realestate_adopted_appraisal_method']) {
                                                                                                    var metodo = appraisals_obj[realestate.id][appraisal_id]['realestate_adopted_appraisal_method']['name_es'];
                                                                                                    if (metodo === 'Coste de Reposición Neto (inmueble en construcción)') {
                                                                                                        c13_inm_metodo_valoracion = 'A01';
                                                                                                    } else if (metodo === 'Método Máximo Legal') {
                                                                                                        c13_inm_metodo_valoracion = 'A12';
                                                                                                    } else if (metodo === 'Método Actualización de Renta a Perpetuidad') {
                                                                                                        c13_inm_metodo_valoracion = 'A09';
                                                                                                    } else if (metodo === 'Método Actualización de Renta Esperada') {
                                                                                                        c13_inm_metodo_valoracion = 'A09';
                                                                                                    } else if (metodo === 'Método de Comparación Ajustado') {
                                                                                                        c13_inm_metodo_valoracion = 'A06';
                                                                                                    } else if (metodo === 'Método de Comparación') {
                                                                                                        c13_inm_metodo_valoracion = 'A06';
                                                                                                    }
                                                                                                }
                                                                                            }

                                                                                            if (appraisals_obj[realestate.id][appraisal_id]['realestate_total_adopted_value']) {
                                                                                                c14_inm_valor_tasacion = appraisals_obj[realestate.id][appraisal_id]['realestate_total_adopted_value'];
                                                                                            }

                                                                                            if (c10_inm_estado_construccion === 'U00') {
                                                                                                // no aplica
                                                                                                c15_inm_valor_hipotesis_edif_terminado = 0;

                                                                                                c16_inm_valor_reemplazamiento_neto = appraisals_obj[realestate.id][appraisal_id]['cost_method_realestate_crn_value'];
                                                                                            } else {
                                                                                                // revisar, quin valor agafar?
                                                                                                // 01/11/2018 -> decidit que en el cas d'estar en construcció aplica el valor de comparació
                                                                                                console.log('edifici no acabat! valor hipotesis edif terminado: ');
                                                                                                c15_inm_valor_hipotesis_edif_terminado = appraisals_obj[realestate.id][appraisal_id]['comparison_method'];

                                                                                                if (appraisals_obj[realestate.id][appraisal_id]['cost_method_unfinished_realestate_crn_value']) {

                                                                                                    c16_inm_valor_reemplazamiento_neto = appraisals_obj[realestate.id][appraisal_id]['cost_method_unfinished_realestate_crn_value'];
                                                                                                }
                                                                                            }

                                                                                            //if (c13_inm_metodo_valoracion === 'A01') {

                                                                                            if (appraisals_obj[realestate.id][appraisal_id]['update_value']) {

                                                                                                c18_inm_valor_actualizacion = appraisals_obj[realestate.id][appraisal_id]['update_value'];
                                                                                            }

                                                                                            if (appraisals_obj[realestate.id][appraisal_id]['max_legal_method']) {

                                                                                                c17_inm_valor_max_legal = appraisals_obj[realestate.id][appraisal_id]['max_legal_method'];
                                                                                            }

                                                                                            if (c13_inm_metodo_valoracion !== 'A09') {
                                                                                                //update
                                                                                                c18_inm_valor_actualizacion = 0;
                                                                                            }

                                                                                            if (appraisals_obj[realestate.id][appraisal_id]['adjusted_market_value']) {

                                                                                                c19_inm_valor_comparacion = appraisals_obj[realestate.id][appraisal_id]['comparison_method'];

                                                                                                var adjustment_coef = appraisals_obj[realestate.id][appraisal_id]['adjustment_coef'];

                                                                                                console.log('adjustment_coef: ');
                                                                                                console.log(adjustment_coef);
                                                                                                var adjustment_pct = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.round((1 - adjustment_coef) * 100);

                                                                                                console.log('adjustment_pct: ');
                                                                                                console.log(adjustment_pct);

                                                                                                //																																let adj_parts = adjustment_pct.toString().split('.')
                                                                                                //
                                                                                                //                                                                                                                                console.log('adj_parts: ')
                                                                                                //																																console.log(adj_parts)
                                                                                                //
                                                                                                //																																let enters = ''
                                                                                                //																																let decimals = ''
                                                                                                //
                                                                                                //																																if(_.isArray(adj_parts)){
                                                                                                //                                                                                                                                    if(_.size(adj_parts) > 1){
                                                                                                //                                                                                                                                        enters = adj_parts[0]
                                                                                                //                                                                                                                                        decimals = adj_parts[1]
                                                                                                //																																	}else{
                                                                                                //                                                                                                                                        enters = adj_parts[0]
                                                                                                //																																	}
                                                                                                //																																}else{
                                                                                                //																																    enters = adj_parts
                                                                                                //																																}
                                                                                                //
                                                                                                //																																console.log('enters: ')
                                                                                                //																																console.log(enters)
                                                                                                //
                                                                                                //																																console.log('decimals: ')
                                                                                                //																																console.log(decimals)
                                                                                                //
                                                                                                //																																let aj_bde = padchar(enters.toString(), 3, '0') + padchar(decimals.toString(), 2, '0')
                                                                                                //
                                                                                                //                                                                                                                                console.log('aj_bde: ')
                                                                                                //                                                                                                                                console.log(aj_bde)

                                                                                                c20_inm_ajuste_valor_comparacion = paddecimals_bde(adjustment_pct, 3, 2, '0', false);

                                                                                                if (adjustment_pct === 0) {
                                                                                                    c21_inm_valor_hipotecario = 0;
                                                                                                } else {
                                                                                                    c21_inm_valor_hipotecario = appraisals_obj[realestate.id][appraisal_id]['adjusted_market_value'];
                                                                                                }
                                                                                            }

                                                                                            if (appraisals_obj[realestate.id][appraisal_id]['registry_idufir']) {
                                                                                                c28_inm_idufir = appraisals_obj[realestate.id][appraisal_id]['registry_idufir'];
                                                                                            }

                                                                                            if (appraisals_obj[realestate.id][appraisal_id]['built_adopted_area']) {
                                                                                                c32_inm_supf_const = appraisals_obj[realestate.id][appraisal_id]['built_adopted_area'];
                                                                                            }

                                                                                            if (appraisals_obj[realestate.id][appraisal_id]['built_plus_common_elements_adopted_area']) {
                                                                                                c33_inm_supf_const_con_zc = appraisals_obj[realestate.id][appraisal_id]['built_plus_common_elements_adopted_area'];
                                                                                            }

                                                                                            if (appraisals_obj[realestate.id][appraisal_id]['net_adopted_area']) {
                                                                                                c34_inm_supf_util = appraisals_obj[realestate.id][appraisal_id]['net_adopted_area'];
                                                                                            }

                                                                                            if (appraisals_obj[realestate.id][appraisal_id]['built_cadastral_area']) {
                                                                                                c35_inm_supf_catastral = appraisals_obj[realestate.id][appraisal_id]['built_cadastral_area'];
                                                                                            }

                                                                                            if (appraisals_obj[realestate.id][appraisal_id]['adopted_area']) {
                                                                                                c36_inm_supf_adoptada = appraisals_obj[realestate.id][appraisal_id]['adopted_area'];
                                                                                            }

                                                                                            if (appraisals_obj[realestate.id][appraisal_id]['land_adopted_area']) {
                                                                                                c37_inm_supf_parcela = appraisals_obj[realestate.id][appraisal_id]['land_adopted_area'];

                                                                                                if (property_type !== 'Casa independiente' || property_type !== 'Masía' || property_type !== 'Finca rústica' || !__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(property_type, 'suelo')) {
                                                                                                    c37_inm_supf_parcela = 0;
                                                                                                }
                                                                                            }

                                                                                            if (!isNaN(c14_inm_valor_tasacion) && !isNaN(c36_inm_supf_adoptada)) {
                                                                                                c38_inm_valor_unitario = c14_inm_valor_tasacion / c36_inm_supf_adoptada;

                                                                                                if (!isNaN(c15_inm_valor_hipotesis_edif_terminado) && c10_inm_estado_construccion !== 'U00') {

                                                                                                    c38_inm_valor_unitario = c15_inm_valor_hipotesis_edif_terminado / c36_inm_supf_adoptada;
                                                                                                }
                                                                                            }

                                                                                            if (appraisals_obj[realestate.id][appraisal_id]['cc']) {
                                                                                                c39_inm_costes_construccion = appraisals_obj[realestate.id][appraisal_id]['cc'];
                                                                                            }

                                                                                            if (appraisals_obj[realestate.id][appraisal_id]['gp']) {
                                                                                                c40_inm_otros_gastos_unitarios = appraisals_obj[realestate.id][appraisal_id]['gp'];
                                                                                            }

                                                                                            if (appraisals_obj[realestate.id][appraisal_id]['bathrooms_number']) {
                                                                                                c41_inm_num_banos = appraisals_obj[realestate.id][appraisal_id]['bathrooms_number'];
                                                                                            }

                                                                                            if (appraisals_obj[realestate.id][appraisal_id]['bedrooms_number']) {
                                                                                                c42_inm_num_dormitorios = appraisals_obj[realestate.id][appraisal_id]['bedrooms_number'];
                                                                                            }

                                                                                            if (appraisals_obj[realestate.id][appraisal_id]['gardened_areas'] === true) {

                                                                                                c43_inm_zonas_verdes = 'S';
                                                                                            } else {
                                                                                                c43_inm_zonas_verdes = 'N';
                                                                                            }

                                                                                            if (appraisals_obj[realestate.id][appraisal_id]['swimming_pool'] === true) {
                                                                                                c44_inm_piscina = 'S';
                                                                                            } else {
                                                                                                c44_inm_piscina = 'N';
                                                                                            }

                                                                                            if (appraisals_obj[realestate.id][appraisal_id]['sports_facilities'] === true) {
                                                                                                c45_inm_zonas_deportivas = 'S';
                                                                                            } else {
                                                                                                c45_inm_zonas_deportivas = 'N';
                                                                                            }

                                                                                            if (appraisals_obj[realestate.id][appraisal_id]['realestate_systems_heating'] === true) {
                                                                                                c46_inm_calefaccion = 'S';
                                                                                            } else {
                                                                                                c46_inm_calefaccion = 'N';
                                                                                            }

                                                                                            if (appraisals_obj[realestate.id][appraisal_id]['realestate_systems_air_conditioning'] === true) {
                                                                                                c47_inm_aire_acondicionado = 'S';
                                                                                            } else {
                                                                                                c47_inm_aire_acondicionado = 'N';
                                                                                            }

                                                                                            if (appraisals_obj[realestate.id][appraisal_id]['quality_of_construction']) {
                                                                                                c48_inm_calidad_construccion = appraisals_obj[realestate.id][appraisal_id]['quality_of_construction']['code_bde'];
                                                                                            }

                                                                                            if (appraisals_obj[realestate.id][appraisal_id]['quality_of_construction']) {
                                                                                                c48_inm_calidad_construccion = appraisals_obj[realestate.id][appraisal_id]['quality_of_construction']['code_bde'];
                                                                                            }

                                                                                            if (appraisals_obj[realestate.id][appraisal_id]['conservation_status']) {
                                                                                                c49_estado_conservacion = appraisals_obj[realestate.id][appraisal_id]['conservation_status']['code_bde'];
                                                                                            }

                                                                                            if (appraisals_obj[realestate.id][appraisal_id]['conservation_status']) {
                                                                                                c49_estado_conservacion = appraisals_obj[realestate.id][appraisal_id]['conservation_status']['code_bde'];
                                                                                            }

                                                                                            if (appraisals_obj[realestate.id][appraisal_id]['covered_terraces_total_adopted_area']) {
                                                                                                c50_inm_m2_terraza_cubierta = appraisals_obj[realestate.id][appraisal_id]['covered_terraces_total_adopted_area'];
                                                                                            }

                                                                                            if (appraisals_obj[realestate.id][appraisal_id]['uncovered_terraces_total_adopted_area']) {
                                                                                                c51_inm_m2_terraza_descubierta = appraisals_obj[realestate.id][appraisal_id]['uncovered_terraces_total_adopted_area'];
                                                                                            }

                                                                                            if (appraisals_obj[realestate.id][appraisal_id]['lift'] === true || appraisals_obj[realestate.id][appraisal_id]['lift'] === 'on') {
                                                                                                c52_inm_ascensor = 'S';
                                                                                            } else {
                                                                                                c52_inm_ascensor = 'N';
                                                                                            }

                                                                                            if (appraisals_obj[realestate.id][appraisal_id]['floor_number']) {
                                                                                                c53_inm_num_planta = appraisals_obj[realestate.id][appraisal_id]['floor_number'];
                                                                                            } else {
                                                                                                c53_inm_num_planta = '0';
                                                                                            }

                                                                                            if (appraisals_obj[realestate.id][appraisal_id]['parking_spots_included_number']) {
                                                                                                c55_inm_plazas_garaje = appraisals_obj[realestate.id][appraisal_id]['parking_spots_included_number'];
                                                                                            }

                                                                                            if (appraisals_obj[realestate.id][appraisal_id]['storage_room'] === true) {
                                                                                                c56_inm_trastero = 'S';
                                                                                            } else {
                                                                                                c56_inm_trastero = 'N';
                                                                                            }

                                                                                            if (appraisals_obj[realestate.id][appraisal_id]['marketstudy_id']) {

                                                                                                var marketstudy_id = appraisals_obj[realestate.id][appraisal_id]['marketstudy_id'];

                                                                                                var marketstudy_comparables_obj = ad_comparables_obj[marketstudy_id];

                                                                                                var comp_count = 0;

                                                                                                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(marketstudy_comparables_obj, function (comparable, comparable_id) {

                                                                                                    comp_count = comp_count + 1;

                                                                                                    //console.log('comparable_id: ')
                                                                                                    //console.log(comparable_id)

                                                                                                    var codigoidcomparable = padchar(c03_num_tasacion + padchar(comp_count, 2, '0'), 20, '0');

                                                                                                    // comparables[reports_year][comparable_id] = {}
                                                                                                    // canviem comparable_id com a id per a codigoidcomparable ja que en estudis de mercat que repeteixen el comparable han dapareixer dues vegades!

                                                                                                    comparables[reports_year][codigoidcomparable] = {};

                                                                                                    comparables[reports_year][codigoidcomparable]['_index'] = comp_count;

                                                                                                    comparables[reports_year][codigoidcomparable]['c01_comp_cod_sociedad'] = '4470';

                                                                                                    comparables[reports_year][codigoidcomparable]['c02_comp_fecha_ref'] = reports_year.toString() + '12';

                                                                                                    comparables[reports_year][codigoidcomparable]['c03_comp_identificador'] = codigoidcomparable;

                                                                                                    relaciones[reports_year][codigoidcomparable] = {};
                                                                                                    relaciones[reports_year][codigoidcomparable]['_index'] = comp_count;

                                                                                                    relaciones[reports_year][codigoidcomparable]['c01_rel_cod_sociedad'] = '4470';
                                                                                                    relaciones[reports_year][codigoidcomparable]['c02_rel_fecha_ref'] = reports_year.toString() + '12';
                                                                                                    relaciones[reports_year][codigoidcomparable]['c03_rel_num_tasacion'] = padchar(c03_num_tasacion, 20, '0');
                                                                                                    relaciones[reports_year][codigoidcomparable]['c04_rel_num_elemento'] = padchar(num_elemento.toString(), 3, '0');
                                                                                                    //relaciones[reports_year][comparable_id]['c05_rel_codigoidcomparable'] = padchar(c03_num_tasacion + padchar(comp_count, 2, '0'), 20, '0')
                                                                                                    relaciones[reports_year][codigoidcomparable]['c05_rel_codigoidcomparable'] = codigoidcomparable;

                                                                                                    var c04_comp_fecha_captura = '';
                                                                                                    //capture_date: 2018-04-24

                                                                                                    if (comparable['capture_date']) {
                                                                                                        c04_comp_fecha_captura = comparable['capture_date'];

                                                                                                        c04_comp_fecha_captura = c04_comp_fecha_captura.replace(new RegExp('-', 'g'), '');
                                                                                                    }

                                                                                                    comparables[reports_year][codigoidcomparable]['c04_comp_fecha_captura'] = padchar(c04_comp_fecha_captura, 8, '0');

                                                                                                    var c05_comp_tipo_datos = '';

                                                                                                    if (comparable['ad_data_type']) {
                                                                                                        c05_comp_tipo_datos = comparable['ad_data_type']['bde_code'];

                                                                                                        if (comparable['ad_data_type']['name_es'] === 'Datos de oferta') {
                                                                                                            c05_comp_tipo_datos = 'A23';
                                                                                                        }
                                                                                                    }
                                                                                                    comparables[reports_year][codigoidcomparable]['c05_comp_tipo_datos'] = padchar(c05_comp_tipo_datos, 3, ' ');

                                                                                                    var c06_comp_visita_interior = 'N';
                                                                                                    //falta o posar 'N' per defecte

                                                                                                    comparables[reports_year][codigoidcomparable]['c06_comp_visita_interior'] = padchar(c06_comp_visita_interior, 1, ' ');

                                                                                                    var c07_comp_contraste_catastro = '';
                                                                                                    // cadastral_data_check: "on"

                                                                                                    if (comparable['cadastral_data_check'] === true || comparable['cadastral_data_check'] === 'on') {
                                                                                                        c07_comp_contraste_catastro = 'S';
                                                                                                    } else {
                                                                                                        c07_comp_contraste_catastro = 'N';
                                                                                                    }
                                                                                                    comparables[reports_year][codigoidcomparable]['c07_comp_contraste_catastro'] = padchar(c07_comp_contraste_catastro, 1, ' ');

                                                                                                    var c08_comp_datos_contacto = '';
                                                                                                    // contact_telephone

                                                                                                    if (comparable['contact_telephone']) {
                                                                                                        c08_comp_datos_contacto = comparable['contact_telephone'];
                                                                                                    }

                                                                                                    comparables[reports_year][codigoidcomparable]['c08_comp_datos_contacto'] = padchar(c08_comp_datos_contacto, 12, ' ');

                                                                                                    var c09_comp_pais = '';
                                                                                                    // country.iso_3166_alpha2_code

                                                                                                    if (comparable['country']) {
                                                                                                        c09_comp_pais = comparable['country']['iso_3166_alpha2_code'];
                                                                                                    }

                                                                                                    comparables[reports_year][codigoidcomparable]['c09_comp_pais'] = padchar(c09_comp_pais, 2, ' ');

                                                                                                    var c10_comp_codigo_ine = '';
                                                                                                    // municipality.ine_province_code + municipality.ine_municipality_code

                                                                                                    if (comparable['municipality']) {
                                                                                                        c10_comp_codigo_ine = comparable['municipality']['ine_province_code'] + comparable['municipality']['ine_municipality_code'];
                                                                                                    }

                                                                                                    comparables[reports_year][codigoidcomparable]['c10_comp_codigo_ine'] = padchar(c10_comp_codigo_ine, 5, ' ');

                                                                                                    var c11_comp_municipio = '';
                                                                                                    // municipality.name_ine

                                                                                                    if (comparable['municipality']) {
                                                                                                        c11_comp_municipio = comparable['municipality']['name_ine'];
                                                                                                    }

                                                                                                    comparables[reports_year][codigoidcomparable]['c11_comp_municipio'] = padchar(c11_comp_municipio, 50, ' ');

                                                                                                    var c12_comp_direccion = '';
                                                                                                    // ad_address

                                                                                                    var street_name = '';
                                                                                                    var street_number = '';
                                                                                                    var door = '';
                                                                                                    var floor = '';
                                                                                                    var staircase = '';

                                                                                                    if (comparable['street_name']) {
                                                                                                        street_name = comparable['street_name'];
                                                                                                    }

                                                                                                    if (comparable['street_number']) {
                                                                                                        street_number = comparable['street_number'];
                                                                                                    }

                                                                                                    if (comparable['floor']) {
                                                                                                        floor = comparable['floor'];
                                                                                                    }

                                                                                                    if (comparable['door']) {
                                                                                                        door = comparable['door'];
                                                                                                    }

                                                                                                    if (comparable['staircase']) {
                                                                                                        staircase = comparable['staircase'];
                                                                                                    }

                                                                                                    c12_comp_direccion = street_name;

                                                                                                    if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(street_number.toString()) > 0) {
                                                                                                        c12_comp_direccion = c12_comp_direccion + ' nº ' + street_number.toString();
                                                                                                    }

                                                                                                    if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(floor) > 0) {
                                                                                                        c12_comp_direccion = c12_comp_direccion + ', ' + floor;
                                                                                                    }

                                                                                                    if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(door) > 0) {
                                                                                                        c12_comp_direccion = c12_comp_direccion + ', puerta ' + door;
                                                                                                    }

                                                                                                    if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(staircase) > 0) {
                                                                                                        c12_comp_direccion = c12_comp_direccion + ', esc. ' + staircase;
                                                                                                    }

                                                                                                    comparables[reports_year][codigoidcomparable]['c12_comp_direccion'] = padchar(c12_comp_direccion, 60, ' ');

                                                                                                    var c13_comp_codigo_postal = '';
                                                                                                    // postal_code

                                                                                                    if (comparable['postal_code']) {
                                                                                                        c13_comp_codigo_postal = comparable['postal_code'];
                                                                                                    }

                                                                                                    comparables[reports_year][codigoidcomparable]['c13_comp_codigo_postal'] = padchar(c13_comp_codigo_postal, 5, ' ');

                                                                                                    var c14_comp_ref_catastral = '';
                                                                                                    // cadastral_reference

                                                                                                    if (comparable['cadastral_reference']) {
                                                                                                        c14_comp_ref_catastral = comparable['cadastral_reference'];
                                                                                                    }

                                                                                                    comparables[reports_year][codigoidcomparable]['c14_comp_ref_catastral'] = padchar(c14_comp_ref_catastral, 20, ' ');

                                                                                                    var c15_comp_idufir = '';
                                                                                                    // idufir

                                                                                                    if (comparable['idufir']) {
                                                                                                        c15_comp_idufir = comparable['idufir'];
                                                                                                    }

                                                                                                    comparables[reports_year][codigoidcomparable]['c15_comp_idufir'] = padchar(c15_comp_idufir, 14, ' ');

                                                                                                    var c16_comp_seccion_censal = '';
                                                                                                    // census_section_code

                                                                                                    if (comparable['census_section_code']) {
                                                                                                        c16_comp_seccion_censal = comparable['census_section_code'];
                                                                                                    }

                                                                                                    comparables[reports_year][codigoidcomparable]['c16_comp_seccion_censal'] = padchar(c16_comp_seccion_censal, 11, ' ');

                                                                                                    var c17_comp_longitud = '';
                                                                                                    // lng
                                                                                                    if (comparable['lng']) {
                                                                                                        c17_comp_longitud = comparable['lng'];
                                                                                                    }

                                                                                                    comparables[reports_year][codigoidcomparable]['c17_comp_longitud'] = paddecimals_bde(c17_comp_longitud, 3, 7, '0', true);

                                                                                                    var c18_comp_latitud = '';
                                                                                                    // lat

                                                                                                    if (comparable['lat']) {
                                                                                                        c18_comp_latitud = comparable['lat'];
                                                                                                    }

                                                                                                    comparables[reports_year][codigoidcomparable]['c18_comp_latitud'] = paddecimals_bde(c18_comp_latitud, 3, 7, '0', true);

                                                                                                    var c19_comp_precio_oferta = 0;
                                                                                                    // offer_price

                                                                                                    if (comparable['offer_price']) {
                                                                                                        c19_comp_precio_oferta = comparable['offer_price'];
                                                                                                    }

                                                                                                    comparables[reports_year][codigoidcomparable]['c19_comp_precio_oferta'] = padchar(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.round(c19_comp_precio_oferta).toString(), 12, '0');

                                                                                                    var c20_comp_precio_venta = 0;
                                                                                                    // estimated_sale_price

                                                                                                    if (comparable['estimated_sale_price']) {
                                                                                                        c20_comp_precio_venta = comparable['estimated_sale_price'];
                                                                                                    }

                                                                                                    comparables[reports_year][codigoidcomparable]['c20_comp_precio_venta'] = padchar(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.round(c20_comp_precio_venta).toString(), 12, '0');

                                                                                                    var c21_comp_supf_catastral = 0;
                                                                                                    // cadastral_area

                                                                                                    if (comparable['cadastral_area']) {
                                                                                                        c21_comp_supf_catastral = comparable['cadastral_area'];
                                                                                                    }

                                                                                                    comparables[reports_year][codigoidcomparable]['c21_comp_supf_catastral'] = padchar(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.round(c21_comp_supf_catastral).toString(), 6, '0');

                                                                                                    var c22_comp_supf_estimada = 0;
                                                                                                    // adopted_area

                                                                                                    if (comparable['adopted_area']) {
                                                                                                        c22_comp_supf_estimada = comparable['adopted_area'];
                                                                                                    }

                                                                                                    comparables[reports_year][codigoidcomparable]['c22_comp_supf_estimada'] = padchar(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.round(c22_comp_supf_estimada).toString(), 6, '0');

                                                                                                    var c23_comp_supf_parcela = 0;
                                                                                                    // ? revisar

                                                                                                    comparables[reports_year][codigoidcomparable]['c23_comp_supf_parcela'] = padchar(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.round(c23_comp_supf_parcela).toString(), 6, '0');

                                                                                                    var c24_comp_precio_unitario = 0;
                                                                                                    // estimated_unit_sale_price

                                                                                                    if (comparable['estimated_unit_sale_price']) {
                                                                                                        c24_comp_precio_unitario = comparable['estimated_unit_sale_price'];
                                                                                                    }

                                                                                                    comparables[reports_year][codigoidcomparable]['c24_comp_precio_unitario'] = padchar(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.round(c24_comp_precio_unitario).toString(), 12, '0');

                                                                                                    var c25_comp_ano_construccion = 0;
                                                                                                    // construction_year

                                                                                                    if (comparable['construction_year']) {
                                                                                                        c25_comp_ano_construccion = comparable['construction_year'];
                                                                                                    }

                                                                                                    comparables[reports_year][codigoidcomparable]['c25_comp_ano_construccion'] = padchar(c25_comp_ano_construccion, 4, '0');

                                                                                                    var c26_comp_ano_ultima_rehab = '';
                                                                                                    // last_renovation_year

                                                                                                    if (comparable['last_renovation_year']) {
                                                                                                        c26_comp_ano_ultima_rehab = comparable['last_renovation_year'];
                                                                                                    }

                                                                                                    comparables[reports_year][codigoidcomparable]['c26_comp_ano_ultima_rehab'] = padchar(c26_comp_ano_ultima_rehab, 4, '0');

                                                                                                    var c27_comp_tipo_vivienda = '';
                                                                                                    // dwelling_type.bde_code

                                                                                                    if (comparable['dwelling_type']) {
                                                                                                        c27_comp_tipo_vivienda = comparable['dwelling_type']['bde_code'];
                                                                                                    }

                                                                                                    comparables[reports_year][codigoidcomparable]['c27_comp_tipo_vivienda'] = padchar(c27_comp_tipo_vivienda, 1, '0');

                                                                                                    var c28_comp_num_banos = '';
                                                                                                    // bathrooms_number

                                                                                                    if (comparable['bathrooms_number']) {
                                                                                                        c28_comp_num_banos = comparable['bathrooms_number'];
                                                                                                    }

                                                                                                    comparables[reports_year][codigoidcomparable]['c28_comp_num_banos'] = padchar(c28_comp_num_banos, 4, '0');

                                                                                                    var c29_comp_num_dormitorios = '';
                                                                                                    // bedrooms_number

                                                                                                    if (comparable['bedrooms_number']) {
                                                                                                        c29_comp_num_dormitorios = comparable['bedrooms_number'];
                                                                                                    }

                                                                                                    comparables[reports_year][codigoidcomparable]['c29_comp_num_dormitorios'] = padchar(c29_comp_num_dormitorios, 4, '0');

                                                                                                    var c30_comp_zonas_verdes = '';
                                                                                                    // green_areas (true or false)

                                                                                                    if (comparable['green_areas'] === true || comparable['green_areas'] === 'on') {
                                                                                                        c30_comp_zonas_verdes = 'S';
                                                                                                    } else {
                                                                                                        c30_comp_zonas_verdes = 'N';
                                                                                                    }

                                                                                                    comparables[reports_year][codigoidcomparable]['c30_comp_zonas_verdes'] = padchar(c30_comp_zonas_verdes, 1, ' ');

                                                                                                    var c31_comp_piscina = '';
                                                                                                    // swimming_pool

                                                                                                    if (comparable['green_areas'] === true || comparable['green_areas'] === 'on') {
                                                                                                        c31_comp_piscina = 'S';
                                                                                                    } else {
                                                                                                        c31_comp_piscina = 'N';
                                                                                                    }

                                                                                                    comparables[reports_year][codigoidcomparable]['c31_comp_piscina'] = padchar(c31_comp_piscina, 1, ' ');

                                                                                                    var c32_comp_zonas_deportivas = 'N';
                                                                                                    // ? revisar

                                                                                                    comparables[reports_year][codigoidcomparable]['c32_comp_zonas_deportivas'] = padchar(c32_comp_zonas_deportivas, 1, ' ');

                                                                                                    var c33_comp_calefaccion = '';
                                                                                                    // heating

                                                                                                    if (comparable['heating'] === true || comparable['heating'] === 'on') {
                                                                                                        c33_comp_calefaccion = 'S';
                                                                                                    } else {
                                                                                                        c33_comp_calefaccion = 'N';
                                                                                                    }

                                                                                                    comparables[reports_year][codigoidcomparable]['c33_comp_calefaccion'] = padchar(c33_comp_calefaccion, 1, ' ');

                                                                                                    var c34_comp_aire_acondicionado = '';
                                                                                                    // air_conditioning

                                                                                                    if (comparable['air_conditioning'] === true || comparable['air_conditioning'] === 'on') {
                                                                                                        c34_comp_aire_acondicionado = 'S';
                                                                                                    } else {
                                                                                                        c34_comp_aire_acondicionado = 'N';
                                                                                                    }

                                                                                                    comparables[reports_year][codigoidcomparable]['c34_comp_aire_acondicionado'] = padchar(c34_comp_aire_acondicionado, 1, ' ');

                                                                                                    var c35_comp_calidad_construccion = '';
                                                                                                    // quality_of_construction.code_bde

                                                                                                    if (comparable['quality_of_construction']) {
                                                                                                        c35_comp_calidad_construccion = comparable['quality_of_construction']['code_bde'];
                                                                                                    }
                                                                                                    comparables[reports_year][codigoidcomparable]['c35_comp_calidad_construccion'] = padchar(c35_comp_calidad_construccion, 1, '0');

                                                                                                    var c36_comp_estado_conservacion = '';
                                                                                                    // conservation_status.code_bde

                                                                                                    if (comparable['conservation_status']) {
                                                                                                        c36_comp_estado_conservacion = comparable['conservation_status']['code_bde'];
                                                                                                    }
                                                                                                    comparables[reports_year][codigoidcomparable]['c36_comp_estado_conservacion'] = padchar(c36_comp_estado_conservacion, 1, '0');

                                                                                                    var c37_comp_m2_terraza_cubierta = '';
                                                                                                    // covered_outdoor_area

                                                                                                    if (comparable['covered_outdoor_area']) {
                                                                                                        c37_comp_m2_terraza_cubierta = comparable['covered_outdoor_area'];
                                                                                                    }
                                                                                                    comparables[reports_year][codigoidcomparable]['c37_comp_m2_terraza_cubierta'] = padchar(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.round(c37_comp_m2_terraza_cubierta).toString(), 6, '0');

                                                                                                    var c38_comp_m2_terraza_descubierta = '';
                                                                                                    // uncovered_outdoor_area

                                                                                                    if (comparable['uncovered_outdoor_area']) {
                                                                                                        c38_comp_m2_terraza_descubierta = comparable['uncovered_outdoor_area'];
                                                                                                    }
                                                                                                    comparables[reports_year][codigoidcomparable]['c38_comp_m2_terraza_descubierta'] = padchar(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.round(c38_comp_m2_terraza_descubierta).toString(), 6, '0');

                                                                                                    var c39_comp_ascensor = '';
                                                                                                    // lift (true)

                                                                                                    if (comparable['lift'] === true || comparable['lift'] === 'on') {
                                                                                                        c39_comp_ascensor = 'S';
                                                                                                    } else {
                                                                                                        c39_comp_ascensor = 'N';
                                                                                                    }

                                                                                                    comparables[reports_year][codigoidcomparable]['c39_comp_ascensor'] = padchar(c39_comp_ascensor, 1, ' ');

                                                                                                    var c40_comp_num_planta = '';
                                                                                                    // floor_number

                                                                                                    if (comparable['floor_number']) {
                                                                                                        c40_comp_num_planta = comparable['floor_number'];
                                                                                                    } else {
                                                                                                        c40_comp_num_planta = 0;
                                                                                                    }

                                                                                                    comparables[reports_year][codigoidcomparable]['c40_comp_num_planta'] = paddecimals_bde(c40_comp_num_planta, 3, 0, '0', true);

                                                                                                    var c41_comp_tipo_planta = '';
                                                                                                    // floor_type.bde_code

                                                                                                    if (comparable['floor_type']) {
                                                                                                        c41_comp_tipo_planta = comparable['floor_type']['bde_code'];
                                                                                                    }
                                                                                                    comparables[reports_year][codigoidcomparable]['c41_comp_tipo_planta'] = padchar(c41_comp_tipo_planta, 2, ' ');

                                                                                                    var c42_comp_num_plazas_garaje = 0;
                                                                                                    // revisar

                                                                                                    comparables[reports_year][codigoidcomparable]['c42_comp_num_plazas_garaje'] = padchar(c42_comp_num_plazas_garaje.toString(), 4, '0');

                                                                                                    var c43_comp_trastero = 'N';
                                                                                                    // revisar

                                                                                                    comparables[reports_year][codigoidcomparable]['c43_comp_trastero'] = padchar(c43_comp_trastero, 1, ' ');
                                                                                                });
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }

                                                                                // Tipo Uso
                                                                                inmuebles[reports_year][realestate.id]['c07_inm_tipo_uso'] = padchar(c07_inm_tipo_uso.toString(), 1, ' ');

                                                                                // Estado Ocupación
                                                                                inmuebles[reports_year][realestate.id]['c08_inm_estado_ocupacion'] = padchar(c08_inm_estado_ocupacion.toString(), 1, ' ');

                                                                                // Indicador visita interior
                                                                                inmuebles[reports_year][realestate.id]['c09_inm_visita_interior'] = padchar(c09_inm_visita_interior.toString(), 1, ' ');

                                                                                // Estado Construcción
                                                                                inmuebles[reports_year][realestate.id]['c10_inm_estado_construccion'] = padchar(c10_inm_estado_construccion.toString(), 3, ' ');

                                                                                // Año Construcción
                                                                                inmuebles[reports_year][realestate.id]['c11_inm_ano_construccion'] = padchar(c11_inm_ano_construccion.toString(), 4, '0');

                                                                                // Año Última Rehabilitación
                                                                                inmuebles[reports_year][realestate.id]['c12_inm_ano_ultima_rehab'] = padchar(c12_inm_ano_ultima_rehab.toString(), 4, '0');

                                                                                // Método Valoración
                                                                                inmuebles[reports_year][realestate.id]['c13_inm_metodo_valoracion'] = padchar(c13_inm_metodo_valoracion.toString(), 3, ' ');

                                                                                // Valor tasación del inmueble
                                                                                inmuebles[reports_year][realestate.id]['c14_inm_valor_tasacion'] = padchar(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.round(c14_inm_valor_tasacion).toString(), 12, '0');

                                                                                // Valor tasación del inmueble en hipótesis de edificio terminado
                                                                                inmuebles[reports_year][realestate.id]['c15_inm_valor_hipotesis_edif_terminado'] = padchar(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.round(c15_inm_valor_hipotesis_edif_terminado).toString(), 12, '0');

                                                                                // Valor de reemplazamiento neto
                                                                                inmuebles[reports_year][realestate.id]['c16_inm_valor_reemplazamiento_neto'] = padchar(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.round(c16_inm_valor_reemplazamiento_neto).toString(), 12, '0');

                                                                                // Valor máximo legal
                                                                                inmuebles[reports_year][realestate.id]['c17_inm_valor_max_legal'] = padchar(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.round(c17_inm_valor_max_legal).toString(), 12, '0');

                                                                                // Valor actualización
                                                                                inmuebles[reports_year][realestate.id]['c18_inm_valor_actualizacion'] = padchar(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.round(c18_inm_valor_actualizacion).toString(), 12, '0');

                                                                                // Valor por comparación
                                                                                inmuebles[reports_year][realestate.id]['c19_inm_valor_comparacion'] = padchar(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.round(c19_inm_valor_comparacion).toString(), 12, '0');

                                                                                // Ajuste al valor por comparación
                                                                                inmuebles[reports_year][realestate.id]['c20_inm_ajuste_valor_comparacion'] = padchar(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.round(c20_inm_ajuste_valor_comparacion).toString(), 5, '0');

                                                                                // Valor hipotecario
                                                                                inmuebles[reports_year][realestate.id]['c21_inm_valor_hipotecario'] = padchar(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.round(c21_inm_valor_hipotecario).toString(), 12, '0');

                                                                                // Pais
                                                                                inmuebles[reports_year][realestate.id]['c22_inm_pais'] = padchar(c22_inm_pais.toString(), 2, ' ');

                                                                                // Código INE
                                                                                inmuebles[reports_year][realestate.id]['c23_inm_codigo_ine'] = padchar(c23_inm_codigo_ine.toString(), 5, ' ');

                                                                                // Nombre Municipio
                                                                                inmuebles[reports_year][realestate.id]['c24_inm_nombre_municipio'] = padchar(c24_inm_nombre_municipio.toString(), 50, ' ');

                                                                                // Dirección
                                                                                inmuebles[reports_year][realestate.id]['c25_inm_direccion'] = padchar(c25_inm_direccion.toString(), 60, ' ');

                                                                                // Código Postal
                                                                                inmuebles[reports_year][realestate.id]['c26_inm_codigo_postal'] = padchar(c26_inm_codigo_postal.toString(), 5, ' ');

                                                                                // Referencia Catastral
                                                                                inmuebles[reports_year][realestate.id]['c27_inm_ref_catastral'] = padchar(c27_inm_ref_catastral.toString(), 20, ' ');

                                                                                // IDUFIR
                                                                                inmuebles[reports_year][realestate.id]['c28_inm_idufir'] = padchar(c28_inm_idufir.toString(), 14, ' ');

                                                                                // Código Sección Censal
                                                                                inmuebles[reports_year][realestate.id]['c29_inm_seccion_censal'] = padchar(c29_inm_seccion_censal.toString(), 11, ' ');

                                                                                // Longitud geolocalización
                                                                                inmuebles[reports_year][realestate.id]['c30_inm_longitud_geolocalizacion'] = padchar(c30_inm_longitud_geolocalizacion.toString(), 11, ' ');

                                                                                // Latitud geolocalización
                                                                                inmuebles[reports_year][realestate.id]['c31_inm_latitud_geolocalizacion'] = padchar(c31_inm_latitud_geolocalizacion.toString(), 11, ' ');

                                                                                // Superfície construida
                                                                                inmuebles[reports_year][realestate.id]['c32_inm_supf_const'] = padchar(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.round(c32_inm_supf_const).toString(), 6, '0');

                                                                                // Superficie Construida con zonas comunes
                                                                                inmuebles[reports_year][realestate.id]['c33_inm_supf_const_con_zc'] = padchar(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.round(c33_inm_supf_const_con_zc).toString(), 6, '0');

                                                                                // Superficie Útil
                                                                                inmuebles[reports_year][realestate.id]['c34_inm_supf_util'] = padchar(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.round(c34_inm_supf_util).toString(), 6, '0');

                                                                                // Superficie Catastral
                                                                                inmuebles[reports_year][realestate.id]['c35_inm_supf_catastral'] = padchar(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.round(c35_inm_supf_catastral).toString(), 6, '0');

                                                                                // Superficie Adoptada
                                                                                inmuebles[reports_year][realestate.id]['c36_inm_supf_adoptada'] = padchar(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.round(c36_inm_supf_adoptada).toString(), 6, '0');

                                                                                // Superficie Parcela
                                                                                inmuebles[reports_year][realestate.id]['c37_inm_supf_parcela'] = padchar(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.round(c37_inm_supf_parcela).toString(), 6, '0');

                                                                                // Valor Unitario
                                                                                inmuebles[reports_year][realestate.id]['c38_inm_valor_unitario'] = padchar(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.round(c38_inm_valor_unitario).toString(), 12, '0');

                                                                                // Costes de construcción estimados
                                                                                inmuebles[reports_year][realestate.id]['c39_inm_costes_construccion'] = padchar(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.round(c39_inm_costes_construccion).toString(), 12, '0');

                                                                                // Otros gastos necesarios unitarios
                                                                                inmuebles[reports_year][realestate.id]['c40_inm_otros_gastos_unitarios'] = padchar(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.round(c40_inm_otros_gastos_unitarios).toString(), 12, '0');

                                                                                // Nº de baños
                                                                                inmuebles[reports_year][realestate.id]['c41_inm_num_banos'] = padchar(c41_inm_num_banos.toString(), 4, '0');

                                                                                // Nº de dormitorios
                                                                                inmuebles[reports_year][realestate.id]['c42_inm_num_dormitorios'] = padchar(c42_inm_num_dormitorios.toString(), 4, '0');

                                                                                // Zonas Verdes
                                                                                inmuebles[reports_year][realestate.id]['c43_inm_zonas_verdes'] = padchar(c43_inm_zonas_verdes.toString(), 1, ' ');

                                                                                // Piscina
                                                                                inmuebles[reports_year][realestate.id]['c44_inm_piscina'] = padchar(c44_inm_piscina.toString(), 1, ' ');

                                                                                // Zonas Deportivas
                                                                                inmuebles[reports_year][realestate.id]['c45_inm_zonas_deportivas'] = padchar(c45_inm_zonas_deportivas.toString(), 1, ' ');

                                                                                // Calefacción
                                                                                inmuebles[reports_year][realestate.id]['c46_inm_calefaccion'] = padchar(c46_inm_calefaccion.toString(), 1, ' ');

                                                                                // Aire Acondicionado
                                                                                inmuebles[reports_year][realestate.id]['c47_inm_aire_acondicionado'] = padchar(c47_inm_aire_acondicionado.toString(), 1, ' ');

                                                                                // Calidad Construcción
                                                                                inmuebles[reports_year][realestate.id]['c48_inm_calidad_construccion'] = padchar(c48_inm_calidad_construccion.toString(), 1, '0');

                                                                                // Estado Conservación
                                                                                inmuebles[reports_year][realestate.id]['c49_estado_conservacion'] = padchar(c49_estado_conservacion.toString(), 1, '0');

                                                                                // Metros terraza cubierta
                                                                                inmuebles[reports_year][realestate.id]['c50_inm_m2_terraza_cubierta'] = padchar(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.round(c50_inm_m2_terraza_cubierta).toString(), 6, '0');

                                                                                // Metros terraza descubierta
                                                                                inmuebles[reports_year][realestate.id]['c51_inm_m2_terraza_descubierta'] = padchar(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.round(c51_inm_m2_terraza_descubierta).toString(), 6, '0');

                                                                                //Ascensor
                                                                                inmuebles[reports_year][realestate.id]['c52_inm_ascensor'] = padchar(c52_inm_ascensor.toString(), 1, ' ');

                                                                                //Nº planta
                                                                                inmuebles[reports_year][realestate.id]['c53_inm_num_planta'] = paddecimals_bde(c53_inm_num_planta, 3, 0, '0', true);

                                                                                //Tipo de planta
                                                                                inmuebles[reports_year][realestate.id]['c54_inm_tipo_planta'] = padchar(c54_inm_tipo_planta.toString(), 2, ' ');

                                                                                //Nº plazas garaje
                                                                                inmuebles[reports_year][realestate.id]['c55_inm_plazas_garaje'] = padchar(c55_inm_plazas_garaje.toString(), 4, '0');

                                                                                //Trastero
                                                                                inmuebles[reports_year][realestate.id]['c56_inm_trastero'] = padchar(c56_inm_trastero.toString(), 1, ' ');
                                                                            }
                                                                        }
                                                                    }
                                                                });

                                                                //console.log('c09_hay_advertencias: ')
                                                                //console.log(c09_hay_advertencias)

                                                                //console.log('c10_hay_condicionantes: ')
                                                                //console.log(c10_hay_condicionantes)

                                                                tasaciones[reports_year][tas_count_str]['c09_hay_advertencias'] = padchar(c09_hay_advertencias, positions, char);
                                                                tasaciones[reports_year][tas_count_str]['c10_hay_condicionantes'] = padchar(c10_hay_condicionantes, positions, char);

                                                                // Valor de tasación 11 9(12) >= 0
                                                                var c11_valor_tasacion = '';
                                                                positions = 12;
                                                                char = '0';

                                                                //inm_count = 0

                                                                // hem de sumar els valors dels immobles que siguin habitatge de l'informe
                                                                var valores = [];

                                                                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(report_realestates_arr, function (realestate) {

                                                                    // només incorporem a la fitxa els immobles que són habitatges o edificis
                                                                    // canviar la comprovació millor pel camp 5 V94 tipo de vivienda o tipo de activo, un cop estigui omplert a totes les taxacions
                                                                    //if (realestate.property_type) {

                                                                    //if (realestate.property_type.usage_type_en === 'Dwelling') {

                                                                    //console.log('veiem, realestate: ')
                                                                    //console.log(realestate)

                                                                    if (realestates_obj[realestate.id]) {

                                                                        if (realestates_obj[realestate.id]['dwelling_type']) {

                                                                            if (realestates_obj[realestate.id]['dwelling_type']['bde_code'] === 1 || realestates_obj[realestate.id]['dwelling_type']['bde_code'] === 2 || realestates_obj[realestate.id]['dwelling_type']['bde_code'] === 3) {

                                                                                //inm_count = inm_count + 1
                                                                                //let inm_count_str = inm_count.toString()

                                                                                console.log('realestate in: ' + realestate.full_address); //

                                                                                if (realestate.appraisal_id) {
                                                                                    if (appraisals_obj[realestate.id]) {

                                                                                        console.log('the appraisal: ');

                                                                                        console.log(appraisals_obj[realestate.id]);

                                                                                        if (appraisals_obj[realestate.id][realestate.appraisal_id.id]) {

                                                                                            if (appraisals_obj[realestate.id][realestate.appraisal_id.id]['realestate_total_adopted_value']) {

                                                                                                var valor = appraisals_obj[realestate.id][realestate.appraisal_id.id]['realestate_total_adopted_value'];

                                                                                                valores.push(valor);
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                });

                                                                c11_valor_tasacion = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sum(valores);

                                                                if (c11_valor_tasacion === '') {
                                                                    tasaciones_errors[reports_year][tas_count_str]['c11_valor_tasacion'] = 'Manca el valor de taxació o és incorrecte';
                                                                } else if (isNaN(c11_valor_tasacion)) {
                                                                    tasaciones_errors[reports_year][tas_count_str]['c11_valor_tasacion'] = 'Manca el valor de taxació o és incorrecte';
                                                                } else {
                                                                    // arrodonim per treure els decimals...
                                                                    c11_valor_tasacion = Math.round(c11_valor_tasacion);
                                                                }
                                                                tasaciones[reports_year][tas_count_str]['c11_valor_tasacion'] = padchar(c11_valor_tasacion, positions, char);

                                                                // Importe facturado por la tasación 12 9(12) >= 0
                                                                var c12_importe_facturado = '';
                                                                positions = 12;
                                                                char = '0';

                                                                // let a = appraisalfiles_obj[]

                                                                var importes = [];
                                                                var importe = 0;

                                                                //inm_count = 0

                                                                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(report_realestates_arr, function (realestate) {

                                                                    // només incorporem a la fitxa els immobles que són habitatges o edificis
                                                                    if (realestates_obj[realestate.id]) {

                                                                        if (realestates_obj[realestate.id]['dwelling_type']) {

                                                                            if (realestates_obj[realestate.id]['dwelling_type']['bde_code'] === 1 || realestates_obj[realestate.id]['dwelling_type']['bde_code'] === 2 || realestates_obj[realestate.id]['dwelling_type']['bde_code'] === 3) {

                                                                                //inm_count = inm_count + 1
                                                                                //let inm_count_str = inm_count.toString()

                                                                                //console.log('realestate in (for importe_facturado): ' + realestate.full_address)

                                                                                // console.log('realestate (for_importe_facturado): ')
                                                                                //console.log(realestate)

                                                                                if (realestates_obj[realestate.id]) {

                                                                                    __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(realestates_obj[realestate.id], function (value, key) {

                                                                                        //console.log('the realestate key: ' + key + ' is ' + value)

                                                                                        // INM - Tipo de activo 5 X(3)
                                                                                        var c05_inm_tipo_activo = '';
                                                                                        if (key === 'asset_type') {
                                                                                            console.log('eureka!');
                                                                                            console.log('key: ');
                                                                                            console.log(key);
                                                                                            console.log('value: ');
                                                                                            console.log(value);
                                                                                            c05_inm_tipo_activo = value.bde_code.toString();
                                                                                            inmuebles[reports_year][realestate.id]['c05_inm_tipo_activo'] = padchar(c05_inm_tipo_activo.toString(), 3, 'x');
                                                                                        }

                                                                                        // INM - Tipo de vivienda 6 9(1)
                                                                                        var c06_inm_tipo_vivienda = '';

                                                                                        console.log('ici2');
                                                                                        console.log('key: ');
                                                                                        console.log(key);
                                                                                        console.log('value: ');
                                                                                        console.log(value);

                                                                                        if (key === 'dwelling_type') {

                                                                                            c06_inm_tipo_vivienda = value.bde_code.toString();
                                                                                            console.log('c06_inm_tipo_vivienda: ');
                                                                                            console.log(c06_inm_tipo_vivienda);

                                                                                            inmuebles[reports_year][realestate.id]['c06_inm_tipo_vivienda'] = padchar(c06_inm_tipo_vivienda.toString(), 1, 'x');
                                                                                        }
                                                                                    });

                                                                                    __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(realestates_obj[realestate.id]['appraisalfiles'], function (value, key) {

                                                                                        //console.log('appraisalfile key:')
                                                                                        //console.log(key)

                                                                                        /*if (appraisalfiles_obj[key]) {
                                                                                        if (appraisalfiles_obj[key]['appraisalinvoices']) {
                                                                                        _.forEach(appraisalfiles_obj[key]['appraisalinvoices'], function (value2, key2) {
                                                                                         if (appraisalinvoices_obj[key2]) {
                                                                                            if (appraisalinvoices_obj[key2]['lines']) {
                                                                                                 _.forEach(appraisalinvoices_obj[key2]['lines'], function (value3, key3) {
                                                                                                     //console.log('invoice line appraisal_id: ')
                                                                                                    //console.log(value3['appraisal_id'])
                                                                                                     console.log('realestate appraisal_id: ')
                                                                                                    if (realestate.appraisal_id) {
                                                                                                        console.log(realestate.appraisal_id.id)
                                                                                                        if (value3['appraisal_id'] === realestate.appraisal_id.id) {
                                                                                                             //console.log('found! line unit_price:')
                                                                                                            //console.log(value3['unit_price'])
                                                                                                             // todo: check if discount in invoice!
                                                                                                            importes.push(value3['unit_price'])
                                                                                                         }
                                                                                                    }
                                                                                                 })
                                                                                             }
                                                                                         }
                                                                                        })
                                                                                        }
                                                                                        }
                                                                                        */

                                                                                        if (appraisalfiles_obj[key]) {

                                                                                            if (appraisalfiles_obj[key]['appraisalquotes']) {

                                                                                                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(appraisalfiles_obj[key]['appraisalquotes'], function (value2, key2) {

                                                                                                    if (appraisalquotes_obj[key2]) {
                                                                                                        if (appraisalquotes_obj[key2]['final_price']) {

                                                                                                            importe = appraisalquotes_obj[key2]['final_price'];

                                                                                                            //console.log('final_price! : ')
                                                                                                            // console.log(importe)

                                                                                                            var anyfound = false;
                                                                                                            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(appraisalquotes_obj[key2]['realestates'], function (value3, key3) {

                                                                                                                //console.log('invoice line appraisal_id: ')
                                                                                                                //console.log(value3['appraisal_id'])

                                                                                                                console.log('realestate appraisal_id: ');

                                                                                                                if (realestate.appraisal_id) {
                                                                                                                    console.log(realestate.appraisal_id.id);
                                                                                                                    if (value3['appraisal_id'] === realestate.appraisal_id.id) {

                                                                                                                        anyfound = true;

                                                                                                                        //console.log('found! line unit_price:')
                                                                                                                        //console.log(value3['unit_price'])

                                                                                                                        // todo: check if discount in invoice!
                                                                                                                        importes.push(value3['quote_price_incl_travel_expenses']);
                                                                                                                    }
                                                                                                                }
                                                                                                            });

                                                                                                            console.log('any found???  --> ' + anyfound);
                                                                                                        }
                                                                                                    }
                                                                                                });
                                                                                            }
                                                                                        }
                                                                                    });
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                });

                                                                c12_importe_facturado = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sum(importes);

                                                                //c12_importe_facturado = importe

                                                                tasaciones[reports_year][tas_count_str]['c12_importe_facturado'] = padchar(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.round(c12_importe_facturado), positions, char);

                                                                // NIF/CIF del mandatario 13 X(11) NIF/CIF
                                                                var c13_nif_mandatario = '';
                                                                positions = 11;
                                                                char = ' ';

                                                                if (appraisalreport_obj['entity']) {
                                                                    c13_nif_mandatario = appraisalreport_obj['entity']['tin'];
                                                                }
                                                                tasaciones[reports_year][tas_count_str]['c13_nif_mandatario'] = padchar(c13_nif_mandatario, positions, char);

                                                                // Nombre del mandatario 14 X(60)
                                                                var c14_nombre_mandatario = '';
                                                                positions = 60;
                                                                char = ' ';

                                                                if (appraisalreport_obj['entity']) {
                                                                    c14_nombre_mandatario = appraisalreport_obj['entity']['name'];
                                                                }
                                                                tasaciones[reports_year][tas_count_str]['c14_nombre_mandatario'] = padchar(c14_nombre_mandatario, positions, char);

                                                                // Código Banco de España del mandatario 15 X(4) Código BE
                                                                var c15_codigo_mandatario = '';
                                                                positions = 4;
                                                                char = ' ';

                                                                if (appraisalreport_obj['entity']) {
                                                                    c15_codigo_mandatario = appraisalreport_obj['entity']['bde_code'];
                                                                }
                                                                tasaciones[reports_year][tas_count_str]['c15_codigo_mandatario'] = padchar(c15_codigo_mandatario, positions, char);

                                                                // NIF/CIF del solicitante 16 X(11) NIF/CIF
                                                                var c16_nif_solicitante = '';
                                                                positions = 11;
                                                                char = ' ';

                                                                if (appraisalreport_obj['petitioners']) {
                                                                    var petitioners = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(appraisalreport_obj['petitioners']);
                                                                    c16_nif_solicitante = petitioners[0]['tin'];
                                                                }

                                                                tasaciones[reports_year][tas_count_str]['c16_nif_solicitante'] = padchar(c16_nif_solicitante, positions, char);

                                                                // Nombre del solicitante 17 X(60)
                                                                var c17_nombre_solicitante = '';
                                                                positions = 60;
                                                                char = ' ';

                                                                if (appraisalreport_obj['petitioners']) {
                                                                    var _petitioners = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(appraisalreport_obj['petitioners']);
                                                                    var name = _petitioners[0]['name'];
                                                                    var surnames = '';

                                                                    if (_petitioners[0]['surnames']) {
                                                                        surnames = ' ' + _petitioners[0]['surnames'];
                                                                    }
                                                                    c17_nombre_solicitante = name + surnames;
                                                                }

                                                                tasaciones[reports_year][tas_count_str]['c17_nombre_solicitante'] = padchar(c17_nombre_solicitante, positions, char);

                                                                // NIF/CIF del tasador 18 X(11) NIF/CIF
                                                                var c18_nif_tasador = '';
                                                                positions = 11;
                                                                char = ' ';

                                                                if (appraisalreport_obj['appraiser']) {
                                                                    c18_nif_tasador = appraisalreport_obj['appraiser']['tin'];
                                                                }
                                                                tasaciones[reports_year][tas_count_str]['c18_nif_tasador'] = padchar(c18_nif_tasador, positions, char);

                                                                // Nombre del tasador 19 X(60)
                                                                var c19_nombre_tasador = '';
                                                                positions = 60;
                                                                char = ' ';

                                                                if (appraisalreport_obj['appraiser']) {
                                                                    var _name = appraisalreport_obj['appraiser']['name'];
                                                                    var _surnames = appraisalreport_obj['appraiser']['surnames'];
                                                                    c19_nombre_tasador = _name + ' ' + _surnames;
                                                                }
                                                                tasaciones[reports_year][tas_count_str]['c19_nombre_tasador'] = padchar(c19_nombre_tasador, positions, char);

                                                                // NIF/CIF del supervisor 20 X(11) NIF/CIF
                                                                var c20_nif_supervisor = '';
                                                                positions = 11;
                                                                char = ' ';

                                                                if (appraisalreport_obj['supervisor']) {
                                                                    c20_nif_supervisor = appraisalreport_obj['supervisor']['tin'];
                                                                }
                                                                tasaciones[reports_year][tas_count_str]['c20_nif_supervisor'] = padchar(c20_nif_supervisor, positions, char);

                                                                // Nombre del supervisor 21 X(60)
                                                                var c21_nombre_supervisor = '';
                                                                positions = 60;
                                                                char = ' ';

                                                                if (appraisalreport_obj['supervisor']) {
                                                                    var _name2 = appraisalreport_obj['supervisor']['name'];
                                                                    var _surnames2 = appraisalreport_obj['supervisor']['surnames'];
                                                                    c21_nombre_supervisor = _name2 + ' ' + _surnames2;
                                                                }
                                                                tasaciones[reports_year][tas_count_str]['c21_nombre_supervisor'] = padchar(c21_nombre_supervisor, positions, char);
                                                            }
                                                        });
                                                    }

                                                    console.log('tasaciones (' + reports_year + '): ');
                                                    console.log(tasaciones[reports_year]);

                                                    console.log('inmuebles (' + reports_year + '): ');
                                                    console.log(inmuebles[reports_year]);

                                                    console.log('comparables (' + reports_year + '): ');
                                                    console.log(comparables[reports_year]);

                                                    console.log('relaciones (' + reports_year + '): ');
                                                    console.log(relaciones[reports_year]);

                                                    //console.log('errors al fichero de tasaciones (' + reports_year + '): ')
                                                    //console.log(tasaciones_errors[reports_year])

                                                    //console.log('errors al fichero de inmuebles (' + reports_year + '): ')
                                                    //console.log(inmuebles_errors[reports_year])
                                                });

                                                //this.bde_appraisal_files = tasaciones
                                                //this.bde_realestate_files = inmuebles
                                                //this.bde_comparable_files = comparables
                                                //this.bde_relationship_files = relaciones

                                                _this.set_bde_appraisal_files(tasaciones);
                                                _this.set_bde_realestate_files(inmuebles);
                                                _this.set_bde_comparable_files(comparables);
                                                _this.set_bde_relationships_files(relaciones);

                                                _this.master_loading = false;
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    });
                });
            });
        });
    },


    components: {
        Bar: __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default.a,
        Message: __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default.a,
        IconButton: __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default.a,
        Checkbox: __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue___default.a,
        Datatable: __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue___default.a,
        DatatableColumn: __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue___default.a,
        Paginator: __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue___default.a,
        SideNavBar: __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default.a
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['theme', 'currentLocale', 'appraisalreports', 'appraisalinvoices', 'appraisalquotes', 'appraisalfiles', 'appraisals', 'realestates', 'marketstudies', 'ad_comparables', 'realestates', 'warnings', 'constraints', 'bde_appraisal_files', 'bde_realestate_files', 'bde_comparable_files', 'bde_relationships_files'])),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['FETCH_APPRAISALREPORTS', 'FETCH_APPRAISALS', 'FETCH_APPRAISALFILES', 'FETCH_MARKETSTUDIES', 'FETCH_AD_COMPARABLES', 'FETCH_APPRAISALINVOICES', 'FETCH_APPRAISALQUOTES', 'FETCH_REALESTATES', 'FETCH_WARNINGS', 'FETCH_CONSTRAINTS', 'SET_BDE_APPRAISAL_FILES', 'SET_BDE_REALESTATE_FILES', 'SET_BDE_COMPARABLE_FILES', 'SET_BDE_RELATIONSHIPS_FILES']), {
        openFilesFromYear: function openFilesFromYear(year) {
            this.$router.push({ name: 'bdefiles-editor', query: { filesyear: year } });
        },
        set_bde_appraisal_files: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (value) {
            this.SET_BDE_APPRAISAL_FILES(value).then(function () {
                //
            });
        }, 0),
        set_bde_realestate_files: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (value) {
            this.SET_BDE_REALESTATE_FILES(value).then(function () {
                //
            });
        }, 0),
        set_bde_comparable_files: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (value) {
            this.SET_BDE_COMPARABLE_FILES(value).then(function () {
                //
            });
        }, 0),
        set_bde_relationships_files: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (value) {
            this.SET_BDE_RELATIONSHIPS_FILES(value).then(function () {
                //
            });
        }, 0)
    }),

    head: {
        title: {
            //inner: Vue.i18n.translate('New_contact')
            inner: 'BDE files'
        }

    }
});

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__router_index_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__options_petitioner_types__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Datatable_datatable_column_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Datatable_datatable_column_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_Datatable_datatable_column_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__aggregators_aggregators_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__formatters_formatters_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Toggles_checkbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Toggles_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Toggles_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Paginator_paginator_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Paginator_paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_Paginator_paginator_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


























/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'becprice-editor',

    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins__["d" /* dateMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["a" /* localStorageMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["f" /* mathMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["e" /* objectsMixin */]],

    data: function data() {
        return {
            loading: true,
            master_loading: true,
            filesOpen: true,
            fileOpen: true,
            reportOpen: true,
            error: null,
            success_message: null,
            metadata_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Metadata'),
            data_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Data'),
            report_title_error_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Report_title_missing_error_text'),
            new_real_estate_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_real_estate'),
            new_becprice_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_bec_number'),
            cancel_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cancel'),
            goup_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_up') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            pdf_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Print_report_in_PDF'),
            save_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save'),
            save_and_go_up_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('go_up'),
            page_dirty_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('The_page_contains_unsaved_changes'),
            actions_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Actions'),
            filter_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type_here_to_filter_paginated_data'),
            becprice_appraisaldateValue: null,
            duplicate_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Duplicate'),
            edit_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Edit'),
            delete_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Delete'),
            discard_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Discard'),
            openlink_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Open_link_in_new_tab'),
            petitionerValue: null,
            petitioner_typeValue: null,
            petitioner_typeOptions: __WEBPACK_IMPORTED_MODULE_13__options_petitioner_types__["a" /* default */]
        };
    },

    created: function created() {
        this.master_loading = false;
    },


    components: {
        Bar: __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default.a,
        Message: __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default.a,
        IconButton: __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default.a,
        SideNavBar: __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default.a,
        Checkbox: __WEBPACK_IMPORTED_MODULE_18__components_Toggles_checkbox_vue___default.a,
        Datatable: __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_vue___default.a,
        DatatableColumn: __WEBPACK_IMPORTED_MODULE_15__components_Datatable_datatable_column_vue___default.a,
        Paginator: __WEBPACK_IMPORTED_MODULE_19__components_Paginator_paginator_vue___default.a
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['theme', 'tags_display', 'currentLocale', 'becproperty', 'becprice'])),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['CHECK_BECPRICE_BECPRICE_APPRAISALS', 'CREATE_NEW_BECPRICE', 'DELETE_BECPRICE', 'FETCH_BECPRICE_BECPRICES', 'RESET_BECPRICE', 'SET_BECPRICE', 'UPDATE_BECPRICE', 'SET_BECPRICE_NUMBER', 'SET_BECPRICE_QUARTER', 'SET_BECPRICE_YEAR', 'SET_BECPRICE_AIRE_ACONDICIONADO', 'SET_BECPRICE_ALBANILERIA_ACABADOS_FACHADA', 'SET_BECPRICE_ALBANILERIA_ACABADOS_INTERIORES', 'SET_BECPRICE_ALBANILERIA_AYUDAS_INDUSTRIALES', 'SET_BECPRICE_ALBANILERIA_AZOTEAS', 'SET_BECPRICE_ALBANILERIA_GRUESA', 'SET_BECPRICE_ALBANILERIA_SOLADOS', 'SET_BECPRICE_ASCENSORES', 'SET_BECPRICE_CALEFACCION', 'SET_BECPRICE_CARPINTERIA_EXTERIOR', 'SET_BECPRICE_CARPINTERIA_INTERIOR', 'SET_BECPRICE_CERRAJERIA', 'SET_BECPRICE_CIMENTACION_Y_MURO_SOTANO', 'SET_BECPRICE_ELECTRICIDAD', 'SET_BECPRICE_ENERGIA_SOLAR_ACS', 'SET_BECPRICE_ESTRUCTURA', 'SET_BECPRICE_FONTANERIA', 'SET_BECPRICE_FUMISTERIA_Y_MUEBLES_COCINA', 'SET_BECPRICE_INSTAL_ESPECIALES', 'SET_BECPRICE_JARDINERIA_DECORATIVA', 'SET_BECPRICE_MAT_SANITARIO_GRIFERIA', 'SET_BECPRICE_MOVIMIENTO_TIERRAS', 'SET_BECPRICE_PERSIANAS', 'SET_BECPRICE_PINTURA_Y_ESTUCOS', 'SET_BECPRICE_RENOVACION_AIRE', 'SET_BECPRICE_SANEAMIENTO', 'SET_BECPRICE_SEGURIDAD_Y_SALUD', 'SET_BECPRICE_SUBTOTAL', 'SET_BECPRICE_TOTAL', 'SET_BECPRICE_VIDRIERIA', 'SET_BECPRICE_YESERIA_CIELOSRASOS']), {

        set_becprice_number: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_BECPRICE_NUMBER(Number(e.target.value));
        }, 1000),
        set_becprice_quarter: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_BECPRICE_QUARTER(Number(e.target.value));
        }, 1000),
        set_becprice_year: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_BECPRICE_YEAR(Number(e.target.value));
        }, 1000),
        set_becprice_aire_acondicionado: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_BECPRICE_AIRE_ACONDICIONADO(Number(e.target.value));
            this.calc_construction_price_totals();
        }, 1000),
        set_becprice_albanileria_acabados_fachada: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_BECPRICE_ALBANILERIA_ACABADOS_FACHADA(Number(e.target.value));
            this.calc_construction_price_totals();
        }, 1000),
        set_becprice_albanileria_acabados_interiores: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_BECPRICE_ALBANILERIA_ACABADOS_INTERIORES(Number(e.target.value));
            this.calc_construction_price_totals();
        }, 1000),
        set_becprice_albanileria_ayudas_industriales: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_BECPRICE_ALBANILERIA_AYUDAS_INDUSTRIALES(Number(e.target.value));
            this.calc_construction_price_totals();
        }, 1000),
        set_becprice_albanileria_azoteas: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_BECPRICE_ALBANILERIA_AZOTEAS(Number(e.target.value));
            this.calc_construction_price_totals();
        }, 1000),
        set_becprice_albanileria_gruesa: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_BECPRICE_ALBANILERIA_GRUESA(Number(e.target.value));
            this.calc_construction_price_totals();
        }, 1000),
        set_becprice_albanileria_solados: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_BECPRICE_ALBANILERIA_SOLADOS(Number(e.target.value));
            this.calc_construction_price_totals();
        }, 1000),
        set_becprice_ascensores: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_BECPRICE_ASCENSORES(Number(e.target.value));
            this.calc_construction_price_totals();
        }, 1000),
        set_becprice_calefaccion: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_BECPRICE_CALEFACCION(Number(e.target.value));
            this.calc_construction_price_totals();
        }, 1000),
        set_becprice_carpinteria_exterior: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_BECPRICE_CARPINTERIA_EXTERIOR(Number(e.target.value));
            this.calc_construction_price_totals();
        }, 1000),
        set_becprice_carpinteria_interior: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_BECPRICE_CARPINTERIA_INTERIOR(Number(e.target.value));
            this.calc_construction_price_totals();
        }, 1000),
        set_becprice_cerrajeria: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_BECPRICE_CERRAJERIA(Number(e.target.value));
            this.calc_construction_price_totals();
        }, 1000),
        set_becprice_cimentacion_y_muro_sotano: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_BECPRICE_CIMENTACION_Y_MURO_SOTANO(Number(e.target.value));
            this.calc_construction_price_totals();
        }, 1000),
        set_becprice_electricidad: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_BECPRICE_ELECTRICIDAD(Number(e.target.value));
            this.calc_construction_price_totals();
        }, 1000),
        set_becprice_energia_solar_acs: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_BECPRICE_ENERGIA_SOLAR_ACS(Number(e.target.value));
            this.calc_construction_price_totals();
        }, 1000),
        set_becprice_estructura: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_BECPRICE_ESTRUCTURA(Number(e.target.value));
            this.calc_construction_price_totals();
        }, 1000),
        set_becprice_fontaneria: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_BECPRICE_FONTANERIA(Number(e.target.value));
            this.calc_construction_price_totals();
        }, 1000),
        set_becprice_fumisteria_y_muebles_cocina: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_BECPRICE_FUMISTERIA_Y_MUEBLES_COCINA(Number(e.target.value));
            this.calc_construction_price_totals();
        }, 1000),
        set_becprice_instal_especiales: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_BECPRICE_INSTAL_ESPECIALES(Number(e.target.value));
            this.calc_construction_price_totals();
        }, 1000),
        set_becprice_jardineria_decorativa: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_BECPRICE_JARDINERIA_DECORATIVA(Number(e.target.value));
            this.calc_construction_price_totals();
        }, 1000),
        set_becprice_mat_sanitario_griferia: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_BECPRICE_MAT_SANITARIO_GRIFERIA(Number(e.target.value));
            this.calc_construction_price_totals();
        }, 1000),
        set_becprice_movimiento_tierras: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_BECPRICE_MOVIMIENTO_TIERRAS(Number(e.target.value));
            this.calc_construction_price_totals();
        }, 1000),
        set_becprice_persianas: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_BECPRICE_PERSIANAS(Number(e.target.value));
            this.calc_construction_price_totals();
        }, 1000),
        set_becprice_pintura_y_estucos: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_BECPRICE_PINTURA_Y_ESTUCOS(Number(e.target.value));
            this.calc_construction_price_totals();
        }, 1000),
        set_becprice_renovacion_aire: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_BECPRICE_RENOVACION_AIRE(Number(e.target.value));
            this.calc_construction_price_totals();
        }, 1000),
        set_becprice_saneamiento: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_BECPRICE_SANEAMIENTO(Number(e.target.value));
            this.calc_construction_price_totals();
        }, 1000),
        set_becprice_seguridad_y_salud: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_BECPRICE_SEGURIDAD_Y_SALUD(Number(e.target.value));
        }, 1000),
        set_becprice_subtotal: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_BECPRICE_SUBTOTAL(Number(e.target.value));
        }, 1000),
        set_becprice_total: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_BECPRICE_TOTAL(Number(e.target.value));
        }, 1000),
        set_becprice_vidrieria: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_BECPRICE_VIDRIERIA(Number(e.target.value));
            this.calc_construction_price_totals();
        }, 1000),
        set_becprice_yeseria_cielosrasos: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_BECPRICE_YESERIA_CIELOSRASOS(Number(e.target.value));
            this.calc_construction_price_totals();
        }, 1000),
        calc_construction_price_totals: function calc_construction_price_totals() {

            var subtotal = this.becprice.aire_acondicionado + this.becprice.albanileria_acabados_fachada + this.becprice.albanileria_acabados_interiores + this.becprice.albanileria_ayudas_industriales + this.becprice.albanileria_azoteas + this.becprice.albanileria_gruesa + this.becprice.albanileria_solados + this.becprice.ascensores + this.becprice.calefaccion + this.becprice.carpinteria_exterior + this.becprice.carpinteria_interior + this.becprice.cerrajeria + this.becprice.cimentacion_y_muro_sotano + this.becprice.electricidad + this.becprice.energia_solar_acs + this.becprice.estructura + this.becprice.fontaneria + this.becprice.fumisteria_y_muebles_cocina + this.becprice.instal_especiales + this.becprice.jardineria_decorativa + this.becprice.mat_sanitario_griferia + this.becprice.movimiento_tierras + this.becprice.persianas + this.becprice.pintura_y_estucos + this.becprice.renovacion_aire + this.becprice.saneamiento + this.becprice.vidrieria + this.becprice.yeseria_cielosrasos;

            var ss = this.roundToTwo(subtotal * 0.02);
            var total = subtotal + ss;

            this.SET_BECPRICE_SUBTOTAL(subtotal);
            this.SET_BECPRICE_SEGURIDAD_Y_SALUD(ss);
            this.SET_BECPRICE_TOTAL(total);
        },
        onSaveCurrentBecProperty: function onSaveCurrentBecProperty(data) {
            var _this = this;

            this.UPDATE_BECPRICE({
                object: this.becprice,
                path: this.becprice.path,
                key: this.becprice.id
            }).then(function (res) {
                // router.go(-1)
                if (data.go_up) {
                    _this.onGoUp();
                }
            });
        },
        onGoBack: function onGoBack() {
            __WEBPACK_IMPORTED_MODULE_11__router_index_js__["a" /* default */].go(-1);
        },
        onGoUp: function onGoUp() {
            this.$router.push({ name: 'becproperties-index' });
        }
    }),
    head: {
        title: {
            inner: 'Edit becprice'
        }
    }

});

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ContactsSearch_Index_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ContactsSearch_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_ContactsSearch_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_SideNavBar_Index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_SideNavBar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_SideNavBar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_SuccessMessage_vue__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_SuccessMessage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_SuccessMessage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__options_honorific_titles__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__options_person_types__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Datatable_datatable_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Datatable_datatable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_Datatable_datatable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Datatable_datatable_column_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Datatable_datatable_column_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Datatable_datatable_column_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__aggregators_aggregators_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__formatters_formatters_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Toggles_checkbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Toggles_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_Toggles_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Paginator_paginator_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Paginator_paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_Paginator_paginator_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



























/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'becproperties-index',

    mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins__["d" /* dateMixin */], __WEBPACK_IMPORTED_MODULE_5__mixins__["a" /* localStorageMixin */], __WEBPACK_IMPORTED_MODULE_5__mixins__["e" /* objectsMixin */]],

    data: function data() {
        return {
            loading: false,
            fileOpen: false,
            filter_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type_here_to_filter_paginated_data'),
            new_appraisalreport_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_appraisal_report'),
            new_becproperty_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_bec_property'),
            cancel_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cancel'),
            goback_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_back') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            goup_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_up') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            save_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('go_up'),
            cad_ref_error_text_01: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cadastral_Reference_less_20_positions_error_text'),
            page_dirty_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('The_page_contains_unsaved_changes'),
            actions_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Actions'),
            duplicate_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Duplicate'),
            edit_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Edit'),
            delete_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Delete'),
            value: null,
            ms_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Pick_an_option'),
            error: null,
            success_message: null,
            honorificTitleOptions: __WEBPACK_IMPORTED_MODULE_14__options_honorific_titles__["a" /* default */],
            personTypeOptions: __WEBPACK_IMPORTED_MODULE_15__options_person_types__["a" /* default */],
            becproperties_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: "EUR",
                dateFormat: "DD/MM/YYYY",
                columns: [{
                    id: "name_es",
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Name'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: "date_modified",
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Last_modified'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format('DD/MM/YYYY HH:mm:ss');
                    }
                }],
                selected: []
            }
        };
    },

    components: {
        Bar: __WEBPACK_IMPORTED_MODULE_9__components_Bar_Index_vue___default.a,
        Message: __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default.a,
        SuccessMessage: __WEBPACK_IMPORTED_MODULE_13__components_SuccessMessage_vue___default.a,
        IconButton: __WEBPACK_IMPORTED_MODULE_10__components_IconButton_Index_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_6__components_Spinner_vue___default.a,
        Checkbox: __WEBPACK_IMPORTED_MODULE_20__components_Toggles_checkbox_vue___default.a,
        Datatable: __WEBPACK_IMPORTED_MODULE_16__components_Datatable_datatable_vue___default.a,
        DatatableColumn: __WEBPACK_IMPORTED_MODULE_17__components_Datatable_datatable_column_vue___default.a,
        Paginator: __WEBPACK_IMPORTED_MODULE_21__components_Paginator_paginator_vue___default.a,
        SideNavBar: __WEBPACK_IMPORTED_MODULE_11__components_SideNavBar_Index_vue___default.a
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['theme', 'currentLocale', 'becproperties'])),

    created: function created() {
        var _this = this;

        this.FETCH_BECPROPERTIES().then(function () {
            _this.loading = false;
        });
    },


    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['FETCH_BECPROPERTIES', 'CREATE_NEW_BECPROPERTY', 'SET_BECPROPERTY', 'RESET_BECPROPERTY']
    /*
    'DELETE_BECPROPERTYREPORT',
    'FETCH_ALL_REALESTATE_BECPROPERTIES',
    'FETCH_BECPROPERTYFILE_BECPROPERTYREPORTS',
     'GET_BECPROPERTYREPORT',
     'SET_BECPROPERTYFILE_DESCRIPTION',
    'SET_BECPROPERTYFILE_NUMBER',
    'UPDATE_BECPROPERTYFILE',
    'UPDATE_BECPROPERTYREPORT'
    */
    ), {
        onCreateNewBecProperty: function onCreateNewBecProperty() {
            var _this2 = this;

            this.master_loading = true;
            this.RESET_BECPROPERTY().then(function () {
                _this2.CREATE_NEW_BECPROPERTY({
                    path: 'becproperties' + '/'
                }).then(function (res) {
                    _this2.master_loading = false;
                    _this2.$router.push({ name: 'becproperty-editor', query: { id: res.key } });
                });
            });
        },

        duplicateBecProperty: function duplicateBecProperty(entity) {

            /*
             this.loading = true
             const new_versionnumber = entity.version + 1
             this.RESET_BECPROPERTYREPORT().then((res) => {
                this.CREATE_NEW_BECPROPERTYREPORT({
                    path: 'appraisalreports' + '/',
                    parent_path: 'appraisalfiles' + '/' + this.appraisalfile.id + '/' + 'appraisalreports' + '/',
                    file_id: this.appraisalfile.id,
                    number: entity.number,
                    version: new_versionnumber
                }).then((res) => {
                     console.log('duplicateBecProperty then res:')
            console.log(res)
                     const new_object_id = res.key
                    const new_object_version = new_versionnumber
                     this.GET_BECPROPERTYREPORT({ path: 'appraisalreports' + '/' + entity.id }).then((res) => {
                         console.log(' *^*^*^*^*^*^*^*^*^*^get appraisal report res: ')
            console.log(res)
                         let new_object = res
            new_object.id = new_object_id
            new_object.version = new_object_version
                          this.UPDATE_BECPROPERTYREPORT({
                            object: new_object,
                            path: 'appraisalreports/',
                            parent_path: 'appraisalfiles' + '/' + this.appraisalfile.id + '/' + 'appraisalreports' + '/',
                            key: new_object_id
                        }).then((res) => {
                             this.loading = true
                            this.FETCH_BECPROPERTYFILE_BECPROPERTYREPORTS({path: 'appraisalfiles' + '/' + this.$route.query.id + '/' + 'appraisalreports'})
                                .then(() => {
                                    this.loading = false
                                })
                         })
            })
                  })
            })
            */

        },
        onGoBack: function onGoBack() {
            // console.log('yeah back')
            __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].go(-1);
        },
        onGoUp: function onGoUp() {
            // console.log('yeah back')
            this.$router.push({ name: 'appraisalfiles-index' });
        },
        onSaveCurrentAppraisalFile: function onSaveCurrentAppraisalFile(data) {

            /*
            console.log('appraisalfile.id: ')
            console.log(this.appraisalfile.id)
            this.UPDATE_BECPROPERTYFILE({
                object: this.appraisalfile,
                path: 'appraisalfiles' + '/' + this.appraisalfile.id
            }).then((res) => {
                if (data.goback) {
                    this.$router.push({name: 'appraisalfiles-index'})
                }
            })
            */
        },
        editBecProperty: function editBecProperty(entity) {
            var _this3 = this;

            this.SET_BECPROPERTY({ path: 'becproperties' + '/' + entity.id + '/' }).then(function (res) {
                _this3.$router.push({ name: 'becproperty-editor', query: { id: entity.id } });
            });
        },
        deleteBecProperty: function deleteBecProperty(entity) {

            /*
             const result = window.confirm(Vue.i18n.translate("You_are_about_to_delete ") + entity.filenumber + ', ' + entity.filedescription + ". " + Vue.i18n.translate("Continue_q"))
             if (result) {
                 this.DELETE_BECPROPERTYREPORT({
                    file_id: this.appraisalfile.id,
                    path: 'appraisalreports' + '/' + entity.id,
                    key: entity.id,
                    parent_path: 'appraisalfiles' + '/' + this.appraisalfile.id + '/' + 'appraisalreports' + '/' + entity.id
                }).then((res) => {
                    //
                    this.loading = true
                    this.FETCH_BECPROPERTYFILE_BECPROPERTYREPORTS({path: 'appraisalfiles' + '/' + this.$route.query.id + '/' + 'appraisalreports'})
                        .then(() => {
                            this.loading = false
                        })
                })
             }
            */

        }
    }),
    head: {
        title: {
            //inner: Vue.i18n.translate('New_appraisalfile')
            inner: 'Bec Properties'
        }
    }

});

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__router_index_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__options_petitioner_types__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Datatable_datatable_column_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Datatable_datatable_column_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_Datatable_datatable_column_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__aggregators_aggregators_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__formatters_formatters_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Toggles_checkbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Toggles_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Toggles_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Paginator_paginator_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Paginator_paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_Paginator_paginator_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


























/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'becproperty-editor',

    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins__["d" /* dateMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["a" /* localStorageMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["e" /* objectsMixin */]],

    data: function data() {
        return {
            loading: true,
            master_loading: true,
            filesOpen: true,
            fileOpen: true,
            reportOpen: true,
            error: null,
            success_message: null,
            metadata_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Metadata'),
            data_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Data'),
            report_title_error_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Report_title_missing_error_text'),
            new_real_estate_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_real_estate'),
            new_becprice_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_bec_number'),
            cancel_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cancel'),
            goup_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_up') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            pdf_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Print_report_in_PDF'),
            save_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save'),
            save_and_go_up_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('go_up'),
            page_dirty_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('The_page_contains_unsaved_changes'),
            actions_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Actions'),
            filter_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type_here_to_filter_paginated_data'),
            becprice_appraisaldateValue: null,
            duplicate_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Duplicate'),
            edit_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Edit'),
            delete_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Delete'),
            discard_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Discard'),
            openlink_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Open_link_in_new_tab'),
            petitionerValue: null,
            petitioner_typeValue: null,
            petitioner_typeOptions: __WEBPACK_IMPORTED_MODULE_13__options_petitioner_types__["a" /* default */],
            becprices_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [{
                    id: 'number',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Number'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'year',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Year'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'quarter',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quarter'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'date_modified',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Last_modified'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format('DD/MM/YYYY HH:mm:ss');
                    }
                }],
                selected: []
            }
        };
    },

    created: function created() {
        var _this = this;

        this.FETCH_BECPROPERTY_BECPRICES({
            path: 'becproperty_becprices' + '/' + this.$route.query.id,
            becproperty_id: this.$route.query.id
        }).then(function () {
            _this.master_loading = false;
        });
    },


    components: {
        Bar: __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default.a,
        Message: __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default.a,
        IconButton: __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default.a,
        SideNavBar: __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default.a,
        Checkbox: __WEBPACK_IMPORTED_MODULE_18__components_Toggles_checkbox_vue___default.a,
        Datatable: __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_vue___default.a,
        DatatableColumn: __WEBPACK_IMPORTED_MODULE_15__components_Datatable_datatable_column_vue___default.a,
        Paginator: __WEBPACK_IMPORTED_MODULE_19__components_Paginator_paginator_vue___default.a
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['theme', 'tags_display', 'currentLocale', 'becproperty', 'becproperty_becprices', 'becprice'])),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['CHECK_BECPROPERTY_BECPRICE_APPRAISALS', 'CREATE_NEW_BECPRICE', 'DELETE_BECPRICE', 'FETCH_BECPROPERTY_BECPRICES', 'RESET_BECPRICE', 'SET_BECPRICE', 'GET_BECPRICE', 'UPDATE_BECPROPERTY', 'UPDATE_BECPRICE', 'SET_BECPROPERTY_NAME_CA', 'SET_BECPROPERTY_NAME_EN', 'SET_BECPROPERTY_NAME_ES']), {
        set_becproperty_name_ca: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_BECPROPERTY_NAME_CA(e.target.value);
        }, 1000),
        set_becproperty_name_en: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_BECPROPERTY_NAME_EN(e.target.value);
        }, 1000),
        set_becproperty_name_es: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_BECPROPERTY_NAME_ES(e.target.value);
        }, 1000),

        onCreateNewBecPrice: function onCreateNewBecPrice() {
            var _this2 = this;

            this.master_loading = true;

            this.RESET_BECPRICE().then(function (res) {
                _this2.CREATE_NEW_BECPRICE({
                    becproperty_id: _this2.becproperty.id,
                    path: 'becproperty_becprices' + '/' + _this2.becproperty.id + '/'
                }).then(function (res) {
                    _this2.FETCH_BECPROPERTY_BECPRICES({
                        path: 'becproperty_becprices' + '/' + _this2.$route.query.id,
                        becproperty_id: _this2.$route.query.id
                    }).then(function () {
                        _this2.master_loading = false;
                    });
                    // this.master_loading = false
                    // this.$router.push({name: 'becprice-editor', query: {id: res.key}})
                });
            });
        },
        editBecPrice: function editBecPrice(entity) {
            var _this3 = this;

            this.SET_BECPRICE({ path: 'becproperty_becprices' + '/' + this.becproperty.id + '/' + entity.id + '/' }).then(function (res) {
                _this3.$router.push({ name: 'becprice-editor', query: { id: entity.id } });
            });
        },
        deleteBecPrice: function deleteBecPrice(entity) {
            var _this4 = this;

            var result = window.confirm(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('You_are_about_to_delete ') + entity.number + '. ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Continue_q'));

            if (result) {
                this.master_loading = true;
                this.DELETE_BECPRICE({
                    path: 'becproperty_becprices' + '/' + this.becproperty.id + '/' + entity.id,
                    key: entity.id
                }).then(function (res) {
                    //

                    _this4.FETCH_BECPROPERTY_BECPRICES({
                        path: 'becproperty_becprices' + '/' + _this4.$route.query.id,
                        becproperty_id: _this4.$route.query.id
                    }).then(function () {
                        _this4.master_loading = false;
                    });
                });
            }
        },
        duplicateBecPrice: function duplicateBecPrice(entity) {
            var _this5 = this;

            this.master_loading = true;

            this.RESET_BECPRICE().then(function (res) {
                _this5.CREATE_NEW_BECPRICE({
                    becproperty_id: _this5.becproperty.id,
                    path: 'becproperty_becprices' + '/' + _this5.becproperty.id + '/'
                }).then(function (res) {

                    var new_object_id = res.key;

                    _this5.GET_BECPRICE({ path: 'becproperty_becprices' + '/' + _this5.becproperty.id + '/' + entity.id }).then(function (res) {

                        var new_object = res;
                        new_object.id = new_object_id;

                        _this5.UPDATE_BECPRICE({
                            object: new_object,
                            path: 'becproperty_becprices' + '/' + _this5.becproperty.id + '/',
                            key: new_object_id
                        }).then(function (res) {

                            _this5.FETCH_BECPROPERTY_BECPRICES({
                                path: 'becproperty_becprices' + '/' + _this5.$route.query.id,
                                becproperty_id: _this5.$route.query.id
                            }).then(function () {
                                _this5.master_loading = false;
                            });
                        });
                    });
                });
            });
        },
        onSaveCurrentBecProperty: function onSaveCurrentBecProperty(data) {
            var _this6 = this;

            this.UPDATE_BECPROPERTY({
                object: this.becproperty,
                path: this.becproperty.path,
                parent_path: this.becproperty.parent_path,
                key: this.becproperty.id
            }).then(function (res) {
                // router.go(-1)
                if (data.go_up) {
                    _this6.onGoUp();
                }
            });
        },
        onGoBack: function onGoBack() {
            __WEBPACK_IMPORTED_MODULE_11__router_index_js__["a" /* default */].go(-1);
        },
        onGoUp: function onGoUp() {
            this.$router.push({ name: 'becproperties-index' });
        }
    }),
    head: {
        title: {
            inner: 'Edit becproperty'
        }
    }

});

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__router_index_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__aggregators_aggregators_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__formatters_formatters_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
























/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'cadasterannex-editor',

    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins__["d" /* dateMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["a" /* localStorageMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["e" /* objectsMixin */]],

    data: function data() {
        return {
            loading: true,
            master_loading: true,
            filesOpen: true,
            fileOpen: true,
            reportOpen: true,
            error: null,
            success_message: null,
            metadata_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Metadata'),
            data_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Data'),
            report_title_error_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Report_title_missing_error_text'),
            new_real_estate_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_real_estate'),
            cancel_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cancel'),
            goup_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_up') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            pdf_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Print_report_in_PDF'),
            save_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save'),
            save_and_go_up_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('go_up'),
            page_dirty_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('The_page_contains_unsaved_changes'),
            actions_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Actions'),
            filter_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type_here_to_filter_paginated_data'),
            duplicate_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Duplicate'),
            edit_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Edit'),
            delete_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Delete'),
            discard_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Discard'),
            openlink_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Open_link_in_new_tab')
        };
    },

    created: function created() {
        this.master_loading = false;
    },


    components: {
        Bar: __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default.a,
        Message: __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default.a,
        IconButton: __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default.a,
        SideNavBar: __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default.a,
        Checkbox: __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue___default.a,
        Datatable: __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue___default.a,
        DatatableColumn: __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue___default.a,
        Paginator: __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue___default.a
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['theme', 'tags_display', 'currentLocale', 'cadasterannex'])),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['UPDATE_CADASTERANNEX', 'SET_CADASTERANNEX_NAME_CA', 'SET_CADASTERANNEX_NAME_EN', 'SET_CADASTERANNEX_NAME_ES']), {
        set_cadasterannex_name_ca: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_CADASTERANNEX_NAME_CA(e.target.value);
        }, 1000),
        set_cadasterannex_name_en: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_CADASTERANNEX_NAME_EN(e.target.value);
        }, 1000),
        set_cadasterannex_name_es: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_CADASTERANNEX_NAME_ES(e.target.value);
        }, 1000),
        set_cadasterannex: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_CADASTERANNEX_NAME_CA(e.name_ca);
            this.SET_CADASTERANNEX_NAME_EN(e.name_en);
            this.SET_CADASTERANNEX_NAME_ES(e.name_es);
        }, 0),
        onSaveCurrentCadasterAnnex: function onSaveCurrentCadasterAnnex(data) {
            var _this = this;

            this.UPDATE_CADASTERANNEX({
                object: this.cadasterannex,
                path: this.cadasterannex.path,
                parent_path: this.cadasterannex.parent_path,
                key: this.cadasterannex.id
            }).then(function (res) {
                // router.go(-1)
                if (data.go_up) {
                    _this.onGoUp();
                }
            });
        },
        onGoBack: function onGoBack() {
            __WEBPACK_IMPORTED_MODULE_11__router_index_js__["a" /* default */].go(-1);
        },
        onGoUp: function onGoUp() {
            __WEBPACK_IMPORTED_MODULE_11__router_index_js__["a" /* default */].go(-1);
        }
    }),
    head: {
        title: {
            inner: 'Edit cadasterannex'
        }
    }

});

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__router_index_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__aggregators_aggregators_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__formatters_formatters_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
























/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'cessionannex-editor',

    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins__["d" /* dateMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["a" /* localStorageMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["e" /* objectsMixin */]],

    data: function data() {
        return {
            loading: true,
            master_loading: true,
            filesOpen: true,
            fileOpen: true,
            reportOpen: true,
            error: null,
            success_message: null,
            metadata_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Metadata'),
            data_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Data'),
            report_title_error_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Report_title_missing_error_text'),
            new_real_estate_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_real_estate'),
            cancel_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cancel'),
            goup_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_up') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            pdf_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Print_report_in_PDF'),
            save_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save'),
            save_and_go_up_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('go_up'),
            page_dirty_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('The_page_contains_unsaved_changes'),
            actions_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Actions'),
            filter_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type_here_to_filter_paginated_data'),
            duplicate_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Duplicate'),
            edit_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Edit'),
            delete_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Delete'),
            discard_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Discard'),
            openlink_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Open_link_in_new_tab')
        };
    },

    created: function created() {
        this.master_loading = false;
    },


    components: {
        Bar: __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default.a,
        Message: __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default.a,
        IconButton: __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default.a,
        SideNavBar: __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default.a,
        Checkbox: __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue___default.a,
        Datatable: __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue___default.a,
        DatatableColumn: __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue___default.a,
        Paginator: __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue___default.a
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['theme', 'tags_display', 'currentLocale', 'cessionannex'])),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['UPDATE_CESSIONANNEX', 'SET_CESSIONANNEX_NAME_CA', 'SET_CESSIONANNEX_NAME_EN', 'SET_CESSIONANNEX_NAME_ES']), {
        set_cessionannex_name_ca: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_CESSIONANNEX_NAME_CA(e.target.value);
        }, 1000),
        set_cessionannex_name_en: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_CESSIONANNEX_NAME_EN(e.target.value);
        }, 1000),
        set_cessionannex_name_es: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_CESSIONANNEX_NAME_ES(e.target.value);
        }, 1000),
        set_cessionannex: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_CESSIONANNEX_NAME_CA(e.name_ca);
            this.SET_CESSIONANNEX_NAME_EN(e.name_en);
            this.SET_CESSIONANNEX_NAME_ES(e.name_es);
        }, 0),
        onSaveCurrentCessionAnnex: function onSaveCurrentCessionAnnex(data) {
            var _this = this;

            this.UPDATE_CESSIONANNEX({
                object: this.cessionannex,
                path: this.cessionannex.path,
                parent_path: this.cessionannex.parent_path,
                key: this.cessionannex.id
            }).then(function (res) {
                // router.go(-1)
                if (data.go_up) {
                    _this.onGoUp();
                }
            });
        },
        onGoBack: function onGoBack() {
            __WEBPACK_IMPORTED_MODULE_11__router_index_js__["a" /* default */].go(-1);
        },
        onGoUp: function onGoUp() {
            __WEBPACK_IMPORTED_MODULE_11__router_index_js__["a" /* default */].go(-1);
        }
    }),
    head: {
        title: {
            inner: 'Edit cessionannex'
        }
    }

});

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__options_default_constraints__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__router_index_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Datatable_datatable_column_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Datatable_datatable_column_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_Datatable_datatable_column_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__aggregators_aggregators_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__formatters_formatters_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Toggles_checkbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Toggles_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Toggles_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Paginator_paginator_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Paginator_paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_Paginator_paginator_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


























/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'constraint-editor',

    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins__["d" /* dateMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["a" /* localStorageMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["e" /* objectsMixin */]],

    data: function data() {
        return {
            loading: true,
            master_loading: true,
            filesOpen: true,
            fileOpen: true,
            reportOpen: true,
            error: null,
            success_message: null,
            metadata_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Metadata'),
            data_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Data'),
            report_title_error_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Report_title_missing_error_text'),
            new_real_estate_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_real_estate'),
            cancel_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cancel'),
            goup_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_up') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            pdf_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Print_report_in_PDF'),
            save_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save'),
            save_and_go_up_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('go_up'),
            page_dirty_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('The_page_contains_unsaved_changes'),
            actions_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Actions'),
            filter_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type_here_to_filter_paginated_data'),
            duplicate_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Duplicate'),
            edit_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Edit'),
            delete_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Delete'),
            discard_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Discard'),
            openlink_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Open_link_in_new_tab'),
            constraintValue: null,
            default_constraintOptions: __WEBPACK_IMPORTED_MODULE_11__options_default_constraints__["a" /* default */]
        };
    },

    created: function created() {
        this.master_loading = false;
    },


    components: {
        Bar: __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default.a,
        Message: __WEBPACK_IMPORTED_MODULE_13__components_Message_vue___default.a,
        IconButton: __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default.a,
        SideNavBar: __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default.a,
        Checkbox: __WEBPACK_IMPORTED_MODULE_18__components_Toggles_checkbox_vue___default.a,
        Datatable: __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_vue___default.a,
        DatatableColumn: __WEBPACK_IMPORTED_MODULE_15__components_Datatable_datatable_column_vue___default.a,
        Paginator: __WEBPACK_IMPORTED_MODULE_19__components_Paginator_paginator_vue___default.a
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['theme', 'tags_display', 'currentLocale', 'constraint'])),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['UPDATE_CONSTRAINT', 'SET_CONSTRAINT_NAME_CA', 'SET_CONSTRAINT_NAME_EN', 'SET_CONSTRAINT_NAME_ES']), {
        set_constraint_name_ca: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_CONSTRAINT_NAME_CA(e.target.value);
        }, 1000),
        set_constraint_name_en: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_CONSTRAINT_NAME_EN(e.target.value);
        }, 1000),
        set_constraint_name_es: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_CONSTRAINT_NAME_ES(e.target.value);
        }, 1000),
        set_constraint: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_CONSTRAINT_NAME_CA(e.name_ca);
            this.SET_CONSTRAINT_NAME_EN(e.name_en);
            this.SET_CONSTRAINT_NAME_ES(e.name_es);
        }, 0),
        onSaveCurrentConstraint: function onSaveCurrentConstraint(data) {
            var _this = this;

            this.UPDATE_CONSTRAINT({
                object: this.constraint,
                path: this.constraint.path,
                parent_path: this.constraint.parent_path,
                key: this.constraint.id
            }).then(function (res) {
                // router.go(-1)
                if (data.go_up) {
                    _this.onGoUp();
                }
            });
        },
        onGoBack: function onGoBack() {
            __WEBPACK_IMPORTED_MODULE_12__router_index_js__["a" /* default */].go(-1);
        },
        onGoUp: function onGoUp() {
            __WEBPACK_IMPORTED_MODULE_12__router_index_js__["a" /* default */].go(-1);
        }
    }),
    head: {
        title: {
            inner: 'Edit constraint'
        }
    }

});

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_SuccessMessage_vue__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_SuccessMessage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_SuccessMessage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__options_honorific_titles__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__options_person_types__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Datatable_datatable_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Datatable_datatable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_Datatable_datatable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Datatable_datatable_column_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Datatable_datatable_column_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_Datatable_datatable_column_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__aggregators_aggregators_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__formatters_formatters_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Toggles_checkbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Toggles_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_Toggles_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Paginator_paginator_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Paginator_paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_Paginator_paginator_vue__);
var _name$mixins$data$cre;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


























/* harmony default export */ __webpack_exports__["default"] = (_name$mixins$data$cre = {
    name: 'contact-editor',

    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins__["d" /* dateMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["a" /* localStorageMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["e" /* objectsMixin */]],

    data: function data() {
        return {
            master_loading: true,
            filesOpen: true,
            fileOpen: true,
            reportOpen: true,
            filter_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type_here_to_filter_paginated_data'),
            data_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Data'),
            quotes_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quotes'),
            invoices_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Invoices'),
            appraisalreports_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Appraisal_reports'),
            new_address_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_address'),
            new_email_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_other_email'),
            new_telephone_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_telephone_number'),
            cancel_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cancel'),
            goback_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_back') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            save_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('go_back'),
            cad_ref_error_text_01: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cadastral_Reference_less_20_positions_error_text'),
            page_dirty_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('The_page_contains_unsaved_changes'),
            actions_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Actions'),
            value: null,
            ms_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Pick_an_option'),
            error: null,
            success_message: null,
            honorificTitleOptions: __WEBPACK_IMPORTED_MODULE_13__options_honorific_titles__["a" /* default */],
            personTypeOptions: __WEBPACK_IMPORTED_MODULE_14__options_person_types__["a" /* default */],
            address_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [{
                    id: 'description',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Description'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'street_name',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Street_name'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'street_number',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Street_number'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'municipality.name_ine',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Municipality'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }],
                selected: []
            },
            email_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [{
                    id: 'description',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Description'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'address',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Address'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }],
                selected: []
            },
            telephone_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [{
                    id: 'description',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Description'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'prefix',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Prefix'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'number',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Number'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }],
                selected: []
            },
            appraisalquote_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [{
                    id: 'quotedate',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Date'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'full_number',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quote'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }],
                selected: []
            }
        };
    },

    created: function created() {},


    components: {
        Bar: __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default.a,
        Message: __WEBPACK_IMPORTED_MODULE_11__components_Message_vue___default.a,
        SuccessMessage: __WEBPACK_IMPORTED_MODULE_12__components_SuccessMessage_vue___default.a,
        IconButton: __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default.a,
        Checkbox: __WEBPACK_IMPORTED_MODULE_19__components_Toggles_checkbox_vue___default.a,
        Datatable: __WEBPACK_IMPORTED_MODULE_15__components_Datatable_datatable_vue___default.a,
        DatatableColumn: __WEBPACK_IMPORTED_MODULE_16__components_Datatable_datatable_column_vue___default.a,
        Paginator: __WEBPACK_IMPORTED_MODULE_20__components_Paginator_paginator_vue___default.a,
        SideNavBar: __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default.a
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['theme', 'currentLocale', 'address', 'emailaddress', 'telephonenumber', 'contact', 'contact_addresses', 'contact_emailaddresses', 'contact_telephonenumbers', 'contact_appraisalinvoices', 'contact_appraisalquotes', 'contact_appraisalreports', 'contact']))

}, _defineProperty(_name$mixins$data$cre, 'created', function created() {
    var _this = this;

    this.FETCH_CONTACT_ADDRESSES({ path: 'contact_addresses' + '/' + this.$route.query.id + '/' }).then(function () {
        _this.FETCH_CONTACT_TELEPHONENUMBERS({ path: 'contact_telephonenumbers' + '/' + _this.$route.query.id + '/' }).then(function () {
            _this.FETCH_CONTACT_EMAILADDRESSES({ path: 'contact_emailaddresses' + '/' + _this.$route.query.id + '/' }).then(function () {
                _this.FETCH_CONTACT_APPRAISALINVOICES({ path: 'contacts' + '/' + _this.$route.query.id + '/' + 'appraisalinvoices' + '/' }).then(function () {
                    _this.FETCH_CONTACT_APPRAISALQUOTES({ path: 'contacts' + '/' + _this.$route.query.id + '/' + 'appraisalquotes' + '/' }).then(function () {
                        _this.FETCH_CONTACT_APPRAISALREPORTS({ path: 'contacts' + '/' + _this.$route.query.id + '/' + 'appraisalreports' + '/' }).then(function () {
                            _this.master_loading = false;
                        });
                    });
                });
            });
        });
    });
}), _defineProperty(_name$mixins$data$cre, 'methods', _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['CREATE_NEW_ADDRESS', 'CREATE_NEW_EMAILADDRESS', 'CREATE_NEW_TELEPHONENUMBER', 'DELETE_ADDRESS', 'DELETE_EMAILADDRESS', 'DELETE_TELEPHONENUMBER', 'FETCH_CONTACT_ADDRESSES', 'FETCH_CONTACT_EMAILADDRESSES', 'FETCH_CONTACT_TELEPHONENUMBERS', 'FETCH_CONTACT_APPRAISALINVOICES', 'FETCH_CONTACT_APPRAISALQUOTES', 'FETCH_CONTACT_APPRAISALREPORTS', 'RESET_ADDRESS', 'RESET_EMAILADDRESS', 'RESET_TELEPHONENUMBER', 'SET_ADDRESS', 'SET_EMAILADDRESS', 'SET_TELEPHONENUMBER', 'SET_APPRAISALQUOTE', 'SET_CONTACT_ADDRESSES', 'SET_CONTACT_MAIN_EMAIL', 'SET_CONTACT_NAME', 'SET_CONTACT_ORGANIZATION', 'SET_CONTACT_PERSON_TYPE', 'SET_CONTACT_REPRESENTATIVE', 'SET_CONTACT_REPRESENTATIVE_TIN', 'SET_CONTACT_SURNAMES', 'SET_CONTACT_EMAILADDRESSES', 'SET_CONTACT_TELEPHONENUMBERS', 'SET_CONTACT_TIN', 'SET_CONTACT_TITLE', 'SET_CONTACT_COMPLETE_NAME', 'SET_CONTACT_COMPLETE_FISCAL_ADDRESS', 'SET_CONTACT_MAIN_TELEPHONENUMBER', 'UPDATE_CONTACT']), {
    set_contact_addresses: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
        this.SET_CONTACT_ADDRESSES(e.target.value);
    }, 1000),
    set_contact_main_email: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
        this.SET_CONTACT_MAIN_EMAIL(e.target.value);
    }, 1000),
    set_contact_main_telephonenumber: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
        this.SET_CONTACT_MAIN_TELEPHONENUMBER(e.target.value);
    }, 1000),
    set_contact_name: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
        var name = e.target.value;
        var surnames = '';
        if (this.contact.surnames) {
            surnames = this.contact.surnames;
        }
        var complete_name = surnames + ', ' + name;
        if (!surnames) {
            complete_name = name;
        }
        this.SET_CONTACT_NAME(name);
        this.SET_CONTACT_COMPLETE_NAME(complete_name);
    }, 1000),
    set_contact_organization: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
        this.SET_CONTACT_ORGANIZATION(e.target.value);
    }, 1000),
    set_contact_person_type: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
        this.SET_CONTACT_PERSON_TYPE(e);
    }, 1000),
    set_contact_representative: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
        this.SET_CONTACT_REPRESENTATIVE(e.target.value);
    }, 1000),
    set_contact_representative_tin: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
        this.SET_CONTACT_REPRESENTATIVE_TIN(e.target.value);
    }, 1000),
    set_contact_surnames: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
        var surnames = e.target.value;
        var name = '';
        if (this.contact.name) {
            name = this.contact.name;
        }
        var complete_name = surnames + ', ' + name;
        if (!surnames) {
            complete_name = name;
        }
        this.SET_CONTACT_SURNAMES(surnames);
        this.SET_CONTACT_COMPLETE_NAME(complete_name);
    }, 1000),
    set_contact_emailaddresses: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
        this.SET_CONTACT_EMAILADDRESSES(e.target.value);
    }, 1000),
    set_contact_telephonenumbers: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
        this.SET_CONTACT_TELEPHONENUMBERS(e.target.value);
    }, 1000),
    set_contact_tin: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
        this.SET_CONTACT_TIN(e.target.value);
    }, 1000),
    set_contact_title: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
        this.SET_CONTACT_TITLE(e);
    }, 1000),
    set_contact_complete_fiscal_address: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
        this.SET_CONTACT_COMPLETE_FISCAL_ADDRESS(e.target.value);
    }, 500),
    onCreateNewAddress: function onCreateNewAddress() {
        var _this2 = this;

        // console.log('hey')
        // console.log('contact: ')
        // console.log(this.contact)
        this.RESET_ADDRESS().then(function (res) {
            _this2.CREATE_NEW_ADDRESS({
                path: 'contact_addresses' + '/' + _this2.contact.id + '/',
                key: _this2.contact.id,
                parent_path: 'contacts' + '/' + _this2.contact.id + '/' + 'addresses' + '/'
            }).then(function (res) {
                _this2.$router.push({ name: 'realestate-editor', query: { id: _this2.address.id } });
            });
        });
    },
    onCreateNewEmailAddress: function onCreateNewEmailAddress() {
        var _this3 = this;

        // console.log('hey')
        // console.log('contact: ')
        // console.log(this.contact)
        this.RESET_EMAILADDRESS().then(function (res) {
            _this3.CREATE_NEW_EMAILADDRESS({
                path: 'contact_emailaddresses' + '/' + _this3.contact.id + '/',
                key: _this3.contact.id,
                parent_path: 'contacts' + '/' + _this3.contact.id + '/' + 'emailaddresses' + '/'
            }).then(function (res) {
                _this3.$router.push({ name: 'emailaddress-editor', query: { id: _this3.emailaddress.id } });
            });
        });
    },
    onCreateNewTelephoneNumber: function onCreateNewTelephoneNumber() {
        var _this4 = this;

        // console.log('hey')
        // console.log('contact: ')
        // console.log(this.contact)
        this.RESET_TELEPHONENUMBER().then(function (res) {
            _this4.CREATE_NEW_TELEPHONENUMBER({
                path: 'contact_telephonenumbers' + '/' + _this4.contact.id + '/',
                key: _this4.contact.id,
                parent_path: 'contacts' + '/' + _this4.contact.id + '/' + 'telephonenumbers' + '/'
            }).then(function (res) {
                _this4.$router.push({ name: 'telephonenumber-editor', query: { id: _this4.telephonenumber.id } });
            });
        });
    },
    onGoBack: function onGoBack() {
        // console.log('yeah back')
        __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].go(-1);
    },
    onSaveCurrentContact: function onSaveCurrentContact(data) {
        // console.log('contact.id: ')
        // console.log(this.contact.id)
        this.UPDATE_CONTACT({
            object: this.contact,
            path: 'contacts' + '/' + this.contact.id
        }).then(function (res) {
            if (data.goback) {
                __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].go(-1);
            }
        });
    },
    editAddress: function editAddress(entity) {
        var _this5 = this;

        // console.log('edit realestate...')
        this.SET_ADDRESS({ path: 'contact_addresses' + '/' + this.contact.id + '/' + entity.id + '/' }).then(function (res) {
            _this5.$router.push({ name: 'realestate-editor', query: { id: entity.id } });
        });
    },
    editEmailAddress: function editEmailAddress(entity) {
        var _this6 = this;

        this.SET_EMAILADDRESS({ path: 'contact_emailaddresses' + '/' + this.contact.id + '/' + entity.id + '/' }).then(function (res) {
            _this6.$router.push({ name: 'emailaddress-editor', query: { id: entity.id } });
        });
    },
    editTelephoneNumber: function editTelephoneNumber(entity) {
        var _this7 = this;

        this.SET_TELEPHONENUMBER({ path: 'contact_telephonenumbers' + '/' + this.contact.id + '/' + entity.id + '/' }).then(function (res) {
            _this7.$router.push({ name: 'telephonenumber-editor', query: { id: entity.id } });
        });
    },
    deleteAddress: function deleteAddress(entity) {
        var _this8 = this;

        var result = window.confirm(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('You_are_about_to_delete ') + entity.street_name + ', ' + entity.street_number + '. ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Continue_q'));

        if (result) {

            this.DELETE_ADDRESS({
                path: 'contact_addresses' + '/' + this.contact.id + '/' + entity.id,
                key: entity.id,
                parent_path: 'contacts' + '/' + this.contact.id + '/' + 'addresses' + '/' + entity.id
            }).then(function (res) {
                //
                _this8.master_loading = true;
                _this8.FETCH_CONTACT_ADDRESSES({ path: 'contact_addresses' + '/' + _this8.$route.query.id + '/' }).then(function () {
                    _this8.master_loading = false;
                });
            });
        }
    },
    deleteEmailAddress: function deleteEmailAddress(entity) {
        var _this9 = this;

        var result = window.confirm(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('You_are_about_to_delete ') + entity.description + ', ' + entity.address + '. ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Continue_q'));

        if (result) {

            this.DELETE_EMAILADDRESS({
                path: 'contact_emailaddresses' + '/' + this.contact.id + '/' + entity.id,
                key: entity.id,
                parent_path: 'contacts' + '/' + this.contact.id + '/' + 'emailaddresses' + '/' + entity.id
            }).then(function (res) {
                //
                _this9.master_loading = true;
                _this9.FETCH_CONTACT_EMAILADDRESSES({ path: 'contact_emailaddresses' + '/' + _this9.$route.query.id + '/' }).then(function () {
                    _this9.master_loading = false;
                });
            });
        }
    },
    deleteTelephoneNumber: function deleteTelephoneNumber(entity) {
        var _this10 = this;

        var result = window.confirm(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('You_are_about_to_delete ') + entity.description + ', ' + entity.number + '. ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Continue_q'));

        if (result) {

            this.DELETE_TELEPHONENUMBER({
                path: 'contact_telephonenumbers' + '/' + this.contact.id + '/' + entity.id,
                key: entity.id,
                parent_path: 'contacts' + '/' + this.contact.id + '/' + 'telephonenumbers' + '/' + entity.id
            }).then(function (res) {
                //
                _this10.master_loading = true;
                _this10.FETCH_CONTACT_TELEPHONENUMBERS({ path: 'contact_telephonenumbers' + '/' + _this10.$route.query.id + '/' }).then(function () {
                    _this10.master_loading = false;
                });
            });
        }
    },
    editAppraisalQuote: function editAppraisalQuote(entity) {
        var _this11 = this;

        this.SET_APPRAISALQUOTE({ path: 'appraisalquotes' + '/' + entity.id }).then(function (res) {
            _this11.$router.push({ name: 'appraisalquote-editor', query: { id: entity.id } });
        });
    }
})), _defineProperty(_name$mixins$data$cre, 'head', {
    title: {
        //inner: Vue.i18n.translate('New_contact')
        inner: 'Edit contact'
    }
}), _name$mixins$data$cre);

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Datatable_datatable_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Datatable_datatable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Datatable_datatable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Datatable_datatable_column_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Datatable_datatable_column_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Datatable_datatable_column_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__aggregators_aggregators_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__formatters_formatters_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Toggles_checkbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Toggles_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_Toggles_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Paginator_paginator_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Paginator_paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_Paginator_paginator_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















// import DatatableCell from '../../../components/Datatable/datatable-cell.js'





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'contacts-index',

    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins__["a" /* localStorageMixin */]],

    data: function data() {
        return {
            master_loading: true,
            filesOpen: false,
            fileOpen: false,
            reportOpen: false,
            error: null,
            filter_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type_here_to_filter_paginated_data'),
            new_contact_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_contact'),
            customers: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,

                currency: 'USD',
                dateFormat: 'D MMMM YYYY',

                columns: [{
                    id: 'complete_name',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Complete_name'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'main_email',
                    label: 'E-mail',
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'tin',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('TIN'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                    /*
                    {
                        id: 'name',
                        label: Vue.i18n.translate('Name'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'surnames',
                        label: Vue.i18n.translate('Surnames'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    }
                    */
                }],

                rows: [{
                    id: '0584e8d2-984c-4ce0-a20f-8b9e21cd2c00',
                    name: 'Nancy Fuller',
                    purchasor_email: 'nfuller0@about.me',
                    purchase_date: '2002-01-02T04:45:48Z',
                    purchase_amount: 1166.14
                }, {
                    id: 'f4769183-38af-4c22-8383-6dea302466fd',
                    name: 'Melissa Meyer',
                    purchasor_email: 'mmeyer1@angelfire.com',
                    purchase_date: '2010-05-15T08:13:59Z',
                    purchase_amount: 6123.50
                }, {
                    id: 'e171c9fb-2438-4f23-8d0d-011b2d8e95bc',
                    name: 'Larry Rose',
                    purchasor_email: 'lrose2@cdbaby.com',
                    purchase_date: '2014-11-23T09:18:18Z',
                    purchase_amount: 8288.27
                }, {
                    id: '3cad078d-083b-416e-9dd4-2f1470c3458d',
                    name: 'Jack Simpson',
                    purchasor_email: 'jsimpson3@mayoclinic.com',
                    purchase_date: '2002-01-02T04:45:48Z',
                    purchase_amount: 1215.03
                }, {
                    id: 'ef7ff12c-90e5-4bfb-8fdd-9f20e4206afa',
                    name: 'Ernest Watson',
                    purchasor_email: 'ewatson4@nytimes.com',
                    purchase_date: '2002-01-02T04:45:48Z',
                    purchase_amount: 9455.16
                }, {
                    id: 'b243be08-6b9c-4ebd-bb8b-b59256ad4956',
                    name: 'Adam Castillo',
                    purchasor_email: 'acastillo5@dailymotion.com',
                    purchase_date: '2014-08-22T08:14:28Z',
                    purchase_amount: 9988.45
                }, {
                    id: 'a491adf5-8129-4f93-9442-98522fbd1e90',
                    name: 'Wayne Wilson',
                    purchasor_email: 'wwilson6@indiegogo.com',
                    purchase_date: '2012-03-07T22:16:08Z',
                    purchase_amount: 4563.87
                }, {
                    id: '497a6cca-5c9c-4b93-af8e-63c93de3eacf',
                    name: 'Roy Coleman',
                    purchasor_email: 'rcoleman7@independent.co.uk',
                    purchase_date: '2010-09-14T05:05:17Z',
                    purchase_amount: 4563.87
                }, {
                    id: 'ea34a698-fb86-44a5-b80e-57087d48737c',
                    name: 'Betty Diaz',
                    purchasor_email: 'bdiaz8@dropbox.com',
                    purchase_date: '2012-03-07T22:16:08Z',
                    purchase_amount: 7527.62
                }, {
                    id: 'c48e5e68-cae5-4a2e-96b2-8509fca19ddb',
                    name: 'Sharon Gardner',
                    purchasor_email: 'sgardner9@seesaa.net',
                    purchase_date: '2004-10-14T14:59:00Z',
                    purchase_amount: 1166.14
                }],

                selected: []
            }
        };
    },

    created: function created() {
        var _this = this;

        this.FETCH_CONTACTS().then(function () {
            _this.master_loading = false;
        });
    },


    components: {
        Bar: __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default.a,
        Checkbox: __WEBPACK_IMPORTED_MODULE_15__components_Toggles_checkbox_vue___default.a,
        Datatable: __WEBPACK_IMPORTED_MODULE_11__components_Datatable_datatable_vue___default.a,
        DatatableColumn: __WEBPACK_IMPORTED_MODULE_12__components_Datatable_datatable_column_vue___default.a,
        IconButton: __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default.a,
        Paginator: __WEBPACK_IMPORTED_MODULE_16__components_Paginator_paginator_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default.a,
        SideNavBar: __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default.a
    },
    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['contacts', 'theme']), {
        selectAll: {
            get: function get() {
                return this.customers.selected.length === this.customers.rows.length;
            },
            set: function set(value) {
                this.customers.selected = value ? this.customers.rows : [];
            }
        }
    }),
    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['CREATE_NEW_CONTACT', 'DELETE_CONTACT', 'EDIT_CONTACT', 'FETCH_CONTACTS', 'SET_CONTACT']), {
        onCreateNewContact: function onCreateNewContact() {
            var _this2 = this;

            this.CREATE_NEW_CONTACT({ path: 'contacts', creating_from_main: true }).then(function (res) {
                _this2.$router.push({ name: 'contact-editor' });
            });
        },
        contacts_to_array: function contacts_to_array(object) {
            return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(object);
        },
        editContact: function editContact(contact) {
            var _this3 = this;

            console.log('edit...');
            this.SET_CONTACT({ path: 'contacts' + '/' + contact.id }).then(function (res) {
                _this3.$router.push({ name: 'contact-editor', query: { id: contact.id } });
            });
        },
        deleteContact: function deleteContact(entity) {
            var _this4 = this;

            var result = window.confirm(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('You_are_about_to_delete') + ' "' + entity.complete_name + '". ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Continue_q'));

            if (result) {

                this.DELETE_CONTACT({
                    path: 'contacts' + '/' + entity.id,
                    key: entity.id
                }).then(function (res) {
                    //
                    _this4.master_loading = true;
                    _this4.FETCH_CONTACTS().then(function () {
                        _this4.master_loading = false;
                    });
                });
            }
        }
    }),

    /*
    watch: {
    contacts: {
    handler: function (val, oldVal) {
    console.log('a thing changed')
    },
    deep: true
    }
    },
    */

    head: {
        title: {
            //inner: Vue.i18n.translate('Contacts_Index')
            inner: 'Contacts Index'
        }
    }

});

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ContactsSearch_Index_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ContactsSearch_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ContactsSearch_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router_index_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Message_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'emailaddress-editor',

    mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins__["d" /* dateMixin */], __WEBPACK_IMPORTED_MODULE_3__mixins__["a" /* localStorageMixin */], __WEBPACK_IMPORTED_MODULE_3__mixins__["e" /* objectsMixin */]],

    data: function data() {
        return {
            loading: true,
            error: null,
            success_message: null,
            cancel_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cancel'),
            goback_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_back') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            save_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('go_back'),
            page_dirty_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('The_page_contains_unsaved_changes')
        };
    },

    created: function created() {
        this.loading = false;
    },


    components: {
        Bar: __WEBPACK_IMPORTED_MODULE_7__components_Bar_Index_vue___default.a,
        Message: __WEBPACK_IMPORTED_MODULE_10__components_Message_vue___default.a,
        IconButton: __WEBPACK_IMPORTED_MODULE_8__components_IconButton_Index_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_4__components_Spinner_vue___default.a
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['theme', 'currentLocale', 'emailaddress'])),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['SET_EMAILADDRESS_ADDRESS', 'SET_EMAILADDRESS_DESCRIPTION', 'UPDATE_EMAILADDRESS']), {

        set_emailaddress_address: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_EMAILADDRESS_ADDRESS(e.target.value);
        }, 1000),
        set_emailaddress_description: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_EMAILADDRESS_DESCRIPTION(e.target.value);
        }, 1000),
        onSaveCurrentEmailAddress: function onSaveCurrentEmailAddress() {
            this.UPDATE_EMAILADDRESS({
                object: this.emailaddress,
                path: this.emailaddress.path + '/' + this.emailaddress.id
            }).then(function (res) {
                __WEBPACK_IMPORTED_MODULE_9__router_index_js__["a" /* default */].go(-1);
            });
        },
        onGoBack: function onGoBack() {
            // console.log('yeah back')
            __WEBPACK_IMPORTED_MODULE_9__router_index_js__["a" /* default */].go(-1);
        }
    }),
    head: {
        title: {
            inner: 'Edit e-mail realestate'
        }
    }

});

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Datatable_datatable_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Datatable_datatable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Datatable_datatable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Datatable_datatable_column_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Datatable_datatable_column_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Datatable_datatable_column_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__aggregators_aggregators_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__formatters_formatters_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Toggles_checkbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Toggles_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_Toggles_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Paginator_paginator_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Paginator_paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_Paginator_paginator_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















// import DatatableCell from '../../../components/Datatable/datatable-cell.js'





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'entities-index',

    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins__["a" /* localStorageMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["e" /* objectsMixin */]],

    data: function data() {
        return {
            master_loading: true,
            filesOpen: false,
            fileOpen: false,
            reportOpen: false,
            error: null,
            filter_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type_here_to_filter_paginated_data'),
            new_entity_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_entity'),
            entities_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,

                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',

                columns: [{
                    id: 'bde_code',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Code') + ' BdE',
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'name',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Name'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'tin',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('TIN'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }],
                selected: []
            }
        };
    },

    created: function created() {
        var _this = this;

        this.FETCH_ENTITIES().then(function () {
            _this.master_loading = false;
        });
    },


    components: {
        Bar: __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default.a,
        Checkbox: __WEBPACK_IMPORTED_MODULE_15__components_Toggles_checkbox_vue___default.a,
        Datatable: __WEBPACK_IMPORTED_MODULE_11__components_Datatable_datatable_vue___default.a,
        DatatableColumn: __WEBPACK_IMPORTED_MODULE_12__components_Datatable_datatable_column_vue___default.a,
        IconButton: __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default.a,
        Paginator: __WEBPACK_IMPORTED_MODULE_16__components_Paginator_paginator_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default.a,
        SideNavBar: __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default.a
    },
    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['entities', 'theme'])),
    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['CREATE_NEW_ENTITY', 'DELETE_ENTITY', 'EDIT_ENTITY', 'FETCH_ENTITIES', 'SET_ENTITY']), {
        onCreateNewEntity: function onCreateNewEntity() {
            var _this2 = this;

            this.CREATE_NEW_ENTITY({ path: 'entities' }).then(function (res) {
                _this2.$router.push({ name: 'entity-editor' });
            });
        },
        editEntity: function editEntity(entity) {
            var _this3 = this;

            console.log('edit...');
            this.SET_ENTITY({ path: 'entities' + '/' + entity.id }).then(function (res) {
                _this3.$router.push({ name: 'entity-editor', query: { id: entity.id } });
            });
        },
        deleteEntity: function deleteEntity(entity) {
            var _this4 = this;

            var result = window.confirm(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('You_are_about_to_delete ') + entity.name + '. ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Continue_q'));

            if (result) {

                this.DELETE_ENTITY({
                    path: 'entities' + '/' + entity.id,
                    key: entity.id
                }).then(function (res) {
                    //
                    _this4.master_loading = true;
                    _this4.FETCH_ENTITIES().then(function () {
                        _this4.master_loading = false;
                    });
                });
            }
        }
    }),

    head: {
        title: {
            //inner: Vue.i18n.translate('Entities_Index')
            inner: 'Entities Index'
        }
    }

});

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_SuccessMessage_vue__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_SuccessMessage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_SuccessMessage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__aggregators_aggregators_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__formatters_formatters_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue__);
var _name$mixins$data$cre;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//























/* harmony default export */ __webpack_exports__["default"] = (_name$mixins$data$cre = {
    name: 'entity-editor',

    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins__["d" /* dateMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["a" /* localStorageMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["e" /* objectsMixin */]],

    data: function data() {
        return {
            master_loading: false,
            filesOpen: true,
            fileOpen: true,
            reportOpen: true,
            filter_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type_here_to_filter_paginated_data'),
            new_address_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_address'),
            new_email_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_email'),
            new_telephone_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_telephone_number'),
            cancel_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cancel'),
            goback_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_back') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            goup_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_up') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            save_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save'),
            save_and_go_up_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('go_up'),
            cad_ref_error_text_01: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cadastral_Reference_less_20_positions_error_text'),
            page_dirty_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('The_page_contains_unsaved_changes'),
            actions_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Actions'),
            value: null,
            ms_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Pick_an_option'),
            error: null,
            success_message: null
        };
    },

    created: function created() {},


    components: {
        Bar: __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default.a,
        Message: __WEBPACK_IMPORTED_MODULE_11__components_Message_vue___default.a,
        SuccessMessage: __WEBPACK_IMPORTED_MODULE_12__components_SuccessMessage_vue___default.a,
        IconButton: __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default.a,
        Checkbox: __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue___default.a,
        Datatable: __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue___default.a,
        DatatableColumn: __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue___default.a,
        Paginator: __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue___default.a,
        SideNavBar: __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default.a
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['theme', 'currentLocale', 'entity']))

}, _defineProperty(_name$mixins$data$cre, 'created', function created() {

    this.master_loading = false;
}), _defineProperty(_name$mixins$data$cre, 'methods', _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['SET_ENTITY_NAME', 'SET_ENTITY_TIN', 'SET_ENTITY_BDE_CODE', 'UPDATE_ENTITY']), {
    set_entity_name: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
        this.SET_ENTITY_NAME(e.target.value);
    }, 1000),
    set_entity_tin: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
        this.SET_ENTITY_TIN(e.target.value);
    }, 1000),
    set_entity_bde_code: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
        this.SET_ENTITY_BDE_CODE(e.target.value);
    }, 1000),
    onGoBack: function onGoBack() {
        // console.log('yeah back')
        __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].go(-1);
    },
    onSaveCurrentEntity: function onSaveCurrentEntity(data) {
        var _this = this;

        // console.log('entity.id: ')
        // console.log(this.entity.id)
        this.UPDATE_ENTITY({
            object: this.entity,
            path: 'entities' + '/' + this.entity.id
        }).then(function (res) {
            if (data.go_up) {
                _this.onGoUp();
            }
        });
    }
})), _defineProperty(_name$mixins$data$cre, 'head', {
    title: {
        //inner: Vue.i18n.translate('New_entity')
        inner: 'Edit entity'
    }
}), _name$mixins$data$cre);

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ContactsSearch_Index_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ContactsSearch_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_ContactsSearch_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_SideNavBar_Index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_SideNavBar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_SideNavBar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_SuccessMessage_vue__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_SuccessMessage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_SuccessMessage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__options_honorific_titles__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__options_person_types__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Datatable_datatable_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Datatable_datatable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_Datatable_datatable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Datatable_datatable_column_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Datatable_datatable_column_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Datatable_datatable_column_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__aggregators_aggregators_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__formatters_formatters_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Toggles_checkbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Toggles_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_Toggles_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Paginator_paginator_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Paginator_paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_Paginator_paginator_vue__);
var _name$mixins$data$cre;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



























/* harmony default export */ __webpack_exports__["default"] = (_name$mixins$data$cre = {
    name: 'appraisalfile-editor',

    mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins__["d" /* dateMixin */], __WEBPACK_IMPORTED_MODULE_5__mixins__["a" /* localStorageMixin */], __WEBPACK_IMPORTED_MODULE_5__mixins__["e" /* objectsMixin */]],

    data: function data() {
        return {
            master_loading: false,
            fileOpen: true,
            filter_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type_here_to_filter_paginated_data'),
            new_appraisalreport_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_appraisal_report'),
            new_appraisalquote_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_appraisal_quote'),
            new_appraisalinvoice_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_appraisal_invoice'),
            cancel_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cancel'),
            goback_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_back') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            goup_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_up') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            save_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save'),
            save_and_go_up_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('go_up'),
            cad_ref_error_text_01: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cadastral_Reference_less_20_positions_error_text'),
            page_dirty_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('The_page_contains_unsaved_changes'),
            actions_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Actions'),
            duplicate_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Duplicate'),
            edit_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Edit'),
            delete_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Delete'),
            value: null,
            ms_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Pick_an_option'),
            error: null,
            success_message: null,
            honorificTitleOptions: __WEBPACK_IMPORTED_MODULE_14__options_honorific_titles__["a" /* default */],
            personTypeOptions: __WEBPACK_IMPORTED_MODULE_15__options_person_types__["a" /* default */],
            appraisalreport_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [{
                    id: 'number',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Report_number'),
                    width: 14,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'version',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Version'),
                    width: 8,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'description',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Description'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'status',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Status'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'send_to_bde',
                    label: 'BdE',
                    width: 8,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'date_modified',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Last_modified'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format('DD/MM/YYYY HH:mm:ss');
                    }
                }],
                selected: []
            },
            appraisalquote_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [{
                    id: 'number',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quote_number'),
                    width: 14,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'version',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Version'),
                    width: 8,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'description',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Description'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'status',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Status'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'date_modified',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Last_modified'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format('DD/MM/YYYY HH:mm:ss');
                    }
                }],
                selected: []
            },
            appraisalinvoice_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [{
                    id: 'number',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Invoice_number'),
                    width: 14,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'version',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Version'),
                    width: 8,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'description',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Description'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'status',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Status'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'date_modified',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Last_modified'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format('DD/MM/YYYY HH:mm:ss');
                    }
                }],
                selected: []
            }
        };
    },

    created: function created() {},


    components: {
        Bar: __WEBPACK_IMPORTED_MODULE_9__components_Bar_Index_vue___default.a,
        Message: __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default.a,
        SuccessMessage: __WEBPACK_IMPORTED_MODULE_13__components_SuccessMessage_vue___default.a,
        IconButton: __WEBPACK_IMPORTED_MODULE_10__components_IconButton_Index_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_6__components_Spinner_vue___default.a,
        Checkbox: __WEBPACK_IMPORTED_MODULE_20__components_Toggles_checkbox_vue___default.a,
        Datatable: __WEBPACK_IMPORTED_MODULE_16__components_Datatable_datatable_vue___default.a,
        DatatableColumn: __WEBPACK_IMPORTED_MODULE_17__components_Datatable_datatable_column_vue___default.a,
        Paginator: __WEBPACK_IMPORTED_MODULE_21__components_Paginator_paginator_vue___default.a,
        SideNavBar: __WEBPACK_IMPORTED_MODULE_11__components_SideNavBar_Index_vue___default.a
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['theme', 'currentLocale', 'appraisalreport', 'appraisalquote', 'appraisalinvoice', 'appraisalfile', 'appraisalfile_appraisalreports', 'appraisalfile_appraisalquotes', 'appraisalfile_appraisalinvoices', 'stats_current']))

}, _defineProperty(_name$mixins$data$cre, 'created', function created() {
    var _this = this;

    this.FETCH_APPRAISALFILE_APPRAISALREPORTS({ path: 'appraisalfiles' + '/' + this.$route.query.id + '/' + 'appraisalreports' }).then(function () {
        _this.FETCH_APPRAISALFILE_APPRAISALQUOTES({ path: 'appraisalfiles' + '/' + _this.$route.query.id + '/' + 'appraisalquotes' }).then(function () {
            _this.FETCH_APPRAISALFILE_APPRAISALINVOICES({ path: 'appraisalfiles' + '/' + _this.$route.query.id + '/' + 'appraisalinvoices' }).then(function () {
                _this.FETCH_STATS_CURRENT({}).then(function () {
                    _this.master_loading = false;
                });
            });
        });
    });
}), _defineProperty(_name$mixins$data$cre, 'methods', _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['CREATE_NEW_APPRAISALREPORT', 'DELETE_APPRAISALREPORT', 'FETCH_APPRAISALFILE_APPRAISALREPORTS', 'RESET_APPRAISALREPORT', 'GET_APPRAISALREPORT', 'SET_APPRAISALREPORT', 'CREATE_NEW_APPRAISALQUOTE', 'DELETE_APPRAISALQUOTE', 'FETCH_APPRAISALFILE_APPRAISALQUOTES', 'RESET_APPRAISALQUOTE', 'GET_APPRAISALQUOTE', 'SET_APPRAISALQUOTE', 'CREATE_NEW_APPRAISALINVOICE', 'DELETE_APPRAISALINVOICE', 'FETCH_APPRAISALFILE_APPRAISALINVOICES', 'RESET_APPRAISALINVOICE', 'GET_APPRAISALINVOICE', 'SET_APPRAISALINVOICE', 'SET_APPRAISALFILE_DESCRIPTION', 'SET_APPRAISALFILE_NUMBER', 'UPDATE_APPRAISALFILE', 'UPDATE_APPRAISALREPORT', 'UPDATE_APPRAISALQUOTE', 'UPDATE_APPRAISALINVOICE', 'SET_VALUE', 'FETCH_STATS_CURRENT']), {

    set_appraisalfile_description: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
        this.SET_APPRAISALFILE_DESCRIPTION(e.target.value);
    }, 1000),
    set_appraisalfile_number: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
        this.SET_APPRAISALFILE_NUMBER(Number(e.target.value));
    }, 1000),

    onCreateNewAppraisalReport: function onCreateNewAppraisalReport() {
        var _this2 = this;

        this.master_loading = true;
        // console.log('hey')
        // console.log('appraisalfile: ')
        // console.log(this.appraisalfile)

        var appraisalreports_size = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(this.appraisalfile_appraisalreports);

        var new_reportnumber = 1;
        var new_versionnumber = 1;

        if (appraisalreports_size > 0) {

            var reportnumbers = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.reverse(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(this.appraisalfile_appraisalreports, 'number'));
            new_reportnumber = reportnumbers[0] + 1;
            // console.log('map reportnumbers: ')
            // console.log(reportnumbers)
        }

        var filenumber = '';
        filenumber = this.appraisalfile.number;

        var s = new_reportnumber + '';
        while (s.length < 2) {
            s = '0' + s;
        }var reportnumber = s;

        var p = new_versionnumber + '';
        while (p.length < 2) {
            p = '0' + p;
        }var reportversion = p;

        var fullnumber = filenumber + '/' + reportnumber + '/' + reportversion;

        this.RESET_APPRAISALREPORT().then(function (res) {
            _this2.CREATE_NEW_APPRAISALREPORT({
                path: 'appraisalreports' + '/',
                parent_path: 'appraisalfiles' + '/' + _this2.appraisalfile.id + '/' + 'appraisalreports' + '/',
                file_id: _this2.appraisalfile.id,
                number: new_reportnumber,
                version: new_versionnumber,
                full_number: fullnumber
            }).then(function (res) {
                _this2.$router.push({ name: 'appraisalreport-editor', query: { id: _this2.appraisalreport.id } });
            });
        });
    },
    checkCreateNewAppraisalReport: function checkCreateNewAppraisalReport() {
        var _this3 = this;

        this.onSaveCurrentAppraisalFile({ go_up: false });
        /*
        if(this.appraisalfile.dirty){
            const result = window.confirm(Vue.i18n.translate('There_are_unsaved_changes') + '. ' + Vue.i18n.translate('Unsaved_data_will_be_lost') + '. ' + Vue.i18n.translate('Continue_q'))
            if (result) {
                this.onCreateNewAppraisalReport()
            }
        }else{
            this.onCreateNewAppraisalReport()
        }*/
        // save appraisalfile before creating new appraisalreport
        this.UPDATE_APPRAISALFILE({
            object: this.appraisalfile,
            path: 'appraisalfiles' + '/' + this.appraisalfile.id
        }).then(function (res) {
            _this3.onCreateNewAppraisalReport();
        });
    },
    duplicateAppraisalReport: function duplicateAppraisalReport(entity) {
        var _this4 = this;

        this.master_loading = true;

        var new_versionnumber = entity.version + 1;

        this.RESET_APPRAISALREPORT().then(function (res) {
            _this4.CREATE_NEW_APPRAISALREPORT({
                path: 'appraisalreports' + '/',
                parent_path: 'appraisalfiles' + '/' + _this4.appraisalfile.id + '/' + 'appraisalreports' + '/',
                file_id: _this4.appraisalfile.id,
                number: entity.number,
                version: new_versionnumber
            }).then(function (res) {

                console.log('duplicateAppraisalReport then res:');
                console.log(res);

                var new_object_id = res.key;
                var new_object_version = new_versionnumber;

                _this4.GET_APPRAISALREPORT({ path: 'appraisalreports' + '/' + entity.id }).then(function (res) {

                    console.log(' *^*^*^*^*^*^*^*^*^*^get appraisal report res: ');
                    console.log(res);

                    var new_object = res;
                    new_object.id = new_object_id;
                    new_object.version = new_object_version;

                    _this4.UPDATE_APPRAISALREPORT({
                        object: new_object,
                        path: 'appraisalreports/',
                        parent_path: 'appraisalfiles' + '/' + _this4.appraisalfile.id + '/' + 'appraisalreports' + '/',
                        key: new_object_id
                    }).then(function (res) {

                        _this4.master_loading = true;
                        _this4.FETCH_APPRAISALFILE_APPRAISALREPORTS({ path: 'appraisalfiles' + '/' + _this4.$route.query.id + '/' + 'appraisalreports' }).then(function () {
                            _this4.master_loading = false;
                        });
                    });
                });
            });
        });
    },
    onCreateNewAppraisalQuote: function onCreateNewAppraisalQuote() {
        var _this5 = this;

        this.master_loading = true;
        // console.log('hey')
        // console.log('appraisalfile: ')
        // console.log(this.appraisalfile)

        var appraisalquotes_size = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(this.appraisalfile_appraisalquotes);

        var new_quotenumber = 1;
        var new_versionnumber = 1;

        if (appraisalquotes_size > 0) {

            var quotenumbers = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.reverse(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(this.appraisalfile_appraisalquotes, 'number'));
            new_quotenumber = quotenumbers[0] + 1;
            // console.log('map quotenumbers: ')
            // console.log(quotenumbers)
        }

        var filenumber = '';
        filenumber = this.appraisalfile.number;

        var s = new_quotenumber + '';
        while (s.length < 2) {
            s = '0' + s;
        }var quotenumber = s;

        var p = new_versionnumber + '';
        while (p.length < 2) {
            p = '0' + p;
        }var quoteversion = p;

        var fullnumber = filenumber + '/' + quotenumber + '/' + quoteversion;

        this.RESET_APPRAISALQUOTE().then(function (res) {
            _this5.CREATE_NEW_APPRAISALQUOTE({
                path: 'appraisalquotes' + '/',
                parent_path: 'appraisalfiles' + '/' + _this5.appraisalfile.id + '/' + 'appraisalquotes' + '/',
                file_id: _this5.appraisalfile.id,
                number: new_quotenumber,
                version: new_versionnumber,
                full_number: fullnumber
            }).then(function (res) {
                _this5.$router.push({ name: 'appraisalquote-editor', query: { id: _this5.appraisalquote.id } });
            });
        });
    },
    checkCreateNewAppraisalQuote: function checkCreateNewAppraisalQuote() {
        this.onSaveCurrentAppraisalFile({ go_up: false });
        this.onCreateNewAppraisalQuote();

        /*
        if (this.appraisalfile.dirty) {
            const result = window.confirm(Vue.i18n.translate('There_are_unsaved_changes') + '. ' + Vue.i18n.translate('Unsaved_data_will_be_lost') + '. ' + Vue.i18n.translate('Continue_q'))
            if (result) {
                this.onCreateNewAppraisalQuote()
            }
        } else {
            this.onCreateNewAppraisalQuote()
        }
        */
    },
    duplicateAppraisalQuote: function duplicateAppraisalQuote(entity) {
        var _this6 = this;

        this.master_loading = true;

        var new_versionnumber = entity.version + 1;

        var filenumber = '';
        filenumber = this.appraisalfile.number;

        var s = this.appraisalquote.number + '';
        while (s.length < 2) {
            s = '0' + s;
        }var quotenumber = s;

        var p = new_versionnumber + '';
        while (p.length < 2) {
            p = '0' + p;
        }var quoteversion = p;

        var fullnumber = filenumber + '/' + quotenumber + '/' + quoteversion;

        this.RESET_APPRAISALQUOTE().then(function (res) {
            _this6.CREATE_NEW_APPRAISALQUOTE({
                path: 'appraisalquotes' + '/',
                parent_path: 'appraisalfiles' + '/' + _this6.appraisalfile.id + '/' + 'appraisalquotes' + '/',
                file_id: _this6.appraisalfile.id,
                number: entity.number,
                version: new_versionnumber,
                full_number: fullnumber
            }).then(function (res) {

                console.log('duplicateAppraisalQuote then res:');
                console.log(res);

                var new_object_id = res.key;
                var new_object_version = new_versionnumber;

                _this6.GET_APPRAISALQUOTE({ path: 'appraisalquotes' + '/' + entity.id }).then(function (res) {

                    console.log(' *^*^*^*^*^*^*^*^*^*^get appraisal quote res: ');
                    console.log(res);

                    var new_object = res;
                    new_object.id = new_object_id;
                    new_object.version = new_object_version;

                    _this6.UPDATE_APPRAISALQUOTE({
                        object: new_object,
                        path: 'appraisalquotes/',
                        parent_path: 'appraisalfiles' + '/' + _this6.appraisalfile.id + '/' + 'appraisalquotes' + '/',
                        key: new_object_id
                    }).then(function (res) {

                        _this6.master_loading = true;
                        _this6.FETCH_APPRAISALFILE_APPRAISALQUOTES({ path: 'appraisalfiles' + '/' + _this6.$route.query.id + '/' + 'appraisalquotes' }).then(function () {
                            _this6.master_loading = false;
                        });
                    });
                });
            });
        });
    },
    onCreateNewAppraisalInvoice: function onCreateNewAppraisalInvoice() {
        var _this7 = this;

        this.master_loading = true;
        // console.log('hey')
        // console.log('appraisalfile: ')
        // console.log(this.appraisalfile)

        var appraisalinvoices_size = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(this.appraisalfile_appraisalinvoices);

        var stats_current = this.stats_current;

        var fiscal_number = 0;

        if (!stats_current) {
            var pre = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YY');
            fiscal_number = pre.toString() + '0000';
            fiscal_number = Number(fiscal_number);
            stats_current = {
                'last_invoice_fiscal_number': 0
            };
        }

        fiscal_number = stats_current.last_invoice_fiscal_number + 1;

        console.log('new fiscal number: ');
        console.log(fiscal_number);

        stats_current['last_invoice_fiscal_number'] = fiscal_number;

        console.log('stats_current: ');
        console.log(stats_current);

        var new_invoicenumber = 1;
        var new_versionnumber = 1;

        if (appraisalinvoices_size > 0) {

            var invoicenumbers = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.reverse(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(this.appraisalfile_appraisalinvoices, 'number'));
            new_invoicenumber = invoicenumbers[0] + 1;
            // console.log('map invoicenumbers: ')
            // console.log(invoicenumbers)
        }

        var filenumber = '';
        filenumber = this.appraisalfile.number;

        var s = new_invoicenumber + '';
        while (s.length < 2) {
            s = '0' + s;
        }var invoicenumber = s;

        var p = new_versionnumber + '';
        while (p.length < 2) {
            p = '0' + p;
        }var invoiceversion = p;

        var fullnumber = filenumber + '/' + invoicenumber + '/' + invoiceversion;

        this.RESET_APPRAISALINVOICE().then(function (res) {
            _this7.CREATE_NEW_APPRAISALINVOICE({
                path: 'appraisalinvoices' + '/',
                parent_path: 'appraisalfiles' + '/' + _this7.appraisalfile.id + '/' + 'appraisalinvoices' + '/',
                file_id: _this7.appraisalfile.id,
                number: new_invoicenumber,
                version: new_versionnumber,
                full_number: fullnumber,
                fiscal_number: fiscal_number
            }).then(function (res) {
                _this7.SET_VALUE({
                    path: 'stats/current',
                    object: stats_current
                });
                _this7.$router.push({
                    name: 'appraisalinvoice-editor',
                    query: { id: _this7.appraisalinvoice.id, file_id: _this7.appraisalfile.id }
                });
            });
        });
    },
    checkCreateNewAppraisalInvoice: function checkCreateNewAppraisalInvoice() {
        this.onSaveCurrentAppraisalFile({ go_up: false });
        this.onCreateNewAppraisalInvoice();
        /*
                     if (this.appraisalfile.dirty) {
                        const result = window.confirm(Vue.i18n.translate('There_are_unsaved_changes') + '. ' + Vue.i18n.translate('Unsaved_data_will_be_lost') + '. ' + Vue.i18n.translate('Continue_q'))
                        if (result) {
                            this.onCreateNewAppraisalInvoice()
                        }
                    } else {
                        this.onCreateNewAppraisalInvoice()
                    }
                    */
    },
    duplicateAppraisalInvoice: function duplicateAppraisalInvoice(entity) {
        var _this8 = this;

        this.master_loading = true;

        var new_versionnumber = entity.version + 1;

        var filenumber = '';
        filenumber = this.appraisalfile.number;

        var s = entity.number + '';
        while (s.length < 2) {
            s = '0' + s;
        }var invoicenumber = s;

        var p = new_versionnumber + '';
        while (p.length < 2) {
            p = '0' + p;
        }var invoiceversion = p;

        var fullnumber = filenumber + '/' + invoicenumber + '/' + invoiceversion;

        this.RESET_APPRAISALINVOICE().then(function (res) {
            _this8.CREATE_NEW_APPRAISALINVOICE({
                path: 'appraisalinvoices' + '/',
                parent_path: 'appraisalfiles' + '/' + _this8.appraisalfile.id + '/' + 'appraisalinvoices' + '/',
                file_id: _this8.appraisalfile.id,
                number: entity.number,
                version: new_versionnumber,
                full_number: fullnumber
            }).then(function (res) {

                console.log('duplicateAppraisalInvoice then res:');
                console.log(res);

                var new_object_id = res.key;
                var new_object_version = new_versionnumber;

                _this8.GET_APPRAISALINVOICE({ path: 'appraisalinvoices' + '/' + entity.id }).then(function (res) {

                    console.log(' *^*^*^*^*^*^*^*^*^*^get appraisal invoice res: ');
                    console.log(res);

                    var new_object = res;
                    new_object.id = new_object_id;
                    new_object.version = new_object_version;

                    _this8.UPDATE_APPRAISALINVOICE({
                        object: new_object,
                        path: 'appraisalinvoices/',
                        parent_path: 'appraisalfiles' + '/' + _this8.appraisalfile.id + '/' + 'appraisalinvoices' + '/',
                        key: new_object_id
                    }).then(function (res) {

                        _this8.master_loading = true;
                        _this8.FETCH_APPRAISALFILE_APPRAISALINVOICES({ path: 'appraisalfiles' + '/' + _this8.$route.query.id + '/' + 'appraisalinvoices' }).then(function () {
                            _this8.master_loading = false;
                        });
                    });
                });
            });
        });
    },
    editAppraisalInvoice: function editAppraisalInvoice(entity) {
        var _this9 = this;

        this.SET_APPRAISALINVOICE({ path: 'appraisalinvoices' + '/' + entity.id }).then(function (res) {
            _this9.$router.push({
                name: 'appraisalinvoice-editor',
                query: { id: entity.id, file_id: _this9.appraisalfile.id }
            });
        });
    },
    checkEditAppraisalInvoice: function checkEditAppraisalInvoice(entity) {
        if (this.appraisalfile.dirty) {
            var result = window.confirm(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('There_are_unsaved_changes') + '. ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Unsaved_data_will_be_lost') + '. ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Continue_q'));
            if (result) {
                this.editAppraisalInvoice(entity);
            }
        } else {
            this.editAppraisalInvoice(entity);
        }
    },
    deleteAppraisalInvoice: function deleteAppraisalInvoice(entity) {
        var _this10 = this;

        var result = window.confirm(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('You_are_about_to_delete') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('invoice') + ' "' + entity.file_number + '/' + entity.number + '/' + entity.version + '". ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Continue_q'));

        if (result) {

            this.DELETE_APPRAISALINVOICE({
                file_id: this.appraisalfile.id,
                path: 'appraisalinvoices' + '/' + entity.id,
                key: entity.id,
                parent_path: 'appraisalfiles' + '/' + this.appraisalfile.id + '/' + 'appraisalinvoices' + '/' + entity.id
            }).then(function (res) {
                //
                _this10.master_loading = true;
                _this10.FETCH_APPRAISALFILE_APPRAISALINVOICES({ path: 'appraisalfiles' + '/' + _this10.$route.query.id + '/' + 'appraisalinvoices' }).then(function () {
                    _this10.master_loading = false;
                });
            });
        }
    },
    onGoBack: function onGoBack() {
        __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].go(-1);
    },
    onGoUp: function onGoUp() {
        this.$router.push({ name: 'appraisalfiles-index' });
    },
    onSaveCurrentAppraisalFile: function onSaveCurrentAppraisalFile(data) {
        var _this11 = this;

        console.log('appraisalfile.id: ');
        console.log(this.appraisalfile.id);
        this.UPDATE_APPRAISALFILE({
            object: this.appraisalfile,
            path: 'appraisalfiles' + '/' + this.appraisalfile.id
        }).then(function (res) {
            if (data.go_up) {
                _this11.onGoUp();
            }
        });
    },
    editAppraisalReport: function editAppraisalReport(entity) {
        var _this12 = this;

        this.SET_APPRAISALREPORT({ path: 'appraisalreports' + '/' + entity.id }).then(function (res) {
            _this12.$router.push({ name: 'appraisalreport-editor', query: { id: entity.id } });
        });
    },
    checkEditAppraisalReport: function checkEditAppraisalReport(entity) {
        if (this.appraisalfile.dirty) {
            var result = window.confirm(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('There_are_unsaved_changes') + '. ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Unsaved_data_will_be_lost') + '. ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Continue_q'));
            if (result) {
                this.editAppraisalReport(entity);
            }
        } else {
            this.editAppraisalReport(entity);
        }
    },
    deleteAppraisalReport: function deleteAppraisalReport(entity) {
        var _this13 = this;

        var result = window.confirm(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('You_are_about_to_delete') + entity.filenumber + ', ' + entity.filedescription + '. ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Continue_q'));

        if (result) {

            this.DELETE_APPRAISALREPORT({
                file_id: this.appraisalfile.id,
                path: 'appraisalreports' + '/' + entity.id,
                key: entity.id,
                parent_path: 'appraisalfiles' + '/' + this.appraisalfile.id + '/' + 'appraisalreports' + '/' + entity.id
            }).then(function (res) {
                //
                _this13.master_loading = true;
                _this13.FETCH_APPRAISALFILE_APPRAISALREPORTS({ path: 'appraisalfiles' + '/' + _this13.$route.query.id + '/' + 'appraisalreports' }).then(function () {
                    _this13.master_loading = false;
                });
            });
        }
    },
    editAppraisalQuote: function editAppraisalQuote(entity) {
        var _this14 = this;

        this.SET_APPRAISALQUOTE({ path: 'appraisalquotes' + '/' + entity.id }).then(function (res) {
            _this14.$router.push({ name: 'appraisalquote-editor', query: { id: entity.id } });
        });
    },
    checkEditAppraisalQuote: function checkEditAppraisalQuote(entity) {
        if (this.appraisalfile.dirty) {
            var result = window.confirm(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('There_are_unsaved_changes') + '. ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Unsaved_data_will_be_lost') + '. ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Continue_q'));
            if (result) {
                this.editAppraisalQuote(entity);
            }
        } else {
            this.editAppraisalQuote(entity);
        }
    },
    deleteAppraisalQuote: function deleteAppraisalQuote(entity) {
        var _this15 = this;

        var result = window.confirm(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('You_are_about_to_delete') + entity.filenumber + ', ' + entity.filedescription + '. ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Continue_q'));

        if (result) {

            this.DELETE_APPRAISALQUOTE({
                file_id: this.appraisalfile.id,
                path: 'appraisalquotes' + '/' + entity.id,
                key: entity.id,
                parent_path: 'appraisalfiles' + '/' + this.appraisalfile.id + '/' + 'appraisalquotes' + '/' + entity.id
            }).then(function (res) {
                //
                _this15.master_loading = true;
                _this15.FETCH_APPRAISALFILE_APPRAISALQUOTES({ path: 'appraisalfiles' + '/' + _this15.$route.query.id + '/' + 'appraisalquotes' }).then(function () {
                    _this15.master_loading = false;
                });
            });
        }
    }
})), _defineProperty(_name$mixins$data$cre, 'head', {
    title: {
        //inner: Vue.i18n.translate('New_appraisalfile')
        inner: 'Edit Appraisal-File'
    }
}), _name$mixins$data$cre);

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ContactsSearch_Index_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ContactsSearch_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_ContactsSearch_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_SideNavBar_Index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_SideNavBar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_SideNavBar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Datatable_datatable_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Datatable_datatable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Datatable_datatable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_column_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_column_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_column_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__aggregators_aggregators_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__formatters_formatters_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Toggles_checkbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Toggles_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_Toggles_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Paginator_paginator_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Paginator_paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Paginator_paginator_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'appraisalfiles-index',

    mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins__["a" /* localStorageMixin */]],

    data: function data() {
        return {
            master_loading: true,
            filesOpen: true,
            filter_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type_here_to_filter_paginated_data'),
            new_appraisalfile_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_appraisal_file'),
            appraisalfile_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [{
                    id: 'number',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('File_number'),
                    width: 12,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'description',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('File_description'),
                    width: 30,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'date_modified',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Last_modified'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format('DD/MM/YYYY HH:mm:ss');
                    }
                }],
                selected: []
            }

        };
    },

    created: function created() {
        var _this = this;

        this.FETCH_APPRAISALFILES().then(function () {
            _this.master_loading = false;
        });
    },


    components: {
        Bar: __WEBPACK_IMPORTED_MODULE_9__components_Bar_Index_vue___default.a,
        Checkbox: __WEBPACK_IMPORTED_MODULE_16__components_Toggles_checkbox_vue___default.a,
        Datatable: __WEBPACK_IMPORTED_MODULE_12__components_Datatable_datatable_vue___default.a,
        DatatableColumn: __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_column_vue___default.a,
        IconButton: __WEBPACK_IMPORTED_MODULE_10__components_IconButton_Index_vue___default.a,
        Paginator: __WEBPACK_IMPORTED_MODULE_17__components_Paginator_paginator_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_6__components_Spinner_vue___default.a,
        SideNavBar: __WEBPACK_IMPORTED_MODULE_11__components_SideNavBar_Index_vue___default.a
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['appraisalfiles', 'theme'])),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['CREATE_NEW_APPRAISALFILE', 'DELETE_APPRAISALFILE', 'EDIT_APPRAISALFILE', 'FETCH_APPRAISALFILES', 'SET_APPRAISALFILE']), {
        onCreateNewAppraisalFile: function onCreateNewAppraisalFile() {
            var _this2 = this;

            this.master_loading = true;

            var appraisalfiles_size = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(this.appraisalfiles);

            var new_filenumber = 13936;

            if (appraisalfiles_size > 0) {

                var filenumbers = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.reverse(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(this.appraisalfiles, 'number'));
                new_filenumber = filenumbers[0] + 1;
                console.log('map filenumbers: ');
                console.log(filenumbers);
            }
            this.CREATE_NEW_APPRAISALFILE({
                path: 'appraisalfiles',
                number: new_filenumber,
                size: appraisalfiles_size
            }).then(function (res) {
                _this2.$router.push({ name: 'appraisalfile-editor' });
            });
        },
        appraisalfiles_to_array: function appraisalfiles_to_array(object) {
            return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(object);
        },
        editAppraisalFile: function editAppraisalFile(entity) {
            var _this3 = this;

            console.log('edit...');
            this.SET_APPRAISALFILE({ path: 'appraisalfiles' + '/' + entity.id }).then(function (res) {
                _this3.$router.push({ name: 'appraisalfile-editor', query: { id: entity.id } });
            });
        },
        deleteAppraisalFile: function deleteAppraisalFile(entity) {
            var _this4 = this;

            var result = window.confirm(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('You_are_about_to_delete') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('file') + ' "' + entity.number + '". ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Continue_q'));

            if (result) {

                this.DELETE_APPRAISALFILE({
                    path: 'appraisalfiles' + '/' + entity.id,
                    key: entity.id,
                    appraisalreports: entity.appraisalreports
                }).then(function (res) {
                    //
                    _this4.master_loading = true;
                    _this4.FETCH_APPRAISALFILES().then(function () {
                        _this4.master_loading = false;
                    });
                });
            }
        },
        goToFile: function goToFile(key) {
            var _this5 = this;

            this.SET_APPRAISALFILE({ path: 'appraisalfiles' + '/' + key }).then(function (res) {
                _this5.$router.push({ name: 'appraisalfile-editor', query: { id: key } });
            });
        }
    }),

    head: {
        title: {
            inner: 'Appraisal-Files Index'
        }
    }

});

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html2canvas__ = __webpack_require__(1157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ContactsSearch_Index_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ContactsSearch_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_ContactsSearch_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_SideNavBar_Index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_SideNavBar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_SideNavBar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__router_index_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__options_conservation_statuses__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__options_property_types__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__options_ad_types__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__options_quality_of_neighbourhood__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__options_quality_of_situation__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__options_quality_of_construction__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__options_quality_of_realestate__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__options_quality_levels__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__options_quality_masc_levels__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__options_trends__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__options_terms__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__options_volatility_types__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__options_conjunctures__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_Datatable_datatable_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_Datatable_datatable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_Datatable_datatable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_Datatable_datatable_column_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_Datatable_datatable_column_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_Datatable_datatable_column_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_Toggles_checkbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_Toggles_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_Toggles_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_Paginator_paginator_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_Paginator_paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_Paginator_paginator_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _this = this;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








































/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'marketstudy-editor',

    mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins__["h" /* appraisalCalcMixin */], __WEBPACK_IMPORTED_MODULE_5__mixins__["d" /* dateMixin */], __WEBPACK_IMPORTED_MODULE_5__mixins__["i" /* geohashMixin */], __WEBPACK_IMPORTED_MODULE_5__mixins__["a" /* localStorageMixin */], __WEBPACK_IMPORTED_MODULE_5__mixins__["f" /* mathMixin */], __WEBPACK_IMPORTED_MODULE_5__mixins__["e" /* objectsMixin */], __WEBPACK_IMPORTED_MODULE_5__mixins__["g" /* typeCheckMixin */]],

    data: function data() {
        return {
            master_loading: true,
            query_comparables_loading: false,
            filesOpen: true,
            fileOpen: true,
            reportOpen: true,
            editabletrue: true,
            error: null,
            success_message: null,
            queryAdTypeValue: null,
            importAppraisalFileValue: null,
            importReportValue: null,
            importRealEstateValue: null,
            importMarketStudyValue: null,
            comparables_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Comparables'),
            homogenisation_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Homogenisation'),
            marketstudy_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Market_study'),
            regressionline_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Regression_line'),
            metadata_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Version'),
            filter_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type_here_to_filter_paginated_data'),
            calc_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Calculate_values'),
            cancel_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cancel'),
            goback_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_back') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            goup_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_up') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            save_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save'),
            import_comparable_set_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Import_comparable_set'),
            save_and_go_up_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('go_up'),
            appraisal_adopted_area_error_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Appraisal_adopted_area_missing_error_text'),
            appraisal_property_type_error_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Appraisal_property_type_missing_error_text'),
            property_type_error_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Property_type_missing_error_text'),
            adopted_area_error_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Adopted_area_missing_error_text'),
            adopted_age_error_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Adopted_age_missing_error_text'),
            adopted_age_length_error_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Adopted_age_length_error_text'),
            lat_lng_error_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Lat_lng_missing_error_text'),
            query_date_error_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Date_missing_error_text'),
            query_ad_type_error_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Ad_type_missing_error_text'),
            page_dirty_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('The_page_contains_unsaved_changes'),
            actions_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Actions'),
            choose_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_to_comparables_list'),
            duplicate_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Duplicate'),
            edit_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Edit'),
            delete_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Delete'),
            discard_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Discard'),
            openlink_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Open_link_in_new_tab'),
            conservation_statusOptions: __WEBPACK_IMPORTED_MODULE_14__options_conservation_statuses__["a" /* default */],
            queryAdTypeOptions: __WEBPACK_IMPORTED_MODULE_16__options_ad_types__["a" /* default */],
            quality_of_neighbourhoodOptions: __WEBPACK_IMPORTED_MODULE_17__options_quality_of_neighbourhood__["a" /* default */],
            quality_of_situationOptions: __WEBPACK_IMPORTED_MODULE_18__options_quality_of_situation__["a" /* default */],
            quality_of_constructionOptions: __WEBPACK_IMPORTED_MODULE_19__options_quality_of_construction__["a" /* default */],
            quality_of_realestateOptions: __WEBPACK_IMPORTED_MODULE_20__options_quality_of_realestate__["a" /* default */],
            property_typeOptions: __WEBPACK_IMPORTED_MODULE_15__options_property_types__["a" /* default */],
            quality_levelOptions: __WEBPACK_IMPORTED_MODULE_21__options_quality_levels__["a" /* default */],
            quality_level_mascOptions: __WEBPACK_IMPORTED_MODULE_22__options_quality_masc_levels__["a" /* default */],
            trendOptions: __WEBPACK_IMPORTED_MODULE_23__options_trends__["a" /* default */],
            termOptions: __WEBPACK_IMPORTED_MODULE_24__options_terms__["a" /* default */],
            volatility_typeOptions: __WEBPACK_IMPORTED_MODULE_25__options_volatility_types__["a" /* default */],
            conjunctureOptions: __WEBPACK_IMPORTED_MODULE_26__options_conjunctures__["a" /* default */],
            conservation_statusValue: null,
            countryValue: null,
            municipalityValue: null,
            provinceValue: null,
            property_typeValue: null,
            quality_of_neighbourhoodValue: null,
            quality_of_situationValue: null,
            quality_of_constructionValue: null,
            quality_of_realestateValue: null,
            appraisal_conservation_statusValue: null,
            appraisal_provinceValue: null,
            appraisal_property_typeValue: null,
            appraisal_quality_of_neighbourhoodValue: null,
            appraisal_quality_of_situationValue: null,
            appraisal_quality_of_constructionValue: null,
            appraisal_quality_of_realestateValue: null,
            offer_productionValue: null,
            offer_yearly_stockValue: null,
            offer_trendValue: null,
            demand_levelValue: null,
            demand_speed_of_salesValue: null,
            demand_trendValue: null,
            prices_expectancyValue: null,
            prices_past_cicles_volatilityValue: null,
            market_conjunctureValue: null,
            market_value_reduction_probability_expectancyValue: null,
            ad_date_colwidth: '100px',
            property_type_colwidth: '80px',
            distance_colwidth: '100px',
            formatted_address_colwidth: '400px',
            floor_colwidth: '160px',
            adopted_area_colwidth: '80px',
            offer_price_colwidth: '120px',
            offer_unit_price_colwidth: '120px',
            conservation_status_colwidth: '80px',
            bathrooms_colwidth: '80px',
            rooms_colwidth: '80px',
            lift_colwidth: '80px',
            contact_phone_colwidth: '120px',
            contact_name_colwidth: '360px',
            notes_1_colwidth: '3000px',
            notes_2_colwidth: '3000px',
            appraisal_tabulation: [],
            ad_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [{
                    id: 'ad_date',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Date'),
                    width: '100px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'property_type',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Typology'),
                    width: '160px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'distance',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Distance'),
                    width: '100px',
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 3, 'KM');
                    }
                }, {
                    id: 'google_formatted_address',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Address'),
                    width: '400px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'floor',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Floor'),
                    width: '160px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'adopted_area',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Area'),
                    width: '80px',
                    sortable: true,
                    groupable: false,
                    aggregators: [__WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].max, __WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].average, __WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].median, __WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].min],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 0, 'M2');
                    }
                }, {
                    id: 'offer_price',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Price'),
                    width: '120px',
                    sortable: true,
                    groupable: false,
                    aggregators: [__WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].max, __WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].average, __WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].median, __WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].min],
                    alignment: 'right',
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 0, 'EUR');
                    }
                }, {
                    id: 'offer_unit_price',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Unit_price'),
                    width: '120px',
                    sortable: true,
                    groupable: false,
                    aggregators: [__WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].max, __WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].average, __WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].median, __WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].min],
                    alignment: 'right',
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 0, 'EUR_M2');
                    }
                }, {
                    id: 'offer_price_reduction_pct',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Reduction_pct'),
                    width: '120px',
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    alignment: 'right',
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(Number(value) * 100, 0, 'PCT');
                    }
                }, {
                    id: 'estimated_sale_price',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Estimated_sale_price'),
                    width: '120px',
                    sortable: true,
                    groupable: false,
                    aggregators: [__WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].max, __WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].average, __WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].median, __WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].min],
                    alignment: 'right',
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 0, 'EUR');
                    }
                }, {
                    id: 'estimated_unit_sale_price',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Estimated_unit_sale_price'),
                    width: '120px',
                    sortable: true,
                    groupable: false,
                    aggregators: [__WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].max, __WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].average, __WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].median, __WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].min],
                    alignment: 'right',
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 0, 'EUR_M2');
                    }
                }, {
                    id: 'conservation_status',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Conservation'),
                    width: '160px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'bathrooms_number',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Bathrooms'),
                    width: '80px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'bedrooms_number',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Bedrooms'),
                    width: '80px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'lift',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Lift'),
                    width: '80px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'contact_phone',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Telephone'),
                    width: '120px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'contact_name',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Contact'),
                    width: '360px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'notes_1',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Notes') + ' 1',
                    width: '3000px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'notes_2',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Notes') + ' 2',
                    width: '3000px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }],
                selected: []
            },
            comparable_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [{
                    id: 'ad_date',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Date'),
                    width: '100px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'property_type',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Typology'),
                    width: '160px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'distance',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Distance'),
                    width: '100px',
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 3, 'KM');
                    }
                }, {
                    id: 'google_formatted_address',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Address'),
                    width: '400px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'floor',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Floor'),
                    width: '160px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'adopted_area',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Area'),
                    width: '80px',
                    sortable: true,
                    groupable: false,
                    aggregators: [__WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].max, __WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].average, __WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].median, __WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].min],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 0, 'M2');
                    }
                }, {
                    id: 'offer_price',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Price'),
                    width: '120px',
                    sortable: true,
                    groupable: false,
                    aggregators: [__WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].max, __WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].average, __WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].median, __WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].min],
                    alignment: 'right',
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 0, 'EUR');
                    }
                }, {
                    id: 'offer_unit_price',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Unit_price'),
                    width: '120px',
                    sortable: true,
                    groupable: false,
                    aggregators: [__WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].max, __WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].average, __WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].median, __WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].min],
                    alignment: 'right',
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 0, 'EUR_M2');
                    }
                }, {
                    id: 'offer_price_reduction_pct',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Reduction_pct'),
                    width: '120px',
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    alignment: 'right',
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(Number(value) * 100, 0, 'PCT');
                    }
                }, {
                    id: 'estimated_sale_price',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Estimated_sale_price'),
                    width: '120px',
                    sortable: true,
                    groupable: false,
                    aggregators: [__WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].max, __WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].average, __WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].median, __WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].min],
                    alignment: 'right',
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 0, 'EUR');
                    }
                }, {
                    id: 'estimated_unit_sale_price',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Estimated_unit_sale_price'),
                    width: '120px',
                    sortable: true,
                    groupable: false,
                    aggregators: [__WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].max, __WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].average, __WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].median, __WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].min],
                    alignment: 'right',
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 0, 'EUR_M2');
                    }
                }, {
                    id: 'conservation_status',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Conservation'),
                    width: '160px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'bathrooms_number',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Bathrooms'),
                    width: '80px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'bedrooms_number',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Bedrooms'),
                    width: '80px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'lift',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Lift'),
                    width: '80px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'contact_phone',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Telephone'),
                    width: '120px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'contact_name',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Contact'),
                    width: '360px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'notes_1',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Notes') + ' 1',
                    width: '3000px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'notes_2',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Notes') + ' 2',
                    width: '3000px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }],
                selected: []
            },
            tabulation_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [{
                    id: 'ad_date',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Date'),
                    width: '100px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'property_type',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Typology'),
                    width: '200px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'quality_of_neighbourhood',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quality_of_neighbourhood'),
                    width: '200px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'quality_of_situation',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quality_of_situation'),
                    width: '200px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'quality_of_construction',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quality_of_construction'),
                    width: '200px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'quality_of_realestate',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quality_of_realestate'),
                    width: '200px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'adopted_age',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Adopted_age'),
                    width: '180px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'conservation_status',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Conservation_status'),
                    width: '200px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'floor_number',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Height_situation'),
                    width: '160px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'adopted_area',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Adopted_area') + ' (m²)',
                    width: '200px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'lift',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Lift'),
                    width: '100px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }],
                selected: []
            },
            comparison_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [{
                    id: 'comp_ad_date',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Date'),
                    width: '100px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'comp_property_type',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Typology'),
                    width: '200px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'comp_quality_of_neighbourhood',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quality_of_neighbourhood'),
                    width: '200px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'comp_quality_of_situation',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quality_of_situation'),
                    width: '200px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'comp_quality_of_construction',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quality_of_construction'),
                    width: '200px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'comp_quality_of_realestate',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quality_of_realestate'),
                    width: '200px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'comp_adopted_age',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Adopted_age'),
                    width: '180px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'comp_conservation_status',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Conservation_status'),
                    width: '200px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'comp_floor_number',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Height_situation'),
                    width: '160px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'comp_adopted_area',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Adopted_area') + ' (m²)',
                    width: '200px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'comp_lift',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Lift'),
                    width: '100px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }],
                selected: []
            },
            homogenisation_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                showHeader: false,
                columns: [{
                    id: 'homg_ad_date',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Date'),
                    width: '100px',
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].homg_percentage(value);
                    }
                }, {
                    id: 'homg_property_type',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Typology'),
                    width: '200px',
                    sortable: true,
                    groupable: false,
                    aggregators: [__WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].average],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].homg_percentage(value);
                    }
                }, {
                    id: 'homg_quality_of_neighbourhood',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quality_of_neighbourhood'),
                    width: '200px',
                    sortable: true,
                    groupable: false,
                    aggregators: [__WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].average],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].homg_percentage(value);
                    }
                }, {
                    id: 'homg_quality_of_situation',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quality_of_situation'),
                    width: '200px',
                    sortable: true,
                    groupable: false,
                    aggregators: [__WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].average],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].homg_percentage(value);
                    }
                }, {
                    id: 'homg_quality_of_construction',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quality_of_construction'),
                    width: '200px',
                    sortable: true,
                    groupable: false,
                    aggregators: [__WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].average],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].homg_percentage(value);
                    }

                }, {
                    id: 'homg_quality_of_realestate',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quality_of_realestate'),
                    width: '200px',
                    sortable: true,
                    groupable: false,
                    aggregators: [__WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].average],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].homg_percentage(value);
                    }
                }, {
                    id: 'homg_adopted_age',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Adopted_age'),
                    width: '180px',
                    sortable: true,
                    groupable: false,
                    aggregators: [__WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].average],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].homg_percentage(value);
                    }
                }, {
                    id: 'homg_conservation_status',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Conservation_status'),
                    width: '200px',
                    sortable: true,
                    groupable: false,
                    aggregators: [__WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].average],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].homg_percentage(value);
                    }
                }, {
                    id: 'homg_floor_number',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Height_situation'),
                    width: '160px',
                    sortable: true,
                    groupable: false,
                    aggregators: [__WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].average],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].homg_percentage(value);
                    }
                }, {
                    id: 'homg_adopted_area',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Adopted_area') + ' (m²)',
                    width: '200px',
                    sortable: true,
                    groupable: false,
                    aggregators: [__WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].average],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].homg_percentage(value);
                    }
                }, {
                    id: 'homg_lift',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Lift'),
                    width: '100px',
                    sortable: true,
                    groupable: false,
                    aggregators: [__WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].average],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].homg_percentage(value);
                    }
                }, {
                    id: 'homg_total',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Total'),
                    width: '100px',
                    sortable: true,
                    groupable: false,
                    aggregators: [__WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].average],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].homg_percentage(value);
                    }
                }],
                selected: []
            },
            weighing_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                showHeader: false,
                columns: [{
                    id: 'ad_date',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Date'),
                    width: '100px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'property_type',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Typology'),
                    width: '200px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'quality_of_neighbourhood',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quality_of_neighbourhood'),
                    width: '200px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'quality_of_situation',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quality_of_situation'),
                    width: '200px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'quality_of_construction',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quality_of_construction'),
                    width: '200px',
                    sortable: true,
                    groupable: false,
                    aggregators: []

                }, {
                    id: 'quality_of_realestate',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quality_of_realestate'),
                    width: '200px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'adopted_age',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Adopted_age'),
                    width: '180px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'conservation_status',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Conservation_status'),
                    width: '200px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'floor_number',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Height_situation'),
                    width: '160px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'adopted_area',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Adopted_area') + ' (m²)',
                    width: '200px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'lift',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Lift'),
                    width: '100px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }],
                selected: []
            },
            appraisal_tabulation_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [{
                    id: 'appraisaldate',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Date'),
                    width: '100px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'property_type',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Typology'),
                    width: '200px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'quality_of_neighbourhood',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quality_of_neighbourhood'),
                    width: '200px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'quality_of_situation',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quality_of_situation'),
                    width: '200px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'quality_of_construction',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quality_of_construction'),
                    width: '200px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'quality_of_realestate',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quality_of_realestate'),
                    width: '200px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'adopted_age',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Adopted_age'),
                    width: '180px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'conservation_status',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Conservation_status'),
                    width: '200px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'floor_number',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Height_situation'),
                    width: '160px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'adopted_area',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Adopted_area') + ' (m²)',
                    width: '200px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'lift',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Lift'),
                    width: '100px',
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }],
                selected: []
            },
            correction_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                showHeader: false,
                columns: [{
                    id: 'calc_initial_unit_price',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Initial_unit_price'),
                    width: '200px',
                    sortable: true,
                    groupable: false,
                    aggregators: [__WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].average],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 2, 'EUR_M2');
                    }
                }, {
                    id: 'calc_correction_pct',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Correction'),
                    width: '100px',
                    sortable: true,
                    groupable: false,
                    aggregators: [__WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].average],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 2, 'PCT');
                    }
                }, {
                    id: 'calc_final_unit_price',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Final_unit_price'),
                    width: '200px',
                    sortable: true,
                    groupable: false,
                    aggregators: [__WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].average],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 2, 'EUR_M2');
                    }
                }],
                selected: []
            },
            regressioncalc_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                showHeader: false,
                columns: [{
                    id: 'calc_Xi',
                    label: 'Xᵢ (' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Area') + ')',
                    width: '120px',
                    sortable: true,
                    groupable: false,
                    aggregators: [__WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].average],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 2, 'M2');
                    }
                }, {
                    id: 'calc_Vi',
                    label: 'Vᵢ (' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Corrected_market_value') + ')',
                    width: '180px',
                    sortable: true,
                    groupable: false,
                    aggregators: [__WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].average],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 2, 'EUR');
                    }
                }, {
                    id: 'calc_Vu',
                    label: 'Vᵤ (' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Corrected_unit_market_value') + ')',
                    width: '180px',
                    sortable: true,
                    groupable: false,
                    aggregators: [__WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].average],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 2, 'EUR_M2');
                    }
                }, {
                    id: 'calc_Vu2',
                    label: 'Vᵤ²',
                    width: '160px',
                    sortable: true,
                    groupable: false,
                    aggregators: [__WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].average],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 2, 'EUR_M2_POW2');
                    }
                }, {
                    id: 'calc_XiVi',
                    label: 'Xᵢ·Vᵢ',
                    width: '120px',
                    sortable: true,
                    groupable: false,
                    aggregators: [__WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].average],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 2, 'EUR_X_M2');
                    }
                }, {
                    id: 'calc_Xi2',
                    label: 'Xᵢ²',
                    width: '120px',
                    sortable: true,
                    groupable: false,
                    aggregators: [__WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].average],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 2, 'M2_POW2');
                    }
                }, {
                    id: 'calc_Vi2',
                    label: 'Vᵢ²',
                    width: '160px',
                    sortable: true,
                    groupable: false,
                    aggregators: [__WEBPACK_IMPORTED_MODULE_29__aggregators_aggregators_js__["a" /* default */].average],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 2, 'EUR2');
                    }
                }],
                selected: []
            },
            univ_dev_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                showHeader: false,
                columns: [{
                    id: 'n',
                    label: 'nº',
                    width: '60px',
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 0, 'NONE');
                    }
                }, {
                    id: 'summation_Vu2_n',
                    label: '∑ ((Vᵤ)² / n)',
                    width: '180px',
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 2, 'EUR_M2_POW2');
                    }
                }, {
                    id: 'summation_Vu_n_2',
                    label: '(∑ (Vᵤ / n))²',
                    width: '180px',
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 2, 'EUR_M2');
                    }
                }, {
                    id: 'g2',
                    label: 'g = i',
                    width: '120px',
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 2, 'NONE');
                    }
                }, {
                    id: 'g',
                    label: 'g (' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Standard_deviation_of_the_sample') + ')',
                    width: '120px',
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 2, 'EUR_M2');
                    }
                }, {
                    id: 't',
                    label: 'T',
                    width: '140px',
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 2, 'NONE');
                    }
                }, {
                    id: 's',
                    label: 'S',
                    width: '120px',
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 2, 'NONE');
                    }
                }, {
                    id: 's2',
                    label: 'S²',
                    width: '120px',
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 2, 'NONE');
                    }
                }, {
                    id: 'r',
                    label: 'R',
                    width: '120px',
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 2, 'NONE');
                    }
                }, {
                    id: 'm',
                    label: 'm',
                    width: '120px',
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 2, 'NONE');
                    }
                }, {
                    id: 'na',
                    label: 'n·a',
                    width: '80px',
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 2, 'NONE');
                    }
                }, {
                    id: 't_ms',
                    label: 'T - m·S',
                    width: '120px',
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 2, 'NONE');
                    }
                }, {
                    id: 's2_nas',
                    label: 'S² - n·a·S',
                    width: '120px',
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 2, 'NONE');
                    }
                }, {
                    id: 'a',
                    label: 'a',
                    width: '120px',
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 2, 'NONE');
                    }
                }, {
                    id: 'b',
                    label: 'b',
                    width: '120px',
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 2, 'NONE');
                    }
                }],
                selected: []
            },
            repr_dev_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                showHeader: false,
                columns: [{
                    id: 'limit_upper',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Upper_limit'),
                    width: '100px',
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 0, 'EUR_M2');
                    }
                }, {
                    id: 'limit_lower',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Lower_limit'),
                    width: '100px',
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 0, 'EUR_M2');
                    }
                }, {
                    id: 'n',
                    label: 'nº',
                    width: '60px',
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 0, 'NONE');
                    }
                }, {
                    id: 'summation_Vu2_n',
                    label: '∑ ((Vᵤ)² / n)',
                    width: '180px',
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 2, 'EUR_M2_POW2');
                    }
                }, {
                    id: 'summation_Vu_n_2',
                    label: '(∑ (Vᵤ / n))²',
                    width: '180px',
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 2, 'EUR_M2');
                    }
                }, {
                    id: 'g2',
                    label: 'g = i',
                    width: '120px',
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 2, 'NONE');
                    }
                }, {
                    id: 'g',
                    label: 'g (' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Standard_deviation_of_the_sample') + ')',
                    width: '120px',
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 2, 'EUR_M2');
                    }
                }, {
                    id: 't',
                    label: 'T',
                    width: '140px',
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 2, 'NONE');
                    }
                }, {
                    id: 's',
                    label: 'S',
                    width: '120px',
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 2, 'NONE');
                    }
                }, {
                    id: 's2',
                    label: 'S²',
                    width: '120px',
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 2, 'NONE');
                    }
                }, {
                    id: 'r',
                    label: 'R',
                    width: '120px',
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 2, 'NONE');
                    }
                }, {
                    id: 'm',
                    label: 'm',
                    width: '120px',
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 2, 'NONE');
                    }
                }, {
                    id: 'na',
                    label: 'n·a',
                    width: '80px',
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 2, 'NONE');
                    }
                }, {
                    id: 't_ms',
                    label: 'T - m·S',
                    width: '120px',
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 2, 'NONE');
                    }
                }, {
                    id: 's2_nas',
                    label: 'S² - n·a·S',
                    width: '120px',
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 2, 'NONE');
                    }
                }, {
                    id: 'a',
                    label: 'a',
                    width: '120px',
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 2, 'NONE');
                    }
                }, {
                    id: 'b',
                    label: 'b',
                    width: '120px',
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_30__formatters_formatters_js__["a" /* default */].currency(value, 2, 'NONE');
                    }
                }],
                selected: []
            },
            regressionline_chart: {
                chartType: 'ScatterChart',
                /*
                columns: [{
                'type': 'string',
                'label': 'Address'
                }, {
                'type': 'number',
                'label': 'Area'
                }, {
                'type': 'number',
                'label': 'Price'
                }, {
                'type': 'string',
                'label': 'Type'
                }],
                */
                columns: [{
                    'type': 'number',
                    'label': 'Index1'
                }, {
                    'type': 'number',
                    'label': __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Comparables')
                }, {
                    'type': 'number',
                    'label': __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Appraised')
                }],
                //rows: this.comparable_points ? this.comparable_points : [[0, 0, 0]],
                rows: _this.marketstudy ? _this.marketstudy.comparable_points ? _this.marketstudy.comparable_points : [[0, 0, 0]] : [[0, 0, 0]],
                //rows: [ [10, 20, null], [15, 17, null], [23, 16, null], [10, null, 22]],
                options: {
                    title: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Regression_line'),
                    width: 1200,
                    height: 600,
                    trendlines: {
                        0: {
                            labelInLegend: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Regression_line'),
                            visibleInLegend: true,
                            //  The coefficient of determination, called R2 in statistics,
                            // identifies how closely a trendline matches the data.
                            // A perfect correlation is 1.0, and a perfect anticorrelation is 0.0.
                            showR2: true
                        }
                    },
                    hAxis: {
                        title: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Area'),
                        titleTextStyle: {
                            color: 'black',
                            fontName: 'Avenir',
                            fontSize: 14,
                            bold: true,
                            italic: false
                        },
                        textStyle: {
                            color: 'black',
                            fontName: 'Avenir',
                            fontSize: 12,
                            bold: false,
                            italic: false
                        }
                        //minValue: 0,
                        //maxValue: 200
                    },
                    vAxis: {
                        title: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Price'),
                        titleTextStyle: {
                            color: 'black',
                            fontName: 'Avenir',
                            fontSize: 14,
                            bold: true,
                            italic: false
                        },
                        textStyle: {
                            color: 'black',
                            fontName: 'Avenir',
                            fontSize: 12,
                            bold: false,
                            italic: false
                        }
                        //minValue: 0,
                        //maxValue: 100000
                    },
                    legend: {
                        textStyle: {
                            color: 'black',
                            fontName: 'Avenir',
                            fontSize: 14,
                            bold: false,
                            italic: false
                        }
                    },
                    bubble: {
                        stroke: 'none',
                        textStyle: { color: 'transparent' }
                    },
                    titleTextStyle: {
                        color: 'black',
                        fontName: 'Avenir',
                        fontSize: 18,
                        bold: true,
                        italic: false
                    }

                }
            }

        };
    },

    created: function created() {
        var _this2 = this;

        this.SET_APPRAISAL({ path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + this.$route.query.appraisal_id + '/' }).then(function (res) {
            // Agafem el mateix que hi hagi a realestate
            _this2.SET_APPRAISAL_PROPERTY_TYPE(_this2.realestate.property_type);
            _this2.appraisal_tabulation.push(_this2.appraisal);
            _this2.FETCH_MARKETSTUDY_AD_COMPARABLES({ path: 'marketstudy_ad_comparables' + '/' + _this2.marketstudy.id + '/' }).then(function () {
                _this2.FETCH_APPRAISALFILES().then(function () {

                    if (_this2.marketstudy) {
                        console.log('yeah, hi ha marketstudy');
                        if (_this2.marketstudy.comparable_points) {
                            console.log('yeah, hi ha regressionline points');
                            console.log('regressionline points: ');
                            console.log(_this2.marketstudy.comparable_points);

                            var parsed_comparable_points = [].concat(_toConsumableArray(_this2.marketstudy.comparable_points));

                            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(parsed_comparable_points, function (value, key) {
                                if (value.length < 3) {
                                    parsed_comparable_points[key].push(null);
                                }
                            });
                            _this2.regressionline_chart.rows = parsed_comparable_points;
                        } else {
                            console.log('nope, no hi ha regressionline points');
                        }
                    } else {
                        console.log('nope, no hi ha marketstudy');
                    }

                    _this2.master_loading = false;
                });
            });
        });
    },


    components: {
        Bar: __WEBPACK_IMPORTED_MODULE_9__components_Bar_Index_vue___default.a,
        Message: __WEBPACK_IMPORTED_MODULE_13__components_Message_vue___default.a,
        IconButton: __WEBPACK_IMPORTED_MODULE_10__components_IconButton_Index_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_6__components_Spinner_vue___default.a,
        Checkbox: __WEBPACK_IMPORTED_MODULE_31__components_Toggles_checkbox_vue___default.a,
        Datatable: __WEBPACK_IMPORTED_MODULE_27__components_Datatable_datatable_vue___default.a,
        DatatableColumn: __WEBPACK_IMPORTED_MODULE_28__components_Datatable_datatable_column_vue___default.a,
        Paginator: __WEBPACK_IMPORTED_MODULE_32__components_Paginator_paginator_vue___default.a,
        SideNavBar: __WEBPACK_IMPORTED_MODULE_11__components_SideNavBar_Index_vue___default.a
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['theme', 'marketstudy', 'appraisal', 'appraisalfile', 'appraisalfiles', 'appraisalreport', 'appraisalreport_realestates', 'marketstudy_ad_comparables', 'marketstudy_matched_ads', 'currentLocale', 'realestate', 'realestate_marketstudies', 'representative_sample_typical_deviation', 'temp_appraisalreports', 'temp_realestates', 'temp_marketstudies', 'universal_sample_typical_deviation', 'weighing']), {
        selectAllAds: {
            get: function get() {
                return this.ad_table.selected.length === this.marketstudy_matched_ads.length;
            },
            set: function set(value) {
                this.ad_table.selected = value ? this.marketstudy_matched_ads : [];
            }
        }
    }),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['CREATE_NEW_MARKETSTUDY', 'CREATE_NEW_AD_COMPARABLE', 'DELETE_AD_COMPARABLE', 'FETCH_APPRAISAL', 'FETCH_APPRAISALFILES', 'FETCH_MARKETSTUDY_AD_COMPARABLES', 'FETCH_MARKETSTUDY_MATCHED_ADS', 'FETCH_TEMP_APPRAISALFILE_APPRAISALREPORTS', 'FETCH_TEMP_APPRAISALREPORT_REALESTATES', 'FETCH_TEMP_REALESTATE_MARKETSTUDIES', 'QUERY_ADS', 'RESET_MARKETSTUDY', 'RESET_AD_COMPARABLE', 'SET_AD', 'SET_APPRAISAL', 'SET_APPRAISAL_ADOPTED_AREA', 'SET_APPRAISAL_LIFT', 'SET_APPRAISAL_CONSTRUCTION_YEAR', 'SET_APPRAISAL_LAST_RENOVATION_YEAR', 'SET_APPRAISAL_ADOPTED_AGE', 'SET_APPRAISAL_FLOOR_NUMBER', 'SET_APPRAISAL_PROPERTY_TYPE', 'SET_APPRAISAL_QUALITY_OF_NEIGHBOURHOOD', 'SET_APPRAISAL_QUALITY_OF_SITUATION', 'SET_APPRAISAL_QUALITY_OF_CONSTRUCTION', 'SET_APPRAISAL_QUALITY_OF_REALESTATE', 'SET_APPRAISAL_CONSERVATION_STATUS', 'SET_APPRAISAL_MARKET_VALUE', 'SET_APPRAISAL_MARKET_UNIT_VALUE', 'SET_ENTITY_QUALITY_OF_NEIGHBOURHOOD', 'SET_MARKETSTUDY_AD_COMPARABLES', 'SET_MARKETSTUDY_APPRAISED_POINTS', 'SET_MARKETSTUDY_COMPARABLE_POINTS', 'SET_MARKETSTUDY_REGRESSIONLINE_POINTS', 'SET_MARKETSTUDY_DESCRIPTION', 'SET_MARKETSTUDY_MATCHED_ADS', 'SET_MARKETSTUDY_MARKET_VALUE', 'SET_MARKETSTUDY_MARKET_UNIT_VALUE', 'SET_MARKETSTUDY_QUERY_AD_TYPE', 'SET_MARKETSTUDY_QUERY_DISTANCE_KM', 'SET_MARKETSTUDY_QUERY_LIMITDATE', 'SET_MARKETSTUDY_QUERY_STARTDATE', 'SET_MARKETSTUDY_PURPOSE', 'SET_MARKETSTUDY_PURPOSE_NOTES', 'SET_MARKETSTUDY_TYPE', 'SET_MARKETSTUDY_REPRESENTATIVE_SAMPLE_TYPICAL_DEVIATION', 'SET_MARKETSTUDY_UNIVERSAL_SAMPLE_TYPICAL_DEVIATION', 'SET_MARKETSTUDY_WEIGHING', 'SET_MARKETSTUDY_WEIGHING_AD_DATE', 'SET_MARKETSTUDY_WEIGHING_PROPERTY_TYPE', 'SET_MARKETSTUDY_WEIGHING_QUALITY_OF_NEIGHBOURHOOD', 'SET_MARKETSTUDY_WEIGHING_QUALITY_OF_SITUATION', 'SET_MARKETSTUDY_WEIGHING_QUALITY_OF_CONSTRUCTION', 'SET_MARKETSTUDY_WEIGHING_QUALITY_OF_REALESTATE', 'SET_MARKETSTUDY_WEIGHING_ADOPTED_AGE', 'SET_MARKETSTUDY_WEIGHING_CONSERVATION_STATUS', 'SET_MARKETSTUDY_WEIGHING_FLOOR_NUMBER', 'SET_MARKETSTUDY_WEIGHING_ADOPTED_AREA', 'SET_MARKETSTUDY_WEIGHING_LIFT', 'SET_REALESTATE_FLOOR_NUMBER', 'SET_REALESTATE_PROPERTY_TYPE', 'SET_ROOM_NETAREA', 'UPDATE_APPRAISAL', 'UPDATE_MARKETSTUDY', 'UPDATE_MARKETSTUDY_AD_COMPARABLES', 'UPDATE_REALESTATE_FLOOR_NUMBER', 'SET_MARKETSTUDY_PRICES_ESTIMATED_YEARLY_EVOLUTION_PCT', 'SET_MARKETSTUDY_MARKET_VALUE_EVOLUTION_PROBABILITY_PCT', 'SET_MARKETSTUDY_OFFER_PRODUCTION', 'SET_MARKETSTUDY_OFFER_YEARLY_STOCK', 'SET_MARKETSTUDY_OFFER_TREND', 'SET_MARKETSTUDY_DEMAND_LEVEL', 'SET_MARKETSTUDY_DEMAND_SPEED_OF_SALES', 'SET_MARKETSTUDY_DEMAND_TREND', 'SET_MARKETSTUDY_PRICES_EXPECTANCY', 'SET_MARKETSTUDY_PRICES_PAST_CICLES_VOLATILITY', 'SET_MARKETSTUDY_MARKET_CONJUNCTURE', 'SET_MARKETSTUDY_MARKET_VALUE_REDUCTION_PROBABILITY_EXPECTANCY', 'SET_MARKETSTUDY_PRICES_MAX', 'SET_MARKETSTUDY_PRICES_MIN', 'SET_MARKETSTUDY_PRICES_MEAN', 'SET_MARKETSTUDY_PRICES_MEDIAN', 'COPY_COMPARABLES_FROM_MARKETSTUDY']), {
        set_marketstudy_description: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_MARKETSTUDY_DESCRIPTION(e.target.value);
        }, 1000),
        set_marketstudy_query_ad_type: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_MARKETSTUDY_QUERY_AD_TYPE(e);
        }, 1000),
        set_marketstudy_query_distance_km: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_MARKETSTUDY_QUERY_DISTANCE_KM(e.target.value);
        }, 1000),
        set_marketstudy_query_startdate: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_MARKETSTUDY_QUERY_STARTDATE(e.target.value);
        }, 1000),
        set_marketstudy_query_limitdate: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_MARKETSTUDY_QUERY_LIMITDATE(e.target.value);
        }, 1000),
        set_appraisal_property_type: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this3 = this;

            this.SET_REALESTATE_PROPERTY_TYPE(e).then(function (res) {});
            this.SET_APPRAISAL_PROPERTY_TYPE(e).then(function (res) {
                _this3.$forceUpdate();
                _this3.set_entities_property_type();
            });
        }, 0),
        set_appraisal_construction_year_event: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this4 = this;

            var construction_year = Number(e.target.value);
            this.SET_APPRAISAL_CONSTRUCTION_YEAR(construction_year);

            var last_renovation_year = construction_year;

            if (this.appraisal.last_renovation_year) {
                last_renovation_year = this.appraisal.last_renovation_year;

                if (last_renovation_year < construction_year) {
                    last_renovation_year = construction_year;
                }
            }

            this.SET_APPRAISAL_LAST_RENOVATION_YEAR(last_renovation_year);

            var average = Math.round((construction_year + last_renovation_year) / 2);

            this.SET_APPRAISAL_ADOPTED_AGE(average).then(function (res) {
                _this4.$forceUpdate();
                _this4.set_entities_adopted_age();
            });
        }, 500),
        set_appraisal_last_renovation_year_event: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this5 = this;

            var last_renovation_year = Number(e.target.value);
            this.SET_APPRAISAL_LAST_RENOVATION_YEAR(last_renovation_year);

            var construction_year = null;
            var cadastral_construction_year = this.appraisal.cadastral_construction_year;

            if (this.appraisal.construction_year) {
                construction_year = this.appraisal.construction_year;
            } else {
                construction_year = cadastral_construction_year;
            }

            this.SET_APPRAISAL_CONSTRUCTION_YEAR(construction_year);

            var average = Math.round((construction_year + last_renovation_year) / 2);

            this.SET_APPRAISAL_ADOPTED_AGE(average).then(function (res) {
                _this5.$forceUpdate();
                _this5.set_entities_adopted_age();
            });
        }, 500),
        set_appraisal_adopted_age_event: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this6 = this;

            this.SET_APPRAISAL_ADOPTED_AGE(Number(e.target.value)).then(function (res) {
                _this6.$forceUpdate();
                _this6.set_entities_adopted_age();
            });
        }, 500),
        set_appraisal_adopted_area_event: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this7 = this;

            this.SET_APPRAISAL_ADOPTED_AREA(Number(e.target.value)).then(function (res) {
                _this7.$forceUpdate();
                _this7.set_entities_adopted_area();
            });
        }, 500),
        set_appraisal_floor_number_event: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this8 = this;

            this.SET_REALESTATE_FLOOR_NUMBER(Number(e.target.value)).then(function (res) {});
            this.SET_APPRAISAL_FLOOR_NUMBER(Number(e.target.value)).then(function (res) {
                _this8.$forceUpdate();
                _this8.set_entities_floor_number();
            });
        }, 500),
        set_appraisal_adopted_age: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this9 = this;

            this.SET_APPRAISAL_ADOPTED_AGE(Number(e)).then(function (res) {
                _this9.$forceUpdate();
                _this9.set_entities_adopted_age();
            });
        }, 0),
        set_appraisal_adopted_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this10 = this;

            this.SET_APPRAISAL_ADOPTED_AREA(Number(e)).then(function (res) {
                _this10.$forceUpdate();
                _this10.set_entities_adopted_area();
            });
        }, 0),
        set_appraisal_floor_number: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this11 = this;

            this.SET_REALESTATE_FLOOR_NUMBER(Number(e)).then(function (res) {});
            this.SET_APPRAISAL_FLOOR_NUMBER(Number(e)).then(function (res) {
                _this11.$forceUpdate();
                _this11.set_entities_floor_number();
            });
        }, 0),
        set_appraisal_lift: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this12 = this;

            console.log('set_appraisal_lift: ' + e);
            this.SET_APPRAISAL_LIFT(e).then(function (res) {
                _this12.$forceUpdate();
                _this12.set_entities_lift();
            });
        }, 0),
        set_appraisal_lift_event: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this13 = this;

            // console.log('this.appraisal.lift: ')
            // console.log(this.appraisal.lift)
            // console.log('set_appraisal_lift: ' + !this.appraisal.lift)
            this.SET_APPRAISAL_LIFT(this.appraisal.lift).then(function (res) {
                _this13.$forceUpdate();
                _this13.set_entities_lift();
            });
        }, 0),
        set_appraisal_conservation_status: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this14 = this;

            this.SET_APPRAISAL_CONSERVATION_STATUS(e).then(function (res) {
                _this14.$forceUpdate();
                _this14.set_entities_conservation_status();
            });
        }, 0),
        set_appraisal_quality_of_neighbourhood: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this15 = this;

            this.SET_APPRAISAL_QUALITY_OF_NEIGHBOURHOOD(e).then(function (res) {
                _this15.$forceUpdate();
                _this15.set_entities_quality_of_neighbourhood();
            });
        }, 0),
        set_appraisal_quality_of_situation: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this16 = this;

            this.SET_APPRAISAL_QUALITY_OF_SITUATION(e).then(function (res) {
                _this16.$forceUpdate();
                _this16.set_entities_quality_of_situation();
            });
        }, 0),
        set_appraisal_quality_of_construction: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this17 = this;

            this.SET_APPRAISAL_QUALITY_OF_CONSTRUCTION(e).then(function (res) {
                _this17.$forceUpdate();
                _this17.set_entities_quality_of_construction();
            });
        }, 0),
        set_appraisal_quality_of_realestate: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this18 = this;

            this.SET_APPRAISAL_QUALITY_OF_REALESTATE(e).then(function (res) {
                _this18.$forceUpdate();
                _this18.set_entities_quality_of_realestate();
            });
        }, 0),
        set_entities_property_type: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function () {
            var _this19 = this;

            var obj = this.marketstudy_ad_comparables;

            // comparison
            for (var key in obj) {
                var compared_value = obj[key].property_type.name_es.toLowerCase();
                var appraised_value = this.appraisal_tabulation[0].property_type.name_es.toLowerCase();
                var comp_result = this.compare_property_type(compared_value, appraised_value);
                obj[key].comp_property_type = comp_result;

                var homg_result = this.homogenize(comp_result, this.weighing[0].property_type);
                obj[key].homg_property_type = homg_result;
            }

            this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then(function (res) {
                _this19.set_homogenisation_totals();
            });
        }, 0),
        set_entities_adopted_age: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function () {
            var _this20 = this;

            var obj = this.marketstudy_ad_comparables;
            for (var key in obj) {
                var compared_value = obj[key].adopted_age;
                var appraised_value = this.appraisal_tabulation[0].adopted_age;
                var comp_result = this.compare_age(compared_value, appraised_value);
                obj[key].comp_adopted_age = comp_result;

                var homg_result = this.homogenize(comp_result, this.weighing[0].adopted_age);
                obj[key].homg_adopted_age = homg_result;
            }
            this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then(function (res) {
                _this20.set_homogenisation_totals();
            });
        }, 0),
        set_entities_adopted_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function () {
            var _this21 = this;

            var obj = this.marketstudy_ad_comparables;
            for (var key in obj) {
                var compared_value = obj[key].adopted_area;
                var appraised_value = this.appraisal_tabulation[0].adopted_area;
                var comp_result = this.compare_area(compared_value, appraised_value);
                obj[key].comp_adopted_area = comp_result;

                var homg_result = this.homogenize(comp_result, this.weighing[0].adopted_area);
                obj[key].homg_adopted_area = homg_result;
            }
            this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then(function (res) {
                _this21.set_homogenisation_totals();
            });
        }, 0),
        set_entities_floor_number: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function () {
            var _this22 = this;

            var obj = this.marketstudy_ad_comparables;
            for (var key in obj) {
                var compared_value = obj[key].floor_number;
                var appraised_value = this.appraisal_tabulation[0].floor_number;
                var comp_result = this.compare_floor_number(compared_value, appraised_value);
                obj[key].comp_floor_number = comp_result;

                var homg_result = this.homogenize(comp_result, this.weighing[0].floor_number);
                obj[key].homg_floor_number = homg_result;
            }
            this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then(function (res) {
                _this22.set_homogenisation_totals();
            });
        }, 0),
        set_entities_lift: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function () {
            var _this23 = this;

            var obj = this.marketstudy_ad_comparables;
            for (var key in obj) {
                var compared_value = obj[key].lift;
                var appraised_value = this.appraisal_tabulation[0].lift;
                var comp_result = this.compare_lift(compared_value, appraised_value);
                obj[key].comp_lift = comp_result;

                var homg_result = this.homogenize(comp_result, this.weighing[0].lift);
                obj[key].homg_lift = homg_result;
            }
            this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then(function (res) {
                _this23.set_homogenisation_totals();
            });
        }, 0),
        set_entities_conservation_status: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function () {
            var _this24 = this;

            var obj = this.marketstudy_ad_comparables;
            for (var key in obj) {
                var compared_value = obj[key].conservation_status.code_bde;
                var appraised_value = this.appraisal_tabulation[0].conservation_status.code_bde;
                var comp_result = this.compare_conservation_status(compared_value, appraised_value);
                obj[key].comp_conservation_status = comp_result;

                var homg_result = this.homogenize(comp_result, this.weighing[0].conservation_status);
                obj[key].homg_conservation_status = homg_result;
            }
            this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then(function (res) {
                _this24.set_homogenisation_totals();
            });
        }, 0),
        set_entities_quality_of_neighbourhood: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function () {
            var _this25 = this;

            var obj = this.marketstudy_ad_comparables;
            for (var key in obj) {
                var compared_value = obj[key].quality_of_neighbourhood.code_bde;
                var appraised_value = this.appraisal_tabulation[0].quality_of_neighbourhood.code_bde;
                var comp_result = this.compare_values(compared_value, appraised_value);
                obj[key].comp_quality_of_neighbourhood = comp_result;

                var homg_result = this.homogenize(comp_result, this.weighing[0].quality_of_neighbourhood);
                obj[key].homg_quality_of_neighbourhood = homg_result;
            }
            this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then(function (res) {
                _this25.set_homogenisation_totals();
            });
        }, 0),
        set_entities_quality_of_situation: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function () {
            var _this26 = this;

            var obj = this.marketstudy_ad_comparables;
            for (var key in obj) {
                var compared_value = obj[key].quality_of_situation.code_bde;
                var appraised_value = this.appraisal_tabulation[0].quality_of_situation.code_bde;
                var comp_result = this.compare_values(compared_value, appraised_value);
                obj[key].comp_quality_of_situation = comp_result;

                var homg_result = this.homogenize(comp_result, this.weighing[0].quality_of_situation);
                obj[key].homg_quality_of_situation = homg_result;
            }
            this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then(function (res) {
                _this26.set_homogenisation_totals();
            });
        }, 0),
        set_entities_quality_of_construction: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function () {
            var _this27 = this;

            var obj = this.marketstudy_ad_comparables;
            for (var key in obj) {
                var compared_value = obj[key].quality_of_construction.code_bde;
                var appraised_value = this.appraisal_tabulation[0].quality_of_construction.code_bde;
                var comp_result = this.compare_values(compared_value, appraised_value);
                obj[key].comp_quality_of_construction = comp_result;

                var homg_result = this.homogenize(comp_result, this.weighing[0].quality_of_construction);
                obj[key].homg_quality_of_construction = homg_result;
            }
            this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then(function (res) {
                _this27.set_homogenisation_totals();
            });
        }, 0),
        set_entities_quality_of_realestate: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function () {
            var _this28 = this;

            var obj = this.marketstudy_ad_comparables;
            for (var key in obj) {
                var compared_value = obj[key].quality_of_realestate.code_bde;
                var appraised_value = this.appraisal_tabulation[0].quality_of_realestate.code_bde;
                var comp_result = this.compare_values(compared_value, appraised_value);
                obj[key].comp_quality_of_realestate = comp_result;

                var homg_result = this.homogenize(comp_result, this.weighing[0].quality_of_realestate);
                obj[key].homg_quality_of_realestate = homg_result;
            }
            this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then(function (res) {
                _this28.set_homogenisation_totals();
            });
        }, 0),
        set_entity_property_type: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e, f) {
            var _this29 = this;

            var compared_value = e.name_es.toLowerCase();
            var appraised_value = this.appraisal_tabulation[0].property_type.name_es.toLowerCase();
            var comp_result = this.compare_property_type(compared_value, appraised_value);
            var obj = this.marketstudy_ad_comparables;
            var comp_id = f['id'];
            obj[comp_id]['comp_property_type'] = comp_result;

            var homg_result = this.homogenize(comp_result, this.weighing[0].property_type);
            obj[comp_id]['homg_property_type'] = homg_result;

            this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then(function (res) {
                _this29.set_homogenisation_totals();
            });
        }, 0),
        set_entity_adopted_age: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e, f) {
            var _this30 = this;

            var compared_value = e.target.value;
            var appraised_value = this.appraisal_tabulation[0].adopted_age;
            var comp_result = this.compare_age(compared_value, appraised_value);
            var obj = this.marketstudy_ad_comparables;
            var comp_id = f['id'];
            obj[comp_id]['comp_adopted_age'] = comp_result;

            var homg_result = this.homogenize(comp_result, this.weighing[0].adopted_age);
            obj[comp_id]['homg_adopted_age'] = homg_result;

            this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then(function (res) {
                _this30.set_homogenisation_totals();
            });
        }, 1000),
        set_entity_adopted_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e, f) {
            var _this31 = this;

            var compared_value = e.target.value;
            var appraised_value = this.appraisal_tabulation[0].adopted_area;
            var comp_result = this.compare_area(compared_value, appraised_value);
            var obj = this.marketstudy_ad_comparables;
            var comp_id = f['id'];
            obj[comp_id]['comp_adopted_area'] = comp_result;

            var homg_result = this.homogenize(comp_result, this.weighing[0].adopted_area);
            obj[comp_id]['homg_adopted_area'] = homg_result;

            this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then(function (res) {
                _this31.set_homogenisation_totals();
            });
        }, 1000),
        set_entity_floor_number: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e, f) {
            var _this32 = this;

            var compared_value = e.target.value;
            var appraised_value = this.appraisal_tabulation[0].floor_number;
            var comp_result = this.compare_floor_number(compared_value, appraised_value);
            var obj = this.marketstudy_ad_comparables;
            var comp_id = f['id'];

            obj[comp_id]['comp_floor_number'] = comp_result;

            var homg_result = this.homogenize(comp_result, this.weighing[0].floor_number);
            obj[comp_id]['homg_floor_number'] = homg_result;

            this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then(function (res) {
                _this32.set_homogenisation_totals();
            });
        }, 500),
        set_entity_lift: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e, f) {
            var _this33 = this;

            var compared_value = e;
            var appraised_value = this.appraisal_tabulation[0].lift;
            var comp_result = this.compare_lift(compared_value, appraised_value);
            var obj = this.marketstudy_ad_comparables;
            var comp_id = f['id'];
            obj[comp_id]['comp_lift'] = comp_result;

            var homg_result = this.homogenize(comp_result, this.weighing[0].lift);
            obj[comp_id]['homg_lift'] = homg_result;

            this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then(function (res) {
                _this33.set_homogenisation_totals();
            });
        }, 0),
        set_entity_conservation_status: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e, f) {
            var _this34 = this;

            var compared_value = e.code_bde;
            var appraised_value = this.appraisal_tabulation[0].conservation_status.code_bde;
            var comp_result = this.compare_conservation_status(compared_value, appraised_value);
            var obj = this.marketstudy_ad_comparables;
            var comp_id = f['id'];
            obj[comp_id]['comp_conservation_status'] = comp_result;

            var homg_result = this.homogenize(comp_result, this.weighing[0].conservation_status);
            obj[comp_id]['homg_conservation_status'] = homg_result;
            this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then(function (res) {
                _this34.set_homogenisation_totals();
            });
        }, 0),
        set_entity_quality_of_neighbourhood: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e, f) {
            var _this35 = this;

            var compared_value = e.code_bde;
            var appraised_value = this.appraisal_tabulation[0].quality_of_neighbourhood.code_bde;
            var comp_result = this.compare_values(compared_value, appraised_value);
            var obj = this.marketstudy_ad_comparables;
            var comp_id = f['id'];
            obj[comp_id]['comp_quality_of_neighbourhood'] = comp_result;

            var homg_result = this.homogenize(comp_result, this.weighing[0].quality_of_neighbourhood);
            obj[comp_id]['homg_quality_of_neighbourhood'] = homg_result;
            this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then(function (res) {
                _this35.set_homogenisation_totals();
            });
        }, 0),
        set_entity_quality_of_situation: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e, f) {
            var _this36 = this;

            var compared_value = e.code_bde;
            var appraised_value = this.appraisal_tabulation[0].quality_of_situation.code_bde;
            var comp_result = this.compare_values(compared_value, appraised_value);
            var obj = this.marketstudy_ad_comparables;
            var comp_id = f['id'];
            obj[comp_id]['comp_quality_of_situation'] = comp_result;

            var homg_result = this.homogenize(comp_result, this.weighing[0].quality_of_situation);
            obj[comp_id]['homg_quality_of_situation'] = homg_result;

            this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then(function (res) {
                _this36.set_homogenisation_totals();
            });
        }, 0),
        set_entity_quality_of_construction: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e, f) {
            var _this37 = this;

            var compared_value = e.code_bde;
            var appraised_value = this.appraisal_tabulation[0].quality_of_construction.code_bde;
            var comp_result = this.compare_values(compared_value, appraised_value);
            var obj = this.marketstudy_ad_comparables;
            var comp_id = f['id'];
            obj[comp_id]['comp_quality_of_construction'] = comp_result;

            var homg_result = this.homogenize(comp_result, this.weighing[0].quality_of_construction);
            obj[comp_id]['homg_quality_of_construction'] = homg_result;

            this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then(function (res) {
                _this37.set_homogenisation_totals();
            });
        }, 0),
        set_entity_quality_of_realestate: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e, f) {
            var _this38 = this;

            var compared_value = e.code_bde;
            var appraised_value = this.appraisal_tabulation[0].quality_of_realestate.code_bde;
            var comp_result = this.compare_values(compared_value, appraised_value);
            var obj = this.marketstudy_ad_comparables;
            var comp_id = f['id'];
            obj[comp_id]['comp_quality_of_realestate'] = comp_result;

            var homg_result = this.homogenize(comp_result, this.weighing[0].quality_of_realestate);
            obj[comp_id]['homg_quality_of_realestate'] = homg_result;

            this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then(function (res) {
                _this38.set_homogenisation_totals();
            });
        }, 0),
        set_marketstudy_weighing_ad_date: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this39 = this;

            this.SET_MARKETSTUDY_WEIGHING_AD_DATE(e.target.value).then(function (res) {
                _this39.set_entities_comparison_and_homogenisation();
            });
        }, 1000),
        set_marketstudy_weighing_property_type: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this40 = this;

            this.SET_MARKETSTUDY_WEIGHING_PROPERTY_TYPE(e.target.value).then(function (res) {
                _this40.set_entities_comparison_and_homogenisation();
            });
        }, 1000),
        set_marketstudy_weighing_quality_of_neighbourhood: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this41 = this;

            this.SET_MARKETSTUDY_WEIGHING_QUALITY_OF_NEIGHBOURHOOD(e.target.value).then(function (res) {
                _this41.set_entities_comparison_and_homogenisation();
            });
        }, 1000),
        set_marketstudy_weighing_quality_of_situation: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this42 = this;

            this.SET_MARKETSTUDY_WEIGHING_QUALITY_OF_SITUATION(e.target.value).then(function (res) {
                _this42.set_entities_comparison_and_homogenisation();
            });
        }, 1000),
        set_marketstudy_weighing_quality_of_construction: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this43 = this;

            this.SET_MARKETSTUDY_WEIGHING_QUALITY_OF_CONSTRUCTION(e.target.value).then(function (res) {
                _this43.set_entities_comparison_and_homogenisation();
            });
        }, 1000),
        set_marketstudy_weighing_quality_of_realestate: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this44 = this;

            this.SET_MARKETSTUDY_WEIGHING_QUALITY_OF_REALESTATE(e.target.value).then(function (res) {
                _this44.set_entities_comparison_and_homogenisation();
            });
        }, 1000),
        set_marketstudy_weighing_adopted_age: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this45 = this;

            this.SET_MARKETSTUDY_WEIGHING_ADOPTED_AGE(e.target.value).then(function (res) {
                _this45.set_entities_comparison_and_homogenisation();
            });
        }, 1000),
        set_marketstudy_weighing_conservation_status: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this46 = this;

            this.SET_MARKETSTUDY_WEIGHING_CONSERVATION_STATUS(e.target.value).then(function (res) {
                _this46.set_entities_comparison_and_homogenisation();
            });
        }, 1000),
        set_marketstudy_weighing_floor_number: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this47 = this;

            this.SET_MARKETSTUDY_WEIGHING_FLOOR_NUMBER(e.target.value).then(function (res) {
                _this47.set_entities_comparison_and_homogenisation();
            });
        }, 1000),
        set_marketstudy_weighing_adopted_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this48 = this;

            this.SET_MARKETSTUDY_WEIGHING_ADOPTED_AREA(e.target.value).then(function (res) {
                _this48.set_entities_comparison_and_homogenisation();
            });
        }, 1000),
        set_marketstudy_weighing_lift: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this49 = this;

            this.SET_MARKETSTUDY_WEIGHING_LIFT(e.target.value).then(function (res) {
                _this49.set_entities_comparison_and_homogenisation();
            });
        }, 1000),
        set_marketstudy_prices_estimated_yearly_evolution_pct: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_MARKETSTUDY_PRICES_ESTIMATED_YEARLY_EVOLUTION_PCT(Number(e.target.value));
        }, 1000),
        set_marketstudy_market_value_evolution_probability_pct: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_MARKETSTUDY_MARKET_VALUE_EVOLUTION_PROBABILITY_PCT(Number(e.target.value));
        }, 1000),
        set_marketstudy_offer_production: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_MARKETSTUDY_OFFER_PRODUCTION(e);
        }, 1000),
        set_marketstudy_offer_yearly_stock: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_MARKETSTUDY_OFFER_YEARLY_STOCK(e);
        }, 1000),
        set_marketstudy_offer_trend: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_MARKETSTUDY_OFFER_TREND(e);
        }, 1000),
        set_marketstudy_demand_level: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_MARKETSTUDY_DEMAND_LEVEL(e);
        }, 1000),
        set_marketstudy_demand_speed_of_sales: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_MARKETSTUDY_DEMAND_SPEED_OF_SALES(e);
        }, 1000),
        set_marketstudy_demand_trend: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_MARKETSTUDY_DEMAND_TREND(e);
        }, 1000),
        set_marketstudy_prices_expectancy: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_MARKETSTUDY_PRICES_EXPECTANCY(e);
        }, 1000),
        set_marketstudy_prices_past_cicles_volatility: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_MARKETSTUDY_PRICES_PAST_CICLES_VOLATILITY(e);
        }, 1000),
        set_marketstudy_market_conjuncture: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_MARKETSTUDY_MARKET_CONJUNCTURE(e);
        }, 1000),
        set_marketstudy_market_value_reduction_probability_expectancy: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_MARKETSTUDY_MARKET_VALUE_REDUCTION_PROBABILITY_EXPECTANCY(e);
        }, 1000),
        set_marketstudy_prices_max: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_MARKETSTUDY_PRICES_MAX(Number(e.target.value));
        }, 1000),
        set_marketstudy_prices_min: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_MARKETSTUDY_PRICES_MIN(Number(e.target.value));
        }, 1000),
        set_marketstudy_prices_mean: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_MARKETSTUDY_PRICES_MEAN(Number(e.target.value));
        }, 1000),
        set_marketstudy_prices_median: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_MARKETSTUDY_PRICES_MEDIAN(Number(e.target.value));
        }, 1000),
        set_entities_comparison_and_homogenisation: function set_entities_comparison_and_homogenisation() {
            var _this50 = this;

            var unit_prices = [];
            var obj = this.marketstudy_ad_comparables;
            for (var key in obj) {

                var compared_value = null;
                var appraised_value = null;
                var comp_result = null;

                unit_prices.push(obj[key]['estimated_unit_sale_price']);

                var end_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.appraisal_tabulation[0].appraisaldate).add(6, 'months');
                var start_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.appraisal_tabulation[0].appraisaldate).subtract(6, 'months');

                if (__WEBPACK_IMPORTED_MODULE_3_moment___default()(obj[key].ad_date).isBetween(start_date, end_date)) {
                    obj[key]['comp_ad_date'] = 'S';
                } else {
                    obj[key]['comp_ad_date'] = 'INVALID';
                }

                if (obj[key].property_type && this.appraisal_tabulation[0].property_type) {
                    compared_value = obj[key].property_type.name_es.toLowerCase();
                    appraised_value = this.appraisal_tabulation[0].property_type.name_es.toLowerCase();
                    comp_result = this.compare_property_type(compared_value, appraised_value);
                } else {
                    comp_result = 'S';
                }
                obj[key]['comp_property_type'] = comp_result;
                var homg_result = this.homogenize(comp_result, this.weighing[0].property_type);
                obj[key]['homg_property_type'] = homg_result;

                if (obj[key].quality_of_neighbourhood && this.appraisal_tabulation[0].quality_of_neighbourhood) {
                    compared_value = obj[key].quality_of_neighbourhood.code_bde;
                    appraised_value = this.appraisal_tabulation[0].quality_of_neighbourhood.code_bde;
                    comp_result = this.compare_values(compared_value, appraised_value);
                } else {
                    comp_result = 'S';
                }
                obj[key]['comp_quality_of_neighbourhood'] = comp_result;
                homg_result = this.homogenize(comp_result, this.weighing[0].quality_of_neighbourhood);
                obj[key]['homg_quality_of_neighbourhood'] = homg_result;

                if (obj[key].quality_of_situation && this.appraisal_tabulation[0].quality_of_situation) {
                    compared_value = obj[key].quality_of_situation.code_bde;
                    appraised_value = this.appraisal_tabulation[0].quality_of_situation.code_bde;
                    comp_result = this.compare_values(compared_value, appraised_value);
                }
                obj[key]['comp_quality_of_situation'] = comp_result;
                homg_result = this.homogenize(comp_result, this.weighing[0].quality_of_situation);
                obj[key]['homg_quality_of_situation'] = homg_result;

                if (obj[key].quality_of_construction && this.appraisal_tabulation[0].quality_of_construction) {
                    compared_value = obj[key].quality_of_construction.code_bde;
                    appraised_value = this.appraisal_tabulation[0].quality_of_construction.code_bde;
                    comp_result = this.compare_values(compared_value, appraised_value);
                } else {
                    comp_result = 'S';
                }
                obj[key]['comp_quality_of_construction'] = comp_result;
                homg_result = this.homogenize(comp_result, this.weighing[0].quality_of_construction);
                obj[key]['homg_quality_of_construction'] = homg_result;

                if (obj[key].quality_of_realestate && this.appraisal_tabulation[0].quality_of_realestate) {
                    compared_value = obj[key].quality_of_realestate.code_bde;
                    appraised_value = this.appraisal_tabulation[0].quality_of_realestate.code_bde;
                    comp_result = this.compare_values(compared_value, appraised_value);
                } else {
                    comp_result = 'S';
                }
                obj[key]['comp_quality_of_realestate'] = comp_result;
                homg_result = this.homogenize(comp_result, this.weighing[0].quality_of_realestate);
                obj[key]['homg_quality_of_realestate'] = homg_result;

                if (obj[key].adopted_age) {
                    compared_value = obj[key].adopted_age;
                    appraised_value = this.appraisal_tabulation[0].adopted_age;
                    comp_result = this.compare_age(compared_value, appraised_value);
                } else {
                    comp_result = 'S';
                }
                obj[key]['comp_adopted_age'] = comp_result;
                homg_result = this.homogenize(comp_result, this.weighing[0].adopted_age);
                obj[key]['homg_adopted_age'] = homg_result;

                if (obj[key].conservation_status && this.appraisal_tabulation[0].conservation_status) {
                    compared_value = obj[key].conservation_status.code_bde;
                    appraised_value = this.appraisal_tabulation[0].conservation_status.code_bde;
                    comp_result = this.compare_conservation_status(compared_value, appraised_value);
                } else {
                    comp_result = 'S';
                }
                obj[key]['comp_conservation_status'] = comp_result;
                homg_result = this.homogenize(comp_result, this.weighing[0].conservation_status);
                obj[key]['homg_conservation_status'] = homg_result;

                if (obj[key].floor_number && this.appraisal_tabulation[0].floor_number) {
                    compared_value = obj[key].floor_number;
                    appraised_value = this.appraisal_tabulation[0].floor_number;
                    comp_result = this.compare_floor_number(compared_value, appraised_value);
                } else {
                    comp_result = 'S';
                }
                obj[key]['comp_floor_number'] = comp_result;
                homg_result = this.homogenize(comp_result, this.weighing[0].floor_number);
                obj[key]['homg_floor_number'] = homg_result;

                if (obj[key].adopted_area && this.appraisal_tabulation[0].adopted_area) {
                    compared_value = obj[key].adopted_area;
                    appraised_value = this.appraisal_tabulation[0].adopted_area;
                    comp_result = this.compare_area(compared_value, appraised_value);
                } else {
                    comp_result = 'S';
                }
                obj[key]['comp_adopted_area'] = comp_result;
                homg_result = this.homogenize(comp_result, this.weighing[0].adopted_area);
                obj[key]['homg_adopted_area'] = homg_result;

                compared_value = obj[key].lift;
                appraised_value = this.appraisal_tabulation[0].lift;
                comp_result = this.compare_lift(compared_value, appraised_value);

                obj[key]['comp_lift'] = comp_result;
                homg_result = this.homogenize(comp_result, this.weighing[0].lift);
                obj[key]['homg_lift'] = homg_result;
            }

            var prices_max = this.roundToTwo(this.calcMax(unit_prices));
            var prices_min = this.roundToTwo(this.calcMin(unit_prices));
            var prices_mean = this.roundToTwo(this.calcMean(unit_prices));
            var prices_median = this.roundToTwo(this.calcMedian(unit_prices));

            this.SET_MARKETSTUDY_PRICES_MAX(prices_max);
            this.SET_MARKETSTUDY_PRICES_MIN(prices_min);
            this.SET_MARKETSTUDY_PRICES_MEAN(prices_mean);
            this.SET_MARKETSTUDY_PRICES_MEDIAN(prices_median);

            this.SET_MARKETSTUDY_AD_COMPARABLES(obj).then(function (res) {
                _this50.set_homogenisation_totals();
            });
        },
        set_import_appraisalfile: function set_import_appraisalfile() {
            var _this51 = this;

            console.log('set_import_appraisalfile');
            this.master_loading = true;
            this.FETCH_TEMP_APPRAISALFILE_APPRAISALREPORTS({ path: 'appraisalfiles' + '/' + this.marketstudy.importAppraisalFile.id + '/' + 'appraisalreports' }).then(function () {
                _this51.master_loading = false;
            });
        },
        set_import_report: function set_import_report() {
            var _this52 = this;

            console.log('set_import_report');
            this.master_loading = true;
            this.FETCH_TEMP_APPRAISALREPORT_REALESTATES({ path: 'appraisalreports' + '/' + this.marketstudy.importReport.id + '/' + 'realestates' + '/' }).then(function () {
                _this52.master_loading = false;
            });
        },
        set_import_realestate: function set_import_realestate() {
            var _this53 = this;

            console.log('set_import_realestate');
            this.master_loading = true;
            this.FETCH_TEMP_REALESTATE_MARKETSTUDIES({ path: 'realestate_marketstudies' + '/' + this.marketstudy.importRealEstate.id + '/' }).then(function () {
                _this53.master_loading = false;
            });
        },
        set_homogenisation_totals: function set_homogenisation_totals() {
            var _this54 = this;

            var obj = this.marketstudy_ad_comparables;

            var univ_dev_obj = {
                '0': {}
            };
            var repr_dev_obj = {
                '0': {}
            };

            var univ_n = 0;

            var univ_Xi_total = 0;
            var univ_Vu_total = 0;
            var univ_Vi_total = 0;
            var univ_Vu2_total = 0;
            var univ_XiVi_total = 0;
            var univ_Xi2_total = 0;
            var univ_Vi2_total = 0;

            var arr_vi_univ = [];
            var arr_vu_univ = [];
            var arr_xi_univ = [];

            for (var key in obj) {

                var homg_total = this.check_undefined_get_number(obj[key].homg_property_type) + this.check_undefined_get_number(obj[key].homg_quality_of_neighbourhood) + this.check_undefined_get_number(obj[key].homg_quality_of_situation) + this.check_undefined_get_number(obj[key].homg_quality_of_construction) + this.check_undefined_get_number(obj[key].homg_quality_of_realestate) + this.check_undefined_get_number(obj[key].homg_adopted_age) + this.check_undefined_get_number(obj[key].homg_conservation_status) + this.check_undefined_get_number(obj[key].homg_floor_number) + this.check_undefined_get_number(obj[key].homg_adopted_area) + this.check_undefined_get_number(obj[key].homg_lift);

                var adopted_area = obj[key]['adopted_area'];

                var calc_initial_unit_price = Number(obj[key]['estimated_unit_sale_price']);
                var calc_correction_pct = homg_total;
                var calc_final_unit_price = calc_initial_unit_price + calc_initial_unit_price * (calc_correction_pct / 100);

                var calc_Xi = Number(adopted_area);
                var calc_Vu = calc_final_unit_price;
                var calc_Vi = calc_Xi * calc_Vu;
                var calc_Vu2 = Math.pow(calc_Vu, 2);
                var calc_XiVi = calc_Xi * calc_Vi;
                var calc_Xi2 = Math.pow(calc_Xi, 2);
                var calc_Vi2 = Math.pow(calc_Vi, 2);

                obj[key]['homg_total'] = homg_total;
                obj[key]['calc_initial_unit_price'] = calc_initial_unit_price;
                obj[key]['calc_correction_pct'] = calc_correction_pct;
                obj[key]['calc_final_unit_price'] = calc_final_unit_price;
                obj[key]['calc_Xi'] = calc_Xi;
                obj[key]['calc_Vu'] = calc_Vu;
                obj[key]['calc_Vi'] = calc_Vi;
                obj[key]['calc_Vu2'] = calc_Vu2;
                obj[key]['calc_XiVi'] = calc_XiVi;
                obj[key]['calc_Xi2'] = calc_Xi2;
                obj[key]['calc_Vi2'] = calc_Vi2;

                univ_n = univ_n + 1;

                arr_xi_univ.push(calc_Xi);
                arr_vu_univ.push(calc_Vu);
                arr_vi_univ.push(calc_Vi);

                univ_Xi_total = univ_Xi_total + calc_Xi;
                univ_Vu_total = univ_Vu_total + calc_Vu;
                univ_Vi_total = univ_Vi_total + calc_Vi;
                univ_Vu2_total = univ_Vu2_total + calc_Vu2;
                univ_XiVi_total = univ_XiVi_total + calc_XiVi;
                univ_Xi2_total = univ_Xi2_total + calc_Xi2;
                univ_Vi2_total = univ_Vi2_total + calc_Vi2;
            }

            var univ_summation_vu2_n = univ_Vu2_total / univ_n;
            //console.log('univ_summation_vu2_n: ' + univ_summation_vu2_n)

            var univ_summation_vu_n_2 = Math.pow(univ_Vu_total / univ_n, 2);
            //console.log('univ_summation_vu_n_2: ' + univ_summation_vu_n_2)

            var univ_g2 = univ_summation_vu2_n - univ_summation_vu_n_2;
            //console.log('univ_g2: ' + univ_g2)

            var univ_g = Math.sqrt(univ_g2);
            //console.log('univ_g: ' + univ_g)

            var univ_t = univ_XiVi_total;
            //console.log('univ_t: ' + univ_t)

            var univ_s = univ_Xi_total;
            //console.log('univ_s: ' + univ_s)

            var univ_s2 = univ_Xi2_total;
            //console.log('univ_s2: ' + univ_s2)

            var univ_r = univ_Vi_total;
            //console.log('univ_r: ' + univ_r)

            var univ_m = univ_r / univ_n;
            //console.log('univ_m: ' + univ_m)

            var univ_na = univ_s / univ_n;
            //console.log('univ_na: ' + univ_na)

            var univ_t_ms = univ_t - univ_m * univ_s;
            //console.log('univ_t_ms: ' + univ_t_ms)

            var univ_s2_nas = univ_s2 - univ_na * univ_s;
            //console.log('univ_s2_nas: ' + univ_s2_nas)

            var univ_a = univ_t_ms / univ_s2_nas;
            //console.log('univ_a: ' + univ_a)

            var univ_b = (univ_r - univ_s * univ_a) / univ_n;
            //console.log('univ_b: ' + univ_b)

            var univ_Vu_average = univ_Vu_total / univ_n;
            var univ_coef_V = univ_g / univ_Vu_average;

            //console.log('univ_Vu_average: ' + univ_Vu_average)
            //console.log('univ_coef_V: ' + univ_coef_V)

            // console.log('arr_vi_univ: ')
            // console.log(arr_vi_univ)
            var univ_vi_max = Math.max.apply(null, arr_vi_univ);
            // console.log('univ_vi_max: ' + univ_vi_max)
            var univ_vi_min = Math.min.apply(null, arr_vi_univ);

            var univ_vu_max = Math.max.apply(null, arr_vu_univ);
            var univ_vu_min = Math.min.apply(null, arr_vu_univ);

            var univ_xi_max = Math.max.apply(null, arr_xi_univ);
            var univ_xi_min = Math.min.apply(null, arr_xi_univ);

            univ_dev_obj['0']['Xi_total'] = univ_Xi_total;
            univ_dev_obj['0']['Vu_total'] = univ_Vu_total;
            univ_dev_obj['0']['Vi_total'] = univ_Vi_total;
            univ_dev_obj['0']['Vu2_total'] = univ_Vu2_total;
            univ_dev_obj['0']['XiVi_total'] = univ_XiVi_total;
            univ_dev_obj['0']['Xi2_total'] = univ_Xi2_total;
            univ_dev_obj['0']['Vi2_total'] = univ_Vi2_total;

            univ_dev_obj['0']['n'] = univ_n;
            univ_dev_obj['0']['Vu_average'] = univ_Vu_average;
            univ_dev_obj['0']['V_coef'] = univ_coef_V;
            univ_dev_obj['0']['Vu2_n'] = univ_summation_vu2_n;
            univ_dev_obj['0']['Vu_n_2'] = univ_summation_vu_n_2;
            univ_dev_obj['0']['summation_Vu2_n'] = univ_summation_vu2_n;
            univ_dev_obj['0']['summation_Vu_n_2'] = univ_summation_vu_n_2;
            univ_dev_obj['0']['g2'] = univ_g2;
            univ_dev_obj['0']['g'] = univ_g;
            univ_dev_obj['0']['t'] = univ_t;
            univ_dev_obj['0']['s'] = univ_s;
            univ_dev_obj['0']['s2'] = univ_s2;
            univ_dev_obj['0']['r'] = univ_r;
            univ_dev_obj['0']['m'] = univ_m;
            univ_dev_obj['0']['na'] = univ_na;
            univ_dev_obj['0']['t_ms'] = univ_t_ms;
            univ_dev_obj['0']['s2_nas'] = univ_s2_nas;
            univ_dev_obj['0']['a'] = univ_a;
            univ_dev_obj['0']['b'] = univ_b;

            var limit_upper = this.roundToTwo(univ_Vu_average * (1 + univ_coef_V));
            var limit_lower = this.roundToTwo(univ_Vu_average * (1 - univ_coef_V));

            //console.log('limit_upper: ' + limit_upper)
            //console.log('limit_lower: ' + limit_lower)

            var repr_n = 0;

            var repr_Vi_total = 0;

            var repr_Vi2_total = 0;

            var repr_Vu_total = 0;

            var repr_Vu2_total = 0;

            var repr_Xi_total = 0;

            var repr_Xi2_total = 0;

            var repr_XiVi_total = 0;

            var arr_vu_repr = [];

            var scatter_points = [];

            for (var _key in obj) {

                var _adopted_area = obj[_key]['adopted_area'];
                var _calc_initial_unit_price = Number(obj[_key]['estimated_unit_sale_price']);
                var _calc_correction_pct = obj[_key]['homg_total'];
                var _calc_final_unit_price = obj[_key]['calc_final_unit_price'];

                var _calc_Xi = obj[_key]['calc_Xi'];
                var _calc_Vu = obj[_key]['calc_Vu'];
                var _calc_Vi = obj[_key]['calc_Vi'];
                var _calc_Vu2 = obj[_key]['calc_Vu2'];
                var _calc_XiVi = obj[_key]['calc_XiVi'];
                var _calc_Xi2 = obj[_key]['calc_Xi2'];
                var _calc_Vi2 = obj[_key]['calc_Vi2'];

                var address = obj[_key]['google_formatted_address'];
                /*
                scatter_points.push({
                x: calc_Xi,
                y: calc_Vi,
                r: 4
                })
                */
                // scatter_points.push([address, calc_Xi, calc_Vi, 'Comparables', 12])
                scatter_points.push([_calc_Xi, _calc_Vi, null]);

                if (_calc_Vu > limit_upper) {} else if (_calc_Vu < limit_lower) {} else {

                    repr_n = repr_n + 1;

                    arr_vu_repr.push(_calc_Vu);

                    repr_Xi_total = repr_Xi_total + _calc_Xi;
                    repr_Vu_total = repr_Vu_total + _calc_Vu;
                    repr_Vi_total = repr_Vi_total + _calc_Vi;
                    repr_Vu2_total = repr_Vu2_total + _calc_Vu2;
                    repr_XiVi_total = repr_XiVi_total + _calc_XiVi;
                    repr_Xi2_total = repr_Xi2_total + _calc_Xi2;
                    repr_Vi2_total = repr_Vi2_total + _calc_Vi2;
                }
            }

            //console.log('repr_n: ' + repr_n);

            var repr_summation_vu2_n = repr_Vu2_total / repr_n;
            //console.log('repr_summation_vu2_n: ' + repr_summation_vu2_n);

            var repr_summation_vu_n_2 = Math.pow(repr_Vu_total / repr_n, 2);
            //console.log('repr_summation_vu_n_2: ' + repr_summation_vu_n_2);

            var repr_g2 = repr_summation_vu2_n - repr_summation_vu_n_2;
            //console.log('repr_g2: ' + repr_g2);

            var repr_g = Math.sqrt(repr_g2);
            //console.log('repr_g: ' + repr_g);

            var repr_t = repr_XiVi_total;
            //console.log('repr_t: ' + repr_t);

            var repr_s = repr_Xi_total;
            //console.log('repr_s: ' + repr_s);

            var repr_s2 = repr_Xi2_total;
            //console.log('repr_s2: ' + repr_s2);

            var repr_r = repr_Vi_total;
            //console.log('repr_r: ' + repr_r);

            var repr_m = repr_r / repr_n;
            //console.log('repr_m : ' + repr_m);

            var repr_na = repr_s / repr_n;
            //console.log('repr_na: ' + repr_na);

            var repr_t_ms = repr_t - repr_m * repr_s;
            //console.log('repr_t_ms : ' + repr_t_ms);

            var repr_s2_nas = repr_s2 - repr_na * repr_s;
            //console.log('repr_s2_nas: ' + repr_s2_nas);

            var repr_a = repr_t_ms / repr_s2_nas;
            //console.log('repr_a: ' + repr_a);

            if (repr_a === Number.POSITIVE_INFINITY || repr_a === Number.NEGATIVE_INFINITY) {
                console.log('repr_A ÉS INFINIT !!!!!!!!! canviem a null per evitar error a firebase');

                repr_a = null;
            }

            var factor_corrector_x = 0;
            var factor_corrector_y = 0;

            var repr_b = factor_corrector_x * factor_corrector_y + (repr_r - repr_s * repr_a) / repr_n;
            //console.log('repr_b: ' + repr_b);

            if (repr_b === Number.POSITIVE_INFINITY || repr_b === Number.NEGATIVE_INFINITY) {
                console.log('repr_B ÉS INFINIT !!!!!!!!! canviem a null per evitar error a firebase');

                repr_b = null;
            }

            var repr_vu_max = Math.max.apply(null, arr_vu_repr);
            var repr_vu_min = Math.min.apply(null, arr_vu_repr);

            repr_dev_obj['0']['Xi_total'] = repr_Xi_total;
            repr_dev_obj['0']['Vu_total'] = repr_Vu_total;
            repr_dev_obj['0']['Vi_total'] = repr_Vi_total;
            repr_dev_obj['0']['Vu2_total'] = repr_Vu2_total;
            repr_dev_obj['0']['XiVi_total'] = repr_XiVi_total;
            repr_dev_obj['0']['Xi2_total'] = repr_Xi2_total;
            repr_dev_obj['0']['Vi2_total'] = repr_Vi2_total;

            repr_dev_obj['0']['limit_upper'] = limit_upper;
            repr_dev_obj['0']['limit_lower'] = limit_lower;

            repr_dev_obj['0']['n'] = repr_n;
            repr_dev_obj['0']['Vu_max'] = repr_vu_max;
            repr_dev_obj['0']['Vu_min'] = repr_vu_min;
            repr_dev_obj['0']['summation_Vu2_n'] = repr_summation_vu2_n;
            repr_dev_obj['0']['summation_Vu_n_2'] = repr_summation_vu_n_2;
            repr_dev_obj['0']['g2'] = repr_g2;
            repr_dev_obj['0']['g'] = repr_g;
            repr_dev_obj['0']['t'] = repr_t;
            repr_dev_obj['0']['s'] = repr_s;
            repr_dev_obj['0']['s2'] = repr_s2;
            repr_dev_obj['0']['r'] = repr_r;
            repr_dev_obj['0']['m'] = repr_m;
            repr_dev_obj['0']['na'] = repr_na;
            repr_dev_obj['0']['t_ms'] = repr_t_ms;
            repr_dev_obj['0']['s2_nas'] = repr_s2_nas;
            repr_dev_obj['0']['a'] = repr_a;
            repr_dev_obj['0']['b'] = repr_b;

            var regressionline_points = [];

            // increment de superfície (22 metres), com a constant per a càlcular increment de superfície per a cada punt en la formula de la línia, segons plantilla excel
            var increment = 22;

            //console.log('univ_xi_min: ' + univ_xi_min);
            //console.log('repr_a: ' + repr_a);
            //console.log('repr_b: ' + repr_b);

            regressionline_points.push({
                x: univ_xi_min - increment * 0.4,
                y: repr_a * (univ_xi_min - increment * 0.4) + repr_b
            });

            regressionline_points.push({
                x: (univ_vi_max + increment * 400 - repr_b) / repr_a,
                y: univ_vi_max + increment * 400
            });

            var adopted_area_appraised = Number(this.appraisal.adopted_area);
            var market_value = this.roundToTwo(repr_a * adopted_area_appraised + repr_b);
            var market_unit_value = this.roundToTwo(market_value / adopted_area_appraised);

            scatter_points.push([adopted_area_appraised, null, market_value]);

            this.SET_MARKETSTUDY_MARKET_VALUE(market_value);
            this.SET_MARKETSTUDY_MARKET_UNIT_VALUE(market_unit_value);

            /*
            this.SET_MARKETSTUDY_APPRAISED_POINTS(appraised_points).then((res) => {
            })
            */

            this.SET_MARKETSTUDY_COMPARABLE_POINTS(scatter_points).then(function (res) {
                console.log('scatter_points: ');
                console.log(scatter_points);
                _this54.regressionline_chart.rows = scatter_points;

                /*
                html2canvas(document.querySelector("#regline")).then(canvas => {
                document.body.appendChild(canvas)
                })
                */
            });
            this.SET_MARKETSTUDY_REGRESSIONLINE_POINTS(regressionline_points).then(function (res) {});

            this.SET_MARKETSTUDY_UNIVERSAL_SAMPLE_TYPICAL_DEVIATION(univ_dev_obj).then(function (res) {
                _this54.SET_MARKETSTUDY_REPRESENTATIVE_SAMPLE_TYPICAL_DEVIATION(repr_dev_obj).then(function (res) {
                    _this54.SET_MARKETSTUDY_AD_COMPARABLES(obj).then(function (res) {
                        _this54.$forceUpdate();
                    });
                });
            });
        },
        homogenize: function homogenize(comp_result, weight) {

            weight = parseInt(weight);
            var homg_result = 0;

            if (comp_result === 'MMM') {
                homg_result = -3 * weight;
            } else if (comp_result === 'MM') {
                homg_result = -2 * weight;
            } else if (comp_result === 'M') {
                homg_result = -1 * weight;
            } else if (comp_result === 'S') {
                homg_result = 0;
            } else if (comp_result === 'P') {
                homg_result = 1 * weight;
            } else if (comp_result === 'PP') {
                homg_result = 2 * weight;
            } else if (comp_result === 'PPP') {
                homg_result = 3 * weight;
            }

            return homg_result;
        },
        compare_property_type: function compare_property_type(compared_value, appraised_value) {
            // console.log('compared_value: ' + compared_value)
            // console.log('appraised_value: ' + appraised_value)
            var comp_result = 'S';

            if (appraised_value === 'piso') {
                if (compared_value === 'piso') {
                    comp_result = 'S';
                } else if (compared_value === 'loft') {
                    comp_result = 'S';
                } else if (compared_value === 'dúplex') {
                    comp_result = 'S';
                } else if (compared_value === 'triplex') {
                    comp_result = 'S';
                } else if (compared_value === 'apartamento') {
                    comp_result = 'S';
                } else if (compared_value === 'casa adosada') {
                    comp_result = 'M';
                } else if (compared_value === 'bajos') {
                    comp_result = 'P';
                } else if (compared_value === 'torre') {
                    comp_result = 'MM';
                } else if (compared_value === 'ático') {
                    comp_result = 'MM';
                } else if (compared_value === 'casa independiente') {
                    comp_result = 'MM';
                } else if (compared_value === 'trastero') {
                    comp_result = 'PPP';
                } else if (compared_value === 'plaza de aparcamiento') {
                    comp_result = 'PPP';
                } else {
                    comp_result = 'S';
                }
            } else if (appraised_value === 'ático') {
                if (compared_value === 'piso') {
                    comp_result = 'PP';
                } else if (compared_value === 'loft') {
                    comp_result = 'P';
                } else if (compared_value === 'dúplex') {
                    comp_result = 'P';
                } else if (compared_value === 'triplex') {
                    comp_result = 'P';
                } else if (compared_value === 'apartamento') {
                    comp_result = 'P';
                } else if (compared_value === 'casa adosada') {
                    comp_result = 'P';
                } else if (compared_value === 'bajos') {
                    comp_result = 'PP';
                } else if (compared_value === 'torre') {
                    comp_result = 'S';
                } else if (compared_value === 'ático') {
                    comp_result = 'S';
                } else if (compared_value === 'casa independiente') {
                    comp_result = 'S';
                } else if (compared_value === 'trastero') {
                    comp_result = 'PPP';
                } else if (compared_value === 'plaza de aparcamiento') {
                    comp_result = 'PPP';
                } else {
                    comp_result = 'S';
                }
            } else if (appraised_value === 'bajos') {
                if (compared_value === 'piso') {
                    comp_result = 'MM';
                } else if (compared_value === 'loft') {
                    comp_result = 'MM';
                } else if (compared_value === 'dúplex') {
                    comp_result = 'MM';
                } else if (compared_value === 'triplex') {
                    comp_result = 'MM';
                } else if (compared_value === 'apartamento') {
                    comp_result = 'MM';
                } else if (compared_value === 'casa adosada') {
                    comp_result = 'MM';
                } else if (compared_value === 'bajos') {
                    comp_result = 'S';
                } else if (compared_value === 'torre') {
                    comp_result = 'MM';
                } else if (compared_value === 'ático') {
                    comp_result = 'MMM';
                } else if (compared_value === 'casa independiente') {
                    comp_result = 'MM';
                } else if (compared_value === 'trastero') {
                    comp_result = 'PPP';
                } else if (compared_value === 'plaza de aparcamiento') {
                    comp_result = 'PPP';
                } else {
                    comp_result = 'S';
                }
            }

            return comp_result;
        },
        compare_conservation_status: function compare_conservation_status(compared_value, appraised_value) {
            // console.log('compared_value: ' + compared_value)
            // console.log('appraised_value: ' + appraised_value)

            var comp_result = 'S';

            if (compared_value === 1 && appraised_value === 1) {
                comp_result = 'S';
            } else if (compared_value === 1 && appraised_value === 2) {
                comp_result = 'M';
            } else if (compared_value === 1 && appraised_value === 3) {
                comp_result = 'MM';
            } else if (compared_value === 1 && appraised_value === 4) {
                comp_result = 'MMM';
            } else if (compared_value === 1 && appraised_value === 5) {
                comp_result = 'S';
            } else if (compared_value === 2 && appraised_value === 1) {
                comp_result = 'P';
            } else if (compared_value === 2 && appraised_value === 2) {
                comp_result = 'S';
            } else if (compared_value === 2 && appraised_value === 3) {
                comp_result = 'M';
            } else if (compared_value === 2 && appraised_value === 4) {
                comp_result = 'MM';
            } else if (compared_value === 2 && appraised_value === 5) {
                comp_result = 'S';
            } else if (compared_value === 3 && appraised_value === 1) {
                comp_result = 'PP';
            } else if (compared_value === 3 && appraised_value === 2) {
                comp_result = 'P';
            } else if (compared_value === 3 && appraised_value === 3) {
                comp_result = 'S';
            } else if (compared_value === 3 && appraised_value === 4) {
                comp_result = 'M';
            } else if (compared_value === 3 && appraised_value === 5) {
                comp_result = 'S';
            } else if (compared_value === 4 && appraised_value === 1) {
                comp_result = 'PPP';
            } else if (compared_value === 4 && appraised_value === 2) {
                comp_result = 'PP';
            } else if (compared_value === 4 && appraised_value === 3) {
                comp_result = 'P';
            } else if (compared_value === 4 && appraised_value === 4) {
                comp_result = 'S';
            } else if (compared_value === 4 && appraised_value === 5) {
                comp_result = 'S';
            }

            return comp_result;
        },
        compare_lift: function compare_lift(compared_value, appraised_value) {
            // console.log('compared_value: ' + compared_value)
            // console.log('appraised_value: ' + appraised_value)
            var comp_result = 'S';

            if (compared_value === true && appraised_value === true) {
                comp_result = 'S';
            } else if (compared_value === true && appraised_value === false) {
                comp_result = 'MM';
            } else if (compared_value === false && appraised_value === true) {
                comp_result = 'PP';
            } else if (compared_value === false && appraised_value === false) {
                comp_result = 'S';
            }
            return comp_result;
        },
        compare_floor_number: function compare_floor_number(compared_value, appraised_value) {

            //compared_value = parseInt(compared_value)
            //appraised_value = parseInt(appraised_value)
            //console.log('compared_value: ' + compared_value)
            //console.log('appraised_value: ' + appraised_value)
            var comp_result = 'S';

            if (compared_value === appraised_value) {
                comp_result = 'S';
            } else if (compared_value > appraised_value) {
                if (compared_value > appraised_value + 2) {
                    comp_result = 'MM';
                } else if (compared_value > appraised_value + 1) {
                    comp_result = 'M';
                } else {
                    comp_result = 'S';
                }
            } else if (compared_value < appraised_value) {
                comp_result = 'S';
                if (compared_value < appraised_value - 1) {
                    comp_result = 'P';
                }
                if (compared_value < appraised_value - 2) {
                    comp_result = 'PP';
                }
            }
            return comp_result;
        },
        compare_area: function compare_area(compared_value, appraised_value) {
            // console.log('compared_value: ' + compared_value)
            // console.log('appraised_value: ' + appraised_value)
            var comp_result = 'S';

            if (compared_value < appraised_value * 0.5) {
                comp_result = 'MM';
            } else if (compared_value < appraised_value * 0.9) {
                comp_result = 'M';
            } else if (compared_value < appraised_value * 1.2) {
                comp_result = 'S';
            } else if (compared_value < appraised_value * 1.4) {
                comp_result = 'P';
            } else if (compared_value < appraised_value * 1.6) {
                comp_result = 'PP';
            } else {
                comp_result = 'PP';
            }

            return comp_result;
        },
        compare_age: function compare_age(compared_value, appraised_value) {
            // console.log('compared_value: ' + compared_value)
            // console.log('appraised_value: ' + appraised_value)
            var comp_result = 'S';

            if (appraised_value - compared_value > 20) {
                comp_result = 'PP';
            } else if (appraised_value - compared_value > 10) {
                comp_result = 'P';
            } else if (appraised_value - compared_value > -10) {
                comp_result = 'S';
            } else if (appraised_value - compared_value > -20) {
                comp_result = 'M';
            } else {
                comp_result = 'MM';
            }

            return comp_result;
        },
        compare_values: function compare_values(compared_value, appraised_value) {

            // console.log('compared_value: ' + compared_value)
            // console.log('appraised_value: ' + appraised_value)
            var comp_result = 'S';

            if (compared_value === 5) {
                comp_result = 'S';
            } else if (appraised_value === 5) {
                comp_result = 'S';
            } else if (compared_value === 1 && appraised_value === 1) {
                comp_result = 'S';
            } else if (compared_value === 1 && appraised_value === 2) {
                comp_result = 'M';
            } else if (compared_value === 1 && appraised_value === 3) {
                comp_result = 'MM';
            } else if (compared_value === 1 && appraised_value === 4) {
                comp_result = 'MMM';
            } else if (compared_value === 2 && appraised_value === 1) {
                comp_result = 'P';
            } else if (compared_value === 2 && appraised_value === 2) {
                comp_result = 'S';
            } else if (compared_value === 2 && appraised_value === 3) {
                comp_result = 'M';
            } else if (compared_value === 2 && appraised_value === 4) {
                comp_result = 'MM';
            } else if (compared_value === 3 && appraised_value === 1) {
                comp_result = 'PP';
            } else if (compared_value === 3 && appraised_value === 2) {
                comp_result = 'P';
            } else if (compared_value === 3 && appraised_value === 3) {
                comp_result = 'S';
            } else if (compared_value === 3 && appraised_value === 4) {
                comp_result = 'M';
            } else if (compared_value === 4 && appraised_value === 1) {
                comp_result = 'PPP';
            } else if (compared_value === 4 && appraised_value === 2) {
                comp_result = 'PP';
            } else if (compared_value === 4 && appraised_value === 3) {
                comp_result = 'P';
            } else if (compared_value === 4 && appraised_value === 4) {
                comp_result = 'S';
            }

            return comp_result;
        },
        onOpenCadastralMap: function onOpenCadastralMap() {
            console.log('opening cadastral map...');

            var url = 'https://www1.sedecatastro.gob.es/Cartografia/mapa.aspx?del=' + this.realestate.municipality.cadaster_province_code + '&mun=' + this.realestate.municipality.cadaster_municipality_code + '&refcat=' + this.realestate.cadastral_reference + '&final=';
            var win = window.open(url, '_blank');
            win.focus();
        },
        onSaveCurrentMarketStudy: function onSaveCurrentMarketStudy(data) {
            var _this55 = this;

            return new Promise(function (resolve, reject) {

                var updateAppraisal = function updateAppraisal(data) {
                    return new Promise(function (resolve, reject) {
                        _this55.UPDATE_APPRAISAL(data).then(function (res) {
                            resolve(res);
                        });
                    });
                };

                var fetchAppraisal = function fetchAppraisal(data) {
                    return new Promise(function (resolve, reject) {
                        _this55.$store.dispatch('FETCH_APPRAISAL', data).then(function (res) {
                            resolve(res);
                        });
                    });
                };

                _this55.master_loading = true;

                _this55.UPDATE_MARKETSTUDY({
                    key: _this55.marketstudy.id,
                    object: _this55.marketstudy,
                    parent_path: 'realestates/' + _this55.realestate.id + '/' + 'marketstudies' + '/',
                    path: _this55.marketstudy.path + _this55.marketstudy.id,
                    realestate_id: _this55.realestate.id
                }).then(function (res) {

                    _this55.UPDATE_MARKETSTUDY_AD_COMPARABLES({
                        object: _this55.marketstudy_ad_comparables,
                        path: 'marketstudy_ad_comparables/' + _this55.marketstudy.id
                    });

                    // 1- actualitzar possibles canvis fets a realestate (floor_number bàsicament)
                    // 2- actualitzar appraisal de referència
                    // 3- per cada appraisal assignada al marketstudy, actualitzar càlculs i guardar

                    //finalment: actualitzar appraisalreports amb la suma dels nous valors calculats per a cada appraisal

                    var floor_number = 0;
                    if (_this55.appraisal_tabulation[0].floor_number) {
                        floor_number = _this55.appraisal_tabulation[0].floor_number;
                    }
                    console.log('floor_number: ' + floor_number);
                    _this55.UPDATE_REALESTATE_FLOOR_NUMBER({
                        value: floor_number,
                        path: 'realestates/' + _this55.realestate.id,
                        realestate_id: _this55.realestate.id
                    }).then(function (res) {

                        _this55.UPDATE_APPRAISAL({
                            key: _this55.appraisal.id,
                            object: _this55.appraisal,
                            parent_path: 'realestates/' + _this55.appraisal.realestate_id + '/' + 'appraisals' + '/',
                            path: _this55.appraisal.path + _this55.appraisal.id,
                            realestate_id: _this55.realestate.id
                        }).then(function (res) {

                            console.log('updated_appriaisal: ');
                            console.log(_this55.appraisal);

                            console.log('*****');

                            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(_this55.marketstudy.realestate_appraisals, function (value, key) {

                                console.log('· calculating realestate: ' + key);

                                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(value, function (value2, key2) {

                                    console.log('· calculating appraisal: ' + key2 + ' from realestate: ' + key);

                                    fetchAppraisal({ path: 'realestate_appraisals' + '/' + key + '/' + key2 }).then(function (res) {

                                        var calculated_appraisal = _this55.calcAppraisal(res, _this55.marketstudy.id, _this55.marketstudy.market_value, _this55.marketstudy.market_unit_value);

                                        updateAppraisal({
                                            key: calculated_appraisal['id'],
                                            object: calculated_appraisal,
                                            parent_path: 'realestates/' + calculated_appraisal['realestate_id'] + '/' + 'appraisals' + '/',
                                            path: calculated_appraisal['path'] + calculated_appraisal['id'],
                                            realestate_id: calculated_appraisal['realestate_id']
                                        });
                                    });
                                });
                            });

                            console.log('*****');

                            // TODO: calcular els totals de appraisalreport amb els nous valors de cada appraisal

                            _this55.master_loading = false;
                            resolve();

                            if (data.go_up) {
                                _this55.onGoUp();
                            }
                        });
                    });
                });
            });
        },
        onQueryAds: function onQueryAds() {
            var _this56 = this;

            this.master_loading = true;
            this.query_comparables_loading = true;

            // si guardem abans de tenir comparables donar error perque diversos calculs donen NaN
            // this.onSaveCurrentMarketStudy({go_up: false}).then((res) => {

            this.QUERY_ADS({
                key: this.realestate.id,
                lat: this.realestate.lat,
                lng: this.realestate.lng,
                ad_type: this.marketstudy.query_ad_type.name_db,
                startdate: this.marketstudy.query_startdate,
                limitdate: this.marketstudy.query_limitdate,
                geohash: this.realestate.geohash,
                radius_km: this.marketstudy.query_distance_km
            }).then(function (res) {
                //
                _this56.master_loading = false;
                _this56.query_comparables_loading = false;
            });
        },
        onImportComparableSet: function onImportComparableSet() {
            var _this57 = this;

            this.master_loading = true;
            if (this.marketstudy.importMarketStudy) {
                console.log('import comparable set: ' + this.marketstudy.importMarketStudy.id);
                this.COPY_COMPARABLES_FROM_MARKETSTUDY({
                    comparables: this.marketstudy.importMarketStudy.comparables,
                    marketstudy_id: this.marketstudy.id,
                    realestate_id: this.realestate.id,
                    temp_marketstudy_id: this.marketstudy.importMarketStudy.id
                }).then(function (res) {
                    _this57.FETCH_MARKETSTUDY_AD_COMPARABLES({ path: 'marketstudy_ad_comparables' + '/' + _this57.marketstudy.id + '/' }).then(function () {
                        _this57.set_entities_comparison_and_homogenisation();
                        _this57.$forceUpdate();
                        _this57.master_loading = false;
                    });
                });
            } else {
                console.log('falta triar un estudi de mercat');
                alert('falta triar un estudi de mercat');
            }
        },
        onGoBack: function onGoBack() {
            // console.log('yeah back')
            __WEBPACK_IMPORTED_MODULE_12__router_index_js__["a" /* default */].go(-1);
        },
        onGoUp: function onGoUp() {
            // console.log('yeah up')
            this.$router.push({ name: 'realestate-editor', query: { id: this.realestate.id } });
        },
        onCancelAll: function onCancelAll() {
            var result = window.confirm(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Changes_will_be_lost_p_continue_q'));

            if (result) {
                __WEBPACK_IMPORTED_MODULE_12__router_index_js__["a" /* default */].go(-1);
            } else {
                return false;
            }
        },
        openAdLink: function openAdLink(entity) {
            if (entity.url) {
                var url = entity.url;
                var win = window.open(url, '_blank');
                win.focus();
            }
        },
        chooseAd: function chooseAd(entity) {
            var _this58 = this;

            this.loading_new_comparable = true;
            this.master_loading = true;

            entity['chosen'] = true;

            this.RESET_AD_COMPARABLE().then(function (res) {
                _this58.CREATE_NEW_AD_COMPARABLE({
                    path: 'marketstudy_ad_comparables' + '/' + _this58.marketstudy.id + '/',
                    parent_path: 'realestate_marketstudies' + '/' + _this58.realestate.id + '/' + _this58.marketstudy.id + '/' + 'comparables' + '/',
                    ad: entity
                }).then(function (res) {
                    // this.$router.push({name: 'comparabl', query: {id: this.appraisal.id}})
                    _this58.FETCH_MARKETSTUDY_AD_COMPARABLES({ path: 'marketstudy_ad_comparables' + '/' + _this58.marketstudy.id + '/' }).then(function () {

                        _this58.set_entities_comparison_and_homogenisation();

                        _this58.loading_new_comparable = false;
                        _this58.master_loading = false;
                    });
                });
            });
        },
        discardAd: function discardAd(entity) {

            var arr = this.marketstudy_matched_ads;
            arr = arr.filter(function (item) {
                return item.id !== entity.id;
            });
            // console.log('new array:')
            // console.log(arr)

            this.SET_MARKETSTUDY_MATCHED_ADS(arr).then(function (res) {});
        },
        editAd: function editAd(entity) {
            var _this59 = this;

            // let ad_path =  'ads' + '/' + entity.ad_type.name_db + '/' + entity.ad_year  + '/' + this.chunk(entity.geohash, 1).join('/') + '/' + entity.ad_id
            // console.log(ad_path)

            if (this.marketstudy.dirty) {
                this.onSaveCurrentMarketStudy({ go_up: false }).then(function (res) {});
            }

            var ad_path = 'marketstudy_ad_comparables' + '/' + this.marketstudy.id + '/' + entity.id;
            this.SET_AD({ path: ad_path }).then(function (res) {
                _this59.$router.push({ name: 'ad-editor', query: { id: entity.id } });
            });
        },
        deleteAdComparable: function deleteAdComparable(entity) {
            var _this60 = this;

            this.master_loading = true;

            var result = window.confirm(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('You_are_about_to_delete ') + entity.description + '. ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Continue_q'));

            if (result) {

                this.DELETE_AD_COMPARABLE({
                    marketstudy_id: this.marketstudy.id,
                    path: 'marketstudy_ad_comparables' + '/' + this.marketstudy.id + '/' + entity.id,
                    key: entity.id,
                    parent_path: 'realestate_marketstudies' + '/' + this.realestate.id + '/' + this.marketstudy.id + '/' + 'comparables' + '/' + entity.id
                }).then(function (res) {
                    //
                    _this60.loading_new_comparable = true;
                    _this60.FETCH_MARKETSTUDY_AD_COMPARABLES({ path: 'marketstudy_ad_comparables' + '/' + _this60.marketstudy.id + '/' }).then(function () {

                        _this60.set_entities_comparison_and_homogenisation();
                        _this60.loading_new_comparable = false;
                        _this60.master_loading = false;
                    });
                });
            }
        }

    }),
    head: {
        title: {
            //inner: Vue.i18n.translate('New_contact')
            inner: 'Edit market study'
        }

    }
});

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__options_default_notes__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__router_index_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Datatable_datatable_column_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Datatable_datatable_column_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_Datatable_datatable_column_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__aggregators_aggregators_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__formatters_formatters_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Toggles_checkbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Toggles_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Toggles_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Paginator_paginator_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Paginator_paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_Paginator_paginator_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


























/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'note-editor',

    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins__["d" /* dateMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["a" /* localStorageMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["e" /* objectsMixin */]],

    data: function data() {
        return {
            loading: true,
            master_loading: true,
            filesOpen: true,
            fileOpen: true,
            reportOpen: true,
            error: null,
            success_message: null,
            metadata_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Metadata'),
            data_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Data'),
            report_title_error_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Report_title_missing_error_text'),
            new_real_estate_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_real_estate'),
            cancel_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cancel'),
            goup_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_up') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            pdf_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Print_report_in_PDF'),
            save_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save'),
            save_and_go_up_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('go_up'),
            page_dirty_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('The_page_contains_unsaved_changes'),
            actions_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Actions'),
            filter_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type_here_to_filter_paginated_data'),
            duplicate_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Duplicate'),
            edit_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Edit'),
            delete_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Delete'),
            discard_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Discard'),
            openlink_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Open_link_in_new_tab'),
            noteValue: null,
            default_noteOptions: __WEBPACK_IMPORTED_MODULE_11__options_default_notes__["a" /* default */]
        };
    },

    created: function created() {
        this.master_loading = false;
    },


    components: {
        Bar: __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default.a,
        Message: __WEBPACK_IMPORTED_MODULE_13__components_Message_vue___default.a,
        IconButton: __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default.a,
        SideNavBar: __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default.a,
        Checkbox: __WEBPACK_IMPORTED_MODULE_18__components_Toggles_checkbox_vue___default.a,
        Datatable: __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_vue___default.a,
        DatatableColumn: __WEBPACK_IMPORTED_MODULE_15__components_Datatable_datatable_column_vue___default.a,
        Paginator: __WEBPACK_IMPORTED_MODULE_19__components_Paginator_paginator_vue___default.a
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['theme', 'tags_display', 'currentLocale', 'note'])),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['UPDATE_NOTE', 'SET_NOTE_NAME_CA', 'SET_NOTE_NAME_EN', 'SET_NOTE_NAME_ES']), {
        set_note_name_ca: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_NOTE_NAME_CA(e.target.value);

            if (!this.note.name_en) {
                this.SET_NOTE_NAME_EN('translation missing');
            }
            if (!this.note.name_es) {
                this.SET_NOTE_NAME_ES('translation missing');
            }
        }, 1000),
        set_note_name_en: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_NOTE_NAME_EN(e.target.value);

            if (!this.note.name_ca) {
                this.SET_NOTE_NAME_CA('translation missing');
            }
            if (!this.note.name_es) {
                this.SET_NOTE_NAME_ES('translation missing');
            }
        }, 1000),
        set_note_name_es: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_NOTE_NAME_ES(e.target.value);

            if (!this.note.name_ca) {
                this.SET_NOTE_NAME_CA('translation missing');
            }
            if (!this.note.name_en) {
                this.SET_NOTE_NAME_EN('translation missing');
            }
        }, 1000),
        set_note: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_NOTE_NAME_CA(e.name_ca);
            this.SET_NOTE_NAME_EN(e.name_en);
            this.SET_NOTE_NAME_ES(e.name_es);
        }, 0),
        onSaveCurrentNote: function onSaveCurrentNote(data) {
            var _this = this;

            this.UPDATE_NOTE({
                object: this.note,
                path: this.note.path,
                parent_path: this.note.parent_path,
                key: this.note.id
            }).then(function (res) {
                // router.go(-1)
                if (data.go_up) {
                    _this.onGoUp();
                }
            });
        },
        onGoBack: function onGoBack() {
            __WEBPACK_IMPORTED_MODULE_12__router_index_js__["a" /* default */].go(-1);
        },
        onGoUp: function onGoUp() {
            __WEBPACK_IMPORTED_MODULE_12__router_index_js__["a" /* default */].go(-1);
        }
    }),
    head: {
        title: {
            inner: 'Edit note'
        }
    }

});

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__router_index_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__aggregators_aggregators_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__formatters_formatters_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
























/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'otherannex-editor',

    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins__["d" /* dateMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["a" /* localStorageMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["e" /* objectsMixin */]],

    data: function data() {
        return {
            loading: true,
            master_loading: true,
            filesOpen: true,
            fileOpen: true,
            reportOpen: true,
            error: null,
            success_message: null,
            metadata_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Metadata'),
            data_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Data'),
            report_title_error_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Report_title_missing_error_text'),
            new_real_estate_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_real_estate'),
            cancel_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cancel'),
            goup_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_up') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            pdf_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Print_report_in_PDF'),
            save_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save'),
            save_and_go_up_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('go_up'),
            page_dirty_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('The_page_contains_unsaved_changes'),
            actions_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Actions'),
            filter_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type_here_to_filter_paginated_data'),
            duplicate_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Duplicate'),
            edit_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Edit'),
            delete_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Delete'),
            discard_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Discard'),
            openlink_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Open_link_in_new_tab')
        };
    },

    created: function created() {
        this.master_loading = false;
    },


    components: {
        Bar: __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default.a,
        Message: __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default.a,
        IconButton: __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default.a,
        SideNavBar: __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default.a,
        Checkbox: __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue___default.a,
        Datatable: __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue___default.a,
        DatatableColumn: __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue___default.a,
        Paginator: __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue___default.a
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['theme', 'tags_display', 'currentLocale', 'otherannex'])),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['UPDATE_OTHERANNEX', 'SET_OTHERANNEX_NAME_CA', 'SET_OTHERANNEX_NAME_EN', 'SET_OTHERANNEX_NAME_ES']), {
        set_otherannex_name_ca: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_OTHERANNEX_NAME_CA(e.target.value);
        }, 1000),
        set_otherannex_name_en: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_OTHERANNEX_NAME_EN(e.target.value);
        }, 1000),
        set_otherannex_name_es: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_OTHERANNEX_NAME_ES(e.target.value);
        }, 1000),
        set_otherannex: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_OTHERANNEX_NAME_CA(e.name_ca);
            this.SET_OTHERANNEX_NAME_EN(e.name_en);
            this.SET_OTHERANNEX_NAME_ES(e.name_es);
        }, 0),
        onSaveCurrentOtherAnnex: function onSaveCurrentOtherAnnex(data) {
            var _this = this;

            this.UPDATE_OTHERANNEX({
                object: this.otherannex,
                path: this.otherannex.path,
                parent_path: this.otherannex.parent_path,
                key: this.otherannex.id
            }).then(function (res) {
                // router.go(-1)
                if (data.go_up) {
                    _this.onGoUp();
                }
            });
        },
        onGoBack: function onGoBack() {
            __WEBPACK_IMPORTED_MODULE_11__router_index_js__["a" /* default */].go(-1);
        },
        onGoUp: function onGoUp() {
            __WEBPACK_IMPORTED_MODULE_11__router_index_js__["a" /* default */].go(-1);
        }
    }),
    head: {
        title: {
            inner: 'Edit otherannex'
        }
    }

});

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__router_index_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__aggregators_aggregators_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__formatters_formatters_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
























/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'photograph-editor',

    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins__["d" /* dateMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["a" /* localStorageMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["e" /* objectsMixin */]],

    data: function data() {
        return {
            loading: true,
            master_loading: true,
            filesOpen: true,
            fileOpen: true,
            reportOpen: true,
            error: null,
            success_message: null,
            metadata_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Metadata'),
            data_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Data'),
            report_title_error_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Report_title_missing_error_text'),
            new_real_estate_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_real_estate'),
            cancel_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cancel'),
            goup_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_up') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            pdf_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Print_report_in_PDF'),
            save_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save'),
            save_and_go_up_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('go_up'),
            page_dirty_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('The_page_contains_unsaved_changes'),
            actions_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Actions'),
            filter_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type_here_to_filter_paginated_data'),
            duplicate_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Duplicate'),
            edit_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Edit'),
            delete_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Delete'),
            discard_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Discard'),
            openlink_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Open_link_in_new_tab')
        };
    },

    created: function created() {
        this.master_loading = false;
    },


    components: {
        Bar: __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default.a,
        Message: __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default.a,
        IconButton: __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default.a,
        SideNavBar: __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default.a,
        Checkbox: __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue___default.a,
        Datatable: __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue___default.a,
        DatatableColumn: __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue___default.a,
        Paginator: __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue___default.a
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['theme', 'tags_display', 'currentLocale', 'photograph'])),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['UPDATE_PHOTOGRAPH', 'SET_PHOTOGRAPH_NAME_CA', 'SET_PHOTOGRAPH_NAME_EN', 'SET_PHOTOGRAPH_NAME_ES']), {
        set_photograph_name_ca: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_PHOTOGRAPH_NAME_CA(e.target.value);
        }, 1000),
        set_photograph_name_en: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_PHOTOGRAPH_NAME_EN(e.target.value);
        }, 1000),
        set_photograph_name_es: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_PHOTOGRAPH_NAME_ES(e.target.value);
        }, 1000),
        set_photograph: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_PHOTOGRAPH_NAME_CA(e.name_ca);
            this.SET_PHOTOGRAPH_NAME_EN(e.name_en);
            this.SET_PHOTOGRAPH_NAME_ES(e.name_es);
        }, 0),
        onSaveCurrentPhotograph: function onSaveCurrentPhotograph(data) {
            var _this = this;

            this.UPDATE_PHOTOGRAPH({
                object: this.photograph,
                path: this.photograph.path,
                parent_path: this.photograph.parent_path,
                key: this.photograph.id
            }).then(function (res) {
                // router.go(-1)
                if (data.go_up) {
                    _this.onGoUp();
                }
            });
        },
        onGoBack: function onGoBack() {
            __WEBPACK_IMPORTED_MODULE_11__router_index_js__["a" /* default */].go(-1);
        },
        onGoUp: function onGoUp() {
            __WEBPACK_IMPORTED_MODULE_11__router_index_js__["a" /* default */].go(-1);
        }
    }),
    head: {
        title: {
            inner: 'Edit photograph'
        }
    }

});

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__router_index_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__aggregators_aggregators_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__formatters_formatters_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
























/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'planannex-editor',

    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins__["d" /* dateMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["a" /* localStorageMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["e" /* objectsMixin */]],

    data: function data() {
        return {
            loading: true,
            master_loading: true,
            filesOpen: true,
            fileOpen: true,
            reportOpen: true,
            error: null,
            success_message: null,
            metadata_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Metadata'),
            data_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Data'),
            report_title_error_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Report_title_missing_error_text'),
            new_real_estate_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_real_estate'),
            cancel_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cancel'),
            goup_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_up') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            pdf_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Print_report_in_PDF'),
            save_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save'),
            save_and_go_up_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('go_up'),
            page_dirty_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('The_page_contains_unsaved_changes'),
            actions_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Actions'),
            filter_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type_here_to_filter_paginated_data'),
            duplicate_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Duplicate'),
            edit_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Edit'),
            delete_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Delete'),
            discard_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Discard'),
            openlink_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Open_link_in_new_tab')
        };
    },

    created: function created() {
        this.master_loading = false;
    },


    components: {
        Bar: __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default.a,
        Message: __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default.a,
        IconButton: __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default.a,
        SideNavBar: __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default.a,
        Checkbox: __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue___default.a,
        Datatable: __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue___default.a,
        DatatableColumn: __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue___default.a,
        Paginator: __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue___default.a
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['theme', 'tags_display', 'currentLocale', 'planannex'])),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['UPDATE_PLANANNEX', 'SET_PLANANNEX_NAME_CA', 'SET_PLANANNEX_NAME_EN', 'SET_PLANANNEX_NAME_ES']), {
        set_planannex_name_ca: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_PLANANNEX_NAME_CA(e.target.value);
        }, 1000),
        set_planannex_name_en: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_PLANANNEX_NAME_EN(e.target.value);
        }, 1000),
        set_planannex_name_es: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_PLANANNEX_NAME_ES(e.target.value);
        }, 1000),
        set_planannex: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_PLANANNEX_NAME_CA(e.name_ca);
            this.SET_PLANANNEX_NAME_EN(e.name_en);
            this.SET_PLANANNEX_NAME_ES(e.name_es);
        }, 0),
        onSaveCurrentPlanAnnex: function onSaveCurrentPlanAnnex(data) {
            var _this = this;

            this.UPDATE_PLANANNEX({
                object: this.planannex,
                path: this.planannex.path,
                parent_path: this.planannex.parent_path,
                key: this.planannex.id
            }).then(function (res) {
                // router.go(-1)
                if (data.go_up) {
                    _this.onGoUp();
                }
            });
        },
        onGoBack: function onGoBack() {
            __WEBPACK_IMPORTED_MODULE_11__router_index_js__["a" /* default */].go(-1);
        },
        onGoUp: function onGoUp() {
            __WEBPACK_IMPORTED_MODULE_11__router_index_js__["a" /* default */].go(-1);
        }
    }),
    head: {
        title: {
            inner: 'Edit planannex'
        }
    }

});

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__router_index_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__options_project_types__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__options_countries__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__options_spanish_provinces__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__options_property_types__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__options_conservation_statuses__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__options_room_types__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__options_covered_outdoor_types__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__options_uncovered_outdoor_types__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__options_selected_areas__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__options_plot_occupations__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__options_plot_free_area_usages__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__options_construction_statuses__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Datatable_datatable_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Datatable_datatable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_Datatable_datatable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_Datatable_datatable_column_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_Datatable_datatable_column_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_Datatable_datatable_column_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__aggregators_aggregators_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__formatters_formatters_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_Toggles_checkbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_Toggles_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_Toggles_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_Paginator_paginator_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_Paginator_paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_Paginator_paginator_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__options_occupancy_statuses__ = __webpack_require__(244);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








































var fonts = {
    Roboto: {
        normal: 'fonts/Roboto-Regular.ttf',
        bold: 'fonts/Roboto-Medium.ttf',
        italics: 'fonts/Roboto-Italic.ttf',
        bolditalics: 'fonts/Roboto-MediumItalic.ttf'
    }
};

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'project-editor',

    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins__["d" /* dateMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["a" /* localStorageMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["f" /* mathMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["e" /* objectsMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["g" /* typeCheckMixin */]],

    data: function data() {
        return {
            tabName: '',
            currentTabTitle: '',
            master_loading: true,
            urban_map_offset: 5,
            urban_map_size: '640x480',
            urban_map_width: 640,
            urban_map_height: 480,
            urban_map_zoom_factor: 0.1,
            editing_room: false,
            editing_room_text_color: 'black',
            editing_room_border_color: 'lightgray',
            editing_covered_outdoor: false,
            editing_covered_outdoor_text_color: 'black',
            editing_covered_outdoor_border_color: 'lightgray',
            editing_uncovered_outdoor: false,
            editing_uncovered_outdoor_text_color: 'black',
            editing_uncovered_outdoor_border_color: 'lightgray',
            creatingCoveredOutdoor: false,
            creatingUncoveredOutdoor: false,
            loadingProjectPurpose: false,
            filesOpen: true,
            fileOpen: true,
            reportOpen: true,
            editabletrue: true,
            cadaster_ref_loading: false,
            idescat_info_loading: false,
            muc_info_loading: false,
            muc_map_01_loading: false,
            muc_map_02_loading: false,
            muc_map_03_loading: false,
            google_geocode_loading: false,
            error: null,
            success_message: null,
            metadata_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Version'),
            filter_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type_here_to_filter_paginated_data'),
            General_data_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('General_data'),
            cancel_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cancel'),
            goback_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_back') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            goup_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_up') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            save_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save'),
            save_and_go_up_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('go_up'),
            page_dirty_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('The_page_contains_unsaved_changes'),
            actions_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Actions'),
            duplicate_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Duplicate'),
            edit_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Edit'),
            delete_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Delete'),
            projectTypeValue: null,
            projectTypeOptions: __WEBPACK_IMPORTED_MODULE_13__options_project_types__["a" /* default */],
            countryOptions: __WEBPACK_IMPORTED_MODULE_14__options_countries__["a" /* default */],
            spanishProvinceOptions: __WEBPACK_IMPORTED_MODULE_15__options_spanish_provinces__["a" /* default */],
            conservation_statusOptions: __WEBPACK_IMPORTED_MODULE_17__options_conservation_statuses__["a" /* default */],
            construction_statusOptions: __WEBPACK_IMPORTED_MODULE_24__options_construction_statuses__["a" /* default */],
            countryValue: null,
            municipalityValue: null,
            provinceValue: null,
            property_typeValue: null,
            construction_statusValue: null

        };
    },

    created: function created() {
        this.master_loading = false;
    },


    components: {
        Bar: __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default.a,
        Message: __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default.a,
        IconButton: __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default.a,
        Checkbox: __WEBPACK_IMPORTED_MODULE_29__components_Toggles_checkbox_vue___default.a,
        Datatable: __WEBPACK_IMPORTED_MODULE_25__components_Datatable_datatable_vue___default.a,
        DatatableColumn: __WEBPACK_IMPORTED_MODULE_26__components_Datatable_datatable_column_vue___default.a,
        Paginator: __WEBPACK_IMPORTED_MODULE_30__components_Paginator_paginator_vue___default.a,
        SideNavBar: __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default.a
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['theme', 'tags_display', 'project', 'currentLocale', 'realestate', 'realestate_projects'])),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['RESET_PROJECT', 'UPDATE_PROJECT']), {

        onSaveCurrentProject: function onSaveCurrentProject(data) {

            /*
             this.UPDATE_PROJECT({
                key: this.project.id,
                object: this.project,
                parent_path: 'realestates/' + this.realestate.id + '/' + 'projects' + '/',
                path: this.project.path + this.project.id,
                realestate_id: this.realestate.id
            }).then((res) => {
                if (data.go_up) {
                    this.onGoUp()
                } else {
                    this.setCurrentTab(this.currentTabTitle)
                    window.scroll(0, 0)
                }
            })
             this.UPDATE_REALESTATE({
                key: this.realestate.id,
                object: this.realestate,
                // parent_path: 'projectreports/' + this.projectreport.id + '/' + 'realestates' + '/',
                path: this.realestate.path + this.realestate.id,
                file_id: this.projectfile.id,
                report_id: this.projectreport.id
            }).then((res) => {
             })
            */
        },
        setCurrentTabTitle: function setCurrentTabTitle(tabTitle) {
            console.log('hey, current Tab Title: ' + tabTitle);
            this.currentTabTitle = tabTitle;
        },
        setCurrentTab: function setCurrentTab(tabTitle) {
            console.log('hey, current Tab: ' + tabTitle);
            this.tabName = tabTitle;
        },
        onGoBack: function onGoBack() {
            // console.log('yeah back')
            __WEBPACK_IMPORTED_MODULE_11__router_index_js__["a" /* default */].go(-1);
        },
        onGoUp: function onGoUp() {
            // console.log('yeah up')
            this.$router.push({ name: 'realestate-editor', query: { id: this.realestate.id } });
        },
        onCancelAll: function onCancelAll() {
            var result = window.confirm(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Changes_will_be_lost_p_continue_q'));

            if (result) {
                __WEBPACK_IMPORTED_MODULE_11__router_index_js__["a" /* default */].go(-1);
            } else {
                return false;
            }
        }
    }),
    head: {
        title: {
            //inner: Vue.i18n.translate('New_contact')
            inner: 'Edit project'
        }
    }

});

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_locale_ca__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_locale_ca___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_locale_ca__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ContactsSearch_Index_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ContactsSearch_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_ContactsSearch_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_SideNavBar_Index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_SideNavBar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_SideNavBar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__router_index_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__options_countries__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__options_spanish_provinces__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__options_property_types__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Datatable_datatable_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Datatable_datatable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Datatable_datatable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Datatable_datatable_column_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Datatable_datatable_column_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Datatable_datatable_column_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__aggregators_aggregators_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__formatters_formatters_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Toggles_checkbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Toggles_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_Toggles_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Paginator_paginator_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Paginator_paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_Paginator_paginator_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__options_asset_types__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__options_dwelling_types__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__options_floor_types__ = __webpack_require__(243);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





 // without this line it didn't work
__WEBPACK_IMPORTED_MODULE_3_moment___default.a.locale('ca');




























/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'realestate-editor',

    mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins__["d" /* dateMixin */], __WEBPACK_IMPORTED_MODULE_5__mixins__["a" /* localStorageMixin */], __WEBPACK_IMPORTED_MODULE_5__mixins__["f" /* mathMixin */], __WEBPACK_IMPORTED_MODULE_5__mixins__["e" /* objectsMixin */], __WEBPACK_IMPORTED_MODULE_5__mixins__["k" /* colorMixin */]],

    data: function data() {
        return {
            master_loading: true,
            check_prices_loading: false,
            tabName: '',
            currentTabTitle: '',
            google_map_offset: 0.00005,
            google_map_size: '640x480',
            filesOpen: true,
            fileOpen: true,
            reportOpen: true,
            cadaster_ref_loading: false,
            icc_census_section_loading: false,
            google_geocode_loading: false,
            error: null,
            success_message: null,
            google_map_01_loading: false,
            google_map_02_loading: false,
            google_map_03_loading: false,
            metadata_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Version'),
            identification_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Identification') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('pre_appraisal'),
            marketstudies_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Market_studies'),
            appraisals_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Appraisals'),
            projects_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Projects'),
            appraisal_cost_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Appraisal_cost'),
            quote_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Quote'),
            filter_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type_here_to_filter_paginated_data'),
            new_appraisal_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_appraisal'),
            new_project_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_project'),
            new_marketstudy_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_market_study'),
            cancel_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cancel'),
            goback_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_back') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            goup_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_up') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            save_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save'),
            save_and_go_up_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('go_up'),
            cad_ref_error_text_01: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cadastral_Reference_less_20_positions_error_text'),
            page_dirty_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('The_page_contains_unsaved_changes'),
            actions_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Actions'),
            duplicate_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Duplicate'),
            edit_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Edit'),
            delete_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Delete'),
            countryOptions: __WEBPACK_IMPORTED_MODULE_14__options_countries__["a" /* default */],
            property_typeOptions: __WEBPACK_IMPORTED_MODULE_16__options_property_types__["a" /* default */],
            spanishProvinceOptions: __WEBPACK_IMPORTED_MODULE_15__options_spanish_provinces__["a" /* default */],
            countryValue: null,
            property_typeValue: null,
            municipalityValue: null,
            provinceValue: null,
            asset_typeValue: null,
            dwelling_typeValue: null,
            floor_typeValue: null,
            floor_typeOptions: __WEBPACK_IMPORTED_MODULE_25__options_floor_types__["a" /* default */],
            asset_typeOptions: __WEBPACK_IMPORTED_MODULE_23__options_asset_types__["a" /* default */],
            dwelling_typeOptions: __WEBPACK_IMPORTED_MODULE_24__options_dwelling_types__["a" /* default */],
            mapStyles: [{
                featureType: 'poi',
                elementType: 'labels',
                stylers: [{
                    visibility: 'off'
                }]
            }],
            appraisal_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [{
                    id: 'description',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Description'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'date_modified',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Last_modified'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format('DD/MM/YYYY HH:mm:ss');
                    }
                }],
                selected: []
            },
            project_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [{
                    id: 'description',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Description'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'date_modified',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Last_modified'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format('DD/MM/YYYY HH:mm:ss');
                    }
                }],
                selected: []
            },

            marketstudy_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [{
                    id: 'description',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Description'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'appraisal_id',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Appraisal'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'date_modified',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Last_modified'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format('DD/MM/YYYY HH:mm:ss');
                    }
                }],
                selected: []
            }

        };
    },

    created: function created() {
        var _this = this;

        this.FETCH_VALUATION_PRICES({ path: 'valuation_prices' + '/' }).then(function () {
            _this.FETCH_REALESTATE_MARKETSTUDIES({ path: 'realestate_marketstudies' + '/' + _this.realestate.id + '/' }).then(function () {
                _this.FETCH_REALESTATE_APPRAISALS({ path: 'realestate_appraisals' + '/' + _this.realestate.id + '/' }).then(function () {
                    _this.FETCH_REALESTATE_PROJECTS({ path: 'realestate_projects' + '/' + _this.realestate.id + '/' }).then(function () {
                        if (_this.realestate.province && !_this.realestate_municipalities.municipalities) {

                            if (_this.realestate.province.ine_province_code) {
                                console.log('fetching...');
                                _this.FETCH_REALESTATE_MUNICIPALITIES({ path: 'municipalities' + '/' + 'province_' + _this.realestate.province.ine_province_code + '/' }).then(function () {

                                    _this.master_loading = false;
                                });
                            } else {

                                _this.master_loading = false;
                            }
                        } else {

                            _this.master_loading = false;
                        }
                    });
                });
            });
        });
    },


    components: {
        Bar: __WEBPACK_IMPORTED_MODULE_9__components_Bar_Index_vue___default.a,
        Message: __WEBPACK_IMPORTED_MODULE_13__components_Message_vue___default.a,
        IconButton: __WEBPACK_IMPORTED_MODULE_10__components_IconButton_Index_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_6__components_Spinner_vue___default.a,
        Checkbox: __WEBPACK_IMPORTED_MODULE_21__components_Toggles_checkbox_vue___default.a,
        Datatable: __WEBPACK_IMPORTED_MODULE_17__components_Datatable_datatable_vue___default.a,
        DatatableColumn: __WEBPACK_IMPORTED_MODULE_18__components_Datatable_datatable_column_vue___default.a,
        Paginator: __WEBPACK_IMPORTED_MODULE_22__components_Paginator_paginator_vue___default.a,
        SideNavBar: __WEBPACK_IMPORTED_MODULE_11__components_SideNavBar_Index_vue___default.a
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['theme', 'appraisal', 'appraisalfile', 'appraisalreport', 'appraisalreport_realestates', 'currentLocale', 'marketstudy', 'project', 'realestate', 'realestate_appraisals', 'realestate_marketstudies', 'realestate_municipalities', 'realestate_projects', 'valuation_prices']), {
        prices_startdate: function prices_startdate() {
            return __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(6, 'months').format('YYYY-MM-DD');
        },
        prices_limitdate: function prices_limitdate() {
            return __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD');
        },
        prices_startdate_readformat: function prices_startdate_readformat() {
            return __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(6, 'months').format('DD MMMM YYYY');
        },
        prices_limitdate_readformat: function prices_limitdate_readformat() {
            return __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('DD MMMM YYYY');
        }
    }),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['CREATE_NEW_APPRAISAL', 'CREATE_NEW_MARKETSTUDY', 'CREATE_NEW_PROJECT', 'DELETE_MARKETSTUDY', 'DELETE_APPRAISAL', 'DELETE_PROJECT', 'FETCH_REALESTATE_APPRAISALS', 'FETCH_REALESTATE_MARKETSTUDIES', 'FETCH_REALESTATE_MUNICIPALITIES', 'FETCH_REALESTATE_PROJECTS', 'GEOLOCATE_REALESTATE', 'GOOGLEDISTANCE_REALESTATE', 'FETCH_VALUATION_PRICES', 'REQUEST_CADASTRAL_REFERENCE_BY_COORDINATES', 'REQUEST_CENSUS_SECTION_INFO', 'RESET_APPRAISAL', 'RESET_MARKETSTUDY', 'RESET_PROJECT', 'SET_APPRAISAL', 'SET_APPRAISAL_FLOOR_NUMBER_BY_KEY', 'SET_APPRAISAL_PROPERTY_TYPE_BY_KEY', 'SET_MARKETSTUDY', 'SET_REALESTATE_CADASTRAL_REFERENCE', 'SET_REALESTATE_CENSUS_SECTION_CODE', 'SET_REALESTATE_COUNTRY', 'SET_REALESTATE_DESCRIPTION', 'SET_REALESTATE_DOOR', 'SET_REALESTATE_EPSG25831_X', 'SET_REALESTATE_EPSG25831_Y', 'SET_REALESTATE_FLOOR', 'SET_REALESTATE_FLOOR_NUMBER', 'SET_REALESTATE_GOOGLE_FORMATTED_ADDRESS', 'SET_REALESTATE_LAT', 'SET_REALESTATE_LNG', 'SET_REALESTATE_MUNICIPALITY', 'SET_REALESTATE_POSTAL_CODE', 'SET_REALESTATE_PROPERTY_TYPE', 'SET_REALESTATE_REGISTRY_NAME', 'SET_REALESTATE_PROVINCE', 'SET_REALESTATE_STAIRCASE', 'SET_REALESTATE_STREET_NAME', 'SET_REALESTATE_STREET_NUMBER', 'SET_REALESTATE_MAP_GOOGLE_01_URL', 'SET_REALESTATE_MAP_GOOGLE_01_LAT', 'SET_REALESTATE_MAP_GOOGLE_01_LNG', 'SET_REALESTATE_MAP_GOOGLE_01_ZOOM', 'SET_REALESTATE_MAP_GOOGLE_02_URL', 'SET_REALESTATE_MAP_GOOGLE_02_LAT', 'SET_REALESTATE_MAP_GOOGLE_02_LNG', 'SET_REALESTATE_MAP_GOOGLE_02_ZOOM', 'SET_REALESTATE_MAP_GOOGLE_03_URL', 'SET_REALESTATE_MAP_GOOGLE_03_LAT', 'SET_REALESTATE_MAP_GOOGLE_03_LNG', 'SET_REALESTATE_MAP_GOOGLE_03_ZOOM', 'SET_REALESTATE_FULL_ADDRESS', 'SET_REALESTATE_SHORT_ADDRESS', 'SET_REALESTATE_BLOCK', 'SET_REALESTATE_AREA_ADS_MARKERS', 'SET_REALESTATE_AREA_AVERAGE_PRICE', 'SET_REALESTATE_AREA_AVERAGE_PRICE_COEF', 'SET_REALESTATE_ADOPTED_AREA_AVERAGE_PRICE', 'SET_REALESTATE_ESTIMATED_BUILT_AREA', 'SET_REALESTATE_PRE_APPRAISAL_VALUE', 'SET_REALESTATE_TRAVEL_ONE_WAY_HOURS', 'SET_REALESTATE_TRAVEL_BOTH_WAYS_HOURS', 'SET_REALESTATE_TRAVEL_FEES_PER_HOUR', 'SET_REALESTATE_CAR_FUEL_EXPENSES_ONE_WAY', 'SET_REALESTATE_CAR_FUEL_EXPENSES_BOTH_WAYS', 'SET_REALESTATE_CAR_TOLL_EXPENSES_ONE_WAY', 'SET_REALESTATE_CAR_TOLL_EXPENSES_BOTH_WAYS', 'SET_REALESTATE_CAR_EXPENSES_ONE_WAY', 'SET_REALESTATE_CAR_EXPENSES_BOTH_WAYS', 'SET_REALESTATE_TOTAL_TRAVEL_FEES', 'SET_REALESTATE_QUOTE_BASE_FEES', 'SET_REALESTATE_QUOTE_EXCESS_PCT', 'SET_REALESTATE_QUOTE_EXCESS', 'SET_REALESTATE_QUOTE_BASE_PRICE', 'SET_REALESTATE_QUOTE_BASE_PRICE_COEF', 'SET_REALESTATE_QUOTE_APPRAISAL_TYPE_IS_ECO', 'SET_REALESTATE_AREA_ADS_QUERY_STARTDATE', 'SET_REALESTATE_AREA_ADS_QUERY_LIMITDATE', 'SET_REALESTATE_AREA_ADS_QUERY_DISTANCE', 'SET_REALESTATE_QUOTE_PRICE_INCL_TRAVEL_EXPENSES', 'SET_REALESTATE_ASSET_TYPE', 'SET_REALESTATE_DWELLING_TYPE', 'SET_REALESTATE_FLOOR_TYPE', 'QUERY_ADS', 'UPDATE_REALESTATE']), {
        backgroundStyle: function backgroundStyle(value) {
            // console.log('step2: ')
            // console.log(value)
            return {
                'background-color': this.getColor(value)
            };
        },
        setCurrentTabTitle: function setCurrentTabTitle(tabTitle) {
            console.log('hey, current Tab Title: ' + tabTitle);
            this.currentTabTitle = tabTitle;
        },
        setCurrentTab: function setCurrentTab(tabTitle) {
            console.log('hey, current Tab: ' + tabTitle);
            this.tabName = tabTitle;
        },
        set_realestate_cadastral_reference: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_REALESTATE_CADASTRAL_REFERENCE(e.target.value);
        }, 1000),
        set_realestate_census_section_code: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_REALESTATE_CENSUS_SECTION_CODE(e.target.value);
        }, 1000),
        set_realestate_full_address: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_REALESTATE_FULL_ADDRESS(e.target.value);
        }, 0),
        set_realestate_short_address: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_REALESTATE_SHORT_ADDRESS(e.target.value);
        }, 0),
        set_realestate_country_option: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            console.log('set_realestate_country e: ');
            console.log(e);
            this.SET_REALESTATE_COUNTRY(e);

            this.SET_REALESTATE_PROVINCE(null);
            this.realestate.province = null;

            this.SET_REALESTATE_MUNICIPALITY(null);
            this.realestate.municipality = null;

            this.SET_REALESTATE_LAT(null);
            this.realestate.lat = null;

            this.SET_REALESTATE_LNG(null);
            this.realestate.lng = null;

            this.SET_REALESTATE_EPSG25831_X(null);
            this.realestate.epsg25831_x = null;

            this.SET_REALESTATE_EPSG25831_Y(null);
            this.realestate.epsg25831_y = null;

            this.SET_REALESTATE_CADASTRAL_REFERENCE(null);
            this.realestate.cadastral_reference = null;

            this.SET_REALESTATE_CENSUS_SECTION_CODE(null);
            this.realestate.census_section_code = null;

            this.SET_REALESTATE_POSTAL_CODE(null);
            this.realestate.postal_code = null;

            this.SET_REALESTATE_GOOGLE_FORMATTED_ADDRESS(null);
            this.realestate.google_formatted_address = null;
        }, 1000),
        set_realestate_description: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_REALESTATE_DESCRIPTION(e.target.value);
        }, 1000),
        set_realestate_door: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {

            var street_name = '';
            var street_number = '';
            var floor = '';
            var door = e.target.value;
            var staircase = '';
            var block = '';
            var postal_code = '';
            var municipality = '';
            var full_address = '';

            if (this.realestate.street_name) {
                street_name = this.realestate.street_name;
                full_address = street_name;
            }

            if (this.realestate.street_number) {
                street_number = this.realestate.street_number;
                full_address = full_address + ', ' + street_number;
            }

            if (this.realestate.floor) {
                floor = this.realestate.floor;
                full_address = full_address + ', ' + floor;
            }

            if (this.realestate.floor) {
                full_address = full_address + ' ' + door;
            } else {
                full_address = full_address + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('door') + ' ' + door;
            }

            if (this.realestate.staircase) {
                staircase = this.realestate.staircase;
                full_address = full_address + ', ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('staircase') + ' ' + staircase;
            }

            if (this.realestate.block) {
                block = this.realestate.block;
                full_address = full_address + ', ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('block') + ' ' + block;
            }

            if (this.realestate.postal_code) {
                postal_code = this.realestate.postal_code;
                full_address = full_address + ', ' + postal_code;
            }

            if (this.realestate.municipality) {
                municipality = this.realestate.municipality.name_ine;
                full_address = full_address + ', ' + municipality;
            }

            this.SET_REALESTATE_FULL_ADDRESS(full_address);

            this.SET_REALESTATE_DOOR(e.target.value);
        }, 1000),
        set_realestate_epsg25831_x: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_REALESTATE_EPSG25831_X(e.target.value);
        }, 1000),
        set_realestate_epsg25831_y: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_REALESTATE_EPSG25831_Y(e.target.value);
        }, 1000),
        set_realestate_floor: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_REALESTATE_FLOOR(e.target.value);

            var street_name = '';
            var street_number = '';
            var floor = e.target.value;
            var door = '';
            var staircase = '';
            var block = '';
            var postal_code = '';
            var municipality = '';
            var full_address = '';

            if (this.realestate.street_name) {
                street_name = this.realestate.street_name;
                full_address = street_name;
            }

            if (this.realestate.street_number) {
                street_number = this.realestate.street_number;
                full_address = full_address + ', ' + street_number;
            }

            full_address = full_address + ', ' + floor;

            if (this.realestate.door) {
                door = this.realestate.door;
                if (this.realestate.floor) {
                    full_address = full_address + ' ' + door;
                } else {
                    full_address = full_address + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('door') + ' ' + door;
                }
            }

            if (this.realestate.staircase) {
                staircase = this.realestate.staircase;
                full_address = full_address + ', ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('staircase') + ' ' + staircase;
            }

            if (this.realestate.block) {
                block = this.realestate.block;
                full_address = full_address + ', ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('block') + ' ' + block;
            }

            if (this.realestate.postal_code) {
                postal_code = this.realestate.postal_code;
                full_address = full_address + ', ' + postal_code;
            }

            if (this.realestate.municipality) {
                municipality = this.realestate.municipality.name_ine;
                full_address = full_address + ', ' + municipality;
            }

            this.SET_REALESTATE_FULL_ADDRESS(full_address);
        }, 1000),
        set_realestate_block: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_REALESTATE_BLOCK(e.target.value);

            var street_name = '';
            var street_number = '';
            var floor = '';
            var door = '';
            var staircase = '';
            var block = e.target.value;
            var postal_code = '';
            var municipality = '';
            var full_address = '';

            if (this.realestate.street_name) {
                street_name = this.realestate.street_name;
                full_address = street_name;
            }

            if (this.realestate.street_number) {
                street_number = this.realestate.street_number;
                full_address = full_address + ', ' + street_number;
            }

            if (this.realestate.floor) {
                floor = this.realestate.floor;
                full_address = full_address + ', ' + floor;
            }

            if (this.realestate.door) {
                door = this.realestate.door;
                if (this.realestate.floor) {
                    full_address = full_address + ' ' + door;
                } else {
                    full_address = full_address + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('door') + ' ' + door;
                }
            }

            if (this.realestate.staircase) {
                staircase = this.realestate.staircase;
                full_address = full_address + ', ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('staircase') + ' ' + staircase;
            }

            full_address = full_address + ', ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('block') + ' ' + block;

            if (this.realestate.postal_code) {
                postal_code = this.realestate.postal_code;
                full_address = full_address + ', ' + postal_code;
            }

            if (this.realestate.municipality) {
                municipality = this.realestate.municipality.name_ine;
                full_address = full_address + ', ' + municipality;
            }

            this.SET_REALESTATE_FULL_ADDRESS(full_address);
        }, 1000),
        set_realestate_floor_number: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this2 = this;

            var floor_number = e.target.value;
            console.log('hola!');
            // TODO: al canviar aquest paràmetre s'hauria d'actualitzar els estudis de mercat de les diferents taxacions d'aquest immoble i també el de les taxacions
            this.SET_REALESTATE_FLOOR_NUMBER(floor_number);

            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(this.realestate_appraisals, function (value, key) {
                // console.log('appraisal key: ')
                // console.log(key)
                _this2.SET_APPRAISAL_FLOOR_NUMBER_BY_KEY({
                    realestate_id: _this2.realestate.id,
                    appraisal_id: key,
                    floor_number: floor_number
                });
            });
        }, 1000),
        set_realestate_lat: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_REALESTATE_LAT(e.target.value);
        }, 1000),
        set_realestate_lng: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_REALESTATE_LNG(e.target.value);
        }, 1000),
        set_realestate_municipality: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_REALESTATE_MUNICIPALITY(e.target.value);

            var street_name = '';
            var street_number = '';
            var floor = '';
            var door = '';
            var staircase = '';
            var block = '';
            var postal_code = '';
            var municipality = e.target.value;
            var full_address = '';

            if (this.realestate.street_name) {
                street_name = this.realestate.street_name;
                full_address = street_name;
            }

            if (this.realestate.street_number) {
                street_number = this.realestate.street_number;
                full_address = full_address + ', ' + street_number;
            }

            if (this.realestate.floor) {
                floor = this.realestate.floor;
                full_address = full_address + ', ' + floor;
            }

            if (this.realestate.door) {
                door = this.realestate.door;
                if (this.realestate.floor) {
                    full_address = full_address + ' ' + door;
                } else {
                    full_address = full_address + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('door') + ' ' + door;
                }
            }

            if (this.realestate.staircase) {
                staircase = this.realestate.staircase;
                full_address = full_address + ', ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('staircase') + ' ' + staircase;
            }

            if (this.realestate.block) {
                block = this.realestate.block;
                full_address = full_address + ', ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('block') + ' ' + block;
            }

            if (this.realestate.postal_code) {
                postal_code = this.realestate.postal_code;
                full_address = full_address + ', ' + postal_code;
            }

            full_address = full_address + ', ' + municipality;

            this.SET_REALESTATE_FULL_ADDRESS(full_address);
        }, 1000),
        set_realestate_municipality_option: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_REALESTATE_MUNICIPALITY(e);
        }, 1000),
        set_realestate_postal_code: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_REALESTATE_POSTAL_CODE(e.target.value);

            var street_name = '';
            var street_number = '';
            var floor = '';
            var door = '';
            var staircase = '';
            var block = '';
            var postal_code = e.target.value;
            var municipality = '';
            var full_address = '';

            if (this.realestate.street_name) {
                street_name = this.realestate.street_name;
                full_address = street_name;
            }

            if (this.realestate.street_number) {
                street_number = this.realestate.street_number;
                full_address = full_address + ', ' + street_number;
            }

            if (this.realestate.floor) {
                floor = this.realestate.floor;
                full_address = full_address + ', ' + floor;
            }

            if (this.realestate.door) {
                door = this.realestate.door;
                if (this.realestate.floor) {
                    full_address = full_address + ' ' + door;
                } else {
                    full_address = full_address + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('door') + ' ' + door;
                }
            }

            if (this.realestate.staircase) {
                staircase = this.realestate.staircase;
                full_address = full_address + ', ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('staircase') + ' ' + staircase;
            }

            if (this.realestate.block) {
                block = this.realestate.block;
                full_address = full_address + ', ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('block') + ' ' + block;
            }

            full_address = full_address + ', ' + postal_code;

            if (this.realestate.municipality) {
                municipality = this.realestate.municipality.name_ine;
                full_address = full_address + ', ' + municipality;
            }

            this.SET_REALESTATE_FULL_ADDRESS(full_address);
        }, 1000),
        set_realestate_property_type: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this3 = this;

            var property_type = e;
            this.SET_REALESTATE_PROPERTY_TYPE(property_type);

            // Si es canvia el tipus d'immoble actualitzar els honoraris
            if (this.realestate.pre_appraisal_value) {
                this.set_base_fees(this.realestate.pre_appraisal_value);
            }

            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(this.realestate_appraisals, function (value, key) {
                // console.log('appraisal key: ')
                // console.log(key)
                _this3.SET_APPRAISAL_PROPERTY_TYPE_BY_KEY({
                    realestate_id: _this3.realestate.id,
                    appraisal_id: key,
                    property_type: property_type
                });
            });

            if (property_type.name_es === 'Garaje') {

                var asset_obj = {
                    bde_code: 'V98',
                    name_es: 'V98 - Plazas de garaje',
                    name_ca: 'V98 - Places d\'aparcament',
                    name_en: 'V98 - Parking spaces',
                    lifespan: 100
                };

                var dwelling_obj = {
                    id: 0,
                    bde_code: 0,
                    name_ca: '0 - No s\'aplica, al no tractar-se d\'habitatge',
                    name_en: '0 - Not applicable, the real estate is not a housing type',
                    name_es: '0 - No se aplica, al no tratarse de vivienda'
                };

                this.SET_REALESTATE_ASSET_TYPE(asset_obj);
                this.SET_REALESTATE_DWELLING_TYPE(dwelling_obj);
            } else if (property_type.name_es === 'Plaza de aparcamiento') {

                var _asset_obj = {
                    bde_code: 'V98',
                    name_es: 'V98 - Plazas de garaje',
                    name_ca: 'V98 - Places d\'aparcament',
                    name_en: 'V98 - Parking spaces',
                    lifespan: 100
                };

                var _dwelling_obj = {
                    id: 0,
                    bde_code: 0,
                    name_ca: '0 - No s\'aplica, al no tractar-se d\'habitatge',
                    name_en: '0 - Not applicable, the real estate is not a housing type',
                    name_es: '0 - No se aplica, al no tratarse de vivienda'
                };

                this.SET_REALESTATE_ASSET_TYPE(_asset_obj);
                this.SET_REALESTATE_DWELLING_TYPE(_dwelling_obj);
            } else if (property_type.name_es === 'Trastero') {

                var _asset_obj2 = {
                    bde_code: 'V99',
                    name_es: 'V99 - Trasteros',
                    name_ca: 'V99 - Trasters',
                    name_en: 'V99 - Storage rooms',
                    lifespan: 100
                };

                var _dwelling_obj2 = {
                    id: 0,
                    bde_code: 0,
                    name_ca: '0 - No s\'aplica, al no tractar-se d\'habitatge',
                    name_en: '0 - Not applicable, the real estate is not a housing type',
                    name_es: '0 - No se aplica, al no tratarse de vivienda'
                };

                this.SET_REALESTATE_ASSET_TYPE(_asset_obj2);
                this.SET_REALESTATE_DWELLING_TYPE(_dwelling_obj2);
            } else if (property_type.name_es === 'Trastero') {

                var _asset_obj3 = {
                    bde_code: 'V99',
                    name_es: 'V99 - Trasteros',
                    name_ca: 'V99 - Trasters',
                    name_en: 'V99 - Storage rooms',
                    lifespan: 100
                };

                var _dwelling_obj3 = {
                    id: 0,
                    bde_code: 0,
                    name_ca: '0 - No s\'aplica, al no tractar-se d\'habitatge',
                    name_en: '0 - Not applicable, the real estate is not a housing type',
                    name_es: '0 - No se aplica, al no tratarse de vivienda'
                };

                this.SET_REALESTATE_ASSET_TYPE(_asset_obj3);
                this.SET_REALESTATE_DWELLING_TYPE(_dwelling_obj3);
            } else if (property_type.name_es === 'Piscina') {

                var _asset_obj4 = {
                    bde_code: 'VA3',
                    name_es: 'VA3 - Resto de los edificios',
                    name_ca: 'VA3 - Altres edificis',
                    name_en: 'VA3 - Other buildings',
                    lifespan: 50
                };

                var _dwelling_obj4 = {
                    id: 0,
                    bde_code: 0,
                    name_ca: '0 - No s\'aplica, al no tractar-se d\'habitatge',
                    name_en: '0 - Not applicable, the real estate is not a housing type',
                    name_es: '0 - No se aplica, al no tratarse de vivienda'
                };

                this.SET_REALESTATE_ASSET_TYPE(_asset_obj4);
                this.SET_REALESTATE_DWELLING_TYPE(_dwelling_obj4);
            } else if (property_type.name_es === 'Pista deportiva') {

                var _asset_obj5 = {
                    bde_code: 'VA3',
                    name_es: 'VA3 - Resto de los edificios',
                    name_ca: 'VA3 - Altres edificis',
                    name_en: 'VA3 - Other buildings',
                    lifespan: 50
                };

                var _dwelling_obj5 = {
                    id: 0,
                    bde_code: 0,
                    name_ca: '0 - No s\'aplica, al no tractar-se d\'habitatge',
                    name_en: '0 - Not applicable, the real estate is not a housing type',
                    name_es: '0 - No se aplica, al no tratarse de vivienda'
                };

                this.SET_REALESTATE_ASSET_TYPE(_asset_obj5);
                this.SET_REALESTATE_DWELLING_TYPE(_dwelling_obj5);
            } else if (property_type.name_es === 'Club deportivo') {

                var _asset_obj6 = {
                    bde_code: 'VA3',
                    name_es: 'VA3 - Resto de los edificios',
                    name_ca: 'VA3 - Altres edificis',
                    name_en: 'VA3 - Other buildings',
                    lifespan: 50
                };

                var _dwelling_obj6 = {
                    id: 0,
                    bde_code: 0,
                    name_ca: '0 - No s\'aplica, al no tractar-se d\'habitatge',
                    name_en: '0 - Not applicable, the real estate is not a housing type',
                    name_es: '0 - No se aplica, al no tratarse de vivienda'
                };

                this.SET_REALESTATE_ASSET_TYPE(_asset_obj6);
                this.SET_REALESTATE_DWELLING_TYPE(_dwelling_obj6);
            } else if (property_type.name_es === 'Local con acceso directo') {

                var _asset_obj7 = {
                    bde_code: 'V97',
                    name_es: 'V97 - Locales comerciales',
                    name_ca: 'V97 - Locals comercials',
                    name_en: 'V97 - Retail',
                    lifespan: 50
                };

                var _dwelling_obj7 = {
                    id: 0,
                    bde_code: 0,
                    name_ca: '0 - No s\'aplica, al no tractar-se d\'habitatge',
                    name_en: '0 - Not applicable, the real estate is not a housing type',
                    name_es: '0 - No se aplica, al no tratarse de vivienda'
                };

                this.SET_REALESTATE_ASSET_TYPE(_asset_obj7);
                this.SET_REALESTATE_DWELLING_TYPE(_dwelling_obj7);
            } else if (property_type.name_es === 'Local sin acceso directo') {

                var _asset_obj8 = {
                    bde_code: 'V97',
                    name_es: 'V97 - Locales comerciales',
                    name_ca: 'V97 - Locals comercials',
                    name_en: 'V97 - Retail',
                    lifespan: 50
                };

                var _dwelling_obj8 = {
                    id: 0,
                    bde_code: 0,
                    name_ca: '0 - No s\'aplica, al no tractar-se d\'habitatge',
                    name_en: '0 - Not applicable, the real estate is not a housing type',
                    name_es: '0 - No se aplica, al no tratarse de vivienda'
                };

                this.SET_REALESTATE_ASSET_TYPE(_asset_obj8);
                this.SET_REALESTATE_DWELLING_TYPE(_dwelling_obj8);
            } else if (property_type.name_es === 'Nave industrial') {

                var _asset_obj9 = {
                    bde_code: 'VA3',
                    name_es: 'VA3 - Resto de los edificios',
                    name_ca: 'VA3 - Altres edificis',
                    name_en: 'VA3 - Other buildings',
                    lifespan: 35
                };

                var _dwelling_obj9 = {
                    id: 0,
                    bde_code: 0,
                    name_ca: '0 - No s\'aplica, al no tractar-se d\'habitatge',
                    name_en: '0 - Not applicable, the real estate is not a housing type',
                    name_es: '0 - No se aplica, al no tratarse de vivienda'
                };

                this.SET_REALESTATE_ASSET_TYPE(_asset_obj9);
                this.SET_REALESTATE_DWELLING_TYPE(_dwelling_obj9);
            } else if (property_type.name_es === 'Escuela') {

                var _asset_obj10 = {
                    bde_code: 'VA3',
                    name_es: 'VA3 - Resto de los edificios',
                    name_ca: 'VA3 - Altres edificis',
                    name_en: 'VA3 - Other buildings',
                    lifespan: 50
                };

                var _dwelling_obj10 = {
                    id: 0,
                    bde_code: 0,
                    name_ca: '0 - No s\'aplica, al no tractar-se d\'habitatge',
                    name_en: '0 - Not applicable, the real estate is not a housing type',
                    name_es: '0 - No se aplica, al no tratarse de vivienda'
                };

                this.SET_REALESTATE_ASSET_TYPE(_asset_obj10);
                this.SET_REALESTATE_DWELLING_TYPE(_dwelling_obj10);
            } else if (property_type.name_es === 'Hotel') {

                var _asset_obj11 = {
                    bde_code: 'VA1',
                    name_es: 'VA1 - Hoteles',
                    name_ca: 'VA1 - Hotels',
                    name_en: 'VA1 - Hotels',
                    lifespan: 50
                };

                var _dwelling_obj11 = {
                    id: 0,
                    bde_code: 0,
                    name_ca: '0 - No s\'aplica, al no tractar-se d\'habitatge',
                    name_en: '0 - Not applicable, the real estate is not a housing type',
                    name_es: '0 - No se aplica, al no tratarse de vivienda'
                };

                this.SET_REALESTATE_ASSET_TYPE(_asset_obj11);
                this.SET_REALESTATE_DWELLING_TYPE(_dwelling_obj11);
            }
        }, 500),
        set_realestate_province: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this4 = this;

            this.SET_REALESTATE_PROVINCE(e.target.value).then(function (res) {
                _this4.SET_REALESTATE_MUNICIPALITY(null);
                _this4.realestate.municipality = null;
            });
        }, 1000),
        set_realestate_province_option: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var _this5 = this;

            this.SET_REALESTATE_PROVINCE(e).then(function (res) {
                _this5.FETCH_REALESTATE_MUNICIPALITIES({ path: 'municipalities' + '/' + 'province_' + _this5.realestate.province.ine_province_code + '/' });
                _this5.SET_REALESTATE_MUNICIPALITY(null);
                _this5.realestate.municipality = null;
            });
        }, 1000),
        set_realestate_registry_name: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_REALESTATE_REGISTRY_NAME(e.target.value);
        }, 1000),
        set_realestate_staircase: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {

            var street_name = '';
            var street_number = '';
            var floor = '';
            var door = '';
            var staircase = e.target.value;
            var block = '';
            var postal_code = '';
            var municipality = '';
            var full_address = '';

            if (this.realestate.street_name) {
                street_name = this.realestate.street_name;
                full_address = street_name;
            }

            if (this.realestate.street_number) {
                floor = this.realestate.street_number;
                full_address = full_address + ', ' + street_number;
            }

            if (this.realestate.floor) {
                floor = this.realestate.floor;
                if (this.realestate.floor) {
                    full_address = full_address + '-' + floor;
                } else {
                    full_address = full_address + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('floor') + ' ' + floor;
                }
            }

            if (this.realestate.door) {
                door = this.realestate.door;
                if (this.realestate.door) {
                    full_address = full_address + ' ' + door;
                } else {
                    full_address = full_address + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('door') + ' ' + door;
                }
            }

            full_address = full_address + ', ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('staircase') + ' ' + staircase;

            if (this.realestate.block) {
                block = this.realestate.block;
                full_address = full_address + ', ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('block') + ' ' + block;
            }

            if (this.realestate.postal_code) {
                postal_code = this.realestate.postal_code;
                full_address = full_address + ', ' + postal_code;
            }

            if (this.realestate.municipality) {
                municipality = this.realestate.municipality.name_ine;
                full_address = full_address + ', ' + municipality;
            }

            this.SET_REALESTATE_STAIRCASE(e.target.value);
        }, 1000),
        set_realestate_street_name: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {

            var street_name = e.target.value;
            var street_number = '';
            var floor = '';
            var door = '';
            var staircase = '';
            var block = '';
            var postal_code = '';
            var municipality = '';
            var full_address = '';

            full_address = street_name;

            if (this.realestate.street_number) {
                street_number = this.realestate.street_number;
                full_address = full_address + ', ' + street_number;
            }

            if (this.realestate.floor) {
                floor = this.realestate.floor;
                full_address = full_address + ', ' + floor;
            }

            if (this.realestate.door) {
                door = this.realestate.door;
                if (this.realestate.floor) {
                    full_address = full_address + ' ' + door;
                } else {
                    full_address = full_address + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('door') + ' ' + door;
                }
            }

            if (this.realestate.staircase) {
                staircase = this.realestate.staircase;
                full_address = full_address + ', ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('staircase') + ' ' + staircase;
            }

            if (this.realestate.block) {
                block = this.realestate.block;
                full_address = full_address + ', ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('block') + ' ' + block;
            }

            if (this.realestate.postal_code) {
                postal_code = this.realestate.postal_code;
                full_address = full_address + ', ' + postal_code;
            }

            if (this.realestate.municipality) {
                municipality = this.realestate.municipality.name_ine;
                full_address = full_address + ', ' + municipality;
            }

            this.SET_REALESTATE_FULL_ADDRESS(full_address);

            this.SET_REALESTATE_STREET_NAME(street_name);

            if (!e.target.value || e.target.value.length === 0) {
                // console.log('no street name')

                this.SET_REALESTATE_LAT(null);
                this.realestate.lat = null;

                this.SET_REALESTATE_LNG(null);
                this.realestate.lng = null;

                this.SET_REALESTATE_EPSG25831_X(null);
                this.realestate.epsg25831_x = null;

                this.SET_REALESTATE_EPSG25831_Y(null);
                this.realestate.epsg25831_y = null;

                this.SET_REALESTATE_CADASTRAL_REFERENCE(null);
                this.realestate.cadastral_reference = null;

                this.SET_REALESTATE_CENSUS_SECTION_CODE(null);
                this.realestate.census_section_code = null;

                this.SET_REALESTATE_POSTAL_CODE(null);
                this.realestate.postal_code = null;

                this.SET_REALESTATE_GOOGLE_FORMATTED_ADDRESS(null);
                this.realestate.google_formatted_address = null;
            }
        }, 1000),
        set_realestate_street_number: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_REALESTATE_STREET_NUMBER(e.target.value);

            var street_name = '';
            var street_number = e.target.value;
            var floor = '';
            var door = '';
            var staircase = '';
            var block = '';
            var postal_code = '';
            var municipality = '';
            var full_address = '';

            if (this.realestate.street_name) {
                street_name = this.realestate.street_name;
                full_address = street_name;
            }

            full_address = full_address + ', ' + street_number;

            if (this.realestate.floor) {
                floor = this.realestate.floor;
                full_address = full_address + ', ' + floor;
            }

            if (this.realestate.door) {
                door = this.realestate.door;
                if (this.realestate.floor) {
                    full_address = full_address + ' ' + door;
                } else {
                    full_address = full_address + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('door') + ' ' + door;
                }
            }

            if (this.realestate.staircase) {
                staircase = this.realestate.staircase;
                full_address = full_address + ', ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('staircase') + ' ' + staircase;
            }

            if (this.realestate.block) {
                block = this.realestate.block;
                full_address = full_address + ', ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('block') + ' ' + block;
            }

            if (this.realestate.postal_code) {
                postal_code = this.realestate.postal_code;
                full_address = full_address + ', ' + postal_code;
            }

            if (this.realestate.municipality) {
                municipality = this.realestate.municipality.name_ine;
                full_address = full_address + ', ' + municipality;
            }

            this.SET_REALESTATE_FULL_ADDRESS(full_address);
        }, 1000),
        set_realestate_area_average_price_coef: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {

            var coef = 0.95;
            var area_average_price = this.realestate.area_average_price;

            if (!area_average_price || isNaN(area_average_price) === true) {
                area_average_price = 0;
            }

            if (e) {
                coef = Number(e.target.value);
            }

            var adopted_area_average_price = this.roundToTwo(area_average_price * coef);

            var area = 0;

            if (this.realestate.estimated_built_area) {
                area = this.realestate.estimated_built_area;
            }

            var pre_appraisal_value = this.roundToTwo(adopted_area_average_price * area);

            this.SET_REALESTATE_ESTIMATED_BUILT_AREA(area);
            this.SET_REALESTATE_PRE_APPRAISAL_VALUE(pre_appraisal_value);
            this.SET_REALESTATE_ADOPTED_AREA_AVERAGE_PRICE(adopted_area_average_price);
            this.SET_REALESTATE_AREA_AVERAGE_PRICE_COEF(coef);

            this.set_base_fees(pre_appraisal_value);
        }, 0),
        set_realestate_quote_price_incl_travel_expenses: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_REALESTATE_QUOTE_PRICE_INCL_TRAVEL_EXPENSES(Number(e.target.value));
        }, 1000),
        set_base_fees: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (pre_appraisal_value) {

            var base_fees = 0;
            var bp_coef = 1;
            if (this.realestate.quote_base_price_coef) {
                bp_coef = this.realestate.quote_base_price_coef;
            }
            var quote_excess_pct = 0;
            var excess = 0;
            var base_price = 0;

            var is_eco = this.realestate.quote_appraisal_type_is_eco;

            var roundToTwoTemp = function roundToTwoTemp(num) {
                return +(Math.round(num + 'e+2') + 'e-2');
            };

            if (this.realestate.property_type.name_db === 'residential' || this.realestate.property_type.name_db === 'parking' || this.realestate.property_type.name_db === 'storage') {
                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(this.valuation_prices.group_A, function (range, key) {
                    // console.log('pre_appraisal_value: ')
                    // console.log(pre_appraisal_value)
                    // console.log('range.ceil: ')
                    // console.log(range.ceil)
                    // console.log('range.floor: ')
                    // console.log(range.floor)

                    if (pre_appraisal_value >= range.floor && pre_appraisal_value < range.ceil) {

                        excess = pre_appraisal_value - range.floor;

                        if (is_eco) {

                            base_fees = range.mortgage_valuation_fee;
                            // console.log('base_fees: ')
                            // console.log(base_fees)

                            quote_excess_pct = range.increment_pct_mortgage_valuation;
                            base_price = roundToTwoTemp((base_fees + excess * (quote_excess_pct / 100)) * bp_coef);
                        } else {
                            base_fees = range.standard_valuation_fee;
                            // console.log('base_fees: ')
                            // console.log(base_fees)

                            quote_excess_pct = range.increment_pct_standard_valuation;
                            base_price = roundToTwoTemp((base_fees + excess * (quote_excess_pct / 100)) * bp_coef);
                        }
                    }
                });
            } else if (this.realestate.property_type.name_db === 'retail_and_industrial' || this.realestate.property_type.name_db === 'office') {
                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(this.valuation_prices.group_B, function (range, key) {
                    // console.log('pre_appraisal_value: ')
                    // console.log(pre_appraisal_value)
                    // console.log('range.ceil: ')
                    // console.log(range.ceil)
                    // console.log('range.floor: ')
                    // console.log(range.floor)

                    if (pre_appraisal_value >= range.floor && pre_appraisal_value < range.ceil) {

                        excess = pre_appraisal_value - range.floor;

                        console.log('excess: ');
                        console.log(excess);

                        if (is_eco) {

                            base_fees = range.mortgage_valuation_fee;

                            quote_excess_pct = range.increment_pct_mortgage_valuation;
                            base_price = roundToTwoTemp((base_fees + excess * (quote_excess_pct / 100)) * bp_coef);

                            console.log('base_fees: ');
                            console.log(base_fees);

                            console.log('quote_excess_pct: ');
                            console.log(quote_excess_pct);

                            console.log('base_price: ');
                            console.log(base_price);
                        } else {
                            base_fees = range.standard_valuation_fee;
                            // console.log('base_fees: ')
                            // console.log(base_fees)

                            quote_excess_pct = range.increment_pct_standard_valuation;
                            base_price = roundToTwoTemp((base_fees + excess * (quote_excess_pct / 100)) * bp_coef);
                        }
                    }
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(this.valuation_prices.group_C, function (range, key) {
                    // console.log('pre_appraisal_value: ')
                    // console.log(pre_appraisal_value)
                    // console.log('range.ceil: ')
                    // console.log(range.ceil)
                    // console.log('range.floor: ')
                    // console.log(range.floor)

                    if (pre_appraisal_value >= range.floor && pre_appraisal_value < range.ceil) {

                        excess = pre_appraisal_value - range.floor;

                        base_fees = range.standard_valuation_fee;
                        // console.log('base_fees: ')
                        // console.log(base_fees)

                        quote_excess_pct = range.increment_pct_standard_valuation;
                        base_price = roundToTwoTemp((base_fees + excess * (quote_excess_pct / 100)) * bp_coef);
                    }
                });
            }
            /*
            else if(this.realestate.property_type.name_db === 'entire_buildings' || this.realestate.property_type.name_db === 'land'){
            }
            */

            this.SET_REALESTATE_QUOTE_BASE_FEES(base_fees);
            this.SET_REALESTATE_QUOTE_EXCESS(excess);
            this.SET_REALESTATE_QUOTE_EXCESS_PCT(quote_excess_pct);
            this.SET_REALESTATE_QUOTE_BASE_PRICE(base_price);
            this.SET_REALESTATE_QUOTE_BASE_PRICE_COEF(bp_coef);

            this.SET_REALESTATE_QUOTE_BASE_FEES(base_fees);

            var total_travel_fees = this.realestate.total_travel_fees;
            this.calc_base_price(base_fees, quote_excess_pct, bp_coef, total_travel_fees, excess);
        }, 0),
        set_realestate_adopted_area_average_price: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_REALESTATE_ADOPTED_AREA_AVERAGE_PRICE(Number(e.target.value));
        }, 1000),
        set_realestate_estimated_built_area: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {

            var area = Number(e.target.value);

            var adopted_area_average_price = 0;

            if (this.realestate.adopted_area_average_price) {
                adopted_area_average_price = this.realestate.adopted_area_average_price;
            }

            var pre_appraisal_value = this.roundToTwo(adopted_area_average_price * area);

            this.SET_REALESTATE_PRE_APPRAISAL_VALUE(pre_appraisal_value);

            this.SET_REALESTATE_ESTIMATED_BUILT_AREA(area);

            this.set_base_fees(pre_appraisal_value);
        }, 0),
        set_realestate_pre_appraisal_value: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_REALESTATE_PRE_APPRAISAL_VALUE(Number(e.target.value));
        }, 1000),
        set_realestate_travel_one_way_hours: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {

            var hours = Number(e.target.value);
            this.SET_REALESTATE_TRAVEL_ONE_WAY_HOURS(hours);

            if (hours > 0) {
                this.SET_REALESTATE_TRAVEL_BOTH_WAYS_HOURS(hours * 2);
            } else if (hours === 0 || !hours) {
                this.SET_REALESTATE_TRAVEL_BOTH_WAYS_HOURS(0);
            }
            this.set_realestate_total_travel_fees();
        }, 0),
        set_realestate_travel_both_ways_hours: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_REALESTATE_TRAVEL_BOTH_WAYS_HOURS(Number(e.target.value));
        }, 0),
        set_realestate_travel_fees_per_hour: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_REALESTATE_TRAVEL_FEES_PER_HOUR(Number(e.target.value));
            this.set_realestate_total_travel_fees();
        }, 0),
        set_realestate_car_fuel_expenses_one_way: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {

            var fuel_expenses = Number(e.target.value);

            this.SET_REALESTATE_CAR_FUEL_EXPENSES_ONE_WAY(fuel_expenses);
            this.SET_REALESTATE_CAR_FUEL_EXPENSES_BOTH_WAYS(this.roundToTwo(fuel_expenses * 2));
            this.set_realestate_total_travel_fees();
        }, 0),
        set_realestate_car_fuel_expenses_both_ways: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_REALESTATE_CAR_FUEL_EXPENSES_BOTH_WAYS(Number(e.target.value));
        }, 0),
        set_realestate_car_toll_expenses_one_way: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var toll_expenses = Number(e.target.value);

            this.SET_REALESTATE_CAR_TOLL_EXPENSES_ONE_WAY(toll_expenses);
            this.SET_REALESTATE_CAR_TOLL_EXPENSES_BOTH_WAYS(this.roundToTwo(toll_expenses * 2));
            this.set_realestate_total_travel_fees();
        }, 0),
        set_realestate_car_toll_expenses_both_ways: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_REALESTATE_CAR_TOLL_EXPENSES_BOTH_WAYS(Number(e.target.value));
        }, 0),
        set_realestate_car_expenses_one_way: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var travel_expenses = this.realestate.car_fuel_expenses_one_way + this.realestate.car_toll_expenses_one_way;
            this.SET_REALESTATE_CAR_EXPENSES_ONE_WAY(travel_expenses);
        }, 0),
        set_realestate_car_expenses_both_ways: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            var travel_expenses = this.realestate.car_fuel_expenses_both_ways + this.realestate.car_toll_expenses_both_ways;
            this.SET_REALESTATE_CAR_EXPENSES_BOTH_WAYS(travel_expenses);
        }, 0),
        set_realestate_total_travel_fees: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {

            var travel_expenses = this.realestate.car_fuel_expenses_both_ways + this.realestate.car_toll_expenses_both_ways;

            var hours = this.realestate.travel_both_ways_hours;

            if (!this.realestate.travel_both_ways_hours) {
                hours = 0;
            }

            var hourly_fees = this.realestate.travel_fees_per_hour;

            if (!this.realestate.travel_fees_per_hour) {
                hourly_fees = 0;
            }
            var travel_fees = hours * hourly_fees;
            var total_travel_fees = travel_expenses + travel_fees;

            this.SET_REALESTATE_TOTAL_TRAVEL_FEES(total_travel_fees);

            var base_fees = this.realestate.quote_base_fees;
            var quote_excess_pct = this.realestate.quote_excess_pct;
            var quote_base_price_coef = this.realestate.quote_base_price_coef;

            var excess = this.realestate.quote_excess;

            this.calc_base_price(base_fees, quote_excess_pct, quote_base_price_coef, total_travel_fees, excess);
        }, 0),
        set_realestate_quote_base_fees: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {

            var base_fees = Number(e.target.value);
            this.SET_REALESTATE_QUOTE_BASE_FEES(base_fees);

            var quote_excess_pct = this.realestate.quote_excess_pct;
            var quote_base_price_coef = this.realestate.quote_base_price_coef;

            var total_travel_fees = this.realestate.total_travel_fees;

            var excess = this.realestate.quote_excess;

            this.calc_base_price(base_fees, quote_excess_pct, quote_base_price_coef, total_travel_fees, excess);
        }, 0),
        set_realestate_quote_excess_pct: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {

            var quote_excess_pct = Number(e.target.value);
            this.SET_REALESTATE_QUOTE_EXCESS_PCT(quote_excess_pct);

            var base_fees = this.realestate.quote_base_fees;
            var quote_base_price_coef = this.realestate.quote_base_price_coef;
            var total_travel_fees = this.realestate.total_travel_fees;

            var excess = this.realestate.quote_excess;

            this.calc_base_price(base_fees, quote_excess_pct, quote_base_price_coef, total_travel_fees, excess);
        }, 0),
        set_realestate_quote_excess: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_REALESTATE_QUOTE_EXCESS(Number(e.target.value));
        }, 0),
        set_realestate_quote_base_price: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {

            var quote_base_price = Number(e.target.value);
            this.SET_REALESTATE_QUOTE_BASE_PRICE(quote_base_price);

            var quote_excess_pct = this.realestate.quote_excess_pct;
            var quote_base_price_coef = this.realestate.quote_base_price_coef;
            var total_travel_fees = this.realestate.total_travel_fees;

            var excess = this.realestate.quote_excess;

            this.calc_base_price(base_fees, quote_excess_pct, quote_base_price_coef, total_travel_fees, excess);
        }, 0),
        set_realestate_quote_base_price_coef: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {

            var quote_base_price_coef = Number(e.target.value);
            this.SET_REALESTATE_QUOTE_BASE_PRICE_COEF(quote_base_price_coef);

            var base_fees = this.realestate.quote_base_fees;
            var quote_excess_pct = this.realestate.quote_excess_pct;
            var total_travel_fees = this.realestate.total_travel_fees;

            var excess = this.realestate.quote_excess;

            this.calc_base_price(base_fees, quote_excess_pct, quote_base_price_coef, total_travel_fees, excess);
        }, 0),
        set_realestate_quote_appraisal_type_is_eco: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.set_base_fees(this.realestate.pre_appraisal_value);
            // console.log(e)
        }, 0),
        set_realestate_area_ads_query_startdate: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_REALESTATE_AREA_ADS_QUERY_STARTDATE(e.target.value);
        }, 0),
        set_realestate_area_ads_query_limitdate: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_REALESTATE_AREA_ADS_QUERY_LIMITDATE(e.target.value);
        }, 0),
        set_realestate_area_ads_query_distance: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_REALESTATE_AREA_ADS_QUERY_DISTANCE(Number(e.target.value));
        }, 1000),
        set_realestate_area_average_price: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {

            var area_average_price = 0;

            if (e) {
                area_average_price = Number(e.target.value);
            }

            if (!area_average_price || isNaN(area_average_price) === true) {
                area_average_price = 0;
            }

            var coef = this.realestate.area_average_price_coef;

            if (!coef || isNaN(coef) === true) {
                coef = 0.95;
            }

            var adopted_area_average_price = this.roundToTwo(area_average_price * coef);

            var area = 0;

            if (this.realestate.estimated_built_area) {
                area = this.realestate.estimated_built_area;
            }

            var pre_appraisal_value = this.roundToTwo(adopted_area_average_price * area);

            this.SET_REALESTATE_AREA_AVERAGE_PRICE(area_average_price);

            this.SET_REALESTATE_ESTIMATED_BUILT_AREA(area);
            this.SET_REALESTATE_PRE_APPRAISAL_VALUE(pre_appraisal_value);
            this.SET_REALESTATE_ADOPTED_AREA_AVERAGE_PRICE(adopted_area_average_price);
            this.SET_REALESTATE_AREA_AVERAGE_PRICE_COEF(coef);

            this.set_base_fees(pre_appraisal_value);
        }, 1000),
        set_realestate_asset_type: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_REALESTATE_ASSET_TYPE(e);
        }, 500),
        set_realestate_dwelling_type: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_REALESTATE_DWELLING_TYPE(e);
        }, 500),
        set_realestate_floor_type: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_REALESTATE_FLOOR_TYPE(e);
        }, 1000),
        calc_base_price: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (base_fees, quote_excess_pct, bp_coef, total_travel_fees, excess) {
            var base_price = this.roundToTwo((base_fees + excess * (quote_excess_pct / 100)) * bp_coef);
            this.SET_REALESTATE_QUOTE_BASE_PRICE(base_price);

            var quote_price_incl_travel_expenses = base_price + total_travel_fees;
            this.SET_REALESTATE_QUOTE_PRICE_INCL_TRAVEL_EXPENSES(quote_price_incl_travel_expenses);
        }, 0),
        onSaveCurrentRealEstate: function onSaveCurrentRealEstate(data) {
            var _this6 = this;

            this.UPDATE_REALESTATE({
                key: this.realestate.id,
                object: this.realestate,
                // parent_path: 'appraisalreports/' + this.appraisalreport.id + '/' + 'realestates' + '/',
                path: this.realestate.path + this.realestate.id,
                file_id: this.appraisalfile.id,
                report_id: this.appraisalreport.id
            }).then(function (res) {
                if (data.go_up) {
                    _this6.onGoUp();
                } else {
                    _this6.setCurrentTab(_this6.currentTabTitle);
                    window.scroll(0, 0);
                }
            });
        },

        onGoBack: function onGoBack() {
            // console.log('yeah back')
            __WEBPACK_IMPORTED_MODULE_12__router_index_js__["a" /* default */].go(-1);
        },

        onGoUp: function onGoUp() {
            // console.log('yeah back')
            this.$router.push({ name: 'appraisalreport-editor', query: { id: this.appraisalreport.id } });
        },

        onCancelAll: function onCancelAll() {
            var result = window.confirm(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Changes_will_be_lost_p_continue_q'));

            if (result) {
                __WEBPACK_IMPORTED_MODULE_12__router_index_js__["a" /* default */].go(-1);
            } else {
                return false;
            }
        },
        openAdUrl: function openAdUrl(url) {
            if (url) {
                var win = window.open(url, '_blank');
                win.focus();
            }
        },
        discardAd: function discardAd(index) {

            console.log('index: ');
            console.log(index);

            var markers = this.realestate.area_ads_markers;

            // delete the element from array
            markers.splice(index, 1);

            var unit_prices = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(markers, 'unit_price');

            var max = Math.max.apply(null, unit_prices);
            var min = Math.min.apply(null, unit_prices);
            var diff = max - min;

            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(markers, function (value, index) {

                var label = {
                    color: 'black',
                    text: (index + 1).toString()
                };
                markers[index]['label'] = label;

                // calculating step for color scale formatting
                var step = (unit_prices[index] - min) / diff;
                markers[index]['step'] = step;
            });

            console.log('markers: ');
            console.log(markers);

            var area_average_price = this.calcMean(unit_prices);

            console.log('area_average_price: ');
            console.log(area_average_price);

            this.realestate.area_ads_markers = markers;
            this.SET_REALESTATE_AREA_ADS_MARKERS(markers);
            this.SET_REALESTATE_AREA_AVERAGE_PRICE(area_average_price);

            var coef = 0.95;

            if (this.realestate.area_average_price_coef) {
                coef = this.realestate.area_average_price_coef;
            }

            var adopted_area_average_price = this.roundToTwo(area_average_price * coef);

            console.log('adopted_area_average_price: ');
            console.log(adopted_area_average_price);

            this.SET_REALESTATE_ADOPTED_AREA_AVERAGE_PRICE(adopted_area_average_price);

            var area = 0;

            if (this.realestate.estimated_built_area) {
                area = this.realestate.estimated_built_area;
            }

            var pre_appraisal_value = this.roundToTwo(adopted_area_average_price * area);

            this.SET_REALESTATE_PRE_APPRAISAL_VALUE(pre_appraisal_value);

            this.set_base_fees(pre_appraisal_value);

            this.$forceUpdate();
        },
        onGeolocate: function onGeolocate() {
            var _this7 = this;

            this.google_geocode_loading = true;
            this.master_loading = true;

            this.GEOLOCATE_REALESTATE({
                id: this.realestate.id,
                old_geohash: this.realestate.geohash,
                street_name: this.realestate.street_name,
                street_number: this.realestate.street_number,
                municipality: this.realestate.municipality
            }).then(function (res) {

                if (res.none) {

                    _this7.google_geocode_loading = false;
                    _this7.master_loading = false;
                } else {
                    var lat = null;
                    var lng = null;

                    console.log('res.lat?: ');
                    console.log(res.lat);

                    if (res.lat) {
                        lat = res.lat;
                    }

                    if (res.lng) {
                        lng = res.lng;
                    }
                    _this7.SET_REALESTATE_MAP_GOOGLE_01_LAT(lat);
                    _this7.SET_REALESTATE_MAP_GOOGLE_01_LNG(lng);
                    _this7.SET_REALESTATE_MAP_GOOGLE_01_ZOOM('13');

                    _this7.SET_REALESTATE_MAP_GOOGLE_02_LAT(lat);
                    _this7.SET_REALESTATE_MAP_GOOGLE_02_LNG(lng);
                    _this7.SET_REALESTATE_MAP_GOOGLE_02_ZOOM('16');

                    _this7.SET_REALESTATE_MAP_GOOGLE_03_LAT(lat);
                    _this7.SET_REALESTATE_MAP_GOOGLE_03_LNG(lng);
                    _this7.SET_REALESTATE_MAP_GOOGLE_03_ZOOM('19');

                    _this7.setMapGoogle01(lat, lng, '13', _this7.google_map_size, 'roadmap', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k');
                    _this7.setMapGoogle02(lat, lng, '16', _this7.google_map_size, 'roadmap', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k');
                    _this7.setMapGoogle03(lat, lng, '19', _this7.google_map_size, 'hybrid', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k');

                    // console.log('GELOCATE RES: ')
                    // console.log(res)

                    _this7.google_geocode_loading = false;
                    _this7.master_loading = false;
                }
            });
        },
        onCheckPrices: function onCheckPrices() {
            var _this8 = this;

            this.check_prices_loading = true;
            this.master_loading = true;

            this.onSaveCurrentRealEstate({ go_up: false });

            console.log('this.prices_startdate: ');
            console.log(this.prices_startdate);

            console.log('this.prices_limitdate: ');
            console.log(this.prices_limitdate);

            this.QUERY_ADS({
                key: this.realestate.id,
                lat: this.realestate.lat,
                lng: this.realestate.lng,
                ad_type: this.realestate.property_type ? this.realestate.property_type.name_db : 'residential',
                startdate: this.prices_startdate,
                limitdate: this.prices_limitdate,
                geohash: this.realestate.geohash,
                radius_km: this.realestate.area_ads_query_distance ? this.realestate.area_ads_query_distance : 1
            }).then(function (res2) {

                var area_average_price = 0;

                if (res2.area_average_price && isNaN(res2.area_average_price) === false) {
                    area_average_price = res2.area_average_price;
                } else {
                    area_average_price = 0;
                }

                var coef = 0.95;

                if (_this8.realestate.area_average_price_coef) {
                    coef = _this8.realestate.area_average_price_coef;
                }

                var adopted_area_average_price = _this8.roundToTwo(area_average_price * coef);

                // console.log('average price in the area: ')
                // console.log(area_average_price)

                var area = 0;

                if (_this8.realestate.estimated_built_area) {
                    area = _this8.realestate.estimated_built_area;
                }

                var pre_appraisal_value = _this8.roundToTwo(adopted_area_average_price * area);

                _this8.SET_REALESTATE_ESTIMATED_BUILT_AREA(area);
                _this8.SET_REALESTATE_PRE_APPRAISAL_VALUE(pre_appraisal_value);

                _this8.set_base_fees(pre_appraisal_value);

                _this8.realestate.area_average_price = area_average_price;
                _this8.realestate.adopted_area_average_price = adopted_area_average_price;
                _this8.realestate.area_ads_markers = res2.markers;

                _this8.SET_REALESTATE_AREA_ADS_MARKERS(res2.markers);
                _this8.SET_REALESTATE_AREA_AVERAGE_PRICE_COEF(coef);
                _this8.SET_REALESTATE_AREA_AVERAGE_PRICE(area_average_price);
                _this8.SET_REALESTATE_ADOPTED_AREA_AVERAGE_PRICE(adopted_area_average_price);

                _this8.$forceUpdate();

                _this8.check_prices_loading = false;
                _this8.master_loading = false;
            });
        },
        setMapGoogle01: function setMapGoogle01(lat, lng, zoom, size, maptype, style, key) {
            // console.log('setting Map Google 01....')

            if (!zoom) {
                zoom = '13';
            }

            if (!lat) {
                lat = this.realestate.lat;
            }

            if (!lng) {
                lng = this.realestate.lng;
            }

            var map_01_url = 'https://maps.googleapis.com/maps/api/staticmap?' + 'center=' + lat + ',' + lng + '&zoom=' + zoom + '&size=' + size + '&maptype=' + maptype + '&markers=color:red%7Clabel:T%7C' + lat + ',' + lng + '&style=' + style + '&format=' + 'png' + '&visual_refresh=' + 'true' + '&key=' + key;

            this.realestate.map_google_01_url = map_01_url;
            this.SET_REALESTATE_MAP_GOOGLE_01_URL(map_01_url);
        },
        setMapGoogle02: function setMapGoogle02(lat, lng, zoom, size, maptype, style, key) {
            // console.log('setting Map Google 02....')

            if (!zoom) {
                zoom = '16';
            }

            if (!lat) {
                lat = this.realestate.lat;
            }

            if (!lng) {
                lng = this.realestate.lng;
            }

            var map_02_url = 'https://maps.googleapis.com/maps/api/staticmap?' + 'center=' + lat + ',' + lng + '&zoom=' + zoom + '&size=' + size + '&maptype=' + maptype + '&markers=color:red%7Clabel:T%7C' + lat + ',' + lng + '&style=' + style + '&format=' + 'png' + '&visual_refresh=' + 'true' + '&key=' + key;

            this.realestate.map_google_02_url = map_02_url;
            this.SET_REALESTATE_MAP_GOOGLE_02_URL(map_02_url);
        },
        setMapGoogle03: function setMapGoogle03(lat, lng, zoom, size, maptype, style, key) {
            // console.log('setting Map Google 03....')

            if (!zoom) {
                zoom = '19';
            }

            if (!lat) {
                lat = this.realestate.lat;
            }

            if (!lng) {
                lng = this.realestate.lng;
            }

            var map_03_url = 'https://maps.googleapis.com/maps/api/staticmap?' + 'center=' + lat + ',' + lng + '&zoom=' + zoom + '&size=' + size + '&maptype=' + maptype + '&markers=color:red%7Clabel:T%7C' + lat + ',' + lng + '&style=' + style + '&format=' + 'png' + '&visual_refresh=' + 'true' + '&key=' + key;

            this.realestate.map_google_03_url = map_03_url;
            this.SET_REALESTATE_MAP_GOOGLE_03_URL(map_03_url);
        },

        onRefreshMaps: function onRefreshMaps() {
            // console.log('refreshing Maps...')
            var zoom = '13';
            if (this.realestate.map_google_01_zoom) {
                zoom = this.realestate.map_google_01_zoom.toString();
            }
            this.setMapGoogle01(this.realestate.lat, this.realestate.lng, zoom, '640x640', 'roadmap', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k');
        },

        onDecreaseZoomMapGoogle01: function onDecreaseZoomMapGoogle01() {
            // console.log('decreasing Maps Zoom...')

            var map_google_01_zoom = (Number(this.realestate.map_google_01_zoom) - 1).toString();
            this.SET_REALESTATE_MAP_GOOGLE_01_ZOOM(map_google_01_zoom);

            this.setMapGoogle01(this.realestate.map_google_01_lat, this.realestate.map_google_01_lng, map_google_01_zoom, this.google_map_size, 'roadmap', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k');
        },

        onIncreaseZoomMapGoogle01: function onIncreaseZoomMapGoogle01() {
            // console.log('increasing Maps Zoom...')

            var map_google_01_zoom = (Number(this.realestate.map_google_01_zoom) + 1).toString();
            this.SET_REALESTATE_MAP_GOOGLE_01_ZOOM(map_google_01_zoom);

            this.setMapGoogle01(this.realestate.map_google_01_lat, this.realestate.map_google_01_lng, map_google_01_zoom, this.google_map_size, 'roadmap', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k');
        },

        onGoUpMapGoogle01: function onGoUpMapGoogle01() {
            // console.log('going up Maps Zoom...')

            var map_google_01_lat = this.realestate.map_google_01_lat + this.google_map_offset;
            this.SET_REALESTATE_MAP_GOOGLE_01_LAT(map_google_01_lat);

            this.setMapGoogle01(map_google_01_lat, this.realestate.map_google_01_lng, this.realestate.map_google_01_zoom, this.google_map_size, 'roadmap', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k');
        },

        onGoLeftMapGoogle01: function onGoLeftMapGoogle01() {
            // console.log('going left Maps Zoom...')

            var map_google_01_lng = this.realestate.map_google_01_lng - this.google_map_offset;
            this.SET_REALESTATE_MAP_GOOGLE_01_LNG(map_google_01_lng);

            this.setMapGoogle01(this.realestate.map_google_01_lat, map_google_01_lng, this.realestate.map_google_01_zoom, this.google_map_size, 'roadmap', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k');
        },

        onGoRightMapGoogle01: function onGoRightMapGoogle01() {
            // console.log('going right Maps Zoom...')

            var map_google_01_lng = this.realestate.map_google_01_lng + this.google_map_offset;
            this.SET_REALESTATE_MAP_GOOGLE_01_LNG(map_google_01_lng);

            this.setMapGoogle01(this.realestate.map_google_01_lat, map_google_01_lng, this.realestate.map_google_01_zoom, this.google_map_size, 'roadmap', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k');
        },

        onGoDownMapGoogle01: function onGoDownMapGoogle01() {
            // console.log('going down Maps Zoom...')

            var map_google_01_lat = this.realestate.map_google_01_lat - this.google_map_offset;
            this.SET_REALESTATE_MAP_GOOGLE_01_LAT(map_google_01_lat);

            this.setMapGoogle01(map_google_01_lat, this.realestate.map_google_01_lng, this.realestate.map_google_01_zoom, this.google_map_size, 'roadmap', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k');
        },

        onDecreaseZoomMapGoogle02: function onDecreaseZoomMapGoogle02() {
            // console.log('decreasing Maps Zoom...')

            var map_google_02_zoom = (Number(this.realestate.map_google_02_zoom) - 1).toString();
            this.SET_REALESTATE_MAP_GOOGLE_02_ZOOM(map_google_02_zoom);

            this.setMapGoogle02(this.realestate.map_google_02_lat, this.realestate.map_google_02_lng, map_google_02_zoom, this.google_map_size, 'roadmap', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k');
        },

        onIncreaseZoomMapGoogle02: function onIncreaseZoomMapGoogle02() {
            // console.log('increasing Maps Zoom...')

            var map_google_02_zoom = (Number(this.realestate.map_google_02_zoom) + 1).toString();
            this.SET_REALESTATE_MAP_GOOGLE_02_ZOOM(map_google_02_zoom);

            this.setMapGoogle02(this.realestate.map_google_02_lat, this.realestate.map_google_02_lng, map_google_02_zoom, this.google_map_size, 'roadmap', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k');
        },

        onGoUpMapGoogle02: function onGoUpMapGoogle02() {
            // console.log('going up Maps Zoom...')

            var map_google_02_lat = this.realestate.map_google_02_lat + this.google_map_offset;
            this.SET_REALESTATE_MAP_GOOGLE_02_LAT(map_google_02_lat);

            this.setMapGoogle02(map_google_02_lat, this.realestate.map_google_02_lng, this.realestate.map_google_02_zoom, this.google_map_size, 'roadmap', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k');
        },

        onGoLeftMapGoogle02: function onGoLeftMapGoogle02() {
            // console.log('going left Maps Zoom...')

            var map_google_02_lng = this.realestate.map_google_02_lng - this.google_map_offset;
            this.SET_REALESTATE_MAP_GOOGLE_02_LNG(map_google_02_lng);

            this.setMapGoogle02(this.realestate.map_google_02_lat, map_google_02_lng, this.realestate.map_google_02_zoom, this.google_map_size, 'roadmap', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k');
        },

        onGoRightMapGoogle02: function onGoRightMapGoogle02() {
            // console.log('going right Maps Zoom...')

            var map_google_02_lng = this.realestate.map_google_02_lng + this.google_map_offset;
            this.SET_REALESTATE_MAP_GOOGLE_02_LNG(map_google_02_lng);

            this.setMapGoogle02(this.realestate.map_google_02_lat, map_google_02_lng, this.realestate.map_google_02_zoom, this.google_map_size, 'roadmap', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k');
        },

        onGoDownMapGoogle02: function onGoDownMapGoogle02() {
            // console.log('going down Maps Zoom...')

            var map_google_02_lat = this.realestate.map_google_02_lat - this.google_map_offset;
            this.SET_REALESTATE_MAP_GOOGLE_02_LAT(map_google_02_lat);

            this.setMapGoogle02(map_google_02_lat, this.realestate.map_google_02_lng, this.realestate.map_google_02_zoom, this.google_map_size, 'roadmap', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k');
        },

        onDecreaseZoomMapGoogle03: function onDecreaseZoomMapGoogle03() {
            // console.log('decreasing Maps Zoom...')

            var map_google_03_zoom = (Number(this.realestate.map_google_03_zoom) - 1).toString();
            this.SET_REALESTATE_MAP_GOOGLE_03_ZOOM(map_google_03_zoom);

            this.setMapGoogle03(this.realestate.map_google_03_lat, this.realestate.map_google_03_lng, map_google_03_zoom, this.google_map_size, 'hybrid', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k');
        },

        onIncreaseZoomMapGoogle03: function onIncreaseZoomMapGoogle03() {
            // console.log('increasing Maps Zoom...')

            var map_google_03_zoom = (Number(this.realestate.map_google_03_zoom) + 1).toString();
            this.SET_REALESTATE_MAP_GOOGLE_03_ZOOM(map_google_03_zoom);

            this.setMapGoogle03(this.realestate.map_google_03_lat, this.realestate.map_google_03_lng, map_google_03_zoom, this.google_map_size, 'hybrid', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k');
        },

        onGoUpMapGoogle03: function onGoUpMapGoogle03() {
            // console.log('going up Maps Zoom...')

            var map_google_03_lat = this.realestate.map_google_03_lat + this.google_map_offset;
            this.SET_REALESTATE_MAP_GOOGLE_03_LAT(map_google_03_lat);

            this.setMapGoogle03(map_google_03_lat, this.realestate.map_google_03_lng, this.realestate.map_google_03_zoom, this.google_map_size, 'hybrid', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k');
        },

        onGoLeftMapGoogle03: function onGoLeftMapGoogle03() {
            // console.log('going left Maps Zoom...')

            var map_google_03_lng = this.realestate.map_google_03_lng - this.google_map_offset;
            this.SET_REALESTATE_MAP_GOOGLE_03_LNG(map_google_03_lng);

            this.setMapGoogle03(this.realestate.map_google_03_lat, map_google_03_lng, this.realestate.map_google_03_zoom, this.google_map_size, 'hybrid', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k');
        },

        onGoRightMapGoogle03: function onGoRightMapGoogle03() {
            // console.log('going right Maps Zoom...')

            var map_google_03_lng = this.realestate.map_google_03_lng + this.google_map_offset;
            this.SET_REALESTATE_MAP_GOOGLE_03_LNG(map_google_03_lng);

            this.setMapGoogle03(this.realestate.map_google_03_lat, map_google_03_lng, this.realestate.map_google_03_zoom, this.google_map_size, 'hybrid', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k');
        },

        onGoDownMapGoogle03: function onGoDownMapGoogle03() {
            // console.log('going down Maps Zoom...')

            var map_google_03_lat = this.realestate.map_google_03_lat - this.google_map_offset;
            this.SET_REALESTATE_MAP_GOOGLE_03_LAT(map_google_03_lat);

            this.setMapGoogle03(map_google_03_lat, this.realestate.map_google_03_lng, this.realestate.map_google_03_zoom, this.google_map_size, 'hybrid', 'feature:poi|element:labels|visibility:off', 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k');
        },

        onRequestCensusSectionInfo: function onRequestCensusSectionInfo() {
            var _this9 = this;

            console.log('requesting census section info...');
            this.icc_census_section_loading = true;
            this.REQUEST_CENSUS_SECTION_INFO({
                x: this.realestate.epsg25831_x,
                y: this.realestate.epsg25831_y
            }).then(function (res) {
                //
                _this9.icc_census_section_loading = false;
            });
        },

        onRequestCadastralReferenceSuggestion: function onRequestCadastralReferenceSuggestion() {
            var _this10 = this;

            console.log('requesting cadastral reference suggestion...');
            this.cadaster_ref_loading = true;
            this.REQUEST_CADASTRAL_REFERENCE_BY_COORDINATES({
                x: this.realestate.epsg25831_x,
                y: this.realestate.epsg25831_y
            }).then(function (res) {
                //
                _this10.cadaster_ref_loading = false;
            });
        },

        onOpenCadastralList: function onOpenCadastralList() {
            console.log('opening cadastral list...');
            // const url = 'https://www.whatismyreferer.com/'
            var refcat = this.realestate.cadastral_reference;
            var rc1 = refcat.substring(0, 7);
            var rc2 = refcat.substring(7, 14);
            var url = 'https://www1.sedecatastro.gob.es/CYCBienInmueble/OVCListaBienes.aspx?del=' + this.realestate.municipality.cadaster_province_code + '&muni=' + this.realestate.municipality.cadaster_municipality_code + '&rc1=' + rc1 + '&rc2=' + rc2;
            var win = window.open(url, '_blank');
            win.focus();
        },

        onOpenCadastralMap: function onOpenCadastralMap() {
            console.log('opening cadastral map...');

            var url = 'https://www1.sedecatastro.gob.es/Cartografia/mapa.aspx?del=' + this.realestate.municipality.cadaster_province_code + '&mun=' + this.realestate.municipality.cadaster_municipality_code + '&refcat=' + this.realestate.cadastral_reference + '&final=';
            var win = window.open(url, '_blank');
            win.focus();
        },

        onRequestGoogleMap: function onRequestGoogleMap() {},

        onCreateNewAppraisal: function onCreateNewAppraisal() {
            var _this11 = this;

            this.master_loading = true;
            this.RESET_APPRAISAL().then(function (res) {
                _this11.CREATE_NEW_APPRAISAL({
                    path: 'realestate_appraisals' + '/' + _this11.realestate.id + '/',
                    parent_path: 'realestates' + '/' + _this11.realestate.id + '/' + 'appraisals' + '/',
                    file_id: _this11.appraisalfile.id,
                    realestate_id: _this11.realestate.id
                }).then(function (res) {
                    _this11.$router.push({ name: 'appraisal-editor', query: { id: _this11.appraisal.id } });
                });
            });
        },
        onCreateNewProject: function onCreateNewProject() {
            var _this12 = this;

            this.master_loading = true;
            this.RESET_PROJECT().then(function (res) {
                _this12.CREATE_NEW_PROJECT({
                    path: 'realestate_projects' + '/' + _this12.realestate.id + '/',
                    parent_path: 'realestates' + '/' + _this12.realestate.id + '/' + 'projects' + '/',
                    // file_id: this.projectfile.id,
                    realestate_id: _this12.realestate.id
                }).then(function (res) {
                    _this12.$router.push({ name: 'project-editor', query: { id: _this12.project.id } });
                });
            });
        },
        onCreateNewMarketStudy: function onCreateNewMarketStudy() {
            var _this13 = this;

            var appraisal_id = this.object_to_array(this.realestate_appraisals)[0].id;
            // console.log('appraisal_id: )
            // console.log(appraisal_id)
            this.master_loading = true;
            this.RESET_MARKETSTUDY().then(function (res) {
                _this13.CREATE_NEW_MARKETSTUDY({
                    path: 'realestate_marketstudies' + '/' + _this13.realestate.id + '/',
                    parent_path: 'realestates' + '/' + _this13.realestate.id + '/' + 'marketstudies' + '/',
                    file_id: _this13.appraisalfile.id,
                    appraisal_id: appraisal_id,
                    realestate_id: _this13.realestate.id
                    // appraisal_id: this.object_to_array(this.realestate_appraisals).length > 0 ? this.object_to_array(this.realestate_appraisals)[0].id : null,
                }).then(function (res) {
                    _this13.$router.push({
                        name: 'marketstudy-editor',
                        query: { id: res.key, appraisal_id: appraisal_id }
                    });
                });
            });

            // TODO: revisar al crear nou marketstudy.....sembla que dona algun error d'algiun element que es null a appraisal.js
        },

        duplicateAppraisal: function duplicateAppraisal(entity) {
            /*
            this.master_loading = true
            const new_versionnumber = entity.version + 1
            this.RESET_APPRAISALREPORT().then((res) => {
            this.CREATE_NEW_APPRAISALREPORT({
            path: 'appraisalreports' + '/',
            parent_path: 'appraisalfiles' + '/' + this.appraisalfile.id + '/' + 'appraisalreports' + '/',
            file_id: this.appraisalfile.id,
            number: entity.number,
            version: new_versionnumber
            }).then((res) => {
            console.log('duplicateAppraisalReport then res:')
            console.log(res)
            const new_object_id = res.key
            const new_object_version = new_versionnumber
            this.GET_APPRAISALREPORT({ path: 'appraisalreports' + '/' + entity.id }).then((res) => {
            console.log(' *^*^*^*^*^*^*^*^*^*^get appraisal report res: ')
            console.log(res)
            let new_object = res
            new_object.id = new_object_id
            new_object.version = new_object_version
            this.UPDATE_APPRAISALREPORT({
            object: new_object,
            path: 'appraisalreports/',
            parent_path: 'appraisalfiles' + '/' + this.appraisalfile.id + '/' + 'appraisalreports' + '/',
            key: new_object_id
            }).then((res) => {
            this.master_loading = true
            this.FETCH_APPRAISALFILE_APPRAISALREPORTS({path: 'appraisalfiles' + '/' + this.$route.query.id + '/' + 'appraisalreports'})
            .then(() => {
            this.master_loading = false
            })
            })
            })
            })
            })
            */

        },

        duplicateMarketStudy: function duplicateMarketStudy(entity) {},

        editAppraisal: function editAppraisal(entity) {
            var _this14 = this;

            this.SET_APPRAISAL({ path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + entity.id + '/' }).then(function (res) {
                _this14.$router.push({ name: 'appraisal-editor', query: { id: entity.id } });
            });
        },

        editMarketStudy: function editMarketStudy(entity) {
            var _this15 = this;

            this.SET_MARKETSTUDY({ path: 'realestate_marketstudies' + '/' + this.realestate.id + '/' + entity.id + '/' }).then(function (res) {
                _this15.$router.push({
                    name: 'marketstudy-editor',
                    query: { id: entity.id, appraisal_id: entity.appraisal_id }
                });
            });
        },

        editProject: function editProject(entity) {
            var _this16 = this;

            this.SET_PROJECT({ path: 'realestate_projects' + '/' + this.realestate.id + '/' + entity.id + '/' }).then(function (res) {
                _this16.$router.push({ name: 'project-editor', query: { id: entity.id } });
            });
        },

        deleteAppraisal: function deleteAppraisal(entity) {
            var _this17 = this;

            var result = window.confirm(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('You_are_about_to_delete ') + entity.description + '. ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Continue_q'));

            if (result) {

                this.DELETE_APPRAISAL({
                    realestate_id: this.realestate.id,
                    path: 'realestate_appraisals' + '/' + this.realestate.id + '/' + entity.id,
                    key: entity.id,
                    parent_path: 'realestates' + '/' + this.realestate.id + '/' + 'appraisals' + '/' + entity.id
                }).then(function (res) {
                    //
                    _this17.master_loading = true;
                    _this17.FETCH_REALESTATE_APPRAISALS({ path: 'realestate_appraisals' + '/' + _this17.realestate.id + '/' }).then(function () {
                        _this17.master_loading = false;
                    });
                });
            }
        },

        deleteMarketStudy: function deleteMarketStudy(entity) {
            var _this18 = this;

            var result = window.confirm(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('You_are_about_to_delete ') + entity.description + '. ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Continue_q'));

            if (result) {

                this.DELETE_MARKETSTUDY({
                    realestate_id: this.realestate.id,
                    path: 'realestate_marketstudies' + '/' + this.realestate.id + '/' + entity.id,
                    key: entity.id,
                    parent_path: 'realestates' + '/' + this.realestate.id + '/' + 'marketstudies' + '/' + entity.id
                }).then(function (res) {
                    //
                    _this18.master_loading = true;
                    _this18.FETCH_REALESTATE_MARKETSTUDIES({ path: 'realestate_marketstudies' + '/' + _this18.realestate.id + '/' }).then(function () {
                        _this18.master_loading = false;
                    });
                });
            }
        },
        deleteProject: function deleteProject(entity) {
            var _this19 = this;

            var result = window.confirm(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('You_are_about_to_delete ') + entity.description + '. ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Continue_q'));

            if (result) {

                this.DELETE_PROJECT({
                    realestate_id: this.realestate.id,
                    path: 'realestate_projects' + '/' + this.realestate.id + '/' + entity.id,
                    key: entity.id,
                    parent_path: 'realestates' + '/' + this.realestate.id + '/' + 'projects' + '/' + entity.id
                }).then(function (res) {
                    //
                    _this19.master_loading = true;
                    _this19.FETCH_REALESTATE_PROJECTS({ path: 'realestate_projects' + '/' + _this19.realestate.id + '/' }).then(function () {
                        _this19.master_loading = false;
                    });
                });
            }
        }
    }),

    head: {
        title: {
            //inner: Vue.i18n.translate('New_contact')
            inner: 'Edit realestate'
        }
    }

});

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__router_index_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__aggregators_aggregators_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__formatters_formatters_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
























/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'realestates-index',

    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins__["d" /* dateMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["a" /* localStorageMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["e" /* objectsMixin */]],

    data: function data() {
        return {
            master_loading: true,
            loading: true,
            query_comparables_loading: false,
            realestatesOpen: false,
            realestateOpen: false,
            editabletrue: true,
            error: null,
            success_message: null,
            queryComparableTypeValue: null,
            new_real_estate_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_real_estate'),
            add_realestate_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_real_estate'),
            query_realestates_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Query_real_estates'),
            realestates_index_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estates_index'),
            realestates_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Real_estates'),
            filter_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type_here_to_filter_paginated_data'),
            cancel_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cancel'),
            goback_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_back') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            goup_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_up') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            save_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('go_up'),
            lat_lng_error_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Lat_lng_missing_error_text'),
            actions_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Actions'),
            duplicate_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Duplicate'),
            edit_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Edit'),
            delete_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Delete'),
            countryValue: null,
            municipalityValue: null,
            provinceValue: null,
            realestate_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [{
                    id: 'address',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Address'),
                    width: 40,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'appraisalfiles',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Files'),
                    width: 10,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                },
                /*
                {
                id: 'street_number',
                label: Vue.i18n.translate('Street_number'),
                width: null,
                sortable: true,
                groupable: false,
                aggregators: []
                },
                {
                id: 'floor',
                label: Vue.i18n.translate('Floor'),
                width: null,
                sortable: true,
                groupable: false,
                aggregators: []
                },
                {
                id: 'door',
                label: Vue.i18n.translate('door'),
                width: null,
                sortable: true,
                groupable: false,
                aggregators: []
                },
                {
                id: 'postal_code',
                label: Vue.i18n.translate('Postal_code'),
                width: null,
                sortable: true,
                groupable: false,
                aggregators: []
                },
                {
                id: 'municipality',
                label: Vue.i18n.translate('Municipality'),
                width: null,
                sortable: true,
                groupable: false,
                aggregators: []
                },
                */
                {
                    id: 'description',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Description'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'date_modified',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Last_modified'),
                    width: 18,
                    sortable: true,
                    groupable: false,
                    aggregators: [],
                    formatter: function formatter(value) {
                        return __WEBPACK_IMPORTED_MODULE_3_moment___default()(value).format('DD/MM/YYYY HH:mm:ss');
                    }
                }],
                selected: []
            }

        };
    },

    created: function created() {
        var _this = this;

        this.FETCH_REALESTATES({ path: 'realestates' }).then(function () {
            _this.master_loading = false;
        });
    },


    components: {
        Bar: __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default.a,
        Message: __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default.a,
        IconButton: __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default.a,
        Checkbox: __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue___default.a,
        Datatable: __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue___default.a,
        DatatableColumn: __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue___default.a,
        Paginator: __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue___default.a,
        SideNavBar: __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default.a
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['theme', 'currentLocale', 'realestates'])),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['CREATE_NEW_REALESTATE', 'FETCH_REALESTATES', 'RESET_REALESTATE', 'SET_REALESTATE', 'SET_APPRAISALFILE']), {
        onCreateNewRealEstate: function onCreateNewRealEstate() {
            var _this2 = this;

            // console.log('hey')
            // console.log('realestate: ')
            // console.log(this.realestate)
            this.RESET_REALESTATE().then(function (res) {
                _this2.CREATE_NEW_REALESTATE({
                    report_id: null,
                    file_id: null,
                    file_number: null,
                    report_number: null,
                    report_version: null,
                    path: 'realestates' + '/',
                    parent_path: null
                }).then(function (res) {
                    _this2.$router.push({ name: 'realestate-editor', query: { id: res.key } });
                });
            });
        },
        editRealEstate: function editRealEstate(entity) {
            var _this3 = this;

            // console.log('edit realestate...')
            this.SET_REALESTATE({ path: 'realestates' + '/' + entity.id + '/' }).then(function (res) {
                _this3.$router.push({ name: 'realestate-editor', query: { id: entity.id } });
            });
        },
        goToFile: function goToFile(key) {
            var _this4 = this;

            this.SET_APPRAISALFILE({ path: 'appraisalfiles' + '/' + key }).then(function (res) {
                _this4.$router.push({ name: 'appraisalfile-editor', query: { id: key } });
            });
        }
    }),
    head: {
        title: {
            //inner: Vue.i18n.translate('New_contact')
            inner: 'Real Estates'
        }

    }
});

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__router_index_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__aggregators_aggregators_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__formatters_formatters_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
























/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'registryannex-editor',

    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins__["d" /* dateMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["a" /* localStorageMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["e" /* objectsMixin */]],

    data: function data() {
        return {
            loading: true,
            master_loading: true,
            filesOpen: true,
            fileOpen: true,
            reportOpen: true,
            error: null,
            success_message: null,
            metadata_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Metadata'),
            data_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Data'),
            report_title_error_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Report_title_missing_error_text'),
            new_real_estate_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_real_estate'),
            cancel_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cancel'),
            goup_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_up') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            pdf_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Print_report_in_PDF'),
            save_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save'),
            save_and_go_up_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('go_up'),
            page_dirty_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('The_page_contains_unsaved_changes'),
            actions_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Actions'),
            filter_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type_here_to_filter_paginated_data'),
            duplicate_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Duplicate'),
            edit_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Edit'),
            delete_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Delete'),
            discard_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Discard'),
            openlink_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Open_link_in_new_tab')
        };
    },

    created: function created() {
        this.master_loading = false;
    },


    components: {
        Bar: __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default.a,
        Message: __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default.a,
        IconButton: __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default.a,
        SideNavBar: __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default.a,
        Checkbox: __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue___default.a,
        Datatable: __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue___default.a,
        DatatableColumn: __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue___default.a,
        Paginator: __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue___default.a
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['theme', 'tags_display', 'currentLocale', 'registryannex'])),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['UPDATE_REGISTRYANNEX', 'SET_REGISTRYANNEX_NAME_CA', 'SET_REGISTRYANNEX_NAME_EN', 'SET_REGISTRYANNEX_NAME_ES']), {
        set_registryannex_name_ca: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_REGISTRYANNEX_NAME_CA(e.target.value);
        }, 1000),
        set_registryannex_name_en: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_REGISTRYANNEX_NAME_EN(e.target.value);
        }, 1000),
        set_registryannex_name_es: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_REGISTRYANNEX_NAME_ES(e.target.value);
        }, 1000),
        set_registryannex: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_REGISTRYANNEX_NAME_CA(e.name_ca);
            this.SET_REGISTRYANNEX_NAME_EN(e.name_en);
            this.SET_REGISTRYANNEX_NAME_ES(e.name_es);
        }, 0),
        onSaveCurrentRegistryAnnex: function onSaveCurrentRegistryAnnex(data) {
            var _this = this;

            this.UPDATE_REGISTRYANNEX({
                object: this.registryannex,
                path: this.registryannex.path,
                parent_path: this.registryannex.parent_path,
                key: this.registryannex.id
            }).then(function (res) {
                // router.go(-1)
                if (data.go_up) {
                    _this.onGoUp();
                }
            });
        },
        onGoBack: function onGoBack() {
            __WEBPACK_IMPORTED_MODULE_11__router_index_js__["a" /* default */].go(-1);
        },
        onGoUp: function onGoUp() {
            __WEBPACK_IMPORTED_MODULE_11__router_index_js__["a" /* default */].go(-1);
        }
    }),
    head: {
        title: {
            inner: 'Edit registryannex'
        }
    }

});

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_SideNavBar_Index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_SideNavBar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_SideNavBar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_SuccessMessage_vue__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_SuccessMessage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_SuccessMessage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__options_honorific_titles__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__aggregators_aggregators_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__formatters_formatters_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue__);
var _name$mixins$data$cre;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
























/* harmony default export */ __webpack_exports__["default"] = (_name$mixins$data$cre = {
    name: 'supervisor-editor',

    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins__["d" /* dateMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["a" /* localStorageMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["e" /* objectsMixin */]],

    data: function data() {
        return {
            master_loading: false,
            filesOpen: true,
            fileOpen: true,
            reportOpen: true,
            filter_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type_here_to_filter_paginated_data'),
            new_address_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_address'),
            new_email_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_email'),
            new_telephone_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_telephone_number'),
            cancel_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cancel'),
            goback_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_back') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            save_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('go_back'),
            cad_ref_error_text_01: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cadastral_Reference_less_20_positions_error_text'),
            page_dirty_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('The_page_contains_unsaved_changes'),
            actions_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Actions'),
            value: null,
            ms_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Pick_an_option'),
            error: null,
            success_message: null,
            honorificTitleOptions: __WEBPACK_IMPORTED_MODULE_12__options_honorific_titles__["a" /* default */]
        };
    },

    created: function created() {},


    components: {
        Bar: __WEBPACK_IMPORTED_MODULE_7__components_Bar_Index_vue___default.a,
        Message: __WEBPACK_IMPORTED_MODULE_10__components_Message_vue___default.a,
        SuccessMessage: __WEBPACK_IMPORTED_MODULE_11__components_SuccessMessage_vue___default.a,
        IconButton: __WEBPACK_IMPORTED_MODULE_8__components_IconButton_Index_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default.a,
        Checkbox: __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue___default.a,
        Datatable: __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue___default.a,
        DatatableColumn: __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue___default.a,
        Paginator: __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue___default.a,
        SideNavBar: __WEBPACK_IMPORTED_MODULE_9__components_SideNavBar_Index_vue___default.a
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['theme', 'currentLocale', 'address', 'emailaddress', 'telephonenumber', 'supervisor', 'supervisor_addresses', 'supervisor_emailaddresses', 'supervisor_telephonenumbers']))

}, _defineProperty(_name$mixins$data$cre, 'created', function created() {

    this.master_loading = false;
}), _defineProperty(_name$mixins$data$cre, 'methods', _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['SET_SUPERVISOR_ADDRESSES', 'SET_SUPERVISOR_NAME', 'SET_SUPERVISOR_SURNAMES', 'SET_SUPERVISOR_TIN', 'SET_SUPERVISOR_PROF_ASSOC_REG_NUMBER', 'SET_SUPERVISOR_TITLE', 'SET_SUPERVISOR_COMPLETE_NAME', 'UPDATE_SUPERVISOR']), {
    set_supervisor_name: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
        var name = e.target.value;
        var surnames = '';
        if (this.supervisor.surnames) {
            surnames = this.supervisor.surnames;
        }
        var complete_name = surnames + ', ' + name;
        this.SET_SUPERVISOR_NAME(name);
        this.SET_SUPERVISOR_COMPLETE_NAME(complete_name);
    }, 1000),
    set_supervisor_surnames: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
        var surnames = e.target.value;
        var name = '';
        if (this.supervisor.name) {
            name = this.supervisor.name;
        }
        var complete_name = surnames + ', ' + name;
        this.SET_SUPERVISOR_SURNAMES(surnames);
        this.SET_SUPERVISOR_COMPLETE_NAME(complete_name);
    }, 1000),
    set_supervisor_tin: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
        this.SET_SUPERVISOR_TIN(e.target.value);
    }, 1000),
    set_supervisor_prof_assoc_reg_number: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
        this.SET_SUPERVISOR_PROF_ASSOC_REG_NUMBER(e.target.value);
    }, 1000),
    set_supervisor_title: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
        this.SET_SUPERVISOR_TITLE(e);
    }, 1000),
    onGoBack: function onGoBack() {
        // console.log('yeah back')
        __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].go(-1);
    },
    onSaveCurrentSupervisor: function onSaveCurrentSupervisor(data) {
        console.log('supervisor.id: ');
        console.log(this.supervisor.id);
        this.UPDATE_SUPERVISOR({
            object: this.supervisor,
            path: 'supervisors' + '/' + this.supervisor.id
        }).then(function (res) {
            if (data.goback) {
                __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].go(-1);
            }
        });
    }
})), _defineProperty(_name$mixins$data$cre, 'head', {
    title: {
        //inner: Vue.i18n.translate('New_supervisor')
        inner: 'Edit supervisor'
    }
}), _name$mixins$data$cre);

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_SideNavBar_Index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_SideNavBar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_SideNavBar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Datatable_datatable_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Datatable_datatable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Datatable_datatable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Datatable_datatable_column_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Datatable_datatable_column_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Datatable_datatable_column_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__aggregators_aggregators_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__formatters_formatters_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Toggles_checkbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Toggles_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Toggles_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Paginator_paginator_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Paginator_paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_Paginator_paginator_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














// import DatatableCell from '../../../components/Datatable/datatable-cell.js'





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'supervisors-index',

    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins__["a" /* localStorageMixin */]],

    data: function data() {
        return {
            master_loading: true,
            filesOpen: false,
            fileOpen: false,
            reportOpen: false,
            error: null,
            filter_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type_here_to_filter_paginated_data'),
            new_supervisor_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_supervisor'),
            customers: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,

                currency: 'USD',
                dateFormat: 'D MMMM YYYY',

                columns: [{
                    id: 'name',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Name'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }, {
                    id: 'surnames',
                    label: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Surnames'),
                    width: null,
                    sortable: true,
                    groupable: false,
                    aggregators: []
                }],

                rows: [{
                    id: '0584e8d2-984c-4ce0-a20f-8b9e21cd2c00',
                    name: 'Nancy Fuller',
                    purchasor_email: 'nfuller0@about.me',
                    purchase_date: '2002-01-02T04:45:48Z',
                    purchase_amount: 1166.14
                }, {
                    id: 'f4769183-38af-4c22-8383-6dea302466fd',
                    name: 'Melissa Meyer',
                    purchasor_email: 'mmeyer1@angelfire.com',
                    purchase_date: '2010-05-15T08:13:59Z',
                    purchase_amount: 6123.50
                }, {
                    id: 'e171c9fb-2438-4f23-8d0d-011b2d8e95bc',
                    name: 'Larry Rose',
                    purchasor_email: 'lrose2@cdbaby.com',
                    purchase_date: '2014-11-23T09:18:18Z',
                    purchase_amount: 8288.27
                }, {
                    id: '3cad078d-083b-416e-9dd4-2f1470c3458d',
                    name: 'Jack Simpson',
                    purchasor_email: 'jsimpson3@mayoclinic.com',
                    purchase_date: '2002-01-02T04:45:48Z',
                    purchase_amount: 1215.03
                }, {
                    id: 'ef7ff12c-90e5-4bfb-8fdd-9f20e4206afa',
                    name: 'Ernest Watson',
                    purchasor_email: 'ewatson4@nytimes.com',
                    purchase_date: '2002-01-02T04:45:48Z',
                    purchase_amount: 9455.16
                }, {
                    id: 'b243be08-6b9c-4ebd-bb8b-b59256ad4956',
                    name: 'Adam Castillo',
                    purchasor_email: 'acastillo5@dailymotion.com',
                    purchase_date: '2014-08-22T08:14:28Z',
                    purchase_amount: 9988.45
                }, {
                    id: 'a491adf5-8129-4f93-9442-98522fbd1e90',
                    name: 'Wayne Wilson',
                    purchasor_email: 'wwilson6@indiegogo.com',
                    purchase_date: '2012-03-07T22:16:08Z',
                    purchase_amount: 4563.87
                }, {
                    id: '497a6cca-5c9c-4b93-af8e-63c93de3eacf',
                    name: 'Roy Coleman',
                    purchasor_email: 'rcoleman7@independent.co.uk',
                    purchase_date: '2010-09-14T05:05:17Z',
                    purchase_amount: 4563.87
                }, {
                    id: 'ea34a698-fb86-44a5-b80e-57087d48737c',
                    name: 'Betty Diaz',
                    purchasor_email: 'bdiaz8@dropbox.com',
                    purchase_date: '2012-03-07T22:16:08Z',
                    purchase_amount: 7527.62
                }, {
                    id: 'c48e5e68-cae5-4a2e-96b2-8509fca19ddb',
                    name: 'Sharon Gardner',
                    purchasor_email: 'sgardner9@seesaa.net',
                    purchase_date: '2004-10-14T14:59:00Z',
                    purchase_amount: 1166.14
                }],

                selected: []
            }
        };
    },

    created: function created() {
        var _this = this;

        this.FETCH_SUPERVISORS().then(function () {
            _this.master_loading = false;
        });
    },


    components: {
        Bar: __WEBPACK_IMPORTED_MODULE_7__components_Bar_Index_vue___default.a,
        Checkbox: __WEBPACK_IMPORTED_MODULE_14__components_Toggles_checkbox_vue___default.a,
        Datatable: __WEBPACK_IMPORTED_MODULE_10__components_Datatable_datatable_vue___default.a,
        DatatableColumn: __WEBPACK_IMPORTED_MODULE_11__components_Datatable_datatable_column_vue___default.a,
        IconButton: __WEBPACK_IMPORTED_MODULE_8__components_IconButton_Index_vue___default.a,
        Paginator: __WEBPACK_IMPORTED_MODULE_15__components_Paginator_paginator_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default.a,
        SideNavBar: __WEBPACK_IMPORTED_MODULE_9__components_SideNavBar_Index_vue___default.a
    },
    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['supervisors', 'theme']), {
        selectAll: {
            get: function get() {
                return this.customers.selected.length === this.customers.rows.length;
            },
            set: function set(value) {
                this.customers.selected = value ? this.customers.rows : [];
            }
        }
    }),
    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['CREATE_NEW_SUPERVISOR', 'DELETE_SUPERVISOR', 'EDIT_SUPERVISOR', 'FETCH_SUPERVISORS', 'SET_SUPERVISOR']), {
        onCreateNewSupervisor: function onCreateNewSupervisor() {
            var _this2 = this;

            this.CREATE_NEW_SUPERVISOR({ path: 'supervisors' }).then(function (res) {
                _this2.$router.push({ name: 'supervisor-editor' });
            });
        },
        supervisors_to_array: function supervisors_to_array(object) {
            return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(object);
        },
        editSupervisor: function editSupervisor(supervisor) {
            var _this3 = this;

            console.log('edit...');
            this.SET_SUPERVISOR({ path: 'supervisors' + '/' + supervisor.id }).then(function (res) {
                _this3.$router.push({ name: 'supervisor-editor', query: { id: supervisor.id } });
            });
        },
        deleteSupervisor: function deleteSupervisor(entity) {
            var _this4 = this;

            var result = window.confirm(__WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('You_are_about_to_delete ') + entity.name + '. ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Continue_q'));
            if (result) {
                this.DELETE_SUPERVISOR({
                    path: 'supervisors' + '/' + entity.id,
                    key: entity.id
                }).then(function (res) {
                    //
                    _this4.master_loading = true;
                    _this4.FETCH_SUPERVISORS().then(function () {
                        _this4.master_loading = false;
                    });
                });
            }
        }
    }),

    head: {
        title: {
            //inner: Vue.i18n.translate('Supervisors_Index')
            inner: 'Supervisors Index'
        }
    }

});

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ContactsSearch_Index_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ContactsSearch_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ContactsSearch_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router_index_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Message_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'telephonenumber-editor',

    mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins__["d" /* dateMixin */], __WEBPACK_IMPORTED_MODULE_3__mixins__["a" /* localStorageMixin */], __WEBPACK_IMPORTED_MODULE_3__mixins__["e" /* objectsMixin */]],

    data: function data() {
        return {
            loading: true,
            error: null,
            success_message: null,
            cancel_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cancel'),
            goback_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_back') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            save_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('go_back'),
            page_dirty_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('The_page_contains_unsaved_changes')
        };
    },

    created: function created() {
        this.loading = false;
    },


    components: {
        Bar: __WEBPACK_IMPORTED_MODULE_7__components_Bar_Index_vue___default.a,
        Message: __WEBPACK_IMPORTED_MODULE_10__components_Message_vue___default.a,
        IconButton: __WEBPACK_IMPORTED_MODULE_8__components_IconButton_Index_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_4__components_Spinner_vue___default.a
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['theme', 'currentLocale', 'telephonenumber'])),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['SET_TELEPHONENUMBER_DESCRIPTION', 'SET_TELEPHONENUMBER_NUMBER', 'SET_TELEPHONENUMBER_PREFIX', 'UPDATE_TELEPHONENUMBER']), {

        set_telephonenumber_description: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_TELEPHONENUMBER_DESCRIPTION(e.target.value);
        }, 1000),
        set_telephonenumber_number: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_TELEPHONENUMBER_NUMBER(e.target.value);
        }, 1000),
        set_telephonenumber_prefix: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_TELEPHONENUMBER_PREFIX(e.target.value);
        }, 1000),
        onSaveCurrentTelephoneNumber: function onSaveCurrentTelephoneNumber() {
            this.UPDATE_TELEPHONENUMBER({
                object: this.telephonenumber,
                path: this.telephonenumber.path + '/' + this.telephonenumber.id
            }).then(function (res) {
                __WEBPACK_IMPORTED_MODULE_9__router_index_js__["a" /* default */].go(-1);
            });
        },
        onGoBack: function onGoBack() {
            // console.log('yeah back')
            __WEBPACK_IMPORTED_MODULE_9__router_index_js__["a" /* default */].go(-1);
        }
    }),
    head: {
        title: {
            inner: 'Edit telephone number'
        }
    }

});

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__router_index_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__aggregators_aggregators_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__formatters_formatters_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
























/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'urbanannex-editor',

    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins__["d" /* dateMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["a" /* localStorageMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["e" /* objectsMixin */]],

    data: function data() {
        return {
            loading: true,
            master_loading: true,
            filesOpen: true,
            fileOpen: true,
            reportOpen: true,
            error: null,
            success_message: null,
            metadata_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Metadata'),
            data_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Data'),
            report_title_error_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Report_title_missing_error_text'),
            new_real_estate_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_real_estate'),
            cancel_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cancel'),
            goup_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_up') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            pdf_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Print_report_in_PDF'),
            save_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save'),
            save_and_go_up_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('go_up'),
            page_dirty_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('The_page_contains_unsaved_changes'),
            actions_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Actions'),
            filter_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type_here_to_filter_paginated_data'),
            duplicate_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Duplicate'),
            edit_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Edit'),
            delete_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Delete'),
            discard_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Discard'),
            openlink_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Open_link_in_new_tab')
        };
    },

    created: function created() {
        this.master_loading = false;
    },


    components: {
        Bar: __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default.a,
        Message: __WEBPACK_IMPORTED_MODULE_12__components_Message_vue___default.a,
        IconButton: __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default.a,
        SideNavBar: __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default.a,
        Checkbox: __WEBPACK_IMPORTED_MODULE_17__components_Toggles_checkbox_vue___default.a,
        Datatable: __WEBPACK_IMPORTED_MODULE_13__components_Datatable_datatable_vue___default.a,
        DatatableColumn: __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_column_vue___default.a,
        Paginator: __WEBPACK_IMPORTED_MODULE_18__components_Paginator_paginator_vue___default.a
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['theme', 'tags_display', 'currentLocale', 'urbanannex'])),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['UPDATE_URBANANNEX', 'SET_URBANANNEX_NAME_CA', 'SET_URBANANNEX_NAME_EN', 'SET_URBANANNEX_NAME_ES']), {
        set_urbanannex_name_ca: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_URBANANNEX_NAME_CA(e.target.value);
        }, 1000),
        set_urbanannex_name_en: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_URBANANNEX_NAME_EN(e.target.value);
        }, 1000),
        set_urbanannex_name_es: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_URBANANNEX_NAME_ES(e.target.value);
        }, 1000),
        set_urbanannex: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_URBANANNEX_NAME_CA(e.name_ca);
            this.SET_URBANANNEX_NAME_EN(e.name_en);
            this.SET_URBANANNEX_NAME_ES(e.name_es);
        }, 0),
        onSaveCurrentUrbanAnnex: function onSaveCurrentUrbanAnnex(data) {
            var _this = this;

            this.UPDATE_URBANANNEX({
                object: this.urbanannex,
                path: this.urbanannex.path,
                parent_path: this.urbanannex.parent_path,
                key: this.urbanannex.id
            }).then(function (res) {
                // router.go(-1)
                if (data.go_up) {
                    _this.onGoUp();
                }
            });
        },
        onGoBack: function onGoBack() {
            __WEBPACK_IMPORTED_MODULE_11__router_index_js__["a" /* default */].go(-1);
        },
        onGoUp: function onGoUp() {
            __WEBPACK_IMPORTED_MODULE_11__router_index_js__["a" /* default */].go(-1);
        }
    }),
    head: {
        title: {
            inner: 'Edit urbanannex'
        }
    }

});

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ContactsSearch_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Editor_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__options_default_warnings__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__router_index_js__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Message_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Datatable_datatable_column_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Datatable_datatable_column_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_Datatable_datatable_column_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__aggregators_aggregators_js__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__formatters_formatters_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Toggles_checkbox_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Toggles_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Toggles_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Paginator_paginator_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Paginator_paginator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_Paginator_paginator_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


























/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'warning-editor',

    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins__["d" /* dateMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["a" /* localStorageMixin */], __WEBPACK_IMPORTED_MODULE_4__mixins__["e" /* objectsMixin */]],

    data: function data() {
        return {
            loading: true,
            master_loading: true,
            filesOpen: true,
            fileOpen: true,
            reportOpen: true,
            error: null,
            success_message: null,
            metadata_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Metadata'),
            data_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Data'),
            report_title_error_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Report_title_missing_error_text'),
            new_real_estate_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Add_real_estate'),
            cancel_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Cancel'),
            goup_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Go_up') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('without_saving'),
            pdf_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Print_report_in_PDF'),
            save_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save'),
            save_and_go_up_button_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Save') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('and') + ' ' + __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('go_up'),
            page_dirty_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('The_page_contains_unsaved_changes'),
            actions_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Actions'),
            filter_placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Type_here_to_filter_paginated_data'),
            duplicate_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Duplicate'),
            edit_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Edit'),
            delete_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Delete'),
            discard_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Discard'),
            openlink_text: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Open_link_in_new_tab'),
            warningValue: null,
            default_warningOptions: __WEBPACK_IMPORTED_MODULE_11__options_default_warnings__["a" /* default */]
        };
    },

    created: function created() {
        this.master_loading = false;
    },


    components: {
        Bar: __WEBPACK_IMPORTED_MODULE_8__components_Bar_Index_vue___default.a,
        Message: __WEBPACK_IMPORTED_MODULE_13__components_Message_vue___default.a,
        IconButton: __WEBPACK_IMPORTED_MODULE_9__components_IconButton_Index_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_5__components_Spinner_vue___default.a,
        SideNavBar: __WEBPACK_IMPORTED_MODULE_10__components_SideNavBar_Index_vue___default.a,
        Checkbox: __WEBPACK_IMPORTED_MODULE_18__components_Toggles_checkbox_vue___default.a,
        Datatable: __WEBPACK_IMPORTED_MODULE_14__components_Datatable_datatable_vue___default.a,
        DatatableColumn: __WEBPACK_IMPORTED_MODULE_15__components_Datatable_datatable_column_vue___default.a,
        Paginator: __WEBPACK_IMPORTED_MODULE_19__components_Paginator_paginator_vue___default.a
    },

    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['theme', 'tags_display', 'currentLocale', 'warning'])),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['UPDATE_WARNING', 'SET_WARNING_NAME_CA', 'SET_WARNING_NAME_EN', 'SET_WARNING_NAME_ES']), {
        set_warning_name_ca: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_WARNING_NAME_CA(e.target.value);
        }, 1000),
        set_warning_name_en: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_WARNING_NAME_EN(e.target.value);
        }, 1000),
        set_warning_name_es: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_WARNING_NAME_ES(e.target.value);
        }, 1000),
        set_warning: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function (e) {
            this.SET_WARNING_NAME_CA(e.name_ca);
            this.SET_WARNING_NAME_EN(e.name_en);
            this.SET_WARNING_NAME_ES(e.name_es);
        }, 0),
        onSaveCurrentWarning: function onSaveCurrentWarning(data) {
            var _this = this;

            this.UPDATE_WARNING({
                object: this.warning,
                path: this.warning.path,
                parent_path: this.warning.parent_path,
                key: this.warning.id
            }).then(function (res) {
                // router.go(-1)
                if (data.go_up) {
                    _this.onGoUp();
                }
            });
        },
        onGoBack: function onGoBack() {
            __WEBPACK_IMPORTED_MODULE_12__router_index_js__["a" /* default */].go(-1);
        },
        onGoUp: function onGoUp() {
            __WEBPACK_IMPORTED_MODULE_12__router_index_js__["a" /* default */].go(-1);
        }
    }),
    head: {
        title: {
            inner: 'Edit warning'
        }
    }

});

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Field_vue__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Field_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Field_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Message_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'login',

    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins__["a" /* localStorageMixin */]],

    components: {
        Field: __WEBPACK_IMPORTED_MODULE_2__components_Field_vue___default.a,
        Message: __WEBPACK_IMPORTED_MODULE_3__components_Message_vue___default.a
    },

    data: function data() {
        return {
            fields: {
                email: {
                    name: 'Email Address',
                    value: '',
                    type: 'text',
                    placeholder: 'email@email.com',
                    autofocus: true
                },
                password: {
                    name: 'Password',
                    value: '',
                    type: 'password',
                    placeholder: 'Super, secret',
                    autofocus: false
                }
            },
            error: null
        };
    },

    created: function created() {
        if (this.$route.query.email) {
            this.fields.email.value = this.$route.query.email;
        }
    },


    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['user'])),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['LOG_IN_USER']), {
        onLogIn: function onLogIn() {
            var _this = this;

            if (this.fields.email.value.length == 0) {
                this.error = 'Please enter an email realestate.';
                return;
            }

            if (this.fields.password.value.length == 0) {
                this.error = 'Please enter a password.';
                return;
            }

            var data = {
                email: this.fields.email.value,
                password: this.fields.password.value
            };
            this.LOG_IN_USER(data).then(function () {
                _this.ls_pushUser(_this.user);
                _this.$router.push({ name: 'app' });
            }).catch(function (error) {
                _this.error = error.message;
            });
        },
        closeMessage: function closeMessage() {
            this.error = null;
        }
    }),

    head: {
        title: {
            inner: 'Log In'
        }
    }

});

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Field_vue__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Field_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Field_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Message_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Message_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Message_vue__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'signup',

    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins__["a" /* localStorageMixin */]],

    components: {
        Field: __WEBPACK_IMPORTED_MODULE_3__components_Field_vue___default.a,
        Message: __WEBPACK_IMPORTED_MODULE_4__components_Message_vue___default.a
    },

    data: function data() {
        return {
            fields: {
                name: {
                    name: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Name') + ' *',
                    value: '',
                    type: 'text',
                    placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Name'),
                    autofocus: true
                },
                surnames: {
                    name: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Surnames') + ' *',
                    value: '',
                    type: 'text',
                    placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Surnames'),
                    autofocus: false
                },
                company: {
                    name: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Company_or_business_name'),
                    value: '',
                    type: 'text',
                    placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Company_or_business_name'),
                    autofocus: false
                },
                email: {
                    name: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Email_Address') + ' *',
                    value: '',
                    type: 'text',
                    placeholder: 'email@email.com',
                    autofocus: true
                },
                password: {
                    name: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Password'),
                    value: '',
                    type: 'password',
                    placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Password') + ' *',
                    autofocus: false
                },
                confirm: {
                    name: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Confirm_Password') + ' *',
                    value: '',
                    type: 'password',
                    placeholder: __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Password'),
                    autofocus: false
                }
            },
            error: null
        };
    },

    created: function created() {
        if (this.$route.query.email) {
            this.fields.email.value = this.$route.query.email;
        }
    },


    computed: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['user'])),

    methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapActions */])(['SIGN_UP_USER', 'INIT_NOTES', 'UPDATE_USER_INITIAL_DATA']), {
        onSignUp: function onSignUp() {
            var _this = this;

            if (this.fields.password.value != this.fields.confirm.value) {
                this.error = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('The_passwords_do_not_match') + '.';
                return;
            }

            if (this.fields.email.value === null & this.fields.password.value === null) {
                this.error = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.i18n.translate('Please_enter_an_email_address') + '.';
                return;
            }

            var data = {
                name: this.fields.name.value,
                surnames: this.fields.surnames.value,
                company: this.fields.company.value,
                email: this.fields.email.value,
                password: this.fields.password.value
            };

            var user_initial_data = {
                name: this.fields.name.value,
                surnames: this.fields.surnames.value,
                company: this.fields.company.value
            };

            this.SIGN_UP_USER(data).then(function () {
                _this.ls_pushUser(_this.user);
                _this.UPDATE_USER_INITIAL_DATA(user_initial_data);
                _this.INIT_NOTES().then(function () {
                    return _this.$router.push({ name: 'app' });
                }).catch(function (error) {
                    return _this.error = error.message;
                });
            }).catch(function (error) {
                _this.error = error.message;
            });
        },
        closeMessage: function closeMessage() {
            this.error = null;
        }
    }),

    head: {
        title: {
            inner: 'Sign Up'
        }
    }

});

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(9);

var _lodash2 = _interopRequireDefault(_lodash);

var _propsBinder = __webpack_require__(52);

var _propsBinder2 = _interopRequireDefault(_propsBinder);

var _simulateArrowDown = __webpack_require__(471);

var _simulateArrowDown2 = _interopRequireDefault(_simulateArrowDown);

var _getPropsValuesMixin = __webpack_require__(64);

var _getPropsValuesMixin2 = _interopRequireDefault(_getPropsValuesMixin);

var _manager = __webpack_require__(116);

var _assert = __webpack_require__(163);

var _assert2 = _interopRequireDefault(_assert);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var props = {
  bounds: {
    type: Object
  },
  componentRestrictions: {
    type: Object
  },
  types: {
    type: Array,
    default: function _default() {
      return [];
    }
  },
  placeholder: {
    required: false,
    type: String
  },
  selectFirstOnEnter: {
    require: false,
    type: Boolean,
    default: false
  },
  value: {
    type: String,
    default: ''
  },
  options: {
    type: Object
  }
};

exports.default = {
  mixins: [_getPropsValuesMixin2.default],

  mounted: function mounted() {
    var _this = this;

    _manager.loaded.then(function () {
      var options = _lodash2.default.clone(_this.getPropsValues());
      if (_this.selectFirstOnEnter) {
        (0, _simulateArrowDown2.default)(_this.$refs.input);
      }

      (0, _assert2.default)(typeof google.maps.places.Autocomplete === 'function', 'google.maps.places.Autocomplete is undefined. Did you add \'places\' to libraries when loading Google Maps?');

      /* eslint-disable no-unused-vars */
      var finalOptions = _lodash2.default.pickBy(_lodash2.default.defaults({}, options.options, _lodash2.default.omit(options, ['options', 'selectFirstOnEnter', 'value', 'place', 'placeholder'])), function (v, k) {
        return v !== undefined;
      });

      // Component restrictions is rather particular. Undefined not allowed
      _this.$watch('componentRestrictions', function (v) {
        if (v !== undefined) {
          _this.$autocomplete.setComponentRestrictions(v);
        }
      });

      _this.$autocomplete = new google.maps.places.Autocomplete(_this.$refs.input, finalOptions);
      (0, _propsBinder2.default)(_this, _this.$autocomplete, _lodash2.default.omit(props, ['placeholder', 'place', 'selectFirstOnEnter', 'value', 'componentRestrictions']));

      _this.$autocomplete.addListener('place_changed', function () {
        _this.$emit('place_changed', _this.$autocomplete.getPlace());
      });
    });
  },

  props: props
};

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(9);

var _lodash2 = _interopRequireDefault(_lodash);

var _propsBinder = __webpack_require__(52);

var _propsBinder2 = _interopRequireDefault(_propsBinder);

var _eventsBinder = __webpack_require__(69);

var _eventsBinder2 = _interopRequireDefault(_eventsBinder);

var _mapElementMixin = __webpack_require__(76);

var _mapElementMixin2 = _interopRequireDefault(_mapElementMixin);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var props = {
  options: {
    type: Object,
    required: false,
    default: function _default() {
      return {};
    }
  },
  content: {},
  opened: {
    type: Boolean,
    default: true
  },
  position: {
    type: Object,
    twoWay: true
  },
  zIndex: {
    type: Number,
    twoWay: true
  }
};

var events = ['domready', 'closeclick', 'content_changed'];

exports.default = {
  mixins: [_mapElementMixin2.default],
  replace: false,
  props: props,

  mounted: function mounted() {
    var el = this.$refs.flyaway;
    el.parentNode.removeChild(el);
  },
  deferredReady: function deferredReady() {
    this.$markerObject = null;
    this.$markerComponent = this.$findAncestor(function (ans) {
      return ans.$markerObject;
    });

    if (this.$markerComponent) {
      this.$markerObject = this.$markerComponent.$markerObject;
    }
    this.createInfoWindow();
  },
  destroyed: function destroyed() {
    if (this.disconnect) {
      this.disconnect();
    }
    if (this.$infoWindow) {
      this.$infoWindow.setMap(null);
    }
  },

  methods: {
    openInfoWindow: function openInfoWindow() {
      if (this.opened) {
        if (this.$markerObject !== null) {
          this.$infoWindow.open(this.$map, this.$markerObject);
        } else {
          this.$infoWindow.open(this.$map);
        }
      } else {
        this.$infoWindow.close();
      }
    },
    createInfoWindow: function createInfoWindow() {
      var _this = this;

      // setting options
      var options = _lodash2.default.clone(this.options);
      options.content = this.$refs.flyaway;

      // only set the position if the info window is not bound to a marker
      if (this.$markerComponent === null) {
        options.position = this.position;
      }

      this.$infoWindow = new google.maps.InfoWindow(options);

      // Binding
      (0, _propsBinder2.default)(this, this.$infoWindow, _lodash2.default.omit(props, ['opened']));
      (0, _eventsBinder2.default)(this, this.$infoWindow, events);

      this.openInfoWindow();
      this.$watch('opened', function () {
        _this.openInfoWindow();
      });
    }
  }
};

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(157);

var _promise2 = _interopRequireDefault(_promise);

var _lodash = __webpack_require__(9);

var _lodash2 = _interopRequireDefault(_lodash);

var _manager = __webpack_require__(116);

var _deferredReady = __webpack_require__(156);

var _eventsBinder = __webpack_require__(69);

var _eventsBinder2 = _interopRequireDefault(_eventsBinder);

var _propsBinder = __webpack_require__(52);

var _propsBinder2 = _interopRequireDefault(_propsBinder);

var _getPropsValuesMixin = __webpack_require__(64);

var _getPropsValuesMixin2 = _interopRequireDefault(_getPropsValuesMixin);

var _mountableMixin = __webpack_require__(222);

var _mountableMixin2 = _interopRequireDefault(_mountableMixin);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var props = {
  center: {
    required: true,
    twoWay: true,
    type: Object
  },
  zoom: {
    required: false,
    twoWay: true,
    type: Number
  },
  heading: {
    type: Number,
    twoWay: true
  },
  mapTypeId: {
    twoWay: true,
    type: String
  },
  bounds: {
    twoWay: true,
    type: Object
  },
  tilt: {
    twoWay: true,
    type: Number
  },
  options: {
    type: Object,
    default: function _default() {
      return {};
    }
  }
};

var events = ['click', 'dblclick', 'drag', 'dragend', 'dragstart', 'idle', 'mousemove', 'mouseout', 'mouseover', 'resize', 'rightclick', 'tilesloaded'];

// Plain Google Maps methods exposed here for convenience
var linkedMethods = (0, _lodash2.default)(['panBy', 'panTo', 'panToBounds', 'fitBounds']).map(function (methodName) {
  return [methodName, function () {
    if (this.$mapObject) this.$mapObject[methodName].apply(this.$mapObject, arguments);
  }];
}).fromPairs().value();

// Other convenience methods exposed by Vue Google Maps
var customMethods = {
  resize: function resize() {
    if (this.$mapObject) {
      google.maps.event.trigger(this.$mapObject, 'resize');
    }
  },
  resizePreserveCenter: function resizePreserveCenter() {
    if (!this.$mapObject) return;

    var oldCenter = this.$mapObject.getCenter();
    google.maps.event.trigger(this.$mapObject, 'resize');
    this.$mapObject.setCenter(oldCenter);
  },

  /// Override mountableMixin::_resizeCallback
  /// because resizePreserveCenter is usually the
  /// expected behaviour
  _resizeCallback: function _resizeCallback() {
    this.resizePreserveCenter();
  }
};

// Methods is a combination of customMethods and linkedMethods
var methods = _lodash2.default.assign({}, customMethods, linkedMethods);

exports.default = {
  mixins: [_getPropsValuesMixin2.default, _deferredReady.DeferredReadyMixin, _mountableMixin2.default],
  props: props,
  replace: false, // necessary for css styles

  created: function created() {
    var _this = this;

    this.$mapCreated = new _promise2.default(function (resolve, reject) {
      _this.$mapCreatedDeferred = { resolve: resolve, reject: reject };
    });

    var updateCenter = function updateCenter() {
      if (!_this.$mapObject) return;

      _this.$mapObject.setCenter({
        lat: _this.finalLat,
        lng: _this.finalLng
      });
    };
    this.$watch('finalLat', updateCenter);
    this.$watch('finalLng', updateCenter);
  },

  computed: {
    finalLat: function finalLat() {
      return this.center && typeof this.center.lat === 'function' ? this.center.lat() : this.center.lat;
    },
    finalLng: function finalLng() {
      return this.center && typeof this.center.lng === 'function' ? this.center.lng() : this.center.lng;
    }
  },

  watch: {
    zoom: function zoom(_zoom) {
      if (this.$mapObject) {
        this.$mapObject.setZoom(_zoom);
      }
    }
  },

  deferredReady: function deferredReady() {
    var _this2 = this;

    return _manager.loaded.then(function () {
      // getting the DOM element where to create the map
      var element = _this2.$refs['vue-map'];

      // creating the map
      var copiedData = _lodash2.default.clone(_this2.getPropsValues());
      delete copiedData.options;
      var options = _lodash2.default.clone(_this2.options);
      _lodash2.default.assign(options, copiedData);
      _this2.$mapObject = new google.maps.Map(element, options);

      // binding properties (two and one way)
      (0, _propsBinder2.default)(_this2, _this2.$mapObject, _lodash2.default.omit(props, ['center', 'zoom', 'bounds']));

      // manually trigger center and zoom
      _this2.$mapObject.addListener('center_changed', function () {
        _this2.$emit('center_changed', _this2.$mapObject.getCenter());
      });
      _this2.$mapObject.addListener('zoom_changed', function () {
        _this2.$emit('zoom_changed', _this2.$mapObject.getZoom());
      });
      _this2.$mapObject.addListener('bounds_changed', function () {
        _this2.$emit('bounds_changed', _this2.$mapObject.getBounds());
      });

      //binding events
      (0, _eventsBinder2.default)(_this2, _this2.$mapObject, events);

      _this2.$mapCreatedDeferred.resolve(_this2.$mapObject);

      return _this2.$mapCreated;
    }).catch(function (error) {
      throw error;
    });
  },

  methods: methods
};

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(9);

var _lodash2 = _interopRequireDefault(_lodash);

var _propsBinder = __webpack_require__(52);

var _propsBinder2 = _interopRequireDefault(_propsBinder);

var _simulateArrowDown = __webpack_require__(471);

var _simulateArrowDown2 = _interopRequireDefault(_simulateArrowDown);

var _getPropsValuesMixin = __webpack_require__(64);

var _getPropsValuesMixin2 = _interopRequireDefault(_getPropsValuesMixin);

var _manager = __webpack_require__(116);

var _assert = __webpack_require__(163);

var _assert2 = _interopRequireDefault(_assert);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var props = {
  bounds: {
    type: Object
  },
  defaultPlace: {
    type: String,
    default: ''
  },
  componentRestrictions: {
    type: Object,
    default: null
  },
  types: {
    type: Array,
    default: function _default() {
      return [];
    }
  },
  placeholder: {
    required: false,
    type: String
  },
  className: {
    required: false,
    type: String
  },
  label: {
    required: false,
    type: String,
    default: null
  },
  selectFirstOnEnter: {
    require: false,
    type: Boolean,
    default: false
  }
};

exports.default = {
  mixins: [_getPropsValuesMixin2.default],

  mounted: function mounted() {
    var _this = this;

    var input = this.$refs.input;

    // Allow default place to be set
    input.value = this.defaultPlace;
    this.$watch('defaultPlace', function () {
      input.value = _this.defaultPlace;
    });

    _manager.loaded.then(function () {
      var options = _lodash2.default.clone(_this.getPropsValues());
      if (_this.selectFirstOnEnter) {
        (0, _simulateArrowDown2.default)(_this.$refs.input);
      }

      (0, _assert2.default)(typeof google.maps.places.Autocomplete === 'function', 'google.maps.places.Autocomplete is undefined. Did you add \'places\' to libraries when loading Google Maps?');

      _this.autoCompleter = new google.maps.places.Autocomplete(_this.$refs.input, options);
      (0, _propsBinder2.default)(_this, _this.autoCompleter, _lodash2.default.omit(props, ['placeholder', 'place', 'selectFirstOnEnter', 'defaultPlace', 'className', 'label']));

      _this.autoCompleter.addListener('place_changed', function () {
        _this.$emit('place_changed', _this.autoCompleter.getPlace());
      });
    });
  },
  created: function created() {
    console.warn('The PlaceInput class is deprecated! Please consider using the Autocomplete input instead'); //eslint-disable-line no-console
  },

  props: props
};

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(157);

var _promise2 = _interopRequireDefault(_promise);

var _lodash = __webpack_require__(9);

var _lodash2 = _interopRequireDefault(_lodash);

var _manager = __webpack_require__(116);

var _deferredReady = __webpack_require__(156);

var _eventsBinder = __webpack_require__(69);

var _eventsBinder2 = _interopRequireDefault(_eventsBinder);

var _propsBinder = __webpack_require__(52);

var _propsBinder2 = _interopRequireDefault(_propsBinder);

var _getPropsValuesMixin = __webpack_require__(64);

var _getPropsValuesMixin2 = _interopRequireDefault(_getPropsValuesMixin);

var _mountableMixin = __webpack_require__(222);

var _mountableMixin2 = _interopRequireDefault(_mountableMixin);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var props = {
  zoom: {
    twoWay: true,
    type: Number
  },
  pov: {
    twoWay: true,
    type: Object,
    trackProperties: ['pitch', 'heading']
  },
  position: {
    twoWay: true,
    type: Object
  },
  pano: {
    twoWay: true,
    type: String
  },
  motionTracking: {
    twoWay: false,
    type: Boolean
  },
  visible: {
    twoWay: true,
    type: Boolean,
    default: true
  },
  options: {
    twoWay: false,
    type: Object,
    default: function _default() {
      return {};
    }
  }
};

var events = ['closeclick', 'status_changed'];

// Other convenience methods exposed by Vue Google Maps
var customMethods = {
  resize: function resize() {
    if (this.$panoObject) {
      google.maps.event.trigger(this.$panoObject, 'resize');
    }
  }
};

// Methods is a combination of customMethods and linkedMethods
var methods = _lodash2.default.assign({}, customMethods);

exports.default = {
  mixins: [_getPropsValuesMixin2.default, _deferredReady.DeferredReadyMixin, _mountableMixin2.default],
  props: props,
  replace: false, // necessary for css styles
  methods: methods,

  created: function created() {
    var _this = this;

    this.$panoCreated = new _promise2.default(function (resolve, reject) {
      _this.$panoCreatedDeferred = { resolve: resolve, reject: reject };
    });

    var updateCenter = function updateCenter() {
      if (!_this.panoObject) return;

      _this.$panoObject.setPosition({
        lat: _this.finalLat,
        lng: _this.finalLng
      });
    };
    this.$watch('finalLat', updateCenter);
    this.$watch('finalLng', updateCenter);
  },

  computed: {
    finalLat: function finalLat() {
      return this.position && typeof this.position.lat === 'function' ? this.position.lat() : this.position.lat;
    },
    finalLng: function finalLng() {
      return this.position && typeof this.position.lng === 'function' ? this.position.lng() : this.position.lng;
    }
  },

  watch: {
    zoom: function zoom(_zoom) {
      if (this.$panoObject) {
        this.$panoObject.setZoom(_zoom);
      }
    }
  },

  deferredReady: function deferredReady() {
    var _this2 = this;

    return _manager.loaded.then(function () {
      // getting the DOM element where to create the map
      var element = _this2.$refs['vue-street-view-pano'];

      // creating the map
      var options = _lodash2.default.defaults({}, _lodash2.default.omit(_this2.getPropsValues(), ['options']), _this2.options);

      _this2.$panoObject = new google.maps.StreetViewPanorama(element, options);

      // binding properties (two and one way)
      (0, _propsBinder2.default)(_this2, _this2.$panoObject, _lodash2.default.omit(props, ['position', 'zoom']));

      //binding events
      (0, _eventsBinder2.default)(_this2, _this2.$panoObject, events);

      _this2.$panoCreatedDeferred.resolve(_this2.$panoObject);

      return _this2.$panoCreated;
    }).catch(function (error) {
      throw error;
    });
  }
};

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_average_of__ = __webpack_require__(251);


/* harmony default export */ __webpack_exports__["a"] = ({
    label: "Mitjana",
    callback: __WEBPACK_IMPORTED_MODULE_0__utilities_average_of__["a" /* default */],
    format: true
});

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
    label: "Count",
    callback: function callback(array) {
        return array.length;
    }
});

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_max_of__ = __webpack_require__(725);


/* harmony default export */ __webpack_exports__["a"] = ({
    label: "Màxim",
    callback: __WEBPACK_IMPORTED_MODULE_0__utilities_max_of__["a" /* default */],
    format: true
});

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_median_of__ = __webpack_require__(726);


/* harmony default export */ __webpack_exports__["a"] = ({
    label: "Mediana",
    callback: __WEBPACK_IMPORTED_MODULE_0__utilities_median_of__["a" /* default */],
    format: true
});

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_min_of__ = __webpack_require__(727);


/* harmony default export */ __webpack_exports__["a"] = ({
    label: "Mínim",
    callback: __WEBPACK_IMPORTED_MODULE_0__utilities_min_of__["a" /* default */],
    format: true
});

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_standard_deviation_of__ = __webpack_require__(729);


/* harmony default export */ __webpack_exports__["a"] = ({
    label: "Standard Deviation",
    callback: __WEBPACK_IMPORTED_MODULE_0__utilities_standard_deviation_of__["a" /* default */]
});

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_total_of__ = __webpack_require__(256);


/* harmony default export */ __webpack_exports__["a"] = ({
    label: "Total",
    callback: __WEBPACK_IMPORTED_MODULE_0__utilities_total_of__["a" /* default */],
    format: true
});

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_variance_of__ = __webpack_require__(257);


/* harmony default export */ __webpack_exports__["a"] = ({
    label: "Variance",
    callback: __WEBPACK_IMPORTED_MODULE_0__utilities_variance_of__["a" /* default */]
});

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__directives__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__filters__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_icons__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_awesome_swiper__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_multiselect__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_nav_tabs__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_nav_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_nav_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_nav_tabs_themes_vue_tabs_css__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_nav_tabs_themes_vue_tabs_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_nav_tabs_themes_vue_tabs_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_circle_slider__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_charts__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_charts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_charts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue2_google_maps__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue2_google_maps__);
__webpack_require__(482);
















__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_vue_nav_tabs___default.a);



__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_vue_circle_slider__["default"]);



__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_14_vue_charts___default.a);

//vue-awesome
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('icon', __WEBPACK_IMPORTED_MODULE_7_vue_awesome_components_Icon_vue___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('multiselect', __WEBPACK_IMPORTED_MODULE_9_vue_multiselect___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_vue_awesome_swiper___default.a);

// import 'swiper/dist/css/swiper.css'


// vue2-google-maps

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_vue2_google_maps__, {
    load: {
        key: 'AIzaSyCx8ghi_qXr6KToLFS0R18UIYI25KKo1lI',
        libraries: 'places' // This is required if you use the Autocomplete plugin
        // OR: libraries: 'places,drawing'
        // OR: libraries: 'places,drawing,visualization'
        // (as you require)
    }
});

var numeral = __webpack_require__(119);

numeral.register('locale', 'es-es', {
    delimiters: {
        thousands: '.',
        decimal: ','
    },
    abbreviations: {
        thousand: 'k',
        million: 'mm',
        billion: 'b',
        trillion: 't'
    },
    ordinal: function ordinal(number) {
        var b = number % 10;
        return b === 1 || b === 3 ? 'er' : b === 2 ? 'do' : b === 7 || b === 0 ? 'mo' : b === 8 ? 'vo' : b === 9 ? 'no' : 'to';
    },
    currency: {
        symbol: '€'
    }
});

numeral.locale('es-es');

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('formatNumber', function (value) {
    if (!value || value === 0) {
        return '-';
    } else {
        return numeral(value).format('0,0.00');
    }
});

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('formatDateAsLocal', function (value) {
    if (!value || value === 0) {
        return '-';
    } else {
        //console.log('formatDateAsLocal value: ')
        //console.log(value)
        return __WEBPACK_IMPORTED_MODULE_10_moment___default()(value, 'X').format('LLLL');
    }
});

Object.keys(__WEBPACK_IMPORTED_MODULE_5__filters__).forEach(function (key) {
    __WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter(key, __WEBPACK_IMPORTED_MODULE_5__filters__[key]);
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
    el: '#app',
    template: '<App/>',
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App_vue___default.a }
});

// Others
// Disable mousewheel on input type number
/*
document.addEventListener("mousewheel", function(event){
    if(document.activeElement.type === "number"){
        document.activeElement.blur()
    }
})
*/

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var defaultTemplate = "<span>{{ column.formatData(row[column.id]) }}</span>";
var editableTemplate = '<input type="text" v-model="row[column.id]"/>';
var optimizedEditableTemplate = '<input type="text" v-model.lazy="row[column.id]"/>';

function getChildComponent(editable, optimize) {

    var component = {
        template: defaultTemplate,
        props: ["row", "column"]
    };

    if (editable) {
        component.template = optimize ? optimizedEditableTemplate : editableTemplate;
    }

    return component;
}

/* harmony default export */ __webpack_exports__["a"] = ({
    functional: true,

    name: "datatable-cell",

    props: {

        row: Object,
        column: Object,

        editable: {
            type: Boolean,
            default: false
        },

        optimize: {
            type: Boolean,
            default: false
        }

    },

    render: function render(createElement, context) {
        var row = context.props.row;
        var column = context.props.column;

        var cell = "td";
        var cellProps = {
            class: {
                "datatable-cell": true
            },
            style: column.columnStyles
        };

        if (column.template) {

            var vNode = column.template({
                row: row,
                column: column,
                value: row[column.id]
            });

            return createElement(cell, cellProps, [vNode]);
        }

        var child = getChildComponent(context.props.editable, context.props.optimize);

        var childProps = {
            props: {
                row: row,
                column: column
            }
        };

        return createElement(cell, cellProps, [createElement(child, childProps)]);
    }
});

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

function genericHandler(event) {}

var eventHandlerMap = {
    start: {
        eventName: "dragstart",
        draggable: true,
        callback: genericHandler
    },
    drag: {
        eventName: "drag",
        draggable: true,
        callback: genericHandler
    },
    enter: {
        eventName: "dragenter",
        callback: genericHandler
    },
    leave: {
        eventName: "dragleave",
        callback: genericHandler
    },
    over: {
        eventName: "dragover",
        callback: genericHandler
    },
    drop: {
        eventName: "drop",
        callback: genericHandler
    },
    end: {
        eventName: "dragend",
        draggable: true,
        callback: genericHandler
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    bind: function bind(element, binding, vNode) {
        var eventType = binding.arg.toLowerCase();

        if (!(eventType in eventHandlerMap)) {
            console.warn("Event not supported");
            return;
        }

        var handler = eventHandlerMap[eventType];

        if (handler.draggable) {
            element.setAttribute("draggable", true);
        }

        var callback = binding.value;

        if (typeof callback !== "function") {
            callback = function callback(event) {};
        }

        element.addEventListener(handler.eventName, function (event) {
            handler.callback.call(element, event);
            callback.call(element, event);

            return false;
        }, false);
    }
});

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = currency;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__maps_currencies__ = __webpack_require__(603);


function currency(value, precision, currency) {

    var symbol = currency ? __WEBPACK_IMPORTED_MODULE_0__maps_currencies__["a" /* default */][currency.toUpperCase()] : __WEBPACK_IMPORTED_MODULE_0__maps_currencies__["a" /* default */].EUR;

    if (precision > 0) {

        var parsed = parseFloat(value);

        if (isNaN(parsed)) {
            return value;
        }

        var formatted = parsed.toFixed(precision).replace('.', ',');
        return formatted.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.') + ' ' + symbol;
    } else {

        return parseFloat(value).toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.') + ' ' + symbol;
    }
}

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dateShort;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datetime__ = __webpack_require__(164);


function dateShort(value) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__datetime__["a" /* default */])(value, "D MMMM YYYY");
}

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dateShort;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datetime__ = __webpack_require__(164);


function dateShort(value) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__datetime__["a" /* default */])(value, "DD/MM/YYYY");
}

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = homg_percentage;
function homg_percentage(value) {

    if (!value) {
        return '-';
    } else {
        value = Number(value);

        if (value === 0) {
            return '-';
        }

        if (value > 0) {

            return '+' + value + ' %';
        } else {
            return value + ' %';
        }
    }
}

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    AED: "د.إ",
    AFN: "؋",
    ALL: "L",
    ANG: "ƒ",
    AOA: "Kz",
    ARS: "$",
    AUD: "$",
    AWG: "ƒ",
    AZN: "₼",
    BAM: "KM",
    BBD: "$",
    BDT: "৳",
    BGN: "лв",
    BHD: ".د.ب",
    BIF: "FBu",
    BMD: "$",
    BND: "$",
    BOB: "Bs.",
    BRL: "R$",
    BSD: "$",
    BTN: "Nu.",
    BWP: "P",
    BYR: "p.",
    BZD: "BZ$",
    CAD: "$",
    CDF: "FC",
    CHF: "Fr.",
    CLP: "$",
    CNY: "¥",
    COP: "$",
    CRC: "₡",
    CUC: "$",
    CUP: "₱",
    CVE: "$",
    CZK: "Kč",
    DJF: "Fdj",
    DKK: "kr",
    DOP: "RD$",
    DZD: "دج",
    EEK: "kr",
    EGP: "£",
    ERN: "Nfk",
    ETB: "Br",
    EUR: "€",
    EUR2: "€²",
    EUR_X_M2: "€·m²",
    EUR_M2: "€/m²",
    EUR_M2_POW2: "(€/m²)²",
    KM: "km",
    M: "m",
    M2: "m²",
    M2_POW2: "(m²)²",
    PCT: "%",
    FJD: "$",
    FKP: "£",
    GBP: "£",
    GEL: "₾",
    GGP: "£",
    GHC: "₵",
    GHS: "GH₵",
    GIP: "£",
    GMD: "D",
    GNF: "FG",
    GTQ: "Q",
    GYD: "$",
    HKD: "$",
    HNL: "L",
    HRK: "kn",
    HTG: "G",
    HUF: "Ft",
    IDR: "Rp",
    ILS: "₪",
    IMP: "£",
    INR: "₹",
    IQD: "ع.د",
    IRR: "﷼",
    ISK: "kr",
    JEP: "£",
    JMD: "J$",
    JPY: "¥",
    KES: "KSh",
    KGS: "лв",
    KHR: "៛",
    KMF: "CF",
    KPW: "₩",
    KRW: "₩",
    KYD: "$",
    KZT: "₸",
    LAK: "₭",
    LBP: "£",
    LKR: "₨",
    LRD: "$",
    LSL: "M",
    LTL: "Lt",
    LVL: "Ls",
    MAD: "MAD",
    MDL: "lei",
    MGA: "Ar",
    MKD: "ден",
    MMK: "K",
    MNT: "₮",
    MOP: "MOP$",
    MUR: "₨",
    MVR: "Rf",
    MWK: "MK",
    MXN: "$",
    MYR: "RM",
    MZN: "MT",
    NAD: "$",
    NGN: "₦",
    NIO: "C$",
    NOK: "kr",
    NPR: "₨",
    NZD: "$",
    OMR: "﷼",
    PAB: "B/.",
    PEN: "S/.",
    PGK: "K",
    PHP: "₱",
    PKR: "₨",
    PLN: "zł",
    PYG: "Gs",
    QAR: "﷼",
    RMB: "￥",
    RON: "lei",
    RSD: "Дин.",
    RUB: "₽",
    RWF: "R₣",
    SAR: "﷼",
    SBD: "$",
    SCR: "₨",
    SDG: "ج.س.",
    SEK: "kr",
    SGD: "$",
    SHP: "£",
    SLL: "Le",
    SOS: "S",
    SRD: "$",
    SSP: "£",
    STD: "Db",
    SVC: "$",
    SYP: "£",
    SZL: "E",
    THB: "฿",
    TJS: "SM",
    TMT: "T",
    TND: "د.ت",
    TOP: "T$",
    TRL: "₤",
    TRY: "₺",
    TTD: "TT$",
    TVD: "$",
    TWD: "NT$",
    TZS: "TSh",
    UAH: "₴",
    UGX: "USh",
    USD: "$",
    UYU: "$U",
    UZS: "лв",
    VEF: "Bs",
    VND: "₫",
    VUV: "VT",
    WST: "WS$",
    XAF: "FCFA",
    XBT: "Ƀ",
    XCD: "$",
    XOF: "CFA",
    XPF: "₣",
    YER: "﷼",
    ZAR: "R",
    ZWD: "Z$",
    BTC: "฿",
    NONE: ""
});

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({

    model: {
        prop: "source",
        event: "change"
    },

    props: {

        id: {
            type: String,
            required: true
        },

        source: {
            required: true
        },

        value: {
            required: false
        },

        disabled: {
            type: Boolean,
            default: false
        }

    },

    data: function data() {
        return {
            proxy: false
        };
    },


    computed: {

        checked: {
            get: function get() {
                return this.source;
            },
            set: function set(value) {
                this.proxy = value;
                this.$emit("change", this.proxy);
            }
        }

    }
});

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Bona',
    name_en: 'Good',
    name_es: 'Buena'
}, {
    id: 2,
    name_ca: 'Correcta',
    name_en: 'Correct',
    name_es: 'Correcta'
}, {
    id: 3,
    name_ca: 'Difícil',
    name_en: 'Difficult',
    name_es: 'Difícil'
}]);

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    bde_code: 'A23',
    name_ca: 'Dades d\'oferta',
    name_en: 'Offer data',
    name_es: 'Datos de oferta'
}, {
    id: 2,
    bde_code: 'A22',
    name_ca: 'Transaccions recents',
    name_en: 'Recent transactions',
    name_es: 'Transacciones recientes'
}]);

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    bde_code: 'C',
    id: 1,
    name_ca: 'Taxació completa',
    name_en: 'Complete Valuation',
    name_es: 'Tasación Completa'
}, {
    bde_code: 'M',
    id: 2,
    name_ca: 'Model Automàtic',
    name_en: 'Automatic Model',
    name_es: 'Modelo Automático'
}, {
    bde_code: 'O',
    id: 3,
    name_ca: 'Taxació Online',
    name_en: 'Online Valuation',
    name_es: 'Tasación Online'
}, {
    bde_code: 'R',
    id: 4,
    name_ca: 'Resta de Taxacions',
    name_en: 'Other Valuations',
    name_es: 'Resto de Tasaciones'
}]);

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// si canvia algun camp revisar i actualitzar, per exemple, RealEstateEditor.vue funció "set_realestate_property_type"
/* harmony default export */ __webpack_exports__["a"] = ([{
    bde_code: 'V93',
    name_es: 'V93 - Vivienda protegida',
    name_ca: 'V93 - Habitatge protegit',
    name_en: 'V93 - State-subsidized housing',
    lifespan: 100
}, {
    bde_code: 'V94',
    name_es: 'V94 - Vivienda libre de primera residencia',
    name_ca: 'V94 - Habitatge lliure de primera residència',
    name_en: 'V94 - Primary residence free-market housing',
    lifespan: 100
}, {
    bde_code: 'V95',
    name_es: 'V95 - Vivienda libre de segunda residencia',
    name_ca: 'V95 - Habitatge lliure de segona residència',
    name_en: 'V95 - Secondary residence free-market housing',
    lifespan: 100
}, {
    bde_code: 'V96',
    name_es: 'V96 - Oficinas',
    name_ca: 'V96 - Oficines',
    name_en: 'V96 - Offices',
    lifespan: 75
}, {
    bde_code: 'V97',
    name_es: 'V97 - Locales comerciales',
    name_ca: 'V97 - Locals comercials',
    name_en: 'V97 - Retail',
    lifespan: 50
}, {
    bde_code: 'V98',
    name_es: 'V98 - Plazas de garaje',
    name_ca: 'V98 - Places d\'aparcament',
    name_en: 'V98 - Parking spaces',
    lifespan: 100
}, {
    bde_code: 'V99',
    name_es: 'V99 - Trasteros',
    name_ca: 'V99 - Trasters',
    name_en: 'V99 - Storage rooms',
    lifespan: 100
}, {
    bde_code: 'VA1',
    name_es: 'VA1 - Hoteles',
    name_ca: 'VA1 - Hotels',
    name_en: 'VA1 - Hotels',
    lifespan: 50
}, {
    bde_code: 'VA2',
    name_es: 'VA2 - Residencias de estudiantes',
    name_ca: 'VA2 - Residències d\'estudiants',
    name_en: 'VA2 - Students residencew',
    lifespan: 100
}, {
    bde_code: 'VA3',
    name_es: 'VA3 - Resto de los edificios',
    name_ca: 'VA3 - Altres edificis',
    name_en: 'VA3 - Other buildings',
    lifespan: 50
}, {
    bde_code: 'VA2',
    name_es: 'VA2 - Residencias de la tercera edad',
    name_ca: 'VA2 - Residències geriàtriques',
    name_en: 'VA2 - Elderly homes',
    lifespan: 100
}]);

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: '0 a 10 anys',
    name_en: '0 to 10 years',
    name_es: '0 a 10 años'
}, {
    id: 2,
    name_ca: '10 a 25 anys',
    name_en: '10 to 25 years',
    name_es: '10 a 25 años'
}, {
    id: 3,
    name_ca: '25 a 50 anys',
    name_en: '25 to 50 years',
    name_es: '25 a 50 años'
}, {
    id: 4,
    name_ca: 'Més de 50 anys',
    name_en: 'More than 50 years',
    name_es: 'Más de 50 años'
}]);

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Desconeguda',
    name_es: 'Desconocida',
    name_en: 'Unknown'
}, {
    id: 2,
    name_ca: 'Cap',
    name_es: 'Ninguno',
    name_en: 'None'
}, {
    id: 3,
    name_ca: 'Estructura vista',
    name_es: 'Estructura vista',
    name_en: 'Naked structure'
}, {
    id: 4,
    name_ca: 'Pintat',
    name_es: 'Pintado',
    name_en: 'Painted'
}, {
    id: 5,
    name_ca: 'Enguixat i pintat',
    name_es: 'Enyesado y pintado',
    name_en: 'Plastered and painted'
}, {
    id: 6,
    name_ca: 'Plaques d\'escaiola',
    name_es: 'Placas de escayola',
    name_en: 'Plaster boards'
}, {
    id: 7,
    name_ca: 'Plaques de fibres minerals',
    name_es: 'Placas de fibras minerales',
    name_en: 'Mineral fiber plates'
}, {
    id: 8,
    name_ca: 'Plaques de fibres vegetals',
    name_es: 'Placas de fibras vegetales',
    name_en: 'Mineral fibes plates'
}, {
    id: 9,
    name_ca: 'Plaques de guix laminat',
    name_es: 'Placas de yeso laminado',
    name_en: 'Gypsum plasterboard'
}, {
    id: 10,
    name_ca: 'Plaques de fusta',
    name_es: 'Placas de madera',
    name_en: 'Wood paneling'
}, {
    id: 11,
    name_ca: 'Plaques de fibres minerals aglomerades en humit',
    name_es: 'Placas de fibras minerales aglomeradas en húmedo',
    name_en: 'Agglomerated mineral fiber plates'
}, {
    id: 12,
    name_ca: 'Lamel·les metàl·liques',
    name_es: 'Lamas metálicas',
    name_en: 'Metallic strips'
}, {
    id: 13,
    name_ca: 'Plaques metàl·liques',
    name_es: 'Placas metálicas',
    name_en: 'Metal plates'
}, {
    id: 14,
    name_ca: 'Planxes metàl·liques',
    name_es: 'Planchas metálicas',
    name_en: 'Metal sheets'
}, {
    id: 15,
    name_ca: 'Plaques de GRC',
    name_es: 'Placas de GRC',
    name_en: 'GRC plates'
}, {
    id: 16,
    name_ca: 'Plaques d\'aglomerat de ciment amb fibres',
    name_es: 'Placas de aglomerado de cemento con fibras',
    name_en: 'Agglomerated fiber and cement plates'
}, {
    id: 17,
    name_ca: 'Taulers de partícules aglomerades amb ciment',
    name_es: 'Tableros de partículas aglomeradas con cemento',
    name_en: 'Cement and particles agglomerated panels'
}, {
    id: 18,
    name_ca: 'Plaques de silicat',
    name_es: 'Placas de silicato',
    name_en: 'Silicate boards'
}]);

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Punt alt',
    name_es: 'Punto alto',
    name_en: 'High point'
}, {
    id: 2,
    name_ca: 'Punt mig',
    name_es: 'Punto medio',
    name_en: 'Middle point'
}, {
    id: 3,
    name_ca: 'Punt baix',
    name_es: 'Punto bajo',
    name_en: 'Low point'
}]);

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'No s\'ha pogut comprovar la identificació física de l\'immoble mitjançant la seva localització i inspecció ocular',
    name_es: 'No se ha podido comprobar la identificación física del inmueble mediante su localización e inspección ocular',
    name_en: 'It was not possible to verify the physical identification of the property through its location and ocular inspection'
}, {
    id: 2,
    name_ca: 'No s\'ha pogut comprovar la superfície de l\'immoble',
    name_es: 'No se ha podido comprobar la superfície del inmueble',
    name_en: 'It was not possible to check the area of the property'
}, {
    id: 3,
    name_ca: 'No s\'ha pogut comprovar l\'existència de servituds visibles',
    name_es: 'No se ha podido comprobar la existencia de servidumbres visibles',
    name_en: 'It has not been possible to verify the existence of visible easements'
}, {
    id: 4,
    name_ca: 'No s\'ha pogut comprovar l\'estat de conservació aparent',
    name_es: 'No se ha podido comprobar el estado de conservación aparente',
    name_en: ''
}, {
    id: 5,
    name_ca: 'No s\'ha pogut comprovar l\'estat de conservació aparent',
    name_es: 'No se ha podido comprobar el estado de construcción aparente',
    name_en: 'The apparent conservation status could not be verified'
}, {
    id: 6,
    name_ca: 'No s\'ha pogut comprovar l\'estat d\'ocupació i l\'ús o explotació a què està destinat',
    name_es: 'No se ha podido comprobar el estado de ocupación y el uso o explotación al que está destinado',
    name_en: 'It has not been possible to verify the state of occupation and the use or exploitation for which it is destined'
}, {
    id: 7,
    name_ca: 'No s\'ha pogut comprovar el règim de protecció pública (en el cas d\'habitatges)',
    name_es: 'No se ha podido comprobar el régimen de protección pública (en el caso de viviendas)',
    name_en: 'It has not been possible to verify the public protection regime (in the case of housing)'
}, {
    id: 8,
    name_ca: 'No s\'ha pogut comprovar el règim de protecció del patrimoni arquitectònic',
    name_es: 'No se ha podido comprobar el régimen de protección del patrimonio arquitectónico',
    name_en: 'The protection regime of the architectural heritage could not be verified'
}, {
    id: 9,
    name_ca: 'No s\'ha pogut comprovar l\'adequació de l\'immoble al planejament urbanístic vigent, i, si escau, l\'existència d\'dret a l\'aprofitament urbanístic',
    name_es: 'No se ha podido comprobar la adecuación del inmueble al planeamiento urbanístico vigente, y, en su caso, la existencia de derecho al aprovechamiento urbanístico',
    name_en: 'It has not been possible to verify the adequacy of the property to the current urban planning, and, as the case may be, the existence of a right to urban development'
}, {
    id: 10,
    name_ca: 'No s\'ha disposat del contracte d\'arrendament o un altre títol d\'ocupació i de les condicions actuals de l\'arrendament o cessió, i l\'ús de l\'immoble està cedit',
    name_es: 'No se ha dispuesto del contrato de arrendamiento u otro título de ocupación y de las condiciones actuales del arrendamiento o cesión, y el uso del inmueble está cedido',
    name_en: 'The lease or other title of occupation and the current conditions of the lease or assignment have not been arranged, and the use of the property is assigned'
}, {
    id: 11,
    name_ca: 'No s\'ha pogut calcular el valor màxim legal i l\'immoble està subjecte a protecció pública',
    name_es: 'No se ha podido calcular el valor máximo legal y el inmueble está sujeto a protección pública',
    name_en: 'The maximum legal value could not be calculated and the property is subject to public protection'
}, {
    id: 12,
    name_ca: 'El titular registral de l\'immoble no coincideix amb la institució d\'inversió col·lectiva que l\'inclou a efectes de càlcul en el seu valor patrimonial',
    name_es: 'El titular registral del inmueble no coincide con la institución de inversión colectiva que lo incluye a efectos de cálculo en su valor patrimonial',
    name_en: 'The registered owner of the property does not match with the collective investment institution that includes it for purposes of calculation in its equity value'
}, {
    id: 13,
    name_ca: 'El titular registral de l\'immoble no coincideix amb la societat o entitat d\'arrendament referides en el paràgraf a) de l\'article 56.1. del Reglament de la Llei 35/2003, de 4 de novembre, d\'Institucions d\'Inversió Col·lectiva',
    name_es: 'El titular registral del inmueble no coincide con la sociedad o entidad de arrendamiento referidas en el párrafo a) del artículo 56.1. del Reglamento de la Ley 35/2003, de 4 de noviembre, de Instituciones de Inversión Colectiva',
    name_en: 'The registered owner of the property does not agree with the company or leasing entity referred to in paragraph a) of article 56.1. Of the Regulation of Law 35/2003, of November 4, on Collective Investment Institutions'
}, {
    id: 14,
    name_ca: 'El titular registral de l\'immoble no coincideix amb la persona física o jurídica que actua de contrapart en el contracte en el cas de compra sobre plànol o d\'immobles en fase de construcció i la promoció immobiliària no s\'executa directament per part de la institució',
    name_es: 'El titular registral del inmueble no coincide con la persona física o jurídica que actua de contraparte en el contrato en el caso de compra sobre plano e inmuebles en fase de construcción y la promoción inmobiliaria no se ejecuta directamente por parte de la institución',
    name_en: 'The registered owner of the property does not match with the natural or legal person acting as counterpart in the contract in the case of purchase on flat and real estate in the construction phase and the real estate promotion is not executed directly by the institution'
}, {
    id: 15,
    name_ca: 'El titular registral de l\'immoble no coincideix amb la persona física o jurídica que actua de contrapart en el contracte en el cas de compromís de compra a termini o compra d\'opcions de compra o contractes d\'arres',
    name_es: 'El titular registral del inmueble no coincide con la persona física o jurídica que actua de contraparte en el contrato en el caso de compromiso de compra a plazo o  compra de opciones de compra o contratos de arras',
    name_en: 'The registered owner of the property does not agree with the natural or legal person acting as counterparty in the contract in the case of a commitment to purchase for term or purchase of call options or contracts'
}]);

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    name_ca: 'Aquesta taxació s\'ha realitzat d\'acord amb els requisits recollits a l\'Ordre ECO-805-2003 DE 27 DE MARÇ del Ministeri d\'Economia i Hisenda, sobre Valoració de Béns per a determinades entitats financeres, excepte pel que fa al que assenyala l\'apartat condicionants i advertiments generals',
    name_es: 'Esta tasación se ha realizado de acuerdo con los requisitos recogidos en la Orden ECO-805-2003 DE 27 DE MARZO del Ministerio de Economía y Hacienda, sobre Valoración de Bienes para determinadas entidades financieras, excepto en cuanto a lo que señala el apartado condicionantes y advertencias',
    name_en: ''
}, {
    name_ca: 'La present taxació NO és vàlida a efectes de constituir garanties hipotecàries, de provisions de fons de les companyies d\'assegurances i de fons d\'inversió Immobiliàries',
    name_es: 'La presente tasación NO es válida a efectos de constituir garantías hipotecarias, de provisiones de fondos de las compañías de seguros y de fondos de inversión Inmobiliarias',
    name_en: 'This valuation report is NOT valid for the purpose of constituting guarantees for mortgage loans, provision of funds from insurance companies and real estate investment funds'
}, {
    name_ca: 'Aquesta taxació té una validesa de SIS mesos a partir de la data de la seva expedició',
    name_es: 'Esta tasación tiene una validez de SEIS meses a partir de la fecha de su expedición',
    name_en: 'This appraisal is valid for SIX months from the date of issue.'
}, {
    name_ca: 'Tant BARNA-TASA, S.A. Com els professionals que hem intervingut en l\'elaboració del present informe de taxació, declarem que coneixem i hem tingut en consideració de manera estricta i fidel les incompatibilitats establertes en els articles 6 i 13 del Reial decret 775/1997 de 30 de maig, referents tant a la Societat com als seus professionals i així ho subscrivim',
    name_es: 'Tanto BARNA-TASA, S.A. Como los profesionales que hemos intervenido en la elaboración del presente informe de tasación, declaramos que conocemos y hemos tenido en consideración de manera estricta y fiel las incompatibilidades establecidas en los artículos 6 y 13 del Real Decreto 775/1997 de 30 de mayo, referentes tanto a la Sociedad como a sus profesionales y así lo suscribimos',
    name_en: 'Both BARNA-Charges, S.A. and the professionals who have been involved in the preparation of the valuation report, we declare that we know and have in consideration strictly and faithfully the incompatibilities established in articles 6 and 13 of Royal Decree 775/1997 of 30 May, concerning both the Company and its professionals and thus subscribe them'
}, {
    name_ca: 'El valor de taxació expressat és el que resulta tenint en compte l\'objecte i finalitat de la valoració',
    name_es: 'El valor de tasación expresado es el que resulta teniendo en cuenta el objeto y finalidad de la valoración',
    name_en: 'The appraisal value is expressed considering the scope and purpose of the valuation'
}, {
    name_ca: 'La taxació s\'ha efectuat suposada la finca lliure de càrregues i gravàmens',
    name_es: 'La tasación se ha efectuado supuesta la finca libre de cargas y gravámenes',
    name_en: 'The valuation has been made considering the property is free of charges and liens'
}]);

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Existeixen discrepàncies entre la realitat física de l\'immoble i les seves descripcions registral o cadastral',
    name_es: 'Existen discrepancias entre la realidad física del inmueble y sus descripciones registral o catastral',
    name_en: 'There are discrepancies between the physical reality of the property and its descriptions registry or cadastral'
}, {
    id: 2,
    name_ca: 'L\'immoble que es valora no està conforme amb el planejament urbanístic vigent',
    name_es: 'El inmueble que se valora no está conforme con el planeamiento urbanístico vigente',
    name_en: 'The property that is valued is not in accordance with the current urban planning'
}, {
    id: 3,
    name_ca: 'No s\'ha pogut comprovar el règim de protecció del patrimoni arquitectònic de l\'immoble',
    name_es: 'No se ha podido comprobar el régimen de protección del patrimonio arquitectónico del inmueble',
    name_en: 'It was not possible to verify the protection regime of the architectural heritage of the property'
}, {
    id: 4,
    name_ca: 'L\'immoble està subjecte a expropiació forçosa, que de no complir pot originar modificacions en el valor certificat',
    name_es: 'El inmueble está sujeto a expropiación forzosa, que de no cumplirse puede originar modificaciones en el valor certificado',
    name_en: 'The property is subject to compulsory expropriation, which if not complied with may lead to changes in the certified value'
}, {
    id: 5,
    name_ca: 'L\'immoble està subjecte a una llicència de construcció, que de no complir-se pot originar modificacions en el valor certificat',
    name_es: 'El inmueble está sujeto a una licencia de construcción, que de no cumplirse puede originar modificaciones en el valor certificado',
    name_en: 'The building is subject to a construction license, which, if not complied with, may lead to changes in the certified value'
}, {
    id: 6,
    name_ca: 'L\'immoble està subjecte a una autorització administrativa que conté condicions, que de no complir pot originar modificacions en el valor certificat',
    name_es: 'El inmueble está sujeto a una autorización administrativa que contiene condiciones, que de no cumplirse puede originar modificaciones en el valor certificado',
    name_en: 'The property is subject to an administrative authorization that contains conditions, which if not fulfilled can lead to changes in the certified value'
}, {
    id: 7,
    name_ca: 'S\'han utilitzat mètodes de valoració diferents indicats a l\'article 15.1 (Mètodes) de l\'Ordre Ordre ECO / 805/2003, de 27 de març, sobre normes de valoració de béns immobles i de determinats drets per a certes finalitats financeres',
    name_es: 'Se han utilizado métodos de valoración diferentes indicados en el artículo 15.1 (Métodos) de la Orden Orden ECO/805/2003, de 27 de marzo, sobre normas de valoración de bienes inmuebles y de determinados derechos para ciertas finalidades financieras',
    name_en: 'Different valuation methods indicated in Article 15.1 (Methods) of Order Order ECO / 805/2003, of March 27, have been used for valuation of real property and certain rights for certain financial purposes'
}, {
    id: 8,
    name_ca: 'Per al càlcul del valor màxim legal no s\'ha disposat de cèdula de qualificació o document administratiu que acrediti o permeti determinar el preu màxim en venda o lloguer',
    name_es: 'Para el cálculo del valor máximo legal no se ha dispuesto de cédula de calificación o documento administrativo que acredite o permita determinar el precio máximo en venta o alquiler',
    name_en: 'For the calculation of the maximum legal value, there has not been a certificate of qualification or administrative document that proves or allows determining the maximum price for sale or rent'
}, {
    id: 9,
    name_ca: 'No s\'ha disposat dels documents necessaris per calcular els fluxos de caixa',
    name_es: 'No se ha dispuesto de los documentos necesarios para calcular los flujos de caja',
    name_en: 'The documents necessary to calculate cash flows have not been available'
}, {
    id: 10,
    name_ca: 'No s\'ha disposat de la documentació cadastral rellevant de la finca rústica o la documentació referent al règim d\'explotació o rendiment de la mateixa',
    name_es: 'No se ha dispuesto de la documentación catastral relevante de la finca rústica o la documentación referente al régimen de explotación o rendimiento de la misma',
    name_en: 'The relevant cadastral documentation of the rural property has not been available or the documentation regarding the regime of exploitation or performance of the same'
}, {
    id: 11,
    name_ca: 'No s\'ha disposat de la documentació necessària en el cas d\'edificis en construcció o rehabilitació: el projecte visat pel Col·legi professional corresponent, la llicència d\'obra, l\'última certificació de l\'obra executada expedida per la direcció facultativa, així com el contracte de execució de l\'obra i el pressupost de contracta, si existeixen',
    name_es: 'No se ha dispuesto de la documentación necesaria en el caso de edificios en construcción o rehabilitación: el proyecto visado por el Colegio profesional correspondiente, la licencia de obra, la última certificación de la obra ejecutada expedida por la dirección facultativa, así como el contrato de ejecución de la obra y el presupuesto de contrata, si existen',
    name_en: 'The necessary documentation has not been available in the case of buildings under construction or rehabilitation: the project endorsed by the corresponding professional association, the work permit, the last certification of the executed work issued by the facultative management, as well as the contract of Execution of the work and the contract budget, if they exist'
}, {
    id: 12,
    name_ca: 'En el cas d\'edificis (dels quals l\'ús principal és habitatge) a què es refereix l\'article 2 de la Llei 38/1999, de 5 de novembre, d\'ordenació de l\'edificació, no s\'ha disposat del document acreditatiu de l\'expedició de l\'assegurança de danys materials contemplat en el seu article 19.1.c) (Assegurança de danys decennal)',
    name_es: 'En el caso de edificios (cuyo uso principal sea la vivienda) a que se refiere el artículo 2 de la Ley 38/1999, de 5 de noviembre, de ordenación de la edificación, no se ha dispuesto del documento acreditativo de la expedición del seguro de daños materiales contemplado en su artículo 19.1.c) (Seguro de daños decenal)',
    name_en: 'In the case of buildings (the main use of which is the dwelling) referred to in article 2 of Law 38/1999, dated November 5, on building management, the document certifying the issuance of the insurance has not been available of material damage referred to in Article 19.1 (c) (Ten Year Damage Insurance)'
}, {
    id: 13,
    name_ca: 'En el cas d\'edificis en règim de propietat horitzontal o elements d\'edificis diferents d\'habitatge o plaça de garatge, no s\'ha disposat dels estatuts de la comunitat de propietaris, document equivalent o certificació de l\'administrador de la comunitat acreditativa de les limitacions del seu ús o altres circumstàncies contingudes en aquells que puguin afectar al seu valor',
    name_es: 'La referencia catastral no existe o no puede ser conocida por los medios previstos en el artículo 41.1 del Texto Refundido de la Ley del Catastro Inmobiliario o directamente a través de la oficina virtual del Catastro.',
    name_en: 'In the case of horizontally owned buildings or elements of different buildings of dwelling or garage space, the statutes of the community of owners, equivalent document or certification of the community administrator proving the limitations of their ownership have not been available. Use or other circumstances contained in those that could affect its value'
}, {
    id: 14,
    name_ca: 'La referència cadastral no existeix o no pot ser coneguda pels mitjans previstos en l\'article 41.1 del Text refós de la Llei del Cadastre Immobiliari o directament a través de l\'oficina virtual del Cadastre',
    name_es: 'La referencia catastral no existe o no puede ser conocida por los medios previstos en el artículo 41.1 del Texto Refundido de la Ley del Catastro Inmobiliario o directamente a través de la oficina virtual del Catastro',
    name_en: 'The cadastral reference does not exist or can not be known by means provided in article 41.1 of the Revised Text of the Real Estate Cadastre Law or directly through the virtual office of the Cadastre'
}, {
    id: 15,
    name_ca: 'En el cas de valoracions d\'immobles o drets radicats a l\'estranger: no s\'ha disposat de la documentació exigida en els apartats ui dos de l\'article 8 no pugui ser substituïda pel seu equivalent en el país on es trobin situats, es farà constar el fet de forma expressa. A més, s\'ha d\'advertir, si no s\'ha condicionat per això, quan no s\'hagi disposat de tota la documentació que, d\'acord amb la normativa del país en què es trobi radicat el immoble o dret, resulti necessària per a la identificació completa de l\'objecte de valoració, per determinar l\'aptitud de l\'ús o aprofitament que se li estigui donant o es prevegi donar, per dur a terme la construcció o rehabilitació d\'un immoble, en les seves diferents fases, per a la valoració d\'habitatges de protecció pública o equivalents, o que pugui influir en el valor de l\'immoble',
    name_es: 'En el caso de valoraciones de inmuebles o derechos radicados en el extranjero: no se ha dispuesto de la documentación exigida en los apartados uno y dos del artículo 8 no pueda ser sustituida por su equivalente en el país donde se encuentren situados, se hará constar el hecho de forma expresa. Además, se advertirá, si no se ha condicionado por ello, cuando no se haya dispuesto de toda la documentación que, de acuerdo con la normativa del país en el que se encuentre radicado el inmueble o derecho, resulte necesaria para la identificación completa del objeto de valoración, para determinar la aptitud del uso u aprovechamiento que se le esté dando o se prevea dar, para llevar a cabo la construcción o rehabilitación de un inmueble, en sus distintas fases, para la valoración de viviendas de protección pública o equivalentes, o que pueda influir en el valor del inmueble',
    name_en: 'In the case of valuations of real estate or rights residing abroad: the documentation required in paragraphs 1 and 2 of article 8 has not been provided and can not be replaced by its equivalent in the country where they are located, Done expressly. In addition, it will be noted, if it has not been conditioned by it, when it has not been disposed of all the documentation that, in accordance with the regulations of the country in which the property or right is located, is necessary for the complete identification of the object Of valuation, to determine the suitability of the use or use that is being given or is expected to give, to carry out the construction or rehabilitation of a building, in its different phases, for the valuation of public housing or equivalent, or Which may influence the value of the property'
}]);

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: '> 75 %',
    name_en: '> 75 %',
    name_es: '> 75 %'
}, {
    id: 2,
    name_ca: '> 50 %',
    name_en: '> 50 %',
    name_es: '> 50 %'
}, {
    id: 3,
    name_ca: '< 50 %',
    name_en: '< 50 %',
    name_es: '< 50 %'
}, {
    id: 4,
    name_ca: '< 25 %',
    name_en: '< 25 %',
    name_es: '< 25 %'
}]);

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Ràpida',
    name_en: 'Quick',
    name_es: 'Rápida'
}, {
    id: 2,
    name_ca: 'Mitjana',
    name_en: 'Average',
    name_es: 'Media'
}, {
    id: 3,
    name_ca: 'Lenta, renovació alta',
    name_en: 'Slow, high renovation',
    name_es: 'Lenta, renovación alta'
}, {
    id: 4,
    name_ca: 'Lenta, renovació escassa',
    name_en: 'Slow, poor renovation',
    name_es: 'Lenta, renovación escasa'
}]);

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Desconeguda',
    name_es: 'Desconocida',
    name_en: 'Unknown'
}, {
    id: 9,
    name_ca: 'Alumini',
    name_es: 'Aluminio',
    name_en: 'Aluminum'
}, {
    id: 2,
    name_ca: 'Alumini blanc',
    name_es: 'Aluminio blanco',
    name_en: 'Aluminum white'
}, {
    id: 3,
    name_ca: 'Alumini bronze',
    name_es: 'Aluminio bronce',
    name_en: 'Aluminum bronze'
}, {
    id: 4,
    name_ca: 'Alumini natural',
    name_es: 'Aluminio natural',
    name_en: 'Aluminum natural'
}, {
    id: 5,
    name_ca: 'Fusta pintada',
    name_es: 'Madera pintada',
    name_en: 'Wood, painted'
}, {
    id: 6,
    name_ca: 'Fusta envernissada',
    name_es: 'Madera barnizada',
    name_en: 'Wood, barnished'
}, {
    id: 10,
    name_ca: 'Doble fusteria alumini i fusta',
    name_es: 'Doble carpintería aluminio y madera',
    name_en: 'Double window aluminum and wood'
}, {
    id: 7,
    name_ca: 'Acer',
    name_es: 'Acero',
    name_en: 'Steel'
}, {
    id: 8,
    name_ca: 'PVC (Policlorur de Vinil)',
    name_es: 'PVC (Policloruro de Vinilo)',
    name_en: 'PVC (Polyvinylchloride)'
}]);

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Desconegut',
    name_es: 'Desconocido',
    name_en: 'Unknown'
}, {
    id: 2,
    name_ca: 'Estucat monocapa',
    name_es: 'Estucado monocapa',
    name_en: 'Stucco, monolayer'
}, {
    id: 3,
    name_ca: 'Estucat venecià',
    name_es: 'Estucado veneciano',
    name_en: 'Venetian stucco'
}, {
    id: 4,
    name_ca: 'Arrebossat i pintat',
    name_es: 'Rebozado y pintado',
    name_en: 'Coated and painted'
}, {
    id: 5,
    name_ca: 'Acabat pintat',
    name_es: 'Acabado pintado',
    name_en: 'Painted'
}, {
    id: 6,
    name_ca: 'Maó obra vista',
    name_es: 'Ladrillo obra vista',
    name_en: 'Brickwork'
}, {
    id: 7,
    name_ca: 'Formigó',
    name_es: 'Hormigón',
    name_en: 'Concrete'
}, {
    id: 8,
    name_ca: 'Pedra',
    name_es: 'Piedra',
    name_en: 'Stone'
}, {
    id: 9,
    name_ca: 'Panells de formigó reforçats amb fibra de vidre (GRC)',
    name_es: 'Paneles de hormigón reforzados con fibra de vidrio (GRC)',
    name_en: 'Glass fiber Reinforced Concrete panels'
}, {
    id: 10,
    name_ca: 'Xapa ondulada d\'alumini',
    name_es: 'Chapa ondulada de aluminio',
    name_en: 'Corrugated aluminum sheet'
}, {
    id: 11,
    name_ca: 'Bloc de formigó',
    name_es: 'Bloque de hormigón',
    name_en: 'Concrete block'
}, {
    id: 12,
    name_ca: 'Policarbonat',
    name_es: 'Policarbonato',
    name_en: 'Polycarbonate'
}, {
    id: 13,
    name_ca: 'Termoargila vista',
    name_es: 'Termoarcilla vista',
    name_en: 'Thermoclay'
}]);

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Desconeguda',
    name_es: 'Desconocida',
    name_en: 'Unknown'
}, {
    id: 2,
    name_ca: 'Superficial',
    name_es: 'Superficial',
    name_en: 'Shallow'
}, {
    id: 3,
    name_ca: 'Formigó ciclopi',
    name_es: 'Hormigón ciclópeo',
    name_en: 'Cyclopean'
}, {
    id: 4,
    name_ca: 'Formigó armat',
    name_es: 'Hormigón armado',
    name_en: 'Reinforced concrete'
}, {
    id: 5,
    name_ca: 'Correguda',
    name_es: 'Corrida',
    name_en: 'Linear'
}, {
    id: 6,
    name_ca: 'Sabates',
    name_es: 'Zapatas',
    name_en: 'Footings'
}, {
    id: 7,
    name_ca: 'Flotant',
    name_es: 'Flotante',
    name_en: 'Floating'
}, {
    id: 8,
    name_ca: 'Profunda',
    name_es: 'Profunda',
    name_en: 'Deep'
}, {
    id: 9,
    name_ca: 'Pilotis',
    name_es: 'Pilotis',
    name_en: 'Pile foundation'
}]);

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Desconeguda',
    name_es: 'Desconocida',
    name_en: 'Unknown'
}, {
    id: 2,
    name_ca: 'Cap',
    name_es: 'Ninguno',
    name_en: 'None'
}, {
    id: 3,
    name_ca: 'Simple',
    name_es: 'Simple',
    name_en: 'Simple glazing'
}, {
    id: 4,
    name_ca: 'Doble',
    name_es: 'Doble',
    name_en: 'Double glazing'
}, {
    id: 5,
    name_ca: 'Doble amb càmera',
    name_es: 'Doble con cámara',
    name_en: 'Double glazing with camera'
}, {
    id: 6,
    name_ca: 'Triple amb doble càmera',
    name_es: 'Triple con doble cámara',
    name_en: 'Triple glazing with double camera'
}]);

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Edificació entre mitgeres',
    name_en: 'Terraced buildings',
    name_es: 'Edificación entre medianeras'
}, {
    id: 2,
    name_ca: 'Edificació aïllada',
    name_en: 'Detached buildings',
    name_es: 'Edificación aislada'
}, {
    id: 3,
    name_ca: 'Edificació segons volumetria específica',
    name_en: 'Buildings according to specific volumetry',
    name_es: 'Edificación según volumetría específica'
}, {
    id: 4,
    name_ca: 'Edificació seguint alineació de vial',
    name_en: 'Buildings following road alignment',
    name_es: 'Edificación siguiendo alineación de vial'
}]);

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Desconeguda',
    name_es: 'Desconocida',
    name_en: 'Unknown'
}, {
    id: 2,
    name_ca: 'Cap',
    name_es: 'Ninguno',
    name_en: 'None'
}, {
    id: 9,
    name_ca: 'Sí',
    name_es: 'Sí',
    name_en: 'Yes'
}, {
    id: 3,
    name_ca: 'Poliestirè extruït',
    name_es: 'Poliestireno extruido',
    name_en: 'Extruded Polystyrene'
}, {
    id: 4,
    name_ca: 'Poliestirè expandit',
    name_es: 'Poliestireno expandido',
    name_en: 'Expanded polystyrene'
}, {
    id: 5,
    name_ca: 'Llana de roca',
    name_es: 'Lana de roca',
    name_en: 'Rockwool'
}, {
    id: 6,
    name_ca: 'Llana de vidre',
    name_es: 'Lana de vidrio',
    name_en: 'Glass wool'
}, {
    id: 7,
    name_ca: 'Poliuretà',
    name_es: 'Poliuretano',
    name_en: 'Polyurethane'
}, {
    id: 8,
    name_ca: 'Panell sàndvitx',
    name_es: 'Panel sándwich',
    name_en: 'Sandwich panel'
}]);

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Desconeguda',
    name_es: 'Desconocida',
    name_en: 'Unknown'
}, {
    id: 2,
    name_ca: 'Cap',
    name_es: 'Ninguno',
    name_en: 'None'
}, {
    id: 3,
    name_ca: 'Fusta vernissada',
    name_es: 'Madera barnizada',
    name_en: 'Varnished wood'
}, {
    id: 4,
    name_ca: 'Fusta pintada',
    name_es: 'Madera pintada',
    name_en: 'Painted wood'
}, {
    id: 5,
    name_ca: 'Alumini',
    name_es: 'Aluminio',
    name_en: 'Aluminum'
}, {
    id: 6,
    name_ca: 'Acer',
    name_es: 'Acero',
    name_en: 'Steel'
}, {
    id: 7,
    name_ca: 'PVC',
    name_es: 'PVC',
    name_en: 'PVC'
}, {
    id: 8,
    name_ca: 'Vidre',
    name_es: 'Vidrio',
    name_en: 'Glass'
}]);

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Bo',
    name_en: 'Good',
    name_es: 'Bueno'
}, {
    id: 1,
    name_ca: 'Mig',
    name_en: 'Average',
    name_es: 'Medio'
}, {
    id: 1,
    name_ca: 'Escàs',
    name_en: 'Poor',
    name_es: 'Escaso'
}, {
    id: 1,
    name_ca: 'Inexistent',
    name_en: 'Inexisting',
    name_es: 'Inexistente'
}]);

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Desconegut',
    name_es: 'Desconocido',
    name_en: 'Unknown'
}, {
    id: 2,
    name_ca: 'Baix',
    name_es: 'Bajo',
    name_en: 'Low'
}, {
    id: 3,
    name_ca: 'Mitjà',
    name_es: 'Medio',
    name_en: 'Average'
}, {
    id: 3,
    name_ca: 'Sorollós',
    name_es: 'Ruidoso',
    name_en: 'Noisy'
}, {
    id: 3,
    name_ca: 'Molt sorollós',
    name_es: 'Muy ruidoso',
    name_en: 'Very noisy'
}]);

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Desconeguda',
    name_es: 'Desconocida',
    name_en: 'Unknown'
}, {
    id: 2,
    name_ca: 'Nord',
    name_es: 'Norte',
    name_en: 'North'
}, {
    id: 3,
    name_ca: 'Nord-Est',
    name_es: 'Noreste',
    name_en: 'North-East'
}, {
    id: 4,
    name_ca: 'Est',
    name_es: 'Este',
    name_en: 'East'
}, {
    id: 5,
    name_ca: 'Sud-Est',
    name_es: 'Sureste',
    name_en: 'South-East'
}, {
    id: 6,
    name_ca: 'Sud',
    name_es: 'Sur',
    name_en: 'South'
}, {
    id: 7,
    name_ca: 'Sud-Oest',
    name_es: 'Suroeste',
    name_en: 'South-West'
}, {
    id: 8,
    name_ca: 'Oest',
    name_es: 'Oeste',
    name_en: 'West'
}, {
    id: 9,
    name_ca: 'Nord-Oest',
    name_es: 'Noroeste',
    name_en: 'Nort-West'
}]);

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Desconeguda',
    name_es: 'Desconocida',
    name_en: 'Unknown'
}, {
    id: 2,
    name_ca: 'Cap',
    name_es: 'Ninguno',
    name_en: 'None'
}, {
    id: 39,
    name_ca: 'Parquet',
    name_es: 'Parquet',
    name_en: 'Parquet'
}, {
    id: 3,
    name_ca: 'Parquet de fusta natural',
    name_es: 'Parquet de madera natural',
    name_en: 'Natural wood flooring'
}, {
    id: 4,
    name_ca: 'Parquet sintètic',
    name_es: 'Parquet sintétco',
    name_en: 'Synthetic wood flooring'
}, {
    id: 5,
    name_ca: 'Terratzo continu',
    name_es: 'Terrazo continuo',
    name_en: 'Continuous terrazzo'
}, {
    id: 6,
    name_ca: 'Rajoles de terratzo',
    name_es: 'Baldosas de terrazo',
    name_en: 'Terrazo tiles'
}, {
    id: 7,
    name_ca: 'Rajola ceràmica',
    name_es: 'Baldosa cerámica',
    name_en: 'Ceramic tile'
}, {
    id: 8,
    name_ca: 'Rajola de gres extruït esmaltat',
    name_es: 'Baldosa de gres extruido esmaltado',
    name_en: 'Glazed extruded stoneware tile'
}, {
    id: 9,
    name_ca: 'Rajola de gres extruït sense esmaltar',
    name_es: 'Baldosa de gres extruido sin esmaltar',
    name_en: 'Unglazed extruded stoneware tile'
}, {
    id: 10,
    name_ca: 'Rajola de gres porcelànic',
    name_es: 'Baldosa de gres porcelánico',
    name_en: 'Porcelain stoneware tile'
}, {
    id: 11,
    name_ca: 'Rajola de gres premsat esmaltat',
    name_es: 'Baldosa de gres prensado esmaltado',
    name_en: 'Pressed glazed stoneware tile'
}, {
    id: 12,
    name_ca: 'Rajola hidràulica',
    name_es: 'Baldosa hidráulica',
    name_en: 'Hydraulic tile'
}, {
    id: 13,
    name_ca: 'Panot',
    name_es: 'Panot',
    name_en: 'Panot'
}, {
    id: 14,
    name_ca: 'Rajola de gres',
    name_es: 'Baldosa de gres',
    name_en: 'Stoneware tile'
}, {
    id: 15,
    name_ca: 'Formigó',
    name_es: 'Hormigón',
    name_en: 'Concrete'
}, {
    id: 16,
    name_ca: 'Peces de formigó',
    name_es: 'Piezas de hormigón',
    name_en: 'Concrete pieces'
}, {
    id: 17,
    name_ca: 'Microciment',
    name_es: 'Microcemeento',
    name_en: 'Microcement'
}, {
    id: 18,
    name_ca: 'Morter continu',
    name_es: 'Mortero continuo',
    name_en: 'Continous mortar'
}, {
    id: 19,
    name_ca: 'Llosetes de suro',
    name_es: 'Losetas de corcho',
    name_en: 'Cork tiles'
}, {
    id: 20,
    name_ca: 'Continu de resines',
    name_es: 'Continuo de resinas',
    name_en: 'Continuous resin'
}, {
    id: 21,
    name_ca: 'Linoleum',
    name_es: 'Linoleum',
    name_en: 'Linoleum'
}, {
    id: 22,
    name_ca: 'Goma bicapa',
    name_es: 'Goma bicapa',
    name_en: 'Bilayer rubber'
}, {
    id: 23,
    name_ca: 'Cautxú reciclat',
    name_es: 'Caucho reciclado',
    name_en: 'Recycled rubber'
}, {
    id: 24,
    name_ca: 'Flotant de pvc',
    name_es: 'Flotante de pvc',
    name_en: 'Floating pvc'
}, {
    id: 25,
    name_ca: 'Entramat sintètic',
    name_es: 'Entramado sintético',
    name_en: 'Synthetic fabric'
}, {
    id: 26,
    name_ca: 'PVC homogeni',
    name_es: 'PVC homogéneo',
    name_en: 'Homogeneous PVC'
}, {
    id: 27,
    name_ca: 'PVC heterogeni',
    name_es: 'PVC heterogéneo',
    name_en: 'Heterogeneous PVC'
}, {
    id: 28,
    name_ca: 'Composite de fusta i plàstic',
    name_es: 'Composite de madera y plástico',
    name_en: 'Wood and plastic composite'
}, {
    id: 29,
    name_ca: 'Moqueta de llana',
    name_es: 'Moqueta de lana',
    name_en: 'Wool carpet'
}, {
    id: 30,
    name_ca: 'Moqueta de fibres sintètiques',
    name_es: 'Moqueta de fibras sintéticas',
    name_en: 'Carpet fibers'
}, {
    id: 31,
    name_ca: 'Entramat metàl·lic',
    name_es: 'Entramado metálico',
    name_en: 'Metal lattice'
}, {
    id: 32,
    name_ca: 'Planxa d\'acer galvanitzat',
    name_es: 'Plancha de acero galvanizado',
    name_en: 'Galvanized steel plate'
}, {
    id: 33,
    name_ca: 'Paviment tècnic per a interiors',
    name_es: 'Pavimento técnico para interiores',
    name_en: 'Technical flooring'
}, {
    id: 34,
    name_ca: 'Pedra natural',
    name_es: 'Piedra natural',
    name_en: 'Natural stone'
}, {
    id: 35,
    name_ca: 'Marbre',
    name_es: 'Mármol',
    name_en: 'Marble'
}, {
    id: 36,
    name_ca: 'Granit',
    name_es: 'Granito',
    name_en: 'Granite'
}, {
    id: 37,
    name_ca: 'Pissarra',
    name_es: 'Pizarra',
    name_en: 'Slate'
}, {
    id: 38,
    name_ca: 'Rajola ceràmica vermella',
    name_es: 'Baldosa cerámica roja',
    name_en: 'Red ceramic tile'
}, {
    id: 40,
    name_ca: 'Gresite',
    name_es: 'Gresite',
    name_en: 'Gresite'
}]);

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Obra nova',
    name_en: 'New construction',
    name_es: 'Obra nueva'
}, {
    id: 2,
    name_ca: 'Rehabilitació',
    name_en: 'Renovation',
    name_es: 'Rehabilitación'
}]);

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Règim general',
    name_en: 'General regime',
    name_es: 'Régimen general'
}, {
    id: 2,
    name_ca: 'Règim especial',
    name_en: 'Special regime',
    name_es: 'Régimen especial'
}, {
    id: 3,
    name_ca: 'Preu concertat',
    name_en: 'Agreed price',
    name_es: 'Precio concertado'
}]);

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Expedients anteriors a 1969. Actualment amb preu de venta lliure',
    name_en: 'Files prior to 1969. Currently with free market sale price',
    name_es: 'Expedientes anteriores a 1969. Actualment con precio de venta libre'
}, {
    id: 2,
    name_ca: 'Expedients de 1969 a 1978',
    name_en: 'Files from 1969 to 1978',
    name_es: 'Expedientes de 1969 a 1978'
}, {
    id: 3,
    name_ca: 'Expedients de 1979 a 2001',
    name_en: 'Files from 1979 to 2001',
    name_es: 'Expedientes de 1979 a 2001'
}, {
    id: 3,
    name_ca: 'Expedients de 2002 i posteriors',
    name_en: 'Files from 2002 and afterwards',
    name_es: 'Expedientes de 2002 y posteriores'
}]);

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Zona A',
    name_en: 'Zone A',
    name_es: 'Zona A'
}, {
    id: 1,
    name_ca: 'Zona B',
    name_en: 'Zone B',
    name_es: 'Zona B'
}, {
    id: 1,
    name_ca: 'Zona C',
    name_en: 'Zone C',
    name_es: 'Zona C'
}, {
    id: 1,
    name_ca: 'Zona D',
    name_en: 'Zone D',
    name_es: 'Zona D'
}]);

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Molt alt',
    name_en: 'Very high',
    name_es: 'Muy alto'
}, {
    id: 2,
    name_ca: 'Alt',
    name_en: 'High',
    name_es: 'Alto'
}, {
    id: 3,
    name_ca: 'Mitjà-alt',
    name_en: 'Medium-high',
    name_es: 'Medio alto'
}, {
    id: 4,
    name_ca: 'Mitjà',
    name_en: 'Medium',
    name_es: 'Medio'
}, {
    id: 5,
    name_ca: 'Mitjà-baix',
    name_en: 'Medium-low',
    name_es: 'Medio bajo'
}, {
    id: 6,
    name_ca: 'Baix',
    name_en: 'Low',
    name_es: 'Bajo'
}, {
    id: 7,
    name_ca: 'Molt baix',
    name_en: 'Very low',
    name_es: 'Muy bajo'
}]);

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Molt alta',
    name_en: 'Very high',
    name_es: 'Muy alta'
}, {
    id: 2,
    name_ca: 'Alta',
    name_en: 'High',
    name_es: 'Alta'
}, {
    id: 3,
    name_ca: 'Mitjana-alta',
    name_en: 'Medium-high',
    name_es: 'Media alta'
}, {
    id: 4,
    name_ca: 'Mitjana',
    name_en: 'Medium',
    name_es: 'Media'
}, {
    id: 5,
    name_ca: 'Mitjana-baixa',
    name_en: 'Medium-low',
    name_es: 'Media baja'
}, {
    id: 6,
    name_ca: 'Baixa',
    name_en: 'Low',
    name_es: 'Baja'
}, {
    id: 7,
    name_ca: 'Molt baixa',
    name_en: 'Very low',
    name_es: 'Muy baja'
}]);

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: "Nom, NIF i adreça del sol·licitant",
    name_es: "Nombre, NIF y dirección del solicitante",
    name_en: "Petitioner details: Name, tax identification number, ID and address"
}, {
    id: 2,
    name_ca: "Nom, NIF i adreça fiscal per a la factura",
    name_es: "Nombre, NIF y dirección fiscal para la factura",
    name_en: "Invoice details: Name, tax identification number and fiscal address"
}, {
    id: 3,
    name_ca: "Còpia completa de l'escriptura o de la nota registral",
    name_es: "Copia completa de la escritura o de la nota registral",
    name_en: "Full copy of the property deed or registration note"
}, {
    id: 4,
    name_ca: "Còpia de rebut de l'I.B.I. (Dades Cadastrals) (Opcional)",
    name_es: "Copia de recibo del I.B.I. (Datos Cadastrales) (Opcional)",
    name_en: "Property tax payment receipt copy (Cadastral data) (Optional)"
}, {
    id: 5,
    name_ca: "Plànol de la finca (Opcional)",
    name_es: "Plano de la finca (Opcional)",
    name_en: "Plan of the property (Optional)"
}, {
    id: 6,
    name_ca: "Còpia del contracte de lloguer i un rebut actualitzat (en el cas d'estar llogat)",
    name_es: "Copia del contrato de alquiler y un recibo actualizado (en el caso de estar alquilado)",
    name_en: "Full copy of the rental contract and an updated receipt (in the event of being rented)"
}, {
    id: 7,
    name_ca: "Finalitat de la taxació (adquisició o venda, constituir garanties hipotecàries, expropiació,...)",
    name_es: "Finalidad de la tasación (adquisición o venta, constituir garantías hipotecarias, expropiación... )",
    name_en: "Valuation purpose (Acquisition or sale, to provide mortgage guarantees, expropiation...)"
}, {
    id: 8,
    name_ca: "Nom i telèfon de la persona de contacte per a visitar la finca",
    name_es: "Nombre y teléfono de la persona de contacto para visitar la finca",
    name_en: "Name and telephone number of the contact person in order to visit the property"
}, {
    id: 9,
    name_ca: "Còpia del projecte visat pel Col·legi d'Arquitectes",
    name_es: "Copia del proyecto visado por el Colegio de Arquitectos",
    name_en: "Copy of the project validated by the Architects Professional Association"
}, {
    id: 10,
    name_ca: "Llicència d'obres, contracte d'execució d'obres i pressupost de contracte d'obra",
    name_es: "Licencia de obras, contrato de ejecución de obras y presupuesto de contrato de obra",
    name_en: "Construction license, construction contract and construction budget"
}, {
    id: 11,
    name_ca: "En el cas d'ésser Habitatge de Protecció Oficial: cèdula de qualificació provisional",
    name_es: "En el caso de ser Vivienda de Protección Oficial: cédula de calificación provisional",
    name_en: "In the case of being a Subsidized Dwelling: provisional qualification card"
}, {
    id: 12,
    name_ca: "Document acreditatiu de l'assegurança decennal",
    name_es: "Documento acreditativo del seguro decenal",
    name_en: "Decennial insurance proving document"
}, {
    id: 13,
    name_ca: "Darrera certificació d'obra executada",
    name_es: "Última certificación de obra ejecutada",
    name_en: "Last certification of executed construction"
}, {
    id: 14,
    name_ca: "Cèdul·la urbanística o certificat municipal de qualificació urbanística",
    name_es: "Cédula urbanística o certificado municipal de calificación urbanística",
    name_en: "Certificate of urban planning qualification"
}]);

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Desconeguda',
    name_es: 'Desconocida',
    name_en: 'Unknown'
}, {
    id: 2,
    name_ca: 'Plana transitable',
    name_es: 'Plana transitable',
    name_en: 'Flat and transitable'
}, {
    id: 3,
    name_ca: 'Plana no transitable',
    name_es: 'Plana no transitable',
    name_en: 'Flat, not transitable'
}, {
    id: 4,
    name_ca: 'Inclinada de pissarra',
    name_es: 'Inclinada de pizarra',
    name_en: 'Pitched, slate'
}, {
    id: 4,
    name_ca: 'Inclinada de zinc',
    name_es: 'Inclinada de zinc',
    name_en: 'Pitched, zinc'
}, {
    id: 5,
    name_ca: 'Inclinada de teula',
    name_es: 'Inclinada de teja',
    name_en: 'Pitched, tile'
}, {
    id: 6,
    name_ca: 'Part plana, part teula',
    name_es: 'Parte plana, parte teja',
    name_en: 'partially flat, partially pitched, with tile'
}, {
    id: 7,
    name_ca: 'Panell sandvitx',
    name_es: 'Panel Sándwich',
    name_en: 'Sandwich panel'
}, {
    id: 8,
    name_ca: 'Enjardinada',
    name_es: 'Ajardinada',
    name_en: 'Gardened'
}]);

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    level: 1,
    progress_coef: 0.166,
    name_ca: '1/6 - Esperant la firma del Supervisor Comercial',
    name_es: '1/6 - Esperando la firma del Supervisor Comercial',
    name_en: '1/6 - Waiting to be signed by the Commercial Supervisor'
}, {
    id: 2,
    level: 2,
    progress_coef: 0.333,
    name_ca: '2/6 - Firmat pel Supervisor Comercial, falta l\'aprovació del Supervisor Tècnic',
    name_es: '2/6 - Firmado por el Supervisor Comercial, falta la aprobación del Supervisor Técnico',
    name_en: '2/6 - Signed by the Commercial Supervisor, needs to be approved by the Technical Supervisor'
}, {
    id: 3,
    level: 3,
    progress_coef: 0.5,
    name_ca: '3/6 - Firmat, llest per enviar al client',
    name_es: '3/6 - Firmado, listo para enviar al cliente',
    name_en: '3/6 - Signed, ready to be sent to the client'
}, {
    id: 4,
    level: 4,
    progress_coef: 0.666,
    name_ca: '4/6 - Enviat al client, esperant la seva acceptació',
    name_es: '4/6 - Enviado al cliente, esperando su aceptación',
    name_en: '4/6 - Sent to client, waiting for acceptance'
}, {
    id: 5,
    level: 5,
    progress_coef: 0.833,
    name_ca: '5/6 - Acceptat pel client, falta el cobrament de la provisió de fons',
    name_es: '5/6 - Aceptado por el cliente, falta el cobro de la provisión de fondos',
    name_en: '5/6 - Accepted by client, funds not paid yet'
}, {
    id: 6,
    level: 6,
    progress_coef: 1,
    name_ca: '6/6 - Acceptat i provisió de fons cobrada',
    name_es: '6/6 - Aceptado y provisión de fondos cobrada',
    name_en: '6/6 - Accepted and funds payed'
}]);

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    level: 1,
    progress_coef: 0.166,
    name_ca: '1/6 - Esperant la firma del Supervisor Comercial',
    name_es: '1/6 - Esperando la firma del Supervisor Comercial',
    name_en: '1/6 - Waiting to be signed by the Commercial Supervisor'
}, {
    id: 2,
    level: 2,
    progress_coef: 0.333,
    name_ca: '2/6 - Firmat pel Supervisor Comercial, falta l\'aprovació del Supervisor Tècnic',
    name_es: '2/6 - Firmado por el Supervisor Comercial, falta la aprobación del Supervisor Técnico',
    name_en: '2/6 - Signed by the Commercial Supervisor, needs to be approved by the Technical Supervisor'
}, {
    id: 3,
    level: 3,
    progress_coef: 0.5,
    name_ca: '3/6 - Firmat, llest per enviar al client',
    name_es: '3/6 - Firmado, listo para enviar al cliente',
    name_en: '3/6 - Signed, ready to be sent to the client'
}, {
    id: 4,
    level: 4,
    progress_coef: 0.666,
    name_ca: '4/6 - Enviat al client, esperant la seva acceptació',
    name_es: '4/6 - Enviado al cliente, esperando su aceptación',
    name_en: '4/6 - Sent to client, waiting for acceptance'
}, {
    id: 5,
    level: 5,
    progress_coef: 0.833,
    name_ca: '5/6 - Acceptat pel client, falta el cobrament de la provisió de fons',
    name_es: '5/6 - Aceptado por el cliente, falta el cobro de la provisión de fondos',
    name_en: '5/6 - Accepted by client, waiting for provision funds'
}, {
    id: 6,
    level: 6,
    progress_coef: 1,
    name_ca: '6/6 - Acceptat i provisió de fons cobrada',
    name_es: '6/6 - Aceptado y provisión de fondos cobrada',
    name_en: '6/6 - Accepted and funds payed'
}]);

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    level: 1,
    progress_coef: 0.166,
    name_ca: '1/6 - Esperant la firma del Taxador',
    name_es: '1/6 - Esperando la firma del Tasador',
    name_en: '1/6 - Needs to be signed by the Appraiser'
}, {
    id: 2,
    level: 2,
    progress_coef: 0.333,
    name_ca: '2/6 - Firmat pel Taxador, falta la firma del Supervisor Tècnic',
    name_es: '2/6 - Firmado por el Tasador, falta la firma del Supervisor Técnico',
    name_en: '2/6 - Signed by CFO, needs to be signed by the Technical Supervisor'
}, {
    id: 3,
    level: 3,
    progress_coef: 0.5,
    name_ca: '3/6 - Firmat, falta enviar factura al client',
    name_es: '3/6 - Firmado, falta enviar factura al cliente',
    name_en: '3/6 - Signed, client needs to be notified to pay'
}, {
    id: 4,
    level: 4,
    progress_coef: 0.666,
    name_ca: '4/6 - Client notificat, falta el pagament de la factura',
    name_es: '4/6 - Cliente notificado, falta el pago de la factura',
    name_en: '4/6 - Client notified, waiting for the invoice payment'
}, {
    id: 5,
    level: 5,
    progress_coef: 0.833,
    name_ca: '5/6 - Factura pagada, falta enviar al client',
    name_es: '5/6 - Factura pagada, falta enviar al cliente',
    name_en: '5/6 - Invoice payed, needs to be sent to client'
}, {
    id: 6,
    level: 6,
    progress_coef: 1,
    name_ca: '6/6 - Pagat i enviat al client',
    name_es: '6/6 - Pagado y enviado al cliente',
    name_en: '6/6 - Payed and sent to client'
}]);

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Desconeguda',
    name_es: 'Desconocida',
    name_en: 'Unknown'
}, {
    id: 2,
    name_ca: 'Formigó armat',
    name_es: 'Hormigón armado',
    name_en: 'Reinforced Concrete'
}, {
    id: 3,
    name_ca: 'Murs de càrrega',
    name_es: 'Muros de carga',
    name_en: 'Bearing walls'
}, {
    id: 4,
    name_ca: 'Metàl·lica',
    name_es: 'Metálica',
    name_en: 'Metal'
}]);

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Curt termini',
    name_es: 'Corto plazo',
    name_en: 'Short term'
}, {
    id: 2,
    name_ca: 'Mig termini',
    name_es: 'Medio plazo',
    name_en: 'Medium term'
}, {
    id: 3,
    name_ca: 'Llarg termini',
    name_es: 'Largo plazo',
    name_en: 'Long term'
}]);

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Urbà',
    name_en: 'Urban',
    name_es: 'Urbano'
}, {
    id: 2,
    name_ca: 'Suburbà',
    name_en: 'Suburban',
    name_es: 'Suburbano'
}, {
    id: 3,
    name_ca: 'Rural',
    name_en: 'Rural',
    name_es: 'Rural'
}]);

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Tendència a l\'alça',
    name_es: 'Tendencia al alza',
    name_en: 'Upward trend'
}, {
    id: 2,
    name_ca: 'Tendència a l\'alça moderada',
    name_es: 'Tendencia al alza moderada',
    name_en: 'Moderate upward trend'
}, {
    id: 3,
    name_ca: 'Tendència a mantenir-se estable',
    name_es: 'Tendencia a mantenerse estable',
    name_en: 'to remain stable'
}, {
    id: 4,
    name_ca: 'Tendència a la baixa moderada',
    name_es: 'Tendencia a la baja moderada',
    name_en: 'Moderate downward trend'
}, {
    id: 5,
    name_ca: 'Tendència a la baixa',
    name_es: 'Tendencia a la baja',
    name_en: 'Downward trend'
}]);

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Habitatges',
    name_en: 'Housing',
    name_es: 'Viviendas'
}, {
    id: 2,
    name_ca: 'Oficines',
    name_en: 'Offices',
    name_es: 'Oficinas'
}, {
    id: 3,
    name_ca: 'Comercial',
    name_en: 'Retail',
    name_es: 'Comercial'
}, {
    id: 4,
    name_ca: 'Industrial',
    name_en: 'Industrial',
    name_es: 'Industrial'
}, {
    id: 5,
    name_ca: 'Aparcament',
    name_en: 'Parking',
    name_es: 'Aparcamiento'
}, {
    id: 6,
    name_ca: 'Trasters',
    name_en: 'Storage',
    name_es: 'Trasteros'
}, {
    id: 7,
    name_ca: 'Esportiu',
    name_en: 'Sports',
    name_es: 'Deportivo'
}, {
    id: 8,
    name_ca: 'Educacional',
    name_en: 'Educational',
    name_es: 'Educacional'
}, {
    id: 9,
    name_ca: 'Hoteler',
    name_en: 'Hoteler',
    name_es: 'Hoteler'
}, {
    id: 10,
    name_ca: 'Ús mixt',
    name_en: 'Mixed use',
    name_es: 'Úso mixto'
}]);

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Habitatge',
    name_en: 'Housing',
    name_es: 'Vivienda',
    bde_code: 'V'
}, {
    id: 2,
    name_ca: 'Oficina',
    name_en: 'Office',
    name_es: 'Oficina',
    bde_code: 'L'
}, {
    id: 3,
    name_ca: 'Altres',
    name_en: 'Others',
    name_es: 'Otros',
    bde_code: 'O'
}]);

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Desconeguda',
    name_es: 'Desconocida',
    name_en: 'Unknown'
}, {
    id: 2,
    name_ca: 'A carrer',
    name_es: 'A calle',
    name_en: 'To the street'
}, {
    id: 3,
    name_ca: 'A pati interior',
    name_es: 'A patio interior',
    name_en: 'Interior courtyard'
}, {
    id: 4,
    name_ca: 'A interior d\'illa',
    name_es: 'Interior de manzana',
    name_en: 'Block interior'
}, {
    id: 5,
    name_ca: 'A parc',
    name_es: 'A parque',
    name_en: 'To the park'
}, {
    id: 6,
    name_ca: 'A jardí',
    name_es: 'A jardín',
    name_en: 'To the garden'
}, {
    id: 7,
    name_ca: 'A mar',
    name_es: 'Al mar',
    name_en: 'To the sea'
}, {
    id: 8,
    name_ca: 'A muntanya',
    name_es: 'A la montaña',
    name_en: 'To the mountain'
}, {
    id: 9,
    name_ca: 'A camp',
    name_es: 'Al campo',
    name_en: 'To the countryside'
}, {
    id: 10,
    name_ca: 'Bones',
    name_es: 'Buenas',
    name_en: 'Good'
}, {
    id: 10,
    name_ca: 'No gaire bones',
    name_es: 'No muy buenas',
    name_en: 'Poor'
}]);

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'No significativa',
    name_es: 'No significativa',
    name_en: 'Non significant'
}, {
    id: 2,
    name_ca: 'Significativa',
    name_es: 'Significativa',
    name_en: 'Significant'
}]);

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Desconeguda',
    name_es: 'Desconocida',
    name_en: 'Unknown'
}, {
    id: 2,
    name_ca: 'Cap',
    name_es: 'Ninguno',
    name_en: 'None'
}, {
    id: 3,
    name_ca: 'Pintat',
    name_es: 'Pintado',
    name_en: 'Painted'
}, {
    id: 4,
    name_ca: 'Enguixat i pintat',
    name_es: 'Enyesado y pintado',
    name_en: 'Plastered and painted'
}, {
    id: 5,
    name_ca: 'Rajola ceràmica esmaltada',
    name_es: 'Baldosa cerámica esmaltada',
    name_en: 'Glazed ceramic tile'
}, {
    id: 6,
    name_ca: 'Rajola ceràmica natural',
    name_es: 'Baldosa cerámica natural',
    name_en: 'Ceramic tile'
}, {
    id: 7,
    name_ca: 'Rajola de gres porcellànic',
    name_es: 'Baldosa de gres porcelánico',
    name_en: 'Porcelain stoneware tile'
}, {
    id: 8,
    name_ca: 'Rajola de gres extruït sense esmaltar',
    name_es: 'Baldosa de gres extruido sin esmaltar',
    name_en: 'Unglazed extruded stoneware tile'
}, {
    id: 9,
    name_ca: 'Rajola de gres extruït esmaltada',
    name_es: 'Baldosa de gres extruido esmaltada',
    name_en: 'Glazed extruded stoneware tile'
}, {
    id: 10,
    name_ca: 'Rajola de gres premsat esmaltat',
    name_es: 'Baldosa de gres prensado esmaltado',
    name_en: 'Glazed pressed stoneware tile'
}, {
    id: 11,
    name_ca: 'Rajola de gres porcellànic',
    name_es: 'Baldosa de gres porcelánico',
    name_en: 'Porcelain stoneware tile'
}, {
    id: 12,
    name_ca: 'Arrebossat',
    name_es: 'Rebozado',
    name_en: 'Coated'
}, {
    id: 13,
    name_ca: 'Estucat',
    name_es: 'Estucado',
    name_en: 'Coated'
}, {
    id: 14,
    name_ca: 'Aplacat de fusta natural',
    name_es: 'Aplacado de madera natural',
    name_en: 'Natural wood paneling'
}, {
    id: 15,
    name_ca: 'Aplacat amb plaques sintètiques',
    name_es: 'Aplacado con placas sintéticas',
    name_en: 'Synthetic paneling'
}, {
    id: 16,
    name_ca: 'Obra vista',
    name_es: 'Obra vista',
    name_en: 'Brickwork'
}, {
    id: 17,
    name_ca: 'Gresite',
    name_es: 'Gresite',
    name_en: 'Gresite'
}]);

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    id: 1,
    name_ca: 'Desconegut',
    name_es: 'Desconocido',
    name_en: 'Unknown'
}, {
    id: 2,
    name_ca: 'Adients',
    name_es: 'Adecuadas',
    name_en: 'Suitable'
}, {
    id: 3,
    name_ca: 'Insuficients',
    name_es: 'Insuficientes',
    name_en: 'Insufficient'
}]);

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_proj4__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__maps_api__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__functions_global_functions__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }











var default_state = {
    cadastral_reference: null,
    census_section_code: null,
    country: {
        iso_3166_alpha2_code: 'ES',
        name_en: 'Spain'
    },
    description: null,
    door: null,
    floor: null,
    geohash: null,
    google_formatted_address: null,
    google_viewport: null,
    lat: null,
    lng: null,
    municipality: null,
    postal_code: null,
    province: null,
    staircase: null,
    street_name: null,
    street_number: null,
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    path: null,
    parent_path: null,

    cadastral_area: null,
    registry_idufir: null,
    ad_date: null,
    ad_type: null,
    ad_year: null,
    adopted_area: null,
    adopted_age: null,
    air_conditioning: null,
    bathrooms_number: null,
    bedrooms_number: null,
    covered_outdoor_area: null,
    uncovered_outdoor_area: null,
    construction_year: null,
    dwelling_type: null,
    estimated_sale_price: null,
    external_storage_room: null,
    floor_number: null,
    floor_type: null,
    green_areas: null,
    heating: null,
    last_renovation_year: null,
    lift: null,
    offer_price: null,
    parking_lots_number: null,
    quality_of_neighbourhood: null,
    quality_of_situation: null,
    quality_of_construction: null,
    quality_of_realestate: null,
    sports_facilities: null,
    swimming_pool: null,

    ad_address: null,
    built_area: null,
    capture_date: null,
    ad_data_type: null,
    ad_code: null,
    interior_visit_check: null,
    land_area: null,
    net_area: null,
    cadastral_data_check: null,
    contact_telephone: null,
    notes_1: null,
    notes_2: null,
    orientation: null,
    property_type: null,
    source: null,
    url: null,

    block: null,
    contact_name: null,
    offer_unit_price: null,
    conservation_status: null,

    offer_price_reduction_pct: 0.05,
    estimated_unit_sale_price: null

};

var state = default_state;

var actions = {

    CREATE_NEW_AD: function CREATE_NEW_AD(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        // 1- crear un new ad en un lloc temporal i quan s'editi es puja al lloc que li toca.

        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].create({ path: data.path }).then(function (res) {
                var new_created_key = res.key;

                commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_993" /* SET_AD_ID */], new_created_key);
                commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_994" /* SET_AD_DATE_CREATED */], res.date_created);
                commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_995" /* SET_AD_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_996" /* SET_AD_PATH */], res.path);

                __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].set_value({
                    value: new_created_key,
                    path: data.path + new_created_key + '/' + 'id',
                    save_timestamp: false
                }).then(function (res) {
                    resolve({ key: new_created_key });
                });
            });
        });
    },
    DELETE_AD: function DELETE_AD(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;


        console.log('path check: ' + data.path);
        console.log('parent_path check: ' + data.parent_path);

        // delete from contact_addresses/contact_key
        __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].delete({ key: data.key, path: data.path }).then(function (res) {

            // delete from contact/contact_key/ads
            __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].delete({ key: data.key, path: data.parent_path + '/' + data.key }).then(function (res) {
                commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_997" /* RESET_AD */]);
            });
        });
    },
    SET_AD: function SET_AD(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;


        // console.log('SET_AD data.path:')
        // console.log(data.path)
        return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            // console.log('ad.js api.get res:')
            // console.log(res)
            commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_998" /* SET_AD */], res);
        });
    },
    GEOLOCATE_AD: function GEOLOCATE_AD(_ref4, data) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;


        // console.log('--- geolocate_address data:')
        // console.log(data)
        // console.log('----------')
        return __WEBPACK_IMPORTED_MODULE_3__maps_api__["a" /* default */].geolocate(data).then(function (res) {
            console.log(res.results);
            var result = window.confirm(__WEBPACK_IMPORTED_MODULE_0_vue___default.a.i18n.translate('S\'ha trobat via Google la següent adreça: ') + res.formatted_address + '. S\'actualitzaran les dades de geolocalització segons aquesta adreça. És correcte?');

            if (result) {

                var new_lat = res.lat;
                var new_lng = res.lng;

                commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_999" /* SET_AD_GOOGLE_FORMATTED_ADDRESS */], res.formatted_address);
                commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1000" /* SET_AD_GOOGLE_VIEWPORT */], res.viewport);
                commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1001" /* SET_AD_LAT */], new_lat);
                commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1002" /* SET_AD_LNG */], new_lng);
                commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1003" /* SET_AD_POSTAL_CODE */], res.postal_code);
                commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1004" /* SET_AD_STREET_NAME */], res.street_name);
                commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1005" /* SET_AD_STREET_NUMBER */], res.street_number);

                var proj4_wgs84 = '+proj=longlat +datum=WGS84 +no_defs';
                var proj4_epsg25831 = '+proj=utm +zone=31 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ';

                var epsg25831_coords = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_proj4__["a" /* default */])(proj4_wgs84, proj4_epsg25831, [res.lng, res.lat]);
                // console.log('epsg25831_coords: ')
                // console.log(epsg25831_coords)
                commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1006" /* SET_AD_EPSG25831_X */], epsg25831_coords[0]);
                commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1007" /* SET_AD_EPSG25831_Y */], epsg25831_coords[1]);

                if (data.old_geohash) {

                    var old_location_path = 'ad_locations/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__functions_global_functions__["a" /* default */])(data.old_geohash, 1).join('/') + '/' + data.id;

                    console.log('old_location_path: ');
                    console.log(old_location_path);

                    __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].delete({ path: old_location_path }).then(function (res) {

                        __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getGeohash({ key: data.id, lat: new_lat, lng: new_lng }).then(function (res) {
                            // console.log('ad.js api.get res:')
                            // console.log(res)
                            var new_geohash = res.geohash;

                            var new_location_path = 'ad_locations/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__functions_global_functions__["a" /* default */])(new_geohash, 1).join('/');
                            var new_object = {};
                            new_object[data.id] = true;

                            __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].set_value({
                                value: new_object,
                                path: new_location_path,
                                save_timestamp: false
                            }).then(function (res) {
                                commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1008" /* SET_AD_GEOHASH */], new_geohash);
                            });
                        });
                    });
                } else {

                    __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getGeohash({ key: data.id, lat: res.lat, lng: res.lng }).then(function (res) {
                        // console.log('ad.js api.get res:')
                        // console.log(res)
                        var new_geohash = res.geohash;

                        var new_location_path = 'ad_locations/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__functions_global_functions__["a" /* default */])(new_geohash, 1).join('/');
                        var new_object = {};
                        new_object[data.id] = true;

                        __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].set_value({
                            value: new_object,
                            path: new_location_path,
                            save_timestamp: false
                        }).then(function (res) {
                            commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1008" /* SET_AD_GEOHASH */], new_geohash);
                        });
                    });
                }
            }
        });
    },
    REQUEST_CENSUS_SECTION_INFO: function REQUEST_CENSUS_SECTION_INFO(_ref5, data) {
        var state = _ref5.state,
            commit = _ref5.commit,
            rootState = _ref5.rootState;


        return __WEBPACK_IMPORTED_MODULE_3__maps_api__["a" /* default */].request_icc_census_section_info(data).then(function (res) {

            console.log('request_census_section_info res:');
            console.log(res);

            // parse the html response from ICC
            var div = document.createElement('div');
            div.innerHTML = res.html;
            var ths = div.querySelectorAll('th');
            var tds = div.querySelectorAll('td');

            // console.log('div: ')
            // console.log(div)

            var new_ths = [];
            var new_tds = [];

            for (var i = 0; i < ths.length; i++) {
                new_ths.push(ths[i].innerText.toLowerCase());
            }

            for (var _i = 0; _i < tds.length; _i++) {
                new_tds.push(tds[_i].innerText.toLowerCase());
            }

            console.log('new_ths: ');
            console.log(new_ths);
            console.log('new_tds: ');
            console.log(new_tds);

            var census_obj = Object.assign.apply(Object, [{}].concat(_toConsumableArray(new_ths.map(function (n, index) {
                return _defineProperty({}, n, new_tds[index]);
            }))));

            // console.log(census_obj)

            var census_section_code = '' + census_obj.municipi + census_obj.districte + census_obj.seccio;

            commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1009" /* SET_AD_CENSUS_SECTION_CODE */], census_section_code);
        });
    },
    REQUEST_CADASTRAL_REFERENCE_BY_COORDINATES: function REQUEST_CADASTRAL_REFERENCE_BY_COORDINATES(_ref7, data) {
        var state = _ref7.state,
            commit = _ref7.commit,
            rootState = _ref7.rootState;


        return __WEBPACK_IMPORTED_MODULE_3__maps_api__["a" /* default */].request_cadastral_reference_by_coordinates(data).then(function (res) {

            console.log('request_cadastral_reference_by_coordinates res:');
            console.log(res);

            if (res.result.consulta_coordenadas_distancias) {
                var cadref_part1 = res.result.consulta_coordenadas_distancias.coordenadas_distancias.coordd.lpcd.pcd[0].pc.pc1;
                var cadref_part2 = res.result.consulta_coordenadas_distancias.coordenadas_distancias.coordd.lpcd.pcd[0].pc.pc2;

                var cadref = cadref_part1 + cadref_part2;

                commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1010" /* SET_AD_CADASTRAL_REFERENCE */], cadref);
            } else {
                console.log('res.result.consulta_coordenadas_distancias .... is undefined?');
            }
        });
    },
    RESET_AD: function RESET_AD(_ref8) {
        var state = _ref8.state,
            commit = _ref8.commit,
            rootState = _ref8.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_997" /* RESET_AD */]);
    },
    SET_AD_CADASTRAL_REFERENCE: function SET_AD_CADASTRAL_REFERENCE(_ref9, data) {
        var state = _ref9.state,
            commit = _ref9.commit,
            rootState = _ref9.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1010" /* SET_AD_CADASTRAL_REFERENCE */], data);
    },
    SET_AD_CENSUS_SECTION_CODE: function SET_AD_CENSUS_SECTION_CODE(_ref10, data) {
        var state = _ref10.state,
            commit = _ref10.commit,
            rootState = _ref10.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1009" /* SET_AD_CENSUS_SECTION_CODE */], data);
    },
    SET_AD_COUNTRY: function SET_AD_COUNTRY(_ref11, data) {
        var state = _ref11.state,
            commit = _ref11.commit,
            rootState = _ref11.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1011" /* SET_AD_COUNTRY */], data);
    },
    SET_AD_DATE_CREATED: function SET_AD_DATE_CREATED(_ref12, data) {
        var state = _ref12.state,
            commit = _ref12.commit,
            rootState = _ref12.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_994" /* SET_AD_DATE_CREATED */], data);
    },
    SET_AD_DATE_MODIFIED: function SET_AD_DATE_MODIFIED(_ref13, data) {
        var state = _ref13.state,
            commit = _ref13.commit,
            rootState = _ref13.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_995" /* SET_AD_DATE_MODIFIED */], data);
    },
    SET_AD_DESCRIPTION: function SET_AD_DESCRIPTION(_ref14, data) {
        var state = _ref14.state,
            commit = _ref14.commit,
            rootState = _ref14.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1012" /* SET_AD_DESCRIPTION */], data);
    },
    SET_AD_DOOR: function SET_AD_DOOR(_ref15, data) {
        var state = _ref15.state,
            commit = _ref15.commit,
            rootState = _ref15.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1013" /* SET_AD_DOOR */], data);
    },
    SET_AD_EPSG25831_X: function SET_AD_EPSG25831_X(_ref16, data) {
        var state = _ref16.state,
            commit = _ref16.commit,
            rootState = _ref16.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1006" /* SET_AD_EPSG25831_X */], data);
    },
    SET_AD_EPSG25831_Y: function SET_AD_EPSG25831_Y(_ref17, data) {
        var state = _ref17.state,
            commit = _ref17.commit,
            rootState = _ref17.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1007" /* SET_AD_EPSG25831_Y */], data);
    },
    SET_AD_FLOOR: function SET_AD_FLOOR(_ref18, data) {
        var state = _ref18.state,
            commit = _ref18.commit,
            rootState = _ref18.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1014" /* SET_AD_FLOOR */], data);
    },
    SET_AD_GEOHASH: function SET_AD_GEOHASH(_ref19, data) {
        var state = _ref19.state,
            commit = _ref19.commit,
            rootState = _ref19.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1008" /* SET_AD_GEOHASH */], data);
    },
    SET_AD_GOOGLE_FORMATTED_ADDRESS: function SET_AD_GOOGLE_FORMATTED_ADDRESS(_ref20, data) {
        var state = _ref20.state,
            commit = _ref20.commit,
            rootState = _ref20.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_999" /* SET_AD_GOOGLE_FORMATTED_ADDRESS */], data);
    },
    SET_AD_ID: function SET_AD_ID(_ref21, data) {
        var state = _ref21.state,
            commit = _ref21.commit,
            rootState = _ref21.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_993" /* SET_AD_ID */], data);
    },
    SET_AD_LAT: function SET_AD_LAT(_ref22, data) {
        var state = _ref22.state,
            commit = _ref22.commit,
            rootState = _ref22.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1001" /* SET_AD_LAT */], data);
    },
    SET_AD_LNG: function SET_AD_LNG(_ref23, data) {
        var state = _ref23.state,
            commit = _ref23.commit,
            rootState = _ref23.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1002" /* SET_AD_LNG */], data);
    },
    SET_AD_MUNICIPALITY: function SET_AD_MUNICIPALITY(_ref24, data) {
        var state = _ref24.state,
            commit = _ref24.commit,
            rootState = _ref24.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1015" /* SET_AD_MUNICIPALITY */], data);
    },
    SET_AD_POSTAL_CODE: function SET_AD_POSTAL_CODE(_ref25, data) {
        var state = _ref25.state,
            commit = _ref25.commit,
            rootState = _ref25.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1003" /* SET_AD_POSTAL_CODE */], data);
    },
    SET_AD_PARENT_PATH: function SET_AD_PARENT_PATH(_ref26, data) {
        var state = _ref26.state,
            commit = _ref26.commit,
            rootState = _ref26.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1016" /* SET_AD_PARENT_PATH */], data);
    },
    SET_AD_PATH: function SET_AD_PATH(_ref27, data) {
        var state = _ref27.state,
            commit = _ref27.commit,
            rootState = _ref27.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_996" /* SET_AD_PATH */], data);
    },
    SET_AD_PROVINCE: function SET_AD_PROVINCE(_ref28, data) {
        var state = _ref28.state,
            commit = _ref28.commit,
            rootState = _ref28.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1017" /* SET_AD_PROVINCE */], data);
    },
    SET_AD_STAIRCASE: function SET_AD_STAIRCASE(_ref29, data) {
        var state = _ref29.state,
            commit = _ref29.commit,
            rootState = _ref29.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1018" /* SET_AD_STAIRCASE */], data);
    },
    SET_AD_STREET_NAME: function SET_AD_STREET_NAME(_ref30, data) {
        var state = _ref30.state,
            commit = _ref30.commit,
            rootState = _ref30.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1004" /* SET_AD_STREET_NAME */], data);
    },
    SET_AD_STREET_NUMBER: function SET_AD_STREET_NUMBER(_ref31, data) {
        var state = _ref31.state,
            commit = _ref31.commit,
            rootState = _ref31.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1005" /* SET_AD_STREET_NUMBER */], data);
    },
    UPDATE_AD: function UPDATE_AD(_ref32, data) {
        var state = _ref32.state,
            commit = _ref32.commit,
            rootState = _ref32.rootState;


        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].update({ object: data.object, path: data.path, save_timestamp: true }).then(function (res) {
                var date_modified = res.date_modified;

                commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_995" /* SET_AD_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1019" /* SET_AD_DIRTYNESS */], false);

                __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].update({ object: data.object, path: data.path_ads, save_timestamp: true }).then(function (res) {
                    __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].update({ object: data.object, path: data.path_ad_locations, save_timestamp: true }).then(function (res) {});
                });
            });
        });
    },
    SET_AD_CADASTRAL_AREA: function SET_AD_CADASTRAL_AREA(_ref33, data) {
        var state = _ref33.state,
            commit = _ref33.commit,
            rootState = _ref33.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1020" /* SET_AD_CADASTRAL_AREA */], data);
    },
    SET_AD_REGISTRY_IDUFIR: function SET_AD_REGISTRY_IDUFIR(_ref34, data) {
        var state = _ref34.state,
            commit = _ref34.commit,
            rootState = _ref34.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1021" /* SET_AD_REGISTRY_IDUFIR */], data);
    },
    SET_AD_AD_DATE: function SET_AD_AD_DATE(_ref35, data) {
        var state = _ref35.state,
            commit = _ref35.commit,
            rootState = _ref35.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1022" /* SET_AD_AD_DATE */], data);
    },
    SET_AD_AD_TYPE: function SET_AD_AD_TYPE(_ref36, data) {
        var state = _ref36.state,
            commit = _ref36.commit,
            rootState = _ref36.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1023" /* SET_AD_AD_TYPE */], data);
    },
    SET_AD_AD_YEAR: function SET_AD_AD_YEAR(_ref37, data) {
        var state = _ref37.state,
            commit = _ref37.commit,
            rootState = _ref37.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1024" /* SET_AD_AD_YEAR */], data);
    },
    SET_AD_ADOPTED_AREA: function SET_AD_ADOPTED_AREA(_ref38, data) {
        var state = _ref38.state,
            commit = _ref38.commit,
            rootState = _ref38.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1025" /* SET_AD_ADOPTED_AREA */], data);
    },
    SET_AD_ADOPTED_AGE: function SET_AD_ADOPTED_AGE(_ref39, data) {
        var state = _ref39.state,
            commit = _ref39.commit,
            rootState = _ref39.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1026" /* SET_AD_ADOPTED_AGE */], data);
    },
    SET_AD_AIR_CONDITIONING: function SET_AD_AIR_CONDITIONING(_ref40, data) {
        var state = _ref40.state,
            commit = _ref40.commit,
            rootState = _ref40.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1027" /* SET_AD_AIR_CONDITIONING */], data);
    },
    SET_AD_BATHROOMS_NUMBER: function SET_AD_BATHROOMS_NUMBER(_ref41, data) {
        var state = _ref41.state,
            commit = _ref41.commit,
            rootState = _ref41.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1028" /* SET_AD_BATHROOMS_NUMBER */], data);
    },
    SET_AD_BEDROOMS_NUMBER: function SET_AD_BEDROOMS_NUMBER(_ref42, data) {
        var state = _ref42.state,
            commit = _ref42.commit,
            rootState = _ref42.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1029" /* SET_AD_BEDROOMS_NUMBER */], data);
    },
    SET_AD_COVERED_OUTDOOR_AREA: function SET_AD_COVERED_OUTDOOR_AREA(_ref43, data) {
        var state = _ref43.state,
            commit = _ref43.commit,
            rootState = _ref43.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1030" /* SET_AD_COVERED_OUTDOOR_AREA */], data);
    },
    SET_AD_UNCOVERED_OUTDOOR_AREA: function SET_AD_UNCOVERED_OUTDOOR_AREA(_ref44, data) {
        var state = _ref44.state,
            commit = _ref44.commit,
            rootState = _ref44.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1031" /* SET_AD_UNCOVERED_OUTDOOR_AREA */], data);
    },
    SET_AD_CONSTRUCTION_YEAR: function SET_AD_CONSTRUCTION_YEAR(_ref45, data) {
        var state = _ref45.state,
            commit = _ref45.commit,
            rootState = _ref45.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1032" /* SET_AD_CONSTRUCTION_YEAR */], data);
    },
    SET_AD_DWELLING_TYPE: function SET_AD_DWELLING_TYPE(_ref46, data) {
        var state = _ref46.state,
            commit = _ref46.commit,
            rootState = _ref46.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1033" /* SET_AD_DWELLING_TYPE */], data);
    },
    SET_AD_ESTIMATED_SALE_PRICE: function SET_AD_ESTIMATED_SALE_PRICE(_ref47, data) {
        var state = _ref47.state,
            commit = _ref47.commit,
            rootState = _ref47.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1034" /* SET_AD_ESTIMATED_SALE_PRICE */], data);
    },
    SET_AD_EXTERNAL_STORAGE_ROOM: function SET_AD_EXTERNAL_STORAGE_ROOM(_ref48, data) {
        var state = _ref48.state,
            commit = _ref48.commit,
            rootState = _ref48.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1035" /* SET_AD_EXTERNAL_STORAGE_ROOM */], data);
    },
    SET_AD_FLOOR_NUMBER: function SET_AD_FLOOR_NUMBER(_ref49, data) {
        var state = _ref49.state,
            commit = _ref49.commit,
            rootState = _ref49.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1036" /* SET_AD_FLOOR_NUMBER */], data);
    },
    SET_AD_FLOOR_TYPE: function SET_AD_FLOOR_TYPE(_ref50, data) {
        var state = _ref50.state,
            commit = _ref50.commit,
            rootState = _ref50.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1037" /* SET_AD_FLOOR_TYPE */], data);
    },
    SET_AD_GREEN_AREAS: function SET_AD_GREEN_AREAS(_ref51, data) {
        var state = _ref51.state,
            commit = _ref51.commit,
            rootState = _ref51.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1038" /* SET_AD_GREEN_AREAS */], data);
    },
    SET_AD_HEATING: function SET_AD_HEATING(_ref52, data) {
        var state = _ref52.state,
            commit = _ref52.commit,
            rootState = _ref52.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1039" /* SET_AD_HEATING */], data);
    },
    SET_AD_LAST_RENOVATION_YEAR: function SET_AD_LAST_RENOVATION_YEAR(_ref53, data) {
        var state = _ref53.state,
            commit = _ref53.commit,
            rootState = _ref53.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1040" /* SET_AD_LAST_RENOVATION_YEAR */], data);
    },
    SET_AD_LIFT: function SET_AD_LIFT(_ref54, data) {
        var state = _ref54.state,
            commit = _ref54.commit,
            rootState = _ref54.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1041" /* SET_AD_LIFT */], data);
    },
    SET_AD_OFFER_PRICE: function SET_AD_OFFER_PRICE(_ref55, data) {
        var state = _ref55.state,
            commit = _ref55.commit,
            rootState = _ref55.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1042" /* SET_AD_OFFER_PRICE */], data);
    },
    SET_AD_PARKING_LOTS_NUMBER: function SET_AD_PARKING_LOTS_NUMBER(_ref56, data) {
        var state = _ref56.state,
            commit = _ref56.commit,
            rootState = _ref56.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1043" /* SET_AD_PARKING_LOTS_NUMBER */], data);
    },
    SET_AD_QUALITY_OF_NEIGHBOURHOOD: function SET_AD_QUALITY_OF_NEIGHBOURHOOD(_ref57, data) {
        var state = _ref57.state,
            commit = _ref57.commit,
            rootState = _ref57.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1044" /* SET_AD_QUALITY_OF_NEIGHBOURHOOD */], data);
    },
    SET_ENTITY_QUALITY_OF_NEIGHBOURHOOD: function SET_ENTITY_QUALITY_OF_NEIGHBOURHOOD(_ref58, data) {
        var state = _ref58.state,
            commit = _ref58.commit,
            rootState = _ref58.rootState;


        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].set_value({
                value: data.value,
                path: 'appraisal_rooms' + '/' + data.appraisal_id + '/' + data.key + '/' + 'netarea',
                save_timestamp: false
            }).then(function (res) {
                resolve();
            });
        });
    },
    SET_AD_QUALITY_OF_SITUATION: function SET_AD_QUALITY_OF_SITUATION(_ref59, data) {
        var state = _ref59.state,
            commit = _ref59.commit,
            rootState = _ref59.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1045" /* SET_AD_QUALITY_OF_SITUATION */], data);
    },
    SET_AD_QUALITY_OF_CONSTRUCTION: function SET_AD_QUALITY_OF_CONSTRUCTION(_ref60, data) {
        var state = _ref60.state,
            commit = _ref60.commit,
            rootState = _ref60.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1046" /* SET_AD_QUALITY_OF_CONSTRUCTION */], data);
    },
    SET_AD_QUALITY_OF_REALESTATE: function SET_AD_QUALITY_OF_REALESTATE(_ref61, data) {
        var state = _ref61.state,
            commit = _ref61.commit,
            rootState = _ref61.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1047" /* SET_AD_QUALITY_OF_REALESTATE */], data);
    },
    SET_AD_SPORTS_FACILITIES: function SET_AD_SPORTS_FACILITIES(_ref62, data) {
        var state = _ref62.state,
            commit = _ref62.commit,
            rootState = _ref62.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1048" /* SET_AD_SPORTS_FACILITIES */], data);
    },
    SET_AD_SWIMMING_POOL: function SET_AD_SWIMMING_POOL(_ref63, data) {
        var state = _ref63.state,
            commit = _ref63.commit,
            rootState = _ref63.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1049" /* SET_AD_SWIMMING_POOL */], data);
    },
    SET_AD_AD_ADDRESS: function SET_AD_AD_ADDRESS(_ref64, data) {
        var state = _ref64.state,
            commit = _ref64.commit,
            rootState = _ref64.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1050" /* SET_AD_AD_ADDRESS */], data);
    },
    SET_AD_BUILT_AREA: function SET_AD_BUILT_AREA(_ref65, data) {
        var state = _ref65.state,
            commit = _ref65.commit,
            rootState = _ref65.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1051" /* SET_AD_BUILT_AREA */], data);
    },
    SET_AD_CAPTURE_DATE: function SET_AD_CAPTURE_DATE(_ref66, data) {
        var state = _ref66.state,
            commit = _ref66.commit,
            rootState = _ref66.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1052" /* SET_AD_CAPTURE_DATE */], data);
    },
    SET_AD_AD_DATA_TYPE: function SET_AD_AD_DATA_TYPE(_ref67, data) {
        var state = _ref67.state,
            commit = _ref67.commit,
            rootState = _ref67.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1053" /* SET_AD_AD_DATA_TYPE */], data);
    },
    SET_AD_AD_CODE: function SET_AD_AD_CODE(_ref68, data) {
        var state = _ref68.state,
            commit = _ref68.commit,
            rootState = _ref68.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1054" /* SET_AD_AD_CODE */], data);
    },
    SET_AD_INTERIOR_VISIT_CHECK: function SET_AD_INTERIOR_VISIT_CHECK(_ref69, data) {
        var state = _ref69.state,
            commit = _ref69.commit,
            rootState = _ref69.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1055" /* SET_AD_INTERIOR_VISIT_CHECK */], data);
    },
    SET_AD_LAND_AREA: function SET_AD_LAND_AREA(_ref70, data) {
        var state = _ref70.state,
            commit = _ref70.commit,
            rootState = _ref70.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1056" /* SET_AD_LAND_AREA */], data);
    },
    SET_AD_NET_AREA: function SET_AD_NET_AREA(_ref71, data) {
        var state = _ref71.state,
            commit = _ref71.commit,
            rootState = _ref71.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1057" /* SET_AD_NET_AREA */], data);
    },
    SET_AD_CADASTRAL_DATA_CHECK: function SET_AD_CADASTRAL_DATA_CHECK(_ref72, data) {
        var state = _ref72.state,
            commit = _ref72.commit,
            rootState = _ref72.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1058" /* SET_AD_CADASTRAL_DATA_CHECK */], data);
    },
    SET_AD_CONTACT_TELEPHONE: function SET_AD_CONTACT_TELEPHONE(_ref73, data) {
        var state = _ref73.state,
            commit = _ref73.commit,
            rootState = _ref73.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1059" /* SET_AD_CONTACT_TELEPHONE */], data);
    },
    SET_AD_NOTES_1: function SET_AD_NOTES_1(_ref74, data) {
        var state = _ref74.state,
            commit = _ref74.commit,
            rootState = _ref74.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1060" /* SET_AD_NOTES_1 */], data);
    },
    SET_AD_NOTES_2: function SET_AD_NOTES_2(_ref75, data) {
        var state = _ref75.state,
            commit = _ref75.commit,
            rootState = _ref75.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1061" /* SET_AD_NOTES_2 */], data);
    },
    SET_AD_ORIENTATION: function SET_AD_ORIENTATION(_ref76, data) {
        var state = _ref76.state,
            commit = _ref76.commit,
            rootState = _ref76.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1062" /* SET_AD_ORIENTATION */], data);
    },
    SET_AD_PROPERTY_TYPE: function SET_AD_PROPERTY_TYPE(_ref77, data) {
        var state = _ref77.state,
            commit = _ref77.commit,
            rootState = _ref77.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1063" /* SET_AD_PROPERTY_TYPE */], data);
    },
    SET_AD_SOURCE: function SET_AD_SOURCE(_ref78, data) {
        var state = _ref78.state,
            commit = _ref78.commit,
            rootState = _ref78.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1064" /* SET_AD_SOURCE */], data);
    },
    SET_AD_URL: function SET_AD_URL(_ref79, data) {
        var state = _ref79.state,
            commit = _ref79.commit,
            rootState = _ref79.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1065" /* SET_AD_URL */], data);
    },
    SET_AD_BLOCK: function SET_AD_BLOCK(_ref80, data) {
        var state = _ref80.state,
            commit = _ref80.commit,
            rootState = _ref80.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1066" /* SET_AD_BLOCK */], data);
    },
    SET_AD_CONTACT_NAME: function SET_AD_CONTACT_NAME(_ref81, data) {
        var state = _ref81.state,
            commit = _ref81.commit,
            rootState = _ref81.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1067" /* SET_AD_CONTACT_NAME */], data);
    },
    SET_AD_OFFER_UNIT_PRICE: function SET_AD_OFFER_UNIT_PRICE(_ref82, data) {
        var state = _ref82.state,
            commit = _ref82.commit,
            rootState = _ref82.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1068" /* SET_AD_OFFER_UNIT_PRICE */], data);
    },
    SET_AD_CONSERVATION_STATUS: function SET_AD_CONSERVATION_STATUS(_ref83, data) {
        var state = _ref83.state,
            commit = _ref83.commit,
            rootState = _ref83.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1069" /* SET_AD_CONSERVATION_STATUS */], data);
    },
    SET_AD_OFFER_PRICE_REDUCTION_PCT: function SET_AD_OFFER_PRICE_REDUCTION_PCT(_ref84, data) {
        var state = _ref84.state,
            commit = _ref84.commit,
            rootState = _ref84.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1070" /* SET_AD_OFFER_PRICE_REDUCTION_PCT */], data);
    },
    SET_AD_ESTIMATED_UNIT_SALE_PRICE: function SET_AD_ESTIMATED_UNIT_SALE_PRICE(_ref85, data) {
        var state = _ref85.state,
            commit = _ref85.commit,
            rootState = _ref85.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_5__constants__["_1071" /* SET_AD_ESTIMATED_UNIT_SALE_PRICE */], data);
    }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_997" /* RESET_AD */], function (state) {
    state.block = null;
    state.cadastral_reference = null;
    state.census_section_code = null;
    state.country = {
        iso_3166_alpha2_code: 'ES',
        name_en: 'Spain'
    };
    state.description = null;
    state.door = null;
    state.floor = null;
    state.geohash = null;
    state.google_formatted_address = null;
    state.google_viewport = null;
    state.lat = null;
    state.lng = null;
    state.municipality = null;
    state.postal_code = null;
    state.province = null;
    state.staircase = null;
    state.street_name = null;
    state.street_number = null;
    state.type = null;
    state.date_created = null;
    state.date_modified = null;
    state.dirty = false;
    state.id = null;
    state.path = null;
    state.parent_path = null;

    state.cadastral_area = null;
    state.registry_idufir = null;
    state.ad_date = null;
    state.ad_type = null;
    state.ad_year = null;
    state.adopted_area = null;
    state.adopted_age = null;
    state.air_conditioning = null;
    state.bathrooms_number = null;
    state.bedrooms_number = null;
    state.covered_outdoor_area = null;
    state.uncovered_outdoor_area = null;
    state.construction_year = null;
    state.dwelling_type = null;
    state.estimated_sale_price = null;
    state.external_storage_room = null;
    state.floor_number = null;
    state.floor_type = null;
    state.green_areas = null;
    state.heating = null;
    state.last_renovation_year = null;
    state.lift = null;
    state.offer_price = null;
    state.parking_lots_number = null;
    state.quality_of_neighbourhood = null;
    state.quality_of_situation = null;
    state.quality_of_construction = null;
    state.quality_of_realestate = null;
    state.sports_facilities = null;
    state.swimming_pool = null;

    state.ad_address = null;
    state.built_area = null;
    state.capture_date = null;
    state.ad_data_type = null;
    state.ad_code = null;
    state.interior_visit_check = null;
    state.land_area = null;
    state.net_area = null;
    state.cadastral_data_check = null;
    state.contact_telephone = null;
    state.notes_1 = null;
    state.notes_2 = null;
    state.orientation = null;
    state.property_type = null;
    state.source = null;
    state.url = null;

    state.block = null;
    state.contact_name = null;
    state.offer_unit_price = null;
    state.conservation_status = null;

    state.offer_price_reduction_pct = 0.05;

    state.estimated_unit_sale_price = null;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_998" /* SET_AD */], function (state, data) {
    // console.log('mutations SET_CONTACT data: ')
    // console.log(data)
    state.block = check_undefined(data.block);
    state.cadastral_reference = check_undefined(data.cadastral_reference);
    state.census_section_code = check_undefined(data.census_section_code);
    state.description = check_undefined(data.description);
    state.door = check_undefined(data.door);
    state.epsg25831_x = check_undefined(data.epsg25831_x);
    state.epsg25831_y = check_undefined(data.epsg25831_y);
    state.floor = check_undefined(data.floor);
    state.geohash = check_undefined(data.geohash);
    state.google_formatted_address = check_undefined(data.google_formatted_address);
    state.lat = check_undefined(data.lat);
    state.lng = check_undefined(data.lng);
    state.municipality = check_undefined(data.municipality);
    state.postal_code = check_undefined(data.postal_code);
    state.province = check_undefined(data.province);
    state.staircase = check_undefined(data.staircase);
    state.street_name = check_undefined(data.street_name);
    state.street_number = check_undefined(data.street_number);
    state.type = check_undefined(data.type);

    //general data
    state.date_created = check_undefined(data.date_created);
    state.date_modified = check_undefined(data.date_modified);
    state.dirty = false;
    state.id = check_undefined(data.id);
    state.path = check_undefined(data.path);
    state.parent_path = check_undefined(data.parent_path);

    //
    state.cadastral_area = check_undefined(data.cadastral_area);
    state.registry_idufir = check_undefined(data.registry_idufir);
    state.ad_date = check_undefined(data.ad_date);
    state.ad_type = check_undefined(data.ad_type);
    state.ad_year = check_undefined(data.ad_year);
    state.adopted_area = check_undefined(data.adopted_area);
    state.adopted_age = check_undefined(data.adopted_age);
    state.air_conditioning = check_undefined(data.air_conditioning);
    state.bathrooms_number = check_undefined(data.bathrooms_number);
    state.bedrooms_number = check_undefined(data.bedrooms_number);
    state.covered_outdoor_area = check_undefined(data.covered_outdoor_area);
    state.uncovered_outdoor_area = check_undefined(data.uncovered_outdoor_area);
    state.construction_year = check_undefined(data.construction_year);
    state.dwelling_type = check_undefined(data.dwelling_type);
    state.estimated_sale_price = check_undefined(data.estimated_sale_price);
    state.external_storage_room = check_undefined(data.external_storage_room);
    state.floor_number = check_undefined(data.floor_number);
    state.floor_type = check_undefined(data.floor_type);
    state.green_areas = check_undefined(data.green_areas);
    state.heating = check_undefined(data.heating);
    state.last_renovation_year = check_undefined(data.last_renovation_year);
    state.lift = check_undefined(data.lift);
    state.offer_price = check_undefined(data.offer_price);
    state.parking_lots_number = check_undefined(data.parking_lots_number);
    state.quality_of_neighbourhood = check_undefined(data.quality_of_neighbourhood);
    state.quality_of_situation = check_undefined(data.quality_of_situation);
    state.quality_of_construction = check_undefined(data.quality_of_construction);
    state.quality_of_realestate = check_undefined(data.quality_of_realestate);
    state.sports_facilities = check_undefined(data.sports_facilities);
    state.swimming_pool = check_undefined(data.swimming_pool);

    state.ad_address = check_undefined(data.ad_address);
    state.built_area = check_undefined(data.built_area);
    state.capture_date = check_undefined(data.capture_date);
    state.ad_data_type = check_undefined(data.ad_data_type);
    state.ad_code = check_undefined(data.ad_code);
    state.interior_visit_check = check_undefined(data.interior_visit_check);
    state.land_area = check_undefined(data.land_area);
    state.net_area = check_undefined(data.net_area);
    state.cadastral_data_check = check_undefined(data.cadastral_data_check);
    state.contact_telephone = check_undefined(data.contact_telephone);
    state.notes_1 = check_undefined(data.notes_1);
    state.notes_2 = check_undefined(data.notes_2);
    state.orientation = check_undefined(data.orientation);
    state.property_type = check_undefined(data.property_type);
    state.source = check_undefined(data.source);
    state.url = check_undefined(data.url);

    state.block = check_undefined(data.block);
    state.contact_name = check_undefined(data.contact_name);
    state.offer_unit_price = check_undefined(data.offer_unit_price);
    state.conservation_status = check_undefined(data.conservation_status);

    state.offer_price_reduction_pct = check_undefined(data.offer_price_reduction_pct);
    state.estimated_unit_sale_price = check_undefined(data.estimated_unit_sale_price);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1010" /* SET_AD_CADASTRAL_REFERENCE */], function (state, data) {
    state.cadastral_reference = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1009" /* SET_AD_CENSUS_SECTION_CODE */], function (state, data) {
    state.census_section_code = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1011" /* SET_AD_COUNTRY */], function (state, data) {
    state.country = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_994" /* SET_AD_DATE_CREATED */], function (state, data) {
    state.date_created = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_995" /* SET_AD_DATE_MODIFIED */], function (state, data) {
    state.date_modified = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1012" /* SET_AD_DESCRIPTION */], function (state, data) {
    state.description = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1019" /* SET_AD_DIRTYNESS */], function (state, boolean) {
    state.dirty = boolean;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1013" /* SET_AD_DOOR */], function (state, data) {
    state.door = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1014" /* SET_AD_FLOOR */], function (state, data) {
    state.floor = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1008" /* SET_AD_GEOHASH */], function (state, data) {
    state.geohash = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_999" /* SET_AD_GOOGLE_FORMATTED_ADDRESS */], function (state, data) {
    state.google_formatted_address = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1000" /* SET_AD_GOOGLE_VIEWPORT */], function (state, data) {
    state.google_viewport = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1006" /* SET_AD_EPSG25831_X */], function (state, data) {
    state.epsg25831_x = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1007" /* SET_AD_EPSG25831_Y */], function (state, data) {
    state.epsg25831_y = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_993" /* SET_AD_ID */], function (state, data) {
    state.id = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1001" /* SET_AD_LAT */], function (state, data) {
    state.lat = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1002" /* SET_AD_LNG */], function (state, data) {
    state.lng = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1015" /* SET_AD_MUNICIPALITY */], function (state, data) {
    state.municipality = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1016" /* SET_AD_PARENT_PATH */], function (state, data) {
    state.parent_path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_996" /* SET_AD_PATH */], function (state, data) {
    state.path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1003" /* SET_AD_POSTAL_CODE */], function (state, data) {
    state.postal_code = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1017" /* SET_AD_PROVINCE */], function (state, data) {
    state.province = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1018" /* SET_AD_STAIRCASE */], function (state, data) {
    state.staircase = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1004" /* SET_AD_STREET_NAME */], function (state, data) {
    state.street_name = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1005" /* SET_AD_STREET_NUMBER */], function (state, data) {
    state.street_number = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1020" /* SET_AD_CADASTRAL_AREA */], function (state, data) {
    state.cadastral_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1021" /* SET_AD_REGISTRY_IDUFIR */], function (state, data) {
    state.registry_idufir = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1022" /* SET_AD_AD_DATE */], function (state, data) {
    state.ad_date = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1023" /* SET_AD_AD_TYPE */], function (state, data) {
    state.ad_type = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1024" /* SET_AD_AD_YEAR */], function (state, data) {
    state.ad_year = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1025" /* SET_AD_ADOPTED_AREA */], function (state, data) {
    state.adopted_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1026" /* SET_AD_ADOPTED_AGE */], function (state, data) {
    state.adopted_age = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1027" /* SET_AD_AIR_CONDITIONING */], function (state, data) {
    state.air_conditioning = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1028" /* SET_AD_BATHROOMS_NUMBER */], function (state, data) {
    state.bathrooms_number = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1029" /* SET_AD_BEDROOMS_NUMBER */], function (state, data) {
    state.bedrooms_number = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1069" /* SET_AD_CONSERVATION_STATUS */], function (state, data) {
    state.conservation_status = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1030" /* SET_AD_COVERED_OUTDOOR_AREA */], function (state, data) {
    state.covered_outdoor_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1031" /* SET_AD_UNCOVERED_OUTDOOR_AREA */], function (state, data) {
    state.uncovered_outdoor_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1032" /* SET_AD_CONSTRUCTION_YEAR */], function (state, data) {
    state.construction_year = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1033" /* SET_AD_DWELLING_TYPE */], function (state, data) {
    state.dwelling_type = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1034" /* SET_AD_ESTIMATED_SALE_PRICE */], function (state, data) {
    state.estimated_sale_price = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1035" /* SET_AD_EXTERNAL_STORAGE_ROOM */], function (state, data) {
    state.external_storage_room = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1036" /* SET_AD_FLOOR_NUMBER */], function (state, data) {
    state.floor_number = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1037" /* SET_AD_FLOOR_TYPE */], function (state, data) {
    state.floor_type = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1038" /* SET_AD_GREEN_AREAS */], function (state, data) {
    state.green_areas = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1039" /* SET_AD_HEATING */], function (state, data) {
    state.heating = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1040" /* SET_AD_LAST_RENOVATION_YEAR */], function (state, data) {
    state.last_renovation_year = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1041" /* SET_AD_LIFT */], function (state, data) {
    state.lift = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1042" /* SET_AD_OFFER_PRICE */], function (state, data) {
    state.offer_price = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1043" /* SET_AD_PARKING_LOTS_NUMBER */], function (state, data) {
    state.parking_lots_number = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1044" /* SET_AD_QUALITY_OF_NEIGHBOURHOOD */], function (state, data) {
    state.quality_of_neighbourhood = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1045" /* SET_AD_QUALITY_OF_SITUATION */], function (state, data) {
    state.quality_of_situation = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1046" /* SET_AD_QUALITY_OF_CONSTRUCTION */], function (state, data) {
    state.quality_of_construction = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1047" /* SET_AD_QUALITY_OF_REALESTATE */], function (state, data) {
    state.quality_of_realestate = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1048" /* SET_AD_SPORTS_FACILITIES */], function (state, data) {
    state.sports_facilities = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1049" /* SET_AD_SWIMMING_POOL */], function (state, data) {
    state.swimming_pool = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1050" /* SET_AD_AD_ADDRESS */], function (state, data) {
    state.ad_address = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1051" /* SET_AD_BUILT_AREA */], function (state, data) {
    state.built_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1052" /* SET_AD_CAPTURE_DATE */], function (state, data) {
    state.capture_date = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1053" /* SET_AD_AD_DATA_TYPE */], function (state, data) {
    state.ad_data_type = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1054" /* SET_AD_AD_CODE */], function (state, data) {
    state.ad_code = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1055" /* SET_AD_INTERIOR_VISIT_CHECK */], function (state, data) {
    state.interior_visit_check = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1056" /* SET_AD_LAND_AREA */], function (state, data) {
    state.land_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1057" /* SET_AD_NET_AREA */], function (state, data) {
    state.net_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1058" /* SET_AD_CADASTRAL_DATA_CHECK */], function (state, data) {
    state.cadastral_data_check = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1059" /* SET_AD_CONTACT_TELEPHONE */], function (state, data) {
    state.contact_telephone = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1060" /* SET_AD_NOTES_1 */], function (state, data) {
    state.notes_1 = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1061" /* SET_AD_NOTES_2 */], function (state, data) {
    state.notes_2 = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1062" /* SET_AD_ORIENTATION */], function (state, data) {
    state.orientation = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1063" /* SET_AD_PROPERTY_TYPE */], function (state, data) {
    state.property_type = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1064" /* SET_AD_SOURCE */], function (state, data) {
    state.source = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1065" /* SET_AD_URL */], function (state, data) {
    state.url = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1066" /* SET_AD_BLOCK */], function (state, data) {
    state.block = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1067" /* SET_AD_CONTACT_NAME */], function (state, data) {
    state.contact_name = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1068" /* SET_AD_OFFER_UNIT_PRICE */], function (state, data) {
    state.offer_unit_price = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1069" /* SET_AD_CONSERVATION_STATUS */], function (state, data) {
    state.conservation_status = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1070" /* SET_AD_OFFER_PRICE_REDUCTION_PCT */], function (state, data) {
    state.offer_price_reduction_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__constants__["_1071" /* SET_AD_ESTIMATED_UNIT_SALE_PRICE */], function (state, data) {
    state.estimated_unit_sale_price = data;
    state.dirty = true;
}), _mutations);

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

var getters = {

    ad: function ad(state) {
        return state;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    municipalities: {}
};
var state = default_state;

var actions = {
    FETCH_AD_MUNICIPALITIES: function FETCH_AD_MUNICIPALITIES(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        // console.log('data.path (fetch_ad_municipalities) ---->')
        // console.log(data.path)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            // console.log(res)
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_992" /* SET_AD_MUNICIPALITIES */], res);
        });
    }
};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__constants__["_992" /* SET_AD_MUNICIPALITIES */], function (state, data) {
    state.municipalities = data;
});

var getters = {
    ad_municipalities: function ad_municipalities(state) {
        return state.municipalities;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    parent_path: null,
    path: null,
    description: null
};

var state = default_state;

var actions = {

    CREATE_NEW_AD_COMPARABLE: function CREATE_NEW_AD_COMPARABLE(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].create({ key: data.key, path: data.path }).then(function (res) {
                var new_created_key = res.key;

                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_371" /* SET_AD_COMPARABLE_ID */], new_created_key);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_372" /* SET_AD_COMPARABLE_DATE_CREATED */], res.date_created);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_373" /* SET_AD_COMPARABLE_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_374" /* SET_AD_COMPARABLE_PARENT_PATH */], data.parent_path);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_375" /* SET_AD_COMPARABLE_PATH */], res.path);

                var comp_obj = data.ad;
                comp_obj['ad_id'] = comp_obj['id'];
                comp_obj['id'] = new_created_key;
                comp_obj['date_created'] = res.date_created;
                comp_obj['date_modified'] = res.date_modified;
                comp_obj['parent_path'] = data.parent_path;
                comp_obj['path'] = res.path;

                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                    value: comp_obj,
                    path: data.path + new_created_key + '/',
                    save_timestamp: false
                }).then(function (res) {
                    var object = {};
                    object[new_created_key] = true;
                    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({
                        object: object,
                        path: data.parent_path,
                        save_timestamp: false
                    }).then(function (res) {
                        return resolve({ key: new_created_key });
                    });
                });
            });
        });
    },
    DELETE_AD_COMPARABLE: function DELETE_AD_COMPARABLE(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;


        return new Promise(function (resolve, reject) {

            // delete from path
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.path }).then(function (res) {
                // delete from parent_path
                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.parent_path }).then(function (res) {
                    commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_376" /* RESET_AD_COMPARABLE */]);
                }).then(function (res) {
                    return resolve({});
                });
            });
        });
    },
    SET_AD_COMPARABLE: function SET_AD_COMPARABLE(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;


        return new Promise(function (resolve, reject) {
            return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                // console.log(res)
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_377" /* SET_AD_COMPARABLE */], res);
            }).then(function (res) {
                return resolve({});
            });
        });
    },
    RESET_AD_COMPARABLE: function RESET_AD_COMPARABLE(_ref4) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_376" /* RESET_AD_COMPARABLE */]);
    },
    SET_AD_COMPARABLE_DATE_CREATED: function SET_AD_COMPARABLE_DATE_CREATED(_ref5, data) {
        var state = _ref5.state,
            commit = _ref5.commit,
            rootState = _ref5.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_372" /* SET_AD_COMPARABLE_DATE_CREATED */], data);
    },
    SET_AD_COMPARABLE_DATE_MODIFIED: function SET_AD_COMPARABLE_DATE_MODIFIED(_ref6, data) {
        var state = _ref6.state,
            commit = _ref6.commit,
            rootState = _ref6.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_373" /* SET_AD_COMPARABLE_DATE_MODIFIED */], data);
    },

    SET_AD_COMPARABLE_ID: function SET_AD_COMPARABLE_ID(_ref7, data) {
        var state = _ref7.state,
            commit = _ref7.commit,
            rootState = _ref7.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_371" /* SET_AD_COMPARABLE_ID */], data);
    },
    SET_AD_COMPARABLE_PARENT_PATH: function SET_AD_COMPARABLE_PARENT_PATH(_ref8, data) {
        var state = _ref8.state,
            commit = _ref8.commit,
            rootState = _ref8.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_374" /* SET_AD_COMPARABLE_PARENT_PATH */], data);
    },
    SET_AD_COMPARABLE_PATH: function SET_AD_COMPARABLE_PATH(_ref9, data) {
        var state = _ref9.state,
            commit = _ref9.commit,
            rootState = _ref9.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_375" /* SET_AD_COMPARABLE_PATH */], data);
    },
    UPDATE_AD_COMPARABLE: function UPDATE_AD_COMPARABLE(_ref10, data) {
        var state = _ref10.state,
            commit = _ref10.commit,
            rootState = _ref10.rootState;

        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({ object: data.object, path: data.path, save_timestamp: true }).then(function (res) {

            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_373" /* SET_AD_COMPARABLE_DATE_MODIFIED */], res.date_modified);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_378" /* SET_AD_COMPARABLE_DIRTYNESS */], false);
        });
    },
    SET_AD_COMPARABLE_DESCRIPTION: function SET_AD_COMPARABLE_DESCRIPTION(_ref11, data) {
        var state = _ref11.state,
            commit = _ref11.commit,
            rootState = _ref11.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_379" /* SET_AD_COMPARABLE_DESCRIPTION */], data);
    }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_376" /* RESET_AD_COMPARABLE */], function (state) {
    //general data
    state.date_created = null;
    state.date_modified = null;
    state.dirty = false;
    state.id = null;
    state.parent_path = null;
    state.path = null;

    //particular data
    state.description = null;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_377" /* SET_AD_COMPARABLE */], function (state, data) {
    //general data
    state.date_created = check_undefined(data.date_created);
    state.date_modified = check_undefined(data.date_modified);
    state.dirty = false;
    state.id = check_undefined(data.id);
    state.parent_path = check_undefined(data.parent_path);
    state.path = check_undefined(data.path);

    //particular data
    state.description = check_undefined(data.description);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_372" /* SET_AD_COMPARABLE_DATE_CREATED */], function (state, data) {
    state.date_created = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_373" /* SET_AD_COMPARABLE_DATE_MODIFIED */], function (state, data) {
    state.date_modified = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_378" /* SET_AD_COMPARABLE_DIRTYNESS */], function (state, boolean) {
    state.dirty = boolean;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_371" /* SET_AD_COMPARABLE_ID */], function (state, data) {
    state.id = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_374" /* SET_AD_COMPARABLE_PARENT_PATH */], function (state, data) {
    state.parent_path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_375" /* SET_AD_COMPARABLE_PATH */], function (state, data) {
    state.path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_379" /* SET_AD_COMPARABLE_DESCRIPTION */], function (state, data) {
    state.description = data;
    state.dirty = true;
}), _mutations);

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

var getters = {

    ad_comparable: function ad_comparable(state) {
        return state;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__maps_api__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var default_state = {
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    parent_path: null,
    path: null,
    appraisaldate: null,
    visitdate: null,
    technician_visiting: null,
    description: null,
    checks_cadastral_data: true,
    checks_conservation_status: true,
    checks_expropriation_procedure: true,
    checks_expropriation_plan: true,
    checks_expropriation_admin_ruling: true,
    checks_expropriation_file: true,
    checks_interior_visit: true,
    checks_occupancy: true,
    checks_other: null,
    checks_registry_data: true,
    checks_servitudes: true,
    checks_subsidy_status: true,
    checks_urban_planning: true,
    docs_approved_project: true,
    docs_cadastral_data: true,
    docs_construction_license: true,
    docs_construction_last_certificate: true,
    docs_construction_contract: true,
    docs_occupancy_status: true,
    docs_other: null,
    docs_photographic_report: true,
    docs_property_sketch: true,
    docs_property_titles: true,
    docs_situation_plan: true,
    docs_subsidy_status: true,
    docs_tenyear_insurance: true,
    docs_urban_plan: true,
    purpose: {
        acc_eco_decree: { id: 2, bde_code: 'N', name_ca: 'No', name_en: 'No', name_es: 'No' },
        acc_mortgage_market_law: { id: 2, bde_code: 'N', name_ca: 'No', name_en: 'No', name_es: 'No' },
        bde_code: 'O',
        id: 5,
        name_ca: 'Adquisició o venda',
        name_en: 'Purchase or sale',
        name_es: 'Adquisición o venta',
        default_notes: {
            name_ca: 'La taxació NO és vàlida per a fins hipotecaris perquè no s\'utilitza el criteri de valor garantit en el temps, si més no el valor en el dia de la data consignada',
            name_en: 'The appraisal is NOT valid for mortgage guarantees since the criteria for the value-over-time-guarantee is not applied',
            name_es: 'La tasación NO es válida para fines hipotecarios porque no se utiliza el criterio del valor garantizado en el tiempo, sino el valor en el día de la fecha consignada'
        },
        default_reduction_pct: 0
    },
    purpose_notes: 'La taxació NO és vàlida per a fins hipotecaris perquè no s\'utilitza el criteri de valor garantit en el temps, si més no el valor en el dia de la data consignada',
    type: {
        bde_code: 'C',
        id: 1,
        name_ca: 'Taxació completa',
        name_en: 'Complete Valuation',
        name_es: 'Tasación Completa'
    },
    adopted_area: null,
    lift: null,
    adopted_age: null,
    adopted_age_years_old: null,
    property_type: null,
    quality_of_neighbourhood: null,
    quality_of_situation: null,
    quality_of_construction: null,
    quality_of_realestate: null,
    conservation_status: null,
    floor_number: null,
    market_value: null,
    market_unit_value: null,
    bec_price: null,
    adjusted_bec_price: null,
    bc: null,
    bc_pct: null,
    gc: null,
    gc_pct: null,
    bc_and_gc_pct: null,
    bc_and_gc: null,
    cc: null,
    cc_pct: null,
    htl: null,
    htl_pct: null,
    inr: null,
    inr_pct: null,
    ga: null,
    ga_pct: null,
    gpd: null,
    gpd_pct: null,
    oct: null,
    oct_pct: null,
    gp: null,
    gp_pct: null,
    cc_and_gp: null,
    f: null,
    crb: null,
    ccd: null,
    tlr_pct: null,
    pr_pct: null,
    am_coef: null,
    b1_pct: null,
    b2_pct: null,
    b_pct: null,
    b_remaining_pct: null,
    i_pct: null,
    tenant_age_years: 35,
    tenant_life_expectancy_years: 83,
    tenant_remaining_life_expectancy_years: 48,
    cession_boolean: null,
    cession_gross_monthly_income: null,
    cession_gross_yearly_income: null,
    cession_net_yearly_income: null,
    cession_contract_period_years: null,
    cession_contract_remaining_years: null,
    cession_contract_start_date: null,
    landlord_expenses_pct: 70,
    reduction_pct: null,
    adjustment_coef: null,
    usufructuary_age_years: null,
    useful_life_years: null,
    remaining_useful_life_years: null,
    max_legal_price: null,
    max_legal_area: null,
    material_execution_cost: null,
    deprecated_material_execution_cost: null,
    mec_adjustment_coef: 1,
    adopted_material_execution_cost: null,
    physical_depreciation_pct: null,
    functional_depreciation_pct: null,
    total_depreciation_pct: null,
    total_construction_progress_pct: 100,
    adopted_market_value: null,
    adopted_market_unit_value: null,
    market_value_appraiser_adjustment_pct: null,
    deprecated_land_and_cc: null,
    finished_realestate_crn: null,
    ccr: null,
    executed_construction_cost: null,
    under_construction_realestate_crn: null,
    k: null,
    repercussion_method_land_value: null,
    cost_method_construction_crb_value: null,
    cost_method_construction_crn_value: null,
    cost_method_realestate_crb_value: null,
    cost_method_realestate_crn_value: null,
    comparison_method: null,
    adjusted_market_value: null,
    max_legal_method: null,
    vc: null,
    income_perpetuity_update_method: null,
    u: null,
    residual_depreciation_pct: null,
    residual_depreciation: null,
    realestate_residual_value: null,
    i: null,
    np: null,
    coef_1: null,
    current_future_income_value: null,
    coef_2: null,
    updated_reversion_value: null,
    update_value: null,
    insurance_value: null,
    vu_coef: null,
    usufruct_value: null,
    bare_ownership_value: null,
    realestate_total_adopted_value: null,
    realestate_adopted_appraisal_method: null,
    realestate_id: null,
    right_of_use_boolean: null,
    protection_boolean: null,
    protection_type: null,
    protection_regime: null,
    protection_zone: null,
    urban_planning_type: null,
    urban_planning_file: null,
    urban_planning_council_qualification: null,
    urban_planning_council_qualification_description: null,
    urban_planning_council_classification: null,
    urban_planning_council_classification_description: null,
    urban_planning_regional_qualification: null,
    urban_planning_regional_qualification_description: null,
    urban_planning_regional_classification: null,
    urban_planning_regional_classification_description: null,
    map_urban_muc_land_colors: null,
    map_urban_muc_council_qual: null,
    map_urban_icc_topo: null,
    land_registry_area: null,
    land_cadastral_area: null,
    land_checked_area: null,
    land_adopted_area: null,
    land_infrastructure_paving_execution_pct: 100,
    land_infrastructure_sewage_execution_pct: 100,
    land_infrastructure_public_lighting_execution_pct: 100,
    land_infrastructure_electricity_supply_execution_pct: 100,
    land_infrastructure_piped_gas_execution_pct: 100,
    land_infrastructure_telephone_service_execution_pct: 100,
    land_infrastructure_gardened_areas_execution_pct: 100,
    land_infrastructure_total_execution_pct: 100,
    land_infrastructure_repercussion_cost: 150,
    land_infrastructure_pending_investment: 0,
    land_infrastructure_paving: true,
    land_infrastructure_sewage: true,
    land_infrastructure_public_lighting: true,
    land_infrastructure_electricity_supply: true,
    land_infrastructure_piped_gas: true,
    land_infrastructure_telephone_service: true,
    land_infrastructure_gardened_areas: true,
    land_is_plot_according_to_law: true,
    land_area_notes: null,
    land_infrastructure_notes: null,
    land_infrastructure_conservation_status: {
        id: 2,
        code_bde: 2,
        name_ca: 'Bona',
        name_en: 'Good',
        name_es: 'Buena'
    },
    land_infrastructure_water_supply_execution_pct: 100,
    land_infrastructure_water_supply: true,
    plot_occupation: null,
    plot_free_area_usage: null,
    floors_number_underground: null,
    floors_number_overground: null,
    parking_slots_included_in_appraisal_number: null,
    entrance_hall: null,
    doorman_space: null,
    staircase: null,
    swimming_pool: null,
    gardened_areas: null,
    sports_facilities: null,
    community_room: null,
    storage_room: null,
    community_parking: null,
    facilities_others: null,
    floors_usage_underground: null,
    floors_usage_overground: null,
    groundfloor_usage: null,
    communications_airport: null,
    communications_harbour: null,
    communications_train: null,
    public_transport_urban_underground: null,
    public_transport_interurban: null,
    surrounding_facilities_notes: null,
    surrounding_territorial_feature: null,
    surrounding_income_level: null,
    surrounding_homogeneity_feature: null,
    surrounding_main_uses: null,
    surrounding_density: null,
    surrounding_accessibility: null,
    surrounding_consolidation_degree: null,
    surrounding_occupation_degree: null,
    surrounding_evolution_speed: null,
    surrounding_average_age: null,
    surrounding_conservation_status: null,
    surrounding_commercial_facilities: null,
    surrounding_educational_facilities: null,
    surrounding_public_parking: null,
    surrounding_medical_assistance: null,
    surrounding_leisure: null,
    cadastral_usage: null,
    cadastral_floor: null,
    cadastral_door: null,
    cadastral_block: null,
    cadastral_staircase: null,
    registry_name: null,
    registry_section: null,
    registry_volume: null,
    registry_book: null,
    registry_page: null,
    registry_real_estate_number: null,
    registry_idufir: null,
    registry_owner: null,
    registry_property_coef: null,
    net_cadastral_area: null,
    net_registry_area: null,
    net_checked_area: null,
    net_adopted_area: null,
    enclosed_cadastral_area: null,
    enclosed_registry_area: null,
    enclosed_checked_area: null,
    enclosed_adopted_area: null,
    covered_terraces_total_cadastral_area: null,
    covered_terraces_total_registry_area: null,
    covered_terraces_total_checked_area: null,
    covered_terraces_total_adopted_area: null,
    uncovered_terraces_total_cadastral_area: null,
    uncovered_terraces_total_registry_area: null,
    uncovered_terraces_total_checked_area: null,
    uncovered_terraces_total_adopted_area: null,
    built_cadastral_area: null,
    built_registry_area: null,
    built_checked_area: null,
    built_adopted_area: null,
    common_elements_cadastral_area: null,
    common_elements_registry_area: null,
    common_elements_checked_area: null,
    common_elements_adopted_area: null,
    built_plus_common_elements_cadastral_area: null,
    built_plus_common_elements_registry_area: null,
    built_plus_common_elements_checked_area: null,
    built_plus_common_elements_adopted_area: null,
    bathrooms_number: null,
    bedrooms_number: null,
    net_selected_area: {
        id: 1,
        name_ca: 'Auto',
        name_en: 'Auto',
        name_es: 'Auto'
    },
    enclosed_selected_area: {
        id: 1,
        name_ca: 'Auto',
        name_en: 'Auto',
        name_es: 'Auto'
    },
    covered_outdoors_selected_area: {
        id: 1,
        name_ca: 'Auto',
        name_en: 'Auto',
        name_es: 'Auto'
    },
    built_selected_area: {
        id: 1,
        name_ca: 'Auto',
        name_en: 'Auto',
        name_es: 'Auto'
    },
    common_elements_selected_area: {
        id: 1,
        name_ca: 'Auto',
        name_en: 'Auto',
        name_es: 'Auto'
    },
    built_plus_common_elements_selected_area: {
        id: 1,
        name_ca: 'Auto',
        name_en: 'Auto',
        name_es: 'Auto'
    },
    land_selected_area: {
        id: 1,
        name_ca: 'Auto',
        name_en: 'Auto',
        name_es: 'Auto'
    },
    realestate_rooms_to_exterior_number: null,
    realestate_day_night_zoning: null,
    realestate_systems_door_opener: null,
    realestate_systems_fitted_cupboards: null,
    realestate_systems_gas: null,
    realestate_systems_sanitary_fittings: null,
    realestate_systems_taps: null,
    realestate_systems_hot_water: null,
    realestate_systems_heating: null,
    realestate_systems_air_conditioning: null,
    realestate_systems_tv: null,
    realestate_systems_telephone: null,
    realestate_systems_fire_prevention: null,
    realestate_systems_intrusion_prevention: null,
    realestate_foundation: null,
    realestate_structure: null,
    realestate_roof: null,
    realestate_external_enclosures: null,
    realestate_insulation: null,
    realestate_external_carpentry: null,
    realestate_glazing: null,
    realestate_interior_paving_living: null,
    realestate_interior_paving_corridor: null,
    realestate_interior_paving_bedroom: null,
    realestate_interior_paving_kitchen: null,
    realestate_interior_paving_bathroom: null,
    realestate_interior_paving_quality: null,
    realestate_interior_walls_living: null,
    realestate_interior_walls_corridor: null,
    realestate_interior_walls_bedroom: null,
    realestate_interior_walls_kitchen: null,
    realestate_interior_walls_bathroom: null,
    realestate_interior_walls_quality: null,
    realestate_interior_ceilings_living: null,
    realestate_interior_ceilings_corridor: null,
    realestate_interior_ceilings_bedroom: null,
    realestate_interior_ceilings_kitchen: null,
    realestate_interior_ceilings_bathroom: null,
    realestate_interior_ceilings_quality: null,
    realestate_interior_carpentry_living: null,
    realestate_interior_carpentry_corridor: null,
    realestate_interior_carpentry_bedroom: null,
    realestate_interior_carpentry_kitchen: null,
    realestate_interior_carpentry_bathroom: null,
    realestate_interior_carpentry_quality: null,
    realestate_main_orientation: null,
    realestate_main_views: null,
    realestate_windows_size_and_quantity: null,
    realestate_noise_facade: null,
    realestate_systems_sanitary_fittings_quality: null,
    realestate_systems_taps_quality: null,
    bec_adjustment_coef: 1,
    bec_property_type: null,
    bec_number: null,
    construction_status: {
        id: 1,
        name_ca: 'Acabat',
        name_es: 'Terminado',
        name_en: 'Finished',
        code_bde: 'U00'
    },
    expenses_and_industrial_benefit_bec_pct: 20,
    construction_cost_notes: null,
    cadastral_construction_year: null,
    construction_year: null,
    last_renovation_year: null,
    nucleus_population: null,
    nucleus_population_density: null,
    nucleus_population_growth: null,
    occupation_agriculture_pct: null,
    occupation_industry_pct: null,
    occupation_construction_pct: null,
    occupation_services_pct: null,
    occupation_total_pct: null,
    nucleus_type: null,
    occupation_description: null,
    nucleus_area: null,
    property_title: null,
    usage_assigned: null,
    inspection_realized: null,
    economical_activity: null,
    occupancy_status: null,
    marketstudy_id: null,
    parking_spots_included_number: null,
    notes: {
        note_001: {
            name_ca: 'Aquesta taxació s\'ha realitzat d\'acord amb els requisits recollits a l\'Ordre ECO-805-2003 DE 27 DE MARÇ del Ministeri d\'Economia i Hisenda, sobre Valoració de Béns per a determinades entitats financeres, excepte pel que fa al que assenyala l\'apartat condicionants i advertiments generals',
            name_es: 'Esta tasación se ha realizado de acuerdo con los requisitos recogidos en la Orden ECO-805-2003 DE 27 DE MARZO del Ministerio de Economía y Hacienda, sobre Valoración de Bienes para determinadas entidades financieras, excepto en cuanto a lo que señala el apartado condicionantes y advertencias',
            name_en: ''
        },
        note_002: {
            name_ca: 'La present taxació NO és vàlida a efectes de constituir garanties hipotecàries, de provisions de fons de les companyies d\'assegurances i de fons d\'inversió Immobiliàries',
            name_es: 'La presente tasación NO es válida a efectos de constituir garantías hipotecarias, de provisiones de fondos de las compañías de seguros y de fondos de inversión Inmobiliarias',
            name_en: 'This valuation report is NOT valid for the purpose of constituting guarantees for mortgage loans, provision of funds from insurance companies and real estate investment funds'
        },
        note_003: {
            name_ca: 'Aquesta taxació té una validesa de SIS mesos a partir de la data de la seva expedició',
            name_es: 'Esta tasación tiene una validez de SEIS meses a partir de la fecha de su expedición'
        },
        note_004: {
            name_ca: 'Tant BARNA-TASA, S.A. Com els professionals que hem intervingut en l\'elaboració del present informe de taxació, declarem que coneixem i hem tingut en consideració de manera estricta i fidel les incompatibilitats establertes en els articles 6 i 13 del Reial decret 775/1997 de 30 de maig, referents tant a la Societat com als seus professionals i així ho subscrivim',
            name_es: 'Tanto BARNA-TASA, S.A. Como los profesionales que hemos intervenido en la elaboración del presente informe de tasación, declaramos que conocemos y hemos tenido en consideración de manera estricta y fiel las incompatibilidades establecidas en los artículos 6 y 13 del Real Decreto 775/1997 de 30 de mayo, referentes tanto a la Sociedad como a sus profesionales y así lo suscribimos',
            name_en: 'Both BARNA-Charges, S.A. and the professionals who have been involved in the preparation of the valuation report, we declare that we know and have in consideration strictly and faithfully the incompatibilities established in articles 6 and 13 of Royal Decree 775/1997 of 30 May, concerning both the Company and its professionals and thus subscribe them'
        },
        note_005: {
            name_ca: 'El valor de taxació expressat és el que resulta tenint en compte l\'objecte i finalitat de la valoració',
            name_es: 'El valor de tasación expresado es el que resulta teniendo en cuenta el objeto y finalidad de la valoración',
            name_en: 'The appraisal value is expressed considering the scope and purpose of the valuation'
        },
        note_006: {
            name_ca: 'La taxació s\'ha efectuat suposada la finca lliure de càrregues i gravàmens',
            name_es: 'La tasación se ha efectuado supuesta la finca libre de cargas y gravámenes',
            name_en: 'The valuation has been made considering the property is free of charges and liens'
        }
    },
    map_urban_muc_land_colors_offset_x: 0,
    map_urban_muc_land_colors_offset_y: 0,
    map_urban_muc_land_colors_zoom: 1,
    map_urban_muc_council_qual_offset_x: 0,
    map_urban_muc_council_qual_offset_y: 0,
    map_urban_muc_council_qual_zoom: 1,
    map_urban_icc_topo_offset_x: 0,
    map_urban_icc_topo_offset_y: 0,
    map_urban_icc_topo_zoom: 1,
    quote_travel_one_way_hours: 0,
    quote_travel_both_ways_hours: 0,
    quote_travel_fees_per_hour: 20,
    quote_car_expenses_one_way: 0,
    quote_car_expenses_both_ways: 0,
    quote_total_travel_fees: 0,
    quote_area_average_unit_price: null,
    quote_base_fees: null,
    quote_excess_pct: null,
    quote_base_price: null,
    quote_base_price_coef: 1,
    usage_type: null

};

var state = default_state;

var actions = {

    CREATE_NEW_APPRAISAL: function CREATE_NEW_APPRAISAL(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].create({ key: data.key, path: data.path }).then(function (res) {
                var new_created_key = res.key;

                var default_appraisaldate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(res.date_created, 'x').format('YYYY-MM-DD');

                commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_605" /* SET_APPRAISAL_ID */], new_created_key);
                commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_606" /* SET_APPRAISAL_DATE_CREATED */], res.date_created);
                commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_607" /* SET_APPRAISAL_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_608" /* SET_APPRAISAL_APPRAISALDATE */], default_appraisaldate);
                commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_609" /* SET_APPRAISAL_PARENT_PATH */], data.parent_path);
                commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_610" /* SET_APPRAISAL_PATH */], res.path);
                commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_611" /* SET_APPRAISAL_REALESTATE_ID */], data.realestate_id);

                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                    value: default_appraisaldate,
                    path: data.path + new_created_key + '/' + 'appraisaldate',
                    save_timestamp: false
                }).then(function (res) {
                    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                        value: data.realestate_id,
                        path: data.path + new_created_key + '/' + 'realestate_id',
                        save_timestamp: false
                    }).then(function (res) {
                        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                            value: new_created_key,
                            path: data.path + new_created_key + '/' + 'id',
                            save_timestamp: false
                        }).then(function (res) {
                            var object = {};
                            object[new_created_key] = true;
                            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({
                                object: object,
                                path: data.parent_path,
                                save_timestamp: false
                            }).then(function (res) {
                                return resolve({ key: new_created_key });
                            });
                        });
                    });
                });
            });
        });
    },
    DELETE_APPRAISAL: function DELETE_APPRAISAL(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;


        return new Promise(function (resolve, reject) {

            // console.log('path check: ' + data.path)
            // console.log('parent_path check: ' + data.parent_path)

            // delete from contact_appraisals/contact_key
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.path }).then(function (res) {
                // delete from contact/contact_key/appraisals
                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.parent_path }).then(function (res) {
                    commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_612" /* RESET_APPRAISAL */]);
                }).then(function (res) {
                    return resolve({});
                });
            });
        });
    },
    FETCH_APPRAISAL: function FETCH_APPRAISAL(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;

        return new Promise(function (resolve, reject) {
            return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                resolve(res);
            });
        });
    },
    SET_APPRAISAL: function SET_APPRAISAL(_ref4, data) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;


        return new Promise(function (resolve, reject) {

            // console.log('set_appraisal data:')
            // console.log(data)
            return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                console.log(res);
                commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_613" /* SET_APPRAISAL */], res);
            }).then(function (res) {
                return resolve({});
            });
        });
    },
    RESET_APPRAISAL: function RESET_APPRAISAL(_ref5) {
        var state = _ref5.state,
            commit = _ref5.commit,
            rootState = _ref5.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_612" /* RESET_APPRAISAL */]);
    },
    REQUEST_IDESCAT_INFO_BY_CODE_INE: function REQUEST_IDESCAT_INFO_BY_CODE_INE(_ref6, data) {
        var state = _ref6.state,
            commit = _ref6.commit,
            rootState = _ref6.rootState;


        return __WEBPACK_IMPORTED_MODULE_1__maps_api__["a" /* default */].request_idescat_info_by_code_ine(data).then(function (res) {

            console.log('request_idescat_info_by_code_ine res:');
            console.log(res);

            var val_arr = [];

            // 1: Població
            // 0: Densitat de població
            // 0: Superfície
            var nucleus_area = res['html']['fitxes']['gg']['g'][1]['tt']['t'][0]['ff']['f'][0]['v'];
            val_arr = nucleus_area.split(',');
            nucleus_area = Number(val_arr[0]);
            console.log('nucleus_area: ');
            console.log(nucleus_area);

            // 1: Població
            // 0: Densitat de població
            // 1: Densitat
            var nucleus_population_density = res['html']['fitxes']['gg']['g'][1]['tt']['t'][0]['ff']['f'][1]['v'];
            val_arr = nucleus_population_density.split(',');
            nucleus_population_density = Number(val_arr[0]);
            console.log('nucleus_population_density: ');
            console.log(nucleus_population_density);

            // 1: Població
            // 1: Població. Per sexe
            // 2: Total
            var nucleus_population = res['html']['fitxes']['gg']['g'][1]['tt']['t'][1]['ff']['f'][2]['v'];
            val_arr = nucleus_population.split(',');
            nucleus_population = Number(val_arr[0]);
            console.log('nucleus_population: ');
            console.log(nucleus_population);

            // 1: Població
            // 19: Creixement de la població
            // 4: Creixement total

            var nucleus_population_growth = null;
            var nucleus_pre_19 = res['html']['fitxes']['gg']['g'][1]['tt']['t'][19];
            var nucleus_pre_17 = res['html']['fitxes']['gg']['g'][1]['tt']['t'][17];

            if (nucleus_pre_19) {
                var nucleus_pre = res['html']['fitxes']['gg']['g'][1]['tt']['t'][19]['ff']['f'];
                //nucleus_population_growth = res['html']['fitxes']['gg']['g'][1]['tt']['t'][19]['ff']['f'][4]['v']

                if (nucleus_pre) {

                    _.forEach(nucleus_pre, function (value) {
                        if (value['c'] === 'Creixement total') {
                            nucleus_population_growth = value['v'];
                            if (nucleus_population_growth) {
                                val_arr = nucleus_population_growth.split(',');
                                nucleus_population_growth = Number(val_arr[0]);
                                console.log('nucleus_population_growth: ');
                                console.log(nucleus_population_growth);
                            }
                        }
                    });
                }
            } else if (nucleus_pre_17) {
                var _nucleus_pre = res['html']['fitxes']['gg']['g'][1]['tt']['t'][17]['ff']['f'];

                if (_nucleus_pre) {

                    _.forEach(_nucleus_pre, function (value) {
                        if (value['c'] === 'Creixement total') {
                            nucleus_population_growth = value['v'];
                            if (nucleus_population_growth) {
                                val_arr = nucleus_population_growth.split(',');
                                nucleus_population_growth = Number(val_arr[0]);
                                console.log('nucleus_population_growth: ');
                                console.log(nucleus_population_growth);
                            }
                        }
                    });
                }
            } else {}

            // 5: Treball
            // 3: Afiliacions al règim general de la S.S. segons ubicació del compte de cotització. Per sectors
            // 0: Agricultura
            var occupation_general_agriculture = res['html']['fitxes']['gg']['g'][5]['tt']['t'][3]['ff']['f'][0]['v'];
            val_arr = occupation_general_agriculture.split(',');
            occupation_general_agriculture = Number(val_arr[0]);
            if (isNaN(occupation_general_agriculture)) {
                occupation_general_agriculture = 0;
            }
            console.log('occupation_general_agriculture: ');
            console.log(occupation_general_agriculture);

            // 5: Treball
            // 3: Afiliacions al règim general de la S.S. segons ubicació del compte de cotització. Per sectors
            // 1: Indústria
            var occupation_general_industry = res['html']['fitxes']['gg']['g'][5]['tt']['t'][3]['ff']['f'][1]['v'];
            val_arr = occupation_general_industry.split(',');
            occupation_general_industry = Number(val_arr[0]);
            if (isNaN(occupation_general_industry)) {
                occupation_general_industry = 0;
            }
            console.log('occupation_general_industry: ');
            console.log(occupation_general_industry);

            // 5: Treball
            // 3: Afiliacions al règim general de la S.S. segons ubicació del compte de cotització. Per sectors
            // 2: Construcció
            var occupation_general_construction = res['html']['fitxes']['gg']['g'][5]['tt']['t'][3]['ff']['f'][2]['v'];
            val_arr = occupation_general_construction.split(',');
            occupation_general_construction = Number(val_arr[0]);
            if (isNaN(occupation_general_construction)) {
                occupation_general_construction = 0;
            }
            console.log('occupation_general_construction: ');
            console.log(occupation_general_construction);

            // 5: Treball
            // 3: Afiliacions al règim general de la S.S. segons ubicació del compte de cotització. Per sectors
            // 3: Serveis
            var occupation_general_services = res['html']['fitxes']['gg']['g'][5]['tt']['t'][3]['ff']['f'][3]['v'];
            val_arr = occupation_general_services.split(',');
            occupation_general_services = Number(val_arr[0]);
            if (isNaN(occupation_general_services)) {
                occupation_general_services = 0;
            }
            console.log('occupation_general_services: ');
            console.log(occupation_general_services);

            // 5: Treball
            // 3: Afiliacions al règim general de la S.S. segons ubicació del compte de cotització. Per sectors
            // 4: Total
            var occupation_general_total = res['html']['fitxes']['gg']['g'][5]['tt']['t'][3]['ff']['f'][4]['v'];
            val_arr = occupation_general_total.split(',');
            occupation_general_total = Number(val_arr[0]);
            if (isNaN(occupation_general_total)) {
                occupation_general_total = 0;
            }
            console.log('occupation_general_total: ');
            console.log(occupation_general_total);

            // 5: Treball
            // 4: Afiliacions al règim d'autònoms de la S.S. segons ubicació del compte de cotització. Per sectors
            // 0: Agricultura
            var occupation_freelance_agriculture = res['html']['fitxes']['gg']['g'][5]['tt']['t'][4]['ff']['f'][0]['v'];
            val_arr = occupation_freelance_agriculture.split(',');
            occupation_freelance_agriculture = Number(val_arr[0]);
            console.log('occupation_freelance_agriculture: ');
            console.log(occupation_freelance_agriculture);

            // 5: Treball
            // 4: Afiliacions al règim d'autònoms de la S.S. segons ubicació del compte de cotització. Per sectors
            // 1: Indústria
            var occupation_freelance_industry = res['html']['fitxes']['gg']['g'][5]['tt']['t'][4]['ff']['f'][1]['v'];
            val_arr = occupation_freelance_industry.split(',');
            occupation_freelance_industry = Number(val_arr[0]);
            console.log('occupation_freelance_industry: ');
            console.log(occupation_freelance_industry);

            // 5: Treball
            // 4: Afiliacions al règim d'autònoms de la S.S. segons ubicació del compte de cotització. Per sectors
            // 2: Construcció
            var occupation_freelance_construction = res['html']['fitxes']['gg']['g'][5]['tt']['t'][4]['ff']['f'][2]['v'];
            val_arr = occupation_freelance_construction.split(',');
            occupation_freelance_construction = Number(val_arr[0]);
            console.log('occupation_freelance_construction: ');
            console.log(occupation_freelance_construction);

            // 5: Treball
            // 4: Afiliacions al règim d'autònoms de la S.S. segons ubicació del compte de cotització. Per sectors
            // 3: Serveis

            var occupation_f_s_pre = res['html']['fitxes']['gg']['g'][5]['tt']['t'][4]['ff']['f'][3];
            var occupation_freelance_services = 0;

            if (occupation_f_s_pre) {
                occupation_freelance_services = res['html']['fitxes']['gg']['g'][5]['tt']['t'][4]['ff']['f'][3]['v'];
                val_arr = occupation_freelance_services.split(',');
                occupation_freelance_services = Number(val_arr[0]);
            } else {}
            console.log('occupation_freelance_services: ');
            console.log(occupation_freelance_services);

            // 5: Treball
            // 4: Afiliacions al règim d'autònoms de la S.S. segons ubicació del compte de cotització. Per sectors
            // 4: Total
            var occupation_f_t_pre = res['html']['fitxes']['gg']['g'][5]['tt']['t'][4]['ff']['f'][4];
            var occupation_freelance_total = 0;

            if (occupation_f_t_pre) {
                occupation_freelance_total = res['html']['fitxes']['gg']['g'][5]['tt']['t'][4]['ff']['f'][4]['v'];
                val_arr = occupation_freelance_total.split(',');
                occupation_freelance_total = Number(val_arr[0]);
            } else {}
            console.log('occupation_freelance_total: ');
            console.log(occupation_freelance_total);

            var occupation_agriculture = occupation_general_agriculture + occupation_freelance_agriculture;
            var occupation_industry = occupation_general_industry + occupation_freelance_industry;
            var occupation_construction = occupation_general_construction + occupation_freelance_construction;
            var occupation_services = occupation_general_services + occupation_freelance_services;
            var occupation_total = occupation_general_total + occupation_freelance_total;

            var occupation_agriculture_pct = roundToTwo(occupation_agriculture / occupation_total * 100);
            var occupation_industry_pct = roundToTwo(occupation_industry / occupation_total * 100);
            var occupation_construction_pct = roundToTwo(occupation_construction / occupation_total * 100);
            var occupation_services_pct = roundToTwo(occupation_services / occupation_total * 100);
            var occupation_total_pct = roundToTwo(occupation_total / occupation_total * 100);

            /*
            let occupation_description = {
                id: 1,
                'name_ca': 'El ' + occupation_services_pct + '% de la població està ocupat al sector Serveis, el ' + occupation_industry_pct + '% al sector Indústria, ' + occupation_construction_pct + '% al sector de la Construcció i el ' + occupation_agriculture_pct + '% al sector Agricultura',
                'name_en': 'The ' + occupation_services_pct + '% of the population is employed in the Services sector, the ' + occupation_industry_pct + '% in the Industry sector, ' + occupation_construction_pct + '% in the Construction sector and the ' + occupation_agriculture_pct + '% in the Agriculture sector',
                'name_es': 'El ' + occupation_services_pct + '% de la población está ocupado en el sector Servicios, el ' + occupation_industry_pct + '% en el sector Industria, ' + occupation_construction_pct + '% en el sector de la Construcción y el ' + occupation_agriculture_pct + '% en el sector Agricultura'
            }*/

            var occupation_description = 'El ' + occupation_services_pct + '% de la població està ocupat al sector Serveis, el ' + occupation_industry_pct + '% al sector Indústria, el ' + occupation_construction_pct + '% al sector de la Construcció i el ' + occupation_agriculture_pct + '% al sector Agricultura';

            var nucleus_type = {};
            if (nucleus_population < 5000) {
                nucleus_type = {
                    'id': 1,
                    'name_ca': 'Municipi de mida molt petita, menys de cinc mil habitants',
                    'name_en': 'Very small municipality with less than five thousand inhabitants',
                    'name_es': 'Municipio de tamaño muy pequeño, menos de cinco mil habitantes'
                };
            } else if (nucleus_population < 20000) {
                nucleus_type = {
                    'id': 2,
                    'name_ca': 'Municipi de mida petita, entre cinc mil i vint mil habitants',
                    'name_en': 'Small municipality, between five and twenty thousand inhabitants',
                    'name_es': 'Municipio de tamaño pequeño, entre cinco mil y veinte mil habitantes'
                };
            } else if (nucleus_population < 50000) {
                nucleus_type = {
                    'id': 3,
                    'name_ca': 'Municipi de mida mitjana, entre vint mil i cinquanta mil habitants',
                    'name_en': 'Medium size municipality, between twenty and fifty thousand inhabitants',
                    'name_es': 'Municipio de tamaño medio, entre veinte mil y cincuenta mil habitantes'
                };
            } else if (nucleus_population < 100000) {
                nucleus_type = {
                    'id': 4,
                    'name_ca': 'Municipi important, entre cinquanta mil i cent mil habitants',
                    'name_en': 'Important municipality, between fifty and one hundred thousand inhabitants',
                    'name_es': 'Municipio importante, entre cincuenta mil y cien mil habitantes'
                };
            } else if (nucleus_population < 500000) {
                nucleus_type = {
                    'id': 5,
                    'name_ca': 'Ciutat de mida gran, entre cent mil i cinc-cents mil habitants',
                    'name_en': 'Big city, between one hundred thousand and five hundred thousand inhabitants',
                    'name_es': 'Ciudad de gran tamaño, entre cien mil y quinientos mil habitantes'
                };
            } else if (nucleus_population >= 500000) {
                nucleus_type = {
                    'id': 6,
                    'name_ca': 'Gran capital, major de cinc-cents mil habitants',
                    'name_en': 'Big capital, more than five hundred thousand inhabitants',
                    'name_es': 'Gran capital, mayor de quinientos mil habitantes'
                };
            }

            nucleus_type = nucleus_type['name_ca'];

            // console.log('nucleus_type: ')
            // console.log(nucleus_type)

            commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_614" /* SET_APPRAISAL_NUCLEUS_POPULATION */], nucleus_population);
            commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_615" /* SET_APPRAISAL_NUCLEUS_AREA */], nucleus_area);
            commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_616" /* SET_APPRAISAL_NUCLEUS_POPULATION_DENSITY */], nucleus_population_density);
            commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_617" /* SET_APPRAISAL_NUCLEUS_POPULATION_GROWTH */], nucleus_population_growth);
            commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_618" /* SET_APPRAISAL_NUCLEUS_TYPE */], nucleus_type);
            commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_619" /* SET_APPRAISAL_OCCUPATION_DESCRIPTION */], occupation_description);
        });
    },
    REQUEST_MUC_INFO: function REQUEST_MUC_INFO(_ref7, data) {
        var state = _ref7.state,
            commit = _ref7.commit,
            rootState = _ref7.rootState;


        return __WEBPACK_IMPORTED_MODULE_1__maps_api__["a" /* default */].request_muc_info(data).then(function (res) {

            console.log('request_muc_info res:');
            console.log(res);

            // parse the html response from ICC
            var div = document.createElement('div');
            div.innerHTML = res.html;
            var tds = div.querySelectorAll('td');
            var trs = div.querySelectorAll('tr');

            // console.log('div: ')
            // console.log(div)

            var new_obj = {};

            for (var i = 0; i < tds.length - 1; i = i + 2) {

                console.log('tds[i].innerText: ');
                console.log(tds[i].innerText);

                var key = tds[i].innerText.toLowerCase();
                var value = tds[i + 1].innerText.toUpperCase();

                if (tds[i].innerText.toLowerCase() === 'expedient') {
                    new_obj[key] = value;
                } else if (tds[i].innerText.toLowerCase() === 'codi_clas_ajunt') {
                    new_obj[key] = value;
                } else if (tds[i].innerText.toLowerCase() === 'codi_qual_ajunt') {
                    new_obj[key] = value;
                } else if (tds[i].innerText.toLowerCase() === 'desc_clas_ajunt') {
                    new_obj[key] = value;
                } else if (tds[i].innerText.toLowerCase() === 'desc_qual_ajunt') {
                    new_obj[key] = value;
                } else if (tds[i].innerText.toLowerCase() === 'codi_clas_muc') {
                    new_obj[key] = value;
                } else if (tds[i].innerText.toLowerCase() === 'codi_qual_muc') {
                    new_obj[key] = value;
                } else if (tds[i].innerText.toLowerCase() === 'desc_clas_muc') {
                    new_obj[key] = value;
                } else if (tds[i].innerText.toLowerCase() === 'desc_qual_muc') {
                    new_obj[key] = value;
                } else if (tds[i].innerText.toLowerCase().includes('tipus')) {
                    new_obj[key] = value;
                }

                if (!'expedient' in new_obj) {
                    if (tds[i].innerText.toLowerCase().includes('expedient')) {
                        var arr = tds[i].innerText.split('TIPUS');
                        console.log('arr: ');
                        console.log(arr);
                        if (arr.length > 0) {
                            new_obj['expedient'] = arr[0].replace('EXPEDIENT', '');
                            console.log('yeah--> new_obj[\'expedient\'] ');
                            console.log(new_obj['expedient']);
                        }
                    }
                }
            }

            for (var _i = 0; _i < trs.length - 1; _i = _i + 2) {

                console.log('trs[i].innerText: ');
                console.log(trs[_i].innerText);

                if (trs[_i].innerText.toLowerCase().includes('tipus')) {
                    new_obj['tipus'] = trs[_i].innerText.replace('TIPUS', '');
                }
                /*
                else if (trs[i].innerText.toLowerCase().includes('expedient')) {
                    console.log('it includes expedient')
                    let arr = trs[i].innerText.split('TIPUS')
                    console.log('arr: ')
                    console.log(arr)
                    if(arr.length>0){
                        new_obj['expedient'] = arr.replace('EXPEDIENT', '')
                    }
                 }
                */
            }

            console.log('new_obj: ');
            console.log(new_obj);

            // console.log(census_obj)

            // const census_section_code = '' + census_obj.municipi + census_obj.districte + census_obj.seccio

            commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_620" /* SET_APPRAISAL_URBAN_PLANNING_TYPE */], new_obj['tipus']);
            commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_621" /* SET_APPRAISAL_URBAN_PLANNING_FILE */], new_obj['expedient']);
            commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_622" /* SET_APPRAISAL_URBAN_PLANNING_COUNCIL_QUALIFICATION */], new_obj['codi_qual_ajunt']);
            commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_623" /* SET_APPRAISAL_URBAN_PLANNING_COUNCIL_QUALIFICATION_DESCRIPTION */], new_obj['desc_qual_ajunt']);
            commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_624" /* SET_APPRAISAL_URBAN_PLANNING_COUNCIL_CLASSIFICATION */], new_obj['codi_clas_ajunt']);
            commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_625" /* SET_APPRAISAL_URBAN_PLANNING_COUNCIL_CLASSIFICATION_DESCRIPTION */], new_obj['desc_clas_ajunt']);
            commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_626" /* SET_APPRAISAL_URBAN_PLANNING_REGIONAL_QUALIFICATION */], new_obj['codi_qual_muc']);
            commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_627" /* SET_APPRAISAL_URBAN_PLANNING_REGIONAL_QUALIFICATION_DESCRIPTION */], new_obj['desc_qual_muc']);
            commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_628" /* SET_APPRAISAL_URBAN_PLANNING_REGIONAL_CLASSIFICATION */], new_obj['codi_clas_muc']);
            commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_629" /* SET_APPRAISAL_URBAN_PLANNING_REGIONAL_CLASSIFICATION_DESCRIPTION */], new_obj['desc_clas_muc']);
        });
    },
    REQUEST_MAP_URBAN_MUC_LAND_COLORS_BY_BBOX: function REQUEST_MAP_URBAN_MUC_LAND_COLORS_BY_BBOX(_ref8, data) {
        var state = _ref8.state,
            commit = _ref8.commit,
            rootState = _ref8.rootState;

        // console.log('REQUEST_MUC_MAP data in appraisal.js: ')
        // console.log(data)
        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_1__maps_api__["a" /* default */].request_map_urban_muc_land_colors_by_bbox(data).then(function (res) {
                // console.log('request_muc_map response in appraisal.js:')
                // console.log(res)
                console.log('link: ');
                console.log(res.link);

                commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_630" /* SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS */], res.link);

                resolve(res.link);
            }, function (res) {
                console.error(res);
                reject();
            });
        });
    },
    REQUEST_MAP_URBAN_MUC_COUNCIL_QUAL_BY_BBOX: function REQUEST_MAP_URBAN_MUC_COUNCIL_QUAL_BY_BBOX(_ref9, data) {
        var state = _ref9.state,
            commit = _ref9.commit,
            rootState = _ref9.rootState;

        // console.log('REQUEST_MUC_MAP data in appraisal.js: ')
        // console.log(data)
        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_1__maps_api__["a" /* default */].request_map_urban_muc_council_qual_by_bbox(data).then(function (res) {
                // console.log('request_muc_map response in appraisal.js:')
                // console.log(res)
                console.log('link: ');
                console.log(res.link);

                commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_631" /* SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL */], res.link);

                resolve(res.link);
            }, function (res) {
                console.error(res);
                reject();
            });
        });
    },
    REQUEST_MAP_URBAN_ICC_TOPO_BY_BBOX: function REQUEST_MAP_URBAN_ICC_TOPO_BY_BBOX(_ref10, data) {
        var state = _ref10.state,
            commit = _ref10.commit,
            rootState = _ref10.rootState;

        // console.log('REQUEST_MUC_MAP data in appraisal.js: ')
        // console.log(data)
        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_1__maps_api__["a" /* default */].request_map_urban_icc_topo_by_bbox(data).then(function (res) {
                // console.log('request_muc_map response in appraisal.js:')
                // console.log(res)
                console.log('link: ');
                console.log(res.link);

                commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_632" /* SET_APPRAISAL_MAP_URBAN_ICC_TOPO */], res.link);

                resolve(res.link);
            }, function (res) {
                console.error(res);
                reject();
            });
        });
    },
    SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS: function SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS(_ref11, data) {
        var state = _ref11.state,
            commit = _ref11.commit,
            rootState = _ref11.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_630" /* SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS */], data);
    },
    SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL: function SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL(_ref12, data) {
        var state = _ref12.state,
            commit = _ref12.commit,
            rootState = _ref12.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_631" /* SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL */], data);
    },
    SET_APPRAISAL_MAP_URBAN_ICC_TOPO: function SET_APPRAISAL_MAP_URBAN_ICC_TOPO(_ref13, data) {
        var state = _ref13.state,
            commit = _ref13.commit,
            rootState = _ref13.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_632" /* SET_APPRAISAL_MAP_URBAN_ICC_TOPO */], data);
    },
    SET_APPRAISAL_APPRAISALDATE: function SET_APPRAISAL_APPRAISALDATE(_ref14, data) {
        var state = _ref14.state,
            commit = _ref14.commit,
            rootState = _ref14.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_608" /* SET_APPRAISAL_APPRAISALDATE */], data);
    },
    SET_APPRAISAL_VISITDATE: function SET_APPRAISAL_VISITDATE(_ref15, data) {
        var state = _ref15.state,
            commit = _ref15.commit,
            rootState = _ref15.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_633" /* SET_APPRAISAL_VISITDATE */], data);
    },
    SET_APPRAISAL_TECHNICIAN_VISITING: function SET_APPRAISAL_TECHNICIAN_VISITING(_ref16, data) {
        var state = _ref16.state,
            commit = _ref16.commit,
            rootState = _ref16.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_634" /* SET_APPRAISAL_TECHNICIAN_VISITING */], data);
    },
    SET_APPRAISAL_DATE_CREATED: function SET_APPRAISAL_DATE_CREATED(_ref17, data) {
        var state = _ref17.state,
            commit = _ref17.commit,
            rootState = _ref17.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_606" /* SET_APPRAISAL_DATE_CREATED */], data);
    },
    SET_APPRAISAL_DATE_MODIFIED: function SET_APPRAISAL_DATE_MODIFIED(_ref18, data) {
        var state = _ref18.state,
            commit = _ref18.commit,
            rootState = _ref18.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_607" /* SET_APPRAISAL_DATE_MODIFIED */], data);
    },

    SET_APPRAISAL_ID: function SET_APPRAISAL_ID(_ref19, data) {
        var state = _ref19.state,
            commit = _ref19.commit,
            rootState = _ref19.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_605" /* SET_APPRAISAL_ID */], data);
    },

    SET_APPRAISAL_PATH: function SET_APPRAISAL_PATH(_ref20, data) {
        var state = _ref20.state,
            commit = _ref20.commit,
            rootState = _ref20.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_610" /* SET_APPRAISAL_PATH */], data);
    },
    UPDATE_APPRAISAL: function UPDATE_APPRAISAL(_ref21, data) {
        var state = _ref21.state,
            commit = _ref21.commit,
            rootState = _ref21.rootState;

        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({ object: data.object, path: data.path, save_timestamp: true }).then(function (res) {

            commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_607" /* SET_APPRAISAL_DATE_MODIFIED */], res.date_modified);
            commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_635" /* SET_APPRAISAL_DIRTYNESS */], false);
        });
    },
    SET_APPRAISAL_CHECKS_CADASTRAL_DATA: function SET_APPRAISAL_CHECKS_CADASTRAL_DATA(_ref22, data) {
        var state = _ref22.state,
            commit = _ref22.commit,
            rootState = _ref22.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_636" /* SET_APPRAISAL_CHECKS_CADASTRAL_DATA */], data);
    },
    SET_APPRAISAL_CHECKS_CONSERVATION_STATUS: function SET_APPRAISAL_CHECKS_CONSERVATION_STATUS(_ref23, data) {
        var state = _ref23.state,
            commit = _ref23.commit,
            rootState = _ref23.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_637" /* SET_APPRAISAL_CHECKS_CONSERVATION_STATUS */], data);
    },
    SET_APPRAISAL_CHECKS_EXPROPRIATION_PROCEDURE: function SET_APPRAISAL_CHECKS_EXPROPRIATION_PROCEDURE(_ref24, data) {
        var state = _ref24.state,
            commit = _ref24.commit,
            rootState = _ref24.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_638" /* SET_APPRAISAL_CHECKS_EXPROPRIATION_PROCEDURE */], data);
    },
    SET_APPRAISAL_CHECKS_EXPROPRIATION_PLAN: function SET_APPRAISAL_CHECKS_EXPROPRIATION_PLAN(_ref25, data) {
        var state = _ref25.state,
            commit = _ref25.commit,
            rootState = _ref25.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_639" /* SET_APPRAISAL_CHECKS_EXPROPRIATION_PLAN */], data);
    },
    SET_APPRAISAL_CHECKS_EXPROPRIATION_ADMIN_RULING: function SET_APPRAISAL_CHECKS_EXPROPRIATION_ADMIN_RULING(_ref26, data) {
        var state = _ref26.state,
            commit = _ref26.commit,
            rootState = _ref26.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_640" /* SET_APPRAISAL_CHECKS_EXPROPRIATION_ADMIN_RULING */], data);
    },
    SET_APPRAISAL_CHECKS_EXPROPRIATION_FILE: function SET_APPRAISAL_CHECKS_EXPROPRIATION_FILE(_ref27, data) {
        var state = _ref27.state,
            commit = _ref27.commit,
            rootState = _ref27.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_641" /* SET_APPRAISAL_CHECKS_EXPROPRIATION_FILE */], data);
    },
    SET_APPRAISAL_CHECKS_INTERIOR_VISIT: function SET_APPRAISAL_CHECKS_INTERIOR_VISIT(_ref28, data) {
        var state = _ref28.state,
            commit = _ref28.commit,
            rootState = _ref28.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_642" /* SET_APPRAISAL_CHECKS_INTERIOR_VISIT */], data);
    },
    SET_APPRAISAL_CHECKS_OCCUPANCY: function SET_APPRAISAL_CHECKS_OCCUPANCY(_ref29, data) {
        var state = _ref29.state,
            commit = _ref29.commit,
            rootState = _ref29.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_643" /* SET_APPRAISAL_CHECKS_OCCUPANCY */], data);
    },
    SET_APPRAISAL_CHECKS_OTHER: function SET_APPRAISAL_CHECKS_OTHER(_ref30, data) {
        var state = _ref30.state,
            commit = _ref30.commit,
            rootState = _ref30.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_644" /* SET_APPRAISAL_CHECKS_OTHER */], data);
    },
    SET_APPRAISAL_CHECKS_REGISTRY_DATA: function SET_APPRAISAL_CHECKS_REGISTRY_DATA(_ref31, data) {
        var state = _ref31.state,
            commit = _ref31.commit,
            rootState = _ref31.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_645" /* SET_APPRAISAL_CHECKS_REGISTRY_DATA */], data);
    },
    SET_APPRAISAL_CHECKS_SERVITUDES: function SET_APPRAISAL_CHECKS_SERVITUDES(_ref32, data) {
        var state = _ref32.state,
            commit = _ref32.commit,
            rootState = _ref32.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_646" /* SET_APPRAISAL_CHECKS_SERVITUDES */], data);
    },
    SET_APPRAISAL_CHECKS_SUBSIDY_STATUS: function SET_APPRAISAL_CHECKS_SUBSIDY_STATUS(_ref33, data) {
        var state = _ref33.state,
            commit = _ref33.commit,
            rootState = _ref33.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_647" /* SET_APPRAISAL_CHECKS_SUBSIDY_STATUS */], data);
    },
    SET_APPRAISAL_CHECKS_URBAN_PLANNING: function SET_APPRAISAL_CHECKS_URBAN_PLANNING(_ref34, data) {
        var state = _ref34.state,
            commit = _ref34.commit,
            rootState = _ref34.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_648" /* SET_APPRAISAL_CHECKS_URBAN_PLANNING */], data);
    },
    SET_APPRAISAL_DOCS_APPROVED_PROJECT: function SET_APPRAISAL_DOCS_APPROVED_PROJECT(_ref35, data) {
        var state = _ref35.state,
            commit = _ref35.commit,
            rootState = _ref35.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_649" /* SET_APPRAISAL_DOCS_APPROVED_PROJECT */], data);
    },
    SET_APPRAISAL_DOCS_CADASTRAL_DATA: function SET_APPRAISAL_DOCS_CADASTRAL_DATA(_ref36, data) {
        var state = _ref36.state,
            commit = _ref36.commit,
            rootState = _ref36.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_650" /* SET_APPRAISAL_DOCS_CADASTRAL_DATA */], data);
    },
    SET_APPRAISAL_DOCS_CONSTRUCTION_LICENSE: function SET_APPRAISAL_DOCS_CONSTRUCTION_LICENSE(_ref37, data) {
        var state = _ref37.state,
            commit = _ref37.commit,
            rootState = _ref37.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_651" /* SET_APPRAISAL_DOCS_CONSTRUCTION_LICENSE */], data);
    },
    SET_APPRAISAL_DOCS_CONSTRUCTION_LAST_CERTIFICATE: function SET_APPRAISAL_DOCS_CONSTRUCTION_LAST_CERTIFICATE(_ref38, data) {
        var state = _ref38.state,
            commit = _ref38.commit,
            rootState = _ref38.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_652" /* SET_APPRAISAL_DOCS_CONSTRUCTION_LAST_CERTIFICATE */], data);
    },
    SET_APPRAISAL_DOCS_CONSTRUCTION_CONTRACT: function SET_APPRAISAL_DOCS_CONSTRUCTION_CONTRACT(_ref39, data) {
        var state = _ref39.state,
            commit = _ref39.commit,
            rootState = _ref39.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_653" /* SET_APPRAISAL_DOCS_CONSTRUCTION_CONTRACT */], data);
    },
    SET_APPRAISAL_DOCS_OCCUPANCY_STATUS: function SET_APPRAISAL_DOCS_OCCUPANCY_STATUS(_ref40, data) {
        var state = _ref40.state,
            commit = _ref40.commit,
            rootState = _ref40.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_654" /* SET_APPRAISAL_DOCS_OCCUPANCY_STATUS */], data);
    },
    SET_APPRAISAL_DOCS_PHOTOGRAPHIC_REPORT: function SET_APPRAISAL_DOCS_PHOTOGRAPHIC_REPORT(_ref41, data) {
        var state = _ref41.state,
            commit = _ref41.commit,
            rootState = _ref41.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_655" /* SET_APPRAISAL_DOCS_PHOTOGRAPHIC_REPORT */], data);
    },
    SET_APPRAISAL_DOCS_PROPERTY_SKETCH: function SET_APPRAISAL_DOCS_PROPERTY_SKETCH(_ref42, data) {
        var state = _ref42.state,
            commit = _ref42.commit,
            rootState = _ref42.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_656" /* SET_APPRAISAL_DOCS_PROPERTY_SKETCH */], data);
    },
    SET_APPRAISAL_DOCS_PROPERTY_TITLES: function SET_APPRAISAL_DOCS_PROPERTY_TITLES(_ref43, data) {
        var state = _ref43.state,
            commit = _ref43.commit,
            rootState = _ref43.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_657" /* SET_APPRAISAL_DOCS_PROPERTY_TITLES */], data);
    },
    SET_APPRAISAL_DOCS_SITUATION_PLAN: function SET_APPRAISAL_DOCS_SITUATION_PLAN(_ref44, data) {
        var state = _ref44.state,
            commit = _ref44.commit,
            rootState = _ref44.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_658" /* SET_APPRAISAL_DOCS_SITUATION_PLAN */], data);
    },
    SET_APPRAISAL_DOCS_SUBSIDY_STATUS: function SET_APPRAISAL_DOCS_SUBSIDY_STATUS(_ref45, data) {
        var state = _ref45.state,
            commit = _ref45.commit,
            rootState = _ref45.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_659" /* SET_APPRAISAL_DOCS_SUBSIDY_STATUS */], data);
    },
    SET_APPRAISAL_DOCS_TENYEAR_INSURANCE: function SET_APPRAISAL_DOCS_TENYEAR_INSURANCE(_ref46, data) {
        var state = _ref46.state,
            commit = _ref46.commit,
            rootState = _ref46.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_660" /* SET_APPRAISAL_DOCS_TENYEAR_INSURANCE */], data);
    },
    SET_APPRAISAL_DOCS_URBAN_PLAN: function SET_APPRAISAL_DOCS_URBAN_PLAN(_ref47, data) {
        var state = _ref47.state,
            commit = _ref47.commit,
            rootState = _ref47.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_661" /* SET_APPRAISAL_DOCS_URBAN_PLAN */], data);
    },
    SET_APPRAISAL_DESCRIPTION: function SET_APPRAISAL_DESCRIPTION(_ref48, data) {
        var state = _ref48.state,
            commit = _ref48.commit,
            rootState = _ref48.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_662" /* SET_APPRAISAL_DESCRIPTION */], data);
    },
    SET_APPRAISAL_PURPOSE: function SET_APPRAISAL_PURPOSE(_ref49, data) {
        var state = _ref49.state,
            commit = _ref49.commit,
            rootState = _ref49.rootState;

        return new Promise(function (resolve, reject) {
            commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_663" /* SET_APPRAISAL_PURPOSE */], data);
            resolve();
        });
    },
    SET_APPRAISAL_PURPOSE_NOTES: function SET_APPRAISAL_PURPOSE_NOTES(_ref50, data) {
        var state = _ref50.state,
            commit = _ref50.commit,
            rootState = _ref50.rootState;

        return new Promise(function (resolve, reject) {
            commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_664" /* SET_APPRAISAL_PURPOSE_NOTES */], data);
            resolve();
        });
    },
    SET_APPRAISAL_TYPE: function SET_APPRAISAL_TYPE(_ref51, data) {
        var state = _ref51.state,
            commit = _ref51.commit,
            rootState = _ref51.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_665" /* SET_APPRAISAL_TYPE */], data);
    },
    SET_APPRAISAL_ADOPTED_AREA: function SET_APPRAISAL_ADOPTED_AREA(_ref52, data) {
        var state = _ref52.state,
            commit = _ref52.commit,
            rootState = _ref52.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_666" /* SET_APPRAISAL_ADOPTED_AREA */], data);
    },
    SET_APPRAISAL_LIFT: function SET_APPRAISAL_LIFT(_ref53, data) {
        var state = _ref53.state,
            commit = _ref53.commit,
            rootState = _ref53.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_667" /* SET_APPRAISAL_LIFT */], data);
    },
    SET_APPRAISAL_ADOPTED_AGE: function SET_APPRAISAL_ADOPTED_AGE(_ref54, data) {
        var state = _ref54.state,
            commit = _ref54.commit,
            rootState = _ref54.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_668" /* SET_APPRAISAL_ADOPTED_AGE */], data);
    },
    SET_APPRAISAL_ADOPTED_AGE_YEARS_OLD: function SET_APPRAISAL_ADOPTED_AGE_YEARS_OLD(_ref55, data) {
        var state = _ref55.state,
            commit = _ref55.commit,
            rootState = _ref55.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_669" /* SET_APPRAISAL_ADOPTED_AGE_YEARS_OLD */], data);
    },
    SET_APPRAISAL_PROPERTY_TYPE: function SET_APPRAISAL_PROPERTY_TYPE(_ref56, data) {
        var state = _ref56.state,
            commit = _ref56.commit,
            rootState = _ref56.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_670" /* SET_APPRAISAL_PROPERTY_TYPE */], data);
    },
    SET_APPRAISAL_QUALITY_OF_NEIGHBOURHOOD: function SET_APPRAISAL_QUALITY_OF_NEIGHBOURHOOD(_ref57, data) {
        var state = _ref57.state,
            commit = _ref57.commit,
            rootState = _ref57.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_671" /* SET_APPRAISAL_QUALITY_OF_NEIGHBOURHOOD */], data);
    },
    SET_APPRAISAL_QUALITY_OF_SITUATION: function SET_APPRAISAL_QUALITY_OF_SITUATION(_ref58, data) {
        var state = _ref58.state,
            commit = _ref58.commit,
            rootState = _ref58.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_672" /* SET_APPRAISAL_QUALITY_OF_SITUATION */], data);
    },
    SET_APPRAISAL_QUALITY_OF_CONSTRUCTION: function SET_APPRAISAL_QUALITY_OF_CONSTRUCTION(_ref59, data) {
        var state = _ref59.state,
            commit = _ref59.commit,
            rootState = _ref59.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_673" /* SET_APPRAISAL_QUALITY_OF_CONSTRUCTION */], data);
    },
    SET_APPRAISAL_QUALITY_OF_REALESTATE: function SET_APPRAISAL_QUALITY_OF_REALESTATE(_ref60, data) {
        var state = _ref60.state,
            commit = _ref60.commit,
            rootState = _ref60.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_674" /* SET_APPRAISAL_QUALITY_OF_REALESTATE */], data);
    },
    SET_APPRAISAL_CONSERVATION_STATUS: function SET_APPRAISAL_CONSERVATION_STATUS(_ref61, data) {
        var state = _ref61.state,
            commit = _ref61.commit,
            rootState = _ref61.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_675" /* SET_APPRAISAL_CONSERVATION_STATUS */], data);
    },
    SET_APPRAISAL_FLOOR_NUMBER: function SET_APPRAISAL_FLOOR_NUMBER(_ref62, data) {
        var state = _ref62.state,
            commit = _ref62.commit,
            rootState = _ref62.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_676" /* SET_APPRAISAL_FLOOR_NUMBER */], data);
    },
    SET_APPRAISAL_MARKET_VALUE: function SET_APPRAISAL_MARKET_VALUE(_ref63, data) {
        var state = _ref63.state,
            commit = _ref63.commit,
            rootState = _ref63.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_677" /* SET_APPRAISAL_MARKET_VALUE */], data);
    },
    SET_APPRAISAL_MARKET_UNIT_VALUE: function SET_APPRAISAL_MARKET_UNIT_VALUE(_ref64, data) {
        var state = _ref64.state,
            commit = _ref64.commit,
            rootState = _ref64.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_678" /* SET_APPRAISAL_MARKET_UNIT_VALUE */], data);
    },
    SET_APPRAISAL_BEC_PRICE: function SET_APPRAISAL_BEC_PRICE(_ref65, data) {
        var state = _ref65.state,
            commit = _ref65.commit,
            rootState = _ref65.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_679" /* SET_APPRAISAL_BEC_PRICE */], data);
    },
    SET_APPRAISAL_ADJUSTED_BEC_PRICE: function SET_APPRAISAL_ADJUSTED_BEC_PRICE(_ref66, data) {
        var state = _ref66.state,
            commit = _ref66.commit,
            rootState = _ref66.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_680" /* SET_APPRAISAL_ADJUSTED_BEC_PRICE */], data);
    },
    SET_APPRAISAL_BC: function SET_APPRAISAL_BC(_ref67, data) {
        var state = _ref67.state,
            commit = _ref67.commit,
            rootState = _ref67.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_681" /* SET_APPRAISAL_BC */], data);
    },
    SET_APPRAISAL_BC_PCT: function SET_APPRAISAL_BC_PCT(_ref68, data) {
        var state = _ref68.state,
            commit = _ref68.commit,
            rootState = _ref68.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_682" /* SET_APPRAISAL_BC_PCT */], data);
    },
    SET_APPRAISAL_GC: function SET_APPRAISAL_GC(_ref69, data) {
        var state = _ref69.state,
            commit = _ref69.commit,
            rootState = _ref69.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_683" /* SET_APPRAISAL_GC */], data);
    },
    SET_APPRAISAL_GC_PCT: function SET_APPRAISAL_GC_PCT(_ref70, data) {
        var state = _ref70.state,
            commit = _ref70.commit,
            rootState = _ref70.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_684" /* SET_APPRAISAL_GC_PCT */], data);
    },
    SET_APPRAISAL_BC_AND_GC_PCT: function SET_APPRAISAL_BC_AND_GC_PCT(_ref71, data) {
        var state = _ref71.state,
            commit = _ref71.commit,
            rootState = _ref71.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_685" /* SET_APPRAISAL_BC_AND_GC_PCT */], data);
    },
    SET_APPRAISAL_BC_AND_GC: function SET_APPRAISAL_BC_AND_GC(_ref72, data) {
        var state = _ref72.state,
            commit = _ref72.commit,
            rootState = _ref72.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_686" /* SET_APPRAISAL_BC_AND_GC */], data);
    },
    SET_APPRAISAL_CC: function SET_APPRAISAL_CC(_ref73, data) {
        var state = _ref73.state,
            commit = _ref73.commit,
            rootState = _ref73.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_687" /* SET_APPRAISAL_CC */], data);
    },
    SET_APPRAISAL_CC_PCT: function SET_APPRAISAL_CC_PCT(_ref74, data) {
        var state = _ref74.state,
            commit = _ref74.commit,
            rootState = _ref74.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_688" /* SET_APPRAISAL_CC_PCT */], data);
    },
    SET_APPRAISAL_HTL: function SET_APPRAISAL_HTL(_ref75, data) {
        var state = _ref75.state,
            commit = _ref75.commit,
            rootState = _ref75.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_689" /* SET_APPRAISAL_HTL */], data);
    },
    SET_APPRAISAL_HTL_PCT: function SET_APPRAISAL_HTL_PCT(_ref76, data) {
        var state = _ref76.state,
            commit = _ref76.commit,
            rootState = _ref76.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_690" /* SET_APPRAISAL_HTL_PCT */], data);
    },
    SET_APPRAISAL_INR: function SET_APPRAISAL_INR(_ref77, data) {
        var state = _ref77.state,
            commit = _ref77.commit,
            rootState = _ref77.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_691" /* SET_APPRAISAL_INR */], data);
    },
    SET_APPRAISAL_INR_PCT: function SET_APPRAISAL_INR_PCT(_ref78, data) {
        var state = _ref78.state,
            commit = _ref78.commit,
            rootState = _ref78.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_692" /* SET_APPRAISAL_INR_PCT */], data);
    },
    SET_APPRAISAL_GA: function SET_APPRAISAL_GA(_ref79, data) {
        var state = _ref79.state,
            commit = _ref79.commit,
            rootState = _ref79.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_693" /* SET_APPRAISAL_GA */], data);
    },
    SET_APPRAISAL_GA_PCT: function SET_APPRAISAL_GA_PCT(_ref80, data) {
        var state = _ref80.state,
            commit = _ref80.commit,
            rootState = _ref80.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_694" /* SET_APPRAISAL_GA_PCT */], data);
    },
    SET_APPRAISAL_GPD: function SET_APPRAISAL_GPD(_ref81, data) {
        var state = _ref81.state,
            commit = _ref81.commit,
            rootState = _ref81.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_695" /* SET_APPRAISAL_GPD */], data);
    },
    SET_APPRAISAL_GPD_PCT: function SET_APPRAISAL_GPD_PCT(_ref82, data) {
        var state = _ref82.state,
            commit = _ref82.commit,
            rootState = _ref82.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_696" /* SET_APPRAISAL_GPD_PCT */], data);
    },
    SET_APPRAISAL_OCT: function SET_APPRAISAL_OCT(_ref83, data) {
        var state = _ref83.state,
            commit = _ref83.commit,
            rootState = _ref83.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_697" /* SET_APPRAISAL_OCT */], data);
    },
    SET_APPRAISAL_OCT_PCT: function SET_APPRAISAL_OCT_PCT(_ref84, data) {
        var state = _ref84.state,
            commit = _ref84.commit,
            rootState = _ref84.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_698" /* SET_APPRAISAL_OCT_PCT */], data);
    },
    SET_APPRAISAL_GP: function SET_APPRAISAL_GP(_ref85, data) {
        var state = _ref85.state,
            commit = _ref85.commit,
            rootState = _ref85.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_699" /* SET_APPRAISAL_GP */], data);
    },
    SET_APPRAISAL_GP_PCT: function SET_APPRAISAL_GP_PCT(_ref86, data) {
        var state = _ref86.state,
            commit = _ref86.commit,
            rootState = _ref86.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_700" /* SET_APPRAISAL_GP_PCT */], data);
    },
    SET_APPRAISAL_CC_AND_GP: function SET_APPRAISAL_CC_AND_GP(_ref87, data) {
        var state = _ref87.state,
            commit = _ref87.commit,
            rootState = _ref87.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_701" /* SET_APPRAISAL_CC_AND_GP */], data);
    },
    SET_APPRAISAL_F: function SET_APPRAISAL_F(_ref88, data) {
        var state = _ref88.state,
            commit = _ref88.commit,
            rootState = _ref88.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_702" /* SET_APPRAISAL_F */], data);
    },
    SET_APPRAISAL_CRB: function SET_APPRAISAL_CRB(_ref89, data) {
        var state = _ref89.state,
            commit = _ref89.commit,
            rootState = _ref89.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_703" /* SET_APPRAISAL_CRB */], data);
    },
    SET_APPRAISAL_CCD: function SET_APPRAISAL_CCD(_ref90, data) {
        var state = _ref90.state,
            commit = _ref90.commit,
            rootState = _ref90.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_704" /* SET_APPRAISAL_CCD */], data);
    },
    SET_APPRAISAL_TLR_PCT: function SET_APPRAISAL_TLR_PCT(_ref91, data) {
        var state = _ref91.state,
            commit = _ref91.commit,
            rootState = _ref91.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_705" /* SET_APPRAISAL_TLR_PCT */], data);
    },
    SET_APPRAISAL_PR_PCT: function SET_APPRAISAL_PR_PCT(_ref92, data) {
        var state = _ref92.state,
            commit = _ref92.commit,
            rootState = _ref92.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_706" /* SET_APPRAISAL_PR_PCT */], data);
    },
    SET_APPRAISAL_AM_COEF: function SET_APPRAISAL_AM_COEF(_ref93, data) {
        var state = _ref93.state,
            commit = _ref93.commit,
            rootState = _ref93.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_707" /* SET_APPRAISAL_AM_COEF */], data);
    },
    SET_APPRAISAL_B1_PCT: function SET_APPRAISAL_B1_PCT(_ref94, data) {
        var state = _ref94.state,
            commit = _ref94.commit,
            rootState = _ref94.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_708" /* SET_APPRAISAL_B1_PCT */], data);
    },
    SET_APPRAISAL_B2_PCT: function SET_APPRAISAL_B2_PCT(_ref95, data) {
        var state = _ref95.state,
            commit = _ref95.commit,
            rootState = _ref95.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_709" /* SET_APPRAISAL_B2_PCT */], data);
    },
    SET_APPRAISAL_B_PCT: function SET_APPRAISAL_B_PCT(_ref96, data) {
        var state = _ref96.state,
            commit = _ref96.commit,
            rootState = _ref96.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_710" /* SET_APPRAISAL_B_PCT */], data);
    },
    SET_APPRAISAL_B_REMAINING_PCT: function SET_APPRAISAL_B_REMAINING_PCT(_ref97, data) {
        var state = _ref97.state,
            commit = _ref97.commit,
            rootState = _ref97.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_711" /* SET_APPRAISAL_B_REMAINING_PCT */], data);
    },
    SET_APPRAISAL_I_PCT: function SET_APPRAISAL_I_PCT(_ref98, data) {
        var state = _ref98.state,
            commit = _ref98.commit,
            rootState = _ref98.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_712" /* SET_APPRAISAL_I_PCT */], data);
    },
    SET_APPRAISAL_TENANT_AGE_YEARS: function SET_APPRAISAL_TENANT_AGE_YEARS(_ref99, data) {
        var state = _ref99.state,
            commit = _ref99.commit,
            rootState = _ref99.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_713" /* SET_APPRAISAL_TENANT_AGE_YEARS */], data);
    },
    SET_APPRAISAL_TENANT_LIFE_EXPECTANCY_YEARS: function SET_APPRAISAL_TENANT_LIFE_EXPECTANCY_YEARS(_ref100, data) {
        var state = _ref100.state,
            commit = _ref100.commit,
            rootState = _ref100.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_714" /* SET_APPRAISAL_TENANT_LIFE_EXPECTANCY_YEARS */], data);
    },
    SET_APPRAISAL_TENANT_REMAINING_LIFE_EXPECTANCY_YEARS: function SET_APPRAISAL_TENANT_REMAINING_LIFE_EXPECTANCY_YEARS(_ref101, data) {
        var state = _ref101.state,
            commit = _ref101.commit,
            rootState = _ref101.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_715" /* SET_APPRAISAL_TENANT_REMAINING_LIFE_EXPECTANCY_YEARS */], data);
    },
    SET_APPRAISAL_CESSION_BOOLEAN: function SET_APPRAISAL_CESSION_BOOLEAN(_ref102, data) {
        var state = _ref102.state,
            commit = _ref102.commit,
            rootState = _ref102.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_716" /* SET_APPRAISAL_CESSION_BOOLEAN */], data);
    },
    SET_APPRAISAL_CESSION_GROSS_MONTHLY_INCOME: function SET_APPRAISAL_CESSION_GROSS_MONTHLY_INCOME(_ref103, data) {
        var state = _ref103.state,
            commit = _ref103.commit,
            rootState = _ref103.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_717" /* SET_APPRAISAL_CESSION_GROSS_MONTHLY_INCOME */], data);
    },
    SET_APPRAISAL_CESSION_GROSS_YEARLY_INCOME: function SET_APPRAISAL_CESSION_GROSS_YEARLY_INCOME(_ref104, data) {
        var state = _ref104.state,
            commit = _ref104.commit,
            rootState = _ref104.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_718" /* SET_APPRAISAL_CESSION_GROSS_YEARLY_INCOME */], data);
    },
    SET_APPRAISAL_CESSION_NET_YEARLY_INCOME: function SET_APPRAISAL_CESSION_NET_YEARLY_INCOME(_ref105, data) {
        var state = _ref105.state,
            commit = _ref105.commit,
            rootState = _ref105.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_719" /* SET_APPRAISAL_CESSION_NET_YEARLY_INCOME */], data);
    },
    SET_APPRAISAL_CESSION_CONTRACT_PERIOD_YEARS: function SET_APPRAISAL_CESSION_CONTRACT_PERIOD_YEARS(_ref106, data) {
        var state = _ref106.state,
            commit = _ref106.commit,
            rootState = _ref106.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_720" /* SET_APPRAISAL_CESSION_CONTRACT_PERIOD_YEARS */], data);
    },
    SET_APPRAISAL_CESSION_CONTRACT_REMAINING_YEARS: function SET_APPRAISAL_CESSION_CONTRACT_REMAINING_YEARS(_ref107, data) {
        var state = _ref107.state,
            commit = _ref107.commit,
            rootState = _ref107.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_721" /* SET_APPRAISAL_CESSION_CONTRACT_REMAINING_YEARS */], data);
    },
    SET_APPRAISAL_CESSION_CONTRACT_START_DATE: function SET_APPRAISAL_CESSION_CONTRACT_START_DATE(_ref108, data) {
        var state = _ref108.state,
            commit = _ref108.commit,
            rootState = _ref108.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_722" /* SET_APPRAISAL_CESSION_CONTRACT_START_DATE */], data);
    },
    SET_APPRAISAL_LANDLORD_EXPENSES_PCT: function SET_APPRAISAL_LANDLORD_EXPENSES_PCT(_ref109, data) {
        var state = _ref109.state,
            commit = _ref109.commit,
            rootState = _ref109.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_723" /* SET_APPRAISAL_LANDLORD_EXPENSES_PCT */], data);
    },
    SET_APPRAISAL_REDUCTION_PCT: function SET_APPRAISAL_REDUCTION_PCT(_ref110, data) {
        var state = _ref110.state,
            commit = _ref110.commit,
            rootState = _ref110.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_724" /* SET_APPRAISAL_REDUCTION_PCT */], data);
    },
    SET_APPRAISAL_ADJUSTMENT_COEF: function SET_APPRAISAL_ADJUSTMENT_COEF(_ref111, data) {
        var state = _ref111.state,
            commit = _ref111.commit,
            rootState = _ref111.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_725" /* SET_APPRAISAL_ADJUSTMENT_COEF */], data);
    },
    SET_APPRAISAL_USUFRUCTUARY_AGE_YEARS: function SET_APPRAISAL_USUFRUCTUARY_AGE_YEARS(_ref112, data) {
        var state = _ref112.state,
            commit = _ref112.commit,
            rootState = _ref112.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_726" /* SET_APPRAISAL_USUFRUCTUARY_AGE_YEARS */], data);
    },
    SET_APPRAISAL_USEFUL_LIFE_YEARS: function SET_APPRAISAL_USEFUL_LIFE_YEARS(_ref113, data) {
        var state = _ref113.state,
            commit = _ref113.commit,
            rootState = _ref113.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_727" /* SET_APPRAISAL_USEFUL_LIFE_YEARS */], data);
    },
    SET_APPRAISAL_REMAINING_USEFUL_LIFE_YEARS: function SET_APPRAISAL_REMAINING_USEFUL_LIFE_YEARS(_ref114, data) {
        var state = _ref114.state,
            commit = _ref114.commit,
            rootState = _ref114.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_728" /* SET_APPRAISAL_REMAINING_USEFUL_LIFE_YEARS */], data);
    },
    SET_APPRAISAL_MAX_LEGAL_PRICE: function SET_APPRAISAL_MAX_LEGAL_PRICE(_ref115, data) {
        var state = _ref115.state,
            commit = _ref115.commit,
            rootState = _ref115.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_729" /* SET_APPRAISAL_MAX_LEGAL_PRICE */], data);
    },
    SET_APPRAISAL_MAX_LEGAL_AREA: function SET_APPRAISAL_MAX_LEGAL_AREA(_ref116, data) {
        var state = _ref116.state,
            commit = _ref116.commit,
            rootState = _ref116.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_730" /* SET_APPRAISAL_MAX_LEGAL_AREA */], data);
    },
    SET_APPRAISAL_MATERIAL_EXECUTION_COST: function SET_APPRAISAL_MATERIAL_EXECUTION_COST(_ref117, data) {
        var state = _ref117.state,
            commit = _ref117.commit,
            rootState = _ref117.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_731" /* SET_APPRAISAL_MATERIAL_EXECUTION_COST */], data);
    },
    SET_APPRAISAL_DEPRECATED_MATERIAL_EXECUTION_COST: function SET_APPRAISAL_DEPRECATED_MATERIAL_EXECUTION_COST(_ref118, data) {
        var state = _ref118.state,
            commit = _ref118.commit,
            rootState = _ref118.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_732" /* SET_APPRAISAL_DEPRECATED_MATERIAL_EXECUTION_COST */], data);
    },
    SET_APPRAISAL_MEC_ADJUSTMENT_COEF: function SET_APPRAISAL_MEC_ADJUSTMENT_COEF(_ref119, data) {
        var state = _ref119.state,
            commit = _ref119.commit,
            rootState = _ref119.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_733" /* SET_APPRAISAL_MEC_ADJUSTMENT_COEF */], data);
    },
    SET_APPRAISAL_ADOPTED_MATERIAL_EXECUTION_COST: function SET_APPRAISAL_ADOPTED_MATERIAL_EXECUTION_COST(_ref120, data) {
        var state = _ref120.state,
            commit = _ref120.commit,
            rootState = _ref120.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_734" /* SET_APPRAISAL_ADOPTED_MATERIAL_EXECUTION_COST */], data);
    },
    SET_APPRAISAL_PHYSICAL_DEPRECIATION_PCT: function SET_APPRAISAL_PHYSICAL_DEPRECIATION_PCT(_ref121, data) {
        var state = _ref121.state,
            commit = _ref121.commit,
            rootState = _ref121.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_735" /* SET_APPRAISAL_PHYSICAL_DEPRECIATION_PCT */], data);
    },
    SET_APPRAISAL_FUNCTIONAL_DEPRECIATION_PCT: function SET_APPRAISAL_FUNCTIONAL_DEPRECIATION_PCT(_ref122, data) {
        var state = _ref122.state,
            commit = _ref122.commit,
            rootState = _ref122.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_736" /* SET_APPRAISAL_FUNCTIONAL_DEPRECIATION_PCT */], data);
    },
    SET_APPRAISAL_TOTAL_DEPRECIATION_PCT: function SET_APPRAISAL_TOTAL_DEPRECIATION_PCT(_ref123, data) {
        var state = _ref123.state,
            commit = _ref123.commit,
            rootState = _ref123.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_737" /* SET_APPRAISAL_TOTAL_DEPRECIATION_PCT */], data);
    },
    SET_APPRAISAL_TOTAL_CONSTRUCTION_PROGRESS_PCT: function SET_APPRAISAL_TOTAL_CONSTRUCTION_PROGRESS_PCT(_ref124, data) {
        var state = _ref124.state,
            commit = _ref124.commit,
            rootState = _ref124.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_738" /* SET_APPRAISAL_TOTAL_CONSTRUCTION_PROGRESS_PCT */], data);
    },
    SET_APPRAISAL_ADOPTED_MARKET_VALUE: function SET_APPRAISAL_ADOPTED_MARKET_VALUE(_ref125, data) {
        var state = _ref125.state,
            commit = _ref125.commit,
            rootState = _ref125.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_739" /* SET_APPRAISAL_ADOPTED_MARKET_VALUE */], data);
    },
    SET_APPRAISAL_ADOPTED_MARKET_UNIT_VALUE: function SET_APPRAISAL_ADOPTED_MARKET_UNIT_VALUE(_ref126, data) {
        var state = _ref126.state,
            commit = _ref126.commit,
            rootState = _ref126.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_740" /* SET_APPRAISAL_ADOPTED_MARKET_UNIT_VALUE */], data);
    },
    SET_APPRAISAL_MARKET_VALUE_APPRAISER_ADJUSTMENT_PCT: function SET_APPRAISAL_MARKET_VALUE_APPRAISER_ADJUSTMENT_PCT(_ref127, data) {
        var state = _ref127.state,
            commit = _ref127.commit,
            rootState = _ref127.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_741" /* SET_APPRAISAL_MARKET_VALUE_APPRAISER_ADJUSTMENT_PCT */], data);
    },
    SET_APPRAISAL_DEPRECATED_LAND_AND_CC: function SET_APPRAISAL_DEPRECATED_LAND_AND_CC(_ref128, data) {
        var state = _ref128.state,
            commit = _ref128.commit,
            rootState = _ref128.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_742" /* SET_APPRAISAL_DEPRECATED_LAND_AND_CC */], data);
    },
    SET_APPRAISAL_FINISHED_REALESTATE_CRN: function SET_APPRAISAL_FINISHED_REALESTATE_CRN(_ref129, data) {
        var state = _ref129.state,
            commit = _ref129.commit,
            rootState = _ref129.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_743" /* SET_APPRAISAL_FINISHED_REALESTATE_CRN */], data);
    },
    SET_APPRAISAL_CCR: function SET_APPRAISAL_CCR(_ref130, data) {
        var state = _ref130.state,
            commit = _ref130.commit,
            rootState = _ref130.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_744" /* SET_APPRAISAL_CCR */], data);
    },
    SET_APPRAISAL_EXECUTED_CONSTRUCTION_COST: function SET_APPRAISAL_EXECUTED_CONSTRUCTION_COST(_ref131, data) {
        var state = _ref131.state,
            commit = _ref131.commit,
            rootState = _ref131.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_745" /* SET_APPRAISAL_EXECUTED_CONSTRUCTION_COST */], data);
    },
    SET_APPRAISAL_UNDER_CONSTRUCTION_REALESTATE_CRN: function SET_APPRAISAL_UNDER_CONSTRUCTION_REALESTATE_CRN(_ref132, data) {
        var state = _ref132.state,
            commit = _ref132.commit,
            rootState = _ref132.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_746" /* SET_APPRAISAL_UNDER_CONSTRUCTION_REALESTATE_CRN */], data);
    },
    SET_APPRAISAL_K: function SET_APPRAISAL_K(_ref133, data) {
        var state = _ref133.state,
            commit = _ref133.commit,
            rootState = _ref133.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_747" /* SET_APPRAISAL_K */], data);
    },
    SET_APPRAISAL_REPERCUSSION_METHOD_LAND_VALUE: function SET_APPRAISAL_REPERCUSSION_METHOD_LAND_VALUE(_ref134, data) {
        var state = _ref134.state,
            commit = _ref134.commit,
            rootState = _ref134.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_748" /* SET_APPRAISAL_REPERCUSSION_METHOD_LAND_VALUE */], data);
    },
    SET_APPRAISAL_COST_METHOD_CONSTRUCTION_CRB_VALUE: function SET_APPRAISAL_COST_METHOD_CONSTRUCTION_CRB_VALUE(_ref135, data) {
        var state = _ref135.state,
            commit = _ref135.commit,
            rootState = _ref135.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_749" /* SET_APPRAISAL_COST_METHOD_CONSTRUCTION_CRB_VALUE */], data);
    },
    SET_APPRAISAL_COST_METHOD_CONSTRUCTION_CRN_VALUE: function SET_APPRAISAL_COST_METHOD_CONSTRUCTION_CRN_VALUE(_ref136, data) {
        var state = _ref136.state,
            commit = _ref136.commit,
            rootState = _ref136.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_750" /* SET_APPRAISAL_COST_METHOD_CONSTRUCTION_CRN_VALUE */], data);
    },
    SET_APPRAISAL_COST_METHOD_REALESTATE_CRB_VALUE: function SET_APPRAISAL_COST_METHOD_REALESTATE_CRB_VALUE(_ref137, data) {
        var state = _ref137.state,
            commit = _ref137.commit,
            rootState = _ref137.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_751" /* SET_APPRAISAL_COST_METHOD_REALESTATE_CRB_VALUE */], data);
    },
    SET_APPRAISAL_COST_METHOD_REALESTATE_CRN_VALUE: function SET_APPRAISAL_COST_METHOD_REALESTATE_CRN_VALUE(_ref138, data) {
        var state = _ref138.state,
            commit = _ref138.commit,
            rootState = _ref138.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_752" /* SET_APPRAISAL_COST_METHOD_REALESTATE_CRN_VALUE */], data);
    },
    SET_APPRAISAL_COMPARISON_METHOD: function SET_APPRAISAL_COMPARISON_METHOD(_ref139, data) {
        var state = _ref139.state,
            commit = _ref139.commit,
            rootState = _ref139.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_753" /* SET_APPRAISAL_COMPARISON_METHOD */], data);
    },
    SET_APPRAISAL_ADJUSTED_MARKET_VALUE: function SET_APPRAISAL_ADJUSTED_MARKET_VALUE(_ref140, data) {
        var state = _ref140.state,
            commit = _ref140.commit,
            rootState = _ref140.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_754" /* SET_APPRAISAL_ADJUSTED_MARKET_VALUE */], data);
    },
    SET_APPRAISAL_MAX_LEGAL_METHOD: function SET_APPRAISAL_MAX_LEGAL_METHOD(_ref141, data) {
        var state = _ref141.state,
            commit = _ref141.commit,
            rootState = _ref141.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_755" /* SET_APPRAISAL_MAX_LEGAL_METHOD */], data);
    },
    SET_APPRAISAL_VC: function SET_APPRAISAL_VC(_ref142, data) {
        var state = _ref142.state,
            commit = _ref142.commit,
            rootState = _ref142.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_756" /* SET_APPRAISAL_VC */], data);
    },
    SET_APPRAISAL_INCOME_PERPETUITY_UPDATE_METHOD: function SET_APPRAISAL_INCOME_PERPETUITY_UPDATE_METHOD(_ref143, data) {
        var state = _ref143.state,
            commit = _ref143.commit,
            rootState = _ref143.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_757" /* SET_APPRAISAL_INCOME_PERPETUITY_UPDATE_METHOD */], data);
    },
    SET_APPRAISAL_U: function SET_APPRAISAL_U(_ref144, data) {
        var state = _ref144.state,
            commit = _ref144.commit,
            rootState = _ref144.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_758" /* SET_APPRAISAL_U */], data);
    },
    SET_APPRAISAL_RESIDUAL_DEPRECIATION_PCT: function SET_APPRAISAL_RESIDUAL_DEPRECIATION_PCT(_ref145, data) {
        var state = _ref145.state,
            commit = _ref145.commit,
            rootState = _ref145.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_759" /* SET_APPRAISAL_RESIDUAL_DEPRECIATION_PCT */], data);
    },
    SET_APPRAISAL_RESIDUAL_DEPRECIATION: function SET_APPRAISAL_RESIDUAL_DEPRECIATION(_ref146, data) {
        var state = _ref146.state,
            commit = _ref146.commit,
            rootState = _ref146.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_760" /* SET_APPRAISAL_RESIDUAL_DEPRECIATION */], data);
    },
    SET_APPRAISAL_REALESTATE_RESIDUAL_VALUE: function SET_APPRAISAL_REALESTATE_RESIDUAL_VALUE(_ref147, data) {
        var state = _ref147.state,
            commit = _ref147.commit,
            rootState = _ref147.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_761" /* SET_APPRAISAL_REALESTATE_RESIDUAL_VALUE */], data);
    },
    SET_APPRAISAL_I: function SET_APPRAISAL_I(_ref148, data) {
        var state = _ref148.state,
            commit = _ref148.commit,
            rootState = _ref148.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_762" /* SET_APPRAISAL_I */], data);
    },
    SET_APPRAISAL_NP: function SET_APPRAISAL_NP(_ref149, data) {
        var state = _ref149.state,
            commit = _ref149.commit,
            rootState = _ref149.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_763" /* SET_APPRAISAL_NP */], data);
    },
    SET_APPRAISAL_COEF_1: function SET_APPRAISAL_COEF_1(_ref150, data) {
        var state = _ref150.state,
            commit = _ref150.commit,
            rootState = _ref150.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_764" /* SET_APPRAISAL_COEF_1 */], data);
    },
    SET_APPRAISAL_CURRENT_FUTURE_INCOME_VALUE: function SET_APPRAISAL_CURRENT_FUTURE_INCOME_VALUE(_ref151, data) {
        var state = _ref151.state,
            commit = _ref151.commit,
            rootState = _ref151.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_765" /* SET_APPRAISAL_CURRENT_FUTURE_INCOME_VALUE */], data);
    },
    SET_APPRAISAL_COEF_2: function SET_APPRAISAL_COEF_2(_ref152, data) {
        var state = _ref152.state,
            commit = _ref152.commit,
            rootState = _ref152.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_766" /* SET_APPRAISAL_COEF_2 */], data);
    },
    SET_APPRAISAL_UPDATED_REVERSION_VALUE: function SET_APPRAISAL_UPDATED_REVERSION_VALUE(_ref153, data) {
        var state = _ref153.state,
            commit = _ref153.commit,
            rootState = _ref153.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_767" /* SET_APPRAISAL_UPDATED_REVERSION_VALUE */], data);
    },
    SET_APPRAISAL_UPDATE_VALUE: function SET_APPRAISAL_UPDATE_VALUE(_ref154, data) {
        var state = _ref154.state,
            commit = _ref154.commit,
            rootState = _ref154.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_768" /* SET_APPRAISAL_UPDATE_VALUE */], data);
    },
    SET_APPRAISAL_INSURANCE_VALUE: function SET_APPRAISAL_INSURANCE_VALUE(_ref155, data) {
        var state = _ref155.state,
            commit = _ref155.commit,
            rootState = _ref155.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_769" /* SET_APPRAISAL_INSURANCE_VALUE */], data);
    },
    SET_APPRAISAL_VU_COEF: function SET_APPRAISAL_VU_COEF(_ref156, data) {
        var state = _ref156.state,
            commit = _ref156.commit,
            rootState = _ref156.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_770" /* SET_APPRAISAL_VU_COEF */], data);
    },
    SET_APPRAISAL_USUFRUCT_VALUE: function SET_APPRAISAL_USUFRUCT_VALUE(_ref157, data) {
        var state = _ref157.state,
            commit = _ref157.commit,
            rootState = _ref157.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_771" /* SET_APPRAISAL_USUFRUCT_VALUE */], data);
    },
    SET_APPRAISAL_BARE_OWNERSHIP_VALUE: function SET_APPRAISAL_BARE_OWNERSHIP_VALUE(_ref158, data) {
        var state = _ref158.state,
            commit = _ref158.commit,
            rootState = _ref158.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_772" /* SET_APPRAISAL_BARE_OWNERSHIP_VALUE */], data);
    },
    SET_APPRAISAL_REALESTATE_TOTAL_ADOPTED_VALUE: function SET_APPRAISAL_REALESTATE_TOTAL_ADOPTED_VALUE(_ref159, data) {
        var state = _ref159.state,
            commit = _ref159.commit,
            rootState = _ref159.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_773" /* SET_APPRAISAL_REALESTATE_TOTAL_ADOPTED_VALUE */], data);
    },
    SET_APPRAISAL_REALESTATE_ADOPTED_APPRAISAL_METHOD: function SET_APPRAISAL_REALESTATE_ADOPTED_APPRAISAL_METHOD(_ref160, data) {
        var state = _ref160.state,
            commit = _ref160.commit,
            rootState = _ref160.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_774" /* SET_APPRAISAL_REALESTATE_ADOPTED_APPRAISAL_METHOD */], data);
    },
    SET_APPRAISAL_REALESTATE_ID: function SET_APPRAISAL_REALESTATE_ID(_ref161, data) {
        var state = _ref161.state,
            commit = _ref161.commit,
            rootState = _ref161.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_611" /* SET_APPRAISAL_REALESTATE_ID */], data);
    },
    SET_APPRAISAL_RIGHT_OF_USE_BOOLEAN: function SET_APPRAISAL_RIGHT_OF_USE_BOOLEAN(_ref162, data) {
        var state = _ref162.state,
            commit = _ref162.commit,
            rootState = _ref162.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_775" /* SET_APPRAISAL_RIGHT_OF_USE_BOOLEAN */], data);
    },
    SET_APPRAISAL_PROTECTION_BOOLEAN: function SET_APPRAISAL_PROTECTION_BOOLEAN(_ref163, data) {
        var state = _ref163.state,
            commit = _ref163.commit,
            rootState = _ref163.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_776" /* SET_APPRAISAL_PROTECTION_BOOLEAN */], data);
    },
    SET_APPRAISAL_PROTECTION_TYPE: function SET_APPRAISAL_PROTECTION_TYPE(_ref164, data) {
        var state = _ref164.state,
            commit = _ref164.commit,
            rootState = _ref164.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_777" /* SET_APPRAISAL_PROTECTION_TYPE */], data);
    },
    SET_APPRAISAL_PROTECTION_REGIME: function SET_APPRAISAL_PROTECTION_REGIME(_ref165, data) {
        var state = _ref165.state,
            commit = _ref165.commit,
            rootState = _ref165.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_778" /* SET_APPRAISAL_PROTECTION_REGIME */], data);
    },
    SET_APPRAISAL_PROTECTION_ZONE: function SET_APPRAISAL_PROTECTION_ZONE(_ref166, data) {
        var state = _ref166.state,
            commit = _ref166.commit,
            rootState = _ref166.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_779" /* SET_APPRAISAL_PROTECTION_ZONE */], data);
    },
    SET_APPRAISAL_URBAN_PLANNING_TYPE: function SET_APPRAISAL_URBAN_PLANNING_TYPE(_ref167, data) {
        var state = _ref167.state,
            commit = _ref167.commit,
            rootState = _ref167.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_620" /* SET_APPRAISAL_URBAN_PLANNING_TYPE */], data);
    },
    SET_APPRAISAL_URBAN_PLANNING_FILE: function SET_APPRAISAL_URBAN_PLANNING_FILE(_ref168, data) {
        var state = _ref168.state,
            commit = _ref168.commit,
            rootState = _ref168.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_621" /* SET_APPRAISAL_URBAN_PLANNING_FILE */], data);
    },
    SET_APPRAISAL_URBAN_PLANNING_COUNCIL_QUALIFICATION: function SET_APPRAISAL_URBAN_PLANNING_COUNCIL_QUALIFICATION(_ref169, data) {
        var state = _ref169.state,
            commit = _ref169.commit,
            rootState = _ref169.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_622" /* SET_APPRAISAL_URBAN_PLANNING_COUNCIL_QUALIFICATION */], data);
    },
    SET_APPRAISAL_URBAN_PLANNING_COUNCIL_QUALIFICATION_DESCRIPTION: function SET_APPRAISAL_URBAN_PLANNING_COUNCIL_QUALIFICATION_DESCRIPTION(_ref170, data) {
        var state = _ref170.state,
            commit = _ref170.commit,
            rootState = _ref170.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_623" /* SET_APPRAISAL_URBAN_PLANNING_COUNCIL_QUALIFICATION_DESCRIPTION */], data);
    },
    SET_APPRAISAL_URBAN_PLANNING_COUNCIL_CLASSIFICATION: function SET_APPRAISAL_URBAN_PLANNING_COUNCIL_CLASSIFICATION(_ref171, data) {
        var state = _ref171.state,
            commit = _ref171.commit,
            rootState = _ref171.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_624" /* SET_APPRAISAL_URBAN_PLANNING_COUNCIL_CLASSIFICATION */], data);
    },
    SET_APPRAISAL_URBAN_PLANNING_COUNCIL_CLASSIFICATION_DESCRIPTION: function SET_APPRAISAL_URBAN_PLANNING_COUNCIL_CLASSIFICATION_DESCRIPTION(_ref172, data) {
        var state = _ref172.state,
            commit = _ref172.commit,
            rootState = _ref172.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_625" /* SET_APPRAISAL_URBAN_PLANNING_COUNCIL_CLASSIFICATION_DESCRIPTION */], data);
    },
    SET_APPRAISAL_URBAN_PLANNING_REGIONAL_QUALIFICATION: function SET_APPRAISAL_URBAN_PLANNING_REGIONAL_QUALIFICATION(_ref173, data) {
        var state = _ref173.state,
            commit = _ref173.commit,
            rootState = _ref173.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_626" /* SET_APPRAISAL_URBAN_PLANNING_REGIONAL_QUALIFICATION */], data);
    },
    SET_APPRAISAL_URBAN_PLANNING_REGIONAL_QUALIFICATION_DESCRIPTION: function SET_APPRAISAL_URBAN_PLANNING_REGIONAL_QUALIFICATION_DESCRIPTION(_ref174, data) {
        var state = _ref174.state,
            commit = _ref174.commit,
            rootState = _ref174.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_627" /* SET_APPRAISAL_URBAN_PLANNING_REGIONAL_QUALIFICATION_DESCRIPTION */], data);
    },
    SET_APPRAISAL_URBAN_PLANNING_REGIONAL_CLASSIFICATION: function SET_APPRAISAL_URBAN_PLANNING_REGIONAL_CLASSIFICATION(_ref175, data) {
        var state = _ref175.state,
            commit = _ref175.commit,
            rootState = _ref175.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_628" /* SET_APPRAISAL_URBAN_PLANNING_REGIONAL_CLASSIFICATION */], data);
    },
    SET_APPRAISAL_URBAN_PLANNING_REGIONAL_CLASSIFICATION_DESCRIPTION: function SET_APPRAISAL_URBAN_PLANNING_REGIONAL_CLASSIFICATION_DESCRIPTION(_ref176, data) {
        var state = _ref176.state,
            commit = _ref176.commit,
            rootState = _ref176.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_629" /* SET_APPRAISAL_URBAN_PLANNING_REGIONAL_CLASSIFICATION_DESCRIPTION */], data);
    },
    SET_APPRAISAL_LAND_REGISTRY_AREA: function SET_APPRAISAL_LAND_REGISTRY_AREA(_ref177, data) {
        var state = _ref177.state,
            commit = _ref177.commit,
            rootState = _ref177.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_780" /* SET_APPRAISAL_LAND_REGISTRY_AREA */], data);
    },
    SET_APPRAISAL_LAND_CADASTRAL_AREA: function SET_APPRAISAL_LAND_CADASTRAL_AREA(_ref178, data) {
        var state = _ref178.state,
            commit = _ref178.commit,
            rootState = _ref178.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_781" /* SET_APPRAISAL_LAND_CADASTRAL_AREA */], data);
    },
    SET_APPRAISAL_LAND_CHECKED_AREA: function SET_APPRAISAL_LAND_CHECKED_AREA(_ref179, data) {
        var state = _ref179.state,
            commit = _ref179.commit,
            rootState = _ref179.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_782" /* SET_APPRAISAL_LAND_CHECKED_AREA */], data);
    },
    SET_APPRAISAL_LAND_ADOPTED_AREA: function SET_APPRAISAL_LAND_ADOPTED_AREA(_ref180, data) {
        var state = _ref180.state,
            commit = _ref180.commit,
            rootState = _ref180.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_783" /* SET_APPRAISAL_LAND_ADOPTED_AREA */], data);
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_PAVING_EXECUTION_PCT: function SET_APPRAISAL_LAND_INFRASTRUCTURE_PAVING_EXECUTION_PCT(_ref181, data) {
        var state = _ref181.state,
            commit = _ref181.commit,
            rootState = _ref181.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_784" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_PAVING_EXECUTION_PCT */], data);
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_SEWAGE_EXECUTION_PCT: function SET_APPRAISAL_LAND_INFRASTRUCTURE_SEWAGE_EXECUTION_PCT(_ref182, data) {
        var state = _ref182.state,
            commit = _ref182.commit,
            rootState = _ref182.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_785" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_SEWAGE_EXECUTION_PCT */], data);
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_PUBLIC_LIGHTING_EXECUTION_PCT: function SET_APPRAISAL_LAND_INFRASTRUCTURE_PUBLIC_LIGHTING_EXECUTION_PCT(_ref183, data) {
        var state = _ref183.state,
            commit = _ref183.commit,
            rootState = _ref183.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_786" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_PUBLIC_LIGHTING_EXECUTION_PCT */], data);
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_ELECTRICITY_SUPPLY_EXECUTION_PCT: function SET_APPRAISAL_LAND_INFRASTRUCTURE_ELECTRICITY_SUPPLY_EXECUTION_PCT(_ref184, data) {
        var state = _ref184.state,
            commit = _ref184.commit,
            rootState = _ref184.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_787" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_ELECTRICITY_SUPPLY_EXECUTION_PCT */], data);
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_PIPED_GAS_EXECUTION_PCT: function SET_APPRAISAL_LAND_INFRASTRUCTURE_PIPED_GAS_EXECUTION_PCT(_ref185, data) {
        var state = _ref185.state,
            commit = _ref185.commit,
            rootState = _ref185.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_788" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_PIPED_GAS_EXECUTION_PCT */], data);
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_TELEPHONE_SERVICE_EXECUTION_PCT: function SET_APPRAISAL_LAND_INFRASTRUCTURE_TELEPHONE_SERVICE_EXECUTION_PCT(_ref186, data) {
        var state = _ref186.state,
            commit = _ref186.commit,
            rootState = _ref186.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_789" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_TELEPHONE_SERVICE_EXECUTION_PCT */], data);
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_GARDENED_AREAS_EXECUTION_PCT: function SET_APPRAISAL_LAND_INFRASTRUCTURE_GARDENED_AREAS_EXECUTION_PCT(_ref187, data) {
        var state = _ref187.state,
            commit = _ref187.commit,
            rootState = _ref187.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_790" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_GARDENED_AREAS_EXECUTION_PCT */], data);
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_TOTAL_EXECUTION_PCT: function SET_APPRAISAL_LAND_INFRASTRUCTURE_TOTAL_EXECUTION_PCT(_ref188, data) {
        var state = _ref188.state,
            commit = _ref188.commit,
            rootState = _ref188.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_791" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_TOTAL_EXECUTION_PCT */], data);
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_REPERCUSSION_COST: function SET_APPRAISAL_LAND_INFRASTRUCTURE_REPERCUSSION_COST(_ref189, data) {
        var state = _ref189.state,
            commit = _ref189.commit,
            rootState = _ref189.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_792" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_REPERCUSSION_COST */], data);
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_PENDING_INVESTMENT: function SET_APPRAISAL_LAND_INFRASTRUCTURE_PENDING_INVESTMENT(_ref190, data) {
        var state = _ref190.state,
            commit = _ref190.commit,
            rootState = _ref190.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_793" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_PENDING_INVESTMENT */], data);
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_PAVING: function SET_APPRAISAL_LAND_INFRASTRUCTURE_PAVING(_ref191, data) {
        var state = _ref191.state,
            commit = _ref191.commit,
            rootState = _ref191.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_794" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_PAVING */], data);
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_SEWAGE: function SET_APPRAISAL_LAND_INFRASTRUCTURE_SEWAGE(_ref192, data) {
        var state = _ref192.state,
            commit = _ref192.commit,
            rootState = _ref192.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_795" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_SEWAGE */], data);
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_PUBLIC_LIGHTING: function SET_APPRAISAL_LAND_INFRASTRUCTURE_PUBLIC_LIGHTING(_ref193, data) {
        var state = _ref193.state,
            commit = _ref193.commit,
            rootState = _ref193.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_796" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_PUBLIC_LIGHTING */], data);
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_ELECTRICITY_SUPPLY: function SET_APPRAISAL_LAND_INFRASTRUCTURE_ELECTRICITY_SUPPLY(_ref194, data) {
        var state = _ref194.state,
            commit = _ref194.commit,
            rootState = _ref194.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_797" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_ELECTRICITY_SUPPLY */], data);
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_PIPED_GAS: function SET_APPRAISAL_LAND_INFRASTRUCTURE_PIPED_GAS(_ref195, data) {
        var state = _ref195.state,
            commit = _ref195.commit,
            rootState = _ref195.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_798" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_PIPED_GAS */], data);
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_TELEPHONE_SERVICE: function SET_APPRAISAL_LAND_INFRASTRUCTURE_TELEPHONE_SERVICE(_ref196, data) {
        var state = _ref196.state,
            commit = _ref196.commit,
            rootState = _ref196.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_799" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_TELEPHONE_SERVICE */], data);
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_GARDENED_AREAS: function SET_APPRAISAL_LAND_INFRASTRUCTURE_GARDENED_AREAS(_ref197, data) {
        var state = _ref197.state,
            commit = _ref197.commit,
            rootState = _ref197.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_800" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_GARDENED_AREAS */], data);
    },
    SET_APPRAISAL_LAND_IS_PLOT_ACCORDING_TO_LAW: function SET_APPRAISAL_LAND_IS_PLOT_ACCORDING_TO_LAW(_ref198, data) {
        var state = _ref198.state,
            commit = _ref198.commit,
            rootState = _ref198.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_801" /* SET_APPRAISAL_LAND_IS_PLOT_ACCORDING_TO_LAW */], data);
    },
    SET_APPRAISAL_LAND_AREA_NOTES: function SET_APPRAISAL_LAND_AREA_NOTES(_ref199, data) {
        var state = _ref199.state,
            commit = _ref199.commit,
            rootState = _ref199.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_802" /* SET_APPRAISAL_LAND_AREA_NOTES */], data);
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_NOTES: function SET_APPRAISAL_LAND_INFRASTRUCTURE_NOTES(_ref200, data) {
        var state = _ref200.state,
            commit = _ref200.commit,
            rootState = _ref200.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_803" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_NOTES */], data);
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_CONSERVATION_STATUS: function SET_APPRAISAL_LAND_INFRASTRUCTURE_CONSERVATION_STATUS(_ref201, data) {
        var state = _ref201.state,
            commit = _ref201.commit,
            rootState = _ref201.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_804" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_CONSERVATION_STATUS */], data);
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_WATER_SUPPLY_EXECUTION_PCT: function SET_APPRAISAL_LAND_INFRASTRUCTURE_WATER_SUPPLY_EXECUTION_PCT(_ref202, data) {
        var state = _ref202.state,
            commit = _ref202.commit,
            rootState = _ref202.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_805" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_WATER_SUPPLY_EXECUTION_PCT */], data);
    },
    SET_APPRAISAL_LAND_INFRASTRUCTURE_WATER_SUPPLY: function SET_APPRAISAL_LAND_INFRASTRUCTURE_WATER_SUPPLY(_ref203, data) {
        var state = _ref203.state,
            commit = _ref203.commit,
            rootState = _ref203.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_806" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_WATER_SUPPLY */], data);
    },
    SET_APPRAISAL_PLOT_OCCUPATION: function SET_APPRAISAL_PLOT_OCCUPATION(_ref204, data) {
        var state = _ref204.state,
            commit = _ref204.commit,
            rootState = _ref204.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_807" /* SET_APPRAISAL_PLOT_OCCUPATION */], data);
    },
    SET_APPRAISAL_PLOT_FREE_AREA_USAGE: function SET_APPRAISAL_PLOT_FREE_AREA_USAGE(_ref205, data) {
        var state = _ref205.state,
            commit = _ref205.commit,
            rootState = _ref205.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_808" /* SET_APPRAISAL_PLOT_FREE_AREA_USAGE */], data);
    },
    SET_APPRAISAL_FLOORS_NUMBER_UNDERGROUND: function SET_APPRAISAL_FLOORS_NUMBER_UNDERGROUND(_ref206, data) {
        var state = _ref206.state,
            commit = _ref206.commit,
            rootState = _ref206.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_809" /* SET_APPRAISAL_FLOORS_NUMBER_UNDERGROUND */], data);
    },
    SET_APPRAISAL_FLOORS_NUMBER_OVERGROUND: function SET_APPRAISAL_FLOORS_NUMBER_OVERGROUND(_ref207, data) {
        var state = _ref207.state,
            commit = _ref207.commit,
            rootState = _ref207.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_810" /* SET_APPRAISAL_FLOORS_NUMBER_OVERGROUND */], data);
    },
    SET_APPRAISAL_PARKING_SLOTS_INCLUDED_IN_APPRAISAL_NUMBER: function SET_APPRAISAL_PARKING_SLOTS_INCLUDED_IN_APPRAISAL_NUMBER(_ref208, data) {
        var state = _ref208.state,
            commit = _ref208.commit,
            rootState = _ref208.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_811" /* SET_APPRAISAL_PARKING_SLOTS_INCLUDED_IN_APPRAISAL_NUMBER */], data);
    },
    SET_APPRAISAL_ENTRANCE_HALL: function SET_APPRAISAL_ENTRANCE_HALL(_ref209, data) {
        var state = _ref209.state,
            commit = _ref209.commit,
            rootState = _ref209.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_812" /* SET_APPRAISAL_ENTRANCE_HALL */], data);
    },
    SET_APPRAISAL_DOORMAN_SPACE: function SET_APPRAISAL_DOORMAN_SPACE(_ref210, data) {
        var state = _ref210.state,
            commit = _ref210.commit,
            rootState = _ref210.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_813" /* SET_APPRAISAL_DOORMAN_SPACE */], data);
    },
    SET_APPRAISAL_STAIRCASE: function SET_APPRAISAL_STAIRCASE(_ref211, data) {
        var state = _ref211.state,
            commit = _ref211.commit,
            rootState = _ref211.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_814" /* SET_APPRAISAL_STAIRCASE */], data);
    },
    SET_APPRAISAL_SWIMMING_POOL: function SET_APPRAISAL_SWIMMING_POOL(_ref212, data) {
        var state = _ref212.state,
            commit = _ref212.commit,
            rootState = _ref212.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_815" /* SET_APPRAISAL_SWIMMING_POOL */], data);
    },
    SET_APPRAISAL_GARDENED_AREAS: function SET_APPRAISAL_GARDENED_AREAS(_ref213, data) {
        var state = _ref213.state,
            commit = _ref213.commit,
            rootState = _ref213.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_816" /* SET_APPRAISAL_GARDENED_AREAS */], data);
    },
    SET_APPRAISAL_SPORTS_FACILITIES: function SET_APPRAISAL_SPORTS_FACILITIES(_ref214, data) {
        var state = _ref214.state,
            commit = _ref214.commit,
            rootState = _ref214.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_817" /* SET_APPRAISAL_SPORTS_FACILITIES */], data);
    },
    SET_APPRAISAL_COMMUNITY_ROOM: function SET_APPRAISAL_COMMUNITY_ROOM(_ref215, data) {
        var state = _ref215.state,
            commit = _ref215.commit,
            rootState = _ref215.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_818" /* SET_APPRAISAL_COMMUNITY_ROOM */], data);
    },
    SET_APPRAISAL_STORAGE_ROOM: function SET_APPRAISAL_STORAGE_ROOM(_ref216, data) {
        var state = _ref216.state,
            commit = _ref216.commit,
            rootState = _ref216.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_819" /* SET_APPRAISAL_STORAGE_ROOM */], data);
    },
    SET_APPRAISAL_COMMUNITY_PARKING: function SET_APPRAISAL_COMMUNITY_PARKING(_ref217, data) {
        var state = _ref217.state,
            commit = _ref217.commit,
            rootState = _ref217.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_820" /* SET_APPRAISAL_COMMUNITY_PARKING */], data);
    },
    SET_APPRAISAL_FACILITIES_OTHERS: function SET_APPRAISAL_FACILITIES_OTHERS(_ref218, data) {
        var state = _ref218.state,
            commit = _ref218.commit,
            rootState = _ref218.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_821" /* SET_APPRAISAL_FACILITIES_OTHERS */], data);
    },
    SET_APPRAISAL_FLOORS_USAGE_UNDERGROUND: function SET_APPRAISAL_FLOORS_USAGE_UNDERGROUND(_ref219, data) {
        var state = _ref219.state,
            commit = _ref219.commit,
            rootState = _ref219.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_822" /* SET_APPRAISAL_FLOORS_USAGE_UNDERGROUND */], data);
    },
    SET_APPRAISAL_FLOORS_USAGE_OVERGROUND: function SET_APPRAISAL_FLOORS_USAGE_OVERGROUND(_ref220, data) {
        var state = _ref220.state,
            commit = _ref220.commit,
            rootState = _ref220.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_823" /* SET_APPRAISAL_FLOORS_USAGE_OVERGROUND */], data);
    },
    SET_APPRAISAL_GROUNDFLOOR_USAGE: function SET_APPRAISAL_GROUNDFLOOR_USAGE(_ref221, data) {
        var state = _ref221.state,
            commit = _ref221.commit,
            rootState = _ref221.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_824" /* SET_APPRAISAL_GROUNDFLOOR_USAGE */], data);
    },
    SET_APPRAISAL_COMMUNICATIONS_AIRPORT: function SET_APPRAISAL_COMMUNICATIONS_AIRPORT(_ref222, data) {
        var state = _ref222.state,
            commit = _ref222.commit,
            rootState = _ref222.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_825" /* SET_APPRAISAL_COMMUNICATIONS_AIRPORT */], data);
    },
    SET_APPRAISAL_COMMUNICATIONS_HARBOUR: function SET_APPRAISAL_COMMUNICATIONS_HARBOUR(_ref223, data) {
        var state = _ref223.state,
            commit = _ref223.commit,
            rootState = _ref223.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_826" /* SET_APPRAISAL_COMMUNICATIONS_HARBOUR */], data);
    },
    SET_APPRAISAL_COMMUNICATIONS_TRAIN: function SET_APPRAISAL_COMMUNICATIONS_TRAIN(_ref224, data) {
        var state = _ref224.state,
            commit = _ref224.commit,
            rootState = _ref224.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_827" /* SET_APPRAISAL_COMMUNICATIONS_TRAIN */], data);
    },
    SET_APPRAISAL_PUBLIC_TRANSPORT_URBAN_UNDERGROUND: function SET_APPRAISAL_PUBLIC_TRANSPORT_URBAN_UNDERGROUND(_ref225, data) {
        var state = _ref225.state,
            commit = _ref225.commit,
            rootState = _ref225.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_828" /* SET_APPRAISAL_PUBLIC_TRANSPORT_URBAN_UNDERGROUND */], data);
    },
    SET_APPRAISAL_PUBLIC_TRANSPORT_INTERURBAN: function SET_APPRAISAL_PUBLIC_TRANSPORT_INTERURBAN(_ref226, data) {
        var state = _ref226.state,
            commit = _ref226.commit,
            rootState = _ref226.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_829" /* SET_APPRAISAL_PUBLIC_TRANSPORT_INTERURBAN */], data);
    },
    SET_APPRAISAL_SURROUNDING_FACILITIES_NOTES: function SET_APPRAISAL_SURROUNDING_FACILITIES_NOTES(_ref227, data) {
        var state = _ref227.state,
            commit = _ref227.commit,
            rootState = _ref227.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_830" /* SET_APPRAISAL_SURROUNDING_FACILITIES_NOTES */], data);
    },
    SET_APPRAISAL_SURROUNDING_TERRITORIAL_FEATURE: function SET_APPRAISAL_SURROUNDING_TERRITORIAL_FEATURE(_ref228, data) {
        var state = _ref228.state,
            commit = _ref228.commit,
            rootState = _ref228.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_831" /* SET_APPRAISAL_SURROUNDING_TERRITORIAL_FEATURE */], data);
    },
    SET_APPRAISAL_SURROUNDING_INCOME_LEVEL: function SET_APPRAISAL_SURROUNDING_INCOME_LEVEL(_ref229, data) {
        var state = _ref229.state,
            commit = _ref229.commit,
            rootState = _ref229.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_832" /* SET_APPRAISAL_SURROUNDING_INCOME_LEVEL */], data);
    },
    SET_APPRAISAL_SURROUNDING_HOMOGENEITY_FEATURE: function SET_APPRAISAL_SURROUNDING_HOMOGENEITY_FEATURE(_ref230, data) {
        var state = _ref230.state,
            commit = _ref230.commit,
            rootState = _ref230.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_833" /* SET_APPRAISAL_SURROUNDING_HOMOGENEITY_FEATURE */], data);
    },
    SET_APPRAISAL_SURROUNDING_MAIN_USES: function SET_APPRAISAL_SURROUNDING_MAIN_USES(_ref231, data) {
        var state = _ref231.state,
            commit = _ref231.commit,
            rootState = _ref231.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_834" /* SET_APPRAISAL_SURROUNDING_MAIN_USES */], data);
    },
    SET_APPRAISAL_SURROUNDING_DENSITY: function SET_APPRAISAL_SURROUNDING_DENSITY(_ref232, data) {
        var state = _ref232.state,
            commit = _ref232.commit,
            rootState = _ref232.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_835" /* SET_APPRAISAL_SURROUNDING_DENSITY */], data);
    },
    SET_APPRAISAL_SURROUNDING_ACCESSIBILITY: function SET_APPRAISAL_SURROUNDING_ACCESSIBILITY(_ref233, data) {
        var state = _ref233.state,
            commit = _ref233.commit,
            rootState = _ref233.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_836" /* SET_APPRAISAL_SURROUNDING_ACCESSIBILITY */], data);
    },
    SET_APPRAISAL_SURROUNDING_CONSOLIDATION_DEGREE: function SET_APPRAISAL_SURROUNDING_CONSOLIDATION_DEGREE(_ref234, data) {
        var state = _ref234.state,
            commit = _ref234.commit,
            rootState = _ref234.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_837" /* SET_APPRAISAL_SURROUNDING_CONSOLIDATION_DEGREE */], data);
    },
    SET_APPRAISAL_SURROUNDING_OCCUPATION_DEGREE: function SET_APPRAISAL_SURROUNDING_OCCUPATION_DEGREE(_ref235, data) {
        var state = _ref235.state,
            commit = _ref235.commit,
            rootState = _ref235.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_838" /* SET_APPRAISAL_SURROUNDING_OCCUPATION_DEGREE */], data);
    },
    SET_APPRAISAL_SURROUNDING_EVOLUTION_SPEED: function SET_APPRAISAL_SURROUNDING_EVOLUTION_SPEED(_ref236, data) {
        var state = _ref236.state,
            commit = _ref236.commit,
            rootState = _ref236.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_839" /* SET_APPRAISAL_SURROUNDING_EVOLUTION_SPEED */], data);
    },
    SET_APPRAISAL_SURROUNDING_AVERAGE_AGE: function SET_APPRAISAL_SURROUNDING_AVERAGE_AGE(_ref237, data) {
        var state = _ref237.state,
            commit = _ref237.commit,
            rootState = _ref237.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_840" /* SET_APPRAISAL_SURROUNDING_AVERAGE_AGE */], data);
    },
    SET_APPRAISAL_SURROUNDING_CONSERVATION_STATUS: function SET_APPRAISAL_SURROUNDING_CONSERVATION_STATUS(_ref238, data) {
        var state = _ref238.state,
            commit = _ref238.commit,
            rootState = _ref238.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_841" /* SET_APPRAISAL_SURROUNDING_CONSERVATION_STATUS */], data);
    },
    SET_APPRAISAL_SURROUNDING_COMMERCIAL_FACILITIES: function SET_APPRAISAL_SURROUNDING_COMMERCIAL_FACILITIES(_ref239, data) {
        var state = _ref239.state,
            commit = _ref239.commit,
            rootState = _ref239.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_842" /* SET_APPRAISAL_SURROUNDING_COMMERCIAL_FACILITIES */], data);
    },
    SET_APPRAISAL_SURROUNDING_EDUCATIONAL_FACILITIES: function SET_APPRAISAL_SURROUNDING_EDUCATIONAL_FACILITIES(_ref240, data) {
        var state = _ref240.state,
            commit = _ref240.commit,
            rootState = _ref240.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_843" /* SET_APPRAISAL_SURROUNDING_EDUCATIONAL_FACILITIES */], data);
    },
    SET_APPRAISAL_SURROUNDING_PUBLIC_PARKING: function SET_APPRAISAL_SURROUNDING_PUBLIC_PARKING(_ref241, data) {
        var state = _ref241.state,
            commit = _ref241.commit,
            rootState = _ref241.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_844" /* SET_APPRAISAL_SURROUNDING_PUBLIC_PARKING */], data);
    },
    SET_APPRAISAL_SURROUNDING_MEDICAL_ASSISTANCE: function SET_APPRAISAL_SURROUNDING_MEDICAL_ASSISTANCE(_ref242, data) {
        var state = _ref242.state,
            commit = _ref242.commit,
            rootState = _ref242.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_845" /* SET_APPRAISAL_SURROUNDING_MEDICAL_ASSISTANCE */], data);
    },
    SET_APPRAISAL_SURROUNDING_LEISURE: function SET_APPRAISAL_SURROUNDING_LEISURE(_ref243, data) {
        var state = _ref243.state,
            commit = _ref243.commit,
            rootState = _ref243.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_846" /* SET_APPRAISAL_SURROUNDING_LEISURE */], data);
    },
    SET_APPRAISAL_CADASTRAL_USAGE: function SET_APPRAISAL_CADASTRAL_USAGE(_ref244, data) {
        var state = _ref244.state,
            commit = _ref244.commit,
            rootState = _ref244.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_847" /* SET_APPRAISAL_CADASTRAL_USAGE */], data);
    },
    SET_APPRAISAL_CADASTRAL_FLOOR: function SET_APPRAISAL_CADASTRAL_FLOOR(_ref245, data) {
        var state = _ref245.state,
            commit = _ref245.commit,
            rootState = _ref245.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_848" /* SET_APPRAISAL_CADASTRAL_FLOOR */], data);
    },
    SET_APPRAISAL_CADASTRAL_DOOR: function SET_APPRAISAL_CADASTRAL_DOOR(_ref246, data) {
        var state = _ref246.state,
            commit = _ref246.commit,
            rootState = _ref246.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_849" /* SET_APPRAISAL_CADASTRAL_DOOR */], data);
    },
    SET_APPRAISAL_CADASTRAL_BLOCK: function SET_APPRAISAL_CADASTRAL_BLOCK(_ref247, data) {
        var state = _ref247.state,
            commit = _ref247.commit,
            rootState = _ref247.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_850" /* SET_APPRAISAL_CADASTRAL_BLOCK */], data);
    },
    SET_APPRAISAL_CADASTRAL_STAIRCASE: function SET_APPRAISAL_CADASTRAL_STAIRCASE(_ref248, data) {
        var state = _ref248.state,
            commit = _ref248.commit,
            rootState = _ref248.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_851" /* SET_APPRAISAL_CADASTRAL_STAIRCASE */], data);
    },
    SET_APPRAISAL_REGISTRY_NAME: function SET_APPRAISAL_REGISTRY_NAME(_ref249, data) {
        var state = _ref249.state,
            commit = _ref249.commit,
            rootState = _ref249.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_852" /* SET_APPRAISAL_REGISTRY_NAME */], data);
    },
    SET_APPRAISAL_REGISTRY_SECTION: function SET_APPRAISAL_REGISTRY_SECTION(_ref250, data) {
        var state = _ref250.state,
            commit = _ref250.commit,
            rootState = _ref250.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_853" /* SET_APPRAISAL_REGISTRY_SECTION */], data);
    },
    SET_APPRAISAL_REGISTRY_VOLUME: function SET_APPRAISAL_REGISTRY_VOLUME(_ref251, data) {
        var state = _ref251.state,
            commit = _ref251.commit,
            rootState = _ref251.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_854" /* SET_APPRAISAL_REGISTRY_VOLUME */], data);
    },
    SET_APPRAISAL_REGISTRY_BOOK: function SET_APPRAISAL_REGISTRY_BOOK(_ref252, data) {
        var state = _ref252.state,
            commit = _ref252.commit,
            rootState = _ref252.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_855" /* SET_APPRAISAL_REGISTRY_BOOK */], data);
    },
    SET_APPRAISAL_REGISTRY_PAGE: function SET_APPRAISAL_REGISTRY_PAGE(_ref253, data) {
        var state = _ref253.state,
            commit = _ref253.commit,
            rootState = _ref253.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_856" /* SET_APPRAISAL_REGISTRY_PAGE */], data);
    },
    SET_APPRAISAL_REGISTRY_REAL_ESTATE_NUMBER: function SET_APPRAISAL_REGISTRY_REAL_ESTATE_NUMBER(_ref254, data) {
        var state = _ref254.state,
            commit = _ref254.commit,
            rootState = _ref254.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_857" /* SET_APPRAISAL_REGISTRY_REAL_ESTATE_NUMBER */], data);
    },
    SET_APPRAISAL_REGISTRY_IDUFIR: function SET_APPRAISAL_REGISTRY_IDUFIR(_ref255, data) {
        var state = _ref255.state,
            commit = _ref255.commit,
            rootState = _ref255.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_858" /* SET_APPRAISAL_REGISTRY_IDUFIR */], data);
    },
    SET_APPRAISAL_REGISTRY_OWNER: function SET_APPRAISAL_REGISTRY_OWNER(_ref256, data) {
        var state = _ref256.state,
            commit = _ref256.commit,
            rootState = _ref256.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_859" /* SET_APPRAISAL_REGISTRY_OWNER */], data);
    },
    SET_APPRAISAL_REGISTRY_PROPERTY_COEF: function SET_APPRAISAL_REGISTRY_PROPERTY_COEF(_ref257, data) {
        var state = _ref257.state,
            commit = _ref257.commit,
            rootState = _ref257.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_860" /* SET_APPRAISAL_REGISTRY_PROPERTY_COEF */], data);
    },
    SET_APPRAISAL_NET_CADASTRAL_AREA: function SET_APPRAISAL_NET_CADASTRAL_AREA(_ref258, data) {
        var state = _ref258.state,
            commit = _ref258.commit,
            rootState = _ref258.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_861" /* SET_APPRAISAL_NET_CADASTRAL_AREA */], data);
    },
    SET_APPRAISAL_NET_REGISTRY_AREA: function SET_APPRAISAL_NET_REGISTRY_AREA(_ref259, data) {
        var state = _ref259.state,
            commit = _ref259.commit,
            rootState = _ref259.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_862" /* SET_APPRAISAL_NET_REGISTRY_AREA */], data);
    },
    SET_APPRAISAL_NET_CHECKED_AREA: function SET_APPRAISAL_NET_CHECKED_AREA(_ref260, data) {
        var state = _ref260.state,
            commit = _ref260.commit,
            rootState = _ref260.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_863" /* SET_APPRAISAL_NET_CHECKED_AREA */], data);
    },
    SET_APPRAISAL_NET_ADOPTED_AREA: function SET_APPRAISAL_NET_ADOPTED_AREA(_ref261, data) {
        var state = _ref261.state,
            commit = _ref261.commit,
            rootState = _ref261.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_864" /* SET_APPRAISAL_NET_ADOPTED_AREA */], data);
    },
    SET_APPRAISAL_ENCLOSED_CADASTRAL_AREA: function SET_APPRAISAL_ENCLOSED_CADASTRAL_AREA(_ref262, data) {
        var state = _ref262.state,
            commit = _ref262.commit,
            rootState = _ref262.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_865" /* SET_APPRAISAL_ENCLOSED_CADASTRAL_AREA */], data);
    },
    SET_APPRAISAL_ENCLOSED_REGISTRY_AREA: function SET_APPRAISAL_ENCLOSED_REGISTRY_AREA(_ref263, data) {
        var state = _ref263.state,
            commit = _ref263.commit,
            rootState = _ref263.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_866" /* SET_APPRAISAL_ENCLOSED_REGISTRY_AREA */], data);
    },
    SET_APPRAISAL_ENCLOSED_CHECKED_AREA: function SET_APPRAISAL_ENCLOSED_CHECKED_AREA(_ref264, data) {
        var state = _ref264.state,
            commit = _ref264.commit,
            rootState = _ref264.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_867" /* SET_APPRAISAL_ENCLOSED_CHECKED_AREA */], data);
    },
    SET_APPRAISAL_ENCLOSED_ADOPTED_AREA: function SET_APPRAISAL_ENCLOSED_ADOPTED_AREA(_ref265, data) {
        var state = _ref265.state,
            commit = _ref265.commit,
            rootState = _ref265.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_868" /* SET_APPRAISAL_ENCLOSED_ADOPTED_AREA */], data);
    },
    SET_APPRAISAL_COVERED_TERRACES_TOTAL_CADASTRAL_AREA: function SET_APPRAISAL_COVERED_TERRACES_TOTAL_CADASTRAL_AREA(_ref266, data) {
        var state = _ref266.state,
            commit = _ref266.commit,
            rootState = _ref266.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_869" /* SET_APPRAISAL_COVERED_TERRACES_TOTAL_CADASTRAL_AREA */], data);
    },
    SET_APPRAISAL_COVERED_TERRACES_TOTAL_REGISTRY_AREA: function SET_APPRAISAL_COVERED_TERRACES_TOTAL_REGISTRY_AREA(_ref267, data) {
        var state = _ref267.state,
            commit = _ref267.commit,
            rootState = _ref267.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_870" /* SET_APPRAISAL_COVERED_TERRACES_TOTAL_REGISTRY_AREA */], data);
    },
    SET_APPRAISAL_COVERED_TERRACES_TOTAL_CHECKED_AREA: function SET_APPRAISAL_COVERED_TERRACES_TOTAL_CHECKED_AREA(_ref268, data) {
        var state = _ref268.state,
            commit = _ref268.commit,
            rootState = _ref268.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_871" /* SET_APPRAISAL_COVERED_TERRACES_TOTAL_CHECKED_AREA */], data);
    },
    SET_APPRAISAL_COVERED_TERRACES_TOTAL_ADOPTED_AREA: function SET_APPRAISAL_COVERED_TERRACES_TOTAL_ADOPTED_AREA(_ref269, data) {
        var state = _ref269.state,
            commit = _ref269.commit,
            rootState = _ref269.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_872" /* SET_APPRAISAL_COVERED_TERRACES_TOTAL_ADOPTED_AREA */], data);
    },
    SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_CADASTRAL_AREA: function SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_CADASTRAL_AREA(_ref270, data) {
        var state = _ref270.state,
            commit = _ref270.commit,
            rootState = _ref270.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_873" /* SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_CADASTRAL_AREA */], data);
    },
    SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_REGISTRY_AREA: function SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_REGISTRY_AREA(_ref271, data) {
        var state = _ref271.state,
            commit = _ref271.commit,
            rootState = _ref271.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_874" /* SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_REGISTRY_AREA */], data);
    },
    SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_CHECKED_AREA: function SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_CHECKED_AREA(_ref272, data) {
        var state = _ref272.state,
            commit = _ref272.commit,
            rootState = _ref272.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_875" /* SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_CHECKED_AREA */], data);
    },
    SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_ADOPTED_AREA: function SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_ADOPTED_AREA(_ref273, data) {
        var state = _ref273.state,
            commit = _ref273.commit,
            rootState = _ref273.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_876" /* SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_ADOPTED_AREA */], data);
    },
    SET_APPRAISAL_BUILT_CADASTRAL_AREA: function SET_APPRAISAL_BUILT_CADASTRAL_AREA(_ref274, data) {
        var state = _ref274.state,
            commit = _ref274.commit,
            rootState = _ref274.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_877" /* SET_APPRAISAL_BUILT_CADASTRAL_AREA */], data);
    },
    SET_APPRAISAL_BUILT_REGISTRY_AREA: function SET_APPRAISAL_BUILT_REGISTRY_AREA(_ref275, data) {
        var state = _ref275.state,
            commit = _ref275.commit,
            rootState = _ref275.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_878" /* SET_APPRAISAL_BUILT_REGISTRY_AREA */], data);
    },
    SET_APPRAISAL_BUILT_CHECKED_AREA: function SET_APPRAISAL_BUILT_CHECKED_AREA(_ref276, data) {
        var state = _ref276.state,
            commit = _ref276.commit,
            rootState = _ref276.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_879" /* SET_APPRAISAL_BUILT_CHECKED_AREA */], data);
    },
    SET_APPRAISAL_BUILT_ADOPTED_AREA: function SET_APPRAISAL_BUILT_ADOPTED_AREA(_ref277, data) {
        var state = _ref277.state,
            commit = _ref277.commit,
            rootState = _ref277.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_880" /* SET_APPRAISAL_BUILT_ADOPTED_AREA */], data);
    },
    SET_APPRAISAL_COMMON_ELEMENTS_CADASTRAL_AREA: function SET_APPRAISAL_COMMON_ELEMENTS_CADASTRAL_AREA(_ref278, data) {
        var state = _ref278.state,
            commit = _ref278.commit,
            rootState = _ref278.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_881" /* SET_APPRAISAL_COMMON_ELEMENTS_CADASTRAL_AREA */], data);
    },
    SET_APPRAISAL_COMMON_ELEMENTS_REGISTRY_AREA: function SET_APPRAISAL_COMMON_ELEMENTS_REGISTRY_AREA(_ref279, data) {
        var state = _ref279.state,
            commit = _ref279.commit,
            rootState = _ref279.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_882" /* SET_APPRAISAL_COMMON_ELEMENTS_REGISTRY_AREA */], data);
    },
    SET_APPRAISAL_COMMON_ELEMENTS_CHECKED_AREA: function SET_APPRAISAL_COMMON_ELEMENTS_CHECKED_AREA(_ref280, data) {
        var state = _ref280.state,
            commit = _ref280.commit,
            rootState = _ref280.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_883" /* SET_APPRAISAL_COMMON_ELEMENTS_CHECKED_AREA */], data);
    },
    SET_APPRAISAL_COMMON_ELEMENTS_ADOPTED_AREA: function SET_APPRAISAL_COMMON_ELEMENTS_ADOPTED_AREA(_ref281, data) {
        var state = _ref281.state,
            commit = _ref281.commit,
            rootState = _ref281.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_884" /* SET_APPRAISAL_COMMON_ELEMENTS_ADOPTED_AREA */], data);
    },
    SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_CADASTRAL_AREA: function SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_CADASTRAL_AREA(_ref282, data) {
        var state = _ref282.state,
            commit = _ref282.commit,
            rootState = _ref282.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_885" /* SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_CADASTRAL_AREA */], data);
    },
    SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_REGISTRY_AREA: function SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_REGISTRY_AREA(_ref283, data) {
        var state = _ref283.state,
            commit = _ref283.commit,
            rootState = _ref283.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_886" /* SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_REGISTRY_AREA */], data);
    },
    SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_CHECKED_AREA: function SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_CHECKED_AREA(_ref284, data) {
        var state = _ref284.state,
            commit = _ref284.commit,
            rootState = _ref284.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_887" /* SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_CHECKED_AREA */], data);
    },
    SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_ADOPTED_AREA: function SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_ADOPTED_AREA(_ref285, data) {
        var state = _ref285.state,
            commit = _ref285.commit,
            rootState = _ref285.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_888" /* SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_ADOPTED_AREA */], data);
    },
    SET_APPRAISAL_BATHROOMS_NUMBER: function SET_APPRAISAL_BATHROOMS_NUMBER(_ref286, data) {
        var state = _ref286.state,
            commit = _ref286.commit,
            rootState = _ref286.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_889" /* SET_APPRAISAL_BATHROOMS_NUMBER */], data);
    },
    SET_APPRAISAL_BEDROOMS_NUMBER: function SET_APPRAISAL_BEDROOMS_NUMBER(_ref287, data) {
        var state = _ref287.state,
            commit = _ref287.commit,
            rootState = _ref287.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_890" /* SET_APPRAISAL_BEDROOMS_NUMBER */], data);
    },
    SET_APPRAISAL_NET_SELECTED_AREA: function SET_APPRAISAL_NET_SELECTED_AREA(_ref288, data) {
        var state = _ref288.state,
            commit = _ref288.commit,
            rootState = _ref288.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_891" /* SET_APPRAISAL_NET_SELECTED_AREA */], data);
    },
    SET_APPRAISAL_ENCLOSED_SELECTED_AREA: function SET_APPRAISAL_ENCLOSED_SELECTED_AREA(_ref289, data) {
        var state = _ref289.state,
            commit = _ref289.commit,
            rootState = _ref289.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_892" /* SET_APPRAISAL_ENCLOSED_SELECTED_AREA */], data);
    },
    SET_APPRAISAL_COVERED_OUTDOORS_SELECTED_AREA: function SET_APPRAISAL_COVERED_OUTDOORS_SELECTED_AREA(_ref290, data) {
        var state = _ref290.state,
            commit = _ref290.commit,
            rootState = _ref290.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_893" /* SET_APPRAISAL_COVERED_OUTDOORS_SELECTED_AREA */], data);
    },
    SET_APPRAISAL_BUILT_SELECTED_AREA: function SET_APPRAISAL_BUILT_SELECTED_AREA(_ref291, data) {
        var state = _ref291.state,
            commit = _ref291.commit,
            rootState = _ref291.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_894" /* SET_APPRAISAL_BUILT_SELECTED_AREA */], data);
    },
    SET_APPRAISAL_COMMON_ELEMENTS_SELECTED_AREA: function SET_APPRAISAL_COMMON_ELEMENTS_SELECTED_AREA(_ref292, data) {
        var state = _ref292.state,
            commit = _ref292.commit,
            rootState = _ref292.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_895" /* SET_APPRAISAL_COMMON_ELEMENTS_SELECTED_AREA */], data);
    },
    SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_SELECTED_AREA: function SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_SELECTED_AREA(_ref293, data) {
        var state = _ref293.state,
            commit = _ref293.commit,
            rootState = _ref293.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_896" /* SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_SELECTED_AREA */], data);
    },
    SET_APPRAISAL_LAND_SELECTED_AREA: function SET_APPRAISAL_LAND_SELECTED_AREA(_ref294, data) {
        var state = _ref294.state,
            commit = _ref294.commit,
            rootState = _ref294.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_897" /* SET_APPRAISAL_LAND_SELECTED_AREA */], data);
    },
    SET_APPRAISAL_REALESTATE_ROOMS_TO_EXTERIOR_NUMBER: function SET_APPRAISAL_REALESTATE_ROOMS_TO_EXTERIOR_NUMBER(_ref295, data) {
        var state = _ref295.state,
            commit = _ref295.commit,
            rootState = _ref295.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_898" /* SET_APPRAISAL_REALESTATE_ROOMS_TO_EXTERIOR_NUMBER */], data);
    },
    SET_APPRAISAL_REALESTATE_DAY_NIGHT_ZONING: function SET_APPRAISAL_REALESTATE_DAY_NIGHT_ZONING(_ref296, data) {
        var state = _ref296.state,
            commit = _ref296.commit,
            rootState = _ref296.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_899" /* SET_APPRAISAL_REALESTATE_DAY_NIGHT_ZONING */], data);
    },
    SET_APPRAISAL_REALESTATE_SYSTEMS_DOOR_OPENER: function SET_APPRAISAL_REALESTATE_SYSTEMS_DOOR_OPENER(_ref297, data) {
        var state = _ref297.state,
            commit = _ref297.commit,
            rootState = _ref297.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_900" /* SET_APPRAISAL_REALESTATE_SYSTEMS_DOOR_OPENER */], data);
    },
    SET_APPRAISAL_REALESTATE_SYSTEMS_FITTED_CUPBOARDS: function SET_APPRAISAL_REALESTATE_SYSTEMS_FITTED_CUPBOARDS(_ref298, data) {
        var state = _ref298.state,
            commit = _ref298.commit,
            rootState = _ref298.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_901" /* SET_APPRAISAL_REALESTATE_SYSTEMS_FITTED_CUPBOARDS */], data);
    },
    SET_APPRAISAL_REALESTATE_SYSTEMS_GAS: function SET_APPRAISAL_REALESTATE_SYSTEMS_GAS(_ref299, data) {
        var state = _ref299.state,
            commit = _ref299.commit,
            rootState = _ref299.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_902" /* SET_APPRAISAL_REALESTATE_SYSTEMS_GAS */], data);
    },
    SET_APPRAISAL_REALESTATE_SYSTEMS_SANITARY_FITTINGS: function SET_APPRAISAL_REALESTATE_SYSTEMS_SANITARY_FITTINGS(_ref300, data) {
        var state = _ref300.state,
            commit = _ref300.commit,
            rootState = _ref300.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_903" /* SET_APPRAISAL_REALESTATE_SYSTEMS_SANITARY_FITTINGS */], data);
    },
    SET_APPRAISAL_REALESTATE_SYSTEMS_TAPS: function SET_APPRAISAL_REALESTATE_SYSTEMS_TAPS(_ref301, data) {
        var state = _ref301.state,
            commit = _ref301.commit,
            rootState = _ref301.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_904" /* SET_APPRAISAL_REALESTATE_SYSTEMS_TAPS */], data);
    },
    SET_APPRAISAL_REALESTATE_SYSTEMS_HOT_WATER: function SET_APPRAISAL_REALESTATE_SYSTEMS_HOT_WATER(_ref302, data) {
        var state = _ref302.state,
            commit = _ref302.commit,
            rootState = _ref302.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_905" /* SET_APPRAISAL_REALESTATE_SYSTEMS_HOT_WATER */], data);
    },
    SET_APPRAISAL_REALESTATE_SYSTEMS_HEATING: function SET_APPRAISAL_REALESTATE_SYSTEMS_HEATING(_ref303, data) {
        var state = _ref303.state,
            commit = _ref303.commit,
            rootState = _ref303.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_906" /* SET_APPRAISAL_REALESTATE_SYSTEMS_HEATING */], data);
    },
    SET_APPRAISAL_REALESTATE_SYSTEMS_AIR_CONDITIONING: function SET_APPRAISAL_REALESTATE_SYSTEMS_AIR_CONDITIONING(_ref304, data) {
        var state = _ref304.state,
            commit = _ref304.commit,
            rootState = _ref304.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_907" /* SET_APPRAISAL_REALESTATE_SYSTEMS_AIR_CONDITIONING */], data);
    },
    SET_APPRAISAL_REALESTATE_SYSTEMS_TV: function SET_APPRAISAL_REALESTATE_SYSTEMS_TV(_ref305, data) {
        var state = _ref305.state,
            commit = _ref305.commit,
            rootState = _ref305.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_908" /* SET_APPRAISAL_REALESTATE_SYSTEMS_TV */], data);
    },
    SET_APPRAISAL_REALESTATE_SYSTEMS_TELEPHONE: function SET_APPRAISAL_REALESTATE_SYSTEMS_TELEPHONE(_ref306, data) {
        var state = _ref306.state,
            commit = _ref306.commit,
            rootState = _ref306.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_909" /* SET_APPRAISAL_REALESTATE_SYSTEMS_TELEPHONE */], data);
    },
    SET_APPRAISAL_REALESTATE_SYSTEMS_FIRE_PREVENTION: function SET_APPRAISAL_REALESTATE_SYSTEMS_FIRE_PREVENTION(_ref307, data) {
        var state = _ref307.state,
            commit = _ref307.commit,
            rootState = _ref307.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_910" /* SET_APPRAISAL_REALESTATE_SYSTEMS_FIRE_PREVENTION */], data);
    },
    SET_APPRAISAL_REALESTATE_SYSTEMS_INTRUSION_PREVENTION: function SET_APPRAISAL_REALESTATE_SYSTEMS_INTRUSION_PREVENTION(_ref308, data) {
        var state = _ref308.state,
            commit = _ref308.commit,
            rootState = _ref308.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_911" /* SET_APPRAISAL_REALESTATE_SYSTEMS_INTRUSION_PREVENTION */], data);
    },
    SET_APPRAISAL_REALESTATE_FOUNDATION: function SET_APPRAISAL_REALESTATE_FOUNDATION(_ref309, data) {
        var state = _ref309.state,
            commit = _ref309.commit,
            rootState = _ref309.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_912" /* SET_APPRAISAL_REALESTATE_FOUNDATION */], data);
    },
    SET_APPRAISAL_REALESTATE_STRUCTURE: function SET_APPRAISAL_REALESTATE_STRUCTURE(_ref310, data) {
        var state = _ref310.state,
            commit = _ref310.commit,
            rootState = _ref310.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_913" /* SET_APPRAISAL_REALESTATE_STRUCTURE */], data);
    },
    SET_APPRAISAL_REALESTATE_ROOF: function SET_APPRAISAL_REALESTATE_ROOF(_ref311, data) {
        var state = _ref311.state,
            commit = _ref311.commit,
            rootState = _ref311.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_914" /* SET_APPRAISAL_REALESTATE_ROOF */], data);
    },
    SET_APPRAISAL_REALESTATE_EXTERNAL_ENCLOSURES: function SET_APPRAISAL_REALESTATE_EXTERNAL_ENCLOSURES(_ref312, data) {
        var state = _ref312.state,
            commit = _ref312.commit,
            rootState = _ref312.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_915" /* SET_APPRAISAL_REALESTATE_EXTERNAL_ENCLOSURES */], data);
    },
    SET_APPRAISAL_REALESTATE_INSULATION: function SET_APPRAISAL_REALESTATE_INSULATION(_ref313, data) {
        var state = _ref313.state,
            commit = _ref313.commit,
            rootState = _ref313.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_916" /* SET_APPRAISAL_REALESTATE_INSULATION */], data);
    },
    SET_APPRAISAL_REALESTATE_EXTERNAL_CARPENTRY: function SET_APPRAISAL_REALESTATE_EXTERNAL_CARPENTRY(_ref314, data) {
        var state = _ref314.state,
            commit = _ref314.commit,
            rootState = _ref314.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_917" /* SET_APPRAISAL_REALESTATE_EXTERNAL_CARPENTRY */], data);
    },
    SET_APPRAISAL_REALESTATE_GLAZING: function SET_APPRAISAL_REALESTATE_GLAZING(_ref315, data) {
        var state = _ref315.state,
            commit = _ref315.commit,
            rootState = _ref315.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_918" /* SET_APPRAISAL_REALESTATE_GLAZING */], data);
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_LIVING: function SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_LIVING(_ref316, data) {
        var state = _ref316.state,
            commit = _ref316.commit,
            rootState = _ref316.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_919" /* SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_LIVING */], data);
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_CORRIDOR: function SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_CORRIDOR(_ref317, data) {
        var state = _ref317.state,
            commit = _ref317.commit,
            rootState = _ref317.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_920" /* SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_CORRIDOR */], data);
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_BEDROOM: function SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_BEDROOM(_ref318, data) {
        var state = _ref318.state,
            commit = _ref318.commit,
            rootState = _ref318.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_921" /* SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_BEDROOM */], data);
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_KITCHEN: function SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_KITCHEN(_ref319, data) {
        var state = _ref319.state,
            commit = _ref319.commit,
            rootState = _ref319.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_922" /* SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_KITCHEN */], data);
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_BATHROOM: function SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_BATHROOM(_ref320, data) {
        var state = _ref320.state,
            commit = _ref320.commit,
            rootState = _ref320.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_923" /* SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_BATHROOM */], data);
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_QUALITY: function SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_QUALITY(_ref321, data) {
        var state = _ref321.state,
            commit = _ref321.commit,
            rootState = _ref321.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_924" /* SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_QUALITY */], data);
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_LIVING: function SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_LIVING(_ref322, data) {
        var state = _ref322.state,
            commit = _ref322.commit,
            rootState = _ref322.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_925" /* SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_LIVING */], data);
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_CORRIDOR: function SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_CORRIDOR(_ref323, data) {
        var state = _ref323.state,
            commit = _ref323.commit,
            rootState = _ref323.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_926" /* SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_CORRIDOR */], data);
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_BEDROOM: function SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_BEDROOM(_ref324, data) {
        var state = _ref324.state,
            commit = _ref324.commit,
            rootState = _ref324.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_927" /* SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_BEDROOM */], data);
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_KITCHEN: function SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_KITCHEN(_ref325, data) {
        var state = _ref325.state,
            commit = _ref325.commit,
            rootState = _ref325.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_928" /* SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_KITCHEN */], data);
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_BATHROOM: function SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_BATHROOM(_ref326, data) {
        var state = _ref326.state,
            commit = _ref326.commit,
            rootState = _ref326.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_929" /* SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_BATHROOM */], data);
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_QUALITY: function SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_QUALITY(_ref327, data) {
        var state = _ref327.state,
            commit = _ref327.commit,
            rootState = _ref327.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_930" /* SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_QUALITY */], data);
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_LIVING: function SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_LIVING(_ref328, data) {
        var state = _ref328.state,
            commit = _ref328.commit,
            rootState = _ref328.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_931" /* SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_LIVING */], data);
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_CORRIDOR: function SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_CORRIDOR(_ref329, data) {
        var state = _ref329.state,
            commit = _ref329.commit,
            rootState = _ref329.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_932" /* SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_CORRIDOR */], data);
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_BEDROOM: function SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_BEDROOM(_ref330, data) {
        var state = _ref330.state,
            commit = _ref330.commit,
            rootState = _ref330.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_933" /* SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_BEDROOM */], data);
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_KITCHEN: function SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_KITCHEN(_ref331, data) {
        var state = _ref331.state,
            commit = _ref331.commit,
            rootState = _ref331.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_934" /* SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_KITCHEN */], data);
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_BATHROOM: function SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_BATHROOM(_ref332, data) {
        var state = _ref332.state,
            commit = _ref332.commit,
            rootState = _ref332.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_935" /* SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_BATHROOM */], data);
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_QUALITY: function SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_QUALITY(_ref333, data) {
        var state = _ref333.state,
            commit = _ref333.commit,
            rootState = _ref333.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_936" /* SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_QUALITY */], data);
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_LIVING: function SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_LIVING(_ref334, data) {
        var state = _ref334.state,
            commit = _ref334.commit,
            rootState = _ref334.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_937" /* SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_LIVING */], data);
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_CORRIDOR: function SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_CORRIDOR(_ref335, data) {
        var state = _ref335.state,
            commit = _ref335.commit,
            rootState = _ref335.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_938" /* SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_CORRIDOR */], data);
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_BEDROOM: function SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_BEDROOM(_ref336, data) {
        var state = _ref336.state,
            commit = _ref336.commit,
            rootState = _ref336.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_939" /* SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_BEDROOM */], data);
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_KITCHEN: function SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_KITCHEN(_ref337, data) {
        var state = _ref337.state,
            commit = _ref337.commit,
            rootState = _ref337.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_940" /* SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_KITCHEN */], data);
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_BATHROOM: function SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_BATHROOM(_ref338, data) {
        var state = _ref338.state,
            commit = _ref338.commit,
            rootState = _ref338.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_941" /* SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_BATHROOM */], data);
    },
    SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_QUALITY: function SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_QUALITY(_ref339, data) {
        var state = _ref339.state,
            commit = _ref339.commit,
            rootState = _ref339.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_942" /* SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_QUALITY */], data);
    },
    SET_APPRAISAL_REALESTATE_MAIN_ORIENTATION: function SET_APPRAISAL_REALESTATE_MAIN_ORIENTATION(_ref340, data) {
        var state = _ref340.state,
            commit = _ref340.commit,
            rootState = _ref340.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_943" /* SET_APPRAISAL_REALESTATE_MAIN_ORIENTATION */], data);
    },
    SET_APPRAISAL_REALESTATE_MAIN_VIEWS: function SET_APPRAISAL_REALESTATE_MAIN_VIEWS(_ref341, data) {
        var state = _ref341.state,
            commit = _ref341.commit,
            rootState = _ref341.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_944" /* SET_APPRAISAL_REALESTATE_MAIN_VIEWS */], data);
    },
    SET_APPRAISAL_REALESTATE_WINDOWS_SIZE_AND_QUANTITY: function SET_APPRAISAL_REALESTATE_WINDOWS_SIZE_AND_QUANTITY(_ref342, data) {
        var state = _ref342.state,
            commit = _ref342.commit,
            rootState = _ref342.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_945" /* SET_APPRAISAL_REALESTATE_WINDOWS_SIZE_AND_QUANTITY */], data);
    },
    SET_APPRAISAL_REALESTATE_NOISE_FACADE: function SET_APPRAISAL_REALESTATE_NOISE_FACADE(_ref343, data) {
        var state = _ref343.state,
            commit = _ref343.commit,
            rootState = _ref343.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_946" /* SET_APPRAISAL_REALESTATE_NOISE_FACADE */], data);
    },
    SET_APPRAISAL_REALESTATE_SYSTEMS_SANITARY_FITTINGS_QUALITY: function SET_APPRAISAL_REALESTATE_SYSTEMS_SANITARY_FITTINGS_QUALITY(_ref344, data) {
        var state = _ref344.state,
            commit = _ref344.commit,
            rootState = _ref344.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_947" /* SET_APPRAISAL_REALESTATE_SYSTEMS_SANITARY_FITTINGS_QUALITY */], data);
    },
    SET_APPRAISAL_REALESTATE_SYSTEMS_TAPS_QUALITY: function SET_APPRAISAL_REALESTATE_SYSTEMS_TAPS_QUALITY(_ref345, data) {
        var state = _ref345.state,
            commit = _ref345.commit,
            rootState = _ref345.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_948" /* SET_APPRAISAL_REALESTATE_SYSTEMS_TAPS_QUALITY */], data);
    },
    SET_APPRAISAL_BEC_ADJUSTMENT_COEF: function SET_APPRAISAL_BEC_ADJUSTMENT_COEF(_ref346, data) {
        var state = _ref346.state,
            commit = _ref346.commit,
            rootState = _ref346.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_949" /* SET_APPRAISAL_BEC_ADJUSTMENT_COEF */], data);
    },
    SET_APPRAISAL_BEC_PROPERTY_TYPE: function SET_APPRAISAL_BEC_PROPERTY_TYPE(_ref347, data) {
        var state = _ref347.state,
            commit = _ref347.commit,
            rootState = _ref347.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_950" /* SET_APPRAISAL_BEC_PROPERTY_TYPE */], data);
    },
    SET_APPRAISAL_BEC_NUMBER: function SET_APPRAISAL_BEC_NUMBER(_ref348, data) {
        var state = _ref348.state,
            commit = _ref348.commit,
            rootState = _ref348.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_951" /* SET_APPRAISAL_BEC_NUMBER */], data);
    },
    SET_APPRAISAL_CONSTRUCTION_STATUS: function SET_APPRAISAL_CONSTRUCTION_STATUS(_ref349, data) {
        var state = _ref349.state,
            commit = _ref349.commit,
            rootState = _ref349.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_952" /* SET_APPRAISAL_CONSTRUCTION_STATUS */], data);
    },
    SET_APPRAISAL_EXPENSES_AND_INDUSTRIAL_BENEFIT_BEC_PCT: function SET_APPRAISAL_EXPENSES_AND_INDUSTRIAL_BENEFIT_BEC_PCT(_ref350, data) {
        var state = _ref350.state,
            commit = _ref350.commit,
            rootState = _ref350.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_953" /* SET_APPRAISAL_EXPENSES_AND_INDUSTRIAL_BENEFIT_BEC_PCT */], data);
    },
    SET_APPRAISAL_CONSTRUCTION_COST_NOTES: function SET_APPRAISAL_CONSTRUCTION_COST_NOTES(_ref351, data) {
        var state = _ref351.state,
            commit = _ref351.commit,
            rootState = _ref351.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_954" /* SET_APPRAISAL_CONSTRUCTION_COST_NOTES */], data);
    },
    SET_APPRAISAL_CADASTRAL_CONSTRUCTION_YEAR: function SET_APPRAISAL_CADASTRAL_CONSTRUCTION_YEAR(_ref352, data) {
        var state = _ref352.state,
            commit = _ref352.commit,
            rootState = _ref352.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_955" /* SET_APPRAISAL_CADASTRAL_CONSTRUCTION_YEAR */], data);
    },
    SET_APPRAISAL_CONSTRUCTION_YEAR: function SET_APPRAISAL_CONSTRUCTION_YEAR(_ref353, data) {
        var state = _ref353.state,
            commit = _ref353.commit,
            rootState = _ref353.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_956" /* SET_APPRAISAL_CONSTRUCTION_YEAR */], data);
    },
    SET_APPRAISAL_LAST_RENOVATION_YEAR: function SET_APPRAISAL_LAST_RENOVATION_YEAR(_ref354, data) {
        var state = _ref354.state,
            commit = _ref354.commit,
            rootState = _ref354.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_957" /* SET_APPRAISAL_LAST_RENOVATION_YEAR */], data);
    },
    SET_APPRAISAL_NUCLEUS_POPULATION: function SET_APPRAISAL_NUCLEUS_POPULATION(_ref355, data) {
        var state = _ref355.state,
            commit = _ref355.commit,
            rootState = _ref355.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_614" /* SET_APPRAISAL_NUCLEUS_POPULATION */], data);
    },
    SET_APPRAISAL_NUCLEUS_POPULATION_DENSITY: function SET_APPRAISAL_NUCLEUS_POPULATION_DENSITY(_ref356, data) {
        var state = _ref356.state,
            commit = _ref356.commit,
            rootState = _ref356.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_616" /* SET_APPRAISAL_NUCLEUS_POPULATION_DENSITY */], data);
    },
    SET_APPRAISAL_NUCLEUS_POPULATION_GROWTH: function SET_APPRAISAL_NUCLEUS_POPULATION_GROWTH(_ref357, data) {
        var state = _ref357.state,
            commit = _ref357.commit,
            rootState = _ref357.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_617" /* SET_APPRAISAL_NUCLEUS_POPULATION_GROWTH */], data);
    },
    SET_APPRAISAL_OCCUPATION_AGRICULTURE_PCT: function SET_APPRAISAL_OCCUPATION_AGRICULTURE_PCT(_ref358, data) {
        var state = _ref358.state,
            commit = _ref358.commit,
            rootState = _ref358.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_958" /* SET_APPRAISAL_OCCUPATION_AGRICULTURE_PCT */], data);
    },
    SET_APPRAISAL_OCCUPATION_INDUSTRY_PCT: function SET_APPRAISAL_OCCUPATION_INDUSTRY_PCT(_ref359, data) {
        var state = _ref359.state,
            commit = _ref359.commit,
            rootState = _ref359.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_959" /* SET_APPRAISAL_OCCUPATION_INDUSTRY_PCT */], data);
    },
    SET_APPRAISAL_OCCUPATION_CONSTRUCTION_PCT: function SET_APPRAISAL_OCCUPATION_CONSTRUCTION_PCT(_ref360, data) {
        var state = _ref360.state,
            commit = _ref360.commit,
            rootState = _ref360.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_960" /* SET_APPRAISAL_OCCUPATION_CONSTRUCTION_PCT */], data);
    },
    SET_APPRAISAL_OCCUPATION_SERVICES_PCT: function SET_APPRAISAL_OCCUPATION_SERVICES_PCT(_ref361, data) {
        var state = _ref361.state,
            commit = _ref361.commit,
            rootState = _ref361.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_961" /* SET_APPRAISAL_OCCUPATION_SERVICES_PCT */], data);
    },
    SET_APPRAISAL_OCCUPATION_TOTAL_PCT: function SET_APPRAISAL_OCCUPATION_TOTAL_PCT(_ref362, data) {
        var state = _ref362.state,
            commit = _ref362.commit,
            rootState = _ref362.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_962" /* SET_APPRAISAL_OCCUPATION_TOTAL_PCT */], data);
    },
    SET_APPRAISAL_NUCLEUS_TYPE: function SET_APPRAISAL_NUCLEUS_TYPE(_ref363, data) {
        var state = _ref363.state,
            commit = _ref363.commit,
            rootState = _ref363.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_618" /* SET_APPRAISAL_NUCLEUS_TYPE */], data);
    },
    SET_APPRAISAL_OCCUPATION_DESCRIPTION: function SET_APPRAISAL_OCCUPATION_DESCRIPTION(_ref364, data) {
        var state = _ref364.state,
            commit = _ref364.commit,
            rootState = _ref364.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_619" /* SET_APPRAISAL_OCCUPATION_DESCRIPTION */], data);
    },
    SET_APPRAISAL_NUCLEUS_AREA: function SET_APPRAISAL_NUCLEUS_AREA(_ref365, data) {
        var state = _ref365.state,
            commit = _ref365.commit,
            rootState = _ref365.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_615" /* SET_APPRAISAL_NUCLEUS_AREA */], data);
    },
    SET_APPRAISAL_PROPERTY_TITLE: function SET_APPRAISAL_PROPERTY_TITLE(_ref366, data) {
        var state = _ref366.state,
            commit = _ref366.commit,
            rootState = _ref366.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_963" /* SET_APPRAISAL_PROPERTY_TITLE */], data);
    },
    SET_APPRAISAL_USAGE_ASSIGNED: function SET_APPRAISAL_USAGE_ASSIGNED(_ref367, data) {
        var state = _ref367.state,
            commit = _ref367.commit,
            rootState = _ref367.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_964" /* SET_APPRAISAL_USAGE_ASSIGNED */], data);
    },
    SET_APPRAISAL_INSPECTION_REALIZED: function SET_APPRAISAL_INSPECTION_REALIZED(_ref368, data) {
        var state = _ref368.state,
            commit = _ref368.commit,
            rootState = _ref368.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_965" /* SET_APPRAISAL_INSPECTION_REALIZED */], data);
    },
    SET_APPRAISAL_ECONOMICAL_ACTIVITY: function SET_APPRAISAL_ECONOMICAL_ACTIVITY(_ref369, data) {
        var state = _ref369.state,
            commit = _ref369.commit,
            rootState = _ref369.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_966" /* SET_APPRAISAL_ECONOMICAL_ACTIVITY */], data);
    },
    SET_APPRAISAL_OCCUPANCY_STATUS: function SET_APPRAISAL_OCCUPANCY_STATUS(_ref370, data) {
        var state = _ref370.state,
            commit = _ref370.commit,
            rootState = _ref370.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_967" /* SET_APPRAISAL_OCCUPANCY_STATUS */], data);
    },
    SET_APPRAISAL_MARKETSTUDY_ID: function SET_APPRAISAL_MARKETSTUDY_ID(_ref371, data) {
        var state = _ref371.state,
            commit = _ref371.commit,
            rootState = _ref371.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_968" /* SET_APPRAISAL_MARKETSTUDY_ID */], data);
    },
    SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_OFFSET_X: function SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_OFFSET_X(_ref372, data) {
        var state = _ref372.state,
            commit = _ref372.commit,
            rootState = _ref372.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_969" /* SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_OFFSET_X */], data);
    },
    SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_OFFSET_Y: function SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_OFFSET_Y(_ref373, data) {
        var state = _ref373.state,
            commit = _ref373.commit,
            rootState = _ref373.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_970" /* SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_OFFSET_Y */], data);
    },
    SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_ZOOM: function SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_ZOOM(_ref374, data) {
        var state = _ref374.state,
            commit = _ref374.commit,
            rootState = _ref374.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_971" /* SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_ZOOM */], data);
    },
    SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_OFFSET_X: function SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_OFFSET_X(_ref375, data) {
        var state = _ref375.state,
            commit = _ref375.commit,
            rootState = _ref375.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_972" /* SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_OFFSET_X */], data);
    },
    SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_OFFSET_Y: function SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_OFFSET_Y(_ref376, data) {
        var state = _ref376.state,
            commit = _ref376.commit,
            rootState = _ref376.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_973" /* SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_OFFSET_Y */], data);
    },
    SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_ZOOM: function SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_ZOOM(_ref377, data) {
        var state = _ref377.state,
            commit = _ref377.commit,
            rootState = _ref377.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_974" /* SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_ZOOM */], data);
    },
    SET_APPRAISAL_MAP_URBAN_ICC_TOPO_OFFSET_X: function SET_APPRAISAL_MAP_URBAN_ICC_TOPO_OFFSET_X(_ref378, data) {
        var state = _ref378.state,
            commit = _ref378.commit,
            rootState = _ref378.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_975" /* SET_APPRAISAL_MAP_URBAN_ICC_TOPO_OFFSET_X */], data);
    },
    SET_APPRAISAL_MAP_URBAN_ICC_TOPO_OFFSET_Y: function SET_APPRAISAL_MAP_URBAN_ICC_TOPO_OFFSET_Y(_ref379, data) {
        var state = _ref379.state,
            commit = _ref379.commit,
            rootState = _ref379.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_976" /* SET_APPRAISAL_MAP_URBAN_ICC_TOPO_OFFSET_Y */], data);
    },
    SET_APPRAISAL_MAP_URBAN_ICC_TOPO_ZOOM: function SET_APPRAISAL_MAP_URBAN_ICC_TOPO_ZOOM(_ref380, data) {
        var state = _ref380.state,
            commit = _ref380.commit,
            rootState = _ref380.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_977" /* SET_APPRAISAL_MAP_URBAN_ICC_TOPO_ZOOM */], data);
    },
    SET_APPRAISAL_QUOTE_TRAVEL_ONE_WAY_HOURS: function SET_APPRAISAL_QUOTE_TRAVEL_ONE_WAY_HOURS(_ref381, data) {
        var state = _ref381.state,
            commit = _ref381.commit,
            rootState = _ref381.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_978" /* SET_APPRAISAL_QUOTE_TRAVEL_ONE_WAY_HOURS */], data);
    },
    SET_APPRAISAL_QUOTE_TRAVEL_BOTH_WAYS_HOURS: function SET_APPRAISAL_QUOTE_TRAVEL_BOTH_WAYS_HOURS(_ref382, data) {
        var state = _ref382.state,
            commit = _ref382.commit,
            rootState = _ref382.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_979" /* SET_APPRAISAL_QUOTE_TRAVEL_BOTH_WAYS_HOURS */], data);
    },
    SET_APPRAISAL_QUOTE_TRAVEL_FEES_PER_HOUR: function SET_APPRAISAL_QUOTE_TRAVEL_FEES_PER_HOUR(_ref383, data) {
        var state = _ref383.state,
            commit = _ref383.commit,
            rootState = _ref383.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_980" /* SET_APPRAISAL_QUOTE_TRAVEL_FEES_PER_HOUR */], data);
    },
    SET_APPRAISAL_QUOTE_CAR_EXPENSES_ONE_WAY: function SET_APPRAISAL_QUOTE_CAR_EXPENSES_ONE_WAY(_ref384, data) {
        var state = _ref384.state,
            commit = _ref384.commit,
            rootState = _ref384.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_981" /* SET_APPRAISAL_QUOTE_CAR_EXPENSES_ONE_WAY */], data);
    },
    SET_APPRAISAL_QUOTE_CAR_EXPENSES_BOTH_WAYS: function SET_APPRAISAL_QUOTE_CAR_EXPENSES_BOTH_WAYS(_ref385, data) {
        var state = _ref385.state,
            commit = _ref385.commit,
            rootState = _ref385.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_982" /* SET_APPRAISAL_QUOTE_CAR_EXPENSES_BOTH_WAYS */], data);
    },
    SET_APPRAISAL_QUOTE_TOTAL_TRAVEL_FEES: function SET_APPRAISAL_QUOTE_TOTAL_TRAVEL_FEES(_ref386, data) {
        var state = _ref386.state,
            commit = _ref386.commit,
            rootState = _ref386.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_983" /* SET_APPRAISAL_QUOTE_TOTAL_TRAVEL_FEES */], data);
    },
    SET_APPRAISAL_QUOTE_AREA_AVERAGE_UNIT_PRICE: function SET_APPRAISAL_QUOTE_AREA_AVERAGE_UNIT_PRICE(_ref387, data) {
        var state = _ref387.state,
            commit = _ref387.commit,
            rootState = _ref387.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_984" /* SET_APPRAISAL_QUOTE_AREA_AVERAGE_UNIT_PRICE */], data);
    },
    SET_APPRAISAL_QUOTE_BASE_FEES: function SET_APPRAISAL_QUOTE_BASE_FEES(_ref388, data) {
        var state = _ref388.state,
            commit = _ref388.commit,
            rootState = _ref388.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_985" /* SET_APPRAISAL_QUOTE_BASE_FEES */], data);
    },
    SET_APPRAISAL_QUOTE_EXCESS_PCT: function SET_APPRAISAL_QUOTE_EXCESS_PCT(_ref389, data) {
        var state = _ref389.state,
            commit = _ref389.commit,
            rootState = _ref389.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_986" /* SET_APPRAISAL_QUOTE_EXCESS_PCT */], data);
    },
    SET_APPRAISAL_QUOTE_BASE_PRICE: function SET_APPRAISAL_QUOTE_BASE_PRICE(_ref390, data) {
        var state = _ref390.state,
            commit = _ref390.commit,
            rootState = _ref390.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_987" /* SET_APPRAISAL_QUOTE_BASE_PRICE */], data);
    },
    SET_APPRAISAL_QUOTE_BASE_PRICE_COEF: function SET_APPRAISAL_QUOTE_BASE_PRICE_COEF(_ref391, data) {
        var state = _ref391.state,
            commit = _ref391.commit,
            rootState = _ref391.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_988" /* SET_APPRAISAL_QUOTE_BASE_PRICE_COEF */], data);
    },
    SET_APPRAISAL_USAGE_TYPE: function SET_APPRAISAL_USAGE_TYPE(_ref392, data) {
        var state = _ref392.state,
            commit = _ref392.commit,
            rootState = _ref392.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_989" /* SET_APPRAISAL_USAGE_TYPE */], data);
    },
    SET_APPRAISAL_PARKING_SPOTS_INCLUDED_NUMBER: function SET_APPRAISAL_PARKING_SPOTS_INCLUDED_NUMBER(_ref393, data) {
        var state = _ref393.state,
            commit = _ref393.commit,
            rootState = _ref393.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_990" /* SET_APPRAISAL_PARKING_SPOTS_INCLUDED_NUMBER */], data);
    }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_612" /* RESET_APPRAISAL */], function (state) {
    state.date_created = null;
    state.date_modified = null;
    state.dirty = false;
    state.id = null;
    state.parent_path = null;
    state.path = null;
    state.appraisaldate = null;
    state.visitdate = null;
    state.technician_visiting = null;
    state.description = null;
    state.checks_cadastral_data = true;
    state.checks_conservation_status = true;
    state.checks_expropriation_procedure = false;
    state.checks_expropriation_plan = false;
    state.checks_expropriation_admin_ruling = false;
    state.checks_expropriation_file = false;
    state.checks_interior_visit = true;
    state.checks_occupancy = true;
    state.checks_other = null;
    state.checks_registry_data = true;
    state.checks_servitudes = true;
    state.checks_subsidy_status = true;
    state.checks_urban_planning = true;
    state.docs_approved_project = false;
    state.docs_cadastral_data = true;
    state.docs_construction_license = false;
    state.docs_construction_last_certificate = false;
    state.docs_construction_contract = false;
    state.docs_occupancy_status = false;
    state.docs_other = null;
    state.docs_photographic_report = true;
    state.docs_property_sketch = true;
    state.docs_property_titles = true;
    state.docs_situation_plan = true;
    state.docs_subsidy_status = false;
    state.docs_tenyear_insurance = false;
    state.docs_urban_plan = true;
    state.purpose = {
        acc_eco_decree: { id: 2, bde_code: 'N', name_ca: 'No', name_en: 'No', name_es: 'No' },
        acc_mortgage_market_law: { id: 2, bde_code: 'N', name_ca: 'No', name_en: 'No', name_es: 'No' },
        bde_code: 'O',
        id: 5,
        name_ca: 'Adquisició o venda',
        name_en: 'Purchase or sale',
        name_es: 'Adquisición o venta',
        default_notes: {
            name_ca: 'La taxació NO és vàlida per a fins hipotecaris perquè no s\'utilitza el criteri de valor garantit en el temps, si més no el valor en el dia de la data consignada',
            name_en: 'The appraisal is NOT valid for mortgage guarantees since the criteria for the value-over-time-guarantee is not applied',
            name_es: 'La tasación NO es válida para fines hipotecarios porque no se utiliza el criterio del valor garantizado en el tiempo, sino el valor en el día de la fecha consignada'
        },
        default_reduction_pct: 0
    };
    state.purpose_notes = 'La taxació NO és vàlida per a fins hipotecaris perquè no s\'utilitza el criteri de valor garantit en el temps, si més no el valor en el dia de la data consignada';
    state.type = {
        bde_code: 'C',
        id: 1,
        name_ca: 'Taxació completa',
        name_en: 'Complete Valuation',
        name_es: 'Tasación Completa'
    };
    state.adopted_area = null;
    state.lift = null;
    state.adopted_age = null;
    state.adopted_age_years_old = null;
    state.property_type = null;
    state.quality_of_neighbourhood = null;
    state.quality_of_situation = null;
    state.quality_of_construction = null;
    state.quality_of_realestate = null;
    state.conservation_status = null;
    state.floor_number = null;
    state.market_value = null;
    state.market_unit_value = null;
    state.bec_price = null;
    state.adjusted_bec_price = null;
    state.bc = null;
    state.bc_pct = null;
    state.gc = null;
    state.gc_pct = null;
    state.bc_and_gc_pct = null;
    state.bc_and_gc = null;
    state.cc = null;
    state.cc_pct = null;
    state.htl = null;
    state.htl_pct = null;
    state.inr = null;
    state.inr_pct = null;
    state.ga = null;
    state.ga_pct = null;
    state.gpd = null;
    state.gpd_pct = null;
    state.oct = null;
    state.oct_pct = null;
    state.gp = null;
    state.gp_pct = null;
    state.cc_and_gp = null;
    state.f = null;
    state.crb = null;
    state.ccd = null;
    state.tlr_pct = null;
    state.pr_pct = null;
    state.am_coef = null;
    state.b1_pct = null;
    state.b2_pct = null;
    state.b_pct = null;
    state.b_remaining_pct = null;
    state.i_pct = null;
    state.tenant_age_years = 35;
    state.tenant_life_expectancy_years = 83;
    state.tenant_remaining_life_expectancy_years = 48;
    state.cession_boolean = null;
    state.cession_gross_monthly_income = null;
    state.cession_gross_yearly_income = null;
    state.cession_net_yearly_income = null;
    state.cession_contract_period_years = null;
    state.cession_contract_remaining_years = null;
    state.cession_contract_start_date = null;
    state.landlord_expenses_pct = 70;
    state.reduction_pct = null;
    state.adjustment_coef = null;
    state.reduction_pct = null;
    state.usufructuary_age_years = null;
    state.useful_life_years = null;
    state.remaining_useful_life_years = null;
    state.max_legal_price = null;
    state.max_legal_area = null;
    state.material_execution_cost = null;
    state.deprecated_material_execution_cost = null;
    state.mec_adjustment_coef = 1;
    state.adopted_material_execution_cost = null;
    state.physical_depreciation_pct = null;
    state.functional_depreciation_pct = null;
    state.total_depreciation_pct = null;
    state.total_construction_progress_pct = 100;
    state.adopted_market_value = null;
    state.adopted_market_unit_value = null;
    state.market_value_appraiser_adjustment_pct = null;
    state.deprecated_land_and_cc = null;
    state.finished_realestate_crn = null;
    state.ccr = null;
    state.executed_construction_cost = null;
    state.under_construction_realestate_crn = null;
    state.k = null;
    state.repercussion_method_land_value = null;
    state.cost_method_construction_crb_value = null;
    state.cost_method_construction_crn_value = null;
    state.cost_method_realestate_crb_value = null;
    state.cost_method_realestate_crn_value = null;
    state.comparison_method = null;
    state.adjusted_market_value = null;
    state.max_legal_method = null;
    state.vc = null;
    state.income_perpetuity_update_method = null;
    state.u = null;
    state.residual_depreciation_pct = null;
    state.residual_depreciation = null;
    state.realestate_residual_value = null;
    state.i = null;
    state.np = null;
    state.coef_1 = null;
    state.current_future_income_value = null;
    state.coef_2 = null;
    state.updated_reversion_value = null;
    state.update_value = null;
    state.insurance_value = null;
    state.vu_coef = null;
    state.usufruct_value = null;
    state.bare_ownership_value = null;
    state.realestate_total_adopted_value = null;
    state.realestate_adopted_appraisal_method = null;
    state.realestate_id = null;
    state.right_of_use_boolean = null;
    state.protection_boolean = null;
    state.protection_type = null;
    state.protection_regime = null;
    state.protection_zone = null;
    state.urban_planning_type = null;
    state.urban_planning_file = null;
    state.urban_planning_council_qualification = null;
    state.urban_planning_council_qualification_description = null;
    state.urban_planning_council_classification = null;
    state.urban_planning_council_classification_description = null;
    state.urban_planning_regional_qualification = null;
    state.urban_planning_regional_qualification_description = null;
    state.urban_planning_regional_classification = null;
    state.urban_planning_regional_classification_description = null;
    state.map_urban_muc_land_colors = null;
    state.map_urban_muc_council_qual = null;
    state.map_urban_icc_topo = null;
    state.land_registry_area = null;
    state.land_cadastral_area = null;
    state.land_checked_area = null;
    state.land_adopted_area = null;
    state.land_infrastructure_paving_execution_pct = 100;
    state.land_infrastructure_sewage_execution_pct = 100;
    state.land_infrastructure_public_lighting_execution_pct = 100;
    state.land_infrastructure_electricity_supply_execution_pct = 100;
    state.land_infrastructure_piped_gas_execution_pct = 100;
    state.land_infrastructure_telephone_service_execution_pct = 100;
    state.land_infrastructure_gardened_areas_execution_pct = 100;
    state.land_infrastructure_total_execution_pct = 100;
    state.land_infrastructure_repercussion_cost = 150;
    state.land_infrastructure_pending_investment = 0;
    state.land_infrastructure_paving = true;
    state.land_infrastructure_sewage = true;
    state.land_infrastructure_public_lighting = true;
    state.land_infrastructure_electricity_supply = true;
    state.land_infrastructure_piped_gas = true;
    state.land_infrastructure_telephone_service = true;
    state.land_infrastructure_gardened_areas = true;
    state.land_is_plot_according_to_law = true;
    state.land_area_notes = null;
    state.land_infrastructure_notes = null;
    state.land_infrastructure_conservation_status = {
        id: 2,
        code_bde: 2,
        name_ca: 'Bona',
        name_en: 'Good',
        name_es: 'Buena'
    };
    state.land_infrastructure_water_supply_execution_pct = 100;
    state.land_infrastructure_water_supply = true;
    state.plot_occupation = null;
    state.plot_free_area_usage = null;
    state.floors_number_underground = null;
    state.floors_number_overground = null;
    state.parking_slots_included_in_appraisal_number = null;
    state.entrance_hall = null;
    state.doorman_space = null;
    state.staircase = null;
    state.swimming_pool = null;
    state.gardened_areas = null;
    state.sports_facilities = null;
    state.community_room = null;
    state.storage_room = null;
    state.community_parking = null;
    state.facilities_others = null;
    state.floors_usage_underground = null;
    state.floors_usage_overground = null;
    state.groundfloor_usage = null;
    state.communications_airport = null;
    state.communications_harbour = null;
    state.communications_train = null;
    state.public_transport_urban_underground = null;
    state.public_transport_interurban = null;
    state.surrounding_facilities_notes = null;
    state.surrounding_territorial_feature = null;
    state.surrounding_income_level = null;
    state.surrounding_homogeneity_feature = null;
    state.surrounding_main_uses = null;
    state.surrounding_density = null;
    state.surrounding_accessibility = null;
    state.surrounding_consolidation_degree = null;
    state.surrounding_occupation_degree = null;
    state.surrounding_evolution_speed = null;
    state.surrounding_average_age = null;
    state.surrounding_conservation_status = null;
    state.surrounding_commercial_facilities = null;
    state.surrounding_educational_facilities = null;
    state.surrounding_public_parking = null;
    state.surrounding_medical_assistance = null;
    state.surrounding_leisure = null;
    state.cadastral_usage = null;
    state.cadastral_floor = null;
    state.cadastral_door = null;
    state.cadastral_block = null;
    state.cadastral_staircase = null;
    state.registry_name = null;
    state.registry_section = null;
    state.registry_volume = null;
    state.registry_book = null;
    state.registry_page = null;
    state.registry_real_estate_number = null;
    state.registry_idufir = null;
    state.registry_owner = null;
    state.registry_property_coef = null;
    state.net_cadastral_area = null;
    state.net_registry_area = null;
    state.net_checked_area = null;
    state.net_adopted_area = null;
    state.enclosed_cadastral_area = null;
    state.enclosed_registry_area = null;
    state.enclosed_checked_area = null;
    state.enclosed_adopted_area = null;
    state.covered_terraces_total_cadastral_area = null;
    state.covered_terraces_total_registry_area = null;
    state.covered_terraces_total_checked_area = null;
    state.covered_terraces_total_adopted_area = null;
    state.uncovered_terraces_total_cadastral_area = null;
    state.uncovered_terraces_total_registry_area = null;
    state.uncovered_terraces_total_checked_area = null;
    state.uncovered_terraces_total_adopted_area = null;
    state.built_cadastral_area = null;
    state.built_registry_area = null;
    state.built_checked_area = null;
    state.built_adopted_area = null;
    state.common_elements_cadastral_area = null;
    state.common_elements_registry_area = null;
    state.common_elements_checked_area = null;
    state.common_elements_adopted_area = null;
    state.built_plus_common_elements_cadastral_area = null;
    state.built_plus_common_elements_registry_area = null;
    state.built_plus_common_elements_checked_area = null;
    state.built_plus_common_elements_adopted_area = null;
    state.bathrooms_number = null;
    state.bedrooms_number = null;
    state.net_selected_area = null;
    state.enclosed_selected_area = null;
    state.covered_outdoors_selected_area = null;
    state.built_selected_areacommon_elements_selected_area = null;
    state.built_plus_common_elements_selected_area = null;
    state.net_selected_area = {
        id: 1,
        name_ca: 'Auto',
        name_en: 'Auto',
        name_es: 'Auto'
    };
    state.enclosed_selected_area = {
        id: 1,
        name_ca: 'Auto',
        name_en: 'Auto',
        name_es: 'Auto'
    };
    state.covered_outdoors_selected_area = {
        id: 1,
        name_ca: 'Auto',
        name_en: 'Auto',
        name_es: 'Auto'
    };
    state.built_selected_area = {
        id: 1,
        name_ca: 'Auto',
        name_en: 'Auto',
        name_es: 'Auto'
    };
    state.common_elements_selected_area = {
        id: 1,
        name_ca: 'Auto',
        name_en: 'Auto',
        name_es: 'Auto'
    };
    state.built_plus_common_elements_selected_area = {
        id: 1,
        name_ca: 'Auto',
        name_en: 'Auto',
        name_es: 'Auto'
    };
    state.land_selected_area = {
        id: 1,
        name_ca: 'Auto',
        name_en: 'Auto',
        name_es: 'Auto'
    };
    state.realestate_rooms_to_exterior_number = null;
    state.realestate_day_night_zoning = null;
    state.realestate_systems_door_opener = null;
    state.realestate_systems_fitted_cupboards = null;
    state.realestate_systems_gas = null;
    state.realestate_systems_sanitary_fittings = null;
    state.realestate_systems_taps = null;
    state.realestate_systems_hot_water = null;
    state.realestate_systems_heating = null;
    state.realestate_systems_air_conditioning = null;
    state.realestate_systems_tv = null;
    state.realestate_systems_telephone = null;
    state.realestate_systems_fire_prevention = null;
    state.realestate_systems_intrusion_prevention = null;
    state.realestate_foundation = null;
    state.realestate_structure = null;
    state.realestate_roof = null;
    state.realestate_external_enclosures = null;
    state.realestate_insulation = null;
    state.realestate_external_carpentry = null;
    state.realestate_glazing = null;
    state.realestate_interior_paving_living = null;
    state.realestate_interior_paving_corridor = null;
    state.realestate_interior_paving_bedroom = null;
    state.realestate_interior_paving_kitchen = null;
    state.realestate_interior_paving_bathroom = null;
    state.realestate_interior_paving_quality = null;
    state.realestate_interior_walls_living = null;
    state.realestate_interior_walls_corridor = null;
    state.realestate_interior_walls_bedroom = null;
    state.realestate_interior_walls_kitchen = null;
    state.realestate_interior_walls_bathroom = null;
    state.realestate_interior_walls_quality = null;
    state.realestate_interior_ceilings_living = null;
    state.realestate_interior_ceilings_corridor = null;
    state.realestate_interior_ceilings_bedroom = null;
    state.realestate_interior_ceilings_kitchen = null;
    state.realestate_interior_ceilings_bathroom = null;
    state.realestate_interior_ceilings_quality = null;
    state.realestate_interior_carpentry_living = null;
    state.realestate_interior_carpentry_corridor = null;
    state.realestate_interior_carpentry_bedroom = null;
    state.realestate_interior_carpentry_kitchen = null;
    state.realestate_interior_carpentry_bathroom = null;
    state.realestate_interior_carpentry_quality = null;
    state.realestate_main_orientation = null;
    state.realestate_main_views = null;
    state.realestate_windows_size_and_quantity = null;
    state.realestate_noise_facade = null;
    state.realestate_systems_sanitary_fittings_quality = null;
    state.realestate_systems_taps_quality = null;
    state.bec_adjustment_coef = 1;
    state.bec_property_type = null;
    state.bec_number = null;
    state.construction_status = {
        id: 1,
        name_ca: 'Acabat',
        name_es: 'Terminado',
        name_en: 'Finished',
        code_bde: 'U00'
    };
    state.expenses_and_industrial_benefit_bec_pct = 20;
    state.construction_cost_notes = null;
    state.cadastral_construction_year = null;
    state.construction_year = null;
    state.last_renovation_year = null;
    state.nucleus_population = null;
    state.nucleus_population_density = null;
    state.nucleus_population_growth = null;
    state.occupation_agriculture_pct = null;
    state.occupation_industry_pct = null;
    state.occupation_construction_pct = null;
    state.occupation_services_pct = null;
    state.occupation_total_pct = null;
    state.nucleus_type = null;
    state.occupation_description = null;
    state.nucleus_area = null;
    state.property_title = null;
    state.usage_assigned = null;
    state.inspection_realized = null;
    state.economical_activity = null;
    state.occupancy_status = null;
    state.marketstudy_id = null;
    state.notes = {
        note_001: {
            name_ca: 'Aquesta taxació s\'ha realitzat d\'acord amb els requisits recollits a l\'Ordre ECO-805-2003 DE 27 DE MARÇ del Ministeri d\'Economia i Hisenda, sobre Valoració de Béns per a determinades entitats financeres, excepte pel que fa al que assenyala l\'apartat condicionants i advertiments generals',
            name_es: 'Esta tasación se ha realizado de acuerdo con los requisitos recogidos en la Orden ECO-805-2003 DE 27 DE MARZO del Ministerio de Economía y Hacienda, sobre Valoración de Bienes para determinadas entidades financieras, excepto en cuanto a lo que señala el apartado condicionantes y advertencias',
            name_en: ''
        },
        note_002: {
            name_ca: 'La present taxació NO és vàlida a efectes de constituir garanties hipotecàries, de provisions de fons de les companyies d\'assegurances i de fons d\'inversió Immobiliàries',
            name_es: 'La presente tasación NO es válida a efectos de constituir garantías hipotecarias, de provisiones de fondos de las compañías de seguros y de fondos de inversión Inmobiliarias',
            name_en: 'This valuation report is NOT valid for the purpose of constituting guarantees for mortgage loans, provision of funds from insurance companies and real estate investment funds'
        },
        note_003: {
            name_ca: 'Aquesta taxació té una validesa de SIS mesos a partir de la data de la seva expedició',
            name_es: 'Esta tasación tiene una validez de SEIS meses a partir de la fecha de su expedición'
        },
        note_004: {
            name_ca: 'Tant BARNA-TASA, S.A. Com els professionals que hem intervingut en l\'elaboració del present informe de taxació, declarem que coneixem i hem tingut en consideració de manera estricta i fidel les incompatibilitats establertes en els articles 6 i 13 del Reial decret 775/1997 de 30 de maig, referents tant a la Societat com als seus professionals i així ho subscrivim',
            name_es: 'Tanto BARNA-TASA, S.A. Como los profesionales que hemos intervenido en la elaboración del presente informe de tasación, declaramos que conocemos y hemos tenido en consideración de manera estricta y fiel las incompatibilidades establecidas en los artículos 6 y 13 del Real Decreto 775/1997 de 30 de mayo, referentes tanto a la Sociedad como a sus profesionales y así lo suscribimos',
            name_en: 'Both BARNA-TASA, S.A. and the professionals who have been involved in the preparation of the valuation report, we declare that we know and have in consideration strictly and faithfully the incompatibilities established in articles 6 and 13 of Royal Decree 775/1997 of 30 May, concerning both the Company and its professionals and thus subscribe them'
        },
        note_005: {
            name_ca: 'El valor de taxació expressat és el que resulta tenint en compte l\'objecte i finalitat de la valoració',
            name_es: 'El valor de tasación expresado es el que resulta teniendo en cuenta el objeto y finalidad de la valoración',
            name_en: 'The appraisal value is expressed considering the scope and purpose of the valuation'
        },
        note_006: {
            name_ca: 'La taxació s\'ha efectuat suposada la finca lliure de càrregues i gravàmens',
            name_es: 'La tasación se ha efectuado supuesta la finca libre de cargas y gravámenes',
            name_en: 'The valuation has been made considering the property is free of charges and liens'
        }
    };
    state.map_urban_muc_land_colors_offset_x = 0;
    state.map_urban_muc_land_colors_offset_y = 0;
    state.map_urban_muc_land_colors_zoom = 1;
    state.map_urban_muc_council_qual_offset_x = 0;
    state.map_urban_muc_council_qual_offset_y = 0;
    state.map_urban_muc_council_qual_zoom = 1;
    state.map_urban_icc_topo_offset_x = 0;
    state.map_urban_icc_topo_offset_y = 0;
    state.map_urban_icc_topo_zoom = 1;

    state.quote_travel_one_way_hours = 0;
    state.quote_travel_both_ways_hours = 0;
    state.quote_travel_fees_per_hour = 20;
    state.quote_car_expenses_one_way = 0;
    state.quote_car_expenses_both_ways = 0;
    state.quote_total_travel_fees = 0;
    state.quote_area_average_unit_price = null;
    state.quote_base_fees = null;
    state.quote_excess_pct = null;
    state.quote_base_price = null;
    state.quote_base_price_coef = 1;
    state.usage_type = null;
    state.parking_spots_included_number = null;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_613" /* SET_APPRAISAL */], function (state, data) {
    state.date_created = check_undefined(data.date_created);
    state.date_modified = check_undefined(data.date_modified);
    state.dirty = false;
    state.id = check_undefined(data.id);
    state.parent_path = check_undefined(data.parent_path);
    state.path = check_undefined(data.path);
    state.appraisaldate = check_undefined(data.appraisaldate);
    state.visitdate = check_undefined(data.visitdate);
    state.technician_visiting = check_undefined(data.technician_visiting);
    state.description = check_undefined(data.description);
    state.purpose = check_undefined(data.purpose);
    state.purpose_notes = check_undefined(data.purpose_notes);
    state.type = check_undefined(data.type);
    state.checks_cadastral_data = check_undefined(data.checks_cadastral_data);
    state.checks_conservation_status = check_undefined(data.checks_conservation_status);
    state.checks_expropriation_procedure = check_undefined(data.checks_expropriation_procedure);
    state.checks_expropriation_plan = check_undefined(data.checks_expropriation_plan);
    state.checks_expropriation_admin_ruling = check_undefined(data.checks_expropriation_admin_ruling);
    state.checks_expropriation_file = check_undefined(data.checks_expropriation_file);
    state.checks_interior_visit = check_undefined(data.checks_interior_visit);
    state.checks_occupancy = check_undefined(data.checks_occupancy);
    state.checks_other = check_undefined(data.checks_other);
    state.checks_registry_data = check_undefined(data.checks_registry_data);
    state.checks_servitudes = check_undefined(data.checks_servitudes);
    state.checks_subsidy_status = check_undefined(data.checks_subsidy_status);
    state.checks_urban_planning = check_undefined(data.checks_urban_planning);
    state.docs_approved_project = check_undefined(data.docs_approved_project);
    state.docs_cadastral_data = check_undefined(data.docs_cadastral_data);
    state.docs_construction_license = check_undefined(data.docs_construction_license);
    state.docs_construction_last_certificate = check_undefined(data.docs_construction_last_certificate);
    state.docs_construction_contract = check_undefined(data.docs_construction_contract);
    state.docs_occupancy_status = check_undefined(data.docs_occupancy_status);
    state.docs_other = check_undefined(data.docs_other);
    state.docs_photographic_report = check_undefined(data.docs_photographic_report);
    state.docs_property_sketch = check_undefined(data.docs_property_sketch);
    state.docs_property_titles = check_undefined(data.docs_property_titles);
    state.docs_situation_plan = check_undefined(data.docs_situation_plan);
    state.docs_subsidy_status = check_undefined(data.docs_subsidy_status);
    state.docs_tenyear_insurance = check_undefined(data.docs_tenyear_insurance);
    state.docs_urban_plan = check_undefined(data.docs_urban_plan);
    state.adopted_area = check_undefined(data.adopted_area);
    state.lift = check_undefined(data.lift);
    state.adopted_age = check_undefined(data.adopted_age);
    state.adopted_age_years_old = check_undefined(data.adopted_age_years_old);
    state.property_type = check_undefined(data.property_type);
    state.quality_of_neighbourhood = check_undefined(data.quality_of_neighbourhood);
    state.quality_of_situation = check_undefined(data.quality_of_situation);
    state.quality_of_construction = check_undefined(data.quality_of_construction);
    state.quality_of_realestate = check_undefined(data.quality_of_realestate);
    state.conservation_status = check_undefined(data.conservation_status);
    state.floor_number = check_undefined(data.floor_number);
    state.market_value = check_undefined(data.market_value);
    state.market_unit_value = check_undefined(data.market_unit_value);
    state.bec_price = check_undefined(data.bec_price);
    state.adjusted_bec_price = check_undefined(data.adjusted_bec_price);
    state.bc = check_undefined(data.bc);
    state.bc_pct = check_undefined(data.bc_pct);
    state.gc = check_undefined(data.gc);
    state.gc_pct = check_undefined(data.gc_pct);
    state.bc_and_gc_pct = check_undefined(data.bc_and_gc_pct);
    state.bc_and_gc = check_undefined(data.bc_and_gc);
    state.cc = check_undefined(data.cc);
    state.cc_pct = check_undefined(data.cc_pct);
    state.htl = check_undefined(data.htl);
    state.htl_pct = check_undefined(data.htl_pct);
    state.inr = check_undefined(data.inr);
    state.inr_pct = check_undefined(data.inr_pct);
    state.ga = check_undefined(data.ga);
    state.ga_pct = check_undefined(data.ga_pct);
    state.gpd = check_undefined(data.gpd);
    state.gpd_pct = check_undefined(data.gpd_pct);
    state.oct = check_undefined(data.oct);
    state.oct_pct = check_undefined(data.oct_pct);
    state.gp = check_undefined(data.gp);
    state.gp_pct = check_undefined(data.gp_pct);
    state.cc_and_gp = check_undefined(data.cc_and_gp);
    state.f = check_undefined(data.f);
    state.crb = check_undefined(data.crb);
    state.ccd = check_undefined(data.ccd);
    state.tlr_pct = check_undefined(data.tlr_pct);
    state.pr_pct = check_undefined(data.pr_pct);
    state.am_coef = check_undefined(data.am_coef);
    state.b1_pct = check_undefined(data.b1_pct);
    state.b2_pct = check_undefined(data.b2_pct);
    state.b_pct = check_undefined(data.b_pct);
    state.b_remaining_pct = check_undefined(data.b_remaining_pct);
    state.i_pct = check_undefined(data.i_pct);
    state.tenant_age_years = check_undefined(data.tenant_age_years);
    state.tenant_life_expectancy_years = check_undefined(data.tenant_life_expectancy_years);
    state.tenant_remaining_life_expectancy_years = check_undefined(data.tenant_remaining_life_expectancy_years);
    state.cession_boolean = check_undefined(data.cession_boolean);
    state.cession_gross_monthly_income = check_undefined(data.cession_gross_monthly_income);
    state.cession_gross_yearly_income = check_undefined(data.cession_gross_yearly_income);
    state.cession_net_yearly_income = check_undefined(data.cession_net_yearly_income);
    state.cession_contract_period_years = check_undefined(data.cession_contract_period_years);
    state.cession_contract_remaining_years = check_undefined(data.cession_contract_remaining_years);
    state.cession_contract_start_date = check_undefined(data.cession_contract_start_date);
    state.landlord_expenses_pct = check_undefined(data.landlord_expenses_pct);
    state.reduction_pct = check_undefined(data.reduction_pct);
    state.adjustment_coef = check_undefined(data.adjustment_coef);
    state.usufructuary_age_years = check_undefined(data.usufructuary_age_years);
    state.useful_life_years = check_undefined(data.useful_life_years);
    state.remaining_useful_life_years = check_undefined(data.remaining_useful_life_years);
    state.max_legal_price = check_undefined(data.max_legal_price);
    state.max_legal_area = check_undefined(data.max_legal_area);
    state.material_execution_cost = check_undefined(data.material_execution_cost);
    state.deprecated_material_execution_cost = check_undefined(data.deprecated_material_execution_cost);
    state.mec_adjustment_coef = check_undefined(data.mec_adjustment_coef);
    state.adopted_material_execution_cost = check_undefined(data.adopted_material_execution_cost);
    state.physical_depreciation_pct = check_undefined(data.physical_depreciation_pct);
    state.functional_depreciation_pct = check_undefined(data.functional_depreciation_pct);
    state.total_depreciation_pct = check_undefined(data.total_depreciation_pct);
    state.total_construction_progress_pct = check_undefined(data.total_construction_progress_pct);
    state.adopted_market_value = check_undefined(data.adopted_market_value);
    state.adopted_market_unit_value = check_undefined(data.adopted_market_unit_value);
    state.market_value_appraiser_adjustment_pct = check_undefined(data.market_value_appraiser_adjustment_pct);
    state.deprecated_land_and_cc = check_undefined(data.deprecated_land_and_cc);
    state.finished_realestate_crn = check_undefined(data.finished_realestate_crn);
    state.ccr = check_undefined(data.ccr);
    state.executed_construction_cost = check_undefined(data.executed_construction_cost);
    state.under_construction_realestate_crn = check_undefined(data.under_construction_realestate_crn);
    state.k = check_undefined(data.k);
    state.repercussion_method_land_value = check_undefined(data.repercussion_method_land_value);
    state.cost_method_construction_crb_value = check_undefined(data.cost_method_construction_crb_value);
    state.cost_method_construction_crn_value = check_undefined(data.cost_method_construction_crn_value);
    state.cost_method_realestate_crb_value = check_undefined(data.cost_method_realestate_crb_value);
    state.cost_method_realestate_crn_value = check_undefined(data.cost_method_realestate_crn_value);
    state.comparison_method = check_undefined(data.comparison_method);
    state.adjusted_market_value = check_undefined(data.adjusted_market_value);
    state.max_legal_method = check_undefined(data.max_legal_method);
    state.vc = check_undefined(data.vc);
    state.income_perpetuity_update_method = check_undefined(data.income_perpetuity_update_method);
    state.u = check_undefined(data.u);
    state.residual_depreciation_pct = check_undefined(data.residual_depreciation_pct);
    state.residual_depreciation = check_undefined(data.residual_depreciation);
    state.realestate_residual_value = check_undefined(data.realestate_residual_value);
    state.i = check_undefined(data.i);
    state.np = check_undefined(data.np);
    state.coef_1 = check_undefined(data.coef_1);
    state.current_future_income_value = check_undefined(data.current_future_income_value);
    state.coef_2 = check_undefined(data.coef_2);
    state.updated_reversion_value = check_undefined(data.updated_reversion_value);
    state.update_value = check_undefined(data.update_value);
    state.insurance_value = check_undefined(data.insurance_value);
    state.vu_coef = check_undefined(data.vu_coef);
    state.usufruct_value = check_undefined(data.usufruct_value);
    state.bare_ownership_value = check_undefined(data.bare_ownership_value);
    state.realestate_total_adopted_value = check_undefined(data.realestate_total_adopted_value);
    state.realestate_adopted_appraisal_method = check_undefined(data.realestate_adopted_appraisal_method);
    state.realestate_id = check_undefined(data.realestate_id);
    state.right_of_use_boolean = check_undefined(data.right_of_use_boolean);
    state.protection_boolean = check_undefined(data.protection_boolean);
    state.protection_type = check_undefined(data.protection_type);
    state.protection_regime = check_undefined(data.protection_regime);
    state.protection_zone = check_undefined(data.protection_zone);
    state.urban_planning_type = check_undefined(data.urban_planning_type);
    state.urban_planning_file = check_undefined(data.urban_planning_file);
    state.urban_planning_council_qualification = check_undefined(data.urban_planning_council_qualification);
    state.urban_planning_council_qualification_description = check_undefined(data.urban_planning_council_qualification_description);
    state.urban_planning_council_classification = check_undefined(data.urban_planning_council_classification);
    state.urban_planning_council_classification_description = check_undefined(data.urban_planning_council_classification_description);
    state.urban_planning_regional_qualification = check_undefined(data.urban_planning_regional_qualification);
    state.urban_planning_regional_qualification_description = check_undefined(data.urban_planning_regional_qualification_description);
    state.urban_planning_regional_classification = check_undefined(data.urban_planning_regional_classification);
    state.urban_planning_regional_classification_description = check_undefined(data.urban_planning_regional_classification_description);
    state.map_urban_muc_land_colors = check_undefined(data.map_urban_muc_land_colors);
    state.map_urban_muc_council_qual = check_undefined(data.map_urban_muc_council_qual);
    state.map_urban_icc_topo = check_undefined(data.map_urban_icc_topo);
    state.land_registry_area = check_undefined(data.land_registry_area);
    state.land_cadastral_area = check_undefined(data.land_cadastral_area);
    state.land_checked_area = check_undefined(data.land_checked_area);
    state.land_adopted_area = check_undefined(data.land_adopted_area);
    state.land_infrastructure_paving_execution_pct = check_undefined(data.land_infrastructure_paving_execution_pct);
    state.land_infrastructure_sewage_execution_pct = check_undefined(data.land_infrastructure_sewage_execution_pct);
    state.land_infrastructure_public_lighting_execution_pct = check_undefined(data.land_infrastructure_public_lighting_execution_pct);
    state.land_infrastructure_electricity_supply_execution_pct = check_undefined(data.land_infrastructure_electricity_supply_execution_pct);
    state.land_infrastructure_piped_gas_execution_pct = check_undefined(data.land_infrastructure_piped_gas_execution_pct);
    state.land_infrastructure_telephone_service_execution_pct = check_undefined(data.land_infrastructure_telephone_service_execution_pct);
    state.land_infrastructure_gardened_areas_execution_pct = check_undefined(data.land_infrastructure_gardened_areas_execution_pct);
    state.land_infrastructure_total_execution_pct = check_undefined(data.land_infrastructure_total_execution_pct);
    state.land_infrastructure_repercussion_cost = check_undefined(data.land_infrastructure_repercussion_cost);
    state.land_infrastructure_pending_investment = check_undefined(data.land_infrastructure_pending_investment);
    state.land_infrastructure_paving = check_undefined(data.land_infrastructure_paving);
    state.land_infrastructure_sewage = check_undefined(data.land_infrastructure_sewage);
    state.land_infrastructure_public_lighting = check_undefined(data.land_infrastructure_public_lighting);
    state.land_infrastructure_electricity_supply = check_undefined(data.land_infrastructure_electricity_supply);
    state.land_infrastructure_piped_gas = check_undefined(data.land_infrastructure_piped_gas);
    state.land_infrastructure_telephone_service = check_undefined(data.land_infrastructure_telephone_service);
    state.land_infrastructure_gardened_areas = check_undefined(data.land_infrastructure_gardened_areas);
    state.land_is_plot_according_to_law = check_undefined(data.land_is_plot_according_to_law);
    state.land_area_notes = check_undefined(data.land_area_notes);
    state.land_infrastructure_notes = check_undefined(data.land_infrastructure_notes);
    state.land_infrastructure_conservation_status = check_undefined(data.land_infrastructure_conservation_status);
    state.land_infrastructure_water_supply_execution_pct = check_undefined(data.land_infrastructure_water_supply_execution_pct);
    state.land_infrastructure_water_supply = check_undefined(data.land_infrastructure_water_supply);
    state.plot_occupation = check_undefined(data.plot_occupation);
    state.plot_free_area_usage = check_undefined(data.plot_free_area_usage);
    state.floors_number_underground = check_undefined(data.floors_number_underground);
    state.floors_number_overground = check_undefined(data.floors_number_overground);
    state.parking_slots_included_in_appraisal_number = check_undefined(data.parking_slots_included_in_appraisal_number);
    state.entrance_hall = check_undefined(data.entrance_hall);
    state.doorman_space = check_undefined(data.doorman_space);
    state.staircase = check_undefined(data.staircase);
    state.swimming_pool = check_undefined(data.swimming_pool);
    state.gardened_areas = check_undefined(data.gardened_areas);
    state.sports_facilities = check_undefined(data.sports_facilities);
    state.community_room = check_undefined(data.community_room);
    state.storage_room = check_undefined(data.storage_room);
    state.community_parking = check_undefined(data.community_parking);
    state.facilities_others = check_undefined(data.facilities_others);
    state.floors_usage_underground = check_undefined(data.floors_usage_underground);
    state.floors_usage_overground = check_undefined(data.floors_usage_overground);
    state.groundfloor_usage = check_undefined(data.groundfloor_usage);
    state.communications_airport = check_undefined(data.communications_airport);
    state.communications_harbour = check_undefined(data.communications_harbour);
    state.communications_train = check_undefined(data.communications_train);
    state.public_transport_urban_underground = check_undefined(data.public_transport_urban_underground);
    state.public_transport_interurban = check_undefined(data.public_transport_interurban);
    state.surrounding_facilities_notes = check_undefined(data.surrounding_facilities_notes);
    state.surrounding_territorial_feature = check_undefined(data.surrounding_territorial_feature);
    state.surrounding_income_level = check_undefined(data.surrounding_income_level);
    state.surrounding_homogeneity_feature = check_undefined(data.surrounding_homogeneity_feature);
    state.surrounding_main_uses = check_undefined(data.surrounding_main_uses);
    state.surrounding_density = check_undefined(data.surrounding_density);
    state.surrounding_accessibility = check_undefined(data.surrounding_accessibility);
    state.surrounding_consolidation_degree = check_undefined(data.surrounding_consolidation_degree);
    state.surrounding_occupation_degree = check_undefined(data.surrounding_occupation_degree);
    state.surrounding_evolution_speed = check_undefined(data.surrounding_evolution_speed);
    state.surrounding_average_age = check_undefined(data.surrounding_average_age);
    state.surrounding_conservation_status = check_undefined(data.surrounding_conservation_status);
    state.surrounding_commercial_facilities = check_undefined(data.surrounding_commercial_facilities);
    state.surrounding_educational_facilities = check_undefined(data.surrounding_educational_facilities);
    state.surrounding_public_parking = check_undefined(data.surrounding_public_parking);
    state.surrounding_medical_assistance = check_undefined(data.surrounding_medical_assistance);
    state.surrounding_leisure = check_undefined(data.surrounding_leisure);
    state.cadastral_usage = check_undefined(data.cadastral_usage);
    state.cadastral_floor = check_undefined(data.cadastral_floor);
    state.cadastral_door = check_undefined(data.cadastral_door);
    state.cadastral_block = check_undefined(data.cadastral_block);
    state.cadastral_staircase = check_undefined(data.cadastral_staircase);
    state.registry_name = check_undefined(data.registry_name);
    state.registry_section = check_undefined(data.registry_section);
    state.registry_volume = check_undefined(data.registry_volume);
    state.registry_book = check_undefined(data.registry_book);
    state.registry_page = check_undefined(data.registry_page);
    state.registry_real_estate_number = check_undefined(data.registry_real_estate_number);
    state.registry_idufir = check_undefined(data.registry_idufir);
    state.registry_owner = check_undefined(data.registry_owner);
    state.registry_property_coef = check_undefined(data.registry_property_coef);
    state.net_cadastral_area = check_undefined(data.net_cadastral_area);
    state.net_registry_area = check_undefined(data.net_registry_area);
    state.net_checked_area = check_undefined(data.net_checked_area);
    state.net_adopted_area = check_undefined(data.net_adopted_area);
    state.enclosed_cadastral_area = check_undefined(data.enclosed_cadastral_area);
    state.enclosed_registry_area = check_undefined(data.enclosed_registry_area);
    state.enclosed_checked_area = check_undefined(data.enclosed_checked_area);
    state.enclosed_adopted_area = check_undefined(data.enclosed_adopted_area);
    state.covered_terraces_total_cadastral_area = check_undefined(data.covered_terraces_total_cadastral_area);
    state.covered_terraces_total_registry_area = check_undefined(data.covered_terraces_total_registry_area);
    state.covered_terraces_total_checked_area = check_undefined(data.covered_terraces_total_checked_area);
    state.covered_terraces_total_adopted_area = check_undefined(data.covered_terraces_total_adopted_area);
    state.uncovered_terraces_total_cadastral_area = check_undefined(data.uncovered_terraces_total_cadastral_area);
    state.uncovered_terraces_total_registry_area = check_undefined(data.uncovered_terraces_total_registry_area);
    state.uncovered_terraces_total_checked_area = check_undefined(data.uncovered_terraces_total_checked_area);
    state.uncovered_terraces_total_adopted_area = check_undefined(data.uncovered_terraces_total_adopted_area);
    state.built_cadastral_area = check_undefined(data.built_cadastral_area);
    state.built_registry_area = check_undefined(data.built_registry_area);
    state.built_checked_area = check_undefined(data.built_checked_area);
    state.built_adopted_area = check_undefined(data.built_adopted_area);
    state.common_elements_cadastral_area = check_undefined(data.common_elements_cadastral_area);
    state.common_elements_registry_area = check_undefined(data.common_elements_registry_area);
    state.common_elements_checked_area = check_undefined(data.common_elements_checked_area);
    state.common_elements_adopted_area = check_undefined(data.common_elements_adopted_area);
    state.built_plus_common_elements_cadastral_area = check_undefined(data.built_plus_common_elements_cadastral_area);
    state.built_plus_common_elements_registry_area = check_undefined(data.built_plus_common_elements_registry_area);
    state.built_plus_common_elements_checked_area = check_undefined(data.built_plus_common_elements_checked_area);
    state.built_plus_common_elements_adopted_area = check_undefined(data.built_plus_common_elements_adopted_area);
    state.bathrooms_number = check_undefined(data.bathrooms_number);
    state.bedrooms_number = check_undefined(data.bedrooms_number);
    state.net_selected_area = check_undefined(data.net_selected_area);
    state.enclosed_selected_area = check_undefined(data.enclosed_selected_area);
    state.covered_outdoors_selected_area = check_undefined(data.covered_outdoors_selected_area);
    state.built_selected_areacommon_elements_selected_area = check_undefined(data.built_selected_areacommon_elements_selected_area);
    state.built_plus_common_elements_selected_area = check_undefined(data.built_plus_common_elements_selected_area);
    state.land_selected_area = check_undefined(data.land_selected_area);
    state.net_selected_area = check_undefined(data.net_selected_area);
    state.enclosed_selected_area = check_undefined(data.enclosed_selected_area);
    state.covered_outdoors_selected_area = check_undefined(data.covered_outdoors_selected_area);
    state.built_selected_area = check_undefined(data.built_selected_area);
    state.common_elements_selected_area = check_undefined(data.common_elements_selected_area);
    state.built_plus_common_elements_selected_area = check_undefined(data.built_plus_common_elements_selected_area);
    state.land_selected_area = check_undefined(data.land_selected_area);
    state.realestate_rooms_to_exterior_number = check_undefined(data.realestate_rooms_to_exterior_number);
    state.realestate_day_night_zoning = check_undefined(data.realestate_day_night_zoning);
    state.realestate_systems_door_opener = check_undefined(data.realestate_systems_door_opener);
    state.realestate_systems_fitted_cupboards = check_undefined(data.realestate_systems_fitted_cupboards);
    state.realestate_systems_gas = check_undefined(data.realestate_systems_gas);
    state.realestate_systems_sanitary_fittings = check_undefined(data.realestate_systems_sanitary_fittings);
    state.realestate_systems_taps = check_undefined(data.realestate_systems_taps);
    state.realestate_systems_hot_water = check_undefined(data.realestate_systems_hot_water);
    state.realestate_systems_heating = check_undefined(data.realestate_systems_heating);
    state.realestate_systems_air_conditioning = check_undefined(data.realestate_systems_air_conditioning);
    state.realestate_systems_tv = check_undefined(data.realestate_systems_tv);
    state.realestate_systems_telephone = check_undefined(data.realestate_systems_telephone);
    state.realestate_systems_fire_prevention = check_undefined(data.realestate_systems_fire_prevention);
    state.realestate_systems_intrusion_prevention = check_undefined(data.realestate_systems_intrusion_prevention);
    state.realestate_foundation = check_undefined(data.realestate_foundation);
    state.realestate_structure = check_undefined(data.realestate_structure);
    state.realestate_roof = check_undefined(data.realestate_roof);
    state.realestate_external_enclosures = check_undefined(data.realestate_external_enclosures);
    state.realestate_insulation = check_undefined(data.realestate_insulation);
    state.realestate_external_carpentry = check_undefined(data.realestate_external_carpentry);
    state.realestate_glazing = check_undefined(data.realestate_glazing);
    state.realestate_interior_paving_living = check_undefined(data.realestate_interior_paving_living);
    state.realestate_interior_paving_corridor = check_undefined(data.realestate_interior_paving_corridor);
    state.realestate_interior_paving_bedroom = check_undefined(data.realestate_interior_paving_bedroom);
    state.realestate_interior_paving_kitchen = check_undefined(data.realestate_interior_paving_kitchen);
    state.realestate_interior_paving_bathroom = check_undefined(data.realestate_interior_paving_bathroom);
    state.realestate_interior_paving_quality = check_undefined(data.realestate_interior_paving_quality);
    state.realestate_interior_walls_living = check_undefined(data.realestate_interior_walls_living);
    state.realestate_interior_walls_corridor = check_undefined(data.realestate_interior_walls_corridor);
    state.realestate_interior_walls_bedroom = check_undefined(data.realestate_interior_walls_bedroom);
    state.realestate_interior_walls_kitchen = check_undefined(data.realestate_interior_walls_kitchen);
    state.realestate_interior_walls_bathroom = check_undefined(data.realestate_interior_walls_bathroom);
    state.realestate_interior_walls_quality = check_undefined(data.realestate_interior_walls_quality);
    state.realestate_interior_ceilings_living = check_undefined(data.realestate_interior_ceilings_living);
    state.realestate_interior_ceilings_corridor = check_undefined(data.realestate_interior_ceilings_corridor);
    state.realestate_interior_ceilings_bedroom = check_undefined(data.realestate_interior_ceilings_bedroom);
    state.realestate_interior_ceilings_kitchen = check_undefined(data.realestate_interior_ceilings_kitchen);
    state.realestate_interior_ceilings_bathroom = check_undefined(data.realestate_interior_ceilings_bathroom);
    state.realestate_interior_ceilings_quality = check_undefined(data.realestate_interior_ceilings_quality);
    state.realestate_interior_carpentry_living = check_undefined(data.realestate_interior_carpentry_living);
    state.realestate_interior_carpentry_corridor = check_undefined(data.realestate_interior_carpentry_corridor);
    state.realestate_interior_carpentry_bedroom = check_undefined(data.realestate_interior_carpentry_bedroom);
    state.realestate_interior_carpentry_kitchen = check_undefined(data.realestate_interior_carpentry_kitchen);
    state.realestate_interior_carpentry_bathroom = check_undefined(data.realestate_interior_carpentry_bathroom);
    state.realestate_interior_carpentry_quality = check_undefined(data.realestate_interior_carpentry_quality);
    state.realestate_main_orientation = check_undefined(data.realestate_main_orientation);
    state.realestate_main_views = check_undefined(data.realestate_main_views);
    state.realestate_windows_size_and_quantity = check_undefined(data.realestate_windows_size_and_quantity);
    state.realestate_noise_facade = check_undefined(data.realestate_noise_facade);
    state.realestate_systems_sanitary_fittings_quality = check_undefined(data.realestate_systems_sanitary_fittings_quality);
    state.realestate_systems_taps_quality = check_undefined(data.realestate_systems_taps_quality);
    state.bec_adjustment_coef = check_undefined(data.bec_adjustment_coef);
    state.bec_property_type = check_undefined(data.bec_property_type);
    state.bec_number = check_undefined(data.bec_number);
    state.construction_status = check_undefined(data.construction_status);
    state.expenses_and_industrial_benefit_bec_pct = check_undefined(data.expenses_and_industrial_benefit_bec_pct);
    state.construction_cost_notes = check_undefined(data.construction_cost_notes);
    state.cadastral_construction_year = check_undefined(data.cadastral_construction_year);
    state.construction_year = check_undefined(data.construction_year);
    state.last_renovation_year = check_undefined(data.last_renovation_year);
    state.nucleus_population = check_undefined(data.nucleus_population);
    state.nucleus_population_density = check_undefined(data.nucleus_population_density);
    state.nucleus_population_growth = check_undefined(data.nucleus_population_growth);
    state.occupation_agriculture_pct = check_undefined(data.occupation_agriculture_pct);
    state.occupation_industry_pct = check_undefined(data.occupation_industry_pct);
    state.occupation_construction_pct = check_undefined(data.occupation_construction_pct);
    state.occupation_services_pct = check_undefined(data.occupation_services_pct);
    state.occupation_total_pct = check_undefined(data.occupation_total_pct);
    state.nucleus_type = check_undefined(data.nucleus_type);
    state.occupation_description = check_undefined(data.occupation_description);
    state.nucleus_area = check_undefined(data.nucleus_area);
    state.property_title = check_undefined(data.property_title);
    state.usage_assigned = check_undefined(data.usage_assigned);
    state.inspection_realized = check_undefined(data.inspection_realized);
    state.economical_activity = check_undefined(data.economical_activity);
    state.occupancy_status = check_undefined(data.occupancy_status);
    state.marketstudy_id = check_undefined(data.marketstudy_id);
    state.map_urban_muc_land_colors_offset_x = check_undefined(data.map_urban_muc_land_colors_offset_x);
    state.map_urban_muc_land_colors_offset_y = check_undefined(data.map_urban_muc_land_colors_offset_y);
    state.map_urban_muc_land_colors_zoom = check_undefined(data.map_urban_muc_land_colors_zoom);
    state.map_urban_muc_council_qual_offset_x = check_undefined(data.map_urban_muc_council_qual_offset_x);
    state.map_urban_muc_council_qual_offset_y = check_undefined(data.map_urban_muc_council_qual_offset_y);
    state.map_urban_muc_council_qual_zoom = check_undefined(data.map_urban_muc_council_qual_zoom);
    state.map_urban_icc_topo_offset_x = check_undefined(data.map_urban_icc_topo_offset_x);
    state.map_urban_icc_topo_offset_y = check_undefined(data.map_urban_icc_topo_offset_y);
    state.map_urban_icc_topo_zoom = check_undefined(data.map_urban_icc_topo_zoom);
    state.quote_travel_one_way_hours = check_undefined(data.quote_travel_one_way_hours);
    state.quote_travel_both_ways_hours = check_undefined(data.quote_travel_both_ways_hours);
    state.quote_travel_fees_per_hour = check_undefined(data.quote_travel_fees_per_hour);
    state.quote_car_expenses_one_way = check_undefined(data.quote_car_expenses_one_way);
    state.quote_car_expenses_both_ways = check_undefined(data.quote_car_expenses_both_ways);
    state.quote_total_travel_fees = check_undefined(data.quote_total_travel_fees);
    state.quote_area_average_unit_price = check_undefined(data.quote_area_average_unit_price);
    state.quote_base_fees = check_undefined(data.quote_base_fees);
    state.quote_excess_pct = check_undefined(data.quote_excess_pct);
    state.quote_base_price = check_undefined(data.quote_base_price);
    state.quote_base_price_coef = check_undefined(data.quote_base_price_coef);
    state.usage_type = check_undefined(data.usage_type);
    state.parking_spots_included_number = check_undefined(data.parking_spots_included_number);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_606" /* SET_APPRAISAL_DATE_CREATED */], function (state, data) {
    state.date_created = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_607" /* SET_APPRAISAL_DATE_MODIFIED */], function (state, data) {
    state.date_modified = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_635" /* SET_APPRAISAL_DIRTYNESS */], function (state, boolean) {
    state.dirty = boolean;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_605" /* SET_APPRAISAL_ID */], function (state, data) {
    state.id = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_609" /* SET_APPRAISAL_PARENT_PATH */], function (state, data) {
    state.parent_path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_610" /* SET_APPRAISAL_PATH */], function (state, data) {
    state.path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_608" /* SET_APPRAISAL_APPRAISALDATE */], function (state, data) {
    state.appraisaldate = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_633" /* SET_APPRAISAL_VISITDATE */], function (state, data) {
    state.visitdate = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_634" /* SET_APPRAISAL_TECHNICIAN_VISITING */], function (state, data) {
    state.technician_visiting = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_662" /* SET_APPRAISAL_DESCRIPTION */], function (state, data) {
    state.description = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_663" /* SET_APPRAISAL_PURPOSE */], function (state, data) {
    state.purpose = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_664" /* SET_APPRAISAL_PURPOSE_NOTES */], function (state, data) {
    state.purpose_notes = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_665" /* SET_APPRAISAL_TYPE */], function (state, data) {
    state.type = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_636" /* SET_APPRAISAL_CHECKS_CADASTRAL_DATA */], function (state, data) {
    state.checks_cadastral_data = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_637" /* SET_APPRAISAL_CHECKS_CONSERVATION_STATUS */], function (state, data) {
    state.checks_conservation_status = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_638" /* SET_APPRAISAL_CHECKS_EXPROPRIATION_PROCEDURE */], function (state, data) {
    state.checks_expropriation_procedure = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_639" /* SET_APPRAISAL_CHECKS_EXPROPRIATION_PLAN */], function (state, data) {
    state.checks_expropriation_plan = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_640" /* SET_APPRAISAL_CHECKS_EXPROPRIATION_ADMIN_RULING */], function (state, data) {
    state.checks_expropriation_admin_ruling = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_641" /* SET_APPRAISAL_CHECKS_EXPROPRIATION_FILE */], function (state, data) {
    state.checks_expropriation_file = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_642" /* SET_APPRAISAL_CHECKS_INTERIOR_VISIT */], function (state, data) {
    state.checks_interior_visit = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_643" /* SET_APPRAISAL_CHECKS_OCCUPANCY */], function (state, data) {
    state.checks_occupancy = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_644" /* SET_APPRAISAL_CHECKS_OTHER */], function (state, data) {
    state.checks_other = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_645" /* SET_APPRAISAL_CHECKS_REGISTRY_DATA */], function (state, data) {
    state.checks_registry_data = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_646" /* SET_APPRAISAL_CHECKS_SERVITUDES */], function (state, data) {
    state.checks_servitudes = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_647" /* SET_APPRAISAL_CHECKS_SUBSIDY_STATUS */], function (state, data) {
    state.checks_subsidy_status = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_648" /* SET_APPRAISAL_CHECKS_URBAN_PLANNING */], function (state, data) {
    state.checks_urban_planning = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_649" /* SET_APPRAISAL_DOCS_APPROVED_PROJECT */], function (state, data) {
    state.docs_approved_project = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_650" /* SET_APPRAISAL_DOCS_CADASTRAL_DATA */], function (state, data) {
    state.docs_cadastral_data = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_651" /* SET_APPRAISAL_DOCS_CONSTRUCTION_LICENSE */], function (state, data) {
    state.docs_construction_license = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_652" /* SET_APPRAISAL_DOCS_CONSTRUCTION_LAST_CERTIFICATE */], function (state, data) {
    state.docs_construction_last_certificate = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_653" /* SET_APPRAISAL_DOCS_CONSTRUCTION_CONTRACT */], function (state, data) {
    state.docs_construction_contract = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_654" /* SET_APPRAISAL_DOCS_OCCUPANCY_STATUS */], function (state, data) {
    state.docs_occupancy_status = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_991" /* SET_APPRAISAL_DOCS_OTHER */], function (state, data) {
    state.docs_other = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_655" /* SET_APPRAISAL_DOCS_PHOTOGRAPHIC_REPORT */], function (state, data) {
    state.docs_photographic_report = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_656" /* SET_APPRAISAL_DOCS_PROPERTY_SKETCH */], function (state, data) {
    state.docs_property_sketch = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_657" /* SET_APPRAISAL_DOCS_PROPERTY_TITLES */], function (state, data) {
    state.docs_property_titles = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_658" /* SET_APPRAISAL_DOCS_SITUATION_PLAN */], function (state, data) {
    state.docs_situation_plan = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_659" /* SET_APPRAISAL_DOCS_SUBSIDY_STATUS */], function (state, data) {
    state.docs_subsidy_status = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_660" /* SET_APPRAISAL_DOCS_TENYEAR_INSURANCE */], function (state, data) {
    state.docs_tenyear_insurance = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_661" /* SET_APPRAISAL_DOCS_URBAN_PLAN */], function (state, data) {
    state.docs_urban_plan = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_666" /* SET_APPRAISAL_ADOPTED_AREA */], function (state, data) {
    state.adopted_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_667" /* SET_APPRAISAL_LIFT */], function (state, data) {
    state.lift = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_668" /* SET_APPRAISAL_ADOPTED_AGE */], function (state, data) {
    state.adopted_age = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_669" /* SET_APPRAISAL_ADOPTED_AGE_YEARS_OLD */], function (state, data) {
    state.adopted_age_years_old = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_670" /* SET_APPRAISAL_PROPERTY_TYPE */], function (state, data) {
    state.property_type = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_671" /* SET_APPRAISAL_QUALITY_OF_NEIGHBOURHOOD */], function (state, data) {
    state.quality_of_neighbourhood = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_672" /* SET_APPRAISAL_QUALITY_OF_SITUATION */], function (state, data) {
    state.quality_of_situation = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_673" /* SET_APPRAISAL_QUALITY_OF_CONSTRUCTION */], function (state, data) {
    state.quality_of_construction = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_674" /* SET_APPRAISAL_QUALITY_OF_REALESTATE */], function (state, data) {
    state.quality_of_realestate = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_675" /* SET_APPRAISAL_CONSERVATION_STATUS */], function (state, data) {
    state.conservation_status = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_676" /* SET_APPRAISAL_FLOOR_NUMBER */], function (state, data) {
    state.floor_number = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_677" /* SET_APPRAISAL_MARKET_VALUE */], function (state, data) {
    state.market_value = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_678" /* SET_APPRAISAL_MARKET_UNIT_VALUE */], function (state, data) {
    state.market_unit_value = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_679" /* SET_APPRAISAL_BEC_PRICE */], function (state, data) {
    state.bec_price = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_680" /* SET_APPRAISAL_ADJUSTED_BEC_PRICE */], function (state, data) {
    state.adjusted_bec_price = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_681" /* SET_APPRAISAL_BC */], function (state, data) {
    state.bc = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_682" /* SET_APPRAISAL_BC_PCT */], function (state, data) {
    state.bc_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_683" /* SET_APPRAISAL_GC */], function (state, data) {
    state.gc = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_684" /* SET_APPRAISAL_GC_PCT */], function (state, data) {
    state.gc_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_685" /* SET_APPRAISAL_BC_AND_GC_PCT */], function (state, data) {
    state.bc_and_gc_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_686" /* SET_APPRAISAL_BC_AND_GC */], function (state, data) {
    state.bc_and_gc = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_687" /* SET_APPRAISAL_CC */], function (state, data) {
    state.cc = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_688" /* SET_APPRAISAL_CC_PCT */], function (state, data) {
    state.cc_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_689" /* SET_APPRAISAL_HTL */], function (state, data) {
    state.htl = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_690" /* SET_APPRAISAL_HTL_PCT */], function (state, data) {
    state.htl_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_691" /* SET_APPRAISAL_INR */], function (state, data) {
    state.inr = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_692" /* SET_APPRAISAL_INR_PCT */], function (state, data) {
    state.inr_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_693" /* SET_APPRAISAL_GA */], function (state, data) {
    state.ga = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_694" /* SET_APPRAISAL_GA_PCT */], function (state, data) {
    state.ga_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_695" /* SET_APPRAISAL_GPD */], function (state, data) {
    state.gpd = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_696" /* SET_APPRAISAL_GPD_PCT */], function (state, data) {
    state.gpd_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_697" /* SET_APPRAISAL_OCT */], function (state, data) {
    state.oct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_698" /* SET_APPRAISAL_OCT_PCT */], function (state, data) {
    state.oct_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_699" /* SET_APPRAISAL_GP */], function (state, data) {
    state.gp = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_700" /* SET_APPRAISAL_GP_PCT */], function (state, data) {
    state.gp_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_701" /* SET_APPRAISAL_CC_AND_GP */], function (state, data) {
    state.cc_and_gp = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_702" /* SET_APPRAISAL_F */], function (state, data) {
    state.f = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_703" /* SET_APPRAISAL_CRB */], function (state, data) {
    state.crb = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_704" /* SET_APPRAISAL_CCD */], function (state, data) {
    state.ccd = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_705" /* SET_APPRAISAL_TLR_PCT */], function (state, data) {
    state.tlr_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_706" /* SET_APPRAISAL_PR_PCT */], function (state, data) {
    state.pr_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_707" /* SET_APPRAISAL_AM_COEF */], function (state, data) {
    state.am_coef = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_708" /* SET_APPRAISAL_B1_PCT */], function (state, data) {
    state.b1_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_709" /* SET_APPRAISAL_B2_PCT */], function (state, data) {
    state.b2_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_710" /* SET_APPRAISAL_B_PCT */], function (state, data) {
    state.b_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_711" /* SET_APPRAISAL_B_REMAINING_PCT */], function (state, data) {
    state.b_remaining_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_712" /* SET_APPRAISAL_I_PCT */], function (state, data) {
    state.i_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_713" /* SET_APPRAISAL_TENANT_AGE_YEARS */], function (state, data) {
    state.tenant_age_years = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_714" /* SET_APPRAISAL_TENANT_LIFE_EXPECTANCY_YEARS */], function (state, data) {
    state.tenant_life_expectancy_years = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_715" /* SET_APPRAISAL_TENANT_REMAINING_LIFE_EXPECTANCY_YEARS */], function (state, data) {
    state.tenant_remaining_life_expectancy_years = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_716" /* SET_APPRAISAL_CESSION_BOOLEAN */], function (state, data) {
    state.cession_boolean = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_717" /* SET_APPRAISAL_CESSION_GROSS_MONTHLY_INCOME */], function (state, data) {
    state.cession_gross_monthly_income = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_718" /* SET_APPRAISAL_CESSION_GROSS_YEARLY_INCOME */], function (state, data) {
    state.cession_gross_yearly_income = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_719" /* SET_APPRAISAL_CESSION_NET_YEARLY_INCOME */], function (state, data) {
    state.cession_net_yearly_income = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_720" /* SET_APPRAISAL_CESSION_CONTRACT_PERIOD_YEARS */], function (state, data) {
    state.cession_contract_period_years = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_721" /* SET_APPRAISAL_CESSION_CONTRACT_REMAINING_YEARS */], function (state, data) {
    state.cession_contract_remaining_years = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_722" /* SET_APPRAISAL_CESSION_CONTRACT_START_DATE */], function (state, data) {
    state.cession_contract_start_date = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_723" /* SET_APPRAISAL_LANDLORD_EXPENSES_PCT */], function (state, data) {
    state.landlord_expenses_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_724" /* SET_APPRAISAL_REDUCTION_PCT */], function (state, data) {
    state.reduction_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_725" /* SET_APPRAISAL_ADJUSTMENT_COEF */], function (state, data) {
    state.adjustment_coef = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_726" /* SET_APPRAISAL_USUFRUCTUARY_AGE_YEARS */], function (state, data) {
    state.usufructuary_age_years = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_727" /* SET_APPRAISAL_USEFUL_LIFE_YEARS */], function (state, data) {
    state.useful_life_years = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_728" /* SET_APPRAISAL_REMAINING_USEFUL_LIFE_YEARS */], function (state, data) {
    state.remaining_useful_life_years = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_729" /* SET_APPRAISAL_MAX_LEGAL_PRICE */], function (state, data) {
    state.max_legal_price = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_730" /* SET_APPRAISAL_MAX_LEGAL_AREA */], function (state, data) {
    state.max_legal_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_731" /* SET_APPRAISAL_MATERIAL_EXECUTION_COST */], function (state, data) {
    state.material_execution_cost = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_732" /* SET_APPRAISAL_DEPRECATED_MATERIAL_EXECUTION_COST */], function (state, data) {
    state.deprecated_material_execution_cost = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_733" /* SET_APPRAISAL_MEC_ADJUSTMENT_COEF */], function (state, data) {
    state.mec_adjustment_coef = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_734" /* SET_APPRAISAL_ADOPTED_MATERIAL_EXECUTION_COST */], function (state, data) {
    state.adopted_material_execution_cost = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_735" /* SET_APPRAISAL_PHYSICAL_DEPRECIATION_PCT */], function (state, data) {
    state.physical_depreciation_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_736" /* SET_APPRAISAL_FUNCTIONAL_DEPRECIATION_PCT */], function (state, data) {
    state.functional_depreciation_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_737" /* SET_APPRAISAL_TOTAL_DEPRECIATION_PCT */], function (state, data) {
    state.total_depreciation_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_738" /* SET_APPRAISAL_TOTAL_CONSTRUCTION_PROGRESS_PCT */], function (state, data) {
    state.total_construction_progress_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_739" /* SET_APPRAISAL_ADOPTED_MARKET_VALUE */], function (state, data) {
    state.adopted_market_value = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_740" /* SET_APPRAISAL_ADOPTED_MARKET_UNIT_VALUE */], function (state, data) {
    state.adopted_market_unit_value = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_741" /* SET_APPRAISAL_MARKET_VALUE_APPRAISER_ADJUSTMENT_PCT */], function (state, data) {
    state.market_value_appraiser_adjustment_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_742" /* SET_APPRAISAL_DEPRECATED_LAND_AND_CC */], function (state, data) {
    state.deprecated_land_and_cc = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_743" /* SET_APPRAISAL_FINISHED_REALESTATE_CRN */], function (state, data) {
    state.finished_realestate_crn = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_744" /* SET_APPRAISAL_CCR */], function (state, data) {
    state.ccr = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_745" /* SET_APPRAISAL_EXECUTED_CONSTRUCTION_COST */], function (state, data) {
    state.executed_construction_cost = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_746" /* SET_APPRAISAL_UNDER_CONSTRUCTION_REALESTATE_CRN */], function (state, data) {
    state.under_construction_realestate_crn = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_747" /* SET_APPRAISAL_K */], function (state, data) {
    state.k = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_748" /* SET_APPRAISAL_REPERCUSSION_METHOD_LAND_VALUE */], function (state, data) {
    state.repercussion_method_land_value = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_749" /* SET_APPRAISAL_COST_METHOD_CONSTRUCTION_CRB_VALUE */], function (state, data) {
    state.cost_method_construction_crb_value = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_750" /* SET_APPRAISAL_COST_METHOD_CONSTRUCTION_CRN_VALUE */], function (state, data) {
    state.cost_method_construction_crn_value = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_751" /* SET_APPRAISAL_COST_METHOD_REALESTATE_CRB_VALUE */], function (state, data) {
    state.cost_method_realestate_crb_value = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_752" /* SET_APPRAISAL_COST_METHOD_REALESTATE_CRN_VALUE */], function (state, data) {
    state.cost_method_realestate_crn_value = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_753" /* SET_APPRAISAL_COMPARISON_METHOD */], function (state, data) {
    state.comparison_method = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_754" /* SET_APPRAISAL_ADJUSTED_MARKET_VALUE */], function (state, data) {
    state.adjusted_market_value = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_755" /* SET_APPRAISAL_MAX_LEGAL_METHOD */], function (state, data) {
    state.max_legal_method = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_756" /* SET_APPRAISAL_VC */], function (state, data) {
    state.vc = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_757" /* SET_APPRAISAL_INCOME_PERPETUITY_UPDATE_METHOD */], function (state, data) {
    state.income_perpetuity_update_method = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_758" /* SET_APPRAISAL_U */], function (state, data) {
    state.u = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_759" /* SET_APPRAISAL_RESIDUAL_DEPRECIATION_PCT */], function (state, data) {
    state.residual_depreciation_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_760" /* SET_APPRAISAL_RESIDUAL_DEPRECIATION */], function (state, data) {
    state.residual_depreciation = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_761" /* SET_APPRAISAL_REALESTATE_RESIDUAL_VALUE */], function (state, data) {
    state.realestate_residual_value = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_762" /* SET_APPRAISAL_I */], function (state, data) {
    state.i = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_763" /* SET_APPRAISAL_NP */], function (state, data) {
    state.np = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_764" /* SET_APPRAISAL_COEF_1 */], function (state, data) {
    state.coef_1 = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_765" /* SET_APPRAISAL_CURRENT_FUTURE_INCOME_VALUE */], function (state, data) {
    state.current_future_income_value = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_766" /* SET_APPRAISAL_COEF_2 */], function (state, data) {
    state.coef_2 = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_767" /* SET_APPRAISAL_UPDATED_REVERSION_VALUE */], function (state, data) {
    state.updated_reversion_value = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_768" /* SET_APPRAISAL_UPDATE_VALUE */], function (state, data) {
    state.update_value = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_769" /* SET_APPRAISAL_INSURANCE_VALUE */], function (state, data) {
    state.insurance_value = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_770" /* SET_APPRAISAL_VU_COEF */], function (state, data) {
    state.vu_coef = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_771" /* SET_APPRAISAL_USUFRUCT_VALUE */], function (state, data) {
    state.usufruct_value = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_772" /* SET_APPRAISAL_BARE_OWNERSHIP_VALUE */], function (state, data) {
    state.bare_ownership_value = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_773" /* SET_APPRAISAL_REALESTATE_TOTAL_ADOPTED_VALUE */], function (state, data) {
    state.realestate_total_adopted_value = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_774" /* SET_APPRAISAL_REALESTATE_ADOPTED_APPRAISAL_METHOD */], function (state, data) {
    state.realestate_adopted_appraisal_method = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_611" /* SET_APPRAISAL_REALESTATE_ID */], function (state, data) {
    state.realestate_id = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_775" /* SET_APPRAISAL_RIGHT_OF_USE_BOOLEAN */], function (state, data) {
    state.right_of_use_boolean = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_776" /* SET_APPRAISAL_PROTECTION_BOOLEAN */], function (state, data) {
    state.protection_boolean = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_777" /* SET_APPRAISAL_PROTECTION_TYPE */], function (state, data) {
    state.protection_type = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_778" /* SET_APPRAISAL_PROTECTION_REGIME */], function (state, data) {
    state.protection_regime = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_779" /* SET_APPRAISAL_PROTECTION_ZONE */], function (state, data) {
    state.protection_zone = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_620" /* SET_APPRAISAL_URBAN_PLANNING_TYPE */], function (state, data) {
    state.urban_planning_type = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_621" /* SET_APPRAISAL_URBAN_PLANNING_FILE */], function (state, data) {
    state.urban_planning_file = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_622" /* SET_APPRAISAL_URBAN_PLANNING_COUNCIL_QUALIFICATION */], function (state, data) {
    state.urban_planning_council_qualification = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_623" /* SET_APPRAISAL_URBAN_PLANNING_COUNCIL_QUALIFICATION_DESCRIPTION */], function (state, data) {
    state.urban_planning_council_qualification_description = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_624" /* SET_APPRAISAL_URBAN_PLANNING_COUNCIL_CLASSIFICATION */], function (state, data) {
    state.urban_planning_council_classification = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_625" /* SET_APPRAISAL_URBAN_PLANNING_COUNCIL_CLASSIFICATION_DESCRIPTION */], function (state, data) {
    state.urban_planning_council_classification_description = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_626" /* SET_APPRAISAL_URBAN_PLANNING_REGIONAL_QUALIFICATION */], function (state, data) {
    state.urban_planning_regional_qualification = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_627" /* SET_APPRAISAL_URBAN_PLANNING_REGIONAL_QUALIFICATION_DESCRIPTION */], function (state, data) {
    state.urban_planning_regional_qualification_description = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_628" /* SET_APPRAISAL_URBAN_PLANNING_REGIONAL_CLASSIFICATION */], function (state, data) {
    state.urban_planning_regional_classification = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_629" /* SET_APPRAISAL_URBAN_PLANNING_REGIONAL_CLASSIFICATION_DESCRIPTION */], function (state, data) {
    state.urban_planning_regional_classification_description = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_630" /* SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS */], function (state, data) {
    state.map_urban_muc_land_colors = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_631" /* SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL */], function (state, data) {
    state.map_urban_muc_council_qual = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_632" /* SET_APPRAISAL_MAP_URBAN_ICC_TOPO */], function (state, data) {
    state.map_urban_icc_topo = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_780" /* SET_APPRAISAL_LAND_REGISTRY_AREA */], function (state, data) {
    state.land_registry_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_781" /* SET_APPRAISAL_LAND_CADASTRAL_AREA */], function (state, data) {
    state.land_cadastral_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_782" /* SET_APPRAISAL_LAND_CHECKED_AREA */], function (state, data) {
    state.land_checked_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_783" /* SET_APPRAISAL_LAND_ADOPTED_AREA */], function (state, data) {
    state.land_adopted_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_784" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_PAVING_EXECUTION_PCT */], function (state, data) {
    state.land_infrastructure_paving_execution_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_785" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_SEWAGE_EXECUTION_PCT */], function (state, data) {
    state.land_infrastructure_sewage_execution_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_786" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_PUBLIC_LIGHTING_EXECUTION_PCT */], function (state, data) {
    state.land_infrastructure_public_lighting_execution_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_787" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_ELECTRICITY_SUPPLY_EXECUTION_PCT */], function (state, data) {
    state.land_infrastructure_electricity_supply_execution_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_788" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_PIPED_GAS_EXECUTION_PCT */], function (state, data) {
    state.land_infrastructure_piped_gas_execution_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_789" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_TELEPHONE_SERVICE_EXECUTION_PCT */], function (state, data) {
    state.land_infrastructure_telephone_service_execution_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_790" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_GARDENED_AREAS_EXECUTION_PCT */], function (state, data) {
    state.land_infrastructure_gardened_areas_execution_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_791" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_TOTAL_EXECUTION_PCT */], function (state, data) {
    state.land_infrastructure_total_execution_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_792" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_REPERCUSSION_COST */], function (state, data) {
    state.land_infrastructure_repercussion_cost = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_793" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_PENDING_INVESTMENT */], function (state, data) {
    state.land_infrastructure_pending_investment = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_794" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_PAVING */], function (state, data) {
    state.land_infrastructure_paving = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_795" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_SEWAGE */], function (state, data) {
    state.land_infrastructure_sewage = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_796" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_PUBLIC_LIGHTING */], function (state, data) {
    state.land_infrastructure_public_lighting = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_797" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_ELECTRICITY_SUPPLY */], function (state, data) {
    state.land_infrastructure_electricity_supply = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_798" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_PIPED_GAS */], function (state, data) {
    state.land_infrastructure_piped_gas = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_799" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_TELEPHONE_SERVICE */], function (state, data) {
    state.land_infrastructure_telephone_service = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_800" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_GARDENED_AREAS */], function (state, data) {
    state.land_infrastructure_gardened_areas = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_801" /* SET_APPRAISAL_LAND_IS_PLOT_ACCORDING_TO_LAW */], function (state, data) {
    state.land_is_plot_according_to_law = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_802" /* SET_APPRAISAL_LAND_AREA_NOTES */], function (state, data) {
    state.land_area_notes = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_803" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_NOTES */], function (state, data) {
    state.land_infrastructure_notes = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_804" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_CONSERVATION_STATUS */], function (state, data) {
    state.land_infrastructure_conservation_status = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_805" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_WATER_SUPPLY_EXECUTION_PCT */], function (state, data) {
    state.land_infrastructure_water_supply_execution_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_806" /* SET_APPRAISAL_LAND_INFRASTRUCTURE_WATER_SUPPLY */], function (state, data) {
    state.land_infrastructure_water_supply = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_807" /* SET_APPRAISAL_PLOT_OCCUPATION */], function (state, data) {
    state.plot_occupation = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_808" /* SET_APPRAISAL_PLOT_FREE_AREA_USAGE */], function (state, data) {
    state.plot_free_area_usage = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_809" /* SET_APPRAISAL_FLOORS_NUMBER_UNDERGROUND */], function (state, data) {
    state.floors_number_underground = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_810" /* SET_APPRAISAL_FLOORS_NUMBER_OVERGROUND */], function (state, data) {
    state.floors_number_overground = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_811" /* SET_APPRAISAL_PARKING_SLOTS_INCLUDED_IN_APPRAISAL_NUMBER */], function (state, data) {
    state.parking_slots_included_in_appraisal_number = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_812" /* SET_APPRAISAL_ENTRANCE_HALL */], function (state, data) {
    state.entrance_hall = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_813" /* SET_APPRAISAL_DOORMAN_SPACE */], function (state, data) {
    state.doorman_space = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_814" /* SET_APPRAISAL_STAIRCASE */], function (state, data) {
    state.staircase = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_815" /* SET_APPRAISAL_SWIMMING_POOL */], function (state, data) {
    state.swimming_pool = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_816" /* SET_APPRAISAL_GARDENED_AREAS */], function (state, data) {
    state.gardened_areas = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_817" /* SET_APPRAISAL_SPORTS_FACILITIES */], function (state, data) {
    state.sports_facilities = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_818" /* SET_APPRAISAL_COMMUNITY_ROOM */], function (state, data) {
    state.community_room = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_819" /* SET_APPRAISAL_STORAGE_ROOM */], function (state, data) {
    state.storage_room = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_820" /* SET_APPRAISAL_COMMUNITY_PARKING */], function (state, data) {
    state.community_parking = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_821" /* SET_APPRAISAL_FACILITIES_OTHERS */], function (state, data) {
    state.facilities_others = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_822" /* SET_APPRAISAL_FLOORS_USAGE_UNDERGROUND */], function (state, data) {
    state.floors_usage_underground = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_823" /* SET_APPRAISAL_FLOORS_USAGE_OVERGROUND */], function (state, data) {
    state.floors_usage_overground = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_824" /* SET_APPRAISAL_GROUNDFLOOR_USAGE */], function (state, data) {
    state.groundfloor_usage = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_825" /* SET_APPRAISAL_COMMUNICATIONS_AIRPORT */], function (state, data) {
    state.communications_airport = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_826" /* SET_APPRAISAL_COMMUNICATIONS_HARBOUR */], function (state, data) {
    state.communications_harbour = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_827" /* SET_APPRAISAL_COMMUNICATIONS_TRAIN */], function (state, data) {
    state.communications_train = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_828" /* SET_APPRAISAL_PUBLIC_TRANSPORT_URBAN_UNDERGROUND */], function (state, data) {
    state.public_transport_urban_underground = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_829" /* SET_APPRAISAL_PUBLIC_TRANSPORT_INTERURBAN */], function (state, data) {
    state.public_transport_interurban = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_830" /* SET_APPRAISAL_SURROUNDING_FACILITIES_NOTES */], function (state, data) {
    state.surrounding_facilities_notes = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_831" /* SET_APPRAISAL_SURROUNDING_TERRITORIAL_FEATURE */], function (state, data) {
    state.surrounding_territorial_feature = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_832" /* SET_APPRAISAL_SURROUNDING_INCOME_LEVEL */], function (state, data) {
    state.surrounding_income_level = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_833" /* SET_APPRAISAL_SURROUNDING_HOMOGENEITY_FEATURE */], function (state, data) {
    state.surrounding_homogeneity_feature = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_834" /* SET_APPRAISAL_SURROUNDING_MAIN_USES */], function (state, data) {
    state.surrounding_main_uses = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_835" /* SET_APPRAISAL_SURROUNDING_DENSITY */], function (state, data) {
    state.surrounding_density = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_836" /* SET_APPRAISAL_SURROUNDING_ACCESSIBILITY */], function (state, data) {
    state.surrounding_accessibility = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_837" /* SET_APPRAISAL_SURROUNDING_CONSOLIDATION_DEGREE */], function (state, data) {
    state.surrounding_consolidation_degree = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_838" /* SET_APPRAISAL_SURROUNDING_OCCUPATION_DEGREE */], function (state, data) {
    state.surrounding_occupation_degree = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_839" /* SET_APPRAISAL_SURROUNDING_EVOLUTION_SPEED */], function (state, data) {
    state.surrounding_evolution_speed = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_840" /* SET_APPRAISAL_SURROUNDING_AVERAGE_AGE */], function (state, data) {
    state.surrounding_average_age = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_841" /* SET_APPRAISAL_SURROUNDING_CONSERVATION_STATUS */], function (state, data) {
    state.surrounding_conservation_status = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_842" /* SET_APPRAISAL_SURROUNDING_COMMERCIAL_FACILITIES */], function (state, data) {
    state.surrounding_commercial_facilities = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_843" /* SET_APPRAISAL_SURROUNDING_EDUCATIONAL_FACILITIES */], function (state, data) {
    state.surrounding_educational_facilities = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_844" /* SET_APPRAISAL_SURROUNDING_PUBLIC_PARKING */], function (state, data) {
    state.surrounding_public_parking = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_845" /* SET_APPRAISAL_SURROUNDING_MEDICAL_ASSISTANCE */], function (state, data) {
    state.surrounding_medical_assistance = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_846" /* SET_APPRAISAL_SURROUNDING_LEISURE */], function (state, data) {
    state.surrounding_leisure = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_847" /* SET_APPRAISAL_CADASTRAL_USAGE */], function (state, data) {
    state.cadastral_usage = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_848" /* SET_APPRAISAL_CADASTRAL_FLOOR */], function (state, data) {
    state.cadastral_floor = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_849" /* SET_APPRAISAL_CADASTRAL_DOOR */], function (state, data) {
    state.cadastral_door = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_850" /* SET_APPRAISAL_CADASTRAL_BLOCK */], function (state, data) {
    state.cadastral_block = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_851" /* SET_APPRAISAL_CADASTRAL_STAIRCASE */], function (state, data) {
    state.cadastral_staircase = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_852" /* SET_APPRAISAL_REGISTRY_NAME */], function (state, data) {
    state.registry_name = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_853" /* SET_APPRAISAL_REGISTRY_SECTION */], function (state, data) {
    state.registry_section = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_854" /* SET_APPRAISAL_REGISTRY_VOLUME */], function (state, data) {
    state.registry_volume = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_855" /* SET_APPRAISAL_REGISTRY_BOOK */], function (state, data) {
    state.registry_book = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_856" /* SET_APPRAISAL_REGISTRY_PAGE */], function (state, data) {
    state.registry_page = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_857" /* SET_APPRAISAL_REGISTRY_REAL_ESTATE_NUMBER */], function (state, data) {
    state.registry_real_estate_number = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_858" /* SET_APPRAISAL_REGISTRY_IDUFIR */], function (state, data) {
    state.registry_idufir = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_859" /* SET_APPRAISAL_REGISTRY_OWNER */], function (state, data) {
    state.registry_owner = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_860" /* SET_APPRAISAL_REGISTRY_PROPERTY_COEF */], function (state, data) {
    state.registry_property_coef = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_861" /* SET_APPRAISAL_NET_CADASTRAL_AREA */], function (state, data) {
    state.net_cadastral_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_862" /* SET_APPRAISAL_NET_REGISTRY_AREA */], function (state, data) {
    state.net_registry_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_863" /* SET_APPRAISAL_NET_CHECKED_AREA */], function (state, data) {
    state.net_checked_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_864" /* SET_APPRAISAL_NET_ADOPTED_AREA */], function (state, data) {
    state.net_adopted_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_865" /* SET_APPRAISAL_ENCLOSED_CADASTRAL_AREA */], function (state, data) {
    state.enclosed_cadastral_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_866" /* SET_APPRAISAL_ENCLOSED_REGISTRY_AREA */], function (state, data) {
    state.enclosed_registry_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_867" /* SET_APPRAISAL_ENCLOSED_CHECKED_AREA */], function (state, data) {
    state.enclosed_checked_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_868" /* SET_APPRAISAL_ENCLOSED_ADOPTED_AREA */], function (state, data) {
    state.enclosed_adopted_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_869" /* SET_APPRAISAL_COVERED_TERRACES_TOTAL_CADASTRAL_AREA */], function (state, data) {
    state.covered_terraces_total_cadastral_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_870" /* SET_APPRAISAL_COVERED_TERRACES_TOTAL_REGISTRY_AREA */], function (state, data) {
    state.covered_terraces_total_registry_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_871" /* SET_APPRAISAL_COVERED_TERRACES_TOTAL_CHECKED_AREA */], function (state, data) {
    state.covered_terraces_total_checked_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_872" /* SET_APPRAISAL_COVERED_TERRACES_TOTAL_ADOPTED_AREA */], function (state, data) {
    state.covered_terraces_total_adopted_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_873" /* SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_CADASTRAL_AREA */], function (state, data) {
    state.uncovered_terraces_total_cadastral_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_874" /* SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_REGISTRY_AREA */], function (state, data) {
    state.uncovered_terraces_total_registry_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_875" /* SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_CHECKED_AREA */], function (state, data) {
    state.uncovered_terraces_total_checked_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_876" /* SET_APPRAISAL_UNCOVERED_TERRACES_TOTAL_ADOPTED_AREA */], function (state, data) {
    state.uncovered_terraces_total_adopted_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_877" /* SET_APPRAISAL_BUILT_CADASTRAL_AREA */], function (state, data) {
    state.built_cadastral_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_878" /* SET_APPRAISAL_BUILT_REGISTRY_AREA */], function (state, data) {
    state.built_registry_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_879" /* SET_APPRAISAL_BUILT_CHECKED_AREA */], function (state, data) {
    state.built_checked_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_880" /* SET_APPRAISAL_BUILT_ADOPTED_AREA */], function (state, data) {
    state.built_adopted_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_881" /* SET_APPRAISAL_COMMON_ELEMENTS_CADASTRAL_AREA */], function (state, data) {
    state.common_elements_cadastral_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_882" /* SET_APPRAISAL_COMMON_ELEMENTS_REGISTRY_AREA */], function (state, data) {
    state.common_elements_registry_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_883" /* SET_APPRAISAL_COMMON_ELEMENTS_CHECKED_AREA */], function (state, data) {
    state.common_elements_checked_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_884" /* SET_APPRAISAL_COMMON_ELEMENTS_ADOPTED_AREA */], function (state, data) {
    state.common_elements_adopted_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_885" /* SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_CADASTRAL_AREA */], function (state, data) {
    state.built_plus_common_elements_cadastral_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_886" /* SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_REGISTRY_AREA */], function (state, data) {
    state.built_plus_common_elements_registry_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_887" /* SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_CHECKED_AREA */], function (state, data) {
    state.built_plus_common_elements_checked_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_888" /* SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_ADOPTED_AREA */], function (state, data) {
    state.built_plus_common_elements_adopted_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_889" /* SET_APPRAISAL_BATHROOMS_NUMBER */], function (state, data) {
    state.bathrooms_number = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_890" /* SET_APPRAISAL_BEDROOMS_NUMBER */], function (state, data) {
    state.bedrooms_number = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_891" /* SET_APPRAISAL_NET_SELECTED_AREA */], function (state, data) {
    state.net_selected_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_892" /* SET_APPRAISAL_ENCLOSED_SELECTED_AREA */], function (state, data) {
    state.enclosed_selected_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_893" /* SET_APPRAISAL_COVERED_OUTDOORS_SELECTED_AREA */], function (state, data) {
    state.covered_outdoors_selected_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_894" /* SET_APPRAISAL_BUILT_SELECTED_AREA */], function (state, data) {
    state.built_selected_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_895" /* SET_APPRAISAL_COMMON_ELEMENTS_SELECTED_AREA */], function (state, data) {
    state.common_elements_selected_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_896" /* SET_APPRAISAL_BUILT_PLUS_COMMON_ELEMENTS_SELECTED_AREA */], function (state, data) {
    state.built_plus_common_elements_selected_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_897" /* SET_APPRAISAL_LAND_SELECTED_AREA */], function (state, data) {
    state.land_selected_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_898" /* SET_APPRAISAL_REALESTATE_ROOMS_TO_EXTERIOR_NUMBER */], function (state, data) {
    state.realestate_rooms_to_exterior_number = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_899" /* SET_APPRAISAL_REALESTATE_DAY_NIGHT_ZONING */], function (state, data) {
    state.realestate_day_night_zoning = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_900" /* SET_APPRAISAL_REALESTATE_SYSTEMS_DOOR_OPENER */], function (state, data) {
    state.realestate_systems_door_opener = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_901" /* SET_APPRAISAL_REALESTATE_SYSTEMS_FITTED_CUPBOARDS */], function (state, data) {
    state.realestate_systems_fitted_cupboards = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_902" /* SET_APPRAISAL_REALESTATE_SYSTEMS_GAS */], function (state, data) {
    state.realestate_systems_gas = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_903" /* SET_APPRAISAL_REALESTATE_SYSTEMS_SANITARY_FITTINGS */], function (state, data) {
    state.realestate_systems_sanitary_fittings = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_904" /* SET_APPRAISAL_REALESTATE_SYSTEMS_TAPS */], function (state, data) {
    state.realestate_systems_taps = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_905" /* SET_APPRAISAL_REALESTATE_SYSTEMS_HOT_WATER */], function (state, data) {
    state.realestate_systems_hot_water = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_906" /* SET_APPRAISAL_REALESTATE_SYSTEMS_HEATING */], function (state, data) {
    state.realestate_systems_heating = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_907" /* SET_APPRAISAL_REALESTATE_SYSTEMS_AIR_CONDITIONING */], function (state, data) {
    state.realestate_systems_air_conditioning = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_908" /* SET_APPRAISAL_REALESTATE_SYSTEMS_TV */], function (state, data) {
    state.realestate_systems_tv = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_909" /* SET_APPRAISAL_REALESTATE_SYSTEMS_TELEPHONE */], function (state, data) {
    state.realestate_systems_telephone = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_910" /* SET_APPRAISAL_REALESTATE_SYSTEMS_FIRE_PREVENTION */], function (state, data) {
    state.realestate_systems_fire_prevention = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_911" /* SET_APPRAISAL_REALESTATE_SYSTEMS_INTRUSION_PREVENTION */], function (state, data) {
    state.realestate_systems_intrusion_prevention = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_912" /* SET_APPRAISAL_REALESTATE_FOUNDATION */], function (state, data) {
    state.realestate_foundation = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_913" /* SET_APPRAISAL_REALESTATE_STRUCTURE */], function (state, data) {
    state.realestate_structure = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_914" /* SET_APPRAISAL_REALESTATE_ROOF */], function (state, data) {
    state.realestate_roof = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_915" /* SET_APPRAISAL_REALESTATE_EXTERNAL_ENCLOSURES */], function (state, data) {
    state.realestate_external_enclosures = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_916" /* SET_APPRAISAL_REALESTATE_INSULATION */], function (state, data) {
    state.realestate_insulation = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_917" /* SET_APPRAISAL_REALESTATE_EXTERNAL_CARPENTRY */], function (state, data) {
    state.realestate_external_carpentry = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_918" /* SET_APPRAISAL_REALESTATE_GLAZING */], function (state, data) {
    state.realestate_glazing = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_919" /* SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_LIVING */], function (state, data) {
    state.realestate_interior_paving_living = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_920" /* SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_CORRIDOR */], function (state, data) {
    state.realestate_interior_paving_corridor = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_921" /* SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_BEDROOM */], function (state, data) {
    state.realestate_interior_paving_bedroom = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_922" /* SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_KITCHEN */], function (state, data) {
    state.realestate_interior_paving_kitchen = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_923" /* SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_BATHROOM */], function (state, data) {
    state.realestate_interior_paving_bathroom = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_924" /* SET_APPRAISAL_REALESTATE_INTERIOR_PAVING_QUALITY */], function (state, data) {
    state.realestate_interior_paving_quality = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_925" /* SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_LIVING */], function (state, data) {
    state.realestate_interior_walls_living = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_926" /* SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_CORRIDOR */], function (state, data) {
    state.realestate_interior_walls_corridor = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_927" /* SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_BEDROOM */], function (state, data) {
    state.realestate_interior_walls_bedroom = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_928" /* SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_KITCHEN */], function (state, data) {
    state.realestate_interior_walls_kitchen = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_929" /* SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_BATHROOM */], function (state, data) {
    state.realestate_interior_walls_bathroom = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_930" /* SET_APPRAISAL_REALESTATE_INTERIOR_WALLS_QUALITY */], function (state, data) {
    state.realestate_interior_walls_quality = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_931" /* SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_LIVING */], function (state, data) {
    state.realestate_interior_ceilings_living = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_932" /* SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_CORRIDOR */], function (state, data) {
    state.realestate_interior_ceilings_corridor = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_933" /* SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_BEDROOM */], function (state, data) {
    state.realestate_interior_ceilings_bedroom = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_934" /* SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_KITCHEN */], function (state, data) {
    state.realestate_interior_ceilings_kitchen = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_935" /* SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_BATHROOM */], function (state, data) {
    state.realestate_interior_ceilings_bathroom = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_936" /* SET_APPRAISAL_REALESTATE_INTERIOR_CEILINGS_QUALITY */], function (state, data) {
    state.realestate_interior_ceilings_quality = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_937" /* SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_LIVING */], function (state, data) {
    state.realestate_interior_carpentry_living = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_938" /* SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_CORRIDOR */], function (state, data) {
    state.realestate_interior_carpentry_corridor = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_939" /* SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_BEDROOM */], function (state, data) {
    state.realestate_interior_carpentry_bedroom = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_940" /* SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_KITCHEN */], function (state, data) {
    state.realestate_interior_carpentry_kitchen = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_941" /* SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_BATHROOM */], function (state, data) {
    state.realestate_interior_carpentry_bathroom = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_942" /* SET_APPRAISAL_REALESTATE_INTERIOR_CARPENTRY_QUALITY */], function (state, data) {
    state.realestate_interior_carpentry_quality = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_943" /* SET_APPRAISAL_REALESTATE_MAIN_ORIENTATION */], function (state, data) {
    state.realestate_main_orientation = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_944" /* SET_APPRAISAL_REALESTATE_MAIN_VIEWS */], function (state, data) {
    state.realestate_main_views = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_945" /* SET_APPRAISAL_REALESTATE_WINDOWS_SIZE_AND_QUANTITY */], function (state, data) {
    state.realestate_windows_size_and_quantity = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_946" /* SET_APPRAISAL_REALESTATE_NOISE_FACADE */], function (state, data) {
    state.realestate_noise_facade = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_947" /* SET_APPRAISAL_REALESTATE_SYSTEMS_SANITARY_FITTINGS_QUALITY */], function (state, data) {
    state.realestate_systems_sanitary_fittings_quality = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_948" /* SET_APPRAISAL_REALESTATE_SYSTEMS_TAPS_QUALITY */], function (state, data) {
    state.realestate_systems_taps_quality = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_949" /* SET_APPRAISAL_BEC_ADJUSTMENT_COEF */], function (state, data) {
    state.bec_adjustment_coef = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_950" /* SET_APPRAISAL_BEC_PROPERTY_TYPE */], function (state, data) {
    state.bec_property_type = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_951" /* SET_APPRAISAL_BEC_NUMBER */], function (state, data) {
    state.bec_number = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_952" /* SET_APPRAISAL_CONSTRUCTION_STATUS */], function (state, data) {
    state.construction_status = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_953" /* SET_APPRAISAL_EXPENSES_AND_INDUSTRIAL_BENEFIT_BEC_PCT */], function (state, data) {
    state.expenses_and_industrial_benefit_bec_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_954" /* SET_APPRAISAL_CONSTRUCTION_COST_NOTES */], function (state, data) {
    state.construction_cost_notes = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_955" /* SET_APPRAISAL_CADASTRAL_CONSTRUCTION_YEAR */], function (state, data) {
    state.cadastral_construction_year = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_956" /* SET_APPRAISAL_CONSTRUCTION_YEAR */], function (state, data) {
    state.construction_year = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_957" /* SET_APPRAISAL_LAST_RENOVATION_YEAR */], function (state, data) {
    state.last_renovation_year = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_614" /* SET_APPRAISAL_NUCLEUS_POPULATION */], function (state, data) {
    state.nucleus_population = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_616" /* SET_APPRAISAL_NUCLEUS_POPULATION_DENSITY */], function (state, data) {
    state.nucleus_population_density = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_617" /* SET_APPRAISAL_NUCLEUS_POPULATION_GROWTH */], function (state, data) {
    state.nucleus_population_growth = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_958" /* SET_APPRAISAL_OCCUPATION_AGRICULTURE_PCT */], function (state, data) {
    state.occupation_agriculture_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_959" /* SET_APPRAISAL_OCCUPATION_INDUSTRY_PCT */], function (state, data) {
    state.occupation_industry_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_960" /* SET_APPRAISAL_OCCUPATION_CONSTRUCTION_PCT */], function (state, data) {
    state.occupation_construction_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_961" /* SET_APPRAISAL_OCCUPATION_SERVICES_PCT */], function (state, data) {
    state.occupation_services_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_962" /* SET_APPRAISAL_OCCUPATION_TOTAL_PCT */], function (state, data) {
    state.occupation_total_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_618" /* SET_APPRAISAL_NUCLEUS_TYPE */], function (state, data) {
    state.nucleus_type = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_619" /* SET_APPRAISAL_OCCUPATION_DESCRIPTION */], function (state, data) {
    state.occupation_description = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_615" /* SET_APPRAISAL_NUCLEUS_AREA */], function (state, data) {
    state.nucleus_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_963" /* SET_APPRAISAL_PROPERTY_TITLE */], function (state, data) {
    state.property_title = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_964" /* SET_APPRAISAL_USAGE_ASSIGNED */], function (state, data) {
    state.usage_assigned = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_965" /* SET_APPRAISAL_INSPECTION_REALIZED */], function (state, data) {
    state.inspection_realized = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_966" /* SET_APPRAISAL_ECONOMICAL_ACTIVITY */], function (state, data) {
    state.economical_activity = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_967" /* SET_APPRAISAL_OCCUPANCY_STATUS */], function (state, data) {
    state.occupancy_status = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_968" /* SET_APPRAISAL_MARKETSTUDY_ID */], function (state, data) {
    state.marketstudy_id = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_969" /* SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_OFFSET_X */], function (state, data) {
    state.map_urban_muc_land_colors_offset_x = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_970" /* SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_OFFSET_Y */], function (state, data) {
    state.map_urban_muc_land_colors_offset_y = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_971" /* SET_APPRAISAL_MAP_URBAN_MUC_LAND_COLORS_ZOOM */], function (state, data) {
    state.map_urban_muc_land_colors_zoom = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_972" /* SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_OFFSET_X */], function (state, data) {
    state.map_urban_muc_council_qual_offset_x = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_973" /* SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_OFFSET_Y */], function (state, data) {
    state.map_urban_muc_council_qual_offset_y = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_974" /* SET_APPRAISAL_MAP_URBAN_MUC_COUNCIL_QUAL_ZOOM */], function (state, data) {
    state.map_urban_muc_council_qual_zoom = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_975" /* SET_APPRAISAL_MAP_URBAN_ICC_TOPO_OFFSET_X */], function (state, data) {
    state.map_urban_icc_topo_offset_x = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_976" /* SET_APPRAISAL_MAP_URBAN_ICC_TOPO_OFFSET_Y */], function (state, data) {
    state.map_urban_icc_topo_offset_y = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_977" /* SET_APPRAISAL_MAP_URBAN_ICC_TOPO_ZOOM */], function (state, data) {
    state.map_urban_icc_topo_zoom = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_978" /* SET_APPRAISAL_QUOTE_TRAVEL_ONE_WAY_HOURS */], function (state, data) {
    state.quote_travel_one_way_hours = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_979" /* SET_APPRAISAL_QUOTE_TRAVEL_BOTH_WAYS_HOURS */], function (state, data) {
    state.quote_travel_both_ways_hours = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_980" /* SET_APPRAISAL_QUOTE_TRAVEL_FEES_PER_HOUR */], function (state, data) {
    state.quote_travel_fees_per_hour = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_981" /* SET_APPRAISAL_QUOTE_CAR_EXPENSES_ONE_WAY */], function (state, data) {
    state.quote_car_expenses_one_way = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_982" /* SET_APPRAISAL_QUOTE_CAR_EXPENSES_BOTH_WAYS */], function (state, data) {
    state.quote_car_expenses_both_ways = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_983" /* SET_APPRAISAL_QUOTE_TOTAL_TRAVEL_FEES */], function (state, data) {
    state.quote_total_travel_fees = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_984" /* SET_APPRAISAL_QUOTE_AREA_AVERAGE_UNIT_PRICE */], function (state, data) {
    state.quote_area_average_unit_price = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_985" /* SET_APPRAISAL_QUOTE_BASE_FEES */], function (state, data) {
    state.quote_base_fees = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_986" /* SET_APPRAISAL_QUOTE_EXCESS_PCT */], function (state, data) {
    state.quote_excess_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_987" /* SET_APPRAISAL_QUOTE_BASE_PRICE */], function (state, data) {
    state.quote_base_price = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_988" /* SET_APPRAISAL_QUOTE_BASE_PRICE_COEF */], function (state, data) {
    state.quote_base_price_coef = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_989" /* SET_APPRAISAL_USAGE_TYPE */], function (state, data) {
    state.usage_type = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_990" /* SET_APPRAISAL_PARKING_SPOTS_INCLUDED_NUMBER */], function (state, data) {
    state.parking_spots_included_number = data;
    state.dirty = true;
}), _mutations);

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

function roundToTwo(num) {
    return +(Math.round(num + 'e+2') + 'e-2');
}

var getters = {

    appraisal: function appraisal(state) {
        return state;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    bec_prices: {}
};
var state = default_state;

var actions = {
    FETCH_APPRAISAL_BEC_PRICES: function FETCH_APPRAISAL_BEC_PRICES(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        // console.log('data.path (fetch_appraisal_bec_prices) ---->')
        // console.log(data.path)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_604" /* SET_APPRAISAL_BEC_PRICES */], res);
        });
    },
    SET_APPRAISAL_BEC_PRICES: function SET_APPRAISAL_BEC_PRICES(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_604" /* SET_APPRAISAL_BEC_PRICES */], data);
    },
    UPDATE_APPRAISAL_BEC_PRICES: function UPDATE_APPRAISAL_BEC_PRICES(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;

        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                value: data.object,
                path: 'becproperty_becprices' + '/' + data.becproperty_id + '/' + data.becprice_id + '/',
                save_timestamp: false
            }).then(function (res) {
                resolve();
            });
        });
    }
};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__constants__["_604" /* SET_APPRAISAL_BEC_PRICES */], function (state, data) {
    state.bec_prices = check_undefined(data);
});

var getters = {
    appraisal_bec_prices: function appraisal_bec_prices(state) {
        return state.bec_prices;
    }
};

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    bec_properties: {}
};
var state = default_state;

var actions = {
    FETCH_APPRAISAL_BEC_PROPERTIES: function FETCH_APPRAISAL_BEC_PROPERTIES(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        // console.log('data.path (fetch_appraisal_bec_properties) ---->')
        // console.log(data.path)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_603" /* SET_APPRAISAL_BEC_PROPERTIES */], res);
        });
    },
    SET_APPRAISAL_BEC_PROPERTIES: function SET_APPRAISAL_BEC_PROPERTIES(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_603" /* SET_APPRAISAL_BEC_PROPERTIES */], data);
    },
    UPDATE_APPRAISAL_BEC_PROPERTIES: function UPDATE_APPRAISAL_BEC_PROPERTIES(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;

        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                value: data.object,
                path: 'becproperties' + '/' + data.becproperty_id + '/',
                save_timestamp: false
            }).then(function (res) {
                resolve();
            });
        });
    }
};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__constants__["_603" /* SET_APPRAISAL_BEC_PROPERTIES */], function (state, data) {
    state.bec_properties = check_undefined(data);
});

var getters = {
    appraisal_bec_properties: function appraisal_bec_properties(state) {
        return state.bec_properties;
    }
};

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    cadasterannexes: {}
};
var state = default_state;

var actions = {
    FETCH_APPRAISAL_CADASTERANNEXES: function FETCH_APPRAISAL_CADASTERANNEXES(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        // console.log('data.path (fetch_appraisal_cadasterannexes) ---->')
        // console.log(data.path)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_594" /* SET_APPRAISAL_CADASTERANNEXES */], res);
        });
    },
    SET_APPRAISAL_CADASTERANNEXES: function SET_APPRAISAL_CADASTERANNEXES(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_594" /* SET_APPRAISAL_CADASTERANNEXES */], data);
    },
    UPLOAD_CADASTERANNEX_FILES: function UPLOAD_CADASTERANNEX_FILES(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;

        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].uploadImages(data).then(function () {
                resolve();
            });
        });
    },
    UPDATE_APPRAISAL_CADASTERANNEXES: function UPDATE_APPRAISAL_CADASTERANNEXES(_ref4, data) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;

        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                value: data.object,
                path: 'appraisal_cadasterannexes' + '/' + data.appraisal_id + '/',
                save_timestamp: false
            }).then(function (res) {
                resolve();
            });
        });
    }
};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__constants__["_594" /* SET_APPRAISAL_CADASTERANNEXES */], function (state, data) {
    state.cadasterannexes = check_undefined(data);
});

var getters = {
    appraisal_cadasterannexes: function appraisal_cadasterannexes(state) {
        return state.cadasterannexes;
    }
};

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    cessionannexes: {}
};
var state = default_state;

var actions = {
    FETCH_APPRAISAL_CESSIONANNEXES: function FETCH_APPRAISAL_CESSIONANNEXES(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        // console.log('data.path (fetch_appraisal_cessionannexes) ---->')
        // console.log(data.path)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_591" /* SET_APPRAISAL_CESSIONANNEXES */], res);
        });
    },
    SET_APPRAISAL_CESSIONANNEXES: function SET_APPRAISAL_CESSIONANNEXES(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_591" /* SET_APPRAISAL_CESSIONANNEXES */], data);
    },
    UPLOAD_CESSIONANNEX_FILES: function UPLOAD_CESSIONANNEX_FILES(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;

        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].uploadImages(data).then(function () {
                resolve();
            });
        });
    },
    UPDATE_APPRAISAL_CESSIONANNEXES: function UPDATE_APPRAISAL_CESSIONANNEXES(_ref4, data) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;

        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                value: data.object,
                path: 'appraisal_cessionannexes' + '/' + data.appraisal_id + '/',
                save_timestamp: false
            }).then(function (res) {
                resolve();
            });
        });
    }
};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__constants__["_591" /* SET_APPRAISAL_CESSIONANNEXES */], function (state, data) {
    state.cessionannexes = check_undefined(data);
});

var getters = {
    appraisal_cessionannexes: function appraisal_cessionannexes(state) {
        return state.cessionannexes;
    }
};

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    constraints: {}
};
var state = default_state;

var actions = {
    FETCH_APPRAISAL_CONSTRAINTS: function FETCH_APPRAISAL_CONSTRAINTS(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        // console.log('data.path (fetch_appraisal_constraints) ---->')
        // console.log(data.path)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_599" /* SET_APPRAISAL_CONSTRAINTS */], res);
        });
    },
    SET_APPRAISAL_CONSTRAINTS: function SET_APPRAISAL_CONSTRAINTS(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_599" /* SET_APPRAISAL_CONSTRAINTS */], data);
    },
    UPDATE_APPRAISAL_CONSTRAINTS: function UPDATE_APPRAISAL_CONSTRAINTS(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;

        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                value: data.object,
                path: 'appraisal_constraints' + '/' + data.appraisal_id + '/',
                save_timestamp: false
            }).then(function (res) {
                resolve();
            });
        });
    }
};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__constants__["_599" /* SET_APPRAISAL_CONSTRAINTS */], function (state, data) {
    state.constraints = check_undefined(data);
});

var getters = {
    appraisal_constraints: function appraisal_constraints(state) {
        return state.constraints;
    }
};

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    covered_outdoors: {}
};
var state = default_state;

var actions = {
    FETCH_APPRAISAL_COVERED_OUTDOORS: function FETCH_APPRAISAL_COVERED_OUTDOORS(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        // console.log('data.path (fetch_appraisal_covered_outdoors) ---->')
        // console.log(data.path)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_601" /* SET_APPRAISAL_COVERED_OUTDOORS */], res);
        });
    },
    SET_APPRAISAL_COVERED_OUTDOORS: function SET_APPRAISAL_COVERED_OUTDOORS(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_601" /* SET_APPRAISAL_COVERED_OUTDOORS */], data);
    },
    UPDATE_APPRAISAL_COVERED_OUTDOORS: function UPDATE_APPRAISAL_COVERED_OUTDOORS(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;

        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                value: data.object,
                path: 'appraisal_covered_outdoors' + '/' + data.appraisal_id + '/',
                save_timestamp: false
            }).then(function (res) {
                resolve();
            });
        });
    }
};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__constants__["_601" /* SET_APPRAISAL_COVERED_OUTDOORS */], function (state, data) {
    state.covered_outdoors = check_undefined(data);
});

var getters = {
    appraisal_covered_outdoors: function appraisal_covered_outdoors(state) {
        return state.covered_outdoors;
    }
};

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    notes: {
        note_001: {
            name_ca: 'Aquesta taxació s\'ha realitzat d\'acord amb els requisits recollits a l\'Ordre ECO-805-2003 DE 27 DE MARÇ del Ministeri d\'Economia i Hisenda, sobre Valoració de Béns per a determinades entitats financeres, excepte pel que fa al que assenyala l\'apartat condicionants i advertiments generals',
            name_es: 'Esta tasación se ha realizado de acuerdo con los requisitos recogidos en la Orden ECO-805-2003 DE 27 DE MARZO del Ministerio de Economía y Hacienda, sobre Valoración de Bienes para determinadas entidades financieras, excepto en cuanto a lo que señala el apartado condicionantes y advertencias',
            name_en: ''
        },
        note_002: {
            name_ca: 'La present taxació NO és vàlida a efectes de constituir garanties hipotecàries, de provisions de fons de les companyies d\'assegurances i de fons d\'inversió Immobiliàries',
            name_es: 'La presente tasación NO es válida a efectos de constituir garantías hipotecarias, de provisiones de fondos de las compañías de seguros y de fondos de inversión Inmobiliarias',
            name_en: 'This valuation report is NOT valid for the purpose of constituting guarantees for mortgage loans, provision of funds from insurance companies and real estate investment funds'
        },
        note_003: {
            name_ca: 'Aquesta taxació té una validesa de SIS mesos a partir de la data de la seva expedició',
            name_es: 'Esta tasación tiene una validez de SEIS meses a partir de la fecha de su expedición'
        },
        note_004: {
            name_ca: 'Tant BARNA-TASA, S.A. Com els professionals que hem intervingut en l\'elaboració del present informe de taxació, declarem que coneixem i hem tingut en consideració de manera estricta i fidel les incompatibilitats establertes en els articles 6 i 13 del Reial decret 775/1997 de 30 de maig, referents tant a la Societat com als seus professionals i així ho subscrivim',
            name_es: 'Tanto BARNA-TASA, S.A. Como los profesionales que hemos intervenido en la elaboración del presente informe de tasación, declaramos que conocemos y hemos tenido en consideración de manera estricta y fiel las incompatibilidades establecidas en los artículos 6 y 13 del Real Decreto 775/1997 de 30 de mayo, referentes tanto a la Sociedad como a sus profesionales y así lo suscribimos',
            name_en: 'Both BARNA-Charges, S.A. and the professionals who have been involved in the preparation of the valuation report, we declare that we know and have in consideration strictly and faithfully the incompatibilities established in articles 6 and 13 of Royal Decree 775/1997 of 30 May, concerning both the Company and its professionals and thus subscribe them'
        },
        note_005: {
            name_ca: 'El valor de taxació expressat és el que resulta tenint en compte l\'objecte i finalitat de la valoració',
            name_es: 'El valor de tasación expresado es el que resulta teniendo en cuenta el objeto y finalidad de la valoración',
            name_en: 'The appraisal value is expressed considering the scope and purpose of the valuation'
        },
        note_006: {
            name_ca: 'La taxació s\'ha efectuat suposada la finca lliure de càrregues i gravàmens',
            name_es: 'La tasación se ha efectuado supuesta la finca libre de cargas y gravámenes',
            name_en: 'The valuation has been made considering the property is free of charges and liens'
        }
    }
};
var state = default_state;

var actions = {
    FETCH_APPRAISAL_NOTES: function FETCH_APPRAISAL_NOTES(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        // console.log('data.path (fetch_appraisal_notes) ---->')
        // console.log(data.path)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_597" /* SET_APPRAISAL_NOTES */], res);
        });
    },
    SET_APPRAISAL_NOTES: function SET_APPRAISAL_NOTES(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_597" /* SET_APPRAISAL_NOTES */], data);
    },
    UPDATE_APPRAISAL_NOTES: function UPDATE_APPRAISAL_NOTES(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;

        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                value: data.object,
                path: 'appraisal_notes' + '/' + data.appraisal_id + '/',
                save_timestamp: false
            }).then(function (res) {
                resolve();
            });
        });
    }
};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__constants__["_597" /* SET_APPRAISAL_NOTES */], function (state, data) {
    state.notes = check_undefined(data);
});

var getters = {
    appraisal_notes: function appraisal_notes(state) {
        return state.notes;
    }
};

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    otherannexes: {}
};
var state = default_state;

var actions = {
    FETCH_APPRAISAL_OTHERANNEXES: function FETCH_APPRAISAL_OTHERANNEXES(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        // console.log('data.path (fetch_appraisal_otherannexes) ---->')
        // console.log(data.path)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_590" /* SET_APPRAISAL_OTHERANNEXES */], res);
        });
    },
    SET_APPRAISAL_OTHERANNEXES: function SET_APPRAISAL_OTHERANNEXES(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_590" /* SET_APPRAISAL_OTHERANNEXES */], data);
    },
    UPLOAD_OTHERANNEX_FILES: function UPLOAD_OTHERANNEX_FILES(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;

        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].uploadImages(data).then(function () {
                resolve();
            });
        });
    },
    UPDATE_APPRAISAL_OTHERANNEXES: function UPDATE_APPRAISAL_OTHERANNEXES(_ref4, data) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;

        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                value: data.object,
                path: 'appraisal_otherannexes' + '/' + data.appraisal_id + '/',
                save_timestamp: false
            }).then(function (res) {
                resolve();
            });
        });
    }
};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__constants__["_590" /* SET_APPRAISAL_OTHERANNEXES */], function (state, data) {
    state.otherannexes = check_undefined(data);
});

var getters = {
    appraisal_otherannexes: function appraisal_otherannexes(state) {
        return state.otherannexes;
    }
};

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    photographs: {}
};
var state = default_state;

var actions = {
    FETCH_APPRAISAL_PHOTOGRAPHS: function FETCH_APPRAISAL_PHOTOGRAPHS(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        // console.log('data.path (fetch_appraisal_photographs) ---->')
        // console.log(data.path)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_596" /* SET_APPRAISAL_PHOTOGRAPHS */], res);
        });
    },
    SET_APPRAISAL_PHOTOGRAPHS: function SET_APPRAISAL_PHOTOGRAPHS(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_596" /* SET_APPRAISAL_PHOTOGRAPHS */], data);
    },
    UPLOAD_PHOTOGRAPH_FILES: function UPLOAD_PHOTOGRAPH_FILES(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;

        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].uploadImages(data).then(function () {
                resolve();
            });
        });
    },
    UPDATE_APPRAISAL_PHOTOGRAPHS: function UPDATE_APPRAISAL_PHOTOGRAPHS(_ref4, data) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;

        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                value: data.object,
                path: 'appraisal_photographs' + '/' + data.appraisal_id + '/',
                save_timestamp: false
            }).then(function (res) {
                resolve();
            });
        });
    }
};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__constants__["_596" /* SET_APPRAISAL_PHOTOGRAPHS */], function (state, data) {
    state.photographs = check_undefined(data);
});

var getters = {
    appraisal_photographs: function appraisal_photographs(state) {
        return state.photographs;
    }
};

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    planannexes: {}
};
var state = default_state;

var actions = {
    FETCH_APPRAISAL_PLANANNEXES: function FETCH_APPRAISAL_PLANANNEXES(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        // console.log('data.path (fetch_appraisal_planannexes) ---->')
        // console.log(data.path)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_592" /* SET_APPRAISAL_PLANANNEXES */], res);
        });
    },
    SET_APPRAISAL_PLANANNEXES: function SET_APPRAISAL_PLANANNEXES(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_592" /* SET_APPRAISAL_PLANANNEXES */], data);
    },
    UPLOAD_PLANANNEX_FILES: function UPLOAD_PLANANNEX_FILES(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;

        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].uploadImages(data).then(function () {
                resolve();
            });
        });
    },
    UPDATE_APPRAISAL_PLANANNEXES: function UPDATE_APPRAISAL_PLANANNEXES(_ref4, data) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;

        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                value: data.object,
                path: 'appraisal_planannexes' + '/' + data.appraisal_id + '/',
                save_timestamp: false
            }).then(function (res) {
                resolve();
            });
        });
    }
};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__constants__["_592" /* SET_APPRAISAL_PLANANNEXES */], function (state, data) {
    state.planannexes = check_undefined(data);
});

var getters = {
    appraisal_planannexes: function appraisal_planannexes(state) {
        return state.planannexes;
    }
};

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    registryannexes: {}
};
var state = default_state;

var actions = {
    FETCH_APPRAISAL_REGISTRYANNEXES: function FETCH_APPRAISAL_REGISTRYANNEXES(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        // console.log('data.path (fetch_appraisal_registryannexes) ---->')
        // console.log(data.path)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_595" /* SET_APPRAISAL_REGISTRYANNEXES */], res);
        });
    },
    SET_APPRAISAL_REGISTRYANNEXES: function SET_APPRAISAL_REGISTRYANNEXES(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_595" /* SET_APPRAISAL_REGISTRYANNEXES */], data);
    },
    UPLOAD_REGISTRYANNEX_FILES: function UPLOAD_REGISTRYANNEX_FILES(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;

        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].uploadImages(data).then(function () {
                resolve();
            });
        });
    },
    UPDATE_APPRAISAL_REGISTRYANNEXES: function UPDATE_APPRAISAL_REGISTRYANNEXES(_ref4, data) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;

        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                value: data.object,
                path: 'appraisal_registryannexes' + '/' + data.appraisal_id + '/',
                save_timestamp: false
            }).then(function (res) {
                resolve();
            });
        });
    }
};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__constants__["_595" /* SET_APPRAISAL_REGISTRYANNEXES */], function (state, data) {
    state.registryannexes = check_undefined(data);
});

var getters = {
    appraisal_registryannexes: function appraisal_registryannexes(state) {
        return state.registryannexes;
    }
};

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    rooms: {}
};
var state = default_state;

var actions = {
    FETCH_APPRAISAL_ROOMS: function FETCH_APPRAISAL_ROOMS(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        // console.log('data.path (fetch_appraisal_rooms) ---->')
        // console.log(data.path)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_602" /* SET_APPRAISAL_ROOMS */], res);
        });
    },
    SET_APPRAISAL_ROOMS: function SET_APPRAISAL_ROOMS(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_602" /* SET_APPRAISAL_ROOMS */], data);
    },
    UPDATE_APPRAISAL_ROOMS: function UPDATE_APPRAISAL_ROOMS(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;

        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                value: data.object,
                path: 'appraisal_rooms' + '/' + data.appraisal_id + '/',
                save_timestamp: false
            }).then(function (res) {
                resolve();
            });
        });
    }
};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__constants__["_602" /* SET_APPRAISAL_ROOMS */], function (state, data) {
    state.rooms = check_undefined(data);
});

var getters = {
    appraisal_rooms: function appraisal_rooms(state) {
        return state.rooms;
    }
};

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    uncovered_outdoors: {}
};
var state = default_state;

var actions = {
    FETCH_APPRAISAL_UNCOVERED_OUTDOORS: function FETCH_APPRAISAL_UNCOVERED_OUTDOORS(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        // console.log('data.path (fetch_appraisal_uncovered_outdoors) ---->')
        // console.log(data.path)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_600" /* SET_APPRAISAL_UNCOVERED_OUTDOORS */], res);
        });
    },
    SET_APPRAISAL_UNCOVERED_OUTDOORS: function SET_APPRAISAL_UNCOVERED_OUTDOORS(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_600" /* SET_APPRAISAL_UNCOVERED_OUTDOORS */], data);
    },
    UPDATE_APPRAISAL_UNCOVERED_OUTDOORS: function UPDATE_APPRAISAL_UNCOVERED_OUTDOORS(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;

        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                value: data.object,
                path: 'appraisal_uncovered_outdoors' + '/' + data.appraisal_id + '/',
                save_timestamp: false
            }).then(function (res) {
                resolve();
            });
        });
    }
};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__constants__["_600" /* SET_APPRAISAL_UNCOVERED_OUTDOORS */], function (state, data) {
    state.uncovered_outdoors = check_undefined(data);
});

var getters = {
    appraisal_uncovered_outdoors: function appraisal_uncovered_outdoors(state) {
        return state.uncovered_outdoors;
    }
};

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    urbanannexes: {}
};
var state = default_state;

var actions = {
    FETCH_APPRAISAL_URBANANNEXES: function FETCH_APPRAISAL_URBANANNEXES(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        // console.log('data.path (fetch_appraisal_urbanannexes) ---->')
        // console.log(data.path)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_593" /* SET_APPRAISAL_URBANANNEXES */], res);
        });
    },
    SET_APPRAISAL_URBANANNEXES: function SET_APPRAISAL_URBANANNEXES(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_593" /* SET_APPRAISAL_URBANANNEXES */], data);
    },
    UPLOAD_URBANANNEX_FILES: function UPLOAD_URBANANNEX_FILES(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;

        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].uploadImages(data).then(function () {
                resolve();
            });
        });
    },
    UPDATE_APPRAISAL_URBANANNEXES: function UPDATE_APPRAISAL_URBANANNEXES(_ref4, data) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;

        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                value: data.object,
                path: 'appraisal_urbanannexes' + '/' + data.appraisal_id + '/',
                save_timestamp: false
            }).then(function (res) {
                resolve();
            });
        });
    }
};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__constants__["_593" /* SET_APPRAISAL_URBANANNEXES */], function (state, data) {
    state.urbanannexes = check_undefined(data);
});

var getters = {
    appraisal_urbanannexes: function appraisal_urbanannexes(state) {
        return state.urbanannexes;
    }
};

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    warnings: {}
};
var state = default_state;

var actions = {
    FETCH_APPRAISAL_WARNINGS: function FETCH_APPRAISAL_WARNINGS(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        // console.log('data.path (fetch_appraisal_warnings) ---->')
        // console.log(data.path)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_598" /* SET_APPRAISAL_WARNINGS */], res);
        });
    },
    SET_APPRAISAL_WARNINGS: function SET_APPRAISAL_WARNINGS(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_598" /* SET_APPRAISAL_WARNINGS */], data);
    },
    UPDATE_APPRAISAL_WARNINGS: function UPDATE_APPRAISAL_WARNINGS(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;

        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                value: data.object,
                path: 'appraisal_warnings' + '/' + data.appraisal_id + '/',
                save_timestamp: false
            }).then(function (res) {
                resolve();
            });
        });
    }
};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__constants__["_598" /* SET_APPRAISAL_WARNINGS */], function (state, data) {
    state.warnings = check_undefined(data);
});

var getters = {
    appraisal_warnings: function appraisal_warnings(state) {
        return state.warnings;
    }
};

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    path: null,
    description: null,
    number: null
};
var state = default_state;

var actions = {
    CREATE_NEW_APPRAISALFILE: function CREATE_NEW_APPRAISALFILE(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: 'stats/files/' }).then(function (res) {
                // console.log('create_new_apprisalfile api.get res:')
                // console.log(res)
                // const number = res.basenumber + data.size + 1

                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_581" /* RESET_APPRAISALFILE */]);
                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].create({ path: data.path }).then(function (res) {
                    commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_582" /* SET_APPRAISALFILE_NUMBER */], data.number);
                    commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_583" /* SET_APPRAISALFILE_ID */], res.key);
                    commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_584" /* SET_APPRAISALFILE_DATE_CREATED */], res.date_created);
                    commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_585" /* SET_APPRAISALFILE_DATE_MODIFIED */], res.date_modified);
                    commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_586" /* SET_APPRAISALFILE_PATH */], res.path);
                    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                        value: res.key,
                        path: data.path + '/' + res.key + '/' + 'id',
                        save_timestamp: false
                    });
                    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                        value: data.number,
                        path: data.path + '/' + res.key + '/' + 'number',
                        save_timestamp: false
                    }).then(function (res) {
                        return resolve(res);
                    });
                });
            });
        });
    },
    DELETE_APPRAISALFILE: function DELETE_APPRAISALFILE(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;


        var appraisalfile_id = data.key;

        console.log('path check: ' + data.path);
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.path }).then(function (res) {
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_581" /* RESET_APPRAISALFILE */]);
        });
        // TODO:
        // al borrar expedient s'ha de borrar també:
        // els informes que conté, i per tant de la llista de appraisalreport de cadascun dels realestates on hi figuri
        // s'ha de treure de la llista de appraisalfiles de cadascun dels realestates a on hi figuri

        _.forEach(data.appraisalreports, function (value, key) {

            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: 'appraisalreports' + '/' + key }).then(function (res) {
                console.log('huhuhuhuhaaaaalklklkkl res: ');
                console.log(res);

                _.forEach(res.realestates, function (value2, key2) {

                    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ path: 'realestates' + '/' + key2 + '/' + 'appraisalreports' + '/' + key }).then(function (res) {
                        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ path: 'realestates' + '/' + key2 + '/' + 'appraisalfiles' + '/' + appraisalfile_id }).then(function (res) {
                            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ path: 'appraisalreports' + '/' + key }).then(function (res) {});
                        });
                    });
                });
            });
        });
    },
    RESET_APPRAISALFILE: function RESET_APPRAISALFILE(_ref3) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_581" /* RESET_APPRAISALFILE */]);
    },
    SET_APPRAISALFILE: function SET_APPRAISALFILE(_ref4, data) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;


        console.log('set_appraisalfile data:');
        console.log(data);
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_587" /* SET_APPRAISALFILE */], res);
        });
    },
    SET_APPRAISALFILE_DATE_CREATED: function SET_APPRAISALFILE_DATE_CREATED(_ref5, data) {
        var state = _ref5.state,
            commit = _ref5.commit,
            rootState = _ref5.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_584" /* SET_APPRAISALFILE_DATE_CREATED */], data);
    },
    SET_APPRAISALFILE_DATE_MODIFIED: function SET_APPRAISALFILE_DATE_MODIFIED(_ref6, data) {
        var state = _ref6.state,
            commit = _ref6.commit,
            rootState = _ref6.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_585" /* SET_APPRAISALFILE_DATE_MODIFIED */], data);
    },
    SET_APPRAISALFILE_ID: function SET_APPRAISALFILE_ID(_ref7, data) {
        var state = _ref7.state,
            commit = _ref7.commit,
            rootState = _ref7.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_583" /* SET_APPRAISALFILE_ID */], data);
    },
    SET_APPRAISALFILE_PATH: function SET_APPRAISALFILE_PATH(_ref8, data) {
        var state = _ref8.state,
            commit = _ref8.commit,
            rootState = _ref8.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_586" /* SET_APPRAISALFILE_PATH */], data);
    },
    UPDATE_APPRAISALFILE: function UPDATE_APPRAISALFILE(_ref9, data) {
        var state = _ref9.state,
            commit = _ref9.commit,
            rootState = _ref9.rootState;

        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({ object: data.object, path: data.path, save_timestamp: true }).then(function (res) {
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_585" /* SET_APPRAISALFILE_DATE_MODIFIED */], res.date_modified);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_588" /* SET_APPRAISALFILE_DIRTYNESS */], false);
        });
    },
    SET_APPRAISALFILE_DESCRIPTION: function SET_APPRAISALFILE_DESCRIPTION(_ref10, data) {
        var state = _ref10.state,
            commit = _ref10.commit,
            rootState = _ref10.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_589" /* SET_APPRAISALFILE_DESCRIPTION */], data);
    },
    SET_APPRAISALFILE_NUMBER: function SET_APPRAISALFILE_NUMBER(_ref11, data) {
        var state = _ref11.state,
            commit = _ref11.commit,
            rootState = _ref11.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_582" /* SET_APPRAISALFILE_NUMBER */], data);
    }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_581" /* RESET_APPRAISALFILE */], function (state) {
    state.date_created = null;
    state.date_modified = null;
    state.id = null;
    state.path = null;
    state.dirty = false;
    state.description = null;
    state.number = null;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_587" /* SET_APPRAISALFILE */], function (state, data) {
    // console.log('mutations SET_APPRAISALFILE data: ')
    // console.log(data)
    state.date_created = check_undefined(data.date_created);
    state.date_modified = check_undefined(data.date_modified);
    state.id = check_undefined(data.id);
    state.path = check_undefined(data.path);
    state.dirty = false;
    state.description = check_undefined(data.description);
    state.number = check_undefined(data.number);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_584" /* SET_APPRAISALFILE_DATE_CREATED */], function (state, data) {
    state.date_created = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_585" /* SET_APPRAISALFILE_DATE_MODIFIED */], function (state, data) {
    state.date_modified = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_588" /* SET_APPRAISALFILE_DIRTYNESS */], function (state, boolean) {
    state.dirty = boolean;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_583" /* SET_APPRAISALFILE_ID */], function (state, data) {
    state.id = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_586" /* SET_APPRAISALFILE_PATH */], function (state, data) {
    state.path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_589" /* SET_APPRAISALFILE_DESCRIPTION */], function (state, data) {
    state.description = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_582" /* SET_APPRAISALFILE_NUMBER */], function (state, data) {
    state.number = data;
    state.dirty = true;
}), _mutations);

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

var getters = {

    appraisalfile: function appraisalfile(state) {
        return state;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    appraisalinvoices: {},
    temp_appraisalinvoices: {}
};
var state = default_state;

var actions = {
    FETCH_APPRAISALFILE_APPRAISALINVOICES: function FETCH_APPRAISALFILE_APPRAISALINVOICES(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;

        // console.log('data.path (fetch_appraisalfile_appraisalinvoices) ---->')
        // console.log(data.path)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            // console.log(res)
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_575" /* SET_APPRAISALFILE_APPRAISALINVOICES */], res);
        });
    },

    FETCH_TEMP_APPRAISALFILE_APPRAISALINVOICES: function FETCH_TEMP_APPRAISALFILE_APPRAISALINVOICES(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;

        // console.log('data.path (fetch_appraisalfile_appraisalinvoices) ---->')
        // console.log(data.path)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            // console.log(res)
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_576" /* SET_TEMP_APPRAISALFILE_APPRAISALINVOICES */], res);
        });
    }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_575" /* SET_APPRAISALFILE_APPRAISALINVOICES */], function (state, data) {
    state.appraisalinvoices = data;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_576" /* SET_TEMP_APPRAISALFILE_APPRAISALINVOICES */], function (state, data) {
    state.temp_appraisalinvoices = data;
}), _mutations);

var getters = {
    appraisalfile_appraisalinvoices: function appraisalfile_appraisalinvoices(state) {
        return state.appraisalinvoices;
    },
    temp_appraisalinvoices: function temp_appraisalinvoices(state) {
        return state.temp_appraisalinvoices;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    appraisalquotes: {},
    temp_appraisalquotes: {}
};
var state = default_state;

var actions = {
    FETCH_APPRAISALFILE_APPRAISALQUOTES: function FETCH_APPRAISALFILE_APPRAISALQUOTES(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;

        // console.log('data.path (fetch_appraisalfile_appraisalquotes) ---->')
        // console.log(data.path)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            // console.log(res)
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_577" /* SET_APPRAISALFILE_APPRAISALQUOTES */], res);
        });
    },

    FETCH_TEMP_APPRAISALFILE_APPRAISALQUOTES: function FETCH_TEMP_APPRAISALFILE_APPRAISALQUOTES(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;

        // console.log('data.path (fetch_appraisalfile_appraisalquotes) ---->')
        // console.log(data.path)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            // console.log(res)
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_578" /* SET_TEMP_APPRAISALFILE_APPRAISALQUOTES */], res);
        });
    }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_577" /* SET_APPRAISALFILE_APPRAISALQUOTES */], function (state, data) {
    state.appraisalquotes = data;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_578" /* SET_TEMP_APPRAISALFILE_APPRAISALQUOTES */], function (state, data) {
    state.temp_appraisalquotes = data;
}), _mutations);

var getters = {
    appraisalfile_appraisalquotes: function appraisalfile_appraisalquotes(state) {
        return state.appraisalquotes;
    },
    temp_appraisalquotes: function temp_appraisalquotes(state) {
        return state.temp_appraisalquotes;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    appraisalreports: {},
    temp_appraisalreports: {}
};
var state = default_state;

var actions = {
    FETCH_APPRAISALFILE_APPRAISALREPORTS: function FETCH_APPRAISALFILE_APPRAISALREPORTS(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;

        // console.log('data.path (fetch_appraisalfile_appraisalreports) ---->')
        // console.log(data.path)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            // console.log(res)
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_579" /* SET_APPRAISALFILE_APPRAISALREPORTS */], res);
        });
    },

    FETCH_TEMP_APPRAISALFILE_APPRAISALREPORTS: function FETCH_TEMP_APPRAISALFILE_APPRAISALREPORTS(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;

        // console.log('data.path (fetch_appraisalfile_appraisalreports) ---->')
        // console.log(data.path)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            // console.log(res)
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_580" /* SET_TEMP_APPRAISALFILE_APPRAISALREPORTS */], res);
        });
    }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_579" /* SET_APPRAISALFILE_APPRAISALREPORTS */], function (state, data) {
    state.appraisalreports = data;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_580" /* SET_TEMP_APPRAISALFILE_APPRAISALREPORTS */], function (state, data) {
    state.temp_appraisalreports = data;
}), _mutations);

var getters = {
    appraisalfile_appraisalreports: function appraisalfile_appraisalreports(state) {
        return state.appraisalreports;
    },
    temp_appraisalreports: function temp_appraisalreports(state) {
        return state.temp_appraisalreports;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var state = {
    appraisalfiles: []
};

var actions = {
    FETCH_APPRAISALFILES: function FETCH_APPRAISALFILES(_ref) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;

        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: 'appraisalfiles' }).then(function (res) {
            // console.log(res)
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_574" /* SET_APPRAISALFILES */], res);
        });
    }
};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__constants__["_574" /* SET_APPRAISALFILES */], function (state, data) {
    state.appraisalfiles = data;
});

var getters = {
    appraisalfiles: function appraisalfiles(state) {
        return state.appraisalfiles;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var default_state = {
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    path: null,
    description: null,
    number: null,
    full_number: null,
    invoicedate: null,
    send_to_bde: false,
    title: null,
    vat_pct: 21,
    version: null,
    petitioner: null,
    petitioner_type: {
        id: 1,
        'name_ca': 'Altres persones físiques o jurídiques',
        'name_en': 'Other natural or legal persons',
        'name_es': 'Otras personas físicas o jurídicas'
    },
    quote: {},
    entity: null,
    supervisor: {
        complete_name: 'López-Doriga, Ferran',
        id: '-L-K_d-_ZNBuuqfNtjJy',
        name: 'Ferran',
        path: 'supervisors',
        prof_assoc_reg_number: '9830-2',
        surnames: 'López-Doriga',
        tin: '46108653R'
    },
    appraiser: null,
    cover_photo_url: null,
    status: {
        id: 1,
        level: 1,
        progress_coef: 0.166,
        name_ca: '1/6 - Falta la firma del Director Financer (CFO)',
        name_es: '1/6 - Falta la firma del Director Financiero (CFO)',
        name_en: '1/6 - Needs to be signed by CFO'
    },
    base_price: 0,
    discount_pct: 0,
    final_price: 0,
    final_price_incl_vat: 0,
    discount_notes: null,
    bank_name: 'CAIXABANK',
    iban: 'ES09 2100 0911 01 0200176881',
    fiscal_number: null,
    signature_name: null,
    signature_base64: null,
    signature_date: null,
    signature_email: null,
    signature_uid: null,
    is_signed: null

};

var state = default_state;

var actions = {

    CREATE_NEW_APPRAISALINVOICE: function CREATE_NEW_APPRAISALINVOICE(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].create({ key: data.key, path: data.path }).then(function (res) {
                var new_created_key = res.key;
                var default_appraisalinvoicedate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(res.date_created, 'x').format('YYYY-MM-DD');

                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_462" /* SET_APPRAISALINVOICE_ID */], res.key);
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_463" /* SET_APPRAISALINVOICE_DATE_CREATED */], res.date_created);
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_464" /* SET_APPRAISALINVOICE_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_465" /* SET_APPRAISALINVOICE_NUMBER */], data.number);
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_466" /* SET_APPRAISALINVOICE_PATH */], res.path);
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_467" /* SET_APPRAISALINVOICE_PARENT_PATH */], data.parent_path);
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_468" /* SET_APPRAISALINVOICE_REPORTDATE */], default_appraisalinvoicedate);
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_469" /* SET_APPRAISALINVOICE_VERSION */], data.version);
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_470" /* SET_APPRAISALINVOICE_FULL_NUMBER */], data.full_number);
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_471" /* SET_APPRAISALINVOICE_FISCAL_NUMBER */], data.fiscal_number);
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_472" /* SET_APPRAISALINVOICE_FILE_ID */], data.file_id);

                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                    value: res.key,
                    path: data.path + new_created_key + '/' + 'id',
                    save_timestamp: false
                }).then(function (res) {
                    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                        value: default_appraisalinvoicedate,
                        path: data.path + new_created_key + '/' + 'invoicedate',
                        save_timestamp: false
                    }).then(function (res) {
                        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                            value: data.file_id,
                            path: data.path + new_created_key + '/' + 'file_id',
                            save_timestamp: false
                        }).then(function (res) {
                            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                                value: data.number,
                                path: data.path + new_created_key + '/' + 'number',
                                save_timestamp: false
                            }).then(function (res) {
                                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                                    value: data.full_number,
                                    path: data.path + new_created_key + '/' + 'full_number',
                                    save_timestamp: false
                                }).then(function (res) {
                                    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                                        value: data.fiscal_number,
                                        path: data.path + new_created_key + '/' + 'fiscal_number',
                                        save_timestamp: false
                                    }).then(function (res) {

                                        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                                            value: data.parent_path,
                                            path: data.path + new_created_key + '/' + 'parent_path',
                                            save_timestamp: false
                                        }).then(function (res) {
                                            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                                                value: data.version,
                                                path: data.path + new_created_key + '/' + 'version',
                                                save_timestamp: false
                                            }).then(function (res) {
                                                var object = {};
                                                object[new_created_key] = {
                                                    description: '',
                                                    id: new_created_key,
                                                    number: data.number,
                                                    version: data.version
                                                };
                                                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({
                                                    object: object,
                                                    path: data.parent_path,
                                                    save_timestamp: false
                                                }).then(function (res) {
                                                    return resolve({ key: new_created_key });
                                                });
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    });
                });
            });
        });
    },
    DELETE_APPRAISALINVOICE: function DELETE_APPRAISALINVOICE(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;


        // console.log('DELETE_APPRAISALINVOICE path check: ' + data.path)
        // console.log('DELETE APPRAISALINVOICE parent_path check: ' + data.parent_path)

        // delete from appraisalinvoices/appraisalinvoice_key
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.path }).then(function (res) {

            var date_modified = res.date_modified;

            // delete from appraisalfiles/appraisalfile_key/appraisalinvoices/appraisalinvoice_key
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.parent_path }).then(function (res) {
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_473" /* RESET_APPRAISALINVOICE */]);

                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                    value: date_modified,
                    path: 'appraisalfiles' + '/' + data.file_id + '/' + 'date_modified',
                    save_timestamp: false
                }).then(function (res) {});
            });
        });
    },
    GET_APPRAISALINVOICE: function GET_APPRAISALINVOICE(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;


        return new Promise(function (resolve, reject) {
            return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                return resolve(res);
            });
        });
    },
    SET_APPRAISALINVOICE: function SET_APPRAISALINVOICE(_ref4, data) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;


        // console.log('set_appraisalinvoice data:')
        // console.log(data)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_474" /* SET_APPRAISALINVOICE */], res);
        });
    },
    RESET_APPRAISALINVOICE: function RESET_APPRAISALINVOICE(_ref5) {
        var state = _ref5.state,
            commit = _ref5.commit,
            rootState = _ref5.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_473" /* RESET_APPRAISALINVOICE */]);
    },
    SET_APPRAISALINVOICE_REPORTDATE: function SET_APPRAISALINVOICE_REPORTDATE(_ref6, data) {
        var state = _ref6.state,
            commit = _ref6.commit,
            rootState = _ref6.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_468" /* SET_APPRAISALINVOICE_REPORTDATE */], data);
    },
    SET_APPRAISALINVOICE_DATE_CREATED: function SET_APPRAISALINVOICE_DATE_CREATED(_ref7, data) {
        var state = _ref7.state,
            commit = _ref7.commit,
            rootState = _ref7.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_463" /* SET_APPRAISALINVOICE_DATE_CREATED */], data);
    },
    SET_APPRAISALINVOICE_DATE_MODIFIED: function SET_APPRAISALINVOICE_DATE_MODIFIED(_ref8, data) {
        var state = _ref8.state,
            commit = _ref8.commit,
            rootState = _ref8.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_464" /* SET_APPRAISALINVOICE_DATE_MODIFIED */], data);
    },

    SET_APPRAISALINVOICE_FILE_ID: function SET_APPRAISALINVOICE_FILE_ID(_ref9, data) {
        var state = _ref9.state,
            commit = _ref9.commit,
            rootState = _ref9.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_472" /* SET_APPRAISALINVOICE_FILE_ID */], data);
    },
    SET_APPRAISALINVOICE_ID: function SET_APPRAISALINVOICE_ID(_ref10, data) {
        var state = _ref10.state,
            commit = _ref10.commit,
            rootState = _ref10.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_462" /* SET_APPRAISALINVOICE_ID */], data);
    },
    SET_APPRAISALINVOICE_NUMBER: function SET_APPRAISALINVOICE_NUMBER(_ref11, data) {
        var state = _ref11.state,
            commit = _ref11.commit,
            rootState = _ref11.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_465" /* SET_APPRAISALINVOICE_NUMBER */], data);
    },
    SET_APPRAISALINVOICE_PARENT_PATH: function SET_APPRAISALINVOICE_PARENT_PATH(_ref12, data) {
        var state = _ref12.state,
            commit = _ref12.commit,
            rootState = _ref12.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_467" /* SET_APPRAISALINVOICE_PARENT_PATH */], data);
    },
    SET_APPRAISALINVOICE_PATH: function SET_APPRAISALINVOICE_PATH(_ref13, data) {
        var state = _ref13.state,
            commit = _ref13.commit,
            rootState = _ref13.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_466" /* SET_APPRAISALINVOICE_PATH */], data);
    },
    SET_APPRAISALINVOICE_SEND_TO_BDE: function SET_APPRAISALINVOICE_SEND_TO_BDE(_ref14, data) {
        var state = _ref14.state,
            commit = _ref14.commit,
            rootState = _ref14.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_475" /* SET_APPRAISALINVOICE_SEND_TO_BDE */], data);
    },
    SET_APPRAISALINVOICE_TITLE: function SET_APPRAISALINVOICE_TITLE(_ref15, data) {
        var state = _ref15.state,
            commit = _ref15.commit,
            rootState = _ref15.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_476" /* SET_APPRAISALINVOICE_TITLE */], data);
    },
    SET_APPRAISALINVOICE_VERSION: function SET_APPRAISALINVOICE_VERSION(_ref16, data) {
        var state = _ref16.state,
            commit = _ref16.commit,
            rootState = _ref16.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_469" /* SET_APPRAISALINVOICE_VERSION */], data);
    },
    UPDATE_APPRAISALINVOICE: function UPDATE_APPRAISALINVOICE(_ref17, data) {
        var state = _ref17.state,
            commit = _ref17.commit,
            rootState = _ref17.rootState;

        return new Promise(function (resolve, reject) {
            // console.log('UPDATE_APPRAISALINVOICE data:')
            // console.log(data)
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({ object: data.object, path: data.path + data.key, save_timestamp: true }).then(function (res) {

                var date_modified = res.date_modified;
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_464" /* SET_APPRAISALINVOICE_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_477" /* SET_APPRAISALINVOICE_DIRTYNESS */], false);

                var parent_object = {};

                parent_object = {
                    description: data.object.description,
                    id: data.object.id,
                    date_modified: res.date_modified,
                    number: data.object.number,
                    version: data.object.version,
                    send_to_bde: data.object.send_to_bde
                };
                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({ object: parent_object, path: data.parent_path + data.key, save_timestamp: false }).then(function (res) {

                    // update file date_modified
                    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                        value: date_modified,
                        path: 'appraisalfiles' + '/' + data.object.file_id + '/' + 'date_modified',
                        save_timestamp: false
                    }).then(function (res) {
                        return resolve({ key: res.key });
                    });
                });
            });
        });
    },
    SET_APPRAISALINVOICE_REALESTATE_APPRAISAL_ID: function SET_APPRAISALINVOICE_REALESTATE_APPRAISAL_ID(_ref18, data) {
        var state = _ref18.state,
            commit = _ref18.commit,
            rootState = _ref18.rootState;

        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                value: data.value,
                path: data.path,
                save_timestamp: false
            }).then(function () {
                resolve();
            });
        });
    },
    UPDATE_APPRAISALINVOICE_REALESTATE_APPRAISAL_ID: function UPDATE_APPRAISALINVOICE_REALESTATE_APPRAISAL_ID(_ref19, data) {
        var state = _ref19.state,
            commit = _ref19.commit,
            rootState = _ref19.rootState;

        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                value: data.appraisal_id,
                path: 'appraisalinvoices' + '/' + data.appraisalinvoice_id + '/' + 'realestates' + '/' + data.realestate_id + '/' + 'appraisal_id',
                save_timestamp: false
            });
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                value: data.appraisaldate,
                path: 'appraisalinvoices' + '/' + data.appraisalinvoice_id + '/' + 'realestates' + '/' + data.realestate_id + '/' + 'appraisals' + '/' + data.appraisal_id + '/' + 'appraisaldate',
                save_timestamp: false
            });
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                value: data.appraisal_id,
                path: 'appraisalinvoices' + '/' + data.appraisalinvoice_id + '/' + 'realestates' + '/' + data.realestate_id + '/' + 'appraisals' + '/' + data.appraisal_id + '/' + 'id',
                save_timestamp: false
            }).then(function () {
                resolve();
            });
        });
    },
    SET_APPRAISALINVOICE_DESCRIPTION: function SET_APPRAISALINVOICE_DESCRIPTION(_ref20, data) {
        var state = _ref20.state,
            commit = _ref20.commit,
            rootState = _ref20.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_478" /* SET_APPRAISALINVOICE_DESCRIPTION */], data);
    },
    SET_APPRAISALINVOICE_PETITIONER: function SET_APPRAISALINVOICE_PETITIONER(_ref21, data) {
        var state = _ref21.state,
            commit = _ref21.commit,
            rootState = _ref21.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_479" /* SET_APPRAISALINVOICE_PETITIONER */], data);
    },
    SET_APPRAISALINVOICE_PETITIONER_TYPE: function SET_APPRAISALINVOICE_PETITIONER_TYPE(_ref22, data) {
        var state = _ref22.state,
            commit = _ref22.commit,
            rootState = _ref22.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_480" /* SET_APPRAISALINVOICE_PETITIONER_TYPE */], data);
    },
    SET_APPRAISALINVOICE_ENTITY: function SET_APPRAISALINVOICE_ENTITY(_ref23, data) {
        var state = _ref23.state,
            commit = _ref23.commit,
            rootState = _ref23.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_481" /* SET_APPRAISALINVOICE_ENTITY */], data);
    },
    SET_APPRAISALINVOICE_SUPERVISOR: function SET_APPRAISALINVOICE_SUPERVISOR(_ref24, data) {
        var state = _ref24.state,
            commit = _ref24.commit,
            rootState = _ref24.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_482" /* SET_APPRAISALINVOICE_SUPERVISOR */], data);
    },
    SET_APPRAISALINVOICE_APPRAISER: function SET_APPRAISALINVOICE_APPRAISER(_ref25, data) {
        var state = _ref25.state,
            commit = _ref25.commit,
            rootState = _ref25.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_483" /* SET_APPRAISALINVOICE_APPRAISER */], data);
    },
    SET_APPRAISALINVOICE_COVER_PHOTO_URL: function SET_APPRAISALINVOICE_COVER_PHOTO_URL(_ref26, data) {
        var state = _ref26.state,
            commit = _ref26.commit,
            rootState = _ref26.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_484" /* SET_APPRAISALINVOICE_COVER_PHOTO_URL */], data);
    },
    SET_APPRAISALINVOICE_VAT_PCT: function SET_APPRAISALINVOICE_VAT_PCT(_ref27, data) {
        var state = _ref27.state,
            commit = _ref27.commit,
            rootState = _ref27.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_485" /* SET_APPRAISALINVOICE_VAT_PCT */], data);
    },
    SET_APPRAISALINVOICE_STATUS: function SET_APPRAISALINVOICE_STATUS(_ref28, data) {
        var state = _ref28.state,
            commit = _ref28.commit,
            rootState = _ref28.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_486" /* SET_APPRAISALINVOICE_STATUS */], data);
    },
    SET_APPRAISALINVOICE_QUOTE: function SET_APPRAISALINVOICE_QUOTE(_ref29, data) {
        var state = _ref29.state,
            commit = _ref29.commit,
            rootState = _ref29.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_487" /* SET_APPRAISALINVOICE_QUOTE */], data);
    },
    SET_APPRAISALINVOICE_FULL_NUMBER: function SET_APPRAISALINVOICE_FULL_NUMBER(_ref30, data) {
        var state = _ref30.state,
            commit = _ref30.commit,
            rootState = _ref30.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_470" /* SET_APPRAISALINVOICE_FULL_NUMBER */], data);
    },
    SET_APPRAISALINVOICE_BASE_PRICE: function SET_APPRAISALINVOICE_BASE_PRICE(_ref31, data) {
        var state = _ref31.state,
            commit = _ref31.commit,
            rootState = _ref31.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_488" /* SET_APPRAISALINVOICE_BASE_PRICE */], data);
    },
    SET_APPRAISALINVOICE_DISCOUNT_PCT: function SET_APPRAISALINVOICE_DISCOUNT_PCT(_ref32, data) {
        var state = _ref32.state,
            commit = _ref32.commit,
            rootState = _ref32.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_489" /* SET_APPRAISALINVOICE_DISCOUNT_PCT */], data);
    },
    SET_APPRAISALINVOICE_FINAL_PRICE: function SET_APPRAISALINVOICE_FINAL_PRICE(_ref33, data) {
        var state = _ref33.state,
            commit = _ref33.commit,
            rootState = _ref33.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_490" /* SET_APPRAISALINVOICE_FINAL_PRICE */], data);
    },
    SET_APPRAISALINVOICE_FINAL_PRICE_INCL_VAT: function SET_APPRAISALINVOICE_FINAL_PRICE_INCL_VAT(_ref34, data) {
        var state = _ref34.state,
            commit = _ref34.commit,
            rootState = _ref34.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_491" /* SET_APPRAISALINVOICE_FINAL_PRICE_INCL_VAT */], data);
    },
    SET_APPRAISALINVOICE_DISCOUNT_NOTES: function SET_APPRAISALINVOICE_DISCOUNT_NOTES(_ref35, data) {
        var state = _ref35.state,
            commit = _ref35.commit,
            rootState = _ref35.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_492" /* SET_APPRAISALINVOICE_DISCOUNT_NOTES */], data);
    },
    SET_APPRAISALINVOICE_BANK_NAME: function SET_APPRAISALINVOICE_BANK_NAME(_ref36, data) {
        var state = _ref36.state,
            commit = _ref36.commit,
            rootState = _ref36.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_493" /* SET_APPRAISALINVOICE_BANK_NAME */], data);
    },
    SET_APPRAISALINVOICE_IBAN: function SET_APPRAISALINVOICE_IBAN(_ref37, data) {
        var state = _ref37.state,
            commit = _ref37.commit,
            rootState = _ref37.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_494" /* SET_APPRAISALINVOICE_IBAN */], data);
    },
    SET_APPRAISALINVOICE_FISCAL_NUMBER: function SET_APPRAISALINVOICE_FISCAL_NUMBER(_ref38, data) {
        var state = _ref38.state,
            commit = _ref38.commit,
            rootState = _ref38.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_471" /* SET_APPRAISALINVOICE_FISCAL_NUMBER */], data);
    },
    SET_APPRAISALINVOICE_SIGNATURE_NAME: function SET_APPRAISALINVOICE_SIGNATURE_NAME(_ref39, data) {
        var state = _ref39.state,
            commit = _ref39.commit,
            rootState = _ref39.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_495" /* SET_APPRAISALINVOICE_SIGNATURE_NAME */], data);
    },
    SET_APPRAISALINVOICE_SIGNATURE_BASE64: function SET_APPRAISALINVOICE_SIGNATURE_BASE64(_ref40, data) {
        var state = _ref40.state,
            commit = _ref40.commit,
            rootState = _ref40.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_496" /* SET_APPRAISALINVOICE_SIGNATURE_BASE64 */], data);
    },
    SET_APPRAISALINVOICE_SIGNATURE_DATE: function SET_APPRAISALINVOICE_SIGNATURE_DATE(_ref41, data) {
        var state = _ref41.state,
            commit = _ref41.commit,
            rootState = _ref41.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_497" /* SET_APPRAISALINVOICE_SIGNATURE_DATE */], data);
    },
    SET_APPRAISALINVOICE_SIGNATURE_EMAIL: function SET_APPRAISALINVOICE_SIGNATURE_EMAIL(_ref42, data) {
        var state = _ref42.state,
            commit = _ref42.commit,
            rootState = _ref42.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_498" /* SET_APPRAISALINVOICE_SIGNATURE_EMAIL */], data);
    },
    SET_APPRAISALINVOICE_SIGNATURE_UID: function SET_APPRAISALINVOICE_SIGNATURE_UID(_ref43, data) {
        var state = _ref43.state,
            commit = _ref43.commit,
            rootState = _ref43.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_499" /* SET_APPRAISALINVOICE_SIGNATURE_UID */], data);
    },
    SET_APPRAISALINVOICE_IS_SIGNED: function SET_APPRAISALINVOICE_IS_SIGNED(_ref44, data) {
        var state = _ref44.state,
            commit = _ref44.commit,
            rootState = _ref44.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_500" /* SET_APPRAISALINVOICE_IS_SIGNED */], data);
    }

};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_473" /* RESET_APPRAISALINVOICE */], function (state) {
    state.date_created = null;
    state.date_modified = null;
    state.dirty = false;
    state.file_id = null;
    state.id = null;
    state.number = null;
    state.full_number = null;
    state.path = null;
    state.parent_path = null;
    state.quote = null;
    state.description = null;
    state.invoicedate = null;
    state.send_to_bde = null;
    state.title = null;
    state.version = null;
    state.petitioner = null;
    state.petitioner_type = {
        id: 1,
        'name_ca': 'Altres persones físiques o jurídiques',
        'name_en': 'Other natural or legal persons',
        'name_es': 'Otras personas físicas o jurídicas'
    };
    state.entity = null;
    state.supervisor = null;
    state.appraiser = null;
    state.cover_photo_url = null;
    state.vat_pct = 21;
    state.status = {
        id: 1,
        level: 1,
        progress_coef: 0.166,
        name_ca: '1/6 - Falta la firma del Director Financer (CFO)',
        name_es: '1/6 - Falta la firma del Director Financiero (CFO)',
        name_en: '1/6 - Needs to be signed by CFO'
    };
    state.base_price = 0;
    state.discount_pct = 0;
    state.final_price = 0;
    state.final_price_incl_vat = 0;
    state.discount_notes = null;
    state.bank_name = 'CAIXABANK';
    state.iban = 'ES09 2100 0911 01 0200176881';
    state.fiscal_number = null;
    state.signature_name = null;
    state.signature_base64 = null;
    state.signature_date = null;
    state.signature_email = null;
    state.signature_uid = null;
    state.is_signed = null;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_474" /* SET_APPRAISALINVOICE */], function (state, data) {
    state.date_created = check_undefined(data.date_created);
    state.date_modified = check_undefined(data.date_modified);
    state.dirty = false;
    state.file_id = check_undefined(data.file_id);
    state.id = check_undefined(data.id);
    state.number = check_undefined(data.number);
    state.full_number = check_undefined(data.full_number);
    state.path = check_undefined(data.path);
    state.parent_path = check_undefined(data.parent_path);
    state.description = check_undefined(data.description);
    state.invoicedate = check_undefined(data.invoicedate);
    state.send_to_bde = check_undefined(data.send_to_bde);
    state.title = check_undefined(data.title);
    state.version = check_undefined(data.version);
    state.petitioner = check_undefined(data.petitioner);
    state.petitioner_type = check_undefined(data.petitioner_type);
    state.entity = check_undefined(data.entity);
    state.supervisor = check_undefined(data.supervisor);
    state.appraiser = check_undefined(data.appraiser);
    state.cover_photo_url = check_undefined(data.cover_photo_url);
    state.vat_pct = check_undefined(data.vat_pct);
    state.status = check_undefined(data.status);
    state.quote = check_undefined(data.quote);
    state.base_price = check_undefined(data.base_price);
    state.discount_pct = check_undefined(data.discount_pct);
    state.final_price = check_undefined(data.final_price);
    state.final_price_incl_vat = check_undefined(data.final_price_incl_vat);
    state.discount_notes = check_undefined(data.discount_notes);
    state.bank_name = check_undefined(data.bank_name);
    state.iban = check_undefined(data.iban);
    state.fiscal_number = check_undefined(data.fiscal_number);
    state.signature_name = check_undefined(data.signature_name);
    state.signature_base64 = check_undefined(data.signature_base64);
    state.signature_date = check_undefined(data.signature_date);
    state.signature_email = check_undefined(data.signature_email);
    state.signature_uid = check_undefined(data.signature_uid);
    state.is_signed = check_undefined(data.is_signed);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_463" /* SET_APPRAISALINVOICE_DATE_CREATED */], function (state, data) {
    state.date_created = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_464" /* SET_APPRAISALINVOICE_DATE_MODIFIED */], function (state, data) {
    state.date_modified = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_477" /* SET_APPRAISALINVOICE_DIRTYNESS */], function (state, boolean) {
    state.dirty = boolean;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_472" /* SET_APPRAISALINVOICE_FILE_ID */], function (state, data) {
    state.file_id = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_462" /* SET_APPRAISALINVOICE_ID */], function (state, data) {
    state.id = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_465" /* SET_APPRAISALINVOICE_NUMBER */], function (state, data) {
    state.number = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_467" /* SET_APPRAISALINVOICE_PARENT_PATH */], function (state, data) {
    state.parent_path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_466" /* SET_APPRAISALINVOICE_PATH */], function (state, data) {
    state.path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_468" /* SET_APPRAISALINVOICE_REPORTDATE */], function (state, data) {
    state.invoicedate = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_476" /* SET_APPRAISALINVOICE_TITLE */], function (state, data) {
    state.title = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_478" /* SET_APPRAISALINVOICE_DESCRIPTION */], function (state, data) {
    state.description = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_469" /* SET_APPRAISALINVOICE_VERSION */], function (state, data) {
    state.version = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_479" /* SET_APPRAISALINVOICE_PETITIONER */], function (state, data) {
    state.petitioner = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_480" /* SET_APPRAISALINVOICE_PETITIONER_TYPE */], function (state, data) {
    state.petitioner_type = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_481" /* SET_APPRAISALINVOICE_ENTITY */], function (state, data) {
    state.entity = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_482" /* SET_APPRAISALINVOICE_SUPERVISOR */], function (state, data) {
    state.supervisor = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_483" /* SET_APPRAISALINVOICE_APPRAISER */], function (state, data) {
    state.appraiser = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_484" /* SET_APPRAISALINVOICE_COVER_PHOTO_URL */], function (state, data) {
    state.cover_photo_url = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_485" /* SET_APPRAISALINVOICE_VAT_PCT */], function (state, data) {
    state.vat_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_486" /* SET_APPRAISALINVOICE_STATUS */], function (state, data) {
    state.status = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_487" /* SET_APPRAISALINVOICE_QUOTE */], function (state, data) {
    state.quote = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_470" /* SET_APPRAISALINVOICE_FULL_NUMBER */], function (state, data) {
    state.full_number = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_488" /* SET_APPRAISALINVOICE_BASE_PRICE */], function (state, data) {
    state.base_price = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_489" /* SET_APPRAISALINVOICE_DISCOUNT_PCT */], function (state, data) {
    state.discount_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_490" /* SET_APPRAISALINVOICE_FINAL_PRICE */], function (state, data) {
    state.final_price = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_491" /* SET_APPRAISALINVOICE_FINAL_PRICE_INCL_VAT */], function (state, data) {
    state.final_price_incl_vat = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_492" /* SET_APPRAISALINVOICE_DISCOUNT_NOTES */], function (state, data) {
    state.discount_notes = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_493" /* SET_APPRAISALINVOICE_BANK_NAME */], function (state, data) {
    state.bank_name = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_494" /* SET_APPRAISALINVOICE_IBAN */], function (state, data) {
    state.iban = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_471" /* SET_APPRAISALINVOICE_FISCAL_NUMBER */], function (state, data) {
    state.fiscal_number = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_495" /* SET_APPRAISALINVOICE_SIGNATURE_NAME */], function (state, data) {
    state.signature_name = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_496" /* SET_APPRAISALINVOICE_SIGNATURE_BASE64 */], function (state, data) {
    state.signature_base64 = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_497" /* SET_APPRAISALINVOICE_SIGNATURE_DATE */], function (state, data) {
    state.signature_date = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_498" /* SET_APPRAISALINVOICE_SIGNATURE_EMAIL */], function (state, data) {
    state.signature_email = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_499" /* SET_APPRAISALINVOICE_SIGNATURE_UID */], function (state, data) {
    state.signature_uid = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_500" /* SET_APPRAISALINVOICE_IS_SIGNED */], function (state, data) {
    state.is_signed = data;
    state.dirty = true;
}), _mutations);

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

var getters = {

    appraisalinvoice: function appraisalinvoice(state) {
        return state;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    appraisalquotes: {}
};
var state = default_state;

var actions = {
    FETCH_APPRAISALINVOICE_APPRAISALQUOTES: function FETCH_APPRAISALINVOICE_APPRAISALQUOTES(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        // console.log('data.path (fetch_appraisalinvoice_appraisalquotes) ---->')
        // console.log(data.path)
        return new Promise(function (resolve, reject) {
            var appraisalquotes = null;

            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                // console.log(res)
                appraisalquotes = res;
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_342" /* SET_APPRAISALINVOICE_APPRAISALQUOTES */], appraisalquotes);
                resolve();
                // console.log('****** appraisalquotes: ')
                // console.log(appraisalquotes)
            });
        });
    }
};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__constants__["_342" /* SET_APPRAISALINVOICE_APPRAISALQUOTES */], function (state, data) {
    state.appraisalquotes = data;
});

var getters = {
    appraisalinvoice_appraisalquotes: function appraisalinvoice_appraisalquotes(state) {
        return state.appraisalquotes;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    lines: {}
};
var state = default_state;

var actions = {
    FETCH_APPRAISALINVOICE_LINES: function FETCH_APPRAISALINVOICE_LINES(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        // console.log('data.path (fetch_appraisalinvoice_lines) ---->')
        // console.log(data.path)
        return new Promise(function (resolve, reject) {
            var lines = null;

            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                // console.log(res)
                lines = res;
                // console.log('lines: ')
                // console.log(lines)

                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_343" /* SET_APPRAISALINVOICE_LINES */], lines);
                resolve();
                // console.log('****** lines: ')
                // console.log(lines)
            });
        });
    },
    SET_APPRAISALINVOICE_LINES: function SET_APPRAISALINVOICE_LINES(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_343" /* SET_APPRAISALINVOICE_LINES */], data);
    },
    UPDATE_APPRAISALINVOICE_LINES: function UPDATE_APPRAISALINVOICE_LINES(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;

        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                value: data.object,
                path: 'appraisalinvoices' + '/' + data.appraisalinvoice_id + '/' + 'lines',
                save_timestamp: false
            }).then(function (res) {
                resolve();
            });
        });
    }
};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__constants__["_343" /* SET_APPRAISALINVOICE_LINES */], function (state, data) {
    state.lines = data;
});

var getters = {
    appraisalinvoice_lines: function appraisalinvoice_lines(state) {
        return state.lines;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    petitioners: {}
};
var state = default_state;

var actions = {
    FETCH_APPRAISALINVOICE_PETITIONERS: function FETCH_APPRAISALINVOICE_PETITIONERS(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        // console.log('data.path (fetch_appraisalinvoice_petitioners) ---->')
        // console.log(data.path)
        return new Promise(function (resolve, reject) {
            var petitioners = null;

            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                // console.log(res)
                petitioners = res;
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_341" /* SET_APPRAISALINVOICE_PETITIONERS */], petitioners);
                resolve();
                // console.log('****** petitioners: ')
                // console.log(petitioners)
            });
        });
    }
};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__constants__["_341" /* SET_APPRAISALINVOICE_PETITIONERS */], function (state, data) {
    state.petitioners = data;
});

var getters = {
    appraisalinvoice_petitioners: function appraisalinvoice_petitioners(state) {
        return state.petitioners;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var default_state = {
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    path: null,
    description: null,
    number: null,
    full_number: null,
    quotedate: null,
    send_to_bde: false,
    title: null,
    vat_pct: 21,
    version: null,
    petitioner: null,
    petitioner_type: {
        id: 1,
        'name_ca': 'Altres persones físiques o jurídiques',
        'name_en': 'Other natural or legal persons',
        'name_es': 'Otras personas físicas o jurídicas'
    },
    entity: null,
    supervisor: {
        complete_name: 'López-Doriga, Ferran',
        id: '-L-K_d-_ZNBuuqfNtjJy',
        name: 'Ferran',
        path: 'supervisors',
        prof_assoc_reg_number: '9830-2',
        surnames: 'López-Doriga',
        tin: '46108653R'
    },
    appraiser: null,
    cover_photo_url: null,
    status: {
        id: 1,
        level: 1,
        progress_coef: 0.166,
        name_ca: '1/6 - Falta la firma del Director Financer (CFO)',
        name_es: '1/6 - Falta la firma del Director Financiero (CFO)',
        name_en: '1/6 - Needs to be signed by CFO'
    },
    bank_name: 'CAIXABANK',
    iban: 'ES09 2100 0911 01 0200176881',
    court_assistance_fees: 200,
    discount_pct: 0,
    discount_notes: null,
    final_price: 0,
    requireddoc: null,
    signature_name: null,
    signature_base64: null,
    signature_date: null,
    signature_email: null,
    signature_uid: null,
    purpose: null

};

var state = default_state;

var actions = {

    CREATE_NEW_APPRAISALQUOTE: function CREATE_NEW_APPRAISALQUOTE(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].create({ key: data.key, path: data.path }).then(function (res) {
                var new_created_key = res.key;
                var default_appraisalquotedate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(res.date_created, 'x').format('YYYY-MM-DD');

                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_501" /* SET_APPRAISALQUOTE_ID */], res.key);
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_502" /* SET_APPRAISALQUOTE_DATE_CREATED */], res.date_created);
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_503" /* SET_APPRAISALQUOTE_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_504" /* SET_APPRAISALQUOTE_NUMBER */], data.number);
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_505" /* SET_APPRAISALQUOTE_PATH */], res.path);
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_506" /* SET_APPRAISALQUOTE_PARENT_PATH */], data.parent_path);
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_507" /* SET_APPRAISALQUOTE_REPORTDATE */], default_appraisalquotedate);
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_508" /* SET_APPRAISALQUOTE_VERSION */], data.version);
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_509" /* SET_APPRAISALQUOTE_FULL_NUMBER */], data.full_number);
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_510" /* SET_APPRAISALQUOTE_FILE_ID */], data.file_id);

                // 1514764800 = 1 gener 2018 en unix timestamp

                var requireddocs_object = {
                    '1514764800': {
                        id: '1514764800',
                        name_ca: 'Nom, NIF i adreça del sol·licitant',
                        name_es: 'Nombre, NIF y dirección del solicitante',
                        name_en: 'Petitioner details: Name, tax identification number, ID and address'
                    },
                    '1514764801': {
                        id: '1514764801',
                        name_ca: 'Nom, NIF i adreça fiscal per a la factura',
                        name_es: 'Nombre, NIF y dirección fiscal para la factura',
                        name_en: 'Invoice details: Name, tax identification number and fiscal address'
                    },
                    '1514764802': {
                        id: '1514764802',
                        name_ca: 'Còpia completa de l\'escriptura o de la nota registral',
                        name_es: 'Copia completa de la escritura o de la nota registral',
                        name_en: 'Full copy of the property deed or registration note'
                    },
                    '1514764803': {
                        id: '1514764803',
                        name_ca: 'Còpia de rebut de l\'I.B.I. (Dades Cadastrals) (Opcional)',
                        name_es: 'Copia de recibo del I.B.I. (Datos Cadastrales) (Opcional)',
                        name_en: 'Property tax payment receipt copy (Cadastral data) (Optional)'
                    },
                    '1514764804': {
                        id: '1514764804',
                        name_ca: 'Plànol de la finca (Opcional)',
                        name_es: 'Plano de la finca (Opcional)',
                        name_en: 'Plan of the property (Optional)'
                    },
                    '1514764805': {
                        id: '1514764805',
                        name_ca: 'Còpia del contracte de lloguer i un rebut actualitzat (en el cas d\'estar llogat)',
                        name_es: 'Copia del contrato de alquiler y un recibo actualizado (en el caso de estar alquilado)',
                        name_en: 'Full copy of the rental contract and an updated receipt (in the event of being rented)'
                    },
                    '1514764806': {
                        id: '1514764806',
                        name_ca: 'Finalitat de la taxació (adquisició o venda, constituir garanties hipotecàries, expropiació,...)',
                        name_es: 'Finalidad de la tasación (adquisición o venta, constituir garantías hipotecarias, expropiación... )',
                        name_en: 'Valuation purpose (Acquisition or sale, to provide mortgage guarantees, expropiation...)'
                    },
                    '1514764807': {
                        id: '1514764807',
                        name_ca: 'Nom i telèfon de la persona de contacte per a visitar la finca',
                        name_es: 'Nombre y teléfono de la persona de contacto para visitar la finca',
                        name_en: 'Name and telephone number of the contact person in order to visit the property'
                    }
                };

                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                    value: res.key,
                    path: data.path + new_created_key + '/' + 'id',
                    save_timestamp: false
                }).then(function (res) {
                    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                        value: default_appraisalquotedate,
                        path: data.path + new_created_key + '/' + 'quotedate',
                        save_timestamp: false
                    }).then(function (res) {
                        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                            value: data.file_id,
                            path: data.path + new_created_key + '/' + 'file_id',
                            save_timestamp: false
                        }).then(function (res) {
                            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                                value: data.number,
                                path: data.path + new_created_key + '/' + 'number',
                                save_timestamp: false
                            }).then(function (res) {
                                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                                    value: data.version,
                                    path: data.path + new_created_key + '/' + 'version',
                                    save_timestamp: false
                                }).then(function (res) {
                                    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                                        value: data.full_number,
                                        path: data.path + new_created_key + '/' + 'full_number',
                                        save_timestamp: false
                                    }).then(function (res) {
                                        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                                            value: data.parent_path,
                                            path: data.path + new_created_key + '/' + 'parent_path',
                                            save_timestamp: false
                                        }).then(function (res) {
                                            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                                                value: requireddocs_object,
                                                path: data.path + new_created_key + '/' + 'requireddocs',
                                                save_timestamp: false
                                            }).then(function (res) {
                                                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                                                    value: default_appraisalquotedate,
                                                    path: data.path + new_created_key + '/' + 'quotedate',
                                                    save_timestamp: false
                                                }).then(function (res) {
                                                    var object = {};
                                                    object[new_created_key] = {
                                                        description: '',
                                                        id: new_created_key,
                                                        number: data.number,
                                                        version: data.version,
                                                        full_number: data.full_number
                                                    };
                                                    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({
                                                        object: object,
                                                        path: data.parent_path,
                                                        save_timestamp: false
                                                    }).then(function (res) {
                                                        return resolve({ key: new_created_key });
                                                    });
                                                });
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    });
                });
            });
        });
    },
    DELETE_APPRAISALQUOTE: function DELETE_APPRAISALQUOTE(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;


        // console.log('DELETE_APPRAISALQUOTE path check: ' + data.path)
        // console.log('DELETE APPRAISALQUOTE parent_path check: ' + data.parent_path)

        // delete from appraisalquotes/appraisalquote_key
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.path }).then(function (res) {

            var date_modified = res.date_modified;

            // delete from appraisalfiles/appraisalfile_key/appraisalquotes/appraisalquote_key
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.parent_path }).then(function (res) {
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_511" /* RESET_APPRAISALQUOTE */]);

                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                    value: date_modified,
                    path: 'appraisalfiles' + '/' + data.file_id + '/' + 'date_modified',
                    save_timestamp: false
                }).then(function (res) {});
            });
        });
    },
    GET_APPRAISALQUOTE: function GET_APPRAISALQUOTE(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;


        return new Promise(function (resolve, reject) {
            return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                return resolve(res);
            });
        });
    },
    SET_APPRAISALQUOTE: function SET_APPRAISALQUOTE(_ref4, data) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;


        // console.log('set_appraisalquote data:')
        // console.log(data)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_512" /* SET_APPRAISALQUOTE */], res);
        });
    },
    RESET_APPRAISALQUOTE: function RESET_APPRAISALQUOTE(_ref5) {
        var state = _ref5.state,
            commit = _ref5.commit,
            rootState = _ref5.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_511" /* RESET_APPRAISALQUOTE */]);
    },
    SET_APPRAISALQUOTE_REPORTDATE: function SET_APPRAISALQUOTE_REPORTDATE(_ref6, data) {
        var state = _ref6.state,
            commit = _ref6.commit,
            rootState = _ref6.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_507" /* SET_APPRAISALQUOTE_REPORTDATE */], data);
    },
    SET_APPRAISALQUOTE_DATE_CREATED: function SET_APPRAISALQUOTE_DATE_CREATED(_ref7, data) {
        var state = _ref7.state,
            commit = _ref7.commit,
            rootState = _ref7.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_502" /* SET_APPRAISALQUOTE_DATE_CREATED */], data);
    },
    SET_APPRAISALQUOTE_DATE_MODIFIED: function SET_APPRAISALQUOTE_DATE_MODIFIED(_ref8, data) {
        var state = _ref8.state,
            commit = _ref8.commit,
            rootState = _ref8.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_503" /* SET_APPRAISALQUOTE_DATE_MODIFIED */], data);
    },

    SET_APPRAISALQUOTE_FILE_ID: function SET_APPRAISALQUOTE_FILE_ID(_ref9, data) {
        var state = _ref9.state,
            commit = _ref9.commit,
            rootState = _ref9.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_510" /* SET_APPRAISALQUOTE_FILE_ID */], data);
    },
    SET_APPRAISALQUOTE_ID: function SET_APPRAISALQUOTE_ID(_ref10, data) {
        var state = _ref10.state,
            commit = _ref10.commit,
            rootState = _ref10.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_501" /* SET_APPRAISALQUOTE_ID */], data);
    },
    SET_APPRAISALQUOTE_NUMBER: function SET_APPRAISALQUOTE_NUMBER(_ref11, data) {
        var state = _ref11.state,
            commit = _ref11.commit,
            rootState = _ref11.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_504" /* SET_APPRAISALQUOTE_NUMBER */], data);
    },
    SET_APPRAISALQUOTE_FULL_NUMBER: function SET_APPRAISALQUOTE_FULL_NUMBER(_ref12, data) {
        var state = _ref12.state,
            commit = _ref12.commit,
            rootState = _ref12.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_509" /* SET_APPRAISALQUOTE_FULL_NUMBER */], data);
    },
    SET_APPRAISALQUOTE_PARENT_PATH: function SET_APPRAISALQUOTE_PARENT_PATH(_ref13, data) {
        var state = _ref13.state,
            commit = _ref13.commit,
            rootState = _ref13.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_506" /* SET_APPRAISALQUOTE_PARENT_PATH */], data);
    },
    SET_APPRAISALQUOTE_PATH: function SET_APPRAISALQUOTE_PATH(_ref14, data) {
        var state = _ref14.state,
            commit = _ref14.commit,
            rootState = _ref14.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_505" /* SET_APPRAISALQUOTE_PATH */], data);
    },
    SET_APPRAISALQUOTE_SEND_TO_BDE: function SET_APPRAISALQUOTE_SEND_TO_BDE(_ref15, data) {
        var state = _ref15.state,
            commit = _ref15.commit,
            rootState = _ref15.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_513" /* SET_APPRAISALQUOTE_SEND_TO_BDE */], data);
    },
    SET_APPRAISALQUOTE_TITLE: function SET_APPRAISALQUOTE_TITLE(_ref16, data) {
        var state = _ref16.state,
            commit = _ref16.commit,
            rootState = _ref16.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_514" /* SET_APPRAISALQUOTE_TITLE */], data);
    },
    SET_APPRAISALQUOTE_VERSION: function SET_APPRAISALQUOTE_VERSION(_ref17, data) {
        var state = _ref17.state,
            commit = _ref17.commit,
            rootState = _ref17.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_508" /* SET_APPRAISALQUOTE_VERSION */], data);
    },
    UPDATE_APPRAISALQUOTE: function UPDATE_APPRAISALQUOTE(_ref18, data) {
        var state = _ref18.state,
            commit = _ref18.commit,
            rootState = _ref18.rootState;

        return new Promise(function (resolve, reject) {
            // console.log('UPDATE_APPRAISALQUOTE data:')
            // console.log(data)
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({ object: data.object, path: data.path + data.key, save_timestamp: true }).then(function (res) {

                var date_modified = res.date_modified;
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_503" /* SET_APPRAISALQUOTE_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_515" /* SET_APPRAISALQUOTE_DIRTYNESS */], false);

                var parent_object = {};

                parent_object = {
                    description: data.object.description,
                    id: data.object.id,
                    date_modified: res.date_modified,
                    number: data.object.number,
                    version: data.object.version,
                    full_number: data.object.full_number,
                    send_to_bde: data.object.send_to_bde
                };
                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({ object: parent_object, path: data.parent_path + data.key, save_timestamp: false }).then(function (res) {

                    // update file date_modified
                    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                        value: date_modified,
                        path: 'appraisalfiles' + '/' + data.object.file_id + '/' + 'date_modified',
                        save_timestamp: false
                    }).then(function (res) {
                        return resolve({ key: res.key });
                    });
                });
            });
        });
    },
    SET_APPRAISALQUOTE_REALESTATE_APPRAISAL_ID: function SET_APPRAISALQUOTE_REALESTATE_APPRAISAL_ID(_ref19, data) {
        var state = _ref19.state,
            commit = _ref19.commit,
            rootState = _ref19.rootState;

        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                value: data.value,
                path: data.path,
                save_timestamp: false
            }).then(function () {
                resolve();
            });
        });
    },
    UPDATE_APPRAISALQUOTE_REALESTATE_APPRAISAL_ID: function UPDATE_APPRAISALQUOTE_REALESTATE_APPRAISAL_ID(_ref20, data) {
        var state = _ref20.state,
            commit = _ref20.commit,
            rootState = _ref20.rootState;

        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                value: data.appraisal_id,
                path: 'appraisalquotes' + '/' + data.appraisalquote_id + '/' + 'realestates' + '/' + data.realestate_id + '/' + 'appraisal_id',
                save_timestamp: false
            });
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                value: data.appraisaldate,
                path: 'appraisalquotes' + '/' + data.appraisalquote_id + '/' + 'realestates' + '/' + data.realestate_id + '/' + 'appraisals' + '/' + data.appraisal_id + '/' + 'appraisaldate',
                save_timestamp: false
            });
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                value: data.appraisal_id,
                path: 'appraisalquotes' + '/' + data.appraisalquote_id + '/' + 'realestates' + '/' + data.realestate_id + '/' + 'appraisals' + '/' + data.appraisal_id + '/' + 'id',
                save_timestamp: false
            }).then(function () {
                resolve();
            });
        });
    },
    SET_APPRAISALQUOTE_DESCRIPTION: function SET_APPRAISALQUOTE_DESCRIPTION(_ref21, data) {
        var state = _ref21.state,
            commit = _ref21.commit,
            rootState = _ref21.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_516" /* SET_APPRAISALQUOTE_DESCRIPTION */], data);
    },
    SET_APPRAISALQUOTE_PETITIONER: function SET_APPRAISALQUOTE_PETITIONER(_ref22, data) {
        var state = _ref22.state,
            commit = _ref22.commit,
            rootState = _ref22.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_517" /* SET_APPRAISALQUOTE_PETITIONER */], data);
    },
    SET_APPRAISALQUOTE_PETITIONER_TYPE: function SET_APPRAISALQUOTE_PETITIONER_TYPE(_ref23, data) {
        var state = _ref23.state,
            commit = _ref23.commit,
            rootState = _ref23.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_518" /* SET_APPRAISALQUOTE_PETITIONER_TYPE */], data);
    },
    SET_APPRAISALQUOTE_ENTITY: function SET_APPRAISALQUOTE_ENTITY(_ref24, data) {
        var state = _ref24.state,
            commit = _ref24.commit,
            rootState = _ref24.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_519" /* SET_APPRAISALQUOTE_ENTITY */], data);
    },
    SET_APPRAISALQUOTE_SUPERVISOR: function SET_APPRAISALQUOTE_SUPERVISOR(_ref25, data) {
        var state = _ref25.state,
            commit = _ref25.commit,
            rootState = _ref25.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_520" /* SET_APPRAISALQUOTE_SUPERVISOR */], data);
    },
    SET_APPRAISALQUOTE_APPRAISER: function SET_APPRAISALQUOTE_APPRAISER(_ref26, data) {
        var state = _ref26.state,
            commit = _ref26.commit,
            rootState = _ref26.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_521" /* SET_APPRAISALQUOTE_APPRAISER */], data);
    },
    SET_APPRAISALQUOTE_COVER_PHOTO_URL: function SET_APPRAISALQUOTE_COVER_PHOTO_URL(_ref27, data) {
        var state = _ref27.state,
            commit = _ref27.commit,
            rootState = _ref27.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_522" /* SET_APPRAISALQUOTE_COVER_PHOTO_URL */], data);
    },
    SET_APPRAISALQUOTE_VAT_PCT: function SET_APPRAISALQUOTE_VAT_PCT(_ref28, data) {
        var state = _ref28.state,
            commit = _ref28.commit,
            rootState = _ref28.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_523" /* SET_APPRAISALQUOTE_VAT_PCT */], data);
    },
    SET_APPRAISALQUOTE_STATUS: function SET_APPRAISALQUOTE_STATUS(_ref29, data) {
        var state = _ref29.state,
            commit = _ref29.commit,
            rootState = _ref29.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_524" /* SET_APPRAISALQUOTE_STATUS */], data);
    },
    SET_APPRAISALQUOTE_BANK_NAME: function SET_APPRAISALQUOTE_BANK_NAME(_ref30, data) {
        var state = _ref30.state,
            commit = _ref30.commit,
            rootState = _ref30.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_525" /* SET_APPRAISALQUOTE_BANK_NAME */], data);
    },
    SET_APPRAISALQUOTE_IBAN: function SET_APPRAISALQUOTE_IBAN(_ref31, data) {
        var state = _ref31.state,
            commit = _ref31.commit,
            rootState = _ref31.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_526" /* SET_APPRAISALQUOTE_IBAN */], data);
    },
    SET_APPRAISALQUOTE_COURT_ASSISTANCE_FEES: function SET_APPRAISALQUOTE_COURT_ASSISTANCE_FEES(_ref32, data) {
        var state = _ref32.state,
            commit = _ref32.commit,
            rootState = _ref32.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_527" /* SET_APPRAISALQUOTE_COURT_ASSISTANCE_FEES */], data);
    },
    SET_APPRAISALQUOTE_DISCOUNT_PCT: function SET_APPRAISALQUOTE_DISCOUNT_PCT(_ref33, data) {
        var state = _ref33.state,
            commit = _ref33.commit,
            rootState = _ref33.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_528" /* SET_APPRAISALQUOTE_DISCOUNT_PCT */], data);
    },
    SET_APPRAISALQUOTE_DISCOUNT_NOTES: function SET_APPRAISALQUOTE_DISCOUNT_NOTES(_ref34, data) {
        var state = _ref34.state,
            commit = _ref34.commit,
            rootState = _ref34.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_529" /* SET_APPRAISALQUOTE_DISCOUNT_NOTES */], data);
    },
    SET_APPRAISALQUOTE_FINAL_PRICE: function SET_APPRAISALQUOTE_FINAL_PRICE(_ref35, data) {
        var state = _ref35.state,
            commit = _ref35.commit,
            rootState = _ref35.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_530" /* SET_APPRAISALQUOTE_FINAL_PRICE */], data);
    },
    SET_APPRAISALQUOTE_REQUIREDDOC: function SET_APPRAISALQUOTE_REQUIREDDOC(_ref36, data) {
        var state = _ref36.state,
            commit = _ref36.commit,
            rootState = _ref36.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_531" /* SET_APPRAISALQUOTE_REQUIREDDOC */], data);
    },
    SET_APPRAISALQUOTE_SIGNATURE_NAME: function SET_APPRAISALQUOTE_SIGNATURE_NAME(_ref37, data) {
        var state = _ref37.state,
            commit = _ref37.commit,
            rootState = _ref37.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_532" /* SET_APPRAISALQUOTE_SIGNATURE_NAME */], data);
    },
    SET_APPRAISALQUOTE_SIGNATURE_BASE64: function SET_APPRAISALQUOTE_SIGNATURE_BASE64(_ref38, data) {
        var state = _ref38.state,
            commit = _ref38.commit,
            rootState = _ref38.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_533" /* SET_APPRAISALQUOTE_SIGNATURE_BASE64 */], data);
    },
    SET_APPRAISALQUOTE_SIGNATURE_DATE: function SET_APPRAISALQUOTE_SIGNATURE_DATE(_ref39, data) {
        var state = _ref39.state,
            commit = _ref39.commit,
            rootState = _ref39.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_534" /* SET_APPRAISALQUOTE_SIGNATURE_DATE */], data);
    },
    SET_APPRAISALQUOTE_SIGNATURE_EMAIL: function SET_APPRAISALQUOTE_SIGNATURE_EMAIL(_ref40, data) {
        var state = _ref40.state,
            commit = _ref40.commit,
            rootState = _ref40.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_535" /* SET_APPRAISALQUOTE_SIGNATURE_EMAIL */], data);
    },
    SET_APPRAISALQUOTE_SIGNATURE_UID: function SET_APPRAISALQUOTE_SIGNATURE_UID(_ref41, data) {
        var state = _ref41.state,
            commit = _ref41.commit,
            rootState = _ref41.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_536" /* SET_APPRAISALQUOTE_SIGNATURE_UID */], data);
    },
    SET_APPRAISALQUOTE_PURPOSE: function SET_APPRAISALQUOTE_PURPOSE(_ref42, data) {
        var state = _ref42.state,
            commit = _ref42.commit,
            rootState = _ref42.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_537" /* SET_APPRAISALQUOTE_PURPOSE */], data);
    }

};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_511" /* RESET_APPRAISALQUOTE */], function (state) {
    state.date_created = null;
    state.date_modified = null;
    state.dirty = false;
    state.file_id = null;
    state.id = null;
    state.number = null;
    state.full_number = null;
    state.path = null;
    state.parent_path = null;
    state.description = null;
    state.quotedate = null;
    state.send_to_bde = null;
    state.title = null;
    state.version = null;
    state.petitioner = null;
    state.petitioner_type = {
        id: 1,
        'name_ca': 'Altres persones físiques o jurídiques',
        'name_en': 'Other natural or legal persons',
        'name_es': 'Otras personas físicas o jurídicas'
    };
    state.entity = null;
    state.supervisor = null;
    state.appraiser = null;
    state.cover_photo_url = null;
    state.vat_pct = 21;
    state.status = {
        id: 1,
        level: 1,
        progress_coef: 0.166,
        name_ca: '1/6 - Falta la firma del Director Financer (CFO)',
        name_es: '1/6 - Falta la firma del Director Financiero (CFO)',
        name_en: '1/6 - Needs to be signed by CFO'
    };
    state.bank_name = 'CAIXABANK';
    state.iban = 'ES09 2100 0911 01 0200176881';
    state.court_assistance_fees = 200;
    state.discount_pct = 0;
    state.discount_notes = null;
    state.final_price = 0;
    state.requireddoc = null;
    state.signature_name = null;
    state.signature_base64 = null;
    state.signature_date = null;
    state.signature_email = null;
    state.signature_uid = null;
    state.purpose = null;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_512" /* SET_APPRAISALQUOTE */], function (state, data) {
    state.date_created = check_undefined(data.date_created);
    state.date_modified = check_undefined(data.date_modified);
    state.dirty = false;
    state.file_id = check_undefined(data.file_id);
    state.id = check_undefined(data.id);
    state.number = check_undefined(data.number);
    state.full_number = check_undefined(data.full_number);
    state.path = check_undefined(data.path);
    state.parent_path = check_undefined(data.parent_path);
    state.description = check_undefined(data.description);
    state.quotedate = check_undefined(data.quotedate);
    state.send_to_bde = check_undefined(data.send_to_bde);
    state.title = check_undefined(data.title);
    state.version = check_undefined(data.version);
    state.petitioner = check_undefined(data.petitioner);
    state.petitioner_type = check_undefined(data.petitioner_type);
    state.entity = check_undefined(data.entity);
    state.supervisor = check_undefined(data.supervisor);
    state.appraiser = check_undefined(data.appraiser);
    state.cover_photo_url = check_undefined(data.cover_photo_url);
    state.vat_pct = check_undefined(data.vat_pct);
    state.status = check_undefined(data.status);
    state.bank_name = check_undefined(data.bank_name);
    state.iban = check_undefined(data.iban);
    state.court_assistance_fees = check_undefined(data.court_assistance_fees);
    state.discount_pct = check_undefined(data.discount_pct);
    state.discount_notes = check_undefined(data.discount_notes);
    state.final_price = check_undefined(data.final_price);
    state.requireddoc = check_undefined(data.requireddoc);
    state.signature_name = check_undefined(data.signature_name);
    state.signature_base64 = check_undefined(data.signature_base64);
    state.signature_date = check_undefined(data.signature_date);
    state.signature_email = check_undefined(data.signature_email);
    state.signature_uid = check_undefined(data.signature_uid);
    state.purpose = check_undefined(data.purpose);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_502" /* SET_APPRAISALQUOTE_DATE_CREATED */], function (state, data) {
    state.date_created = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_503" /* SET_APPRAISALQUOTE_DATE_MODIFIED */], function (state, data) {
    state.date_modified = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_515" /* SET_APPRAISALQUOTE_DIRTYNESS */], function (state, boolean) {
    state.dirty = boolean;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_510" /* SET_APPRAISALQUOTE_FILE_ID */], function (state, data) {
    state.file_id = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_501" /* SET_APPRAISALQUOTE_ID */], function (state, data) {
    state.id = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_504" /* SET_APPRAISALQUOTE_NUMBER */], function (state, data) {
    state.number = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_509" /* SET_APPRAISALQUOTE_FULL_NUMBER */], function (state, data) {
    state.full_number = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_506" /* SET_APPRAISALQUOTE_PARENT_PATH */], function (state, data) {
    state.parent_path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_505" /* SET_APPRAISALQUOTE_PATH */], function (state, data) {
    state.path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_507" /* SET_APPRAISALQUOTE_REPORTDATE */], function (state, data) {
    state.quotedate = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_514" /* SET_APPRAISALQUOTE_TITLE */], function (state, data) {
    state.title = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_516" /* SET_APPRAISALQUOTE_DESCRIPTION */], function (state, data) {
    state.description = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_508" /* SET_APPRAISALQUOTE_VERSION */], function (state, data) {
    state.version = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_517" /* SET_APPRAISALQUOTE_PETITIONER */], function (state, data) {
    state.petitioner = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_518" /* SET_APPRAISALQUOTE_PETITIONER_TYPE */], function (state, data) {
    state.petitioner_type = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_519" /* SET_APPRAISALQUOTE_ENTITY */], function (state, data) {
    state.entity = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_520" /* SET_APPRAISALQUOTE_SUPERVISOR */], function (state, data) {
    state.supervisor = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_521" /* SET_APPRAISALQUOTE_APPRAISER */], function (state, data) {
    state.appraiser = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_522" /* SET_APPRAISALQUOTE_COVER_PHOTO_URL */], function (state, data) {
    state.cover_photo_url = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_523" /* SET_APPRAISALQUOTE_VAT_PCT */], function (state, data) {
    state.vat_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_524" /* SET_APPRAISALQUOTE_STATUS */], function (state, data) {
    state.status = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_525" /* SET_APPRAISALQUOTE_BANK_NAME */], function (state, data) {
    state.bank_name = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_526" /* SET_APPRAISALQUOTE_IBAN */], function (state, data) {
    state.iban = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_527" /* SET_APPRAISALQUOTE_COURT_ASSISTANCE_FEES */], function (state, data) {
    state.court_assistance_fees = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_528" /* SET_APPRAISALQUOTE_DISCOUNT_PCT */], function (state, data) {
    state.discount_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_529" /* SET_APPRAISALQUOTE_DISCOUNT_NOTES */], function (state, data) {
    state.discount_notes = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_530" /* SET_APPRAISALQUOTE_FINAL_PRICE */], function (state, data) {
    state.final_price = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_531" /* SET_APPRAISALQUOTE_REQUIREDDOC */], function (state, data) {
    state.requireddoc = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_532" /* SET_APPRAISALQUOTE_SIGNATURE_NAME */], function (state, data) {
    state.signature_name = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_533" /* SET_APPRAISALQUOTE_SIGNATURE_BASE64 */], function (state, data) {
    state.signature_base64 = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_534" /* SET_APPRAISALQUOTE_SIGNATURE_DATE */], function (state, data) {
    state.signature_date = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_535" /* SET_APPRAISALQUOTE_SIGNATURE_EMAIL */], function (state, data) {
    state.signature_email = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_536" /* SET_APPRAISALQUOTE_SIGNATURE_UID */], function (state, data) {
    state.signature_uid = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_537" /* SET_APPRAISALQUOTE_PURPOSE */], function (state, data) {
    state.purpose = data;
    state.dirty = true;
}), _mutations);

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

var getters = {

    appraisalquote: function appraisalquote(state) {
        return state;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    petitioners: {},
    temp_quote_petitioners: {}
};
var state = default_state;

var actions = {
    FETCH_APPRAISALQUOTE_PETITIONERS: function FETCH_APPRAISALQUOTE_PETITIONERS(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        // console.log('data.path (fetch_appraisalquote_petitioners) ---->')
        // console.log(data.path)
        return new Promise(function (resolve, reject) {
            var petitioners = null;

            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                // console.log(res)
                petitioners = res;
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_347" /* SET_APPRAISALQUOTE_PETITIONERS */], petitioners);
                resolve();
                // console.log('****** petitioners: ')
                // console.log(petitioners)
            });
        });
    },
    FETCH_TEMP_APPRAISALQUOTE_PETITIONERS: function FETCH_TEMP_APPRAISALQUOTE_PETITIONERS(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;


        // console.log('data.path (fetch_appraisalquote_petitioners) ---->')
        // console.log(data.path)
        return new Promise(function (resolve, reject) {
            var petitioners = null;

            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                // console.log(res)
                petitioners = res;
                // console.log('petitioners: ')
                // console.log(petitioners)

                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_348" /* SET_TEMP_APPRAISALQUOTE_PETITIONERS */], petitioners);
                resolve();
                // console.log('****** petitioners: ')
                // console.log(petitioners)
            });
        });
    }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_347" /* SET_APPRAISALQUOTE_PETITIONERS */], function (state, data) {
    state.petitioners = data;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_348" /* SET_TEMP_APPRAISALQUOTE_PETITIONERS */], function (state, data) {
    state.temp_quote_petitioners = data;
}), _mutations);

var getters = {
    appraisalquote_petitioners: function appraisalquote_petitioners(state) {
        return state.petitioners;
    },
    temp_quote_petitioners: function temp_quote_petitioners(state) {
        return state.temp_quote_petitioners;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    realestates: {},
    temp_quote_realestates: {}
};
var state = default_state;

var actions = {
    FETCH_APPRAISALQUOTE_REALESTATES: function FETCH_APPRAISALQUOTE_REALESTATES(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        // console.log('data.path (fetch_appraisalquote_realestates) ---->')
        // console.log(data.path)
        return new Promise(function (resolve, reject) {
            var realestates = null;

            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                // console.log(res)
                realestates = res;
                // console.log('realestates: ')
                // console.log(realestates)


                /*
                // Esborrar aquest tros? Sembla copiat d'appraisalreport i no te sentit aquí.
                _.forEach(realestates, (value, key) => {
                    let realestate_id = value['id']
                     // console.log('>> realestate:')
                    // console.log(value)
                     api.get({path: 'realestate_appraisals' + '/' + value['id']})
                        .then((res) => {
                            let appraisals = res
                            _.forEach(appraisals, (value2, key2) => {
                                 let appraisal_id = value2['id']
                                let obj = {}
                                obj['appraisaldate'] = value2['appraisaldate']
                                obj['id'] = value2['id']
                                 if (value2['realestate_total_adopted_value']) {
                                    obj['realestate_total_adopted_value'] = value2['realestate_total_adopted_value']
                                } else {
                                    obj['realestate_total_adopted_value'] = null
                                }
                                  // console.log('>>>> obj: ')
                                // console.log(obj)
                                 api.set_value({
                                    value: obj,
                                    path: 'appraisalquotes' + '/' + data.appraisalquote_id + '/' + 'realestates' + '/' + realestate_id + '/' + 'appraisals' + '/' + appraisal_id,
                                    save_timestamp: false
                                })
                                 realestates[realestate_id]['appraisals'][appraisal_id] = obj
                                 if(value['appraisal_id'] === appraisal_id){
                                    api.set_value({
                                        value: obj['id'],
                                        path: 'appraisalquotes' + '/' + data.appraisalquote_id + '/' + 'realestates' + '/' + realestate_id + '/' + 'appraisal_id',
                                        save_timestamp: false
                                    })
                                    api.set_value({
                                        value: obj['appraisaldate'],
                                        path: 'appraisalquotes' + '/' + data.appraisalquote_id + '/' + 'realestates' + '/' + realestate_id + '/' + 'appraisaldate',
                                        save_timestamp: false
                                    })
                                    api.set_value({
                                        value: obj['realestate_total_adopted_value'],
                                        path: 'appraisalquotes' + '/' + data.appraisalquote_id + '/' + 'realestates' + '/' + realestate_id + '/' + 'realestate_total_adopted_value',
                                        save_timestamp: false
                                    })
                                     realestates[realestate_id]['appraisal_id'] = obj['id']
                                    realestates[realestate_id]['appraisaldate'] = obj['appraisaldate']
                                    realestates[realestate_id]['realestate_total_adopted_value'] = obj['realestate_total_adopted_value']
                                }
                               })
                         })
                 })
                */
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_345" /* SET_APPRAISALQUOTE_REALESTATES */], realestates);
                resolve();
                // console.log('****** realestates: ')
                // console.log(realestates)
            });
        });
    },
    FETCH_TEMP_APPRAISALQUOTE_REALESTATES: function FETCH_TEMP_APPRAISALQUOTE_REALESTATES(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;


        // console.log('data.path (fetch_appraisalquote_realestates) ---->')
        // console.log(data.path)
        return new Promise(function (resolve, reject) {
            var realestates = null;

            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                // console.log(res)
                realestates = res;
                // console.log('realestates: ')
                // console.log(realestates)

                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_346" /* SET_TEMP_APPRAISALQUOTE_REALESTATES */], realestates);
                resolve();
                // console.log('****** realestates: ')
                // console.log(realestates)
            });
        });
    }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_345" /* SET_APPRAISALQUOTE_REALESTATES */], function (state, data) {
    state.realestates = data;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_346" /* SET_TEMP_APPRAISALQUOTE_REALESTATES */], function (state, data) {
    state.temp_quote_realestates = data;
}), _mutations);

var getters = {
    appraisalquote_realestates: function appraisalquote_realestates(state) {
        return state.realestates;
    },
    temp_quote_realestates: function temp_quote_realestates(state) {
        return state.temp_quote_realestates;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    requireddocs: {}
};
var state = default_state;

var actions = {
    FETCH_APPRAISALQUOTE_REQUIREDDOCS: function FETCH_APPRAISALQUOTE_REQUIREDDOCS(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        // console.log('data.path (fetch_appraisalquote_requireddocs) ---->')
        // console.log(data.path)
        return new Promise(function (resolve, reject) {
            var requireddocs = null;

            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                // console.log(res)
                requireddocs = res;
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_344" /* SET_APPRAISALQUOTE_REQUIREDDOCS */], requireddocs);
                resolve();
                // console.log('****** requireddocs: ')
                // console.log(requireddocs)
            });
        });
    }
};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__constants__["_344" /* SET_APPRAISALQUOTE_REQUIREDDOCS */], function (state, data) {
    state.requireddocs = data;
});

var getters = {
    appraisalquote_requireddocs: function appraisalquote_requireddocs(state) {
        return state.requireddocs;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var default_state = {
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    path: null,
    description: null,
    number: null,
    full_number: null,
    reportdate: null,
    send_to_bde: false,
    title: null,
    version: null,
    petitioner: null,
    petitioner_type: {
        id: 1,
        'name_ca': 'Altres persones físiques o jurídiques',
        'name_en': 'Other natural or legal persons',
        'name_es': 'Otras personas físicas o jurídicas'
    },
    entity: null,
    supervisor: {
        complete_name: 'López-Doriga, Ferran',
        id: '-L-K_d-_ZNBuuqfNtjJy',
        name: 'Ferran',
        path: 'supervisors',
        prof_assoc_reg_number: '9830-2',
        surnames: 'López-Doriga',
        tin: '46108653R'
    },
    appraiser: null,
    cover_photo_url: null,
    status: {
        id: 1,
        level: 1,
        progress_coef: 0.166,
        name_ca: '1/6 - Falta la firma del Taxador',
        name_es: '1/6 - Falta la firma del Tasador',
        name_en: '1/6 - Needs to be signed by Appraiser'
    },
    signature_sv_name: null,
    signature_sv_base64: null,
    signature_sv_date: null,
    signature_sv_email: null,
    signature_sv_uid: null,
    signature_ap_name: null,
    signature_ap_base64: null,
    signature_ap_date: null,
    signature_ap_email: null,
    signature_ap_uid: null,
    is_signed: null,
    is_sv_signed: null,
    is_ap_signed: null

};

var state = default_state;

var actions = {

    CREATE_NEW_APPRAISALREPORT: function CREATE_NEW_APPRAISALREPORT(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].create({ key: data.key, path: data.path }).then(function (res) {
                var new_created_key = res.key;
                var default_appraisalreportdate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(res.date_created, 'x').format('YYYY-MM-DD');

                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_538" /* SET_APPRAISALREPORT_ID */], res.key);
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_539" /* SET_APPRAISALREPORT_DATE_CREATED */], res.date_created);
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_540" /* SET_APPRAISALREPORT_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_541" /* SET_APPRAISALREPORT_NUMBER */], data.number);
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_542" /* SET_APPRAISALREPORT_FULL_NUMBER */], data.full_number);
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_543" /* SET_APPRAISALREPORT_PATH */], res.path);
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_544" /* SET_APPRAISALREPORT_PARENT_PATH */], data.parent_path);
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_545" /* SET_APPRAISALREPORT_REPORTDATE */], default_appraisalreportdate);
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_546" /* SET_APPRAISALREPORT_VERSION */], data.version);
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_547" /* SET_APPRAISALREPORT_FILE_ID */], data.file_id);

                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                    value: res.key,
                    path: data.path + new_created_key + '/' + 'id',
                    save_timestamp: false
                }).then(function (res) {
                    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                        value: default_appraisalreportdate,
                        path: data.path + new_created_key + '/' + 'reportdate',
                        save_timestamp: false
                    }).then(function (res) {
                        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                            value: data.file_id,
                            path: data.path + new_created_key + '/' + 'file_id',
                            save_timestamp: false
                        }).then(function (res) {
                            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                                value: data.number,
                                path: data.path + new_created_key + '/' + 'number',
                                save_timestamp: false
                            }).then(function (res) {
                                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                                    value: data.full_number,
                                    path: data.path + new_created_key + '/' + 'full_number',
                                    save_timestamp: false
                                }).then(function (res) {
                                    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                                        value: data.parent_path,
                                        path: data.path + new_created_key + '/' + 'parent_path',
                                        save_timestamp: false
                                    }).then(function (res) {
                                        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                                            value: data.version,
                                            path: data.path + new_created_key + '/' + 'version',
                                            save_timestamp: false
                                        }).then(function (res) {
                                            var object = {};
                                            object[new_created_key] = {
                                                description: '',
                                                id: new_created_key,
                                                number: data.number,
                                                version: data.version
                                            };
                                            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({
                                                object: object,
                                                path: data.parent_path,
                                                save_timestamp: false
                                            }).then(function (res) {
                                                return resolve({ key: new_created_key });
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    });
                });
            });
        });
    },
    DELETE_APPRAISALREPORT: function DELETE_APPRAISALREPORT(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;


        // console.log('DELETE_APPRAISALREPORT path check: ' + data.path)
        // console.log('DELETE APPRAISALREPORT parent_path check: ' + data.parent_path)

        // delete from appraisalreports/appraisalreport_key
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.path }).then(function (res) {

            var date_modified = res.date_modified;

            // delete from appraisalfiles/appraisalfile_key/appraisalreports/appraisalreport_key
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.parent_path }).then(function (res) {
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_548" /* RESET_APPRAISALREPORT */]);

                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                    value: date_modified,
                    path: 'appraisalfiles' + '/' + data.file_id + '/' + 'date_modified',
                    save_timestamp: false
                }).then(function (res) {});
            });
        });
    },
    GET_APPRAISALREPORT: function GET_APPRAISALREPORT(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;


        return new Promise(function (resolve, reject) {
            return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                return resolve(res);
            });
        });
    },
    SET_APPRAISALREPORT: function SET_APPRAISALREPORT(_ref4, data) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;


        // console.log('set_appraisalreport data:')
        // console.log(data)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_549" /* SET_APPRAISALREPORT */], res);
        });
    },
    RESET_APPRAISALREPORT: function RESET_APPRAISALREPORT(_ref5) {
        var state = _ref5.state,
            commit = _ref5.commit,
            rootState = _ref5.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_548" /* RESET_APPRAISALREPORT */]);
    },
    SET_APPRAISALREPORT_REPORTDATE: function SET_APPRAISALREPORT_REPORTDATE(_ref6, data) {
        var state = _ref6.state,
            commit = _ref6.commit,
            rootState = _ref6.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_545" /* SET_APPRAISALREPORT_REPORTDATE */], data);
    },
    SET_APPRAISALREPORT_DATE_CREATED: function SET_APPRAISALREPORT_DATE_CREATED(_ref7, data) {
        var state = _ref7.state,
            commit = _ref7.commit,
            rootState = _ref7.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_539" /* SET_APPRAISALREPORT_DATE_CREATED */], data);
    },
    SET_APPRAISALREPORT_DATE_MODIFIED: function SET_APPRAISALREPORT_DATE_MODIFIED(_ref8, data) {
        var state = _ref8.state,
            commit = _ref8.commit,
            rootState = _ref8.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_540" /* SET_APPRAISALREPORT_DATE_MODIFIED */], data);
    },

    SET_APPRAISALREPORT_FILE_ID: function SET_APPRAISALREPORT_FILE_ID(_ref9, data) {
        var state = _ref9.state,
            commit = _ref9.commit,
            rootState = _ref9.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_547" /* SET_APPRAISALREPORT_FILE_ID */], data);
    },
    SET_APPRAISALREPORT_ID: function SET_APPRAISALREPORT_ID(_ref10, data) {
        var state = _ref10.state,
            commit = _ref10.commit,
            rootState = _ref10.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_538" /* SET_APPRAISALREPORT_ID */], data);
    },
    SET_APPRAISALREPORT_NUMBER: function SET_APPRAISALREPORT_NUMBER(_ref11, data) {
        var state = _ref11.state,
            commit = _ref11.commit,
            rootState = _ref11.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_541" /* SET_APPRAISALREPORT_NUMBER */], data);
    },
    SET_APPRAISALREPORT_PARENT_PATH: function SET_APPRAISALREPORT_PARENT_PATH(_ref12, data) {
        var state = _ref12.state,
            commit = _ref12.commit,
            rootState = _ref12.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_544" /* SET_APPRAISALREPORT_PARENT_PATH */], data);
    },
    SET_APPRAISALREPORT_PATH: function SET_APPRAISALREPORT_PATH(_ref13, data) {
        var state = _ref13.state,
            commit = _ref13.commit,
            rootState = _ref13.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_543" /* SET_APPRAISALREPORT_PATH */], data);
    },
    SET_APPRAISALREPORT_SEND_TO_BDE: function SET_APPRAISALREPORT_SEND_TO_BDE(_ref14, data) {
        var state = _ref14.state,
            commit = _ref14.commit,
            rootState = _ref14.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_550" /* SET_APPRAISALREPORT_SEND_TO_BDE */], data);
    },
    SET_APPRAISALREPORT_TITLE: function SET_APPRAISALREPORT_TITLE(_ref15, data) {
        var state = _ref15.state,
            commit = _ref15.commit,
            rootState = _ref15.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_551" /* SET_APPRAISALREPORT_TITLE */], data);
    },
    SET_APPRAISALREPORT_VERSION: function SET_APPRAISALREPORT_VERSION(_ref16, data) {
        var state = _ref16.state,
            commit = _ref16.commit,
            rootState = _ref16.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_546" /* SET_APPRAISALREPORT_VERSION */], data);
    },
    UPDATE_APPRAISALREPORT: function UPDATE_APPRAISALREPORT(_ref17, data) {
        var state = _ref17.state,
            commit = _ref17.commit,
            rootState = _ref17.rootState;

        return new Promise(function (resolve, reject) {
            // console.log('UPDATE_APPRAISALREPORT data:')
            // console.log(data)
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({ object: data.object, path: data.path + data.key, save_timestamp: true }).then(function (res) {

                var date_modified = res.date_modified;
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_540" /* SET_APPRAISALREPORT_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_552" /* SET_APPRAISALREPORT_DIRTYNESS */], false);

                var parent_object = {};

                parent_object = {
                    description: data.object.description,
                    id: data.object.id,
                    date_modified: res.date_modified,
                    number: data.object.number,
                    version: data.object.version,
                    send_to_bde: data.object.send_to_bde
                };
                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({ object: parent_object, path: data.parent_path + data.key, save_timestamp: false }).then(function (res) {

                    // update file date_modified
                    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                        value: date_modified,
                        path: 'appraisalfiles' + '/' + data.object.file_id + '/' + 'date_modified',
                        save_timestamp: false
                    }).then(function (res) {
                        return resolve({ key: res.key });
                    });
                });
            });
        });
    },
    SET_APPRAISALREPORT_REALESTATE_APPRAISAL_ID: function SET_APPRAISALREPORT_REALESTATE_APPRAISAL_ID(_ref18, data) {
        var state = _ref18.state,
            commit = _ref18.commit,
            rootState = _ref18.rootState;

        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                value: data.value,
                path: data.path,
                save_timestamp: false
            }).then(function () {
                resolve();
            });
        });
    },
    UPDATE_APPRAISALREPORT_REALESTATE_APPRAISAL_ID: function UPDATE_APPRAISALREPORT_REALESTATE_APPRAISAL_ID(_ref19, data) {
        var state = _ref19.state,
            commit = _ref19.commit,
            rootState = _ref19.rootState;

        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                value: data.appraisal_id,
                path: 'appraisalreports' + '/' + data.appraisalreport_id + '/' + 'realestates' + '/' + data.realestate_id + '/' + 'appraisal_id',
                save_timestamp: false
            });
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                value: data.appraisaldate,
                path: 'appraisalreports' + '/' + data.appraisalreport_id + '/' + 'realestates' + '/' + data.realestate_id + '/' + 'appraisals' + '/' + data.appraisal_id + '/' + 'appraisaldate',
                save_timestamp: false
            });
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                value: data.appraisal_id,
                path: 'appraisalreports' + '/' + data.appraisalreport_id + '/' + 'realestates' + '/' + data.realestate_id + '/' + 'appraisals' + '/' + data.appraisal_id + '/' + 'id',
                save_timestamp: false
            }).then(function () {
                resolve();
            });
        });
    },
    SET_APPRAISALREPORT_DESCRIPTION: function SET_APPRAISALREPORT_DESCRIPTION(_ref20, data) {
        var state = _ref20.state,
            commit = _ref20.commit,
            rootState = _ref20.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_553" /* SET_APPRAISALREPORT_DESCRIPTION */], data);
    },
    SET_APPRAISALREPORT_PETITIONER: function SET_APPRAISALREPORT_PETITIONER(_ref21, data) {
        var state = _ref21.state,
            commit = _ref21.commit,
            rootState = _ref21.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_554" /* SET_APPRAISALREPORT_PETITIONER */], data);
    },
    SET_APPRAISALREPORT_PETITIONER_TYPE: function SET_APPRAISALREPORT_PETITIONER_TYPE(_ref22, data) {
        var state = _ref22.state,
            commit = _ref22.commit,
            rootState = _ref22.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_555" /* SET_APPRAISALREPORT_PETITIONER_TYPE */], data);
    },
    SET_APPRAISALREPORT_ENTITY: function SET_APPRAISALREPORT_ENTITY(_ref23, data) {
        var state = _ref23.state,
            commit = _ref23.commit,
            rootState = _ref23.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_556" /* SET_APPRAISALREPORT_ENTITY */], data);
    },
    SET_APPRAISALREPORT_SUPERVISOR: function SET_APPRAISALREPORT_SUPERVISOR(_ref24, data) {
        var state = _ref24.state,
            commit = _ref24.commit,
            rootState = _ref24.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_557" /* SET_APPRAISALREPORT_SUPERVISOR */], data);
    },
    SET_APPRAISALREPORT_APPRAISER: function SET_APPRAISALREPORT_APPRAISER(_ref25, data) {
        var state = _ref25.state,
            commit = _ref25.commit,
            rootState = _ref25.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_558" /* SET_APPRAISALREPORT_APPRAISER */], data);
    },
    SET_APPRAISALREPORT_COVER_PHOTO_URL: function SET_APPRAISALREPORT_COVER_PHOTO_URL(_ref26, data) {
        var state = _ref26.state,
            commit = _ref26.commit,
            rootState = _ref26.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_559" /* SET_APPRAISALREPORT_COVER_PHOTO_URL */], data);
    },
    SET_APPRAISALREPORT_STATUS: function SET_APPRAISALREPORT_STATUS(_ref27, data) {
        var state = _ref27.state,
            commit = _ref27.commit,
            rootState = _ref27.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_560" /* SET_APPRAISALREPORT_STATUS */], data);
    },
    SET_APPRAISALREPORT_FULL_NUMBER: function SET_APPRAISALREPORT_FULL_NUMBER(_ref28, data) {
        var state = _ref28.state,
            commit = _ref28.commit,
            rootState = _ref28.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_542" /* SET_APPRAISALREPORT_FULL_NUMBER */], data);
    },
    SET_APPRAISALREPORT_SIGNATURE_SV_NAME: function SET_APPRAISALREPORT_SIGNATURE_SV_NAME(_ref29, data) {
        var state = _ref29.state,
            commit = _ref29.commit,
            rootState = _ref29.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_561" /* SET_APPRAISALREPORT_SIGNATURE_SV_NAME */], data);
    },
    SET_APPRAISALREPORT_SIGNATURE_SV_BASE64: function SET_APPRAISALREPORT_SIGNATURE_SV_BASE64(_ref30, data) {
        var state = _ref30.state,
            commit = _ref30.commit,
            rootState = _ref30.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_562" /* SET_APPRAISALREPORT_SIGNATURE_SV_BASE64 */], data);
    },
    SET_APPRAISALREPORT_SIGNATURE_SV_DATE: function SET_APPRAISALREPORT_SIGNATURE_SV_DATE(_ref31, data) {
        var state = _ref31.state,
            commit = _ref31.commit,
            rootState = _ref31.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_563" /* SET_APPRAISALREPORT_SIGNATURE_SV_DATE */], data);
    },
    SET_APPRAISALREPORT_SIGNATURE_SV_EMAIL: function SET_APPRAISALREPORT_SIGNATURE_SV_EMAIL(_ref32, data) {
        var state = _ref32.state,
            commit = _ref32.commit,
            rootState = _ref32.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_564" /* SET_APPRAISALREPORT_SIGNATURE_SV_EMAIL */], data);
    },
    SET_APPRAISALREPORT_SIGNATURE_SV_UID: function SET_APPRAISALREPORT_SIGNATURE_SV_UID(_ref33, data) {
        var state = _ref33.state,
            commit = _ref33.commit,
            rootState = _ref33.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_565" /* SET_APPRAISALREPORT_SIGNATURE_SV_UID */], data);
    },
    SET_APPRAISALREPORT_SIGNATURE_AP_NAME: function SET_APPRAISALREPORT_SIGNATURE_AP_NAME(_ref34, data) {
        var state = _ref34.state,
            commit = _ref34.commit,
            rootState = _ref34.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_566" /* SET_APPRAISALREPORT_SIGNATURE_AP_NAME */], data);
    },
    SET_APPRAISALREPORT_SIGNATURE_AP_BASE64: function SET_APPRAISALREPORT_SIGNATURE_AP_BASE64(_ref35, data) {
        var state = _ref35.state,
            commit = _ref35.commit,
            rootState = _ref35.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_567" /* SET_APPRAISALREPORT_SIGNATURE_AP_BASE64 */], data);
    },
    SET_APPRAISALREPORT_SIGNATURE_AP_DATE: function SET_APPRAISALREPORT_SIGNATURE_AP_DATE(_ref36, data) {
        var state = _ref36.state,
            commit = _ref36.commit,
            rootState = _ref36.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_568" /* SET_APPRAISALREPORT_SIGNATURE_AP_DATE */], data);
    },
    SET_APPRAISALREPORT_SIGNATURE_AP_EMAIL: function SET_APPRAISALREPORT_SIGNATURE_AP_EMAIL(_ref37, data) {
        var state = _ref37.state,
            commit = _ref37.commit,
            rootState = _ref37.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_569" /* SET_APPRAISALREPORT_SIGNATURE_AP_EMAIL */], data);
    },
    SET_APPRAISALREPORT_SIGNATURE_AP_UID: function SET_APPRAISALREPORT_SIGNATURE_AP_UID(_ref38, data) {
        var state = _ref38.state,
            commit = _ref38.commit,
            rootState = _ref38.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_570" /* SET_APPRAISALREPORT_SIGNATURE_AP_UID */], data);
    },
    SET_APPRAISALREPORT_IS_SIGNED: function SET_APPRAISALREPORT_IS_SIGNED(_ref39, data) {
        var state = _ref39.state,
            commit = _ref39.commit,
            rootState = _ref39.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_571" /* SET_APPRAISALREPORT_IS_SIGNED */], data);
    },
    SET_APPRAISALREPORT_IS_SV_SIGNED: function SET_APPRAISALREPORT_IS_SV_SIGNED(_ref40, data) {
        var state = _ref40.state,
            commit = _ref40.commit,
            rootState = _ref40.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_572" /* SET_APPRAISALREPORT_IS_SV_SIGNED */], data);
    },
    SET_APPRAISALREPORT_IS_AP_SIGNED: function SET_APPRAISALREPORT_IS_AP_SIGNED(_ref41, data) {
        var state = _ref41.state,
            commit = _ref41.commit,
            rootState = _ref41.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_573" /* SET_APPRAISALREPORT_IS_AP_SIGNED */], data);
    }

};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_548" /* RESET_APPRAISALREPORT */], function (state) {
    state.date_created = null;
    state.date_modified = null;
    state.dirty = false;
    state.file_id = null;
    state.id = null;
    state.number = null;
    state.full_number = null;
    state.path = null;
    state.parent_path = null;
    state.description = null;
    state.reportdate = null;
    state.send_to_bde = null;
    state.title = null;
    state.version = null;
    state.petitioner = null;
    state.petitioner_type = {
        id: 1,
        'name_ca': 'Altres persones físiques o jurídiques',
        'name_en': 'Other natural or legal persons',
        'name_es': 'Otras personas físicas o jurídicas'
    };
    state.entity = null;
    state.supervisor = null;
    state.appraiser = null;
    state.cover_photo_url = null;
    state.status = {
        id: 1,
        level: 1,
        progress_coef: 0.166,
        name_ca: '1/6 - Falta la firma del Taxador',
        name_es: '1/6 - Falta la firma del Tasador',
        name_en: '1/6 - Needs to be signed by Appraiser'
    };
    state.signature_sv_name = null;
    state.signature_sv_base64 = null;
    state.signature_sv_date = null;
    state.signature_sv_email = null;
    state.signature_sv_uid = null;
    state.signature_ap_name = null;
    state.signature_ap_base64 = null;
    state.signature_ap_date = null;
    state.signature_ap_email = null;
    state.signature_ap_uid = null;
    state.is_signed = null;
    state.is_sv_signed = null;
    state.is_ap_signed = null;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_549" /* SET_APPRAISALREPORT */], function (state, data) {
    state.date_created = check_undefined(data.date_created);
    state.date_modified = check_undefined(data.date_modified);
    state.dirty = false;
    state.file_id = check_undefined(data.file_id);
    state.id = check_undefined(data.id);
    state.number = check_undefined(data.number);
    state.path = check_undefined(data.path);
    state.parent_path = check_undefined(data.parent_path);
    state.description = check_undefined(data.description);
    state.reportdate = check_undefined(data.reportdate);
    state.send_to_bde = check_undefined(data.send_to_bde);
    state.title = check_undefined(data.title);
    state.version = check_undefined(data.version);
    state.petitioner = check_undefined(data.petitioner);
    state.petitioner_type = check_undefined(data.petitioner_type);
    state.entity = check_undefined(data.entity);
    state.supervisor = check_undefined(data.supervisor);
    state.appraiser = check_undefined(data.appraiser);
    state.cover_photo_url = check_undefined(data.cover_photo_url);
    state.status = check_undefined(data.status);
    state.full_number = check_undefined(data.full_number);
    state.signature_sv_name = check_undefined(data.signature_sv_name);
    state.signature_sv_base64 = check_undefined(data.signature_sv_base64);
    state.signature_sv_date = check_undefined(data.signature_sv_date);
    state.signature_sv_email = check_undefined(data.signature_sv_email);
    state.signature_sv_uid = check_undefined(data.signature_sv_uid);
    state.signature_ap_name = check_undefined(data.signature_ap_name);
    state.signature_ap_base64 = check_undefined(data.signature_ap_base64);
    state.signature_ap_date = check_undefined(data.signature_ap_date);
    state.signature_ap_email = check_undefined(data.signature_ap_email);
    state.signature_ap_uid = check_undefined(data.signature_ap_uid);
    state.is_signed = check_undefined(data.is_signed);
    state.is_sv_signed = check_undefined(data.is_sv_signed);
    state.is_ap_signed = check_undefined(data.is_ap_signed);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_539" /* SET_APPRAISALREPORT_DATE_CREATED */], function (state, data) {
    state.date_created = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_540" /* SET_APPRAISALREPORT_DATE_MODIFIED */], function (state, data) {
    state.date_modified = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_552" /* SET_APPRAISALREPORT_DIRTYNESS */], function (state, boolean) {
    state.dirty = boolean;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_547" /* SET_APPRAISALREPORT_FILE_ID */], function (state, data) {
    state.file_id = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_538" /* SET_APPRAISALREPORT_ID */], function (state, data) {
    state.id = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_541" /* SET_APPRAISALREPORT_NUMBER */], function (state, data) {
    state.number = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_544" /* SET_APPRAISALREPORT_PARENT_PATH */], function (state, data) {
    state.parent_path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_543" /* SET_APPRAISALREPORT_PATH */], function (state, data) {
    state.path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_545" /* SET_APPRAISALREPORT_REPORTDATE */], function (state, data) {
    state.reportdate = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_551" /* SET_APPRAISALREPORT_TITLE */], function (state, data) {
    state.title = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_553" /* SET_APPRAISALREPORT_DESCRIPTION */], function (state, data) {
    state.description = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_546" /* SET_APPRAISALREPORT_VERSION */], function (state, data) {
    state.version = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_554" /* SET_APPRAISALREPORT_PETITIONER */], function (state, data) {
    state.petitioner = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_555" /* SET_APPRAISALREPORT_PETITIONER_TYPE */], function (state, data) {
    state.petitioner_type = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_556" /* SET_APPRAISALREPORT_ENTITY */], function (state, data) {
    state.entity = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_557" /* SET_APPRAISALREPORT_SUPERVISOR */], function (state, data) {
    state.supervisor = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_558" /* SET_APPRAISALREPORT_APPRAISER */], function (state, data) {
    state.appraiser = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_559" /* SET_APPRAISALREPORT_COVER_PHOTO_URL */], function (state, data) {
    state.cover_photo_url = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_560" /* SET_APPRAISALREPORT_STATUS */], function (state, data) {
    state.status = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_542" /* SET_APPRAISALREPORT_FULL_NUMBER */], function (state, data) {
    state.full_number = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_561" /* SET_APPRAISALREPORT_SIGNATURE_SV_NAME */], function (state, data) {
    state.signature_sv_name = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_562" /* SET_APPRAISALREPORT_SIGNATURE_SV_BASE64 */], function (state, data) {
    state.signature_sv_base64 = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_563" /* SET_APPRAISALREPORT_SIGNATURE_SV_DATE */], function (state, data) {
    state.signature_sv_date = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_564" /* SET_APPRAISALREPORT_SIGNATURE_SV_EMAIL */], function (state, data) {
    state.signature_sv_email = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_565" /* SET_APPRAISALREPORT_SIGNATURE_SV_UID */], function (state, data) {
    state.signature_sv_uid = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_566" /* SET_APPRAISALREPORT_SIGNATURE_AP_NAME */], function (state, data) {
    state.signature_ap_name = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_567" /* SET_APPRAISALREPORT_SIGNATURE_AP_BASE64 */], function (state, data) {
    state.signature_ap_base64 = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_568" /* SET_APPRAISALREPORT_SIGNATURE_AP_DATE */], function (state, data) {
    state.signature_ap_date = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_569" /* SET_APPRAISALREPORT_SIGNATURE_AP_EMAIL */], function (state, data) {
    state.signature_ap_email = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_570" /* SET_APPRAISALREPORT_SIGNATURE_AP_UID */], function (state, data) {
    state.signature_ap_uid = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_571" /* SET_APPRAISALREPORT_IS_SIGNED */], function (state, data) {
    state.is_signed = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_572" /* SET_APPRAISALREPORT_IS_SV_SIGNED */], function (state, data) {
    state.is_sv_signed = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_573" /* SET_APPRAISALREPORT_IS_AP_SIGNED */], function (state, data) {
    state.is_ap_signed = data;
    state.dirty = true;
}), _mutations);

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

var getters = {

    appraisalreport: function appraisalreport(state) {
        return state;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    petitioners: {}
};
var state = default_state;

var actions = {
    FETCH_APPRAISALREPORT_PETITIONERS: function FETCH_APPRAISALREPORT_PETITIONERS(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        // console.log('data.path (fetch_appraisalreport_petitioners) ---->')
        // console.log(data.path)
        return new Promise(function (resolve, reject) {
            var petitioners = null;

            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                // console.log(res)
                petitioners = res;
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_349" /* SET_APPRAISALREPORT_PETITIONERS */], petitioners);
                resolve();
                // console.log('****** petitioners: ')
                // console.log(petitioners)
            });
        });
    }
};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__constants__["_349" /* SET_APPRAISALREPORT_PETITIONERS */], function (state, data) {
    state.petitioners = data;
});

var getters = {
    appraisalreport_petitioners: function appraisalreport_petitioners(state) {
        return state.petitioners;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var _require = __webpack_require__(40),
    forEachSeries = _require.forEachSeries;



var default_state = {
    realestates: {},
    temp_realestates: {}
};
var state = default_state;

var actions = {
    FETCH_APPRAISALREPORT_REALESTATES: function FETCH_APPRAISALREPORT_REALESTATES(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        // console.log('data.path (fetch_appraisalreport_realestates) ---->')
        // console.log(data.path)
        return new Promise(function (resolve, reject) {
            var realestates = null;

            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                // console.log(res)
                realestates = res;
                console.log('realestates: ');
                console.log(realestates);

                var realestate_counter = 0;
                var realestates_size = _.size(realestates);

                if (_.size(realestates) > 0) {

                    forEachSeries(_.values(realestates), function (realestate) {
                        realestate_counter++;
                        console.log('forEachSeries realestate: ');
                        console.log(realestate);

                        var realestate_id = realestate.id;
                        // let realestate_index = realestate.index
                        //
                        // if (!realestate_index) {
                        //     realestate_index = 0
                        // }


                        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: 'realestate_appraisals' + '/' + realestate.id }).then(function (res) {
                            var appraisals = res;

                            var appraisal_counter = 0;
                            var appraisals_size = _.size(appraisals);

                            forEachSeries(_.values(appraisals), function (appraisal) {
                                appraisal_counter++;
                                // console.log('forEachSeries appraisal: ')
                                // console.log(appraisal)

                                var appraisal_id = appraisal.id;
                                // console.log('appraisal_id: ')
                                // console.log(appraisal_id)

                                var obj = {};
                                obj['appraisaldate'] = appraisal.appraisaldate;
                                obj['id'] = appraisal.id;

                                if (appraisal.realestate_total_adopted_value) {
                                    obj['realestate_total_adopted_value'] = appraisal.realestate_total_adopted_value;
                                } else {
                                    obj['realestate_total_adopted_value'] = null;
                                }

                                // console.log('>>>> obj: ')
                                // console.log(obj)

                                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                                    value: obj,
                                    path: 'appraisalreports' + '/' + data.appraisalreport_id + '/' + 'realestates' + '/' + realestate_id + '/' + 'appraisals' + '/' + appraisal_id,
                                    save_timestamp: false
                                }).then(function () {

                                    if (realestate.appraisal_id === appraisal_id) {
                                        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                                            value: obj['id'],
                                            path: 'appraisalreports' + '/' + data.appraisalreport_id + '/' + 'realestates' + '/' + realestate_id + '/' + 'appraisal_id',
                                            save_timestamp: false
                                        }).then(function () {
                                            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                                                value: obj['appraisaldate'],
                                                path: 'appraisalreports' + '/' + data.appraisalreport_id + '/' + 'realestates' + '/' + realestate_id + '/' + 'appraisaldate',
                                                save_timestamp: false
                                            }).then(function () {
                                                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                                                    value: obj['realestate_total_adopted_value'],
                                                    path: 'appraisalreports' + '/' + data.appraisalreport_id + '/' + 'realestates' + '/' + realestate_id + '/' + 'realestate_total_adopted_value',
                                                    save_timestamp: false
                                                }).then(function () {
                                                    realestates[realestate_id]['appraisal_id'] = obj['id'];
                                                    realestates[realestate_id]['appraisaldate'] = obj['appraisaldate'];
                                                    realestates[realestate_id]['realestate_total_adopted_value'] = obj['realestate_total_adopted_value'];

                                                    console.log('yup');

                                                    console.log('realestate_counter: ' + realestate_counter + ' realestate_total: ' + realestates_size);
                                                    console.log('appraisal_counter: ' + appraisal_counter + ' appraisal_total: ' + appraisals_size);

                                                    if (function (appraisal_counter) {
                                                        return appraisals_size;
                                                    }) {
                                                        if (function (realestate_counter) {
                                                            return realestates_size;
                                                        }) {
                                                            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_350" /* SET_APPRAISALREPORT_REALESTATES */], realestates);
                                                            resolve();
                                                        }
                                                    }
                                                });
                                            });
                                        });
                                    } else {
                                        console.log('nope');

                                        console.log('realestate_counter: ' + realestate_counter + ' realestate_total: ' + realestates_size);
                                        console.log('appraisal_counter: ' + appraisal_counter + ' appraisal_total: ' + appraisals_size);

                                        if (function (appraisal_counter) {
                                            return appraisals_size;
                                        }) {
                                            if (function (realestate_counter) {
                                                return realestates_size;
                                            }) {
                                                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_350" /* SET_APPRAISALREPORT_REALESTATES */], realestates);
                                                resolve();
                                            }
                                        }
                                    }
                                });
                            });
                        });
                    });

                    /*
                    _.forEach(realestates, (value, key) => {
                        let realestate_id = value['id']
                         // console.log('>> realestate:')
                        // console.log(value)
                         api.get({path: 'realestate_appraisals' + '/' + value['id']})
                            .then((res) => {
                                let appraisals = res
                                _.forEach(appraisals, (value2, key2) => {
                                     let appraisal_id = value2['id']
                                    let obj = {}
                                    obj['appraisaldate'] = value2['appraisaldate']
                                    obj['id'] = value2['id']
                                     if (value2['realestate_total_adopted_value']) {
                                        obj['realestate_total_adopted_value'] = value2['realestate_total_adopted_value']
                                    } else {
                                        obj['realestate_total_adopted_value'] = null
                                    }
                                      // console.log('>>>> obj: ')
                                    // console.log(obj)
                                     api.set_value({
                                        value: obj,
                                        path: 'appraisalreports' + '/' + data.appraisalreport_id + '/' + 'realestates' + '/' + realestate_id + '/' + 'appraisals' + '/' + appraisal_id,
                                        save_timestamp: false
                                    })
                                     realestates[realestate_id]['appraisals'][appraisal_id] = obj
                                     if(value['appraisal_id'] === appraisal_id){
                                        api.set_value({
                                            value: obj['id'],
                                            path: 'appraisalreports' + '/' + data.appraisalreport_id + '/' + 'realestates' + '/' + realestate_id + '/' + 'appraisal_id',
                                            save_timestamp: false
                                        })
                                        api.set_value({
                                            value: obj['appraisaldate'],
                                            path: 'appraisalreports' + '/' + data.appraisalreport_id + '/' + 'realestates' + '/' + realestate_id + '/' + 'appraisaldate',
                                            save_timestamp: false
                                        })
                                        api.set_value({
                                            value: obj['realestate_total_adopted_value'],
                                            path: 'appraisalreports' + '/' + data.appraisalreport_id + '/' + 'realestates' + '/' + realestate_id + '/' + 'realestate_total_adopted_value',
                                            save_timestamp: false
                                        })
                                         realestates[realestate_id]['appraisal_id'] = obj['id']
                                        realestates[realestate_id]['appraisaldate'] = obj['appraisaldate']
                                        realestates[realestate_id]['realestate_total_adopted_value'] = obj['realestate_total_adopted_value']
                                    }
                                   })
                             })
                     })
                     */

                    // console.log('****** realestates: ')
                    // console.log(realestates)
                } else {
                    console.log('realestates size is 0');
                    commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_350" /* SET_APPRAISALREPORT_REALESTATES */], null);
                    resolve();
                }
            });
        });
    },
    FETCH_TEMP_APPRAISALREPORT_REALESTATES: function FETCH_TEMP_APPRAISALREPORT_REALESTATES(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;


        // console.log('data.path (fetch_appraisalreport_realestates) ---->')
        // console.log(data.path)
        return new Promise(function (resolve, reject) {
            var realestates = null;

            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                // console.log(res)
                realestates = res;
                // console.log('realestates: ')
                // console.log(realestates)

                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_351" /* SET_TEMP_APPRAISALREPORT_REALESTATES */], realestates);
                resolve();
                // console.log('****** realestates: ')
                // console.log(realestates)
            });
        });
    }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_350" /* SET_APPRAISALREPORT_REALESTATES */], function (state, data) {
    state.realestates = data;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_351" /* SET_TEMP_APPRAISALREPORT_REALESTATES */], function (state, data) {
    state.temp_realestates = data;
}), _mutations);

var getters = {
    appraisalreport_realestates: function appraisalreport_realestates(state) {
        return state.realestates;
    },
    temp_realestates: function temp_realestates(state) {
        return state.temp_realestates;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    name: null,
    organization: null,
    path: null,
    surnames: null,
    tin: null,
    title: null,
    complete_name: null,
    prof_assoc_reg_number: null

};
var state = default_state;

var actions = {
    CREATE_NEW_APPRAISER: function CREATE_NEW_APPRAISER(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;

        return new Promise(function (resolve, reject) {
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_448" /* RESET_APPRAISER */]);
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].create({ path: data.path }).then(function (res) {
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_449" /* SET_APPRAISER_ID */], res.key);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_450" /* SET_APPRAISER_DATE_CREATED */], res.date_created);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_451" /* SET_APPRAISER_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_452" /* SET_APPRAISER_PATH */], res.path);
                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({ value: res.key, path: data.path + '/' + res.key + '/' + 'id', save_timestamp: false });
                resolve();
            });
        });
    },
    DELETE_APPRAISER: function DELETE_APPRAISER(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;


        console.log('path check: ' + data.path);
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.path }).then(function (res) {
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_448" /* RESET_APPRAISER */]);

            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: 'appraiser_addresses' + '/' + data.key }).then(function (res) {});
        });
    },
    RESET_APPRAISER: function RESET_APPRAISER(_ref3) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_448" /* RESET_APPRAISER */]);
    },
    SET_APPRAISER: function SET_APPRAISER(_ref4, data) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;


        console.log('set_appraiser data:');
        console.log(data);
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_453" /* SET_APPRAISER */], res);
        });
    },
    SET_APPRAISER_DATE_CREATED: function SET_APPRAISER_DATE_CREATED(_ref5, data) {
        var state = _ref5.state,
            commit = _ref5.commit,
            rootState = _ref5.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_450" /* SET_APPRAISER_DATE_CREATED */], data);
    },
    SET_APPRAISER_DATE_MODIFIED: function SET_APPRAISER_DATE_MODIFIED(_ref6, data) {
        var state = _ref6.state,
            commit = _ref6.commit,
            rootState = _ref6.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_451" /* SET_APPRAISER_DATE_MODIFIED */], data);
    },
    SET_APPRAISER_ID: function SET_APPRAISER_ID(_ref7, data) {
        var state = _ref7.state,
            commit = _ref7.commit,
            rootState = _ref7.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_449" /* SET_APPRAISER_ID */], data);
    },
    SET_APPRAISER_NAME: function SET_APPRAISER_NAME(_ref8, name) {
        var state = _ref8.state,
            commit = _ref8.commit,
            rootState = _ref8.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_454" /* SET_APPRAISER_NAME */], name);
    },
    SET_APPRAISER_ORGANIZATION: function SET_APPRAISER_ORGANIZATION(_ref9, name) {
        var state = _ref9.state,
            commit = _ref9.commit,
            rootState = _ref9.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_455" /* SET_APPRAISER_ORGANIZATION */], name);
    },
    SET_APPRAISER_PATH: function SET_APPRAISER_PATH(_ref10, data) {
        var state = _ref10.state,
            commit = _ref10.commit,
            rootState = _ref10.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_452" /* SET_APPRAISER_PATH */], data);
    },
    SET_APPRAISER_SURNAMES: function SET_APPRAISER_SURNAMES(_ref11, surnames) {
        var state = _ref11.state,
            commit = _ref11.commit,
            rootState = _ref11.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_456" /* SET_APPRAISER_SURNAMES */], surnames);
    },
    SET_APPRAISER_TIN: function SET_APPRAISER_TIN(_ref12, tin) {
        var state = _ref12.state,
            commit = _ref12.commit,
            rootState = _ref12.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_457" /* SET_APPRAISER_TIN */], tin);
    },
    SET_APPRAISER_TITLE: function SET_APPRAISER_TITLE(_ref13, title) {
        var state = _ref13.state,
            commit = _ref13.commit,
            rootState = _ref13.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_458" /* SET_APPRAISER_TITLE */], title);
    },
    SET_APPRAISER_COMPLETE_NAME: function SET_APPRAISER_COMPLETE_NAME(_ref14, data) {
        var state = _ref14.state,
            commit = _ref14.commit,
            rootState = _ref14.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_459" /* SET_APPRAISER_COMPLETE_NAME */], data);
    },
    SET_APPRAISER_PROF_ASSOC_REG_NUMBER: function SET_APPRAISER_PROF_ASSOC_REG_NUMBER(_ref15, data) {
        var state = _ref15.state,
            commit = _ref15.commit,
            rootState = _ref15.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_460" /* SET_APPRAISER_PROF_ASSOC_REG_NUMBER */], data);
    },
    UPDATE_APPRAISER: function UPDATE_APPRAISER(_ref16, data) {
        var state = _ref16.state,
            commit = _ref16.commit,
            rootState = _ref16.rootState;

        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({ object: data.object, path: data.path, save_timestamp: true }).then(function (res) {
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_451" /* SET_APPRAISER_DATE_MODIFIED */], res.date_modified);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_461" /* SET_APPRAISER_DIRTYNESS */], false);
        });
    }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_448" /* RESET_APPRAISER */], function (state) {
    state.date_created = null;
    state.date_modified = null;
    state.id = null;
    state.name = null;
    state.organization = null;
    state.path = null;
    state.surnames = null;
    state.tin = null;
    state.title = null;
    state.dirty = false;
    state.complete_name = null;
    state.prof_assoc_reg_number = null;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_453" /* SET_APPRAISER */], function (state, data) {
    // console.log('mutations SET_APPRAISER data: ')
    //  console.log(data)
    state.date_created = check_undefined(data.date_created);
    state.date_modified = check_undefined(data.date_modified);
    state.id = check_undefined(data.id);
    state.name = check_undefined(data.name);
    state.organization = check_undefined(data.organization);
    state.path = check_undefined(data.path);
    state.surnames = check_undefined(data.surnames);
    state.tin = check_undefined(data.tin);
    state.title = check_undefined(data.title);
    state.dirty = false;
    state.complete_name = check_undefined(data.complete_name);
    state.prof_assoc_reg_number = check_undefined(data.prof_assoc_reg_number);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_450" /* SET_APPRAISER_DATE_CREATED */], function (state, data) {
    state.date_created = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_451" /* SET_APPRAISER_DATE_MODIFIED */], function (state, data) {
    state.date_modified = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_461" /* SET_APPRAISER_DIRTYNESS */], function (state, boolean) {
    state.dirty = boolean;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_449" /* SET_APPRAISER_ID */], function (state, data) {
    state.id = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_454" /* SET_APPRAISER_NAME */], function (state, name) {
    state.name = name;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_455" /* SET_APPRAISER_ORGANIZATION */], function (state, data) {
    state.organization = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_452" /* SET_APPRAISER_PATH */], function (state, data) {
    state.path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_456" /* SET_APPRAISER_SURNAMES */], function (state, surnames) {
    state.surnames = surnames;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_457" /* SET_APPRAISER_TIN */], function (state, tin) {
    state.tin = tin;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_458" /* SET_APPRAISER_TITLE */], function (state, title) {
    state.title = title;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_459" /* SET_APPRAISER_COMPLETE_NAME */], function (state, data) {
    state.complete_name = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_460" /* SET_APPRAISER_PROF_ASSOC_REG_NUMBER */], function (state, data) {
    state.prof_assoc_reg_number = data;
    state.dirty = true;
}), _mutations);

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

var getters = {

    appraiser: function appraiser(state) {
        return state;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var state = {
    user: null
};

var actions = {
    LOG_IN_USER: function LOG_IN_USER(_ref, data) {
        var commit = _ref.commit;

        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].logIn(data.email, data.password).then(function (user) {
            return commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_115" /* SET_USER */], user);
        });
    },

    LOG_OUT_USER: function LOG_OUT_USER(_ref2) {
        var state = _ref2.state,
            commit = _ref2.commit;

        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].logOut().then(function () {
            return commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_115" /* SET_USER */], null);
        });
    },

    SIGN_UP_USER: function SIGN_UP_USER(_ref3, data) {
        var commit = _ref3.commit;

        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].signUp(data.email, data.password).then(function (user) {
            return commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_115" /* SET_USER */], user);
        });
    }
};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__constants__["_115" /* SET_USER */], function (state, user) {
    state.user = user;
});

var getters = {
    user: function user(state) {
        return state.user;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    path: null,
    number: null,
    quarter: null,
    year: null,
    aire_acondicionado: null,
    albanileria_acabados_fachada: null,
    albanileria_acabados_interiores: null,
    albanileria_ayudas_industriales: null,
    albanileria_azoteas: null,
    albanileria_gruesa: null,
    albanileria_solados: null,
    ascensores: null,
    calefaccion: null,
    carpinteria_exterior: null,
    carpinteria_interior: null,
    cerrajeria: null,
    cimentacion_y_muro_sotano: null,
    electricidad: null,
    energia_solar_acs: null,
    estructura: null,
    fontaneria: null,
    fumisteria_y_muebles_cocina: null,
    instal_especiales: null,
    jardineria_decorativa: null,
    mat_sanitario_griferia: null,
    movimiento_tierras: null,
    persianas: null,
    pintura_y_estucos: null,
    renovacion_aire: null,
    saneamiento: null,
    seguridad_y_salud: null,
    subtotal: null,
    total: null,
    vidrieria: null,
    yeseria_cielosrasos: null

};

var state = default_state;

var actions = {

    CREATE_NEW_BECPRICE: function CREATE_NEW_BECPRICE(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].create({ key: data.key, path: data.path }).then(function (res) {
                var new_created_key = res.key;

                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_392" /* SET_BECPRICE_ID */], res.key);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_393" /* SET_BECPRICE_DATE_CREATED */], res.date_created);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_394" /* SET_BECPRICE_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_395" /* SET_BECPRICE_PATH */], res.path);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_396" /* SET_BECPRICE_PARENT_PATH */], data.parent_path);

                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                    value: res.key,
                    path: data.path + new_created_key + '/' + 'id',
                    save_timestamp: false
                }).then(function (res) {
                    return resolve({ key: new_created_key });
                });
            });
        });
    },
    DELETE_BECPRICE: function DELETE_BECPRICE(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;


        // console.log('DELETE_BECPRICE path check: ' + data.path)
        // console.log('DELETE BECPRICE parent_path check: ' + data.parent_path)

        // delete from becprices/becprice_key
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.path }).then(function (res) {});
    },
    GET_BECPRICE: function GET_BECPRICE(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;


        return new Promise(function (resolve, reject) {
            return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                return resolve(res);
            });
        });
    },
    SET_BECPRICE: function SET_BECPRICE(_ref4, data) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;


        // console.log('set_becprice data:')
        // console.log(data)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_397" /* SET_BECPRICE */], res);
        });
    },
    RESET_BECPRICE: function RESET_BECPRICE(_ref5) {
        var state = _ref5.state,
            commit = _ref5.commit,
            rootState = _ref5.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_398" /* RESET_BECPRICE */]);
    },
    SET_BECPRICE_REPORTDATE: function (_SET_BECPRICE_REPORTDATE) {
        function SET_BECPRICE_REPORTDATE(_x, _x2) {
            return _SET_BECPRICE_REPORTDATE.apply(this, arguments);
        }

        SET_BECPRICE_REPORTDATE.toString = function () {
            return _SET_BECPRICE_REPORTDATE.toString();
        };

        return SET_BECPRICE_REPORTDATE;
    }(function (_ref6, data) {
        var state = _ref6.state,
            commit = _ref6.commit,
            rootState = _ref6.rootState;

        commit(SET_BECPRICE_REPORTDATE, data);
    }),
    SET_BECPRICE_DATE_CREATED: function SET_BECPRICE_DATE_CREATED(_ref7, data) {
        var state = _ref7.state,
            commit = _ref7.commit,
            rootState = _ref7.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_393" /* SET_BECPRICE_DATE_CREATED */], data);
    },
    SET_BECPRICE_DATE_MODIFIED: function SET_BECPRICE_DATE_MODIFIED(_ref8, data) {
        var state = _ref8.state,
            commit = _ref8.commit,
            rootState = _ref8.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_394" /* SET_BECPRICE_DATE_MODIFIED */], data);
    },

    SET_BECPRICE_ID: function SET_BECPRICE_ID(_ref9, data) {
        var state = _ref9.state,
            commit = _ref9.commit,
            rootState = _ref9.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_392" /* SET_BECPRICE_ID */], data);
    },
    SET_BECPRICE_PARENT_PATH: function SET_BECPRICE_PARENT_PATH(_ref10, data) {
        var state = _ref10.state,
            commit = _ref10.commit,
            rootState = _ref10.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_396" /* SET_BECPRICE_PARENT_PATH */], data);
    },
    SET_BECPRICE_PATH: function SET_BECPRICE_PATH(_ref11, data) {
        var state = _ref11.state,
            commit = _ref11.commit,
            rootState = _ref11.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_395" /* SET_BECPRICE_PATH */], data);
    },
    UPDATE_BECPRICE: function UPDATE_BECPRICE(_ref12, data) {
        var state = _ref12.state,
            commit = _ref12.commit,
            rootState = _ref12.rootState;

        return new Promise(function (resolve, reject) {
            // console.log('UPDATE_BECPRICE data:')
            // console.log(data)
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({ object: data.object, path: data.path + data.key, save_timestamp: true }).then(function (res) {

                var date_modified = res.date_modified;
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_394" /* SET_BECPRICE_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_399" /* SET_BECPRICE_DIRTYNESS */], false);
                resolve();
            });
        });
    },
    SET_BECPRICE_NUMBER: function SET_BECPRICE_NUMBER(_ref13, data) {
        var state = _ref13.state,
            commit = _ref13.commit,
            rootState = _ref13.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_400" /* SET_BECPRICE_NUMBER */], data);
    },
    SET_BECPRICE_QUARTER: function SET_BECPRICE_QUARTER(_ref14, data) {
        var state = _ref14.state,
            commit = _ref14.commit,
            rootState = _ref14.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_401" /* SET_BECPRICE_QUARTER */], data);
    },
    SET_BECPRICE_YEAR: function SET_BECPRICE_YEAR(_ref15, data) {
        var state = _ref15.state,
            commit = _ref15.commit,
            rootState = _ref15.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_402" /* SET_BECPRICE_YEAR */], data);
    },
    SET_BECPRICE_AIRE_ACONDICIONADO: function SET_BECPRICE_AIRE_ACONDICIONADO(_ref16, data) {
        var state = _ref16.state,
            commit = _ref16.commit,
            rootState = _ref16.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_403" /* SET_BECPRICE_AIRE_ACONDICIONADO */], data);
    },
    SET_BECPRICE_ALBANILERIA_ACABADOS_FACHADA: function SET_BECPRICE_ALBANILERIA_ACABADOS_FACHADA(_ref17, data) {
        var state = _ref17.state,
            commit = _ref17.commit,
            rootState = _ref17.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_404" /* SET_BECPRICE_ALBANILERIA_ACABADOS_FACHADA */], data);
    },
    SET_BECPRICE_ALBANILERIA_ACABADOS_INTERIORES: function SET_BECPRICE_ALBANILERIA_ACABADOS_INTERIORES(_ref18, data) {
        var state = _ref18.state,
            commit = _ref18.commit,
            rootState = _ref18.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_405" /* SET_BECPRICE_ALBANILERIA_ACABADOS_INTERIORES */], data);
    },
    SET_BECPRICE_ALBANILERIA_AYUDAS_INDUSTRIALES: function SET_BECPRICE_ALBANILERIA_AYUDAS_INDUSTRIALES(_ref19, data) {
        var state = _ref19.state,
            commit = _ref19.commit,
            rootState = _ref19.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_406" /* SET_BECPRICE_ALBANILERIA_AYUDAS_INDUSTRIALES */], data);
    },
    SET_BECPRICE_ALBANILERIA_AZOTEAS: function SET_BECPRICE_ALBANILERIA_AZOTEAS(_ref20, data) {
        var state = _ref20.state,
            commit = _ref20.commit,
            rootState = _ref20.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_407" /* SET_BECPRICE_ALBANILERIA_AZOTEAS */], data);
    },
    SET_BECPRICE_ALBANILERIA_GRUESA: function SET_BECPRICE_ALBANILERIA_GRUESA(_ref21, data) {
        var state = _ref21.state,
            commit = _ref21.commit,
            rootState = _ref21.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_408" /* SET_BECPRICE_ALBANILERIA_GRUESA */], data);
    },
    SET_BECPRICE_ALBANILERIA_SOLADOS: function SET_BECPRICE_ALBANILERIA_SOLADOS(_ref22, data) {
        var state = _ref22.state,
            commit = _ref22.commit,
            rootState = _ref22.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_409" /* SET_BECPRICE_ALBANILERIA_SOLADOS */], data);
    },
    SET_BECPRICE_ASCENSORES: function SET_BECPRICE_ASCENSORES(_ref23, data) {
        var state = _ref23.state,
            commit = _ref23.commit,
            rootState = _ref23.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_410" /* SET_BECPRICE_ASCENSORES */], data);
    },
    SET_BECPRICE_CALEFACCION: function SET_BECPRICE_CALEFACCION(_ref24, data) {
        var state = _ref24.state,
            commit = _ref24.commit,
            rootState = _ref24.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_411" /* SET_BECPRICE_CALEFACCION */], data);
    },
    SET_BECPRICE_CARPINTERIA_EXTERIOR: function SET_BECPRICE_CARPINTERIA_EXTERIOR(_ref25, data) {
        var state = _ref25.state,
            commit = _ref25.commit,
            rootState = _ref25.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_412" /* SET_BECPRICE_CARPINTERIA_EXTERIOR */], data);
    },
    SET_BECPRICE_CARPINTERIA_INTERIOR: function SET_BECPRICE_CARPINTERIA_INTERIOR(_ref26, data) {
        var state = _ref26.state,
            commit = _ref26.commit,
            rootState = _ref26.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_413" /* SET_BECPRICE_CARPINTERIA_INTERIOR */], data);
    },
    SET_BECPRICE_CERRAJERIA: function SET_BECPRICE_CERRAJERIA(_ref27, data) {
        var state = _ref27.state,
            commit = _ref27.commit,
            rootState = _ref27.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_414" /* SET_BECPRICE_CERRAJERIA */], data);
    },
    SET_BECPRICE_CIMENTACION_Y_MURO_SOTANO: function SET_BECPRICE_CIMENTACION_Y_MURO_SOTANO(_ref28, data) {
        var state = _ref28.state,
            commit = _ref28.commit,
            rootState = _ref28.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_415" /* SET_BECPRICE_CIMENTACION_Y_MURO_SOTANO */], data);
    },
    SET_BECPRICE_ELECTRICIDAD: function SET_BECPRICE_ELECTRICIDAD(_ref29, data) {
        var state = _ref29.state,
            commit = _ref29.commit,
            rootState = _ref29.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_416" /* SET_BECPRICE_ELECTRICIDAD */], data);
    },
    SET_BECPRICE_ENERGIA_SOLAR_ACS: function SET_BECPRICE_ENERGIA_SOLAR_ACS(_ref30, data) {
        var state = _ref30.state,
            commit = _ref30.commit,
            rootState = _ref30.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_417" /* SET_BECPRICE_ENERGIA_SOLAR_ACS */], data);
    },
    SET_BECPRICE_ESTRUCTURA: function SET_BECPRICE_ESTRUCTURA(_ref31, data) {
        var state = _ref31.state,
            commit = _ref31.commit,
            rootState = _ref31.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_418" /* SET_BECPRICE_ESTRUCTURA */], data);
    },
    SET_BECPRICE_FONTANERIA: function SET_BECPRICE_FONTANERIA(_ref32, data) {
        var state = _ref32.state,
            commit = _ref32.commit,
            rootState = _ref32.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_419" /* SET_BECPRICE_FONTANERIA */], data);
    },
    SET_BECPRICE_FUMISTERIA_Y_MUEBLES_COCINA: function SET_BECPRICE_FUMISTERIA_Y_MUEBLES_COCINA(_ref33, data) {
        var state = _ref33.state,
            commit = _ref33.commit,
            rootState = _ref33.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_420" /* SET_BECPRICE_FUMISTERIA_Y_MUEBLES_COCINA */], data);
    },
    SET_BECPRICE_INSTAL_ESPECIALES: function SET_BECPRICE_INSTAL_ESPECIALES(_ref34, data) {
        var state = _ref34.state,
            commit = _ref34.commit,
            rootState = _ref34.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_421" /* SET_BECPRICE_INSTAL_ESPECIALES */], data);
    },
    SET_BECPRICE_JARDINERIA_DECORATIVA: function SET_BECPRICE_JARDINERIA_DECORATIVA(_ref35, data) {
        var state = _ref35.state,
            commit = _ref35.commit,
            rootState = _ref35.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_422" /* SET_BECPRICE_JARDINERIA_DECORATIVA */], data);
    },
    SET_BECPRICE_MAT_SANITARIO_GRIFERIA: function SET_BECPRICE_MAT_SANITARIO_GRIFERIA(_ref36, data) {
        var state = _ref36.state,
            commit = _ref36.commit,
            rootState = _ref36.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_423" /* SET_BECPRICE_MAT_SANITARIO_GRIFERIA */], data);
    },
    SET_BECPRICE_MOVIMIENTO_TIERRAS: function SET_BECPRICE_MOVIMIENTO_TIERRAS(_ref37, data) {
        var state = _ref37.state,
            commit = _ref37.commit,
            rootState = _ref37.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_424" /* SET_BECPRICE_MOVIMIENTO_TIERRAS */], data);
    },
    SET_BECPRICE_PERSIANAS: function SET_BECPRICE_PERSIANAS(_ref38, data) {
        var state = _ref38.state,
            commit = _ref38.commit,
            rootState = _ref38.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_425" /* SET_BECPRICE_PERSIANAS */], data);
    },
    SET_BECPRICE_PINTURA_Y_ESTUCOS: function SET_BECPRICE_PINTURA_Y_ESTUCOS(_ref39, data) {
        var state = _ref39.state,
            commit = _ref39.commit,
            rootState = _ref39.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_426" /* SET_BECPRICE_PINTURA_Y_ESTUCOS */], data);
    },
    SET_BECPRICE_RENOVACION_AIRE: function SET_BECPRICE_RENOVACION_AIRE(_ref40, data) {
        var state = _ref40.state,
            commit = _ref40.commit,
            rootState = _ref40.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_427" /* SET_BECPRICE_RENOVACION_AIRE */], data);
    },
    SET_BECPRICE_SANEAMIENTO: function SET_BECPRICE_SANEAMIENTO(_ref41, data) {
        var state = _ref41.state,
            commit = _ref41.commit,
            rootState = _ref41.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_428" /* SET_BECPRICE_SANEAMIENTO */], data);
    },
    SET_BECPRICE_SEGURIDAD_Y_SALUD: function SET_BECPRICE_SEGURIDAD_Y_SALUD(_ref42, data) {
        var state = _ref42.state,
            commit = _ref42.commit,
            rootState = _ref42.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_429" /* SET_BECPRICE_SEGURIDAD_Y_SALUD */], data);
    },
    SET_BECPRICE_SUBTOTAL: function SET_BECPRICE_SUBTOTAL(_ref43, data) {
        var state = _ref43.state,
            commit = _ref43.commit,
            rootState = _ref43.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_430" /* SET_BECPRICE_SUBTOTAL */], data);
    },
    SET_BECPRICE_TOTAL: function SET_BECPRICE_TOTAL(_ref44, data) {
        var state = _ref44.state,
            commit = _ref44.commit,
            rootState = _ref44.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_431" /* SET_BECPRICE_TOTAL */], data);
    },
    SET_BECPRICE_VIDRIERIA: function SET_BECPRICE_VIDRIERIA(_ref45, data) {
        var state = _ref45.state,
            commit = _ref45.commit,
            rootState = _ref45.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_432" /* SET_BECPRICE_VIDRIERIA */], data);
    },
    SET_BECPRICE_YESERIA_CIELOSRASOS: function SET_BECPRICE_YESERIA_CIELOSRASOS(_ref46, data) {
        var state = _ref46.state,
            commit = _ref46.commit,
            rootState = _ref46.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_433" /* SET_BECPRICE_YESERIA_CIELOSRASOS */], data);
    }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_398" /* RESET_BECPRICE */], function (state) {
    state.date_created = null;
    state.date_modified = null;
    state.dirty = false;
    state.file_id = null;
    state.id = null;
    state.path = null;
    state.parent_path = null;
    state.number = null;
    state.quarter = null;
    state.year = null;
    state.aire_acondicionado = null;
    state.albanileria_acabados_fachada = null;
    state.albanileria_acabados_interiores = null;
    state.albanileria_ayudas_industriales = null;
    state.albanileria_azoteas = null;
    state.albanileria_gruesa = null;
    state.albanileria_solados = null;
    state.ascensores = null;
    state.calefaccion = null;
    state.carpinteria_exterior = null;
    state.carpinteria_interior = null;
    state.cerrajeria = null;
    state.cimentacion_y_muro_sotano = null;
    state.electricidad = null;
    state.energia_solar_acs = null;
    state.estructura = null;
    state.fontaneria = null;
    state.fumisteria_y_muebles_cocina = null;
    state.instal_especiales = null;
    state.jardineria_decorativa = null;
    state.mat_sanitario_griferia = null;
    state.movimiento_tierras = null;
    state.persianas = null;
    state.pintura_y_estucos = null;
    state.renovacion_aire = null;
    state.saneamiento = null;
    state.seguridad_y_salud = null;
    state.subtotal = null;
    state.total = null;
    state.vidrieria = null;
    state.yeseria_cielosrasos = null;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_397" /* SET_BECPRICE */], function (state, data) {
    state.date_created = check_undefined(data.date_created);
    state.date_modified = check_undefined(data.date_modified);
    state.dirty = false;
    state.file_id = check_undefined(data.file_id);
    state.id = check_undefined(data.id);
    state.path = check_undefined(data.path);
    state.parent_path = check_undefined(data.parent_path);
    state.number = check_undefined(data.number);
    state.quarter = check_undefined(data.quarter);
    state.year = check_undefined(data.year);
    state.aire_acondicionado = check_undefined(data.aire_acondicionado);
    state.albanileria_acabados_fachada = check_undefined(data.albanileria_acabados_fachada);
    state.albanileria_acabados_interiores = check_undefined(data.albanileria_acabados_interiores);
    state.albanileria_ayudas_industriales = check_undefined(data.albanileria_ayudas_industriales);
    state.albanileria_azoteas = check_undefined(data.albanileria_azoteas);
    state.albanileria_gruesa = check_undefined(data.albanileria_gruesa);
    state.albanileria_solados = check_undefined(data.albanileria_solados);
    state.ascensores = check_undefined(data.ascensores);
    state.calefaccion = check_undefined(data.calefaccion);
    state.carpinteria_exterior = check_undefined(data.carpinteria_exterior);
    state.carpinteria_interior = check_undefined(data.carpinteria_interior);
    state.cerrajeria = check_undefined(data.cerrajeria);
    state.cimentacion_y_muro_sotano = check_undefined(data.cimentacion_y_muro_sotano);
    state.electricidad = check_undefined(data.electricidad);
    state.energia_solar_acs = check_undefined(data.energia_solar_acs);
    state.estructura = check_undefined(data.estructura);
    state.fontaneria = check_undefined(data.fontaneria);
    state.fumisteria_y_muebles_cocina = check_undefined(data.fumisteria_y_muebles_cocina);
    state.instal_especiales = check_undefined(data.instal_especiales);
    state.jardineria_decorativa = check_undefined(data.jardineria_decorativa);
    state.mat_sanitario_griferia = check_undefined(data.mat_sanitario_griferia);
    state.movimiento_tierras = check_undefined(data.movimiento_tierras);
    state.persianas = check_undefined(data.persianas);
    state.pintura_y_estucos = check_undefined(data.pintura_y_estucos);
    state.renovacion_aire = check_undefined(data.renovacion_aire);
    state.saneamiento = check_undefined(data.saneamiento);
    state.seguridad_y_salud = check_undefined(data.seguridad_y_salud);
    state.subtotal = check_undefined(data.subtotal);
    state.total = check_undefined(data.total);
    state.vidrieria = check_undefined(data.vidrieria);
    state.yeseria_cielosrasos = check_undefined(data.yeseria_cielosrasos);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_393" /* SET_BECPRICE_DATE_CREATED */], function (state, data) {
    state.date_created = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_394" /* SET_BECPRICE_DATE_MODIFIED */], function (state, data) {
    state.date_modified = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_399" /* SET_BECPRICE_DIRTYNESS */], function (state, boolean) {
    state.dirty = boolean;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_392" /* SET_BECPRICE_ID */], function (state, data) {
    state.id = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_396" /* SET_BECPRICE_PARENT_PATH */], function (state, data) {
    state.parent_path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_395" /* SET_BECPRICE_PATH */], function (state, data) {
    state.path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_400" /* SET_BECPRICE_NUMBER */], function (state, data) {
    state.number = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_401" /* SET_BECPRICE_QUARTER */], function (state, data) {
    state.quarter = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_402" /* SET_BECPRICE_YEAR */], function (state, data) {
    state.year = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_403" /* SET_BECPRICE_AIRE_ACONDICIONADO */], function (state, data) {
    state.aire_acondicionado = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_404" /* SET_BECPRICE_ALBANILERIA_ACABADOS_FACHADA */], function (state, data) {
    state.albanileria_acabados_fachada = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_405" /* SET_BECPRICE_ALBANILERIA_ACABADOS_INTERIORES */], function (state, data) {
    state.albanileria_acabados_interiores = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_406" /* SET_BECPRICE_ALBANILERIA_AYUDAS_INDUSTRIALES */], function (state, data) {
    state.albanileria_ayudas_industriales = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_407" /* SET_BECPRICE_ALBANILERIA_AZOTEAS */], function (state, data) {
    state.albanileria_azoteas = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_408" /* SET_BECPRICE_ALBANILERIA_GRUESA */], function (state, data) {
    state.albanileria_gruesa = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_409" /* SET_BECPRICE_ALBANILERIA_SOLADOS */], function (state, data) {
    state.albanileria_solados = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_410" /* SET_BECPRICE_ASCENSORES */], function (state, data) {
    state.ascensores = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_411" /* SET_BECPRICE_CALEFACCION */], function (state, data) {
    state.calefaccion = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_412" /* SET_BECPRICE_CARPINTERIA_EXTERIOR */], function (state, data) {
    state.carpinteria_exterior = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_413" /* SET_BECPRICE_CARPINTERIA_INTERIOR */], function (state, data) {
    state.carpinteria_interior = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_414" /* SET_BECPRICE_CERRAJERIA */], function (state, data) {
    state.cerrajeria = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_415" /* SET_BECPRICE_CIMENTACION_Y_MURO_SOTANO */], function (state, data) {
    state.cimentacion_y_muro_sotano = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_416" /* SET_BECPRICE_ELECTRICIDAD */], function (state, data) {
    state.electricidad = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_417" /* SET_BECPRICE_ENERGIA_SOLAR_ACS */], function (state, data) {
    state.energia_solar_acs = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_418" /* SET_BECPRICE_ESTRUCTURA */], function (state, data) {
    state.estructura = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_419" /* SET_BECPRICE_FONTANERIA */], function (state, data) {
    state.fontaneria = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_420" /* SET_BECPRICE_FUMISTERIA_Y_MUEBLES_COCINA */], function (state, data) {
    state.fumisteria_y_muebles_cocina = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_421" /* SET_BECPRICE_INSTAL_ESPECIALES */], function (state, data) {
    state.instal_especiales = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_422" /* SET_BECPRICE_JARDINERIA_DECORATIVA */], function (state, data) {
    state.jardineria_decorativa = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_423" /* SET_BECPRICE_MAT_SANITARIO_GRIFERIA */], function (state, data) {
    state.mat_sanitario_griferia = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_424" /* SET_BECPRICE_MOVIMIENTO_TIERRAS */], function (state, data) {
    state.movimiento_tierras = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_425" /* SET_BECPRICE_PERSIANAS */], function (state, data) {
    state.persianas = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_426" /* SET_BECPRICE_PINTURA_Y_ESTUCOS */], function (state, data) {
    state.pintura_y_estucos = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_427" /* SET_BECPRICE_RENOVACION_AIRE */], function (state, data) {
    state.renovacion_aire = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_428" /* SET_BECPRICE_SANEAMIENTO */], function (state, data) {
    state.saneamiento = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_429" /* SET_BECPRICE_SEGURIDAD_Y_SALUD */], function (state, data) {
    state.seguridad_y_salud = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_430" /* SET_BECPRICE_SUBTOTAL */], function (state, data) {
    state.subtotal = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_431" /* SET_BECPRICE_TOTAL */], function (state, data) {
    state.total = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_432" /* SET_BECPRICE_VIDRIERIA */], function (state, data) {
    state.vidrieria = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_433" /* SET_BECPRICE_YESERIA_CIELOSRASOS */], function (state, data) {
    state.yeseria_cielosrasos = data;
    state.dirty = true;
}), _mutations);

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

var getters = {
    becprice: function becprice(state) {
        return state;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    path: null,
    name_ca: null,
    name_en: null,
    name_es: null

};

var state = default_state;

var actions = {

    CREATE_NEW_BECPROPERTY: function CREATE_NEW_BECPROPERTY(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].create({ key: data.key, path: data.path }).then(function (res) {
                var new_created_key = res.key;

                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_381" /* SET_BECPROPERTY_ID */], res.key);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_382" /* SET_BECPROPERTY_DATE_CREATED */], res.date_created);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_383" /* SET_BECPROPERTY_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_384" /* SET_BECPROPERTY_PATH */], res.path);

                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                    value: res.key,
                    path: data.path + new_created_key + '/' + 'id',
                    save_timestamp: false
                }).then(function (res) {
                    return resolve({ key: new_created_key });
                });
            });
        });
    },
    DELETE_BECPROPERTY: function DELETE_BECPROPERTY(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;


        // console.log('DELETE_BECPROPERTY path check: ' + data.path)
        // console.log('DELETE BECPROPERTY parent_path check: ' + data.parent_path)

        // delete from becpropertys/becproperty_key
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.path }).then(function (res) {

            var date_modified = res.date_modified;

            // delete from appraisalfiles/appraisalfile_key/becpropertys/becproperty_key
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.parent_path }).then(function (res) {
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_385" /* RESET_BECPROPERTY */]);
                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                    value: date_modified,
                    path: 'appraisalfiles' + '/' + data.file_id + '/' + 'date_modified',
                    save_timestamp: false
                }).then(function (res) {});
            });
        });
    },
    GET_BECPROPERTY: function GET_BECPROPERTY(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;


        return new Promise(function (resolve, reject) {
            return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                return resolve(res);
            });
        });
    },
    SET_BECPROPERTY: function SET_BECPROPERTY(_ref4, data) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;


        // console.log('set_becproperty data:')
        // console.log(data)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_386" /* SET_BECPROPERTY */], res);
        });
    },
    RESET_BECPROPERTY: function RESET_BECPROPERTY(_ref5) {
        var state = _ref5.state,
            commit = _ref5.commit,
            rootState = _ref5.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_385" /* RESET_BECPROPERTY */]);
    },
    SET_BECPROPERTY_DATE_CREATED: function SET_BECPROPERTY_DATE_CREATED(_ref6, data) {
        var state = _ref6.state,
            commit = _ref6.commit,
            rootState = _ref6.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_382" /* SET_BECPROPERTY_DATE_CREATED */], data);
    },
    SET_BECPROPERTY_DATE_MODIFIED: function SET_BECPROPERTY_DATE_MODIFIED(_ref7, data) {
        var state = _ref7.state,
            commit = _ref7.commit,
            rootState = _ref7.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_383" /* SET_BECPROPERTY_DATE_MODIFIED */], data);
    },
    SET_BECPROPERTY_ID: function SET_BECPROPERTY_ID(_ref8, data) {
        var state = _ref8.state,
            commit = _ref8.commit,
            rootState = _ref8.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_381" /* SET_BECPROPERTY_ID */], data);
    },
    SET_BECPROPERTY_PARENT_PATH: function SET_BECPROPERTY_PARENT_PATH(_ref9, data) {
        var state = _ref9.state,
            commit = _ref9.commit,
            rootState = _ref9.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_387" /* SET_BECPROPERTY_PARENT_PATH */], data);
    },
    SET_BECPROPERTY_PATH: function SET_BECPROPERTY_PATH(_ref10, data) {
        var state = _ref10.state,
            commit = _ref10.commit,
            rootState = _ref10.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_384" /* SET_BECPROPERTY_PATH */], data);
    },
    UPDATE_BECPROPERTY: function UPDATE_BECPROPERTY(_ref11, data) {
        var state = _ref11.state,
            commit = _ref11.commit,
            rootState = _ref11.rootState;

        return new Promise(function (resolve, reject) {
            // console.log('UPDATE_BECPROPERTY data:')
            // console.log(data)
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({ object: data.object, path: data.path + data.key, save_timestamp: true }).then(function (res) {

                var date_modified = res.date_modified;
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_383" /* SET_BECPROPERTY_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_388" /* SET_BECPROPERTY_DIRTYNESS */], false);
            });
        });
    },
    SET_BECPROPERTY_NAME_CA: function SET_BECPROPERTY_NAME_CA(_ref12, data) {
        var state = _ref12.state,
            commit = _ref12.commit,
            rootState = _ref12.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_389" /* SET_BECPROPERTY_NAME_CA */], data);
    },
    SET_BECPROPERTY_NAME_EN: function SET_BECPROPERTY_NAME_EN(_ref13, data) {
        var state = _ref13.state,
            commit = _ref13.commit,
            rootState = _ref13.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_390" /* SET_BECPROPERTY_NAME_EN */], data);
    },
    SET_BECPROPERTY_NAME_ES: function SET_BECPROPERTY_NAME_ES(_ref14, data) {
        var state = _ref14.state,
            commit = _ref14.commit,
            rootState = _ref14.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_391" /* SET_BECPROPERTY_NAME_ES */], data);
    }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_385" /* RESET_BECPROPERTY */], function (state) {
    state.date_created = null;
    state.date_modified = null;
    state.dirty = false;
    state.file_id = null;
    state.id = null;
    state.path = null;
    state.parent_path = null;
    state.name_ca = null;
    state.name_en = null;
    state.name_es = null;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_386" /* SET_BECPROPERTY */], function (state, data) {
    state.date_created = check_undefined(data.date_created);
    state.date_modified = check_undefined(data.date_modified);
    state.dirty = false;
    state.file_id = check_undefined(data.file_id);
    state.id = check_undefined(data.id);
    state.path = check_undefined(data.path);
    state.parent_path = check_undefined(data.parent_path);
    state.name_ca = check_undefined(data.name_ca);
    state.name_en = check_undefined(data.name_en);
    state.name_es = check_undefined(data.name_es);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_382" /* SET_BECPROPERTY_DATE_CREATED */], function (state, data) {
    state.date_created = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_383" /* SET_BECPROPERTY_DATE_MODIFIED */], function (state, data) {
    state.date_modified = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_388" /* SET_BECPROPERTY_DIRTYNESS */], function (state, boolean) {
    state.dirty = boolean;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_381" /* SET_BECPROPERTY_ID */], function (state, data) {
    state.id = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_387" /* SET_BECPROPERTY_PARENT_PATH */], function (state, data) {
    state.parent_path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_384" /* SET_BECPROPERTY_PATH */], function (state, data) {
    state.path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_389" /* SET_BECPROPERTY_NAME_CA */], function (state, data) {
    state.name_ca = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_390" /* SET_BECPROPERTY_NAME_EN */], function (state, data) {
    state.name_en = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_391" /* SET_BECPROPERTY_NAME_ES */], function (state, data) {
    state.name_es = data;
    state.dirty = true;
}), _mutations);

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

var getters = {
    becproperty: function becproperty(state) {
        return state;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    becprices: {}
};
var state = default_state;

var actions = {
    FETCH_BECPROPERTY_BECPRICES: function FETCH_BECPROPERTY_BECPRICES(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        // console.log('data.path (fetch_becproperty_becprices) ---->')
        // console.log(data.path)
        return new Promise(function (resolve, reject) {
            var becprices = null;

            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                // console.log(res)
                becprices = res;
                // console.log('becprices: ')
                // console.log(becprices)

                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_380" /* SET_BECPROPERTY_BECPRICES */], becprices);
                resolve();
                // console.log('****** becprices: ')
                // console.log(becprices)
            });
        });
    }
};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__constants__["_380" /* SET_BECPROPERTY_BECPRICES */], function (state, data) {
    state.becprices = data;
});

var getters = {
    becproperty_becprices: function becproperty_becprices(state) {
        return state.becprices;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    path: null,
    name_ca: null,
    name_en: null,
    name_es: null,
    url: null,
    filename: null

};

var state = default_state;

var actions = {

    CREATE_NEW_CADASTERANNEX: function CREATE_NEW_CADASTERANNEX(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].create({ key: data.key, path: data.path }).then(function (res) {
                var new_created_key = res.key;

                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_10" /* SET_CADASTERANNEX_ID */], res.key);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_11" /* SET_CADASTERANNEX_DATE_CREATED */], res.date_created);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_12" /* SET_CADASTERANNEX_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_13" /* SET_CADASTERANNEX_PATH */], res.path);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_14" /* SET_CADASTERANNEX_PARENT_PATH */], data.parent_path);

                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                    value: res.key,
                    path: data.path + new_created_key + '/' + 'id',
                    save_timestamp: false
                }).then(function (res) {
                    return resolve({ key: new_created_key });
                });
            });
        });
    },
    DELETE_CADASTERANNEX: function DELETE_CADASTERANNEX(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;


        // console.log('DELETE_CADASTERANNEX path check: ' + data.path)
        // console.log('DELETE CADASTERANNEX parent_path check: ' + data.parent_path)

        // delete from cadasterannexes/cadasterannex_key
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.path }).then(function (res) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].deleteImage({ path: data.path, filename: data.filename });
        });
    },
    GET_CADASTERANNEX: function GET_CADASTERANNEX(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;


        return new Promise(function (resolve, reject) {
            return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                return resolve(res);
            });
        });
    },
    SET_CADASTERANNEX: function SET_CADASTERANNEX(_ref4, data) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;


        // console.log('set_cadasterannex data:')
        // console.log(data)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_15" /* SET_CADASTERANNEX */], res);
        });
    },
    RESET_CADASTERANNEX: function RESET_CADASTERANNEX(_ref5) {
        var state = _ref5.state,
            commit = _ref5.commit,
            rootState = _ref5.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_16" /* RESET_CADASTERANNEX */]);
    },
    SET_CADASTERANNEX_REPORTDATE: function (_SET_CADASTERANNEX_REPORTDATE) {
        function SET_CADASTERANNEX_REPORTDATE(_x, _x2) {
            return _SET_CADASTERANNEX_REPORTDATE.apply(this, arguments);
        }

        SET_CADASTERANNEX_REPORTDATE.toString = function () {
            return _SET_CADASTERANNEX_REPORTDATE.toString();
        };

        return SET_CADASTERANNEX_REPORTDATE;
    }(function (_ref6, data) {
        var state = _ref6.state,
            commit = _ref6.commit,
            rootState = _ref6.rootState;

        commit(SET_CADASTERANNEX_REPORTDATE, data);
    }),
    SET_CADASTERANNEX_DATE_CREATED: function SET_CADASTERANNEX_DATE_CREATED(_ref7, data) {
        var state = _ref7.state,
            commit = _ref7.commit,
            rootState = _ref7.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_11" /* SET_CADASTERANNEX_DATE_CREATED */], data);
    },
    SET_CADASTERANNEX_DATE_MODIFIED: function SET_CADASTERANNEX_DATE_MODIFIED(_ref8, data) {
        var state = _ref8.state,
            commit = _ref8.commit,
            rootState = _ref8.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_12" /* SET_CADASTERANNEX_DATE_MODIFIED */], data);
    },

    SET_CADASTERANNEX_ID: function SET_CADASTERANNEX_ID(_ref9, data) {
        var state = _ref9.state,
            commit = _ref9.commit,
            rootState = _ref9.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_10" /* SET_CADASTERANNEX_ID */], data);
    },
    SET_CADASTERANNEX_PARENT_PATH: function SET_CADASTERANNEX_PARENT_PATH(_ref10, data) {
        var state = _ref10.state,
            commit = _ref10.commit,
            rootState = _ref10.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_14" /* SET_CADASTERANNEX_PARENT_PATH */], data);
    },
    SET_CADASTERANNEX_PATH: function SET_CADASTERANNEX_PATH(_ref11, data) {
        var state = _ref11.state,
            commit = _ref11.commit,
            rootState = _ref11.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_13" /* SET_CADASTERANNEX_PATH */], data);
    },
    UPDATE_CADASTERANNEX: function UPDATE_CADASTERANNEX(_ref12, data) {
        var state = _ref12.state,
            commit = _ref12.commit,
            rootState = _ref12.rootState;

        return new Promise(function (resolve, reject) {
            // console.log('UPDATE_CADASTERANNEX data:')
            // console.log(data)
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({ object: data.object, path: data.path + data.key, save_timestamp: true }).then(function (res) {

                var date_modified = res.date_modified;
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_12" /* SET_CADASTERANNEX_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_17" /* SET_CADASTERANNEX_DIRTYNESS */], false);
                resolve();
            });
        });
    },
    SET_CADASTERANNEX_NAME_CA: function SET_CADASTERANNEX_NAME_CA(_ref13, data) {
        var state = _ref13.state,
            commit = _ref13.commit,
            rootState = _ref13.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_18" /* SET_CADASTERANNEX_NAME_CA */], data);
    },
    SET_CADASTERANNEX_NAME_EN: function SET_CADASTERANNEX_NAME_EN(_ref14, data) {
        var state = _ref14.state,
            commit = _ref14.commit,
            rootState = _ref14.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_19" /* SET_CADASTERANNEX_NAME_EN */], data);
    },
    SET_CADASTERANNEX_NAME_ES: function SET_CADASTERANNEX_NAME_ES(_ref15, data) {
        var state = _ref15.state,
            commit = _ref15.commit,
            rootState = _ref15.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_20" /* SET_CADASTERANNEX_NAME_ES */], data);
    },
    SET_CADASTERANNEX_URL: function SET_CADASTERANNEX_URL(_ref16, data) {
        var state = _ref16.state,
            commit = _ref16.commit,
            rootState = _ref16.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_21" /* SET_CADASTERANNEX_URL */], data);
    },
    SET_CADASTERANNEX_FILENAME: function SET_CADASTERANNEX_FILENAME(_ref17, data) {
        var state = _ref17.state,
            commit = _ref17.commit,
            rootState = _ref17.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_22" /* SET_CADASTERANNEX_FILENAME */], data);
    }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_16" /* RESET_CADASTERANNEX */], function (state) {
    state.date_created = null;
    state.date_modified = null;
    state.dirty = false;
    state.file_id = null;
    state.id = null;
    state.path = null;
    state.parent_path = null;
    state.name_ca = null;
    state.name_en = null;
    state.name_es = null;
    state.url = null;
    state.filename = null;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_15" /* SET_CADASTERANNEX */], function (state, data) {
    state.date_created = check_undefined(data.date_created);
    state.date_modified = check_undefined(data.date_modified);
    state.dirty = false;
    state.file_id = check_undefined(data.file_id);
    state.id = check_undefined(data.id);
    state.path = check_undefined(data.path);
    state.parent_path = check_undefined(data.parent_path);
    state.name_ca = check_undefined(data.name_ca);
    state.name_en = check_undefined(data.name_en);
    state.name_es = check_undefined(data.name_es);
    state.url = check_undefined(data.url);
    state.filename = check_undefined(data.filename);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_11" /* SET_CADASTERANNEX_DATE_CREATED */], function (state, data) {
    state.date_created = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_12" /* SET_CADASTERANNEX_DATE_MODIFIED */], function (state, data) {
    state.date_modified = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_17" /* SET_CADASTERANNEX_DIRTYNESS */], function (state, boolean) {
    state.dirty = boolean;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_10" /* SET_CADASTERANNEX_ID */], function (state, data) {
    state.id = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_14" /* SET_CADASTERANNEX_PARENT_PATH */], function (state, data) {
    state.parent_path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_13" /* SET_CADASTERANNEX_PATH */], function (state, data) {
    state.path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_18" /* SET_CADASTERANNEX_NAME_CA */], function (state, data) {
    state.name_ca = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_19" /* SET_CADASTERANNEX_NAME_EN */], function (state, data) {
    state.name_en = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_20" /* SET_CADASTERANNEX_NAME_ES */], function (state, data) {
    state.name_es = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_21" /* SET_CADASTERANNEX_URL */], function (state, data) {
    state.url = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_22" /* SET_CADASTERANNEX_FILENAME */], function (state, data) {
    state.filename = data;
    state.dirty = true;
}), _mutations);

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

var getters = {
    cadasterannex: function cadasterannex(state) {
        return state;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    path: null,
    name_ca: null,
    name_en: null,
    name_es: null,
    url: null,
    filename: null

};

var state = default_state;

var actions = {

    CREATE_NEW_CESSIONANNEX: function CREATE_NEW_CESSIONANNEX(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].create({ key: data.key, path: data.path }).then(function (res) {
                var new_created_key = res.key;

                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["x" /* SET_CESSIONANNEX_ID */], res.key);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["y" /* SET_CESSIONANNEX_DATE_CREATED */], res.date_created);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["z" /* SET_CESSIONANNEX_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["A" /* SET_CESSIONANNEX_PATH */], res.path);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["B" /* SET_CESSIONANNEX_PARENT_PATH */], data.parent_path);

                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                    value: res.key,
                    path: data.path + new_created_key + '/' + 'id',
                    save_timestamp: false
                }).then(function (res) {
                    return resolve({ key: new_created_key });
                });
            });
        });
    },
    DELETE_CESSIONANNEX: function DELETE_CESSIONANNEX(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;


        // console.log('DELETE_CESSIONANNEX path check: ' + data.path)
        // console.log('DELETE CESSIONANNEX parent_path check: ' + data.parent_path)

        // delete from cessionannexes/cessionannex_key
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.path }).then(function (res) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].deleteImage({ path: data.path, filename: data.filename });
        });
    },
    GET_CESSIONANNEX: function GET_CESSIONANNEX(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;


        return new Promise(function (resolve, reject) {
            return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                return resolve(res);
            });
        });
    },
    SET_CESSIONANNEX: function SET_CESSIONANNEX(_ref4, data) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;


        // console.log('set_cessionannex data:')
        // console.log(data)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["C" /* SET_CESSIONANNEX */], res);
        });
    },
    RESET_CESSIONANNEX: function RESET_CESSIONANNEX(_ref5) {
        var state = _ref5.state,
            commit = _ref5.commit,
            rootState = _ref5.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["D" /* RESET_CESSIONANNEX */]);
    },
    SET_CESSIONANNEX_REPORTDATE: function (_SET_CESSIONANNEX_REPORTDATE) {
        function SET_CESSIONANNEX_REPORTDATE(_x, _x2) {
            return _SET_CESSIONANNEX_REPORTDATE.apply(this, arguments);
        }

        SET_CESSIONANNEX_REPORTDATE.toString = function () {
            return _SET_CESSIONANNEX_REPORTDATE.toString();
        };

        return SET_CESSIONANNEX_REPORTDATE;
    }(function (_ref6, data) {
        var state = _ref6.state,
            commit = _ref6.commit,
            rootState = _ref6.rootState;

        commit(SET_CESSIONANNEX_REPORTDATE, data);
    }),
    SET_CESSIONANNEX_DATE_CREATED: function SET_CESSIONANNEX_DATE_CREATED(_ref7, data) {
        var state = _ref7.state,
            commit = _ref7.commit,
            rootState = _ref7.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["y" /* SET_CESSIONANNEX_DATE_CREATED */], data);
    },
    SET_CESSIONANNEX_DATE_MODIFIED: function SET_CESSIONANNEX_DATE_MODIFIED(_ref8, data) {
        var state = _ref8.state,
            commit = _ref8.commit,
            rootState = _ref8.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["z" /* SET_CESSIONANNEX_DATE_MODIFIED */], data);
    },

    SET_CESSIONANNEX_ID: function SET_CESSIONANNEX_ID(_ref9, data) {
        var state = _ref9.state,
            commit = _ref9.commit,
            rootState = _ref9.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["x" /* SET_CESSIONANNEX_ID */], data);
    },
    SET_CESSIONANNEX_PARENT_PATH: function SET_CESSIONANNEX_PARENT_PATH(_ref10, data) {
        var state = _ref10.state,
            commit = _ref10.commit,
            rootState = _ref10.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["B" /* SET_CESSIONANNEX_PARENT_PATH */], data);
    },
    SET_CESSIONANNEX_PATH: function SET_CESSIONANNEX_PATH(_ref11, data) {
        var state = _ref11.state,
            commit = _ref11.commit,
            rootState = _ref11.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["A" /* SET_CESSIONANNEX_PATH */], data);
    },
    UPDATE_CESSIONANNEX: function UPDATE_CESSIONANNEX(_ref12, data) {
        var state = _ref12.state,
            commit = _ref12.commit,
            rootState = _ref12.rootState;

        return new Promise(function (resolve, reject) {
            // console.log('UPDATE_CESSIONANNEX data:')
            // console.log(data)
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({ object: data.object, path: data.path + data.key, save_timestamp: true }).then(function (res) {

                var date_modified = res.date_modified;
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["z" /* SET_CESSIONANNEX_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["E" /* SET_CESSIONANNEX_DIRTYNESS */], false);
                resolve();
            });
        });
    },
    SET_CESSIONANNEX_NAME_CA: function SET_CESSIONANNEX_NAME_CA(_ref13, data) {
        var state = _ref13.state,
            commit = _ref13.commit,
            rootState = _ref13.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["F" /* SET_CESSIONANNEX_NAME_CA */], data);
    },
    SET_CESSIONANNEX_NAME_EN: function SET_CESSIONANNEX_NAME_EN(_ref14, data) {
        var state = _ref14.state,
            commit = _ref14.commit,
            rootState = _ref14.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["G" /* SET_CESSIONANNEX_NAME_EN */], data);
    },
    SET_CESSIONANNEX_NAME_ES: function SET_CESSIONANNEX_NAME_ES(_ref15, data) {
        var state = _ref15.state,
            commit = _ref15.commit,
            rootState = _ref15.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["H" /* SET_CESSIONANNEX_NAME_ES */], data);
    },
    SET_CESSIONANNEX_URL: function SET_CESSIONANNEX_URL(_ref16, data) {
        var state = _ref16.state,
            commit = _ref16.commit,
            rootState = _ref16.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["I" /* SET_CESSIONANNEX_URL */], data);
    },
    SET_CESSIONANNEX_FILENAME: function SET_CESSIONANNEX_FILENAME(_ref17, data) {
        var state = _ref17.state,
            commit = _ref17.commit,
            rootState = _ref17.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["J" /* SET_CESSIONANNEX_FILENAME */], data);
    }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["D" /* RESET_CESSIONANNEX */], function (state) {
    state.date_created = null;
    state.date_modified = null;
    state.dirty = false;
    state.file_id = null;
    state.id = null;
    state.path = null;
    state.parent_path = null;
    state.name_ca = null;
    state.name_en = null;
    state.name_es = null;
    state.url = null;
    state.filename = null;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["C" /* SET_CESSIONANNEX */], function (state, data) {
    state.date_created = check_undefined(data.date_created);
    state.date_modified = check_undefined(data.date_modified);
    state.dirty = false;
    state.file_id = check_undefined(data.file_id);
    state.id = check_undefined(data.id);
    state.path = check_undefined(data.path);
    state.parent_path = check_undefined(data.parent_path);
    state.name_ca = check_undefined(data.name_ca);
    state.name_en = check_undefined(data.name_en);
    state.name_es = check_undefined(data.name_es);
    state.url = check_undefined(data.url);
    state.filename = check_undefined(data.filename);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["y" /* SET_CESSIONANNEX_DATE_CREATED */], function (state, data) {
    state.date_created = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["z" /* SET_CESSIONANNEX_DATE_MODIFIED */], function (state, data) {
    state.date_modified = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["E" /* SET_CESSIONANNEX_DIRTYNESS */], function (state, boolean) {
    state.dirty = boolean;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["x" /* SET_CESSIONANNEX_ID */], function (state, data) {
    state.id = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["B" /* SET_CESSIONANNEX_PARENT_PATH */], function (state, data) {
    state.parent_path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["A" /* SET_CESSIONANNEX_PATH */], function (state, data) {
    state.path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["F" /* SET_CESSIONANNEX_NAME_CA */], function (state, data) {
    state.name_ca = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["G" /* SET_CESSIONANNEX_NAME_EN */], function (state, data) {
    state.name_en = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["H" /* SET_CESSIONANNEX_NAME_ES */], function (state, data) {
    state.name_es = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["I" /* SET_CESSIONANNEX_URL */], function (state, data) {
    state.url = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["J" /* SET_CESSIONANNEX_FILENAME */], function (state, data) {
    state.filename = data;
    state.dirty = true;
}), _mutations);

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

var getters = {
    cessionannex: function cessionannex(state) {
        return state;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    path: null,
    name_ca: null,
    name_en: null,
    name_es: null,
    default_constraints: null

};

var state = default_state;

var actions = {

    CREATE_NEW_CONSTRAINT: function CREATE_NEW_CONSTRAINT(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].create({ key: data.key, path: data.path }).then(function (res) {
                var new_created_key = res.key;

                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_82" /* SET_CONSTRAINT_ID */], res.key);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_83" /* SET_CONSTRAINT_DATE_CREATED */], res.date_created);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_84" /* SET_CONSTRAINT_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_85" /* SET_CONSTRAINT_PATH */], res.path);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_86" /* SET_CONSTRAINT_PARENT_PATH */], data.parent_path);

                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                    value: res.key,
                    path: data.path + new_created_key + '/' + 'id',
                    save_timestamp: false
                }).then(function (res) {
                    return resolve({ key: new_created_key });
                });
            });
        });
    },
    DELETE_CONSTRAINT: function DELETE_CONSTRAINT(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;


        // console.log('DELETE_CONSTRAINT path check: ' + data.path)
        // console.log('DELETE CONSTRAINT parent_path check: ' + data.parent_path)

        // delete from constraints/constraint_key
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.path }).then(function (res) {});
    },
    GET_CONSTRAINT: function GET_CONSTRAINT(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;


        return new Promise(function (resolve, reject) {
            return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                return resolve(res);
            });
        });
    },
    SET_CONSTRAINT: function SET_CONSTRAINT(_ref4, data) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;


        // console.log('set_constraint data:')
        // console.log(data)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_87" /* SET_CONSTRAINT */], res);
        });
    },
    RESET_CONSTRAINT: function RESET_CONSTRAINT(_ref5) {
        var state = _ref5.state,
            commit = _ref5.commit,
            rootState = _ref5.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_88" /* RESET_CONSTRAINT */]);
    },
    SET_CONSTRAINT_REPORTDATE: function (_SET_CONSTRAINT_REPORTDATE) {
        function SET_CONSTRAINT_REPORTDATE(_x, _x2) {
            return _SET_CONSTRAINT_REPORTDATE.apply(this, arguments);
        }

        SET_CONSTRAINT_REPORTDATE.toString = function () {
            return _SET_CONSTRAINT_REPORTDATE.toString();
        };

        return SET_CONSTRAINT_REPORTDATE;
    }(function (_ref6, data) {
        var state = _ref6.state,
            commit = _ref6.commit,
            rootState = _ref6.rootState;

        commit(SET_CONSTRAINT_REPORTDATE, data);
    }),
    SET_CONSTRAINT_DATE_CREATED: function SET_CONSTRAINT_DATE_CREATED(_ref7, data) {
        var state = _ref7.state,
            commit = _ref7.commit,
            rootState = _ref7.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_83" /* SET_CONSTRAINT_DATE_CREATED */], data);
    },
    SET_CONSTRAINT_DATE_MODIFIED: function SET_CONSTRAINT_DATE_MODIFIED(_ref8, data) {
        var state = _ref8.state,
            commit = _ref8.commit,
            rootState = _ref8.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_84" /* SET_CONSTRAINT_DATE_MODIFIED */], data);
    },

    SET_CONSTRAINT_ID: function SET_CONSTRAINT_ID(_ref9, data) {
        var state = _ref9.state,
            commit = _ref9.commit,
            rootState = _ref9.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_82" /* SET_CONSTRAINT_ID */], data);
    },
    SET_CONSTRAINT_PARENT_PATH: function SET_CONSTRAINT_PARENT_PATH(_ref10, data) {
        var state = _ref10.state,
            commit = _ref10.commit,
            rootState = _ref10.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_86" /* SET_CONSTRAINT_PARENT_PATH */], data);
    },
    SET_CONSTRAINT_PATH: function SET_CONSTRAINT_PATH(_ref11, data) {
        var state = _ref11.state,
            commit = _ref11.commit,
            rootState = _ref11.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_85" /* SET_CONSTRAINT_PATH */], data);
    },
    UPDATE_CONSTRAINT: function UPDATE_CONSTRAINT(_ref12, data) {
        var state = _ref12.state,
            commit = _ref12.commit,
            rootState = _ref12.rootState;

        return new Promise(function (resolve, reject) {
            // console.log('UPDATE_CONSTRAINT data:')
            // console.log(data)
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({ object: data.object, path: data.path + data.key, save_timestamp: true }).then(function (res) {

                var date_modified = res.date_modified;
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_84" /* SET_CONSTRAINT_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_89" /* SET_CONSTRAINT_DIRTYNESS */], false);
                resolve();
            });
        });
    },
    SET_CONSTRAINT_NAME_CA: function SET_CONSTRAINT_NAME_CA(_ref13, data) {
        var state = _ref13.state,
            commit = _ref13.commit,
            rootState = _ref13.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_90" /* SET_CONSTRAINT_NAME_CA */], data);
    },
    SET_CONSTRAINT_NAME_EN: function SET_CONSTRAINT_NAME_EN(_ref14, data) {
        var state = _ref14.state,
            commit = _ref14.commit,
            rootState = _ref14.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_91" /* SET_CONSTRAINT_NAME_EN */], data);
    },
    SET_CONSTRAINT_NAME_ES: function SET_CONSTRAINT_NAME_ES(_ref15, data) {
        var state = _ref15.state,
            commit = _ref15.commit,
            rootState = _ref15.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_92" /* SET_CONSTRAINT_NAME_ES */], data);
    },
    SET_CONSTRAINT_DEFAULT_CONSTRAINTS: function SET_CONSTRAINT_DEFAULT_CONSTRAINTS(_ref16, data) {
        var state = _ref16.state,
            commit = _ref16.commit,
            rootState = _ref16.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_93" /* SET_CONSTRAINT_DEFAULT_CONSTRAINTS */], data);
    }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_88" /* RESET_CONSTRAINT */], function (state) {
    state.date_created = null;
    state.date_modified = null;
    state.dirty = false;
    state.file_id = null;
    state.id = null;
    state.path = null;
    state.parent_path = null;
    state.name_ca = null;
    state.name_en = null;
    state.name_es = null;
    state.default_constraints = null;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_87" /* SET_CONSTRAINT */], function (state, data) {
    state.date_created = check_undefined(data.date_created);
    state.date_modified = check_undefined(data.date_modified);
    state.dirty = false;
    state.file_id = check_undefined(data.file_id);
    state.id = check_undefined(data.id);
    state.path = check_undefined(data.path);
    state.parent_path = check_undefined(data.parent_path);
    state.name_ca = check_undefined(data.name_ca);
    state.name_en = check_undefined(data.name_en);
    state.name_es = check_undefined(data.name_es);
    state.default_constraints = check_undefined(data.default_constraints);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_83" /* SET_CONSTRAINT_DATE_CREATED */], function (state, data) {
    state.date_created = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_84" /* SET_CONSTRAINT_DATE_MODIFIED */], function (state, data) {
    state.date_modified = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_89" /* SET_CONSTRAINT_DIRTYNESS */], function (state, boolean) {
    state.dirty = boolean;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_82" /* SET_CONSTRAINT_ID */], function (state, data) {
    state.id = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_86" /* SET_CONSTRAINT_PARENT_PATH */], function (state, data) {
    state.parent_path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_85" /* SET_CONSTRAINT_PATH */], function (state, data) {
    state.path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_90" /* SET_CONSTRAINT_NAME_CA */], function (state, data) {
    state.name_ca = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_91" /* SET_CONSTRAINT_NAME_EN */], function (state, data) {
    state.name_en = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_92" /* SET_CONSTRAINT_NAME_ES */], function (state, data) {
    state.name_es = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_93" /* SET_CONSTRAINT_DEFAULT_CONSTRAINTS */], function (state, data) {
    state.default_constraints = data;
    state.dirty = true;
}), _mutations);

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

var getters = {
    constraint: function constraint(state) {
        return state;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    main_email: null,
    name: null,
    organization: null,
    path: null,
    person_type: null,
    representative: null,
    representative_tin: null,
    surnames: null,
    tin: null,
    title: null,
    complete_name: null,
    complete_fiscal_address: null,
    main_telephonenumber: null

};
var state = default_state;

var actions = {
    CREATE_NEW_CONTACT: function CREATE_NEW_CONTACT(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;

        return new Promise(function (resolve, reject) {

            // cal fer un RESET CONTACT aquí??? estava així, l'hem tret al treballr la cració de contactes dinpamica des de pressupost
            // commit(RESET_CONTACT)
            // resposta: sí, si es crea des de lapartat de contactes, no si es fa des de un import des de pressupost per exemple, per tant:

            if (data.creating_from_main) {
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_352" /* RESET_CONTACT */]);
            }

            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].create({ path: data.path }).then(function (res) {
                var new_created_key = res.key;
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_353" /* SET_CONTACT_ID */], res.key);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_354" /* SET_CONTACT_DATE_CREATED */], res.date_created);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_355" /* SET_CONTACT_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_356" /* SET_CONTACT_PATH */], res.path);
                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                    value: new_created_key,
                    path: data.path + '/' + new_created_key + '/' + 'id',
                    save_timestamp: false
                }).then(function (res) {
                    return resolve({ key: new_created_key });
                });
            });
        });
    },
    DELETE_CONTACT: function DELETE_CONTACT(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;


        console.log('path check: ' + data.path);
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.path }).then(function (res) {
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_352" /* RESET_CONTACT */]);

            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: 'contact_addresses' + '/' + data.key }).then(function (res) {});
        });
    },
    RESET_CONTACT: function RESET_CONTACT(_ref3) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_352" /* RESET_CONTACT */]);
    },
    SET_CONTACT: function SET_CONTACT(_ref4, data) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;


        console.log('set_contact data:');
        console.log(data);
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_357" /* SET_CONTACT */], res);
        });
    },
    SET_CONTACT_DATE_CREATED: function SET_CONTACT_DATE_CREATED(_ref5, data) {
        var state = _ref5.state,
            commit = _ref5.commit,
            rootState = _ref5.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_354" /* SET_CONTACT_DATE_CREATED */], data);
    },
    SET_CONTACT_DATE_MODIFIED: function SET_CONTACT_DATE_MODIFIED(_ref6, data) {
        var state = _ref6.state,
            commit = _ref6.commit,
            rootState = _ref6.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_355" /* SET_CONTACT_DATE_MODIFIED */], data);
    },
    SET_CONTACT_ID: function SET_CONTACT_ID(_ref7, data) {
        var state = _ref7.state,
            commit = _ref7.commit,
            rootState = _ref7.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_353" /* SET_CONTACT_ID */], data);
    },
    SET_CONTACT_EMAILADDRESSES: function SET_CONTACT_EMAILADDRESSES(_ref8, data) {
        var state = _ref8.state,
            commit = _ref8.commit,
            rootState = _ref8.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_339" /* SET_CONTACT_EMAILADDRESSES */], data);
    },
    SET_CONTACT_MAIN_EMAIL: function SET_CONTACT_MAIN_EMAIL(_ref9, data) {
        var state = _ref9.state,
            commit = _ref9.commit,
            rootState = _ref9.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_358" /* SET_CONTACT_MAIN_EMAIL */], data);
    },
    SET_CONTACT_NAME: function SET_CONTACT_NAME(_ref10, name) {
        var state = _ref10.state,
            commit = _ref10.commit,
            rootState = _ref10.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_359" /* SET_CONTACT_NAME */], name);
    },
    SET_CONTACT_ORGANIZATION: function SET_CONTACT_ORGANIZATION(_ref11, name) {
        var state = _ref11.state,
            commit = _ref11.commit,
            rootState = _ref11.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_360" /* SET_CONTACT_ORGANIZATION */], name);
    },
    SET_CONTACT_PATH: function SET_CONTACT_PATH(_ref12, data) {
        var state = _ref12.state,
            commit = _ref12.commit,
            rootState = _ref12.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_356" /* SET_CONTACT_PATH */], data);
    },
    SET_CONTACT_PERSON_TYPE: function SET_CONTACT_PERSON_TYPE(_ref13, person_type) {
        var state = _ref13.state,
            commit = _ref13.commit,
            rootState = _ref13.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_361" /* SET_CONTACT_PERSON_TYPE */], person_type);
    },
    SET_CONTACT_REPRESENTATIVE: function SET_CONTACT_REPRESENTATIVE(_ref14, name) {
        var state = _ref14.state,
            commit = _ref14.commit,
            rootState = _ref14.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_362" /* SET_CONTACT_REPRESENTATIVE */], name);
    },
    SET_CONTACT_REPRESENTATIVE_TIN: function SET_CONTACT_REPRESENTATIVE_TIN(_ref15, name) {
        var state = _ref15.state,
            commit = _ref15.commit,
            rootState = _ref15.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_363" /* SET_CONTACT_REPRESENTATIVE_TIN */], name);
    },
    SET_CONTACT_SURNAMES: function SET_CONTACT_SURNAMES(_ref16, surnames) {
        var state = _ref16.state,
            commit = _ref16.commit,
            rootState = _ref16.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_364" /* SET_CONTACT_SURNAMES */], surnames);
    },
    SET_CONTACT_TELEPHONENUMBERS: function SET_CONTACT_TELEPHONENUMBERS(_ref17, telephonenumbers) {
        var state = _ref17.state,
            commit = _ref17.commit,
            rootState = _ref17.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_338" /* SET_CONTACT_TELEPHONENUMBERS */], telephonenumbers);
    },
    SET_CONTACT_TIN: function SET_CONTACT_TIN(_ref18, tin) {
        var state = _ref18.state,
            commit = _ref18.commit,
            rootState = _ref18.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_365" /* SET_CONTACT_TIN */], tin);
    },
    SET_CONTACT_TITLE: function SET_CONTACT_TITLE(_ref19, title) {
        var state = _ref19.state,
            commit = _ref19.commit,
            rootState = _ref19.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_366" /* SET_CONTACT_TITLE */], title);
    },
    SET_CONTACT_COMPLETE_NAME: function SET_CONTACT_COMPLETE_NAME(_ref20, data) {
        var state = _ref20.state,
            commit = _ref20.commit,
            rootState = _ref20.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_367" /* SET_CONTACT_COMPLETE_NAME */], data);
    },
    SET_CONTACT_COMPLETE_FISCAL_ADDRESS: function SET_CONTACT_COMPLETE_FISCAL_ADDRESS(_ref21, data) {
        var state = _ref21.state,
            commit = _ref21.commit,
            rootState = _ref21.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_368" /* SET_CONTACT_COMPLETE_FISCAL_ADDRESS */], data);
    },
    SET_CONTACT_MAIN_TELEPHONENUMBER: function SET_CONTACT_MAIN_TELEPHONENUMBER(_ref22, data) {
        var state = _ref22.state,
            commit = _ref22.commit,
            rootState = _ref22.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_369" /* SET_CONTACT_MAIN_TELEPHONENUMBER */], data);
    },
    UPDATE_CONTACT: function UPDATE_CONTACT(_ref23, data) {
        var state = _ref23.state,
            commit = _ref23.commit,
            rootState = _ref23.rootState;

        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({ object: data.object, path: data.path, save_timestamp: true }).then(function (res) {
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_355" /* SET_CONTACT_DATE_MODIFIED */], res.date_modified);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_370" /* SET_CONTACT_DIRTYNESS */], false);
        });
    }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_352" /* RESET_CONTACT */], function (state) {
    state.date_created = null;
    state.date_modified = null;
    state.id = null;
    state.main_email = null;
    state.name = null;
    state.organization = null;
    state.path = null;
    state.person_type = null;
    state.representative = null;
    state.representative_tin = null;
    state.surnames = null;
    state.tin = null;
    state.title = null;
    state.dirty = false;
    state.complete_name = null;
    state.complete_fiscal_address = null;
    state.main_telephonenumber = null;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_357" /* SET_CONTACT */], function (state, data) {
    // console.log('mutations SET_CONTACT data: ')
    //  console.log(data)
    state.date_created = check_undefined(data.date_created);
    state.date_modified = check_undefined(data.date_modified);
    state.id = check_undefined(data.id);
    state.main_email = check_undefined(data.main_email);
    state.name = check_undefined(data.name);
    state.organization = check_undefined(data.organization);
    state.path = check_undefined(data.path);
    state.person_type = check_undefined(data.person_type);
    state.representative = check_undefined(data.representative);
    state.representative_tin = check_undefined(data.representative_tin);
    state.surnames = check_undefined(data.surnames);
    state.tin = check_undefined(data.tin);
    state.title = check_undefined(data.title);
    state.dirty = false;
    state.complete_name = check_undefined(data.complete_name);
    state.complete_fiscal_address = check_undefined(data.complete_fiscal_address);
    state.main_telephonenumber = check_undefined(data.main_telephonenumber);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_354" /* SET_CONTACT_DATE_CREATED */], function (state, data) {
    state.date_created = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_355" /* SET_CONTACT_DATE_MODIFIED */], function (state, data) {
    state.date_modified = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_370" /* SET_CONTACT_DIRTYNESS */], function (state, boolean) {
    state.dirty = boolean;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_353" /* SET_CONTACT_ID */], function (state, data) {
    state.id = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_339" /* SET_CONTACT_EMAILADDRESSES */], function (state, emailaddresses) {
    state.emailaddresses = emailaddresses;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_358" /* SET_CONTACT_MAIN_EMAIL */], function (state, data) {
    state.main_email = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_359" /* SET_CONTACT_NAME */], function (state, name) {
    state.name = name;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_360" /* SET_CONTACT_ORGANIZATION */], function (state, data) {
    state.organization = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_356" /* SET_CONTACT_PATH */], function (state, data) {
    state.path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_361" /* SET_CONTACT_PERSON_TYPE */], function (state, person_type) {
    state.person_type = person_type;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_362" /* SET_CONTACT_REPRESENTATIVE */], function (state, data) {
    state.representative = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_363" /* SET_CONTACT_REPRESENTATIVE_TIN */], function (state, data) {
    state.representative_tin = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_364" /* SET_CONTACT_SURNAMES */], function (state, surnames) {
    state.surnames = surnames;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_338" /* SET_CONTACT_TELEPHONENUMBERS */], function (state, telephonenumbers) {
    state.telephonenumbers = telephonenumbers;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_365" /* SET_CONTACT_TIN */], function (state, tin) {
    state.tin = tin;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_366" /* SET_CONTACT_TITLE */], function (state, title) {
    state.title = title;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_367" /* SET_CONTACT_COMPLETE_NAME */], function (state, data) {
    state.complete_name = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_368" /* SET_CONTACT_COMPLETE_FISCAL_ADDRESS */], function (state, data) {
    state.complete_fiscal_address = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_369" /* SET_CONTACT_MAIN_TELEPHONENUMBER */], function (state, data) {
    state.main_telephonenumber = data;
    state.dirty = true;
}), _mutations);

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

var getters = {

    contact: function contact(state) {
        return state;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    addresses: {}
};
var state = default_state;

var actions = {
    FETCH_CONTACT_ADDRESSES: function FETCH_CONTACT_ADDRESSES(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;

        return new Promise(function (resolve, reject) {

            // console.log('data.path (fetch_contact_addresses) ---->')
            // console.log(data.path)
            return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                // console.log(res)
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_340" /* SET_CONTACT_ADDRESSES */], res);
                resolve();
            });
        });
    }
};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__constants__["_340" /* SET_CONTACT_ADDRESSES */], function (state, data) {
    state.addresses = data;
});

var getters = {
    contact_addresses: function contact_addresses(state) {
        return state.addresses;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    appraisalinvoices: {}
};
var state = default_state;

var actions = {
    FETCH_CONTACT_APPRAISALINVOICES: function FETCH_CONTACT_APPRAISALINVOICES(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;

        return new Promise(function (resolve, reject) {

            // console.log('data.path (fetch_contact_appraisalinvoices) ---->')
            // console.log(data.path)
            return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                // console.log(res)
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_337" /* SET_CONTACT_APPRAISALINVOICES */], res);
                resolve();
            });
        });
    }
};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__constants__["_337" /* SET_CONTACT_APPRAISALINVOICES */], function (state, data) {
    state.appraisalinvoices = data;
});

var getters = {
    contact_appraisalinvoices: function contact_appraisalinvoices(state) {
        return state.appraisalinvoices;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    appraisalquotes: {}
};
var state = default_state;

var actions = {
    FETCH_CONTACT_APPRAISALQUOTES: function FETCH_CONTACT_APPRAISALQUOTES(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        return new Promise(function (resolve, reject) {
            // console.log('data.path (fetch_contact_appraisalquotes) ---->')
            // console.log(data.path)
            return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                // console.log(res)
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_336" /* SET_CONTACT_APPRAISALQUOTES */], res);
                resolve();
            });
        });
    }
};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__constants__["_336" /* SET_CONTACT_APPRAISALQUOTES */], function (state, data) {
    state.appraisalquotes = data;
});

var getters = {
    contact_appraisalquotes: function contact_appraisalquotes(state) {
        return state.appraisalquotes;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    appraisalreports: {}
};
var state = default_state;

var actions = {
    FETCH_CONTACT_APPRAISALREPORTS: function FETCH_CONTACT_APPRAISALREPORTS(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;

        return new Promise(function (resolve, reject) {

            // console.log('data.path (fetch_contact_appraisalreports) ---->')
            // console.log(data.path)
            return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                // console.log(res)
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_335" /* SET_CONTACT_APPRAISALREPORTS */], res);
                resolve();
            });
        });
    }
};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__constants__["_335" /* SET_CONTACT_APPRAISALREPORTS */], function (state, data) {
    state.appraisalreports = data;
});

var getters = {
    contact_appraisalreports: function contact_appraisalreports(state) {
        return state.appraisalreports;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    emailaddresses: {}
};
var state = default_state;

var actions = {
    FETCH_CONTACT_EMAILADDRESSES: function FETCH_CONTACT_EMAILADDRESSES(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;

        return new Promise(function (resolve, reject) {
            console.log('data.path (fetch_contact_emailaddresses) ---->');
            console.log(data.path);
            return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                // console.log(res)
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_339" /* SET_CONTACT_EMAILADDRESSES */], res);
                resolve();
            });
        });
    }
};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__constants__["_339" /* SET_CONTACT_EMAILADDRESSES */], function (state, data) {
    state.emailaddresses = data;
});

var getters = {
    contact_emailaddresses: function contact_emailaddresses(state) {
        return state.emailaddresses;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    telephonenumbers: {}
};
var state = default_state;

var actions = {
    FETCH_CONTACT_TELEPHONENUMBERS: function FETCH_CONTACT_TELEPHONENUMBERS(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;

        return new Promise(function (resolve, reject) {

            console.log('data.path (fetch_contact_telephonenumbers) ---->');
            console.log(data.path);
            return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                // console.log(res)
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_338" /* SET_CONTACT_TELEPHONENUMBERS */], res);
                resolve();
            });
        });
    }
};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__constants__["_338" /* SET_CONTACT_TELEPHONENUMBERS */], function (state, data) {
    state.telephonenumbers = data;
});

var getters = {
    contact_telephonenumbers: function contact_telephonenumbers(state) {
        return state.telephonenumbers;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    parent_path: null,
    path: null,
    description: null,
    netarea: null,
    type: null
};

var state = default_state;

var actions = {

    CREATE_NEW_COVERED_OUTDOOR: function CREATE_NEW_COVERED_OUTDOOR(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].create({ key: data.key, path: data.path }).then(function (res) {
                var new_created_key = res.key;

                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_143" /* SET_COVERED_OUTDOOR_ID */], new_created_key);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_144" /* SET_COVERED_OUTDOOR_DATE_CREATED */], res.date_created);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_145" /* SET_COVERED_OUTDOOR_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_146" /* SET_COVERED_OUTDOOR_PARENT_PATH */], data.parent_path);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_147" /* SET_COVERED_OUTDOOR_PATH */], res.path);

                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                    value: new_created_key,
                    path: data.path + new_created_key + '/' + 'id',
                    save_timestamp: false
                }).then(function (res) {
                    var object = {};
                    object[new_created_key] = true;
                    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({
                        object: object,
                        path: data.parent_path,
                        save_timestamp: false
                    }).then(function (res) {
                        return resolve({ key: new_created_key });
                    });
                });
            });
        });
    },
    DELETE_COVERED_OUTDOOR: function DELETE_COVERED_OUTDOOR(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;


        return new Promise(function (resolve, reject) {

            // console.log('path check: ' + data.path)
            // console.log('parent_path check: ' + data.parent_path)

            // delete from contact_covered_outdoors/contact_key
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.path }).then(function (res) {
                // delete from contact/contact_key/covered_outdoors
                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.parent_path }).then(function (res) {
                    commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_148" /* RESET_COVERED_OUTDOOR */]);
                }).then(function (res) {
                    return resolve({});
                });
            });
        });
    },
    SET_COVERED_OUTDOOR: function SET_COVERED_OUTDOOR(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;


        return new Promise(function (resolve, reject) {

            // console.log('set_covered_outdoor data:')
            // console.log(data)
            return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                console.log(res);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_149" /* SET_COVERED_OUTDOOR */], res);
            }).then(function (res) {
                return resolve({});
            });
        });
    },
    RESET_COVERED_OUTDOOR: function RESET_COVERED_OUTDOOR(_ref4) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_148" /* RESET_COVERED_OUTDOOR */]);
    },
    SET_COVERED_OUTDOOR_DATE_CREATED: function SET_COVERED_OUTDOOR_DATE_CREATED(_ref5, data) {
        var state = _ref5.state,
            commit = _ref5.commit,
            rootState = _ref5.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_144" /* SET_COVERED_OUTDOOR_DATE_CREATED */], data);
    },
    SET_COVERED_OUTDOOR_DATE_MODIFIED: function SET_COVERED_OUTDOOR_DATE_MODIFIED(_ref6, data) {
        var state = _ref6.state,
            commit = _ref6.commit,
            rootState = _ref6.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_145" /* SET_COVERED_OUTDOOR_DATE_MODIFIED */], data);
    },

    SET_COVERED_OUTDOOR_ID: function SET_COVERED_OUTDOOR_ID(_ref7, data) {
        var state = _ref7.state,
            commit = _ref7.commit,
            rootState = _ref7.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_143" /* SET_COVERED_OUTDOOR_ID */], data);
    },

    SET_COVERED_OUTDOOR_PATH: function SET_COVERED_OUTDOOR_PATH(_ref8, data) {
        var state = _ref8.state,
            commit = _ref8.commit,
            rootState = _ref8.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_147" /* SET_COVERED_OUTDOOR_PATH */], data);
    },
    UPDATE_COVERED_OUTDOOR: function UPDATE_COVERED_OUTDOOR(_ref9, data) {
        var state = _ref9.state,
            commit = _ref9.commit,
            rootState = _ref9.rootState;

        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({ object: data.object, path: data.path, save_timestamp: true }).then(function (res) {

            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_145" /* SET_COVERED_OUTDOOR_DATE_MODIFIED */], res.date_modified);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_150" /* SET_COVERED_OUTDOOR_DIRTYNESS */], false);
        });
    },
    SET_COVERED_OUTDOOR_DESCRIPTION: function SET_COVERED_OUTDOOR_DESCRIPTION(_ref10, data) {
        var state = _ref10.state,
            commit = _ref10.commit,
            rootState = _ref10.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_151" /* SET_COVERED_OUTDOOR_DESCRIPTION */], data);
    },
    /*
    SET_COVERED_OUTDOOR_NETAREA: ({state, commit, rootState}, data) => {
         return new Promise((resolve, reject) => {
            api.set_value({
                value: data.netarea,
                path: 'appraisal_covered_outdoors' + '/' + data.appraisal_id + '/' + data.key + '/' + 'netarea',
                save_timestamp: false
            }).then((res) => {
                resolve()
             })
         })
     },
    */
    SET_COVERED_OUTDOOR_TYPE: function SET_COVERED_OUTDOOR_TYPE(_ref11, data) {
        var state = _ref11.state,
            commit = _ref11.commit,
            rootState = _ref11.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_152" /* SET_COVERED_OUTDOOR_TYPE */], data);
    }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_148" /* RESET_COVERED_OUTDOOR */], function (state) {
    state.date_created = null;
    state.date_modified = null;
    state.dirty = false;
    state.id = null;
    state.parent_path = null;
    state.path = null;
    state.description = null;
    state.netarea = null;
    state.type = null;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_149" /* SET_COVERED_OUTDOOR */], function (state, data) {
    state.date_created = check_undefined(data.date_created);
    state.date_modified = check_undefined(data.date_modified);
    state.dirty = false;
    state.id = check_undefined(data.id);
    state.parent_path = check_undefined(data.parent_path);
    state.path = check_undefined(data.path);
    state.description = check_undefined(data.description);
    state.netarea = check_undefined(data.netarea);
    state.type = check_undefined(data.type);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_144" /* SET_COVERED_OUTDOOR_DATE_CREATED */], function (state, data) {
    state.date_created = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_145" /* SET_COVERED_OUTDOOR_DATE_MODIFIED */], function (state, data) {
    state.date_modified = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_150" /* SET_COVERED_OUTDOOR_DIRTYNESS */], function (state, boolean) {
    state.dirty = boolean;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_143" /* SET_COVERED_OUTDOOR_ID */], function (state, data) {
    state.id = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_153" /* SET_COVERED_OUTDOOR_NETAREA */], function (state, data) {
    state.netarea = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_146" /* SET_COVERED_OUTDOOR_PARENT_PATH */], function (state, data) {
    state.parent_path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_147" /* SET_COVERED_OUTDOOR_PATH */], function (state, data) {
    state.path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_151" /* SET_COVERED_OUTDOOR_DESCRIPTION */], function (state, data) {
    state.description = data;
    state.dirty = true;
}), _mutations);

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

var getters = {

    covered_outdoor: function covered_outdoor(state) {
        return state;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    path: null,
    address: null,
    description: null
};

var state = default_state;

var actions = {

    CREATE_NEW_EMAILADDRESS: function CREATE_NEW_EMAILADDRESS(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;

        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].create({ key: data.key, path: data.path }).then(function (res) {
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_326" /* SET_EMAILADDRESS_ID */], res.key);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_327" /* SET_EMAILADDRESS_DATE_CREATED */], res.date_created);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_328" /* SET_EMAILADDRESS_DATE_MODIFIED */], res.date_modified);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_329" /* SET_EMAILADDRESS_PATH */], res.path);

            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({ value: res.key, path: data.path + res.key + '/' + 'id', save_timestamp: false });

            var object = {};
            object[res.key] = true;
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({ object: object, path: data.parent_path, save_timestamp: false });
        });
    },
    DELETE_EMAILADDRESS: function DELETE_EMAILADDRESS(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;


        console.log('path check: ' + data.path);
        console.log('parent_path check: ' + data.parent_path);

        // delete from contact_emailaddressses/contact_key
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.path }).then(function (res) {
            // delete from contacts/contact_key/emailaddressses
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.parent_path }).then(function (res) {
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_330" /* RESET_EMAILADDRESS */]);
            });
        });
    },
    SET_EMAILADDRESS: function SET_EMAILADDRESS(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;


        // console.log('set_emailaddress data:')
        // console.log(data)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_331" /* SET_EMAILADDRESS */], res);
        });
    },

    RESET_EMAILADDRESS: function RESET_EMAILADDRESS(_ref4) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_330" /* RESET_EMAILADDRESS */]);
    },
    SET_EMAILADDRESS_DATE_CREATED: function SET_EMAILADDRESS_DATE_CREATED(_ref5, data) {
        var state = _ref5.state,
            commit = _ref5.commit,
            rootState = _ref5.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_327" /* SET_EMAILADDRESS_DATE_CREATED */], data);
    },
    SET_EMAILADDRESS_DATE_MODIFIED: function SET_EMAILADDRESS_DATE_MODIFIED(_ref6, data) {
        var state = _ref6.state,
            commit = _ref6.commit,
            rootState = _ref6.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_328" /* SET_EMAILADDRESS_DATE_MODIFIED */], data);
    },

    SET_EMAILADDRESS_ID: function SET_EMAILADDRESS_ID(_ref7, data) {
        var state = _ref7.state,
            commit = _ref7.commit,
            rootState = _ref7.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_326" /* SET_EMAILADDRESS_ID */], data);
    },

    SET_EMAILADDRESS_PATH: function SET_EMAILADDRESS_PATH(_ref8, data) {
        var state = _ref8.state,
            commit = _ref8.commit,
            rootState = _ref8.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_329" /* SET_EMAILADDRESS_PATH */], data);
    },
    UPDATE_EMAILADDRESS: function UPDATE_EMAILADDRESS(_ref9, data) {
        var state = _ref9.state,
            commit = _ref9.commit,
            rootState = _ref9.rootState;

        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({ object: data.object, path: data.path, save_timestamp: true }).then(function (res) {

            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_328" /* SET_EMAILADDRESS_DATE_MODIFIED */], res.date_modified);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_332" /* SET_EMAILADDRESS_DIRTYNESS */], false);
        });
    },
    SET_EMAILADDRESS_ADDRESS: function SET_EMAILADDRESS_ADDRESS(_ref10, data) {
        var state = _ref10.state,
            commit = _ref10.commit,
            rootState = _ref10.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_333" /* SET_EMAILADDRESS_ADDRESS */], data);
    },
    SET_EMAILADDRESS_DESCRIPTION: function SET_EMAILADDRESS_DESCRIPTION(_ref11, data) {
        var state = _ref11.state,
            commit = _ref11.commit,
            rootState = _ref11.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_334" /* SET_EMAILADDRESS_DESCRIPTION */], data);
    }

};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_330" /* RESET_EMAILADDRESS */], function (state) {
    state.description = null, state.number = null,
    // general state data
    state.date_created = null, state.date_modified = null, state.dirty = false, state.id = null, state.path = null;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_331" /* SET_EMAILADDRESS */], function (state, data) {
    state.description = check_undefined(data.description);
    state.number = check_undefined(data.number);
    // general state data
    state.date_created = check_undefined(data.date_created);
    state.date_modified = check_undefined(data.date_modified);
    state.dirty = false;
    state.id = check_undefined(data.id);
    state.path = check_undefined(data.path);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_327" /* SET_EMAILADDRESS_DATE_CREATED */], function (state, data) {
    state.date_created = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_328" /* SET_EMAILADDRESS_DATE_MODIFIED */], function (state, data) {
    state.date_modified = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_332" /* SET_EMAILADDRESS_DIRTYNESS */], function (state, boolean) {
    state.dirty = boolean;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_326" /* SET_EMAILADDRESS_ID */], function (state, data) {
    state.id = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_329" /* SET_EMAILADDRESS_PATH */], function (state, data) {
    state.path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_333" /* SET_EMAILADDRESS_ADDRESS */], function (state, data) {
    state.address = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_334" /* SET_EMAILADDRESS_DESCRIPTION */], function (state, data) {
    state.description = data;
    state.dirty = true;
}), _mutations);

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

var getters = {

    emailaddress: function emailaddress(state) {
        return state;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    path: null,
    name: null,
    tin: null,
    bde_code: null

};
var state = default_state;

var actions = {
    CREATE_NEW_ENTITY: function CREATE_NEW_ENTITY(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_316" /* RESET_ENTITY */]);
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].create({ path: data.path }).then(function (res) {
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_317" /* SET_ENTITY_ID */], res.key);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_318" /* SET_ENTITY_DATE_CREATED */], res.date_created);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_319" /* SET_ENTITY_DATE_MODIFIED */], res.date_modified);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_320" /* SET_ENTITY_PATH */], res.path);
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({ value: res.key, path: data.path + '/' + res.key + '/' + 'id', save_timestamp: false });
        });
    },
    DELETE_ENTITY: function DELETE_ENTITY(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;


        console.log('path check: ' + data.path);
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.path }).then(function (res) {
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_316" /* RESET_ENTITY */]);
        });
    },
    RESET_ENTITY: function RESET_ENTITY(_ref3) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_316" /* RESET_ENTITY */]);
    },
    SET_ENTITY: function SET_ENTITY(_ref4, data) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;

        // console.log('set_entity data:')
        // console.log(data)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_321" /* SET_ENTITY */], res);
        });
    },
    SET_ENTITY_DATE_CREATED: function SET_ENTITY_DATE_CREATED(_ref5, data) {
        var state = _ref5.state,
            commit = _ref5.commit,
            rootState = _ref5.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_318" /* SET_ENTITY_DATE_CREATED */], data);
    },
    SET_ENTITY_DATE_MODIFIED: function SET_ENTITY_DATE_MODIFIED(_ref6, data) {
        var state = _ref6.state,
            commit = _ref6.commit,
            rootState = _ref6.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_319" /* SET_ENTITY_DATE_MODIFIED */], data);
    },
    SET_ENTITY_ID: function SET_ENTITY_ID(_ref7, data) {
        var state = _ref7.state,
            commit = _ref7.commit,
            rootState = _ref7.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_317" /* SET_ENTITY_ID */], data);
    },

    SET_ENTITY_PATH: function SET_ENTITY_PATH(_ref8, data) {
        var state = _ref8.state,
            commit = _ref8.commit,
            rootState = _ref8.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_320" /* SET_ENTITY_PATH */], data);
    },
    UPDATE_ENTITY: function UPDATE_ENTITY(_ref9, data) {
        var state = _ref9.state,
            commit = _ref9.commit,
            rootState = _ref9.rootState;

        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({ object: data.object, path: data.path, save_timestamp: true }).then(function (res) {
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_319" /* SET_ENTITY_DATE_MODIFIED */], res.date_modified);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_322" /* SET_ENTITY_DIRTYNESS */], false);
        });
    },
    SET_ENTITY_NAME: function SET_ENTITY_NAME(_ref10, data) {
        var state = _ref10.state,
            commit = _ref10.commit,
            rootState = _ref10.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_323" /* SET_ENTITY_NAME */], data);
    },
    SET_ENTITY_TIN: function SET_ENTITY_TIN(_ref11, data) {
        var state = _ref11.state,
            commit = _ref11.commit,
            rootState = _ref11.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_324" /* SET_ENTITY_TIN */], data);
    },
    SET_ENTITY_BDE_CODE: function SET_ENTITY_BDE_CODE(_ref12, data) {
        var state = _ref12.state,
            commit = _ref12.commit,
            rootState = _ref12.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_325" /* SET_ENTITY_BDE_CODE */], data);
    }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_316" /* RESET_ENTITY */], function (state) {
    state.date_created = null;
    state.date_modified = null;
    state.id = null;
    state.path = null;
    state.dirty = false;
    state.name = null;
    state.tin = null;
    state.bde_code = null;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_321" /* SET_ENTITY */], function (state, data) {
    // console.log('mutations SET_ENTITY data: ')
    //  console.log(data)
    state.date_created = check_undefined(data.date_created);
    state.date_modified = check_undefined(data.date_modified);
    state.id = check_undefined(data.id);
    state.path = check_undefined(data.path);
    state.dirty = false;
    state.name = check_undefined(data.name);
    state.tin = check_undefined(data.tin);
    state.bde_code = check_undefined(data.bde_code);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_318" /* SET_ENTITY_DATE_CREATED */], function (state, data) {
    state.date_created = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_319" /* SET_ENTITY_DATE_MODIFIED */], function (state, data) {
    state.date_modified = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_322" /* SET_ENTITY_DIRTYNESS */], function (state, boolean) {
    state.dirty = boolean;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_317" /* SET_ENTITY_ID */], function (state, data) {
    state.id = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_320" /* SET_ENTITY_PATH */], function (state, data) {
    state.path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_323" /* SET_ENTITY_NAME */], function (state, data) {
    state.name = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_324" /* SET_ENTITY_TIN */], function (state, data) {
    state.tin = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_325" /* SET_ENTITY_BDE_CODE */], function (state, data) {
    state.bde_code = data;
    state.dirty = true;
}), _mutations);

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

var getters = {

    entity: function entity(state) {
        return state;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    parent_path: null,
    path: null,
    description: null,
    units: null,
    unit_price: null,
    price: null
};

var state = default_state;

var actions = {
    CREATE_NEW_LINE: function CREATE_NEW_LINE(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].create({ key: data.key, path: data.path }).then(function (res) {
                var new_created_key = res.key;

                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_154" /* SET_LINE_ID */], new_created_key);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_155" /* SET_LINE_DATE_CREATED */], res.date_created);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_156" /* SET_LINE_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_157" /* SET_LINE_PARENT_PATH */], data.parent_path);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_158" /* SET_LINE_PATH */], res.path);

                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                    value: new_created_key,
                    path: data.path + new_created_key + '/' + 'id',
                    save_timestamp: false
                }).then(function (res) {
                    var object = {};
                    object[new_created_key] = {};
                    object[new_created_key]['description'] = '';
                    object[new_created_key]['units'] = 1;
                    object[new_created_key]['unit_price'] = 0;
                    object[new_created_key]['price'] = 0;
                    object[new_created_key]['id'] = new_created_key;
                    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({
                        object: object,
                        path: data.parent_path,
                        save_timestamp: false
                    }).then(function (res) {
                        return resolve({ key: new_created_key });
                    });
                });
            });
        });
    },
    DELETE_LINE: function DELETE_LINE(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;


        return new Promise(function (resolve, reject) {

            // console.log('path check: ' + data.path)
            // console.log('parent_path check: ' + data.parent_path)

            // delete from contact_lines/contact_key
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.path }).then(function (res) {
                // delete from contact/contact_key/lines
                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.parent_path }).then(function (res) {
                    commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_159" /* RESET_LINE */]);
                }).then(function (res) {
                    return resolve({});
                });
            });
        });
    },
    SET_LINE: function SET_LINE(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;


        return new Promise(function (resolve, reject) {

            // console.log('set_line data:')
            // console.log(data)
            return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                console.log(res);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_160" /* SET_LINE */], res);
            }).then(function (res) {
                return resolve({});
            });
        });
    },
    RESET_LINE: function RESET_LINE(_ref4) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_159" /* RESET_LINE */]);
    },
    SET_LINE_DATE_CREATED: function SET_LINE_DATE_CREATED(_ref5, data) {
        var state = _ref5.state,
            commit = _ref5.commit,
            rootState = _ref5.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_155" /* SET_LINE_DATE_CREATED */], data);
    },
    SET_LINE_DATE_MODIFIED: function SET_LINE_DATE_MODIFIED(_ref6, data) {
        var state = _ref6.state,
            commit = _ref6.commit,
            rootState = _ref6.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_156" /* SET_LINE_DATE_MODIFIED */], data);
    },

    SET_LINE_ID: function SET_LINE_ID(_ref7, data) {
        var state = _ref7.state,
            commit = _ref7.commit,
            rootState = _ref7.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_154" /* SET_LINE_ID */], data);
    },

    SET_LINE_PATH: function SET_LINE_PATH(_ref8, data) {
        var state = _ref8.state,
            commit = _ref8.commit,
            rootState = _ref8.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_158" /* SET_LINE_PATH */], data);
    },
    UPDATE_LINE: function UPDATE_LINE(_ref9, data) {
        var state = _ref9.state,
            commit = _ref9.commit,
            rootState = _ref9.rootState;

        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({ object: data.object, path: data.path, save_timestamp: true }).then(function (res) {

            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_156" /* SET_LINE_DATE_MODIFIED */], res.date_modified);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_161" /* SET_LINE_DIRTYNESS */], false);
        });
    },
    SET_LINE_DESCRIPTION: function SET_LINE_DESCRIPTION(_ref10, data) {
        var state = _ref10.state,
            commit = _ref10.commit,
            rootState = _ref10.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_162" /* SET_LINE_DESCRIPTION */], data);
    },
    SET_LINE_UNITS: function SET_LINE_UNITS(_ref11, data) {
        var state = _ref11.state,
            commit = _ref11.commit,
            rootState = _ref11.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_163" /* SET_LINE_UNITS */], data);
    },
    SET_LINE_UNIT_PRICE: function SET_LINE_UNIT_PRICE(_ref12, data) {
        var state = _ref12.state,
            commit = _ref12.commit,
            rootState = _ref12.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_164" /* SET_LINE_UNIT_PRICE */], data);
    },
    SET_LINE_PRICE: function SET_LINE_PRICE(_ref13, data) {
        var state = _ref13.state,
            commit = _ref13.commit,
            rootState = _ref13.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_165" /* SET_LINE_PRICE */], data);
    }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_159" /* RESET_LINE */], function (state) {
    state.date_created = null;
    state.date_modified = null;
    state.dirty = false;
    state.id = null;
    state.parent_path = null;
    state.path = null;
    state.description = null;
    state.units = null;
    state.unit_price = null;
    state.price = null;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_160" /* SET_LINE */], function (state, data) {
    state.date_created = check_undefined(data.date_created);
    state.date_modified = check_undefined(data.date_modified);
    state.dirty = false;
    state.id = check_undefined(data.id);
    state.parent_path = check_undefined(data.parent_path);
    state.path = check_undefined(data.path);
    state.description = check_undefined(data.description);
    state.units = check_undefined(data.units);
    state.unit_price = check_undefined(data.unit_price);
    state.price = check_undefined(data.price);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_155" /* SET_LINE_DATE_CREATED */], function (state, data) {
    state.date_created = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_156" /* SET_LINE_DATE_MODIFIED */], function (state, data) {
    state.date_modified = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_161" /* SET_LINE_DIRTYNESS */], function (state, boolean) {
    state.dirty = boolean;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_154" /* SET_LINE_ID */], function (state, data) {
    state.id = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_157" /* SET_LINE_PARENT_PATH */], function (state, data) {
    state.parent_path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_158" /* SET_LINE_PATH */], function (state, data) {
    state.path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_162" /* SET_LINE_DESCRIPTION */], function (state, data) {
    state.description = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_163" /* SET_LINE_UNITS */], function (state, data) {
    state.units = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_164" /* SET_LINE_UNIT_PRICE */], function (state, data) {
    state.unit_price = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_165" /* SET_LINE_PRICE */], function (state, data) {
    state.price = data;
    state.dirty = true;
}), _mutations);

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

var getters = {

    line: function line(state) {
        return state;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var default_state = {
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    parent_path: null,
    path: null,
    appraisal_id: null,
    description: null,
    query_ad_type: null,
    query_distance_km: 1,
    query_limitdate: null,
    query_startdate: null,
    weighing: {
        '0': {
            ad_date: 0,
            property_type: 2,
            quality_of_neighbourhood: 2,
            quality_of_situation: 2,
            quality_of_construction: 2,
            quality_of_realestate: 2,
            adopted_age: 2,
            conservation_status: 5,
            floor_number: 5,
            adopted_area: 2,
            lift: 10
        }
    },
    universal_sample_typical_deviation: {
        '0': {
            Xi_total: null,
            Vu_total: null,
            Vi_total: null,
            Vu2_total: null,
            XiVi_total: null,
            Xi2_total: null,
            Vi2_total: null,

            n: null,
            Vu_average: null,
            V_coef: null,
            Vu2_n: null,
            Vu_n_2: null,
            summation_Vu2_n: null,
            summation_Vu_n_2: null,
            g2: null,
            g: null,
            t: null,
            s: null,
            s2: null,
            r: null,
            m: null,
            na: null,
            t_ms: null,
            s2_nas: null,
            a: null,
            b: null
        }
    },
    representative_sample_typical_deviation: {
        '0': {
            Xi_total: null,
            Vu_total: null,
            Vi_total: null,
            Vu2_total: null,
            XiVi_total: null,
            Xi2_total: null,
            Vi2_total: null,

            limit_upper: null,
            limit_lower: null,

            n: null,
            Vu_max: null,
            Vu_min: null,
            summation_Vu2_n: null,
            summation_Vu_n_2: null,
            g2: null,
            g: null,
            t: null,
            s: null,
            s2: null,
            r: null,
            m: null,
            na: null,
            t_ms: null,
            s2_nas: null,
            a: null,
            b: null
        }
    },
    appraised_points: [],
    comparable_points: [],
    regressionline_points: [],
    market_value: null,
    market_unit_value: null,
    realestate_appraisals: {},
    prices_estimated_yearly_evolution_pct: null,
    market_value_evolution_probability_pct: null,
    offer_production: null,
    offer_yearly_stock: null,
    offer_trend: null,
    demand_level: null,
    demand_speed_of_sales: null,
    demand_trend: null,
    prices_expectancy: null,
    prices_past_cicles_volatility: null,
    market_conjuncture: null,
    market_value_reduction_probability_expectancy: null,
    prices_max: null,
    prices_min: null,
    prices_mean: null,
    prices_median: null
};

var state = default_state;

var actions = {

    CREATE_NEW_MARKETSTUDY: function CREATE_NEW_MARKETSTUDY(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].create({ key: data.key, path: data.path }).then(function (res) {
                var new_created_key = res.key;

                var limitdate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(res.date_created, 'x').format('YYYY-MM-DD');
                var startdate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(limitdate).subtract(6, 'months').format('YYYY-MM-DD');

                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_266" /* SET_MARKETSTUDY_ID */], new_created_key);
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_267" /* SET_MARKETSTUDY_DATE_CREATED */], res.date_created);
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_268" /* SET_MARKETSTUDY_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_269" /* SET_MARKETSTUDY_PARENT_PATH */], data.parent_path);
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_270" /* SET_MARKETSTUDY_PATH */], res.path);
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_271" /* SET_MARKETSTUDY_QUERY_LIMITDATE */], limitdate);
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_272" /* SET_MARKETSTUDY_QUERY_STARTDATE */], startdate);

                // console.log('data.appraisal_id: ')
                // console.log(data.appraisal_id)

                var realestate_appraisals = {};
                realestate_appraisals[data.realestate_id] = {};
                realestate_appraisals[data.realestate_id][data.appraisal_id] = true;

                var obj = {
                    'appraisal_id': data.appraisal_id,
                    'date_created': res.date_created,
                    'date_modified': res.date_modified,
                    'id': new_created_key,
                    'parent_path': data.parent_path,
                    'path': data.path,
                    'query_distance_km': 1,
                    'query_limitdate': limitdate,
                    'query_startdate': startdate,
                    'realestate_appraisals': realestate_appraisals,
                    'weighing': {
                        '0': {
                            ad_date: 0,
                            property_type: 2,
                            quality_of_neighbourhood: 2,
                            quality_of_situation: 2,
                            quality_of_construction: 2,
                            quality_of_realestate: 2,
                            adopted_age: 2,
                            conservation_status: 5,
                            floor_number: 5,
                            adopted_area: 2,
                            lift: 10
                        }
                    }
                };

                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                    value: obj,
                    path: data.path + new_created_key,
                    save_timestamp: false
                }).then(function (res) {
                    var object = {};
                    object[new_created_key] = true;
                    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({
                        object: object,
                        path: data.parent_path,
                        save_timestamp: false
                    }).then(function (res) {
                        return resolve({ key: new_created_key });
                    });
                });
            });
        });
    },
    DELETE_MARKETSTUDY: function DELETE_MARKETSTUDY(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;


        return new Promise(function (resolve, reject) {

            // console.log('path check: ' + data.path)
            // console.log('parent_path check: ' + data.parent_path)

            // delete from contact_marketstudies/contact_key
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.path }).then(function (res) {
                // delete from contact/contact_key/marketstudies
                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.parent_path }).then(function (res) {
                    commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_273" /* RESET_MARKETSTUDY */]);
                }).then(function (res) {
                    return resolve({});
                });
            });
        });
    },
    SET_MARKETSTUDY: function SET_MARKETSTUDY(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;


        return new Promise(function (resolve, reject) {

            // console.log('set_marketstudy data:')
            // console.log(data)
            return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                // console.log(res)
                commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_274" /* SET_MARKETSTUDY */], res);
            }).then(function (res) {
                return resolve({});
            });
        });
    },
    RESET_MARKETSTUDY: function RESET_MARKETSTUDY(_ref4) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_273" /* RESET_MARKETSTUDY */]);
    },
    SET_MARKETSTUDY_DATE_CREATED: function SET_MARKETSTUDY_DATE_CREATED(_ref5, data) {
        var state = _ref5.state,
            commit = _ref5.commit,
            rootState = _ref5.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_267" /* SET_MARKETSTUDY_DATE_CREATED */], data);
    },
    SET_MARKETSTUDY_DATE_MODIFIED: function SET_MARKETSTUDY_DATE_MODIFIED(_ref6, data) {
        var state = _ref6.state,
            commit = _ref6.commit,
            rootState = _ref6.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_268" /* SET_MARKETSTUDY_DATE_MODIFIED */], data);
    },

    SET_MARKETSTUDY_ID: function SET_MARKETSTUDY_ID(_ref7, data) {
        var state = _ref7.state,
            commit = _ref7.commit,
            rootState = _ref7.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_266" /* SET_MARKETSTUDY_ID */], data);
    },

    SET_MARKETSTUDY_PATH: function SET_MARKETSTUDY_PATH(_ref8, data) {
        var state = _ref8.state,
            commit = _ref8.commit,
            rootState = _ref8.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_270" /* SET_MARKETSTUDY_PATH */], data);
    },
    UPDATE_MARKETSTUDY: function UPDATE_MARKETSTUDY(_ref9, data) {
        var state = _ref9.state,
            commit = _ref9.commit,
            rootState = _ref9.rootState;

        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({ object: data.object, path: data.path, save_timestamp: true }).then(function (res) {

            commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_268" /* SET_MARKETSTUDY_DATE_MODIFIED */], res.date_modified);
            commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_275" /* SET_MARKETSTUDY_DIRTYNESS */], false);
        });
    },
    SET_MARKETSTUDY_APPRAISAL_ID: function SET_MARKETSTUDY_APPRAISAL_ID(_ref10, data) {
        var state = _ref10.state,
            commit = _ref10.commit,
            rootState = _ref10.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_276" /* SET_MARKETSTUDY_APPRAISAL_ID */], data);
    },
    SET_MARKETSTUDY_DESCRIPTION: function SET_MARKETSTUDY_DESCRIPTION(_ref11, data) {
        var state = _ref11.state,
            commit = _ref11.commit,
            rootState = _ref11.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_277" /* SET_MARKETSTUDY_DESCRIPTION */], data);
    },
    SET_MARKETSTUDY_QUERY_AD_TYPE: function SET_MARKETSTUDY_QUERY_AD_TYPE(_ref12, data) {
        var state = _ref12.state,
            commit = _ref12.commit,
            rootState = _ref12.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_278" /* SET_MARKETSTUDY_QUERY_AD_TYPE */], data);
    },
    SET_MARKETSTUDY_QUERY_DISTANCE_KM: function SET_MARKETSTUDY_QUERY_DISTANCE_KM(_ref13, data) {
        var state = _ref13.state,
            commit = _ref13.commit,
            rootState = _ref13.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_279" /* SET_MARKETSTUDY_QUERY_DISTANCE_KM */], data);
    },
    SET_MARKETSTUDY_QUERY_LIMITDATE: function SET_MARKETSTUDY_QUERY_LIMITDATE(_ref14, data) {
        var state = _ref14.state,
            commit = _ref14.commit,
            rootState = _ref14.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_271" /* SET_MARKETSTUDY_QUERY_LIMITDATE */], data);
    },
    SET_MARKETSTUDY_QUERY_STARTDATE: function SET_MARKETSTUDY_QUERY_STARTDATE(_ref15, data) {
        var state = _ref15.state,
            commit = _ref15.commit,
            rootState = _ref15.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_272" /* SET_MARKETSTUDY_QUERY_STARTDATE */], data);
    },
    SET_MARKETSTUDY_REPRESENTATIVE_SAMPLE_TYPICAL_DEVIATION: function SET_MARKETSTUDY_REPRESENTATIVE_SAMPLE_TYPICAL_DEVIATION(_ref16, data) {
        var state = _ref16.state,
            commit = _ref16.commit,
            rootState = _ref16.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_280" /* SET_MARKETSTUDY_REPRESENTATIVE_SAMPLE_TYPICAL_DEVIATION */], data);
    },
    SET_MARKETSTUDY_UNIVERSAL_SAMPLE_TYPICAL_DEVIATION: function SET_MARKETSTUDY_UNIVERSAL_SAMPLE_TYPICAL_DEVIATION(_ref17, data) {
        var state = _ref17.state,
            commit = _ref17.commit,
            rootState = _ref17.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_281" /* SET_MARKETSTUDY_UNIVERSAL_SAMPLE_TYPICAL_DEVIATION */], data);
    },
    SET_MARKETSTUDY_WEIGHING: function SET_MARKETSTUDY_WEIGHING(_ref18, data) {
        var state = _ref18.state,
            commit = _ref18.commit,
            rootState = _ref18.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_282" /* SET_MARKETSTUDY_WEIGHING */], data);
    },
    SET_MARKETSTUDY_WEIGHING_AD_DATE: function SET_MARKETSTUDY_WEIGHING_AD_DATE(_ref19, data) {
        var state = _ref19.state,
            commit = _ref19.commit,
            rootState = _ref19.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_283" /* SET_MARKETSTUDY_WEIGHING_AD_DATE */], data);
    },
    SET_MARKETSTUDY_WEIGHING_PROPERTY_TYPE: function SET_MARKETSTUDY_WEIGHING_PROPERTY_TYPE(_ref20, data) {
        var state = _ref20.state,
            commit = _ref20.commit,
            rootState = _ref20.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_284" /* SET_MARKETSTUDY_WEIGHING_PROPERTY_TYPE */], data);
    },
    SET_MARKETSTUDY_WEIGHING_QUALITY_OF_NEIGHBOURHOOD: function SET_MARKETSTUDY_WEIGHING_QUALITY_OF_NEIGHBOURHOOD(_ref21, data) {
        var state = _ref21.state,
            commit = _ref21.commit,
            rootState = _ref21.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_285" /* SET_MARKETSTUDY_WEIGHING_QUALITY_OF_NEIGHBOURHOOD */], data);
    },
    SET_MARKETSTUDY_WEIGHING_QUALITY_OF_SITUATION: function SET_MARKETSTUDY_WEIGHING_QUALITY_OF_SITUATION(_ref22, data) {
        var state = _ref22.state,
            commit = _ref22.commit,
            rootState = _ref22.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_286" /* SET_MARKETSTUDY_WEIGHING_QUALITY_OF_SITUATION */], data);
    },
    SET_MARKETSTUDY_WEIGHING_QUALITY_OF_CONSTRUCTION: function SET_MARKETSTUDY_WEIGHING_QUALITY_OF_CONSTRUCTION(_ref23, data) {
        var state = _ref23.state,
            commit = _ref23.commit,
            rootState = _ref23.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_287" /* SET_MARKETSTUDY_WEIGHING_QUALITY_OF_CONSTRUCTION */], data);
    },
    SET_MARKETSTUDY_WEIGHING_QUALITY_OF_REALESTATE: function SET_MARKETSTUDY_WEIGHING_QUALITY_OF_REALESTATE(_ref24, data) {
        var state = _ref24.state,
            commit = _ref24.commit,
            rootState = _ref24.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_288" /* SET_MARKETSTUDY_WEIGHING_QUALITY_OF_REALESTATE */], data);
    },
    SET_MARKETSTUDY_WEIGHING_ADOPTED_AGE: function SET_MARKETSTUDY_WEIGHING_ADOPTED_AGE(_ref25, data) {
        var state = _ref25.state,
            commit = _ref25.commit,
            rootState = _ref25.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_289" /* SET_MARKETSTUDY_WEIGHING_ADOPTED_AGE */], data);
    },
    SET_MARKETSTUDY_WEIGHING_CONSERVATION_STATUS: function SET_MARKETSTUDY_WEIGHING_CONSERVATION_STATUS(_ref26, data) {
        var state = _ref26.state,
            commit = _ref26.commit,
            rootState = _ref26.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_290" /* SET_MARKETSTUDY_WEIGHING_CONSERVATION_STATUS */], data);
    },
    SET_MARKETSTUDY_WEIGHING_FLOOR_NUMBER: function SET_MARKETSTUDY_WEIGHING_FLOOR_NUMBER(_ref27, data) {
        var state = _ref27.state,
            commit = _ref27.commit,
            rootState = _ref27.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_291" /* SET_MARKETSTUDY_WEIGHING_FLOOR_NUMBER */], data);
    },
    SET_MARKETSTUDY_WEIGHING_ADOPTED_AREA: function SET_MARKETSTUDY_WEIGHING_ADOPTED_AREA(_ref28, data) {
        var state = _ref28.state,
            commit = _ref28.commit,
            rootState = _ref28.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_292" /* SET_MARKETSTUDY_WEIGHING_ADOPTED_AREA */], data);
    },
    SET_MARKETSTUDY_WEIGHING_LIFT: function SET_MARKETSTUDY_WEIGHING_LIFT(_ref29, data) {
        var state = _ref29.state,
            commit = _ref29.commit,
            rootState = _ref29.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_293" /* SET_MARKETSTUDY_WEIGHING_LIFT */], data);
    },
    SET_MARKETSTUDY_APPRAISED_POINTS: function SET_MARKETSTUDY_APPRAISED_POINTS(_ref30, data) {
        var state = _ref30.state,
            commit = _ref30.commit,
            rootState = _ref30.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_294" /* SET_MARKETSTUDY_APPRAISED_POINTS */], data);
    },
    SET_MARKETSTUDY_COMPARABLE_POINTS: function SET_MARKETSTUDY_COMPARABLE_POINTS(_ref31, data) {
        var state = _ref31.state,
            commit = _ref31.commit,
            rootState = _ref31.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_295" /* SET_MARKETSTUDY_COMPARABLE_POINTS */], data);
    },
    SET_MARKETSTUDY_REGRESSIONLINE_POINTS: function SET_MARKETSTUDY_REGRESSIONLINE_POINTS(_ref32, data) {
        var state = _ref32.state,
            commit = _ref32.commit,
            rootState = _ref32.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_296" /* SET_MARKETSTUDY_REGRESSIONLINE_POINTS */], data);
    },
    SET_MARKETSTUDY_MARKET_VALUE: function SET_MARKETSTUDY_MARKET_VALUE(_ref33, data) {
        var state = _ref33.state,
            commit = _ref33.commit,
            rootState = _ref33.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_297" /* SET_MARKETSTUDY_MARKET_VALUE */], data);
    },
    SET_MARKETSTUDY_MARKET_UNIT_VALUE: function SET_MARKETSTUDY_MARKET_UNIT_VALUE(_ref34, data) {
        var state = _ref34.state,
            commit = _ref34.commit,
            rootState = _ref34.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_298" /* SET_MARKETSTUDY_MARKET_UNIT_VALUE */], data);
    },
    SET_MARKETSTUDY_REALESTATE_APPRAISALS: function SET_MARKETSTUDY_REALESTATE_APPRAISALS(_ref35, data) {
        var state = _ref35.state,
            commit = _ref35.commit,
            rootState = _ref35.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_299" /* SET_MARKETSTUDY_REALESTATE_APPRAISALS */], data);
    },
    SET_MARKETSTUDY_PRICES_ESTIMATED_YEARLY_EVOLUTION_PCT: function SET_MARKETSTUDY_PRICES_ESTIMATED_YEARLY_EVOLUTION_PCT(_ref36, data) {
        var state = _ref36.state,
            commit = _ref36.commit,
            rootState = _ref36.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_300" /* SET_MARKETSTUDY_PRICES_ESTIMATED_YEARLY_EVOLUTION_PCT */], data);
    },
    SET_MARKETSTUDY_MARKET_VALUE_EVOLUTION_PROBABILITY_PCT: function SET_MARKETSTUDY_MARKET_VALUE_EVOLUTION_PROBABILITY_PCT(_ref37, data) {
        var state = _ref37.state,
            commit = _ref37.commit,
            rootState = _ref37.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_301" /* SET_MARKETSTUDY_MARKET_VALUE_EVOLUTION_PROBABILITY_PCT */], data);
    },
    SET_MARKETSTUDY_OFFER_PRODUCTION: function SET_MARKETSTUDY_OFFER_PRODUCTION(_ref38, data) {
        var state = _ref38.state,
            commit = _ref38.commit,
            rootState = _ref38.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_302" /* SET_MARKETSTUDY_OFFER_PRODUCTION */], data);
    },
    SET_MARKETSTUDY_OFFER_YEARLY_STOCK: function SET_MARKETSTUDY_OFFER_YEARLY_STOCK(_ref39, data) {
        var state = _ref39.state,
            commit = _ref39.commit,
            rootState = _ref39.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_303" /* SET_MARKETSTUDY_OFFER_YEARLY_STOCK */], data);
    },
    SET_MARKETSTUDY_OFFER_TREND: function SET_MARKETSTUDY_OFFER_TREND(_ref40, data) {
        var state = _ref40.state,
            commit = _ref40.commit,
            rootState = _ref40.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_304" /* SET_MARKETSTUDY_OFFER_TREND */], data);
    },
    SET_MARKETSTUDY_DEMAND_LEVEL: function SET_MARKETSTUDY_DEMAND_LEVEL(_ref41, data) {
        var state = _ref41.state,
            commit = _ref41.commit,
            rootState = _ref41.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_305" /* SET_MARKETSTUDY_DEMAND_LEVEL */], data);
    },
    SET_MARKETSTUDY_DEMAND_SPEED_OF_SALES: function SET_MARKETSTUDY_DEMAND_SPEED_OF_SALES(_ref42, data) {
        var state = _ref42.state,
            commit = _ref42.commit,
            rootState = _ref42.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_306" /* SET_MARKETSTUDY_DEMAND_SPEED_OF_SALES */], data);
    },
    SET_MARKETSTUDY_DEMAND_TREND: function SET_MARKETSTUDY_DEMAND_TREND(_ref43, data) {
        var state = _ref43.state,
            commit = _ref43.commit,
            rootState = _ref43.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_307" /* SET_MARKETSTUDY_DEMAND_TREND */], data);
    },
    SET_MARKETSTUDY_PRICES_EXPECTANCY: function SET_MARKETSTUDY_PRICES_EXPECTANCY(_ref44, data) {
        var state = _ref44.state,
            commit = _ref44.commit,
            rootState = _ref44.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_308" /* SET_MARKETSTUDY_PRICES_EXPECTANCY */], data);
    },
    SET_MARKETSTUDY_PRICES_PAST_CICLES_VOLATILITY: function SET_MARKETSTUDY_PRICES_PAST_CICLES_VOLATILITY(_ref45, data) {
        var state = _ref45.state,
            commit = _ref45.commit,
            rootState = _ref45.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_309" /* SET_MARKETSTUDY_PRICES_PAST_CICLES_VOLATILITY */], data);
    },
    SET_MARKETSTUDY_MARKET_CONJUNCTURE: function SET_MARKETSTUDY_MARKET_CONJUNCTURE(_ref46, data) {
        var state = _ref46.state,
            commit = _ref46.commit,
            rootState = _ref46.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_310" /* SET_MARKETSTUDY_MARKET_CONJUNCTURE */], data);
    },
    SET_MARKETSTUDY_MARKET_VALUE_REDUCTION_PROBABILITY_EXPECTANCY: function SET_MARKETSTUDY_MARKET_VALUE_REDUCTION_PROBABILITY_EXPECTANCY(_ref47, data) {
        var state = _ref47.state,
            commit = _ref47.commit,
            rootState = _ref47.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_311" /* SET_MARKETSTUDY_MARKET_VALUE_REDUCTION_PROBABILITY_EXPECTANCY */], data);
    },
    SET_MARKETSTUDY_PRICES_MAX: function SET_MARKETSTUDY_PRICES_MAX(_ref48, data) {
        var state = _ref48.state,
            commit = _ref48.commit,
            rootState = _ref48.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_312" /* SET_MARKETSTUDY_PRICES_MAX */], data);
    },
    SET_MARKETSTUDY_PRICES_MIN: function SET_MARKETSTUDY_PRICES_MIN(_ref49, data) {
        var state = _ref49.state,
            commit = _ref49.commit,
            rootState = _ref49.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_313" /* SET_MARKETSTUDY_PRICES_MIN */], data);
    },
    SET_MARKETSTUDY_PRICES_MEAN: function SET_MARKETSTUDY_PRICES_MEAN(_ref50, data) {
        var state = _ref50.state,
            commit = _ref50.commit,
            rootState = _ref50.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_314" /* SET_MARKETSTUDY_PRICES_MEAN */], data);
    },
    SET_MARKETSTUDY_PRICES_MEDIAN: function SET_MARKETSTUDY_PRICES_MEDIAN(_ref51, data) {
        var state = _ref51.state,
            commit = _ref51.commit,
            rootState = _ref51.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_315" /* SET_MARKETSTUDY_PRICES_MEDIAN */], data);
    }

};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_273" /* RESET_MARKETSTUDY */], function (state) {
    state.date_created = null;
    state.date_modified = null;
    state.dirty = false;
    state.id = null;
    state.parent_path = null;
    state.path = null;
    state.appraisal_id = null;
    state.description = null;
    state.query_ad_type = null;
    state.query_distance_km = 1;
    state.query_limitdate = null;
    state.query_startdate = null;
    state.weighing = {
        '0': {
            ad_date: 0,
            property_type: 2,
            quality_of_neighbourhood: 2,
            quality_of_situation: 2,
            quality_of_construction: 2,
            quality_of_realestate: 2,
            adopted_age: 2,
            conservation_status: 5,
            floor_number: 5,
            adopted_area: 2,
            lift: 10
        }
    };
    state.universal_sample_typical_deviation = {
        '0': {
            Xi_total: null,
            Vu_total: null,
            Vi_total: null,
            Vu2_total: null,
            XiVi_total: null,
            Xi2_total: null,
            Vi2_total: null,

            n: null,
            Vu_average: null,
            V_coef: null,
            Vu2_n: null,
            Vu_n_2: null,
            summation_Vu2_n: null,
            summation_Vu_n_2: null,
            g2: null,
            g: null,
            t: null,
            s: null,
            s2: null,
            r: null,
            m: null,
            na: null,
            t_ms: null,
            s2_nas: null,
            a: null,
            b: null
        }
    };
    state.representative_sample_typical_deviation = {
        '0': {
            Xi_total: null,
            Vu_total: null,
            Vi_total: null,
            Vu2_total: null,
            XiVi_total: null,
            Xi2_total: null,
            Vi2_total: null,

            limit_upper: null,
            limit_lower: null,

            n: null,
            Vu_max: null,
            Vu_min: null,
            summation_Vu2_n: null,
            summation_Vu_n_2: null,
            g2: null,
            g: null,
            t: null,
            s: null,
            s2: null,
            r: null,
            m: null,
            na: null,
            t_ms: null,
            s2_nas: null,
            a: null,
            b: null
        }
    };
    state.appraised_points = [];
    state.comparable_points = [];
    state.regressionline_points = [];
    state.market_value = null;
    state.market_unit_value = null;
    state.realestate_appraisals = {};
    state.prices_estimated_yearly_evolution_pct = null;
    state.market_value_evolution_probability_pct = null;
    state.offer_production = null;
    state.offer_yearly_stock = null;
    state.offer_trend = null;
    state.demand_level = null;
    state.demand_speed_of_sales = null;
    state.demand_trend = null;
    state.prices_expectancy = null;
    state.prices_past_cicles_volatility = null;
    state.market_conjuncture = null;
    state.market_value_reduction_probability_expectancy = null;
    state.prices_max = null;
    state.prices_min = null;
    state.prices_mean = null;
    state.prices_median = null;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_274" /* SET_MARKETSTUDY */], function (state, data) {
    state.date_created = check_undefined(data.date_created);
    state.date_modified = check_undefined(data.date_modified);
    state.dirty = false;
    state.id = check_undefined(data.id);
    state.parent_path = check_undefined(data.parent_path);
    state.path = check_undefined(data.path);
    state.appraisal_id = check_undefined(data.appraisal_id);
    state.description = check_undefined(data.description);
    state.query_ad_type = check_undefined(data.query_ad_type);
    state.query_distance_km = check_undefined(data.query_distance_km);
    state.query_limitdate = check_undefined(data.query_limitdate);
    state.query_startdate = check_undefined(data.query_startdate);
    state.representative_sample_typical_deviation = check_undefined(data.representative_sample_typical_deviation);
    state.universal_sample_typical_deviation = check_undefined(data.universal_sample_typical_deviation);
    state.weighing = check_undefined(data.weighing);
    state.appraised_points = check_undefined(data.appraised_points);
    state.comparable_points = check_undefined(data.comparable_points);
    state.regressionline_points = check_undefined(data.regressionline_points);
    state.market_value = check_undefined(data.market_value);
    state.market_unit_value = check_undefined(data.market_unit_value);
    state.realestate_appraisals = check_undefined(data.realestate_appraisals);
    state.prices_estimated_yearly_evolution_pct = check_undefined(data.prices_estimated_yearly_evolution_pct);
    state.market_value_evolution_probability_pct = check_undefined(data.market_value_evolution_probability_pct);
    state.offer_production = check_undefined(data.offer_production);
    state.offer_yearly_stock = check_undefined(data.offer_yearly_stock);
    state.offer_trend = check_undefined(data.offer_trend);
    state.demand_level = check_undefined(data.demand_level);
    state.demand_speed_of_sales = check_undefined(data.demand_speed_of_sales);
    state.demand_trend = check_undefined(data.demand_trend);
    state.prices_expectancy = check_undefined(data.prices_expectancy);
    state.prices_past_cicles_volatility = check_undefined(data.prices_past_cicles_volatility);
    state.market_conjunction = check_undefined(data.market_conjunction);
    state.market_conjuncture = check_undefined(data.market_conjuncture);
    state.market_value_reduction_probability_expectancy = check_undefined(data.market_value_reduction_probability_expectancy);
    state.prices_max = check_undefined(data.prices_max);
    state.prices_min = check_undefined(data.prices_min);
    state.prices_mean = check_undefined(data.prices_mean);
    state.prices_median = check_undefined(data.prices_median);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_276" /* SET_MARKETSTUDY_APPRAISAL_ID */], function (state, data) {
    state.appraisal_id = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_267" /* SET_MARKETSTUDY_DATE_CREATED */], function (state, data) {
    state.date_created = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_268" /* SET_MARKETSTUDY_DATE_MODIFIED */], function (state, data) {
    state.date_modified = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_275" /* SET_MARKETSTUDY_DIRTYNESS */], function (state, boolean) {
    state.dirty = boolean;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_266" /* SET_MARKETSTUDY_ID */], function (state, data) {
    state.id = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_269" /* SET_MARKETSTUDY_PARENT_PATH */], function (state, data) {
    state.parent_path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_270" /* SET_MARKETSTUDY_PATH */], function (state, data) {
    state.path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_277" /* SET_MARKETSTUDY_DESCRIPTION */], function (state, data) {
    state.description = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_278" /* SET_MARKETSTUDY_QUERY_AD_TYPE */], function (state, data) {
    state.query_ad_type = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_279" /* SET_MARKETSTUDY_QUERY_DISTANCE_KM */], function (state, data) {
    state.query_distance_km = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_271" /* SET_MARKETSTUDY_QUERY_LIMITDATE */], function (state, data) {
    state.query_limitdate = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_272" /* SET_MARKETSTUDY_QUERY_STARTDATE */], function (state, data) {
    state.query_startdate = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_280" /* SET_MARKETSTUDY_REPRESENTATIVE_SAMPLE_TYPICAL_DEVIATION */], function (state, data) {
    state.representative_sample_typical_deviation = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_281" /* SET_MARKETSTUDY_UNIVERSAL_SAMPLE_TYPICAL_DEVIATION */], function (state, data) {
    state.universal_sample_typical_deviation = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_282" /* SET_MARKETSTUDY_WEIGHING */], function (state, data) {
    state.weighing = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_283" /* SET_MARKETSTUDY_WEIGHING_AD_DATE */], function (state, data) {
    state.weighing['0']['ad_date'] = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_284" /* SET_MARKETSTUDY_WEIGHING_PROPERTY_TYPE */], function (state, data) {
    state.weighing['0']['property_type'] = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_285" /* SET_MARKETSTUDY_WEIGHING_QUALITY_OF_NEIGHBOURHOOD */], function (state, data) {
    state.weighing['0']['quality_of_neighbourhood'] = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_286" /* SET_MARKETSTUDY_WEIGHING_QUALITY_OF_SITUATION */], function (state, data) {
    state.weighing['0']['quality_of_situation'] = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_287" /* SET_MARKETSTUDY_WEIGHING_QUALITY_OF_CONSTRUCTION */], function (state, data) {
    state.weighing['0']['quality_of_construction'] = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_288" /* SET_MARKETSTUDY_WEIGHING_QUALITY_OF_REALESTATE */], function (state, data) {
    state.weighing['0']['quality_of_realestate'] = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_289" /* SET_MARKETSTUDY_WEIGHING_ADOPTED_AGE */], function (state, data) {
    state.weighing['0']['adopted_age'] = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_290" /* SET_MARKETSTUDY_WEIGHING_CONSERVATION_STATUS */], function (state, data) {
    state.weighing['0']['conservation_status'] = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_291" /* SET_MARKETSTUDY_WEIGHING_FLOOR_NUMBER */], function (state, data) {
    state.weighing['0']['floor_number'] = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_292" /* SET_MARKETSTUDY_WEIGHING_ADOPTED_AREA */], function (state, data) {
    state.weighing['0']['adopted_area'] = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_293" /* SET_MARKETSTUDY_WEIGHING_LIFT */], function (state, data) {
    state.weighing['0']['lift'] = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_294" /* SET_MARKETSTUDY_APPRAISED_POINTS */], function (state, data) {
    state.appraised_points = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_295" /* SET_MARKETSTUDY_COMPARABLE_POINTS */], function (state, data) {
    state.comparable_points = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_296" /* SET_MARKETSTUDY_REGRESSIONLINE_POINTS */], function (state, data) {
    state.regressionline_points = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_297" /* SET_MARKETSTUDY_MARKET_VALUE */], function (state, data) {
    state.market_value = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_298" /* SET_MARKETSTUDY_MARKET_UNIT_VALUE */], function (state, data) {
    state.market_unit_value = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_299" /* SET_MARKETSTUDY_REALESTATE_APPRAISALS */], function (state, data) {
    state.realestate_appraisals = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_300" /* SET_MARKETSTUDY_PRICES_ESTIMATED_YEARLY_EVOLUTION_PCT */], function (state, data) {
    state.prices_estimated_yearly_evolution_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_301" /* SET_MARKETSTUDY_MARKET_VALUE_EVOLUTION_PROBABILITY_PCT */], function (state, data) {
    state.market_value_evolution_probability_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_302" /* SET_MARKETSTUDY_OFFER_PRODUCTION */], function (state, data) {
    state.offer_production = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_303" /* SET_MARKETSTUDY_OFFER_YEARLY_STOCK */], function (state, data) {
    state.offer_yearly_stock = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_304" /* SET_MARKETSTUDY_OFFER_TREND */], function (state, data) {
    state.offer_trend = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_305" /* SET_MARKETSTUDY_DEMAND_LEVEL */], function (state, data) {
    state.demand_level = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_306" /* SET_MARKETSTUDY_DEMAND_SPEED_OF_SALES */], function (state, data) {
    state.demand_speed_of_sales = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_307" /* SET_MARKETSTUDY_DEMAND_TREND */], function (state, data) {
    state.demand_trend = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_308" /* SET_MARKETSTUDY_PRICES_EXPECTANCY */], function (state, data) {
    state.prices_expectancy = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_309" /* SET_MARKETSTUDY_PRICES_PAST_CICLES_VOLATILITY */], function (state, data) {
    state.prices_past_cicles_volatility = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_310" /* SET_MARKETSTUDY_MARKET_CONJUNCTURE */], function (state, data) {
    state.market_conjuncture = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_311" /* SET_MARKETSTUDY_MARKET_VALUE_REDUCTION_PROBABILITY_EXPECTANCY */], function (state, data) {
    state.market_value_reduction_probability_expectancy = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_312" /* SET_MARKETSTUDY_PRICES_MAX */], function (state, data) {
    state.prices_max = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_313" /* SET_MARKETSTUDY_PRICES_MIN */], function (state, data) {
    state.prices_min = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_314" /* SET_MARKETSTUDY_PRICES_MEAN */], function (state, data) {
    state.prices_mean = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_2__constants__["_315" /* SET_MARKETSTUDY_PRICES_MEDIAN */], function (state, data) {
    state.prices_median = data;
    state.dirty = true;
}), _mutations);

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

var getters = {

    marketstudy: function marketstudy(state) {
        return state;
    },
    weighing: function weighing(state) {
        return state.weighing;
    },
    representative_sample_typical_deviation: function representative_sample_typical_deviation(state) {
        return state.representative_sample_typical_deviation;
    },
    universal_sample_typical_deviation: function universal_sample_typical_deviation(state) {
        return state.universal_sample_typical_deviation;
    },
    appraised_points: function appraised_points(state) {
        return state.appraised_points;
    },
    comparable_points: function comparable_points(state) {
        return state.comparable_points;
    },
    regressionline_points: function regressionline_points(state) {
        return state.regressionline_points;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var default_state = {
    ad_comparables: {}
};
var state = default_state;

var actions = {
    FETCH_MARKETSTUDY_AD_COMPARABLES: function FETCH_MARKETSTUDY_AD_COMPARABLES(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;

        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            // console.log(res)
            if (!res) {
                res = { '0': { 'id': 'default', 'adopted_area': 0, 'offer_price': 0, 'offer_unit_price': 0 } };
            }
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_264" /* SET_MARKETSTUDY_AD_COMPARABLES */], res);
        });
    },
    SET_MARKETSTUDY_AD_COMPARABLES: function SET_MARKETSTUDY_AD_COMPARABLES(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_264" /* SET_MARKETSTUDY_AD_COMPARABLES */], data);
    },
    UPDATE_MARKETSTUDY_AD_COMPARABLES: function UPDATE_MARKETSTUDY_AD_COMPARABLES(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;

        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({ object: data.object, path: data.path, save_timestamp: false }).then(function (res) {});
    }

};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__constants__["_264" /* SET_MARKETSTUDY_AD_COMPARABLES */], function (state, data) {
    state.ad_comparables = check_undefined(data);
});

var getters = {
    marketstudy_ad_comparables: function marketstudy_ad_comparables(state) {
        return state.ad_comparables;
    }
};

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(6);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    matched_ads: [{ 'id': 'default', 'adopted_area': 0, 'offer_price': 0, 'offer_unit_price': 0 }]
};
var state = default_state;

function chunk(str, n) {
    var ret = [];
    var i = void 0;
    var len = void 0;

    for (i = 0, len = str.length; i < len; i += n) {
        ret.push(str.substr(i, n));
    }

    return ret;
}

//This function takes in latitude and longitude of two location and returns the distance between them (in km)
function calcDistance(lat1, lng1, lat2, lng2) {
    // console.log('yeah calc dist')
    var R = 6371; // km
    var dLat = toRad(lat2 - lat1);
    var dLng = toRad(lng2 - lng1);
    lat1 = toRad(lat1);
    lat2 = toRad(lat2);

    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.sin(dLng / 2) * Math.sin(dLng / 2) * Math.cos(lat1) * Math.cos(lat2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d;
}

// Converts numeric degrees to radians
function toRad(Value) {
    return Value * Math.PI / 180;
}

function collect_ad_locations(object, result) {
    _.forEach(object, function (value, key) {
        // console.log('value: ')
        // console.log(value)
        if (_.isObject(value)) {
            collect_ad_locations(value, result);
        } else {
            result.push(key);
        }
    });
}

var temp_i = 0;

function collect_ads(ref_lat, ref_lng, ref_startdate, ref_limitdate, radius_km, object, result) {
    _.forEach(object, function (value, key) {
        // console.log('value: ')
        // console.log(value)


        if (_.isObject(value)) {

            if (value['ad_address']) {
                console.log('-->  ' + value['ad_address']);
            } else {
                console.log('--> there is no value or no ad_address');
            }

            if (value['offer_price']) {
                // console.log('pushing value....')
                // console.log(value)
                /*temp_i = temp_i + 1
                 value['temp_id'] = temp_i.toString()*/

                if (__WEBPACK_IMPORTED_MODULE_1_moment___default()(value['ad_date']).isSameOrAfter(ref_startdate)) {

                    if (__WEBPACK_IMPORTED_MODULE_1_moment___default()(value['ad_date']).isSameOrBefore(ref_limitdate)) {

                        var distance = calcDistance(ref_lat, ref_lng, value['lat'], value['lng']).toFixed(3);

                        if (distance <= radius_km) {
                            value['distance'] = distance;
                            result.push(value);
                        } else {
                            console.log('distance is higher than radius_km');
                        }
                    } else {
                        console.log('ad_date is not same or before ref_limitdate');
                    }
                } else {
                    console.log('ad_date is not same or after ref_startdate');
                }
            } else {
                console.log('there is no value or no offer_price');
                collect_ads(ref_lat, ref_lng, ref_startdate, ref_limitdate, radius_km, value, result);
            }
        } else {
            console.log('item is not an object?? key: ');
            console.log(key);
            // console.log('*** not an object?? value: ')
            // console.log(value)

            /*
            if (key !== 0) {
                result.push(key)
            }
            */
        }
    });
}

var actions = {
    FETCH_MARKETSTUDY_MATCHED_ADS: function FETCH_MARKETSTUDY_MATCHED_ADS(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        // console.log('data.path (fetch_marketstudy_matched_ads) ---->')
        // console.log(data.path)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_265" /* SET_MARKETSTUDY_MATCHED_ADS */], res);
        });
    },
    QUERY_ADS: function QUERY_ADS(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;


        var result = [];
        return new Promise(function (resolve, reject) {
            var reference_geohash = data.geohash;

            console.log('Query ads data: ');
            console.log(data);
            console.log('reference_geohash: ');
            console.log(reference_geohash);

            // console.log('data.precision: ')
            // console.log(data.precision)

            var precision = 6;

            /*
            if (data.radius_km < 0.6) {
                precision = 6
            } else if (data.radius_km < 3.8) {
                precision = 5
            } else if (data.radius_km < 19) {
                precision = 3
            }
            */

            if (data.radius_km < 0.6) {
                precision = 5;
            } else if (data.radius_km < 3.8) {
                precision = 4;
            } else if (data.radius_km < 19) {
                precision = 3;
            }

            /*
            else{
                precision = 2
            }
            */

            var query_geohash = reference_geohash.substring(0, precision);

            // console.log('query_geohash:')
            // console.log(query_geohash)

            var ad_year_start = data.startdate;

            var ad_year_limit = data.limitdate;

            ad_year_start = ad_year_start.substring(0, 4);

            ad_year_limit = ad_year_limit.substring(0, 4);

            var query_path_start = 'ads' + '/' + data.ad_type + '/' + ad_year_start + '/' + chunk(query_geohash, 1).join('/');

            console.log('query_path_start: ');
            console.log(query_path_start);

            var query_path_limit = 'ads' + '/' + data.ad_type + '/' + ad_year_limit + '/' + chunk(query_geohash, 1).join('/');

            console.log('query_path_limit: ');
            console.log(query_path_limit);

            var average_price = 0;
            // let top_listed = []
            var markers = [];
            var map_url = 'https://maps.googleapis.com/maps/api/staticmap?' + 'center=' + data.lat + ',' + data.lng + '&zoom=' + '16' + '&size=' + '640x480' + '&maptype=' + 'roadmap' + '&markers=color:red%7Clabel:%7C' + data.lat + ',' + data.lng + '&style=' + 'feature:poi|element:labels|visibility:off' + '&format=' + 'png' + '&visual_refresh=' + 'true' + '&key=' + 'AIzaSyDSgNi8z5SzzrkFX2ndABL3b84wt8EsK_k';

            var sorted_result_start = [];
            var sorted_result_limit = [];

            var calcSum = function calcSum(array) {
                var num = 0;
                for (var i = 0, l = array.length; i < l; i++) {
                    num += array[i];
                }return num;
            };

            var calcMean = function calcMean(array) {
                return calcSum(array) / array.length;
            };

            var set_markers = function set_markers(sorted_result) {

                // we take 'offer_unit_price', not the 'estimated_unitsale_price'
                var unit_prices = _.map(sorted_result, 'offer_unit_price');
                var lats = _.map(sorted_result, 'lat');
                var lngs = _.map(sorted_result, 'lng');
                var urls = _.map(sorted_result, 'url');
                var addresses = _.map(sorted_result, 'google_formatted_address');

                var max_ads = 25;

                if (unit_prices.length > max_ads) {
                    // we get the first 30 elements only (the closest ones)
                    unit_prices = unit_prices.slice(0, max_ads);
                    lats = lats.slice(0, max_ads);
                    lngs = lngs.slice(0, max_ads);
                    urls = urls.slice(0, max_ads);
                    addresses = addresses.slice(0, max_ads);
                }

                for (var i = 0; i < unit_prices.length; i++) {

                    // var chr = String.fromCharCode(97 + n); // where n is 0, 1, 2 ...
                    //  Note that if n > 25, you will get out of the range of letters.

                    map_url += '&markers=color:blue%7Clabel:' + String.fromCharCode(97 + i).toUpperCase() + '%7C' + lats[i] + ',' + lngs[i];

                    markers.push({
                        position: {
                            lat: lats[i],
                            lng: lngs[i]
                        },
                        opacity: 1,
                        icon: 'https://firebasestorage.googleapis.com/v0/b/barnatasa5.appspot.com/o/app_assets%2Fsymbol_blank.png?alt=media&token=2a21b980-2dbb-4887-8fc3-3fba6d073252',
                        label: {
                            color: 'black',
                            text: (i + 1).toString()
                        },
                        unit_price: unit_prices[i],
                        url: urls[i],
                        address: addresses[i]
                    });
                }

                // console.log('prices: ')
                // console.log(prices)

                average_price = calcMean(unit_prices);

                average_price = Number(average_price.toFixed(2));

                var max = Math.max.apply(null, unit_prices);
                var min = Math.min.apply(null, unit_prices);
                var diff = max - min;

                // calculating step for color scale formatting
                for (var _i = 0; _i < unit_prices.length; _i++) {
                    var step = (unit_prices[_i] - min) / diff;
                    // console.log('step: ')
                    // console.log(step)
                    markers[_i]['step'] = step;
                }

                // console.log('average_area_prices: ')
                // console.log(average_price)
            };

            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: query_path_start }).then(function (res) {
                console.log('!wey-start! res: ');
                console.log(res);

                collect_ads(data.lat, data.lng, data.startdate, data.limitdate, data.radius_km, res, result);
                console.log('result: ');
                console.log(result);

                var sorted_result = _.sortBy(result, 'distance');

                sorted_result_start = sorted_result;

                if (ad_year_limit !== ad_year_start) {

                    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: query_path_limit }).then(function (res) {
                        console.log('!wey-limit! res: ');
                        console.log(res);

                        collect_ads(data.lat, data.lng, data.startdate, data.limitdate, data.radius_km, res, result);
                        console.log('result: ');
                        console.log(result);

                        var sorted_result_limit = _.sortBy(result, 'distance');

                        var final_sorted_result = sorted_result_start.concat(sorted_result_limit);

                        final_sorted_result = _.sortBy(final_sorted_result, 'distance');

                        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_265" /* SET_MARKETSTUDY_MATCHED_ADS */], final_sorted_result);

                        set_markers(final_sorted_result);

                        resolve({
                            result: final_sorted_result,
                            area_average_price: average_price,
                            map_url: map_url,
                            markers: markers
                        });
                    });
                } else {
                    commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_265" /* SET_MARKETSTUDY_MATCHED_ADS */], sorted_result);

                    set_markers(sorted_result);

                    resolve({
                        result: result,
                        area_average_price: average_price,
                        map_url: map_url,
                        markers: markers
                    });
                }
            });
        });
    },
    SET_MARKETSTUDY_MATCHED_ADS: function SET_MARKETSTUDY_MATCHED_ADS(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_2__constants__["_265" /* SET_MARKETSTUDY_MATCHED_ADS */], data);
    }

};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_2__constants__["_265" /* SET_MARKETSTUDY_MATCHED_ADS */], function (state, data) {
    state.matched_ads = check_undefined(data);
});

var getters = {
    marketstudy_matched_ads: function marketstudy_matched_ads(state) {
        return state.matched_ads;
    }
};

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    path: null,
    name_ca: null,
    name_en: null,
    name_es: null

};

var state = default_state;

var actions = {

    CREATE_NEW_NOTE: function CREATE_NEW_NOTE(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].create({ key: data.key, path: data.path }).then(function (res) {
                var new_created_key = res.key;

                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_60" /* SET_NOTE_ID */], res.key);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_61" /* SET_NOTE_DATE_CREATED */], res.date_created);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_62" /* SET_NOTE_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_63" /* SET_NOTE_PATH */], res.path);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_64" /* SET_NOTE_PARENT_PATH */], data.parent_path);

                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                    value: res.key,
                    path: data.path + new_created_key + '/' + 'id',
                    save_timestamp: false
                }).then(function (res) {
                    return resolve({ key: new_created_key });
                });
            });
        });
    },
    DELETE_NOTE: function DELETE_NOTE(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;


        // console.log('DELETE_NOTE path check: ' + data.path)
        // console.log('DELETE NOTE parent_path check: ' + data.parent_path)

        // delete from notes/note_key
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.path }).then(function (res) {});
    },
    GET_NOTE: function GET_NOTE(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;


        return new Promise(function (resolve, reject) {
            return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                return resolve(res);
            });
        });
    },
    SET_NOTE: function SET_NOTE(_ref4, data) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;


        // console.log('set_note data:')
        // console.log(data)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_65" /* SET_NOTE */], res);
        });
    },
    RESET_NOTE: function RESET_NOTE(_ref5) {
        var state = _ref5.state,
            commit = _ref5.commit,
            rootState = _ref5.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_66" /* RESET_NOTE */]);
    },
    SET_NOTE_REPORTDATE: function (_SET_NOTE_REPORTDATE) {
        function SET_NOTE_REPORTDATE(_x, _x2) {
            return _SET_NOTE_REPORTDATE.apply(this, arguments);
        }

        SET_NOTE_REPORTDATE.toString = function () {
            return _SET_NOTE_REPORTDATE.toString();
        };

        return SET_NOTE_REPORTDATE;
    }(function (_ref6, data) {
        var state = _ref6.state,
            commit = _ref6.commit,
            rootState = _ref6.rootState;

        commit(SET_NOTE_REPORTDATE, data);
    }),
    SET_NOTE_DATE_CREATED: function SET_NOTE_DATE_CREATED(_ref7, data) {
        var state = _ref7.state,
            commit = _ref7.commit,
            rootState = _ref7.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_61" /* SET_NOTE_DATE_CREATED */], data);
    },
    SET_NOTE_DATE_MODIFIED: function SET_NOTE_DATE_MODIFIED(_ref8, data) {
        var state = _ref8.state,
            commit = _ref8.commit,
            rootState = _ref8.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_62" /* SET_NOTE_DATE_MODIFIED */], data);
    },

    SET_NOTE_ID: function SET_NOTE_ID(_ref9, data) {
        var state = _ref9.state,
            commit = _ref9.commit,
            rootState = _ref9.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_60" /* SET_NOTE_ID */], data);
    },
    SET_NOTE_PARENT_PATH: function SET_NOTE_PARENT_PATH(_ref10, data) {
        var state = _ref10.state,
            commit = _ref10.commit,
            rootState = _ref10.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_64" /* SET_NOTE_PARENT_PATH */], data);
    },
    SET_NOTE_PATH: function SET_NOTE_PATH(_ref11, data) {
        var state = _ref11.state,
            commit = _ref11.commit,
            rootState = _ref11.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_63" /* SET_NOTE_PATH */], data);
    },
    UPDATE_NOTE: function UPDATE_NOTE(_ref12, data) {
        var state = _ref12.state,
            commit = _ref12.commit,
            rootState = _ref12.rootState;

        return new Promise(function (resolve, reject) {
            // console.log('UPDATE_NOTE data:')
            // console.log(data)
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({ object: data.object, path: data.path + data.key, save_timestamp: true }).then(function (res) {

                var date_modified = res.date_modified;
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_62" /* SET_NOTE_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_67" /* SET_NOTE_DIRTYNESS */], false);
                resolve();
            });
        });
    },
    SET_NOTE_NAME_CA: function SET_NOTE_NAME_CA(_ref13, data) {
        var state = _ref13.state,
            commit = _ref13.commit,
            rootState = _ref13.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_68" /* SET_NOTE_NAME_CA */], data);
    },
    SET_NOTE_NAME_EN: function SET_NOTE_NAME_EN(_ref14, data) {
        var state = _ref14.state,
            commit = _ref14.commit,
            rootState = _ref14.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_69" /* SET_NOTE_NAME_EN */], data);
    },
    SET_NOTE_NAME_ES: function SET_NOTE_NAME_ES(_ref15, data) {
        var state = _ref15.state,
            commit = _ref15.commit,
            rootState = _ref15.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_70" /* SET_NOTE_NAME_ES */], data);
    }

};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_66" /* RESET_NOTE */], function (state) {
    state.date_created = null;
    state.date_modified = null;
    state.dirty = false;
    state.file_id = null;
    state.id = null;
    state.path = null;
    state.parent_path = null;
    state.name_ca = null;
    state.name_en = null;
    state.name_es = null;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_65" /* SET_NOTE */], function (state, data) {
    state.date_created = check_undefined(data.date_created);
    state.date_modified = check_undefined(data.date_modified);
    state.dirty = false;
    state.file_id = check_undefined(data.file_id);
    state.id = check_undefined(data.id);
    state.path = check_undefined(data.path);
    state.parent_path = check_undefined(data.parent_path);
    state.name_ca = check_undefined(data.name_ca);
    state.name_en = check_undefined(data.name_en);
    state.name_es = check_undefined(data.name_es);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_61" /* SET_NOTE_DATE_CREATED */], function (state, data) {
    state.date_created = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_62" /* SET_NOTE_DATE_MODIFIED */], function (state, data) {
    state.date_modified = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_67" /* SET_NOTE_DIRTYNESS */], function (state, boolean) {
    state.dirty = boolean;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_60" /* SET_NOTE_ID */], function (state, data) {
    state.id = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_64" /* SET_NOTE_PARENT_PATH */], function (state, data) {
    state.parent_path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_63" /* SET_NOTE_PATH */], function (state, data) {
    state.path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_68" /* SET_NOTE_NAME_CA */], function (state, data) {
    state.name_ca = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_69" /* SET_NOTE_NAME_EN */], function (state, data) {
    state.name_en = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_70" /* SET_NOTE_NAME_ES */], function (state, data) {
    state.name_es = data;
    state.dirty = true;
}), _mutations);

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

var getters = {
    note: function note(state) {
        return state;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var state = {
    activeContact: null,
    activeKey: null,
    activeNote: null,
    bde_appraisal_files: {},
    bde_realestate_files: {},
    bde_comparable_files: {},
    bde_relationships_files: {},
    budget_request_data: null,
    appraisers: [],
    appraisalreports: [],
    realestates: [],
    appraisals: [],
    marketstudies: [],
    ad_comparables: [],
    supervisors: [],
    appraisalinvoices: [],
    appraisalquotes: [],
    contacts: [],
    entities: [],
    becproperties: [],
    notes: [],
    theme: 'light',
    tags_display: true,
    user_role: null,
    valuation_prices: {},
    warnings: [],
    constraints: [],
    stats_current: {}
};

var actions = {
    INIT_NOTES: function INIT_NOTES(_ref) {
        //return api.initNotesForUserId(rootState.auth.user.uid)

        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;
    },

    UPDATE_USER_INITIAL_DATA: function UPDATE_USER_INITIAL_DATA(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;

        return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].updateUserInitialData(rootState.auth.user.uid, data);
    },

    SET_TAGS_DISPLAY: function SET_TAGS_DISPLAY(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_94" /* SET_TAGS_DISPLAY */], data);
    },
    SET_BDE_APPRAISAL_FILES: function SET_BDE_APPRAISAL_FILES(_ref4, data) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_95" /* SET_BDE_APPRAISAL_FILES */], data);
    },
    SET_BDE_REALESTATE_FILES: function SET_BDE_REALESTATE_FILES(_ref5, data) {
        var state = _ref5.state,
            commit = _ref5.commit,
            rootState = _ref5.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_96" /* SET_BDE_REALESTATE_FILES */], data);
    },
    SET_BDE_COMPARABLE_FILES: function SET_BDE_COMPARABLE_FILES(_ref6, data) {
        var state = _ref6.state,
            commit = _ref6.commit,
            rootState = _ref6.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_97" /* SET_BDE_COMPARABLE_FILES */], data);
    },
    SET_BDE_RELATIONSHIPS_FILES: function SET_BDE_RELATIONSHIPS_FILES(_ref7, data) {
        var state = _ref7.state,
            commit = _ref7.commit,
            rootState = _ref7.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_98" /* SET_BDE_RELATIONSHIPS_FILES */], data);
    },
    FETCH_BECPROPERTIES: function FETCH_BECPROPERTIES(_ref8) {
        var state = _ref8.state,
            commit = _ref8.commit,
            rootState = _ref8.rootState;

        return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get({ path: 'becproperties' }).then(function (res) {
            // console.log(res)
            commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_99" /* SET_BECPROPERTIES */], res);
        });
    },
    FETCH_APPRAISERS: function FETCH_APPRAISERS(_ref9) {
        var state = _ref9.state,
            commit = _ref9.commit,
            rootState = _ref9.rootState;

        return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get({ path: 'appraisers' }).then(function (res) {
            // console.log(res)
            commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_100" /* SET_APPRAISERS */], res);
        });
    },
    FETCH_REALESTATES: function FETCH_REALESTATES(_ref10) {
        var state = _ref10.state,
            commit = _ref10.commit,
            rootState = _ref10.rootState;

        return new Promise(function (resolve, reject) {
            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get({ path: 'realestates' }).then(function (res) {
                // console.log(res)
                commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_101" /* SET_REALESTATES */], res);
                resolve(res);
            });
        });
    },
    FETCH_APPRAISALS: function FETCH_APPRAISALS(_ref11) {
        var state = _ref11.state,
            commit = _ref11.commit,
            rootState = _ref11.rootState;

        return new Promise(function (resolve, reject) {
            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get({ path: 'realestate_appraisals' }).then(function (res) {
                // console.log(res)
                commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_102" /* SET_APPRAISALS */], res);
                resolve(res);
            });
        });
    },
    FETCH_WARNINGS: function FETCH_WARNINGS(_ref12) {
        var state = _ref12.state,
            commit = _ref12.commit,
            rootState = _ref12.rootState;

        return new Promise(function (resolve, reject) {
            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get({ path: 'appraisal_warnings' }).then(function (res) {
                // console.log(res)
                commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_103" /* SET_WARNINGS */], res);
                resolve(res);
            });
        });
    },
    FETCH_CONSTRAINTS: function FETCH_CONSTRAINTS(_ref13) {
        var state = _ref13.state,
            commit = _ref13.commit,
            rootState = _ref13.rootState;

        return new Promise(function (resolve, reject) {
            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get({ path: 'appraisal_constraints' }).then(function (res) {
                // console.log(res)
                commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_104" /* SET_CONSTRAINTS */], res);
                resolve(res);
            });
        });
    },
    FETCH_MARKETSTUDIES: function FETCH_MARKETSTUDIES(_ref14) {
        var state = _ref14.state,
            commit = _ref14.commit,
            rootState = _ref14.rootState;

        return new Promise(function (resolve, reject) {
            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get({ path: 'realestate_marketstudies' }).then(function (res) {
                // console.log(res)
                commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_105" /* SET_MARKETSTUDIES */], res);
                resolve(res);
            });
        });
    },
    FETCH_AD_COMPARABLES: function FETCH_AD_COMPARABLES(_ref15) {
        var state = _ref15.state,
            commit = _ref15.commit,
            rootState = _ref15.rootState;

        return new Promise(function (resolve, reject) {
            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get({ path: 'marketstudy_ad_comparables' }).then(function (res) {
                // console.log(res)
                commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_106" /* SET_AD_COMPARABLES */], res);
                resolve(res);
            });
        });
    },
    FETCH_SUPERVISORS: function FETCH_SUPERVISORS(_ref16) {
        var state = _ref16.state,
            commit = _ref16.commit,
            rootState = _ref16.rootState;

        return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get({ path: 'supervisors' }).then(function (res) {
            // console.log(res)
            commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_107" /* SET_SUPERVISORS */], res);
        });
    },
    FETCH_APPRAISALREPORTS: function FETCH_APPRAISALREPORTS(_ref17) {
        var state = _ref17.state,
            commit = _ref17.commit,
            rootState = _ref17.rootState;

        return new Promise(function (resolve, reject) {
            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get({ path: 'appraisalreports' }).then(function (res) {
                // console.log(res)
                commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_108" /* SET_APPRAISALREPORTS */], res);
                resolve(res);
            });
        });
    },
    FETCH_CONTACTS: function FETCH_CONTACTS(_ref18) {
        var state = _ref18.state,
            commit = _ref18.commit,
            rootState = _ref18.rootState;

        return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getContacts().then(function (res) {
            // console.log(res)
            commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_109" /* SET_CONTACTS */], res);
        });
    },
    FETCH_APPRAISALINVOICES: function FETCH_APPRAISALINVOICES(_ref19) {
        var state = _ref19.state,
            commit = _ref19.commit,
            rootState = _ref19.rootState;

        return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get({ path: 'appraisalinvoices' }).then(function (res) {
            // console.log(res)
            commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_110" /* SET_APPRAISALINVOICES */], res);
        });
    },
    FETCH_APPRAISALQUOTES: function FETCH_APPRAISALQUOTES(_ref20) {
        var state = _ref20.state,
            commit = _ref20.commit,
            rootState = _ref20.rootState;

        return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get({ path: 'appraisalquotes' }).then(function (res) {
            // console.log(res)
            commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_111" /* SET_APPRAISALQUOTES */], res);
        });
    },
    FETCH_STATS_CURRENT: function FETCH_STATS_CURRENT(_ref21) {
        var state = _ref21.state,
            commit = _ref21.commit,
            rootState = _ref21.rootState;

        return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get({ path: 'stats/current' }).then(function (res) {
            // console.log(res)
            commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_112" /* SET_STATS_CURRENT */], res);
        });
    },
    FETCH_ENTITIES: function FETCH_ENTITIES(_ref22) {
        var state = _ref22.state,
            commit = _ref22.commit,
            rootState = _ref22.rootState;

        return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get({ path: 'entities' }).then(function (res) {
            // console.log(res)
            commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_113" /* SET_ENTITIES */], res);
        });
    },
    FETCH_USER_DATA: function FETCH_USER_DATA(_ref23) {
        var state = _ref23.state,
            commit = _ref23.commit,
            rootState = _ref23.rootState;

        return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getDataForUserId(rootState.auth.user.uid).then(function (res) {
            //commit(SET_NOTES, res.notes)
            // commit(SET_THEME, res.theme)
            commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_114" /* SET_USER_ROLE */], res.role);

            //nota: origialment no era així, això sobreescriu l'objecte user per defecte, que conté altres dades de quan fas logion, potser eren importants?
            commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_115" /* SET_USER */], res);
        });
    },
    FETCH_USER_APPRAISALS: function FETCH_USER_APPRAISALS(_ref24) {
        var state = _ref24.state,
            commit = _ref24.commit,
            rootState = _ref24.rootState;

        return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getAppraisalIdsForUserId(rootState.auth.user.uid).then(function (res) {
            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getAppraisals(res.appraisal_ids).then(function (res) {
                commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_102" /* SET_APPRAISALS */], res.appraisals);
            });
        });
    },

    FETCH_VALUATION_PRICES: function FETCH_VALUATION_PRICES(_ref25) {
        var state = _ref25.state,
            commit = _ref25.commit,
            rootState = _ref25.rootState;

        return new Promise(function (resolve, reject) {
            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getValuationPrices().then(function (res) {
                commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_116" /* SET_VALUATION_PRICES */], res);
                resolve(res);
            });
        });
    },
    FETCH: function FETCH(_ref26, data) {
        var state = _ref26.state,
            commit = _ref26.commit,
            rootState = _ref26.rootState;

        return new Promise(function (resolve, reject) {
            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                resolve(res);
            });
        });
    },
    FETCH_PREVIEW_DATA: function FETCH_PREVIEW_DATA(_ref27) {
        var state = _ref27.state,
            commit = _ref27.commit,
            rootState = _ref27.rootState;

        return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getPreviewData().then(function (res) {
            commit(__WEBPACK_IMPORTED_MODULE_3__constants__["h" /* SET_NOTES */], res.notes);
            commit(__WEBPACK_IMPORTED_MODULE_3__constants__["f" /* SET_THEME */], res.theme);
        });
    },

    CREATE_NOTE: function CREATE_NOTE(_ref28, note) {
        var state = _ref28.state,
            commit = _ref28.commit,
            rootState = _ref28.rootState;

        if (rootState.auth.user) {
            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].createNote(rootState.auth.user.uid, note).then(function (key) {
                commit(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* SET_RESULT_INDEX */], 0);
                commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_117" /* CREATE_NOTE */], { key: key, note: note });
            });
        } else {
            commit(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* SET_RESULT_INDEX */], 0);
            commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_117" /* CREATE_NOTE */], { key: note.id, note: note });
        }
    },

    UPDATE_BUDGET_REQUEST: function UPDATE_BUDGET_REQUEST(_ref29, data) {
        var state = _ref29.state,
            commit = _ref29.commit,
            rootState = _ref29.rootState;

        return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].updateBudgetRequest(data).then(function (res) {
            return commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_118" /* UPDATE_BUDGET_REQUEST */], { data: data });
        });
    },
    /*
        UPDATE_NOTE: ({state, commit, rootState}) => {
            if (rootState.auth.user) {
                return api.updateNote(rootState.auth.user.uid, state.activeKey, state.activeNote)
                    .then((res) => commit(UPDATE_NOTE, {key: res.key, date_modified: res.date_modified}))
            } else {
                const dateModified = moment().toString()
                commit(UPDATE_NOTE, {key: state.activeKey, date_modified: dateModified})
            }
        },
         DELETE_NOTE: ({state, commit, rootState}) => {
            if (rootState.auth.user) {
                return api.deleteNote(rootState.auth.user.uid, state.activeKey)
                    .then(() => { commit(DELETE_NOTE, state.activeKey)})
            } else {
                commit(DELETE_NOTE, state.activeKey)
            }
        },
        */

    SET_APPRAISAL_FLOOR_NUMBER_BY_KEY: function SET_APPRAISAL_FLOOR_NUMBER_BY_KEY(_ref30, data) {
        var state = _ref30.state,
            commit = _ref30.commit,
            rootState = _ref30.rootState;

        return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].set_value({
            path: 'realestate_appraisals/' + data.realestate_id + '/' + data.appraisal_id + '/' + 'floor_number',
            value: data.floor_number
        });
    },

    SET_APPRAISAL_PROPERTY_TYPE_BY_KEY: function SET_APPRAISAL_PROPERTY_TYPE_BY_KEY(_ref31, data) {
        var state = _ref31.state,
            commit = _ref31.commit,
            rootState = _ref31.rootState;

        return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].set_value({
            path: 'realestate_appraisals/' + data.realestate_id + '/' + data.appraisal_id + '/' + 'property_type',
            value: data.property_type
        });
    },

    UPDATE_THEME: function UPDATE_THEME(_ref32, theme) {
        var state = _ref32.state,
            commit = _ref32.commit,
            rootState = _ref32.rootState;

        if (rootState.auth.user) {
            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].updateTheme(rootState.auth.user.uid, theme).then(function (theme) {
                return commit(__WEBPACK_IMPORTED_MODULE_3__constants__["f" /* SET_THEME */], theme);
            });
        } else {
            commit(__WEBPACK_IMPORTED_MODULE_3__constants__["f" /* SET_THEME */], theme);
        }
    },

    UPDATE_LANGUAGE: function UPDATE_LANGUAGE(_ref33, language) {
        var state = _ref33.state,
            commit = _ref33.commit,
            rootState = _ref33.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["e" /* SET_LANGUAGE */], language);
        /*
        if (rootState.auth.user) {
            return api.updateTheme(rootState.auth.user.uid, language)
                .then((language) => commit(SET_LANGUAGE, language))
         } else {
            commit(SET_LANGUAGE, language)
        }
        */
    },

    TOGGLE_IS_PUBLIC: function TOGGLE_IS_PUBLIC(_ref34, note) {
        var state = _ref34.state,
            commit = _ref34.commit,
            rootState = _ref34.rootState;

        return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].toggleIsPublic(rootState.auth.user.uid, state.activeKey, note).then(function (res) {
            return commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_119" /* TOGGLE_IS_PUBLIC */], { key: res.key, is_public: res.is_public });
        });
    },

    FETCH_PUBLIC_NOTE_FOR_ID: function FETCH_PUBLIC_NOTE_FOR_ID(_ref35, noteId) {
        var state = _ref35.state,
            commit = _ref35.commit,
            rootState = _ref35.rootState;

        return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getPublicNoteForId(noteId).then(function (note) {
            return commit(__WEBPACK_IMPORTED_MODULE_3__constants__["d" /* SET_ACTIVE_NOTE */], note);
        });
    },
    GET: function GET(_ref36, data) {
        var state = _ref36.state,
            commit = _ref36.commit,
            rootState = _ref36.rootState;


        return new Promise(function (resolve, reject) {
            return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                return resolve(res);
            });
        });
    }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_117" /* CREATE_NOTE */], function (state, data) {
    __WEBPACK_IMPORTED_MODULE_0_vue___default.a.set(state.notes, data.key, data.note);
    state.activeKey = data.key;
    state.activeNote = data.note;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_120" /* DELETE_NOTE */], function (state, key) {
    __WEBPACK_IMPORTED_MODULE_0_vue___default.a.delete(state.notes, key);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* SET_ACTIVE_CONTACT */], function (state, contact) {
    state.activeContact = contact;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["d" /* SET_ACTIVE_NOTE */], function (state, note) {
    state.activeNote = note;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["c" /* SET_ACTIVE_KEY */], function (state, key) {
    state.activeKey = key;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_102" /* SET_APPRAISALS */], function (state, data) {
    state.appraisals = data;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_103" /* SET_WARNINGS */], function (state, data) {
    state.warnings = data;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_104" /* SET_CONSTRAINTS */], function (state, data) {
    state.constraints = data;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_105" /* SET_MARKETSTUDIES */], function (state, data) {
    state.marketstudies = data;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_106" /* SET_AD_COMPARABLES */], function (state, data) {
    state.ad_comparables = data;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_100" /* SET_APPRAISERS */], function (state, data) {
    state.appraisers = data;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_101" /* SET_REALESTATES */], function (state, data) {
    state.realestates = data;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_107" /* SET_SUPERVISORS */], function (state, data) {
    state.supervisors = data;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_108" /* SET_APPRAISALREPORTS */], function (state, data) {
    state.appraisalreports = data;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_110" /* SET_APPRAISALINVOICES */], function (state, data) {
    state.appraisalinvoices = data;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_111" /* SET_APPRAISALQUOTES */], function (state, data) {
    state.appraisalquotes = data;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_112" /* SET_STATS_CURRENT */], function (state, data) {
    state.stats_current = data;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_109" /* SET_CONTACTS */], function (state, contacts) {
    state.contacts = contacts;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_99" /* SET_BECPROPERTIES */], function (state, data) {
    state.becproperties = data;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_113" /* SET_ENTITIES */], function (state, data) {
    state.entities = data;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["e" /* SET_LANGUAGE */], function (state, language) {
    state.language = language;
    __WEBPACK_IMPORTED_MODULE_0_vue___default.a.i18n.set(language);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["h" /* SET_NOTES */], function (state, notes) {
    state.notes = notes;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_94" /* SET_TAGS_DISPLAY */], function (state, data) {
    state.tags_display = data;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["f" /* SET_THEME */], function (state, theme) {
    state.theme = theme;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_114" /* SET_USER_ROLE */], function (state, user_role) {
    state.user_role = user_role;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_116" /* SET_VALUATION_PRICES */], function (state, valuation_prices) {
    state.valuation_prices = valuation_prices;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_119" /* TOGGLE_IS_PUBLIC */], function (state, data) {
    var note = state.notes['' + data.key];
    note.is_public = data.is_public;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_118" /* UPDATE_BUDGET_REQUEST */], function (state, data) {
    state.budget_request_data = data;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_121" /* UPDATE_NOTE */], function (state, data) {
    var note = state.notes['' + data.key];
    note.date_modified = data.date_modified;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_95" /* SET_BDE_APPRAISAL_FILES */], function (state, value) {
    state.bde_appraisal_files = value;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_96" /* SET_BDE_REALESTATE_FILES */], function (state, value) {
    state.bde_realestate_files = value;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_97" /* SET_BDE_COMPARABLE_FILES */], function (state, value) {
    state.bde_comparable_files = value;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_98" /* SET_BDE_RELATIONSHIPS_FILES */], function (state, value) {
    state.bde_relationships_files = value;
}), _mutations);

var getters = {
    activeContact: function activeContact(state) {
        return state.activeContact;
    },
    activeKey: function activeKey(state) {
        return state.activeKey;
    },
    activeNote: function activeNote(state) {
        return state.activeNote;
    },
    bde_appraisal_files: function bde_appraisal_files(state) {
        return state.bde_appraisal_files;
    },
    bde_realestate_files: function bde_realestate_files(state) {
        return state.bde_realestate_files;
    },
    bde_comparable_files: function bde_comparable_files(state) {
        return state.bde_comparable_files;
    },
    bde_relationships_files: function bde_relationships_files(state) {
        return state.bde_relationships_files;
    },
    budget_request_data: function budget_request_data(state) {
        return state.budget_request_data;
    },
    appraisers: function appraisers(state) {
        return state.appraisers;
    },
    constraints: function constraints(state) {
        return state.constraints;
    },
    realestates: function realestates(state) {
        return state.realestates;
    },
    stats_current: function stats_current(state) {
        return state.stats_current;
    },
    supervisors: function supervisors(state) {
        return state.supervisors;
    },
    appraisals: function appraisals(state) {
        return state.appraisals;
    },
    marketstudies: function marketstudies(state) {
        return state.marketstudies;
    },
    ad_comparables: function ad_comparables(state) {
        return state.ad_comparables;
    },
    appraisalreports: function appraisalreports(state) {
        return state.appraisalreports;
    },
    appraisalinvoices: function appraisalinvoices(state) {
        return state.appraisalinvoices;
    },
    appraisalquotes: function appraisalquotes(state) {
        return state.appraisalquotes;
    },
    contacts: function contacts(state) {
        return state.contacts;
    },
    becproperties: function becproperties(state) {
        return state.becproperties;
    },
    entities: function entities(state) {
        return state.entities;
    },
    language: function language(state) {
        return state.language;
    },
    notes: function notes(state) {
        return state.notes;
    },
    tags_display: function tags_display(state) {
        return state.tags_display;
    },
    theme: function theme(state) {
        return state.theme;
    },
    user_role: function user_role(state) {
        return state.user_role;
    },
    valuation_prices: function valuation_prices(state) {
        return state.valuation_prices;
    },
    warnings: function warnings(state) {
        return state.warnings;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    path: null,
    name_ca: null,
    name_en: null,
    name_es: null,
    url: null,
    filename: null

};

var state = default_state;

var actions = {

    CREATE_NEW_OTHERANNEX: function CREATE_NEW_OTHERANNEX(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].create({ key: data.key, path: data.path }).then(function (res) {
                var new_created_key = res.key;

                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["k" /* SET_OTHERANNEX_ID */], res.key);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["l" /* SET_OTHERANNEX_DATE_CREATED */], res.date_created);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["m" /* SET_OTHERANNEX_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["n" /* SET_OTHERANNEX_PATH */], res.path);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["o" /* SET_OTHERANNEX_PARENT_PATH */], data.parent_path);

                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                    value: res.key,
                    path: data.path + new_created_key + '/' + 'id',
                    save_timestamp: false
                }).then(function (res) {
                    return resolve({ key: new_created_key });
                });
            });
        });
    },
    DELETE_OTHERANNEX: function DELETE_OTHERANNEX(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;


        // console.log('DELETE_OTHERANNEX path check: ' + data.path)
        // console.log('DELETE OTHERANNEX parent_path check: ' + data.parent_path)

        // delete from otherannexes/otherannex_key
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.path }).then(function (res) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].deleteImage({ path: data.path, filename: data.filename });
        });
    },
    GET_OTHERANNEX: function GET_OTHERANNEX(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;


        return new Promise(function (resolve, reject) {
            return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                return resolve(res);
            });
        });
    },
    SET_OTHERANNEX: function SET_OTHERANNEX(_ref4, data) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;


        // console.log('set_otherannex data:')
        // console.log(data)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["p" /* SET_OTHERANNEX */], res);
        });
    },
    RESET_OTHERANNEX: function RESET_OTHERANNEX(_ref5) {
        var state = _ref5.state,
            commit = _ref5.commit,
            rootState = _ref5.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["q" /* RESET_OTHERANNEX */]);
    },
    SET_OTHERANNEX_REPORTDATE: function (_SET_OTHERANNEX_REPORTDATE) {
        function SET_OTHERANNEX_REPORTDATE(_x, _x2) {
            return _SET_OTHERANNEX_REPORTDATE.apply(this, arguments);
        }

        SET_OTHERANNEX_REPORTDATE.toString = function () {
            return _SET_OTHERANNEX_REPORTDATE.toString();
        };

        return SET_OTHERANNEX_REPORTDATE;
    }(function (_ref6, data) {
        var state = _ref6.state,
            commit = _ref6.commit,
            rootState = _ref6.rootState;

        commit(SET_OTHERANNEX_REPORTDATE, data);
    }),
    SET_OTHERANNEX_DATE_CREATED: function SET_OTHERANNEX_DATE_CREATED(_ref7, data) {
        var state = _ref7.state,
            commit = _ref7.commit,
            rootState = _ref7.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["l" /* SET_OTHERANNEX_DATE_CREATED */], data);
    },
    SET_OTHERANNEX_DATE_MODIFIED: function SET_OTHERANNEX_DATE_MODIFIED(_ref8, data) {
        var state = _ref8.state,
            commit = _ref8.commit,
            rootState = _ref8.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["m" /* SET_OTHERANNEX_DATE_MODIFIED */], data);
    },

    SET_OTHERANNEX_ID: function SET_OTHERANNEX_ID(_ref9, data) {
        var state = _ref9.state,
            commit = _ref9.commit,
            rootState = _ref9.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["k" /* SET_OTHERANNEX_ID */], data);
    },
    SET_OTHERANNEX_PARENT_PATH: function SET_OTHERANNEX_PARENT_PATH(_ref10, data) {
        var state = _ref10.state,
            commit = _ref10.commit,
            rootState = _ref10.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["o" /* SET_OTHERANNEX_PARENT_PATH */], data);
    },
    SET_OTHERANNEX_PATH: function SET_OTHERANNEX_PATH(_ref11, data) {
        var state = _ref11.state,
            commit = _ref11.commit,
            rootState = _ref11.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["n" /* SET_OTHERANNEX_PATH */], data);
    },
    UPDATE_OTHERANNEX: function UPDATE_OTHERANNEX(_ref12, data) {
        var state = _ref12.state,
            commit = _ref12.commit,
            rootState = _ref12.rootState;

        return new Promise(function (resolve, reject) {
            // console.log('UPDATE_OTHERANNEX data:')
            // console.log(data)
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({ object: data.object, path: data.path + data.key, save_timestamp: true }).then(function (res) {

                var date_modified = res.date_modified;
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["m" /* SET_OTHERANNEX_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["r" /* SET_OTHERANNEX_DIRTYNESS */], false);
                resolve();
            });
        });
    },
    SET_OTHERANNEX_NAME_CA: function SET_OTHERANNEX_NAME_CA(_ref13, data) {
        var state = _ref13.state,
            commit = _ref13.commit,
            rootState = _ref13.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["s" /* SET_OTHERANNEX_NAME_CA */], data);
    },
    SET_OTHERANNEX_NAME_EN: function SET_OTHERANNEX_NAME_EN(_ref14, data) {
        var state = _ref14.state,
            commit = _ref14.commit,
            rootState = _ref14.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["t" /* SET_OTHERANNEX_NAME_EN */], data);
    },
    SET_OTHERANNEX_NAME_ES: function SET_OTHERANNEX_NAME_ES(_ref15, data) {
        var state = _ref15.state,
            commit = _ref15.commit,
            rootState = _ref15.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["u" /* SET_OTHERANNEX_NAME_ES */], data);
    },
    SET_OTHERANNEX_URL: function SET_OTHERANNEX_URL(_ref16, data) {
        var state = _ref16.state,
            commit = _ref16.commit,
            rootState = _ref16.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["v" /* SET_OTHERANNEX_URL */], data);
    },
    SET_OTHERANNEX_FILENAME: function SET_OTHERANNEX_FILENAME(_ref17, data) {
        var state = _ref17.state,
            commit = _ref17.commit,
            rootState = _ref17.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["w" /* SET_OTHERANNEX_FILENAME */], data);
    }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["q" /* RESET_OTHERANNEX */], function (state) {
    state.date_created = null;
    state.date_modified = null;
    state.dirty = false;
    state.file_id = null;
    state.id = null;
    state.path = null;
    state.parent_path = null;
    state.name_ca = null;
    state.name_en = null;
    state.name_es = null;
    state.url = null;
    state.filename = null;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["p" /* SET_OTHERANNEX */], function (state, data) {
    state.date_created = check_undefined(data.date_created);
    state.date_modified = check_undefined(data.date_modified);
    state.dirty = false;
    state.file_id = check_undefined(data.file_id);
    state.id = check_undefined(data.id);
    state.path = check_undefined(data.path);
    state.parent_path = check_undefined(data.parent_path);
    state.name_ca = check_undefined(data.name_ca);
    state.name_en = check_undefined(data.name_en);
    state.name_es = check_undefined(data.name_es);
    state.url = check_undefined(data.url);
    state.filename = check_undefined(data.filename);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["l" /* SET_OTHERANNEX_DATE_CREATED */], function (state, data) {
    state.date_created = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["m" /* SET_OTHERANNEX_DATE_MODIFIED */], function (state, data) {
    state.date_modified = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["r" /* SET_OTHERANNEX_DIRTYNESS */], function (state, boolean) {
    state.dirty = boolean;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["k" /* SET_OTHERANNEX_ID */], function (state, data) {
    state.id = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["o" /* SET_OTHERANNEX_PARENT_PATH */], function (state, data) {
    state.parent_path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["n" /* SET_OTHERANNEX_PATH */], function (state, data) {
    state.path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["s" /* SET_OTHERANNEX_NAME_CA */], function (state, data) {
    state.name_ca = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["t" /* SET_OTHERANNEX_NAME_EN */], function (state, data) {
    state.name_en = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["u" /* SET_OTHERANNEX_NAME_ES */], function (state, data) {
    state.name_es = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["v" /* SET_OTHERANNEX_URL */], function (state, data) {
    state.url = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["w" /* SET_OTHERANNEX_FILENAME */], function (state, data) {
    state.filename = data;
    state.dirty = true;
}), _mutations);

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

var getters = {
    otherannex: function otherannex(state) {
        return state;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    path: null,
    name_ca: null,
    name_en: null,
    name_es: null,
    url: null,
    filename: null,
    is_cover_photo: false

};

var state = default_state;

var actions = {

    CREATE_NEW_PHOTOGRAPH: function CREATE_NEW_PHOTOGRAPH(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].create({ key: data.key, path: data.path }).then(function (res) {
                var new_created_key = res.key;

                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_46" /* SET_PHOTOGRAPH_ID */], res.key);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_47" /* SET_PHOTOGRAPH_DATE_CREATED */], res.date_created);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_48" /* SET_PHOTOGRAPH_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_49" /* SET_PHOTOGRAPH_PATH */], res.path);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_50" /* SET_PHOTOGRAPH_PARENT_PATH */], data.parent_path);

                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                    value: res.key,
                    path: data.path + new_created_key + '/' + 'id',
                    save_timestamp: false
                }).then(function (res) {
                    return resolve({ key: new_created_key });
                });
            });
        });
    },
    DELETE_PHOTOGRAPH: function DELETE_PHOTOGRAPH(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;


        // console.log('DELETE_PHOTOGRAPH path check: ' + data.path)
        // console.log('DELETE PHOTOGRAPH parent_path check: ' + data.parent_path)

        // delete from photographs/photograph_key
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.path }).then(function (res) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].deleteImage({ path: data.path, filename: data.filename });
        });
    },
    GET_PHOTOGRAPH: function GET_PHOTOGRAPH(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;


        return new Promise(function (resolve, reject) {
            return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                return resolve(res);
            });
        });
    },
    SET_PHOTOGRAPH: function SET_PHOTOGRAPH(_ref4, data) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;


        // console.log('set_photograph data:')
        // console.log(data)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_51" /* SET_PHOTOGRAPH */], res);
        });
    },
    RESET_PHOTOGRAPH: function RESET_PHOTOGRAPH(_ref5) {
        var state = _ref5.state,
            commit = _ref5.commit,
            rootState = _ref5.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_52" /* RESET_PHOTOGRAPH */]);
    },
    SET_PHOTOGRAPH_REPORTDATE: function (_SET_PHOTOGRAPH_REPORTDATE) {
        function SET_PHOTOGRAPH_REPORTDATE(_x, _x2) {
            return _SET_PHOTOGRAPH_REPORTDATE.apply(this, arguments);
        }

        SET_PHOTOGRAPH_REPORTDATE.toString = function () {
            return _SET_PHOTOGRAPH_REPORTDATE.toString();
        };

        return SET_PHOTOGRAPH_REPORTDATE;
    }(function (_ref6, data) {
        var state = _ref6.state,
            commit = _ref6.commit,
            rootState = _ref6.rootState;

        commit(SET_PHOTOGRAPH_REPORTDATE, data);
    }),
    SET_PHOTOGRAPH_DATE_CREATED: function SET_PHOTOGRAPH_DATE_CREATED(_ref7, data) {
        var state = _ref7.state,
            commit = _ref7.commit,
            rootState = _ref7.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_47" /* SET_PHOTOGRAPH_DATE_CREATED */], data);
    },
    SET_PHOTOGRAPH_DATE_MODIFIED: function SET_PHOTOGRAPH_DATE_MODIFIED(_ref8, data) {
        var state = _ref8.state,
            commit = _ref8.commit,
            rootState = _ref8.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_48" /* SET_PHOTOGRAPH_DATE_MODIFIED */], data);
    },

    SET_PHOTOGRAPH_ID: function SET_PHOTOGRAPH_ID(_ref9, data) {
        var state = _ref9.state,
            commit = _ref9.commit,
            rootState = _ref9.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_46" /* SET_PHOTOGRAPH_ID */], data);
    },
    SET_PHOTOGRAPH_PARENT_PATH: function SET_PHOTOGRAPH_PARENT_PATH(_ref10, data) {
        var state = _ref10.state,
            commit = _ref10.commit,
            rootState = _ref10.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_50" /* SET_PHOTOGRAPH_PARENT_PATH */], data);
    },
    SET_PHOTOGRAPH_PATH: function SET_PHOTOGRAPH_PATH(_ref11, data) {
        var state = _ref11.state,
            commit = _ref11.commit,
            rootState = _ref11.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_49" /* SET_PHOTOGRAPH_PATH */], data);
    },
    UPDATE_PHOTOGRAPH: function UPDATE_PHOTOGRAPH(_ref12, data) {
        var state = _ref12.state,
            commit = _ref12.commit,
            rootState = _ref12.rootState;

        return new Promise(function (resolve, reject) {
            // console.log('UPDATE_PHOTOGRAPH data:')
            // console.log(data)
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({ object: data.object, path: data.path + data.key, save_timestamp: true }).then(function (res) {

                var date_modified = res.date_modified;
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_48" /* SET_PHOTOGRAPH_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_53" /* SET_PHOTOGRAPH_DIRTYNESS */], false);
                resolve();
            });
        });
    },
    SET_PHOTOGRAPH_NAME_CA: function SET_PHOTOGRAPH_NAME_CA(_ref13, data) {
        var state = _ref13.state,
            commit = _ref13.commit,
            rootState = _ref13.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_54" /* SET_PHOTOGRAPH_NAME_CA */], data);
    },
    SET_PHOTOGRAPH_NAME_EN: function SET_PHOTOGRAPH_NAME_EN(_ref14, data) {
        var state = _ref14.state,
            commit = _ref14.commit,
            rootState = _ref14.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_55" /* SET_PHOTOGRAPH_NAME_EN */], data);
    },
    SET_PHOTOGRAPH_NAME_ES: function SET_PHOTOGRAPH_NAME_ES(_ref15, data) {
        var state = _ref15.state,
            commit = _ref15.commit,
            rootState = _ref15.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_56" /* SET_PHOTOGRAPH_NAME_ES */], data);
    },
    SET_PHOTOGRAPH_URL: function SET_PHOTOGRAPH_URL(_ref16, data) {
        var state = _ref16.state,
            commit = _ref16.commit,
            rootState = _ref16.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_57" /* SET_PHOTOGRAPH_URL */], data);
    },
    SET_PHOTOGRAPH_FILENAME: function SET_PHOTOGRAPH_FILENAME(_ref17, data) {
        var state = _ref17.state,
            commit = _ref17.commit,
            rootState = _ref17.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_58" /* SET_PHOTOGRAPH_FILENAME */], data);
    },
    SET_PHOTOGRAPH_IS_COVER_PHOTO: function SET_PHOTOGRAPH_IS_COVER_PHOTO(_ref18, data) {
        var state = _ref18.state,
            commit = _ref18.commit,
            rootState = _ref18.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_59" /* SET_PHOTOGRAPH_IS_COVER_PHOTO */], data);
    }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_52" /* RESET_PHOTOGRAPH */], function (state) {
    state.date_created = null;
    state.date_modified = null;
    state.dirty = false;
    state.file_id = null;
    state.id = null;
    state.path = null;
    state.parent_path = null;
    state.name_ca = null;
    state.name_en = null;
    state.name_es = null;
    state.url = null;
    state.filename = null;
    state.is_cover_photo = false;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_51" /* SET_PHOTOGRAPH */], function (state, data) {
    state.date_created = check_undefined(data.date_created);
    state.date_modified = check_undefined(data.date_modified);
    state.dirty = false;
    state.file_id = check_undefined(data.file_id);
    state.id = check_undefined(data.id);
    state.path = check_undefined(data.path);
    state.parent_path = check_undefined(data.parent_path);
    state.name_ca = check_undefined(data.name_ca);
    state.name_en = check_undefined(data.name_en);
    state.name_es = check_undefined(data.name_es);
    state.url = check_undefined(data.url);
    state.filename = check_undefined(data.filename);
    state.is_cover_photo = check_undefined(data.is_cover_photo);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_47" /* SET_PHOTOGRAPH_DATE_CREATED */], function (state, data) {
    state.date_created = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_48" /* SET_PHOTOGRAPH_DATE_MODIFIED */], function (state, data) {
    state.date_modified = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_53" /* SET_PHOTOGRAPH_DIRTYNESS */], function (state, boolean) {
    state.dirty = boolean;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_46" /* SET_PHOTOGRAPH_ID */], function (state, data) {
    state.id = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_50" /* SET_PHOTOGRAPH_PARENT_PATH */], function (state, data) {
    state.parent_path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_49" /* SET_PHOTOGRAPH_PATH */], function (state, data) {
    state.path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_54" /* SET_PHOTOGRAPH_NAME_CA */], function (state, data) {
    state.name_ca = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_55" /* SET_PHOTOGRAPH_NAME_EN */], function (state, data) {
    state.name_en = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_56" /* SET_PHOTOGRAPH_NAME_ES */], function (state, data) {
    state.name_es = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_57" /* SET_PHOTOGRAPH_URL */], function (state, data) {
    state.url = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_58" /* SET_PHOTOGRAPH_FILENAME */], function (state, data) {
    state.filename = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_59" /* SET_PHOTOGRAPH_IS_COVER_PHOTO */], function (state, data) {
    state.is_cover_photo = data;
    state.dirty = true;
}), _mutations);

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

var getters = {
    photograph: function photograph(state) {
        return state;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    path: null,
    name_ca: null,
    name_en: null,
    name_es: null,
    url: null,
    filename: null

};

var state = default_state;

var actions = {

    CREATE_NEW_PLANANNEX: function CREATE_NEW_PLANANNEX(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].create({ key: data.key, path: data.path }).then(function (res) {
                var new_created_key = res.key;

                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["K" /* SET_PLANANNEX_ID */], res.key);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["L" /* SET_PLANANNEX_DATE_CREATED */], res.date_created);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["M" /* SET_PLANANNEX_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["N" /* SET_PLANANNEX_PATH */], res.path);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["O" /* SET_PLANANNEX_PARENT_PATH */], data.parent_path);

                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                    value: res.key,
                    path: data.path + new_created_key + '/' + 'id',
                    save_timestamp: false
                }).then(function (res) {
                    return resolve({ key: new_created_key });
                });
            });
        });
    },
    DELETE_PLANANNEX: function DELETE_PLANANNEX(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;


        // console.log('DELETE_PLANANNEX path check: ' + data.path)
        // console.log('DELETE PLANANNEX parent_path check: ' + data.parent_path)

        // delete from planannexes/planannex_key
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.path }).then(function (res) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].deletePlanAnnex({ path: data.path, filename: data.filename });
        });
    },
    GET_PLANANNEX: function GET_PLANANNEX(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;


        return new Promise(function (resolve, reject) {
            return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                return resolve(res);
            });
        });
    },
    SET_PLANANNEX: function SET_PLANANNEX(_ref4, data) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;


        // console.log('set_planannex data:')
        // console.log(data)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["P" /* SET_PLANANNEX */], res);
        });
    },
    RESET_PLANANNEX: function RESET_PLANANNEX(_ref5) {
        var state = _ref5.state,
            commit = _ref5.commit,
            rootState = _ref5.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["Q" /* RESET_PLANANNEX */]);
    },
    SET_PLANANNEX_REPORTDATE: function (_SET_PLANANNEX_REPORTDATE) {
        function SET_PLANANNEX_REPORTDATE(_x, _x2) {
            return _SET_PLANANNEX_REPORTDATE.apply(this, arguments);
        }

        SET_PLANANNEX_REPORTDATE.toString = function () {
            return _SET_PLANANNEX_REPORTDATE.toString();
        };

        return SET_PLANANNEX_REPORTDATE;
    }(function (_ref6, data) {
        var state = _ref6.state,
            commit = _ref6.commit,
            rootState = _ref6.rootState;

        commit(SET_PLANANNEX_REPORTDATE, data);
    }),
    SET_PLANANNEX_DATE_CREATED: function SET_PLANANNEX_DATE_CREATED(_ref7, data) {
        var state = _ref7.state,
            commit = _ref7.commit,
            rootState = _ref7.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["L" /* SET_PLANANNEX_DATE_CREATED */], data);
    },
    SET_PLANANNEX_DATE_MODIFIED: function SET_PLANANNEX_DATE_MODIFIED(_ref8, data) {
        var state = _ref8.state,
            commit = _ref8.commit,
            rootState = _ref8.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["M" /* SET_PLANANNEX_DATE_MODIFIED */], data);
    },

    SET_PLANANNEX_ID: function SET_PLANANNEX_ID(_ref9, data) {
        var state = _ref9.state,
            commit = _ref9.commit,
            rootState = _ref9.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["K" /* SET_PLANANNEX_ID */], data);
    },
    SET_PLANANNEX_PARENT_PATH: function SET_PLANANNEX_PARENT_PATH(_ref10, data) {
        var state = _ref10.state,
            commit = _ref10.commit,
            rootState = _ref10.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["O" /* SET_PLANANNEX_PARENT_PATH */], data);
    },
    SET_PLANANNEX_PATH: function SET_PLANANNEX_PATH(_ref11, data) {
        var state = _ref11.state,
            commit = _ref11.commit,
            rootState = _ref11.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["N" /* SET_PLANANNEX_PATH */], data);
    },
    UPDATE_PLANANNEX: function UPDATE_PLANANNEX(_ref12, data) {
        var state = _ref12.state,
            commit = _ref12.commit,
            rootState = _ref12.rootState;

        return new Promise(function (resolve, reject) {
            // console.log('UPDATE_PLANANNEX data:')
            // console.log(data)
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({ object: data.object, path: data.path + data.key, save_timestamp: true }).then(function (res) {

                var date_modified = res.date_modified;
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["M" /* SET_PLANANNEX_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["R" /* SET_PLANANNEX_DIRTYNESS */], false);
                resolve();
            });
        });
    },
    SET_PLANANNEX_NAME_CA: function SET_PLANANNEX_NAME_CA(_ref13, data) {
        var state = _ref13.state,
            commit = _ref13.commit,
            rootState = _ref13.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["S" /* SET_PLANANNEX_NAME_CA */], data);
    },
    SET_PLANANNEX_NAME_EN: function SET_PLANANNEX_NAME_EN(_ref14, data) {
        var state = _ref14.state,
            commit = _ref14.commit,
            rootState = _ref14.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["T" /* SET_PLANANNEX_NAME_EN */], data);
    },
    SET_PLANANNEX_NAME_ES: function SET_PLANANNEX_NAME_ES(_ref15, data) {
        var state = _ref15.state,
            commit = _ref15.commit,
            rootState = _ref15.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["U" /* SET_PLANANNEX_NAME_ES */], data);
    },
    SET_PLANANNEX_URL: function SET_PLANANNEX_URL(_ref16, data) {
        var state = _ref16.state,
            commit = _ref16.commit,
            rootState = _ref16.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["V" /* SET_PLANANNEX_URL */], data);
    },
    SET_PLANANNEX_FILENAME: function SET_PLANANNEX_FILENAME(_ref17, data) {
        var state = _ref17.state,
            commit = _ref17.commit,
            rootState = _ref17.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["W" /* SET_PLANANNEX_FILENAME */], data);
    }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["Q" /* RESET_PLANANNEX */], function (state) {
    state.date_created = null;
    state.date_modified = null;
    state.dirty = false;
    state.file_id = null;
    state.id = null;
    state.path = null;
    state.parent_path = null;
    state.name_ca = null;
    state.name_en = null;
    state.name_es = null;
    state.url = null;
    state.filename = null;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["P" /* SET_PLANANNEX */], function (state, data) {
    state.date_created = check_undefined(data.date_created);
    state.date_modified = check_undefined(data.date_modified);
    state.dirty = false;
    state.file_id = check_undefined(data.file_id);
    state.id = check_undefined(data.id);
    state.path = check_undefined(data.path);
    state.parent_path = check_undefined(data.parent_path);
    state.name_ca = check_undefined(data.name_ca);
    state.name_en = check_undefined(data.name_en);
    state.name_es = check_undefined(data.name_es);
    state.url = check_undefined(data.url);
    state.filename = check_undefined(data.filename);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["L" /* SET_PLANANNEX_DATE_CREATED */], function (state, data) {
    state.date_created = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["M" /* SET_PLANANNEX_DATE_MODIFIED */], function (state, data) {
    state.date_modified = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["R" /* SET_PLANANNEX_DIRTYNESS */], function (state, boolean) {
    state.dirty = boolean;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["K" /* SET_PLANANNEX_ID */], function (state, data) {
    state.id = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["O" /* SET_PLANANNEX_PARENT_PATH */], function (state, data) {
    state.parent_path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["N" /* SET_PLANANNEX_PATH */], function (state, data) {
    state.path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["S" /* SET_PLANANNEX_NAME_CA */], function (state, data) {
    state.name_ca = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["T" /* SET_PLANANNEX_NAME_EN */], function (state, data) {
    state.name_en = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["U" /* SET_PLANANNEX_NAME_ES */], function (state, data) {
    state.name_es = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["V" /* SET_PLANANNEX_URL */], function (state, data) {
    state.url = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["W" /* SET_PLANANNEX_FILENAME */], function (state, data) {
    state.filename = data;
    state.dirty = true;
}), _mutations);

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

var getters = {
    planannex: function planannex(state) {
        return state;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__maps_api__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var default_state = {
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    parent_path: null,
    path: null,
    projectdate: null,
    realestate_id: null
};
var state = default_state;

var actions = {
    CREATE_NEW_PROJECT: function CREATE_NEW_PROJECT(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].create({ key: data.key, path: data.path }).then(function (res) {
                var new_created_key = res.key;

                var default_projectdate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(res.date_created, 'x').format('YYYY-MM-DD');

                commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_36" /* SET_PROJECT_ID */], new_created_key);
                commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_37" /* SET_PROJECT_DATE_CREATED */], res.date_created);
                commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_38" /* SET_PROJECT_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_39" /* SET_PROJECT_PROJECTDATE */], default_projectdate);
                commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_40" /* SET_PROJECT_PARENT_PATH */], data.parent_path);
                commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_41" /* SET_PROJECT_PATH */], res.path);
                commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_42" /* SET_PROJECT_REALESTATE_ID */], data.realestate_id);

                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                    value: default_projectdate,
                    path: data.path + new_created_key + '/' + 'projectdate',
                    save_timestamp: false
                }).then(function (res) {
                    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                        value: data.realestate_id,
                        path: data.path + new_created_key + '/' + 'realestate_id',
                        save_timestamp: false
                    }).then(function (res) {
                        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                            value: new_created_key,
                            path: data.path + new_created_key + '/' + 'id',
                            save_timestamp: false
                        }).then(function (res) {
                            var object = {};
                            object[new_created_key] = true;
                            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({
                                object: object,
                                path: data.parent_path,
                                save_timestamp: false
                            }).then(function (res) {
                                return resolve({ key: new_created_key });
                            });
                        });
                    });
                });
            });
        });
    },
    DELETE_PROJECT: function DELETE_PROJECT(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;


        return new Promise(function (resolve, reject) {

            // console.log('path check: ' + data.path)
            // console.log('parent_path check: ' + data.parent_path)

            // delete from contact_projects/contact_key
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.path }).then(function (res) {
                // delete from contact/contact_key/projects
                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.parent_path }).then(function (res) {
                    commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_43" /* RESET_PROJECT */]);
                }).then(function (res) {
                    return resolve({});
                });
            });
        });
    },
    FETCH_PROJECT: function FETCH_PROJECT(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;

        return new Promise(function (resolve, reject) {
            return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                resolve(res);
            });
        });
    },
    SET_PROJECT: function SET_PROJECT(_ref4, data) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;


        return new Promise(function (resolve, reject) {

            // console.log('set_project data:')
            // console.log(data)
            return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                console.log(res);
                commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_44" /* SET_PROJECT */], res);
            }).then(function (res) {
                return resolve({});
            });
        });
    },
    RESET_PROJECT: function RESET_PROJECT(_ref5) {
        var state = _ref5.state,
            commit = _ref5.commit,
            rootState = _ref5.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_43" /* RESET_PROJECT */]);
    },
    SET_PROJECT_DATE_CREATED: function SET_PROJECT_DATE_CREATED(_ref6, data) {
        var state = _ref6.state,
            commit = _ref6.commit,
            rootState = _ref6.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_37" /* SET_PROJECT_DATE_CREATED */], data);
    },
    SET_PROJECT_DATE_MODIFIED: function SET_PROJECT_DATE_MODIFIED(_ref7, data) {
        var state = _ref7.state,
            commit = _ref7.commit,
            rootState = _ref7.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_38" /* SET_PROJECT_DATE_MODIFIED */], data);
    },
    SET_PROJECT_ID: function SET_PROJECT_ID(_ref8, data) {
        var state = _ref8.state,
            commit = _ref8.commit,
            rootState = _ref8.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_36" /* SET_PROJECT_ID */], data);
    },

    SET_PROJECT_PATH: function SET_PROJECT_PATH(_ref9, data) {
        var state = _ref9.state,
            commit = _ref9.commit,
            rootState = _ref9.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_41" /* SET_PROJECT_PATH */], data);
    },
    SET_PROJECT_PARENT_PATH: function SET_PROJECT_PARENT_PATH(_ref10, data) {
        var state = _ref10.state,
            commit = _ref10.commit,
            rootState = _ref10.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_40" /* SET_PROJECT_PARENT_PATH */], data);
    },
    SET_PROJECT_PROJECTDATE: function SET_PROJECT_PROJECTDATE(_ref11, data) {
        var state = _ref11.state,
            commit = _ref11.commit,
            rootState = _ref11.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_39" /* SET_PROJECT_PROJECTDATE */], data);
    },
    UPDATE_PROJECT: function UPDATE_PROJECT(_ref12, data) {
        var state = _ref12.state,
            commit = _ref12.commit,
            rootState = _ref12.rootState;

        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({ object: data.object, path: data.path, save_timestamp: true }).then(function (res) {
            commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_38" /* SET_PROJECT_DATE_MODIFIED */], res.date_modified);
            commit(__WEBPACK_IMPORTED_MODULE_3__constants__["_45" /* SET_PROJECT_DIRTYNESS */], false);
        });
    }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_43" /* RESET_PROJECT */], function (state) {
    state.date_created = null;
    state.date_modified = null;
    state.id = null;
    state.path = null;
    state.parent_path = null;
    state.projectdate = null;
    state.realestate_id = null;
    state.dirty = false;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_44" /* SET_PROJECT */], function (state, data) {
    // console.log('mutations SET_PROJECT data: ')
    //  console.log(data)
    state.date_created = check_undefined(data.date_created);
    state.date_modified = check_undefined(data.date_modified);
    state.id = check_undefined(data.id);
    state.path = check_undefined(data.path);
    state.parent_path = check_undefined(data.parent_path);
    state.projectdate = check_undefined(data.projectdate);
    state.realestate_id = check_undefined(data.realestate_id);
    state.dirty = false;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_37" /* SET_PROJECT_DATE_CREATED */], function (state, data) {
    state.date_created = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_38" /* SET_PROJECT_DATE_MODIFIED */], function (state, data) {
    state.date_modified = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_45" /* SET_PROJECT_DIRTYNESS */], function (state, boolean) {
    state.dirty = boolean;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_36" /* SET_PROJECT_ID */], function (state, data) {
    state.id = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_41" /* SET_PROJECT_PATH */], function (state, data) {
    state.path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_40" /* SET_PROJECT_PARENT_PATH */], function (state, data) {
    state.parent_path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_39" /* SET_PROJECT_PROJECTDATE */], function (state, data) {
    state.projectdate = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__constants__["_42" /* SET_PROJECT_REALESTATE_ID */], function (state, data) {
    state.realestate_id = data;
    state.dirty = true;
}), _mutations);

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

var getters = {

    project: function project(state) {
        return state;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_proj4__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__maps_api__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__functions_global_functions__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }













var default_state = {
    appraisalreports: null,
    cadastral_reference: null,
    census_section_code: null,
    country: {
        iso_3166_alpha2_code: 'ES',
        name_en: 'Spain'
    },
    description: null,
    door: null,
    floor: null,
    floor_number: null,
    floor_type: null,
    geohash: null,
    google_formatted_address: null,
    google_viewport: null,
    lat: null,
    lng: null,
    municipality: null,
    parent_path: null,
    postal_code: null,
    property_type: null,
    province: null,
    registry_name: null,
    registry_estate_number: null,
    staircase: null,
    street_name: null,
    street_number: null,
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    path: null,
    map_google_01_url: null,
    map_google_01_lat: null,
    map_google_01_lng: null,
    map_google_01_zoom: 13,
    map_google_02_url: null,
    map_google_02_lat: null,
    map_google_02_lng: null,
    map_google_02_zoom: 16,
    map_google_03_url: null,
    map_google_03_lat: null,
    map_google_03_lng: null,
    map_google_03_zoom: 19,
    full_address: null,
    short_address: null,
    block: null,
    area_ads_markers: null,
    area_average_price: null,

    area_average_price_coef: 0.95,
    adopted_area_average_price: null,
    estimated_built_area: null,
    pre_appraisal_value: null,
    travel_one_way_hours: null,
    travel_both_ways_hours: null,
    travel_fees_per_hour: 20,
    car_fuel_expenses_one_way: null,
    car_fuel_expenses_both_ways: null,
    car_toll_expenses_one_way: null,
    car_toll_expenses_both_ways: null,
    car_expenses_one_way: null,
    car_expenses_both_ways: null,
    total_travel_fees: null,
    quote_base_fees: null,
    quote_excess_pct: null,
    quote_base_price: null,
    quote_base_price_coef: 1,
    quote_appraisal_type_is_eco: null,
    area_ads_query_startdate: null,
    area_ads_query_limitdate: null,
    area_ads_query_distance: 1,
    quote_price_incl_travel_expenses: null,
    invoice_base_fees: null,
    invoice_excess_pct: null,
    invoice_base_price: null,
    invoice_base_price_coef: 1,
    invoice_appraisal_type_is_eco: null,
    quote_excess: null,
    asset_type: null,
    dwelling_type: null

};

var state = default_state;

var actions = {

    QUERY_MUNICIPALITIES: function QUERY_MUNICIPALITIES(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        // console.log('query_municipalities data:')
        // console.log(data)
        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get({ path: 'municipalities/' }).then(function (res) {
            return new Promise(function (resolve, reject) {
                setTimeout(function () {

                    //console.log(res)
                    var res_array = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.values(res);
                    console.log('res_array: ');
                    console.log(res_array);
                    var results = res_array.filter(function (element, index, array) {
                        console.log('data.query: ');
                        console.log(data.query);
                        return element.name_ine.toLowerCase().includes(data.query.toLowerCase());
                    });
                    resolve(results);
                }, 1000);
            });
        });
    },

    CREATE_NEW_REALESTATE: function CREATE_NEW_REALESTATE(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;


        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].create({ path: data.path }).then(function (res) {
                var new_created_key = res.key;

                commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_185" /* SET_REALESTATE_ID */], new_created_key);
                commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_186" /* SET_REALESTATE_DATE_CREATED */], res.date_created);
                commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_187" /* SET_REALESTATE_DATE_MODIFIED */], res.date_modified);
                // commit(SET_REALESTATE_PARENT_PATH, data.parent_path)
                commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_188" /* SET_REALESTATE_PATH */], res.path);

                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].set_value({ value: res.key, path: data.path + res.key + '/' + 'id', save_timestamp: false });

                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].set_value({
                    value: new_created_key,
                    path: data.path + new_created_key + '/' + 'id',
                    save_timestamp: false
                }).then(function (res) {

                    if (data.file_id && data.file_number) {
                        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].set_value({
                            // value: true,
                            value: data.file_number,
                            path: data.path + new_created_key + '/' + 'appraisalfiles' + '/' + data.file_id,
                            save_timestamp: false
                        });
                    }

                    if (data.report_id && data.report_number && data.report_version) {

                        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].set_value({
                            // value: true,
                            value: data.report_number + '.' + data.report_version,
                            path: data.path + new_created_key + '/' + 'appraisalreports' + '/' + data.report_id,
                            save_timestamp: false
                        });

                        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].set_value({
                            value: true,
                            path: 'appraisalreports' + '/' + data.report_id + '/' + 'realestates' + '/' + new_created_key + '/' + 'id',
                            save_timestamp: false
                        }).then(function (res) {
                            return resolve({ key: new_created_key });
                        });
                    }

                    if (data.quote_id && data.quote_number && data.quote_version) {

                        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].set_value({
                            // value: true,
                            value: data.quote_number + '.' + data.quote_version,
                            path: data.path + new_created_key + '/' + 'appraisalquotes' + '/' + data.quote_id,
                            save_timestamp: false
                        });

                        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].set_value({
                            // value: true,
                            value: new_created_key,
                            path: 'appraisalquotes' + '/' + data.quote_id + '/' + 'realestates' + '/' + new_created_key + '/' + 'id',
                            save_timestamp: false
                        }).then(function (res) {
                            return resolve({ key: new_created_key });
                        });
                    }
                });
            });
        });
    },
    DELETE_REALESTATE: function DELETE_REALESTATE(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;


        console.log('path check: ' + data.path);
        console.log('parent_path check: ' + data.parent_path);

        // delete from contact_addresses/contact_key
        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].delete({ key: data.key, path: data.path }).then(function (res) {

            // delete from contact/contact_key/realestates
            __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].delete({ key: data.key, path: data.parent_path + data.key }).then(function (res) {
                commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_189" /* RESET_REALESTATE */]);
            });
        });
    },
    SET_REALESTATE: function SET_REALESTATE(_ref4, data) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;


        // console.log('SET_REALESTATE data.path:')
        // console.log(data.path)
        return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            // console.log('realestate.js api.get res:')
            // console.log(res)
            commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_190" /* SET_REALESTATE */], res);
        });
    },
    FETCH_REALESTATE: function FETCH_REALESTATE(_ref5, data) {
        var state = _ref5.state,
            commit = _ref5.commit,
            rootState = _ref5.rootState;

        return new Promise(function (resolve, reject) {
            return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                resolve(res);
            });
        });
    },
    GEOLOCATE_REALESTATE: function GEOLOCATE_REALESTATE(_ref6, data) {
        var state = _ref6.state,
            commit = _ref6.commit,
            rootState = _ref6.rootState;


        // console.log('--- geolocate_address data:')
        // console.log(data)
        // console.log('----------')
        return new Promise(function (resolve, reject) {
            return __WEBPACK_IMPORTED_MODULE_5__maps_api__["a" /* default */].geolocate(data).then(function (res) {
                console.log(res.results);
                var result = window.confirm(__WEBPACK_IMPORTED_MODULE_0_vue___default.a.i18n.translate('S\'ha trobat via Google la següent adreça: ') + res.formatted_address + '. S\'actualitzaran les dades de geolocalització segons aquesta adreça. És correcte?');

                if (result) {

                    var new_lat = res.lat;
                    var new_lng = res.lng;

                    commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_191" /* SET_REALESTATE_GOOGLE_FORMATTED_ADDRESS */], res.formatted_address);
                    commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_192" /* SET_REALESTATE_GOOGLE_VIEWPORT */], res.viewport);
                    commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_193" /* SET_REALESTATE_LAT */], new_lat);
                    commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_194" /* SET_REALESTATE_LNG */], new_lng);

                    // commit(SET_REALESTATE_MAP_GOOGLE_01_LAT, new_lat)
                    // commit(SET_REALESTATE_MAP_GOOGLE_01_LNG, new_lng)

                    // commit(SET_REALESTATE_MAP_GOOGLE_02_LAT, new_lat)
                    // commit(SET_REALESTATE_MAP_GOOGLE_02_LNG, new_lng)

                    // commit(SET_REALESTATE_MAP_GOOGLE_03_LAT, new_lat)
                    // commit(SET_REALESTATE_MAP_GOOGLE_03_LNG, new_lng)

                    commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_195" /* SET_REALESTATE_POSTAL_CODE */], res.postal_code);
                    commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_196" /* SET_REALESTATE_STREET_NAME */], res.street_name);
                    commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_197" /* SET_REALESTATE_STREET_NUMBER */], res.street_number);

                    var proj4_wgs84 = '+proj=longlat +datum=WGS84 +no_defs';
                    var proj4_epsg25831 = '+proj=utm +zone=31 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ';

                    var epsg25831_coords = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_proj4__["a" /* default */])(proj4_wgs84, proj4_epsg25831, [res.lng, res.lat]);
                    // console.log('epsg25831_coords: ')
                    // console.log(epsg25831_coords)
                    commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_198" /* SET_REALESTATE_EPSG25831_X */], epsg25831_coords[0]);
                    commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_199" /* SET_REALESTATE_EPSG25831_Y */], epsg25831_coords[1]);

                    if (data.old_geohash) {

                        var old_location_path = 'realestate_locations/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__functions_global_functions__["a" /* default */])(data.old_geohash, 1).join('/') + '/' + data.id;

                        console.log('old_location_path: ');
                        console.log(old_location_path);

                        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].delete({ path: old_location_path }).then(function (res) {

                            __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getGeohash({ key: data.id, lat: new_lat, lng: new_lng }).then(function (res) {
                                // console.log('realestate.js api.get res:')
                                // console.log(res)
                                var new_geohash = res.geohash;

                                var new_location_path = 'realestate_locations/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__functions_global_functions__["a" /* default */])(new_geohash, 1).join('/');
                                var new_object = {};
                                new_object[data.id] = true;

                                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].set_value({
                                    value: new_object,
                                    path: new_location_path,
                                    save_timestamp: false
                                }).then(function (res) {
                                    commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_200" /* SET_REALESTATE_GEOHASH */], new_geohash);
                                    resolve(res);
                                });
                            });
                        });
                    } else {

                        __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getGeohash({ key: data.id, lat: res.lat, lng: res.lng }).then(function (res) {
                            // console.log('realestate.js api.get res:')
                            // console.log(res)
                            var new_geohash = res.geohash;

                            var new_location_path = 'realestate_locations/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__functions_global_functions__["a" /* default */])(new_geohash, 1).join('/');
                            var new_object = {};
                            new_object[data.id] = true;

                            __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].set_value({
                                value: new_object,
                                path: new_location_path,
                                save_timestamp: false
                            }).then(function (res) {
                                commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_200" /* SET_REALESTATE_GEOHASH */], new_geohash);
                                resolve(res);
                            });
                        });
                    }
                } else {
                    resolve({ none: true });
                }
            });
        });
    },
    GOOGLEDISTANCE_REALESTATE: function GOOGLEDISTANCE_REALESTATE(_ref7, data) {
        var state = _ref7.state,
            commit = _ref7.commit,
            rootState = _ref7.rootState;


        // console.log('--- geolocate_address data:')
        // console.log(data)
        // console.log('----------')
        return new Promise(function (resolve, reject) {
            return __WEBPACK_IMPORTED_MODULE_5__maps_api__["a" /* default */].googledistance(data).then(function (res) {
                console.log(res);

                // commit(SET_REALESTATE_GOOGLE_FORMATTED_ADDRESS, res.formatted_address)

                resolve(res);
            });
        });
    },
    REQUEST_CENSUS_SECTION_INFO: function REQUEST_CENSUS_SECTION_INFO(_ref8, data) {
        var state = _ref8.state,
            commit = _ref8.commit,
            rootState = _ref8.rootState;


        return __WEBPACK_IMPORTED_MODULE_5__maps_api__["a" /* default */].request_icc_census_section_info(data).then(function (res) {

            console.log('request_census_section_info res:');
            console.log(res);

            // parse the html response from ICC
            var div = document.createElement('div');
            div.innerHTML = res.html;
            var ths = div.querySelectorAll('th');
            var tds = div.querySelectorAll('td');

            // console.log('div: ')
            // console.log(div)

            var new_ths = [];
            var new_tds = [];

            for (var i = 0; i < ths.length; i++) {
                new_ths.push(ths[i].innerText.toLowerCase());
            }

            for (var _i = 0; _i < tds.length; _i++) {
                new_tds.push(tds[_i].innerText.toLowerCase());
            }

            console.log('new_ths: ');
            console.log(new_ths);
            console.log('new_tds: ');
            console.log(new_tds);

            var census_obj = Object.assign.apply(Object, [{}].concat(_toConsumableArray(new_ths.map(function (n, index) {
                return _defineProperty({}, n, new_tds[index]);
            }))));

            // console.log(census_obj)

            var census_section_code = '' + census_obj.municipi + census_obj.districte + census_obj.seccio;

            commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_201" /* SET_REALESTATE_CENSUS_SECTION_CODE */], census_section_code);
        });
    },
    REQUEST_CADASTRAL_REFERENCE_BY_COORDINATES: function REQUEST_CADASTRAL_REFERENCE_BY_COORDINATES(_ref10, data) {
        var state = _ref10.state,
            commit = _ref10.commit,
            rootState = _ref10.rootState;


        return __WEBPACK_IMPORTED_MODULE_5__maps_api__["a" /* default */].request_cadastral_reference_by_coordinates(data).then(function (res) {

            console.log('request_cadastral_reference_by_coordinates res:');
            console.log(res);

            if (res.result.consulta_coordenadas_distancias) {
                var cadref_part1 = res.result.consulta_coordenadas_distancias.coordenadas_distancias.coordd.lpcd.pcd[0].pc.pc1;
                var cadref_part2 = res.result.consulta_coordenadas_distancias.coordenadas_distancias.coordd.lpcd.pcd[0].pc.pc2;

                var cadref = cadref_part1 + cadref_part2;

                commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_202" /* SET_REALESTATE_CADASTRAL_REFERENCE */], cadref);
            } else {
                console.log('res.result.consulta_coordenadas_distancias .... is undefined?');
            }
        });
    },
    RESET_REALESTATE: function RESET_REALESTATE(_ref11) {
        var state = _ref11.state,
            commit = _ref11.commit,
            rootState = _ref11.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_189" /* RESET_REALESTATE */]);
    },
    SET_REALESTATE_CADASTRAL_REFERENCE: function SET_REALESTATE_CADASTRAL_REFERENCE(_ref12, data) {
        var state = _ref12.state,
            commit = _ref12.commit,
            rootState = _ref12.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_202" /* SET_REALESTATE_CADASTRAL_REFERENCE */], data);
    },
    SET_REALESTATE_CENSUS_SECTION_CODE: function SET_REALESTATE_CENSUS_SECTION_CODE(_ref13, data) {
        var state = _ref13.state,
            commit = _ref13.commit,
            rootState = _ref13.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_201" /* SET_REALESTATE_CENSUS_SECTION_CODE */], data);
    },
    SET_REALESTATE_COUNTRY: function SET_REALESTATE_COUNTRY(_ref14, data) {
        var state = _ref14.state,
            commit = _ref14.commit,
            rootState = _ref14.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_203" /* SET_REALESTATE_COUNTRY */], data);
    },
    SET_REALESTATE_DATE_CREATED: function SET_REALESTATE_DATE_CREATED(_ref15, data) {
        var state = _ref15.state,
            commit = _ref15.commit,
            rootState = _ref15.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_186" /* SET_REALESTATE_DATE_CREATED */], data);
    },
    SET_REALESTATE_DATE_MODIFIED: function SET_REALESTATE_DATE_MODIFIED(_ref16, data) {
        var state = _ref16.state,
            commit = _ref16.commit,
            rootState = _ref16.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_187" /* SET_REALESTATE_DATE_MODIFIED */], data);
    },
    SET_REALESTATE_DESCRIPTION: function SET_REALESTATE_DESCRIPTION(_ref17, data) {
        var state = _ref17.state,
            commit = _ref17.commit,
            rootState = _ref17.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_204" /* SET_REALESTATE_DESCRIPTION */], data);
    },
    SET_REALESTATE_DOOR: function SET_REALESTATE_DOOR(_ref18, data) {
        var state = _ref18.state,
            commit = _ref18.commit,
            rootState = _ref18.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_205" /* SET_REALESTATE_DOOR */], data);
    },
    SET_REALESTATE_EPSG25831_X: function SET_REALESTATE_EPSG25831_X(_ref19, data) {
        var state = _ref19.state,
            commit = _ref19.commit,
            rootState = _ref19.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_198" /* SET_REALESTATE_EPSG25831_X */], data);
    },
    SET_REALESTATE_EPSG25831_Y: function SET_REALESTATE_EPSG25831_Y(_ref20, data) {
        var state = _ref20.state,
            commit = _ref20.commit,
            rootState = _ref20.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_199" /* SET_REALESTATE_EPSG25831_Y */], data);
    },
    SET_REALESTATE_FLOOR: function SET_REALESTATE_FLOOR(_ref21, data) {
        var state = _ref21.state,
            commit = _ref21.commit,
            rootState = _ref21.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_206" /* SET_REALESTATE_FLOOR */], data);
    },
    SET_REALESTATE_FLOOR_NUMBER: function SET_REALESTATE_FLOOR_NUMBER(_ref22, data) {
        var state = _ref22.state,
            commit = _ref22.commit,
            rootState = _ref22.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_207" /* SET_REALESTATE_FLOOR_NUMBER */], data);
    },
    SET_REALESTATE_GEOHASH: function SET_REALESTATE_GEOHASH(_ref23, data) {
        var state = _ref23.state,
            commit = _ref23.commit,
            rootState = _ref23.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_200" /* SET_REALESTATE_GEOHASH */], data);
    },
    SET_REALESTATE_GOOGLE_FORMATTED_ADDRESS: function SET_REALESTATE_GOOGLE_FORMATTED_ADDRESS(_ref24, data) {
        var state = _ref24.state,
            commit = _ref24.commit,
            rootState = _ref24.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_191" /* SET_REALESTATE_GOOGLE_FORMATTED_ADDRESS */], data);
    },
    SET_REALESTATE_ID: function SET_REALESTATE_ID(_ref25, data) {
        var state = _ref25.state,
            commit = _ref25.commit,
            rootState = _ref25.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_185" /* SET_REALESTATE_ID */], data);
    },
    SET_REALESTATE_LAT: function SET_REALESTATE_LAT(_ref26, data) {
        var state = _ref26.state,
            commit = _ref26.commit,
            rootState = _ref26.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_193" /* SET_REALESTATE_LAT */], data);
    },
    SET_REALESTATE_LNG: function SET_REALESTATE_LNG(_ref27, data) {
        var state = _ref27.state,
            commit = _ref27.commit,
            rootState = _ref27.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_194" /* SET_REALESTATE_LNG */], data);
    },
    SET_REALESTATE_MUNICIPALITY: function SET_REALESTATE_MUNICIPALITY(_ref28, data) {
        var state = _ref28.state,
            commit = _ref28.commit,
            rootState = _ref28.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_208" /* SET_REALESTATE_MUNICIPALITY */], data);
    },
    SET_REALESTATE_POSTAL_CODE: function SET_REALESTATE_POSTAL_CODE(_ref29, data) {
        var state = _ref29.state,
            commit = _ref29.commit,
            rootState = _ref29.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_195" /* SET_REALESTATE_POSTAL_CODE */], data);
    },
    SET_REALESTATE_PARENT_PATH: function SET_REALESTATE_PARENT_PATH(_ref30, data) {
        var state = _ref30.state,
            commit = _ref30.commit,
            rootState = _ref30.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_209" /* SET_REALESTATE_PARENT_PATH */], data);
    },
    SET_REALESTATE_PATH: function SET_REALESTATE_PATH(_ref31, data) {
        var state = _ref31.state,
            commit = _ref31.commit,
            rootState = _ref31.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_188" /* SET_REALESTATE_PATH */], data);
    },
    SET_REALESTATE_PROPERTY_TYPE: function SET_REALESTATE_PROPERTY_TYPE(_ref32, data) {
        var state = _ref32.state,
            commit = _ref32.commit,
            rootState = _ref32.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_210" /* SET_REALESTATE_PROPERTY_TYPE */], data);
    },
    SET_REALESTATE_PROVINCE: function SET_REALESTATE_PROVINCE(_ref33, data) {
        var state = _ref33.state,
            commit = _ref33.commit,
            rootState = _ref33.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_211" /* SET_REALESTATE_PROVINCE */], data);
    },
    SET_REALESTATE_REGISTRY_NAME: function SET_REALESTATE_REGISTRY_NAME(_ref34, data) {
        var state = _ref34.state,
            commit = _ref34.commit,
            rootState = _ref34.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_212" /* SET_REALESTATE_REGISTRY_NAME */], data);
    },
    SET_REALESTATE_STAIRCASE: function SET_REALESTATE_STAIRCASE(_ref35, data) {
        var state = _ref35.state,
            commit = _ref35.commit,
            rootState = _ref35.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_213" /* SET_REALESTATE_STAIRCASE */], data);
    },
    SET_REALESTATE_STREET_NAME: function SET_REALESTATE_STREET_NAME(_ref36, data) {
        var state = _ref36.state,
            commit = _ref36.commit,
            rootState = _ref36.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_196" /* SET_REALESTATE_STREET_NAME */], data);
    },
    SET_REALESTATE_STREET_NUMBER: function SET_REALESTATE_STREET_NUMBER(_ref37, data) {
        var state = _ref37.state,
            commit = _ref37.commit,
            rootState = _ref37.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_197" /* SET_REALESTATE_STREET_NUMBER */], data);
    },
    SET_REALESTATE_MAP_GOOGLE_01_URL: function SET_REALESTATE_MAP_GOOGLE_01_URL(_ref38, data) {
        var state = _ref38.state,
            commit = _ref38.commit,
            rootState = _ref38.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_214" /* SET_REALESTATE_MAP_GOOGLE_01_URL */], data);
    },
    SET_REALESTATE_MAP_GOOGLE_01_LAT: function SET_REALESTATE_MAP_GOOGLE_01_LAT(_ref39, data) {
        var state = _ref39.state,
            commit = _ref39.commit,
            rootState = _ref39.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_215" /* SET_REALESTATE_MAP_GOOGLE_01_LAT */], data);
    },
    SET_REALESTATE_MAP_GOOGLE_01_LNG: function SET_REALESTATE_MAP_GOOGLE_01_LNG(_ref40, data) {
        var state = _ref40.state,
            commit = _ref40.commit,
            rootState = _ref40.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_216" /* SET_REALESTATE_MAP_GOOGLE_01_LNG */], data);
    },
    SET_REALESTATE_MAP_GOOGLE_01_ZOOM: function SET_REALESTATE_MAP_GOOGLE_01_ZOOM(_ref41, data) {
        var state = _ref41.state,
            commit = _ref41.commit,
            rootState = _ref41.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_217" /* SET_REALESTATE_MAP_GOOGLE_01_ZOOM */], data);
    },
    SET_REALESTATE_MAP_GOOGLE_02_URL: function SET_REALESTATE_MAP_GOOGLE_02_URL(_ref42, data) {
        var state = _ref42.state,
            commit = _ref42.commit,
            rootState = _ref42.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_218" /* SET_REALESTATE_MAP_GOOGLE_02_URL */], data);
    },
    SET_REALESTATE_MAP_GOOGLE_02_LAT: function SET_REALESTATE_MAP_GOOGLE_02_LAT(_ref43, data) {
        var state = _ref43.state,
            commit = _ref43.commit,
            rootState = _ref43.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_219" /* SET_REALESTATE_MAP_GOOGLE_02_LAT */], data);
    },
    SET_REALESTATE_MAP_GOOGLE_02_LNG: function SET_REALESTATE_MAP_GOOGLE_02_LNG(_ref44, data) {
        var state = _ref44.state,
            commit = _ref44.commit,
            rootState = _ref44.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_220" /* SET_REALESTATE_MAP_GOOGLE_02_LNG */], data);
    },
    SET_REALESTATE_MAP_GOOGLE_02_ZOOM: function SET_REALESTATE_MAP_GOOGLE_02_ZOOM(_ref45, data) {
        var state = _ref45.state,
            commit = _ref45.commit,
            rootState = _ref45.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_221" /* SET_REALESTATE_MAP_GOOGLE_02_ZOOM */], data);
    },
    SET_REALESTATE_MAP_GOOGLE_03_URL: function SET_REALESTATE_MAP_GOOGLE_03_URL(_ref46, data) {
        var state = _ref46.state,
            commit = _ref46.commit,
            rootState = _ref46.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_222" /* SET_REALESTATE_MAP_GOOGLE_03_URL */], data);
    },
    SET_REALESTATE_MAP_GOOGLE_03_LAT: function SET_REALESTATE_MAP_GOOGLE_03_LAT(_ref47, data) {
        var state = _ref47.state,
            commit = _ref47.commit,
            rootState = _ref47.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_223" /* SET_REALESTATE_MAP_GOOGLE_03_LAT */], data);
    },
    SET_REALESTATE_MAP_GOOGLE_03_LNG: function SET_REALESTATE_MAP_GOOGLE_03_LNG(_ref48, data) {
        var state = _ref48.state,
            commit = _ref48.commit,
            rootState = _ref48.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_224" /* SET_REALESTATE_MAP_GOOGLE_03_LNG */], data);
    },
    SET_REALESTATE_MAP_GOOGLE_03_ZOOM: function SET_REALESTATE_MAP_GOOGLE_03_ZOOM(_ref49, data) {
        var state = _ref49.state,
            commit = _ref49.commit,
            rootState = _ref49.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_225" /* SET_REALESTATE_MAP_GOOGLE_03_ZOOM */], data);
    },
    SET_REALESTATE_FLOOR_TYPE: function SET_REALESTATE_FLOOR_TYPE(_ref50, data) {
        var state = _ref50.state,
            commit = _ref50.commit,
            rootState = _ref50.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_226" /* SET_REALESTATE_FLOOR_TYPE */], data);
    },
    UPDATE_REALESTATE: function UPDATE_REALESTATE(_ref51, data) {
        var state = _ref51.state,
            commit = _ref51.commit,
            rootState = _ref51.rootState;


        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].update({ object: data.object, path: data.path, save_timestamp: true }).then(function (res) {
                var date_modified = res.date_modified;
                var reskey = res.key;

                console.log('update realestate data: ');
                console.log(data);

                commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_187" /* SET_REALESTATE_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_227" /* SET_REALESTATE_DIRTYNESS */], false);

                var parent_object = {};

                parent_object = {
                    description: check_undefined(data.object.description),
                    id: data.object.id,
                    date_modified: check_undefined(res.date_modified),
                    block: check_undefined(data.object.block),
                    cadastral_reference: check_undefined(data.object.cadastral_reference),
                    door: check_undefined(data.object.door),
                    type: check_undefined(data.object.type),
                    floor: check_undefined(data.object.floor),
                    property_type: check_undefined(data.object.property_type),
                    municipality: check_undefined(data.object.municipality.name_ine),
                    registry_estate_number: check_undefined(data.object.registry_estate_number),
                    registry_name: check_undefined(data.object.registry_name),
                    staircase: check_undefined(data.object.staircase),
                    street_name: check_undefined(data.object.street_name),
                    street_number: check_undefined(data.object.street_number),
                    full_address: check_undefined(data.object.full_address),
                    total_travel_fees: check_undefined(data.object.total_travel_fees),
                    quote_base_price: check_undefined(data.object.quote_base_price),
                    quote_price_incl_travel_expenses: check_undefined(data.object.quote_price_incl_travel_expenses),
                    invoice_base_price: check_undefined(data.object.invoice_base_price),
                    invoice_price_incl_travel_expenses: check_undefined(data.object.invoice_price_incl_travel_expenses)

                    // if added to report by import from appraisalreport
                };if (data.report_id) {
                    __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].set_value({
                        value: true,
                        path: 'appraisalreports' + '/' + data.report_id + '/' + 'realestates' + '/' + data.object.id + '/' + 'id',
                        save_timestamp: false
                    });

                    __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].set_value({
                        value: true,
                        path: 'realestates' + '/' + data.key + '/' + 'appraisalreports' + '/' + data.report_id,
                        save_timestamp: false
                    });
                }

                // if added to quote by import from appraisalquote
                if (data.quote_id) {
                    __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].set_value({
                        value: true,
                        path: 'appraisalquotes' + '/' + data.quote_id + '/' + 'realestates' + '/' + data.object.id + '/' + 'id',
                        save_timestamp: false
                    });

                    __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].set_value({
                        value: true,
                        path: 'realestates' + '/' + data.key + '/' + 'appraisalquotes' + '/' + data.quote_id,
                        save_timestamp: false
                    });
                }

                // if added to quote by import from appraisalinvoice
                if (data.invoice_id) {
                    __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].set_value({
                        value: true,
                        path: 'appraisalinvoices' + '/' + data.invoice_id + '/' + 'realestates' + '/' + data.object.id + '/' + 'id',
                        save_timestamp: false
                    });

                    __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].set_value({
                        value: true,
                        path: 'realestates' + '/' + data.key + '/' + 'appraisalinvoices' + '/' + data.quote_id,
                        save_timestamp: false
                    });
                }

                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get({ path: 'realestates' + '/' + data.key + '/' + 'appraisalreports' }).then(function (res) {

                    var appraisalreports = res;

                    __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get({ path: 'realestates' + '/' + data.key + '/' + 'appraisalquotes' }).then(function (res) {

                        var appraisalquotes = res;

                        if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(appraisalquotes) > 0 || __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(appraisalreports) > 0) {
                            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(appraisalquotes, function (value, key) {
                                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].update({
                                    object: parent_object,
                                    path: 'appraisalquotes' + '/' + key + '/' + 'realestates' + '/' + data.object.id,
                                    save_timestamp: false
                                }).then(function (res) {
                                    resolve({ key: reskey });
                                });
                            });

                            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(appraisalreports, function (value, key) {
                                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].update({
                                    object: parent_object,
                                    path: 'appraisalreports' + '/' + key + '/' + 'realestates' + '/' + data.object.id,
                                    save_timestamp: false
                                }).then(function (res) {
                                    resolve({ key: reskey });
                                });
                            });
                        } else {
                            resolve({ key: reskey });
                        }
                    });

                    __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].get({ path: 'realestates' + '/' + data.key + '/' + 'appraisalinvoices' }).then(function (res) {

                        var appraisalinvoices = res;

                        if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(appraisalinvoices) > 0 || __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.size(appraisalreports) > 0) {
                            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(appraisalinvoices, function (value, key) {
                                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].update({
                                    object: parent_object,
                                    path: 'appraisalinvoices' + '/' + key + '/' + 'realestates' + '/' + data.object.id,
                                    save_timestamp: false
                                }).then(function (res) {
                                    resolve({ key: reskey });
                                });
                            });

                            __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.forEach(appraisalreports, function (value, key) {
                                __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].update({
                                    object: parent_object,
                                    path: 'appraisalreports' + '/' + key + '/' + 'realestates' + '/' + data.object.id,
                                    save_timestamp: false
                                }).then(function (res) {
                                    resolve({ key: reskey });
                                });
                            });
                        } else {
                            resolve({ key: reskey });
                        }
                    });
                });
            });
        });
    },
    UPDATE_REALESTATE_FLOOR_NUMBER: function UPDATE_REALESTATE_FLOOR_NUMBER(_ref52, data) {
        var state = _ref52.state,
            commit = _ref52.commit,
            rootState = _ref52.rootState;

        return new Promise(function (resolve, reject) {
            commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_207" /* SET_REALESTATE_FLOOR_NUMBER */], data.floor_number);
            __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].set_value({
                value: data.value,
                path: data.path + '/' + 'floor_number',
                save_timestamp: false
            }).then(function (res) {

                resolve();
            });
        });
    },
    SET_REALESTATE_FULL_ADDRESS: function SET_REALESTATE_FULL_ADDRESS(_ref53, data) {
        var state = _ref53.state,
            commit = _ref53.commit,
            rootState = _ref53.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_228" /* SET_REALESTATE_FULL_ADDRESS */], data);
    },
    SET_REALESTATE_SHORT_ADDRESS: function SET_REALESTATE_SHORT_ADDRESS(_ref54, data) {
        var state = _ref54.state,
            commit = _ref54.commit,
            rootState = _ref54.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_229" /* SET_REALESTATE_SHORT_ADDRESS */], data);
    },
    SET_REALESTATE_BLOCK: function SET_REALESTATE_BLOCK(_ref55, data) {
        var state = _ref55.state,
            commit = _ref55.commit,
            rootState = _ref55.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_230" /* SET_REALESTATE_BLOCK */], data);
    },
    SET_REALESTATE_AREA_ADS_MARKERS: function SET_REALESTATE_AREA_ADS_MARKERS(_ref56, data) {
        var state = _ref56.state,
            commit = _ref56.commit,
            rootState = _ref56.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_231" /* SET_REALESTATE_AREA_ADS_MARKERS */], data);
    },
    SET_REALESTATE_AREA_AVERAGE_PRICE: function SET_REALESTATE_AREA_AVERAGE_PRICE(_ref57, data) {
        var state = _ref57.state,
            commit = _ref57.commit,
            rootState = _ref57.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_232" /* SET_REALESTATE_AREA_AVERAGE_PRICE */], data);
    },
    SET_REALESTATE_AREA_AVERAGE_PRICE_COEF: function SET_REALESTATE_AREA_AVERAGE_PRICE_COEF(_ref58, data) {
        var state = _ref58.state,
            commit = _ref58.commit,
            rootState = _ref58.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_233" /* SET_REALESTATE_AREA_AVERAGE_PRICE_COEF */], data);
    },
    SET_REALESTATE_ADOPTED_AREA_AVERAGE_PRICE: function SET_REALESTATE_ADOPTED_AREA_AVERAGE_PRICE(_ref59, data) {
        var state = _ref59.state,
            commit = _ref59.commit,
            rootState = _ref59.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_234" /* SET_REALESTATE_ADOPTED_AREA_AVERAGE_PRICE */], data);
    },
    SET_REALESTATE_ESTIMATED_BUILT_AREA: function SET_REALESTATE_ESTIMATED_BUILT_AREA(_ref60, data) {
        var state = _ref60.state,
            commit = _ref60.commit,
            rootState = _ref60.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_235" /* SET_REALESTATE_ESTIMATED_BUILT_AREA */], data);
    },
    SET_REALESTATE_PRE_APPRAISAL_VALUE: function SET_REALESTATE_PRE_APPRAISAL_VALUE(_ref61, data) {
        var state = _ref61.state,
            commit = _ref61.commit,
            rootState = _ref61.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_236" /* SET_REALESTATE_PRE_APPRAISAL_VALUE */], data);
    },
    SET_REALESTATE_TRAVEL_ONE_WAY_HOURS: function SET_REALESTATE_TRAVEL_ONE_WAY_HOURS(_ref62, data) {
        var state = _ref62.state,
            commit = _ref62.commit,
            rootState = _ref62.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_237" /* SET_REALESTATE_TRAVEL_ONE_WAY_HOURS */], data);
    },
    SET_REALESTATE_TRAVEL_BOTH_WAYS_HOURS: function SET_REALESTATE_TRAVEL_BOTH_WAYS_HOURS(_ref63, data) {
        var state = _ref63.state,
            commit = _ref63.commit,
            rootState = _ref63.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_238" /* SET_REALESTATE_TRAVEL_BOTH_WAYS_HOURS */], data);
    },
    SET_REALESTATE_TRAVEL_FEES_PER_HOUR: function SET_REALESTATE_TRAVEL_FEES_PER_HOUR(_ref64, data) {
        var state = _ref64.state,
            commit = _ref64.commit,
            rootState = _ref64.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_239" /* SET_REALESTATE_TRAVEL_FEES_PER_HOUR */], data);
    },
    SET_REALESTATE_CAR_FUEL_EXPENSES_ONE_WAY: function SET_REALESTATE_CAR_FUEL_EXPENSES_ONE_WAY(_ref65, data) {
        var state = _ref65.state,
            commit = _ref65.commit,
            rootState = _ref65.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_240" /* SET_REALESTATE_CAR_FUEL_EXPENSES_ONE_WAY */], data);
    },
    SET_REALESTATE_CAR_FUEL_EXPENSES_BOTH_WAYS: function SET_REALESTATE_CAR_FUEL_EXPENSES_BOTH_WAYS(_ref66, data) {
        var state = _ref66.state,
            commit = _ref66.commit,
            rootState = _ref66.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_241" /* SET_REALESTATE_CAR_FUEL_EXPENSES_BOTH_WAYS */], data);
    },
    SET_REALESTATE_CAR_TOLL_EXPENSES_ONE_WAY: function SET_REALESTATE_CAR_TOLL_EXPENSES_ONE_WAY(_ref67, data) {
        var state = _ref67.state,
            commit = _ref67.commit,
            rootState = _ref67.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_242" /* SET_REALESTATE_CAR_TOLL_EXPENSES_ONE_WAY */], data);
    },
    SET_REALESTATE_CAR_TOLL_EXPENSES_BOTH_WAYS: function SET_REALESTATE_CAR_TOLL_EXPENSES_BOTH_WAYS(_ref68, data) {
        var state = _ref68.state,
            commit = _ref68.commit,
            rootState = _ref68.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_243" /* SET_REALESTATE_CAR_TOLL_EXPENSES_BOTH_WAYS */], data);
    },
    SET_REALESTATE_CAR_EXPENSES_ONE_WAY: function SET_REALESTATE_CAR_EXPENSES_ONE_WAY(_ref69, data) {
        var state = _ref69.state,
            commit = _ref69.commit,
            rootState = _ref69.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_244" /* SET_REALESTATE_CAR_EXPENSES_ONE_WAY */], data);
    },
    SET_REALESTATE_CAR_EXPENSES_BOTH_WAYS: function SET_REALESTATE_CAR_EXPENSES_BOTH_WAYS(_ref70, data) {
        var state = _ref70.state,
            commit = _ref70.commit,
            rootState = _ref70.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_245" /* SET_REALESTATE_CAR_EXPENSES_BOTH_WAYS */], data);
    },
    SET_REALESTATE_TOTAL_TRAVEL_FEES: function SET_REALESTATE_TOTAL_TRAVEL_FEES(_ref71, data) {
        var state = _ref71.state,
            commit = _ref71.commit,
            rootState = _ref71.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_246" /* SET_REALESTATE_TOTAL_TRAVEL_FEES */], data);
    },
    SET_REALESTATE_QUOTE_APPRAISAL_TYPE_IS_ECO: function SET_REALESTATE_QUOTE_APPRAISAL_TYPE_IS_ECO(_ref72, data) {
        var state = _ref72.state,
            commit = _ref72.commit,
            rootState = _ref72.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_247" /* SET_REALESTATE_QUOTE_APPRAISAL_TYPE_IS_ECO */], data);
    },
    SET_REALESTATE_QUOTE_BASE_FEES: function SET_REALESTATE_QUOTE_BASE_FEES(_ref73, data) {
        var state = _ref73.state,
            commit = _ref73.commit,
            rootState = _ref73.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_248" /* SET_REALESTATE_QUOTE_BASE_FEES */], data);
    },
    SET_REALESTATE_QUOTE_EXCESS_PCT: function SET_REALESTATE_QUOTE_EXCESS_PCT(_ref74, data) {
        var state = _ref74.state,
            commit = _ref74.commit,
            rootState = _ref74.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_249" /* SET_REALESTATE_QUOTE_EXCESS_PCT */], data);
    },
    SET_REALESTATE_QUOTE_BASE_PRICE: function SET_REALESTATE_QUOTE_BASE_PRICE(_ref75, data) {
        var state = _ref75.state,
            commit = _ref75.commit,
            rootState = _ref75.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_250" /* SET_REALESTATE_QUOTE_BASE_PRICE */], data);
    },
    SET_REALESTATE_QUOTE_BASE_PRICE_COEF: function SET_REALESTATE_QUOTE_BASE_PRICE_COEF(_ref76, data) {
        var state = _ref76.state,
            commit = _ref76.commit,
            rootState = _ref76.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_251" /* SET_REALESTATE_QUOTE_BASE_PRICE_COEF */], data);
    },
    SET_REALESTATE_AREA_ADS_QUERY_STARTDATE: function SET_REALESTATE_AREA_ADS_QUERY_STARTDATE(_ref77, data) {
        var state = _ref77.state,
            commit = _ref77.commit,
            rootState = _ref77.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_252" /* SET_REALESTATE_AREA_ADS_QUERY_STARTDATE */], data);
    },
    SET_REALESTATE_AREA_ADS_QUERY_LIMITDATE: function SET_REALESTATE_AREA_ADS_QUERY_LIMITDATE(_ref78, data) {
        var state = _ref78.state,
            commit = _ref78.commit,
            rootState = _ref78.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_253" /* SET_REALESTATE_AREA_ADS_QUERY_LIMITDATE */], data);
    },
    SET_REALESTATE_AREA_ADS_QUERY_DISTANCE: function SET_REALESTATE_AREA_ADS_QUERY_DISTANCE(_ref79, data) {
        var state = _ref79.state,
            commit = _ref79.commit,
            rootState = _ref79.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_254" /* SET_REALESTATE_AREA_ADS_QUERY_DISTANCE */], data);
    },
    SET_REALESTATE_QUOTE_PRICE_INCL_TRAVEL_EXPENSES: function SET_REALESTATE_QUOTE_PRICE_INCL_TRAVEL_EXPENSES(_ref80, data) {
        var state = _ref80.state,
            commit = _ref80.commit,
            rootState = _ref80.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_255" /* SET_REALESTATE_QUOTE_PRICE_INCL_TRAVEL_EXPENSES */], data);
    },
    SET_REALESTATE_INVOICE_BASE_FEES: function SET_REALESTATE_INVOICE_BASE_FEES(_ref81, data) {
        var state = _ref81.state,
            commit = _ref81.commit,
            rootState = _ref81.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_256" /* SET_REALESTATE_INVOICE_BASE_FEES */], data);
    },
    SET_REALESTATE_INVOICE_EXCESS_PCT: function SET_REALESTATE_INVOICE_EXCESS_PCT(_ref82, data) {
        var state = _ref82.state,
            commit = _ref82.commit,
            rootState = _ref82.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_257" /* SET_REALESTATE_INVOICE_EXCESS_PCT */], data);
    },
    SET_REALESTATE_INVOICE_BASE_PRICE: function SET_REALESTATE_INVOICE_BASE_PRICE(_ref83, data) {
        var state = _ref83.state,
            commit = _ref83.commit,
            rootState = _ref83.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_258" /* SET_REALESTATE_INVOICE_BASE_PRICE */], data);
    },
    SET_REALESTATE_INVOICE_BASE_PRICE_COEF: function SET_REALESTATE_INVOICE_BASE_PRICE_COEF(_ref84, data) {
        var state = _ref84.state,
            commit = _ref84.commit,
            rootState = _ref84.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_259" /* SET_REALESTATE_INVOICE_BASE_PRICE_COEF */], data);
    },
    SET_REALESTATE_INVOICE_APPRAISAL_TYPE_IS_ECO: function SET_REALESTATE_INVOICE_APPRAISAL_TYPE_IS_ECO(_ref85, data) {
        var state = _ref85.state,
            commit = _ref85.commit,
            rootState = _ref85.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_260" /* SET_REALESTATE_INVOICE_APPRAISAL_TYPE_IS_ECO */], data);
    },
    SET_REALESTATE_QUOTE_EXCESS: function SET_REALESTATE_QUOTE_EXCESS(_ref86, data) {
        var state = _ref86.state,
            commit = _ref86.commit,
            rootState = _ref86.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_261" /* SET_REALESTATE_QUOTE_EXCESS */], data);
    },
    SET_REALESTATE_ASSET_TYPE: function SET_REALESTATE_ASSET_TYPE(_ref87, data) {
        var state = _ref87.state,
            commit = _ref87.commit,
            rootState = _ref87.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_262" /* SET_REALESTATE_ASSET_TYPE */], data);
    },
    SET_REALESTATE_DWELLING_TYPE: function SET_REALESTATE_DWELLING_TYPE(_ref88, data) {
        var state = _ref88.state,
            commit = _ref88.commit,
            rootState = _ref88.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_7__constants__["_263" /* SET_REALESTATE_DWELLING_TYPE */], data);
    }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_189" /* RESET_REALESTATE */], function (state) {
    state.appraisalreports = null;
    state.block = null;
    state.cadastral_reference = null;
    state.census_section_code = null;
    state.country = {
        iso_3166_alpha2_code: 'ES',
        name_en: 'Spain'
    };
    state.description = null;
    state.door = null;
    state.floor = null;
    state.floor_number = null;
    state.geohash = null;
    state.google_formatted_address = null;
    state.google_viewport = null;
    state.lat = null;
    state.lng = null;
    state.municipality = null;
    state.parent_path = null;
    state.postal_code = null;
    state.property_type = null;
    state.province = null;
    state.registry_estate_number = null;
    state.registry_name = null;
    state.staircase = null;
    state.street_name = null;
    state.street_number = null;
    state.type = null;
    state.date_created = null;
    state.date_modified = null;
    state.dirty = false;
    state.id = null;
    state.path = null;
    state.map_google_01_url = null;
    state.map_google_01_lat = null;
    state.map_google_01_lng = null;
    state.map_google_01_zoom = 13;

    state.map_google_02_url = null;
    state.map_google_02_lat = null;
    state.map_google_02_lng = null;
    state.map_google_02_zoom = 16;

    state.map_google_03_url = null;
    state.map_google_03_lat = null;
    state.map_google_03_lng = null;
    state.map_google_03_zoom = 19;

    state.full_address = null;
    state.short_address = null;

    state.block = null;

    state.area_ads_markers = null;
    state.area_average_price = null;

    state.area_average_price_coef = 0.95;
    state.adopted_area_average_price = null;
    state.estimated_built_area = null;
    state.pre_appraisal_value = null;
    state.travel_one_way_hours = null;
    state.travel_both_ways_hours = null;
    state.travel_fees_per_hour = 20;
    state.car_fuel_expenses_one_way = null;
    state.car_fuel_expenses_both_ways = null;
    state.car_toll_expenses_one_way = null;
    state.car_toll_expenses_both_ways = null;
    state.car_expenses_one_way = null;
    state.car_expenses_both_ways = null;
    state.total_travel_fees = null;
    state.quote_base_fees = null;
    state.quote_excess_pct = null;
    state.quote_base_price = null;
    state.quote_base_price_coef = 1;
    state.quote_appraisal_type_is_eco = null;
    state.area_ads_query_startdate = null;
    state.area_ads_query_limitdate = null;
    state.area_ads_query_distance = 1;

    state.quote_price_incl_travel_expenses = null;

    state.invoice_base_fees = null;
    state.invoice_excess_pct = null;
    state.invoice_base_price = null;
    state.invoice_base_price_coef = null;
    state.invoice_appraisal_type_is_eco = null;
    state.quote_excess = null;

    state.asset_type = null;
    state.dwelling_type = null;

    state.floor_type = null;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_190" /* SET_REALESTATE */], function (state, data) {
    // console.log('mutations SET_CONTACT data: ')
    // console.log(data)
    state.appraisalreports = check_undefined(data.appraisalreports);
    state.block = check_undefined(data.block);
    state.cadastral_reference = check_undefined(data.cadastral_reference);
    state.census_section_code = check_undefined(data.census_section_code);
    state.description = check_undefined(data.description);
    state.door = check_undefined(data.door);
    state.epsg25831_x = check_undefined(data.epsg25831_x);
    state.epsg25831_y = check_undefined(data.epsg25831_y);
    state.floor = check_undefined(data.floor);
    state.floor_number = check_undefined(data.floor_number);
    state.geohash = check_undefined(data.geohash);
    state.google_formatted_address = check_undefined(data.google_formatted_address);
    state.lat = check_undefined(data.lat);
    state.lng = check_undefined(data.lng);
    state.municipality = check_undefined(data.municipality);
    state.postal_code = check_undefined(data.postal_code);
    state.property_type = check_undefined(data.property_type);
    state.province = check_undefined(data.province);
    state.registry_estate_number = check_undefined(data.registry_estate_number);
    state.registry_name = check_undefined(data.registry_name);
    state.staircase = check_undefined(data.staircase);
    state.street_name = check_undefined(data.street_name);
    state.street_number = check_undefined(data.street_number);
    state.type = check_undefined(data.type);

    state.map_google_01_url = check_undefined(data.map_google_01_url);
    state.map_google_01_lat = check_undefined(data.map_google_01_lat);
    state.map_google_01_lng = check_undefined(data.map_google_01_lng);
    state.map_google_01_zoom = check_undefined(data.map_google_01_zoom);

    state.map_google_02_url = check_undefined(data.map_google_02_url);
    state.map_google_02_lat = check_undefined(data.map_google_02_lat);
    state.map_google_02_lng = check_undefined(data.map_google_02_lng);
    state.map_google_02_zoom = check_undefined(data.map_google_02_zoom);

    state.map_google_03_url = check_undefined(data.map_google_03_url);
    state.map_google_03_lat = check_undefined(data.map_google_03_lat);
    state.map_google_03_lng = check_undefined(data.map_google_03_lng);
    state.map_google_03_zoom = check_undefined(data.map_google_03_zoom);

    //general data
    state.date_created = check_undefined(data.date_created);
    state.date_modified = check_undefined(data.date_modified);
    state.dirty = false;
    state.id = check_undefined(data.id);
    state.path = check_undefined(data.path);
    state.parent_path = check_undefined(data.parent_path);

    state.full_address = check_undefined(data.full_address);
    state.short_address = check_undefined(data.short_address);

    state.block = check_undefined(data.block);

    state.area_ads_markers = check_undefined(data.area_ads_markers);
    state.area_average_price = check_undefined(data.area_average_price);

    state.area_average_price_coef = check_undefined(data.area_average_price_coef);
    state.adopted_area_average_price = check_undefined(data.adopted_area_average_price);
    state.estimated_built_area = check_undefined(data.estimated_built_area);
    state.pre_appraisal_value = check_undefined(data.pre_appraisal_value);
    state.travel_one_way_hours = check_undefined(data.travel_one_way_hours);
    state.travel_both_ways_hours = check_undefined(data.travel_both_ways_hours);
    state.travel_fees_per_hour = check_undefined(data.travel_fees_per_hour);
    state.car_fuel_expenses_one_way = check_undefined(data.car_fuel_expenses_one_way);
    state.car_fuel_expenses_both_ways = check_undefined(data.car_fuel_expenses_both_ways);
    state.car_toll_expenses_one_way = check_undefined(data.car_toll_expenses_one_way);
    state.car_toll_expenses_both_ways = check_undefined(data.car_toll_expenses_both_ways);
    state.car_expenses_one_way = check_undefined(data.car_expenses_one_way);
    state.car_expenses_both_ways = check_undefined(data.car_expenses_both_ways);
    state.total_travel_fees = check_undefined(data.total_travel_fees);
    state.quote_base_fees = check_undefined(data.quote_base_fees);
    state.quote_excess_pct = check_undefined(data.quote_excess_pct);
    state.quote_base_price = check_undefined(data.quote_base_price);
    state.quote_base_price_coef = check_undefined(data.quote_base_price_coef);
    state.quote_appraisal_type_is_eco = check_undefined(data.quote_appraisal_type_is_eco);
    state.area_ads_query_startdate = check_undefined(data.area_ads_query_startdate);
    state.area_ads_query_limitdate = check_undefined(data.area_ads_query_limitdate);
    state.area_ads_query_distance = check_undefined(data.area_ads_query_distance);

    state.quote_price_incl_travel_expenses = check_undefined(data.quote_price_incl_travel_expenses);

    state.invoice_base_fees = check_undefined(data.invoice_base_fees);
    state.invoice_excess_pct = check_undefined(data.invoice_excess_pct);
    state.invoice_base_price = check_undefined(data.invoice_base_price);
    state.invoice_base_price_coef = check_undefined(data.invoice_base_price_coef);
    state.invoice_appraisal_type_is_eco = check_undefined(data.invoice_appraisal_type_is_eco);

    state.quote_excess = check_undefined(data.quote_excess);

    state.asset_type = check_undefined(data.asset_type);
    state.dwelling_type = check_undefined(data.dwelling_type);

    state.floor_type = check_undefined(data.floor_type);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_202" /* SET_REALESTATE_CADASTRAL_REFERENCE */], function (state, data) {
    state.cadastral_reference = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_201" /* SET_REALESTATE_CENSUS_SECTION_CODE */], function (state, data) {
    state.census_section_code = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_203" /* SET_REALESTATE_COUNTRY */], function (state, data) {
    state.country = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_186" /* SET_REALESTATE_DATE_CREATED */], function (state, data) {
    state.date_created = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_187" /* SET_REALESTATE_DATE_MODIFIED */], function (state, data) {
    state.date_modified = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_204" /* SET_REALESTATE_DESCRIPTION */], function (state, data) {
    state.description = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_227" /* SET_REALESTATE_DIRTYNESS */], function (state, boolean) {
    state.dirty = boolean;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_205" /* SET_REALESTATE_DOOR */], function (state, data) {
    state.door = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_206" /* SET_REALESTATE_FLOOR */], function (state, data) {
    state.floor = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_207" /* SET_REALESTATE_FLOOR_NUMBER */], function (state, data) {
    state.floor_number = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_200" /* SET_REALESTATE_GEOHASH */], function (state, data) {
    state.geohash = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_191" /* SET_REALESTATE_GOOGLE_FORMATTED_ADDRESS */], function (state, data) {
    state.google_formatted_address = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_192" /* SET_REALESTATE_GOOGLE_VIEWPORT */], function (state, data) {
    state.google_viewport = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_198" /* SET_REALESTATE_EPSG25831_X */], function (state, data) {
    state.epsg25831_x = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_199" /* SET_REALESTATE_EPSG25831_Y */], function (state, data) {
    state.epsg25831_y = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_185" /* SET_REALESTATE_ID */], function (state, data) {
    state.id = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_193" /* SET_REALESTATE_LAT */], function (state, data) {
    state.lat = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_194" /* SET_REALESTATE_LNG */], function (state, data) {
    state.lng = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_208" /* SET_REALESTATE_MUNICIPALITY */], function (state, data) {
    state.municipality = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_209" /* SET_REALESTATE_PARENT_PATH */], function (state, data) {
    state.parent_path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_188" /* SET_REALESTATE_PATH */], function (state, data) {
    state.path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_195" /* SET_REALESTATE_POSTAL_CODE */], function (state, data) {
    state.postal_code = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_210" /* SET_REALESTATE_PROPERTY_TYPE */], function (state, data) {
    state.property_type = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_211" /* SET_REALESTATE_PROVINCE */], function (state, data) {
    state.province = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_212" /* SET_REALESTATE_REGISTRY_NAME */], function (state, data) {
    state.registry_name = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_213" /* SET_REALESTATE_STAIRCASE */], function (state, data) {
    state.staircase = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_196" /* SET_REALESTATE_STREET_NAME */], function (state, data) {
    state.street_name = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_197" /* SET_REALESTATE_STREET_NUMBER */], function (state, data) {
    state.street_number = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_214" /* SET_REALESTATE_MAP_GOOGLE_01_URL */], function (state, data) {
    state.map_google_01_url = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_215" /* SET_REALESTATE_MAP_GOOGLE_01_LAT */], function (state, data) {
    state.map_google_01_lat = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_216" /* SET_REALESTATE_MAP_GOOGLE_01_LNG */], function (state, data) {
    state.map_google_01_lng = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_217" /* SET_REALESTATE_MAP_GOOGLE_01_ZOOM */], function (state, data) {
    state.map_google_01_zoom = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_218" /* SET_REALESTATE_MAP_GOOGLE_02_URL */], function (state, data) {
    state.map_google_02_url = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_219" /* SET_REALESTATE_MAP_GOOGLE_02_LAT */], function (state, data) {
    state.map_google_02_lat = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_220" /* SET_REALESTATE_MAP_GOOGLE_02_LNG */], function (state, data) {
    state.map_google_02_lng = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_221" /* SET_REALESTATE_MAP_GOOGLE_02_ZOOM */], function (state, data) {
    state.map_google_02_zoom = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_222" /* SET_REALESTATE_MAP_GOOGLE_03_URL */], function (state, data) {
    state.map_google_03_url = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_223" /* SET_REALESTATE_MAP_GOOGLE_03_LAT */], function (state, data) {
    state.map_google_03_lat = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_224" /* SET_REALESTATE_MAP_GOOGLE_03_LNG */], function (state, data) {
    state.map_google_03_lng = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_225" /* SET_REALESTATE_MAP_GOOGLE_03_ZOOM */], function (state, data) {
    state.map_google_03_zoom = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_228" /* SET_REALESTATE_FULL_ADDRESS */], function (state, data) {
    state.full_address = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_229" /* SET_REALESTATE_SHORT_ADDRESS */], function (state, data) {
    state.short_address = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_230" /* SET_REALESTATE_BLOCK */], function (state, data) {
    state.block = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_231" /* SET_REALESTATE_AREA_ADS_MARKERS */], function (state, data) {
    state.area_ads_markers = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_232" /* SET_REALESTATE_AREA_AVERAGE_PRICE */], function (state, data) {
    state.area_average_price = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_233" /* SET_REALESTATE_AREA_AVERAGE_PRICE_COEF */], function (state, data) {
    state.area_average_price_coef = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_234" /* SET_REALESTATE_ADOPTED_AREA_AVERAGE_PRICE */], function (state, data) {
    state.adopted_area_average_price = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_235" /* SET_REALESTATE_ESTIMATED_BUILT_AREA */], function (state, data) {
    state.estimated_built_area = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_236" /* SET_REALESTATE_PRE_APPRAISAL_VALUE */], function (state, data) {
    state.pre_appraisal_value = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_237" /* SET_REALESTATE_TRAVEL_ONE_WAY_HOURS */], function (state, data) {
    state.travel_one_way_hours = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_238" /* SET_REALESTATE_TRAVEL_BOTH_WAYS_HOURS */], function (state, data) {
    state.travel_both_ways_hours = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_239" /* SET_REALESTATE_TRAVEL_FEES_PER_HOUR */], function (state, data) {
    state.travel_fees_per_hour = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_240" /* SET_REALESTATE_CAR_FUEL_EXPENSES_ONE_WAY */], function (state, data) {
    state.car_fuel_expenses_one_way = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_241" /* SET_REALESTATE_CAR_FUEL_EXPENSES_BOTH_WAYS */], function (state, data) {
    state.car_fuel_expenses_both_ways = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_242" /* SET_REALESTATE_CAR_TOLL_EXPENSES_ONE_WAY */], function (state, data) {
    state.car_toll_expenses_one_way = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_243" /* SET_REALESTATE_CAR_TOLL_EXPENSES_BOTH_WAYS */], function (state, data) {
    state.car_toll_expenses_both_ways = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_244" /* SET_REALESTATE_CAR_EXPENSES_ONE_WAY */], function (state, data) {
    state.car_expenses_one_way = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_245" /* SET_REALESTATE_CAR_EXPENSES_BOTH_WAYS */], function (state, data) {
    state.car_expenses_both_ways = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_246" /* SET_REALESTATE_TOTAL_TRAVEL_FEES */], function (state, data) {
    state.total_travel_fees = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_248" /* SET_REALESTATE_QUOTE_BASE_FEES */], function (state, data) {
    state.quote_base_fees = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_249" /* SET_REALESTATE_QUOTE_EXCESS_PCT */], function (state, data) {
    state.quote_excess_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_250" /* SET_REALESTATE_QUOTE_BASE_PRICE */], function (state, data) {
    state.quote_base_price = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_251" /* SET_REALESTATE_QUOTE_BASE_PRICE_COEF */], function (state, data) {
    state.quote_base_price_coef = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_247" /* SET_REALESTATE_QUOTE_APPRAISAL_TYPE_IS_ECO */], function (state, data) {
    state.quote_appraisal_type_is_eco = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_252" /* SET_REALESTATE_AREA_ADS_QUERY_STARTDATE */], function (state, data) {
    state.area_ads_query_startdate = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_253" /* SET_REALESTATE_AREA_ADS_QUERY_LIMITDATE */], function (state, data) {
    state.area_ads_query_limitdate = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_254" /* SET_REALESTATE_AREA_ADS_QUERY_DISTANCE */], function (state, data) {
    state.area_ads_query_distance = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_255" /* SET_REALESTATE_QUOTE_PRICE_INCL_TRAVEL_EXPENSES */], function (state, data) {
    state.quote_price_incl_travel_expenses = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_256" /* SET_REALESTATE_INVOICE_BASE_FEES */], function (state, data) {
    state.invoice_base_fees = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_257" /* SET_REALESTATE_INVOICE_EXCESS_PCT */], function (state, data) {
    state.invoice_excess_pct = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_258" /* SET_REALESTATE_INVOICE_BASE_PRICE */], function (state, data) {
    state.invoice_base_price = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_259" /* SET_REALESTATE_INVOICE_BASE_PRICE_COEF */], function (state, data) {
    state.invoice_base_price_coef = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_260" /* SET_REALESTATE_INVOICE_APPRAISAL_TYPE_IS_ECO */], function (state, data) {
    state.invoice_appraisal_type_is_eco = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_261" /* SET_REALESTATE_QUOTE_EXCESS */], function (state, data) {
    state.quote_excess = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_262" /* SET_REALESTATE_ASSET_TYPE */], function (state, data) {
    state.asset_type = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_263" /* SET_REALESTATE_DWELLING_TYPE */], function (state, data) {
    state.dwelling_type = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_7__constants__["_226" /* SET_REALESTATE_FLOOR_TYPE */], function (state, data) {
    state.floor_type = data;
    state.dirty = true;
}), _mutations);

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

var getters = {

    realestate: function realestate(state) {
        return state;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    all_appraisals: {},
    appraisals: {}
};
var state = default_state;

var actions = {
    FETCH_ALL_REALESTATE_APPRAISALS: function FETCH_ALL_REALESTATE_APPRAISALS(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        // console.log('data.path (fetch_realestate_appraisals) ---->')
        // console.log(data.path)

        var temp_all_appraisals = [];

        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_183" /* SET_ALL_REALESTATE_APPRAISALS */], res.all_children);
        });
    },
    FETCH_REALESTATE_APPRAISALS: function FETCH_REALESTATE_APPRAISALS(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;


        // console.log('data.path (fetch_realestate_appraisals) ---->')
        // console.log(data.path)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_184" /* SET_REALESTATE_APPRAISALS */], res);
        });
    }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_183" /* SET_ALL_REALESTATE_APPRAISALS */], function (state, data) {
    state.appraisals = check_undefined(data);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_184" /* SET_REALESTATE_APPRAISALS */], function (state, data) {
    state.appraisals = check_undefined(data);
}), _mutations);

var getters = {
    all_realestate_appraisals: function all_realestate_appraisals(state) {
        return state.all_appraisals;
    },
    realestate_appraisals: function realestate_appraisals(state) {
        return state.appraisals;
    }
};

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
var _mutations;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    marketstudies: {},
    temp_marketstudies: {}
};
var state = default_state;

var _require = __webpack_require__(40),
    map = _require.map;

var _map = _.map;

var actions = {
    FETCH_REALESTATE_MARKETSTUDIES: function FETCH_REALESTATE_MARKETSTUDIES(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;

        // console.log('data.path (fetch_realestate_marketstudies) ---->')
        // console.log(data.path)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_180" /* SET_REALESTATE_MARKETSTUDIES */], res);
        });
    },
    FETCH_TEMP_REALESTATE_MARKETSTUDIES: function FETCH_TEMP_REALESTATE_MARKETSTUDIES(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;

        // console.log('data.path (fetch_realestate_marketstudies) ---->')
        // console.log(data.path)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_181" /* SET_TEMP_REALESTATE_MARKETSTUDIES */], res);
        });
    },
    COPY_COMPARABLES_FROM_MARKETSTUDY: function COPY_COMPARABLES_FROM_MARKETSTUDY(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;

        // console.log('data.path (fetch_realestate_marketstudies) ---->')
        // console.log(data.path)
        return new Promise(function (resolve, reject) {

            var arr_comparables = _map(data.comparables, function (value, key) {
                return _extends({
                    key: key
                }, value);
            });

            console.log('data.comparables: ');
            console.log(data.comparables);
            console.log('arr_comparables: ');
            console.log(arr_comparables);

            // constant "map" from the 'p-iteration' plugin
            map(arr_comparables, function (value, index) {
                return new Promise(function (resolve, reject) {

                    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: 'marketstudy_ad_comparables' + '/' + data.temp_marketstudy_id + '/' + value.key }).then(function (res) {

                        var comparable = res;
                        // console.log('waruuuaa res:')
                        // console.log(res)

                        // set the correct ids in the paths
                        //comparable['path'] = "realestate_marketstudies/" + data.marketstudy_id + '/'
                        comparable['path'] = "marketstudy_ad_comparables/" + data.marketstudy_id + '/';
                        comparable['parent_path'] = "realestate_marketstudies/" + data.realestate_id + "/" + data.marketstudy_id + "/" + "comparables" + "/";

                        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                            path: 'realestate_marketstudies' + '/' + data.realestate_id + '/' + data.marketstudy_id + '/' + 'comparables' + '/' + value.key,
                            value: true
                        }).then(function (res) {
                            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                                path: 'marketstudy_ad_comparables' + '/' + data.marketstudy_id + '/' + value.key,
                                value: comparable
                            }).then(function (res) {
                                // console.log(res)
                                resolve();
                            });
                        });
                    });
                });
            }).then(function (result) {
                resolve();
            });
        });

        /*
        _.forEach(data.comparables, function (value, key) {
            api.get({path: 'marketstudy_ad_comparables' + '/' + data.temp_marketstudy_id + '/' + key})
                .then((res) => {
                    console.log('waruuuaa res:')
                    console.log(res)
                    api.set_value({
                        path: 'realestate_marketstudies' + '/' + data.realestate_id + '/' + data.marketstudy_id + '/' + 'comparables' + '/' + key,
                        value: true
                    })
                        .then((res) => {
                            // console.log(res)
                        })
                    api.set_value({
                        path: 'marketstudy_ad_comparables' + '/' + data.marketstudy_id + '/' + key,
                        value: res
                    })
                        .then((res) => {
                            // console.log(res)
                        })
                })
        })
        */
    },

    FETCH_REALESTATE_MARKETSTUDIES_PARENT: function FETCH_REALESTATE_MARKETSTUDIES_PARENT(_ref4, data) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;

        // console.log('data.path (fetch_realestate_marketstudies) ---->')
        // console.log(data.path)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            var keys = [];
            _.forEach(res, function (value, key) {
                console.log('key!: ');
                console.log(key);
                keys.push(key);
            });

            console.log('*********!!!!!! keys: ');
            console.log(keys);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_182" /* SET_APPRAISAL_MARKETSTUDIES */], keys);
        });
    }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_180" /* SET_REALESTATE_MARKETSTUDIES */], function (state, data) {
    state.marketstudies = check_undefined(data);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_181" /* SET_TEMP_REALESTATE_MARKETSTUDIES */], function (state, data) {
    state.temp_marketstudies = check_undefined(data);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_182" /* SET_APPRAISAL_MARKETSTUDIES */], function (state, data) {
    state.app_marketstudies = check_undefined(data);
}), _mutations);

var getters = {
    realestate_marketstudies: function realestate_marketstudies(state) {
        return state.marketstudies;
    },
    temp_marketstudies: function temp_marketstudies(state) {
        return state.temp_marketstudies;
    },
    // short version (parent)
    appraisal_marketstudies: function appraisal_marketstudies(state) {
        return state.app_marketstudies;
    }
};

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    municipalities: {}
};
var state = default_state;

var actions = {
    FETCH_REALESTATE_MUNICIPALITIES: function FETCH_REALESTATE_MUNICIPALITIES(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        // console.log('data.path (fetch_realestate_municipalities) ---->')
        // console.log(data.path)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            // console.log(res)
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_179" /* SET_REALESTATE_MUNICIPALITIES */], res);
        });
    }
};

var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__constants__["_179" /* SET_REALESTATE_MUNICIPALITIES */], function (state, data) {
    state.municipalities = data;
});

var getters = {
    realestate_municipalities: function realestate_municipalities(state) {
        return state.municipalities;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    all_projects: {},
    projects: {}
};
var state = default_state;

var actions = {
    FETCH_ALL_REALESTATE_PROJECTS: function FETCH_ALL_REALESTATE_PROJECTS(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        // console.log('data.path (fetch_realestate_projects) ---->')
        // console.log(data.path)

        var temp_all_projects = [];

        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_177" /* SET_ALL_REALESTATE_PROJECTS */], res.all_children);
        });
    },
    FETCH_REALESTATE_PROJECTS: function FETCH_REALESTATE_PROJECTS(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;


        // console.log('data.path (fetch_realestate_projects) ---->')
        // console.log(data.path)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_178" /* SET_REALESTATE_PROJECTS */], res);
        });
    }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_177" /* SET_ALL_REALESTATE_PROJECTS */], function (state, data) {
    state.projects = check_undefined(data);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_178" /* SET_REALESTATE_PROJECTS */], function (state, data) {
    state.projects = check_undefined(data);
}), _mutations);

var getters = {
    all_realestate_projects: function all_realestate_projects(state) {
        return state.all_projects;
    },
    realestate_projects: function realestate_projects(state) {
        return state.projects;
    }
};

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    path: null,
    name_ca: null,
    name_en: null,
    name_es: null,
    url: null,
    filename: null

};

var state = default_state;

var actions = {

    CREATE_NEW_REGISTRYANNEX: function CREATE_NEW_REGISTRYANNEX(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].create({ key: data.key, path: data.path }).then(function (res) {
                var new_created_key = res.key;

                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_23" /* SET_REGISTRYANNEX_ID */], res.key);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_24" /* SET_REGISTRYANNEX_DATE_CREATED */], res.date_created);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_25" /* SET_REGISTRYANNEX_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_26" /* SET_REGISTRYANNEX_PATH */], res.path);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_27" /* SET_REGISTRYANNEX_PARENT_PATH */], data.parent_path);

                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                    value: res.key,
                    path: data.path + new_created_key + '/' + 'id',
                    save_timestamp: false
                }).then(function (res) {
                    return resolve({ key: new_created_key });
                });
            });
        });
    },
    DELETE_REGISTRYANNEX: function DELETE_REGISTRYANNEX(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;


        // console.log('DELETE_REGISTRYANNEX path check: ' + data.path)
        // console.log('DELETE REGISTRYANNEX parent_path check: ' + data.parent_path)

        // delete from registryannexes/registryannex_key
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.path }).then(function (res) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].deleteImage({ path: data.path, filename: data.filename });
        });
    },
    GET_REGISTRYANNEX: function GET_REGISTRYANNEX(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;


        return new Promise(function (resolve, reject) {
            return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                return resolve(res);
            });
        });
    },
    SET_REGISTRYANNEX: function SET_REGISTRYANNEX(_ref4, data) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;


        // console.log('set_registryannex data:')
        // console.log(data)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_28" /* SET_REGISTRYANNEX */], res);
        });
    },
    RESET_REGISTRYANNEX: function RESET_REGISTRYANNEX(_ref5) {
        var state = _ref5.state,
            commit = _ref5.commit,
            rootState = _ref5.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_29" /* RESET_REGISTRYANNEX */]);
    },
    SET_REGISTRYANNEX_REPORTDATE: function (_SET_REGISTRYANNEX_REPORTDATE) {
        function SET_REGISTRYANNEX_REPORTDATE(_x, _x2) {
            return _SET_REGISTRYANNEX_REPORTDATE.apply(this, arguments);
        }

        SET_REGISTRYANNEX_REPORTDATE.toString = function () {
            return _SET_REGISTRYANNEX_REPORTDATE.toString();
        };

        return SET_REGISTRYANNEX_REPORTDATE;
    }(function (_ref6, data) {
        var state = _ref6.state,
            commit = _ref6.commit,
            rootState = _ref6.rootState;

        commit(SET_REGISTRYANNEX_REPORTDATE, data);
    }),
    SET_REGISTRYANNEX_DATE_CREATED: function SET_REGISTRYANNEX_DATE_CREATED(_ref7, data) {
        var state = _ref7.state,
            commit = _ref7.commit,
            rootState = _ref7.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_24" /* SET_REGISTRYANNEX_DATE_CREATED */], data);
    },
    SET_REGISTRYANNEX_DATE_MODIFIED: function SET_REGISTRYANNEX_DATE_MODIFIED(_ref8, data) {
        var state = _ref8.state,
            commit = _ref8.commit,
            rootState = _ref8.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_25" /* SET_REGISTRYANNEX_DATE_MODIFIED */], data);
    },

    SET_REGISTRYANNEX_ID: function SET_REGISTRYANNEX_ID(_ref9, data) {
        var state = _ref9.state,
            commit = _ref9.commit,
            rootState = _ref9.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_23" /* SET_REGISTRYANNEX_ID */], data);
    },
    SET_REGISTRYANNEX_PARENT_PATH: function SET_REGISTRYANNEX_PARENT_PATH(_ref10, data) {
        var state = _ref10.state,
            commit = _ref10.commit,
            rootState = _ref10.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_27" /* SET_REGISTRYANNEX_PARENT_PATH */], data);
    },
    SET_REGISTRYANNEX_PATH: function SET_REGISTRYANNEX_PATH(_ref11, data) {
        var state = _ref11.state,
            commit = _ref11.commit,
            rootState = _ref11.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_26" /* SET_REGISTRYANNEX_PATH */], data);
    },
    UPDATE_REGISTRYANNEX: function UPDATE_REGISTRYANNEX(_ref12, data) {
        var state = _ref12.state,
            commit = _ref12.commit,
            rootState = _ref12.rootState;

        return new Promise(function (resolve, reject) {
            // console.log('UPDATE_REGISTRYANNEX data:')
            // console.log(data)
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({ object: data.object, path: data.path + data.key, save_timestamp: true }).then(function (res) {

                var date_modified = res.date_modified;
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_25" /* SET_REGISTRYANNEX_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_30" /* SET_REGISTRYANNEX_DIRTYNESS */], false);
                resolve();
            });
        });
    },
    SET_REGISTRYANNEX_NAME_CA: function SET_REGISTRYANNEX_NAME_CA(_ref13, data) {
        var state = _ref13.state,
            commit = _ref13.commit,
            rootState = _ref13.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_31" /* SET_REGISTRYANNEX_NAME_CA */], data);
    },
    SET_REGISTRYANNEX_NAME_EN: function SET_REGISTRYANNEX_NAME_EN(_ref14, data) {
        var state = _ref14.state,
            commit = _ref14.commit,
            rootState = _ref14.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_32" /* SET_REGISTRYANNEX_NAME_EN */], data);
    },
    SET_REGISTRYANNEX_NAME_ES: function SET_REGISTRYANNEX_NAME_ES(_ref15, data) {
        var state = _ref15.state,
            commit = _ref15.commit,
            rootState = _ref15.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_33" /* SET_REGISTRYANNEX_NAME_ES */], data);
    },
    SET_REGISTRYANNEX_URL: function SET_REGISTRYANNEX_URL(_ref16, data) {
        var state = _ref16.state,
            commit = _ref16.commit,
            rootState = _ref16.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_34" /* SET_REGISTRYANNEX_URL */], data);
    },
    SET_REGISTRYANNEX_FILENAME: function SET_REGISTRYANNEX_FILENAME(_ref17, data) {
        var state = _ref17.state,
            commit = _ref17.commit,
            rootState = _ref17.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_35" /* SET_REGISTRYANNEX_FILENAME */], data);
    }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_29" /* RESET_REGISTRYANNEX */], function (state) {
    state.date_created = null;
    state.date_modified = null;
    state.dirty = false;
    state.file_id = null;
    state.id = null;
    state.path = null;
    state.parent_path = null;
    state.name_ca = null;
    state.name_en = null;
    state.name_es = null;
    state.url = null;
    state.filename = null;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_28" /* SET_REGISTRYANNEX */], function (state, data) {
    state.date_created = check_undefined(data.date_created);
    state.date_modified = check_undefined(data.date_modified);
    state.dirty = false;
    state.file_id = check_undefined(data.file_id);
    state.id = check_undefined(data.id);
    state.path = check_undefined(data.path);
    state.parent_path = check_undefined(data.parent_path);
    state.name_ca = check_undefined(data.name_ca);
    state.name_en = check_undefined(data.name_en);
    state.name_es = check_undefined(data.name_es);
    state.url = check_undefined(data.url);
    state.filename = check_undefined(data.filename);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_24" /* SET_REGISTRYANNEX_DATE_CREATED */], function (state, data) {
    state.date_created = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_25" /* SET_REGISTRYANNEX_DATE_MODIFIED */], function (state, data) {
    state.date_modified = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_30" /* SET_REGISTRYANNEX_DIRTYNESS */], function (state, boolean) {
    state.dirty = boolean;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_23" /* SET_REGISTRYANNEX_ID */], function (state, data) {
    state.id = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_27" /* SET_REGISTRYANNEX_PARENT_PATH */], function (state, data) {
    state.parent_path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_26" /* SET_REGISTRYANNEX_PATH */], function (state, data) {
    state.path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_31" /* SET_REGISTRYANNEX_NAME_CA */], function (state, data) {
    state.name_ca = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_32" /* SET_REGISTRYANNEX_NAME_EN */], function (state, data) {
    state.name_en = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_33" /* SET_REGISTRYANNEX_NAME_ES */], function (state, data) {
    state.name_es = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_34" /* SET_REGISTRYANNEX_URL */], function (state, data) {
    state.url = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_35" /* SET_REGISTRYANNEX_FILENAME */], function (state, data) {
    state.filename = data;
    state.dirty = true;
}), _mutations);

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

var getters = {
    registryannex: function registryannex(state) {
        return state;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    parent_path: null,
    path: null,
    description: null,
    netarea: null,
    type: null
};

var state = default_state;

var actions = {

    CREATE_NEW_ROOM: function CREATE_NEW_ROOM(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].create({ key: data.key, path: data.path }).then(function (res) {
                var new_created_key = res.key;

                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_166" /* SET_ROOM_ID */], new_created_key);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_167" /* SET_ROOM_DATE_CREATED */], res.date_created);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_168" /* SET_ROOM_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_169" /* SET_ROOM_PARENT_PATH */], data.parent_path);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_170" /* SET_ROOM_PATH */], res.path);

                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                    value: new_created_key,
                    path: data.path + new_created_key + '/' + 'id',
                    save_timestamp: false
                }).then(function (res) {
                    var object = {};
                    object[new_created_key] = true;
                    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({
                        object: object,
                        path: data.parent_path,
                        save_timestamp: false
                    }).then(function (res) {
                        return resolve({ key: new_created_key });
                    });
                });
            });
        });
    },
    DELETE_ROOM: function DELETE_ROOM(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;


        return new Promise(function (resolve, reject) {

            // console.log('path check: ' + data.path)
            // console.log('parent_path check: ' + data.parent_path)

            // delete from contact_rooms/contact_key
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.path }).then(function (res) {
                // delete from contact/contact_key/rooms
                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.parent_path }).then(function (res) {
                    commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_171" /* RESET_ROOM */]);
                }).then(function (res) {
                    return resolve({});
                });
            });
        });
    },
    SET_ROOM: function SET_ROOM(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;


        return new Promise(function (resolve, reject) {

            // console.log('set_room data:')
            // console.log(data)
            return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                console.log(res);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_172" /* SET_ROOM */], res);
            }).then(function (res) {
                return resolve({});
            });
        });
    },
    RESET_ROOM: function RESET_ROOM(_ref4) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_171" /* RESET_ROOM */]);
    },
    SET_ROOM_DATE_CREATED: function SET_ROOM_DATE_CREATED(_ref5, data) {
        var state = _ref5.state,
            commit = _ref5.commit,
            rootState = _ref5.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_167" /* SET_ROOM_DATE_CREATED */], data);
    },
    SET_ROOM_DATE_MODIFIED: function SET_ROOM_DATE_MODIFIED(_ref6, data) {
        var state = _ref6.state,
            commit = _ref6.commit,
            rootState = _ref6.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_168" /* SET_ROOM_DATE_MODIFIED */], data);
    },

    SET_ROOM_ID: function SET_ROOM_ID(_ref7, data) {
        var state = _ref7.state,
            commit = _ref7.commit,
            rootState = _ref7.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_166" /* SET_ROOM_ID */], data);
    },

    SET_ROOM_PATH: function SET_ROOM_PATH(_ref8, data) {
        var state = _ref8.state,
            commit = _ref8.commit,
            rootState = _ref8.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_170" /* SET_ROOM_PATH */], data);
    },
    UPDATE_ROOM: function UPDATE_ROOM(_ref9, data) {
        var state = _ref9.state,
            commit = _ref9.commit,
            rootState = _ref9.rootState;

        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({ object: data.object, path: data.path, save_timestamp: true }).then(function (res) {

            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_168" /* SET_ROOM_DATE_MODIFIED */], res.date_modified);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_173" /* SET_ROOM_DIRTYNESS */], false);
        });
    },
    SET_ROOM_DESCRIPTION: function SET_ROOM_DESCRIPTION(_ref10, data) {
        var state = _ref10.state,
            commit = _ref10.commit,
            rootState = _ref10.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_174" /* SET_ROOM_DESCRIPTION */], data);
    },
    /*
    SET_ROOM_NETAREA: ({state, commit, rootState}, data) => {
         return new Promise((resolve, reject) => {
            api.set_value({
                value: data.netarea,
                path: 'appraisal_rooms' + '/' + data.appraisal_id + '/' + data.key + '/' + 'netarea',
                save_timestamp: false
            }).then((res) => {
                resolve()
             })
         })
     },
    */
    SET_ROOM_TYPE: function SET_ROOM_TYPE(_ref11, data) {
        var state = _ref11.state,
            commit = _ref11.commit,
            rootState = _ref11.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_175" /* SET_ROOM_TYPE */], data);
    }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_171" /* RESET_ROOM */], function (state) {
    state.date_created = null;
    state.date_modified = null;
    state.dirty = false;
    state.id = null;
    state.parent_path = null;
    state.path = null;
    state.description = null;
    state.netarea = null;
    state.type = null;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_172" /* SET_ROOM */], function (state, data) {
    state.date_created = check_undefined(data.date_created);
    state.date_modified = check_undefined(data.date_modified);
    state.dirty = false;
    state.id = check_undefined(data.id);
    state.parent_path = check_undefined(data.parent_path);
    state.path = check_undefined(data.path);
    state.description = check_undefined(data.description);
    state.netarea = check_undefined(data.netarea);
    state.type = check_undefined(data.type);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_167" /* SET_ROOM_DATE_CREATED */], function (state, data) {
    state.date_created = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_168" /* SET_ROOM_DATE_MODIFIED */], function (state, data) {
    state.date_modified = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_173" /* SET_ROOM_DIRTYNESS */], function (state, boolean) {
    state.dirty = boolean;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_166" /* SET_ROOM_ID */], function (state, data) {
    state.id = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_176" /* SET_ROOM_NETAREA */], function (state, data) {
    state.netarea = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_169" /* SET_ROOM_PARENT_PATH */], function (state, data) {
    state.parent_path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_170" /* SET_ROOM_PATH */], function (state, data) {
    state.path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_174" /* SET_ROOM_DESCRIPTION */], function (state, data) {
    state.description = data;
    state.dirty = true;
}), _mutations);

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

var getters = {

    room: function room(state) {
        return state;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    name: null,
    organization: null,
    path: null,
    surnames: null,
    tin: null,
    title: null,
    complete_name: null,
    prof_assoc_reg_number: null

};
var state = default_state;

var actions = {
    CREATE_NEW_SUPERVISOR: function CREATE_NEW_SUPERVISOR(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;

        return new Promise(function (resolve, reject) {
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_434" /* RESET_SUPERVISOR */]);
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].create({ path: data.path }).then(function (res) {
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_435" /* SET_SUPERVISOR_ID */], res.key);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_436" /* SET_SUPERVISOR_DATE_CREATED */], res.date_created);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_437" /* SET_SUPERVISOR_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_438" /* SET_SUPERVISOR_PATH */], res.path);
                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({ value: res.key, path: data.path + '/' + res.key + '/' + 'id', save_timestamp: false });
                resolve();
            });
        });
    },
    DELETE_SUPERVISOR: function DELETE_SUPERVISOR(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;


        console.log('path check: ' + data.path);
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.path }).then(function (res) {
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_434" /* RESET_SUPERVISOR */]);

            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: 'supervisor_addresses' + '/' + data.key }).then(function (res) {});
        });
    },
    RESET_SUPERVISOR: function RESET_SUPERVISOR(_ref3) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_434" /* RESET_SUPERVISOR */]);
    },
    SET_SUPERVISOR: function SET_SUPERVISOR(_ref4, data) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;


        console.log('set_supervisor data:');
        console.log(data);
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_439" /* SET_SUPERVISOR */], res);
        });
    },
    SET_SUPERVISOR_DATE_CREATED: function SET_SUPERVISOR_DATE_CREATED(_ref5, data) {
        var state = _ref5.state,
            commit = _ref5.commit,
            rootState = _ref5.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_436" /* SET_SUPERVISOR_DATE_CREATED */], data);
    },
    SET_SUPERVISOR_DATE_MODIFIED: function SET_SUPERVISOR_DATE_MODIFIED(_ref6, data) {
        var state = _ref6.state,
            commit = _ref6.commit,
            rootState = _ref6.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_437" /* SET_SUPERVISOR_DATE_MODIFIED */], data);
    },
    SET_SUPERVISOR_ID: function SET_SUPERVISOR_ID(_ref7, data) {
        var state = _ref7.state,
            commit = _ref7.commit,
            rootState = _ref7.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_435" /* SET_SUPERVISOR_ID */], data);
    },
    SET_SUPERVISOR_NAME: function SET_SUPERVISOR_NAME(_ref8, name) {
        var state = _ref8.state,
            commit = _ref8.commit,
            rootState = _ref8.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_440" /* SET_SUPERVISOR_NAME */], name);
    },
    SET_SUPERVISOR_ORGANIZATION: function SET_SUPERVISOR_ORGANIZATION(_ref9, name) {
        var state = _ref9.state,
            commit = _ref9.commit,
            rootState = _ref9.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_441" /* SET_SUPERVISOR_ORGANIZATION */], name);
    },
    SET_SUPERVISOR_PATH: function SET_SUPERVISOR_PATH(_ref10, data) {
        var state = _ref10.state,
            commit = _ref10.commit,
            rootState = _ref10.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_438" /* SET_SUPERVISOR_PATH */], data);
    },
    SET_SUPERVISOR_SURNAMES: function SET_SUPERVISOR_SURNAMES(_ref11, surnames) {
        var state = _ref11.state,
            commit = _ref11.commit,
            rootState = _ref11.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_442" /* SET_SUPERVISOR_SURNAMES */], surnames);
    },
    SET_SUPERVISOR_TIN: function SET_SUPERVISOR_TIN(_ref12, tin) {
        var state = _ref12.state,
            commit = _ref12.commit,
            rootState = _ref12.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_443" /* SET_SUPERVISOR_TIN */], tin);
    },
    SET_SUPERVISOR_TITLE: function SET_SUPERVISOR_TITLE(_ref13, title) {
        var state = _ref13.state,
            commit = _ref13.commit,
            rootState = _ref13.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_444" /* SET_SUPERVISOR_TITLE */], title);
    },
    SET_SUPERVISOR_COMPLETE_NAME: function SET_SUPERVISOR_COMPLETE_NAME(_ref14, data) {
        var state = _ref14.state,
            commit = _ref14.commit,
            rootState = _ref14.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_445" /* SET_SUPERVISOR_COMPLETE_NAME */], data);
    },
    SET_SUPERVISOR_PROF_ASSOC_REG_NUMBER: function SET_SUPERVISOR_PROF_ASSOC_REG_NUMBER(_ref15, data) {
        var state = _ref15.state,
            commit = _ref15.commit,
            rootState = _ref15.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_446" /* SET_SUPERVISOR_PROF_ASSOC_REG_NUMBER */], data);
    },
    UPDATE_SUPERVISOR: function UPDATE_SUPERVISOR(_ref16, data) {
        var state = _ref16.state,
            commit = _ref16.commit,
            rootState = _ref16.rootState;

        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({ object: data.object, path: data.path, save_timestamp: true }).then(function (res) {
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_437" /* SET_SUPERVISOR_DATE_MODIFIED */], res.date_modified);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_447" /* SET_SUPERVISOR_DIRTYNESS */], false);
        });
    }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_434" /* RESET_SUPERVISOR */], function (state) {
    state.date_created = null;
    state.date_modified = null;
    state.id = null;
    state.name = null;
    state.organization = null;
    state.path = null;
    state.surnames = null;
    state.tin = null;
    state.title = null;
    state.dirty = false;
    state.complete_name = null;
    state.prof_assoc_reg_number = null;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_439" /* SET_SUPERVISOR */], function (state, data) {
    // console.log('mutations SET_SUPERVISOR data: ')
    //  console.log(data)
    state.date_created = check_undefined(data.date_created);
    state.date_modified = check_undefined(data.date_modified);
    state.id = check_undefined(data.id);
    state.name = check_undefined(data.name);
    state.organization = check_undefined(data.organization);
    state.path = check_undefined(data.path);
    state.surnames = check_undefined(data.surnames);
    state.tin = check_undefined(data.tin);
    state.title = check_undefined(data.title);
    state.dirty = false;
    state.complete_name = check_undefined(data.complete_name);
    state.prof_assoc_reg_number = check_undefined(data.prof_assoc_reg_number);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_436" /* SET_SUPERVISOR_DATE_CREATED */], function (state, data) {
    state.date_created = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_437" /* SET_SUPERVISOR_DATE_MODIFIED */], function (state, data) {
    state.date_modified = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_447" /* SET_SUPERVISOR_DIRTYNESS */], function (state, boolean) {
    state.dirty = boolean;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_435" /* SET_SUPERVISOR_ID */], function (state, data) {
    state.id = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_440" /* SET_SUPERVISOR_NAME */], function (state, name) {
    state.name = name;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_441" /* SET_SUPERVISOR_ORGANIZATION */], function (state, data) {
    state.organization = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_438" /* SET_SUPERVISOR_PATH */], function (state, data) {
    state.path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_442" /* SET_SUPERVISOR_SURNAMES */], function (state, surnames) {
    state.surnames = surnames;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_443" /* SET_SUPERVISOR_TIN */], function (state, tin) {
    state.tin = tin;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_444" /* SET_SUPERVISOR_TITLE */], function (state, title) {
    state.title = title;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_445" /* SET_SUPERVISOR_COMPLETE_NAME */], function (state, data) {
    state.complete_name = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_446" /* SET_SUPERVISOR_PROF_ASSOC_REG_NUMBER */], function (state, data) {
    state.prof_assoc_reg_number = data;
    state.dirty = true;
}), _mutations);

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

var getters = {

    supervisor: function supervisor(state) {
        return state;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    description: null,
    number: null,
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    path: null
};

var state = default_state;

var actions = {

    CREATE_NEW_TELEPHONENUMBER: function CREATE_NEW_TELEPHONENUMBER(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;

        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].create({ key: data.key, path: data.path }).then(function (res) {
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_122" /* SET_TELEPHONENUMBER_ID */], res.key);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_123" /* SET_TELEPHONENUMBER_DATE_CREATED */], res.date_created);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_124" /* SET_TELEPHONENUMBER_DATE_MODIFIED */], res.date_modified);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_125" /* SET_TELEPHONENUMBER_PATH */], res.path);

            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({ value: res.key, path: data.path + res.key + '/' + 'id', save_timestamp: false });

            var object = {};
            object[res.key] = true;
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({ object: object, path: data.parent_path, save_timestamp: false });
        });
    },
    DELETE_TELEPHONENUMBER: function DELETE_TELEPHONENUMBER(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;


        console.log('path check: ' + data.path);
        console.log('parent_path check: ' + data.parent_path);

        // delete from contact_telephonenumbers/contactkey
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.path }).then(function (res) {
            // delete from contact/contactkey/telephonenumbers
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.parent_path }).then(function (res) {
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_126" /* RESET_TELEPHONENUMBER */]);
            });
        });
    },
    SET_TELEPHONENUMBER: function SET_TELEPHONENUMBER(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;


        // console.log('set_telephonenumber data:')
        // console.log(data)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_127" /* SET_TELEPHONENUMBER */], res);
        });
    },

    RESET_TELEPHONENUMBER: function RESET_TELEPHONENUMBER(_ref4) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_126" /* RESET_TELEPHONENUMBER */]);
    },

    SET_TELEPHONENUMBER_DESCRIPTION: function SET_TELEPHONENUMBER_DESCRIPTION(_ref5, data) {
        var state = _ref5.state,
            commit = _ref5.commit,
            rootState = _ref5.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_128" /* SET_TELEPHONENUMBER_DESCRIPTION */], data);
    },
    SET_TELEPHONENUMBER_NUMBER: function SET_TELEPHONENUMBER_NUMBER(_ref6, data) {
        var state = _ref6.state,
            commit = _ref6.commit,
            rootState = _ref6.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_129" /* SET_TELEPHONENUMBER_NUMBER */], data);
    },
    SET_TELEPHONENUMBER_DATE_CREATED: function SET_TELEPHONENUMBER_DATE_CREATED(_ref7, data) {
        var state = _ref7.state,
            commit = _ref7.commit,
            rootState = _ref7.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_123" /* SET_TELEPHONENUMBER_DATE_CREATED */], data);
    },
    SET_TELEPHONENUMBER_DATE_MODIFIED: function SET_TELEPHONENUMBER_DATE_MODIFIED(_ref8, data) {
        var state = _ref8.state,
            commit = _ref8.commit,
            rootState = _ref8.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_124" /* SET_TELEPHONENUMBER_DATE_MODIFIED */], data);
    },

    SET_TELEPHONENUMBER_ID: function SET_TELEPHONENUMBER_ID(_ref9, data) {
        var state = _ref9.state,
            commit = _ref9.commit,
            rootState = _ref9.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_122" /* SET_TELEPHONENUMBER_ID */], data);
    },

    SET_TELEPHONENUMBER_PATH: function SET_TELEPHONENUMBER_PATH(_ref10, data) {
        var state = _ref10.state,
            commit = _ref10.commit,
            rootState = _ref10.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_125" /* SET_TELEPHONENUMBER_PATH */], data);
    },
    SET_TELEPHONENUMBER_PREFIX: function SET_TELEPHONENUMBER_PREFIX(_ref11, data) {
        var state = _ref11.state,
            commit = _ref11.commit,
            rootState = _ref11.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_130" /* SET_TELEPHONENUMBER_PREFIX */], data);
    },
    UPDATE_TELEPHONENUMBER: function UPDATE_TELEPHONENUMBER(_ref12, data) {
        var state = _ref12.state,
            commit = _ref12.commit,
            rootState = _ref12.rootState;

        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({ object: data.object, path: data.path, save_timestamp: true }).then(function (res) {

            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_124" /* SET_TELEPHONENUMBER_DATE_MODIFIED */], res.date_modified);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_131" /* SET_TELEPHONENUMBER_DIRTYNESS */], false);
        });
    }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_126" /* RESET_TELEPHONENUMBER */], function (state) {
    state.description = null, state.number = null,
    // general state data
    state.date_created = null, state.date_modified = null, state.dirty = false, state.id = null, state.path = null;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_127" /* SET_TELEPHONENUMBER */], function (state, data) {
    state.description = check_undefined(data.description);
    state.number = check_undefined(data.number);
    // general state data
    state.date_created = check_undefined(data.date_created);
    state.date_modified = check_undefined(data.date_modified);
    state.dirty = false;
    state.id = check_undefined(data.id);
    state.path = check_undefined(data.path);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_123" /* SET_TELEPHONENUMBER_DATE_CREATED */], function (state, data) {
    state.date_created = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_124" /* SET_TELEPHONENUMBER_DATE_MODIFIED */], function (state, data) {
    state.date_modified = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_131" /* SET_TELEPHONENUMBER_DIRTYNESS */], function (state, boolean) {
    state.dirty = boolean;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_122" /* SET_TELEPHONENUMBER_ID */], function (state, data) {
    state.id = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_125" /* SET_TELEPHONENUMBER_PATH */], function (state, data) {
    state.path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_128" /* SET_TELEPHONENUMBER_DESCRIPTION */], function (state, data) {
    state.description = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_129" /* SET_TELEPHONENUMBER_NUMBER */], function (state, data) {
    state.number = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_130" /* SET_TELEPHONENUMBER_PREFIX */], function (state, data) {
    state.prefix = data;
    state.dirty = true;
}), _mutations);

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

var getters = {

    telephonenumber: function telephonenumber(state) {
        return state;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    parent_path: null,
    path: null,
    description: null,
    netarea: null,
    type: null
};

var state = default_state;

var actions = {

    CREATE_NEW_UNCOVERED_OUTDOOR: function CREATE_NEW_UNCOVERED_OUTDOOR(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].create({ key: data.key, path: data.path }).then(function (res) {
                var new_created_key = res.key;

                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_132" /* SET_UNCOVERED_OUTDOOR_ID */], new_created_key);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_133" /* SET_UNCOVERED_OUTDOOR_DATE_CREATED */], res.date_created);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_134" /* SET_UNCOVERED_OUTDOOR_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_135" /* SET_UNCOVERED_OUTDOOR_PARENT_PATH */], data.parent_path);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_136" /* SET_UNCOVERED_OUTDOOR_PATH */], res.path);

                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                    value: new_created_key,
                    path: data.path + new_created_key + '/' + 'id',
                    save_timestamp: false
                }).then(function (res) {
                    var object = {};
                    object[new_created_key] = true;
                    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({
                        object: object,
                        path: data.parent_path,
                        save_timestamp: false
                    }).then(function (res) {
                        return resolve({ key: new_created_key });
                    });
                });
            });
        });
    },
    DELETE_UNCOVERED_OUTDOOR: function DELETE_UNCOVERED_OUTDOOR(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;


        return new Promise(function (resolve, reject) {

            // console.log('path check: ' + data.path)
            // console.log('parent_path check: ' + data.parent_path)

            // delete from contact_uncovered_outdoors/contact_key
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.path }).then(function (res) {
                // delete from contact/contact_key/uncovered_outdoors
                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.parent_path }).then(function (res) {
                    commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_137" /* RESET_UNCOVERED_OUTDOOR */]);
                }).then(function (res) {
                    return resolve({});
                });
            });
        });
    },
    SET_UNCOVERED_OUTDOOR: function SET_UNCOVERED_OUTDOOR(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;


        return new Promise(function (resolve, reject) {

            // console.log('set_uncovered_outdoor data:')
            // console.log(data)
            return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                console.log(res);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_138" /* SET_UNCOVERED_OUTDOOR */], res);
            }).then(function (res) {
                return resolve({});
            });
        });
    },
    RESET_UNCOVERED_OUTDOOR: function RESET_UNCOVERED_OUTDOOR(_ref4) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_137" /* RESET_UNCOVERED_OUTDOOR */]);
    },
    SET_UNCOVERED_OUTDOOR_DATE_CREATED: function SET_UNCOVERED_OUTDOOR_DATE_CREATED(_ref5, data) {
        var state = _ref5.state,
            commit = _ref5.commit,
            rootState = _ref5.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_133" /* SET_UNCOVERED_OUTDOOR_DATE_CREATED */], data);
    },
    SET_UNCOVERED_OUTDOOR_DATE_MODIFIED: function SET_UNCOVERED_OUTDOOR_DATE_MODIFIED(_ref6, data) {
        var state = _ref6.state,
            commit = _ref6.commit,
            rootState = _ref6.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_134" /* SET_UNCOVERED_OUTDOOR_DATE_MODIFIED */], data);
    },

    SET_UNCOVERED_OUTDOOR_ID: function SET_UNCOVERED_OUTDOOR_ID(_ref7, data) {
        var state = _ref7.state,
            commit = _ref7.commit,
            rootState = _ref7.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_132" /* SET_UNCOVERED_OUTDOOR_ID */], data);
    },

    SET_UNCOVERED_OUTDOOR_PATH: function SET_UNCOVERED_OUTDOOR_PATH(_ref8, data) {
        var state = _ref8.state,
            commit = _ref8.commit,
            rootState = _ref8.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_136" /* SET_UNCOVERED_OUTDOOR_PATH */], data);
    },
    UPDATE_UNCOVERED_OUTDOOR: function UPDATE_UNCOVERED_OUTDOOR(_ref9, data) {
        var state = _ref9.state,
            commit = _ref9.commit,
            rootState = _ref9.rootState;

        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({ object: data.object, path: data.path, save_timestamp: true }).then(function (res) {

            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_134" /* SET_UNCOVERED_OUTDOOR_DATE_MODIFIED */], res.date_modified);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_139" /* SET_UNCOVERED_OUTDOOR_DIRTYNESS */], false);
        });
    },
    SET_UNCOVERED_OUTDOOR_DESCRIPTION: function SET_UNCOVERED_OUTDOOR_DESCRIPTION(_ref10, data) {
        var state = _ref10.state,
            commit = _ref10.commit,
            rootState = _ref10.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_140" /* SET_UNCOVERED_OUTDOOR_DESCRIPTION */], data);
    },
    /*
    SET_UNCOVERED_OUTDOOR_NETAREA: ({state, commit, rootState}, data) => {
         return new Promise((resolve, reject) => {
            api.set_value({
                value: data.netarea,
                path: 'appraisal_uncovered_outdoors' + '/' + data.appraisal_id + '/' + data.key + '/' + 'netarea',
                save_timestamp: false
            }).then((res) => {
                resolve()
             })
         })
     },
    */
    SET_UNCOVERED_OUTDOOR_TYPE: function SET_UNCOVERED_OUTDOOR_TYPE(_ref11, data) {
        var state = _ref11.state,
            commit = _ref11.commit,
            rootState = _ref11.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_141" /* SET_UNCOVERED_OUTDOOR_TYPE */], data);
    }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_137" /* RESET_UNCOVERED_OUTDOOR */], function (state) {
    state.date_created = null;
    state.date_modified = null;
    state.dirty = false;
    state.id = null;
    state.parent_path = null;
    state.path = null;
    state.description = null;
    state.netarea = null;
    state.type = null;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_138" /* SET_UNCOVERED_OUTDOOR */], function (state, data) {
    state.date_created = check_undefined(data.date_created);
    state.date_modified = check_undefined(data.date_modified);
    state.dirty = false;
    state.id = check_undefined(data.id);
    state.parent_path = check_undefined(data.parent_path);
    state.path = check_undefined(data.path);
    state.description = check_undefined(data.description);
    state.netarea = check_undefined(data.netarea);
    state.type = check_undefined(data.type);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_133" /* SET_UNCOVERED_OUTDOOR_DATE_CREATED */], function (state, data) {
    state.date_created = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_134" /* SET_UNCOVERED_OUTDOOR_DATE_MODIFIED */], function (state, data) {
    state.date_modified = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_139" /* SET_UNCOVERED_OUTDOOR_DIRTYNESS */], function (state, boolean) {
    state.dirty = boolean;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_132" /* SET_UNCOVERED_OUTDOOR_ID */], function (state, data) {
    state.id = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_142" /* SET_UNCOVERED_OUTDOOR_NETAREA */], function (state, data) {
    state.netarea = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_135" /* SET_UNCOVERED_OUTDOOR_PARENT_PATH */], function (state, data) {
    state.parent_path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_136" /* SET_UNCOVERED_OUTDOOR_PATH */], function (state, data) {
    state.path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_140" /* SET_UNCOVERED_OUTDOOR_DESCRIPTION */], function (state, data) {
    state.description = data;
    state.dirty = true;
}), _mutations);

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

var getters = {

    uncovered_outdoor: function uncovered_outdoor(state) {
        return state;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    path: null,
    name_ca: null,
    name_en: null,
    name_es: null,
    url: null,
    filename: null

};

var state = default_state;

var actions = {

    CREATE_NEW_URBANANNEX: function CREATE_NEW_URBANANNEX(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].create({ key: data.key, path: data.path }).then(function (res) {
                var new_created_key = res.key;

                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["X" /* SET_URBANANNEX_ID */], res.key);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["Y" /* SET_URBANANNEX_DATE_CREATED */], res.date_created);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["Z" /* SET_URBANANNEX_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_0" /* SET_URBANANNEX_PATH */], res.path);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_1" /* SET_URBANANNEX_PARENT_PATH */], data.parent_path);

                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                    value: res.key,
                    path: data.path + new_created_key + '/' + 'id',
                    save_timestamp: false
                }).then(function (res) {
                    return resolve({ key: new_created_key });
                });
            });
        });
    },
    DELETE_URBANANNEX: function DELETE_URBANANNEX(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;


        // console.log('DELETE_URBANANNEX path check: ' + data.path)
        // console.log('DELETE URBANANNEX parent_path check: ' + data.parent_path)

        // delete from urbanannexes/urbanannex_key
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.path }).then(function (res) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].deleteImage({ path: data.path, filename: data.filename });
        });
    },
    GET_URBANANNEX: function GET_URBANANNEX(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;


        return new Promise(function (resolve, reject) {
            return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                return resolve(res);
            });
        });
    },
    SET_URBANANNEX: function SET_URBANANNEX(_ref4, data) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;


        // console.log('set_urbanannex data:')
        // console.log(data)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_2" /* SET_URBANANNEX */], res);
        });
    },
    RESET_URBANANNEX: function RESET_URBANANNEX(_ref5) {
        var state = _ref5.state,
            commit = _ref5.commit,
            rootState = _ref5.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_3" /* RESET_URBANANNEX */]);
    },
    SET_URBANANNEX_REPORTDATE: function (_SET_URBANANNEX_REPORTDATE) {
        function SET_URBANANNEX_REPORTDATE(_x, _x2) {
            return _SET_URBANANNEX_REPORTDATE.apply(this, arguments);
        }

        SET_URBANANNEX_REPORTDATE.toString = function () {
            return _SET_URBANANNEX_REPORTDATE.toString();
        };

        return SET_URBANANNEX_REPORTDATE;
    }(function (_ref6, data) {
        var state = _ref6.state,
            commit = _ref6.commit,
            rootState = _ref6.rootState;

        commit(SET_URBANANNEX_REPORTDATE, data);
    }),
    SET_URBANANNEX_DATE_CREATED: function SET_URBANANNEX_DATE_CREATED(_ref7, data) {
        var state = _ref7.state,
            commit = _ref7.commit,
            rootState = _ref7.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["Y" /* SET_URBANANNEX_DATE_CREATED */], data);
    },
    SET_URBANANNEX_DATE_MODIFIED: function SET_URBANANNEX_DATE_MODIFIED(_ref8, data) {
        var state = _ref8.state,
            commit = _ref8.commit,
            rootState = _ref8.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["Z" /* SET_URBANANNEX_DATE_MODIFIED */], data);
    },

    SET_URBANANNEX_ID: function SET_URBANANNEX_ID(_ref9, data) {
        var state = _ref9.state,
            commit = _ref9.commit,
            rootState = _ref9.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["X" /* SET_URBANANNEX_ID */], data);
    },
    SET_URBANANNEX_PARENT_PATH: function SET_URBANANNEX_PARENT_PATH(_ref10, data) {
        var state = _ref10.state,
            commit = _ref10.commit,
            rootState = _ref10.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_1" /* SET_URBANANNEX_PARENT_PATH */], data);
    },
    SET_URBANANNEX_PATH: function SET_URBANANNEX_PATH(_ref11, data) {
        var state = _ref11.state,
            commit = _ref11.commit,
            rootState = _ref11.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_0" /* SET_URBANANNEX_PATH */], data);
    },
    UPDATE_URBANANNEX: function UPDATE_URBANANNEX(_ref12, data) {
        var state = _ref12.state,
            commit = _ref12.commit,
            rootState = _ref12.rootState;

        return new Promise(function (resolve, reject) {
            // console.log('UPDATE_URBANANNEX data:')
            // console.log(data)
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({ object: data.object, path: data.path + data.key, save_timestamp: true }).then(function (res) {

                var date_modified = res.date_modified;
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["Z" /* SET_URBANANNEX_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_4" /* SET_URBANANNEX_DIRTYNESS */], false);
                resolve();
            });
        });
    },
    SET_URBANANNEX_NAME_CA: function SET_URBANANNEX_NAME_CA(_ref13, data) {
        var state = _ref13.state,
            commit = _ref13.commit,
            rootState = _ref13.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_5" /* SET_URBANANNEX_NAME_CA */], data);
    },
    SET_URBANANNEX_NAME_EN: function SET_URBANANNEX_NAME_EN(_ref14, data) {
        var state = _ref14.state,
            commit = _ref14.commit,
            rootState = _ref14.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_6" /* SET_URBANANNEX_NAME_EN */], data);
    },
    SET_URBANANNEX_NAME_ES: function SET_URBANANNEX_NAME_ES(_ref15, data) {
        var state = _ref15.state,
            commit = _ref15.commit,
            rootState = _ref15.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_7" /* SET_URBANANNEX_NAME_ES */], data);
    },
    SET_URBANANNEX_URL: function SET_URBANANNEX_URL(_ref16, data) {
        var state = _ref16.state,
            commit = _ref16.commit,
            rootState = _ref16.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_8" /* SET_URBANANNEX_URL */], data);
    },
    SET_URBANANNEX_FILENAME: function SET_URBANANNEX_FILENAME(_ref17, data) {
        var state = _ref17.state,
            commit = _ref17.commit,
            rootState = _ref17.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_9" /* SET_URBANANNEX_FILENAME */], data);
    }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_3" /* RESET_URBANANNEX */], function (state) {
    state.date_created = null;
    state.date_modified = null;
    state.dirty = false;
    state.file_id = null;
    state.id = null;
    state.path = null;
    state.parent_path = null;
    state.name_ca = null;
    state.name_en = null;
    state.name_es = null;
    state.url = null;
    state.filename = null;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_2" /* SET_URBANANNEX */], function (state, data) {
    state.date_created = check_undefined(data.date_created);
    state.date_modified = check_undefined(data.date_modified);
    state.dirty = false;
    state.file_id = check_undefined(data.file_id);
    state.id = check_undefined(data.id);
    state.path = check_undefined(data.path);
    state.parent_path = check_undefined(data.parent_path);
    state.name_ca = check_undefined(data.name_ca);
    state.name_en = check_undefined(data.name_en);
    state.name_es = check_undefined(data.name_es);
    state.url = check_undefined(data.url);
    state.filename = check_undefined(data.filename);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["Y" /* SET_URBANANNEX_DATE_CREATED */], function (state, data) {
    state.date_created = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["Z" /* SET_URBANANNEX_DATE_MODIFIED */], function (state, data) {
    state.date_modified = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_4" /* SET_URBANANNEX_DIRTYNESS */], function (state, boolean) {
    state.dirty = boolean;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["X" /* SET_URBANANNEX_ID */], function (state, data) {
    state.id = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_1" /* SET_URBANANNEX_PARENT_PATH */], function (state, data) {
    state.parent_path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_0" /* SET_URBANANNEX_PATH */], function (state, data) {
    state.path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_5" /* SET_URBANANNEX_NAME_CA */], function (state, data) {
    state.name_ca = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_6" /* SET_URBANANNEX_NAME_EN */], function (state, data) {
    state.name_en = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_7" /* SET_URBANANNEX_NAME_ES */], function (state, data) {
    state.name_es = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_8" /* SET_URBANANNEX_URL */], function (state, data) {
    state.url = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_9" /* SET_URBANANNEX_FILENAME */], function (state, data) {
    state.filename = data;
    state.dirty = true;
}), _mutations);

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

var getters = {
    urbanannex: function urbanannex(state) {
        return state;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(6);
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var default_state = {
    date_created: null,
    date_modified: null,
    dirty: false,
    id: null,
    path: null,
    name_ca: null,
    name_en: null,
    name_es: null

};

var state = default_state;

var actions = {

    CREATE_NEW_WARNING: function CREATE_NEW_WARNING(_ref, data) {
        var state = _ref.state,
            commit = _ref.commit,
            rootState = _ref.rootState;


        return new Promise(function (resolve, reject) {
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].create({ key: data.key, path: data.path }).then(function (res) {
                var new_created_key = res.key;

                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_71" /* SET_WARNING_ID */], res.key);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_72" /* SET_WARNING_DATE_CREATED */], res.date_created);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_73" /* SET_WARNING_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_74" /* SET_WARNING_PATH */], res.path);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_75" /* SET_WARNING_PARENT_PATH */], data.parent_path);

                __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].set_value({
                    value: res.key,
                    path: data.path + new_created_key + '/' + 'id',
                    save_timestamp: false
                }).then(function (res) {
                    return resolve({ key: new_created_key });
                });
            });
        });
    },
    DELETE_WARNING: function DELETE_WARNING(_ref2, data) {
        var state = _ref2.state,
            commit = _ref2.commit,
            rootState = _ref2.rootState;


        // console.log('DELETE_WARNING path check: ' + data.path)
        // console.log('DELETE WARNING parent_path check: ' + data.parent_path)

        // delete from warnings/warning_key
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].delete({ key: data.key, path: data.path }).then(function (res) {});
    },
    GET_WARNING: function GET_WARNING(_ref3, data) {
        var state = _ref3.state,
            commit = _ref3.commit,
            rootState = _ref3.rootState;


        return new Promise(function (resolve, reject) {
            return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
                return resolve(res);
            });
        });
    },
    SET_WARNING: function SET_WARNING(_ref4, data) {
        var state = _ref4.state,
            commit = _ref4.commit,
            rootState = _ref4.rootState;


        // console.log('set_warning data:')
        // console.log(data)
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].get({ path: data.path }).then(function (res) {
            console.log(res);
            commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_76" /* SET_WARNING */], res);
        });
    },
    RESET_WARNING: function RESET_WARNING(_ref5) {
        var state = _ref5.state,
            commit = _ref5.commit,
            rootState = _ref5.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_77" /* RESET_WARNING */]);
    },
    SET_WARNING_REPORTDATE: function (_SET_WARNING_REPORTDATE) {
        function SET_WARNING_REPORTDATE(_x, _x2) {
            return _SET_WARNING_REPORTDATE.apply(this, arguments);
        }

        SET_WARNING_REPORTDATE.toString = function () {
            return _SET_WARNING_REPORTDATE.toString();
        };

        return SET_WARNING_REPORTDATE;
    }(function (_ref6, data) {
        var state = _ref6.state,
            commit = _ref6.commit,
            rootState = _ref6.rootState;

        commit(SET_WARNING_REPORTDATE, data);
    }),
    SET_WARNING_DATE_CREATED: function SET_WARNING_DATE_CREATED(_ref7, data) {
        var state = _ref7.state,
            commit = _ref7.commit,
            rootState = _ref7.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_72" /* SET_WARNING_DATE_CREATED */], data);
    },
    SET_WARNING_DATE_MODIFIED: function SET_WARNING_DATE_MODIFIED(_ref8, data) {
        var state = _ref8.state,
            commit = _ref8.commit,
            rootState = _ref8.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_73" /* SET_WARNING_DATE_MODIFIED */], data);
    },

    SET_WARNING_ID: function SET_WARNING_ID(_ref9, data) {
        var state = _ref9.state,
            commit = _ref9.commit,
            rootState = _ref9.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_71" /* SET_WARNING_ID */], data);
    },
    SET_WARNING_PARENT_PATH: function SET_WARNING_PARENT_PATH(_ref10, data) {
        var state = _ref10.state,
            commit = _ref10.commit,
            rootState = _ref10.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_75" /* SET_WARNING_PARENT_PATH */], data);
    },
    SET_WARNING_PATH: function SET_WARNING_PATH(_ref11, data) {
        var state = _ref11.state,
            commit = _ref11.commit,
            rootState = _ref11.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_74" /* SET_WARNING_PATH */], data);
    },
    UPDATE_WARNING: function UPDATE_WARNING(_ref12, data) {
        var state = _ref12.state,
            commit = _ref12.commit,
            rootState = _ref12.rootState;

        return new Promise(function (resolve, reject) {
            // console.log('UPDATE_WARNING data:')
            // console.log(data)
            __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].update({ object: data.object, path: data.path + data.key, save_timestamp: true }).then(function (res) {

                var date_modified = res.date_modified;
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_73" /* SET_WARNING_DATE_MODIFIED */], res.date_modified);
                commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_78" /* SET_WARNING_DIRTYNESS */], false);
                resolve();
            });
        });
    },
    SET_WARNING_NAME_CA: function SET_WARNING_NAME_CA(_ref13, data) {
        var state = _ref13.state,
            commit = _ref13.commit,
            rootState = _ref13.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_79" /* SET_WARNING_NAME_CA */], data);
    },
    SET_WARNING_NAME_EN: function SET_WARNING_NAME_EN(_ref14, data) {
        var state = _ref14.state,
            commit = _ref14.commit,
            rootState = _ref14.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_80" /* SET_WARNING_NAME_EN */], data);
    },
    SET_WARNING_NAME_ES: function SET_WARNING_NAME_ES(_ref15, data) {
        var state = _ref15.state,
            commit = _ref15.commit,
            rootState = _ref15.rootState;

        commit(__WEBPACK_IMPORTED_MODULE_1__constants__["_81" /* SET_WARNING_NAME_ES */], data);
    }
};

var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_77" /* RESET_WARNING */], function (state) {
    state.date_created = null;
    state.date_modified = null;
    state.dirty = false;
    state.file_id = null;
    state.id = null;
    state.path = null;
    state.parent_path = null;
    state.name_ca = null;
    state.name_en = null;
    state.name_es = null;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_76" /* SET_WARNING */], function (state, data) {
    state.date_created = check_undefined(data.date_created);
    state.date_modified = check_undefined(data.date_modified);
    state.dirty = false;
    state.file_id = check_undefined(data.file_id);
    state.id = check_undefined(data.id);
    state.path = check_undefined(data.path);
    state.parent_path = check_undefined(data.parent_path);
    state.name_ca = check_undefined(data.name_ca);
    state.name_en = check_undefined(data.name_en);
    state.name_es = check_undefined(data.name_es);
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_72" /* SET_WARNING_DATE_CREATED */], function (state, data) {
    state.date_created = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_73" /* SET_WARNING_DATE_MODIFIED */], function (state, data) {
    state.date_modified = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_78" /* SET_WARNING_DIRTYNESS */], function (state, boolean) {
    state.dirty = boolean;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_71" /* SET_WARNING_ID */], function (state, data) {
    state.id = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_75" /* SET_WARNING_PARENT_PATH */], function (state, data) {
    state.parent_path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_74" /* SET_WARNING_PATH */], function (state, data) {
    state.path = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_79" /* SET_WARNING_NAME_CA */], function (state, data) {
    state.name_ca = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_80" /* SET_WARNING_NAME_EN */], function (state, data) {
    state.name_en = data;
    state.dirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__constants__["_81" /* SET_WARNING_NAME_ES */], function (state, data) {
    state.name_es = data;
    state.dirty = true;
}), _mutations);

function check_undefined(myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar;
    } else {
        return null;
    }
}

var getters = {
    warning: function warning(state) {
        return state;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
});

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = groupBy;
/**
 * Group and array of objects by a given key
 * 
 * @export
 * @param {Array} array The array to group
 * @param {String} key The key to group the array by
 * @returns Object
 */
function groupBy(array, callback) {

    callback = callback || function (item) {
        return item;
    };

    var groups = {};

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = array[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            var value = callback.call(array, item);

            if (!groups.hasOwnProperty(value)) {
                groups[value] = [];
            }

            groups[value].push(item);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return groups;
}

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = minOf;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_aggregator__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_type_converter__ = __webpack_require__(252);



function max(accumulator, value, converter) {
    var converted = converter(value);

    return isNaN(converted) ? false : Math.max(accumulator, converted);
}

function minOf(array, callback) {

    callback = callback || function (item) {
        return item;
    };

    // Let's assume (in a perfect world) that the data type of the first item
    // is the same throughout the whole array and use the same converter
    var firstValue = callback.call(array, array[0]);
    var converter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__base_type_converter__["a" /* default */])(firstValue);

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__base_aggregator__["a" /* default */])(array, function (accumulator, item, array) {
        var value = callback.call(array, item);

        return max(accumulator, value, converter);
    }, -Infinity);
}

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = medianOf;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sort_by__ = __webpack_require__(255);


function getValue(item, callback) {
    return callback.call(this, item);
}

function medianOf(array, callback) {
    var sorted = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sort_by__["a" /* default */])(array, callback);
    var count = sorted.length;
    var half = Math.floor(count / 2);

    var primaryMedian = getValue(sorted[half], callback);

    if (count % 2) {
        return primaryMedian;
    }

    var secondaryMedian = getValue(sorted[half - 1], callback);

    return (primaryMedian + secondaryMedian) / 2;
}

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = minOf;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base_aggregator__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_type_converter__ = __webpack_require__(252);



function min(accumulator, value, converter) {
    var converted = converter(value);

    return isNaN(converted) ? false : Math.min(accumulator, converted);
}

function minOf(array, callback) {

    callback = callback || function (item) {
        return item;
    };

    // Let's assume (in a perfect world) that the data type of the first item
    // is the same throughout the whole array and use the same converter
    var firstValue = callback.call(array, array[0]);
    var converter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__base_type_converter__["a" /* default */])(firstValue);

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__base_aggregator__["a" /* default */])(array, function (accumulator, item, array) {
        var value = callback.call(array, item);

        return min(accumulator, value, converter);
    }, Infinity);
}

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = page;
function page(array, pageSize) {
    var pages = [];
    var start = 0;
    var length = array.length;

    while (start < length) {
        var end = start + pageSize;

        if (length - start < pageSize) {
            end = start + (length - start);
        }

        var _page = array.slice(start, end);

        pages.push(_page);
        start += pageSize;
    }

    return pages;
}

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = standardDeviationOf;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__variance_of__ = __webpack_require__(257);


function standardDeviationOf(array, callback) {
    var variance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__variance_of__["a" /* default */])(array, callback);

    return variance ? Math.sqrt(variance) : false;
}

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(930);

__webpack_require__(1230);

__webpack_require__(731);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(738);
module.exports = __webpack_require__(56).RegExp.escape;


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(30);
var isArray = __webpack_require__(129);
var SPECIES = __webpack_require__(32)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(29);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(24);
var toPrimitive = __webpack_require__(60);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(83);
var gOPS = __webpack_require__(133);
var pIE = __webpack_require__(105);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 736 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 737 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(2);
var $re = __webpack_require__(736)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(2);

$export($export.P, 'Array', { copyWithin: __webpack_require__(259) });

__webpack_require__(71)('copyWithin');


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $every = __webpack_require__(55)(4);

$export($export.P + $export.F * !__webpack_require__(51)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(2);

$export($export.P, 'Array', { fill: __webpack_require__(170) });

__webpack_require__(71)('fill');


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $filter = __webpack_require__(55)(2);

$export($export.P + $export.F * !__webpack_require__(51)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(2);
var $find = __webpack_require__(55)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(71)(KEY);


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(2);
var $find = __webpack_require__(55)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(71)(KEY);


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $forEach = __webpack_require__(55)(0);
var STRICT = __webpack_require__(51)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(50);
var $export = __webpack_require__(2);
var toObject = __webpack_require__(37);
var call = __webpack_require__(270);
var isArrayIter = __webpack_require__(178);
var toLength = __webpack_require__(36);
var createProperty = __webpack_require__(172);
var getIterFn = __webpack_require__(194);

$export($export.S + $export.F * !__webpack_require__(131)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $indexOf = __webpack_require__(125)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(51)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(2);

$export($export.S, 'Array', { isArray: __webpack_require__(129) });


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(2);
var toIObject = __webpack_require__(47);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(104) != Object || !__webpack_require__(51)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toIObject = __webpack_require__(47);
var toInteger = __webpack_require__(59);
var toLength = __webpack_require__(36);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(51)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $map = __webpack_require__(55)(1);

$export($export.P + $export.F * !__webpack_require__(51)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var createProperty = __webpack_require__(172);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(29)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $reduce = __webpack_require__(261);

$export($export.P + $export.F * !__webpack_require__(51)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $reduce = __webpack_require__(261);

$export($export.P + $export.F * !__webpack_require__(51)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var html = __webpack_require__(176);
var cof = __webpack_require__(49);
var toAbsoluteIndex = __webpack_require__(87);
var toLength = __webpack_require__(36);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(29)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $some = __webpack_require__(55)(3);

$export($export.P + $export.F * !__webpack_require__(51)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var aFunction = __webpack_require__(39);
var toObject = __webpack_require__(37);
var fails = __webpack_require__(29);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(51)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(86)('Array');


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(2);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(2);
var toISOString = __webpack_require__(733);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toObject = __webpack_require__(37);
var toPrimitive = __webpack_require__(60);

$export($export.P + $export.F * __webpack_require__(29)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(32)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(42)(proto, TO_PRIMITIVE, __webpack_require__(734));


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(43)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(2);

$export($export.P, 'Function', { bind: __webpack_require__(262) });


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(30);
var getPrototypeOf = __webpack_require__(46);
var HAS_INSTANCE = __webpack_require__(32)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(35).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(35).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(34) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(2);
var log1p = __webpack_require__(273);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(2);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(2);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(2);
var sign = __webpack_require__(182);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(2);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(2);
var $expm1 = __webpack_require__(181);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', { fround: __webpack_require__(272) });


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(2);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(2);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(29)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', { log1p: __webpack_require__(273) });


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', { sign: __webpack_require__(182) });


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(2);
var expm1 = __webpack_require__(181);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(29)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(2);
var expm1 = __webpack_require__(181);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(26);
var has = __webpack_require__(41);
var cof = __webpack_require__(49);
var inheritIfRequired = __webpack_require__(177);
var toPrimitive = __webpack_require__(60);
var fails = __webpack_require__(29);
var gOPN = __webpack_require__(82).f;
var gOPD = __webpack_require__(45).f;
var dP = __webpack_require__(35).f;
var $trim = __webpack_require__(95).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(81)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(34) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(43)(global, NUMBER, $Number);
}


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(2);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(2);
var _isFinite = __webpack_require__(26).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(2);

$export($export.S, 'Number', { isInteger: __webpack_require__(269) });


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(2);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(2);
var isInteger = __webpack_require__(269);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(2);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(2);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var $parseFloat = __webpack_require__(281);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var $parseInt = __webpack_require__(282);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toInteger = __webpack_require__(59);
var aNumberValue = __webpack_require__(258);
var repeat = __webpack_require__(189);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(29)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $fails = __webpack_require__(29);
var aNumberValue = __webpack_require__(258);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(2);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(275) });


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(81) });


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(34), 'Object', { defineProperties: __webpack_require__(276) });


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(34), 'Object', { defineProperty: __webpack_require__(35).f });


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(30);
var meta = __webpack_require__(72).onFreeze;

__webpack_require__(58)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(47);
var $getOwnPropertyDescriptor = __webpack_require__(45).f;

__webpack_require__(58)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(58)('getOwnPropertyNames', function () {
  return __webpack_require__(277).f;
});


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(37);
var $getPrototypeOf = __webpack_require__(46);

__webpack_require__(58)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(30);

__webpack_require__(58)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(30);

__webpack_require__(58)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(30);

__webpack_require__(58)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(2);
$export($export.S, 'Object', { is: __webpack_require__(737) });


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(37);
var $keys = __webpack_require__(83);

__webpack_require__(58)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(30);
var meta = __webpack_require__(72).onFreeze;

__webpack_require__(58)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(30);
var meta = __webpack_require__(72).onFreeze;

__webpack_require__(58)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(2);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(185).set });


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(103);
var test = {};
test[__webpack_require__(32)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(43)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var $parseFloat = __webpack_require__(281);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var $parseInt = __webpack_require__(282);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(80);
var global = __webpack_require__(26);
var ctx = __webpack_require__(50);
var classof = __webpack_require__(103);
var $export = __webpack_require__(2);
var isObject = __webpack_require__(30);
var aFunction = __webpack_require__(39);
var anInstance = __webpack_require__(78);
var forOf = __webpack_require__(79);
var speciesConstructor = __webpack_require__(137);
var task = __webpack_require__(191).set;
var microtask = __webpack_require__(183)();
var newPromiseCapabilityModule = __webpack_require__(184);
var perform = __webpack_require__(283);
var promiseResolve = __webpack_require__(284);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(32)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  if (promise._h == 1) return false;
  var chain = promise._a || promise._c;
  var i = 0;
  var reaction;
  while (chain.length > i) {
    reaction = chain[i++];
    if (reaction.fail || !isUnhandled(reaction.promise)) return false;
  } return true;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(85)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(94)($Promise, PROMISE);
__webpack_require__(86)(PROMISE);
Wrapper = __webpack_require__(56)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(131)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(2);
var aFunction = __webpack_require__(39);
var anObject = __webpack_require__(24);
var rApply = (__webpack_require__(26).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(29)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(2);
var create = __webpack_require__(81);
var aFunction = __webpack_require__(39);
var anObject = __webpack_require__(24);
var isObject = __webpack_require__(30);
var fails = __webpack_require__(29);
var bind = __webpack_require__(262);
var rConstruct = (__webpack_require__(26).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(35);
var $export = __webpack_require__(2);
var anObject = __webpack_require__(24);
var toPrimitive = __webpack_require__(60);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(29)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(2);
var gOPD = __webpack_require__(45).f;
var anObject = __webpack_require__(24);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(2);
var anObject = __webpack_require__(24);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(179)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(45);
var $export = __webpack_require__(2);
var anObject = __webpack_require__(24);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(2);
var getProto = __webpack_require__(46);
var anObject = __webpack_require__(24);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(45);
var getPrototypeOf = __webpack_require__(46);
var has = __webpack_require__(41);
var $export = __webpack_require__(2);
var isObject = __webpack_require__(30);
var anObject = __webpack_require__(24);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(2);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(2);
var anObject = __webpack_require__(24);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(2);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(280) });


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(2);
var anObject = __webpack_require__(24);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(2);
var setProto = __webpack_require__(185);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(35);
var gOPD = __webpack_require__(45);
var getPrototypeOf = __webpack_require__(46);
var has = __webpack_require__(41);
var $export = __webpack_require__(2);
var createDesc = __webpack_require__(84);
var anObject = __webpack_require__(24);
var isObject = __webpack_require__(30);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
    existingDescriptor.value = V;
    dP.f(receiver, propertyKey, existingDescriptor);
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(26);
var inheritIfRequired = __webpack_require__(177);
var dP = __webpack_require__(35).f;
var gOPN = __webpack_require__(82).f;
var isRegExp = __webpack_require__(130);
var $flags = __webpack_require__(128);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(34) && (!CORRECT_NEW || __webpack_require__(29)(function () {
  re2[__webpack_require__(32)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(43)(global, 'RegExp', $RegExp);
}

__webpack_require__(86)('RegExp');


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

// @@match logic
__webpack_require__(127)('match', 1, function (defined, MATCH, $match) {
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

// @@replace logic
__webpack_require__(127)('replace', 2, function (defined, REPLACE, $replace) {
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue) {
    'use strict';
    var O = defined(this);
    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

// @@search logic
__webpack_require__(127)('search', 1, function (defined, SEARCH, $search) {
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

// @@split logic
__webpack_require__(127)('split', 2, function (defined, SPLIT, $split) {
  'use strict';
  var isRegExp = __webpack_require__(130);
  var _split = $split;
  var $push = [].push;
  var $SPLIT = 'split';
  var LENGTH = 'length';
  var LAST_INDEX = 'lastIndex';
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while (match = separatorCopy.exec(string)) {
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          // eslint-disable-next-line no-loop-func
          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
          });
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    $split = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit) {
    var O = defined(this);
    var fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(289);
var anObject = __webpack_require__(24);
var $flags = __webpack_require__(128);
var DESCRIPTORS = __webpack_require__(34);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(43)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(29)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(44)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(44)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(44)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(44)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $at = __webpack_require__(187)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(2);
var toLength = __webpack_require__(36);
var context = __webpack_require__(188);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(175)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(44)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(44)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(44)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var toAbsoluteIndex = __webpack_require__(87);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(2);
var context = __webpack_require__(188);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(175)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(44)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(187)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(180)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(44)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var toIObject = __webpack_require__(47);
var toLength = __webpack_require__(36);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(189)
});


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(44)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(2);
var toLength = __webpack_require__(36);
var context = __webpack_require__(188);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(175)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(44)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(44)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(44)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(95)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(26);
var has = __webpack_require__(41);
var DESCRIPTORS = __webpack_require__(34);
var $export = __webpack_require__(2);
var redefine = __webpack_require__(43);
var META = __webpack_require__(72).KEY;
var $fails = __webpack_require__(29);
var shared = __webpack_require__(136);
var setToStringTag = __webpack_require__(94);
var uid = __webpack_require__(88);
var wks = __webpack_require__(32);
var wksExt = __webpack_require__(287);
var wksDefine = __webpack_require__(193);
var enumKeys = __webpack_require__(735);
var isArray = __webpack_require__(129);
var anObject = __webpack_require__(24);
var toIObject = __webpack_require__(47);
var toPrimitive = __webpack_require__(60);
var createDesc = __webpack_require__(84);
var _create = __webpack_require__(81);
var gOPNExt = __webpack_require__(277);
var $GOPD = __webpack_require__(45);
var $DP = __webpack_require__(35);
var $keys = __webpack_require__(83);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(82).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(105).f = $propertyIsEnumerable;
  __webpack_require__(133).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(80)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    replacer = args[1];
    if (typeof replacer == 'function') $replacer = replacer;
    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
      if ($replacer) value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(42)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var $typed = __webpack_require__(138);
var buffer = __webpack_require__(192);
var anObject = __webpack_require__(24);
var toAbsoluteIndex = __webpack_require__(87);
var toLength = __webpack_require__(36);
var isObject = __webpack_require__(30);
var ArrayBuffer = __webpack_require__(26).ArrayBuffer;
var speciesConstructor = __webpack_require__(137);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(29)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var final = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < final) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(86)(ARRAY_BUFFER);


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
$export($export.G + $export.W + $export.F * !__webpack_require__(138).ABV, {
  DataView: __webpack_require__(192).DataView
});


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(68)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(68)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(68)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(68)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(68)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(68)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(68)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(68)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(68)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(265);
var validate = __webpack_require__(96);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(126)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(2);
var flattenIntoArray = __webpack_require__(266);
var toObject = __webpack_require__(37);
var toLength = __webpack_require__(36);
var aFunction = __webpack_require__(39);
var arraySpeciesCreate = __webpack_require__(171);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(71)('flatMap');


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(2);
var flattenIntoArray = __webpack_require__(266);
var toObject = __webpack_require__(37);
var toLength = __webpack_require__(36);
var toInteger = __webpack_require__(59);
var arraySpeciesCreate = __webpack_require__(171);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(71)('flatten');


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(2);
var $includes = __webpack_require__(125)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(71)('includes');


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(2);
var microtask = __webpack_require__(183)();
var process = __webpack_require__(26).process;
var isNode = __webpack_require__(49)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(2);
var cof = __webpack_require__(49);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(2);

$export($export.G, { global: __webpack_require__(26) });


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(134)('Map');


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(135)('Map');


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(2);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(264)('Map') });


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(2);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(2);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(2);
var scale = __webpack_require__(274);
var fround = __webpack_require__(272);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(2);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(2);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(2);

$export($export.S, 'Math', { scale: __webpack_require__(274) });


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(2);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(2);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toObject = __webpack_require__(37);
var aFunction = __webpack_require__(39);
var $defineProperty = __webpack_require__(35);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(34) && $export($export.P + __webpack_require__(132), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toObject = __webpack_require__(37);
var aFunction = __webpack_require__(39);
var $defineProperty = __webpack_require__(35);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(34) && $export($export.P + __webpack_require__(132), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(2);
var $entries = __webpack_require__(279)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(2);
var ownKeys = __webpack_require__(280);
var toIObject = __webpack_require__(47);
var gOPD = __webpack_require__(45);
var createProperty = __webpack_require__(172);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toObject = __webpack_require__(37);
var toPrimitive = __webpack_require__(60);
var getPrototypeOf = __webpack_require__(46);
var getOwnPropertyDescriptor = __webpack_require__(45).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(34) && $export($export.P + __webpack_require__(132), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(2);
var toObject = __webpack_require__(37);
var toPrimitive = __webpack_require__(60);
var getPrototypeOf = __webpack_require__(46);
var getOwnPropertyDescriptor = __webpack_require__(45).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(34) && $export($export.P + __webpack_require__(132), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(2);
var $values = __webpack_require__(279)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(2);
var global = __webpack_require__(26);
var core = __webpack_require__(56);
var microtask = __webpack_require__(183)();
var OBSERVABLE = __webpack_require__(32)('observable');
var aFunction = __webpack_require__(39);
var anObject = __webpack_require__(24);
var anInstance = __webpack_require__(78);
var redefineAll = __webpack_require__(85);
var hide = __webpack_require__(42);
var forOf = __webpack_require__(79);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(86)('Observable');


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(2);
var core = __webpack_require__(56);
var global = __webpack_require__(26);
var speciesConstructor = __webpack_require__(137);
var promiseResolve = __webpack_require__(284);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(2);
var newPromiseCapability = __webpack_require__(184);
var perform = __webpack_require__(283);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(67);
var anObject = __webpack_require__(24);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(67);
var anObject = __webpack_require__(24);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(290);
var from = __webpack_require__(260);
var metadata = __webpack_require__(67);
var anObject = __webpack_require__(24);
var getPrototypeOf = __webpack_require__(46);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(67);
var anObject = __webpack_require__(24);
var getPrototypeOf = __webpack_require__(46);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(67);
var anObject = __webpack_require__(24);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(67);
var anObject = __webpack_require__(24);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(67);
var anObject = __webpack_require__(24);
var getPrototypeOf = __webpack_require__(46);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(67);
var anObject = __webpack_require__(24);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(67);
var anObject = __webpack_require__(24);
var aFunction = __webpack_require__(39);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(134)('Set');


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(135)('Set');


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(2);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(264)('Set') });


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(2);
var $at = __webpack_require__(187)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(2);
var defined = __webpack_require__(57);
var toLength = __webpack_require__(36);
var isRegExp = __webpack_require__(130);
var getFlags = __webpack_require__(128);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(179)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(2);
var $pad = __webpack_require__(285);

$export($export.P, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(2);
var $pad = __webpack_require__(285);

$export($export.P, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(95)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(95)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(193)('asyncIterator');


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(193)('observable');


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(2);

$export($export.S, 'System', { global: __webpack_require__(26) });


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(134)('WeakMap');


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(135)('WeakMap');


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(134)('WeakSet');


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(135)('WeakSet');


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(195);
var getKeys = __webpack_require__(83);
var redefine = __webpack_require__(43);
var global = __webpack_require__(26);
var hide = __webpack_require__(42);
var Iterators = __webpack_require__(93);
var wks = __webpack_require__(32);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(2);
var $task = __webpack_require__(191);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(26);
var $export = __webpack_require__(2);
var navigator = global.navigator;
var slice = [].slice;
var MSIE = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(858);
__webpack_require__(797);
__webpack_require__(799);
__webpack_require__(798);
__webpack_require__(801);
__webpack_require__(803);
__webpack_require__(808);
__webpack_require__(802);
__webpack_require__(800);
__webpack_require__(810);
__webpack_require__(809);
__webpack_require__(805);
__webpack_require__(806);
__webpack_require__(804);
__webpack_require__(796);
__webpack_require__(807);
__webpack_require__(811);
__webpack_require__(812);
__webpack_require__(764);
__webpack_require__(766);
__webpack_require__(765);
__webpack_require__(814);
__webpack_require__(813);
__webpack_require__(784);
__webpack_require__(794);
__webpack_require__(795);
__webpack_require__(785);
__webpack_require__(786);
__webpack_require__(787);
__webpack_require__(788);
__webpack_require__(789);
__webpack_require__(790);
__webpack_require__(791);
__webpack_require__(792);
__webpack_require__(793);
__webpack_require__(767);
__webpack_require__(768);
__webpack_require__(769);
__webpack_require__(770);
__webpack_require__(771);
__webpack_require__(772);
__webpack_require__(773);
__webpack_require__(774);
__webpack_require__(775);
__webpack_require__(776);
__webpack_require__(777);
__webpack_require__(778);
__webpack_require__(779);
__webpack_require__(780);
__webpack_require__(781);
__webpack_require__(782);
__webpack_require__(783);
__webpack_require__(845);
__webpack_require__(850);
__webpack_require__(857);
__webpack_require__(848);
__webpack_require__(840);
__webpack_require__(841);
__webpack_require__(846);
__webpack_require__(851);
__webpack_require__(853);
__webpack_require__(836);
__webpack_require__(837);
__webpack_require__(838);
__webpack_require__(839);
__webpack_require__(842);
__webpack_require__(843);
__webpack_require__(844);
__webpack_require__(847);
__webpack_require__(849);
__webpack_require__(852);
__webpack_require__(854);
__webpack_require__(855);
__webpack_require__(856);
__webpack_require__(759);
__webpack_require__(761);
__webpack_require__(760);
__webpack_require__(763);
__webpack_require__(762);
__webpack_require__(748);
__webpack_require__(746);
__webpack_require__(752);
__webpack_require__(749);
__webpack_require__(755);
__webpack_require__(757);
__webpack_require__(745);
__webpack_require__(751);
__webpack_require__(742);
__webpack_require__(756);
__webpack_require__(740);
__webpack_require__(754);
__webpack_require__(753);
__webpack_require__(747);
__webpack_require__(750);
__webpack_require__(739);
__webpack_require__(741);
__webpack_require__(744);
__webpack_require__(743);
__webpack_require__(758);
__webpack_require__(195);
__webpack_require__(830);
__webpack_require__(835);
__webpack_require__(289);
__webpack_require__(831);
__webpack_require__(832);
__webpack_require__(833);
__webpack_require__(834);
__webpack_require__(815);
__webpack_require__(288);
__webpack_require__(290);
__webpack_require__(291);
__webpack_require__(870);
__webpack_require__(859);
__webpack_require__(860);
__webpack_require__(865);
__webpack_require__(868);
__webpack_require__(869);
__webpack_require__(863);
__webpack_require__(866);
__webpack_require__(864);
__webpack_require__(867);
__webpack_require__(861);
__webpack_require__(862);
__webpack_require__(816);
__webpack_require__(817);
__webpack_require__(818);
__webpack_require__(819);
__webpack_require__(820);
__webpack_require__(823);
__webpack_require__(821);
__webpack_require__(822);
__webpack_require__(824);
__webpack_require__(825);
__webpack_require__(826);
__webpack_require__(827);
__webpack_require__(829);
__webpack_require__(828);
__webpack_require__(873);
__webpack_require__(871);
__webpack_require__(872);
__webpack_require__(914);
__webpack_require__(917);
__webpack_require__(916);
__webpack_require__(918);
__webpack_require__(919);
__webpack_require__(915);
__webpack_require__(920);
__webpack_require__(921);
__webpack_require__(895);
__webpack_require__(898);
__webpack_require__(894);
__webpack_require__(892);
__webpack_require__(893);
__webpack_require__(896);
__webpack_require__(897);
__webpack_require__(879);
__webpack_require__(913);
__webpack_require__(878);
__webpack_require__(912);
__webpack_require__(924);
__webpack_require__(926);
__webpack_require__(877);
__webpack_require__(911);
__webpack_require__(923);
__webpack_require__(925);
__webpack_require__(876);
__webpack_require__(922);
__webpack_require__(875);
__webpack_require__(880);
__webpack_require__(881);
__webpack_require__(882);
__webpack_require__(883);
__webpack_require__(884);
__webpack_require__(886);
__webpack_require__(885);
__webpack_require__(887);
__webpack_require__(888);
__webpack_require__(889);
__webpack_require__(891);
__webpack_require__(890);
__webpack_require__(900);
__webpack_require__(901);
__webpack_require__(902);
__webpack_require__(903);
__webpack_require__(905);
__webpack_require__(904);
__webpack_require__(907);
__webpack_require__(906);
__webpack_require__(908);
__webpack_require__(909);
__webpack_require__(910);
__webpack_require__(874);
__webpack_require__(899);
__webpack_require__(929);
__webpack_require__(928);
__webpack_require__(927);
module.exports = __webpack_require__(56);


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, __webpack_require__(1231)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports !== "undefined") {
        factory(module, require('select'));
    } else {
        var mod = {
            exports: {}
        };
        factory(mod, global.select);
        global.clipboardAction = mod.exports;
    }
})(this, function (module, _select) {
    'use strict';

    var _select2 = _interopRequireDefault(_select);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    var ClipboardAction = function () {
        /**
         * @param {Object} options
         */
        function ClipboardAction(options) {
            _classCallCheck(this, ClipboardAction);

            this.resolveOptions(options);
            this.initSelection();
        }

        /**
         * Defines base properties passed from constructor.
         * @param {Object} options
         */


        _createClass(ClipboardAction, [{
            key: 'resolveOptions',
            value: function resolveOptions() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                this.action = options.action;
                this.container = options.container;
                this.emitter = options.emitter;
                this.target = options.target;
                this.text = options.text;
                this.trigger = options.trigger;

                this.selectedText = '';
            }
        }, {
            key: 'initSelection',
            value: function initSelection() {
                if (this.text) {
                    this.selectFake();
                } else if (this.target) {
                    this.selectTarget();
                }
            }
        }, {
            key: 'selectFake',
            value: function selectFake() {
                var _this = this;

                var isRTL = document.documentElement.getAttribute('dir') == 'rtl';

                this.removeFake();

                this.fakeHandlerCallback = function () {
                    return _this.removeFake();
                };
                this.fakeHandler = this.container.addEventListener('click', this.fakeHandlerCallback) || true;

                this.fakeElem = document.createElement('textarea');
                // Prevent zooming on iOS
                this.fakeElem.style.fontSize = '12pt';
                // Reset box model
                this.fakeElem.style.border = '0';
                this.fakeElem.style.padding = '0';
                this.fakeElem.style.margin = '0';
                // Move element out of screen horizontally
                this.fakeElem.style.position = 'absolute';
                this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
                // Move element to the same position vertically
                var yPosition = window.pageYOffset || document.documentElement.scrollTop;
                this.fakeElem.style.top = yPosition + 'px';

                this.fakeElem.setAttribute('readonly', '');
                this.fakeElem.value = this.text;

                this.container.appendChild(this.fakeElem);

                this.selectedText = (0, _select2.default)(this.fakeElem);
                this.copyText();
            }
        }, {
            key: 'removeFake',
            value: function removeFake() {
                if (this.fakeHandler) {
                    this.container.removeEventListener('click', this.fakeHandlerCallback);
                    this.fakeHandler = null;
                    this.fakeHandlerCallback = null;
                }

                if (this.fakeElem) {
                    this.container.removeChild(this.fakeElem);
                    this.fakeElem = null;
                }
            }
        }, {
            key: 'selectTarget',
            value: function selectTarget() {
                this.selectedText = (0, _select2.default)(this.target);
                this.copyText();
            }
        }, {
            key: 'copyText',
            value: function copyText() {
                var succeeded = void 0;

                try {
                    succeeded = document.execCommand(this.action);
                } catch (err) {
                    succeeded = false;
                }

                this.handleResult(succeeded);
            }
        }, {
            key: 'handleResult',
            value: function handleResult(succeeded) {
                this.emitter.emit(succeeded ? 'success' : 'error', {
                    action: this.action,
                    text: this.selectedText,
                    trigger: this.trigger,
                    clearSelection: this.clearSelection.bind(this)
                });
            }
        }, {
            key: 'clearSelection',
            value: function clearSelection() {
                if (this.trigger) {
                    this.trigger.focus();
                }

                window.getSelection().removeAllRanges();
            }
        }, {
            key: 'destroy',
            value: function destroy() {
                this.removeFake();
            }
        }, {
            key: 'action',
            set: function set() {
                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';

                this._action = action;

                if (this._action !== 'copy' && this._action !== 'cut') {
                    throw new Error('Invalid "action" value, use either "copy" or "cut"');
                }
            },
            get: function get() {
                return this._action;
            }
        }, {
            key: 'target',
            set: function set(target) {
                if (target !== undefined) {
                    if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
                        if (this.action === 'copy' && target.hasAttribute('disabled')) {
                            throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                        }

                        if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
                            throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                        }

                        this._target = target;
                    } else {
                        throw new Error('Invalid "target" value, use a valid Element');
                    }
                }
            },
            get: function get() {
                return this._target;
            }
        }]);

        return ClipboardAction;
    }();

    module.exports = ClipboardAction;
});

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)();
// imports


// module
exports.push([module.i, ".swiper-container{margin-left:auto;margin-right:auto;position:relative;overflow:hidden;z-index:1}.swiper-container-no-flexbox .swiper-slide{float:left}.swiper-container-vertical>.swiper-wrapper{-webkit-box-orient:vertical;-ms-flex-direction:column;flex-direction:column}.swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:-webkit-box;display:-ms-flexbox;display:flex;transition-property:transform;box-sizing:content-box}.swiper-container-android .swiper-slide,.swiper-wrapper{-webkit-transform:translateZ(0);transform:translateZ(0)}.swiper-container-multirow>.swiper-wrapper{-webkit-box-lines:multiple;-moz-box-lines:multiple;-ms-flex-wrap:wrap;flex-wrap:wrap}.swiper-container-free-mode>.swiper-wrapper{transition-timing-function:ease-out;margin:0 auto}.swiper-slide{-webkit-flex-shrink:0;-ms-flex:0 0 auto;flex-shrink:0;width:100%;height:100%;position:relative}.swiper-container-autoheight,.swiper-container-autoheight .swiper-slide{height:auto}.swiper-container-autoheight .swiper-wrapper{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;transition-property:transform,height}.swiper-container .swiper-notification{position:absolute;left:0;top:0;pointer-events:none;opacity:0;z-index:-1000}.swiper-wp8-horizontal{-ms-touch-action:pan-y;touch-action:pan-y}.swiper-wp8-vertical{-ms-touch-action:pan-x;touch-action:pan-x}.swiper-button-next,.swiper-button-prev{position:absolute;top:50%;width:27px;height:44px;margin-top:-22px;z-index:10;cursor:pointer;background-size:27px 44px;background-position:50%;background-repeat:no-repeat}.swiper-button-next.swiper-button-disabled,.swiper-button-prev.swiper-button-disabled{opacity:.35;cursor:auto;pointer-events:none}.swiper-button-prev,.swiper-container-rtl .swiper-button-next{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M0 22L22 0l2.1 2.1L4.2 22l19.9 19.9L22 44 0 22z' fill='%23007aff'/%3E%3C/svg%3E\");left:10px;right:auto}.swiper-button-prev.swiper-button-black,.swiper-container-rtl .swiper-button-next.swiper-button-black{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M0 22L22 0l2.1 2.1L4.2 22l19.9 19.9L22 44 0 22z'/%3E%3C/svg%3E\")}.swiper-button-prev.swiper-button-white,.swiper-container-rtl .swiper-button-next.swiper-button-white{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M0 22L22 0l2.1 2.1L4.2 22l19.9 19.9L22 44 0 22z' fill='%23fff'/%3E%3C/svg%3E\")}.swiper-button-next,.swiper-container-rtl .swiper-button-prev{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M27 22L5 44l-2.1-2.1L22.8 22 2.9 2.1 5 0l22 22z' fill='%23007aff'/%3E%3C/svg%3E\");right:10px;left:auto}.swiper-button-next.swiper-button-black,.swiper-container-rtl .swiper-button-prev.swiper-button-black{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M27 22L5 44l-2.1-2.1L22.8 22 2.9 2.1 5 0l22 22z'/%3E%3C/svg%3E\")}.swiper-button-next.swiper-button-white,.swiper-container-rtl .swiper-button-prev.swiper-button-white{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M27 22L5 44l-2.1-2.1L22.8 22 2.9 2.1 5 0l22 22z' fill='%23fff'/%3E%3C/svg%3E\")}.swiper-pagination{position:absolute;text-align:center;transition:.3s;-webkit-transform:translateZ(0);transform:translateZ(0);z-index:10}.swiper-pagination.swiper-pagination-hidden{opacity:0}.swiper-container-horizontal>.swiper-pagination-bullets,.swiper-pagination-custom,.swiper-pagination-fraction{bottom:10px;left:0;width:100%}.swiper-pagination-bullet{width:8px;height:8px;display:inline-block;border-radius:100%;background:#000;opacity:.2}button.swiper-pagination-bullet{border:none;margin:0;padding:0;box-shadow:none;-moz-appearance:none;-ms-appearance:none;-webkit-appearance:none;appearance:none}.swiper-pagination-clickable .swiper-pagination-bullet{cursor:pointer}.swiper-pagination-white .swiper-pagination-bullet{background:#fff}.swiper-pagination-bullet-active{opacity:1;background:#007aff}.swiper-pagination-white .swiper-pagination-bullet-active{background:#fff}.swiper-pagination-black .swiper-pagination-bullet-active{background:#000}.swiper-container-vertical>.swiper-pagination-bullets{right:10px;top:50%;-webkit-transform:translate3d(0,-50%,0);transform:translate3d(0,-50%,0)}.swiper-container-vertical>.swiper-pagination-bullets .swiper-pagination-bullet{margin:5px 0;display:block}.swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet{margin:0 5px}.swiper-pagination-progress{background:rgba(0,0,0,.25);position:absolute}.swiper-pagination-progress .swiper-pagination-progressbar{background:#007aff;position:absolute;left:0;top:0;width:100%;height:100%;-webkit-transform:scale(0);transform:scale(0);-webkit-transform-origin:left top;transform-origin:left top}.swiper-container-rtl .swiper-pagination-progress .swiper-pagination-progressbar{-webkit-transform-origin:right top;transform-origin:right top}.swiper-container-horizontal>.swiper-pagination-progress{width:100%;height:4px;left:0;top:0}.swiper-container-vertical>.swiper-pagination-progress{width:4px;height:100%;left:0;top:0}.swiper-pagination-progress.swiper-pagination-white{background:hsla(0,0%,100%,.5)}.swiper-pagination-progress.swiper-pagination-white .swiper-pagination-progressbar{background:#fff}.swiper-pagination-progress.swiper-pagination-black .swiper-pagination-progressbar{background:#000}.swiper-container-3d{-webkit-perspective:1200px;-o-perspective:1200px;perspective:1200px}.swiper-container-3d .swiper-cube-shadow,.swiper-container-3d .swiper-slide,.swiper-container-3d .swiper-slide-shadow-bottom,.swiper-container-3d .swiper-slide-shadow-left,.swiper-container-3d .swiper-slide-shadow-right,.swiper-container-3d .swiper-slide-shadow-top,.swiper-container-3d .swiper-wrapper{-webkit-transform-style:preserve-3d;transform-style:preserve-3d}.swiper-container-3d .swiper-slide-shadow-bottom,.swiper-container-3d .swiper-slide-shadow-left,.swiper-container-3d .swiper-slide-shadow-right,.swiper-container-3d .swiper-slide-shadow-top{position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:10}.swiper-container-3d .swiper-slide-shadow-left{background-image:linear-gradient(270deg,rgba(0,0,0,.5),transparent)}.swiper-container-3d .swiper-slide-shadow-right{background-image:linear-gradient(90deg,rgba(0,0,0,.5),transparent)}.swiper-container-3d .swiper-slide-shadow-top{background-image:linear-gradient(0deg,rgba(0,0,0,.5),transparent)}.swiper-container-3d .swiper-slide-shadow-bottom{background-image:linear-gradient(180deg,rgba(0,0,0,.5),transparent)}.swiper-container-coverflow .swiper-wrapper,.swiper-container-flip .swiper-wrapper{-ms-perspective:1200px}.swiper-container-cube,.swiper-container-flip{overflow:visible}.swiper-container-cube .swiper-slide,.swiper-container-flip .swiper-slide{pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1}.swiper-container-cube .swiper-slide .swiper-slide,.swiper-container-flip .swiper-slide .swiper-slide{pointer-events:none}.swiper-container-cube .swiper-slide-active,.swiper-container-cube .swiper-slide-active .swiper-slide-active,.swiper-container-flip .swiper-slide-active,.swiper-container-flip .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper-container-cube .swiper-slide-shadow-bottom,.swiper-container-cube .swiper-slide-shadow-left,.swiper-container-cube .swiper-slide-shadow-right,.swiper-container-cube .swiper-slide-shadow-top,.swiper-container-flip .swiper-slide-shadow-bottom,.swiper-container-flip .swiper-slide-shadow-left,.swiper-container-flip .swiper-slide-shadow-right,.swiper-container-flip .swiper-slide-shadow-top{z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}.swiper-container-cube .swiper-slide{visibility:hidden;-webkit-transform-origin:0 0;transform-origin:0 0;width:100%;height:100%}.swiper-container-cube.swiper-container-rtl .swiper-slide{-webkit-transform-origin:100% 0;transform-origin:100% 0}.swiper-container-cube .swiper-slide-active,.swiper-container-cube .swiper-slide-next,.swiper-container-cube .swiper-slide-next+.swiper-slide,.swiper-container-cube .swiper-slide-prev{pointer-events:auto;visibility:visible}.swiper-container-cube .swiper-cube-shadow{position:absolute;left:0;bottom:0;width:100%;height:100%;background:#000;opacity:.6;-webkit-filter:blur(50px);filter:blur(50px);z-index:0}.swiper-container-fade.swiper-container-free-mode .swiper-slide{transition-timing-function:ease-out}.swiper-container-fade .swiper-slide{pointer-events:none;transition-property:opacity}.swiper-container-fade .swiper-slide .swiper-slide{pointer-events:none}.swiper-container-fade .swiper-slide-active,.swiper-container-fade .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper-zoom-container{width:100%;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-align:center}.swiper-zoom-container>canvas,.swiper-zoom-container>img,.swiper-zoom-container>svg{max-width:100%;max-height:100%;object-fit:contain}.swiper-scrollbar{border-radius:10px;position:relative;-ms-touch-action:none;background:rgba(0,0,0,.1)}.swiper-container-horizontal>.swiper-scrollbar{position:absolute;left:1%;bottom:3px;z-index:50;height:5px;width:98%}.swiper-container-vertical>.swiper-scrollbar{position:absolute;right:3px;top:1%;z-index:50;width:5px;height:98%}.swiper-scrollbar-drag{height:100%;width:100%;position:relative;background:rgba(0,0,0,.5);border-radius:10px;left:0;top:0}.swiper-scrollbar-cursor-drag{cursor:move}.swiper-lazy-preloader{width:42px;height:42px;position:absolute;left:50%;top:50%;margin-left:-21px;margin-top:-21px;z-index:10;-webkit-transform-origin:50%;transform-origin:50%;-webkit-animation:swiper-preloader-spin 1s steps(12) infinite;animation:swiper-preloader-spin 1s steps(12) infinite}.swiper-lazy-preloader:after{display:block;content:\"\";width:100%;height:100%;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath id='a' stroke='%236c6c6c' stroke-width='11' stroke-linecap='round' d='M60 7v20'/%3E%3C/defs%3E%3Cuse xlink:href='%23a' opacity='.27'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(30 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(60 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(90 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(120 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(150 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.37' transform='rotate(180 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.46' transform='rotate(210 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.56' transform='rotate(240 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.66' transform='rotate(270 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.75' transform='rotate(300 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.85' transform='rotate(330 60 60)'/%3E%3C/svg%3E\");background-position:50%;background-size:100%;background-repeat:no-repeat}.swiper-lazy-preloader-white:after{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath id='a' stroke='%23fff' stroke-width='11' stroke-linecap='round' d='M60 7v20'/%3E%3C/defs%3E%3Cuse xlink:href='%23a' opacity='.27'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(30 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(60 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(90 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(120 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(150 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.37' transform='rotate(180 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.46' transform='rotate(210 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.56' transform='rotate(240 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.66' transform='rotate(270 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.75' transform='rotate(300 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.85' transform='rotate(330 60 60)'/%3E%3C/svg%3E\")}@-webkit-keyframes swiper-preloader-spin{to{-webkit-transform:rotate(1turn)}}@keyframes swiper-preloader-spin{to{transform:rotate(1turn)}}", ""]);

// exports


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)();
// imports


// module
exports.push([module.i, ".datatable th{padding:0}.datatable-linenumber-cell,.datatable-linenumber-column{text-align:center}.datatable-aggregate-cell,.datatable-linenumber-cell{font-weight:600;background-color:#fafafc!important;border-right-color:#dde}.datatable-group-chip{margin-right:.5rem}.datatable-collection .datatable-collection .datatable-resultset{border-top:1px solid #dde}.datatable-group{padding:0;background-color:#fff}.datatable-group,.datatable-groups-header{border-bottom:1px solid #dde}.datatable-group-header{padding:.5rem 1rem;background-color:#fafafc}.datatable-grouping-over{box-shadow:0 0 0 2px #2196f3}.datatable-row-indent{display:inline-block;width:1.5rem;height:1em}.datatable-group-label{font-weight:600}.datatable-info-cell{text-align:center;font-weight:600}.datatable-aggregators .datatable-info-cell{border-bottom:1px solid #dde}.datatable-options{padding:.75rem 1rem;background-color:#fafafc;border-top:1px solid #dde}.datatable-editable .datatable-cell{position:relative;padding:0!important;overflow:visible}.datatable-editable .datatable-cell input,.datatable-editable .datatable-cell select{display:block;width:100%;height:auto;padding:.5rem 1rem;background-color:transparent;border:none;border-radius:0}.datatable-editable .datatable-cell input:active,.datatable-editable .datatable-cell input:focus,.datatable-editable .datatable-cell select:active,.datatable-editable .datatable-cell select:focus{box-shadow:0 0 0 2px #2196f3}", ""]);

// exports


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)();
// imports


// module
exports.push([module.i, ".datatable-column{padding:.75rem 1rem;cursor:pointer;user-select:none}.datatable-sort-arrow{width:0;height:0;border:.375rem solid transparent}.datatable-sort-arrow-asc{border-bottom-color:currentColor;transform:translateY(-.1875rem)}.datatable-sort-arrow-desc{border-top-color:currentColor;transform:translateY(.1875rem)}", ""]);

// exports


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)();
// imports


// module
exports.push([module.i, ".checkbox{display:inline-block;margin-right:1rem;vertical-align:baseline}.checkbox label{position:relative;display:inline-block;width:1.25rem;height:1.25rem;margin-right:.25rem;background-color:#fff;border:1px solid #dde;border-radius:2px;vertical-align:text-bottom;cursor:pointer;user-select:none}.checkbox label:after{position:absolute;display:block;content:\" \";width:.375rem;height:.75rem;top:.125rem;left:.4rem;border-right:.2rem solid #fff;border-bottom:.2rem solid #fff;opacity:0;transform:rotate(45deg);transition:opacity .15s ease-out}.checkbox input[type=checkbox]{display:none!important}.checkbox input[type=checkbox]:checked+label{background-color:#2196f3;border-color:#2196f3}.checkbox input[type=checkbox]:checked+label:after{opacity:1}.checkbox input[type=checkbox]:disabled+label{background-color:#fafafa;cursor:not-allowed}", ""]);

// exports


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)();
// imports


// module
exports.push([module.i, ".notfound{margin-top:4rem}.notfound__headline{color:#000;font-size:2rem;font-weight:700;margin-top:0;margin-bottom:.5rem}.notfound__subline{color:#888;font-size:1.5rem;font-weight:500;margin-top:0;margin-bottom:2rem}.notfound a{text-decoration:none}", ""]);

// exports


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)();
// imports


// module
exports.push([module.i, ".spinner{display:flex;justify-content:center;align-items:center;height:20vh}@keyframes spin{to{transform:rotate(1turn)}}.icon{position:relative;display:inline-block;width:25px;height:25px;overflow:hidden}.icon__cnt{width:100%;height:100%;background:inherit;pointer-events:none;transform:translateX(0)}.dark .icon__cnt,.icon__cnt{fill:#0087f8}.icon--m{width:50px;height:50px}.icon__spinner{position:absolute;top:0;left:0;width:100%;height:100%}.icon--ei-spinner-2 .icon__spinner,.icon--ei-spinner .icon__spinner{animation:spin 1s steps(12) infinite}", ""]);

// exports


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)();
// imports


// module
exports.push([module.i, ".paginator{border:1px solid #dde;border-radius:2px}.paginator-footer{padding:1rem;background-color:#fafafc;border-top:1px solid #dde}.paginator-button{display:inline-block;min-width:1.5em;padding:0 .5rem;font-weight:600;background-color:#dde;border-radius:2px;cursor:pointer}.paginator-button.active{color:#fff;background-color:#2196f3}.paginator-page-number{margin:0 .25rem}", ""]);

// exports


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)();
// imports


// module
exports.push([module.i, "body{text-rendering:optimizeLegibility;background-color:palette(#fff);margin:0}#app{width:100vw;font-family:Avenir,Lato,sans-serif;font-size:.9rem;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.text-center{text-align:center}@font-face{font-family:Adobe Caslon Pro;src:url(" + __webpack_require__(1135) + ") format(\"woff\")}@font-face{font-family:Aktiv Grotesk Corp;src:url(" + __webpack_require__(1137) + ") format(\"woff\")}@font-face{font-family:Aktiv Grotesk Corp Bold;src:url(" + __webpack_require__(1136) + ") format(\"woff\")}", ""]);

// exports


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)();
// imports


// module
exports.push([module.i, ".field__group{display:flex;flex-direction:column;flex:1;margin-bottom:10px;padding:6px 1.5rem;transition:border-color .25s ease-in-out}.field__group.active{border-color:#0087f8}.field__group__label{color:gray;font-family:Avenir,Lato,sans-serif;font-size:.8rem;font-weight:500;margin-bottom:1px;transition:color .25s ease-in-out}.field__group__input{height:2rem!important;padding:0!important;border-top:0!important;border-left:0!important;border-right:0!important;border-bottom:1px solid #dde!important;color:#000;background-color:transparent;font-family:Avenir,Lato,sans-serif;font-size:1rem;outline:0}.field__group__input::placeholder{color:#888;transition:color .25s ease-in-out}.field__group__textarea{height:auto!important;width:100%!important;padding:0!important;border-top:0!important;border-left:0!important;border-right:0!important;border-bottom:1px solid #dde!important;color:#000;background-color:transparent;font-family:Avenir,Lato,sans-serif;font-size:1rem;outline:0}.field__group__textarea::placeholder{color:#888;transition:color .25s ease-in-out}.dark .field__group{border:1px solid #6f6f6f;border-radius:3px}.dark .field__group.active{border-color:#0087f8}.dark .field__group__input,.dark .field__group__label{color:#fff}.dark .field__group__input::placeholder{color:#d5d5d5}.field-container{display:flex;flex-wrap:wrap;flex-direction:row;justify-content:space-between;align-items:stretch;margin-bottom:1rem}.bt-form h3{border-bottom:1px solid #000;line-height:2rem}", ""]);

// exports


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)();
// imports


// module
exports.push([module.i, ".message{width:fit-content;border-radius:3px;border-style:dashed;border-width:1px;box-shadow:0 2px 4px rgba(0,0,0,.04);display:flex;font-family:Avenir,Lato,sans-serif;font-size:.9rem;font-weight:500;font-style:italic;justify-content:space-between;margin:1rem 0 1rem auto;padding:.75rem}.message .text{flex:1}.message .close{background-image:url(" + __webpack_require__(1068) + ");background-position:95%;background-repeat:no-repeat;background-size:22px;cursor:pointer;width:22px}", ""]);

// exports


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)();
// imports


// module
exports.push([module.i, ".success-message{border:1px solid green;border-radius:3px;box-shadow:0 2px 4px rgba(0,0,0,.04);color:#006400;display:flex;font-family:Avenir,Lato,sans-serif;font-size:.9rem;font-weight:500;justify-content:space-between;margin:1rem 0;padding:.75rem}.success-message .success-text{flex:1}.success-message .success-close{cursor:pointer;width:22px}", ""]);

// exports


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)();
// imports


// module
exports.push([module.i, ".notfound{margin-top:4rem}.notfound__headline{color:#000;font-size:2rem;font-weight:700;margin-top:0;margin-bottom:.5rem}.notfound__subline{color:#888;font-size:1.5rem;font-weight:500;margin-top:0;margin-bottom:2rem}.notfound a{text-decoration:none}", ""]);

// exports


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)();
// imports


// module
exports.push([module.i, ".public__body,.public__header{border-bottom-width:1px;border-bottom-style:solid;border-bottom-color:#ddd}.public__header{display:flex;justify-content:space-between;align-items:center;padding-bottom:.35rem}.public__header h1{color:#0087f8;margin:0;font-size:1rem}.public__header span{font-size:.85rem}.public__body{word-wrap:break-word;white-space:pre-wrap;height:18rem;overflow-y:scroll;color:#000;font-size:.95rem;font-family:Avenir,Lato,sans-serif;padding-top:.75rem;padding-bottom:.75rem;margin-bottom:.5rem}.public__footer{text-align:center;font-weight:500;font-size:.9rem}.public__footer a{color:#0087f8;transition:color .25s ease-in-out}", ""]);

// exports


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)();
// imports


// module
exports.push([module.i, ".vue-tabs.stacked{display:flex}.vue-tabs a{text-decoration:none;color:gray}.vue-tabs .nav{margin-bottom:0;margin-top:0;padding-left:0;list-style:none}.vue-tabs .nav:after,.vue-tabs .nav:before{content:\" \";display:table}.vue-tabs .nav:after{clear:both}.vue-tabs .nav>li,.vue-tabs .nav>li>a{position:relative;display:block}.vue-tabs .nav>li>a{padding:10px 15px}.vue-tabs .nav>li>a:focus,.vue-tabs .nav>li>a:hover{text-decoration:none;background-color:#eee}.vue-tabs .nav>li span.title{display:flex;justify-content:center}.vue-tabs .nav>li.disabled>a{color:#777}.vue-tabs .nav>li.disabled>a:focus,.vue-tabs .nav>li.disabled>a:hover{color:#777;text-decoration:none;background-color:transparent;cursor:not-allowed}.vue-tabs .nav .nav-divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.vue-tabs .nav>li>a>img{max-width:none}.vue-tabs .nav-tabs{border-bottom:1px solid #ddd}.vue-tabs .nav-tabs>li{float:left;margin-bottom:-1px}.vue-tabs .nav-tabs>li>a{margin-right:2px;line-height:1.42857;border:1px solid transparent;border-radius:4px 4px 0 0}.vue-tabs .nav-tabs>li>a:hover{border-color:#eee #eee #ddd}.vue-tabs .nav-tabs>li.active>a,.vue-tabs .nav-tabs>li.active>a:focus,.vue-tabs .nav-tabs>li.active>a:hover{color:#555;background-color:#fff;border:1px solid #ddd;border-bottom-color:transparent;cursor:default}.vue-tabs .nav-pills>li{float:left}.vue-tabs .nav-pills>li>a{border-radius:4px}.vue-tabs .nav-pills>li+li{margin-left:2px}.vue-tabs .nav-pills>li.active>a,.vue-tabs .nav-pills>li.active>a:focus,.vue-tabs .nav-pills>li.active>a:hover{color:#fff;background-color:#337ab7}.vue-tabs .nav-stacked>li{float:none}.vue-tabs .nav-stacked>li+li{margin-top:2px;margin-left:0}.vue-tabs .nav-justified,.vue-tabs .nav-tabs.nav-justified{width:100%}.vue-tabs .nav-justified>li,.vue-tabs .nav-tabs.nav-justified>li{float:none}.vue-tabs .nav-justified>li>a,.vue-tabs .nav-tabs.nav-justified>li>a{text-align:center;margin-bottom:5px}.vue-tabs .nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.vue-tabs .nav-justified>li,.vue-tabs .nav-tabs.nav-justified>li{display:table-cell;width:1%}.vue-tabs .nav-justified>li>a,.vue-tabs .nav-tabs.nav-justified>li>a{margin-bottom:0}}.vue-tabs .nav-tabs-justified,.vue-tabs .nav-tabs.nav-justified{border-bottom:0}.vue-tabs .nav-tabs-justified>li>a,.vue-tabs .nav-tabs.nav-justified>li>a{margin-right:0;border-radius:4px}.vue-tabs .nav-tabs-justified>.active>a,.vue-tabs .nav-tabs-justified>.active>a:focus,.vue-tabs .nav-tabs-justified>.active>a:hover,.vue-tabs .nav-tabs.nav-justified>.active>a,.vue-tabs .nav-tabs.nav-justified>.active>a:focus,.vue-tabs .nav-tabs.nav-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.vue-tabs .nav-tabs-justified>li>a,.vue-tabs .nav-tabs.nav-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.vue-tabs .nav-tabs-justified>.active>a,.vue-tabs .nav-tabs-justified>.active>a:focus,.vue-tabs .nav-tabs-justified>.active>a:hover,.vue-tabs .nav-tabs.nav-justified>.active>a,.vue-tabs .nav-tabs.nav-justified>.active>a:focus,.vue-tabs .nav-tabs.nav-justified>.active>a:hover{border-bottom-color:#fff}}.vue-tabs .tab-content>.tab-pane{display:none}.vue-tabs .tab-content>.active{display:block}.vue-tabs section[aria-hidden=true]{display:none}", ""]);

// exports


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)();
// imports


// module
exports.push([module.i, ".swiper-container[data-v-00315fee]{height:40vh;width:100%}.slide-img[data-v-00315fee]{width:100%;height:auto}", ""]);

// exports


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)();
// imports


// module
exports.push([module.i, ".swiper-container[data-v-12fb11ca]{height:40vh;width:100%}.slide-img[data-v-12fb11ca]{width:100%;height:auto}", ""]);

// exports


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)();
// imports


// module
exports.push([module.i, ".fa-icon{display:inline-block;fill:currentColor}.fa-flip-horizontal{transform:scaleX(-1)}.fa-flip-vertical{transform:scaleY(-1)}.fa-spin{animation:fa-spin 1s 0s infinite linear}.fa-inverse{color:#fff}@keyframes fa-spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);

// exports


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)();
// imports


// module
exports.push([module.i, ".swiper-container[data-v-2078095a]{height:100vh;width:100%}.slide-img[data-v-2078095a]{width:100%;height:auto}.swiper-button-prev[data-v-2078095a]{background-image:none;left:0;width:50vw;height:100vh;top:0}.swiper-button-next[data-v-2078095a]{background-image:none;right:0;width:50vw;height:100vh;top:0}", ""]);

// exports


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)();
// imports


// module
exports.push([module.i, ".swiper-container[data-v-230e8aa2]{height:40vh;width:100%}.slide-img[data-v-230e8aa2]{width:100%;height:auto}", ""]);

// exports


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)();
// imports


// module
exports.push([module.i, ".swiper-container[data-v-260176a8]{height:40vh;width:100%}.slide-img[data-v-260176a8]{width:100%;height:auto}", ""]);

// exports


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)();
// imports


// module
exports.push([module.i, ".listlink{margin-bottom:1em}.listlink:hover{cursor:pointer;color:#0c7cd5}", ""]);

// exports


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)();
// imports


// module
exports.push([module.i, ".swiper-container[data-v-3cf21d34]{height:100vh;width:100%;text-align:center}.slide-img[data-v-3cf21d34]{width:100%;height:auto}.topleftdiv[data-v-3cf21d34]{left:1em}.topleftdiv[data-v-3cf21d34],.toprightdiv[data-v-3cf21d34]{top:1em;position:absolute;font-family:Aktiv Grotesk Corp,sans-serif;font-size:small;color:#000;z-index:9999}.toprightdiv[data-v-3cf21d34]{right:1em;text-align:right}.bottomcenterdiv[data-v-3cf21d34]{bottom:4em;position:relative;font-family:Aktiv Grotesk Corp,sans-serif;font-size:small;color:#000;z-index:9999}.swiper-button-prev[data-v-3cf21d34]{background-image:none;left:0;width:50vw;height:80vh;top:14vh}.swiper-button-next[data-v-3cf21d34]{background-image:none;right:0;width:50vw;height:80vh;top:14vh}", ""]);

// exports


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)();
// imports


// module
exports.push([module.i, "@media screen and (max-width:1280px){.sidenavbar{display:none!important}}.sidenavbar{position:relative;width:300px;height:100vh;display:inline-block;vertical-align:top;padding-top:6rem;padding-left:1rem;padding-right:1rem;color:#000;font-size:.8rem;z-index:10}.navul{margin-top:0;padding-left:1rem}.navli,.navul{list-style:none}.navli{padding-top:.5rem}.navli:hover{color:#2196f3;cursor:pointer}", ""]);

// exports


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)();
// imports


// module
exports.push([module.i, ".footer-item{padding-right:1rem;padding-left:1rem;white-space:nowrap}", ""]);

// exports


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)();
// imports


// module
exports.push([module.i, ".swiper-container[data-v-5691b2cc]{height:40vh;width:100%}.slide-img[data-v-5691b2cc]{width:100%;height:auto}", ""]);

// exports


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)();
// imports


// module
exports.push([module.i, ".vue-map-container{position:relative}.vue-map-container .vue-map{left:0;right:0;top:0;bottom:0;position:absolute}.vue-map-hidden{display:none}", ""]);

// exports


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)();
// imports


// module
exports.push([module.i, ".fade-enter-active,.fade-leave-active{transition:opacity 1s}.fade-enter,.fade-leave-to{opacity:0}", ""]);

// exports


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)();
// imports


// module
exports.push([module.i, ".swiper-container[data-v-996a384e]{height:40vh;width:100%}.slide-img[data-v-996a384e]{width:100%;height:auto}.services-item[data-v-996a384e]{width:30%;margin:1rem}.icon-container[data-v-996a384e]{text-align:center;width:100%}", ""]);

// exports


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)();
// imports


// module
exports.push([module.i, ".vue-street-view-pano-container{position:relative}.vue-street-view-pano-container .vue-street-view-pano{left:0;right:0;top:0;bottom:0;position:absolute}", ""]);

// exports


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)();
// imports


// module
exports.push([module.i, ".map-container{width:100%;height:40vh}", ""]);

// exports


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)();
// imports


// module
exports.push([module.i, ".swiper-container[data-v-ef288e52]{height:40vh;width:100%}.slide-img[data-v-ef288e52]{width:100%;height:auto}", ""]);

// exports


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Range Helpers
 * @summary Is the given date range overlapping with another date range?
 *
 * @description
 * Is the given date range overlapping with another date range?
 *
 * @param {Date|String|Number} initialRangeStartDate - the start of the initial range
 * @param {Date|String|Number} initialRangeEndDate - the end of the initial range
 * @param {Date|String|Number} comparedRangeStartDate - the start of the range to compare it with
 * @param {Date|String|Number} comparedRangeEndDate - the end of the range to compare it with
 * @returns {Boolean} whether the date ranges are overlapping
 * @throws {Error} startDate of a date range cannot be after its endDate
 *
 * @example
 * // For overlapping date ranges:
 * areRangesOverlapping(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 17), new Date(2014, 0, 21)
 * )
 * //=> true
 *
 * @example
 * // For non-overlapping date ranges:
 * areRangesOverlapping(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 21), new Date(2014, 0, 22)
 * )
 * //=> false
 */
function areRangesOverlapping (dirtyInitialRangeStartDate, dirtyInitialRangeEndDate, dirtyComparedRangeStartDate, dirtyComparedRangeEndDate) {
  var initialStartTime = parse(dirtyInitialRangeStartDate).getTime()
  var initialEndTime = parse(dirtyInitialRangeEndDate).getTime()
  var comparedStartTime = parse(dirtyComparedRangeStartDate).getTime()
  var comparedEndTime = parse(dirtyComparedRangeEndDate).getTime()

  if (initialStartTime > initialEndTime || comparedStartTime > comparedEndTime) {
    throw new Error('The start of the range cannot be after the end of the range')
  }

  return initialStartTime < comparedEndTime && comparedStartTime < initialEndTime
}

module.exports = areRangesOverlapping


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Common Helpers
 * @summary Return an index of the closest date from the array comparing to the given date.
 *
 * @description
 * Return an index of the closest date from the array comparing to the given date.
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date[]|String[]|Number[]} datesArray - the array to search
 * @returns {Number} an index of the date closest to the given date
 * @throws {TypeError} the second argument must be an instance of Array
 *
 * @example
 * // Which date is closer to 6 September 2015?
 * var dateToCompare = new Date(2015, 8, 6)
 * var datesArray = [
 *   new Date(2015, 0, 1),
 *   new Date(2016, 0, 1),
 *   new Date(2017, 0, 1)
 * ]
 * var result = closestIndexTo(dateToCompare, datesArray)
 * //=> 1
 */
function closestIndexTo (dirtyDateToCompare, dirtyDatesArray) {
  if (!(dirtyDatesArray instanceof Array)) {
    throw new TypeError(toString.call(dirtyDatesArray) + ' is not an instance of Array')
  }

  var dateToCompare = parse(dirtyDateToCompare)
  var timeToCompare = dateToCompare.getTime()

  var result
  var minDistance

  dirtyDatesArray.forEach(function (dirtyDate, index) {
    var currentDate = parse(dirtyDate)
    var distance = Math.abs(timeToCompare - currentDate.getTime())
    if (result === undefined || distance < minDistance) {
      result = index
      minDistance = distance
    }
  })

  return result
}

module.exports = closestIndexTo


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Common Helpers
 * @summary Return a date from the array closest to the given date.
 *
 * @description
 * Return a date from the array closest to the given date.
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date[]|String[]|Number[]} datesArray - the array to search
 * @returns {Date} the date from the array closest to the given date
 * @throws {TypeError} the second argument must be an instance of Array
 *
 * @example
 * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
 * var dateToCompare = new Date(2015, 8, 6)
 * var result = closestTo(dateToCompare, [
 *   new Date(2000, 0, 1),
 *   new Date(2030, 0, 1)
 * ])
 * //=> Tue Jan 01 2030 00:00:00
 */
function closestTo (dirtyDateToCompare, dirtyDatesArray) {
  if (!(dirtyDatesArray instanceof Array)) {
    throw new TypeError(toString.call(dirtyDatesArray) + ' is not an instance of Array')
  }

  var dateToCompare = parse(dirtyDateToCompare)
  var timeToCompare = dateToCompare.getTime()

  var result
  var minDistance

  dirtyDatesArray.forEach(function (dirtyDate) {
    var currentDate = parse(dirtyDate)
    var distance = Math.abs(timeToCompare - currentDate.getTime())
    if (result === undefined || distance < minDistance) {
      result = currentDate
      minDistance = distance
    }
  })

  return result
}

module.exports = closestTo


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

var startOfISOWeek = __webpack_require__(91)

var MILLISECONDS_IN_MINUTE = 60000
var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category ISO Week Helpers
 * @summary Get the number of calendar ISO weeks between the given dates.
 *
 * @description
 * Get the number of calendar ISO weeks between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar ISO weeks
 *
 * @example
 * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
 * var result = differenceInCalendarISOWeeks(
 *   new Date(2014, 6, 21),
 *   new Date(2014, 6, 6)
 * )
 * //=> 3
 */
function differenceInCalendarISOWeeks (dirtyDateLeft, dirtyDateRight) {
  var startOfISOWeekLeft = startOfISOWeek(dirtyDateLeft)
  var startOfISOWeekRight = startOfISOWeek(dirtyDateRight)

  var timestampLeft = startOfISOWeekLeft.getTime() -
    startOfISOWeekLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
  var timestampRight = startOfISOWeekRight.getTime() -
    startOfISOWeekRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK)
}

module.exports = differenceInCalendarISOWeeks


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

var getQuarter = __webpack_require__(308)
var parse = __webpack_require__(4)

/**
 * @category Quarter Helpers
 * @summary Get the number of calendar quarters between the given dates.
 *
 * @description
 * Get the number of calendar quarters between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar quarters
 *
 * @example
 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
 * var result = differenceInCalendarQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 3
 */
function differenceInCalendarQuarters (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear()
  var quarterDiff = getQuarter(dateLeft) - getQuarter(dateRight)

  return yearDiff * 4 + quarterDiff
}

module.exports = differenceInCalendarQuarters


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

var startOfWeek = __webpack_require__(142)

var MILLISECONDS_IN_MINUTE = 60000
var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Number} the number of calendar weeks
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   {weekStartsOn: 1}
 * )
 * //=> 2
 */
function differenceInCalendarWeeks (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  var startOfWeekLeft = startOfWeek(dirtyDateLeft, dirtyOptions)
  var startOfWeekRight = startOfWeek(dirtyDateRight, dirtyOptions)

  var timestampLeft = startOfWeekLeft.getTime() -
    startOfWeekLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
  var timestampRight = startOfWeekRight.getTime() -
    startOfWeekRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK)
}

module.exports = differenceInCalendarWeeks


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

var differenceInMilliseconds = __webpack_require__(141)

var MILLISECONDS_IN_HOUR = 3600000

/**
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of hours
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * var result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */
function differenceInHours (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_HOUR
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInHours


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)
var differenceInCalendarISOYears = __webpack_require__(299)
var compareAsc = __webpack_require__(108)
var subISOYears = __webpack_require__(327)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of full ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of full ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full ISO week-numbering years
 *
 * @example
 * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
 * var result = differenceInISOYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 1
 */
function differenceInISOYears (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarISOYears(dateLeft, dateRight))
  dateLeft = subISOYears(dateLeft, sign * difference)

  // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
  // if last calendar ISO year is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastISOYearNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastISOYearNotFull)
}

module.exports = differenceInISOYears


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

var differenceInMilliseconds = __webpack_require__(141)

var MILLISECONDS_IN_MINUTE = 60000

/**
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the number of minutes between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of minutes
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * var result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 */
function differenceInMinutes (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_MINUTE
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInMinutes


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

var differenceInMonths = __webpack_require__(198)

/**
 * @category Quarter Helpers
 * @summary Get the number of full quarters between the given dates.
 *
 * @description
 * Get the number of full quarters between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full quarters
 *
 * @example
 * // How many full quarters are between 31 December 2013 and 2 July 2014?
 * var result = differenceInQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */
function differenceInQuarters (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMonths(dirtyDateLeft, dirtyDateRight) / 3
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInQuarters


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

var differenceInDays = __webpack_require__(302)

/**
 * @category Week Helpers
 * @summary Get the number of full weeks between the given dates.
 *
 * @description
 * Get the number of full weeks between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full weeks
 *
 * @example
 * // How many full weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 2
 */
function differenceInWeeks (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInDays(dirtyDateLeft, dirtyDateRight) / 7
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInWeeks


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)
var differenceInCalendarYears = __webpack_require__(301)
var compareAsc = __webpack_require__(108)

/**
 * @category Year Helpers
 * @summary Get the number of full years between the given dates.
 *
 * @description
 * Get the number of full years between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full years
 *
 * @example
 * // How many full years are between 31 December 2013 and 11 February 2015?
 * var result = differenceInYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 1
 */
function differenceInYears (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarYears(dateLeft, dateRight))
  dateLeft.setFullYear(dateLeft.getFullYear() - sign * difference)

  // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastYearNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastYearNotFull)
}

module.exports = differenceInYears


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

var compareDesc = __webpack_require__(197)
var parse = __webpack_require__(4)
var differenceInSeconds = __webpack_require__(199)
var enLocale = __webpack_require__(205)

var MINUTES_IN_DAY = 1440
var MINUTES_IN_MONTH = 43200
var MINUTES_IN_YEAR = 525600

/**
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `distanceInWords`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date|String|Number} date - the other date
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {'s'|'m'|'h'|'d'|'M'|'Y'} [options.unit] - if specified, will force a unit
 * @param {'floor'|'ceil'|'round'} [options.partialMethod='floor'] - which way to round partial units
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the distance in words
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * var result = distanceInWordsStrict(
 *   new Date(2014, 6, 2),
 *   new Date(2015, 0, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00?
 * var result = distanceInWordsStrict(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 * )
 * //=> '15 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * var result = distanceInWordsStrict(
 *   new Date(2016, 0, 1),
 *   new Date(2015, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> '1 year ago'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, in minutes?
 * var result = distanceInWordsStrict(
 *   new Date(2016, 0, 1),
 *   new Date(2015, 0, 1),
 *   {unit: 'm'}
 * )
 * //=> '525600 minutes'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 28 January 2015, in months, rounded up?
 * var result = distanceInWordsStrict(
 *   new Date(2015, 0, 28),
 *   new Date(2015, 0, 1),
 *   {unit: 'M', partialMethod: 'ceil'}
 * )
 * //=> '1 month'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * var eoLocale = require('date-fns/locale/eo')
 * var result = distanceInWordsStrict(
 *   new Date(2016, 7, 1),
 *   new Date(2015, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> '1 jaro'
 */
function distanceInWordsStrict (dirtyDateToCompare, dirtyDate, dirtyOptions) {
  var options = dirtyOptions || {}

  var comparison = compareDesc(dirtyDateToCompare, dirtyDate)

  var locale = options.locale
  var localize = enLocale.distanceInWords.localize
  if (locale && locale.distanceInWords && locale.distanceInWords.localize) {
    localize = locale.distanceInWords.localize
  }

  var localizeOptions = {
    addSuffix: Boolean(options.addSuffix),
    comparison: comparison
  }

  var dateLeft, dateRight
  if (comparison > 0) {
    dateLeft = parse(dirtyDateToCompare)
    dateRight = parse(dirtyDate)
  } else {
    dateLeft = parse(dirtyDate)
    dateRight = parse(dirtyDateToCompare)
  }

  var unit
  var mathPartial = Math[options.partialMethod ? String(options.partialMethod) : 'floor']
  var seconds = differenceInSeconds(dateRight, dateLeft)
  var offset = dateRight.getTimezoneOffset() - dateLeft.getTimezoneOffset()
  var minutes = mathPartial(seconds / 60) - offset
  var hours, days, months, years

  if (options.unit) {
    unit = String(options.unit)
  } else {
    if (minutes < 1) {
      unit = 's'
    } else if (minutes < 60) {
      unit = 'm'
    } else if (minutes < MINUTES_IN_DAY) {
      unit = 'h'
    } else if (minutes < MINUTES_IN_MONTH) {
      unit = 'd'
    } else if (minutes < MINUTES_IN_YEAR) {
      unit = 'M'
    } else {
      unit = 'Y'
    }
  }

  // 0 up to 60 seconds
  if (unit === 's') {
    return localize('xSeconds', seconds, localizeOptions)

  // 1 up to 60 mins
  } else if (unit === 'm') {
    return localize('xMinutes', minutes, localizeOptions)

  // 1 up to 24 hours
  } else if (unit === 'h') {
    hours = mathPartial(minutes / 60)
    return localize('xHours', hours, localizeOptions)

  // 1 up to 30 days
  } else if (unit === 'd') {
    days = mathPartial(minutes / MINUTES_IN_DAY)
    return localize('xDays', days, localizeOptions)

  // 1 up to 12 months
  } else if (unit === 'M') {
    months = mathPartial(minutes / MINUTES_IN_MONTH)
    return localize('xMonths', months, localizeOptions)

  // 1 year up to max Date
  } else if (unit === 'Y') {
    years = mathPartial(minutes / MINUTES_IN_YEAR)
    return localize('xYears', years, localizeOptions)
  }

  throw new Error('Unknown unit: ' + unit)
}

module.exports = distanceInWordsStrict


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

var distanceInWords = __webpack_require__(303)

/**
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 *
 * @description
 * Return the distance between the given date and now in words.
 *
 * | Distance to now                                                   | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance to now     | Result               |
 * |---------------------|----------------------|
 * | 0 secs ... 5 secs   | less than 5 seconds  |
 * | 5 secs ... 10 secs  | less than 10 seconds |
 * | 10 secs ... 20 secs | less than 20 seconds |
 * | 20 secs ... 40 secs | half a minute        |
 * | 40 secs ... 60 secs | less than a minute   |
 * | 60 secs ... 90 secs | 1 minute             |
 *
 * @param {Date|String|Number} date - the given date
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
 * @param {Boolean} [options.addSuffix=false] - result specifies if the second date is earlier or later than the first
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the distance in words
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * var result = distanceInWordsToNow(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * var result = distanceInWordsToNow(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * var result = distanceInWordsToNow(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in about 1 year'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 August 2016 in Esperanto?
 * var eoLocale = require('date-fns/locale/eo')
 * var result = distanceInWordsToNow(
 *   new Date(2016, 7, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */
function distanceInWordsToNow (dirtyDate, dirtyOptions) {
  return distanceInWords(Date.now(), dirtyDate, dirtyOptions)
}

module.exports = distanceInWordsToNow


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Day Helpers
 * @summary Return the array of dates within the specified range.
 *
 * @description
 * Return the array of dates within the specified range.
 *
 * @param {Date|String|Number} startDate - the first date
 * @param {Date|String|Number} endDate - the last date
 * @returns {Date[]} the array with starts of days from the day of startDate to the day of endDate
 * @throws {Error} startDate cannot be after endDate
 *
 * @example
 * // Each day between 6 October 2014 and 10 October 2014:
 * var result = eachDay(
 *   new Date(2014, 9, 6),
 *   new Date(2014, 9, 10)
 * )
 * //=> [
 * //   Mon Oct 06 2014 00:00:00,
 * //   Tue Oct 07 2014 00:00:00,
 * //   Wed Oct 08 2014 00:00:00,
 * //   Thu Oct 09 2014 00:00:00,
 * //   Fri Oct 10 2014 00:00:00
 * // ]
 */
function eachDay (dirtyStartDate, dirtyEndDate) {
  var startDate = parse(dirtyStartDate)
  var endDate = parse(dirtyEndDate)

  var endTime = endDate.getTime()

  if (startDate.getTime() > endTime) {
    throw new Error('The first date cannot be after the second date')
  }

  var dates = []

  var currentDate = startDate
  currentDate.setHours(0, 0, 0, 0)

  while (currentDate.getTime() <= endTime) {
    dates.push(parse(currentDate))
    currentDate.setDate(currentDate.getDate() + 1)
  }

  return dates
}

module.exports = eachDay


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Hour Helpers
 * @summary Return the end of an hour for the given date.
 *
 * @description
 * Return the end of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an hour
 *
 * @example
 * // The end of an hour for 2 September 2014 11:55:00:
 * var result = endOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:59:59.999
 */
function endOfHour (dirtyDate) {
  var date = parse(dirtyDate)
  date.setMinutes(59, 59, 999)
  return date
}

module.exports = endOfHour


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

var endOfWeek = __webpack_require__(305)

/**
 * @category ISO Week Helpers
 * @summary Return the end of an ISO week for the given date.
 *
 * @description
 * Return the end of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an ISO week
 *
 * @example
 * // The end of an ISO week for 2 September 2014 11:55:00:
 * var result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfISOWeek (dirtyDate) {
  return endOfWeek(dirtyDate, {weekStartsOn: 1})
}

module.exports = endOfISOWeek


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__(89)
var startOfISOWeek = __webpack_require__(91)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the end of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the end of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an ISO week-numbering year
 *
 * @example
 * // The end of an ISO week-numbering year for 2 July 2005:
 * var result = endOfISOYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 23:59:59.999
 */
function endOfISOYear (dirtyDate) {
  var year = getISOYear(dirtyDate)
  var fourthOfJanuaryOfNextYear = new Date(0)
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4)
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0)
  var date = startOfISOWeek(fourthOfJanuaryOfNextYear)
  date.setMilliseconds(date.getMilliseconds() - 1)
  return date
}

module.exports = endOfISOYear


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Minute Helpers
 * @summary Return the end of a minute for the given date.
 *
 * @description
 * Return the end of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a minute
 *
 * @example
 * // The end of a minute for 1 December 2014 22:15:45.400:
 * var result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:59.999
 */
function endOfMinute (dirtyDate) {
  var date = parse(dirtyDate)
  date.setSeconds(59, 999)
  return date
}

module.exports = endOfMinute


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Quarter Helpers
 * @summary Return the end of a year quarter for the given date.
 *
 * @description
 * Return the end of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a quarter
 *
 * @example
 * // The end of a quarter for 2 September 2014 11:55:00:
 * var result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfQuarter (dirtyDate) {
  var date = parse(dirtyDate)
  var currentMonth = date.getMonth()
  var month = currentMonth - currentMonth % 3 + 3
  date.setMonth(month, 0)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfQuarter


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Second Helpers
 * @summary Return the end of a second for the given date.
 *
 * @description
 * Return the end of a second for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a second
 *
 * @example
 * // The end of a second for 1 December 2014 22:15:45.400:
 * var result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.999
 */
function endOfSecond (dirtyDate) {
  var date = parse(dirtyDate)
  date.setMilliseconds(999)
  return date
}

module.exports = endOfSecond


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

var endOfDay = __webpack_require__(200)

/**
 * @category Day Helpers
 * @summary Return the end of today.
 *
 * @description
 * Return the end of today.
 *
 * @returns {Date} the end of today
 *
 * @example
 * // If today is 6 October 2014:
 * var result = endOfToday()
 * //=> Mon Oct 6 2014 23:59:59.999
 */
function endOfToday () {
  return endOfDay(new Date())
}

module.exports = endOfToday


/***/ }),
/* 986 */
/***/ (function(module, exports) {

/**
 * @category Day Helpers
 * @summary Return the end of tomorrow.
 *
 * @description
 * Return the end of tomorrow.
 *
 * @returns {Date} the end of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * var result = endOfTomorrow()
 * //=> Tue Oct 7 2014 23:59:59.999
 */
function endOfTomorrow () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var day = now.getDate()

  var date = new Date(0)
  date.setFullYear(year, month, day + 1)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfTomorrow


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a year
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * var result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */
function endOfYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  date.setFullYear(year + 1, 0, 0)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfYear


/***/ }),
/* 988 */
/***/ (function(module, exports) {

/**
 * @category Day Helpers
 * @summary Return the end of yesterday.
 *
 * @description
 * Return the end of yesterday.
 *
 * @returns {Date} the end of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * var result = endOfYesterday()
 * //=> Sun Oct 5 2014 23:59:59.999
 */
function endOfYesterday () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var day = now.getDate()

  var date = new Date(0)
  date.setFullYear(year, month, day - 1)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfYesterday


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

var getDayOfYear = __webpack_require__(306)
var getISOWeek = __webpack_require__(202)
var getISOYear = __webpack_require__(89)
var parse = __webpack_require__(4)
var isValid = __webpack_require__(318)
var enLocale = __webpack_require__(205)

/**
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format.
 *
 * Accepted tokens:
 * | Unit                    | Token | Result examples                  |
 * |-------------------------|-------|----------------------------------|
 * | Month                   | M     | 1, 2, ..., 12                    |
 * |                         | Mo    | 1st, 2nd, ..., 12th              |
 * |                         | MM    | 01, 02, ..., 12                  |
 * |                         | MMM   | Jan, Feb, ..., Dec               |
 * |                         | MMMM  | January, February, ..., December |
 * | Quarter                 | Q     | 1, 2, 3, 4                       |
 * |                         | Qo    | 1st, 2nd, 3rd, 4th               |
 * | Day of month            | D     | 1, 2, ..., 31                    |
 * |                         | Do    | 1st, 2nd, ..., 31st              |
 * |                         | DD    | 01, 02, ..., 31                  |
 * | Day of year             | DDD   | 1, 2, ..., 366                   |
 * |                         | DDDo  | 1st, 2nd, ..., 366th             |
 * |                         | DDDD  | 001, 002, ..., 366               |
 * | Day of week             | d     | 0, 1, ..., 6                     |
 * |                         | do    | 0th, 1st, ..., 6th               |
 * |                         | dd    | Su, Mo, ..., Sa                  |
 * |                         | ddd   | Sun, Mon, ..., Sat               |
 * |                         | dddd  | Sunday, Monday, ..., Saturday    |
 * | Day of ISO week         | E     | 1, 2, ..., 7                     |
 * | ISO week                | W     | 1, 2, ..., 53                    |
 * |                         | Wo    | 1st, 2nd, ..., 53rd              |
 * |                         | WW    | 01, 02, ..., 53                  |
 * | Year                    | YY    | 00, 01, ..., 99                  |
 * |                         | YYYY  | 1900, 1901, ..., 2099            |
 * | ISO week-numbering year | GG    | 00, 01, ..., 99                  |
 * |                         | GGGG  | 1900, 1901, ..., 2099            |
 * | AM/PM                   | A     | AM, PM                           |
 * |                         | a     | am, pm                           |
 * |                         | aa    | a.m., p.m.                       |
 * | Hour                    | H     | 0, 1, ... 23                     |
 * |                         | HH    | 00, 01, ... 23                   |
 * |                         | h     | 1, 2, ..., 12                    |
 * |                         | hh    | 01, 02, ..., 12                  |
 * | Minute                  | m     | 0, 1, ..., 59                    |
 * |                         | mm    | 00, 01, ..., 59                  |
 * | Second                  | s     | 0, 1, ..., 59                    |
 * |                         | ss    | 00, 01, ..., 59                  |
 * | 1/10 of second          | S     | 0, 1, ..., 9                     |
 * | 1/100 of second         | SS    | 00, 01, ..., 99                  |
 * | Millisecond             | SSS   | 000, 001, ..., 999               |
 * | Timezone                | Z     | -01:00, +00:00, ... +12:00       |
 * |                         | ZZ    | -0100, +0000, ..., +1200         |
 * | Seconds timestamp       | X     | 512969520                        |
 * | Milliseconds timestamp  | x     | 512969520900                     |
 *
 * The characters wrapped in square brackets are escaped.
 *
 * The result may vary by locale.
 *
 * @param {Date|String|Number} date - the original date
 * @param {String} [format='YYYY-MM-DDTHH:mm:ss.SSSZ'] - the string of tokens
 * @param {Object} [options] - the object with options
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the formatted date string
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(
 *   new Date(2014, 1, 11),
 *   'MM/DD/YYYY'
 * )
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * var eoLocale = require('date-fns/locale/eo')
 * var result = format(
 *   new Date(2014, 6, 2),
 *   'Do [de] MMMM YYYY',
 *   {locale: eoLocale}
 * )
 * //=> '2-a de julio 2014'
 */
function format (dirtyDate, dirtyFormatStr, dirtyOptions) {
  var formatStr = dirtyFormatStr ? String(dirtyFormatStr) : 'YYYY-MM-DDTHH:mm:ss.SSSZ'
  var options = dirtyOptions || {}

  var locale = options.locale
  var localeFormatters = enLocale.format.formatters
  var formattingTokensRegExp = enLocale.format.formattingTokensRegExp
  if (locale && locale.format && locale.format.formatters) {
    localeFormatters = locale.format.formatters

    if (locale.format.formattingTokensRegExp) {
      formattingTokensRegExp = locale.format.formattingTokensRegExp
    }
  }

  var date = parse(dirtyDate)

  if (!isValid(date)) {
    return 'Invalid Date'
  }

  var formatFn = buildFormatFn(formatStr, localeFormatters, formattingTokensRegExp)

  return formatFn(date)
}

var formatters = {
  // Month: 1, 2, ..., 12
  'M': function (date) {
    return date.getMonth() + 1
  },

  // Month: 01, 02, ..., 12
  'MM': function (date) {
    return addLeadingZeros(date.getMonth() + 1, 2)
  },

  // Quarter: 1, 2, 3, 4
  'Q': function (date) {
    return Math.ceil((date.getMonth() + 1) / 3)
  },

  // Day of month: 1, 2, ..., 31
  'D': function (date) {
    return date.getDate()
  },

  // Day of month: 01, 02, ..., 31
  'DD': function (date) {
    return addLeadingZeros(date.getDate(), 2)
  },

  // Day of year: 1, 2, ..., 366
  'DDD': function (date) {
    return getDayOfYear(date)
  },

  // Day of year: 001, 002, ..., 366
  'DDDD': function (date) {
    return addLeadingZeros(getDayOfYear(date), 3)
  },

  // Day of week: 0, 1, ..., 6
  'd': function (date) {
    return date.getDay()
  },

  // Day of ISO week: 1, 2, ..., 7
  'E': function (date) {
    return date.getDay() || 7
  },

  // ISO week: 1, 2, ..., 53
  'W': function (date) {
    return getISOWeek(date)
  },

  // ISO week: 01, 02, ..., 53
  'WW': function (date) {
    return addLeadingZeros(getISOWeek(date), 2)
  },

  // Year: 00, 01, ..., 99
  'YY': function (date) {
    return addLeadingZeros(date.getFullYear(), 4).substr(2)
  },

  // Year: 1900, 1901, ..., 2099
  'YYYY': function (date) {
    return addLeadingZeros(date.getFullYear(), 4)
  },

  // ISO week-numbering year: 00, 01, ..., 99
  'GG': function (date) {
    return String(getISOYear(date)).substr(2)
  },

  // ISO week-numbering year: 1900, 1901, ..., 2099
  'GGGG': function (date) {
    return getISOYear(date)
  },

  // Hour: 0, 1, ... 23
  'H': function (date) {
    return date.getHours()
  },

  // Hour: 00, 01, ..., 23
  'HH': function (date) {
    return addLeadingZeros(date.getHours(), 2)
  },

  // Hour: 1, 2, ..., 12
  'h': function (date) {
    var hours = date.getHours()
    if (hours === 0) {
      return 12
    } else if (hours > 12) {
      return hours % 12
    } else {
      return hours
    }
  },

  // Hour: 01, 02, ..., 12
  'hh': function (date) {
    return addLeadingZeros(formatters['h'](date), 2)
  },

  // Minute: 0, 1, ..., 59
  'm': function (date) {
    return date.getMinutes()
  },

  // Minute: 00, 01, ..., 59
  'mm': function (date) {
    return addLeadingZeros(date.getMinutes(), 2)
  },

  // Second: 0, 1, ..., 59
  's': function (date) {
    return date.getSeconds()
  },

  // Second: 00, 01, ..., 59
  'ss': function (date) {
    return addLeadingZeros(date.getSeconds(), 2)
  },

  // 1/10 of second: 0, 1, ..., 9
  'S': function (date) {
    return Math.floor(date.getMilliseconds() / 100)
  },

  // 1/100 of second: 00, 01, ..., 99
  'SS': function (date) {
    return addLeadingZeros(Math.floor(date.getMilliseconds() / 10), 2)
  },

  // Millisecond: 000, 001, ..., 999
  'SSS': function (date) {
    return addLeadingZeros(date.getMilliseconds(), 3)
  },

  // Timezone: -01:00, +00:00, ... +12:00
  'Z': function (date) {
    return formatTimezone(date.getTimezoneOffset(), ':')
  },

  // Timezone: -0100, +0000, ... +1200
  'ZZ': function (date) {
    return formatTimezone(date.getTimezoneOffset())
  },

  // Seconds timestamp: 512969520
  'X': function (date) {
    return Math.floor(date.getTime() / 1000)
  },

  // Milliseconds timestamp: 512969520900
  'x': function (date) {
    return date.getTime()
  }
}

function buildFormatFn (formatStr, localeFormatters, formattingTokensRegExp) {
  var array = formatStr.match(formattingTokensRegExp)
  var length = array.length

  var i
  var formatter
  for (i = 0; i < length; i++) {
    formatter = localeFormatters[array[i]] || formatters[array[i]]
    if (formatter) {
      array[i] = formatter
    } else {
      array[i] = removeFormattingTokens(array[i])
    }
  }

  return function (date) {
    var output = ''
    for (var i = 0; i < length; i++) {
      if (array[i] instanceof Function) {
        output += array[i](date, formatters)
      } else {
        output += array[i]
      }
    }
    return output
  }
}

function removeFormattingTokens (input) {
  if (input.match(/\[[\s\S]/)) {
    return input.replace(/^\[|]$/g, '')
  }
  return input.replace(/\\/g, '')
}

function formatTimezone (offset, delimeter) {
  delimeter = delimeter || ''
  var sign = offset > 0 ? '-' : '+'
  var absOffset = Math.abs(offset)
  var hours = Math.floor(absOffset / 60)
  var minutes = absOffset % 60
  return sign + addLeadingZeros(hours, 2) + delimeter + addLeadingZeros(minutes, 2)
}

function addLeadingZeros (number, targetLength) {
  var output = Math.abs(number).toString()
  while (output.length < targetLength) {
    output = '0' + output
  }
  return output
}

module.exports = format


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of month
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * var result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */
function getDate (dirtyDate) {
  var date = parse(dirtyDate)
  var dayOfMonth = date.getDate()
  return dayOfMonth
}

module.exports = getDate


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of week
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * var result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */
function getDay (dirtyDate) {
  var date = parse(dirtyDate)
  var day = date.getDay()
  return day
}

module.exports = getDay


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

var isLeapYear = __webpack_require__(309)

/**
 * @category Year Helpers
 * @summary Get the number of days in a year of the given date.
 *
 * @description
 * Get the number of days in a year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the number of days in a year
 *
 * @example
 * // How many days are in 2012?
 * var result = getDaysInYear(new Date(2012, 0, 1))
 * //=> 366
 */
function getDaysInYear (dirtyDate) {
  return isLeapYear(dirtyDate) ? 366 : 365
}

module.exports = getDaysInYear


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the hours
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * var result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */
function getHours (dirtyDate) {
  var date = parse(dirtyDate)
  var hours = date.getHours()
  return hours
}

module.exports = getHours


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

var startOfISOYear = __webpack_require__(109)
var addWeeks = __webpack_require__(196)

var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * @description
 * Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the number of ISO weeks in a year
 *
 * @example
 * // How many weeks are in ISO week-numbering year 2015?
 * var result = getISOWeeksInYear(new Date(2015, 1, 11))
 * //=> 53
 */
function getISOWeeksInYear (dirtyDate) {
  var thisYear = startOfISOYear(dirtyDate)
  var nextYear = startOfISOYear(addWeeks(thisYear, 60))
  var diff = nextYear.valueOf() - thisYear.valueOf()
  // Round the number of weeks to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK)
}

module.exports = getISOWeeksInYear


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Millisecond Helpers
 * @summary Get the milliseconds of the given date.
 *
 * @description
 * Get the milliseconds of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the milliseconds
 *
 * @example
 * // Get the milliseconds of 29 February 2012 11:45:05.123:
 * var result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 123
 */
function getMilliseconds (dirtyDate) {
  var date = parse(dirtyDate)
  var milliseconds = date.getMilliseconds()
  return milliseconds
}

module.exports = getMilliseconds


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the minutes
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * var result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */
function getMinutes (dirtyDate) {
  var date = parse(dirtyDate)
  var minutes = date.getMinutes()
  return minutes
}

module.exports = getMinutes


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the month
 *
 * @example
 * // Which month is 29 February 2012?
 * var result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */
function getMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var month = date.getMonth()
  return month
}

module.exports = getMonth


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

var MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000

/**
 * @category Range Helpers
 * @summary Get the number of days that overlap in two date ranges
 *
 * @description
 * Get the number of days that overlap in two date ranges
 *
 * @param {Date|String|Number} initialRangeStartDate - the start of the initial range
 * @param {Date|String|Number} initialRangeEndDate - the end of the initial range
 * @param {Date|String|Number} comparedRangeStartDate - the start of the range to compare it with
 * @param {Date|String|Number} comparedRangeEndDate - the end of the range to compare it with
 * @returns {Number} the number of days that overlap in two date ranges
 * @throws {Error} startDate of a date range cannot be after its endDate
 *
 * @example
 * // For overlapping date ranges adds 1 for each started overlapping day:
 * getOverlappingDaysInRanges(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 17), new Date(2014, 0, 21)
 * )
 * //=> 3
 *
 * @example
 * // For non-overlapping date ranges returns 0:
 * getOverlappingDaysInRanges(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 21), new Date(2014, 0, 22)
 * )
 * //=> 0
 */
function getOverlappingDaysInRanges (dirtyInitialRangeStartDate, dirtyInitialRangeEndDate, dirtyComparedRangeStartDate, dirtyComparedRangeEndDate) {
  var initialStartTime = parse(dirtyInitialRangeStartDate).getTime()
  var initialEndTime = parse(dirtyInitialRangeEndDate).getTime()
  var comparedStartTime = parse(dirtyComparedRangeStartDate).getTime()
  var comparedEndTime = parse(dirtyComparedRangeEndDate).getTime()

  if (initialStartTime > initialEndTime || comparedStartTime > comparedEndTime) {
    throw new Error('The start of the range cannot be after the end of the range')
  }

  var isOverlapping = initialStartTime < comparedEndTime && comparedStartTime < initialEndTime

  if (!isOverlapping) {
    return 0
  }

  var overlapStartDate = comparedStartTime < initialStartTime
    ? initialStartTime
    : comparedStartTime

  var overlapEndDate = comparedEndTime > initialEndTime
    ? initialEndTime
    : comparedEndTime

  var differenceInMs = overlapEndDate - overlapStartDate

  return Math.ceil(differenceInMs / MILLISECONDS_IN_DAY)
}

module.exports = getOverlappingDaysInRanges


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the seconds
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * var result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */
function getSeconds (dirtyDate) {
  var date = parse(dirtyDate)
  var seconds = date.getSeconds()
  return seconds
}

module.exports = getSeconds


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * var result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */
function getTime (dirtyDate) {
  var date = parse(dirtyDate)
  var timestamp = date.getTime()
  return timestamp
}

module.exports = getTime


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the year
 *
 * @example
 * // Which year is 2 July 2014?
 * var result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */
function getYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  return year
}

module.exports = getYear


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  addDays: __webpack_require__(106),
  addHours: __webpack_require__(293),
  addISOYears: __webpack_require__(294),
  addMilliseconds: __webpack_require__(107),
  addMinutes: __webpack_require__(295),
  addMonths: __webpack_require__(139),
  addQuarters: __webpack_require__(296),
  addSeconds: __webpack_require__(297),
  addWeeks: __webpack_require__(196),
  addYears: __webpack_require__(298),
  areRangesOverlapping: __webpack_require__(964),
  closestIndexTo: __webpack_require__(965),
  closestTo: __webpack_require__(966),
  compareAsc: __webpack_require__(108),
  compareDesc: __webpack_require__(197),
  differenceInCalendarDays: __webpack_require__(140),
  differenceInCalendarISOWeeks: __webpack_require__(967),
  differenceInCalendarISOYears: __webpack_require__(299),
  differenceInCalendarMonths: __webpack_require__(300),
  differenceInCalendarQuarters: __webpack_require__(968),
  differenceInCalendarWeeks: __webpack_require__(969),
  differenceInCalendarYears: __webpack_require__(301),
  differenceInDays: __webpack_require__(302),
  differenceInHours: __webpack_require__(970),
  differenceInISOYears: __webpack_require__(971),
  differenceInMilliseconds: __webpack_require__(141),
  differenceInMinutes: __webpack_require__(972),
  differenceInMonths: __webpack_require__(198),
  differenceInQuarters: __webpack_require__(973),
  differenceInSeconds: __webpack_require__(199),
  differenceInWeeks: __webpack_require__(974),
  differenceInYears: __webpack_require__(975),
  distanceInWords: __webpack_require__(303),
  distanceInWordsStrict: __webpack_require__(976),
  distanceInWordsToNow: __webpack_require__(977),
  eachDay: __webpack_require__(978),
  endOfDay: __webpack_require__(200),
  endOfHour: __webpack_require__(979),
  endOfISOWeek: __webpack_require__(980),
  endOfISOYear: __webpack_require__(981),
  endOfMinute: __webpack_require__(982),
  endOfMonth: __webpack_require__(304),
  endOfQuarter: __webpack_require__(983),
  endOfSecond: __webpack_require__(984),
  endOfToday: __webpack_require__(985),
  endOfTomorrow: __webpack_require__(986),
  endOfWeek: __webpack_require__(305),
  endOfYear: __webpack_require__(987),
  endOfYesterday: __webpack_require__(988),
  format: __webpack_require__(989),
  getDate: __webpack_require__(990),
  getDay: __webpack_require__(991),
  getDayOfYear: __webpack_require__(306),
  getDaysInMonth: __webpack_require__(201),
  getDaysInYear: __webpack_require__(992),
  getHours: __webpack_require__(993),
  getISODay: __webpack_require__(307),
  getISOWeek: __webpack_require__(202),
  getISOWeeksInYear: __webpack_require__(994),
  getISOYear: __webpack_require__(89),
  getMilliseconds: __webpack_require__(995),
  getMinutes: __webpack_require__(996),
  getMonth: __webpack_require__(997),
  getOverlappingDaysInRanges: __webpack_require__(998),
  getQuarter: __webpack_require__(308),
  getSeconds: __webpack_require__(999),
  getTime: __webpack_require__(1000),
  getYear: __webpack_require__(1001),
  isAfter: __webpack_require__(1003),
  isBefore: __webpack_require__(1004),
  isDate: __webpack_require__(203),
  isEqual: __webpack_require__(1005),
  isFirstDayOfMonth: __webpack_require__(1006),
  isFriday: __webpack_require__(1007),
  isFuture: __webpack_require__(1008),
  isLastDayOfMonth: __webpack_require__(1009),
  isLeapYear: __webpack_require__(309),
  isMonday: __webpack_require__(1010),
  isPast: __webpack_require__(1011),
  isSameDay: __webpack_require__(1012),
  isSameHour: __webpack_require__(310),
  isSameISOWeek: __webpack_require__(311),
  isSameISOYear: __webpack_require__(312),
  isSameMinute: __webpack_require__(313),
  isSameMonth: __webpack_require__(314),
  isSameQuarter: __webpack_require__(315),
  isSameSecond: __webpack_require__(316),
  isSameWeek: __webpack_require__(204),
  isSameYear: __webpack_require__(317),
  isSaturday: __webpack_require__(1013),
  isSunday: __webpack_require__(1014),
  isThisHour: __webpack_require__(1015),
  isThisISOWeek: __webpack_require__(1016),
  isThisISOYear: __webpack_require__(1017),
  isThisMinute: __webpack_require__(1018),
  isThisMonth: __webpack_require__(1019),
  isThisQuarter: __webpack_require__(1020),
  isThisSecond: __webpack_require__(1021),
  isThisWeek: __webpack_require__(1022),
  isThisYear: __webpack_require__(1023),
  isThursday: __webpack_require__(1024),
  isToday: __webpack_require__(1025),
  isTomorrow: __webpack_require__(1026),
  isTuesday: __webpack_require__(1027),
  isValid: __webpack_require__(318),
  isWednesday: __webpack_require__(1028),
  isWeekend: __webpack_require__(1029),
  isWithinRange: __webpack_require__(1030),
  isYesterday: __webpack_require__(1031),
  lastDayOfISOWeek: __webpack_require__(1032),
  lastDayOfISOYear: __webpack_require__(1033),
  lastDayOfMonth: __webpack_require__(1034),
  lastDayOfQuarter: __webpack_require__(1035),
  lastDayOfWeek: __webpack_require__(319),
  lastDayOfYear: __webpack_require__(1036),
  max: __webpack_require__(1040),
  min: __webpack_require__(1041),
  parse: __webpack_require__(4),
  setDate: __webpack_require__(1042),
  setDay: __webpack_require__(1043),
  setDayOfYear: __webpack_require__(1044),
  setHours: __webpack_require__(1045),
  setISODay: __webpack_require__(1046),
  setISOWeek: __webpack_require__(1047),
  setISOYear: __webpack_require__(320),
  setMilliseconds: __webpack_require__(1048),
  setMinutes: __webpack_require__(1049),
  setMonth: __webpack_require__(321),
  setQuarter: __webpack_require__(1050),
  setSeconds: __webpack_require__(1051),
  setYear: __webpack_require__(1052),
  startOfDay: __webpack_require__(90),
  startOfHour: __webpack_require__(322),
  startOfISOWeek: __webpack_require__(91),
  startOfISOYear: __webpack_require__(109),
  startOfMinute: __webpack_require__(323),
  startOfMonth: __webpack_require__(1053),
  startOfQuarter: __webpack_require__(324),
  startOfSecond: __webpack_require__(325),
  startOfToday: __webpack_require__(1054),
  startOfTomorrow: __webpack_require__(1055),
  startOfWeek: __webpack_require__(142),
  startOfYear: __webpack_require__(326),
  startOfYesterday: __webpack_require__(1056),
  subDays: __webpack_require__(1057),
  subHours: __webpack_require__(1058),
  subISOYears: __webpack_require__(327),
  subMilliseconds: __webpack_require__(1059),
  subMinutes: __webpack_require__(1060),
  subMonths: __webpack_require__(1061),
  subQuarters: __webpack_require__(1062),
  subSeconds: __webpack_require__(1063),
  subWeeks: __webpack_require__(1064),
  subYears: __webpack_require__(1065)
}


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|String|Number} date - the date that should be after the other one to return true
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter (dirtyDate, dirtyDateToCompare) {
  var date = parse(dirtyDate)
  var dateToCompare = parse(dirtyDateToCompare)
  return date.getTime() > dateToCompare.getTime()
}

module.exports = isAfter


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param {Date|String|Number} date - the date that should be before the other one to return true
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore (dirtyDate, dirtyDateToCompare) {
  var date = parse(dirtyDate)
  var dateToCompare = parse(dirtyDateToCompare)
  return date.getTime() < dateToCompare.getTime()
}

module.exports = isBefore


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * var result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0)
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */
function isEqual (dirtyLeftDate, dirtyRightDate) {
  var dateLeft = parse(dirtyLeftDate)
  var dateRight = parse(dirtyRightDate)
  return dateLeft.getTime() === dateRight.getTime()
}

module.exports = isEqual


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Month Helpers
 * @summary Is the given date the first day of a month?
 *
 * @description
 * Is the given date the first day of a month?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is the first day of a month
 *
 * @example
 * // Is 1 September 2014 the first day of a month?
 * var result = isFirstDayOfMonth(new Date(2014, 8, 1))
 * //=> true
 */
function isFirstDayOfMonth (dirtyDate) {
  return parse(dirtyDate).getDate() === 1
}

module.exports = isFirstDayOfMonth


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Weekday Helpers
 * @summary Is the given date Friday?
 *
 * @description
 * Is the given date Friday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Friday
 *
 * @example
 * // Is 26 September 2014 Friday?
 * var result = isFriday(new Date(2014, 8, 26))
 * //=> true
 */
function isFriday (dirtyDate) {
  return parse(dirtyDate).getDay() === 5
}

module.exports = isFriday


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Common Helpers
 * @summary Is the given date in the future?
 *
 * @description
 * Is the given date in the future?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in the future
 *
 * @example
 * // If today is 6 October 2014, is 31 December 2014 in the future?
 * var result = isFuture(new Date(2014, 11, 31))
 * //=> true
 */
function isFuture (dirtyDate) {
  return parse(dirtyDate).getTime() > new Date().getTime()
}

module.exports = isFuture


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)
var endOfDay = __webpack_require__(200)
var endOfMonth = __webpack_require__(304)

/**
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is the last day of a month
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * var result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */
function isLastDayOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  return endOfDay(date).getTime() === endOfMonth(date).getTime()
}

module.exports = isLastDayOfMonth


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Weekday Helpers
 * @summary Is the given date Monday?
 *
 * @description
 * Is the given date Monday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Monday
 *
 * @example
 * // Is 22 September 2014 Monday?
 * var result = isMonday(new Date(2014, 8, 22))
 * //=> true
 */
function isMonday (dirtyDate) {
  return parse(dirtyDate).getDay() === 1
}

module.exports = isMonday


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Common Helpers
 * @summary Is the given date in the past?
 *
 * @description
 * Is the given date in the past?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in the past
 *
 * @example
 * // If today is 6 October 2014, is 2 July 2014 in the past?
 * var result = isPast(new Date(2014, 6, 2))
 * //=> true
 */
function isPast (dirtyDate) {
  return parse(dirtyDate).getTime() < new Date().getTime()
}

module.exports = isPast


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(90)

/**
 * @category Day Helpers
 * @summary Are the given dates in the same day?
 *
 * @description
 * Are the given dates in the same day?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * var result = isSameDay(
 *   new Date(2014, 8, 4, 6, 0),
 *   new Date(2014, 8, 4, 18, 0)
 * )
 * //=> true
 */
function isSameDay (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft)
  var dateRightStartOfDay = startOfDay(dirtyDateRight)

  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime()
}

module.exports = isSameDay


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Weekday Helpers
 * @summary Is the given date Saturday?
 *
 * @description
 * Is the given date Saturday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Saturday
 *
 * @example
 * // Is 27 September 2014 Saturday?
 * var result = isSaturday(new Date(2014, 8, 27))
 * //=> true
 */
function isSaturday (dirtyDate) {
  return parse(dirtyDate).getDay() === 6
}

module.exports = isSaturday


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Weekday Helpers
 * @summary Is the given date Sunday?
 *
 * @description
 * Is the given date Sunday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Sunday
 *
 * @example
 * // Is 21 September 2014 Sunday?
 * var result = isSunday(new Date(2014, 8, 21))
 * //=> true
 */
function isSunday (dirtyDate) {
  return parse(dirtyDate).getDay() === 0
}

module.exports = isSunday


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

var isSameHour = __webpack_require__(310)

/**
 * @category Hour Helpers
 * @summary Is the given date in the same hour as the current date?
 *
 * @description
 * Is the given date in the same hour as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this hour
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:00:00 in this hour?
 * var result = isThisHour(new Date(2014, 8, 25, 18))
 * //=> true
 */
function isThisHour (dirtyDate) {
  return isSameHour(new Date(), dirtyDate)
}

module.exports = isThisHour


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

var isSameISOWeek = __webpack_require__(311)

/**
 * @category ISO Week Helpers
 * @summary Is the given date in the same ISO week as the current date?
 *
 * @description
 * Is the given date in the same ISO week as the current date?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this ISO week
 *
 * @example
 * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
 * var result = isThisISOWeek(new Date(2014, 8, 22))
 * //=> true
 */
function isThisISOWeek (dirtyDate) {
  return isSameISOWeek(new Date(), dirtyDate)
}

module.exports = isThisISOWeek


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

var isSameISOYear = __webpack_require__(312)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Is the given date in the same ISO week-numbering year as the current date?
 *
 * @description
 * Is the given date in the same ISO week-numbering year as the current date?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this ISO week-numbering year
 *
 * @example
 * // If today is 25 September 2014,
 * // is 30 December 2013 in this ISO week-numbering year?
 * var result = isThisISOYear(new Date(2013, 11, 30))
 * //=> true
 */
function isThisISOYear (dirtyDate) {
  return isSameISOYear(new Date(), dirtyDate)
}

module.exports = isThisISOYear


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

var isSameMinute = __webpack_require__(313)

/**
 * @category Minute Helpers
 * @summary Is the given date in the same minute as the current date?
 *
 * @description
 * Is the given date in the same minute as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this minute
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:00 in this minute?
 * var result = isThisMinute(new Date(2014, 8, 25, 18, 30))
 * //=> true
 */
function isThisMinute (dirtyDate) {
  return isSameMinute(new Date(), dirtyDate)
}

module.exports = isThisMinute


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

var isSameMonth = __webpack_require__(314)

/**
 * @category Month Helpers
 * @summary Is the given date in the same month as the current date?
 *
 * @description
 * Is the given date in the same month as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this month
 *
 * @example
 * // If today is 25 September 2014, is 15 September 2014 in this month?
 * var result = isThisMonth(new Date(2014, 8, 15))
 * //=> true
 */
function isThisMonth (dirtyDate) {
  return isSameMonth(new Date(), dirtyDate)
}

module.exports = isThisMonth


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

var isSameQuarter = __webpack_require__(315)

/**
 * @category Quarter Helpers
 * @summary Is the given date in the same quarter as the current date?
 *
 * @description
 * Is the given date in the same quarter as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this quarter
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this quarter?
 * var result = isThisQuarter(new Date(2014, 6, 2))
 * //=> true
 */
function isThisQuarter (dirtyDate) {
  return isSameQuarter(new Date(), dirtyDate)
}

module.exports = isThisQuarter


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

var isSameSecond = __webpack_require__(316)

/**
 * @category Second Helpers
 * @summary Is the given date in the same second as the current date?
 *
 * @description
 * Is the given date in the same second as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this second
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:15.000 in this second?
 * var result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
 * //=> true
 */
function isThisSecond (dirtyDate) {
  return isSameSecond(new Date(), dirtyDate)
}

module.exports = isThisSecond


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

var isSameWeek = __webpack_require__(204)

/**
 * @category Week Helpers
 * @summary Is the given date in the same week as the current date?
 *
 * @description
 * Is the given date in the same week as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Boolean} the date is in this week
 *
 * @example
 * // If today is 25 September 2014, is 21 September 2014 in this week?
 * var result = isThisWeek(new Date(2014, 8, 21))
 * //=> true
 *
 * @example
 * // If today is 25 September 2014 and week starts with Monday
 * // is 21 September 2014 in this week?
 * var result = isThisWeek(new Date(2014, 8, 21), {weekStartsOn: 1})
 * //=> false
 */
function isThisWeek (dirtyDate, dirtyOptions) {
  return isSameWeek(new Date(), dirtyDate, dirtyOptions)
}

module.exports = isThisWeek


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

var isSameYear = __webpack_require__(317)

/**
 * @category Year Helpers
 * @summary Is the given date in the same year as the current date?
 *
 * @description
 * Is the given date in the same year as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this year
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this year?
 * var result = isThisYear(new Date(2014, 6, 2))
 * //=> true
 */
function isThisYear (dirtyDate) {
  return isSameYear(new Date(), dirtyDate)
}

module.exports = isThisYear


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Weekday Helpers
 * @summary Is the given date Thursday?
 *
 * @description
 * Is the given date Thursday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Thursday
 *
 * @example
 * // Is 25 September 2014 Thursday?
 * var result = isThursday(new Date(2014, 8, 25))
 * //=> true
 */
function isThursday (dirtyDate) {
  return parse(dirtyDate).getDay() === 4
}

module.exports = isThursday


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(90)

/**
 * @category Day Helpers
 * @summary Is the given date today?
 *
 * @description
 * Is the given date today?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is today
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * var result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */
function isToday (dirtyDate) {
  return startOfDay(dirtyDate).getTime() === startOfDay(new Date()).getTime()
}

module.exports = isToday


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(90)

/**
 * @category Day Helpers
 * @summary Is the given date tomorrow?
 *
 * @description
 * Is the given date tomorrow?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is tomorrow
 *
 * @example
 * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
 * var result = isTomorrow(new Date(2014, 9, 7, 14, 0))
 * //=> true
 */
function isTomorrow (dirtyDate) {
  var tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 1)
  return startOfDay(dirtyDate).getTime() === startOfDay(tomorrow).getTime()
}

module.exports = isTomorrow


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Weekday Helpers
 * @summary Is the given date Tuesday?
 *
 * @description
 * Is the given date Tuesday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Tuesday
 *
 * @example
 * // Is 23 September 2014 Tuesday?
 * var result = isTuesday(new Date(2014, 8, 23))
 * //=> true
 */
function isTuesday (dirtyDate) {
  return parse(dirtyDate).getDay() === 2
}

module.exports = isTuesday


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Weekday Helpers
 * @summary Is the given date Wednesday?
 *
 * @description
 * Is the given date Wednesday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Wednesday
 *
 * @example
 * // Is 24 September 2014 Wednesday?
 * var result = isWednesday(new Date(2014, 8, 24))
 * //=> true
 */
function isWednesday (dirtyDate) {
  return parse(dirtyDate).getDay() === 3
}

module.exports = isWednesday


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Weekday Helpers
 * @summary Does the given date fall on a weekend?
 *
 * @description
 * Does the given date fall on a weekend?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date falls on a weekend
 *
 * @example
 * // Does 5 October 2014 fall on a weekend?
 * var result = isWeekend(new Date(2014, 9, 5))
 * //=> true
 */
function isWeekend (dirtyDate) {
  var date = parse(dirtyDate)
  var day = date.getDay()
  return day === 0 || day === 6
}

module.exports = isWeekend


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Range Helpers
 * @summary Is the given date within the range?
 *
 * @description
 * Is the given date within the range?
 *
 * @param {Date|String|Number} date - the date to check
 * @param {Date|String|Number} startDate - the start of range
 * @param {Date|String|Number} endDate - the end of range
 * @returns {Boolean} the date is within the range
 * @throws {Error} startDate cannot be after endDate
 *
 * @example
 * // For the date within the range:
 * isWithinRange(
 *   new Date(2014, 0, 3), new Date(2014, 0, 1), new Date(2014, 0, 7)
 * )
 * //=> true
 *
 * @example
 * // For the date outside of the range:
 * isWithinRange(
 *   new Date(2014, 0, 10), new Date(2014, 0, 1), new Date(2014, 0, 7)
 * )
 * //=> false
 */
function isWithinRange (dirtyDate, dirtyStartDate, dirtyEndDate) {
  var time = parse(dirtyDate).getTime()
  var startTime = parse(dirtyStartDate).getTime()
  var endTime = parse(dirtyEndDate).getTime()

  if (startTime > endTime) {
    throw new Error('The start of the range cannot be after the end of the range')
  }

  return time >= startTime && time <= endTime
}

module.exports = isWithinRange


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(90)

/**
 * @category Day Helpers
 * @summary Is the given date yesterday?
 *
 * @description
 * Is the given date yesterday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is yesterday
 *
 * @example
 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
 * var result = isYesterday(new Date(2014, 9, 5, 14, 0))
 * //=> true
 */
function isYesterday (dirtyDate) {
  var yesterday = new Date()
  yesterday.setDate(yesterday.getDate() - 1)
  return startOfDay(dirtyDate).getTime() === startOfDay(yesterday).getTime()
}

module.exports = isYesterday


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

var lastDayOfWeek = __webpack_require__(319)

/**
 * @category ISO Week Helpers
 * @summary Return the last day of an ISO week for the given date.
 *
 * @description
 * Return the last day of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of an ISO week
 *
 * @example
 * // The last day of an ISO week for 2 September 2014 11:55:00:
 * var result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 00:00:00
 */
function lastDayOfISOWeek (dirtyDate) {
  return lastDayOfWeek(dirtyDate, {weekStartsOn: 1})
}

module.exports = lastDayOfISOWeek


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__(89)
var startOfISOWeek = __webpack_require__(91)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the last day of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the last day of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an ISO week-numbering year
 *
 * @example
 * // The last day of an ISO week-numbering year for 2 July 2005:
 * var result = lastDayOfISOYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 00:00:00
 */
function lastDayOfISOYear (dirtyDate) {
  var year = getISOYear(dirtyDate)
  var fourthOfJanuary = new Date(0)
  fourthOfJanuary.setFullYear(year + 1, 0, 4)
  fourthOfJanuary.setHours(0, 0, 0, 0)
  var date = startOfISOWeek(fourthOfJanuary)
  date.setDate(date.getDate() - 1)
  return date
}

module.exports = lastDayOfISOYear


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Month Helpers
 * @summary Return the last day of a month for the given date.
 *
 * @description
 * Return the last day of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of a month
 *
 * @example
 * // The last day of a month for 2 September 2014 11:55:00:
 * var result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */
function lastDayOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var month = date.getMonth()
  date.setFullYear(date.getFullYear(), month + 1, 0)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = lastDayOfMonth


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Quarter Helpers
 * @summary Return the last day of a year quarter for the given date.
 *
 * @description
 * Return the last day of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of a quarter
 *
 * @example
 * // The last day of a quarter for 2 September 2014 11:55:00:
 * var result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */
function lastDayOfQuarter (dirtyDate) {
  var date = parse(dirtyDate)
  var currentMonth = date.getMonth()
  var month = currentMonth - currentMonth % 3 + 3
  date.setMonth(month, 0)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = lastDayOfQuarter


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Year Helpers
 * @summary Return the last day of a year for the given date.
 *
 * @description
 * Return the last day of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of a year
 *
 * @example
 * // The last day of a year for 2 September 2014 11:55:00:
 * var result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 00:00:00
 */
function lastDayOfYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  date.setFullYear(year + 1, 0, 0)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = lastDayOfYear


/***/ }),
/* 1037 */
/***/ (function(module, exports) {

var commonFormatterKeys = [
  'M', 'MM', 'Q', 'D', 'DD', 'DDD', 'DDDD', 'd',
  'E', 'W', 'WW', 'YY', 'YYYY', 'GG', 'GGGG',
  'H', 'HH', 'h', 'hh', 'm', 'mm',
  's', 'ss', 'S', 'SS', 'SSS',
  'Z', 'ZZ', 'X', 'x'
]

function buildFormattingTokensRegExp (formatters) {
  var formatterKeys = []
  for (var key in formatters) {
    if (formatters.hasOwnProperty(key)) {
      formatterKeys.push(key)
    }
  }

  var formattingTokens = commonFormatterKeys
    .concat(formatterKeys)
    .sort()
    .reverse()
  var formattingTokensRegExp = new RegExp(
    '(\\[[^\\[]*\\])|(\\\\)?' + '(' + formattingTokens.join('|') + '|.)', 'g'
  )

  return formattingTokensRegExp
}

module.exports = buildFormattingTokensRegExp


/***/ }),
/* 1038 */
/***/ (function(module, exports) {

function buildDistanceInWordsLocale () {
  var distanceInWordsLocale = {
    lessThanXSeconds: {
      one: 'less than a second',
      other: 'less than {{count}} seconds'
    },

    xSeconds: {
      one: '1 second',
      other: '{{count}} seconds'
    },

    halfAMinute: 'half a minute',

    lessThanXMinutes: {
      one: 'less than a minute',
      other: 'less than {{count}} minutes'
    },

    xMinutes: {
      one: '1 minute',
      other: '{{count}} minutes'
    },

    aboutXHours: {
      one: 'about 1 hour',
      other: 'about {{count}} hours'
    },

    xHours: {
      one: '1 hour',
      other: '{{count}} hours'
    },

    xDays: {
      one: '1 day',
      other: '{{count}} days'
    },

    aboutXMonths: {
      one: 'about 1 month',
      other: 'about {{count}} months'
    },

    xMonths: {
      one: '1 month',
      other: '{{count}} months'
    },

    aboutXYears: {
      one: 'about 1 year',
      other: 'about {{count}} years'
    },

    xYears: {
      one: '1 year',
      other: '{{count}} years'
    },

    overXYears: {
      one: 'over 1 year',
      other: 'over {{count}} years'
    },

    almostXYears: {
      one: 'almost 1 year',
      other: 'almost {{count}} years'
    }
  }

  function localize (token, count, options) {
    options = options || {}

    var result
    if (typeof distanceInWordsLocale[token] === 'string') {
      result = distanceInWordsLocale[token]
    } else if (count === 1) {
      result = distanceInWordsLocale[token].one
    } else {
      result = distanceInWordsLocale[token].other.replace('{{count}}', count)
    }

    if (options.addSuffix) {
      if (options.comparison > 0) {
        return 'in ' + result
      } else {
        return result + ' ago'
      }
    }

    return result
  }

  return {
    localize: localize
  }
}

module.exports = buildDistanceInWordsLocale


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

var buildFormattingTokensRegExp = __webpack_require__(1037)

function buildFormatLocale () {
  // Note: in English, the names of days of the week and months are capitalized.
  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
  // Generally, formatted dates should look like they are in the middle of a sentence,
  // e.g. in Spanish language the weekdays and months should be in the lowercase.
  var months3char = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  var monthsFull = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
  var weekdays2char = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']
  var weekdays3char = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
  var weekdaysFull = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  var meridiemUppercase = ['AM', 'PM']
  var meridiemLowercase = ['am', 'pm']
  var meridiemFull = ['a.m.', 'p.m.']

  var formatters = {
    // Month: Jan, Feb, ..., Dec
    'MMM': function (date) {
      return months3char[date.getMonth()]
    },

    // Month: January, February, ..., December
    'MMMM': function (date) {
      return monthsFull[date.getMonth()]
    },

    // Day of week: Su, Mo, ..., Sa
    'dd': function (date) {
      return weekdays2char[date.getDay()]
    },

    // Day of week: Sun, Mon, ..., Sat
    'ddd': function (date) {
      return weekdays3char[date.getDay()]
    },

    // Day of week: Sunday, Monday, ..., Saturday
    'dddd': function (date) {
      return weekdaysFull[date.getDay()]
    },

    // AM, PM
    'A': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemUppercase[1] : meridiemUppercase[0]
    },

    // am, pm
    'a': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemLowercase[1] : meridiemLowercase[0]
    },

    // a.m., p.m.
    'aa': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemFull[1] : meridiemFull[0]
    }
  }

  // Generate ordinal version of formatters: M -> Mo, D -> Do, etc.
  var ordinalFormatters = ['M', 'D', 'DDD', 'd', 'Q', 'W']
  ordinalFormatters.forEach(function (formatterToken) {
    formatters[formatterToken + 'o'] = function (date, formatters) {
      return ordinal(formatters[formatterToken](date))
    }
  })

  return {
    formatters: formatters,
    formattingTokensRegExp: buildFormattingTokensRegExp(formatters)
  }
}

function ordinal (number) {
  var rem100 = number % 100
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st'
      case 2:
        return number + 'nd'
      case 3:
        return number + 'rd'
    }
  }
  return number + 'th'
}

module.exports = buildFormatLocale


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @param {...(Date|String|Number)} dates - the dates to compare
 * @returns {Date} the latest of the dates
 *
 * @example
 * // Which of these dates is the latest?
 * var result = max(
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * )
 * //=> Sun Jul 02 1995 00:00:00
 */
function max () {
  var dirtyDates = Array.prototype.slice.call(arguments)
  var dates = dirtyDates.map(function (dirtyDate) {
    return parse(dirtyDate)
  })
  var latestTimestamp = Math.max.apply(null, dates)
  return new Date(latestTimestamp)
}

module.exports = max


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Common Helpers
 * @summary Return the earliest of the given dates.
 *
 * @description
 * Return the earliest of the given dates.
 *
 * @param {...(Date|String|Number)} dates - the dates to compare
 * @returns {Date} the earliest of the dates
 *
 * @example
 * // Which of these dates is the earliest?
 * var result = min(
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * )
 * //=> Wed Feb 11 1987 00:00:00
 */
function min () {
  var dirtyDates = Array.prototype.slice.call(arguments)
  var dates = dirtyDates.map(function (dirtyDate) {
    return parse(dirtyDate)
  })
  var earliestTimestamp = Math.min.apply(null, dates)
  return new Date(earliestTimestamp)
}

module.exports = min


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Day Helpers
 * @summary Set the day of the month to the given date.
 *
 * @description
 * Set the day of the month to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} dayOfMonth - the day of the month of the new date
 * @returns {Date} the new date with the day of the month setted
 *
 * @example
 * // Set the 30th day of the month to 1 September 2014:
 * var result = setDate(new Date(2014, 8, 1), 30)
 * //=> Tue Sep 30 2014 00:00:00
 */
function setDate (dirtyDate, dirtyDayOfMonth) {
  var date = parse(dirtyDate)
  var dayOfMonth = Number(dirtyDayOfMonth)
  date.setDate(dayOfMonth)
  return date
}

module.exports = setDate


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)
var addDays = __webpack_require__(106)

/**
 * @category Weekday Helpers
 * @summary Set the day of the week to the given date.
 *
 * @description
 * Set the day of the week to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} day - the day of the week of the new date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the new date with the day of the week setted
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * var result = setDay(new Date(2014, 8, 1), 0)
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If week starts with Monday, set Sunday to 1 September 2014:
 * var result = setDay(new Date(2014, 8, 1), 0, {weekStartsOn: 1})
 * //=> Sun Sep 07 2014 00:00:00
 */
function setDay (dirtyDate, dirtyDay, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0
  var date = parse(dirtyDate)
  var day = Number(dirtyDay)
  var currentDay = date.getDay()

  var remainder = day % 7
  var dayIndex = (remainder + 7) % 7

  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay
  return addDays(date, diff)
}

module.exports = setDay


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Day Helpers
 * @summary Set the day of the year to the given date.
 *
 * @description
 * Set the day of the year to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} dayOfYear - the day of the year of the new date
 * @returns {Date} the new date with the day of the year setted
 *
 * @example
 * // Set the 2nd day of the year to 2 July 2014:
 * var result = setDayOfYear(new Date(2014, 6, 2), 2)
 * //=> Thu Jan 02 2014 00:00:00
 */
function setDayOfYear (dirtyDate, dirtyDayOfYear) {
  var date = parse(dirtyDate)
  var dayOfYear = Number(dirtyDayOfYear)
  date.setMonth(0)
  date.setDate(dayOfYear)
  return date
}

module.exports = setDayOfYear


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} hours - the hours of the new date
 * @returns {Date} the new date with the hours setted
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */
function setHours (dirtyDate, dirtyHours) {
  var date = parse(dirtyDate)
  var hours = Number(dirtyHours)
  date.setHours(hours)
  return date
}

module.exports = setHours


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)
var addDays = __webpack_require__(106)
var getISODay = __webpack_require__(307)

/**
 * @category Weekday Helpers
 * @summary Set the day of the ISO week to the given date.
 *
 * @description
 * Set the day of the ISO week to the given date.
 * ISO week starts with Monday.
 * 7 is the index of Sunday, 1 is the index of Monday etc.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} day - the day of the ISO week of the new date
 * @returns {Date} the new date with the day of the ISO week setted
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * var result = setISODay(new Date(2014, 8, 1), 7)
 * //=> Sun Sep 07 2014 00:00:00
 */
function setISODay (dirtyDate, dirtyDay) {
  var date = parse(dirtyDate)
  var day = Number(dirtyDay)
  var currentDay = getISODay(date)
  var diff = day - currentDay
  return addDays(date, diff)
}

module.exports = setISODay


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)
var getISOWeek = __webpack_require__(202)

/**
 * @category ISO Week Helpers
 * @summary Set the ISO week to the given date.
 *
 * @description
 * Set the ISO week to the given date, saving the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} isoWeek - the ISO week of the new date
 * @returns {Date} the new date with the ISO week setted
 *
 * @example
 * // Set the 53rd ISO week to 7 August 2004:
 * var result = setISOWeek(new Date(2004, 7, 7), 53)
 * //=> Sat Jan 01 2005 00:00:00
 */
function setISOWeek (dirtyDate, dirtyISOWeek) {
  var date = parse(dirtyDate)
  var isoWeek = Number(dirtyISOWeek)
  var diff = getISOWeek(date) - isoWeek
  date.setDate(date.getDate() - diff * 7)
  return date
}

module.exports = setISOWeek


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Millisecond Helpers
 * @summary Set the milliseconds to the given date.
 *
 * @description
 * Set the milliseconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} milliseconds - the milliseconds of the new date
 * @returns {Date} the new date with the milliseconds setted
 *
 * @example
 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
 * var result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
 * //=> Mon Sep 01 2014 11:30:40.300
 */
function setMilliseconds (dirtyDate, dirtyMilliseconds) {
  var date = parse(dirtyDate)
  var milliseconds = Number(dirtyMilliseconds)
  date.setMilliseconds(milliseconds)
  return date
}

module.exports = setMilliseconds


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} minutes - the minutes of the new date
 * @returns {Date} the new date with the minutes setted
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * var result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */
function setMinutes (dirtyDate, dirtyMinutes) {
  var date = parse(dirtyDate)
  var minutes = Number(dirtyMinutes)
  date.setMinutes(minutes)
  return date
}

module.exports = setMinutes


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)
var setMonth = __webpack_require__(321)

/**
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} quarter - the quarter of the new date
 * @returns {Date} the new date with the quarter setted
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * var result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */
function setQuarter (dirtyDate, dirtyQuarter) {
  var date = parse(dirtyDate)
  var quarter = Number(dirtyQuarter)
  var oldQuarter = Math.floor(date.getMonth() / 3) + 1
  var diff = quarter - oldQuarter
  return setMonth(date, date.getMonth() + diff * 3)
}

module.exports = setQuarter


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} seconds - the seconds of the new date
 * @returns {Date} the new date with the seconds setted
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * var result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */
function setSeconds (dirtyDate, dirtySeconds) {
  var date = parse(dirtyDate)
  var seconds = Number(dirtySeconds)
  date.setSeconds(seconds)
  return date
}

module.exports = setSeconds


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} year - the year of the new date
 * @returns {Date} the new date with the year setted
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * var result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */
function setYear (dirtyDate, dirtyYear) {
  var date = parse(dirtyDate)
  var year = Number(dirtyYear)
  date.setFullYear(year)
  return date
}

module.exports = setYear


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(4)

/**
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * var result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  date.setDate(1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfMonth


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(90)

/**
 * @category Day Helpers
 * @summary Return the start of today.
 *
 * @description
 * Return the start of today.
 *
 * @returns {Date} the start of today
 *
 * @example
 * // If today is 6 October 2014:
 * var result = startOfToday()
 * //=> Mon Oct 6 2014 00:00:00
 */
function startOfToday () {
  return startOfDay(new Date())
}

module.exports = startOfToday


/***/ }),
/* 1055 */
/***/ (function(module, exports) {

/**
 * @category Day Helpers
 * @summary Return the start of tomorrow.
 *
 * @description
 * Return the start of tomorrow.
 *
 * @returns {Date} the start of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * var result = startOfTomorrow()
 * //=> Tue Oct 7 2014 00:00:00
 */
function startOfTomorrow () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var day = now.getDate()

  var date = new Date(0)
  date.setFullYear(year, month, day + 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfTomorrow


/***/ }),
/* 1056 */
/***/ (function(module, exports) {

/**
 * @category Day Helpers
 * @summary Return the start of yesterday.
 *
 * @description
 * Return the start of yesterday.
 *
 * @returns {Date} the start of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * var result = startOfYesterday()
 * //=> Sun Oct 5 2014 00:00:00
 */
function startOfYesterday () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var day = now.getDate()

  var date = new Date(0)
  date.setFullYear(year, month, day - 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfYesterday


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

var addDays = __webpack_require__(106)

/**
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted
 * @returns {Date} the new date with the days subtracted
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * var result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */
function subDays (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addDays(dirtyDate, -amount)
}

module.exports = subDays


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

var addHours = __webpack_require__(293)

/**
 * @category Hour Helpers
 * @summary Subtract the specified number of hours from the given date.
 *
 * @description
 * Subtract the specified number of hours from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be subtracted
 * @returns {Date} the new date with the hours subtracted
 *
 * @example
 * // Subtract 2 hours from 11 July 2014 01:00:00:
 * var result = subHours(new Date(2014, 6, 11, 1, 0), 2)
 * //=> Thu Jul 10 2014 23:00:00
 */
function subHours (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addHours(dirtyDate, -amount)
}

module.exports = subHours


/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

var addMilliseconds = __webpack_require__(107)

/**
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted
 * @returns {Date} the new date with the milliseconds subtracted
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * var result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMilliseconds(dirtyDate, -amount)
}

module.exports = subMilliseconds


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

var addMinutes = __webpack_require__(295)

/**
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be subtracted
 * @returns {Date} the new date with the mintues subtracted
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * var result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */
function subMinutes (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMinutes(dirtyDate, -amount)
}

module.exports = subMinutes


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

var addMonths = __webpack_require__(139)

/**
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted
 * @returns {Date} the new date with the months subtracted
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * var result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */
function subMonths (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMonths(dirtyDate, -amount)
}

module.exports = subMonths


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

var addQuarters = __webpack_require__(296)

/**
 * @category Quarter Helpers
 * @summary Subtract the specified number of year quarters from the given date.
 *
 * @description
 * Subtract the specified number of year quarters from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of quarters to be subtracted
 * @returns {Date} the new date with the quarters subtracted
 *
 * @example
 * // Subtract 3 quarters from 1 September 2014:
 * var result = subQuarters(new Date(2014, 8, 1), 3)
 * //=> Sun Dec 01 2013 00:00:00
 */
function subQuarters (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addQuarters(dirtyDate, -amount)
}

module.exports = subQuarters


/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

var addSeconds = __webpack_require__(297)

/**
 * @category Second Helpers
 * @summary Subtract the specified number of seconds from the given date.
 *
 * @description
 * Subtract the specified number of seconds from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of seconds to be subtracted
 * @returns {Date} the new date with the seconds subtracted
 *
 * @example
 * // Subtract 30 seconds from 10 July 2014 12:45:00:
 * var result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:44:30
 */
function subSeconds (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addSeconds(dirtyDate, -amount)
}

module.exports = subSeconds


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

var addWeeks = __webpack_require__(196)

/**
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be subtracted
 * @returns {Date} the new date with the weeks subtracted
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * var result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */
function subWeeks (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addWeeks(dirtyDate, -amount)
}

module.exports = subWeeks


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

var addYears = __webpack_require__(298)

/**
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be subtracted
 * @returns {Date} the new date with the years subtracted
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * var result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */
function subYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addYears(dirtyDate, -amount)
}

module.exports = subYears


/***/ }),
/* 1066 */
/***/ (function(module, exports) {

var DOCUMENT_NODE_TYPE = 9;

/**
 * A polyfill for Element.matches()
 */
if (typeof Element !== 'undefined' && !Element.prototype.matches) {
    var proto = Element.prototype;

    proto.matches = proto.matchesSelector ||
                    proto.mozMatchesSelector ||
                    proto.msMatchesSelector ||
                    proto.oMatchesSelector ||
                    proto.webkitMatchesSelector;
}

/**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */
function closest (element, selector) {
    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
        if (typeof element.matches === 'function' &&
            element.matches(selector)) {
          return element;
        }
        element = element.parentNode;
    }
}

module.exports = closest;


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

var closest = __webpack_require__(1066);

/**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function delegate(element, selector, type, callback, useCapture) {
    var listenerFn = listener.apply(this, arguments);

    element.addEventListener(type, listenerFn, useCapture);

    return {
        destroy: function() {
            element.removeEventListener(type, listenerFn, useCapture);
        }
    }
}

/**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */
function listener(element, selector, type, callback) {
    return function(e) {
        e.delegateTarget = closest(e.target, selector);

        if (e.delegateTarget) {
            callback.call(element, e);
        }
    }
}

module.exports = delegate;


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/close.svg?cb3314fab92e95d3b42d24c69597de52";

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1201_01.jpg?c573c19409377f93e76b6e8bc5bdfc28";

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1201_02.jpg?92a3e5420f03b27a3ac8eb43b8d74cda";

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1201_03.jpg?65f1c5ac81573d1db4274a48ee4db855";

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1303.jpg?d24bb1cf305fc491f0aeae3c0aa8fe8c";

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1403_01.jpg?697440d633d952b36ebb77a08eee5223";

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1403_02.jpg?60bc0e06b4a93b6a57c1a532f19af23c";

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1403_03.jpg?847b1d72060ce5fcb5d775563e04f1dc";

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1406.jpg?61ca152af26b9737096ea3995a4bc811";

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1408.jpg?0b923312381bbcd9c4299dcc8c40be4b";

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1410.jpg?200380e70f17cd28aa94dd59a7aaae2e";

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1411.jpg?11acf7b5fa5c4725d886641931b62f76";

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1414_01.jpg?c7c2287389170665bd21d585b46b93c9";

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1414_02.jpg?3a52535e68b85b4236c2e95985a57387";

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1414_03.jpg?0529dd46a33b52c4486cef265e00aef0";

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1414_04.jpg?cd646b2e9ddd75277786b64c1fa2be85";

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1414_05.jpg?9e5edc57bd9a433a60628adda3ef4ef4";

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1501.jpg?f0c5eed41116d25f2abd3c58975a28d1";

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1506_01.jpg?e4a71dadf2f98f98e6e4be3dddb8eb60";

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1506_02.jpg?99ef6325877740eb563e2ed3625b9c78";

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1506_03.jpg?7acc75fc515f59ad39b2cf3bae4a26e5";

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1506_04.jpg?5eca317ce5425d4e35bac9d2aeec8835";

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1506_05.jpg?ad54883b546a096ea2caf6e708c621c1";

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1512_01.jpg?f85e6b88c1fdec39949639122abdd49e";

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1512_02.jpg?c1cd7c001f72334e7f563a18e113a943";

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1512_03.jpg?c74b372431a0884b73451529dbd323f2";

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1512_04.jpg?c9968e79dae80c96ad4cbf29be34a6a3";

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1601_01.jpg?3a295d4b611d2ba2f6b50d12e118f838";

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1601_02.jpg?4d3ea44ed9b110e113256a1d910060c5";

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1601_03.jpg?9ac52904518cc1be9def0084f91e5383";

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1602_01.jpg?77dce9e5cbe212027b9ea8fc03384aab";

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1602_02.jpg?053e79b529f8997eb829543307b7a1d3";

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1602_03.jpg?79357fe4f2d9b03f2064ae9529df00f3";

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1602_04.jpg?12e4a5608fc651011726fdee1e42dbb5";

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1602_05.jpg?cc4fa9bda23cb26472ec5d92fe8b9d85";

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1602_06.jpg?253880f7b95f9c75ed7b2a69388b1975";

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1605_01.jpg?8a695ea2d5965b7d4861b1fd81e0c086";

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1605_02.jpg?07a37d3fe32c6557d78b32e04a31ea32";

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1605_03.jpg?b892551deb17d3ce4c8c0b1d19749c12";

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1605_04.jpg?f17c1569d1a3e5841b2f6d61799781be";

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1605_05.jpg?050bb4903ffe4e4653c76acdf44fb33e";

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1605_06.jpg?b7930b012e2b4d111ca78cdac71f47db";

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1605_07.jpg?7e3073bfe4f8c6b55875e32b707e4541";

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1606_01.jpg?236df0f08bbb849dc223324b33bf17b7";

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1606_02.jpg?0719e393d23462af87d8053338f8cd90";

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1606_03.jpg?a7cb21be9cb2221b7dcb2eb97ab5f14d";

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1608.jpg?764f4c3a91e00c831095a0eee7956abd";

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1609.jpg?fc742939ee0aac88fc358bde2b655d9c";

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1610.jpg?655ce2fa09e1741fd99c0061f7973cee";

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1611.jpg?2a6efd4fb326362b21d887e1fc0e005b";

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1612_01.jpg?c7296f84de036488685a4539b6dcdce2";

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1612_02.jpg?2193f88de865fe308b7de590e2ce7870";

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1701_01.jpg?f92602c177ddcbf2bee24b8ced329012";

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1701_02.jpg?06fa131e7919abb97b8d999235eeaff1";

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1701_03.jpg?24ff4a8ab9b1110b4781c741ed132e27";

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1701_04.jpg?43a7be396341ffc6a2c5a9946decde82";

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1701_05.jpg?9a8b2da70e783e204d6358253cacab06";

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1701_06.jpg?9e1be1807e5255753a152efb24b7d80c";

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1706.jpg?a93bc0c8d1792e15181c5d7bc1a348c3";

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1708_lq.jpg?6433420f44e25585ba352f2265186281";

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1804.jpg?f03d7444baf318e3e4ac665352890afb";

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1809_1.jpg?e16eb8f83e9d88c505c8419c1840f3f4";

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1809_2.jpg?bd0fc123ecdefe63c1df53740cd99d76";

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/1902.jpg?3640f55569cfbdf89b5cb3cfab93c035";

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/bt_logo_tr.png?bb84a9fe860099b3462fcf0b0ef45973";

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/logo.png?74a89367edafc18a39975a12d58adee0";

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/img/logo_bde.png?bf4abeaeb3437eb05d7a3baa062ebe6b";

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/adobe_caslon_pro.cc899199fbbedadb0e2fe5e3477b5124.woff";

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/aktivgrotesk-corp-bold.0174a06d5d14fbe7b87e705c87e6408a.woff";

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/aktivgrotesk-corp-regular.082ad4bb3b2bca1897b4f459fc0490da.woff";

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*! @license Firebase v3.9.0
Build: rev-cc77c9e
Terms: https://firebase.google.com/terms/ */

var firebase = __webpack_require__(110);
(function(){
(function(){var h,aa=aa||{},l=this,ba=function(){},ca=function(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&
!a.propertyIsEnumerable("call"))return"function"}else return"null";else if("function"==b&&"undefined"==typeof a.call)return"object";return b},da=function(a){return null===a},ea=function(a){return"array"==ca(a)},fa=function(a){var b=ca(a);return"array"==b||"object"==b&&"number"==typeof a.length},m=function(a){return"string"==typeof a},ga=function(a){return"number"==typeof a},p=function(a){return"function"==ca(a)},ha=function(a){var b=typeof a;return"object"==b&&null!=a||"function"==b},ia=function(a,
b,c){return a.call.apply(a.bind,arguments)},ja=function(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}},q=function(a,b,c){q=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?ia:ja;return q.apply(null,arguments)},ka=function(a,b){var c=Array.prototype.slice.call(arguments,
1);return function(){var b=c.slice();b.push.apply(b,arguments);return a.apply(this,b)}},la=Date.now||function(){return+new Date},r=function(a,b){function c(){}c.prototype=b.prototype;a.xd=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.Tf=function(a,c,f){for(var d=Array(arguments.length-2),e=2;e<arguments.length;e++)d[e-2]=arguments[e];return b.prototype[c].apply(a,d)}};var t=function(a){if(Error.captureStackTrace)Error.captureStackTrace(this,t);else{var b=Error().stack;b&&(this.stack=b)}a&&(this.message=String(a))};r(t,Error);t.prototype.name="CustomError";var ma=function(a,b){for(var c=a.split("%s"),d="",e=Array.prototype.slice.call(arguments,1);e.length&&1<c.length;)d+=c.shift()+e.shift();return d+c.join("%s")},na=String.prototype.trim?function(a){return a.trim()}:function(a){return a.replace(/^[\s\xa0]+|[\s\xa0]+$/g,"")},oa=/&/g,pa=/</g,qa=/>/g,ra=/"/g,sa=/'/g,ta=/\x00/g,ua=/[\x00&<>"']/,u=function(a,b){return-1!=a.indexOf(b)},va=function(a,b){return a<b?-1:a>b?1:0};var wa=function(a,b){b.unshift(a);t.call(this,ma.apply(null,b));b.shift()};r(wa,t);wa.prototype.name="AssertionError";
var xa=function(a,b,c,d){var e="Assertion failed";if(c)var e=e+(": "+c),f=d;else a&&(e+=": "+a,f=b);throw new wa(""+e,f||[]);},v=function(a,b,c){a||xa("",null,b,Array.prototype.slice.call(arguments,2))},ya=function(a,b){throw new wa("Failure"+(a?": "+a:""),Array.prototype.slice.call(arguments,1));},za=function(a,b,c){ga(a)||xa("Expected number but got %s: %s.",[ca(a),a],b,Array.prototype.slice.call(arguments,2));return a},Aa=function(a,b,c){m(a)||xa("Expected string but got %s: %s.",[ca(a),a],b,Array.prototype.slice.call(arguments,
2))},Ba=function(a,b,c){p(a)||xa("Expected function but got %s: %s.",[ca(a),a],b,Array.prototype.slice.call(arguments,2))};var Ca=Array.prototype.indexOf?function(a,b,c){v(null!=a.length);return Array.prototype.indexOf.call(a,b,c)}:function(a,b,c){c=null==c?0:0>c?Math.max(0,a.length+c):c;if(m(a))return m(b)&&1==b.length?a.indexOf(b,c):-1;for(;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1},w=Array.prototype.forEach?function(a,b,c){v(null!=a.length);Array.prototype.forEach.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=m(a)?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a)},Da=function(a,b){for(var c=m(a)?
a.split(""):a,d=a.length-1;0<=d;--d)d in c&&b.call(void 0,c[d],d,a)},Ea=Array.prototype.map?function(a,b,c){v(null!=a.length);return Array.prototype.map.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=Array(d),f=m(a)?a.split(""):a,g=0;g<d;g++)g in f&&(e[g]=b.call(c,f[g],g,a));return e},Fa=Array.prototype.some?function(a,b,c){v(null!=a.length);return Array.prototype.some.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=m(a)?a.split(""):a,f=0;f<d;f++)if(f in e&&b.call(c,e[f],f,a))return!0;return!1},
Ha=function(a){var b;a:{b=Ga;for(var c=a.length,d=m(a)?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a)){b=e;break a}b=-1}return 0>b?null:m(a)?a.charAt(b):a[b]},Ia=function(a,b){return 0<=Ca(a,b)},Ka=function(a,b){b=Ca(a,b);var c;(c=0<=b)&&Ja(a,b);return c},Ja=function(a,b){v(null!=a.length);return 1==Array.prototype.splice.call(a,b,1).length},La=function(a,b){var c=0;Da(a,function(d,e){b.call(void 0,d,e,a)&&Ja(a,e)&&c++})},Ma=function(a){return Array.prototype.concat.apply([],arguments)},
Na=function(a){var b=a.length;if(0<b){for(var c=Array(b),d=0;d<b;d++)c[d]=a[d];return c}return[]};var Oa=function(a){return Ea(a,function(a){a=a.toString(16);return 1<a.length?a:"0"+a}).join("")};var Pa;a:{var Qa=l.navigator;if(Qa){var Ra=Qa.userAgent;if(Ra){Pa=Ra;break a}}Pa=""}var x=function(a){return u(Pa,a)};var Sa=function(a,b){for(var c in a)b.call(void 0,a[c],c,a)},Ta=function(a){var b=[],c=0,d;for(d in a)b[c++]=a[d];return b},Ua=function(a){var b=[],c=0,d;for(d in a)b[c++]=d;return b},Va=function(a){for(var b in a)return!1;return!0},Wa=function(a,b){for(var c in a)if(!(c in b)||a[c]!==b[c])return!1;for(c in b)if(!(c in a))return!1;return!0},Xa=function(a){var b={},c;for(c in a)b[c]=a[c];return b},Ya="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" "),
Za=function(a,b){for(var c,d,e=1;e<arguments.length;e++){d=arguments[e];for(c in d)a[c]=d[c];for(var f=0;f<Ya.length;f++)c=Ya[f],Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c])}};var $a=function(a){$a[" "](a);return a};$a[" "]=ba;var bb=function(a,b){var c=ab;return Object.prototype.hasOwnProperty.call(c,a)?c[a]:c[a]=b(a)};var cb=x("Opera"),y=x("Trident")||x("MSIE"),eb=x("Edge"),fb=eb||y,gb=x("Gecko")&&!(u(Pa.toLowerCase(),"webkit")&&!x("Edge"))&&!(x("Trident")||x("MSIE"))&&!x("Edge"),hb=u(Pa.toLowerCase(),"webkit")&&!x("Edge"),ib=function(){var a=l.document;return a?a.documentMode:void 0},jb;
a:{var kb="",lb=function(){var a=Pa;if(gb)return/rv\:([^\);]+)(\)|;)/.exec(a);if(eb)return/Edge\/([\d\.]+)/.exec(a);if(y)return/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);if(hb)return/WebKit\/(\S+)/.exec(a);if(cb)return/(?:Version)[ \/]?(\S+)/.exec(a)}();lb&&(kb=lb?lb[1]:"");if(y){var mb=ib();if(null!=mb&&mb>parseFloat(kb)){jb=String(mb);break a}}jb=kb}
var nb=jb,ab={},z=function(a){return bb(a,function(){for(var b=0,c=na(String(nb)).split("."),d=na(String(a)).split("."),e=Math.max(c.length,d.length),f=0;0==b&&f<e;f++){var g=c[f]||"",k=d[f]||"";do{g=/(\d*)(\D*)(.*)/.exec(g)||["","","",""];k=/(\d*)(\D*)(.*)/.exec(k)||["","","",""];if(0==g[0].length&&0==k[0].length)break;b=va(0==g[1].length?0:parseInt(g[1],10),0==k[1].length?0:parseInt(k[1],10))||va(0==g[2].length,0==k[2].length)||va(g[2],k[2]);g=g[3];k=k[3]}while(0==b)}return 0<=b})},ob;var pb=l.document;
ob=pb&&y?ib()||("CSS1Compat"==pb.compatMode?parseInt(nb,10):5):void 0;var qb=null,rb=null,tb=function(a){var b="";sb(a,function(a){b+=String.fromCharCode(a)});return b},sb=function(a,b){function c(b){for(;d<a.length;){var c=a.charAt(d++),e=rb[c];if(null!=e)return e;if(!/^[\s\xa0]*$/.test(c))throw Error("Unknown base64 encoding at char: "+c);}return b}ub();for(var d=0;;){var e=c(-1),f=c(0),g=c(64),k=c(64);if(64===k&&-1===e)break;b(e<<2|f>>4);64!=g&&(b(f<<4&240|g>>2),64!=k&&b(g<<6&192|k))}},ub=function(){if(!qb){qb={};rb={};for(var a=0;65>a;a++)qb[a]="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(a),
rb[qb[a]]=a,62<=a&&(rb["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_.".charAt(a)]=a)}};var vb=function(){this.Da=-1};var yb=function(a,b){this.Da=64;this.ec=l.Uint8Array?new Uint8Array(this.Da):Array(this.Da);this.Fc=this.hb=0;this.h=[];this.lf=a;this.Wd=b;this.Mf=l.Int32Array?new Int32Array(64):Array(64);void 0!==wb||(wb=l.Int32Array?new Int32Array(xb):xb);this.reset()},wb;r(yb,vb);for(var zb=[],Ab=0;63>Ab;Ab++)zb[Ab]=0;var Bb=Ma(128,zb);yb.prototype.reset=function(){this.Fc=this.hb=0;this.h=l.Int32Array?new Int32Array(this.Wd):Na(this.Wd)};
var Cb=function(a){var b=a.ec;v(b.length==a.Da);for(var c=a.Mf,d=0,e=0;e<b.length;)c[d++]=b[e]<<24|b[e+1]<<16|b[e+2]<<8|b[e+3],e=4*d;for(b=16;64>b;b++){var e=c[b-15]|0,d=c[b-2]|0,f=(c[b-16]|0)+((e>>>7|e<<25)^(e>>>18|e<<14)^e>>>3)|0,g=(c[b-7]|0)+((d>>>17|d<<15)^(d>>>19|d<<13)^d>>>10)|0;c[b]=f+g|0}for(var d=a.h[0]|0,e=a.h[1]|0,k=a.h[2]|0,n=a.h[3]|0,C=a.h[4]|0,db=a.h[5]|0,Pb=a.h[6]|0,f=a.h[7]|0,b=0;64>b;b++)var Ah=((d>>>2|d<<30)^(d>>>13|d<<19)^(d>>>22|d<<10))+(d&e^d&k^e&k)|0,g=C&db^~C&Pb,f=f+((C>>>6|
C<<26)^(C>>>11|C<<21)^(C>>>25|C<<7))|0,g=g+(wb[b]|0)|0,g=f+(g+(c[b]|0)|0)|0,f=Pb,Pb=db,db=C,C=n+g|0,n=k,k=e,e=d,d=g+Ah|0;a.h[0]=a.h[0]+d|0;a.h[1]=a.h[1]+e|0;a.h[2]=a.h[2]+k|0;a.h[3]=a.h[3]+n|0;a.h[4]=a.h[4]+C|0;a.h[5]=a.h[5]+db|0;a.h[6]=a.h[6]+Pb|0;a.h[7]=a.h[7]+f|0};
yb.prototype.update=function(a,b){void 0===b&&(b=a.length);var c=0,d=this.hb;if(m(a))for(;c<b;)this.ec[d++]=a.charCodeAt(c++),d==this.Da&&(Cb(this),d=0);else if(fa(a))for(;c<b;){var e=a[c++];if(!("number"==typeof e&&0<=e&&255>=e&&e==(e|0)))throw Error("message must be a byte array");this.ec[d++]=e;d==this.Da&&(Cb(this),d=0)}else throw Error("message must be string or array");this.hb=d;this.Fc+=b};
yb.prototype.digest=function(){var a=[],b=8*this.Fc;56>this.hb?this.update(Bb,56-this.hb):this.update(Bb,this.Da-(this.hb-56));for(var c=63;56<=c;c--)this.ec[c]=b&255,b/=256;Cb(this);for(c=b=0;c<this.lf;c++)for(var d=24;0<=d;d-=8)a[b++]=this.h[c]>>d&255;return a};
var xb=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,
4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];var Eb=function(){yb.call(this,8,Db)};r(Eb,yb);var Db=[1779033703,3144134277,1013904242,2773480762,1359893119,2600822924,528734635,1541459225];var Fb=function(){this.Ga=this.Ga;this.tc=this.tc};Fb.prototype.Ga=!1;Fb.prototype.isDisposed=function(){return this.Ga};Fb.prototype.cb=function(){if(this.tc)for(;this.tc.length;)this.tc.shift()()};var Gb=!y||9<=Number(ob),Hb=y&&!z("9");!hb||z("528");gb&&z("1.9b")||y&&z("8")||cb&&z("9.5")||hb&&z("528");gb&&!z("8")||y&&z("9");var Ib=function(a,b){this.type=a;this.currentTarget=this.target=b;this.defaultPrevented=this.nb=!1;this.ee=!0};Ib.prototype.preventDefault=function(){this.defaultPrevented=!0;this.ee=!1};var Jb=function(a,b){Ib.call(this,a?a.type:"");this.relatedTarget=this.currentTarget=this.target=null;this.button=this.screenY=this.screenX=this.clientY=this.clientX=this.offsetY=this.offsetX=0;this.key="";this.charCode=this.keyCode=0;this.metaKey=this.shiftKey=this.altKey=this.ctrlKey=!1;this.eb=this.state=null;a&&this.init(a,b)};r(Jb,Ib);
Jb.prototype.init=function(a,b){var c=this.type=a.type,d=a.changedTouches?a.changedTouches[0]:null;this.target=a.target||a.srcElement;this.currentTarget=b;if(b=a.relatedTarget){if(gb){var e;a:{try{$a(b.nodeName);e=!0;break a}catch(f){}e=!1}e||(b=null)}}else"mouseover"==c?b=a.fromElement:"mouseout"==c&&(b=a.toElement);this.relatedTarget=b;null===d?(this.offsetX=hb||void 0!==a.offsetX?a.offsetX:a.layerX,this.offsetY=hb||void 0!==a.offsetY?a.offsetY:a.layerY,this.clientX=void 0!==a.clientX?a.clientX:
a.pageX,this.clientY=void 0!==a.clientY?a.clientY:a.pageY,this.screenX=a.screenX||0,this.screenY=a.screenY||0):(this.clientX=void 0!==d.clientX?d.clientX:d.pageX,this.clientY=void 0!==d.clientY?d.clientY:d.pageY,this.screenX=d.screenX||0,this.screenY=d.screenY||0);this.button=a.button;this.keyCode=a.keyCode||0;this.key=a.key||"";this.charCode=a.charCode||("keypress"==c?a.keyCode:0);this.ctrlKey=a.ctrlKey;this.altKey=a.altKey;this.shiftKey=a.shiftKey;this.metaKey=a.metaKey;this.state=a.state;this.eb=
a;a.defaultPrevented&&this.preventDefault()};Jb.prototype.preventDefault=function(){Jb.xd.preventDefault.call(this);var a=this.eb;if(a.preventDefault)a.preventDefault();else if(a.returnValue=!1,Hb)try{if(a.ctrlKey||112<=a.keyCode&&123>=a.keyCode)a.keyCode=-1}catch(b){}};Jb.prototype.Pe=function(){return this.eb};var Kb="closure_listenable_"+(1E6*Math.random()|0),Lb=0;var Mb=function(a,b,c,d,e){this.listener=a;this.xc=null;this.src=b;this.type=c;this.capture=!!d;this.kc=e;this.key=++Lb;this.rb=this.dc=!1},Nb=function(a){a.rb=!0;a.listener=null;a.xc=null;a.src=null;a.kc=null};var Ob=function(a){this.src=a;this.G={};this.$b=0};Ob.prototype.add=function(a,b,c,d,e){var f=a.toString();a=this.G[f];a||(a=this.G[f]=[],this.$b++);var g=Qb(a,b,d,e);-1<g?(b=a[g],c||(b.dc=!1)):(b=new Mb(b,this.src,f,!!d,e),b.dc=c,a.push(b));return b};Ob.prototype.remove=function(a,b,c,d){a=a.toString();if(!(a in this.G))return!1;var e=this.G[a];b=Qb(e,b,c,d);return-1<b?(Nb(e[b]),Ja(e,b),0==e.length&&(delete this.G[a],this.$b--),!0):!1};
var Rb=function(a,b){var c=b.type;c in a.G&&Ka(a.G[c],b)&&(Nb(b),0==a.G[c].length&&(delete a.G[c],a.$b--))};Ob.prototype.Uc=function(a,b,c,d){a=this.G[a.toString()];var e=-1;a&&(e=Qb(a,b,c,d));return-1<e?a[e]:null};var Qb=function(a,b,c,d){for(var e=0;e<a.length;++e){var f=a[e];if(!f.rb&&f.listener==b&&f.capture==!!c&&f.kc==d)return e}return-1};var Sb="closure_lm_"+(1E6*Math.random()|0),Tb={},Ub=0,Vb=function(a,b,c,d,e){if(ea(b))for(var f=0;f<b.length;f++)Vb(a,b[f],c,d,e);else c=Wb(c),a&&a[Kb]?a.listen(b,c,d,e):Xb(a,b,c,!1,d,e)},Xb=function(a,b,c,d,e,f){if(!b)throw Error("Invalid event type");var g=!!e,k=Yb(a);k||(a[Sb]=k=new Ob(a));c=k.add(b,c,d,e,f);if(!c.xc){d=Zb();c.xc=d;d.src=a;d.listener=c;if(a.addEventListener)a.addEventListener(b.toString(),d,g);else if(a.attachEvent)a.attachEvent($b(b.toString()),d);else throw Error("addEventListener and attachEvent are unavailable.");
Ub++}},Zb=function(){var a=ac,b=Gb?function(c){return a.call(b.src,b.listener,c)}:function(c){c=a.call(b.src,b.listener,c);if(!c)return c};return b},bc=function(a,b,c,d,e){if(ea(b))for(var f=0;f<b.length;f++)bc(a,b[f],c,d,e);else c=Wb(c),a&&a[Kb]?cc(a,b,c,d,e):Xb(a,b,c,!0,d,e)},dc=function(a,b,c,d,e){if(ea(b))for(var f=0;f<b.length;f++)dc(a,b[f],c,d,e);else c=Wb(c),a&&a[Kb]?a.fa.remove(String(b),c,d,e):a&&(a=Yb(a))&&(b=a.Uc(b,c,!!d,e))&&ec(b)},ec=function(a){if(!ga(a)&&a&&!a.rb){var b=a.src;if(b&&
b[Kb])Rb(b.fa,a);else{var c=a.type,d=a.xc;b.removeEventListener?b.removeEventListener(c,d,a.capture):b.detachEvent&&b.detachEvent($b(c),d);Ub--;(c=Yb(b))?(Rb(c,a),0==c.$b&&(c.src=null,b[Sb]=null)):Nb(a)}}},$b=function(a){return a in Tb?Tb[a]:Tb[a]="on"+a},gc=function(a,b,c,d){var e=!0;if(a=Yb(a))if(b=a.G[b.toString()])for(b=b.concat(),a=0;a<b.length;a++){var f=b[a];f&&f.capture==c&&!f.rb&&(f=fc(f,d),e=e&&!1!==f)}return e},fc=function(a,b){var c=a.listener,d=a.kc||a.src;a.dc&&ec(a);return c.call(d,
b)},ac=function(a,b){if(a.rb)return!0;if(!Gb){if(!b)a:{b=["window","event"];for(var c=l,d;d=b.shift();)if(null!=c[d])c=c[d];else{b=null;break a}b=c}d=b;b=new Jb(d,this);c=!0;if(!(0>d.keyCode||void 0!=d.returnValue)){a:{var e=!1;if(0==d.keyCode)try{d.keyCode=-1;break a}catch(g){e=!0}if(e||void 0==d.returnValue)d.returnValue=!0}d=[];for(e=b.currentTarget;e;e=e.parentNode)d.push(e);a=a.type;for(e=d.length-1;!b.nb&&0<=e;e--){b.currentTarget=d[e];var f=gc(d[e],a,!0,b),c=c&&f}for(e=0;!b.nb&&e<d.length;e++)b.currentTarget=
d[e],f=gc(d[e],a,!1,b),c=c&&f}return c}return fc(a,new Jb(b,this))},Yb=function(a){a=a[Sb];return a instanceof Ob?a:null},hc="__closure_events_fn_"+(1E9*Math.random()>>>0),Wb=function(a){v(a,"Listener can not be null.");if(p(a))return a;v(a.handleEvent,"An object listener must have handleEvent method.");a[hc]||(a[hc]=function(b){return a.handleEvent(b)});return a[hc]};var ic=/^[+a-zA-Z0-9_.!#$%&'*\/=?^`{|}~-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z0-9]{2,63}$/;var kc=function(){this.Cc="";this.we=jc};kc.prototype.Eb=!0;kc.prototype.Bb=function(){return this.Cc};kc.prototype.toString=function(){return"Const{"+this.Cc+"}"};var lc=function(a){if(a instanceof kc&&a.constructor===kc&&a.we===jc)return a.Cc;ya("expected object of type Const, got '"+a+"'");return"type_error:Const"},jc={},mc=function(a){var b=new kc;b.Cc=a;return b};mc("");var oc=function(){this.wc="";this.xe=nc};oc.prototype.Eb=!0;oc.prototype.Bb=function(){return this.wc};oc.prototype.toString=function(){return"TrustedResourceUrl{"+this.wc+"}"};var nc={};var qc=function(){this.pa="";this.ve=pc};qc.prototype.Eb=!0;qc.prototype.Bb=function(){return this.pa};qc.prototype.toString=function(){return"SafeUrl{"+this.pa+"}"};
var rc=function(a){if(a instanceof qc&&a.constructor===qc&&a.ve===pc)return a.pa;ya("expected object of type SafeUrl, got '"+a+"' of type "+ca(a));return"type_error:SafeUrl"},sc=/^(?:(?:https?|mailto|ftp):|[^&:/?#]*(?:[/?#]|$))/i,uc=function(a){if(a instanceof qc)return a;a=a.Eb?a.Bb():String(a);sc.test(a)||(a="about:invalid#zClosurez");return tc(a)},pc={},tc=function(a){var b=new qc;b.pa=a;return b};tc("about:blank");var xc=function(a){var b=[];vc(new wc,a,b);return b.join("")},wc=function(){this.yc=void 0},vc=function(a,b,c){if(null==b)c.push("null");else{if("object"==typeof b){if(ea(b)){var d=b;b=d.length;c.push("[");for(var e="",f=0;f<b;f++)c.push(e),e=d[f],vc(a,a.yc?a.yc.call(d,String(f),e):e,c),e=",";c.push("]");return}if(b instanceof String||b instanceof Number||b instanceof Boolean)b=b.valueOf();else{c.push("{");f="";for(d in b)Object.prototype.hasOwnProperty.call(b,d)&&(e=b[d],"function"!=typeof e&&(c.push(f),
yc(d,c),c.push(":"),vc(a,a.yc?a.yc.call(b,d,e):e,c),f=","));c.push("}");return}}switch(typeof b){case "string":yc(b,c);break;case "number":c.push(isFinite(b)&&!isNaN(b)?String(b):"null");break;case "boolean":c.push(String(b));break;case "function":c.push("null");break;default:throw Error("Unknown type: "+typeof b);}}},zc={'"':'\\"',"\\":"\\\\","/":"\\/","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\u000b"},Ac=/\uffff/.test("\uffff")?/[\\\"\x00-\x1f\x7f-\uffff]/g:/[\\\"\x00-\x1f\x7f-\xff]/g,
yc=function(a,b){b.push('"',a.replace(Ac,function(a){var b=zc[a];b||(b="\\u"+(a.charCodeAt(0)|65536).toString(16).substr(1),zc[a]=b);return b}),'"')};var Bc=function(){};Bc.prototype.Dd=null;var Cc=function(a){return a.Dd||(a.Dd=a.$c())};var Dc,Ec=function(){};r(Ec,Bc);Ec.prototype.fc=function(){var a=Fc(this);return a?new ActiveXObject(a):new XMLHttpRequest};Ec.prototype.$c=function(){var a={};Fc(this)&&(a[0]=!0,a[1]=!0);return a};
var Fc=function(a){if(!a.Vd&&"undefined"==typeof XMLHttpRequest&&"undefined"!=typeof ActiveXObject){for(var b=["MSXML2.XMLHTTP.6.0","MSXML2.XMLHTTP.3.0","MSXML2.XMLHTTP","Microsoft.XMLHTTP"],c=0;c<b.length;c++){var d=b[c];try{return new ActiveXObject(d),a.Vd=d}catch(e){}}throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");}return a.Vd};Dc=new Ec;var Gc=function(){};r(Gc,Bc);Gc.prototype.fc=function(){var a=new XMLHttpRequest;if("withCredentials"in a)return a;if("undefined"!=typeof XDomainRequest)return new Hc;throw Error("Unsupported browser");};Gc.prototype.$c=function(){return{}};
var Hc=function(){this.ua=new XDomainRequest;this.readyState=0;this.onreadystatechange=null;this.responseText="";this.status=-1;this.statusText=this.responseXML=null;this.ua.onload=q(this.Re,this);this.ua.onerror=q(this.Sd,this);this.ua.onprogress=q(this.Se,this);this.ua.ontimeout=q(this.Te,this)};h=Hc.prototype;h.open=function(a,b,c){if(null!=c&&!c)throw Error("Only async requests are supported.");this.ua.open(a,b)};
h.send=function(a){if(a)if("string"==typeof a)this.ua.send(a);else throw Error("Only string data is supported");else this.ua.send()};h.abort=function(){this.ua.abort()};h.setRequestHeader=function(){};h.Re=function(){this.status=200;this.responseText=this.ua.responseText;Ic(this,4)};h.Sd=function(){this.status=500;this.responseText="";Ic(this,4)};h.Te=function(){this.Sd()};h.Se=function(){this.status=200;Ic(this,1)};var Ic=function(a,b){a.readyState=b;if(a.onreadystatechange)a.onreadystatechange()};var Jc=function(a,b,c){this.ef=c;this.Fe=a;this.wf=b;this.sc=0;this.lc=null};Jc.prototype.get=function(){var a;0<this.sc?(this.sc--,a=this.lc,this.lc=a.next,a.next=null):a=this.Fe();return a};Jc.prototype.put=function(a){this.wf(a);this.sc<this.ef&&(this.sc++,a.next=this.lc,this.lc=a)};var Kc=function(a){l.setTimeout(function(){throw a;},0)},Lc,Mc=function(){var a=l.MessageChannel;"undefined"===typeof a&&"undefined"!==typeof window&&window.postMessage&&window.addEventListener&&!x("Presto")&&(a=function(){var a=document.createElement("IFRAME");a.style.display="none";a.src="";document.documentElement.appendChild(a);var b=a.contentWindow,a=b.document;a.open();a.write("");a.close();var c="callImmediate"+Math.random(),d="file:"==b.location.protocol?"*":b.location.protocol+"//"+b.location.host,
a=q(function(a){if(("*"==d||a.origin==d)&&a.data==c)this.port1.onmessage()},this);b.addEventListener("message",a,!1);this.port1={};this.port2={postMessage:function(){b.postMessage(c,d)}}});if("undefined"!==typeof a&&!x("Trident")&&!x("MSIE")){var b=new a,c={},d=c;b.port1.onmessage=function(){if(void 0!==c.next){c=c.next;var a=c.Gd;c.Gd=null;a()}};return function(a){d.next={Gd:a};d=d.next;b.port2.postMessage(0)}}return"undefined"!==typeof document&&"onreadystatechange"in document.createElement("SCRIPT")?
function(a){var b=document.createElement("SCRIPT");b.onreadystatechange=function(){b.onreadystatechange=null;b.parentNode.removeChild(b);b=null;a();a=null};document.documentElement.appendChild(b)}:function(a){l.setTimeout(a,0)}};var Nc=function(){this.Jc=this.Za=null},Pc=new Jc(function(){return new Oc},function(a){a.reset()},100);Nc.prototype.add=function(a,b){var c=Pc.get();c.set(a,b);this.Jc?this.Jc.next=c:(v(!this.Za),this.Za=c);this.Jc=c};Nc.prototype.remove=function(){var a=null;this.Za&&(a=this.Za,this.Za=this.Za.next,this.Za||(this.Jc=null),a.next=null);return a};var Oc=function(){this.next=this.scope=this.Tc=null};Oc.prototype.set=function(a,b){this.Tc=a;this.scope=b;this.next=null};
Oc.prototype.reset=function(){this.next=this.scope=this.Tc=null};var Uc=function(a,b){Qc||Rc();Sc||(Qc(),Sc=!0);Tc.add(a,b)},Qc,Rc=function(){if(-1!=String(l.Promise).indexOf("[native code]")){var a=l.Promise.resolve(void 0);Qc=function(){a.then(Vc)}}else Qc=function(){var a=Vc;!p(l.setImmediate)||l.Window&&l.Window.prototype&&!x("Edge")&&l.Window.prototype.setImmediate==l.setImmediate?(Lc||(Lc=Mc()),Lc(a)):l.setImmediate(a)}},Sc=!1,Tc=new Nc,Vc=function(){for(var a;a=Tc.remove();){try{a.Tc.call(a.scope)}catch(b){Kc(b)}Pc.put(a)}Sc=!1};!gb&&!y||y&&9<=Number(ob)||gb&&z("1.9.1");y&&z("9");var Xc=function(){this.pa="";this.ue=Wc};Xc.prototype.Eb=!0;Xc.prototype.Bb=function(){return this.pa};Xc.prototype.toString=function(){return"SafeHtml{"+this.pa+"}"};var Yc=function(a){if(a instanceof Xc&&a.constructor===Xc&&a.ue===Wc)return a.pa;ya("expected object of type SafeHtml, got '"+a+"' of type "+ca(a));return"type_error:SafeHtml"},Wc={};Xc.prototype.$e=function(a){this.pa=a;return this};var $c=function(a,b){Sa(b,function(b,d){b&&b.Eb&&(b=b.Bb());"style"==d?a.style.cssText=b:"class"==d?a.className=b:"for"==d?a.htmlFor=b:Zc.hasOwnProperty(d)?a.setAttribute(Zc[d],b):0==d.lastIndexOf("aria-",0)||0==d.lastIndexOf("data-",0)?a.setAttribute(d,b):a[d]=b})},Zc={cellpadding:"cellPadding",cellspacing:"cellSpacing",colspan:"colSpan",frameborder:"frameBorder",height:"height",maxlength:"maxLength",nonce:"nonce",role:"role",rowspan:"rowSpan",type:"type",usemap:"useMap",valign:"vAlign",width:"width"};var ad=function(a){a.prototype.then=a.prototype.then;a.prototype.$goog_Thenable=!0},bd=function(a){if(!a)return!1;try{return!!a.$goog_Thenable}catch(b){return!1}};var A=function(a,b){this.N=0;this.ra=void 0;this.bb=this.na=this.s=null;this.jc=this.Sc=!1;if(a!=ba)try{var c=this;a.call(b,function(a){cd(c,2,a)},function(a){if(!(a instanceof dd))try{if(a instanceof Error)throw a;throw Error("Promise rejected.");}catch(e){}cd(c,3,a)})}catch(d){cd(this,3,d)}},ed=function(){this.next=this.context=this.jb=this.Oa=this.child=null;this.xb=!1};ed.prototype.reset=function(){this.context=this.jb=this.Oa=this.child=null;this.xb=!1};
var fd=new Jc(function(){return new ed},function(a){a.reset()},100),gd=function(a,b,c){var d=fd.get();d.Oa=a;d.jb=b;d.context=c;return d},B=function(a){if(a instanceof A)return a;var b=new A(ba);cd(b,2,a);return b},D=function(a){return new A(function(b,c){c(a)})},id=function(a,b,c){hd(a,b,c,null)||Uc(ka(b,a))},jd=function(a){return new A(function(b){var c=a.length,d=[];if(c)for(var e=function(a,e,f){c--;d[a]=e?{Ne:!0,value:f}:{Ne:!1,reason:f};0==c&&b(d)},f=0,g;f<a.length;f++)g=a[f],id(g,ka(e,f,!0),
ka(e,f,!1));else b(d)})};A.prototype.then=function(a,b,c){null!=a&&Ba(a,"opt_onFulfilled should be a function.");null!=b&&Ba(b,"opt_onRejected should be a function. Did you pass opt_context as the second argument instead of the third?");return kd(this,p(a)?a:null,p(b)?b:null,c)};ad(A);var md=function(a,b){b=gd(b,b,void 0);b.xb=!0;ld(a,b);return a};A.prototype.f=function(a,b){return kd(this,null,a,b)};A.prototype.cancel=function(a){0==this.N&&Uc(function(){var b=new dd(a);nd(this,b)},this)};
var nd=function(a,b){if(0==a.N)if(a.s){var c=a.s;if(c.na){for(var d=0,e=null,f=null,g=c.na;g&&(g.xb||(d++,g.child==a&&(e=g),!(e&&1<d)));g=g.next)e||(f=g);e&&(0==c.N&&1==d?nd(c,b):(f?(d=f,v(c.na),v(null!=d),d.next==c.bb&&(c.bb=d),d.next=d.next.next):od(c),pd(c,e,3,b)))}a.s=null}else cd(a,3,b)},ld=function(a,b){a.na||2!=a.N&&3!=a.N||qd(a);v(null!=b.Oa);a.bb?a.bb.next=b:a.na=b;a.bb=b},kd=function(a,b,c,d){var e=gd(null,null,null);e.child=new A(function(a,g){e.Oa=b?function(c){try{var e=b.call(d,c);a(e)}catch(C){g(C)}}:
a;e.jb=c?function(b){try{var e=c.call(d,b);void 0===e&&b instanceof dd?g(b):a(e)}catch(C){g(C)}}:g});e.child.s=a;ld(a,e);return e.child};A.prototype.Jf=function(a){v(1==this.N);this.N=0;cd(this,2,a)};A.prototype.Kf=function(a){v(1==this.N);this.N=0;cd(this,3,a)};
var cd=function(a,b,c){0==a.N&&(a===c&&(b=3,c=new TypeError("Promise cannot resolve to itself")),a.N=1,hd(c,a.Jf,a.Kf,a)||(a.ra=c,a.N=b,a.s=null,qd(a),3!=b||c instanceof dd||rd(a,c)))},hd=function(a,b,c,d){if(a instanceof A)return null!=b&&Ba(b,"opt_onFulfilled should be a function."),null!=c&&Ba(c,"opt_onRejected should be a function. Did you pass opt_context as the second argument instead of the third?"),ld(a,gd(b||ba,c||null,d)),!0;if(bd(a))return a.then(b,c,d),!0;if(ha(a))try{var e=a.then;if(p(e))return sd(a,
e,b,c,d),!0}catch(f){return c.call(d,f),!0}return!1},sd=function(a,b,c,d,e){var f=!1,g=function(a){f||(f=!0,c.call(e,a))},k=function(a){f||(f=!0,d.call(e,a))};try{b.call(a,g,k)}catch(n){k(n)}},qd=function(a){a.Sc||(a.Sc=!0,Uc(a.Je,a))},od=function(a){var b=null;a.na&&(b=a.na,a.na=b.next,b.next=null);a.na||(a.bb=null);null!=b&&v(null!=b.Oa);return b};A.prototype.Je=function(){for(var a;a=od(this);)pd(this,a,this.N,this.ra);this.Sc=!1};
var pd=function(a,b,c,d){if(3==c&&b.jb&&!b.xb)for(;a&&a.jc;a=a.s)a.jc=!1;if(b.child)b.child.s=null,td(b,c,d);else try{b.xb?b.Oa.call(b.context):td(b,c,d)}catch(e){ud.call(null,e)}fd.put(b)},td=function(a,b,c){2==b?a.Oa.call(a.context,c):a.jb&&a.jb.call(a.context,c)},rd=function(a,b){a.jc=!0;Uc(function(){a.jc&&ud.call(null,b)})},ud=Kc,dd=function(a){t.call(this,a)};r(dd,t);dd.prototype.name="cancel";
var vd=function(a,b){this.zc=[];this.$d=a;this.Jd=b||null;this.Cb=this.fb=!1;this.ra=void 0;this.ud=this.Cd=this.Nc=!1;this.Gc=0;this.s=null;this.Oc=0};vd.prototype.cancel=function(a){if(this.fb)this.ra instanceof vd&&this.ra.cancel();else{if(this.s){var b=this.s;delete this.s;a?b.cancel(a):(b.Oc--,0>=b.Oc&&b.cancel())}this.$d?this.$d.call(this.Jd,this):this.ud=!0;this.fb||wd(this,new xd)}};vd.prototype.Hd=function(a,b){this.Nc=!1;yd(this,a,b)};
var yd=function(a,b,c){a.fb=!0;a.ra=c;a.Cb=!b;zd(a)},Bd=function(a){if(a.fb){if(!a.ud)throw new Ad;a.ud=!1}};vd.prototype.callback=function(a){Bd(this);Cd(a);yd(this,!0,a)};
var wd=function(a,b){Bd(a);Cd(b);yd(a,!1,b)},Cd=function(a){v(!(a instanceof vd),"An execution sequence may not be initiated with a blocking Deferred.")},Gd=function(a){var b=Dd("https://apis.google.com/js/client.js?onload="+Ed);Fd(b,null,a,void 0)},Fd=function(a,b,c,d){v(!a.Cd,"Blocking Deferreds can not be re-used");a.zc.push([b,c,d]);a.fb&&zd(a)};vd.prototype.then=function(a,b,c){var d,e,f=new A(function(a,b){d=a;e=b});Fd(this,d,function(a){a instanceof xd?f.cancel():e(a)});return f.then(a,b,c)};
ad(vd);
var Hd=function(a){return Fa(a.zc,function(a){return p(a[1])})},zd=function(a){if(a.Gc&&a.fb&&Hd(a)){var b=a.Gc,c=Id[b];c&&(l.clearTimeout(c.Db),delete Id[b]);a.Gc=0}a.s&&(a.s.Oc--,delete a.s);for(var b=a.ra,d=c=!1;a.zc.length&&!a.Nc;){var e=a.zc.shift(),f=e[0],g=e[1],e=e[2];if(f=a.Cb?g:f)try{var k=f.call(e||a.Jd,b);void 0!==k&&(a.Cb=a.Cb&&(k==b||k instanceof Error),a.ra=b=k);if(bd(b)||"function"===typeof l.Promise&&b instanceof l.Promise)d=!0,a.Nc=!0}catch(n){b=n,a.Cb=!0,Hd(a)||(c=!0)}}a.ra=b;d&&
(k=q(a.Hd,a,!0),d=q(a.Hd,a,!1),b instanceof vd?(Fd(b,k,d),b.Cd=!0):b.then(k,d));c&&(b=new Jd(b),Id[b.Db]=b,a.Gc=b.Db)},Ad=function(){t.call(this)};r(Ad,t);Ad.prototype.message="Deferred has already fired";Ad.prototype.name="AlreadyCalledError";var xd=function(){t.call(this)};r(xd,t);xd.prototype.message="Deferred was canceled";xd.prototype.name="CanceledError";var Jd=function(a){this.Db=l.setTimeout(q(this.If,this),0);this.P=a};
Jd.prototype.If=function(){v(Id[this.Db],"Cannot throw an error that is not scheduled.");delete Id[this.Db];throw this.P;};var Id={};var Dd=function(a){var b=new oc;b.wc=a;return Kd(b)},Kd=function(a){var b={},c=b.document||document,d;a instanceof oc&&a.constructor===oc&&a.xe===nc?d=a.wc:(ya("expected object of type TrustedResourceUrl, got '"+a+"' of type "+ca(a)),d="type_error:TrustedResourceUrl");var e=document.createElement("SCRIPT");a={fe:e,Zb:void 0};var f=new vd(Ld,a),g=null,k=null!=b.timeout?b.timeout:5E3;0<k&&(g=window.setTimeout(function(){Md(e,!0);wd(f,new Nd(1,"Timeout reached for loading script "+d))},k),a.Zb=g);e.onload=
e.onreadystatechange=function(){e.readyState&&"loaded"!=e.readyState&&"complete"!=e.readyState||(Md(e,b.Uf||!1,g),f.callback(null))};e.onerror=function(){Md(e,!0,g);wd(f,new Nd(0,"Error while loading script "+d))};a=b.attributes||{};Za(a,{type:"text/javascript",charset:"UTF-8",src:d});$c(e,a);Od(c).appendChild(e);return f},Od=function(a){var b;return(b=(a||document).getElementsByTagName("HEAD"))&&0!=b.length?b[0]:a.documentElement},Ld=function(){if(this&&this.fe){var a=this.fe;a&&"SCRIPT"==a.tagName&&
Md(a,!0,this.Zb)}},Md=function(a,b,c){null!=c&&l.clearTimeout(c);a.onload=ba;a.onerror=ba;a.onreadystatechange=ba;b&&window.setTimeout(function(){a&&a.parentNode&&a.parentNode.removeChild(a)},0)},Nd=function(a,b){var c="Jsloader error (code #"+a+")";b&&(c+=": "+b);t.call(this,c);this.code=a};r(Nd,t);var Pd="StopIteration"in l?l.StopIteration:{message:"StopIteration",stack:""},Qd=function(){};Qd.prototype.next=function(){throw Pd;};Qd.prototype.ye=function(){return this};var Rd=function(a,b){this.ga={};this.w=[];this.wb=this.o=0;var c=arguments.length;if(1<c){if(c%2)throw Error("Uneven number of arguments");for(var d=0;d<c;d+=2)this.set(arguments[d],arguments[d+1])}else a&&this.addAll(a)};Rd.prototype.Z=function(){Sd(this);for(var a=[],b=0;b<this.w.length;b++)a.push(this.ga[this.w[b]]);return a};Rd.prototype.oa=function(){Sd(this);return this.w.concat()};Rd.prototype.yb=function(a){return Td(this.ga,a)};
Rd.prototype.remove=function(a){return Td(this.ga,a)?(delete this.ga[a],this.o--,this.wb++,this.w.length>2*this.o&&Sd(this),!0):!1};var Sd=function(a){if(a.o!=a.w.length){for(var b=0,c=0;b<a.w.length;){var d=a.w[b];Td(a.ga,d)&&(a.w[c++]=d);b++}a.w.length=c}if(a.o!=a.w.length){for(var e={},c=b=0;b<a.w.length;)d=a.w[b],Td(e,d)||(a.w[c++]=d,e[d]=1),b++;a.w.length=c}};h=Rd.prototype;h.get=function(a,b){return Td(this.ga,a)?this.ga[a]:b};
h.set=function(a,b){Td(this.ga,a)||(this.o++,this.w.push(a),this.wb++);this.ga[a]=b};h.addAll=function(a){var b;a instanceof Rd?(b=a.oa(),a=a.Z()):(b=Ua(a),a=Ta(a));for(var c=0;c<b.length;c++)this.set(b[c],a[c])};h.forEach=function(a,b){for(var c=this.oa(),d=0;d<c.length;d++){var e=c[d],f=this.get(e);a.call(b,f,e,this)}};h.clone=function(){return new Rd(this)};
h.ye=function(a){Sd(this);var b=0,c=this.wb,d=this,e=new Qd;e.next=function(){if(c!=d.wb)throw Error("The map has changed since the iterator was created");if(b>=d.w.length)throw Pd;var e=d.w[b++];return a?e:d.ga[e]};return e};var Td=function(a,b){return Object.prototype.hasOwnProperty.call(a,b)};var Ud=function(a){if(a.Z&&"function"==typeof a.Z)return a.Z();if(m(a))return a.split("");if(fa(a)){for(var b=[],c=a.length,d=0;d<c;d++)b.push(a[d]);return b}return Ta(a)},Vd=function(a){if(a.oa&&"function"==typeof a.oa)return a.oa();if(!a.Z||"function"!=typeof a.Z){if(fa(a)||m(a)){var b=[];a=a.length;for(var c=0;c<a;c++)b.push(c);return b}return Ua(a)}},Wd=function(a,b){if(a.forEach&&"function"==typeof a.forEach)a.forEach(b,void 0);else if(fa(a)||m(a))w(a,b,void 0);else for(var c=Vd(a),d=Ud(a),e=
d.length,f=0;f<e;f++)b.call(void 0,d[f],c&&c[f],a)};var Xd=function(a,b,c,d,e){this.reset(a,b,c,d,e)};Xd.prototype.Md=null;var Yd=0;Xd.prototype.reset=function(a,b,c,d,e){"number"==typeof e||Yd++;d||la();this.Ib=a;this.hf=b;delete this.Md};Xd.prototype.ie=function(a){this.Ib=a};var Zd=function(a){this.jf=a;this.Td=this.Pc=this.Ib=this.s=null},$d=function(a,b){this.name=a;this.value=b};$d.prototype.toString=function(){return this.name};var ae=new $d("SEVERE",1E3),be=new $d("CONFIG",700),ce=new $d("FINE",500);Zd.prototype.getParent=function(){return this.s};Zd.prototype.ie=function(a){this.Ib=a};var de=function(a){if(a.Ib)return a.Ib;if(a.s)return de(a.s);ya("Root logger has no level set.");return null};
Zd.prototype.log=function(a,b,c){if(a.value>=de(this).value)for(p(b)&&(b=b()),a=new Xd(a,String(b),this.jf),c&&(a.Md=c),c="log:"+a.hf,l.console&&(l.console.timeStamp?l.console.timeStamp(c):l.console.markTimeline&&l.console.markTimeline(c)),l.msWriteProfilerMark&&l.msWriteProfilerMark(c),c=this;c;){var d=c,e=a;if(d.Td)for(var f=0;b=d.Td[f];f++)b(e);c=c.getParent()}};
var ee={},fe=null,ge=function(a){fe||(fe=new Zd(""),ee[""]=fe,fe.ie(be));var b;if(!(b=ee[a])){b=new Zd(a);var c=a.lastIndexOf("."),d=a.substr(c+1),c=ge(a.substr(0,c));c.Pc||(c.Pc={});c.Pc[d]=b;b.s=c;ee[a]=b}return b};var he=function(){Fb.call(this);this.fa=new Ob(this);this.ze=this;this.hd=null};r(he,Fb);he.prototype[Kb]=!0;h=he.prototype;h.addEventListener=function(a,b,c,d){Vb(this,a,b,c,d)};h.removeEventListener=function(a,b,c,d){dc(this,a,b,c,d)};
h.dispatchEvent=function(a){ie(this);var b,c=this.hd;if(c){b=[];for(var d=1;c;c=c.hd)b.push(c),v(1E3>++d,"infinite loop")}c=this.ze;d=a.type||a;if(m(a))a=new Ib(a,c);else if(a instanceof Ib)a.target=a.target||c;else{var e=a;a=new Ib(d,c);Za(a,e)}var e=!0,f;if(b)for(var g=b.length-1;!a.nb&&0<=g;g--)f=a.currentTarget=b[g],e=je(f,d,!0,a)&&e;a.nb||(f=a.currentTarget=c,e=je(f,d,!0,a)&&e,a.nb||(e=je(f,d,!1,a)&&e));if(b)for(g=0;!a.nb&&g<b.length;g++)f=a.currentTarget=b[g],e=je(f,d,!1,a)&&e;return e};
h.cb=function(){he.xd.cb.call(this);if(this.fa){var a=this.fa,b=0,c;for(c in a.G){for(var d=a.G[c],e=0;e<d.length;e++)++b,Nb(d[e]);delete a.G[c];a.$b--}}this.hd=null};h.listen=function(a,b,c,d){ie(this);return this.fa.add(String(a),b,!1,c,d)};
var cc=function(a,b,c,d,e){a.fa.add(String(b),c,!0,d,e)},je=function(a,b,c,d){b=a.fa.G[String(b)];if(!b)return!0;b=b.concat();for(var e=!0,f=0;f<b.length;++f){var g=b[f];if(g&&!g.rb&&g.capture==c){var k=g.listener,n=g.kc||g.src;g.dc&&Rb(a.fa,g);e=!1!==k.call(n,d)&&e}}return e&&0!=d.ee};he.prototype.Uc=function(a,b,c,d){return this.fa.Uc(String(a),b,c,d)};var ie=function(a){v(a.fa,"Event target is not initialized. Did you call the superclass (goog.events.EventTarget) constructor?")};var E=function(a,b){a&&a.log(ce,b,void 0)};var ke=function(a,b,c){if(p(a))c&&(a=q(a,c));else if(a&&"function"==typeof a.handleEvent)a=q(a.handleEvent,a);else throw Error("Invalid listener argument");return 2147483647<Number(b)?-1:l.setTimeout(a,b||0)},le=function(a){var b=null;return(new A(function(c,d){b=ke(function(){c(void 0)},a);-1==b&&d(Error("Failed to schedule timer."))})).f(function(a){l.clearTimeout(b);throw a;})};var me=/^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/,ne=function(a,b){if(a){a=a.split("&");for(var c=0;c<a.length;c++){var d=a[c].indexOf("="),e,f=null;0<=d?(e=a[c].substring(0,d),f=a[c].substring(d+1)):e=a[c];b(e,f?decodeURIComponent(f.replace(/\+/g," ")):"")}}};var F=function(a){he.call(this);this.headers=new Rd;this.Lc=a||null;this.va=!1;this.Kc=this.b=null;this.Hb=this.Zd=this.qc="";this.Ka=this.Yc=this.oc=this.Rc=!1;this.sb=0;this.Ec=null;this.de="";this.Hc=this.sf=this.te=!1};r(F,he);var oe=F.prototype,pe=ge("goog.net.XhrIo");oe.U=pe;var qe=/^https?$/i,re=["POST","PUT"];
F.prototype.send=function(a,b,c,d){if(this.b)throw Error("[goog.net.XhrIo] Object is active with another request="+this.qc+"; newUri="+a);b=b?b.toUpperCase():"GET";this.qc=a;this.Hb="";this.Zd=b;this.Rc=!1;this.va=!0;this.b=this.Lc?this.Lc.fc():Dc.fc();this.Kc=this.Lc?Cc(this.Lc):Cc(Dc);this.b.onreadystatechange=q(this.be,this);this.sf&&"onprogress"in this.b&&(this.b.onprogress=q(function(a){this.ae(a,!0)},this),this.b.upload&&(this.b.upload.onprogress=q(this.ae,this)));try{E(this.U,se(this,"Opening Xhr")),
this.Yc=!0,this.b.open(b,String(a),!0),this.Yc=!1}catch(f){E(this.U,se(this,"Error opening Xhr: "+f.message));this.P(5,f);return}a=c||"";var e=this.headers.clone();d&&Wd(d,function(a,b){e.set(b,a)});d=Ha(e.oa());c=l.FormData&&a instanceof l.FormData;!Ia(re,b)||d||c||e.set("Content-Type","application/x-www-form-urlencoded;charset=utf-8");e.forEach(function(a,b){this.b.setRequestHeader(b,a)},this);this.de&&(this.b.responseType=this.de);"withCredentials"in this.b&&this.b.withCredentials!==this.te&&(this.b.withCredentials=
this.te);try{te(this),0<this.sb&&(this.Hc=ue(this.b),E(this.U,se(this,"Will abort after "+this.sb+"ms if incomplete, xhr2 "+this.Hc)),this.Hc?(this.b.timeout=this.sb,this.b.ontimeout=q(this.Zb,this)):this.Ec=ke(this.Zb,this.sb,this)),E(this.U,se(this,"Sending request")),this.oc=!0,this.b.send(a),this.oc=!1}catch(f){E(this.U,se(this,"Send error: "+f.message)),this.P(5,f)}};var ue=function(a){return y&&z(9)&&ga(a.timeout)&&void 0!==a.ontimeout},Ga=function(a){return"content-type"==a.toLowerCase()};
F.prototype.Zb=function(){"undefined"!=typeof aa&&this.b&&(this.Hb="Timed out after "+this.sb+"ms, aborting",E(this.U,se(this,this.Hb)),this.dispatchEvent("timeout"),this.abort(8))};F.prototype.P=function(a,b){this.va=!1;this.b&&(this.Ka=!0,this.b.abort(),this.Ka=!1);this.Hb=b;ve(this);we(this)};var ve=function(a){a.Rc||(a.Rc=!0,a.dispatchEvent("complete"),a.dispatchEvent("error"))};
F.prototype.abort=function(){this.b&&this.va&&(E(this.U,se(this,"Aborting")),this.va=!1,this.Ka=!0,this.b.abort(),this.Ka=!1,this.dispatchEvent("complete"),this.dispatchEvent("abort"),we(this))};F.prototype.cb=function(){this.b&&(this.va&&(this.va=!1,this.Ka=!0,this.b.abort(),this.Ka=!1),we(this,!0));F.xd.cb.call(this)};F.prototype.be=function(){this.isDisposed()||(this.Yc||this.oc||this.Ka?xe(this):this.nf())};F.prototype.nf=function(){xe(this)};
var xe=function(a){if(a.va&&"undefined"!=typeof aa)if(a.Kc[1]&&4==ye(a)&&2==ze(a))E(a.U,se(a,"Local request error detected and ignored"));else if(a.oc&&4==ye(a))ke(a.be,0,a);else if(a.dispatchEvent("readystatechange"),4==ye(a)){E(a.U,se(a,"Request complete"));a.va=!1;try{var b=ze(a),c;a:switch(b){case 200:case 201:case 202:case 204:case 206:case 304:case 1223:c=!0;break a;default:c=!1}var d;if(!(d=c)){var e;if(e=0===b){var f=String(a.qc).match(me)[1]||null;if(!f&&l.self&&l.self.location)var g=l.self.location.protocol,
f=g.substr(0,g.length-1);e=!qe.test(f?f.toLowerCase():"")}d=e}if(d)a.dispatchEvent("complete"),a.dispatchEvent("success");else{var k;try{k=2<ye(a)?a.b.statusText:""}catch(n){E(a.U,"Can not get status: "+n.message),k=""}a.Hb=k+" ["+ze(a)+"]";ve(a)}}finally{we(a)}}};F.prototype.ae=function(a,b){v("progress"===a.type,"goog.net.EventType.PROGRESS is of the same type as raw XHR progress.");this.dispatchEvent(Ae(a,"progress"));this.dispatchEvent(Ae(a,b?"downloadprogress":"uploadprogress"))};
var Ae=function(a,b){return{type:b,lengthComputable:a.lengthComputable,loaded:a.loaded,total:a.total}},we=function(a,b){if(a.b){te(a);var c=a.b,d=a.Kc[0]?ba:null;a.b=null;a.Kc=null;b||a.dispatchEvent("ready");try{c.onreadystatechange=d}catch(e){(a=a.U)&&a.log(ae,"Problem encountered resetting onreadystatechange: "+e.message,void 0)}}},te=function(a){a.b&&a.Hc&&(a.b.ontimeout=null);ga(a.Ec)&&(l.clearTimeout(a.Ec),a.Ec=null)},ye=function(a){return a.b?a.b.readyState:0},ze=function(a){try{return 2<ye(a)?
a.b.status:-1}catch(b){return-1}},Be=function(a){try{return a.b?a.b.responseText:""}catch(b){return E(a.U,"Can not get responseText: "+b.message),""}},se=function(a,b){return b+" ["+a.Zd+" "+a.qc+" "+ze(a)+"]"};var G=function(a,b){this.ea=this.Xa=this.ha="";this.lb=null;this.Ja=this.xa="";this.S=this.df=!1;var c;a instanceof G?(this.S=void 0!==b?b:a.S,Ce(this,a.ha),c=a.Xa,H(this),this.Xa=c,De(this,a.ea),Ee(this,a.lb),Fe(this,a.xa),Ge(this,a.W.clone()),a=a.Ja,H(this),this.Ja=a):a&&(c=String(a).match(me))?(this.S=!!b,Ce(this,c[1]||"",!0),a=c[2]||"",H(this),this.Xa=He(a),De(this,c[3]||"",!0),Ee(this,c[4]),Fe(this,c[5]||"",!0),Ge(this,c[6]||"",!0),a=c[7]||"",H(this),this.Ja=He(a)):(this.S=!!b,this.W=new I(null,
0,this.S))};G.prototype.toString=function(){var a=[],b=this.ha;b&&a.push(Ie(b,Je,!0),":");var c=this.ea;if(c||"file"==b)a.push("//"),(b=this.Xa)&&a.push(Ie(b,Je,!0),"@"),a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g,"%$1")),c=this.lb,null!=c&&a.push(":",String(c));if(c=this.xa)this.ea&&"/"!=c.charAt(0)&&a.push("/"),a.push(Ie(c,"/"==c.charAt(0)?Ke:Le,!0));(c=this.W.toString())&&a.push("?",c);(c=this.Ja)&&a.push("#",Ie(c,Me));return a.join("")};
G.prototype.resolve=function(a){var b=this.clone(),c=!!a.ha;c?Ce(b,a.ha):c=!!a.Xa;if(c){var d=a.Xa;H(b);b.Xa=d}else c=!!a.ea;c?De(b,a.ea):c=null!=a.lb;d=a.xa;if(c)Ee(b,a.lb);else if(c=!!a.xa){if("/"!=d.charAt(0))if(this.ea&&!this.xa)d="/"+d;else{var e=b.xa.lastIndexOf("/");-1!=e&&(d=b.xa.substr(0,e+1)+d)}e=d;if(".."==e||"."==e)d="";else if(u(e,"./")||u(e,"/.")){for(var d=0==e.lastIndexOf("/",0),e=e.split("/"),f=[],g=0;g<e.length;){var k=e[g++];"."==k?d&&g==e.length&&f.push(""):".."==k?((1<f.length||
1==f.length&&""!=f[0])&&f.pop(),d&&g==e.length&&f.push("")):(f.push(k),d=!0)}d=f.join("/")}else d=e}c?Fe(b,d):c=""!==a.W.toString();c?Ge(b,a.W.clone()):c=!!a.Ja;c&&(a=a.Ja,H(b),b.Ja=a);return b};G.prototype.clone=function(){return new G(this)};
var Ce=function(a,b,c){H(a);a.ha=c?He(b,!0):b;a.ha&&(a.ha=a.ha.replace(/:$/,""))},De=function(a,b,c){H(a);a.ea=c?He(b,!0):b},Ee=function(a,b){H(a);if(b){b=Number(b);if(isNaN(b)||0>b)throw Error("Bad port number "+b);a.lb=b}else a.lb=null},Fe=function(a,b,c){H(a);a.xa=c?He(b,!0):b},Ge=function(a,b,c){H(a);b instanceof I?(a.W=b,a.W.td(a.S)):(c||(b=Ie(b,Ne)),a.W=new I(b,0,a.S))},J=function(a,b,c){H(a);a.W.set(b,c)},Oe=function(a,b){return a.W.get(b)};
G.prototype.removeParameter=function(a){H(this);this.W.remove(a);return this};var H=function(a){if(a.df)throw Error("Tried to modify a read-only Uri");};G.prototype.td=function(a){this.S=a;this.W&&this.W.td(a);return this};
var Pe=function(a){return a instanceof G?a.clone():new G(a,void 0)},Qe=function(a,b){var c=new G(null,void 0);Ce(c,"https");a&&De(c,a);b&&Fe(c,b);return c},He=function(a,b){return a?b?decodeURI(a.replace(/%25/g,"%2525")):decodeURIComponent(a):""},Ie=function(a,b,c){return m(a)?(a=encodeURI(a).replace(b,Re),c&&(a=a.replace(/%25([0-9a-fA-F]{2})/g,"%$1")),a):null},Re=function(a){a=a.charCodeAt(0);return"%"+(a>>4&15).toString(16)+(a&15).toString(16)},Je=/[#\/\?@]/g,Le=/[\#\?:]/g,Ke=/[\#\?]/g,Ne=/[\#\?@]/g,
Me=/#/g,I=function(a,b,c){this.o=this.l=null;this.O=a||null;this.S=!!c},Se=function(a){a.l||(a.l=new Rd,a.o=0,a.O&&ne(a.O,function(b,c){a.add(decodeURIComponent(b.replace(/\+/g," ")),c)}))},Ue=function(a){var b=Vd(a);if("undefined"==typeof b)throw Error("Keys are undefined");var c=new I(null,0,void 0);a=Ud(a);for(var d=0;d<b.length;d++){var e=b[d],f=a[d];ea(f)?Te(c,e,f):c.add(e,f)}return c};h=I.prototype;
h.add=function(a,b){Se(this);this.O=null;a=this.R(a);var c=this.l.get(a);c||this.l.set(a,c=[]);c.push(b);this.o=za(this.o)+1;return this};h.remove=function(a){Se(this);a=this.R(a);return this.l.yb(a)?(this.O=null,this.o=za(this.o)-this.l.get(a).length,this.l.remove(a)):!1};h.yb=function(a){Se(this);a=this.R(a);return this.l.yb(a)};h.oa=function(){Se(this);for(var a=this.l.Z(),b=this.l.oa(),c=[],d=0;d<b.length;d++)for(var e=a[d],f=0;f<e.length;f++)c.push(b[d]);return c};
h.Z=function(a){Se(this);var b=[];if(m(a))this.yb(a)&&(b=Ma(b,this.l.get(this.R(a))));else{a=this.l.Z();for(var c=0;c<a.length;c++)b=Ma(b,a[c])}return b};h.set=function(a,b){Se(this);this.O=null;a=this.R(a);this.yb(a)&&(this.o=za(this.o)-this.l.get(a).length);this.l.set(a,[b]);this.o=za(this.o)+1;return this};h.get=function(a,b){a=a?this.Z(a):[];return 0<a.length?String(a[0]):b};var Te=function(a,b,c){a.remove(b);0<c.length&&(a.O=null,a.l.set(a.R(b),Na(c)),a.o=za(a.o)+c.length)};
I.prototype.toString=function(){if(this.O)return this.O;if(!this.l)return"";for(var a=[],b=this.l.oa(),c=0;c<b.length;c++)for(var d=b[c],e=encodeURIComponent(String(d)),d=this.Z(d),f=0;f<d.length;f++){var g=e;""!==d[f]&&(g+="="+encodeURIComponent(String(d[f])));a.push(g)}return this.O=a.join("&")};I.prototype.clone=function(){var a=new I;a.O=this.O;this.l&&(a.l=this.l.clone(),a.o=this.o);return a};I.prototype.R=function(a){a=String(a);this.S&&(a=a.toLowerCase());return a};
I.prototype.td=function(a){a&&!this.S&&(Se(this),this.O=null,this.l.forEach(function(a,c){var b=c.toLowerCase();c!=b&&(this.remove(c),Te(this,b,a))},this));this.S=a};var Ve=function(){var a=K();return y&&!!ob&&11==ob||/Edge\/\d+/.test(a)},We=function(){return l.window&&l.window.location.href||""},Xe=function(a,b){b=b||l.window;var c="about:blank";a&&(c=rc(uc(a)));b.location.href=c},Ye=function(a,b){var c=[],d;for(d in a)d in b?typeof a[d]!=typeof b[d]?c.push(d):ea(a[d])?Wa(a[d],b[d])||c.push(d):"object"==typeof a[d]&&null!=a[d]&&null!=b[d]?0<Ye(a[d],b[d]).length&&c.push(d):a[d]!==b[d]&&c.push(d):c.push(d);for(d in b)d in a||c.push(d);return c},$e=function(){var a;
a=K();a="Chrome"!=Ze(a)?null:(a=a.match(/\sChrome\/(\d+)/i))&&2==a.length?parseInt(a[1],10):null;return a&&30>a?!1:!y||!ob||9<ob},af=function(a){a=(a||K()).toLowerCase();return a.match(/android/)||a.match(/webos/)||a.match(/iphone|ipad|ipod/)||a.match(/blackberry/)||a.match(/windows phone/)||a.match(/iemobile/)?!0:!1},bf=function(a){a=a||l.window;try{a.close()}catch(b){}},cf=function(a,b,c){var d=Math.floor(1E9*Math.random()).toString();b=b||500;c=c||600;var e=(window.screen.availHeight-c)/2,f=(window.screen.availWidth-
b)/2;b={width:b,height:c,top:0<e?e:0,left:0<f?f:0,location:!0,resizable:!0,statusbar:!0,toolbar:!1};c=K().toLowerCase();d&&(b.target=d,u(c,"crios/")&&(b.target="_blank"));"Firefox"==Ze(K())&&(a=a||"http://localhost",b.scrollbars=!0);var g;c=a||"about:blank";(d=b)||(d={});a=window;b=c instanceof qc?c:uc("undefined"!=typeof c.href?c.href:String(c));c=d.target||c.target;e=[];for(g in d)switch(g){case "width":case "height":case "top":case "left":e.push(g+"="+d[g]);break;case "target":case "noreferrer":break;
default:e.push(g+"="+(d[g]?1:0))}g=e.join(",");(x("iPhone")&&!x("iPod")&&!x("iPad")||x("iPad")||x("iPod"))&&a.navigator&&a.navigator.standalone&&c&&"_self"!=c?(g=a.document.createElement("A"),"undefined"!=typeof HTMLAnchorElement&&"undefined"!=typeof Location&&"undefined"!=typeof Element&&(e=g&&(g instanceof HTMLAnchorElement||!(g instanceof Location||g instanceof Element)),f=ha(g)?g.constructor.displayName||g.constructor.name||Object.prototype.toString.call(g):void 0===g?"undefined":null===g?"null":
typeof g,v(e,"Argument is not a HTMLAnchorElement (or a non-Element mock); got: %s",f)),b=b instanceof qc?b:uc(b),g.href=rc(b),g.setAttribute("target",c),d.noreferrer&&g.setAttribute("rel","noreferrer"),d=document.createEvent("MouseEvent"),d.initMouseEvent("click",!0,!0,a,1),g.dispatchEvent(d),g={}):d.noreferrer?(g=a.open("",c,g),d=rc(b),g&&(fb&&u(d,";")&&(d="'"+d.replace(/'/g,"%27")+"'"),g.opener=null,a=mc("b/12014412, meta tag with sanitized URL"),ua.test(d)&&(-1!=d.indexOf("&")&&(d=d.replace(oa,
"&amp;")),-1!=d.indexOf("<")&&(d=d.replace(pa,"&lt;")),-1!=d.indexOf(">")&&(d=d.replace(qa,"&gt;")),-1!=d.indexOf('"')&&(d=d.replace(ra,"&quot;")),-1!=d.indexOf("'")&&(d=d.replace(sa,"&#39;")),-1!=d.indexOf("\x00")&&(d=d.replace(ta,"&#0;"))),d='<META HTTP-EQUIV="refresh" content="0; url='+d+'">',Aa(lc(a),"must provide justification"),v(!/^[\s\xa0]*$/.test(lc(a)),"must provide non-empty justification"),g.document.write(Yc((new Xc).$e(d))),g.document.close())):g=a.open(rc(b),c,g);if(g)try{g.focus()}catch(k){}return g},
df=function(a){return new A(function(b){var c=function(){le(2E3).then(function(){if(!a||a.closed)b();else return c()})};return c()})},ef=/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/,ff=function(){var a=null;return(new A(function(b){"complete"==l.document.readyState?b():(a=function(){b()},bc(window,"load",a))})).f(function(b){dc(window,"load",a);throw b;})},hf=function(){return gf(void 0)?ff().then(function(){return new A(function(a,b){var c=l.document,d=setTimeout(function(){b(Error("Cordova framework is not ready."))},
1E3);c.addEventListener("deviceready",function(){clearTimeout(d);a()},!1)})}):D(Error("Cordova must run in an Android or iOS file scheme."))},gf=function(a){a=a||K();return!("file:"!==jf()||!a.toLowerCase().match(/iphone|ipad|ipod|android/))},kf=function(){var a=l.window;try{return!(!a||a==a.top)}catch(b){return!1}},L=function(){return firebase.INTERNAL.hasOwnProperty("reactNative")?"ReactNative":firebase.INTERNAL.hasOwnProperty("node")?"Node":"Browser"},lf=function(){var a=L();return"ReactNative"===
a||"Node"===a},Ze=function(a){var b=a.toLowerCase();if(u(b,"opera/")||u(b,"opr/")||u(b,"opios/"))return"Opera";if(u(b,"iemobile"))return"IEMobile";if(u(b,"msie")||u(b,"trident/"))return"IE";if(u(b,"edge/"))return"Edge";if(u(b,"firefox/"))return"Firefox";if(u(b,"silk/"))return"Silk";if(u(b,"blackberry"))return"Blackberry";if(u(b,"webos"))return"Webos";if(!u(b,"safari/")||u(b,"chrome/")||u(b,"crios/")||u(b,"android"))if(!u(b,"chrome/")&&!u(b,"crios/")||u(b,"edge/")){if(u(b,"android"))return"Android";
if((a=a.match(/([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/))&&2==a.length)return a[1]}else return"Chrome";else return"Safari";return"Other"},mf=function(a){var b=L();return("Browser"===b?Ze(K()):b)+"/JsCore/"+a},K=function(){return l.navigator&&l.navigator.userAgent||""},M=function(a,b){a=a.split(".");b=b||l;for(var c=0;c<a.length&&"object"==typeof b&&null!=b;c++)b=b[a[c]];c!=a.length&&(b=void 0);return b},pf=function(){var a;if(a=(nf()||"chrome-extension:"===jf()||gf())&&!lf())a:{try{var b=l.localStorage,c=
of();if(b){b.setItem(c,"1");b.removeItem(c);a=Ve()?!!l.indexedDB:!0;break a}}catch(d){}a=!1}return a},nf=function(){return"http:"===jf()||"https:"===jf()},jf=function(){return l.location&&l.location.protocol||null},qf=function(a){a=a||K();return af(a)||"Firefox"==Ze(a)?!1:!0},rf=function(a){return"undefined"===typeof a?null:xc(a)},sf=function(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&null!==a[c]&&void 0!==a[c]&&(b[c]=a[c]);return b},tf=function(a){if(null!==a)return JSON.parse(a)},of=function(a){return a?
a:""+Math.floor(1E9*Math.random()).toString()},uf=function(a){a=a||K();return"Safari"==Ze(a)||a.toLowerCase().match(/iphone|ipad|ipod/)?!1:!0},vf=function(){var a=l.___jsl;if(a&&a.H)for(var b in a.H)if(a.H[b].r=a.H[b].r||[],a.H[b].L=a.H[b].L||[],a.H[b].r=a.H[b].L.concat(),a.CP)for(var c=0;c<a.CP.length;c++)a.CP[c]=null},wf=function(){return l.navigator&&"boolean"===typeof l.navigator.onLine?l.navigator.onLine:!0},xf=function(a,b,c,d){if(a>b)throw Error("Short delay should be less than long delay!");
this.Ff=a;this.gf=b;a=c||K();d=d||L();this.cf=af(a)||"ReactNative"===d};xf.prototype.get=function(){return this.cf?this.gf:this.Ff};
var yf=function(){var a=l.document;return a&&"undefined"!==typeof a.visibilityState?"visible"==a.visibilityState:!0},zf=function(){var a=l.document,b=null;return yf()||!a?B():(new A(function(c){b=function(){yf()&&(a.removeEventListener("visibilitychange",b,!1),c())};a.addEventListener("visibilitychange",b,!1)})).f(function(c){a.removeEventListener("visibilitychange",b,!1);throw c;})};var Af={},Bf=function(a){Af[a]||(Af[a]=!0,"undefined"!==typeof console&&"function"===typeof console.warn&&console.warn(a))};var Cf;try{var Df={};Object.defineProperty(Df,"abcd",{configurable:!0,enumerable:!0,value:1});Object.defineProperty(Df,"abcd",{configurable:!0,enumerable:!0,value:2});Cf=2==Df.abcd}catch(a){Cf=!1}
var N=function(a,b,c){Cf?Object.defineProperty(a,b,{configurable:!0,enumerable:!0,value:c}):a[b]=c},Ef=function(a,b){Cf?Object.defineProperty(a,"provider",{configurable:!0,enumerable:!0,get:function(){Bf("firebase.auth.AuthCredential.provider is deprecated. Please use the providerId field instead.");return b}}):a.provider=b},Ff=function(a,b){if(b)for(var c in b)b.hasOwnProperty(c)&&N(a,c,b[c])},Gf=function(a){var b={};Ff(b,a);return b},Hf=function(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&(b[c]=
a[c]);return b},If=function(a,b){if(!b||!b.length)return!0;if(!a)return!1;for(var c=0;c<b.length;c++){var d=a[b[c]];if(void 0===d||null===d||""===d)return!1}return!0},Jf=function(a){var b=a;if("object"==typeof a&&null!=a){var b="length"in a?[]:{},c;for(c in a)N(b,c,Jf(a[c]))}return b};var Kf="oauth_consumer_key oauth_nonce oauth_signature oauth_signature_method oauth_timestamp oauth_token oauth_version".split(" "),Lf=["client_id","response_type","scope","redirect_uri","state"],Mf={Pf:{Mb:500,Lb:600,providerId:"facebook.com",qd:Lf},Qf:{Mb:500,Lb:620,providerId:"github.com",qd:Lf},Rf:{Mb:515,Lb:680,providerId:"google.com",qd:Lf},Sf:{Mb:485,Lb:705,providerId:"twitter.com",qd:Kf}},Nf=function(a){for(var b in Mf)if(Mf[b].providerId==a)return Mf[b];return null};var O=function(a,b){this.code="auth/"+a;this.message=b||Of[a]||""};r(O,Error);O.prototype.C=function(){return{code:this.code,message:this.message}};O.prototype.toJSON=function(){return this.C()};
var Pf=function(a){var b=a&&a.code;return b?new O(b.substring(5),a.message):null},Of={"argument-error":"","app-not-authorized":"This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.","app-not-installed":"The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.","captcha-check-failed":"",
"code-expired":"","cordova-not-ready":"Cordova framework is not ready.","cors-unsupported":"This browser is not supported.","credential-already-in-use":"This credential is already associated with a different user account.","custom-token-mismatch":"The custom token corresponds to a different audience.","requires-recent-login":"This operation is sensitive and requires recent authentication. Log in again before retrying this request.","dynamic-link-not-activated":"Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
"email-already-in-use":"The email address is already in use by another account.","expired-action-code":"The action code has expired. ","cancelled-popup-request":"This operation has been cancelled due to another conflicting popup being opened.","internal-error":"An internal error has occurred.","invalid-app-credential":"","invalid-app-id":"The mobile app identifier is not registed for the current project.","invalid-user-token":"The user's credential is no longer valid. The user must sign in again.",
"invalid-auth-event":"An internal error has occurred.","invalid-verification-code":"","invalid-cordova-configuration":"The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.","invalid-custom-token":"The custom token format is incorrect. Please check the documentation.","invalid-email":"The email address is badly formatted.","invalid-api-key":"Your API key is invalid, please check you have copied it correctly.",
"invalid-credential":"The supplied auth credential is malformed or has expired.","invalid-message-payload":"The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.","invalid-oauth-provider":"EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.","unauthorized-domain":"This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
"invalid-action-code":"The action code is invalid. This can happen if the code is malformed, expired, or has already been used.","wrong-password":"The password is invalid or the user does not have a password.","invalid-identifier-number":"","invalid-recipient-email":"The email corresponding to this action failed to send as the provided recipient email address is invalid.","invalid-sender":"The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
"invalid-verification-id":"","missing-iframe-start":"An internal error has occurred.","auth-domain-config-required":"Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.","missing-app-credential":"","missing-verification-code":"","missing-identifier-number":"","missing-verification-id":"","app-deleted":"This instance of FirebaseApp has been deleted.","account-exists-with-different-credential":"An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
"network-request-failed":"A network error (such as timeout, interrupted connection or unreachable host) has occurred.","no-auth-event":"An internal error has occurred.","no-such-provider":"User was not linked to an account with the given provider.","operation-not-allowed":"The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.","operation-not-supported-in-this-environment":'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
"popup-blocked":"Unable to establish a connection with the popup. It may have been blocked by the browser.","popup-closed-by-user":"The popup has been closed by the user before finalizing the operation.","provider-already-linked":"User can only be linked to one identity for the given provider.","quota-exceeded":"","redirect-cancelled-by-user":"The redirect operation has been cancelled by the user before finalizing.","redirect-operation-pending":"A redirect sign-in operation is already pending.",timeout:"The operation has timed out.",
"user-token-expired":"The user's credential is no longer valid. The user must sign in again.","too-many-requests":"We have blocked all requests from this device due to unusual activity. Try again later.","user-cancelled":"User did not grant your application the permissions it requested.","user-not-found":"There is no user record corresponding to this identifier. The user may have been deleted.","user-disabled":"The user account has been disabled by an administrator.","user-mismatch":"The supplied credentials do not correspond to the previously signed in user.",
"user-signed-out":"","weak-password":"The password must be 6 characters long or more.","web-storage-unsupported":"This browser is not supported or 3rd party cookies and data may be disabled."};var P=function(a,b,c,d,e){this.da=a;this.J=b||null;this.tb=c||null;this.sd=d||null;this.P=e||null;if(this.tb||this.P){if(this.tb&&this.P)throw new O("invalid-auth-event");if(this.tb&&!this.sd)throw new O("invalid-auth-event");}else throw new O("invalid-auth-event");};P.prototype.ic=function(){return this.sd};P.prototype.getError=function(){return this.P};P.prototype.C=function(){return{type:this.da,eventId:this.J,urlResponse:this.tb,sessionId:this.sd,error:this.P&&this.P.C()}};
var Qf=function(a){a=a||{};return a.type?new P(a.type,a.eventId,a.urlResponse,a.sessionId,a.error&&Pf(a.error)):null};var Rf=function(a){var b="unauthorized-domain",c=void 0,d=Pe(a);a=d.ea;d=d.ha;"chrome-extension"==d?c=ma("This chrome extension ID (chrome-extension://%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):"http"==d||"https"==d?c=ma("This domain (%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):b=
"operation-not-supported-in-this-environment";O.call(this,b,c)};r(Rf,O);var Sf=function(a){this.ff=a.sub;la();this.gc=a.email||null};var Tf=function(a,b){return a.then(function(a){if(a.idToken){var c;a:{var e=a.idToken.split(".");if(3==e.length){for(var e=e[1],f=(4-e.length%4)%4,g=0;g<f;g++)e+=".";try{var k=JSON.parse(tb(e));if(k.sub&&k.iss&&k.aud&&k.exp){c=new Sf(k);break a}}catch(n){}}c=null}if(!c||b!=c.ff)throw new O("user-mismatch");return a}throw new O("user-mismatch");}).f(function(a){throw a&&a.code&&"auth/user-not-found"==a.code?new O("user-mismatch"):a;})},Uf=function(a,b){if(b.idToken||b.accessToken)b.idToken&&N(this,
"idToken",b.idToken),b.accessToken&&N(this,"accessToken",b.accessToken);else if(b.oauthToken&&b.oauthTokenSecret)N(this,"accessToken",b.oauthToken),N(this,"secret",b.oauthTokenSecret);else throw new O("internal-error","failed to construct a credential");Ef(this,a);N(this,"providerId",a)};Uf.prototype.Ab=function(a){return Vf(a,Wf(this))};Uf.prototype.cd=function(a,b){var c=Wf(this);c.idToken=b;return Xf(a,c)};Uf.prototype.ed=function(a,b){var c=Wf(this);return Tf(Yf(a,c),b)};
var Wf=function(a){var b={};a.idToken&&(b.id_token=a.idToken);a.accessToken&&(b.access_token=a.accessToken);a.secret&&(b.oauth_token_secret=a.secret);b.providerId=a.providerId;return{postBody:Ue(b).toString(),requestUri:"http://localhost"}};Uf.prototype.C=function(){var a={providerId:this.providerId};this.idToken&&(a.oauthIdToken=this.idToken);this.accessToken&&(a.oauthAccessToken=this.accessToken);this.secret&&(a.oauthTokenSecret=this.secret);return a};
var Zf=function(a,b){this.vf=b||[];Ff(this,{providerId:a,isOAuthProvider:!0});this.Id={}};Zf.prototype.setCustomParameters=function(a){this.Id=Xa(a);return this};var Q=function(a){Zf.call(this,a,Lf);this.rd=[]};r(Q,Zf);Q.prototype.addScope=function(a){Ia(this.rd,a)||this.rd.push(a);return this};Q.prototype.Rd=function(){return Na(this.rd)};
Q.prototype.credential=function(a,b){if(!a&&!b)throw new O("argument-error","credential failed: must provide the ID token and/or the access token.");return new Uf(this.providerId,{idToken:a||null,accessToken:b||null})};var $f=function(){Q.call(this,"facebook.com")};r($f,Q);N($f,"PROVIDER_ID","facebook.com");
var ag=function(a){if(!a)throw new O("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;ha(a)&&(b=a.accessToken);return(new $f).credential(null,b)},bg=function(){Q.call(this,"github.com")};r(bg,Q);N(bg,"PROVIDER_ID","github.com");
var cg=function(a){if(!a)throw new O("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;ha(a)&&(b=a.accessToken);return(new bg).credential(null,b)},dg=function(){Q.call(this,"google.com");this.addScope("profile")};r(dg,Q);N(dg,"PROVIDER_ID","google.com");var eg=function(a,b){var c=a;ha(a)&&(c=a.idToken,b=a.accessToken);return(new dg).credential(c,b)},fg=function(){Zf.call(this,"twitter.com",Kf)};r(fg,Zf);N(fg,"PROVIDER_ID","twitter.com");
var gg=function(a,b){var c=a;ha(c)||(c={oauthToken:a,oauthTokenSecret:b});if(!c.oauthToken||!c.oauthTokenSecret)throw new O("argument-error","credential failed: expected 2 arguments (the OAuth access token and secret).");return new Uf("twitter.com",c)},hg=function(a,b){this.gc=a;this.jd=b;Ef(this,"password");N(this,"providerId","password")};hg.prototype.Ab=function(a){return R(a,ig,{email:this.gc,password:this.jd})};hg.prototype.cd=function(a,b){return R(a,jg,{idToken:b,email:this.gc,password:this.jd})};
hg.prototype.ed=function(a,b){return Tf(this.Ab(a),b)};hg.prototype.C=function(){return{email:this.gc,password:this.jd}};var kg=function(){Ff(this,{providerId:"password",isOAuthProvider:!1})};Ff(kg,{PROVIDER_ID:"password"});var lg=function(a){if(!(a.Bd&&a.Ad||a.Yb&&a.ya))throw new O("internal-error");this.I=a;N(this,"providerId","identifier")};lg.prototype.Ab=function(a){return a.se(mg(this))};lg.prototype.cd=function(a,b){var c=mg(this);c.idToken=b;return R(a,ng,c)};
lg.prototype.ed=function(a,b){var c=mg(this);c.operation="REAUTH";a=R(a,og,c);return Tf(a,b)};lg.prototype.C=function(){var a={providerId:"identifier"};this.I.Bd&&(a.verificationId=this.I.Bd);this.I.Ad&&(a.verificationCode=this.I.Ad);this.I.Yb&&(a.temporaryProof=this.I.Yb);this.I.ya&&(a.identifierNumber=this.I.ya);return a};
var mg=function(a){return a.I.Yb&&a.I.ya?{temporaryProof:a.I.Yb,identifierNumber:a.I.ya}:{sessionInfo:a.I.Bd,code:a.I.Ad}},pg=function(a){try{this.Ce=a||firebase.auth()}catch(b){throw new O("argument-error","Either an instance of firebase.auth.Auth must be passed as an argument to the firebase.auth.identifierAuthProvider constructor, or the default firebase App instance must be initialized via firebase.initializeApp().");}Ff(this,{providerId:"identifier",isOAuthProvider:!1})};
pg.prototype.se=function(a,b){var c=this.Ce.g;return B(b.verify()).then(function(d){if(!m(d))throw new O("argument-error","An implementation of firebase.auth.ApplicationVerifier.prototype.verify() must return a firebase.Promise that resolves with a string.");switch(b.type){case "recaptcha":return R(c,qg,{identifierNumber:a,recaptchaToken:d});default:throw new O("argument-error",'Only firebase.auth.ApplicationVerifiers with type="recaptcha" are currently supported.');}})};Ff(pg,{PROVIDER_ID:"identifier"});
var rg=function(a){if(a.temporaryProof&&a.identifierNumber)return new lg({Yb:a.temporaryProof,ya:a.identifierNumber});var b=a&&a.providerId;if(!b||"password"===b)return null;var c=a&&a.oauthAccessToken,d=a&&a.oauthTokenSecret;a=a&&a.oauthIdToken;try{switch(b){case "google.com":return eg(a,c);case "facebook.com":return ag(c);case "github.com":return cg(c);case "twitter.com":return gg(c,d);default:return(new Q(b)).credential(a,c)}}catch(e){return null}},sg=function(a){if(!a.isOAuthProvider)throw new O("invalid-oauth-provider");
};var tg=function(a,b,c){O.call(this,a,c);a=b||{};a.email&&N(this,"email",a.email);a.ya&&N(this,"identifierNumber",a.ya);a.credential&&N(this,"credential",a.credential)};r(tg,O);tg.prototype.C=function(){var a={code:this.code,message:this.message};this.email&&(a.email=this.email);this.identifierNumber&&(a.identifierNumber=this.identifierNumber);var b=this.credential&&this.credential.C();b&&Za(a,b);return a};tg.prototype.toJSON=function(){return this.C()};
var ug=function(a){if(a.code){var b=a.code||"";0==b.indexOf("auth/")&&(b=b.substring(5));var c={credential:rg(a)};if(a.email)c.email=a.email;else if(a.identifierNumber)c.ya=a.identifierNumber;else return new O(b,a.message||void 0);return new tg(b,c,a.message)}return null};var vg=function(a){this.Of=a};r(vg,Bc);vg.prototype.fc=function(){return new this.Of};vg.prototype.$c=function(){return{}};
var S=function(a,b,c){var d;d="Node"==L();d=l.XMLHttpRequest||d&&firebase.INTERNAL.node&&firebase.INTERNAL.node.XMLHttpRequest;if(!d)throw new O("internal-error","The XMLHttpRequest compatibility library was not found.");this.j=a;a=b||{};this.Bf=a.secureTokenEndpoint||"https://securetoken.googleapis.com/v1/token";this.Cf=a.secureTokenTimeout||wg;this.ge=Xa(a.secureTokenHeaders||xg);this.Le=a.firebaseEndpoint||"https://www.googleapis.com/identitytoolkit/v3/relyingparty/";this.Me=a.firebaseTimeout||
yg;this.Pd=Xa(a.firebaseHeaders||zg);c&&(this.Pd["X-Client-Version"]=c,this.ge["X-Client-Version"]=c);this.Ee=new Gc;this.Nf=new vg(d)},Ag,wg=new xf(3E4,6E4),xg={"Content-Type":"application/x-www-form-urlencoded"},yg=new xf(3E4,6E4),zg={"Content-Type":"application/json"},Cg=function(a,b,c,d,e,f,g){wf()?($e()?a=q(a.Ef,a):(Ag||(Ag=new A(function(a,b){Bg(a,b)})),a=q(a.Df,a)),a(b,c,d,e,f,g)):c&&c(null)};
S.prototype.Ef=function(a,b,c,d,e,f){var g="Node"==L(),k=lf()?g?new F(this.Nf):new F:new F(this.Ee),n;f&&(k.sb=Math.max(0,f),n=setTimeout(function(){k.dispatchEvent("timeout")},f));k.listen("complete",function(){n&&clearTimeout(n);var a=null;try{a=JSON.parse(Be(this))||null}catch(db){a=null}b&&b(a)});cc(k,"ready",function(){n&&clearTimeout(n);this.Ga||(this.Ga=!0,this.cb())});cc(k,"timeout",function(){n&&clearTimeout(n);this.Ga||(this.Ga=!0,this.cb());b&&b(null)});k.send(a,c,d,e)};
var Ed="__fcb"+Math.floor(1E6*Math.random()).toString(),Bg=function(a,b){((window.gapi||{}).client||{}).request?a():(l[Ed]=function(){((window.gapi||{}).client||{}).request?a():b(Error("CORS_UNSUPPORTED"))},Gd(function(){b(Error("CORS_UNSUPPORTED"))}))};
S.prototype.Df=function(a,b,c,d,e){var f=this;Ag.then(function(){window.gapi.client.setApiKey(f.j);var g=window.gapi.auth.getToken();window.gapi.auth.setToken(null);window.gapi.client.request({path:a,method:c,body:d,headers:e,authType:"none",callback:function(a){window.gapi.auth.setToken(g);b&&b(a)}})}).f(function(a){b&&b({error:{message:a&&a.message||"CORS_UNSUPPORTED"}})})};
var Eg=function(a,b){return new A(function(c,d){"refresh_token"==b.grant_type&&b.refresh_token||"authorization_code"==b.grant_type&&b.code?Cg(a,a.Bf+"?key="+encodeURIComponent(a.j),function(a){a?a.error?d(Dg(a)):a.access_token&&a.refresh_token?c(a):d(new O("internal-error")):d(new O("network-request-failed"))},"POST",Ue(b).toString(),a.ge,a.Cf.get()):d(new O("internal-error"))})},Fg=function(a,b,c,d,e,f){var g=Pe(a.Le+b);J(g,"key",a.j);f&&J(g,"cb",la().toString());var k="GET"==c;if(k)for(var n in d)d.hasOwnProperty(n)&&
J(g,n,d[n]);return new A(function(b,f){Cg(a,g.toString(),function(a){a?a.error?f(Dg(a,e||{})):b(a):f(new O("network-request-failed"))},c,k?void 0:xc(sf(d)),a.Pd,a.Me.get())})},Gg=function(a){if(!ic.test(a.email))throw new O("invalid-email");},Hg=function(a){"email"in a&&Gg(a)},Jg=function(a,b){return R(a,Ig,{identifier:b,continueUri:nf()?We():"http://localhost"}).then(function(a){return a.allProviders||[]})},Lg=function(a){return R(a,Kg,{}).then(function(a){return a.authorizedDomains||[]})},Mg=function(a){if(!a.idToken)throw new O("internal-error");
},Ng=function(a){if(a.identifierNumber||a.temporaryProof){if(!a.identifierNumber||!a.temporaryProof)throw new O("internal-error");}else{if(!a.sessionInfo)throw new O("missing-verification-id");if(!a.code)throw new O("missing-verification-code");}};S.prototype.signInAnonymously=function(){return R(this,Og,{})};S.prototype.updateEmail=function(a,b){return R(this,Pg,{idToken:a,email:b})};S.prototype.updatePassword=function(a,b){return R(this,jg,{idToken:a,password:b})};var Qg={displayName:"DISPLAY_NAME",photoUrl:"PHOTO_URL"};
S.prototype.updateProfile=function(a,b){var c={idToken:a},d=[];Sa(Qg,function(a,f){var e=b[f];null===e?d.push(a):f in b&&(c[f]=e)});d.length&&(c.deleteAttribute=d);return R(this,Pg,c)};S.prototype.sendPasswordResetEmail=function(a){return R(this,Rg,{requestType:"PASSWORD_RESET",email:a})};S.prototype.sendEmailVerification=function(a){return R(this,Sg,{requestType:"VERIFY_EMAIL",idToken:a})};S.prototype.se=function(a){return R(this,Tg,a)};
var Vg=function(a,b,c){return R(a,Ug,{idToken:b,deleteProvider:c})},Wg=function(a){if(!a.requestUri||!a.sessionId&&!a.postBody)throw new O("internal-error");},Xg=function(a){var b=null;a.needConfirmation?(a.code="account-exists-with-different-credential",b=ug(a)):"FEDERATED_USER_ID_ALREADY_LINKED"==a.errorMessage?(a.code="credential-already-in-use",b=ug(a)):"EMAIL_EXISTS"==a.errorMessage&&(a.code="email-already-in-use",b=ug(a));if(b)throw b;if(!a.idToken)throw new O("internal-error");},Vf=function(a,
b){b.returnIdpCredential=!0;return R(a,Yg,b)},Xf=function(a,b){b.returnIdpCredential=!0;return R(a,Zg,b)},Yf=function(a,b){b.returnIdpCredential=!0;b.autoCreate=!1;return R(a,$g,b)},ah=function(a){if(!a.oobCode)throw new O("invalid-action-code");};S.prototype.confirmPasswordReset=function(a,b){return R(this,bh,{oobCode:a,newPassword:b})};S.prototype.checkActionCode=function(a){return R(this,ch,{oobCode:a})};S.prototype.applyActionCode=function(a){return R(this,dh,{oobCode:a})};
var dh={endpoint:"setAccountInfo",A:ah,Wa:"email"},ch={endpoint:"resetPassword",A:ah,Y:function(a){if(!a.email||!a.requestType)throw new O("internal-error");}},eh={endpoint:"signupNewUser",A:function(a){Gg(a);if(!a.password)throw new O("weak-password");},Y:Mg,sa:!0},Ig={endpoint:"createAuthUri"},fh={endpoint:"deleteAccount",Ua:["idToken"]},Ug={endpoint:"setAccountInfo",Ua:["idToken","deleteProvider"],A:function(a){if(!ea(a.deleteProvider))throw new O("internal-error");}},gh={endpoint:"getAccountInfo"},
Sg={endpoint:"getOobConfirmationCode",Ua:["idToken","requestType"],A:function(a){if("VERIFY_EMAIL"!=a.requestType)throw new O("internal-error");},Wa:"email"},Rg={endpoint:"getOobConfirmationCode",Ua:["requestType"],A:function(a){if("PASSWORD_RESET"!=a.requestType)throw new O("internal-error");Gg(a)},Wa:"email"},Kg={De:!0,endpoint:"getProjectConfig",We:"GET"},bh={endpoint:"resetPassword",A:ah,Wa:"email"},qg={endpoint:"sendVerificationCode",Ua:["identifierNumber","recaptchaToken"],Wa:"sessionInfo"},Pg={endpoint:"setAccountInfo",
Ua:["idToken"],A:Hg,sa:!0},jg={endpoint:"setAccountInfo",Ua:["idToken"],A:function(a){Hg(a);if(!a.password)throw new O("weak-password");},Y:Mg,sa:!0},Og={endpoint:"signupNewUser",Y:Mg,sa:!0},Yg={endpoint:"verifyAssertion",A:Wg,Y:Xg,sa:!0},$g={endpoint:"verifyAssertion",A:Wg,Y:function(a){if(a.errorMessage&&"USER_NOT_FOUND"==a.errorMessage)throw new O("user-not-found");if(!a.idToken)throw new O("internal-error");},sa:!0},Zg={endpoint:"verifyAssertion",A:function(a){Wg(a);if(!a.idToken)throw new O("internal-error");
},Y:Xg,sa:!0},hh={endpoint:"verifyCustomToken",A:function(a){if(!a.token)throw new O("invalid-custom-token");},Y:Mg,sa:!0},ig={endpoint:"verifyPassword",A:function(a){Gg(a);if(!a.password)throw new O("wrong-password");},Y:Mg,sa:!0},Tg={endpoint:"verifyidentifierNumber",A:Ng,Y:Mg},ng={endpoint:"verifyidentifierNumber",A:function(a){if(!a.idToken)throw new O("internal-error");Ng(a)},Y:function(a){if(a.temporaryProof)throw a.code="credential-already-in-use",ug(a);Mg(a)}},og={Ge:{USER_NOT_FOUND:"user-not-found"},
endpoint:"verifyidentifierNumber",A:Ng,Y:Mg},R=function(a,b,c){if(!If(c,b.Ua))return D(new O("internal-error"));var d=b.We||"POST",e;return B(c).then(b.A).then(function(){b.sa&&(c.returnSecureToken=!0);return Fg(a,b.endpoint,d,c,b.Ge,b.De||!1)}).then(function(a){return e=a}).then(b.Y).then(function(){if(!b.Wa)return e;if(!(b.Wa in e))throw new O("internal-error");return e[b.Wa]})},Dg=function(a,b){var c;c=(a.error&&a.error.errors&&a.error.errors[0]||{}).reason||"";var d={keyInvalid:"invalid-api-key",ipRefererBlocked:"app-not-authorized"};
if(c=d[c]?new O(d[c]):null)return c;c=a.error&&a.error.message||"";d={INVALID_CUSTOM_TOKEN:"invalid-custom-token",CREDENTIAL_MISMATCH:"custom-token-mismatch",MISSING_CUSTOM_TOKEN:"internal-error",INVALID_IDENTIFIER:"invalid-email",MISSING_CONTINUE_URI:"internal-error",INVALID_EMAIL:"invalid-email",INVALID_PASSWORD:"wrong-password",USER_DISABLED:"user-disabled",MISSING_PASSWORD:"internal-error",EMAIL_EXISTS:"email-already-in-use",PASSWORD_LOGIN_DISABLED:"operation-not-allowed",INVALID_IDP_RESPONSE:"invalid-credential",
FEDERATED_USER_ID_ALREADY_LINKED:"credential-already-in-use",INVALID_MESSAGE_PAYLOAD:"invalid-message-payload",INVALID_RECIPIENT_EMAIL:"invalid-recipient-email",INVALID_SENDER:"invalid-sender",EMAIL_NOT_FOUND:"user-not-found",EXPIRED_OOB_CODE:"expired-action-code",INVALID_OOB_CODE:"invalid-action-code",MISSING_OOB_CODE:"internal-error",CREDENTIAL_TOO_OLD_LOGIN_AGAIN:"requires-recent-login",INVALID_ID_TOKEN:"invalid-user-token",TOKEN_EXPIRED:"user-token-expired",USER_NOT_FOUND:"user-token-expired",
CORS_UNSUPPORTED:"cors-unsupported",DYNAMIC_LINK_NOT_ACTIVATED:"dynamic-link-not-activated",INVALID_APP_ID:"invalid-app-id",TOO_MANY_ATTEMPTS_TRY_LATER:"too-many-requests",WEAK_PASSWORD:"weak-password",OPERATION_NOT_ALLOWED:"operation-not-allowed",USER_CANCELLED:"user-cancelled",CAPTCHA_CHECK_FAILED:"captcha-check-failed",INVALID_APP_CREDENTIAL:"invalid-app-credential",INVALID_CODE:"invalid-verification-code",INVALID_identifier_NUMBER:"invalid-identifier-number",INVALID_SESSION_INFO:"invalid-verification-id",
INVALID_TEMPORARY_PROOF:"invalid-credential",MISSING_APP_CREDENTIAL:"missing-app-credential",MISSING_CODE:"missing-verification-code",MISSING_identifier_NUMBER:"missing-identifier-number",MISSING_SESSION_INFO:"missing-verification-id",QUOTA_EXCEEDED:"quota-exceeded",SESSION_EXPIRED:"code-expired"};Za(d,b||{});b=(b=c.match(/^[^\s]+\s*:\s*(.*)$/))&&1<b.length?b[1]:void 0;for(var e in d)if(0===c.indexOf(e))return new O(d[e],b);!b&&a&&(b=rf(a));return new O("internal-error",b)};var ih=function(a){this.V=a};ih.prototype.value=function(){return this.V};ih.prototype.je=function(a){this.V.style=a;return this};var jh=function(a){this.V=a||{}};jh.prototype.value=function(){return this.V};jh.prototype.je=function(a){this.V.style=a;return this};var lh=function(a){this.Lf=a;this.nc=null;this.gd=kh(this)},mh=function(a){var b=new jh;b.V.where=document.body;b.V.url=a.Lf;b.V.messageHandlersFilter=M("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER");b.V.attributes=b.V.attributes||{};(new ih(b.V.attributes)).je({position:"absolute",top:"-100px",width:"1px",height:"1px"});b.V.dontclear=!0;return b},kh=function(a){return nh().then(function(){return new A(function(b,c){M("gapi.iframes.getContext")().open(mh(a).value(),function(d){a.nc=d;a.nc.restyle({setHideOnLeave:!1});
var e=setTimeout(function(){c(Error("Network Error"))},oh.get()),f=function(){clearTimeout(e);b()};d.ping(f).then(f,function(){c(Error("Network Error"))})})})})};lh.prototype.sendMessage=function(a){var b=this;return this.gd.then(function(){return new A(function(c){b.nc.send(a.type,a,c,M("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})})};
var ph=function(a,b){a.gd.then(function(){a.nc.register("authEvent",b,M("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})},qh=new xf(3E4,6E4),oh=new xf(5E3,15E3),nh=function(){return new A(function(a,b){if(wf()){var c=function(){vf();M("gapi.load")("gapi.iframes",{callback:a,ontimeout:function(){vf();b(Error("Network Error"))},timeout:qh.get()})};if(M("gapi.iframes.Iframe"))a();else if(M("gapi.load"))c();else{var d="__iframefcb"+Math.floor(1E6*Math.random()).toString();l[d]=function(){M("gapi.load")?
c():b(Error("Network Error"))};B(Dd("https://apis.google.com/js/api.js?onload="+d)).f(function(){b(Error("Network Error"))})}}else b(Error("Network Error"))})};var rh=function(a,b,c){this.v=a;this.j=b;this.D=c;this.Ya=null;this.ac=Qe(this.v,"/__/auth/iframe");J(this.ac,"apiKey",this.j);J(this.ac,"appName",this.D)};rh.prototype.setVersion=function(a){this.Ya=a;return this};rh.prototype.toString=function(){this.Ya?J(this.ac,"v",this.Ya):this.ac.removeParameter("v");return this.ac.toString()};var sh=function(a,b,c,d,e){this.v=a;this.j=b;this.D=c;this.Be=d;this.Ya=this.J=this.pd=null;this.Pb=e};sh.prototype.setVersion=function(a){this.Ya=a;return this};
sh.prototype.toString=function(){var a=Qe(this.v,"/__/auth/handler");J(a,"apiKey",this.j);J(a,"appName",this.D);J(a,"authType",this.Be);if(this.Pb.isOAuthProvider){J(a,"providerId",this.Pb.providerId);var b=this.Pb,c=sf(b.Id),d;for(d in c)c[d]=c[d].toString();b=b.vf;c=Xa(c);for(d=0;d<b.length;d++){var e=b[d];e in c&&delete c[e]}Va(c)||J(a,"customParameters",rf(c))}"function"===typeof this.Pb.Rd&&(b=this.Pb.Rd(),b.length&&J(a,"scopes",b.join(",")));this.pd?J(a,"redirectUrl",this.pd):a.removeParameter("redirectUrl");
this.J?J(a,"eventId",this.J):a.removeParameter("eventId");this.Ya?J(a,"v",this.Ya):a.removeParameter("v");if(this.bc)for(var f in this.bc)this.bc.hasOwnProperty(f)&&!Oe(a,f)&&J(a,f,this.bc[f]);return a.toString()};
var th=function(a,b,c,d){this.v=a;this.j=b;this.D=c;this.Oe=(this.Ea=d||null)?mf(this.Ea):null;d=this.Ea;this.Xe=(new rh(a,b,c)).setVersion(d).toString();this.ma=[];this.g=new S(b,null,this.Oe);this.pc=this.wa=null},uh=function(a){var b=We();return Lg(a).then(function(a){a:{for(var c=Pe(b),e=c.ha,c=c.ea,f=0;f<a.length;f++){var g;var k=a[f];g=c;var n=e;0==k.indexOf("chrome-extension://")?g=Pe(k).ea==g&&"chrome-extension"==n:"http"!=n&&"https"!=n?g=!1:ef.test(k)?g=g==k:(k=k.split(".").join("\\."),g=
(new RegExp("^(.+\\."+k+"|"+k+")$","i")).test(g));if(g){a=!0;break a}}a=!1}if(!a)throw new Rf(We());})};h=th.prototype;h.Gb=function(){if(this.pc)return this.pc;var a=this;return this.pc=ff().then(function(){a.mc=new lh(a.Xe);vh(a)})};h.Vb=function(a,b,c){var d=new O("popup-closed-by-user"),e=new O("web-storage-unsupported"),f=this,g=!1;return this.La().then(function(){wh(f).then(function(c){c||(a&&bf(a),b(e),g=!0)})}).f(function(){}).then(function(){if(!g)return df(a)}).then(function(){if(!g)return le(c).then(function(){b(d)})})};
h.ke=function(){var a=K();return!qf(a)&&!uf(a)};h.Ud=function(){return!1};h.Nb=function(a,b,c,d,e,f,g){if(!a)return D(new O("popup-blocked"));if(g&&!qf())return this.La().f(function(b){bf(a);e(b)}),d(),B();this.wa||(this.wa=uh(this.g));var k=this;return this.wa.then(function(){var b=k.La().f(function(b){bf(a);e(b);throw b;});d();return b}).then(function(){sg(c);if(!g){var d=xh(k.v,k.j,k.D,b,c,null,f,k.Ea);Xe(d,a)}}).f(function(a){"auth/network-request-failed"==a.code&&(k.wa=null);throw a;})};
h.Ob=function(a,b,c){this.wa||(this.wa=uh(this.g));var d=this;return this.wa.then(function(){sg(b);var e=xh(d.v,d.j,d.D,a,b,We(),c,d.Ea);Xe(e)})};h.La=function(){var a=this;return this.Gb().then(function(){return a.mc.gd}).f(function(){a.wa=null;throw new O("network-request-failed");})};h.ne=function(){return!0};
var xh=function(a,b,c,d,e,f,g,k,n){a=new sh(a,b,c,d,e);a.pd=f;a.J=g;f=a.setVersion(k);f.bc=Xa(n||null);return f.toString()},vh=function(a){if(!a.mc)throw Error("IfcHandler must be initialized!");ph(a.mc,function(b){var c={};if(b&&b.authEvent){var d=!1;b=Qf(b.authEvent);for(c=0;c<a.ma.length;c++)d=a.ma[c](b)||d;c={};c.status=d?"ACK":"ERROR";return B(c)}c.status="ERROR";return B(c)})},wh=function(a){var b={type:"webStorageSupport"};return a.Gb().then(function(){return a.mc.sendMessage(b)}).then(function(a){if(a&&
a.length&&"undefined"!==typeof a[0].webStorageSupport)return a[0].webStorageSupport;throw Error();})};th.prototype.$a=function(a){this.ma.push(a)};th.prototype.Tb=function(a){La(this.ma,function(b){return b==a})};var yh=function(a){this.B=a||firebase.INTERNAL.reactNative&&firebase.INTERNAL.reactNative.AsyncStorage;if(!this.B)throw new O("internal-error","The React Native compatibility library was not found.");};h=yh.prototype;h.get=function(a){return B(this.B.getItem(a)).then(function(a){return a&&tf(a)})};h.set=function(a,b){return B(this.B.setItem(a,rf(b)))};h.remove=function(a){return B(this.B.removeItem(a))};h.ab=function(){};h.Ta=function(){};var zh=function(){this.B={}};h=zh.prototype;h.get=function(a){return B(this.B[a])};h.set=function(a,b){this.B[a]=b;return B()};h.remove=function(a){delete this.B[a];return B()};h.ab=function(){};h.Ta=function(){};var Ch=function(){if(!Bh()){if("Node"==L())throw new O("internal-error","The LocalStorage compatibility library was not found.");throw new O("web-storage-unsupported");}this.B=l.localStorage||firebase.INTERNAL.node.localStorage},Bh=function(){var a="Node"==L(),a=l.localStorage||a&&firebase.INTERNAL.node&&firebase.INTERNAL.node.localStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}};h=Ch.prototype;
h.get=function(a){var b=this;return B().then(function(){var c=b.B.getItem(a);return tf(c)})};h.set=function(a,b){var c=this;return B().then(function(){var d=rf(b);null===d?c.remove(a):c.B.setItem(a,d)})};h.remove=function(a){var b=this;return B().then(function(){b.B.removeItem(a)})};h.ab=function(a){l.window&&Vb(l.window,"storage",a)};h.Ta=function(a){l.window&&dc(l.window,"storage",a)};var Dh=function(){this.B={}};h=Dh.prototype;h.get=function(){return B(null)};h.set=function(){return B()};h.remove=function(){return B()};h.ab=function(){};h.Ta=function(){};var Fh=function(){if(!Eh()){if("Node"==L())throw new O("internal-error","The SessionStorage compatibility library was not found.");throw new O("web-storage-unsupported");}this.B=l.sessionStorage||firebase.INTERNAL.node.sessionStorage},Eh=function(){var a="Node"==L(),a=l.sessionStorage||a&&firebase.INTERNAL.node&&firebase.INTERNAL.node.sessionStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}};h=Fh.prototype;
h.get=function(a){var b=this;return B().then(function(){var c=b.B.getItem(a);return tf(c)})};h.set=function(a,b){var c=this;return B().then(function(){var d=rf(b);null===d?c.remove(a):c.B.setItem(a,d)})};h.remove=function(a){var b=this;return B().then(function(){b.B.removeItem(a)})};h.ab=function(){};h.Ta=function(){};var Gh=function(a,b,c,d,e,f){if(!window.indexedDB)throw new O("web-storage-unsupported");this.He=a;this.fd=b;this.Qc=c;this.re=d;this.wb=e;this.$={};this.Wb=[];this.Jb=0;this.Ye=f||l.indexedDB},Hh,Ih=function(a){return new A(function(b,c){var d=a.Ye.open(a.He,a.wb);d.onerror=function(a){c(Error(a.target.errorCode))};d.onupgradeneeded=function(b){b=b.target.result;try{b.createObjectStore(a.fd,{keyPath:a.Qc})}catch(f){c(f)}};d.onsuccess=function(a){b(a.target.result)}})},Jh=function(a){a.Xd||(a.Xd=
Ih(a));return a.Xd},Kh=function(a,b){return b.objectStore(a.fd)},Lh=function(a,b,c){return b.transaction([a.fd],c?"readwrite":"readonly")},Mh=function(a){return new A(function(b,c){a.onsuccess=function(a){a&&a.target?b(a.target.result):b()};a.onerror=function(a){c(Error(a.target.errorCode))}})};h=Gh.prototype;
h.set=function(a,b){var c=!1,d,e=this;return md(Jh(this).then(function(b){d=b;b=Kh(e,Lh(e,d,!0));return Mh(b.get(a))}).then(function(f){var g=Kh(e,Lh(e,d,!0));if(f)return f.value=b,Mh(g.put(f));e.Jb++;c=!0;f={};f[e.Qc]=a;f[e.re]=b;return Mh(g.add(f))}).then(function(){e.$[a]=b}),function(){c&&e.Jb--})};h.get=function(a){var b=this;return Jh(this).then(function(c){return Mh(Kh(b,Lh(b,c,!1)).get(a))}).then(function(a){return a&&a.value})};
h.remove=function(a){var b=!1,c=this;return md(Jh(this).then(function(d){b=!0;c.Jb++;return Mh(Kh(c,Lh(c,d,!0))["delete"](a))}).then(function(){delete c.$[a]}),function(){b&&c.Jb--})};
h.Hf=function(){var a=this;return Jh(this).then(function(b){var c=Kh(a,Lh(a,b,!1));return c.getAll?Mh(c.getAll()):new A(function(a,b){var d=[],e=c.openCursor();e.onsuccess=function(b){(b=b.target.result)?(d.push(b.value),b["continue"]()):a(d)};e.onerror=function(a){b(Error(a.target.errorCode))}})}).then(function(b){var c={},d=[];if(0==a.Jb){for(d=0;d<b.length;d++)c[b[d][a.Qc]]=b[d][a.re];d=Ye(a.$,c);a.$=c}return d})};h.ab=function(a){0==this.Wb.length&&this.vd();this.Wb.push(a)};
h.Ta=function(a){La(this.Wb,function(b){return b==a});0==this.Wb.length&&this.Bc()};h.vd=function(){var a=this;this.Bc();var b=function(){a.kd=le(800).then(q(a.Hf,a)).then(function(b){0<b.length&&w(a.Wb,function(a){a(b)})}).then(b).f(function(a){"STOP_EVENT"!=a.message&&b()});return a.kd};b()};h.Bc=function(){this.kd&&this.kd.cancel("STOP_EVENT")};var Qh=function(){this.Ld={Browser:Nh,Node:Oh,ReactNative:Ph}[L()]},Rh,Nh={M:Ch,yd:Fh},Oh={M:Ch,yd:Fh},Ph={M:yh,yd:Dh};var Sh=function(a){var b={},c=a.email,d=a.newEmail;a=a.requestType;if(!c||!a)throw Error("Invalid provider user info!");b.fromEmail=d||null;b.email=c;N(this,"operation",a);N(this,"data",Jf(b))};var Th=function(a,b,c,d,e,f){this.pf=a;this.xf=b;this.Qe=c;this.rc=d;this.zd=e;this.yf=!!f;this.kb=null;this.Ma=this.rc;if(this.zd<this.rc)throw Error("Proactive refresh lower bound greater than upper bound!");};Th.prototype.start=function(){this.Ma=this.rc;Uh(this,!0)};
var Vh=function(a,b){if(b)return a.Ma=a.rc,a.Qe();b=a.Ma;a.Ma*=2;a.Ma>a.zd&&(a.Ma=a.zd);return b},Uh=function(a,b){a.stop();a.kb=le(Vh(a,b)).then(function(){return a.yf?B():zf()}).then(function(){return a.pf()}).then(function(){Uh(a,!0)}).f(function(b){a.xf(b)&&Uh(a,!1)})};Th.prototype.stop=function(){this.kb&&(this.kb.cancel(),this.kb=null)};var ai=function(a){var b={};b["facebook.com"]=Wh;b["google.com"]=Xh;b["github.com"]=Yh;b["twitter.com"]=Zh;var c=a&&a.providerId;return c?b[c]?new b[c](a):new $h(a):null},$h=function(a){var b=tf(a.rawUserInfo||"{}");a=a.providerId;if(!a)throw Error("Invalid additional user info!");N(this,"profile",Jf(b||{}));N(this,"providerId",a)},Wh=function(a){$h.call(this,a);if("facebook.com"!=this.providerId)throw Error("Invalid provider id!");};r(Wh,$h);
var Yh=function(a){$h.call(this,a);if("github.com"!=this.providerId)throw Error("Invalid provider id!");N(this,"username",this.profile&&this.profile.login||null)};r(Yh,$h);var Xh=function(a){$h.call(this,a);if("google.com"!=this.providerId)throw Error("Invalid provider id!");};r(Xh,$h);var Zh=function(a){$h.call(this,a);if("twitter.com"!=this.providerId)throw Error("Invalid provider id!");N(this,"username",a.screenName||null)};r(Zh,$h);var bi=function(a,b,c,d){this.kf=a;this.he=b;this.zf=c;this.Ub=d;this.T={};Rh||(Rh=new Qh);a=Rh;try{var e;Ve()?(Hh||(Hh=new Gh("firebaseLocalStorageDb","firebaseLocalStorage","fbase_key","value",1)),e=Hh):e=new a.Ld.M;this.Qa=e}catch(f){this.Qa=new zh,this.Ub=!0}try{this.Dc=new a.Ld.yd}catch(f){this.Dc=new zh}this.wd=q(this.le,this);this.$={}},ci,di=function(){ci||(ci=new bi("firebase",":",!uf(K())&&kf()?!0:!1,qf()));return ci};h=bi.prototype;
h.R=function(a,b){return this.kf+this.he+a.name+(b?this.he+b:"")};h.get=function(a,b){return(a.M?this.Qa:this.Dc).get(this.R(a,b))};h.remove=function(a,b){b=this.R(a,b);a.M&&!this.Ub&&(this.$[b]=null);return(a.M?this.Qa:this.Dc).remove(b)};h.set=function(a,b,c){var d=this.R(a,c),e=this,f=a.M?this.Qa:this.Dc;return f.set(d,b).then(function(){return f.get(d)}).then(function(b){a.M&&!this.Ub&&(e.$[d]=b)})};
h.addListener=function(a,b,c){a=this.R(a,b);this.Ub||(this.$[a]=l.localStorage.getItem(a));Va(this.T)&&this.vd();this.T[a]||(this.T[a]=[]);this.T[a].push(c)};h.removeListener=function(a,b,c){a=this.R(a,b);this.T[a]&&(La(this.T[a],function(a){return a==c}),0==this.T[a].length&&delete this.T[a]);Va(this.T)&&this.Bc()};h.vd=function(){this.Qa.ab(this.wd);this.Ub||Ve()||ei(this)};
var ei=function(a){fi(a);a.dd=setInterval(function(){for(var b in a.T){var c=l.localStorage.getItem(b),d=a.$[b];c!=d&&(a.$[b]=c,c=new Jb({type:"storage",key:b,target:window,oldValue:d,newValue:c,rf:!0}),a.le(c))}},1E3)},fi=function(a){a.dd&&(clearInterval(a.dd),a.dd=null)};bi.prototype.Bc=function(){this.Qa.Ta(this.wd);fi(this)};
bi.prototype.le=function(a){if(a&&a.Pe){var b=a.eb.key;"undefined"!==typeof a.eb.rf?this.Qa.Ta(this.wd):fi(this);if(this.zf){var c=l.localStorage.getItem(b);a=a.eb.newValue;a!=c&&(a?l.localStorage.setItem(b,a):a||l.localStorage.removeItem(b))}this.$[b]=l.localStorage.getItem(b);this.Ed(b)}else w(a,q(this.Ed,this))};bi.prototype.Ed=function(a){this.T[a]&&w(this.T[a],function(a){a()})};var gi=function(a,b){this.u=a;this.i=b||di()},hi={name:"authEvent",M:!0},ii=function(a){return a.i.get(hi,a.u).then(function(a){return Qf(a)})};gi.prototype.$a=function(a){this.i.addListener(hi,this.u,a)};gi.prototype.Tb=function(a){this.i.removeListener(hi,this.u,a)};var ji=function(a){this.i=a||di()},ki={name:"sessionId",M:!1};ji.prototype.ic=function(a){return this.i.get(ki,a)};var li=function(a,b,c,d,e,f){this.v=a;this.j=b;this.D=c;this.Ea=d||null;this.me=b+":"+c;this.Af=new ji;this.Qd=new gi(this.me);this.Zc=null;this.ma=[];this.bf=e||500;this.tf=f||2E3;this.Fb=this.uc=null},mi=function(a){return new O("invalid-cordova-configuration",a)};
li.prototype.La=function(){return this.ad?this.ad:this.ad=hf().then(function(){if("function"!==typeof M("universalLinks.subscribe",l))throw mi("cordova-universal-links-plugin is not installed");if("undefined"===typeof M("BuildInfo.packageName",l))throw mi("cordova-plugin-buildinfo is not installed");if("function"!==typeof M("cordova.plugins.browsertab.openUrl",l))throw mi("cordova-plugin-browsertab is not installed");if("function"!==typeof M("cordova.InAppBrowser.open",l))throw mi("cordova-plugin-inappbrowser is not installed");
},function(){throw new O("cordova-not-ready");})};var ni=function(){for(var a=20,b=[];0<a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62*Math.random()))),a--;return b.join("")},oi=function(a){var b=new Eb;b.update(a);return Oa(b.digest())};h=li.prototype;h.Vb=function(a,b){b(new O("operation-not-supported-in-this-environment"));return B()};h.Nb=function(){return D(new O("operation-not-supported-in-this-environment"))};h.ne=function(){return!1};h.ke=function(){return!0};
h.Ud=function(){return!0};
h.Ob=function(a,b,c){if(this.uc)return D(new O("redirect-operation-pending"));var d=this,e=l.document,f=null,g=null,k=null,n=null;return this.uc=md(B().then(function(){sg(b);return pi(d)}).then(function(){return qi(d,a,b,c)}).then(function(){return(new A(function(a,b){g=function(){var b=M("cordova.plugins.browsertab.close",l);a();"function"===typeof b&&b();d.Fb&&"function"===typeof d.Fb.close&&(d.Fb.close(),d.Fb=null);return!1};d.$a(g);k=function(){f||(f=le(d.tf).then(function(){b(new O("redirect-cancelled-by-user"))}))};n=
function(){yf()&&k()};e.addEventListener("resume",k,!1);K().toLowerCase().match(/android/)||e.addEventListener("visibilitychange",n,!1)})).f(function(a){return ri(d).then(function(){throw a;})})}),function(){k&&e.removeEventListener("resume",k,!1);n&&e.removeEventListener("visibilitychange",n,!1);f&&f.cancel();g&&d.Tb(g);d.uc=null})};
var qi=function(a,b,c,d){var e=ni(),f=new P(b,d,null,e,new O("no-auth-event")),g=M("BuildInfo.packageName",l);if("string"!==typeof g)throw new O("invalid-cordova-configuration");var k=M("BuildInfo.displayName",l),n={};if(K().toLowerCase().match(/iphone|ipad|ipod/))n.ibi=g;else if(K().toLowerCase().match(/android/))n.apn=g;else return D(new O("operation-not-supported-in-this-environment"));k&&(n.appDisplayName=k);e=oi(e);n.sessionId=e;var C=xh(a.v,a.j,a.D,b,c,null,d,a.Ea,n);return a.La().then(function(){var b=
a.me;return a.Af.i.set(hi,f.C(),b)}).then(function(){var b=M("cordova.plugins.browsertab.isAvailable",l);if("function"!==typeof b)throw new O("invalid-cordova-configuration");var c=null;b(function(b){if(b){c=M("cordova.plugins.browsertab.openUrl",l);if("function"!==typeof c)throw new O("invalid-cordova-configuration");c(C)}else{c=M("cordova.InAppBrowser.open",l);if("function"!==typeof c)throw new O("invalid-cordova-configuration");b=c;var d;d=K();d=!(!d.match(/(iPad|iPhone|iPod).*OS 7_\d/i)&&!d.match(/(iPad|iPhone|iPod).*OS 8_\d/i));
a.Fb=b(C,d?"_blank":"_system","location=yes")}})})},si=function(a,b){for(var c=0;c<a.ma.length;c++)try{a.ma[c](b)}catch(d){}},pi=function(a){a.Zc||(a.Zc=a.La().then(function(){return new A(function(b){var c=function(d){b(d);a.Tb(c);return!1};a.$a(c);ti(a)})}));return a.Zc},ri=function(a){var b=null;return ii(a.Qd).then(function(c){b=c;c=a.Qd;return c.i.remove(hi,c.u)}).then(function(){return b})},ti=function(a){var b=M("universalLinks.subscribe",l);if("function"!==typeof b)throw new O("invalid-cordova-configuration");
var c=new P("unknown",null,null,null,new O("no-auth-event")),d=!1,e=le(a.bf).then(function(){return ri(a).then(function(){d||si(a,c)})}),f=function(b){d=!0;e&&e.cancel();ri(a).then(function(d){var e=c;if(d&&b&&b.url){var e=null,f;f=b.url;var g=Pe(f),k=Oe(g,"link"),n=Oe(Pe(k),"link"),g=Oe(g,"deep_link_id");f=Oe(Pe(g),"link")||g||n||k||f;-1!=f.indexOf("/__/auth/callback")&&(e=Pe(f),e=tf(Oe(e,"firebaseError")||null),e=(e="object"===typeof e?Pf(e):null)?new P(d.da,d.J,null,null,e):new P(d.da,d.J,f,d.ic()));
e=e||c}si(a,e)})},g=l.handleOpenURL;l.handleOpenURL=function(a){0==a.indexOf(M("BuildInfo.packageName",l)+"://")&&f({url:a});if("function"===typeof g)try{g(a)}catch(n){console.error(n)}};b(null,f)};li.prototype.$a=function(a){this.ma.push(a);pi(this).f(function(b){"auth/invalid-cordova-configuration"===b.code&&(b=new P("unknown",null,null,null,new O("no-auth-event")),a(b))})};li.prototype.Tb=function(a){La(this.ma,function(b){return b==a})};var ui=function(a){this.u=a;this.i=di()},vi={name:"pendingRedirect",M:!1},wi=function(a){return a.i.set(vi,"pending",a.u)},xi=function(a){return a.i.remove(vi,a.u)},yi=function(a){return a.i.get(vi,a.u).then(function(a){return"pending"==a})};var T=function(a,b,c){this.v=a;this.j=b;this.D=c;this.Xb=[];this.ib=!1;this.Mc=q(this.Wc,this);this.Ra=new zi(this);this.ld=new Ai(this);this.Kb=new ui(this.j+":"+this.D);this.Aa={};this.Aa.unknown=this.Ra;this.Aa.signInViaRedirect=this.Ra;this.Aa.linkViaRedirect=this.Ra;this.Aa.reauthViaRedirect=this.Ra;this.Aa.signInViaPopup=this.ld;this.Aa.linkViaPopup=this.ld;this.Aa.reauthViaPopup=this.ld;this.K=Bi(this.v,this.j,this.D)},Bi=function(a,b,c){var d=firebase.SDK_VERSION||null;return gf()?new li(a,
b,c,d):new th(a,b,c,d)};T.prototype.reset=function(){this.ib=!1;this.K.Tb(this.Mc);this.K=Bi(this.v,this.j,this.D)};T.prototype.Gb=function(){var a=this;this.ib||(this.ib=!0,this.K.$a(this.Mc));var b=this.K;return this.K.La().f(function(c){a.K==b&&a.reset();throw c;})};var Ei=function(a){a.K.ke()&&a.Gb().f(function(b){var c=new P("unknown",null,null,null,new O("operation-not-supported-in-this-environment"));Ci(b)&&a.Wc(c)});a.K.Ud()||Di(a.Ra)};
T.prototype.subscribe=function(a){Ia(this.Xb,a)||this.Xb.push(a);if(!this.ib){var b=this;yi(this.Kb).then(function(a){a?xi(b.Kb).then(function(){b.Gb().f(function(a){var c=new P("unknown",null,null,null,new O("operation-not-supported-in-this-environment"));Ci(a)&&b.Wc(c)})}):Ei(b)}).f(function(){Ei(b)})}};T.prototype.unsubscribe=function(a){La(this.Xb,function(b){return b==a})};
T.prototype.Wc=function(a){if(!a)throw new O("invalid-auth-event");for(var b=!1,c=0;c<this.Xb.length;c++){var d=this.Xb[c];if(d.Fd(a.da,a.J)){(b=this.Aa[a.da])&&b.ce(a,d);b=!0;break}}Di(this.Ra);return b};var Fi=new xf(2E3,1E4),Gi=new xf(3E4,6E4);T.prototype.getRedirectResult=function(){return this.Ra.getRedirectResult()};T.prototype.Nb=function(a,b,c,d,e){var f=this;return this.K.Nb(a,b,c,function(){f.ib||(f.ib=!0,f.K.$a(f.Mc))},function(){f.reset()},d,e)};
var Ci=function(a){return a&&"auth/cordova-not-ready"==a.code?!0:!1};T.prototype.Ob=function(a,b,c){var d=this,e;return wi(this.Kb).then(function(){return d.K.Ob(a,b,c).f(function(a){if(Ci(a))throw new O("operation-not-supported-in-this-environment");e=a;return xi(d.Kb).then(function(){throw e;})}).then(function(){return d.K.ne()?new A(function(){}):xi(d.Kb).then(function(){return d.getRedirectResult()}).then(function(){}).f(function(){})})})};
T.prototype.Vb=function(a,b,c,d){return this.K.Vb(c,function(c){a.Va(b,null,c,d)},Fi.get())};var Hi={},Ii=function(a,b,c){var d=b+":"+c;Hi[d]||(Hi[d]=new T(a,b,c));return Hi[d]},zi=function(a){this.i=a;this.qb=null;this.Rb=[];this.Qb=[];this.ob=null;this.od=!1};zi.prototype.reset=function(){this.qb=null;this.ob&&(this.ob.cancel(),this.ob=null)};
zi.prototype.ce=function(a,b){if(!a)return D(new O("invalid-auth-event"));this.reset();this.od=!0;var c=a.da,d=a.J,e=a.getError()&&"auth/web-storage-unsupported"==a.getError().code,f=a.getError()&&"auth/operation-not-supported-in-this-environment"==a.getError().code;"unknown"!=c||e||f?a=a.P?this.md(a,b):b.zb(c,d)?this.nd(a,b):D(new O("invalid-auth-event")):(Ji(this,!1,null,null),a=B());return a};var Di=function(a){a.od||(a.od=!0,Ji(a,!1,null,null))};
zi.prototype.md=function(a){Ji(this,!0,null,a.getError());return B()};zi.prototype.nd=function(a,b){var c=this;b=b.zb(a.da,a.J);var d=a.tb,e=a.ic(),f=!!a.da.match(/Redirect$/);return b(d,e).then(function(a){Ji(c,f,a,null)}).f(function(a){Ji(c,f,null,a)})};
var Ki=function(a,b){a.qb=function(){return D(b)};if(a.Qb.length)for(var c=0;c<a.Qb.length;c++)a.Qb[c](b)},Li=function(a,b){a.qb=function(){return B(b)};if(a.Rb.length)for(var c=0;c<a.Rb.length;c++)a.Rb[c](b)},Ji=function(a,b,c,d){b?d?Ki(a,d):Li(a,c):Li(a,{user:null});a.Rb=[];a.Qb=[]};zi.prototype.getRedirectResult=function(){var a=this;return new A(function(b,c){a.qb?a.qb().then(b,c):(a.Rb.push(b),a.Qb.push(c),Mi(a))})};
var Mi=function(a){var b=new O("timeout");a.ob&&a.ob.cancel();a.ob=le(Gi.get()).then(function(){a.qb||Ji(a,!0,null,b)})},Ai=function(a){this.i=a};Ai.prototype.ce=function(a,b){if(!a)return D(new O("invalid-auth-event"));var c=a.da,d=a.J;return a.P?this.md(a,b):b.zb(c,d)?this.nd(a,b):D(new O("invalid-auth-event"))};Ai.prototype.md=function(a,b){b.Va(a.da,null,a.getError(),a.J);return B()};
Ai.prototype.nd=function(a,b){var c=a.J,d=a.da,e=b.zb(d,c),f=a.tb;a=a.ic();return e(f,a).then(function(a){b.Va(d,a,null,c)}).f(function(a){b.Va(d,null,a,c)})};var Ni=function(a){this.g=a;this.Ba=this.X=null;this.Ha=0};Ni.prototype.C=function(){return{apiKey:this.g.j,refreshToken:this.X,accessToken:this.Ba,expirationTime:this.Ha}};
var Pi=function(a,b){var c=b.idToken,d=b.refreshToken;b=Oi(b.expiresIn);a.Ba=c;a.Ha=b;a.X=d},Oi=function(a){return la()+1E3*parseInt(a,10)},Qi=function(a,b){return Eg(a.g,b).then(function(b){a.Ba=b.access_token;a.Ha=Oi(b.expires_in);a.X=b.refresh_token;return{accessToken:a.Ba,expirationTime:a.Ha,refreshToken:a.X}}).f(function(b){"auth/user-token-expired"==b.code&&(a.X=null);throw b;})};
Ni.prototype.getToken=function(a){a=!!a;return this.Ba&&!this.X?D(new O("user-token-expired")):a||!this.Ba||la()>this.Ha-3E4?this.X?Qi(this,{grant_type:"refresh_token",refresh_token:this.X}):B(null):B({accessToken:this.Ba,expirationTime:this.Ha,refreshToken:this.X})};var Ri=function(a,b,c,d,e){Ff(this,{uid:a,displayName:d||null,photoURL:e||null,email:c||null,providerId:b})},Si=function(a,b){Ib.call(this,a);for(var c in b)this[c]=b[c]};r(Si,Ib);
var U=function(a,b,c){this.ba=[];this.j=a.apiKey;this.D=a.appName;this.v=a.authDomain||null;a=firebase.SDK_VERSION?mf(firebase.SDK_VERSION):null;this.g=new S(this.j,null,a);this.ia=new Ni(this.g);Ti(this,b.idToken);Pi(this.ia,b);N(this,"refreshToken",this.ia.X);Ui(this,c||{});he.call(this);this.vc=!1;this.v&&pf()&&(this.m=Ii(this.v,this.j,this.D));this.Ac=[];this.ka=null;this.mb=Vi(this);this.vb=q(this.Xc,this)};r(U,he);U.prototype.Xc=function(){this.mb.kb&&(this.mb.stop(),this.mb.start())};
var Vi=function(a){return new Th(function(){return a.getToken(!0)},function(a){return a&&"auth/network-request-failed"==a.code?!0:!1},function(){var b=a.ia.Ha-la()-3E5;return 0<b?b:0},3E4,96E4,!1)},Wi=function(a){a.Kd||a.mb.kb||(a.mb.start(),dc(a,"tokenChanged",a.vb),Vb(a,"tokenChanged",a.vb))},Xi=function(a){dc(a,"tokenChanged",a.vb);a.mb.stop()},Ti=function(a,b){a.Yd=b;N(a,"_lat",b)},Yi=function(a,b){La(a.Ac,function(a){return a==b})},Zi=function(a){for(var b=[],c=0;c<a.Ac.length;c++)b.push(a.Ac[c](a));
return jd(b).then(function(){return a})},$i=function(a){a.m&&!a.vc&&(a.vc=!0,a.m.subscribe(a))},Ui=function(a,b){Ff(a,{uid:b.uid,displayName:b.displayName||null,photoURL:b.photoURL||null,email:b.email||null,emailVerified:b.emailVerified||!1,identifierNumber:b.identifierNumber||null,isAnonymous:b.isAnonymous||!1,providerData:[]})};N(U.prototype,"providerId","firebase");
var aj=function(){},bj=function(a){return B().then(function(){if(a.Kd)throw new O("app-deleted");})},cj=function(a){return Ea(a.providerData,function(a){return a.providerId})},ej=function(a,b){b&&(dj(a,b.providerId),a.providerData.push(b))},dj=function(a,b){La(a.providerData,function(a){return a.providerId==b})},fj=function(a,b,c){("uid"!=b||c)&&a.hasOwnProperty(b)&&N(a,b,c)};
U.prototype.copy=function(a){var b=this;b!=a&&(Ff(this,{uid:a.uid,displayName:a.displayName,photoURL:a.photoURL,email:a.email,emailVerified:a.emailVerified,identifierNumber:a.identifierNumber,isAnonymous:a.isAnonymous,providerData:[]}),w(a.providerData,function(a){ej(b,a)}),this.ia=a.ia,N(this,"refreshToken",this.ia.X))};U.prototype.reload=function(){var a=this;return this.c(bj(this).then(function(){return gj(a).then(function(){return Zi(a)}).then(aj)}))};
var gj=function(a){return a.getToken().then(function(b){var c=a.isAnonymous;return hj(a,b).then(function(){c||fj(a,"isAnonymous",!1);return b})})};U.prototype.getToken=function(a){var b=this;return this.c(bj(this).then(function(){return b.ia.getToken(a)}).then(function(a){if(!a)throw new O("internal-error");a.accessToken!=b.Yd&&(Ti(b,a.accessToken),b.Na());fj(b,"refreshToken",a.refreshToken);return a.accessToken}))};
var ij=function(a,b){b.idToken&&a.Yd!=b.idToken&&(Pi(a.ia,b),a.Na(),Ti(a,b.idToken),fj(a,"refreshToken",a.ia.X))};U.prototype.Na=function(){this.dispatchEvent(new Si("tokenChanged"))};var hj=function(a,b){return R(a.g,gh,{idToken:b}).then(q(a.qf,a))};
U.prototype.qf=function(a){a=a.users;if(!a||!a.length)throw new O("internal-error");a=a[0];Ui(this,{uid:a.localId,displayName:a.displayName,photoURL:a.photoUrl,email:a.email,emailVerified:!!a.emailVerified,identifierNumber:a.identifierNumber});for(var b=jj(a),c=0;c<b.length;c++)ej(this,b[c]);fj(this,"isAnonymous",!(this.email&&a.passwordHash)&&!(this.providerData&&this.providerData.length))};
var jj=function(a){return(a=a.providerUserInfo)&&a.length?Ea(a,function(a){return new Ri(a.rawId,a.providerId,a.email,a.displayName,a.photoUrl)}):[]},lj=function(a,b){var c=null;return a.c(b.ed(a.g,a.uid).then(function(b){ij(a,b);c=kj(a,b,"reauthenticate");a.ka=null;return a.reload()}).then(function(){return c}),!0)};U.prototype.reauthenticate=function(a){Bf("firebase.User.prototype.reauthenticate is deprecated. Please use firebase.User.prototype.reauthenticateWithCredential instead.");return this.reauthenticateWithCredential(a)};
U.prototype.reauthenticateWithCredential=function(a){return lj(this,a).then(function(){})};var mj=function(a,b){return gj(a).then(function(){if(Ia(cj(a),b))return Zi(a).then(function(){throw new O("provider-already-linked");})})},oj=function(a,b){var c=null;return a.c(mj(a,b.providerId).then(function(){return a.getToken()}).then(function(c){return b.cd(a.g,c)}).then(function(b){c=kj(a,b,"link");return nj(a,b)}).then(function(){return c}))};
U.prototype.link=function(a){Bf("firebase.User.prototype.link is deprecated. Please use firebase.User.prototype.linkWithCredential instead.");return this.linkWithCredential(a)};U.prototype.linkWithCredential=function(a){return oj(this,a).then(function(a){return a.user})};var kj=function(a,b,c){var d=rg(b);b=ai(b);return Gf({user:a,credential:d,additionalUserInfo:b,operationType:c})},nj=function(a,b){ij(a,b);return a.reload().then(function(){return a})};h=U.prototype;
h.updateEmail=function(a){var b=this;return this.c(this.getToken().then(function(c){return b.g.updateEmail(c,a)}).then(function(a){ij(b,a);return b.reload()}))};h.updatePassword=function(a){var b=this;return this.c(this.getToken().then(function(c){return b.g.updatePassword(c,a)}).then(function(a){ij(b,a);return b.reload()}))};
h.updateProfile=function(a){if(void 0===a.displayName&&void 0===a.photoURL)return bj(this);var b=this;return this.c(this.getToken().then(function(c){return b.g.updateProfile(c,{displayName:a.displayName,photoUrl:a.photoURL})}).then(function(a){ij(b,a);fj(b,"displayName",a.displayName||null);fj(b,"photoURL",a.photoUrl||null);return Zi(b)}).then(aj))};
h.unlink=function(a){var b=this;return this.c(gj(this).then(function(c){return Ia(cj(b),a)?Vg(b.g,c,[a]).then(function(a){var c={};w(a.providerUserInfo||[],function(a){c[a.providerId]=!0});w(cj(b),function(a){c[a]||dj(b,a)});return Zi(b)}):Zi(b).then(function(){throw new O("no-such-provider");})}))};
h["delete"]=function(){var a=this;return this.c(this.getToken().then(function(b){return R(a.g,fh,{idToken:b})}).then(function(){a.dispatchEvent(new Si("userDeleted"))})).then(function(){for(var b=0;b<a.ba.length;b++)a.ba[b].cancel("app-deleted");a.ba=[];a.Kd=!0;Xi(a);N(a,"refreshToken",null);a.m&&a.m.unsubscribe(a)})};
h.Fd=function(a,b){return"linkViaPopup"==a&&(this.ca||null)==b&&this.aa||"reauthViaPopup"==a&&(this.ca||null)==b&&this.aa||"linkViaRedirect"==a&&(this.za||null)==b||"reauthViaRedirect"==a&&(this.za||null)==b?!0:!1};h.Va=function(a,b,c,d){"linkViaPopup"!=a&&"reauthViaPopup"!=a||d!=(this.ca||null)||(c&&this.Pa?this.Pa(c):b&&!c&&this.aa&&this.aa(b),this.F&&(this.F.cancel(),this.F=null),delete this.aa,delete this.Pa)};
h.zb=function(a,b){return"linkViaPopup"==a&&b==(this.ca||null)?q(this.Nd,this):"reauthViaPopup"==a&&b==(this.ca||null)?q(this.Od,this):"linkViaRedirect"==a&&(this.za||null)==b?q(this.Nd,this):"reauthViaRedirect"==a&&(this.za||null)==b?q(this.Od,this):null};h.hc=function(){return of(this.uid+":::")};var qj=function(a,b){return pj(a,"linkViaPopup",b,function(){return mj(a,b.providerId).then(function(){return Zi(a)})},!1)};
U.prototype.linkWithPopup=function(a){return qj(this,a).then(function(a){return a?Gf({user:a.user,credential:a.credential,operationType:a.operationType}):a})};var rj=function(a,b){return pj(a,"reauthViaPopup",b,function(){return B()},!0)};U.prototype.reauthenticateWithPopup=function(a){return rj(this,a).then(function(a){return a?Gf({user:a.user,credential:a.credential,operationType:a.operationType}):a})};
var pj=function(a,b,c,d,e){if(!pf())return D(new O("operation-not-supported-in-this-environment"));if(a.ka&&!e)return D(a.ka);var f=Nf(c.providerId),g=a.hc(),k=null;(!qf()||kf())&&a.v&&c.isOAuthProvider&&(k=xh(a.v,a.j,a.D,b,c,null,g,firebase.SDK_VERSION||null));var n=cf(k,f&&f.Mb,f&&f.Lb);d=d().then(function(){sj(a);if(!e)return a.getToken().then(function(){})}).then(function(){return a.m.Nb(n,b,c,g,!!k)}).then(function(){return new A(function(c,d){a.Va(b,null,new O("cancelled-popup-request"),a.ca||
null);a.aa=c;a.Pa=d;a.ca=g;a.F=a.m.Vb(a,b,n,g)})}).then(function(a){n&&bf(n);return a}).f(function(a){n&&bf(n);throw a;});return a.c(d,e)};U.prototype.linkWithRedirect=function(a){var b=this;return tj(this,"linkViaRedirect",a,function(){return mj(b,a.providerId)},!1)};U.prototype.reauthenticateWithRedirect=function(a){return tj(this,"reauthViaRedirect",a,function(){return B()},!0)};
var tj=function(a,b,c,d,e){if(!pf())return D(new O("operation-not-supported-in-this-environment"));if(a.ka&&!e)return D(a.ka);var f=null,g=a.hc();d=d().then(function(){sj(a);if(!e)return a.getToken().then(function(){})}).then(function(){a.za=g;return Zi(a)}).then(function(b){a.Sa&&(b=a.Sa,b=b.i.set(uj,a.C(),b.u));return b}).then(function(){return a.m.Ob(b,c,g)}).f(function(b){f=b;if(a.Sa)return vj(a.Sa);throw f;}).then(function(){if(f)throw f;});return a.c(d,e)},sj=function(a){if(!a.m||!a.vc){if(a.m&&
!a.vc)throw new O("internal-error");throw new O("auth-domain-config-required");}};U.prototype.Nd=function(a,b){var c=this;this.F&&(this.F.cancel(),this.F=null);var d=null,e=this.getToken().then(function(d){return Xf(c.g,{requestUri:a,sessionId:b,idToken:d})}).then(function(a){d=kj(c,a,"link");return nj(c,a)}).then(function(){return d});return this.c(e)};
U.prototype.Od=function(a,b){var c=this;this.F&&(this.F.cancel(),this.F=null);var d=null,e=B().then(function(){return Tf(Yf(c.g,{requestUri:a,sessionId:b}),c.uid)}).then(function(a){d=kj(c,a,"reauthenticate");ij(c,a);c.ka=null;return c.reload()}).then(function(){return d});return this.c(e,!0)};U.prototype.sendEmailVerification=function(){var a=this;return this.c(this.getToken().then(function(b){return a.g.sendEmailVerification(b)}).then(function(b){if(a.email!=b)return a.reload()}).then(function(){}))};
U.prototype.c=function(a,b){var c=this,d=wj(this,a,b);this.ba.push(d);md(d,function(){Ka(c.ba,d)});return d};var wj=function(a,b,c){return a.ka&&!c?(b.cancel(),D(a.ka)):b.f(function(b){!b||"auth/user-disabled"!=b.code&&"auth/user-token-expired"!=b.code||(a.ka||a.dispatchEvent(new Si("userInvalidated")),a.ka=b);throw b;})};U.prototype.toJSON=function(){return this.C()};
U.prototype.C=function(){var a={uid:this.uid,displayName:this.displayName,photoURL:this.photoURL,email:this.email,emailVerified:this.emailVerified,identifierNumber:this.identifierNumber,isAnonymous:this.isAnonymous,providerData:[],apiKey:this.j,appName:this.D,authDomain:this.v,stsTokenManager:this.ia.C(),redirectEventId:this.za||null};w(this.providerData,function(b){a.providerData.push(Hf(b))});return a};
var xj=function(a){if(!a.apiKey)return null;var b={apiKey:a.apiKey,authDomain:a.authDomain,appName:a.appName},c={};if(a.stsTokenManager&&a.stsTokenManager.accessToken&&a.stsTokenManager.expirationTime)c.idToken=a.stsTokenManager.accessToken,c.refreshToken=a.stsTokenManager.refreshToken||null,c.expiresIn=(a.stsTokenManager.expirationTime-la())/1E3;else return null;var d=new U(b,c,a);a.providerData&&w(a.providerData,function(a){a&&ej(d,Gf(a))});a.redirectEventId&&(d.za=a.redirectEventId);return d},
yj=function(a,b,c){var d=new U(a,b);c&&(d.Sa=c);return d.reload().then(function(){return d})};var zj=function(a){this.u=a;this.i=di()},uj={name:"redirectUser",M:!1},vj=function(a){return a.i.remove(uj,a.u)},Aj=function(a,b){return a.i.get(uj,a.u).then(function(a){a&&b&&(a.authDomain=b);return xj(a||{})})};var Bj=function(a){this.u=a;this.i=di()},Cj={name:"authUser",M:!0},Dj=function(a,b){return a.i.set(Cj,b.C(),a.u)},Ej=function(a){return a.i.remove(Cj,a.u)},Fj=function(a,b){return a.i.get(Cj,a.u).then(function(a){a&&b&&(a.authDomain=b);return xj(a||{})})};var W=function(a){this.Fa=!1;N(this,"app",a);if(V(this).options&&V(this).options.apiKey)a=firebase.SDK_VERSION?mf(firebase.SDK_VERSION):null,this.g=new S(V(this).options&&V(this).options.apiKey,null,a);else throw new O("invalid-api-key");this.ba=[];this.Ca=[];this.ub=[];this.mf=firebase.INTERNAL.createSubscribe(q(this.Ze,this));this.Ic=void 0;firebase.INTERNAL.createSubscribe(q(this.af,this));Gj(this,null);this.ta=new Bj(V(this).options.apiKey+":"+V(this).name);this.pb=new zj(V(this).options.apiKey+
":"+V(this).name);this.cc=this.c(Hj(this));this.qa=this.c(Ij(this));this.bd=!1;this.Vc=q(this.Gf,this);this.qe=q(this.gb,this);this.vb=q(this.Xc,this);this.oe=q(this.Ue,this);this.pe=q(this.Ve,this);Jj(this);this.INTERNAL={};this.INTERNAL["delete"]=q(this["delete"],this);this.Ia=0};W.prototype.toJSON=function(){return{apiKey:V(this).options.apiKey,authDomain:V(this).options.authDomain,appName:V(this).name,currentUser:X(this)&&X(this).C()}};
var Kj=function(a){return a.Ie||D(new O("auth-domain-config-required"))},Jj=function(a){var b=V(a).options.authDomain,c=V(a).options.apiKey;b&&pf()&&(a.Ie=a.cc.then(function(){if(!a.Fa)return a.m=Ii(b,c,V(a).name),a.m.subscribe(a),X(a)&&$i(X(a)),a.Sb&&($i(a.Sb),a.Sb=null),a.m}))};h=W.prototype;h.Fd=function(a,b){switch(a){case "unknown":case "signInViaRedirect":return!0;case "signInViaPopup":return this.ca==b&&!!this.aa;default:return!1}};
h.Va=function(a,b,c,d){"signInViaPopup"==a&&this.ca==d&&(c&&this.Pa?this.Pa(c):b&&!c&&this.aa&&this.aa(b),this.F&&(this.F.cancel(),this.F=null),delete this.aa,delete this.Pa)};h.zb=function(a,b){return"signInViaRedirect"==a||"signInViaPopup"==a&&this.ca==b&&this.aa?q(this.Ke,this):null};
h.Ke=function(a,b){var c=this;a={requestUri:a,sessionId:b};this.F&&(this.F.cancel(),this.F=null);var d=null,e=null,f=Vf(c.g,a).then(function(a){d=rg(a);e=ai(a);return a});a=c.cc.then(function(){return f}).then(function(a){return Lj(c,a)}).then(function(){return Gf({user:X(c),credential:d,additionalUserInfo:e,operationType:"signIn"})});return this.c(a)};h.hc=function(){return of()};
var Mj=function(a,b){if(!pf())return D(new O("operation-not-supported-in-this-environment"));var c=Nf(b.providerId),d=a.hc(),e=null;(!qf()||kf())&&V(a).options.authDomain&&b.isOAuthProvider&&(e=xh(V(a).options.authDomain,V(a).options.apiKey,V(a).name,"signInViaPopup",b,null,d,firebase.SDK_VERSION||null));var f=cf(e,c&&c.Mb,c&&c.Lb),c=Kj(a).then(function(a){return a.Nb(f,"signInViaPopup",b,d,!!e)}).then(function(){return new A(function(b,c){a.Va("signInViaPopup",null,new O("cancelled-popup-request"),
a.ca);a.aa=b;a.Pa=c;a.ca=d;a.F=a.m.Vb(a,"signInViaPopup",f,d)})}).then(function(a){f&&bf(f);return a}).f(function(a){f&&bf(f);throw a;});return a.c(c)};W.prototype.signInWithPopup=function(a){return Mj(this,a).then(function(a){return a?Gf({user:a.user,credential:a.credential,operationType:a.operationType}):a})};W.prototype.getRedirectResult=function(){return Nj(this).then(function(a){return a?Gf({user:a.user,credential:a.credential,operationType:a.operationType}):a})};
W.prototype.signInWithRedirect=function(a){if(!pf())return D(new O("operation-not-supported-in-this-environment"));var b=this,c=Kj(this).then(function(){return b.m.Ob("signInViaRedirect",a)});return this.c(c)};
var Nj=function(a){if(!pf())return D(new O("operation-not-supported-in-this-environment"));var b=Kj(a).then(function(){return a.m.getRedirectResult()});return a.c(b)},Lj=function(a,b){var c={};c.apiKey=V(a).options.apiKey;c.authDomain=V(a).options.authDomain;c.appName=V(a).name;return a.cc.then(function(){return yj(c,b,a.pb)}).then(function(b){if(X(a)&&b.uid==X(a).uid)return X(a).copy(b),a.gb(b);Gj(a,b);$i(b);return a.gb(b)}).then(function(){a.Na()})},Gj=function(a,b){X(a)&&(Yi(X(a),a.qe),dc(X(a),
"tokenChanged",a.vb),dc(X(a),"userDeleted",a.oe),dc(X(a),"userInvalidated",a.pe),Xi(X(a)));b&&(b.Ac.push(a.qe),Vb(b,"tokenChanged",a.vb),Vb(b,"userDeleted",a.oe),Vb(b,"userInvalidated",a.pe),0<a.Ia&&Wi(b));N(a,"currentUser",b)};W.prototype.signOut=function(){var a=this,b=this.qa.then(function(){if(!X(a))return B();Gj(a,null);return Ej(a.ta).then(function(){a.Na()})});return this.c(b)};
var Oj=function(a){var b=Aj(a.pb,V(a).options.authDomain).then(function(b){if(a.Sb=b)b.Sa=a.pb;return vj(a.pb)});return a.c(b)},Hj=function(a){var b=V(a).options.authDomain,c=Oj(a).then(function(){return Fj(a.ta,b)}).then(function(b){return b?(b.Sa=a.pb,a.Sb&&(a.Sb.za||null)==(b.za||null)?b:b.reload().then(function(){return Dj(a.ta,b).then(function(){return b})}).f(function(c){return"auth/network-request-failed"==c.code?b:Ej(a.ta)})):null}).then(function(b){Gj(a,b||null)});return a.c(c)},Ij=function(a){return a.cc.then(function(){return a.getRedirectResult()}).f(function(){}).then(function(){if(!a.Fa)return a.Vc()}).f(function(){}).then(function(){if(!a.Fa){a.bd=
!0;var b=a.ta;b.i.addListener(Cj,b.u,a.Vc)}})};h=W.prototype;h.Gf=function(){var a=this;return Fj(this.ta,V(this).options.authDomain).then(function(b){if(!a.Fa){var c;if(c=X(a)&&b){c=X(a).uid;var d=b.uid;c=void 0===c||null===c||""===c||void 0===d||null===d||""===d?!1:c==d}if(c)return X(a).copy(b),X(a).getToken();if(X(a)||b)Gj(a,b),b&&($i(b),b.Sa=a.pb),a.m&&a.m.subscribe(a),a.Na()}})};h.gb=function(a){return Dj(this.ta,a)};h.Xc=function(){this.Na();this.gb(X(this))};h.Ue=function(){this.signOut()};
h.Ve=function(){this.signOut()};var Pj=function(a,b){var c=null,d=null;return a.c(b.then(function(b){c=rg(b);d=ai(b);return Lj(a,b)}).then(function(){return Gf({user:X(a),credential:c,additionalUserInfo:d,operationType:"signIn"})}))};h=W.prototype;h.Ze=function(a){var b=this;this.addAuthTokenListener(function(){a.next(X(b))})};h.af=function(a){var b=this;Qj(this,function(){a.next(X(b))})};
h.onAuthStateChanged=function(a,b,c){var d=this;this.bd&&firebase.Promise.resolve().then(function(){p(a)?a(X(d)):p(a.next)&&a.next(X(d))});return this.mf(a,b,c)};h.getToken=function(a){var b=this,c=this.qa.then(function(){return X(b)?X(b).getToken(a).then(function(a){return{accessToken:a}}):null});return this.c(c)};h.signInWithCustomToken=function(a){var b=this;return this.qa.then(function(){return Pj(b,R(b.g,hh,{token:a}))}).then(function(a){a=a.user;fj(a,"isAnonymous",!1);return b.gb(a)}).then(function(){return X(b)})};
h.signInWithEmailAndPassword=function(a,b){var c=this;return this.qa.then(function(){return Pj(c,R(c.g,ig,{email:a,password:b}))}).then(function(a){return a.user})};h.createUserWithEmailAndPassword=function(a,b){var c=this;return this.qa.then(function(){return Pj(c,R(c.g,eh,{email:a,password:b}))}).then(function(a){return a.user})};h.signInWithCredential=function(a){return Rj(this,a).then(function(a){return a.user})};var Rj=function(a,b){return a.qa.then(function(){return Pj(a,b.Ab(a.g))})};
W.prototype.signInAnonymously=function(){var a=X(this),b=this;return a&&a.isAnonymous?B(a):this.qa.then(function(){return Pj(b,b.g.signInAnonymously())}).then(function(a){a=a.user;fj(a,"isAnonymous",!0);return b.gb(a)}).then(function(){return X(b)})};var V=function(a){return a.app},X=function(a){return a.currentUser};W.prototype.getUid=function(){return X(this)&&X(this).uid||null};var Sj=function(a){return X(a)&&X(a)._lat||null};h=W.prototype;
h.Na=function(){if(this.bd){for(var a=0;a<this.Ca.length;a++)if(this.Ca[a])this.Ca[a](Sj(this));if(this.Ic!==this.getUid()&&this.ub.length)for(this.Ic=this.getUid(),a=0;a<this.ub.length;a++)if(this.ub[a])this.ub[a](Sj(this))}};h.Ae=function(a){this.addAuthTokenListener(a);this.Ia++;0<this.Ia&&X(this)&&Wi(X(this))};h.uf=function(a){var b=this;w(this.Ca,function(c){c==a&&b.Ia--});0>this.Ia&&(this.Ia=0);0==this.Ia&&X(this)&&Xi(X(this));this.removeAuthTokenListener(a)};
h.addAuthTokenListener=function(a){var b=this;this.Ca.push(a);this.c(this.qa.then(function(){b.Fa||Ia(b.Ca,a)&&a(Sj(b))}))};h.removeAuthTokenListener=function(a){La(this.Ca,function(b){return b==a})};var Qj=function(a,b){a.ub.push(b);a.c(a.qa.then(function(){!a.Fa&&Ia(a.ub,b)&&a.Ic!==a.getUid()&&(a.Ic=a.getUid(),b(Sj(a)))}))};h=W.prototype;
h["delete"]=function(){this.Fa=!0;for(var a=0;a<this.ba.length;a++)this.ba[a].cancel("app-deleted");this.ba=[];this.ta&&(a=this.ta,a.i.removeListener(Cj,a.u,this.Vc));this.m&&this.m.unsubscribe(this);return firebase.Promise.resolve()};h.c=function(a){var b=this;this.ba.push(a);md(a,function(){Ka(b.ba,a)});return a};h.fetchProvidersForEmail=function(a){return this.c(Jg(this.g,a))};h.verifyPasswordResetCode=function(a){return this.checkActionCode(a).then(function(a){return a.data.email})};
h.confirmPasswordReset=function(a,b){return this.c(this.g.confirmPasswordReset(a,b).then(function(){}))};h.checkActionCode=function(a){return this.c(this.g.checkActionCode(a).then(function(a){return new Sh(a)}))};h.applyActionCode=function(a){return this.c(this.g.applyActionCode(a).then(function(){}))};h.sendPasswordResetEmail=function(a){return this.c(this.g.sendPasswordResetEmail(a).then(function(){}))};var Tj="First Second Third Fourth Fifth Sixth Seventh Eighth Ninth".split(" "),Y=function(a,b){return{name:a||"",ja:"a valid string",optional:!!b,la:m}},Z=function(a){return{name:a||"",ja:"a valid object",optional:!1,la:ha}},Uj=function(a,b){return{name:a||"",ja:"a function",optional:!!b,la:p}},Vj=function(){return{name:"",ja:"null",optional:!1,la:da}},Wj=function(){return{name:"credential",ja:"a valid credential",optional:!1,la:function(a){return a?!!a.Ab:!1}}},Xj=function(){return{name:"authProvider",
ja:"a valid Auth provider",optional:!1,la:function(a){return!!(a&&a.providerId&&a.hasOwnProperty&&a.hasOwnProperty("isOAuthProvider"))}}},Yj=function(a,b,c,d){return{name:c||"",ja:a.ja+" or "+b.ja,optional:!!d,la:function(c){return a.la(c)||b.la(c)}}};var ak=function(a,b){for(var c in b){var d=b[c].name;a[d]=Zj(d,a[c],b[c].a)}},bk=function(a,b,c,d){a[b]=Zj(b,c,d)},Zj=function(a,b,c){if(!c)return b;var d=ck(a);a=function(){var a=Array.prototype.slice.call(arguments),e;a:{e=Array.prototype.slice.call(a);var k;k=0;for(var n=!1,C=0;C<c.length;C++)if(c[C].optional)n=!0;else{if(n)throw new O("internal-error","Argument validator encountered a required argument after an optional argument.");k++}n=c.length;if(e.length<k||n<e.length)e="Expected "+(k==n?
1==k?"1 argument":k+" arguments":k+"-"+n+" arguments")+" but got "+e.length+".";else{for(k=0;k<e.length;k++)if(n=c[k].optional&&void 0===e[k],!c[k].la(e[k])&&!n){e=c[k];if(0>k||k>=Tj.length)throw new O("internal-error","Argument validator received an unsupported number of arguments.");e=Tj[k]+" argument "+(e.name?'"'+e.name+'" ':"")+"must be "+e.ja+".";break a}e=null}}if(e)throw new O("argument-error",d+" failed: "+e);return b.apply(this,a)};for(var e in b)a[e]=b[e];for(e in b.prototype)a.prototype[e]=
b.prototype[e];return a},ck=function(a){a=a.split(".");return a[a.length-1]};ak(W.prototype,{applyActionCode:{name:"applyActionCode",a:[Y("code")]},checkActionCode:{name:"checkActionCode",a:[Y("code")]},confirmPasswordReset:{name:"confirmPasswordReset",a:[Y("code"),Y("newPassword")]},createUserWithEmailAndPassword:{name:"createUserWithEmailAndPassword",a:[Y("email"),Y("password")]},fetchProvidersForEmail:{name:"fetchProvidersForEmail",a:[Y("email")]},getRedirectResult:{name:"getRedirectResult",a:[]},onAuthStateChanged:{name:"onAuthStateChanged",a:[Yj(Z(),Uj(),"nextOrObserver"),
Uj("opt_error",!0),Uj("opt_completed",!0)]},sendPasswordResetEmail:{name:"sendPasswordResetEmail",a:[Y("email")]},signInAnonymously:{name:"signInAnonymously",a:[]},signInWithCredential:{name:"signInWithCredential",a:[Wj()]},signInWithCustomToken:{name:"signInWithCustomToken",a:[Y("token")]},signInWithEmailAndPassword:{name:"signInWithEmailAndPassword",a:[Y("email"),Y("password")]},signInWithPopup:{name:"signInWithPopup",a:[Xj()]},signInWithRedirect:{name:"signInWithRedirect",a:[Xj()]},signOut:{name:"signOut",
a:[]},toJSON:{name:"toJSON",a:[Y(null,!0)]},verifyPasswordResetCode:{name:"verifyPasswordResetCode",a:[Y("code")]}});
ak(U.prototype,{"delete":{name:"delete",a:[]},getToken:{name:"getToken",a:[{name:"opt_forceRefresh",ja:"a boolean",optional:!0,la:function(a){return"boolean"==typeof a}}]},link:{name:"link",a:[Wj()]},linkWithCredential:{name:"linkWithCredential",a:[Wj()]},linkWithPopup:{name:"linkWithPopup",a:[Xj()]},linkWithRedirect:{name:"linkWithRedirect",a:[Xj()]},reauthenticate:{name:"reauthenticate",a:[Wj()]},reauthenticateWithCredential:{name:"reauthenticateWithCredential",a:[Wj()]},reauthenticateWithPopup:{name:"reauthenticateWithPopup",
a:[Xj()]},reauthenticateWithRedirect:{name:"reauthenticateWithRedirect",a:[Xj()]},reload:{name:"reload",a:[]},sendEmailVerification:{name:"sendEmailVerification",a:[]},toJSON:{name:"toJSON",a:[Y(null,!0)]},unlink:{name:"unlink",a:[Y("provider")]},updateEmail:{name:"updateEmail",a:[Y("email")]},updatePassword:{name:"updatePassword",a:[Y("password")]},updateProfile:{name:"updateProfile",a:[Z("profile")]}});ak(A.prototype,{f:{name:"catch"},then:{name:"then"}});
bk(kg,"credential",function(a,b){return new hg(a,b)},[Y("email"),Y("password")]);ak($f.prototype,{addScope:{name:"addScope",a:[Y("scope")]},setCustomParameters:{name:"setCustomParameters",a:[Z("customOAuthParameters")]}});bk($f,"credential",ag,[Yj(Y(),Z(),"token")]);ak(bg.prototype,{addScope:{name:"addScope",a:[Y("scope")]},setCustomParameters:{name:"setCustomParameters",a:[Z("customOAuthParameters")]}});bk(bg,"credential",cg,[Yj(Y(),Z(),"token")]);
ak(dg.prototype,{addScope:{name:"addScope",a:[Y("scope")]},setCustomParameters:{name:"setCustomParameters",a:[Z("customOAuthParameters")]}});bk(dg,"credential",eg,[Yj(Y(),Yj(Z(),Vj()),"idToken"),Yj(Y(),Vj(),"accessToken",!0)]);ak(fg.prototype,{setCustomParameters:{name:"setCustomParameters",a:[Z("customOAuthParameters")]}});bk(fg,"credential",gg,[Yj(Y(),Z(),"token"),Y("secret",!0)]);ak(O.prototype,{toJSON:{name:"toJSON",a:[Y(null,!0)]}});ak(tg.prototype,{toJSON:{name:"toJSON",a:[Y(null,!0)]}});
ak(Rf.prototype,{toJSON:{name:"toJSON",a:[Y(null,!0)]}});
(function(){if("undefined"!==typeof firebase&&firebase.INTERNAL&&firebase.INTERNAL.registerService){var a={Auth:W,Error:O};bk(a,"EmailAuthProvider",kg,[]);bk(a,"FacebookAuthProvider",$f,[]);bk(a,"GithubAuthProvider",bg,[]);bk(a,"GoogleAuthProvider",dg,[]);bk(a,"TwitterAuthProvider",fg,[]);firebase.INTERNAL.registerService("auth",function(a,c){a=new W(a);c({INTERNAL:{getUid:q(a.getUid,a),getToken:q(a.getToken,a),addAuthTokenListener:q(a.Ae,a),removeAuthTokenListener:q(a.uf,a)}});return a},a,function(a,
c){if("create"===a)try{c.auth()}catch(d){}});firebase.INTERNAL.extendNamespace({User:U})}else throw Error("Cannot find the firebase namespace; be sure to include firebase-app.js before this library.");})();}).call(this);
}).call(typeof global !== undefined ? global : typeof self !== undefined ? self : typeof window !== undefined ? window : {});
module.exports = firebase.auth;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*! @license Firebase v3.9.0
Build: rev-cc77c9e
Terms: https://firebase.google.com/terms/

---

typedarray.js
Copyright (c) 2010, Linden Research, Inc.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE. */

var firebase = __webpack_require__(110);
(function(){
(function() {var g,aa=this;function n(a){return void 0!==a}function ba(){}function ca(a){a.Vb=function(){return a.Ye?a.Ye:a.Ye=new a}}
function da(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";
else if("function"==b&&"undefined"==typeof a.call)return"object";return b}function ea(a){return"array"==da(a)}function fa(a){var b=da(a);return"array"==b||"object"==b&&"number"==typeof a.length}function p(a){return"string"==typeof a}function ga(a){return"number"==typeof a}function ha(a){return"function"==da(a)}function ia(a){var b=typeof a;return"object"==b&&null!=a||"function"==b}function ja(a,b,c){return a.call.apply(a.bind,arguments)}
function ka(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}}function q(a,b,c){q=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?ja:ka;return q.apply(null,arguments)}
function la(a,b){function c(){}c.prototype=b.prototype;a.wg=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.sg=function(a,c,f){for(var h=Array(arguments.length-2),k=2;k<arguments.length;k++)h[k-2]=arguments[k];return b.prototype[c].apply(a,h)}};function ma(a){a=String(a);if(/^\s*$/.test(a)?0:/^[\],:{}\s\u2028\u2029]*$/.test(a.replace(/\\["\\\/bfnrtu]/g,"@").replace(/"[^"\\\n\r\u2028\u2029\x00-\x08\x0a-\x1f]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,"]").replace(/(?:^|:|,)(?:[\s\u2028\u2029]*\[)+/g,"")))try{return eval("("+a+")")}catch(b){}throw Error("Invalid JSON string: "+a);}function na(){this.Fd=void 0}
function oa(a,b,c){switch(typeof b){case "string":pa(b,c);break;case "number":c.push(isFinite(b)&&!isNaN(b)?b:"null");break;case "boolean":c.push(b);break;case "undefined":c.push("null");break;case "object":if(null==b){c.push("null");break}if(ea(b)){var d=b.length;c.push("[");for(var e="",f=0;f<d;f++)c.push(e),e=b[f],oa(a,a.Fd?a.Fd.call(b,String(f),e):e,c),e=",";c.push("]");break}c.push("{");d="";for(f in b)Object.prototype.hasOwnProperty.call(b,f)&&(e=b[f],"function"!=typeof e&&(c.push(d),pa(f,c),
c.push(":"),oa(a,a.Fd?a.Fd.call(b,f,e):e,c),d=","));c.push("}");break;case "function":break;default:throw Error("Unknown type: "+typeof b);}}var qa={'"':'\\"',"\\":"\\\\","/":"\\/","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\u000b"},ra=/\uffff/.test("\uffff")?/[\\\"\x00-\x1f\x7f-\uffff]/g:/[\\\"\x00-\x1f\x7f-\xff]/g;
function pa(a,b){b.push('"',a.replace(ra,function(a){if(a in qa)return qa[a];var b=a.charCodeAt(0),e="\\u";16>b?e+="000":256>b?e+="00":4096>b&&(e+="0");return qa[a]=e+b.toString(16)}),'"')};function sa(){this.Wa=-1};function ta(){this.Wa=-1;this.Wa=64;this.M=[];this.Wd=[];this.Af=[];this.zd=[];this.zd[0]=128;for(var a=1;a<this.Wa;++a)this.zd[a]=0;this.Pd=this.$b=0;this.reset()}la(ta,sa);ta.prototype.reset=function(){this.M[0]=1732584193;this.M[1]=4023233417;this.M[2]=2562383102;this.M[3]=271733878;this.M[4]=3285377520;this.Pd=this.$b=0};
function ua(a,b,c){c||(c=0);var d=a.Af;if(p(b))for(var e=0;16>e;e++)d[e]=b.charCodeAt(c)<<24|b.charCodeAt(c+1)<<16|b.charCodeAt(c+2)<<8|b.charCodeAt(c+3),c+=4;else for(e=0;16>e;e++)d[e]=b[c]<<24|b[c+1]<<16|b[c+2]<<8|b[c+3],c+=4;for(e=16;80>e;e++){var f=d[e-3]^d[e-8]^d[e-14]^d[e-16];d[e]=(f<<1|f>>>31)&4294967295}b=a.M[0];c=a.M[1];for(var h=a.M[2],k=a.M[3],m=a.M[4],l,e=0;80>e;e++)40>e?20>e?(f=k^c&(h^k),l=1518500249):(f=c^h^k,l=1859775393):60>e?(f=c&h|k&(c|h),l=2400959708):(f=c^h^k,l=3395469782),f=(b<<
5|b>>>27)+f+m+l+d[e]&4294967295,m=k,k=h,h=(c<<30|c>>>2)&4294967295,c=b,b=f;a.M[0]=a.M[0]+b&4294967295;a.M[1]=a.M[1]+c&4294967295;a.M[2]=a.M[2]+h&4294967295;a.M[3]=a.M[3]+k&4294967295;a.M[4]=a.M[4]+m&4294967295}
ta.prototype.update=function(a,b){if(null!=a){n(b)||(b=a.length);for(var c=b-this.Wa,d=0,e=this.Wd,f=this.$b;d<b;){if(0==f)for(;d<=c;)ua(this,a,d),d+=this.Wa;if(p(a))for(;d<b;){if(e[f]=a.charCodeAt(d),++f,++d,f==this.Wa){ua(this,e);f=0;break}}else for(;d<b;)if(e[f]=a[d],++f,++d,f==this.Wa){ua(this,e);f=0;break}}this.$b=f;this.Pd+=b}};var r;a:{var va=aa.navigator;if(va){var wa=va.userAgent;if(wa){r=wa;break a}}r=""};var t=Array.prototype,xa=t.indexOf?function(a,b,c){return t.indexOf.call(a,b,c)}:function(a,b,c){c=null==c?0:0>c?Math.max(0,a.length+c):c;if(p(a))return p(b)&&1==b.length?a.indexOf(b,c):-1;for(;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1},ya=t.forEach?function(a,b,c){t.forEach.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=p(a)?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a)},za=t.filter?function(a,b,c){return t.filter.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=[],f=0,h=p(a)?
a.split(""):a,k=0;k<d;k++)if(k in h){var m=h[k];b.call(c,m,k,a)&&(e[f++]=m)}return e},Aa=t.map?function(a,b,c){return t.map.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=Array(d),f=p(a)?a.split(""):a,h=0;h<d;h++)h in f&&(e[h]=b.call(c,f[h],h,a));return e},Ba=t.reduce?function(a,b,c,d){for(var e=[],f=1,h=arguments.length;f<h;f++)e.push(arguments[f]);d&&(e[0]=q(b,d));return t.reduce.apply(a,e)}:function(a,b,c,d){var e=c;ya(a,function(c,h){e=b.call(d,e,c,h,a)});return e},Ca=t.every?function(a,b,
c){return t.every.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=p(a)?a.split(""):a,f=0;f<d;f++)if(f in e&&!b.call(c,e[f],f,a))return!1;return!0};function Da(a,b){var c=Ea(a,b,void 0);return 0>c?null:p(a)?a.charAt(c):a[c]}function Ea(a,b,c){for(var d=a.length,e=p(a)?a.split(""):a,f=0;f<d;f++)if(f in e&&b.call(c,e[f],f,a))return f;return-1}function Fa(a,b){var c=xa(a,b);0<=c&&t.splice.call(a,c,1)}function Ga(a,b,c){return 2>=arguments.length?t.slice.call(a,b):t.slice.call(a,b,c)}
function Ha(a,b){a.sort(b||Ia)}function Ia(a,b){return a>b?1:a<b?-1:0};function v(a,b){for(var c in a)b.call(void 0,a[c],c,a)}function Ja(a,b){var c={},d;for(d in a)c[d]=b.call(void 0,a[d],d,a);return c}function Ka(a,b){for(var c in a)if(!b.call(void 0,a[c],c,a))return!1;return!0}function La(a){var b=0,c;for(c in a)b++;return b}function Ma(a){for(var b in a)return b}function Na(a){var b=[],c=0,d;for(d in a)b[c++]=a[d];return b}function Oa(a){var b=[],c=0,d;for(d in a)b[c++]=d;return b}function Pa(a,b){for(var c in a)if(a[c]==b)return!0;return!1}
function Qa(a,b,c){for(var d in a)if(b.call(c,a[d],d,a))return d}function Ra(a,b){var c=Qa(a,b,void 0);return c&&a[c]}function Sa(a){for(var b in a)return!1;return!0}function Ta(a){var b={},c;for(c in a)b[c]=a[c];return b};var Ua=-1!=r.indexOf("Opera")||-1!=r.indexOf("OPR"),Va=-1!=r.indexOf("Trident")||-1!=r.indexOf("MSIE"),Wa=-1!=r.indexOf("Gecko")&&-1==r.toLowerCase().indexOf("webkit")&&!(-1!=r.indexOf("Trident")||-1!=r.indexOf("MSIE")),Xa=-1!=r.toLowerCase().indexOf("webkit");
(function(){var a="",b;if(Ua&&aa.opera)return a=aa.opera.version,ha(a)?a():a;Wa?b=/rv\:([^\);]+)(\)|;)/:Va?b=/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/:Xa&&(b=/WebKit\/(\S+)/);b&&(a=(a=b.exec(r))?a[1]:"");return Va&&(b=(b=aa.document)?b.documentMode:void 0,b>parseFloat(a))?String(b):a})();var Ya=null,Za=null,$a=null;function ab(a,b){if(!fa(a))throw Error("encodeByteArray takes an array as a parameter");bb();for(var c=b?Za:Ya,d=[],e=0;e<a.length;e+=3){var f=a[e],h=e+1<a.length,k=h?a[e+1]:0,m=e+2<a.length,l=m?a[e+2]:0,u=f>>2,f=(f&3)<<4|k>>4,k=(k&15)<<2|l>>6,l=l&63;m||(l=64,h||(k=64));d.push(c[u],c[f],c[k],c[l])}return d.join("")}
function bb(){if(!Ya){Ya={};Za={};$a={};for(var a=0;65>a;a++)Ya[a]="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(a),Za[a]="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_.".charAt(a),$a[Za[a]]=a,62<=a&&($a["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(a)]=a)}};function cb(a,b){if(!a)throw db(b);}function db(a){return Error("Firebase Database ("+firebase.SDK_VERSION+") INTERNAL ASSERT FAILED: "+a)};function eb(a,b){return Object.prototype.hasOwnProperty.call(a,b)}function w(a,b){if(Object.prototype.hasOwnProperty.call(a,b))return a[b]}function fb(a,b){for(var c in a)Object.prototype.hasOwnProperty.call(a,c)&&b(c,a[c])};function gb(a){var b=[];fb(a,function(a,d){ea(d)?ya(d,function(d){b.push(encodeURIComponent(a)+"="+encodeURIComponent(d))}):b.push(encodeURIComponent(a)+"="+encodeURIComponent(d))});return b.length?"&"+b.join("&"):""};var hb=firebase.Promise;function ib(){var a=this;this.reject=this.resolve=null;this.ra=new hb(function(b,c){a.resolve=b;a.reject=c})}function jb(a,b){return function(c,d){c?a.reject(c):a.resolve(d);ha(b)&&(kb(a.ra),1===b.length?b(c):b(c,d))}}function kb(a){a.then(void 0,ba)};function lb(a){return"undefined"!==typeof JSON&&n(JSON.parse)?JSON.parse(a):ma(a)}function x(a){if("undefined"!==typeof JSON&&n(JSON.stringify))a=JSON.stringify(a);else{var b=[];oa(new na,a,b);a=b.join("")}return a};function mb(a){for(var b=[],c=0,d=0;d<a.length;d++){var e=a.charCodeAt(d);55296<=e&&56319>=e&&(e-=55296,d++,cb(d<a.length,"Surrogate pair missing trail surrogate."),e=65536+(e<<10)+(a.charCodeAt(d)-56320));128>e?b[c++]=e:(2048>e?b[c++]=e>>6|192:(65536>e?b[c++]=e>>12|224:(b[c++]=e>>18|240,b[c++]=e>>12&63|128),b[c++]=e>>6&63|128),b[c++]=e&63|128)}return b}function nb(a){for(var b=0,c=0;c<a.length;c++){var d=a.charCodeAt(c);128>d?b++:2048>d?b+=2:55296<=d&&56319>=d?(b+=4,c++):b+=3}return b};function y(a,b,c,d){var e;d<b?e="at least "+b:d>c&&(e=0===c?"none":"no more than "+c);if(e)throw Error(a+" failed: Was called with "+d+(1===d?" argument.":" arguments.")+" Expects "+e+".");}function A(a,b,c){var d="";switch(b){case 1:d=c?"first":"First";break;case 2:d=c?"second":"Second";break;case 3:d=c?"third":"Third";break;case 4:d=c?"fourth":"Fourth";break;default:throw Error("errorPrefix called with argumentNumber > 4.  Need to update it?");}return a=a+" failed: "+(d+" argument ")}
function B(a,b,c,d){if((!d||n(c))&&!ha(c))throw Error(A(a,b,d)+"must be a valid function.");}function ob(a,b,c){if(n(c)&&(!ia(c)||null===c))throw Error(A(a,b,!0)+"must be a valid context object.");};function pb(){return"undefined"!==typeof window&&!!(window.cordova||window.phonegap||window.PhoneGap)&&/ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test("undefined"!==typeof navigator&&"string"===typeof navigator.userAgent?navigator.userAgent:"")};function C(a,b){this.name=a;this.R=b}function qb(a,b){return new C(a,b)};function rb(a,b){return sb(a.name,b.name)}function tb(a,b){return sb(a,b)};function ub(a){this.uc=a;this.Cd="firebase:"}g=ub.prototype;g.set=function(a,b){null==b?this.uc.removeItem(this.Cd+a):this.uc.setItem(this.Cd+a,x(b))};g.get=function(a){a=this.uc.getItem(this.Cd+a);return null==a?null:lb(a)};g.remove=function(a){this.uc.removeItem(this.Cd+a)};g.Ze=!1;g.toString=function(){return this.uc.toString()};function vb(){this.pc={}}vb.prototype.set=function(a,b){null==b?delete this.pc[a]:this.pc[a]=b};vb.prototype.get=function(a){return eb(this.pc,a)?this.pc[a]:null};vb.prototype.remove=function(a){delete this.pc[a]};vb.prototype.Ze=!0;function wb(a){try{if("undefined"!==typeof window&&"undefined"!==typeof window[a]){var b=window[a];b.setItem("firebase:sentinel","cache");b.removeItem("firebase:sentinel");return new ub(b)}}catch(c){}return new vb}var xb=wb("localStorage"),yb=wb("sessionStorage");function zb(a,b,c,d,e){this.host=a.toLowerCase();this.domain=this.host.substr(this.host.indexOf(".")+1);this.Sc=b;this.pe=c;this.qg=d;this.gf=e||"";this.$a=xb.get("host:"+a)||this.host}function Ab(a,b){b!==a.$a&&(a.$a=b,"s-"===a.$a.substr(0,2)&&xb.set("host:"+a.host,a.$a))}
function Bb(a,b,c){D("string"===typeof b,"typeof type must == string");D("object"===typeof c,"typeof params must == object");if(b===Cb)b=(a.Sc?"wss://":"ws://")+a.$a+"/.ws?";else if(b===Db)b=(a.Sc?"https://":"http://")+a.$a+"/.lp?";else throw Error("Unknown connection type: "+b);a.host!==a.$a&&(c.ns=a.pe);var d=[];v(c,function(a,b){d.push(b+"="+a)});return b+d.join("&")}zb.prototype.toString=function(){var a=(this.Sc?"https://":"http://")+this.host;this.gf&&(a+="<"+this.gf+">");return a};function Eb(a,b){return a&&"object"===typeof a?(D(".sv"in a,"Unexpected leaf node or priority contents"),b[a[".sv"]]):a}function Fb(a,b){var c=new Gb;Hb(a,new E(""),function(a,e){Ib(c,a,Jb(e,b))});return c}function Jb(a,b){var c=a.C().H(),c=Eb(c,b),d;if(a.J()){var e=Eb(a.Ca(),b);return e!==a.Ca()||c!==a.C().H()?new Kb(e,G(c)):a}d=a;c!==a.C().H()&&(d=d.fa(new Kb(c)));a.O(H,function(a,c){var e=Jb(c,b);e!==c&&(d=d.T(a,e))});return d};var Lb=function(){var a=1;return function(){return a++}}(),D=cb,Mb=db;
function Nb(a){try{var b;bb();for(var c=$a,d=[],e=0;e<a.length;){var f=c[a.charAt(e++)],h=e<a.length?c[a.charAt(e)]:0;++e;var k=e<a.length?c[a.charAt(e)]:64;++e;var m=e<a.length?c[a.charAt(e)]:64;++e;if(null==f||null==h||null==k||null==m)throw Error();d.push(f<<2|h>>4);64!=k&&(d.push(h<<4&240|k>>2),64!=m&&d.push(k<<6&192|m))}if(8192>d.length)b=String.fromCharCode.apply(null,d);else{a="";for(c=0;c<d.length;c+=8192)a+=String.fromCharCode.apply(null,Ga(d,c,c+8192));b=a}return b}catch(l){I("base64Decode failed: ",
l)}return null}function Ob(a){var b=mb(a);a=new ta;a.update(b);var b=[],c=8*a.Pd;56>a.$b?a.update(a.zd,56-a.$b):a.update(a.zd,a.Wa-(a.$b-56));for(var d=a.Wa-1;56<=d;d--)a.Wd[d]=c&255,c/=256;ua(a,a.Wd);for(d=c=0;5>d;d++)for(var e=24;0<=e;e-=8)b[c]=a.M[d]>>e&255,++c;return ab(b)}function Pb(a){for(var b="",c=0;c<arguments.length;c++)b=fa(arguments[c])?b+Pb.apply(null,arguments[c]):"object"===typeof arguments[c]?b+x(arguments[c]):b+arguments[c],b+=" ";return b}var Qb=null,Rb=!0;
function Sb(a,b){cb(!b||!0===a||!1===a,"Can't turn on custom loggers persistently.");!0===a?("undefined"!==typeof console&&("function"===typeof console.log?Qb=q(console.log,console):"object"===typeof console.log&&(Qb=function(a){console.log(a)})),b&&yb.set("logging_enabled",!0)):ha(a)?Qb=a:(Qb=null,yb.remove("logging_enabled"))}function I(a){!0===Rb&&(Rb=!1,null===Qb&&!0===yb.get("logging_enabled")&&Sb(!0));if(Qb){var b=Pb.apply(null,arguments);Qb(b)}}
function Tb(a){return function(){I(a,arguments)}}function Ub(a){if("undefined"!==typeof console){var b="FIREBASE INTERNAL ERROR: "+Pb.apply(null,arguments);"undefined"!==typeof console.error?console.error(b):console.log(b)}}function Vb(a){var b=Pb.apply(null,arguments);throw Error("FIREBASE FATAL ERROR: "+b);}function J(a){if("undefined"!==typeof console){var b="FIREBASE WARNING: "+Pb.apply(null,arguments);"undefined"!==typeof console.warn?console.warn(b):console.log(b)}}
function Wb(a){var b,c,d,e,f,h=a;f=c=a=b="";d=!0;e="https";if(p(h)){var k=h.indexOf("//");0<=k&&(e=h.substring(0,k-1),h=h.substring(k+2));k=h.indexOf("/");-1===k&&(k=h.length);b=h.substring(0,k);f="";h=h.substring(k).split("/");for(k=0;k<h.length;k++)if(0<h[k].length){var m=h[k];try{m=decodeURIComponent(m.replace(/\+/g," "))}catch(l){}f+="/"+m}h=b.split(".");3===h.length?(a=h[1],c=h[0].toLowerCase()):2===h.length&&(a=h[0]);k=b.indexOf(":");0<=k&&(d="https"===e||"wss"===e)}"firebase"===a&&Vb(b+" is no longer supported. Please use <YOUR FIREBASE>.firebaseio.com instead");
c&&"undefined"!=c||Vb("Cannot parse Firebase url. Please use https://<YOUR FIREBASE>.firebaseio.com");d||"undefined"!==typeof window&&window.location&&window.location.protocol&&-1!==window.location.protocol.indexOf("https:")&&J("Insecure Firebase access from a secure page. Please use https in calls to new Firebase().");return{jc:new zb(b,d,c,"ws"===e||"wss"===e),path:new E(f)}}function Xb(a){return ga(a)&&(a!=a||a==Number.POSITIVE_INFINITY||a==Number.NEGATIVE_INFINITY)}
function Yb(a){if("complete"===document.readyState)a();else{var b=!1,c=function(){document.body?b||(b=!0,a()):setTimeout(c,Math.floor(10))};document.addEventListener?(document.addEventListener("DOMContentLoaded",c,!1),window.addEventListener("load",c,!1)):document.attachEvent&&(document.attachEvent("onreadystatechange",function(){"complete"===document.readyState&&c()}),window.attachEvent("onload",c))}}
function sb(a,b){if(a===b)return 0;if("[MIN_NAME]"===a||"[MAX_NAME]"===b)return-1;if("[MIN_NAME]"===b||"[MAX_NAME]"===a)return 1;var c=Zb(a),d=Zb(b);return null!==c?null!==d?0==c-d?a.length-b.length:c-d:-1:null!==d?1:a<b?-1:1}function $b(a,b){if(b&&a in b)return b[a];throw Error("Missing required key ("+a+") in object: "+x(b));}
function ac(a){if("object"!==typeof a||null===a)return x(a);var b=[],c;for(c in a)b.push(c);b.sort();c="{";for(var d=0;d<b.length;d++)0!==d&&(c+=","),c+=x(b[d]),c+=":",c+=ac(a[b[d]]);return c+"}"}function bc(a,b){if(a.length<=b)return[a];for(var c=[],d=0;d<a.length;d+=b)d+b>a?c.push(a.substring(d,a.length)):c.push(a.substring(d,d+b));return c}function cc(a,b){if(ea(a))for(var c=0;c<a.length;++c)b(c,a[c]);else v(a,b)}
function dc(a){D(!Xb(a),"Invalid JSON number");var b,c,d,e;0===a?(d=c=0,b=-Infinity===1/a?1:0):(b=0>a,a=Math.abs(a),a>=Math.pow(2,-1022)?(d=Math.min(Math.floor(Math.log(a)/Math.LN2),1023),c=d+1023,d=Math.round(a*Math.pow(2,52-d)-Math.pow(2,52))):(c=0,d=Math.round(a/Math.pow(2,-1074))));e=[];for(a=52;a;--a)e.push(d%2?1:0),d=Math.floor(d/2);for(a=11;a;--a)e.push(c%2?1:0),c=Math.floor(c/2);e.push(b?1:0);e.reverse();b=e.join("");c="";for(a=0;64>a;a+=8)d=parseInt(b.substr(a,8),2).toString(16),1===d.length&&
(d="0"+d),c+=d;return c.toLowerCase()}var ec=/^-?\d{1,10}$/;function Zb(a){return ec.test(a)&&(a=Number(a),-2147483648<=a&&2147483647>=a)?a:null}function fc(a){try{a()}catch(b){setTimeout(function(){J("Exception was thrown by user callback.",b.stack||"");throw b;},Math.floor(0))}}function gc(a,b,c){Object.defineProperty(a,b,{get:c})}function hc(a,b){var c=setTimeout(a,b);"object"===typeof c&&c.unref&&c.unref();return c};function ic(a){var b={},c={},d={},e="";try{var f=a.split("."),b=lb(Nb(f[0])||""),c=lb(Nb(f[1])||""),e=f[2],d=c.d||{};delete c.d}catch(h){}return{tg:b,Je:c,data:d,mg:e}}function jc(a){a=ic(a);var b=a.Je;return!!a.mg&&!!b&&"object"===typeof b&&b.hasOwnProperty("iat")}function kc(a){a=ic(a).Je;return"object"===typeof a&&!0===w(a,"admin")};function lc(){}var mc={};function nc(a){return q(a.compare,a)}lc.prototype.nd=function(a,b){return 0!==this.compare(new C("[MIN_NAME]",a),new C("[MIN_NAME]",b))};lc.prototype.Hc=function(){return oc};function pc(a){D(!a.e()&&".priority"!==K(a),"Can't create PathIndex with empty path or .priority key");this.bc=a}la(pc,lc);g=pc.prototype;g.xc=function(a){return!a.P(this.bc).e()};g.compare=function(a,b){var c=a.R.P(this.bc),d=b.R.P(this.bc),c=c.sc(d);return 0===c?sb(a.name,b.name):c};
g.Ec=function(a,b){var c=G(a),c=L.F(this.bc,c);return new C(b,c)};g.Fc=function(){var a=L.F(this.bc,qc);return new C("[MAX_NAME]",a)};g.toString=function(){return this.bc.slice().join("/")};function rc(){}la(rc,lc);g=rc.prototype;g.compare=function(a,b){var c=a.R.C(),d=b.R.C(),c=c.sc(d);return 0===c?sb(a.name,b.name):c};g.xc=function(a){return!a.C().e()};g.nd=function(a,b){return!a.C().Z(b.C())};g.Hc=function(){return oc};g.Fc=function(){return new C("[MAX_NAME]",new Kb("[PRIORITY-POST]",qc))};
g.Ec=function(a,b){var c=G(a);return new C(b,new Kb("[PRIORITY-POST]",c))};g.toString=function(){return".priority"};var H=new rc;function sc(){}la(sc,lc);g=sc.prototype;g.compare=function(a,b){return sb(a.name,b.name)};g.xc=function(){throw Mb("KeyIndex.isDefinedOn not expected to be called.");};g.nd=function(){return!1};g.Hc=function(){return oc};g.Fc=function(){return new C("[MAX_NAME]",L)};g.Ec=function(a){D(p(a),"KeyIndex indexValue must always be a string.");return new C(a,L)};g.toString=function(){return".key"};
var tc=new sc;function uc(){}la(uc,lc);g=uc.prototype;g.compare=function(a,b){var c=a.R.sc(b.R);return 0===c?sb(a.name,b.name):c};g.xc=function(){return!0};g.nd=function(a,b){return!a.Z(b)};g.Hc=function(){return oc};g.Fc=function(){return vc};g.Ec=function(a,b){var c=G(a);return new C(b,c)};g.toString=function(){return".value"};var wc=new uc;function xc(a,b){this.od=a;this.cc=b}xc.prototype.get=function(a){var b=w(this.od,a);if(!b)throw Error("No index defined for "+a);return b===mc?null:b};function yc(a,b,c){var d=Ja(a.od,function(d,f){var h=w(a.cc,f);D(h,"Missing index implementation for "+f);if(d===mc){if(h.xc(b.R)){for(var k=[],m=c.Wb(qb),l=M(m);l;)l.name!=b.name&&k.push(l),l=M(m);k.push(b);return zc(k,nc(h))}return mc}h=c.get(b.name);k=d;h&&(k=k.remove(new C(b.name,h)));return k.Oa(b,b.R)});return new xc(d,a.cc)}
function Ac(a,b,c){var d=Ja(a.od,function(a){if(a===mc)return a;var d=c.get(b.name);return d?a.remove(new C(b.name,d)):a});return new xc(d,a.cc)}var Bc=new xc({".priority":mc},{".priority":H});function Kb(a,b){this.B=a;D(n(this.B)&&null!==this.B,"LeafNode shouldn't be created with null/undefined value.");this.aa=b||L;Cc(this.aa);this.Db=null}var Dc=["object","boolean","number","string"];g=Kb.prototype;g.J=function(){return!0};g.C=function(){return this.aa};g.fa=function(a){return new Kb(this.B,a)};g.Q=function(a){return".priority"===a?this.aa:L};g.P=function(a){return a.e()?this:".priority"===K(a)?this.aa:L};g.Da=function(){return!1};g.Ve=function(){return null};
g.T=function(a,b){return".priority"===a?this.fa(b):b.e()&&".priority"!==a?this:L.T(a,b).fa(this.aa)};g.F=function(a,b){var c=K(a);if(null===c)return b;if(b.e()&&".priority"!==c)return this;D(".priority"!==c||1===Ec(a),".priority must be the last token in a path");return this.T(c,L.F(N(a),b))};g.e=function(){return!1};g.Eb=function(){return 0};g.O=function(){return!1};g.H=function(a){return a&&!this.C().e()?{".value":this.Ca(),".priority":this.C().H()}:this.Ca()};
g.hash=function(){if(null===this.Db){var a="";this.aa.e()||(a+="priority:"+Fc(this.aa.H())+":");var b=typeof this.B,a=a+(b+":"),a="number"===b?a+dc(this.B):a+this.B;this.Db=Ob(a)}return this.Db};g.Ca=function(){return this.B};g.sc=function(a){if(a===L)return 1;if(a instanceof O)return-1;D(a.J(),"Unknown node type");var b=typeof a.B,c=typeof this.B,d=xa(Dc,b),e=xa(Dc,c);D(0<=d,"Unknown leaf type: "+b);D(0<=e,"Unknown leaf type: "+c);return d===e?"object"===c?0:this.B<a.B?-1:this.B===a.B?0:1:e-d};
g.nb=function(){return this};g.yc=function(){return!0};g.Z=function(a){return a===this?!0:a.J()?this.B===a.B&&this.aa.Z(a.aa):!1};g.toString=function(){return x(this.H(!0))};function Gc(){this.set={}}g=Gc.prototype;g.add=function(a,b){this.set[a]=null!==b?b:!0};g.contains=function(a){return eb(this.set,a)};g.get=function(a){return this.contains(a)?this.set[a]:void 0};g.remove=function(a){delete this.set[a]};g.clear=function(){this.set={}};g.e=function(){return Sa(this.set)};g.count=function(){return La(this.set)};function Hc(a,b){v(a.set,function(a,d){b(d,a)})}g.keys=function(){var a=[];v(this.set,function(b,c){a.push(c)});return a};function Ic(a){D(ea(a)&&0<a.length,"Requires a non-empty array");this.Bf=a;this.Dc={}}Ic.prototype.Ge=function(a,b){var c;c=this.Dc[a]||[];var d=c.length;if(0<d){for(var e=Array(d),f=0;f<d;f++)e[f]=c[f];c=e}else c=[];for(d=0;d<c.length;d++)c[d].Ie.apply(c[d].Ma,Array.prototype.slice.call(arguments,1))};Ic.prototype.gc=function(a,b,c){Jc(this,a);this.Dc[a]=this.Dc[a]||[];this.Dc[a].push({Ie:b,Ma:c});(a=this.Ue(a))&&b.apply(c,a)};
Ic.prototype.Ic=function(a,b,c){Jc(this,a);a=this.Dc[a]||[];for(var d=0;d<a.length;d++)if(a[d].Ie===b&&(!c||c===a[d].Ma)){a.splice(d,1);break}};function Jc(a,b){D(Da(a.Bf,function(a){return a===b}),"Unknown event: "+b)};var Kc=function(){var a=0,b=[];return function(c){var d=c===a;a=c;for(var e=Array(8),f=7;0<=f;f--)e[f]="-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz".charAt(c%64),c=Math.floor(c/64);D(0===c,"Cannot push at time == 0");c=e.join("");if(d){for(f=11;0<=f&&63===b[f];f--)b[f]=0;b[f]++}else for(f=0;12>f;f++)b[f]=Math.floor(64*Math.random());for(f=0;12>f;f++)c+="-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz".charAt(b[f]);D(20===c.length,"nextPushId: Length should be 20.");
return c}}();function Lc(){Ic.call(this,["online"]);this.hc=!0;if("undefined"!==typeof window&&"undefined"!==typeof window.addEventListener&&!pb()){var a=this;window.addEventListener("online",function(){a.hc||(a.hc=!0,a.Ge("online",!0))},!1);window.addEventListener("offline",function(){a.hc&&(a.hc=!1,a.Ge("online",!1))},!1)}}la(Lc,Ic);Lc.prototype.Ue=function(a){D("online"===a,"Unknown event type: "+a);return[this.hc]};ca(Lc);function Mc(){Ic.call(this,["visible"]);var a,b;"undefined"!==typeof document&&"undefined"!==typeof document.addEventListener&&("undefined"!==typeof document.hidden?(b="visibilitychange",a="hidden"):"undefined"!==typeof document.mozHidden?(b="mozvisibilitychange",a="mozHidden"):"undefined"!==typeof document.msHidden?(b="msvisibilitychange",a="msHidden"):"undefined"!==typeof document.webkitHidden&&(b="webkitvisibilitychange",a="webkitHidden"));this.Mb=!0;if(b){var c=this;document.addEventListener(b,
function(){var b=!document[a];b!==c.Mb&&(c.Mb=b,c.Ge("visible",b))},!1)}}la(Mc,Ic);Mc.prototype.Ue=function(a){D("visible"===a,"Unknown event type: "+a);return[this.Mb]};ca(Mc);function E(a,b){if(1==arguments.length){this.o=a.split("/");for(var c=0,d=0;d<this.o.length;d++)0<this.o[d].length&&(this.o[c]=this.o[d],c++);this.o.length=c;this.Y=0}else this.o=a,this.Y=b}function P(a,b){var c=K(a);if(null===c)return b;if(c===K(b))return P(N(a),N(b));throw Error("INTERNAL ERROR: innerPath ("+b+") is not within outerPath ("+a+")");}
function Nc(a,b){for(var c=a.slice(),d=b.slice(),e=0;e<c.length&&e<d.length;e++){var f=sb(c[e],d[e]);if(0!==f)return f}return c.length===d.length?0:c.length<d.length?-1:1}function K(a){return a.Y>=a.o.length?null:a.o[a.Y]}function Ec(a){return a.o.length-a.Y}function N(a){var b=a.Y;b<a.o.length&&b++;return new E(a.o,b)}function Oc(a){return a.Y<a.o.length?a.o[a.o.length-1]:null}g=E.prototype;
g.toString=function(){for(var a="",b=this.Y;b<this.o.length;b++)""!==this.o[b]&&(a+="/"+this.o[b]);return a||"/"};g.slice=function(a){return this.o.slice(this.Y+(a||0))};g.parent=function(){if(this.Y>=this.o.length)return null;for(var a=[],b=this.Y;b<this.o.length-1;b++)a.push(this.o[b]);return new E(a,0)};
g.n=function(a){for(var b=[],c=this.Y;c<this.o.length;c++)b.push(this.o[c]);if(a instanceof E)for(c=a.Y;c<a.o.length;c++)b.push(a.o[c]);else for(a=a.split("/"),c=0;c<a.length;c++)0<a[c].length&&b.push(a[c]);return new E(b,0)};g.e=function(){return this.Y>=this.o.length};g.Z=function(a){if(Ec(this)!==Ec(a))return!1;for(var b=this.Y,c=a.Y;b<=this.o.length;b++,c++)if(this.o[b]!==a.o[c])return!1;return!0};
g.contains=function(a){var b=this.Y,c=a.Y;if(Ec(this)>Ec(a))return!1;for(;b<this.o.length;){if(this.o[b]!==a.o[c])return!1;++b;++c}return!0};var Q=new E("");function Pc(a,b){this.Qa=a.slice();this.Ha=Math.max(1,this.Qa.length);this.Qe=b;for(var c=0;c<this.Qa.length;c++)this.Ha+=nb(this.Qa[c]);Qc(this)}Pc.prototype.push=function(a){0<this.Qa.length&&(this.Ha+=1);this.Qa.push(a);this.Ha+=nb(a);Qc(this)};Pc.prototype.pop=function(){var a=this.Qa.pop();this.Ha-=nb(a);0<this.Qa.length&&--this.Ha};
function Qc(a){if(768<a.Ha)throw Error(a.Qe+"has a key path longer than 768 bytes ("+a.Ha+").");if(32<a.Qa.length)throw Error(a.Qe+"path specified exceeds the maximum depth that can be written (32) or object contains a cycle "+Rc(a));}function Rc(a){return 0==a.Qa.length?"":"in property '"+a.Qa.join(".")+"'"};function Sc(){this.children={};this.bd=0;this.value=null}function Tc(a,b,c){this.ud=a?a:"";this.Pc=b?b:null;this.A=c?c:new Sc}function Uc(a,b){for(var c=b instanceof E?b:new E(b),d=a,e;null!==(e=K(c));)d=new Tc(e,d,w(d.A.children,e)||new Sc),c=N(c);return d}g=Tc.prototype;g.Ca=function(){return this.A.value};function Vc(a,b){D("undefined"!==typeof b,"Cannot set value to undefined");a.A.value=b;Wc(a)}g.clear=function(){this.A.value=null;this.A.children={};this.A.bd=0;Wc(this)};
g.kd=function(){return 0<this.A.bd};g.e=function(){return null===this.Ca()&&!this.kd()};g.O=function(a){var b=this;v(this.A.children,function(c,d){a(new Tc(d,b,c))})};function Xc(a,b,c,d){c&&!d&&b(a);a.O(function(a){Xc(a,b,!0,d)});c&&d&&b(a)}function Yc(a,b){for(var c=a.parent();null!==c&&!b(c);)c=c.parent()}g.path=function(){return new E(null===this.Pc?this.ud:this.Pc.path()+"/"+this.ud)};g.name=function(){return this.ud};g.parent=function(){return this.Pc};
function Wc(a){if(null!==a.Pc){var b=a.Pc,c=a.ud,d=a.e(),e=eb(b.A.children,c);d&&e?(delete b.A.children[c],b.A.bd--,Wc(b)):d||e||(b.A.children[c]=a.A,b.A.bd++,Wc(b))}};function Zc(a,b){this.La=a;this.ba=b?b:$c}g=Zc.prototype;g.Oa=function(a,b){return new Zc(this.La,this.ba.Oa(a,b,this.La).X(null,null,!1,null,null))};g.remove=function(a){return new Zc(this.La,this.ba.remove(a,this.La).X(null,null,!1,null,null))};g.get=function(a){for(var b,c=this.ba;!c.e();){b=this.La(a,c.key);if(0===b)return c.value;0>b?c=c.left:0<b&&(c=c.right)}return null};
function ad(a,b){for(var c,d=a.ba,e=null;!d.e();){c=a.La(b,d.key);if(0===c){if(d.left.e())return e?e.key:null;for(d=d.left;!d.right.e();)d=d.right;return d.key}0>c?d=d.left:0<c&&(e=d,d=d.right)}throw Error("Attempted to find predecessor key for a nonexistent key.  What gives?");}g.e=function(){return this.ba.e()};g.count=function(){return this.ba.count()};g.Gc=function(){return this.ba.Gc()};g.ec=function(){return this.ba.ec()};g.ha=function(a){return this.ba.ha(a)};
g.Wb=function(a){return new bd(this.ba,null,this.La,!1,a)};g.Xb=function(a,b){return new bd(this.ba,a,this.La,!1,b)};g.Zb=function(a,b){return new bd(this.ba,a,this.La,!0,b)};g.We=function(a){return new bd(this.ba,null,this.La,!0,a)};function bd(a,b,c,d,e){this.Hd=e||null;this.le=d;this.Pa=[];for(e=1;!a.e();)if(e=b?c(a.key,b):1,d&&(e*=-1),0>e)a=this.le?a.left:a.right;else if(0===e){this.Pa.push(a);break}else this.Pa.push(a),a=this.le?a.right:a.left}
function M(a){if(0===a.Pa.length)return null;var b=a.Pa.pop(),c;c=a.Hd?a.Hd(b.key,b.value):{key:b.key,value:b.value};if(a.le)for(b=b.left;!b.e();)a.Pa.push(b),b=b.right;else for(b=b.right;!b.e();)a.Pa.push(b),b=b.left;return c}function cd(a){if(0===a.Pa.length)return null;var b;b=a.Pa;b=b[b.length-1];return a.Hd?a.Hd(b.key,b.value):{key:b.key,value:b.value}}function dd(a,b,c,d,e){this.key=a;this.value=b;this.color=null!=c?c:!0;this.left=null!=d?d:$c;this.right=null!=e?e:$c}g=dd.prototype;
g.X=function(a,b,c,d,e){return new dd(null!=a?a:this.key,null!=b?b:this.value,null!=c?c:this.color,null!=d?d:this.left,null!=e?e:this.right)};g.count=function(){return this.left.count()+1+this.right.count()};g.e=function(){return!1};g.ha=function(a){return this.left.ha(a)||a(this.key,this.value)||this.right.ha(a)};function ed(a){return a.left.e()?a:ed(a.left)}g.Gc=function(){return ed(this).key};g.ec=function(){return this.right.e()?this.key:this.right.ec()};
g.Oa=function(a,b,c){var d,e;e=this;d=c(a,e.key);e=0>d?e.X(null,null,null,e.left.Oa(a,b,c),null):0===d?e.X(null,b,null,null,null):e.X(null,null,null,null,e.right.Oa(a,b,c));return gd(e)};function hd(a){if(a.left.e())return $c;a.left.ea()||a.left.left.ea()||(a=id(a));a=a.X(null,null,null,hd(a.left),null);return gd(a)}
g.remove=function(a,b){var c,d;c=this;if(0>b(a,c.key))c.left.e()||c.left.ea()||c.left.left.ea()||(c=id(c)),c=c.X(null,null,null,c.left.remove(a,b),null);else{c.left.ea()&&(c=jd(c));c.right.e()||c.right.ea()||c.right.left.ea()||(c=kd(c),c.left.left.ea()&&(c=jd(c),c=kd(c)));if(0===b(a,c.key)){if(c.right.e())return $c;d=ed(c.right);c=c.X(d.key,d.value,null,null,hd(c.right))}c=c.X(null,null,null,null,c.right.remove(a,b))}return gd(c)};g.ea=function(){return this.color};
function gd(a){a.right.ea()&&!a.left.ea()&&(a=ld(a));a.left.ea()&&a.left.left.ea()&&(a=jd(a));a.left.ea()&&a.right.ea()&&(a=kd(a));return a}function id(a){a=kd(a);a.right.left.ea()&&(a=a.X(null,null,null,null,jd(a.right)),a=ld(a),a=kd(a));return a}function ld(a){return a.right.X(null,null,a.color,a.X(null,null,!0,null,a.right.left),null)}function jd(a){return a.left.X(null,null,a.color,null,a.X(null,null,!0,a.left.right,null))}
function kd(a){return a.X(null,null,!a.color,a.left.X(null,null,!a.left.color,null,null),a.right.X(null,null,!a.right.color,null,null))}function md(){}g=md.prototype;g.X=function(){return this};g.Oa=function(a,b){return new dd(a,b,null)};g.remove=function(){return this};g.count=function(){return 0};g.e=function(){return!0};g.ha=function(){return!1};g.Gc=function(){return null};g.ec=function(){return null};g.ea=function(){return!1};var $c=new md;function O(a,b,c){this.k=a;(this.aa=b)&&Cc(this.aa);a.e()&&D(!this.aa||this.aa.e(),"An empty node cannot have a priority");this.yb=c;this.Db=null}g=O.prototype;g.J=function(){return!1};g.C=function(){return this.aa||L};g.fa=function(a){return this.k.e()?this:new O(this.k,a,this.yb)};g.Q=function(a){if(".priority"===a)return this.C();a=this.k.get(a);return null===a?L:a};g.P=function(a){var b=K(a);return null===b?this:this.Q(b).P(N(a))};g.Da=function(a){return null!==this.k.get(a)};
g.T=function(a,b){D(b,"We should always be passing snapshot nodes");if(".priority"===a)return this.fa(b);var c=new C(a,b),d,e;b.e()?(d=this.k.remove(a),c=Ac(this.yb,c,this.k)):(d=this.k.Oa(a,b),c=yc(this.yb,c,this.k));e=d.e()?L:this.aa;return new O(d,e,c)};g.F=function(a,b){var c=K(a);if(null===c)return b;D(".priority"!==K(a)||1===Ec(a),".priority must be the last token in a path");var d=this.Q(c).F(N(a),b);return this.T(c,d)};g.e=function(){return this.k.e()};g.Eb=function(){return this.k.count()};
var nd=/^(0|[1-9]\d*)$/;g=O.prototype;g.H=function(a){if(this.e())return null;var b={},c=0,d=0,e=!0;this.O(H,function(f,h){b[f]=h.H(a);c++;e&&nd.test(f)?d=Math.max(d,Number(f)):e=!1});if(!a&&e&&d<2*c){var f=[],h;for(h in b)f[h]=b[h];return f}a&&!this.C().e()&&(b[".priority"]=this.C().H());return b};g.hash=function(){if(null===this.Db){var a="";this.C().e()||(a+="priority:"+Fc(this.C().H())+":");this.O(H,function(b,c){var d=c.hash();""!==d&&(a+=":"+b+":"+d)});this.Db=""===a?"":Ob(a)}return this.Db};
g.Ve=function(a,b,c){return(c=od(this,c))?(a=ad(c,new C(a,b)))?a.name:null:ad(this.k,a)};function pd(a,b){var c;c=(c=od(a,b))?(c=c.Gc())&&c.name:a.k.Gc();return c?new C(c,a.k.get(c)):null}function qd(a,b){var c;c=(c=od(a,b))?(c=c.ec())&&c.name:a.k.ec();return c?new C(c,a.k.get(c)):null}g.O=function(a,b){var c=od(this,a);return c?c.ha(function(a){return b(a.name,a.R)}):this.k.ha(b)};g.Wb=function(a){return this.Xb(a.Hc(),a)};
g.Xb=function(a,b){var c=od(this,b);if(c)return c.Xb(a,function(a){return a});for(var c=this.k.Xb(a.name,qb),d=cd(c);null!=d&&0>b.compare(d,a);)M(c),d=cd(c);return c};g.We=function(a){return this.Zb(a.Fc(),a)};g.Zb=function(a,b){var c=od(this,b);if(c)return c.Zb(a,function(a){return a});for(var c=this.k.Zb(a.name,qb),d=cd(c);null!=d&&0<b.compare(d,a);)M(c),d=cd(c);return c};g.sc=function(a){return this.e()?a.e()?0:-1:a.J()||a.e()?1:a===qc?-1:0};
g.nb=function(a){if(a===tc||Pa(this.yb.cc,a.toString()))return this;var b=this.yb,c=this.k;D(a!==tc,"KeyIndex always exists and isn't meant to be added to the IndexMap.");for(var d=[],e=!1,c=c.Wb(qb),f=M(c);f;)e=e||a.xc(f.R),d.push(f),f=M(c);d=e?zc(d,nc(a)):mc;e=a.toString();c=Ta(b.cc);c[e]=a;a=Ta(b.od);a[e]=d;return new O(this.k,this.aa,new xc(a,c))};g.yc=function(a){return a===tc||Pa(this.yb.cc,a.toString())};
g.Z=function(a){if(a===this)return!0;if(a.J())return!1;if(this.C().Z(a.C())&&this.k.count()===a.k.count()){var b=this.Wb(H);a=a.Wb(H);for(var c=M(b),d=M(a);c&&d;){if(c.name!==d.name||!c.R.Z(d.R))return!1;c=M(b);d=M(a)}return null===c&&null===d}return!1};function od(a,b){return b===tc?null:a.yb.get(b.toString())}g.toString=function(){return x(this.H(!0))};function G(a,b){if(null===a)return L;var c=null;"object"===typeof a&&".priority"in a?c=a[".priority"]:"undefined"!==typeof b&&(c=b);D(null===c||"string"===typeof c||"number"===typeof c||"object"===typeof c&&".sv"in c,"Invalid priority type found: "+typeof c);"object"===typeof a&&".value"in a&&null!==a[".value"]&&(a=a[".value"]);if("object"!==typeof a||".sv"in a)return new Kb(a,G(c));if(a instanceof Array){var d=L,e=a;v(e,function(a,b){if(eb(e,b)&&"."!==b.substring(0,1)){var c=G(a);if(c.J()||!c.e())d=
d.T(b,c)}});return d.fa(G(c))}var f=[],h=!1,k=a;fb(k,function(a){if("string"!==typeof a||"."!==a.substring(0,1)){var b=G(k[a]);b.e()||(h=h||!b.C().e(),f.push(new C(a,b)))}});if(0==f.length)return L;var m=zc(f,rb,function(a){return a.name},tb);if(h){var l=zc(f,nc(H));return new O(m,G(c),new xc({".priority":l},{".priority":H}))}return new O(m,G(c),Bc)}var rd=Math.log(2);
function sd(a){this.count=parseInt(Math.log(a+1)/rd,10);this.Oe=this.count-1;this.Cf=a+1&parseInt(Array(this.count+1).join("1"),2)}function td(a){var b=!(a.Cf&1<<a.Oe);a.Oe--;return b}
function zc(a,b,c,d){function e(b,d){var f=d-b;if(0==f)return null;if(1==f){var l=a[b],u=c?c(l):l;return new dd(u,l.R,!1,null,null)}var l=parseInt(f/2,10)+b,f=e(b,l),z=e(l+1,d),l=a[l],u=c?c(l):l;return new dd(u,l.R,!1,f,z)}a.sort(b);var f=function(b){function d(b,h){var k=u-b,z=u;u-=b;var z=e(k+1,z),k=a[k],F=c?c(k):k,z=new dd(F,k.R,h,null,z);f?f.left=z:l=z;f=z}for(var f=null,l=null,u=a.length,z=0;z<b.count;++z){var F=td(b),fd=Math.pow(2,b.count-(z+1));F?d(fd,!1):(d(fd,!1),d(fd,!0))}return l}(new sd(a.length));
return null!==f?new Zc(d||b,f):new Zc(d||b)}function Fc(a){return"number"===typeof a?"number:"+dc(a):"string:"+a}function Cc(a){if(a.J()){var b=a.H();D("string"===typeof b||"number"===typeof b||"object"===typeof b&&eb(b,".sv"),"Priority must be a string or number.")}else D(a===qc||a.e(),"priority of unexpected type.");D(a===qc||a.C().e(),"Priority nodes can't have a priority of their own.")}var L=new O(new Zc(tb),null,Bc);function ud(){O.call(this,new Zc(tb),L,Bc)}la(ud,O);g=ud.prototype;
g.sc=function(a){return a===this?0:1};g.Z=function(a){return a===this};g.C=function(){return this};g.Q=function(){return L};g.e=function(){return!1};var qc=new ud,oc=new C("[MIN_NAME]",L),vc=new C("[MAX_NAME]",qc);function vd(a,b){this.value=a;this.children=b||wd}var wd=new Zc(function(a,b){return a===b?0:a<b?-1:1});function xd(a){var b=R;v(a,function(a,d){b=b.set(new E(d),a)});return b}g=vd.prototype;g.e=function(){return null===this.value&&this.children.e()};function yd(a,b,c){if(null!=a.value&&c(a.value))return{path:Q,value:a.value};if(b.e())return null;var d=K(b);a=a.children.get(d);return null!==a?(b=yd(a,N(b),c),null!=b?{path:(new E(d)).n(b.path),value:b.value}:null):null}
function zd(a,b){return yd(a,b,function(){return!0})}g.subtree=function(a){if(a.e())return this;var b=this.children.get(K(a));return null!==b?b.subtree(N(a)):R};g.set=function(a,b){if(a.e())return new vd(b,this.children);var c=K(a),d=(this.children.get(c)||R).set(N(a),b),c=this.children.Oa(c,d);return new vd(this.value,c)};
g.remove=function(a){if(a.e())return this.children.e()?R:new vd(null,this.children);var b=K(a),c=this.children.get(b);return c?(a=c.remove(N(a)),b=a.e()?this.children.remove(b):this.children.Oa(b,a),null===this.value&&b.e()?R:new vd(this.value,b)):this};g.get=function(a){if(a.e())return this.value;var b=this.children.get(K(a));return b?b.get(N(a)):null};
function Ad(a,b,c){if(b.e())return c;var d=K(b);b=Ad(a.children.get(d)||R,N(b),c);d=b.e()?a.children.remove(d):a.children.Oa(d,b);return new vd(a.value,d)}function Bd(a,b){return Cd(a,Q,b)}function Cd(a,b,c){var d={};a.children.ha(function(a,f){d[a]=Cd(f,b.n(a),c)});return c(b,a.value,d)}function Dd(a,b,c){return Ed(a,b,Q,c)}function Ed(a,b,c,d){var e=a.value?d(c,a.value):!1;if(e)return e;if(b.e())return null;e=K(b);return(a=a.children.get(e))?Ed(a,N(b),c.n(e),d):null}
function Fd(a,b,c){Gd(a,b,Q,c)}function Gd(a,b,c,d){if(b.e())return a;a.value&&d(c,a.value);var e=K(b);return(a=a.children.get(e))?Gd(a,N(b),c.n(e),d):R}function Hd(a,b){Id(a,Q,b)}function Id(a,b,c){a.children.ha(function(a,e){Id(e,b.n(a),c)});a.value&&c(b,a.value)}function Jd(a,b){a.children.ha(function(a,d){d.value&&b(a,d.value)})}var R=new vd(null);vd.prototype.toString=function(){var a={};Hd(this,function(b,c){a[b.toString()]=c.toString()});return x(a)};var Kd=/[\[\].#$\/\u0000-\u001F\u007F]/,Ld=/[\[\].#$\u0000-\u001F\u007F]/;function Md(a){return p(a)&&0!==a.length&&!Kd.test(a)}function Nd(a){return null===a||p(a)||ga(a)&&!Xb(a)||ia(a)&&eb(a,".sv")}function Od(a,b,c,d){d&&!n(b)||Pd(A(a,1,d),b,c)}
function Pd(a,b,c){c instanceof E&&(c=new Pc(c,a));if(!n(b))throw Error(a+"contains undefined "+Rc(c));if(ha(b))throw Error(a+"contains a function "+Rc(c)+" with contents: "+b.toString());if(Xb(b))throw Error(a+"contains "+b.toString()+" "+Rc(c));if(p(b)&&b.length>10485760/3&&10485760<nb(b))throw Error(a+"contains a string greater than 10485760 utf8 bytes "+Rc(c)+" ('"+b.substring(0,50)+"...')");if(ia(b)){var d=!1,e=!1;fb(b,function(b,h){if(".value"===b)d=!0;else if(".priority"!==b&&".sv"!==b&&(e=
!0,!Md(b)))throw Error(a+" contains an invalid key ("+b+") "+Rc(c)+'.  Keys must be non-empty strings and can\'t contain ".", "#", "$", "/", "[", or "]"');c.push(b);Pd(a,h,c);c.pop()});if(d&&e)throw Error(a+' contains ".value" child '+Rc(c)+" in addition to actual children.");}}
function Qd(a,b){var c,d;for(c=0;c<b.length;c++){d=b[c];for(var e=d.slice(),f=0;f<e.length;f++)if((".priority"!==e[f]||f!==e.length-1)&&!Md(e[f]))throw Error(a+"contains an invalid key ("+e[f]+") in path "+d.toString()+'. Keys must be non-empty strings and can\'t contain ".", "#", "$", "/", "[", or "]"');}b.sort(Nc);e=null;for(c=0;c<b.length;c++){d=b[c];if(null!==e&&e.contains(d))throw Error(a+"contains a path "+e.toString()+" that is ancestor of another path "+d.toString());e=d}}
function Rd(a,b,c){var d=A(a,1,!1);if(!ia(b)||ea(b))throw Error(d+" must be an object containing the children to replace.");var e=[];fb(b,function(a,b){var k=new E(a);Pd(d,b,c.n(k));if(".priority"===Oc(k)&&!Nd(b))throw Error(d+"contains an invalid value for '"+k.toString()+"', which must be a valid Firebase priority (a string, finite number, server value, or null).");e.push(k)});Qd(d,e)}
function Sd(a,b,c){if(Xb(c))throw Error(A(a,b,!1)+"is "+c.toString()+", but must be a valid Firebase priority (a string, finite number, server value, or null).");if(!Nd(c))throw Error(A(a,b,!1)+"must be a valid Firebase priority (a string, finite number, server value, or null).");}
function Td(a,b,c){if(!c||n(b))switch(b){case "value":case "child_added":case "child_removed":case "child_changed":case "child_moved":break;default:throw Error(A(a,1,c)+'must be a valid event type: "value", "child_added", "child_removed", "child_changed", or "child_moved".');}}function Ud(a,b){if(n(b)&&!Md(b))throw Error(A(a,2,!0)+'was an invalid key: "'+b+'".  Firebase keys must be non-empty strings and can\'t contain ".", "#", "$", "/", "[", or "]").');}
function Vd(a,b){if(!p(b)||0===b.length||Ld.test(b))throw Error(A(a,1,!1)+'was an invalid path: "'+b+'". Paths must be non-empty strings and can\'t contain ".", "#", "$", "[", or "]"');}function Wd(a,b){if(".info"===K(b))throw Error(a+" failed: Can't modify data under /.info/");}
function Xd(a,b){var c=b.path.toString(),d;!(d=!p(b.jc.host)||0===b.jc.host.length||!Md(b.jc.pe))&&(d=0!==c.length)&&(c&&(c=c.replace(/^\/*\.info(\/|$)/,"/")),d=!(p(c)&&0!==c.length&&!Ld.test(c)));if(d)throw Error(A(a,1,!1)+'must be a valid firebase URL and the path can\'t contain ".", "#", "$", "[", or "]".');};function Gb(){this.k=this.B=null}Gb.prototype.find=function(a){if(null!=this.B)return this.B.P(a);if(a.e()||null==this.k)return null;var b=K(a);a=N(a);return this.k.contains(b)?this.k.get(b).find(a):null};function Ib(a,b,c){if(b.e())a.B=c,a.k=null;else if(null!==a.B)a.B=a.B.F(b,c);else{null==a.k&&(a.k=new Gc);var d=K(b);a.k.contains(d)||a.k.add(d,new Gb);a=a.k.get(d);b=N(b);Ib(a,b,c)}}
function Yd(a,b){if(b.e())return a.B=null,a.k=null,!0;if(null!==a.B){if(a.B.J())return!1;var c=a.B;a.B=null;c.O(H,function(b,c){Ib(a,new E(b),c)});return Yd(a,b)}return null!==a.k?(c=K(b),b=N(b),a.k.contains(c)&&Yd(a.k.get(c),b)&&a.k.remove(c),a.k.e()?(a.k=null,!0):!1):!0}function Hb(a,b,c){null!==a.B?c(b,a.B):a.O(function(a,e){var f=new E(b.toString()+"/"+a);Hb(e,f,c)})}Gb.prototype.O=function(a){null!==this.k&&Hc(this.k,function(b,c){a(b,c)})};function Zd(a,b){this.type=$d;this.source=a;this.path=b}Zd.prototype.Mc=function(){return this.path.e()?new Zd(this.source,Q):new Zd(this.source,N(this.path))};Zd.prototype.toString=function(){return"Operation("+this.path+": "+this.source.toString()+" listen_complete)"};function ae(a,b,c){this.type=be;this.source=a;this.path=b;this.children=c}ae.prototype.Mc=function(a){if(this.path.e())return a=this.children.subtree(new E(a)),a.e()?null:a.value?new ce(this.source,Q,a.value):new ae(this.source,Q,a);D(K(this.path)===a,"Can't get a merge for a child not on the path of the operation");return new ae(this.source,N(this.path),this.children)};ae.prototype.toString=function(){return"Operation("+this.path+": "+this.source.toString()+" merge: "+this.children.toString()+")"};function de(a,b,c){this.type=ee;this.source=fe;this.path=a;this.Ob=b;this.Id=c}de.prototype.Mc=function(a){if(this.path.e()){if(null!=this.Ob.value)return D(this.Ob.children.e(),"affectedTree should not have overlapping affected paths."),this;a=this.Ob.subtree(new E(a));return new de(Q,a,this.Id)}D(K(this.path)===a,"operationForChild called for unrelated child.");return new de(N(this.path),this.Ob,this.Id)};
de.prototype.toString=function(){return"Operation("+this.path+": "+this.source.toString()+" ack write revert="+this.Id+" affectedTree="+this.Ob+")"};function ce(a,b,c){this.type=ge;this.source=a;this.path=b;this.Ga=c}ce.prototype.Mc=function(a){return this.path.e()?new ce(this.source,Q,this.Ga.Q(a)):new ce(this.source,N(this.path),this.Ga)};ce.prototype.toString=function(){return"Operation("+this.path+": "+this.source.toString()+" overwrite: "+this.Ga.toString()+")"};var ge=0,be=1,ee=2,$d=3;function he(a,b,c,d){this.ee=a;this.Se=b;this.Hb=c;this.Ee=d;D(!d||b,"Tagged queries must be from server.")}var fe=new he(!0,!1,null,!1),ie=new he(!1,!0,null,!1);he.prototype.toString=function(){return this.ee?"user":this.Ee?"server(queryID="+this.Hb+")":"server"};function je(a,b,c){this.A=a;this.da=b;this.Sb=c}function ke(a){return a.da}function le(a){return a.Sb}function me(a,b){return b.e()?a.da&&!a.Sb:ne(a,K(b))}function ne(a,b){return a.da&&!a.Sb||a.A.Da(b)}je.prototype.j=function(){return this.A};function oe(a,b){this.N=a;this.Ld=b}function pe(a,b,c,d){return new oe(new je(b,c,d),a.Ld)}function qe(a){return a.N.da?a.N.j():null}oe.prototype.w=function(){return this.Ld};function re(a){return a.Ld.da?a.Ld.j():null};function se(){}se.prototype.Te=function(){return null};se.prototype.fe=function(){return null};var te=new se;function ue(a,b,c){this.xf=a;this.Ka=b;this.yd=c}ue.prototype.Te=function(a){var b=this.Ka.N;if(ne(b,a))return b.j().Q(a);b=null!=this.yd?new je(this.yd,!0,!1):this.Ka.w();return this.xf.qc(a,b)};ue.prototype.fe=function(a,b,c){var d=null!=this.yd?this.yd:re(this.Ka);a=this.xf.Xd(d,b,1,c,a);return 0===a.length?null:a[0]};function ve(a,b){this.Sd=a;this.Df=b}function we(a){this.U=a}
we.prototype.eb=function(a,b,c,d){var e=new xe,f;if(b.type===ge)b.source.ee?c=ye(this,a,b.path,b.Ga,c,d,e):(D(b.source.Se,"Unknown source."),f=b.source.Ee||le(a.w())&&!b.path.e(),c=ze(this,a,b.path,b.Ga,c,d,f,e));else if(b.type===be)b.source.ee?c=Ae(this,a,b.path,b.children,c,d,e):(D(b.source.Se,"Unknown source."),f=b.source.Ee||le(a.w()),c=Be(this,a,b.path,b.children,c,d,f,e));else if(b.type===ee)if(b.Id)if(b=b.path,null!=c.lc(b))c=a;else{f=new ue(c,a,d);d=a.N.j();if(b.e()||".priority"===K(b))ke(a.w())?
b=c.Aa(re(a)):(b=a.w().j(),D(b instanceof O,"serverChildren would be complete if leaf node"),b=c.rc(b)),b=this.U.ya(d,b,e);else{var h=K(b),k=c.qc(h,a.w());null==k&&ne(a.w(),h)&&(k=d.Q(h));b=null!=k?this.U.F(d,h,k,N(b),f,e):a.N.j().Da(h)?this.U.F(d,h,L,N(b),f,e):d;b.e()&&ke(a.w())&&(d=c.Aa(re(a)),d.J()&&(b=this.U.ya(b,d,e)))}d=ke(a.w())||null!=c.lc(Q);c=pe(a,b,d,this.U.Na())}else c=Ce(this,a,b.path,b.Ob,c,d,e);else if(b.type===$d)d=b.path,b=a.w(),f=b.j(),h=b.da||d.e(),c=De(this,new oe(a.N,new je(f,
h,b.Sb)),d,c,te,e);else throw Mb("Unknown operation type: "+b.type);e=Na(e.fb);d=c;b=d.N;b.da&&(f=b.j().J()||b.j().e(),h=qe(a),(0<e.length||!a.N.da||f&&!b.j().Z(h)||!b.j().C().Z(h.C()))&&e.push(Ee(qe(d))));return new ve(c,e)};
function De(a,b,c,d,e,f){var h=b.N;if(null!=d.lc(c))return b;var k;if(c.e())D(ke(b.w()),"If change path is empty, we must have complete server data"),le(b.w())?(e=re(b),d=d.rc(e instanceof O?e:L)):d=d.Aa(re(b)),f=a.U.ya(b.N.j(),d,f);else{var m=K(c);if(".priority"==m)D(1==Ec(c),"Can't have a priority with additional path components"),f=h.j(),k=b.w().j(),d=d.ad(c,f,k),f=null!=d?a.U.fa(f,d):h.j();else{var l=N(c);ne(h,m)?(k=b.w().j(),d=d.ad(c,h.j(),k),d=null!=d?h.j().Q(m).F(l,d):h.j().Q(m)):d=d.qc(m,
b.w());f=null!=d?a.U.F(h.j(),m,d,l,e,f):h.j()}}return pe(b,f,h.da||c.e(),a.U.Na())}function ze(a,b,c,d,e,f,h,k){var m=b.w();h=h?a.U:a.U.Ub();if(c.e())d=h.ya(m.j(),d,null);else if(h.Na()&&!m.Sb)d=m.j().F(c,d),d=h.ya(m.j(),d,null);else{var l=K(c);if(!me(m,c)&&1<Ec(c))return b;var u=N(c);d=m.j().Q(l).F(u,d);d=".priority"==l?h.fa(m.j(),d):h.F(m.j(),l,d,u,te,null)}m=m.da||c.e();b=new oe(b.N,new je(d,m,h.Na()));return De(a,b,c,e,new ue(e,b,f),k)}
function ye(a,b,c,d,e,f,h){var k=b.N;e=new ue(e,b,f);if(c.e())h=a.U.ya(b.N.j(),d,h),a=pe(b,h,!0,a.U.Na());else if(f=K(c),".priority"===f)h=a.U.fa(b.N.j(),d),a=pe(b,h,k.da,k.Sb);else{c=N(c);var m=k.j().Q(f);if(!c.e()){var l=e.Te(f);d=null!=l?".priority"===Oc(c)&&l.P(c.parent()).e()?l:l.F(c,d):L}m.Z(d)?a=b:(h=a.U.F(k.j(),f,d,c,e,h),a=pe(b,h,k.da,a.U.Na()))}return a}
function Ae(a,b,c,d,e,f,h){var k=b;Hd(d,function(d,l){var u=c.n(d);ne(b.N,K(u))&&(k=ye(a,k,u,l,e,f,h))});Hd(d,function(d,l){var u=c.n(d);ne(b.N,K(u))||(k=ye(a,k,u,l,e,f,h))});return k}function Fe(a,b){Hd(b,function(b,d){a=a.F(b,d)});return a}
function Be(a,b,c,d,e,f,h,k){if(b.w().j().e()&&!ke(b.w()))return b;var m=b;c=c.e()?d:Ad(R,c,d);var l=b.w().j();c.children.ha(function(c,d){if(l.Da(c)){var F=b.w().j().Q(c),F=Fe(F,d);m=ze(a,m,new E(c),F,e,f,h,k)}});c.children.ha(function(c,d){var F=!ne(b.w(),c)&&null==d.value;l.Da(c)||F||(F=b.w().j().Q(c),F=Fe(F,d),m=ze(a,m,new E(c),F,e,f,h,k))});return m}
function Ce(a,b,c,d,e,f,h){if(null!=e.lc(c))return b;var k=le(b.w()),m=b.w();if(null!=d.value){if(c.e()&&m.da||me(m,c))return ze(a,b,c,m.j().P(c),e,f,k,h);if(c.e()){var l=R;m.j().O(tc,function(a,b){l=l.set(new E(a),b)});return Be(a,b,c,l,e,f,k,h)}return b}l=R;Hd(d,function(a){var b=c.n(a);me(m,b)&&(l=l.set(a,m.j().P(b)))});return Be(a,b,c,l,e,f,k,h)};function Ge(a){this.V=a;this.g=a.m.g}function He(a,b,c,d){var e=[],f=[];ya(b,function(b){b.type===Ie&&a.g.nd(b.qe,b.Ja)&&f.push(new S(Je,b.Ja,b.Xa))});Ke(a,e,Le,b,d,c);Ke(a,e,Me,b,d,c);Ke(a,e,Je,f,d,c);Ke(a,e,Ie,b,d,c);Ke(a,e,Ne,b,d,c);return e}function Ke(a,b,c,d,e,f){d=za(d,function(a){return a.type===c});Ha(d,q(a.Ff,a));ya(d,function(c){var d=Oe(a,c,f);ya(e,function(e){e.nf(c.type)&&b.push(e.createEvent(d,a.V))})})}
function Oe(a,b,c){"value"!==b.type&&"child_removed"!==b.type&&(b.Dd=c.Ve(b.Xa,b.Ja,a.g));return b}Ge.prototype.Ff=function(a,b){if(null==a.Xa||null==b.Xa)throw Mb("Should only compare child_ events.");return this.g.compare(new C(a.Xa,a.Ja),new C(b.Xa,b.Ja))};function Pe(a,b){this.V=a;var c=a.m,d=new Qe(c.g),c=T(c)?new Qe(c.g):c.xa?new Re(c):new Se(c);this.hf=new we(c);var e=b.w(),f=b.N,h=d.ya(L,e.j(),null),k=c.ya(L,f.j(),null);this.Ka=new oe(new je(k,f.da,c.Na()),new je(h,e.da,d.Na()));this.Za=[];this.Jf=new Ge(a)}function Te(a){return a.V}g=Pe.prototype;g.w=function(){return this.Ka.w().j()};g.hb=function(a){var b=re(this.Ka);return b&&(T(this.V.m)||!a.e()&&!b.Q(K(a)).e())?b.P(a):null};g.e=function(){return 0===this.Za.length};g.Nb=function(a){this.Za.push(a)};
g.kb=function(a,b){var c=[];if(b){D(null==a,"A cancel should cancel all event registrations.");var d=this.V.path;ya(this.Za,function(a){(a=a.Me(b,d))&&c.push(a)})}if(a){for(var e=[],f=0;f<this.Za.length;++f){var h=this.Za[f];if(!h.matches(a))e.push(h);else if(a.Xe()){e=e.concat(this.Za.slice(f+1));break}}this.Za=e}else this.Za=[];return c};
g.eb=function(a,b,c){a.type===be&&null!==a.source.Hb&&(D(re(this.Ka),"We should always have a full cache before handling merges"),D(qe(this.Ka),"Missing event cache, even though we have a server cache"));var d=this.Ka;a=this.hf.eb(d,a,b,c);b=this.hf;c=a.Sd;D(c.N.j().yc(b.U.g),"Event snap not indexed");D(c.w().j().yc(b.U.g),"Server snap not indexed");D(ke(a.Sd.w())||!ke(d.w()),"Once a server snap is complete, it should never go back");this.Ka=a.Sd;return Ue(this,a.Df,a.Sd.N.j(),null)};
function Ve(a,b){var c=a.Ka.N,d=[];c.j().J()||c.j().O(H,function(a,b){d.push(new S(Me,b,a))});c.da&&d.push(Ee(c.j()));return Ue(a,d,c.j(),b)}function Ue(a,b,c,d){return He(a.Jf,b,c,d?[d]:a.Za)};function We(a,b,c,d){this.ae=b;this.Md=c;this.Dd=d;this.hd=a}We.prototype.Yb=function(){var a=this.Md.wb();return"value"===this.hd?a.path:a.getParent().path};We.prototype.ge=function(){return this.hd};We.prototype.Tb=function(){return this.ae.Tb(this)};We.prototype.toString=function(){return this.Yb().toString()+":"+this.hd+":"+x(this.Md.be())};function Xe(a,b,c){this.ae=a;this.error=b;this.path=c}Xe.prototype.Yb=function(){return this.path};Xe.prototype.ge=function(){return"cancel"};
Xe.prototype.Tb=function(){return this.ae.Tb(this)};Xe.prototype.toString=function(){return this.path.toString()+":cancel"};function Ye(){this.vb=[]}function Ze(a,b){for(var c=null,d=0;d<b.length;d++){var e=b[d],f=e.Yb();null===c||f.Z(c.Yb())||(a.vb.push(c),c=null);null===c&&(c=new $e(f));c.add(e)}c&&a.vb.push(c)}function af(a,b,c){Ze(a,c);bf(a,function(a){return a.Z(b)})}function cf(a,b,c){Ze(a,c);bf(a,function(a){return a.contains(b)||b.contains(a)})}
function bf(a,b){for(var c=!0,d=0;d<a.vb.length;d++){var e=a.vb[d];if(e)if(e=e.Yb(),b(e)){for(var e=a.vb[d],f=0;f<e.jd.length;f++){var h=e.jd[f];if(null!==h){e.jd[f]=null;var k=h.Tb();Qb&&I("event: "+h.toString());fc(k)}}a.vb[d]=null}else c=!1}c&&(a.vb=[])}function $e(a){this.qa=a;this.jd=[]}$e.prototype.add=function(a){this.jd.push(a)};$e.prototype.Yb=function(){return this.qa};function Qe(a){this.g=a}g=Qe.prototype;g.F=function(a,b,c,d,e,f){D(a.yc(this.g),"A node must be indexed if only a child is updated");e=a.Q(b);if(e.P(d).Z(c.P(d))&&e.e()==c.e())return a;null!=f&&(c.e()?a.Da(b)?df(f,new S(Le,e,b)):D(a.J(),"A child remove without an old child only makes sense on a leaf node"):e.e()?df(f,new S(Me,c,b)):df(f,new S(Ie,c,b,e)));return a.J()&&c.e()?a:a.T(b,c).nb(this.g)};
g.ya=function(a,b,c){null!=c&&(a.J()||a.O(H,function(a,e){b.Da(a)||df(c,new S(Le,e,a))}),b.J()||b.O(H,function(b,e){if(a.Da(b)){var f=a.Q(b);f.Z(e)||df(c,new S(Ie,e,b,f))}else df(c,new S(Me,e,b))}));return b.nb(this.g)};g.fa=function(a,b){return a.e()?L:a.fa(b)};g.Na=function(){return!1};g.Ub=function(){return this};function Se(a){this.he=new Qe(a.g);this.g=a.g;var b;a.ka?(b=ef(a),b=a.g.Ec(ff(a),b)):b=a.g.Hc();this.Uc=b;a.na?(b=gf(a),a=a.g.Ec(hf(a),b)):a=a.g.Fc();this.vc=a}g=Se.prototype;g.matches=function(a){return 0>=this.g.compare(this.Uc,a)&&0>=this.g.compare(a,this.vc)};g.F=function(a,b,c,d,e,f){this.matches(new C(b,c))||(c=L);return this.he.F(a,b,c,d,e,f)};
g.ya=function(a,b,c){b.J()&&(b=L);var d=b.nb(this.g),d=d.fa(L),e=this;b.O(H,function(a,b){e.matches(new C(a,b))||(d=d.T(a,L))});return this.he.ya(a,d,c)};g.fa=function(a){return a};g.Na=function(){return!0};g.Ub=function(){return this.he};function Re(a){this.sa=new Se(a);this.g=a.g;D(a.xa,"Only valid if limit has been set");this.oa=a.oa;this.Ib=!jf(a)}g=Re.prototype;g.F=function(a,b,c,d,e,f){this.sa.matches(new C(b,c))||(c=L);return a.Q(b).Z(c)?a:a.Eb()<this.oa?this.sa.Ub().F(a,b,c,d,e,f):kf(this,a,b,c,e,f)};
g.ya=function(a,b,c){var d;if(b.J()||b.e())d=L.nb(this.g);else if(2*this.oa<b.Eb()&&b.yc(this.g)){d=L.nb(this.g);b=this.Ib?b.Zb(this.sa.vc,this.g):b.Xb(this.sa.Uc,this.g);for(var e=0;0<b.Pa.length&&e<this.oa;){var f=M(b),h;if(h=this.Ib?0>=this.g.compare(this.sa.Uc,f):0>=this.g.compare(f,this.sa.vc))d=d.T(f.name,f.R),e++;else break}}else{d=b.nb(this.g);d=d.fa(L);var k,m,l;if(this.Ib){b=d.We(this.g);k=this.sa.vc;m=this.sa.Uc;var u=nc(this.g);l=function(a,b){return u(b,a)}}else b=d.Wb(this.g),k=this.sa.Uc,
m=this.sa.vc,l=nc(this.g);for(var e=0,z=!1;0<b.Pa.length;)f=M(b),!z&&0>=l(k,f)&&(z=!0),(h=z&&e<this.oa&&0>=l(f,m))?e++:d=d.T(f.name,L)}return this.sa.Ub().ya(a,d,c)};g.fa=function(a){return a};g.Na=function(){return!0};g.Ub=function(){return this.sa.Ub()};
function kf(a,b,c,d,e,f){var h;if(a.Ib){var k=nc(a.g);h=function(a,b){return k(b,a)}}else h=nc(a.g);D(b.Eb()==a.oa,"");var m=new C(c,d),l=a.Ib?pd(b,a.g):qd(b,a.g),u=a.sa.matches(m);if(b.Da(c)){for(var z=b.Q(c),l=e.fe(a.g,l,a.Ib);null!=l&&(l.name==c||b.Da(l.name));)l=e.fe(a.g,l,a.Ib);e=null==l?1:h(l,m);if(u&&!d.e()&&0<=e)return null!=f&&df(f,new S(Ie,d,c,z)),b.T(c,d);null!=f&&df(f,new S(Le,z,c));b=b.T(c,L);return null!=l&&a.sa.matches(l)?(null!=f&&df(f,new S(Me,l.R,l.name)),b.T(l.name,l.R)):b}return d.e()?
b:u&&0<=h(l,m)?(null!=f&&(df(f,new S(Le,l.R,l.name)),df(f,new S(Me,d,c))),b.T(c,d).T(l.name,L)):b};function S(a,b,c,d){this.type=a;this.Ja=b;this.Xa=c;this.qe=d;this.Dd=void 0}function Ee(a){return new S(Ne,a)}var Me="child_added",Le="child_removed",Ie="child_changed",Je="child_moved",Ne="value";function xe(){this.fb={}}
function df(a,b){var c=b.type,d=b.Xa;D(c==Me||c==Ie||c==Le,"Only child changes supported for tracking");D(".priority"!==d,"Only non-priority child changes can be tracked.");var e=w(a.fb,d);if(e){var f=e.type;if(c==Me&&f==Le)a.fb[d]=new S(Ie,b.Ja,d,e.Ja);else if(c==Le&&f==Me)delete a.fb[d];else if(c==Le&&f==Ie)a.fb[d]=new S(Le,e.qe,d);else if(c==Ie&&f==Me)a.fb[d]=new S(Me,b.Ja,d);else if(c==Ie&&f==Ie)a.fb[d]=new S(Ie,b.Ja,d,e.qe);else throw Mb("Illegal combination of changes: "+b+" occurred after "+
e);}else a.fb[d]=b};function lf(){this.Rb=this.na=this.Kb=this.ka=this.xa=!1;this.oa=0;this.mb="";this.dc=null;this.zb="";this.ac=null;this.xb="";this.g=H}var mf=new lf;function jf(a){return""===a.mb?a.ka:"l"===a.mb}function ff(a){D(a.ka,"Only valid if start has been set");return a.dc}function ef(a){D(a.ka,"Only valid if start has been set");return a.Kb?a.zb:"[MIN_NAME]"}function hf(a){D(a.na,"Only valid if end has been set");return a.ac}
function gf(a){D(a.na,"Only valid if end has been set");return a.Rb?a.xb:"[MAX_NAME]"}function nf(a){var b=new lf;b.xa=a.xa;b.oa=a.oa;b.ka=a.ka;b.dc=a.dc;b.Kb=a.Kb;b.zb=a.zb;b.na=a.na;b.ac=a.ac;b.Rb=a.Rb;b.xb=a.xb;b.g=a.g;b.mb=a.mb;return b}g=lf.prototype;g.ne=function(a){var b=nf(this);b.xa=!0;b.oa=a;b.mb="l";return b};g.oe=function(a){var b=nf(this);b.xa=!0;b.oa=a;b.mb="r";return b};g.Nd=function(a,b){var c=nf(this);c.ka=!0;n(a)||(a=null);c.dc=a;null!=b?(c.Kb=!0,c.zb=b):(c.Kb=!1,c.zb="");return c};
g.gd=function(a,b){var c=nf(this);c.na=!0;n(a)||(a=null);c.ac=a;n(b)?(c.Rb=!0,c.xb=b):(c.vg=!1,c.xb="");return c};function of(a,b){var c=nf(a);c.g=b;return c}function pf(a){var b={};a.ka&&(b.sp=a.dc,a.Kb&&(b.sn=a.zb));a.na&&(b.ep=a.ac,a.Rb&&(b.en=a.xb));if(a.xa){b.l=a.oa;var c=a.mb;""===c&&(c=jf(a)?"l":"r");b.vf=c}a.g!==H&&(b.i=a.g.toString());return b}function T(a){return!(a.ka||a.na||a.xa)}function qf(a){return T(a)&&a.g==H}
function rf(a){var b={};if(qf(a))return b;var c;a.g===H?c="$priority":a.g===wc?c="$value":a.g===tc?c="$key":(D(a.g instanceof pc,"Unrecognized index type!"),c=a.g.toString());b.orderBy=x(c);a.ka&&(b.startAt=x(a.dc),a.Kb&&(b.startAt+=","+x(a.zb)));a.na&&(b.endAt=x(a.ac),a.Rb&&(b.endAt+=","+x(a.xb)));a.xa&&(jf(a)?b.limitToFirst=a.oa:b.limitToLast=a.oa);return b}g.toString=function(){return x(pf(this))};function sf(a){this.W=a}var tf=new sf(new vd(null));function uf(a,b,c){if(b.e())return new sf(new vd(c));var d=zd(a.W,b);if(null!=d){var e=d.path,d=d.value;b=P(e,b);d=d.F(b,c);return new sf(a.W.set(e,d))}a=Ad(a.W,b,new vd(c));return new sf(a)}function vf(a,b,c){var d=a;fb(c,function(a,c){d=uf(d,b.n(a),c)});return d}sf.prototype.Ed=function(a){if(a.e())return tf;a=Ad(this.W,a,R);return new sf(a)};function wf(a,b){var c=zd(a.W,b);return null!=c?a.W.get(c.path).P(P(c.path,b)):null}
function xf(a){var b=[],c=a.W.value;null!=c?c.J()||c.O(H,function(a,c){b.push(new C(a,c))}):a.W.children.ha(function(a,c){null!=c.value&&b.push(new C(a,c.value))});return b}function yf(a,b){if(b.e())return a;var c=wf(a,b);return null!=c?new sf(new vd(c)):new sf(a.W.subtree(b))}sf.prototype.e=function(){return this.W.e()};sf.prototype.apply=function(a){return zf(Q,this.W,a)};
function zf(a,b,c){if(null!=b.value)return c.F(a,b.value);var d=null;b.children.ha(function(b,f){".priority"===b?(D(null!==f.value,"Priority writes must always be leaf nodes"),d=f.value):c=zf(a.n(b),f,c)});c.P(a).e()||null===d||(c=c.F(a.n(".priority"),d));return c};function Af(){this.Jd=L}Af.prototype.j=function(a){return this.Jd.P(a)};Af.prototype.toString=function(){return this.Jd.toString()};function Bf(a){this.oc=a}Bf.prototype.getToken=function(a){return this.oc.INTERNAL.getToken(a).then(null,function(a){return a&&"auth/token-not-initialized"===a.code?(I("Got auth/token-not-initialized error.  Treating as null token."),null):Promise.reject(a)})};function Cf(a,b){a.oc.INTERNAL.addAuthTokenListener(b)};function Df(){this.S=tf;this.la=[];this.Bc=-1}function Ef(a,b){for(var c=0;c<a.la.length;c++){var d=a.la[c];if(d.Zc===b)return d}return null}g=Df.prototype;
g.Ed=function(a){var b=Ea(this.la,function(b){return b.Zc===a});D(0<=b,"removeWrite called with nonexistent writeId.");var c=this.la[b];this.la.splice(b,1);for(var d=c.visible,e=!1,f=this.la.length-1;d&&0<=f;){var h=this.la[f];h.visible&&(f>=b&&Ff(h,c.path)?d=!1:c.path.contains(h.path)&&(e=!0));f--}if(d){if(e)this.S=Gf(this.la,Hf,Q),this.Bc=0<this.la.length?this.la[this.la.length-1].Zc:-1;else if(c.Ga)this.S=this.S.Ed(c.path);else{var k=this;v(c.children,function(a,b){k.S=k.S.Ed(c.path.n(b))})}return!0}return!1};
g.Aa=function(a,b,c,d){if(c||d){var e=yf(this.S,a);return!d&&e.e()?b:d||null!=b||null!=wf(e,Q)?(e=Gf(this.la,function(b){return(b.visible||d)&&(!c||!(0<=xa(c,b.Zc)))&&(b.path.contains(a)||a.contains(b.path))},a),b=b||L,e.apply(b)):null}e=wf(this.S,a);if(null!=e)return e;e=yf(this.S,a);return e.e()?b:null!=b||null!=wf(e,Q)?(b=b||L,e.apply(b)):null};
g.rc=function(a,b){var c=L,d=wf(this.S,a);if(d)d.J()||d.O(H,function(a,b){c=c.T(a,b)});else if(b){var e=yf(this.S,a);b.O(H,function(a,b){var d=yf(e,new E(a)).apply(b);c=c.T(a,d)});ya(xf(e),function(a){c=c.T(a.name,a.R)})}else e=yf(this.S,a),ya(xf(e),function(a){c=c.T(a.name,a.R)});return c};g.ad=function(a,b,c,d){D(c||d,"Either existingEventSnap or existingServerSnap must exist");a=a.n(b);if(null!=wf(this.S,a))return null;a=yf(this.S,a);return a.e()?d.P(b):a.apply(d.P(b))};
g.qc=function(a,b,c){a=a.n(b);var d=wf(this.S,a);return null!=d?d:ne(c,b)?yf(this.S,a).apply(c.j().Q(b)):null};g.lc=function(a){return wf(this.S,a)};g.Xd=function(a,b,c,d,e,f){var h;a=yf(this.S,a);h=wf(a,Q);if(null==h)if(null!=b)h=a.apply(b);else return[];h=h.nb(f);if(h.e()||h.J())return[];b=[];a=nc(f);e=e?h.Zb(c,f):h.Xb(c,f);for(f=M(e);f&&b.length<d;)0!==a(f,c)&&b.push(f),f=M(e);return b};
function Ff(a,b){return a.Ga?a.path.contains(b):!!Qa(a.children,function(c,d){return a.path.n(d).contains(b)})}function Hf(a){return a.visible}
function Gf(a,b,c){for(var d=tf,e=0;e<a.length;++e){var f=a[e];if(b(f)){var h=f.path;if(f.Ga)c.contains(h)?(h=P(c,h),d=uf(d,h,f.Ga)):h.contains(c)&&(h=P(h,c),d=uf(d,Q,f.Ga.P(h)));else if(f.children)if(c.contains(h))h=P(c,h),d=vf(d,h,f.children);else{if(h.contains(c))if(h=P(h,c),h.e())d=vf(d,Q,f.children);else if(f=w(f.children,K(h)))f=f.P(N(h)),d=uf(d,Q,f)}else throw Mb("WriteRecord should have .snap or .children");}}return d}function If(a,b){this.Lb=a;this.W=b}g=If.prototype;
g.Aa=function(a,b,c){return this.W.Aa(this.Lb,a,b,c)};g.rc=function(a){return this.W.rc(this.Lb,a)};g.ad=function(a,b,c){return this.W.ad(this.Lb,a,b,c)};g.lc=function(a){return this.W.lc(this.Lb.n(a))};g.Xd=function(a,b,c,d,e){return this.W.Xd(this.Lb,a,b,c,d,e)};g.qc=function(a,b){return this.W.qc(this.Lb,a,b)};g.n=function(a){return new If(this.Lb.n(a),this.W)};function Jf(a,b){this.rf={};this.Vc=new Kf(a);this.va=b;var c=1E4+2E4*Math.random();hc(q(this.lf,this),Math.floor(c))}Jf.prototype.lf=function(){var a=this.Vc.get(),b={},c=!1,d;for(d in a)0<a[d]&&eb(this.rf,d)&&(b[d]=a[d],c=!0);c&&this.va.ye(b);hc(q(this.lf,this),Math.floor(6E5*Math.random()))};function Lf(){this.tc={}}function Mf(a,b,c){n(c)||(c=1);eb(a.tc,b)||(a.tc[b]=0);a.tc[b]+=c}Lf.prototype.get=function(){return Ta(this.tc)};function Kf(a){this.Ef=a;this.rd=null}Kf.prototype.get=function(){var a=this.Ef.get(),b=Ta(a);if(this.rd)for(var c in this.rd)b[c]-=this.rd[c];this.rd=a;return b};var Nf={},Of={};function Pf(a){a=a.toString();Nf[a]||(Nf[a]=new Lf);return Nf[a]}function Qf(a,b){var c=a.toString();Of[c]||(Of[c]=b());return Of[c]};function Rf(a,b,c){this.f=Tb("p:rest:");this.L=a;this.Gb=b;this.$c=c;this.$={}}function Sf(a,b){if(n(b))return"tag$"+b;D(qf(a.m),"should have a tag if it's not a default query.");return a.path.toString()}g=Rf.prototype;
g.$e=function(a,b,c,d){var e=a.path.toString();this.f("Listen called for "+e+" "+a.ja());var f=Sf(a,c),h={};this.$[f]=h;a=rf(a.m);var k=this;Tf(this,e+".json",a,function(a,b){var u=b;404===a&&(a=u=null);null===a&&k.Gb(e,u,!1,c);w(k.$,f)===h&&d(a?401==a?"permission_denied":"rest_error:"+a:"ok",null)})};g.uf=function(a,b){var c=Sf(a,b);delete this.$[c]};g.kf=function(){};g.re=function(){};g.cf=function(){};g.xd=function(){};g.put=function(){};g.af=function(){};g.ye=function(){};
function Tf(a,b,c,d){c=c||{};c.format="export";a.$c.getToken(!1).then(function(e){(e=e&&e.accessToken)&&(c.auth=e);var f=(a.L.Sc?"https://":"http://")+a.L.host+b+"?"+gb(c);a.f("Sending REST request for "+f);var h=new XMLHttpRequest;h.onreadystatechange=function(){if(d&&4===h.readyState){a.f("REST Response for "+f+" received. status:",h.status,"response:",h.responseText);var b=null;if(200<=h.status&&300>h.status){try{b=lb(h.responseText)}catch(c){J("Failed to parse JSON response for "+f+": "+h.responseText)}d(null,
b)}else 401!==h.status&&404!==h.status&&J("Got unsuccessful REST response for "+f+" Status: "+h.status),d(h.status);d=null}};h.open("GET",f,!0);h.send()})};function Uf(a){this.te=a;this.Bd=[];this.Qb=0;this.Yd=-1;this.Fb=null}function Vf(a,b,c){a.Yd=b;a.Fb=c;a.Yd<a.Qb&&(a.Fb(),a.Fb=null)}function Wf(a,b,c){for(a.Bd[b]=c;a.Bd[a.Qb];){var d=a.Bd[a.Qb];delete a.Bd[a.Qb];for(var e=0;e<d.length;++e)if(d[e]){var f=a;fc(function(){f.te(d[e])})}if(a.Qb===a.Yd){a.Fb&&(clearTimeout(a.Fb),a.Fb(),a.Fb=null);break}a.Qb++}};var Cb="websocket",Db="long_polling";var Xf=null;"undefined"!==typeof MozWebSocket?Xf=MozWebSocket:"undefined"!==typeof WebSocket&&(Xf=WebSocket);function Yf(a,b,c,d){this.Zd=a;this.f=Tb(this.Zd);this.frames=this.zc=null;this.pb=this.qb=this.Fe=0;this.Va=Pf(b);a={v:"5"};"undefined"!==typeof location&&location.href&&-1!==location.href.indexOf("firebaseio.com")&&(a.r="f");c&&(a.s=c);d&&(a.ls=d);this.Ke=Bb(b,Cb,a)}var Zf;
Yf.prototype.open=function(a,b){this.ib=b;this.Xf=a;this.f("Websocket connecting to "+this.Ke);this.wc=!1;xb.set("previous_websocket_failure",!0);try{this.Ia=new Xf(this.Ke)}catch(c){this.f("Error instantiating WebSocket.");var d=c.message||c.data;d&&this.f(d);this.bb();return}var e=this;this.Ia.onopen=function(){e.f("Websocket connected.");e.wc=!0};this.Ia.onclose=function(){e.f("Websocket connection was disconnected.");e.Ia=null;e.bb()};this.Ia.onmessage=function(a){if(null!==e.Ia)if(a=a.data,e.pb+=
a.length,Mf(e.Va,"bytes_received",a.length),$f(e),null!==e.frames)ag(e,a);else{a:{D(null===e.frames,"We already have a frame buffer");if(6>=a.length){var b=Number(a);if(!isNaN(b)){e.Fe=b;e.frames=[];a=null;break a}}e.Fe=1;e.frames=[]}null!==a&&ag(e,a)}};this.Ia.onerror=function(a){e.f("WebSocket error.  Closing connection.");(a=a.message||a.data)&&e.f(a);e.bb()}};Yf.prototype.start=function(){};
Yf.isAvailable=function(){var a=!1;if("undefined"!==typeof navigator&&navigator.userAgent){var b=navigator.userAgent.match(/Android ([0-9]{0,}\.[0-9]{0,})/);b&&1<b.length&&4.4>parseFloat(b[1])&&(a=!0)}return!a&&null!==Xf&&!Zf};Yf.responsesRequiredToBeHealthy=2;Yf.healthyTimeout=3E4;g=Yf.prototype;g.sd=function(){xb.remove("previous_websocket_failure")};function ag(a,b){a.frames.push(b);if(a.frames.length==a.Fe){var c=a.frames.join("");a.frames=null;c=lb(c);a.Xf(c)}}
g.send=function(a){$f(this);a=x(a);this.qb+=a.length;Mf(this.Va,"bytes_sent",a.length);a=bc(a,16384);1<a.length&&bg(this,String(a.length));for(var b=0;b<a.length;b++)bg(this,a[b])};g.Tc=function(){this.Ab=!0;this.zc&&(clearInterval(this.zc),this.zc=null);this.Ia&&(this.Ia.close(),this.Ia=null)};g.bb=function(){this.Ab||(this.f("WebSocket is closing itself"),this.Tc(),this.ib&&(this.ib(this.wc),this.ib=null))};g.close=function(){this.Ab||(this.f("WebSocket is being closed"),this.Tc())};
function $f(a){clearInterval(a.zc);a.zc=setInterval(function(){a.Ia&&bg(a,"0");$f(a)},Math.floor(45E3))}function bg(a,b){try{a.Ia.send(b)}catch(c){a.f("Exception thrown from WebSocket.send():",c.message||c.data,"Closing connection."),setTimeout(q(a.bb,a),0)}};function cg(a,b,c,d){this.Zd=a;this.f=Tb(a);this.jc=b;this.pb=this.qb=0;this.Va=Pf(b);this.tf=c;this.wc=!1;this.Cb=d;this.Yc=function(a){return Bb(b,Db,a)}}var dg,eg;
cg.prototype.open=function(a,b){this.Ne=0;this.ia=b;this.bf=new Uf(a);this.Ab=!1;var c=this;this.sb=setTimeout(function(){c.f("Timed out trying to connect.");c.bb();c.sb=null},Math.floor(3E4));Yb(function(){if(!c.Ab){c.Ta=new fg(function(a,b,d,k,m){gg(c,arguments);if(c.Ta)if(c.sb&&(clearTimeout(c.sb),c.sb=null),c.wc=!0,"start"==a)c.id=b,c.ff=d;else if("close"===a)b?(c.Ta.Kd=!1,Vf(c.bf,b,function(){c.bb()})):c.bb();else throw Error("Unrecognized command received: "+a);},function(a,b){gg(c,arguments);
Wf(c.bf,a,b)},function(){c.bb()},c.Yc);var a={start:"t"};a.ser=Math.floor(1E8*Math.random());c.Ta.Qd&&(a.cb=c.Ta.Qd);a.v="5";c.tf&&(a.s=c.tf);c.Cb&&(a.ls=c.Cb);"undefined"!==typeof location&&location.href&&-1!==location.href.indexOf("firebaseio.com")&&(a.r="f");a=c.Yc(a);c.f("Connecting via long-poll to "+a);hg(c.Ta,a,function(){})}})};
cg.prototype.start=function(){var a=this.Ta,b=this.ff;a.Vf=this.id;a.Wf=b;for(a.Ud=!0;ig(a););a=this.id;b=this.ff;this.fc=document.createElement("iframe");var c={dframe:"t"};c.id=a;c.pw=b;this.fc.src=this.Yc(c);this.fc.style.display="none";document.body.appendChild(this.fc)};
cg.isAvailable=function(){return dg||!eg&&"undefined"!==typeof document&&null!=document.createElement&&!("object"===typeof window&&window.chrome&&window.chrome.extension&&!/^chrome/.test(window.location.href))&&!("object"===typeof Windows&&"object"===typeof Windows.rg)&&!0};g=cg.prototype;g.sd=function(){};g.Tc=function(){this.Ab=!0;this.Ta&&(this.Ta.close(),this.Ta=null);this.fc&&(document.body.removeChild(this.fc),this.fc=null);this.sb&&(clearTimeout(this.sb),this.sb=null)};
g.bb=function(){this.Ab||(this.f("Longpoll is closing itself"),this.Tc(),this.ia&&(this.ia(this.wc),this.ia=null))};g.close=function(){this.Ab||(this.f("Longpoll is being closed."),this.Tc())};g.send=function(a){a=x(a);this.qb+=a.length;Mf(this.Va,"bytes_sent",a.length);a=mb(a);a=ab(a,!0);a=bc(a,1840);for(var b=0;b<a.length;b++){var c=this.Ta;c.Qc.push({jg:this.Ne,pg:a.length,Pe:a[b]});c.Ud&&ig(c);this.Ne++}};function gg(a,b){var c=x(b).length;a.pb+=c;Mf(a.Va,"bytes_received",c)}
function fg(a,b,c,d){this.Yc=d;this.ib=c;this.ve=new Gc;this.Qc=[];this.$d=Math.floor(1E8*Math.random());this.Kd=!0;this.Qd=Lb();window["pLPCommand"+this.Qd]=a;window["pRTLPCB"+this.Qd]=b;a=document.createElement("iframe");a.style.display="none";if(document.body){document.body.appendChild(a);try{a.contentWindow.document||I("No IE domain setting required")}catch(e){a.src="javascript:void((function(){document.open();document.domain='"+document.domain+"';document.close();})())"}}else throw"Document body has not initialized. Wait to initialize Firebase until after the document is ready.";
a.contentDocument?a.gb=a.contentDocument:a.contentWindow?a.gb=a.contentWindow.document:a.document&&(a.gb=a.document);this.Ea=a;a="";this.Ea.src&&"javascript:"===this.Ea.src.substr(0,11)&&(a='<script>document.domain="'+document.domain+'";\x3c/script>');a="<html><body>"+a+"</body></html>";try{this.Ea.gb.open(),this.Ea.gb.write(a),this.Ea.gb.close()}catch(f){I("frame writing exception"),f.stack&&I(f.stack),I(f)}}
fg.prototype.close=function(){this.Ud=!1;if(this.Ea){this.Ea.gb.body.innerHTML="";var a=this;setTimeout(function(){null!==a.Ea&&(document.body.removeChild(a.Ea),a.Ea=null)},Math.floor(0))}var b=this.ib;b&&(this.ib=null,b())};
function ig(a){if(a.Ud&&a.Kd&&a.ve.count()<(0<a.Qc.length?2:1)){a.$d++;var b={};b.id=a.Vf;b.pw=a.Wf;b.ser=a.$d;for(var b=a.Yc(b),c="",d=0;0<a.Qc.length;)if(1870>=a.Qc[0].Pe.length+30+c.length){var e=a.Qc.shift(),c=c+"&seg"+d+"="+e.jg+"&ts"+d+"="+e.pg+"&d"+d+"="+e.Pe;d++}else break;jg(a,b+c,a.$d);return!0}return!1}function jg(a,b,c){function d(){a.ve.remove(c);ig(a)}a.ve.add(c,1);var e=setTimeout(d,Math.floor(25E3));hg(a,b,function(){clearTimeout(e);d()})}
function hg(a,b,c){setTimeout(function(){try{if(a.Kd){var d=a.Ea.gb.createElement("script");d.type="text/javascript";d.async=!0;d.src=b;d.onload=d.onreadystatechange=function(){var a=d.readyState;a&&"loaded"!==a&&"complete"!==a||(d.onload=d.onreadystatechange=null,d.parentNode&&d.parentNode.removeChild(d),c())};d.onerror=function(){I("Long-poll script failed to load: "+b);a.Kd=!1;a.close()};a.Ea.gb.body.appendChild(d)}}catch(e){}},Math.floor(1))};function kg(a){lg(this,a)}var mg=[cg,Yf];function lg(a,b){var c=Yf&&Yf.isAvailable(),d=c&&!(xb.Ze||!0===xb.get("previous_websocket_failure"));b.qg&&(c||J("wss:// URL used, but browser isn't known to support websockets.  Trying anyway."),d=!0);if(d)a.Wc=[Yf];else{var e=a.Wc=[];cc(mg,function(a,b){b&&b.isAvailable()&&e.push(b)})}}function ng(a){if(0<a.Wc.length)return a.Wc[0];throw Error("No transports available");};function og(a,b,c,d,e,f,h){this.id=a;this.f=Tb("c:"+this.id+":");this.te=c;this.Lc=d;this.ia=e;this.se=f;this.L=b;this.Ad=[];this.Le=0;this.sf=new kg(b);this.Ua=0;this.Cb=h;this.f("Connection created");pg(this)}
function pg(a){var b=ng(a.sf);a.I=new b("c:"+a.id+":"+a.Le++,a.L,void 0,a.Cb);a.xe=b.responsesRequiredToBeHealthy||0;var c=qg(a,a.I),d=rg(a,a.I);a.Xc=a.I;a.Rc=a.I;a.D=null;a.Bb=!1;setTimeout(function(){a.I&&a.I.open(c,d)},Math.floor(0));b=b.healthyTimeout||0;0<b&&(a.md=hc(function(){a.md=null;a.Bb||(a.I&&102400<a.I.pb?(a.f("Connection exceeded healthy timeout but has received "+a.I.pb+" bytes.  Marking connection healthy."),a.Bb=!0,a.I.sd()):a.I&&10240<a.I.qb?a.f("Connection exceeded healthy timeout but has sent "+
a.I.qb+" bytes.  Leaving connection alive."):(a.f("Closing unhealthy connection after timeout."),a.close()))},Math.floor(b)))}function rg(a,b){return function(c){b===a.I?(a.I=null,c||0!==a.Ua?1===a.Ua&&a.f("Realtime connection lost."):(a.f("Realtime connection failed."),"s-"===a.L.$a.substr(0,2)&&(xb.remove("host:"+a.L.host),a.L.$a=a.L.host)),a.close()):b===a.D?(a.f("Secondary connection lost."),c=a.D,a.D=null,a.Xc!==c&&a.Rc!==c||a.close()):a.f("closing an old connection")}}
function qg(a,b){return function(c){if(2!=a.Ua)if(b===a.Rc){var d=$b("t",c);c=$b("d",c);if("c"==d){if(d=$b("t",c),"d"in c)if(c=c.d,"h"===d){var d=c.ts,e=c.v,f=c.h;a.qf=c.s;Ab(a.L,f);0==a.Ua&&(a.I.start(),sg(a,a.I,d),"5"!==e&&J("Protocol version mismatch detected"),c=a.sf,(c=1<c.Wc.length?c.Wc[1]:null)&&tg(a,c))}else if("n"===d){a.f("recvd end transmission on primary");a.Rc=a.D;for(c=0;c<a.Ad.length;++c)a.wd(a.Ad[c]);a.Ad=[];ug(a)}else"s"===d?(a.f("Connection shutdown command received. Shutting down..."),
a.se&&(a.se(c),a.se=null),a.ia=null,a.close()):"r"===d?(a.f("Reset packet received.  New host: "+c),Ab(a.L,c),1===a.Ua?a.close():(vg(a),pg(a))):"e"===d?Ub("Server Error: "+c):"o"===d?(a.f("got pong on primary."),wg(a),xg(a)):Ub("Unknown control packet command: "+d)}else"d"==d&&a.wd(c)}else if(b===a.D)if(d=$b("t",c),c=$b("d",c),"c"==d)"t"in c&&(c=c.t,"a"===c?yg(a):"r"===c?(a.f("Got a reset on secondary, closing it"),a.D.close(),a.Xc!==a.D&&a.Rc!==a.D||a.close()):"o"===c&&(a.f("got pong on secondary."),
a.pf--,yg(a)));else if("d"==d)a.Ad.push(c);else throw Error("Unknown protocol layer: "+d);else a.f("message on old connection")}}og.prototype.ua=function(a){zg(this,{t:"d",d:a})};function ug(a){a.Xc===a.D&&a.Rc===a.D&&(a.f("cleaning up and promoting a connection: "+a.D.Zd),a.I=a.D,a.D=null)}
function yg(a){0>=a.pf?(a.f("Secondary connection is healthy."),a.Bb=!0,a.D.sd(),a.D.start(),a.f("sending client ack on secondary"),a.D.send({t:"c",d:{t:"a",d:{}}}),a.f("Ending transmission on primary"),a.I.send({t:"c",d:{t:"n",d:{}}}),a.Xc=a.D,ug(a)):(a.f("sending ping on secondary."),a.D.send({t:"c",d:{t:"p",d:{}}}))}og.prototype.wd=function(a){wg(this);this.te(a)};function wg(a){a.Bb||(a.xe--,0>=a.xe&&(a.f("Primary connection is healthy."),a.Bb=!0,a.I.sd()))}
function tg(a,b){a.D=new b("c:"+a.id+":"+a.Le++,a.L,a.qf);a.pf=b.responsesRequiredToBeHealthy||0;a.D.open(qg(a,a.D),rg(a,a.D));hc(function(){a.D&&(a.f("Timed out trying to upgrade."),a.D.close())},Math.floor(6E4))}function sg(a,b,c){a.f("Realtime connection established.");a.I=b;a.Ua=1;a.Lc&&(a.Lc(c,a.qf),a.Lc=null);0===a.xe?(a.f("Primary connection is healthy."),a.Bb=!0):hc(function(){xg(a)},Math.floor(5E3))}
function xg(a){a.Bb||1!==a.Ua||(a.f("sending ping on primary."),zg(a,{t:"c",d:{t:"p",d:{}}}))}function zg(a,b){if(1!==a.Ua)throw"Connection is not connected";a.Xc.send(b)}og.prototype.close=function(){2!==this.Ua&&(this.f("Closing realtime connection."),this.Ua=2,vg(this),this.ia&&(this.ia(),this.ia=null))};function vg(a){a.f("Shutting down all connections");a.I&&(a.I.close(),a.I=null);a.D&&(a.D.close(),a.D=null);a.md&&(clearTimeout(a.md),a.md=null)};function Ag(a,b,c,d,e,f){this.id=Bg++;this.f=Tb("p:"+this.id+":");this.qd={};this.$={};this.pa=[];this.Oc=0;this.Kc=[];this.ma=!1;this.Sa=1E3;this.td=3E5;this.Gb=b;this.Jc=c;this.ue=d;this.L=a;this.ob=this.Fa=this.Cb=this.ze=null;this.$c=e;this.de=!1;this.ke=0;if(f)throw Error("Auth override specified in options, but not supported on non Node.js platforms");this.Vd=f;this.ub=null;this.Mb=!1;this.Gd={};this.ig=0;this.Re=!0;this.Ac=this.me=null;Cg(this,0);Mc.Vb().gc("visible",this.Zf,this);-1===a.host.indexOf("fblocal")&&
Lc.Vb().gc("online",this.Yf,this)}var Bg=0,Dg=0;g=Ag.prototype;g.ua=function(a,b,c){var d=++this.ig;a={r:d,a:a,b:b};this.f(x(a));D(this.ma,"sendRequest call when we're not connected not allowed.");this.Fa.ua(a);c&&(this.Gd[d]=c)};
g.$e=function(a,b,c,d){var e=a.ja(),f=a.path.toString();this.f("Listen called for "+f+" "+e);this.$[f]=this.$[f]||{};D(qf(a.m)||!T(a.m),"listen() called for non-default but complete query");D(!this.$[f][e],"listen() called twice for same path/queryId.");a={G:d,ld:b,eg:a,tag:c};this.$[f][e]=a;this.ma&&Eg(this,a)};
function Eg(a,b){var c=b.eg,d=c.path.toString(),e=c.ja();a.f("Listen on "+d+" for "+e);var f={p:d};b.tag&&(f.q=pf(c.m),f.t=b.tag);f.h=b.ld();a.ua("q",f,function(f){var k=f.d,m=f.s;if(k&&"object"===typeof k&&eb(k,"w")){var l=w(k,"w");ea(l)&&0<=xa(l,"no_index")&&J("Using an unspecified index. Consider adding "+('".indexOn": "'+c.m.g.toString()+'"')+" at "+c.path.toString()+" to your security rules for better performance")}(a.$[d]&&a.$[d][e])===b&&(a.f("listen response",f),"ok"!==m&&Fg(a,d,e),b.G&&b.G(m,
k))})}g.kf=function(a){this.ob=a;this.f("Auth token refreshed");this.ob?Gg(this):this.ma&&this.ua("unauth",{},function(){});if(a&&40===a.length||kc(a))this.f("Admin auth credential detected.  Reducing max reconnect time."),this.td=3E4};function Gg(a){if(a.ma&&a.ob){var b=a.ob,c=jc(b)?"auth":"gauth",d={cred:b};null===a.Vd?d.noauth=!0:"object"===typeof a.Vd&&(d.authvar=a.Vd);a.ua(c,d,function(c){var d=c.s;c=c.d||"error";a.ob===b&&("ok"===d?a.ke=0:Hg(a,d,c))})}}
g.uf=function(a,b){var c=a.path.toString(),d=a.ja();this.f("Unlisten called for "+c+" "+d);D(qf(a.m)||!T(a.m),"unlisten() called for non-default but complete query");if(Fg(this,c,d)&&this.ma){var e=pf(a.m);this.f("Unlisten on "+c+" for "+d);c={p:c};b&&(c.q=e,c.t=b);this.ua("n",c)}};g.re=function(a,b,c){this.ma?Ig(this,"o",a,b,c):this.Kc.push({we:a,action:"o",data:b,G:c})};g.cf=function(a,b,c){this.ma?Ig(this,"om",a,b,c):this.Kc.push({we:a,action:"om",data:b,G:c})};
g.xd=function(a,b){this.ma?Ig(this,"oc",a,null,b):this.Kc.push({we:a,action:"oc",data:null,G:b})};function Ig(a,b,c,d,e){c={p:c,d:d};a.f("onDisconnect "+b,c);a.ua(b,c,function(a){e&&setTimeout(function(){e(a.s,a.d)},Math.floor(0))})}g.put=function(a,b,c,d){Jg(this,"p",a,b,c,d)};g.af=function(a,b,c,d){Jg(this,"m",a,b,c,d)};function Jg(a,b,c,d,e,f){d={p:c,d:d};n(f)&&(d.h=f);a.pa.push({action:b,mf:d,G:e});a.Oc++;b=a.pa.length-1;a.ma?Kg(a,b):a.f("Buffering put: "+c)}
function Kg(a,b){var c=a.pa[b].action,d=a.pa[b].mf,e=a.pa[b].G;a.pa[b].fg=a.ma;a.ua(c,d,function(d){a.f(c+" response",d);delete a.pa[b];a.Oc--;0===a.Oc&&(a.pa=[]);e&&e(d.s,d.d)})}g.ye=function(a){this.ma&&(a={c:a},this.f("reportStats",a),this.ua("s",a,function(a){"ok"!==a.s&&this.f("reportStats","Error sending stats: "+a.d)}))};
g.wd=function(a){if("r"in a){this.f("from server: "+x(a));var b=a.r,c=this.Gd[b];c&&(delete this.Gd[b],c(a.b))}else{if("error"in a)throw"A server-side error has occurred: "+a.error;"a"in a&&(b=a.a,a=a.b,this.f("handleServerMessage",b,a),"d"===b?this.Gb(a.p,a.d,!1,a.t):"m"===b?this.Gb(a.p,a.d,!0,a.t):"c"===b?Lg(this,a.p,a.q):"ac"===b?Hg(this,a.s,a.d):"sd"===b?this.ze?this.ze(a):"msg"in a&&"undefined"!==typeof console&&console.log("FIREBASE: "+a.msg.replace("\n","\nFIREBASE: ")):Ub("Unrecognized action received from server: "+
x(b)+"\nAre you using the latest client?"))}};g.Lc=function(a,b){this.f("connection ready");this.ma=!0;this.Ac=(new Date).getTime();this.ue({serverTimeOffset:a-(new Date).getTime()});this.Cb=b;if(this.Re){var c={};c["sdk.js."+firebase.SDK_VERSION.replace(/\./g,"-")]=1;pb()?c["framework.cordova"]=1:"object"===typeof navigator&&"ReactNative"===navigator.product&&(c["framework.reactnative"]=1);this.ye(c)}Mg(this);this.Re=!1;this.Jc(!0)};
function Cg(a,b){D(!a.Fa,"Scheduling a connect when we're already connected/ing?");a.ub&&clearTimeout(a.ub);a.ub=setTimeout(function(){a.ub=null;Ng(a)},Math.floor(b))}g.Zf=function(a){a&&!this.Mb&&this.Sa===this.td&&(this.f("Window became visible.  Reducing delay."),this.Sa=1E3,this.Fa||Cg(this,0));this.Mb=a};g.Yf=function(a){a?(this.f("Browser went online."),this.Sa=1E3,this.Fa||Cg(this,0)):(this.f("Browser went offline.  Killing connection."),this.Fa&&this.Fa.close())};
g.df=function(){this.f("data client disconnected");this.ma=!1;this.Fa=null;for(var a=0;a<this.pa.length;a++){var b=this.pa[a];b&&"h"in b.mf&&b.fg&&(b.G&&b.G("disconnect"),delete this.pa[a],this.Oc--)}0===this.Oc&&(this.pa=[]);this.Gd={};Og(this)&&(this.Mb?this.Ac&&(3E4<(new Date).getTime()-this.Ac&&(this.Sa=1E3),this.Ac=null):(this.f("Window isn't visible.  Delaying reconnect."),this.Sa=this.td,this.me=(new Date).getTime()),a=Math.max(0,this.Sa-((new Date).getTime()-this.me)),a*=Math.random(),this.f("Trying to reconnect in "+
a+"ms"),Cg(this,a),this.Sa=Math.min(this.td,1.3*this.Sa));this.Jc(!1)};
function Ng(a){if(Og(a)){a.f("Making a connection attempt");a.me=(new Date).getTime();a.Ac=null;var b=q(a.wd,a),c=q(a.Lc,a),d=q(a.df,a),e=a.id+":"+Dg++,f=a.Cb,h=!1,k=null,m=function(){k?k.close():(h=!0,d())};a.Fa={close:m,ua:function(a){D(k,"sendRequest call when we're not connected not allowed.");k.ua(a)}};var l=a.de;a.de=!1;a.$c.getToken(l).then(function(l){h?I("getToken() completed but was canceled"):(I("getToken() completed. Creating connection."),a.ob=l&&l.accessToken,k=new og(e,a.L,b,c,d,function(b){J(b+
" ("+a.L.toString()+")");a.ab("server_kill")},f))}).then(null,function(b){a.f("Failed to get token: "+b);h||m()})}}g.ab=function(a){I("Interrupting connection for reason: "+a);this.qd[a]=!0;this.Fa?this.Fa.close():(this.ub&&(clearTimeout(this.ub),this.ub=null),this.ma&&this.df())};g.kc=function(a){I("Resuming connection for reason: "+a);delete this.qd[a];Sa(this.qd)&&(this.Sa=1E3,this.Fa||Cg(this,0))};
function Lg(a,b,c){c=c?Aa(c,function(a){return ac(a)}).join("$"):"default";(a=Fg(a,b,c))&&a.G&&a.G("permission_denied")}function Fg(a,b,c){b=(new E(b)).toString();var d;n(a.$[b])?(d=a.$[b][c],delete a.$[b][c],0===La(a.$[b])&&delete a.$[b]):d=void 0;return d}
function Hg(a,b,c){I("Auth token revoked: "+b+"/"+c);a.ob=null;a.de=!0;a.Fa.close();if("invalid_token"===b||"permission_denied"===b)a.ke++,3<=a.ke&&(a.Sa=3E4,a=a.$c,b='Provided authentication credentials for the app named "'+a.oc.name+'" are invalid. This usually indicates your app was not initialized correctly. ',b="credential"in a.oc.options?b+'Make sure the "credential" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.':"serviceAccount"in
a.oc.options?b+'Make sure the "serviceAccount" property provided to initializeApp() is authorized to access the specified "databaseURL" and is from the correct project.':b+'Make sure the "apiKey" and "databaseURL" properties provided to initializeApp() match the values provided for your app at https://console.firebase.google.com/.',J(b))}
function Mg(a){Gg(a);v(a.$,function(b){v(b,function(b){Eg(a,b)})});for(var b=0;b<a.pa.length;b++)a.pa[b]&&Kg(a,b);for(;a.Kc.length;)b=a.Kc.shift(),Ig(a,b.action,b.we,b.data,b.G)}function Og(a){var b;b=Lc.Vb().hc;return Sa(a.qd)&&b};function Pg(a){a instanceof Qg||Vb("Don't call new Database() directly - please use firebase.database().");this.ta=a;this.ba=new U(a,Q);this.INTERNAL=new Rg(this)}var Sg={TIMESTAMP:{".sv":"timestamp"}};g=Pg.prototype;g.app=null;g.jf=function(a){Tg(this,"ref");y("database.ref",0,1,arguments.length);return n(a)?this.ba.n(a):this.ba};
g.gg=function(a){Tg(this,"database.refFromURL");y("database.refFromURL",1,1,arguments.length);var b=Wb(a);Xd("database.refFromURL",b);var c=b.jc;c.host!==this.ta.L.host&&Vb("database.refFromURL: Host name does not match the current database: (found "+c.host+" but expected "+this.ta.L.host+")");return this.jf(b.path.toString())};function Tg(a,b){null===a.ta&&Vb("Cannot call "+b+" on a deleted database.")}g.Pf=function(){y("database.goOffline",0,0,arguments.length);Tg(this,"goOffline");this.ta.ab()};
g.Qf=function(){y("database.goOnline",0,0,arguments.length);Tg(this,"goOnline");this.ta.kc()};Object.defineProperty(Pg.prototype,"app",{get:function(){return this.ta.app}});function Rg(a){this.Ya=a}Rg.prototype.delete=function(){Tg(this.Ya,"delete");var a=Ug.Vb(),b=this.Ya.ta;w(a.lb,b.app.name)!==b&&Vb("Database "+b.app.name+" has already been deleted.");b.ab();delete a.lb[b.app.name];this.Ya.ta=null;this.Ya.ba=null;this.Ya=this.Ya.INTERNAL=null;return firebase.Promise.resolve()};
Pg.prototype.ref=Pg.prototype.jf;Pg.prototype.refFromURL=Pg.prototype.gg;Pg.prototype.goOnline=Pg.prototype.Qf;Pg.prototype.goOffline=Pg.prototype.Pf;Rg.prototype["delete"]=Rg.prototype.delete;function V(a,b,c){this.A=a;this.V=b;this.g=c}V.prototype.H=function(){y("Firebase.DataSnapshot.val",0,0,arguments.length);return this.A.H()};V.prototype.val=V.prototype.H;V.prototype.be=function(){y("Firebase.DataSnapshot.exportVal",0,0,arguments.length);return this.A.H(!0)};V.prototype.exportVal=V.prototype.be;V.prototype.toJSON=function(){y("Firebase.DataSnapshot.toJSON",0,1,arguments.length);return this.be()};V.prototype.toJSON=V.prototype.toJSON;
V.prototype.Lf=function(){y("Firebase.DataSnapshot.exists",0,0,arguments.length);return!this.A.e()};V.prototype.exists=V.prototype.Lf;V.prototype.n=function(a){y("Firebase.DataSnapshot.child",0,1,arguments.length);ga(a)&&(a=String(a));Vd("Firebase.DataSnapshot.child",a);var b=new E(a),c=this.V.n(b);return new V(this.A.P(b),c,H)};V.prototype.child=V.prototype.n;
V.prototype.Da=function(a){y("Firebase.DataSnapshot.hasChild",1,1,arguments.length);Vd("Firebase.DataSnapshot.hasChild",a);var b=new E(a);return!this.A.P(b).e()};V.prototype.hasChild=V.prototype.Da;V.prototype.C=function(){y("Firebase.DataSnapshot.getPriority",0,0,arguments.length);return this.A.C().H()};V.prototype.getPriority=V.prototype.C;
V.prototype.forEach=function(a){y("Firebase.DataSnapshot.forEach",1,1,arguments.length);B("Firebase.DataSnapshot.forEach",1,a,!1);if(this.A.J())return!1;var b=this;return!!this.A.O(this.g,function(c,d){return a(new V(d,b.V.n(c),H))})};V.prototype.forEach=V.prototype.forEach;V.prototype.kd=function(){y("Firebase.DataSnapshot.hasChildren",0,0,arguments.length);return this.A.J()?!1:!this.A.e()};V.prototype.hasChildren=V.prototype.kd;
V.prototype.getKey=function(){y("Firebase.DataSnapshot.key",0,0,arguments.length);return this.V.getKey()};gc(V.prototype,"key",V.prototype.getKey);V.prototype.Eb=function(){y("Firebase.DataSnapshot.numChildren",0,0,arguments.length);return this.A.Eb()};V.prototype.numChildren=V.prototype.Eb;V.prototype.wb=function(){y("Firebase.DataSnapshot.ref",0,0,arguments.length);return this.V};gc(V.prototype,"ref",V.prototype.wb);function Vg(a,b,c){this.Pb=a;this.rb=b;this.tb=c||null}g=Vg.prototype;g.nf=function(a){return"value"===a};g.createEvent=function(a,b){var c=b.m.g;return new We("value",this,new V(a.Ja,b.wb(),c))};g.Tb=function(a){var b=this.tb;if("cancel"===a.ge()){D(this.rb,"Raising a cancel event on a listener with no cancel callback");var c=this.rb;return function(){c.call(b,a.error)}}var d=this.Pb;return function(){d.call(b,a.Md)}};g.Me=function(a,b){return this.rb?new Xe(this,a,b):null};
g.matches=function(a){return a instanceof Vg?a.Pb&&this.Pb?a.Pb===this.Pb&&a.tb===this.tb:!0:!1};g.Xe=function(){return null!==this.Pb};function Wg(a,b,c){this.ga=a;this.rb=b;this.tb=c}g=Wg.prototype;g.nf=function(a){a="children_added"===a?"child_added":a;return("children_removed"===a?"child_removed":a)in this.ga};g.Me=function(a,b){return this.rb?new Xe(this,a,b):null};
g.createEvent=function(a,b){D(null!=a.Xa,"Child events should have a childName.");var c=b.wb().n(a.Xa);return new We(a.type,this,new V(a.Ja,c,b.m.g),a.Dd)};g.Tb=function(a){var b=this.tb;if("cancel"===a.ge()){D(this.rb,"Raising a cancel event on a listener with no cancel callback");var c=this.rb;return function(){c.call(b,a.error)}}var d=this.ga[a.hd];return function(){d.call(b,a.Md,a.Dd)}};
g.matches=function(a){if(a instanceof Wg){if(!this.ga||!a.ga)return!0;if(this.tb===a.tb){var b=La(a.ga);if(b===La(this.ga)){if(1===b){var b=Ma(a.ga),c=Ma(this.ga);return c===b&&(!a.ga[b]||!this.ga[c]||a.ga[b]===this.ga[c])}return Ka(this.ga,function(b,c){return a.ga[c]===b})}}}return!1};g.Xe=function(){return null!==this.ga};function Xg(){this.za={}}g=Xg.prototype;g.e=function(){return Sa(this.za)};g.eb=function(a,b,c){var d=a.source.Hb;if(null!==d)return d=w(this.za,d),D(null!=d,"SyncTree gave us an op for an invalid query."),d.eb(a,b,c);var e=[];v(this.za,function(d){e=e.concat(d.eb(a,b,c))});return e};g.Nb=function(a,b,c,d,e){var f=a.ja(),h=w(this.za,f);if(!h){var h=c.Aa(e?d:null),k=!1;h?k=!0:(h=d instanceof O?c.rc(d):L,k=!1);h=new Pe(a,new oe(new je(h,k,!1),new je(d,e,!1)));this.za[f]=h}h.Nb(b);return Ve(h,b)};
g.kb=function(a,b,c){var d=a.ja(),e=[],f=[],h=null!=Yg(this);if("default"===d){var k=this;v(this.za,function(a,d){f=f.concat(a.kb(b,c));a.e()&&(delete k.za[d],T(a.V.m)||e.push(a.V))})}else{var m=w(this.za,d);m&&(f=f.concat(m.kb(b,c)),m.e()&&(delete this.za[d],T(m.V.m)||e.push(m.V)))}h&&null==Yg(this)&&e.push(new U(a.u,a.path));return{hg:e,Kf:f}};function Zg(a){return za(Na(a.za),function(a){return!T(a.V.m)})}g.hb=function(a){var b=null;v(this.za,function(c){b=b||c.hb(a)});return b};
function $g(a,b){if(T(b.m))return Yg(a);var c=b.ja();return w(a.za,c)}function Yg(a){return Ra(a.za,function(a){return T(a.V.m)})||null};function ah(a){this.wa=R;this.jb=new Df;this.De={};this.ic={};this.Cc=a}function bh(a,b,c,d,e){var f=a.jb,h=e;D(d>f.Bc,"Stacking an older write on top of newer ones");n(h)||(h=!0);f.la.push({path:b,Ga:c,Zc:d,visible:h});h&&(f.S=uf(f.S,b,c));f.Bc=d;return e?ch(a,new ce(fe,b,c)):[]}function dh(a,b,c,d){var e=a.jb;D(d>e.Bc,"Stacking an older merge on top of newer ones");e.la.push({path:b,children:c,Zc:d,visible:!0});e.S=vf(e.S,b,c);e.Bc=d;c=xd(c);return ch(a,new ae(fe,b,c))}
function eh(a,b,c){c=c||!1;var d=Ef(a.jb,b);if(a.jb.Ed(b)){var e=R;null!=d.Ga?e=e.set(Q,!0):fb(d.children,function(a,b){e=e.set(new E(a),b)});return ch(a,new de(d.path,e,c))}return[]}function fh(a,b,c){c=xd(c);return ch(a,new ae(ie,b,c))}function gh(a,b,c,d){d=hh(a,d);if(null!=d){var e=ih(d);d=e.path;e=e.Hb;b=P(d,b);c=new ce(new he(!1,!0,e,!0),b,c);return jh(a,d,c)}return[]}
function kh(a,b,c,d){if(d=hh(a,d)){var e=ih(d);d=e.path;e=e.Hb;b=P(d,b);c=xd(c);c=new ae(new he(!1,!0,e,!0),b,c);return jh(a,d,c)}return[]}
ah.prototype.Nb=function(a,b){var c=a.path,d=null,e=!1;Fd(this.wa,c,function(a,b){var f=P(a,c);d=d||b.hb(f);e=e||null!=Yg(b)});var f=this.wa.get(c);f?(e=e||null!=Yg(f),d=d||f.hb(Q)):(f=new Xg,this.wa=this.wa.set(c,f));var h;null!=d?h=!0:(h=!1,d=L,Jd(this.wa.subtree(c),function(a,b){var c=b.hb(Q);c&&(d=d.T(a,c))}));var k=null!=$g(f,a);if(!k&&!T(a.m)){var m=lh(a);D(!(m in this.ic),"View does not exist, but we have a tag");var l=mh++;this.ic[m]=l;this.De["_"+l]=m}h=f.Nb(a,b,new If(c,this.jb),d,h);k||
e||(f=$g(f,a),h=h.concat(nh(this,a,f)));return h};
ah.prototype.kb=function(a,b,c){var d=a.path,e=this.wa.get(d),f=[];if(e&&("default"===a.ja()||null!=$g(e,a))){f=e.kb(a,b,c);e.e()&&(this.wa=this.wa.remove(d));e=f.hg;f=f.Kf;b=-1!==Ea(e,function(a){return T(a.m)});var h=Dd(this.wa,d,function(a,b){return null!=Yg(b)});if(b&&!h&&(d=this.wa.subtree(d),!d.e()))for(var d=oh(d),k=0;k<d.length;++k){var m=d[k],l=m.V,m=ph(this,m);this.Cc.Ae(qh(l),rh(this,l),m.ld,m.G)}if(!h&&0<e.length&&!c)if(b)this.Cc.Od(qh(a),null);else{var u=this;ya(e,function(a){a.ja();
var b=u.ic[lh(a)];u.Cc.Od(qh(a),b)})}sh(this,e)}return f};ah.prototype.Aa=function(a,b){var c=this.jb,d=Dd(this.wa,a,function(b,c){var d=P(b,a);if(d=c.hb(d))return d});return c.Aa(a,d,b,!0)};function oh(a){return Bd(a,function(a,c,d){if(c&&null!=Yg(c))return[Yg(c)];var e=[];c&&(e=Zg(c));v(d,function(a){e=e.concat(a)});return e})}function sh(a,b){for(var c=0;c<b.length;++c){var d=b[c];if(!T(d.m)){var d=lh(d),e=a.ic[d];delete a.ic[d];delete a.De["_"+e]}}}
function qh(a){return T(a.m)&&!qf(a.m)?a.wb():a}function nh(a,b,c){var d=b.path,e=rh(a,b);c=ph(a,c);b=a.Cc.Ae(qh(b),e,c.ld,c.G);d=a.wa.subtree(d);if(e)D(null==Yg(d.value),"If we're adding a query, it shouldn't be shadowed");else for(e=Bd(d,function(a,b,c){if(!a.e()&&b&&null!=Yg(b))return[Te(Yg(b))];var d=[];b&&(d=d.concat(Aa(Zg(b),function(a){return a.V})));v(c,function(a){d=d.concat(a)});return d}),d=0;d<e.length;++d)c=e[d],a.Cc.Od(qh(c),rh(a,c));return b}
function ph(a,b){var c=b.V,d=rh(a,c);return{ld:function(){return(b.w()||L).hash()},G:function(b){if("ok"===b){if(d){var f=c.path;if(b=hh(a,d)){var h=ih(b);b=h.path;h=h.Hb;f=P(b,f);f=new Zd(new he(!1,!0,h,!0),f);b=jh(a,b,f)}else b=[]}else b=ch(a,new Zd(ie,c.path));return b}f="Unknown Error";"too_big"===b?f="The data requested exceeds the maximum size that can be accessed with a single request.":"permission_denied"==b?f="Client doesn't have permission to access the desired data.":"unavailable"==b&&
(f="The service is unavailable");f=Error(b+" at "+c.path.toString()+": "+f);f.code=b.toUpperCase();return a.kb(c,null,f)}}}function lh(a){return a.path.toString()+"$"+a.ja()}function ih(a){var b=a.indexOf("$");D(-1!==b&&b<a.length-1,"Bad queryKey.");return{Hb:a.substr(b+1),path:new E(a.substr(0,b))}}function hh(a,b){var c=a.De,d="_"+b;return d in c?c[d]:void 0}function rh(a,b){var c=lh(b);return w(a.ic,c)}var mh=1;
function jh(a,b,c){var d=a.wa.get(b);D(d,"Missing sync point for query tag that we're tracking");return d.eb(c,new If(b,a.jb),null)}function ch(a,b){return th(a,b,a.wa,null,new If(Q,a.jb))}function th(a,b,c,d,e){if(b.path.e())return uh(a,b,c,d,e);var f=c.get(Q);null==d&&null!=f&&(d=f.hb(Q));var h=[],k=K(b.path),m=b.Mc(k);if((c=c.children.get(k))&&m)var l=d?d.Q(k):null,k=e.n(k),h=h.concat(th(a,m,c,l,k));f&&(h=h.concat(f.eb(b,e,d)));return h}
function uh(a,b,c,d,e){var f=c.get(Q);null==d&&null!=f&&(d=f.hb(Q));var h=[];c.children.ha(function(c,f){var l=d?d.Q(c):null,u=e.n(c),z=b.Mc(c);z&&(h=h.concat(uh(a,z,f,l,u)))});f&&(h=h.concat(f.eb(b,e,d)));return h};function Qg(a,b,c){this.app=c;var d=new Bf(c);this.L=a;this.Va=Pf(a);this.Vc=null;this.ca=new Ye;this.vd=1;this.Ra=null;if(b||0<=("object"===typeof window&&window.navigator&&window.navigator.userAgent||"").search(/googlebot|google webmaster tools|bingbot|yahoo! slurp|baiduspider|yandexbot|duckduckbot/i))this.va=new Rf(this.L,q(this.Gb,this),d),setTimeout(q(this.Jc,this,!0),0);else{b=c.options.databaseAuthVariableOverride;if("undefined"!==da(b)&&null!==b){if("object"!==da(b))throw Error("Only objects are supported for option databaseAuthVariableOverride");
try{x(b)}catch(e){throw Error("Invalid authOverride provided: "+e);}}this.va=this.Ra=new Ag(this.L,q(this.Gb,this),q(this.Jc,this),q(this.ue,this),d,b)}var f=this;Cf(d,function(a){f.va.kf(a)});this.og=Qf(a,q(function(){return new Jf(this.Va,this.va)},this));this.mc=new Tc;this.ie=new Af;this.pd=new ah({Ae:function(a,b,c,d){b=[];c=f.ie.j(a.path);c.e()||(b=ch(f.pd,new ce(ie,a.path,c)),setTimeout(function(){d("ok")},0));return b},Od:ba});vh(this,"connected",!1);this.ia=new Gb;this.Ya=new Pg(this);this.fd=
0;this.je=null;this.K=new ah({Ae:function(a,b,c,d){f.va.$e(a,c,b,function(b,c){var e=d(b,c);cf(f.ca,a.path,e)});return[]},Od:function(a,b){f.va.uf(a,b)}})}g=Qg.prototype;g.toString=function(){return(this.L.Sc?"https://":"http://")+this.L.host};g.name=function(){return this.L.pe};function wh(a){a=a.ie.j(new E(".info/serverTimeOffset")).H()||0;return(new Date).getTime()+a}function xh(a){a=a={timestamp:wh(a)};a.timestamp=a.timestamp||(new Date).getTime();return a}
g.Gb=function(a,b,c,d){this.fd++;var e=new E(a);b=this.je?this.je(a,b):b;a=[];d?c?(b=Ja(b,function(a){return G(a)}),a=kh(this.K,e,b,d)):(b=G(b),a=gh(this.K,e,b,d)):c?(d=Ja(b,function(a){return G(a)}),a=fh(this.K,e,d)):(d=G(b),a=ch(this.K,new ce(ie,e,d)));d=e;0<a.length&&(d=yh(this,e));cf(this.ca,d,a)};g.Jc=function(a){vh(this,"connected",a);!1===a&&zh(this)};g.ue=function(a){var b=this;cc(a,function(a,d){vh(b,d,a)})};
function vh(a,b,c){b=new E("/.info/"+b);c=G(c);var d=a.ie;d.Jd=d.Jd.F(b,c);c=ch(a.pd,new ce(ie,b,c));cf(a.ca,b,c)}g.Jb=function(a,b,c,d){this.f("set",{path:a.toString(),value:b,ug:c});var e=xh(this);b=G(b,c);var e=Jb(b,e),f=this.vd++,e=bh(this.K,a,e,f,!0);Ze(this.ca,e);var h=this;this.va.put(a.toString(),b.H(!0),function(b,c){var e="ok"===b;e||J("set at "+a+" failed: "+b);e=eh(h.K,f,!e);cf(h.ca,a,e);Ah(d,b,c)});e=Bh(this,a);yh(this,e);cf(this.ca,e,[])};
g.update=function(a,b,c){this.f("update",{path:a.toString(),value:b});var d=!0,e=xh(this),f={};v(b,function(a,b){d=!1;var c=G(a);f[b]=Jb(c,e)});if(d)I("update() called with empty data.  Don't do anything."),Ah(c,"ok");else{var h=this.vd++,k=dh(this.K,a,f,h);Ze(this.ca,k);var m=this;this.va.af(a.toString(),b,function(b,d){var e="ok"===b;e||J("update at "+a+" failed: "+b);var e=eh(m.K,h,!e),f=a;0<e.length&&(f=yh(m,a));cf(m.ca,f,e);Ah(c,b,d)});v(b,function(b,c){var d=Bh(m,a.n(c));yh(m,d)});cf(this.ca,
a,[])}};function zh(a){a.f("onDisconnectEvents");var b=xh(a),c=[];Hb(Fb(a.ia,b),Q,function(b,e){c=c.concat(ch(a.K,new ce(ie,b,e)));var f=Bh(a,b);yh(a,f)});a.ia=new Gb;cf(a.ca,Q,c)}g.xd=function(a,b){var c=this;this.va.xd(a.toString(),function(d,e){"ok"===d&&Yd(c.ia,a);Ah(b,d,e)})};function Ch(a,b,c,d){var e=G(c);a.va.re(b.toString(),e.H(!0),function(c,h){"ok"===c&&Ib(a.ia,b,e);Ah(d,c,h)})}
function Dh(a,b,c,d,e){var f=G(c,d);a.va.re(b.toString(),f.H(!0),function(c,d){"ok"===c&&Ib(a.ia,b,f);Ah(e,c,d)})}function Eh(a,b,c,d){var e=!0,f;for(f in c)e=!1;e?(I("onDisconnect().update() called with empty data.  Don't do anything."),Ah(d,"ok")):a.va.cf(b.toString(),c,function(e,f){if("ok"===e)for(var m in c){var l=G(c[m]);Ib(a.ia,b.n(m),l)}Ah(d,e,f)})}function Fh(a,b,c){c=".info"===K(b.path)?a.pd.Nb(b,c):a.K.Nb(b,c);af(a.ca,b.path,c)}g.ab=function(){this.Ra&&this.Ra.ab("repo_interrupt")};
g.kc=function(){this.Ra&&this.Ra.kc("repo_interrupt")};g.Be=function(a){if("undefined"!==typeof console){a?(this.Vc||(this.Vc=new Kf(this.Va)),a=this.Vc.get()):a=this.Va.get();var b=Ba(Oa(a),function(a,b){return Math.max(b.length,a)},0),c;for(c in a){for(var d=a[c],e=c.length;e<b+2;e++)c+=" ";console.log(c+d)}}};g.Ce=function(a){Mf(this.Va,a);this.og.rf[a]=!0};g.f=function(a){var b="";this.Ra&&(b=this.Ra.id+":");I(b,arguments)};
function Ah(a,b,c){a&&fc(function(){if("ok"==b)a(null);else{var d=(b||"error").toUpperCase(),e=d;c&&(e+=": "+c);e=Error(e);e.code=d;a(e)}})};function Gh(a,b,c,d,e){function f(){}a.f("transaction on "+b);var h=new U(a,b);h.gc("value",f);c={path:b,update:c,G:d,status:null,ef:Lb(),He:e,of:0,Rd:function(){h.Ic("value",f)},Td:null,Ba:null,cd:null,dd:null,ed:null};d=a.K.Aa(b,void 0)||L;c.cd=d;d=c.update(d.H());if(n(d)){Pd("transaction failed: Data returned ",d,c.path);c.status=1;e=Uc(a.mc,b);var k=e.Ca()||[];k.push(c);Vc(e,k);"object"===typeof d&&null!==d&&eb(d,".priority")?(k=w(d,".priority"),D(Nd(k),"Invalid priority returned by transaction. Priority must be a valid string, finite number, server value, or null.")):
k=(a.K.Aa(b)||L).C().H();e=xh(a);d=G(d,k);e=Jb(d,e);c.dd=d;c.ed=e;c.Ba=a.vd++;c=bh(a.K,b,e,c.Ba,c.He);cf(a.ca,b,c);Hh(a)}else c.Rd(),c.dd=null,c.ed=null,c.G&&(a=new V(c.cd,new U(a,c.path),H),c.G(null,!1,a))}function Hh(a,b){var c=b||a.mc;b||Ih(a,c);if(null!==c.Ca()){var d=Jh(a,c);D(0<d.length,"Sending zero length transaction queue");Ca(d,function(a){return 1===a.status})&&Kh(a,c.path(),d)}else c.kd()&&c.O(function(b){Hh(a,b)})}
function Kh(a,b,c){for(var d=Aa(c,function(a){return a.Ba}),e=a.K.Aa(b,d)||L,d=e,e=e.hash(),f=0;f<c.length;f++){var h=c[f];D(1===h.status,"tryToSendTransactionQueue_: items in queue should all be run.");h.status=2;h.of++;var k=P(b,h.path),d=d.F(k,h.dd)}d=d.H(!0);a.va.put(b.toString(),d,function(d){a.f("transaction put response",{path:b.toString(),status:d});var e=[];if("ok"===d){d=[];for(f=0;f<c.length;f++){c[f].status=3;e=e.concat(eh(a.K,c[f].Ba));if(c[f].G){var h=c[f].ed,k=new U(a,c[f].path);d.push(q(c[f].G,
null,null,!0,new V(h,k,H)))}c[f].Rd()}Ih(a,Uc(a.mc,b));Hh(a);cf(a.ca,b,e);for(f=0;f<d.length;f++)fc(d[f])}else{if("datastale"===d)for(f=0;f<c.length;f++)c[f].status=4===c[f].status?5:1;else for(J("transaction at "+b.toString()+" failed: "+d),f=0;f<c.length;f++)c[f].status=5,c[f].Td=d;yh(a,b)}},e)}function yh(a,b){var c=Lh(a,b),d=c.path(),c=Jh(a,c);Mh(a,c,d);return d}
function Mh(a,b,c){if(0!==b.length){for(var d=[],e=[],f=za(b,function(a){return 1===a.status}),f=Aa(f,function(a){return a.Ba}),h=0;h<b.length;h++){var k=b[h],m=P(c,k.path),l=!1,u;D(null!==m,"rerunTransactionsUnderNode_: relativePath should not be null.");if(5===k.status)l=!0,u=k.Td,e=e.concat(eh(a.K,k.Ba,!0));else if(1===k.status)if(25<=k.of)l=!0,u="maxretry",e=e.concat(eh(a.K,k.Ba,!0));else{var z=a.K.Aa(k.path,f)||L;k.cd=z;var F=b[h].update(z.H());n(F)?(Pd("transaction failed: Data returned ",F,
k.path),m=G(F),"object"===typeof F&&null!=F&&eb(F,".priority")||(m=m.fa(z.C())),z=k.Ba,F=xh(a),F=Jb(m,F),k.dd=m,k.ed=F,k.Ba=a.vd++,Fa(f,z),e=e.concat(bh(a.K,k.path,F,k.Ba,k.He)),e=e.concat(eh(a.K,z,!0))):(l=!0,u="nodata",e=e.concat(eh(a.K,k.Ba,!0)))}cf(a.ca,c,e);e=[];l&&(b[h].status=3,setTimeout(b[h].Rd,Math.floor(0)),b[h].G&&("nodata"===u?(k=new U(a,b[h].path),d.push(q(b[h].G,null,null,!1,new V(b[h].cd,k,H)))):d.push(q(b[h].G,null,Error(u),!1,null))))}Ih(a,a.mc);for(h=0;h<d.length;h++)fc(d[h]);Hh(a)}}
function Lh(a,b){for(var c,d=a.mc;null!==(c=K(b))&&null===d.Ca();)d=Uc(d,c),b=N(b);return d}function Jh(a,b){var c=[];Nh(a,b,c);c.sort(function(a,b){return a.ef-b.ef});return c}function Nh(a,b,c){var d=b.Ca();if(null!==d)for(var e=0;e<d.length;e++)c.push(d[e]);b.O(function(b){Nh(a,b,c)})}function Ih(a,b){var c=b.Ca();if(c){for(var d=0,e=0;e<c.length;e++)3!==c[e].status&&(c[d]=c[e],d++);c.length=d;Vc(b,0<c.length?c:null)}b.O(function(b){Ih(a,b)})}
function Bh(a,b){var c=Lh(a,b).path(),d=Uc(a.mc,b);Yc(d,function(b){Oh(a,b)});Oh(a,d);Xc(d,function(b){Oh(a,b)});return c}
function Oh(a,b){var c=b.Ca();if(null!==c){for(var d=[],e=[],f=-1,h=0;h<c.length;h++)4!==c[h].status&&(2===c[h].status?(D(f===h-1,"All SENT items should be at beginning of queue."),f=h,c[h].status=4,c[h].Td="set"):(D(1===c[h].status,"Unexpected transaction status in abort"),c[h].Rd(),e=e.concat(eh(a.K,c[h].Ba,!0)),c[h].G&&d.push(q(c[h].G,null,Error("set"),!1,null))));-1===f?Vc(b,null):c.length=f+1;cf(a.ca,b.path(),e);for(h=0;h<d.length;h++)fc(d[h])}};function Ug(){this.lb={};this.wf=!1}Ug.prototype.ab=function(){for(var a in this.lb)this.lb[a].ab()};Ug.prototype.kc=function(){for(var a in this.lb)this.lb[a].kc()};Ug.prototype.ce=function(a){this.wf=a};ca(Ug);Ug.prototype.interrupt=Ug.prototype.ab;Ug.prototype.resume=Ug.prototype.kc;var W={};W.nc=Ag;W.DataConnection=W.nc;Ag.prototype.ng=function(a,b){this.ua("q",{p:a},b)};W.nc.prototype.simpleListen=W.nc.prototype.ng;Ag.prototype.Hf=function(a,b){this.ua("echo",{d:a},b)};W.nc.prototype.echo=W.nc.prototype.Hf;Ag.prototype.interrupt=Ag.prototype.ab;W.zf=og;W.RealTimeConnection=W.zf;og.prototype.sendRequest=og.prototype.ua;og.prototype.close=og.prototype.close;
W.Rf=function(a){var b=Ag.prototype.put;Ag.prototype.put=function(c,d,e,f){n(f)&&(f=a());b.call(this,c,d,e,f)};return function(){Ag.prototype.put=b}};W.hijackHash=W.Rf;W.yf=zb;W.ConnectionTarget=W.yf;W.ja=function(a){return a.ja()};W.queryIdentifier=W.ja;W.Uf=function(a){return a.u.Ra.$};W.listens=W.Uf;W.ce=function(a){Ug.Vb().ce(a)};W.forceRestClient=W.ce;W.Context=Ug;function Ph(a,b){this.committed=a;this.snapshot=b};function X(a,b,c,d){this.u=a;this.path=b;this.m=c;this.Nc=d}
function Qh(a){var b=null,c=null;a.ka&&(b=ff(a));a.na&&(c=hf(a));if(a.g===tc){if(a.ka){if("[MIN_NAME]"!=ef(a))throw Error("Query: When ordering by key, you may only pass one argument to startAt(), endAt(), or equalTo().");if("string"!==typeof b)throw Error("Query: When ordering by key, the argument passed to startAt(), endAt(),or equalTo() must be a string.");}if(a.na){if("[MAX_NAME]"!=gf(a))throw Error("Query: When ordering by key, you may only pass one argument to startAt(), endAt(), or equalTo().");if("string"!==
typeof c)throw Error("Query: When ordering by key, the argument passed to startAt(), endAt(),or equalTo() must be a string.");}}else if(a.g===H){if(null!=b&&!Nd(b)||null!=c&&!Nd(c))throw Error("Query: When ordering by priority, the first argument passed to startAt(), endAt(), or equalTo() must be a valid priority value (null, a number, or a string).");}else if(D(a.g instanceof pc||a.g===wc,"unknown index type."),null!=b&&"object"===typeof b||null!=c&&"object"===typeof c)throw Error("Query: First argument passed to startAt(), endAt(), or equalTo() cannot be an object.");
}function Rh(a){if(a.ka&&a.na&&a.xa&&(!a.xa||""===a.mb))throw Error("Query: Can't combine startAt(), endAt(), and limit(). Use limitToFirst() or limitToLast() instead.");}function Sh(a,b){if(!0===a.Nc)throw Error(b+": You can't combine multiple orderBy calls.");}g=X.prototype;g.wb=function(){y("Query.ref",0,0,arguments.length);return new U(this.u,this.path)};
g.gc=function(a,b,c,d){y("Query.on",2,4,arguments.length);Td("Query.on",a,!1);B("Query.on",2,b,!1);var e=Th("Query.on",c,d);if("value"===a)Fh(this.u,this,new Vg(b,e.cancel||null,e.Ma||null));else{var f={};f[a]=b;Fh(this.u,this,new Wg(f,e.cancel,e.Ma))}return b};
g.Ic=function(a,b,c){y("Query.off",0,3,arguments.length);Td("Query.off",a,!0);B("Query.off",2,b,!0);ob("Query.off",3,c);var d=null,e=null;"value"===a?d=new Vg(b||null,null,c||null):a&&(b&&(e={},e[a]=b),d=new Wg(e,null,c||null));e=this.u;d=".info"===K(this.path)?e.pd.kb(this,d):e.K.kb(this,d);af(e.ca,this.path,d)};
g.$f=function(a,b){function c(k){f&&(f=!1,e.Ic(a,c),b&&b.call(d.Ma,k),h.resolve(k))}y("Query.once",1,4,arguments.length);Td("Query.once",a,!1);B("Query.once",2,b,!0);var d=Th("Query.once",arguments[2],arguments[3]),e=this,f=!0,h=new ib;kb(h.ra);this.gc(a,c,function(b){e.Ic(a,c);d.cancel&&d.cancel.call(d.Ma,b);h.reject(b)});return h.ra};
g.ne=function(a){y("Query.limitToFirst",1,1,arguments.length);if(!ga(a)||Math.floor(a)!==a||0>=a)throw Error("Query.limitToFirst: First argument must be a positive integer.");if(this.m.xa)throw Error("Query.limitToFirst: Limit was already set (by another call to limit, limitToFirst, or limitToLast).");return new X(this.u,this.path,this.m.ne(a),this.Nc)};
g.oe=function(a){y("Query.limitToLast",1,1,arguments.length);if(!ga(a)||Math.floor(a)!==a||0>=a)throw Error("Query.limitToLast: First argument must be a positive integer.");if(this.m.xa)throw Error("Query.limitToLast: Limit was already set (by another call to limit, limitToFirst, or limitToLast).");return new X(this.u,this.path,this.m.oe(a),this.Nc)};
g.ag=function(a){y("Query.orderByChild",1,1,arguments.length);if("$key"===a)throw Error('Query.orderByChild: "$key" is invalid.  Use Query.orderByKey() instead.');if("$priority"===a)throw Error('Query.orderByChild: "$priority" is invalid.  Use Query.orderByPriority() instead.');if("$value"===a)throw Error('Query.orderByChild: "$value" is invalid.  Use Query.orderByValue() instead.');Vd("Query.orderByChild",a);Sh(this,"Query.orderByChild");var b=new E(a);if(b.e())throw Error("Query.orderByChild: cannot pass in empty path.  Use Query.orderByValue() instead.");
b=new pc(b);b=of(this.m,b);Qh(b);return new X(this.u,this.path,b,!0)};g.bg=function(){y("Query.orderByKey",0,0,arguments.length);Sh(this,"Query.orderByKey");var a=of(this.m,tc);Qh(a);return new X(this.u,this.path,a,!0)};g.cg=function(){y("Query.orderByPriority",0,0,arguments.length);Sh(this,"Query.orderByPriority");var a=of(this.m,H);Qh(a);return new X(this.u,this.path,a,!0)};
g.dg=function(){y("Query.orderByValue",0,0,arguments.length);Sh(this,"Query.orderByValue");var a=of(this.m,wc);Qh(a);return new X(this.u,this.path,a,!0)};g.Nd=function(a,b){y("Query.startAt",0,2,arguments.length);Od("Query.startAt",a,this.path,!0);Ud("Query.startAt",b);var c=this.m.Nd(a,b);Rh(c);Qh(c);if(this.m.ka)throw Error("Query.startAt: Starting point was already set (by another call to startAt or equalTo).");n(a)||(b=a=null);return new X(this.u,this.path,c,this.Nc)};
g.gd=function(a,b){y("Query.endAt",0,2,arguments.length);Od("Query.endAt",a,this.path,!0);Ud("Query.endAt",b);var c=this.m.gd(a,b);Rh(c);Qh(c);if(this.m.na)throw Error("Query.endAt: Ending point was already set (by another call to endAt or equalTo).");return new X(this.u,this.path,c,this.Nc)};
g.If=function(a,b){y("Query.equalTo",1,2,arguments.length);Od("Query.equalTo",a,this.path,!1);Ud("Query.equalTo",b);if(this.m.ka)throw Error("Query.equalTo: Starting point was already set (by another call to startAt or equalTo).");if(this.m.na)throw Error("Query.equalTo: Ending point was already set (by another call to endAt or equalTo).");return this.Nd(a,b).gd(a,b)};
g.toString=function(){y("Query.toString",0,0,arguments.length);for(var a=this.path,b="",c=a.Y;c<a.o.length;c++)""!==a.o[c]&&(b+="/"+encodeURIComponent(String(a.o[c])));return this.u.toString()+(b||"/")};g.toJSON=function(){y("Query.toJSON",0,1,arguments.length);return this.toString()};g.ja=function(){var a=ac(pf(this.m));return"{}"===a?"default":a};
g.isEqual=function(a){y("Query.isEqual",1,1,arguments.length);if(!(a instanceof X))throw Error("Query.isEqual failed: First argument must be an instance of firebase.database.Query.");var b=this.u===a.u,c=this.path.Z(a.path),d=this.ja()===a.ja();return b&&c&&d};
function Th(a,b,c){var d={cancel:null,Ma:null};if(b&&c)d.cancel=b,B(a,3,d.cancel,!0),d.Ma=c,ob(a,4,d.Ma);else if(b)if("object"===typeof b&&null!==b)d.Ma=b;else if("function"===typeof b)d.cancel=b;else throw Error(A(a,3,!0)+" must either be a cancel callback or a context object.");return d}X.prototype.on=X.prototype.gc;X.prototype.off=X.prototype.Ic;X.prototype.once=X.prototype.$f;X.prototype.limitToFirst=X.prototype.ne;X.prototype.limitToLast=X.prototype.oe;X.prototype.orderByChild=X.prototype.ag;
X.prototype.orderByKey=X.prototype.bg;X.prototype.orderByPriority=X.prototype.cg;X.prototype.orderByValue=X.prototype.dg;X.prototype.startAt=X.prototype.Nd;X.prototype.endAt=X.prototype.gd;X.prototype.equalTo=X.prototype.If;X.prototype.toString=X.prototype.toString;X.prototype.isEqual=X.prototype.isEqual;gc(X.prototype,"ref",X.prototype.wb);function Y(a,b){this.ta=a;this.qa=b}Y.prototype.cancel=function(a){y("Firebase.onDisconnect().cancel",0,1,arguments.length);B("Firebase.onDisconnect().cancel",1,a,!0);var b=new ib;this.ta.xd(this.qa,jb(b,a));return b.ra};Y.prototype.cancel=Y.prototype.cancel;Y.prototype.remove=function(a){y("Firebase.onDisconnect().remove",0,1,arguments.length);Wd("Firebase.onDisconnect().remove",this.qa);B("Firebase.onDisconnect().remove",1,a,!0);var b=new ib;Ch(this.ta,this.qa,null,jb(b,a));return b.ra};
Y.prototype.remove=Y.prototype.remove;Y.prototype.set=function(a,b){y("Firebase.onDisconnect().set",1,2,arguments.length);Wd("Firebase.onDisconnect().set",this.qa);Od("Firebase.onDisconnect().set",a,this.qa,!1);B("Firebase.onDisconnect().set",2,b,!0);var c=new ib;Ch(this.ta,this.qa,a,jb(c,b));return c.ra};Y.prototype.set=Y.prototype.set;
Y.prototype.Jb=function(a,b,c){y("Firebase.onDisconnect().setWithPriority",2,3,arguments.length);Wd("Firebase.onDisconnect().setWithPriority",this.qa);Od("Firebase.onDisconnect().setWithPriority",a,this.qa,!1);Sd("Firebase.onDisconnect().setWithPriority",2,b);B("Firebase.onDisconnect().setWithPriority",3,c,!0);var d=new ib;Dh(this.ta,this.qa,a,b,jb(d,c));return d.ra};Y.prototype.setWithPriority=Y.prototype.Jb;
Y.prototype.update=function(a,b){y("Firebase.onDisconnect().update",1,2,arguments.length);Wd("Firebase.onDisconnect().update",this.qa);if(ea(a)){for(var c={},d=0;d<a.length;++d)c[""+d]=a[d];a=c;J("Passing an Array to Firebase.onDisconnect().update() is deprecated. Use set() if you want to overwrite the existing data, or an Object with integer keys if you really do want to only update some of the children.")}Rd("Firebase.onDisconnect().update",a,this.qa);B("Firebase.onDisconnect().update",2,b,!0);
c=new ib;Eh(this.ta,this.qa,a,jb(c,b));return c.ra};Y.prototype.update=Y.prototype.update;var Z={Mf:function(){dg=Zf=!0}};Z.forceLongPolling=Z.Mf;Z.Nf=function(){eg=!0};Z.forceWebSockets=Z.Nf;Z.Tf=function(){return Yf.isAvailable()};Z.isWebSocketsAvailable=Z.Tf;Z.lg=function(a,b){a.u.Ra.ze=b};Z.setSecurityDebugCallback=Z.lg;Z.Be=function(a,b){a.u.Be(b)};Z.stats=Z.Be;Z.Ce=function(a,b){a.u.Ce(b)};Z.statsIncrementCounter=Z.Ce;Z.fd=function(a){return a.u.fd};Z.dataUpdateCount=Z.fd;Z.Sf=function(a,b){a.u.je=b};Z.interceptServerData=Z.Sf;function U(a,b){if(!(a instanceof Qg))throw Error("new Firebase() no longer supported - use app.database().");X.call(this,a,b,mf,!1);this.then=void 0;this["catch"]=void 0}la(U,X);g=U.prototype;g.getKey=function(){y("Firebase.key",0,0,arguments.length);return this.path.e()?null:Oc(this.path)};
g.n=function(a){y("Firebase.child",1,1,arguments.length);if(ga(a))a=String(a);else if(!(a instanceof E))if(null===K(this.path)){var b=a;b&&(b=b.replace(/^\/*\.info(\/|$)/,"/"));Vd("Firebase.child",b)}else Vd("Firebase.child",a);return new U(this.u,this.path.n(a))};g.getParent=function(){y("Firebase.parent",0,0,arguments.length);var a=this.path.parent();return null===a?null:new U(this.u,a)};
g.Of=function(){y("Firebase.ref",0,0,arguments.length);for(var a=this;null!==a.getParent();)a=a.getParent();return a};g.Gf=function(){return this.u.Ya};g.set=function(a,b){y("Firebase.set",1,2,arguments.length);Wd("Firebase.set",this.path);Od("Firebase.set",a,this.path,!1);B("Firebase.set",2,b,!0);var c=new ib;this.u.Jb(this.path,a,null,jb(c,b));return c.ra};
g.update=function(a,b){y("Firebase.update",1,2,arguments.length);Wd("Firebase.update",this.path);if(ea(a)){for(var c={},d=0;d<a.length;++d)c[""+d]=a[d];a=c;J("Passing an Array to Firebase.update() is deprecated. Use set() if you want to overwrite the existing data, or an Object with integer keys if you really do want to only update some of the children.")}Rd("Firebase.update",a,this.path);B("Firebase.update",2,b,!0);c=new ib;this.u.update(this.path,a,jb(c,b));return c.ra};
g.Jb=function(a,b,c){y("Firebase.setWithPriority",2,3,arguments.length);Wd("Firebase.setWithPriority",this.path);Od("Firebase.setWithPriority",a,this.path,!1);Sd("Firebase.setWithPriority",2,b);B("Firebase.setWithPriority",3,c,!0);if(".length"===this.getKey()||".keys"===this.getKey())throw"Firebase.setWithPriority failed: "+this.getKey()+" is a read-only object.";var d=new ib;this.u.Jb(this.path,a,b,jb(d,c));return d.ra};
g.remove=function(a){y("Firebase.remove",0,1,arguments.length);Wd("Firebase.remove",this.path);B("Firebase.remove",1,a,!0);return this.set(null,a)};
g.transaction=function(a,b,c){y("Firebase.transaction",1,3,arguments.length);Wd("Firebase.transaction",this.path);B("Firebase.transaction",1,a,!1);B("Firebase.transaction",2,b,!0);if(n(c)&&"boolean"!=typeof c)throw Error(A("Firebase.transaction",3,!0)+"must be a boolean.");if(".length"===this.getKey()||".keys"===this.getKey())throw"Firebase.transaction failed: "+this.getKey()+" is a read-only object.";"undefined"===typeof c&&(c=!0);var d=new ib;ha(b)&&kb(d.ra);Gh(this.u,this.path,a,function(a,c,h){a?
d.reject(a):d.resolve(new Ph(c,h));ha(b)&&b(a,c,h)},c);return d.ra};g.kg=function(a,b){y("Firebase.setPriority",1,2,arguments.length);Wd("Firebase.setPriority",this.path);Sd("Firebase.setPriority",1,a);B("Firebase.setPriority",2,b,!0);var c=new ib;this.u.Jb(this.path.n(".priority"),a,null,jb(c,b));return c.ra};
g.push=function(a,b){y("Firebase.push",0,2,arguments.length);Wd("Firebase.push",this.path);Od("Firebase.push",a,this.path,!0);B("Firebase.push",2,b,!0);var c=wh(this.u),d=Kc(c),c=this.n(d),e=this.n(d),d=null!=a?c.set(a,b).then(function(){return e}):hb.resolve(e);c.then=q(d.then,d);c["catch"]=q(d.then,d,void 0);ha(b)&&kb(d);return c};g.ib=function(){Wd("Firebase.onDisconnect",this.path);return new Y(this.u,this.path)};U.prototype.child=U.prototype.n;U.prototype.set=U.prototype.set;
U.prototype.update=U.prototype.update;U.prototype.setWithPriority=U.prototype.Jb;U.prototype.remove=U.prototype.remove;U.prototype.transaction=U.prototype.transaction;U.prototype.setPriority=U.prototype.kg;U.prototype.push=U.prototype.push;U.prototype.onDisconnect=U.prototype.ib;gc(U.prototype,"database",U.prototype.Gf);gc(U.prototype,"key",U.prototype.getKey);gc(U.prototype,"parent",U.prototype.getParent);gc(U.prototype,"root",U.prototype.Of);if("undefined"===typeof firebase)throw Error("Cannot install Firebase Database - be sure to load firebase-app.js first.");
try{firebase.INTERNAL.registerService("database",function(a){var b=Ug.Vb(),c=a.options.databaseURL;n(c)||Vb("Can't determine Firebase Database URL.  Be sure to include databaseURL option when calling firebase.intializeApp().");var d=Wb(c),c=d.jc;Xd("Invalid Firebase Database URL",d);d.path.e()||Vb("Database URL must point to the root of a Firebase Database (not including a child path).");(d=w(b.lb,a.name))&&Vb("FIREBASE INTERNAL ERROR: Database initialized multiple times.");d=new Qg(c,b.wf,a);b.lb[a.name]=
d;return d.Ya},{Reference:U,Query:X,Database:Pg,enableLogging:Sb,INTERNAL:Z,TEST_ACCESS:W,ServerValue:Sg})}catch(Uh){Vb("Failed to register the Firebase Database Service ("+Uh+")")};})();

}).call(typeof global !== undefined ? global : typeof self !== undefined ? self : typeof window !== undefined ? window : {});
module.exports = firebase.database;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! @license Firebase v3.9.0
Build: rev-cc77c9e
Terms: https://firebase.google.com/terms/ */



Object.defineProperty(exports, "__esModule", {
    value: true
});
var firebase = __webpack_require__(110);
__webpack_require__(1138);
var Storage, XMLHttpRequest;

__webpack_require__(1139);
__webpack_require__(1142);
var AsyncStorage;

__webpack_require__(1141);
exports.default = firebase;
module.exports = exports['default'];
//# sourceMappingURL=firebase.js.map


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*! @license Firebase v3.9.0
Build: rev-cc77c9e
Terms: https://firebase.google.com/terms/ */

var firebase = __webpack_require__(110);
(function(){
(function(){var f=function(a,b){function c(){}c.prototype=b.prototype;a.u=b.prototype;a.prototype=new c;for(var d in b)if(Object.defineProperties){var e=Object.getOwnPropertyDescriptor(b,d);e&&Object.defineProperty(a,d,e)}else a[d]=b[d]},g=this,h=function(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&
"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";else if("function"==b&&"undefined"==typeof a.call)return"object";return b},k=function(a,b){function c(){}c.prototype=b.prototype;a.u=b.prototype;a.prototype=new c;a.v=function(a,c,n){for(var d=Array(arguments.length-2),e=2;e<arguments.length;e++)d[e-
2]=arguments[e];return b.prototype[c].apply(a,d)}};var m=function(a){if(Error.captureStackTrace)Error.captureStackTrace(this,m);else{var b=Error().stack;b&&(this.stack=b)}a&&(this.message=String(a))};k(m,Error);var p=function(a,b){for(var c=a.split("%s"),d="",e=Array.prototype.slice.call(arguments,1);e.length&&1<c.length;)d+=c.shift()+e.shift();return d+c.join("%s")};var q=function(a,b){b.unshift(a);m.call(this,p.apply(null,b));b.shift()};k(q,m);var r=function(a,b,c){if(!a){var d="Assertion failed";if(b)var d=d+(": "+b),e=Array.prototype.slice.call(arguments,2);throw new q(""+d,e||[]);}};var t=null;var v=function(a){a=new Uint8Array(a);var b=h(a);r("array"==b||"object"==b&&"number"==typeof a.length,"encodeByteArray takes an array as a parameter");if(!t)for(t={},b=0;65>b;b++)t[b]="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(b);for(var b=t,c=[],d=0;d<a.length;d+=3){var e=a[d],n=d+1<a.length,l=n?a[d+1]:0,z=d+2<a.length,u=z?a[d+2]:0,M=e>>2,e=(e&3)<<4|l>>4,l=(l&15)<<2|u>>6,u=u&63;z||(u=64,n||(l=64));c.push(b[M],b[e],b[l],b[u])}return c.join("").replace(/\+/g,"-").replace(/\//g,
"_").replace(/=+$/,"")};var w={},x=(w["only-available-in-window"]="This method is available in a Window context.",w["only-available-in-sw"]="This method is available in a service worker context.",w["should-be-overriden"]="This method should be overriden by extended classes.",w["bad-sender-id"]="Please ensure that 'messagingSenderId' is set correctly in the options passed into firebase.initializeApp().",w["permission-default"]="The required permissions were not granted and dismissed instead.",w["permission-blocked"]="The required permissions were not granted and blocked instead.",
w["unsupported-browser"]="This browser doesn't support the API's required to use the firebase SDK.",w["notifications-blocked"]="Notifications have been blocked.",w["failed-serviceworker-registration"]="We are unable to register the default service worker. {$browserErrorMessage}",w["sw-registration-expected"]="A service worker registration was the expected input.",w["get-subscription-failed"]="There was an error when trying to get any existing Push Subscriptions.",w["invalid-saved-token"]="Unable to access details of the saved token.",
w["sw-reg-redundant"]="The service worker being used for push was made redundant.",w["token-subscribe-failed"]="A problem occured while subscribing the user to FCM: {$message}",w["token-subscribe-no-token"]="FCM returned no token when subscribing the user to push.",w["token-subscribe-no-push-set"]="FCM returned an invalid response when getting an FCM token.",w["use-sw-before-get-token"]="You must call useServiceWorker() before calling getToken() to ensure your service worker is used.",w["invalid-delete-token"]=
"You must pass a valid token into deleteToken(), i.e. the token from getToken().",w["delete-token-not-found"]="The deletion attempt for token could not be performed as the token was not found.",w["delete-scope-not-found"]="The deletion attempt for service worker scope could not be performed as the scope was not found.",w["bg-handler-function-expected"]="The input to setBackgroundMessageHandler() must be a function.",w["no-window-client-to-msg"]="An attempt was made to message a non-existant window client.",
w["unable-to-resubscribe"]="There was an error while re-subscribing the FCM token for push messaging. Will have to resubscribe the user on next visit. {$message}",w["no-fcm-token-for-resubscribe"]="Could not find an FCM token and as a result, unable to resubscribe. Will have to resubscribe the user on next visit.",w["failed-to-delete-token"]="Unable to delete the currently saved token.",w["no-sw-in-reg"]="Even though the service worker registration was successful, there was a problem accessing the service worker itself.",
w["incorrect-gcm-sender-id"]="Please change your web app manifest's 'gcm_sender_id' value to '103953800507' to use Firebase messaging.",w["bad-scope"]="The service worker scope must be a string with at least one character.",w["bad-vapid-key"]="The public VAPID key must be a string with at least one character.",w["bad-subscription"]="The subscription must be a valid PushSubscription.",w["bad-token"]="The FCM Token used for storage / lookup was not a valid token string.",w["bad-push-set"]="The FCM push set used for storage / lookup was not not a valid push set string.",
w["failed-delete-vapid-key"]="The VAPID key could not be deleted.",w);var y={userVisibleOnly:!0,applicationServerKey:new Uint8Array([4,51,148,247,223,161,235,177,220,3,162,94,21,113,219,72,211,46,237,237,178,52,219,183,71,58,12,143,196,204,225,111,60,140,132,223,171,182,102,62,242,12,212,139,254,227,249,118,47,20,28,99,8,106,111,45,177,26,149,176,206,55,192,156,110])};var A=new firebase.INTERNAL.ErrorFactory("messaging","Messaging",x),B=function(){this.a=null},C=function(a){if(a.a)return a.a;a.a=new Promise(function(a,c){var b=g.indexedDB.open("fcm_token_details_db",1);b.onerror=function(a){c(a.target.error)};b.onsuccess=function(b){a(b.target.result)};b.onupgradeneeded=function(a){a=a.target.result.createObjectStore("fcm_token_object_Store",{keyPath:"swScope"});a.createIndex("fcmSenderId","fcmSenderId",{unique:!1});a.createIndex("fcmToken","fcmToken",{unique:!0})}});
return a.a},D=function(a){a.a?a.a.then(function(b){b.close();a.a=null}):Promise.resolve()},E=function(a,b){return C(a).then(function(a){return new Promise(function(c,e){var d=a.transaction(["fcm_token_object_Store"]).objectStore("fcm_token_object_Store").index("fcmToken").get(b);d.onerror=function(a){e(a.target.error)};d.onsuccess=function(a){c(a.target.result)}})})},F=function(a,b){return C(a).then(function(a){return new Promise(function(c,e){var d=[],l=a.transaction(["fcm_token_object_Store"]).objectStore("fcm_token_object_Store").openCursor();
l.onerror=function(a){e(a.target.error)};l.onsuccess=function(a){(a=a.target.result)?(a.value.fcmSenderId===b&&d.push(a.value),a.continue()):c(d)}})})},G=function(a,b,c){var d=v(b.getKey("p256dh")),e=v(b.getKey("auth"));a="authorized_entity="+a+"&"+("endpoint="+b.endpoint+"&")+("encryption_key="+d+"&")+("encryption_auth="+e);c&&(a+="&pushSet="+c);c=new Headers;c.append("Content-Type","application/x-www-form-urlencoded");return fetch("https://fcm.googleapis.com/fcm/connect/subscribe",{method:"POST",
headers:c,body:a}).then(function(a){return a.json()}).then(function(a){if(a.error)throw A.create("token-subscribe-failed",{message:a.error.message});if(!a.token)throw A.create("token-subscribe-no-token");if(!a.pushSet)throw A.create("token-subscribe-no-push-set");return{token:a.token,pushSet:a.pushSet}})},H=function(a,b,c,d,e,n){var l={swScope:c.scope,endpoint:d.endpoint,auth:v(d.getKey("auth")),p256dh:v(d.getKey("p256dh")),fcmToken:e,fcmPushSet:n,fcmSenderId:b};return C(a).then(function(a){return new Promise(function(b,
c){var d=a.transaction(["fcm_token_object_Store"],"readwrite").objectStore("fcm_token_object_Store").put(l);d.onerror=function(a){c(a.target.error)};d.onsuccess=function(){b()}})})};
B.prototype.i=function(a,b){return b instanceof ServiceWorkerRegistration?"string"!==typeof a||0===a.length?Promise.reject(A.create("bad-sender-id")):F(this,a).then(function(c){if(0!==c.length){var d=c.findIndex(function(c){return b.scope===c.swScope&&a===c.fcmSenderId});if(-1!==d)return c[d]}}).then(function(a){if(a)return b.pushManager.getSubscription().catch(function(){throw A.create("get-subscription-failed");}).then(function(b){var c;if(c=b)c=b.endpoint===a.endpoint&&v(b.getKey("auth"))===a.auth&&
v(b.getKey("p256dh"))===a.p256dh;if(c)return a.fcmToken})}):Promise.reject(A.create("sw-registration-expected"))};B.prototype.getSavedToken=B.prototype.i;
B.prototype.h=function(a,b){var c=this;return"string"!==typeof a||0===a.length?Promise.reject(A.create("bad-sender-id")):b instanceof ServiceWorkerRegistration?b.pushManager.getSubscription().then(function(a){return a?a:b.pushManager.subscribe(y)}).then(function(d){return G(a,d).then(function(e){return H(c,a,b,d,e.token,e.pushSet).then(function(){return e.token})})}):Promise.reject(A.create("sw-registration-expected"))};B.prototype.createToken=B.prototype.h;
B.prototype.deleteToken=function(a){var b=this;return"string"!==typeof a||0===a.length?Promise.reject(A.create("invalid-delete-token")):E(this,a).then(function(a){if(!a)throw A.create("delete-token-not-found");return C(b).then(function(b){return new Promise(function(c,d){var e=b.transaction(["fcm_token_object_Store"],"readwrite").objectStore("fcm_token_object_Store").delete(a.swScope);e.onerror=function(a){d(a.target.error)};e.onsuccess=function(b){0===b.target.result?d(A.create("failed-to-delete-token")):
c(a)}})})})};var I=function(a){var b=this;this.a=new firebase.INTERNAL.ErrorFactory("messaging","Messaging",x);if(!a.options.messagingSenderId||"string"!==typeof a.options.messagingSenderId)throw this.a.create("bad-sender-id");this.l=a.options.messagingSenderId;this.c=new B;this.app=a;this.INTERNAL={};this.INTERNAL.delete=function(){return b.delete}};
I.prototype.getToken=function(){var a=this,b=Notification.permission;return"granted"!==b?"denied"===b?Promise.reject(this.a.create("notifications-blocked")):Promise.resolve(null):this.f().then(function(b){return a.c.i(a.l,b).then(function(c){return c?c:a.c.h(a.l,b)})})};I.prototype.getToken=I.prototype.getToken;I.prototype.deleteToken=function(a){var b=this;return this.c.deleteToken(a).then(function(){return b.f()}).then(function(a){return a?a.pushManager.getSubscription():null}).then(function(a){if(a)return a.unsubscribe()})};
I.prototype.deleteToken=I.prototype.deleteToken;I.prototype.f=function(){throw this.a.create("should-be-overriden");};I.prototype.requestPermission=function(){throw this.a.create("only-available-in-window");};I.prototype.useServiceWorker=function(){throw this.a.create("only-available-in-window");};I.prototype.useServiceWorker=I.prototype.useServiceWorker;I.prototype.onMessage=function(){throw this.a.create("only-available-in-window");};I.prototype.onMessage=I.prototype.onMessage;
I.prototype.onTokenRefresh=function(){throw this.a.create("only-available-in-window");};I.prototype.onTokenRefresh=I.prototype.onTokenRefresh;I.prototype.setBackgroundMessageHandler=function(){throw this.a.create("only-available-in-sw");};I.prototype.setBackgroundMessageHandler=I.prototype.setBackgroundMessageHandler;I.prototype.delete=function(){D(this.c)};var J=function(a,b){var c={};return c["firebase-messaging-msg-type"]=a,c["firebase-messaging-msg-data"]=b,c};var K=self,P=function(a){I.call(this,a);var b=this;this.a=new firebase.INTERNAL.ErrorFactory("messaging","Messaging",x);K.addEventListener("push",function(a){return L(b,a)},!1);K.addEventListener("pushsubscriptionchange",function(a){return N(b,a)},!1);K.addEventListener("notificationclick",function(a){return O(b,a)},!1);this.b=null};f(P,I);
var L=function(a,b){var c;try{c=b.data.json()}catch(e){return}var d=Q().then(function(b){if(b){if(c.notification||a.b)return R(a,c)}else{if((b=c)&&"object"===typeof b.notification){var d=Object.assign({},b.notification),e={};d.data=(e.FCM_MSG=b,e);b=d}else b=void 0;if(b)return K.registration.showNotification(b.title||"",b);if(a.b)return a.b(c)}});b.waitUntil(d)},N=function(a,b){var c=a.getToken().then(function(b){if(!b)throw a.a.create("no-fcm-token-for-resubscribe");var c=a.c;return E(c,b).then(function(b){if(!b)throw a.a.create("invalid-saved-token");
return K.registration.pushManager.subscribe(y).then(function(a){return G(b.A,a,b.w)}).catch(function(d){return c.deleteToken(b.B).then(function(){throw a.a.create("unable-to-resubscribe",{message:d});})})})});b.waitUntil(c)},O=function(a,b){if(b.notification&&b.notification.data&&b.notification.data.FCM_MSG){b.stopImmediatePropagation();b.notification.close();var c=b.notification.data.FCM_MSG,d=c.notification.click_action;if(d){var e=S(d).then(function(a){return a?a:K.clients.openWindow(d)}).then(function(b){if(b)return delete c.notification,
T(a,b,J("notification-clicked",c))});b.waitUntil(e)}}};P.prototype.setBackgroundMessageHandler=function(a){if(a&&"function"!==typeof a)throw this.a.create("bg-handler-function-expected");this.b=a};P.prototype.setBackgroundMessageHandler=P.prototype.setBackgroundMessageHandler;
var S=function(a){var b=(new URL(a)).href;return K.clients.matchAll({type:"window",includeUncontrolled:!0}).then(function(a){for(var c=null,e=0;e<a.length;e++)if((new URL(a[e].url)).href===b){c=a[e];break}if(c)return c.focus(),c})},T=function(a,b,c){return new Promise(function(d,e){if(!b)return e(a.a.create("no-window-client-to-msg"));b.postMessage(c);d()})},Q=function(){return K.clients.matchAll({type:"window",includeUncontrolled:!0}).then(function(a){return a.some(function(a){return"visible"===
a.visibilityState})})},R=function(a,b){return K.clients.matchAll({type:"window",includeUncontrolled:!0}).then(function(c){var d=J("push-msg-received",b);return Promise.all(c.map(function(b){return T(a,b,d)}))})};P.prototype.f=function(){return Promise.resolve(K.registration)};var V=function(a){I.call(this,a);var b=this;this.j=null;this.m=firebase.INTERNAL.createSubscribe(function(a){b.j=a});this.s=null;this.o=firebase.INTERNAL.createSubscribe(function(a){b.s=a});U(this)};f(V,I);
V.prototype.getToken=function(){var a=this;return"serviceWorker"in navigator&&"PushManager"in window&&"Notification"in window&&ServiceWorkerRegistration.prototype.hasOwnProperty("showNotification")&&PushSubscription.prototype.hasOwnProperty("getKey")?W(this).then(function(){return I.prototype.getToken.call(a)}):Promise.reject(this.a.create("unsupported-browser"))};V.prototype.getToken=V.prototype.getToken;
var W=function(a){if(a.g)return a.g;var b=document.querySelector('link[rel="manifest"]');b?a.g=fetch(b.href).then(function(a){return a.json()}).catch(function(){return Promise.resolve()}).then(function(b){if(b&&b.gcm_sender_id&&"103953800507"!==b.gcm_sender_id)throw a.a.create("incorrect-gcm-sender-id");}):a.g=Promise.resolve();return a.g};
V.prototype.requestPermission=function(){var a=this;return"granted"===Notification.permission?Promise.resolve():new Promise(function(b,c){var d=function(d){return"granted"===d?b():"denied"===d?c(a.a.create("permission-blocked")):c(a.a.create("permission-default"))},e=Notification.requestPermission(function(a){e||d(a)});e&&e.then(d)})};V.prototype.requestPermission=V.prototype.requestPermission;
V.prototype.useServiceWorker=function(a){if(!(a instanceof ServiceWorkerRegistration))throw this.a.create("sw-registration-expected");if("undefined"!==typeof this.b)throw this.a.create("use-sw-before-get-token");this.b=a};V.prototype.useServiceWorker=V.prototype.useServiceWorker;V.prototype.onMessage=function(a,b,c){return this.m(a,b,c)};V.prototype.onMessage=V.prototype.onMessage;V.prototype.onTokenRefresh=function(a,b,c){return this.o(a,b,c)};V.prototype.onTokenRefresh=V.prototype.onTokenRefresh;
var X=function(a,b){var c=b.installing||b.waiting||b.active;return new Promise(function(d,e){if(c)if("activated"===c.state)d(b);else if("redundant"===c.state)e(a.a.create("sw-reg-redundant"));else{var n=function(){if("activated"===c.state)d(b);else if("redundant"===c.state)e(a.a.create("sw-reg-redundant"));else return;c.removeEventListener("statechange",n)};c.addEventListener("statechange",n)}else e(a.a.create("no-sw-in-reg"))})};
V.prototype.f=function(){var a=this;if(this.b)return X(this,this.b);this.b=null;return navigator.serviceWorker.register("/firebase-messaging-sw.js",{scope:"/firebase-cloud-messaging-push-scope"}).catch(function(b){throw a.a.create("failed-serviceworker-registration",{browserErrorMessage:b.message});}).then(function(b){return X(a,b).then(function(){a.b=b;b.update();return b})})};
var U=function(a){"serviceWorker"in navigator&&navigator.serviceWorker.addEventListener("message",function(b){if(b.data&&b.data["firebase-messaging-msg-type"])switch(b=b.data,b["firebase-messaging-msg-type"]){case "push-msg-received":case "notification-clicked":a.j.next(b["firebase-messaging-msg-data"])}},!1)};if(!(firebase&&firebase.INTERNAL&&firebase.INTERNAL.registerService))throw Error("Cannot install Firebase Messaging - be sure to load firebase-app.js first.");firebase.INTERNAL.registerService("messaging",function(a){return self&&"ServiceWorkerGlobalScope"in self?new P(a):new V(a)},{Messaging:V});new firebase.INTERNAL.ErrorFactory("messaging","Messaging",x);new firebase.INTERNAL.ErrorFactory("messaging","Messaging",x);new firebase.INTERNAL.ErrorFactory("messaging","Messaging",x);}).call(this);
}).call(typeof global !== undefined ? global : typeof self !== undefined ? self : typeof window !== undefined ? window : {});
module.exports = firebase.messaging;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*! @license Firebase v3.9.0
Build: rev-cc77c9e
Terms: https://firebase.google.com/terms/ */

var firebase = __webpack_require__(110);
(function(){
(function(){for(var h,aa="function"==typeof Object.defineProperties?Object.defineProperty:function(a,b,c){a!=Array.prototype&&a!=Object.prototype&&(a[b]=c.value)},l="undefined"!=typeof window&&window===this?this:"undefined"!=typeof global&&null!=global?global:this,n=["Number","MIN_SAFE_INTEGER"],ba=0;ba<n.length-1;ba++){var ca=n[ba];ca in l||(l[ca]={});l=l[ca]}var da=n[n.length-1];-9007199254740991!=l[da]&&aa(l,da,{configurable:!0,writable:!0,value:-9007199254740991});
var p=this,q=function(a){return void 0!==a},ea=function(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&
!a.propertyIsEnumerable("call"))return"function"}else return"null";else if("function"==b&&"undefined"==typeof a.call)return"object";return b};var r=function(a,b){this.code="storage/"+a;this.message="Firebase Storage: "+b;this.serverResponse=null;this.name="FirebaseError"};(function(){var a=Error;function b(){}b.prototype=a.prototype;r.b=a.prototype;r.prototype=new b;r.a=function(b,d,e){for(var c=Array(arguments.length-2),f=2;f<arguments.length;f++)c[f-2]=arguments[f];return a.prototype[d].apply(b,c)}})();
var fa=function(){return new r("unknown","An unknown error occurred, please check the error payload for server response.")},ga=function(){return new r("canceled","User canceled the upload/download.")},ha=function(){return new r("cannot-slice-blob","Cannot slice blob for upload. Please retry the upload.")},ia=function(a,b,c){return new r("invalid-argument","Invalid argument in `"+b+"` at index "+a+": "+c)},ja=function(){return new r("app-deleted","The Firebase app was deleted.")},t=function(a,b){return new r("invalid-format",
"String does not match format '"+a+"': "+b)},u=function(a){throw new r("internal-error","Internal error: "+a);};var v="https://firebasestorage.googleapis.com";var ka=function(a){if("undefined"!==typeof firebase)return new firebase.Promise(a);throw Error("Error in Firebase Storage - be sure to load firebase-app.js first.");};var la=function(a,b){return-1!==a.indexOf(b)};var ma=function(a,b,c){function d(){C||(C=!0,b.apply(null,arguments))}function e(b){m=setTimeout(function(){m=null;a(g,2===y)},b)}function g(a,b){if(!C)if(a)d.apply(null,arguments);else if(2===y||z)d.apply(null,arguments);else{64>k&&(k*=2);var c;1===y?(y=2,c=0):c=1E3*(k+Math.random());e(c)}}function f(a){Pa||(Pa=!0,C||(null!==m?(a||(y=2),clearTimeout(m),e(0)):a||(y=1)))}var k=1,m=null,z=!1,y=0,C=!1,Pa=!1;e(0);setTimeout(function(){z=!0;f(!0)},c);return f};var na=function(a,b){for(var c in a)Object.prototype.hasOwnProperty.call(a,c)&&b(c,a[c])},oa=function(a){var b={};na(a,function(a,d){b[a]=d});return b};var w=function(a,b,c,d){this.l=a;this.b={};this.method=b;this.headers={};this.body=null;this.m=c;this.c=this.a=null;this.f=[200];this.i=[];this.timeout=d;this.g=!0};var pa=function(a){var b=encodeURIComponent,c="?";na(a,function(a,e){a=b(a)+"="+b(e);c=c+a+"&"});return c=c.slice(0,-1)};var ra=function(a,b,c,d,e,g,f,k,m,z,y){this.F=a;this.D=b;this.A=c;this.u=d;this.B=e.slice();this.s=g.slice();this.m=this.o=this.c=this.b=null;this.g=this.i=!1;this.v=f;this.l=k;this.f=z;this.G=y;this.C=m;var C=this;this.w=ka(function(a,b){C.o=a;C.m=b;qa(C)})},sa=function(a,b,c){this.b=a;this.c=b;this.a=!!c},qa=function(a){function b(a,b){function c(a){d.f(a.loaded,a.lengthComputable?a.total:-1)}b?a(!1,new sa(!1,null,!0)):(b=new ta,b.h.withCredentials=d.G,d.b=b,null!==d.f&&q(b.h.upload)&&b.h.upload.addEventListener("progress",
c),ua(b,d.F,d.D,d.u,d.A).then(function(b){null!==d.f&&q(b.h.upload)&&b.h.upload.removeEventListener("progress",c);d.b=null;var e=0===va(b),f=x(b);if(!(e=!e))var e=la([408,429],f),g=la(d.s,f),e=500<=f&&600>f||e||g;e?(b=2===va(b),a(!1,new sa(!1,null,b))):a(!0,new sa(la(d.B,f),b))}))}function c(a,b){var c=d.o;a=d.m;var e=b.c;if(b.b)try{var g=d.v(e,wa(e));q(g)?c(g):c()}catch(z){a(z)}else null!==e?(b=fa(),g=wa(e),b.serverResponse=g,d.l?a(d.l(e,b)):a(b)):(b=b.a?d.g?ja():ga():new r("retry-limit-exceeded",
"Max retry time for operation exceeded, please try again."),a(b))}var d=a;a.i?c(0,new sa(!1,null,!0)):a.c=ma(b,c,a.C)};ra.prototype.a=function(){return this.w};ra.prototype.cancel=function(a){this.i=!0;this.g=a||!1;null!==this.c&&(0,this.c)(!1);null!==this.b&&this.b.abort()};
var xa=function(a,b,c){var d=pa(a.b),d=a.l+d,e=a.headers?oa(a.headers):{};null!==b&&0<b.length&&(e.Authorization="Firebase "+b);e["X-Firebase-Storage-Version"]="webjs/"+("undefined"!==typeof firebase?firebase.SDK_VERSION:"AppManager");return new ra(d,a.method,e,a.body,a.f,a.i,a.m,a.a,a.timeout,a.c,c)};var ya=function(a){this.b=firebase.Promise.reject(a)};ya.prototype.a=function(){return this.b};ya.prototype.cancel=function(){};var A=function(a,b){this.bucket=a;this.path=b},za=function(a){var b=encodeURIComponent;return"/b/"+b(a.bucket)+"/o/"+b(a.path)},Ba=function(a){var b;try{b=Aa(a)}catch(c){return new A(a,"")}if(""===b.path)return b;throw new r("invalid-default-bucket","Invalid default bucket '"+a+"'.");},Aa=function(a){for(var b=null,c=[{M:/^gs:\/\/([A-Za-z0-9.\-]+)(\/(.*))?$/i,H:{bucket:1,path:3},L:function(a){"/"===a.path.charAt(a.path.length-1)&&(a.path=a.path.slice(0,-1))}},{M:/^https?:\/\/firebasestorage\.googleapis\.com\/v[A-Za-z0-9_]+\/b\/([A-Za-z0-9.\-]+)\/o(\/([^?#]*).*)?$/i,
H:{bucket:1,path:3},L:function(a){a.path=decodeURIComponent(a.path)}}],d=0;d<c.length;d++){var e=c[d],g=e.M.exec(a);if(g){b=g[e.H.bucket];(g=g[e.H.path])||(g="");b=new A(b,g);e.L(b);break}}if(null==b)throw new r("invalid-url","Invalid URL '"+a+"'.");return b};var Ca=function(){this.a={};this.b=Number.MIN_SAFE_INTEGER},Da=function(a,b){function c(){delete e.a[d]}var d=a.b;a.b++;a.a[d]=b;var e=a;b.a().then(c,c)},Ea=function(a){na(a.a,function(a,c){c&&c.cancel(!0)});a.a={}};var B=function(a){return q(a)&&null!==a},Fa=function(a){return"string"===typeof a||a instanceof String},Ga=function(){return"undefined"!==typeof Blob};var Ha=function(a,b,c,d,e){this.a=a;this.g=null;null!==this.a&&(a=this.a.options,B(a)&&(a=a.storageBucket||null,this.g=null==a?null:Ba(a).bucket));this.s=b;this.o=c;this.l=e;this.m=d;this.c=12E4;this.b=6E4;this.i=new Ca;this.f=!1},Ia=function(a){return null!==a.a&&B(a.a.INTERNAL)&&B(a.a.INTERNAL.getToken)?a.a.INTERNAL.getToken().then(function(a){return B(a)?a.accessToken:null},function(){return null}):firebase.Promise.resolve(null)};Ha.prototype.bucket=function(){if(this.f)throw ja();return this.g};
var D=function(a,b,c){if(a.f)return new ya(ja());b=a.o(b,c,null===a.a,a.l);Da(a.i,b);return b};var Ja=function(a,b){b=b.split("/").filter(function(a){return 0<a.length}).join("/");return 0===a.length?b:a+"/"+b},Ka=function(a){var b=a.lastIndexOf("/",a.length-2);return-1===b?a:a.slice(b+1)};var La=function(a,b){return b},E=function(a,b,c,d){this.c=a;this.b=b||a;this.writable=!!c;this.a=d||La},Ma=null,Na=function(){if(Ma)return Ma;var a=[];a.push(new E("bucket"));a.push(new E("generation"));a.push(new E("metageneration"));a.push(new E("name","fullPath",!0));var b=new E("name");b.a=function(a,b){return!Fa(b)||2>b.length?b:Ka(b)};a.push(b);b=new E("size");b.a=function(a,b){return B(b)?+b:b};a.push(b);a.push(new E("timeCreated"));a.push(new E("updated"));a.push(new E("md5Hash",null,!0));
a.push(new E("cacheControl",null,!0));a.push(new E("contentDisposition",null,!0));a.push(new E("contentEncoding",null,!0));a.push(new E("contentLanguage",null,!0));a.push(new E("contentType",null,!0));a.push(new E("metadata","customMetadata",!0));a.push(new E("downloadTokens","downloadURLs",!1,function(a,b){if(!(Fa(b)&&0<b.length))return[];var c=encodeURIComponent;return b.split(",").map(function(b){var d=a.fullPath,d="https://firebasestorage.googleapis.com/v0"+("/b/"+c(a.bucket)+"/o/"+c(d));b=pa({alt:"media",
token:b});return d+b})}));return Ma=a},Oa=function(a,b){Object.defineProperty(a,"ref",{get:function(){return b.s(b,new A(a.bucket,a.fullPath))}})},Qa=function(a,b){for(var c={},d=b.length,e=0;e<d;e++){var g=b[e];g.writable&&(c[g.c]=a[g.b])}return JSON.stringify(c)},Ra=function(a){if(!a||"object"!==typeof a)throw"Expected Metadata object.";for(var b in a){var c=a[b];if("customMetadata"===b){if("object"!==typeof c)throw"Expected object for 'customMetadata' mapping.";}else if(null!=c&&"object"===typeof c)throw"Mapping for '"+
b+"' cannot be an object.";}};var F=function(a,b,c){for(var d=b.length,e=b.length,g=0;g<b.length;g++)if(b[g].b){d=g;break}if(!(d<=c.length&&c.length<=e))throw d===e?(b=d,d=1===d?"argument":"arguments"):(b="between "+d+" and "+e,d="arguments"),new r("invalid-argument-count","Invalid argument count in `"+a+"`: Expected "+b+" "+d+", received "+c.length+".");for(g=0;g<c.length;g++)try{b[g].a(c[g])}catch(f){if(f instanceof Error)throw ia(g,a,f.message);throw ia(g,a,f);}},G=function(a,b){var c=this;this.a=function(b){c.b&&!q(b)||a(b)};
this.b=!!b},Sa=function(a,b){return function(c){a(c);b(c)}},H=function(a,b){function c(a){if(!("string"===typeof a||a instanceof String))throw"Expected string.";}var d;a?d=Sa(c,a):d=c;return new G(d,b)},Ta=function(){return new G(function(a){if(!(a instanceof Uint8Array||a instanceof ArrayBuffer||Ga()&&a instanceof Blob))throw"Expected Blob or File.";})},Ua=function(){return new G(function(a){if(!(("number"===typeof a||a instanceof Number)&&0<=a))throw"Expected a number 0 or greater.";})},Va=function(a,
b){return new G(function(b){if(!(null===b||B(b)&&b instanceof Object))throw"Expected an Object.";B(a)&&a(b)},b)},I=function(){return new G(function(a){if(null!==a&&"function"!=ea(a))throw"Expected a Function.";},!0)};var J=function(a){return function(){var b=[];Array.prototype.push.apply(b,arguments);firebase.Promise.resolve(!0).then(function(){a.apply(null,b)})}};var Wa=String.prototype.trim?function(a){return a.trim()}:function(a){return a.replace(/^[\s\xa0]+|[\s\xa0]+$/g,"")},Xa=function(a,b){return a<b?-1:a>b?1:0};var K;a:{var Ya=p.navigator;if(Ya){var Za=Ya.userAgent;if(Za){K=Za;break a}}K=""};var ab=function(a,b){var c=$a;return Object.prototype.hasOwnProperty.call(c,a)?c[a]:c[a]=b(a)};var bb=-1!=K.indexOf("Opera"),cb=-1!=K.indexOf("Trident")||-1!=K.indexOf("MSIE"),db=-1!=K.indexOf("Edge"),eb=-1!=K.indexOf("Gecko")&&!(-1!=K.toLowerCase().indexOf("webkit")&&-1==K.indexOf("Edge"))&&!(-1!=K.indexOf("Trident")||-1!=K.indexOf("MSIE"))&&-1==K.indexOf("Edge"),fb=-1!=K.toLowerCase().indexOf("webkit")&&-1==K.indexOf("Edge"),gb;
a:{var hb="",ib=function(){var a=K;if(eb)return/rv\:([^\);]+)(\)|;)/.exec(a);if(db)return/Edge\/([\d\.]+)/.exec(a);if(cb)return/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);if(fb)return/WebKit\/(\S+)/.exec(a);if(bb)return/(?:Version)[ \/]?(\S+)/.exec(a)}();ib&&(hb=ib?ib[1]:"");if(cb){var jb,kb=p.document;jb=kb?kb.documentMode:void 0;if(null!=jb&&jb>parseFloat(hb)){gb=String(jb);break a}}gb=hb}
var lb=gb,$a={},mb=function(a){return ab(a,function(){for(var b=0,c=Wa(String(lb)).split("."),d=Wa(String(a)).split("."),e=Math.max(c.length,d.length),g=0;0==b&&g<e;g++){var f=c[g]||"",k=d[g]||"";do{f=/(\d*)(\D*)(.*)/.exec(f)||["","","",""];k=/(\d*)(\D*)(.*)/.exec(k)||["","","",""];if(0==f[0].length&&0==k[0].length)break;b=Xa(0==f[1].length?0:parseInt(f[1],10),0==k[1].length?0:parseInt(k[1],10))||Xa(0==f[2].length,0==k[2].length)||Xa(f[2],k[2]);f=f[3];k=k[3]}while(0==b)}return 0<=b})};var nb=function(a){var b=p.BlobBuilder||p.WebKitBlobBuilder;if(q(b)){for(var b=new b,c=0;c<arguments.length;c++)b.append(arguments[c]);return b.getBlob()}b=Array.prototype.slice.call(arguments);c=p.BlobBuilder||p.WebKitBlobBuilder;if(q(c)){for(var c=new c,d=0;d<b.length;d++)c.append(b[d],void 0);b=c.getBlob(void 0)}else if(q(p.Blob))b=new Blob(b,{});else throw Error("This browser doesn't seem to support creating Blobs");return b},ob=function(a,b,c){q(c)||(c=a.size);return a.webkitSlice?a.webkitSlice(b,
c):a.mozSlice?a.mozSlice(b,c):a.slice?eb&&!mb("13.0")||fb&&!mb("537.1")?(0>b&&(b+=a.size),0>b&&(b=0),0>c&&(c+=a.size),c<b&&(c=b),a.slice(b,c-b)):a.slice(b,c):null};var L={RAW:"raw",BASE64:"base64",BASE64URL:"base64url",DATA_URL:"data_url"},pb=function(a){switch(a){case "raw":case "base64":case "base64url":case "data_url":break;default:throw"Expected one of the event types: [raw, base64, base64url, data_url].";}},qb=function(a,b){this.data=a;this.a=b||null},ub=function(a,b){switch(a){case "raw":return new qb(rb(b));case "base64":case "base64url":return new qb(sb(a,b));case "data_url":a=new tb(b);var c;if(a.a)c=sb("base64",a.c);else{try{c=decodeURIComponent(a.c)}catch(d){throw t("data_url",
"Malformed data URL.");}c=rb(c)}return new qb(c,(new tb(b)).b)}throw fa();},rb=function(a){for(var b=[],c=0;c<a.length;c++){var d=a.charCodeAt(c);if(127>=d)b.push(d);else if(2047>=d)b.push(192|d>>6,128|d&63);else if(55296==(d&64512))if(c<a.length-1&&56320==(a.charCodeAt(c+1)&64512)){var e=a.charCodeAt(++c),d=65536|(d&1023)<<10|e&1023;b.push(240|d>>18,128|d>>12&63,128|d>>6&63,128|d&63)}else b.push(239,191,189);else 56320==(d&64512)?b.push(239,191,189):b.push(224|d>>12,128|d>>6&63,128|d&63)}return new Uint8Array(b)},
sb=function(a,b){switch(a){case "base64":var c=-1!==b.indexOf("-"),d=-1!==b.indexOf("_");if(c||d)throw t(a,"Invalid character '"+(c?"-":"_")+"' found: is it base64url encoded?");break;case "base64url":c=-1!==b.indexOf("+");d=-1!==b.indexOf("/");if(c||d)throw t(a,"Invalid character '"+(c?"+":"/")+"' found: is it base64 encoded?");b=b.replace(/-/g,"+").replace(/_/g,"/")}var e;try{e=atob(b)}catch(g){throw t(a,"Invalid character found");}a=new Uint8Array(e.length);for(b=0;b<e.length;b++)a[b]=e.charCodeAt(b);
return a},tb=function(a){var b=a.match(/^data:([^,]+)?,/);if(null===b)throw t("data_url","Must be formatted 'data:[<mediatype>][;base64],<data>");b=b[1]||null;this.a=!1;this.b=null;if(null!=b){var c=b.length-7;this.b=(this.a=0<=c&&b.indexOf(";base64",c)==c)?b.substring(0,b.length-7):b}this.c=a.substring(a.indexOf(",")+1)};var M=function(a,b){Ga()&&a instanceof Blob?(this.j=a,b=a.size,a=a.type):(a instanceof ArrayBuffer?(b?this.j=new Uint8Array(a):(this.j=new Uint8Array(a.byteLength),this.j.set(new Uint8Array(a))),b=this.j.length):(b?this.j=a:(this.j=new Uint8Array(a.length),this.j.set(a)),b=a.length),a="");this.a=b;this.b=a};M.prototype.type=function(){return this.b};
M.prototype.slice=function(a,b){if(Ga()&&this.j instanceof Blob)return a=ob(this.j,a,b),null===a?null:new M(a);a=new Uint8Array(this.j.buffer,a,b-a);return new M(a,!0)};
var vb=function(a){var b=[];Array.prototype.push.apply(b,arguments);if(Ga())return b=b.map(function(a){return a instanceof M?a.j:a}),new M(nb.apply(null,b));var b=b.map(function(a){return Fa(a)?ub("raw",a).data:a.j}),c=0;b.forEach(function(a){c+=a.byteLength});var d=new Uint8Array(c),e=0;b.forEach(function(a){for(var b=0;b<a.length;b++)d[e++]=a[b]});return new M(d,!0)};var wb=function(a,b,c){"function"==ea(a)||B(b)||B(c)?(this.b=a,this.error=b||null,this.a=c||null):(this.b=a.next||null,this.error=a.error||null,this.a=a.complete||null)};var N=function(a){if(!a)throw fa();},xb=function(a,b){return function(c,d){var e;a:{try{e=JSON.parse(d)}catch(k){e=null;break a}c=typeof e;e="object"==c&&null!=e||"function"==c?e:null}if(null===e)e=null;else{c={type:"file"};d=b.length;for(var g=0;g<d;g++){var f=b[g];c[f.b]=f.a(c,e[f.c])}Oa(c,a);e=c}N(null!==e);return e}},O=function(a){return function(b,c){b=401===x(b)?new r("unauthenticated","User is not authenticated, please authenticate using Firebase Authentication and try again."):402===x(b)?
new r("quota-exceeded","Quota for bucket '"+a.bucket+"' exceeded, please view quota on https://firebase.google.com/pricing/."):403===x(b)?new r("unauthorized","User does not have permission to access '"+a.path+"'."):c;b.serverResponse=c.serverResponse;return b}},yb=function(a){var b=O(a);return function(c,d){var e=b(c,d);404===x(c)&&(e=new r("object-not-found","Object '"+a.path+"' does not exist."));e.serverResponse=d.serverResponse;return e}},zb=function(a,b,c){var d=za(b);a=new w(v+"/v0"+d,"GET",
xb(a,c),a.c);a.a=yb(b);return a},Ab=function(a,b){var c=za(b);a=new w(v+"/v0"+c,"DELETE",function(){},a.c);a.f=[200,204];a.a=yb(b);return a},Bb=function(a,b,c){c=c?oa(c):{};c.fullPath=a.path;c.size=b.a;c.contentType||(a=b&&b.type()||"application/octet-stream",c.contentType=a);return c},Cb=function(a,b,c,d,e){var g="/b/"+encodeURIComponent(b.bucket)+"/o",f={"X-Goog-Upload-Protocol":"multipart"},k;k="";for(var m=0;2>m;m++)k+=Math.random().toString().slice(2);f["Content-Type"]="multipart/related; boundary="+
k;e=Bb(b,d,e);m=Qa(e,c);d=vb("--"+k+"\r\nContent-Type: application/json; charset=utf-8\r\n\r\n"+m+"\r\n--"+k+"\r\nContent-Type: "+e.contentType+"\r\n\r\n",d,"\r\n--"+k+"--");if(null===d)throw ha();a=new w(v+"/v0"+g,"POST",xb(a,c),a.b);a.b={name:e.fullPath};a.headers=f;a.body=d.j;a.a=O(b);return a},Db=function(a,b,c,d){this.current=a;this.total=b;this.I=!!c;this.metadata=d||null},Eb=function(a,b){var c;try{c=a.h.getResponseHeader("X-Goog-Upload-Status")}catch(d){N(!1)}N(la(b||["active"],c));return c},
Fb=function(a,b,c,d,e){var g="/b/"+encodeURIComponent(b.bucket)+"/o",f=Bb(b,d,e);e={name:f.fullPath};g=v+"/v0"+g;d={"X-Goog-Upload-Protocol":"resumable","X-Goog-Upload-Command":"start","X-Goog-Upload-Header-Content-Length":d.a,"X-Goog-Upload-Header-Content-Type":f.contentType,"Content-Type":"application/json; charset=utf-8"};c=Qa(f,c);a=new w(g,"POST",function(a){Eb(a);var b;try{b=a.h.getResponseHeader("X-Goog-Upload-URL")}catch(z){N(!1)}N(Fa(b));return b},a.b);a.b=e;a.headers=d;a.body=c;a.a=O(b);
return a},Gb=function(a,b,c,d){a=new w(c,"POST",function(a){var b=Eb(a,["active","final"]),c;try{c=a.h.getResponseHeader("X-Goog-Upload-Size-Received")}catch(k){N(!1)}a=c;isFinite(a)&&(a=String(a));a="string"==typeof a?/^\s*-?0x/i.test(a)?parseInt(a,16):parseInt(a,10):NaN;N(!isNaN(a));return new Db(a,d.a,"final"===b)},a.b);a.headers={"X-Goog-Upload-Command":"query"};a.a=O(b);a.g=!1;return a},Hb=function(a,b,c,d,e,g,f,k){var m=new Db(0,0);f?(m.current=f.current,m.total=f.total):(m.current=0,m.total=
d.a);if(d.a!==m.total)throw new r("server-file-wrong-size","Server recorded incorrect upload file size, please retry the upload.");var z=f=m.total-m.current;0<e&&(z=Math.min(z,e));var y=m.current;e={"X-Goog-Upload-Command":z===f?"upload, finalize":"upload","X-Goog-Upload-Offset":m.current};f=d.slice(y,y+z);if(null===f)throw ha();c=new w(c,"POST",function(a,c){var e=Eb(a,["active","final"]),f=m.current+z,k=d.a,y;"final"===e?y=xb(b,g)(a,c):y=null;return new Db(f,k,"final"===e,y)},b.b);c.headers=e;c.body=
f.j;c.c=k||null;c.a=O(a);c.g=!1;return c};var Ib={STATE_CHANGED:"state_changed"},P={RUNNING:"running",PAUSED:"paused",SUCCESS:"success",CANCELED:"canceled",ERROR:"error"},Jb=function(a){switch(a){case "running":case "pausing":case "canceling":return"running";case "paused":return"paused";case "success":return"success";case "canceled":return"canceled";case "error":return"error";default:return"error"}};var ta=function(){var a=this;this.h=new XMLHttpRequest;this.b=0;this.c=ka(function(b){a.h.addEventListener("abort",function(){a.b=2;b(a)});a.h.addEventListener("error",function(){a.b=1;b(a)});a.h.addEventListener("load",function(){b(a)})});this.a=!1},ua=function(a,b,c,d,e){if(a.a)throw u("cannot .send() more than once");a.a=!0;a.h.open(c,b,!0);B(e)&&na(e,function(b,c){a.h.setRequestHeader(b,c.toString())});B(d)?a.h.send(d):a.h.send();return a.c},va=function(a){if(!a.a)throw u("cannot .getErrorCode() before sending");
return a.b},x=function(a){if(!a.a)throw u("cannot .getStatus() before sending");try{return a.h.status}catch(b){return-1}},wa=function(a){if(!a.a)throw u("cannot .getResponseText() before sending");return a.h.responseText};ta.prototype.abort=function(){this.h.abort()};var Kb=function(){};var Q=function(a,b,c,d,e,g){this.b=a;this.i=b;this.f=c;this.a=d;this.g=e;this.c=g};h=Q.prototype;h.X=function(){return this.b};h.sa=function(){return this.i};h.pa=function(){return this.f};h.ka=function(){return this.a};h.Y=function(){if(B(this.a)){var a=this.a.downloadURLs;return B(a)&&B(a[0])?a[0]:null}return null};h.ra=function(){return this.g};h.na=function(){return this.c};var T=function(a,b,c,d,e,g){var f=this;this.O=a;this.c=b;this.o=c;this.f=e;this.i=void 0===g?null:g;this.u=d;this.l=0;this.G=this.w=!1;this.B=[];this.U=262144<this.f.a;this.b="running";this.a=this.A=this.g=null;this.m=1;this.s=function(a){f.a=null;f.m=1;"storage/canceled"===a.code?(f.w=!0,R(f)):(f.g=a,S(f,"error"))};this.N=function(a){f.a=null;"storage/canceled"===a.code?R(f):(f.g=a,S(f,"error"))};this.D=this.v=null;this.F=ka(function(a,b){f.v=a;f.D=b;Lb(f)});this.F.then(null,function(){})},Nb=function(a){var b=
a.l;return function(c){Mb(a,b+c)}},Lb=function(a){"running"===a.b&&null===a.a&&(a.U?null===a.A?Ob(a):a.w?Pb(a):a.G?Qb(a):Rb(a):Sb(a))},U=function(a,b){Ia(a.c).then(function(c){switch(a.b){case "running":b(c);break;case "canceling":S(a,"canceled");break;case "pausing":S(a,"paused")}})},Ob=function(a){U(a,function(b){var c=Fb(a.c,a.o,a.u,a.f,a.i);a.a=D(a.c,c,b);a.a.a().then(function(b){a.a=null;a.A=b;a.w=!1;R(a)},a.s)})},Pb=function(a){var b=a.A;U(a,function(c){var d=Gb(a.c,a.o,b,a.f);a.a=D(a.c,d,c);
a.a.a().then(function(b){a.a=null;Mb(a,b.current);a.w=!1;b.I&&(a.G=!0);R(a)},a.s)})},Rb=function(a){var b=262144*a.m,c=new Db(a.l,a.f.a),d=a.A;U(a,function(e){var g;try{g=Hb(a.o,a.c,d,a.f,b,a.u,c,Nb(a))}catch(f){a.g=f;S(a,"error");return}a.a=D(a.c,g,e);a.a.a().then(function(b){33554432>262144*a.m&&(a.m*=2);a.a=null;Mb(a,b.current);b.I?(a.i=b.metadata,S(a,"success")):R(a)},a.s)})},Qb=function(a){U(a,function(b){var c=zb(a.c,a.o,a.u);a.a=D(a.c,c,b);a.a.a().then(function(b){a.a=null;a.i=b;S(a,"success")},
a.N)})},Sb=function(a){U(a,function(b){var c=Cb(a.c,a.o,a.u,a.f,a.i);a.a=D(a.c,c,b);a.a.a().then(function(b){a.a=null;a.i=b;Mb(a,a.f.a);S(a,"success")},a.s)})},Mb=function(a,b){var c=a.l;a.l=b;a.l!==c&&V(a)},S=function(a,b){if(a.b!==b)switch(b){case "canceling":a.b=b;null!==a.a&&a.a.cancel();break;case "pausing":a.b=b;null!==a.a&&a.a.cancel();break;case "running":var c="paused"===a.b;a.b=b;c&&(V(a),Lb(a));break;case "paused":a.b=b;V(a);break;case "canceled":a.g=ga();a.b=b;V(a);break;case "error":a.b=
b;V(a);break;case "success":a.b=b,V(a)}},R=function(a){switch(a.b){case "pausing":S(a,"paused");break;case "canceling":S(a,"canceled");break;case "running":Lb(a)}};T.prototype.C=function(){return new Q(this.l,this.f.a,Jb(this.b),this.i,this,this.O)};
T.prototype.P=function(a,b,c,d){function e(a){try{f(a);return}catch(C){}try{if(k(a),!(q(a.next)||q(a.error)||q(a.complete)))throw"";}catch(C){throw"Expected a function or an Object with one of `next`, `error`, `complete` properties.";}}function g(a){return function(b,c,d){null!==a&&F("on",a,arguments);var e=new wb(b,c,d);m.B.push(e);Tb(m,e);return function(){var a=m.B,b=a.indexOf(e);-1!==b&&a.splice(b,1)}}}var f=I().a,k=Va(null,!0).a;F("on",[H(function(){if("state_changed"!==a)throw"Expected one of the event types: [state_changed].";
}),Va(e,!0),I(),I()],arguments);var m=this,z=[Va(function(a){if(null===a)throw"Expected a function or an Object with one of `next`, `error`, `complete` properties.";e(a)}),I(),I()];return q(b)||q(c)||q(d)?g(null)(b,c,d):g(z)};T.prototype.then=function(a,b){return this.F.then(void 0===a?null:a,void 0===b?null:b)};T.prototype["catch"]=function(a){return this.then(null,a)};
var V=function(a){Ub(a);Array.prototype.slice.call(a.B).forEach(function(b){Tb(a,b)})},Ub=function(a){if(null!==a.v){var b=!0;switch(Jb(a.b)){case "success":J(a.v.bind(null,a.C()))();break;case "canceled":case "error":J(a.D.bind(null,a.g))();break;default:b=!1}b&&(a.v=null,a.D=null)}},Tb=function(a,b){switch(Jb(a.b)){case "running":case "paused":null!==b.b&&J(b.b.bind(b,a.C()))();break;case "success":null!==b.a&&J(b.a.bind(b))();break;case "canceled":case "error":null!==b.error&&J(b.error.bind(b,
a.g))();break;default:null!==b.error&&J(b.error.bind(b,a.g))()}};T.prototype.T=function(){F("resume",[],arguments);var a="paused"===this.b||"pausing"===this.b;a&&S(this,"running");return a};T.prototype.R=function(){F("pause",[],arguments);var a="running"===this.b;a&&S(this,"pausing");return a};T.prototype.cancel=function(){F("cancel",[],arguments);var a="running"===this.b||"pausing"===this.b;a&&S(this,"canceling");return a};var W=function(a,b){this.a=a;this.location=b instanceof A?b:Aa(b)};W.prototype.toString=function(){F("toString",[],arguments);return"gs://"+this.location.bucket+"/"+this.location.path};var Vb=function(a,b){return new W(a,b)};h=W.prototype;h.J=function(a){F("child",[H()],arguments);var b=Ja(this.location.path,a);return Vb(this.a,new A(this.location.bucket,b))};
h.ma=function(){var a;a=this.location.path;if(0==a.length)a=null;else{var b=a.lastIndexOf("/");a=-1===b?"":a.slice(0,b)}return null===a?null:Vb(this.a,new A(this.location.bucket,a))};h.oa=function(){return Vb(this.a,new A(this.location.bucket,""))};h.W=function(){return this.location.bucket};h.ha=function(){return this.location.path};h.la=function(){return Ka(this.location.path)};h.qa=function(){return this.a.m};
h.aa=function(a,b){F("put",[Ta(),new G(Ra,!0)],arguments);X(this,"put");return new T(this,this.a,this.location,Na(),new M(a),b)};h.ba=function(a,b,c){F("putString",[H(),H(pb,!0),new G(Ra,!0)],arguments);X(this,"putString");var d=ub(B(b)?b:"raw",a),e=c?oa(c):{};!B(e.contentType)&&B(d.a)&&(e.contentType=d.a);return new T(this,this.a,this.location,Na(),new M(d.data,!0),e)};
h.Z=function(){F("delete",[],arguments);X(this,"delete");var a=this;return Ia(this.a).then(function(b){var c=Ab(a.a,a.location);return D(a.a,c,b).a()})};h.K=function(){F("getMetadata",[],arguments);X(this,"getMetadata");var a=this;return Ia(this.a).then(function(b){var c=zb(a.a,a.location,Na());return D(a.a,c,b).a()})};
h.ca=function(a){F("updateMetadata",[new G(Ra,void 0)],arguments);X(this,"updateMetadata");var b=this;return Ia(this.a).then(function(c){var d=b.a,e=b.location,g=a,f=Na(),k=za(e),k=v+"/v0"+k,g=Qa(g,f),d=new w(k,"PATCH",xb(d,f),d.c);d.headers={"Content-Type":"application/json; charset=utf-8"};d.body=g;d.a=yb(e);return D(b.a,d,c).a()})};
h.$=function(){F("getDownloadURL",[],arguments);X(this,"getDownloadURL");return this.K().then(function(a){a=a.downloadURLs[0];if(B(a))return a;throw new r("no-download-url","The given file does not have any download URLs.");})};var X=function(a,b){if(""===a.location.path)throw new r("invalid-root-operation","The operation '"+b+"' cannot be performed on a root reference, create a non-root reference using child, such as .child('file.png').");};var Y=function(a,b,c){this.a=new Ha(a,function(a,b){return new W(a,b)},xa,this,b);this.c=a;q(c)?this.b=Ba(c):null!=this.a.bucket()&&(this.b=new A(this.a.bucket(),""));this.f=new Wb(this)};h=Y.prototype;h.da=function(a){F("ref",[H(function(a){if(/^[A-Za-z]+:\/\//.test(a))throw"Expected child path but got a URL, use refFromURL instead.";},!0)],arguments);if(null===this.b)throw Error("No Storage Bucket defined in Firebase Options.");var b=new W(this.a,this.b);return q(a)?b.J(a):b};
h.ea=function(a){F("refFromURL",[H(function(a){if(!/^[A-Za-z]+:\/\//.test(a))throw"Expected full URL but got a child path, use ref instead.";try{Aa(a)}catch(c){throw"Expected valid full URL but got an invalid one.";}},!1)],arguments);return new W(this.a,a)};h.ja=function(){return this.a.b};h.ga=function(a){F("setMaxUploadRetryTime",[Ua()],arguments);this.a.b=a};h.ia=function(){return this.a.c};h.fa=function(a){F("setMaxOperationRetryTime",[Ua()],arguments);this.a.c=a};h.V=function(){return this.c};
h.S=function(){return this.f};var Wb=function(a){this.a=a};Wb.prototype.b=function(){var a=this.a.a;a.f=!0;a.a=null;Ea(a.i)};var Z=function(a,b,c){Object.defineProperty(a,b,{get:c})};W.prototype.toString=W.prototype.toString;W.prototype.child=W.prototype.J;W.prototype.put=W.prototype.aa;W.prototype.putString=W.prototype.ba;W.prototype["delete"]=W.prototype.Z;W.prototype.getMetadata=W.prototype.K;W.prototype.updateMetadata=W.prototype.ca;W.prototype.getDownloadURL=W.prototype.$;Z(W.prototype,"parent",W.prototype.ma);Z(W.prototype,"root",W.prototype.oa);Z(W.prototype,"bucket",W.prototype.W);Z(W.prototype,"fullPath",W.prototype.ha);
Z(W.prototype,"name",W.prototype.la);Z(W.prototype,"storage",W.prototype.qa);Y.prototype.ref=Y.prototype.da;Y.prototype.refFromURL=Y.prototype.ea;Z(Y.prototype,"maxOperationRetryTime",Y.prototype.ia);Y.prototype.setMaxOperationRetryTime=Y.prototype.fa;Z(Y.prototype,"maxUploadRetryTime",Y.prototype.ja);Y.prototype.setMaxUploadRetryTime=Y.prototype.ga;Z(Y.prototype,"app",Y.prototype.V);Z(Y.prototype,"INTERNAL",Y.prototype.S);Wb.prototype["delete"]=Wb.prototype.b;Y.prototype.capi_=function(a){v=a};
T.prototype.on=T.prototype.P;T.prototype.resume=T.prototype.T;T.prototype.pause=T.prototype.R;T.prototype.cancel=T.prototype.cancel;T.prototype.then=T.prototype.then;T.prototype["catch"]=T.prototype["catch"];Z(T.prototype,"snapshot",T.prototype.C);Z(Q.prototype,"bytesTransferred",Q.prototype.X);Z(Q.prototype,"totalBytes",Q.prototype.sa);Z(Q.prototype,"state",Q.prototype.pa);Z(Q.prototype,"metadata",Q.prototype.ka);Z(Q.prototype,"downloadURL",Q.prototype.Y);Z(Q.prototype,"task",Q.prototype.ra);
Z(Q.prototype,"ref",Q.prototype.na);Ib.STATE_CHANGED="state_changed";P.RUNNING="running";P.PAUSED="paused";P.SUCCESS="success";P.CANCELED="canceled";P.ERROR="error";L.RAW="raw";L.BASE64="base64";L.BASE64URL="base64url";L.DATA_URL="data_url";
(function(){function a(a,b,e){return new Y(a,new Kb,e)}var b={TaskState:P,TaskEvent:Ib,StringFormat:L,Storage:Y,Reference:W};if("undefined"!==typeof firebase)firebase.INTERNAL.registerService("storage",a,b,void 0,!0);else throw Error("Cannot install Firebase Storage - be sure to load firebase-app.js first.");})();}).call(this);
}).call(typeof global !== undefined ? global : typeof self !== undefined ? self : typeof window !== undefined ? window : {});
module.exports = firebase.storage;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/*!
 * GeoFire is an open-source library that allows you to store and query a set
 * of keys based on their geographic location. At its heart, GeoFire simply
 * stores locations with string keys. Its main benefit, however, is the
 * possibility of retrieving only those keys within a given geographic area -
 * all in realtime.
 *
 * GeoFire 4.1.2
 * https://github.com/firebase/geofire-js/
 * License: MIT
 */

var GeoFire = (function() {
  "use strict";

/**
 * Creates a GeoCallbackRegistration instance.
 *
 * @constructor
 * @this {GeoCallbackRegistration}
 * @callback cancelCallback Callback to run when this callback registration is cancelled.
 */
var GeoCallbackRegistration = function(cancelCallback) {
  /********************/
  /*  PUBLIC METHODS  */
  /********************/
  /**
   * Cancels this callback registration so that it no longer fires its callback. This
   * has no effect on any other callback registrations you may have created.
   */
  this.cancel = function() {
    if (typeof _cancelCallback !== "undefined") {
      _cancelCallback();
      _cancelCallback = undefined;
    }
  };

  /*****************/
  /*  CONSTRUCTOR  */
  /*****************/
  if (typeof cancelCallback !== "function") {
    throw new Error("callback must be a function");
  }

  var _cancelCallback = cancelCallback;
};
/**
 * Creates a GeoFire instance.
 *
 * @constructor
 * @this {GeoFire}
 * @param {Firebase} firebaseRef A Firebase reference where the GeoFire data will be stored.
 */
var GeoFire = function(firebaseRef) {
  /********************/
  /*  PUBLIC METHODS  */
  /********************/
  /**
   * Returns the Firebase instance used to create this GeoFire instance.
   *
   * @return {Firebase} The Firebase instance used to create this GeoFire instance.
   */
  this.ref = function() {
    return _firebaseRef;
  };

  /**
   * Adds the provided key - location pair(s) to Firebase. Returns an empty promise which is fulfilled when the write is complete.
   *
   * If any provided key already exists in this GeoFire, it will be overwritten with the new location value.
   *
   * @param {string|Object} keyOrLocations The key representing the location to add or a mapping of key - location pairs which
   * represent the locations to add.
   * @param {Array.<number>|undefined} location The [latitude, longitude] pair to add.
   * @return {Promise.<>} A promise that is fulfilled when the write is complete.
   */
  this.set = function(keyOrLocations, location) {
    var locations;
    if (typeof keyOrLocations === "string" && keyOrLocations.length !== 0) {
      // If this is a set for a single location, convert it into a object
      locations = {};
      locations[keyOrLocations] = location;
    } else if (typeof keyOrLocations === "object") {
      if (typeof location !== "undefined") {
        throw new Error("The location argument should not be used if you pass an object to set().");
      }
      locations = keyOrLocations;
    } else {
      throw new Error("keyOrLocations must be a string or a mapping of key - location pairs.");
    }

    var newData = {};

    Object.keys(locations).forEach(function(key) {
      validateKey(key);

      var location = locations[key];
      if (location === null) {
        // Setting location to null is valid since it will remove the key
        newData[key] = null;
      } else {
        validateLocation(location);

        var geohash = encodeGeohash(location);
        newData[key] = encodeGeoFireObject(location, geohash);
      }
    });

    return _firebaseRef.update(newData);
  };

  /**
   * Returns a promise fulfilled with the location corresponding to the provided key.
   *
   * If the provided key does not exist, the returned promise is fulfilled with null.
   *
   * @param {string} key The key of the location to retrieve.
   * @return {Promise.<Array.<number>>} A promise that is fulfilled with the location of the given key.
   */
  this.get = function(key) {
    validateKey(key);
    return _firebaseRef.child(key).once("value").then(function(dataSnapshot) {
      var snapshotVal = dataSnapshot.val();
      if (snapshotVal === null) {
        return null;
      } else {
        return decodeGeoFireObject(snapshotVal);
      }
    });
  };

  /**
   * Removes the provided key from this GeoFire. Returns an empty promise fulfilled when the key has been removed.
   *
   * If the provided key is not in this GeoFire, the promise will still successfully resolve.
   *
   * @param {string} key The key of the location to remove.
   * @return {Promise.<string>} A promise that is fulfilled after the inputted key is removed.
   */
  this.remove = function(key) {
    return this.set(key, null);
  };

  /**
   * Returns a new GeoQuery instance with the provided queryCriteria.
   *
   * @param {Object} queryCriteria The criteria which specifies the GeoQuery's center and radius.
   * @return {GeoQuery} A new GeoQuery object.
   */
  this.query = function(queryCriteria) {
    return new GeoQuery(_firebaseRef, queryCriteria);
  };

  /*****************/
  /*  CONSTRUCTOR  */
  /*****************/
  if (Object.prototype.toString.call(firebaseRef) !== "[object Object]") {
    throw new Error("firebaseRef must be an instance of Firebase");
  }

  var _firebaseRef = firebaseRef;
};

/**
 * Static method which calculates the distance, in kilometers, between two locations,
 * via the Haversine formula. Note that this is approximate due to the fact that the
 * Earth's radius varies between 6356.752 km and 6378.137 km.
 *
 * @param {Array.<number>} location1 The [latitude, longitude] pair of the first location.
 * @param {Array.<number>} location2 The [latitude, longitude] pair of the second location.
 * @return {number} The distance, in kilometers, between the inputted locations.
 */
GeoFire.distance = function(location1, location2) {
  validateLocation(location1);
  validateLocation(location2);

  var radius = 6371; // Earth's radius in kilometers
  var latDelta = degreesToRadians(location2[0] - location1[0]);
  var lonDelta = degreesToRadians(location2[1] - location1[1]);

  var a = (Math.sin(latDelta / 2) * Math.sin(latDelta / 2)) +
          (Math.cos(degreesToRadians(location1[0])) * Math.cos(degreesToRadians(location2[0])) *
          Math.sin(lonDelta / 2) * Math.sin(lonDelta / 2));

  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return radius * c;
};

// Default geohash length
var g_GEOHASH_PRECISION = 10;

// Characters used in location geohashes
var g_BASE32 = "0123456789bcdefghjkmnpqrstuvwxyz";

// The meridional circumference of the earth in meters
var g_EARTH_MERI_CIRCUMFERENCE = 40007860;

// Length of a degree latitude at the equator
var g_METERS_PER_DEGREE_LATITUDE = 110574;

// Number of bits per geohash character
var g_BITS_PER_CHAR = 5;

// Maximum length of a geohash in bits
var g_MAXIMUM_BITS_PRECISION = 22*g_BITS_PER_CHAR;

// Equatorial radius of the earth in meters
var g_EARTH_EQ_RADIUS = 6378137.0;

// The following value assumes a polar radius of
// var g_EARTH_POL_RADIUS = 6356752.3;
// The formulate to calculate g_E2 is
// g_E2 == (g_EARTH_EQ_RADIUS^2-g_EARTH_POL_RADIUS^2)/(g_EARTH_EQ_RADIUS^2)
// The exact value is used here to avoid rounding errors
var g_E2 = 0.00669447819799;

// Cutoff for rounding errors on double calculations
var g_EPSILON = 1e-12;

Math.log2 = Math.log2 || function(x) {
  return Math.log(x)/Math.log(2);
};

/**
 * Validates the inputted key and throws an error if it is invalid.
 *
 * @param {string} key The key to be verified.
 */
var validateKey = function(key) {
  var error;

  if (typeof key !== "string") {
    error = "key must be a string";
  }
  else if (key.length === 0) {
    error = "key cannot be the empty string";
  }
  else if (1 + g_GEOHASH_PRECISION + key.length > 755) {
    // Firebase can only stored child paths up to 768 characters
    // The child path for this key is at the least: "i/<geohash>key"
    error = "key is too long to be stored in Firebase";
  }
  else if (/[\[\].#$\/\u0000-\u001F\u007F]/.test(key)) {
    // Firebase does not allow node keys to contain the following characters
    error = "key cannot contain any of the following characters: . # $ ] [ /";
  }

  if (typeof error !== "undefined") {
    throw new Error("Invalid GeoFire key '" + key + "': " + error);
  }
};

/**
 * Validates the inputted location and throws an error if it is invalid.
 *
 * @param {Array.<number>} location The [latitude, longitude] pair to be verified.
 */
var validateLocation = function(location) {
  var error;

  if (!Array.isArray(location)) {
    error = "location must be an array";
  }
  else if (location.length !== 2) {
    error = "expected array of length 2, got length " + location.length;
  }
  else {
    var latitude = location[0];
    var longitude = location[1];

    if (typeof latitude !== "number" || isNaN(latitude)) {
      error = "latitude must be a number";
    }
    else if (latitude < -90 || latitude > 90) {
      error = "latitude must be within the range [-90, 90]";
    }
    else if (typeof longitude !== "number" || isNaN(longitude)) {
      error = "longitude must be a number";
    }
    else if (longitude < -180 || longitude > 180) {
      error = "longitude must be within the range [-180, 180]";
    }
  }

  if (typeof error !== "undefined") {
    throw new Error("Invalid GeoFire location '" + location + "': " + error);
  }
};

/**
 * Validates the inputted geohash and throws an error if it is invalid.
 *
 * @param {string} geohash The geohash to be validated.
 */
var validateGeohash = function(geohash) {
  var error;

  if (typeof geohash !== "string") {
    error = "geohash must be a string";
  }
  else if (geohash.length === 0) {
    error = "geohash cannot be the empty string";
  }
  else {
    for (var i = 0, length = geohash.length; i < length; ++i) {
      if (g_BASE32.indexOf(geohash[i]) === -1) {
        error = "geohash cannot contain \"" + geohash[i] + "\"";
      }
    }
  }

  if (typeof error !== "undefined") {
    throw new Error("Invalid GeoFire geohash '" + geohash + "': " + error);
  }
};

/**
 * Validates the inputted query criteria and throws an error if it is invalid.
 *
 * @param {Object} newQueryCriteria The criteria which specifies the query's center and/or radius.
 */
var validateCriteria = function(newQueryCriteria, requireCenterAndRadius) {
  if (typeof newQueryCriteria !== "object") {
    throw new Error("query criteria must be an object");
  }
  else if (typeof newQueryCriteria.center === "undefined" && typeof newQueryCriteria.radius === "undefined") {
    throw new Error("radius and/or center must be specified");
  }
  else if (requireCenterAndRadius && (typeof newQueryCriteria.center === "undefined" || typeof newQueryCriteria.radius === "undefined")) {
    throw new Error("query criteria for a new query must contain both a center and a radius");
  }

  // Throw an error if there are any extraneous attributes
  var keys = Object.keys(newQueryCriteria);
  var numKeys = keys.length;
  for (var i = 0; i < numKeys; ++i) {
    var key = keys[i];
    if (key !== "center" && key !== "radius") {
      throw new Error("Unexpected attribute '" + key + "'' found in query criteria");
    }
  }

  // Validate the "center" attribute
  if (typeof newQueryCriteria.center !== "undefined") {
    validateLocation(newQueryCriteria.center);
  }

  // Validate the "radius" attribute
  if (typeof newQueryCriteria.radius !== "undefined") {
    if (typeof newQueryCriteria.radius !== "number" || isNaN(newQueryCriteria.radius)) {
      throw new Error("radius must be a number");
    }
    else if (newQueryCriteria.radius < 0) {
      throw new Error("radius must be greater than or equal to 0");
    }
  }
};

/**
 * Converts degrees to radians.
 *
 * @param {number} degrees The number of degrees to be converted to radians.
 * @return {number} The number of radians equal to the inputted number of degrees.
 */
var degreesToRadians = function(degrees) {
  if (typeof degrees !== "number" || isNaN(degrees)) {
    throw new Error("Error: degrees must be a number");
  }

  return (degrees * Math.PI / 180);
};

/**
 * Generates a geohash of the specified precision/string length from the  [latitude, longitude]
 * pair, specified as an array.
 *
 * @param {Array.<number>} location The [latitude, longitude] pair to encode into a geohash.
 * @param {number=} precision The length of the geohash to create. If no precision is
 * specified, the global default is used.
 * @return {string} The geohash of the inputted location.
 */
var encodeGeohash = function(location, precision) {
  validateLocation(location);
  if (typeof precision !== "undefined") {
    if (typeof precision !== "number" || isNaN(precision)) {
      throw new Error("precision must be a number");
    }
    else if (precision <= 0) {
      throw new Error("precision must be greater than 0");
    }
    else if (precision > 22) {
      throw new Error("precision cannot be greater than 22");
    }
    else if (Math.round(precision) !== precision) {
      throw new Error("precision must be an integer");
    }
  }

  // Use the global precision default if no precision is specified
  precision = precision || g_GEOHASH_PRECISION;

  var latitudeRange = {
    min: -90,
    max: 90
  };
  var longitudeRange = {
    min: -180,
    max: 180
  };
  var hash = "";
  var hashVal = 0;
  var bits = 0;
  var even = 1;

  while (hash.length < precision) {
    var val = even ? location[1] : location[0];
    var range = even ? longitudeRange : latitudeRange;
    var mid = (range.min + range.max) / 2;

    /* jshint -W016 */
    if (val > mid) {
      hashVal = (hashVal << 1) + 1;
      range.min = mid;
    }
    else {
      hashVal = (hashVal << 1) + 0;
      range.max = mid;
    }
    /* jshint +W016 */

    even = !even;
    if (bits < 4) {
      bits++;
    }
    else {
      bits = 0;
      hash += g_BASE32[hashVal];
      hashVal = 0;
    }
  }

  return hash;
};

/**
 * Calculates the number of degrees a given distance is at a given latitude.
 *
 * @param {number} distance The distance to convert.
 * @param {number} latitude The latitude at which to calculate.
 * @return {number} The number of degrees the distance corresponds to.
 */
var metersToLongitudeDegrees = function(distance, latitude) {
  var radians = degreesToRadians(latitude);
  var num = Math.cos(radians)*g_EARTH_EQ_RADIUS*Math.PI/180;
  var denom = 1/Math.sqrt(1-g_E2*Math.sin(radians)*Math.sin(radians));
  var deltaDeg = num*denom;
  if (deltaDeg  < g_EPSILON) {
    return distance > 0 ? 360 : 0;
  }
  else {
    return Math.min(360, distance/deltaDeg);
  }
};

/**
 * Calculates the bits necessary to reach a given resolution, in meters, for the longitude at a
 * given latitude.
 *
 * @param {number} resolution The desired resolution.
 * @param {number} latitude The latitude used in the conversion.
 * @return {number} The bits necessary to reach a given resolution, in meters.
 */
var longitudeBitsForResolution = function(resolution, latitude) {
  var degs = metersToLongitudeDegrees(resolution, latitude);
  return (Math.abs(degs) > 0.000001) ?  Math.max(1, Math.log2(360/degs)) : 1;
};

/**
 * Calculates the bits necessary to reach a given resolution, in meters, for the latitude.
 *
 * @param {number} resolution The bits necessary to reach a given resolution, in meters.
 */
var latitudeBitsForResolution = function(resolution) {
  return Math.min(Math.log2(g_EARTH_MERI_CIRCUMFERENCE/2/resolution), g_MAXIMUM_BITS_PRECISION);
};

/**
 * Wraps the longitude to [-180,180].
 *
 * @param {number} longitude The longitude to wrap.
 * @return {number} longitude The resulting longitude.
 */
var wrapLongitude = function(longitude) {
  if (longitude <= 180 && longitude >= -180) {
    return longitude;
  }
  var adjusted = longitude + 180;
  if (adjusted > 0) {
    return (adjusted % 360) - 180;
  }
  else {
    return 180 - (-adjusted % 360);
  }
};

/**
 * Calculates the maximum number of bits of a geohash to get a bounding box that is larger than a
 * given size at the given coordinate.
 *
 * @param {Array.<number>} coordinate The coordinate as a [latitude, longitude] pair.
 * @param {number} size The size of the bounding box.
 * @return {number} The number of bits necessary for the geohash.
 */
var boundingBoxBits = function(coordinate, size) {
  var latDeltaDegrees = size/g_METERS_PER_DEGREE_LATITUDE;
  var latitudeNorth = Math.min(90, coordinate[0] + latDeltaDegrees);
  var latitudeSouth = Math.max(-90, coordinate[0] - latDeltaDegrees);
  var bitsLat = Math.floor(latitudeBitsForResolution(size))*2;
  var bitsLongNorth = Math.floor(longitudeBitsForResolution(size, latitudeNorth))*2-1;
  var bitsLongSouth = Math.floor(longitudeBitsForResolution(size, latitudeSouth))*2-1;
  return Math.min(bitsLat, bitsLongNorth, bitsLongSouth, g_MAXIMUM_BITS_PRECISION);
};

/**
 * Calculates eight points on the bounding box and the center of a given circle. At least one
 * geohash of these nine coordinates, truncated to a precision of at most radius, are guaranteed
 * to be prefixes of any geohash that lies within the circle.
 *
 * @param {Array.<number>} center The center given as [latitude, longitude].
 * @param {number} radius The radius of the circle.
 * @return {Array.<Array.<number>>} The eight bounding box points.
 */
var boundingBoxCoordinates = function(center, radius) {
  var latDegrees = radius/g_METERS_PER_DEGREE_LATITUDE;
  var latitudeNorth = Math.min(90, center[0] + latDegrees);
  var latitudeSouth = Math.max(-90, center[0] - latDegrees);
  var longDegsNorth = metersToLongitudeDegrees(radius, latitudeNorth);
  var longDegsSouth = metersToLongitudeDegrees(radius, latitudeSouth);
  var longDegs = Math.max(longDegsNorth, longDegsSouth);
  return [
    [center[0], center[1]],
    [center[0], wrapLongitude(center[1] - longDegs)],
    [center[0], wrapLongitude(center[1] + longDegs)],
    [latitudeNorth, center[1]],
    [latitudeNorth, wrapLongitude(center[1] - longDegs)],
    [latitudeNorth, wrapLongitude(center[1] + longDegs)],
    [latitudeSouth, center[1]],
    [latitudeSouth, wrapLongitude(center[1] - longDegs)],
    [latitudeSouth, wrapLongitude(center[1] + longDegs)]
  ];
};

/**
 * Calculates the bounding box query for a geohash with x bits precision.
 *
 * @param {string} geohash The geohash whose bounding box query to generate.
 * @param {number} bits The number of bits of precision.
 * @return {Array.<string>} A [start, end] pair of geohashes.
 */
var geohashQuery = function(geohash, bits) {
  validateGeohash(geohash);
  var precision = Math.ceil(bits/g_BITS_PER_CHAR);
  if (geohash.length < precision) {
    return [geohash, geohash+"~"];
  }
  geohash = geohash.substring(0, precision);
  var base = geohash.substring(0, geohash.length - 1);
  var lastValue = g_BASE32.indexOf(geohash.charAt(geohash.length - 1));
  var significantBits = bits - (base.length*g_BITS_PER_CHAR);
  var unusedBits = (g_BITS_PER_CHAR - significantBits);
  /*jshint bitwise: false*/
  // delete unused bits
  var startValue = (lastValue >> unusedBits) << unusedBits;
  var endValue = startValue + (1 << unusedBits);
  /*jshint bitwise: true*/
  if (endValue > 31) {
    return [base+g_BASE32[startValue], base+"~"];
  }
  else {
    return [base+g_BASE32[startValue], base+g_BASE32[endValue]];
  }
};

/**
 * Calculates a set of queries to fully contain a given circle. A query is a [start, end] pair
 * where any geohash is guaranteed to be lexiographically larger then start and smaller than end.
 *
 * @param {Array.<number>} center The center given as [latitude, longitude] pair.
 * @param {number} radius The radius of the circle.
 * @return {Array.<Array.<string>>} An array of geohashes containing a [start, end] pair.
 */
var geohashQueries = function(center, radius) {
  validateLocation(center);
  var queryBits = Math.max(1, boundingBoxBits(center, radius));
  var geohashPrecision = Math.ceil(queryBits/g_BITS_PER_CHAR);
  var coordinates = boundingBoxCoordinates(center, radius);
  var queries = coordinates.map(function(coordinate) {
    return geohashQuery(encodeGeohash(coordinate, geohashPrecision), queryBits);
  });
  // remove duplicates
  return queries.filter(function(query, index) {
    return !queries.some(function(other, otherIndex) {
      return index > otherIndex && query[0] === other[0] && query[1] === other[1];
    });
  });
};

/**
 * Encodes a location and geohash as a GeoFire object.
 *
 * @param {Array.<number>} location The location as [latitude, longitude] pair.
 * @param {string} geohash The geohash of the location.
 * @return {Object} The location encoded as GeoFire object.
 */
function encodeGeoFireObject(location, geohash) {
  validateLocation(location);
  validateGeohash(geohash);
  return {
    ".priority": geohash,
    "g": geohash,
    "l": location
  };
}

/**
 * Decodes the location given as GeoFire object. Returns null if decoding fails.
 *
 * @param {Object} geoFireObj The location encoded as GeoFire object.
 * @return {?Array.<number>} location The location as [latitude, longitude] pair or null if
 * decoding fails.
 */
function decodeGeoFireObject(geoFireObj) {
  if (geoFireObj !== null && geoFireObj.hasOwnProperty("l") && Array.isArray(geoFireObj.l) && geoFireObj.l.length === 2) {
    return geoFireObj.l;
  } else {
    throw new Error("Unexpected GeoFire location object encountered: " + JSON.stringify(geoFireObj));
  }
}

/**
 * Returns the key of a Firebase snapshot across SDK versions.
 *
 * @param {DataSnapshot} snapshot A Firebase snapshot.
 * @return {string|null} key The Firebase snapshot's key.
 */
 function getKey(snapshot) {
   var key;
   if (typeof snapshot.key === "function") {
     key = snapshot.key();
   } else if (typeof snapshot.key === "string" || snapshot.key === null) {
     key = snapshot.key;
   } else {
     key = snapshot.name();
   }
   return key;
 }

/**
 * Creates a GeoQuery instance.
 *
 * @constructor
 * @this {GeoQuery}
 * @param {Firebase} firebaseRef A Firebase reference.
 * @param {Object} queryCriteria The criteria which specifies the query's center and radius.
 */
var GeoQuery = function (firebaseRef, queryCriteria) {
  /*********************/
  /*  PRIVATE METHODS  */
  /*********************/
  /**
   * Fires each callback for the provided eventType, passing it provided key's data.
   *
   * @param {string} eventType The event type whose callbacks to fire. One of "key_entered", "key_exited", or "key_moved".
   * @param {string} key The key of the location for which to fire the callbacks.
   * @param {?Array.<number>} location The location as [latitude, longitude] pair
   * @param {?double} distanceFromCenter The distance from the center or null.
   */
  function _fireCallbacksForKey(eventType, key, location, distanceFromCenter) {
    _callbacks[eventType].forEach(function(callback) {
      if (typeof location === "undefined" || location === null) {
        callback(key, null, null);
      }
      else {
        callback(key, location, distanceFromCenter);
      }
    });
  }

  /**
   * Fires each callback for the "ready" event.
   */
  function _fireReadyEventCallbacks() {
    _callbacks.ready.forEach(function(callback) {
      callback();
    });
  }

  /**
   * Decodes a query string to a query
   *
   * @param {string} str The encoded query.
   * @return {Array.<string>} The decoded query as a [start, end] pair.
   */
  function _stringToQuery(string) {
    var decoded = string.split(":");
    if (decoded.length !== 2) {
      throw new Error("Invalid internal state! Not a valid geohash query: " + string);
    }
    return decoded;
  }

  /**
   * Encodes a query as a string for easier indexing and equality.
   *
   * @param {Array.<string>} query The query to encode.
   * @param {string} The encoded query as string.
   */
  function _queryToString(query) {
    if (query.length !== 2) {
      throw new Error("Not a valid geohash query: " + query);
    }
    return query[0]+":"+query[1];
  }

  /**
   * Turns off all callbacks for the provide geohash query.
   *
   * @param {Array.<string>} query The geohash query.
   * @param {Object} queryState An object storing the current state of the query.
   */
  function _cancelGeohashQuery(query, queryState) {
    var queryRef = _firebaseRef.orderByChild("g").startAt(query[0]).endAt(query[1]);
    queryRef.off("child_added", queryState.childAddedCallback);
    queryRef.off("child_removed", queryState.childRemovedCallback);
    queryRef.off("child_changed", queryState.childChangedCallback);
    queryRef.off("value", queryState.valueCallback);
  }

  /**
   * Removes unnecessary Firebase queries which are currently being queried.
   */
  function _cleanUpCurrentGeohashesQueried() {
    var keys = Object.keys(_currentGeohashesQueried);
    var numKeys = keys.length;
    for (var i = 0; i < numKeys; ++i) {
      var geohashQueryStr = keys[i];
      var queryState = _currentGeohashesQueried[geohashQueryStr];
      if (queryState.active === false) {
        var query = _stringToQuery(geohashQueryStr);
        // Delete the geohash since it should no longer be queried
        _cancelGeohashQuery(query, queryState);
        delete _currentGeohashesQueried[geohashQueryStr];
      }
    }

    // Delete each location which should no longer be queried
    keys = Object.keys(_locationsTracked);
    numKeys = keys.length;
    for (i = 0; i < numKeys; ++i) {
      var key = keys[i];
      if (!_geohashInSomeQuery(_locationsTracked[key].geohash)) {
        if (_locationsTracked[key].isInQuery) {
          throw new Error("Internal State error, trying to remove location that is still in query");
        }
        delete _locationsTracked[key];
      }
    }

    // Specify that this is done cleaning up the current geohashes queried
    _geohashCleanupScheduled = false;

    // Cancel any outstanding scheduled cleanup
    if (_cleanUpCurrentGeohashesQueriedTimeout !== null) {
      clearTimeout(_cleanUpCurrentGeohashesQueriedTimeout);
      _cleanUpCurrentGeohashesQueriedTimeout = null;
    }
  }

  /**
   * Callback for any updates to locations. Will update the information about a key and fire any necessary
   * events every time the key's location changes.
   *
   * When a key is removed from GeoFire or the query, this function will be called with null and performs
   * any necessary cleanup.
   *
   * @param {string} key The key of the geofire location.
   * @param {?Array.<number>} location The location as [latitude, longitude] pair.
   */
  function _updateLocation(key, location) {
    validateLocation(location);
    // Get the key and location
    var distanceFromCenter, isInQuery;
    var wasInQuery = (_locationsTracked.hasOwnProperty(key)) ? _locationsTracked[key].isInQuery : false;
    var oldLocation = (_locationsTracked.hasOwnProperty(key)) ? _locationsTracked[key].location : null;

    // Determine if the location is within this query
    distanceFromCenter = GeoFire.distance(location, _center);
    isInQuery = (distanceFromCenter <= _radius);

    // Add this location to the locations queried dictionary even if it is not within this query
    _locationsTracked[key] = {
      location: location,
      distanceFromCenter: distanceFromCenter,
      isInQuery: isInQuery,
      geohash: encodeGeohash(location, g_GEOHASH_PRECISION)
    };

    // Fire the "key_entered" event if the provided key has entered this query
    if (isInQuery && !wasInQuery) {
      _fireCallbacksForKey("key_entered", key, location, distanceFromCenter);
    } else if (isInQuery && oldLocation !== null && (location[0] !== oldLocation[0] || location[1] !== oldLocation[1])) {
      _fireCallbacksForKey("key_moved", key, location, distanceFromCenter);
    } else if (!isInQuery && wasInQuery) {
      _fireCallbacksForKey("key_exited", key, location, distanceFromCenter);
    }
  }

  /**
   * Checks if this geohash is currently part of any of the geohash queries.
   *
   * @param {string} geohash The geohash.
   * @param {boolean} Returns true if the geohash is part of any of the current geohash queries.
   */
  function _geohashInSomeQuery(geohash) {
    var keys = Object.keys(_currentGeohashesQueried);
    var numKeys = keys.length;
    for (var i = 0; i < numKeys; ++i) {
      var queryStr = keys[i];
      if (_currentGeohashesQueried.hasOwnProperty(queryStr)) {
        var query = _stringToQuery(queryStr);
        if (geohash >= query[0] && geohash <= query[1]) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * Removes the location from the local state and fires any events if necessary.
   *
   * @param {string} key The key to be removed.
   * @param {?Array.<number>} currentLocation The current location as [latitude, longitude] pair
   * or null if removed.
   */
  function _removeLocation(key, currentLocation) {
    var locationDict = _locationsTracked[key];
    delete _locationsTracked[key];
    if (typeof locationDict !== "undefined" && locationDict.isInQuery) {
      var distanceFromCenter = (currentLocation) ? GeoFire.distance(currentLocation, _center) : null;
      _fireCallbacksForKey("key_exited", key, currentLocation, distanceFromCenter);
    }
  }

  /**
   * Callback for child added events.
   *
   * @param {Firebase DataSnapshot} locationDataSnapshot A snapshot of the data stored for this location.
   */
  function _childAddedCallback(locationDataSnapshot) {
    _updateLocation(getKey(locationDataSnapshot), decodeGeoFireObject(locationDataSnapshot.val()));
  }

  /**
   * Callback for child changed events
   *
   * @param {Firebase DataSnapshot} locationDataSnapshot A snapshot of the data stored for this location.
   */
  function _childChangedCallback(locationDataSnapshot) {
    _updateLocation(getKey(locationDataSnapshot), decodeGeoFireObject(locationDataSnapshot.val()));
  }

  /**
   * Callback for child removed events
   *
   * @param {Firebase DataSnapshot} locationDataSnapshot A snapshot of the data stored for this location.
   */
  function _childRemovedCallback(locationDataSnapshot) {
    var key = getKey(locationDataSnapshot);
    if (_locationsTracked.hasOwnProperty(key)) {
      _firebaseRef.child(key).once("value", function(snapshot) {
        var location = snapshot.val() === null ? null : decodeGeoFireObject(snapshot.val());
        var geohash = (location !== null) ? encodeGeohash(location) : null;
        // Only notify observers if key is not part of any other geohash query or this actually might not be
        // a key exited event, but a key moved or entered event. These events will be triggered by updates
        // to a different query
        if (!_geohashInSomeQuery(geohash)) {
          _removeLocation(key, location);
        }
      });
    }
  }

  /**
   * Called once all geohash queries have received all child added events and fires the ready
   * event if necessary.
   */
  function _geohashQueryReadyCallback(queryStr) {
    var index = _outstandingGeohashReadyEvents.indexOf(queryStr);
    if (index > -1) {
      _outstandingGeohashReadyEvents.splice(index, 1);
    }
    _valueEventFired = (_outstandingGeohashReadyEvents.length === 0);

    // If all queries have been processed, fire the ready event
    if (_valueEventFired) {
      _fireReadyEventCallbacks();
    }
  }

  /**
   * Attaches listeners to Firebase which track when new geohashes are added within this query's
   * bounding box.
   */
  function _listenForNewGeohashes() {
    // Get the list of geohashes to query
    var geohashesToQuery = geohashQueries(_center, _radius*1000).map(_queryToString);

    // Filter out duplicate geohashes
    geohashesToQuery = geohashesToQuery.filter(function(geohash, i){
      return geohashesToQuery.indexOf(geohash) === i;
    });

    // For all of the geohashes that we are already currently querying, check if they are still
    // supposed to be queried. If so, don't re-query them. Otherwise, mark them to be un-queried
    // next time we clean up the current geohashes queried dictionary.
    var keys = Object.keys(_currentGeohashesQueried);
    var numKeys = keys.length;
    for (var i = 0; i < numKeys; ++i) {
      var geohashQueryStr = keys[i];
      var index = geohashesToQuery.indexOf(geohashQueryStr);
      if (index === -1) {
        _currentGeohashesQueried[geohashQueryStr].active = false;
      }
      else {
        _currentGeohashesQueried[geohashQueryStr].active = true;
        geohashesToQuery.splice(index, 1);
      }
    }

    // If we are not already cleaning up the current geohashes queried and we have more than 25 of them,
    // kick off a timeout to clean them up so we don't create an infinite number of unneeded queries.
    if (_geohashCleanupScheduled === false && Object.keys(_currentGeohashesQueried).length > 25) {
      _geohashCleanupScheduled = true;
      _cleanUpCurrentGeohashesQueriedTimeout = setTimeout(_cleanUpCurrentGeohashesQueried, 10);
    }

    // Keep track of which geohashes have been processed so we know when to fire the "ready" event
    _outstandingGeohashReadyEvents = geohashesToQuery.slice();

    // Loop through each geohash to query for and listen for new geohashes which have the same prefix.
    // For every match, attach a value callback which will fire the appropriate events.
    // Once every geohash to query is processed, fire the "ready" event.
    geohashesToQuery.forEach(function(toQueryStr) {
      // decode the geohash query string
      var query = _stringToQuery(toQueryStr);

      // Create the Firebase query
      var firebaseQuery = _firebaseRef.orderByChild("g").startAt(query[0]).endAt(query[1]);

      // For every new matching geohash, determine if we should fire the "key_entered" event
      var childAddedCallback = firebaseQuery.on("child_added", _childAddedCallback);
      var childRemovedCallback = firebaseQuery.on("child_removed", _childRemovedCallback);
      var childChangedCallback = firebaseQuery.on("child_changed", _childChangedCallback);

      // Once the current geohash to query is processed, see if it is the last one to be processed
      // and, if so, mark the value event as fired.
      // Note that Firebase fires the "value" event after every "child_added" event fires.
      var valueCallback = firebaseQuery.on("value", function() {
        firebaseQuery.off("value", valueCallback);
        _geohashQueryReadyCallback(toQueryStr);
      });

      // Add the geohash query to the current geohashes queried dictionary and save its state
      _currentGeohashesQueried[toQueryStr] = {
        active: true,
        childAddedCallback: childAddedCallback,
        childRemovedCallback: childRemovedCallback,
        childChangedCallback: childChangedCallback,
        valueCallback: valueCallback
      };
    });
    // Based upon the algorithm to calculate geohashes, it's possible that no "new"
    // geohashes were queried even if the client updates the radius of the query.
    // This results in no "READY" event being fired after the .updateQuery() call.
    // Check to see if this is the case, and trigger the "READY" event.
    if(geohashesToQuery.length === 0) {
      _geohashQueryReadyCallback();
    }
  }

  /********************/
  /*  PUBLIC METHODS  */
  /********************/
  /**
   * Returns the location signifying the center of this query.
   *
   * @return {Array.<number>} The [latitude, longitude] pair signifying the center of this query.
   */
  this.center = function() {
    return _center;
  };

  /**
   * Returns the radius of this query, in kilometers.
   *
   * @return {number} The radius of this query, in kilometers.
   */
  this.radius = function() {
    return _radius;
  };

  /**
   * Updates the criteria for this query.
   *
   * @param {Object} newQueryCriteria The criteria which specifies the query's center and radius.
   */
  this.updateCriteria = function(newQueryCriteria) {
    // Validate and save the new query criteria
    validateCriteria(newQueryCriteria);
    _center = newQueryCriteria.center || _center;
    _radius = newQueryCriteria.radius || _radius;

    // Loop through all of the locations in the query, update their distance from the center of the
    // query, and fire any appropriate events
    var keys = Object.keys(_locationsTracked);
    var numKeys = keys.length;
    for (var i = 0; i < numKeys; ++i) {
      var key = keys[i];

      // If the query was cancelled while going through this loop, stop updating locations and stop
      // firing events
      if (_cancelled === true) {
        break;
      }

      // Get the cached information for this location
      var locationDict = _locationsTracked[key];

      // Save if the location was already in the query
      var wasAlreadyInQuery = locationDict.isInQuery;

      // Update the location's distance to the new query center
      locationDict.distanceFromCenter = GeoFire.distance(locationDict.location, _center);

      // Determine if the location is now in this query
      locationDict.isInQuery = (locationDict.distanceFromCenter <= _radius);

      // If the location just left the query, fire the "key_exited" callbacks
      if (wasAlreadyInQuery && !locationDict.isInQuery) {
        _fireCallbacksForKey("key_exited", key, locationDict.location, locationDict.distanceFromCenter);
      }

      // If the location just entered the query, fire the "key_entered" callbacks
      else if (!wasAlreadyInQuery && locationDict.isInQuery) {
        _fireCallbacksForKey("key_entered", key, locationDict.location, locationDict.distanceFromCenter);
      }
    }

    // Reset the variables which control when the "ready" event fires
    _valueEventFired = false;

    // Listen for new geohashes being added to GeoFire and fire the appropriate events
    _listenForNewGeohashes();
  };

  /**
   * Attaches a callback to this query which will be run when the provided eventType fires. Valid eventType
   * values are "ready", "key_entered", "key_exited", and "key_moved". The ready event callback is passed no
   * parameters. All other callbacks will be passed three parameters: (1) the location's key, (2) the location's
   * [latitude, longitude] pair, and (3) the distance, in kilometers, from the location to this query's center
   *
   * "ready" is used to signify that this query has loaded its initial state and is up-to-date with its corresponding
   * GeoFire instance. "ready" fires when this query has loaded all of the initial data from GeoFire and fired all
   * other events for that data. It also fires every time updateQuery() is called, after all other events have
   * fired for the updated query.
   *
   * "key_entered" fires when a key enters this query. This can happen when a key moves from a location outside of
   * this query to one inside of it or when a key is written to GeoFire for the first time and it falls within
   * this query.
   *
   * "key_exited" fires when a key moves from a location inside of this query to one outside of it. If the key was
   * entirely removed from GeoFire, both the location and distance passed to the callback will be null.
   *
   * "key_moved" fires when a key which is already in this query moves to another location inside of it.
   *
   * Returns a GeoCallbackRegistration which can be used to cancel the callback. You can add as many callbacks
   * as you would like for the same eventType by repeatedly calling on(). Each one will get called when its
   * corresponding eventType fires. Each callback must be cancelled individually.
   *
   * @param {string} eventType The event type for which to attach the callback. One of "ready", "key_entered",
   * "key_exited", or "key_moved".
   * @callback callback Callback function to be called when an event of type eventType fires.
   * @return {GeoCallbackRegistration} A callback registration which can be used to cancel the provided callback.
   */
  this.on = function(eventType, callback) {
    // Validate the inputs
    if (["ready", "key_entered", "key_exited", "key_moved"].indexOf(eventType) === -1) {
      throw new Error("event type must be \"ready\", \"key_entered\", \"key_exited\", or \"key_moved\"");
    }
    if (typeof callback !== "function") {
      throw new Error("callback must be a function");
    }

    // Add the callback to this query's callbacks list
    _callbacks[eventType].push(callback);

    // If this is a "key_entered" callback, fire it for every location already within this query
    if (eventType === "key_entered") {
      var keys = Object.keys(_locationsTracked);
      var numKeys = keys.length;
      for (var i = 0; i < numKeys; ++i) {
        var key = keys[i];
        var locationDict = _locationsTracked[key];
        if (typeof locationDict !== "undefined" && locationDict.isInQuery) {
          callback(key, locationDict.location, locationDict.distanceFromCenter);
        }
      }
    }

    // If this is a "ready" callback, fire it if this query is already ready
    if (eventType === "ready") {
      if (_valueEventFired) {
        callback();
      }
    }

    // Return an event registration which can be used to cancel the callback
    return new GeoCallbackRegistration(function() {
      _callbacks[eventType].splice(_callbacks[eventType].indexOf(callback), 1);
    });
  };

  /**
   * Terminates this query so that it no longer sends location updates. All callbacks attached to this
   * query via on() will be cancelled. This query can no longer be used in the future.
   */
  this.cancel = function () {
    // Mark this query as cancelled
    _cancelled = true;

    // Cancel all callbacks in this query's callback list
    _callbacks = {
      ready: [],
      key_entered: [],
      key_exited: [],
      key_moved: []
    };

    // Turn off all Firebase listeners for the current geohashes being queried
    var keys = Object.keys(_currentGeohashesQueried);
    var numKeys = keys.length;
    for (var i = 0; i < numKeys; ++i) {
      var geohashQueryStr = keys[i];
      var query = _stringToQuery(geohashQueryStr);
      _cancelGeohashQuery(query, _currentGeohashesQueried[geohashQueryStr]);
      delete _currentGeohashesQueried[geohashQueryStr];
    }

    // Delete any stored locations
    _locationsTracked = {};

    // Turn off the current geohashes queried clean up interval
    clearInterval(_cleanUpCurrentGeohashesQueriedInterval);
  };


  /*****************/
  /*  CONSTRUCTOR  */
  /*****************/
  // Firebase reference of the GeoFire which created this query
  if (Object.prototype.toString.call(firebaseRef) !== "[object Object]") {
    throw new Error("firebaseRef must be an instance of Firebase");
  }
  var _firebaseRef = firebaseRef;

  // Event callbacks
  var _callbacks = {
    ready: [],
    key_entered: [],
    key_exited: [],
    key_moved: []
  };

  // Variable to track when the query is cancelled
  var _cancelled = false;

  // Variables used to keep track of when to fire the "ready" event
  var _valueEventFired = false;
  var _outstandingGeohashReadyEvents;

  // A dictionary of locations that a currently active in the queries
  // Note that not all of these are currently within this query
  var _locationsTracked = {};

  // A dictionary of geohash queries which currently have an active callbacks
  var _currentGeohashesQueried = {};

  // Every ten seconds, clean up the geohashes we are currently querying for. We keep these around
  // for a little while since it's likely that they will need to be re-queried shortly after they
  // move outside of the query's bounding box.
  var _geohashCleanupScheduled = false;
  var _cleanUpCurrentGeohashesQueriedTimeout = null;
  var _cleanUpCurrentGeohashesQueriedInterval = setInterval(function() {
      if (_geohashCleanupScheduled === false) {
        _cleanUpCurrentGeohashesQueried();
      }
    }, 10000);

  // Validate and save the query criteria
  validateCriteria(queryCriteria, /* requireCenterAndRadius */ true);
  var _center = queryCriteria.center;
  var _radius = queryCriteria.radius;

  // Listen for new geohashes being added around this query and fire the appropriate events
  _listenForNewGeohashes();
};

  return GeoFire;
})();

// Export GeoFire if this is being run in node
if (typeof module !== "undefined" && typeof process !== "undefined") {
  module.exports = GeoFire;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(213)))

/***/ }),
/* 1144 */
/***/ (function(module, exports) {

/**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.node = function(value) {
    return value !== undefined
        && value instanceof HTMLElement
        && value.nodeType === 1;
};

/**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.nodeList = function(value) {
    var type = Object.prototype.toString.call(value);

    return value !== undefined
        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
        && ('length' in value)
        && (value.length === 0 || exports.node(value[0]));
};

/**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.string = function(value) {
    return typeof value === 'string'
        || value instanceof String;
};

/**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.fn = function(value) {
    var type = Object.prototype.toString.call(value);

    return type === '[object Function]';
};


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

var is = __webpack_require__(1144);
var delegate = __webpack_require__(1067);

/**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listen(target, type, callback) {
    if (!target && !type && !callback) {
        throw new Error('Missing required arguments');
    }

    if (!is.string(type)) {
        throw new TypeError('Second argument must be a String');
    }

    if (!is.fn(callback)) {
        throw new TypeError('Third argument must be a Function');
    }

    if (is.node(target)) {
        return listenNode(target, type, callback);
    }
    else if (is.nodeList(target)) {
        return listenNodeList(target, type, callback);
    }
    else if (is.string(target)) {
        return listenSelector(target, type, callback);
    }
    else {
        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
    }
}

/**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNode(node, type, callback) {
    node.addEventListener(type, callback);

    return {
        destroy: function() {
            node.removeEventListener(type, callback);
        }
    }
}

/**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNodeList(nodeList, type, callback) {
    Array.prototype.forEach.call(nodeList, function(node) {
        node.addEventListener(type, callback);
    });

    return {
        destroy: function() {
            Array.prototype.forEach.call(nodeList, function(node) {
                node.removeEventListener(type, callback);
            });
        }
    }
}

/**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenSelector(selector, type, callback) {
    return delegate(document.body, selector, type, callback);
}

module.exports = listen;


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var ANGLE = /([+-]?\d*\.?\d+)(deg|grad|rad|turn)/i;

var parseAngle = exports.parseAngle = function parseAngle(angle) {
    var match = angle.match(ANGLE);

    if (match) {
        var value = parseFloat(match[1]);
        switch (match[2].toLowerCase()) {
            case 'deg':
                return Math.PI * value / 180;
            case 'grad':
                return Math.PI / 200 * value;
            case 'rad':
                return value;
            case 'turn':
                return Math.PI * 2 * value;
        }
    }

    return null;
};

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cloneWindow = exports.DocumentCloner = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Bounds = __webpack_require__(73);

var _Proxy = __webpack_require__(331);

var _ResourceLoader = __webpack_require__(1151);

var _ResourceLoader2 = _interopRequireDefault(_ResourceLoader);

var _Util = __webpack_require__(111);

var _background = __webpack_require__(147);

var _CanvasRenderer = __webpack_require__(336);

var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';

var DocumentCloner = exports.DocumentCloner = function () {
    function DocumentCloner(element, options, logger, copyInline, renderer) {
        _classCallCheck(this, DocumentCloner);

        this.referenceElement = element;
        this.scrolledElements = [];
        this.copyStyles = copyInline;
        this.inlineImages = copyInline;
        this.logger = logger;
        this.options = options;
        this.renderer = renderer;
        this.resourceLoader = new _ResourceLoader2.default(options, logger, window);
        // $FlowFixMe
        this.documentElement = this.cloneNode(element.ownerDocument.documentElement);
    }

    _createClass(DocumentCloner, [{
        key: 'inlineAllImages',
        value: function inlineAllImages(node) {
            var _this = this;

            if (this.inlineImages && node) {
                var style = node.style;
                Promise.all((0, _background.parseBackgroundImage)(style.backgroundImage).map(function (backgroundImage) {
                    if (backgroundImage.method === 'url') {
                        return _this.resourceLoader.inlineImage(backgroundImage.args[0]).then(function (img) {
                            return img && typeof img.src === 'string' ? 'url("' + img.src + '")' : 'none';
                        }).catch(function (e) {
                            if (false) {
                                _this.logger.log('Unable to load image', e);
                            }
                        });
                    }
                    return Promise.resolve('' + backgroundImage.prefix + backgroundImage.method + '(' + backgroundImage.args.join(',') + ')');
                })).then(function (backgroundImages) {
                    if (backgroundImages.length > 1) {
                        // TODO Multiple backgrounds somehow broken in Chrome
                        style.backgroundColor = '';
                    }
                    style.backgroundImage = backgroundImages.join(',');
                });

                if (node instanceof HTMLImageElement) {
                    this.resourceLoader.inlineImage(node.src).then(function (img) {
                        if (img && node instanceof HTMLImageElement && node.parentNode) {
                            var parentNode = node.parentNode;
                            var clonedChild = (0, _Util.copyCSSStyles)(node.style, img.cloneNode(false));
                            parentNode.replaceChild(clonedChild, node);
                        }
                    }).catch(function (e) {
                        if (false) {
                            _this.logger.log('Unable to load image', e);
                        }
                    });
                }
            }
        }
    }, {
        key: 'inlineFonts',
        value: function inlineFonts(document) {
            var _this2 = this;

            return Promise.all(Array.from(document.styleSheets).map(function (sheet) {
                if (sheet.href) {
                    return fetch(sheet.href).then(function (res) {
                        return res.text();
                    }).then(function (text) {
                        return createStyleSheetFontsFromText(text, sheet.href);
                    }).catch(function (e) {
                        if (false) {
                            _this2.logger.log('Unable to load stylesheet', e);
                        }
                        return [];
                    });
                }
                return getSheetFonts(sheet, document);
            })).then(function (fonts) {
                return fonts.reduce(function (acc, font) {
                    return acc.concat(font);
                }, []);
            }).then(function (fonts) {
                return Promise.all(fonts.map(function (font) {
                    return fetch(font.formats[0].src).then(function (response) {
                        return response.blob();
                    }).then(function (blob) {
                        return new Promise(function (resolve, reject) {
                            var reader = new FileReader();
                            reader.onerror = reject;
                            reader.onload = function () {
                                // $FlowFixMe
                                var result = reader.result;
                                resolve(result);
                            };
                            reader.readAsDataURL(blob);
                        });
                    }).then(function (dataUri) {
                        font.fontFace.setProperty('src', 'url("' + dataUri + '")');
                        return '@font-face {' + font.fontFace.cssText + ' ';
                    });
                }));
            }).then(function (fontCss) {
                var style = document.createElement('style');
                style.textContent = fontCss.join('\n');
                _this2.documentElement.appendChild(style);
            });
        }
    }, {
        key: 'createElementClone',
        value: function createElementClone(node) {
            var _this3 = this;

            if (this.copyStyles && node instanceof HTMLCanvasElement) {
                var img = node.ownerDocument.createElement('img');
                try {
                    img.src = node.toDataURL();
                    return img;
                } catch (e) {
                    if (false) {
                        this.logger.log('Unable to clone canvas contents, canvas is tainted');
                    }
                }
            }

            if (node instanceof HTMLIFrameElement) {
                var tempIframe = node.cloneNode(false);
                var iframeKey = generateIframeKey();
                tempIframe.setAttribute('data-html2canvas-internal-iframe-key', iframeKey);

                var _parseBounds = (0, _Bounds.parseBounds)(node, 0, 0),
                    width = _parseBounds.width,
                    height = _parseBounds.height;

                this.resourceLoader.cache[iframeKey] = getIframeDocumentElement(node, this.options).then(function (documentElement) {
                    return _this3.renderer(documentElement, {
                        async: _this3.options.async,
                        allowTaint: _this3.options.allowTaint,
                        backgroundColor: '#ffffff',
                        canvas: null,
                        imageTimeout: _this3.options.imageTimeout,
                        logging: _this3.options.logging,
                        proxy: _this3.options.proxy,
                        removeContainer: _this3.options.removeContainer,
                        scale: _this3.options.scale,
                        foreignObjectRendering: _this3.options.foreignObjectRendering,
                        target: new _CanvasRenderer2.default(),
                        width: width,
                        height: height,
                        x: 0,
                        y: 0,
                        windowWidth: documentElement.ownerDocument.defaultView.innerWidth,
                        windowHeight: documentElement.ownerDocument.defaultView.innerHeight,
                        scrollX: documentElement.ownerDocument.defaultView.pageXOffset,
                        scrollY: documentElement.ownerDocument.defaultView.pageYOffset
                    }, _this3.logger.child(iframeKey));
                }).then(function (canvas) {
                    return new Promise(function (resolve, reject) {
                        var iframeCanvas = document.createElement('img');
                        iframeCanvas.onload = function () {
                            return resolve(canvas);
                        };
                        iframeCanvas.onerror = reject;
                        iframeCanvas.src = canvas.toDataURL();
                        if (tempIframe.parentNode) {
                            tempIframe.parentNode.replaceChild((0, _Util.copyCSSStyles)(node.ownerDocument.defaultView.getComputedStyle(node), iframeCanvas), tempIframe);
                        }
                    });
                });
                return tempIframe;
            }

            return node.cloneNode(false);
        }
    }, {
        key: 'cloneNode',
        value: function cloneNode(node) {
            var clone = node.nodeType === Node.TEXT_NODE ? document.createTextNode(node.nodeValue) : this.createElementClone(node);

            var window = node.ownerDocument.defaultView;

            if (this.referenceElement === node && clone instanceof window.HTMLElement) {
                this.clonedReferenceElement = clone;
            }

            if (clone instanceof window.HTMLBodyElement) {
                createPseudoHideStyles(clone);
            }

            for (var child = node.firstChild; child; child = child.nextSibling) {
                if (child.nodeType !== Node.ELEMENT_NODE ||
                // $FlowFixMe
                child.nodeName !== 'SCRIPT' && !child.hasAttribute(IGNORE_ATTRIBUTE)) {
                    if (!this.copyStyles || child.nodeName !== 'STYLE') {
                        clone.appendChild(this.cloneNode(child));
                    }
                }
            }
            if (node instanceof window.HTMLElement && clone instanceof window.HTMLElement) {
                this.inlineAllImages(inlinePseudoElement(node, clone, PSEUDO_BEFORE));
                this.inlineAllImages(inlinePseudoElement(node, clone, PSEUDO_AFTER));
                if (this.copyStyles && !(node instanceof HTMLIFrameElement)) {
                    (0, _Util.copyCSSStyles)(node.ownerDocument.defaultView.getComputedStyle(node), clone);
                }
                this.inlineAllImages(clone);
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) {
                    this.scrolledElements.push([clone, node.scrollLeft, node.scrollTop]);
                }
                switch (node.nodeName) {
                    case 'CANVAS':
                        if (!this.copyStyles) {
                            cloneCanvasContents(node, clone);
                        }
                        break;
                    case 'TEXTAREA':
                    case 'SELECT':
                        clone.value = node.value;
                        break;
                }
            }
            return clone;
        }
    }]);

    return DocumentCloner;
}();

var getSheetFonts = function getSheetFonts(sheet, document) {
    // $FlowFixMe
    return (sheet.cssRules ? Array.from(sheet.cssRules) : []).filter(function (rule) {
        return rule.type === CSSRule.FONT_FACE_RULE;
    }).map(function (rule) {
        var src = (0, _background.parseBackgroundImage)(rule.style.getPropertyValue('src'));
        var formats = [];
        for (var i = 0; i < src.length; i++) {
            if (src[i].method === 'url' && src[i + 1] && src[i + 1].method === 'format') {
                var a = document.createElement('a');
                a.href = src[i].args[0];
                if (document.body) {
                    document.body.appendChild(a);
                }

                var font = {
                    src: a.href,
                    format: src[i + 1].args[0]
                };
                formats.push(font);
            }
        }

        return {
            // TODO select correct format for browser),

            formats: formats.filter(function (font) {
                return (/^woff/i.test(font.format)
                );
            }),
            fontFace: rule.style
        };
    }).filter(function (font) {
        return font.formats.length;
    });
};

var createStyleSheetFontsFromText = function createStyleSheetFontsFromText(text, baseHref) {
    var doc = document.implementation.createHTMLDocument('');
    var base = document.createElement('base');
    // $FlowFixMe
    base.href = baseHref;
    var style = document.createElement('style');

    style.textContent = text;
    if (doc.head) {
        doc.head.appendChild(base);
    }
    if (doc.body) {
        doc.body.appendChild(style);
    }

    return style.sheet ? getSheetFonts(style.sheet, doc) : [];
};

var restoreOwnerScroll = function restoreOwnerScroll(ownerDocument, x, y) {
    if (ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) {
        ownerDocument.defaultView.scrollTo(x, y);
    }
};

var cloneCanvasContents = function cloneCanvasContents(canvas, clonedCanvas) {
    try {
        if (clonedCanvas) {
            clonedCanvas.width = canvas.width;
            clonedCanvas.height = canvas.height;
            var ctx = canvas.getContext('2d');
            var clonedCtx = clonedCanvas.getContext('2d');
            if (ctx) {
                clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
            } else {
                clonedCtx.drawImage(canvas, 0, 0);
            }
        }
    } catch (e) {}
};

var inlinePseudoElement = function inlinePseudoElement(node, clone, pseudoElt) {
    var style = node.ownerDocument.defaultView.getComputedStyle(node, pseudoElt);
    if (!style || !style.content || style.content === 'none' || style.content === '-moz-alt-content' || style.display === 'none') {
        return;
    }

    var content = stripQuotes(style.content);
    var image = content.match(URL_REGEXP);
    var anonymousReplacedElement = clone.ownerDocument.createElement(image ? 'img' : 'html2canvaspseudoelement');
    if (image) {
        // $FlowFixMe
        anonymousReplacedElement.src = stripQuotes(image[1]);
    } else {
        anonymousReplacedElement.textContent = content;
    }

    (0, _Util.copyCSSStyles)(style, anonymousReplacedElement);

    anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + ' ' + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
    clone.className += pseudoElt === PSEUDO_BEFORE ? ' ' + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : ' ' + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
    if (pseudoElt === PSEUDO_BEFORE) {
        clone.insertBefore(anonymousReplacedElement, clone.firstChild);
    } else {
        clone.appendChild(anonymousReplacedElement);
    }

    return anonymousReplacedElement;
};

var stripQuotes = function stripQuotes(content) {
    var first = content.substr(0, 1);
    return first === content.substr(content.length - 1) && first.match(/['"]/) ? content.substr(1, content.length - 2) : content;
};

var URL_REGEXP = /^url\((.+)\)$/i;
var PSEUDO_BEFORE = ':before';
var PSEUDO_AFTER = ':after';
var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';

var PSEUDO_HIDE_ELEMENT_STYLE = '{\n    content: "" !important;\n    display: none !important;\n}';

var createPseudoHideStyles = function createPseudoHideStyles(body) {
    createStyles(body, '.' + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + '\n         .' + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
};

var createStyles = function createStyles(body, styles) {
    var style = body.ownerDocument.createElement('style');
    style.innerHTML = styles;
    body.appendChild(style);
};

var initNode = function initNode(_ref) {
    var _ref2 = _slicedToArray(_ref, 3),
        element = _ref2[0],
        x = _ref2[1],
        y = _ref2[2];

    element.scrollLeft = x;
    element.scrollTop = y;
};

var generateIframeKey = function generateIframeKey() {
    return Math.ceil(Date.now() + Math.random() * 10000000).toString(16);
};

var DATA_URI_REGEXP = /^data:text\/(.+);(base64)?,(.*)$/i;

var getIframeDocumentElement = function getIframeDocumentElement(node, options) {
    try {
        return Promise.resolve(node.contentWindow.document.documentElement);
    } catch (e) {
        return options.proxy ? (0, _Proxy.Proxy)(node.src, options).then(function (html) {
            var match = html.match(DATA_URI_REGEXP);
            if (!match) {
                return Promise.reject();
            }

            return match[2] === 'base64' ? window.atob(decodeURIComponent(match[3])) : decodeURIComponent(match[3]);
        }).then(function (html) {
            return createIframeContainer(node.ownerDocument, (0, _Bounds.parseBounds)(node, 0, 0)).then(function (cloneIframeContainer) {
                var cloneWindow = cloneIframeContainer.contentWindow;
                var documentClone = cloneWindow.document;

                documentClone.open();
                documentClone.write(html);
                var iframeLoad = iframeLoader(cloneIframeContainer).then(function () {
                    return documentClone.documentElement;
                });

                documentClone.close();
                return iframeLoad;
            });
        }) : Promise.reject();
    }
};

var createIframeContainer = function createIframeContainer(ownerDocument, bounds) {
    var cloneIframeContainer = ownerDocument.createElement('iframe');

    cloneIframeContainer.className = 'html2canvas-container';
    cloneIframeContainer.style.visibility = 'hidden';
    cloneIframeContainer.style.position = 'fixed';
    cloneIframeContainer.style.left = '-10000px';
    cloneIframeContainer.style.top = '0px';
    cloneIframeContainer.style.border = '0';
    cloneIframeContainer.width = bounds.width.toString();
    cloneIframeContainer.height = bounds.height.toString();
    cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
    cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
    if (!ownerDocument.body) {
        return Promise.reject( false ? 'Body element not found in Document that is getting rendered' : '');
    }

    ownerDocument.body.appendChild(cloneIframeContainer);

    return Promise.resolve(cloneIframeContainer);
};

var iframeLoader = function iframeLoader(cloneIframeContainer) {
    var cloneWindow = cloneIframeContainer.contentWindow;
    var documentClone = cloneWindow.document;

    return new Promise(function (resolve, reject) {
        cloneWindow.onload = cloneIframeContainer.onload = documentClone.onreadystatechange = function () {
            var interval = setInterval(function () {
                if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                    clearInterval(interval);
                    resolve(cloneIframeContainer);
                }
            }, 50);
        };
    });
};

var cloneWindow = exports.cloneWindow = function cloneWindow(ownerDocument, bounds, referenceElement, options, logger, renderer) {
    var cloner = new DocumentCloner(referenceElement, options, logger, false, renderer);
    var scrollX = ownerDocument.defaultView.pageXOffset;
    var scrollY = ownerDocument.defaultView.pageYOffset;

    return createIframeContainer(ownerDocument, bounds).then(function (cloneIframeContainer) {
        var cloneWindow = cloneIframeContainer.contentWindow;
        var documentClone = cloneWindow.document;

        /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */

        var iframeLoad = iframeLoader(cloneIframeContainer).then(function () {
            cloner.scrolledElements.forEach(initNode);
            cloneWindow.scrollTo(bounds.left, bounds.top);
            if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== bounds.top || cloneWindow.scrollX !== bounds.left)) {
                documentClone.documentElement.style.top = -bounds.top + 'px';
                documentClone.documentElement.style.left = -bounds.left + 'px';
                documentClone.documentElement.style.position = 'absolute';
            }
            return cloner.clonedReferenceElement instanceof cloneWindow.HTMLElement || cloner.clonedReferenceElement instanceof ownerDocument.defaultView.HTMLElement || cloner.clonedReferenceElement instanceof HTMLElement ? Promise.resolve([cloneIframeContainer, cloner.clonedReferenceElement, cloner.resourceLoader]) : Promise.reject( false ? 'Error finding the ' + referenceElement.nodeName + ' in the cloned document' : '');
        });

        documentClone.open();
        documentClone.write('<!DOCTYPE html><html></html>');
        // Chrome scrolls the parent document for some reason after the write to the cloned window???
        restoreOwnerScroll(referenceElement.ownerDocument, scrollX, scrollY);
        documentClone.replaceChild(documentClone.adoptNode(cloner.documentElement), documentClone.documentElement);
        documentClone.close();

        return iframeLoad;
    });
};

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.transformWebkitRadialGradientArgs = exports.parseGradient = exports.RadialGradient = exports.LinearGradient = exports.RADIAL_GRADIENT_SHAPE = exports.GRADIENT_TYPE = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _NodeContainer = __webpack_require__(144);

var _NodeContainer2 = _interopRequireDefault(_NodeContainer);

var _Angle = __webpack_require__(1146);

var _Color = __webpack_require__(74);

var _Color2 = _interopRequireDefault(_Color);

var _Length = __webpack_require__(97);

var _Length2 = _interopRequireDefault(_Length);

var _Util = __webpack_require__(111);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SIDE_OR_CORNER = /^(to )?(left|top|right|bottom)( (left|top|right|bottom))?$/i;
var PERCENTAGE_ANGLES = /^([+-]?\d*\.?\d+)% ([+-]?\d*\.?\d+)%$/i;
var ENDS_WITH_LENGTH = /(px)|%|( 0)$/i;
var FROM_TO_COLORSTOP = /^(from|to|color-stop)\((?:([\d.]+)(%)?,\s*)?(.+?)\)$/i;
var RADIAL_SHAPE_DEFINITION = /^\s*(circle|ellipse)?\s*((?:([\d.]+)(px|r?em|%)\s*(?:([\d.]+)(px|r?em|%))?)|closest-side|closest-corner|farthest-side|farthest-corner)?\s*(?:at\s*(?:(left|center|right)|([\d.]+)(px|r?em|%))\s+(?:(top|center|bottom)|([\d.]+)(px|r?em|%)))?(?:\s|$)/i;

var GRADIENT_TYPE = exports.GRADIENT_TYPE = {
    LINEAR_GRADIENT: 0,
    RADIAL_GRADIENT: 1
};

var RADIAL_GRADIENT_SHAPE = exports.RADIAL_GRADIENT_SHAPE = {
    CIRCLE: 0,
    ELLIPSE: 1
};

var LENGTH_FOR_POSITION = {
    left: new _Length2.default('0%'),
    top: new _Length2.default('0%'),
    center: new _Length2.default('50%'),
    right: new _Length2.default('100%'),
    bottom: new _Length2.default('100%')
};

var LinearGradient = exports.LinearGradient = function LinearGradient(colorStops, direction) {
    _classCallCheck(this, LinearGradient);

    this.type = GRADIENT_TYPE.LINEAR_GRADIENT;
    this.colorStops = colorStops;
    this.direction = direction;
};

var RadialGradient = exports.RadialGradient = function RadialGradient(colorStops, shape, center, radius) {
    _classCallCheck(this, RadialGradient);

    this.type = GRADIENT_TYPE.RADIAL_GRADIENT;
    this.colorStops = colorStops;
    this.shape = shape;
    this.center = center;
    this.radius = radius;
};

var parseGradient = exports.parseGradient = function parseGradient(container, _ref, bounds) {
    var args = _ref.args,
        method = _ref.method,
        prefix = _ref.prefix;

    if (method === 'linear-gradient') {
        return parseLinearGradient(args, bounds, !!prefix);
    } else if (method === 'gradient' && args[0] === 'linear') {
        // TODO handle correct angle
        return parseLinearGradient(['to bottom'].concat(transformObsoleteColorStops(args.slice(3))), bounds, !!prefix);
    } else if (method === 'radial-gradient') {
        return parseRadialGradient(container, prefix === '-webkit-' ? transformWebkitRadialGradientArgs(args) : args, bounds);
    } else if (method === 'gradient' && args[0] === 'radial') {
        return parseRadialGradient(container, transformObsoleteColorStops(transformWebkitRadialGradientArgs(args.slice(1))), bounds);
    }
};

var parseColorStops = function parseColorStops(args, firstColorStopIndex, lineLength) {
    var colorStops = [];

    for (var i = firstColorStopIndex; i < args.length; i++) {
        var value = args[i];
        var HAS_LENGTH = ENDS_WITH_LENGTH.test(value);
        var lastSpaceIndex = value.lastIndexOf(' ');
        var _color = new _Color2.default(HAS_LENGTH ? value.substring(0, lastSpaceIndex) : value);
        var _stop = HAS_LENGTH ? new _Length2.default(value.substring(lastSpaceIndex + 1)) : i === firstColorStopIndex ? new _Length2.default('0%') : i === args.length - 1 ? new _Length2.default('100%') : null;
        colorStops.push({ color: _color, stop: _stop });
    }

    var absoluteValuedColorStops = colorStops.map(function (_ref2) {
        var color = _ref2.color,
            stop = _ref2.stop;

        var absoluteStop = lineLength === 0 ? 0 : stop ? stop.getAbsoluteValue(lineLength) / lineLength : null;

        return {
            color: color,
            // $FlowFixMe
            stop: absoluteStop
        };
    });

    var previousColorStop = absoluteValuedColorStops[0].stop;
    for (var _i = 0; _i < absoluteValuedColorStops.length; _i++) {
        if (previousColorStop !== null) {
            var _stop2 = absoluteValuedColorStops[_i].stop;
            if (_stop2 === null) {
                var n = _i;
                while (absoluteValuedColorStops[n].stop === null) {
                    n++;
                }
                var steps = n - _i + 1;
                var nextColorStep = absoluteValuedColorStops[n].stop;
                var stepSize = (nextColorStep - previousColorStop) / steps;
                for (; _i < n; _i++) {
                    previousColorStop = absoluteValuedColorStops[_i].stop = previousColorStop + stepSize;
                }
            } else {
                previousColorStop = _stop2;
            }
        }
    }

    return absoluteValuedColorStops;
};

var parseLinearGradient = function parseLinearGradient(args, bounds, hasPrefix) {
    var angle = (0, _Angle.parseAngle)(args[0]);
    var HAS_SIDE_OR_CORNER = SIDE_OR_CORNER.test(args[0]);
    var HAS_DIRECTION = HAS_SIDE_OR_CORNER || angle !== null || PERCENTAGE_ANGLES.test(args[0]);
    var direction = HAS_DIRECTION ? angle !== null ? calculateGradientDirection(
    // if there is a prefix, the 0° angle points due East (instead of North per W3C)
    hasPrefix ? angle - Math.PI * 0.5 : angle, bounds) : HAS_SIDE_OR_CORNER ? parseSideOrCorner(args[0], bounds) : parsePercentageAngle(args[0], bounds) : calculateGradientDirection(Math.PI, bounds);
    var firstColorStopIndex = HAS_DIRECTION ? 1 : 0;

    // TODO: Fix some inaccuracy with color stops with px values
    var lineLength = Math.min((0, _Util.distance)(Math.abs(direction.x0) + Math.abs(direction.x1), Math.abs(direction.y0) + Math.abs(direction.y1)), bounds.width * 2, bounds.height * 2);

    return new LinearGradient(parseColorStops(args, firstColorStopIndex, lineLength), direction);
};

var parseRadialGradient = function parseRadialGradient(container, args, bounds) {
    var m = args[0].match(RADIAL_SHAPE_DEFINITION);
    var shape = m && (m[1] === 'circle' || // explicit shape specification
    m[3] !== undefined && m[5] === undefined) // only one radius coordinate
    ? RADIAL_GRADIENT_SHAPE.CIRCLE : RADIAL_GRADIENT_SHAPE.ELLIPSE;
    var radius = {};
    var center = {};

    if (m) {
        // Radius
        if (m[3] !== undefined) {
            radius.x = (0, _Length.calculateLengthFromValueWithUnit)(container, m[3], m[4]).getAbsoluteValue(bounds.width);
        }

        if (m[5] !== undefined) {
            radius.y = (0, _Length.calculateLengthFromValueWithUnit)(container, m[5], m[6]).getAbsoluteValue(bounds.height);
        }

        // Position
        if (m[7]) {
            center.x = LENGTH_FOR_POSITION[m[7].toLowerCase()];
        } else if (m[8] !== undefined) {
            center.x = (0, _Length.calculateLengthFromValueWithUnit)(container, m[8], m[9]);
        }

        if (m[10]) {
            center.y = LENGTH_FOR_POSITION[m[10].toLowerCase()];
        } else if (m[11] !== undefined) {
            center.y = (0, _Length.calculateLengthFromValueWithUnit)(container, m[11], m[12]);
        }
    }

    var gradientCenter = {
        x: center.x === undefined ? bounds.width / 2 : center.x.getAbsoluteValue(bounds.width),
        y: center.y === undefined ? bounds.height / 2 : center.y.getAbsoluteValue(bounds.height)
    };
    var gradientRadius = calculateRadius(m && m[2] || 'farthest-corner', shape, gradientCenter, radius, bounds);

    return new RadialGradient(parseColorStops(args, m ? 1 : 0, Math.min(gradientRadius.x, gradientRadius.y)), shape, gradientCenter, gradientRadius);
};

var calculateGradientDirection = function calculateGradientDirection(radian, bounds) {
    var width = bounds.width;
    var height = bounds.height;
    var HALF_WIDTH = width * 0.5;
    var HALF_HEIGHT = height * 0.5;
    var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
    var HALF_LINE_LENGTH = lineLength / 2;

    var x0 = HALF_WIDTH + Math.sin(radian) * HALF_LINE_LENGTH;
    var y0 = HALF_HEIGHT - Math.cos(radian) * HALF_LINE_LENGTH;
    var x1 = width - x0;
    var y1 = height - y0;

    return { x0: x0, x1: x1, y0: y0, y1: y1 };
};

var parseTopRight = function parseTopRight(bounds) {
    return Math.acos(bounds.width / 2 / ((0, _Util.distance)(bounds.width, bounds.height) / 2));
};

var parseSideOrCorner = function parseSideOrCorner(side, bounds) {
    switch (side) {
        case 'bottom':
        case 'to top':
            return calculateGradientDirection(0, bounds);
        case 'left':
        case 'to right':
            return calculateGradientDirection(Math.PI / 2, bounds);
        case 'right':
        case 'to left':
            return calculateGradientDirection(3 * Math.PI / 2, bounds);
        case 'top right':
        case 'right top':
        case 'to bottom left':
        case 'to left bottom':
            return calculateGradientDirection(Math.PI + parseTopRight(bounds), bounds);
        case 'top left':
        case 'left top':
        case 'to bottom right':
        case 'to right bottom':
            return calculateGradientDirection(Math.PI - parseTopRight(bounds), bounds);
        case 'bottom left':
        case 'left bottom':
        case 'to top right':
        case 'to right top':
            return calculateGradientDirection(parseTopRight(bounds), bounds);
        case 'bottom right':
        case 'right bottom':
        case 'to top left':
        case 'to left top':
            return calculateGradientDirection(2 * Math.PI - parseTopRight(bounds), bounds);
        case 'top':
        case 'to bottom':
        default:
            return calculateGradientDirection(Math.PI, bounds);
    }
};

var parsePercentageAngle = function parsePercentageAngle(angle, bounds) {
    var _angle$split$map = angle.split(' ').map(parseFloat),
        _angle$split$map2 = _slicedToArray(_angle$split$map, 2),
        left = _angle$split$map2[0],
        top = _angle$split$map2[1];

    var ratio = left / 100 * bounds.width / (top / 100 * bounds.height);

    return calculateGradientDirection(Math.atan(isNaN(ratio) ? 1 : ratio) + Math.PI / 2, bounds);
};

var findCorner = function findCorner(bounds, x, y, closest) {
    var corners = [{ x: 0, y: 0 }, { x: 0, y: bounds.height }, { x: bounds.width, y: 0 }, { x: bounds.width, y: bounds.height }];

    // $FlowFixMe
    return corners.reduce(function (stat, corner) {
        var d = (0, _Util.distance)(x - corner.x, y - corner.y);
        if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) {
            return {
                optimumCorner: corner,
                optimumDistance: d
            };
        }

        return stat;
    }, {
        optimumDistance: closest ? Infinity : -Infinity,
        optimumCorner: null
    }).optimumCorner;
};

var calculateRadius = function calculateRadius(extent, shape, center, radius, bounds) {
    var x = center.x;
    var y = center.y;
    var rx = 0;
    var ry = 0;

    switch (extent) {
        case 'closest-side':
            // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
            // If the shape is an ellipse, it exactly meets the closest side in each dimension.
            if (shape === RADIAL_GRADIENT_SHAPE.CIRCLE) {
                rx = ry = Math.min(Math.abs(x), Math.abs(x - bounds.width), Math.abs(y), Math.abs(y - bounds.height));
            } else if (shape === RADIAL_GRADIENT_SHAPE.ELLIPSE) {
                rx = Math.min(Math.abs(x), Math.abs(x - bounds.width));
                ry = Math.min(Math.abs(y), Math.abs(y - bounds.height));
            }
            break;

        case 'closest-corner':
            // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
            // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
            if (shape === RADIAL_GRADIENT_SHAPE.CIRCLE) {
                rx = ry = Math.min((0, _Util.distance)(x, y), (0, _Util.distance)(x, y - bounds.height), (0, _Util.distance)(x - bounds.width, y), (0, _Util.distance)(x - bounds.width, y - bounds.height));
            } else if (shape === RADIAL_GRADIENT_SHAPE.ELLIPSE) {
                // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                var c = Math.min(Math.abs(y), Math.abs(y - bounds.height)) / Math.min(Math.abs(x), Math.abs(x - bounds.width));
                var corner = findCorner(bounds, x, y, true);
                rx = (0, _Util.distance)(corner.x - x, (corner.y - y) / c);
                ry = c * rx;
            }
            break;

        case 'farthest-side':
            // Same as closest-side, except the ending shape is sized based on the farthest side(s)
            if (shape === RADIAL_GRADIENT_SHAPE.CIRCLE) {
                rx = ry = Math.max(Math.abs(x), Math.abs(x - bounds.width), Math.abs(y), Math.abs(y - bounds.height));
            } else if (shape === RADIAL_GRADIENT_SHAPE.ELLIPSE) {
                rx = Math.max(Math.abs(x), Math.abs(x - bounds.width));
                ry = Math.max(Math.abs(y), Math.abs(y - bounds.height));
            }
            break;

        case 'farthest-corner':
            // Same as closest-corner, except the ending shape is sized based on the farthest corner.
            // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
            if (shape === RADIAL_GRADIENT_SHAPE.CIRCLE) {
                rx = ry = Math.max((0, _Util.distance)(x, y), (0, _Util.distance)(x, y - bounds.height), (0, _Util.distance)(x - bounds.width, y), (0, _Util.distance)(x - bounds.width, y - bounds.height));
            } else if (shape === RADIAL_GRADIENT_SHAPE.ELLIPSE) {
                // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                var _c = Math.max(Math.abs(y), Math.abs(y - bounds.height)) / Math.max(Math.abs(x), Math.abs(x - bounds.width));
                var _corner = findCorner(bounds, x, y, false);
                rx = (0, _Util.distance)(_corner.x - x, (_corner.y - y) / _c);
                ry = _c * rx;
            }
            break;

        default:
            // pixel or percentage values
            rx = radius.x || 0;
            ry = radius.y !== undefined ? radius.y : rx;
            break;
    }

    return {
        x: rx,
        y: ry
    };
};

var transformWebkitRadialGradientArgs = exports.transformWebkitRadialGradientArgs = function transformWebkitRadialGradientArgs(args) {
    var shape = '';
    var radius = '';
    var extent = '';
    var position = '';
    var idx = 0;

    var POSITION = /^(left|center|right|\d+(?:px|r?em|%)?)(?:\s+(top|center|bottom|\d+(?:px|r?em|%)?))?$/i;
    var SHAPE_AND_EXTENT = /^(circle|ellipse)?\s*(closest-side|closest-corner|farthest-side|farthest-corner|contain|cover)?$/i;
    var RADIUS = /^\d+(px|r?em|%)?(?:\s+\d+(px|r?em|%)?)?$/i;

    var matchStartPosition = args[idx].match(POSITION);
    if (matchStartPosition) {
        idx++;
    }

    var matchShapeExtent = args[idx].match(SHAPE_AND_EXTENT);
    if (matchShapeExtent) {
        shape = matchShapeExtent[1] || '';
        extent = matchShapeExtent[2] || '';
        if (extent === 'contain') {
            extent = 'closest-side';
        } else if (extent === 'cover') {
            extent = 'farthest-corner';
        }
        idx++;
    }

    var matchStartRadius = args[idx].match(RADIUS);
    if (matchStartRadius) {
        idx++;
    }

    var matchEndPosition = args[idx].match(POSITION);
    if (matchEndPosition) {
        idx++;
    }

    var matchEndRadius = args[idx].match(RADIUS);
    if (matchEndRadius) {
        idx++;
    }

    var matchPosition = matchEndPosition || matchStartPosition;
    if (matchPosition && matchPosition[1]) {
        position = matchPosition[1] + (/^\d+$/.test(matchPosition[1]) ? 'px' : '');
        if (matchPosition[2]) {
            position += ' ' + matchPosition[2] + (/^\d+$/.test(matchPosition[2]) ? 'px' : '');
        }
    }

    var matchRadius = matchEndRadius || matchStartRadius;
    if (matchRadius) {
        radius = matchRadius[0];
        if (!matchRadius[1]) {
            radius += 'px';
        }
    }

    if (position && !shape && !radius && !extent) {
        radius = position;
        position = '';
    }

    if (position) {
        position = 'at ' + position;
    }

    return [[shape, extent, radius, position].filter(function (s) {
        return !!s;
    }).join(' ')].concat(args.slice(idx));
};

var transformObsoleteColorStops = function transformObsoleteColorStops(args) {
    return args.map(function (color) {
        return color.match(FROM_TO_COLORSTOP);
    })
    // $FlowFixMe
    .map(function (v, index) {
        if (!v) {
            return args[index];
        }

        switch (v[1]) {
            case 'from':
                return v[4] + ' 0%';
            case 'to':
                return v[4] + ' 100%';
            case 'color-stop':
                if (v[3] === '%') {
                    return v[4] + ' ' + v[2];
                }
                return v[4] + ' ' + parseFloat(v[2]) * 100 + '%';
        }
    });
};

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NodeParser = undefined;

var _StackingContext = __webpack_require__(1152);

var _StackingContext2 = _interopRequireDefault(_StackingContext);

var _NodeContainer = __webpack_require__(144);

var _NodeContainer2 = _interopRequireDefault(_NodeContainer);

var _TextContainer = __webpack_require__(206);

var _TextContainer2 = _interopRequireDefault(_TextContainer);

var _Input = __webpack_require__(329);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NodeParser = exports.NodeParser = function NodeParser(node, resourceLoader, logger) {
    if (false) {
        logger.log('Starting node parsing');
    }

    var index = 0;

    var container = new _NodeContainer2.default(node, null, resourceLoader, index++);
    var stack = new _StackingContext2.default(container, null, true);

    parseNodeTree(node, container, stack, resourceLoader, index);

    if (false) {
        logger.log('Finished parsing node tree');
    }

    return stack;
};

var IGNORED_NODE_NAMES = ['SCRIPT', 'HEAD', 'TITLE', 'OBJECT', 'BR', 'OPTION'];

var parseNodeTree = function parseNodeTree(node, parent, stack, resourceLoader, index) {
    if (false) {
        throw new Error('Recursion error while parsing node tree');
    }

    for (var childNode = node.firstChild, nextNode; childNode; childNode = nextNode) {
        nextNode = childNode.nextSibling;
        var defaultView = childNode.ownerDocument.defaultView;
        if (childNode instanceof defaultView.Text || childNode instanceof Text || defaultView.parent && childNode instanceof defaultView.parent.Text) {
            if (childNode.data.trim().length > 0) {
                parent.childNodes.push(_TextContainer2.default.fromTextNode(childNode, parent));
            }
        } else if (childNode instanceof defaultView.HTMLElement || childNode instanceof HTMLElement || defaultView.parent && childNode instanceof defaultView.parent.HTMLElement) {
            if (IGNORED_NODE_NAMES.indexOf(childNode.nodeName) === -1) {
                var container = new _NodeContainer2.default(childNode, parent, resourceLoader, index++);
                if (container.isVisible()) {
                    if (childNode.tagName === 'INPUT') {
                        // $FlowFixMe
                        (0, _Input.inlineInputElement)(childNode, container);
                    } else if (childNode.tagName === 'TEXTAREA') {
                        // $FlowFixMe
                        (0, _Input.inlineTextAreaElement)(childNode, container);
                    } else if (childNode.tagName === 'SELECT') {
                        // $FlowFixMe
                        (0, _Input.inlineSelectElement)(childNode, container);
                    }

                    var SHOULD_TRAVERSE_CHILDREN = childNode.tagName !== 'TEXTAREA';
                    var treatAsRealStackingContext = createsRealStackingContext(container, childNode);
                    if (treatAsRealStackingContext || createsStackingContext(container)) {
                        // for treatAsRealStackingContext:false, any positioned descendants and descendants
                        // which actually create a new stacking context should be considered part of the parent stacking context
                        var parentStack = treatAsRealStackingContext || container.isPositioned() ? stack.getRealParentStackingContext() : stack;
                        var childStack = new _StackingContext2.default(container, parentStack, treatAsRealStackingContext);
                        parentStack.contexts.push(childStack);
                        if (SHOULD_TRAVERSE_CHILDREN) {
                            parseNodeTree(childNode, container, childStack, resourceLoader, index);
                        }
                    } else {
                        stack.children.push(container);
                        if (SHOULD_TRAVERSE_CHILDREN) {
                            parseNodeTree(childNode, container, stack, resourceLoader, index);
                        }
                    }
                }
            }
        } else if (childNode instanceof defaultView.SVGSVGElement || childNode instanceof SVGSVGElement || defaultView.parent && childNode instanceof defaultView.parent.SVGSVGElement) {
            var _container = new _NodeContainer2.default(childNode, parent, resourceLoader, index++);
            var _treatAsRealStackingContext = createsRealStackingContext(_container, childNode);
            if (_treatAsRealStackingContext || createsStackingContext(_container)) {
                // for treatAsRealStackingContext:false, any positioned descendants and descendants
                // which actually create a new stacking context should be considered part of the parent stacking context
                var _parentStack = _treatAsRealStackingContext || _container.isPositioned() ? stack.getRealParentStackingContext() : stack;
                var _childStack = new _StackingContext2.default(_container, _parentStack, _treatAsRealStackingContext);
                _parentStack.contexts.push(_childStack);
            } else {
                stack.children.push(_container);
            }
        }
    }
};

var createsRealStackingContext = function createsRealStackingContext(container, node) {
    return container.isRootElement() || container.isPositionedWithZIndex() || container.style.opacity < 1 || container.isTransformed() || isBodyWithTransparentRoot(container, node);
};

var createsStackingContext = function createsStackingContext(container) {
    return container.isPositioned() || container.isFloating();
};

var isBodyWithTransparentRoot = function isBodyWithTransparentRoot(container, node) {
    return node.nodeName === 'BODY' && container.parent instanceof _NodeContainer2.default && container.parent.style.background.backgroundColor.isTransparent();
};

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Bounds = __webpack_require__(73);

var _Font = __webpack_require__(328);

var _Gradient = __webpack_require__(1148);

var _TextContainer = __webpack_require__(206);

var _TextContainer2 = _interopRequireDefault(_TextContainer);

var _background = __webpack_require__(147);

var _border = __webpack_require__(207);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Renderer = function () {
    function Renderer(target, options) {
        _classCallCheck(this, Renderer);

        this.target = target;
        this.options = options;
        target.render(options);
    }

    _createClass(Renderer, [{
        key: 'renderNode',
        value: function renderNode(container) {
            if (container.isVisible()) {
                this.renderNodeBackgroundAndBorders(container);
                this.renderNodeContent(container);
            }
        }
    }, {
        key: 'renderNodeContent',
        value: function renderNodeContent(container) {
            var _this = this;

            var callback = function callback() {
                if (container.childNodes.length) {
                    container.childNodes.forEach(function (child) {
                        if (child instanceof _TextContainer2.default) {
                            var style = child.parent.style;
                            _this.target.renderTextNode(child.bounds, style.color, style.font, style.textDecoration, style.textShadow);
                        } else {
                            _this.target.drawShape(child, container.style.color);
                        }
                    });
                }

                if (container.image) {
                    var _image = _this.options.imageStore.get(container.image);
                    if (_image) {
                        var contentBox = (0, _Bounds.calculateContentBox)(container.bounds, container.style.padding, container.style.border);
                        var _width = typeof _image.width === 'number' && _image.width > 0 ? _image.width : contentBox.width;
                        var _height = typeof _image.height === 'number' && _image.height > 0 ? _image.height : contentBox.height;
                        if (_width > 0 && _height > 0) {
                            _this.target.clip([(0, _Bounds.calculatePaddingBoxPath)(container.curvedBounds)], function () {
                                _this.target.drawImage(_image, new _Bounds.Bounds(0, 0, _width, _height), contentBox);
                            });
                        }
                    }
                }
            };
            var paths = container.getClipPaths();
            if (paths.length) {
                this.target.clip(paths, callback);
            } else {
                callback();
            }
        }
    }, {
        key: 'renderNodeBackgroundAndBorders',
        value: function renderNodeBackgroundAndBorders(container) {
            var _this2 = this;

            var HAS_BACKGROUND = !container.style.background.backgroundColor.isTransparent() || container.style.background.backgroundImage.length;

            var renderableBorders = container.style.border.filter(function (border) {
                return border.borderStyle !== _border.BORDER_STYLE.NONE && !border.borderColor.isTransparent();
            });

            var callback = function callback() {
                var backgroundPaintingArea = (0, _background.calculateBackgroungPaintingArea)(container.curvedBounds, container.style.background.backgroundClip);

                if (HAS_BACKGROUND) {
                    _this2.target.clip([backgroundPaintingArea], function () {
                        if (!container.style.background.backgroundColor.isTransparent()) {
                            _this2.target.fill(container.style.background.backgroundColor);
                        }

                        _this2.renderBackgroundImage(container);
                    });
                }

                renderableBorders.forEach(function (border, side) {
                    _this2.renderBorder(border, side, container.curvedBounds);
                });
            };

            if (HAS_BACKGROUND || renderableBorders.length) {
                var paths = container.parent ? container.parent.getClipPaths() : [];
                if (paths.length) {
                    this.target.clip(paths, callback);
                } else {
                    callback();
                }
            }
        }
    }, {
        key: 'renderBackgroundImage',
        value: function renderBackgroundImage(container) {
            var _this3 = this;

            container.style.background.backgroundImage.slice(0).reverse().forEach(function (backgroundImage) {
                if (backgroundImage.source.method === 'url' && backgroundImage.source.args.length) {
                    _this3.renderBackgroundRepeat(container, backgroundImage);
                } else if (/gradient/i.test(backgroundImage.source.method)) {
                    _this3.renderBackgroundGradient(container, backgroundImage);
                }
            });
        }
    }, {
        key: 'renderBackgroundRepeat',
        value: function renderBackgroundRepeat(container, background) {
            var image = this.options.imageStore.get(background.source.args[0]);
            if (image) {
                var backgroundPositioningArea = (0, _background.calculateBackgroungPositioningArea)(container.style.background.backgroundOrigin, container.bounds, container.style.padding, container.style.border);
                var backgroundImageSize = (0, _background.calculateBackgroundSize)(background, image, backgroundPositioningArea);
                var position = (0, _background.calculateBackgroundPosition)(background.position, backgroundImageSize, backgroundPositioningArea);
                var _path = (0, _background.calculateBackgroundRepeatPath)(background, position, backgroundImageSize, backgroundPositioningArea, container.bounds);

                var _offsetX = Math.round(backgroundPositioningArea.left + position.x);
                var _offsetY = Math.round(backgroundPositioningArea.top + position.y);
                this.target.renderRepeat(_path, image, backgroundImageSize, _offsetX, _offsetY);
            }
        }
    }, {
        key: 'renderBackgroundGradient',
        value: function renderBackgroundGradient(container, background) {
            var backgroundPositioningArea = (0, _background.calculateBackgroungPositioningArea)(container.style.background.backgroundOrigin, container.bounds, container.style.padding, container.style.border);
            var backgroundImageSize = (0, _background.calculateGradientBackgroundSize)(background, backgroundPositioningArea);
            var position = (0, _background.calculateBackgroundPosition)(background.position, backgroundImageSize, backgroundPositioningArea);
            var gradientBounds = new _Bounds.Bounds(Math.round(backgroundPositioningArea.left + position.x), Math.round(backgroundPositioningArea.top + position.y), backgroundImageSize.width, backgroundImageSize.height);

            var gradient = (0, _Gradient.parseGradient)(container, background.source, gradientBounds);
            if (gradient) {
                switch (gradient.type) {
                    case _Gradient.GRADIENT_TYPE.LINEAR_GRADIENT:
                        // $FlowFixMe
                        this.target.renderLinearGradient(gradientBounds, gradient);
                        break;
                    case _Gradient.GRADIENT_TYPE.RADIAL_GRADIENT:
                        // $FlowFixMe
                        this.target.renderRadialGradient(gradientBounds, gradient);
                        break;
                }
            }
        }
    }, {
        key: 'renderBorder',
        value: function renderBorder(border, side, curvePoints) {
            this.target.drawShape((0, _Bounds.parsePathForBorder)(curvePoints, side), border.borderColor);
        }
    }, {
        key: 'renderStack',
        value: function renderStack(stack) {
            var _this4 = this;

            if (stack.container.isVisible()) {
                var _opacity = stack.getOpacity();
                if (_opacity !== this._opacity) {
                    this.target.setOpacity(stack.getOpacity());
                    this._opacity = _opacity;
                }

                var _transform = stack.container.style.transform;
                if (_transform !== null) {
                    this.target.transform(stack.container.bounds.left + _transform.transformOrigin[0].value, stack.container.bounds.top + _transform.transformOrigin[1].value, _transform.transform, function () {
                        return _this4.renderStackContent(stack);
                    });
                } else {
                    this.renderStackContent(stack);
                }
            }
        }
    }, {
        key: 'renderStackContent',
        value: function renderStackContent(stack) {
            var _splitStackingContext = splitStackingContexts(stack),
                _splitStackingContext2 = _slicedToArray(_splitStackingContext, 5),
                negativeZIndex = _splitStackingContext2[0],
                zeroOrAutoZIndexOrTransformedOrOpacity = _splitStackingContext2[1],
                positiveZIndex = _splitStackingContext2[2],
                nonPositionedFloats = _splitStackingContext2[3],
                nonPositionedInlineLevel = _splitStackingContext2[4];

            var _splitDescendants = splitDescendants(stack),
                _splitDescendants2 = _slicedToArray(_splitDescendants, 2),
                inlineLevel = _splitDescendants2[0],
                nonInlineLevel = _splitDescendants2[1];

            // https://www.w3.org/TR/css-position-3/#painting-order
            // 1. the background and borders of the element forming the stacking context.


            this.renderNodeBackgroundAndBorders(stack.container);
            // 2. the child stacking contexts with negative stack levels (most negative first).
            negativeZIndex.sort(sortByZIndex).forEach(this.renderStack, this);
            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
            this.renderNodeContent(stack.container);
            nonInlineLevel.forEach(this.renderNode, this);
            // 4. All non-positioned floating descendants, in tree order. For each one of these,
            // treat the element as if it created a new stacking context, but any positioned descendants and descendants
            // which actually create a new stacking context should be considered part of the parent stacking context,
            // not this new one.
            nonPositionedFloats.forEach(this.renderStack, this);
            // 5. the in-flow, inline-level, non-positioned descendants, including inline tables and inline blocks.
            nonPositionedInlineLevel.forEach(this.renderStack, this);
            inlineLevel.forEach(this.renderNode, this);
            // 6. All positioned, opacity or transform descendants, in tree order that fall into the following categories:
            //  All positioned descendants with 'z-index: auto' or 'z-index: 0', in tree order.
            //  For those with 'z-index: auto', treat the element as if it created a new stacking context,
            //  but any positioned descendants and descendants which actually create a new stacking context should be
            //  considered part of the parent stacking context, not this new one. For those with 'z-index: 0',
            //  treat the stacking context generated atomically.
            //
            //  All opacity descendants with opacity less than 1
            //
            //  All transform descendants with transform other than none
            zeroOrAutoZIndexOrTransformedOrOpacity.forEach(this.renderStack, this);
            // 7. Stacking contexts formed by positioned descendants with z-indices greater than or equal to 1 in z-index
            // order (smallest first) then tree order.
            positiveZIndex.sort(sortByZIndex).forEach(this.renderStack, this);
        }
    }, {
        key: 'render',
        value: function render(stack) {
            var _this5 = this;

            if (this.options.backgroundColor) {
                this.target.rectangle(this.options.x, this.options.y, this.options.width, this.options.height, this.options.backgroundColor);
            }
            this.renderStack(stack);
            var target = this.target.getTarget();
            if (false) {
                return target.then(function (output) {
                    _this5.options.logger.log('Render completed');
                    return output;
                });
            }
            return target;
        }
    }]);

    return Renderer;
}();

exports.default = Renderer;


var splitDescendants = function splitDescendants(stack) {
    var inlineLevel = [];
    var nonInlineLevel = [];

    var length = stack.children.length;
    for (var i = 0; i < length; i++) {
        var child = stack.children[i];
        if (child.isInlineLevel()) {
            inlineLevel.push(child);
        } else {
            nonInlineLevel.push(child);
        }
    }
    return [inlineLevel, nonInlineLevel];
};

var splitStackingContexts = function splitStackingContexts(stack) {
    var negativeZIndex = [];
    var zeroOrAutoZIndexOrTransformedOrOpacity = [];
    var positiveZIndex = [];
    var nonPositionedFloats = [];
    var nonPositionedInlineLevel = [];
    var length = stack.contexts.length;
    for (var i = 0; i < length; i++) {
        var child = stack.contexts[i];
        if (child.container.isPositioned() || child.container.style.opacity < 1 || child.container.isTransformed()) {
            if (child.container.style.zIndex.order < 0) {
                negativeZIndex.push(child);
            } else if (child.container.style.zIndex.order > 0) {
                positiveZIndex.push(child);
            } else {
                zeroOrAutoZIndexOrTransformedOrOpacity.push(child);
            }
        } else {
            if (child.container.isFloating()) {
                nonPositionedFloats.push(child);
            } else {
                nonPositionedInlineLevel.push(child);
            }
        }
    }
    return [negativeZIndex, zeroOrAutoZIndexOrTransformedOrOpacity, positiveZIndex, nonPositionedFloats, nonPositionedInlineLevel];
};

var sortByZIndex = function sortByZIndex(a, b) {
    if (a.container.style.zIndex.order > b.container.style.zIndex.order) {
        return 1;
    } else if (a.container.style.zIndex.order < b.container.style.zIndex.order) {
        return -1;
    }

    return a.container.index > b.container.index ? 1 : -1;
};

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ResourceStore = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Feature = __webpack_require__(143);

var _Feature2 = _interopRequireDefault(_Feature);

var _Proxy = __webpack_require__(331);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ResourceLoader = function () {
    function ResourceLoader(options, logger, window) {
        _classCallCheck(this, ResourceLoader);

        this.options = options;
        this._window = window;
        this.origin = this.getOrigin(window.location.href);
        this.cache = {};
        this.logger = logger;
        this._index = 0;
    }

    _createClass(ResourceLoader, [{
        key: 'loadImage',
        value: function loadImage(src) {
            var _this = this;

            if (this.hasResourceInCache(src)) {
                return src;
            }

            if (!isSVG(src) || _Feature2.default.SUPPORT_SVG_DRAWING) {
                if (this.options.allowTaint === true || isInlineImage(src) || this.isSameOrigin(src)) {
                    return this.addImage(src, src, false);
                } else if (!this.isSameOrigin(src)) {
                    if (typeof this.options.proxy === 'string') {
                        this.cache[src] = (0, _Proxy.Proxy)(src, this.options).then(function (src) {
                            return _loadImage(src, _this.options.imageTimeout || 0);
                        });
                        return src;
                    } else if (this.options.useCORS === true && _Feature2.default.SUPPORT_CORS_IMAGES) {
                        return this.addImage(src, src, true);
                    }
                }
            }
        }
    }, {
        key: 'inlineImage',
        value: function inlineImage(src) {
            var _this2 = this;

            if (isInlineImage(src)) {
                return _loadImage(src, this.options.imageTimeout || 0);
            }
            if (this.hasResourceInCache(src)) {
                return this.cache[src];
            }
            if (!this.isSameOrigin(src) && typeof this.options.proxy === 'string') {
                return this.cache[src] = (0, _Proxy.Proxy)(src, this.options).then(function (src) {
                    return _loadImage(src, _this2.options.imageTimeout || 0);
                });
            }

            return this.xhrImage(src);
        }
    }, {
        key: 'xhrImage',
        value: function xhrImage(src) {
            var _this3 = this;

            this.cache[src] = new Promise(function (resolve, reject) {
                var xhr = new XMLHttpRequest();
                xhr.onreadystatechange = function () {
                    if (xhr.readyState === 4) {
                        if (xhr.status !== 200) {
                            reject('Failed to fetch image ' + src.substring(0, 256) + ' with status code ' + xhr.status);
                        } else {
                            var reader = new FileReader();
                            reader.addEventListener('load', function () {
                                // $FlowFixMe
                                var result = reader.result;
                                resolve(result);
                            }, false);
                            reader.addEventListener('error', function (e) {
                                return reject(e);
                            }, false);
                            reader.readAsDataURL(xhr.response);
                        }
                    }
                };
                xhr.responseType = 'blob';
                if (_this3.options.imageTimeout) {
                    var timeout = _this3.options.imageTimeout;
                    xhr.timeout = timeout;
                    xhr.ontimeout = function () {
                        return reject( false ? 'Timed out (' + timeout + 'ms) fetching ' + src.substring(0, 256) : '');
                    };
                }
                xhr.open('GET', src, true);
                xhr.send();
            }).then(function (src) {
                return _loadImage(src, _this3.options.imageTimeout || 0);
            });

            return this.cache[src];
        }
    }, {
        key: 'loadCanvas',
        value: function loadCanvas(node) {
            var key = String(this._index++);
            this.cache[key] = Promise.resolve(node);
            return key;
        }
    }, {
        key: 'hasResourceInCache',
        value: function hasResourceInCache(key) {
            return typeof this.cache[key] !== 'undefined';
        }
    }, {
        key: 'addImage',
        value: function addImage(key, src, useCORS) {
            var _this4 = this;

            if (false) {
                this.logger.log('Added image ' + key.substring(0, 256));
            }

            var imageLoadHandler = function imageLoadHandler(supportsDataImages) {
                return new Promise(function (resolve, reject) {
                    var img = new Image();
                    img.onload = function () {
                        return resolve(img);
                    };
                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                    if (!supportsDataImages || useCORS) {
                        img.crossOrigin = 'anonymous';
                    }

                    img.onerror = reject;
                    img.src = src;
                    if (img.complete === true) {
                        // Inline XML images may fail to parse, throwing an Error later on
                        setTimeout(function () {
                            resolve(img);
                        }, 500);
                    }
                    if (_this4.options.imageTimeout) {
                        var timeout = _this4.options.imageTimeout;
                        setTimeout(function () {
                            return reject( false ? 'Timed out (' + timeout + 'ms) fetching ' + src.substring(0, 256) : '');
                        }, timeout);
                    }
                });
            };

            this.cache[key] = isInlineBase64Image(src) && !isSVG(src) ? // $FlowFixMe
            _Feature2.default.SUPPORT_BASE64_DRAWING(src).then(imageLoadHandler) : imageLoadHandler(true);
            return key;
        }
    }, {
        key: 'isSameOrigin',
        value: function isSameOrigin(url) {
            return this.getOrigin(url) === this.origin;
        }
    }, {
        key: 'getOrigin',
        value: function getOrigin(url) {
            var link = this._link || (this._link = this._window.document.createElement('a'));
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        }
    }, {
        key: 'ready',
        value: function ready() {
            var _this5 = this;

            var keys = Object.keys(this.cache);
            var values = keys.map(function (str) {
                return _this5.cache[str].catch(function (e) {
                    if (false) {
                        _this5.logger.log('Unable to load image', e);
                    }
                    return null;
                });
            });
            return Promise.all(values).then(function (images) {
                if (false) {
                    _this5.logger.log('Finished loading ' + images.length + ' images', images);
                }
                return new ResourceStore(keys, images);
            });
        }
    }]);

    return ResourceLoader;
}();

exports.default = ResourceLoader;

var ResourceStore = exports.ResourceStore = function () {
    function ResourceStore(keys, resources) {
        _classCallCheck(this, ResourceStore);

        this._keys = keys;
        this._resources = resources;
    }

    _createClass(ResourceStore, [{
        key: 'get',
        value: function get(key) {
            var index = this._keys.indexOf(key);
            return index === -1 ? null : this._resources[index];
        }
    }]);

    return ResourceStore;
}();

var INLINE_SVG = /^data:image\/svg\+xml/i;
var INLINE_BASE64 = /^data:image\/.*;base64,/i;
var INLINE_IMG = /^data:image\/.*/i;

var isInlineImage = function isInlineImage(src) {
    return INLINE_IMG.test(src);
};
var isInlineBase64Image = function isInlineBase64Image(src) {
    return INLINE_BASE64.test(src);
};

var isSVG = function isSVG(src) {
    return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src);
};

var _loadImage = function _loadImage(src, timeout) {
    return new Promise(function (resolve, reject) {
        var img = new Image();
        img.onload = function () {
            return resolve(img);
        };
        img.onerror = reject;
        img.src = src;
        if (img.complete === true) {
            // Inline XML images may fail to parse, throwing an Error later on
            setTimeout(function () {
                resolve(img);
            }, 500);
        }
        if (timeout) {
            setTimeout(function () {
                return reject( false ? 'Timed out (' + timeout + 'ms) loading image' : '');
            }, timeout);
        }
    });
};

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _NodeContainer = __webpack_require__(144);

var _NodeContainer2 = _interopRequireDefault(_NodeContainer);

var _position = __webpack_require__(334);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StackingContext = function () {
    function StackingContext(container, parent, treatAsRealStackingContext) {
        _classCallCheck(this, StackingContext);

        this.container = container;
        this.parent = parent;
        this.contexts = [];
        this.children = [];
        this.treatAsRealStackingContext = treatAsRealStackingContext;
    }

    _createClass(StackingContext, [{
        key: 'getOpacity',
        value: function getOpacity() {
            return this.parent ? this.container.style.opacity * this.parent.getOpacity() : this.container.style.opacity;
        }
    }, {
        key: 'getRealParentStackingContext',
        value: function getRealParentStackingContext() {
            return !this.parent || this.treatAsRealStackingContext ? this : this.parent.getRealParentStackingContext();
        }
    }]);

    return StackingContext;
}();

exports.default = StackingContext;

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.renderElement = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _Logger = __webpack_require__(330);

var _Logger2 = _interopRequireDefault(_Logger);

var _NodeParser = __webpack_require__(1149);

var _Renderer = __webpack_require__(1150);

var _Renderer2 = _interopRequireDefault(_Renderer);

var _ForeignObjectRenderer = __webpack_require__(337);

var _ForeignObjectRenderer2 = _interopRequireDefault(_ForeignObjectRenderer);

var _Feature = __webpack_require__(143);

var _Feature2 = _interopRequireDefault(_Feature);

var _Bounds = __webpack_require__(73);

var _Clone = __webpack_require__(1147);

var _Font = __webpack_require__(328);

var _Color = __webpack_require__(74);

var _Color2 = _interopRequireDefault(_Color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderElement = exports.renderElement = function renderElement(element, options, logger) {
    var ownerDocument = element.ownerDocument;

    var windowBounds = new _Bounds.Bounds(options.scrollX, options.scrollY, options.windowWidth, options.windowHeight);

    // http://www.w3.org/TR/css3-background/#special-backgrounds
    var documentBackgroundColor = ownerDocument.documentElement ? new _Color2.default(getComputedStyle(ownerDocument.documentElement).backgroundColor) : _Color.TRANSPARENT;
    var bodyBackgroundColor = ownerDocument.body ? new _Color2.default(getComputedStyle(ownerDocument.body).backgroundColor) : _Color.TRANSPARENT;

    var backgroundColor = element === ownerDocument.documentElement ? documentBackgroundColor.isTransparent() ? bodyBackgroundColor.isTransparent() ? options.backgroundColor ? new _Color2.default(options.backgroundColor) : null : bodyBackgroundColor : documentBackgroundColor : options.backgroundColor ? new _Color2.default(options.backgroundColor) : null;

    return (options.foreignObjectRendering ? // $FlowFixMe
    _Feature2.default.SUPPORT_FOREIGNOBJECT_DRAWING : Promise.resolve(false)).then(function (supportForeignObject) {
        return supportForeignObject ? function (cloner) {
            if (false) {
                logger.log('Document cloned, using foreignObject rendering');
            }

            return cloner.inlineFonts(ownerDocument).then(function () {
                return cloner.resourceLoader.ready();
            }).then(function () {
                var renderer = new _ForeignObjectRenderer2.default(cloner.documentElement);
                return renderer.render({
                    backgroundColor: backgroundColor,
                    logger: logger,
                    scale: options.scale,
                    x: options.x,
                    y: options.y,
                    width: options.width,
                    height: options.height,
                    windowWidth: options.windowWidth,
                    windowHeight: options.windowHeight,
                    scrollX: options.scrollX,
                    scrollY: options.scrollY
                });
            });
        }(new _Clone.DocumentCloner(element, options, logger, true, renderElement)) : (0, _Clone.cloneWindow)(ownerDocument, windowBounds, element, options, logger, renderElement).then(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 3),
                container = _ref2[0],
                clonedElement = _ref2[1],
                resourceLoader = _ref2[2];

            if (false) {
                logger.log('Document cloned, using computed rendering');
            }

            var stack = (0, _NodeParser.NodeParser)(clonedElement, resourceLoader, logger);
            var clonedDocument = clonedElement.ownerDocument;

            if (backgroundColor === stack.container.style.background.backgroundColor) {
                stack.container.style.background.backgroundColor = _Color.TRANSPARENT;
            }

            return resourceLoader.ready().then(function (imageStore) {
                if (options.removeContainer === true) {
                    if (container.parentNode) {
                        container.parentNode.removeChild(container);
                    } else if (false) {
                        logger.log('Cannot detach cloned iframe as it is not in the DOM anymore');
                    }
                }

                var fontMetrics = new _Font.FontMetrics(clonedDocument);
                if (false) {
                    logger.log('Starting renderer');
                }

                var renderOptions = {
                    backgroundColor: backgroundColor,
                    fontMetrics: fontMetrics,
                    imageStore: imageStore,
                    logger: logger,
                    scale: options.scale,
                    x: options.x,
                    y: options.y,
                    width: options.width,
                    height: options.height
                };

                if (Array.isArray(options.target)) {
                    return Promise.all(options.target.map(function (target) {
                        var renderer = new _Renderer2.default(target, renderOptions);
                        return renderer.render(stack);
                    }));
                } else {
                    var renderer = new _Renderer2.default(options.target, renderOptions);
                    return renderer.render(stack);
                }
            });
        });
    });
};

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Path = __webpack_require__(145);

var _Vector = __webpack_require__(146);

var _Vector2 = _interopRequireDefault(_Vector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var lerp = function lerp(a, b, t) {
    return new _Vector2.default(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
};

var BezierCurve = function () {
    function BezierCurve(start, startControl, endControl, end) {
        _classCallCheck(this, BezierCurve);

        this.type = _Path.PATH.BEZIER_CURVE;
        this.start = start;
        this.startControl = startControl;
        this.endControl = endControl;
        this.end = end;
    }

    _createClass(BezierCurve, [{
        key: 'subdivide',
        value: function subdivide(t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        }
    }, {
        key: 'reverse',
        value: function reverse() {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        }
    }]);

    return BezierCurve;
}();

exports.default = BezierCurve;

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Path = __webpack_require__(145);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Circle = function Circle(x, y, radius) {
    _classCallCheck(this, Circle);

    this.type = _Path.PATH.CIRCLE;
    this.x = x;
    this.y = y;
    this.radius = radius;
    if (false) {
        if (isNaN(x)) {
            console.error('Invalid x value given for Circle');
        }
        if (isNaN(y)) {
            console.error('Invalid y value given for Circle');
        }
        if (isNaN(radius)) {
            console.error('Invalid radius value given for Circle');
        }
    }
};

exports.default = Circle;

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Size = function Size(width, height) {
    _classCallCheck(this, Size);

    this.width = width;
    this.height = height;
};

exports.default = Size;

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _CanvasRenderer = __webpack_require__(336);

var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);

var _Logger = __webpack_require__(330);

var _Logger2 = _interopRequireDefault(_Logger);

var _Window = __webpack_require__(1153);

var _Bounds = __webpack_require__(73);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var html2canvas = function html2canvas(element, conf) {
    // eslint-disable-next-line no-console
    if ((typeof console === 'undefined' ? 'undefined' : _typeof(console)) === 'object' && typeof console.log === 'function') {
        // eslint-disable-next-line no-console
        console.log('html2canvas ' + "$npm_package_version");
    }

    var config = conf || {};
    var logger = new _Logger2.default(typeof config.logging === 'boolean' ? config.logging : true);

    if (false) {
        logger.error('onrendered option is deprecated, html2canvas returns a Promise with the canvas as the value');
    }

    var ownerDocument = element.ownerDocument;
    if (!ownerDocument) {
        return Promise.reject('Provided element is not within a Document');
    }
    var defaultView = ownerDocument.defaultView;

    var scrollX = defaultView.pageXOffset;
    var scrollY = defaultView.pageYOffset;

    var isDocument = element.tagName === 'HTML' || element.tagName === 'BODY';

    var _ref = isDocument ? (0, _Bounds.parseDocumentSize)(ownerDocument) : (0, _Bounds.parseBounds)(element, scrollX, scrollY),
        width = _ref.width,
        height = _ref.height,
        left = _ref.left,
        top = _ref.top;

    var defaultOptions = {
        async: true,
        allowTaint: false,
        backgroundColor: '#ffffff',
        imageTimeout: 15000,
        logging: true,
        proxy: null,
        removeContainer: true,
        foreignObjectRendering: false,
        scale: defaultView.devicePixelRatio || 1,
        target: new _CanvasRenderer2.default(config.canvas),
        x: left,
        y: top,
        width: Math.ceil(width),
        height: Math.ceil(height),
        windowWidth: defaultView.innerWidth,
        windowHeight: defaultView.innerHeight,
        scrollX: defaultView.pageXOffset,
        scrollY: defaultView.pageYOffset
    };

    var result = (0, _Window.renderElement)(element, _extends({}, defaultOptions, config), logger);

    if (false) {
        return result.catch(function (e) {
            logger.error(e);
            throw e;
        });
    }
    return result;
};

html2canvas.CanvasRenderer = _CanvasRenderer2.default;

module.exports = html2canvas;

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseBorderRadius = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _Length = __webpack_require__(97);

var _Length2 = _interopRequireDefault(_Length);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SIDES = ['top-left', 'top-right', 'bottom-right', 'bottom-left'];

var parseBorderRadius = exports.parseBorderRadius = function parseBorderRadius(style) {
    return SIDES.map(function (side) {
        var value = style.getPropertyValue('border-' + side + '-radius');

        var _value$split$map = value.split(' ').map(_Length2.default.create),
            _value$split$map2 = _slicedToArray(_value$split$map, 2),
            horizontal = _value$split$map2[0],
            vertical = _value$split$map2[1];

        return typeof vertical === 'undefined' ? [horizontal, horizontal] : [horizontal, vertical];
    });
};

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var DISPLAY = exports.DISPLAY = {
    NONE: 1 << 0,
    BLOCK: 1 << 1,
    INLINE: 1 << 2,
    RUN_IN: 1 << 3,
    FLOW: 1 << 4,
    FLOW_ROOT: 1 << 5,
    TABLE: 1 << 6,
    FLEX: 1 << 7,
    GRID: 1 << 8,
    RUBY: 1 << 9,
    SUBGRID: 1 << 10,
    LIST_ITEM: 1 << 11,
    TABLE_ROW_GROUP: 1 << 12,
    TABLE_HEADER_GROUP: 1 << 13,
    TABLE_FOOTER_GROUP: 1 << 14,
    TABLE_ROW: 1 << 15,
    TABLE_CELL: 1 << 16,
    TABLE_COLUMN_GROUP: 1 << 17,
    TABLE_COLUMN: 1 << 18,
    TABLE_CAPTION: 1 << 19,
    RUBY_BASE: 1 << 20,
    RUBY_TEXT: 1 << 21,
    RUBY_BASE_CONTAINER: 1 << 22,
    RUBY_TEXT_CONTAINER: 1 << 23,
    CONTENTS: 1 << 24,
    INLINE_BLOCK: 1 << 25,
    INLINE_LIST_ITEM: 1 << 26,
    INLINE_TABLE: 1 << 27,
    INLINE_FLEX: 1 << 28,
    INLINE_GRID: 1 << 29
};

var parseDisplayValue = function parseDisplayValue(display) {
    switch (display) {
        case 'block':
            return DISPLAY.BLOCK;
        case 'inline':
            return DISPLAY.INLINE;
        case 'run-in':
            return DISPLAY.RUN_IN;
        case 'flow':
            return DISPLAY.FLOW;
        case 'flow-root':
            return DISPLAY.FLOW_ROOT;
        case 'table':
            return DISPLAY.TABLE;
        case 'flex':
            return DISPLAY.FLEX;
        case 'grid':
            return DISPLAY.GRID;
        case 'ruby':
            return DISPLAY.RUBY;
        case 'subgrid':
            return DISPLAY.SUBGRID;
        case 'list-item':
            return DISPLAY.LIST_ITEM;
        case 'table-row-group':
            return DISPLAY.TABLE_ROW_GROUP;
        case 'table-header-group':
            return DISPLAY.TABLE_HEADER_GROUP;
        case 'table-footer-group':
            return DISPLAY.TABLE_FOOTER_GROUP;
        case 'table-row':
            return DISPLAY.TABLE_ROW;
        case 'table-cell':
            return DISPLAY.TABLE_CELL;
        case 'table-column-group':
            return DISPLAY.TABLE_COLUMN_GROUP;
        case 'table-column':
            return DISPLAY.TABLE_COLUMN;
        case 'table-caption':
            return DISPLAY.TABLE_CAPTION;
        case 'ruby-base':
            return DISPLAY.RUBY_BASE;
        case 'ruby-text':
            return DISPLAY.RUBY_TEXT;
        case 'ruby-base-container':
            return DISPLAY.RUBY_BASE_CONTAINER;
        case 'ruby-text-container':
            return DISPLAY.RUBY_TEXT_CONTAINER;
        case 'contents':
            return DISPLAY.CONTENTS;
        case 'inline-block':
            return DISPLAY.INLINE_BLOCK;
        case 'inline-list-item':
            return DISPLAY.INLINE_LIST_ITEM;
        case 'inline-table':
            return DISPLAY.INLINE_TABLE;
        case 'inline-flex':
            return DISPLAY.INLINE_FLEX;
        case 'inline-grid':
            return DISPLAY.INLINE_GRID;
    }

    return DISPLAY.NONE;
};

var setDisplayBit = function setDisplayBit(bit, display) {
    return bit | parseDisplayValue(display);
};

var parseDisplay = exports.parseDisplay = function parseDisplay(display) {
    return display.split(' ').reduce(setDisplayBit, 0);
};

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var FLOAT = exports.FLOAT = {
    NONE: 0,
    LEFT: 1,
    RIGHT: 2,
    INLINE_START: 3,
    INLINE_END: 4
};

var parseCSSFloat = exports.parseCSSFloat = function parseCSSFloat(float) {
    switch (float) {
        case 'left':
            return FLOAT.LEFT;
        case 'right':
            return FLOAT.RIGHT;
        case 'inline-start':
            return FLOAT.INLINE_START;
        case 'inline-end':
            return FLOAT.INLINE_END;
    }
    return FLOAT.NONE;
};

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});


var parseFontWeight = function parseFontWeight(weight) {
    switch (weight) {
        case 'normal':
            return 400;
        case 'bold':
            return 700;
    }

    var value = parseInt(weight, 10);
    return isNaN(value) ? 400 : value;
};

var parseFont = exports.parseFont = function parseFont(style) {
    var fontFamily = style.fontFamily;
    var fontSize = style.fontSize;
    var fontStyle = style.fontStyle;
    var fontVariant = style.fontVariant;
    var fontWeight = parseFontWeight(style.fontWeight);

    return {
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontStyle: fontStyle,
        fontVariant: fontVariant,
        fontWeight: fontWeight
    };
};

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var parseLetterSpacing = exports.parseLetterSpacing = function parseLetterSpacing(letterSpacing) {
    if (letterSpacing === 'normal') {
        return 0;
    }
    var value = parseFloat(letterSpacing);
    return isNaN(value) ? 0 : value;
};

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var OVERFLOW = exports.OVERFLOW = {
    VISIBLE: 0,
    HIDDEN: 1,
    SCROLL: 2,
    AUTO: 3
};

var parseOverflow = exports.parseOverflow = function parseOverflow(overflow) {
    switch (overflow) {
        case 'hidden':
            return OVERFLOW.HIDDEN;
        case 'scroll':
            return OVERFLOW.SCROLL;
        case 'auto':
            return OVERFLOW.AUTO;
        case 'visible':
        default:
            return OVERFLOW.VISIBLE;
    }
};

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseTextShadow = undefined;

var _Color = __webpack_require__(74);

var _Color2 = _interopRequireDefault(_Color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NUMBER = /^([+-]|\d|\.)$/i;

var parseTextShadow = exports.parseTextShadow = function parseTextShadow(textShadow) {
    if (textShadow === 'none' || typeof textShadow !== 'string') {
        return null;
    }

    var currentValue = '';
    var isLength = false;
    var values = [];
    var shadows = [];
    var numParens = 0;
    var color = null;

    var appendValue = function appendValue() {
        if (currentValue.length) {
            if (isLength) {
                values.push(parseFloat(currentValue));
            } else {
                color = new _Color2.default(currentValue);
            }
        }
        isLength = false;
        currentValue = '';
    };

    var appendShadow = function appendShadow() {
        if (values.length && color !== null) {
            shadows.push({
                color: color,
                offsetX: values[0] || 0,
                offsetY: values[1] || 0,
                blur: values[2] || 0
            });
        }
        values.splice(0, values.length);
        color = null;
    };

    for (var i = 0; i < textShadow.length; i++) {
        var c = textShadow[i];
        switch (c) {
            case '(':
                currentValue += c;
                numParens++;
                break;
            case ')':
                currentValue += c;
                numParens--;
                break;
            case ',':
                if (numParens === 0) {
                    appendValue();
                    appendShadow();
                } else {
                    currentValue += c;
                }
                break;
            case ' ':
                if (numParens === 0) {
                    appendValue();
                } else {
                    currentValue += c;
                }
                break;
            default:
                if (currentValue.length === 0 && NUMBER.test(c)) {
                    isLength = true;
                }
                currentValue += c;
        }
    }

    appendValue();
    appendShadow();

    if (shadows.length === 0) {
        return null;
    }

    return shadows;
};

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseTransform = undefined;

var _Length = __webpack_require__(97);

var _Length2 = _interopRequireDefault(_Length);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var toFloat = function toFloat(s) {
    return parseFloat(s.trim());
};

var MATRIX = /(matrix|matrix3d)\((.+)\)/;

var parseTransform = exports.parseTransform = function parseTransform(style) {
    var transform = parseTransformMatrix(style.transform || style.webkitTransform || style.mozTransform ||
    // $FlowFixMe
    style.msTransform ||
    // $FlowFixMe
    style.oTransform);
    if (transform === null) {
        return null;
    }

    return {
        transform: transform,
        transformOrigin: parseTransformOrigin(style.transformOrigin || style.webkitTransformOrigin || style.mozTransformOrigin ||
        // $FlowFixMe
        style.msTransformOrigin ||
        // $FlowFixMe
        style.oTransformOrigin)
    };
};

// $FlowFixMe
var parseTransformOrigin = function parseTransformOrigin(origin) {
    if (typeof origin !== 'string') {
        var v = new _Length2.default('0');
        return [v, v];
    }
    var values = origin.split(' ').map(_Length2.default.create);
    return [values[0], values[1]];
};

// $FlowFixMe
var parseTransformMatrix = function parseTransformMatrix(transform) {
    if (transform === 'none' || typeof transform !== 'string') {
        return null;
    }

    var match = transform.match(MATRIX);
    if (match) {
        if (match[1] === 'matrix') {
            var matrix = match[2].split(',').map(toFloat);
            return [matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]];
        } else {
            var matrix3d = match[2].split(',').map(toFloat);
            return [matrix3d[0], matrix3d[1], matrix3d[4], matrix3d[5], matrix3d[12], matrix3d[13]];
        }
    }
    return null;
};

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var VISIBILITY = exports.VISIBILITY = {
    VISIBLE: 0,
    HIDDEN: 1,
    COLLAPSE: 2
};

var parseVisibility = exports.parseVisibility = function parseVisibility(visibility) {
    switch (visibility) {
        case 'hidden':
            return VISIBILITY.HIDDEN;
        case 'collapse':
            return VISIBILITY.COLLAPSE;
        case 'visible':
        default:
            return VISIBILITY.VISIBLE;
    }
};

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var parseZIndex = exports.parseZIndex = function parseZIndex(zIndex) {
    var auto = zIndex === 'auto';
    return {
        auto: auto,
        order: auto ? 0 : parseInt(zIndex, 10)
    };
};

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
var Locale = __webpack_require__(338);
var KeyCombo = __webpack_require__(209);


function Keyboard(targetWindow, targetElement, platform, userAgent) {
  this._locale               = null;
  this._currentContext       = null;
  this._contexts             = {};
  this._listeners            = [];
  this._appliedListeners     = [];
  this._locales              = {};
  this._targetElement        = null;
  this._targetWindow         = null;
  this._targetPlatform       = '';
  this._targetUserAgent      = '';
  this._isModernBrowser      = false;
  this._targetKeyDownBinding = null;
  this._targetKeyUpBinding   = null;
  this._targetResetBinding   = null;
  this._paused               = false;

  this.setContext('global');
  this.watch(targetWindow, targetElement, platform, userAgent);
}

Keyboard.prototype.setLocale = function(localeName, localeBuilder) {
  var locale = null;
  if (typeof localeName === 'string') {

    if (localeBuilder) {
      locale = new Locale(localeName);
      localeBuilder(locale, this._targetPlatform, this._targetUserAgent);
    } else {
      locale = this._locales[localeName] || null;
    }
  } else {
    locale     = localeName;
    localeName = locale._localeName;
  }

  this._locale              = locale;
  this._locales[localeName] = locale;
  if (locale) {
    this._locale.pressedKeys = locale.pressedKeys;
  }
};

Keyboard.prototype.getLocale = function(localName) {
  localName || (localName = this._locale.localeName);
  return this._locales[localName] || null;
};

Keyboard.prototype.bind = function(keyComboStr, pressHandler, releaseHandler, preventRepeatByDefault) {
  if (keyComboStr === null || typeof keyComboStr === 'function') {
    preventRepeatByDefault = releaseHandler;
    releaseHandler         = pressHandler;
    pressHandler           = keyComboStr;
    keyComboStr            = null;
  }

  if (
    keyComboStr &&
    typeof keyComboStr === 'object' &&
    typeof keyComboStr.length === 'number'
  ) {
    for (var i = 0; i < keyComboStr.length; i += 1) {
      this.bind(keyComboStr[i], pressHandler, releaseHandler);
    }
    return;
  }

  this._listeners.push({
    keyCombo               : keyComboStr ? new KeyCombo(keyComboStr) : null,
    pressHandler           : pressHandler           || null,
    releaseHandler         : releaseHandler         || null,
    preventRepeat          : preventRepeatByDefault || false,
    preventRepeatByDefault : preventRepeatByDefault || false
  });
};
Keyboard.prototype.addListener = Keyboard.prototype.bind;
Keyboard.prototype.on          = Keyboard.prototype.bind;

Keyboard.prototype.unbind = function(keyComboStr, pressHandler, releaseHandler) {
  if (keyComboStr === null || typeof keyComboStr === 'function') {
    releaseHandler = pressHandler;
    pressHandler   = keyComboStr;
    keyComboStr = null;
  }

  if (
    keyComboStr &&
    typeof keyComboStr === 'object' &&
    typeof keyComboStr.length === 'number'
  ) {
    for (var i = 0; i < keyComboStr.length; i += 1) {
      this.unbind(keyComboStr[i], pressHandler, releaseHandler);
    }
    return;
  }

  for (var i = 0; i < this._listeners.length; i += 1) {
    var listener = this._listeners[i];

    var comboMatches          = !keyComboStr && !listener.keyCombo ||
                                listener.keyCombo && listener.keyCombo.isEqual(keyComboStr);
    var pressHandlerMatches   = !pressHandler && !releaseHandler ||
                                !pressHandler && !listener.pressHandler ||
                                pressHandler === listener.pressHandler;
    var releaseHandlerMatches = !pressHandler && !releaseHandler ||
                                !releaseHandler && !listener.releaseHandler ||
                                releaseHandler === listener.releaseHandler;

    if (comboMatches && pressHandlerMatches && releaseHandlerMatches) {
      this._listeners.splice(i, 1);
      i -= 1;
    }
  }
};
Keyboard.prototype.removeListener = Keyboard.prototype.unbind;
Keyboard.prototype.off            = Keyboard.prototype.unbind;

Keyboard.prototype.setContext = function(contextName) {
  if(this._locale) { this.releaseAllKeys(); }

  if (!this._contexts[contextName]) {
    this._contexts[contextName] = [];
  }
  this._listeners      = this._contexts[contextName];
  this._currentContext = contextName;
};

Keyboard.prototype.getContext = function() {
  return this._currentContext;
};

Keyboard.prototype.withContext = function(contextName, callback) {
  var previousContextName = this.getContext();
  this.setContext(contextName);

  callback();

  this.setContext(previousContextName);
};

Keyboard.prototype.watch = function(targetWindow, targetElement, targetPlatform, targetUserAgent) {
  var _this = this;

  this.stop();

  if (!targetWindow) {
    if (!global.addEventListener && !global.attachEvent) {
      throw new Error('Cannot find global functions addEventListener or attachEvent.');
    }
    targetWindow = global;
  }

  if (typeof targetWindow.nodeType === 'number') {
    targetUserAgent = targetPlatform;
    targetPlatform  = targetElement;
    targetElement   = targetWindow;
    targetWindow    = global;
  }

  if (!targetWindow.addEventListener && !targetWindow.attachEvent) {
    throw new Error('Cannot find addEventListener or attachEvent methods on targetWindow.');
  }

  this._isModernBrowser = !!targetWindow.addEventListener;

  var userAgent = targetWindow.navigator && targetWindow.navigator.userAgent || '';
  var platform  = targetWindow.navigator && targetWindow.navigator.platform  || '';

  targetElement   && targetElement   !== null || (targetElement   = targetWindow.document);
  targetPlatform  && targetPlatform  !== null || (targetPlatform  = platform);
  targetUserAgent && targetUserAgent !== null || (targetUserAgent = userAgent);

  this._targetKeyDownBinding = function(event) {
    _this.pressKey(event.keyCode, event);
  };
  this._targetKeyUpBinding = function(event) {
    _this.releaseKey(event.keyCode, event);
  };
  this._targetResetBinding = function(event) {
    _this.releaseAllKeys(event)
  };

  this._bindEvent(targetElement, 'keydown', this._targetKeyDownBinding);
  this._bindEvent(targetElement, 'keyup',   this._targetKeyUpBinding);
  this._bindEvent(targetWindow,  'focus',   this._targetResetBinding);
  this._bindEvent(targetWindow,  'blur',    this._targetResetBinding);

  this._targetElement   = targetElement;
  this._targetWindow    = targetWindow;
  this._targetPlatform  = targetPlatform;
  this._targetUserAgent = targetUserAgent;
};

Keyboard.prototype.stop = function() {
  var _this = this;

  if (!this._targetElement || !this._targetWindow) { return; }

  this._unbindEvent(this._targetElement, 'keydown', this._targetKeyDownBinding);
  this._unbindEvent(this._targetElement, 'keyup',   this._targetKeyUpBinding);
  this._unbindEvent(this._targetWindow,  'focus',   this._targetResetBinding);
  this._unbindEvent(this._targetWindow,  'blur',    this._targetResetBinding);

  this._targetWindow  = null;
  this._targetElement = null;
};

Keyboard.prototype.pressKey = function(keyCode, event) {
  if (this._paused) { return; }
  if (!this._locale) { throw new Error('Locale not set'); }

  this._locale.pressKey(keyCode);
  this._applyBindings(event);
};

Keyboard.prototype.releaseKey = function(keyCode, event) {
  if (this._paused) { return; }
  if (!this._locale) { throw new Error('Locale not set'); }

  this._locale.releaseKey(keyCode);
  this._clearBindings(event);
};

Keyboard.prototype.releaseAllKeys = function(event) {
  if (this._paused) { return; }
  if (!this._locale) { throw new Error('Locale not set'); }

  this._locale.pressedKeys.length = 0;
  this._clearBindings(event);
};

Keyboard.prototype.pause = function() {
  if (this._paused) { return; }
  if (this._locale) { this.releaseAllKeys(); }
  this._paused = true;
};

Keyboard.prototype.resume = function() {
  this._paused = false;
};

Keyboard.prototype.reset = function() {
  this.releaseAllKeys();
  this._listeners.length = 0;
};

Keyboard.prototype._bindEvent = function(targetElement, eventName, handler) {
  return this._isModernBrowser ?
    targetElement.addEventListener(eventName, handler, false) :
    targetElement.attachEvent('on' + eventName, handler);
};

Keyboard.prototype._unbindEvent = function(targetElement, eventName, handler) {
  return this._isModernBrowser ?
    targetElement.removeEventListener(eventName, handler, false) :
    targetElement.detachEvent('on' + eventName, handler);
};

Keyboard.prototype._getGroupedListeners = function() {
  var listenerGroups   = [];
  var listenerGroupMap = [];

  var listeners = this._listeners;
  if (this._currentContext !== 'global') {
    listeners = [].concat(listeners, this._contexts.global);
  }

  listeners.sort(function(a, b) {
    return (b.keyCombo ? b.keyCombo.keyNames.length : 0) - (a.keyCombo ? a.keyCombo.keyNames.length : 0);
  }).forEach(function(l) {
    var mapIndex = -1;
    for (var i = 0; i < listenerGroupMap.length; i += 1) {
      if (listenerGroupMap[i] === null && l.keyCombo === null ||
          listenerGroupMap[i] !== null && listenerGroupMap[i].isEqual(l.keyCombo)) {
        mapIndex = i;
      }
    }
    if (mapIndex === -1) {
      mapIndex = listenerGroupMap.length;
      listenerGroupMap.push(l.keyCombo);
    }
    if (!listenerGroups[mapIndex]) {
      listenerGroups[mapIndex] = [];
    }
    listenerGroups[mapIndex].push(l);
  });
  return listenerGroups;
};

Keyboard.prototype._applyBindings = function(event) {
  var preventRepeat = false;

  event || (event = {});
  event.preventRepeat = function() { preventRepeat = true; };
  event.pressedKeys   = this._locale.pressedKeys.slice(0);

  var pressedKeys    = this._locale.pressedKeys.slice(0);
  var listenerGroups = this._getGroupedListeners();


  for (var i = 0; i < listenerGroups.length; i += 1) {
    var listeners = listenerGroups[i];
    var keyCombo  = listeners[0].keyCombo;

    if (keyCombo === null || keyCombo.check(pressedKeys)) {
      for (var j = 0; j < listeners.length; j += 1) {
        var listener = listeners[j];

        if (keyCombo === null) {
          listener = {
            keyCombo               : new KeyCombo(pressedKeys.join('+')),
            pressHandler           : listener.pressHandler,
            releaseHandler         : listener.releaseHandler,
            preventRepeat          : listener.preventRepeat,
            preventRepeatByDefault : listener.preventRepeatByDefault
          };
        }

        if (listener.pressHandler && !listener.preventRepeat) {
          listener.pressHandler.call(this, event);
          if (preventRepeat) {
            listener.preventRepeat = preventRepeat;
            preventRepeat          = false;
          }
        }

        if (listener.releaseHandler && this._appliedListeners.indexOf(listener) === -1) {
          this._appliedListeners.push(listener);
        }
      }

      if (keyCombo) {
        for (var j = 0; j < keyCombo.keyNames.length; j += 1) {
          var index = pressedKeys.indexOf(keyCombo.keyNames[j]);
          if (index !== -1) {
            pressedKeys.splice(index, 1);
            j -= 1;
          }
        }
      }
    }
  }
};

Keyboard.prototype._clearBindings = function(event) {
  event || (event = {});

  for (var i = 0; i < this._appliedListeners.length; i += 1) {
    var listener = this._appliedListeners[i];
    var keyCombo = listener.keyCombo;
    if (keyCombo === null || !keyCombo.check(this._locale.pressedKeys)) {
      listener.preventRepeat = listener.preventRepeatByDefault;
      listener.releaseHandler.call(this, event);
      this._appliedListeners.splice(i, 1);
      i -= 1;
    }
  }
};

module.exports = Keyboard;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 1169 */
/***/ (function(module, exports) {


module.exports = function(locale, platform, userAgent) {

  // general
  locale.bindKeyCode(3,   ['cancel']);
  locale.bindKeyCode(8,   ['backspace']);
  locale.bindKeyCode(9,   ['tab']);
  locale.bindKeyCode(12,  ['clear']);
  locale.bindKeyCode(13,  ['enter']);
  locale.bindKeyCode(16,  ['shift']);
  locale.bindKeyCode(17,  ['ctrl']);
  locale.bindKeyCode(18,  ['alt', 'menu']);
  locale.bindKeyCode(19,  ['pause', 'break']);
  locale.bindKeyCode(20,  ['capslock']);
  locale.bindKeyCode(27,  ['escape', 'esc']);
  locale.bindKeyCode(32,  ['space', 'spacebar']);
  locale.bindKeyCode(33,  ['pageup']);
  locale.bindKeyCode(34,  ['pagedown']);
  locale.bindKeyCode(35,  ['end']);
  locale.bindKeyCode(36,  ['home']);
  locale.bindKeyCode(37,  ['left']);
  locale.bindKeyCode(38,  ['up']);
  locale.bindKeyCode(39,  ['right']);
  locale.bindKeyCode(40,  ['down']);
  locale.bindKeyCode(41,  ['select']);
  locale.bindKeyCode(42,  ['printscreen']);
  locale.bindKeyCode(43,  ['execute']);
  locale.bindKeyCode(44,  ['snapshot']);
  locale.bindKeyCode(45,  ['insert', 'ins']);
  locale.bindKeyCode(46,  ['delete', 'del']);
  locale.bindKeyCode(47,  ['help']);
  locale.bindKeyCode(145, ['scrolllock', 'scroll']);
  locale.bindKeyCode(187, ['equal', 'equalsign', '=']);
  locale.bindKeyCode(188, ['comma', ',']);
  locale.bindKeyCode(190, ['period', '.']);
  locale.bindKeyCode(191, ['slash', 'forwardslash', '/']);
  locale.bindKeyCode(192, ['graveaccent', '`']);
  locale.bindKeyCode(219, ['openbracket', '[']);
  locale.bindKeyCode(220, ['backslash', '\\']);
  locale.bindKeyCode(221, ['closebracket', ']']);
  locale.bindKeyCode(222, ['apostrophe', '\'']);

  // 0-9
  locale.bindKeyCode(48, ['zero', '0']);
  locale.bindKeyCode(49, ['one', '1']);
  locale.bindKeyCode(50, ['two', '2']);
  locale.bindKeyCode(51, ['three', '3']);
  locale.bindKeyCode(52, ['four', '4']);
  locale.bindKeyCode(53, ['five', '5']);
  locale.bindKeyCode(54, ['six', '6']);
  locale.bindKeyCode(55, ['seven', '7']);
  locale.bindKeyCode(56, ['eight', '8']);
  locale.bindKeyCode(57, ['nine', '9']);

  // numpad
  locale.bindKeyCode(96, ['numzero', 'num0']);
  locale.bindKeyCode(97, ['numone', 'num1']);
  locale.bindKeyCode(98, ['numtwo', 'num2']);
  locale.bindKeyCode(99, ['numthree', 'num3']);
  locale.bindKeyCode(100, ['numfour', 'num4']);
  locale.bindKeyCode(101, ['numfive', 'num5']);
  locale.bindKeyCode(102, ['numsix', 'num6']);
  locale.bindKeyCode(103, ['numseven', 'num7']);
  locale.bindKeyCode(104, ['numeight', 'num8']);
  locale.bindKeyCode(105, ['numnine', 'num9']);
  locale.bindKeyCode(106, ['nummultiply', 'num*']);
  locale.bindKeyCode(107, ['numadd', 'num+']);
  locale.bindKeyCode(108, ['numenter']);
  locale.bindKeyCode(109, ['numsubtract', 'num-']);
  locale.bindKeyCode(110, ['numdecimal', 'num.']);
  locale.bindKeyCode(111, ['numdivide', 'num/']);
  locale.bindKeyCode(144, ['numlock', 'num']);

  // function keys
  locale.bindKeyCode(112, ['f1']);
  locale.bindKeyCode(113, ['f2']);
  locale.bindKeyCode(114, ['f3']);
  locale.bindKeyCode(115, ['f4']);
  locale.bindKeyCode(116, ['f5']);
  locale.bindKeyCode(117, ['f6']);
  locale.bindKeyCode(118, ['f7']);
  locale.bindKeyCode(119, ['f8']);
  locale.bindKeyCode(120, ['f9']);
  locale.bindKeyCode(121, ['f10']);
  locale.bindKeyCode(122, ['f11']);
  locale.bindKeyCode(123, ['f12']);

  // secondary key symbols
  locale.bindMacro('shift + `', ['tilde', '~']);
  locale.bindMacro('shift + 1', ['exclamation', 'exclamationpoint', '!']);
  locale.bindMacro('shift + 2', ['at', '@']);
  locale.bindMacro('shift + 3', ['number', '#']);
  locale.bindMacro('shift + 4', ['dollar', 'dollars', 'dollarsign', '$']);
  locale.bindMacro('shift + 5', ['percent', '%']);
  locale.bindMacro('shift + 6', ['caret', '^']);
  locale.bindMacro('shift + 7', ['ampersand', 'and', '&']);
  locale.bindMacro('shift + 8', ['asterisk', '*']);
  locale.bindMacro('shift + 9', ['openparen', '(']);
  locale.bindMacro('shift + 0', ['closeparen', ')']);
  locale.bindMacro('shift + -', ['underscore', '_']);
  locale.bindMacro('shift + =', ['plus', '+']);
  locale.bindMacro('shift + [', ['opencurlybrace', 'opencurlybracket', '{']);
  locale.bindMacro('shift + ]', ['closecurlybrace', 'closecurlybracket', '}']);
  locale.bindMacro('shift + \\', ['verticalbar', '|']);
  locale.bindMacro('shift + ;', ['colon', ':']);
  locale.bindMacro('shift + \'', ['quotationmark', '\'']);
  locale.bindMacro('shift + !,', ['openanglebracket', '<']);
  locale.bindMacro('shift + .', ['closeanglebracket', '>']);
  locale.bindMacro('shift + /', ['questionmark', '?']);

  //a-z and A-Z
  for (var keyCode = 65; keyCode <= 90; keyCode += 1) {
    var keyName = String.fromCharCode(keyCode + 32);
    var capitalKeyName = String.fromCharCode(keyCode);
  	locale.bindKeyCode(keyCode, keyName);
  	locale.bindMacro('shift + ' + keyName, capitalKeyName);
  	locale.bindMacro('capslock + ' + keyName, capitalKeyName);
  }

  // browser caveats
  var semicolonKeyCode = userAgent.match('Firefox') ? 59  : 186;
  var dashKeyCode      = userAgent.match('Firefox') ? 173 : 189;
  var leftCommandKeyCode;
  var rightCommandKeyCode;
  if (platform.match('Mac') && (userAgent.match('Safari') || userAgent.match('Chrome'))) {
    leftCommandKeyCode  = 91;
    rightCommandKeyCode = 93;
  } else if(platform.match('Mac') && userAgent.match('Opera')) {
    leftCommandKeyCode  = 17;
    rightCommandKeyCode = 17;
  } else if(platform.match('Mac') && userAgent.match('Firefox')) {
    leftCommandKeyCode  = 224;
    rightCommandKeyCode = 224;
  }
  locale.bindKeyCode(semicolonKeyCode,    ['semicolon', ';']);
  locale.bindKeyCode(dashKeyCode,         ['dash', '-']);
  locale.bindKeyCode(leftCommandKeyCode,  ['command', 'windows', 'win', 'super', 'leftcommand', 'leftwindows', 'leftwin', 'leftsuper']);
  locale.bindKeyCode(rightCommandKeyCode, ['command', 'windows', 'win', 'super', 'rightcommand', 'rightwindows', 'rightwin', 'rightsuper']);

  // kill keys
  locale.setKillKey('command');
};


/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ms = {};

function getItem (key) {
  return key in ms ? ms[key] : null;
}

function setItem (key, value) {
  ms[key] = value;
  return true;
}

function removeItem (key) {
  var found = key in ms;
  if (found) {
    return delete ms[key];
  }
  return false;
}

function clear () {
  ms = {};
  return true;
}

module.exports = {
  getItem: getItem,
  setItem: setItem,
  removeItem: removeItem,
  clear: clear
};


/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var listeners = {};
var listening = false;

function listen () {
  if (global.addEventListener) {
    global.addEventListener('storage', change, false);
  } else if (global.attachEvent) {
    global.attachEvent('onstorage', change);
  } else {
    global.onstorage = change;
  }
}

function change (e) {
  if (!e) {
    e = global.event;
  }
  var all = listeners[e.key];
  if (all) {
    all.forEach(fire);
  }

  function fire (listener) {
    listener(JSON.parse(e.newValue), JSON.parse(e.oldValue), e.url || e.uri);
  }
}

function on (key, fn) {
  if (listeners[key]) {
    listeners[key].push(fn);
  } else {
    listeners[key] = [fn];
  }
  if (listening === false) {
    listen();
  }
}

function off (key, fn) {
  var ns = listeners[key];
  if (ns.length > 1) {
    ns.splice(ns.indexOf(fn), 1);
  } else {
    listeners[key] = [];
  }
}

module.exports = {
  on: on,
  off: off
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 1172 */
/***/ (function(module, exports) {

/**
 * @name MarkerClustererPlus for Google Maps V3
 * @version 2.1.2 [May 28, 2014]
 * @author Gary Little
 * @fileoverview
 * The library creates and manages per-zoom-level clusters for large amounts of markers.
 * <p>
 * This is an enhanced V3 implementation of the
 * <a href="http://gmaps-utility-library-dev.googlecode.com/svn/tags/markerclusterer/"
 * >V2 MarkerClusterer</a> by Xiaoxi Wu. It is based on the
 * <a href="http://google-maps-utility-library-v3.googlecode.com/svn/tags/markerclusterer/"
 * >V3 MarkerClusterer</a> port by Luke Mahe. MarkerClustererPlus was created by Gary Little.
 * <p>
 * v2.0 release: MarkerClustererPlus v2.0 is backward compatible with MarkerClusterer v1.0. It
 *  adds support for the <code>ignoreHidden</code>, <code>title</code>, <code>batchSizeIE</code>,
 *  and <code>calculator</code> properties as well as support for four more events. It also allows
 *  greater control over the styling of the text that appears on the cluster marker. The
 *  documentation has been significantly improved and the overall code has been simplified and
 *  polished. Very large numbers of markers can now be managed without causing Javascript timeout
 *  errors on Internet Explorer. Note that the name of the <code>clusterclick</code> event has been
 *  deprecated. The new name is <code>click</code>, so please change your application code now.
 */

/**
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/**
 * @name ClusterIconStyle
 * @class This class represents the object for values in the <code>styles</code> array passed
 *  to the {@link MarkerClusterer} constructor. The element in this array that is used to
 *  style the cluster icon is determined by calling the <code>calculator</code> function.
 *
 * @property {string} url The URL of the cluster icon image file. Required.
 * @property {number} height The display height (in pixels) of the cluster icon. Required.
 * @property {number} width The display width (in pixels) of the cluster icon. Required.
 * @property {Array} [anchorText] The position (in pixels) from the center of the cluster icon to
 *  where the text label is to be centered and drawn. The format is <code>[yoffset, xoffset]</code>
 *  where <code>yoffset</code> increases as you go down from center and <code>xoffset</code>
 *  increases to the right of center. The default is <code>[0, 0]</code>.
 * @property {Array} [anchorIcon] The anchor position (in pixels) of the cluster icon. This is the
 *  spot on the cluster icon that is to be aligned with the cluster position. The format is
 *  <code>[yoffset, xoffset]</code> where <code>yoffset</code> increases as you go down and
 *  <code>xoffset</code> increases to the right of the top-left corner of the icon. The default
 *  anchor position is the center of the cluster icon.
 * @property {string} [textColor="black"] The color of the label text shown on the
 *  cluster icon.
 * @property {number} [textSize=11] The size (in pixels) of the label text shown on the
 *  cluster icon.
 * @property {string} [textDecoration="none"] The value of the CSS <code>text-decoration</code>
 *  property for the label text shown on the cluster icon.
 * @property {string} [fontWeight="bold"] The value of the CSS <code>font-weight</code>
 *  property for the label text shown on the cluster icon.
 * @property {string} [fontStyle="normal"] The value of the CSS <code>font-style</code>
 *  property for the label text shown on the cluster icon.
 * @property {string} [fontFamily="Arial,sans-serif"] The value of the CSS <code>font-family</code>
 *  property for the label text shown on the cluster icon.
 * @property {string} [backgroundPosition="0 0"] The position of the cluster icon image
 *  within the image defined by <code>url</code>. The format is <code>"xpos ypos"</code>
 *  (the same format as for the CSS <code>background-position</code> property). You must set
 *  this property appropriately when the image defined by <code>url</code> represents a sprite
 *  containing multiple images. Note that the position <i>must</i> be specified in px units.
 */
/**
 * @name ClusterIconInfo
 * @class This class is an object containing general information about a cluster icon. This is
 *  the object that a <code>calculator</code> function returns.
 *
 * @property {string} text The text of the label to be shown on the cluster icon.
 * @property {number} index The index plus 1 of the element in the <code>styles</code>
 *  array to be used to style the cluster icon.
 * @property {string} title The tooltip to display when the mouse moves over the cluster icon.
 *  If this value is <code>undefined</code> or <code>""</code>, <code>title</code> is set to the
 *  value of the <code>title</code> property passed to the MarkerClusterer.
 */
/**
 * A cluster icon.
 *
 * @constructor
 * @extends google.maps.OverlayView
 * @param {Cluster} cluster The cluster with which the icon is to be associated.
 * @param {Array} [styles] An array of {@link ClusterIconStyle} defining the cluster icons
 *  to use for various cluster sizes.
 * @private
 */
function ClusterIcon(cluster, styles) {
  cluster.getMarkerClusterer().extend(ClusterIcon, google.maps.OverlayView);

  this.cluster_ = cluster;
  this.className_ = cluster.getMarkerClusterer().getClusterClass();
  this.styles_ = styles;
  this.center_ = null;
  this.div_ = null;
  this.sums_ = null;
  this.visible_ = false;

  this.setMap(cluster.getMap()); // Note: this causes onAdd to be called
}


/**
 * Adds the icon to the DOM.
 */
ClusterIcon.prototype.onAdd = function () {
  var cClusterIcon = this;
  var cMouseDownInCluster;
  var cDraggingMapByCluster;

  this.div_ = document.createElement("div");
  this.div_.className = this.className_;
  if (this.visible_) {
    this.show();
  }

  this.getPanes().overlayMouseTarget.appendChild(this.div_);

  // Fix for Issue 157
  this.boundsChangedListener_ = google.maps.event.addListener(this.getMap(), "bounds_changed", function () {
    cDraggingMapByCluster = cMouseDownInCluster;
  });

  google.maps.event.addDomListener(this.div_, "mousedown", function () {
    cMouseDownInCluster = true;
    cDraggingMapByCluster = false;
  });

  google.maps.event.addDomListener(this.div_, "click", function (e) {
    cMouseDownInCluster = false;
    if (!cDraggingMapByCluster) {
      var theBounds;
      var mz;
      var mc = cClusterIcon.cluster_.getMarkerClusterer();
      /**
       * This event is fired when a cluster marker is clicked.
       * @name MarkerClusterer#click
       * @param {Cluster} c The cluster that was clicked.
       * @event
       */
      google.maps.event.trigger(mc, "click", cClusterIcon.cluster_);
      google.maps.event.trigger(mc, "clusterclick", cClusterIcon.cluster_); // deprecated name

      // The default click handler follows. Disable it by setting
      // the zoomOnClick property to false.
      if (mc.getZoomOnClick()) {
        // Zoom into the cluster.
        mz = mc.getMaxZoom();
        theBounds = cClusterIcon.cluster_.getBounds();
        mc.getMap().fitBounds(theBounds);
        // There is a fix for Issue 170 here:
        setTimeout(function () {
          mc.getMap().fitBounds(theBounds);
          // Don't zoom beyond the max zoom level
          if (mz !== null && (mc.getMap().getZoom() > mz)) {
            mc.getMap().setZoom(mz + 1);
          }
        }, 100);
      }

      // Prevent event propagation to the map:
      e.cancelBubble = true;
      if (e.stopPropagation) {
        e.stopPropagation();
      }
    }
  });

  google.maps.event.addDomListener(this.div_, "mouseover", function () {
    var mc = cClusterIcon.cluster_.getMarkerClusterer();
    /**
     * This event is fired when the mouse moves over a cluster marker.
     * @name MarkerClusterer#mouseover
     * @param {Cluster} c The cluster that the mouse moved over.
     * @event
     */
    google.maps.event.trigger(mc, "mouseover", cClusterIcon.cluster_);
  });

  google.maps.event.addDomListener(this.div_, "mouseout", function () {
    var mc = cClusterIcon.cluster_.getMarkerClusterer();
    /**
     * This event is fired when the mouse moves out of a cluster marker.
     * @name MarkerClusterer#mouseout
     * @param {Cluster} c The cluster that the mouse moved out of.
     * @event
     */
    google.maps.event.trigger(mc, "mouseout", cClusterIcon.cluster_);
  });
};


/**
 * Removes the icon from the DOM.
 */
ClusterIcon.prototype.onRemove = function () {
  if (this.div_ && this.div_.parentNode) {
    this.hide();
    google.maps.event.removeListener(this.boundsChangedListener_);
    google.maps.event.clearInstanceListeners(this.div_);
    this.div_.parentNode.removeChild(this.div_);
    this.div_ = null;
  }
};


/**
 * Draws the icon.
 */
ClusterIcon.prototype.draw = function () {
  if (this.visible_) {
    var pos = this.getPosFromLatLng_(this.center_);
    this.div_.style.top = pos.y + "px";
    this.div_.style.left = pos.x + "px";
  }
};


/**
 * Hides the icon.
 */
ClusterIcon.prototype.hide = function () {
  if (this.div_) {
    this.div_.style.display = "none";
  }
  this.visible_ = false;
};


/**
 * Positions and shows the icon.
 */
ClusterIcon.prototype.show = function () {
  if (this.div_) {
    var img = "";
    // NOTE: values must be specified in px units
    var bp = this.backgroundPosition_.split(" ");
    var spriteH = parseInt(bp[0].replace(/^\s+|\s+$/g, ""), 10);
    var spriteV = parseInt(bp[1].replace(/^\s+|\s+$/g, ""), 10);
    var pos = this.getPosFromLatLng_(this.center_);
    this.div_.style.cssText = this.createCss(pos);
    img = "<img src='" + this.url_ + "' style='position: absolute; top: " + spriteV + "px; left: " + spriteH + "px; ";
    if (!this.cluster_.getMarkerClusterer().enableRetinaIcons_) {
      img += "clip: rect(" + (-1 * spriteV) + "px, " + ((-1 * spriteH) + this.width_) + "px, " +
          ((-1 * spriteV) + this.height_) + "px, " + (-1 * spriteH) + "px);";
    }
    img += "'>";
    this.div_.innerHTML = img + "<div style='" +
        "position: absolute;" +
        "top: " + this.anchorText_[0] + "px;" +
        "left: " + this.anchorText_[1] + "px;" +
        "color: " + this.textColor_ + ";" +
        "font-size: " + this.textSize_ + "px;" +
        "font-family: " + this.fontFamily_ + ";" +
        "font-weight: " + this.fontWeight_ + ";" +
        "font-style: " + this.fontStyle_ + ";" +
        "text-decoration: " + this.textDecoration_ + ";" +
        "text-align: center;" +
        "width: " + this.width_ + "px;" +
        "line-height:" + this.height_ + "px;" +
        "'>" + this.sums_.text + "</div>";
    if (typeof this.sums_.title === "undefined" || this.sums_.title === "") {
      this.div_.title = this.cluster_.getMarkerClusterer().getTitle();
    } else {
      this.div_.title = this.sums_.title;
    }
    this.div_.style.display = "";
  }
  this.visible_ = true;
};


/**
 * Sets the icon styles to the appropriate element in the styles array.
 *
 * @param {ClusterIconInfo} sums The icon label text and styles index.
 */
ClusterIcon.prototype.useStyle = function (sums) {
  this.sums_ = sums;
  var index = Math.max(0, sums.index - 1);
  index = Math.min(this.styles_.length - 1, index);
  var style = this.styles_[index];
  this.url_ = style.url;
  this.height_ = style.height;
  this.width_ = style.width;
  this.anchorText_ = style.anchorText || [0, 0];
  this.anchorIcon_ = style.anchorIcon || [parseInt(this.height_ / 2, 10), parseInt(this.width_ / 2, 10)];
  this.textColor_ = style.textColor || "black";
  this.textSize_ = style.textSize || 11;
  this.textDecoration_ = style.textDecoration || "none";
  this.fontWeight_ = style.fontWeight || "bold";
  this.fontStyle_ = style.fontStyle || "normal";
  this.fontFamily_ = style.fontFamily || "Arial,sans-serif";
  this.backgroundPosition_ = style.backgroundPosition || "0 0";
};


/**
 * Sets the position at which to center the icon.
 *
 * @param {google.maps.LatLng} center The latlng to set as the center.
 */
ClusterIcon.prototype.setCenter = function (center) {
  this.center_ = center;
};


/**
 * Creates the cssText style parameter based on the position of the icon.
 *
 * @param {google.maps.Point} pos The position of the icon.
 * @return {string} The CSS style text.
 */
ClusterIcon.prototype.createCss = function (pos) {
  var style = [];
  style.push("cursor: pointer;");
  style.push("position: absolute; top: " + pos.y + "px; left: " + pos.x + "px;");
  style.push("width: " + this.width_ + "px; height: " + this.height_ + "px;");
  return style.join("");
};


/**
 * Returns the position at which to place the DIV depending on the latlng.
 *
 * @param {google.maps.LatLng} latlng The position in latlng.
 * @return {google.maps.Point} The position in pixels.
 */
ClusterIcon.prototype.getPosFromLatLng_ = function (latlng) {
  var pos = this.getProjection().fromLatLngToDivPixel(latlng);
  pos.x -= this.anchorIcon_[1];
  pos.y -= this.anchorIcon_[0];
  pos.x = parseInt(pos.x, 10);
  pos.y = parseInt(pos.y, 10);
  return pos;
};


/**
 * Creates a single cluster that manages a group of proximate markers.
 *  Used internally, do not call this constructor directly.
 * @constructor
 * @param {MarkerClusterer} mc The <code>MarkerClusterer</code> object with which this
 *  cluster is associated.
 */
function Cluster(mc) {
  this.markerClusterer_ = mc;
  this.map_ = mc.getMap();
  this.gridSize_ = mc.getGridSize();
  this.minClusterSize_ = mc.getMinimumClusterSize();
  this.averageCenter_ = mc.getAverageCenter();
  this.markers_ = [];
  this.center_ = null;
  this.bounds_ = null;
  this.clusterIcon_ = new ClusterIcon(this, mc.getStyles());
}


/**
 * Returns the number of markers managed by the cluster. You can call this from
 * a <code>click</code>, <code>mouseover</code>, or <code>mouseout</code> event handler
 * for the <code>MarkerClusterer</code> object.
 *
 * @return {number} The number of markers in the cluster.
 */
Cluster.prototype.getSize = function () {
  return this.markers_.length;
};


/**
 * Returns the array of markers managed by the cluster. You can call this from
 * a <code>click</code>, <code>mouseover</code>, or <code>mouseout</code> event handler
 * for the <code>MarkerClusterer</code> object.
 *
 * @return {Array} The array of markers in the cluster.
 */
Cluster.prototype.getMarkers = function () {
  return this.markers_;
};


/**
 * Returns the center of the cluster. You can call this from
 * a <code>click</code>, <code>mouseover</code>, or <code>mouseout</code> event handler
 * for the <code>MarkerClusterer</code> object.
 *
 * @return {google.maps.LatLng} The center of the cluster.
 */
Cluster.prototype.getCenter = function () {
  return this.center_;
};


/**
 * Returns the map with which the cluster is associated.
 *
 * @return {google.maps.Map} The map.
 * @ignore
 */
Cluster.prototype.getMap = function () {
  return this.map_;
};


/**
 * Returns the <code>MarkerClusterer</code> object with which the cluster is associated.
 *
 * @return {MarkerClusterer} The associated marker clusterer.
 * @ignore
 */
Cluster.prototype.getMarkerClusterer = function () {
  return this.markerClusterer_;
};


/**
 * Returns the bounds of the cluster.
 *
 * @return {google.maps.LatLngBounds} the cluster bounds.
 * @ignore
 */
Cluster.prototype.getBounds = function () {
  var i;
  var bounds = new google.maps.LatLngBounds(this.center_, this.center_);
  var markers = this.getMarkers();
  for (i = 0; i < markers.length; i++) {
    bounds.extend(markers[i].getPosition());
  }
  return bounds;
};


/**
 * Removes the cluster from the map.
 *
 * @ignore
 */
Cluster.prototype.remove = function () {
  this.clusterIcon_.setMap(null);
  this.markers_ = [];
  delete this.markers_;
};


/**
 * Adds a marker to the cluster.
 *
 * @param {google.maps.Marker} marker The marker to be added.
 * @return {boolean} True if the marker was added.
 * @ignore
 */
Cluster.prototype.addMarker = function (marker) {
  var i;
  var mCount;
  var mz;

  if (this.isMarkerAlreadyAdded_(marker)) {
    return false;
  }

  if (!this.center_) {
    this.center_ = marker.getPosition();
    this.calculateBounds_();
  } else {
    if (this.averageCenter_) {
      var l = this.markers_.length + 1;
      var lat = (this.center_.lat() * (l - 1) + marker.getPosition().lat()) / l;
      var lng = (this.center_.lng() * (l - 1) + marker.getPosition().lng()) / l;
      this.center_ = new google.maps.LatLng(lat, lng);
      this.calculateBounds_();
    }
  }

  marker.isAdded = true;
  this.markers_.push(marker);

  mCount = this.markers_.length;
  mz = this.markerClusterer_.getMaxZoom();
  if (mz !== null && this.map_.getZoom() > mz) {
    // Zoomed in past max zoom, so show the marker.
    if (marker.getMap() !== this.map_) {
      marker.setMap(this.map_);
    }
  } else if (mCount < this.minClusterSize_) {
    // Min cluster size not reached so show the marker.
    if (marker.getMap() !== this.map_) {
      marker.setMap(this.map_);
    }
  } else if (mCount === this.minClusterSize_) {
    // Hide the markers that were showing.
    for (i = 0; i < mCount; i++) {
      this.markers_[i].setMap(null);
    }
  } else {
    marker.setMap(null);
  }

  this.updateIcon_();
  return true;
};


/**
 * Determines if a marker lies within the cluster's bounds.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @return {boolean} True if the marker lies in the bounds.
 * @ignore
 */
Cluster.prototype.isMarkerInClusterBounds = function (marker) {
  return this.bounds_.contains(marker.getPosition());
};


/**
 * Calculates the extended bounds of the cluster with the grid.
 */
Cluster.prototype.calculateBounds_ = function () {
  var bounds = new google.maps.LatLngBounds(this.center_, this.center_);
  this.bounds_ = this.markerClusterer_.getExtendedBounds(bounds);
};


/**
 * Updates the cluster icon.
 */
Cluster.prototype.updateIcon_ = function () {
  var mCount = this.markers_.length;
  var mz = this.markerClusterer_.getMaxZoom();

  if (mz !== null && this.map_.getZoom() > mz) {
    this.clusterIcon_.hide();
    return;
  }

  if (mCount < this.minClusterSize_) {
    // Min cluster size not yet reached.
    this.clusterIcon_.hide();
    return;
  }

  var numStyles = this.markerClusterer_.getStyles().length;
  var sums = this.markerClusterer_.getCalculator()(this.markers_, numStyles);
  this.clusterIcon_.setCenter(this.center_);
  this.clusterIcon_.useStyle(sums);
  this.clusterIcon_.show();
};


/**
 * Determines if a marker has already been added to the cluster.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @return {boolean} True if the marker has already been added.
 */
Cluster.prototype.isMarkerAlreadyAdded_ = function (marker) {
  var i;
  if (this.markers_.indexOf) {
    return this.markers_.indexOf(marker) !== -1;
  } else {
    for (i = 0; i < this.markers_.length; i++) {
      if (marker === this.markers_[i]) {
        return true;
      }
    }
  }
  return false;
};


/**
 * @name MarkerClustererOptions
 * @class This class represents the optional parameter passed to
 *  the {@link MarkerClusterer} constructor.
 * @property {number} [gridSize=60] The grid size of a cluster in pixels. The grid is a square.
 * @property {number} [maxZoom=null] The maximum zoom level at which clustering is enabled or
 *  <code>null</code> if clustering is to be enabled at all zoom levels.
 * @property {boolean} [zoomOnClick=true] Whether to zoom the map when a cluster marker is
 *  clicked. You may want to set this to <code>false</code> if you have installed a handler
 *  for the <code>click</code> event and it deals with zooming on its own.
 * @property {boolean} [averageCenter=false] Whether the position of a cluster marker should be
 *  the average position of all markers in the cluster. If set to <code>false</code>, the
 *  cluster marker is positioned at the location of the first marker added to the cluster.
 * @property {number} [minimumClusterSize=2] The minimum number of markers needed in a cluster
 *  before the markers are hidden and a cluster marker appears.
 * @property {boolean} [ignoreHidden=false] Whether to ignore hidden markers in clusters. You
 *  may want to set this to <code>true</code> to ensure that hidden markers are not included
 *  in the marker count that appears on a cluster marker (this count is the value of the
 *  <code>text</code> property of the result returned by the default <code>calculator</code>).
 *  If set to <code>true</code> and you change the visibility of a marker being clustered, be
 *  sure to also call <code>MarkerClusterer.repaint()</code>.
 * @property {string} [title=""] The tooltip to display when the mouse moves over a cluster
 *  marker. (Alternatively, you can use a custom <code>calculator</code> function to specify a
 *  different tooltip for each cluster marker.)
 * @property {function} [calculator=MarkerClusterer.CALCULATOR] The function used to determine
 *  the text to be displayed on a cluster marker and the index indicating which style to use
 *  for the cluster marker. The input parameters for the function are (1) the array of markers
 *  represented by a cluster marker and (2) the number of cluster icon styles. It returns a
 *  {@link ClusterIconInfo} object. The default <code>calculator</code> returns a
 *  <code>text</code> property which is the number of markers in the cluster and an
 *  <code>index</code> property which is one higher than the lowest integer such that
 *  <code>10^i</code> exceeds the number of markers in the cluster, or the size of the styles
 *  array, whichever is less. The <code>styles</code> array element used has an index of
 *  <code>index</code> minus 1. For example, the default <code>calculator</code> returns a
 *  <code>text</code> value of <code>"125"</code> and an <code>index</code> of <code>3</code>
 *  for a cluster icon representing 125 markers so the element used in the <code>styles</code>
 *  array is <code>2</code>. A <code>calculator</code> may also return a <code>title</code>
 *  property that contains the text of the tooltip to be used for the cluster marker. If
 *   <code>title</code> is not defined, the tooltip is set to the value of the <code>title</code>
 *   property for the MarkerClusterer.
 * @property {string} [clusterClass="cluster"] The name of the CSS class defining general styles
 *  for the cluster markers. Use this class to define CSS styles that are not set up by the code
 *  that processes the <code>styles</code> array.
 * @property {Array} [styles] An array of {@link ClusterIconStyle} elements defining the styles
 *  of the cluster markers to be used. The element to be used to style a given cluster marker
 *  is determined by the function defined by the <code>calculator</code> property.
 *  The default is an array of {@link ClusterIconStyle} elements whose properties are derived
 *  from the values for <code>imagePath</code>, <code>imageExtension</code>, and
 *  <code>imageSizes</code>.
 * @property {boolean} [enableRetinaIcons=false] Whether to allow the use of cluster icons that
 * have sizes that are some multiple (typically double) of their actual display size. Icons such
 * as these look better when viewed on high-resolution monitors such as Apple's Retina displays.
 * Note: if this property is <code>true</code>, sprites cannot be used as cluster icons.
 * @property {number} [batchSize=MarkerClusterer.BATCH_SIZE] Set this property to the
 *  number of markers to be processed in a single batch when using a browser other than
 *  Internet Explorer (for Internet Explorer, use the batchSizeIE property instead).
 * @property {number} [batchSizeIE=MarkerClusterer.BATCH_SIZE_IE] When Internet Explorer is
 *  being used, markers are processed in several batches with a small delay inserted between
 *  each batch in an attempt to avoid Javascript timeout errors. Set this property to the
 *  number of markers to be processed in a single batch; select as high a number as you can
 *  without causing a timeout error in the browser. This number might need to be as low as 100
 *  if 15,000 markers are being managed, for example.
 * @property {string} [imagePath=MarkerClusterer.IMAGE_PATH]
 *  The full URL of the root name of the group of image files to use for cluster icons.
 *  The complete file name is of the form <code>imagePath</code>n.<code>imageExtension</code>
 *  where n is the image file number (1, 2, etc.).
 * @property {string} [imageExtension=MarkerClusterer.IMAGE_EXTENSION]
 *  The extension name for the cluster icon image files (e.g., <code>"png"</code> or
 *  <code>"jpg"</code>).
 * @property {Array} [imageSizes=MarkerClusterer.IMAGE_SIZES]
 *  An array of numbers containing the widths of the group of
 *  <code>imagePath</code>n.<code>imageExtension</code> image files.
 *  (The images are assumed to be square.)
 */
/**
 * Creates a MarkerClusterer object with the options specified in {@link MarkerClustererOptions}.
 * @constructor
 * @extends google.maps.OverlayView
 * @param {google.maps.Map} map The Google map to attach to.
 * @param {Array.<google.maps.Marker>} [opt_markers] The markers to be added to the cluster.
 * @param {MarkerClustererOptions} [opt_options] The optional parameters.
 */
function MarkerClusterer(map, opt_markers, opt_options) {
  // MarkerClusterer implements google.maps.OverlayView interface. We use the
  // extend function to extend MarkerClusterer with google.maps.OverlayView
  // because it might not always be available when the code is defined so we
  // look for it at the last possible moment. If it doesn't exist now then
  // there is no point going ahead :)
  this.extend(MarkerClusterer, google.maps.OverlayView);

  opt_markers = opt_markers || [];
  opt_options = opt_options || {};

  this.markers_ = [];
  this.clusters_ = [];
  this.listeners_ = [];
  this.activeMap_ = null;
  this.ready_ = false;

  this.gridSize_ = opt_options.gridSize || 60;
  this.minClusterSize_ = opt_options.minimumClusterSize || 2;
  this.maxZoom_ = opt_options.maxZoom || null;
  this.styles_ = opt_options.styles || [];
  this.title_ = opt_options.title || "";
  this.zoomOnClick_ = true;
  if (opt_options.zoomOnClick !== undefined) {
    this.zoomOnClick_ = opt_options.zoomOnClick;
  }
  this.averageCenter_ = false;
  if (opt_options.averageCenter !== undefined) {
    this.averageCenter_ = opt_options.averageCenter;
  }
  this.ignoreHidden_ = false;
  if (opt_options.ignoreHidden !== undefined) {
    this.ignoreHidden_ = opt_options.ignoreHidden;
  }
  this.enableRetinaIcons_ = false;
  if (opt_options.enableRetinaIcons !== undefined) {
    this.enableRetinaIcons_ = opt_options.enableRetinaIcons;
  }
  this.imagePath_ = opt_options.imagePath || MarkerClusterer.IMAGE_PATH;
  this.imageExtension_ = opt_options.imageExtension || MarkerClusterer.IMAGE_EXTENSION;
  this.imageSizes_ = opt_options.imageSizes || MarkerClusterer.IMAGE_SIZES;
  this.calculator_ = opt_options.calculator || MarkerClusterer.CALCULATOR;
  this.batchSize_ = opt_options.batchSize || MarkerClusterer.BATCH_SIZE;
  this.batchSizeIE_ = opt_options.batchSizeIE || MarkerClusterer.BATCH_SIZE_IE;
  this.clusterClass_ = opt_options.clusterClass || "cluster";

  if (navigator.userAgent.toLowerCase().indexOf("msie") !== -1) {
    // Try to avoid IE timeout when processing a huge number of markers:
    this.batchSize_ = this.batchSizeIE_;
  }

  this.setupStyles_();

  this.addMarkers(opt_markers, true);
  this.setMap(map); // Note: this causes onAdd to be called
}


/**
 * Implementation of the onAdd interface method.
 * @ignore
 */
MarkerClusterer.prototype.onAdd = function () {
  var cMarkerClusterer = this;

  this.activeMap_ = this.getMap();
  this.ready_ = true;

  this.repaint();

  // Add the map event listeners
  this.listeners_ = [
    google.maps.event.addListener(this.getMap(), "zoom_changed", function () {
      cMarkerClusterer.resetViewport_(false);
      // Workaround for this Google bug: when map is at level 0 and "-" of
      // zoom slider is clicked, a "zoom_changed" event is fired even though
      // the map doesn't zoom out any further. In this situation, no "idle"
      // event is triggered so the cluster markers that have been removed
      // do not get redrawn. Same goes for a zoom in at maxZoom.
      if (this.getZoom() === (this.get("minZoom") || 0) || this.getZoom() === this.get("maxZoom")) {
        google.maps.event.trigger(this, "idle");
      }
    }),
    google.maps.event.addListener(this.getMap(), "idle", function () {
      cMarkerClusterer.redraw_();
    })
  ];
};


/**
 * Implementation of the onRemove interface method.
 * Removes map event listeners and all cluster icons from the DOM.
 * All managed markers are also put back on the map.
 * @ignore
 */
MarkerClusterer.prototype.onRemove = function () {
  var i;

  // Put all the managed markers back on the map:
  for (i = 0; i < this.markers_.length; i++) {
    if (this.markers_[i].getMap() !== this.activeMap_) {
      this.markers_[i].setMap(this.activeMap_);
    }
  }

  // Remove all clusters:
  for (i = 0; i < this.clusters_.length; i++) {
    this.clusters_[i].remove();
  }
  this.clusters_ = [];

  // Remove map event listeners:
  for (i = 0; i < this.listeners_.length; i++) {
    google.maps.event.removeListener(this.listeners_[i]);
  }
  this.listeners_ = [];

  this.activeMap_ = null;
  this.ready_ = false;
};


/**
 * Implementation of the draw interface method.
 * @ignore
 */
MarkerClusterer.prototype.draw = function () {};


/**
 * Sets up the styles object.
 */
MarkerClusterer.prototype.setupStyles_ = function () {
  var i, size;
  if (this.styles_.length > 0) {
    return;
  }

  for (i = 0; i < this.imageSizes_.length; i++) {
    size = this.imageSizes_[i];
    this.styles_.push({
      url: this.imagePath_ + (i + 1) + "." + this.imageExtension_,
      height: size,
      width: size
    });
  }
};


/**
 *  Fits the map to the bounds of the markers managed by the clusterer.
 */
MarkerClusterer.prototype.fitMapToMarkers = function () {
  var i;
  var markers = this.getMarkers();
  var bounds = new google.maps.LatLngBounds();
  for (i = 0; i < markers.length; i++) {
    bounds.extend(markers[i].getPosition());
  }

  this.getMap().fitBounds(bounds);
};


/**
 * Returns the value of the <code>gridSize</code> property.
 *
 * @return {number} The grid size.
 */
MarkerClusterer.prototype.getGridSize = function () {
  return this.gridSize_;
};


/**
 * Sets the value of the <code>gridSize</code> property.
 *
 * @param {number} gridSize The grid size.
 */
MarkerClusterer.prototype.setGridSize = function (gridSize) {
  this.gridSize_ = gridSize;
};


/**
 * Returns the value of the <code>minimumClusterSize</code> property.
 *
 * @return {number} The minimum cluster size.
 */
MarkerClusterer.prototype.getMinimumClusterSize = function () {
  return this.minClusterSize_;
};

/**
 * Sets the value of the <code>minimumClusterSize</code> property.
 *
 * @param {number} minimumClusterSize The minimum cluster size.
 */
MarkerClusterer.prototype.setMinimumClusterSize = function (minimumClusterSize) {
  this.minClusterSize_ = minimumClusterSize;
};


/**
 *  Returns the value of the <code>maxZoom</code> property.
 *
 *  @return {number} The maximum zoom level.
 */
MarkerClusterer.prototype.getMaxZoom = function () {
  return this.maxZoom_;
};


/**
 *  Sets the value of the <code>maxZoom</code> property.
 *
 *  @param {number} maxZoom The maximum zoom level.
 */
MarkerClusterer.prototype.setMaxZoom = function (maxZoom) {
  this.maxZoom_ = maxZoom;
};


/**
 *  Returns the value of the <code>styles</code> property.
 *
 *  @return {Array} The array of styles defining the cluster markers to be used.
 */
MarkerClusterer.prototype.getStyles = function () {
  return this.styles_;
};


/**
 *  Sets the value of the <code>styles</code> property.
 *
 *  @param {Array.<ClusterIconStyle>} styles The array of styles to use.
 */
MarkerClusterer.prototype.setStyles = function (styles) {
  this.styles_ = styles;
};


/**
 * Returns the value of the <code>title</code> property.
 *
 * @return {string} The content of the title text.
 */
MarkerClusterer.prototype.getTitle = function () {
  return this.title_;
};


/**
 *  Sets the value of the <code>title</code> property.
 *
 *  @param {string} title The value of the title property.
 */
MarkerClusterer.prototype.setTitle = function (title) {
  this.title_ = title;
};


/**
 * Returns the value of the <code>zoomOnClick</code> property.
 *
 * @return {boolean} True if zoomOnClick property is set.
 */
MarkerClusterer.prototype.getZoomOnClick = function () {
  return this.zoomOnClick_;
};


/**
 *  Sets the value of the <code>zoomOnClick</code> property.
 *
 *  @param {boolean} zoomOnClick The value of the zoomOnClick property.
 */
MarkerClusterer.prototype.setZoomOnClick = function (zoomOnClick) {
  this.zoomOnClick_ = zoomOnClick;
};


/**
 * Returns the value of the <code>averageCenter</code> property.
 *
 * @return {boolean} True if averageCenter property is set.
 */
MarkerClusterer.prototype.getAverageCenter = function () {
  return this.averageCenter_;
};


/**
 *  Sets the value of the <code>averageCenter</code> property.
 *
 *  @param {boolean} averageCenter The value of the averageCenter property.
 */
MarkerClusterer.prototype.setAverageCenter = function (averageCenter) {
  this.averageCenter_ = averageCenter;
};


/**
 * Returns the value of the <code>ignoreHidden</code> property.
 *
 * @return {boolean} True if ignoreHidden property is set.
 */
MarkerClusterer.prototype.getIgnoreHidden = function () {
  return this.ignoreHidden_;
};


/**
 *  Sets the value of the <code>ignoreHidden</code> property.
 *
 *  @param {boolean} ignoreHidden The value of the ignoreHidden property.
 */
MarkerClusterer.prototype.setIgnoreHidden = function (ignoreHidden) {
  this.ignoreHidden_ = ignoreHidden;
};


/**
 * Returns the value of the <code>enableRetinaIcons</code> property.
 *
 * @return {boolean} True if enableRetinaIcons property is set.
 */
MarkerClusterer.prototype.getEnableRetinaIcons = function () {
  return this.enableRetinaIcons_;
};


/**
 *  Sets the value of the <code>enableRetinaIcons</code> property.
 *
 *  @param {boolean} enableRetinaIcons The value of the enableRetinaIcons property.
 */
MarkerClusterer.prototype.setEnableRetinaIcons = function (enableRetinaIcons) {
  this.enableRetinaIcons_ = enableRetinaIcons;
};


/**
 * Returns the value of the <code>imageExtension</code> property.
 *
 * @return {string} The value of the imageExtension property.
 */
MarkerClusterer.prototype.getImageExtension = function () {
  return this.imageExtension_;
};


/**
 *  Sets the value of the <code>imageExtension</code> property.
 *
 *  @param {string} imageExtension The value of the imageExtension property.
 */
MarkerClusterer.prototype.setImageExtension = function (imageExtension) {
  this.imageExtension_ = imageExtension;
};


/**
 * Returns the value of the <code>imagePath</code> property.
 *
 * @return {string} The value of the imagePath property.
 */
MarkerClusterer.prototype.getImagePath = function () {
  return this.imagePath_;
};


/**
 *  Sets the value of the <code>imagePath</code> property.
 *
 *  @param {string} imagePath The value of the imagePath property.
 */
MarkerClusterer.prototype.setImagePath = function (imagePath) {
  this.imagePath_ = imagePath;
};


/**
 * Returns the value of the <code>imageSizes</code> property.
 *
 * @return {Array} The value of the imageSizes property.
 */
MarkerClusterer.prototype.getImageSizes = function () {
  return this.imageSizes_;
};


/**
 *  Sets the value of the <code>imageSizes</code> property.
 *
 *  @param {Array} imageSizes The value of the imageSizes property.
 */
MarkerClusterer.prototype.setImageSizes = function (imageSizes) {
  this.imageSizes_ = imageSizes;
};


/**
 * Returns the value of the <code>calculator</code> property.
 *
 * @return {function} the value of the calculator property.
 */
MarkerClusterer.prototype.getCalculator = function () {
  return this.calculator_;
};


/**
 * Sets the value of the <code>calculator</code> property.
 *
 * @param {function(Array.<google.maps.Marker>, number)} calculator The value
 *  of the calculator property.
 */
MarkerClusterer.prototype.setCalculator = function (calculator) {
  this.calculator_ = calculator;
};


/**
 * Returns the value of the <code>batchSizeIE</code> property.
 *
 * @return {number} the value of the batchSizeIE property.
 */
MarkerClusterer.prototype.getBatchSizeIE = function () {
  return this.batchSizeIE_;
};


/**
 * Sets the value of the <code>batchSizeIE</code> property.
 *
 *  @param {number} batchSizeIE The value of the batchSizeIE property.
 */
MarkerClusterer.prototype.setBatchSizeIE = function (batchSizeIE) {
  this.batchSizeIE_ = batchSizeIE;
};


/**
 * Returns the value of the <code>clusterClass</code> property.
 *
 * @return {string} the value of the clusterClass property.
 */
MarkerClusterer.prototype.getClusterClass = function () {
  return this.clusterClass_;
};


/**
 * Sets the value of the <code>clusterClass</code> property.
 *
 *  @param {string} clusterClass The value of the clusterClass property.
 */
MarkerClusterer.prototype.setClusterClass = function (clusterClass) {
  this.clusterClass_ = clusterClass;
};


/**
 *  Returns the array of markers managed by the clusterer.
 *
 *  @return {Array} The array of markers managed by the clusterer.
 */
MarkerClusterer.prototype.getMarkers = function () {
  return this.markers_;
};


/**
 *  Returns the number of markers managed by the clusterer.
 *
 *  @return {number} The number of markers.
 */
MarkerClusterer.prototype.getTotalMarkers = function () {
  return this.markers_.length;
};


/**
 * Returns the current array of clusters formed by the clusterer.
 *
 * @return {Array} The array of clusters formed by the clusterer.
 */
MarkerClusterer.prototype.getClusters = function () {
  return this.clusters_;
};


/**
 * Returns the number of clusters formed by the clusterer.
 *
 * @return {number} The number of clusters formed by the clusterer.
 */
MarkerClusterer.prototype.getTotalClusters = function () {
  return this.clusters_.length;
};


/**
 * Adds a marker to the clusterer. The clusters are redrawn unless
 *  <code>opt_nodraw</code> is set to <code>true</code>.
 *
 * @param {google.maps.Marker} marker The marker to add.
 * @param {boolean} [opt_nodraw] Set to <code>true</code> to prevent redrawing.
 */
MarkerClusterer.prototype.addMarker = function (marker, opt_nodraw) {
  this.pushMarkerTo_(marker);
  if (!opt_nodraw) {
    this.redraw_();
  }
};


/**
 * Adds an array of markers to the clusterer. The clusters are redrawn unless
 *  <code>opt_nodraw</code> is set to <code>true</code>.
 *
 * @param {Array.<google.maps.Marker>} markers The markers to add.
 * @param {boolean} [opt_nodraw] Set to <code>true</code> to prevent redrawing.
 */
MarkerClusterer.prototype.addMarkers = function (markers, opt_nodraw) {
  var key;
  for (key in markers) {
    if (markers.hasOwnProperty(key)) {
      this.pushMarkerTo_(markers[key]);
    }
  }  
  if (!opt_nodraw) {
    this.redraw_();
  }
};


/**
 * Pushes a marker to the clusterer.
 *
 * @param {google.maps.Marker} marker The marker to add.
 */
MarkerClusterer.prototype.pushMarkerTo_ = function (marker) {
  // If the marker is draggable add a listener so we can update the clusters on the dragend:
  if (marker.getDraggable()) {
    var cMarkerClusterer = this;
    google.maps.event.addListener(marker, "dragend", function () {
      if (cMarkerClusterer.ready_) {
        this.isAdded = false;
        cMarkerClusterer.repaint();
      }
    });
  }
  marker.isAdded = false;
  this.markers_.push(marker);
};


/**
 * Removes a marker from the cluster.  The clusters are redrawn unless
 *  <code>opt_nodraw</code> is set to <code>true</code>. Returns <code>true</code> if the
 *  marker was removed from the clusterer.
 *
 * @param {google.maps.Marker} marker The marker to remove.
 * @param {boolean} [opt_nodraw] Set to <code>true</code> to prevent redrawing.
 * @return {boolean} True if the marker was removed from the clusterer.
 */
MarkerClusterer.prototype.removeMarker = function (marker, opt_nodraw) {
  var removed = this.removeMarker_(marker);

  if (!opt_nodraw && removed) {
    this.repaint();
  }

  return removed;
};


/**
 * Removes an array of markers from the cluster. The clusters are redrawn unless
 *  <code>opt_nodraw</code> is set to <code>true</code>. Returns <code>true</code> if markers
 *  were removed from the clusterer.
 *
 * @param {Array.<google.maps.Marker>} markers The markers to remove.
 * @param {boolean} [opt_nodraw] Set to <code>true</code> to prevent redrawing.
 * @return {boolean} True if markers were removed from the clusterer.
 */
MarkerClusterer.prototype.removeMarkers = function (markers, opt_nodraw) {
  var i, r;
  var removed = false;

  for (i = 0; i < markers.length; i++) {
    r = this.removeMarker_(markers[i]);
    removed = removed || r;
  }

  if (!opt_nodraw && removed) {
    this.repaint();
  }

  return removed;
};


/**
 * Removes a marker and returns true if removed, false if not.
 *
 * @param {google.maps.Marker} marker The marker to remove
 * @return {boolean} Whether the marker was removed or not
 */
MarkerClusterer.prototype.removeMarker_ = function (marker) {
  var i;
  var index = -1;
  if (this.markers_.indexOf) {
    index = this.markers_.indexOf(marker);
  } else {
    for (i = 0; i < this.markers_.length; i++) {
      if (marker === this.markers_[i]) {
        index = i;
        break;
      }
    }
  }

  if (index === -1) {
    // Marker is not in our list of markers, so do nothing:
    return false;
  }

  marker.setMap(null);
  this.markers_.splice(index, 1); // Remove the marker from the list of managed markers
  return true;
};


/**
 * Removes all clusters and markers from the map and also removes all markers
 *  managed by the clusterer.
 */
MarkerClusterer.prototype.clearMarkers = function () {
  this.resetViewport_(true);
  this.markers_ = [];
};


/**
 * Recalculates and redraws all the marker clusters from scratch.
 *  Call this after changing any properties.
 */
MarkerClusterer.prototype.repaint = function () {
  var oldClusters = this.clusters_.slice();
  this.clusters_ = [];
  this.resetViewport_(false);
  this.redraw_();

  // Remove the old clusters.
  // Do it in a timeout to prevent blinking effect.
  setTimeout(function () {
    var i;
    for (i = 0; i < oldClusters.length; i++) {
      oldClusters[i].remove();
    }
  }, 0);
};


/**
 * Returns the current bounds extended by the grid size.
 *
 * @param {google.maps.LatLngBounds} bounds The bounds to extend.
 * @return {google.maps.LatLngBounds} The extended bounds.
 * @ignore
 */
MarkerClusterer.prototype.getExtendedBounds = function (bounds) {
  var projection = this.getProjection();

  // Turn the bounds into latlng.
  var tr = new google.maps.LatLng(bounds.getNorthEast().lat(),
      bounds.getNorthEast().lng());
  var bl = new google.maps.LatLng(bounds.getSouthWest().lat(),
      bounds.getSouthWest().lng());

  // Convert the points to pixels and the extend out by the grid size.
  var trPix = projection.fromLatLngToDivPixel(tr);
  trPix.x += this.gridSize_;
  trPix.y -= this.gridSize_;

  var blPix = projection.fromLatLngToDivPixel(bl);
  blPix.x -= this.gridSize_;
  blPix.y += this.gridSize_;

  // Convert the pixel points back to LatLng
  var ne = projection.fromDivPixelToLatLng(trPix);
  var sw = projection.fromDivPixelToLatLng(blPix);

  // Extend the bounds to contain the new bounds.
  bounds.extend(ne);
  bounds.extend(sw);

  return bounds;
};


/**
 * Redraws all the clusters.
 */
MarkerClusterer.prototype.redraw_ = function () {
  this.createClusters_(0);
};


/**
 * Removes all clusters from the map. The markers are also removed from the map
 *  if <code>opt_hide</code> is set to <code>true</code>.
 *
 * @param {boolean} [opt_hide] Set to <code>true</code> to also remove the markers
 *  from the map.
 */
MarkerClusterer.prototype.resetViewport_ = function (opt_hide) {
  var i, marker;
  // Remove all the clusters
  for (i = 0; i < this.clusters_.length; i++) {
    this.clusters_[i].remove();
  }
  this.clusters_ = [];

  // Reset the markers to not be added and to be removed from the map.
  for (i = 0; i < this.markers_.length; i++) {
    marker = this.markers_[i];
    marker.isAdded = false;
    if (opt_hide) {
      marker.setMap(null);
    }
  }
};


/**
 * Calculates the distance between two latlng locations in km.
 *
 * @param {google.maps.LatLng} p1 The first lat lng point.
 * @param {google.maps.LatLng} p2 The second lat lng point.
 * @return {number} The distance between the two points in km.
 * @see http://www.movable-type.co.uk/scripts/latlong.html
*/
MarkerClusterer.prototype.distanceBetweenPoints_ = function (p1, p2) {
  var R = 6371; // Radius of the Earth in km
  var dLat = (p2.lat() - p1.lat()) * Math.PI / 180;
  var dLon = (p2.lng() - p1.lng()) * Math.PI / 180;
  var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(p1.lat() * Math.PI / 180) * Math.cos(p2.lat() * Math.PI / 180) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c;
  return d;
};


/**
 * Determines if a marker is contained in a bounds.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @param {google.maps.LatLngBounds} bounds The bounds to check against.
 * @return {boolean} True if the marker is in the bounds.
 */
MarkerClusterer.prototype.isMarkerInBounds_ = function (marker, bounds) {
  return bounds.contains(marker.getPosition());
};


/**
 * Adds a marker to a cluster, or creates a new cluster.
 *
 * @param {google.maps.Marker} marker The marker to add.
 */
MarkerClusterer.prototype.addToClosestCluster_ = function (marker) {
  var i, d, cluster, center;
  var distance = 40000; // Some large number
  var clusterToAddTo = null;
  for (i = 0; i < this.clusters_.length; i++) {
    cluster = this.clusters_[i];
    center = cluster.getCenter();
    if (center) {
      d = this.distanceBetweenPoints_(center, marker.getPosition());
      if (d < distance) {
        distance = d;
        clusterToAddTo = cluster;
      }
    }
  }

  if (clusterToAddTo && clusterToAddTo.isMarkerInClusterBounds(marker)) {
    clusterToAddTo.addMarker(marker);
  } else {
    cluster = new Cluster(this);
    cluster.addMarker(marker);
    this.clusters_.push(cluster);
  }
};


/**
 * Creates the clusters. This is done in batches to avoid timeout errors
 *  in some browsers when there is a huge number of markers.
 *
 * @param {number} iFirst The index of the first marker in the batch of
 *  markers to be added to clusters.
 */
MarkerClusterer.prototype.createClusters_ = function (iFirst) {
  var i, marker;
  var mapBounds;
  var cMarkerClusterer = this;
  if (!this.ready_) {
    return;
  }

  // Cancel previous batch processing if we're working on the first batch:
  if (iFirst === 0) {
    /**
     * This event is fired when the <code>MarkerClusterer</code> begins
     *  clustering markers.
     * @name MarkerClusterer#clusteringbegin
     * @param {MarkerClusterer} mc The MarkerClusterer whose markers are being clustered.
     * @event
     */
    google.maps.event.trigger(this, "clusteringbegin", this);

    if (typeof this.timerRefStatic !== "undefined") {
      clearTimeout(this.timerRefStatic);
      delete this.timerRefStatic;
    }
  }

  // Get our current map view bounds.
  // Create a new bounds object so we don't affect the map.
  //
  // See Comments 9 & 11 on Issue 3651 relating to this workaround for a Google Maps bug:
  if (this.getMap().getZoom() > 3) {
    mapBounds = new google.maps.LatLngBounds(this.getMap().getBounds().getSouthWest(),
      this.getMap().getBounds().getNorthEast());
  } else {
    mapBounds = new google.maps.LatLngBounds(new google.maps.LatLng(85.02070771743472, -178.48388434375), new google.maps.LatLng(-85.08136444384544, 178.00048865625));
  }
  var bounds = this.getExtendedBounds(mapBounds);

  var iLast = Math.min(iFirst + this.batchSize_, this.markers_.length);

  for (i = iFirst; i < iLast; i++) {
    marker = this.markers_[i];
    if (!marker.isAdded && this.isMarkerInBounds_(marker, bounds)) {
      if (!this.ignoreHidden_ || (this.ignoreHidden_ && marker.getVisible())) {
        this.addToClosestCluster_(marker);
      }
    }
  }

  if (iLast < this.markers_.length) {
    this.timerRefStatic = setTimeout(function () {
      cMarkerClusterer.createClusters_(iLast);
    }, 0);
  } else {
    delete this.timerRefStatic;

    /**
     * This event is fired when the <code>MarkerClusterer</code> stops
     *  clustering markers.
     * @name MarkerClusterer#clusteringend
     * @param {MarkerClusterer} mc The MarkerClusterer whose markers are being clustered.
     * @event
     */
    google.maps.event.trigger(this, "clusteringend", this);
  }
};


/**
 * Extends an object's prototype by another's.
 *
 * @param {Object} obj1 The object to be extended.
 * @param {Object} obj2 The object to extend with.
 * @return {Object} The new extended object.
 * @ignore
 */
MarkerClusterer.prototype.extend = function (obj1, obj2) {
  return (function (object) {
    var property;
    for (property in object.prototype) {
      this.prototype[property] = object.prototype[property];
    }
    return this;
  }).apply(obj1, [obj2]);
};


/**
 * The default function for determining the label text and style
 * for a cluster icon.
 *
 * @param {Array.<google.maps.Marker>} markers The array of markers represented by the cluster.
 * @param {number} numStyles The number of marker styles available.
 * @return {ClusterIconInfo} The information resource for the cluster.
 * @constant
 * @ignore
 */
MarkerClusterer.CALCULATOR = function (markers, numStyles) {
  var index = 0;
  var title = "";
  var count = markers.length.toString();

  var dv = count;
  while (dv !== 0) {
    dv = parseInt(dv / 10, 10);
    index++;
  }

  index = Math.min(index, numStyles);
  return {
    text: count,
    index: index,
    title: title
  };
};


/**
 * The number of markers to process in one batch.
 *
 * @type {number}
 * @constant
 */
MarkerClusterer.BATCH_SIZE = 2000;


/**
 * The number of markers to process in one batch (IE only).
 *
 * @type {number}
 * @constant
 */
MarkerClusterer.BATCH_SIZE_IE = 500;


/**
 * The default root name for the marker cluster images.
 *
 * @type {string}
 * @constant
 */
MarkerClusterer.IMAGE_PATH = "https://raw.githubusercontent.com/googlemaps/v3-utility-library/master/markerclustererplus/images/m";


/**
 * The default extension name for the marker cluster images.
 *
 * @type {string}
 * @constant
 */
MarkerClusterer.IMAGE_EXTENSION = "png";


/**
 * The default array of sizes for the marker cluster images.
 *
 * @type {Array.<number>}
 * @constant
 */
MarkerClusterer.IMAGE_SIZES = [53, 56, 66, 78, 90];

module.exports = MarkerClusterer


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 341,
	"./af.js": 341,
	"./ar": 348,
	"./ar-dz": 342,
	"./ar-dz.js": 342,
	"./ar-kw": 343,
	"./ar-kw.js": 343,
	"./ar-ly": 344,
	"./ar-ly.js": 344,
	"./ar-ma": 345,
	"./ar-ma.js": 345,
	"./ar-sa": 346,
	"./ar-sa.js": 346,
	"./ar-tn": 347,
	"./ar-tn.js": 347,
	"./ar.js": 348,
	"./az": 349,
	"./az.js": 349,
	"./be": 350,
	"./be.js": 350,
	"./bg": 351,
	"./bg.js": 351,
	"./bn": 352,
	"./bn.js": 352,
	"./bo": 353,
	"./bo.js": 353,
	"./br": 354,
	"./br.js": 354,
	"./bs": 355,
	"./bs.js": 355,
	"./ca": 210,
	"./ca.js": 210,
	"./cs": 356,
	"./cs.js": 356,
	"./cv": 357,
	"./cv.js": 357,
	"./cy": 358,
	"./cy.js": 358,
	"./da": 359,
	"./da.js": 359,
	"./de": 362,
	"./de-at": 360,
	"./de-at.js": 360,
	"./de-ch": 361,
	"./de-ch.js": 361,
	"./de.js": 362,
	"./dv": 363,
	"./dv.js": 363,
	"./el": 364,
	"./el.js": 364,
	"./en-au": 365,
	"./en-au.js": 365,
	"./en-ca": 366,
	"./en-ca.js": 366,
	"./en-gb": 367,
	"./en-gb.js": 367,
	"./en-ie": 368,
	"./en-ie.js": 368,
	"./en-nz": 369,
	"./en-nz.js": 369,
	"./eo": 370,
	"./eo.js": 370,
	"./es": 372,
	"./es-do": 371,
	"./es-do.js": 371,
	"./es.js": 372,
	"./et": 373,
	"./et.js": 373,
	"./eu": 374,
	"./eu.js": 374,
	"./fa": 375,
	"./fa.js": 375,
	"./fi": 376,
	"./fi.js": 376,
	"./fo": 377,
	"./fo.js": 377,
	"./fr": 380,
	"./fr-ca": 378,
	"./fr-ca.js": 378,
	"./fr-ch": 379,
	"./fr-ch.js": 379,
	"./fr.js": 380,
	"./fy": 381,
	"./fy.js": 381,
	"./gd": 382,
	"./gd.js": 382,
	"./gl": 383,
	"./gl.js": 383,
	"./gom-latn": 384,
	"./gom-latn.js": 384,
	"./he": 385,
	"./he.js": 385,
	"./hi": 386,
	"./hi.js": 386,
	"./hr": 387,
	"./hr.js": 387,
	"./hu": 388,
	"./hu.js": 388,
	"./hy-am": 389,
	"./hy-am.js": 389,
	"./id": 390,
	"./id.js": 390,
	"./is": 391,
	"./is.js": 391,
	"./it": 392,
	"./it.js": 392,
	"./ja": 393,
	"./ja.js": 393,
	"./jv": 394,
	"./jv.js": 394,
	"./ka": 395,
	"./ka.js": 395,
	"./kk": 396,
	"./kk.js": 396,
	"./km": 397,
	"./km.js": 397,
	"./kn": 398,
	"./kn.js": 398,
	"./ko": 399,
	"./ko.js": 399,
	"./ky": 400,
	"./ky.js": 400,
	"./lb": 401,
	"./lb.js": 401,
	"./lo": 402,
	"./lo.js": 402,
	"./lt": 403,
	"./lt.js": 403,
	"./lv": 404,
	"./lv.js": 404,
	"./me": 405,
	"./me.js": 405,
	"./mi": 406,
	"./mi.js": 406,
	"./mk": 407,
	"./mk.js": 407,
	"./ml": 408,
	"./ml.js": 408,
	"./mr": 409,
	"./mr.js": 409,
	"./ms": 411,
	"./ms-my": 410,
	"./ms-my.js": 410,
	"./ms.js": 411,
	"./my": 412,
	"./my.js": 412,
	"./nb": 413,
	"./nb.js": 413,
	"./ne": 414,
	"./ne.js": 414,
	"./nl": 416,
	"./nl-be": 415,
	"./nl-be.js": 415,
	"./nl.js": 416,
	"./nn": 417,
	"./nn.js": 417,
	"./pa-in": 418,
	"./pa-in.js": 418,
	"./pl": 419,
	"./pl.js": 419,
	"./pt": 421,
	"./pt-br": 420,
	"./pt-br.js": 420,
	"./pt.js": 421,
	"./ro": 422,
	"./ro.js": 422,
	"./ru": 423,
	"./ru.js": 423,
	"./sd": 424,
	"./sd.js": 424,
	"./se": 425,
	"./se.js": 425,
	"./si": 426,
	"./si.js": 426,
	"./sk": 427,
	"./sk.js": 427,
	"./sl": 428,
	"./sl.js": 428,
	"./sq": 429,
	"./sq.js": 429,
	"./sr": 431,
	"./sr-cyrl": 430,
	"./sr-cyrl.js": 430,
	"./sr.js": 431,
	"./ss": 432,
	"./ss.js": 432,
	"./sv": 433,
	"./sv.js": 433,
	"./sw": 434,
	"./sw.js": 434,
	"./ta": 435,
	"./ta.js": 435,
	"./te": 436,
	"./te.js": 436,
	"./tet": 437,
	"./tet.js": 437,
	"./th": 438,
	"./th.js": 438,
	"./tl-ph": 439,
	"./tl-ph.js": 439,
	"./tlh": 440,
	"./tlh.js": 440,
	"./tr": 441,
	"./tr.js": 441,
	"./tzl": 442,
	"./tzl.js": 442,
	"./tzm": 444,
	"./tzm-latn": 443,
	"./tzm-latn.js": 443,
	"./tzm.js": 444,
	"./uk": 445,
	"./uk.js": 445,
	"./ur": 446,
	"./ur.js": 446,
	"./uz": 448,
	"./uz-latn": 447,
	"./uz-latn.js": 447,
	"./uz.js": 448,
	"./vi": 449,
	"./vi.js": 449,
	"./x-pseudo": 450,
	"./x-pseudo.js": 450,
	"./yo": 451,
	"./yo.js": 451,
	"./zh-cn": 452,
	"./zh-cn.js": 452,
	"./zh-hk": 453,
	"./zh-hk.js": 453,
	"./zh-tw": 454,
	"./zh-tw.js": 454
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1173;

/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mgrs__ = __webpack_require__(340);


function Point(x, y, z) {
  if (!(this instanceof Point)) {
    return new Point(x, y, z);
  }
  if (Array.isArray(x)) {
    this.x = x[0];
    this.y = x[1];
    this.z = x[2] || 0.0;
  } else if(typeof x === 'object') {
    this.x = x.x;
    this.y = x.y;
    this.z = x.z || 0.0;
  } else if (typeof x === 'string' && typeof y === 'undefined') {
    var coords = x.split(',');
    this.x = parseFloat(coords[0], 10);
    this.y = parseFloat(coords[1], 10);
    this.z = parseFloat(coords[2], 10) || 0.0;
  } else {
    this.x = x;
    this.y = y;
    this.z = z || 0.0;
  }
  console.warn('proj4.Point will be removed in version 3, use proj4.toPoint');
}

Point.fromMGRS = function(mgrsStr) {
  return new Point(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_mgrs__["b" /* toPoint */])(mgrsStr));
};
Point.prototype.toMGRS = function(accuracy) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_mgrs__["c" /* forward */])([this.x, this.y], accuracy);
};
/* harmony default export */ __webpack_exports__["a"] = (Point);


/***/ }),
/* 1175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(crs, denorm, point) {
  var xin = point.x,
    yin = point.y,
    zin = point.z || 0.0;
  var v, t, i;
  var out = {};
  for (i = 0; i < 3; i++) {
    if (denorm && i === 2 && point.z === undefined) {
      continue;
    }
    if (i === 0) {
      v = xin;
      t = 'x';
    }
    else if (i === 1) {
      v = yin;
      t = 'y';
    }
    else {
      v = zin;
      t = 'z';
    }
    switch (crs.axis[i]) {
    case 'e':
      out[t] = v;
      break;
    case 'w':
      out[t] = -v;
      break;
    case 'n':
      out[t] = v;
      break;
    case 's':
      out[t] = -v;
      break;
    case 'u':
      if (point[t] !== undefined) {
        out.z = v;
      }
      break;
    case 'd':
      if (point[t] !== undefined) {
        out.z = -v;
      }
      break;
    default:
      //console.log("ERROR: unknow axis ("+crs.axis[i]+") - check definition of "+crs.projName);
      return null;
    }
  }
  return out;
});


/***/ }),
/* 1176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (point) {
  checkCoord(point.x);
  checkCoord(point.y);
});
function checkCoord(num) {
  if (typeof Number.isFinite === 'function') {
    if (Number.isFinite(num)) {
      return;
    }
    throw new TypeError('coordinates must be finite numbers');
  }
  if (typeof num !== 'number' || num !== num || !isFinite(num)) {
    throw new TypeError('coordinates must be finite numbers');
  }
}


/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adjust_lon__ = __webpack_require__(33);


/* harmony default export */ __webpack_exports__["a"] = (function(zone, lon) {
  if (zone === undefined) {
    zone = Math.floor((__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__adjust_lon__["a" /* default */])(lon) + Math.PI) * 30 / Math.PI) + 1;

    if (zone < 0) {
      return 0;
    } else if (zone > 60) {
      return 60;
    }
  }
  return zone;
});


/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hypot__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__log1py__ = __webpack_require__(1184);



/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  var y = Math.abs(x);
  y = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__log1py__["a" /* default */])(y * (1 + y / (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__hypot__["a" /* default */])(1, y) + 1)));

  return x < 0 ? -y : y;
});


/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(pp, arg_r) {
  var r = 2 * Math.cos(arg_r);
  var i = pp.length - 1;
  var hr1 = pp[i];
  var hr2 = 0;
  var hr;

  while (--i >= 0) {
    hr = -hr2 + r * hr1 + pp[i];
    hr2 = hr1;
    hr1 = hr;
  }

  return Math.sin(arg_r) * hr;
});


/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sinh__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cosh__ = __webpack_require__(1181);



/* harmony default export */ __webpack_exports__["a"] = (function(pp, arg_r, arg_i) {
  var sin_arg_r = Math.sin(arg_r);
  var cos_arg_r = Math.cos(arg_r);
  var sinh_arg_i = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sinh__["a" /* default */])(arg_i);
  var cosh_arg_i = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cosh__["a" /* default */])(arg_i);
  var r = 2 * cos_arg_r * cosh_arg_i;
  var i = -2 * sin_arg_r * sinh_arg_i;
  var j = pp.length - 1;
  var hr = pp[j];
  var hi1 = 0;
  var hr1 = 0;
  var hi = 0;
  var hr2;
  var hi2;

  while (--j >= 0) {
    hr2 = hr1;
    hi2 = hi1;
    hr1 = hr;
    hi1 = hi;
    hr = -hr2 + r * hr1 - i * hi1 + pp[j];
    hi = -hi2 + i * hr1 + r * hi1;
  }

  r = sin_arg_r * cosh_arg_i;
  i = cos_arg_r * sinh_arg_i;

  return [r * hr - i * hi, r * hi + i * hr];
});


/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  var r = Math.exp(x);
  r = (r + 1 / r) / 2;
  return r;
});

/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(pp, B) {
  var cos_2B = 2 * Math.cos(2 * B);
  var i = pp.length - 1;
  var h1 = pp[i];
  var h2 = 0;
  var h;

  while (--i >= 0) {
    h = -h2 + cos_2B * h1 + pp[i];
    h2 = h1;
    h1 = h;
  }

  return (B + h * Math.sin(2 * B));
});


/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_values__ = __webpack_require__(28);


/* harmony default export */ __webpack_exports__["a"] = (function(eccent, q) {
  var temp = 1 - (1 - eccent * eccent) / (2 * eccent) * Math.log((1 - eccent) / (1 + eccent));
  if (Math.abs(Math.abs(q) - temp) < 1.0E-6) {
    if (q < 0) {
      return (-1 * __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */]);
    }
    else {
      return __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */];
    }
  }
  //var phi = 0.5* q/(1-eccent*eccent);
  var phi = Math.asin(0.5 * q);
  var dphi;
  var sin_phi;
  var cos_phi;
  var con;
  for (var i = 0; i < 30; i++) {
    sin_phi = Math.sin(phi);
    cos_phi = Math.cos(phi);
    con = eccent * sin_phi;
    dphi = Math.pow(1 - con * con, 2) / (2 * cos_phi) * (q / (1 - eccent * eccent) - sin_phi / (1 - con * con) + 0.5 / eccent * Math.log((1 - con) / (1 + con)));
    phi += dphi;
    if (Math.abs(dphi) <= 0.0000000001) {
      return phi;
    }
  }

  //console.log("IQSFN-CONV:Latitude failed to converge after 30 iterations");
  return NaN;
});


/***/ }),
/* 1184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  var y = 1 + x;
  var z = y - 1;

  return z === 0 ? x : x * Math.log(y) / z;
});


/***/ }),
/* 1185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(esinp, exp) {
  return (Math.pow((1 - esinp) / (1 + esinp), exp));
});

/***/ }),
/* 1186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return exports; });
var exports = {};

exports.wgs84 = {
  towgs84: "0,0,0",
  ellipse: "WGS84",
  datumName: "WGS84"
};

exports.ch1903 = {
  towgs84: "674.374,15.056,405.346",
  ellipse: "bessel",
  datumName: "swiss"
};

exports.ggrs87 = {
  towgs84: "-199.87,74.79,246.62",
  ellipse: "GRS80",
  datumName: "Greek_Geodetic_Reference_System_1987"
};

exports.nad83 = {
  towgs84: "0,0,0",
  ellipse: "GRS80",
  datumName: "North_American_Datum_1983"
};

exports.nad27 = {
  nadgrids: "@conus,@alaska,@ntv2_0.gsb,@ntv1_can.dat",
  ellipse: "clrk66",
  datumName: "North_American_Datum_1927"
};

exports.potsdam = {
  towgs84: "606.0,23.0,413.0",
  ellipse: "bessel",
  datumName: "Potsdam Rauenberg 1950 DHDN"
};

exports.carthage = {
  towgs84: "-263.0,6.0,431.0",
  ellipse: "clark80",
  datumName: "Carthage 1934 Tunisia"
};

exports.hermannskogel = {
  towgs84: "653.0,-212.0,449.0",
  ellipse: "bessel",
  datumName: "Hermannskogel"
};

exports.osni52 = {
  towgs84: "482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15",
  ellipse: "airy",
  datumName: "Irish National"
};

exports.ire65 = {
  towgs84: "482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15",
  ellipse: "mod_airy",
  datumName: "Ireland 1965"
};

exports.rassadiran = {
  towgs84: "-133.63,-157.5,-158.62",
  ellipse: "intl",
  datumName: "Rassadiran"
};

exports.nzgd49 = {
  towgs84: "59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993",
  ellipse: "intl",
  datumName: "New Zealand Geodetic Datum 1949"
};

exports.osgb36 = {
  towgs84: "446.448,-125.157,542.060,0.1502,0.2470,0.8421,-20.4894",
  ellipse: "airy",
  datumName: "Airy 1830"
};

exports.s_jtsk = {
  towgs84: "589,76,480",
  ellipse: 'bessel',
  datumName: 'S-JTSK (Ferro)'
};

exports.beduaram = {
  towgs84: '-106,-87,188',
  ellipse: 'clrk80',
  datumName: 'Beduaram'
};

exports.gunung_segara = {
  towgs84: '-403,684,41',
  ellipse: 'bessel',
  datumName: 'Gunung Segara Jakarta'
};

exports.rnb72 = {
  towgs84: "106.869,-52.2978,103.724,-0.33657,0.456955,-1.84218,1",
  ellipse: "intl",
  datumName: "Reseau National Belge 1972"
};


/***/ }),
/* 1187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return exports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return WGS84; });
var exports = {};

exports.MERIT = {
  a: 6378137.0,
  rf: 298.257,
  ellipseName: "MERIT 1983"
};

exports.SGS85 = {
  a: 6378136.0,
  rf: 298.257,
  ellipseName: "Soviet Geodetic System 85"
};

exports.GRS80 = {
  a: 6378137.0,
  rf: 298.257222101,
  ellipseName: "GRS 1980(IUGG, 1980)"
};

exports.IAU76 = {
  a: 6378140.0,
  rf: 298.257,
  ellipseName: "IAU 1976"
};

exports.airy = {
  a: 6377563.396,
  b: 6356256.910,
  ellipseName: "Airy 1830"
};

exports.APL4 = {
  a: 6378137,
  rf: 298.25,
  ellipseName: "Appl. Physics. 1965"
};

exports.NWL9D = {
  a: 6378145.0,
  rf: 298.25,
  ellipseName: "Naval Weapons Lab., 1965"
};

exports.mod_airy = {
  a: 6377340.189,
  b: 6356034.446,
  ellipseName: "Modified Airy"
};

exports.andrae = {
  a: 6377104.43,
  rf: 300.0,
  ellipseName: "Andrae 1876 (Den., Iclnd.)"
};

exports.aust_SA = {
  a: 6378160.0,
  rf: 298.25,
  ellipseName: "Australian Natl & S. Amer. 1969"
};

exports.GRS67 = {
  a: 6378160.0,
  rf: 298.2471674270,
  ellipseName: "GRS 67(IUGG 1967)"
};

exports.bessel = {
  a: 6377397.155,
  rf: 299.1528128,
  ellipseName: "Bessel 1841"
};

exports.bess_nam = {
  a: 6377483.865,
  rf: 299.1528128,
  ellipseName: "Bessel 1841 (Namibia)"
};

exports.clrk66 = {
  a: 6378206.4,
  b: 6356583.8,
  ellipseName: "Clarke 1866"
};

exports.clrk80 = {
  a: 6378249.145,
  rf: 293.4663,
  ellipseName: "Clarke 1880 mod."
};

exports.clrk58 = {
  a: 6378293.645208759,
  rf: 294.2606763692654,
  ellipseName: "Clarke 1858"
};

exports.CPM = {
  a: 6375738.7,
  rf: 334.29,
  ellipseName: "Comm. des Poids et Mesures 1799"
};

exports.delmbr = {
  a: 6376428.0,
  rf: 311.5,
  ellipseName: "Delambre 1810 (Belgium)"
};

exports.engelis = {
  a: 6378136.05,
  rf: 298.2566,
  ellipseName: "Engelis 1985"
};

exports.evrst30 = {
  a: 6377276.345,
  rf: 300.8017,
  ellipseName: "Everest 1830"
};

exports.evrst48 = {
  a: 6377304.063,
  rf: 300.8017,
  ellipseName: "Everest 1948"
};

exports.evrst56 = {
  a: 6377301.243,
  rf: 300.8017,
  ellipseName: "Everest 1956"
};

exports.evrst69 = {
  a: 6377295.664,
  rf: 300.8017,
  ellipseName: "Everest 1969"
};

exports.evrstSS = {
  a: 6377298.556,
  rf: 300.8017,
  ellipseName: "Everest (Sabah & Sarawak)"
};

exports.fschr60 = {
  a: 6378166.0,
  rf: 298.3,
  ellipseName: "Fischer (Mercury Datum) 1960"
};

exports.fschr60m = {
  a: 6378155.0,
  rf: 298.3,
  ellipseName: "Fischer 1960"
};

exports.fschr68 = {
  a: 6378150.0,
  rf: 298.3,
  ellipseName: "Fischer 1968"
};

exports.helmert = {
  a: 6378200.0,
  rf: 298.3,
  ellipseName: "Helmert 1906"
};

exports.hough = {
  a: 6378270.0,
  rf: 297.0,
  ellipseName: "Hough"
};

exports.intl = {
  a: 6378388.0,
  rf: 297.0,
  ellipseName: "International 1909 (Hayford)"
};

exports.kaula = {
  a: 6378163.0,
  rf: 298.24,
  ellipseName: "Kaula 1961"
};

exports.lerch = {
  a: 6378139.0,
  rf: 298.257,
  ellipseName: "Lerch 1979"
};

exports.mprts = {
  a: 6397300.0,
  rf: 191.0,
  ellipseName: "Maupertius 1738"
};

exports.new_intl = {
  a: 6378157.5,
  b: 6356772.2,
  ellipseName: "New International 1967"
};

exports.plessis = {
  a: 6376523.0,
  rf: 6355863.0,
  ellipseName: "Plessis 1817 (France)"
};

exports.krass = {
  a: 6378245.0,
  rf: 298.3,
  ellipseName: "Krassovsky, 1942"
};

exports.SEasia = {
  a: 6378155.0,
  b: 6356773.3205,
  ellipseName: "Southeast Asia"
};

exports.walbeck = {
  a: 6376896.0,
  b: 6355834.8467,
  ellipseName: "Walbeck"
};

exports.WGS60 = {
  a: 6378165.0,
  rf: 298.3,
  ellipseName: "WGS 60"
};

exports.WGS66 = {
  a: 6378145.0,
  rf: 298.25,
  ellipseName: "WGS 66"
};

exports.WGS7 = {
  a: 6378135.0,
  rf: 298.26,
  ellipseName: "WGS 72"
};

var WGS84 = exports.WGS84 = {
  a: 6378137.0,
  rf: 298.257223563,
  ellipseName: "WGS 84"
};

exports.sphere = {
  a: 6370997.0,
  b: 6370997.0,
  ellipseName: "Normal Sphere (r=6370997)"
};


/***/ }),
/* 1188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return exports; });
var exports = {};


exports.greenwich = 0.0; //"0dE",
exports.lisbon = -9.131906111111; //"9d07'54.862\"W",
exports.paris = 2.337229166667; //"2d20'14.025\"E",
exports.bogota = -74.080916666667; //"74d04'51.3\"W",
exports.madrid = -3.687938888889; //"3d41'16.58\"W",
exports.rome = 12.452333333333; //"12d27'8.4\"E",
exports.bern = 7.439583333333; //"7d26'22.5\"E",
exports.jakarta = 106.807719444444; //"106d48'27.79\"E",
exports.ferro = -17.666666666667; //"17d40'W",
exports.brussels = 4.367975; //"4d22'4.71\"E",
exports.stockholm = 18.058277777778; //"18d3'29.8\"E",
exports.athens = 23.7163375; //"23d42'58.815\"E",
exports.oslo = 10.722916666667; //"10d43'22.5\"E"


/***/ }),
/* 1189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  ft: {to_meter: 0.3048},
  'us-ft': {to_meter: 1200 / 3937}
});


/***/ }),
/* 1190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Proj__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transform__ = __webpack_require__(464);


var wgs84 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__Proj__["a" /* default */])('WGS84');

function transformer(from, to, coords) {
  var transformedArray, out, keys;
  if (Array.isArray(coords)) {
    transformedArray = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__transform__["a" /* default */])(from, to, coords);
    if (coords.length === 3) {
      return [transformedArray.x, transformedArray.y, transformedArray.z];
    }
    else {
      return [transformedArray.x, transformedArray.y];
    }
  }
  else {
    out = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__transform__["a" /* default */])(from, to, coords);
    keys = Object.keys(coords);
    if (keys.length === 2) {
      return out;
    }
    keys.forEach(function (key) {
      if (key === 'x' || key === 'y') {
        return;
      }
      out[key] = coords[key];
    });
    return out;
  }
}

function checkProj(item) {
  if (item instanceof __WEBPACK_IMPORTED_MODULE_0__Proj__["a" /* default */]) {
    return item;
  }
  if (item.oProj) {
    return item.oProj;
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__Proj__["a" /* default */])(item);
}
function proj4(fromProj, toProj, coord) {
  fromProj = checkProj(fromProj);
  var single = false;
  var obj;
  if (typeof toProj === 'undefined') {
    toProj = fromProj;
    fromProj = wgs84;
    single = true;
  }
  else if (typeof toProj.x !== 'undefined' || Array.isArray(toProj)) {
    coord = toProj;
    toProj = fromProj;
    fromProj = wgs84;
    single = true;
  }
  toProj = checkProj(toProj);
  if (coord) {
    return transformer(fromProj, toProj, coord);
  }
  else {
    obj = {
      forward: function(coords) {
        return transformer(fromProj, toProj, coords);
      },
      inverse: function(coords) {
        return transformer(toProj, fromProj, coords);
      }
    };
    if (single) {
      obj.oProj = toProj;
    }
    return obj;
  }
}
/* harmony default export */ __webpack_exports__["a"] = (proj4);


/***/ }),
/* 1191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_values__ = __webpack_require__(28);


function datum(datumCode, datum_params, a, b, es, ep2) {
  var out = {};

  if (datumCode === undefined || datumCode === 'none') {
    out.datum_type = __WEBPACK_IMPORTED_MODULE_0__constants_values__["k" /* PJD_NODATUM */];
  } else {
    out.datum_type = __WEBPACK_IMPORTED_MODULE_0__constants_values__["l" /* PJD_WGS84 */];
  }

  if (datum_params) {
    out.datum_params = datum_params.map(parseFloat);
    if (out.datum_params[0] !== 0 || out.datum_params[1] !== 0 || out.datum_params[2] !== 0) {
      out.datum_type = __WEBPACK_IMPORTED_MODULE_0__constants_values__["h" /* PJD_3PARAM */];
    }
    if (out.datum_params.length > 3) {
      if (out.datum_params[3] !== 0 || out.datum_params[4] !== 0 || out.datum_params[5] !== 0 || out.datum_params[6] !== 0) {
        out.datum_type = __WEBPACK_IMPORTED_MODULE_0__constants_values__["i" /* PJD_7PARAM */];
        out.datum_params[3] *= __WEBPACK_IMPORTED_MODULE_0__constants_values__["f" /* SEC_TO_RAD */];
        out.datum_params[4] *= __WEBPACK_IMPORTED_MODULE_0__constants_values__["f" /* SEC_TO_RAD */];
        out.datum_params[5] *= __WEBPACK_IMPORTED_MODULE_0__constants_values__["f" /* SEC_TO_RAD */];
        out.datum_params[6] = (out.datum_params[6] / 1000000.0) + 1.0;
      }
    }
  }

  out.a = a; //datum object also uses these values
  out.b = b;
  out.es = es;
  out.ep2 = ep2;
  return out;
}

/* harmony default export */ __webpack_exports__["a"] = (datum);


/***/ }),
/* 1192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compareDatums;
/* harmony export (immutable) */ __webpack_exports__["b"] = geodeticToGeocentric;
/* harmony export (immutable) */ __webpack_exports__["e"] = geocentricToGeodetic;
/* harmony export (immutable) */ __webpack_exports__["c"] = geocentricToWgs84;
/* harmony export (immutable) */ __webpack_exports__["d"] = geocentricFromWgs84;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_values__ = __webpack_require__(28);


function compareDatums(source, dest) {
  if (source.datum_type !== dest.datum_type) {
    return false; // false, datums are not equal
  } else if (source.a !== dest.a || Math.abs(source.es - dest.es) > 0.000000000050) {
    // the tolerance for es is to ensure that GRS80 and WGS84
    // are considered identical
    return false;
  } else if (source.datum_type === __WEBPACK_IMPORTED_MODULE_0__constants_values__["h" /* PJD_3PARAM */]) {
    return (source.datum_params[0] === dest.datum_params[0] && source.datum_params[1] === dest.datum_params[1] && source.datum_params[2] === dest.datum_params[2]);
  } else if (source.datum_type === __WEBPACK_IMPORTED_MODULE_0__constants_values__["i" /* PJD_7PARAM */]) {
    return (source.datum_params[0] === dest.datum_params[0] && source.datum_params[1] === dest.datum_params[1] && source.datum_params[2] === dest.datum_params[2] && source.datum_params[3] === dest.datum_params[3] && source.datum_params[4] === dest.datum_params[4] && source.datum_params[5] === dest.datum_params[5] && source.datum_params[6] === dest.datum_params[6]);
  } else {
    return true; // datums are equal
  }
} // cs_compare_datums()

/*
 * The function Convert_Geodetic_To_Geocentric converts geodetic coordinates
 * (latitude, longitude, and height) to geocentric coordinates (X, Y, Z),
 * according to the current ellipsoid parameters.
 *
 *    Latitude  : Geodetic latitude in radians                     (input)
 *    Longitude : Geodetic longitude in radians                    (input)
 *    Height    : Geodetic height, in meters                       (input)
 *    X         : Calculated Geocentric X coordinate, in meters    (output)
 *    Y         : Calculated Geocentric Y coordinate, in meters    (output)
 *    Z         : Calculated Geocentric Z coordinate, in meters    (output)
 *
 */
function geodeticToGeocentric(p, es, a) {
  var Longitude = p.x;
  var Latitude = p.y;
  var Height = p.z ? p.z : 0; //Z value not always supplied

  var Rn; /*  Earth radius at location  */
  var Sin_Lat; /*  Math.sin(Latitude)  */
  var Sin2_Lat; /*  Square of Math.sin(Latitude)  */
  var Cos_Lat; /*  Math.cos(Latitude)  */

  /*
   ** Don't blow up if Latitude is just a little out of the value
   ** range as it may just be a rounding issue.  Also removed longitude
   ** test, it should be wrapped by Math.cos() and Math.sin().  NFW for PROJ.4, Sep/2001.
   */
  if (Latitude < -__WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */] && Latitude > -1.001 * __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */]) {
    Latitude = -__WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */];
  } else if (Latitude > __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */] && Latitude < 1.001 * __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */]) {
    Latitude = __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */];
  } else if ((Latitude < -__WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */]) || (Latitude > __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */])) {
    /* Latitude out of range */
    //..reportError('geocent:lat out of range:' + Latitude);
    return null;
  }

  if (Longitude > Math.PI) {
    Longitude -= (2 * Math.PI);
  }
  Sin_Lat = Math.sin(Latitude);
  Cos_Lat = Math.cos(Latitude);
  Sin2_Lat = Sin_Lat * Sin_Lat;
  Rn = a / (Math.sqrt(1.0e0 - es * Sin2_Lat));
  return {
    x: (Rn + Height) * Cos_Lat * Math.cos(Longitude),
    y: (Rn + Height) * Cos_Lat * Math.sin(Longitude),
    z: ((Rn * (1 - es)) + Height) * Sin_Lat
  };
} // cs_geodetic_to_geocentric()

function geocentricToGeodetic(p, es, a, b) {
  /* local defintions and variables */
  /* end-criterium of loop, accuracy of sin(Latitude) */
  var genau = 1e-12;
  var genau2 = (genau * genau);
  var maxiter = 30;

  var P; /* distance between semi-minor axis and location */
  var RR; /* distance between center and location */
  var CT; /* sin of geocentric latitude */
  var ST; /* cos of geocentric latitude */
  var RX;
  var RK;
  var RN; /* Earth radius at location */
  var CPHI0; /* cos of start or old geodetic latitude in iterations */
  var SPHI0; /* sin of start or old geodetic latitude in iterations */
  var CPHI; /* cos of searched geodetic latitude */
  var SPHI; /* sin of searched geodetic latitude */
  var SDPHI; /* end-criterium: addition-theorem of sin(Latitude(iter)-Latitude(iter-1)) */
  var iter; /* # of continous iteration, max. 30 is always enough (s.a.) */

  var X = p.x;
  var Y = p.y;
  var Z = p.z ? p.z : 0.0; //Z value not always supplied
  var Longitude;
  var Latitude;
  var Height;

  P = Math.sqrt(X * X + Y * Y);
  RR = Math.sqrt(X * X + Y * Y + Z * Z);

  /*      special cases for latitude and longitude */
  if (P / a < genau) {

    /*  special case, if P=0. (X=0., Y=0.) */
    Longitude = 0.0;

    /*  if (X,Y,Z)=(0.,0.,0.) then Height becomes semi-minor axis
     *  of ellipsoid (=center of mass), Latitude becomes PI/2 */
    if (RR / a < genau) {
      Latitude = __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */];
      Height = -b;
      return {
        x: p.x,
        y: p.y,
        z: p.z
      };
    }
  } else {
    /*  ellipsoidal (geodetic) longitude
     *  interval: -PI < Longitude <= +PI */
    Longitude = Math.atan2(Y, X);
  }

  /* --------------------------------------------------------------
   * Following iterative algorithm was developped by
   * "Institut for Erdmessung", University of Hannover, July 1988.
   * Internet: www.ife.uni-hannover.de
   * Iterative computation of CPHI,SPHI and Height.
   * Iteration of CPHI and SPHI to 10**-12 radian resp.
   * 2*10**-7 arcsec.
   * --------------------------------------------------------------
   */
  CT = Z / RR;
  ST = P / RR;
  RX = 1.0 / Math.sqrt(1.0 - es * (2.0 - es) * ST * ST);
  CPHI0 = ST * (1.0 - es) * RX;
  SPHI0 = CT * RX;
  iter = 0;

  /* loop to find sin(Latitude) resp. Latitude
   * until |sin(Latitude(iter)-Latitude(iter-1))| < genau */
  do {
    iter++;
    RN = a / Math.sqrt(1.0 - es * SPHI0 * SPHI0);

    /*  ellipsoidal (geodetic) height */
    Height = P * CPHI0 + Z * SPHI0 - RN * (1.0 - es * SPHI0 * SPHI0);

    RK = es * RN / (RN + Height);
    RX = 1.0 / Math.sqrt(1.0 - RK * (2.0 - RK) * ST * ST);
    CPHI = ST * (1.0 - RK) * RX;
    SPHI = CT * RX;
    SDPHI = SPHI * CPHI0 - CPHI * SPHI0;
    CPHI0 = CPHI;
    SPHI0 = SPHI;
  }
  while (SDPHI * SDPHI > genau2 && iter < maxiter);

  /*      ellipsoidal (geodetic) latitude */
  Latitude = Math.atan(SPHI / Math.abs(CPHI));
  return {
    x: Longitude,
    y: Latitude,
    z: Height
  };
} // cs_geocentric_to_geodetic()

/****************************************************************/
// pj_geocentic_to_wgs84( p )
//  p = point to transform in geocentric coordinates (x,y,z)


/** point object, nothing fancy, just allows values to be
    passed back and forth by reference rather than by value.
    Other point classes may be used as long as they have
    x and y properties, which will get modified in the transform method.
*/
function geocentricToWgs84(p, datum_type, datum_params) {

  if (datum_type === __WEBPACK_IMPORTED_MODULE_0__constants_values__["h" /* PJD_3PARAM */]) {
    // if( x[io] === HUGE_VAL )
    //    continue;
    return {
      x: p.x + datum_params[0],
      y: p.y + datum_params[1],
      z: p.z + datum_params[2],
    };
  } else if (datum_type === __WEBPACK_IMPORTED_MODULE_0__constants_values__["i" /* PJD_7PARAM */]) {
    var Dx_BF = datum_params[0];
    var Dy_BF = datum_params[1];
    var Dz_BF = datum_params[2];
    var Rx_BF = datum_params[3];
    var Ry_BF = datum_params[4];
    var Rz_BF = datum_params[5];
    var M_BF = datum_params[6];
    // if( x[io] === HUGE_VAL )
    //    continue;
    return {
      x: M_BF * (p.x - Rz_BF * p.y + Ry_BF * p.z) + Dx_BF,
      y: M_BF * (Rz_BF * p.x + p.y - Rx_BF * p.z) + Dy_BF,
      z: M_BF * (-Ry_BF * p.x + Rx_BF * p.y + p.z) + Dz_BF
    };
  }
} // cs_geocentric_to_wgs84

/****************************************************************/
// pj_geocentic_from_wgs84()
//  coordinate system definition,
//  point to transform in geocentric coordinates (x,y,z)
function geocentricFromWgs84(p, datum_type, datum_params) {

  if (datum_type === __WEBPACK_IMPORTED_MODULE_0__constants_values__["h" /* PJD_3PARAM */]) {
    //if( x[io] === HUGE_VAL )
    //    continue;
    return {
      x: p.x - datum_params[0],
      y: p.y - datum_params[1],
      z: p.z - datum_params[2],
    };

  } else if (datum_type === __WEBPACK_IMPORTED_MODULE_0__constants_values__["i" /* PJD_7PARAM */]) {
    var Dx_BF = datum_params[0];
    var Dy_BF = datum_params[1];
    var Dz_BF = datum_params[2];
    var Rx_BF = datum_params[3];
    var Ry_BF = datum_params[4];
    var Rz_BF = datum_params[5];
    var M_BF = datum_params[6];
    var x_tmp = (p.x - Dx_BF) / M_BF;
    var y_tmp = (p.y - Dy_BF) / M_BF;
    var z_tmp = (p.z - Dz_BF) / M_BF;
    //if( x[io] === HUGE_VAL )
    //    continue;

    return {
      x: x_tmp + Rz_BF * y_tmp - Ry_BF * z_tmp,
      y: -Rz_BF * x_tmp + y_tmp + Rx_BF * z_tmp,
      z: Ry_BF * x_tmp - Rx_BF * y_tmp + z_tmp
    };
  } //cs_geocentric_from_wgs84()
}


/***/ }),
/* 1193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_values__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__datumUtils__ = __webpack_require__(1192);



function checkParams(type) {
  return (type === __WEBPACK_IMPORTED_MODULE_0__constants_values__["h" /* PJD_3PARAM */] || type === __WEBPACK_IMPORTED_MODULE_0__constants_values__["i" /* PJD_7PARAM */]);
}

/* harmony default export */ __webpack_exports__["a"] = (function(source, dest, point) {
  // Short cut if the datums are identical.
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__datumUtils__["a" /* compareDatums */])(source, dest)) {
    return point; // in this case, zero is sucess,
    // whereas cs_compare_datums returns 1 to indicate TRUE
    // confusing, should fix this
  }

  // Explicitly skip datum transform by setting 'datum=none' as parameter for either source or dest
  if (source.datum_type === __WEBPACK_IMPORTED_MODULE_0__constants_values__["k" /* PJD_NODATUM */] || dest.datum_type === __WEBPACK_IMPORTED_MODULE_0__constants_values__["k" /* PJD_NODATUM */]) {
    return point;
  }

  // If this datum requires grid shifts, then apply it to geodetic coordinates.

  // Do we need to go through geocentric coordinates?
  if (source.es === dest.es && source.a === dest.a && !checkParams(source.datum_type) &&  !checkParams(dest.datum_type)) {
    return point;
  }

  // Convert to geocentric coordinates.
  point = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__datumUtils__["b" /* geodeticToGeocentric */])(point, source.es, source.a);
  // Convert between datums
  if (checkParams(source.datum_type)) {
    point = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__datumUtils__["c" /* geocentricToWgs84 */])(point, source.datum_type, source.datum_params);
  }
  if (checkParams(dest.datum_type)) {
    point = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__datumUtils__["d" /* geocentricFromWgs84 */])(point, dest.datum_type, dest.datum_params);
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__datumUtils__["e" /* geocentricToGeodetic */])(point, dest.es, dest.a, dest.b);

});


/***/ }),
/* 1194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = eccentricity;
/* harmony export (immutable) */ __webpack_exports__["a"] = sphere;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_values__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_Ellipsoid__ = __webpack_require__(1187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__match__ = __webpack_require__(219);




function eccentricity(a, b, rf, R_A) {
  var a2 = a * a; // used in geocentric
  var b2 = b * b; // used in geocentric
  var es = (a2 - b2) / a2; // e ^ 2
  var e = 0;
  if (R_A) {
    a *= 1 - es * (__WEBPACK_IMPORTED_MODULE_0__constants_values__["m" /* SIXTH */] + es * (__WEBPACK_IMPORTED_MODULE_0__constants_values__["n" /* RA4 */] + es * __WEBPACK_IMPORTED_MODULE_0__constants_values__["o" /* RA6 */]));
    a2 = a * a;
    es = 0;
  } else {
    e = Math.sqrt(es); // eccentricity
  }
  var ep2 = (a2 - b2) / b2; // used in geocentric
  return {
    es: es,
    e: e,
    ep2: ep2
  };
}
function sphere(a, b, rf, ellps, sphere) {
  if (!a) { // do we have an ellipsoid?
    var ellipse = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__match__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__constants_Ellipsoid__["a" /* default */], ellps);
    if (!ellipse) {
      ellipse = __WEBPACK_IMPORTED_MODULE_1__constants_Ellipsoid__["b" /* WGS84 */];
    }
    a = ellipse.a;
    b = ellipse.b;
    rf = ellipse.rf;
  }

  if (rf && !b) {
    b = (1.0 - 1.0 / rf) * a;
  }
  if (rf === 0 || Math.abs(a - b) < __WEBPACK_IMPORTED_MODULE_0__constants_values__["d" /* EPSLN */]) {
    sphere = true;
    b = a;
  }
  return {
    a: a,
    b: b,
    rf: rf,
    sphere: sphere
  };
}


/***/ }),
/* 1195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(destination, source) {
  destination = destination || {};
  var value, property;
  if (!source) {
    return destination;
  }
  for (property in source) {
    value = source[property];
    if (value !== undefined) {
      destination[property] = value;
    }
  }
  return destination;
});


/***/ }),
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(defs) {
  defs('EPSG:4326', "+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees");
  defs('EPSG:4269', "+title=NAD83 (long/lat) +proj=longlat +a=6378137.0 +b=6356752.31414036 +ellps=GRS80 +datum=NAD83 +units=degrees");
  defs('EPSG:3857', "+title=WGS 84 / Pseudo-Mercator +proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +no_defs");

  defs.WGS84 = defs['EPSG:4326'];
  defs['EPSG:3785'] = defs['EPSG:3857']; // maintain backward compat, official code is 3857
  defs.GOOGLE = defs['EPSG:3857'];
  defs['EPSG:900913'] = defs['EPSG:3857'];
  defs['EPSG:102113'] = defs['EPSG:3857'];
});


/***/ }),
/* 1197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defs__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_wkt_parser__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__projString__ = __webpack_require__(462);



function testObj(code){
  return typeof code === 'string';
}
function testDef(code){
  return code in __WEBPACK_IMPORTED_MODULE_0__defs__["a" /* default */];
}
 var codeWords = ['PROJECTEDCRS', 'PROJCRS', 'GEOGCS','GEOCCS','PROJCS','LOCAL_CS', 'GEODCRS', 'GEODETICCRS', 'GEODETICDATUM', 'ENGCRS', 'ENGINEERINGCRS']; 
function testWKT(code){
  return codeWords.some(function (word) {
    return code.indexOf(word) > -1;
  });
}
function testProj(code){
  return code[0] === '+';
}
function parse(code){
  if (testObj(code)) {
    //check to see if this is a WKT string
    if (testDef(code)) {
      return __WEBPACK_IMPORTED_MODULE_0__defs__["a" /* default */][code];
    }
    if (testWKT(code)) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_wkt_parser__["a" /* default */])(code);
    }
    if (testProj(code)) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__projString__["a" /* default */])(code);
    }
  }else{
    return code;
  }
}

/* harmony default export */ __webpack_exports__["a"] = (parse);


/***/ }),
/* 1198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export add */
/* unused harmony export get */
/* unused harmony export start */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__projections_merc__ = __webpack_require__(1211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__projections_longlat__ = __webpack_require__(1210);


var projs = [__WEBPACK_IMPORTED_MODULE_0__projections_merc__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__projections_longlat__["a" /* default */]];
var names = {};
var projStore = [];

function add(proj, i) {
  var len = projStore.length;
  if (!proj.names) {
    console.log(i);
    return true;
  }
  projStore[len] = proj;
  proj.names.forEach(function(n) {
    names[n.toLowerCase()] = len;
  });
  return this;
}



function get(name) {
  if (!name) {
    return false;
  }
  var n = name.toLowerCase();
  if (typeof names[n] !== 'undefined' && projStore[names[n]]) {
    return projStore[names[n]];
  }
}

function start() {
  projs.forEach(add);
}
/* harmony default export */ __webpack_exports__["a"] = ({
  start: start,
  add: add,
  get: get
});


/***/ }),
/* 1199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export init */
/* unused harmony export forward */
/* unused harmony export inverse */
/* unused harmony export phi1z */
/* unused harmony export names */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_msfnz__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_qsfnz__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_adjust_lon__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_asinz__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_values__ = __webpack_require__(28);






function init() {

  if (Math.abs(this.lat1 + this.lat2) < __WEBPACK_IMPORTED_MODULE_4__constants_values__["d" /* EPSLN */]) {
    return;
  }
  this.temp = this.b / this.a;
  this.es = 1 - Math.pow(this.temp, 2);
  this.e3 = Math.sqrt(this.es);

  this.sin_po = Math.sin(this.lat1);
  this.cos_po = Math.cos(this.lat1);
  this.t1 = this.sin_po;
  this.con = this.sin_po;
  this.ms1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_msfnz__["a" /* default */])(this.e3, this.sin_po, this.cos_po);
  this.qs1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_qsfnz__["a" /* default */])(this.e3, this.sin_po, this.cos_po);

  this.sin_po = Math.sin(this.lat2);
  this.cos_po = Math.cos(this.lat2);
  this.t2 = this.sin_po;
  this.ms2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_msfnz__["a" /* default */])(this.e3, this.sin_po, this.cos_po);
  this.qs2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_qsfnz__["a" /* default */])(this.e3, this.sin_po, this.cos_po);

  this.sin_po = Math.sin(this.lat0);
  this.cos_po = Math.cos(this.lat0);
  this.t3 = this.sin_po;
  this.qs0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_qsfnz__["a" /* default */])(this.e3, this.sin_po, this.cos_po);

  if (Math.abs(this.lat1 - this.lat2) > __WEBPACK_IMPORTED_MODULE_4__constants_values__["d" /* EPSLN */]) {
    this.ns0 = (this.ms1 * this.ms1 - this.ms2 * this.ms2) / (this.qs2 - this.qs1);
  }
  else {
    this.ns0 = this.con;
  }
  this.c = this.ms1 * this.ms1 + this.ns0 * this.qs1;
  this.rh = this.a * Math.sqrt(this.c - this.ns0 * this.qs0) / this.ns0;
}

/* Albers Conical Equal Area forward equations--mapping lat,long to x,y
  -------------------------------------------------------------------*/
function forward(p) {

  var lon = p.x;
  var lat = p.y;

  this.sin_phi = Math.sin(lat);
  this.cos_phi = Math.cos(lat);

  var qs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_qsfnz__["a" /* default */])(this.e3, this.sin_phi, this.cos_phi);
  var rh1 = this.a * Math.sqrt(this.c - this.ns0 * qs) / this.ns0;
  var theta = this.ns0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_adjust_lon__["a" /* default */])(lon - this.long0);
  var x = rh1 * Math.sin(theta) + this.x0;
  var y = this.rh - rh1 * Math.cos(theta) + this.y0;

  p.x = x;
  p.y = y;
  return p;
}

function inverse(p) {
  var rh1, qs, con, theta, lon, lat;

  p.x -= this.x0;
  p.y = this.rh - p.y + this.y0;
  if (this.ns0 >= 0) {
    rh1 = Math.sqrt(p.x * p.x + p.y * p.y);
    con = 1;
  }
  else {
    rh1 = -Math.sqrt(p.x * p.x + p.y * p.y);
    con = -1;
  }
  theta = 0;
  if (rh1 !== 0) {
    theta = Math.atan2(con * p.x, con * p.y);
  }
  con = rh1 * this.ns0 / this.a;
  if (this.sphere) {
    lat = Math.asin((this.c - con * con) / (2 * this.ns0));
  }
  else {
    qs = (this.c - con * con) / this.ns0;
    lat = this.phi1z(this.e3, qs);
  }

  lon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_adjust_lon__["a" /* default */])(theta / this.ns0 + this.long0);
  p.x = lon;
  p.y = lat;
  return p;
}

/* Function to compute phi1, the latitude for the inverse of the
   Albers Conical Equal-Area projection.
-------------------------------------------*/
function phi1z(eccent, qs) {
  var sinphi, cosphi, con, com, dphi;
  var phi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_asinz__["a" /* default */])(0.5 * qs);
  if (eccent < __WEBPACK_IMPORTED_MODULE_4__constants_values__["d" /* EPSLN */]) {
    return phi;
  }

  var eccnts = eccent * eccent;
  for (var i = 1; i <= 25; i++) {
    sinphi = Math.sin(phi);
    cosphi = Math.cos(phi);
    con = eccent * sinphi;
    com = 1 - con * con;
    dphi = 0.5 * com * com / cosphi * (qs / (1 - eccnts) - sinphi / com + 0.5 / eccent * Math.log((1 - con) / (1 + con)));
    phi = phi + dphi;
    if (Math.abs(dphi) <= 1e-7) {
      return phi;
    }
  }
  return null;
}

var names = ["Albers_Conic_Equal_Area", "Albers", "aea"];
/* harmony default export */ __webpack_exports__["a"] = ({
  init: init,
  forward: forward,
  inverse: inverse,
  names: names,
  phi1z: phi1z
});


/***/ }),
/* 1200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export init */
/* unused harmony export forward */
/* unused harmony export inverse */
/* unused harmony export names */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_adjust_lon__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_values__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_mlfn__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_e0fn__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_e1fn__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_e2fn__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_e3fn__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_gN__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_asinz__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_imlfn__ = __webpack_require__(216);














function init() {
  this.sin_p12 = Math.sin(this.lat0);
  this.cos_p12 = Math.cos(this.lat0);
}

function forward(p) {
  var lon = p.x;
  var lat = p.y;
  var sinphi = Math.sin(p.y);
  var cosphi = Math.cos(p.y);
  var dlon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_adjust_lon__["a" /* default */])(lon - this.long0);
  var e0, e1, e2, e3, Mlp, Ml, tanphi, Nl1, Nl, psi, Az, G, H, GH, Hs, c, kp, cos_c, s, s2, s3, s4, s5;
  if (this.sphere) {
    if (Math.abs(this.sin_p12 - 1) <= __WEBPACK_IMPORTED_MODULE_1__constants_values__["d" /* EPSLN */]) {
      //North Pole case
      p.x = this.x0 + this.a * (__WEBPACK_IMPORTED_MODULE_1__constants_values__["a" /* HALF_PI */] - lat) * Math.sin(dlon);
      p.y = this.y0 - this.a * (__WEBPACK_IMPORTED_MODULE_1__constants_values__["a" /* HALF_PI */] - lat) * Math.cos(dlon);
      return p;
    }
    else if (Math.abs(this.sin_p12 + 1) <= __WEBPACK_IMPORTED_MODULE_1__constants_values__["d" /* EPSLN */]) {
      //South Pole case
      p.x = this.x0 + this.a * (__WEBPACK_IMPORTED_MODULE_1__constants_values__["a" /* HALF_PI */] + lat) * Math.sin(dlon);
      p.y = this.y0 + this.a * (__WEBPACK_IMPORTED_MODULE_1__constants_values__["a" /* HALF_PI */] + lat) * Math.cos(dlon);
      return p;
    }
    else {
      //default case
      cos_c = this.sin_p12 * sinphi + this.cos_p12 * cosphi * Math.cos(dlon);
      c = Math.acos(cos_c);
      kp = c / Math.sin(c);
      p.x = this.x0 + this.a * kp * cosphi * Math.sin(dlon);
      p.y = this.y0 + this.a * kp * (this.cos_p12 * sinphi - this.sin_p12 * cosphi * Math.cos(dlon));
      return p;
    }
  }
  else {
    e0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_e0fn__["a" /* default */])(this.es);
    e1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_e1fn__["a" /* default */])(this.es);
    e2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_e2fn__["a" /* default */])(this.es);
    e3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_e3fn__["a" /* default */])(this.es);
    if (Math.abs(this.sin_p12 - 1) <= __WEBPACK_IMPORTED_MODULE_1__constants_values__["d" /* EPSLN */]) {
      //North Pole case
      Mlp = this.a * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_mlfn__["a" /* default */])(e0, e1, e2, e3, __WEBPACK_IMPORTED_MODULE_1__constants_values__["a" /* HALF_PI */]);
      Ml = this.a * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_mlfn__["a" /* default */])(e0, e1, e2, e3, lat);
      p.x = this.x0 + (Mlp - Ml) * Math.sin(dlon);
      p.y = this.y0 - (Mlp - Ml) * Math.cos(dlon);
      return p;
    }
    else if (Math.abs(this.sin_p12 + 1) <= __WEBPACK_IMPORTED_MODULE_1__constants_values__["d" /* EPSLN */]) {
      //South Pole case
      Mlp = this.a * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_mlfn__["a" /* default */])(e0, e1, e2, e3, __WEBPACK_IMPORTED_MODULE_1__constants_values__["a" /* HALF_PI */]);
      Ml = this.a * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_mlfn__["a" /* default */])(e0, e1, e2, e3, lat);
      p.x = this.x0 + (Mlp + Ml) * Math.sin(dlon);
      p.y = this.y0 + (Mlp + Ml) * Math.cos(dlon);
      return p;
    }
    else {
      //Default case
      tanphi = sinphi / cosphi;
      Nl1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_gN__["a" /* default */])(this.a, this.e, this.sin_p12);
      Nl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_gN__["a" /* default */])(this.a, this.e, sinphi);
      psi = Math.atan((1 - this.es) * tanphi + this.es * Nl1 * this.sin_p12 / (Nl * cosphi));
      Az = Math.atan2(Math.sin(dlon), this.cos_p12 * Math.tan(psi) - this.sin_p12 * Math.cos(dlon));
      if (Az === 0) {
        s = Math.asin(this.cos_p12 * Math.sin(psi) - this.sin_p12 * Math.cos(psi));
      }
      else if (Math.abs(Math.abs(Az) - Math.PI) <= __WEBPACK_IMPORTED_MODULE_1__constants_values__["d" /* EPSLN */]) {
        s = -Math.asin(this.cos_p12 * Math.sin(psi) - this.sin_p12 * Math.cos(psi));
      }
      else {
        s = Math.asin(Math.sin(dlon) * Math.cos(psi) / Math.sin(Az));
      }
      G = this.e * this.sin_p12 / Math.sqrt(1 - this.es);
      H = this.e * this.cos_p12 * Math.cos(Az) / Math.sqrt(1 - this.es);
      GH = G * H;
      Hs = H * H;
      s2 = s * s;
      s3 = s2 * s;
      s4 = s3 * s;
      s5 = s4 * s;
      c = Nl1 * s * (1 - s2 * Hs * (1 - Hs) / 6 + s3 / 8 * GH * (1 - 2 * Hs) + s4 / 120 * (Hs * (4 - 7 * Hs) - 3 * G * G * (1 - 7 * Hs)) - s5 / 48 * GH);
      p.x = this.x0 + c * Math.sin(Az);
      p.y = this.y0 + c * Math.cos(Az);
      return p;
    }
  }


}

function inverse(p) {
  p.x -= this.x0;
  p.y -= this.y0;
  var rh, z, sinz, cosz, lon, lat, con, e0, e1, e2, e3, Mlp, M, N1, psi, Az, cosAz, tmp, A, B, D, Ee, F;
  if (this.sphere) {
    rh = Math.sqrt(p.x * p.x + p.y * p.y);
    if (rh > (2 * __WEBPACK_IMPORTED_MODULE_1__constants_values__["a" /* HALF_PI */] * this.a)) {
      return;
    }
    z = rh / this.a;

    sinz = Math.sin(z);
    cosz = Math.cos(z);

    lon = this.long0;
    if (Math.abs(rh) <= __WEBPACK_IMPORTED_MODULE_1__constants_values__["d" /* EPSLN */]) {
      lat = this.lat0;
    }
    else {
      lat = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__common_asinz__["a" /* default */])(cosz * this.sin_p12 + (p.y * sinz * this.cos_p12) / rh);
      con = Math.abs(this.lat0) - __WEBPACK_IMPORTED_MODULE_1__constants_values__["a" /* HALF_PI */];
      if (Math.abs(con) <= __WEBPACK_IMPORTED_MODULE_1__constants_values__["d" /* EPSLN */]) {
        if (this.lat0 >= 0) {
          lon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_adjust_lon__["a" /* default */])(this.long0 + Math.atan2(p.x, - p.y));
        }
        else {
          lon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_adjust_lon__["a" /* default */])(this.long0 - Math.atan2(-p.x, p.y));
        }
      }
      else {
        /*con = cosz - this.sin_p12 * Math.sin(lat);
        if ((Math.abs(con) < EPSLN) && (Math.abs(p.x) < EPSLN)) {
          //no-op, just keep the lon value as is
        } else {
          var temp = Math.atan2((p.x * sinz * this.cos_p12), (con * rh));
          lon = adjust_lon(this.long0 + Math.atan2((p.x * sinz * this.cos_p12), (con * rh)));
        }*/
        lon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_adjust_lon__["a" /* default */])(this.long0 + Math.atan2(p.x * sinz, rh * this.cos_p12 * cosz - p.y * this.sin_p12 * sinz));
      }
    }

    p.x = lon;
    p.y = lat;
    return p;
  }
  else {
    e0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_e0fn__["a" /* default */])(this.es);
    e1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_e1fn__["a" /* default */])(this.es);
    e2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_e2fn__["a" /* default */])(this.es);
    e3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_e3fn__["a" /* default */])(this.es);
    if (Math.abs(this.sin_p12 - 1) <= __WEBPACK_IMPORTED_MODULE_1__constants_values__["d" /* EPSLN */]) {
      //North pole case
      Mlp = this.a * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_mlfn__["a" /* default */])(e0, e1, e2, e3, __WEBPACK_IMPORTED_MODULE_1__constants_values__["a" /* HALF_PI */]);
      rh = Math.sqrt(p.x * p.x + p.y * p.y);
      M = Mlp - rh;
      lat = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__common_imlfn__["a" /* default */])(M / this.a, e0, e1, e2, e3);
      lon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_adjust_lon__["a" /* default */])(this.long0 + Math.atan2(p.x, - 1 * p.y));
      p.x = lon;
      p.y = lat;
      return p;
    }
    else if (Math.abs(this.sin_p12 + 1) <= __WEBPACK_IMPORTED_MODULE_1__constants_values__["d" /* EPSLN */]) {
      //South pole case
      Mlp = this.a * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_mlfn__["a" /* default */])(e0, e1, e2, e3, __WEBPACK_IMPORTED_MODULE_1__constants_values__["a" /* HALF_PI */]);
      rh = Math.sqrt(p.x * p.x + p.y * p.y);
      M = rh - Mlp;

      lat = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__common_imlfn__["a" /* default */])(M / this.a, e0, e1, e2, e3);
      lon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_adjust_lon__["a" /* default */])(this.long0 + Math.atan2(p.x, p.y));
      p.x = lon;
      p.y = lat;
      return p;
    }
    else {
      //default case
      rh = Math.sqrt(p.x * p.x + p.y * p.y);
      Az = Math.atan2(p.x, p.y);
      N1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_gN__["a" /* default */])(this.a, this.e, this.sin_p12);
      cosAz = Math.cos(Az);
      tmp = this.e * this.cos_p12 * cosAz;
      A = -tmp * tmp / (1 - this.es);
      B = 3 * this.es * (1 - A) * this.sin_p12 * this.cos_p12 * cosAz / (1 - this.es);
      D = rh / N1;
      Ee = D - A * (1 + A) * Math.pow(D, 3) / 6 - B * (1 + 3 * A) * Math.pow(D, 4) / 24;
      F = 1 - A * Ee * Ee / 2 - D * Ee * Ee * Ee / 6;
      psi = Math.asin(this.sin_p12 * Math.cos(Ee) + this.cos_p12 * Math.sin(Ee) * cosAz);
      lon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_adjust_lon__["a" /* default */])(this.long0 + Math.asin(Math.sin(Az) * Math.sin(Ee) / Math.cos(psi)));
      lat = Math.atan((1 - this.es * F * this.sin_p12 / Math.sin(psi)) * Math.tan(psi) / (1 - this.es));
      p.x = lon;
      p.y = lat;
      return p;
    }
  }

}

var names = ["Azimuthal_Equidistant", "aeqd"];
/* harmony default export */ __webpack_exports__["a"] = ({
  init: init,
  forward: forward,
  inverse: inverse,
  names: names
});


/***/ }),
/* 1201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export init */
/* unused harmony export forward */
/* unused harmony export inverse */
/* unused harmony export names */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_mlfn__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_e0fn__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_e1fn__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_e2fn__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_e3fn__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_gN__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_adjust_lon__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_adjust_lat__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_imlfn__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_values__ = __webpack_require__(28);











function init() {
  if (!this.sphere) {
    this.e0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_e0fn__["a" /* default */])(this.es);
    this.e1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_e1fn__["a" /* default */])(this.es);
    this.e2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_e2fn__["a" /* default */])(this.es);
    this.e3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_e3fn__["a" /* default */])(this.es);
    this.ml0 = this.a * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_mlfn__["a" /* default */])(this.e0, this.e1, this.e2, this.e3, this.lat0);
  }
}

/* Cassini forward equations--mapping lat,long to x,y
  -----------------------------------------------------------------------*/
function forward(p) {

  /* Forward equations
      -----------------*/
  var x, y;
  var lam = p.x;
  var phi = p.y;
  lam = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_adjust_lon__["a" /* default */])(lam - this.long0);

  if (this.sphere) {
    x = this.a * Math.asin(Math.cos(phi) * Math.sin(lam));
    y = this.a * (Math.atan2(Math.tan(phi), Math.cos(lam)) - this.lat0);
  }
  else {
    //ellipsoid
    var sinphi = Math.sin(phi);
    var cosphi = Math.cos(phi);
    var nl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_gN__["a" /* default */])(this.a, this.e, sinphi);
    var tl = Math.tan(phi) * Math.tan(phi);
    var al = lam * Math.cos(phi);
    var asq = al * al;
    var cl = this.es * cosphi * cosphi / (1 - this.es);
    var ml = this.a * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_mlfn__["a" /* default */])(this.e0, this.e1, this.e2, this.e3, phi);

    x = nl * al * (1 - asq * tl * (1 / 6 - (8 - tl + 8 * cl) * asq / 120));
    y = ml - this.ml0 + nl * sinphi / cosphi * asq * (0.5 + (5 - tl + 6 * cl) * asq / 24);


  }

  p.x = x + this.x0;
  p.y = y + this.y0;
  return p;
}

/* Inverse equations
  -----------------*/
function inverse(p) {
  p.x -= this.x0;
  p.y -= this.y0;
  var x = p.x / this.a;
  var y = p.y / this.a;
  var phi, lam;

  if (this.sphere) {
    var dd = y + this.lat0;
    phi = Math.asin(Math.sin(dd) * Math.cos(x));
    lam = Math.atan2(Math.tan(x), Math.cos(dd));
  }
  else {
    /* ellipsoid */
    var ml1 = this.ml0 / this.a + y;
    var phi1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__common_imlfn__["a" /* default */])(ml1, this.e0, this.e1, this.e2, this.e3);
    if (Math.abs(Math.abs(phi1) - __WEBPACK_IMPORTED_MODULE_9__constants_values__["a" /* HALF_PI */]) <= __WEBPACK_IMPORTED_MODULE_9__constants_values__["d" /* EPSLN */]) {
      p.x = this.long0;
      p.y = __WEBPACK_IMPORTED_MODULE_9__constants_values__["a" /* HALF_PI */];
      if (y < 0) {
        p.y *= -1;
      }
      return p;
    }
    var nl1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_gN__["a" /* default */])(this.a, this.e, Math.sin(phi1));

    var rl1 = nl1 * nl1 * nl1 / this.a / this.a * (1 - this.es);
    var tl1 = Math.pow(Math.tan(phi1), 2);
    var dl = x * this.a / nl1;
    var dsq = dl * dl;
    phi = phi1 - nl1 * Math.tan(phi1) / rl1 * dl * dl * (0.5 - (1 + 3 * tl1) * dl * dl / 24);
    lam = dl * (1 - dsq * (tl1 / 3 + (1 + 3 * tl1) * tl1 * dsq / 15)) / Math.cos(phi1);

  }

  p.x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_adjust_lon__["a" /* default */])(lam + this.long0);
  p.y = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_adjust_lat__["a" /* default */])(phi);
  return p;

}

var names = ["Cassini", "Cassini_Soldner", "cass"];
/* harmony default export */ __webpack_exports__["a"] = ({
  init: init,
  forward: forward,
  inverse: inverse,
  names: names
});


/***/ }),
/* 1202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export init */
/* unused harmony export forward */
/* unused harmony export inverse */
/* unused harmony export names */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_adjust_lon__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_qsfnz__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_msfnz__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_iqsfnz__ = __webpack_require__(1183);





/*
  reference:
    "Cartographic Projection Procedures for the UNIX Environment-
    A User's Manual" by Gerald I. Evenden,
    USGS Open File Report 90-284and Release 4 Interim Reports (2003)
*/
function init() {
  //no-op
  if (!this.sphere) {
    this.k0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_msfnz__["a" /* default */])(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts));
  }
}

/* Cylindrical Equal Area forward equations--mapping lat,long to x,y
    ------------------------------------------------------------*/
function forward(p) {
  var lon = p.x;
  var lat = p.y;
  var x, y;
  /* Forward equations
      -----------------*/
  var dlon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_adjust_lon__["a" /* default */])(lon - this.long0);
  if (this.sphere) {
    x = this.x0 + this.a * dlon * Math.cos(this.lat_ts);
    y = this.y0 + this.a * Math.sin(lat) / Math.cos(this.lat_ts);
  }
  else {
    var qs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_qsfnz__["a" /* default */])(this.e, Math.sin(lat));
    x = this.x0 + this.a * this.k0 * dlon;
    y = this.y0 + this.a * qs * 0.5 / this.k0;
  }

  p.x = x;
  p.y = y;
  return p;
}

/* Cylindrical Equal Area inverse equations--mapping x,y to lat/long
    ------------------------------------------------------------*/
function inverse(p) {
  p.x -= this.x0;
  p.y -= this.y0;
  var lon, lat;

  if (this.sphere) {
    lon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_adjust_lon__["a" /* default */])(this.long0 + (p.x / this.a) / Math.cos(this.lat_ts));
    lat = Math.asin((p.y / this.a) * Math.cos(this.lat_ts));
  }
  else {
    lat = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_iqsfnz__["a" /* default */])(this.e, 2 * p.y * this.k0 / this.a);
    lon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_adjust_lon__["a" /* default */])(this.long0 + p.x / (this.a * this.k0));
  }

  p.x = lon;
  p.y = lat;
  return p;
}

var names = ["cea"];
/* harmony default export */ __webpack_exports__["a"] = ({
  init: init,
  forward: forward,
  inverse: inverse,
  names: names
});


/***/ }),
/* 1203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export init */
/* unused harmony export forward */
/* unused harmony export inverse */
/* unused harmony export names */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_adjust_lon__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_adjust_lat__ = __webpack_require__(113);



function init() {

  this.x0 = this.x0 || 0;
  this.y0 = this.y0 || 0;
  this.lat0 = this.lat0 || 0;
  this.long0 = this.long0 || 0;
  this.lat_ts = this.lat_ts || 0;
  this.title = this.title || "Equidistant Cylindrical (Plate Carre)";

  this.rc = Math.cos(this.lat_ts);
}

// forward equations--mapping lat,long to x,y
// -----------------------------------------------------------------
function forward(p) {

  var lon = p.x;
  var lat = p.y;

  var dlon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_adjust_lon__["a" /* default */])(lon - this.long0);
  var dlat = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_adjust_lat__["a" /* default */])(lat - this.lat0);
  p.x = this.x0 + (this.a * dlon * this.rc);
  p.y = this.y0 + (this.a * dlat);
  return p;
}

// inverse equations--mapping x,y to lat/long
// -----------------------------------------------------------------
function inverse(p) {

  var x = p.x;
  var y = p.y;

  p.x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_adjust_lon__["a" /* default */])(this.long0 + ((x - this.x0) / (this.a * this.rc)));
  p.y = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_adjust_lat__["a" /* default */])(this.lat0 + ((y - this.y0) / (this.a)));
  return p;
}

var names = ["Equirectangular", "Equidistant_Cylindrical", "eqc"];
/* harmony default export */ __webpack_exports__["a"] = ({
  init: init,
  forward: forward,
  inverse: inverse,
  names: names
});


/***/ }),
/* 1204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export init */
/* unused harmony export forward */
/* unused harmony export inverse */
/* unused harmony export names */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_e0fn__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_e1fn__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_e2fn__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_e3fn__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_msfnz__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_mlfn__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_adjust_lon__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_adjust_lat__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_imlfn__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_values__ = __webpack_require__(28);











function init() {

  /* Place parameters in static storage for common use
      -------------------------------------------------*/
  // Standard Parallels cannot be equal and on opposite sides of the equator
  if (Math.abs(this.lat1 + this.lat2) < __WEBPACK_IMPORTED_MODULE_9__constants_values__["d" /* EPSLN */]) {
    return;
  }
  this.lat2 = this.lat2 || this.lat1;
  this.temp = this.b / this.a;
  this.es = 1 - Math.pow(this.temp, 2);
  this.e = Math.sqrt(this.es);
  this.e0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_e0fn__["a" /* default */])(this.es);
  this.e1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_e1fn__["a" /* default */])(this.es);
  this.e2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_e2fn__["a" /* default */])(this.es);
  this.e3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_e3fn__["a" /* default */])(this.es);

  this.sinphi = Math.sin(this.lat1);
  this.cosphi = Math.cos(this.lat1);

  this.ms1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_msfnz__["a" /* default */])(this.e, this.sinphi, this.cosphi);
  this.ml1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_mlfn__["a" /* default */])(this.e0, this.e1, this.e2, this.e3, this.lat1);

  if (Math.abs(this.lat1 - this.lat2) < __WEBPACK_IMPORTED_MODULE_9__constants_values__["d" /* EPSLN */]) {
    this.ns = this.sinphi;
  }
  else {
    this.sinphi = Math.sin(this.lat2);
    this.cosphi = Math.cos(this.lat2);
    this.ms2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_msfnz__["a" /* default */])(this.e, this.sinphi, this.cosphi);
    this.ml2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_mlfn__["a" /* default */])(this.e0, this.e1, this.e2, this.e3, this.lat2);
    this.ns = (this.ms1 - this.ms2) / (this.ml2 - this.ml1);
  }
  this.g = this.ml1 + this.ms1 / this.ns;
  this.ml0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_mlfn__["a" /* default */])(this.e0, this.e1, this.e2, this.e3, this.lat0);
  this.rh = this.a * (this.g - this.ml0);
}

/* Equidistant Conic forward equations--mapping lat,long to x,y
  -----------------------------------------------------------*/
function forward(p) {
  var lon = p.x;
  var lat = p.y;
  var rh1;

  /* Forward equations
      -----------------*/
  if (this.sphere) {
    rh1 = this.a * (this.g - lat);
  }
  else {
    var ml = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_mlfn__["a" /* default */])(this.e0, this.e1, this.e2, this.e3, lat);
    rh1 = this.a * (this.g - ml);
  }
  var theta = this.ns * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_adjust_lon__["a" /* default */])(lon - this.long0);
  var x = this.x0 + rh1 * Math.sin(theta);
  var y = this.y0 + this.rh - rh1 * Math.cos(theta);
  p.x = x;
  p.y = y;
  return p;
}

/* Inverse equations
  -----------------*/
function inverse(p) {
  p.x -= this.x0;
  p.y = this.rh - p.y + this.y0;
  var con, rh1, lat, lon;
  if (this.ns >= 0) {
    rh1 = Math.sqrt(p.x * p.x + p.y * p.y);
    con = 1;
  }
  else {
    rh1 = -Math.sqrt(p.x * p.x + p.y * p.y);
    con = -1;
  }
  var theta = 0;
  if (rh1 !== 0) {
    theta = Math.atan2(con * p.x, con * p.y);
  }

  if (this.sphere) {
    lon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_adjust_lon__["a" /* default */])(this.long0 + theta / this.ns);
    lat = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__common_adjust_lat__["a" /* default */])(this.g - rh1 / this.a);
    p.x = lon;
    p.y = lat;
    return p;
  }
  else {
    var ml = this.g - rh1 / this.a;
    lat = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__common_imlfn__["a" /* default */])(ml, this.e0, this.e1, this.e2, this.e3);
    lon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_adjust_lon__["a" /* default */])(this.long0 + theta / this.ns);
    p.x = lon;
    p.y = lat;
    return p;
  }

}

var names = ["Equidistant_Conic", "eqdc"];
/* harmony default export */ __webpack_exports__["a"] = ({
  init: init,
  forward: forward,
  inverse: inverse,
  names: names
});


/***/ }),
/* 1205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export init */
/* unused harmony export forward */
/* unused harmony export inverse */
/* unused harmony export names */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_srat__ = __webpack_require__(1185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_values__ = __webpack_require__(28);

var MAX_ITER = 20;


function init() {
  var sphi = Math.sin(this.lat0);
  var cphi = Math.cos(this.lat0);
  cphi *= cphi;
  this.rc = Math.sqrt(1 - this.es) / (1 - this.es * sphi * sphi);
  this.C = Math.sqrt(1 + this.es * cphi * cphi / (1 - this.es));
  this.phic0 = Math.asin(sphi / this.C);
  this.ratexp = 0.5 * this.C * this.e;
  this.K = Math.tan(0.5 * this.phic0 + __WEBPACK_IMPORTED_MODULE_1__constants_values__["b" /* FORTPI */]) / (Math.pow(Math.tan(0.5 * this.lat0 + __WEBPACK_IMPORTED_MODULE_1__constants_values__["b" /* FORTPI */]), this.C) * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_srat__["a" /* default */])(this.e * sphi, this.ratexp));
}

function forward(p) {
  var lon = p.x;
  var lat = p.y;

  p.y = 2 * Math.atan(this.K * Math.pow(Math.tan(0.5 * lat + __WEBPACK_IMPORTED_MODULE_1__constants_values__["b" /* FORTPI */]), this.C) * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_srat__["a" /* default */])(this.e * Math.sin(lat), this.ratexp)) - __WEBPACK_IMPORTED_MODULE_1__constants_values__["a" /* HALF_PI */];
  p.x = this.C * lon;
  return p;
}

function inverse(p) {
  var DEL_TOL = 1e-14;
  var lon = p.x / this.C;
  var lat = p.y;
  var num = Math.pow(Math.tan(0.5 * lat + __WEBPACK_IMPORTED_MODULE_1__constants_values__["b" /* FORTPI */]) / this.K, 1 / this.C);
  for (var i = MAX_ITER; i > 0; --i) {
    lat = 2 * Math.atan(num * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_srat__["a" /* default */])(this.e * Math.sin(p.y), - 0.5 * this.e)) - __WEBPACK_IMPORTED_MODULE_1__constants_values__["a" /* HALF_PI */];
    if (Math.abs(lat - p.y) < DEL_TOL) {
      break;
    }
    p.y = lat;
  }
  /* convergence failed */
  if (!i) {
    return null;
  }
  p.x = lon;
  p.y = lat;
  return p;
}

var names = ["gauss"];
/* harmony default export */ __webpack_exports__["a"] = ({
  init: init,
  forward: forward,
  inverse: inverse,
  names: names
});


/***/ }),
/* 1206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export init */
/* unused harmony export forward */
/* unused harmony export inverse */
/* unused harmony export names */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_adjust_lon__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_asinz__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_values__ = __webpack_require__(28);




/*
  reference:
    Wolfram Mathworld "Gnomonic Projection"
    http://mathworld.wolfram.com/GnomonicProjection.html
    Accessed: 12th November 2009
  */
function init() {

  /* Place parameters in static storage for common use
      -------------------------------------------------*/
  this.sin_p14 = Math.sin(this.lat0);
  this.cos_p14 = Math.cos(this.lat0);
  // Approximation for projecting points to the horizon (infinity)
  this.infinity_dist = 1000 * this.a;
  this.rc = 1;
}

/* Gnomonic forward equations--mapping lat,long to x,y
    ---------------------------------------------------*/
function forward(p) {
  var sinphi, cosphi; /* sin and cos value        */
  var dlon; /* delta longitude value      */
  var coslon; /* cos of longitude        */
  var ksp; /* scale factor          */
  var g;
  var x, y;
  var lon = p.x;
  var lat = p.y;
  /* Forward equations
      -----------------*/
  dlon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_adjust_lon__["a" /* default */])(lon - this.long0);

  sinphi = Math.sin(lat);
  cosphi = Math.cos(lat);

  coslon = Math.cos(dlon);
  g = this.sin_p14 * sinphi + this.cos_p14 * cosphi * coslon;
  ksp = 1;
  if ((g > 0) || (Math.abs(g) <= __WEBPACK_IMPORTED_MODULE_2__constants_values__["d" /* EPSLN */])) {
    x = this.x0 + this.a * ksp * cosphi * Math.sin(dlon) / g;
    y = this.y0 + this.a * ksp * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon) / g;
  }
  else {

    // Point is in the opposing hemisphere and is unprojectable
    // We still need to return a reasonable point, so we project
    // to infinity, on a bearing
    // equivalent to the northern hemisphere equivalent
    // This is a reasonable approximation for short shapes and lines that
    // straddle the horizon.

    x = this.x0 + this.infinity_dist * cosphi * Math.sin(dlon);
    y = this.y0 + this.infinity_dist * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon);

  }
  p.x = x;
  p.y = y;
  return p;
}

function inverse(p) {
  var rh; /* Rho */
  var sinc, cosc;
  var c;
  var lon, lat;

  /* Inverse equations
      -----------------*/
  p.x = (p.x - this.x0) / this.a;
  p.y = (p.y - this.y0) / this.a;

  p.x /= this.k0;
  p.y /= this.k0;

  if ((rh = Math.sqrt(p.x * p.x + p.y * p.y))) {
    c = Math.atan2(rh, this.rc);
    sinc = Math.sin(c);
    cosc = Math.cos(c);

    lat = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_asinz__["a" /* default */])(cosc * this.sin_p14 + (p.y * sinc * this.cos_p14) / rh);
    lon = Math.atan2(p.x * sinc, rh * this.cos_p14 * cosc - p.y * this.sin_p14 * sinc);
    lon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_adjust_lon__["a" /* default */])(this.long0 + lon);
  }
  else {
    lat = this.phic0;
    lon = 0;
  }

  p.x = lon;
  p.y = lat;
  return p;
}

var names = ["gnom"];
/* harmony default export */ __webpack_exports__["a"] = ({
  init: init,
  forward: forward,
  inverse: inverse,
  names: names
});


/***/ }),
/* 1207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export init */
/* unused harmony export forward */
/* unused harmony export inverse */
/* unused harmony export names */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_adjust_lon__ = __webpack_require__(33);


function init() {
  this.a = 6377397.155;
  this.es = 0.006674372230614;
  this.e = Math.sqrt(this.es);
  if (!this.lat0) {
    this.lat0 = 0.863937979737193;
  }
  if (!this.long0) {
    this.long0 = 0.7417649320975901 - 0.308341501185665;
  }
  /* if scale not set default to 0.9999 */
  if (!this.k0) {
    this.k0 = 0.9999;
  }
  this.s45 = 0.785398163397448; /* 45 */
  this.s90 = 2 * this.s45;
  this.fi0 = this.lat0;
  this.e2 = this.es;
  this.e = Math.sqrt(this.e2);
  this.alfa = Math.sqrt(1 + (this.e2 * Math.pow(Math.cos(this.fi0), 4)) / (1 - this.e2));
  this.uq = 1.04216856380474;
  this.u0 = Math.asin(Math.sin(this.fi0) / this.alfa);
  this.g = Math.pow((1 + this.e * Math.sin(this.fi0)) / (1 - this.e * Math.sin(this.fi0)), this.alfa * this.e / 2);
  this.k = Math.tan(this.u0 / 2 + this.s45) / Math.pow(Math.tan(this.fi0 / 2 + this.s45), this.alfa) * this.g;
  this.k1 = this.k0;
  this.n0 = this.a * Math.sqrt(1 - this.e2) / (1 - this.e2 * Math.pow(Math.sin(this.fi0), 2));
  this.s0 = 1.37008346281555;
  this.n = Math.sin(this.s0);
  this.ro0 = this.k1 * this.n0 / Math.tan(this.s0);
  this.ad = this.s90 - this.uq;
}

/* ellipsoid */
/* calculate xy from lat/lon */
/* Constants, identical to inverse transform function */
function forward(p) {
  var gfi, u, deltav, s, d, eps, ro;
  var lon = p.x;
  var lat = p.y;
  var delta_lon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_adjust_lon__["a" /* default */])(lon - this.long0);
  /* Transformation */
  gfi = Math.pow(((1 + this.e * Math.sin(lat)) / (1 - this.e * Math.sin(lat))), (this.alfa * this.e / 2));
  u = 2 * (Math.atan(this.k * Math.pow(Math.tan(lat / 2 + this.s45), this.alfa) / gfi) - this.s45);
  deltav = -delta_lon * this.alfa;
  s = Math.asin(Math.cos(this.ad) * Math.sin(u) + Math.sin(this.ad) * Math.cos(u) * Math.cos(deltav));
  d = Math.asin(Math.cos(u) * Math.sin(deltav) / Math.cos(s));
  eps = this.n * d;
  ro = this.ro0 * Math.pow(Math.tan(this.s0 / 2 + this.s45), this.n) / Math.pow(Math.tan(s / 2 + this.s45), this.n);
  p.y = ro * Math.cos(eps) / 1;
  p.x = ro * Math.sin(eps) / 1;

  if (!this.czech) {
    p.y *= -1;
    p.x *= -1;
  }
  return (p);
}

/* calculate lat/lon from xy */
function inverse(p) {
  var u, deltav, s, d, eps, ro, fi1;
  var ok;

  /* Transformation */
  /* revert y, x*/
  var tmp = p.x;
  p.x = p.y;
  p.y = tmp;
  if (!this.czech) {
    p.y *= -1;
    p.x *= -1;
  }
  ro = Math.sqrt(p.x * p.x + p.y * p.y);
  eps = Math.atan2(p.y, p.x);
  d = eps / Math.sin(this.s0);
  s = 2 * (Math.atan(Math.pow(this.ro0 / ro, 1 / this.n) * Math.tan(this.s0 / 2 + this.s45)) - this.s45);
  u = Math.asin(Math.cos(this.ad) * Math.sin(s) - Math.sin(this.ad) * Math.cos(s) * Math.cos(d));
  deltav = Math.asin(Math.cos(s) * Math.sin(d) / Math.cos(u));
  p.x = this.long0 - deltav / this.alfa;
  fi1 = u;
  ok = 0;
  var iter = 0;
  do {
    p.y = 2 * (Math.atan(Math.pow(this.k, - 1 / this.alfa) * Math.pow(Math.tan(u / 2 + this.s45), 1 / this.alfa) * Math.pow((1 + this.e * Math.sin(fi1)) / (1 - this.e * Math.sin(fi1)), this.e / 2)) - this.s45);
    if (Math.abs(fi1 - p.y) < 0.0000000001) {
      ok = 1;
    }
    fi1 = p.y;
    iter += 1;
  } while (ok === 0 && iter < 15);
  if (iter >= 15) {
    return null;
  }

  return (p);
}

var names = ["Krovak", "krovak"];
/* harmony default export */ __webpack_exports__["a"] = ({
  init: init,
  forward: forward,
  inverse: inverse,
  names: names
});


/***/ }),
/* 1208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export S_POLE */
/* unused harmony export N_POLE */
/* unused harmony export EQUIT */
/* unused harmony export OBLIQ */
/* unused harmony export init */
/* unused harmony export forward */
/* unused harmony export inverse */
/* unused harmony export names */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_values__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_qsfnz__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_adjust_lon__ = __webpack_require__(33);






/*
  reference
    "New Equal-Area Map Projections for Noncircular Regions", John P. Snyder,
    The American Cartographer, Vol 15, No. 4, October 1988, pp. 341-355.
  */

var S_POLE = 1;

var N_POLE = 2;
var EQUIT = 3;
var OBLIQ = 4;

/* Initialize the Lambert Azimuthal Equal Area projection
  ------------------------------------------------------*/
function init() {
  var t = Math.abs(this.lat0);
  if (Math.abs(t - __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */]) < __WEBPACK_IMPORTED_MODULE_0__constants_values__["d" /* EPSLN */]) {
    this.mode = this.lat0 < 0 ? this.S_POLE : this.N_POLE;
  }
  else if (Math.abs(t) < __WEBPACK_IMPORTED_MODULE_0__constants_values__["d" /* EPSLN */]) {
    this.mode = this.EQUIT;
  }
  else {
    this.mode = this.OBLIQ;
  }
  if (this.es > 0) {
    var sinphi;

    this.qp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_qsfnz__["a" /* default */])(this.e, 1);
    this.mmf = 0.5 / (1 - this.es);
    this.apa = authset(this.es);
    switch (this.mode) {
    case this.N_POLE:
      this.dd = 1;
      break;
    case this.S_POLE:
      this.dd = 1;
      break;
    case this.EQUIT:
      this.rq = Math.sqrt(0.5 * this.qp);
      this.dd = 1 / this.rq;
      this.xmf = 1;
      this.ymf = 0.5 * this.qp;
      break;
    case this.OBLIQ:
      this.rq = Math.sqrt(0.5 * this.qp);
      sinphi = Math.sin(this.lat0);
      this.sinb1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_qsfnz__["a" /* default */])(this.e, sinphi) / this.qp;
      this.cosb1 = Math.sqrt(1 - this.sinb1 * this.sinb1);
      this.dd = Math.cos(this.lat0) / (Math.sqrt(1 - this.es * sinphi * sinphi) * this.rq * this.cosb1);
      this.ymf = (this.xmf = this.rq) / this.dd;
      this.xmf *= this.dd;
      break;
    }
  }
  else {
    if (this.mode === this.OBLIQ) {
      this.sinph0 = Math.sin(this.lat0);
      this.cosph0 = Math.cos(this.lat0);
    }
  }
}

/* Lambert Azimuthal Equal Area forward equations--mapping lat,long to x,y
  -----------------------------------------------------------------------*/
function forward(p) {

  /* Forward equations
      -----------------*/
  var x, y, coslam, sinlam, sinphi, q, sinb, cosb, b, cosphi;
  var lam = p.x;
  var phi = p.y;

  lam = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_adjust_lon__["a" /* default */])(lam - this.long0);
  if (this.sphere) {
    sinphi = Math.sin(phi);
    cosphi = Math.cos(phi);
    coslam = Math.cos(lam);
    if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
      y = (this.mode === this.EQUIT) ? 1 + cosphi * coslam : 1 + this.sinph0 * sinphi + this.cosph0 * cosphi * coslam;
      if (y <= __WEBPACK_IMPORTED_MODULE_0__constants_values__["d" /* EPSLN */]) {
        return null;
      }
      y = Math.sqrt(2 / y);
      x = y * cosphi * Math.sin(lam);
      y *= (this.mode === this.EQUIT) ? sinphi : this.cosph0 * sinphi - this.sinph0 * cosphi * coslam;
    }
    else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
      if (this.mode === this.N_POLE) {
        coslam = -coslam;
      }
      if (Math.abs(phi + this.phi0) < __WEBPACK_IMPORTED_MODULE_0__constants_values__["d" /* EPSLN */]) {
        return null;
      }
      y = __WEBPACK_IMPORTED_MODULE_0__constants_values__["b" /* FORTPI */] - phi * 0.5;
      y = 2 * ((this.mode === this.S_POLE) ? Math.cos(y) : Math.sin(y));
      x = y * Math.sin(lam);
      y *= coslam;
    }
  }
  else {
    sinb = 0;
    cosb = 0;
    b = 0;
    coslam = Math.cos(lam);
    sinlam = Math.sin(lam);
    sinphi = Math.sin(phi);
    q = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_qsfnz__["a" /* default */])(this.e, sinphi);
    if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
      sinb = q / this.qp;
      cosb = Math.sqrt(1 - sinb * sinb);
    }
    switch (this.mode) {
    case this.OBLIQ:
      b = 1 + this.sinb1 * sinb + this.cosb1 * cosb * coslam;
      break;
    case this.EQUIT:
      b = 1 + cosb * coslam;
      break;
    case this.N_POLE:
      b = __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */] + phi;
      q = this.qp - q;
      break;
    case this.S_POLE:
      b = phi - __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */];
      q = this.qp + q;
      break;
    }
    if (Math.abs(b) < __WEBPACK_IMPORTED_MODULE_0__constants_values__["d" /* EPSLN */]) {
      return null;
    }
    switch (this.mode) {
    case this.OBLIQ:
    case this.EQUIT:
      b = Math.sqrt(2 / b);
      if (this.mode === this.OBLIQ) {
        y = this.ymf * b * (this.cosb1 * sinb - this.sinb1 * cosb * coslam);
      }
      else {
        y = (b = Math.sqrt(2 / (1 + cosb * coslam))) * sinb * this.ymf;
      }
      x = this.xmf * b * cosb * sinlam;
      break;
    case this.N_POLE:
    case this.S_POLE:
      if (q >= 0) {
        x = (b = Math.sqrt(q)) * sinlam;
        y = coslam * ((this.mode === this.S_POLE) ? b : -b);
      }
      else {
        x = y = 0;
      }
      break;
    }
  }

  p.x = this.a * x + this.x0;
  p.y = this.a * y + this.y0;
  return p;
}

/* Inverse equations
  -----------------*/
function inverse(p) {
  p.x -= this.x0;
  p.y -= this.y0;
  var x = p.x / this.a;
  var y = p.y / this.a;
  var lam, phi, cCe, sCe, q, rho, ab;
  if (this.sphere) {
    var cosz = 0,
      rh, sinz = 0;

    rh = Math.sqrt(x * x + y * y);
    phi = rh * 0.5;
    if (phi > 1) {
      return null;
    }
    phi = 2 * Math.asin(phi);
    if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
      sinz = Math.sin(phi);
      cosz = Math.cos(phi);
    }
    switch (this.mode) {
    case this.EQUIT:
      phi = (Math.abs(rh) <= __WEBPACK_IMPORTED_MODULE_0__constants_values__["d" /* EPSLN */]) ? 0 : Math.asin(y * sinz / rh);
      x *= sinz;
      y = cosz * rh;
      break;
    case this.OBLIQ:
      phi = (Math.abs(rh) <= __WEBPACK_IMPORTED_MODULE_0__constants_values__["d" /* EPSLN */]) ? this.phi0 : Math.asin(cosz * this.sinph0 + y * sinz * this.cosph0 / rh);
      x *= sinz * this.cosph0;
      y = (cosz - Math.sin(phi) * this.sinph0) * rh;
      break;
    case this.N_POLE:
      y = -y;
      phi = __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */] - phi;
      break;
    case this.S_POLE:
      phi -= __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */];
      break;
    }
    lam = (y === 0 && (this.mode === this.EQUIT || this.mode === this.OBLIQ)) ? 0 : Math.atan2(x, y);
  }
  else {
    ab = 0;
    if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
      x /= this.dd;
      y *= this.dd;
      rho = Math.sqrt(x * x + y * y);
      if (rho < __WEBPACK_IMPORTED_MODULE_0__constants_values__["d" /* EPSLN */]) {
        p.x = 0;
        p.y = this.phi0;
        return p;
      }
      sCe = 2 * Math.asin(0.5 * rho / this.rq);
      cCe = Math.cos(sCe);
      x *= (sCe = Math.sin(sCe));
      if (this.mode === this.OBLIQ) {
        ab = cCe * this.sinb1 + y * sCe * this.cosb1 / rho;
        q = this.qp * ab;
        y = rho * this.cosb1 * cCe - y * this.sinb1 * sCe;
      }
      else {
        ab = y * sCe / rho;
        q = this.qp * ab;
        y = rho * cCe;
      }
    }
    else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
      if (this.mode === this.N_POLE) {
        y = -y;
      }
      q = (x * x + y * y);
      if (!q) {
        p.x = 0;
        p.y = this.phi0;
        return p;
      }
      ab = 1 - q / this.qp;
      if (this.mode === this.S_POLE) {
        ab = -ab;
      }
    }
    lam = Math.atan2(x, y);
    phi = authlat(Math.asin(ab), this.apa);
  }

  p.x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_adjust_lon__["a" /* default */])(this.long0 + lam);
  p.y = phi;
  return p;
}

/* determine latitude from authalic latitude */
var P00 = 0.33333333333333333333;

var P01 = 0.17222222222222222222;
var P02 = 0.10257936507936507936;
var P10 = 0.06388888888888888888;
var P11 = 0.06640211640211640211;
var P20 = 0.01641501294219154443;

function authset(es) {
  var t;
  var APA = [];
  APA[0] = es * P00;
  t = es * es;
  APA[0] += t * P01;
  APA[1] = t * P10;
  t *= es;
  APA[0] += t * P02;
  APA[1] += t * P11;
  APA[2] = t * P20;
  return APA;
}

function authlat(beta, APA) {
  var t = beta + beta;
  return (beta + APA[0] * Math.sin(t) + APA[1] * Math.sin(t + t) + APA[2] * Math.sin(t + t + t));
}

var names = ["Lambert Azimuthal Equal Area", "Lambert_Azimuthal_Equal_Area", "laea"];
/* harmony default export */ __webpack_exports__["a"] = ({
  init: init,
  forward: forward,
  inverse: inverse,
  names: names,
  S_POLE: S_POLE,
  N_POLE: N_POLE,
  EQUIT: EQUIT,
  OBLIQ: OBLIQ
});


/***/ }),
/* 1209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export init */
/* unused harmony export forward */
/* unused harmony export inverse */
/* unused harmony export names */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_msfnz__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_tsfnz__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_sign__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_adjust_lon__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_phi2z__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_values__ = __webpack_require__(28);






function init() {

  // array of:  r_maj,r_min,lat1,lat2,c_lon,c_lat,false_east,false_north
  //double c_lat;                   /* center latitude                      */
  //double c_lon;                   /* center longitude                     */
  //double lat1;                    /* first standard parallel              */
  //double lat2;                    /* second standard parallel             */
  //double r_maj;                   /* major axis                           */
  //double r_min;                   /* minor axis                           */
  //double false_east;              /* x offset in meters                   */
  //double false_north;             /* y offset in meters                   */

  if (!this.lat2) {
    this.lat2 = this.lat1;
  } //if lat2 is not defined
  if (!this.k0) {
    this.k0 = 1;
  }
  this.x0 = this.x0 || 0;
  this.y0 = this.y0 || 0;
  // Standard Parallels cannot be equal and on opposite sides of the equator
  if (Math.abs(this.lat1 + this.lat2) < __WEBPACK_IMPORTED_MODULE_5__constants_values__["d" /* EPSLN */]) {
    return;
  }

  var temp = this.b / this.a;
  this.e = Math.sqrt(1 - temp * temp);

  var sin1 = Math.sin(this.lat1);
  var cos1 = Math.cos(this.lat1);
  var ms1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_msfnz__["a" /* default */])(this.e, sin1, cos1);
  var ts1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_tsfnz__["a" /* default */])(this.e, this.lat1, sin1);

  var sin2 = Math.sin(this.lat2);
  var cos2 = Math.cos(this.lat2);
  var ms2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_msfnz__["a" /* default */])(this.e, sin2, cos2);
  var ts2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_tsfnz__["a" /* default */])(this.e, this.lat2, sin2);

  var ts0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_tsfnz__["a" /* default */])(this.e, this.lat0, Math.sin(this.lat0));

  if (Math.abs(this.lat1 - this.lat2) > __WEBPACK_IMPORTED_MODULE_5__constants_values__["d" /* EPSLN */]) {
    this.ns = Math.log(ms1 / ms2) / Math.log(ts1 / ts2);
  }
  else {
    this.ns = sin1;
  }
  if (isNaN(this.ns)) {
    this.ns = sin1;
  }
  this.f0 = ms1 / (this.ns * Math.pow(ts1, this.ns));
  this.rh = this.a * this.f0 * Math.pow(ts0, this.ns);
  if (!this.title) {
    this.title = "Lambert Conformal Conic";
  }
}

// Lambert Conformal conic forward equations--mapping lat,long to x,y
// -----------------------------------------------------------------
function forward(p) {

  var lon = p.x;
  var lat = p.y;

  // singular cases :
  if (Math.abs(2 * Math.abs(lat) - Math.PI) <= __WEBPACK_IMPORTED_MODULE_5__constants_values__["d" /* EPSLN */]) {
    lat = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_sign__["a" /* default */])(lat) * (__WEBPACK_IMPORTED_MODULE_5__constants_values__["a" /* HALF_PI */] - 2 * __WEBPACK_IMPORTED_MODULE_5__constants_values__["d" /* EPSLN */]);
  }

  var con = Math.abs(Math.abs(lat) - __WEBPACK_IMPORTED_MODULE_5__constants_values__["a" /* HALF_PI */]);
  var ts, rh1;
  if (con > __WEBPACK_IMPORTED_MODULE_5__constants_values__["d" /* EPSLN */]) {
    ts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_tsfnz__["a" /* default */])(this.e, lat, Math.sin(lat));
    rh1 = this.a * this.f0 * Math.pow(ts, this.ns);
  }
  else {
    con = lat * this.ns;
    if (con <= 0) {
      return null;
    }
    rh1 = 0;
  }
  var theta = this.ns * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_adjust_lon__["a" /* default */])(lon - this.long0);
  p.x = this.k0 * (rh1 * Math.sin(theta)) + this.x0;
  p.y = this.k0 * (this.rh - rh1 * Math.cos(theta)) + this.y0;

  return p;
}

// Lambert Conformal Conic inverse equations--mapping x,y to lat/long
// -----------------------------------------------------------------
function inverse(p) {

  var rh1, con, ts;
  var lat, lon;
  var x = (p.x - this.x0) / this.k0;
  var y = (this.rh - (p.y - this.y0) / this.k0);
  if (this.ns > 0) {
    rh1 = Math.sqrt(x * x + y * y);
    con = 1;
  }
  else {
    rh1 = -Math.sqrt(x * x + y * y);
    con = -1;
  }
  var theta = 0;
  if (rh1 !== 0) {
    theta = Math.atan2((con * x), (con * y));
  }
  if ((rh1 !== 0) || (this.ns > 0)) {
    con = 1 / this.ns;
    ts = Math.pow((rh1 / (this.a * this.f0)), con);
    lat = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_phi2z__["a" /* default */])(this.e, ts);
    if (lat === -9999) {
      return null;
    }
  }
  else {
    lat = -__WEBPACK_IMPORTED_MODULE_5__constants_values__["a" /* HALF_PI */];
  }
  lon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_adjust_lon__["a" /* default */])(theta / this.ns + this.long0);

  p.x = lon;
  p.y = lat;
  return p;
}

var names = ["Lambert Tangential Conformal Conic Projection", "Lambert_Conformal_Conic", "Lambert_Conformal_Conic_2SP", "lcc"];
/* harmony default export */ __webpack_exports__["a"] = ({
  init: init,
  forward: forward,
  inverse: inverse,
  names: names
});


/***/ }),
/* 1210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export init */
/* unused harmony export forward */
/* unused harmony export inverse */
/* unused harmony export names */
function init() {
  //no-op for longlat
}

function identity(pt) {
  return pt;
}


var names = ["longlat", "identity"];
/* harmony default export */ __webpack_exports__["a"] = ({
  init: init,
  forward: identity,
  inverse: identity,
  names: names
});


/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export init */
/* unused harmony export forward */
/* unused harmony export inverse */
/* unused harmony export names */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_msfnz__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_adjust_lon__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_tsfnz__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_phi2z__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_values__ = __webpack_require__(28);






function init() {
  var con = this.b / this.a;
  this.es = 1 - con * con;
  if(!('x0' in this)){
    this.x0 = 0;
  }
  if(!('y0' in this)){
    this.y0 = 0;
  }
  this.e = Math.sqrt(this.es);
  if (this.lat_ts) {
    if (this.sphere) {
      this.k0 = Math.cos(this.lat_ts);
    }
    else {
      this.k0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_msfnz__["a" /* default */])(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts));
    }
  }
  else {
    if (!this.k0) {
      if (this.k) {
        this.k0 = this.k;
      }
      else {
        this.k0 = 1;
      }
    }
  }
}

/* Mercator forward equations--mapping lat,long to x,y
  --------------------------------------------------*/

function forward(p) {
  var lon = p.x;
  var lat = p.y;
  // convert to radians
  if (lat * __WEBPACK_IMPORTED_MODULE_4__constants_values__["j" /* R2D */] > 90 && lat * __WEBPACK_IMPORTED_MODULE_4__constants_values__["j" /* R2D */] < -90 && lon * __WEBPACK_IMPORTED_MODULE_4__constants_values__["j" /* R2D */] > 180 && lon * __WEBPACK_IMPORTED_MODULE_4__constants_values__["j" /* R2D */] < -180) {
    return null;
  }

  var x, y;
  if (Math.abs(Math.abs(lat) - __WEBPACK_IMPORTED_MODULE_4__constants_values__["a" /* HALF_PI */]) <= __WEBPACK_IMPORTED_MODULE_4__constants_values__["d" /* EPSLN */]) {
    return null;
  }
  else {
    if (this.sphere) {
      x = this.x0 + this.a * this.k0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_adjust_lon__["a" /* default */])(lon - this.long0);
      y = this.y0 + this.a * this.k0 * Math.log(Math.tan(__WEBPACK_IMPORTED_MODULE_4__constants_values__["b" /* FORTPI */] + 0.5 * lat));
    }
    else {
      var sinphi = Math.sin(lat);
      var ts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_tsfnz__["a" /* default */])(this.e, lat, sinphi);
      x = this.x0 + this.a * this.k0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_adjust_lon__["a" /* default */])(lon - this.long0);
      y = this.y0 - this.a * this.k0 * Math.log(ts);
    }
    p.x = x;
    p.y = y;
    return p;
  }
}

/* Mercator inverse equations--mapping x,y to lat/long
  --------------------------------------------------*/
function inverse(p) {

  var x = p.x - this.x0;
  var y = p.y - this.y0;
  var lon, lat;

  if (this.sphere) {
    lat = __WEBPACK_IMPORTED_MODULE_4__constants_values__["a" /* HALF_PI */] - 2 * Math.atan(Math.exp(-y / (this.a * this.k0)));
  }
  else {
    var ts = Math.exp(-y / (this.a * this.k0));
    lat = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_phi2z__["a" /* default */])(this.e, ts);
    if (lat === -9999) {
      return null;
    }
  }
  lon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_adjust_lon__["a" /* default */])(this.long0 + x / (this.a * this.k0));

  p.x = lon;
  p.y = lat;
  return p;
}

var names = ["Mercator", "Popular Visualisation Pseudo Mercator", "Mercator_1SP", "Mercator_Auxiliary_Sphere", "merc"];
/* harmony default export */ __webpack_exports__["a"] = ({
  init: init,
  forward: forward,
  inverse: inverse,
  names: names
});


/***/ }),
/* 1212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export init */
/* unused harmony export forward */
/* unused harmony export inverse */
/* unused harmony export names */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_adjust_lon__ = __webpack_require__(33);


/*
  reference
    "New Equal-Area Map Projections for Noncircular Regions", John P. Snyder,
    The American Cartographer, Vol 15, No. 4, October 1988, pp. 341-355.
  */


/* Initialize the Miller Cylindrical projection
  -------------------------------------------*/
function init() {
  //no-op
}

/* Miller Cylindrical forward equations--mapping lat,long to x,y
    ------------------------------------------------------------*/
function forward(p) {
  var lon = p.x;
  var lat = p.y;
  /* Forward equations
      -----------------*/
  var dlon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_adjust_lon__["a" /* default */])(lon - this.long0);
  var x = this.x0 + this.a * dlon;
  var y = this.y0 + this.a * Math.log(Math.tan((Math.PI / 4) + (lat / 2.5))) * 1.25;

  p.x = x;
  p.y = y;
  return p;
}

/* Miller Cylindrical inverse equations--mapping x,y to lat/long
    ------------------------------------------------------------*/
function inverse(p) {
  p.x -= this.x0;
  p.y -= this.y0;

  var lon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_adjust_lon__["a" /* default */])(this.long0 + p.x / this.a);
  var lat = 2.5 * (Math.atan(Math.exp(0.8 * p.y / this.a)) - Math.PI / 4);

  p.x = lon;
  p.y = lat;
  return p;
}

var names = ["Miller_Cylindrical", "mill"];
/* harmony default export */ __webpack_exports__["a"] = ({
  init: init,
  forward: forward,
  inverse: inverse,
  names: names
});


/***/ }),
/* 1213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export init */
/* unused harmony export forward */
/* unused harmony export inverse */
/* unused harmony export names */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_adjust_lon__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_values__ = __webpack_require__(28);

function init() {}

/* Mollweide forward equations--mapping lat,long to x,y
    ----------------------------------------------------*/
function forward(p) {

  /* Forward equations
      -----------------*/
  var lon = p.x;
  var lat = p.y;

  var delta_lon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_adjust_lon__["a" /* default */])(lon - this.long0);
  var theta = lat;
  var con = Math.PI * Math.sin(lat);

  /* Iterate using the Newton-Raphson method to find theta
      -----------------------------------------------------*/
  while (true) {
    var delta_theta = -(theta + Math.sin(theta) - con) / (1 + Math.cos(theta));
    theta += delta_theta;
    if (Math.abs(delta_theta) < __WEBPACK_IMPORTED_MODULE_1__constants_values__["d" /* EPSLN */]) {
      break;
    }
  }
  theta /= 2;

  /* If the latitude is 90 deg, force the x coordinate to be "0 + false easting"
       this is done here because of precision problems with "cos(theta)"
       --------------------------------------------------------------------------*/
  if (Math.PI / 2 - Math.abs(lat) < __WEBPACK_IMPORTED_MODULE_1__constants_values__["d" /* EPSLN */]) {
    delta_lon = 0;
  }
  var x = 0.900316316158 * this.a * delta_lon * Math.cos(theta) + this.x0;
  var y = 1.4142135623731 * this.a * Math.sin(theta) + this.y0;

  p.x = x;
  p.y = y;
  return p;
}

function inverse(p) {
  var theta;
  var arg;

  /* Inverse equations
      -----------------*/
  p.x -= this.x0;
  p.y -= this.y0;
  arg = p.y / (1.4142135623731 * this.a);

  /* Because of division by zero problems, 'arg' can not be 1.  Therefore
       a number very close to one is used instead.
       -------------------------------------------------------------------*/
  if (Math.abs(arg) > 0.999999999999) {
    arg = 0.999999999999;
  }
  theta = Math.asin(arg);
  var lon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_adjust_lon__["a" /* default */])(this.long0 + (p.x / (0.900316316158 * this.a * Math.cos(theta))));
  if (lon < (-Math.PI)) {
    lon = -Math.PI;
  }
  if (lon > Math.PI) {
    lon = Math.PI;
  }
  arg = (2 * theta + Math.sin(2 * theta)) / Math.PI;
  if (Math.abs(arg) > 1) {
    arg = 1;
  }
  var lat = Math.asin(arg);

  p.x = lon;
  p.y = lat;
  return p;
}

var names = ["Mollweide", "moll"];
/* harmony default export */ __webpack_exports__["a"] = ({
  init: init,
  forward: forward,
  inverse: inverse,
  names: names
});


/***/ }),
/* 1214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export iterations */
/* unused harmony export init */
/* unused harmony export forward */
/* unused harmony export inverse */
/* unused harmony export names */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_values__ = __webpack_require__(28);


/*
  reference
    Department of Land and Survey Technical Circular 1973/32
      http://www.linz.govt.nz/docs/miscellaneous/nz-map-definition.pdf
    OSG Technical Report 4.1
      http://www.linz.govt.nz/docs/miscellaneous/nzmg.pdf
  */

/**
 * iterations: Number of iterations to refine inverse transform.
 *     0 -> km accuracy
 *     1 -> m accuracy -- suitable for most mapping applications
 *     2 -> mm accuracy
 */
var iterations = 1;

function init() {
  this.A = [];
  this.A[1] = 0.6399175073;
  this.A[2] = -0.1358797613;
  this.A[3] = 0.063294409;
  this.A[4] = -0.02526853;
  this.A[5] = 0.0117879;
  this.A[6] = -0.0055161;
  this.A[7] = 0.0026906;
  this.A[8] = -0.001333;
  this.A[9] = 0.00067;
  this.A[10] = -0.00034;

  this.B_re = [];
  this.B_im = [];
  this.B_re[1] = 0.7557853228;
  this.B_im[1] = 0;
  this.B_re[2] = 0.249204646;
  this.B_im[2] = 0.003371507;
  this.B_re[3] = -0.001541739;
  this.B_im[3] = 0.041058560;
  this.B_re[4] = -0.10162907;
  this.B_im[4] = 0.01727609;
  this.B_re[5] = -0.26623489;
  this.B_im[5] = -0.36249218;
  this.B_re[6] = -0.6870983;
  this.B_im[6] = -1.1651967;

  this.C_re = [];
  this.C_im = [];
  this.C_re[1] = 1.3231270439;
  this.C_im[1] = 0;
  this.C_re[2] = -0.577245789;
  this.C_im[2] = -0.007809598;
  this.C_re[3] = 0.508307513;
  this.C_im[3] = -0.112208952;
  this.C_re[4] = -0.15094762;
  this.C_im[4] = 0.18200602;
  this.C_re[5] = 1.01418179;
  this.C_im[5] = 1.64497696;
  this.C_re[6] = 1.9660549;
  this.C_im[6] = 2.5127645;

  this.D = [];
  this.D[1] = 1.5627014243;
  this.D[2] = 0.5185406398;
  this.D[3] = -0.03333098;
  this.D[4] = -0.1052906;
  this.D[5] = -0.0368594;
  this.D[6] = 0.007317;
  this.D[7] = 0.01220;
  this.D[8] = 0.00394;
  this.D[9] = -0.0013;
}

/**
    New Zealand Map Grid Forward  - long/lat to x/y
    long/lat in radians
  */
function forward(p) {
  var n;
  var lon = p.x;
  var lat = p.y;

  var delta_lat = lat - this.lat0;
  var delta_lon = lon - this.long0;

  // 1. Calculate d_phi and d_psi    ...                          // and d_lambda
  // For this algorithm, delta_latitude is in seconds of arc x 10-5, so we need to scale to those units. Longitude is radians.
  var d_phi = delta_lat / __WEBPACK_IMPORTED_MODULE_0__constants_values__["f" /* SEC_TO_RAD */] * 1E-5;
  var d_lambda = delta_lon;
  var d_phi_n = 1; // d_phi^0

  var d_psi = 0;
  for (n = 1; n <= 10; n++) {
    d_phi_n = d_phi_n * d_phi;
    d_psi = d_psi + this.A[n] * d_phi_n;
  }

  // 2. Calculate theta
  var th_re = d_psi;
  var th_im = d_lambda;

  // 3. Calculate z
  var th_n_re = 1;
  var th_n_im = 0; // theta^0
  var th_n_re1;
  var th_n_im1;

  var z_re = 0;
  var z_im = 0;
  for (n = 1; n <= 6; n++) {
    th_n_re1 = th_n_re * th_re - th_n_im * th_im;
    th_n_im1 = th_n_im * th_re + th_n_re * th_im;
    th_n_re = th_n_re1;
    th_n_im = th_n_im1;
    z_re = z_re + this.B_re[n] * th_n_re - this.B_im[n] * th_n_im;
    z_im = z_im + this.B_im[n] * th_n_re + this.B_re[n] * th_n_im;
  }

  // 4. Calculate easting and northing
  p.x = (z_im * this.a) + this.x0;
  p.y = (z_re * this.a) + this.y0;

  return p;
}

/**
    New Zealand Map Grid Inverse  -  x/y to long/lat
  */
function inverse(p) {
  var n;
  var x = p.x;
  var y = p.y;

  var delta_x = x - this.x0;
  var delta_y = y - this.y0;

  // 1. Calculate z
  var z_re = delta_y / this.a;
  var z_im = delta_x / this.a;

  // 2a. Calculate theta - first approximation gives km accuracy
  var z_n_re = 1;
  var z_n_im = 0; // z^0
  var z_n_re1;
  var z_n_im1;

  var th_re = 0;
  var th_im = 0;
  for (n = 1; n <= 6; n++) {
    z_n_re1 = z_n_re * z_re - z_n_im * z_im;
    z_n_im1 = z_n_im * z_re + z_n_re * z_im;
    z_n_re = z_n_re1;
    z_n_im = z_n_im1;
    th_re = th_re + this.C_re[n] * z_n_re - this.C_im[n] * z_n_im;
    th_im = th_im + this.C_im[n] * z_n_re + this.C_re[n] * z_n_im;
  }

  // 2b. Iterate to refine the accuracy of the calculation
  //        0 iterations gives km accuracy
  //        1 iteration gives m accuracy -- good enough for most mapping applications
  //        2 iterations bives mm accuracy
  for (var i = 0; i < this.iterations; i++) {
    var th_n_re = th_re;
    var th_n_im = th_im;
    var th_n_re1;
    var th_n_im1;

    var num_re = z_re;
    var num_im = z_im;
    for (n = 2; n <= 6; n++) {
      th_n_re1 = th_n_re * th_re - th_n_im * th_im;
      th_n_im1 = th_n_im * th_re + th_n_re * th_im;
      th_n_re = th_n_re1;
      th_n_im = th_n_im1;
      num_re = num_re + (n - 1) * (this.B_re[n] * th_n_re - this.B_im[n] * th_n_im);
      num_im = num_im + (n - 1) * (this.B_im[n] * th_n_re + this.B_re[n] * th_n_im);
    }

    th_n_re = 1;
    th_n_im = 0;
    var den_re = this.B_re[1];
    var den_im = this.B_im[1];
    for (n = 2; n <= 6; n++) {
      th_n_re1 = th_n_re * th_re - th_n_im * th_im;
      th_n_im1 = th_n_im * th_re + th_n_re * th_im;
      th_n_re = th_n_re1;
      th_n_im = th_n_im1;
      den_re = den_re + n * (this.B_re[n] * th_n_re - this.B_im[n] * th_n_im);
      den_im = den_im + n * (this.B_im[n] * th_n_re + this.B_re[n] * th_n_im);
    }

    // Complex division
    var den2 = den_re * den_re + den_im * den_im;
    th_re = (num_re * den_re + num_im * den_im) / den2;
    th_im = (num_im * den_re - num_re * den_im) / den2;
  }

  // 3. Calculate d_phi              ...                                    // and d_lambda
  var d_psi = th_re;
  var d_lambda = th_im;
  var d_psi_n = 1; // d_psi^0

  var d_phi = 0;
  for (n = 1; n <= 9; n++) {
    d_psi_n = d_psi_n * d_psi;
    d_phi = d_phi + this.D[n] * d_psi_n;
  }

  // 4. Calculate latitude and longitude
  // d_phi is calcuated in second of arc * 10^-5, so we need to scale back to radians. d_lambda is in radians.
  var lat = this.lat0 + (d_phi * __WEBPACK_IMPORTED_MODULE_0__constants_values__["f" /* SEC_TO_RAD */] * 1E5);
  var lon = this.long0 + d_lambda;

  p.x = lon;
  p.y = lat;

  return p;
}

var names = ["New_Zealand_Map_Grid", "nzmg"];
/* harmony default export */ __webpack_exports__["a"] = ({
  init: init,
  forward: forward,
  inverse: inverse,
  names: names
});


/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export init */
/* unused harmony export forward */
/* unused harmony export inverse */
/* unused harmony export names */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_tsfnz__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_adjust_lon__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_phi2z__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_values__ = __webpack_require__(28);





/* Initialize the Oblique Mercator  projection
    ------------------------------------------*/
function init() {
  this.no_off = this.no_off || false;
  this.no_rot = this.no_rot || false;

  if (isNaN(this.k0)) {
    this.k0 = 1;
  }
  var sinlat = Math.sin(this.lat0);
  var coslat = Math.cos(this.lat0);
  var con = this.e * sinlat;

  this.bl = Math.sqrt(1 + this.es / (1 - this.es) * Math.pow(coslat, 4));
  this.al = this.a * this.bl * this.k0 * Math.sqrt(1 - this.es) / (1 - con * con);
  var t0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_tsfnz__["a" /* default */])(this.e, this.lat0, sinlat);
  var dl = this.bl / coslat * Math.sqrt((1 - this.es) / (1 - con * con));
  if (dl * dl < 1) {
    dl = 1;
  }
  var fl;
  var gl;
  if (!isNaN(this.longc)) {
    //Central point and azimuth method

    if (this.lat0 >= 0) {
      fl = dl + Math.sqrt(dl * dl - 1);
    }
    else {
      fl = dl - Math.sqrt(dl * dl - 1);
    }
    this.el = fl * Math.pow(t0, this.bl);
    gl = 0.5 * (fl - 1 / fl);
    this.gamma0 = Math.asin(Math.sin(this.alpha) / dl);
    this.long0 = this.longc - Math.asin(gl * Math.tan(this.gamma0)) / this.bl;

  }
  else {
    //2 points method
    var t1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_tsfnz__["a" /* default */])(this.e, this.lat1, Math.sin(this.lat1));
    var t2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_tsfnz__["a" /* default */])(this.e, this.lat2, Math.sin(this.lat2));
    if (this.lat0 >= 0) {
      this.el = (dl + Math.sqrt(dl * dl - 1)) * Math.pow(t0, this.bl);
    }
    else {
      this.el = (dl - Math.sqrt(dl * dl - 1)) * Math.pow(t0, this.bl);
    }
    var hl = Math.pow(t1, this.bl);
    var ll = Math.pow(t2, this.bl);
    fl = this.el / hl;
    gl = 0.5 * (fl - 1 / fl);
    var jl = (this.el * this.el - ll * hl) / (this.el * this.el + ll * hl);
    var pl = (ll - hl) / (ll + hl);
    var dlon12 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_adjust_lon__["a" /* default */])(this.long1 - this.long2);
    this.long0 = 0.5 * (this.long1 + this.long2) - Math.atan(jl * Math.tan(0.5 * this.bl * (dlon12)) / pl) / this.bl;
    this.long0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_adjust_lon__["a" /* default */])(this.long0);
    var dlon10 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_adjust_lon__["a" /* default */])(this.long1 - this.long0);
    this.gamma0 = Math.atan(Math.sin(this.bl * (dlon10)) / gl);
    this.alpha = Math.asin(dl * Math.sin(this.gamma0));
  }

  if (this.no_off) {
    this.uc = 0;
  }
  else {
    if (this.lat0 >= 0) {
      this.uc = this.al / this.bl * Math.atan2(Math.sqrt(dl * dl - 1), Math.cos(this.alpha));
    }
    else {
      this.uc = -1 * this.al / this.bl * Math.atan2(Math.sqrt(dl * dl - 1), Math.cos(this.alpha));
    }
  }

}

/* Oblique Mercator forward equations--mapping lat,long to x,y
    ----------------------------------------------------------*/
function forward(p) {
  var lon = p.x;
  var lat = p.y;
  var dlon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_adjust_lon__["a" /* default */])(lon - this.long0);
  var us, vs;
  var con;
  if (Math.abs(Math.abs(lat) - __WEBPACK_IMPORTED_MODULE_3__constants_values__["a" /* HALF_PI */]) <= __WEBPACK_IMPORTED_MODULE_3__constants_values__["d" /* EPSLN */]) {
    if (lat > 0) {
      con = -1;
    }
    else {
      con = 1;
    }
    vs = this.al / this.bl * Math.log(Math.tan(__WEBPACK_IMPORTED_MODULE_3__constants_values__["b" /* FORTPI */] + con * this.gamma0 * 0.5));
    us = -1 * con * __WEBPACK_IMPORTED_MODULE_3__constants_values__["a" /* HALF_PI */] * this.al / this.bl;
  }
  else {
    var t = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_tsfnz__["a" /* default */])(this.e, lat, Math.sin(lat));
    var ql = this.el / Math.pow(t, this.bl);
    var sl = 0.5 * (ql - 1 / ql);
    var tl = 0.5 * (ql + 1 / ql);
    var vl = Math.sin(this.bl * (dlon));
    var ul = (sl * Math.sin(this.gamma0) - vl * Math.cos(this.gamma0)) / tl;
    if (Math.abs(Math.abs(ul) - 1) <= __WEBPACK_IMPORTED_MODULE_3__constants_values__["d" /* EPSLN */]) {
      vs = Number.POSITIVE_INFINITY;
    }
    else {
      vs = 0.5 * this.al * Math.log((1 - ul) / (1 + ul)) / this.bl;
    }
    if (Math.abs(Math.cos(this.bl * (dlon))) <= __WEBPACK_IMPORTED_MODULE_3__constants_values__["d" /* EPSLN */]) {
      us = this.al * this.bl * (dlon);
    }
    else {
      us = this.al * Math.atan2(sl * Math.cos(this.gamma0) + vl * Math.sin(this.gamma0), Math.cos(this.bl * dlon)) / this.bl;
    }
  }

  if (this.no_rot) {
    p.x = this.x0 + us;
    p.y = this.y0 + vs;
  }
  else {

    us -= this.uc;
    p.x = this.x0 + vs * Math.cos(this.alpha) + us * Math.sin(this.alpha);
    p.y = this.y0 + us * Math.cos(this.alpha) - vs * Math.sin(this.alpha);
  }
  return p;
}

function inverse(p) {
  var us, vs;
  if (this.no_rot) {
    vs = p.y - this.y0;
    us = p.x - this.x0;
  }
  else {
    vs = (p.x - this.x0) * Math.cos(this.alpha) - (p.y - this.y0) * Math.sin(this.alpha);
    us = (p.y - this.y0) * Math.cos(this.alpha) + (p.x - this.x0) * Math.sin(this.alpha);
    us += this.uc;
  }
  var qp = Math.exp(-1 * this.bl * vs / this.al);
  var sp = 0.5 * (qp - 1 / qp);
  var tp = 0.5 * (qp + 1 / qp);
  var vp = Math.sin(this.bl * us / this.al);
  var up = (vp * Math.cos(this.gamma0) + sp * Math.sin(this.gamma0)) / tp;
  var ts = Math.pow(this.el / Math.sqrt((1 + up) / (1 - up)), 1 / this.bl);
  if (Math.abs(up - 1) < __WEBPACK_IMPORTED_MODULE_3__constants_values__["d" /* EPSLN */]) {
    p.x = this.long0;
    p.y = __WEBPACK_IMPORTED_MODULE_3__constants_values__["a" /* HALF_PI */];
  }
  else if (Math.abs(up + 1) < __WEBPACK_IMPORTED_MODULE_3__constants_values__["d" /* EPSLN */]) {
    p.x = this.long0;
    p.y = -1 * __WEBPACK_IMPORTED_MODULE_3__constants_values__["a" /* HALF_PI */];
  }
  else {
    p.y = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_phi2z__["a" /* default */])(this.e, ts);
    p.x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_adjust_lon__["a" /* default */])(this.long0 - Math.atan2(sp * Math.cos(this.gamma0) - vp * Math.sin(this.gamma0), Math.cos(this.bl * us / this.al)) / this.bl);
  }
  return p;
}

var names = ["Hotine_Oblique_Mercator", "Hotine Oblique Mercator", "Hotine_Oblique_Mercator_Azimuth_Natural_Origin", "Hotine_Oblique_Mercator_Azimuth_Center", "omerc"];
/* harmony default export */ __webpack_exports__["a"] = ({
  init: init,
  forward: forward,
  inverse: inverse,
  names: names
});


/***/ }),
/* 1216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export init */
/* unused harmony export forward */
/* unused harmony export inverse */
/* unused harmony export names */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_adjust_lon__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_asinz__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_values__ = __webpack_require__(28);




function init() {
  //double temp;      /* temporary variable    */

  /* Place parameters in static storage for common use
      -------------------------------------------------*/
  this.sin_p14 = Math.sin(this.lat0);
  this.cos_p14 = Math.cos(this.lat0);
}

/* Orthographic forward equations--mapping lat,long to x,y
    ---------------------------------------------------*/
function forward(p) {
  var sinphi, cosphi; /* sin and cos value        */
  var dlon; /* delta longitude value      */
  var coslon; /* cos of longitude        */
  var ksp; /* scale factor          */
  var g, x, y;
  var lon = p.x;
  var lat = p.y;
  /* Forward equations
      -----------------*/
  dlon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_adjust_lon__["a" /* default */])(lon - this.long0);

  sinphi = Math.sin(lat);
  cosphi = Math.cos(lat);

  coslon = Math.cos(dlon);
  g = this.sin_p14 * sinphi + this.cos_p14 * cosphi * coslon;
  ksp = 1;
  if ((g > 0) || (Math.abs(g) <= __WEBPACK_IMPORTED_MODULE_2__constants_values__["d" /* EPSLN */])) {
    x = this.a * ksp * cosphi * Math.sin(dlon);
    y = this.y0 + this.a * ksp * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon);
  }
  p.x = x;
  p.y = y;
  return p;
}

function inverse(p) {
  var rh; /* height above ellipsoid      */
  var z; /* angle          */
  var sinz, cosz; /* sin of z and cos of z      */
  var con;
  var lon, lat;
  /* Inverse equations
      -----------------*/
  p.x -= this.x0;
  p.y -= this.y0;
  rh = Math.sqrt(p.x * p.x + p.y * p.y);
  z = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_asinz__["a" /* default */])(rh / this.a);

  sinz = Math.sin(z);
  cosz = Math.cos(z);

  lon = this.long0;
  if (Math.abs(rh) <= __WEBPACK_IMPORTED_MODULE_2__constants_values__["d" /* EPSLN */]) {
    lat = this.lat0;
    p.x = lon;
    p.y = lat;
    return p;
  }
  lat = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_asinz__["a" /* default */])(cosz * this.sin_p14 + (p.y * sinz * this.cos_p14) / rh);
  con = Math.abs(this.lat0) - __WEBPACK_IMPORTED_MODULE_2__constants_values__["a" /* HALF_PI */];
  if (Math.abs(con) <= __WEBPACK_IMPORTED_MODULE_2__constants_values__["d" /* EPSLN */]) {
    if (this.lat0 >= 0) {
      lon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_adjust_lon__["a" /* default */])(this.long0 + Math.atan2(p.x, - p.y));
    }
    else {
      lon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_adjust_lon__["a" /* default */])(this.long0 - Math.atan2(-p.x, p.y));
    }
    p.x = lon;
    p.y = lat;
    return p;
  }
  lon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_adjust_lon__["a" /* default */])(this.long0 + Math.atan2((p.x * sinz), rh * this.cos_p14 * cosz - p.y * this.sin_p14 * sinz));
  p.x = lon;
  p.y = lat;
  return p;
}

var names = ["ortho"];
/* harmony default export */ __webpack_exports__["a"] = ({
  init: init,
  forward: forward,
  inverse: inverse,
  names: names
});


/***/ }),
/* 1217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export init */
/* unused harmony export forward */
/* unused harmony export inverse */
/* unused harmony export names */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_e0fn__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_e1fn__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_e2fn__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_e3fn__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_adjust_lon__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_adjust_lat__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_mlfn__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_values__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_gN__ = __webpack_require__(215);










var MAX_ITER = 20;

function init() {
  /* Place parameters in static storage for common use
      -------------------------------------------------*/
  this.temp = this.b / this.a;
  this.es = 1 - Math.pow(this.temp, 2); // devait etre dans tmerc.js mais n y est pas donc je commente sinon retour de valeurs nulles
  this.e = Math.sqrt(this.es);
  this.e0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_e0fn__["a" /* default */])(this.es);
  this.e1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_e1fn__["a" /* default */])(this.es);
  this.e2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_e2fn__["a" /* default */])(this.es);
  this.e3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_e3fn__["a" /* default */])(this.es);
  this.ml0 = this.a * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_mlfn__["a" /* default */])(this.e0, this.e1, this.e2, this.e3, this.lat0); //si que des zeros le calcul ne se fait pas
}

/* Polyconic forward equations--mapping lat,long to x,y
    ---------------------------------------------------*/
function forward(p) {
  var lon = p.x;
  var lat = p.y;
  var x, y, el;
  var dlon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_adjust_lon__["a" /* default */])(lon - this.long0);
  el = dlon * Math.sin(lat);
  if (this.sphere) {
    if (Math.abs(lat) <= __WEBPACK_IMPORTED_MODULE_7__constants_values__["d" /* EPSLN */]) {
      x = this.a * dlon;
      y = -1 * this.a * this.lat0;
    }
    else {
      x = this.a * Math.sin(el) / Math.tan(lat);
      y = this.a * (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_adjust_lat__["a" /* default */])(lat - this.lat0) + (1 - Math.cos(el)) / Math.tan(lat));
    }
  }
  else {
    if (Math.abs(lat) <= __WEBPACK_IMPORTED_MODULE_7__constants_values__["d" /* EPSLN */]) {
      x = this.a * dlon;
      y = -1 * this.ml0;
    }
    else {
      var nl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__common_gN__["a" /* default */])(this.a, this.e, Math.sin(lat)) / Math.tan(lat);
      x = nl * Math.sin(el);
      y = this.a * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_mlfn__["a" /* default */])(this.e0, this.e1, this.e2, this.e3, lat) - this.ml0 + nl * (1 - Math.cos(el));
    }

  }
  p.x = x + this.x0;
  p.y = y + this.y0;
  return p;
}

/* Inverse equations
  -----------------*/
function inverse(p) {
  var lon, lat, x, y, i;
  var al, bl;
  var phi, dphi;
  x = p.x - this.x0;
  y = p.y - this.y0;

  if (this.sphere) {
    if (Math.abs(y + this.a * this.lat0) <= __WEBPACK_IMPORTED_MODULE_7__constants_values__["d" /* EPSLN */]) {
      lon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_adjust_lon__["a" /* default */])(x / this.a + this.long0);
      lat = 0;
    }
    else {
      al = this.lat0 + y / this.a;
      bl = x * x / this.a / this.a + al * al;
      phi = al;
      var tanphi;
      for (i = MAX_ITER; i; --i) {
        tanphi = Math.tan(phi);
        dphi = -1 * (al * (phi * tanphi + 1) - phi - 0.5 * (phi * phi + bl) * tanphi) / ((phi - al) / tanphi - 1);
        phi += dphi;
        if (Math.abs(dphi) <= __WEBPACK_IMPORTED_MODULE_7__constants_values__["d" /* EPSLN */]) {
          lat = phi;
          break;
        }
      }
      lon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_adjust_lon__["a" /* default */])(this.long0 + (Math.asin(x * Math.tan(phi) / this.a)) / Math.sin(lat));
    }
  }
  else {
    if (Math.abs(y + this.ml0) <= __WEBPACK_IMPORTED_MODULE_7__constants_values__["d" /* EPSLN */]) {
      lat = 0;
      lon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_adjust_lon__["a" /* default */])(this.long0 + x / this.a);
    }
    else {

      al = (this.ml0 + y) / this.a;
      bl = x * x / this.a / this.a + al * al;
      phi = al;
      var cl, mln, mlnp, ma;
      var con;
      for (i = MAX_ITER; i; --i) {
        con = this.e * Math.sin(phi);
        cl = Math.sqrt(1 - con * con) * Math.tan(phi);
        mln = this.a * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_mlfn__["a" /* default */])(this.e0, this.e1, this.e2, this.e3, phi);
        mlnp = this.e0 - 2 * this.e1 * Math.cos(2 * phi) + 4 * this.e2 * Math.cos(4 * phi) - 6 * this.e3 * Math.cos(6 * phi);
        ma = mln / this.a;
        dphi = (al * (cl * ma + 1) - ma - 0.5 * cl * (ma * ma + bl)) / (this.es * Math.sin(2 * phi) * (ma * ma + bl - 2 * al * ma) / (4 * cl) + (al - ma) * (cl * mlnp - 2 / Math.sin(2 * phi)) - mlnp);
        phi -= dphi;
        if (Math.abs(dphi) <= __WEBPACK_IMPORTED_MODULE_7__constants_values__["d" /* EPSLN */]) {
          lat = phi;
          break;
        }
      }

      //lat=phi4z(this.e,this.e0,this.e1,this.e2,this.e3,al,bl,0,0);
      cl = Math.sqrt(1 - this.es * Math.pow(Math.sin(lat), 2)) * Math.tan(lat);
      lon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_adjust_lon__["a" /* default */])(this.long0 + Math.asin(x * cl / this.a) / Math.sin(lat));
    }
  }

  p.x = lon;
  p.y = lat;
  return p;
}

var names = ["Polyconic", "poly"];
/* harmony default export */ __webpack_exports__["a"] = ({
  init: init,
  forward: forward,
  inverse: inverse,
  names: names
});


/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export init */
/* unused harmony export forward */
/* unused harmony export inverse */
/* unused harmony export names */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_values__ = __webpack_require__(28);
// QSC projection rewritten from the original PROJ4
// https://github.com/OSGeo/proj.4/blob/master/src/PJ_qsc.c



/* constants */
var FACE_ENUM = {
    FRONT: 1,
    RIGHT: 2,
    BACK: 3,
    LEFT: 4,
    TOP: 5,
    BOTTOM: 6
};

var AREA_ENUM = {
    AREA_0: 1,
    AREA_1: 2,
    AREA_2: 3,
    AREA_3: 4
};

function init() {

  this.x0 = this.x0 || 0;
  this.y0 = this.y0 || 0;
  this.lat0 = this.lat0 || 0;
  this.long0 = this.long0 || 0;
  this.lat_ts = this.lat_ts || 0;
  this.title = this.title || "Quadrilateralized Spherical Cube";

  /* Determine the cube face from the center of projection. */
  if (this.lat0 >= __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */] - __WEBPACK_IMPORTED_MODULE_0__constants_values__["b" /* FORTPI */] / 2.0) {
    this.face = FACE_ENUM.TOP;
  } else if (this.lat0 <= -(__WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */] - __WEBPACK_IMPORTED_MODULE_0__constants_values__["b" /* FORTPI */] / 2.0)) {
    this.face = FACE_ENUM.BOTTOM;
  } else if (Math.abs(this.long0) <= __WEBPACK_IMPORTED_MODULE_0__constants_values__["b" /* FORTPI */]) {
    this.face = FACE_ENUM.FRONT;
  } else if (Math.abs(this.long0) <= __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */] + __WEBPACK_IMPORTED_MODULE_0__constants_values__["b" /* FORTPI */]) {
    this.face = this.long0 > 0.0 ? FACE_ENUM.RIGHT : FACE_ENUM.LEFT;
  } else {
    this.face = FACE_ENUM.BACK;
  }

  /* Fill in useful values for the ellipsoid <-> sphere shift
   * described in [LK12]. */
  if (this.es !== 0) {
    this.one_minus_f = 1 - (this.a - this.b) / this.a;
    this.one_minus_f_squared = this.one_minus_f * this.one_minus_f;
  }
}

// QSC forward equations--mapping lat,long to x,y
// -----------------------------------------------------------------
function forward(p) {
  var xy = {x: 0, y: 0};
  var lat, lon;
  var theta, phi;
  var t, mu;
  /* nu; */
  var area = {value: 0};

  // move lon according to projection's lon
  p.x -= this.long0;

  /* Convert the geodetic latitude to a geocentric latitude.
   * This corresponds to the shift from the ellipsoid to the sphere
   * described in [LK12]. */
  if (this.es !== 0) {//if (P->es != 0) {
    lat = Math.atan(this.one_minus_f_squared * Math.tan(p.y));
  } else {
    lat = p.y;
  }

  /* Convert the input lat, lon into theta, phi as used by QSC.
   * This depends on the cube face and the area on it.
   * For the top and bottom face, we can compute theta and phi
   * directly from phi, lam. For the other faces, we must use
   * unit sphere cartesian coordinates as an intermediate step. */
  lon = p.x; //lon = lp.lam;
  if (this.face === FACE_ENUM.TOP) {
    phi = __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */] - lat;
    if (lon >= __WEBPACK_IMPORTED_MODULE_0__constants_values__["b" /* FORTPI */] && lon <= __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */] + __WEBPACK_IMPORTED_MODULE_0__constants_values__["b" /* FORTPI */]) {
      area.value = AREA_ENUM.AREA_0;
      theta = lon - __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */];
    } else if (lon > __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */] + __WEBPACK_IMPORTED_MODULE_0__constants_values__["b" /* FORTPI */] || lon <= -(__WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */] + __WEBPACK_IMPORTED_MODULE_0__constants_values__["b" /* FORTPI */])) {
      area.value = AREA_ENUM.AREA_1;
      theta = (lon > 0.0 ? lon - __WEBPACK_IMPORTED_MODULE_0__constants_values__["c" /* SPI */] : lon + __WEBPACK_IMPORTED_MODULE_0__constants_values__["c" /* SPI */]);
    } else if (lon > -(__WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */] + __WEBPACK_IMPORTED_MODULE_0__constants_values__["b" /* FORTPI */]) && lon <= -__WEBPACK_IMPORTED_MODULE_0__constants_values__["b" /* FORTPI */]) {
      area.value = AREA_ENUM.AREA_2;
      theta = lon + __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */];
    } else {
      area.value = AREA_ENUM.AREA_3;
      theta = lon;
    }
  } else if (this.face === FACE_ENUM.BOTTOM) {
    phi = __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */] + lat;
    if (lon >= __WEBPACK_IMPORTED_MODULE_0__constants_values__["b" /* FORTPI */] && lon <= __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */] + __WEBPACK_IMPORTED_MODULE_0__constants_values__["b" /* FORTPI */]) {
      area.value = AREA_ENUM.AREA_0;
      theta = -lon + __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */];
    } else if (lon < __WEBPACK_IMPORTED_MODULE_0__constants_values__["b" /* FORTPI */] && lon >= -__WEBPACK_IMPORTED_MODULE_0__constants_values__["b" /* FORTPI */]) {
      area.value = AREA_ENUM.AREA_1;
      theta = -lon;
    } else if (lon < -__WEBPACK_IMPORTED_MODULE_0__constants_values__["b" /* FORTPI */] && lon >= -(__WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */] + __WEBPACK_IMPORTED_MODULE_0__constants_values__["b" /* FORTPI */])) {
      area.value = AREA_ENUM.AREA_2;
      theta = -lon - __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */];
    } else {
      area.value = AREA_ENUM.AREA_3;
      theta = (lon > 0.0 ? -lon + __WEBPACK_IMPORTED_MODULE_0__constants_values__["c" /* SPI */] : -lon - __WEBPACK_IMPORTED_MODULE_0__constants_values__["c" /* SPI */]);
    }
  } else {
    var q, r, s;
    var sinlat, coslat;
    var sinlon, coslon;

    if (this.face === FACE_ENUM.RIGHT) {
      lon = qsc_shift_lon_origin(lon, +__WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */]);
    } else if (this.face === FACE_ENUM.BACK) {
      lon = qsc_shift_lon_origin(lon, +__WEBPACK_IMPORTED_MODULE_0__constants_values__["c" /* SPI */]);
    } else if (this.face === FACE_ENUM.LEFT) {
      lon = qsc_shift_lon_origin(lon, -__WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */]);
    }
    sinlat = Math.sin(lat);
    coslat = Math.cos(lat);
    sinlon = Math.sin(lon);
    coslon = Math.cos(lon);
    q = coslat * coslon;
    r = coslat * sinlon;
    s = sinlat;

    if (this.face === FACE_ENUM.FRONT) {
      phi = Math.acos(q);
      theta = qsc_fwd_equat_face_theta(phi, s, r, area);
    } else if (this.face === FACE_ENUM.RIGHT) {
      phi = Math.acos(r);
      theta = qsc_fwd_equat_face_theta(phi, s, -q, area);
    } else if (this.face === FACE_ENUM.BACK) {
      phi = Math.acos(-q);
      theta = qsc_fwd_equat_face_theta(phi, s, -r, area);
    } else if (this.face === FACE_ENUM.LEFT) {
      phi = Math.acos(-r);
      theta = qsc_fwd_equat_face_theta(phi, s, q, area);
    } else {
      /* Impossible */
      phi = theta = 0;
      area.value = AREA_ENUM.AREA_0;
    }
  }

  /* Compute mu and nu for the area of definition.
   * For mu, see Eq. (3-21) in [OL76], but note the typos:
   * compare with Eq. (3-14). For nu, see Eq. (3-38). */
  mu = Math.atan((12 / __WEBPACK_IMPORTED_MODULE_0__constants_values__["c" /* SPI */]) * (theta + Math.acos(Math.sin(theta) * Math.cos(__WEBPACK_IMPORTED_MODULE_0__constants_values__["b" /* FORTPI */])) - __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */]));
  t = Math.sqrt((1 - Math.cos(phi)) / (Math.cos(mu) * Math.cos(mu)) / (1 - Math.cos(Math.atan(1 / Math.cos(theta)))));

  /* Apply the result to the real area. */
  if (area.value === AREA_ENUM.AREA_1) {
    mu += __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */];
  } else if (area.value === AREA_ENUM.AREA_2) {
    mu += __WEBPACK_IMPORTED_MODULE_0__constants_values__["c" /* SPI */];
  } else if (area.value === AREA_ENUM.AREA_3) {
    mu += 1.5 * __WEBPACK_IMPORTED_MODULE_0__constants_values__["c" /* SPI */];
  }

  /* Now compute x, y from mu and nu */
  xy.x = t * Math.cos(mu);
  xy.y = t * Math.sin(mu);
  xy.x = xy.x * this.a + this.x0;
  xy.y = xy.y * this.a + this.y0;

  p.x = xy.x;
  p.y = xy.y;
  return p;
}

// QSC inverse equations--mapping x,y to lat/long
// -----------------------------------------------------------------
function inverse(p) {
  var lp = {lam: 0, phi: 0};
  var mu, nu, cosmu, tannu;
  var tantheta, theta, cosphi, phi;
  var t;
  var area = {value: 0};

  /* de-offset */
  p.x = (p.x - this.x0) / this.a;
  p.y = (p.y - this.y0) / this.a;

  /* Convert the input x, y to the mu and nu angles as used by QSC.
   * This depends on the area of the cube face. */
  nu = Math.atan(Math.sqrt(p.x * p.x + p.y * p.y));
  mu = Math.atan2(p.y, p.x);
  if (p.x >= 0.0 && p.x >= Math.abs(p.y)) {
    area.value = AREA_ENUM.AREA_0;
  } else if (p.y >= 0.0 && p.y >= Math.abs(p.x)) {
    area.value = AREA_ENUM.AREA_1;
    mu -= __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */];
  } else if (p.x < 0.0 && -p.x >= Math.abs(p.y)) {
    area.value = AREA_ENUM.AREA_2;
    mu = (mu < 0.0 ? mu + __WEBPACK_IMPORTED_MODULE_0__constants_values__["c" /* SPI */] : mu - __WEBPACK_IMPORTED_MODULE_0__constants_values__["c" /* SPI */]);
  } else {
    area.value = AREA_ENUM.AREA_3;
    mu += __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */];
  }

  /* Compute phi and theta for the area of definition.
   * The inverse projection is not described in the original paper, but some
   * good hints can be found here (as of 2011-12-14):
   * http://fits.gsfc.nasa.gov/fitsbits/saf.93/saf.9302
   * (search for "Message-Id: <9302181759.AA25477 at fits.cv.nrao.edu>") */
  t = (__WEBPACK_IMPORTED_MODULE_0__constants_values__["c" /* SPI */] / 12) * Math.tan(mu);
  tantheta = Math.sin(t) / (Math.cos(t) - (1 / Math.sqrt(2)));
  theta = Math.atan(tantheta);
  cosmu = Math.cos(mu);
  tannu = Math.tan(nu);
  cosphi = 1 - cosmu * cosmu * tannu * tannu * (1 - Math.cos(Math.atan(1 / Math.cos(theta))));
  if (cosphi < -1) {
    cosphi = -1;
  } else if (cosphi > +1) {
    cosphi = +1;
  }

  /* Apply the result to the real area on the cube face.
   * For the top and bottom face, we can compute phi and lam directly.
   * For the other faces, we must use unit sphere cartesian coordinates
   * as an intermediate step. */
  if (this.face === FACE_ENUM.TOP) {
    phi = Math.acos(cosphi);
    lp.phi = __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */] - phi;
    if (area.value === AREA_ENUM.AREA_0) {
      lp.lam = theta + __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */];
    } else if (area.value === AREA_ENUM.AREA_1) {
      lp.lam = (theta < 0.0 ? theta + __WEBPACK_IMPORTED_MODULE_0__constants_values__["c" /* SPI */] : theta - __WEBPACK_IMPORTED_MODULE_0__constants_values__["c" /* SPI */]);
    } else if (area.value === AREA_ENUM.AREA_2) {
      lp.lam = theta - __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */];
    } else /* area.value == AREA_ENUM.AREA_3 */ {
      lp.lam = theta;
    }
  } else if (this.face === FACE_ENUM.BOTTOM) {
    phi = Math.acos(cosphi);
    lp.phi = phi - __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */];
    if (area.value === AREA_ENUM.AREA_0) {
      lp.lam = -theta + __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */];
    } else if (area.value === AREA_ENUM.AREA_1) {
      lp.lam = -theta;
    } else if (area.value === AREA_ENUM.AREA_2) {
      lp.lam = -theta - __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */];
    } else /* area.value == AREA_ENUM.AREA_3 */ {
      lp.lam = (theta < 0.0 ? -theta - __WEBPACK_IMPORTED_MODULE_0__constants_values__["c" /* SPI */] : -theta + __WEBPACK_IMPORTED_MODULE_0__constants_values__["c" /* SPI */]);
    }
  } else {
    /* Compute phi and lam via cartesian unit sphere coordinates. */
    var q, r, s;
    q = cosphi;
    t = q * q;
    if (t >= 1) {
      s = 0;
    } else {
      s = Math.sqrt(1 - t) * Math.sin(theta);
    }
    t += s * s;
    if (t >= 1) {
      r = 0;
    } else {
      r = Math.sqrt(1 - t);
    }
    /* Rotate q,r,s into the correct area. */
    if (area.value === AREA_ENUM.AREA_1) {
      t = r;
      r = -s;
      s = t;
    } else if (area.value === AREA_ENUM.AREA_2) {
      r = -r;
      s = -s;
    } else if (area.value === AREA_ENUM.AREA_3) {
      t = r;
      r = s;
      s = -t;
    }
    /* Rotate q,r,s into the correct cube face. */
    if (this.face === FACE_ENUM.RIGHT) {
      t = q;
      q = -r;
      r = t;
    } else if (this.face === FACE_ENUM.BACK) {
      q = -q;
      r = -r;
    } else if (this.face === FACE_ENUM.LEFT) {
      t = q;
      q = r;
      r = -t;
    }
    /* Now compute phi and lam from the unit sphere coordinates. */
    lp.phi = Math.acos(-s) - __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */];
    lp.lam = Math.atan2(r, q);
    if (this.face === FACE_ENUM.RIGHT) {
      lp.lam = qsc_shift_lon_origin(lp.lam, -__WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */]);
    } else if (this.face === FACE_ENUM.BACK) {
      lp.lam = qsc_shift_lon_origin(lp.lam, -__WEBPACK_IMPORTED_MODULE_0__constants_values__["c" /* SPI */]);
    } else if (this.face === FACE_ENUM.LEFT) {
      lp.lam = qsc_shift_lon_origin(lp.lam, +__WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */]);
    }
  }

  /* Apply the shift from the sphere to the ellipsoid as described
   * in [LK12]. */
  if (this.es !== 0) {
    var invert_sign;
    var tanphi, xa;
    invert_sign = (lp.phi < 0 ? 1 : 0);
    tanphi = Math.tan(lp.phi);
    xa = this.b / Math.sqrt(tanphi * tanphi + this.one_minus_f_squared);
    lp.phi = Math.atan(Math.sqrt(this.a * this.a - xa * xa) / (this.one_minus_f * xa));
    if (invert_sign) {
      lp.phi = -lp.phi;
    }
  }

  lp.lam += this.long0;
  p.x = lp.lam;
  p.y = lp.phi;
  return p;
}

/* Helper function for forward projection: compute the theta angle
 * and determine the area number. */
function qsc_fwd_equat_face_theta(phi, y, x, area) {
  var theta;
  if (phi < __WEBPACK_IMPORTED_MODULE_0__constants_values__["d" /* EPSLN */]) {
    area.value = AREA_ENUM.AREA_0;
    theta = 0.0;
  } else {
    theta = Math.atan2(y, x);
    if (Math.abs(theta) <= __WEBPACK_IMPORTED_MODULE_0__constants_values__["b" /* FORTPI */]) {
      area.value = AREA_ENUM.AREA_0;
    } else if (theta > __WEBPACK_IMPORTED_MODULE_0__constants_values__["b" /* FORTPI */] && theta <= __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */] + __WEBPACK_IMPORTED_MODULE_0__constants_values__["b" /* FORTPI */]) {
      area.value = AREA_ENUM.AREA_1;
      theta -= __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */];
    } else if (theta > __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */] + __WEBPACK_IMPORTED_MODULE_0__constants_values__["b" /* FORTPI */] || theta <= -(__WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */] + __WEBPACK_IMPORTED_MODULE_0__constants_values__["b" /* FORTPI */])) {
      area.value = AREA_ENUM.AREA_2;
      theta = (theta >= 0.0 ? theta - __WEBPACK_IMPORTED_MODULE_0__constants_values__["c" /* SPI */] : theta + __WEBPACK_IMPORTED_MODULE_0__constants_values__["c" /* SPI */]);
    } else {
      area.value = AREA_ENUM.AREA_3;
      theta += __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */];
    }
  }
  return theta;
}

/* Helper function: shift the longitude. */
function qsc_shift_lon_origin(lon, offset) {
  var slon = lon + offset;
  if (slon < -__WEBPACK_IMPORTED_MODULE_0__constants_values__["c" /* SPI */]) {
    slon += __WEBPACK_IMPORTED_MODULE_0__constants_values__["e" /* TWO_PI */];
  } else if (slon > +__WEBPACK_IMPORTED_MODULE_0__constants_values__["c" /* SPI */]) {
    slon -= __WEBPACK_IMPORTED_MODULE_0__constants_values__["e" /* TWO_PI */];
  }
  return slon;
}

var names = ["Quadrilateralized Spherical Cube", "Quadrilateralized_Spherical_Cube", "qsc"];
/* harmony default export */ __webpack_exports__["a"] = ({
  init: init,
  forward: forward,
  inverse: inverse,
  names: names
});



/***/ }),
/* 1219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export init */
/* unused harmony export forward */
/* unused harmony export inverse */
/* unused harmony export names */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_adjust_lon__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_adjust_lat__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_pj_enfn__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_pj_mlfn__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_pj_inv_mlfn__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_values__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_asinz__ = __webpack_require__(98);



var MAX_ITER = 20;







function init() {
  /* Place parameters in static storage for common use
    -------------------------------------------------*/


  if (!this.sphere) {
    this.en = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_pj_enfn__["a" /* default */])(this.es);
  }
  else {
    this.n = 1;
    this.m = 0;
    this.es = 0;
    this.C_y = Math.sqrt((this.m + 1) / this.n);
    this.C_x = this.C_y / (this.m + 1);
  }

}

/* Sinusoidal forward equations--mapping lat,long to x,y
  -----------------------------------------------------*/
function forward(p) {
  var x, y;
  var lon = p.x;
  var lat = p.y;
  /* Forward equations
    -----------------*/
  lon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_adjust_lon__["a" /* default */])(lon - this.long0);

  if (this.sphere) {
    if (!this.m) {
      lat = this.n !== 1 ? Math.asin(this.n * Math.sin(lat)) : lat;
    }
    else {
      var k = this.n * Math.sin(lat);
      for (var i = MAX_ITER; i; --i) {
        var V = (this.m * lat + Math.sin(lat) - k) / (this.m + Math.cos(lat));
        lat -= V;
        if (Math.abs(V) < __WEBPACK_IMPORTED_MODULE_5__constants_values__["d" /* EPSLN */]) {
          break;
        }
      }
    }
    x = this.a * this.C_x * lon * (this.m + Math.cos(lat));
    y = this.a * this.C_y * lat;

  }
  else {

    var s = Math.sin(lat);
    var c = Math.cos(lat);
    y = this.a * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_pj_mlfn__["a" /* default */])(lat, s, c, this.en);
    x = this.a * lon * c / Math.sqrt(1 - this.es * s * s);
  }

  p.x = x;
  p.y = y;
  return p;
}

function inverse(p) {
  var lat, temp, lon, s;

  p.x -= this.x0;
  lon = p.x / this.a;
  p.y -= this.y0;
  lat = p.y / this.a;

  if (this.sphere) {
    lat /= this.C_y;
    lon = lon / (this.C_x * (this.m + Math.cos(lat)));
    if (this.m) {
      lat = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_asinz__["a" /* default */])((this.m * lat + Math.sin(lat)) / this.n);
    }
    else if (this.n !== 1) {
      lat = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_asinz__["a" /* default */])(Math.sin(lat) / this.n);
    }
    lon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_adjust_lon__["a" /* default */])(lon + this.long0);
    lat = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_adjust_lat__["a" /* default */])(lat);
  }
  else {
    lat = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_pj_inv_mlfn__["a" /* default */])(p.y / this.a, this.es, this.en);
    s = Math.abs(lat);
    if (s < __WEBPACK_IMPORTED_MODULE_5__constants_values__["a" /* HALF_PI */]) {
      s = Math.sin(lat);
      temp = this.long0 + p.x * Math.sqrt(1 - this.es * s * s) / (this.a * Math.cos(lat));
      //temp = this.long0 + p.x / (this.a * Math.cos(lat));
      lon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_adjust_lon__["a" /* default */])(temp);
    }
    else if ((s - __WEBPACK_IMPORTED_MODULE_5__constants_values__["d" /* EPSLN */]) < __WEBPACK_IMPORTED_MODULE_5__constants_values__["a" /* HALF_PI */]) {
      lon = this.long0;
    }
  }
  p.x = lon;
  p.y = lat;
  return p;
}

var names = ["Sinusoidal", "sinu"];
/* harmony default export */ __webpack_exports__["a"] = ({
  init: init,
  forward: forward,
  inverse: inverse,
  names: names
});


/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export init */
/* unused harmony export forward */
/* unused harmony export inverse */
/* unused harmony export names */
/*
  references:
    Formules et constantes pour le Calcul pour la
    projection cylindrique conforme à axe oblique et pour la transformation entre
    des systèmes de référence.
    http://www.swisstopo.admin.ch/internet/swisstopo/fr/home/topics/survey/sys/refsys/switzerland.parsysrelated1.31216.downloadList.77004.DownloadFile.tmp/swissprojectionfr.pdf
  */

function init() {
  var phy0 = this.lat0;
  this.lambda0 = this.long0;
  var sinPhy0 = Math.sin(phy0);
  var semiMajorAxis = this.a;
  var invF = this.rf;
  var flattening = 1 / invF;
  var e2 = 2 * flattening - Math.pow(flattening, 2);
  var e = this.e = Math.sqrt(e2);
  this.R = this.k0 * semiMajorAxis * Math.sqrt(1 - e2) / (1 - e2 * Math.pow(sinPhy0, 2));
  this.alpha = Math.sqrt(1 + e2 / (1 - e2) * Math.pow(Math.cos(phy0), 4));
  this.b0 = Math.asin(sinPhy0 / this.alpha);
  var k1 = Math.log(Math.tan(Math.PI / 4 + this.b0 / 2));
  var k2 = Math.log(Math.tan(Math.PI / 4 + phy0 / 2));
  var k3 = Math.log((1 + e * sinPhy0) / (1 - e * sinPhy0));
  this.K = k1 - this.alpha * k2 + this.alpha * e / 2 * k3;
}

function forward(p) {
  var Sa1 = Math.log(Math.tan(Math.PI / 4 - p.y / 2));
  var Sa2 = this.e / 2 * Math.log((1 + this.e * Math.sin(p.y)) / (1 - this.e * Math.sin(p.y)));
  var S = -this.alpha * (Sa1 + Sa2) + this.K;

  // spheric latitude
  var b = 2 * (Math.atan(Math.exp(S)) - Math.PI / 4);

  // spheric longitude
  var I = this.alpha * (p.x - this.lambda0);

  // psoeudo equatorial rotation
  var rotI = Math.atan(Math.sin(I) / (Math.sin(this.b0) * Math.tan(b) + Math.cos(this.b0) * Math.cos(I)));

  var rotB = Math.asin(Math.cos(this.b0) * Math.sin(b) - Math.sin(this.b0) * Math.cos(b) * Math.cos(I));

  p.y = this.R / 2 * Math.log((1 + Math.sin(rotB)) / (1 - Math.sin(rotB))) + this.y0;
  p.x = this.R * rotI + this.x0;
  return p;
}

function inverse(p) {
  var Y = p.x - this.x0;
  var X = p.y - this.y0;

  var rotI = Y / this.R;
  var rotB = 2 * (Math.atan(Math.exp(X / this.R)) - Math.PI / 4);

  var b = Math.asin(Math.cos(this.b0) * Math.sin(rotB) + Math.sin(this.b0) * Math.cos(rotB) * Math.cos(rotI));
  var I = Math.atan(Math.sin(rotI) / (Math.cos(this.b0) * Math.cos(rotI) - Math.sin(this.b0) * Math.tan(rotB)));

  var lambda = this.lambda0 + I / this.alpha;

  var S = 0;
  var phy = b;
  var prevPhy = -1000;
  var iteration = 0;
  while (Math.abs(phy - prevPhy) > 0.0000001) {
    if (++iteration > 20) {
      //...reportError("omercFwdInfinity");
      return;
    }
    //S = Math.log(Math.tan(Math.PI / 4 + phy / 2));
    S = 1 / this.alpha * (Math.log(Math.tan(Math.PI / 4 + b / 2)) - this.K) + this.e * Math.log(Math.tan(Math.PI / 4 + Math.asin(this.e * Math.sin(phy)) / 2));
    prevPhy = phy;
    phy = 2 * Math.atan(Math.exp(S)) - Math.PI / 2;
  }

  p.x = lambda;
  p.y = phy;
  return p;
}

var names = ["somerc"];
/* harmony default export */ __webpack_exports__["a"] = ({
  init: init,
  forward: forward,
  inverse: inverse,
  names: names
});


/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ssfn_ */
/* unused harmony export init */
/* unused harmony export forward */
/* unused harmony export inverse */
/* unused harmony export names */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_values__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_sign__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_msfnz__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_tsfnz__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_phi2z__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_adjust_lon__ = __webpack_require__(33);








function ssfn_(phit, sinphi, eccen) {
  sinphi *= eccen;
  return (Math.tan(0.5 * (__WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */] + phit)) * Math.pow((1 - sinphi) / (1 + sinphi), 0.5 * eccen));
}

function init() {
  this.coslat0 = Math.cos(this.lat0);
  this.sinlat0 = Math.sin(this.lat0);
  if (this.sphere) {
    if (this.k0 === 1 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= __WEBPACK_IMPORTED_MODULE_0__constants_values__["d" /* EPSLN */]) {
      this.k0 = 0.5 * (1 + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_sign__["a" /* default */])(this.lat0) * Math.sin(this.lat_ts));
    }
  }
  else {
    if (Math.abs(this.coslat0) <= __WEBPACK_IMPORTED_MODULE_0__constants_values__["d" /* EPSLN */]) {
      if (this.lat0 > 0) {
        //North pole
        //trace('stere:north pole');
        this.con = 1;
      }
      else {
        //South pole
        //trace('stere:south pole');
        this.con = -1;
      }
    }
    this.cons = Math.sqrt(Math.pow(1 + this.e, 1 + this.e) * Math.pow(1 - this.e, 1 - this.e));
    if (this.k0 === 1 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= __WEBPACK_IMPORTED_MODULE_0__constants_values__["d" /* EPSLN */]) {
      this.k0 = 0.5 * this.cons * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_msfnz__["a" /* default */])(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts)) / __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_tsfnz__["a" /* default */])(this.e, this.con * this.lat_ts, this.con * Math.sin(this.lat_ts));
    }
    this.ms1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_msfnz__["a" /* default */])(this.e, this.sinlat0, this.coslat0);
    this.X0 = 2 * Math.atan(this.ssfn_(this.lat0, this.sinlat0, this.e)) - __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */];
    this.cosX0 = Math.cos(this.X0);
    this.sinX0 = Math.sin(this.X0);
  }
}

// Stereographic forward equations--mapping lat,long to x,y
function forward(p) {
  var lon = p.x;
  var lat = p.y;
  var sinlat = Math.sin(lat);
  var coslat = Math.cos(lat);
  var A, X, sinX, cosX, ts, rh;
  var dlon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_adjust_lon__["a" /* default */])(lon - this.long0);

  if (Math.abs(Math.abs(lon - this.long0) - Math.PI) <= __WEBPACK_IMPORTED_MODULE_0__constants_values__["d" /* EPSLN */] && Math.abs(lat + this.lat0) <= __WEBPACK_IMPORTED_MODULE_0__constants_values__["d" /* EPSLN */]) {
    //case of the origine point
    //trace('stere:this is the origin point');
    p.x = NaN;
    p.y = NaN;
    return p;
  }
  if (this.sphere) {
    //trace('stere:sphere case');
    A = 2 * this.k0 / (1 + this.sinlat0 * sinlat + this.coslat0 * coslat * Math.cos(dlon));
    p.x = this.a * A * coslat * Math.sin(dlon) + this.x0;
    p.y = this.a * A * (this.coslat0 * sinlat - this.sinlat0 * coslat * Math.cos(dlon)) + this.y0;
    return p;
  }
  else {
    X = 2 * Math.atan(this.ssfn_(lat, sinlat, this.e)) - __WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */];
    cosX = Math.cos(X);
    sinX = Math.sin(X);
    if (Math.abs(this.coslat0) <= __WEBPACK_IMPORTED_MODULE_0__constants_values__["d" /* EPSLN */]) {
      ts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_tsfnz__["a" /* default */])(this.e, lat * this.con, this.con * sinlat);
      rh = 2 * this.a * this.k0 * ts / this.cons;
      p.x = this.x0 + rh * Math.sin(lon - this.long0);
      p.y = this.y0 - this.con * rh * Math.cos(lon - this.long0);
      //trace(p.toString());
      return p;
    }
    else if (Math.abs(this.sinlat0) < __WEBPACK_IMPORTED_MODULE_0__constants_values__["d" /* EPSLN */]) {
      //Eq
      //trace('stere:equateur');
      A = 2 * this.a * this.k0 / (1 + cosX * Math.cos(dlon));
      p.y = A * sinX;
    }
    else {
      //other case
      //trace('stere:normal case');
      A = 2 * this.a * this.k0 * this.ms1 / (this.cosX0 * (1 + this.sinX0 * sinX + this.cosX0 * cosX * Math.cos(dlon)));
      p.y = A * (this.cosX0 * sinX - this.sinX0 * cosX * Math.cos(dlon)) + this.y0;
    }
    p.x = A * cosX * Math.sin(dlon) + this.x0;
  }
  //trace(p.toString());
  return p;
}

//* Stereographic inverse equations--mapping x,y to lat/long
function inverse(p) {
  p.x -= this.x0;
  p.y -= this.y0;
  var lon, lat, ts, ce, Chi;
  var rh = Math.sqrt(p.x * p.x + p.y * p.y);
  if (this.sphere) {
    var c = 2 * Math.atan(rh / (0.5 * this.a * this.k0));
    lon = this.long0;
    lat = this.lat0;
    if (rh <= __WEBPACK_IMPORTED_MODULE_0__constants_values__["d" /* EPSLN */]) {
      p.x = lon;
      p.y = lat;
      return p;
    }
    lat = Math.asin(Math.cos(c) * this.sinlat0 + p.y * Math.sin(c) * this.coslat0 / rh);
    if (Math.abs(this.coslat0) < __WEBPACK_IMPORTED_MODULE_0__constants_values__["d" /* EPSLN */]) {
      if (this.lat0 > 0) {
        lon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_adjust_lon__["a" /* default */])(this.long0 + Math.atan2(p.x, - 1 * p.y));
      }
      else {
        lon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_adjust_lon__["a" /* default */])(this.long0 + Math.atan2(p.x, p.y));
      }
    }
    else {
      lon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_adjust_lon__["a" /* default */])(this.long0 + Math.atan2(p.x * Math.sin(c), rh * this.coslat0 * Math.cos(c) - p.y * this.sinlat0 * Math.sin(c)));
    }
    p.x = lon;
    p.y = lat;
    return p;
  }
  else {
    if (Math.abs(this.coslat0) <= __WEBPACK_IMPORTED_MODULE_0__constants_values__["d" /* EPSLN */]) {
      if (rh <= __WEBPACK_IMPORTED_MODULE_0__constants_values__["d" /* EPSLN */]) {
        lat = this.lat0;
        lon = this.long0;
        p.x = lon;
        p.y = lat;
        //trace(p.toString());
        return p;
      }
      p.x *= this.con;
      p.y *= this.con;
      ts = rh * this.cons / (2 * this.a * this.k0);
      lat = this.con * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_phi2z__["a" /* default */])(this.e, ts);
      lon = this.con * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_adjust_lon__["a" /* default */])(this.con * this.long0 + Math.atan2(p.x, - 1 * p.y));
    }
    else {
      ce = 2 * Math.atan(rh * this.cosX0 / (2 * this.a * this.k0 * this.ms1));
      lon = this.long0;
      if (rh <= __WEBPACK_IMPORTED_MODULE_0__constants_values__["d" /* EPSLN */]) {
        Chi = this.X0;
      }
      else {
        Chi = Math.asin(Math.cos(ce) * this.sinX0 + p.y * Math.sin(ce) * this.cosX0 / rh);
        lon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_adjust_lon__["a" /* default */])(this.long0 + Math.atan2(p.x * Math.sin(ce), rh * this.cosX0 * Math.cos(ce) - p.y * this.sinX0 * Math.sin(ce)));
      }
      lat = -1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__common_phi2z__["a" /* default */])(this.e, Math.tan(0.5 * (__WEBPACK_IMPORTED_MODULE_0__constants_values__["a" /* HALF_PI */] + Chi)));
    }
  }
  p.x = lon;
  p.y = lat;

  //trace(p.toString());
  return p;

}

var names = ["stere", "Stereographic_South_Pole", "Polar Stereographic (variant B)"];
/* harmony default export */ __webpack_exports__["a"] = ({
  init: init,
  forward: forward,
  inverse: inverse,
  names: names,
  ssfn_: ssfn_
});


/***/ }),
/* 1222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export init */
/* unused harmony export forward */
/* unused harmony export inverse */
/* unused harmony export names */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gauss__ = __webpack_require__(1205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_adjust_lon__ = __webpack_require__(33);



function init() {
  __WEBPACK_IMPORTED_MODULE_0__gauss__["a" /* default */].init.apply(this);
  if (!this.rc) {
    return;
  }
  this.sinc0 = Math.sin(this.phic0);
  this.cosc0 = Math.cos(this.phic0);
  this.R2 = 2 * this.rc;
  if (!this.title) {
    this.title = "Oblique Stereographic Alternative";
  }
}

function forward(p) {
  var sinc, cosc, cosl, k;
  p.x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_adjust_lon__["a" /* default */])(p.x - this.long0);
  __WEBPACK_IMPORTED_MODULE_0__gauss__["a" /* default */].forward.apply(this, [p]);
  sinc = Math.sin(p.y);
  cosc = Math.cos(p.y);
  cosl = Math.cos(p.x);
  k = this.k0 * this.R2 / (1 + this.sinc0 * sinc + this.cosc0 * cosc * cosl);
  p.x = k * cosc * Math.sin(p.x);
  p.y = k * (this.cosc0 * sinc - this.sinc0 * cosc * cosl);
  p.x = this.a * p.x + this.x0;
  p.y = this.a * p.y + this.y0;
  return p;
}

function inverse(p) {
  var sinc, cosc, lon, lat, rho;
  p.x = (p.x - this.x0) / this.a;
  p.y = (p.y - this.y0) / this.a;

  p.x /= this.k0;
  p.y /= this.k0;
  if ((rho = Math.sqrt(p.x * p.x + p.y * p.y))) {
    var c = 2 * Math.atan2(rho, this.R2);
    sinc = Math.sin(c);
    cosc = Math.cos(c);
    lat = Math.asin(cosc * this.sinc0 + p.y * sinc * this.cosc0 / rho);
    lon = Math.atan2(p.x * sinc, rho * this.cosc0 * cosc - p.y * this.sinc0 * sinc);
  }
  else {
    lat = this.phic0;
    lon = 0;
  }

  p.x = lon;
  p.y = lat;
  __WEBPACK_IMPORTED_MODULE_0__gauss__["a" /* default */].inverse.apply(this, [p]);
  p.x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_adjust_lon__["a" /* default */])(p.x + this.long0);
  return p;
}

var names = ["Stereographic_North_Pole", "Oblique_Stereographic", "Polar_Stereographic", "sterea","Oblique Stereographic Alternative"];
/* harmony default export */ __webpack_exports__["a"] = ({
  init: init,
  forward: forward,
  inverse: inverse,
  names: names
});


/***/ }),
/* 1223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export init */
/* unused harmony export forward */
/* unused harmony export inverse */
/* unused harmony export names */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_pj_enfn__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_pj_mlfn__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_pj_inv_mlfn__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_adjust_lon__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_values__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_sign__ = __webpack_require__(114);
// Heavily based on this tmerc projection implementation
// https://github.com/mbloch/mapshaper-proj/blob/master/src/projections/tmerc.js









function init() {
  this.x0 = this.x0 !== undefined ? this.x0 : 0;
  this.y0 = this.y0 !== undefined ? this.y0 : 0;
  this.long0 = this.long0 !== undefined ? this.long0 : 0;
  this.lat0 = this.lat0 !== undefined ? this.lat0 : 0;

  if (this.es) {
    this.en = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_pj_enfn__["a" /* default */])(this.es);
    this.ml0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_pj_mlfn__["a" /* default */])(this.lat0, Math.sin(this.lat0), Math.cos(this.lat0), this.en);
  }
}

/**
    Transverse Mercator Forward  - long/lat to x/y
    long/lat in radians
  */
function forward(p) {
  var lon = p.x;
  var lat = p.y;

  var delta_lon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_adjust_lon__["a" /* default */])(lon - this.long0);
  var con;
  var x, y;
  var sin_phi = Math.sin(lat);
  var cos_phi = Math.cos(lat);

  if (!this.es) {
    var b = cos_phi * Math.sin(delta_lon);

    if ((Math.abs(Math.abs(b) - 1)) < __WEBPACK_IMPORTED_MODULE_4__constants_values__["d" /* EPSLN */]) {
      return (93);
    }
    else {
      x = 0.5 * this.a * this.k0 * Math.log((1 + b) / (1 - b)) + this.x0;
      y = cos_phi * Math.cos(delta_lon) / Math.sqrt(1 - Math.pow(b, 2));
      b = Math.abs(y);

      if (b >= 1) {
        if ((b - 1) > __WEBPACK_IMPORTED_MODULE_4__constants_values__["d" /* EPSLN */]) {
          return (93);
        }
        else {
          y = 0;
        }
      }
      else {
        y = Math.acos(y);
      }

      if (lat < 0) {
        y = -y;
      }

      y = this.a * this.k0 * (y - this.lat0) + this.y0;
    }
  }
  else {
    var al = cos_phi * delta_lon;
    var als = Math.pow(al, 2);
    var c = this.ep2 * Math.pow(cos_phi, 2);
    var cs = Math.pow(c, 2);
    var tq = Math.abs(cos_phi) > __WEBPACK_IMPORTED_MODULE_4__constants_values__["d" /* EPSLN */] ? Math.tan(lat) : 0;
    var t = Math.pow(tq, 2);
    var ts = Math.pow(t, 2);
    con = 1 - this.es * Math.pow(sin_phi, 2);
    al = al / Math.sqrt(con);
    var ml = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_pj_mlfn__["a" /* default */])(lat, sin_phi, cos_phi, this.en);

    x = this.a * (this.k0 * al * (1 +
      als / 6 * (1 - t + c +
      als / 20 * (5 - 18 * t + ts + 14 * c - 58 * t * c +
      als / 42 * (61 + 179 * ts - ts * t - 479 * t))))) +
      this.x0;

    y = this.a * (this.k0 * (ml - this.ml0 +
      sin_phi * delta_lon * al / 2 * (1 +
      als / 12 * (5 - t + 9 * c + 4 * cs +
      als / 30 * (61 + ts - 58 * t + 270 * c - 330 * t * c +
      als / 56 * (1385 + 543 * ts - ts * t - 3111 * t)))))) +
      this.y0;
  }

  p.x = x;
  p.y = y;

  return p;
}

/**
    Transverse Mercator Inverse  -  x/y to long/lat
  */
function inverse(p) {
  var con, phi;
  var lat, lon;
  var x = (p.x - this.x0) * (1 / this.a);
  var y = (p.y - this.y0) * (1 / this.a);

  if (!this.es) {
    var f = Math.exp(x / this.k0);
    var g = 0.5 * (f - 1 / f);
    var temp = this.lat0 + y / this.k0;
    var h = Math.cos(temp);
    con = Math.sqrt((1 - Math.pow(h, 2)) / (1 + Math.pow(g, 2)));
    lat = Math.asin(con);

    if (y < 0) {
      lat = -lat;
    }

    if ((g === 0) && (h === 0)) {
      lon = 0;
    }
    else {
      lon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_adjust_lon__["a" /* default */])(Math.atan2(g, h) + this.long0);
    }
  }
  else { // ellipsoidal form
    con = this.ml0 + y / this.k0;
    phi = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_pj_inv_mlfn__["a" /* default */])(con, this.es, this.en);

    if (Math.abs(phi) < __WEBPACK_IMPORTED_MODULE_4__constants_values__["a" /* HALF_PI */]) {
      var sin_phi = Math.sin(phi);
      var cos_phi = Math.cos(phi);
      var tan_phi = Math.abs(cos_phi) > __WEBPACK_IMPORTED_MODULE_4__constants_values__["d" /* EPSLN */] ? Math.tan(phi) : 0;
      var c = this.ep2 * Math.pow(cos_phi, 2);
      var cs = Math.pow(c, 2);
      var t = Math.pow(tan_phi, 2);
      var ts = Math.pow(t, 2);
      con = 1 - this.es * Math.pow(sin_phi, 2);
      var d = x * Math.sqrt(con) / this.k0;
      var ds = Math.pow(d, 2);
      con = con * tan_phi;

      lat = phi - (con * ds / (1 - this.es)) * 0.5 * (1 -
        ds / 12 * (5 + 3 * t - 9 * c * t + c - 4 * cs -
        ds / 30 * (61 + 90 * t - 252 * c * t + 45 * ts + 46 * c -
        ds / 56 * (1385 + 3633 * t + 4095 * ts + 1574 * ts * t))));

      lon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__common_adjust_lon__["a" /* default */])(this.long0 + (d * (1 -
        ds / 6 * (1 + 2 * t + c -
        ds / 20 * (5 + 28 * t + 24 * ts + 8 * c * t + 6 * c -
        ds / 42 * (61 + 662 * t + 1320 * ts + 720 * ts * t)))) / cos_phi));
    }
    else {
      lat = __WEBPACK_IMPORTED_MODULE_4__constants_values__["a" /* HALF_PI */] * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_sign__["a" /* default */])(y);
      lon = 0;
    }
  }

  p.x = lon;
  p.y = lat;

  return p;
}

var names = ["Transverse_Mercator", "Transverse Mercator", "tmerc"];
/* harmony default export */ __webpack_exports__["a"] = ({
  init: init,
  forward: forward,
  inverse: inverse,
  names: names
});


/***/ }),
/* 1224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export dependsOn */
/* unused harmony export init */
/* unused harmony export names */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_adjust_zone__ = __webpack_require__(1177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__etmerc__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_values__ = __webpack_require__(28);


var dependsOn = 'etmerc';



function init() {
  var zone = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_adjust_zone__["a" /* default */])(this.zone, this.long0);
  if (zone === undefined) {
    throw new Error('unknown utm zone');
  }
  this.lat0 = 0;
  this.long0 =  ((6 * Math.abs(zone)) - 183) * __WEBPACK_IMPORTED_MODULE_2__constants_values__["g" /* D2R */];
  this.x0 = 500000;
  this.y0 = this.utmSouth ? 10000000 : 0;
  this.k0 = 0.9996;

  __WEBPACK_IMPORTED_MODULE_1__etmerc__["a" /* default */].init.apply(this);
  this.forward = __WEBPACK_IMPORTED_MODULE_1__etmerc__["a" /* default */].forward;
  this.inverse = __WEBPACK_IMPORTED_MODULE_1__etmerc__["a" /* default */].inverse;
}

var names = ["Universal Transverse Mercator System", "utm"];
/* harmony default export */ __webpack_exports__["a"] = ({
  init: init,
  names: names,
  dependsOn: dependsOn
});


/***/ }),
/* 1225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export init */
/* unused harmony export forward */
/* unused harmony export inverse */
/* unused harmony export names */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_adjust_lon__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_values__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_asinz__ = __webpack_require__(98);






/* Initialize the Van Der Grinten projection
  ----------------------------------------*/
function init() {
  //this.R = 6370997; //Radius of earth
  this.R = this.a;
}

function forward(p) {

  var lon = p.x;
  var lat = p.y;

  /* Forward equations
    -----------------*/
  var dlon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_adjust_lon__["a" /* default */])(lon - this.long0);
  var x, y;

  if (Math.abs(lat) <= __WEBPACK_IMPORTED_MODULE_1__constants_values__["d" /* EPSLN */]) {
    x = this.x0 + this.R * dlon;
    y = this.y0;
  }
  var theta = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_asinz__["a" /* default */])(2 * Math.abs(lat / Math.PI));
  if ((Math.abs(dlon) <= __WEBPACK_IMPORTED_MODULE_1__constants_values__["d" /* EPSLN */]) || (Math.abs(Math.abs(lat) - __WEBPACK_IMPORTED_MODULE_1__constants_values__["a" /* HALF_PI */]) <= __WEBPACK_IMPORTED_MODULE_1__constants_values__["d" /* EPSLN */])) {
    x = this.x0;
    if (lat >= 0) {
      y = this.y0 + Math.PI * this.R * Math.tan(0.5 * theta);
    }
    else {
      y = this.y0 + Math.PI * this.R * -Math.tan(0.5 * theta);
    }
    //  return(OK);
  }
  var al = 0.5 * Math.abs((Math.PI / dlon) - (dlon / Math.PI));
  var asq = al * al;
  var sinth = Math.sin(theta);
  var costh = Math.cos(theta);

  var g = costh / (sinth + costh - 1);
  var gsq = g * g;
  var m = g * (2 / sinth - 1);
  var msq = m * m;
  var con = Math.PI * this.R * (al * (g - msq) + Math.sqrt(asq * (g - msq) * (g - msq) - (msq + asq) * (gsq - msq))) / (msq + asq);
  if (dlon < 0) {
    con = -con;
  }
  x = this.x0 + con;
  //con = Math.abs(con / (Math.PI * this.R));
  var q = asq + g;
  con = Math.PI * this.R * (m * q - al * Math.sqrt((msq + asq) * (asq + 1) - q * q)) / (msq + asq);
  if (lat >= 0) {
    //y = this.y0 + Math.PI * this.R * Math.sqrt(1 - con * con - 2 * al * con);
    y = this.y0 + con;
  }
  else {
    //y = this.y0 - Math.PI * this.R * Math.sqrt(1 - con * con - 2 * al * con);
    y = this.y0 - con;
  }
  p.x = x;
  p.y = y;
  return p;
}

/* Van Der Grinten inverse equations--mapping x,y to lat/long
  ---------------------------------------------------------*/
function inverse(p) {
  var lon, lat;
  var xx, yy, xys, c1, c2, c3;
  var a1;
  var m1;
  var con;
  var th1;
  var d;

  /* inverse equations
    -----------------*/
  p.x -= this.x0;
  p.y -= this.y0;
  con = Math.PI * this.R;
  xx = p.x / con;
  yy = p.y / con;
  xys = xx * xx + yy * yy;
  c1 = -Math.abs(yy) * (1 + xys);
  c2 = c1 - 2 * yy * yy + xx * xx;
  c3 = -2 * c1 + 1 + 2 * yy * yy + xys * xys;
  d = yy * yy / c3 + (2 * c2 * c2 * c2 / c3 / c3 / c3 - 9 * c1 * c2 / c3 / c3) / 27;
  a1 = (c1 - c2 * c2 / 3 / c3) / c3;
  m1 = 2 * Math.sqrt(-a1 / 3);
  con = ((3 * d) / a1) / m1;
  if (Math.abs(con) > 1) {
    if (con >= 0) {
      con = 1;
    }
    else {
      con = -1;
    }
  }
  th1 = Math.acos(con) / 3;
  if (p.y >= 0) {
    lat = (-m1 * Math.cos(th1 + Math.PI / 3) - c2 / 3 / c3) * Math.PI;
  }
  else {
    lat = -(-m1 * Math.cos(th1 + Math.PI / 3) - c2 / 3 / c3) * Math.PI;
  }

  if (Math.abs(xx) < __WEBPACK_IMPORTED_MODULE_1__constants_values__["d" /* EPSLN */]) {
    lon = this.long0;
  }
  else {
    lon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_adjust_lon__["a" /* default */])(this.long0 + Math.PI * (xys - 1 + Math.sqrt(1 + 2 * (xx * xx - yy * yy) + xys * xys)) / 2 / xx);
  }

  p.x = lon;
  p.y = lat;
  return p;
}

var names = ["Van_der_Grinten_I", "VanDerGrinten", "vandg"];
/* harmony default export */ __webpack_exports__["a"] = ({
  init: init,
  forward: forward,
  inverse: inverse,
  names: names
});


/***/ }),
/* 1226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__package_json__, "version")) __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__package_json__["version"]; });



/***/ }),
/* 1227 */
/***/ (function(module, exports) {

module.exports = {
	"_args": [
		[
			{
				"raw": "proj4",
				"scope": null,
				"escapedName": "proj4",
				"name": "proj4",
				"rawSpec": "",
				"spec": "latest",
				"type": "tag"
			},
			"/Users/danidoriga/Documents/DANI/Coding/Web/barnatasa5"
		]
	],
	"_from": "proj4@latest",
	"_id": "proj4@2.4.4",
	"_inCache": true,
	"_location": "/proj4",
	"_nodeVersion": "8.2.1",
	"_npmOperationalInternal": {
		"host": "s3://npm-registry-packages",
		"tmp": "tmp/proj4-2.4.4.tgz_1502418137878_0.6641639927402139"
	},
	"_npmUser": {
		"name": "ahocevar",
		"email": "andreas.hocevar@gmail.com"
	},
	"_npmVersion": "5.3.0",
	"_phantomChildren": {},
	"_requested": {
		"raw": "proj4",
		"scope": null,
		"escapedName": "proj4",
		"name": "proj4",
		"rawSpec": "",
		"spec": "latest",
		"type": "tag"
	},
	"_requiredBy": [
		"#USER",
		"/"
	],
	"_resolved": "https://registry.npmjs.org/proj4/-/proj4-2.4.4.tgz",
	"_shasum": "c03d825e380f6850a4a7af5d20d365f6b72c4042",
	"_shrinkwrap": null,
	"_spec": "proj4",
	"_where": "/Users/danidoriga/Documents/DANI/Coding/Web/barnatasa5",
	"author": "",
	"bugs": {
		"url": "https://github.com/proj4js/proj4js/issues"
	},
	"contributors": [
		{
			"name": "Mike Adair",
			"email": "madair@dmsolutions.ca"
		},
		{
			"name": "Richard Greenwood",
			"email": "rich@greenwoodmap.com"
		},
		{
			"name": "Calvin Metcalf",
			"email": "calvin.metcalf@gmail.com"
		},
		{
			"name": "Richard Marsden",
			"url": "http://www.winwaed.com"
		},
		{
			"name": "T. Mittan"
		},
		{
			"name": "D. Steinwand"
		},
		{
			"name": "S. Nelson"
		}
	],
	"dependencies": {
		"mgrs": "1.0.0",
		"wkt-parser": "^1.2.0"
	},
	"description": "Proj4js is a JavaScript library to transform point coordinates from one coordinate system to another, including datum transformations.",
	"devDependencies": {
		"chai": "~1.8.1",
		"curl": "git://github.com/cujojs/curl.git",
		"grunt": "^1.0.1",
		"grunt-cli": "~0.1.13",
		"grunt-contrib-connect": "~0.6.0",
		"grunt-contrib-jshint": "~1.1.0",
		"grunt-contrib-uglify": "~0.11.1",
		"grunt-mocha-phantomjs": "~0.4.0",
		"grunt-rollup": "^1.0.1",
		"istanbul": "~0.2.4",
		"mocha": "~1.17.1",
		"rollup": "^0.41.4",
		"rollup-plugin-json": "^2.0.1",
		"rollup-plugin-node-resolve": "^2.0.0",
		"tin": "~0.4.0"
	},
	"directories": {
		"test": "test",
		"doc": "docs"
	},
	"dist": {
		"integrity": "sha512-yo6qTpBQXnxhcPopKJeVwwOBRzUpEa3vzSFlr38f5mF4Jnfb6NOL/ePIomefWiZmPgkUblHpcwnWVMB8FS3GKw==",
		"shasum": "c03d825e380f6850a4a7af5d20d365f6b72c4042",
		"tarball": "https://registry.npmjs.org/proj4/-/proj4-2.4.4.tgz"
	},
	"gitHead": "e0fc90bb256d5b296c2ec9af923158d0fee847c5",
	"homepage": "https://github.com/proj4js/proj4js#readme",
	"license": "MIT",
	"main": "dist/proj4-src.js",
	"maintainers": [
		{
			"name": "cwmma",
			"email": "calvin.metcalf@gmail.com"
		},
		{
			"name": "ahocevar",
			"email": "andreas.hocevar@gmail.com"
		}
	],
	"module": "lib/index.js",
	"name": "proj4",
	"optionalDependencies": {},
	"readme": "ERROR: No README data found!",
	"repository": {
		"type": "git",
		"url": "git://github.com/proj4js/proj4js.git"
	},
	"scripts": {
		"build": "grunt",
		"build:tmerc": "grunt build:tmerc",
		"test": "npm run build && istanbul test _mocha test/test.js"
	},
	"version": "2.4.4"
};

/***/ }),
/* 1228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_projections_tmerc__ = __webpack_require__(1223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_projections_etmerc__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_projections_utm__ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_projections_sterea__ = __webpack_require__(1222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_projections_stere__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_projections_somerc__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_projections_omerc__ = __webpack_require__(1215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_projections_lcc__ = __webpack_require__(1209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_projections_krovak__ = __webpack_require__(1207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_projections_cass__ = __webpack_require__(1201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_projections_laea__ = __webpack_require__(1208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_projections_aea__ = __webpack_require__(1199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_projections_gnom__ = __webpack_require__(1206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_projections_cea__ = __webpack_require__(1202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__lib_projections_eqc__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lib_projections_poly__ = __webpack_require__(1217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lib_projections_nzmg__ = __webpack_require__(1214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__lib_projections_mill__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__lib_projections_sinu__ = __webpack_require__(1219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__lib_projections_moll__ = __webpack_require__(1213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__lib_projections_eqdc__ = __webpack_require__(1204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__lib_projections_vandg__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__lib_projections_aeqd__ = __webpack_require__(1200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__lib_projections_ortho__ = __webpack_require__(1216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__lib_projections_qsc__ = __webpack_require__(1218);

























/* harmony default export */ __webpack_exports__["a"] = (function(proj4){
  proj4.Proj.projections.add(__WEBPACK_IMPORTED_MODULE_0__lib_projections_tmerc__["a" /* default */]);
  proj4.Proj.projections.add(__WEBPACK_IMPORTED_MODULE_1__lib_projections_etmerc__["a" /* default */]);
  proj4.Proj.projections.add(__WEBPACK_IMPORTED_MODULE_2__lib_projections_utm__["a" /* default */]);
  proj4.Proj.projections.add(__WEBPACK_IMPORTED_MODULE_3__lib_projections_sterea__["a" /* default */]);
  proj4.Proj.projections.add(__WEBPACK_IMPORTED_MODULE_4__lib_projections_stere__["a" /* default */]);
  proj4.Proj.projections.add(__WEBPACK_IMPORTED_MODULE_5__lib_projections_somerc__["a" /* default */]);
  proj4.Proj.projections.add(__WEBPACK_IMPORTED_MODULE_6__lib_projections_omerc__["a" /* default */]);
  proj4.Proj.projections.add(__WEBPACK_IMPORTED_MODULE_7__lib_projections_lcc__["a" /* default */]);
  proj4.Proj.projections.add(__WEBPACK_IMPORTED_MODULE_8__lib_projections_krovak__["a" /* default */]);
  proj4.Proj.projections.add(__WEBPACK_IMPORTED_MODULE_9__lib_projections_cass__["a" /* default */]);
  proj4.Proj.projections.add(__WEBPACK_IMPORTED_MODULE_10__lib_projections_laea__["a" /* default */]);
  proj4.Proj.projections.add(__WEBPACK_IMPORTED_MODULE_11__lib_projections_aea__["a" /* default */]);
  proj4.Proj.projections.add(__WEBPACK_IMPORTED_MODULE_12__lib_projections_gnom__["a" /* default */]);
  proj4.Proj.projections.add(__WEBPACK_IMPORTED_MODULE_13__lib_projections_cea__["a" /* default */]);
  proj4.Proj.projections.add(__WEBPACK_IMPORTED_MODULE_14__lib_projections_eqc__["a" /* default */]);
  proj4.Proj.projections.add(__WEBPACK_IMPORTED_MODULE_15__lib_projections_poly__["a" /* default */]);
  proj4.Proj.projections.add(__WEBPACK_IMPORTED_MODULE_16__lib_projections_nzmg__["a" /* default */]);
  proj4.Proj.projections.add(__WEBPACK_IMPORTED_MODULE_17__lib_projections_mill__["a" /* default */]);
  proj4.Proj.projections.add(__WEBPACK_IMPORTED_MODULE_18__lib_projections_sinu__["a" /* default */]);
  proj4.Proj.projections.add(__WEBPACK_IMPORTED_MODULE_19__lib_projections_moll__["a" /* default */]);
  proj4.Proj.projections.add(__WEBPACK_IMPORTED_MODULE_20__lib_projections_eqdc__["a" /* default */]);
  proj4.Proj.projections.add(__WEBPACK_IMPORTED_MODULE_21__lib_projections_vandg__["a" /* default */]);
  proj4.Proj.projections.add(__WEBPACK_IMPORTED_MODULE_22__lib_projections_aeqd__["a" /* default */]);
  proj4.Proj.projections.add(__WEBPACK_IMPORTED_MODULE_23__lib_projections_ortho__["a" /* default */]);
  proj4.Proj.projections.add(__WEBPACK_IMPORTED_MODULE_24__lib_projections_qsc__["a" /* default */]);
});

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return punycode;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(234)(module), __webpack_require__(38)))

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 1231 */
/***/ (function(module, exports) {

function select(element) {
    var selectedText;

    if (element.nodeName === 'SELECT') {
        element.focus();

        selectedText = element.value;
    }
    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
        var isReadOnly = element.hasAttribute('readonly');

        if (!isReadOnly) {
            element.setAttribute('readonly', '');
        }

        element.select();
        element.setSelectionRange(0, element.value.length);

        if (!isReadOnly) {
            element.removeAttribute('readonly');
        }

        selectedText = element.value;
    }
    else {
        if (element.hasAttribute('contenteditable')) {
            element.focus();
        }

        var selection = window.getSelection();
        var range = document.createRange();

        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);

        selectedText = selection.toString();
    }

    return selectedText;
}

module.exports = select;


/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38), __webpack_require__(213)))

/***/ }),
/* 1233 */
/***/ (function(module, exports) {

/*!
 * string_score.js: String Scoring Algorithm 0.1.22
 *
 * http://joshaven.com/string_score
 * https://github.com/joshaven/string_score
 *
 * Copyright (C) 2009-2014 Joshaven Potter <yourtech@gmail.com>
 * Special thanks to all of the contributors listed here https://github.com/joshaven/string_score
 * MIT License: http://opensource.org/licenses/MIT
 *
 * Date: Tue Mar 1 2011
 * Updated: Tue Mar 10 2015
*/

/*jslint nomen:true, white:true, browser:true,devel:true */

/**
 * Scores a string against another string.
 *    'Hello World'.score('he');         //=> 0.5931818181818181
 *    'Hello World'.score('Hello');    //=> 0.7318181818181818
 */
String.prototype.score = function (word, fuzziness) {
  'use strict';

  // If the string is equal to the word, perfect match.
  if (this === word) { return 1; }

  //if it's not a perfect match and is empty return 0
  if (word === "") { return 0; }

  var runningScore = 0,
      charScore,
      finalScore,
      string = this,
      lString = string.toLowerCase(),
      strLength = string.length,
      lWord = word.toLowerCase(),
      wordLength = word.length,
      idxOf,
      startAt = 0,
      fuzzies = 1,
      fuzzyFactor,
      i;

  // Cache fuzzyFactor for speed increase
  if (fuzziness) { fuzzyFactor = 1 - fuzziness; }

  // Walk through word and add up scores.
  // Code duplication occurs to prevent checking fuzziness inside for loop
  if (fuzziness) {
    for (i = 0; i < wordLength; i+=1) {

      // Find next first case-insensitive match of a character.
      idxOf = lString.indexOf(lWord[i], startAt);

      if (idxOf === -1) {
        fuzzies += fuzzyFactor;
      } else {
        if (startAt === idxOf) {
          // Consecutive letter & start-of-string Bonus
          charScore = 0.7;
        } else {
          charScore = 0.1;

          // Acronym Bonus
          // Weighing Logic: Typing the first character of an acronym is as if you
          // preceded it with two perfect character matches.
          if (string[idxOf - 1] === ' ') { charScore += 0.8; }
        }

        // Same case bonus.
        if (string[idxOf] === word[i]) { charScore += 0.1; }

        // Update scores and startAt position for next round of indexOf
        runningScore += charScore;
        startAt = idxOf + 1;
      }
    }
  } else {
    for (i = 0; i < wordLength; i+=1) {
      idxOf = lString.indexOf(lWord[i], startAt);
      if (-1 === idxOf) { return 0; }

      if (startAt === idxOf) {
        charScore = 0.7;
      } else {
        charScore = 0.1;
        if (string[idxOf - 1] === ' ') { charScore += 0.8; }
      }
      if (string[idxOf] === word[i]) { charScore += 0.1; }
      runningScore += charScore;
      startAt = idxOf + 1;
    }
  }

  // Reduce penalty for longer strings.
  finalScore = 0.5 * (runningScore / strLength    + runningScore / wordLength) / fuzzies;

  if ((lWord[0] === lString[0]) && (finalScore < 0.85)) {
    finalScore += 0.15;
  }

  return finalScore;
};


/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(933);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(220)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js!./vue-circle-slider.css", function() {
			var newContent = require("!!../../css-loader/index.js!./vue-circle-slider.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1235 */
/***/ (function(module, exports) {

function E () {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    };

    listener._ = callback
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;


/***/ }),
/* 1236 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 1237 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = __webpack_require__.i({"NODE_ENV":"production"}).NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(1237);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(1236);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38), __webpack_require__(213)))

/***/ }),
/* 1239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"500px":{"width":1536,"height":1792,"paths":[{"d":"M1401 1547l-6 6q-113 113-259 175-154 64-317 64-165 0-317-64-148-63-259-175-113-112-175-258-42-103-54-189-4-28 48-36 51-8 56 20 1 1 1 4 18 90 46 159 50 124 152 226 98 98 226 152 132 56 276 56 143 0 276-56 128-55 225-152l6-6q10-10 25-6 12 3 33 22 36 37 17 58zM929 932l-66 66 63 63q21 21-7 49-17 17-32 17-10 0-19-10l-62-61-66 66q-5 5-15 5-15 0-31-16l-2-2q-18-15-18-29 0-7 8-17l66-65-66-66q-16-16 14-45 18-18 31-18 6 0 13 5l65 66 65-65q18-17 48 13 27 27 11 44zM1400 989q0 118-46 228-45 105-126 186-80 80-187 126t-228 46-228-46-187-126q-82-82-125-186-15-33-15-40h-1q-9-27 43-44 50-16 60 12 37 99 97 167h1v-339-2q3-136 102-232 105-103 253-103 147 0 251 103t104 249q0 147-104.5 251t-250.5 104q-58 0-112-16-28-11-13-61 16-51 44-43l14 3q14 3 33 6t30 3q104 0 176-71.5t72-174.5q0-101-72-171-71-71-175-71-107 0-178 80-64 72-64 160v413q110 67 242 67 96 0 185-36.5t156-103.5 103.5-155 36.5-183q0-198-141-339-140-140-339-140-200 0-340 140-53 53-77 87l-2 2q-8 11-13 15.5t-21.5 9.5-38.5-3q-21-5-36.5-16.5t-15.5-26.5v-680q0-15 10.5-26.5t27.5-11.5h877q30 0 30 55t-30 55h-811v483h1q40-42 102-84t108-61q109-46 231-46 121 0 228 46t187 126q81 81 126 186 46 112 46 229zM1369 408q9 8 9 18t-5.5 18-16.5 21q-26 26-39 26-9 0-16-7-106-91-207-133-128-56-276-56-133 0-262 49-27 10-45-37-9-25-8-38 3-16 16-20 130-57 299-57 164 0 316 64 137 58 235 152z"}]}})


/***/ }),
/* 1240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"address-book-o":{"width":1664,"height":1792,"paths":[{"d":"M1028 644q0 107-76.5 183t-183.5 76-183.5-76-76.5-183q0-108 76.5-184t183.5-76 183.5 76 76.5 184zM980 864q46 0 82.5 17t60 47.5 39.5 67 24 81 11.5 82.5 3.5 79q0 67-39.5 118.5t-105.5 51.5h-576q-66 0-105.5-51.5t-39.5-118.5q0-48 4.5-93.5t18.5-98.5 36.5-91.5 63-64.5 93.5-26h5q7 4 32 19.5t35.5 21 33 17 37 16 35 9 39.5 4.5 39.5-4.5 35-9 37-16 33-17 35.5-21 32-19.5zM1664 608q0 13-9.5 22.5t-22.5 9.5h-96v128h96q13 0 22.5 9.5t9.5 22.5v192q0 13-9.5 22.5t-22.5 9.5h-96v128h96q13 0 22.5 9.5t9.5 22.5v192q0 13-9.5 22.5t-22.5 9.5h-96v224q0 66-47 113t-113 47h-1216q-66 0-113-47t-47-113v-1472q0-66 47-113t113-47h1216q66 0 113 47t47 113v224h96q13 0 22.5 9.5t9.5 22.5v192zM1408 1632v-1472q0-13-9.5-22.5t-22.5-9.5h-1216q-13 0-22.5 9.5t-9.5 22.5v1472q0 13 9.5 22.5t22.5 9.5h1216q13 0 22.5-9.5t9.5-22.5z"}]}})


/***/ }),
/* 1241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"address-book":{"width":1664,"height":1792,"paths":[{"d":"M1201 1238q0-57-5.5-107t-21-100.5-39.5-86-64-58-91-22.5q-6 4-33.5 20.5t-42.5 24.5-40.5 20-49 17-46.5 5-46.5-5-49-17-40.5-20-42.5-24.5-33.5-20.5q-51 0-91 22.5t-64 58-39.5 86-21 100.5-5.5 107q0 73 42 121.5t103 48.5h576q61 0 103-48.5t42-121.5zM1028 644q0-108-76.5-184t-183.5-76-183.5 76-76.5 184q0 107 76.5 183t183.5 76 183.5-76 76.5-183zM1664 1184v192q0 14-9 23t-23 9h-96v224q0 66-47 113t-113 47h-1216q-66 0-113-47t-47-113v-1472q0-66 47-113t113-47h1216q66 0 113 47t47 113v224h96q14 0 23 9t9 23v192q0 14-9 23t-23 9h-96v128h96q14 0 23 9t9 23v192q0 14-9 23t-23 9h-96v128h96q14 0 23 9t9 23z"}]}})


/***/ }),
/* 1242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"address-card-o":{"width":2048,"height":1792,"paths":[{"d":"M1024 1131q0 64-37 106.5t-91 42.5h-512q-54 0-91-42.5t-37-106.5 9-117.5 29.5-103 60.5-78 97-28.5q6 4 30 18t37.5 21.5 35.5 17.5 43 14.5 42 4.5 42-4.5 43-14.5 35.5-17.5 37.5-21.5 30-18q57 0 97 28.5t60.5 78 29.5 103 9 117.5zM867 611q0 94-66.5 160.5t-160.5 66.5-160.5-66.5-66.5-160.5 66.5-160.5 160.5-66.5 160.5 66.5 66.5 160.5zM1792 1056v64q0 14-9 23t-23 9h-576q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h576q14 0 23 9t9 23zM1792 804v56q0 15-10.5 25.5t-25.5 10.5h-568q-15 0-25.5-10.5t-10.5-25.5v-56q0-15 10.5-25.5t25.5-10.5h568q15 0 25.5 10.5t10.5 25.5zM1792 544v64q0 14-9 23t-23 9h-576q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h576q14 0 23 9t9 23zM1920 1504v-1216q0-13-9.5-22.5t-22.5-9.5h-1728q-13 0-22.5 9.5t-9.5 22.5v1216q0 13 9.5 22.5t22.5 9.5h352v-96q0-14 9-23t23-9h64q14 0 23 9t9 23v96h768v-96q0-14 9-23t23-9h64q14 0 23 9t9 23v96h352q13 0 22.5-9.5t9.5-22.5zM2048 288v1216q0 66-47 113t-113 47h-1728q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1728q66 0 113 47t47 113z"}]}})


/***/ }),
/* 1243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"address-card":{"width":2048,"height":1792,"paths":[{"d":"M1024 1131q0-64-9-117.5t-29.5-103-60.5-78-97-28.5q-6 4-30 18t-37.5 21.5-35.5 17.5-43 14.5-42 4.5-42-4.5-43-14.5-35.5-17.5-37.5-21.5-30-18q-57 0-97 28.5t-60.5 78-29.5 103-9 117.5 37 106.5 91 42.5h512q54 0 91-42.5t37-106.5zM867 611q0-94-66.5-160.5t-160.5-66.5-160.5 66.5-66.5 160.5 66.5 160.5 160.5 66.5 160.5-66.5 66.5-160.5zM1792 1120v-64q0-14-9-23t-23-9h-576q-14 0-23 9t-9 23v64q0 14 9 23t23 9h576q14 0 23-9t9-23zM1792 860v-56q0-15-10.5-25.5t-25.5-10.5h-568q-15 0-25.5 10.5t-10.5 25.5v56q0 15 10.5 25.5t25.5 10.5h568q15 0 25.5-10.5t10.5-25.5zM1792 608v-64q0-14-9-23t-23-9h-576q-14 0-23 9t-9 23v64q0 14 9 23t23 9h576q14 0 23-9t9-23zM2048 288v1216q0 66-47 113t-113 47h-352v-96q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v96h-768v-96q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v96h-352q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1728q66 0 113 47t47 113z"}]}})


/***/ }),
/* 1244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"adjust":{"width":1536,"height":1792,"paths":[{"d":"M768 1440v-1088q-148 0-273 73t-198 198-73 273 73 273 198 198 273 73zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"adn":{"width":1536,"height":1792,"paths":[{"d":"M768 622l201 306h-402zM1133 1152h94l-459-691-459 691h94l104-160h522zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"align-center":{"width":1792,"height":1792,"paths":[{"d":"M1792 1344v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zM1408 960v128q0 26-19 45t-45 19h-896q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h896q26 0 45 19t19 45zM1664 576v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zM1280 192v128q0 26-19 45t-45 19h-640q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h640q26 0 45 19t19 45z"}]}})


/***/ }),
/* 1247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"align-justify":{"width":1792,"height":1792,"paths":[{"d":"M1792 1344v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zM1792 960v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zM1792 576v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zM1792 192v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45z"}]}})


/***/ }),
/* 1248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"align-left":{"width":1792,"height":1792,"paths":[{"d":"M1792 1344v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zM1408 960v128q0 26-19 45t-45 19h-1280q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1280q26 0 45 19t19 45zM1664 576v128q0 26-19 45t-45 19h-1536q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1536q26 0 45 19t19 45zM1280 192v128q0 26-19 45t-45 19h-1152q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1152q26 0 45 19t19 45z"}]}})


/***/ }),
/* 1249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"align-right":{"width":1792,"height":1792,"paths":[{"d":"M1792 1344v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zM1792 960v128q0 26-19 45t-45 19h-1280q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1280q26 0 45 19t19 45zM1792 576v128q0 26-19 45t-45 19h-1536q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1536q26 0 45 19t19 45zM1792 192v128q0 26-19 45t-45 19h-1152q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1152q26 0 45 19t19 45z"}]}})


/***/ }),
/* 1250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"amazon":{"width":1792,"height":1792,"paths":[{"d":"M1551 1476q15-6 26-3t11 17.5-15 33.5q-13 16-44 43.5t-95.5 68-141 74-188 58-229.5 24.5q-119 0-238-31t-209-76.5-172.5-104-132.5-105-84-87.5q-8-9-10-16.5t1-12 8-7 11.5-2 11.5 4.5q192 117 300 166 389 176 799 90 190-40 391-135zM1758 1361q11 16 2.5 69.5t-28.5 102.5q-34 83-85 124-17 14-26 9t0-24q21-45 44.5-121.5t6.5-98.5q-5-7-15.5-11.5t-27-6-29.5-2.5-35 0-31.5 2-31 3-22.5 2q-6 1-13 1.5t-11 1-8.5 1-7 0.5h-5.5-4.5t-3-0.5-2-1.5l-1.5-3q-6-16 47-40t103-30q46-7 108-1t76 24zM1364 918q0 31 13.5 64t32 58 37.5 46 33 32l13 11-227 224q-40-37-79-75.5t-58-58.5l-19-20q-11-11-25-33-38 59-97.5 102.5t-127.5 63.5-140 23-137.5-21-117.5-65.5-83-113-31-162.5q0-84 28-154t72-116.5 106.5-83 122.5-57 130-34.5 119.5-18.5 99.5-6.5v-127q0-65-21-97-34-53-121-53-6 0-16.5 1t-40.5 12-56 29.5-56 59.5-48 96l-294-27q0-60 22-119t67-113 108-95 151.5-65.5 190.5-24.5q100 0 181 25t129.5 61.5 81 83 45 86 12.5 73.5v589zM692 939q0 86 70 133 66 44 139 22 84-25 114-123 14-45 14-101v-162q-59 2-111 12t-106.5 33.5-87 71-32.5 114.5z"}]}})


/***/ }),
/* 1251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"ambulance":{"width":1920,"height":1792,"paths":[{"d":"M640 1408q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM256 896h384v-256h-158q-14 2-22 9l-195 195q-7 12-9 22v30zM1536 1408q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1664 736v-192q0-14-9-23t-23-9h-224v-224q0-14-9-23t-23-9h-192q-14 0-23 9t-9 23v224h-224q-14 0-23 9t-9 23v192q0 14 9 23t23 9h224v224q0 14 9 23t23 9h192q14 0 23-9t9-23v-224h224q14 0 23-9t9-23zM1920 192v1152q0 26-19 45t-45 19h-192q0 106-75 181t-181 75-181-75-75-181h-384q0 106-75 181t-181 75-181-75-75-181h-128q-26 0-45-19t-19-45 19-45 45-19v-416q0-26 13-58t32-51l198-198q19-19 51-32t58-13h160v-320q0-26 19-45t45-19h1152q26 0 45 19t19 45z"}]}})


/***/ }),
/* 1252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"american-sign-language-interpreting":{"width":2304,"height":1792,"paths":[{"d":"M1032 960q-59-2-84-55-17-34-48-53.5t-68-19.5q-53 0-90.5 37.5t-37.5 90.5q0 56 36 89l10 8q34 31 82 31 37 0 68-19.5t48-53.5q25-53 84-55zM1600 832q0-56-36-89l-10-8q-34-31-82-31-37 0-68 19.5t-48 53.5q-25 53-84 55 59 2 84 55 17 34 48 53.5t68 19.5q53 0 90.5-37.5t37.5-90.5zM1174 611q-17 35-55 48t-73-4q-62-31-134-31-51 0-99 17 3 0 9.5-0.5t9.5-0.5q92 0 170.5 50t118.5 133q17 36 3.5 73.5t-49.5 54.5q-18 9-39 9 21 0 39 9 36 17 49.5 54.5t-3.5 73.5q-40 83-118.5 133t-170.5 50h-6q-16-2-44-4l-290-27-239 120q-14 7-29 7-40 0-57-35l-160-320q-11-23-4-47.5t29-37.5l209-119 148-267q17-155 91.5-291.5t195.5-236.5q31-25 70.5-21.5t64.5 34.5 21.5 70-34.5 65q-70 59-117 128 123-84 267-101 40-5 71.5 19t35.5 64q5 40-19 71.5t-64 35.5q-84 10-159 55 46-10 99-10 115 0 218 50 36 18 49 55.5t-5 73.5zM2137 451l160 320q11 23 4 47.5t-29 37.5l-209 119-148 267q-17 155-91.5 291.5t-195.5 236.5q-26 22-61 22-45 0-74-35-25-31-21.5-70t34.5-65q70-59 117-128-123 84-267 101-4 1-12 1-36 0-63.5-24t-31.5-60q-5-40 19-71.5t64-35.5q84-10 159-55-46 10-99 10-115 0-218-50-36-18-49-55.5t5-73.5q17-35 55-48t73 4q62 31 134 31 51 0 99-17-3 0-9.5 0.5t-9.5 0.5q-92 0-170.5-50t-118.5-133q-17-36-3.5-73.5t49.5-54.5q18-9 39-9-21 0-39-9-36-17-49.5-54.5t3.5-73.5q40-83 118.5-133t170.5-50h6 1q14 2 42 4l291 27 239-120q14-7 29-7 40 0 57 35z"}]}})


/***/ }),
/* 1253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"anchor":{"width":1792,"height":1792,"paths":[{"d":"M960 256q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zM1792 1184v352q0 22-20 30-8 2-12 2-12 0-23-9l-93-93q-119 143-318.5 226.5t-429.5 83.5-429.5-83.5-318.5-226.5l-93 93q-9 9-23 9-4 0-12-2-20-8-20-30v-352q0-14 9-23t23-9h352q22 0 30 20 8 19-7 35l-100 100q67 91 189.5 153.5t271.5 82.5v-647h-192q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h192v-163q-58-34-93-92.5t-35-128.5q0-106 75-181t181-75 181 75 75 181q0 70-35 128.5t-93 92.5v163h192q26 0 45 19t19 45v128q0 26-19 45t-45 19h-192v647q149-20 271.5-82.5t189.5-153.5l-100-100q-15-16-7-35 8-20 30-20h352q14 0 23 9t9 23z"}]}})


/***/ }),
/* 1254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"android":{"width":1408,"height":1792,"paths":[{"d":"M493 483q16 0 27.5-11.5t11.5-27.5-11.5-27.5-27.5-11.5-27 11.5-11 27.5 11 27.5 27 11.5zM915 483q16 0 27-11.5t11-27.5-11-27.5-27-11.5-27.5 11.5-11.5 27.5 11.5 27.5 27.5 11.5zM103 667q42 0 72 30t30 72v430q0 43-29.5 73t-72.5 30-73-30-30-73v-430q0-42 30-72t73-30zM1163 686v666q0 46-32 78t-77 32h-75v227q0 43-30 73t-73 30-73-30-30-73v-227h-138v227q0 43-30 73t-73 30q-42 0-72-30t-30-73l-1-227h-74q-46 0-78-32t-32-78v-666h918zM931 281q107 55 171 153.5t64 215.5h-925q0-117 64-215.5t172-153.5l-71-131q-7-13 5-20 13-6 20 6l72 132q95-42 201-42t201 42l72-132q7-12 20-6 12 7 5 20zM1408 769v430q0 43-30 73t-73 30q-42 0-72-30t-30-73v-430q0-43 30-72.5t72-29.5q43 0 73 29.5t30 72.5z"}]}})


/***/ }),
/* 1255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"angellist":{"width":1280,"height":1792,"paths":[{"d":"M953 378l-114 328 117 21q165-451 165-518 0-56-38-56-57 0-130 225zM654 1065l33 88q37-42 71-67l-33-5.5t-38.5-7-32.5-8.5zM362 169q0 98 159 521 17-10 49-10 15 0 75 5l-121-351q-75-220-123-220-19 0-29 17.5t-10 37.5zM283 928q0 36 51.5 119t117.5 153 100 70q14 0 25.5-13t11.5-27q0-24-32-102-13-32-32-72t-47.5-89-61.5-81-62-32q-20 0-45.5 27t-25.5 47zM125 1263q0 41 25 104 59 145 183.5 227t281.5 82q227 0 382-170 152-169 152-427 0-43-1-67t-11.5-62-30.5-56q-56-49-211.5-75.5t-270.5-26.5q-37 0-49 11-12 5-12 35 0 34 21.5 60t55.5 40 77.5 23.5 87.5 11.5 85 4 70 0h23q24 0 40 19 15 19 19 55-28 28-96 54-61 22-93 46-64 46-108.5 114t-44.5 137q0 31 18.5 88.5t18.5 87.5l-3 12q-4 12-4 14-137-10-146-216-8 2-41 2 2 7 2 21 0 53-40.5 89.5t-94.5 36.5q-82 0-166.5-78t-84.5-159q0-34 33-67 52 64 60 76 77 104 133 104 12 0 26.5-8.5t14.5-20.5q0-34-87.5-145t-116.5-111q-43 0-70 44.5t-27 90.5zM11 1272q0-101 42.5-163t136.5-88q-28-74-28-104 0-62 61-123t122-61q29 0 70 15-163-462-163-567 0-80 41-130.5t119-50.5q131 0 325 581 6 17 8 23 6-16 29-79.5t43.5-118.5 54-127.5 64.5-123 70.5-86.5 76.5-36q71 0 112 49t41 122q0 108-159 550 61 15 100.5 46t58.5 78 26 93.5 7 110.5q0 150-47 280t-132 225-211 150-278 55q-111 0-223-42-149-57-258-191.5t-109-286.5z"}]}})


/***/ }),
/* 1256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"angle-double-down":{"width":1152,"height":1792,"paths":[{"d":"M1075 864q0 13-10 23l-466 466q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l393 393 393-393q10-10 23-10t23 10l50 50q10 10 10 23zM1075 480q0 13-10 23l-466 466q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l393 393 393-393q10-10 23-10t23 10l50 50q10 10 10 23z"}]}})


/***/ }),
/* 1257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"angle-double-left":{"width":1024,"height":1792,"paths":[{"d":"M627 1376q0 13-10 23l-50 50q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l50 50q10 10 10 23t-10 23l-393 393 393 393q10 10 10 23zM1011 1376q0 13-10 23l-50 50q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l50 50q10 10 10 23t-10 23l-393 393 393 393q10 10 10 23z"}]}})


/***/ }),
/* 1258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"angle-double-right":{"width":1024,"height":1792,"paths":[{"d":"M595 960q0 13-10 23l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23zM979 960q0 13-10 23l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23z"}]}})


/***/ }),
/* 1259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"angle-double-up":{"width":1152,"height":1792,"paths":[{"d":"M1075 1312q0 13-10 23l-50 50q-10 10-23 10t-23-10l-393-393-393 393q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l466 466q10 10 10 23zM1075 928q0 13-10 23l-50 50q-10 10-23 10t-23-10l-393-393-393 393q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l466 466q10 10 10 23z"}]}})


/***/ }),
/* 1260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"angle-down":{"width":1152,"height":1792,"paths":[{"d":"M1075 736q0 13-10 23l-466 466q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l393 393 393-393q10-10 23-10t23 10l50 50q10 10 10 23z"}]}})


/***/ }),
/* 1261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"angle-left":{"width":640,"height":1792,"paths":[{"d":"M627 544q0 13-10 23l-393 393 393 393q10 10 10 23t-10 23l-50 50q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l50 50q10 10 10 23z"}]}})


/***/ }),
/* 1262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"angle-right":{"width":640,"height":1792,"paths":[{"d":"M595 960q0 13-10 23l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23z"}]}})


/***/ }),
/* 1263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"angle-up":{"width":1152,"height":1792,"paths":[{"d":"M1075 1184q0 13-10 23l-50 50q-10 10-23 10t-23-10l-393-393-393 393q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l466 466q10 10 10 23z"}]}})


/***/ }),
/* 1264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"apple":{"width":1408,"height":1792,"paths":[{"d":"M1393 1215q-39 125-123 250-129 196-257 196-49 0-140-32-86-32-151-32-61 0-142 33-81 34-132 34-152 0-301-259-147-261-147-503 0-228 113-374 113-144 284-144 72 0 177 30 104 30 138 30 45 0 143-34 102-34 173-34 119 0 213 65 52 36 104 100-79 67-114 118-65 94-65 207 0 124 69 223t158 126zM1017 42q0 61-29 136-30 75-93 138-54 54-108 72-37 11-104 17 3-149 78-257 74-107 250-148 1 3 2.5 11t2.5 11q0 4 0.5 10t0.5 10z"}]}})


/***/ }),
/* 1265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"archive":{"width":1792,"height":1792,"paths":[{"d":"M1088 832q0-26-19-45t-45-19h-256q-26 0-45 19t-19 45 19 45 45 19h256q26 0 45-19t19-45zM1664 640v960q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-960q0-26 19-45t45-19h1408q26 0 45 19t19 45zM1728 192v256q0 26-19 45t-45 19h-1536q-26 0-45-19t-19-45v-256q0-26 19-45t45-19h1536q26 0 45 19t19 45z"}]}})


/***/ }),
/* 1266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"area-chart":{"width":2048,"height":1792,"paths":[{"d":"M2048 1536v128h-2048v-1536h128v1408h1920zM1664 512l256 896h-1664v-576l448-576 576 576z"}]}})


/***/ }),
/* 1267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"arrow-circle-down":{"width":1536,"height":1792,"paths":[{"d":"M1284 897q0-27-18-45l-91-91q-18-18-45-18t-45 18l-189 189v-502q0-26-19-45t-45-19h-128q-26 0-45 19t-19 45v502l-189-189q-19-19-45-19t-45 19l-91 91q-18 18-18 45t18 45l362 362 91 91q18 18 45 18t45-18l91-91 362-362q18-18 18-45zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"arrow-circle-left":{"width":1536,"height":1792,"paths":[{"d":"M1280 960v-128q0-26-19-45t-45-19h-502l189-189q19-19 19-45t-19-45l-91-91q-18-18-45-18t-45 18l-362 362-91 91q-18 18-18 45t18 45l91 91 362 362q18 18 45 18t45-18l91-91q18-18 18-45t-18-45l-189-189h502q26 0 45-19t19-45zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"arrow-circle-o-down":{"width":1536,"height":1792,"paths":[{"d":"M1120 928q0 12-10 24l-319 319q-11 9-23 9t-23-9l-320-320q-15-16-7-35 8-20 30-20h192v-352q0-14 9-23t23-9h192q14 0 23 9t9 23v352h192q14 0 23 9t9 23zM768 352q-148 0-273 73t-198 198-73 273 73 273 198 198 273 73 273-73 198-198 73-273-73-273-198-198-273-73zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"arrow-circle-o-left":{"width":1536,"height":1792,"paths":[{"d":"M1152 800v192q0 13-9.5 22.5t-22.5 9.5h-352v192q0 14-9 23t-23 9q-12 0-24-10l-319-319q-9-9-9-23t9-23l320-320q9-9 23-9 13 0 22.5 9.5t9.5 22.5v192h352q13 0 22.5 9.5t9.5 22.5zM1312 896q0-148-73-273t-198-198-273-73-273 73-198 198-73 273 73 273 198 198 273 73 273-73 198-198 73-273zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"arrow-circle-o-right":{"width":1536,"height":1792,"paths":[{"d":"M1152 896q0 14-9 23l-320 320q-9 9-23 9-13 0-22.5-9.5t-9.5-22.5v-192h-352q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h352v-192q0-14 9-23t23-9q12 0 24 10l319 319q9 9 9 23zM1312 896q0-148-73-273t-198-198-273-73-273 73-198 198-73 273 73 273 198 198 273 73 273-73 198-198 73-273zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"arrow-circle-o-up":{"width":1536,"height":1792,"paths":[{"d":"M1118 876q-8 20-30 20h-192v352q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-352h-192q-14 0-23-9t-9-23q0-12 10-24l319-319q11-9 23-9t23 9l320 320q15 16 7 35zM768 352q-148 0-273 73t-198 198-73 273 73 273 198 198 273 73 273-73 198-198 73-273-73-273-198-198-273-73zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"arrow-circle-right":{"width":1536,"height":1792,"paths":[{"d":"M1285 896q0-27-18-45l-91-91-362-362q-18-18-45-18t-45 18l-91 91q-18 18-18 45t18 45l189 189h-502q-26 0-45 19t-19 45v128q0 26 19 45t45 19h502l-189 189q-19 19-19 45t19 45l91 91q18 18 45 18t45-18l362-362 91-91q18-18 18-45zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"arrow-circle-up":{"width":1536,"height":1792,"paths":[{"d":"M1284 895q0-27-18-45l-362-362-91-91q-18-18-45-18t-45 18l-91 91-362 362q-18 18-18 45t18 45l91 91q18 18 45 18t45-18l189-189v502q0 26 19 45t45 19h128q26 0 45-19t19-45v-502l189 189q19 19 45 19t45-19l91-91q18-18 18-45zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"arrow-down":{"width":1664,"height":1792,"paths":[{"d":"M1611 832q0 53-37 90l-651 652q-39 37-91 37-53 0-90-37l-651-652q-38-36-38-90 0-53 38-91l74-75q39-37 91-37 53 0 90 37l294 294v-704q0-52 38-90t90-38h128q52 0 90 38t38 90v704l294-294q37-37 90-37 52 0 91 37l75 75q37 39 37 91z"}]}})


/***/ }),
/* 1276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"arrow-left":{"width":1536,"height":1792,"paths":[{"d":"M1536 896v128q0 53-32.5 90.5t-84.5 37.5h-704l293 294q38 36 38 90t-38 90l-75 76q-37 37-90 37-52 0-91-37l-651-652q-37-37-37-90 0-52 37-91l651-650q38-38 91-38 52 0 90 38l75 74q38 38 38 91t-38 91l-293 293h704q52 0 84.5 37.5t32.5 90.5z"}]}})


/***/ }),
/* 1277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"arrow-right":{"width":1536,"height":1792,"paths":[{"d":"M1472 960q0 54-37 91l-651 651q-39 37-91 37-51 0-90-37l-75-75q-38-38-38-91t38-91l293-293h-704q-52 0-84.5-37.5t-32.5-90.5v-128q0-53 32.5-90.5t84.5-37.5h704l-293-294q-38-36-38-90t38-90l75-75q38-38 90-38 53 0 91 38l651 651q37 35 37 90z"}]}})


/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"arrow-up":{"width":1664,"height":1792,"paths":[{"d":"M1611 971q0 51-37 90l-75 75q-38 38-91 38-54 0-90-38l-294-293v704q0 52-37.5 84.5t-90.5 32.5h-128q-53 0-90.5-32.5t-37.5-84.5v-704l-294 293q-36 38-90 38t-90-38l-75-75q-38-38-38-90 0-53 38-91l651-651q35-37 90-37 54 0 91 37l651 651q37 39 37 91z"}]}})


/***/ }),
/* 1279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"arrows-alt":{"width":1536,"height":1792,"paths":[{"d":"M1283 541l-355 355 355 355 144-144q29-31 70-14 39 17 39 59v448q0 26-19 45t-45 19h-448q-42 0-59-40-17-39 14-69l144-144-355-355-355 355 144 144q31 30 14 69-17 40-59 40h-448q-26 0-45-19t-19-45v-448q0-42 40-59 39-17 69 14l144 144 355-355-355-355-144 144q-19 19-45 19-12 0-24-5-40-17-40-59v-448q0-26 19-45t45-19h448q42 0 59 40 17 39-14 69l-144 144 355 355 355-355-144-144q-31-30-14-69 17-40 59-40h448q26 0 45 19t19 45v448q0 42-39 59-13 5-25 5-26 0-45-19z"}]}})


/***/ }),
/* 1280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"arrows-h":{"width":1792,"height":1792,"paths":[{"d":"M1792 896q0 26-19 45l-256 256q-19 19-45 19t-45-19-19-45v-128h-1024v128q0 26-19 45t-45 19-45-19l-256-256q-19-19-19-45t19-45l256-256q19-19 45-19t45 19 19 45v128h1024v-128q0-26 19-45t45-19 45 19l256 256q19 19 19 45z"}]}})


/***/ }),
/* 1281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"arrows-v":{"width":768,"height":1792,"paths":[{"d":"M704 320q0 26-19 45t-45 19h-128v1024h128q26 0 45 19t19 45-19 45l-256 256q-19 19-45 19t-45-19l-256-256q-19-19-19-45t19-45 45-19h128v-1024h-128q-26 0-45-19t-19-45 19-45l256-256q19-19 45-19t45 19l256 256q19 19 19 45z"}]}})


/***/ }),
/* 1282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"arrows":{"width":1792,"height":1792,"paths":[{"d":"M1792 896q0 26-19 45l-256 256q-19 19-45 19t-45-19-19-45v-128h-384v384h128q26 0 45 19t19 45-19 45l-256 256q-19 19-45 19t-45-19l-256-256q-19-19-19-45t19-45 45-19h128v-384h-384v128q0 26-19 45t-45 19-45-19l-256-256q-19-19-19-45t19-45l256-256q19-19 45-19t45 19 19 45v128h384v-384h-128q-26 0-45-19t-19-45 19-45l256-256q19-19 45-19t45 19l256 256q19 19 19 45t-19 45-45 19h-128v384h384v-128q0-26 19-45t45-19 45 19l256 256q19 19 19 45z"}]}})


/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"asl-interpreting":{"width":2304,"height":1792,"paths":[{"d":"M1032 960q-59-2-84-55-17-34-48-53.5t-68-19.5q-53 0-90.5 37.5t-37.5 90.5q0 56 36 89l10 8q34 31 82 31 37 0 68-19.5t48-53.5q25-53 84-55zM1600 832q0-56-36-89l-10-8q-34-31-82-31-37 0-68 19.5t-48 53.5q-25 53-84 55 59 2 84 55 17 34 48 53.5t68 19.5q53 0 90.5-37.5t37.5-90.5zM1174 611q-17 35-55 48t-73-4q-62-31-134-31-51 0-99 17 3 0 9.5-0.5t9.5-0.5q92 0 170.5 50t118.5 133q17 36 3.5 73.5t-49.5 54.5q-18 9-39 9 21 0 39 9 36 17 49.5 54.5t-3.5 73.5q-40 83-118.5 133t-170.5 50h-6q-16-2-44-4l-290-27-239 120q-14 7-29 7-40 0-57-35l-160-320q-11-23-4-47.5t29-37.5l209-119 148-267q17-155 91.5-291.5t195.5-236.5q31-25 70.5-21.5t64.5 34.5 21.5 70-34.5 65q-70 59-117 128 123-84 267-101 40-5 71.5 19t35.5 64q5 40-19 71.5t-64 35.5q-84 10-159 55 46-10 99-10 115 0 218 50 36 18 49 55.5t-5 73.5zM2137 451l160 320q11 23 4 47.5t-29 37.5l-209 119-148 267q-17 155-91.5 291.5t-195.5 236.5q-26 22-61 22-45 0-74-35-25-31-21.5-70t34.5-65q70-59 117-128-123 84-267 101-4 1-12 1-36 0-63.5-24t-31.5-60q-5-40 19-71.5t64-35.5q84-10 159-55-46 10-99 10-115 0-218-50-36-18-49-55.5t5-73.5q17-35 55-48t73 4q62 31 134 31 51 0 99-17-3 0-9.5 0.5t-9.5 0.5q-92 0-170.5-50t-118.5-133q-17-36-3.5-73.5t49.5-54.5q18-9 39-9-21 0-39-9-36-17-49.5-54.5t3.5-73.5q40-83 118.5-133t170.5-50h6 1q14 2 42 4l291 27 239-120q14-7 29-7 40 0 57 35z"}]}})


/***/ }),
/* 1284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"assistive-listening-systems":{"width":1792,"height":1792,"paths":[{"d":"M128 1728q0 26-19 45t-45 19-45-19-19-45 19-45 45-19 45 19 19 45zM320 1536q0 26-19 45t-45 19-45-19-19-45 19-45 45-19 45 19 19 45zM365 1171l256 256-90 90-256-256zM704 1152q0 26-19 45t-45 19-45-19-19-45 19-45 45-19 45 19 19 45zM1411 832q0 59-11.5 108.5t-37.5 93.5-44 67.5-53 64.5q-31 35-45.5 54t-33.5 50-26.5 64-7.5 74q0 159-112.5 271.5t-271.5 112.5q-26 0-45-19t-19-45 19-45 45-19q106 0 181-75t75-181q0-57 11.5-105.5t37-91 43.5-66.5 52-63q40-46 59.5-72t37.5-74.5 18-103.5q0-185-131.5-316.5t-316.5-131.5-316.5 131.5-131.5 316.5q0 26-19 45t-45 19-45-19-19-45q0-117 45.5-223.5t123-184 184-123 223.5-45.5 223.5 45.5 184 123 123 184 45.5 223.5zM896 960q0 26-19 45t-45 19-45-19-19-45 19-45 45-19 45 19 19 45zM1184 832q0 26-19 45t-45 19-45-19-19-45q0-93-65.5-158.5t-158.5-65.5q-92 0-158 65.5t-66 158.5q0 26-19 45t-45 19-45-19-19-45q0-146 103-249t249-103 249 103 103 249zM1578 543q10 25-1 49t-36 34q-9 4-23 4-19 0-35.5-11t-23.5-30q-68-178-224-295-21-16-25-42t12-47q17-21 43-25t47 12q183 137 266 351zM1788 462q9 25-1.5 49t-35.5 34q-11 4-23 4-44 0-60-41-92-238-297-393-22-16-25.5-42t12.5-47q16-22 42-25.5t47 12.5q235 175 341 449z"}]}})


/***/ }),
/* 1285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"asterisk":{"width":1664,"height":1792,"paths":[{"d":"M1482 1050q46 26 59.5 77.5t-12.5 97.5l-64 110q-26 46-77.5 59.5t-97.5-12.5l-266-153v307q0 52-38 90t-90 38h-128q-52 0-90-38t-38-90v-307l-266 153q-46 26-97.5 12.5t-77.5-59.5l-64-110q-26-46-12.5-97.5t59.5-77.5l266-154-266-154q-46-26-59.5-77.5t12.5-97.5l64-110q26-46 77.5-59.5t97.5 12.5l266 153v-307q0-52 38-90t90-38h128q52 0 90 38t38 90v307l266-153q46-26 97.5-12.5t77.5 59.5l64 110q26 46 12.5 97.5t-59.5 77.5l-266 154z"}]}})


/***/ }),
/* 1286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"at":{"width":1536,"height":1792,"paths":[{"d":"M972 775q0-108-53.5-169t-147.5-61q-63 0-124 30.5t-110 84.5-79.5 137-30.5 180q0 112 53.5 173t150.5 61q96 0 176-66.5t122.5-166 42.5-203.5zM1536 896q0 111-37 197t-98.5 135-131.5 74.5-145 27.5q-6 0-15.5 0.5t-16.5 0.5q-95 0-142-53-28-33-33-83-52 66-131.5 110t-173.5 44q-161 0-249.5-95.5t-88.5-269.5q0-157 66-290t179-210.5 246-77.5q87 0 155 35.5t106 99.5l2-19 11-56q1-6 5.5-12t9.5-6h118q5 0 13 11 5 5 3 16l-120 614q-5 24-5 48 0 39 12.5 52t44.5 13q28-1 57-5.5t73-24 77-50 57-89.5 24-137q0-292-174-466t-466-174q-130 0-248.5 51t-204 136.5-136.5 204-51 248.5 51 248.5 136.5 204 204 136.5 248.5 51q228 0 405-144 11-9 24-8t21 12l41 49q8 12 7 24-2 13-12 22-102 83-227.5 128t-258.5 45q-156 0-298-61t-245-164-164-245-61-298 61-298 164-245 245-164 298-61q344 0 556 212t212 556z"}]}})


/***/ }),
/* 1287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"audio-description":{"width":2304,"height":1792,"paths":[{"d":"M504 994h171l-1-265zM1530 895q0-87-50.5-140t-146.5-53h-54v388h52q91 0 145-57t54-138zM956 518l1 756q0 14-9.5 24t-23.5 10h-216q-14 0-23.5-10t-9.5-24v-62h-291l-55 81q-10 15-28 15h-267q-21 0-30.5-18t3.5-35l556-757q9-14 27-14h332q14 0 24 10t10 24zM1783 895q0 193-125.5 303t-324.5 110h-270q-14 0-24-10t-10-24v-756q0-14 10-24t24-10h268q200 0 326 109t126 302zM1939 896q0 11-0.5 29t-8 71.5-21.5 102-44.5 108-73.5 102.5h-51q38-45 66.5-104.5t41.5-112 21-98 9-72.5l1-27q0-8-0.5-22.5t-7.5-60-20-91.5-41-111.5-66-124.5h43q41 47 72 107t45.5 111.5 23 96 10.5 70.5zM2123 896q0 11-0.5 29t-8 71.5-21.5 102-45 108-74 102.5h-51q38-45 66.5-104.5t41.5-112 21-98 9-72.5l1-27q0-8-0.5-22.5t-7.5-60-19.5-91.5-40.5-111.5-66-124.5h43q41 47 72 107t45.5 111.5 23 96 10.5 70.5zM2304 896q0 11-0.5 29t-8 71.5-21.5 102-44.5 108-73.5 102.5h-51q38-45 66-104.5t41-112 21-98 9-72.5l1-27q0-8-0.5-22.5t-7.5-60-19.5-91.5-40.5-111.5-66-124.5h43q41 47 72 107t45.5 111.5 23 96 9.5 70.5z"}]}})


/***/ }),
/* 1288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"automobile":{"width":2048,"height":1792,"paths":[{"d":"M480 1088q0-66-47-113t-113-47-113 47-47 113 47 113 113 47 113-47 47-113zM516 768h1016l-89-357q-2-8-14-17.5t-21-9.5h-768q-9 0-21 9.5t-14 17.5zM1888 1088q0-66-47-113t-113-47-113 47-47 113 47 113 113 47 113-47 47-113zM2048 992v384q0 14-9 23t-23 9h-96v128q0 80-56 136t-136 56-136-56-56-136v-128h-1024v128q0 80-56 136t-136 56-136-56-56-136v-128h-96q-14 0-23-9t-9-23v-384q0-93 65.5-158.5t158.5-65.5h28l105-419q23-94 104-157.5t179-63.5h768q98 0 179 63.5t104 157.5l105 419h28q93 0 158.5 65.5t65.5 158.5z"}]}})


/***/ }),
/* 1289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"backward":{"width":1664,"height":1792,"paths":[{"d":"M1619 141q19-19 32-13t13 32v1472q0 26-13 32t-32-13l-710-710q-9-9-13-19v710q0 26-13 32t-32-13l-710-710q-19-19-19-45t19-45l710-710q19-19 32-13t13 32v710q4-10 13-19z"}]}})


/***/ }),
/* 1290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"balance-scale":{"width":2304,"height":1792,"paths":[{"d":"M1728 448l-384 704h768zM448 448l-384 704h768zM1269 256q-14 40-45.5 71.5t-71.5 45.5v1291h608q14 0 23 9t9 23v64q0 14-9 23t-23 9h-1344q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h608v-1291q-40-14-71.5-45.5t-45.5-71.5h-491q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h491q21-57 70-92.5t111-35.5 111 35.5 70 92.5h491q14 0 23 9t9 23v64q0 14-9 23t-23 9h-491zM1088 272q33 0 56.5-23.5t23.5-56.5-23.5-56.5-56.5-23.5-56.5 23.5-23.5 56.5 23.5 56.5 56.5 23.5zM2176 1152q0 73-46.5 131t-117.5 91-144.5 49.5-139.5 16.5-139.5-16.5-144.5-49.5-117.5-91-46.5-131q0-11 35-81t92-174.5 107-195.5 102-184 56-100q18-33 56-33t56 33q4 7 56 100t102 184 107 195.5 92 174.5 35 81zM896 1152q0 73-46.5 131t-117.5 91-144.5 49.5-139.5 16.5-139.5-16.5-144.5-49.5-117.5-91-46.5-131q0-11 35-81t92-174.5 107-195.5 102-184 56-100q18-33 56-33t56 33q4 7 56 100t102 184 107 195.5 92 174.5 35 81z"}]}})


/***/ }),
/* 1291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"ban":{"width":1536,"height":1792,"paths":[{"d":"M1312 893q0-161-87-295l-754 753q137 89 297 89 111 0 211.5-43.5t173.5-116.5 116-174.5 43-212.5zM313 1192l755-754q-135-91-300-91-148 0-273 73t-198 199-73 274q0 162 89 299zM1536 893q0 157-61 300t-163.5 246-245 164-298.5 61-298.5-61-245-164-163.5-246-61-300 61-299.5 163.5-245.5 245-164 298.5-61 298.5 61 245 164 163.5 245.5 61 299.5z"}]}})


/***/ }),
/* 1292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"bandcamp":{"width":1792,"height":1792,"paths":[{"d":"M1070 1178l306-564h-654l-306 564h654zM1792 896q0 182-71 348t-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71 348 71 286 191 191 286 71 348z"}]}})


/***/ }),
/* 1293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"bank":{"width":2048,"height":1792,"paths":[{"d":"M960 0l960 384v128h-128q0 26-20.5 45t-48.5 19h-1526q-28 0-48.5-19t-20.5-45h-128v-128zM256 640h256v768h128v-768h256v768h128v-768h256v768h128v-768h256v768h59q28 0 48.5 19t20.5 45v64h-1664v-64q0-26 20.5-45t48.5-19h59v-768zM1851 1600q28 0 48.5 19t20.5 45v128h-1920v-128q0-26 20.5-45t48.5-19h1782z"}]}})


/***/ }),
/* 1294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"bar-chart-o":{"width":2048,"height":1792,"paths":[{"d":"M640 896v512h-256v-512h256zM1024 384v1024h-256v-1024h256zM2048 1536v128h-2048v-1536h128v1408h1920zM1408 640v768h-256v-768h256zM1792 256v1152h-256v-1152h256z"}]}})


/***/ }),
/* 1295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"bar-chart":{"width":2048,"height":1792,"paths":[{"d":"M640 896v512h-256v-512h256zM1024 384v1024h-256v-1024h256zM2048 1536v128h-2048v-1536h128v1408h1920zM1408 640v768h-256v-768h256zM1792 256v1152h-256v-1152h256z"}]}})


/***/ }),
/* 1296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"barcode":{"width":1792,"height":1792,"paths":[{"d":"M63 1536h-63v-1408h63v1408zM126 1535h-32v-1407h32v1407zM220 1535h-31v-1407h31v1407zM377 1535h-31v-1407h31v1407zM534 1535h-62v-1407h62v1407zM660 1535h-31v-1407h31v1407zM723 1535h-31v-1407h31v1407zM786 1535h-31v-1407h31v1407zM943 1535h-63v-1407h63v1407zM1100 1535h-63v-1407h63v1407zM1226 1535h-63v-1407h63v1407zM1352 1535h-63v-1407h63v1407zM1446 1535h-63v-1407h63v1407zM1635 1535h-94v-1407h94v1407zM1698 1535h-32v-1407h32v1407zM1792 1536h-63v-1408h63v1408z"}]}})


/***/ }),
/* 1297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"bars":{"width":1536,"height":1792,"paths":[{"d":"M1536 1344v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zM1536 832v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zM1536 320v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45z"}]}})


/***/ }),
/* 1298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"bath":{"width":1792,"height":1792,"paths":[{"d":"M1664 1088v192q0 169-128 286v194q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-118q-63 22-128 22h-768q-65 0-128-22v110q0 17-9.5 28.5t-22.5 11.5h-64q-13 0-22.5-11.5t-9.5-28.5v-186q-128-117-128-286v-192h1536zM704 672q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM768 608q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM704 544q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM832 544q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM768 480q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM704 416q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM1792 928v64q0 14-9 23t-23 9h-1728q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h96v-640q0-106 75-181t181-75q108 0 184 78 46-19 98-12t93 39l22-22q11-11 22 0l42 42q11 11 0 22l-314 314q-11 11-22 0l-42-42q-11-11 0-22l22-22q-36-46-40.5-104t23.5-108q-37-35-88-35-53 0-90.5 37.5t-37.5 90.5v640h1504q14 0 23 9t9 23zM896 480q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM832 416q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM768 352q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM960 416q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM896 352q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM832 288q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM1024 352q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM960 288q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM1088 288q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23z"}]}})


/***/ }),
/* 1299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"bathtub":{"width":1792,"height":1792,"paths":[{"d":"M1664 1088v192q0 169-128 286v194q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-118q-63 22-128 22h-768q-65 0-128-22v110q0 17-9.5 28.5t-22.5 11.5h-64q-13 0-22.5-11.5t-9.5-28.5v-186q-128-117-128-286v-192h1536zM704 672q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM768 608q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM704 544q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM832 544q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM768 480q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM704 416q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM1792 928v64q0 14-9 23t-23 9h-1728q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h96v-640q0-106 75-181t181-75q108 0 184 78 46-19 98-12t93 39l22-22q11-11 22 0l42 42q11 11 0 22l-314 314q-11 11-22 0l-42-42q-11-11 0-22l22-22q-36-46-40.5-104t23.5-108q-37-35-88-35-53 0-90.5 37.5t-37.5 90.5v640h1504q14 0 23 9t9 23zM896 480q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM832 416q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM768 352q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM960 416q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM896 352q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM832 288q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM1024 352q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM960 288q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM1088 288q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23z"}]}})


/***/ }),
/* 1300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"battery-0":{"width":2304,"height":1792,"paths":[{"d":"M2176 576q53 0 90.5 37.5t37.5 90.5v384q0 53-37.5 90.5t-90.5 37.5v160q0 66-47 113t-113 47h-1856q-66 0-113-47t-47-113v-960q0-66 47-113t113-47h1856q66 0 113 47t47 113v160zM2176 1088v-384h-128v-288q0-14-9-23t-23-9h-1856q-14 0-23 9t-9 23v960q0 14 9 23t23 9h1856q14 0 23-9t9-23v-288h128z"}]}})


/***/ }),
/* 1301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"battery-1":{"width":2304,"height":1792,"paths":[{"d":"M256 1280v-768h512v768h-512zM2176 576q53 0 90.5 37.5t37.5 90.5v384q0 53-37.5 90.5t-90.5 37.5v160q0 66-47 113t-113 47h-1856q-66 0-113-47t-47-113v-960q0-66 47-113t113-47h1856q66 0 113 47t47 113v160zM2176 1088v-384h-128v-288q0-14-9-23t-23-9h-1856q-14 0-23 9t-9 23v960q0 14 9 23t23 9h1856q14 0 23-9t9-23v-288h128z"}]}})


/***/ }),
/* 1302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"battery-2":{"width":2304,"height":1792,"paths":[{"d":"M256 1280v-768h896v768h-896zM2176 576q53 0 90.5 37.5t37.5 90.5v384q0 53-37.5 90.5t-90.5 37.5v160q0 66-47 113t-113 47h-1856q-66 0-113-47t-47-113v-960q0-66 47-113t113-47h1856q66 0 113 47t47 113v160zM2176 1088v-384h-128v-288q0-14-9-23t-23-9h-1856q-14 0-23 9t-9 23v960q0 14 9 23t23 9h1856q14 0 23-9t9-23v-288h128z"}]}})


/***/ }),
/* 1303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"battery-3":{"width":2304,"height":1792,"paths":[{"d":"M256 1280v-768h1280v768h-1280zM2176 576q53 0 90.5 37.5t37.5 90.5v384q0 53-37.5 90.5t-90.5 37.5v160q0 66-47 113t-113 47h-1856q-66 0-113-47t-47-113v-960q0-66 47-113t113-47h1856q66 0 113 47t47 113v160zM2176 1088v-384h-128v-288q0-14-9-23t-23-9h-1856q-14 0-23 9t-9 23v960q0 14 9 23t23 9h1856q14 0 23-9t9-23v-288h128z"}]}})


/***/ }),
/* 1304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"battery-4":{"width":2304,"height":1792,"paths":[{"d":"M1920 512v768h-1664v-768h1664zM2048 1088h128v-384h-128v-288q0-14-9-23t-23-9h-1856q-14 0-23 9t-9 23v960q0 14 9 23t23 9h1856q14 0 23-9t9-23v-288zM2304 704v384q0 53-37.5 90.5t-90.5 37.5v160q0 66-47 113t-113 47h-1856q-66 0-113-47t-47-113v-960q0-66 47-113t113-47h1856q66 0 113 47t47 113v160q53 0 90.5 37.5t37.5 90.5z"}]}})


/***/ }),
/* 1305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"battery-empty":{"width":2304,"height":1792,"paths":[{"d":"M2176 576q53 0 90.5 37.5t37.5 90.5v384q0 53-37.5 90.5t-90.5 37.5v160q0 66-47 113t-113 47h-1856q-66 0-113-47t-47-113v-960q0-66 47-113t113-47h1856q66 0 113 47t47 113v160zM2176 1088v-384h-128v-288q0-14-9-23t-23-9h-1856q-14 0-23 9t-9 23v960q0 14 9 23t23 9h1856q14 0 23-9t9-23v-288h128z"}]}})


/***/ }),
/* 1306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"battery-full":{"width":2304,"height":1792,"paths":[{"d":"M1920 512v768h-1664v-768h1664zM2048 1088h128v-384h-128v-288q0-14-9-23t-23-9h-1856q-14 0-23 9t-9 23v960q0 14 9 23t23 9h1856q14 0 23-9t9-23v-288zM2304 704v384q0 53-37.5 90.5t-90.5 37.5v160q0 66-47 113t-113 47h-1856q-66 0-113-47t-47-113v-960q0-66 47-113t113-47h1856q66 0 113 47t47 113v160q53 0 90.5 37.5t37.5 90.5z"}]}})


/***/ }),
/* 1307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"battery-half":{"width":2304,"height":1792,"paths":[{"d":"M256 1280v-768h896v768h-896zM2176 576q53 0 90.5 37.5t37.5 90.5v384q0 53-37.5 90.5t-90.5 37.5v160q0 66-47 113t-113 47h-1856q-66 0-113-47t-47-113v-960q0-66 47-113t113-47h1856q66 0 113 47t47 113v160zM2176 1088v-384h-128v-288q0-14-9-23t-23-9h-1856q-14 0-23 9t-9 23v960q0 14 9 23t23 9h1856q14 0 23-9t9-23v-288h128z"}]}})


/***/ }),
/* 1308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"battery-quarter":{"width":2304,"height":1792,"paths":[{"d":"M256 1280v-768h512v768h-512zM2176 576q53 0 90.5 37.5t37.5 90.5v384q0 53-37.5 90.5t-90.5 37.5v160q0 66-47 113t-113 47h-1856q-66 0-113-47t-47-113v-960q0-66 47-113t113-47h1856q66 0 113 47t47 113v160zM2176 1088v-384h-128v-288q0-14-9-23t-23-9h-1856q-14 0-23 9t-9 23v960q0 14 9 23t23 9h1856q14 0 23-9t9-23v-288h128z"}]}})


/***/ }),
/* 1309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"battery-three-quarters":{"width":2304,"height":1792,"paths":[{"d":"M256 1280v-768h1280v768h-1280zM2176 576q53 0 90.5 37.5t37.5 90.5v384q0 53-37.5 90.5t-90.5 37.5v160q0 66-47 113t-113 47h-1856q-66 0-113-47t-47-113v-960q0-66 47-113t113-47h1856q66 0 113 47t47 113v160zM2176 1088v-384h-128v-288q0-14-9-23t-23-9h-1856q-14 0-23 9t-9 23v960q0 14 9 23t23 9h1856q14 0 23-9t9-23v-288h128z"}]}})


/***/ }),
/* 1310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"battery":{"width":2304,"height":1792,"paths":[{"d":"M1920 512v768h-1664v-768h1664zM2048 1088h128v-384h-128v-288q0-14-9-23t-23-9h-1856q-14 0-23 9t-9 23v960q0 14 9 23t23 9h1856q14 0 23-9t9-23v-288zM2304 704v384q0 53-37.5 90.5t-90.5 37.5v160q0 66-47 113t-113 47h-1856q-66 0-113-47t-47-113v-960q0-66 47-113t113-47h1856q66 0 113 47t47 113v160q53 0 90.5 37.5t37.5 90.5z"}]}})


/***/ }),
/* 1311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"bed":{"width":2048,"height":1792,"paths":[{"d":"M256 1024h1728q26 0 45 19t19 45v448h-256v-256h-1536v256h-256v-1216q0-26 19-45t45-19h128q26 0 45 19t19 45v704zM832 704q0-106-75-181t-181-75-181 75-75 181 75 181 181 75 181-75 75-181zM2048 960v-64q0-159-112.5-271.5t-271.5-112.5h-704q-26 0-45 19t-19 45v384h1152z"}]}})


/***/ }),
/* 1312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"beer":{"width":1664,"height":1792,"paths":[{"d":"M640 896v-384h-256v256q0 53 37.5 90.5t90.5 37.5h128zM1664 1344v192h-1152v-192l128-192h-128q-159 0-271.5-112.5t-112.5-271.5v-320l-64-64 32-128h480l32-128h960l32 192-64 32v800z"}]}})


/***/ }),
/* 1313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"behance-square":{"width":1536,"height":1792,"paths":[{"d":"M1248 128q119 0 203.5 84.5t84.5 203.5v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960zM499 495h-371v787h382q117 0 197-57.5t80-170.5q0-158-143-200 107-52 107-164 0-57-19.5-96.5t-56.5-60.5-79-29.5-97-8.5zM477 813h-176v-184h163q119 0 119 90 0 94-106 94zM486 1148h-185v-217h189q124 0 124 113 0 104-128 104zM1136 1180q-68 0-104-38t-36-107h411q1-10 1-30 0-132-74.5-220.5t-203.5-88.5q-128 0-210 86t-82 216q0 135 79 217t213 82q205 0 267-191h-138q-11 34-47.5 54t-75.5 20zM1126 814q113 0 124 122h-254q4-56 39-89t91-33zM964 548h319v77h-319v-77z"}]}})


/***/ }),
/* 1314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"behance":{"width":2048,"height":1792,"paths":[{"d":"M1848 339h-511v124h511v-124zM1596 765q-90 0-146 52.5t-62 142.5h408q-18-195-200-195zM1612 1350q63 0 122-32t76-87h221q-100 307-427 307-214 0-340.5-132t-126.5-347q0-208 130.5-345.5t336.5-137.5q138 0 240.5 68t153 179 50.5 248q0 17-2 47h-658q0 111 57.5 171.5t166.5 60.5zM277 1300h296q205 0 205-167 0-180-199-180h-302v347zM277 763h281q78 0 123.5-36.5t45.5-113.5q0-144-190-144h-260v294zM0 254h594q87 0 155 14t126.5 47.5 90 96.5 31.5 154q0 181-172 263 114 32 172 115t58 204q0 75-24.5 136.5t-66 103.5-98.5 71-121 42-134 13h-611v-1260z"}]}})


/***/ }),
/* 1315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"bell-o":{"width":1792,"height":1792,"paths":[{"d":"M912 1696q0-16-16-16-59 0-101.5-42.5t-42.5-101.5q0-16-16-16t-16 16q0 73 51.5 124.5t124.5 51.5q16 0 16-16zM246 1408h1300q-266-300-266-832 0-51-24-105t-69-103-121.5-80.5-169.5-31.5-169.5 31.5-121.5 80.5-69 103-24 105q0 532-266 832zM1728 1408q0 52-38 90t-90 38h-448q0 106-75 181t-181 75-181-75-75-181h-448q-52 0-90-38t-38-90q50-42 91-88t85-119.5 74.5-158.5 50-206 19.5-260q0-152 117-282.5t307-158.5q-8-19-8-39 0-40 28-68t68-28 68 28 28 68q0 20-8 39 190 28 307 158.5t117 282.5q0 139 19.5 260t50 206 74.5 158.5 85 119.5 91 88z"}]}})


/***/ }),
/* 1316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"bell-slash-o":{"width":2048,"height":1792,"paths":[{"d":"M1040 1696q0-16-16-16-59 0-101.5-42.5t-42.5-101.5q0-16-16-16t-16 16q0 73 51.5 124.5t124.5 51.5q16 0 16-16zM503 1221l877-760q-42-88-132.5-146.5t-223.5-58.5q-93 0-169.5 31.5t-121.5 80.5-69 103-24 105q0 384-137 645zM1856 1408q0 52-38 90t-90 38h-448q0 106-75 181t-181 75-180.5-74.5-75.5-180.5l149-129h757q-166-187-227-459l111-97q61 356 298 556zM1942 16l84 96q8 10 7.5 23.5t-10.5 22.5l-1872 1622q-10 8-23.5 7t-21.5-11l-84-96q-8-10-7.5-23.5t10.5-21.5l186-161q-19-32-19-66 50-42 91-88t85-119.5 74.5-158.5 50-206 19.5-260q0-152 117-282.5t307-158.5q-8-19-8-39 0-40 28-68t68-28 68 28 28 68q0 20-8 39 124 18 219 82.5t148 157.5l418-363q10-8 23.5-7t21.5 11z"}]}})


/***/ }),
/* 1317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"bell-slash":{"width":2048,"height":1792,"paths":[{"d":"M1558 852q61 356 298 556 0 52-38 90t-90 38h-448q0 106-75 181t-181 75-180.5-74.5-75.5-180.5zM1024 1712q16 0 16-16t-16-16q-59 0-101.5-42.5t-42.5-101.5q0-16-16-16t-16 16q0 73 51.5 124.5t124.5 51.5zM2026 112q8 10 7.5 23.5t-10.5 22.5l-1872 1622q-10 8-23.5 7t-21.5-11l-84-96q-8-10-7.5-23.5t10.5-21.5l186-161q-19-32-19-66 50-42 91-88t85-119.5 74.5-158.5 50-206 19.5-260q0-152 117-282.5t307-158.5q-8-19-8-39 0-40 28-68t68-28 68 28 28 68q0 20-8 39 124 18 219 82.5t148 157.5l418-363q10-8 23.5-7t21.5 11z"}]}})


/***/ }),
/* 1318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"bell":{"width":1792,"height":1792,"paths":[{"d":"M912 1696q0-16-16-16-59 0-101.5-42.5t-42.5-101.5q0-16-16-16t-16 16q0 73 51.5 124.5t124.5 51.5q16 0 16-16zM1728 1408q0 52-38 90t-90 38h-448q0 106-75 181t-181 75-181-75-75-181h-448q-52 0-90-38t-38-90q50-42 91-88t85-119.5 74.5-158.5 50-206 19.5-260q0-152 117-282.5t307-158.5q-8-19-8-39 0-40 28-68t68-28 68 28 28 68q0 20-8 39 190 28 307 158.5t117 282.5q0 139 19.5 260t50 206 74.5 158.5 85 119.5 91 88z"}]}})


/***/ }),
/* 1319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"bicycle":{"width":2304,"height":1792,"paths":[{"d":"M762 1152h-314q-40 0-57.5-35t6.5-67l188-251q-65-31-137-31-132 0-226 94t-94 226 94 226 226 94q115 0 203-72.5t111-183.5zM576 1024h186q-18-85-75-148zM1056 1024l288-384h-480l-99 132q105 103 126 252h165zM2176 1088q0-132-94-226t-226-94q-60 0-121 24l174 260q15 23 10 49t-27 40q-15 11-36 11-35 0-53-29l-174-260q-93 95-93 225 0 132 94 226t226 94 226-94 94-226zM2304 1088q0 185-131.5 316.5t-316.5 131.5-316.5-131.5-131.5-316.5q0-97 39.5-183.5t109.5-149.5l-65-98-353 469q-18 26-51 26h-197q-23 164-149 274t-294 110q-185 0-316.5-131.5t-131.5-316.5 131.5-316.5 316.5-131.5q114 0 215 55l137-183h-224q-26 0-45-19t-19-45 19-45 45-19h384v128h435l-85-128h-222q-26 0-45-19t-19-45 19-45 45-19h256q33 0 53 28l267 400q91-44 192-44 185 0 316.5 131.5t131.5 316.5z"}]}})


/***/ }),
/* 1320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"binoculars":{"width":1792,"height":1792,"paths":[{"d":"M704 320v768q0 26-19 45t-45 19v576q0 26-19 45t-45 19h-512q-26 0-45-19t-19-45v-512l249-873q7-23 31-23h424zM1024 320v704h-256v-704h256zM1792 1216v512q0 26-19 45t-45 19h-512q-26 0-45-19t-19-45v-576q-26 0-45-19t-19-45v-768h424q24 0 31 23zM736 32v224h-352v-224q0-14 9-23t23-9h288q14 0 23 9t9 23zM1408 32v224h-352v-224q0-14 9-23t23-9h288q14 0 23 9t9 23z"}]}})


/***/ }),
/* 1321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"birthday-cake":{"width":1792,"height":1792,"paths":[{"d":"M1792 1408v384h-1792v-384q45 0 85-14t59-27.5 47-37.5q30-27 51.5-38t56.5-11q24 0 44 7t31 15 33 27q29 25 47 38t58 27 86 14q45 0 85-14.5t58-27 48-37.5q21-19 32.5-27t31-15 43.5-7q35 0 56.5 11t51.5 38q28 24 47 37.5t59 27.5 85 14 85-14 59-27.5 47-37.5q30-27 51.5-38t56.5-11q34 0 55.5 11t51.5 38q28 24 47 37.5t59 27.5 85 14zM1792 1088v192q-24 0-44-7t-31-15-33-27q-29-25-47-38t-58-27-85-14q-46 0-86 14t-58 27-47 38q-22 19-33 27t-31 15-44 7q-35 0-56.5-11t-51.5-38q-29-25-47-38t-58-27-86-14q-45 0-85 14.5t-58 27-48 37.5q-21 19-32.5 27t-31 15-43.5 7q-35 0-56.5-11t-51.5-38q-28-24-47-37.5t-59-27.5-85-14q-46 0-86 14t-58 27-47 38q-30 27-51.5 38t-56.5 11v-192q0-80 56-136t136-56h64v-448h256v448h256v-448h256v448h256v-448h256v448h64q80 0 136 56t56 136zM512 224q0 77-36 118.5t-92 41.5q-53 0-90.5-37.5t-37.5-90.5q0-29 9.5-51t23.5-34 31-28 31-31.5 23.5-44.5 9.5-67q38 0 83 74t45 150zM1024 224q0 77-36 118.5t-92 41.5q-53 0-90.5-37.5t-37.5-90.5q0-29 9.5-51t23.5-34 31-28 31-31.5 23.5-44.5 9.5-67q38 0 83 74t45 150zM1536 224q0 77-36 118.5t-92 41.5q-53 0-90.5-37.5t-37.5-90.5q0-29 9.5-51t23.5-34 31-28 31-31.5 23.5-44.5 9.5-67q38 0 83 74t45 150z"}]}})


/***/ }),
/* 1322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"bitbucket-square":{"width":1536,"height":1792,"paths":[{"d":"M848 870q0-43-41-66t-77-1q-43 20-42.5 72.5t43.5 70.5q39 23 81-4t36-72zM928 854q8 66-36 121t-110 61-119-40-56-113q-2-49 25.5-93t72.5-64q70-31 141.5 10t81.5 118zM1100 463q-20 21-53.5 34t-53 16-63.5 8q-155 20-324 0-44-6-63-9.5t-52.5-16-54.5-32.5q13-19 36-31t40-15.5 47-8.5q198-35 408-1 33 5 51 8.5t43 16 39 31.5zM1142 1209q0-7 5.5-26.5t3-32-17.5-16.5q-161 106-365 106t-366-106l-12 6-5 12q26 154 41 210 47 81 204 108 249 46 428-53 34-19 49-51.5t22.5-85.5 12.5-71zM1272 516q9-53-8-75-43-55-155-88-216-63-487-36-132 12-226 46-38 15-59.5 25t-47 34-29.5 54q8 68 19 138t29 171 24 137q1 5 5 31t7 36 12 27 22 28q105 80 284 100 259 28 440-63 24-13 39.5-23t31-29 19.5-40q48-267 80-473zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 1323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"bitbucket":{"width":1408,"height":1792,"paths":[{"d":"M815 859q8 63-50.5 101t-111.5 6q-39-17-53.5-58t-0.5-82 52-58q36-18 72.5-12t64 35.5 27.5 67.5zM926 838q-14-107-113-164t-197-13q-63 28-100.5 88.5t-34.5 129.5q4 91 77.5 155t165.5 56q91-8 152-84t50-168zM1165 296q-20-27-56-44.5t-58-22-71-12.5q-291-47-566 2-43 7-66 12t-55 22-50 43q30 28 76 45.5t73.5 22 87.5 11.5q228 29 448 1 63-8 89.5-12t72.5-21.5 75-46.5zM1222 1331q-8 26-15.5 76.5t-14 84-28.5 70-58 56.5q-86 48-189.5 71.5t-202 22-201.5-18.5q-46-8-81.5-18t-76.5-27-73-43.5-52-61.5q-25-96-57-292l6-16 18-9q223 148 506.5 148t507.5-148q21 6 24 23t-5 45-8 37zM1403 370q-26 167-111 655-5 30-27 56t-43.5 40-54.5 31q-252 126-610 88-248-27-394-139-15-12-25.5-26.5t-17-35-9-34-6-39.5-5.5-35q-9-50-26.5-150t-28-161.5-23.5-147.5-22-158q3-26 17.5-48.5t31.5-37.5 45-30 46-22.5 48-18.5q125-46 313-64 379-37 676 50 155 46 215 122 16 20 16.5 51t-5.5 54z"}]}})


/***/ }),
/* 1324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"bitcoin":{"width":1280,"height":1792,"paths":[{"d":"M1167 640q18 182-131 258 117 28 175 103t45 214q-7 71-32.5 125t-64.5 89-97 58.5-121.5 34.5-145.5 15v255h-154v-251q-80 0-122-1v252h-154v-255q-18 0-54-0.5t-55-0.5h-200l31-183h111q50 0 58-51v-402h16q-6-1-16-1v-287q-13-68-89-68h-111v-164l212 1q64 0 97-1v-252h154v247q82-2 122-2v-245h154v252q79 7 140 22.5t113 45 82.5 78 36.5 114.5zM952 1185q0-36-15-64t-37-46-57.5-30.5-65.5-18.5-74-9-69-3-64.5 1-47.5 1v338q8 0 37 0.5t48 0.5 53-1.5 58.5-4 57-8.5 55.5-14 47.5-21 39.5-30 24.5-40 9.5-51zM881 709q0-33-12.5-58.5t-30.5-42-48-28-55-16.5-61.5-8-58-2.5-54 1-39.5 0.5v307q5 0 34.5 0.5t46.5 0 50-2 55-5.5 51.5-11 48.5-18.5 37-27 27-38.5 9-51z"}]}})


/***/ }),
/* 1325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"black-tie":{"width":1536,"height":1792,"paths":[{"d":"M0 128h1536v1536h-1536v-1536zM1085 1243l-221-631 221-297h-634l221 297-221 631 317 304z"}]}})


/***/ }),
/* 1326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"blind":{"width":1408,"height":1792,"paths":[{"d":"M366 311q-64 0-110-45.5t-46-110.5q0-64 46-109.5t110-45.5 109.5 45.5 45.5 109.5q0 65-45.5 110.5t-109.5 45.5zM917 953q0 50-30 67.5t-63.5 6.5-47.5-34l-367-438q-7-12-14-15.5t-11-1.5l-3 3q-7 8 4 21l122 139 1 354-161 457q-67 192-92 234-15 26-28 32-50 26-103 1-29-13-41.5-43t-9.5-57q2-17 197-618l5-416-85 164 35 222q4 24-1 42t-14 27.5-19 16-17 7.5l-7 2q-19 3-34.5-3t-24-16-14-22-7.5-19.5-2-9.5l-46-299 211-381q23-34 113-34 75 0 107 40l424 521q7 5 14 17l3 3-1 1q7 13 7 29zM514 1103q43 113 88.5 225t69.5 168l24 55q36 93 42 125 11 70-36 97-35 22-66 16t-51-22-29-35h-1q-6-16-8-25l-124-351zM1338 1695q31 49 31 57 0 5-3 7-9 5-14.5-0.5t-15.5-26-16-30.5q-114-172-423-661 3 1 7-1t7-4l3-2q11-9 11-17z"}]}})


/***/ }),
/* 1327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"bluetooth-b":{"width":1024,"height":1792,"paths":[{"d":"M596 1423l173-172-173-172v344zM596 713l173-172-173-172v344zM628 896l356 356-539 540v-711l-297 296-108-108 372-373-372-373 108-108 297 296v-711l539 540z"}]}})


/***/ }),
/* 1328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"bluetooth":{"width":1536,"height":1792,"paths":[{"d":"M841 1053l148 148-149 149zM840 442l149 149-148 148zM710 1666l464-464-306-306 306-306-464-464v611l-255-255-93 93 320 321-320 321 93 93 255-255v611zM1429 896q0 209-32 365.5t-87.5 257-140.5 162.5-181.5 86.5-219.5 24.5-219.5-24.5-181.5-86.5-140.5-162.5-87.5-257-32-365.5 32-365.5 87.5-257 140.5-162.5 181.5-86.5 219.5-24.5 219.5 24.5 181.5 86.5 140.5 162.5 87.5 257 32 365.5z"}]}})


/***/ }),
/* 1329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"bold":{"width":1408,"height":1792,"paths":[{"d":"M555 1521q74 32 140 32 376 0 376-335 0-114-41-180-27-44-61.5-74t-67.5-46.5-80.5-25-84-10.5-94.5-2q-73 0-101 10 0 53-0.5 159t-0.5 158q0 8-1 67.5t-0.5 96.5 4.5 83.5 12 66.5zM541 775q42 7 109 7 82 0 143-13t110-44.5 74.5-89.5 25.5-142q0-70-29-122.5t-79-82-108-43.5-124-14q-50 0-130 13 0 50 4 151t4 152q0 27-0.5 80t-0.5 79q0 46 1 69zM0 1664l2-94q15-4 85-16t106-27q7-12 12.5-27t8.5-33.5 5.5-32.5 3-37.5 0.5-34v-35.5-30q0-982-22-1025-4-8-22-14.5t-44.5-11-49.5-7-48.5-4.5-30.5-3l-4-83q98-2 340-11.5t373-9.5q23 0 68 0.5t68 0.5q70 0 136.5 13t128.5 42 108 71 74 104.5 28 137.5q0 52-16.5 95.5t-39 72-64.5 57.5-73 45-84 40q154 35 256.5 134t102.5 248q0 100-35 179.5t-93.5 130.5-138 85.5-163.5 48.5-176 14q-44 0-132-3t-132-3q-106 0-307 11t-231 12z"}]}})


/***/ }),
/* 1330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"bolt":{"width":896,"height":1792,"paths":[{"d":"M885 566q18 20 7 44l-540 1157q-13 25-42 25-4 0-14-2-17-5-25.5-19t-4.5-30l197-808-406 101q-4 1-12 1-18 0-31-11-18-15-13-39l201-825q4-14 16-23t28-9h328q19 0 32 12.5t13 29.5q0 8-5 18l-171 463 396-98q8-2 12-2 19 0 34 15z"}]}})


/***/ }),
/* 1331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"bomb":{"width":1792,"height":1792,"paths":[{"d":"M571 589q-10-25-34-35t-49 0q-108 44-191 127t-127 191q-10 25 0 49t35 34q13 5 24 5 42 0 60-40 34-84 98.5-148.5t148.5-98.5q25-11 35-35t0-49zM1513 233l46 46-244 243 68 68q19 19 19 45.5t-19 45.5l-64 64q89 161 89 343 0 143-55.5 273.5t-150 225-225 150-273.5 55.5-273.5-55.5-225-150-150-225-55.5-273.5 55.5-273.5 150-225 225-150 273.5-55.5q182 0 343 89l64-64q19-19 45.5-19t45.5 19l68 68zM1521 177q-10 10-22 10-13 0-23-10l-91-90q-9-10-9-23t9-23q10-9 23-9t23 9l90 91q10 9 10 22.5t-10 22.5zM1751 407q-11 9-23 9t-23-9l-90-91q-10-9-10-22.5t10-22.5q9-10 22.5-10t22.5 10l91 90q9 10 9 23t-9 23zM1792 224q0 14-9 23t-23 9h-96q-14 0-23-9t-9-23 9-23 23-9h96q14 0 23 9t9 23zM1600 32v96q0 14-9 23t-23 9-23-9-9-23v-96q0-14 9-23t23-9 23 9 9 23zM1751 87l-91 90q-10 10-22 10-13 0-23-10-10-9-10-22.5t10-22.5l90-91q10-9 23-9t23 9q9 10 9 23t-9 23z"}]}})


/***/ }),
/* 1332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"book":{"width":1664,"height":1792,"paths":[{"d":"M1639 478q40 57 18 129l-275 906q-19 64-76.5 107.5t-122.5 43.5h-923q-77 0-148.5-53.5t-99.5-131.5q-24-67-2-127 0-4 3-27t4-37q1-8-3-21.5t-3-19.5q2-11 8-21t16.5-23.5 16.5-23.5q23-38 45-91.5t30-91.5q3-10 0.5-30t-0.5-28q3-11 17-28t17-23q21-36 42-92t25-90q1-9-2.5-32t0.5-28q4-13 22-30.5t22-22.5q19-26 42.5-84.5t27.5-96.5q1-8-3-25.5t-2-26.5q2-8 9-18t18-23 17-21q8-12 16.5-30.5t15-35 16-36 19.5-32 26.5-23.5 36-11.5 47.5 5.5l-1 3q38-9 51-9h761q74 0 114 56t18 130l-274 906q-36 119-71.5 153.5t-128.5 34.5h-869q-27 0-38 15-11 16-1 43 24 70 144 70h923q29 0 56-15.5t35-41.5l300-987q7-22 5-57 38 15 59 43zM575 480q-4 13 2 22.5t20 9.5h608q13 0 25.5-9.5t16.5-22.5l21-64q4-13-2-22.5t-20-9.5h-608q-13 0-25.5 9.5t-16.5 22.5zM492 736q-4 13 2 22.5t20 9.5h608q13 0 25.5-9.5t16.5-22.5l21-64q4-13-2-22.5t-20-9.5h-608q-13 0-25.5 9.5t-16.5 22.5z"}]}})


/***/ }),
/* 1333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"bookmark-o":{"width":1280,"height":1792,"paths":[{"d":"M1152 256h-1024v1242l423-406 89-85 89 85 423 406v-1242zM1164 128q23 0 44 9 33 13 52.5 41t19.5 62v1289q0 34-19.5 62t-52.5 41q-19 8-44 8-48 0-83-32l-441-424-441 424q-36 33-83 33-23 0-44-9-33-13-52.5-41t-19.5-62v-1289q0-34 19.5-62t52.5-41q21-9 44-9h1048z"}]}})


/***/ }),
/* 1334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"bookmark":{"width":1280,"height":1792,"paths":[{"d":"M1164 128q23 0 44 9 33 13 52.5 41t19.5 62v1289q0 34-19.5 62t-52.5 41q-19 8-44 8-48 0-83-32l-441-424-441 424q-36 33-83 33-23 0-44-9-33-13-52.5-41t-19.5-62v-1289q0-34 19.5-62t52.5-41q21-9 44-9h1048z"}]}})


/***/ }),
/* 1335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"braille":{"width":2176,"height":1792,"paths":[{"d":"M192 1184q-66 0-113 47t-47 113 47 113 113 47 113-47 47-113-47-113-113-47zM704 1184q-66 0-113 47t-47 113 47 113 113 47 113-47 47-113-47-113-113-47zM704 672q-66 0-113 47t-47 113 47 113 113 47 113-47 47-113-47-113-113-47zM1472 1184q-66 0-113 47t-47 113 47 113 113 47 113-47 47-113-47-113-113-47zM1984 1184q-66 0-113 47t-47 113 47 113 113 47 113-47 47-113-47-113-113-47zM1472 672q-66 0-113 47t-47 113 47 113 113 47 113-47 47-113-47-113-113-47zM1984 672q-66 0-113 47t-47 113 47 113 113 47 113-47 47-113-47-113-113-47zM1984 160q-66 0-113 47t-47 113 47 113 113 47 113-47 47-113-47-113-113-47zM384 1344q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM896 1344q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM384 832q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM896 832q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM384 320q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM1664 1344q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM896 320q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM2176 1344q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM1664 832q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM2176 832q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM1664 320q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM2176 320q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136z"}]}})


/***/ }),
/* 1336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"briefcase":{"width":1792,"height":1792,"paths":[{"d":"M640 256h512v-128h-512v128zM1792 896v480q0 66-47 113t-113 47h-1472q-66 0-113-47t-47-113v-480h672v160q0 26 19 45t45 19h320q26 0 45-19t19-45v-160h672zM1024 896v128h-256v-128h256zM1792 416v384h-1792v-384q0-66 47-113t113-47h352v-160q0-40 28-68t68-28h576q40 0 68 28t28 68v160h352q66 0 113 47t47 113z"}]}})


/***/ }),
/* 1337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"btc":{"width":1280,"height":1792,"paths":[{"d":"M1167 640q18 182-131 258 117 28 175 103t45 214q-7 71-32.5 125t-64.5 89-97 58.5-121.5 34.5-145.5 15v255h-154v-251q-80 0-122-1v252h-154v-255q-18 0-54-0.5t-55-0.5h-200l31-183h111q50 0 58-51v-402h16q-6-1-16-1v-287q-13-68-89-68h-111v-164l212 1q64 0 97-1v-252h154v247q82-2 122-2v-245h154v252q79 7 140 22.5t113 45 82.5 78 36.5 114.5zM952 1185q0-36-15-64t-37-46-57.5-30.5-65.5-18.5-74-9-69-3-64.5 1-47.5 1v338q8 0 37 0.5t48 0.5 53-1.5 58.5-4 57-8.5 55.5-14 47.5-21 39.5-30 24.5-40 9.5-51zM881 709q0-33-12.5-58.5t-30.5-42-48-28-55-16.5-61.5-8-58-2.5-54 1-39.5 0.5v307q5 0 34.5 0.5t46.5 0 50-2 55-5.5 51.5-11 48.5-18.5 37-27 27-38.5 9-51z"}]}})


/***/ }),
/* 1338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"bug":{"width":1664,"height":1792,"paths":[{"d":"M1632 960q0 26-19 45t-45 19h-224q0 171-67 290l208 209q19 19 19 45t-19 45q-18 19-45 19t-45-19l-198-197q-5 5-15 13t-42 28.5-65 36.5-82 29-97 13v-896h-128v896q-51 0-101.5-13.5t-87-33-66-39-43.5-32.5l-15-14-183 207q-20 21-48 21-24 0-43-16-19-18-20.5-44.5t15.5-46.5l202-227q-58-114-58-274h-224q-26 0-45-19t-19-45 19-45 45-19h224v-294l-173-173q-19-19-19-45t19-45 45-19 45 19l173 173h844l173-173q19-19 45-19t45 19 19 45-19 45l-173 173v294h224q26 0 45 19t19 45zM1152 384h-640q0-133 93.5-226.5t226.5-93.5 226.5 93.5 93.5 226.5z"}]}})


/***/ }),
/* 1339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"building-o":{"width":1408,"height":1792,"paths":[{"d":"M384 1312v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM384 1056v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM640 1056v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM384 800v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM1152 1312v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM896 1056v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM640 800v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM384 544v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM1152 1056v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM896 800v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM640 544v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM384 288v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM1152 800v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM896 544v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM640 288v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM1152 544v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM896 288v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM1152 288v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM896 1664h384v-1536h-1152v1536h384v-224q0-13 9.5-22.5t22.5-9.5h320q13 0 22.5 9.5t9.5 22.5v224zM1408 64v1664q0 26-19 45t-45 19h-1280q-26 0-45-19t-19-45v-1664q0-26 19-45t45-19h1280q26 0 45 19t19 45z"}]}})


/***/ }),
/* 1340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"building":{"width":1536,"height":1792,"paths":[{"d":"M1344 0q26 0 45 19t19 45v1664q0 26-19 45t-45 19h-1280q-26 0-45-19t-19-45v-1664q0-26 19-45t45-19h1280zM512 288v64q0 14 9 23t23 9h64q14 0 23-9t9-23v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23zM512 544v64q0 14 9 23t23 9h64q14 0 23-9t9-23v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23zM512 800v64q0 14 9 23t23 9h64q14 0 23-9t9-23v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23zM512 1056v64q0 14 9 23t23 9h64q14 0 23-9t9-23v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23zM384 1376v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zM384 1120v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zM384 864v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zM384 608v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zM384 352v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zM896 1632v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zM896 1120v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zM896 864v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zM896 608v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zM896 352v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zM1152 1376v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zM1152 1120v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zM1152 864v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zM1152 608v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zM1152 352v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23z"}]}})


/***/ }),
/* 1341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"bullhorn":{"width":1792,"height":1792,"paths":[{"d":"M1664 640q53 0 90.5 37.5t37.5 90.5-37.5 90.5-90.5 37.5v384q0 52-38 90t-90 38q-417-347-812-380-58 19-91 66t-31 100.5 40 92.5q-20 33-23 65.5t6 58 33.5 55 48 50 61.5 50.5q-29 58-111.5 83t-168.5 11.5-132-55.5q-7-23-29.5-87.5t-32-94.5-23-89-15-101 3.5-98.5 22-110.5h-122q-66 0-113-47t-47-113v-192q0-66 47-113t113-47h480q435 0 896-384 52 0 90 38t38 90v384zM1536 1244v-954q-394 302-768 343v270q377 42 768 341z"}]}})


/***/ }),
/* 1342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"bullseye":{"width":1536,"height":1792,"paths":[{"d":"M1024 896q0 106-75 181t-181 75-181-75-75-181 75-181 181-75 181 75 75 181zM1152 896q0-159-112.5-271.5t-271.5-112.5-271.5 112.5-112.5 271.5 112.5 271.5 271.5 112.5 271.5-112.5 112.5-271.5zM1280 896q0 212-150 362t-362 150-362-150-150-362 150-362 362-150 362 150 150 362zM1408 896q0-130-51-248.5t-136.5-204-204-136.5-248.5-51-248.5 51-204 136.5-136.5 204-51 248.5 51 248.5 136.5 204 204 136.5 248.5 51 248.5-51 204-136.5 136.5-204 51-248.5zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"bus":{"width":1536,"height":1792,"paths":[{"d":"M384 1216q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1408 1216q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1362 820l-72-384q-5-23-22.5-37.5t-40.5-14.5h-918q-23 0-40.5 14.5t-22.5 37.5l-72 384q-5 30 14 53t49 23h1062q30 0 49-23t14-53zM1136 208q0-20-14-34t-34-14h-640q-20 0-34 14t-14 34 14 34 34 14h640q20 0 34-14t14-34zM1536 933v603h-128v128q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5v-128h-768v128q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5v-128h-128v-603q0-112 25-223l103-454q9-78 97.5-137t230-89 312.5-30 312.5 30 230 89 97.5 137l105 454q23 102 23 223z"}]}})


/***/ }),
/* 1344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"buysellads":{"width":1536,"height":1792,"paths":[{"d":"M915 1086h-294l147-551zM1001 1408h311l-324-1024h-440l-324 1024h311l383-314zM1536 416v960q0 118-85 203t-203 85h-960q-118 0-203-85t-85-203v-960q0-118 85-203t203-85h960q118 0 203 85t85 203z"}]}})


/***/ }),
/* 1345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"cab":{"width":2048,"height":1792,"paths":[{"d":"M1824 896q93 0 158.5 65.5t65.5 158.5v384q0 14-9 23t-23 9h-96v64q0 80-56 136t-136 56-136-56-56-136v-64h-1024v64q0 80-56 136t-136 56-136-56-56-136v-64h-96q-14 0-23-9t-9-23v-384q0-93 65.5-158.5t158.5-65.5h28l105-419q23-94 104-157.5t179-63.5h128v-224q0-14 9-23t23-9h448q14 0 23 9t9 23v224h128q98 0 179 63.5t104 157.5l105 419h28zM320 1376q66 0 113-47t47-113-47-113-113-47-113 47-47 113 47 113 113 47zM516 896h1016l-89-357q-2-8-14-17.5t-21-9.5h-768q-9 0-21 9.5t-14 17.5zM1728 1376q66 0 113-47t47-113-47-113-113-47-113 47-47 113 47 113 113 47z"}]}})


/***/ }),
/* 1346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"calculator":{"width":1792,"height":1792,"paths":[{"d":"M384 1536q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM768 1536q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM384 1152q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1152 1536q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM768 1152q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM384 768q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1152 1152q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM768 768q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1536 1536v-384q0-52-38-90t-90-38-90 38-38 90v384q0 52 38 90t90 38 90-38 38-90zM1152 768q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1536 448v-256q0-26-19-45t-45-19h-1280q-26 0-45 19t-19 45v256q0 26 19 45t45 19h1280q26 0 45-19t19-45zM1536 768q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1664 128v1536q0 52-38 90t-90 38h-1408q-52 0-90-38t-38-90v-1536q0-52 38-90t90-38h1408q52 0 90 38t38 90z"}]}})


/***/ }),
/* 1347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"calendar-check-o":{"width":1792,"height":1792,"paths":[{"d":"M1303 964l-512 512q-10 9-23 9t-23-9l-288-288q-9-10-9-23t9-22l46-46q9-9 22-9t23 9l220 220 444-444q10-9 23-9t22 9l46 46q9 9 9 22t-9 23zM128 1664h1408v-1024h-1408v1024zM512 448v-288q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v288q0 14 9 23t23 9h64q14 0 23-9t9-23zM1280 448v-288q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v288q0 14 9 23t23 9h64q14 0 23-9t9-23zM1664 384v1280q0 52-38 90t-90 38h-1408q-52 0-90-38t-38-90v-1280q0-52 38-90t90-38h128v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h384v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h128q52 0 90 38t38 90z"}]}})


/***/ }),
/* 1348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"calendar-minus-o":{"width":1792,"height":1792,"paths":[{"d":"M1152 1120v64q0 14-9 23t-23 9h-576q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h576q14 0 23 9t9 23zM128 1664h1408v-1024h-1408v1024zM512 448v-288q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v288q0 14 9 23t23 9h64q14 0 23-9t9-23zM1280 448v-288q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v288q0 14 9 23t23 9h64q14 0 23-9t9-23zM1664 384v1280q0 52-38 90t-90 38h-1408q-52 0-90-38t-38-90v-1280q0-52 38-90t90-38h128v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h384v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h128q52 0 90 38t38 90z"}]}})


/***/ }),
/* 1349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"calendar-o":{"width":1664,"height":1792,"paths":[{"d":"M128 1664h1408v-1024h-1408v1024zM512 448v-288q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v288q0 14 9 23t23 9h64q14 0 23-9t9-23zM1280 448v-288q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v288q0 14 9 23t23 9h64q14 0 23-9t9-23zM1664 384v1280q0 52-38 90t-90 38h-1408q-52 0-90-38t-38-90v-1280q0-52 38-90t90-38h128v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h384v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h128q52 0 90 38t38 90z"}]}})


/***/ }),
/* 1350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"calendar-plus-o":{"width":1792,"height":1792,"paths":[{"d":"M1536 256q52 0 90 38t38 90v1280q0 52-38 90t-90 38h-1408q-52 0-90-38t-38-90v-1280q0-52 38-90t90-38h128v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h384v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h128zM1152 160v288q0 14 9 23t23 9h64q14 0 23-9t9-23v-288q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23zM384 160v288q0 14 9 23t23 9h64q14 0 23-9t9-23v-288q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23zM1536 1664v-1024h-1408v1024h1408zM896 1088h224q14 0 23 9t9 23v64q0 14-9 23t-23 9h-224v224q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-224h-224q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h224v-224q0-14 9-23t23-9h64q14 0 23 9t9 23v224z"}]}})


/***/ }),
/* 1351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"calendar-times-o":{"width":1792,"height":1792,"paths":[{"d":"M1111 1385l-46 46q-9 9-22 9t-23-9l-188-189-188 189q-10 9-23 9t-22-9l-46-46q-9-9-9-22t9-23l189-188-189-188q-9-10-9-23t9-22l46-46q9-9 22-9t23 9l188 188 188-188q10-9 23-9t22 9l46 46q9 9 9 22t-9 23l-188 188 188 188q9 10 9 23t-9 22zM128 1664h1408v-1024h-1408v1024zM512 448v-288q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v288q0 14 9 23t23 9h64q14 0 23-9t9-23zM1280 448v-288q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v288q0 14 9 23t23 9h64q14 0 23-9t9-23zM1664 384v1280q0 52-38 90t-90 38h-1408q-52 0-90-38t-38-90v-1280q0-52 38-90t90-38h128v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h384v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h128q52 0 90 38t38 90z"}]}})


/***/ }),
/* 1352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"calendar":{"width":1664,"height":1792,"paths":[{"d":"M128 1664h288v-288h-288v288zM480 1664h320v-288h-320v288zM128 1312h288v-320h-288v320zM480 1312h320v-320h-320v320zM128 928h288v-288h-288v288zM864 1664h320v-288h-320v288zM480 928h320v-288h-320v288zM1248 1664h288v-288h-288v288zM864 1312h320v-320h-320v320zM512 448v-288q0-13-9.5-22.5t-22.5-9.5h-64q-13 0-22.5 9.5t-9.5 22.5v288q0 13 9.5 22.5t22.5 9.5h64q13 0 22.5-9.5t9.5-22.5zM1248 1312h288v-320h-288v320zM864 928h320v-288h-320v288zM1248 928h288v-288h-288v288zM1280 448v-288q0-13-9.5-22.5t-22.5-9.5h-64q-13 0-22.5 9.5t-9.5 22.5v288q0 13 9.5 22.5t22.5 9.5h64q13 0 22.5-9.5t9.5-22.5zM1664 384v1280q0 52-38 90t-90 38h-1408q-52 0-90-38t-38-90v-1280q0-52 38-90t90-38h128v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h384v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h128q52 0 90 38t38 90z"}]}})


/***/ }),
/* 1353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"camera-retro":{"width":1792,"height":1792,"paths":[{"d":"M928 832q0-14-9-23t-23-9q-66 0-113 47t-47 113q0 14 9 23t23 9 23-9 9-23q0-40 28-68t68-28q14 0 23-9t9-23zM1152 962q0 106-75 181t-181 75-181-75-75-181 75-181 181-75 181 75 75 181zM128 1536h1536v-128h-1536v128zM1280 962q0-159-112.5-271.5t-271.5-112.5-271.5 112.5-112.5 271.5 112.5 271.5 271.5 112.5 271.5-112.5 112.5-271.5zM256 320h384v-128h-384v128zM128 512h1536v-118-138h-828l-64 128h-644v128zM1792 256v1280q0 53-37.5 90.5t-90.5 37.5h-1536q-53 0-90.5-37.5t-37.5-90.5v-1280q0-53 37.5-90.5t90.5-37.5h1536q53 0 90.5 37.5t37.5 90.5z"}]}})


/***/ }),
/* 1354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"camera":{"width":1920,"height":1792,"paths":[{"d":"M960 672q119 0 203.5 84.5t84.5 203.5-84.5 203.5-203.5 84.5-203.5-84.5-84.5-203.5 84.5-203.5 203.5-84.5zM1664 256q106 0 181 75t75 181v896q0 106-75 181t-181 75h-1408q-106 0-181-75t-75-181v-896q0-106 75-181t181-75h224l51-136q19-49 69.5-84.5t103.5-35.5h512q53 0 103.5 35.5t69.5 84.5l51 136h224zM960 1408q185 0 316.5-131.5t131.5-316.5-131.5-316.5-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5z"}]}})


/***/ }),
/* 1355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"car":{"width":2048,"height":1792,"paths":[{"d":"M480 1088q0-66-47-113t-113-47-113 47-47 113 47 113 113 47 113-47 47-113zM516 768h1016l-89-357q-2-8-14-17.5t-21-9.5h-768q-9 0-21 9.5t-14 17.5zM1888 1088q0-66-47-113t-113-47-113 47-47 113 47 113 113 47 113-47 47-113zM2048 992v384q0 14-9 23t-23 9h-96v128q0 80-56 136t-136 56-136-56-56-136v-128h-1024v128q0 80-56 136t-136 56-136-56-56-136v-128h-96q-14 0-23-9t-9-23v-384q0-93 65.5-158.5t158.5-65.5h28l105-419q23-94 104-157.5t179-63.5h768q98 0 179 63.5t104 157.5l105 419h28q93 0 158.5 65.5t65.5 158.5z"}]}})


/***/ }),
/* 1356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"caret-down":{"width":1024,"height":1792,"paths":[{"d":"M1024 704q0 26-19 45l-448 448q-19 19-45 19t-45-19l-448-448q-19-19-19-45t19-45 45-19h896q26 0 45 19t19 45z"}]}})


/***/ }),
/* 1357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"caret-left":{"width":640,"height":1792,"paths":[{"d":"M640 448v896q0 26-19 45t-45 19-45-19l-448-448q-19-19-19-45t19-45l448-448q19-19 45-19t45 19 19 45z"}]}})


/***/ }),
/* 1358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"caret-right":{"width":640,"height":1792,"paths":[{"d":"M576 896q0 26-19 45l-448 448q-19 19-45 19t-45-19-19-45v-896q0-26 19-45t45-19 45 19l448 448q19 19 19 45z"}]}})


/***/ }),
/* 1359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"caret-square-o-down":{"width":1536,"height":1792,"paths":[{"d":"M1145 675q18 35-5 66l-320 448q-19 27-52 27t-52-27l-320-448q-23-31-5-66 17-35 57-35h640q40 0 57 35zM1280 1376v-960q0-13-9.5-22.5t-22.5-9.5h-960q-13 0-22.5 9.5t-9.5 22.5v960q0 13 9.5 22.5t22.5 9.5h960q13 0 22.5-9.5t9.5-22.5zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 1360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"caret-square-o-left":{"width":1536,"height":1792,"paths":[{"d":"M1024 576v640q0 26-19 45t-45 19q-20 0-37-12l-448-320q-27-19-27-52t27-52l448-320q17-12 37-12 26 0 45 19t19 45zM1280 1376v-960q0-13-9.5-22.5t-22.5-9.5h-960q-13 0-22.5 9.5t-9.5 22.5v960q0 13 9.5 22.5t22.5 9.5h960q13 0 22.5-9.5t9.5-22.5zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 1361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"caret-square-o-right":{"width":1536,"height":1792,"paths":[{"d":"M1088 896q0 33-27 52l-448 320q-31 23-66 5-35-17-35-57v-640q0-40 35-57 35-18 66 5l448 320q27 19 27 52zM1280 1376v-960q0-14-9-23t-23-9h-960q-14 0-23 9t-9 23v960q0 14 9 23t23 9h960q14 0 23-9t9-23zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 1362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"caret-square-o-up":{"width":1536,"height":1792,"paths":[{"d":"M1145 1117q-17 35-57 35h-640q-40 0-57-35-18-35 5-66l320-448q19-27 52-27t52 27l320 448q23 31 5 66zM1280 1376v-960q0-13-9.5-22.5t-22.5-9.5h-960q-13 0-22.5 9.5t-9.5 22.5v960q0 13 9.5 22.5t22.5 9.5h960q13 0 22.5-9.5t9.5-22.5zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 1363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"caret-up":{"width":1024,"height":1792,"paths":[{"d":"M1024 1216q0 26-19 45t-45 19h-896q-26 0-45-19t-19-45 19-45l448-448q19-19 45-19t45 19l448 448q19 19 19 45z"}]}})


/***/ }),
/* 1364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"cart-arrow-down":{"width":1664,"height":1792,"paths":[{"d":"M1280 704q0-26-19-45t-45-19-45 19l-147 146v-293q0-26-19-45t-45-19-45 19-19 45v293l-147-146q-19-19-45-19t-45 19-19 45 19 45l256 256q19 19 45 19t45-19l256-256q19-19 19-45zM640 1536q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zM1536 1536q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zM1664 448v512q0 24-16 42.5t-41 21.5l-1044 122q1 7 4.5 21.5t6 26.5 2.5 22q0 16-24 64h920q26 0 45 19t19 45-19 45-45 19h-1024q-26 0-45-19t-19-45q0-14 11-39.5t29.5-59.5 20.5-38l-177-823h-204q-26 0-45-19t-19-45 19-45 45-19h256q16 0 28.5 6.5t20 15.5 13 24.5 7.5 26.5 5.5 29.5 4.5 25.5h1201q26 0 45 19t19 45z"}]}})


/***/ }),
/* 1365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"cart-plus":{"width":1664,"height":1792,"paths":[{"d":"M1216 704q0-26-19-45t-45-19h-128v-128q0-26-19-45t-45-19-45 19-19 45v128h-128q-26 0-45 19t-19 45 19 45 45 19h128v128q0 26 19 45t45 19 45-19 19-45v-128h128q26 0 45-19t19-45zM640 1536q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zM1536 1536q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zM1664 448v512q0 24-16 42.5t-41 21.5l-1044 122q1 7 4.5 21.5t6 26.5 2.5 22q0 16-24 64h920q26 0 45 19t19 45-19 45-45 19h-1024q-26 0-45-19t-19-45q0-14 11-39.5t29.5-59.5 20.5-38l-177-823h-204q-26 0-45-19t-19-45 19-45 45-19h256q16 0 28.5 6.5t20 15.5 13 24.5 7.5 26.5 5.5 29.5 4.5 25.5h1201q26 0 45 19t19 45z"}]}})


/***/ }),
/* 1366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"cc-amex":{"width":2304,"height":1792,"paths":[{"d":"M119 682h89l-45-108zM740 1208l74-79-70-79h-163v49h142v55h-142v54h159zM898 1130l99 110v-217zM1186 1083q0-33-40-33h-84v69h83q41 0 41-36zM1475 1079q0-29-42-29h-82v61h81q43 0 43-32zM1197 613q0-29-42-29h-82v60h81q43 0 43-31zM1656 682h89l-44-108zM699 527v271h-66v-212l-94 212h-57l-94-212v212h-132l-25-60h-135l-25 60h-70l116-271h96l110 257v-257h106l85 184 77-184h108zM1255 1083q0 20-5.5 35t-14 25-22.5 16.5-26 10-31.5 4.5-31.5 1-32.5-0.5-29.5-0.5v91h-126l-80-90-83 90h-256v-271h260l80 89 82-89h207q109 0 109 89zM964 742v56h-217v-271h217v57h-152v49h148v55h-148v54h152zM2304 1301v229q0 55-38.5 94.5t-93.5 39.5h-2040q-55 0-93.5-39.5t-38.5-94.5v-678h111l25-61h55l25 61h218v-46l19 46h113l20-47v47h541v-99l10-1q10 0 10 14v86h279v-23q23 12 55 18t52.5 6.5 63-0.5 51.5-1l25-61h56l25 61h227v-58l34 58h182v-378h-180v44l-25-44h-185v44l-23-44h-249q-69 0-109 22v-22h-172v22q-24-22-73-22h-628l-43 97-43-97h-198v44l-22-44h-169l-78 179v-391q0-55 38.5-94.5t93.5-39.5h2040q55 0 93.5 39.5t38.5 94.5v678h-120q-51 0-81 22v-22h-177q-55 0-78 22v-22h-316v22q-31-22-87-22h-209v22q-23-22-91-22h-234l-54 58-50-58h-349v378h343l55-59 52 59h211v-89h21q59 0 90-13v102h174v-99h8q8 0 10 2t2 10v87h529q57 0 88-24v24h168q60 0 95-17zM1546 1067q0 23-12 43t-34 29q25 9 34 26t9 46v54h-65v-45q0-33-12-43.5t-46-10.5h-69v99h-65v-271h154q48 0 77 15t29 58zM1269 600q0 24-12.5 44t-33.5 29q26 9 34.5 25.5t8.5 46.5v53h-65q0-9 0.5-26.5t0-25-3-18.5-8.5-16-17.5-8.5-29.5-3.5h-70v98h-64v-271l153 1q49 0 78 14.5t29 57.5zM1798 1209v56h-216v-271h216v56h-151v49h148v55h-148v54zM1372 527v271h-66v-271h66zM2065 1179q0 86-102 86h-126v-58h126q34 0 34-25 0-16-17-21t-41.5-5-49.5-3.5-42-22.5-17-55q0-39 26-60t66-21h130v57h-119q-36 0-36 25 0 16 17.5 20.5t42 4 49 2.5 42 21.5 17.5 54.5zM2304 1129v101q-24 35-88 35h-125v-58h125q33 0 33-25 0-13-12.5-19t-31-5.5-40-2-40-8-31-24-12.5-48.5q0-39 26.5-60t66.5-21h129v57h-118q-36 0-36 25 0 20 29 22t68.5 5 56.5 26zM2139 528v270h-92l-122-203v203h-132l-26-60h-134l-25 60h-75q-129 0-129-133 0-138 133-138h63v59q-7 0-28-1t-28.5-0.5-23 2-21.5 6.5-14.5 13.5-11.5 23-3 33.5q0 38 13.5 58t49.5 20h29l92-213h97l109 256v-256h99l114 188v-188h66z"}]}})


/***/ }),
/* 1367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"cc-diners-club":{"width":2304,"height":1792,"paths":[{"d":"M858 1241v-693q-106 41-172 135.5t-66 211.5 66 211.5 172 134.5zM1362 895q0-117-66-211.5t-172-135.5v694q106-41 172-135.5t66-211.5zM1577 895q0 159-78.5 294t-213.5 213.5-294 78.5q-119 0-227.5-46.5t-187-125-125-187-46.5-227.5q0-159 78.5-294t213.5-213.5 294-78.5 294 78.5 213.5 213.5 78.5 294zM1960 902q0-139-55.5-261.5t-147.5-205.5-213.5-131-252.5-48h-301q-176 0-323.5 81t-235 230-87.5 335q0 171 87 317.5t236 231.5 323 85h301q129 0 251.5-50.5t214.5-135 147.5-202.5 55.5-246zM2304 256v1280q0 52-38 90t-90 38h-2048q-52 0-90-38t-38-90v-1280q0-52 38-90t90-38h2048q52 0 90 38t38 90z"}]}})


/***/ }),
/* 1368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"cc-discover":{"width":2304,"height":1792,"paths":[{"d":"M313 777q0 51-36 84-29 26-89 26h-17v-220h17q61 0 89 27 36 31 36 83zM2089 712q0 52-64 52h-19v-101h20q63 0 63 49zM380 777q0-74-50-120.5t-129-46.5h-95v333h95q74 0 119-38 60-51 60-128zM410 943h65v-333h-65v333zM730 842q0-40-20.5-62t-75.5-42q-29-10-39.5-19t-10.5-23q0-16 13.5-26.5t34.5-10.5q29 0 53 27l34-44q-41-37-98-37-44 0-74 27.5t-30 67.5q0 35 18 55.5t64 36.5q37 13 45 19 19 12 19 34 0 20-14 33.5t-36 13.5q-48 0-71-44l-42 40q44 64 115 64 51 0 83-30.5t32-79.5zM1008 932v-77q-37 37-78 37-49 0-80.5-32.5t-31.5-82.5q0-48 31.5-81.5t77.5-33.5q43 0 81 38v-77q-40-20-80-20-74 0-125.5 50.5t-51.5 123.5 51 123.5 125 50.5q42 0 81-19zM2240 1536v-527q-65 40-144.5 84t-237.5 117-329.5 137.5-417.5 134.5-504 118h1569q26 0 45-19t19-45zM1389 779q0-75-53-128t-128-53-128 53-53 128 53 128 128 53 128-53 53-128zM1541 952l144-342h-71l-90 224-89-224h-71l142 342h35zM1714 943h184v-56h-119v-90h115v-56h-115v-74h119v-57h-184v333zM2105 943h80l-105-140q76-16 76-94 0-47-31-73t-87-26h-97v333h65v-133h9zM2304 262v1268q0 56-38.5 95t-93.5 39h-2040q-55 0-93.5-39t-38.5-95v-1268q0-56 38.5-95t93.5-39h2040q55 0 93.5 39t38.5 95z"}]}})


/***/ }),
/* 1369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"cc-jcb":{"width":2304,"height":1792,"paths":[{"d":"M1951 998q0 26-15.5 44.5t-38.5 23.5q-8 2-18 2h-153v-140h153q10 0 18 2 23 5 38.5 23.5t15.5 44.5zM1933 785q0 25-15 42t-38 21q-3 1-15 1h-139v-129h139q3 0 8.5 0.5t6.5 0.5q23 4 38 21.5t15 42.5zM728 949v-308h-228v308q0 58-38 94.5t-105 36.5q-108 0-229-59v112q53 15 121 23t109 9l42 1q328 0 328-217zM1442 1133v-113q-99 52-200 59-108 8-169-41t-61-142 61-142 169-41q101 7 200 58v-112q-48-12-100-19.5t-80-9.5l-28-2q-127-6-218.5 14t-140.5 60-71 88-22 106 22 106 71 88 140.5 60 218.5 14q101-4 208-31zM2176 1018q0-54-43-88.5t-109-39.5v-3q57-8 89-41.5t32-79.5q0-55-41-88t-107-36q-3 0-12-0.5t-14-0.5h-455v510h491q74 0 121.5-36.5t47.5-96.5zM2304 256v1280q0 52-38 90t-90 38h-2048q-52 0-90-38t-38-90v-1280q0-52 38-90t90-38h2048q52 0 90 38t38 90z"}]}})


/***/ }),
/* 1370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"cc-mastercard":{"width":2304,"height":1792,"paths":[{"d":"M1119 341q-128-85-281-85-103 0-197.5 40.5t-162.5 108.5-108.5 162-40.5 197q0 104 40.5 198t108.5 162 162 108.5 198 40.5q153 0 281-85-131-107-178-265.5t0.5-316.5 177.5-265zM1152 365q-126 99-172 249.5t-0.5 300.5 172.5 249q127-99 172.5-249t-0.5-300.5-172-249.5zM1185 341q130 107 177.5 265.5t0.5 317-178 264.5q128 85 281 85 104 0 198-40.5t162-108.5 108.5-162 40.5-198q0-103-40.5-197t-108.5-162-162.5-108.5-197.5-40.5q-153 0-281 85zM1926 1063h7v-3h-17v3h7v17h3v-17zM1955 1080h4v-20h-5l-6 13-6-13h-5v20h3v-15l6 13h4l5-13v15zM1947 1520v2h-2-3v-3h3 2v1zM1947 1529h3l-4-5h2l1-1q1-1 1-3t-1-3l-1-1h-3-6v13h3v-5h1zM685 1461q0-19 11-31t30-12q18 0 29 12.5t11 30.5q0 19-11 31t-29 12q-19 0-30-12t-11-31zM1158 1417q30 0 35 32h-70q5-32 35-32zM1514 1461q0-19 11-31t29-12 29.5 12.5 11.5 30.5q0 19-11 31t-30 12q-18 0-29-12t-11-31zM1786 1461q0-18 11.5-30.5t29.5-12.5 29.5 12.5 11.5 30.5q0 19-11.5 31t-29.5 12-29.5-12.5-11.5-30.5zM1944 1533q-2 0-4-1-1 0-3-2t-2-3q-1-2-1-4 0-3 1-4 0-2 2-4l1-1q2 0 2-1 2-1 4-1 3 0 4 1l4 2 2 4v1q1 2 1 3l-1 1v3t-1 1l-1 2q-2 2-4 2-1 1-4 1zM599 1529h30v-85q0-24-14.5-38.5t-39.5-15.5q-32 0-47 24-14-24-45-24-24 0-39 20v-16h-30v135h30v-75q0-36 33-36 30 0 30 36v75h29v-75q0-36 33-36 30 0 30 36v75zM765 1529h29v-68-67h-29v16q-17-20-43-20-29 0-48 20t-19 51 19 51 48 20q28 0 43-20v17zM943 1488q0-34-47-40l-14-2q-23-4-23-14 0-15 25-15 23 0 43 11l12-24q-22-14-55-14-26 0-41 12t-15 32q0 33 47 39l13 2q24 4 24 14 0 17-31 17-25 0-45-14l-13 23q25 17 58 17 29 0 45.5-12t16.5-32zM1073 1522l-8-25q-13 7-26 7-19 0-19-22v-61h48v-27h-48v-41h-30v41h-28v27h28v61q0 50 47 50 21 0 36-10zM1159 1390q-29 0-48 20t-19 51q0 32 19.5 51.5t49.5 19.5q33 0 55-19l-14-22q-18 15-39 15-34 0-41-33h101v-12q0-32-18-51.5t-46-19.5zM1318 1390q-23 0-35 20v-16h-30v135h30v-76q0-35 29-35 10 0 18 4l9-28q-9-4-21-4zM1348 1461q0 31 19.5 51t52.5 20q29 0 48-16l-14-24q-18 13-35 12-18 0-29.5-12t-11.5-31 11.5-31 29.5-12q19 0 35 12l14-24q-20-16-48-16-33 0-52.5 20t-19.5 51zM1593 1529h30v-68-67h-30v16q-15-20-42-20-29 0-48.5 20t-19.5 51 19.5 51 48.5 20q28 0 42-20v17zM1726 1390q-23 0-35 20v-16h-29v135h29v-76q0-35 29-35 10 0 18 4l9-28q-8-4-21-4zM1866 1529h29v-68-122h-29v71q-15-20-43-20t-47.5 20.5-19.5 50.5 19.5 50.5 47.5 20.5q29 0 43-20v17zM1944 1509l-2 1h-3q-2 1-4 3-3 1-3 4-1 2-1 6 0 3 1 5 0 2 3 4 2 2 4 3t5 1q4 0 6-1 0-1 2-2l2-1q1-1 3-4 1-2 1-5 0-4-1-6-1-1-3-4 0-1-2-2l-2-1q-1 0-3-0.5t-3-0.5zM2304 256v1280q0 52-38 90t-90 38h-2048q-52 0-90-38t-38-90v-1280q0-52 38-90t90-38h2048q52 0 90 38t38 90z"}]}})


/***/ }),
/* 1371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"cc-paypal":{"width":2304,"height":1792,"paths":[{"d":"M745 906q0 37-25.5 61.5t-62.5 24.5q-29 0-46.5-16t-17.5-44q0-37 25-62.5t62-25.5q28 0 46.5 16.5t18.5 45.5zM1530 757q0 42-22 57t-66 15l-32 1 17-107q2-11 13-11h18q22 0 35 2t25 12.5 12 30.5zM1881 906q0 36-25.5 61t-61.5 25q-29 0-47-16t-18-44q0-37 25-62.5t62-25.5q28 0 46.5 16.5t18.5 45.5zM513 735q0-59-38.5-85.5t-100.5-26.5h-160q-19 0-21 19l-65 408q-1 6 3 11t10 5h76q20 0 22-19l18-110q1-8 7-13t15-6.5 17-1.5 19 1 14 1q86 0 135-48.5t49-134.5zM822 1047l41-261q1-6-3-11t-10-5h-76q-14 0-17 33-27-40-95-40-72 0-122.5 54t-50.5 127q0 59 34.5 94t92.5 35q28 0 58-12t48-32q-4 12-4 21 0 16 13 16h69q19 0 22-19zM1269 784q0-5-4-9.5t-9-4.5h-77q-11 0-18 10l-106 156-44-150q-5-16-22-16h-75q-5 0-9 4.5t-4 9.5q0 2 19.5 59t42 123 23.5 70q-82 112-82 120 0 13 13 13h77q11 0 18-10l255-368q2-2 2-7zM1649 735q0-59-38.5-85.5t-100.5-26.5h-159q-20 0-22 19l-65 408q-1 6 3 11t10 5h82q12 0 16-13l18-116q1-8 7-13t15-6.5 17-1.5 19 1 14 1q86 0 135-48.5t49-134.5zM1958 1047l41-261q1-6-3-11t-10-5h-76q-14 0-17 33-26-40-95-40-72 0-122.5 54t-50.5 127q0 59 34.5 94t92.5 35q29 0 59-12t47-32q0 1-2 9t-2 12q0 16 13 16h69q19 0 22-19zM2176 638v-1q0-14-13-14h-74q-11 0-13 11l-65 416-1 2q0 5 4 9.5t10 4.5h66q19 0 21-19zM392 772q-5 35-26 46t-60 11l-33 1 17-107q2-11 13-11h19q40 0 58 11.5t12 48.5zM2304 256v1280q0 52-38 90t-90 38h-2048q-52 0-90-38t-38-90v-1280q0-52 38-90t90-38h2048q52 0 90 38t38 90z"}]}})


/***/ }),
/* 1372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"cc-stripe":{"width":2304,"height":1792,"paths":[{"d":"M1597 903q0 69-21 106-19 35-52 35-23 0-41-9v-224q29-30 57-30 57 0 57 122zM2035 867h-110q6-98 56-98 51 0 54 98zM476 1002q0-59-33-91.5t-101-57.5q-36-13-52-24t-16-25q0-26 38-26 58 0 124 33l18-112q-67-32-149-32-77 0-123 38-48 39-48 109 0 58 32.5 90.5t99.5 56.5q39 14 54.5 25.5t15.5 27.5q0 31-48 31-29 0-70-12.5t-72-30.5l-18 113q72 41 168 41 81 0 129-37 51-41 51-117zM771 787l19-111h-96v-135l-129 21-18 114-46 8-17 103h62v219q0 84 44 120 38 30 111 30 32 0 79-11v-118q-32 7-44 7-42 0-42-50v-197h77zM1087 812v-139q-15-3-28-3-32 0-55.5 16t-33.5 46l-10-56h-131v471h150v-306q26-31 82-31 16 0 26 2zM1124 1147h150v-471h-150v471zM1746 898q0-122-45-179-40-52-111-52-64 0-117 56l-8-47h-132v645l150-25v-151q36 11 68 11 83 0 134-56 61-65 61-202zM1278 550q0-33-23-56t-56-23-56 23-23 56 23 56.5 56 23.5 56-23.5 23-56.5zM2176 907q0-113-48-176-50-64-144-64-96 0-151.5 66t-55.5 180q0 128 63 188 55 55 161 55 101 0 160-40l-16-103q-57 31-128 31-43 0-63-19-23-19-28-66h248q2-14 2-52zM2304 256v1280q0 52-38 90t-90 38h-2048q-52 0-90-38t-38-90v-1280q0-52 38-90t90-38h2048q52 0 90 38t38 90z"}]}})


/***/ }),
/* 1373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"cc-visa":{"width":2304,"height":1792,"paths":[{"d":"M1975 990h-138q14-37 66-179l3-9q4-10 10-26t9-26l12 55zM531 925l-58-295q-11-54-75-54h-268l-2 13q311 79 403 336zM710 576l-162 438-17-89q-26-70-85-129.5t-131-88.5l135 510h175l261-641h-176zM849 1218h166l104-642h-166zM1617 592q-69-27-149-27-123 0-201 59t-79 153q-1 102 145 174 48 23 67 41t19 39q0 30-30 46t-69 16q-86 0-156-33l-22-11-23 144q74 34 185 34 130 1 208.5-59t80.5-160q0-106-140-174-49-25-71-42t-22-38q0-22 24.5-38.5t70.5-16.5q70-1 124 24l15 8zM2042 576h-128q-65 0-87 54l-246 588h174l35-96h212q5 22 20 96h154zM2304 256v1280q0 52-38 90t-90 38h-2048q-52 0-90-38t-38-90v-1280q0-52 38-90t90-38h2048q52 0 90 38t38 90z"}]}})


/***/ }),
/* 1374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"cc":{"width":2048,"height":1792,"paths":[{"d":"M785 1008h207q-14 158-98.5 248.5t-214.5 90.5q-162 0-254.5-116t-92.5-316q0-194 93-311.5t233-117.5q148 0 232 87t97 247h-203q-5-64-35.5-99t-81.5-35q-57 0-88.5 60.5t-31.5 177.5q0 48 5 84t18 69.5 40 51.5 66 18q95 0 109-139zM1497 1008h206q-14 158-98 248.5t-214 90.5q-162 0-254.5-116t-92.5-316q0-194 93-311.5t233-117.5q148 0 232 87t97 247h-204q-4-64-35-99t-81-35q-57 0-88.5 60.5t-31.5 177.5q0 48 5 84t18 69.5 39.5 51.5 65.5 18q49 0 76.5-38t33.5-101zM1856 889q0-207-15.5-307t-60.5-161q-6-8-13.5-14t-21.5-15-16-11q-86-63-697-63-625 0-710 63-5 4-17.5 11.5t-21 14-14.5 14.5q-45 60-60 159.5t-15 308.5q0 208 15 307.5t60 160.5q6 8 15 15t20.5 14 17.5 12q44 33 239.5 49t470.5 16q610 0 697-65 5-4 17-11t20.5-14 13.5-16q46-60 61-159t15-309zM2048 128v1536h-2048v-1536h2048z"}]}})


/***/ }),
/* 1375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"certificate":{"width":1536,"height":1792,"paths":[{"d":"M1376 896l138 135q30 28 20 70-12 41-52 51l-188 48 53 186q12 41-19 70-29 31-70 19l-186-53-48 188q-10 40-51 52-12 2-19 2-31 0-51-22l-135-138-135 138q-28 30-70 20-41-11-51-52l-48-188-186 53q-41 12-70-19-31-29-19-70l53-186-188-48q-40-10-52-51-10-42 20-70l138-135-138-135q-30-28-20-70 12-41 52-51l188-48-53-186q-12-41 19-70 29-31 70-19l186 53 48-188q10-41 51-51 41-12 70 19l135 139 135-139q29-30 70-19 41 10 51 51l48 188 186-53q41-12 70 19 31 29 19 70l-53 186 188 48q40 10 52 51 10 42-20 70z"}]}})


/***/ }),
/* 1376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"chain-broken":{"width":1664,"height":1792,"paths":[{"d":"M439 1271l-256 256q-11 9-23 9t-23-9q-9-10-9-23t9-23l256-256q10-9 23-9t23 9q9 10 9 23t-9 23zM608 1312v320q0 14-9 23t-23 9-23-9-9-23v-320q0-14 9-23t23-9 23 9 9 23zM384 1088q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23 9-23 23-9h320q14 0 23 9t9 23zM1648 1216q0 120-85 203l-147 146q-83 83-203 83-121 0-204-85l-334-335q-21-21-42-56l239-18 273 274q27 27 68 27.5t68-26.5l147-146q28-28 28-67 0-40-28-68l-274-275 18-239q35 21 56 42l336 336q84 86 84 204zM1031 492l-239 18-273-274q-28-28-68-28-39 0-68 27l-147 146q-28 28-28 67 0 40 28 68l274 274-18 240q-35-21-56-42l-336-336q-84-86-84-204 0-120 85-203l147-146q83-83 203-83 121 0 204 85l334 335q21 21 42 56zM1664 576q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23 9-23 23-9h320q14 0 23 9t9 23zM1120 32v320q0 14-9 23t-23 9-23-9-9-23v-320q0-14 9-23t23-9 23 9 9 23zM1527 183l-256 256q-11 9-23 9t-23-9q-9-10-9-23t9-23l256-256q10-9 23-9t23 9q9 10 9 23t-9 23z"}]}})


/***/ }),
/* 1377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"chain":{"width":1664,"height":1792,"paths":[{"d":"M1456 1216q0-40-28-68l-208-208q-28-28-68-28-42 0-72 32 3 3 19 18.5t21.5 21.5 15 19 13 25.5 3.5 27.5q0 40-28 68t-68 28q-15 0-27.5-3.5t-25.5-13-19-15-21.5-21.5-18.5-19q-33 31-33 73 0 40 28 68l206 207q27 27 68 27 40 0 68-26l147-146q28-28 28-67zM753 511q0-40-28-68l-206-207q-28-28-68-28-39 0-68 27l-147 146q-28 28-28 67 0 40 28 68l208 208q27 27 68 27 42 0 72-31-3-3-19-18.5t-21.5-21.5-15-19-13-25.5-3.5-27.5q0-40 28-68t68-28q15 0 27.5 3.5t25.5 13 19 15 21.5 21.5 18.5 19q33-31 33-73zM1648 1216q0 120-85 203l-147 146q-83 83-203 83-121 0-204-85l-206-207q-83-83-83-203 0-123 88-209l-88-88q-86 88-208 88-120 0-204-84l-208-208q-84-84-84-204t85-203l147-146q83-83 203-83 121 0 204 85l206 207q83 83 83 203 0 123-88 209l88 88q86-88 208-88 120 0 204 84l208 208q84 84 84 204z"}]}})


/***/ }),
/* 1378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"check-circle-o":{"width":1536,"height":1792,"paths":[{"d":"M1171 813l-422 422q-19 19-45 19t-45-19l-294-294q-19-19-19-45t19-45l102-102q19-19 45-19t45 19l147 147 275-275q19-19 45-19t45 19l102 102q19 19 19 45t-19 45zM1312 896q0-148-73-273t-198-198-273-73-273 73-198 198-73 273 73 273 198 198 273 73 273-73 198-198 73-273zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"check-circle":{"width":1536,"height":1792,"paths":[{"d":"M1284 734q0-28-18-46l-91-90q-19-19-45-19t-45 19l-408 407-226-226q-19-19-45-19t-45 19l-91 90q-18 18-18 46 0 27 18 45l362 362q19 19 45 19 27 0 46-19l543-543q18-18 18-45zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"check-square-o":{"width":1664,"height":1792,"paths":[{"d":"M1408 930v318q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q63 0 117 25 15 7 18 23 3 17-9 29l-49 49q-10 10-23 10-3 0-9-2-23-6-45-6h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113v-254q0-13 9-22l64-64q10-10 23-10 6 0 12 3 20 8 20 29zM1639 441l-814 814q-24 24-57 24t-57-24l-430-430q-24-24-24-57t24-57l110-110q24-24 57-24t57 24l263 263 647-647q24-24 57-24t57 24l110 110q24 24 24 57t-24 57z"}]}})


/***/ }),
/* 1381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"check-square":{"width":1536,"height":1792,"paths":[{"d":"M685 1299l614-614q19-19 19-45t-19-45l-102-102q-19-19-45-19t-45 19l-467 467-211-211q-19-19-45-19t-45 19l-102 102q-19 19-19 45t19 45l358 358q19 19 45 19t45-19zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 1382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"check":{"width":1792,"height":1792,"paths":[{"d":"M1671 566q0 40-28 68l-724 724-136 136q-28 28-68 28t-68-28l-136-136-362-362q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 295 656-657q28-28 68-28t68 28l136 136q28 28 28 68z"}]}})


/***/ }),
/* 1383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"chevron-circle-down":{"width":1536,"height":1792,"paths":[{"d":"M813 1299l454-454q19-19 19-45t-19-45l-102-102q-19-19-45-19t-45 19l-307 307-307-307q-19-19-45-19t-45 19l-102 102q-19 19-19 45t19 45l454 454q19 19 45 19t45-19zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"chevron-circle-left":{"width":1536,"height":1792,"paths":[{"d":"M909 1395l102-102q19-19 19-45t-19-45l-307-307 307-307q19-19 19-45t-19-45l-102-102q-19-19-45-19t-45 19l-454 454q-19 19-19 45t19 45l454 454q19 19 45 19t45-19zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"chevron-circle-right":{"width":1536,"height":1792,"paths":[{"d":"M717 1395l454-454q19-19 19-45t-19-45l-454-454q-19-19-45-19t-45 19l-102 102q-19 19-19 45t19 45l307 307-307 307q-19 19-19 45t19 45l102 102q19 19 45 19t45-19zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"chevron-circle-up":{"width":1536,"height":1792,"paths":[{"d":"M1165 1139l102-102q19-19 19-45t-19-45l-454-454q-19-19-45-19t-45 19l-454 454q-19 19-19 45t19 45l102 102q19 19 45 19t45-19l307-307 307 307q19 19 45 19t45-19zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"chevron-down":{"width":1792,"height":1792,"paths":[{"d":"M1683 808l-742 741q-19 19-45 19t-45-19l-742-741q-19-19-19-45.5t19-45.5l166-165q19-19 45-19t45 19l531 531 531-531q19-19 45-19t45 19l166 165q19 19 19 45.5t-19 45.5z"}]}})


/***/ }),
/* 1388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"chevron-left":{"width":1280,"height":1792,"paths":[{"d":"M1171 301l-531 531 531 531q19 19 19 45t-19 45l-166 166q-19 19-45 19t-45-19l-742-742q-19-19-19-45t19-45l742-742q19-19 45-19t45 19l166 166q19 19 19 45t-19 45z"}]}})


/***/ }),
/* 1389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"chevron-right":{"width":1280,"height":1792,"paths":[{"d":"M1107 877l-742 742q-19 19-45 19t-45-19l-166-166q-19-19-19-45t19-45l531-531-531-531q-19-19-19-45t19-45l166-166q19-19 45-19t45 19l742 742q19 19 19 45t-19 45z"}]}})


/***/ }),
/* 1390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"chevron-up":{"width":1792,"height":1792,"paths":[{"d":"M1683 1331l-166 165q-19 19-45 19t-45-19l-531-531-531 531q-19 19-45 19t-45-19l-166-165q-19-19-19-45.5t19-45.5l742-741q19-19 45-19t45 19l742 741q19 19 19 45.5t-19 45.5z"}]}})


/***/ }),
/* 1391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"child":{"width":1280,"height":1792,"paths":[{"d":"M1188 548l-292 292v824q0 46-33 79t-79 33-79-33-33-79v-384h-64v384q0 46-33 79t-79 33-79-33-33-79v-824l-292-292q-28-28-28-68t28-68q29-28 68.5-28t67.5 28l228 228h368l228-228q28-28 68-28t68 28q28 29 28 68.5t-28 67.5zM864 384q0 93-65.5 158.5t-158.5 65.5-158.5-65.5-65.5-158.5 65.5-158.5 158.5-65.5 158.5 65.5 65.5 158.5z"}]}})


/***/ }),
/* 1392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"chrome":{"width":1792,"height":1792,"paths":[{"d":"M893 0q240-2 451 120 232 134 352 372l-742-39q-160-9-294 74.5t-185 229.5l-276-424q128-159 311-245.5t383-87.5zM146 405l337 663q72 143 211 217t293 45l-230 451q-212-33-385-157.5t-272.5-316-99.5-411.5q0-267 146-491zM1732 574q58 150 59.5 310.5t-48.5 306-153 272-246 209.5q-230 133-498 119l405-623q88-131 82.5-290.5t-106.5-277.5zM896 594q125 0 213.5 88.5t88.5 213.5-88.5 213.5-213.5 88.5-213.5-88.5-88.5-213.5 88.5-213.5 213.5-88.5z"}]}})


/***/ }),
/* 1393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"circle-o-notch":{"width":1792,"height":1792,"paths":[{"d":"M1760 896q0 176-68.5 336t-184 275.5-275.5 184-336 68.5-336-68.5-275.5-184-184-275.5-68.5-336q0-213 97-398.5t265-305.5 374-151v228q-221 45-366.5 221t-145.5 406q0 130 51 248.5t136.5 204 204 136.5 248.5 51 248.5-51 204-136.5 136.5-204 51-248.5q0-230-145.5-406t-366.5-221v-228q206 31 374 151t265 305.5 97 398.5z"}]}})


/***/ }),
/* 1394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"circle-o":{"width":1536,"height":1792,"paths":[{"d":"M768 352q-148 0-273 73t-198 198-73 273 73 273 198 198 273 73 273-73 198-198 73-273-73-273-198-198-273-73zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"circle-thin":{"width":1536,"height":1792,"paths":[{"d":"M768 256q-130 0-248.5 51t-204 136.5-136.5 204-51 248.5 51 248.5 136.5 204 204 136.5 248.5 51 248.5-51 204-136.5 136.5-204 51-248.5-51-248.5-136.5-204-204-136.5-248.5-51zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"circle":{"width":1536,"height":1792,"paths":[{"d":"M1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"clipboard":{"width":1792,"height":1792,"paths":[{"d":"M768 1664h896v-640h-416q-40 0-68-28t-28-68v-416h-384v1152zM1024 224v-64q0-13-9.5-22.5t-22.5-9.5h-704q-13 0-22.5 9.5t-9.5 22.5v64q0 13 9.5 22.5t22.5 9.5h704q13 0 22.5-9.5t9.5-22.5zM1280 896h299l-299-299v299zM1792 1024v672q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-160h-544q-40 0-68-28t-28-68v-1344q0-40 28-68t68-28h1088q40 0 68 28t28 68v328q21 13 36 28l408 408q28 28 48 76t20 88z"}]}})


/***/ }),
/* 1398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"clock-o":{"width":1536,"height":1792,"paths":[{"d":"M896 544v448q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h224v-352q0-14 9-23t23-9h64q14 0 23 9t9 23zM1312 896q0-148-73-273t-198-198-273-73-273 73-198 198-73 273 73 273 198 198 273 73 273-73 198-198 73-273zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"clone":{"width":1792,"height":1792,"paths":[{"d":"M1664 1632v-1088q0-13-9.5-22.5t-22.5-9.5h-1088q-13 0-22.5 9.5t-9.5 22.5v1088q0 13 9.5 22.5t22.5 9.5h1088q13 0 22.5-9.5t9.5-22.5zM1792 544v1088q0 66-47 113t-113 47h-1088q-66 0-113-47t-47-113v-1088q0-66 47-113t113-47h1088q66 0 113 47t47 113zM1408 160v160h-128v-160q0-13-9.5-22.5t-22.5-9.5h-1088q-13 0-22.5 9.5t-9.5 22.5v1088q0 13 9.5 22.5t22.5 9.5h160v128h-160q-66 0-113-47t-47-113v-1088q0-66 47-113t113-47h1088q66 0 113 47t47 113z"}]}})


/***/ }),
/* 1400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"close":{"width":1408,"height":1792,"paths":[{"d":"M1298 1322q0 40-28 68l-136 136q-28 28-68 28t-68-28l-294-294-294 294q-28 28-68 28t-68-28l-136-136q-28-28-28-68t28-68l294-294-294-294q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 294 294-294q28-28 68-28t68 28l136 136q28 28 28 68t-28 68l-294 294 294 294q28 28 28 68z"}]}})


/***/ }),
/* 1401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"cloud-download":{"width":1920,"height":1792,"paths":[{"d":"M1280 928q0-14-9-23t-23-9h-224v-352q0-13-9.5-22.5t-22.5-9.5h-192q-13 0-22.5 9.5t-9.5 22.5v352h-224q-13 0-22.5 9.5t-9.5 22.5q0 14 9 23l352 352q9 9 23 9t23-9l351-351q10-12 10-24zM1920 1152q0 159-112.5 271.5t-271.5 112.5h-1088q-185 0-316.5-131.5t-131.5-316.5q0-130 70-240t188-165q-2-30-2-43 0-212 150-362t362-150q156 0 285.5 87t188.5 231q71-62 166-62 106 0 181 75t75 181q0 76-41 138 130 31 213.5 135.5t83.5 238.5z"}]}})


/***/ }),
/* 1402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"cloud-upload":{"width":1920,"height":1792,"paths":[{"d":"M1280 864q0-14-9-23l-352-352q-9-9-23-9t-23 9l-351 351q-10 12-10 24 0 14 9 23t23 9h224v352q0 13 9.5 22.5t22.5 9.5h192q13 0 22.5-9.5t9.5-22.5v-352h224q13 0 22.5-9.5t9.5-22.5zM1920 1152q0 159-112.5 271.5t-271.5 112.5h-1088q-185 0-316.5-131.5t-131.5-316.5q0-130 70-240t188-165q-2-30-2-43 0-212 150-362t362-150q156 0 285.5 87t188.5 231q71-62 166-62 106 0 181 75t75 181q0 76-41 138 130 31 213.5 135.5t83.5 238.5z"}]}})


/***/ }),
/* 1403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"cloud":{"width":1920,"height":1792,"paths":[{"d":"M1920 1152q0 159-112.5 271.5t-271.5 112.5h-1088q-185 0-316.5-131.5t-131.5-316.5q0-132 71-241.5t187-163.5q-2-28-2-43 0-212 150-362t362-150q158 0 286.5 88t187.5 230q70-62 166-62 106 0 181 75t75 181q0 75-41 138 129 30 213 134.5t84 239.5z"}]}})


/***/ }),
/* 1404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"cny":{"width":1027,"height":1792,"paths":[{"d":"M603 1536h-172q-13 0-22.5-9t-9.5-23v-330h-288q-13 0-22.5-9t-9.5-23v-103q0-13 9.5-22.5t22.5-9.5h288v-85h-288q-13 0-22.5-9t-9.5-23v-104q0-13 9.5-22.5t22.5-9.5h214l-321-578q-8-16 0-32 10-16 28-16h194q19 0 29 18l215 425q19 38 56 125 10-24 30.5-68t27.5-61l191-420q8-19 29-19h191q17 0 27 16 9 14 1 31l-313 579h215q13 0 22.5 9.5t9.5 22.5v104q0 14-9.5 23t-22.5 9h-290v85h290q13 0 22.5 9.5t9.5 22.5v103q0 14-9.5 23t-22.5 9h-290v330q0 13-9.5 22.5t-22.5 9.5z"}]}})


/***/ }),
/* 1405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"code-fork":{"width":1024,"height":1792,"paths":[{"d":"M288 1472q0-40-28-68t-68-28-68 28-28 68 28 68 68 28 68-28 28-68zM288 320q0-40-28-68t-68-28-68 28-28 68 28 68 68 28 68-28 28-68zM928 448q0-40-28-68t-68-28-68 28-28 68 28 68 68 28 68-28 28-68zM1024 448q0 52-26 96.5t-70 69.5q-2 287-226 414-67 38-203 81-128 40-169.5 71t-41.5 100v26q44 25 70 69.5t26 96.5q0 80-56 136t-136 56-136-56-56-136q0-52 26-96.5t70-69.5v-820q-44-25-70-69.5t-26-96.5q0-80 56-136t136-56 136 56 56 136q0 52-26 96.5t-70 69.5v497q54-26 154-57 55-17 87.5-29.5t70.5-31 59-39.5 40.5-51 28-69.5 8.5-91.5q-44-25-70-69.5t-26-96.5q0-80 56-136t136-56 136 56 56 136z"}]}})


/***/ }),
/* 1406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"code":{"width":1920,"height":1792,"paths":[{"d":"M617 1399l-50 50q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l50 50q10 10 10 23t-10 23l-393 393 393 393q10 10 10 23t-10 23zM1208 332l-373 1291q-4 13-15.5 19.5t-23.5 2.5l-62-17q-13-4-19.5-15.5t-2.5-24.5l373-1291q4-13 15.5-19.5t23.5-2.5l62 17q13 4 19.5 15.5t2.5 24.5zM1865 983l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23t-10 23z"}]}})


/***/ }),
/* 1407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"codepen":{"width":1792,"height":1792,"paths":[{"d":"M216 1169l603 402v-359l-334-223zM154 1025l193-129-193-129v258zM973 1571l603-402-269-180-334 223v359zM896 1078l272-182-272-182-272 182zM485 803l334-223v-359l-603 402zM1445 896l193 129v-258zM1307 803l269-180-603-402v359zM1792 623v546q0 41-34 64l-819 546q-21 13-43 13t-43-13l-819-546q-34-23-34-64v-546q0-41 34-64l819-546q21-13 43-13t43 13l819 546q34 23 34 64z"}]}})


/***/ }),
/* 1408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"codiepie":{"width":1792,"height":1792,"paths":[{"d":"M1584 1290l-218-111q-74 120-196.5 189t-263.5 69q-147 0-271-72t-196-196-72-270q0-110 42.5-209.5t115-172 172-115 209.5-42.5q131 0 247.5 60.5t192.5 168.5l215-125q-110-169-286.5-265t-378.5-96q-161 0-308 63t-253 169-169 253-63 308 63 308 169 253 253 169 308 63q213 0 397.5-107t290.5-292zM1030 893l693 352q-116 253-334.5 400t-492.5 147q-182 0-348-71t-286-191-191-286-71-348 71-348 191-286 286-191 348-71q260 0 470.5 133.5t335.5 366.5zM1543 896h-39v160h-96v-352h136q32 0 54.5 20t28.5 48 1 56-27.5 48-57.5 20z"}]}})


/***/ }),
/* 1409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"coffee":{"width":1920,"height":1792,"paths":[{"d":"M1664 640q0-80-56-136t-136-56h-64v384h64q80 0 136-56t56-136zM0 1408h1792q0 106-75 181t-181 75h-1280q-106 0-181-75t-75-181zM1856 640q0 159-112.5 271.5t-271.5 112.5h-64v32q0 92-66 158t-158 66h-704q-92 0-158-66t-66-158v-736q0-26 19-45t45-19h1152q159 0 271.5 112.5t112.5 271.5z"}]}})


/***/ }),
/* 1410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"cog":{"width":1536,"height":1792,"paths":[{"d":"M1024 896q0-106-75-181t-181-75-181 75-75 181 75 181 181 75 181-75 75-181zM1536 787v222q0 12-8 23t-20 13l-185 28q-19 54-39 91 35 50 107 138 10 12 10 25t-9 23q-27 37-99 108t-94 71q-12 0-26-9l-138-108q-44 23-91 38-16 136-29 186-7 28-36 28h-222q-14 0-24.5-8.5t-11.5-21.5l-28-184q-49-16-90-37l-141 107q-10 9-25 9-14 0-25-11-126-114-165-168-7-10-7-23 0-12 8-23 15-21 51-66.5t54-70.5q-27-50-41-99l-183-27q-13-2-21-12.5t-8-23.5v-222q0-12 8-23t19-13l186-28q14-46 39-92-40-57-107-138-10-12-10-24 0-10 9-23 26-36 98.5-107.5t94.5-71.5q13 0 26 10l138 107q44-23 91-38 16-136 29-186 7-28 36-28h222q14 0 24.5 8.5t11.5 21.5l28 184q49 16 90 37l142-107q9-9 24-9 13 0 25 10 129 119 165 170 7 8 7 22 0 12-8 23-15 21-51 66.5t-54 70.5q26 50 41 98l183 28q13 2 21 12.5t8 23.5z"}]}})


/***/ }),
/* 1411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"cogs":{"width":1920,"height":1792,"paths":[{"d":"M896 896q0-106-75-181t-181-75-181 75-75 181 75 181 181 75 181-75 75-181zM1664 1408q0-52-38-90t-90-38-90 38-38 90q0 53 37.5 90.5t90.5 37.5 90.5-37.5 37.5-90.5zM1664 384q0-52-38-90t-90-38-90 38-38 90q0 53 37.5 90.5t90.5 37.5 90.5-37.5 37.5-90.5zM1280 805v185q0 10-7 19.5t-16 10.5l-155 24q-11 35-32 76 34 48 90 115 7 11 7 20 0 12-7 19-23 30-82.5 89.5t-78.5 59.5q-11 0-21-7l-115-90q-37 19-77 31-11 108-23 155-7 24-30 24h-186q-11 0-20-7.5t-10-17.5l-23-153q-34-10-75-31l-118 89q-7 7-20 7-11 0-21-8-144-133-144-160 0-9 7-19 10-14 41-53t47-61q-23-44-35-82l-152-24q-10-1-17-9.5t-7-19.5v-185q0-10 7-19.5t16-10.5l155-24q11-35 32-76-34-48-90-115-7-11-7-20 0-12 7-20 22-30 82-89t79-59q11 0 21 7l115 90q34-18 77-32 11-108 23-154 7-24 30-24h186q11 0 20 7.5t10 17.5l23 153q34 10 75 31l118-89q8-7 20-7 11 0 21 8 144 133 144 160 0 8-7 19-12 16-42 54t-45 60q23 48 34 82l152 23q10 2 17 10.5t7 19.5zM1920 1338v140q0 16-149 31-12 27-30 52 51 113 51 138 0 4-4 7-122 71-124 71-8 0-46-47t-52-68q-20 2-30 2t-30-2q-14 21-52 68t-46 47q-2 0-124-71-4-3-4-7 0-25 51-138-18-25-30-52-149-15-149-31v-140q0-16 149-31 13-29 30-52-51-113-51-138 0-4 4-7 4-2 35-20t59-34 30-16q8 0 46 46.5t52 67.5q20-2 30-2t30 2q51-71 92-112l6-2q4 0 124 70 4 3 4 7 0 25-51 138 17 23 30 52 149 15 149 31zM1920 314v140q0 16-149 31-12 27-30 52 51 113 51 138 0 4-4 7-122 71-124 71-8 0-46-47t-52-68q-20 2-30 2t-30-2q-14 21-52 68t-46 47q-2 0-124-71-4-3-4-7 0-25 51-138-18-25-30-52-149-15-149-31v-140q0-16 149-31 13-29 30-52-51-113-51-138 0-4 4-7 4-2 35-20t59-34 30-16q8 0 46 46.5t52 67.5q20-2 30-2t30 2q51-71 92-112l6-2q4 0 124 70 4 3 4 7 0 25-51 138 17 23 30 52 149 15 149 31z"}]}})


/***/ }),
/* 1412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"columns":{"width":1664,"height":1792,"paths":[{"d":"M160 1536h608v-1152h-640v1120q0 13 9.5 22.5t22.5 9.5zM1536 1504v-1120h-640v1152h608q13 0 22.5-9.5t9.5-22.5zM1664 288v1216q0 66-47 113t-113 47h-1344q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1344q66 0 113 47t47 113z"}]}})


/***/ }),
/* 1413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"comment-o":{"width":1792,"height":1792,"paths":[{"d":"M896 384q-204 0-381.5 69.5t-282 187.5-104.5 255q0 112 71.5 213.5t201.5 175.5l87 50-27 96q-24 91-70 172 152-63 275-171l43-38 57 6q69 8 130 8 204 0 381.5-69.5t282-187.5 104.5-255-104.5-255-282-187.5-381.5-69.5zM1792 896q0 174-120 321.5t-326 233-450 85.5q-70 0-145-8-198 175-460 242-49 14-114 22h-5q-15 0-27-10.5t-16-27.5v-1q-3-4-0.5-12t2-10 4.5-9.5l6-9t7-8.5 8-9q7-8 31-34.5t34.5-38 31-39.5 32.5-51 27-59 26-76q-157-89-247.5-220t-90.5-281q0-174 120-321.5t326-233 450-85.5 450 85.5 326 233 120 321.5z"}]}})


/***/ }),
/* 1414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"comment":{"width":1792,"height":1792,"paths":[{"d":"M1792 896q0 174-120 321.5t-326 233-450 85.5q-70 0-145-8-198 175-460 242-49 14-114 22-17 2-30.5-9t-17.5-29v-1q-3-4-0.5-12t2-10 4.5-9.5l6-9t7-8.5 8-9q7-8 31-34.5t34.5-38 31-39.5 32.5-51 27-59 26-76q-157-89-247.5-220t-90.5-281q0-130 71-248.5t191-204.5 286-136.5 348-50.5q244 0 450 85.5t326 233 120 321.5z"}]}})


/***/ }),
/* 1415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"commenting-o":{"width":1792,"height":1792,"paths":[{"d":"M640 896q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zM1024 896q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zM1408 896q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zM896 384q-204 0-381.5 69.5t-282 187.5-104.5 255q0 112 71.5 213.5t201.5 175.5l87 50-27 96q-24 91-70 172 152-63 275-171l43-38 57 6q69 8 130 8 204 0 381.5-69.5t282-187.5 104.5-255-104.5-255-282-187.5-381.5-69.5zM1792 896q0 174-120 321.5t-326 233-450 85.5q-70 0-145-8-198 175-460 242-49 14-114 22h-5q-15 0-27-10.5t-16-27.5v-1q-3-4-0.5-12t2-10 4.5-9.5l6-9t7-8.5 8-9q7-8 31-34.5t34.5-38 31-39.5 32.5-51 27-59 26-76q-157-89-247.5-220t-90.5-281q0-130 71-248.5t191-204.5 286-136.5 348-50.5 348 50.5 286 136.5 191 204.5 71 248.5z"}]}})


/***/ }),
/* 1416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"commenting":{"width":1792,"height":1792,"paths":[{"d":"M640 896q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1024 896q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1408 896q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1792 896q0 174-120 321.5t-326 233-450 85.5q-110 0-211-18-173 173-435 229-52 10-86 13-12 1-22-6t-13-18q-4-15 20-37 5-5 23.5-21.5t25.5-23.5 23.5-25.5 24-31.5 20.5-37 20-48 14.5-57.5 12.5-72.5q-146-90-229.5-216.5t-83.5-269.5q0-174 120-321.5t326-233 450-85.5 450 85.5 326 233 120 321.5z"}]}})


/***/ }),
/* 1417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"comments-o":{"width":1792,"height":1792,"paths":[{"d":"M704 384q-153 0-286 52t-211.5 141-78.5 191q0 82 53 158t149 132l97 56-35 84q34-20 62-39l44-31 53 10q78 14 153 14 153 0 286-52t211.5-141 78.5-191-78.5-191-211.5-141-286-52zM704 256q191 0 353.5 68.5t256.5 186.5 94 257-94 257-256.5 186.5-353.5 68.5q-86 0-176-16-124 88-278 128-36 9-86 16h-3q-11 0-20.5-8t-11.5-21q-1-3-1-6.5t0.5-6.5 2-6l2.5-5t3.5-5.5 4-5 4.5-5 4-4.5q5-6 23-25t26-29.5 22.5-29 25-38.5 20.5-44q-124-72-195-177t-71-224q0-139 94-257t256.5-186.5 353.5-68.5zM1526 1425q10 24 20.5 44t25 38.5 22.5 29 26 29.5 23 25q1 1 4 4.5t4.5 5 4 5 3.5 5.5l2.5 5t2 6 0.5 6.5-1 6.5q-3 14-13 22t-22 7q-50-7-86-16-154-40-278-128-90 16-176 16-271 0-472-132 58 4 88 4 161 0 309-45t264-129q125-92 192-212t67-254q0-77-23-152 129 71 204 178t75 230q0 120-71 224.5t-195 176.5z"}]}})


/***/ }),
/* 1418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"comments":{"width":1792,"height":1792,"paths":[{"d":"M1408 768q0 139-94 257t-256.5 186.5-353.5 68.5q-86 0-176-16-124 88-278 128-36 9-86 16h-3q-11 0-20.5-8t-11.5-21q-1-3-1-6.5t0.5-6.5 2-6l2.5-5t3.5-5.5 4-5 4.5-5 4-4.5q5-6 23-25t26-29.5 22.5-29 25-38.5 20.5-44q-124-72-195-177t-71-224q0-139 94-257t256.5-186.5 353.5-68.5 353.5 68.5 256.5 186.5 94 257zM1792 1024q0 120-71 224.5t-195 176.5q10 24 20.5 44t25 38.5 22.5 29 26 29.5 23 25q1 1 4 4.5t4.5 5 4 5 3.5 5.5l2.5 5t2 6 0.5 6.5-1 6.5q-3 14-13 22t-22 7q-50-7-86-16-154-40-278-128-90 16-176 16-271 0-472-132 58 4 88 4 161 0 309-45t264-129q125-92 192-212t67-254q0-77-23-152 129 71 204 178t75 230z"}]}})


/***/ }),
/* 1419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"compass":{"width":1536,"height":1792,"paths":[{"d":"M640 1088l256-128-256-128v256zM1024 497v542l-512 256v-542zM1312 896q0-148-73-273t-198-198-273-73-273 73-198 198-73 273 73 273 198 198 273 73 273-73 198-198 73-273zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"compress":{"width":1536,"height":1792,"paths":[{"d":"M768 960v448q0 26-19 45t-45 19-45-19l-144-144-332 332q-10 10-23 10t-23-10l-114-114q-10-10-10-23t10-23l332-332-144-144q-19-19-19-45t19-45 45-19h448q26 0 45 19t19 45zM1523 288q0 13-10 23l-332 332 144 144q19 19 19 45t-19 45-45 19h-448q-26 0-45-19t-19-45v-448q0-26 19-45t45-19 45 19l144 144 332-332q10-10 23-10t23 10l114 114q10 10 10 23z"}]}})


/***/ }),
/* 1421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"connectdevelop":{"width":2048,"height":1792,"paths":[{"d":"M2048 895q0 21-13 36.5t-33 19.5l-205 356q3 9 3 18 0 20-12.5 35.5t-32.5 19.5l-193 337q3 8 3 16 0 23-16.5 40t-40.5 17q-25 0-41-18h-400q-17 20-43 20t-43-20h-399q-17 20-43 20-23 0-40-16.5t-17-40.5q0-8 4-20l-193-335q-20-4-32.5-19.5t-12.5-35.5q0-9 3-18l-206-356q-20-5-32.5-20.5t-12.5-35.5q0-21 13.5-36.5t33.5-19.5l199-344q0-1-0.5-3t-0.5-3q0-36 34-51l209-363q-4-10-4-18 0-24 17-40.5t40-16.5q26 0 44 21h396q16-21 43-21t43 21h398q18-21 44-21 23 0 40 16.5t17 40.5q0 6-4 18l207 358q23 1 39 17.5t16 38.5q0 13-7 27l187 324q19 4 31.5 19.5t12.5 35.5zM1063 1694h389l-342-354h-143l-342 354h360q18-16 39-16t39 16zM112 882q1 4 1 13 0 10-2 15l208 360 15 6 188-199v-347l-187-194q-13 8-29 10zM986 98h-388l190 200 554-200h-280q-16 16-38 16t-38-16zM1689 1310q1-6 5-11l-64-68-17 79h76zM1583 1310l22-105-252-266-296 307 63 64h463zM1495 1678l16-28 65-310h-427l333 343q8-4 13-5zM578 1694h5l342-354h-373v335l4 6q14 5 22 13zM552 1310h402l64-66-309-321-157 166v221zM359 1310h163v-189l-168 177q4 8 5 12zM358 485q0 1 0.5 2t0.5 2q0 16-8 29l171 177v-269zM552 415v311l153 157 297-314-223-236zM556 111l-4 8v264l205-74-191-201q-6 2-10 3zM1447 98h-16l-621 224 213 225zM1023 590l-297 315 311 319 296-307zM688 902l-136-141v284zM1038 1266l-42 44h85zM1374 918l238 251 132-624-3-5-1-1zM1718 518q-8-13-8-29v-2l-216-376q-5-1-13-5l-437 463 310 327zM522 394v-223l-163 282zM522 1340h-163l163 283v-283zM1607 1340l-48 227 130-227h-82zM1729 1270l207-361q-2-10-2-14 0-1 3-16l-171-296-129 612 77 82q5-3 15-7z"}]}})


/***/ }),
/* 1422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"contao":{"width":1792,"height":1792,"paths":[{"d":"M138 128h197q-70 64-126 149-36 56-59 115t-30 125.5-8.5 120 10.5 132 21 126 28 136.5q4 19 6 28 51 238 81 329 57 171 152 275h-272q-48 0-82-34t-34-82v-1304q0-48 34-82t82-34zM1346 128h308q48 0 82 34t34 82v1304q0 48-34 82t-82 34h-178q212-210 196-565l-469 101q-2 45-12 82t-31 72-59.5 59.5-93.5 36.5q-123 26-199-40-32-27-53-61t-51.5-129-64.5-258q-35-163-45.5-263t-5.5-139 23-77q20-41 62.5-73t102.5-45q45-12 83.5-6.5t67 17 54 35 43 48 34.5 56.5l468-100q-68-175-180-287z"}]}})


/***/ }),
/* 1423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"copy":{"width":1792,"height":1792,"paths":[{"d":"M1696 384q40 0 68 28t28 68v1216q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-288h-544q-40 0-68-28t-28-68v-672q0-40 20-88t48-76l408-408q28-28 76-48t88-20h416q40 0 68 28t28 68v328q68-40 128-40h416zM1152 597l-299 299h299v-299zM512 213l-299 299h299v-299zM708 860l316-316v-416h-384v416q0 40-28 68t-68 28h-416v640h512v-256q0-40 20-88t48-76zM1664 1664v-1152h-384v416q0 40-28 68t-68 28h-416v640h896z"}]}})


/***/ }),
/* 1424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"copyright":{"width":1536,"height":1792,"paths":[{"d":"M1150 1074v109q0 50-36.5 89t-94 60.5-118 32.5-117.5 11q-205 0-342.5-139t-137.5-346q0-203 136-339t339-136q34 0 75.5 4.5t93 18 92.5 34 69 56.5 28 81v109q0 16-16 16h-118q-16 0-16-16v-70q0-43-65.5-67.5t-137.5-24.5q-140 0-228.5 91.5t-88.5 237.5q0 151 91.5 249.5t233.5 98.5q68 0 138-24t70-66v-70q0-7 4.5-11.5t10.5-4.5h119q6 0 11 4.5t5 11.5zM768 256q-130 0-248.5 51t-204 136.5-136.5 204-51 248.5 51 248.5 136.5 204 204 136.5 248.5 51 248.5-51 204-136.5 136.5-204 51-248.5-51-248.5-136.5-204-204-136.5-248.5-51zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"creative-commons":{"width":1792,"height":1792,"paths":[{"d":"M605 1233q153 0 257-104 14-18 3-36l-45-82q-6-13-24-17-16-2-27 11l-4 3q-4 4-11.5 10t-17.5 13.5-23.5 14.5-28.5 13-33.5 9.5-37.5 3.5q-76 0-125-50t-49-127q0-76 48-125.5t122-49.5q37 0 71.5 14t50.5 28l16 14q11 11 26 10 16-2 24-14l53-78q13-20-2-39-3-4-11-12t-30-23.5-48.5-28-67.5-22.5-86-10q-148 0-246 96.5t-98 240.5q0 146 97 241.5t247 95.5zM1235 1233q153 0 257-104 14-18 4-36l-45-82q-8-14-25-17-16-2-27 11l-4 3q-4 4-11.5 10t-17.5 13.5-23.5 14.5-28.5 13-33.5 9.5-37.5 3.5q-76 0-125-50t-49-127q0-76 48-125.5t122-49.5q37 0 71.5 14t50.5 28l16 14q11 11 26 10 16-2 24-14l53-78q13-20-2-39-3-4-11-12t-30-23.5-48.5-28-67.5-22.5-86-10q-147 0-245.5 96.5t-98.5 240.5q0 146 97 241.5t247 95.5zM896 160q-150 0-286 58.5t-234.5 157-157 234.5-58.5 286 58.5 286 157 234.5 234.5 157 286 58.5 286-58.5 234.5-157 157-234.5 58.5-286-58.5-286-157-234.5-234.5-157-286-58.5zM896 0q182 0 348 71t286 191 191 286 71 348-71 348-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71z"}]}})


/***/ }),
/* 1426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"credit-card-alt":{"width":2304,"height":1792,"paths":[{"d":"M0 1504v-608h2304v608q0 66-47 113t-113 47h-1984q-66 0-113-47t-47-113zM640 1280v128h384v-128h-384zM256 1280v128h256v-128h-256zM2144 128q66 0 113 47t47 113v224h-2304v-224q0-66 47-113t113-47h1984z"}]}})


/***/ }),
/* 1427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"credit-card":{"width":1920,"height":1792,"paths":[{"d":"M1760 128q66 0 113 47t47 113v1216q0 66-47 113t-113 47h-1600q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1600zM160 256q-13 0-22.5 9.5t-9.5 22.5v224h1664v-224q0-13-9.5-22.5t-22.5-9.5h-1600zM1760 1536q13 0 22.5-9.5t9.5-22.5v-608h-1664v608q0 13 9.5 22.5t22.5 9.5h1600zM256 1408v-128h256v128h-256zM640 1408v-128h384v128h-384z"}]}})


/***/ }),
/* 1428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"crop":{"width":1664,"height":1792,"paths":[{"d":"M557 1280h595v-595zM512 1235l595-595h-595v595zM1664 1312v192q0 14-9 23t-23 9h-224v224q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-224h-864q-14 0-23-9t-9-23v-864h-224q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h224v-224q0-14 9-23t23-9h192q14 0 23 9t9 23v224h851l246-247q10-9 23-9t23 9q9 10 9 23t-9 23l-247 246v851h224q14 0 23 9t9 23z"}]}})


/***/ }),
/* 1429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"crosshairs":{"width":1536,"height":1792,"paths":[{"d":"M1197 1024h-109q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h109q-32-108-112.5-188.5t-188.5-112.5v109q0 26-19 45t-45 19h-128q-26 0-45-19t-19-45v-109q-108 32-188.5 112.5t-112.5 188.5h109q26 0 45 19t19 45v128q0 26-19 45t-45 19h-109q32 108 112.5 188.5t188.5 112.5v-109q0-26 19-45t45-19h128q26 0 45 19t19 45v109q108-32 188.5-112.5t112.5-188.5zM1536 832v128q0 26-19 45t-45 19h-143q-37 161-154.5 278.5t-278.5 154.5v143q0 26-19 45t-45 19h-128q-26 0-45-19t-19-45v-143q-161-37-278.5-154.5t-154.5-278.5h-143q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h143q37-161 154.5-278.5t278.5-154.5v-143q0-26 19-45t45-19h128q26 0 45 19t19 45v143q161 37 278.5 154.5t154.5 278.5h143q26 0 45 19t19 45z"}]}})


/***/ }),
/* 1430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"css3":{"width":1792,"height":1792,"paths":[{"d":"M275 128h1505l-266 1333-804 267-698-267 71-356h297l-29 147 422 161 486-161 68-339h-1208l58-297h1209l38-191h-1208z"}]}})


/***/ }),
/* 1431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"cube":{"width":1792,"height":1792,"paths":[{"d":"M896 1629l640-349v-636l-640 233v752zM832 764l698-254-698-254-698 254zM1664 512v768q0 35-18 65t-49 47l-704 384q-28 16-61 16t-61-16l-704-384q-31-17-49-47t-18-65v-768q0-40 23-73t61-47l704-256q22-8 44-8t44 8l704 256q38 14 61 47t23 73z"}]}})


/***/ }),
/* 1432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"cubes":{"width":2304,"height":1792,"paths":[{"d":"M640 1632l384-192v-314l-384 164v342zM576 1178l404-173-404-173-404 173zM1664 1632l384-192v-314l-384 164v342zM1600 1178l404-173-404-173-404 173zM1152 885l384-165v-266l-384 164v267zM1088 506l441-189-441-189-441 189zM2176 1024v416q0 36-19 67t-52 47l-448 224q-25 14-57 14t-57-14l-448-224q-4-2-7-4-2 2-7 4l-448 224q-25 14-57 14t-57-14l-448-224q-33-16-52-47t-19-67v-416q0-38 21.5-70t56.5-48l434-186v-400q0-38 21.5-70t56.5-48l448-192q23-10 50-10t50 10l448 192q35 16 56.5 48t21.5 70v400l434 186q36 16 57 48t21 70z"}]}})


/***/ }),
/* 1433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"cut":{"width":1792,"height":1792,"paths":[{"d":"M960 896q26 0 45 19t19 45-19 45-45 19-45-19-19-45 19-45 45-19zM1260 960l507 398q28 20 25 56-5 35-35 51l-128 64q-13 7-29 7-17 0-31-8l-690-387-110 66q-8 4-12 5 14 49 10 97-7 77-56 147.5t-132 123.5q-132 84-277 84-136 0-222-78-90-84-79-207 7-76 56-147t131-124q132-84 278-84 83 0 151 31 9-13 22-22l122-73-122-73q-13-9-22-22-68 31-151 31-146 0-278-84-82-53-131-124t-56-147q-5-59 15.5-113t63.5-93q85-79 222-79 145 0 277 84 83 52 132 123t56 148q4 48-10 97 4 1 12 5l110 66 690-387q14-8 31-8 16 0 29 7l128 64q30 16 35 51 3 36-25 56zM579 700q46-42 21-108t-106-117q-92-59-192-59-74 0-113 36-46 42-21 108t106 117q92 59 192 59 74 0 113-36zM494 1445q81-51 106-117t-21-108q-39-36-113-36-100 0-192 59-81 51-106 117t21 108q39 36 113 36 100 0 192-59zM672 832l96 58v-11q0-36 33-56l14-8-79-47-26 26q-3 3-10 11t-12 12q-2 2-4 3.5t-3 2.5zM896 1056l96 32 736-576-128-64-768 431v113l-160 96 9 8q2 2 7 6 4 4 11 12t11 12l26 26zM1600 1472l128-64-520-408-177 138q-2 3-13 7z"}]}})


/***/ }),
/* 1434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"cutlery":{"width":1408,"height":1792,"paths":[{"d":"M640 64v640q0 61-35.5 111t-92.5 70v779q0 52-38 90t-90 38h-128q-52 0-90-38t-38-90v-779q-57-20-92.5-70t-35.5-111v-640q0-26 19-45t45-19 45 19 19 45v416q0 26 19 45t45 19 45-19 19-45v-416q0-26 19-45t45-19 45 19 19 45v416q0 26 19 45t45 19 45-19 19-45v-416q0-26 19-45t45-19 45 19 19 45zM1408 64v1600q0 52-38 90t-90 38h-128q-52 0-90-38t-38-90v-512h-224q-13 0-22.5-9.5t-9.5-22.5v-800q0-132 94-226t226-94h256q26 0 45 19t19 45z"}]}})


/***/ }),
/* 1435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"dashboard":{"width":1792,"height":1792,"paths":[{"d":"M384 1152q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM576 704q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1004 1185l101-382q6-26-7.5-48.5t-38.5-29.5-48 6.5-30 39.5l-101 382q-60 5-107 43.5t-63 98.5q-20 77 20 146t117 89 146-20 89-117q16-60-6-117t-72-91zM1664 1152q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1024 512q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1472 704q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1792 1152q0 261-141 483-19 29-54 29h-1402q-35 0-54-29-141-221-141-483 0-182 71-348t191-286 286-191 348-71 348 71 286 191 191 286 71 348z"}]}})


/***/ }),
/* 1436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"dashcube":{"width":1536,"height":1792,"paths":[{"d":"M0 680q0-131 91.5-226.5t222.5-95.5h742l352-358v1470q0 132-91.5 227t-222.5 95h-780q-131 0-222.5-95t-91.5-227v-790zM1232 1434l-176-180v-425q0-46-32-79t-78-33h-484q-46 0-78 33t-32 79v492q0 46 32.5 79.5t77.5 33.5h770z"}]}})


/***/ }),
/* 1437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"database":{"width":1536,"height":1792,"paths":[{"d":"M768 768q237 0 443-43t325-127v170q0 69-103 128t-280 93.5-385 34.5-385-34.5-280-93.5-103-128v-170q119 84 325 127t443 43zM768 1536q237 0 443-43t325-127v170q0 69-103 128t-280 93.5-385 34.5-385-34.5-280-93.5-103-128v-170q119 84 325 127t443 43zM768 1152q237 0 443-43t325-127v170q0 69-103 128t-280 93.5-385 34.5-385-34.5-280-93.5-103-128v-170q119 84 325 127t443 43zM768 0q208 0 385 34.5t280 93.5 103 128v128q0 69-103 128t-280 93.5-385 34.5-385-34.5-280-93.5-103-128v-128q0-69 103-128t280-93.5 385-34.5z"}]}})


/***/ }),
/* 1438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"deaf":{"width":1792,"height":1792,"paths":[{"d":"M1056 832q0 26 19 45t45 19 45-19 19-45q0-146-103-249t-249-103-249 103-103 249q0 26 19 45t45 19 45-19 19-45q0-93 66-158.5t158-65.5 158 65.5 66 158.5zM835 256q-117 0-223.5 45.5t-184 123-123 184-45.5 223.5q0 26 19 45t45 19 45-19 19-45q0-185 131.5-316.5t316.5-131.5 316.5 131.5 131.5 316.5q0 55-18 103.5t-37.5 74.5-59.5 72q-34 39-52 63t-43.5 66.5-37 91-11.5 105.5q0 106-75 181t-181 75q-26 0-45 19t-19 45 19 45 45 19q159 0 271.5-112.5t112.5-271.5q0-41 7.5-74t26.5-64 33.5-50 45.5-54q35-41 53-64.5t44-67.5 37.5-93.5 11.5-108.5q0-117-45.5-223.5t-123-184-184-123-223.5-45.5zM591 975l226 226-579 579q-12 12-29 12t-29-12l-168-168q-12-12-12-29t12-29zM1612 12l168 168q12 12 12 29t-12 30l-233 233-26 25-71 71q-66-153-195-258l91-91 207-207q13-12 30-12t29 12z"}]}})


/***/ }),
/* 1439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"deafness":{"width":1792,"height":1792,"paths":[{"d":"M1056 832q0 26 19 45t45 19 45-19 19-45q0-146-103-249t-249-103-249 103-103 249q0 26 19 45t45 19 45-19 19-45q0-93 66-158.5t158-65.5 158 65.5 66 158.5zM835 256q-117 0-223.5 45.5t-184 123-123 184-45.5 223.5q0 26 19 45t45 19 45-19 19-45q0-185 131.5-316.5t316.5-131.5 316.5 131.5 131.5 316.5q0 55-18 103.5t-37.5 74.5-59.5 72q-34 39-52 63t-43.5 66.5-37 91-11.5 105.5q0 106-75 181t-181 75q-26 0-45 19t-19 45 19 45 45 19q159 0 271.5-112.5t112.5-271.5q0-41 7.5-74t26.5-64 33.5-50 45.5-54q35-41 53-64.5t44-67.5 37.5-93.5 11.5-108.5q0-117-45.5-223.5t-123-184-184-123-223.5-45.5zM591 975l226 226-579 579q-12 12-29 12t-29-12l-168-168q-12-12-12-29t12-29zM1612 12l168 168q12 12 12 29t-12 30l-233 233-26 25-71 71q-66-153-195-258l91-91 207-207q13-12 30-12t29 12z"}]}})


/***/ }),
/* 1440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"dedent":{"width":1792,"height":1792,"paths":[{"d":"M384 544v576q0 13-9.5 22.5t-22.5 9.5q-14 0-23-9l-288-288q-9-9-9-23t9-23l288-288q9-9 23-9 13 0 22.5 9.5t9.5 22.5zM1792 1312v192q0 13-9.5 22.5t-22.5 9.5h-1728q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1728q13 0 22.5 9.5t9.5 22.5zM1792 928v192q0 13-9.5 22.5t-22.5 9.5h-1088q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1088q13 0 22.5 9.5t9.5 22.5zM1792 544v192q0 13-9.5 22.5t-22.5 9.5h-1088q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1088q13 0 22.5 9.5t9.5 22.5zM1792 160v192q0 13-9.5 22.5t-22.5 9.5h-1728q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1728q13 0 22.5 9.5t9.5 22.5z"}]}})


/***/ }),
/* 1441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"delicious":{"width":1536,"height":1792,"paths":[{"d":"M1472 1376v-480h-704v-704h-480q-93 0-158.5 65.5t-65.5 158.5v480h704v704h480q93 0 158.5-65.5t65.5-158.5zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 1442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"desktop":{"width":1920,"height":1792,"paths":[{"d":"M1792 992v-832q0-13-9.5-22.5t-22.5-9.5h-1600q-13 0-22.5 9.5t-9.5 22.5v832q0 13 9.5 22.5t22.5 9.5h1600q13 0 22.5-9.5t9.5-22.5zM1920 160v1088q0 66-47 113t-113 47h-544q0 37 16 77.5t32 71 16 43.5q0 26-19 45t-45 19h-512q-26 0-45-19t-19-45q0-14 16-44t32-70 16-78h-544q-66 0-113-47t-47-113v-1088q0-66 47-113t113-47h1600q66 0 113 47t47 113z"}]}})


/***/ }),
/* 1443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"deviantart":{"width":1024,"height":1792,"paths":[{"d":"M1024 303l-303 582 24 31h279v415h-507l-44 30-142 273-30 30h-301v-303l303-583-24-30h-279v-415h507l44-30 142-273 30-30h301v303z"}]}})


/***/ }),
/* 1444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"diamond":{"width":2048,"height":1792,"paths":[{"d":"M212 768l623 665-300-665h-323zM1024 1540l349-772h-698zM538 640l204-384h-262l-288 384h346zM1213 1433l623-665h-323zM683 640h682l-204-384h-274zM1510 640h346l-288-384h-262zM1651 154l384 512q14 18 13 41.5t-17 40.5l-960 1024q-18 20-47 20t-47-20l-960-1024q-16-17-17-40.5t13-41.5l384-512q18-26 51-26h1152q33 0 51 26z"}]}})


/***/ }),
/* 1445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"digg":{"width":2048,"height":1792,"paths":[{"d":"M328 282h204v983h-532v-697h328v-286zM328 1101v-369h-123v369h123zM614 568v697h205v-697h-205zM614 282v204h205v-204h-205zM901 568h533v942h-533v-163h328v-82h-328v-697zM1229 1101v-369h-123v369h123zM1516 568h532v942h-532v-163h327v-82h-327v-697zM1843 1101v-369h-123v369h123z"}]}})


/***/ }),
/* 1446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"dollar":{"width":1024,"height":1792,"paths":[{"d":"M978 1185q0 153-99.5 263.5t-258.5 136.5v175q0 14-9 23t-23 9h-135q-13 0-22.5-9.5t-9.5-22.5v-175q-66-9-127.5-31t-101.5-44.5-74-48-46.5-37.5-17.5-18q-17-21-2-41l103-135q7-10 23-12 15-2 24 9l2 2q113 99 243 125 37 8 74 8 81 0 142.5-43t61.5-122q0-28-15-53t-33.5-42-58.5-37.5-66-32-80-32.5q-39-16-61.5-25t-61.5-26.5-62.5-31-56.5-35.5-53.5-42.5-43.5-49-35.5-58-21-66.5-8.5-78q0-138 98-242t255-134v-180q0-13 9.5-22.5t22.5-9.5h135q14 0 23 9t9 23v176q57 6 110.5 23t87 33.5 63.5 37.5 39 29 15 14q17 18 5 38l-81 146q-8 15-23 16-14 3-27-7-3-3-14.5-12t-39-26.5-58.5-32-74.5-26-85.5-11.5q-95 0-155 43t-60 111q0 26 8.5 48t29.5 41.5 39.5 33 56 31 60.5 27 70 27.5q53 20 81 31.5t76 35 75.5 42.5 62 50 53 63.5 31.5 76.5 13 94z"}]}})


/***/ }),
/* 1447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"dot-circle-o":{"width":1536,"height":1792,"paths":[{"d":"M1024 896q0 106-75 181t-181 75-181-75-75-181 75-181 181-75 181 75 75 181zM768 352q-148 0-273 73t-198 198-73 273 73 273 198 198 273 73 273-73 198-198 73-273-73-273-198-198-273-73zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"download":{"width":1664,"height":1792,"paths":[{"d":"M1280 1344q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zM1536 1344q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zM1664 1120v320q0 40-28 68t-68 28h-1472q-40 0-68-28t-28-68v-320q0-40 28-68t68-28h465l135 136q58 56 136 56t136-56l136-136h464q40 0 68 28t28 68zM1339 551q17 41-14 70l-448 448q-18 19-45 19t-45-19l-448-448q-31-29-14-70 17-39 59-39h256v-448q0-26 19-45t45-19h256q26 0 45 19t19 45v448h256q42 0 59 39z"}]}})


/***/ }),
/* 1449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"dribbble":{"width":1536,"height":1792,"paths":[{"d":"M1024 1500q-42-241-140-498h-2l-2 1q-16 6-43 16.5t-101 49-137 82-131 114.5-103 148l-15-11q184 150 418 150 132 0 256-52zM839 893q-21-49-53-111-311 93-673 93-1 7-1 21 0 124 44 236.5t124 201.5q50-89 123.5-166.5t142.5-124.5 130.5-81 99.5-48l37-13q4-1 13-3.5t13-4.5zM732 681q-120-213-244-378-138 65-234 186t-128 272q302 0 606-80zM1416 1000q-210-60-409-29 87 239 128 469 111-75 185-189.5t96-250.5zM611 259q-1 0-2 1 1-1 2-1zM1201 404q-185-164-433-164-76 0-155 19 131 170 246 382 69-26 130-60.5t96.5-61.5 65.5-57 37.5-40.5zM1424 889q-3-232-149-410l-1 1q-9 12-19 24.5t-43.5 44.5-71 60.5-100 65-131.5 64.5q25 53 44 95 2 5 6.5 17t7.5 17q36-5 74.5-7t73.5-2 69 1.5 64 4 56.5 5.5 48 6.5 36.5 6 25 4.5zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"drivers-license-o":{"width":2048,"height":1792,"paths":[{"d":"M896 1212q0 55-31.5 93.5t-75.5 38.5h-426q-44 0-75.5-38.5t-31.5-93.5q0-54 7.5-100.5t24.5-90 51-68.5 81-25q64 64 156 64t156-64q47 0 81 25t51 68.5 24.5 90 7.5 100.5zM768 768q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM1792 1184v64q0 14-9 23t-23 9h-704q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h704q14 0 23 9t9 23zM1408 928v64q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h320q14 0 23 9t9 23zM1792 928v64q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h192q14 0 23 9t9 23zM1792 672v64q0 14-9 23t-23 9h-704q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h704q14 0 23 9t9 23zM1920 1504v-1120h-1792v1120q0 13 9.5 22.5t22.5 9.5h1728q13 0 22.5-9.5t9.5-22.5zM2048 288v1216q0 66-47 113t-113 47h-1728q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1728q66 0 113 47t47 113z"}]}})


/***/ }),
/* 1451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"drivers-license":{"width":2048,"height":1792,"paths":[{"d":"M896 1212q0-54-7.5-100.5t-24.5-90-51-68.5-81-25q-64 64-156 64t-156-64q-47 0-81 25t-51 68.5-24.5 90-7.5 100.5q0 55 31.5 93.5t75.5 38.5h426q44 0 75.5-38.5t31.5-93.5zM768 768q0-80-56-136t-136-56-136 56-56 136 56 136 136 56 136-56 56-136zM1792 1248v-64q0-14-9-23t-23-9h-704q-14 0-23 9t-9 23v64q0 14 9 23t23 9h704q14 0 23-9t9-23zM1408 992v-64q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v64q0 14 9 23t23 9h320q14 0 23-9t9-23zM1792 992v-64q0-14-9-23t-23-9h-192q-14 0-23 9t-9 23v64q0 14 9 23t23 9h192q14 0 23-9t9-23zM1792 736v-64q0-14-9-23t-23-9h-704q-14 0-23 9t-9 23v64q0 14 9 23t23 9h704q14 0 23-9t9-23zM128 384h1792v-96q0-14-9-23t-23-9h-1728q-14 0-23 9t-9 23v96zM2048 288v1216q0 66-47 113t-113 47h-1728q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1728q66 0 113 47t47 113z"}]}})


/***/ }),
/* 1452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"dropbox":{"width":1792,"height":1792,"paths":[{"d":"M402 707l494 305-342 285-490-319zM1388 1262v108l-490 293v1l-1-1-1 1v-1l-489-293v-108l147 96 342-284v-2l1 1 1-1v2l343 284zM554 118l342 285-494 304-338-270zM1390 707l338 271-489 319-343-285zM1239 118l489 319-338 270-494-304z"}]}})


/***/ }),
/* 1453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"drupal":{"width":1536,"height":1792,"paths":[{"d":"M1167 1586q-5-19-24-5-30 22-87 39t-131 17q-129 0-193-49-5-4-13-4-11 0-26 12-7 6-7.5 16t7.5 20q34 32 87.5 46t102.5 12.5 99-4.5q41-4 84.5-20.5t65-30 28.5-20.5q12-12 7-29zM1128 1471q-19-47-39-61-23-15-76-15-47 0-71 10-29 12-78 56-26 24-12 44 9 8 17.5 4.5t31.5-23.5q3-2 10.5-8.5t10.5-8.5 10-7 11.5-7 12.5-5 15-4.5 16.5-2.5 20.5-1q27 0 44.5 7.5t23 14.5 13.5 22q10 17 12.5 20t12.5-1q23-12 14-34zM1483 1190q0-22-5-44.5t-16.5-45-34-36.5-52.5-14q-33 0-97 41.5t-129 83.5-101 42q-27 1-63.5-19t-76-49-83.5-58-100-49-111-19q-115 1-197 78.5t-84 178.5q-2 112 74 164 29 20 62.5 28.5t103.5 8.5q57 0 132-32.5t134-71 120-70.5 93-31q26 1 65 31.5t71.5 67 68 67.5 55.5 32q35 3 58.5-14t55.5-63q28-41 42.5-101t14.5-106zM1536 1030q0 164-62 304.5t-166 236-242.5 149.5-290.5 54-293-57.5-247.5-157-170.5-241.5-64-302q0-89 19.5-172.5t49-145.5 70.5-118.5 78.5-94 78.5-69.5 64.5-46.5 42.5-24.5q14-8 51-26.5t54.5-28.5 48-30 60.5-44q36-28 58-72.5t30-125.5q129 155 186 193 44 29 130 68t129 66q21 13 39 25t60.5 46.5 76 70.5 75 95 69 122 47 148.5 19.5 177.5z"}]}})


/***/ }),
/* 1454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"edge":{"width":1792,"height":1792,"paths":[{"d":"M69 795h1q16-126 58.5-241.5t115-217 167.5-176 223.5-117.5 276.5-43q231 0 414 105.5t294 303.5q104 187 104 442v188h-1125q1 111 53.5 192.5t136.5 122.5 189.5 57 213 3 208-46.5 173.5-84.5v377q-92 55-229.5 92t-312.5 38-316-53q-189-73-311.5-249t-124.5-372q-3-242 111-412t325-268q-48 60-78 125.5t-46 159.5h635q8-77-8-140t-47-101.5-70.5-66.5-80.5-41-75-20.5-56-8.5l-22-1q-135 5-259.5 44.5t-223.5 104.5-176 140.5-138 163.5z"}]}})


/***/ }),
/* 1455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"edit":{"width":1792,"height":1792,"paths":[{"d":"M888 1184l116-116-152-152-116 116v56h96v96h56zM1328 464q-16-16-33 1l-350 350q-17 17-1 33t33-1l350-350q17-17 1-33zM1408 1058v190q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q63 0 117 25 15 7 18 23 3 17-9 29l-49 49q-14 14-32 8-23-6-45-6h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113v-126q0-13 9-22l64-64q15-15 35-7t20 29zM1312 320l288 288-672 672h-288v-288zM1756 452l-92 92-288-288 92-92q28-28 68-28t68 28l152 152q28 28 28 68t-28 68z"}]}})


/***/ }),
/* 1456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"eercast":{"width":1792,"height":1792,"paths":[{"d":"M1341 784q29-44-6.5-129.5t-121.5-142.5q-58-39-125.5-53.5t-118-4.5-68.5 37q-12 23-4.5 28t42.5 10q23 3 38.5 5t44.5 9.5 56 17.5q36 13 67.5 31.5t53 37 40 38.5 30.5 38 22 34.5 16.5 28.5 12 18.5 10.5 6 11-9.5zM1704 1358q-52 127-148.5 220t-214.5 141.5-253 60.5-266-13.5-251-91-210-161.5-141.5-235.5-46.5-303.5q1-41 8.5-84.5t12.5-64 24-80.5 23-73q-51 208 1 397t173 318 291 206 346 83 349-74.5 289-244.5q20-27 18-14 0 4-4 14zM1465 909q0 104-40.5 199t-108.5 164-162 109.5-198 40.5-198-40.5-162-109.5-108.5-164-40.5-199 40.5-199 108.5-164 162-109.5 198-40.5 198 40.5 162 109.5 108.5 164 40.5 199zM1752 621q-65-147-180.5-251t-253-153.5-292-53.5-301 36.5-275.5 129-220 211.5-131 297-10 373q-49-161-51.5-311.5t35.5-272.5 109-227 165.5-180.5 207-126 232-71 242.5-9 236 54 216 124.5 178 197q33 50 62 121t31 112zM1690 963q12-244-136.5-416t-396.5-240q-8 0-10-5t24-8q125 4 230 50t173 120 116 168.5 58.5 199-1 208-61.5 197.5-122.5 167-185 117.5-248.5 46.5q108-30 201.5-80t174-123 129.5-176.5 55-225.5z"}]}})


/***/ }),
/* 1457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"eject":{"width":1538,"height":1792,"paths":[{"d":"M14 979l710-710q19-19 45-19t45 19l710 710q19 19 13 32t-32 13h-1472q-26 0-32-13t13-32zM1473 1536h-1408q-26 0-45-19t-19-45v-256q0-26 19-45t45-19h1408q26 0 45 19t19 45v256q0 26-19 45t-45 19z"}]}})


/***/ }),
/* 1458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"ellipsis-h":{"width":1408,"height":1792,"paths":[{"d":"M384 736v192q0 40-28 68t-68 28h-192q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h192q40 0 68 28t28 68zM896 736v192q0 40-28 68t-68 28h-192q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h192q40 0 68 28t28 68zM1408 736v192q0 40-28 68t-68 28h-192q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h192q40 0 68 28t28 68z"}]}})


/***/ }),
/* 1459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"ellipsis-v":{"width":384,"height":1792,"paths":[{"d":"M384 1248v192q0 40-28 68t-68 28h-192q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h192q40 0 68 28t28 68zM384 736v192q0 40-28 68t-68 28h-192q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h192q40 0 68 28t28 68zM384 224v192q0 40-28 68t-68 28h-192q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h192q40 0 68 28t28 68z"}]}})


/***/ }),
/* 1460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"empire":{"width":1792,"height":1792,"paths":[{"d":"M874 1638v66q-208-6-385-109.5t-283-275.5l58-34q29 49 73 99l65-57q148 168 368 212l-17 86q65 12 121 13zM276 1108l-83 28q22 60 49 112l-57 33q-98-180-98-385t98-385l57 33q-30 56-49 112l82 28q-35 100-35 212 0 109 36 212zM1528 1285l58 34q-106 172-283 275.5t-385 109.5v-66q56-1 121-13l-17-86q220-44 368-212l65 57q44-50 73-99zM1377 731l-233 80q14 42 14 85t-14 85l232 80q-31 92-98 169l-185-162q-57 67-147 85l48 241q-52 10-98 10t-98-10l48-241q-90-18-147-85l-185 162q-67-77-98-169l232-80q-14-42-14-85t14-85l-233-80q33-93 99-169l185 162q59-68 147-86l-48-240q44-10 98-10t98 10l-48 240q88 18 147 86l185-162q66 76 99 169zM874 88v66q-65 2-121 13l17 86q-220 42-368 211l-65-56q-38 42-73 98l-57-33q106-172 282-275.5t385-109.5zM1705 896q0 205-98 385l-57-33q27-52 49-112l-83-28q36-103 36-212 0-112-35-212l82-28q-19-56-49-112l57-33q98 180 98 385zM1585 473l-57 33q-35-56-73-98l-65 56q-148-169-368-211l17-86q-56-11-121-13v-66q209 6 385 109.5t282 275.5zM1748 896q0-173-67.5-331t-181.5-272-272-181.5-331-67.5-331 67.5-272 181.5-181.5 272-67.5 331 67.5 331 181.5 272 272 181.5 331 67.5 331-67.5 272-181.5 181.5-272 67.5-331zM1792 896q0 182-71 348t-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71 348 71 286 191 191 286 71 348z"}]}})


/***/ }),
/* 1461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"envelope-o":{"width":1792,"height":1792,"paths":[{"d":"M1664 1504v-768q-32 36-69 66-268 206-426 338-51 43-83 67t-86.5 48.5-102.5 24.5h-1-1q-48 0-102.5-24.5t-86.5-48.5-83-67q-158-132-426-338-37-30-69-66v768q0 13 9.5 22.5t22.5 9.5h1472q13 0 22.5-9.5t9.5-22.5zM1664 453v-11-13.5t-0.5-13-3-12.5-5.5-9-9-7.5-14-2.5h-1472q-13 0-22.5 9.5t-9.5 22.5q0 168 147 284 193 152 401 317 6 5 35 29.5t46 37.5 44.5 31.5 50.5 27.5 43 9h1 1q20 0 43-9t50.5-27.5 44.5-31.5 46-37.5 35-29.5q208-165 401-317 54-43 100.5-115.5t46.5-131.5zM1792 416v1088q0 66-47 113t-113 47h-1472q-66 0-113-47t-47-113v-1088q0-66 47-113t113-47h1472q66 0 113 47t47 113z"}]}})


/***/ }),
/* 1462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"envelope-open-o":{"width":1792,"height":1792,"paths":[{"d":"M1474 913l39 51q8 11 6.5 23.5t-11.5 20.5q-43 34-126.5 98.5t-146.5 113-67 51.5q-39 32-60 48t-60.5 41-76.5 36.5-74 11.5h-1-1q-37 0-74-11.5t-76-36.5-61-41.5-60-47.5q-5-4-65-50.5t-143.5-111-122.5-94.5q-11-8-12.5-20.5t6.5-23.5l37-52q8-11 21.5-13t24.5 7q94 73 306 236 5 4 43.5 35t60.5 46.5 56.5 32.5 58.5 17h1 1q24 0 58.5-17t56.5-32.5 60.5-46.5 43.5-35q258-198 313-242 11-8 24-6.5t21 12.5zM1664 1632v-928q-90-83-159-139-91-74-389-304-3-2-43-35t-61-48-56-32.5-59-17.5h-1-1q-24 0-59 17.5t-56 32.5-61 48-43 35q-215 166-315.5 245.5t-129.5 104-82 74.5q-14 12-21 19v928q0 13 9.5 22.5t22.5 9.5h1472q13 0 22.5-9.5t9.5-22.5zM1792 704v928q0 66-47 113t-113 47h-1472q-66 0-113-47t-47-113v-928q0-56 41-94 123-114 350-290.5t233-181.5q36-30 59-47.5t61.5-42 76-36.5 74.5-12h1 1q37 0 74.5 12t76 36.5 61.5 42 59 47.5q43 36 156 122t226 177 201 173q41 38 41 94z"}]}})


/***/ }),
/* 1463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"envelope-open":{"width":1792,"height":1792,"paths":[{"d":"M1792 654v978q0 66-47 113t-113 47h-1472q-66 0-113-47t-47-113v-978q0-15 11-24 8-7 39-34.5t41.5-36 45.5-37.5 70-55.5 96-73 143.5-107 192.5-140.5q5-4 52.5-40t71.5-52.5 64-35 69-18.5 69 18.5 65 35.5 71 52 52 40q110 80 192.5 140.5t143.5 107 96 73 70 55.5 45.5 37.5 41.5 36 39 34.5q11 9 11 24zM1228 1239q263-191 345-252 11-8 12.5-20.5t-6.5-23.5l-38-52q-8-11-21-12.5t-24 6.5q-231 169-343 250-5 3-52 39t-71.5 52.5-64.5 35-69 18.5-69-18.5-64.5-35-71.5-52.5-52-39q-186-134-343-250-11-8-24-6.5t-21 12.5l-38 52q-8 11-6.5 23.5t12.5 20.5q82 61 345 252 10 8 50 38t65 47 64 39.5 77.5 33.5 75.5 11 75.5-11 79-34.5 64.5-39.5 65-47.5 48-36.5z"}]}})


/***/ }),
/* 1464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"envelope-square":{"width":1536,"height":1792,"paths":[{"d":"M1248 128q119 0 203.5 84.5t84.5 203.5v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960zM1280 1184v-436q-31 35-64 55-34 22-132.5 85t-151.5 99q-98 69-164 69v0 0q-66 0-164-69-47-32-142-92.5t-142-92.5q-12-8-33-27t-31-27v436q0 40 28 68t68 28h832q40 0 68-28t28-68zM1280 611q0-41-27.5-70t-68.5-29h-832q-40 0-68 28t-28 68q0 37 30.5 76.5t67.5 64.5q47 32 137.5 89t129.5 83q3 2 17 11.5t21 14 21 13 23.5 13 21.5 9.5 22.5 7.5 20.5 2.5 20.5-2.5 22.5-7.5 21.5-9.5 23.5-13 21-13 21-14 17-11.5l267-174q35-23 66.5-62.5t31.5-73.5z"}]}})


/***/ }),
/* 1465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"envelope":{"width":1792,"height":1792,"paths":[{"d":"M1792 710v794q0 66-47 113t-113 47h-1472q-66 0-113-47t-47-113v-794q44 49 101 87 362 246 497 345 57 42 92.5 65.5t94.5 48 110 24.5h1 1q51 0 110-24.5t94.5-48 92.5-65.5q170-123 498-345 57-39 100-87zM1792 416q0 79-49 151t-122 123q-376 261-468 325-10 7-42.5 30.5t-54 38-52 32.5-57.5 27-50 9h-1-1q-23 0-50-9t-57.5-27-52-32.5-54-38-42.5-30.5q-91-64-262-182.5t-205-142.5q-62-42-117-115.5t-55-136.5q0-78 41.5-130t118.5-52h1472q65 0 112.5 47t47.5 113z"}]}})


/***/ }),
/* 1466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"envira":{"width":1792,"height":1792,"paths":[{"d":"M896 816q-104-196-160-278-139-202-347-318-34-19-70-36-89-40-94-32t34 38l39 31q62 43 112.5 93.5t94.5 116.5 70.5 113 70.5 131q9 17 13 25 44 84 84 153t98 154 115.5 150 131 123.5 148.5 90.5q153 66 154 60 1-3-49-37-53-36-81-57-77-58-179-211t-185-310zM549 1359q-76-60-132.5-125t-98-143.5-71-154.5-58.5-186-52-209-60.5-252-76.5-289q273 0 497.5 36t379 92 271 144.5 185.5 172.5 110 198.5 56 199.5 12.5 198.5-9.5 173-20 143.5-13 107l323 327h-104l-281-285q-22 2-91.5 14t-121.5 19-138 6-160.5-17-167.5-59-179-111z"}]}})


/***/ }),
/* 1467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"eraser":{"width":1920,"height":1792,"paths":[{"d":"M896 1408l336-384h-768l-336 384h768zM1909 331q15 34 9.5 71.5t-30.5 65.5l-896 1024q-38 44-96 44h-768q-38 0-69.5-20.5t-47.5-54.5q-15-34-9.5-71.5t30.5-65.5l896-1024q38-44 96-44h768q38 0 69.5 20.5t47.5 54.5z"}]}})


/***/ }),
/* 1468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"etsy":{"width":1536,"height":1792,"paths":[{"d":"M518 183v655q103 1 191.5-1.5t125.5-5.5l37-3q68-2 90.5-24.5t39.5-94.5l33-142h103l-14 322 7 319h-103l-29-127q-15-68-45-93t-84-26q-87-8-352-8v556q0 78 43.5 115.5t133.5 37.5h357q35 0 59.5-2t55-7.5 54-18 48.5-32 46-50.5 39-73l93-216h89q-6 37-31.5 252t-30.5 276q-146-5-263.5-8t-162.5-4h-44-628l-376 12v-102l127-25q67-13 91.5-37t25.5-79l8-643q3-402-8-645-2-61-25.5-84t-91.5-36l-127-24v-102l376 12h702q139 0 374-27-6 68-14 194.5t-12 219.5l-5 92h-93l-32-124q-31-121-74-179.5t-113-58.5h-548q-28 0-35.5 8.5t-7.5 30.5z"}]}})


/***/ }),
/* 1469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"eur":{"width":1024,"height":1792,"paths":[{"d":"M976 1307l35 159q3 12-3 22.5t-17 14.5l-5 1q-4 2-10.5 3.5t-16 4.5-21.5 5.5-25.5 5-30 5-33.5 4.5-36.5 3-38.5 1q-234 0-409-130.5t-238-351.5h-95q-13 0-22.5-9.5t-9.5-22.5v-113q0-13 9.5-22.5t22.5-9.5h66q-2-57 1-105h-67q-14 0-23-9t-9-23v-114q0-14 9-23t23-9h98q67-210 243.5-338t400.5-128q102 0 194 23 11 3 20 15 6 11 3 24l-43 159q-3 13-14 19.5t-24 2.5l-4-1q-4-1-11.5-2.5l-17.5-3.5t-22.5-3.5-26-3-29-2.5-29.5-1q-126 0-226 64t-150 176h468q16 0 25 12 10 12 7 26l-24 114q-5 26-32 26h-488q-3 37 0 105h459q15 0 25 12 9 12 6 27l-24 112q-2 11-11 18.5t-20 7.5h-387q48 117 149.5 185.5t228.5 68.5q18 0 36-1.5t33.5-3.5 29.5-4.5 24.5-5 18.5-4.5l12-3 5-2q13-5 26 2 12 7 15 21z"}]}})


/***/ }),
/* 1470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"euro":{"width":1024,"height":1792,"paths":[{"d":"M976 1307l35 159q3 12-3 22.5t-17 14.5l-5 1q-4 2-10.5 3.5t-16 4.5-21.5 5.5-25.5 5-30 5-33.5 4.5-36.5 3-38.5 1q-234 0-409-130.5t-238-351.5h-95q-13 0-22.5-9.5t-9.5-22.5v-113q0-13 9.5-22.5t22.5-9.5h66q-2-57 1-105h-67q-14 0-23-9t-9-23v-114q0-14 9-23t23-9h98q67-210 243.5-338t400.5-128q102 0 194 23 11 3 20 15 6 11 3 24l-43 159q-3 13-14 19.5t-24 2.5l-4-1q-4-1-11.5-2.5l-17.5-3.5t-22.5-3.5-26-3-29-2.5-29.5-1q-126 0-226 64t-150 176h468q16 0 25 12 10 12 7 26l-24 114q-5 26-32 26h-488q-3 37 0 105h459q15 0 25 12 9 12 6 27l-24 112q-2 11-11 18.5t-20 7.5h-387q48 117 149.5 185.5t228.5 68.5q18 0 36-1.5t33.5-3.5 29.5-4.5 24.5-5 18.5-4.5l12-3 5-2q13-5 26 2 12 7 15 21z"}]}})


/***/ }),
/* 1471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"exchange":{"width":1792,"height":1792,"paths":[{"d":"M1792 1184v192q0 13-9.5 22.5t-22.5 9.5h-1376v192q0 13-9.5 22.5t-22.5 9.5q-12 0-24-10l-319-320q-9-9-9-22 0-14 9-23l320-320q9-9 23-9 13 0 22.5 9.5t9.5 22.5v192h1376q13 0 22.5 9.5t9.5 22.5zM1792 640q0 14-9 23l-320 320q-9 9-23 9-13 0-22.5-9.5t-9.5-22.5v-192h-1376q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1376v-192q0-14 9-23t23-9q12 0 24 10l319 319q9 9 9 23z"}]}})


/***/ }),
/* 1472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"exclamation-circle":{"width":1536,"height":1792,"paths":[{"d":"M768 128q209 0 385.5 103t279.5 279.5 103 385.5-103 385.5-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103zM896 1375v-190q0-14-9-23.5t-22-9.5h-192q-13 0-23 10t-10 23v190q0 13 10 23t23 10h192q13 0 22-9.5t9-23.5zM894 1031l18-621q0-12-10-18-10-8-24-8h-220q-14 0-24 8-10 6-10 18l17 621q0 10 10 17.5t24 7.5h185q14 0 23.5-7.5t10.5-17.5z"}]}})


/***/ }),
/* 1473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"exclamation-triangle":{"width":1792,"height":1792,"paths":[{"d":"M1024 1375v-190q0-14-9.5-23.5t-22.5-9.5h-192q-13 0-22.5 9.5t-9.5 23.5v190q0 14 9.5 23.5t22.5 9.5h192q13 0 22.5-9.5t9.5-23.5zM1022 1001l18-459q0-12-10-19-13-11-24-11h-220q-11 0-24 11-10 7-10 21l17 457q0 10 10 16.5t24 6.5h185q14 0 23.5-6.5t10.5-16.5zM1008 67l768 1408q35 63-2 126-17 29-46.5 46t-63.5 17h-1536q-34 0-63.5-17t-46.5-46q-37-63-2-126l768-1408q17-31 47-49t65-18 65 18 47 49z"}]}})


/***/ }),
/* 1474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"exclamation":{"width":640,"height":1792,"paths":[{"d":"M512 1248v224q0 26-19 45t-45 19h-256q-26 0-45-19t-19-45v-224q0-26 19-45t45-19h256q26 0 45 19t19 45zM542 192l-28 768q-1 26-20.5 45t-45.5 19h-256q-26 0-45.5-19t-20.5-45l-28-768q-1-26 17.5-45t44.5-19h320q26 0 44.5 19t17.5 45z"}]}})


/***/ }),
/* 1475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"expand":{"width":1536,"height":1792,"paths":[{"d":"M755 1056q0 13-10 23l-332 332 144 144q19 19 19 45t-19 45-45 19h-448q-26 0-45-19t-19-45v-448q0-26 19-45t45-19 45 19l144 144 332-332q10-10 23-10t23 10l114 114q10 10 10 23zM1536 192v448q0 26-19 45t-45 19-45-19l-144-144-332 332q-10 10-23 10t-23-10l-114-114q-10-10-10-23t10-23l332-332-144-144q-19-19-19-45t19-45 45-19h448q26 0 45 19t19 45z"}]}})


/***/ }),
/* 1476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"expeditedssl":{"width":1792,"height":1792,"paths":[{"d":"M896 64q-169 0-323 66t-265.5 177.5-177.5 265.5-66 323 66 323 177.5 265.5 265.5 177.5 323 66 323-66 265.5-177.5 177.5-265.5 66-323-66-323-177.5-265.5-265.5-177.5-323-66zM896 0q182 0 348 71t286 191 191 286 71 348-71 348-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71zM496 832q16 0 16 16v480q0 16-16 16h-32q-16 0-16-16v-480q0-16 16-16h32zM896 896q53 0 90.5 37.5t37.5 90.5q0 35-17.5 64t-46.5 46v114q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-114q-29-17-46.5-46t-17.5-64q0-53 37.5-90.5t90.5-37.5zM896 128q209 0 385.5 103t279.5 279.5 103 385.5-103 385.5-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103zM544 608v96q0 14 9 23t23 9h64q14 0 23-9t9-23v-96q0-93 65.5-158.5t158.5-65.5 158.5 65.5 65.5 158.5v96q0 14 9 23t23 9h64q14 0 23-9t9-23v-96q0-146-103-249t-249-103-249 103-103 249zM1408 1344v-512q0-26-19-45t-45-19h-896q-26 0-45 19t-19 45v512q0 26 19 45t45 19h896q26 0 45-19t19-45z"}]}})


/***/ }),
/* 1477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"external-link-square":{"width":1536,"height":1792,"paths":[{"d":"M1280 928v-480q0-26-19-45t-45-19h-480q-42 0-59 39-17 41 14 70l144 144-534 534q-19 19-19 45t19 45l102 102q19 19 45 19t45-19l534-534 144 144q18 19 45 19 12 0 25-5 39-17 39-59zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 1478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"external-link":{"width":1792,"height":1792,"paths":[{"d":"M1408 928v320q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h704q14 0 23 9t9 23v64q0 14-9 23t-23 9h-704q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113v-320q0-14 9-23t23-9h64q14 0 23 9t9 23zM1792 64v512q0 26-19 45t-45 19-45-19l-176-176-652 652q-10 10-23 10t-23-10l-114-114q-10-10-10-23t10-23l652-652-176-176q-19-19-19-45t19-45 45-19h512q26 0 45 19t19 45z"}]}})


/***/ }),
/* 1479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"eye-slash":{"width":1792,"height":1792,"paths":[{"d":"M555 1335l78-141q-87-63-136-159t-49-203q0-121 61-225-229 117-381 353 167 258 427 375zM944 576q0-20-14-34t-34-14q-125 0-214.5 89.5t-89.5 214.5q0 20 14 34t34 14 34-14 14-34q0-86 61-147t147-61q20 0 34-14t14-34zM1307 385q0 7-1 9-106 189-316 567t-315 566l-49 89q-10 16-28 16-12 0-134-70-16-10-16-28 0-12 44-87-143-65-263.5-173t-208.5-245q-20-31-20-69t20-69q153-235 380-371t496-136q89 0 180 17l54-97q10-16 28-16 5 0 18 6t31 15.5 33 18.5 31.5 18.5 19.5 11.5q16 10 16 27zM1344 832q0 139-79 253.5t-209 164.5l280-502q8 45 8 84zM1792 960q0 35-20 69-39 64-109 145-150 172-347.5 267t-419.5 95l74-132q212-18 392.5-137t301.5-307q-115-179-282-294l63-112q95 64 182.5 153t144.5 184q20 34 20 69z"}]}})


/***/ }),
/* 1480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"eye":{"width":1792,"height":1792,"paths":[{"d":"M1664 960q-152-236-381-353 61 104 61 225 0 185-131.5 316.5t-316.5 131.5-316.5-131.5-131.5-316.5q0-121 61-225-229 117-381 353 133 205 333.5 326.5t434.5 121.5 434.5-121.5 333.5-326.5zM944 576q0-20-14-34t-34-14q-125 0-214.5 89.5t-89.5 214.5q0 20 14 34t34 14 34-14 14-34q0-86 61-147t147-61q20 0 34-14t14-34zM1792 960q0 34-20 69-140 230-376.5 368.5t-499.5 138.5-499.5-139-376.5-368q-20-35-20-69t20-69q140-229 376.5-368t499.5-139 499.5 139 376.5 368q20 35 20 69z"}]}})


/***/ }),
/* 1481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"eyedropper":{"width":1792,"height":1792,"paths":[{"d":"M1698 94q94 94 94 226.5t-94 225.5l-225 223 104 104q10 10 10 23t-10 23l-210 210q-10 10-23 10t-23-10l-105-105-603 603q-37 37-90 37h-203l-256 128-64-64 128-256v-203q0-53 37-90l603-603-105-105q-10-10-10-23t10-23l210-210q10-10 23-10t23 10l104 104 223-225q93-94 225.5-94t226.5 94zM512 1472l576-576-192-192-576 576v192h192z"}]}})


/***/ }),
/* 1482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"fa":{"width":1536,"height":1792,"paths":[{"d":"M1536 512v839q0 48-49 62-174 52-338 52-73 0-215.5-29.5t-227.5-29.5q-164 0-370 48v338h-160v-1368q-63-25-101-81t-38-124q0-91 64-155t155-64 155 64 64 155q0 68-38 124t-101 81v68q190-44 343-44 99 0 198 15 14 2 111.5 22.5t149.5 20.5q77 0 165-18 11-2 80-21t89-19q26 0 45 19t19 45z"}]}})


/***/ }),
/* 1483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"facebook-f":{"width":1024,"height":1792,"paths":[{"d":"M959 12v264h-157q-86 0-116 36t-30 108v189h293l-39 296h-254v759h-306v-759h-255v-296h255v-218q0-186 104-288.5t277-102.5q147 0 228 12z"}]}})


/***/ }),
/* 1484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"facebook-official":{"width":1536,"height":1792,"paths":[{"d":"M1451 128q35 0 60 25t25 60v1366q0 35-25 60t-60 25h-391v-595h199l30-232h-229v-148q0-56 23.5-84t91.5-28l122-1v-207q-63-9-178-9-136 0-217.5 80t-81.5 226v171h-200v232h200v595h-735q-35 0-60-25t-25-60v-1366q0-35 25-60t60-25h1366z"}]}})


/***/ }),
/* 1485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"facebook-square":{"width":1536,"height":1792,"paths":[{"d":"M1248 128q119 0 203.5 84.5t84.5 203.5v960q0 119-84.5 203.5t-203.5 84.5h-188v-595h199l30-232h-229v-148q0-56 23.5-84t91.5-28l122-1v-207q-63-9-178-9-136 0-217.5 80t-81.5 226v171h-200v232h200v595h-532q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960z"}]}})


/***/ }),
/* 1486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"facebook":{"width":1024,"height":1792,"paths":[{"d":"M959 12v264h-157q-86 0-116 36t-30 108v189h293l-39 296h-254v759h-306v-759h-255v-296h255v-218q0-186 104-288.5t277-102.5q147 0 228 12z"}]}})


/***/ }),
/* 1487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"fast-backward":{"width":1792,"height":1792,"paths":[{"d":"M1747 141q19-19 32-13t13 32v1472q0 26-13 32t-32-13l-710-710q-9-9-13-19v710q0 26-13 32t-32-13l-710-710q-9-9-13-19v678q0 26-19 45t-45 19h-128q-26 0-45-19t-19-45v-1408q0-26 19-45t45-19h128q26 0 45 19t19 45v678q4-10 13-19l710-710q19-19 32-13t13 32v710q4-10 13-19z"}]}})


/***/ }),
/* 1488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"fast-forward":{"width":1792,"height":1792,"paths":[{"d":"M45 1651q-19 19-32 13t-13-32v-1472q0-26 13-32t32 13l710 710q9 9 13 19v-710q0-26 13-32t32 13l710 710q9 9 13 19v-678q0-26 19-45t45-19h128q26 0 45 19t19 45v1408q0 26-19 45t-45 19h-128q-26 0-45-19t-19-45v-678q-4 10-13 19l-710 710q-19 19-32 13t-13-32v-710q-4 10-13 19z"}]}})


/***/ }),
/* 1489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"fax":{"width":1792,"height":1792,"paths":[{"d":"M288 384q66 0 113 47t47 113v1088q0 66-47 113t-113 47h-128q-66 0-113-47t-47-113v-1088q0-66 47-113t113-47h128zM1664 547q58 34 93 93t35 128v768q0 106-75 181t-181 75h-864q-66 0-113-47t-47-113v-1536q0-40 28-68t68-28h672q40 0 88 20t76 48l152 152q28 28 48 76t20 88v163zM928 1536v-128q0-14-9-23t-23-9h-128q-14 0-23 9t-9 23v128q0 14 9 23t23 9h128q14 0 23-9t9-23zM928 1280v-128q0-14-9-23t-23-9h-128q-14 0-23 9t-9 23v128q0 14 9 23t23 9h128q14 0 23-9t9-23zM928 1024v-128q0-14-9-23t-23-9h-128q-14 0-23 9t-9 23v128q0 14 9 23t23 9h128q14 0 23-9t9-23zM1184 1536v-128q0-14-9-23t-23-9h-128q-14 0-23 9t-9 23v128q0 14 9 23t23 9h128q14 0 23-9t9-23zM1184 1280v-128q0-14-9-23t-23-9h-128q-14 0-23 9t-9 23v128q0 14 9 23t23 9h128q14 0 23-9t9-23zM1184 1024v-128q0-14-9-23t-23-9h-128q-14 0-23 9t-9 23v128q0 14 9 23t23 9h128q14 0 23-9t9-23zM1440 1536v-128q0-14-9-23t-23-9h-128q-14 0-23 9t-9 23v128q0 14 9 23t23 9h128q14 0 23-9t9-23zM1440 1280v-128q0-14-9-23t-23-9h-128q-14 0-23 9t-9 23v128q0 14 9 23t23 9h128q14 0 23-9t9-23zM1440 1024v-128q0-14-9-23t-23-9h-128q-14 0-23 9t-9 23v128q0 14 9 23t23 9h128q14 0 23-9t9-23zM1536 640v-256h-160q-40 0-68-28t-28-68v-160h-640v512h896z"}]}})


/***/ }),
/* 1490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"feed":{"width":1408,"height":1792,"paths":[{"d":"M384 1344q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM896 1467q2 28-17 48-18 21-47 21h-135q-25 0-43-16.5t-20-41.5q-22-229-184.5-391.5t-391.5-184.5q-25-2-41.5-20t-16.5-43v-135q0-29 21-47 17-17 43-17h5q160 13 306 80.5t259 181.5q114 113 181.5 259t80.5 306zM1408 1469q2 27-18 47-18 20-46 20h-143q-26 0-44.5-17.5t-19.5-42.5q-12-215-101-408.5t-231.5-336-336-231.5-408.5-102q-25-1-42.5-19.5t-17.5-43.5v-143q0-28 20-46 18-18 44-18h3q262 13 501.5 120t425.5 294q187 186 294 425.5t120 501.5z"}]}})


/***/ }),
/* 1491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"female":{"width":1280,"height":1792,"paths":[{"d":"M1280 1056q0 40-28 68t-68 28q-51 0-80-43l-227-341h-45v132l247 411q9 15 9 33 0 26-19 45t-45 19h-192v272q0 46-33 79t-79 33h-160q-46 0-79-33t-33-79v-272h-192q-26 0-45-19t-19-45q0-18 9-33l247-411v-132h-45l-227 341q-29 43-80 43-40 0-68-28t-28-68q0-29 16-53l256-384q73-107 176-107h384q103 0 176 107l256 384q16 24 16 53zM864 256q0 93-65.5 158.5t-158.5 65.5-158.5-65.5-65.5-158.5 65.5-158.5 158.5-65.5 158.5 65.5 65.5 158.5z"}]}})


/***/ }),
/* 1492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"fighter-jet":{"width":1920,"height":1792,"paths":[{"d":"M1920 960q-1 32-288 96l-352 32-224 64h-64l-293 352h69q26 0 45 4.5t19 11.5-19 11.5-45 4.5h-96-160-64v-32h64v-416h-160l-192 224h-96l-32-32v-192h32v-32h128v-8l-192-24v-128l192-24v-8h-128v-32h-32v-192l32-32h96l192 224h160v-416h-64v-32h64 160 96q26 0 45 4.5t19 11.5-19 11.5-45 4.5h-69l293 352h64l224 64 352 32q128 28 200 52t80 34z"}]}})


/***/ }),
/* 1493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"file-archive-o":{"width":1536,"height":1792,"paths":[{"d":"M640 384v-128h-128v128h128zM768 512v-128h-128v128h128zM640 640v-128h-128v128h128zM768 768v-128h-128v128h128zM1468 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zM1024 136v376h376q-10-29-22-41l-313-313q-12-12-41-22zM1408 1664v-1024h-416q-40 0-68-28t-28-68v-416h-128v128h-128v-128h-512v1536h1280zM781 943l107 349q8 27 8 52 0 83-72.5 137.5t-183.5 54.5-183.5-54.5-72.5-137.5q0-25 8-52 21-63 120-396v-128h128v128h79q22 0 39 13t23 34zM640 1408q53 0 90.5-19t37.5-45-37.5-45-90.5-19-90.5 19-37.5 45 37.5 45 90.5 19z"}]}})


/***/ }),
/* 1494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"file-audio-o":{"width":1536,"height":1792,"paths":[{"d":"M1468 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zM1024 136v376h376q-10-29-22-41l-313-313q-12-12-41-22zM1408 1664v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zM620 850q20 8 20 30v544q0 22-20 30-8 2-12 2-12 0-23-9l-166-167h-131q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h131l166-167q16-15 35-7zM1037 1539q31 0 50-24 129-159 129-363t-129-363q-16-21-43-24t-47 14q-21 17-23.5 43.5t14.5 47.5q100 123 100 282t-100 282q-17 21-14.5 47.5t23.5 42.5q18 15 40 15zM826 1391q27 0 47-20 87-93 87-219t-87-219q-18-19-45-20t-46 17-20 44.5 18 46.5q52 57 52 131t-52 131q-19 20-18 46.5t20 44.5q20 17 44 17z"}]}})


/***/ }),
/* 1495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"file-code-o":{"width":1536,"height":1792,"paths":[{"d":"M1468 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zM1024 136v376h376q-10-29-22-41l-313-313q-12-12-41-22zM1408 1664v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zM480 768q8-11 21-12.5t24 6.5l51 38q11 8 12.5 21t-6.5 24l-182 243 182 243q8 11 6.5 24t-12.5 21l-51 38q-11 8-24 6.5t-21-12.5l-226-301q-14-19 0-38zM1282 1069q14 19 0 38l-226 301q-8 11-21 12.5t-24-6.5l-51-38q-11-8-12.5-21t6.5-24l182-243-182-243q-8-11-6.5-24t12.5-21l51-38q11-8 24-6.5t21 12.5zM662 1530q-13-2-20.5-13t-5.5-24l138-831q2-13 13-20.5t24-5.5l63 10q13 2 20.5 13t5.5 24l-138 831q-2 13-13 20.5t-24 5.5z"}]}})


/***/ }),
/* 1496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"file-excel-o":{"width":1536,"height":1792,"paths":[{"d":"M1468 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zM1024 136v376h376q-10-29-22-41l-313-313q-12-12-41-22zM1408 1664v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zM429 1430v106h281v-106h-75l103-161q5-7 10-16.5t7.5-13.5 3.5-4h2q1 4 5 10 2 4 4.5 7.5t6 8 6.5 8.5l107 161h-76v106h291v-106h-68l-192-273 195-282h67v-107h-279v107h74l-103 159q-4 7-10 16.5t-9 13.5l-2 3h-2q-1-4-5-10-6-11-17-23l-106-159h76v-107h-290v107h68l189 272-194 283h-68z"}]}})


/***/ }),
/* 1497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"file-image-o":{"width":1536,"height":1792,"paths":[{"d":"M1468 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zM1024 136v376h376q-10-29-22-41l-313-313q-12-12-41-22zM1408 1664v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zM1280 1216v320h-1024v-192l192-192 128 128 384-384zM448 1024q-80 0-136-56t-56-136 56-136 136-56 136 56 56 136-56 136-136 56z"}]}})


/***/ }),
/* 1498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"file-movie-o":{"width":1536,"height":1792,"paths":[{"d":"M1468 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zM1024 136v376h376q-10-29-22-41l-313-313q-12-12-41-22zM1408 1664v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zM768 768q52 0 90 38t38 90v384q0 52-38 90t-90 38h-384q-52 0-90-38t-38-90v-384q0-52 38-90t90-38h384zM1260 770q20 8 20 30v576q0 22-20 30-8 2-12 2-14 0-23-9l-265-266v-90l265-266q9-9 23-9 4 0 12 2z"}]}})


/***/ }),
/* 1499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"file-o":{"width":1536,"height":1792,"paths":[{"d":"M1468 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zM1024 136v376h376q-10-29-22-41l-313-313q-12-12-41-22zM1408 1664v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280z"}]}})


/***/ }),
/* 1500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"file-pdf-o":{"width":1536,"height":1792,"paths":[{"d":"M1468 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zM1024 136v376h376q-10-29-22-41l-313-313q-12-12-41-22zM1408 1664v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zM894 1071q33 26 84 56 59-7 117-7 147 0 177 49 16 22 2 52 0 1-1 2l-2 2v1q-6 38-71 38-48 0-115-20t-130-53q-221 24-392 83-153 262-242 262-15 0-28-7l-24-12q-1-1-6-5-10-10-6-36 9-40 56-91.5t132-96.5q14-9 23 6 2 2 2 4 52-85 107-197 68-136 104-262-24-82-30.5-159.5t6.5-127.5q11-40 42-40h21 1q23 0 35 15 18 21 9 68-2 6-4 8 1 3 1 8v30q-2 123-14 192 55 164 146 238zM318 1482q52-24 137-158-51 40-87.5 84t-49.5 74zM716 562q-15 42-2 132 1-7 7-44 0-3 7-43 1-4 4-8-1-1-1-2-1-2-1-3-1-22-13-36 0 1-1 2v2zM592 1223q135-54 284-81-2-1-13-9.5t-16-13.5q-76-67-127-176-27 86-83 197-30 56-45 83zM1238 1207q-24-24-140-24 76 28 124 28 14 0 18-1 0-1-2-3z"}]}})


/***/ }),
/* 1501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"file-photo-o":{"width":1536,"height":1792,"paths":[{"d":"M1468 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zM1024 136v376h376q-10-29-22-41l-313-313q-12-12-41-22zM1408 1664v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zM1280 1216v320h-1024v-192l192-192 128 128 384-384zM448 1024q-80 0-136-56t-56-136 56-136 136-56 136 56 56 136-56 136-136 56z"}]}})


/***/ }),
/* 1502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"file-picture-o":{"width":1536,"height":1792,"paths":[{"d":"M1468 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zM1024 136v376h376q-10-29-22-41l-313-313q-12-12-41-22zM1408 1664v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zM1280 1216v320h-1024v-192l192-192 128 128 384-384zM448 1024q-80 0-136-56t-56-136 56-136 136-56 136 56 56 136-56 136-136 56z"}]}})


/***/ }),
/* 1503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"file-powerpoint-o":{"width":1536,"height":1792,"paths":[{"d":"M1468 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zM1024 136v376h376q-10-29-22-41l-313-313q-12-12-41-22zM1408 1664v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zM416 1430v106h327v-106h-93v-167h137q76 0 118-15 67-23 106.5-87t39.5-146q0-81-37-141t-100-87q-48-19-130-19h-368v107h92v555h-92zM769 1150h-119v-268h120q52 0 83 18 56 33 56 115 0 89-62 120-31 15-78 15z"}]}})


/***/ }),
/* 1504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"file-sound-o":{"width":1536,"height":1792,"paths":[{"d":"M1468 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zM1024 136v376h376q-10-29-22-41l-313-313q-12-12-41-22zM1408 1664v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zM620 850q20 8 20 30v544q0 22-20 30-8 2-12 2-12 0-23-9l-166-167h-131q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h131l166-167q16-15 35-7zM1037 1539q31 0 50-24 129-159 129-363t-129-363q-16-21-43-24t-47 14q-21 17-23.5 43.5t14.5 47.5q100 123 100 282t-100 282q-17 21-14.5 47.5t23.5 42.5q18 15 40 15zM826 1391q27 0 47-20 87-93 87-219t-87-219q-18-19-45-20t-46 17-20 44.5 18 46.5q52 57 52 131t-52 131q-19 20-18 46.5t20 44.5q20 17 44 17z"}]}})


/***/ }),
/* 1505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"file-text-o":{"width":1536,"height":1792,"paths":[{"d":"M1468 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zM1024 136v376h376q-10-29-22-41l-313-313q-12-12-41-22zM1408 1664v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zM384 800q0-14 9-23t23-9h704q14 0 23 9t9 23v64q0 14-9 23t-23 9h-704q-14 0-23-9t-9-23v-64zM1120 1024q14 0 23 9t9 23v64q0 14-9 23t-23 9h-704q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h704zM1120 1280q14 0 23 9t9 23v64q0 14-9 23t-23 9h-704q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h704z"}]}})


/***/ }),
/* 1506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"file-text":{"width":1536,"height":1792,"paths":[{"d":"M1468 476q14 14 28 36h-472v-472q22 14 36 28zM992 640h544v1056q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h800v544q0 40 28 68t68 28zM1152 1376v-64q0-14-9-23t-23-9h-704q-14 0-23 9t-9 23v64q0 14 9 23t23 9h704q14 0 23-9t9-23zM1152 1120v-64q0-14-9-23t-23-9h-704q-14 0-23 9t-9 23v64q0 14 9 23t23 9h704q14 0 23-9t9-23zM1152 864v-64q0-14-9-23t-23-9h-704q-14 0-23 9t-9 23v64q0 14 9 23t23 9h704q14 0 23-9t9-23z"}]}})


/***/ }),
/* 1507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"file-video-o":{"width":1536,"height":1792,"paths":[{"d":"M1468 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zM1024 136v376h376q-10-29-22-41l-313-313q-12-12-41-22zM1408 1664v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zM768 768q52 0 90 38t38 90v384q0 52-38 90t-90 38h-384q-52 0-90-38t-38-90v-384q0-52 38-90t90-38h384zM1260 770q20 8 20 30v576q0 22-20 30-8 2-12 2-14 0-23-9l-265-266v-90l265-266q9-9 23-9 4 0 12 2z"}]}})


/***/ }),
/* 1508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"file-word-o":{"width":1536,"height":1792,"paths":[{"d":"M1468 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zM1024 136v376h376q-10-29-22-41l-313-313q-12-12-41-22zM1408 1664v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zM233 768v107h70l164 661h159l128-485q7-20 10-46 2-16 2-24h4l3 24q1 3 3.5 20t5.5 26l128 485h159l164-661h70v-107h-300v107h90l-99 438q-5 20-7 46l-2 21h-4q0-3-0.5-6.5t-1.5-8-1-6.5q-1-5-4-21t-5-25l-144-545h-114l-144 545q-2 9-4.5 24.5t-3.5 21.5l-4 21h-4l-2-21q-2-26-7-46l-99-438h90v-107h-300z"}]}})


/***/ }),
/* 1509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"file-zip-o":{"width":1536,"height":1792,"paths":[{"d":"M640 384v-128h-128v128h128zM768 512v-128h-128v128h128zM640 640v-128h-128v128h128zM768 768v-128h-128v128h128zM1468 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zM1024 136v376h376q-10-29-22-41l-313-313q-12-12-41-22zM1408 1664v-1024h-416q-40 0-68-28t-28-68v-416h-128v128h-128v-128h-512v1536h1280zM781 943l107 349q8 27 8 52 0 83-72.5 137.5t-183.5 54.5-183.5-54.5-72.5-137.5q0-25 8-52 21-63 120-396v-128h128v128h79q22 0 39 13t23 34zM640 1408q53 0 90.5-19t37.5-45-37.5-45-90.5-19-90.5 19-37.5 45 37.5 45 90.5 19z"}]}})


/***/ }),
/* 1510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"file":{"width":1536,"height":1792,"paths":[{"d":"M1024 512v-472q22 14 36 28l408 408q14 14 28 36h-472zM896 544q0 40 28 68t68 28h544v1056q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h800v544z"}]}})


/***/ }),
/* 1511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"files-o":{"width":1792,"height":1792,"paths":[{"d":"M1696 384q40 0 68 28t28 68v1216q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-288h-544q-40 0-68-28t-28-68v-672q0-40 20-88t48-76l408-408q28-28 76-48t88-20h416q40 0 68 28t28 68v328q68-40 128-40h416zM1152 597l-299 299h299v-299zM512 213l-299 299h299v-299zM708 860l316-316v-416h-384v416q0 40-28 68t-68 28h-416v640h512v-256q0-40 20-88t48-76zM1664 1664v-1152h-384v416q0 40-28 68t-68 28h-416v640h896z"}]}})


/***/ }),
/* 1512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"film":{"width":1920,"height":1792,"paths":[{"d":"M384 1600v-128q0-26-19-45t-45-19h-128q-26 0-45 19t-19 45v128q0 26 19 45t45 19h128q26 0 45-19t19-45zM384 1216v-128q0-26-19-45t-45-19h-128q-26 0-45 19t-19 45v128q0 26 19 45t45 19h128q26 0 45-19t19-45zM384 832v-128q0-26-19-45t-45-19h-128q-26 0-45 19t-19 45v128q0 26 19 45t45 19h128q26 0 45-19t19-45zM1408 1600v-512q0-26-19-45t-45-19h-768q-26 0-45 19t-19 45v512q0 26 19 45t45 19h768q26 0 45-19t19-45zM384 448v-128q0-26-19-45t-45-19h-128q-26 0-45 19t-19 45v128q0 26 19 45t45 19h128q26 0 45-19t19-45zM1792 1600v-128q0-26-19-45t-45-19h-128q-26 0-45 19t-19 45v128q0 26 19 45t45 19h128q26 0 45-19t19-45zM1408 832v-512q0-26-19-45t-45-19h-768q-26 0-45 19t-19 45v512q0 26 19 45t45 19h768q26 0 45-19t19-45zM1792 1216v-128q0-26-19-45t-45-19h-128q-26 0-45 19t-19 45v128q0 26 19 45t45 19h128q26 0 45-19t19-45zM1792 832v-128q0-26-19-45t-45-19h-128q-26 0-45 19t-19 45v128q0 26 19 45t45 19h128q26 0 45-19t19-45zM1792 448v-128q0-26-19-45t-45-19h-128q-26 0-45 19t-19 45v128q0 26 19 45t45 19h128q26 0 45-19t19-45zM1920 288v1344q0 66-47 113t-113 47h-1600q-66 0-113-47t-47-113v-1344q0-66 47-113t113-47h1600q66 0 113 47t47 113z"}]}})


/***/ }),
/* 1513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"filter":{"width":1408,"height":1792,"paths":[{"d":"M1403 295q17 41-14 70l-493 493v742q0 42-39 59-13 5-25 5-27 0-45-19l-256-256q-19-19-19-45v-486l-493-493q-31-29-14-70 17-39 59-39h1280q42 0 59 39z"}]}})


/***/ }),
/* 1514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"fire-extinguisher":{"width":1408,"height":1792,"paths":[{"d":"M512 192q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zM1408 160v320q0 16-12 25-8 7-20 7-4 0-7-1l-448-96q-11-2-18-11t-7-20h-256v102q111 23 183.5 111t72.5 203v800q0 26-19 45t-45 19h-512q-26 0-45-19t-19-45v-800q0-106 62.5-190.5t161.5-114.5v-111h-32q-59 0-115 23.5t-91.5 53-66 66.5-40.5 53.5-14 24.5q-17 35-57 35-16 0-29-7-23-12-31.5-37t3.5-49q5-10 14.5-26t37.5-53.5 60.5-70 85-67 108.5-52.5q-25-42-25-86 0-66 47-113t113-47 113 47 47 113q0 33-14 64h302q0-11 7-20t18-11l448-96q3-1 7-1 12 0 20 7 12 9 12 25z"}]}})


/***/ }),
/* 1515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"fire":{"width":1408,"height":1792,"paths":[{"d":"M1408 1696v64q0 13-9.5 22.5t-22.5 9.5h-1344q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h1344q13 0 22.5 9.5t9.5 22.5zM1152 640q0 78-24.5 144t-64 112.5-87.5 88-96 77.5-87.5 72-64 81.5-24.5 96.5q0 96 67 224l-4-1 1 1q-90-41-160-83t-138.5-100-113.5-122.5-72.5-150.5-27.5-184q0-78 24.5-144t64-112.5 87.5-88 96-77.5 87.5-72 64-81.5 24.5-96.5q0-94-66-224l3 1-1-1q90 41 160 83t138.5 100 113.5 122.5 72.5 150.5 27.5 184z"}]}})


/***/ }),
/* 1516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"firefox":{"width":1792,"height":1792,"paths":[{"d":"M903 1792q-283 0-504.5-150.5t-329.5-398.5q-58-131-67-301t26-332.5 111-312 179-242.5l-11 281q11-14 68-15.5t70 15.5q42-81 160.5-138t234.5-59q-54 45-119.5 148.5t-58.5 163.5q25 8 62.5 13.5t63 7.5 68 4 50.5 3q15 5 9.5 45.5t-30.5 75.5q-5 7-16.5 18.5t-56.5 35.5-101 34l15 189-139-67q-18 43-7.5 81.5t36 66.5 65.5 41.5 81 6.5q51-9 98-34.5t83.5-45 73.5-17.5q61 4 89.5 33t19.5 65q-1 2-2.5 5.5t-8.5 12.5-18 15.5-31.5 10.5-46.5 1q-60 95-144.5 135.5t-209.5 29.5q74 61 162.5 82.5t168.5 6 154.5-52 128-87.5 80.5-104q43-91 39-192.5t-37.5-188.5-78.5-125q87 38 137 79.5t77 112.5q15-170-57.5-343t-209.5-284q265 77 412 279.5t151 517.5q2 127-40.5 255t-123.5 238-189 196-247.5 135.5-288.5 49.5z"}]}})


/***/ }),
/* 1517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"first-order":{"width":1536,"height":1792,"paths":[{"d":"M1322 896q0 45-5 76l-236-14 224 78q-19 73-58 141l-214-103 177 158q-44 61-107 108l-157-178 103 215q-61 37-140 59l-79-228 14 240q-38 6-76 6t-76-6l14-238-78 226q-74-19-140-59l103-215-157 178q-59-43-108-108l178-158-214 104q-39-69-58-141l224-79-237 14q-5-42-5-76 0-35 5-77l238 14-225-79q19-73 58-140l214 104-177-159q46-61 107-108l158 178-103-215q67-39 140-58l77 224-13-236q36-6 75-6 38 0 76 6l-14 237 78-225q74 19 140 59l-103 214 158-178q61 47 107 108l-177 159 213-104q37 62 58 141l-224 78 237-14q5 31 5 77zM1352 896q0-160-78.5-295.5t-213-214-292.5-78.5q-119 0-227 46.5t-186.5 125-124.5 187.5-46 229q0 119 46 228t124.5 187.5 186.5 125 227 46.5q158 0 292.5-78.5t213-214 78.5-294.5zM1425 513v766l-657 383-657-383v-766l657-383zM768 1719l708-412v-823l-708-411-708 411v823zM1536 448v896l-768 448-768-448v-896l768-448z"}]}})


/***/ }),
/* 1518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"flag-checkered":{"width":1792,"height":1792,"paths":[{"d":"M832 1000v-192q-181 16-384 117v185q205-96 384-110zM832 582v-197q-172 8-384 126v189q215-111 384-118zM1664 1045v-184q-235 116-384 71v-224q-20-6-39-15-5-3-33-17t-34.5-17-31.5-15-34.5-15.5-32.5-13-36-12.5-35-8.5-39.5-7.5-39.5-4-44-2q-23 0-49 3v222h19q102 0 192.5 29t197.5 82q19 9 39 15v188q42 17 91 17 120 0 293-92zM1664 618v-189q-169 91-306 91-45 0-78-8v196q148 42 384-90zM320 256q0 35-17.5 64t-46.5 46v1266q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-1266q-29-17-46.5-46t-17.5-64q0-53 37.5-90.5t90.5-37.5 90.5 37.5 37.5 90.5zM1792 320v763q0 39-35 57-10 5-17 9-218 116-369 116-88 0-158-35l-28-14q-64-33-99-48t-91-29-114-14q-102 0-235.5 44t-228.5 102q-15 9-33 9-16 0-32-8-32-19-32-56v-742q0-35 31-55 35-21 78.5-42.5t114-52 152.5-49.5 155-19q112 0 209 31t209 86q38 19 89 19 122 0 310-112 22-12 31-17 31-16 62 2 31 20 31 55z"}]}})


/***/ }),
/* 1519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"flag-o":{"width":1792,"height":1792,"paths":[{"d":"M1664 1045v-616q-169 91-306 91-82 0-145-32-100-49-184-76.5t-178-27.5q-173 0-403 127v599q245-113 433-113 55 0 103.5 7.5t98 26 77 31 82.5 39.5l28 14q44 22 101 22 120 0 293-92zM320 256q0 35-17.5 64t-46.5 46v1266q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-1266q-29-17-46.5-46t-17.5-64q0-53 37.5-90.5t90.5-37.5 90.5 37.5 37.5 90.5zM1792 320v763q0 39-35 57-10 5-17 9-218 116-369 116-88 0-158-35l-28-14q-64-33-99-48t-91-29-114-14q-102 0-235.5 44t-228.5 102q-15 9-33 9-16 0-32-8-32-19-32-56v-742q0-35 31-55 35-21 78.5-42.5t114-52 152.5-49.5 155-19q112 0 209 31t209 86q38 19 89 19 122 0 310-112 22-12 31-17 31-16 62 2 31 20 31 55z"}]}})


/***/ }),
/* 1520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"flag":{"width":1792,"height":1792,"paths":[{"d":"M320 256q0 72-64 110v1266q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-1266q-64-38-64-110 0-53 37.5-90.5t90.5-37.5 90.5 37.5 37.5 90.5zM1792 320v763q0 25-12.5 38.5t-39.5 27.5q-215 116-369 116-61 0-123.5-22t-108.5-48-115.5-48-142.5-22q-192 0-464 146-17 9-33 9-26 0-45-19t-19-45v-742q0-32 31-55 21-14 79-43 236-120 421-120 107 0 200 29t219 88q38 19 88 19 54 0 117.5-21t110-47 88-47 54.5-21q26 0 45 19t19 45z"}]}})


/***/ }),
/* 1521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"flash":{"width":896,"height":1792,"paths":[{"d":"M885 566q18 20 7 44l-540 1157q-13 25-42 25-4 0-14-2-17-5-25.5-19t-4.5-30l197-808-406 101q-4 1-12 1-18 0-31-11-18-15-13-39l201-825q4-14 16-23t28-9h328q19 0 32 12.5t13 29.5q0 8-5 18l-171 463 396-98q8-2 12-2 19 0 34 15z"}]}})


/***/ }),
/* 1522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"flask":{"width":1664,"height":1792,"paths":[{"d":"M1527 1448q56 89 21.5 152.5t-140.5 63.5h-1152q-106 0-140.5-63.5t21.5-152.5l503-793v-399h-64q-26 0-45-19t-19-45 19-45 45-19h512q26 0 45 19t19 45-19 45-45 19h-64v399zM748 723l-272 429h712l-272-429-20-31v-37-399h-128v399 37z"}]}})


/***/ }),
/* 1523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"flickr":{"width":1536,"height":1792,"paths":[{"d":"M1248 128q119 0 203.5 84.5t84.5 203.5v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960zM698 896q0-88-62-150t-150-62-150 62-62 150 62 150 150 62 150-62 62-150zM1262 896q0-88-62-150t-150-62-150 62-62 150 62 150 150 62 150-62 62-150z"}]}})


/***/ }),
/* 1524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"floppy-o":{"width":1536,"height":1792,"paths":[{"d":"M384 1536h768v-384h-768v384zM1280 1536h128v-896q0-14-10-38.5t-20-34.5l-281-281q-10-10-34-20t-39-10v416q0 40-28 68t-68 28h-576q-40 0-68-28t-28-68v-416h-128v1280h128v-416q0-40 28-68t68-28h832q40 0 68 28t28 68v416zM896 608v-320q0-13-9.5-22.5t-22.5-9.5h-192q-13 0-22.5 9.5t-9.5 22.5v320q0 13 9.5 22.5t22.5 9.5h192q13 0 22.5-9.5t9.5-22.5zM1536 640v928q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1344q0-40 28-68t68-28h928q40 0 88 20t76 48l280 280q28 28 48 76t20 88z"}]}})


/***/ }),
/* 1525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"folder-o":{"width":1664,"height":1792,"paths":[{"d":"M1536 1312v-704q0-40-28-68t-68-28h-704q-40 0-68-28t-28-68v-64q0-40-28-68t-68-28h-320q-40 0-68 28t-28 68v960q0 40 28 68t68 28h1216q40 0 68-28t28-68zM1664 608v704q0 92-66 158t-158 66h-1216q-92 0-158-66t-66-158v-960q0-92 66-158t158-66h320q92 0 158 66t66 158v32h672q92 0 158 66t66 158z"}]}})


/***/ }),
/* 1526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"folder-open-o":{"width":1920,"height":1792,"paths":[{"d":"M1781 931q0-35-53-35h-1088q-40 0-85.5 21.5t-71.5 52.5l-294 363q-18 24-18 40 0 35 53 35h1088q40 0 86-22t71-53l294-363q18-22 18-39zM640 768h768v-160q0-40-28-68t-68-28h-576q-40 0-68-28t-28-68v-64q0-40-28-68t-68-28h-320q-40 0-68 28t-28 68v853l256-315q44-53 116-87.5t140-34.5zM1909 931q0 62-46 120l-295 363q-43 53-116 87.5t-140 34.5h-1088q-92 0-158-66t-66-158v-960q0-92 66-158t158-66h320q92 0 158 66t66 158v32h544q92 0 158 66t66 158v160h192q54 0 99 24.5t67 70.5q15 32 15 68z"}]}})


/***/ }),
/* 1527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"folder-open":{"width":1920,"height":1792,"paths":[{"d":"M1879 952q0 31-31 66l-336 396q-43 51-120.5 86.5t-143.5 35.5h-1088q-34 0-60.5-13t-26.5-43q0-31 31-66l336-396q43-51 120.5-86.5t143.5-35.5h1088q34 0 60.5 13t26.5 43zM1536 608v160h-832q-94 0-197 47.5t-164 119.5l-337 396-5 6q0-4-0.5-12.5t-0.5-12.5v-960q0-92 66-158t158-66h320q92 0 158 66t66 158v32h544q92 0 158 66t66 158z"}]}})


/***/ }),
/* 1528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"folder":{"width":1664,"height":1792,"paths":[{"d":"M1664 608v704q0 92-66 158t-158 66h-1216q-92 0-158-66t-66-158v-960q0-92 66-158t158-66h320q92 0 158 66t66 158v32h672q92 0 158 66t66 158z"}]}})


/***/ }),
/* 1529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"font-awesome":{"width":1536,"height":1792,"paths":[{"d":"M1536 512v839q0 48-49 62-174 52-338 52-73 0-215.5-29.5t-227.5-29.5q-164 0-370 48v338h-160v-1368q-63-25-101-81t-38-124q0-91 64-155t155-64 155 64 64 155q0 68-38 124t-101 81v68q190-44 343-44 99 0 198 15 14 2 111.5 22.5t149.5 20.5q77 0 165-18 11-2 80-21t89-19q26 0 45 19t19 45z"}]}})


/***/ }),
/* 1530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"font":{"width":1664,"height":1792,"paths":[{"d":"M725 559l-170 450q33 0 136.5 2t160.5 2q19 0 57-2-87-253-184-452zM0 1664l2-79q23-7 56-12.5t57-10.5 49.5-14.5 44.5-29 31-50.5l237-616 280-724h75 53q8 14 11 21l205 480q33 78 106 257.5t114 274.5q15 34 58 144.5t72 168.5q20 45 35 57 19 15 88 29.5t84 20.5q6 38 6 57 0 5-0.5 13.5t-0.5 12.5q-63 0-190-8t-191-8q-76 0-215 7t-178 8q0-43 4-78l131-28q1 0 12.5-2.5t15.5-3.5 14.5-4.5 15-6.5 11-8 9-11 2.5-14q0-16-31-96.5t-72-177.5-42-100l-450-2q-26 58-76.5 195.5t-50.5 162.5q0 22 14 37.5t43.5 24.5 48.5 13.5 57 8.5 41 4q1 19 1 58 0 9-2 27-58 0-174.5-10t-174.5-10q-8 0-26.5 4t-21.5 4q-80 14-188 14z"}]}})


/***/ }),
/* 1531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"fonticons":{"width":1536,"height":1792,"paths":[{"d":"M0 128h1536v1536h-1536v-1536zM908 448l-12 33 75 83-31 114 25 25 107-57 107 57 25-25-31-114 75-83-12-33h-95l-53-96h-32l-53 96h-95zM641 611q32 0 44.5 16t11.5 63l174-21q0-55-17.5-92.5t-50.5-56-69-25.5-85-7q-133 0-199 57.5t-66 182.5v72h-96v128h76q20 0 20 8v382q0 14-5 20t-18 7l-73 7v88h448v-86l-149-14q-6-1-8.5-1.5t-3.5-2.5-0.5-4 1-7 0.5-10v-387h191l38-128h-231q-6 0-2-6t4-9v-80q0-27 1.5-40.5t7.5-28 19.5-20 36.5-5.5zM1248 1440v-86l-54-9q-7-1-9.5-2.5t-2.5-3 1-7.5 1-12v-520h-275l-23 101 83 22q23 7 23 27v370q0 14-6 18.5t-20 6.5l-70 9v86h352z"}]}})


/***/ }),
/* 1532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"fort-awesome":{"width":1792,"height":1792,"paths":[{"d":"M640 1008v-224q0-16-16-16h-96q-16 0-16 16v224q0 16 16 16h96q16 0 16-16zM1152 1008v-224q0-16-16-16h-96q-16 0-16 16v224q0 16 16 16h96q16 0 16-16zM1664 1040v752h-640v-320q0-80-56-136t-136-56-136 56-56 136v320h-640v-752q0-16 16-16h96q16 0 16 16v112h128v-624q0-16 16-16h96q16 0 16 16v112h128v-112q0-16 16-16h96q16 0 16 16v112h128v-112q0-6 2.5-9.5t8.5-5 9.5-2 11.5 0 9 0.5v-391q-32-15-32-50 0-23 16.5-39t38.5-16 38.5 16 16.5 39q0 35-32 50v17q45-10 83-10 21 0 59.5 7.5t54.5 7.5q17 0 47-7.5t37-7.5q16 0 16 16v210q0 15-35 21.5t-62 6.5q-18 0-54.5-7.5t-55.5-7.5q-40 0-90 12v133q1 0 9-0.5t11.5 0 9.5 2 8.5 5 2.5 9.5v112h128v-112q0-16 16-16h96q16 0 16 16v112h128v-112q0-16 16-16h96q16 0 16 16v624h128v-112q0-16 16-16h96q16 0 16 16z"}]}})


/***/ }),
/* 1533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"forumbee":{"width":1536,"height":1792,"paths":[{"d":"M934 150q-317 121-556 362.5t-358 560.5q-20-89-20-176 0-208 102.5-384.5t278.5-279 384-102.5q82 0 169 19zM1203 269q93 65 164 155-389 113-674.5 400.5t-396.5 676.5q-93-72-155-162 112-386 395-671t667-399zM470 1603q115-356 379.5-622t619.5-384q40 92 54 195-292 120-516 345t-343 518q-103-14-194-52zM1536 1661q-193-50-367-115-135 84-290 107 109-205 274-370.5t369-275.5q-21 152-101 284 65 175 115 370z"}]}})


/***/ }),
/* 1534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"forward":{"width":1664,"height":1792,"paths":[{"d":"M45 1651q-19 19-32 13t-13-32v-1472q0-26 13-32t32 13l710 710q9 9 13 19v-710q0-26 13-32t32 13l710 710q19 19 19 45t-19 45l-710 710q-19 19-32 13t-13-32v-710q-4 10-13 19z"}]}})


/***/ }),
/* 1535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"foursquare":{"width":1280,"height":1792,"paths":[{"d":"M1000 434l37-194q5-23-9-40t-35-17h-712q-23 0-38.5 17t-15.5 37v1101q0 7 6 1l291-352q23-26 38-33.5t48-7.5h239q22 0 37-14.5t18-29.5q24-130 37-191 4-21-11.5-40t-36.5-19h-294q-29 0-48-19t-19-48v-42q0-29 19-47.5t48-18.5h346q18 0 35-13.5t20-29.5zM1227 212q-15 73-53.5 266.5t-69.5 350-35 173.5q-6 22-9 32.5t-14 32.5-24.5 33-38.5 21-58 10h-271q-13 0-22 10-8 9-426 494-22 25-58.5 28.5t-48.5-5.5q-55-22-55-98v-1410q0-55 38-102.5t120-47.5h888q95 0 127 53t10 159zM1227 212l-158 790q4-17 35-173.5t69.5-350 53.5-266.5z"}]}})


/***/ }),
/* 1536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"free-code-camp":{"width":2304,"height":1792,"paths":[{"d":"M453 1637q0 21-16 37.5t-37 16.5q-1 0-13-3-63-15-162-140-225-284-225-676 0-341 213-614 39-51 95-103.5t94-52.5q19 0 35 13.5t16 32.5q0 27-63 90-98 102-147 184-119 199-119 449 0 281 123 491 50 85 136 173 2 3 14.5 16t19.5 21 17 20.5 14.5 23.5 4.5 21zM1796 1503q0 29-17.5 48.5t-46.5 19.5h-1081q-26 0-45-19t-19-45q0-29 17.5-48.5t46.5-19.5h1081q26 0 45 19t19 45zM1581 892q0 134-67 233-25 38-69.5 78.5t-83.5 60.5q-16 10-27 10-7 0-15-6t-8-12q0-9 19-30t42-46 42-67.5 19-88.5q0-76-35-130-29-42-46-42-3 0-3 5 0 12 7.5 35.5t7.5 36.5q0 22-21.5 35t-44.5 13q-66 0-66-76 0-15 1.5-44t1.5-44q0-25-10-46-13-25-42-53.5t-51-28.5q-5 0-7 0.5t-3.5 2.5-1.5 6q0 2 16 26t16 54q0 37-19 68t-46 54-53.5 46-45.5 54-19 68q0 98 42 160 29 43 79 63 16 5 17 10 1 2 1 5 0 16-18 16-6 0-33-11-119-43-195-139.5t-76-218.5q0-55 24.5-115.5t60-115 70.5-108.5 59.5-113.5 24.5-111.5q0-53-25-94-29-48-56-64-19-9-19-21 0-20 41-20 50 0 110 29 41 19 71 44.5t49.5 51 33.5 62.5 22 69 16 80q0 1 3 17.5t4.5 25 5.5 25 9 27 11 21.5 14.5 16.5 18.5 5.5q23 0 37-14t14-37q0-25-20-67t-20-52 10-10q27 0 93 70 72 76 102.5 156t30.5 186zM2304 921q0 274-138 503-19 32-48 72t-68 86.5-81 77-74 30.5q-16 0-31-15.5t-15-31.5q0-15 29-50.5t68.5-77 48.5-52.5q183-230 183-531 0-131-20.5-235t-72.5-211q-58-119-163-228-2-3-13-13.5t-16.5-16.5-15-17.5-15-20-9.5-18.5-4-19q0-19 16-35.5t35-16.5q70 0 196 169 98 131 146 273t60 314q2 42 2 64z"}]}})


/***/ }),
/* 1537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"frown-o":{"width":1536,"height":1792,"paths":[{"d":"M1134 1229q8 25-4 48.5t-37 31.5-49-4-32-38q-25-80-92.5-129.5t-151.5-49.5-151.5 49.5-92.5 129.5q-8 26-31.5 38t-48.5 4q-26-8-38-31.5t-4-48.5q37-121 138-195t228-74 228 74 138 195zM640 640q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zM1152 640q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zM1408 896q0-130-51-248.5t-136.5-204-204-136.5-248.5-51-248.5 51-204 136.5-136.5 204-51 248.5 51 248.5 136.5 204 204 136.5 248.5 51 248.5-51 204-136.5 136.5-204 51-248.5zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"futbol-o":{"width":1792,"height":1792,"paths":[{"d":"M609 816l287-208 287 208-109 336h-355zM896 0q182 0 348 71t286 191 191 286 71 348-71 348-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71zM1515 1350q149-203 149-454v-3l-102 89-240-224 63-323 134 12q-150-206-389-282l53 124-287 159-287-159 53-124q-239 76-389 282l135-12 62 323-240 224-102-89v3q0 251 149 454l30-132 326 40 139 298-116 69q117 39 240 39t240-39l-116-69 139-298 326-40z"}]}})


/***/ }),
/* 1539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"gamepad":{"width":1920,"height":1792,"paths":[{"d":"M832 1088v-128q0-14-9-23t-23-9h-192v-192q0-14-9-23t-23-9h-128q-14 0-23 9t-9 23v192h-192q-14 0-23 9t-9 23v128q0 14 9 23t23 9h192v192q0 14 9 23t23 9h128q14 0 23-9t9-23v-192h192q14 0 23-9t9-23zM1408 1152q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1664 896q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1920 1024q0 212-150 362t-362 150q-192 0-338-128h-220q-146 128-338 128-212 0-362-150t-150-362 150-362 362-150h896q212 0 362 150t150 362z"}]}})


/***/ }),
/* 1540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"gavel":{"width":1792,"height":1792,"paths":[{"d":"M1771 1536q0 53-37 90l-107 108q-39 37-91 37-53 0-90-37l-363-364q-38-36-38-90 0-53 43-96l-256-256-126 126q-14 14-34 14t-34-14q2 2 12.5 12t12.5 13 10 11.5 10 13.5 6 13.5 5.5 16.5 1.5 18q0 38-28 68-3 3-16.5 18t-19 20.5-18.5 16.5-22 15.5-22 9-26 4.5q-40 0-68-28l-408-408q-28-28-28-68 0-13 4.5-26t9-22 15.5-22 16.5-18.5 20.5-19 18-16.5q30-28 68-28 10 0 18 1.5t16.5 5.5 13.5 6 13.5 10 11.5 10 13 12.5 12 12.5q-14-14-14-34t14-34l348-348q14-14 34-14t34 14q-2-2-12.5-12t-12.5-13-10-11.5-10-13.5-6-13.5-5.5-16.5-1.5-18q0-38 28-68 3-3 16.5-18t19-20.5 18.5-16.5 22-15.5 22-9 26-4.5q40 0 68 28l408 408q28 28 28 68 0 13-4.5 26t-9 22-15.5 22-16.5 18.5-20.5 19-18 16.5q-30 28-68 28-10 0-18-1.5t-16.5-5.5-13.5-6-13.5-10-11.5-10-13-12.5-12-12.5q14 14 14 34t-14 34l-126 126 256 256q43-43 96-43 52 0 91 37l363 363q37 39 37 91z"}]}})


/***/ }),
/* 1541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"gbp":{"width":1024,"height":1792,"paths":[{"d":"M1020 1137v367q0 14-9 23t-23 9h-956q-14 0-23-9t-9-23v-150q0-13 9.5-22.5t22.5-9.5h97v-383h-95q-14 0-23-9.5t-9-22.5v-131q0-14 9-23t23-9h95v-223q0-171 123.5-282t314.5-111q185 0 335 125 9 8 10 20.5t-7 22.5l-103 127q-9 11-22 12-13 2-23-7-5-5-26-19t-69-32-93-18q-85 0-137 47t-52 123v215h305q13 0 22.5 9t9.5 23v131q0 13-9.5 22.5t-22.5 9.5h-305v379h414v-181q0-13 9-22.5t23-9.5h162q14 0 23 9.5t9 22.5z"}]}})


/***/ }),
/* 1542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"ge":{"width":1792,"height":1792,"paths":[{"d":"M874 1638v66q-208-6-385-109.5t-283-275.5l58-34q29 49 73 99l65-57q148 168 368 212l-17 86q65 12 121 13zM276 1108l-83 28q22 60 49 112l-57 33q-98-180-98-385t98-385l57 33q-30 56-49 112l82 28q-35 100-35 212 0 109 36 212zM1528 1285l58 34q-106 172-283 275.5t-385 109.5v-66q56-1 121-13l-17-86q220-44 368-212l65 57q44-50 73-99zM1377 731l-233 80q14 42 14 85t-14 85l232 80q-31 92-98 169l-185-162q-57 67-147 85l48 241q-52 10-98 10t-98-10l48-241q-90-18-147-85l-185 162q-67-77-98-169l232-80q-14-42-14-85t14-85l-233-80q33-93 99-169l185 162q59-68 147-86l-48-240q44-10 98-10t98 10l-48 240q88 18 147 86l185-162q66 76 99 169zM874 88v66q-65 2-121 13l17 86q-220 42-368 211l-65-56q-38 42-73 98l-57-33q106-172 282-275.5t385-109.5zM1705 896q0 205-98 385l-57-33q27-52 49-112l-83-28q36-103 36-212 0-112-35-212l82-28q-19-56-49-112l57-33q98 180 98 385zM1585 473l-57 33q-35-56-73-98l-65 56q-148-169-368-211l17-86q-56-11-121-13v-66q209 6 385 109.5t282 275.5zM1748 896q0-173-67.5-331t-181.5-272-272-181.5-331-67.5-331 67.5-272 181.5-181.5 272-67.5 331 67.5 331 181.5 272 272 181.5 331 67.5 331-67.5 272-181.5 181.5-272 67.5-331zM1792 896q0 182-71 348t-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71 348 71 286 191 191 286 71 348z"}]}})


/***/ }),
/* 1543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"gear":{"width":1536,"height":1792,"paths":[{"d":"M1024 896q0-106-75-181t-181-75-181 75-75 181 75 181 181 75 181-75 75-181zM1536 787v222q0 12-8 23t-20 13l-185 28q-19 54-39 91 35 50 107 138 10 12 10 25t-9 23q-27 37-99 108t-94 71q-12 0-26-9l-138-108q-44 23-91 38-16 136-29 186-7 28-36 28h-222q-14 0-24.5-8.5t-11.5-21.5l-28-184q-49-16-90-37l-141 107q-10 9-25 9-14 0-25-11-126-114-165-168-7-10-7-23 0-12 8-23 15-21 51-66.5t54-70.5q-27-50-41-99l-183-27q-13-2-21-12.5t-8-23.5v-222q0-12 8-23t19-13l186-28q14-46 39-92-40-57-107-138-10-12-10-24 0-10 9-23 26-36 98.5-107.5t94.5-71.5q13 0 26 10l138 107q44-23 91-38 16-136 29-186 7-28 36-28h222q14 0 24.5 8.5t11.5 21.5l28 184q49 16 90 37l142-107q9-9 24-9 13 0 25 10 129 119 165 170 7 8 7 22 0 12-8 23-15 21-51 66.5t-54 70.5q26 50 41 98l183 28q13 2 21 12.5t8 23.5z"}]}})


/***/ }),
/* 1544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"gears":{"width":1920,"height":1792,"paths":[{"d":"M896 896q0-106-75-181t-181-75-181 75-75 181 75 181 181 75 181-75 75-181zM1664 1408q0-52-38-90t-90-38-90 38-38 90q0 53 37.5 90.5t90.5 37.5 90.5-37.5 37.5-90.5zM1664 384q0-52-38-90t-90-38-90 38-38 90q0 53 37.5 90.5t90.5 37.5 90.5-37.5 37.5-90.5zM1280 805v185q0 10-7 19.5t-16 10.5l-155 24q-11 35-32 76 34 48 90 115 7 11 7 20 0 12-7 19-23 30-82.5 89.5t-78.5 59.5q-11 0-21-7l-115-90q-37 19-77 31-11 108-23 155-7 24-30 24h-186q-11 0-20-7.5t-10-17.5l-23-153q-34-10-75-31l-118 89q-7 7-20 7-11 0-21-8-144-133-144-160 0-9 7-19 10-14 41-53t47-61q-23-44-35-82l-152-24q-10-1-17-9.5t-7-19.5v-185q0-10 7-19.5t16-10.5l155-24q11-35 32-76-34-48-90-115-7-11-7-20 0-12 7-20 22-30 82-89t79-59q11 0 21 7l115 90q34-18 77-32 11-108 23-154 7-24 30-24h186q11 0 20 7.5t10 17.5l23 153q34 10 75 31l118-89q8-7 20-7 11 0 21 8 144 133 144 160 0 8-7 19-12 16-42 54t-45 60q23 48 34 82l152 23q10 2 17 10.5t7 19.5zM1920 1338v140q0 16-149 31-12 27-30 52 51 113 51 138 0 4-4 7-122 71-124 71-8 0-46-47t-52-68q-20 2-30 2t-30-2q-14 21-52 68t-46 47q-2 0-124-71-4-3-4-7 0-25 51-138-18-25-30-52-149-15-149-31v-140q0-16 149-31 13-29 30-52-51-113-51-138 0-4 4-7 4-2 35-20t59-34 30-16q8 0 46 46.5t52 67.5q20-2 30-2t30 2q51-71 92-112l6-2q4 0 124 70 4 3 4 7 0 25-51 138 17 23 30 52 149 15 149 31zM1920 314v140q0 16-149 31-12 27-30 52 51 113 51 138 0 4-4 7-122 71-124 71-8 0-46-47t-52-68q-20 2-30 2t-30-2q-14 21-52 68t-46 47q-2 0-124-71-4-3-4-7 0-25 51-138-18-25-30-52-149-15-149-31v-140q0-16 149-31 13-29 30-52-51-113-51-138 0-4 4-7 4-2 35-20t59-34 30-16q8 0 46 46.5t52 67.5q20-2 30-2t30 2q51-71 92-112l6-2q4 0 124 70 4 3 4 7 0 25-51 138 17 23 30 52 149 15 149 31z"}]}})


/***/ }),
/* 1545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"genderless":{"width":1280,"height":1792,"paths":[{"d":"M1024 960q0-185-131.5-316.5t-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5 316.5-131.5 131.5-316.5zM1152 960q0 117-45.5 223.5t-123 184-184 123-223.5 45.5-223.5-45.5-184-123-123-184-45.5-223.5 45.5-223.5 123-184 184-123 223.5-45.5 223.5 45.5 184 123 123 184 45.5 223.5z"}]}})


/***/ }),
/* 1546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"get-pocket":{"width":1720,"height":1792,"paths":[{"d":"M1565 128q65 0 110 45.5t45 110.5v519q0 176-68 336t-182.5 275-274 182.5-334.5 67.5q-176 0-335.5-67.5t-274.5-182.5-183-275-68-336v-519q0-64 46-110t110-46h1409zM861 1192q47 0 82-33l404-388q37-35 37-85 0-49-34.5-83.5t-83.5-34.5q-47 0-82 33l-323 310-323-310q-35-33-81-33-49 0-83.5 34.5t-34.5 83.5q0 51 36 85l405 388q33 33 81 33z"}]}})


/***/ }),
/* 1547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"gg-circle":{"width":1792,"height":1792,"paths":[{"d":"M717 1354l271-271-279-279-88 88 192 191-96 96-279-279 279-279 40 40 87-87-127-128-454 454zM1075 1346l454-454-454-454-271 271 279 279 88-88-192-191 96-96 279 279-279 279-40-40-87 88zM1792 896q0 182-71 348t-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71 348 71 286 191 191 286 71 348z"}]}})


/***/ }),
/* 1548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"gg":{"width":2048,"height":1792,"paths":[{"d":"M736 800l384 384-384 384-672-672 672-672 168 168-96 96-72-72-480 480 480 480 193-193-289-287zM1312 224l672 672-672 672-168-168 96-96 72 72 480-480-480-480-193 193 289 287-96 96-384-384z"}]}})


/***/ }),
/* 1549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"gift":{"width":1536,"height":1792,"paths":[{"d":"M928 1356v-56-468-192h-320v192 468 56q0 25 18 38.5t46 13.5h192q28 0 46-13.5t18-38.5zM472 512h195l-126-161q-26-31-69-31-40 0-68 28t-28 68 28 68 68 28zM1160 416q0-40-28-68t-68-28q-43 0-69 31l-125 161h194q40 0 68-28t28-68zM1536 672v320q0 14-9 23t-23 9h-96v416q0 40-28 68t-68 28h-1088q-40 0-68-28t-28-68v-416h-96q-14 0-23-9t-9-23v-320q0-14 9-23t23-9h440q-93 0-158.5-65.5t-65.5-158.5 65.5-158.5 158.5-65.5q107 0 168 77l128 165 128-165q61-77 168-77 93 0 158.5 65.5t65.5 158.5-65.5 158.5-158.5 65.5h440q14 0 23 9t9 23z"}]}})


/***/ }),
/* 1550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"git-square":{"width":1536,"height":1792,"paths":[{"d":"M582 1308q0 66-93 66-107 0-107-63 0-64 98-64 102 0 102 61zM546 842q0 85-74 85-77 0-77-84 0-90 77-90 36 0 55 25.5t19 63.5zM712 767v-125q-78 29-135 29-50-29-110-29-86 0-145 57t-59 143q0 50 29.5 102t73.5 67v3q-38 17-38 85 0 53 41 77v3q-113 37-113 139 0 45 20 78.5t54 51 72 25.5 81 8q224 0 224-188 0-67-48-99t-126-46q-27-5-51.5-20.5t-24.5-39.5q0-44 49-52 77-15 122-70t45-134q0-24-10-52 37-9 49-13zM771 1186h137q-2-27-2-82v-387q0-46 2-69h-137q3 23 3 71v392q0 50-3 75zM1280 1170v-121q-30 21-68 21-53 0-53-82v-225h52q9 0 26.5 1t26.5 1v-117h-105q0-82 3-102h-140q4 24 4 55v47h-60v117q36-3 37-3 3 0 11 0.5t12 0.5v2h-2v217q0 37 2.5 64t11.5 56.5 24.5 48.5 43.5 31 66 12q64 0 108-24zM924 464q0-36-24-63.5t-60-27.5-60.5 27-24.5 64q0 36 25 62.5t60 26.5 59.5-27 24.5-62zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 1551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"git":{"width":1792,"height":1792,"paths":[{"d":"M595 1514q0-100-165-100-158 0-158 104 0 101 172 101 151 0 151-105zM536 759q0-61-30-102t-89-41q-124 0-124 145 0 135 124 135 119 0 119-137zM805 435v202q-36 12-79 22 16 43 16 84 0 127-73 216.5t-197 112.5q-40 8-59.5 27t-19.5 58q0 31 22.5 51.5t58 32 78.5 22 86 25.5 78.5 37.5 58 64 22.5 98.5q0 304-363 304-69 0-130-12.5t-116-41-87.5-82-32.5-127.5q0-165 182-225v-4q-67-41-67-126 0-109 63-137v-4q-72-24-119.5-108.5t-47.5-165.5q0-139 95-231.5t235-92.5q96 0 178 47 98 0 218-47zM1123 1316h-222q4-45 4-134v-609q0-94-4-128h222q-4 33-4 124v613q0 89 4 134zM1724 1094v196q-71 39-174 39-62 0-107-20t-70-50-39.5-78-18.5-92-4-103v-351h2v-4q-7 0-19-1t-18-1q-21 0-59 6v-190h96v-76q0-54-6-89h227q-6 41-6 165h171v190q-15 0-43.5-2t-42.5-2h-85v365q0 131 87 131 61 0 109-33zM1148 147q0 58-39 101.5t-96 43.5q-58 0-98-43.5t-40-101.5q0-59 39.5-103t98.5-44q58 0 96.5 44.5t38.5 102.5z"}]}})


/***/ }),
/* 1552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"github-alt":{"width":1664,"height":1792,"paths":[{"d":"M640 1216q0 40-12.5 82t-43 76-72.5 34-72.5-34-43-76-12.5-82 12.5-82 43-76 72.5-34 72.5 34 43 76 12.5 82zM1280 1216q0 40-12.5 82t-43 76-72.5 34-72.5-34-43-76-12.5-82 12.5-82 43-76 72.5-34 72.5 34 43 76 12.5 82zM1440 1216q0-120-69-204t-187-84q-41 0-195 21-71 11-157 11t-157-11q-152-21-195-21-118 0-187 84t-69 204q0 88 32 153.5t81 103 122 60 140 29.5 149 7h168q82 0 149-7t140-29.5 122-60 81-103 32-153.5zM1664 1040q0 207-61 331-38 77-105.5 133t-141 86-170 47.5-171.5 22-167 4.5q-78 0-142-3t-147.5-12.5-152.5-30-137-51.5-121-81-86-115q-62-123-62-331 0-237 136-396-27-82-27-170 0-116 51-218 108 0 190 39.5t189 123.5q147-35 309-35 148 0 280 32 105-82 187-121t189-39q51 102 51 218 0 87-27 168 136 160 136 398z"}]}})


/***/ }),
/* 1553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"github-square":{"width":1536,"height":1792,"paths":[{"d":"M519 1200q4-6-3-13-9-7-14-2-4 6 3 13 9 7 14 2zM491 1159q-5-7-12-4-6 4 0 12 7 8 12 5 6-4 0-13zM450 1119q2-4-5-8-7-2-8 2-3 5 4 8 8 2 9-2zM471 1142q2-1 1.5-4.5t-3.5-5.5q-6-7-10-3t1 11q6 6 11 2zM557 1217q2-7-9-11-9-3-13 4-2 7 9 11 9 3 13-4zM599 1220q0-8-12-8-10 0-10 8t11 8 11-8zM638 1213q-2-7-13-5t-9 9q2 8 12 6t10-10zM1280 896q0-212-150-362t-362-150-362 150-150 362q0 167 98 300.5t252 185.5q18 3 26.5-5t8.5-20q0-52-1-95-6 1-15.5 2.5t-35.5 2-48-4-43.5-20-29.5-41.5q-23-59-57-74-2-1-4.5-3.5l-8-8t-7-9.5 4-7.5 19.5-3.5q6 0 15 2t30 15.5 33 35.5q16 28 37.5 42t43.5 14 38-3.5 30-9.5q7-47 33-69-49-6-86-18.5t-73-39-55.5-76-19.5-119.5q0-79 53-137-24-62 5-136 19-6 54.5 7.5t60.5 29.5l26 16q58-17 128-17t128 17q11-7 28.5-18t55.5-26 57-9q29 74 5 136 53 58 53 137 0 57-14 100.5t-35.5 70-53.5 44.5-62.5 26-68.5 12q35 31 35 95 0 40-0.5 89t-0.5 51q0 12 8.5 20t26.5 5q154-52 252-185.5t98-300.5zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 1554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"github":{"width":1536,"height":1792,"paths":[{"d":"M768 128q209 0 385.5 103t279.5 279.5 103 385.5q0 251-146.5 451.5t-378.5 277.5q-27 5-40-7t-13-30q0-3 0.5-76.5t0.5-134.5q0-97-52-142 57-6 102.5-18t94-39 81-66.5 53-105 20.5-150.5q0-119-79-206 37-91-8-204-28-9-81 11t-92 44l-38 24q-93-26-192-26t-192 26q-16-11-42.5-27t-83.5-38.5-85-13.5q-45 113-8 204-79 87-79 206 0 85 20.5 150t52.5 105 80.5 67 94 39 102.5 18q-39 36-49 103-21 10-45 15t-57 5-65.5-21.5-55.5-62.5q-19-32-48.5-52t-49.5-24l-20-3q-21 0-29 4.5t-5 11.5 9 14 13 12l7 5q22 10 43.5 38t31.5 51l10 23q13 38 44 61.5t67 30 69.5 7 55.5-3.5l23-4q0 38 0.5 88.5t0.5 54.5q0 18-13 30t-40 7q-232-77-378.5-277.5t-146.5-451.5q0-209 103-385.5t279.5-279.5 385.5-103zM291 1231q3-7-7-12-10-3-13 2-3 7 7 12 9 6 13-2zM322 1265q7-5-2-16-10-9-16-3-7 5 2 16 10 10 16 3zM352 1310q9-7 0-19-8-13-17-6-9 5 0 18t17 7zM394 1352q8-8-4-19-12-12-20-3-9 8 4 19 12 12 20 3zM451 1377q3-11-13-16-15-4-19 7t13 15q15 6 19-6zM514 1382q0-13-17-11-16 0-16 11 0 13 17 11 16 0 16-11zM572 1372q-2-11-18-9-16 3-14 15t18 8 14-14z"}]}})


/***/ }),
/* 1555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"gitlab":{"width":1792,"height":1792,"paths":[{"d":"M104 706l792 1015-868-630q-18-13-25-34.5t0-42.5l101-308v0zM566 706h660l-330 1015v0zM368 94l198 612h-462l198-612q8-23 33-23t33 23zM1688 706l101 308q7 21 0 42.5t-25 34.5l-868 630 792-1015v0zM1688 706h-462l198-612q8-23 33-23t33 23z"}]}})


/***/ }),
/* 1556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"gittip":{"width":1536,"height":1792,"paths":[{"d":"M773 1302l350-473q16-22 24.5-59t-6-85-61.5-79q-40-26-83-25.5t-73.5 17.5-54.5 45q-36 40-96 40-59 0-95-40-24-28-54.5-45t-73.5-17.5-84 25.5q-46 31-60.5 79t-6 85 24.5 59zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"glass":{"width":1792,"height":1792,"paths":[{"d":"M1699 186q0 35-43 78l-632 632v768h320q26 0 45 19t19 45-19 45-45 19h-896q-26 0-45-19t-19-45 19-45 45-19h320v-768l-632-632q-43-43-43-78 0-23 18-36.5t38-17.5 43-4h1408q23 0 43 4t38 17.5 18 36.5z"}]}})


/***/ }),
/* 1558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"glide-g":{"width":1535,"height":1792,"paths":[{"d":"M744 305q0-24-2-38.5t-8.5-30-21-23-37.5-7.5q-39 0-78 23-105 58-159 190.5t-54 269.5q0 44 8.5 85.5t26.5 80.5 52.5 62.5 81.5 23.5q4 0 18 0.5t20 0 16-3 15-8.5 7-16q16-77 48-231.5t48-231.5q19-91 19-146zM1498 961q0 7-7.5 13.5t-15.5 6.5l-6-1q-22-3-62-11t-72-12.5-63-4.5q-167 0-351 93-15 8-21 27-10 36-24.5 105.5t-22.5 100.5q-23 91-70 179.5t-112.5 164.5-154.5 123-185 47q-135 0-214.5-83.5t-79.5-219.5q0-53 19.5-117t63-116.5 97.5-52.5q38 0 120 33.5t83 61.5q0 1-16.5 12.5t-39.5 31-46 44.5-39 61-16 74q0 33 16.5 53t48.5 20q45 0 85-31.5t66.5-78 48-105.5 32.5-107 16-90v-9q0-2-3.5-3.5t-8.5-1.5h-10t-10 0.5-6 0.5q-227 0-352-122.5t-125-348.5q0-108 34.5-221t96-210 156-167.5 204.5-89.5q52-9 106-9 374 0 374 360 0 98-38 273t-43 211l3 3q101-57 182.5-88t167.5-31q22 0 53 13 19 7 80 102.5t61 116.5z"}]}})


/***/ }),
/* 1559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"glide":{"width":1536,"height":1792,"paths":[{"d":"M866 515q0 27-13 94-11 50-31.5 150t-30.5 150q-2 11-4.5 12.5t-13.5 2.5q-20 2-31 2-58 0-84-49.5t-26-113.5q0-88 35-174t103-124q28-14 51-14 28 0 36.5 16.5t8.5 47.5zM1352 939q0-14-39-75.5t-52-66.5q-21-8-34-8-91 0-226 77l-2-2q3-22 27.5-135t24.5-178q0-233-242-233-24 0-68 6-94 17-168.5 89.5t-111.5 166.5-37 189q0 146 80.5 225t227.5 79q25 0 25 3t-1 5q-4 34-26 117-14 52-51.5 101t-82.5 49q-42 0-42-47 0-24 10.5-47.5t25-39.5 29.5-28.5 26-20 11-8.5q0-3-7-10-24-22-58.5-36.5t-65.5-14.5q-35 0-63.5 34t-41 75-12.5 75q0 88 51.5 142t138.5 54q82 0 155-53t117.5-126 65.5-153q6-22 15.5-66.5t14.5-66.5q3-12 14-18 118-60 227-60 48 0 127 18 1 1 4 1 5 0 9.5-4.5t4.5-8.5zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 1560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"globe":{"width":1536,"height":1792,"paths":[{"d":"M768 128q209 0 385.5 103t279.5 279.5 103 385.5-103 385.5-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103zM1042 649q-2 1-9.5 9.5t-13.5 9.5q2 0 4.5-5t5-11 3.5-7q6-7 22-15 14-6 52-12 34-8 51 11-2-2 9.5-13t14.5-12q3-2 15-4.5t15-7.5l2-22q-12 1-17.5-7t-6.5-21q0 2-6 8 0-7-4.5-8t-11.5 1-9 1q-10-3-15-7.5t-8-16.5-4-15q-2-5-9.5-11t-9.5-10q-1-2-2.5-5.5t-3-6.5-4-5.5-5.5-2.5-7 5-7.5 10-4.5 5q-3-2-6-1.5t-4.5 1-4.5 3-5 3.5q-3 2-8.5 3t-8.5 2q15-5-1-11-10-4-16-3 9-4 7.5-12t-8.5-14h5q-1-4-8.5-8.5t-17.5-8.5-13-6q-8-5-34-9.5t-33-0.5q-5 6-4.5 10.5t4 14 3.5 12.5q1 6-5.5 13t-6.5 12q0 7 14 15.5t10 21.5q-3 8-16 16t-16 12q-5 8-1.5 18.5t10.5 16.5q2 2 1.5 4t-3.5 4.5-5.5 4-6.5 3.5l-3 2q-11 5-20.5-6t-13.5-26q-7-25-16-30-23-8-29 1-5-13-41-26-25-9-58-4 6-1 0-15-7-15-19-12 3-6 4-17.5t1-13.5q3-13 12-23 1-1 7-8.5t9.5-13.5 0.5-6q35 4 50-11 5-5 11.5-17t10.5-17q9-6 14-5.5t14.5 5.5 14.5 5q14 1 15.5-11t-7.5-20q12 1 3-17-4-7-8-9-12-4-27 5-8 4 2 8-1-1-9.5 10.5t-16.5 17.5-16-5q-1-1-5.5-13.5t-9.5-13.5q-8 0-16 15 3-8-11-15t-24-8q19-12-8-27-7-4-20.5-5t-19.5 4q-5 7-5.5 11.5t5 8 10.5 5.5 11.5 4 8.5 3q14 10 8 14-2 1-8.5 3.5t-11.5 4.5-6 4q-3 4 0 14t-2 14q-5-5-9-17.5t-7-16.5q7 9-25 6l-10-1q-4 0-16 2t-20.5 1-13.5-8q-4-8 0-20 1-4 4-2-4-3-11-9.5t-10-8.5q-46 15-94 41 6 1 12-1 5-2 13-6.5t10-5.5q34-14 42-7l5-5q14 16 20 25-7-4-30-1-20 6-22 12 7 12 5 18-4-3-11.5-10t-14.5-11-15-5q-16 0-22 1-146 80-235 222 7 7 12 8 4 1 5 9t2.5 11 11.5-3q9 8 3 19 1-1 44 27 19 17 21 21 3 11-10 18-1-2-9-9t-9-4q-3 5 0.5 18.5t10.5 12.5q-7 0-9.5 16t-2.5 35.5-1 23.5l2 1q-3 12 5.5 34.5t21.5 19.5q-13 3 20 43 6 8 8 9 3 2 12 7.5t15 10 10 10.5q4 5 10 22.5t14 23.5q-2 6 9.5 20t10.5 23q-1 0-2.5 1t-2.5 1q3 7 15.5 14t15.5 13q1 3 2 10t3 11 8 2q2-20-24-62-15-25-17-29-3-5-5.5-15.5t-4.5-14.5q2 0 6 1.5t8.5 3.5 7.5 4 2 3q-3 7 2 17.5t12 18.5 17 19 12 13q6 6 14 19.5t0 13.5q9 0 20 10.5t17 19.5q5 8 8 26t5 24q2 7 8.5 13.5t12.5 9.5l16 8t13 7q5 2 18.5 10.5t21.5 11.5q10 4 16 4t14.5-2.5 13.5-3.5q15-2 29 15t21 21q36 19 55 11-2 1 0.5 7.5t8 15.5 9 14.5 5.5 8.5q5 6 18 15t18 15q6-4 7-9-3 8 7 20t18 10q14-3 14-32-31 15-49-18 0-1-2.5-5.5t-4-8.5-2.5-8.5 0-7.5 5-3q9 0 10-3.5t-2-12.5-4-13q-1-8-11-20t-12-15q-5 9-16 8t-16-9q0 1-1.5 5.5t-1.5 6.5q-13 0-15-1 1-3 2.5-17.5t3.5-22.5q1-4 5.5-12t7.5-14.5 4-12.5-4.5-9.5-17.5-2.5q-19 1-26 20-1 3-3 10.5t-5 11.5-9 7q-7 3-24 2t-24-5q-13-8-22.5-29t-9.5-37q0-10 2.5-26.5t3-25-5.5-24.5q3-2 9-9.5t10-10.5q2-1 4.5-1.5t4.5 0 4-1.5 3-6q-1-1-4-3-3-3-4-3 7 3 28.5-1.5t27.5 1.5q15 11 22-2 0-1-2.5-9.5t-0.5-13.5q5 27 29 9 3 3 15.5 5t17.5 5q3 2 7 5.5t5.5 4.5 5-0.5 8.5-6.5q10 14 12 24 11 40 19 44 7 3 11 2t4.5-9.5 0-14-1.5-12.5l-1-8v-18l-1-8q-15-3-18.5-12t1.5-18.5 15-18.5q1-1 8-3.5t15.5-6.5 12.5-8q21-19 15-35 7 0 11-9-1 0-5-3t-7.5-5-4.5-2q9-5 2-16 5-3 7.5-11t7.5-10q9 12 21 2 8-8 1-16 5-7 20.5-10.5t18.5-9.5q7 2 8-2t1-12 3-12q4-5 15-9t13-5l17-11q3-4 0-4 18 2 31-11 10-11-6-20 3-6-3-9.5t-15-5.5q3-1 11.5-0.5t10.5-1.5q15-10-7-16-17-5-43 12zM879 1526q206-36 351-189-3-3-12.5-4.5t-12.5-3.5q-18-7-24-8 1-7-2.5-13t-8-9-12.5-8-11-7q-2-2-7-6t-7-5.5-7.5-4.5-8.5-2-10 1l-3 1q-3 1-5.5 2.5t-5.5 3-4 3 0 2.5q-21-17-36-22-5-1-11-5.5t-10.5-7-10-1.5-11.5 7q-5 5-6 15t-2 13q-7-5 0-17.5t2-18.5q-3-6-10.5-4.5t-12 4.5-11.5 8.5-9 6.5-8.5 5.5-8.5 7.5q-3 4-6 12t-5 11q-2-4-11.5-6.5t-9.5-5.5q2 10 4 35t5 38q7 31-12 48-27 25-29 40-4 22 12 26 0 7-8 20.5t-7 21.5q0 6 2 16z"}]}})


/***/ }),
/* 1561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"google-plus-circle":{"width":1536,"height":1792,"paths":[{"d":"M917 905q0-33-6-64h-362v132h217q-12 76-74.5 120.5t-142.5 44.5q-99 0-169-71.5t-70-170.5 70-170.5 169-71.5q93 0 153 59l104-101q-108-100-257-100-160 0-272 112.5t-112 271.5 112 271.5 272 112.5q165 0 266.5-105t101.5-270zM1262 951h109v-110h-109v-110h-110v110h-110v110h110v110h110v-110zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"google-plus-official":{"width":1536,"height":1792,"paths":[{"d":"M917 905q0-33-6-64h-362v132h217q-12 76-74.5 120.5t-142.5 44.5q-99 0-169-71.5t-70-170.5 70-170.5 169-71.5q93 0 153 59l104-101q-108-100-257-100-160 0-272 112.5t-112 271.5 112 271.5 272 112.5q165 0 266.5-105t101.5-270zM1262 951h109v-110h-109v-110h-110v110h-110v110h110v110h110v-110zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"google-plus-square":{"width":1536,"height":1792,"paths":[{"d":"M917 905q0-26-6-64h-362v132h217q-3 24-16.5 50t-37.5 53-66.5 44.5-96.5 17.5q-99 0-169-71t-70-171 70-171 169-71q92 0 153 59l104-101q-108-100-257-100-160 0-272 112.5t-112 271.5 112 271.5 272 112.5q165 0 266.5-105t101.5-270zM1262 951h109v-110h-109v-110h-110v110h-110v110h110v110h110v-110zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 1564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"google-plus":{"width":2304,"height":1792,"paths":[{"d":"M1437 913q0 208-87 370.5t-248 254-369 91.5q-149 0-285-58t-234-156-156-234-58-285 58-285 156-234 234-156 285-58q286 0 491 192l-199 191q-117-113-292-113-123 0-227.5 62t-165.5 168.5-61 232.5 61 232.5 165.5 168.5 227.5 62q83 0 152.5-23t114.5-57.5 78.5-78.5 49-83 21.5-74h-416v-252h692q12 63 12 122zM2304 791v210h-209v209h-210v-209h-209v-210h209v-209h210v209h209z"}]}})


/***/ }),
/* 1565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"google-wallet":{"width":1792,"height":1792,"paths":[{"d":"M441 672q33 0 52 26 266 364 362 774h-446q-127-441-367-749-12-16-3-33.5t29-17.5h373zM1000 1029q-49 199-125 393-79-310-256-594 40-221 44-449 211 340 337 650zM1099 320q235 324 384.5 698.5t184.5 773.5h-451q-41-665-553-1472h435zM1792 896q0 424-101 812-67-560-359-1083-25-301-106-584-4-16 5.5-28.5t25.5-12.5h359q21 0 38.5 13t22.5 33q115 409 115 850z"}]}})


/***/ }),
/* 1566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"google":{"width":1536,"height":1792,"paths":[{"d":"M768 786h725q12 67 12 128 0 217-91 387.5t-259.5 266.5-386.5 96q-157 0-299-60.5t-245-163.5-163.5-245-60.5-299 60.5-299 163.5-245 245-163.5 299-60.5q300 0 515 201l-209 201q-123-119-306-119-129 0-238.5 65t-173.5 176.5-64 243.5 64 243.5 173.5 176.5 238.5 65q87 0 160-24t120-60 82-82 51.5-87 22.5-78h-436v-264z"}]}})


/***/ }),
/* 1567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"graduation-cap":{"width":2304,"height":1792,"paths":[{"d":"M1774 836l18 316q4 69-82 128t-235 93.5-323 34.5-323-34.5-235-93.5-82-128l18-316 574 181q22 7 48 7t48-7zM2304 512q0 23-22 31l-1120 352q-4 1-10 1t-10-1l-652-206q-43 34-71 111.5t-34 178.5q63 36 63 109 0 69-58 107l58 433q2 14-8 25-9 11-24 11h-192q-15 0-24-11-10-11-8-25l58-433q-58-38-58-107 0-73 65-111 11-207 98-330l-333-104q-22-8-22-31t22-31l1120-352q4-1 10-1t10 1l1120 352q22 8 22 31z"}]}})


/***/ }),
/* 1568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"gratipay":{"width":1536,"height":1792,"paths":[{"d":"M773 1302l350-473q16-22 24.5-59t-6-85-61.5-79q-40-26-83-25.5t-73.5 17.5-54.5 45q-36 40-96 40-59 0-95-40-24-28-54.5-45t-73.5-17.5-84 25.5q-46 31-60.5 79t-6 85 24.5 59zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"grav":{"width":1794,"height":1792,"paths":[{"d":"M1291 476q-15-17-35-8.5t-26 28.5 5 38q14 17 40 14.5t34-20.5-18-52zM895 722q-8 8-19.5 8t-18.5-8q-8-8-8-19t8-18q7-8 18.5-8t19.5 8q7 7 7 18t-7 19zM1060 796l-35 35q-12 13-29.5 13t-30.5-13l-38-38q-12-13-12-30t12-30l35-35q12-12 29.5-12t30.5 12l38 39q12 12 12 29.5t-12 29.5zM951 666q-7 8-18.5 8t-19.5-8q-7-8-7-19t7-19q8-8 19-8t19 8 8 19-8 19zM1354 568q-34 64-107.5 85.5t-127.5-16.5q-38-28-61-66.5t-21-87.5 39-92 75.5-53 70.5 5 70 51q2 2 13 12.5t14.5 13.5 13 13.5 12.5 15.5 10 15.5 8.5 18 4 18.5 1 21-5 22-9.5 24zM1555 1050q3-20-8.5-34.5t-27.5-21.5-33-17-23-20q-40-71-84-98.5t-113-11.5q19-13 40-18.5t33-4.5l12 1q2-45-34-90 6-20 6.5-40.5t-2.5-30.5l-3-10q43-24 71-65t34-91q10-84-43-150.5t-137-76.5q-60-7-114 18.5t-82 74.5q-30 51-33.5 101t14.5 87 43.5 64 56.5 42q-45-4-88-36t-57-88q-28-108 32-222-16-21-29-32-50 0-89 19 19-24 42-37t36-14l13-1q0-50-13-78-10-21-32.5-28.5t-47 3.5-37.5 40q2-4 4-7-7 28-6.5 75.5t19 117 48.5 122.5q-25 14-47 36-35 16-85.5 70.5t-84.5 101.5l-33 46q-90 34-181 125.5t-75 162.5q1 16 11 27-15 12-30 30-21 25-21 54t21.5 40 63.5-6q41-19 77-49.5t55-60.5q-2-2-6.5-5t-20.5-7.5-33-3.5q23-5 51-12.5t40-10 27.5-6 26-4 23.5-0.5q14 7 22-34 7-37 7-90 0-102-40-150 106 103 101 219-1 29-15 50t-27 27l-13 6q-4 7-19 32t-26 45.5-26.5 52-25 61-17 63-6.5 66.5 10 63q-35-54-37-80-22 24-34.5 39t-33.5 42-30.5 46-16.5 41-0.5 38 25.5 27q45 25 144-64t190.5-221.5 122.5-228.5q86-52 145-115.5t86-119.5q47 93 154 178 104 83 167 80 39-2 46-43zM1794 896q0 182-71 348t-191 286-286.5 191-348.5 71-348.5-71-286.5-191-191-286-71-348 71-348 191-286 286.5-191 348.5-71 348.5 71 286.5 191 191 286 71 348z"}]}})


/***/ }),
/* 1570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"group":{"width":1920,"height":1792,"paths":[{"d":"M593 896q-162 5-265 128h-134q-82 0-138-40.5t-56-118.5q0-353 124-353 6 0 43.5 21t97.5 42.5 119 21.5q67 0 133-23-5 37-5 66 0 139 81 256zM1664 1533q0 120-73 189.5t-194 69.5h-874q-121 0-194-69.5t-73-189.5q0-53 3.5-103.5t14-109 26.5-108.5 43-97.5 62-81 85.5-53.5 111.5-20q10 0 43 21.5t73 48 107 48 135 21.5 135-21.5 107-48 73-48 43-21.5q61 0 111.5 20t85.5 53.5 62 81 43 97.5 26.5 108.5 14 109 3.5 103.5zM640 256q0 106-75 181t-181 75-181-75-75-181 75-181 181-75 181 75 75 181zM1344 640q0 159-112.5 271.5t-271.5 112.5-271.5-112.5-112.5-271.5 112.5-271.5 271.5-112.5 271.5 112.5 112.5 271.5zM1920 865q0 78-56 118.5t-138 40.5h-134q-103-123-265-128 81-117 81-256 0-29-5-66 66 23 133 23 59 0 119-21.5t97.5-42.5 43.5-21q124 0 124 353zM1792 256q0 106-75 181t-181 75-181-75-75-181 75-181 181-75 181 75 75 181z"}]}})


/***/ }),
/* 1571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"h-square":{"width":1536,"height":1792,"paths":[{"d":"M1280 1344v-896q0-26-19-45t-45-19h-128q-26 0-45 19t-19 45v320h-512v-320q0-26-19-45t-45-19h-128q-26 0-45 19t-19 45v896q0 26 19 45t45 19h128q26 0 45-19t19-45v-320h512v320q0 26 19 45t45 19h128q26 0 45-19t19-45zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 1572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"hacker-news":{"width":1536,"height":1792,"paths":[{"d":"M809 1004l266-499h-112l-157 312q-24 48-44 92l-42-92-155-312h-120l263 493v324h101v-318zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 1573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"hand-grab-o":{"width":1536,"height":1792,"paths":[{"d":"M768 384q-53 0-90.5 37.5t-37.5 90.5v128h-32v-93q0-48-32-81.5t-80-33.5q-46 0-79 33t-33 79v429l-32-30v-172q0-48-32-81.5t-80-33.5q-46 0-79 33t-33 79v224q0 47 35 82l310 296q39 39 39 102 0 26 19 45t45 19h640q26 0 45-19t19-45v-25q0-41 10-77l108-436q10-36 10-77v-246q0-48-32-81.5t-80-33.5q-46 0-79 33t-33 79v32h-32v-125q0-40-25-72.5t-64-40.5q-14-2-23-2-46 0-79 33t-33 79v128h-32v-122q0-51-32.5-89.5t-82.5-43.5q-5-1-13-1zM768 256q84 0 149 50 57-34 123-34 59 0 111 27t86 76q27-7 59-7 100 0 170 71.5t70 171.5v246q0 51-13 108l-109 436q-6 24-6 71 0 80-56 136t-136 56h-640q-84 0-138-58.5t-54-142.5l-308-296q-76-73-76-175v-224q0-99 70.5-169.5t169.5-70.5q11 0 16 1 6-95 75.5-160t164.5-65q52 0 98 21 72-69 174-69z"}]}})


/***/ }),
/* 1574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"hand-lizard-o":{"width":2048,"height":1792,"paths":[{"d":"M1151 0q61 0 116 28t91 77l572 781q118 159 118 359v355q0 80-56 136t-136 56h-384q-80 0-136-56t-56-136v-177l-286-143h-546q-80 0-136-56t-56-136v-32q0-119 84.5-203.5t203.5-84.5h420l42-128h-686q-100 0-173.5-67.5t-81.5-166.5q-65-79-65-182v-32q0-80 56-136t136-56h959zM1920 1600v-355q0-157-93-284l-573-781q-39-52-103-52h-959q-26 0-45 19t-19 45q0 32 1.5 49.5t9.5 40.5 25 43q10-31 35.5-50t56.5-19h832v32h-832q-26 0-45 19t-19 45q0 44 3 58 8 44 44 73t81 29h640 91q40 0 68 28t28 68q0 15-5 30l-64 192q-10 29-35 47.5t-56 18.5h-443q-66 0-113 47t-47 113v32q0 26 19 45t45 19h561q16 0 29 7l317 158q24 13 38.5 36t14.5 50v197q0 26 19 45t45 19h384q26 0 45-19t19-45z"}]}})


/***/ }),
/* 1575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"hand-o-down":{"width":1536,"height":1792,"paths":[{"d":"M1408 960q0-84-32-183t-64-194-32-167v-32h-640v32q0 35-12 67.5t-37 62.5-46 50-54 49q-9 8-14 12-81 72-145 112-22 14-68 38-3 1-22.5 10.5t-36 18.5-35.5 20-30.5 21.5-11.5 18.5q0 71 30.5 115.5t97.5 44.5q43 0 84.5-15t68-33 55-33 48.5-15v576q0 50 38.5 89t89.5 39q52 0 90-38t38-90v-331q46 35 103 35 69 0 119-53 32 18 69 18t73.5-17.5 52.5-47.5q24 4 56 4 85 0 126-48.5t41-135.5zM1280 192q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zM1536 956q0 142-77.5 230t-217.5 87l-5-1q-76 61-178 61-22 0-43-3-54 30-119 37v169q0 105-76 180.5t-181 75.5q-103 0-179-76t-76-180v-374q-54 22-128 22-121 0-188.5-81.5t-67.5-206.5q0-38 17.5-69.5t49.5-55 63-40.5 72-37 62-33q55-35 129-100 3-2 17-14t21.5-19 21.5-20.5 22.5-24 18-22.5 14-23.5 4.5-21.5v-288q0-53 37.5-90.5t90.5-37.5h640q53 0 90.5 37.5t37.5 90.5v288q0 59 59 223 69 190 69 317z"}]}})


/***/ }),
/* 1576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"hand-o-left":{"width":1792,"height":1792,"paths":[{"d":"M1376 1408h32v-640h-32q-35 0-67.5-12t-62.5-37-50-46-49-54q-8-9-12-14-72-81-112-145-14-22-38-68-1-3-10.5-22.5t-18.5-36-20-35.5-21.5-30.5-18.5-11.5q-71 0-115.5 30.5t-44.5 97.5q0 43 15 84.5t33 68 33 55 15 48.5h-576q-50 0-89 38.5t-39 89.5q0 52 38 90t90 38h331q-15 17-25 47.5t-10 55.5q0 69 53 119-18 32-18 69t17.5 73.5 47.5 52.5q-4 24-4 56 0 85 48.5 126t135.5 41q84 0 183-32t194-64 167-32zM1664 1344q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zM1792 768v640q0 53-37.5 90.5t-90.5 37.5h-288q-59 0-223 59-190 69-317 69-142 0-230-77.5t-87-217.5l1-5q-61-76-61-178 0-22 3-43-33-57-37-119h-169q-105 0-180.5-76t-75.5-181q0-103 76-179t180-76h374q-22-60-22-128 0-122 81.5-189t206.5-67q38 0 69.5 17.5t55 49.5 40.5 63 37 72 33 62q35 55 100 129 2 3 14 17t19 21.5 20.5 21.5 24 22.5 22.5 18 23.5 14 21.5 4.5h288q53 0 90.5 37.5t37.5 90.5z"}]}})


/***/ }),
/* 1577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"hand-o-right":{"width":1792,"height":1792,"paths":[{"d":"M256 1344q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zM1664 768q0-51-39-89.5t-89-38.5h-576q0-20 15-48.5t33-55 33-68 15-84.5q0-67-44.5-97.5t-115.5-30.5q-24 0-90 139-24 44-37 65-40 64-112 145-71 81-101 106-69 57-140 57h-32v640h32q72 0 167 32t193.5 64 179.5 32q189 0 189-167 0-26-5-56 30-16 47.5-52.5t17.5-73.5-18-69q53-50 53-119 0-25-10-55.5t-25-47.5h331q52 0 90-38t38-90zM1792 767q0 105-75.5 181t-180.5 76h-169q-4 62-37 119 3 21 3 43 0 101-60 178 1 139-85 219.5t-227 80.5q-133 0-322-69-164-59-223-59h-288q-53 0-90.5-37.5t-37.5-90.5v-640q0-53 37.5-90.5t90.5-37.5h288q10 0 21.5-4.5t23.5-14 22.5-18 24-22.5 20.5-21.5 19-21.5 14-17q65-74 100-129 13-21 33-62t37-72 40.5-63 55-49.5 69.5-17.5q125 0 206.5 67t81.5 189q0 68-22 128h374q104 0 180 76t76 179z"}]}})


/***/ }),
/* 1578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"hand-o-up":{"width":1536,"height":1792,"paths":[{"d":"M1280 1600q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zM1408 836q0-189-167-189-26 0-56 5-16-30-52.5-47.5t-73.5-17.5-69 18q-50-53-119-53-25 0-55.5 10t-47.5 25v-331q0-52-38-90t-90-38q-51 0-89.5 39t-38.5 89v576q-20 0-48.5-15t-55-33-68-33-84.5-15q-67 0-97.5 44.5t-30.5 115.5q0 24 139 90 44 24 65 37 64 40 145 112 81 71 106 101 57 69 57 140v32h640v-32q0-72 32-167t64-193.5 32-179.5zM1536 831q0 133-69 322-59 164-59 223v288q0 53-37.5 90.5t-90.5 37.5h-640q-53 0-90.5-37.5t-37.5-90.5v-288q0-10-4.5-21.5t-14-23.5-18-22.5-22.5-24-21.5-20.5-21.5-19-17-14q-74-65-129-100-21-13-62-33t-72-37-63-40.5-49.5-55-17.5-69.5q0-125 67-206.5t189-81.5q68 0 128 22v-374q0-104 76-180t179-76q105 0 181 75.5t76 180.5v169q62 4 119 37 21-3 43-3 101 0 178 60 139-1 219.5 85t80.5 227z"}]}})


/***/ }),
/* 1579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"hand-paper-o":{"width":1792,"height":1792,"paths":[{"d":"M880 128q-46 0-79 33t-33 79v656h-32v-528q0-46-33-79t-79-33-79 33-33 79v528 256l-154-205q-38-51-102-51-53 0-90.5 37.5t-37.5 90.5q0 43 26 77l384 512q38 51 102 51h688q34 0 61-22t34-56l76-405q5-32 5-59v-498q0-46-33-79t-79-33-79 33-33 79v272h-32v-528q0-46-33-79t-79-33-79 33-33 79v528h-32v-656q0-46-33-79t-79-33zM880 0q68 0 125.5 35.5t88.5 96.5q19-4 42-4 99 0 169.5 70.5t70.5 169.5v17q105-6 180.5 64t75.5 175v498q0 40-8 83l-76 404q-14 79-76.5 131t-143.5 52h-688q-60 0-114.5-27.5t-90.5-74.5l-384-512q-51-68-51-154 0-106 75-181t181-75q78 0 128 34v-434q0-99 70.5-169.5t169.5-70.5q23 0 42 4 31-61 88.5-96.5t125.5-35.5z"}]}})


/***/ }),
/* 1580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"hand-peace-o":{"width":1536,"height":1792,"paths":[{"d":"M1288 647q60 0 107 23 141 63 141 226v177q0 94-23 186l-85 339q-21 86-90.5 140t-157.5 54h-668q-106 0-181-75t-75-181v-401l-239-628q-17-45-17-91 0-106 75-181t181-75q80 0 145.5 45.5t93.5 119.5l17 44v-113q0-106 75-181t181-75 181 75 75 181v261q27-5 48-5 69 0 127.5 36.5t88.5 98.5zM1072 640q-33 0-60.5 18t-41.5 48l-74 163-71 155h55q50 0 90 31.5t50 80.5l154-338q10-20 10-46 0-46-33-79t-79-33zM1293 775q-22 0-40.5 8t-29 16-23.5 29.5-17 30.5-17 37l-132 290q-10 20-10 46 0 46 33 79t79 33q33 0 60.5-18t41.5-48l160-352q9-18 9-38 0-50-32-81.5t-82-31.5zM128 416q0 22 8 46l248 650v69l102-111q43-46 106-46h198l106-233v-535q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5v640h-64l-200-526q-14-37-47-59.5t-73-22.5q-53 0-90.5 37.5t-37.5 90.5zM1180 1664q44 0 78.5-27t45.5-70l85-339q19-73 19-155v-91l-141 310q-17 38-53 61t-78 23q-53 0-93.5-34.5t-48.5-86.5q-44 57-114 57h-208v-32h208q46 0 81-33t35-79-31-79-77-33h-296q-49 0-82 36l-126 136v308q0 53 37.5 90.5t90.5 37.5h668z"}]}})


/***/ }),
/* 1581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"hand-pointer-o":{"width":1792,"height":1792,"paths":[{"d":"M640 128q-53 0-90.5 37.5t-37.5 90.5v512 384l-151-202q-41-54-107-54-52 0-89 38t-37 90q0 43 26 77l384 512q38 51 102 51h718q22 0 39.5-13.5t22.5-34.5l92-368q24-96 24-194v-217q0-41-28-71t-68-30-68 28-28 68h-32v-61q0-48-32-81.5t-80-33.5q-46 0-79 33t-33 79v64h-32v-90q0-55-37-94.5t-91-39.5q-53 0-90.5 37.5t-37.5 90.5v96h-32v-570q0-55-37-94.5t-91-39.5zM640 0q107 0 181.5 77.5t74.5 184.5v220q22-2 32-2 99 0 173 69 47-21 99-21 113 0 184 87 27-7 56-7 94 0 159 67.5t65 161.5v217q0 116-28 225l-92 368q-16 64-68 104.5t-118 40.5h-718q-60 0-114.5-27.5t-90.5-74.5l-384-512q-51-68-51-154 0-105 74.5-180.5t179.5-75.5q71 0 130 35v-547q0-106 75-181t181-75zM768 1408v-384h-32v384h32zM1024 1408v-384h-32v384h32zM1280 1408v-384h-32v384h32z"}]}})


/***/ }),
/* 1582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"hand-rock-o":{"width":1536,"height":1792,"paths":[{"d":"M768 384q-53 0-90.5 37.5t-37.5 90.5v128h-32v-93q0-48-32-81.5t-80-33.5q-46 0-79 33t-33 79v429l-32-30v-172q0-48-32-81.5t-80-33.5q-46 0-79 33t-33 79v224q0 47 35 82l310 296q39 39 39 102 0 26 19 45t45 19h640q26 0 45-19t19-45v-25q0-41 10-77l108-436q10-36 10-77v-246q0-48-32-81.5t-80-33.5q-46 0-79 33t-33 79v32h-32v-125q0-40-25-72.5t-64-40.5q-14-2-23-2-46 0-79 33t-33 79v128h-32v-122q0-51-32.5-89.5t-82.5-43.5q-5-1-13-1zM768 256q84 0 149 50 57-34 123-34 59 0 111 27t86 76q27-7 59-7 100 0 170 71.5t70 171.5v246q0 51-13 108l-109 436q-6 24-6 71 0 80-56 136t-136 56h-640q-84 0-138-58.5t-54-142.5l-308-296q-76-73-76-175v-224q0-99 70.5-169.5t169.5-70.5q11 0 16 1 6-95 75.5-160t164.5-65q52 0 98 21 72-69 174-69z"}]}})


/***/ }),
/* 1583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"hand-scissors-o":{"width":1792,"height":1792,"paths":[{"d":"M1073 1664h-177q-163 0-226-141-23-49-23-102v-5q-62-30-98.5-88.5t-36.5-127.5q0-38 5-48h-261q-106 0-181-75t-75-181 75-181 181-75h113l-44-17q-74-28-119.5-93.5t-45.5-145.5q0-106 75-181t181-75q46 0 91 17l628 239h401q106 0 181 75t75 181v668q0 88-54 157.5t-140 90.5l-339 85q-92 23-186 23zM1024 953l-155 71-163 74q-30 14-48 41.5t-18 60.5q0 46 33 79t79 33q26 0 46-10l338-154q-49-10-80.5-50t-31.5-90v-55zM1344 1264q0-46-33-79t-79-33q-26 0-46 10l-290 132q-28 13-37 17t-30.5 17-29.5 23.5-16 29-8 40.5q0 50 31.5 82t81.5 32q20 0 38-9l352-160q30-14 48-41.5t18-60.5zM1112 512l-650-248q-24-8-46-8-53 0-90.5 37.5t-37.5 90.5q0 40 22.5 73t59.5 47l526 200v64h-640q-53 0-90.5 37.5t-37.5 90.5 37.5 90.5 90.5 37.5h535l233-106v-198q0-63 46-106l111-102h-69zM1073 1536q82 0 155-19l339-85q43-11 70-45.5t27-78.5v-668q0-53-37.5-90.5t-90.5-37.5h-308l-136 126q-36 33-36 82v296q0 46 33 77t79 31 79-35 33-81v-208h32v208q0 70-57 114 52 8 86.5 48.5t34.5 93.5q0 42-23 78t-61 53l-310 141h91z"}]}})


/***/ }),
/* 1584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"hand-spock-o":{"width":2048,"height":1792,"paths":[{"d":"M459 1792q-77 0-137.5-47.5t-79.5-122.5l-101-401q-13-57-13-108 0-45-5-67l-116-477q-7-27-7-57 0-93 62-161t155-78q17-85 82.5-139t152.5-54q83 0 148 51.5t85 132.5l83 348 103-428q20-81 85-132.5t148-51.5q89 0 155.5 57.5t80.5 144.5q92 10 152 79t60 162q0 24-7 59l-123 512q10-7 37.5-28.5t38.5-29.5 35-23 41-20.5 41.5-11 49.5-5.5q105 0 180 74t75 179q0 62-28.5 118t-78.5 94l-507 380q-68 51-153 51h-694zM1104 128q-38 0-68.5 24t-39.5 62l-164 682h-127l-145-602q-9-38-39.5-62t-68.5-24q-48 0-80 33t-32 80q0 15 3 28l132 547h-26l-99-408q-9-37-40-62.5t-69-25.5q-47 0-80 33t-33 79q0 14 3 26l116 478q7 28 9 86t10 88l100 401q8 32 34 52.5t59 20.5h694q42 0 76-26l507-379q56-43 56-110 0-52-37.5-88.5t-89.5-36.5q-43 0-77 26l-307 230v-227q0-4 32-138t68-282 39-161q4-18 4-29 0-47-32-81t-79-34q-39 0-69.5 24t-39.5 62l-116 482h-26l150-624q3-14 3-28 0-48-31.5-82t-79.5-34z"}]}})


/***/ }),
/* 1585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"hand-stop-o":{"width":1792,"height":1792,"paths":[{"d":"M880 128q-46 0-79 33t-33 79v656h-32v-528q0-46-33-79t-79-33-79 33-33 79v528 256l-154-205q-38-51-102-51-53 0-90.5 37.5t-37.5 90.5q0 43 26 77l384 512q38 51 102 51h688q34 0 61-22t34-56l76-405q5-32 5-59v-498q0-46-33-79t-79-33-79 33-33 79v272h-32v-528q0-46-33-79t-79-33-79 33-33 79v528h-32v-656q0-46-33-79t-79-33zM880 0q68 0 125.5 35.5t88.5 96.5q19-4 42-4 99 0 169.5 70.5t70.5 169.5v17q105-6 180.5 64t75.5 175v498q0 40-8 83l-76 404q-14 79-76.5 131t-143.5 52h-688q-60 0-114.5-27.5t-90.5-74.5l-384-512q-51-68-51-154 0-106 75-181t181-75q78 0 128 34v-434q0-99 70.5-169.5t169.5-70.5q23 0 42 4 31-61 88.5-96.5t125.5-35.5z"}]}})


/***/ }),
/* 1586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"handshake-o":{"width":2304,"height":1792,"paths":[{"d":"M192 1152q40 0 56-32t0-64-56-32-56 32 0 64 56 32zM1665 1094q-10-13-38.5-50t-41.5-54-38-49-42.5-53-40.5-47-45-49l-125 140q-83 94-208.5 92t-205.5-98q-57-69-56.5-158t58.5-157l177-206q-22-11-51-16.5t-47.5-6-56.5 0.5-49 1q-92 0-158 66l-158 158h-155v544q5 0 21-0.5t22 0 19.5 2 20.5 4.5 17.5 8.5 18.5 13.5l297 292q115 111 227 111 78 0 125-47 57 20 112.5-8t72.5-85q74 6 127-44 20-18 36-45.5t14-50.5q10 10 43 10 43 0 77-21t49.5-53 12-71.5-30.5-73.5zM1824 1152h96v-512h-93l-157-180q-66-76-169-76h-167q-89 0-146 67l-209 243q-28 33-28 75t27 75q43 51 110 52t111-49l193-218q25-23 53.5-21.5t47 27 8.5 56.5q16 19 56 63t60 68q29 36 82.5 105.5t64.5 84.5q52 66 60 140zM2112 1152q40 0 56-32t0-64-56-32-56 32 0 64 56 32zM2304 576v640q0 26-19 45t-45 19h-434q-27 65-82 106.5t-125 51.5q-33 48-80.5 81.5t-102.5 45.5q-42 53-104.5 81.5t-128.5 24.5q-60 34-126 39.5t-127.5-14-117-53.5-103.5-81l-287-282h-358q-26 0-45-19t-19-45v-672q0-26 19-45t45-19h421q14-14 47-48t47.5-48 44-40 50.5-37.5 51-25.5 62-19.5 68-5.5h117q99 0 181 56 82-56 181-56h167q35 0 67 6t56.5 14.5 51.5 26.5 44.5 31 43 39.5 39 42 41 48 41.5 48.5h355q26 0 45 19t19 45z"}]}})


/***/ }),
/* 1587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"hard-of-hearing":{"width":1792,"height":1792,"paths":[{"d":"M1056 832q0 26 19 45t45 19 45-19 19-45q0-146-103-249t-249-103-249 103-103 249q0 26 19 45t45 19 45-19 19-45q0-93 66-158.5t158-65.5 158 65.5 66 158.5zM835 256q-117 0-223.5 45.5t-184 123-123 184-45.5 223.5q0 26 19 45t45 19 45-19 19-45q0-185 131.5-316.5t316.5-131.5 316.5 131.5 131.5 316.5q0 55-18 103.5t-37.5 74.5-59.5 72q-34 39-52 63t-43.5 66.5-37 91-11.5 105.5q0 106-75 181t-181 75q-26 0-45 19t-19 45 19 45 45 19q159 0 271.5-112.5t112.5-271.5q0-41 7.5-74t26.5-64 33.5-50 45.5-54q35-41 53-64.5t44-67.5 37.5-93.5 11.5-108.5q0-117-45.5-223.5t-123-184-184-123-223.5-45.5zM591 975l226 226-579 579q-12 12-29 12t-29-12l-168-168q-12-12-12-29t12-29zM1612 12l168 168q12 12 12 29t-12 30l-233 233-26 25-71 71q-66-153-195-258l91-91 207-207q13-12 30-12t29 12z"}]}})


/***/ }),
/* 1588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"hashtag":{"width":1792,"height":1792,"paths":[{"d":"M991 1024l64-256h-254l-64 256h254zM1759 520l-56 224q-7 24-31 24h-327l-64 256h311q15 0 25 12 10 14 6 28l-56 224q-5 24-31 24h-327l-81 328q-7 24-31 24h-224q-16 0-26-12-9-12-6-28l78-312h-254l-81 328q-7 24-31 24h-225q-15 0-25-12-9-12-6-28l78-312h-311q-15 0-25-12-9-12-6-28l56-224q7-24 31-24h327l64-256h-311q-15 0-25-12-10-14-6-28l56-224q5-24 31-24h327l81-328q7-24 32-24h224q15 0 25 12 9 12 6 28l-78 312h254l81-328q7-24 32-24h224q15 0 25 12 9 12 6 28l-78 312h311q15 0 25 12 9 12 6 28z"}]}})


/***/ }),
/* 1589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"hdd-o":{"width":1536,"height":1792,"paths":[{"d":"M1040 1216q0 33-23.5 56.5t-56.5 23.5-56.5-23.5-23.5-56.5 23.5-56.5 56.5-23.5 56.5 23.5 23.5 56.5zM1296 1216q0 33-23.5 56.5t-56.5 23.5-56.5-23.5-23.5-56.5 23.5-56.5 56.5-23.5 56.5 23.5 23.5 56.5zM1408 1376v-320q0-13-9.5-22.5t-22.5-9.5h-1216q-13 0-22.5 9.5t-9.5 22.5v320q0 13 9.5 22.5t22.5 9.5h1216q13 0 22.5-9.5t9.5-22.5zM178 896h1180l-157-482q-4-13-16-21.5t-26-8.5h-782q-14 0-26 8.5t-16 21.5zM1536 1056v320q0 66-47 113t-113 47h-1216q-66 0-113-47t-47-113v-320q0-25 16-75l197-606q17-53 63-86t101-33h782q55 0 101 33t63 86l197 606q16 50 16 75z"}]}})


/***/ }),
/* 1590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"header":{"width":1792,"height":1792,"paths":[{"d":"M1682 1664q-44 0-132.5-3.5t-133.5-3.5q-44 0-132 3.5t-132 3.5q-24 0-37-20.5t-13-45.5q0-31 17-46t39-17 51-7 45-15q33-21 33-140l-1-391q0-21-1-31-13-4-50-4h-675q-38 0-51 4-1 10-1 31l-1 371q0 142 37 164 16 10 48 13t57 3.5 45 15 20 45.5q0 26-12.5 48t-36.5 22q-47 0-139.5-3.5t-138.5-3.5q-43 0-128 3.5t-127 3.5q-23 0-35.5-21t-12.5-45q0-30 15.5-45t36-17.5 47.5-7.5 42-15q33-23 33-143l-1-57v-813q0-3 0.5-26t0-36.5-1.5-38.5-3.5-42-6.5-36.5-11-31.5-16-18q-15-10-45-12t-53-2-41-14-18-45q0-26 12-48t36-22q46 0 138.5 3.5t138.5 3.5q42 0 126.5-3.5t126.5-3.5q25 0 37.5 22t12.5 48q0 30-17 43.5t-38.5 14.5-49.5 4-43 13q-35 21-35 160l1 320q0 21 1 32 13 3 39 3h699q25 0 38-3 1-11 1-32l1-320q0-139-35-160-18-11-58.5-12.5t-66-13-25.5-49.5q0-26 12.5-48t37.5-22q44 0 132 3.5t132 3.5q43 0 129-3.5t129-3.5q25 0 37.5 22t12.5 48q0 30-17.5 44t-40 14.5-51.5 3-44 12.5q-35 23-35 161l1 943q0 119 34 140 16 10 46 13.5t53.5 4.5 41.5 15.5 18 44.5q0 26-12 48t-36 22z"}]}})


/***/ }),
/* 1591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"headphones":{"width":1664,"height":1792,"paths":[{"d":"M1664 886q0 166-60 314l-20 49-185 33q-22 83-90.5 136.5t-156.5 53.5v32q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-576q0-14 9-23t23-9h64q14 0 23 9t9 23v32q71 0 130 35.5t93 95.5l68-12q29-95 29-193 0-148-88-279t-236.5-209-315.5-78-315.5 78-236.5 209-88 279q0 98 29 193l68 12q34-60 93-95.5t130-35.5v-32q0-14 9-23t23-9h64q14 0 23 9t9 23v576q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-32q-88 0-156.5-53.5t-90.5-136.5l-185-33-20-49q-60-148-60-314 0-151 67-291t179-242.5 266-163.5 320-61 320 61 266 163.5 179 242.5 67 291z"}]}})


/***/ }),
/* 1592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"heart-o":{"width":1792,"height":1792,"paths":[{"d":"M1664 596q0-81-21.5-143t-55-98.5-81.5-59.5-94-31-98-8-112 25.5-110.5 64-86.5 72-60 61.5q-18 22-49 22t-49-22q-24-28-60-61.5t-86.5-72-110.5-64-112-25.5-98 8-94 31-81.5 59.5-55 98.5-21.5 143q0 168 187 355l581 560 580-559q188-188 188-356zM1792 596q0 221-229 450l-623 600q-18 18-44 18t-44-18l-624-602q-10-8-27.5-26t-55.5-65.5-68-97.5-53.5-121-23.5-138q0-220 127-344t351-124q62 0 126.5 21.5t120 58 95.5 68.5 76 68q36-36 76-68t95.5-68.5 120-58 126.5-21.5q224 0 351 124t127 344z"}]}})


/***/ }),
/* 1593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"heart":{"width":1792,"height":1792,"paths":[{"d":"M896 1664q-26 0-44-18l-624-602q-10-8-27.5-26t-55.5-65.5-68-97.5-53.5-121-23.5-138q0-220 127-344t351-124q62 0 126.5 21.5t120 58 95.5 68.5 76 68q36-36 76-68t95.5-68.5 120-58 126.5-21.5q224 0 351 124t127 344q0 221-229 450l-623 600q-18 18-44 18z"}]}})


/***/ }),
/* 1594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"heartbeat":{"width":1792,"height":1792,"paths":[{"d":"M1280 1024h305q-5 6-10 10.5t-9 7.5l-3 4-623 600q-18 18-44 18t-44-18l-624-602q-5-2-21-20h369q22 0 39.5-13.5t22.5-34.5l70-281 190 667q6 20 23 33t39 13q21 0 38-13t23-33l146-485 56 112q18 35 57 35zM1792 596q0 145-103 300h-369l-111-221q-8-17-25.5-27t-36.5-8q-45 5-56 46l-129 430-196-686q-6-20-23.5-33t-39.5-13-39 13.5-22 34.5l-116 464h-423q-103-155-103-300 0-220 127-344t351-124q62 0 126.5 21.5t120 58 95.5 68.5 76 68q36-36 76-68t95.5-68.5 120-58 126.5-21.5q224 0 351 124t127 344z"}]}})


/***/ }),
/* 1595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"history":{"width":1536,"height":1792,"paths":[{"d":"M1536 896q0 156-61 298t-164 245-245 164-298 61q-172 0-327-72.5t-264-204.5q-7-10-6.5-22.5t8.5-20.5l137-138q10-9 25-9 16 2 23 12 73 95 179 147t225 52q104 0 198.5-40.5t163.5-109.5 109.5-163.5 40.5-198.5-40.5-198.5-109.5-163.5-163.5-109.5-198.5-40.5q-98 0-188 35.5t-160 101.5l137 138q31 30 14 69-17 40-59 40h-448q-26 0-45-19t-19-45v-448q0-42 40-59 39-17 69 14l130 129q107-101 244.5-156.5t284.5-55.5q156 0 298 61t245 164 164 245 61 298zM896 608v448q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h224v-352q0-14 9-23t23-9h64q14 0 23 9t9 23z"}]}})


/***/ }),
/* 1596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"home":{"width":1664,"height":1792,"paths":[{"d":"M1408 992v480q0 26-19 45t-45 19h-384v-384h-256v384h-384q-26 0-45-19t-19-45v-480q0-1 0.5-3t0.5-3l575-474 575 474q1 2 1 6zM1631 923l-62 74q-8 9-21 11h-3q-13 0-21-7l-692-577-692 577q-12 8-24 7-13-2-21-11l-62-74q-8-10-7-23.5t11-21.5l719-599q32-26 76-26t76 26l244 204v-195q0-14 9-23t23-9h192q14 0 23 9t9 23v408l219 182q10 8 11 21.5t-7 23.5z"}]}})


/***/ }),
/* 1597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"hospital-o":{"width":1408,"height":1792,"paths":[{"d":"M384 1312v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM384 1056v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM640 1056v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM384 800v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM1152 1312v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM896 1056v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM640 800v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM1152 1056v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM896 800v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM1152 800v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM896 1664h384v-1152h-256v32q0 40-28 68t-68 28h-448q-40 0-68-28t-28-68v-32h-256v1152h384v-224q0-13 9.5-22.5t22.5-9.5h320q13 0 22.5 9.5t9.5 22.5v224zM896 480v-320q0-13-9.5-22.5t-22.5-9.5h-64q-13 0-22.5 9.5t-9.5 22.5v96h-128v-96q0-13-9.5-22.5t-22.5-9.5h-64q-13 0-22.5 9.5t-9.5 22.5v320q0 13 9.5 22.5t22.5 9.5h64q13 0 22.5-9.5t9.5-22.5v-96h128v96q0 13 9.5 22.5t22.5 9.5h64q13 0 22.5-9.5t9.5-22.5zM1408 448v1280q0 26-19 45t-45 19h-1280q-26 0-45-19t-19-45v-1280q0-26 19-45t45-19h320v-288q0-40 28-68t68-28h448q40 0 68 28t28 68v288h320q26 0 45 19t19 45z"}]}})


/***/ }),
/* 1598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"hotel":{"width":2048,"height":1792,"paths":[{"d":"M256 1024h1728q26 0 45 19t19 45v448h-256v-256h-1536v256h-256v-1216q0-26 19-45t45-19h128q26 0 45 19t19 45v704zM832 704q0-106-75-181t-181-75-181 75-75 181 75 181 181 75 181-75 75-181zM2048 960v-64q0-159-112.5-271.5t-271.5-112.5h-704q-26 0-45 19t-19 45v384h1152z"}]}})


/***/ }),
/* 1599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"hourglass-1":{"width":1536,"height":1792,"paths":[{"d":"M1408 128q0 261-106.5 461.5t-266.5 306.5q160 106 266.5 306.5t106.5 461.5h96q14 0 23 9t9 23v64q0 14-9 23t-23 9h-1472q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h96q0-261 106.5-461.5t266.5-306.5q-160-106-266.5-306.5t-106.5-461.5h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h1472q14 0 23 9t9 23v64q0 14-9 23t-23 9h-96zM1280 128h-1024q0 66 9 128h1006q9-61 9-128zM1280 1664q0-130-34-249.5t-90.5-208-126.5-152-146-94.5h-230q-76 31-146 94.5t-126.5 152-90.5 208-34 249.5h1024z"}]}})


/***/ }),
/* 1600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"hourglass-2":{"width":1536,"height":1792,"paths":[{"d":"M1408 128q0 261-106.5 461.5t-266.5 306.5q160 106 266.5 306.5t106.5 461.5h96q14 0 23 9t9 23v64q0 14-9 23t-23 9h-1472q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h96q0-261 106.5-461.5t266.5-306.5q-160-106-266.5-306.5t-106.5-461.5h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h1472q14 0 23 9t9 23v64q0 14-9 23t-23 9h-96zM1280 128h-1024q0 206 85 384h854q85-178 85-384zM1223 1344q-54-141-145.5-241.5t-194.5-142.5h-230q-103 42-194.5 142.5t-145.5 241.5h910z"}]}})


/***/ }),
/* 1601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"hourglass-3":{"width":1536,"height":1792,"paths":[{"d":"M1408 128q0 261-106.5 461.5t-266.5 306.5q160 106 266.5 306.5t106.5 461.5h96q14 0 23 9t9 23v64q0 14-9 23t-23 9h-1472q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h96q0-261 106.5-461.5t266.5-306.5q-160-106-266.5-306.5t-106.5-461.5h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h1472q14 0 23 9t9 23v64q0 14-9 23t-23 9h-96zM874 836q77-29 149-92.5t129.5-152.5 92.5-210 35-253h-1024q0 132 35 253t92.5 210 129.5 152.5 149 92.5q19 7 30.5 23.5t11.5 36.5-11.5 36.5-30.5 23.5q-137 51-244 196h700q-107-145-244-196-19-7-30.5-23.5t-11.5-36.5 11.5-36.5 30.5-23.5z"}]}})


/***/ }),
/* 1602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"hourglass-end":{"width":1536,"height":1792,"paths":[{"d":"M1408 128q0 261-106.5 461.5t-266.5 306.5q160 106 266.5 306.5t106.5 461.5h96q14 0 23 9t9 23v64q0 14-9 23t-23 9h-1472q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h96q0-261 106.5-461.5t266.5-306.5q-160-106-266.5-306.5t-106.5-461.5h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h1472q14 0 23 9t9 23v64q0 14-9 23t-23 9h-96zM874 836q77-29 149-92.5t129.5-152.5 92.5-210 35-253h-1024q0 132 35 253t92.5 210 129.5 152.5 149 92.5q19 7 30.5 23.5t11.5 36.5-11.5 36.5-30.5 23.5q-137 51-244 196h700q-107-145-244-196-19-7-30.5-23.5t-11.5-36.5 11.5-36.5 30.5-23.5z"}]}})


/***/ }),
/* 1603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"hourglass-half":{"width":1536,"height":1792,"paths":[{"d":"M1408 128q0 261-106.5 461.5t-266.5 306.5q160 106 266.5 306.5t106.5 461.5h96q14 0 23 9t9 23v64q0 14-9 23t-23 9h-1472q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h96q0-261 106.5-461.5t266.5-306.5q-160-106-266.5-306.5t-106.5-461.5h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h1472q14 0 23 9t9 23v64q0 14-9 23t-23 9h-96zM1280 128h-1024q0 206 85 384h854q85-178 85-384zM1223 1344q-54-141-145.5-241.5t-194.5-142.5h-230q-103 42-194.5 142.5t-145.5 241.5h910z"}]}})


/***/ }),
/* 1604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"hourglass-o":{"width":1536,"height":1792,"paths":[{"d":"M1408 128q0 261-106.5 461.5t-266.5 306.5q160 106 266.5 306.5t106.5 461.5h96q14 0 23 9t9 23v64q0 14-9 23t-23 9h-1472q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h96q0-261 106.5-461.5t266.5-306.5q-160-106-266.5-306.5t-106.5-461.5h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h1472q14 0 23 9t9 23v64q0 14-9 23t-23 9h-96zM874 836q77-29 149-92.5t129.5-152.5 92.5-210 35-253h-1024q0 132 35 253t92.5 210 129.5 152.5 149 92.5q19 7 30.5 23.5t11.5 36.5-11.5 36.5-30.5 23.5q-77 29-149 92.5t-129.5 152.5-92.5 210-35 253h1024q0-132-35-253t-92.5-210-129.5-152.5-149-92.5q-19-7-30.5-23.5t-11.5-36.5 11.5-36.5 30.5-23.5z"}]}})


/***/ }),
/* 1605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"hourglass-start":{"width":1536,"height":1792,"paths":[{"d":"M1408 128q0 261-106.5 461.5t-266.5 306.5q160 106 266.5 306.5t106.5 461.5h96q14 0 23 9t9 23v64q0 14-9 23t-23 9h-1472q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h96q0-261 106.5-461.5t266.5-306.5q-160-106-266.5-306.5t-106.5-461.5h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h1472q14 0 23 9t9 23v64q0 14-9 23t-23 9h-96zM1280 128h-1024q0 66 9 128h1006q9-61 9-128zM1280 1664q0-130-34-249.5t-90.5-208-126.5-152-146-94.5h-230q-76 31-146 94.5t-126.5 152-90.5 208-34 249.5h1024z"}]}})


/***/ }),
/* 1606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"hourglass":{"width":1536,"height":1792,"paths":[{"d":"M1504 1600q14 0 23 9t9 23v128q0 14-9 23t-23 9h-1472q-14 0-23-9t-9-23v-128q0-14 9-23t23-9h1472zM130 1536q3-55 16-107t30-95 46-87 53.5-76 64.5-69.5 66-60 70.5-55 66.5-47.5 65-43q-43-28-65-43t-66.5-47.5-70.5-55-66-60-64.5-69.5-53.5-76-46-87-30-95-16-107h1276q-3 55-16 107t-30 95-46 87-53.5 76-64.5 69.5-66 60-70.5 55-66.5 47.5-65 43q43 28 65 43t66.5 47.5 70.5 55 66 60 64.5 69.5 53.5 76 46 87 30 95 16 107h-1276zM1504 0q14 0 23 9t9 23v128q0 14-9 23t-23 9h-1472q-14 0-23-9t-9-23v-128q0-14 9-23t23-9h1472z"}]}})


/***/ }),
/* 1607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"houzz":{"width":1024,"height":1792,"paths":[{"d":"M512 1191l512-295v591l-512 296v-592zM0 896v591l512-296zM512 9v591l-512 296v-591zM512 600l512-295v591z"}]}})


/***/ }),
/* 1608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"html5":{"width":1408,"height":1792,"paths":[{"d":"M1130 597l16-175h-884l47 534h612l-22 228-197 53-196-53-13-140h-175l22 278 362 100h4v-1l359-99 50-544h-644l-15-181h674zM0 128h1408l-128 1438-578 162-574-162z"}]}})


/***/ }),
/* 1609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"i-cursor":{"width":1024,"height":1792,"paths":[{"d":"M832 128q-320 0-320 224v416h128v128h-128v544q0 224 320 224h64v128h-64q-272 0-384-146-112 146-384 146h-64v-128h64q320 0 320-224v-544h-128v-128h128v-416q0-224-320-224h-64v-128h64q272 0 384 146 112-146 384-146h64v128h-64z"}]}})


/***/ }),
/* 1610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"id-badge":{"width":1280,"height":1792,"paths":[{"d":"M1024 1258q0 64-37 107t-91 43h-512q-54 0-91-43t-37-107 9-118 29.5-104 61-78.5 96.5-28.5q80 75 188 75t188-75q56 0 96.5 28.5t61 78.5 29.5 104 9 118zM870 739q0 94-67.5 160.5t-162.5 66.5-162.5-66.5-67.5-160.5 67.5-160.5 162.5-66.5 162.5 66.5 67.5 160.5zM1152 1632v-1376h-1024v1376q0 13 9.5 22.5t22.5 9.5h960q13 0 22.5-9.5t9.5-22.5zM1280 160v1472q0 66-47 113t-113 47h-960q-66 0-113-47t-47-113v-1472q0-66 47-113t113-47h352v96q0 14 9 23t23 9h192q14 0 23-9t9-23v-96h352q66 0 113 47t47 113z"}]}})


/***/ }),
/* 1611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"id-card-o":{"width":2048,"height":1792,"paths":[{"d":"M896 1212q0 55-31.5 93.5t-75.5 38.5h-426q-44 0-75.5-38.5t-31.5-93.5q0-54 7.5-100.5t24.5-90 51-68.5 81-25q64 64 156 64t156-64q47 0 81 25t51 68.5 24.5 90 7.5 100.5zM768 768q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM1792 1184v64q0 14-9 23t-23 9h-704q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h704q14 0 23 9t9 23zM1408 928v64q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h320q14 0 23 9t9 23zM1792 928v64q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h192q14 0 23 9t9 23zM1792 672v64q0 14-9 23t-23 9h-704q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h704q14 0 23 9t9 23zM1920 1504v-1120h-1792v1120q0 13 9.5 22.5t22.5 9.5h1728q13 0 22.5-9.5t9.5-22.5zM2048 288v1216q0 66-47 113t-113 47h-1728q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1728q66 0 113 47t47 113z"}]}})


/***/ }),
/* 1612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"id-card":{"width":2048,"height":1792,"paths":[{"d":"M896 1212q0-54-7.5-100.5t-24.5-90-51-68.5-81-25q-64 64-156 64t-156-64q-47 0-81 25t-51 68.5-24.5 90-7.5 100.5q0 55 31.5 93.5t75.5 38.5h426q44 0 75.5-38.5t31.5-93.5zM768 768q0-80-56-136t-136-56-136 56-56 136 56 136 136 56 136-56 56-136zM1792 1248v-64q0-14-9-23t-23-9h-704q-14 0-23 9t-9 23v64q0 14 9 23t23 9h704q14 0 23-9t9-23zM1408 992v-64q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v64q0 14 9 23t23 9h320q14 0 23-9t9-23zM1792 992v-64q0-14-9-23t-23-9h-192q-14 0-23 9t-9 23v64q0 14 9 23t23 9h192q14 0 23-9t9-23zM1792 736v-64q0-14-9-23t-23-9h-704q-14 0-23 9t-9 23v64q0 14 9 23t23 9h704q14 0 23-9t9-23zM128 384h1792v-96q0-14-9-23t-23-9h-1728q-14 0-23 9t-9 23v96zM2048 288v1216q0 66-47 113t-113 47h-1728q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1728q66 0 113 47t47 113z"}]}})


/***/ }),
/* 1613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"ils":{"width":1536,"height":1792,"paths":[{"d":"M992 624v496q0 14-9 23t-23 9h-160q-14 0-23-9t-9-23v-496q0-112-80-192t-192-80h-272v1152q0 14-9 23t-23 9h-160q-14 0-23-9t-9-23v-1344q0-14 9-23t23-9h464q135 0 249 66.5t180.5 180.5 66.5 249zM1376 160v880q0 135-66.5 249t-180.5 180.5-249 66.5h-464q-14 0-23-9t-9-23v-960q0-14 9-23t23-9h160q14 0 23 9t9 23v768h272q112 0 192-80t80-192v-880q0-14 9-23t23-9h160q14 0 23 9t9 23z"}]}})


/***/ }),
/* 1614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"image":{"width":1920,"height":1792,"paths":[{"d":"M640 576q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM1664 960v448h-1408v-192l320-320 160 160 512-512zM1760 256h-1600q-13 0-22.5 9.5t-9.5 22.5v1216q0 13 9.5 22.5t22.5 9.5h1600q13 0 22.5-9.5t9.5-22.5v-1216q0-13-9.5-22.5t-22.5-9.5zM1920 288v1216q0 66-47 113t-113 47h-1600q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1600q66 0 113 47t47 113z"}]}})


/***/ }),
/* 1615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"imdb":{"width":1536,"height":1792,"paths":[{"d":"M922 797v182q0 4 0.5 15t0 15l-1.5 12t-3.5 11.5-6.5 7.5-11 5.5-16 1.5v-309q9 0 16 1t11 5 6.5 5.5 3.5 9.5 1 10.5v13.5 14zM1238 893v121q0 1 0.5 12.5t0 15.5-2.5 11.5-7.5 10.5-13.5 3q-9 0-14-9-4-10-4-165v-7-8.5-9t1.5-8.5l3.5-7t5-5.5 8-1.5q6 0 10 1.5t6.5 4.5 4 6 2 8.5 0.5 8v9.5 9zM180 1129h122v-472h-122v472zM614 1129h106v-472h-159l-28 221q-20-148-32-221h-158v472h107v-312l45 312h76l43-319v319zM1039 824q0-67-5-90-3-16-11-28.5t-17-20.5-25-14-26.5-8.5-31-4-29-1.5h-29.5-12-91v472h56q169 1 197-24.5t25-180.5q-1-62-1-100zM1356 1021v-133q0-29-2-45t-9.5-33.5-24.5-25-46-7.5q-46 0-77 34v-154h-117v472h110l7-30q30 36 77 36 50 0 66-30.5t16-83.5zM1536 288v1216q0 66-47 113t-113 47h-1216q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1216q66 0 113 47t47 113z"}]}})


/***/ }),
/* 1616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"inbox":{"width":1536,"height":1792,"paths":[{"d":"M1023 960h316q-1-3-2.5-8.5t-2.5-7.5l-212-496h-708l-212 496q-1 3-2.5 8.5t-2.5 7.5h316l95 192h320zM1536 990v482q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-482q0-62 25-123l238-552q10-25 36.5-42t52.5-17h832q26 0 52.5 17t36.5 42l238 552q25 61 25 123z"}]}})


/***/ }),
/* 1617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"indent":{"width":1792,"height":1792,"paths":[{"d":"M352 832q0 14-9 23l-288 288q-9 9-23 9-13 0-22.5-9.5t-9.5-22.5v-576q0-13 9.5-22.5t22.5-9.5q14 0 23 9l288 288q9 9 9 23zM1792 1312v192q0 13-9.5 22.5t-22.5 9.5h-1728q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1728q13 0 22.5 9.5t9.5 22.5zM1792 928v192q0 13-9.5 22.5t-22.5 9.5h-1088q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1088q13 0 22.5 9.5t9.5 22.5zM1792 544v192q0 13-9.5 22.5t-22.5 9.5h-1088q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1088q13 0 22.5 9.5t9.5 22.5zM1792 160v192q0 13-9.5 22.5t-22.5 9.5h-1728q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1728q13 0 22.5 9.5t9.5 22.5z"}]}})


/***/ }),
/* 1618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"industry":{"width":1792,"height":1792,"paths":[{"d":"M448 0q26 0 45 19t19 45v891l536-429q17-14 40-14 26 0 45 19t19 45v379l536-429q17-14 40-14 26 0 45 19t19 45v1152q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-1664q0-26 19-45t45-19h384z"}]}})


/***/ }),
/* 1619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"info-circle":{"width":1536,"height":1792,"paths":[{"d":"M1024 1376v-160q0-14-9-23t-23-9h-96v-512q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v160q0 14 9 23t23 9h96v320h-96q-14 0-23 9t-9 23v160q0 14 9 23t23 9h448q14 0 23-9t9-23zM896 480v-160q0-14-9-23t-23-9h-192q-14 0-23 9t-9 23v160q0 14 9 23t23 9h192q14 0 23-9t9-23zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"info":{"width":640,"height":1792,"paths":[{"d":"M640 1344v128q0 26-19 45t-45 19h-512q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h64v-384h-64q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h384q26 0 45 19t19 45v576h64q26 0 45 19t19 45zM512 192v192q0 26-19 45t-45 19h-256q-26 0-45-19t-19-45v-192q0-26 19-45t45-19h256q26 0 45 19t19 45z"}]}})


/***/ }),
/* 1621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"inr":{"width":898,"height":1792,"paths":[{"d":"M898 470v102q0 14-9 23t-23 9h-168q-23 144-129 234t-276 110q167 178 459 536 14 16 4 34-8 18-29 18h-195q-16 0-25-12-306-367-498-571-9-9-9-22v-127q0-13 9.5-22.5t22.5-9.5h112q132 0 212.5-43t102.5-125h-427q-14 0-23-9t-9-23v-102q0-14 9-23t23-9h413q-57-113-268-113h-145q-13 0-22.5-9.5t-9.5-22.5v-133q0-14 9-23t23-9h832q14 0 23 9t9 23v102q0 14-9 23t-23 9h-233q47 61 64 144h171q14 0 23 9t9 23z"}]}})


/***/ }),
/* 1622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"instagram":{"width":1536,"height":1792,"paths":[{"d":"M1024 896q0-106-75-181t-181-75-181 75-75 181 75 181 181 75 181-75 75-181zM1162 896q0 164-115 279t-279 115-279-115-115-279 115-279 279-115 279 115 115 279zM1270 486q0 38-27 65t-65 27-65-27-27-65 27-65 65-27 65 27 27 65zM768 266q-7 0-76.5-0.5t-105.5 0-96.5 3-103 10-71.5 18.5q-50 20-88 58t-58 88q-11 29-18.5 71.5t-10 103-3 96.5 0 105.5 0.5 76.5-0.5 76.5 0 105.5 3 96.5 10 103 18.5 71.5q20 50 58 88t88 58q29 11 71.5 18.5t103 10 96.5 3 105.5 0 76.5-0.5 76.5 0.5 105.5 0 96.5-3 103-10 71.5-18.5q50-20 88-58t58-88q11-29 18.5-71.5t10-103 3-96.5 0-105.5-0.5-76.5 0.5-76.5 0-105.5-3-96.5-10-103-18.5-71.5q-20-50-58-88t-88-58q-29-11-71.5-18.5t-103-10-96.5-3-105.5 0-76.5 0.5zM1536 896q0 229-5 317-10 208-124 322t-322 124q-88 5-317 5t-317-5q-208-10-322-124t-124-322q-5-88-5-317t5-317q10-208 124-322t322-124q88-5 317-5t317 5q208 10 322 124t124 322q5 88 5 317z"}]}})


/***/ }),
/* 1623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"institution":{"width":2048,"height":1792,"paths":[{"d":"M960 0l960 384v128h-128q0 26-20.5 45t-48.5 19h-1526q-28 0-48.5-19t-20.5-45h-128v-128zM256 640h256v768h128v-768h256v768h128v-768h256v768h128v-768h256v768h59q28 0 48.5 19t20.5 45v64h-1664v-64q0-26 20.5-45t48.5-19h59v-768zM1851 1600q28 0 48.5 19t20.5 45v128h-1920v-128q0-26 20.5-45t48.5-19h1782z"}]}})


/***/ }),
/* 1624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"internet-explorer":{"width":1792,"height":1792,"paths":[{"d":"M1792 937q0 56-7 104h-1151q0 146 109.5 244.5t257.5 98.5q99 0 185.5-46.5t136.5-130.5h423q-56 159-170.5 281t-267.5 188.5-321 66.5q-187 0-356-83-228 116-394 116-237 0-237-263 0-115 45-275 17-60 109-229 199-360 475-606-184 79-427 354 63-274 283.5-449.5t501.5-175.5q30 0 45 1 255-117 433-117 64 0 116 13t94.5 40.5 66.5 76.5 24 115q0 116-75 286 101 182 101 390zM1722 297q0-83-53-132t-137-49q-108 0-254 70 121 47 222.5 131.5t170.5 195.5q51-135 51-216zM128 1534q0 86 48.5 132.5t134.5 46.5q115 0 266-83-122-72-213.5-183t-137.5-245q-98 205-98 332zM632 821h728q-5-142-113-237t-251-95q-144 0-251.5 95t-112.5 237z"}]}})


/***/ }),
/* 1625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"intersex":{"width":1536,"height":1792,"paths":[{"d":"M1024 32q0-14 9-23t23-9h288q26 0 45 19t19 45v288q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-134l-254 255q126 158 126 359 0 221-147.5 384.5t-364.5 187.5v132h96q14 0 23 9t9 23v64q0 14-9 23t-23 9h-96v96q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-96h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h96v-132q-149-16-270.5-103t-186.5-223.5-53-291.5q16-204 160-353.5t347-172.5q118-14 228 19t198 103l255-254h-134q-14 0-23-9t-9-23v-64zM576 1280q185 0 316.5-131.5t131.5-316.5-131.5-316.5-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5z"}]}})


/***/ }),
/* 1626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"ioxhost":{"width":2048,"height":1792,"paths":[{"d":"M1463 832q0 35-25 60.5t-61 25.5h-702q-36 0-61-25.5t-25-60.5 25-60.5 61-25.5h702q36 0 61 25.5t25 60.5zM1677 832q0-86-23-170h-982q-36 0-61-25t-25-60q0-36 25-61t61-25h908q-88-143-235-227t-320-84q-177 0-327.5 87.5t-238 237.5-87.5 327q0 86 23 170h982q36 0 61 25t25 60q0 36-25 61t-61 25h-908q88 143 235.5 227t320.5 84q132 0 253-51.5t208-139 139-208 52-253.5zM2048 577q0 35-25 60t-61 25h-131q17 85 17 170 0 167-65.5 319.5t-175.5 263-262.5 176-319.5 65.5q-246 0-448.5-133t-301.5-350h-189q-36 0-61-25t-25-61q0-35 25-60t61-25h132q-17-85-17-170 0-167 65.5-319.5t175.5-263 262.5-176 320.5-65.5q245 0 447.5 133t301.5 350h188q36 0 61 25t25 61z"}]}})


/***/ }),
/* 1627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"italic":{"width":1024,"height":1792,"paths":[{"d":"M0 1662l17-85q22-7 61.5-16.5t72-19 59.5-23.5q28-35 41-101 1-7 62-289t114-543.5 52-296.5v-25q-24-13-54.5-18.5t-69.5-8-58-5.5l19-103q33 2 120 6.5t149.5 7 120.5 2.5q48 0 98.5-2.5t121-7 98.5-6.5q-5 39-19 89-30 10-101.5 28.5t-108.5 33.5q-8 19-14 42.5t-9 40-7.5 45.5-6.5 42q-27 148-87.5 419.5t-77.5 355.5q-2 9-13 58t-20 90-16 83.5-6 57.5l1 18q17 4 185 31-3 44-16 99-11 0-32.5 1.5t-32.5 1.5q-29 0-87-10t-86-10q-138-2-206-2-51 0-143 9t-121 11z"}]}})


/***/ }),
/* 1628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"joomla":{"width":1536,"height":1792,"paths":[{"d":"M1070 1073l-160 160-151 152-30 30q-65 64-151.5 87t-171.5 2q-16 70-72 115t-129 45q-85 0-145-60.5t-60-145.5q0-72 44.5-128t113.5-72q-22-86 1-173t88-152l12-12 151 152-11 11q-37 37-37 89t37 90q37 37 89 37t89-37l30-30 151-152 161-160zM729 391l12 12-152 152-12-12q-37-37-89-37t-89 37-37 89.5 37 89.5l29 29 152 152 160 160-151 152-161-160-151-152-30-30q-68-67-90-159.5t5-179.5q-70-15-115-71t-45-129q0-85 60-145.5t145-60.5q76 0 133.5 49t69.5 123q84-20 169.5 3.5t149.5 87.5zM1536 1458q0 85-60 145.5t-145 60.5q-74 0-131-47t-71-118q-86 28-179.5 6t-161.5-90l-11-12 151-152 12 12q37 37 89 37t89-37 37-89-37-89l-30-30-152-152-160-160 152-152 160 160 152 152 29 30q64 64 87.5 150.5t2.5 171.5q76 11 126.5 68.5t50.5 134.5zM1534 334q0 77-51 135t-127 69q26 85 3 176.5t-90 158.5l-12 12-151-152 12-12q37-37 37-89t-37-89-89-37-89 37l-30 30-152 152-160 160-152-152 161-160 152-152 29-30q67-67 159-89.5t178 3.5q11-75 68.5-126t135.5-51q85 0 145 60.5t60 145.5z"}]}})


/***/ }),
/* 1629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"jpy":{"width":1027,"height":1792,"paths":[{"d":"M603 1536h-172q-13 0-22.5-9t-9.5-23v-330h-288q-13 0-22.5-9t-9.5-23v-103q0-13 9.5-22.5t22.5-9.5h288v-85h-288q-13 0-22.5-9t-9.5-23v-104q0-13 9.5-22.5t22.5-9.5h214l-321-578q-8-16 0-32 10-16 28-16h194q19 0 29 18l215 425q19 38 56 125 10-24 30.5-68t27.5-61l191-420q8-19 29-19h191q17 0 27 16 9 14 1 31l-313 579h215q13 0 22.5 9.5t9.5 22.5v104q0 14-9.5 23t-22.5 9h-290v85h290q13 0 22.5 9.5t9.5 22.5v103q0 14-9.5 23t-22.5 9h-290v330q0 13-9.5 22.5t-22.5 9.5z"}]}})


/***/ }),
/* 1630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"jsfiddle":{"width":2048,"height":1792,"paths":[{"d":"M1800 772q111 46 179.5 145.5t68.5 221.5q0 164-118 280.5t-285 116.5q-4 0-11.5-0.5t-10.5-0.5h-1209-1-2-5q-170-10-288-125.5t-118-280.5q0-110 55-203t147-147q-12-39-12-82 0-115 82-196t199-81q95 0 172 58 75-154 222.5-248t326.5-94q166 0 306 80.5t221.5 218.5 81.5 301q0 6-0.5 18t-0.5 18zM468 1038q0 122 84 193t208 71q137 0 240-99-16-20-47.5-56.5t-43.5-50.5q-67 65-144 65-55 0-93.5-33.5t-38.5-87.5q0-53 38.5-87t91.5-34q44 0 84.5 21t73 55 65 75 69 82 77 75 97 55 121.5 21q121 0 204.5-71.5t83.5-190.5q0-121-84-192t-207-71q-143 0-241 97l93 108q66-64 142-64 52 0 92 33t40 84q0 57-37 91.5t-94 34.5q-43 0-82.5-21t-72-55-65.5-75-69.5-82-77.5-75-96.5-55-118.5-21q-122 0-207 70.5t-85 189.5z"}]}})


/***/ }),
/* 1631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"key":{"width":1792,"height":1792,"paths":[{"d":"M832 512q0-80-56-136t-136-56-136 56-56 136q0 42 19 83-41-19-83-19-80 0-136 56t-56 136 56 136 136 56 136-56 56-136q0-42-19-83 41 19 83 19 80 0 136-56t56-136zM1683 1216q0 17-49 66t-66 49q-9 0-28.5-16t-36.5-33-38.5-40-24.5-26l-96 96 220 220q28 28 28 68 0 42-39 81t-81 39q-40 0-68-28l-671-671q-176 131-365 131-163 0-265.5-102.5t-102.5-265.5q0-160 95-313t248-248 313-95q163 0 265.5 102.5t102.5 265.5q0 189-131 365l355 355 96-96q-3-3-26-24.5t-40-38.5-33-36.5-16-28.5q0-17 49-66t66-49q13 0 23 10 6 6 46 44.5t82 79.5 86.5 86 73 78 28.5 41z"}]}})


/***/ }),
/* 1632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"keyboard-o":{"width":1920,"height":1792,"paths":[{"d":"M384 1168v96q0 16-16 16h-96q-16 0-16-16v-96q0-16 16-16h96q16 0 16 16zM512 912v96q0 16-16 16h-224q-16 0-16-16v-96q0-16 16-16h224q16 0 16 16zM384 656v96q0 16-16 16h-96q-16 0-16-16v-96q0-16 16-16h96q16 0 16 16zM1408 1168v96q0 16-16 16h-864q-16 0-16-16v-96q0-16 16-16h864q16 0 16 16zM768 912v96q0 16-16 16h-96q-16 0-16-16v-96q0-16 16-16h96q16 0 16 16zM640 656v96q0 16-16 16h-96q-16 0-16-16v-96q0-16 16-16h96q16 0 16 16zM1024 912v96q0 16-16 16h-96q-16 0-16-16v-96q0-16 16-16h96q16 0 16 16zM896 656v96q0 16-16 16h-96q-16 0-16-16v-96q0-16 16-16h96q16 0 16 16zM1280 912v96q0 16-16 16h-96q-16 0-16-16v-96q0-16 16-16h96q16 0 16 16zM1664 1168v96q0 16-16 16h-96q-16 0-16-16v-96q0-16 16-16h96q16 0 16 16zM1152 656v96q0 16-16 16h-96q-16 0-16-16v-96q0-16 16-16h96q16 0 16 16zM1408 656v96q0 16-16 16h-96q-16 0-16-16v-96q0-16 16-16h96q16 0 16 16zM1664 656v352q0 16-16 16h-224q-16 0-16-16v-96q0-16 16-16h112v-240q0-16 16-16h96q16 0 16 16zM1792 1408v-896h-1664v896h1664zM1920 512v896q0 53-37.5 90.5t-90.5 37.5h-1664q-53 0-90.5-37.5t-37.5-90.5v-896q0-53 37.5-90.5t90.5-37.5h1664q53 0 90.5 37.5t37.5 90.5z"}]}})


/***/ }),
/* 1633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"krw":{"width":1792,"height":1792,"paths":[{"d":"M514 1195l81-299h-159l75 300q1 1 1 3t1 3q0-1 0.5-3.5t0.5-3.5zM630 768l35-128h-292l32 128h225zM822 768h139l-35-128h-70zM1271 1196l78-300h-162l81 299q0 1 0.5 3.5t1.5 3.5q0-1 0.5-3t0.5-3zM1382 768l33-128h-297l34 128h230zM1792 800v64q0 14-9 23t-23 9h-213l-164 616q-7 24-31 24h-159q-24 0-31-24l-166-616h-209l-167 616q-7 24-31 24h-159q-11 0-19.5-7t-10.5-17l-160-616h-208q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h175l-33-128h-142q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h109l-89-344q-5-15 5-28 10-12 26-12h137q26 0 31 24l90 360h359l97-360q7-24 31-24h126q24 0 31 24l98 360h365l93-360q5-24 31-24h137q16 0 26 12 10 13 5 28l-91 344h111q14 0 23 9t9 23v64q0 14-9 23t-23 9h-145l-34 128h179q14 0 23 9t9 23z"}]}})


/***/ }),
/* 1634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"language":{"width":1536,"height":1792,"paths":[{"d":"M654 1078q-1 3-12.5-0.5t-31.5-11.5l-20-9q-44-20-87-49-7-5-41-31.5t-38-28.5q-67 103-134 181-81 95-105 110-4 2-19.5 4t-18.5 0q6-4 82-92 21-24 85.5-115t78.5-118q17-30 51-98.5t36-77.5q-8-1-110 33-8 2-27.5 7.5t-34.5 9.5-17 5q-2 2-2 10.5t-1 9.5q-5 10-31 15-23 7-47 0-18-4-28-21-4-6-5-23 6-2 24.5-5t29.5-6q58-16 105-32 100-35 102-35 10-2 43-19.5t44-21.5q9-3 21.5-8t14.5-5.5 6 0.5q2 12-1 33 0 2-12.5 27t-26.5 53.5-17 33.5q-25 50-77 131l64 28q12 6 74.5 32t67.5 28q4 1 10.5 25.5t4.5 30.5zM449 592q3 15-4 28-12 23-50 38-30 12-60 12-26-3-49-26-14-15-18-41l1-3q3 3 19.5 5t26.5 0 58-16q36-12 55-14 17 0 21 17zM1147 721l63 227-139-42zM39 1521l694-232v-1032l-694 233v1031zM1280 1204l102 31-181-657-100-31-216 536 102 31 45-110 211 65zM777 242l573 184v-380zM1088 1565l158 13-54 160-40-66q-130 83-276 108-58 12-91 12h-84q-79 0-199.5-39t-183.5-85q-8-7-8-16 0-8 5-13.5t13-5.5q4 0 18 7.5t30.5 16.5 20.5 11q73 37 159.5 61.5t157.5 24.5q95 0 167-14.5t157-50.5q15-7 30.5-15.5t34-19 28.5-16.5zM1536 486v1079l-774-246q-14 6-375 127.5t-368 121.5q-13 0-18-13 0-1-1-3v-1078q3-9 4-10 5-6 20-11 107-36 149-50v-384l558 198q2 0 160.5-55t316-108.5 161.5-53.5q20 0 20 21v418z"}]}})


/***/ }),
/* 1635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"laptop":{"width":1920,"height":1792,"paths":[{"d":"M416 1280q-66 0-113-47t-47-113v-704q0-66 47-113t113-47h1088q66 0 113 47t47 113v704q0 66-47 113t-113 47h-1088zM384 416v704q0 13 9.5 22.5t22.5 9.5h1088q13 0 22.5-9.5t9.5-22.5v-704q0-13-9.5-22.5t-22.5-9.5h-1088q-13 0-22.5 9.5t-9.5 22.5zM1760 1344h160v96q0 40-47 68t-113 28h-1600q-66 0-113-28t-47-68v-96h160 1600zM1040 1440q16 0 16-16t-16-16h-160q-16 0-16 16t16 16h160z"}]}})


/***/ }),
/* 1636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"lastfm-square":{"width":1536,"height":1792,"paths":[{"d":"M1432 1052q0-173-234-239-35-10-53-16.5t-38-25-29-46.5q0-2-2-8.5t-3-12-1-7.5q0-36 24.5-59.5t60.5-23.5q54 0 71 15h-1q20 15 39 51l93-71q-39-54-49-64-33-29-67.5-39t-85.5-10q-80 0-142 57.5t-62 137.5q0 7 2 23 16 96 64.5 140t148.5 73q29 8 49 15.5t45 21.5 38.5 34.5 13.5 46.5v5q1 58-40.5 93t-100.5 35q-97 0-167-144-23-47-51.5-121.5t-48-125.5-54-110.5-74-95.5-103.5-60.5-147-24.5q-101 0-192 56t-144 148-50 192v1q4 108 50.5 199t133.5 147.5 196 56.5q186 0 279-110 20-27 31-51l-60-109q-42 80-99 116t-146 36q-115 0-191-87t-76-204q0-105 82-189t186-84q112 0 170 53.5t104 172.5q8 21 25.5 68.5t28.5 76.5 31.5 74.5 38.5 74 45.5 62.5 55.5 53.5 66 33 80 13.5q107 0 183-69.5t76-174.5zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 1637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"lastfm":{"width":1792,"height":1792,"paths":[{"d":"M1292 704q0 6 10 41 10 29 25 49.5t41 34 44 20 55 16.5q325 91 325 332 0 146-105.5 242.5t-254.5 96.5q-59 0-111.5-18.5t-91.5-45.5-77-74.5-63-87.5-53.5-103.5-43.5-103-39.5-106.5-35.5-95q-32-81-61.5-133.5t-73.5-96.5-104-64-142-20q-96 0-183 55.5t-138 144.5-51 185q0 160 106.5 279.5t263.5 119.5q177 0 258-95 56-63 83-116l84 152q-15 34-44 70l1 1q-131 152-388 152-147 0-269.5-79t-190.5-207.5-68-274.5q0-105 43.5-206t116-176.5 172-121.5 204.5-46q87 0 159 19t123.5 50 95 80 72.5 99 58.5 117 50.5 124.5 50 130.5 55 127q96 200 233 200 81 0 138.5-48.5t57.5-128.5q0-42-19-72t-50.5-46-72.5-31.5-84.5-27-87.5-34-81-52-65-82-39-122.5q-3-16-3-33 0-110 87.5-192t198.5-78q78 3 120.5 14.5t90.5 53.5h-1q12 11 23 24.5t26 36 19 27.5l-129 99q-26-49-54-70v-1q-23-21-97-21-49 0-84 33t-35 83z"}]}})


/***/ }),
/* 1638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"leaf":{"width":1792,"height":1792,"paths":[{"d":"M1280 704q0-26-19-45t-45-19q-172 0-318 49.5t-259.5 134-235.5 219.5q-19 21-19 45 0 26 19 45t45 19q24 0 45-19 27-24 74-71t67-66q137-124 268.5-176t313.5-52q26 0 45-19t19-45zM1792 506q0 95-20 193-46 224-184.5 383t-357.5 268q-214 108-438 108-148 0-286-47-15-5-88-42t-96-37q-16 0-39.5 32t-45 70-52.5 70-60 32q-43 0-63.5-17.5t-45.5-59.5q-2-4-6-11t-5.5-10-3-9.5-1.5-13.5q0-35 31-73.5t68-65.5 68-56 31-48q0-4-14-38t-16-44q-9-51-9-104 0-115 43.5-220t119-184.5 170.5-139 204-95.5q55-18 145-25.5t179.5-9 178.5-6 163.5-24 113.5-56.5l29.5-29.5t29.5-28 27-20 36.5-16 43.5-4.5q39 0 70.5 46t47.5 112 24 124 8 96z"}]}})


/***/ }),
/* 1639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"leanpub":{"width":2048,"height":1792,"paths":[{"d":"M1893 392l155 1272q-131 0-257-57-200-91-393-91-226 0-374 148-148-148-374-148-193 0-393 91-128 57-252 57h-5l155-1272q224-127 482-127 233 0 387 106 154-106 387-106 258 0 482 127zM1398 1379q129 0 232 28.5t260 93.5l-124-1021q-171-78-368-78-224 0-374 141-150-141-374-141-197 0-368 78l-124 1021q105-43 165.5-65t148.5-39.5 178-17.5q202 0 374 108 172-108 374-108zM1438 1345l-55-907q-211 4-359 155-152-155-374-155-176 0-336 66l-114 941q124-51 228.5-76t221.5-25q209 0 374 102 172-107 374-102z"}]}})


/***/ }),
/* 1640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"legal":{"width":1792,"height":1792,"paths":[{"d":"M1771 1536q0 53-37 90l-107 108q-39 37-91 37-53 0-90-37l-363-364q-38-36-38-90 0-53 43-96l-256-256-126 126q-14 14-34 14t-34-14q2 2 12.5 12t12.5 13 10 11.5 10 13.5 6 13.5 5.5 16.5 1.5 18q0 38-28 68-3 3-16.5 18t-19 20.5-18.5 16.5-22 15.5-22 9-26 4.5q-40 0-68-28l-408-408q-28-28-28-68 0-13 4.5-26t9-22 15.5-22 16.5-18.5 20.5-19 18-16.5q30-28 68-28 10 0 18 1.5t16.5 5.5 13.5 6 13.5 10 11.5 10 13 12.5 12 12.5q-14-14-14-34t14-34l348-348q14-14 34-14t34 14q-2-2-12.5-12t-12.5-13-10-11.5-10-13.5-6-13.5-5.5-16.5-1.5-18q0-38 28-68 3-3 16.5-18t19-20.5 18.5-16.5 22-15.5 22-9 26-4.5q40 0 68 28l408 408q28 28 28 68 0 13-4.5 26t-9 22-15.5 22-16.5 18.5-20.5 19-18 16.5q-30 28-68 28-10 0-18-1.5t-16.5-5.5-13.5-6-13.5-10-11.5-10-13-12.5-12-12.5q14 14 14 34t-14 34l-126 126 256 256q43-43 96-43 52 0 91 37l363 363q37 39 37 91z"}]}})


/***/ }),
/* 1641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"lemon-o":{"width":1536,"height":1792,"paths":[{"d":"M1407 826q0-44-7-113.5t-18-96.5q-12-30-17-44t-9-36.5-4-48.5q0-23 5-68.5t5-67.5q0-37-10-55-4-1-13-1-19 0-58 4.5t-59 4.5q-60 0-176-24t-175-24q-43 0-94.5 11.5t-85 23.5-89.5 34q-137 54-202 103-96 73-159.5 189.5t-88 236-24.5 248.5q0 40 12.5 120t12.5 121q0 23-11 66.5t-11 65.5 12 36.5 34 14.5q24 0 72.5-11t73.5-11q57 0 169.5 15.5t169.5 15.5q181 0 284-36 129-45 235.5-152.5t166-245.5 59.5-275zM1535 824q0 165-70 327.5t-196 288-281 180.5q-124 44-326 44-57 0-170-14.5t-169-14.5q-24 0-72.5 14.5t-73.5 14.5q-73 0-123.5-55.5t-50.5-128.5q0-24 11-68t11-67q0-40-12.5-120.5t-12.5-121.5q0-111 18-217.5t54.5-209.5 100.5-194 150-156q78-59 232-120 194-78 316-78 60 0 175.5 24t173.5 24q19 0 57-5t58-5q81 0 118 50.5t37 134.5q0 23-5 68t-5 68q0 13 2 25t3.5 16.5 7.5 20.5 8 20q16 40 25 118.5t9 136.5z"}]}})


/***/ }),
/* 1642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"level-down":{"width":1024,"height":1792,"paths":[{"d":"M32 256h704q13 0 22.5 9.5t9.5 23.5v863h192q40 0 58 37t-9 69l-320 384q-18 22-49 22t-49-22l-320-384q-26-31-9-69 18-37 58-37h192v-640h-320q-14 0-25-11l-160-192q-13-14-4-34 9-19 29-19z"}]}})


/***/ }),
/* 1643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"level-up":{"width":1024,"height":1792,"paths":[{"d":"M1018 603q-18 37-58 37h-192v864q0 14-9 23t-23 9h-704q-21 0-29-18-8-20 4-35l160-192q9-11 25-11h320v-640h-192q-40 0-58-37-17-37 9-68l320-384q18-22 49-22t49 22l320 384q27 32 9 68z"}]}})


/***/ }),
/* 1644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"life-bouy":{"width":1792,"height":1792,"paths":[{"d":"M896 0q182 0 348 71t286 191 191 286 71 348-71 348-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71zM896 128q-190 0-361 90l194 194q82-28 167-28t167 28l194-194q-171-90-361-90zM218 1257l194-194q-28-82-28-167t28-167l-194-194q-90 171-90 361t90 361zM896 1664q190 0 361-90l-194-194q-82 28-167 28t-167-28l-194 194q171 90 361 90zM896 1280q159 0 271.5-112.5t112.5-271.5-112.5-271.5-271.5-112.5-271.5 112.5-112.5 271.5 112.5 271.5 271.5 112.5zM1380 1063l194 194q90-171 90-361t-90-361l-194 194q28 82 28 167t-28 167z"}]}})


/***/ }),
/* 1645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"life-buoy":{"width":1792,"height":1792,"paths":[{"d":"M896 0q182 0 348 71t286 191 191 286 71 348-71 348-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71zM896 128q-190 0-361 90l194 194q82-28 167-28t167 28l194-194q-171-90-361-90zM218 1257l194-194q-28-82-28-167t28-167l-194-194q-90 171-90 361t90 361zM896 1664q190 0 361-90l-194-194q-82 28-167 28t-167-28l-194 194q171 90 361 90zM896 1280q159 0 271.5-112.5t112.5-271.5-112.5-271.5-271.5-112.5-271.5 112.5-112.5 271.5 112.5 271.5 271.5 112.5zM1380 1063l194 194q90-171 90-361t-90-361l-194 194q28 82 28 167t-28 167z"}]}})


/***/ }),
/* 1646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"life-ring":{"width":1792,"height":1792,"paths":[{"d":"M896 0q182 0 348 71t286 191 191 286 71 348-71 348-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71zM896 128q-190 0-361 90l194 194q82-28 167-28t167 28l194-194q-171-90-361-90zM218 1257l194-194q-28-82-28-167t28-167l-194-194q-90 171-90 361t90 361zM896 1664q190 0 361-90l-194-194q-82 28-167 28t-167-28l-194 194q171 90 361 90zM896 1280q159 0 271.5-112.5t112.5-271.5-112.5-271.5-271.5-112.5-271.5 112.5-112.5 271.5 112.5 271.5 271.5 112.5zM1380 1063l194 194q90-171 90-361t-90-361l-194 194q28 82 28 167t-28 167z"}]}})


/***/ }),
/* 1647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"life-saver":{"width":1792,"height":1792,"paths":[{"d":"M896 0q182 0 348 71t286 191 191 286 71 348-71 348-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71zM896 128q-190 0-361 90l194 194q82-28 167-28t167 28l194-194q-171-90-361-90zM218 1257l194-194q-28-82-28-167t28-167l-194-194q-90 171-90 361t90 361zM896 1664q190 0 361-90l-194-194q-82 28-167 28t-167-28l-194 194q171 90 361 90zM896 1280q159 0 271.5-112.5t112.5-271.5-112.5-271.5-271.5-112.5-271.5 112.5-112.5 271.5 112.5 271.5 271.5 112.5zM1380 1063l194 194q90-171 90-361t-90-361l-194 194q28 82 28 167t-28 167z"}]}})


/***/ }),
/* 1648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"lightbulb-o":{"width":1024,"height":1792,"paths":[{"d":"M736 576q0 13-9.5 22.5t-22.5 9.5-22.5-9.5-9.5-22.5q0-46-54-71t-106-25q-13 0-22.5-9.5t-9.5-22.5 9.5-22.5 22.5-9.5q50 0 99.5 16t87 54 37.5 90zM896 576q0-72-34.5-134t-90-101.5-123-62-136.5-22.5-136.5 22.5-123 62-90 101.5-34.5 134q0 101 68 180 10 11 30.5 33t30.5 33q128 153 141 298h228q13-145 141-298 10-11 30.5-33t30.5-33q68-79 68-180zM1024 576q0 155-103 268-45 49-74.5 87t-59.5 95.5-34 107.5q47 28 47 82 0 37-25 64 25 27 25 64 0 52-45 81 13 23 13 47 0 46-31.5 71t-77.5 25q-20 44-60 70t-87 26-87-26-60-70q-46 0-77.5-25t-31.5-71q0-24 13-47-45-29-45-81 0-37 25-64-25-27-25-64 0-54 47-82-4-50-34-107.5t-59.5-95.5-74.5-87q-103-113-103-268 0-99 44.5-184.5t117-142 164-89 186.5-32.5 186.5 32.5 164 89 117 142 44.5 184.5z"}]}})


/***/ }),
/* 1649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"line-chart":{"width":2048,"height":1792,"paths":[{"d":"M2048 1536v128h-2048v-1536h128v1408h1920zM1920 288v435q0 21-19.5 29.5t-35.5-7.5l-121-121-633 633q-10 10-23 10t-23-10l-233-233-416 416-192-192 585-585q10-10 23-10t23 10l233 233 464-464-121-121q-16-16-7.5-35.5t29.5-19.5h435q14 0 23 9t9 23z"}]}})


/***/ }),
/* 1650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"link":{"width":1664,"height":1792,"paths":[{"d":"M1456 1216q0-40-28-68l-208-208q-28-28-68-28-42 0-72 32 3 3 19 18.5t21.5 21.5 15 19 13 25.5 3.5 27.5q0 40-28 68t-68 28q-15 0-27.5-3.5t-25.5-13-19-15-21.5-21.5-18.5-19q-33 31-33 73 0 40 28 68l206 207q27 27 68 27 40 0 68-26l147-146q28-28 28-67zM753 511q0-40-28-68l-206-207q-28-28-68-28-39 0-68 27l-147 146q-28 28-28 67 0 40 28 68l208 208q27 27 68 27 42 0 72-31-3-3-19-18.5t-21.5-21.5-15-19-13-25.5-3.5-27.5q0-40 28-68t68-28q15 0 27.5 3.5t25.5 13 19 15 21.5 21.5 18.5 19q33-31 33-73zM1648 1216q0 120-85 203l-147 146q-83 83-203 83-121 0-204-85l-206-207q-83-83-83-203 0-123 88-209l-88-88q-86 88-208 88-120 0-204-84l-208-208q-84-84-84-204t85-203l147-146q83-83 203-83 121 0 204 85l206 207q83 83 83 203 0 123-88 209l88 88q86-88 208-88 120 0 204 84l208 208q84 84 84 204z"}]}})


/***/ }),
/* 1651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"linkedin-square":{"width":1536,"height":1792,"paths":[{"d":"M237 1414h231v-694h-231v694zM483 506q-1-52-36-86t-93-34-94.5 34-36.5 86q0 51 35.5 85.5t92.5 34.5h1q59 0 95-34.5t36-85.5zM1068 1414h231v-398q0-154-73-233t-193-79q-136 0-209 117h2v-101h-231q3 66 0 694h231v-388q0-38 7-56 15-35 45-59.5t74-24.5q116 0 116 157v371zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 1652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"linkedin":{"width":1536,"height":1792,"paths":[{"d":"M349 625v991h-330v-991h330zM370 319q1 73-50.5 122t-135.5 49h-2q-82 0-132-49t-50-122q0-74 51.5-122.5t134.5-48.5 133 48.5 51 122.5zM1536 1048v568h-329v-530q0-105-40.5-164.5t-126.5-59.5q-63 0-105.5 34.5t-63.5 85.5q-11 30-11 81v553h-329q2-399 2-647t-1-296l-1-48h329v144h-2q20-32 41-56t56.5-52 87-43.5 114.5-15.5q171 0 275 113.5t104 332.5z"}]}})


/***/ }),
/* 1653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"linode":{"width":1536,"height":1792,"paths":[{"d":"M330 1535l202 214-34-236-216-213zM556 1761l274-218-11-245-300 215zM245 1123l227 213-48-327-245-204zM495 1347l317-214-14-324-352 200zM843 1358l95 80-2-239-103-79q0 1 1 8.5t0 12-5 7.5l-78 52 85 70q7 6 7 88zM138 606l256 200-68-465-279-173zM1173 1269l15-234-230 164 2 240zM417 814l373-194-19-441-423 163zM1270 1179l20-233-226-142-2 105 144 95q6 4 4 9l-7 119zM1461 1040l30-222-179 128-20 228zM1273 1207l-71-49-8 117q0 5-4 8l-234 187q-7 5-14 0l-98-83 7 161q0 5-4 8l-293 234q-4 2-6 2-8-2-8-3l-228-242q-4-4-59-277-2-7 5-11l61-37q-94-86-95-92l-72-351q-2-7 6-12l94-45q-133-100-135-108l-96-466q-2-10 7-13l433-135q5 0 8 1l317 153q6 4 6 9l20 463q0 7-6 10l-118 61 126 85q5 2 5 8l5 123 121-74q5-4 11 0l84 56 3-110q0-6 5-9l206-126q6-3 11 0l245 135q4 4 5 7t-6.5 60-17.5 124.5-10 70.5q0 5-4 7l-191 153q-6 5-13 0z"}]}})


/***/ }),
/* 1654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"linux":{"width":1536,"height":1792,"paths":[{"d":"M663 411q-11 1-15.5 10.5t-8.5 9.5q-5 1-5-5 0-12 19-15h10zM750 425q-4 1-11.5-6.5t-17.5-4.5q24-11 32 2 3 6-3 9zM399 852q-4-1-6 3t-4.5 12.5-5.5 13.5-10 13q-10 11-1 12 4 1 12.5-7t12.5-18q1-3 2-7t2-6 1.5-4.5 0.5-4v-3t-1-2.5-3-2zM1254 1211q0-18-55-42 4-15 7.5-27.5t5-26 3-21.5 0.5-22.5-1-19.5-3.5-22-4-20.5-5-25-5.5-26.5q-10-48-47-103t-72-75q24 20 57 83 87 162 54 278-11 40-50 42-31 4-38.5-18.5t-8-83.5-11.5-107q-9-39-19.5-69t-19.5-45.5-15.5-24.5-13-15-7.5-7q-14-62-31-103t-29.5-56-23.5-33-15-40q-4-21 6-53.5t4.5-49.5-44.5-25q-15-3-44.5-18t-35.5-16q-8-1-11-26t8-51 36-27q37-3 51 30t4 58q-11 19-2 26.5t30 0.5q13-4 13-36v-37q-5-30-13.5-50t-21-30.5-23.5-15-27-7.5q-107 8-89 134 0 15-1 15-9-9-29.5-10.5t-33 0.5-15.5-5q1-57-16-90t-45-34q-27-1-41.5 27.5t-16.5 59.5q-1 15 3.5 37t13 37.5 15.5 13.5q10-3 16-14 4-9-7-8-7 0-15.5-14.5t-9.5-33.5q-1-22 9-37t34-14q17 0 27 21t9.5 39-1.5 22q-22 15-31 29-8 12-27.5 23.5t-20.5 12.5q-13 14-15.5 27t7.5 18q14 8 25 19.5t16 19 18.5 13 35.5 6.5q47 2 102-15 2-1 23-7t34.5-10.5 29.5-13 21-17.5q9-14 20-8 5 3 6.5 8.5t-3 12-16.5 9.5q-20 6-56.5 21.5t-45.5 19.5q-44 19-70 23-25 5-79-2-10-2-9 2t17 19q25 23 67 22 17-1 36-7t36-14 33.5-17.5 30-17 24.5-12 17.5-2.5 8.5 11q0 2-1 4.5t-4 5-6 4.5-8.5 5-9 4.5-10 5-9.5 4.5q-28 14-67.5 44t-66.5 43-49 1q-21-11-63-73-22-31-25-22-1 3-1 10 0 25-15 56.5t-29.5 55.5-21 58 11.5 63q-23 6-62.5 90t-47.5 141q-2 18-1.5 69t-5.5 59q-8 24-29 3-32-31-36-94-2-28 4-56 4-19-1-18-2 1-4 5-36 65 10 166 5 12 25 28t24 20q20 23 104 90.5t93 76.5q16 15 17.5 38t-14 43-45.5 23q8 15 29 44.5t28 54 7 70.5q46-24 7-92-4-8-10.5-16t-9.5-12-2-6q3-5 13-9.5t20 2.5q46 52 166 36 133-15 177-87 23-38 34-30 12 6 10 52-1 25-23 92-9 23-6 37.5t24 15.5q3-19 14.5-77t13.5-90q2-21-6.5-73.5t-7.5-97 23-70.5q15-18 51-18 1-37 34.5-53t72.5-10.5 60 22.5zM626 384q3-17-2.5-30t-11.5-15q-9-2-9 7 2 5 5 6 10 0 7 15-3 20 8 20 3 0 3-3zM1045 581q-2-8-6.5-11.5t-13-5-14.5-5.5q-5-3-9.5-8t-7-8-5.5-6.5-4-4-4 1.5q-14 16 7 43.5t39 31.5q9 1 14.5-8t3.5-20zM867 368q0-11-5-19.5t-11-12.5-9-3q-6 0-8 2t0 4 5 3q14 4 18 31 0 3 8-2 2-2 2-3zM921 135q0-2-2.5-5t-9-7-9.5-6q-15-15-24-15-9 1-11.5 7.5t-1 13-0.5 12.5q-1 4-6 10.5t-6 9 3 8.5q4 3 8 0t11-9 15-9q1-1 9-1t15-2 9-7zM1486 1476q20 12 31 24.5t12 24-2.5 22.5-15.5 22-23.5 19.5-30 18.5-31.5 16.5-32 15.5-27 13q-38 19-85.5 56t-75.5 64q-17 16-68 19.5t-89-14.5q-18-9-29.5-23.5t-16.5-25.5-22-19.5-47-9.5q-44-1-130-1-19 0-57 1.5t-58 2.5q-44 1-79.5 15t-53.5 30-43.5 28.5-53.5 11.5q-29-1-111-31t-146-43q-19-4-51-9.5t-50-9-39.5-9.5-33.5-14.5-17-19.5q-10-23 7-66.5t18-54.5q1-16-4-40t-10-42.5-4.5-36.5 10.5-27q14-12 57-14t60-12q30-18 42-35t12-51q21 73-32 106-32 20-83 15-34-3-43 10-13 15 5 57 2 6 8 18t8.5 18 4.5 17 1 22q0 15-17 49t-14 48q3 17 37 26 20 6 84.5 18.5t99.5 20.5q24 6 74 22t82.5 23 55.5 4q43-6 64.5-28t23-48-7.5-58.5-19-52-20-36.5q-121-190-169-242-68-74-113-40-11 9-15-15-3-16-2-38 1-29 10-52t24-47 22-42q8-21 26.5-72t29.5-78 30-61 39-54q110-143 124-195-12-112-16-310-2-90 24-151.5t106-104.5q39-21 104-21 53-1 106 13.5t89 41.5q57 42 91.5 121.5t29.5 147.5q-5 95 30 214 34 113 133 218 55 59 99.5 163t59.5 191q8 49 5 84.5t-12 55.5-20 22q-10 2-23.5 19t-27 35.5-40.5 33.5-61 14q-18-1-31.5-5t-22.5-13.5-13.5-15.5-11.5-20.5-9-19.5q-22-37-41-30t-28 49 7 97q20 70 1 195-10 65 18 100.5t73 33 85-35.5q59-49 89.5-66.5t103.5-42.5q53-18 77-36.5t18.5-34.5-25-28.5-51.5-23.5q-33-11-49.5-48t-15-72.5 15.5-47.5q1 31 8 56.5t14.5 40.5 20.5 28.5 21 19 21.5 13 16.5 9.5z"}]}})


/***/ }),
/* 1655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"list-alt":{"width":1792,"height":1792,"paths":[{"d":"M384 1184v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM384 928v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM384 672v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM1536 1184v64q0 13-9.5 22.5t-22.5 9.5h-960q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h960q13 0 22.5 9.5t9.5 22.5zM1536 928v64q0 13-9.5 22.5t-22.5 9.5h-960q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h960q13 0 22.5 9.5t9.5 22.5zM1536 672v64q0 13-9.5 22.5t-22.5 9.5h-960q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h960q13 0 22.5 9.5t9.5 22.5zM1664 1376v-832q0-13-9.5-22.5t-22.5-9.5h-1472q-13 0-22.5 9.5t-9.5 22.5v832q0 13 9.5 22.5t22.5 9.5h1472q13 0 22.5-9.5t9.5-22.5zM1792 288v1088q0 66-47 113t-113 47h-1472q-66 0-113-47t-47-113v-1088q0-66 47-113t113-47h1472q66 0 113 47t47 113z"}]}})


/***/ }),
/* 1656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"list-ol":{"width":1792,"height":1792,"paths":[{"d":"M381 1620q0 80-54.5 126t-135.5 46q-106 0-172-66l57-88q49 45 106 45 29 0 50.5-14.5t21.5-42.5q0-64-105-56l-26-56q8-10 32.5-43.5t42.5-54 37-38.5v-1q-16 0-48.5 1t-48.5 1v53h-106v-152h333v88l-95 115q51 12 81 49t30 88zM383 993v159h-362q-6-36-6-54 0-51 23.5-93t56.5-68 66-47.5 56.5-43.5 23.5-45q0-25-14.5-38.5t-39.5-13.5q-46 0-81 58l-85-59q24-51 71.5-79.5t105.5-28.5q73 0 123 41.5t50 112.5q0 50-34 91.5t-75 64.5-75.5 50.5-35.5 52.5h127v-60h105zM1792 1312v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-14 9-23t23-9h1216q13 0 22.5 9.5t9.5 22.5zM384 413v99h-335v-99h107q0-41 0.5-121.5t0.5-121.5v-12h-2q-8 17-50 54l-71-76 136-127h106v404h108zM1792 800v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-14 9-23t23-9h1216q13 0 22.5 9.5t9.5 22.5zM1792 288v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5z"}]}})


/***/ }),
/* 1657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"list-ul":{"width":1792,"height":1792,"paths":[{"d":"M384 1408q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM384 896q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM1792 1312v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5zM384 384q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM1792 800v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5zM1792 288v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5z"}]}})


/***/ }),
/* 1658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"list":{"width":1792,"height":1792,"paths":[{"d":"M256 1312v192q0 13-9.5 22.5t-22.5 9.5h-192q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h192q13 0 22.5 9.5t9.5 22.5zM256 928v192q0 13-9.5 22.5t-22.5 9.5h-192q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h192q13 0 22.5 9.5t9.5 22.5zM256 544v192q0 13-9.5 22.5t-22.5 9.5h-192q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h192q13 0 22.5 9.5t9.5 22.5zM1792 1312v192q0 13-9.5 22.5t-22.5 9.5h-1344q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1344q13 0 22.5 9.5t9.5 22.5zM256 160v192q0 13-9.5 22.5t-22.5 9.5h-192q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h192q13 0 22.5 9.5t9.5 22.5zM1792 928v192q0 13-9.5 22.5t-22.5 9.5h-1344q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1344q13 0 22.5 9.5t9.5 22.5zM1792 544v192q0 13-9.5 22.5t-22.5 9.5h-1344q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1344q13 0 22.5 9.5t9.5 22.5zM1792 160v192q0 13-9.5 22.5t-22.5 9.5h-1344q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1344q13 0 22.5 9.5t9.5 22.5z"}]}})


/***/ }),
/* 1659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"location-arrow":{"width":1408,"height":1792,"paths":[{"d":"M1401 349l-640 1280q-17 35-57 35-5 0-15-2-22-5-35.5-22.5t-13.5-39.5v-576h-576q-22 0-39.5-13.5t-22.5-35.5 4-42 29-30l1280-640q13-7 29-7 27 0 45 19 15 14 18.5 34.5t-6.5 39.5z"}]}})


/***/ }),
/* 1660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"lock":{"width":1152,"height":1792,"paths":[{"d":"M320 768h512v-192q0-106-75-181t-181-75-181 75-75 181v192zM1152 864v576q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-576q0-40 28-68t68-28h32v-192q0-184 132-316t316-132 316 132 132 316v192h32q40 0 68 28t28 68z"}]}})


/***/ }),
/* 1661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"long-arrow-down":{"width":768,"height":1792,"paths":[{"d":"M765 1299q8 19-5 35l-350 384q-10 10-23 10-14 0-24-10l-355-384q-13-16-5-35 9-19 29-19h224v-1248q0-14 9-23t23-9h192q14 0 23 9t9 23v1248h224q21 0 29 19z"}]}})


/***/ }),
/* 1662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"long-arrow-left":{"width":1792,"height":1792,"paths":[{"d":"M1792 800v192q0 14-9 23t-23 9h-1248v224q0 21-19 29t-35-5l-384-350q-10-10-10-23 0-14 10-24l384-354q16-14 35-6 19 9 19 29v224h1248q14 0 23 9t9 23z"}]}})


/***/ }),
/* 1663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"long-arrow-right":{"width":1792,"height":1792,"paths":[{"d":"M1728 893q0 14-10 24l-384 354q-16 14-35 6-19-9-19-29v-224h-1248q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h1248v-224q0-21 19-29t35 5l384 350q10 10 10 23z"}]}})


/***/ }),
/* 1664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"long-arrow-up":{"width":768,"height":1792,"paths":[{"d":"M765 493q-9 19-29 19h-224v1248q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-1248h-224q-21 0-29-19t5-35l350-384q10-10 23-10 14 0 24 10l355 384q13 16 5 35z"}]}})


/***/ }),
/* 1665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"low-vision":{"width":1792,"height":1792,"paths":[{"d":"M335 1356q-2 0-6-2-86-57-168.5-145t-139.5-180q-21-30-21-69 0-9 2-19t4-18 7-18 8.5-16 10.5-17 10-15 12-15.5 11-14.5q184-251 452-365-110-198-110-211 0-19 17-29 116-64 128-64 18 0 28 16l124 229q92-19 192-19 266 0 497.5 137.5t378.5 369.5q20 31 20 69t-20 69q-91 142-218.5 253.5t-278.5 175.5q110 198 110 211 0 20-17 29-116 64-127 64-19 0-29-16l-124-229-64-119-444-820 7-7q-58 24-99 47 3 5 127 234t243 449 119 223q0 7-9 9-13 3-72 3-57 0-60-7l-456-841q-39 28-82 68 24 43 214 393.5t190 354.5q0 10-11 10-14 0-82.5-22t-72.5-28l-106-197-224-413q-44 53-78 106 2 3 18 25t23 34l176 327q0 10-10 10zM1165 1254l49 91q273-111 450-385-180-277-459-389 67 64 103 148.5t36 176.5q0 106-47 200.5t-132 157.5zM848 640q0 20 14 34t34 14q86 0 147 61t61 147q0 20 14 34t34 14 34-14 14-34q0-126-89-215t-215-89q-20 0-34 14t-14 34zM1214 575l-9-4 7 7z"}]}})


/***/ }),
/* 1666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"magic":{"width":1664,"height":1792,"paths":[{"d":"M1190 581l293-293-107-107-293 293zM1637 288q0 27-18 45l-1286 1286q-18 18-45 18t-45-18l-198-198q-18-18-18-45t18-45l1286-1286q18-18 45-18t45 18l198 198q18 18 18 45zM286 98l98 30-98 30-30 98-30-98-98-30 98-30 30-98zM636 260l196 60-196 60-60 196-60-196-196-60 196-60 60-196zM1566 738l98 30-98 30-30 98-30-98-98-30 98-30 30-98zM926 98l98 30-98 30-30 98-30-98-98-30 98-30 30-98z"}]}})


/***/ }),
/* 1667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"magnet":{"width":1536,"height":1792,"paths":[{"d":"M1536 832v128q0 201-98.5 362t-274 251.5-395.5 90.5-395.5-90.5-274-251.5-98.5-362v-128q0-26 19-45t45-19h384q26 0 45 19t19 45v128q0 52 23.5 90t53.5 57 71 30 64 13 44 2 44-2 64-13 71-30 53.5-57 23.5-90v-128q0-26 19-45t45-19h384q26 0 45 19t19 45zM512 192v384q0 26-19 45t-45 19h-384q-26 0-45-19t-19-45v-384q0-26 19-45t45-19h384q26 0 45 19t19 45zM1536 192v384q0 26-19 45t-45 19h-384q-26 0-45-19t-19-45v-384q0-26 19-45t45-19h384q26 0 45 19t19 45z"}]}})


/***/ }),
/* 1668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"mail-forward":{"width":1792,"height":1792,"paths":[{"d":"M1792 640q0 26-19 45l-512 512q-19 19-45 19t-45-19-19-45v-256h-224q-98 0-175.5 6t-154 21.5-133 42.5-105.5 69.5-80 101-48.5 138.5-17.5 181q0 55 5 123 0 6 2.5 23.5t2.5 26.5q0 15-8.5 25t-23.5 10q-16 0-28-17-7-9-13-22t-13.5-30-10.5-24q-127-285-127-451 0-199 53-333 162-403 875-403h224v-256q0-26 19-45t45-19 45 19l512 512q19 19 19 45z"}]}})


/***/ }),
/* 1669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"mail-reply-all":{"width":1792,"height":1792,"paths":[{"d":"M640 1082v70q0 42-39 59-13 5-25 5-27 0-45-19l-512-512q-19-19-19-45t19-45l512-512q29-31 70-14 39 17 39 59v69l-397 398q-19 19-19 45t19 45zM1792 1120q0 58-17 133.5t-38.5 138-48 125-40.5 90.5l-20 40q-8 17-28 17-6 0-9-1-25-8-23-34 43-400-106-565-64-71-170.5-110.5t-267.5-52.5v251q0 42-39 59-13 5-25 5-27 0-45-19l-512-512q-19-19-19-45t19-45l512-512q29-31 70-14 39 17 39 59v262q411 28 599 221 169 173 169 509z"}]}})


/***/ }),
/* 1670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"mail-reply":{"width":1792,"height":1792,"paths":[{"d":"M1792 1120q0 166-127 451-3 7-10.5 24t-13.5 30-13 22q-12 17-28 17-15 0-23.5-10t-8.5-25q0-9 2.5-26.5t2.5-23.5q5-68 5-123 0-101-17.5-181t-48.5-138.5-80-101-105.5-69.5-133-42.5-154-21.5-175.5-6h-224v256q0 26-19 45t-45 19-45-19l-512-512q-19-19-19-45t19-45l512-512q19-19 45-19t45 19 19 45v256h224q713 0 875 403 53 134 53 333z"}]}})


/***/ }),
/* 1671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"male":{"width":1024,"height":1792,"paths":[{"d":"M1024 704v416q0 40-28 68t-68 28-68-28-28-68v-352h-64v912q0 46-33 79t-79 33-79-33-33-79v-464h-64v464q0 46-33 79t-79 33-79-33-33-79v-912h-64v352q0 40-28 68t-68 28-68-28-28-68v-416q0-80 56-136t136-56h640q80 0 136 56t56 136zM736 256q0 93-65.5 158.5t-158.5 65.5-158.5-65.5-65.5-158.5 65.5-158.5 158.5-65.5 158.5 65.5 65.5 158.5z"}]}})


/***/ }),
/* 1672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"map-marker":{"width":1024,"height":1792,"paths":[{"d":"M768 640q0-106-75-181t-181-75-181 75-75 181 75 181 181 75 181-75 75-181zM1024 640q0 109-33 179l-364 774q-16 33-47.5 52t-67.5 19-67.5-19-46.5-52l-365-774q-33-70-33-179 0-212 150-362t362-150 362 150 150 362z"}]}})


/***/ }),
/* 1673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"map-o":{"width":2048,"height":1792,"paths":[{"d":"M2020 11q28 20 28 53v1408q0 20-11 36t-29 23l-640 256q-24 11-48 0l-616-246-616 246q-10 5-24 5-19 0-36-11-28-20-28-53v-1408q0-20 11-36t29-23l640-256q24-11 48 0l616 246 616-246q32-13 60 6zM736 146v1270l576 230v-1270zM128 363v1270l544-217v-1270zM1920 1429v-1270l-544 217v1270z"}]}})


/***/ }),
/* 1674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"map-pin":{"width":1024,"height":1792,"paths":[{"d":"M512 1088q66 0 128-15v655q0 26-19 45t-45 19h-128q-26 0-45-19t-19-45v-655q62 15 128 15zM512 0q212 0 362 150t150 362-150 362-362 150-362-150-150-362 150-362 362-150zM512 224q14 0 23-9t9-23-9-23-23-9q-146 0-249 103t-103 249q0 14 9 23t23 9 23-9 9-23q0-119 84.5-203.5t203.5-84.5z"}]}})


/***/ }),
/* 1675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"map-signs":{"width":1792,"height":1792,"paths":[{"d":"M1745 297q10 10 10 23t-10 23l-141 141q-28 28-68 28h-1344q-26 0-45-19t-19-45v-256q0-26 19-45t45-19h576v-64q0-26 19-45t45-19h128q26 0 45 19t19 45v64h512q40 0 68 28zM768 1216h256v512q0 26-19 45t-45 19h-128q-26 0-45-19t-19-45v-512zM1600 768q26 0 45 19t19 45v256q0 26-19 45t-45 19h-1344q-40 0-68-28l-141-141q-10-10-10-23t10-23l141-141q28-28 68-28h512v-192h256v192h576z"}]}})


/***/ }),
/* 1676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"map":{"width":1792,"height":1792,"paths":[{"d":"M512 0q13 0 22.5 9.5t9.5 22.5v1472q0 20-17 28l-480 256q-7 4-15 4-13 0-22.5-9.5t-9.5-22.5v-1472q0-20 17-28l480-256q7-4 15-4zM1760 0q13 0 22.5 9.5t9.5 22.5v1472q0 20-17 28l-480 256q-7 4-15 4-13 0-22.5-9.5t-9.5-22.5v-1472q0-20 17-28l480-256q7-4 15-4zM640 0q8 0 14 3l512 256q18 10 18 29v1472q0 13-9.5 22.5t-22.5 9.5q-8 0-14-3l-512-256q-18-10-18-29v-1472q0-13 9.5-22.5t22.5-9.5z"}]}})


/***/ }),
/* 1677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"mars-double":{"width":1920,"height":1792,"paths":[{"d":"M1536 416q0-14 9-23t23-9h288q26 0 45 19t19 45v288q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-134l-254 255q76 95 107.5 214t9.5 247q-31 182-166 312t-318 156q-210 29-384.5-80t-241.5-300q-117-6-221-57.5t-177.5-133-113.5-192.5-32-230q9-135 78-252t182-191.5 248-89.5q118-14 227.5 19t198.5 103l255-254h-134q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h288q26 0 45 19t19 45v288q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-134l-254 255q59 74 93 169 182 9 328 124l255-254h-134q-14 0-23-9t-9-23v-64zM1024 832q0-20-4-58-162 25-271 150t-109 292q0 20 4 58 162-25 271-150t109-292zM128 832q0 168 111 294t276 149q-3-29-3-59 0-210 135-369.5t338-196.5q-53-120-163.5-193t-245.5-73q-185 0-316.5 131.5t-131.5 316.5zM1088 1664q185 0 316.5-131.5t131.5-316.5q0-168-111-294t-276-149q3 28 3 59 0 210-135 369.5t-338 196.5q53 120 163.5 193t245.5 73z"}]}})


/***/ }),
/* 1678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"mars-stroke-h":{"width":2048,"height":1792,"paths":[{"d":"M1901 915q19 19 19 45t-19 45l-294 294q-9 10-22.5 10t-22.5-10l-45-45q-10-9-10-22.5t10-22.5l185-185h-294v224q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-224h-132q-24 217-187.5 364.5t-384.5 147.5q-167 0-306-87t-212-236-54-319q15-133 88-245.5t188-182 249-80.5q155-12 292 52.5t224 186 103 271.5h132v-224q0-14 9-23t23-9h64q14 0 23 9t9 23v224h294l-185-185q-10-9-10-22.5t10-22.5l45-45q9-10 22.5-10t22.5 10zM576 1408q185 0 316.5-131.5t131.5-316.5-131.5-316.5-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5z"}]}})


/***/ }),
/* 1679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"mars-stroke-v":{"width":1280,"height":1792,"paths":[{"d":"M640 644q217 24 364.5 187.5t147.5 384.5q0 167-87 306t-236 212-319 54q-133-15-245.5-88t-182-188-80.5-249q-12-155 52.5-292t186-224 271.5-103v-132h-160q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h160v-165l-92 92q-10 9-23 9t-22-9l-46-46q-9-9-9-22t9-23l202-201q19-19 45-19t45 19l202 201q9 10 9 23t-9 22l-46 46q-9 9-22 9t-23-9l-92-92v165h160q14 0 23 9t9 23v64q0 14-9 23t-23 9h-160v132zM576 1664q185 0 316.5-131.5t131.5-316.5-131.5-316.5-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5z"}]}})


/***/ }),
/* 1680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"mars-stroke":{"width":1536,"height":1792,"paths":[{"d":"M1472 128q26 0 45 19t19 45v416q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-262l-213 214 140 140q9 10 9 23t-9 22l-46 46q-9 9-22 9t-23-9l-140-141-78 79q126 156 126 359 0 117-45.5 223.5t-123 184-184 123-223.5 45.5-223.5-45.5-184-123-123-184-45.5-223.5 45.5-223.5 123-184 184-123 223.5-45.5q203 0 359 126l78-78-172-172q-9-10-9-23t9-22l46-46q9-9 22-9t23 9l172 172 213-213h-261q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h416zM576 1536q185 0 316.5-131.5t131.5-316.5-131.5-316.5-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5z"}]}})


/***/ }),
/* 1681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"mars":{"width":1536,"height":1792,"paths":[{"d":"M1472 128q26 0 45 19t19 45v416q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-262l-382 383q126 156 126 359 0 117-45.5 223.5t-123 184-184 123-223.5 45.5-223.5-45.5-184-123-123-184-45.5-223.5 45.5-223.5 123-184 184-123 223.5-45.5q203 0 359 126l382-382h-261q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h416zM576 1536q185 0 316.5-131.5t131.5-316.5-131.5-316.5-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5z"}]}})


/***/ }),
/* 1682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"maxcdn":{"width":1792,"height":1792,"paths":[{"d":"M1745 773l-164 763h-334l178-832q13-56-15-88-27-33-83-33h-169l-204 953h-334l204-953h-286l-204 953h-334l204-953-153-327h1276q101 0 189.5 40.5t147.5 113.5q60 73 81 168.5t0 194.5z"}]}})


/***/ }),
/* 1683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"meanpath":{"width":1536,"height":1792,"paths":[{"d":"M1311 842v114q0 24-13.5 38t-37.5 14h-202q-24 0-38-14t-14-38v-114q0-24 14-38t38-14h202q24 0 37.5 14t13.5 38zM821 1072v-250q0-53-32.5-85.5t-85.5-32.5h-133q-68 0-96 52-28-52-96-52h-130q-53 0-85.5 32.5t-32.5 85.5v250q0 22 21 22h55q22 0 22-22v-230q0-24 13.5-38t38.5-14h94q24 0 38 14t14 38v230q0 22 21 22h54q22 0 22-22v-230q0-24 14-38t38-14h97q24 0 37.5 14t13.5 38v230q0 22 22 22h55q21 0 21-22zM1410 976v-154q0-53-33-85.5t-86-32.5h-264q-53 0-86 32.5t-33 85.5v410q0 21 22 21h55q21 0 21-21v-180q31 42 94 42h191q53 0 86-32.5t33-85.5zM1536 360v1072q0 96-68 164t-164 68h-1072q-96 0-164-68t-68-164v-1072q0-96 68-164t164-68h1072q96 0 164 68t68 164z"}]}})


/***/ }),
/* 1684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"medium":{"width":1792,"height":1792,"paths":[{"d":"M597 421v1173q0 25-12.5 42.5t-36.5 17.5q-17 0-33-8l-465-233q-21-10-35.5-33.5t-14.5-46.5v-1140q0-20 10-34t29-14q14 0 44 15l511 256q3 3 3 5zM661 522l534 866-534-266v-600zM1792 540v1054q0 25-14 40.5t-38 15.5-47-13l-441-220zM1789 420q0 3-256.5 419.5t-300.5 487.5l-390-634 324-527q17-28 52-28 14 0 26 6l541 270q4 2 4 6z"}]}})


/***/ }),
/* 1685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"medkit":{"width":1792,"height":1792,"paths":[{"d":"M1280 1120v-192q0-14-9-23t-23-9h-224v-224q0-14-9-23t-23-9h-192q-14 0-23 9t-9 23v224h-224q-14 0-23 9t-9 23v192q0 14 9 23t23 9h224v224q0 14 9 23t23 9h192q14 0 23-9t9-23v-224h224q14 0 23-9t9-23zM640 384h512v-128h-512v128zM256 384v1280h-32q-92 0-158-66t-66-158v-832q0-92 66-158t158-66h32zM1440 384v1280h-1088v-1280h160v-160q0-40 28-68t68-28h576q40 0 68 28t28 68v160h160zM1792 608v832q0 92-66 158t-158 66h-32v-1280h32q92 0 158 66t66 158z"}]}})


/***/ }),
/* 1686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"meetup":{"width":1920,"height":1792,"paths":[{"d":"M1334 1234q-4-24-27.5-34t-49.5-10.5-48.5-12.5-25.5-38q-5-47 33-139.5t75-181 32-127.5q-14-101-117-103-45-1-75 16l-3 2-5 2.5t-4.5 2-5 2-5 0.5-6-1.5-6-3.5-6.5-5q-3-2-9-8.5t-9-9-8.5-7.5-9.5-7.5-9.5-5.5-11-4.5-11.5-2.5q-30-5-48 3t-45 31q-1 1-9 8.5t-12.5 11-15 10-16.5 5.5-17-3q-54-27-84-40-41-18-94 5t-76 65q-16 28-41 98.5t-43.5 132.5-40 134-21.5 73q-22 69 18.5 119t110.5 46q30-2 50.5-15t38.5-46q7-13 79-199.5t77-194.5q6-11 21.5-18t29.5 0q27 15 21 53-2 18-51 139.5t-50 132.5q-6 38 19.5 56.5t60.5 7 55-49.5q4-8 45.5-92t81.5-163.5 46-88.5q20-29 41-28 29 0 25 38-2 16-65.5 147.5t-70.5 159.5q-12 53 13 103t74 74q17 9 51 15.5t71.5 8 62.5-14 20-48.5zM383 1450q3 15-5 27.5t-23 15.5q-14 3-26.5-5t-15.5-23q-3-14 5-27t22-16 27 5 16 23zM953 1713q12 17 8.5 37.5t-20.5 32.5-37.5 8-32.5-21q-11-17-7.5-37.5t20.5-32.5 37.5-8 31.5 21zM177 901q-18 27-49.5 33t-57.5-13q-26-18-32-50t12-58q18-27 49.5-33t57.5 12q26 19 32 50.5t-12 58.5zM1467 1578q19 28 13 61.5t-34 52.5-60.5 13-51.5-34-13-61 33-53q28-19 60.5-13t52.5 34zM1579 974q69 113 42.5 244.5t-134.5 207.5q-90 63-199 60-20 80-84.5 127t-143.5 44.5-140-57.5q-12 9-13 10-103 71-225 48.5t-193-126.5q-50-73-53-164-83-14-142.5-70.5t-80.5-128-2-152 81-138.5q-36-60-38-128t24.5-125 79.5-98.5 121-50.5q32-85 99-148t146.5-91.5 168-17 159.5 66.5q72-21 140-17.5t128.5 36 104.5 80 67.5 115 17.5 140.5q52 16 87 57t45.5 89-5.5 99.5-58 87.5zM455 314q14 20 9.5 44.5t-24.5 38.5q-19 14-43.5 9.5t-37.5-24.5q-14-20-9.5-44.5t24.5-38.5q19-14 43.5-9.5t37.5 24.5zM614 33q4 16-5 30.5t-26 18.5-31-5.5-18-26.5q-3-17 6.5-31t25.5-18q17-4 31 5.5t17 26.5zM1800 981q4 20-6.5 37t-30.5 21q-19 4-36-6.5t-21-30.5 6.5-37 30.5-22q20-4 36.5 7.5t20.5 30.5zM1136 88q16 27 8.5 58.5t-35.5 47.5q-27 16-57.5 8.5t-46.5-34.5q-16-28-8.5-59t34.5-48 58-9 47 36zM1882 744q4 15-4 27.5t-23 16.5q-15 3-27.5-5.5t-15.5-22.5q-3-15 5-28t23-16q14-3 26.5 5t15.5 23zM1691 503q15 22 10.5 49t-26.5 43q-22 15-49 10t-42-27-10-49 27-43 48.5-11 41.5 28z"}]}})


/***/ }),
/* 1687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"meh-o":{"width":1536,"height":1792,"paths":[{"d":"M1152 1088q0 26-19 45t-45 19h-640q-26 0-45-19t-19-45 19-45 45-19h640q26 0 45 19t19 45zM640 640q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zM1152 640q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zM1408 896q0-130-51-248.5t-136.5-204-204-136.5-248.5-51-248.5 51-204 136.5-136.5 204-51 248.5 51 248.5 136.5 204 204 136.5 248.5 51 248.5-51 204-136.5 136.5-204 51-248.5zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"mercury":{"width":1280,"height":1792,"paths":[{"d":"M830 316q145 72 233.5 210.5t88.5 305.5q0 221-147.5 384.5t-364.5 187.5v132h96q14 0 23 9t9 23v64q0 14-9 23t-23 9h-96v96q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-96h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h96v-132q-217-24-364.5-187.5t-147.5-384.5q0-167 88.5-305.5t233.5-210.5q-165-96-228-273-6-16 3.5-29.5t26.5-13.5h69q21 0 29 20 44 106 140 171t214 65 214-65 140-171q8-20 37-20h61q17 0 26.5 13.5t3.5 29.5q-63 177-228 273zM576 1280q185 0 316.5-131.5t131.5-316.5-131.5-316.5-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5z"}]}})


/***/ }),
/* 1689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"microchip":{"width":1536,"height":1792,"paths":[{"d":"M192 1280v128h-112q-16 0-16-16v-16h-48q-16 0-16-16v-32q0-16 16-16h48v-16q0-16 16-16h112zM192 1024v128h-112q-16 0-16-16v-16h-48q-16 0-16-16v-32q0-16 16-16h48v-16q0-16 16-16h112zM192 768v128h-112q-16 0-16-16v-16h-48q-16 0-16-16v-32q0-16 16-16h48v-16q0-16 16-16h112zM192 512v128h-112q-16 0-16-16v-16h-48q-16 0-16-16v-32q0-16 16-16h48v-16q0-16 16-16h112zM192 256v128h-112q-16 0-16-16v-16h-48q-16 0-16-16v-32q0-16 16-16h48v-16q0-16 16-16h112zM1280 96v1472q0 40-28 68t-68 28h-832q-40 0-68-28t-28-68v-1472q0-40 28-68t68-28h832q40 0 68 28t28 68zM1536 1328v32q0 16-16 16h-48v16q0 16-16 16h-112v-128h112q16 0 16 16v16h48q16 0 16 16zM1536 1072v32q0 16-16 16h-48v16q0 16-16 16h-112v-128h112q16 0 16 16v16h48q16 0 16 16zM1536 816v32q0 16-16 16h-48v16q0 16-16 16h-112v-128h112q16 0 16 16v16h48q16 0 16 16zM1536 560v32q0 16-16 16h-48v16q0 16-16 16h-112v-128h112q16 0 16 16v16h48q16 0 16 16zM1536 304v32q0 16-16 16h-48v16q0 16-16 16h-112v-128h112q16 0 16 16v16h48q16 0 16 16z"}]}})


/***/ }),
/* 1690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"microphone-slash":{"width":1408,"height":1792,"paths":[{"d":"M271 945l-101 101q-42-103-42-214v-128q0-26 19-45t45-19 45 19 19 45v128q0 53 15 113zM1385 343l-361 361v128q0 132-94 226t-226 94q-55 0-109-19l-96 96q97 51 205 51 185 0 316.5-131.5t131.5-316.5v-128q0-26 19-45t45-19 45 19 19 45v128q0 221-147.5 384.5t-364.5 187.5v132h256q26 0 45 19t19 45-19 45-45 19h-640q-26 0-45-19t-19-45 19-45 45-19h256v-132q-125-13-235-81l-254 254q-10 10-23 10t-23-10l-82-82q-10-10-10-23t10-23l1234-1234q10-10 23-10t23 10l82 82q10 10 10 23t-10 23zM1005 211l-621 621v-512q0-132 94-226t226-94q102 0 184.5 59t116.5 152z"}]}})


/***/ }),
/* 1691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"microphone":{"width":1152,"height":1792,"paths":[{"d":"M1152 704v128q0 221-147.5 384.5t-364.5 187.5v132h256q26 0 45 19t19 45-19 45-45 19h-640q-26 0-45-19t-19-45 19-45 45-19h256v-132q-217-24-364.5-187.5t-147.5-384.5v-128q0-26 19-45t45-19 45 19 19 45v128q0 185 131.5 316.5t316.5 131.5 316.5-131.5 131.5-316.5v-128q0-26 19-45t45-19 45 19 19 45zM896 320v512q0 132-94 226t-226 94-226-94-94-226v-512q0-132 94-226t226-94 226 94 94 226z"}]}})


/***/ }),
/* 1692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"minus-circle":{"width":1536,"height":1792,"paths":[{"d":"M1216 960v-128q0-26-19-45t-45-19h-768q-26 0-45 19t-19 45v128q0 26 19 45t45 19h768q26 0 45-19t19-45zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"minus-square-o":{"width":1408,"height":1792,"paths":[{"d":"M1152 800v64q0 14-9 23t-23 9h-832q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h832q14 0 23 9t9 23zM1280 1248v-832q0-66-47-113t-113-47h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113zM1408 416v832q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 1694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"minus-square":{"width":1536,"height":1792,"paths":[{"d":"M1280 960v-128q0-26-19-45t-45-19h-896q-26 0-45 19t-19 45v128q0 26 19 45t45 19h896q26 0 45-19t19-45zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 1695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"minus":{"width":1408,"height":1792,"paths":[{"d":"M1408 736v192q0 40-28 68t-68 28h-1216q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h1216q40 0 68 28t28 68z"}]}})


/***/ }),
/* 1696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"mixcloud":{"width":2304,"height":1792,"paths":[{"d":"M1645 1098q0-59-34-106.5t-87-68.5q-7 45-23 92-7 24-27.5 38t-44.5 14q-12 0-24-3-31-10-45-38.5t-4-58.5q23-71 23-143 0-123-61-227.5t-166-165.5-228-61q-134 0-247 73t-167 194q108 28 188 106 22 23 22 55t-22 54-54 22-55-22q-75-75-180-75-106 0-181 74.5t-75 180.5 75 180.5 181 74.5h1046q79 0 134.5-55.5t55.5-133.5zM1798 1098q0 142-100.5 242t-242.5 100h-1046q-169 0-289-119.5t-120-288.5q0-153 100-267t249-136q62-184 221-298t354-114q235 0 408.5 158.5t196.5 389.5q116 25 192.5 118.5t76.5 214.5zM2048 1098q0 175-97 319-23 33-64 33-24 0-43-13-26-17-32-48.5t12-57.5q71-104 71-233t-71-233q-18-26-12-57t32-49 57.5-11.5 49.5 32.5q97 142 97 318zM2304 1098q0 244-134 443-23 34-64 34-23 0-42-13-26-18-32.5-49t11.5-57q108-164 108-358 0-195-108-357-18-26-11.5-57.5t32.5-48.5q26-18 57-12t49 33q134 198 134 442z"}]}})


/***/ }),
/* 1697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"mobile-phone":{"width":768,"height":1792,"paths":[{"d":"M464 1408q0-33-23.5-56.5t-56.5-23.5-56.5 23.5-23.5 56.5 23.5 56.5 56.5 23.5 56.5-23.5 23.5-56.5zM672 1248v-704q0-13-9.5-22.5t-22.5-9.5h-512q-13 0-22.5 9.5t-9.5 22.5v704q0 13 9.5 22.5t22.5 9.5h512q13 0 22.5-9.5t9.5-22.5zM480 400q0-16-16-16h-160q-16 0-16 16t16 16h160q16 0 16-16zM768 384v1024q0 52-38 90t-90 38h-512q-52 0-90-38t-38-90v-1024q0-52 38-90t90-38h512q52 0 90 38t38 90z"}]}})


/***/ }),
/* 1698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"mobile":{"width":768,"height":1792,"paths":[{"d":"M464 1408q0-33-23.5-56.5t-56.5-23.5-56.5 23.5-23.5 56.5 23.5 56.5 56.5 23.5 56.5-23.5 23.5-56.5zM672 1248v-704q0-13-9.5-22.5t-22.5-9.5h-512q-13 0-22.5 9.5t-9.5 22.5v704q0 13 9.5 22.5t22.5 9.5h512q13 0 22.5-9.5t9.5-22.5zM480 400q0-16-16-16h-160q-16 0-16 16t16 16h160q16 0 16-16zM768 384v1024q0 52-38 90t-90 38h-512q-52 0-90-38t-38-90v-1024q0-52 38-90t90-38h512q52 0 90 38t38 90z"}]}})


/***/ }),
/* 1699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"modx":{"width":1792,"height":1792,"paths":[{"d":"M1427 709l-614-386 92-151h855zM405 974l-184-116v-858l1183 743zM1424 839l147 95v858l-532-335zM1387 818l-500 802h-855l356-571z"}]}})


/***/ }),
/* 1700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"money":{"width":1920,"height":1792,"paths":[{"d":"M768 1152h384v-96h-128v-448h-114l-148 137 77 80q42-37 55-57h2v288h-128v96zM1280 896q0 70-21 142t-59.5 134-101.5 101-138 39-138-39-101.5-101-59.5-134-21-142 21-142 59.5-134 101.5-101 138-39 138 39 101.5 101 59.5 134 21 142zM1792 1152v-512q-106 0-181-75t-75-181h-1152q0 106-75 181t-181 75v512q106 0 181 75t75 181h1152q0-106 75-181t181-75zM1920 320v1152q0 26-19 45t-45 19h-1792q-26 0-45-19t-19-45v-1152q0-26 19-45t45-19h1792q26 0 45 19t19 45z"}]}})


/***/ }),
/* 1701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"moon-o":{"width":1536,"height":1792,"paths":[{"d":"M1262 1303q-54 9-110 9-182 0-337-90t-245-245-90-337q0-192 104-357-201 60-328.5 229t-127.5 384q0 130 51 248.5t136.5 204 204 136.5 248.5 51q144 0 273.5-61.5t220.5-171.5zM1465 1218q-94 203-283.5 324.5t-413.5 121.5q-156 0-298-61t-245-164-164-245-61-298q0-153 57.5-292.5t156-241.5 235.5-164.5 290-68.5q44-2 61 39 18 41-15 72-86 78-131.5 181.5t-45.5 218.5q0 148 73 273t198 198 273 73q118 0 228-51 41-18 72 13 14 14 17.5 34t-4.5 38z"}]}})


/***/ }),
/* 1702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"mortar-board":{"width":2304,"height":1792,"paths":[{"d":"M1774 836l18 316q4 69-82 128t-235 93.5-323 34.5-323-34.5-235-93.5-82-128l18-316 574 181q22 7 48 7t48-7zM2304 512q0 23-22 31l-1120 352q-4 1-10 1t-10-1l-652-206q-43 34-71 111.5t-34 178.5q63 36 63 109 0 69-58 107l58 433q2 14-8 25-9 11-24 11h-192q-15 0-24-11-10-11-8-25l58-433q-58-38-58-107 0-73 65-111 11-207 98-330l-333-104q-22-8-22-31t22-31l1120-352q4-1 10-1t10 1l1120 352q22 8 22 31z"}]}})


/***/ }),
/* 1703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"motorcycle":{"width":2304,"height":1792,"paths":[{"d":"M2301 1036q12 103-22 198.5t-99 163.5-158.5 106-196.5 31q-161-11-279.5-125t-134.5-274q-12-111 27.5-210.5t118.5-170.5l-71-107q-96 80-151 194t-55 244q0 27-18.5 46.5t-45.5 19.5h-256-69q-23 164-149 274t-294 110q-185 0-316.5-131.5t-131.5-316.5 131.5-316.5 316.5-131.5q76 0 152 27l24-45q-123-110-304-110h-64q-26 0-45-19t-19-45 19-45 45-19h128q78 0 145 13.5t116.5 38.5 71.5 39.5 51 36.5h512 115l-85-128h-222q-30 0-49-22.5t-14-52.5q4-23 23-38t43-15h253q33 0 53 28l70 105 114-114q19-19 46-19h101q26 0 45 19t19 45v128q0 26-19 45t-45 19h-179l115 172q131-63 275-36 143 26 244 134.5t118 253.5zM448 1408q115 0 203-72.5t111-183.5h-314q-35 0-55-31-18-32-1-63l147-277q-47-13-91-13-132 0-226 94t-94 226 94 226 226 94zM1856 1408q132 0 226-94t94-226-94-226-226-94q-60 0-121 24l174 260q15 23 10 49t-27 40q-15 11-36 11-35 0-53-29l-174-260q-93 95-93 225 0 132 94 226t226 94z"}]}})


/***/ }),
/* 1704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"mouse-pointer":{"width":1280,"height":1792,"paths":[{"d":"M1133 1043q31 30 14 69-17 40-59 40h-382l201 476q10 25 0 49t-34 35l-177 75q-25 10-49 0t-35-34l-191-452-312 312q-19 19-45 19-12 0-24-5-40-17-40-59v-1504q0-42 40-59 12-5 24-5 27 0 45 19z"}]}})


/***/ }),
/* 1705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"music":{"width":1536,"height":1792,"paths":[{"d":"M1536 224v1120q0 50-34 89t-86 60.5-103.5 32-96.5 10.5-96.5-10.5-103.5-32-86-60.5-34-89 34-89 86-60.5 103.5-32 96.5-10.5q105 0 192 39v-537l-768 237v709q0 50-34 89t-86 60.5-103.5 32-96.5 10.5-96.5-10.5-103.5-32-86-60.5-34-89 34-89 86-60.5 103.5-32 96.5-10.5q105 0 192 39v-967q0-31 19-56.5t49-35.5l832-256q12-4 28-4 40 0 68 28t28 68z"}]}})


/***/ }),
/* 1706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"navicon":{"width":1536,"height":1792,"paths":[{"d":"M1536 1344v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zM1536 832v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zM1536 320v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45z"}]}})


/***/ }),
/* 1707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"neuter":{"width":1280,"height":1792,"paths":[{"d":"M1152 576q0 221-147.5 384.5t-364.5 187.5v612q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-612q-217-24-364.5-187.5t-147.5-384.5q0-117 45.5-223.5t123-184 184-123 223.5-45.5 223.5 45.5 184 123 123 184 45.5 223.5zM576 1024q185 0 316.5-131.5t131.5-316.5-131.5-316.5-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5z"}]}})


/***/ }),
/* 1708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"newspaper-o":{"width":2048,"height":1792,"paths":[{"d":"M1024 512h-384v384h384v-384zM1152 1152v128h-640v-128h640zM1152 384v640h-640v-640h640zM1792 1152v128h-512v-128h512zM1792 896v128h-512v-128h512zM1792 640v128h-512v-128h512zM1792 384v128h-512v-128h512zM256 1344v-960h-128v960q0 26 19 45t45 19 45-19 19-45zM1920 1344v-1088h-1536v1088q0 33-11 64h1483q26 0 45-19t19-45zM2048 128v1216q0 80-56 136t-136 56h-1664q-80 0-136-56t-56-136v-1088h256v-128h1792z"}]}})


/***/ }),
/* 1709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"object-group":{"width":2048,"height":1792,"paths":[{"d":"M2048 384h-128v1024h128v384h-384v-128h-1280v128h-384v-384h128v-1024h-128v-384h384v128h1280v-128h384v384zM1792 128v128h128v-128h-128zM128 128v128h128v-128h-128zM256 1664v-128h-128v128h128zM1664 1536v-128h128v-1024h-128v-128h-1280v128h-128v1024h128v128h1280zM1920 1664v-128h-128v128h128zM1280 640h384v768h-896v-256h-384v-768h896v256zM512 1024h640v-512h-640v512zM1536 1280v-512h-256v384h-384v128h640z"}]}})


/***/ }),
/* 1710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"object-ungroup":{"width":2304,"height":1792,"paths":[{"d":"M2304 768h-128v640h128v384h-384v-128h-896v128h-384v-384h128v-128h-384v128h-384v-384h128v-640h-128v-384h384v128h896v-128h384v384h-128v128h384v-128h384v384zM2048 512v128h128v-128h-128zM1408 128v128h128v-128h-128zM128 128v128h128v-128h-128zM256 1280v-128h-128v128h128zM1536 1152h-128v128h128v-128zM384 1152h896v-128h128v-640h-128v-128h-896v128h-128v640h128v128zM896 1664v-128h-128v128h128zM2176 1664v-128h-128v128h128zM2048 1408v-640h-128v-128h-384v384h128v384h-384v-128h-384v128h128v128h896v-128h128z"}]}})


/***/ }),
/* 1711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"odnoklassniki-square":{"width":1536,"height":1792,"paths":[{"d":"M927 580q0 66-46.5 112.5t-112.5 46.5-112.5-46.5-46.5-112.5 46.5-112.5 112.5-46.5 112.5 46.5 46.5 112.5zM1141 943q-10-20-28-32t-47.5-9.5-60.5 27.5q-10 8-29 20t-81 32-127 20-124-18-86-36l-27-18q-31-25-60.5-27.5t-47.5 9.5-28 32q-22 45-2 74.5t87 73.5q83 53 226 67l-51 52q-142 142-191 190-22 22-22 52.5t22 52.5l9 9q22 22 52.5 22t52.5-22l191-191q114 115 191 191 22 22 52.5 22t52.5-22l9-9q22-22 22-52.5t-22-52.5l-191-190-52-52q141-14 225-67 67-44 87-73.5t-2-74.5zM1092 580q0-134-95-229t-229-95-229 95-95 229 95 229 229 95 229-95 95-229zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 1712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"odnoklassniki":{"width":1280,"height":1792,"paths":[{"d":"M640 907q-188 0-321-133t-133-320q0-188 133-321t321-133 321 133 133 321q0 187-133 320t-321 133zM640 230q-92 0-157.5 65.5t-65.5 158.5q0 92 65.5 157.5t157.5 65.5 157.5-65.5 65.5-157.5q0-93-65.5-158.5t-157.5-65.5zM1163 962q13 27 15 49.5t-4.5 40.5-26.5 38.5-42.5 37-61.5 41.5q-115 73-315 94l73 72 267 267q30 31 30 74t-30 73l-12 13q-31 30-74 30t-74-30q-67-68-267-268l-267 268q-31 30-74 30t-73-30l-12-13q-31-30-31-73t31-74l267-267 72-72q-203-21-317-94-39-25-61.5-41.5t-42.5-37-26.5-38.5-4.5-40.5 15-49.5q10-20 28-35t42-22 56 2 65 35q5 4 15 11t43 24.5 69 30.5 92 24 113 11q91 0 174-25.5t120-50.5l38-25q33-26 65-35t56-2 42 22 28 35z"}]}})


/***/ }),
/* 1713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"opencart":{"width":2304,"height":1792,"paths":[{"d":"M1524 1561q0 68-48 116t-116 48-116.5-48-48.5-116 48.5-116.5 116.5-48.5 116 48.5 48 116.5zM775 1561q0 68-48.5 116t-116.5 48-116-48-48-116 48-116.5 116-48.5 116.5 48.5 48.5 116.5zM0 67q57 60 110.5 104.5t121 82 136 63 166 45.5 200 31.5 250 18.5 304 9.5 372.5 2.5q139 0 244.5 5t181 16.5 124 27.5 71 39.5 24 51.5-19.5 64-56.5 76.5-89.5 91-116 104.5-139 119q-185 157-286 247 29-51 76.5-109t94-105.5 94.5-98.5 83-91.5 54-80.5 13-70-45.5-55.5-116.5-41-204-23.5-304-5q-168 2-314-6t-256-23-204.5-41-159.5-51.5-122.5-62.5-91.5-66.5-68-71.5-50.5-69.5-40-68-36.5-59.5z"}]}})


/***/ }),
/* 1714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"openid":{"width":1792,"height":1792,"paths":[{"d":"M1086 0v1536l-272 128q-228-20-414-102t-293-208.5-107-272.5q0-140 100.5-263.5t275-205.5 391.5-108v172q-217 38-356.5 150t-139.5 255q0 152 154.5 267t388.5 145v-1360zM1755 582l37 390-525-114 147-83q-119-70-280-99v-172q277 33 481 157z"}]}})


/***/ }),
/* 1715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"opera":{"width":1792,"height":1792,"paths":[{"d":"M1493 228q-165-110-359-110-155 0-293 73t-240 200q-75 93-119.5 218t-48.5 266v42q4 141 48.5 266t119.5 218q102 127 240 200t293 73q194 0 359-110-121 108-274.5 168t-322.5 60q-29 0-43-1-175-8-333-82t-272-193-181-281-67-339q0-182 71-348t191-286 286-191 348-71h3q168 1 320.5 60.5t273.5 167.5zM1792 896q0 192-77 362.5t-213 296.5q-104 63-222 63-137 0-255-84 154-56 253.5-233t99.5-405q0-227-99-404t-253-234q119-83 254-83 119 0 226 65 135 125 210.5 295t75.5 361z"}]}})


/***/ }),
/* 1716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"optin-monster":{"width":2296,"height":1792,"paths":[{"d":"M478 1675q-8 16-27 34.5t-37 25.5q-25 9-51.5-3.5t-28.5-31.5q-1-22 40-55t68-38q23-4 34 21.5t2 46.5zM1819 1675q7 16 26 34.5t38 25.5q25 9 51.5-3.5t27.5-31.5q2-22-39.5-55t-68.5-38q-22-4-33 21.5t-2 46.5zM1867 1566q13 27 56.5 59.5t77.5 41.5q45 13 82-4.5t37-50.5q0-46-67.5-100.5t-115.5-59.5q-40-5-63.5 37.5t-6.5 76.5zM428 1566q-13 27-56 59.5t-77 41.5q-45 13-82-4.5t-37-50.5q0-46 67.5-100.5t115.5-59.5q40-5 63 37.5t6 76.5zM1158 442h1q-41 0-76 15 27 8 44 30.5t17 49.5q0 35-27 60t-65 25q-52 0-80-43-5 23-5 42 0 74 56 126.5t135 52.5q80 0 136-52.5t56-126.5-56-126.5-136-52.5zM1462 224q-99-109-220.5-131.5t-245.5 44.5q27-60 82.5-96.5t118-39.5 121.5 17 99.5 74.5 44.5 131.5zM2212 1463q8 11-11 42 7 23 7 40 1 56-44.5 112.5t-109.5 91.5-118 37q-48 2-92-21.5t-66-65.5q-687 25-1259 0-23 41-66.5 65t-92.5 22q-86-3-179.5-80.5t-92.5-160.5q2-22 7-40-19-31-11-42 6-10 31-1 14-22 41-51-7-29 2-38 11-10 39 4 29-20 59-34 0-29 13-37 23-12 51 16 35-5 61 2 18 4 38 19v-73q-11 0-18-2-53-10-97-44.5t-55-87.5q-9-38 0-81 15-62 93-95 2-17 19-35.5t36-23.5 33 7.5 19 30.5h13q46 5 60 23 3 3 5 7 10-1 30.5-3.5t30.5-3.5q-15-11-30-17-23-40-91-43 0-6 1-10-62-2-118.5-18.5t-84.5-47.5q-32-36-42.5-92t-2.5-112q16-126 90-179 23-16 52-4.5t32 40.5q0 1 1.5 14t2.5 21 3 20 5.5 19 8.5 10q27 14 76 12 48-46 98-74-40-4-162 14l47-46q61-58 163-111 145-73 282-86-20-8-41-15.5t-47-14-42.5-10.5-47.5-11-43-10q595-126 904 139 98 84 158 222 85 10 121-9h1q5-3 8.5-10t5.5-19 3-19.5 3-21.5l1-14q3-28 32-40t52 5q73 52 91 178 7 57-3.5 113t-42.5 91q-28 32-83.5 48.5t-115.5 18.5v10q-71 2-95 43-14 5-31 17 11 1 32 3.5t30 3.5q1-5 5-8 16-18 60-23h13q5-18 19-30t33-8 36 23 19 36q79 32 93 95 9 40 1 81-12 53-56 88t-97 44q-10 2-17 2 0 49-1 73 20-15 38-19 26-7 61-2 28-28 51-16 14 9 14 37 33 16 59 34 27-13 38-4 10 10 2 38 28 30 41 51 23-8 31 1zM1937 511q0 29-9 54 82 32 112 132 4-37-9.5-98.5t-41.5-90.5q-20-19-36-17t-16 20zM1859 611q35 42 47.5 108.5t-0.5 124.5q67-13 97-45 13-14 18-28-3-64-31-114.5t-79-66.5q-15 15-52 21zM1822 615q-30 0-44-1 42 115 53 239 21 0 43-3 16-68 1-135t-53-100zM258 697q30-100 112-132-9-25-9-54 0-18-16.5-20t-35.5 17q-28 29-41.5 90.5t-9.5 98.5zM294 799q29 31 97 45-13-58-0.5-124.5t47.5-108.5v0q-37-6-52-21-51 16-78.5 66t-31.5 115q9 17 18 28zM471 853q14-124 73-235-19 4-55 18l-45 19v-1q-46 89-20 196 25 3 47 3zM1434 892q8 38 16.5 108.5t11.5 89.5q3 18 9.5 21.5t23.5-4.5q40-20 62-85.5t23-125.5q-24-2-146-4zM1152 251q-116 0-199 82.5t-83 198.5q0 117 83 199.5t199 82.5 199-82.5 83-199.5q0-116-83-198.5t-199-82.5zM1380 890q-105-2-211 0v-1q-1 27 2.5 86t13.5 66q29 14 93.5 14.5t95.5-10.5q9-3 11-39t-0.5-69.5-4.5-46.5zM1112 1089q8-4 9.5-48t-0.5-88-4-63v-1q-212 3-214 3-4 20-7 62t0 83 14 46q34 15 101 16t101-10zM718 900q-16 59 4.5 118.5t77.5 84.5q15 8 24 5t12-21q3-16 8-90t10-103q-69 2-136 6zM591 1026q3 23-34 36 132 141 271.5 240t305.5 154q172-49 310.5-146t293.5-250q-33-13-30-34 0-2 0.5-3.5t1.5-3 1-2.5v-1 1q-17-2-50-5.5t-48-4.5q-26 90-82 132-51 38-82-1-5-6-9-14-7-13-17-62-2 5-5 9t-7.5 7-8 5.5-9.5 4l-10 2.5t-12 2l-12 1.5t-13.5 1-13.5 0.5q-106 9-163-11-4 17-10 26.5t-21 15-23 7-36 3.5q-6 1-9 1-179 17-203-40-2 63-56 54-47-8-91-54-12-13-20-26-17-29-26-65-58 6-87 10 1 2 4 10zM507 1654q3-14 3-30-17-71-51-130t-73-70q-41-12-101.5 14.5t-104.5 80-39 107.5q35 53 100 93t119 42q51 2 94-28t53-79zM510 1483q23 63 27 119 195-113 392-174-98-52-180.5-120t-179.5-165q-6 4-29 13 0 1-1 4t-1 5q31 18 22 37-12 23-56 34-10 13-29 24h-1q-2 83 1 150 19 34 35 73zM579 1649q532 21 1145 0-254-147-428-196-76 35-156 57-8 3-16 0-65-21-129-49-208 60-416 188h-1v1q1 0 1-1zM1763 1603q4-54 28-120 14-38 33-71l-1 1q3-77 3-153-15-8-30-25-42-9-56-33-9-20 22-38-2-4-2-9-16-4-28-12-204 190-383 284 198 59 414 176zM2155 1626q5-54-39-107.5t-104-80-102-14.5q-38 11-72.5 70.5t-51.5 129.5q0 16 3 30 10 49 53 79t94 28q54-2 119-42t100-93z"}]}})


/***/ }),
/* 1717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"outdent":{"width":1792,"height":1792,"paths":[{"d":"M384 544v576q0 13-9.5 22.5t-22.5 9.5q-14 0-23-9l-288-288q-9-9-9-23t9-23l288-288q9-9 23-9 13 0 22.5 9.5t9.5 22.5zM1792 1312v192q0 13-9.5 22.5t-22.5 9.5h-1728q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1728q13 0 22.5 9.5t9.5 22.5zM1792 928v192q0 13-9.5 22.5t-22.5 9.5h-1088q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1088q13 0 22.5 9.5t9.5 22.5zM1792 544v192q0 13-9.5 22.5t-22.5 9.5h-1088q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1088q13 0 22.5 9.5t9.5 22.5zM1792 160v192q0 13-9.5 22.5t-22.5 9.5h-1728q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1728q13 0 22.5 9.5t9.5 22.5z"}]}})


/***/ }),
/* 1718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"pagelines":{"width":1408,"height":1792,"paths":[{"d":"M1402 1103q-32 80-76 138t-91 88.5-99 46.5-101.5 14.5-96.5-8.5-86.5-22-69.5-27.5-46-22.5l-17-10q-113 228-289.5 359.5t-384.5 132.5q-19 0-32-13t-13-32 13-31.5 32-12.5q173-1 322.5-107.5t251.5-294.5q-36 14-72 23t-83 13-91-2.5-93-28.5-92-59-84.5-100-74.5-146q114-47 214-57t167.5 7.5 124.5 56.5 88.5 77 56.5 82q53-131 79-291-7 1-18 2.5t-46.5 2.5-69.5-0.5-81.5-10-88.5-23-84-42.5-75-65-54.5-94.5-28.5-127.5q70-28 133.5-36.5t112.5 1 92 30 73.5 50 56 61 42 63 27.5 56 16 39.5l4 16q12-122 12-195-8-6-21.5-16t-49-44.5-63.5-71.5-54-93-33-112.5 12-127 70-138.5q73 25 127.5 61.5t84.5 76.5 48 85 20.5 89-0.5 85.5-13 76.5-19 62-17 42l-7 15q1 4 1 50t-1 72q3-7 10-18.5t30.5-43 50.5-58 71-55.5 91.5-44.5 112-14.5 132.5 24q-2 78-21.5 141.5t-50 104.5-69.5 71.5-81.5 45.5-84.5 24-80 9.5-67.5-1-46.5-4.5l-17-3q-23 147-73 283 6-7 18-18.5t49.5-41 77.5-52.5 99.5-42 117.5-20 129 23.5 137 77.5z"}]}})


/***/ }),
/* 1719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"paint-brush":{"width":1792,"height":1792,"paths":[{"d":"M1615 0q70 0 122.5 46.5t52.5 116.5q0 63-45 151-332 629-465 752-97 91-218 91-126 0-216.5-92.5t-90.5-219.5q0-128 92-212l638-579q59-54 130-54zM706 1034q39 76 106.5 130t150.5 76l1 71q4 213-129.5 347t-348.5 134q-123 0-218-46.5t-152.5-127.5-86.5-183-29-220q7 5 41 30t62 44.5 59 36.5 46 17q41 0 55-37 25-66 57.5-112.5t69.5-76 88-47.5 103-25.5 125-10.5z"}]}})


/***/ }),
/* 1720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"paper-plane-o":{"width":1792,"height":1792,"paths":[{"d":"M1764 11q33 24 27 64l-256 1536q-5 29-32 45-14 8-31 8-11 0-24-5l-527-215-298 327q-18 21-47 21-14 0-23-4-19-7-30-23.5t-11-36.5v-452l-472-193q-37-14-40-55-3-39 32-59l1664-960q35-21 68 2zM1422 1510l221-1323-1434 827 336 137 863-639-478 797z"}]}})


/***/ }),
/* 1721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"paper-plane":{"width":1792,"height":1792,"paths":[{"d":"M1764 11q33 24 27 64l-256 1536q-5 29-32 45-14 8-31 8-11 0-24-5l-453-185-242 295q-18 23-49 23-13 0-22-4-19-7-30.5-23.5t-11.5-36.5v-349l864-1059-1069 925-395-162q-37-14-40-55-2-40 32-59l1664-960q15-9 32-9 20 0 36 11z"}]}})


/***/ }),
/* 1722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"paperclip":{"width":1408,"height":1792,"paths":[{"d":"M1404 1385q0 117-79 196t-196 79q-135 0-235-100l-777-776q-113-115-113-271 0-159 110-270t269-111q158 0 273 113l605 606q10 10 10 22 0 16-30.5 46.5t-46.5 30.5q-13 0-23-10l-606-607q-79-77-181-77-106 0-179 75t-73 181q0 105 76 181l776 777q63 63 145 63 64 0 106-42t42-106q0-82-63-145l-581-581q-26-24-60-24-29 0-48 19t-19 48q0 32 25 59l410 410q10 10 10 22 0 16-31 47t-47 31q-12 0-22-10l-410-410q-63-61-63-149 0-82 57-139t139-57q88 0 149 63l581 581q100 98 100 235z"}]}})


/***/ }),
/* 1723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"paragraph":{"width":1280,"height":1792,"paths":[{"d":"M1278 189v73q0 29-18.5 61t-42.5 32q-50 0-54 1-26 6-32 31-3 11-3 64v1152q0 25-18 43t-43 18h-108q-25 0-43-18t-18-43v-1218h-143v1218q0 25-17.5 43t-43.5 18h-108q-26 0-43.5-18t-17.5-43v-496q-147-12-245-59-126-58-192-179-64-117-64-259 0-166 88-286 88-118 209-159 111-37 417-37h479q25 0 43 18t18 43z"}]}})


/***/ }),
/* 1724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"paste":{"width":1792,"height":1792,"paths":[{"d":"M768 1664h896v-640h-416q-40 0-68-28t-28-68v-416h-384v1152zM1024 224v-64q0-13-9.5-22.5t-22.5-9.5h-704q-13 0-22.5 9.5t-9.5 22.5v64q0 13 9.5 22.5t22.5 9.5h704q13 0 22.5-9.5t9.5-22.5zM1280 896h299l-299-299v299zM1792 1024v672q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-160h-544q-40 0-68-28t-28-68v-1344q0-40 28-68t68-28h1088q40 0 68 28t28 68v328q21 13 36 28l408 408q28 28 48 76t20 88z"}]}})


/***/ }),
/* 1725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"pause-circle-o":{"width":1536,"height":1792,"paths":[{"d":"M768 128q209 0 385.5 103t279.5 279.5 103 385.5-103 385.5-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103zM768 1440q148 0 273-73t198-198 73-273-73-273-198-198-273-73-273 73-198 198-73 273 73 273 198 198 273 73zM864 1216q-14 0-23-9t-9-23v-576q0-14 9-23t23-9h192q14 0 23 9t9 23v576q0 14-9 23t-23 9h-192zM480 1216q-14 0-23-9t-9-23v-576q0-14 9-23t23-9h192q14 0 23 9t9 23v576q0 14-9 23t-23 9h-192z"}]}})


/***/ }),
/* 1726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"pause-circle":{"width":1536,"height":1792,"paths":[{"d":"M704 1184v-576q0-14-9-23t-23-9h-256q-14 0-23 9t-9 23v576q0 14 9 23t23 9h256q14 0 23-9t9-23zM1152 1184v-576q0-14-9-23t-23-9h-256q-14 0-23 9t-9 23v576q0 14 9 23t23 9h256q14 0 23-9t9-23zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"pause":{"width":1536,"height":1792,"paths":[{"d":"M1536 192v1408q0 26-19 45t-45 19h-512q-26 0-45-19t-19-45v-1408q0-26 19-45t45-19h512q26 0 45 19t19 45zM640 192v1408q0 26-19 45t-45 19h-512q-26 0-45-19t-19-45v-1408q0-26 19-45t45-19h512q26 0 45 19t19 45z"}]}})


/***/ }),
/* 1728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"paw":{"width":1664,"height":1792,"paths":[{"d":"M780 472q0 60-19 113.5t-63 92.5-105 39q-76 0-138-57.5t-92-135.5-30-151q0-60 19-113.5t63-92.5 105-39q77 0 138.5 57.5t91.5 135 30 151.5zM438 955q0 80-42 139t-119 59q-76 0-141.5-55.5t-100.5-133.5-35-152q0-80 42-139.5t119-59.5q76 0 141.5 55.5t100.5 134 35 152.5zM832 928q118 0 255 97.5t229 237 92 254.5q0 46-17 76.5t-48.5 45-64.5 20-76 5.5q-68 0-187.5-45t-182.5-45q-66 0-192.5 44.5t-200.5 44.5q-183 0-183-146 0-86 56-191.5t139.5-192.5 187.5-146 193-59zM1071 717q-61 0-105-39t-63-92.5-19-113.5q0-74 30-151.5t91.5-135 138.5-57.5q61 0 105 39t63 92.5 19 113.5q0 73-30 151t-92 135.5-138 57.5zM1503 613q77 0 119 59.5t42 139.5q0 74-35 152t-100.5 133.5-141.5 55.5q-77 0-119-59t-42-139q0-74 35-152.5t100.5-134 141.5-55.5z"}]}})


/***/ }),
/* 1729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"paypal":{"width":1536,"height":1792,"paths":[{"d":"M1519 646q18 84-4 204-87 444-565 444h-44q-25 0-44 16.5t-24 42.5l-4 19-55 346-2 15q-5 26-24.5 42.5t-44.5 16.5h-251q-21 0-33-15t-9-36q9-56 26.5-168t26.5-168 27-167.5 27-167.5q5-37 43-37h131q133 2 236-21 175-39 287-144 102-95 155-246 24-70 35-133 1-6 2.5-7.5t3.5-1 6 3.5q79 59 98 162zM1347 364q0 107-46 236-80 233-302 315-113 40-252 42 0 1-90 1l-90-1q-100 0-118 96-2 8-85 530-1 10-12 10h-295q-22 0-36.5-16.5t-11.5-38.5l232-1471q5-29 27.5-48t51.5-19h598q34 0 97.5 13t111.5 32q107 41 163.5 123t56.5 196z"}]}})


/***/ }),
/* 1730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"pencil-square-o":{"width":1792,"height":1792,"paths":[{"d":"M888 1184l116-116-152-152-116 116v56h96v96h56zM1328 464q-16-16-33 1l-350 350q-17 17-1 33t33-1l350-350q17-17 1-33zM1408 1058v190q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q63 0 117 25 15 7 18 23 3 17-9 29l-49 49q-14 14-32 8-23-6-45-6h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113v-126q0-13 9-22l64-64q15-15 35-7t20 29zM1312 320l288 288-672 672h-288v-288zM1756 452l-92 92-288-288 92-92q28-28 68-28t68 28l152 152q28 28 28 68t-28 68z"}]}})


/***/ }),
/* 1731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"pencil-square":{"width":1536,"height":1792,"paths":[{"d":"M404 1108l152 152-52 52h-56v-96h-96v-56zM818 718q14 13-3 30l-291 291q-17 17-30 3-14-13 3-30l291-291q17-17 30-3zM544 1408l544-544-288-288-544 544v288h288zM1152 800l92-92q28-28 28-68t-28-68l-152-152q-28-28-68-28t-68 28l-92 92zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 1732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"pencil":{"width":1536,"height":1792,"paths":[{"d":"M363 1536l91-91-235-235-91 91v107h128v128h107zM886 608q0-22-22-22-10 0-17 7l-542 542q-7 7-7 17 0 22 22 22 10 0 17-7l542-542q7-7 7-17zM832 416l416 416-832 832h-416v-416zM1515 512q0 53-37 90l-166 166-416-416 166-165q36-38 90-38 53 0 91 38l235 234q37 39 37 91z"}]}})


/***/ }),
/* 1733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"percent":{"width":1536,"height":1792,"paths":[{"d":"M1280 1280q0-52-38-90t-90-38-90 38-38 90 38 90 90 38 90-38 38-90zM512 512q0-52-38-90t-90-38-90 38-38 90 38 90 90 38 90-38 38-90zM1536 1280q0 159-112.5 271.5t-271.5 112.5-271.5-112.5-112.5-271.5 112.5-271.5 271.5-112.5 271.5 112.5 112.5 271.5zM1440 192q0 20-13 38l-1056 1408q-19 26-51 26h-160q-26 0-45-19t-19-45q0-20 13-38l1056-1408q19-26 51-26h160q26 0 45 19t19 45zM768 512q0 159-112.5 271.5t-271.5 112.5-271.5-112.5-112.5-271.5 112.5-271.5 271.5-112.5 271.5 112.5 112.5 271.5z"}]}})


/***/ }),
/* 1734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"phone-square":{"width":1536,"height":1792,"paths":[{"d":"M1280 1193q0-11-2-16t-18-16.5-40.5-25-47.5-26.5-45.5-25-28.5-15q-5-3-19-13t-25-15-21-5q-15 0-36.5 20.5t-39.5 45-38.5 45-33.5 20.5q-7 0-16.5-3.5t-15.5-6.5-17-9.5-14-8.5q-99-55-170-126.5t-127-170.5q-2-3-8.5-14t-9.5-17-6.5-15.5-3.5-16.5q0-13 20.5-33.5t45-38.5 45-39.5 20.5-36.5q0-10-5-21t-15-25-13-19q-3-6-15-28.5t-25-45.5-26.5-47.5-25-40.5-16.5-18-16-2q-48 0-101 22-46 21-80 94.5t-34 130.5q0 16 2.5 34t5 30.5 9 33 10 29.5 12.5 33 11 30q60 164 216.5 320.5t320.5 216.5q6 2 30 11t33 12.5 29.5 10 33 9 30.5 5 34 2.5q57 0 130.5-34t94.5-80q22-53 22-101zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 1735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"phone":{"width":1408,"height":1792,"paths":[{"d":"M1408 1240q0 27-10 70.5t-21 68.5q-21 50-122 106-94 51-186 51-27 0-53-3.5t-57.5-12.5-47-14.5-55.5-20.5-49-18q-98-35-175-83-127-79-264-216t-216-264q-48-77-83-175-3-9-18-49t-20.5-55.5-14.5-47-12.5-57.5-3.5-53q0-92 51-186 56-101 106-122 25-11 68.5-21t70.5-10q14 0 21 3 18 6 53 76 11 19 30 54t35 63.5 31 53.5q3 4 17.5 25t21.5 35.5 7 28.5q0 20-28.5 50t-62 55-62 53-28.5 46q0 9 5 22.5t8.5 20.5 14 24 11.5 19q76 137 174 235t235 174q2 1 19 11.5t24 14 20.5 8.5 22.5 5q18 0 46-28.5t53-62 55-62 50-28.5q14 0 28.5 7t35.5 21.5 25 17.5q25 15 53.5 31t63.5 35 54 30q70 35 76 53 3 7 3 21z"}]}})


/***/ }),
/* 1736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"photo":{"width":1920,"height":1792,"paths":[{"d":"M640 576q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM1664 960v448h-1408v-192l320-320 160 160 512-512zM1760 256h-1600q-13 0-22.5 9.5t-9.5 22.5v1216q0 13 9.5 22.5t22.5 9.5h1600q13 0 22.5-9.5t9.5-22.5v-1216q0-13-9.5-22.5t-22.5-9.5zM1920 288v1216q0 66-47 113t-113 47h-1600q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1600q66 0 113 47t47 113z"}]}})


/***/ }),
/* 1737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"picture-o":{"width":1920,"height":1792,"paths":[{"d":"M640 576q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM1664 960v448h-1408v-192l320-320 160 160 512-512zM1760 256h-1600q-13 0-22.5 9.5t-9.5 22.5v1216q0 13 9.5 22.5t22.5 9.5h1600q13 0 22.5-9.5t9.5-22.5v-1216q0-13-9.5-22.5t-22.5-9.5zM1920 288v1216q0 66-47 113t-113 47h-1600q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1600q66 0 113 47t47 113z"}]}})


/***/ }),
/* 1738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"pie-chart":{"width":1792,"height":1792,"paths":[{"d":"M768 890l546 546q-106 108-247.5 168t-298.5 60q-209 0-385.5-103t-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103v762zM955 896h773q0 157-60 298.5t-168 247.5zM1664 768h-768v-768q209 0 385.5 103t279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"pied-piper-alt":{"width":2038,"height":1792,"paths":[{"d":"M1222 929q75-3 143.5 20.5t118 58.5 101 94.5 84 108 75.5 120.5q33 56 78.5 109t75.5 80.5 99 88.5q-48 30-108.5 57.5t-138.5 59-114 47.5q-44-37-74-115t-43.5-164.5-33-180.5-42.5-168.5-72.5-123-122.5-48.5l-10 2-6 4q4 5 13 14 6 5 28 23.5t25.5 22 19 18 18 20.5 11.5 21 10.5 27.5 4.5 31 4 40.5l1 33q1 26-2.5 57.5t-7.5 52-12.5 58.5-11.5 53q-35-1-101 9.5t-98 10.5q-39 0-72-10-2-16-2-47 0-74 3-96 2-13 31.5-41.5t57-59 26.5-51.5q-24-2-43 24-36 53-111.5 99.5t-136.5 46.5q-25 0-75.5-63t-106.5-139.5-84-96.5q-6-4-27-30-482 112-513 112-16 0-28-11t-12-27q0-15 8.5-26.5t22.5-14.5l486-106q-8-14-8-25t5.5-17.5 16-11.5 20-7 23-4.5 18.5-4.5q4-1 15.5-7.5t17.5-6.5q15 0 28 16t20 33q163-37 172-37 17 0 29.5 11t12.5 28q0 15-8.5 26t-23.5 14l-182 40-1 16q-1 26 81.5 117.5t104.5 91.5q47 0 119-80t72-129q0-36-23.5-53t-51-18.5-51-11.5-23.5-34q0-16 10-34l-68-19q43-44 43-117 0-26-5-58 82-16 144-16 44 0 71.5 1.5t48.5 8.5 31 13.5 20.5 24.5 15.5 33.5 17 47.5 24 60l50-25q-3 40-23 60t-42.5 21-40 6.5-16.5 20.5zM1282 694q-5-5-13.5-15.5t-12-14.5-10.5-11.5-10-10.5l-8-8t-8.5-7.5-8-5-8.5-4.5q-7-3-14.5-5t-20.5-2.5-22-0.5h-32.5-37.5q-126 0-217 43 16-30 36-46.5t54-29.5 65.5-36 46-36.5 50-55 43.5-50.5q12 9 28 31.5t32 36.5 38 13l12-1v76l22 1q247-95 371-190 28-21 50-39t42.5-37.5 33-31 29.5-34 24-31 24.5-37 23-38 27-47.5 29.5-53l7-9q-2 53-43 139-79 165-205 264t-306 142q-14 3-42 7.5t-50 9.5-39 14q3 19 24.5 46t21.5 34q0 11-26 30zM1061 1615q39-26 131.5-47.5t146.5-21.5q9 0 22.5 15.5t28 42.5 26 50 24 51 14.5 33q-121 45-244 45-61 0-125-11zM822 968l48-12 109 177-73 48zM1323 1485q3 15 3 16 0 7-17.5 14.5t-46 13-54 9.5-53.5 7.5-32 4.5l-7-43q21-2 60.5-8.5t72-10 60.5-3.5h14zM866 857l-96 20-6-17q10-1 32.5-7t34.5-6q19 0 35 10zM1061 1491h31l10 83-41 12v-95zM1950 1v-1 1zM1950 1l-1 5-2 2 1-3zM1950 1l1-1z"}]}})


/***/ }),
/* 1740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"pied-piper-pp":{"width":1536,"height":1792,"paths":[{"d":"M1046 1020q0 64-38 109t-91 45q-43 0-70-15v-277q28-17 70-17 53 0 91 45.5t38 109.5zM703 592q0 64-38 109.5t-91 45.5q-43 0-70-15v-277q28-17 70-17 53 0 91 45t38 109zM1265 1023q0-134-88-229t-213-95q-20 0-39 3-23 78-78 136-87 95-211 101v636l211-41v-206q51 19 117 19 125 0 213-95t88-229zM922 596q0-134-88.5-229t-213.5-95q-74 0-141 36h-186v840l211-41v-206q55 19 116 19 125 0 213.5-95t88.5-229zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 1741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"pied-piper":{"width":2304,"height":1792,"paths":[{"d":"M2304 0q-69 46-125 92t-89 81-59.5 71.5-37.5 57.5-22 44.5-14 29.5q-10 18-35.5 136.5t-48.5 164.5q-15 29-50 60.5t-67.5 50.5-72.5 41-48 28q-47 31-151 231-341-14-630 158-92 53-303 179 47-16 86-31t55-22l15-7q71-27 163-64.5t133.5-53.5 108-34.5 142.5-31.5q186-31 465 7 1 0 10 3 11 6 14 17t-3 22l-194 345q-15 29-47 22-128-24-354-24-146 0-402 44.5t-392 46.5q-82 1-149-13t-107-37-61-40-33-34l-1-1v-2q0-6 6-6 138 0 371-55 192-366 374.5-524t383.5-158q5 0 14.5 0.5t38 5 55 12 61.5 24.5 63 39.5 54 59 40 82.5l102-177q2-4 21-42.5t44.5-86.5 61-109.5 84-133.5 100.5-137q66-82 128-141.5t121.5-96.5 92.5-53.5 88-39.5z"}]}})


/***/ }),
/* 1742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"pinterest-p":{"width":1280,"height":1792,"paths":[{"d":"M0 597q0-108 37.5-203.5t103.5-166.5 152-123 185-78 202-26q158 0 294 66.5t221 193.5 85 287q0 96-19 188t-60 177-100 149.5-145 103-189 38.5q-68 0-135-32t-96-88q-10 39-28 112.5t-23.5 95-20.5 71-26 71-32 62.5-46 77.5-62 86.5l-14 5-9-10q-15-157-15-188 0-92 21.5-206.5t66.5-287.5 52-203q-32-65-32-169 0-83 52-156t132-73q61 0 95 40.5t34 102.5q0 66-44 191t-44 187q0 63 45 104.5t109 41.5q55 0 102-25t78.5-68 56-95 38-110.5 20-111 6.5-99.5q0-173-109.5-269.5t-285.5-96.5q-200 0-334 129.5t-134 328.5q0 44 12.5 85t27 65 27 45.5 12.5 30.5q0 28-15 73t-37 45q-2 0-17-3-51-15-90.5-56t-61-94.5-32.5-108-11-106.5z"}]}})


/***/ }),
/* 1743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"pinterest-square":{"width":1536,"height":1792,"paths":[{"d":"M1248 128q119 0 203.5 84.5t84.5 203.5v960q0 119-84.5 203.5t-203.5 84.5h-725q85-122 108-210 9-34 53-209 21 39 73.5 67t112.5 28q181 0 295.5-147.5t114.5-373.5q0-84-35-162.5t-96.5-139-152.5-97-197-36.5q-104 0-194.5 28.5t-153 76.5-107.5 109.5-66.5 128-21.5 132.5q0 102 39.5 180t116.5 110q13 5 23.5 0t14.5-19q10-44 15-61 6-23-11-42-50-62-50-150 0-150 103.5-256.5t270.5-106.5q149 0 232.5 81t83.5 210q0 168-67.5 286t-173.5 118q-60 0-97-43.5t-23-103.5q8-34 26.5-92.5t29.5-102 11-74.5q0-49-26.5-81.5t-75.5-32.5q-61 0-103.5 56.5t-42.5 139.5q0 72 24 121l-98 414q-24 100-7 254h-183q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960z"}]}})


/***/ }),
/* 1744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"pinterest":{"width":1536,"height":1792,"paths":[{"d":"M1536 896q0 209-103 385.5t-279.5 279.5-385.5 103q-111 0-218-32 59-93 78-164 9-34 54-211 20 39 73 67.5t114 28.5q121 0 216-68.5t147-188.5 52-270q0-114-59.5-214t-172.5-163-255-63q-105 0-196 29t-154.5 77-109 110.5-67 129.5-21.5 134q0 104 40 183t117 111q30 12 38-20 2-7 8-31t8-30q6-23-11-43-51-61-51-151 0-151 104.5-259.5t273.5-108.5q151 0 235.5 82t84.5 213q0 170-68.5 289t-175.5 119q-61 0-98-43.5t-23-104.5q8-35 26.5-93.5t30-103 11.5-75.5q0-50-27-83t-77-33q-62 0-105 57t-43 142q0 73 25 122l-99 418q-17 70-13 177-206-91-333-281t-127-423q0-209 103-385.5t279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"plane":{"width":1408,"height":1792,"paths":[{"d":"M1376 160q44 52 12 148t-108 172l-161 161 160 696q5 19-12 33l-128 96q-7 6-19 6-4 0-7-1-15-3-21-16l-279-508-259 259 53 194q5 17-8 31l-96 96q-9 9-23 9h-2q-15-2-24-13l-189-252-252-189q-11-7-13-23-1-13 9-25l96-97q9-9 23-9 6 0 8 1l194 53 259-259-508-279q-14-8-17-24-2-16 9-27l128-128q14-13 30-8l665 159 160-160q76-76 172-108t148 12z"}]}})


/***/ }),
/* 1746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"play-circle-o":{"width":1536,"height":1792,"paths":[{"d":"M1184 896q0 37-32 55l-544 320q-15 9-32 9-16 0-32-8-32-19-32-56v-640q0-37 32-56 33-18 64 1l544 320q32 18 32 55zM1312 896q0-148-73-273t-198-198-273-73-273 73-198 198-73 273 73 273 198 198 273 73 273-73 198-198 73-273zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"play-circle":{"width":1536,"height":1792,"paths":[{"d":"M768 128q209 0 385.5 103t279.5 279.5 103 385.5-103 385.5-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103zM1152 951q32-18 32-55t-32-55l-544-320q-31-19-64-1-32 19-32 56v640q0 37 32 56 16 8 32 8 17 0 32-9z"}]}})


/***/ }),
/* 1748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"play":{"width":1408,"height":1792,"paths":[{"d":"M1384 927l-1328 738q-23 13-39.5 3t-16.5-36v-1472q0-26 16.5-36t39.5 3l1328 738q23 13 23 31t-23 31z"}]}})


/***/ }),
/* 1749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"plug":{"width":1792,"height":1792,"paths":[{"d":"M1755 453q37 38 37 90.5t-37 90.5l-401 400 150 150-160 160q-163 163-389.5 186.5t-411.5-100.5l-362 362h-181v-181l362-362q-124-185-100.5-411.5t186.5-389.5l160-160 150 150 400-401q38-37 91-37t90 37 37 90.5-37 90.5l-400 401 234 234 401-400q38-37 91-37t90 37z"}]}})


/***/ }),
/* 1750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"plus-circle":{"width":1536,"height":1792,"paths":[{"d":"M1216 960v-128q0-26-19-45t-45-19h-256v-256q0-26-19-45t-45-19h-128q-26 0-45 19t-19 45v256h-256q-26 0-45 19t-19 45v128q0 26 19 45t45 19h256v256q0 26 19 45t45 19h128q26 0 45-19t19-45v-256h256q26 0 45-19t19-45zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"plus-square-o":{"width":1408,"height":1792,"paths":[{"d":"M1152 800v64q0 14-9 23t-23 9h-352v352q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-352h-352q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h352v-352q0-14 9-23t23-9h64q14 0 23 9t9 23v352h352q14 0 23 9t9 23zM1280 1248v-832q0-66-47-113t-113-47h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113zM1408 416v832q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 1752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"plus-square":{"width":1536,"height":1792,"paths":[{"d":"M1280 960v-128q0-26-19-45t-45-19h-320v-320q0-26-19-45t-45-19h-128q-26 0-45 19t-19 45v320h-320q-26 0-45 19t-19 45v128q0 26 19 45t45 19h320v320q0 26 19 45t45 19h128q26 0 45-19t19-45v-320h320q26 0 45-19t19-45zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 1753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"plus":{"width":1408,"height":1792,"paths":[{"d":"M1408 736v192q0 40-28 68t-68 28h-416v416q0 40-28 68t-68 28h-192q-40 0-68-28t-28-68v-416h-416q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h416v-416q0-40 28-68t68-28h192q40 0 68 28t28 68v416h416q40 0 68 28t28 68z"}]}})


/***/ }),
/* 1754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"podcast":{"width":1536,"height":1792,"paths":[{"d":"M994 1192q0 86-17 197-31 215-55 313-22 90-152 90t-152-90q-24-98-55-313-17-110-17-197 0-168 224-168t224 168zM1536 768q0 240-134 434t-350 280q-8 3-15-3t-6-15q7-48 10-66 4-32 6-47 1-9 9-12 159-81 255.5-234t96.5-337q0-180-91-330.5t-247-234.5-337-74q-124 7-237 61t-193.5 140.5-128 202-46.5 240.5q1 184 99 336.5t257 231.5q7 3 9 12 3 21 6 45 1 9 5 32.5t6 35.5q1 9-6.5 15t-15.5 2q-148-58-261-169.5t-173.5-264-52.5-319.5q7-143 66-273.5t154.5-227 225-157.5 272.5-70q164-10 315.5 46.5t261 160.5 175 250.5 65.5 308.5zM994 736q0 93-65.5 158.5t-158.5 65.5-158.5-65.5-65.5-158.5 65.5-158.5 158.5-65.5 158.5 65.5 65.5 158.5zM1282 768q0 122-53.5 228.5t-146.5 177.5q-8 6-16 2t-10-14q-6-52-29-92-7-10 3-20 58-54 91-127t33-155q0-111-58.5-204t-157.5-141.5-212-36.5q-133 15-229 113t-109 231q-10 92 23.5 176t98.5 144q10 10 3 20-24 41-29 93-2 9-10 13t-16-2q-95-74-148.5-183t-51.5-234q3-131 69-244t177-181.5 241-74.5q144-7 268 60t196.5 187.5 72.5 263.5z"}]}})


/***/ }),
/* 1755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"power-off":{"width":1536,"height":1792,"paths":[{"d":"M1536 896q0 156-61 298t-164 245-245 164-298 61-298-61-245-164-164-245-61-298q0-182 80.5-343t226.5-270q43-32 95.5-25t83.5 50q32 42 24.5 94.5t-49.5 84.5q-98 74-151.5 181t-53.5 228q0 104 40.5 198.5t109.5 163.5 163.5 109.5 198.5 40.5 198.5-40.5 163.5-109.5 109.5-163.5 40.5-198.5q0-121-53.5-228t-151.5-181q-42-32-49.5-84.5t24.5-94.5q31-43 84-50t95 25q146 109 226.5 270t80.5 343zM896 128v640q0 52-38 90t-90 38-90-38-38-90v-640q0-52 38-90t90-38 90 38 38 90z"}]}})


/***/ }),
/* 1756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"print":{"width":1664,"height":1792,"paths":[{"d":"M384 1536h896v-256h-896v256zM384 896h896v-384h-160q-40 0-68-28t-28-68v-160h-640v640zM1536 960q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zM1664 960v416q0 13-9.5 22.5t-22.5 9.5h-224v160q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-160h-224q-13 0-22.5-9.5t-9.5-22.5v-416q0-79 56.5-135.5t135.5-56.5h64v-544q0-40 28-68t68-28h672q40 0 88 20t76 48l152 152q28 28 48 76t20 88v256h64q79 0 135.5 56.5t56.5 135.5z"}]}})


/***/ }),
/* 1757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"product-hunt":{"width":1792,"height":1792,"paths":[{"d":"M1150 762q0 56-39.5 95t-95.5 39h-253v-269h253q56 0 95.5 39.5t39.5 95.5zM1329 762q0-130-91.5-222t-222.5-92h-433v896h180v-269h253q130 0 222-91.5t92-221.5zM1792 896q0 182-71 348t-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71 348 71 286 191 191 286 71 348z"}]}})


/***/ }),
/* 1758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"puzzle-piece":{"width":1664,"height":1792,"paths":[{"d":"M1664 1098q0 81-44.5 135t-123.5 54q-41 0-77.5-17.5t-59-38-56.5-38-71-17.5q-110 0-110 124 0 39 16 115t15 115v5q-22 0-33 1-34 3-97.5 11.5t-115.5 13.5-98 5q-61 0-103-26.5t-42-83.5q0-37 17.5-71t38-56.5 38-59 17.5-77.5q0-79-54-123.5t-135-44.5q-84 0-143 45.5t-59 127.5q0 43 15 83t33.5 64.5 33.5 53 15 50.5q0 45-46 89-37 35-117 35-95 0-245-24-9-2-27.5-4t-27.5-4l-13-2q-1 0-3-1-2 0-2-1v-1024q2 1 17.5 3.5t34 5 21.5 3.5q150 24 245 24 80 0 117-35 46-44 46-89 0-22-15-50.5t-33.5-53-33.5-64.5-15-83q0-82 59-127.5t144-45.5q80 0 134 44.5t54 123.5q0 41-17.5 77.5t-38 59-38 56.5-17.5 71q0 57 42 83.5t103 26.5q64 0 180-15t163-17v2q-1 2-3.5 17.5t-5 34-3.5 21.5q-24 150-24 245 0 80 35 117 44 46 89 46 22 0 50.5-15t53-33.5 64.5-33.5 83-15q82 0 127.5 59t45.5 143z"}]}})


/***/ }),
/* 1759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"qq":{"width":1792,"height":1792,"paths":[{"d":"M270 806q-8-19-8-52 0-20 11-49t24-45q-1-22 7.5-53t22.5-43q0-139 92.5-288.5t217.5-209.5q139-66 324-66 133 0 266 55 49 21 90 48t71 56 55 68 42 74 32.5 84.5 25.5 89.5 22 98l1 5q55 83 55 150 0 14-9 40t-9 38q0 1 1.5 3.5t3.5 5 2 3.5q77 114 120.5 214.5t43.5 208.5q0 43-19.5 100t-55.5 57q-9 0-19.5-7.5t-19-17.5-19-26-16-26.5-13.5-26-9-17.5q-1-1-3-1l-5 4q-59 154-132 223 20 20 61.5 38.5t69 41.5 35.5 65q-2 4-4 16t-7 18q-64 97-302 97-53 0-110.5-9t-98-20-104.5-30q-15-5-23-7-14-4-46-4.5t-40-1.5q-41 45-127.5 65t-168.5 20q-35 0-69-1.5t-93-9-101-20.5-74.5-40-32.5-64q0-40 10-59.5t41-48.5q11-2 40.5-13t49.5-12q4 0 14-2 2-2 2-4l-2-3q-48-11-108-105.5t-73-156.5l-5-3q-4 0-12 20-18 41-54.5 74.5t-77.5 37.5h-1q-4 0-6-4.5t-5-5.5q-23-54-23-100 0-275 252-466z"}]}})


/***/ }),
/* 1760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"qrcode":{"width":1408,"height":1792,"paths":[{"d":"M384 1152v128h-128v-128h128zM384 384v128h-128v-128h128zM1152 384v128h-128v-128h128zM128 1407h384v-383h-384v383zM128 640h384v-384h-384v384zM896 640h384v-384h-384v384zM640 896v640h-640v-640h640zM1152 1408v128h-128v-128h128zM1408 1408v128h-128v-128h128zM1408 896v384h-384v-128h-128v384h-128v-640h384v128h128v-128h128zM640 128v640h-640v-640h640zM1408 128v640h-640v-640h640z"}]}})


/***/ }),
/* 1761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"question-circle-o":{"width":1536,"height":1792,"paths":[{"d":"M880 1200v160q0 14-9 23t-23 9h-160q-14 0-23-9t-9-23v-160q0-14 9-23t23-9h160q14 0 23 9t9 23zM1136 704q0 50-15 90t-45.5 69-52 44-59.5 36q-32 18-46.5 28t-26 24-11.5 29v32q0 14-9 23t-23 9h-160q-14 0-23-9t-9-23v-68q0-35 10.5-64.5t24-47.5 39-35.5 41-25.5 44.5-21q53-25 75-43t22-49q0-42-43.5-71.5t-95.5-29.5q-56 0-95 27-29 20-80 83-9 12-25 12-11 0-19-6l-108-82q-10-7-12-20t5-23q122-192 349-192 129 0 238.5 89.5t109.5 214.5zM768 256q-130 0-248.5 51t-204 136.5-136.5 204-51 248.5 51 248.5 136.5 204 204 136.5 248.5 51 248.5-51 204-136.5 136.5-204 51-248.5-51-248.5-136.5-204-204-136.5-248.5-51zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"question-circle":{"width":1536,"height":1792,"paths":[{"d":"M896 1376v-192q0-14-9-23t-23-9h-192q-14 0-23 9t-9 23v192q0 14 9 23t23 9h192q14 0 23-9t9-23zM1152 704q0-88-55.5-163t-138.5-116-170-41q-243 0-371 213-15 24 8 42l132 100q7 6 19 6 16 0 25-12 53-68 86-92 34-24 86-24 48 0 85.5 26t37.5 59q0 38-20 61t-68 45q-63 28-115.5 86.5t-52.5 125.5v36q0 14 9 23t23 9h192q14 0 23-9t9-23q0-19 21.5-49.5t54.5-49.5q32-18 49-28.5t46-35 44.5-48 28-60.5 12.5-81zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"question":{"width":1024,"height":1792,"paths":[{"d":"M704 1256v240q0 16-12 28t-28 12h-240q-16 0-28-12t-12-28v-240q0-16 12-28t28-12h240q16 0 28 12t12 28zM1020 656q0 54-15.5 101t-35 76.5-55 59.5-57.5 43.5-61 35.5q-41 23-68.5 65t-27.5 67q0 17-12 32.5t-28 15.5h-240q-15 0-25.5-18.5t-10.5-37.5v-45q0-83 65-156.5t143-108.5q59-27 84-56t25-76q0-42-46.5-74t-107.5-32q-65 0-108 29-35 25-107 115-13 16-31 16-12 0-25-8l-164-125q-13-10-15.5-25t5.5-28q160-266 464-266 80 0 161 31t146 83 106 127.5 41 158.5z"}]}})


/***/ }),
/* 1764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"quora":{"width":1792,"height":1792,"paths":[{"d":"M1255 787q0-318-105-474.5t-330-156.5q-222 0-326 157t-104 474q0 316 104 471.5t326 155.5q74 0 131-17-22-43-39-73t-44-65-53.5-56.5-63-36-77.5-14.5q-46 0-79 16l-49-97q105-91 276-91 132 0 215.5 54t150.5 155q67-149 67-402zM1645 1419h117q3 27-2 67t-26.5 95-58 100.5-107 78-162.5 32.5q-71 0-130.5-19t-105.5-56-79-78-66-96q-97 27-205 27-150 0-292.5-58t-253-158.5-178-249-67.5-317.5q0-170 67.5-319.5t178.5-250.5 253.5-159 291.5-58q121 0 238.5 36t217 106 176 164.5 119.5 219 43 261.5q0 190-80.5 347.5t-218.5 264.5q47 70 93.5 106.5t104.5 36.5q61 0 94-37.5t38-85.5z"}]}})


/***/ }),
/* 1765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"quote-left":{"width":1664,"height":1792,"paths":[{"d":"M768 960v384q0 80-56 136t-136 56h-384q-80 0-136-56t-56-136v-704q0-104 40.5-198.5t109.5-163.5 163.5-109.5 198.5-40.5h64q26 0 45 19t19 45v128q0 26-19 45t-45 19h-64q-106 0-181 75t-75 181v32q0 40 28 68t68 28h224q80 0 136 56t56 136zM1664 960v384q0 80-56 136t-136 56h-384q-80 0-136-56t-56-136v-704q0-104 40.5-198.5t109.5-163.5 163.5-109.5 198.5-40.5h64q26 0 45 19t19 45v128q0 26-19 45t-45 19h-64q-106 0-181 75t-75 181v32q0 40 28 68t68 28h224q80 0 136 56t56 136z"}]}})


/***/ }),
/* 1766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"quote-right":{"width":1664,"height":1792,"paths":[{"d":"M768 320v704q0 104-40.5 198.5t-109.5 163.5-163.5 109.5-198.5 40.5h-64q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h64q106 0 181-75t75-181v-32q0-40-28-68t-68-28h-224q-80 0-136-56t-56-136v-384q0-80 56-136t136-56h384q80 0 136 56t56 136zM1664 320v704q0 104-40.5 198.5t-109.5 163.5-163.5 109.5-198.5 40.5h-64q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h64q106 0 181-75t75-181v-32q0-40-28-68t-68-28h-224q-80 0-136-56t-56-136v-384q0-80 56-136t136-56h384q80 0 136 56t56 136z"}]}})


/***/ }),
/* 1767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"ra":{"width":1792,"height":1792,"paths":[{"d":"M19 874q8-217 116-406t305-318h5q0 1-1 3-8 8-28 33.5t-52 76.5-60 110.5-44.5 135.5-14 150.5 39 157.5 108.5 154q50 50 102 69.5t90.5 11.5 69.5-23.5 47-32.5l16-16q39-51 53-116.5t6.5-122.5-21-107-26.5-80l-14-29q-10-25-30.5-49.5t-43-41-43.5-29.5-35-19l-13-6 104-115q39 17 78 52t59 61l19 27q1-48-18.5-103.5t-40.5-87.5l-20-31 161-183 160 181q-33 46-52.5 102.5t-22.5 90.5l-4 33q22-37 61.5-72.5t67.5-52.5l28-17 103 115q-44 14-85 50t-60 65l-19 29q-31 56-48 133.5t-7 170 57 156.5q33 45 77.5 60.5t85 5.5 76-26.5 57.5-33.5l21-16q60-53 96.5-115t48.5-121.5 10-121.5-18-118-37-107.5-45.5-93-45-72-34.5-47.5l-13-17q-14-13-7-13l10 3q40 29 62.5 46t62 50 64 58 58.5 65 55.5 77 45.5 88 38 103 23.5 117 10.5 136q3 259-108 465t-312 321-456 115q-185 0-351-74t-283.5-198-184-293-60.5-353z"}]}})


/***/ }),
/* 1768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"random":{"width":1792,"height":1792,"paths":[{"d":"M666 481q-60 92-137 273-22-45-37-72.5t-40.5-63.5-51-56.5-63-35-81.5-14.5h-224q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h224q250 0 410 225zM1792 1280q0 14-9 23l-320 320q-9 9-23 9-13 0-22.5-9.5t-9.5-22.5v-192q-32 0-85 0.5t-81 1-73-1-71-5-64-10.5-63-18.5-58-28.5-59-40-55-53.5-56-69.5q59-93 136-273 22 45 37 72.5t40.5 63.5 51 56.5 63 35 81.5 14.5h256v-192q0-14 9-23t23-9q12 0 24 10l319 319q9 9 9 23zM1792 384q0 14-9 23l-320 320q-9 9-23 9-13 0-22.5-9.5t-9.5-22.5v-192h-256q-48 0-87 15t-69 45-51 61.5-45 77.5q-32 62-78 171-29 66-49.5 111t-54 105-64 100-74 83-90 68.5-106.5 42-128 16.5h-224q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h224q48 0 87-15t69-45 51-61.5 45-77.5q32-62 78-171 29-66 49.5-111t54-105 64-100 74-83 90-68.5 106.5-42 128-16.5h256v-192q0-14 9-23t23-9q12 0 24 10l319 319q9 9 9 23z"}]}})


/***/ }),
/* 1769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"ravelry":{"width":2176,"height":1792,"paths":[{"d":"M1143 1733q-6-1-11-4-13-8-36-23t-86-65-116.5-104.5-112-140-89.5-172.5q-17-3-175-37 66 213 235 362t391 184zM502 1127l168 28q-25-76-41-167.5t-19-145.5l-4-53q-84 82-121 224 5 65 17 114zM612 518q-43 64-77 148 44-46 74-68zM2049 952q0-161-62-307t-167.5-252-250.5-168.5-304-62.5q-147 0-281 52.5t-240 148.5q-30 58-45 160 60-51 143-83.5t158.5-43 143-13.5 108.5 1l40 3q33 1 53 15.5t24.5 33 6.5 37-1 28.5q-126-11-227.5-0.5t-183 43.5-142.5 71.5-131 98.5q4 36 11.5 92.5t35.5 178 62 179.5q123 6 247.5-14.5t214.5-53.5 162.5-67 109.5-59l37-24q22-16 39.5-20.5t30.5 5 17 34.5q14 97-39 121-208 97-467 134-135 20-317 16 41 96 110 176.5t137 127 130.5 79 101.5 43.5l39 12q143 23 263-15 195-99 314-289t119-418zM2123 915q-14 135-40 212-70 208-181.5 346.5t-318.5 253.5q-48 33-82 44-72 26-163 16-36 3-73 3-283 0-504.5-173t-295.5-442q-1 0-4-0.5t-5-0.5q-6 50 2.5 112.5t26 115 36 98 31.5 71.5l14 26q8 12 54 82-71-38-124.5-106.5t-78.5-140-39.5-137-17.5-107.5l-2-42q-5-2-33.5-12.5t-48.5-18-53-20.5-57.5-25-50-25.5-42.5-27-25-25.5q19 10 50.5 25.5t113 45.5 145.5 38l2-32q11-149 94-290 41-202 176-365 28-115 81-214 15-28 32-45t49-32q158-74 303.5-104t302-11 306.5 97q220 115 333 336t87 474z"}]}})


/***/ }),
/* 1770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"rebel":{"width":1792,"height":1792,"paths":[{"d":"M19 874q8-217 116-406t305-318h5q0 1-1 3-8 8-28 33.5t-52 76.5-60 110.5-44.5 135.5-14 150.5 39 157.5 108.5 154q50 50 102 69.5t90.5 11.5 69.5-23.5 47-32.5l16-16q39-51 53-116.5t6.5-122.5-21-107-26.5-80l-14-29q-10-25-30.5-49.5t-43-41-43.5-29.5-35-19l-13-6 104-115q39 17 78 52t59 61l19 27q1-48-18.5-103.5t-40.5-87.5l-20-31 161-183 160 181q-33 46-52.5 102.5t-22.5 90.5l-4 33q22-37 61.5-72.5t67.5-52.5l28-17 103 115q-44 14-85 50t-60 65l-19 29q-31 56-48 133.5t-7 170 57 156.5q33 45 77.5 60.5t85 5.5 76-26.5 57.5-33.5l21-16q60-53 96.5-115t48.5-121.5 10-121.5-18-118-37-107.5-45.5-93-45-72-34.5-47.5l-13-17q-14-13-7-13l10 3q40 29 62.5 46t62 50 64 58 58.5 65 55.5 77 45.5 88 38 103 23.5 117 10.5 136q3 259-108 465t-312 321-456 115q-185 0-351-74t-283.5-198-184-293-60.5-353z"}]}})


/***/ }),
/* 1771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"recycle":{"width":1792,"height":1792,"paths":[{"d":"M836 1169l-15 368-2 22-420-29q-36-3-67-31.5t-47-65.5q-11-27-14.5-55t4-65 12-55 21.5-64 19-53q78 12 509 28zM449 583l180 379-147-92q-63 72-111.5 144.5t-72.5 125-39.5 94.5-18.5 63l-4 21-190-357q-17-26-18-56t6-47l8-18q35-63 114-188l-140-86zM1680 1100l-188 359q-12 29-36.5 46.5t-43.5 20.5l-18 4q-71 7-219 12l8 164-230-367 211-362 7 173q170 16 283 5t170-33zM895 176q-47 63-265 435l-317-187-19-12 225-356q20-31 60-45t80-10q24 2 48.5 12t42 21 41.5 33 36 34.5 36 39.5 32 35zM1550 483l212 363q18 37 12.5 76t-27.5 74q-13 20-33 37t-38 28-48.5 22-47 16-51.5 14-46 12q-34-72-265-436l313-195zM1407 257l142-83-220 373-419-20 151-86q-34-89-75-166t-75.5-123.5-64.5-80-47-46.5l-17-13 405 1q31-3 58 10.5t39 28.5l11 15q39 61 112 190z"}]}})


/***/ }),
/* 1772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"reddit-alien":{"width":1792,"height":1792,"paths":[{"d":"M1792 846q0 58-29.5 105.5t-79.5 72.5q12 46 12 96 0 155-106.5 287t-290.5 208.5-400 76.5-399.5-76.5-290-208.5-106.5-287q0-47 11-94-51-25-82-73.5t-31-106.5q0-82 58-140.5t141-58.5q85 0 145 63 218-152 515-162l116-521q3-13 15-21t26-5l369 81q18-37 54-59.5t79-22.5q62 0 106 43.5t44 105.5-44 106-106 44-105.5-43.5-43.5-105.5l-334-74-104 472q300 9 519 160 58-61 143-61 83 0 141 58.5t58 140.5zM418 1045q0 62 43.5 106t105.5 44 106-44 44-106-44-105.5-106-43.5q-61 0-105 44t-44 105zM1228 1400q11-11 11-26t-11-26q-10-10-25-10t-26 10q-41 42-121 62t-160 20-160-20-121-62q-11-10-26-10t-25 10q-11 10-11 25.5t11 26.5q43 43 118.5 68t122.5 29.5 91 4.5 91-4.5 122.5-29.5 118.5-68zM1225 1195q62 0 105.5-44t43.5-106q0-61-44-105t-105-44q-62 0-106 43.5t-44 105.5 44 106 106 44z"}]}})


/***/ }),
/* 1773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"reddit-square":{"width":1536,"height":1792,"paths":[{"d":"M939 1129q13 13 0 26-53 53-171 53t-171-53q-13-13 0-26 5-6 13-6t13 6q42 42 145 42t145-42q5-6 13-6t13 6zM676 973q0 31-23 54t-54 23-54-23-23-54q0-32 22.5-54.5t54.5-22.5 54.5 22.5 22.5 54.5zM1014 973q0 31-23 54t-54 23-54-23-23-54q0-32 22.5-54.5t54.5-22.5 54.5 22.5 22.5 54.5zM1229 870q0-42-30-72t-73-30q-42 0-73 31-113-78-267-82l54-243 171 39q1 32 23.5 54t53.5 22q32 0 54.5-22.5t22.5-54.5-22.5-54.5-54.5-22.5q-48 0-69 43l-189-42q-17-5-21 13l-60 268q-154 6-265 83-30-32-74-32-43 0-73 30t-30 72q0 30 16 55t42 38q-5 25-5 48 0 122 120 208.5t289 86.5q170 0 290-86.5t120-208.5q0-25-6-49 25-13 40.5-37.5t15.5-54.5zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 1774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"reddit":{"width":1792,"height":1792,"paths":[{"d":"M1095 1167q16 16 0 31-62 62-199 62t-199-62q-16-15 0-31 6-6 15-6t15 6q48 49 169 49 120 0 169-49 6-6 15-6t15 6zM788 986q0 37-26 63t-63 26-63.5-26-26.5-63q0-38 26.5-64t63.5-26 63 26.5 26 63.5zM1183 986q0 37-26.5 63t-63.5 26-63-26-26-63 26-63.5 63-26.5 63.5 26 26.5 64zM1434 866q0-49-35-84t-85-35-86 36q-130-90-311-96l63-283 200 45q0 37 26 63t63 26 63.5-26.5 26.5-63.5-26.5-63.5-63.5-26.5q-54 0-80 50l-221-49q-19-5-25 16l-69 312q-180 7-309 97-35-37-87-37-50 0-85 35t-35 84q0 35 18.5 64t49.5 44q-6 27-6 56 0 142 140 243t337 101q198 0 338-101t140-243q0-32-7-57 30-15 48-43.5t18-63.5zM1792 896q0 182-71 348t-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71 348 71 286 191 191 286 71 348z"}]}})


/***/ }),
/* 1775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"refresh":{"width":1536,"height":1792,"paths":[{"d":"M1511 1056q0 5-1 7-64 268-268 434.5t-478 166.5q-146 0-282.5-55t-243.5-157l-129 129q-19 19-45 19t-45-19-19-45v-448q0-26 19-45t45-19h448q26 0 45 19t19 45-19 45l-137 137q71 66 161 102t187 36q134 0 250-65t186-179q11-17 53-117 8-23 30-23h192q13 0 22.5 9.5t9.5 22.5zM1536 256v448q0 26-19 45t-45 19h-448q-26 0-45-19t-19-45 19-45l138-138q-148-137-349-137-134 0-250 65t-186 179q-11 17-53 117-8 23-30 23h-199q-13 0-22.5-9.5t-9.5-22.5v-7q65-268 270-434.5t480-166.5q146 0 284 55.5t245 156.5l130-129q19-19 45-19t45 19 19 45z"}]}})


/***/ }),
/* 1776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"registered":{"width":1792,"height":1792,"paths":[{"d":"M1042 703q0-88-60-121-33-18-117-18h-123v281h162q66 0 102-37t36-105zM1094 988l205 373q8 17-1 31-8 16-27 16h-152q-20 0-28-17l-194-365h-155v350q0 14-9 23t-23 9h-134q-14 0-23-9t-9-23v-960q0-14 9-23t23-9h294q128 0 190 24 85 31 134 109t49 180q0 92-42.5 165.5t-115.5 109.5q6 10 9 16zM896 160q-150 0-286 58.5t-234.5 157-157 234.5-58.5 286 58.5 286 157 234.5 234.5 157 286 58.5 286-58.5 234.5-157 157-234.5 58.5-286-58.5-286-157-234.5-234.5-157-286-58.5zM1792 896q0 182-71 348t-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71 348 71 286 191 191 286 71 348z"}]}})


/***/ }),
/* 1777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"remove":{"width":1408,"height":1792,"paths":[{"d":"M1298 1322q0 40-28 68l-136 136q-28 28-68 28t-68-28l-294-294-294 294q-28 28-68 28t-68-28l-136-136q-28-28-28-68t28-68l294-294-294-294q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 294 294-294q28-28 68-28t68 28l136 136q28 28 28 68t-28 68l-294 294 294 294q28 28 28 68z"}]}})


/***/ }),
/* 1778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"renren":{"width":1536,"height":1792,"paths":[{"d":"M1133 1570q-171 94-368 94-196 0-367-94 138-87 235.5-211t131.5-268q35 144 132.5 268t235.5 211zM638 142v485q0 252-126.5 459.5t-330.5 306.5q-181-215-181-495 0-187 83.5-349.5t229.5-269.5 325-137zM1536 898q0 280-181 495-204-99-330.5-306.5t-126.5-459.5v-485q179 30 325 137t229.5 269.5 83.5 349.5z"}]}})


/***/ }),
/* 1779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"reorder":{"width":1536,"height":1792,"paths":[{"d":"M1536 1344v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zM1536 832v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zM1536 320v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45z"}]}})


/***/ }),
/* 1780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"repeat":{"width":1536,"height":1792,"paths":[{"d":"M1536 256v448q0 26-19 45t-45 19h-448q-42 0-59-40-17-39 14-69l138-138q-148-137-349-137-104 0-198.5 40.5t-163.5 109.5-109.5 163.5-40.5 198.5 40.5 198.5 109.5 163.5 163.5 109.5 198.5 40.5q119 0 225-52t179-147q7-10 23-12 15 0 25 9l137 138q9 8 9.5 20.5t-7.5 22.5q-109 132-264 204.5t-327 72.5q-156 0-298-61t-245-164-164-245-61-298 61-298 164-245 245-164 298-61q147 0 284.5 55.5t244.5 156.5l130-129q29-31 70-14 39 17 39 59z"}]}})


/***/ }),
/* 1781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"reply-all":{"width":1792,"height":1792,"paths":[{"d":"M640 1082v70q0 42-39 59-13 5-25 5-27 0-45-19l-512-512q-19-19-19-45t19-45l512-512q29-31 70-14 39 17 39 59v69l-397 398q-19 19-19 45t19 45zM1792 1120q0 58-17 133.5t-38.5 138-48 125-40.5 90.5l-20 40q-8 17-28 17-6 0-9-1-25-8-23-34 43-400-106-565-64-71-170.5-110.5t-267.5-52.5v251q0 42-39 59-13 5-25 5-27 0-45-19l-512-512q-19-19-19-45t19-45l512-512q29-31 70-14 39 17 39 59v262q411 28 599 221 169 173 169 509z"}]}})


/***/ }),
/* 1782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"reply":{"width":1792,"height":1792,"paths":[{"d":"M1792 1120q0 166-127 451-3 7-10.5 24t-13.5 30-13 22q-12 17-28 17-15 0-23.5-10t-8.5-25q0-9 2.5-26.5t2.5-23.5q5-68 5-123 0-101-17.5-181t-48.5-138.5-80-101-105.5-69.5-133-42.5-154-21.5-175.5-6h-224v256q0 26-19 45t-45 19-45-19l-512-512q-19-19-19-45t19-45l512-512q19-19 45-19t45 19 19 45v256h224q713 0 875 403 53 134 53 333z"}]}})


/***/ }),
/* 1783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"resistance":{"width":1792,"height":1792,"paths":[{"d":"M19 874q8-217 116-406t305-318h5q0 1-1 3-8 8-28 33.5t-52 76.5-60 110.5-44.5 135.5-14 150.5 39 157.5 108.5 154q50 50 102 69.5t90.5 11.5 69.5-23.5 47-32.5l16-16q39-51 53-116.5t6.5-122.5-21-107-26.5-80l-14-29q-10-25-30.5-49.5t-43-41-43.5-29.5-35-19l-13-6 104-115q39 17 78 52t59 61l19 27q1-48-18.5-103.5t-40.5-87.5l-20-31 161-183 160 181q-33 46-52.5 102.5t-22.5 90.5l-4 33q22-37 61.5-72.5t67.5-52.5l28-17 103 115q-44 14-85 50t-60 65l-19 29q-31 56-48 133.5t-7 170 57 156.5q33 45 77.5 60.5t85 5.5 76-26.5 57.5-33.5l21-16q60-53 96.5-115t48.5-121.5 10-121.5-18-118-37-107.5-45.5-93-45-72-34.5-47.5l-13-17q-14-13-7-13l10 3q40 29 62.5 46t62 50 64 58 58.5 65 55.5 77 45.5 88 38 103 23.5 117 10.5 136q3 259-108 465t-312 321-456 115q-185 0-351-74t-283.5-198-184-293-60.5-353z"}]}})


/***/ }),
/* 1784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"retweet":{"width":1920,"height":1792,"paths":[{"d":"M1280 1504q0 13-9.5 22.5t-22.5 9.5h-960q-8 0-13.5-2t-9-7-5.5-8-3-11.5-1-11.5v-13-11-160-416h-192q-26 0-45-19t-19-45q0-24 15-41l320-384q19-22 49-22t49 22l320 384q15 17 15 41 0 26-19 45t-45 19h-192v384h576q16 0 25 11l160 192q7 10 7 21zM1920 1088q0 24-15 41l-320 384q-20 23-49 23t-49-23l-320-384q-15-17-15-41 0-26 19-45t45-19h192v-384h-576q-16 0-25-12l-160-192q-7-9-7-20 0-13 9.5-22.5t22.5-9.5h960q8 0 13.5 2t9 7 5.5 8 3 11.5 1 11.5v13 11 160 416h192q26 0 45 19t19 45z"}]}})


/***/ }),
/* 1785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"rmb":{"width":1027,"height":1792,"paths":[{"d":"M603 1536h-172q-13 0-22.5-9t-9.5-23v-330h-288q-13 0-22.5-9t-9.5-23v-103q0-13 9.5-22.5t22.5-9.5h288v-85h-288q-13 0-22.5-9t-9.5-23v-104q0-13 9.5-22.5t22.5-9.5h214l-321-578q-8-16 0-32 10-16 28-16h194q19 0 29 18l215 425q19 38 56 125 10-24 30.5-68t27.5-61l191-420q8-19 29-19h191q17 0 27 16 9 14 1 31l-313 579h215q13 0 22.5 9.5t9.5 22.5v104q0 14-9.5 23t-22.5 9h-290v85h290q13 0 22.5 9.5t9.5 22.5v103q0 14-9.5 23t-22.5 9h-290v330q0 13-9.5 22.5t-22.5 9.5z"}]}})


/***/ }),
/* 1786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"road":{"width":1920,"height":1792,"paths":[{"d":"M1111 996v-4l-24-320q-1-13-11-22.5t-23-9.5h-186q-13 0-23 9.5t-11 22.5l-24 320v4q-1 12 8 20t21 8h244q12 0 21-8t8-20zM1870 1463q0 73-46 73h-704q13 0 22-9.5t8-22.5l-20-256q-1-13-11-22.5t-23-9.5h-272q-13 0-23 9.5t-11 22.5l-20 256q-1 13 8 22.5t22 9.5h-704q-46 0-46-73 0-54 26-116l417-1044q8-19 26-33t38-14h339q-13 0-23 9.5t-11 22.5l-15 192q-1 14 8 23t22 9h166q13 0 22-9t8-23l-15-192q-1-13-11-22.5t-23-9.5h339q20 0 38 14t26 33l417 1044q26 62 26 116z"}]}})


/***/ }),
/* 1787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"rocket":{"width":1664,"height":1792,"paths":[{"d":"M1440 448q0-40-28-68t-68-28-68 28-28 68 28 68 68 28 68-28 28-68zM1664 160q0 249-75.5 430.5t-253.5 360.5q-81 80-195 176l-20 379q-2 16-16 26l-384 224q-7 4-16 4-12 0-23-9l-64-64q-13-14-8-32l85-276-281-281-276 85q-3 1-9 1-14 0-23-9l-64-64q-17-19-5-39l224-384q10-14 26-16l379-20q96-114 176-195 188-187 358-258t431-71q14 0 24 9.5t10 22.5z"}]}})


/***/ }),
/* 1788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"rotate-left":{"width":1536,"height":1792,"paths":[{"d":"M1536 896q0 156-61 298t-164 245-245 164-298 61q-172 0-327-72.5t-264-204.5q-7-10-6.5-22.5t8.5-20.5l137-138q10-9 25-9 16 2 23 12 73 95 179 147t225 52q104 0 198.5-40.5t163.5-109.5 109.5-163.5 40.5-198.5-40.5-198.5-109.5-163.5-163.5-109.5-198.5-40.5q-98 0-188 35.5t-160 101.5l137 138q31 30 14 69-17 40-59 40h-448q-26 0-45-19t-19-45v-448q0-42 40-59 39-17 69 14l130 129q107-101 244.5-156.5t284.5-55.5q156 0 298 61t245 164 164 245 61 298z"}]}})


/***/ }),
/* 1789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"rotate-right":{"width":1536,"height":1792,"paths":[{"d":"M1536 256v448q0 26-19 45t-45 19h-448q-42 0-59-40-17-39 14-69l138-138q-148-137-349-137-104 0-198.5 40.5t-163.5 109.5-109.5 163.5-40.5 198.5 40.5 198.5 109.5 163.5 163.5 109.5 198.5 40.5q119 0 225-52t179-147q7-10 23-12 15 0 25 9l137 138q9 8 9.5 20.5t-7.5 22.5q-109 132-264 204.5t-327 72.5q-156 0-298-61t-245-164-164-245-61-298 61-298 164-245 245-164 298-61q147 0 284.5 55.5t244.5 156.5l130-129q29-31 70-14 39 17 39 59z"}]}})


/***/ }),
/* 1790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"rouble":{"width":1280,"height":1792,"paths":[{"d":"M1043 565q0-100-65-162t-171-62h-320v448h320q106 0 171-62t65-162zM1280 565q0 193-126.5 315t-326.5 122h-340v118h505q14 0 23 9t9 23v128q0 14-9 23t-23 9h-505v192q0 14-9.5 23t-22.5 9h-167q-14 0-23-9t-9-23v-192h-224q-14 0-23-9t-9-23v-128q0-14 9-23t23-9h224v-118h-224q-14 0-23-9t-9-23v-149q0-13 9-22.5t23-9.5h224v-629q0-14 9-23t23-9h539q200 0 326.5 122t126.5 315z"}]}})


/***/ }),
/* 1791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"rss-square":{"width":1536,"height":1792,"paths":[{"d":"M512 1280q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM863 1374q-13-233-176.5-396.5t-396.5-176.5q-14-1-24 9t-10 23v128q0 13 8.5 22t21.5 10q154 11 264 121t121 264q1 13 10 21.5t22 8.5h128q13 0 23-10t9-24zM1247 1375q-5-154-56-297.5t-139.5-260-205-205-260-139.5-297.5-56q-14-1-23 9-10 10-10 23v128q0 13 9 22t22 10q204 7 378 111.5t278.5 278.5 111.5 378q1 13 10 22t22 9h128q13 0 23-10 11-9 9-23zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 1792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"rss":{"width":1408,"height":1792,"paths":[{"d":"M384 1344q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM896 1467q2 28-17 48-18 21-47 21h-135q-25 0-43-16.5t-20-41.5q-22-229-184.5-391.5t-391.5-184.5q-25-2-41.5-20t-16.5-43v-135q0-29 21-47 17-17 43-17h5q160 13 306 80.5t259 181.5q114 113 181.5 259t80.5 306zM1408 1469q2 27-18 47-18 20-46 20h-143q-26 0-44.5-17.5t-19.5-42.5q-12-215-101-408.5t-231.5-336-336-231.5-408.5-102q-25-1-42.5-19.5t-17.5-43.5v-143q0-28 20-46 18-18 44-18h3q262 13 501.5 120t425.5 294q187 186 294 425.5t120 501.5z"}]}})


/***/ }),
/* 1793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"rub":{"width":1280,"height":1792,"paths":[{"d":"M1043 565q0-100-65-162t-171-62h-320v448h320q106 0 171-62t65-162zM1280 565q0 193-126.5 315t-326.5 122h-340v118h505q14 0 23 9t9 23v128q0 14-9 23t-23 9h-505v192q0 14-9.5 23t-22.5 9h-167q-14 0-23-9t-9-23v-192h-224q-14 0-23-9t-9-23v-128q0-14 9-23t23-9h224v-118h-224q-14 0-23-9t-9-23v-149q0-13 9-22.5t23-9.5h224v-629q0-14 9-23t23-9h539q200 0 326.5 122t126.5 315z"}]}})


/***/ }),
/* 1794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"ruble":{"width":1280,"height":1792,"paths":[{"d":"M1043 565q0-100-65-162t-171-62h-320v448h320q106 0 171-62t65-162zM1280 565q0 193-126.5 315t-326.5 122h-340v118h505q14 0 23 9t9 23v128q0 14-9 23t-23 9h-505v192q0 14-9.5 23t-22.5 9h-167q-14 0-23-9t-9-23v-192h-224q-14 0-23-9t-9-23v-128q0-14 9-23t23-9h224v-118h-224q-14 0-23-9t-9-23v-149q0-13 9-22.5t23-9.5h224v-629q0-14 9-23t23-9h539q200 0 326.5 122t126.5 315z"}]}})


/***/ }),
/* 1795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"rupee":{"width":898,"height":1792,"paths":[{"d":"M898 470v102q0 14-9 23t-23 9h-168q-23 144-129 234t-276 110q167 178 459 536 14 16 4 34-8 18-29 18h-195q-16 0-25-12-306-367-498-571-9-9-9-22v-127q0-13 9.5-22.5t22.5-9.5h112q132 0 212.5-43t102.5-125h-427q-14 0-23-9t-9-23v-102q0-14 9-23t23-9h413q-57-113-268-113h-145q-13 0-22.5-9.5t-9.5-22.5v-133q0-14 9-23t23-9h832q14 0 23 9t9 23v102q0 14-9 23t-23 9h-233q47 61 64 144h171q14 0 23 9t9 23z"}]}})


/***/ }),
/* 1796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"s15":{"width":1792,"height":1792,"paths":[{"d":"M1664 1088v192q0 169-128 286v194q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-118q-63 22-128 22h-768q-65 0-128-22v110q0 17-9.5 28.5t-22.5 11.5h-64q-13 0-22.5-11.5t-9.5-28.5v-186q-128-117-128-286v-192h1536zM704 672q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM768 608q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM704 544q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM832 544q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM768 480q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM704 416q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM1792 928v64q0 14-9 23t-23 9h-1728q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h96v-640q0-106 75-181t181-75q108 0 184 78 46-19 98-12t93 39l22-22q11-11 22 0l42 42q11 11 0 22l-314 314q-11 11-22 0l-42-42q-11-11 0-22l22-22q-36-46-40.5-104t23.5-108q-37-35-88-35-53 0-90.5 37.5t-37.5 90.5v640h1504q14 0 23 9t9 23zM896 480q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM832 416q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM768 352q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM960 416q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM896 352q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM832 288q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM1024 352q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM960 288q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM1088 288q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23z"}]}})


/***/ }),
/* 1797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"safari":{"width":1792,"height":1792,"paths":[{"d":"M949 893q0 26-16.5 45t-41.5 19q-26 0-45-16.5t-19-41.5q0-26 17-45t42-19 44 16.5 19 41.5zM964 951l350-581q-9 8-67.5 62.5t-125.5 116.5-136.5 127-117 110.5-50.5 51.5l-349 580q7-7 67-62t126-116.5 136-127 117-111 50-50.5zM1611 896q0 201-104 371-3-2-17-11t-26.5-16.5-16.5-7.5q-13 0-13 13 0 10 59 44-74 112-184.5 190.5t-241.5 110.5l-16-67q-1-10-15-10-5 0-8 5.5t-2 9.5l16 68q-72 15-146 15-199 0-372-105 1-2 13-20.5t21.5-33.5 9.5-19q0-13-13-13-6 0-17 14.5t-22.5 34.5-13.5 23q-113-75-192-187.5t-110-244.5l69-15q10-3 10-15 0-5-5.5-8t-10.5-2l-68 15q-14-72-14-139 0-206 109-379 2 1 18.5 12t30 19 17.5 8q13 0 13-12 0-6-12.5-15.5t-32.5-21.5l-20-12q77-112 189-189t244-107l15 67q2 10 15 10 5 0 8-5.5t2-10.5l-15-66q71-13 134-13 204 0 379 109-39 56-39 65 0 13 12 13 11 0 48-64 111 75 187.5 186t107.5 241l-56 12q-10 2-10 16 0 5 5.5 8t9.5 2l57-13q14 72 14 140zM1696 896q0-163-63.5-311t-170.5-255-255-170.5-311-63.5-311 63.5-255 170.5-170.5 255-63.5 311 63.5 311 170.5 255 255 170.5 311 63.5 311-63.5 255-170.5 170.5-255 63.5-311zM1792 896q0 182-71 348t-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71 348 71 286 191 191 286 71 348z"}]}})


/***/ }),
/* 1798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"save":{"width":1536,"height":1792,"paths":[{"d":"M384 1536h768v-384h-768v384zM1280 1536h128v-896q0-14-10-38.5t-20-34.5l-281-281q-10-10-34-20t-39-10v416q0 40-28 68t-68 28h-576q-40 0-68-28t-28-68v-416h-128v1280h128v-416q0-40 28-68t68-28h832q40 0 68 28t28 68v416zM896 608v-320q0-13-9.5-22.5t-22.5-9.5h-192q-13 0-22.5 9.5t-9.5 22.5v320q0 13 9.5 22.5t22.5 9.5h192q13 0 22.5-9.5t9.5-22.5zM1536 640v928q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1344q0-40 28-68t68-28h928q40 0 88 20t76 48l280 280q28 28 48 76t20 88z"}]}})


/***/ }),
/* 1799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"scissors":{"width":1792,"height":1792,"paths":[{"d":"M960 896q26 0 45 19t19 45-19 45-45 19-45-19-19-45 19-45 45-19zM1260 960l507 398q28 20 25 56-5 35-35 51l-128 64q-13 7-29 7-17 0-31-8l-690-387-110 66q-8 4-12 5 14 49 10 97-7 77-56 147.5t-132 123.5q-132 84-277 84-136 0-222-78-90-84-79-207 7-76 56-147t131-124q132-84 278-84 83 0 151 31 9-13 22-22l122-73-122-73q-13-9-22-22-68 31-151 31-146 0-278-84-82-53-131-124t-56-147q-5-59 15.5-113t63.5-93q85-79 222-79 145 0 277 84 83 52 132 123t56 148q4 48-10 97 4 1 12 5l110 66 690-387q14-8 31-8 16 0 29 7l128 64q30 16 35 51 3 36-25 56zM579 700q46-42 21-108t-106-117q-92-59-192-59-74 0-113 36-46 42-21 108t106 117q92 59 192 59 74 0 113-36zM494 1445q81-51 106-117t-21-108q-39-36-113-36-100 0-192 59-81 51-106 117t21 108q39 36 113 36 100 0 192-59zM672 832l96 58v-11q0-36 33-56l14-8-79-47-26 26q-3 3-10 11t-12 12q-2 2-4 3.5t-3 2.5zM896 1056l96 32 736-576-128-64-768 431v113l-160 96 9 8q2 2 7 6 4 4 11 12t11 12l26 26zM1600 1472l128-64-520-408-177 138q-2 3-13 7z"}]}})


/***/ }),
/* 1800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"scribd":{"width":1536,"height":1792,"paths":[{"d":"M1500 1549q0 89-63 152.5t-153 63.5-153.5-63.5-63.5-152.5q0-90 63.5-153.5t153.5-63.5 153 63.5 63 153.5zM1267 1268q-115 15-192.5 102.5t-77.5 205.5q0 74 33 138-146 78-379 78-109 0-201-21t-153.5-54.5-110.5-76.5-76-85-44.5-83-23.5-66.5-6-39.5q0-19 4.5-42.5t18.5-56 36.5-58 64-43.5 94.5-18 94 17.5 63 41 35.5 53 17.5 49 4 33.5q0 34-23 81 28 27 82 42t93 17l40 1q115 0 190-51t75-133q0-26-9-48.5t-31.5-44.5-49.5-41-74-44-93.5-47.5-119.5-56.5q-28-13-43-20-116-55-187-100t-122.5-102-72-125.5-20.5-162.5q0-78 20.5-150t66-137.5 112.5-114 166.5-77 221.5-28.5q120 0 220 26t164.5 67 109.5 94 64 105.5 19 103.5q0 46-15 82.5t-36.5 58-48.5 36-49 19.5-39 5h-8-32t-39-5-44-14-41-28-37-46-24-70.5-10-97.5q-15-16-59-25.5t-81-10.5l-37-1q-68 0-117.5 31t-70.5 70-21 76q0 24 5 43t24 46 53 51 97 53.5 150 58.5q76 25 138.5 53.5t109 55.5 83 59 60.5 59.5 41 62.5 26.5 62 14.5 63.5 6 62 1 62.5z"}]}})


/***/ }),
/* 1801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"search-minus":{"width":1664,"height":1792,"paths":[{"d":"M1024 800v64q0 13-9.5 22.5t-22.5 9.5h-576q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h576q13 0 22.5 9.5t9.5 22.5zM1152 832q0-185-131.5-316.5t-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5 316.5-131.5 131.5-316.5zM1664 1664q0 53-37.5 90.5t-90.5 37.5q-54 0-90-38l-343-342q-179 124-399 124-143 0-273.5-55.5t-225-150-150-225-55.5-273.5 55.5-273.5 150-225 225-150 273.5-55.5 273.5 55.5 225 150 150 225 55.5 273.5q0 220-124 399l343 343q37 37 37 90z"}]}})


/***/ }),
/* 1802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"search-plus":{"width":1664,"height":1792,"paths":[{"d":"M1024 800v64q0 13-9.5 22.5t-22.5 9.5h-224v224q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-224h-224q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h224v-224q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5v224h224q13 0 22.5 9.5t9.5 22.5zM1152 832q0-185-131.5-316.5t-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5 316.5-131.5 131.5-316.5zM1664 1664q0 53-37.5 90.5t-90.5 37.5q-54 0-90-38l-343-342q-179 124-399 124-143 0-273.5-55.5t-225-150-150-225-55.5-273.5 55.5-273.5 150-225 225-150 273.5-55.5 273.5 55.5 225 150 150 225 55.5 273.5q0 220-124 399l343 343q37 37 37 90z"}]}})


/***/ }),
/* 1803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"search":{"width":1664,"height":1792,"paths":[{"d":"M1152 832q0-185-131.5-316.5t-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5 316.5-131.5 131.5-316.5zM1664 1664q0 52-38 90t-90 38q-54 0-90-38l-343-342q-179 124-399 124-143 0-273.5-55.5t-225-150-150-225-55.5-273.5 55.5-273.5 150-225 225-150 273.5-55.5 273.5 55.5 225 150 150 225 55.5 273.5q0 220-124 399l343 343q37 37 37 90z"}]}})


/***/ }),
/* 1804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"sellsy":{"width":2048,"height":1792,"paths":[{"d":"M1500 1371v-733q0-21-15-36t-35-15h-93q-20 0-35 15t-15 36v733q0 20 15 35t35 15h93q20 0 35-15t15-35zM1216 1371v-531q0-20-15-35t-35-15h-101q-20 0-35 15t-15 35v531q0 20 15 35t35 15h101q20 0 35-15t15-35zM924 1371v-429q0-20-15-35t-35-15h-101q-20 0-35 15t-15 35v429q0 20 15 35t35 15h101q20 0 35-15t15-35zM632 1371v-362q0-20-15-35t-35-15h-101q-20 0-35 15t-15 35v362q0 20 15 35t35 15h101q20 0 35-15t15-35zM2048 1225q0 166-118 284t-284 118h-1244q-166 0-284-118t-118-284q0-116 63-214.5t168-148.5q-10-34-10-73 0-113 80.5-193.5t193.5-80.5q102 0 180 67 45-183 194-300t338-117q149 0 275 73.5t199.5 199.5 73.5 275q0 66-14 122 135 33 221 142.5t86 247.5z"}]}})


/***/ }),
/* 1805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"send-o":{"width":1792,"height":1792,"paths":[{"d":"M1764 11q33 24 27 64l-256 1536q-5 29-32 45-14 8-31 8-11 0-24-5l-527-215-298 327q-18 21-47 21-14 0-23-4-19-7-30-23.5t-11-36.5v-452l-472-193q-37-14-40-55-3-39 32-59l1664-960q35-21 68 2zM1422 1510l221-1323-1434 827 336 137 863-639-478 797z"}]}})


/***/ }),
/* 1806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"send":{"width":1792,"height":1792,"paths":[{"d":"M1764 11q33 24 27 64l-256 1536q-5 29-32 45-14 8-31 8-11 0-24-5l-453-185-242 295q-18 23-49 23-13 0-22-4-19-7-30.5-23.5t-11.5-36.5v-349l864-1059-1069 925-395-162q-37-14-40-55-2-40 32-59l1664-960q15-9 32-9 20 0 36 11z"}]}})


/***/ }),
/* 1807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"server":{"width":1792,"height":1792,"paths":[{"d":"M128 1408h1024v-128h-1024v128zM128 896h1024v-128h-1024v128zM1696 1344q0-40-28-68t-68-28-68 28-28 68 28 68 68 28 68-28 28-68zM128 384h1024v-128h-1024v128zM1696 832q0-40-28-68t-68-28-68 28-28 68 28 68 68 28 68-28 28-68zM1696 320q0-40-28-68t-68-28-68 28-28 68 28 68 68 28 68-28 28-68zM1792 1152v384h-1792v-384h1792zM1792 640v384h-1792v-384h1792zM1792 128v384h-1792v-384h1792z"}]}})


/***/ }),
/* 1808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"share-alt-square":{"width":1536,"height":1792,"paths":[{"d":"M1280 1195q0-88-62.5-151t-150.5-63q-84 0-145 58l-241-120q2-16 2-23t-2-23l241-120q61 58 145 58 88 0 150.5-63t62.5-151-62.5-150.5-150.5-62.5-151 62.5-63 150.5q0 7 2 23l-241 120q-62-57-145-57-88 0-150.5 62.5t-62.5 150.5 62.5 150.5 150.5 62.5q83 0 145-57l241 120q-2 16-2 23 0 88 63 150.5t151 62.5 150.5-62.5 62.5-150.5zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 1809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"share-alt":{"width":1536,"height":1792,"paths":[{"d":"M1216 1024q133 0 226.5 93.5t93.5 226.5-93.5 226.5-226.5 93.5-226.5-93.5-93.5-226.5q0-12 2-34l-360-180q-92 86-218 86-133 0-226.5-93.5t-93.5-226.5 93.5-226.5 226.5-93.5q126 0 218 86l360-180q-2-22-2-34 0-133 93.5-226.5t226.5-93.5 226.5 93.5 93.5 226.5-93.5 226.5-226.5 93.5q-126 0-218-86l-360 180q2 22 2 34t-2 34l360 180q92-86 218-86z"}]}})


/***/ }),
/* 1810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"share-square-o":{"width":1664,"height":1792,"paths":[{"d":"M1408 989v259q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h255v0q13 0 22.5 9.5t9.5 22.5q0 27-26 32-77 26-133 60-10 4-16 4h-112q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113v-214q0-19 18-29 28-13 54-37 16-16 35-8 21 9 21 29zM1645 493l-384 384q-18 19-45 19-12 0-25-5-39-17-39-59v-192h-160q-323 0-438 131-119 137-74 473 3 23-20 34-8 2-12 2-16 0-26-13-10-14-21-31t-39.5-68.5-49.5-99.5-38.5-114-17.5-122q0-49 3.5-91t14-90 28-88 47-81.5 68.5-74 94.5-61.5 124.5-48.5 159.5-30.5 196.5-11h160v-192q0-42 39-59 13-5 25-5 26 0 45 19l384 384q19 19 19 45t-19 45z"}]}})


/***/ }),
/* 1811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"share-square":{"width":1536,"height":1792,"paths":[{"d":"M1005 1101l352-352q19-19 19-45t-19-45l-352-352q-30-31-69-14-40 17-40 59v160q-119 0-216 19.5t-162.5 51-114 79-76.5 95.5-44.5 109-21.5 111.5-5 110.5q0 181 167 404 11 12 25 12 7 0 13-3 22-9 19-33-44-354 62-473 46-52 130-75.5t224-23.5v160q0 42 40 59 12 5 24 5 26 0 45-19zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 1812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"share":{"width":1792,"height":1792,"paths":[{"d":"M1792 640q0 26-19 45l-512 512q-19 19-45 19t-45-19-19-45v-256h-224q-98 0-175.5 6t-154 21.5-133 42.5-105.5 69.5-80 101-48.5 138.5-17.5 181q0 55 5 123 0 6 2.5 23.5t2.5 26.5q0 15-8.5 25t-23.5 10q-16 0-28-17-7-9-13-22t-13.5-30-10.5-24q-127-285-127-451 0-199 53-333 162-403 875-403h224v-256q0-26 19-45t45-19 45 19l512 512q19 19 19 45z"}]}})


/***/ }),
/* 1813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"shekel":{"width":1536,"height":1792,"paths":[{"d":"M992 624v496q0 14-9 23t-23 9h-160q-14 0-23-9t-9-23v-496q0-112-80-192t-192-80h-272v1152q0 14-9 23t-23 9h-160q-14 0-23-9t-9-23v-1344q0-14 9-23t23-9h464q135 0 249 66.5t180.5 180.5 66.5 249zM1376 160v880q0 135-66.5 249t-180.5 180.5-249 66.5h-464q-14 0-23-9t-9-23v-960q0-14 9-23t23-9h160q14 0 23 9t9 23v768h272q112 0 192-80t80-192v-880q0-14 9-23t23-9h160q14 0 23 9t9 23z"}]}})


/***/ }),
/* 1814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"sheqel":{"width":1536,"height":1792,"paths":[{"d":"M992 624v496q0 14-9 23t-23 9h-160q-14 0-23-9t-9-23v-496q0-112-80-192t-192-80h-272v1152q0 14-9 23t-23 9h-160q-14 0-23-9t-9-23v-1344q0-14 9-23t23-9h464q135 0 249 66.5t180.5 180.5 66.5 249zM1376 160v880q0 135-66.5 249t-180.5 180.5-249 66.5h-464q-14 0-23-9t-9-23v-960q0-14 9-23t23-9h160q14 0 23 9t9 23v768h272q112 0 192-80t80-192v-880q0-14 9-23t23-9h160q14 0 23 9t9 23z"}]}})


/***/ }),
/* 1815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"shield":{"width":1280,"height":1792,"paths":[{"d":"M1088 960v-640h-448v1137q119-63 213-137 235-184 235-360zM1280 192v768q0 86-33.5 170.5t-83 150-118 127.5-126.5 103-121 77.5-89.5 49.5-42.5 20q-12 6-26 6t-26-6q-16-7-42.5-20t-89.5-49.5-121-77.5-126.5-103-118-127.5-83-150-33.5-170.5v-768q0-26 19-45t45-19h1152q26 0 45 19t19 45z"}]}})


/***/ }),
/* 1816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"ship":{"width":2048,"height":1792,"paths":[{"d":"M1811 1555q19-19 45-19t45 19l128 128-90 90-83-83-83 83q-18 19-45 19t-45-19l-83-83-83 83q-19 19-45 19t-45-19l-83-83-83 83q-19 19-45 19t-45-19l-83-83-83 83q-19 19-45 19t-45-19l-83-83-83 83q-19 19-45 19t-45-19l-83-83-83 83q-19 19-45 19t-45-19l-83-83-83 83q-19 19-45 19t-45-19l-128-128 90-90 83 83 83-83q19-19 45-19t45 19l83 83 83-83q19-19 45-19t45 19l83 83 83-83q19-19 45-19t45 19l83 83 83-83q19-19 45-19t45 19l83 83 83-83q19-19 45-19t45 19l83 83 83-83q19-19 45-19t45 19l83 83zM237 1517q-19 19-45 19t-45-19l-128-128 90-90 83 82 83-82q19-19 45-19t45 19l83 82 64-64v-293l-210-314q-17-26-7-56.5t40-40.5l177-58v-299h128v-128h256v-128h256v128h256v128h128v299l177 58q30 10 40 40.5t-7 56.5l-210 314v293l19-18q19-19 45-19t45 19l83 82 83-82q19-19 45-19t45 19l128 128-90 90-83-83-83 83q-18 19-45 19t-45-19l-83-83-83 83q-19 19-45 19t-45-19l-83-83-83 83q-19 19-45 19t-45-19l-83-83-83 83q-19 19-45 19t-45-19l-83-83-83 83q-19 19-45 19t-45-19l-83-83-83 83q-19 19-45 19t-45-19l-83-83zM640 384v128l384-128 384 128v-128h-128v-128h-512v128h-128z"}]}})


/***/ }),
/* 1817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"shirtsinbulk":{"width":1536,"height":1792,"paths":[{"d":"M0 0h1536v1392l-776 338-760-338v-1392zM1436 1327v-926h-1336v926l661 294zM1436 301v-201h-1336v201h1336zM181 599v115h-37v-115h37zM181 747v115h-37v-115h37zM181 895v115h-37v-115h37zM181 1043v115h-37v-115h37zM181 1191v115h-37v-115h37zM207 1334l15-34 105 47-15 33zM343 1394l15-34 105 46-15 34zM478 1454l15-34 105 46-15 34zM614 1513l15-33 104 46-15 34zM797 1526l105-46 15 33-105 47zM932 1466l105-46 15 34-105 46zM1068 1406l105-46 15 34-105 46zM1203 1347l105-47 15 34-105 46zM259 147v36h-114v-36h114zM421 147v36h-115v-36h115zM583 147v36h-115v-36h115zM744 147v36h-114v-36h114zM906 147v36h-114v-36h114zM1068 147v36h-115v-36h115zM1230 147v36h-115v-36h115zM1391 147v36h-114v-36h114zM181 487v79h-37v-115h115v36h-78zM421 451v36h-115v-36h115zM583 451v36h-115v-36h115zM744 451v36h-114v-36h114zM906 451v36h-114v-36h114zM1068 451v36h-115v-36h115zM1230 451v36h-115v-36h115zM1355 566v-79h-78v-36h115v115h-37zM1355 714v-115h37v115h-37zM1355 862v-115h37v115h-37zM1355 1010v-115h37v115h-37zM1355 1158v-115h37v115h-37zM1355 1306v-115h37v115h-37zM760 1271q-129 0-221-91.5t-92-221.5q0-129 92-221t221-92q130 0 221.5 92t91.5 221q0 130-91.5 221.5t-221.5 91.5zM595 890q0 36 19.5 56.5t49.5 25 64 7 64 2 49.5 9 19.5 30.5q0 49-112 49-97 0-123-51h-3l-31 63q67 42 162 42 29 0 56.5-5t55.5-16 45.5-33 17.5-53q0-46-27.5-69.5t-67.5-27-79.5-3-67-5-27.5-25.5q0-21 20.5-33t40.5-15 41-3q34 0 70.5 11t51.5 34h3l30-58q-3-1-21-8.5t-22.5-9-19.5-7-22-7-20-4.5-24-4-23-1q-29 0-56.5 5t-54 16.5-43 34-16.5 53.5z"}]}})


/***/ }),
/* 1818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"shopping-bag":{"width":1792,"height":1792,"paths":[{"d":"M1757 1408l35 313q3 28-16 50-19 21-48 21h-1664q-29 0-48-21-19-22-16-50l35-313h1722zM1664 569l86 775h-1708l86-775q3-24 21-40.5t43-16.5h256v128q0 53 37.5 90.5t90.5 37.5 90.5-37.5 37.5-90.5v-128h384v128q0 53 37.5 90.5t90.5 37.5 90.5-37.5 37.5-90.5v-128h256q25 0 43 16.5t21 40.5zM1280 384v256q0 26-19 45t-45 19-45-19-19-45v-256q0-106-75-181t-181-75-181 75-75 181v256q0 26-19 45t-45 19-45-19-19-45v-256q0-159 112.5-271.5t271.5-112.5 271.5 112.5 112.5 271.5z"}]}})


/***/ }),
/* 1819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"shopping-basket":{"width":2048,"height":1792,"paths":[{"d":"M1920 768q53 0 90.5 37.5t37.5 90.5-37.5 90.5-90.5 37.5h-15l-115 662q-8 46-44 76t-82 30h-1280q-46 0-82-30t-44-76l-115-662h-15q-53 0-90.5-37.5t-37.5-90.5 37.5-90.5 90.5-37.5h1792zM485 1568q26-2 43.5-22.5t15.5-46.5l-32-416q-2-26-22.5-43.5t-46.5-15.5-43.5 22.5-15.5 46.5l32 416q2 25 20.5 42t43.5 17h5zM896 1504v-416q0-26-19-45t-45-19-45 19-19 45v416q0 26 19 45t45 19 45-19 19-45zM1280 1504v-416q0-26-19-45t-45-19-45 19-19 45v416q0 26 19 45t45 19 45-19 19-45zM1632 1509l32-416q2-26-15.5-46.5t-43.5-22.5-46.5 15.5-22.5 43.5l-32 416q-2 26 15.5 46.5t43.5 22.5h5q25 0 43.5-17t20.5-42zM476 292l-93 412h-132l101-441q19-88 89-143.5t160-55.5h167q0-26 19-45t45-19h384q26 0 45 19t19 45h167q90 0 160 55.5t89 143.5l101 441h-132l-93-412q-11-44-45.5-72t-79.5-28h-167q0 26-19 45t-45 19h-384q-26 0-45-19t-19-45h-167q-45 0-79.5 28t-45.5 72z"}]}})


/***/ }),
/* 1820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"shopping-cart":{"width":1664,"height":1792,"paths":[{"d":"M640 1536q0 52-38 90t-90 38-90-38-38-90 38-90 90-38 90 38 38 90zM1536 1536q0 52-38 90t-90 38-90-38-38-90 38-90 90-38 90 38 38 90zM1664 448v512q0 24-16.5 42.5t-40.5 21.5l-1044 122q13 60 13 70 0 16-24 64h920q26 0 45 19t19 45-19 45-45 19h-1024q-26 0-45-19t-19-45q0-11 8-31.5t16-36 21.5-40 15.5-29.5l-177-823h-204q-26 0-45-19t-19-45 19-45 45-19h256q16 0 28.5 6.5t19.5 15.5 13 24.5 8 26 5.5 29.5 4.5 26h1201q26 0 45 19t19 45z"}]}})


/***/ }),
/* 1821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"shower":{"width":1920,"height":1792,"paths":[{"d":"M1433 249q10 10 10 23t-10 23l-626 626q-10 10-23 10t-23-10l-82-82q-10-10-10-23t10-23l44-44q-72-91-81.5-207t46.5-215q-74-71-176-71-106 0-181 75t-75 181v1280h-256v-1280q0-104 40.5-198.5t109.5-163.5 163.5-109.5 198.5-40.5q106 0 201 41t166 115q94-39 197-24.5t185 79.5l44-44q10-10 23-10t23 10zM1344 512q26 0 45 19t19 45-19 45-45 19-45-19-19-45 19-45 45-19zM1600 640q-26 0-45-19t-19-45 19-45 45-19 45 19 19 45-19 45-45 19zM1856 512q26 0 45 19t19 45-19 45-45 19-45-19-19-45 19-45 45-19zM1216 640q26 0 45 19t19 45-19 45-45 19-45-19-19-45 19-45 45-19zM1408 704q0-26 19-45t45-19 45 19 19 45-19 45-45 19-45-19-19-45zM1728 640q26 0 45 19t19 45-19 45-45 19-45-19-19-45 19-45 45-19zM1088 768q26 0 45 19t19 45-19 45-45 19-45-19-19-45 19-45 45-19zM1344 896q-26 0-45-19t-19-45 19-45 45-19 45 19 19 45-19 45-45 19zM1600 768q26 0 45 19t19 45-19 45-45 19-45-19-19-45 19-45 45-19zM1216 1024q-26 0-45-19t-19-45 19-45 45-19 45 19 19 45-19 45-45 19zM1472 896q26 0 45 19t19 45-19 45-45 19-45-19-19-45 19-45 45-19zM1088 1024q26 0 45 19t19 45-19 45-45 19-45-19-19-45 19-45 45-19zM1344 1024q26 0 45 19t19 45-19 45-45 19-45-19-19-45 19-45 45-19zM1216 1152q26 0 45 19t19 45-19 45-45 19-45-19-19-45 19-45 45-19zM1088 1280q26 0 45 19t19 45-19 45-45 19-45-19-19-45 19-45 45-19z"}]}})


/***/ }),
/* 1822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"sign-in":{"width":1536,"height":1792,"paths":[{"d":"M1184 896q0 26-19 45l-544 544q-19 19-45 19t-45-19-19-45v-288h-448q-26 0-45-19t-19-45v-384q0-26 19-45t45-19h448v-288q0-26 19-45t45-19 45 19l544 544q19 19 19 45zM1536 544v704q0 119-84.5 203.5t-203.5 84.5h-320q-13 0-22.5-9.5t-9.5-22.5q0-4-1-20t-0.5-26.5 3-23.5 10-19.5 20.5-6.5h320q66 0 113-47t47-113v-704q0-66-47-113t-113-47h-288-11-13t-11.5-1-11.5-3-8-5.5-7-9-2-13.5q0-4-1-20t-0.5-26.5 3-23.5 10-19.5 20.5-6.5h320q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 1823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"sign-language":{"width":1664,"height":1792,"paths":[{"d":"M831 673q32 0 59 18l222 148q61 40 110 97l146 170q40 46 29 106l-72 413q-6 32-29.5 53.5t-55.5 25.5l-527 56-352 32h-9q-39 0-67.5-28t-28.5-68q0-37 27-64t65-32l260-32h-448q-41 0-69.5-30t-26.5-71q2-39 32-65t69-26l442-1-521-64q-41-5-66-37t-19-73q6-35 34.5-57.5t65.5-22.5h10l481 60-351-94q-38-10-62-41.5t-18-68.5q6-36 33-58.5t62-22.5q6 0 20 2l448 96 217 37q1 0 3 0.5t3 0.5q23 0 30.5-23t-12.5-36l-186-125q-35-23-42-63.5t18-73.5q27-38 76-38zM761 875l186 125-218-37-5-2-36-38-238-262q-1-1-2.5-3.5t-2.5-3.5q-24-31-18.5-70t37.5-64q31-23 68-17.5t64 33.5l142 147q-2 1-5 3.5t-4 4.5q-32 45-23 99t55 85zM1648 421l15 266q4 73-11 147l-48 219q-12 59-67 87l-106 54q2-62-39-109l-146-170q-53-61-117-103l-222-148q-34-23-76-23-51 0-88 37l-235-312q-25-33-18-73.5t41-63.5q33-22 71.5-14t62.5 40l266 352-262-455q-21-35-10.5-75t47.5-59q35-18 72.5-6t57.5 46l241 420-136-337q-15-35-4.5-74t44.5-56q37-19 76-6t56 51l193 415 101 196q8 15 23 17.5t27-7.5 11-26l-12-224q-2-41 26-71t69-31q39 0 67 28.5t30 67.5z"}]}})


/***/ }),
/* 1824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"sign-out":{"width":1664,"height":1792,"paths":[{"d":"M640 1440q0 4 1 20t0.5 26.5-3 23.5-10 19.5-20.5 6.5h-320q-119 0-203.5-84.5t-84.5-203.5v-704q0-119 84.5-203.5t203.5-84.5h320q13 0 22.5 9.5t9.5 22.5q0 4 1 20t0.5 26.5-3 23.5-10 19.5-20.5 6.5h-320q-66 0-113 47t-47 113v704q0 66 47 113t113 47h288 11 13t11.5 1 11.5 3 8 5.5 7 9 2 13.5zM1568 896q0 26-19 45l-544 544q-19 19-45 19t-45-19-19-45v-288h-448q-26 0-45-19t-19-45v-384q0-26 19-45t45-19h448v-288q0-26 19-45t45-19 45 19l544 544q19 19 19 45z"}]}})


/***/ }),
/* 1825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"signal":{"width":1792,"height":1792,"paths":[{"d":"M256 1440v192q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h192q14 0 23 9t9 23zM640 1312v320q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-320q0-14 9-23t23-9h192q14 0 23 9t9 23zM1024 1056v576q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-576q0-14 9-23t23-9h192q14 0 23 9t9 23zM1408 672v960q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-960q0-14 9-23t23-9h192q14 0 23 9t9 23zM1792 160v1472q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-1472q0-14 9-23t23-9h192q14 0 23 9t9 23z"}]}})


/***/ }),
/* 1826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"signing":{"width":1664,"height":1792,"paths":[{"d":"M831 673q32 0 59 18l222 148q61 40 110 97l146 170q40 46 29 106l-72 413q-6 32-29.5 53.5t-55.5 25.5l-527 56-352 32h-9q-39 0-67.5-28t-28.5-68q0-37 27-64t65-32l260-32h-448q-41 0-69.5-30t-26.5-71q2-39 32-65t69-26l442-1-521-64q-41-5-66-37t-19-73q6-35 34.5-57.5t65.5-22.5h10l481 60-351-94q-38-10-62-41.5t-18-68.5q6-36 33-58.5t62-22.5q6 0 20 2l448 96 217 37q1 0 3 0.5t3 0.5q23 0 30.5-23t-12.5-36l-186-125q-35-23-42-63.5t18-73.5q27-38 76-38zM761 875l186 125-218-37-5-2-36-38-238-262q-1-1-2.5-3.5t-2.5-3.5q-24-31-18.5-70t37.5-64q31-23 68-17.5t64 33.5l142 147q-2 1-5 3.5t-4 4.5q-32 45-23 99t55 85zM1648 421l15 266q4 73-11 147l-48 219q-12 59-67 87l-106 54q2-62-39-109l-146-170q-53-61-117-103l-222-148q-34-23-76-23-51 0-88 37l-235-312q-25-33-18-73.5t41-63.5q33-22 71.5-14t62.5 40l266 352-262-455q-21-35-10.5-75t47.5-59q35-18 72.5-6t57.5 46l241 420-136-337q-15-35-4.5-74t44.5-56q37-19 76-6t56 51l193 415 101 196q8 15 23 17.5t27-7.5 11-26l-12-224q-2-41 26-71t69-31q39 0 67 28.5t30 67.5z"}]}})


/***/ }),
/* 1827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"simplybuilt":{"width":2048,"height":1792,"paths":[{"d":"M863 1032q0-112-79.5-191.5t-191.5-79.5-191 79.5-79 191.5 79 191 191 79 191.5-79 79.5-191zM1726 1031q0-112-79-191t-191-79-191.5 79-79.5 191q0 113 79.5 192t191.5 79 191-79.5 79-191.5zM2048 222v1348q0 44-31.5 75.5t-76.5 31.5h-1832q-45 0-76.5-31.5t-31.5-75.5v-1348q0-44 31.5-75.5t76.5-31.5h431q44 0 76 31.5t32 75.5v161h754v-161q0-44 32-75.5t76-31.5h431q45 0 76.5 31.5t31.5 75.5z"}]}})


/***/ }),
/* 1828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"sitemap":{"width":1792,"height":1792,"paths":[{"d":"M1792 1248v320q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-320q0-40 28-68t68-28h96v-192h-512v192h96q40 0 68 28t28 68v320q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-320q0-40 28-68t68-28h96v-192h-512v192h96q40 0 68 28t28 68v320q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-320q0-40 28-68t68-28h96v-192q0-52 38-90t90-38h512v-192h-96q-40 0-68-28t-28-68v-320q0-40 28-68t68-28h320q40 0 68 28t28 68v320q0 40-28 68t-68 28h-96v192h512q52 0 90 38t38 90v192h96q40 0 68 28t28 68z"}]}})


/***/ }),
/* 1829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"skyatlas":{"width":2048,"height":1792,"paths":[{"d":"M1430 583zM1690 787q148 0 253 98.5t105 244.5q0 157-109 261.5t-267 104.5q-85 0-162-27.5t-138-73.5-118-106-109-126-103.5-132.5-108.5-126.5-117-106-136-73.5-159-27.5q-154 0-251.5 91.5t-97.5 244.5q0 157 104 250t263 93q100 0 208-37.5t193-98.5q5-4 21-18.5t30-24 22-9.5q14 0 24.5 10.5t10.5 24.5q0 24-60 77-101 88-234.5 142t-260.5 54q-133 0-245.5-58t-180-165-67.5-241q0-205 141.5-341t347.5-136q120 0 226.5 43.5t185.5 113 151.5 153 139 167.5 133.5 153.5 149.5 113 172.5 43.5q102 0 168.5-61.5t66.5-162.5q0-95-64.5-159t-159.5-64q-30 0-81.5 18.5t-68.5 18.5q-20 0-35.5-15t-15.5-35q0-18 8.5-57t8.5-59q0-159-107.5-263t-266.5-104q-58 0-111.5 18.5t-84 40.5-55.5 40.5-33 18.5q-15 0-25.5-10.5t-10.5-25.5q0-19 25-46 59-67 147-103.5t182-36.5q191 0 318 125.5t127 315.5q0 37-4 66 57-15 115-15z"}]}})


/***/ }),
/* 1830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"skype":{"width":1536,"height":1792,"paths":[{"d":"M1173 1063q0-50-19.5-91.5t-48.5-68.5-73-49-82.5-34-87.5-23l-104-24q-30-7-44-10.5t-35-11.5-30-16-16.5-21-7.5-30q0-77 144-77 43 0 77 12t54 28.5 38 33.5 40 29 48 12q47 0 75.5-32t28.5-77q0-55-56-99.5t-142-67.5-182-23q-68 0-132 15.5t-119.5 47-89 87-33.5 128.5q0 61 19 106.5t56 75.5 80 48.5 103 32.5l146 36q90 22 112 36 32 20 32 60 0 39-40 64.5t-105 25.5q-51 0-91.5-16t-65-38.5-45.5-45-46-38.5-54-16q-50 0-75.5 30t-25.5 75q0 92 122 157.5t291 65.5q73 0 140-18.5t122.5-53.5 88.5-93.5 33-131.5zM1536 1280q0 159-112.5 271.5t-271.5 112.5q-130 0-234-80-77 16-150 16-143 0-273.5-55.5t-225-150-150-225-55.5-273.5q0-73 16-150-80-104-80-234 0-159 112.5-271.5t271.5-112.5q130 0 234 80 77-16 150-16 143 0 273.5 55.5t225 150 150 225 55.5 273.5q0 73-16 150 80 104 80 234z"}]}})


/***/ }),
/* 1831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"slack":{"width":1664,"height":1792,"paths":[{"d":"M1519 776q62 0 103.5 40.5t41.5 101.5q0 97-93 130l-172 59 56 167q7 21 7 47 0 59-42 102t-101 43q-47 0-85.5-27t-53.5-72l-55-165-310 106 55 164q8 24 8 47 0 59-42 102t-102 43q-47 0-85-27t-53-72l-55-163-153 53q-29 9-50 9-61 0-101.5-40t-40.5-101q0-47 27.5-85t71.5-53l156-53-105-313-156 54q-26 8-48 8-60 0-101-40.5t-41-100.5q0-47 27.5-85t71.5-53l157-53-53-159q-8-24-8-47 0-60 42-102.5t102-42.5q47 0 85 27t53 72l54 160 310-105-54-160q-8-24-8-47 0-59 42.5-102t101.5-43q47 0 85.5 27.5t53.5 71.5l53 161 162-55q21-6 43-6 60 0 102.5 39.5t42.5 98.5q0 45-30 81.5t-74 51.5l-157 54 105 316 164-56q24-8 46-8zM725 1038l310-105-105-315-310 107z"}]}})


/***/ }),
/* 1832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"sliders":{"width":1536,"height":1792,"paths":[{"d":"M352 1408v128h-352v-128h352zM704 1280q26 0 45 19t19 45v256q0 26-19 45t-45 19h-256q-26 0-45-19t-19-45v-256q0-26 19-45t45-19h256zM864 896v128h-864v-128h864zM224 384v128h-224v-128h224zM1536 1408v128h-736v-128h736zM576 256q26 0 45 19t19 45v256q0 26-19 45t-45 19h-256q-26 0-45-19t-19-45v-256q0-26 19-45t45-19h256zM1216 768q26 0 45 19t19 45v256q0 26-19 45t-45 19h-256q-26 0-45-19t-19-45v-256q0-26 19-45t45-19h256zM1536 896v128h-224v-128h224zM1536 384v128h-864v-128h864z"}]}})


/***/ }),
/* 1833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"slideshare":{"width":1792,"height":1792,"paths":[{"d":"M873 740q0 83-63.5 142.5t-152.5 59.5-152.5-59.5-63.5-142.5q0-84 63.5-143t152.5-59 152.5 59 63.5 143zM1375 740q0 83-63 142.5t-153 59.5q-89 0-152.5-59.5t-63.5-142.5q0-84 63.5-143t152.5-59q90 0 153 59t63 143zM1600 920v-667q0-87-32-123.5t-111-36.5h-1112q-83 0-112.5 34t-29.5 126v673q43 23 88.5 40t81 28 81 18.5 71 11 70 4 58.5 0.5 56.5-2 44.5-2q68-1 95 27 6 6 10 9 26 25 61 51 7-91 118-87 5 0 36.5 1.5t43 2 45.5 1 53-1 54.5-4.5 61-8.5 62-13.5 67-19.5 67.5-27 72-34.5zM1763 915q-121 149-372 252 84 285-23 465-66 113-183 148-104 32-182-15-86-51-82-164l-1-326v-1q-8-2-24.5-6t-23.5-5l-1 338q4 114-83 164-79 47-183 15-117-36-182-150-105-180-22-463-251-103-372-252-25-37-4-63t60 1q4 2 11.5 7t10.5 8v-694q0-72 47-123t114-51h1257q67 0 114 51t47 123v694l21-15q39-27 60-1t-4 63z"}]}})


/***/ }),
/* 1834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"smile-o":{"width":1536,"height":1792,"paths":[{"d":"M1134 1075q-37 121-138 195t-228 74-228-74-138-195q-8-25 4-48.5t38-31.5q25-8 48.5 4t31.5 38q25 80 92.5 129.5t151.5 49.5 151.5-49.5 92.5-129.5q8-26 32-38t49-4 37 31.5 4 48.5zM640 640q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zM1152 640q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zM1408 896q0-130-51-248.5t-136.5-204-204-136.5-248.5-51-248.5 51-204 136.5-136.5 204-51 248.5 51 248.5 136.5 204 204 136.5 248.5 51 248.5-51 204-136.5 136.5-204 51-248.5zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"snapchat-ghost":{"width":1664,"height":1792,"paths":[{"d":"M848 128q134-1 240.5 68.5t163.5 192.5q27 58 27 179 0 47-9 191 14 7 28 7 18 0 51-13.5t51-13.5q29 0 56 18t27 46q0 32-31.5 54t-69 31.5-69 29-31.5 47.5q0 15 12 43 37 82 102.5 150t144.5 101q28 12 80 23 28 6 28 35 0 70-219 103-7 11-11 39t-14 46.5-33 18.5q-20 0-62-6.5t-64-6.5q-37 0-62 5-32 5-63 22.5t-58 38-58 40.5-76 33.5-99 13.5q-52 0-96.5-13.5t-75-33.5-57.5-40.5-58-38-62-22.5q-26-5-63-5-24 0-65.5 7.5t-58.5 7.5q-25 0-35-18.5t-14-47.5-11-40q-219-33-219-103 0-29 28-35 52-11 80-23 78-32 144.5-101t102.5-150q12-28 12-43 0-28-31.5-47.5t-69.5-29.5-69.5-31.5-31.5-52.5q0-27 26-45.5t55-18.5q15 0 48 13t53 13q18 0 32-7-9-142-9-190 0-122 27-180 64-137 172-198t264-63z"}]}})


/***/ }),
/* 1836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"snapchat-square":{"width":1536,"height":1792,"paths":[{"d":"M1280 1148q0-22-22-27-67-14-118-58t-80-109q-7-14-7-25 0-15 19.5-26t42.5-17 42.5-20.5 19.5-36.5q0-19-18.5-31.5t-38.5-12.5q-11 0-31 8t-32 8q-4 0-12-2 5-63 5-115 0-78-17-114-36-78-102.5-121.5t-152.5-43.5q-198 0-275 165-18 38-18 115 0 38 6 114-10 2-15 2-11 0-31.5-8t-30.5-8q-20 0-37.5 12.5t-17.5 32.5q0 21 19.5 35.5t42.5 20.5 42.5 17 19.5 26q0 11-7 25-64 138-198 167-22 5-22 27 0 47 138 69 2 5 6 26t11 30.5 23 9.5q13 0 38.5-5t38.5-5q35 0 67.5 15t54.5 32.5 57.5 32.5 76.5 15q43 0 79-15t57.5-32.5 54-32.5 67.5-15q13 0 39 4.5t39 4.5q15 0 22.5-9.5t11.5-31 5-24.5q138-22 138-69zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 1837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"snapchat":{"width":1536,"height":1792,"paths":[{"d":"M1279 1148q0-22-22-27-67-15-118-59t-80-108q-7-19-7-25 0-15 19.5-26t43-17 43-20.5 19.5-36.5q0-19-18.5-31.5t-38.5-12.5q-12 0-32 8t-31 8q-4 0-12-2 5-95 5-114 0-79-17-114-36-78-103-121.5t-152-43.5q-199 0-275 165-17 35-17 114 0 19 5 114-4 2-14 2-12 0-32-7.5t-30-7.5q-21 0-38.5 12t-17.5 32q0 21 19.5 35.5t43 20.5 43 17 19.5 26q0 6-7 25-64 138-198 167-22 5-22 27 0 46 137 68 2 5 6 26t11.5 30.5 23.5 9.5q12 0 37.5-4.5t39.5-4.5q35 0 67 15t54 32.5 57.5 32.5 76.5 15q43 0 79-15t57.5-32.5 53.5-32.5 67-15q14 0 39.5 4t38.5 4q16 0 23-10t11-30 6-25q137-22 137-68zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"snowflake-o":{"width":1664,"height":1792,"paths":[{"d":"M1566 1117l-167 33 186 107q23 13 29.5 38.5t-6.5 48.5q-14 23-39 29.5t-48-6.5l-186-106 55 160q13 38-12 63.5t-60.5 20.5-48.5-42l-102-300-271-156v313l208 238q16 18 17 39t-11 36.5-28.5 25-37 5.5-36.5-22l-112-128v214q0 26-19 45t-45 19-45-19-19-45v-214l-112 128q-16 18-36.5 22t-37-5.5-28.5-25-11-36.5 17-39l208-238v-313l-271 156-102 300q-13 37-48.5 42t-60.5-20.5-12-63.5l55-160-186 106q-23 13-48 6.5t-39-29.5q-13-23-6.5-48.5t29.5-38.5l186-107-167-33q-29-6-42-29t-8.5-46.5 25.5-40 50-10.5l310 62 271-157-271-157-310 62q-4 1-13 1-27 0-44-18t-19-40 11-43 40-26l167-33-186-107q-23-13-29.5-38.5t6.5-48.5 39-30 48 7l186 106-55-160q-13-38 12-63.5t60.5-20.5 48.5 42l102 300 271 156v-313l-208-238q-16-18-17-39t11-36.5 28.5-25 37-5.5 36.5 22l112 128v-214q0-26 19-45t45-19 45 19 19 45v214l112-128q16-18 36.5-22t37 5.5 28.5 25 11 36.5-17 39l-208 238v313l271-156 102-300q13-37 48.5-42t60.5 20.5 12 63.5l-55 160 186-106q23-13 48-6.5t39 29.5q13 23 6.5 48.5t-29.5 38.5l-186 107 167 33q27 5 40 26t11 43-19 40-44 18q-9 0-13-1l-310-62-271 157 271 157 310-62q29-6 50 10.5t25.5 40-8.5 46.5-42 29z"}]}})


/***/ }),
/* 1839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"soccer-ball-o":{"width":1792,"height":1792,"paths":[{"d":"M609 816l287-208 287 208-109 336h-355zM896 0q182 0 348 71t286 191 191 286 71 348-71 348-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71zM1515 1350q149-203 149-454v-3l-102 89-240-224 63-323 134 12q-150-206-389-282l53 124-287 159-287-159 53-124q-239 76-389 282l135-12 62 323-240 224-102-89v3q0 251 149 454l30-132 326 40 139 298-116 69q117 39 240 39t240-39l-116-69 139-298 326-40z"}]}})


/***/ }),
/* 1840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"sort-alpha-asc":{"width":1664,"height":1792,"paths":[{"d":"M1191 408h177l-72-218-12-47q-2-16-2-20h-4l-3 20q0 1-3.5 18t-7.5 29zM736 1440q0 12-10 24l-319 319q-10 9-23 9-12 0-23-9l-320-320q-15-16-7-35 8-20 30-20h192v-1376q0-14 9-23t23-9h192q14 0 23 9t9 23v1376h192q14 0 23 9t9 23zM1572 1559v233h-584v-90l369-529q12-18 21-27l11-9v-3q-2 0-6.5 0.5t-7.5 0.5q-12 3-30 3h-232v115h-120v-229h567v89l-369 530q-6 8-21 26l-11 11v2l14-2q9-2 30-2h248v-119h121zM1661 662v106h-288v-106h75l-47-144h-243l-47 144h75v106h-287v-106h70l230-662h162l230 662h70z"}]}})


/***/ }),
/* 1841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"sort-alpha-desc":{"width":1664,"height":1792,"paths":[{"d":"M1191 1432h177l-72-218-12-47q-2-16-2-20h-4l-3 20q0 1-3.5 18t-7.5 29zM736 1440q0 12-10 24l-319 319q-10 9-23 9-12 0-23-9l-320-320q-15-16-7-35 8-20 30-20h192v-1376q0-14 9-23t23-9h192q14 0 23 9t9 23v1376h192q14 0 23 9t9 23zM1661 1686v106h-288v-106h75l-47-144h-243l-47 144h75v106h-287v-106h70l230-662h162l230 662h70zM1572 535v233h-584v-90l369-529q12-18 21-27l11-9v-3q-2 0-6.5 0.5t-7.5 0.5q-12 3-30 3h-232v115h-120v-229h567v89l-369 530q-6 8-21 26l-11 10v3l14-3q9-1 30-1h248v-119h121z"}]}})


/***/ }),
/* 1842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"sort-amount-asc":{"width":1792,"height":1792,"paths":[{"d":"M736 1440q0 12-10 24l-319 319q-10 9-23 9-12 0-23-9l-320-320q-15-16-7-35 8-20 30-20h192v-1376q0-14 9-23t23-9h192q14 0 23 9t9 23v1376h192q14 0 23 9t9 23zM1792 1568v192q0 14-9 23t-23 9h-832q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h832q14 0 23 9t9 23zM1600 1056v192q0 14-9 23t-23 9h-640q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h640q14 0 23 9t9 23zM1408 544v192q0 14-9 23t-23 9h-448q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h448q14 0 23 9t9 23zM1216 32v192q0 14-9 23t-23 9h-256q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h256q14 0 23 9t9 23z"}]}})


/***/ }),
/* 1843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"sort-amount-desc":{"width":1792,"height":1792,"paths":[{"d":"M1216 1568v192q0 14-9 23t-23 9h-256q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h256q14 0 23 9t9 23zM736 1440q0 12-10 24l-319 319q-10 9-23 9-12 0-23-9l-320-320q-15-16-7-35 8-20 30-20h192v-1376q0-14 9-23t23-9h192q14 0 23 9t9 23v1376h192q14 0 23 9t9 23zM1408 1056v192q0 14-9 23t-23 9h-448q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h448q14 0 23 9t9 23zM1600 544v192q0 14-9 23t-23 9h-640q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h640q14 0 23 9t9 23zM1792 32v192q0 14-9 23t-23 9h-832q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h832q14 0 23 9t9 23z"}]}})


/***/ }),
/* 1844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"sort-asc":{"width":1024,"height":1792,"paths":[{"d":"M1024 704q0 26-19 45t-45 19h-896q-26 0-45-19t-19-45 19-45l448-448q19-19 45-19t45 19l448 448q19 19 19 45z"}]}})


/***/ }),
/* 1845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"sort-desc":{"width":1024,"height":1792,"paths":[{"d":"M1024 1088q0 26-19 45l-448 448q-19 19-45 19t-45-19l-448-448q-19-19-19-45t19-45 45-19h896q26 0 45 19t19 45z"}]}})


/***/ }),
/* 1846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"sort-down":{"width":1024,"height":1792,"paths":[{"d":"M1024 1088q0 26-19 45l-448 448q-19 19-45 19t-45-19l-448-448q-19-19-19-45t19-45 45-19h896q26 0 45 19t19 45z"}]}})


/***/ }),
/* 1847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"sort-numeric-asc":{"width":1536,"height":1792,"paths":[{"d":"M1346 1313q0-63-44-116t-103-53q-52 0-83 37t-31 94 36.5 95 104.5 38q50 0 85-27t35-68zM736 1440q0 12-10 24l-319 319q-10 9-23 9-12 0-23-9l-320-320q-15-16-7-35 8-20 30-20h192v-1376q0-14 9-23t23-9h192q14 0 23 9t9 23v1376h192q14 0 23 9t9 23zM1486 1371q0 62-13 121.5t-41 114-68 95.5-98.5 65.5-127.5 24.5q-62 0-108-16-24-8-42-15l39-113q15 7 31 11 37 13 75 13 84 0 134.5-58.5t66.5-145.5h-2q-21 23-61.5 37t-84.5 14q-106 0-173-71.5t-67-172.5q0-105 72-178t181-73q123 0 205 94.5t82 252.5zM1456 654v114h-469v-114h167v-432q0-7 0.5-19t0.5-17v-16h-2l-7 12q-8 13-26 31l-62 58-82-86 192-185h123v654h165z"}]}})


/***/ }),
/* 1848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"sort-numeric-desc":{"width":1536,"height":1792,"paths":[{"d":"M1346 289q0-63-44-116t-103-53q-52 0-83 37t-31 94 36.5 95 104.5 38q50 0 85-27t35-68zM736 1440q0 12-10 24l-319 319q-10 9-23 9-12 0-23-9l-320-320q-15-16-7-35 8-20 30-20h192v-1376q0-14 9-23t23-9h192q14 0 23 9t9 23v1376h192q14 0 23 9t9 23zM1456 1678v114h-469v-114h167v-432q0-7 0.5-19t0.5-17v-16h-2l-7 12q-8 13-26 31l-62 58-82-86 192-185h123v654h165zM1486 347q0 62-13 121.5t-41 114-68 95.5-98.5 65.5-127.5 24.5q-62 0-108-16-24-8-42-15l39-113q15 7 31 11 37 13 75 13 84 0 134.5-58.5t66.5-145.5h-2q-21 23-61.5 37t-84.5 14q-106 0-173-71.5t-67-172.5q0-105 72-178t181-73q123 0 205 94.5t82 252.5z"}]}})


/***/ }),
/* 1849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"sort-up":{"width":1024,"height":1792,"paths":[{"d":"M1024 704q0 26-19 45t-45 19h-896q-26 0-45-19t-19-45 19-45l448-448q19-19 45-19t45 19l448 448q19 19 19 45z"}]}})


/***/ }),
/* 1850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"sort":{"width":1024,"height":1792,"paths":[{"d":"M1024 1088q0 26-19 45l-448 448q-19 19-45 19t-45-19l-448-448q-19-19-19-45t19-45 45-19h896q26 0 45 19t19 45zM1024 704q0 26-19 45t-45 19h-896q-26 0-45-19t-19-45 19-45l448-448q19-19 45-19t45 19l448 448q19 19 19 45z"}]}})


/***/ }),
/* 1851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"soundcloud":{"width":2304,"height":1792,"paths":[{"d":"M784 1372l16-241-16-523q-1-10-7.5-17t-16.5-7q-9 0-16 7t-7 17l-14 523 14 241q1 10 7.5 16.5t15.5 6.5q22 0 24-23zM1080 1343l11-211-12-586q0-16-13-24-8-5-16-5t-16 5q-13 8-13 24l-1 6-10 579q0 1 11 236v1q0 10 6 17 9 11 23 11 11 0 20-9 9-7 9-20zM35 1003l20 128-20 126q-2 9-9 9t-9-9l-17-126 17-128q2-9 9-9t9 9zM121 924l26 207-26 203q-2 9-10 9-9 0-9-10l-23-202 23-207q0-9 9-9 8 0 10 9zM401 1377zM213 886l25 245-25 237q0 11-11 11-10 0-12-11l-21-237 21-245q2-12 12-12 11 0 11 12zM307 879l23 252-23 244q-2 13-14 13-13 0-13-13l-21-244 21-252q0-13 13-13 12 0 14 13zM401 897l21 234-21 246q-2 16-16 16-6 0-10.5-4.5t-4.5-11.5l-20-246 20-234q0-6 4.5-10.5t10.5-4.5q14 0 16 15zM784 1372zM495 751l21 380-21 246q0 7-5 12.5t-12 5.5q-16 0-18-18l-18-246 18-380q2-18 18-18 7 0 12 5.5t5 12.5zM589 665l19 468-19 244q0 8-5.5 13.5t-13.5 5.5q-18 0-20-19l-16-244 16-468q2-19 20-19 8 0 13.5 5.5t5.5 13.5zM687 625l18 506-18 242q-2 21-22 21-19 0-21-21l-16-242 16-506q0-9 6.5-15.5t14.5-6.5q9 0 15 6.5t7 15.5zM1079 1367v0 0 0zM881 621l15 510-15 239q0 10-7.5 17.5t-17.5 7.5-17-7-8-18l-14-239 14-510q0-11 7.5-18t17.5-7 17.5 7 7.5 18zM980 640l14 492-14 236q0 11-8 19t-19 8-19-8-9-19l-12-236 12-492q1-12 9-20t19-8 18.5 8 8.5 20zM1192 1132l-14 231v0q0 13-9 22t-22 9-22-9-10-22l-6-114-6-117 12-636v-3q2-15 12-24 9-7 20-7 8 0 15 5 14 8 16 26zM2304 1113q0 117-83 199.5t-200 82.5h-786q-13-2-22-11t-9-22v-899q0-23 28-33 85-34 181-34 195 0 338 131.5t160 323.5q53-22 110-22 117 0 200 83t83 201z"}]}})


/***/ }),
/* 1852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"space-shuttle":{"width":2176,"height":1792,"paths":[{"d":"M620 1120q-110 64-268 64h-128v-64h-64q-13 0-22.5-23.5t-9.5-56.5q0-24 7-49-58-2-96.5-10.5t-38.5-20.5 38.5-20.5 96.5-10.5q-7-25-7-49 0-33 9.5-56.5t22.5-23.5h64v-64h128q158 0 268 64h1113q42 7 106.5 18t80.5 14q89 15 150 40.5t83.5 47.5 22.5 40-22.5 40-83.5 47.5-150 40.5q-16 3-80.5 14t-106.5 18h-1113zM1739 868q53 36 53 92t-53 92l81 30q68-48 68-122t-68-122zM625 1136h1015q-217 38-456 80-57 0-113 24t-83 48l-28 24-288 288q-26 26-70.5 45t-89.5 19h-96l-93-464h29q157 0 273-64zM352 720h-29l93-464h96q46 0 90 19t70 45l288 288q4 4 11 10.5t30.5 23 48.5 29 61.5 23 72.5 10.5l456 80h-1015q-116-64-273-64z"}]}})


/***/ }),
/* 1853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"spinner":{"width":1792,"height":1792,"paths":[{"d":"M526 1394q0 53-37.5 90.5t-90.5 37.5q-52 0-90-38t-38-90q0-53 37.5-90.5t90.5-37.5 90.5 37.5 37.5 90.5zM1024 1600q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zM320 896q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zM1522 1394q0 52-38 90t-90 38q-53 0-90.5-37.5t-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zM558 398q0 66-47 113t-113 47-113-47-47-113 47-113 113-47 113 47 47 113zM1728 896q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zM1088 192q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM1618 398q0 93-66 158.5t-158 65.5q-93 0-158.5-65.5t-65.5-158.5q0-92 65.5-158t158.5-66q92 0 158 66t66 158z"}]}})


/***/ }),
/* 1854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"spoon":{"width":768,"height":1792,"paths":[{"d":"M704 528q0 145-57 243.5t-152 135.5l45 821q2 26-16 45t-44 19h-192q-26 0-44-19t-16-45l45-821q-95-37-152-135.5t-57-243.5q0-128 42.5-249.5t117.5-200 160-78.5 160 78.5 117.5 200 42.5 249.5z"}]}})


/***/ }),
/* 1855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"spotify":{"width":1536,"height":1792,"paths":[{"d":"M1127 1210q0-32-30-51-193-115-447-115-133 0-287 34-42 9-42 52 0 20 13.5 34.5t35.5 14.5q5 0 37-8 132-27 243-27 226 0 397 103 19 11 33 11 19 0 33-13.5t14-34.5zM1223 995q0-40-35-61-237-141-548-141-153 0-303 42-48 13-48 64 0 25 17.5 42.5t42.5 17.5q7 0 37-8 122-33 251-33 279 0 488 124 24 13 38 13 25 0 42.5-17.5t17.5-42.5zM1331 747q0-47-40-70-126-73-293-110.5t-343-37.5q-204 0-364 47-23 7-38.5 25.5t-15.5 48.5q0 31 20.5 52t51.5 21q11 0 40-8 133-37 307-37 159 0 309.5 34t253.5 95q21 12 40 12 29 0 50.5-20.5t21.5-51.5zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"square-o":{"width":1408,"height":1792,"paths":[{"d":"M1120 256h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113v-832q0-66-47-113t-113-47zM1408 416v832q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 1857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"square":{"width":1536,"height":1792,"paths":[{"d":"M1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 1858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"stack-exchange":{"width":1280,"height":1792,"paths":[{"d":"M1259 1253v66q0 85-57.5 144.5t-138.5 59.5h-57l-260 269v-269h-529q-81 0-138.5-59.5t-57.5-144.5v-66h1238zM1259 927v255h-1238v-255h1238zM1259 599v255h-1238v-255h1238zM1259 459v67h-1238v-67q0-84 57.5-143.5t138.5-59.5h846q81 0 138.5 59.5t57.5 143.5z"}]}})


/***/ }),
/* 1859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"stack-overflow":{"width":1536,"height":1792,"paths":[{"d":"M1289 1632h-1118v-480h-160v640h1438v-640h-160v480zM347 1108l33-157 783 165-33 156zM450 734l67-146 725 339-67 145zM651 378l102-123 614 513-102 123zM1048 0l477 641-128 96-477-641zM330 1471v-159h800v159h-800z"}]}})


/***/ }),
/* 1860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"star-half-empty":{"width":1664,"height":1792,"paths":[{"d":"M1186 957l257-250-356-52-66-10-30-60-159-322v963l59 31 318 168-60-355-12-66zM1638 695l-363 354 86 500q5 33-6 51.5t-34 18.5q-17 0-40-12l-449-236-449 236q-23 12-40 12-23 0-34-18.5t-6-51.5l86-500-364-354q-32-32-23-59.5t54-34.5l502-73 225-455q20-41 49-41 28 0 49 41l225 455 502 73q45 7 54 34.5t-24 59.5z"}]}})


/***/ }),
/* 1861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"star-half-full":{"width":1664,"height":1792,"paths":[{"d":"M1186 957l257-250-356-52-66-10-30-60-159-322v963l59 31 318 168-60-355-12-66zM1638 695l-363 354 86 500q5 33-6 51.5t-34 18.5q-17 0-40-12l-449-236-449 236q-23 12-40 12-23 0-34-18.5t-6-51.5l86-500-364-354q-32-32-23-59.5t54-34.5l502-73 225-455q20-41 49-41 28 0 49 41l225 455 502 73q45 7 54 34.5t-24 59.5z"}]}})


/***/ }),
/* 1862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"star-half-o":{"width":1664,"height":1792,"paths":[{"d":"M1186 957l257-250-356-52-66-10-30-60-159-322v963l59 31 318 168-60-355-12-66zM1638 695l-363 354 86 500q5 33-6 51.5t-34 18.5q-17 0-40-12l-449-236-449 236q-23 12-40 12-23 0-34-18.5t-6-51.5l86-500-364-354q-32-32-23-59.5t54-34.5l502-73 225-455q20-41 49-41 28 0 49 41l225 455 502 73q45 7 54 34.5t-24 59.5z"}]}})


/***/ }),
/* 1863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"star-half":{"width":896,"height":1792,"paths":[{"d":"M832 32v1339l-449 236q-22 12-40 12-21 0-31.5-14.5t-10.5-35.5q0-6 2-20l86-500-364-354q-25-27-25-48 0-37 56-46l502-73 225-455q19-41 49-41z"}]}})


/***/ }),
/* 1864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"star-o":{"width":1664,"height":1792,"paths":[{"d":"M1137 1004l306-297-422-62-189-382-189 382-422 62 306 297-73 421 378-199 377 199zM1664 647q0 22-26 48l-363 354 86 500q1 7 1 20 0 50-41 50-19 0-40-12l-449-236-449 236q-22 12-40 12-21 0-31.5-14.5t-10.5-35.5q0-6 2-20l86-500-364-354q-25-27-25-48 0-37 56-46l502-73 225-455q19-41 49-41t49 41l225 455 502 73q56 9 56 46z"}]}})


/***/ }),
/* 1865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"star":{"width":1664,"height":1792,"paths":[{"d":"M1664 647q0 22-26 48l-363 354 86 500q1 7 1 20 0 21-10.5 35.5t-30.5 14.5q-19 0-40-12l-449-236-449 236q-22 12-40 12-21 0-31.5-14.5t-10.5-35.5q0-6 2-20l86-500-364-354q-25-27-25-48 0-37 56-46l502-73 225-455q19-41 49-41t49 41l225 455 502 73q56 9 56 46z"}]}})


/***/ }),
/* 1866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"steam-square":{"width":1536,"height":1792,"paths":[{"d":"M1242 647q0-80-57-136.5t-137-56.5-136.5 57-56.5 136q0 80 56.5 136.5t136.5 56.5 137-56.5 57-136.5zM632 1235q0 83-58 140.5t-140 57.5q-56 0-103-29t-72-77q52 20 98 40 60 24 120-1.5t85-86.5q24-60-1.5-120t-86.5-84l-82-33q22-5 42-5 82 0 140 57.5t58 140.5zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-153l172 69q20 92 93.5 152t168.5 60q104 0 181-70t87-173l345-252q150 0 255.5-105.5t105.5-254.5q0-150-105.5-255.5t-255.5-105.5q-148 0-253 104.5t-107 252.5l-225 322q-9-1-28-1-75 0-137 37l-297-119v-468q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5zM1289 649q0 100-71 170.5t-171 70.5-170.5-70.5-70.5-170.5 70.5-171 170.5-71q101 0 171.5 70.5t70.5 171.5z"}]}})


/***/ }),
/* 1867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"steam":{"width":1792,"height":1792,"paths":[{"d":"M1582 582q0 101-71.5 172.5t-172.5 71.5-172.5-71.5-71.5-172.5 71.5-172.5 172.5-71.5 172.5 71.5 71.5 172.5zM812 1324q0-104-73-177t-177-73q-27 0-54 6l104 42q77 31 109.5 106.5t1.5 151.5q-31 77-107 109t-152 1q-21-8-62-24.5t-61-24.5q32 60 91 96.5t130 36.5q104 0 177-73t73-177zM1642 583q0-126-89.5-215.5t-215.5-89.5q-127 0-216.5 89.5t-89.5 215.5q0 127 89.5 216t216.5 89q126 0 215.5-89t89.5-216zM1792 583q0 189-133.5 322t-321.5 133l-437 319q-12 129-109 218t-229 89q-121 0-214-76t-118-192l-230-92v-429l389 157q79-48 173-48 13 0 35 2l284-407q2-187 135.5-319t320.5-132q188 0 321.5 133.5t133.5 321.5z"}]}})


/***/ }),
/* 1868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"step-backward":{"width":1024,"height":1792,"paths":[{"d":"M979 141q19-19 32-13t13 32v1472q0 26-13 32t-32-13l-710-710q-9-9-13-19v678q0 26-19 45t-45 19h-128q-26 0-45-19t-19-45v-1408q0-26 19-45t45-19h128q26 0 45 19t19 45v678q4-10 13-19z"}]}})


/***/ }),
/* 1869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"step-forward":{"width":1024,"height":1792,"paths":[{"d":"M45 1651q-19 19-32 13t-13-32v-1472q0-26 13-32t32 13l710 710q9 9 13 19v-678q0-26 19-45t45-19h128q26 0 45 19t19 45v1408q0 26-19 45t-45 19h-128q-26 0-45-19t-19-45v-678q-4 10-13 19z"}]}})


/***/ }),
/* 1870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"stethoscope":{"width":1408,"height":1792,"paths":[{"d":"M1280 704q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zM1408 704q0 62-35.5 111t-92.5 70v395q0 159-131.5 271.5t-316.5 112.5-316.5-112.5-131.5-271.5v-132q-164-20-274-128t-110-252v-512q0-26 19-45t45-19q6 0 16 2 17-30 47-48t65-18q53 0 90.5 37.5t37.5 90.5-37.5 90.5-90.5 37.5q-33 0-64-18v402q0 106 94 181t226 75 226-75 94-181v-402q-31 18-64 18-53 0-90.5-37.5t-37.5-90.5 37.5-90.5 90.5-37.5q35 0 65 18t47 48q10-2 16-2 26 0 45 19t19 45v512q0 144-110 252t-274 128v132q0 106 94 181t226 75 226-75 94-181v-395q-57-21-92.5-70t-35.5-111q0-80 56-136t136-56 136 56 56 136z"}]}})


/***/ }),
/* 1871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"sticky-note-o":{"width":1536,"height":1792,"paths":[{"d":"M1400 1280h-248v248q29-10 41-22l185-185q12-12 22-41zM1120 1152h288v-896h-1280v1280h896v-288q0-40 28-68t68-28zM1536 224v1024q0 40-20 88t-48 76l-184 184q-28 28-76 48t-88 20h-1024q-40 0-68-28t-28-68v-1344q0-40 28-68t68-28h1344q40 0 68 28t28 68z"}]}})


/***/ }),
/* 1872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"sticky-note":{"width":1536,"height":1792,"paths":[{"d":"M1024 1248v416h-928q-40 0-68-28t-28-68v-1344q0-40 28-68t68-28h1344q40 0 68 28t28 68v928h-416q-40 0-68 28t-28 68zM1152 1280h381q-15 82-65 132l-184 184q-50 50-132 65v-381z"}]}})


/***/ }),
/* 1873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"stop-circle-o":{"width":1536,"height":1792,"paths":[{"d":"M768 128q209 0 385.5 103t279.5 279.5 103 385.5-103 385.5-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103zM768 1440q148 0 273-73t198-198 73-273-73-273-198-198-273-73-273 73-198 198-73 273 73 273 198 198 273 73zM480 1216q-14 0-23-9t-9-23v-576q0-14 9-23t23-9h576q14 0 23 9t9 23v576q0 14-9 23t-23 9h-576z"}]}})


/***/ }),
/* 1874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"stop-circle":{"width":1536,"height":1792,"paths":[{"d":"M1088 1184v-576q0-14-9-23t-23-9h-576q-14 0-23 9t-9 23v576q0 14 9 23t23 9h576q14 0 23-9t9-23zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"stop":{"width":1536,"height":1792,"paths":[{"d":"M1536 192v1408q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-1408q0-26 19-45t45-19h1408q26 0 45 19t19 45z"}]}})


/***/ }),
/* 1876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"street-view":{"width":1536,"height":1792,"paths":[{"d":"M1408 1536q0 63-61.5 113.5t-164 81-225 46-253.5 15.5-253.5-15.5-225-46-164-81-61.5-113.5q0-49 33-88.5t91-66.5 118-44.5 131-29.5q26-5 48 10.5t26 41.5q5 26-10.5 48t-41.5 26q-58 10-106 23.5t-76.5 25.5-48.5 23.5-27.5 19.5-8.5 12q3 11 27 26.5t73 33 114 32.5 160.5 25 201.5 10 201.5-10 160.5-25 114-33 73-33.5 27-27.5q-1-4-8.5-11t-27.5-19-48.5-23.5-76.5-25-106-23.5q-26-4-41.5-26t-10.5-48q4-26 26-41.5t48-10.5q71 12 131 29.5t118 44.5 91 66.5 33 88.5zM1024 640v384q0 26-19 45t-45 19h-64v384q0 26-19 45t-45 19h-256q-26 0-45-19t-19-45v-384h-64q-26 0-45-19t-19-45v-384q0-53 37.5-90.5t90.5-37.5h384q53 0 90.5 37.5t37.5 90.5zM928 256q0 93-65.5 158.5t-158.5 65.5-158.5-65.5-65.5-158.5 65.5-158.5 158.5-65.5 158.5 65.5 65.5 158.5z"}]}})


/***/ }),
/* 1877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"strikethrough":{"width":1792,"height":1792,"paths":[{"d":"M1760 896q14 0 23 9t9 23v64q0 14-9 23t-23 9h-1728q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h1728zM483 832q-28-35-51-80-48-98-48-188 0-181 134-309 133-127 393-127 50 0 167 19 66 12 177 48 10 38 21 118 14 123 14 183 0 18-5 45l-12 3-84-6-14-2q-50-149-103-205-88-91-210-91-114 0-182 59-67 58-67 146 0 73 66 140t279 129q69 20 173 66 58 28 95 52h-743zM990 1088h411q7 39 7 92 0 111-41 212-23 56-71 104-37 35-109 81-80 48-153 66-80 21-203 21-114 0-195-23l-140-40q-57-16-72-28-8-8-8-22v-13q0-108-2-156-1-30 0-68l2-37v-44l102-2q15 34 30 71t22.5 56 12.5 27q35 57 80 94 43 36 105 57 59 22 132 22 64 0 139-27 77-26 122-86 47-61 47-129 0-84-81-157-34-29-137-71z"}]}})


/***/ }),
/* 1878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"stumbleupon-circle":{"width":1536,"height":1792,"paths":[{"d":"M866 839l90-27v-62q0-79-58-135t-138-56-138 55.5-58 134.5v283q0 20-14 33.5t-33 13.5-32.5-13.5-13.5-33.5v-120h-151v122q0 82 57.5 139t139.5 57q81 0 138.5-56.5t57.5-136.5v-280q0-19 13.5-33t33.5-14q19 0 32.5 14t13.5 33v54zM1199 1034v-122h-150v126q0 20-13.5 33.5t-33.5 13.5q-19 0-32.5-14t-13.5-33v-123l-90 26-60-28v123q0 80 58 137t139 57 138.5-57 57.5-139zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"stumbleupon":{"width":1920,"height":1792,"paths":[{"d":"M1062 712v-118q0-42-30-72t-72-30-72 30-30 72v612q0 175-126 299t-303 124q-178 0-303.5-125.5t-125.5-303.5v-266h328v262q0 43 30 72.5t72 29.5 72-29.5 30-72.5v-620q0-171 126.5-292t301.5-121q176 0 302 122t126 294v136l-195 58zM1592 934h328v266q0 178-125.5 303.5t-303.5 125.5q-177 0-303-124.5t-126-300.5v-268l131 61 195-58v270q0 42 30 71.5t72 29.5 72-29.5 30-71.5v-275z"}]}})


/***/ }),
/* 1880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"subscript":{"width":1536,"height":1792,"paths":[{"d":"M897 1369v167h-248l-159-252-24-42q-8-9-11-21h-3q-1 3-2.5 6.5t-3.5 8-3 6.5q-10 20-25 44l-155 250h-258v-167h128l197-291-185-272h-137v-168h276l139 228q2 4 23 42 8 9 11 21h3q3-9 11-21l25-42 140-228h257v168h-125l-184 267 204 296h109zM1536 1586v206h-514l-4-27q-3-45-3-46 0-64 26-117t65-86.5 84-65 84-54.5 65-54 26-64q0-38-29.5-62.5t-70.5-24.5q-51 0-97 39-14 11-36 38l-105-92q26-37 63-66 80-65 188-65 110 0 178 59.5t68 158.5q0 66-34.5 118.5t-84 86-99.5 62.5-87 63-41 73h232v-80h126z"}]}})


/***/ }),
/* 1881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"subway":{"width":1536,"height":1792,"paths":[{"d":"M1088 0q185 0 316.5 93.5t131.5 226.5v896q0 130-125.5 222t-305.5 97l213 202q16 15 8 35t-30 20h-1056q-22 0-30-20t8-35l213-202q-180-5-305.5-97t-125.5-222v-896q0-133 131.5-226.5t316.5-93.5h640zM288 1312q66 0 113-47t47-113-47-113-113-47-113 47-47 113 47 113 113 47zM704 768v-512h-544v512h544zM1248 1312q66 0 113-47t47-113-47-113-113-47-113 47-47 113 47 113 113 47zM1408 768v-512h-576v512h576z"}]}})


/***/ }),
/* 1882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"suitcase":{"width":1792,"height":1792,"paths":[{"d":"M640 384h512v-128h-512v128zM288 384v1280h-64q-92 0-158-66t-66-158v-832q0-92 66-158t158-66h64zM1408 384v1280h-1024v-1280h128v-160q0-40 28-68t68-28h576q40 0 68 28t28 68v160h128zM1792 608v832q0 92-66 158t-158 66h-64v-1280h64q92 0 158 66t66 158z"}]}})


/***/ }),
/* 1883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"sun-o":{"width":1792,"height":1792,"paths":[{"d":"M1472 896q0-117-45.5-223.5t-123-184-184-123-223.5-45.5-223.5 45.5-184 123-123 184-45.5 223.5 45.5 223.5 123 184 184 123 223.5 45.5 223.5-45.5 184-123 123-184 45.5-223.5zM1748 1173q-4 15-20 20l-292 96v306q0 16-13 26-15 10-29 4l-292-94-180 248q-10 13-26 13t-26-13l-180-248-292 94q-14 6-29-4-13-10-13-26v-306l-292-96q-16-5-20-20-5-17 4-29l180-248-180-248q-9-13-4-29 4-15 20-20l292-96v-306q0-16 13-26 15-10 29-4l292 94 180-248q9-12 26-12t26 12l180 248 292-94q14-6 29 4 13 10 13 26v306l292 96q16 5 20 20 5 16-4 29l-180 248 180 248q9 12 4 29z"}]}})


/***/ }),
/* 1884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"superpowers":{"width":1792,"height":1792,"paths":[{"d":"M1473 929q7-118-33-226.5t-113-189-177-131-221-57.5q-116-7-225.5 32t-192 110.5-135 175-59.5 220.5q-7 118 33 226.5t113 189 177.5 131 221.5 57.5q155 9 293-59t224-195.5 94-283.5zM1792 0l-349 348q120 117 180.5 272t50.5 321q-11 183-102 339t-241 255.5-332 124.5l-999 132 347-347q-120-116-180.5-271.5t-50.5-321.5q11-184 102-340t241.5-255.5 332.5-124.5q167-22 500-66t500-66z"}]}})


/***/ }),
/* 1885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"superscript":{"width":1536,"height":1792,"paths":[{"d":"M897 1369v167h-248l-159-252-24-42q-8-9-11-21h-3q-1 3-2.5 6.5t-3.5 8-3 6.5q-10 20-25 44l-155 250h-258v-167h128l197-291-185-272h-137v-168h276l139 228q2 4 23 42 8 9 11 21h3q3-9 11-21l25-42 140-228h257v168h-125l-184 267 204 296h109zM1534 690v206h-514l-3-27q-4-28-4-46 0-64 26-117t65-86.5 84-65 84-54.5 65-54 26-64q0-38-29.5-62.5t-70.5-24.5q-51 0-97 39-14 11-36 38l-105-92q26-37 63-66 83-65 188-65 110 0 178 59.5t68 158.5q0 56-24.5 103t-62 76.5-81.5 58.5-82 50.5-65.5 51.5-30.5 63h232v-80h126z"}]}})


/***/ }),
/* 1886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"support":{"width":1792,"height":1792,"paths":[{"d":"M896 0q182 0 348 71t286 191 191 286 71 348-71 348-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71zM896 128q-190 0-361 90l194 194q82-28 167-28t167 28l194-194q-171-90-361-90zM218 1257l194-194q-28-82-28-167t28-167l-194-194q-90 171-90 361t90 361zM896 1664q190 0 361-90l-194-194q-82 28-167 28t-167-28l-194 194q171 90 361 90zM896 1280q159 0 271.5-112.5t112.5-271.5-112.5-271.5-271.5-112.5-271.5 112.5-112.5 271.5 112.5 271.5 271.5 112.5zM1380 1063l194 194q90-171 90-361t-90-361l-194 194q28 82 28 167t-28 167z"}]}})


/***/ }),
/* 1887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"table":{"width":1664,"height":1792,"paths":[{"d":"M512 1376v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zM512 992v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zM1024 1376v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zM512 608v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zM1024 992v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zM1536 1376v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zM1024 608v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zM1536 992v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zM1536 608v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zM1664 288v1088q0 66-47 113t-113 47h-1344q-66 0-113-47t-47-113v-1088q0-66 47-113t113-47h1344q66 0 113 47t47 113z"}]}})


/***/ }),
/* 1888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"tablet":{"width":1152,"height":1792,"paths":[{"d":"M640 1408q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zM1024 1248v-960q0-13-9.5-22.5t-22.5-9.5h-832q-13 0-22.5 9.5t-9.5 22.5v960q0 13 9.5 22.5t22.5 9.5h832q13 0 22.5-9.5t9.5-22.5zM1152 288v1088q0 66-47 113t-113 47h-832q-66 0-113-47t-47-113v-1088q0-66 47-113t113-47h832q66 0 113 47t47 113z"}]}})


/***/ }),
/* 1889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"tachometer":{"width":1792,"height":1792,"paths":[{"d":"M384 1152q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM576 704q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1004 1185l101-382q6-26-7.5-48.5t-38.5-29.5-48 6.5-30 39.5l-101 382q-60 5-107 43.5t-63 98.5q-20 77 20 146t117 89 146-20 89-117q16-60-6-117t-72-91zM1664 1152q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1024 512q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1472 704q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1792 1152q0 261-141 483-19 29-54 29h-1402q-35 0-54-29-141-221-141-483 0-182 71-348t191-286 286-191 348-71 348 71 286 191 191 286 71 348z"}]}})


/***/ }),
/* 1890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"tag":{"width":1536,"height":1792,"paths":[{"d":"M448 448q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1515 1024q0 53-37 90l-491 492q-39 37-91 37-53 0-90-37l-715-716q-38-37-64.5-101t-26.5-117v-416q0-52 38-90t90-38h416q53 0 117 26.5t102 64.5l715 714q37 39 37 91z"}]}})


/***/ }),
/* 1891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"tags":{"width":1920,"height":1792,"paths":[{"d":"M448 448q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1515 1024q0 53-37 90l-491 492q-39 37-91 37-53 0-90-37l-715-716q-38-37-64.5-101t-26.5-117v-416q0-52 38-90t90-38h416q53 0 117 26.5t102 64.5l715 714q37 39 37 91zM1899 1024q0 53-37 90l-491 492q-39 37-91 37-36 0-59-14t-53-45l470-470q37-37 37-90 0-52-37-91l-715-714q-38-38-102-64.5t-117-26.5h224q53 0 117 26.5t102 64.5l715 714q37 39 37 91z"}]}})


/***/ }),
/* 1892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"tasks":{"width":1792,"height":1792,"paths":[{"d":"M1024 1408h640v-128h-640v128zM640 896h1024v-128h-1024v128zM1280 384h384v-128h-384v128zM1792 1216v256q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-256q0-26 19-45t45-19h1664q26 0 45 19t19 45zM1792 704v256q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-256q0-26 19-45t45-19h1664q26 0 45 19t19 45zM1792 192v256q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-256q0-26 19-45t45-19h1664q26 0 45 19t19 45z"}]}})


/***/ }),
/* 1893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"taxi":{"width":2048,"height":1792,"paths":[{"d":"M1824 896q93 0 158.5 65.5t65.5 158.5v384q0 14-9 23t-23 9h-96v64q0 80-56 136t-136 56-136-56-56-136v-64h-1024v64q0 80-56 136t-136 56-136-56-56-136v-64h-96q-14 0-23-9t-9-23v-384q0-93 65.5-158.5t158.5-65.5h28l105-419q23-94 104-157.5t179-63.5h128v-224q0-14 9-23t23-9h448q14 0 23 9t9 23v224h128q98 0 179 63.5t104 157.5l105 419h28zM320 1376q66 0 113-47t47-113-47-113-113-47-113 47-47 113 47 113 113 47zM516 896h1016l-89-357q-2-8-14-17.5t-21-9.5h-768q-9 0-21 9.5t-14 17.5zM1728 1376q66 0 113-47t47-113-47-113-113-47-113 47-47 113 47 113 113 47z"}]}})


/***/ }),
/* 1894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"telegram":{"width":1792,"height":1792,"paths":[{"d":"M1189 1307l147-693q9-44-10.5-63t-51.5-7l-864 333q-29 11-39.5 25t-2.5 26.5 32 19.5l221 69 513-323q21-14 32-6 7 5-4 15l-415 375v0 0l-16 228q23 0 45-22l108-104 224 165q64 36 81-38zM1792 896q0 182-71 348t-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71 348 71 286 191 191 286 71 348z"}]}})


/***/ }),
/* 1895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"television":{"width":2048,"height":1792,"paths":[{"d":"M1792 1248v-960q0-13-9.5-22.5t-22.5-9.5h-1600q-13 0-22.5 9.5t-9.5 22.5v960q0 13 9.5 22.5t22.5 9.5h1600q13 0 22.5-9.5t9.5-22.5zM1920 288v960q0 66-47 113t-113 47h-736v128h352q14 0 23 9t9 23v64q0 14-9 23t-23 9h-832q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h352v-128h-736q-66 0-113-47t-47-113v-960q0-66 47-113t113-47h1600q66 0 113 47t47 113z"}]}})


/***/ }),
/* 1896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"tencent-weibo":{"width":1280,"height":1792,"paths":[{"d":"M842 572q0 80-57 136.5t-136 56.5q-60 0-111-35-62 67-115 146-247 371-202 859 1 22-12.5 38.5t-34.5 18.5h-5q-20 0-35-13.5t-17-33.5q-14-126-3.5-247.5t29.5-217 54-186 69-155.5 74-125q61-90 132-165-16-35-16-77 0-80 56.5-136.5t136.5-56.5 136.5 56.5 56.5 136.5zM1223 583q0 158-78 292t-212.5 212-292.5 78q-64 0-131-14-21-5-32.5-23.5t-6.5-39.5q5-20 23-31.5t39-7.5q51 13 108 13 97 0 186-38t153-102 102-153 38-186-38-186-102-153-153-102-186-38-186 38-153 102-102 153-38 186q0 114 52 218 10 20 3.5 40t-25.5 30-39.5 3-30.5-26q-64-123-64-265 0-119 46.5-227t124.5-186 186-124 226-46q158 0 292.5 78t212.5 212.5 78 292.5z"}]}})


/***/ }),
/* 1897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"terminal":{"width":1664,"height":1792,"paths":[{"d":"M585 983l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23t-10 23zM1664 1440v64q0 14-9 23t-23 9h-960q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h960q14 0 23 9t9 23z"}]}})


/***/ }),
/* 1898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"text-height":{"width":1792,"height":1792,"paths":[{"d":"M1744 1408q33 0 42 18.5t-11 44.5l-126 162q-20 26-49 26t-49-26l-126-162q-20-26-11-44.5t42-18.5h80v-1024h-80q-33 0-42-18.5t11-44.5l126-162q20-26 49-26t49 26l126 162q20 26 11 44.5t-42 18.5h-80v1024h80zM81 129l54 27q12 5 211 5 44 0 132-2t132-2q36 0 107.5 0.5t107.5 0.5h293q6 0 21 0.5t20.5 0 16-3 17.5-9 15-17.5l42-1q4 0 14 0.5t14 0.5q2 112 2 336 0 80-5 109-39 14-68 18-25-44-54-128-3-9-11-48t-14.5-73.5-7.5-35.5q-6-8-12-12.5t-15.5-6-13-2.5-18-0.5-16.5 0.5q-17 0-66.5-0.5t-74.5-0.5-64 2-71 6q-9 81-8 136 0 94 2 388t2 455q0 16-2.5 71.5t0 91.5 12.5 69q40 21 124 42.5t120 37.5q5 40 5 50 0 14-3 29l-34 1q-76 2-218-8t-207-10q-50 0-151 9t-152 9q-3-51-3-52v-9q17-27 61.5-43t98.5-29 78-27q19-42 19-383 0-101-3-303t-3-303v-117q0-2 0.5-15.5t0.5-25-1-25.5-3-24-5-14q-11-12-162-12-33 0-93 12t-80 26q-19 13-34 72.5t-31.5 111-42.5 53.5q-42-26-56-44v-383z"}]}})


/***/ }),
/* 1899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"text-width":{"width":1536,"height":1792,"paths":[{"d":"M81 129l54 27q12 5 211 5 44 0 132-2t132-2q70 0 246.5-1t304.5-0.5 247 4.5q33 1 56-31l42-1q4 0 14 0.5t14 0.5q2 112 2 336 0 80-5 109-39 14-68 18-25-44-54-128-3-9-11-47.5t-15-73.5-7-36q-10-13-27-19-5-2-66-2-30 0-93-1t-103-1-94 2-96 7q-9 81-8 136l1 152v-52q0 55 1 154t1.5 180 0.5 153q0 16-2.5 71.5t0 91.5 12.5 69q40 21 124 42.5t120 37.5q5 40 5 50 0 14-3 29l-34 1q-76 2-218-8t-207-10q-50 0-151 9t-152 9q-3-51-3-52v-9q17-27 61.5-43t98.5-29 78-27q7-16 11.5-74t6-145.5 1.5-155-0.5-153.5-0.5-89q0-7-2.5-21.5t-2.5-22.5q0-7 0.5-44t1-73 0-76.5-3-67.5-6.5-32q-11-12-162-12-41 0-163 13.5t-138 24.5q-19 12-34 71.5t-31.5 111.5-42.5 54q-42-26-56-44v-383zM1310 1411q12 0 42 19.5t57.5 41.5 59.5 49 36 30q26 21 26 49t-26 49q-4 3-36 30t-59.5 49-57.5 41.5-42 19.5q-13 0-20.5-10.5t-10-28.5-2.5-33.5 1.5-33 1.5-19.5h-1024q0 2 1.5 19.5t1.5 33-2.5 33.5-10 28.5-20.5 10.5q-12 0-42-19.5t-57.5-41.5-59.5-49-36-30q-26-21-26-49t26-49q4-3 36-30t59.5-49 57.5-41.5 42-19.5q13 0 20.5 10.5t10 28.5 2.5 33.5-1.5 33-1.5 19.5h1024q0-2-1.5-19.5t-1.5-33 2.5-33.5 10-28.5 20.5-10.5z"}]}})


/***/ }),
/* 1900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"th-large":{"width":1664,"height":1792,"paths":[{"d":"M768 1024v384q0 52-38 90t-90 38h-512q-52 0-90-38t-38-90v-384q0-52 38-90t90-38h512q52 0 90 38t38 90zM768 256v384q0 52-38 90t-90 38h-512q-52 0-90-38t-38-90v-384q0-52 38-90t90-38h512q52 0 90 38t38 90zM1664 1024v384q0 52-38 90t-90 38h-512q-52 0-90-38t-38-90v-384q0-52 38-90t90-38h512q52 0 90 38t38 90zM1664 256v384q0 52-38 90t-90 38h-512q-52 0-90-38t-38-90v-384q0-52 38-90t90-38h512q52 0 90 38t38 90z"}]}})


/***/ }),
/* 1901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"th-list":{"width":1792,"height":1792,"paths":[{"d":"M512 1248v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zM512 736v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zM1792 1248v192q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h960q40 0 68 28t28 68zM512 224v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zM1792 736v192q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h960q40 0 68 28t28 68zM1792 224v192q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h960q40 0 68 28t28 68z"}]}})


/***/ }),
/* 1902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"th":{"width":1792,"height":1792,"paths":[{"d":"M512 1248v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zM512 736v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zM1152 1248v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zM512 224v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zM1152 736v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zM1792 1248v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zM1152 224v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zM1792 736v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zM1792 224v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68z"}]}})


/***/ }),
/* 1903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"themeisle":{"width":1792,"height":1792,"paths":[{"d":"M852 309q0 29-17 52.5t-45 23.5-45-23.5-17-52.5 17-52.5 45-23.5 45 23.5 17 52.5zM688 1685v-114q0-30-20.5-51.5t-50.5-21.5-50 21.5-20 51.5v114q0 30 20.5 52t49.5 22q30 0 50.5-22t20.5-52zM860 1685v-114q0-30-20-51.5t-50-21.5-50.5 21.5-20.5 51.5v114q0 30 20.5 52t50.5 22q29 0 49.5-22t20.5-52zM1034 1685v-114q0-30-20.5-51.5t-50.5-21.5-50.5 21.5-20.5 51.5v114q0 30 20.5 52t50.5 22 50.5-22 20.5-52zM1208 1685v-114q0-30-20.5-51.5t-50.5-21.5-50.5 21.5-20.5 51.5v114q0 30 20.5 52t50.5 22 50.5-22 20.5-52zM1476 1001q-84 160-232 259.5t-323 99.5q-123 0-229.5-51.5t-178.5-137-113-197.5-41-232q0-88 21-174-104 175-104 390 0 162 65 312t185 251q30-57 91-57 56 0 86 50 32-50 87-50 56 0 86 50 32-50 87-50t87 50q30-50 86-50 28 0 52.5 15.5t37.5 40.5q112-94 177-231.5t73-287.5zM1326 972q0-75-72-75-17 0-47 6-95 19-149 19-226 0-226-243 0-86 30-204-83 127-83 275 0 150 89 260.5t235 110.5q111 0 210-70 13-48 13-79zM884 313q0-50-32-89.5t-81-39.5-81 39.5-32 89.5q0 51 31.5 90.5t81.5 39.5 81.5-39.5 31.5-90.5zM1513 652q0-96-37.5-179t-113-137-173.5-54q-77 0-149 35t-127 94q-48 159-48 268 0 104 45.5 157t147.5 53q53 0 142-19 36-6 53-6 51 0 77.5 28t26.5 80q0 26-4 46 75-68 117.5-165.5t42.5-200.5zM1792 869q0 111-33.5 249.5t-93.5 204.5q-58 64-195 142.5t-228 104.5l-4 1v114q0 43-29.5 75t-72.5 32q-56 0-86-50-32 50-87 50t-87-50q-30 50-86 50-55 0-87-50-30 50-86 50-47 0-75-33.5t-28-81.5q-90 68-198 68-118 0-211-80 54-1 106-20-113-31-182-127 32 7 71 7 89 0 164-46-192-192-240-306-24-56-24-160 0-57 9-125.5t31.5-146.5 55-141 86.5-105 120-42q59 0 81 52 19-29 42-54 2-3 12-13t13-16q10-15 23-38t25-42 28-39q87-111 211.5-177t260.5-66q35 0 62 4 59-64 146-64 83 0 140 57 5 5 5 12 0 5-6 13.5t-12.5 16-16 17l-10.5 10.5q17 6 36 18t19 24q0 6-16 25 157 138 197 378 25-30 60-30 45 0 100 49 90 80 90 279z"}]}})


/***/ }),
/* 1904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"thermometer-0":{"width":1024,"height":1792,"paths":[{"d":"M640 1344q0 80-56 136t-136 56-136-56-56-136q0-79 56-135.5t136-56.5 136 56.5 56 135.5zM768 1344q0-77-34-144t-94-112v-768q0-80-56-136t-136-56-136 56-56 136v768q-60 45-94 112t-34 144q0 133 93.5 226.5t226.5 93.5 226.5-93.5 93.5-226.5zM896 1344q0 185-131.5 316.5t-316.5 131.5-316.5-131.5-131.5-316.5q0-182 128-313v-711q0-133 93.5-226.5t226.5-93.5 226.5 93.5 93.5 226.5v711q128 131 128 313zM1024 768v128h-192v-128h192zM1024 512v128h-192v-128h192zM1024 256v128h-192v-128h192z"}]}})


/***/ }),
/* 1905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"thermometer-1":{"width":1024,"height":1792,"paths":[{"d":"M640 1344q0 80-56 136t-136 56-136-56-56-136q0-60 35-110t93-71v-139h128v139q58 21 93 71t35 110zM768 1344q0-77-34-144t-94-112v-768q0-80-56-136t-136-56-136 56-56 136v768q-60 45-94 112t-34 144q0 133 93.5 226.5t226.5 93.5 226.5-93.5 93.5-226.5zM896 1344q0 185-131.5 316.5t-316.5 131.5-316.5-131.5-131.5-316.5q0-182 128-313v-711q0-133 93.5-226.5t226.5-93.5 226.5 93.5 93.5 226.5v711q128 131 128 313zM1024 768v128h-192v-128h192zM1024 512v128h-192v-128h192zM1024 256v128h-192v-128h192z"}]}})


/***/ }),
/* 1906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"thermometer-2":{"width":1024,"height":1792,"paths":[{"d":"M640 1344q0 80-56 136t-136 56-136-56-56-136q0-60 35-110t93-71v-395h128v395q58 21 93 71t35 110zM768 1344q0-77-34-144t-94-112v-768q0-80-56-136t-136-56-136 56-56 136v768q-60 45-94 112t-34 144q0 133 93.5 226.5t226.5 93.5 226.5-93.5 93.5-226.5zM896 1344q0 185-131.5 316.5t-316.5 131.5-316.5-131.5-131.5-316.5q0-182 128-313v-711q0-133 93.5-226.5t226.5-93.5 226.5 93.5 93.5 226.5v711q128 131 128 313zM1024 768v128h-192v-128h192zM1024 512v128h-192v-128h192zM1024 256v128h-192v-128h192z"}]}})


/***/ }),
/* 1907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"thermometer-3":{"width":1024,"height":1792,"paths":[{"d":"M640 1344q0 80-56 136t-136 56-136-56-56-136q0-60 35-110t93-71v-651h128v651q58 21 93 71t35 110zM768 1344q0-77-34-144t-94-112v-768q0-80-56-136t-136-56-136 56-56 136v768q-60 45-94 112t-34 144q0 133 93.5 226.5t226.5 93.5 226.5-93.5 93.5-226.5zM896 1344q0 185-131.5 316.5t-316.5 131.5-316.5-131.5-131.5-316.5q0-182 128-313v-711q0-133 93.5-226.5t226.5-93.5 226.5 93.5 93.5 226.5v711q128 131 128 313zM1024 768v128h-192v-128h192zM1024 512v128h-192v-128h192zM1024 256v128h-192v-128h192z"}]}})


/***/ }),
/* 1908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"thermometer-4":{"width":1024,"height":1792,"paths":[{"d":"M640 1344q0 80-56 136t-136 56-136-56-56-136q0-60 35-110t93-71v-907h128v907q58 21 93 71t35 110zM768 1344q0-77-34-144t-94-112v-768q0-80-56-136t-136-56-136 56-56 136v768q-60 45-94 112t-34 144q0 133 93.5 226.5t226.5 93.5 226.5-93.5 93.5-226.5zM896 1344q0 185-131.5 316.5t-316.5 131.5-316.5-131.5-131.5-316.5q0-182 128-313v-711q0-133 93.5-226.5t226.5-93.5 226.5 93.5 93.5 226.5v711q128 131 128 313zM1024 768v128h-192v-128h192zM1024 512v128h-192v-128h192zM1024 256v128h-192v-128h192z"}]}})


/***/ }),
/* 1909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"thermometer-empty":{"width":1024,"height":1792,"paths":[{"d":"M640 1344q0 80-56 136t-136 56-136-56-56-136q0-79 56-135.5t136-56.5 136 56.5 56 135.5zM768 1344q0-77-34-144t-94-112v-768q0-80-56-136t-136-56-136 56-56 136v768q-60 45-94 112t-34 144q0 133 93.5 226.5t226.5 93.5 226.5-93.5 93.5-226.5zM896 1344q0 185-131.5 316.5t-316.5 131.5-316.5-131.5-131.5-316.5q0-182 128-313v-711q0-133 93.5-226.5t226.5-93.5 226.5 93.5 93.5 226.5v711q128 131 128 313zM1024 768v128h-192v-128h192zM1024 512v128h-192v-128h192zM1024 256v128h-192v-128h192z"}]}})


/***/ }),
/* 1910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"thermometer-full":{"width":1024,"height":1792,"paths":[{"d":"M640 1344q0 80-56 136t-136 56-136-56-56-136q0-60 35-110t93-71v-907h128v907q58 21 93 71t35 110zM768 1344q0-77-34-144t-94-112v-768q0-80-56-136t-136-56-136 56-56 136v768q-60 45-94 112t-34 144q0 133 93.5 226.5t226.5 93.5 226.5-93.5 93.5-226.5zM896 1344q0 185-131.5 316.5t-316.5 131.5-316.5-131.5-131.5-316.5q0-182 128-313v-711q0-133 93.5-226.5t226.5-93.5 226.5 93.5 93.5 226.5v711q128 131 128 313zM1024 768v128h-192v-128h192zM1024 512v128h-192v-128h192zM1024 256v128h-192v-128h192z"}]}})


/***/ }),
/* 1911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"thermometer-half":{"width":1024,"height":1792,"paths":[{"d":"M640 1344q0 80-56 136t-136 56-136-56-56-136q0-60 35-110t93-71v-395h128v395q58 21 93 71t35 110zM768 1344q0-77-34-144t-94-112v-768q0-80-56-136t-136-56-136 56-56 136v768q-60 45-94 112t-34 144q0 133 93.5 226.5t226.5 93.5 226.5-93.5 93.5-226.5zM896 1344q0 185-131.5 316.5t-316.5 131.5-316.5-131.5-131.5-316.5q0-182 128-313v-711q0-133 93.5-226.5t226.5-93.5 226.5 93.5 93.5 226.5v711q128 131 128 313zM1024 768v128h-192v-128h192zM1024 512v128h-192v-128h192zM1024 256v128h-192v-128h192z"}]}})


/***/ }),
/* 1912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"thermometer-quarter":{"width":1024,"height":1792,"paths":[{"d":"M640 1344q0 80-56 136t-136 56-136-56-56-136q0-60 35-110t93-71v-139h128v139q58 21 93 71t35 110zM768 1344q0-77-34-144t-94-112v-768q0-80-56-136t-136-56-136 56-56 136v768q-60 45-94 112t-34 144q0 133 93.5 226.5t226.5 93.5 226.5-93.5 93.5-226.5zM896 1344q0 185-131.5 316.5t-316.5 131.5-316.5-131.5-131.5-316.5q0-182 128-313v-711q0-133 93.5-226.5t226.5-93.5 226.5 93.5 93.5 226.5v711q128 131 128 313zM1024 768v128h-192v-128h192zM1024 512v128h-192v-128h192zM1024 256v128h-192v-128h192z"}]}})


/***/ }),
/* 1913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"thermometer-three-quarters":{"width":1024,"height":1792,"paths":[{"d":"M640 1344q0 80-56 136t-136 56-136-56-56-136q0-60 35-110t93-71v-651h128v651q58 21 93 71t35 110zM768 1344q0-77-34-144t-94-112v-768q0-80-56-136t-136-56-136 56-56 136v768q-60 45-94 112t-34 144q0 133 93.5 226.5t226.5 93.5 226.5-93.5 93.5-226.5zM896 1344q0 185-131.5 316.5t-316.5 131.5-316.5-131.5-131.5-316.5q0-182 128-313v-711q0-133 93.5-226.5t226.5-93.5 226.5 93.5 93.5 226.5v711q128 131 128 313zM1024 768v128h-192v-128h192zM1024 512v128h-192v-128h192zM1024 256v128h-192v-128h192z"}]}})


/***/ }),
/* 1914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"thermometer":{"width":1024,"height":1792,"paths":[{"d":"M640 1344q0 80-56 136t-136 56-136-56-56-136q0-60 35-110t93-71v-907h128v907q58 21 93 71t35 110zM768 1344q0-77-34-144t-94-112v-768q0-80-56-136t-136-56-136 56-56 136v768q-60 45-94 112t-34 144q0 133 93.5 226.5t226.5 93.5 226.5-93.5 93.5-226.5zM896 1344q0 185-131.5 316.5t-316.5 131.5-316.5-131.5-131.5-316.5q0-182 128-313v-711q0-133 93.5-226.5t226.5-93.5 226.5 93.5 93.5 226.5v711q128 131 128 313zM1024 768v128h-192v-128h192zM1024 512v128h-192v-128h192zM1024 256v128h-192v-128h192z"}]}})


/***/ }),
/* 1915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"thumb-tack":{"width":1152,"height":1792,"paths":[{"d":"M480 864v-448q0-14-9-23t-23-9-23 9-9 23v448q0 14 9 23t23 9 23-9 9-23zM1152 1216q0 26-19 45t-45 19h-429l-51 483q-2 12-10.5 20.5t-20.5 8.5h-1q-27 0-32-27l-76-485h-404q-26 0-45-19t-19-45q0-123 78.5-221.5t177.5-98.5v-512q-52 0-90-38t-38-90 38-90 90-38h640q52 0 90 38t38 90-38 90-90 38v512q99 0 177.5 98.5t78.5 221.5z"}]}})


/***/ }),
/* 1916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"thumbs-down":{"width":1664,"height":1792,"paths":[{"d":"M256 576q0 26-19 45t-45 19q-27 0-45.5-19t-18.5-45q0-27 18.5-45.5t45.5-18.5q26 0 45 18.5t19 45.5zM416 1088v-640q0-26-19-45t-45-19h-288q-26 0-45 19t-19 45v640q0 26 19 45t45 19h288q26 0 45-19t19-45zM1545 939q55 61 55 149-1 78-57.5 135t-134.5 57h-277q4 14 8 24t11 22 10 18q18 37 27 57t19 58.5 10 76.5q0 24-0.5 39t-5 45-12 50-24 45-40 40.5-60 26-82.5 10.5q-26 0-45-19-20-20-34-50t-19.5-52-12.5-61q-9-42-13.5-60.5t-17.5-48.5-31-48q-33-33-101-120-49-64-101-121t-76-59q-25-2-43-20.5t-18-43.5v-641q0-26 19-44.5t45-19.5q35-1 158-44 77-26 120.5-39.5t121.5-29 144-15.5h17 76 36q133 2 197 78 58 69 49 181 39 37 54 94 17 61 0 117 46 61 43 137 0 32-15 76z"}]}})


/***/ }),
/* 1917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"thumbs-o-down":{"width":1536,"height":1792,"paths":[{"d":"M256 448q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zM1408 1024q0-35-21.5-81t-53.5-47q15-17 25-47.5t10-55.5q0-69-53-119 18-31 18-69 0-37-17.5-73.5t-47.5-52.5q5-30 5-56 0-85-49-126t-136-41h-128q-131 0-342 73-5 2-29 10.5t-35.5 12.5-35 11.5-38 11-33 6.5-31.5 3h-32v640h32q16 0 35.5 9t40 27 38.5 35.5 40 44 34.5 42.5 31.5 41 23 30q55 68 77 91 41 43 59.5 109.5t30.5 125.5 38 85q96 0 128-47t32-145q0-59-48-160.5t-48-159.5h352q50 0 89-38.5t39-89.5zM1536 1025q0 103-76 179t-180 76h-176q48 99 48 192 0 118-35 186-35 69-102 101.5t-151 32.5q-51 0-90-37-34-33-54-82t-25.5-90.5-17.5-84.5-31-64q-48-50-107-127-101-131-137-155h-274q-53 0-90.5-37.5t-37.5-90.5v-640q0-53 37.5-90.5t90.5-37.5h288q22 0 138-40 128-44 223-66t200-22h112q140 0 226.5 79t85.5 216v5q60 77 60 178 0 22-3 43 38 67 38 144 0 36-9 69 49 73 49 163z"}]}})


/***/ }),
/* 1918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"thumbs-o-up":{"width":1536,"height":1792,"paths":[{"d":"M256 1344q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zM1408 768q0-51-39-89.5t-89-38.5h-352q0-58 48-159.5t48-160.5q0-98-32-145t-128-47q-26 26-38 85t-30.5 125.5-59.5 109.5q-22 23-77 91-4 5-23 30t-31.5 41-34.5 42.5-40 44-38.5 35.5-40 27-35.5 9h-32v640h32q13 0 31.5 3t33 6.5 38 11 35 11.5 35.5 12.5 29 10.5q211 73 342 73h121q192 0 192-167 0-26-5-56 30-16 47.5-52.5t17.5-73.5-18-69q53-50 53-119 0-25-10-55.5t-25-47.5q32-1 53.5-47t21.5-81zM1536 767q0 89-49 163 9 33 9 69 0 77-38 144 3 21 3 43 0 101-60 178 1 139-85 219.5t-227 80.5h-36-93q-96 0-189.5-22.5t-216.5-65.5q-116-40-138-40h-288q-53 0-90.5-37.5t-37.5-90.5v-640q0-53 37.5-90.5t90.5-37.5h274q36-24 137-155 58-75 107-128 24-25 35.5-85.5t30.5-126.5 62-108q39-37 90-37 84 0 151 32.5t102 101.5 35 186q0 93-48 192h176q104 0 180 76t76 179z"}]}})


/***/ }),
/* 1919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"thumbs-up":{"width":1664,"height":1792,"paths":[{"d":"M256 1344q0-26-19-45t-45-19q-27 0-45.5 19t-18.5 45q0 27 18.5 45.5t45.5 18.5q26 0 45-18.5t19-45.5zM416 832v640q0 26-19 45t-45 19h-288q-26 0-45-19t-19-45v-640q0-26 19-45t45-19h288q26 0 45 19t19 45zM1600 832q0 86-55 149 15 44 15 76 3 76-43 137 17 56 0 117-15 57-54 94 9 112-49 181-64 76-197 78h-36-76-17q-66 0-144-15.5t-121.5-29-120.5-39.5q-123-43-158-44-26-1-45-19.5t-19-44.5v-641q0-25 18-43.5t43-20.5q24-2 76-59t101-121q68-87 101-120 18-18 31-48t17.5-48.5 13.5-60.5q7-39 12.5-61t19.5-52 34-50q19-19 45-19 46 0 82.5 10.5t60 26 40 40.5 24 45 12 50 5 45 0.5 39q0 38-9.5 76t-19 60-27.5 56q-3 6-10 18t-11 22-8 24h277q78 0 135 57t57 135z"}]}})


/***/ }),
/* 1920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"ticket":{"width":1792,"height":1792,"paths":[{"d":"M1024 452l316 316-572 572-316-316zM813 1431l618-618q19-19 19-45t-19-45l-362-362q-18-18-45-18t-45 18l-618 618q-19 19-19 45t19 45l362 362q18 18 45 18t45-18zM1702 794l-907 908q-37 37-90.5 37t-90.5-37l-126-126q56-56 56-136t-56-136-136-56-136 56l-125-126q-37-37-37-90.5t37-90.5l907-906q37-37 90.5-37t90.5 37l125 125q-56 56-56 136t56 136 136 56 136-56l126 125q37 37 37 90.5t-37 90.5z"}]}})


/***/ }),
/* 1921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"times-circle-o":{"width":1536,"height":1792,"paths":[{"d":"M1097 1079l-146 146q-10 10-23 10t-23-10l-137-137-137 137q-10 10-23 10t-23-10l-146-146q-10-10-10-23t10-23l137-137-137-137q-10-10-10-23t10-23l146-146q10-10 23-10t23 10l137 137 137-137q10-10 23-10t23 10l146 146q10 10 10 23t-10 23l-137 137 137 137q10 10 10 23t-10 23zM1312 896q0-148-73-273t-198-198-273-73-273 73-198 198-73 273 73 273 198 198 273 73 273-73 198-198 73-273zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"times-circle":{"width":1536,"height":1792,"paths":[{"d":"M1149 1122q0-26-19-45l-181-181 181-181q19-19 19-45 0-27-19-46l-90-90q-19-19-46-19-26 0-45 19l-181 181-181-181q-19-19-45-19-27 0-46 19l-90 90q-19 19-19 46 0 26 19 45l181 181-181 181q-19 19-19 45 0 27 19 46l90 90q19 19 46 19 26 0 45-19l181-181 181 181q19 19 45 19 27 0 46-19l90-90q19-19 19-46zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"}]}})


/***/ }),
/* 1923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"times-rectangle-o":{"width":1792,"height":1792,"paths":[{"d":"M1257 1111l-146 146q-10 10-23 10t-23-10l-169-169-169 169q-10 10-23 10t-23-10l-146-146q-10-10-10-23t10-23l169-169-169-169q-10-10-10-23t10-23l146-146q10-10 23-10t23 10l169 169 169-169q10-10 23-10t23 10l146 146q10 10 10 23t-10 23l-169 169 169 169q10 10 10 23t-10 23zM256 1408h1280v-1024h-1280v1024zM1792 288v1216q0 66-47 113t-113 47h-1472q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1472q66 0 113 47t47 113z"}]}})


/***/ }),
/* 1924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"times-rectangle":{"width":1792,"height":1792,"paths":[{"d":"M1175 1321l146-146q10-10 10-23t-10-23l-233-233 233-233q10-10 10-23t-10-23l-146-146q-10-10-23-10t-23 10l-233 233-233-233q-10-10-23-10t-23 10l-146 146q-10 10-10 23t10 23l233 233-233 233q-10 10-10 23t10 23l146 146q10 10 23 10t23-10l233-233 233 233q10 10 23 10t23-10zM1792 288v1216q0 66-47 113t-113 47h-1472q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1472q66 0 113 47t47 113z"}]}})


/***/ }),
/* 1925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"times":{"width":1408,"height":1792,"paths":[{"d":"M1298 1322q0 40-28 68l-136 136q-28 28-68 28t-68-28l-294-294-294 294q-28 28-68 28t-68-28l-136-136q-28-28-28-68t28-68l294-294-294-294q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 294 294-294q28-28 68-28t68 28l136 136q28 28 28 68t-28 68l-294 294 294 294q28 28 28 68z"}]}})


/***/ }),
/* 1926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"tint":{"width":1024,"height":1792,"paths":[{"d":"M512 1152q0-36-20-69-1-1-15.5-22.5t-25.5-38-25-44-21-50.5q-4-16-21-16t-21 16q-7 23-21 50.5t-25 44-25.5 38-15.5 22.5q-20 33-20 69 0 53 37.5 90.5t90.5 37.5 90.5-37.5 37.5-90.5zM1024 1024q0 212-150 362t-362 150-362-150-150-362q0-145 81-275 6-9 62.5-90.5t101-151 99.5-178 83-201.5q9-30 34-47t51-17 51.5 17 33.5 47q28 93 83 201.5t99.5 178 101 151 62.5 90.5q81 127 81 275z"}]}})


/***/ }),
/* 1927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"toggle-down":{"width":1536,"height":1792,"paths":[{"d":"M1145 675q18 35-5 66l-320 448q-19 27-52 27t-52-27l-320-448q-23-31-5-66 17-35 57-35h640q40 0 57 35zM1280 1376v-960q0-13-9.5-22.5t-22.5-9.5h-960q-13 0-22.5 9.5t-9.5 22.5v960q0 13 9.5 22.5t22.5 9.5h960q13 0 22.5-9.5t9.5-22.5zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 1928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"toggle-left":{"width":1536,"height":1792,"paths":[{"d":"M1024 576v640q0 26-19 45t-45 19q-20 0-37-12l-448-320q-27-19-27-52t27-52l448-320q17-12 37-12 26 0 45 19t19 45zM1280 1376v-960q0-13-9.5-22.5t-22.5-9.5h-960q-13 0-22.5 9.5t-9.5 22.5v960q0 13 9.5 22.5t22.5 9.5h960q13 0 22.5-9.5t9.5-22.5zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 1929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"toggle-off":{"width":2048,"height":1792,"paths":[{"d":"M1152 896q0-104-40.5-198.5t-109.5-163.5-163.5-109.5-198.5-40.5-198.5 40.5-163.5 109.5-109.5 163.5-40.5 198.5 40.5 198.5 109.5 163.5 163.5 109.5 198.5 40.5 198.5-40.5 163.5-109.5 109.5-163.5 40.5-198.5zM1920 896q0-104-40.5-198.5t-109.5-163.5-163.5-109.5-198.5-40.5h-386q119 90 188.5 224t69.5 288-69.5 288-188.5 224h386q104 0 198.5-40.5t163.5-109.5 109.5-163.5 40.5-198.5zM2048 896q0 130-51 248.5t-136.5 204-204 136.5-248.5 51h-768q-130 0-248.5-51t-204-136.5-136.5-204-51-248.5 51-248.5 136.5-204 204-136.5 248.5-51h768q130 0 248.5 51t204 136.5 136.5 204 51 248.5z"}]}})


/***/ }),
/* 1930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"toggle-on":{"width":2048,"height":1792,"paths":[{"d":"M0 896q0-130 51-248.5t136.5-204 204-136.5 248.5-51h768q130 0 248.5 51t204 136.5 136.5 204 51 248.5-51 248.5-136.5 204-204 136.5-248.5 51h-768q-130 0-248.5-51t-204-136.5-136.5-204-51-248.5zM1408 1408q104 0 198.5-40.5t163.5-109.5 109.5-163.5 40.5-198.5-40.5-198.5-109.5-163.5-163.5-109.5-198.5-40.5-198.5 40.5-163.5 109.5-109.5 163.5-40.5 198.5 40.5 198.5 109.5 163.5 163.5 109.5 198.5 40.5z"}]}})


/***/ }),
/* 1931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"toggle-right":{"width":1536,"height":1792,"paths":[{"d":"M1088 896q0 33-27 52l-448 320q-31 23-66 5-35-17-35-57v-640q0-40 35-57 35-18 66 5l448 320q27 19 27 52zM1280 1376v-960q0-14-9-23t-23-9h-960q-14 0-23 9t-9 23v960q0 14 9 23t23 9h960q14 0 23-9t9-23zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 1932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"toggle-up":{"width":1536,"height":1792,"paths":[{"d":"M1145 1117q-17 35-57 35h-640q-40 0-57-35-18-35 5-66l320-448q19-27 52-27t52 27l320 448q23 31 5 66zM1280 1376v-960q0-13-9.5-22.5t-22.5-9.5h-960q-13 0-22.5 9.5t-9.5 22.5v960q0 13 9.5 22.5t22.5 9.5h960q13 0 22.5-9.5t9.5-22.5zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 1933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"trademark":{"width":1973,"height":1792,"paths":[{"d":"M857 544v117q0 13-9.5 22t-22.5 9h-298v812q0 13-9 22.5t-22 9.5h-135q-13 0-22.5-9t-9.5-23v-812h-297q-13 0-22.5-9t-9.5-22v-117q0-14 9-23t23-9h793q13 0 22.5 9.5t9.5 22.5zM1895 541l77 961q1 13-8 24-10 10-23 10h-134q-12 0-21-8.5t-10-20.5l-46-588-189 425q-8 19-29 19h-120q-20 0-29-19l-188-427-45 590q-1 12-10 20.5t-21 8.5h-135q-13 0-23-10-9-10-9-24l78-961q1-12 10-20.5t21-8.5h142q20 0 29 19l220 520q10 24 20 51 3-7 9.5-24.5t10.5-26.5l221-520q9-19 29-19h141q13 0 22 8.5t10 20.5z"}]}})


/***/ }),
/* 1934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"train":{"width":1536,"height":1792,"paths":[{"d":"M1088 0q185 0 316.5 93.5t131.5 226.5v896q0 130-125.5 222t-305.5 97l213 202q16 15 8 35t-30 20h-1056q-22 0-30-20t8-35l213-202q-180-5-305.5-97t-125.5-222v-896q0-133 131.5-226.5t316.5-93.5h640zM768 1344q80 0 136-56t56-136-56-136-136-56-136 56-56 136 56 136 136 56zM1344 768v-512h-1152v512h1152z"}]}})


/***/ }),
/* 1935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"transgender-alt":{"width":1792,"height":1792,"paths":[{"d":"M1280 32q0-14 9-23t23-9h288q26 0 45 19t19 45v288q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-134l-254 255q126 158 126 359 0 221-147.5 384.5t-364.5 187.5v132h96q14 0 23 9t9 23v64q0 14-9 23t-23 9h-96v96q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-96h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h96v-132q-217-24-364.5-187.5t-147.5-384.5q0-201 126-359l-52-53-101 111q-9 10-22 10.5t-23-7.5l-48-44q-10-8-10.5-21.5t8.5-23.5l105-115-111-112v134q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-288q0-26 19-45t45-19h288q14 0 23 9t9 23v64q0 14-9 23t-23 9h-133l106 107 86-94q9-10 22-10.5t23 7.5l48 44q10 8 10.5 21.5t-8.5 23.5l-90 99 57 56q158-126 359-126t359 126l255-254h-134q-14 0-23-9t-9-23v-64zM832 1280q185 0 316.5-131.5t131.5-316.5-131.5-316.5-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5z"}]}})


/***/ }),
/* 1936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"transgender":{"width":1536,"height":1792,"paths":[{"d":"M1024 32q0-14 9-23t23-9h288q26 0 45 19t19 45v288q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-134l-254 255q126 158 126 359 0 221-147.5 384.5t-364.5 187.5v132h96q14 0 23 9t9 23v64q0 14-9 23t-23 9h-96v96q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-96h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h96v-132q-149-16-270.5-103t-186.5-223.5-53-291.5q16-204 160-353.5t347-172.5q118-14 228 19t198 103l255-254h-134q-14 0-23-9t-9-23v-64zM576 1280q185 0 316.5-131.5t131.5-316.5-131.5-316.5-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5z"}]}})


/***/ }),
/* 1937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"trash-o":{"width":1408,"height":1792,"paths":[{"d":"M512 736v576q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-576q0-14 9-23t23-9h64q14 0 23 9t9 23zM768 736v576q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-576q0-14 9-23t23-9h64q14 0 23 9t9 23zM1024 736v576q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-576q0-14 9-23t23-9h64q14 0 23 9t9 23zM1152 1460v-948h-896v948q0 22 7 40.5t14.5 27 10.5 8.5h832q3 0 10.5-8.5t14.5-27 7-40.5zM480 384h448l-48-117q-7-9-17-11h-317q-10 2-17 11zM1408 416v64q0 14-9 23t-23 9h-96v948q0 83-47 143.5t-113 60.5h-832q-66 0-113-58.5t-47-141.5v-952h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h309l70-167q15-37 54-63t79-26h320q40 0 79 26t54 63l70 167h309q14 0 23 9t9 23z"}]}})


/***/ }),
/* 1938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"trash":{"width":1408,"height":1792,"paths":[{"d":"M512 1376v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zM768 1376v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zM1024 1376v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zM480 384h448l-48-117q-7-9-17-11h-317q-10 2-17 11zM1408 416v64q0 14-9 23t-23 9h-96v948q0 83-47 143.5t-113 60.5h-832q-66 0-113-58.5t-47-141.5v-952h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h309l70-167q15-37 54-63t79-26h320q40 0 79 26t54 63l70 167h309q14 0 23 9t9 23z"}]}})


/***/ }),
/* 1939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"tree":{"width":1536,"height":1792,"paths":[{"d":"M1504 1472q0 26-19 45t-45 19h-462q1 17 6 87.5t5 108.5q0 25-18 42.5t-43 17.5h-320q-25 0-43-17.5t-18-42.5q0-38 5-108.5t6-87.5h-462q-26 0-45-19t-19-45 19-45l402-403h-229q-26 0-45-19t-19-45 19-45l402-403h-197q-26 0-45-19t-19-45 19-45l384-384q19-19 45-19t45 19l384 384q19 19 19 45t-19 45-45 19h-197l402 403q19 19 19 45t-19 45-45 19h-229l402 403q19 19 19 45z"}]}})


/***/ }),
/* 1940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"trello":{"width":1536,"height":1792,"paths":[{"d":"M704 1344v-1024q0-14-9-23t-23-9h-480q-14 0-23 9t-9 23v1024q0 14 9 23t23 9h480q14 0 23-9t9-23zM1376 960v-640q0-14-9-23t-23-9h-480q-14 0-23 9t-9 23v640q0 14 9 23t23 9h480q14 0 23-9t9-23zM1536 192v1408q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-1408q0-26 19-45t45-19h1408q26 0 45 19t19 45z"}]}})


/***/ }),
/* 1941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"tripadvisor":{"width":2304,"height":1792,"paths":[{"d":"M651 997q0 39-27.5 66.5t-65.5 27.5q-39 0-66.5-27.5t-27.5-66.5q0-38 27.5-65.5t66.5-27.5q38 0 65.5 27.5t27.5 65.5zM1805 996q0 39-27.5 66.5t-66.5 27.5-66.5-27.5-27.5-66.5 27.5-66 66.5-27 66.5 27 27.5 66zM765 997q0-79-56.5-136t-136.5-57-136.5 56.5-56.5 136.5 56.5 136.5 136.5 56.5 136.5-56.5 56.5-136.5zM1918 996q0-80-56.5-136.5t-136.5-56.5q-79 0-136 56.5t-57 136.5 56.5 136.5 136.5 56.5 136.5-56.5 56.5-136.5zM850 997q0 116-81.5 197.5t-196.5 81.5q-116 0-197.5-82t-81.5-197 82-196.5 197-81.5 196.5 81.5 81.5 196.5zM2004 996q0 115-81.5 196.5t-197.5 81.5q-115 0-196.5-81.5t-81.5-196.5 81.5-196.5 196.5-81.5q116 0 197.5 81.5t81.5 196.5zM1040 999q0-191-135.5-326.5t-326.5-135.5q-125 0-231 62t-168 168.5-62 231.5 62 231.5 168 168.5 231 62q191 0 326.5-135.5t135.5-326.5zM1708 426q-254-111-556-111-319 0-573 110 117 0 223 45.5t182.5 122.5 122 183 45.5 223q0-115 43.5-219.5t118-180.5 177.5-123 217-50zM2187 999q0-191-135-326.5t-326-135.5-326.5 135.5-135.5 326.5 135.5 326.5 326.5 135.5 326-135.5 135-326.5zM1921 433h383q-44 51-75 114.5t-40 114.5q110 151 110 337 0 156-77 288t-209 208.5-287 76.5q-133 0-249-56t-196-155q-47 56-129 179-11-22-53.5-82.5t-74.5-97.5q-80 99-196.5 155.5t-249.5 56.5q-155 0-287-76.5t-209-208.5-77-288q0-186 110-337-9-51-40-114.5t-75-114.5h365q149-100 355-156.5t432-56.5q224 0 421 56t348 157z"}]}})


/***/ }),
/* 1942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"trophy":{"width":1664,"height":1792,"paths":[{"d":"M458 883q-74-162-74-371h-256v96q0 78 94.5 162t235.5 113zM1536 608v-96h-256q0 209-74 371 141-29 235.5-113t94.5-162zM1664 480v128q0 71-41.5 143t-112 130-173 97.5-215.5 44.5q-42 54-95 95-38 34-52.5 72.5t-14.5 89.5q0 54 30.5 91t97.5 37q75 0 133.5 45.5t58.5 114.5v64q0 14-9 23t-23 9h-832q-14 0-23-9t-9-23v-64q0-69 58.5-114.5t133.5-45.5q67 0 97.5-37t30.5-91q0-51-14.5-89.5t-52.5-72.5q-53-41-95-95-113-5-215.5-44.5t-173-97.5-112-130-41.5-143v-128q0-40 28-68t68-28h288v-96q0-66 47-113t113-47h576q66 0 113 47t47 113v96h288q40 0 68 28t28 68z"}]}})


/***/ }),
/* 1943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"truck":{"width":1792,"height":1792,"paths":[{"d":"M640 1408q0-52-38-90t-90-38-90 38-38 90 38 90 90 38 90-38 38-90zM256 896h384v-256h-158q-13 0-22 9l-195 195q-9 9-9 22v30zM1536 1408q0-52-38-90t-90-38-90 38-38 90 38 90 90 38 90-38 38-90zM1792 320v1024q0 15-4 26.5t-13.5 18.5-16.5 11.5-23.5 6-22.5 2-25.5 0-22.5-0.5q0 106-75 181t-181 75-181-75-75-181h-384q0 106-75 181t-181 75-181-75-75-181h-64q-3 0-22.5 0.5t-25.5 0-22.5-2-23.5-6-16.5-11.5-13.5-18.5-4-26.5q0-26 19-45t45-19v-320q0-8-0.5-35t0-38 2.5-34.5 6.5-37 14-30.5 22.5-30l198-198q19-19 50.5-32t58.5-13h160v-192q0-26 19-45t45-19h1024q26 0 45 19t19 45z"}]}})


/***/ }),
/* 1944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"try":{"width":1152,"height":1792,"paths":[{"d":"M1152 832q0 191-94.5 353t-256.5 256.5-353 94.5h-160q-14 0-23-9t-9-23v-611l-215 66q-3 1-9 1-10 0-19-6-13-10-13-26v-128q0-23 23-31l233-71v-93l-215 66q-3 1-9 1-10 0-19-6-13-10-13-26v-128q0-23 23-31l233-71v-250q0-14 9-23t23-9h160q14 0 23 9t9 23v181l375-116q15-5 28 5t13 26v128q0 23-23 31l-393 121v93l375-116q15-5 28 5t13 26v128q0 23-23 31l-393 121v487q188-13 318-151t130-328q0-14 9-23t23-9h160q14 0 23 9t9 23z"}]}})


/***/ }),
/* 1945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"tty":{"width":1792,"height":1792,"paths":[{"d":"M448 1312v192q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h192q14 0 23 9t9 23zM256 928v192q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h192q14 0 23 9t9 23zM832 1312v192q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h192q14 0 23 9t9 23zM640 928v192q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h192q14 0 23 9t9 23zM66 768q-28 0-47-19t-19-46v-129h514v129q0 27-19 46t-46 19h-383zM1216 1312v192q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h192q14 0 23 9t9 23zM1024 928v192q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h192q14 0 23 9t9 23zM1600 1312v192q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h192q14 0 23 9t9 23zM1408 928v192q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h192q14 0 23 9t9 23zM1792 520v13h-514v-10q0-104-382-102-382 1-382 102v10h-514v-13q0-17 8.5-43t34-64 65.5-75.5 110.5-76 160-67.5 224-47.5 293.5-18.5 293 18.5 224 47.5 160.5 67.5 110.5 76 65.5 75.5 34 64 8.5 43zM1792 928v192q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h192q14 0 23 9t9 23zM1792 574v129q0 27-19 46t-46 19h-384q-27 0-46-19t-19-46v-129h514z"}]}})


/***/ }),
/* 1946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"tumblr-square":{"width":1536,"height":1792,"paths":[{"d":"M1136 1461l-62-183q-44 22-103 22-36 1-62-10.5t-38.5-31.5-17.5-40.5-5-43.5v-398h257v-194h-256v-326h-188q-8 0-9 10-5 44-17.5 87t-39 95-77 95-118.5 68v165h130v418q0 57 21.5 115t65 111 121 85.5 176.5 30.5q69-1 136.5-25t85.5-50zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 1947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"tumblr":{"width":1024,"height":1792,"paths":[{"d":"M944 1329l80 237q-23 35-111 66t-177 32q-104 2-190.5-26t-142.5-74-95-106-55.5-120-16.5-118v-544h-168v-215q72-26 129-69.5t91-90 58-102 34-99 15-88.5q1-5 4.5-8.5t7.5-3.5h244v424h333v252h-334v518q0 30 6.5 56t22.5 52.5 49.5 41.5 81.5 14q78-2 134-29z"}]}})


/***/ }),
/* 1948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"turkish-lira":{"width":1152,"height":1792,"paths":[{"d":"M1152 832q0 191-94.5 353t-256.5 256.5-353 94.5h-160q-14 0-23-9t-9-23v-611l-215 66q-3 1-9 1-10 0-19-6-13-10-13-26v-128q0-23 23-31l233-71v-93l-215 66q-3 1-9 1-10 0-19-6-13-10-13-26v-128q0-23 23-31l233-71v-250q0-14 9-23t23-9h160q14 0 23 9t9 23v181l375-116q15-5 28 5t13 26v128q0 23-23 31l-393 121v93l375-116q15-5 28 5t13 26v128q0 23-23 31l-393 121v487q188-13 318-151t130-328q0-14 9-23t23-9h160q14 0 23 9t9 23z"}]}})


/***/ }),
/* 1949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"tv":{"width":2048,"height":1792,"paths":[{"d":"M1792 1248v-960q0-13-9.5-22.5t-22.5-9.5h-1600q-13 0-22.5 9.5t-9.5 22.5v960q0 13 9.5 22.5t22.5 9.5h1600q13 0 22.5-9.5t9.5-22.5zM1920 288v960q0 66-47 113t-113 47h-736v128h352q14 0 23 9t9 23v64q0 14-9 23t-23 9h-832q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h352v-128h-736q-66 0-113-47t-47-113v-960q0-66 47-113t113-47h1600q66 0 113 47t47 113z"}]}})


/***/ }),
/* 1950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"twitch":{"width":1792,"height":1792,"paths":[{"d":"M896 434v434h-145v-434h145zM1294 434v434h-145v-434h145zM1294 1194l253-254v-795h-1194v1049h326v217l217-217h398zM1692 0v1013l-434 434h-326l-217 217h-217v-217h-398v-1158l109-289h1483z"}]}})


/***/ }),
/* 1951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"twitter-square":{"width":1536,"height":1792,"paths":[{"d":"M1280 610q-56 25-121 34 68-40 93-117-65 38-134 51-61-66-153-66-87 0-148.5 61.5t-61.5 148.5q0 29 5 48-129-7-242-65t-192-155q-29 50-29 106 0 114 91 175-47-1-100-26v2q0 75 50 133.5t123 72.5q-29 8-51 8-13 0-39-4 21 63 74.5 104t121.5 42q-116 90-261 90-26 0-50-3 148 94 322 94 112 0 210-35.5t168-95 120.5-137 75-162 24.5-168.5q0-18-1-27 63-45 105-109zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 1952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"twitter":{"width":1664,"height":1792,"paths":[{"d":"M1620 408q-67 98-162 167 1 14 1 42 0 130-38 259.5t-115.5 248.5-184.5 210.5-258 146-323 54.5q-271 0-496-145 35 4 78 4 225 0 401-138-105-2-188-64.5t-114-159.5q33 5 61 5 43 0 85-11-112-23-185.5-111.5t-73.5-205.5v-4q68 38 146 41-66-44-105-115t-39-154q0-88 44-163 121 149 294.5 238.5t371.5 99.5q-8-38-8-74 0-134 94.5-228.5t228.5-94.5q140 0 236 102 109-21 205-78-37 115-142 178 93-10 186-50z"}]}})


/***/ }),
/* 1953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"umbrella":{"width":1664,"height":1792,"paths":[{"d":"M896 828v580q0 104-76 180t-180 76-180-76-76-180q0-26 19-45t45-19 45 19 19 45q0 50 39 89t89 39 89-39 39-89v-580q33-11 64-11t64 11zM1664 855q0 13-9.5 22.5t-22.5 9.5q-11 0-23-10-49-46-93-69t-102-23q-68 0-128 37t-103 97q-7 10-17.5 28t-14.5 24q-11 17-28 17-18 0-29-17-4-6-14.5-24t-17.5-28q-43-60-102.5-97t-127.5-37-127.5 37-102.5 97q-7 10-17.5 28t-14.5 24q-11 17-29 17-17 0-28-17-4-6-14.5-24t-17.5-28q-43-60-103-97t-128-37q-58 0-102 23t-93 69q-12 10-23 10-13 0-22.5-9.5t-9.5-22.5q0-5 1-7 45-183 172.5-319.5t298-204.5 360.5-68q140 0 274.5 40t246.5 113.5 194.5 187 115.5 251.5q1 2 1 7zM896 128v98q-42-2-64-2t-64 2v-98q0-26 19-45t45-19 45 19 19 45z"}]}})


/***/ }),
/* 1954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"underline":{"width":1536,"height":1792,"paths":[{"d":"M48 223q-37-2-45-4l-3-88q13-1 40-1 60 0 112 4 132 7 166 7 86 0 168-3 116-4 146-5 56 0 86-2l-1 14 2 64v9q-60 9-124 9-60 0-79 25-13 14-13 132 0 13 0.5 32.5t0.5 25.5l1 229 14 280q6 124 51 202 35 59 96 92 88 47 177 47 104 0 191-28 56-18 99-51 48-36 65-64 36-56 53-114 21-73 21-229 0-79-3.5-128t-11-122.5-13.5-159.5l-4-59q-5-67-24-88-34-35-77-34l-100 2-14-3 2-86h84l205 10q76 3 196-10l18 2q6 38 6 51 0 7-4 31-45 12-84 13-73 11-79 17-15 15-15 41 0 7 1.5 27t1.5 31q8 19 22 396 6 195-15 304-15 76-41 122-38 65-112 123-75 57-182 89-109 33-255 33-167 0-284-46-119-47-179-122-61-76-83-195-16-80-16-237v-333q0-188-17-213-25-36-147-39zM1536 1632v-64q0-14-9-23t-23-9h-1472q-14 0-23 9t-9 23v64q0 14 9 23t23 9h1472q14 0 23-9t9-23z"}]}})


/***/ }),
/* 1955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"undo":{"width":1536,"height":1792,"paths":[{"d":"M1536 896q0 156-61 298t-164 245-245 164-298 61q-172 0-327-72.5t-264-204.5q-7-10-6.5-22.5t8.5-20.5l137-138q10-9 25-9 16 2 23 12 73 95 179 147t225 52q104 0 198.5-40.5t163.5-109.5 109.5-163.5 40.5-198.5-40.5-198.5-109.5-163.5-163.5-109.5-198.5-40.5q-98 0-188 35.5t-160 101.5l137 138q31 30 14 69-17 40-59 40h-448q-26 0-45-19t-19-45v-448q0-42 40-59 39-17 69 14l130 129q107-101 244.5-156.5t284.5-55.5q156 0 298 61t245 164 164 245 61 298z"}]}})


/***/ }),
/* 1956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"universal-access":{"width":1792,"height":1792,"paths":[{"d":"M1374 657q-6-26-28.5-39.5t-48.5-7.5q-261 62-401 62t-401-62q-26-6-48.5 7.5t-28.5 39.5 7.5 48.5 39.5 28.5q194 46 303 58-2 158-15.5 269t-26.5 155.5-41 115.5l-9 21q-10 25 1 49t36 34q9 4 23 4 44 0 60-41l8-20q54-139 71-259h42q17 120 71 259l8 20q16 41 60 41 14 0 23-4 25-10 36-34t1-49l-9-21q-28-71-41-115.5t-26.5-155.5-15.5-269q109-12 303-58 26-6 39.5-28.5t7.5-48.5zM1024 512q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1600 896q0 143-55.5 273.5t-150 225-225 150-273.5 55.5-273.5-55.5-225-150-150-225-55.5-273.5 55.5-273.5 150-225 225-150 273.5-55.5 273.5 55.5 225 150 150 225 55.5 273.5zM896 128q-156 0-298 61t-245 164-164 245-61 298 61 298 164 245 245 164 298 61 298-61 245-164 164-245 61-298-61-298-164-245-245-164-298-61zM1792 896q0 182-71 348t-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71 348 71 286 191 191 286 71 348z"}]}})


/***/ }),
/* 1957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"university":{"width":2048,"height":1792,"paths":[{"d":"M960 0l960 384v128h-128q0 26-20.5 45t-48.5 19h-1526q-28 0-48.5-19t-20.5-45h-128v-128zM256 640h256v768h128v-768h256v768h128v-768h256v768h128v-768h256v768h59q28 0 48.5 19t20.5 45v64h-1664v-64q0-26 20.5-45t48.5-19h59v-768zM1851 1600q28 0 48.5 19t20.5 45v128h-1920v-128q0-26 20.5-45t48.5-19h1782z"}]}})


/***/ }),
/* 1958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"unlink":{"width":1664,"height":1792,"paths":[{"d":"M439 1271l-256 256q-11 9-23 9t-23-9q-9-10-9-23t9-23l256-256q10-9 23-9t23 9q9 10 9 23t-9 23zM608 1312v320q0 14-9 23t-23 9-23-9-9-23v-320q0-14 9-23t23-9 23 9 9 23zM384 1088q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23 9-23 23-9h320q14 0 23 9t9 23zM1648 1216q0 120-85 203l-147 146q-83 83-203 83-121 0-204-85l-334-335q-21-21-42-56l239-18 273 274q27 27 68 27.5t68-26.5l147-146q28-28 28-67 0-40-28-68l-274-275 18-239q35 21 56 42l336 336q84 86 84 204zM1031 492l-239 18-273-274q-28-28-68-28-39 0-68 27l-147 146q-28 28-28 67 0 40 28 68l274 274-18 240q-35-21-56-42l-336-336q-84-86-84-204 0-120 85-203l147-146q83-83 203-83 121 0 204 85l334 335q21 21 42 56zM1664 576q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23 9-23 23-9h320q14 0 23 9t9 23zM1120 32v320q0 14-9 23t-23 9-23-9-9-23v-320q0-14 9-23t23-9 23 9 9 23zM1527 183l-256 256q-11 9-23 9t-23-9q-9-10-9-23t9-23l256-256q10-9 23-9t23 9q9 10 9 23t-9 23z"}]}})


/***/ }),
/* 1959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"unlock-alt":{"width":1152,"height":1792,"paths":[{"d":"M1056 768q40 0 68 28t28 68v576q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-576q0-40 28-68t68-28h32v-320q0-185 131.5-316.5t316.5-131.5 316.5 131.5 131.5 316.5q0 26-19 45t-45 19h-64q-26 0-45-19t-19-45q0-106-75-181t-181-75-181 75-75 181v320h736z"}]}})


/***/ }),
/* 1960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"unlock":{"width":1664,"height":1792,"paths":[{"d":"M1664 576v256q0 26-19 45t-45 19h-64q-26 0-45-19t-19-45v-256q0-106-75-181t-181-75-181 75-75 181v192h96q40 0 68 28t28 68v576q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-576q0-40 28-68t68-28h672v-192q0-185 131.5-316.5t316.5-131.5 316.5 131.5 131.5 316.5z"}]}})


/***/ }),
/* 1961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"unsorted":{"width":1024,"height":1792,"paths":[{"d":"M1024 1088q0 26-19 45l-448 448q-19 19-45 19t-45-19l-448-448q-19-19-19-45t19-45 45-19h896q26 0 45 19t19 45zM1024 704q0 26-19 45t-45 19h-896q-26 0-45-19t-19-45 19-45l448-448q19-19 45-19t45 19l448 448q19 19 19 45z"}]}})


/***/ }),
/* 1962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"upload":{"width":1664,"height":1792,"paths":[{"d":"M1280 1472q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zM1536 1472q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zM1664 1248v320q0 40-28 68t-68 28h-1472q-40 0-68-28t-28-68v-320q0-40 28-68t68-28h427q21 56 70.5 92t110.5 36h256q61 0 110.5-36t70.5-92h427q40 0 68 28t28 68zM1339 600q-17 40-59 40h-256v448q0 26-19 45t-45 19h-256q-26 0-45-19t-19-45v-448h-256q-42 0-59-40-17-39 14-69l448-448q18-19 45-19t45 19l448 448q31 30 14 69z"}]}})


/***/ }),
/* 1963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"usb":{"width":2304,"height":1792,"paths":[{"d":"M2288 805q16 8 16 27t-16 27l-320 192q-8 5-16 5-9 0-16-4-16-10-16-28v-128h-858q37 58 83 165 16 37 24.5 55t24 49 27 47 27 34 31.5 26 33 8h96v-96q0-14 9-23t23-9h320q14 0 23 9t9 23v320q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23v-96h-96q-32 0-61-10t-51-23.5-45-40.5-37-46-33.5-57-28.5-57.5-28-60.5q-23-53-37-81.5t-36-65-44.5-53.5-46.5-17h-360q-22 84-91 138t-157 54q-106 0-181-75t-75-181 75-181 181-75q88 0 157 54t91 138h104q24 0 46.5-17t44.5-53.5 36-65 37-81.5q19-41 28-60.5t28.5-57.5 33.5-57 37-46 45-40.5 51-23.5 61-10h107q21-57 70-92.5t111-35.5q80 0 136 56t56 136-56 136-136 56q-62 0-111-35.5t-70-92.5h-107q-17 0-33 8t-31.5 26-27 34-27 47-24 49-24.5 55q-46 107-83 165h1114v-128q0-18 16-28t32 1z"}]}})


/***/ }),
/* 1964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"usd":{"width":1024,"height":1792,"paths":[{"d":"M978 1185q0 153-99.5 263.5t-258.5 136.5v175q0 14-9 23t-23 9h-135q-13 0-22.5-9.5t-9.5-22.5v-175q-66-9-127.5-31t-101.5-44.5-74-48-46.5-37.5-17.5-18q-17-21-2-41l103-135q7-10 23-12 15-2 24 9l2 2q113 99 243 125 37 8 74 8 81 0 142.5-43t61.5-122q0-28-15-53t-33.5-42-58.5-37.5-66-32-80-32.5q-39-16-61.5-25t-61.5-26.5-62.5-31-56.5-35.5-53.5-42.5-43.5-49-35.5-58-21-66.5-8.5-78q0-138 98-242t255-134v-180q0-13 9.5-22.5t22.5-9.5h135q14 0 23 9t9 23v176q57 6 110.5 23t87 33.5 63.5 37.5 39 29 15 14q17 18 5 38l-81 146q-8 15-23 16-14 3-27-7-3-3-14.5-12t-39-26.5-58.5-32-74.5-26-85.5-11.5q-95 0-155 43t-60 111q0 26 8.5 48t29.5 41.5 39.5 33 56 31 60.5 27 70 27.5q53 20 81 31.5t76 35 75.5 42.5 62 50 53 63.5 31.5 76.5 13 94z"}]}})


/***/ }),
/* 1965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"user-circle-o":{"width":1792,"height":1792,"paths":[{"d":"M896 0q182 0 348 71t286 191 191 286 71 348q0 181-70.5 347t-190.5 286-286 191.5-349 71.5-349-71-285.5-191.5-190.5-286-71-347.5 71-348 191-286 286-191 348-71zM1515 1351q149-205 149-455 0-156-61-298t-164-245-245-164-298-61-298 61-245 164-164 245-61 298q0 250 149 455 66-327 306-327 131 128 313 128t313-128q240 0 306 327zM1280 704q0-159-112.5-271.5t-271.5-112.5-271.5 112.5-112.5 271.5 112.5 271.5 271.5 112.5 271.5-112.5 112.5-271.5z"}]}})


/***/ }),
/* 1966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"user-circle":{"width":1792,"height":1792,"paths":[{"d":"M1523 1339q-22-155-87.5-257.5t-184.5-118.5q-67 74-159.5 115.5t-195.5 41.5-195.5-41.5-159.5-115.5q-119 16-184.5 118.5t-87.5 257.5q106 150 271 237.5t356 87.5 356-87.5 271-237.5zM1280 640q0-159-112.5-271.5t-271.5-112.5-271.5 112.5-112.5 271.5 112.5 271.5 271.5 112.5 271.5-112.5 112.5-271.5zM1792 896q0 182-71 347.5t-190.5 286-285.5 191.5-349 71q-182 0-348-71t-286-191-191-286-71-348 71-348 191-286 286-191 348-71 348 71 286 191 191 286 71 348z"}]}})


/***/ }),
/* 1967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"user-md":{"width":1408,"height":1792,"paths":[{"d":"M384 1344q0 26-19 45t-45 19-45-19-19-45 19-45 45-19 45 19 19 45zM1408 1405q0 121-73 190t-194 69h-874q-121 0-194-69t-73-190q0-68 5.5-131t24-138 47.5-132.5 81-103 120-60.5q-22 52-22 120v203q-58 20-93 70t-35 111q0 80 56 136t136 56 136-56 56-136q0-61-35.5-111t-92.5-70v-203q0-62 25-93 132 104 295 104t295-104q25 31 25 93v64q-106 0-181 75t-75 181v89q-32 29-32 71 0 40 28 68t68 28 68-28 28-68q0-42-32-71v-89q0-52 38-90t90-38 90 38 38 90v89q-32 29-32 71 0 40 28 68t68 28 68-28 28-68q0-42-32-71v-89q0-68-34.5-127.5t-93.5-93.5q0-10 0.5-42.5t0-48-2.5-41.5-7-47-13-40q68 15 120 60.5t81 103 47.5 132.5 24 138 5.5 131zM1088 512q0 159-112.5 271.5t-271.5 112.5-271.5-112.5-112.5-271.5 112.5-271.5 271.5-112.5 271.5 112.5 112.5 271.5z"}]}})


/***/ }),
/* 1968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"user-o":{"width":1536,"height":1792,"paths":[{"d":"M1201 784q47 14 89.5 38t89 73 79.5 115.5 55 172 22 236.5q0 154-100 263.5t-241 109.5h-854q-141 0-241-109.5t-100-263.5q0-131 22-236.5t55-172 79.5-115.5 89-73 89.5-38q-79-125-79-272 0-104 40.5-198.5t109.5-163.5 163.5-109.5 198.5-40.5 198.5 40.5 163.5 109.5 109.5 163.5 40.5 198.5q0 147-79 272zM768 128q-159 0-271.5 112.5t-112.5 271.5 112.5 271.5 271.5 112.5 271.5-112.5 112.5-271.5-112.5-271.5-271.5-112.5zM1195 1664q88 0 150.5-71.5t62.5-173.5q0-239-78.5-377t-225.5-145q-145 127-336 127t-336-127q-147 7-225.5 145t-78.5 377q0 102 62.5 173.5t150.5 71.5h854z"}]}})


/***/ }),
/* 1969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"user-plus":{"width":2048,"height":1792,"paths":[{"d":"M704 896q-159 0-271.5-112.5t-112.5-271.5 112.5-271.5 271.5-112.5 271.5 112.5 112.5 271.5-112.5 271.5-271.5 112.5zM1664 1024h352q13 0 22.5 9.5t9.5 22.5v192q0 13-9.5 22.5t-22.5 9.5h-352v352q0 13-9.5 22.5t-22.5 9.5h-192q-13 0-22.5-9.5t-9.5-22.5v-352h-352q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h352v-352q0-13 9.5-22.5t22.5-9.5h192q13 0 22.5 9.5t9.5 22.5v352zM928 1248q0 52 38 90t90 38h256v238q-68 50-171 50h-874q-121 0-194-69t-73-190q0-53 3.5-103.5t14-109 26.5-108.5 43-97.5 62-81 85.5-53.5 111.5-20q19 0 39 17 79 61 154.5 91.5t164.5 30.5 164.5-30.5 154.5-91.5q20-17 39-17 132 0 217 96h-223q-52 0-90 38t-38 90v192z"}]}})


/***/ }),
/* 1970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"user-secret":{"width":1536,"height":1792,"paths":[{"d":"M576 1536l96-448-96-128-128-64zM832 1536l128-640-128 64-96 128zM992 526q-2-4-4-6-10-8-96-8-70 0-167 19-7 2-21 2t-21-2q-97-19-167-19-86 0-96 8-2 2-4 6 2 18 4 27 2 3 7.5 6.5t7.5 10.5q2 4 7.5 20.5t7 20.5 7.5 17 8.5 17 9 14 12 13.5 14 9.5 17.5 8 20.5 4 24.5 2q36 0 59-12.5t32.5-30 14.5-34.5 11.5-29.5 17.5-12.5h12q11 0 17.5 12.5t11.5 29.5 14.5 34.5 32.5 30 59 12.5q13 0 24.5-2t20.5-4 17.5-8 14-9.5 12-13.5 9-14 8.5-17 7.5-17 7-20.5 7.5-20.5q2-7 7.5-10.5t7.5-6.5q2-9 4-27zM1408 1405q0 121-73 190t-194 69h-874q-121 0-194-69t-73-190q0-61 4.5-118t19-125.5 37.5-123.5 63.5-103.5 93.5-74.5l-90-220h214q-22-64-22-128 0-12 2-32-194-40-194-96 0-57 210-99 17-62 51.5-134t70.5-114q32-37 76-37 30 0 84 31t84 31 84-31 84-31q44 0 76 37 36 42 70.5 114t51.5 134q210 42 210 99 0 56-194 96 7 81-20 160h214l-82 225q63 33 107.5 96.5t65.5 143.5 29 151.5 8 148.5z"}]}})


/***/ }),
/* 1971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"user-times":{"width":2048,"height":1792,"paths":[{"d":"M704 896q-159 0-271.5-112.5t-112.5-271.5 112.5-271.5 271.5-112.5 271.5 112.5 112.5 271.5-112.5 271.5-271.5 112.5zM1781 1216l249 249q9 9 9 23 0 13-9 22l-136 136q-9 9-22 9-14 0-23-9l-249-249-249 249q-9 9-23 9-13 0-22-9l-136-136q-9-9-9-22 0-14 9-23l249-249-249-249q-9-9-9-23 0-13 9-22l136-136q9-9 22-9 14 0 23 9l249 249 249-249q9-9 23-9 13 0 22 9l136 136q9 9 9 22 0 14-9 23zM1283 1216l-181 181q-37 37-37 91 0 53 37 90l83 83q-21 3-44 3h-874q-121 0-194-69t-73-190q0-53 3.5-103.5t14-109 26.5-108.5 43-97.5 62-81 85.5-53.5 111.5-20q19 0 39 17 154 122 319 122t319-122q20-17 39-17 28 0 57 6-28 27-41 50t-13 56q0 54 37 91z"}]}})


/***/ }),
/* 1972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"user":{"width":1280,"height":1792,"paths":[{"d":"M1280 1399q0 109-62.5 187t-150.5 78h-854q-88 0-150.5-78t-62.5-187q0-85 8.5-160.5t31.5-152 58.5-131 94-89 134.5-34.5q131 128 313 128t313-128q76 0 134.5 34.5t94 89 58.5 131 31.5 152 8.5 160.5zM1024 512q0 159-112.5 271.5t-271.5 112.5-271.5-112.5-112.5-271.5 112.5-271.5 271.5-112.5 271.5 112.5 112.5 271.5z"}]}})


/***/ }),
/* 1973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"users":{"width":1920,"height":1792,"paths":[{"d":"M593 896q-162 5-265 128h-134q-82 0-138-40.5t-56-118.5q0-353 124-353 6 0 43.5 21t97.5 42.5 119 21.5q67 0 133-23-5 37-5 66 0 139 81 256zM1664 1533q0 120-73 189.5t-194 69.5h-874q-121 0-194-69.5t-73-189.5q0-53 3.5-103.5t14-109 26.5-108.5 43-97.5 62-81 85.5-53.5 111.5-20q10 0 43 21.5t73 48 107 48 135 21.5 135-21.5 107-48 73-48 43-21.5q61 0 111.5 20t85.5 53.5 62 81 43 97.5 26.5 108.5 14 109 3.5 103.5zM640 256q0 106-75 181t-181 75-181-75-75-181 75-181 181-75 181 75 75 181zM1344 640q0 159-112.5 271.5t-271.5 112.5-271.5-112.5-112.5-271.5 112.5-271.5 271.5-112.5 271.5 112.5 112.5 271.5zM1920 865q0 78-56 118.5t-138 40.5h-134q-103-123-265-128 81-117 81-256 0-29-5-66 66 23 133 23 59 0 119-21.5t97.5-42.5 43.5-21q124 0 124 353zM1792 256q0 106-75 181t-181 75-181-75-75-181 75-181 181-75 181 75 75 181z"}]}})


/***/ }),
/* 1974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"vcard-o":{"width":2048,"height":1792,"paths":[{"d":"M1024 1131q0 64-37 106.5t-91 42.5h-512q-54 0-91-42.5t-37-106.5 9-117.5 29.5-103 60.5-78 97-28.5q6 4 30 18t37.5 21.5 35.5 17.5 43 14.5 42 4.5 42-4.5 43-14.5 35.5-17.5 37.5-21.5 30-18q57 0 97 28.5t60.5 78 29.5 103 9 117.5zM867 611q0 94-66.5 160.5t-160.5 66.5-160.5-66.5-66.5-160.5 66.5-160.5 160.5-66.5 160.5 66.5 66.5 160.5zM1792 1056v64q0 14-9 23t-23 9h-576q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h576q14 0 23 9t9 23zM1792 804v56q0 15-10.5 25.5t-25.5 10.5h-568q-15 0-25.5-10.5t-10.5-25.5v-56q0-15 10.5-25.5t25.5-10.5h568q15 0 25.5 10.5t10.5 25.5zM1792 544v64q0 14-9 23t-23 9h-576q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h576q14 0 23 9t9 23zM1920 1504v-1216q0-13-9.5-22.5t-22.5-9.5h-1728q-13 0-22.5 9.5t-9.5 22.5v1216q0 13 9.5 22.5t22.5 9.5h352v-96q0-14 9-23t23-9h64q14 0 23 9t9 23v96h768v-96q0-14 9-23t23-9h64q14 0 23 9t9 23v96h352q13 0 22.5-9.5t9.5-22.5zM2048 288v1216q0 66-47 113t-113 47h-1728q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1728q66 0 113 47t47 113z"}]}})


/***/ }),
/* 1975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"vcard":{"width":2048,"height":1792,"paths":[{"d":"M1024 1131q0-64-9-117.5t-29.5-103-60.5-78-97-28.5q-6 4-30 18t-37.5 21.5-35.5 17.5-43 14.5-42 4.5-42-4.5-43-14.5-35.5-17.5-37.5-21.5-30-18q-57 0-97 28.5t-60.5 78-29.5 103-9 117.5 37 106.5 91 42.5h512q54 0 91-42.5t37-106.5zM867 611q0-94-66.5-160.5t-160.5-66.5-160.5 66.5-66.5 160.5 66.5 160.5 160.5 66.5 160.5-66.5 66.5-160.5zM1792 1120v-64q0-14-9-23t-23-9h-576q-14 0-23 9t-9 23v64q0 14 9 23t23 9h576q14 0 23-9t9-23zM1792 860v-56q0-15-10.5-25.5t-25.5-10.5h-568q-15 0-25.5 10.5t-10.5 25.5v56q0 15 10.5 25.5t25.5 10.5h568q15 0 25.5-10.5t10.5-25.5zM1792 608v-64q0-14-9-23t-23-9h-576q-14 0-23 9t-9 23v64q0 14 9 23t23 9h576q14 0 23-9t9-23zM2048 288v1216q0 66-47 113t-113 47h-352v-96q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v96h-768v-96q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v96h-352q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1728q66 0 113 47t47 113z"}]}})


/***/ }),
/* 1976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"venus-double":{"width":1792,"height":1792,"paths":[{"d":"M1790 529q12 155-52.5 292t-186 224-271.5 103v260h224q14 0 23 9t9 23v64q0 14-9 23t-23 9h-224v224q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-224h-512v224q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-224h-224q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h224v-260q-150-16-271.5-103t-186-224-52.5-292q17-206 164.5-356.5t352.5-169.5q206-21 377 94 171-115 377-94 205 19 352.5 169.5t164.5 356.5zM896 889q128-131 128-313t-128-313q-128 131-128 313t128 313zM576 1024q115 0 218-57-154-165-154-391 0-224 154-391-103-57-218-57-185 0-316.5 131.5t-131.5 316.5 131.5 316.5 316.5 131.5zM1152 1408v-260q-137-15-256-94-119 79-256 94v260h512zM1216 1024q185 0 316.5-131.5t131.5-316.5-131.5-316.5-316.5-131.5q-115 0-218 57 154 167 154 391 0 226-154 391 103 57 218 57z"}]}})


/***/ }),
/* 1977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"venus-mars":{"width":2048,"height":1792,"paths":[{"d":"M1664 32q0-14 9-23t23-9h288q26 0 45 19t19 45v288q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-134l-254 255q76 95 107.5 214t9.5 247q-32 180-164.5 310t-313.5 157q-223 34-409-90-117 78-256 93v132h96q14 0 23 9t9 23v64q0 14-9 23t-23 9h-96v96q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-96h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h96v-132q-155-17-279.5-109.5t-187-237.5-39.5-307q25-187 159.5-322.5t320.5-164.5q224-34 410 90 146-97 320-97 201 0 359 126l255-254h-134q-14 0-23-9t-9-23v-64zM896 1145q128-131 128-313t-128-313q-128 131-128 313t128 313zM128 832q0 185 131.5 316.5t316.5 131.5q117 0 218-57-154-167-154-391t154-391q-101-57-218-57-185 0-316.5 131.5t-131.5 316.5zM1216 1280q185 0 316.5-131.5t131.5-316.5-131.5-316.5-316.5-131.5q-117 0-218 57 154 167 154 391t-154 391q101 57 218 57z"}]}})


/***/ }),
/* 1978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"venus":{"width":1280,"height":1792,"paths":[{"d":"M1152 576q0 221-147.5 384.5t-364.5 187.5v260h224q14 0 23 9t9 23v64q0 14-9 23t-23 9h-224v224q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-224h-224q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h224v-260q-150-16-271.5-103t-186-224-52.5-292q11-134 80.5-249t182-188 245.5-88q170-19 319 54t236 212 87 306zM128 576q0 185 131.5 316.5t316.5 131.5 316.5-131.5 131.5-316.5-131.5-316.5-316.5-131.5-316.5 131.5-131.5 316.5z"}]}})


/***/ }),
/* 1979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"viacoin":{"width":1536,"height":1792,"paths":[{"d":"M1536 0l-192 448h192v192h-274l-55 128h329v192h-411l-357 832-357-832h-411v-192h329l-55-128h-274v-192h192l-192-448h256l323 768h378l323-768h256zM768 1216l108-256h-216z"}]}})


/***/ }),
/* 1980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"viadeo-square":{"width":1536,"height":1792,"paths":[{"d":"M1050 1041q0-78-28-147-41 25-85 34 22 50 22 114 0 117-77 198.5t-193 81.5-193.5-81.5-77.5-198.5q0-115 78-199.5t193-84.5q53 0 98 19 4-43 27-87-60-21-125-21-154 0-257.5 108.5t-103.5 263.5 103.5 261 257.5 106 257.5-106.5 103.5-260.5zM872 686q2 24 2 71 0 63-5 123t-20.5 132.5-40.5 130-68.5 106-100.5 70.5q21 3 42 3h10q219-139 219-411 0-116-38-225zM872 686q-4-80-44-171.5t-98-130.5q92 156 142 302zM1207 581q0-102-51-174-41 86-124 109-69 19-109 53.5t-40 99.5q0 40 24 77 74-17 140.5-67t95.5-115q-4 52-74.5 111.5t-138.5 97.5q52 52 110 52 51 0 90-37t60-90q17-42 17-117zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 1981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"viadeo":{"width":1280,"height":1792,"paths":[{"d":"M1050 1106q0 215-147 374-148 161-378 161-232 0-378-161-147-159-147-374 0-147 68-270.5t189-196.5 268-73q96 0 182 31-32 62-39 126-66-28-143-28-167 0-280.5 123t-113.5 291q0 170 112.5 288.5t281.5 118.5 281-118.5 112-288.5q0-89-32-166 66-13 123-49 41 98 41 212zM846 917q0 192-79.5 345t-238.5 253l-14 1q-29 0-62-5 83-32 146.5-102.5t99.5-154.5 58.5-189 30-192.5 7.5-178.5q0-69-3-103 55 160 55 326zM791 589v2q-73-214-206-440 88 59 142.5 186.5t63.5 251.5zM1035 792q-83 0-160-75 218-120 290-247 19-37 21-56-42 94-139.5 166.5t-204.5 97.5q-35-54-35-113 0-37 17-79t43-68q46-44 157-74 59-16 106-58.5t74-100.5q74 105 74 253 0 109-24 170-32 77-88.5 130.5t-130.5 53.5z"}]}})


/***/ }),
/* 1982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"video-camera":{"width":1792,"height":1792,"paths":[{"d":"M1792 352v1088q0 42-39 59-13 5-25 5-27 0-45-19l-403-403v166q0 119-84.5 203.5t-203.5 84.5h-704q-119 0-203.5-84.5t-84.5-203.5v-704q0-119 84.5-203.5t203.5-84.5h704q119 0 203.5 84.5t84.5 203.5v165l403-402q18-19 45-19 12 0 25 5 39 17 39 59z"}]}})


/***/ }),
/* 1983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"vimeo-square":{"width":1536,"height":1792,"paths":[{"d":"M1292 638q10-216-161-222-231-8-312 261 44-19 82-19 85 0 74 96-4 57-74 167t-105 110q-43 0-82-169-13-54-45-255-30-189-160-177-59 7-164 100l-81 72-81 72 52 67q76-52 87-52 57 0 107 179 15 55 45 164.5t45 164.5q68 179 164 179 157 0 383-294 220-283 226-444zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 1984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"vimeo":{"width":1792,"height":1792,"paths":[{"d":"M1709 518q-10 236-332 651-333 431-562 431-142 0-240-263-44-160-132-482-72-262-157-262-18 0-127 76l-77-98q24-21 108-96.5t130-115.5q156-138 241-146 95-9 153 55.5t81 203.5q44 287 66 373 55 249 120 249 51 0 154-161 101-161 109-246 13-139-109-139-57 0-121 26 120-393 459-382 251 8 236 326z"}]}})


/***/ }),
/* 1985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"vine":{"width":1536,"height":1792,"paths":[{"d":"M1497 827v198q-101 23-198 23-65 136-165.5 271t-181.5 215.5-128 106.5q-80 45-162-3-28-17-60.5-43.5t-85-83.5-102.5-128.5-107.5-184-105.5-244-91.5-314.5-70.5-390h283q26 218 70 398.5t104.5 317 121.5 235.5 140 195q169-169 287-406-142-72-223-220t-81-333q0-192 104-314.5t284-122.5q178 0 273 105.5t95 297.5q0 159-58 286-7 1-19.5 3t-46 2-63-6-62-25.5-50.5-51.5q31-103 31-184 0-87-29-132t-79-45q-53 0-85 49.5t-32 140.5q0 186 105 293.5t267 107.5q62 0 121-14z"}]}})


/***/ }),
/* 1986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"vk":{"width":1920,"height":1792,"paths":[{"d":"M1917 520q23 64-150 294-24 32-65 85-40 51-55 72t-30.5 49.5-12 42 13 34.5 32.5 43 57 53q4 2 5 4 141 131 191 221 3 5 6.5 12.5t7 26.5-0.5 34-25 27.5-59 12.5l-256 4q-24 5-56-5t-52-22l-20-12q-30-21-70-64t-68.5-77.5-61-58-56.5-15.5q-3 1-8 3.5t-17 14.5-21.5 29.5-17 52-6.5 77.5q0 15-3.5 27.5t-7.5 18.5l-4 5q-18 19-53 22h-115q-71 4-146-16.5t-131.5-53-103-66-70.5-57.5l-25-24q-10-10-27.5-30t-71.5-91-106-151-122.5-211-130.5-272q-6-16-6-27t3-16l4-6q15-19 57-19l274-2q12 2 23 6.5t16 8.5l5 3q16 11 24 32 20 50 46 103.5t41 81.5l16 29q29 60 56 104t48.5 68.5 41.5 38.5 34 14 27-5q2-1 5-5t12-22 13.5-47 9.5-81 0-125q-2-40-9-73t-14-46l-6-12q-25-34-85-43-13-2 5-24 16-19 38-30 53-26 239-24 82 1 135 13 20 5 33.5 13.5t20.5 24 10.5 32 3.5 45.5-1 55-2.5 70.5-1.5 82.5q0 11-1 42t-0.5 48 3.5 40.5 11.5 39 22.5 24.5q8 2 17 4t26-11 38-34.5 52-67 68-107.5q60-104 107-225 4-10 10-17.5t11-10.5l4-3 5-2.5t13-3 20-0.5l288-2q39-5 64 2.5t31 16.5z"}]}})


/***/ }),
/* 1987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"volume-control-phone":{"width":1408,"height":1792,"paths":[{"d":"M617 1689q0-11-13-58t-31-107-20-69q-1-4-5-26.5t-8.5-36-13.5-21.5q-15-14-51-14-23 0-70 5.5t-71 5.5q-34 0-47-11-6-5-11-15.5t-7.5-20-6.5-24-5-18.5q-37-128-37-255t37-255q1-4 5-18.5t6.5-24 7.5-20 11-15.5q13-11 47-11 24 0 71 5.5t70 5.5q36 0 51-14 9-8 13.5-21.5t8.5-36 5-26.5q2-9 20-69t31-107 13-58q0-22-43.5-52.5t-75.5-42.5q-20-8-45-8-34 0-98 18-57 17-96.5 40.5t-71 66-46 70-45.5 94.5q-6 12-9 19-49 107-68 216t-19 244 19 244 68 216q56 122 83 161 63 91 179 127l6 2q64 18 98 18 25 0 45-8 32-12 75.5-42.5t43.5-52.5zM776 776q-26 0-45-19t-19-45.5 19-45.5q37-37 37-90 0-52-37-91-19-19-19-45t19-45 45-19 45 19q75 75 75 181t-75 181q-21 19-45 19zM957 957q-27 0-45-19-19-19-19-45t19-45q112-114 112-272t-112-272q-19-19-19-45t19-45 45-19 45 19q150 150 150 362t-150 362q-18 19-45 19zM1138 1138q-27 0-45-19-19-19-19-45t19-45q90-91 138.5-208t48.5-245-48.5-245-138.5-208q-19-19-19-45t19-45 45-19 45 19q109 109 167 249t58 294-58 294-167 249q-18 19-45 19z"}]}})


/***/ }),
/* 1988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"volume-down":{"width":1152,"height":1792,"paths":[{"d":"M768 352v1088q0 26-19 45t-45 19-45-19l-333-333h-262q-26 0-45-19t-19-45v-384q0-26 19-45t45-19h262l333-333q19-19 45-19t45 19 19 45zM1152 896q0 76-42.5 141.5t-112.5 93.5q-10 5-25 5-26 0-45-18.5t-19-45.5q0-21 12-35.5t29-25 34-23 29-36 12-56.5-12-56.5-29-36-34-23-29-25-12-35.5q0-27 19-45.5t45-18.5q15 0 25 5 70 27 112.5 93t42.5 142z"}]}})


/***/ }),
/* 1989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"volume-off":{"width":768,"height":1792,"paths":[{"d":"M768 352v1088q0 26-19 45t-45 19-45-19l-333-333h-262q-26 0-45-19t-19-45v-384q0-26 19-45t45-19h262l333-333q19-19 45-19t45 19 19 45z"}]}})


/***/ }),
/* 1990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"volume-up":{"width":1664,"height":1792,"paths":[{"d":"M768 352v1088q0 26-19 45t-45 19-45-19l-333-333h-262q-26 0-45-19t-19-45v-384q0-26 19-45t45-19h262l333-333q19-19 45-19t45 19 19 45zM1152 896q0 76-42.5 141.5t-112.5 93.5q-10 5-25 5-26 0-45-18.5t-19-45.5q0-21 12-35.5t29-25 34-23 29-36 12-56.5-12-56.5-29-36-34-23-29-25-12-35.5q0-27 19-45.5t45-18.5q15 0 25 5 70 27 112.5 93t42.5 142zM1408 896q0 153-85 282.5t-225 188.5q-13 5-25 5-27 0-46-19t-19-45q0-39 39-59 56-29 76-44 74-54 115.5-135.5t41.5-173.5-41.5-173.5-115.5-135.5q-20-15-76-44-39-20-39-59 0-26 19-45t45-19q13 0 26 5 140 59 225 188.5t85 282.5zM1664 896q0 230-127 422.5t-338 283.5q-13 5-26 5-26 0-45-19t-19-45q0-36 39-59 7-4 22.5-10.5t22.5-10.5q46-25 82-51 123-91 192-227t69-289-69-289-192-227q-36-26-82-51-7-4-22.5-10.5t-22.5-10.5q-39-23-39-59 0-26 19-45t45-19q13 0 26 5 211 91 338 283.5t127 422.5z"}]}})


/***/ }),
/* 1991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"warning":{"width":1792,"height":1792,"paths":[{"d":"M1024 1375v-190q0-14-9.5-23.5t-22.5-9.5h-192q-13 0-22.5 9.5t-9.5 23.5v190q0 14 9.5 23.5t22.5 9.5h192q13 0 22.5-9.5t9.5-23.5zM1022 1001l18-459q0-12-10-19-13-11-24-11h-220q-11 0-24 11-10 7-10 21l17 457q0 10 10 16.5t24 6.5h185q14 0 23.5-6.5t10.5-16.5zM1008 67l768 1408q35 63-2 126-17 29-46.5 46t-63.5 17h-1536q-34 0-63.5-17t-46.5-46q-37-63-2-126l768-1408q17-31 47-49t65-18 65 18 47 49z"}]}})


/***/ }),
/* 1992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"wechat":{"width":2048,"height":1792,"paths":[{"d":"M580 461q0-41-25-66t-66-25q-43 0-76 25.5t-33 65.5q0 39 33 64.5t76 25.5q41 0 66-24.5t25-65.5zM1323 968q0-28-25.5-50t-65.5-22q-27 0-49.5 22.5t-22.5 49.5q0 28 22.5 50.5t49.5 22.5q40 0 65.5-22t25.5-51zM1087 461q0-41-24.5-66t-65.5-25q-43 0-76 25.5t-33 65.5q0 39 33 64.5t76 25.5q41 0 65.5-24.5t24.5-65.5zM1722 968q0-28-26-50t-65-22q-27 0-49.5 22.5t-22.5 49.5q0 28 22.5 50.5t49.5 22.5q39 0 65-22t26-51zM1456 571q-31-4-70-4-169 0-311 77t-223.5 208.5-81.5 287.5q0 78 23 152-35 3-68 3-26 0-50-1.5t-55-6.5-44.5-7-54.5-10.5-50-10.5l-253 127 72-218q-290-203-290-490 0-169 97.5-311t264-223.5 363.5-81.5q176 0 332.5 66t262 182.5 136.5 260.5zM2048 1132q0 117-68.5 223.5t-185.5 193.5l55 181-199-109q-150 37-218 37-169 0-311-70.5t-223.5-191.5-81.5-264 81.5-264 223.5-191.5 311-70.5q161 0 303 70.5t227.5 192 85.5 263.5z"}]}})


/***/ }),
/* 1993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"weibo":{"width":1792,"height":1792,"paths":[{"d":"M675 1284q21-34 11-69t-45-50q-34-14-73-1t-60 46q-22 34-13 68.5t43 50.5 74.5 2.5 62.5-47.5zM769 1163q8-13 3.5-26.5t-17.5-18.5q-14-5-28.5 0.5t-21.5 18.5q-17 31 13 45 14 5 29-0.5t22-18.5zM943 1270q-45 102-158 150t-224 12q-107-34-147.5-126.5t6.5-187.5q47-93 151.5-139t210.5-19q111 29 158.5 119.5t2.5 190.5zM1255 1110q-9-96-89-170t-208.5-109-274.5-21q-223 23-369.5 141.5t-132.5 264.5q9 96 89 170t208.5 109 274.5 21q223-23 369.5-141.5t132.5-264.5zM1563 1114q0 68-37 139.5t-109 137-168.5 117.5-226 83-270.5 31-275-33.5-240.5-93-171.5-151-65-199.5q0-115 69.5-245t197.5-258q169-169 341.5-236t246.5 7q65 64 20 209-4 14-1 20t10 7 14.5-0.5 13.5-3.5l6-2q139-59 246-59t153 61q45 63 0 178-2 13-4.5 20t4.5 12.5 12 7.5 17 6q57 18 103 47t80 81.5 34 116.5zM1489 490q42 47 54.5 108.5t-6.5 117.5q-8 23-29.5 34t-44.5 4q-23-8-34-29.5t-4-44.5q20-63-24-111t-107-35q-24 5-45-8t-25-37q-5-24 8-44.5t37-25.5q60-13 119 5.5t101 65.5zM1670 327q87 96 112.5 222.5t-13.5 241.5q-9 27-34 40t-52 4-40-34-5-52q28-82 10-172t-80-158q-62-69-148-95.5t-173-8.5q-28 6-52-9.5t-30-43.5 9.5-51.5 43.5-29.5q123-26 244 11.5t208 134.5z"}]}})


/***/ }),
/* 1994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"weixin":{"width":2048,"height":1792,"paths":[{"d":"M580 461q0-41-25-66t-66-25q-43 0-76 25.5t-33 65.5q0 39 33 64.5t76 25.5q41 0 66-24.5t25-65.5zM1323 968q0-28-25.5-50t-65.5-22q-27 0-49.5 22.5t-22.5 49.5q0 28 22.5 50.5t49.5 22.5q40 0 65.5-22t25.5-51zM1087 461q0-41-24.5-66t-65.5-25q-43 0-76 25.5t-33 65.5q0 39 33 64.5t76 25.5q41 0 65.5-24.5t24.5-65.5zM1722 968q0-28-26-50t-65-22q-27 0-49.5 22.5t-22.5 49.5q0 28 22.5 50.5t49.5 22.5q39 0 65-22t26-51zM1456 571q-31-4-70-4-169 0-311 77t-223.5 208.5-81.5 287.5q0 78 23 152-35 3-68 3-26 0-50-1.5t-55-6.5-44.5-7-54.5-10.5-50-10.5l-253 127 72-218q-290-203-290-490 0-169 97.5-311t264-223.5 363.5-81.5q176 0 332.5 66t262 182.5 136.5 260.5zM2048 1132q0 117-68.5 223.5t-185.5 193.5l55 181-199-109q-150 37-218 37-169 0-311-70.5t-223.5-191.5-81.5-264 81.5-264 223.5-191.5 311-70.5q161 0 303 70.5t227.5 192 85.5 263.5z"}]}})


/***/ }),
/* 1995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"whatsapp":{"width":1536,"height":1792,"paths":[{"d":"M985 974q13 0 97.5 44t89.5 53q2 5 2 15 0 33-17 76-16 39-71 65.5t-102 26.5q-57 0-190-62-98-45-170-118t-148-185q-72-107-71-194v-8q3-91 74-158 24-22 52-22 6 0 18 1.5t19 1.5q19 0 26.5 6.5t15.5 27.5q8 20 33 88t25 75q0 21-34.5 57.5t-34.5 46.5q0 7 5 15 34 73 102 137 56 53 151 101 12 7 22 7 15 0 54-48.5t52-48.5zM782 1504q127 0 243.5-50t200.5-134 134-200.5 50-243.5-50-243.5-134-200.5-200.5-134-243.5-50-243.5 50-200.5 134-134 200.5-50 243.5q0 203 120 368l-79 233 242-77q158 104 345 104zM782 122q153 0 292.5 60t240.5 161 161 240.5 60 292.5-60 292.5-161 240.5-240.5 161-292.5 60q-195 0-365-94l-417 134 136-405q-108-178-108-389 0-153 60-292.5t161-240.5 240.5-161 292.5-60z"}]}})


/***/ }),
/* 1996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"wheelchair-alt":{"width":1536,"height":1792,"paths":[{"d":"M1438 813q34 35 29 82l-44 551q-4 42-34.5 70t-71.5 28q-6 0-9-1-44-3-72.5-36.5t-25.5-77.5l35-429-143 8q55 113 55 240 0 216-148 372l-137-137q91-101 91-235 0-145-102.5-248t-247.5-103q-134 0-236 92l-137-138q120-114 284-141l264-300-149-87-181 161q-33 30-77 27.5t-73-35.5-26.5-77 34.5-73l239-213q26-23 60-26.5t64 14.5l488 283q36 21 48 68 17 67-26 117l-205 232 371-20q49-3 83 32zM1240 356q-74 0-126-52t-52-126 52-126 126-52 126.5 52 52.5 126-52.5 126-126.5 52zM613 1598q106 0 196-61l139 139q-146 116-335 116-148 0-273.5-73t-198.5-198-73-273q0-188 116-336l139 139q-60 88-60 197 0 145 102.5 247.5t247.5 102.5z"}]}})


/***/ }),
/* 1997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"wheelchair":{"width":1664,"height":1792,"paths":[{"d":"M1023 1187l102 204q-58 179-210 290t-339 111q-156 0-288.5-77.5t-210-210-77.5-288.5q0-181 104.5-330t274.5-211l17 131q-122 54-195 165.5t-73 244.5q0 185 131.5 316.5t316.5 131.5q126 0 232.5-65t165-175.5 49.5-236.5zM1571 1287l58 114-256 128q-13 7-29 7-40 0-57-35l-239-477h-472q-24 0-42.5-16.5t-21.5-40.5l-96-779q-2-17 6-42 14-51 57-82.5t97-31.5q66 0 113 47t47 113q0 69-52 117.5t-120 41.5l37 289h423v128h-407l16 128h455q40 0 57 35l228 455z"}]}})


/***/ }),
/* 1998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"wifi":{"width":2048,"height":1792,"paths":[{"d":"M1024 1523q-20 0-93-73.5t-73-93.5q0-32 62.5-54t103.5-22 103.5 22 62.5 54q0 20-73 93.5t-93 73.5zM1294 1252q-2 0-40-25t-101.5-50-128.5-25-128.5 25-101 50-40.5 25q-18 0-93.5-75t-75.5-93q0-13 10-23 78-77 196-121t233-44 233 44 196 121q10 10 10 23 0 18-75.5 93t-93.5 75zM1567 980q-11 0-23-8-136-105-252-154.5t-268-49.5q-85 0-170.5 22t-149 53-113.5 62-79 53-31 22q-17 0-92-75t-75-93q0-12 10-22 132-132 320-205t380-73 380 73 320 205q10 10 10 22 0 18-75 93t-92 75zM1838 709q-11 0-22-9-179-157-371.5-236.5t-420.5-79.5-420.5 79.5-371.5 236.5q-11 9-22 9-17 0-92.5-75t-75.5-93q0-13 10-23 187-186 445-288t527-102 527 102 445 288q10 10 10 23 0 18-75.5 93t-92.5 75z"}]}})


/***/ }),
/* 1999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"wikipedia-w":{"width":2304,"height":1792,"paths":[{"d":"M1494 1639l-295-695q-25 49-158.5 305.5t-198.5 389.5q-1 1-27.5 0.5t-26.5-1.5q-82-193-255.5-587t-259.5-596q-21-50-66.5-107.5t-103.5-100.5-102-43q0-5-0.5-24t-0.5-27h583v50q-39 2-79.5 16t-66.5 43-10 64q26 59 216.5 499t235.5 540q31-61 140-266.5t131-247.5q-19-39-126-281t-136-295q-38-69-201-71v-50l513 1v47q-60 2-93.5 25t-12.5 69q33 70 87 189.5t86 187.5q110-214 173-363 24-55-10-79.5t-129-26.5q1-7 1-25v-24q64 0 170.5-0.5t180-1 92.5-0.5v49q-62 2-119 33t-90 81l-213 442q13 33 127.5 290t121.5 274l441-1017q-14-38-49.5-62.5t-65-31.5-55.5-8v-50l460 4 1 2-1 44q-139 4-201 145-526 1216-559 1291h-49z"}]}})


/***/ }),
/* 2000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"window-close-o":{"width":1792,"height":1792,"paths":[{"d":"M1257 1111l-146 146q-10 10-23 10t-23-10l-169-169-169 169q-10 10-23 10t-23-10l-146-146q-10-10-10-23t10-23l169-169-169-169q-10-10-10-23t10-23l146-146q10-10 23-10t23 10l169 169 169-169q10-10 23-10t23 10l146 146q10 10 10 23t-10 23l-169 169 169 169q10 10 10 23t-10 23zM256 1408h1280v-1024h-1280v1024zM1792 288v1216q0 66-47 113t-113 47h-1472q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1472q66 0 113 47t47 113z"}]}})


/***/ }),
/* 2001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"window-close":{"width":1792,"height":1792,"paths":[{"d":"M1175 1321l146-146q10-10 10-23t-10-23l-233-233 233-233q10-10 10-23t-10-23l-146-146q-10-10-23-10t-23 10l-233 233-233-233q-10-10-23-10t-23 10l-146 146q-10 10-10 23t10 23l233 233-233 233q-10 10-10 23t10 23l146 146q10 10 23 10t23-10l233-233 233 233q10 10 23 10t23-10zM1792 288v1216q0 66-47 113t-113 47h-1472q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1472q66 0 113 47t47 113z"}]}})


/***/ }),
/* 2002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"window-maximize":{"width":1792,"height":1792,"paths":[{"d":"M256 1408h1280v-768h-1280v768zM1792 288v1216q0 66-47 113t-113 47h-1472q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1472q66 0 113 47t47 113z"}]}})


/***/ }),
/* 2003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"window-minimize":{"width":1792,"height":1792,"paths":[{"d":"M1792 1312v192q0 66-47 113t-113 47h-1472q-66 0-113-47t-47-113v-192q0-66 47-113t113-47h1472q66 0 113 47t47 113z"}]}})


/***/ }),
/* 2004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"window-restore":{"width":2048,"height":1792,"paths":[{"d":"M256 1536h768v-512h-768v512zM1280 1024h512v-768h-768v256h96q66 0 113 47t47 113v352zM2048 160v960q0 66-47 113t-113 47h-608v352q0 66-47 113t-113 47h-960q-66 0-113-47t-47-113v-960q0-66 47-113t113-47h608v-352q0-66 47-113t113-47h960q66 0 113 47t47 113z"}]}})


/***/ }),
/* 2005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"windows":{"width":1664,"height":1792,"paths":[{"d":"M682 1006v651l-682-94v-557h682zM682 263v659h-682v-565zM1664 1006v786l-907-125v-661h907zM1664 128v794h-907v-669z"}]}})


/***/ }),
/* 2006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"won":{"width":1792,"height":1792,"paths":[{"d":"M514 1195l81-299h-159l75 300q1 1 1 3t1 3q0-1 0.5-3.5t0.5-3.5zM630 768l35-128h-292l32 128h225zM822 768h139l-35-128h-70zM1271 1196l78-300h-162l81 299q0 1 0.5 3.5t1.5 3.5q0-1 0.5-3t0.5-3zM1382 768l33-128h-297l34 128h230zM1792 800v64q0 14-9 23t-23 9h-213l-164 616q-7 24-31 24h-159q-24 0-31-24l-166-616h-209l-167 616q-7 24-31 24h-159q-11 0-19.5-7t-10.5-17l-160-616h-208q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h175l-33-128h-142q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h109l-89-344q-5-15 5-28 10-12 26-12h137q26 0 31 24l90 360h359l97-360q7-24 31-24h126q24 0 31 24l98 360h365l93-360q5-24 31-24h137q16 0 26 12 10 13 5 28l-91 344h111q14 0 23 9t9 23v64q0 14-9 23t-23 9h-145l-34 128h179q14 0 23 9t9 23z"}]}})


/***/ }),
/* 2007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"wordpress":{"width":1792,"height":1792,"paths":[{"d":"M127 896q0-163 67-313l367 1005q-196-95-315-281t-119-411zM1415 857q0 19-2.5 38.5t-10 49.5-11.5 44-17.5 59-17.5 58l-76 256-278-826q46-3 88-8 19-2 26-18.5t-2.5-31-28.5-13.5l-205 10q-75-1-202-10-12-1-20.5 5t-11.5 15-1.5 18.5 9 16.5 19.5 8l80 8 120 328-168 504-280-832q46-3 88-8 19-2 26-18.5t-2.5-31-28.5-13.5l-205 10q-7 0-23-0.5t-26-0.5q105-160 274.5-253.5t367.5-93.5q147 0 280.5 53t238.5 149h-10q-55 0-92 40.5t-37 95.5q0 12 2 24t4 21.5 8 23 9 21 12 22.5 12.5 21 14.5 24 14 23q63 107 63 212zM909 963l237 647q1 6 5 11-126 44-255 44-112 0-217-32zM1570 527q95 174 95 369 0 209-104 385.5t-279 278.5l235-678q59-169 59-276 0-42-6-79zM896 0q182 0 348 71t286 191 191 286 71 348-71 348-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71zM896 1751q173 0 331.5-68t273-182.5 182.5-273 68-331.5-68-331.5-182.5-273-273-182.5-331.5-68-331.5 68-273 182.5-182.5 273-68 331.5 68 331.5 182.5 273 273 182.5 331.5 68z"}]}})


/***/ }),
/* 2008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"wpbeginner":{"width":1792,"height":1792,"paths":[{"d":"M384 832h160v-224h-160v224zM1221 1164v-92q-104 36-243 38-135 1-259.5-46.5t-220.5-122.5l1 96q88 80 212 128.5t272 47.5q129 0 238-49zM640 832h640v-224h-640v224zM1792 800q0 187-99 352 89 102 89 229 0 157-129.5 268t-313.5 111q-122 0-225-52.5t-161-140.5q-19 1-57 1t-57-1q-58 88-161 140.5t-225 52.5q-184 0-313.5-111t-129.5-268q0-127 89-229-99-165-99-352 0-209 120-385.5t326.5-279.5 449.5-103 449.5 103 326.5 279.5 120 385.5z"}]}})


/***/ }),
/* 2009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"wpexplorer":{"width":1792,"height":1792,"paths":[{"d":"M948 1028l163 329h-51l-175-350-171 350h-49l179-374-78-33 21-49 240 102-21 50zM563 436l304 130-130 304-304-130zM907 621l240 103-103 239-239-102zM1188 771l191 81-82 190-190-81zM1680 896q0-159-62-304t-167.5-250.5-250.5-167.5-304-62-304 62-250.5 167.5-167.5 250.5-62 304 62 304 167.5 250.5 250.5 167.5 304 62 304-62 250.5-167.5 167.5-250.5 62-304zM1792 896q0 182-71 348t-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71 348 71 286 191 191 286 71 348z"}]}})


/***/ }),
/* 2010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"wpforms":{"width":1536,"height":1792,"paths":[{"d":"M515 911v128h-252v-128h252zM515 656v127h-252v-127h252zM1273 1167v128h-341v-128h341zM1273 911v128h-672v-128h672zM1273 656v127h-672v-127h672zM1408 1516v-1240q0-8-6-14t-14-6h-32l-378 256-210-171-210 171-378-256h-32q-8 0-14 6t-6 14v1240q0 8 6 14t14 6h1240q8 0 14-6t6-14zM553 406l185-150h-406zM983 406l221-150h-406zM1536 276v1240q0 62-43 105t-105 43h-1240q-62 0-105-43t-43-105v-1240q0-62 43-105t105-43h1240q62 0 105 43t43 105z"}]}})


/***/ }),
/* 2011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"wrench":{"width":1664,"height":1792,"paths":[{"d":"M384 1472q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zM1028 1052l-682 682q-37 37-90 37-52 0-91-37l-106-108q-38-36-38-90 0-53 38-91l681-681q39 98 114.5 173.5t173.5 114.5zM1662 617q0 39-23 106-47 134-164.5 217.5t-258.5 83.5q-185 0-316.5-131.5t-131.5-316.5 131.5-316.5 316.5-131.5q58 0 121.5 16.5t107.5 46.5q16 11 16 28t-16 28l-293 169v224l193 107q5-3 79-48.5t135.5-81 70.5-35.5q15 0 23.5 10t8.5 25z"}]}})


/***/ }),
/* 2012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"xing-square":{"width":1536,"height":1792,"paths":[{"d":"M685 765q0-1-126-222-21-34-52-34h-184q-18 0-26 11-7 12 1 29l125 216v1l-196 346q-9 14 0 28 8 13 24 13h185q31 0 50-36zM1309 268q-7-12-24-12h-187q-30 0-49 35l-411 729q1 2 262 481 20 35 52 35h184q18 0 25-12 8-13-1-28l-260-476v-1l409-723q8-16 0-28zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 2013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"xing":{"width":1408,"height":1792,"paths":[{"d":"M597 667q-10 18-257 456-27 46-65 46h-239q-21 0-31-17t0-36l253-448q1 0 0-1l-161-279q-12-22-1-37 9-15 32-15h239q40 0 66 45zM1403 25q11 16 0 37l-528 934v1l336 615q11 20 1 37-10 15-32 15h-239q-42 0-66-45l-339-622q18-32 531-942 25-45 64-45h241q22 0 31 15z"}]}})


/***/ }),
/* 2014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"y-combinator-square":{"width":1536,"height":1792,"paths":[{"d":"M809 1004l266-499h-112l-157 312q-24 48-44 92l-42-92-155-312h-120l263 493v324h101v-318zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 2015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"y-combinator":{"width":1536,"height":1792,"paths":[{"d":"M809 1004l266-499h-112l-157 312q-24 48-44 92l-42-92-155-312h-120l263 493v324h101v-318zM1536 128v1536h-1536v-1536h1536z"}]}})


/***/ }),
/* 2016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"yahoo":{"width":1536,"height":1792,"paths":[{"d":"M859 957l13 707q-62-11-105-11-41 0-105 11l13-707q-40-69-168.5-295.5t-216.5-374.5-181-287q58 15 108 15 44 0 111-15 63 111 133.5 229.5t167 276.5 138.5 227q37-61 109.5-177.5t117.5-190 105-176 107-189.5q54 14 107 14 56 0 114-14v0q-28 39-60 88.5t-49.5 78.5-56.5 96-49 84q-146 248-353 610z"}]}})


/***/ }),
/* 2017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"yc-square":{"width":1536,"height":1792,"paths":[{"d":"M809 1004l266-499h-112l-157 312q-24 48-44 92l-42-92-155-312h-120l263 493v324h101v-318zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 2018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"yc":{"width":1536,"height":1792,"paths":[{"d":"M809 1004l266-499h-112l-157 312q-24 48-44 92l-42-92-155-312h-120l263 493v324h101v-318zM1536 128v1536h-1536v-1536h1536z"}]}})


/***/ }),
/* 2019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"yelp":{"width":1536,"height":1792,"paths":[{"d":"M773 1319v127q-1 292-6 305-12 32-51 40-54 9-181.5-38t-162.5-89q-13-15-17-36-1-12 4-26 4-10 34-47t181-216q1 0 60-70 15-19 39.5-24.5t49.5 3.5q24 10 37.5 29t12.5 42zM624 1068q-3 55-52 70l-120 39q-275 88-292 88-35-2-54-36-12-25-17-75-8-76 1-166.5t30-124.5 56-32q13 0 202 77 71 29 115 47l84 34q23 9 35.5 30.5t11.5 48.5zM1450 1365q-7 54-91.5 161t-135.5 127q-37 14-63-7-14-10-184-287l-47-77q-14-21-11.5-46t19.5-46q35-43 83-26 1 1 119 40 203 66 242 79.5t47 20.5q28 22 22 61zM778 733q5 102-54 122-58 17-114-71l-378-598q-8-35 19-62 41-43 207.5-89.5t224.5-31.5q40 10 49 45 3 18 22 305.5t24 379.5zM1440 841q3 39-26 59-15 10-329 86-67 15-91 23l1-2q-23 6-46-4t-37-32q-30-47 0-87 1-1 75-102 125-171 150-204t34-39q28-19 65-2 48 23 123 133.5t81 167.5v3z"}]}})


/***/ }),
/* 2020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"yen":{"width":1027,"height":1792,"paths":[{"d":"M603 1536h-172q-13 0-22.5-9t-9.5-23v-330h-288q-13 0-22.5-9t-9.5-23v-103q0-13 9.5-22.5t22.5-9.5h288v-85h-288q-13 0-22.5-9t-9.5-23v-104q0-13 9.5-22.5t22.5-9.5h214l-321-578q-8-16 0-32 10-16 28-16h194q19 0 29 18l215 425q19 38 56 125 10-24 30.5-68t27.5-61l191-420q8-19 29-19h191q17 0 27 16 9 14 1 31l-313 579h215q13 0 22.5 9.5t9.5 22.5v104q0 14-9.5 23t-22.5 9h-290v85h290q13 0 22.5 9.5t9.5 22.5v103q0 14-9.5 23t-22.5 9h-290v330q0 13-9.5 22.5t-22.5 9.5z"}]}})


/***/ }),
/* 2021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"yoast":{"width":1664,"height":1792,"paths":[{"d":"M339 218h691l-26 72h-665q-110 0-188.5 79t-78.5 189v771q0 95 60.5 169.5t153.5 93.5q23 5 98 5v72h-45q-140 0-239.5-100t-99.5-240v-771q0-140 99.5-240t239.5-100zM1190 0h247l-482 1294q-23 61-40.5 103.5t-45 98-54 93.5-64.5 78.5-79.5 65-95.5 41-116 18.5v-195q163-26 220-182 20-52 20-105 0-54-20-106l-285-733h228l187 585zM1664 558v1111h-795q37-55 45-73h678v-1038q0-85-49.5-155t-129.5-99l25-67q101 34 163.5 123.5t62.5 197.5z"}]}})


/***/ }),
/* 2022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"youtube-play":{"width":1792,"height":1792,"paths":[{"d":"M711 1128l484-250-484-253v503zM896 266q168 0 324.5 4.5t229.5 9.5l73 4q1 0 17 1.5t23 3 23.5 4.5 28.5 8 28 13 31 19.5 29 26.5q6 6 15.5 18.5t29 58.5 26.5 101q8 64 12.5 136.5t5.5 113.5v40 136q1 145-18 290-7 55-25 99.5t-32 61.5l-14 17q-14 15-29 26.5t-31 19-28 12.5-28.5 8-24 4.5-23 3-16.5 1.5q-251 19-627 19-207-2-359.5-6.5t-200.5-7.5l-49-4-36-4q-36-5-54.5-10t-51-21-56.5-41q-6-6-15.5-18.5t-29-58.5-26.5-101q-8-64-12.5-136.5t-5.5-113.5v-40-136q-1-145 18-290 7-55 25-99.5t32-61.5l14-17q14-15 29-26.5t31-19.5 28-13 28.5-8 23.5-4.5 23-3 17-1.5q251-18 627-18z"}]}})


/***/ }),
/* 2023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"youtube-square":{"width":1536,"height":1792,"paths":[{"d":"M919 1303v-157q0-50-29-50-17 0-33 16v224q16 16 33 16 29 0 29-49zM1103 1181h66v-34q0-51-33-51t-33 51v34zM532 915v70h-80v423h-74v-423h-78v-70h232zM733 1041v367h-67v-40q-39 45-76 45-33 0-42-28-6-17-6-54v-290h66v270q0 24 1 26 1 15 15 15 20 0 42-31v-280h67zM985 1152v146q0 52-7 73-12 42-53 42-35 0-68-41v36h-67v-493h67v161q32-40 68-40 41 0 53 42 7 21 7 74zM1236 1281v9q0 29-2 43-3 22-15 40-27 40-80 40-52 0-81-38-21-27-21-86v-129q0-59 20-86 29-38 80-38t78 38q21 29 21 86v76h-133v65q0 51 34 51 24 0 30-26 0-1 0.5-7t0.5-16.5v-21.5h68zM785 457v156q0 51-32 51t-32-51v-156q0-52 32-52t32 52zM1318 1170q0-177-19-260-10-44-43-73.5t-76-34.5q-136-15-412-15-275 0-411 15-44 5-76.5 34.5t-42.5 73.5q-20 87-20 260 0 176 20 260 10 43 42.5 73t75.5 35q137 15 412 15t412-15q43-5 75.5-35t42.5-73q20-84 20-260zM563 519l90-296h-75l-51 195-53-195h-78q7 23 23 69l24 69q35 103 46 158v201h74v-201zM852 600v-130q0-58-21-87-29-38-78-38-51 0-78 38-21 29-21 87v130q0 58 21 87 27 38 78 38 49 0 78-38 21-27 21-87zM1033 720h67v-370h-67v283q-22 31-42 31-15 0-16-16-1-2-1-26v-272h-67v293q0 37 6 55 11 27 43 27 36 0 77-45v40zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})


/***/ }),
/* 2024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue__);


__WEBPACK_IMPORTED_MODULE_0__components_Icon_vue___default.a.register({"youtube":{"width":1536,"height":1792,"paths":[{"d":"M971 1244v211q0 67-39 67-23 0-45-22v-301q22-22 45-22 39 0 39 67zM1309 1245v46h-90v-46q0-68 45-68t45 68zM343 1027h107v-94h-312v94h105v569h100v-569zM631 1596h89v-494h-89v378q-30 42-57 42-18 0-21-21-1-3-1-35v-364h-89v391q0 49 8 73 12 37 58 37 48 0 102-61v54zM1060 1448v-197q0-73-9-99-17-56-71-56-50 0-93 54v-217h-89v663h89v-48q45 55 93 55 54 0 71-55 9-27 9-100zM1398 1438v-13h-91q0 51-2 61-7 36-40 36-46 0-46-69v-87h179v-103q0-79-27-116-39-51-106-51-68 0-107 51-28 37-28 116v173q0 79 29 116 39 51 108 51 72 0 108-53 18-27 21-54 2-9 2-58zM790 525v-210q0-69-43-69t-43 69v210q0 70 43 70t43-70zM1509 1276q0 234-26 350-14 59-58 99t-102 46q-184 21-555 21t-555-21q-58-6-102.5-46t-57.5-99q-26-112-26-350 0-234 26-350 14-59 58-99t103-47q183-20 554-20t555 20q58 7 102.5 47t57.5 99q26 112 26 350zM511 0h102l-121 399v271h-100v-271q-14-74-61-212-37-103-65-187h106l71 263zM881 333v175q0 81-28 118-38 51-106 51-67 0-105-51-28-38-28-118v-175q0-80 28-117 38-51 105-51 68 0 106 51 28 37 28 117zM1216 171v499h-91v-55q-53 62-103 62-46 0-59-37-8-24-8-75v-394h91v367q0 33 1 35 3 22 21 22 27 0 57-43v-381h91z"}]}})


/***/ }),
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable */
;(function() {

  'use strict'

  var opt = {
    complement: window.document.title,
    separator: '|'
  }

  var diffTitle = {}
  var els = []
  var diffEls = []
  var installed = false

  var util = {
    /**
     * Shorthand
     * @type {Object}
     */
    shorthand: {
      ch: 'charset',
      tg: 'target',
      n: 'name',
      he: 'http-equiv',
      ip: 'itemprop',
      c: 'content',
      p: 'property',
      sc: 'scheme',
      r: 'rel',
      h: 'href',
      sz: 'sizes',
      t: 'type',
      s: 'src',
      a: 'async',
      d: 'defer',
      i: 'inner'
    },

    /**
     * This function return the element <head>
     * @type {Function}
     * @return {Object}
     */
    getPlace: function (place) {
      return window.document.getElementsByTagName(place)[0]
    },

    /**
     * Undo the window.document title for previous state
     * @type {Function}
     * @param  {Object} state 
     */
    undoTitle: function (state) {
      if (!state.before) return
      window.document.title = state.before
    },

    /**
     * Undo elements to its previous state
     * @type {Function}
     */
    undo: function () {
      if (!els.length) return
      els.map(function (el) {
        el.parentElement.removeChild(el)
      })
      els = []
    },

    /**
     * Set attributes in element
     * @type {Function}
     * @param  {Object} obj
     * @param  {HTMLElement} el
     * @return {HTMLElement} with defined attributes
     */
    prepareElement: function (obj, el) {
      var self = this
      Object.keys(obj).map(function (prop) {
        var sh = self.shorthand[prop] || prop
        if (sh.match(/(body|undo|replace)/g)) return
        if (sh === 'inner') {
          el.textContent = obj[prop]
          return
        }
        el.setAttribute(sh, obj[prop])
      })
      return el
    },

    /**
     * Change window.document title
     * @type {Function}
     * @param  {Object} obj
     */
    title: function (obj) {
      if (!obj) return
      diffTitle.before = opt.complement
      var title = obj.inner + ' ' + (obj.separator || opt.separator) +
        ' ' +  (obj.complement || opt.complement)
      window.document.title = title.trim()
    },

    /**
     * Update Element
     */
    update: function () {
      if (!els.length) return
      els.forEach(function(el, key) {
        if (diffEls[key] && !diffEls[key].isEqualNode(el)) {
          el.parentElement.replaceChild(diffEls[key], els[key])
          els.splice(key, 1, diffEls[key])
          return
        }
      })
      diffEls = []
    },

    /**
     * Add Elements
     * @param {Object} obj
     * @param {HTMLElement} el
     * @param {HTMLElement} parent
     */
    add: function (obj, el, parent) {
      parent.appendChild(el)
      // Fixed elements that do not suffer removal
      if (obj.undo !== undefined && !obj.undo) return
      // Elements which are removed
      els.push(el)
    },

    /**
     * Handle of create elements
     * @type {Function}
     * @param  {Array} arr
     * @param  {String} tag   - style, link, meta, script, base
     * @param  {String} place - Default 'head'
     * @param  {Boolean} update
     */
    handle: function (arr, tag, place, update) {
      var self = this
      if (!arr) return
      arr.map(function (obj) {
        var parent = (obj.body) ? self.getPlace('body') : self.getPlace(place)
        var el = window.document.getElementById(obj.id) || window.document.createElement(tag)
        // Elements that will substitute data
        if (el.hasAttribute('id') || obj.id) {
          self.prepareElement(obj, el)
          return
        }
        // Other elements
        el = self.prepareElement(obj, el)
        // Updated elements
        if (update) {
          diffEls.push(el)
          return
        }
        // Append Elements
        self.add(obj, el, parent)
      })
    }
  }

  /**
   * Plugin | vue-head
   * @param  {Function} Vue
   * @param  {Object} options
   */
  function VueHead (Vue, options) {
    if (installed) return

    installed = true

    if (options) {
      Vue.util.extend(opt, options)
    }

    /**
     * Initializes and updates the elements in the head
     * @param  {Boolean} update
     */
    function init (update) {
      var self = this
      var head = self.$options.head
      if (!head) return
      Object.keys(head).map(function (key) {
        var prop = head[key]
        if (!prop) return
        var obj = (typeof prop === 'function') ? head[key].bind(self)() : head[key]
        if (key === 'title') {
          util[key](obj)
          return
        }
        util.handle(obj, key, 'head', update)
      })
      self.$emit('okHead')
    }

    /**
     * Remove the meta tags elements in the head
     */
    function destroy () {
      if (!this.$options.head) return
      util.undoTitle(diffTitle)
      util.undo()
    }

    // v1
    if (Vue.version.match(/[1].(.)+/g)) {
      Vue.mixin({
        ready: function () {
          init.bind(this)()
        },
        destroyed: function () {
          destroy.bind(this)()
        },
        events: {
          updateHead: function () {
            init.bind(this)(true)
            util.update()
          }
        }   
      })
    }
    // v2
    if (Vue.version.match(/[2].(.)+/g)) {
      Vue.mixin({
        created: function () {
          var self = this
          self.$on('updateHead', function () {
            init.bind(self)(true)
            util.update()
          })
        },
        mounted: function () {
          init.bind(this)()
        },
        beforeDestroy: function () {
          destroy.bind(this)()
        }
      })
    }
  }

  VueHead.version = '2.0.11'

  // auto install
  if (typeof Vue !== 'undefined') {
    Vue.use(VueHead)
  }

  if(true) {
    module.exports = VueHead
  } else if(typeof define === 'function' && define.amd) {
    define(function () { return VueHead })
  } else if (typeof window !== 'undefined') {
    window.VueHead = VueHead
  }

})()

/***/ }),
/* 2026 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(492),
  /* template */
  __webpack_require__(2144),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(493),
  /* template */
  __webpack_require__(2109),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(583),
  /* template */
  __webpack_require__(2174),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(584),
  /* template */
  __webpack_require__(2136),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2030 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(2222)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(585),
  /* template */
  __webpack_require__(2154),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(586),
  /* template */
  __webpack_require__(2159),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(2225)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(587),
  /* template */
  __webpack_require__(2183),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2033 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(496),
  /* template */
  __webpack_require__(2106),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2034 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(497),
  /* template */
  __webpack_require__(2153),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2035 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(500),
  /* template */
  __webpack_require__(2184),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(501),
  /* template */
  __webpack_require__(2108),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(502),
  /* template */
  __webpack_require__(2191),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2038 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(506),
  /* template */
  __webpack_require__(2151),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2039 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(509),
  /* template */
  __webpack_require__(2118),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2040 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(510),
  /* template */
  __webpack_require__(2152),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2041 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(520),
  /* template */
  __webpack_require__(2195),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2042 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(521),
  /* template */
  __webpack_require__(2120),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2043 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(2215)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(526),
  /* template */
  __webpack_require__(2121),
  /* scopeId */
  "data-v-230e8aa2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2044 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(2226)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(527),
  /* template */
  __webpack_require__(2185),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(2221)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(528),
  /* template */
  __webpack_require__(2149),
  /* scopeId */
  "data-v-5691b2cc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2046 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(2214)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(529),
  /* template */
  __webpack_require__(2119),
  /* scopeId */
  "data-v-2078095a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2047 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(2218)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(530),
  /* template */
  __webpack_require__(2133),
  /* scopeId */
  "data-v-3cf21d34",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2048 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(2209)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(531),
  /* template */
  __webpack_require__(2179),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2049 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(2227)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(532),
  /* template */
  __webpack_require__(2194),
  /* scopeId */
  "data-v-ef288e52",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2050 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(2216)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(533),
  /* template */
  __webpack_require__(2123),
  /* scopeId */
  "data-v-260176a8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2051 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(2212)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(534),
  /* template */
  __webpack_require__(2105),
  /* scopeId */
  "data-v-12fb11ca",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(2211)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(535),
  /* template */
  __webpack_require__(2100),
  /* scopeId */
  "data-v-00315fee",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2053 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(2202)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(536),
  /* template */
  __webpack_require__(2141),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(2224)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(537),
  /* template */
  __webpack_require__(2176),
  /* scopeId */
  "data-v-996a384e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(2223)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(538),
  /* template */
  __webpack_require__(2171),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2056 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(539),
  /* template */
  __webpack_require__(2189),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(2210)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(540),
  /* template */
  __webpack_require__(2188),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2058 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(541),
  /* template */
  __webpack_require__(2115),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(542),
  /* template */
  __webpack_require__(2101),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(543),
  /* template */
  __webpack_require__(2102),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(544),
  /* template */
  __webpack_require__(2113),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2062 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(545),
  /* template */
  __webpack_require__(2170),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(546),
  /* template */
  __webpack_require__(2193),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(547),
  /* template */
  __webpack_require__(2169),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(548),
  /* template */
  __webpack_require__(2160),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(549),
  /* template */
  __webpack_require__(2175),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(550),
  /* template */
  __webpack_require__(2173),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2068 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(551),
  /* template */
  __webpack_require__(2181),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2069 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(552),
  /* template */
  __webpack_require__(2177),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(2217)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(553),
  /* template */
  __webpack_require__(2125),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(554),
  /* template */
  __webpack_require__(2131),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2072 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(555),
  /* template */
  __webpack_require__(2132),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2073 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(556),
  /* template */
  __webpack_require__(2190),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(557),
  /* template */
  __webpack_require__(2111),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2075 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(558),
  /* template */
  __webpack_require__(2129),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2076 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(559),
  /* template */
  __webpack_require__(2192),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2077 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(560),
  /* template */
  __webpack_require__(2104),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2078 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(561),
  /* template */
  __webpack_require__(2107),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(562),
  /* template */
  __webpack_require__(2114),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(563),
  /* template */
  __webpack_require__(2127),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(564),
  /* template */
  __webpack_require__(2163),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(565),
  /* template */
  __webpack_require__(2178),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2083 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(566),
  /* template */
  __webpack_require__(2186),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2084 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(567),
  /* template */
  __webpack_require__(2134),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(568),
  /* template */
  __webpack_require__(2135),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(569),
  /* template */
  __webpack_require__(2187),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2087 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(570),
  /* template */
  __webpack_require__(2103),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2088 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(571),
  /* template */
  __webpack_require__(2172),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(572),
  /* template */
  __webpack_require__(2137),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(573),
  /* template */
  __webpack_require__(2145),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(574),
  /* template */
  __webpack_require__(2130),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(575),
  /* template */
  __webpack_require__(2167),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(576),
  /* template */
  __webpack_require__(2138),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(577),
  /* template */
  __webpack_require__(2126),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(578),
  /* template */
  __webpack_require__(2147),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2096 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(579),
  /* template */
  __webpack_require__(2168),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(580),
  /* template */
  __webpack_require__(2162),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2098 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(581),
  /* template */
  __webpack_require__(2146),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2099 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(582),
  /* template */
  __webpack_require__(2156),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2100 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home",
    class: _vm.theme,
    attrs: {
      "id": "quote-request-page"
    }
  }, [_c('nav-bar'), _vm._v(" "), _c('swiper', {
    ref: "mySwiper8",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticStyle: {
      "height": "100%",
      "background-image": "url('../assets/img/n1.jpg')",
      "background-size": "cover",
      "background-repeat": "no-repeat"
    }
  }, [_c('div', {
    staticClass: "slide-center"
  }, [_c('h1', {
    staticClass: "page__title-white"
  }, [_vm._v(_vm._s(_vm.$t('Budget_request')))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "quote-request",
    attrs: {
      "id": "quote-form"
    }
  }, [_c('h1', {
    staticClass: "quote-request__title text-center"
  }, [_vm._v(_vm._s(_vm.$t('Budget_request')))]), _vm._v(" "), (_vm.error) ? _c('message', {
    attrs: {
      "text": _vm.error
    },
    on: {
      "closeMessage": _vm.closeMessage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.success_message) ? _c('success-message', {
    attrs: {
      "text": _vm.success_message
    },
    on: {
      "closeMessage": _vm.closeMessage
    }
  }) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "quote-request__form"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Petitioner_data')))]), _vm._v(" "), _vm._l((_vm.petitioner_fields), function(field) {
    return _c('field', {
      attrs: {
        "name": field.name,
        "type": field.type,
        "placeholder": field.placeholder,
        "autofocus": field.autofocus
      },
      model: {
        value: (field.value),
        callback: function($$v) {
          field.value = $$v
        },
        expression: "field.value"
      }
    })
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('Data_of_property_to_be_appraised')))]), _vm._v(" "), _vm._l((_vm.property_fields), function(field) {
    return _c('field', {
      attrs: {
        "name": field.name,
        "type": field.type,
        "placeholder": field.placeholder,
        "autofocus": field.autofocus
      },
      model: {
        value: (field.value),
        callback: function($$v) {
          field.value = $$v
        },
        expression: "field.value"
      }
    })
  }), _vm._v(" "), _c('p', [_vm._v("* " + _vm._s(_vm.$t('Required_fields')))]), _vm._v(" "), (_vm.error) ? _c('message', {
    attrs: {
      "text": _vm.error
    },
    on: {
      "closeMessage": _vm.closeMessage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.success_message) ? _c('success-message', {
    attrs: {
      "text": _vm.success_message
    },
    on: {
      "closeMessage": _vm.closeMessage
    }
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "quote-request__form__button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onSend($event)
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onSend($event)
      }
    }
  }, [_vm._v("\n\t\t\t\tEnviar\n\t\t\t")])], 2)], 1), _vm._v(" "), _c('logo-bar'), _vm._v(" "), _c('footer-bar')], 1)
},staticRenderFns: []}

/***/ }),
/* 2101 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "marketstudies-index"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "adsOpen": _vm.adsOpen
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('Ads_index')))]), _vm._v(" "), _c('vue-tabs', [_c('v-tab', {
      attrs: {
        "title": _vm.ads_index_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCreateNewAd($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus-circle",
        "text": _vm.new_ad_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "section-container",
      staticStyle: {
        "background-color": "#fafafc",
        "padding": "2rem"
      }
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Address_referral')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    })])])])])])], 1), _vm._v(" "), _c('bar')], 1)], 1)]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 2102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "appraisalinvoice-editor"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), (_vm.selecting_line) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "dialog_container"
    }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('Select_Real_estate_to_be_added')) + " " + _vm._s(_vm.$t('or')) + " "), _c('span', {
      staticClass: "navspan",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCreateNewLine()
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('create_a_new_one')))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Existing_Real_estates')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.importLineValue,
        "options": _vm.object_to_array(_vm.lines),
        "track-by": "id",
        "label": 'full_address',
        "searchable": true
      },
      on: {
        "input": _vm.set_import_line
      },
      model: {
        value: (_vm.appraisalinvoice.importLine),
        callback: function($$v) {
          _vm.appraisalinvoice.importLine = $$v
        },
        expression: "appraisalinvoice.importLine"
      }
    })], 1)]), _vm._v(" "), _c('table', {
      staticClass: "dialog_buttons_table"
    }, [_c('tr', [_c('td', [_c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-right": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCancelImportNewLine($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "times",
        "text": '',
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray",
        "min_width": "80px",
        "max_width": "80px"
      }
    })], 1)])]), _vm._v(" "), _c('td', [_c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onImportNewLine({
            id: _vm.appraisalinvoice.importLine.id
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "check",
        "text": '',
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray",
        "min_width": "80px",
        "max_width": "80px"
      }
    })], 1)])])])])])]) : _vm._e(), _vm._v(" "), (_vm.creating_contact) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "dialog_container"
    }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('Create_new_contact')))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "form-section"
    }, [_c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Person_type')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.value,
        "options": _vm.personTypeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ?
          'name_ca' : (_vm.currentLocale === 'en') ?
          'name_en' : 'name_es',
        "searchable": false
      },
      on: {
        "input": _vm.set_contact_person_type
      },
      model: {
        value: (_vm.contact.person_type),
        callback: function($$v) {
          _vm.contact.person_type = $$v
        },
        expression: "contact.person_type"
      }
    })], 1)]), _vm._v(" "), (_vm.contact.person_type) ? _c('div', [_c('div', {
      staticClass: "field-container"
    }, [(_vm.contact.person_type.id === 1) ? _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Title')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.value,
        "options": _vm.honorificTitleOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ?
          'abb_ca' : (_vm.currentLocale === 'en') ?
          'abb_en' : 'abb_es',
        "searchable": false
      },
      on: {
        "input": _vm.set_contact_title
      },
      model: {
        value: (_vm.contact.title),
        callback: function($$v) {
          _vm.contact.title = $$v
        },
        expression: "contact.title"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Name')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.contact.name),
        expression: "contact.name"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.contact.name)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.contact.name = $event.target.value
        }, _vm.set_contact_name]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [(_vm.contact.person_type.id === 1) ? _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Surnames')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.contact.surnames),
        expression: "contact.surnames"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.contact.surnames)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.contact.surnames = $event.target.value
        }, _vm.set_contact_surnames]
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('TIN')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.contact.tin),
        expression: "contact.tin"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.contact.tin)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.contact.tin = $event.target.value
        }, _vm.set_contact_tin]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Complete_fiscal_address')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.contact.complete_fiscal_address),
        expression: "contact.complete_fiscal_address"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.contact.complete_fiscal_address)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.contact.complete_fiscal_address = $event.target.value
        }, _vm.set_contact_complete_fiscal_address]
      }
    })])])]) : _vm._e()]), _vm._v(" "), _c('table', {
      staticClass: "dialog_buttons_table"
    }, [_c('tr', [_c('td', [_c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-right": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCancelCreateNewContact($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "times",
        "text": '',
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray",
        "min_width": "80px",
        "max_width": "80px"
      }
    })], 1)])]), _vm._v(" "), _c('td', [_c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCreateNewContact($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "check",
        "text": '',
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray",
        "min_width": "80px",
        "max_width": "80px"
      }
    })], 1)])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "filesOpen": _vm.filesOpen,
        "fileOpen": _vm.fileOpen,
        "fileId": _vm.appraisalfile.id,
        "fileNumber": _vm.appraisalfile.number,
        "invoiceOpen": _vm.invoiceOpen,
        "invoiceNumber": _vm.appraisalinvoice.full_number,
        "realEstates": _vm.appraisalinvoice_lines,
        "invoiceId": _vm.appraisalinvoice.id
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('Appraisal_invoice')) + " "), (_vm.appraisalinvoice.full_number) ? _c('span', [_vm._v(_vm._s(_vm.appraisalinvoice.full_number))]) : _vm._e(), _vm._v(" "), (_vm.appraisalinvoice.dirty) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.appraisalinvoice.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "datedata"
    }, [_c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Created')) + ": " + _vm._s(_vm.millis_to_time(_vm.appraisalinvoice.date_created)))]), _vm._v(" "), _c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Last_modified')) + ": " + _vm._s(_vm.millis_to_time(_vm.appraisalinvoice.date_modified)))])]), _vm._v(" "), _c('vue-tabs', [_c('v-tab', {
      attrs: {
        "title": _vm.invoicecontent_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Client')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container",
      staticStyle: {
        "background-color": "#fafafc",
        "padding": "2rem"
      }
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Surnames_name_or_company'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.petitionerValue,
        "options": _vm.object_to_array(_vm.contacts),
        "track-by": "id",
        "label": 'complete_name',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisalinvoice_petitioner
      },
      model: {
        value: (_vm.appraisalinvoice.petitioner),
        callback: function($$v) {
          _vm.appraisalinvoice.petitioner = $$v
        },
        expression: "appraisalinvoice.petitioner"
      }
    }, [_c('span', {
      style: ({
        color: _vm.no_result_color
      }),
      attrs: {
        "slot-scope": "props"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onAddNewContact($event)
        },
        "mouseover": function($event) {
          _vm.no_result_color = 'rgb(0, 135, 248)'
        },
        "mouseleave": function($event) {
          _vm.no_result_color = 'black'
        }
      },
      slot: "noResult"
    }, [_vm._v("Cap resultat. Click per crear nou.")])])], 1), _vm._v(" "), (_vm.appraisalinvoice.petitioner) ? _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onAddNewPetitioner($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus-circle",
        "text": _vm.add_petitioner_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), (_vm.object_length(_vm.appraisalinvoice_petitioners) > 0) ? _c('div', [_c('div', {
      staticClass: "text_table"
    }, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "data-table-appraisalinvoice_petitioners",
        "source": _vm.object_to_array(_vm.appraisalinvoice_petitioners),
        "filterable": false,
        "striped": _vm.petitioner_table.striped,
        "editable": _vm.petitioner_table.editable,
        "line-numbers": _vm.petitioner_table.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-petitioners",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.edit_text
            },
            on: {
              "click": function($event) {
                _vm.editContact(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "pencil",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.discardPetitioner(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "times",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }])
    }, [_c('datatable-column', {
      attrs: {
        "id": "actions-petitioners",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    }), _vm._v(" "), _vm._l((_vm.petitioner_table.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    })], 2)], 1)])])]) : _c('div', [_c('br'), _vm._v(_vm._s(_vm.$t('No_petitioners_text')))])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Date')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('invoice_fiscal_number')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Date_of_invoice'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalinvoice.invoicedate),
        expression: "appraisalinvoice.invoicedate"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "date",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisalinvoice.invoicedate)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisalinvoice.invoicedate = $event.target.value
        }, _vm.set_appraisalinvoice_invoicedate]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Invoice_fiscal_number'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalinvoice.fiscal_number),
        expression: "appraisalinvoice.fiscal_number"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisalinvoice.fiscal_number)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisalinvoice.fiscal_number = $event.target.value
        }, _vm.set_appraisalinvoice_fiscal_number],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Quote_reference')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container",
      staticStyle: {
        "background-color": "#fafafc",
        "padding": "2rem"
      }
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Quote')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.quoteValue,
        "options": _vm.object_to_array(_vm.appraisalinvoice_appraisalquotes),
        "track-by": "id",
        "label": 'full_number',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisalinvoice_quote
      },
      model: {
        value: (_vm.appraisalinvoice.quote),
        callback: function($$v) {
          _vm.appraisalinvoice.quote = $$v
        },
        expression: "appraisalinvoice.quote"
      }
    })], 1), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onImportQuoteConcepts($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus-circle",
        "text": _vm.import_quote_concepts_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Invoice_lines')))]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCreateNewLine($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus-circle",
        "text": _vm.add_line_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), (_vm.object_length(_vm.appraisalinvoice_lines) > 0) ? _c('div', [_c('div', {
      staticClass: "text_table"
    }, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "data-table-main",
        "source": _vm.object_to_array(_vm.appraisalinvoice_lines),
        "filterable": false,
        "striped": _vm.line_table.striped,
        "editable": _vm.line_table.editable,
        "line-numbers": _vm.line_table.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "description",
        fn: function(cell) {
          return [_c('div', {}, [_c('textarea', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['description']),
              expression: "cell.row['description']"
            }],
            staticClass: "field__group__textarea",
            attrs: {
              "rows": "2",
              "spellcheck": "false"
            },
            domProps: {
              "value": (cell.row['description'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'description';
                if (!Array.isArray($$exp)) {
                  cell.row['description'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, function($event) {
                _vm.set_line_description($event, cell.row)
              }]
            }
          })])]
        }
      }, {
        key: "units",
        fn: function(cell) {
          return [_c('div', {}, [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['units']),
              expression: "cell.row['units']"
            }],
            attrs: {
              "type": "number",
              "min": "0",
              "step": "0.1"
            },
            domProps: {
              "value": (cell.row['units'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'units';
                if (!Array.isArray($$exp)) {
                  cell.row['units'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, function($event) {
                _vm.set_line_units($event, cell.row)
              }],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])]
        }
      }, {
        key: "unit_price",
        fn: function(cell) {
          return [_c('div', {}, [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['unit_price']),
              expression: "cell.row['unit_price']"
            }],
            attrs: {
              "type": "number",
              "min": "0"
            },
            domProps: {
              "value": (cell.row['unit_price'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'unit_price';
                if (!Array.isArray($$exp)) {
                  cell.row['unit_price'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, function($event) {
                _vm.set_line_unit_price($event, cell.row)
              }],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])]
        }
      }, {
        key: "actions-lines",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.deleteLine(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "trash-o",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }, {
        key: "property_type",
        fn: function(cell) {
          return [(cell.row['property_type']) ? _c('span', [(_vm.currentLocale === 'ca') ? _c('span', [_vm._v(_vm._s(cell.row['property_type']['name_ca']))]) : (_vm.currentLocale === 'en') ? _c('span', [_vm._v(_vm._s(cell.row['property_type']['name_en']))]) : _c('span', [_vm._v(_vm._s(cell.row['property_type']['name_es']))])]) : _vm._e()]
        }
      }, {
        key: "appraisal_id",
        fn: function(cell) {
          return [_c('div', [_c('multiselect', {
            attrs: {
              "placeholder": "",
              "value": _vm.line_appraisaldateValue,
              "options": _vm.object_to_array(_vm.appraisalinvoice_lines[cell.row['id']]['appraisals']),
              "track-by": "id",
              "label": 'id',
              "searchable": false,
              "selectedLabel": "",
              "selectLabel": "",
              "deselectLabel": ""
            },
            on: {
              "input": function($event) {
                _vm.set_appraisalinvoice_line_appraisal_id($event, cell.row['id'])
              }
            },
            model: {
              value: (cell.row['appraisal_id']),
              callback: function($$v) {
                var $$exp = cell.row,
                  $$idx = 'appraisal_id';
                if (!Array.isArray($$exp)) {
                  cell.row['appraisal_id'] = $$v
                } else {
                  $$exp.splice($$idx, 1, $$v)
                }
              },
              expression: "cell.row['appraisal_id']"
            }
          })], 1)]
        }
      }, {
        key: "appraisaldate",
        fn: function(cell) {
          return [_c('div', [(cell.row.appraisal_id) ? _c('span', [_vm._v(_vm._s(cell.row.appraisal_id.appraisaldate))]) : _vm._e()])]
        }
      }, {
        key: "line_total_adopted_value",
        fn: function(cell) {
          return [_c('div', [(cell.row.appraisal_id) ? _c('span', [_vm._v(_vm._s(_vm._f("formatNumber")(cell.row.appraisal_id.line_total_adopted_value)) + " €")]) : _vm._e()])]
        }
      }])
    }, [_vm._l((_vm.line_table.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "actions-lines",
        "label": _vm.actions_text,
        "width": "70px",
        "sortable": false,
        "groupable": false
      }
    })], 2)], 1)])])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Final_price')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Discount_pct'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalinvoice.discount_pct),
        expression: "appraisalinvoice.discount_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "max": "100",
        "min": "0",
        "step": "1",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisalinvoice.discount_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisalinvoice.discount_pct = $event.target.value
        }, _vm.set_appraisalinvoice_discount_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Final_price'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisalinvoice.final_price)) + " €")])])])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Discount_notes'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalinvoice.discount_notes),
        expression: "appraisalinvoice.discount_notes"
      }],
      staticClass: "field__group__textarea",
      attrs: {
        "rows": "3",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisalinvoice.discount_notes)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisalinvoice.discount_notes = $event.target.value
        }, _vm.set_appraisalinvoice_discount_notes]
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Fiscal_parameters')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('VAT_pct'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalinvoice.vat_pct),
        expression: "appraisalinvoice.vat_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisalinvoice.vat_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisalinvoice.vat_pct = $event.target.value
        }, _vm.set_appraisalinvoice_vat_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Payment_conditions')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Bank_name'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalinvoice.bank_name),
        expression: "appraisalinvoice.bank_name"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisalinvoice.bank_name)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisalinvoice.bank_name = $event.target.value
        }, _vm.set_appraisalinvoice_bank_name]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v("IBAN"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalinvoice.iban),
        expression: "appraisalinvoice.iban"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisalinvoice.iban)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisalinvoice.iban = $event.target.value
        }, _vm.set_appraisalinvoice_iban]
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Signature')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [(_vm.appraisalinvoice.signature_uid === _vm.user.id || !_vm.appraisalinvoice.is_signed) ? _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Sign_invoice')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalinvoice.is_signed),
        expression: "appraisalinvoice.is_signed"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisalinvoice.is_signed) ? _vm._i(_vm.appraisalinvoice.is_signed, null) > -1 : (_vm.appraisalinvoice.is_signed)
      },
      on: {
        "click": _vm.set_appraisalinvoice_is_signed,
        "__c": function($event) {
          var $$a = _vm.appraisalinvoice.is_signed,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisalinvoice.is_signed = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisalinvoice.is_signed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisalinvoice.is_signed = $$c
          }
        }
      }
    })]) : _c('div', {
      staticClass: "field__group"
    }, [_c('span')]), _vm._v(" "), _c('div', {
      staticClass: "field-group"
    }, [(_vm.appraisalinvoice.is_signed) ? _c('div', [_c('img', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "src": _vm.appraisalinvoice.signature_base64,
        "alt": "s"
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.appraisalinvoice.signature_name))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Signed')) + " " + _vm._s(_vm._f("formatDateAsLocal")(_vm.appraisalinvoice.signature_date)))])]) : _vm._e()])]), _vm._v(" "), _c('hr')])]), _vm._v(" "), (_vm.object_length(_vm.appraisalinvoice_petitioners) > 0 && _vm.object_length(_vm.appraisalinvoice_lines) > 0) ? _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCreatePdf($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "file-pdf-o",
        "text": _vm.pdf_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]) : _c('div', [(!this.appraisalinvoice_petitioners) ? _c('div', [_c('message', {
      attrs: {
        "text": _vm.petitioners_missing_error_text,
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : _vm._e(), _vm._v(" "), (!this.appraisalinvoice_lines) ? _c('div', [_c('message', {
      attrs: {
        "text": _vm.lines_missing_error_text,
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : _vm._e()])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.metadata_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Description')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Appraisal_invoice_description')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalinvoice.description),
        expression: "appraisalinvoice.description"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisalinvoice.description)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisalinvoice.description = $event.target.value
        }, _vm.set_appraisalinvoice_description]
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Invoice_number')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Invoice_number')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalinvoice.number),
        expression: "appraisalinvoice.number"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "maxlength": "2",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisalinvoice.number)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisalinvoice.number = $event.target.value
        }, _vm.set_appraisalinvoice_number],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Version')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalinvoice.version),
        expression: "appraisalinvoice.version"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "maxlength": "2",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisalinvoice.version)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisalinvoice.version = $event.target.value
        }, _vm.set_appraisalinvoice_version],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Status')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Status')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.statusValue,
        "options": _vm.status_invoicesOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisalinvoice_status
      },
      model: {
        value: (_vm.appraisalinvoice.status),
        callback: function($$v) {
          _vm.appraisalinvoice.status = $$v
        },
        expression: "appraisalinvoice.status"
      }
    })], 1)])])])])])], 1), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUp($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "chevron-left",
        "text": _vm.goup_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentAppraisalInvoice({
            go_up: false
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentAppraisalInvoice({
            go_up: true
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_and_go_up_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), (_vm.appraisalinvoice.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e()], 1)], 1)]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 2103 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "photograph-editor"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "filesOpen": _vm.filesOpen,
        "fileOpen": _vm.fileOpen,
        "reportOpen": _vm.reportOpen
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [_c('span', [_vm._v(_vm._s(_vm.$t('Photograph')) + " \"" + _vm._s(_vm.photograph.filename) + "\"")]), (_vm.photograph.dirty) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.photograph.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "datedata"
    }, [_c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Created')) + ": " + _vm._s(_vm.millis_to_time(_vm.photograph.date_created)))]), _vm._v(" "), _c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Last_modified')) + ": " + _vm._s(_vm.millis_to_time(_vm.photograph.date_modified)))])]), _vm._v(" "), _c('vue-tabs', [_c('v-tab', {
      attrs: {
        "title": _vm.data_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('div', {
      staticClass: "field-container"
    }, [(_vm.photograph.url) ? _c('div', [_c('img', {
      attrs: {
        "src": _vm.photograph.url,
        "width": "600px",
        "height": "auto"
      }
    })]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('File_name')) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('File_name')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.photograph.filename))])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Image_footer')) + " ")]), _vm._v(" "), (_vm.photograph.name_ca || _vm.currentLocale === 'ca') ? _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Image_footer')) + " " + _vm._s(_vm.$t('in')) + " " + _vm._s(_vm.$t('Catalan')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.photograph.name_ca),
        expression: "photograph.name_ca"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.photograph.name_ca)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.photograph.name_ca = $event.target.value
        }, _vm.set_photograph_name_ca]
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.photograph.name_en || _vm.currentLocale === 'en') ? _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Image_footer')) + " " + _vm._s(_vm.$t('in')) + " " + _vm._s(_vm.$t('English')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.photograph.name_en),
        expression: "photograph.name_en"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.photograph.name_en)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.photograph.name_en = $event.target.value
        }, _vm.set_photograph_name_en]
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.photograph.name_es || _vm.currentLocale === 'es') ? _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Image_footer')) + " " + _vm._s(_vm.$t('in')) + " " + _vm._s(_vm.$t('Spanish')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.photograph.name_es),
        expression: "photograph.name_es"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.photograph.name_es)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.photograph.name_es = $event.target.value
        }, _vm.set_photograph_name_es]
      }
    })])]) : _vm._e()])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.metadata_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('form', {
      staticClass: "bt-form"
    })])])], 1), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUp($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "chevron-left",
        "text": _vm.goup_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentPhotograph({
            go_up: false
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentPhotograph({
            go_up: true
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_and_go_up_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), (_vm.photograph.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e()], 1)], 1)]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 2104 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "appraisals-index"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "filesOpen": _vm.filesOpen,
        "reportOpen": _vm.reportOpen
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [(!_vm.contact.surnames) ? _c('span', [_vm._v(_vm._s(_vm.$t('New_contact')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('Contact')) + ": " + _vm._s(_vm.contact.name) + " " + _vm._s(_vm.contact.surnames))]), _vm._v(" "), (_vm.contact.dirty) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.contact.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "datedata"
    }, [_c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Created')) + ": " + _vm._s(_vm.millis_to_time(_vm.contact.date_created)))]), _vm._v(" "), _c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Last_modified')) + ": " + _vm._s(_vm.millis_to_time(_vm.contact.date_modified)))])]), _vm._v(" "), _c('div', [_c('vue-tabs', [_c('v-tab', {
      attrs: {
        "title": _vm.data_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Person_type')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Person_type')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.value,
        "options": _vm.personTypeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ?
          'name_ca' : (_vm.currentLocale === 'en') ?
          'name_en' : 'name_es',
        "searchable": false
      },
      on: {
        "input": _vm.set_contact_person_type
      },
      model: {
        value: (_vm.contact.person_type),
        callback: function($$v) {
          _vm.contact.person_type = $$v
        },
        expression: "contact.person_type"
      }
    })], 1)])]), _vm._v(" "), (_vm.contact.person_type) ? _c('div', [_c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Data')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [(_vm.contact.person_type.id === 1) ? _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Title')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.value,
        "options": _vm.honorificTitleOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ?
          'abb_ca' : (_vm.currentLocale === 'en') ?
          'abb_en' : 'abb_es',
        "searchable": false
      },
      on: {
        "input": _vm.set_contact_title
      },
      model: {
        value: (_vm.contact.title),
        callback: function($$v) {
          _vm.contact.title = $$v
        },
        expression: "contact.title"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Name')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.contact.name),
        expression: "contact.name"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.contact.name)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.contact.name = $event.target.value
        }, _vm.set_contact_name]
      }
    })]), _vm._v(" "), (_vm.contact.person_type.id === 1) ? _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Surnames')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.contact.surnames),
        expression: "contact.surnames"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.contact.surnames)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.contact.surnames = $event.target.value
        }, _vm.set_contact_surnames]
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('TIN')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.contact.tin),
        expression: "contact.tin"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.contact.tin)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.contact.tin = $event.target.value
        }, _vm.set_contact_tin]
      }
    })])])]), _vm._v(" "), (_vm.contact.person_type.id === 1) ? _c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Organization_s_Company')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Organization_s_Company')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.contact.organization),
        expression: "contact.organization"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.contact.organization)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.contact.organization = $event.target.value
        }, _vm.set_contact_organization]
      }
    })])])]) : _vm._e(), _vm._v(" "), (_vm.contact.person_type.id === 2) ? _c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Representative')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Representative')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.contact.representative),
        expression: "contact.representative"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.contact.representative)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.contact.representative = $event.target.value
        }, _vm.set_contact_representative]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Representative_TIN')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.contact.representative_tin),
        expression: "contact.representative_tin"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.contact.representative_tin)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.contact.representative_tin = $event.target.value
        }, _vm.set_contact_representative_tin]
      }
    })])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('E-mail_addresses')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Main_email')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.contact.main_email),
        expression: "contact.main_email"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.contact.main_email)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.contact.main_email = $event.target.value
        }, _vm.set_contact_main_email]
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Addresses')))]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Complete_fiscal_address')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.contact.complete_fiscal_address),
        expression: "contact.complete_fiscal_address"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.contact.complete_fiscal_address)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.contact.complete_fiscal_address = $event.target.value
        }, _vm.set_contact_complete_fiscal_address]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Telephone_numbers')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Main_telephonenumber')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.contact.main_telephonenumber),
        expression: "contact.main_telephonenumber"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.contact.main_telephonenumber)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.contact.main_telephonenumber = $event.target.value
        }, _vm.set_contact_main_telephonenumber]
      }
    })])])])]) : _vm._e(), _vm._v(" "), _c('div', [_c('hr')]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoBack($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "chevron-left",
        "text": _vm.goback_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentContact({
            goback: true
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), (_vm.contact.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e()], 1)])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.quotes_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Quotes_requested_by')) + " " + _vm._s(this.contact.complete_name))]), _vm._v(" "), (_vm.object_length(_vm.contact_appraisalquotes) > 0) ? _c('div', [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell",
      attrs: {
        "layout": "row"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalquote_table.filter),
        expression: "appraisalquote_table.filter"
      }],
      attrs: {
        "type": "text",
        "placeholder": _vm.filter_placeholder,
        "self": "size-x1",
        "data-intro": "You can filter the data in a datatable by typing in any of the filter fields",
        "data-step": "9",
        "data-position": "top"
      },
      domProps: {
        "value": (_vm.appraisalquote_table.filter)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisalquote_table.filter = $event.target.value
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('paginator', {
      attrs: {
        "source": _vm.object_to_array(_vm.contact_appraisalquotes),
        "page-size": 10,
        "filter": _vm.appraisalquote_table.filter,
        "data-intro": "Use the paginator to page data for easier viewing",
        "data-step": "10",
        "data-position": "top"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(page) {
          return [_c('datatable', {
            attrs: {
              "id": "data-table-appraisalquotes",
              "source": page.data,
              "filterable": false,
              "striped": _vm.appraisalquote_table.striped,
              "editable": _vm.appraisalquote_table.editable,
              "line-numbers": _vm.appraisalquote_table.lineNumbers
            },
            scopedSlots: _vm._u([{
              key: "actions-appraisalquotes",
              fn: function(cell) {
                return [_c('a', {
                  staticStyle: {
                    "margin-right": "2rem",
                    "cursor": "pointer"
                  },
                  on: {
                    "click": function($event) {
                      _vm.editAppraisalQuote(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "pencil",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1)]
              }
            }])
          }, [_vm._l((_vm.appraisalquote_table.columns), function(column) {
            return _c('datatable-column', {
              attrs: {
                "id": column.id,
                "label": column.label,
                "width": column.width,
                "sortable": column.sortable,
                "groupable": column.groupable,
                "formatter": column.formatter
              }
            })
          }), _vm._v(" "), _c('datatable-column', {
            attrs: {
              "id": "actions-appraisalquotes",
              "label": _vm.actions_text,
              "sortable": false,
              "groupable": false
            }
          })], 2)]
        }
      }])
    })], 1)])]) : _c('div', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('No_records')) + ".\n\t\t\t\t\t\t\t\t\t\t\t")])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.invoices_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    })]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.appraisalreports_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    })])], 1)], 1)], 1)], 1)]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 2105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home",
    class: _vm.theme,
    attrs: {
      "id": "services-page"
    }
  }, [_c('nav-bar'), _vm._v(" "), _c('swiper', {
    ref: "mySwiper5",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticStyle: {
      "height": "100%",
      "background-image": "url('../assets/img/c1.jpg')",
      "background-size": "cover",
      "background-repeat": "no-repeat"
    }
  }, [_c('div', {
    staticClass: "slide-center"
  }, [_c('h1', {
    staticClass: "page__title-white"
  }, [_vm._v(_vm._s(_vm.$t('Pricing')))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "page"
  }, [_c('h1', {
    staticClass: "page__title"
  }, [_vm._v(_vm._s(_vm.$t('Valuation_pricing')) + " - " + _vm._s(_vm.$t('VAT_not_included')))]), _vm._v(" "), _c('hr', {
    staticClass: "page__hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "page__container main"
  }, [_c('div', {
    staticClass: "page__content left"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.$t('Pricing_text_01')) + ".\n\n\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "page__content right",
    staticStyle: {
      "background-color": "whitesmoke",
      "padding": "1rem"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'quote-request'
      }
    }
  }, [_c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Request_a_quote_here')))])]), _vm._v("\n\t\t\t\t\t. " + _vm._s(_vm.$t('Pricing_text_02')) + ".\n\t\t\t\t")])], 1)]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "color": "midnightblue"
    }
  }, [_vm._v(_vm._s(_vm.$t('Dwellings')) + ", " + _vm._s(_vm.$t('Parking_spaces')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('Storerooms')))]), _vm._v(" "), _c('table', {
    staticClass: "d-table-center"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('Appraisal_value')) + " " + _vm._s(_vm.$t('in_01')) + " " + _vm._s(_vm.$t('thousands_of_euros')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Mortgage_Appraisal_Fees')) + " *"), _c('sup', [_vm._v("1")]), _vm._v(" *"), _c('sup', [_vm._v("2")])]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Informative_Appraisal_Fees')) + "  *"), _c('sup', [_vm._v("2")])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.valuation_prices.group_A), function(range, key, index) {
    return (index < 6) ? _c('tr', [_c('td', [_vm._v(_vm._s(range.floor / 1000) + " a " + _vm._s(range.ceil / 1000))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(range.mortgage_valuation_fee) + " €\n\t\t\t\t\t"), (range.increment_pct_mortgage_valuation > 0) ? _c('span', {
      staticClass: "small"
    }, [_vm._v("\n\t\t\t\t\t+ " + _vm._s(range.increment_pct_mortgage_valuation) + " % " + _vm._s(_vm.$t('of_the_excess_of')) + " " + _vm._s(range.floor / 1000) + " " + _vm._s(_vm.$t('thousand')) + "\n\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(range.standard_valuation_fee) + " €\n\t\t\t\t\t"), (range.increment_pct_standard_valuation > 0) ? _c('span', {
      staticClass: "small"
    }, [_vm._v("\n\t\t\t\t\t+ " + _vm._s(range.increment_pct_standard_valuation) + " % " + _vm._s(_vm.$t('of_the_excess_of')) + " " + _vm._s(range.floor / 1000) + " " + _vm._s(_vm.$t('thousand')) + "\n\t\t\t\t\t")]) : _vm._e()])]) : _vm._e()
  }), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" " + _vm._s(_vm.$t('Higher_values')))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.$t('acc_Budget')))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.$t('acc_Budget')))])])], 2)]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "color": "midnightblue"
    }
  }, [_vm._v(_vm._s(_vm.$t('Commercial_premises')) + ", " + _vm._s(_vm.$t('Offices')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('Industrial_warehouses')))]), _vm._v(" "), _c('table', {
    staticClass: "d-table-center"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('Appraisal_value')) + " " + _vm._s(_vm.$t('in_01')) + " " + _vm._s(_vm.$t('thousands_of_euros')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Mortgage_Appraisal_Fees')) + " *"), _c('sup', [_vm._v("1")]), _vm._v(" *"), _c('sup', [_vm._v("2")])]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Informative_Appraisal_Fees')) + "  *"), _c('sup', [_vm._v("2")])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.valuation_prices.group_B), function(range, key, index) {
    return (index < 5) ? _c('tr', [_c('td', [_vm._v(_vm._s(range.floor / 1000) + " a " + _vm._s(range.ceil / 1000))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(range.mortgage_valuation_fee) + " €\n\t\t\t\t\t"), (range.increment_pct_mortgage_valuation > 0) ? _c('span', {
      staticClass: "small"
    }, [_vm._v("\n\t\t\t\t\t+ " + _vm._s(range.increment_pct_mortgage_valuation) + " % " + _vm._s(_vm.$t('of_the_excess_of')) + " " + _vm._s(range.floor / 1000) + " " + _vm._s(_vm.$t('thousand')) + "\n\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(range.standard_valuation_fee) + " €\n\t\t\t\t\t"), (range.increment_pct_standard_valuation > 0) ? _c('span', {
      staticClass: "small"
    }, [_vm._v("\n\t\t\t\t\t+ " + _vm._s(range.increment_pct_standard_valuation) + " % " + _vm._s(_vm.$t('of_the_excess_of')) + " " + _vm._s(range.floor / 1000) + " " + _vm._s(_vm.$t('thousand')) + "\n\t\t\t\t\t")]) : _vm._e()])]) : _vm._e()
  }), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" " + _vm._s(_vm.$t('Higher_values')))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.$t('acc_Budget')))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.$t('acc_Budget')))])])], 2)]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "color": "midnightblue"
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.$t('Buildings')) + ", " + _vm._s(_vm.$t('Property_developments')) + ", " + _vm._s(_vm.$t('Properties_under_economic_exploitation')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('Land_pl')))]), _vm._v(" "), _c('table', {
    staticClass: "d-table-center"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('Appraisal_value')) + " " + _vm._s(_vm.$t('in_01')) + " " + _vm._s(_vm.$t('thousands_of_euros')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Fees')) + " *"), _c('sup', [_vm._v("2")])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.valuation_prices.group_C), function(range, key, index) {
    return (index < 6) ? _c('tr', [_c('td', [_vm._v(_vm._s(range.floor / 1000) + " a " + _vm._s(range.ceil / 1000))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(range.standard_valuation_fee) + " €\n\t\t\t\t\t"), (range.increment_pct_standard_valuation > 0) ? _c('span', {
      staticClass: "small"
    }, [_vm._v("\n\t\t\t\t\t+ " + _vm._s(range.increment_pct_standard_valuation) + " % " + _vm._s(_vm.$t('of_the_excess_of')) + " " + _vm._s(range.floor / 1000) + " " + _vm._s(_vm.$t('thousand')) + "\n\t\t\t\t\t")]) : _vm._e()])]) : _vm._e()
  }), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" " + _vm._s(_vm.$t('Higher_values')))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.$t('acc_Budget')))])])], 2)]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "color": "midnightblue"
    }
  }, [_vm._v(_vm._s(_vm.$t('Machinery')) + ", " + _vm._s(_vm.$t('Expropriations')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('others')) + ": "), _c('span', {
    staticStyle: {
      "color": "gray"
    }
  }, [_vm._v(_vm._s(_vm.$t('acc_Budget')))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("\n\t\t\t*"), _c('sup'), _vm._v(" " + _vm._s(_vm.$t('Pricing_text_03')) + ".\n\n\t\t"), _c('br'), _vm._v("\n\t\t\t*"), _c('sup', [_vm._v("1")]), _vm._v(" " + _vm._s(_vm.$t('Pricing_text_04')) + ".\n\t\t"), _c('br'), _vm._v("\n\t\t\t*"), _c('sup', [_vm._v("2")]), _vm._v(" " + _vm._s(_vm.$t('Pricing_text_05')) + ".\n\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h1', {
    staticClass: "page__title"
  }, [_vm._v(_vm._s(_vm.$t('Report_content')))]), _vm._v(" "), _c('hr', {
    staticClass: "page__hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "page__container main"
  }, [_c('ul', [_c('li', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t('Report_content_text_01')) + ".\n\t\t\t\t\t")]), _vm._v(" "), _c('li', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t('Report_content_text_02')) + ".\n\t\t\t\t\t")]), _vm._v(" "), _c('li', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t('Report_content_text_03')) + ".\n\t\t\t\t\t")]), _vm._v(" "), _c('li', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t('Report_content_text_04')) + ".\n\t\t\t\t\t")])])])]), _vm._v(" "), _c('div', {
    staticClass: "page",
    staticStyle: {
      "background": "whitesmoke"
    }
  }, [_c('h1', {
    staticClass: "page__title"
  }, [_vm._v(_vm._s(_vm.$t('Other_services')))]), _vm._v(" "), _c('hr', {
    staticClass: "page__hr"
  }), _vm._v(" "), _c('h3', {
    staticStyle: {
      "color": "midnightblue"
    }
  }, [_vm._v(_vm._s(_vm.$t('Energy_Efficiency_Certificate')) + ": "), _c('span', {
    staticStyle: {
      "color": "gray"
    }
  }, [_vm._v(_vm._s(_vm.$t('EEC_conditions')) + ". " + _vm._s(_vm.$t('OT_conditions')) + ".")])]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "color": "midnightblue"
    }
  }, [_vm._v(_vm._s(_vm.$t('Occupancy_Card_and_Certificate')) + ": "), _c('span', {
    staticStyle: {
      "color": "gray"
    }
  }, [_vm._v(_vm._s(_vm.$t('OCC_conditions')) + ". " + _vm._s(_vm.$t('OT_conditions')) + ".")])]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "color": "midnightblue"
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.$t('Energy_Efficiency_Certificate')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('Occupancy_Card')) + " " + _vm._s(_vm.$t('of_the_same_property')) + ": "), _c('span', {
    staticStyle: {
      "color": "gray"
    }
  }, [_vm._v(_vm._s(_vm.$t('EECOCC_conditions')) + ". " + _vm._s(_vm.$t('OT_conditions')) + ".")])]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "color": "midnightblue"
    }
  }, [_vm._v(_vm._s(_vm.$t('Surveying')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('Measurements')) + ": "), _c('span', {
    staticStyle: {
      "color": "gray"
    }
  }, [_vm._v(_vm._s(_vm.$t('acc_Budget')))])])]), _vm._v(" "), _c('div', {
    staticClass: "page"
  }, [_c('strong', [_vm._v("\n\t\t\t*"), _c('sup', [_vm._v("3")]), _vm._v(" " + _vm._s(_vm.$t('Pricing_text_06')) + ".\n\t\t")])]), _vm._v(" "), _c('logo-bar'), _vm._v(" "), _c('footer-bar')], 1)
},staticRenderFns: []}

/***/ }),
/* 2106 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-actions"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "foot"
  }, [_c('div', {
    staticClass: "dropdown"
  }, [_c('button', {
    staticClass: "button-icon lnr-list",
    on: {
      "click": function($event) {
        _vm.goTo('dashboard')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dropdown-content"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.goTo('appraisalfiles-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "folder-o",
      "scale": "1"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('Files')))], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.goTo('realestates-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "building-o",
      "scale": "1"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('Real_estates')))], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.goTo('ads-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "bookmark-o",
      "scale": "1"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('Ads')))], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.goTo('contacts-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "address-card-o",
      "scale": "1"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('Contacts')))], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.goTo('appraisalquotes-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "file-powerpoint-o",
      "scale": "1"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('Quotes')))], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.goTo('appraisalinvoices-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "eur",
      "scale": "1"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('Invoices')))], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.goTo('appraisers-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "user-circle-o",
      "scale": "1"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('Appraisers')))], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.goTo('supervisors-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "user-circle",
      "scale": "1"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('Supervisors')))], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.goTo('entities-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "university",
      "scale": "1"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('Entities')))], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.goTo('becproperties-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "tag",
      "scale": "1"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('Construction_prices')))], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.goTo('bdefiles-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "archive",
      "scale": "1"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('BDE_files')))], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "foot__right"
  }, [_c('div', {
    staticClass: "dropdown"
  }, [_c('button', {
    staticStyle: {
      "border": "1px solid #DDDDDD",
      "padding": "0.2rem"
    }
  }, [_vm._v(_vm._s(_vm.$t('Language')))]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-content"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.setLanguage('ca')
      }
    }
  }, [_vm._v("Català")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.setLanguage('es')
      }
    }
  }, [_vm._v("Castellano")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.setLanguage('en')
      }
    }
  }, [_vm._v("English")])])]), _vm._v(" "), _c('dropdown')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "color": "#1a3856"
    }
  }, [_c('strong', [_vm._v("Bonell+Dòriga")])])
}]}

/***/ }),
/* 2107 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "contacts-index"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "filesOpen": _vm.filesOpen,
        "fileOpen": _vm.fileOpen,
        "reportOpen": _vm.reportOpen
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('Contacts_Index')))]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCreateNewContact($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus-circle",
        "text": _vm.new_contact_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell",
      attrs: {
        "layout": "row"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.customers.filter),
        expression: "customers.filter"
      }],
      attrs: {
        "type": "text",
        "placeholder": _vm.filter_placeholder,
        "self": "size-x1",
        "data-intro": "You can filter the data in a datatable by typing in any of the filter fields",
        "data-step": "9",
        "data-position": "top"
      },
      domProps: {
        "value": (_vm.customers.filter)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.customers.filter = $event.target.value
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('paginator', {
      attrs: {
        "source": _vm.contacts_to_array(_vm.contacts),
        "page-size": 10,
        "filter": _vm.customers.filter,
        "data-intro": "Use the paginator to page data for easier viewing",
        "data-step": "10",
        "data-position": "top"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(page) {
          return [_c('datatable', {
            attrs: {
              "id": "data-table-main",
              "source": page.data,
              "filterable": false,
              "striped": _vm.customers.striped,
              "editable": _vm.customers.editable,
              "line-numbers": _vm.customers.lineNumbers
            },
            scopedSlots: _vm._u([{
              key: "actions",
              fn: function(cell) {
                return [_c('a', {
                  staticStyle: {
                    "margin-right": "2rem",
                    "cursor": "pointer"
                  },
                  on: {
                    "click": function($event) {
                      _vm.editContact(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "pencil",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1), _vm._v(" "), _c('a', {
                  staticStyle: {
                    "cursor": "pointer"
                  },
                  on: {
                    "click": function($event) {
                      _vm.deleteContact(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "trash-o",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1)]
              }
            }])
          }, [_vm._l((_vm.customers.columns), function(column) {
            return _c('datatable-column', {
              attrs: {
                "id": column.id,
                "label": column.label,
                "width": column.width,
                "sortable": column.sortable,
                "groupable": column.groupable,
                "formatter": column.formatter
              }
            })
          }), _vm._v(" "), _c('datatable-column', {
            attrs: {
              "id": "actions",
              "label": "Actions",
              "sortable": false,
              "groupable": false
            }
          })], 2)]
        }
      }])
    })], 1)])], 1)], 1)]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 2108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "search__result",
    class: {
      active: _vm.isActive
    },
    attrs: {
      "id": ("result_" + (_vm.contact.id))
    },
    on: {
      "dblclick": _vm.onRenameFocus,
      "!click": function($event) {
        _vm.onResultSelect($event)
      },
      "mouseenter": function($event) {
        _vm.showDelete = true
      },
      "mouseleave": function($event) {
        _vm.showDelete = false
      }
    }
  }, [(_vm.renaming) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contact.name),
      expression: "contact.name"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "search__result__editor",
    attrs: {
      "id": ("search-result-editor-" + (_vm.contact.id)),
      "type": "text"
    },
    domProps: {
      "value": (_vm.contact.name)
    },
    on: {
      "blur": _vm.onRenameBlur,
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.onRenameBlur($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onRenameSave($event)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contact.name = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (!(_vm.renaming)) ? [_c('span', {
    staticClass: "search__result__name"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.name)
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.contact.body.length > 0),
      expression: "contact.body.length > 0"
    }],
    staticClass: "search__result__description"
  }, [_vm._v(" \n        – " + _vm._s(_vm.contact.body) + "\n      ")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDelete),
      expression: "showDelete"
    }],
    staticClass: "search__result__delete",
    on: {
      "click": _vm.onDelete
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showDelete),
      expression: "!showDelete"
    }],
    staticClass: "search__result__time"
  }, [_vm._v("\n      " + _vm._s(_vm._f("prettyDate")(_vm.contact.date_modified)) + "\n    ")])] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 2109 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-container"
  }, [_vm._t("parallax-bg"), _vm._v(" "), _c('div', {
    class: _vm.defaultSwiperClasses.wrapperClass
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("pagination"), _vm._v(" "), _vm._t("button-prev"), _vm._v(" "), _vm._t("button-next"), _vm._v(" "), _vm._t("scrollbar")], 2)
},staticRenderFns: []}

/***/ }),
/* 2110 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: _vm.clazz,
    style: (_vm.style),
    attrs: {
      "version": "1.1",
      "role": _vm.label ? 'img' : 'presentation',
      "aria-label": _vm.label,
      "x": _vm.x,
      "y": _vm.y,
      "width": _vm.width,
      "height": _vm.height,
      "viewBox": _vm.box
    }
  }, [_vm._t("default", [(_vm.icon && _vm.icon.paths) ? _vm._l((_vm.icon.paths), function(path) {
    return _c('path', _vm._b({}, 'path', path))
  }) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.icon.polygons) ? _vm._l((_vm.icon.polygons), function(polygon) {
    return _c('polygon', _vm._b({}, 'polygon', polygon))
  }) : _vm._e(), _vm._v("\b\n    "), (_vm.icon && _vm.icon.raw) ? [_c('g', {
    domProps: {
      "innerHTML": _vm._s(_vm.icon.raw)
    }
  })] : _vm._e()])], 2)
},staticRenderFns: []}

/***/ }),
/* 2111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "cadasterannex-editor"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "filesOpen": _vm.filesOpen,
        "fileOpen": _vm.fileOpen,
        "reportOpen": _vm.reportOpen
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [_c('span', [_vm._v(_vm._s(_vm.$t('Annex')) + " \"" + _vm._s(_vm.cadasterannex.filename) + "\"")]), (_vm.cadasterannex.dirty) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.cadasterannex.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "datedata"
    }, [_c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Created')) + ": " + _vm._s(_vm.millis_to_time(_vm.cadasterannex.date_created)))]), _vm._v(" "), _c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Last_modified')) + ": " + _vm._s(_vm.millis_to_time(_vm.cadasterannex.date_modified)))])]), _vm._v(" "), _c('vue-tabs', [_c('v-tab', {
      attrs: {
        "title": _vm.data_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('div', {
      staticClass: "field-container"
    }, [(_vm.cadasterannex.url) ? _c('div', [_c('img', {
      attrs: {
        "src": _vm.cadasterannex.url,
        "width": "600px",
        "height": "auto"
      }
    })]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('File_name')) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('File_name')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.cadasterannex.filename))])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Image_footer')) + " ")]), _vm._v(" "), (_vm.cadasterannex.name_ca || _vm.currentLocale === 'ca') ? _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Image_footer')) + " " + _vm._s(_vm.$t('in')) + " " + _vm._s(_vm.$t('Catalan')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.cadasterannex.name_ca),
        expression: "cadasterannex.name_ca"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.cadasterannex.name_ca)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.cadasterannex.name_ca = $event.target.value
        }, _vm.set_cadasterannex_name_ca]
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.cadasterannex.name_en || _vm.currentLocale === 'en') ? _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Image_footer')) + " " + _vm._s(_vm.$t('in')) + " " + _vm._s(_vm.$t('English')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.cadasterannex.name_en),
        expression: "cadasterannex.name_en"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.cadasterannex.name_en)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.cadasterannex.name_en = $event.target.value
        }, _vm.set_cadasterannex_name_en]
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.cadasterannex.name_es || _vm.currentLocale === 'es') ? _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Image_footer')) + " " + _vm._s(_vm.$t('in')) + " " + _vm._s(_vm.$t('Spanish')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.cadasterannex.name_es),
        expression: "cadasterannex.name_es"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.cadasterannex.name_es)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.cadasterannex.name_es = $event.target.value
        }, _vm.set_cadasterannex_name_es]
      }
    })])]) : _vm._e()])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.metadata_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('form', {
      staticClass: "bt-form"
    })])])], 1), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUp($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "chevron-left",
        "text": _vm.goup_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentCadasterAnnex({
            go_up: false
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentCadasterAnnex({
            go_up: true
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_and_go_up_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), (_vm.cadasterannex.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e()], 1)], 1)]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 2112 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "editor"
  }, [(_vm.activeNote) ? [_c('editor-highlight', {
    attrs: {
      "body": _vm.activeNote.body
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeNote.body),
      expression: "activeNote.body"
    }],
    staticClass: "editor__textarea",
    attrs: {
      "id": "editor-textarea",
      "placeholder": "The quick brown fox...",
      "rows": "12"
    },
    domProps: {
      "value": (_vm.activeNote.body)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.activeNote.body = $event.target.value
      }, _vm.onInput],
      "blur": _vm.onBlur,
      "focus": _vm.onFocus
    }
  })] : _c('div', {
    staticClass: "editor__placeholder"
  }, [_vm._v("\n    No Note Selected\n  ")])], 2)
},staticRenderFns: []}

/***/ }),
/* 2113 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "appraisalinvoices-index"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "invoicesOpen": _vm.invoicesOpen
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('Appraisal_invoices_index')))]), _vm._v(" "), _c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell",
      attrs: {
        "layout": "row"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalinvoice_table.filter),
        expression: "appraisalinvoice_table.filter"
      }],
      attrs: {
        "type": "text",
        "placeholder": _vm.filter_placeholder,
        "self": "size-x1",
        "data-intro": "You can filter the data in a datatable by typing in any of the filter fields",
        "data-step": "9",
        "data-position": "top"
      },
      domProps: {
        "value": (_vm.appraisalinvoice_table.filter)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisalinvoice_table.filter = $event.target.value
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('paginator', {
      attrs: {
        "source": _vm.appraisalinvoices_to_array(_vm.appraisalinvoices),
        "page-size": 10,
        "filter": _vm.appraisalinvoice_table.filter,
        "data-intro": "Use the paginator to page data for easier viewing",
        "data-step": "10",
        "data-position": "top"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(page) {
          return [_c('datatable', {
            attrs: {
              "id": "data-table-main",
              "source": page.data,
              "filterable": false,
              "striped": _vm.appraisalinvoice_table.striped,
              "editable": _vm.appraisalinvoice_table.editable,
              "line-numbers": _vm.appraisalinvoice_table.lineNumbers
            },
            scopedSlots: _vm._u([{
              key: "number",
              fn: function(cell) {
                return [_c('span', {
                  staticClass: "navspan",
                  on: {
                    "click": function($event) {
                      $event.preventDefault();
                      _vm.goToInvoice(cell.row['id'], cell.row['file_id'])
                    }
                  }
                }, [_vm._v(_vm._s(cell.row['number']))])]
              }
            }, {
              key: "actions",
              fn: function(cell) {
                return [_c('a', {
                  staticStyle: {
                    "margin-right": "2rem",
                    "cursor": "pointer"
                  },
                  on: {
                    "click": function($event) {
                      _vm.editAppraisalInvoice(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "pencil",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1), _vm._v(" "), _c('a', {
                  staticStyle: {
                    "cursor": "pointer"
                  },
                  on: {
                    "click": function($event) {
                      _vm.deleteAppraisalInvoice(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "trash-o",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1)]
              }
            }])
          }, [_vm._l((_vm.appraisalinvoice_table.columns), function(column) {
            return _c('datatable-column', {
              attrs: {
                "id": column.id,
                "label": column.label,
                "width": column.width,
                "sortable": column.sortable,
                "groupable": column.groupable,
                "formatter": column.formatter
              }
            })
          }), _vm._v(" "), _c('datatable-column', {
            attrs: {
              "id": "actions",
              "label": "Actions",
              "sortable": false,
              "groupable": false
            }
          })], 2)]
        }
      }])
    })], 1)])], 1)], 1)]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 2114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "appraisals-index"
    }
  }, [(_vm.loading) ? _c('spinner') : [_c('div', {
    staticClass: "app-container"
  }, [_c('bar'), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('Edit')) + " " + _vm._s(_vm.$t('e-mail'))), (_vm.emailaddress.dirty) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.emailaddress.dirty) ? _c('message', {
    attrs: {
      "text": _vm.page_dirty_text,
      "icon_name": "info",
      "icon_color": "rgb(0, 135, 248)",
      "border_color": "rgb(0, 135, 248)",
      "text_color": "rgb(0, 135, 248)"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "datedata"
  }, [_c('p', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('Created')) + ": " + _vm._s(_vm.millis_to_time(_vm.emailaddress.date_created)))]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('Last_modified')) + ": " + _vm._s(_vm.millis_to_time(_vm.emailaddress.date_modified)))])]), _vm._v(" "), _c('div', [_c('form', {
    staticClass: "bt-form"
  }, [_c('div', {
    staticClass: "section-container"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('E-mail_address')))]), _vm._v(" "), _c('div', {
    staticClass: "field-container"
  }, [_c('div', {
    staticClass: "field__group"
  }, [_c('label', {
    staticClass: "field__group__label"
  }, [_vm._v(_vm._s(_vm.$t('E-mail_address')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailaddress.address),
      expression: "emailaddress.address"
    }],
    staticClass: "field__group__input",
    attrs: {
      "type": "email",
      "step": "1",
      "spellcheck": "false"
    },
    domProps: {
      "value": (_vm.emailaddress.address)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.emailaddress.address = $event.target.value
      }, _vm.set_emailaddress_address]
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "section-container"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Description')))]), _vm._v(" "), _c('div', {
    staticClass: "field-container"
  }, [_c('div', {
    staticClass: "field__group"
  }, [_c('label', {
    staticClass: "field__group__label"
  }, [_vm._v(_vm._s(_vm.$t('Description')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailaddress.description),
      expression: "emailaddress.description"
    }],
    staticClass: "field__group__input",
    attrs: {
      "type": "text",
      "spellcheck": "false"
    },
    domProps: {
      "value": (_vm.emailaddress.description)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.emailaddress.description = $event.target.value
      }, _vm.set_emailaddress_description]
    }
  })])])]), _vm._v(" "), _c('div', [_c('hr')]), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "width": "fit-content",
      "margin-left": "auto"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onGoBack($event)
      }
    }
  }, [_c('icon-button', {
    attrs: {
      "icon": "chevron-left",
      "text": _vm.goback_button_text,
      "icon_color": "black",
      "text_color": "black",
      "border_color": "lightgray"
    }
  })], 1)]), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "width": "fit-content",
      "margin-left": "auto"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onSaveCurrentEmailAddress({
          goback: true
        })
      }
    }
  }, [_c('icon-button', {
    attrs: {
      "icon": "floppy-o",
      "text": _vm.save_button_text,
      "icon_color": "white",
      "text_color": "white",
      "border_color": "#006bc5",
      "background_color": "#0087F8"
    }
  })], 1)]), _vm._v(" "), (_vm.emailaddress.dirty) ? _c('message', {
    attrs: {
      "text": _vm.page_dirty_text,
      "icon_name": "info",
      "icon_color": "rgb(0, 135, 248)",
      "border_color": "rgb(0, 135, 248)",
      "text_color": "rgb(0, 135, 248)"
    }
  }) : _vm._e()], 1)])], 1)]], 2)
},staticRenderFns: []}

/***/ }),
/* 2115 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "appraisals-index"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "filesOpen": _vm.filesOpen,
        "fileOpen": _vm.fileOpen,
        "fileId": _vm.appraisalfile.id,
        "fileNumber": _vm.appraisalfile.number,
        "reportOpen": _vm.reportOpen,
        "reportNumber": _vm.appraisalreport.number,
        "versionNumber": _vm.appraisalreport.version,
        "realEstateId": _vm.ad.id,
        "reportId": _vm.appraisalreport.id
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('Ad')) + " "), (_vm.ad.ad_date) ? _c('span', [_vm._v(_vm._s(_vm.$t('from')) + " " + _vm._s(_vm.formatted_ad_date))]) : _vm._e(), _vm._v(" "), (_vm.ad.street_name) ? _c('span', [_vm._v(_vm._s(_vm.$t('at')) + " " + _vm._s(_vm.ad.street_name))]) : _vm._e(), (_vm.ad.street_number) ? _c('span', [_vm._v(", " + _vm._s(_vm.ad.street_number))]) : _vm._e(), (_vm.ad.municipality) ? _c('span', [_vm._v(", " + _vm._s(_vm.ad.municipality.name_ine))]) : _vm._e(), _vm._v(" "), (_vm.ad.dirty) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.ad.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "datedata"
    }, [_c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Created')) + ": " + _vm._s(_vm.millis_to_time(_vm.ad.date_created)))]), _vm._v(" "), _c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Last_modified')) + ": " + _vm._s(_vm.millis_to_time(_vm.ad.date_modified)))])]), _vm._v(" "), _c('vue-tabs', [_c('v-tab', {
      attrs: {
        "title": _vm.identification_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [(_vm.ad.url) ? _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onOpenAd($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "external-link",
        "text": _vm.open_ad_button_text,
        "icon_color": "#004f92",
        "text_color": "#004f92",
        "border_color": "lightgray"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Address')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Country')) + " "), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.countryValue,
        "options": _vm.countryOptions,
        "track-by": "iso_3166_alpha2_code",
        "label": 'name_en',
        "searchable": true
      },
      on: {
        "input": _vm.set_ad_country_option
      },
      model: {
        value: (_vm.ad.country),
        callback: function($$v) {
          _vm.ad.country = $$v
        },
        expression: "ad.country"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [(_vm.ad.country) ? _c('div', {
      staticClass: "ms-container"
    }, [(_vm.ad.country.name_en === 'Spain') ? _c('div', [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Province'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.provinceValue,
        "options": _vm.spanishProvinceOptions,
        "track-by": "id",
        "label": 'name_ine',
        "searchable": true
      },
      on: {
        "input": _vm.set_ad_province_option
      },
      model: {
        value: (_vm.ad.province),
        callback: function($$v) {
          _vm.ad.province = $$v
        },
        expression: "ad.province"
      }
    })], 1) : _c('div', [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Province')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.province),
        expression: "ad.province"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.province)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.province = $event.target.value
        }, _vm.set_ad_province]
      }
    })])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [(_vm.ad.province) ? _c('div', {
      staticClass: "ms-container"
    }, [(_vm.ad.country.name_en === 'Spain') ? _c('div', [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Municipality'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.municipalityValue,
        "options": _vm.object_to_array(_vm.ad_municipalities),
        "track-by": "id",
        "label": 'name_ine',
        "searchable": true
      },
      on: {
        "input": _vm.set_ad_municipality_option
      },
      model: {
        value: (_vm.ad.municipality),
        callback: function($$v) {
          _vm.ad.municipality = $$v
        },
        expression: "ad.municipality"
      }
    })], 1) : _c('div', [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Municipality')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.municipality),
        expression: "ad.municipality"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.municipality)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.municipality = $event.target.value
        }, _vm.set_ad_municipality]
      }
    })])]) : _vm._e()]), _vm._v(" "), (_vm.ad.municipality) ? _c('div', [_c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Street_name'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.street_name),
        expression: "ad.street_name"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.street_name)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.street_name = $event.target.value
        }, _vm.set_ad_street_name]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Street_number'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.street_number),
        expression: "ad.street_number"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "step": "1",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.street_number)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.street_number = $event.target.value
        }, _vm.set_ad_street_number],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Floor_name'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.floor),
        expression: "ad.floor"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.floor)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.floor = $event.target.value
        }, _vm.set_ad_floor]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Height_situation'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.floor_number),
        expression: "ad.floor_number"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.floor_number)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.floor_number = $event.target.value
        }, _vm.set_ad_floor_number],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Floor_type'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.floor_typeValue,
        "options": _vm.floor_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_ad_floor_type
      },
      model: {
        value: (_vm.ad.floor_type),
        callback: function($$v) {
          _vm.ad.floor_type = $$v
        },
        expression: "ad.floor_type"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Door'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.door),
        expression: "ad.door"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.door)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.door = $event.target.value
        }, _vm.set_ad_door]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Staircase'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.staircase),
        expression: "ad.staircase"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.staircase)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.staircase = $event.target.value
        }, _vm.set_ad_staircase]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Block'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.block),
        expression: "ad.block"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.block)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.block = $event.target.value
        }, _vm.set_ad_block]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Ad_address')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.ad_address),
        expression: "ad.ad_address"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.ad_address)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.ad_address = $event.target.value
        }, _vm.set_ad_ad_address]
      }
    })])])]) : _vm._e()]), _vm._v(" "), (this.ad.municipality && this.ad.street_name && this.ad.street_number) ? _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Geolocation')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('button', {
      staticClass: "quote-request__aux__button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGeolocate($event)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.onGeolocate($event)
        }
      }
    }, [_c('span', [_c('icon', {
      attrs: {
        "name": "globe",
        "scale": "1",
        "color": "rgb(0, 79, 146)"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Geolocate')))], 1)])]), _vm._v(" "), (_vm.google_geocode_loading) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "1",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Loading')) + "...")], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Latitude'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.lat),
        expression: "ad.lat"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "step": "any",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.lat)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.lat = $event.target.value
        }, _vm.set_ad_lat],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Longitude'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.lng),
        expression: "ad.lng"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "step": "any",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.lng)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.lng = $event.target.value
        }, _vm.set_ad_lng],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Postal_code'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.postal_code),
        expression: "ad.postal_code"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.postal_code)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.postal_code = $event.target.value
        }, _vm.set_ad_postal_code]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v("X EPSG:25831"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.epsg25831_x),
        expression: "ad.epsg25831_x"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "step": "any",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.epsg25831_x)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.epsg25831_x = $event.target.value
        }, _vm.set_ad_epsg25831_x],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v("Y EPSG:25831"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.epsg25831_y),
        expression: "ad.epsg25831_y"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "step": "any",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.epsg25831_y)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.epsg25831_y = $event.target.value
        }, _vm.set_ad_epsg25831_y],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('span', {
      staticClass: "help"
    }, [_c('i', [_vm._v("Aquesta geolocalització es correspon a l'adreça:")]), _vm._v(" " + _vm._s(_vm.ad.google_formatted_address) + ", (" + _vm._s(_vm.ad.geohash) + ")")])])])]) : _vm._e(), _vm._v(" "), (this.ad.epsg25831_x && this.ad.epsg25831_y) ? _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Census_section')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('button', {
      staticClass: "quote-request__aux__button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onRequestCensusSectionInfo($event)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.onRequestCensusSectionInfo($event)
        }
      }
    }, [_c('span', [_c('icon', {
      attrs: {
        "name": "globe",
        "scale": "1",
        "color": "rgb(0, 79, 146)"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Census_section')))], 1)])]), _vm._v(" "), (_vm.icc_census_section_loading) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "1",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Loading')) + "...")], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Census_section_code'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.census_section_code),
        expression: "ad.census_section_code"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.census_section_code)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.census_section_code = $event.target.value
        }, _vm.set_ad_census_section_code]
      }
    })])])]) : _vm._e(), _vm._v(" "), (this.ad.epsg25831_x && this.ad.epsg25831_y) ? _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Cadastral_data')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('button', {
      staticClass: "quote-request__aux__button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onRequestCadastralReferenceSuggestion($event)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.onRequestCadastralReferenceSuggestion($event)
        }
      }
    }, [_c('span', [_c('icon', {
      attrs: {
        "name": "globe",
        "scale": "1",
        "color": "rgb(0, 79, 146)"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Cadastral_reference')))], 1)])]), _vm._v(" "), (_vm.cadaster_ref_loading) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "1",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Loading')) + "...")], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Cadastral_reference'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.cadastral_reference),
        expression: "ad.cadastral_reference"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "maxlength": "20",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.cadastral_reference)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.cadastral_reference = $event.target.value
        }, _vm.set_ad_cadastral_reference]
      }
    })]), _vm._v(" "), (_vm.ad.cadastral_reference) ? _c('div', [(_vm.ad.cadastral_reference.length > 0 && _vm.ad.cadastral_reference.length < 20) ? _c('message', {
      attrs: {
        "text": _vm.cad_ref_error_text_01,
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    }) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('button', {
      staticClass: "quote-request__aux__button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onOpenCadastralMap($event)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.onOpenCadastralMap($event)
        }
      }
    }, [_c('span', [_c('icon', {
      attrs: {
        "name": "external-link",
        "scale": "1",
        "color": "rgb(0, 79, 146)"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Open')) + " " + _vm._s(_vm.$t('Cadastral_Map')))], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Construction_year'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.construction_year),
        expression: "ad.construction_year"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.construction_year)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.construction_year = $event.target.value
        }, _vm.set_ad_construction_year],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Cadastral_area'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.cadastral_area),
        expression: "ad.cadastral_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.cadastral_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.cadastral_area = $event.target.value
        }, _vm.set_ad_cadastral_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Cadastral_data_check'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.cadastral_data_check),
        expression: "ad.cadastral_data_check"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.ad.cadastral_data_check) ? _vm._i(_vm.ad.cadastral_data_check, null) > -1 : (_vm.ad.cadastral_data_check)
      },
      on: {
        "input": _vm.set_ad_cadastral_data_check,
        "__c": function($event) {
          var $$a = _vm.ad.cadastral_data_check,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.ad.cadastral_data_check = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.ad.cadastral_data_check = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.ad.cadastral_data_check = $$c
          }
        }
      }
    })])])]) : _c('div', [(this.ad.municipality && this.ad.street_name && this.ad.street_number) ? _c('message', {
      attrs: {
        "text": _vm.epsg_missing_text,
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Registry_data')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v("IDUFIR"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.registry_idufir),
        expression: "ad.registry_idufir"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.registry_idufir)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.registry_idufir = $event.target.value
        }, _vm.set_ad_registry_idufir]
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Info_source')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Ad_data_type'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.ad_data_typeValue,
        "options": _vm.ad_data_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_ad_ad_data_type
      },
      model: {
        value: (_vm.ad.ad_data_type),
        callback: function($$v) {
          _vm.ad.ad_data_type = $$v
        },
        expression: "ad.ad_data_type"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Ad_type')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.ad_typeValue,
        "options": _vm.ad_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_ad_ad_type
      },
      model: {
        value: (_vm.ad.ad_type),
        callback: function($$v) {
          _vm.ad.ad_type = $$v
        },
        expression: "ad.ad_type"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Property_type')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.property_typeValue,
        "options": _vm.property_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_ad_property_type
      },
      model: {
        value: (_vm.ad.property_type),
        callback: function($$v) {
          _vm.ad.property_type = $$v
        },
        expression: "ad.property_type"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Dwelling_type'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.dwelling_typeValue,
        "options": _vm.dwelling_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_ad_dwelling_type
      },
      model: {
        value: (_vm.ad.dwelling_type),
        callback: function($$v) {
          _vm.ad.dwelling_type = $$v
        },
        expression: "ad.dwelling_type"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Source'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.source),
        expression: "ad.source"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.source)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.source = $event.target.value
        }, _vm.set_ad_source]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Ad_date'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.ad_date),
        expression: "ad.ad_date"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "date",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.ad_date)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.ad_date = $event.target.value
        }, _vm.set_ad_ad_date]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Capture_date'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.capture_date),
        expression: "ad.capture_date"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "date",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.capture_date)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.capture_date = $event.target.value
        }, _vm.set_ad_capture_date]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Url')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.url),
        expression: "ad.url"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.url)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.url = $event.target.value
        }, _vm.set_ad_url]
      }
    })]), _vm._v(" "), (_vm.ad.url) ? _c('div', {
      staticClass: "field__group"
    }, [_c('button', {
      staticClass: "quote-request__aux__button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onOpenAd($event)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.onOpenAd($event)
        }
      }
    }, [_c('span', [_c('icon', {
      attrs: {
        "name": "external-link",
        "scale": "1",
        "color": "rgb(0, 79, 146)"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Open')) + " " + _vm._s(_vm.$t('Ad')))], 1)])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Contact_telephone'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.contact_telephone),
        expression: "ad.contact_telephone"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.contact_telephone)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.contact_telephone = $event.target.value
        }, _vm.set_ad_contact_telephone]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Contact_name')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.contact_name),
        expression: "ad.contact_name"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.contact_name)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.contact_name = $event.target.value
        }, _vm.set_ad_contact_name]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Ad_code')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.ad_code),
        expression: "ad.ad_code"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.ad_code)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.ad_code = $event.target.value
        }, _vm.set_ad_ad_code]
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Age')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('Conservation_status')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Construction_year'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.construction_year),
        expression: "ad.construction_year"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.construction_year)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.construction_year = $event.target.value
        }, _vm.set_ad_construction_year],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Last_renovation_year'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.last_renovation_year),
        expression: "ad.last_renovation_year"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.last_renovation_year)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.last_renovation_year = $event.target.value
        }, _vm.set_ad_last_renovation_year],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Adopted_age'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.adopted_age),
        expression: "ad.adopted_age"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.adopted_age)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.adopted_age = $event.target.value
        }, _vm.set_ad_adopted_age],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Conservation_status'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.conservation_statusValue,
        "options": _vm.conservation_statusOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_ad_conservation_status
      },
      model: {
        value: (_vm.ad.conservation_status),
        callback: function($$v) {
          _vm.ad.conservation_status = $$v
        },
        expression: "ad.conservation_status"
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Areas')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Adopted_area')) + " (m²)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.adopted_area),
        expression: "ad.adopted_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.adopted_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.adopted_area = $event.target.value
        }, _vm.set_ad_adopted_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Built_area')) + " (m²)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.built_area),
        expression: "ad.built_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.built_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.built_area = $event.target.value
        }, _vm.set_ad_built_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Land_area')) + " (m²)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.land_area),
        expression: "ad.land_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.land_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.land_area = $event.target.value
        }, _vm.set_ad_land_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Net_area')) + " (m²)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.net_area),
        expression: "ad.net_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.net_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.net_area = $event.target.value
        }, _vm.set_ad_net_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Covered_outdoor_area')) + " (m²)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.covered_outdoor_area),
        expression: "ad.covered_outdoor_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.covered_outdoor_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.covered_outdoor_area = $event.target.value
        }, _vm.set_ad_covered_outdoor_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Uncovered_outdoor_area')) + " (m²)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.uncovered_outdoor_area),
        expression: "ad.uncovered_outdoor_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.uncovered_outdoor_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.uncovered_outdoor_area = $event.target.value
        }, _vm.set_ad_uncovered_outdoor_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Price')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Offer_price')) + " (€)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.offer_price),
        expression: "ad.offer_price"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.offer_price)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.offer_price = $event.target.value
        }, _vm.set_ad_offer_price],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Unit_price')) + " (€/m²)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.ad.offer_unit_price)) + " €/m²")])])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Offer_price_reduction_coef')) + " "), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.offer_price_reduction_pct),
        expression: "ad.offer_price_reduction_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.offer_price_reduction_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.offer_price_reduction_pct = $event.target.value
        }, _vm.set_ad_offer_price_reduction_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', [_vm._v(" Nota*")]), _vm._v(" "), _c('span', {
      staticClass: "small"
    }, [_vm._v("Reducció per concepte d'Oferta, Comercialització, Negociació, etc.. per estimar el preu de venta final")])])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Estimated_sale_price')) + " (€)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.ad.estimated_sale_price)) + " €")])])]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Estimated_unit_sale_price')) + " (€)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.ad.estimated_unit_sale_price)) + " €/m²")])])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Features')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Bedrooms_number'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.bedrooms_number),
        expression: "ad.bedrooms_number"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.bedrooms_number)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.bedrooms_number = $event.target.value
        }, _vm.set_ad_bedrooms_number],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Bathrooms_number'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.bathrooms_number),
        expression: "ad.bathrooms_number"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.bathrooms_number)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.bathrooms_number = $event.target.value
        }, _vm.set_ad_bathrooms_number],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Parking_lots_number'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.parking_lots_number),
        expression: "ad.parking_lots_number"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.parking_lots_number)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.parking_lots_number = $event.target.value
        }, _vm.set_ad_parking_lots_number],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Orientation')) + " ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.orientation),
        expression: "ad.orientation"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.orientation)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.orientation = $event.target.value
        }, _vm.set_ad_orientation]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Air_conditioning'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.air_conditioning),
        expression: "ad.air_conditioning"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.ad.air_conditioning) ? _vm._i(_vm.ad.air_conditioning, null) > -1 : (_vm.ad.air_conditioning)
      },
      on: {
        "input": _vm.set_ad_air_conditioning,
        "__c": function($event) {
          var $$a = _vm.ad.air_conditioning,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.ad.air_conditioning = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.ad.air_conditioning = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.ad.air_conditioning = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('External_storage_room'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.external_storage_room),
        expression: "ad.external_storage_room"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.ad.external_storage_room) ? _vm._i(_vm.ad.external_storage_room, null) > -1 : (_vm.ad.external_storage_room)
      },
      on: {
        "input": _vm.set_ad_external_storage_room,
        "__c": function($event) {
          var $$a = _vm.ad.external_storage_room,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.ad.external_storage_room = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.ad.external_storage_room = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.ad.external_storage_room = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Green_areas'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.green_areas),
        expression: "ad.green_areas"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.ad.green_areas) ? _vm._i(_vm.ad.green_areas, null) > -1 : (_vm.ad.green_areas)
      },
      on: {
        "input": _vm.set_ad_green_areas,
        "__c": function($event) {
          var $$a = _vm.ad.green_areas,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.ad.green_areas = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.ad.green_areas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.ad.green_areas = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Heating'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.heating),
        expression: "ad.heating"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.ad.heating) ? _vm._i(_vm.ad.heating, null) > -1 : (_vm.ad.heating)
      },
      on: {
        "input": _vm.set_ad_heating,
        "__c": function($event) {
          var $$a = _vm.ad.heating,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.ad.heating = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.ad.heating = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.ad.heating = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Lift'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.lift),
        expression: "ad.lift"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.ad.lift) ? _vm._i(_vm.ad.lift, null) > -1 : (_vm.ad.lift)
      },
      on: {
        "input": _vm.set_ad_lift,
        "__c": function($event) {
          var $$a = _vm.ad.lift,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.ad.lift = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.ad.lift = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.ad.lift = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Sports_facilities'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.sports_facilities),
        expression: "ad.sports_facilities"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.ad.sports_facilities) ? _vm._i(_vm.ad.sports_facilities, null) > -1 : (_vm.ad.sports_facilities)
      },
      on: {
        "input": _vm.set_ad_sports_facilities,
        "__c": function($event) {
          var $$a = _vm.ad.sports_facilities,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.ad.sports_facilities = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.ad.sports_facilities = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.ad.sports_facilities = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Swimming_pool'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.swimming_pool),
        expression: "ad.swimming_pool"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.ad.swimming_pool) ? _vm._i(_vm.ad.swimming_pool, null) > -1 : (_vm.ad.swimming_pool)
      },
      on: {
        "input": _vm.set_ad_swimming_pool,
        "__c": function($event) {
          var $$a = _vm.ad.swimming_pool,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.ad.swimming_pool = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.ad.swimming_pool = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.ad.swimming_pool = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Interior_visit_check'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.interior_visit_check),
        expression: "ad.interior_visit_check"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.ad.interior_visit_check) ? _vm._i(_vm.ad.interior_visit_check, null) > -1 : (_vm.ad.interior_visit_check)
      },
      on: {
        "input": _vm.set_ad_interior_visit_check,
        "__c": function($event) {
          var $$a = _vm.ad.interior_visit_check,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.ad.interior_visit_check = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.ad.interior_visit_check = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.ad.interior_visit_check = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Qualities')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Quality_of_neighbourhood'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.quality_of_neighbourhoodValue,
        "options": _vm.quality_of_neighbourhoodOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_ad_quality_of_neighbourhood
      },
      model: {
        value: (_vm.ad.quality_of_neighbourhood),
        callback: function($$v) {
          _vm.ad.quality_of_neighbourhood = $$v
        },
        expression: "ad.quality_of_neighbourhood"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Quality_of_situation'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.quality_of_situationValue,
        "options": _vm.quality_of_situationOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_ad_quality_of_situation
      },
      model: {
        value: (_vm.ad.quality_of_situation),
        callback: function($$v) {
          _vm.ad.quality_of_situation = $$v
        },
        expression: "ad.quality_of_situation"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Quality_of_construction'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.quality_of_constructionValue,
        "options": _vm.quality_of_constructionOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_ad_quality_of_construction
      },
      model: {
        value: (_vm.ad.quality_of_construction),
        callback: function($$v) {
          _vm.ad.quality_of_construction = $$v
        },
        expression: "ad.quality_of_construction"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Quality_of_realestate'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.quality_of_realestateValue,
        "options": _vm.quality_of_realestateOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_ad_quality_of_realestate
      },
      model: {
        value: (_vm.ad.quality_of_realestate),
        callback: function($$v) {
          _vm.ad.quality_of_realestate = $$v
        },
        expression: "ad.quality_of_realestate"
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Notes')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Notes_1')))]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.notes_1),
        expression: "ad.notes_1"
      }],
      staticClass: "field__group__textarea",
      attrs: {
        "rows": "15",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.notes_1)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.notes_1 = $event.target.value
        }, _vm.set_ad_notes_1]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Notes_2')))]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.notes_2),
        expression: "ad.notes_2"
      }],
      staticClass: "field__group__textarea",
      attrs: {
        "rows": "15",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.notes_2)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.notes_2 = $event.target.value
        }, _vm.set_ad_notes_2]
      }
    })])])])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.metadata_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Description')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Ad_description')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ad.description),
        expression: "ad.description"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.ad.description)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.ad.description = $event.target.value
        }, _vm.set_ad_description]
      }
    })])])])])])])])], 1), _vm._v(" "), (!this.ad.lat || !this.ad.lng) ? _c('div', [_c('message', {
      attrs: {
        "text": _vm.epsg_missing_text,
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : _vm._e(), _vm._v(" "), (!this.ad.geohash) ? _c('div', [_c('message', {
      attrs: {
        "text": "Falta el Geohash (Geolocalitzar)",
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : _vm._e(), _vm._v(" "), (!this.ad.ad_type) ? _c('div', [_c('message', {
      attrs: {
        "text": "Falta indicar el tipus d'anunci",
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : _vm._e(), _vm._v(" "), (!this.ad.ad_date) ? _c('div', [_c('message', {
      attrs: {
        "text": "Falta la data de l'anunci",
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : _vm._e(), _vm._v(" "), (!this.ad.estimated_sale_price) ? _c('div', [_c('message', {
      attrs: {
        "text": "Falta el preu de venta estimat",
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : _vm._e(), _vm._v(" "), (!this.ad.adopted_area) ? _c('div', [_c('message', {
      attrs: {
        "text": "Falta la superfície adoptada",
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : _vm._e(), _vm._v(" "), (!this.manually_creating_new_ad) ? _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoToMarketStudy($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "level-up",
        "text": _vm.go_to_market_study_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), (!this.manually_creating_new_ad) ? _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentAd({
            go_up: false
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), (!this.manually_creating_new_ad) ? _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentAd({
            go_up: true
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_and_go_up_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), (this.manually_creating_new_ad && this.ad.lat && this.ad.lng && this.ad.geohash && this.ad.ad_type && this.ad.ad_date && this.ad.estimated_sale_price && this.ad.adopted_area) ? _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onUploadCurrentAd({
            go_up: false
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.upload_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), (_vm.ad.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e(), _vm._v(" "), _c('bar')], 1)], 1)]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 2116 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search",
    attrs: {
      "id": "search"
    }
  }, [_c('div', {
    staticClass: "search__container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.query),
      expression: "query",
      modifiers: {
        "trim": true
      }
    }, {
      name: "focus",
      rawName: "v-focus",
      value: (true),
      expression: "true"
    }],
    ref: "input",
    staticClass: "search__input",
    attrs: {
      "id": "search-input",
      "type": "text",
      "placeholder": "Search or create",
      "spellcheck": "false",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "focus": function($event) {
        _vm.isSearchFocused = true
      },
      "blur": [function($event) {
        _vm.isSearchFocused = false
      }, function($event) {
        _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value.trim()
      }, _vm.updateQuery],
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onSearch($event)
      }
    }
  }), _vm._v(" "), _c('search-info', {
    attrs: {
      "resultsCount": _vm.filteredNotes.length,
      "queryLength": _vm.query.length,
      "selected": _vm.activeNote != null,
      "searching": _vm.isSearchFocused,
      "renaming": _vm.renamingId != null,
      "editing": _vm.editingId != null
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.preview),
      expression: "!preview"
    }],
    staticClass: "search__add",
    on: {
      "click": _vm.onCreate
    }
  })], 1), _vm._v(" "), _c('ul', {
    staticClass: "search__results"
  })])
},staticRenderFns: []}

/***/ }),
/* 2117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "foot"
  }, [(_vm.showShareNote && _vm.activeNote) ? _c('foot-share-note', {
    on: {
      "onDone": _vm.onShareNote
    }
  }) : _c('foot-actions', {
    on: {
      "onShareNote": _vm.onShareNote
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2118 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-actions"
  }, [(_vm.activeNote) ? _c('span', [_vm._v("\n      " + _vm._s(_vm._f("wordCount")(_vm.activeNote.body)) + " words,\n      " + _vm._s(_vm._f("charCount")(_vm.activeNote.body)) + " chars\n    ")]) : _c('span', [_vm._v("\n      " + _vm._s(_vm.randomQuote()) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "foot__right"
  }, [(_vm.activeNote && _vm.user) ? [_c('button', {
    staticClass: "button-icon share",
    on: {
      "click": _vm.onShareNote
    }
  })] : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button-icon theme",
    on: {
      "click": _vm.onUpdateTheme
    }
  }), _vm._v(" "), _c('dropdown')], 2)])
},staticRenderFns: []}

/***/ }),
/* 2119 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home",
    class: _vm.theme,
    attrs: {
      "id": "home"
    }
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticStyle: {
      "height": "100%",
      "background-image": "url('../assets/img/bg1512.jpg')",
      "background-size": "cover",
      "background-repeat": "no-repeat"
    }
  }, [_c('div', {
    staticClass: "slide-center"
  }, [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "40vh"
    },
    attrs: {
      "src": _vm.logoUrl,
      "alt": "Bonell+Dòriga"
    },
    on: {
      "mouseover": function($event) {
        _vm.logoUrl = _vm.logoHighlightUrl
      },
      "mouseout": function($event) {
        _vm.logoUrl = _vm.logoNormalUrl
      },
      "click": function($event) {
        _vm.goTo('main')
      }
    }
  })])])])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 2120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "search__result",
    class: {
      active: _vm.isActive
    },
    attrs: {
      "id": ("result_" + (_vm.note.id))
    },
    on: {
      "dblclick": _vm.onRenameFocus,
      "!click": function($event) {
        _vm.onResultSelect($event)
      },
      "mouseenter": function($event) {
        _vm.showDelete = true
      },
      "mouseleave": function($event) {
        _vm.showDelete = false
      }
    }
  }, [(_vm.renaming) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.note.name),
      expression: "note.name"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "search__result__editor",
    attrs: {
      "id": ("search-result-editor-" + (_vm.note.id)),
      "type": "text"
    },
    domProps: {
      "value": (_vm.note.name)
    },
    on: {
      "blur": _vm.onRenameBlur,
      "keyup": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.onRenameBlur($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onRenameSave($event)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.note.name = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (!(_vm.renaming)) ? [_c('span', {
    staticClass: "search__result__name"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.name)
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.note.body.length > 0),
      expression: "note.body.length > 0"
    }],
    staticClass: "search__result__description"
  }, [_vm._v(" \n        – " + _vm._s(_vm.note.body) + "\n      ")])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDelete),
      expression: "showDelete"
    }],
    staticClass: "search__result__delete",
    on: {
      "click": _vm.onDelete
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showDelete),
      expression: "!showDelete"
    }],
    staticClass: "search__result__time"
  }, [_vm._v("\n      " + _vm._s(_vm._f("prettyDate")(_vm.note.date_modified)) + "\n    ")])] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 2121 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home",
    class: _vm.theme,
    attrs: {
      "id": "services-page"
    }
  }, [_c('nav-bar'), _vm._v(" "), _c('swiper', {
    ref: "mySwiper4",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticStyle: {
      "height": "100%",
      "background-image": "url('../assets/img/a1.jpg')",
      "background-size": "cover",
      "background-repeat": "no-repeat"
    }
  }, [_c('div', {
    staticClass: "slide-center"
  }, [_c('h1', {
    staticClass: "page__title-white"
  }, [_vm._v(_vm._s(_vm.$t('About_us')))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "page",
    attrs: {
      "id": "quote-form"
    }
  }, [_c('h1', {
    staticClass: "page__title"
  }, [_vm._v(_vm._s(_vm.$t('About_us')))]), _vm._v(" "), _c('hr', {
    staticClass: "page__hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "page__container main"
  }, [_c('div', {
    staticClass: "page__content left"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.$t('About_text_01')) + ".\n\n\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "page__content right"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.$t('About_text_02')) + ".\n\n\n\t\t\t")])])]), _vm._v(" "), _c('logo-bar'), _vm._v(" "), _c('footer-bar')], 1)
},staticRenderFns: []}

/***/ }),
/* 2122 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "datatable table-wrapper",
    class: _vm.tableClasses
  }, [_c('table', [_c('thead', {
    staticClass: "datatable-columns"
  }, [_c('tr', [(_vm.lineNumbers) ? _c('th', {
    style: ({
      width: _vm.lineColumnWidth
    })
  }, [_c('div', {
    staticClass: "datatable-column datatable-linenumber-column"
  }, [_vm._v("#")])]) : _vm._e(), _vm._v(" "), (_vm.aggregated) ? _c('th', {
    style: ({
      width: '100px'
    })
  }, [_c('div', {
    staticClass: "datatable-column datatable-aggregate-column"
  })]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)]), _vm._v(" "), (_vm.groupingColumnIds.length > 0) ? _c('tbody', {
    staticClass: "datatable-groups"
  }, [_c('tr', [_c('td', {
    staticClass: "datatable-groups-header",
    attrs: {
      "colspan": _vm.columnSpan
    }
  }, _vm._l((_vm.groupingColumns), function(column, index) {
    return _c('chip', {
      key: column.id,
      staticClass: "datatable-group-chip",
      on: {
        "remove": function($event) {
          _vm.degroupColumn(column)
        }
      }
    }, [_c('div', [_c('small', [_c('strong', [_vm._v(_vm._s(index == 0 ? "Grouping By:" : "Then:"))])])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(column.label))])])
  }))])]) : _vm._e(), _vm._v(" "), _c('tbody', {
    staticClass: "datatable-collections"
  }, [_c('tr', [_c('td', {
    staticClass: "datatable-group",
    attrs: {
      "colspan": _vm.columnSpan
    }
  }, [_c('datatable-collection', {
    attrs: {
      "rows": _vm.rows,
      "columns": _vm.columns,
      "striped": _vm.striped,
      "editable": _vm.editable,
      "line-numbers": _vm.lineNumbers,
      "aggregated": _vm.aggregated,
      "grouping-columns": _vm.groupingColumnIds,
      "margin": _vm.lineColumnWidth,
      "message": _vm.message
    }
  })], 1)])]), _vm._v(" "), (_vm.aggregated) ? _c('tfoot', {
    staticClass: "datatable-aggregators"
  }, [_c('tr', [_c('td', {
    staticClass: "datatable-info-cell",
    attrs: {
      "colspan": _vm.columnSpan
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _vm._l((_vm.aggregators), function(aggregator, index) {
    return _c('tr', {
      key: aggregator.label
    }, [(_vm.lineNumbers) ? _c('td', {
      staticClass: "datatable-linenumber-cell"
    }, [_vm._v(_vm._s(index + 1))]) : _vm._e(), _vm._v(" "), (_vm.aggregated) ? _c('td', {
      staticClass: "datatable-aggregate-cell"
    }, [_vm._v(_vm._s(aggregator.label))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.columns), function(column) {
      return _c('td', {
        style: (column.columnStyles)
      }, [_vm._v(_vm._s(_vm.aggregate(column, aggregator)))])
    })], 2)
  })], 2) : _vm._e()], 1), _vm._v(" "), (_vm.filterable) ? _c('div', {
    staticClass: "datatable-options",
    attrs: {
      "layout": "row center-justify"
    }
  }, [(_vm.optimize) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.filter),
      expression: "filter",
      modifiers: {
        "lazy": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "Filter this dataset. Press enter to search...",
      "self": "size-x1"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "change": function($event) {
        _vm.filter = $event.target.value
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Filter this dataset...",
      "self": "size-x1"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 2123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home",
    class: _vm.theme,
    attrs: {
      "id": "services-page"
    }
  }, [_c('nav-bar'), _vm._v(" "), _c('swiper', {
    ref: "mySwiper6",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticStyle: {
      "height": "100%",
      "background-image": "url('../assets/img/p1.jpg')",
      "background-size": "cover",
      "background-repeat": "no-repeat"
    }
  }, [_c('div', {
    staticClass: "slide-center"
  }, [_c('h1', {
    staticClass: "page__title-white"
  }, [_vm._v(_vm._s(_vm.$t('Philosophy')))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "page",
    attrs: {
      "id": "quote-form"
    }
  }, [_c('h1', {
    staticClass: "page__title"
  }, [_vm._v(_vm._s(_vm.$t('Philosophy')))]), _vm._v(" "), _c('hr', {
    staticClass: "page__hr"
  }), _vm._v("\n\n\n\t\t" + _vm._s(_vm.$t('Philosophy_text_01')) + ".\n\n\t\t" + _vm._s(_vm.$t('Philosophy_text_02')) + ":\n\n\n\t\t"), _c('ul', [_c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('Professionalism')))])]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('Innovation')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('Technology')))]), _vm._v(".\n\t\t\t" + _vm._s(_vm.$t('Philosophy_text_03')) + ".\n\t\t\t")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('Independence')))]), _vm._v(".\n\t\t\t" + _vm._s(_vm.$t('Philosophy_text_04')) + ".\n\t\t\t")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('Trust')))]), _vm._v(".")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('Adaptability')))]), _vm._v(".")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('Commitment')))]), _vm._v(".\n\t\t\t" + _vm._s(_vm.$t('Philosophy_text_05')) + ".\n\t\t\t")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('Quality')))]), _vm._v(".\n\t\t\t" + _vm._s(_vm.$t('Philosophy_text_06')) + ".\n\t\t\t")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('Rigor')))]), _vm._v(".\n\t\t\t" + _vm._s(_vm.$t('Philosophy_text_07')) + ".\n\t\t\t")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('Transparency')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('Assurance')))]), _vm._v(".\n\t\t\t" + _vm._s(_vm.$t('Philosophy_text_08')) + ".\n\t\t\t")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('Teamwork')))]), _vm._v(".")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('Professional_ethics')))]), _vm._v(".")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('Experience')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('Security')))]), _vm._v(".\n\t\t\t" + _vm._s(_vm.$t('Philosophy_text_09')) + ".\n\n\n\n\t\t\t")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('Confidentiality')))]), _vm._v(".\n\t\t\t" + _vm._s(_vm.$t('Philosophy_text_10')) + ".\n\t\t\t")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('Internal_regulation')))]), _vm._v(".\n\t\t\t" + _vm._s(_vm.$t('Philosophy_text_11')) + ".\n\t\t\t")])])]), _vm._v(" "), _c('logo-bar'), _vm._v(" "), _c('footer-bar')], 1)
},staticRenderFns: []}

/***/ }),
/* 2124 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home__nav2"
  }, [_c('div', {
    staticClass: "home__container nav"
  }, [_c('div'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "dropdown"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'services'
      }
    }
  }, [_c('button', {
    staticClass: "dropbtn"
  }, [_vm._v(_vm._s(_vm.$t('Services')))])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-content"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'services'
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Services')))])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dropdown"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'pricing'
      }
    }
  }, [_c('button', {
    staticClass: "dropbtn"
  }, [_vm._v(_vm._s(_vm.$t('Pricing')))])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-content"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'pricing'
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Pricing')))])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'quote-request'
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Quote_request')))])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dropdown"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'about'
      }
    }
  }, [_c('button', {
    staticClass: "dropbtn"
  }, [_vm._v(_vm._s(_vm.$t('The_company')))])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-content"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'about'
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('About_us')))])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'our-clients'
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Our_clients')))])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'philosophy'
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Philosophy')))])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'customer-service'
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Customer_Service')))])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dropdown"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'contact'
      }
    }
  }, [_c('button', {
    staticClass: "dropbtn"
  }, [_vm._v(_vm._s(_vm.$t('Contact')))])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-content"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'contact'
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Contact')))])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dropdown"
  }, [_c('button', {
    staticClass: "dropbtn"
  }, [_vm._v(_vm._s(_vm.$t('Language')))]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-content"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.setLanguage('ca')
      }
    }
  }, [_vm._v("Català")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.setLanguage('es')
      }
    }
  }, [_vm._v("Castellano")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.setLanguage('en')
      }
    }
  }, [_vm._v("English")])])])])])])
},staticRenderFns: []}

/***/ }),
/* 2125 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "marketstudies-index"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "bdefilesOpen": _vm.bdefilesOpen
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('BDE_files_index')))]), _vm._v(" "), _c('vue-tabs', [_c('v-tab', {
      attrs: {
        "title": _vm.bdefiles_index_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('BDE_files')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('ul', _vm._l((this.bdefiles_by_years), function(value, key) {
      return _c('li', {
        staticClass: "listlink",
        on: {
          "click": function($event) {
            _vm.openFilesFromYear(key)
          }
        }
      }, [_vm._v(" " + _vm._s(key) + "\n\t\t\t\t\t\t\t\t\t\t\t\t")])
    }))])])])])])])], 1), _vm._v(" "), _c('bar')], 1)], 1)]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 2126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "supervisors-index"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "filesOpen": _vm.filesOpen,
        "fileOpen": _vm.fileOpen,
        "reportOpen": _vm.reportOpen
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('Supervisors_Index')))]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCreateNewSupervisor($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus-circle",
        "text": _vm.new_supervisor_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell",
      attrs: {
        "layout": "row"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.customers.filter),
        expression: "customers.filter"
      }],
      attrs: {
        "type": "text",
        "placeholder": _vm.filter_placeholder,
        "self": "size-x1",
        "data-intro": "You can filter the data in a datatable by typing in any of the filter fields",
        "data-step": "9",
        "data-position": "top"
      },
      domProps: {
        "value": (_vm.customers.filter)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.customers.filter = $event.target.value
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('paginator', {
      attrs: {
        "source": _vm.supervisors_to_array(_vm.supervisors),
        "page-size": 10,
        "filter": _vm.customers.filter,
        "data-intro": "Use the paginator to page data for easier viewing",
        "data-step": "10",
        "data-position": "top"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(page) {
          return [_c('datatable', {
            attrs: {
              "id": "data-table-main",
              "source": page.data,
              "filterable": false,
              "striped": _vm.customers.striped,
              "editable": _vm.customers.editable,
              "line-numbers": _vm.customers.lineNumbers
            },
            scopedSlots: _vm._u([{
              key: "actions",
              fn: function(cell) {
                return [_c('a', {
                  staticStyle: {
                    "margin-right": "2rem",
                    "cursor": "pointer"
                  },
                  on: {
                    "click": function($event) {
                      _vm.editSupervisor(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "pencil",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1), _vm._v(" "), _c('a', {
                  staticStyle: {
                    "cursor": "pointer"
                  },
                  on: {
                    "click": function($event) {
                      _vm.deleteSupervisor(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "trash-o",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1)]
              }
            }])
          }, [_vm._l((_vm.customers.columns), function(column) {
            return _c('datatable-column', {
              attrs: {
                "id": column.id,
                "label": column.label,
                "width": column.width,
                "sortable": column.sortable,
                "groupable": column.groupable,
                "formatter": column.formatter
              }
            })
          }), _vm._v(" "), _c('datatable-column', {
            attrs: {
              "id": "actions",
              "label": "Actions",
              "sortable": false,
              "groupable": false
            }
          })], 2)]
        }
      }])
    })], 1)])], 1)], 1)]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 2127 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "entities-index"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "filesOpen": _vm.filesOpen,
        "fileOpen": _vm.fileOpen,
        "reportOpen": _vm.reportOpen
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('Entities_Index')))]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCreateNewEntity($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus-circle",
        "text": _vm.new_entity_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell",
      attrs: {
        "layout": "row"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.entities_table.filter),
        expression: "entities_table.filter"
      }],
      attrs: {
        "type": "text",
        "placeholder": _vm.filter_placeholder,
        "self": "size-x1",
        "data-intro": "You can filter the data in a datatable by typing in any of the filter fields",
        "data-step": "9",
        "data-position": "top"
      },
      domProps: {
        "value": (_vm.entities_table.filter)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.entities_table.filter = $event.target.value
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('paginator', {
      attrs: {
        "source": _vm.object_to_array(_vm.entities),
        "page-size": 15,
        "filter": _vm.entities_table.filter,
        "data-intro": "Use the paginator to page data for easier viewing",
        "data-step": "10",
        "data-position": "top"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(page) {
          return [_c('datatable', {
            attrs: {
              "id": "data-table-main",
              "source": page.data,
              "filterable": false,
              "striped": _vm.entities_table.striped,
              "editable": _vm.entities_table.editable,
              "line-numbers": _vm.entities_table.lineNumbers
            },
            scopedSlots: _vm._u([{
              key: "actions",
              fn: function(cell) {
                return [_c('a', {
                  staticStyle: {
                    "margin-right": "2rem",
                    "cursor": "pointer"
                  },
                  on: {
                    "click": function($event) {
                      _vm.editEntity(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "pencil",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1), _vm._v(" "), _c('a', {
                  staticStyle: {
                    "cursor": "pointer"
                  },
                  on: {
                    "click": function($event) {
                      _vm.deleteEntity(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "trash-o",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1)]
              }
            }])
          }, [_vm._l((_vm.entities_table.columns), function(column) {
            return _c('datatable-column', {
              attrs: {
                "id": column.id,
                "label": column.label,
                "width": column.width,
                "sortable": column.sortable,
                "groupable": column.groupable,
                "formatter": column.formatter
              }
            })
          }), _vm._v(" "), _c('datatable-column', {
            attrs: {
              "id": "actions",
              "label": "Actions",
              "sortable": false,
              "groupable": false
            }
          })], 2)]
        }
      }])
    })], 1)])], 1)], 1)]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 2128 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    directives: [{
      name: "drag",
      rawName: "v-drag:start",
      value: (_vm.dragStart),
      expression: "dragStart",
      arg: "start"
    }],
    style: (_vm.columnStyles),
    attrs: {
      "title": "Click to sort. Drag to center to group."
    },
    on: {
      "click": _vm.sort
    }
  }, [_c('div', {
    staticClass: "datatable-column",
    attrs: {
      "layout": _vm.columnLayout
    }
  }, [_c('div', [_vm._t("default", [_vm._v(_vm._s(_vm.label || _vm.id))])], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sorting),
      expression: "sorting"
    }],
    staticClass: "datatable-sort-arrow",
    class: _vm.sortArrowClass
  })])])
},staticRenderFns: []}

/***/ }),
/* 2129 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "cessionannex-editor"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "filesOpen": _vm.filesOpen,
        "fileOpen": _vm.fileOpen,
        "reportOpen": _vm.reportOpen
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [_c('span', [_vm._v(_vm._s(_vm.$t('Annex')) + " \"" + _vm._s(_vm.cessionannex.filename) + "\"")]), (_vm.cessionannex.dirty) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.cessionannex.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "datedata"
    }, [_c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Created')) + ": " + _vm._s(_vm.millis_to_time(_vm.cessionannex.date_created)))]), _vm._v(" "), _c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Last_modified')) + ": " + _vm._s(_vm.millis_to_time(_vm.cessionannex.date_modified)))])]), _vm._v(" "), _c('vue-tabs', [_c('v-tab', {
      attrs: {
        "title": _vm.data_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('div', {
      staticClass: "field-container"
    }, [(_vm.cessionannex.url) ? _c('div', [_c('img', {
      attrs: {
        "src": _vm.cessionannex.url,
        "width": "600px",
        "height": "auto"
      }
    })]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('File_name')) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('File_name')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.cessionannex.filename))])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Image_footer')) + " ")]), _vm._v(" "), (_vm.cessionannex.name_ca || _vm.currentLocale === 'ca') ? _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Image_footer')) + " " + _vm._s(_vm.$t('in')) + " " + _vm._s(_vm.$t('Catalan')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.cessionannex.name_ca),
        expression: "cessionannex.name_ca"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.cessionannex.name_ca)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.cessionannex.name_ca = $event.target.value
        }, _vm.set_cessionannex_name_ca]
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.cessionannex.name_en || _vm.currentLocale === 'en') ? _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Image_footer')) + " " + _vm._s(_vm.$t('in')) + " " + _vm._s(_vm.$t('English')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.cessionannex.name_en),
        expression: "cessionannex.name_en"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.cessionannex.name_en)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.cessionannex.name_en = $event.target.value
        }, _vm.set_cessionannex_name_en]
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.cessionannex.name_es || _vm.currentLocale === 'es') ? _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Image_footer')) + " " + _vm._s(_vm.$t('in')) + " " + _vm._s(_vm.$t('Spanish')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.cessionannex.name_es),
        expression: "cessionannex.name_es"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.cessionannex.name_es)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.cessionannex.name_es = $event.target.value
        }, _vm.set_cessionannex_name_es]
      }
    })])]) : _vm._e()])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.metadata_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('form', {
      staticClass: "bt-form"
    })])])], 1), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUp($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "chevron-left",
        "text": _vm.goup_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentCessionAnnex({
            go_up: false
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentCessionAnnex({
            go_up: true
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_and_go_up_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), (_vm.cessionannex.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e()], 1)], 1)]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 2130 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "marketstudies-index"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "realestatesOpen": _vm.realestatesOpen
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('Real_estates_index')))]), _vm._v(" "), _c('vue-tabs', [_c('v-tab', {
      attrs: {
        "title": _vm.realestates_index_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCreateNewRealEstate($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus-circle",
        "text": _vm.new_real_estate_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell",
      attrs: {
        "layout": "row"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate_table.filter),
        expression: "realestate_table.filter"
      }],
      attrs: {
        "type": "text",
        "placeholder": _vm.filter_placeholder,
        "self": "size-x1",
        "data-intro": "You can filter the data in a datatable by typing in any of the filter fields",
        "data-step": "9",
        "data-position": "top"
      },
      domProps: {
        "value": (_vm.realestate_table.filter)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate_table.filter = $event.target.value
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('paginator', {
      attrs: {
        "source": _vm._.orderBy(_vm.object_to_array(_vm.realestates), ['date_modified'], ['desc']),
        "page-size": 50,
        "filter": _vm.realestate_table.filter,
        "data-intro": "Use the paginator to page data for easier viewing",
        "data-step": "50",
        "data-position": "top"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(page) {
          return [_c('datatable', {
            attrs: {
              "id": "data-table-main",
              "source": page.data,
              "filterable": false,
              "striped": _vm.realestate_table.striped,
              "editable": _vm.realestate_table.editable,
              "line-numbers": _vm.realestate_table.lineNumbers
            },
            scopedSlots: _vm._u([{
              key: "address",
              fn: function(cell) {
                return [_c('div', [_c('span', {
                  staticClass: "navspan",
                  on: {
                    "click": function($event) {
                      $event.preventDefault();
                      _vm.editRealEstate(cell.row)
                    }
                  }
                }, [(cell.row['street_name']) ? _c('span', [_vm._v(_vm._s(cell.row['street_name']))]) : _vm._e(), (cell.row['street_number']) ? _c('span', [_vm._v(", " + _vm._s(cell.row['street_number']))]) : _vm._e(), (cell.row['floor']) ? _c('span', [_vm._v(", " + _vm._s(cell.row['floor']))]) : _vm._e(), (cell.row['door']) ? _c('span', [_vm._v("-" + _vm._s(cell.row['door']))]) : _vm._e(), (cell.row['staircase']) ? _c('span', [_vm._v(", esc. " + _vm._s(cell.row['staircase']))]) : _vm._e(), (cell.row['block']) ? _c('span', [_vm._v(", blo. " + _vm._s(cell.row['block']))]) : _vm._e(), (cell.row['postal_code']) ? _c('span', [_vm._v(", " + _vm._s(cell.row['postal_code']))]) : _vm._e(), (cell.row['municipality']) ? _c('span', [_vm._v(", " + _vm._s(cell.row['municipality'].name_ine))]) : _vm._e()])])]
              }
            }, {
              key: "appraisalfiles",
              fn: function(cell) {
                return [_c('div', _vm._l((cell.row['appraisalfiles']), function(val, key) {
                  return _c('span', [_c('span', {
                    staticClass: "navspan",
                    on: {
                      "click": function($event) {
                        $event.preventDefault();
                        _vm.goToFile(key)
                      }
                    }
                  }, [_vm._v(_vm._s(val))])])
                }))]
              }
            }, {
              key: "actions",
              fn: function(cell) {
                return [_c('a', {
                  staticStyle: {
                    "margin-right": "2rem",
                    "cursor": "pointer"
                  },
                  on: {
                    "click": function($event) {
                      _vm.editRealEstate(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "pencil",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1)]
              }
            }])
          }, [_vm._l((_vm.realestate_table.columns), function(column) {
            return _c('datatable-column', {
              attrs: {
                "id": column.id,
                "label": column.label,
                "width": column.width,
                "sortable": column.sortable,
                "groupable": column.groupable,
                "formatter": column.formatter
              }
            })
          }), _vm._v(" "), _c('datatable-column', {
            attrs: {
              "id": "actions",
              "label": "Actions",
              "sortable": false,
              "groupable": false
            }
          })], 2)]
        }
      }])
    })], 1)])])])], 1)], 1)], 1)]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 2131 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "becprice-editor"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "filesOpen": _vm.filesOpen,
        "fileOpen": _vm.fileOpen,
        "reportOpen": _vm.reportOpen
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [_vm._v("B.E.C. nº " + _vm._s(_vm.becprice.number) + ", " + _vm._s(_vm.becprice.year) + " T" + _vm._s(_vm.becprice.quarter)), (_vm.becprice.dirty) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('h2', [(_vm.currentLocale === 'ca') ? _c('span', [_vm._v(_vm._s(_vm.becproperty.name_ca))]) : (_vm.currentLocale === 'en') ? _c('span', [_vm._v(_vm._s(_vm.becproperty.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.becproperty.name_es))])]), _vm._v(" "), (_vm.becprice.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "datedata"
    }, [_c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Created')) + ": " + _vm._s(_vm.millis_to_time(_vm.becprice.date_created)))]), _vm._v(" "), _c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Last_modified')) + ": " + _vm._s(_vm.millis_to_time(_vm.becprice.date_modified)))])]), _vm._v(" "), _c('vue-tabs', [_c('v-tab', {
      attrs: {
        "title": _vm.data_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Data')) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Number')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.number),
        expression: "becprice.number"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.number)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.number = $event.target.value
        }, _vm.set_becprice_number],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Year')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.year),
        expression: "becprice.year"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.year)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.year = $event.target.value
        }, _vm.set_becprice_year],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Quarter')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.quarter),
        expression: "becprice.quarter"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.quarter)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.quarter = $event.target.value
        }, _vm.set_becprice_quarter],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Prices')) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {}, [_c('table', {
      staticClass: "table-striped",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', {
      staticStyle: {
        "min-width": "120px"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Price')) + " (€/m²)\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Movimiento tierras")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.movimiento_tierras),
        expression: "becprice.movimiento_tierras"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.movimiento_tierras)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.movimiento_tierras = $event.target.value
        }, _vm.set_becprice_movimiento_tierras],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Cimentación y muro sótano")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.cimentacion_y_muro_sotano),
        expression: "becprice.cimentacion_y_muro_sotano"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.cimentacion_y_muro_sotano)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.cimentacion_y_muro_sotano = $event.target.value
        }, _vm.set_becprice_cimentacion_y_muro_sotano],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Estructura")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.estructura),
        expression: "becprice.estructura"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.estructura)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.estructura = $event.target.value
        }, _vm.set_becprice_estructura],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Saneamiento (horizontal y vertical)")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.saneamiento),
        expression: "becprice.saneamiento"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.saneamiento)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.saneamiento = $event.target.value
        }, _vm.set_becprice_saneamiento],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Albañilería gruesa")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.albanileria_gruesa),
        expression: "becprice.albanileria_gruesa"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.albanileria_gruesa)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.albanileria_gruesa = $event.target.value
        }, _vm.set_becprice_albanileria_gruesa],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Albañilería, azoteas e impermeabilización")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.albanileria_azoteas),
        expression: "becprice.albanileria_azoteas"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.albanileria_azoteas)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.albanileria_azoteas = $event.target.value
        }, _vm.set_becprice_albanileria_azoteas],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Albañilería, acabados de fachada")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.albanileria_acabados_fachada),
        expression: "becprice.albanileria_acabados_fachada"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.albanileria_acabados_fachada)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.albanileria_acabados_fachada = $event.target.value
        }, _vm.set_becprice_albanileria_acabados_fachada],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Albañilería, solados")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.albanileria_solados),
        expression: "becprice.albanileria_solados"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.albanileria_solados)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.albanileria_solados = $event.target.value
        }, _vm.set_becprice_albanileria_solados],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Albañilería, acabados interiores")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.albanileria_acabados_interiores),
        expression: "becprice.albanileria_acabados_interiores"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.albanileria_acabados_interiores)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.albanileria_acabados_interiores = $event.target.value
        }, _vm.set_becprice_albanileria_acabados_interiores],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Albañilería, ayudas a industriales")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.albanileria_ayudas_industriales),
        expression: "becprice.albanileria_ayudas_industriales"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.albanileria_ayudas_industriales)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.albanileria_ayudas_industriales = $event.target.value
        }, _vm.set_becprice_albanileria_ayudas_industriales],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Yesería cielosrasos")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.yeseria_cielosrasos),
        expression: "becprice.yeseria_cielosrasos"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.yeseria_cielosrasos)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.yeseria_cielosrasos = $event.target.value
        }, _vm.set_becprice_yeseria_cielosrasos],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Cerrajería")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.cerrajeria),
        expression: "becprice.cerrajeria"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.cerrajeria)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.cerrajeria = $event.target.value
        }, _vm.set_becprice_cerrajeria],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Carpintería exterior")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.carpinteria_exterior),
        expression: "becprice.carpinteria_exterior"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.carpinteria_exterior)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.carpinteria_exterior = $event.target.value
        }, _vm.set_becprice_carpinteria_exterior],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Carpintería interior")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.carpinteria_interior),
        expression: "becprice.carpinteria_interior"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.carpinteria_interior)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.carpinteria_interior = $event.target.value
        }, _vm.set_becprice_carpinteria_interior],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Persianas")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.persianas),
        expression: "becprice.persianas"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.persianas)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.persianas = $event.target.value
        }, _vm.set_becprice_persianas],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Fontanería")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.fontaneria),
        expression: "becprice.fontaneria"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.fontaneria)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.fontaneria = $event.target.value
        }, _vm.set_becprice_fontaneria],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Material sanitario grifería")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.mat_sanitario_griferia),
        expression: "becprice.mat_sanitario_griferia"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.mat_sanitario_griferia)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.mat_sanitario_griferia = $event.target.value
        }, _vm.set_becprice_mat_sanitario_griferia],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Electricidad")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.electricidad),
        expression: "becprice.electricidad"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.electricidad)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.electricidad = $event.target.value
        }, _vm.set_becprice_electricidad],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Aire acondicionado")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.aire_acondicionado),
        expression: "becprice.aire_acondicionado"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.aire_acondicionado)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.aire_acondicionado = $event.target.value
        }, _vm.set_becprice_aire_acondicionado],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Instalaciones especiales")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.instal_especiales),
        expression: "becprice.instal_especiales"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.instal_especiales)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.instal_especiales = $event.target.value
        }, _vm.set_becprice_instal_especiales],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Fumistería y muebles cocina")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.fumisteria_y_muebles_cocina),
        expression: "becprice.fumisteria_y_muebles_cocina"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.fumisteria_y_muebles_cocina)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.fumisteria_y_muebles_cocina = $event.target.value
        }, _vm.set_becprice_fumisteria_y_muebles_cocina],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Ascensores")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.ascensores),
        expression: "becprice.ascensores"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.ascensores)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.ascensores = $event.target.value
        }, _vm.set_becprice_ascensores],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Vidrieria")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.vidrieria),
        expression: "becprice.vidrieria"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.vidrieria)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.vidrieria = $event.target.value
        }, _vm.set_becprice_vidrieria],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Pintura y estucos")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.pintura_y_estucos),
        expression: "becprice.pintura_y_estucos"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.pintura_y_estucos)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.pintura_y_estucos = $event.target.value
        }, _vm.set_becprice_pintura_y_estucos],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Calefacción")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.calefaccion),
        expression: "becprice.calefaccion"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.calefaccion)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.calefaccion = $event.target.value
        }, _vm.set_becprice_calefaccion],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Energía solar a.c.s.")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.energia_solar_acs),
        expression: "becprice.energia_solar_acs"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.energia_solar_acs)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.energia_solar_acs = $event.target.value
        }, _vm.set_becprice_energia_solar_acs],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Jardinería decorativa")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.jardineria_decorativa),
        expression: "becprice.jardineria_decorativa"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.jardineria_decorativa)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.jardineria_decorativa = $event.target.value
        }, _vm.set_becprice_jardineria_decorativa],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Renovación de aire")])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprice.renovacion_aire),
        expression: "becprice.renovacion_aire"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becprice.renovacion_aire)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becprice.renovacion_aire = $event.target.value
        }, _vm.set_becprice_renovacion_aire],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Subtotal")])]), _vm._v(" "), _c('td', [_c('strong', [_c('span', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.becprice.subtotal)) + " €/m²")])])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Seguridad y salud (2%)")])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.becprice.seguridad_y_salud)) + " €/m²")])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v("Total")])]), _vm._v(" "), _c('td', [_c('strong', [_c('span', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.becprice.total)) + " €/m²")])])])])])])])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.metadata_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('form', {
      staticClass: "bt-form"
    })])])], 1), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUp($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "chevron-left",
        "text": _vm.goup_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentBecProperty({
            go_up: false
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentBecProperty({
            go_up: true
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_and_go_up_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), (_vm.becprice.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e()], 1)], 1)]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 2132 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "becproperties-index"
    }
  }, [(_vm.loading) ? _c('spinner') : [_c('side-nav-bar', {
    attrs: {
      "fileOpen": _vm.fileOpen
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "app-container"
  }, [_c('bar'), _vm._v(" "), _c('h1', [_c('span', [_vm._v(_vm._s(_vm.$t('Construction_prices')))])]), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "width": "fit-content",
      "margin-left": "auto"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onCreateNewBecProperty($event)
      }
    }
  }, [_c('icon-button', {
    attrs: {
      "icon": "plus-circle",
      "text": _vm.new_becproperty_button_text,
      "icon_color": "black",
      "text_color": "black",
      "border_color": "lightgray"
    }
  })], 1)]), _vm._v(" "), _c('div', [_c('form', {
    staticClass: "bt-form"
  }, [_c('div', {
    staticClass: "form-section"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Property_types')))]), _vm._v(" "), (_vm._.size(_vm.becproperties) > 0) ? _c('div', [_c('div', {
    staticClass: "grid-row",
    attrs: {
      "layout": "row top-stretch"
    }
  }, [_c('div', {
    staticClass: "grid-cell",
    attrs: {
      "layout": "row"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.becproperties_table.filter),
      expression: "becproperties_table.filter"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.filter_placeholder,
      "self": "size-x1",
      "data-intro": "You can filter the data in a datatable by typing in any of the filter fields",
      "data-step": "9",
      "data-position": "top"
    },
    domProps: {
      "value": (_vm.becproperties_table.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.becproperties_table.filter = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "grid-row",
    attrs: {
      "layout": "row top-stretch"
    }
  }, [_c('div', {
    staticClass: "grid-cell"
  }, [_c('paginator', {
    attrs: {
      "source": this.object_to_array(_vm.becproperties),
      "page-size": 20,
      "filter": _vm.becproperties_table.filter,
      "data-intro": "Use the paginator to page data for easier viewing",
      "data-step": "10",
      "data-position": "top"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(page) {
        return [_c('datatable', {
          attrs: {
            "id": "data-table-becproperties",
            "source": page.data,
            "filterable": false,
            "striped": _vm.becproperties_table.striped,
            "editable": _vm.becproperties_table.editable,
            "line-numbers": _vm.becproperties_table.lineNumbers
          },
          scopedSlots: _vm._u([{
            key: "actions-becproperties",
            fn: function(cell) {
              return [_c('table', {
                staticClass: "actions-table"
              }, [_c('tr', [_c('td', [_c('a', {
                staticStyle: {
                  "cursor": "pointer"
                },
                attrs: {
                  "title": _vm.edit_text
                },
                on: {
                  "click": function($event) {
                    _vm.editBecProperty(cell.row)
                  }
                }
              }, [_c('icon', {
                attrs: {
                  "name": "pencil",
                  "scale": "1",
                  "color": "gray"
                }
              })], 1)]), _vm._v(" "), _c('td', [_c('a', {
                staticStyle: {
                  "cursor": "pointer"
                },
                attrs: {
                  "title": _vm.duplicate_text
                },
                on: {
                  "click": function($event) {
                    _vm.duplicateBecProperty(cell.row)
                  }
                }
              }, [_c('icon', {
                attrs: {
                  "name": "files-o",
                  "scale": "1",
                  "color": "gray"
                }
              })], 1)]), _vm._v(" "), _c('td', [_c('a', {
                staticStyle: {
                  "cursor": "pointer"
                },
                attrs: {
                  "title": _vm.delete_text
                },
                on: {
                  "click": function($event) {
                    _vm.deleteBecProperty(cell.row)
                  }
                }
              }, [_c('icon', {
                attrs: {
                  "name": "trash-o",
                  "scale": "1",
                  "color": "gray"
                }
              })], 1)])])])]
            }
          }])
        }, [_vm._l((_vm.becproperties_table.columns), function(column) {
          return _c('datatable-column', {
            attrs: {
              "id": column.id,
              "label": column.label,
              "width": column.width,
              "sortable": column.sortable,
              "groupable": column.groupable,
              "formatter": column.formatter
            }
          })
        }), _vm._v(" "), _c('datatable-column', {
          attrs: {
            "id": "actions-becproperties",
            "label": _vm.actions_text,
            "sortable": false,
            "groupable": false
          }
        })], 2)]
      }
    }])
  })], 1)])]) : _vm._e()])])])], 1)]], 2)
},staticRenderFns: []}

/***/ }),
/* 2133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home",
    class: _vm.theme,
    attrs: {
      "id": "main"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1131),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("Bonell+Dòriga receives the Lisbon Triennale Millennium bcp Début Award 2019!")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1130),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1809 | Argia. A Model for the Exhibition \"MIRABILIA Interpretations of Italo Calvino's Invisible Cities")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1129),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1809 | Argia. A Model for the Exhibition \"MIRABILIA Interpretations of Italo Calvino's Invisible Cities")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1128),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1804 | Galeria. A Drawing for the Exhibition \"Documents (To Come)\"")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('picture', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    }
  }, [_c('source', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "media": "(max-width: 1999px)",
      "srcset": "../assets/img/1708_lq.jpg"
    }
  }), _vm._v(" "), _c('source', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "media": "(min-width: 2000px)",
      "srcset": "../assets/img/1708.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1127),
      "alt": "Bonell+Dòriga"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1708 | Our Workspace. A Drawing for the Publication \"Carnets\"")])], 1)]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1126),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1706 | DGZ Dallwigk. Competition for a new Digital Center in Ingolstadt, First Prize (with Bonell i Gil & the ARGE Falk von Tettenborn & GINA Barcelona architects)\n\t\t\t\t\t, )")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1125),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1701 | Ground Control. Competition for the new Headquarters of a Media Company")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1124),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1701 | Ground Control. Competition for the new Headquarters of a Media Company")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1123),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1701 | Ground Control. Competition for the new Headquarters of a Media Company")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1122),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1701 | Ground Control. Competition for the new Headquarters of a Media Company")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1121),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1701 | Ground Control. Competition for the new Headquarters of a Media Company")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1120),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1701 | Ground Control. Competition for the new Headquarters of a Media Company")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1119),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1612 | LOGMA. Competition in Málaga (in association with MHAP)")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1118),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1612 | LOGMA. Competition in Málaga (in association with MHAP)")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1117),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1611 | A Series of Rooms. A Collection of Domestic Spaces --> "), _c('a', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "href": "https://www.aseriesofrooms.com",
      "target": "_blank"
    }
  }, [_vm._v("HERE")])])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1116),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1610 | Castellar. Renovation of a Housing Building")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1115),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1609 | Ordinary Floorplans. Contribution to Cartha's \"Issue II - The Architecture of the City. A Palimpsest\"")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1114),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1608 | Sydhavnen. Competition for a New Church in Copenhagen")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1113),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1606 | Bertran II. A Garden")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1112),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1606 | Bertran II. A Garden")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1111),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1606 | Bertran II. A Garden")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1110),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1605 | Comte Borrell. Renovation of an apartment")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1109),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1605 | Comte Borrell. Renovation of an apartment")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1108),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1605 | Comte Borrell. Renovation of an apartment")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1107),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1605 | Comte Borrell. Renovation of an apartment")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1106),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1605 | Comte Borrell. Renovation of an apartment")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1105),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1605 | Comte Borrell. Renovation of an apartment")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1104),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1605 | Comte Borrell. Renovation of an apartment")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1103),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1602 | Llur Table")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1102),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1602 | Llur Table")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1101),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1602 | Llur Table")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1100),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1602 | Llur Table")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1099),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1602 | Llur Table")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1098),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1602 | Llur Table")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1097),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1601 | Bertran I. Renovation of an apartment")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1096),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1601 | Bertran I. Renovation of an apartment")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1095),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1601 | Bertran I. Renovation of an apartment")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1094),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1512 | Madrazo. Renovation of an apartment")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1093),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("P1512 | Madrazo. Renovation of an apartment")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1092),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1512 | Madrazo. Renovation of an apartment")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1091),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1512 | Madrazo. Renovation of an apartment")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1090),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1506 | I am a Treasure. Competition for an Exhibition Space and Landscape Project in Warsaw, Special Mention")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1089),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1506 | I am a Treasure. Competition for an Exhibition Space and Landscape Project in Warsaw, Special Mention")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1088),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1506 | I am a Treasure. Competition for an Exhibition Space and Landscape Project in Warsaw, Special Mention")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1087),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1506 | I am a Treasure. Competition for an Exhibition Space and Landscape Project in Warsaw, Special Mention")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1086),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1506 | I am a Treasure. Competition for an Exhibition Space and Landscape Project in Warsaw, Special Mention")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1085),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1501 | Appenzellerhaus. Housing Competition (in association with Carla Ferrando and Pablo Garrido)")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1084),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1414 | Galeria Eixample")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1083),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1414 | Galeria Eixample")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1082),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1414 | Galeria Eixample")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1081),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1414 | Galeria Eixample")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1080),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1414 | Galeria Eixample")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1079),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1411 | Loire-et-Loges. Competition, Special Mention")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1078),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1410 | Sessay. Competition")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1077),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1408 | La musa inquiteante. Mannequin for a scarves shop")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1076),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1406 | Tuset Street. Renovation of an Office Space")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1075),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1403 | Pfefferkuchenhaus. Competition for a School in St Moritz")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1074),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1403 | Pfefferkuchenhaus. Competition for a School in St Moritz")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1073),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1403 | Pfefferkuchenhaus. Competition for a School in St Moritz")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1072),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1303 | Plaça Reial Daurada. Competition, Extraordinary Prize")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1071),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1201 | Rosselló. Renovation of an apartment")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1070),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1201 | Rosselló. Renovation of an apartment")])])]), _vm._v(" "), _c('swiper-slide', [_c('div', [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "100vh"
    },
    attrs: {
      "src": __webpack_require__(1069),
      "alt": "Bonell+Dòriga"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottomcenterdiv"
  }, [_vm._v("1201 | Rosselló. Renovation of an apartment")])])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev",
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    slot: "button-next"
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topleftdiv"
  }, [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "40px"
    },
    attrs: {
      "src": __webpack_require__(1133),
      "alt": "Bonell+Dòriga"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toprightdiv"
  }, [_vm._v("office@bonelldoriga.com"), _c('br'), _c('a', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "href": "https://www.instagram.com/bonelldoriga",
      "target": "_blank"
    }
  }, [_vm._v("@bonelldoriga")])])
}]}

/***/ }),
/* 2134 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "marketstudies-index"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "filesOpen": _vm.filesOpen,
        "fileOpen": _vm.fileOpen,
        "fileId": _vm.appraisalfile.id,
        "fileNumber": _vm.appraisalfile.number,
        "reportOpen": _vm.reportOpen,
        "reportNumber": _vm.appraisalreport.number,
        "versionNumber": _vm.appraisalreport.version,
        "realEstates": _vm.appraisalreport_realestates,
        "realEstateId": _vm.realestate.id,
        "reportId": _vm.appraisalreport.id
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('Market_study_for')) + " "), (_vm.realestate.street_name) ? _c('span', [_vm._v(_vm._s(_vm.realestate.street_name))]) : _vm._e(), (_vm.realestate.street_number) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.street_number))]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v("-" + _vm._s(_vm.realestate.door))]) : _vm._e(), _vm._v(" "), (_vm.marketstudy.dirty) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.marketstudy.market_value && _vm.marketstudy.market_unit_value) ? _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('Market_value')) + ": " + _vm._s(_vm._f("formatNumber")(_vm.marketstudy.market_value)) + " €  (" + _vm._s(_vm._f("formatNumber")(_vm.marketstudy.market_unit_value)) + " €/m²)")])]) : _vm._e(), _vm._v(" "), (_vm.marketstudy.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "datedata"
    }, [_c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Created')) + ": " + _vm._s(_vm.millis_to_time(_vm.marketstudy.date_created)))]), _vm._v(" "), _c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Last_modified')) + ": " + _vm._s(_vm.millis_to_time(_vm.marketstudy.date_modified)))])]), _vm._v(" "), _c('vue-tabs', [_c('v-tab', {
      attrs: {
        "title": _vm.marketstudy_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container",
      staticStyle: {
        "background-color": "#fafafc",
        "padding": "2rem"
      }
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Real_estate_referral')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticStyle: {
        "padding-left": "1.5rem"
      }
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Address')))]), _vm._v(" "), _c('strong', [_c('span', [_vm._v(_vm._s(_vm.realestate.street_name))]), (_vm.realestate.street_number) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.street_number))]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v("-" + _vm._s(_vm.realestate.door))]) : _vm._e(), (_vm.realestate.postal_code) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.postal_code))]) : _vm._e(), (_vm.realestate.municipality) ? _c('span', [_vm._v(" - " + _vm._s(_vm.realestate.municipality.name_ine))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticStyle: {
        "padding-left": "1.5rem"
      }
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Cadastral_reference')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.realestate.cadastral_reference))])])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('button', {
      staticClass: "quote-request__aux__button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onOpenCadastralMap($event)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.onOpenCadastralMap($event)
        }
      }
    }, [_c('span', [_c('icon', {
      attrs: {
        "name": "external-link",
        "scale": "1",
        "color": "rgb(0, 79, 146)"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Open')) + " " + _vm._s(_vm.$t('Cadastral_Map')))], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Property_type')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.appraisal_property_typeValue,
        "options": _vm.property_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": false,
        "selectedLabel": "",
        "selectLabel": "",
        "deselectLabel": ""
      },
      on: {
        "input": _vm.set_appraisal_property_type
      },
      model: {
        value: (_vm.appraisal.property_type),
        callback: function($$v) {
          _vm.appraisal.property_type = $$v
        },
        expression: "appraisal.property_type"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Built_area')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.adopted_area),
        expression: "appraisal.adopted_area"
      }],
      staticClass: "field__group__input",
      staticStyle: {
        "background-color": "white!important"
      },
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.adopted_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.adopted_area = $event.target.value
        }, _vm.set_appraisal_adopted_area_event],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Construction_year')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.construction_year),
        expression: "appraisal.construction_year"
      }],
      staticClass: "field__group__input",
      staticStyle: {
        "background-color": "white!important"
      },
      attrs: {
        "type": "number",
        "maxlength": "4",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.construction_year)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.construction_year = $event.target.value
        }, _vm.set_appraisal_construction_year_event],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Last_renovation_year')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.last_renovation_year),
        expression: "appraisal.last_renovation_year"
      }],
      staticClass: "field__group__input",
      staticStyle: {
        "background-color": "white!important"
      },
      attrs: {
        "type": "number",
        "maxlength": "4",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.last_renovation_year)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.last_renovation_year = $event.target.value
        }, _vm.set_appraisal_last_renovation_year_event],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Adopted_age')) + " (" + _vm._s(_vm.$t('Average')) + ")")]), _vm._v(" "), _c('strong', [_c('span', [_vm._v(_vm._s(_vm.appraisal.adopted_age))])])]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Floor_number')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.floor_number),
        expression: "appraisal.floor_number"
      }],
      staticClass: "field__group__input",
      staticStyle: {
        "background-color": "white!important"
      },
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.floor_number)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.floor_number = $event.target.value
        }, _vm.set_appraisal_floor_number_event],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Quality_of_neighbourhood')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.appraisal_quality_of_neighbourhoodValue,
        "options": _vm.quality_of_neighbourhoodOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": false,
        "selectedLabel": "",
        "selectLabel": "",
        "deselectLabel": ""
      },
      on: {
        "input": _vm.set_appraisal_quality_of_neighbourhood
      },
      model: {
        value: (_vm.appraisal.quality_of_neighbourhood),
        callback: function($$v) {
          _vm.appraisal.quality_of_neighbourhood = $$v
        },
        expression: "appraisal.quality_of_neighbourhood"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Quality_of_situation')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.appraisal_quality_of_situationValue,
        "options": _vm.quality_of_situationOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": false,
        "selectedLabel": "",
        "selectLabel": "",
        "deselectLabel": ""
      },
      on: {
        "input": _vm.set_appraisal_quality_of_situation
      },
      model: {
        value: (_vm.appraisal.quality_of_situation),
        callback: function($$v) {
          _vm.appraisal.quality_of_situation = $$v
        },
        expression: "appraisal.quality_of_situation"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Quality_of_construction')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.appraisal_quality_of_constructionValue,
        "options": _vm.quality_of_constructionOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": false,
        "selectedLabel": "",
        "selectLabel": "",
        "deselectLabel": ""
      },
      on: {
        "input": _vm.set_appraisal_quality_of_construction
      },
      model: {
        value: (_vm.appraisal.quality_of_construction),
        callback: function($$v) {
          _vm.appraisal.quality_of_construction = $$v
        },
        expression: "appraisal.quality_of_construction"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Quality_of_realestate')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.appraisal_quality_of_realestateValue,
        "options": _vm.quality_of_realestateOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": false,
        "selectedLabel": "",
        "selectLabel": "",
        "deselectLabel": ""
      },
      on: {
        "input": _vm.set_appraisal_quality_of_realestate
      },
      model: {
        value: (_vm.appraisal.quality_of_realestate),
        callback: function($$v) {
          _vm.appraisal.quality_of_realestate = $$v
        },
        expression: "appraisal.quality_of_realestate"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Conservation_status')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.appraisal_conservation_statusValue,
        "options": _vm.conservation_statusOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": false,
        "selectedLabel": "",
        "selectLabel": "",
        "deselectLabel": ""
      },
      on: {
        "input": _vm.set_appraisal_conservation_status
      },
      model: {
        value: (_vm.appraisal.conservation_status),
        callback: function($$v) {
          _vm.appraisal.conservation_status = $$v
        },
        expression: "appraisal.conservation_status"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Lift')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.lift),
        expression: "appraisal.lift"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.lift) ? _vm._i(_vm.appraisal.lift, null) > -1 : (_vm.appraisal.lift)
      },
      on: {
        "click": _vm.set_appraisal_lift_event,
        "__c": function($event) {
          var $$a = _vm.appraisal.lift,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.lift = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.lift = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.lift = $$c
          }
        }
      }
    })])]), _vm._v(" "), (!this.appraisal.property_type) ? _c('div', [_c('message', {
      attrs: {
        "text": _vm.property_type_error_text,
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : _vm._e(), _vm._v(" "), (!this.appraisal.adopted_area) ? _c('div', [_c('message', {
      attrs: {
        "text": _vm.adopted_area_error_text,
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : _vm._e(), _vm._v(" "), (!this.appraisal.adopted_age) ? _c('div', [_c('message', {
      attrs: {
        "text": _vm.adopted_age_error_text,
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : _c('div', [(this.appraisal.adopted_age.toString().length < 4) ? _c('div', [_c('message', {
      attrs: {
        "text": _vm.adopted_age_length_error_text,
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : (this.appraisal.adopted_age.toString().length > 4) ? _c('div', [_c('message', {
      attrs: {
        "text": _vm.adopted_age_length_error_text,
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "section-container",
      staticStyle: {
        "background-color": "#fafafc",
        "padding": "2rem"
      }
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Ad_database_query')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Comparable_type')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.queryAdTypeValue,
        "options": _vm.queryAdTypeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ?
          'name_ca' : (_vm.currentLocale === 'en') ?
          'name_en' : 'name_es',
        "searchable": false
      },
      on: {
        "input": _vm.set_marketstudy_query_ad_type
      },
      model: {
        value: (_vm.marketstudy.query_ad_type),
        callback: function($$v) {
          _vm.marketstudy.query_ad_type = $$v
        },
        expression: "marketstudy.query_ad_type"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Advertisements_between_starting_date')) + ":")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.marketstudy.query_startdate),
        expression: "marketstudy.query_startdate"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "date",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.marketstudy.query_startdate)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.marketstudy.query_startdate = $event.target.value
        }, _vm.set_marketstudy_query_startdate]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('and_limit_date')) + ":")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.marketstudy.query_limitdate),
        expression: "marketstudy.query_limitdate"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "date",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.marketstudy.query_limitdate)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.marketstudy.query_limitdate = $event.target.value
        }, _vm.set_marketstudy_query_limitdate]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Search_radius_km')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.marketstudy.query_distance_km),
        expression: "marketstudy.query_distance_km"
      }],
      staticClass: "field__group__input",
      staticStyle: {
        "background-color": "white!important"
      },
      attrs: {
        "type": "number",
        "min": "0",
        "step": "any",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.marketstudy.query_distance_km)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.marketstudy.query_distance_km = $event.target.value
        }, _vm.set_marketstudy_query_distance_km],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [(this.realestate.lat && this.realestate.lng && this.marketstudy.query_startdate && this.marketstudy.query_limitdate && this.marketstudy.query_ad_type && this.appraisal.property_type && this.appraisal.adopted_area && this.appraisal.adopted_age) ? _c('div', {
      staticClass: "field__group"
    }, [_c('button', {
      staticClass: "quote-request__aux__button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onQueryAds($event)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.onQueryAds($event)
        }
      }
    }, [_c('span', [_c('icon', {
      attrs: {
        "name": "globe",
        "scale": "1",
        "color": "rgb(0, 79, 146)"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Query_comparables')))], 1)])]) : _vm._e(), _vm._v(" "), (_vm.query_comparables_loading) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "1",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Loading')) + "...")], 1)]) : _vm._e()]), _vm._v(" "), (!this.realestate.lat && !this.realestate.lng) ? _c('div', [_c('message', {
      attrs: {
        "text": _vm.lat_lng_error_text,
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : _vm._e(), _vm._v(" "), (!this.marketstudy.query_startdate || !this.marketstudy.query_limitdate) ? _c('div', [_c('message', {
      attrs: {
        "text": _vm.query_date_error_text,
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : _vm._e(), _vm._v(" "), (!this.marketstudy.query_ad_type) ? _c('div', [_c('message', {
      attrs: {
        "text": _vm.query_ad_type_error_text,
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Query_result')))]), _vm._v(" "), _c('div', {
      staticClass: "query_table"
    }, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "data-table-main",
        "source": _vm.marketstudy_matched_ads,
        "filterable": false,
        "striped": _vm.ad_table.striped,
        "editable": _vm.ad_table.editable,
        "line-numbers": _vm.ad_table.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "property_type",
        fn: function(cell) {
          return [(cell.row['property_type']) ? _c('div', [(_vm.currentLocale === 'ca') ? _c('span', [_vm._v(_vm._s(cell.row['property_type'].name_ca))]) : (_vm.currentLocale === 'es') ? _c('span', [_vm._v(_vm._s(cell.row['property_type'].name_es))]) : (_vm.currentLocale === 'en') ? _c('span', [_vm._v(_vm._s(cell.row['property_type'].name_en))]) : _vm._e()]) : _vm._e()]
        }
      }, {
        key: "conservation_status",
        fn: function(cell) {
          return [(cell.row['conservation_status']) ? _c('div', [(_vm.currentLocale === 'ca') ? _c('span', [_vm._v(_vm._s(cell.row['conservation_status'].name_ca))]) : (_vm.currentLocale === 'es') ? _c('span', [_vm._v(_vm._s(cell.row['conservation_status'].name_es))]) : (_vm.currentLocale === 'en') ? _c('span', [_vm._v(_vm._s(cell.row['conservation_status'].name_en))]) : _vm._e()]) : _vm._e()]
        }
      }, {
        key: "actions-matched_ads",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.openlink_text
            },
            on: {
              "click": function($event) {
                _vm.openAdLink(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "link",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.choose_text
            },
            on: {
              "click": function($event) {
                _vm.chooseAd(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "plus",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.discard_text
            },
            on: {
              "click": function($event) {
                _vm.discardAd(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "times",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }])
    }, [_c('datatable-column', {
      attrs: {
        "id": "actions-matched_ads",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    }), _vm._v(" "), _vm._l((_vm.ad_table.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    })], 2)], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container",
      staticStyle: {
        "background-color": "#fafafc",
        "padding": "2rem"
      }
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Import_comparable_set_from_another_market_study')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('File_number')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.importAppraisalFileValue,
        "options": _vm.object_to_array(_vm.appraisalfiles),
        "track-by": "id",
        "label": 'number',
        "searchable": true
      },
      on: {
        "input": _vm.set_import_appraisalfile
      },
      model: {
        value: (_vm.marketstudy.importAppraisalFile),
        callback: function($$v) {
          _vm.marketstudy.importAppraisalFile = $$v
        },
        expression: "marketstudy.importAppraisalFile"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [(_vm.marketstudy.importAppraisalFile) ? _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Report')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.importReportValue,
        "options": _vm.object_to_array(_vm.temp_appraisalreports),
        "track-by": "id",
        "label": 'number',
        "searchable": true
      },
      on: {
        "input": _vm.set_import_report
      },
      model: {
        value: (_vm.marketstudy.importReport),
        callback: function($$v) {
          _vm.marketstudy.importReport = $$v
        },
        expression: "marketstudy.importReport"
      }
    })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [(_vm.marketstudy.importReport) ? _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Real_estate')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.importRealEstateValue,
        "options": _vm.object_to_array(_vm.temp_realestates),
        "track-by": "id",
        "label": 'street_name',
        "searchable": true
      },
      on: {
        "input": _vm.set_import_realestate
      },
      model: {
        value: (_vm.marketstudy.importRealEstate),
        callback: function($$v) {
          _vm.marketstudy.importRealEstate = $$v
        },
        expression: "marketstudy.importRealEstate"
      }
    })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [(_vm.marketstudy.importRealEstate) ? _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Market_study')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.importMarketStudyValue,
        "options": _vm.object_to_array(_vm.temp_marketstudies),
        "track-by": "id",
        "label": 'id',
        "searchable": true
      },
      on: {
        "input": function($event) {}
      },
      model: {
        value: (_vm.marketstudy.importMarketStudy),
        callback: function($$v) {
          _vm.marketstudy.importMarketStudy = $$v
        },
        expression: "marketstudy.importMarketStudy"
      }
    })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [(_vm.marketstudy.importRealEstate) ? _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onImportComparableSet({
            go_up: false
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-down",
        "text": _vm.import_comparable_set_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Selected_comparables')))]), _vm._v(" "), _c('div', {
      staticClass: "query_table"
    }, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "data-table-selected_comparables",
        "source": _vm.object_to_array(_vm.marketstudy_ad_comparables),
        "filterable": false,
        "striped": _vm.comparable_table.striped,
        "editable": _vm.comparable_table.editable,
        "line-numbers": _vm.comparable_table.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "property_type",
        fn: function(cell) {
          return [(cell.row['property_type']) ? _c('div', [(_vm.currentLocale === 'ca') ? _c('span', [_vm._v(_vm._s(cell.row['property_type'].name_ca))]) : (_vm.currentLocale === 'es') ? _c('span', [_vm._v(_vm._s(cell.row['property_type'].name_es))]) : (_vm.currentLocale === 'en') ? _c('span', [_vm._v(_vm._s(cell.row['property_type'].name_en))]) : _vm._e()]) : _vm._e()]
        }
      }, {
        key: "conservation_status",
        fn: function(cell) {
          return [(cell.row['conservation_status']) ? _c('div', [(_vm.currentLocale === 'ca') ? _c('span', [_vm._v(_vm._s(cell.row['conservation_status'].name_ca))]) : (_vm.currentLocale === 'es') ? _c('span', [_vm._v(_vm._s(cell.row['conservation_status'].name_es))]) : (_vm.currentLocale === 'en') ? _c('span', [_vm._v(_vm._s(cell.row['conservation_status'].name_en))]) : _vm._e()]) : _vm._e()]
        }
      }, {
        key: "actions-selected_comparables",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.openlink_text
            },
            on: {
              "click": function($event) {
                _vm.openAdLink(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "link",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.edit_text
            },
            on: {
              "click": function($event) {
                _vm.editAd(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "pencil",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.deleteAdComparable(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "trash-o",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }])
    }, [_c('datatable-column', {
      attrs: {
        "id": "actions-selected_comparables",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    }), _vm._v(" "), _vm._l((_vm.comparable_table.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    })], 2)], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Data_tabulation')))]), _vm._v(" "), _c('div', {
      staticClass: "weighing_table"
    }, [_c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "data-table-tabulation",
        "source": _vm.object_to_array(_vm.marketstudy_ad_comparables),
        "filterable": false,
        "striped": _vm.tabulation_table.striped,
        "editable": _vm.tabulation_table.editable,
        "line-numbers": _vm.tabulation_table.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "property_type",
        fn: function(cell) {
          return [_c('div', [_c('multiselect', {
            attrs: {
              "placeholder": "",
              "value": _vm.property_typeValue,
              "options": _vm.property_typeOptions,
              "track-by": "id",
              "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
              "searchable": false,
              "selectedLabel": "",
              "selectLabel": "",
              "deselectLabel": ""
            },
            on: {
              "input": function($event) {
                _vm.set_entity_property_type($event, cell.row)
              }
            },
            model: {
              value: (cell.row['property_type']),
              callback: function($$v) {
                var $$exp = cell.row,
                  $$idx = 'property_type';
                if (!Array.isArray($$exp)) {
                  cell.row['property_type'] = $$v
                } else {
                  $$exp.splice($$idx, 1, $$v)
                }
              },
              expression: "cell.row['property_type']"
            }
          })], 1)]
        }
      }, {
        key: "quality_of_neighbourhood",
        fn: function(cell) {
          return [_c('div', [_c('multiselect', {
            attrs: {
              "placeholder": "",
              "value": _vm.quality_of_neighbourhoodValue,
              "options": _vm.quality_of_neighbourhoodOptions,
              "track-by": "id",
              "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
              "searchable": false,
              "selectedLabel": "",
              "selectLabel": "",
              "deselectLabel": ""
            },
            on: {
              "input": function($event) {
                _vm.set_entity_quality_of_neighbourhood($event, cell.row)
              }
            },
            model: {
              value: (cell.row['quality_of_neighbourhood']),
              callback: function($$v) {
                var $$exp = cell.row,
                  $$idx = 'quality_of_neighbourhood';
                if (!Array.isArray($$exp)) {
                  cell.row['quality_of_neighbourhood'] = $$v
                } else {
                  $$exp.splice($$idx, 1, $$v)
                }
              },
              expression: "cell.row['quality_of_neighbourhood']"
            }
          })], 1)]
        }
      }, {
        key: "quality_of_situation",
        fn: function(cell) {
          return [_c('div', [_c('multiselect', {
            attrs: {
              "placeholder": "",
              "value": _vm.quality_of_situationValue,
              "options": _vm.quality_of_situationOptions,
              "track-by": "id",
              "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
              "searchable": false,
              "selectedLabel": "",
              "selectLabel": "",
              "deselectLabel": ""
            },
            on: {
              "input": function($event) {
                _vm.set_entity_quality_of_situation($event, cell.row)
              }
            },
            model: {
              value: (cell.row['quality_of_situation']),
              callback: function($$v) {
                var $$exp = cell.row,
                  $$idx = 'quality_of_situation';
                if (!Array.isArray($$exp)) {
                  cell.row['quality_of_situation'] = $$v
                } else {
                  $$exp.splice($$idx, 1, $$v)
                }
              },
              expression: "cell.row['quality_of_situation']"
            }
          })], 1)]
        }
      }, {
        key: "quality_of_construction",
        fn: function(cell) {
          return [_c('div', [_c('multiselect', {
            attrs: {
              "placeholder": "",
              "value": _vm.quality_of_constructionValue,
              "options": _vm.quality_of_constructionOptions,
              "track-by": "id",
              "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
              "searchable": false,
              "selectedLabel": "",
              "selectLabel": "",
              "deselectLabel": ""
            },
            on: {
              "input": function($event) {
                _vm.set_entity_quality_of_construction($event, cell.row)
              }
            },
            model: {
              value: (cell.row['quality_of_construction']),
              callback: function($$v) {
                var $$exp = cell.row,
                  $$idx = 'quality_of_construction';
                if (!Array.isArray($$exp)) {
                  cell.row['quality_of_construction'] = $$v
                } else {
                  $$exp.splice($$idx, 1, $$v)
                }
              },
              expression: "cell.row['quality_of_construction']"
            }
          })], 1)]
        }
      }, {
        key: "quality_of_realestate",
        fn: function(cell) {
          return [_c('div', [_c('multiselect', {
            attrs: {
              "placeholder": "",
              "value": _vm.quality_of_realestateValue,
              "options": _vm.quality_of_realestateOptions,
              "track-by": "id",
              "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
              "searchable": false,
              "selectedLabel": "",
              "selectLabel": "",
              "deselectLabel": ""
            },
            on: {
              "input": function($event) {
                _vm.set_entity_quality_of_realestate($event, cell.row)
              }
            },
            model: {
              value: (cell.row['quality_of_realestate']),
              callback: function($$v) {
                var $$exp = cell.row,
                  $$idx = 'quality_of_realestate';
                if (!Array.isArray($$exp)) {
                  cell.row['quality_of_realestate'] = $$v
                } else {
                  $$exp.splice($$idx, 1, $$v)
                }
              },
              expression: "cell.row['quality_of_realestate']"
            }
          })], 1)]
        }
      }, {
        key: "conservation_status",
        fn: function(cell) {
          return [_c('div', [_c('multiselect', {
            attrs: {
              "placeholder": "",
              "value": _vm.conservation_statusValue,
              "options": _vm.conservation_statusOptions,
              "track-by": "id",
              "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
              "searchable": false,
              "selectedLabel": "",
              "selectLabel": "",
              "deselectLabel": ""
            },
            on: {
              "input": function($event) {
                _vm.set_entity_conservation_status($event, cell.row)
              }
            },
            model: {
              value: (cell.row['conservation_status']),
              callback: function($$v) {
                var $$exp = cell.row,
                  $$idx = 'conservation_status';
                if (!Array.isArray($$exp)) {
                  cell.row['conservation_status'] = $$v
                } else {
                  $$exp.splice($$idx, 1, $$v)
                }
              },
              expression: "cell.row['conservation_status']"
            }
          })], 1)]
        }
      }, {
        key: "adopted_age",
        fn: function(cell) {
          return [_c('div', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['adopted_age']),
              expression: "cell.row['adopted_age']"
            }],
            attrs: {
              "type": "number",
              "maxlength": "4"
            },
            domProps: {
              "value": (cell.row['adopted_age'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'adopted_age';
                if (!Array.isArray($$exp)) {
                  cell.row['adopted_age'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, function($event) {
                _vm.set_entity_adopted_age($event, cell.row)
              }],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])]
        }
      }, {
        key: "adopted_area",
        fn: function(cell) {
          return [_c('div', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['adopted_area']),
              expression: "cell.row['adopted_area']"
            }],
            attrs: {
              "type": "number"
            },
            domProps: {
              "value": (cell.row['adopted_area'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'adopted_area';
                if (!Array.isArray($$exp)) {
                  cell.row['adopted_area'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, function($event) {
                _vm.set_entity_adopted_area($event, cell.row)
              }],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])]
        }
      }, {
        key: "floor_number",
        fn: function(cell) {
          return [_c('div', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['floor_number']),
              expression: "cell.row['floor_number']"
            }],
            attrs: {
              "type": "number"
            },
            domProps: {
              "value": (cell.row['floor_number'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'floor_number';
                if (!Array.isArray($$exp)) {
                  cell.row['floor_number'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, function($event) {
                _vm.set_entity_floor_number($event, cell.row)
              }],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])]
        }
      }, {
        key: "lift",
        fn: function(cell) {
          return [_c('div', [_c('checkbox', {
            attrs: {
              "id": cell.row.id,
              "editable": _vm.editabletrue
            },
            on: {
              "toggle_flag": function($event) {
                _vm.set_entity_lift(cell.row['lift'], cell.row)
              }
            },
            model: {
              value: (cell.row['lift']),
              callback: function($$v) {
                var $$exp = cell.row,
                  $$idx = 'lift';
                if (!Array.isArray($$exp)) {
                  cell.row['lift'] = $$v
                } else {
                  $$exp.splice($$idx, 1, $$v)
                }
              },
              expression: "cell.row['lift']"
            }
          })], 1)]
        }
      }])
    }, _vm._l((_vm.tabulation_table.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }))], 1)])]), _vm._v(" "), _c('div', {}, [_c('span', [_vm._v(_vm._s(_vm.$t('Appraised')) + ":")]), _vm._v(" "), _c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "data-table-appraisal_tabulation",
        "source": _vm.appraisal_tabulation,
        "filterable": false,
        "striped": _vm.appraisal_tabulation_table.striped,
        "editable": _vm.appraisal_tabulation_table.editable,
        "line-numbers": _vm.appraisal_tabulation_table.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "property_type",
        fn: function(cell) {
          return [_c('div', [_c('multiselect', {
            attrs: {
              "placeholder": "",
              "value": _vm.appraisal_property_typeValue,
              "options": _vm.property_typeOptions,
              "track-by": "id",
              "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
              "searchable": false,
              "selectedLabel": "",
              "selectLabel": "",
              "deselectLabel": ""
            },
            on: {
              "input": _vm.set_appraisal_property_type
            },
            model: {
              value: (cell.row['property_type']),
              callback: function($$v) {
                var $$exp = cell.row,
                  $$idx = 'property_type';
                if (!Array.isArray($$exp)) {
                  cell.row['property_type'] = $$v
                } else {
                  $$exp.splice($$idx, 1, $$v)
                }
              },
              expression: "cell.row['property_type']"
            }
          })], 1)]
        }
      }, {
        key: "conservation_status",
        fn: function(cell) {
          return [_c('div', [_c('multiselect', {
            attrs: {
              "placeholder": "",
              "value": _vm.appraisal_conservation_statusValue,
              "options": _vm.conservation_statusOptions,
              "track-by": "id",
              "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
              "searchable": false,
              "selectedLabel": "",
              "selectLabel": "",
              "deselectLabel": ""
            },
            on: {
              "input": _vm.set_appraisal_conservation_status
            },
            model: {
              value: (cell.row['conservation_status']),
              callback: function($$v) {
                var $$exp = cell.row,
                  $$idx = 'conservation_status';
                if (!Array.isArray($$exp)) {
                  cell.row['conservation_status'] = $$v
                } else {
                  $$exp.splice($$idx, 1, $$v)
                }
              },
              expression: "cell.row['conservation_status']"
            }
          })], 1)]
        }
      }, {
        key: "quality_of_neighbourhood",
        fn: function(cell) {
          return [_c('div', [_c('multiselect', {
            attrs: {
              "placeholder": "",
              "value": _vm.appraisal_quality_of_neighbourhoodValue,
              "options": _vm.quality_of_neighbourhoodOptions,
              "track-by": "id",
              "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
              "searchable": false,
              "selectedLabel": "",
              "selectLabel": "",
              "deselectLabel": ""
            },
            on: {
              "input": _vm.set_appraisal_quality_of_neighbourhood
            },
            model: {
              value: (cell.row['quality_of_neighbourhood']),
              callback: function($$v) {
                var $$exp = cell.row,
                  $$idx = 'quality_of_neighbourhood';
                if (!Array.isArray($$exp)) {
                  cell.row['quality_of_neighbourhood'] = $$v
                } else {
                  $$exp.splice($$idx, 1, $$v)
                }
              },
              expression: "cell.row['quality_of_neighbourhood']"
            }
          })], 1)]
        }
      }, {
        key: "quality_of_situation",
        fn: function(cell) {
          return [_c('div', [_c('multiselect', {
            attrs: {
              "placeholder": "",
              "value": _vm.appraisal_quality_of_situationValue,
              "options": _vm.quality_of_situationOptions,
              "track-by": "id",
              "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
              "searchable": false,
              "selectedLabel": "",
              "selectLabel": "",
              "deselectLabel": ""
            },
            on: {
              "input": _vm.set_appraisal_quality_of_situation
            },
            model: {
              value: (cell.row['quality_of_situation']),
              callback: function($$v) {
                var $$exp = cell.row,
                  $$idx = 'quality_of_situation';
                if (!Array.isArray($$exp)) {
                  cell.row['quality_of_situation'] = $$v
                } else {
                  $$exp.splice($$idx, 1, $$v)
                }
              },
              expression: "cell.row['quality_of_situation']"
            }
          })], 1)]
        }
      }, {
        key: "quality_of_construction",
        fn: function(cell) {
          return [_c('div', [_c('multiselect', {
            attrs: {
              "placeholder": "",
              "value": _vm.appraisal_quality_of_constructionValue,
              "options": _vm.quality_of_constructionOptions,
              "track-by": "id",
              "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
              "searchable": false,
              "selectedLabel": "",
              "selectLabel": "",
              "deselectLabel": ""
            },
            on: {
              "input": _vm.set_appraisal_quality_of_construction
            },
            model: {
              value: (cell.row['quality_of_construction']),
              callback: function($$v) {
                var $$exp = cell.row,
                  $$idx = 'quality_of_construction';
                if (!Array.isArray($$exp)) {
                  cell.row['quality_of_construction'] = $$v
                } else {
                  $$exp.splice($$idx, 1, $$v)
                }
              },
              expression: "cell.row['quality_of_construction']"
            }
          })], 1)]
        }
      }, {
        key: "quality_of_realestate",
        fn: function(cell) {
          return [_c('div', [_c('multiselect', {
            attrs: {
              "placeholder": "",
              "value": _vm.appraisal_quality_of_realestateValue,
              "options": _vm.quality_of_realestateOptions,
              "track-by": "id",
              "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
              "searchable": false,
              "selectedLabel": "",
              "selectLabel": "",
              "deselectLabel": ""
            },
            on: {
              "input": _vm.set_appraisal_quality_of_realestate
            },
            model: {
              value: (cell.row['quality_of_realestate']),
              callback: function($$v) {
                var $$exp = cell.row,
                  $$idx = 'quality_of_realestate';
                if (!Array.isArray($$exp)) {
                  cell.row['quality_of_realestate'] = $$v
                } else {
                  $$exp.splice($$idx, 1, $$v)
                }
              },
              expression: "cell.row['quality_of_realestate']"
            }
          })], 1)]
        }
      }, {
        key: "adopted_age",
        fn: function(cell) {
          return [_c('div', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['adopted_age']),
              expression: "cell.row['adopted_age']"
            }],
            attrs: {
              "type": "number",
              "maxlength": "4"
            },
            domProps: {
              "value": (cell.row['adopted_age'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'adopted_age';
                if (!Array.isArray($$exp)) {
                  cell.row['adopted_age'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, function($event) {
                _vm.set_appraisal_adopted_age(cell.row['adopted_age'])
              }],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])]
        }
      }, {
        key: "adopted_area",
        fn: function(cell) {
          return [_c('div', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['adopted_area']),
              expression: "cell.row['adopted_area']"
            }],
            attrs: {
              "type": "number"
            },
            domProps: {
              "value": (cell.row['adopted_area'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'adopted_area';
                if (!Array.isArray($$exp)) {
                  cell.row['adopted_area'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, function($event) {
                _vm.set_appraisal_adopted_area(cell.row['adopted_area'])
              }],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])]
        }
      }, {
        key: "floor_number",
        fn: function(cell) {
          return [_c('div', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['floor_number']),
              expression: "cell.row['floor_number']"
            }],
            attrs: {
              "type": "number"
            },
            domProps: {
              "value": (cell.row['floor_number'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'floor_number';
                if (!Array.isArray($$exp)) {
                  cell.row['floor_number'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, function($event) {
                _vm.set_appraisal_floor_number(cell.row['floor_number'])
              }],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])]
        }
      }, {
        key: "lift",
        fn: function(cell) {
          return [_c('div', [_c('checkbox', {
            attrs: {
              "id": cell.row.id,
              "editable": _vm.editabletrue
            },
            on: {
              "toggle_flag": function($event) {
                _vm.set_appraisal_lift(cell.row['lift'])
              }
            },
            model: {
              value: (cell.row['lift']),
              callback: function($$v) {
                var $$exp = cell.row,
                  $$idx = 'lift';
                if (!Array.isArray($$exp)) {
                  cell.row['lift'] = $$v
                } else {
                  $$exp.splice($$idx, 1, $$v)
                }
              },
              expression: "cell.row['lift']"
            }
          })], 1)]
        }
      }])
    }, _vm._l((_vm.appraisal_tabulation_table.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter,
          "showHeader": column.showHeader
        }
      })
    }))], 1)])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Qualities_comparison')))]), _vm._v(" "), _c('div', {
      staticClass: "query_table"
    }, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "data-table-comparison",
        "source": _vm.object_to_array(_vm.marketstudy_ad_comparables),
        "filterable": false,
        "striped": _vm.comparison_table.striped,
        "editable": _vm.comparison_table.editable,
        "line-numbers": _vm.comparison_table.lineNumbers
      }
    }, _vm._l((_vm.comparison_table.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }))], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Homogenisation_of_values')))]), _vm._v(" "), _c('div', {
      staticClass: "weighing_table"
    }, [_c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "data-table-weighing",
        "source": _vm.object_to_array(_vm.weighing),
        "filterable": false,
        "striped": _vm.weighing_table.striped,
        "editable": _vm.weighing_table.editable,
        "line-numbers": _vm.weighing_table.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "ad_date",
        fn: function(cell) {
          return [_c('div', {
            staticStyle: {
              "text-align": "center",
              "margin": "0 auto"
            }
          }, [_c('div', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['ad_date']),
              expression: "cell.row['ad_date']"
            }],
            staticClass: "weighing-input",
            attrs: {
              "type": "number"
            },
            domProps: {
              "value": (cell.row['ad_date'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'ad_date';
                if (!Array.isArray($$exp)) {
                  cell.row['ad_date'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, _vm.set_marketstudy_weighing_ad_date],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])])]
        }
      }, {
        key: "property_type",
        fn: function(cell) {
          return [_c('div', {
            staticStyle: {
              "text-align": "center",
              "margin": "0 auto"
            }
          }, [_c('div', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['property_type']),
              expression: "cell.row['property_type']"
            }],
            staticClass: "weighing-input",
            attrs: {
              "type": "number"
            },
            domProps: {
              "value": (cell.row['property_type'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'property_type';
                if (!Array.isArray($$exp)) {
                  cell.row['property_type'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, _vm.set_marketstudy_weighing_property_type],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])])]
        }
      }, {
        key: "quality_of_neighbourhood",
        fn: function(cell) {
          return [_c('div', {
            staticStyle: {
              "text-align": "center",
              "margin": "0 auto"
            }
          }, [_c('div', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['quality_of_neighbourhood']),
              expression: "cell.row['quality_of_neighbourhood']"
            }],
            staticClass: "weighing-input",
            attrs: {
              "type": "number"
            },
            domProps: {
              "value": (cell.row['quality_of_neighbourhood'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'quality_of_neighbourhood';
                if (!Array.isArray($$exp)) {
                  cell.row['quality_of_neighbourhood'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, _vm.set_marketstudy_weighing_quality_of_neighbourhood],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])])]
        }
      }, {
        key: "quality_of_situation",
        fn: function(cell) {
          return [_c('div', {
            staticStyle: {
              "text-align": "center",
              "margin": "0 auto"
            }
          }, [_c('div', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['quality_of_situation']),
              expression: "cell.row['quality_of_situation']"
            }],
            staticClass: "weighing-input",
            attrs: {
              "type": "number"
            },
            domProps: {
              "value": (cell.row['quality_of_situation'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'quality_of_situation';
                if (!Array.isArray($$exp)) {
                  cell.row['quality_of_situation'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, _vm.set_marketstudy_weighing_quality_of_situation],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])])]
        }
      }, {
        key: "quality_of_construction",
        fn: function(cell) {
          return [_c('div', {
            staticStyle: {
              "text-align": "center",
              "margin": "0 auto"
            }
          }, [_c('div', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['quality_of_construction']),
              expression: "cell.row['quality_of_construction']"
            }],
            staticClass: "weighing-input",
            attrs: {
              "type": "number"
            },
            domProps: {
              "value": (cell.row['quality_of_construction'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'quality_of_construction';
                if (!Array.isArray($$exp)) {
                  cell.row['quality_of_construction'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, _vm.set_marketstudy_weighing_quality_of_construction],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])])]
        }
      }, {
        key: "quality_of_realestate",
        fn: function(cell) {
          return [_c('div', {
            staticStyle: {
              "text-align": "center",
              "margin": "0 auto"
            }
          }, [_c('div', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['quality_of_realestate']),
              expression: "cell.row['quality_of_realestate']"
            }],
            staticClass: "weighing-input",
            attrs: {
              "type": "number"
            },
            domProps: {
              "value": (cell.row['quality_of_realestate'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'quality_of_realestate';
                if (!Array.isArray($$exp)) {
                  cell.row['quality_of_realestate'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, _vm.set_marketstudy_weighing_quality_of_realestate],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])])]
        }
      }, {
        key: "adopted_age",
        fn: function(cell) {
          return [_c('div', {
            staticStyle: {
              "text-align": "center",
              "margin": "0 auto"
            }
          }, [_c('div', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['adopted_age']),
              expression: "cell.row['adopted_age']"
            }],
            staticClass: "weighing-input",
            attrs: {
              "type": "number"
            },
            domProps: {
              "value": (cell.row['adopted_age'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'adopted_age';
                if (!Array.isArray($$exp)) {
                  cell.row['adopted_age'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, _vm.set_marketstudy_weighing_adopted_age],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])])]
        }
      }, {
        key: "conservation_status",
        fn: function(cell) {
          return [_c('div', {
            staticStyle: {
              "text-align": "center",
              "margin": "0 auto"
            }
          }, [_c('div', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['conservation_status']),
              expression: "cell.row['conservation_status']"
            }],
            staticClass: "weighing-input",
            attrs: {
              "type": "number"
            },
            domProps: {
              "value": (cell.row['conservation_status'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'conservation_status';
                if (!Array.isArray($$exp)) {
                  cell.row['conservation_status'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, _vm.set_marketstudy_weighing_conservation_status],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])])]
        }
      }, {
        key: "floor_number",
        fn: function(cell) {
          return [_c('div', {
            staticStyle: {
              "text-align": "center",
              "margin": "0 auto"
            }
          }, [_c('div', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['floor_number']),
              expression: "cell.row['floor_number']"
            }],
            staticClass: "weighing-input",
            attrs: {
              "type": "number"
            },
            domProps: {
              "value": (cell.row['floor_number'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'floor_number';
                if (!Array.isArray($$exp)) {
                  cell.row['floor_number'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, _vm.set_marketstudy_weighing_floor_number],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])])]
        }
      }, {
        key: "adopted_area",
        fn: function(cell) {
          return [_c('div', {
            staticStyle: {
              "text-align": "center",
              "margin": "0 auto"
            }
          }, [_c('div', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['adopted_area']),
              expression: "cell.row['adopted_area']"
            }],
            staticClass: "weighing-input",
            attrs: {
              "type": "number"
            },
            domProps: {
              "value": (cell.row['adopted_area'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'adopted_area';
                if (!Array.isArray($$exp)) {
                  cell.row['adopted_area'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, _vm.set_marketstudy_weighing_adopted_area],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])])]
        }
      }, {
        key: "lift",
        fn: function(cell) {
          return [_c('div', {
            staticStyle: {
              "text-align": "center",
              "margin": "0 auto"
            }
          }, [_c('div', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['lift']),
              expression: "cell.row['lift']"
            }],
            staticClass: "weighing-input",
            attrs: {
              "type": "number"
            },
            domProps: {
              "value": (cell.row['lift'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'lift';
                if (!Array.isArray($$exp)) {
                  cell.row['lift'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, _vm.set_marketstudy_weighing_lift],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])])]
        }
      }])
    }, _vm._l((_vm.weighing_table.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter,
          "showHeader": column.showHeader
        }
      })
    }))], 1)])]), _vm._v(" "), _c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "data-table-homogenisation",
        "source": _vm.object_to_array(_vm.marketstudy_ad_comparables),
        "filterable": false,
        "striped": _vm.homogenisation_table.striped,
        "editable": _vm.homogenisation_table.editable,
        "line-numbers": _vm.homogenisation_table.lineNumbers
      }
    }, _vm._l((_vm.homogenisation_table.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter,
          "showHeader": column.showHeader
        }
      })
    }))], 1)])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Correction_of_values')))]), _vm._v(" "), _c('div', {
      staticClass: "query_table"
    }, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "data-table-correction",
        "source": _vm.object_to_array(_vm.marketstudy_ad_comparables),
        "filterable": false,
        "striped": _vm.correction_table.striped,
        "editable": _vm.correction_table.editable,
        "line-numbers": _vm.correction_table.lineNumbers
      }
    }, _vm._l((_vm.correction_table.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }))], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Regression_line_calculation')))]), _vm._v(" "), _c('div', {
      staticClass: "query_table"
    }, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "data-table-regressioncalc",
        "source": _vm.object_to_array(_vm.marketstudy_ad_comparables),
        "filterable": false,
        "striped": _vm.regressioncalc_table.striped,
        "editable": _vm.regressioncalc_table.editable,
        "line-numbers": _vm.regressioncalc_table.lineNumbers
      }
    }, _vm._l((_vm.regressioncalc_table.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }))], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Typical_deviation')) + ", " + _vm._s(_vm.$t('universal_sample')))]), _vm._v(" "), _c('div', {
      staticClass: "query_table"
    }, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "data-table-univdev",
        "source": _vm.object_to_array(_vm.universal_sample_typical_deviation),
        "filterable": false,
        "striped": _vm.univ_dev_table.striped,
        "editable": _vm.univ_dev_table.editable,
        "line-numbers": _vm.univ_dev_table.lineNumbers
      }
    }, _vm._l((_vm.univ_dev_table.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }))], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Typical_deviation')) + ", " + _vm._s(_vm.$t('representative_sample')))]), _vm._v(" "), _c('div', {
      staticClass: "query_table"
    }, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "data-table-reprdev",
        "source": _vm.object_to_array(_vm.representative_sample_typical_deviation),
        "filterable": false,
        "striped": _vm.repr_dev_table.striped,
        "editable": _vm.repr_dev_table.editable,
        "line-numbers": _vm.repr_dev_table.lineNumbers
      }
    }, _vm._l((_vm.repr_dev_table.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }))], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('div', {
      attrs: {
        "id": "regline"
      }
    }, [_c('vue-chart', {
      attrs: {
        "chart-type": _vm.regressionline_chart.chartType,
        "columns": _vm.regressionline_chart.columns,
        "rows": _vm.regressionline_chart.rows,
        "options": _vm.regressionline_chart.options
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Market_value_of_the_appraised_realestate')))]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Built_area')) + ": " + _vm._s(_vm._f("formatNumber")(_vm.appraisal.adopted_area)) + " m²"), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.$t('Market_value')) + ": " + _vm._s(_vm._f("formatNumber")(_vm.marketstudy.market_value)) + " €"), _c('br')]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.$t('Market_unit_value')) + ": " + _vm._s(_vm._f("formatNumber")(_vm.marketstudy.market_unit_value)) + " €/m²"), _c('br')])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Market_analysis')))])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Offer')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Offer_production')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.offer_productionValue,
        "options": _vm.quality_levelOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_marketstudy_offer_production
      },
      model: {
        value: (_vm.marketstudy.offer_production),
        callback: function($$v) {
          _vm.marketstudy.offer_production = $$v
        },
        expression: "marketstudy.offer_production"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Offer_yearly_stock')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.offer_yearly_stockValue,
        "options": _vm.quality_level_mascOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_marketstudy_offer_yearly_stock
      },
      model: {
        value: (_vm.marketstudy.offer_yearly_stock),
        callback: function($$v) {
          _vm.marketstudy.offer_yearly_stock = $$v
        },
        expression: "marketstudy.offer_yearly_stock"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Offer_trend')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.offer_trendValue,
        "options": _vm.trendOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_marketstudy_offer_trend
      },
      model: {
        value: (_vm.marketstudy.offer_trend),
        callback: function($$v) {
          _vm.marketstudy.offer_trend = $$v
        },
        expression: "marketstudy.offer_trend"
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Demand')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Demand_level')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.demand_levelValue,
        "options": _vm.quality_levelOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_marketstudy_demand_level
      },
      model: {
        value: (_vm.marketstudy.demand_level),
        callback: function($$v) {
          _vm.marketstudy.demand_level = $$v
        },
        expression: "marketstudy.demand_level"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Demand_speed_of_sales')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.demand_speed_of_salesValue,
        "options": _vm.termOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_marketstudy_demand_speed_of_sales
      },
      model: {
        value: (_vm.marketstudy.demand_speed_of_sales),
        callback: function($$v) {
          _vm.marketstudy.demand_speed_of_sales = $$v
        },
        expression: "marketstudy.demand_speed_of_sales"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Demand_trend')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.demand_trendValue,
        "options": _vm.trendOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_marketstudy_demand_trend
      },
      model: {
        value: (_vm.marketstudy.demand_trend),
        callback: function($$v) {
          _vm.marketstudy.demand_trend = $$v
        },
        expression: "marketstudy.demand_trend"
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Prices')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Maximum')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.marketstudy.prices_max)) + " €/m²")])]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Average')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.marketstudy.prices_mean)) + " €/m²")])]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Median')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.marketstudy.prices_median)) + " €/m²")])]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Minimum')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.marketstudy.prices_min)) + " €/m²")])])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Prices_estimated_yearly_evolution_pct')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.marketstudy.prices_estimated_yearly_evolution_pct),
        expression: "marketstudy.prices_estimated_yearly_evolution_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.marketstudy.prices_estimated_yearly_evolution_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.marketstudy.prices_estimated_yearly_evolution_pct = $event.target.value
        }, _vm.set_marketstudy_prices_estimated_yearly_evolution_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Prices_expectancy')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.prices_expectancyValue,
        "options": _vm.trendOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_marketstudy_prices_expectancy
      },
      model: {
        value: (_vm.marketstudy.prices_expectancy),
        callback: function($$v) {
          _vm.marketstudy.prices_expectancy = $$v
        },
        expression: "marketstudy.prices_expectancy"
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Expectation')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Prices_past_cicles_volatility')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.prices_past_cicles_volatilityValue,
        "options": _vm.volatility_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_marketstudy_prices_past_cicles_volatility
      },
      model: {
        value: (_vm.marketstudy.prices_past_cicles_volatility),
        callback: function($$v) {
          _vm.marketstudy.prices_past_cicles_volatility = $$v
        },
        expression: "marketstudy.prices_past_cicles_volatility"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Market_conjuncture')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.market_conjunctureValue,
        "options": _vm.conjunctureOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_marketstudy_market_conjuncture
      },
      model: {
        value: (_vm.marketstudy.market_conjuncture),
        callback: function($$v) {
          _vm.marketstudy.market_conjuncture = $$v
        },
        expression: "marketstudy.market_conjuncture"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Market_value_reduction_probability_expectancy')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.market_value_reduction_probability_expectancyValue,
        "options": _vm.quality_levelOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_marketstudy_market_value_reduction_probability_expectancy
      },
      model: {
        value: (_vm.marketstudy.market_value_reduction_probability_expectancy),
        callback: function($$v) {
          _vm.marketstudy.market_value_reduction_probability_expectancy = $$v
        },
        expression: "marketstudy.market_value_reduction_probability_expectancy"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Market_value_evolution_probability_pct')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.marketstudy.market_value_evolution_probability_pct),
        expression: "marketstudy.market_value_evolution_probability_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.marketstudy.market_value_evolution_probability_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.marketstudy.market_value_evolution_probability_pct = $event.target.value
        }, _vm.set_marketstudy_market_value_evolution_probability_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.metadata_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Description')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('MarketStudy_description')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.marketstudy.description),
        expression: "marketstudy.description"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.marketstudy.description)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.marketstudy.description = $event.target.value
        }, _vm.set_marketstudy_description]
      }
    })])])])])])])])], 1), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.set_entities_comparison_and_homogenisation($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "calculator",
        "text": _vm.calc_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUp($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "level-up",
        "text": _vm.goup_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentMarketStudy({
            go_up: false
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentMarketStudy({
            go_up: true
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_and_go_up_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), (_vm.marketstudy.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e()], 1)], 1)]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 2135 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "note-editor"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "filesOpen": _vm.filesOpen,
        "fileOpen": _vm.fileOpen,
        "reportOpen": _vm.reportOpen
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [_c('span', [_vm._v(_vm._s(_vm.$t('Note')))]), (_vm.note.dirty) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.note.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "datedata"
    }, [_c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Created')) + ": " + _vm._s(_vm.millis_to_time(_vm.note.date_created)))]), _vm._v(" "), _c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Last_modified')) + ": " + _vm._s(_vm.millis_to_time(_vm.note.date_modified)))])]), _vm._v(" "), _c('vue-tabs', [_c('v-tab', {
      attrs: {
        "title": _vm.data_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Note')) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Notes_foreseen_by_barnatasa')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.noteValue,
        "options": _vm.default_noteOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_note
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Catalan')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.note.name_ca),
        expression: "note.name_ca"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.note.name_ca)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.note.name_ca = $event.target.value
        }, _vm.set_note_name_ca]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('English')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.note.name_en),
        expression: "note.name_en"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.note.name_en)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.note.name_en = $event.target.value
        }, _vm.set_note_name_en]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Spanish')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.note.name_es),
        expression: "note.name_es"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.note.name_es)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.note.name_es = $event.target.value
        }, _vm.set_note_name_es]
      }
    })])])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.metadata_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('form', {
      staticClass: "bt-form"
    })])])], 1), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUp($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "chevron-left",
        "text": _vm.goup_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentNote({
            go_up: false
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentNote({
            go_up: true
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_and_go_up_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), (_vm.note.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e()], 1)], 1)]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 2136 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "flyaway"
  }, [_vm._t("default", [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])], 2)])
},staticRenderFns: []}

/***/ }),
/* 2137 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "projects-index"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "filesOpen": _vm.filesOpen,
        "fileOpen": _vm.fileOpen,
        "realEstateId": _vm.realestate.id
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('Project')) + " " + _vm._s(_vm.$t('with')) + " " + _vm._s(_vm.$t('date')) + " " + _vm._s(_vm.project.projectdate) + " " + _vm._s(_vm.$t('at')) + " "), (_vm.realestate.street_name) ? _c('span', [_vm._v(_vm._s(_vm.realestate.street_name))]) : _vm._e(), (_vm.realestate.street_number) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.street_number))]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v(" " + _vm._s(_vm.realestate.door))]) : _vm._e(), _vm._v(" "), (_vm.project.dirty) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.project.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "datedata"
    }, [_c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Created')) + ": " + _vm._s(_vm.millis_to_time(_vm.project.date_created)))]), _vm._v(" "), _c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Last_modified')) + ": " + _vm._s(_vm.millis_to_time(_vm.project.date_modified)))])]), _vm._v(" "), _c('vue-tabs', {
      model: {
        value: (_vm.tabName),
        callback: function($$v) {
          _vm.tabName = $$v
        },
        expression: "tabName"
      }
    }, [_c('v-tab', {
      attrs: {
        "title": _vm.General_data_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Dades generals')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.General_data_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('General data')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.General_data_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Datos generales')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.General_data_text))]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Project_type')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    })])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.metadata_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Metadades')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.metadata_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Metadatos')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.metadata_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Metadata')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.metadata_text) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Description')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    })])])])])])], 1), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUp($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "level-up",
        "text": _vm.goup_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentProject({
            go_up: false
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentProject({
            go_up: true
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_and_go_up_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), (_vm.project.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e()], 1)], 1)]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 2138 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "appraisals-index"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "filesOpen": _vm.filesOpen,
        "reportOpen": _vm.reportOpen
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [(!_vm.supervisor.surnames) ? _c('span', [_vm._v(_vm._s(_vm.$t('New_supervisor')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('Supervisor')) + ": " + _vm._s(_vm.supervisor.name) + " " + _vm._s(_vm.supervisor.surnames))]), _vm._v(" "), (_vm.supervisor.dirty) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.supervisor.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "datedata"
    }, [_c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Created')) + ": " + _vm._s(_vm.millis_to_time(_vm.supervisor.date_created)))]), _vm._v(" "), _c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Last_modified')) + ": " + _vm._s(_vm.millis_to_time(_vm.supervisor.date_modified)))])]), _vm._v(" "), _c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Data')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Name')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.supervisor.name),
        expression: "supervisor.name"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.supervisor.name)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.supervisor.name = $event.target.value
        }, _vm.set_supervisor_name]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Surnames')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.supervisor.surnames),
        expression: "supervisor.surnames"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.supervisor.surnames)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.supervisor.surnames = $event.target.value
        }, _vm.set_supervisor_surnames]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('TIN')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.supervisor.tin),
        expression: "supervisor.tin"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.supervisor.tin)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.supervisor.tin = $event.target.value
        }, _vm.set_supervisor_tin]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Prof_assoc_reg_number')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.supervisor.prof_assoc_reg_number),
        expression: "supervisor.prof_assoc_reg_number"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.supervisor.prof_assoc_reg_number)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.supervisor.prof_assoc_reg_number = $event.target.value
        }, _vm.set_supervisor_prof_assoc_reg_number]
      }
    })])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoBack($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "chevron-left",
        "text": _vm.goback_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentSupervisor({
            goback: true
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), (_vm.supervisor.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e()], 1)])], 1)], 1)]
  ], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('hr')])
}]}

/***/ }),
/* 2139 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checked),
      expression: "checked"
    }],
    attrs: {
      "type": "checkbox",
      "id": _vm.id,
      "name": _vm.id,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.value,
      "checked": Array.isArray(_vm.checked) ? _vm._i(_vm.checked, _vm.value) > -1 : (_vm.checked)
    },
    on: {
      "click": _vm.update,
      "__c": function($event) {
        var $$a = _vm.checked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.value,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.checked = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checked = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": _vm.id
    }
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 2140 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.hideDropdown),
      expression: "hideDropdown"
    }],
    staticClass: "dropdown"
  }, [_c('button', {
    staticClass: "button-icon user",
    on: {
      "click": function($event) {
        _vm.isActive = !_vm.isActive
      }
    }
  }), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isActive),
      expression: "isActive"
    }],
    staticClass: "app-dropdown__menu"
  }, [(_vm.user) ? [_c('li', {
    on: {
      "click": _vm.onLogOut
    }
  }, [_vm._v("Log Out")])] : [_c('li', {
    on: {
      "click": _vm.onLogIn
    }
  }, [_vm._v("Log In")]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.onSignUp
    }
  }, [_vm._v("Sign Up")])]], 2)])
},staticRenderFns: []}

/***/ }),
/* 2141 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notfound",
    attrs: {
      "id": "notfound"
    }
  }, [_c('h1', {
    staticClass: "notfound__headline"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('Restricted')) + "\n  ")]), _vm._v(" "), _c('router-link', {
    staticClass: "button primary large",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('Back_home')) + "\n  ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 2142 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidenavbar"
  }, [_c('div'), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 auto"
    }
  }, [(_vm.filesOpen) ? _c('li', {
    staticClass: "navli",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goTo('appraisalfiles-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "folder-open",
      "scale": "1"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.$t('Files')))])], 1) : _c('li', {
    staticClass: "navli",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goTo('appraisalfiles-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "folder-o",
      "scale": "1"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.$t('Files')))])], 1), _vm._v(" "), (_vm.fileOpen) ? _c('ul', {
    staticClass: "navul"
  }, [_c('li', {
    staticClass: "navli",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goToFile()
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "folder-open",
      "scale": "1"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.fileNumber))])], 1), _vm._v(" "), (_vm.reportOpen) ? _c('ul', {
    staticClass: "navul"
  }, [_c('li', {
    staticClass: "navli",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goToReport(_vm.reportId)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "file-text",
      "scale": "1"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.$t('Report')) + " nº " + _vm._s(_vm.reportNumber) + " (v. " + _vm._s(_vm.versionNumber) + ")")])], 1), _vm._v(" "), (_vm.realEstates) ? _c('ul', {
    staticClass: "navul"
  }, _vm._l((_vm.realEstates), function(realEstate) {
    return _c('li', {
      staticClass: "navli",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.goToRealEstate(realEstate.id)
        }
      }
    }, [(realEstate.id === _vm.realEstateId) ? _c('div', [_c('icon', {
      attrs: {
        "name": "building",
        "scale": "1"
      }
    })], 1) : _c('div', [_c('icon', {
      attrs: {
        "name": "building-o",
        "scale": "1"
      }
    })], 1), _vm._v(" "), _c('span', [(realEstate.street_name) ? _c('span', [_vm._v(_vm._s(realEstate.street_name))]) : _vm._e(), (realEstate.street_number) ? _c('span', [_vm._v(", " + _vm._s(realEstate.street_number))]) : _vm._e(), (realEstate.floor) ? _c('span', [_vm._v(", " + _vm._s(realEstate.floor))]) : _vm._e(), (realEstate.door) ? _c('span', [_vm._v("-" + _vm._s(realEstate.door))]) : _vm._e()])])
  })) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "navli",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goTo('realestates-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "building-o",
      "scale": "1"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.$t('Real_estates')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "navli",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goTo('ads-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "bookmark-o",
      "scale": "1"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.$t('Ads')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "navli",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goTo('contacts-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "address-card-o",
      "scale": "1"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.$t('Contacts')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "navli",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goTo('appraisalquotes-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "file-powerpoint-o",
      "scale": "1"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.$t('Quotes')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "navli",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goTo('appraisalinvoices-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "eur",
      "scale": "1"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.$t('Invoices')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "navli",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goTo('appraisers-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "user-circle-o",
      "scale": "1"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.$t('Appraisers')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "navli",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goTo('supervisors-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "user-circle",
      "scale": "1"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.$t('Supervisors')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "navli",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goTo('entities-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "university",
      "scale": "1"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.$t('Entities')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "navli",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goTo('becproperties-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "tag",
      "scale": "1"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.$t('Construction_prices')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "navli",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goTo('bdefiles-index')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "archive",
      "scale": "1"
    }
  }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.$t('BdE_files')))])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2143 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner"
  }, [_c('div', {
    staticClass: "icon icon--ei-spinner-2 icon--m"
  }, [_c('div', {
    staticClass: "icon__spinner"
  }, [_c('svg', {
    staticClass: "icon__cnt",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 50 50"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "25",
      "cy": "10",
      "r": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "opacity": ".3",
      "cx": "25",
      "cy": "40",
      "r": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "opacity": ".3",
      "cx": "32.5",
      "cy": "12",
      "r": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "opacity": ".3",
      "cx": "17.5",
      "cy": "38",
      "r": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "opacity": ".93",
      "cx": "17.5",
      "cy": "12",
      "r": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "opacity": ".3",
      "cx": "32.5",
      "cy": "38",
      "r": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "opacity": ".65",
      "cx": "10",
      "cy": "25",
      "r": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "opacity": ".3",
      "cx": "40",
      "cy": "25",
      "r": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "opacity": ".86",
      "cx": "12",
      "cy": "17.5",
      "r": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "opacity": ".3",
      "cx": "38",
      "cy": "32.5",
      "r": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "opacity": ".44",
      "cx": "12",
      "cy": "32.5",
      "r": "2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "opacity": ".3",
      "cx": "38",
      "cy": "17.5",
      "r": "2"
    }
  })])])])])
},staticRenderFns: []}

/***/ }),
/* 2144 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.slideClass
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 2145 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "appraisals-index"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "filesOpen": _vm.filesOpen,
        "fileOpen": _vm.fileOpen,
        "fileId": _vm.appraisalfile.id,
        "fileNumber": _vm.appraisalfile.number,
        "reportOpen": _vm.reportOpen,
        "reportNumber": _vm.appraisalreport.number,
        "versionNumber": _vm.appraisalreport.version,
        "realEstates": _vm.appraisalreport_realestates,
        "realEstateId": _vm.realestate.id,
        "reportId": _vm.appraisalreport.id
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('Edit_Real_Estate')) + " "), (_vm.realestate.property_type) ? _c('span', [(_vm.currentLocale == 'ca') ? _c('span', [_vm._v(_vm._s(_vm.realestate.property_type.name_ca))]) : (_vm.currentLocale == 'en') ? _c('span', [_vm._v(_vm._s(_vm.realestate.property_type.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.realestate.property_type.name_es))])]) : _vm._e(), _vm._v(" " + _vm._s(_vm.$t('at')) + " "), (_vm.realestate.street_name) ? _c('span', [_vm._v(_vm._s(_vm.realestate.street_name))]) : _vm._e(), (_vm.realestate.street_number) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.street_number))]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v(" " + _vm._s(_vm.realestate.door))]) : _vm._e(), _vm._v(" "), (_vm.realestate.dirty) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.realestate.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "datedata"
    }, [_c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Created')) + ": " + _vm._s(_vm.millis_to_time(_vm.realestate.date_created)))]), _vm._v(" "), _c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Last_modified')) + ": " + _vm._s(_vm.millis_to_time(_vm.realestate.date_modified)))])]), _vm._v(" "), _c('vue-tabs', {
      model: {
        value: (_vm.tabName),
        callback: function($$v) {
          _vm.tabName = $$v
        },
        expression: "tabName"
      }
    }, [_c('v-tab', {
      attrs: {
        "title": _vm.identification_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Identificació i pre-taxació')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.identification_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Identification and pre-appraisal')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.identification_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Identificación y pre-tasación')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.identification_text) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Property_type')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Property_type')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.property_typeValue,
        "options": _vm.property_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_realestate_property_type
      },
      model: {
        value: (_vm.realestate.property_type),
        callback: function($$v) {
          _vm.realestate.property_type = $$v
        },
        expression: "realestate.property_type"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Asset_type')) + " (BdE)")]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.asset_typeValue,
        "options": _vm.asset_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_realestate_asset_type
      },
      model: {
        value: (_vm.realestate.asset_type),
        callback: function($$v) {
          _vm.realestate.asset_type = $$v
        },
        expression: "realestate.asset_type"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Dwelling_type')) + " (BdE)")]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.dwelling_typeValue,
        "options": _vm.dwelling_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_realestate_dwelling_type
      },
      model: {
        value: (_vm.realestate.dwelling_type),
        callback: function($$v) {
          _vm.realestate.dwelling_type = $$v
        },
        expression: "realestate.dwelling_type"
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Address')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Country')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.countryValue,
        "options": _vm.countryOptions,
        "track-by": "iso_3166_alpha2_code",
        "label": 'name_en',
        "searchable": true
      },
      on: {
        "input": _vm.set_realestate_country_option
      },
      model: {
        value: (_vm.realestate.country),
        callback: function($$v) {
          _vm.realestate.country = $$v
        },
        expression: "realestate.country"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [(_vm.realestate.country) ? _c('div', {
      staticClass: "ms-container"
    }, [(_vm.realestate.country.name_en === 'Spain') ? _c('div', [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Province')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.provinceValue,
        "options": _vm.spanishProvinceOptions,
        "track-by": "id",
        "label": 'name_ine',
        "searchable": true
      },
      on: {
        "input": _vm.set_realestate_province_option
      },
      model: {
        value: (_vm.realestate.province),
        callback: function($$v) {
          _vm.realestate.province = $$v
        },
        expression: "realestate.province"
      }
    })], 1) : _c('div', [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Province')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.province),
        expression: "realestate.province"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.province)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.province = $event.target.value
        }, _vm.set_realestate_province]
      }
    })])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [(_vm.realestate.province) ? _c('div', {
      staticClass: "ms-container"
    }, [(_vm.realestate.country.name_en === 'Spain') ? _c('div', [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Municipality')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.municipalityValue,
        "options": _vm.object_to_array(_vm.realestate_municipalities),
        "track-by": "id",
        "label": 'name_ine',
        "searchable": true
      },
      on: {
        "input": _vm.set_realestate_municipality_option
      },
      model: {
        value: (_vm.realestate.municipality),
        callback: function($$v) {
          _vm.realestate.municipality = $$v
        },
        expression: "realestate.municipality"
      }
    })], 1) : _c('div', [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Municipality')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.municipality),
        expression: "realestate.municipality"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.municipality)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.municipality = $event.target.value
        }, _vm.set_realestate_municipality]
      }
    })])]) : _vm._e()]), _vm._v(" "), (_vm.realestate.municipality) ? _c('div', [_c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Street_name')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.street_name),
        expression: "realestate.street_name"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.street_name)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.street_name = $event.target.value
        }, _vm.set_realestate_street_name]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Street_number')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.street_number),
        expression: "realestate.street_number"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "step": "1",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.street_number)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.street_number = $event.target.value
        }, _vm.set_realestate_street_number],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Floor_name')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.floor),
        expression: "realestate.floor"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.floor)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.floor = $event.target.value
        }, _vm.set_realestate_floor]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [(_vm.realestate.property_type.name_db === 'parking') ? _c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('pkg_number')))]) : _c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Door')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.door),
        expression: "realestate.door"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.door)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.door = $event.target.value
        }, _vm.set_realestate_door]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Staircase')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.staircase),
        expression: "realestate.staircase"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.staircase)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.staircase = $event.target.value
        }, _vm.set_realestate_staircase]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Block')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.block),
        expression: "realestate.block"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.block)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.block = $event.target.value
        }, _vm.set_realestate_block]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Height_situation')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.floor_number),
        expression: "realestate.floor_number"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.floor_number)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.floor_number = $event.target.value
        }, _vm.set_realestate_floor_number],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Floor_type')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.floor_typeValue,
        "options": _vm.floor_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_realestate_floor_type
      },
      model: {
        value: (_vm.realestate.floor_type),
        callback: function($$v) {
          _vm.realestate.floor_type = $$v
        },
        expression: "realestate.floor_type"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('span', {
      staticClass: "help"
    }, [_c('i', [_vm._v(_vm._s(_vm.$t('Full_address')) + ":")]), _vm._v(" " + _vm._s(_vm.realestate.full_address))])])])])]) : _vm._e()]), _vm._v(" "), (this.realestate.municipality && this.realestate.street_name && this.realestate.street_number) ? _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Geolocation')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('button', {
      staticClass: "quote-request__aux__button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGeolocate($event)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.onGeolocate($event)
        }
      }
    }, [_c('span', [_c('icon', {
      attrs: {
        "name": "globe",
        "scale": "1",
        "color": "rgb(0, 79, 146)"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Geolocate')))], 1)])]), _vm._v(" "), (_vm.google_geocode_loading) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "1",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Loading')) + "...")], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Latitude')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.lat),
        expression: "realestate.lat"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "step": "any",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.lat)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.lat = $event.target.value
        }, _vm.set_realestate_lat],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Longitude')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.lng),
        expression: "realestate.lng"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "step": "any",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.lng)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.lng = $event.target.value
        }, _vm.set_realestate_lng],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Postal_code')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.postal_code),
        expression: "realestate.postal_code"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.postal_code)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.postal_code = $event.target.value
        }, _vm.set_realestate_postal_code]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v("X EPSG:25831")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.epsg25831_x),
        expression: "realestate.epsg25831_x"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "step": "any",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.epsg25831_x)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.epsg25831_x = $event.target.value
        }, _vm.set_realestate_epsg25831_x],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v("Y EPSG:25831")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.epsg25831_y),
        expression: "realestate.epsg25831_y"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "step": "any",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.epsg25831_y)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.epsg25831_y = $event.target.value
        }, _vm.set_realestate_epsg25831_y],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('span', {
      staticClass: "help"
    }, [_c('i', [_vm._v("Aquesta geolocalització es correspon a l'adreça:")]), _vm._v(" " + _vm._s(_vm.realestate.google_formatted_address) + ", (" + _vm._s(_vm.realestate.geohash) + ")")])])])]) : _vm._e(), _vm._v(" "), (this.realestate.epsg25831_x && this.realestate.epsg25831_y) ? _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Census_section')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('button', {
      staticClass: "quote-request__aux__button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onRequestCensusSectionInfo($event)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.onRequestCensusSectionInfo($event)
        }
      }
    }, [_c('span', [_c('icon', {
      attrs: {
        "name": "globe",
        "scale": "1",
        "color": "rgb(0, 79, 146)"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Census_section')))], 1)])]), _vm._v(" "), (_vm.icc_census_section_loading) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "1",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Loading')) + "...")], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Census_section_code')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.census_section_code),
        expression: "realestate.census_section_code"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.census_section_code)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.census_section_code = $event.target.value
        }, _vm.set_realestate_census_section_code]
      }
    })])])]) : _vm._e(), _vm._v(" "), (this.realestate.epsg25831_x && this.realestate.epsg25831_y) ? _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Cadastral_data')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('button', {
      staticClass: "quote-request__aux__button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onRequestCadastralReferenceSuggestion($event)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.onRequestCadastralReferenceSuggestion($event)
        }
      }
    }, [_c('span', [_c('icon', {
      attrs: {
        "name": "globe",
        "scale": "1",
        "color": "rgb(0, 79, 146)"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Cadastral_reference')))], 1)])]), _vm._v(" "), (_vm.cadaster_ref_loading) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "1",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Loading')) + "...")], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Cadastral_reference')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.cadastral_reference),
        expression: "realestate.cadastral_reference"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "maxlength": "20",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.cadastral_reference)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.cadastral_reference = $event.target.value
        }, _vm.set_realestate_cadastral_reference]
      }
    })]), _vm._v(" "), (_vm.realestate.cadastral_reference) ? _c('div', [(_vm.realestate.cadastral_reference.length > 0 && _vm.realestate.cadastral_reference.length < 20) ? _c('message', {
      attrs: {
        "text": _vm.cad_ref_error_text_01,
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    }) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('button', {
      staticClass: "quote-request__aux__button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onOpenCadastralMap($event)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.onOpenCadastralMap($event)
        }
      }
    }, [_c('span', [_c('icon', {
      attrs: {
        "name": "external-link",
        "scale": "1",
        "color": "rgb(0, 79, 146)"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Open')) + " " + _vm._s(_vm.$t('Cadastral_Map')))], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    })]) : _vm._e(), _vm._v(" "), (this.realestate.lat && this.realestate.lng) ? _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Maps')))]), _vm._v(" "), (_vm.google_map_01_loading) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "1",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Loading')) + " Map 01...")], 1)]) : _vm._e(), _vm._v(" "), (_vm.google_map_02_loading) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "1",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Loading')) + " Map 02...")], 1)]) : _vm._e(), _vm._v(" "), (_vm.google_map_03_loading) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "1",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Loading')) + " Map 03...")], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "field-container",
      staticStyle: {
        "justify-content": "baseline!important"
      }
    }, [(_vm.realestate.map_google_01_url) ? _c('div', [_c('div', {
      staticStyle: {
        "background": "transparent",
        "padding": "2em",
        "border": "1px solid lightgray",
        "margin": "2em",
        "box-shadow": "0 2px 4px rgba(0, 0, 0, 0.04)"
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "center",
        "padding-bottom": "1em"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('Map')) + " 1/3")])]), _vm._v(" "), _c('div', [_c('img', {
      attrs: {
        "src": _vm.realestate.map_google_01_url,
        "width": "640px",
        "height": "480px"
      }
    })]), _vm._v(" "), _c('div', [_c('table', {
      staticStyle: {
        "width": "640px",
        "text-align": "center"
      }
    }, [_c('tr', [_c('td', [_c('table', {
      staticStyle: {
        "width": "240px",
        "text-align": "center",
        "margin": "0 auto"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('span', {
      staticClass: "small"
    }, [_vm._v("center: " + _vm._s(_vm.realestate.map_google_01_lat) + ", " + _vm._s(_vm.realestate.map_google_01_lng))])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center!important"
      },
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUpMapGoogle01($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-up",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoLeftMapGoogle01($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-left",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoRightMapGoogle01($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-right",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center!important"
      },
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoDownMapGoogle01($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-down",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])])])]), _vm._v(" "), _c('td', [_c('table', {
      staticStyle: {
        "width": "240px",
        "text-align": "center",
        "margin": "0 auto"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('span', {
      staticClass: "small"
    }, [_vm._v("zoom: " + _vm._s(_vm.realestate.map_google_01_zoom))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onDecreaseZoomMapGoogle01($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "minus",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onIncreaseZoomMapGoogle01($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])])])])])])])]), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), (_vm.realestate.map_google_02_url) ? _c('div', [_c('div', {
      staticStyle: {
        "background": "transparent",
        "padding": "2em",
        "border": "1px solid lightgray",
        "margin": "2em",
        "box-shadow": "0 2px 4px rgba(0, 0, 0, 0.04)"
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "center",
        "padding-bottom": "1em"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('Map')) + " 2/3")])]), _vm._v(" "), _c('div', [_c('img', {
      attrs: {
        "src": _vm.realestate.map_google_02_url,
        "width": "640px",
        "height": "480px"
      }
    })]), _vm._v(" "), _c('div', [_c('table', {
      staticStyle: {
        "width": "640px",
        "text-align": "center"
      }
    }, [_c('tr', [_c('td', [_c('table', {
      staticStyle: {
        "width": "240px",
        "text-align": "center",
        "margin": "0 auto"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('span', {
      staticClass: "small"
    }, [_vm._v("center: " + _vm._s(_vm.realestate.map_google_02_lat) + ", " + _vm._s(_vm.realestate.map_google_02_lng))])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center!important"
      },
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUpMapGoogle02($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-up",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoLeftMapGoogle02($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-left",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoRightMapGoogle02($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-right",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center!important"
      },
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoDownMapGoogle02($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-down",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])])])]), _vm._v(" "), _c('td', [_c('table', {
      staticStyle: {
        "width": "240px",
        "text-align": "center",
        "margin": "0 auto"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('span', {
      staticClass: "small"
    }, [_vm._v("zoom: " + _vm._s(_vm.realestate.map_google_02_zoom))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onDecreaseZoomMapGoogle02($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "minus",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onIncreaseZoomMapGoogle02($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])])])])])])])]), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), (_vm.realestate.map_google_03_url) ? _c('div', [_c('div', {
      staticStyle: {
        "background": "transparent",
        "padding": "2em",
        "border": "1px solid lightgray",
        "margin": "2em",
        "box-shadow": "0 2px 4px rgba(0, 0, 0, 0.04)"
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "center",
        "padding-bottom": "1em"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('Map')) + " 3/3")])]), _vm._v(" "), _c('div', [_c('img', {
      attrs: {
        "src": _vm.realestate.map_google_03_url,
        "width": "640px",
        "height": "480px"
      }
    })]), _vm._v(" "), _c('div', [_c('table', {
      staticStyle: {
        "width": "640px",
        "text-align": "center"
      }
    }, [_c('tr', [_c('td', [_c('table', {
      staticStyle: {
        "width": "240px",
        "text-align": "center",
        "margin": "0 auto"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('span', {
      staticClass: "small"
    }, [_vm._v("center: " + _vm._s(_vm.realestate.map_google_03_lat) + ", " + _vm._s(_vm.realestate.map_google_03_lng))])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center!important"
      },
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUpMapGoogle03($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-up",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoLeftMapGoogle03($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-left",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoRightMapGoogle03($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-right",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center!important"
      },
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoDownMapGoogle03($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-down",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])])])]), _vm._v(" "), _c('td', [_c('table', {
      staticStyle: {
        "width": "240px",
        "text-align": "center",
        "margin": "0 auto"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('span', {
      staticClass: "small"
    }, [_vm._v("zoom: " + _vm._s(_vm.realestate.map_google_03_zoom))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onDecreaseZoomMapGoogle03($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "minus",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onIncreaseZoomMapGoogle03($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])])])])])])])]), _vm._v(" "), _c('div')]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (this.realestate.lat && this.realestate.lng) ? _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Area_prices')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [
      [_c('gmap-map', {
        staticStyle: {
          "width": "100vw",
          "height": "40vw"
        },
        attrs: {
          "center": {
            lat: this.realestate.lat,
            lng: this.realestate.lng
          },
          "zoom": 16,
          "options": {
            styles: _vm.mapStyles,
            scrollwheel: false
          }
        }
      }, [_vm._l((this.realestate.area_ads_markers), function(m, index) {
        return _c('gmap-marker', {
          key: index,
          attrs: {
            "position": m.position,
            "clickable": true,
            "draggable": false,
            "opacity": m.opacity,
            "title": m.title,
            "label": m.label,
            "icon": m.icon
          },
          on: {
            "click": function($event) {
              _vm.openAdUrl(m.url)
            }
          }
        })
      }), _vm._v(" "), _c('gmap-marker', {
        key: 9999,
        attrs: {
          "position": {
            lat: this.realestate.lat,
            lng: this.realestate.lng
          },
          "clickable": false,
          "draggable": false
        }
      })], 2)]
    ], 2), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Area_average_unit_price')))]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.realestate.area_average_price)) + " €/m²")])])]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Max_distance')) + " (Km.)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.area_ads_query_distance),
        expression: "realestate.area_ads_query_distance"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false",
        "min": "0.1",
        "step": "0.1",
        "max": "60"
      },
      domProps: {
        "value": (_vm.realestate.area_ads_query_distance)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.area_ads_query_distance = $event.target.value
        }, _vm.set_realestate_area_ads_query_distance],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Ads_date_range')))]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(this.prices_startdate_readformat) + " - " + _vm._s(this.prices_limitdate_readformat))])])])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('button', {
      staticClass: "quote-request__aux__button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCheckPrices($event)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.onCheckPrices($event)
        }
      }
    }, [_c('span', [_c('icon', {
      attrs: {
        "name": "globe",
        "scale": "1",
        "color": "rgb(0, 79, 146)"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Check_prices')))], 1)])]), _vm._v(" "), (_vm.check_prices_loading) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "1",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Loading')) + "...")], 1)]) : _vm._e()]), _vm._v(" "), (this.realestate.area_ads_markers) ? _c('div', {
      staticClass: "field-container"
    }, [_c('span', [_vm._v("* Nota: La següent és una selecció automàtica dels anuncis més propers a l'immoble extistents a la base de dades de BARNA-TASA, S.A.")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('table', [_c('tr', [_c('th', {
      staticStyle: {
        "width": "60px",
        "text-align": "center"
      }
    }, [_vm._v("#")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "160px",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(_vm.$t('Actions')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Address')))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "320px"
      }
    }, [_vm._v(_vm._s(_vm.$t('Offer_unit_price')))])]), _vm._v(" "), _vm._l((this.realestate.area_ads_markers), function(m, index) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('table', {
        staticStyle: {
          "border": "none"
        }
      }, [_c('tr', [_c('td', {
        staticStyle: {
          "border": "none",
          "padding": "0.1rem"
        }
      }, [_c('a', {
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            _vm.openAdUrl(m.url)
          }
        }
      }, [_c('icon', {
        attrs: {
          "name": "link",
          "scale": ".9",
          "color": "gray"
        }
      })], 1)]), _vm._v(" "), _c('td', {
        staticStyle: {
          "border": "none",
          "padding": "0.1rem"
        }
      }, [_c('a', {
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            _vm.discardAd(index)
          }
        }
      }, [_c('icon', {
        attrs: {
          "name": "times",
          "scale": ".9",
          "color": "gray"
        }
      })], 1)])])])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(m.address))]), _vm._v(" "), _c('td', {
        style: (_vm.backgroundStyle(m.step))
      }, [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(m.unit_price)) + " €/m²")])])])
    })], 2)])]) : _vm._e(), _vm._v(" "), (this.realestate.lat && this.realestate.lng) ? _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Pre_appraisal')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Area_average_unit_price')) + " (€/m²)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.area_average_price),
        expression: "realestate.area_average_price"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.area_average_price)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.area_average_price = $event.target.value
        }, _vm.set_realestate_area_average_price],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Area_average_price_coef')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.area_average_price_coef),
        expression: "realestate.area_average_price_coef"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false",
        "step": "0.01"
      },
      domProps: {
        "value": (_vm.realestate.area_average_price_coef)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.area_average_price_coef = $event.target.value
        }, _vm.set_realestate_area_average_price_coef],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Adopted_area_average_price')))]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.realestate.adopted_area_average_price)) + " €/m²")])])])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Estimated_built_area')) + " (m²)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.estimated_built_area),
        expression: "realestate.estimated_built_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.estimated_built_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.estimated_built_area = $event.target.value
        }, _vm.set_realestate_estimated_built_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Pre_appraisal_value')))]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.realestate.pre_appraisal_value)) + " €")])])]), _vm._v(" "), (!this.realestate.estimated_built_area) ? _c('div', [_c('message', {
      attrs: {
        "text": "Falta indicar la superfície estimada",
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : _vm._e()])]) : _vm._e()])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.appraisal_cost_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Pressupost')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.quote_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Quote')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.quote_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Presupuesto')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.quote_text) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Travel_expenses')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Travel_one_way_hours')) + " (h)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.travel_one_way_hours),
        expression: "realestate.travel_one_way_hours"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.travel_one_way_hours)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.travel_one_way_hours = $event.target.value
        }, _vm.set_realestate_travel_one_way_hours],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Travel_both_ways_hours')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.realestate.travel_both_ways_hours) + " h")])]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Travel_fees_per_hour')) + " (€/h)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.travel_fees_per_hour),
        expression: "realestate.travel_fees_per_hour"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.travel_fees_per_hour)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.travel_fees_per_hour = $event.target.value
        }, _vm.set_realestate_travel_fees_per_hour],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Car_fuel_expenses_one_way')) + " (€)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.car_fuel_expenses_one_way),
        expression: "realestate.car_fuel_expenses_one_way"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.car_fuel_expenses_one_way)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.car_fuel_expenses_one_way = $event.target.value
        }, _vm.set_realestate_car_fuel_expenses_one_way],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Car_fuel_expenses_both_ways')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.realestate.car_fuel_expenses_both_ways) + " €")])]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Car_toll_expenses_one_way')) + " (€)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.car_toll_expenses_one_way),
        expression: "realestate.car_toll_expenses_one_way"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.car_toll_expenses_one_way)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.car_toll_expenses_one_way = $event.target.value
        }, _vm.set_realestate_car_toll_expenses_one_way],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Car_toll_expenses_both_ways')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.realestate.car_toll_expenses_both_ways) + " €")])])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Total_travel_fees')))]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.realestate.total_travel_fees) + " €")])])])])]), _vm._v(" "), _c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Appraisal_fees')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Acc_eco_decree_q')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.quote_appraisal_type_is_eco),
        expression: "realestate.quote_appraisal_type_is_eco"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.realestate.quote_appraisal_type_is_eco) ? _vm._i(_vm.realestate.quote_appraisal_type_is_eco, null) > -1 : (_vm.realestate.quote_appraisal_type_is_eco)
      },
      on: {
        "click": _vm.set_realestate_quote_appraisal_type_is_eco,
        "__c": function($event) {
          var $$a = _vm.realestate.quote_appraisal_type_is_eco,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.realestate.quote_appraisal_type_is_eco = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.realestate.quote_appraisal_type_is_eco = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.realestate.quote_appraisal_type_is_eco = $$c
          }
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Pre_appraisal_value')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.realestate.pre_appraisal_value)) + " €")])]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Quote_base_fees')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.quote_base_fees),
        expression: "realestate.quote_base_fees"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.quote_base_fees)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.quote_base_fees = $event.target.value
        }, _vm.set_realestate_quote_base_fees],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Quote_excess_pct')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.quote_excess_pct),
        expression: "realestate.quote_excess_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.quote_excess_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.quote_excess_pct = $event.target.value
        }, _vm.set_realestate_quote_excess_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Quote_base_price_coef')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.quote_base_price_coef),
        expression: "realestate.quote_base_price_coef"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.quote_base_price_coef)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.quote_base_price_coef = $event.target.value
        }, _vm.set_realestate_quote_base_price_coef],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Quote_base_price')))]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.realestate.quote_base_price) + " €")])])])])]), _vm._v(" "), _c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Valuation_pricing_info_table')))]), _vm._v(" "), (_vm.realestate.property_type) ? _c('div', {
      staticClass: "field-container"
    }, [_c('div', [(_vm.realestate.property_type.name_db === 'residential' || _vm.realestate.property_type.name_db === 'parking' || _vm.realestate.property_type.name_db === 'storage') ? _c('div', [_c('h4', {
      staticStyle: {
        "color": "midnightblue"
      }
    }, [_vm._v(_vm._s(_vm.$t('Dwellings')) + ", " + _vm._s(_vm.$t('Parking_spaces')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('Storerooms')))]), _vm._v(" "), _c('table', {
      staticClass: "d-table-center"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('Appraisal_value')) + " " + _vm._s(_vm.$t('in_01')) + " " + _vm._s(_vm.$t('thousands_of_euros')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Mortgage_Appraisal_Fees')) + " *"), _c('sup', [_vm._v("1")]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t*"), _c('sup', [_vm._v("2")])]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Informative_Appraisal_Fees')) + "  *"), _c('sup', [_vm._v("2")])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.valuation_prices.group_A), function(range, key, index) {
      return (index < 6) ? _c('tr', [_c('td', [_vm._v(_vm._s(range.floor / 1000) + " a " + _vm._s(range.ceil / 1000) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(range.mortgage_valuation_fee) + " €\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"), (range.increment_pct_mortgage_valuation > 0) ? _c('span', {
        staticClass: "small"
      }, [_vm._v("\n\t\t\t\t\t\t+ " + _vm._s(range.increment_pct_mortgage_valuation) + " % " + _vm._s(_vm.$t('of_the_excess_of')) + " " + _vm._s(range.floor / 1000) + " " + _vm._s(_vm.$t('thousand')) + "\n\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(range.standard_valuation_fee) + " €\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"), (range.increment_pct_standard_valuation > 0) ? _c('span', {
        staticClass: "small"
      }, [_vm._v("\n\t\t\t\t\t\t+ " + _vm._s(range.increment_pct_standard_valuation) + " % " + _vm._s(_vm.$t('of_the_excess_of')) + " " + _vm._s(range.floor / 1000) + " " + _vm._s(_vm.$t('thousand')) + "\n\t\t\t\t\t\t")]) : _vm._e()])]) : _vm._e()
    }), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" " + _vm._s(_vm.$t('Higher_values')))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.$t('acc_Budget')))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.$t('acc_Budget')))])])], 2)])]) : (_vm.realestate.property_type.name_db === 'retail_and_industrial' || _vm.realestate.property_type.name_db === 'office') ? _c('div', [_c('h4', {
      staticStyle: {
        "color": "midnightblue"
      }
    }, [_vm._v(_vm._s(_vm.$t('Commercial_premises')) + ", " + _vm._s(_vm.$t('Offices')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('Industrial_warehouses')))]), _vm._v(" "), _c('table', {
      staticClass: "d-table-center"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('Appraisal_value')) + " " + _vm._s(_vm.$t('in_01')) + " " + _vm._s(_vm.$t('thousands_of_euros')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Mortgage_Appraisal_Fees')) + " *"), _c('sup', [_vm._v("1")]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t*"), _c('sup', [_vm._v("2")])]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Informative_Appraisal_Fees')) + "  *"), _c('sup', [_vm._v("2")])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.valuation_prices.group_B), function(range, key, index) {
      return (index < 5) ? _c('tr', [_c('td', [_vm._v(_vm._s(range.floor / 1000) + " a " + _vm._s(range.ceil / 1000) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(range.mortgage_valuation_fee) + " €\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"), (range.increment_pct_mortgage_valuation > 0) ? _c('span', {
        staticClass: "small"
      }, [_vm._v("\n\t\t\t\t\t\t+ " + _vm._s(range.increment_pct_mortgage_valuation) + " % " + _vm._s(_vm.$t('of_the_excess_of')) + " " + _vm._s(range.floor / 1000) + " " + _vm._s(_vm.$t('thousand')) + "\n\t\t\t\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(range.standard_valuation_fee) + " €\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"), (range.increment_pct_standard_valuation > 0) ? _c('span', {
        staticClass: "small"
      }, [_vm._v("\n\t\t\t\t\t\t+ " + _vm._s(range.increment_pct_standard_valuation) + " % " + _vm._s(_vm.$t('of_the_excess_of')) + " " + _vm._s(range.floor / 1000) + " " + _vm._s(_vm.$t('thousand')) + "\n\t\t\t\t\t\t")]) : _vm._e()])]) : _vm._e()
    }), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" " + _vm._s(_vm.$t('Higher_values')))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.$t('acc_Budget')))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.$t('acc_Budget')))])])], 2)])]) : (_vm.realestate.property_type.name_db === 'entire_buildings' || _vm.realestate.property_type.name_db === 'land') ? _c('div', [_c('h4', {
      staticStyle: {
        "color": "midnightblue"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Buildings')) + ", " + _vm._s(_vm.$t('Property_developments')) + ", " + _vm._s(_vm.$t('Properties_under_economic_exploitation')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('Land_pl')))]), _vm._v(" "), _c('table', {
      staticClass: "d-table-center"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('Appraisal_value')) + " " + _vm._s(_vm.$t('in_01')) + " " + _vm._s(_vm.$t('thousands_of_euros')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Fees')) + " *"), _c('sup', [_vm._v("2")])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.valuation_prices.group_C), function(range, key, index) {
      return (index < 6) ? _c('tr', [_c('td', [_vm._v(_vm._s(range.floor / 1000) + " a " + _vm._s(range.ceil / 1000) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(range.standard_valuation_fee) + " €\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t"), (range.increment_pct_standard_valuation > 0) ? _c('span', {
        staticClass: "small"
      }, [_vm._v("\n\t\t\t\t\t\t+ " + _vm._s(range.increment_pct_standard_valuation) + " % " + _vm._s(_vm.$t('of_the_excess_of')) + " " + _vm._s(range.floor / 1000) + " " + _vm._s(_vm.$t('thousand')) + "\n\t\t\t\t\t\t")]) : _vm._e()])]) : _vm._e()
    }), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" " + _vm._s(_vm.$t('Higher_values')))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.$t('acc_Budget')))])])], 2)])]) : _c('div', [_c('h4', {
      staticStyle: {
        "color": "midnightblue"
      }
    }, [_vm._v(_vm._s(_vm.$t('Machinery')) + ", " + _vm._s(_vm.$t('Expropriations')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('others')) + ": "), _c('span', {
      staticStyle: {
        "color": "gray"
      }
    }, [_vm._v(_vm._s(_vm.$t('acc_Budget')))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "small"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t*"), _c('sup'), _vm._v(" " + _vm._s(_vm.$t('Pricing_text_03')) + ".\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t*"), _c('sup', [_vm._v("1")]), _vm._v(" " + _vm._s(_vm.$t('Pricing_text_04')) + ".\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t*"), _c('sup', [_vm._v("2")]), _vm._v(" " + _vm._s(_vm.$t('Pricing_text_05')) + ".\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('br')])]) : _vm._e()])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.marketstudies_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Estudis de mercat')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.marketstudies_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Market studies')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.marketstudies_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Estudios de mercado')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.marketstudies_text))]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Market_studies_for_this_real_estate')))]), _vm._v(" "), (_vm.object_length(_vm.realestate_marketstudies) > 0) ? _c('div', [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell",
      attrs: {
        "layout": "row"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.marketstudy_table.filter),
        expression: "marketstudy_table.filter"
      }],
      attrs: {
        "type": "text",
        "placeholder": _vm.filter_placeholder,
        "self": "size-x1",
        "data-intro": "You can filter the data in a datatable by typing in any of the filter fields",
        "data-step": "9",
        "data-position": "top"
      },
      domProps: {
        "value": (_vm.marketstudy_table.filter)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.marketstudy_table.filter = $event.target.value
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('paginator', {
      attrs: {
        "source": _vm.object_to_array(_vm.realestate_marketstudies),
        "page-size": 10,
        "filter": _vm.marketstudy_table.filter,
        "data-intro": "Use the paginator to page data for easier viewing",
        "data-step": "10",
        "data-position": "top"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(page) {
          return [_c('datatable', {
            attrs: {
              "id": "data-table-marketstudy",
              "source": page.data,
              "filterable": false,
              "striped": _vm.marketstudy_table.striped,
              "editable": _vm.marketstudy_table.editable,
              "line-numbers": _vm.marketstudy_table.lineNumbers
            },
            scopedSlots: _vm._u([{
              key: "actions-marketstudy",
              fn: function(cell) {
                return [_c('table', {
                  staticClass: "actions-table"
                }, [_c('tr', [_c('td', {
                  staticClass: "actions_td"
                }, [_c('a', {
                  staticStyle: {
                    "cursor": "pointer"
                  },
                  attrs: {
                    "title": _vm.edit_text
                  },
                  on: {
                    "click": function($event) {
                      _vm.editMarketStudy(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "pencil",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1)])])])]
              }
            }])
          }, [_vm._l((_vm.marketstudy_table.columns), function(column) {
            return _c('datatable-column', {
              attrs: {
                "id": column.id,
                "label": column.label,
                "width": column.width,
                "sortable": column.sortable,
                "groupable": column.groupable,
                "formatter": column.formatter
              }
            })
          }), _vm._v(" "), _c('datatable-column', {
            attrs: {
              "id": "actions-marketstudy",
              "label": _vm.actions_text,
              "sortable": false,
              "groupable": false
            }
          })], 2)]
        }
      }])
    })], 1)])]) : _vm._e()])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.appraisals_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Taxacions')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.appraisals_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Appraisals')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.appraisals_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Tasaciones')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.appraisals_text))]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Appraisals_of_the_Real_Estate')))]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCreateNewAppraisal($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus-circle",
        "text": _vm.new_appraisal_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), (_vm.object_length(_vm.realestate_appraisals) > 0) ? _c('div', [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell",
      attrs: {
        "layout": "row"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal_table.filter),
        expression: "appraisal_table.filter"
      }],
      attrs: {
        "type": "text",
        "placeholder": _vm.filter_placeholder,
        "self": "size-x1",
        "data-intro": "You can filter the data in a datatable by typing in any of the filter fields",
        "data-step": "9",
        "data-position": "top"
      },
      domProps: {
        "value": (_vm.appraisal_table.filter)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal_table.filter = $event.target.value
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('paginator', {
      attrs: {
        "source": _vm.object_to_array(_vm.realestate_appraisals),
        "page-size": 10,
        "filter": _vm.appraisal_table.filter,
        "data-intro": "Use the paginator to page data for easier viewing",
        "data-step": "10",
        "data-position": "top"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(page) {
          return [_c('datatable', {
            attrs: {
              "id": "data-table-appraisal",
              "source": page.data,
              "filterable": false,
              "striped": _vm.appraisal_table.striped,
              "editable": _vm.appraisal_table.editable,
              "line-numbers": _vm.appraisal_table.lineNumbers
            },
            scopedSlots: _vm._u([{
              key: "actions-appraisal",
              fn: function(cell) {
                return [_c('table', {
                  staticClass: "actions-table"
                }, [_c('tr', [_c('td', [_c('a', {
                  staticStyle: {
                    "cursor": "pointer"
                  },
                  attrs: {
                    "title": _vm.edit_text
                  },
                  on: {
                    "click": function($event) {
                      _vm.editAppraisal(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "pencil",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1)]), _vm._v(" "), _c('td', [_c('a', {
                  staticStyle: {
                    "cursor": "pointer"
                  },
                  attrs: {
                    "title": _vm.duplicate_text
                  },
                  on: {
                    "click": function($event) {
                      _vm.duplicateAppraisal(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "files-o",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1)]), _vm._v(" "), _c('td', [_c('a', {
                  staticStyle: {
                    "cursor": "pointer"
                  },
                  attrs: {
                    "title": _vm.delete_text
                  },
                  on: {
                    "click": function($event) {
                      _vm.deleteAppraisal(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "trash-o",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1)])])])]
              }
            }])
          }, [_vm._l((_vm.appraisal_table.columns), function(column) {
            return _c('datatable-column', {
              attrs: {
                "id": column.id,
                "label": column.label,
                "width": column.width,
                "sortable": column.sortable,
                "groupable": column.groupable,
                "formatter": column.formatter
              }
            })
          }), _vm._v(" "), _c('datatable-column', {
            attrs: {
              "id": "actions-appraisal",
              "label": _vm.actions_text,
              "sortable": false,
              "groupable": false
            }
          })], 2)]
        }
      }])
    })], 1)])]) : _vm._e()])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.projects_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Projectes')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.projects_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Projects')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.projects_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Proyectos')
        }
      },
      slot: "title"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.projects_text) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Projects_of_the_Real_Estate')))]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCreateNewProject($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus-circle",
        "text": _vm.new_project_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), (_vm.object_length(_vm.realestate_projects) > 0) ? _c('div', [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell",
      attrs: {
        "layout": "row"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.project_table.filter),
        expression: "project_table.filter"
      }],
      attrs: {
        "type": "text",
        "placeholder": _vm.filter_placeholder,
        "self": "size-x1",
        "data-intro": "You can filter the data in a datatable by typing in any of the filter fields",
        "data-step": "9",
        "data-position": "top"
      },
      domProps: {
        "value": (_vm.project_table.filter)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.project_table.filter = $event.target.value
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('paginator', {
      attrs: {
        "source": _vm.object_to_array(_vm.realestate_projects),
        "page-size": 10,
        "filter": _vm.project_table.filter,
        "data-intro": "Use the paginator to page data for easier viewing",
        "data-step": "10",
        "data-position": "top"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(page) {
          return [_c('datatable', {
            attrs: {
              "id": "data-table-project",
              "source": page.data,
              "filterable": false,
              "striped": _vm.project_table.striped,
              "editable": _vm.project_table.editable,
              "line-numbers": _vm.project_table.lineNumbers
            },
            scopedSlots: _vm._u([{
              key: "actions-project",
              fn: function(cell) {
                return [_c('table', {
                  staticClass: "actions-table"
                }, [_c('tr', [_c('td', [_c('a', {
                  staticStyle: {
                    "cursor": "pointer"
                  },
                  attrs: {
                    "title": _vm.edit_text
                  },
                  on: {
                    "click": function($event) {
                      _vm.editProject(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "pencil",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1)]), _vm._v(" "), _c('td', [_c('a', {
                  staticStyle: {
                    "cursor": "pointer"
                  },
                  attrs: {
                    "title": _vm.duplicate_text
                  },
                  on: {
                    "click": function($event) {
                      _vm.duplicateProject(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "files-o",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1)]), _vm._v(" "), _c('td', [_c('a', {
                  staticStyle: {
                    "cursor": "pointer"
                  },
                  attrs: {
                    "title": _vm.delete_text
                  },
                  on: {
                    "click": function($event) {
                      _vm.deleteProject(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "trash-o",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1)])])])]
              }
            }])
          }, [_vm._l((_vm.project_table.columns), function(column) {
            return _c('datatable-column', {
              attrs: {
                "id": column.id,
                "label": column.label,
                "width": column.width,
                "sortable": column.sortable,
                "groupable": column.groupable,
                "formatter": column.formatter
              }
            })
          }), _vm._v(" "), _c('datatable-column', {
            attrs: {
              "id": "actions-project",
              "label": _vm.actions_text,
              "sortable": false,
              "groupable": false
            }
          })], 2)]
        }
      }])
    })], 1)])]) : _vm._e()])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.metadata_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Versió')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.metadata_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Version')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.metadata_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Versión')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.metadata_text) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Description')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('RealEstate_description')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.realestate.description),
        expression: "realestate.description"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.realestate.description)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.realestate.description = $event.target.value
        }, _vm.set_realestate_description]
      }
    })])])])])])])])], 1), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUp($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "level-up",
        "text": _vm.goup_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentRealEstate({
            go_up: false
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentRealEstate({
            go_up: true
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_and_go_up_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), (_vm.realestate.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e()], 1)], 1)]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 2146 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auth",
    attrs: {
      "id": "login"
    }
  }, [_c('h1', {
    staticClass: "auth__title text-center"
  }, [_vm._v("Log In")]), _vm._v(" "), (_vm.error) ? _c('message', {
    attrs: {
      "text": _vm.error
    },
    on: {
      "closeMessage": _vm.closeMessage
    }
  }) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "auth__form"
  }, [_vm._l((_vm.fields), function(field) {
    return _c('field', {
      attrs: {
        "name": field.name,
        "type": field.type,
        "placeholder": field.placeholder,
        "autofocus": field.autofocus
      },
      model: {
        value: (field.value),
        callback: function($$v) {
          field.value = $$v
        },
        expression: "field.value"
      }
    })
  }), _vm._v(" "), _c('p', [_vm._v("* " + _vm._s(_vm.$t('Required_fields')))]), _vm._v(" "), _c('button', {
    staticClass: "auth__form__button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onLogIn($event)
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onLogIn($event)
      }
    }
  }, [_vm._v("\n\t  Log In\n\t")])], 2), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'signup',
        query: {
          email: this.fields.email.value
        }
      }
    }
  }, [_vm._v("\n\tNew here? Sign up\n  ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 2147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "appraisals-index"
    }
  }, [(_vm.loading) ? _c('spinner') : [_c('div', {
    staticClass: "app-container"
  }, [_c('bar'), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('Edit')) + " " + _vm._s(_vm.$t('telephonenumber'))), (_vm.telephonenumber.dirty) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.telephonenumber.dirty) ? _c('message', {
    attrs: {
      "text": _vm.page_dirty_text,
      "icon_name": "info",
      "icon_color": "rgb(0, 135, 248)",
      "border_color": "rgb(0, 135, 248)",
      "text_color": "rgb(0, 135, 248)"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "datedata"
  }, [_c('p', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('Created')) + ": " + _vm._s(_vm.millis_to_time(_vm.telephonenumber.date_created)))]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('Last_modified')) + ": " + _vm._s(_vm.millis_to_time(_vm.telephonenumber.date_modified)))])]), _vm._v(" "), _c('div', [_c('form', {
    staticClass: "bt-form"
  }, [_c('div', {
    staticClass: "section-container"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Telephone_number')))]), _vm._v(" "), _c('div', {
    staticClass: "field-container"
  }, [_c('div', {
    staticClass: "field__group"
  }, [_c('label', {
    staticClass: "field__group__label"
  }, [_vm._v(_vm._s(_vm.$t('Prefix')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telephonenumber.prefix),
      expression: "telephonenumber.prefix"
    }],
    staticClass: "field__group__input",
    attrs: {
      "type": "text",
      "spellcheck": "false"
    },
    domProps: {
      "value": (_vm.telephonenumber.prefix)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.telephonenumber.prefix = $event.target.value
      }, _vm.set_telephonenumber_prefix]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field__group"
  }, [_c('label', {
    staticClass: "field__group__label"
  }, [_vm._v(_vm._s(_vm.$t('Telephone_number')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telephonenumber.number),
      expression: "telephonenumber.number"
    }],
    staticClass: "field__group__input",
    attrs: {
      "type": "number",
      "step": "1",
      "spellcheck": "false"
    },
    domProps: {
      "value": (_vm.telephonenumber.number)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.telephonenumber.number = $event.target.value
      }, _vm.set_telephonenumber_number],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "section-container"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Description')))]), _vm._v(" "), _c('div', {
    staticClass: "field-container"
  }, [_c('div', {
    staticClass: "field__group"
  }, [_c('label', {
    staticClass: "field__group__label"
  }, [_vm._v(_vm._s(_vm.$t('Telephone_description')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telephonenumber.description),
      expression: "telephonenumber.description"
    }],
    staticClass: "field__group__input",
    attrs: {
      "type": "text",
      "spellcheck": "false"
    },
    domProps: {
      "value": (_vm.telephonenumber.description)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.telephonenumber.description = $event.target.value
      }, _vm.set_telephonenumber_description]
    }
  })])])]), _vm._v(" "), _c('div', [_c('hr')]), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "width": "fit-content",
      "margin-left": "auto"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onGoBack($event)
      }
    }
  }, [_c('icon-button', {
    attrs: {
      "icon": "chevron-left",
      "text": _vm.goback_button_text,
      "icon_color": "black",
      "text_color": "black",
      "border_color": "lightgray"
    }
  })], 1)]), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "width": "fit-content",
      "margin-left": "auto"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onSaveCurrentTelephoneNumber({
          goback: true
        })
      }
    }
  }, [_c('icon-button', {
    attrs: {
      "icon": "floppy-o",
      "text": _vm.save_button_text,
      "icon_color": "white",
      "text_color": "white",
      "border_color": "#006bc5",
      "background_color": "#0087F8"
    }
  })], 1)]), _vm._v(" "), (_vm.telephonenumber.dirty) ? _c('message', {
    attrs: {
      "text": _vm.page_dirty_text,
      "icon_name": "info",
      "icon_color": "rgb(0, 135, 248)",
      "border_color": "rgb(0, 135, 248)",
      "text_color": "rgb(0, 135, 248)"
    }
  }) : _vm._e()], 1)])], 1)]], 2)
},staticRenderFns: []}

/***/ }),
/* 2148 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page__foot"
  }, [_c('div', {
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('span', {
    staticClass: "footer-item"
  }, [_c('icon', {
    attrs: {
      "name": "copyright",
      "scale": "1"
    }
  }), _vm._v(" 2017 - BARNA-TASA, S.A.")], 1), _vm._v(" "), _c('span', {
    staticClass: "footer-item"
  }, [_c('icon', {
    attrs: {
      "name": "home",
      "scale": "1"
    }
  }), _vm._v(" Carrer de Còrsega, 168, 1º 1ª, 08036 - Barcelona")], 1), _vm._v(" "), _c('span', {
    staticClass: "footer-item"
  }, [_c('icon', {
    attrs: {
      "name": "phone",
      "scale": "1"
    }
  }), _vm._v(" (+34) 93 410 05 32")], 1), _vm._v(" "), _c('span', {
    staticClass: "footer-item"
  }, [_c('icon', {
    attrs: {
      "name": "envelope",
      "scale": "1"
    }
  }), _vm._v(" info@barnatasa.com")], 1)])])
},staticRenderFns: []}

/***/ }),
/* 2149 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home",
    class: _vm.theme,
    attrs: {
      "id": "services-page"
    }
  }, [_c('nav-bar'), _vm._v(" "), _c('swiper', {
    ref: "mySwiper3",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticStyle: {
      "height": "100%",
      "background-image": "url('../assets/img/b1.jpg')",
      "background-size": "cover",
      "background-repeat": "no-repeat"
    }
  }, [_c('div', {
    staticClass: "slide-center"
  }, [_c('h1', {
    staticClass: "page__title-white"
  }, [_vm._v(_vm._s(_vm.$t('Customer_Service')))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "page",
    attrs: {
      "id": "quote-form"
    }
  }, [_c('h1', {
    staticClass: "page__title"
  }, [_vm._v(_vm._s(_vm.$t('Customer_Service')))]), _vm._v(" "), _c('hr', {
    staticClass: "page__hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "page__container main"
  }, [_c('div', [_c('p', [_c('strong', [_vm._v("BARNA- TASA S.A.")]), _vm._v(", " + _vm._s(_vm.$t('appraisal_company')) + ", " + _vm._s(_vm.$t('Customer_Service_text_01')) + " "), _c('strong', [_vm._v(_vm._s(_vm.$t('Customer_Service')))]), _vm._v(", " + _vm._s(_vm.$t('Customer_Service_text_02')) + ".\n\t\t\t\t")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_03')) + ":\n\t\t\t\t  ")]), _vm._v(" "), _c('ol', [_c('li', [_c('p', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_04')) + ".\n\t\t\t\t\t\t  ")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_05')) + ".\n\t\t\t\t\t\t  ")])])]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_06')) + ". " + _vm._s(_vm.$t('Customer_Service_text_09')) + ":\n\t\t\t\t")]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('a', {
    attrs: {
      "href": "https://www.boe.es/diario_boe/txt.php?id=BOE-A-2004-5290",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v(" →\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_12')) + ".")])])])]), _vm._v(" "), _c('li', [_c('p', [_c('a', {
    attrs: {
      "href": "https://www.boe.es/diario_boe/txt.php?id=BOE-A-2011-4117",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v(" →\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_10')) + ".")])])])]), _vm._v(" "), _c('li', [_c('p', [_c('a', {
    attrs: {
      "href": "https://www.boe.es/diario_boe/txt.php?id=BOE-A-2012-14363",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v(" →\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_11')) + ".")])])])])]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_13')) + ":\n\n\t\t\t\t  ")]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_14')) + ":\n\t\t\t\t\t\t")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$t('By')) + " " + _vm._s(_vm.$t('e-mail')) + ":\n\t\t\t\t\t  ")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_15')) + ":\n\t\t\t\t\t  ")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', [_c('u', [_vm._v(_vm._s(_vm.$t('Customer_Service_text_16')) + " "), _c('a', {
    attrs: {
      "href": "http://barnatasa.com/wordpress/wp-content/uploads/2016/07/Hoja_Reclam.pdf",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v(" →" + _vm._s(_vm.$t('link')))])]), _vm._v(". " + _vm._s(_vm.$t('Customer_Service_text_17')) + ":")])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_18')) + ".\n\n\t\t\t\t\t\t  ")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_19')) + ".\n\n\t\t\t\t\t\t  ")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_20')) + ".\n\n\t\t\t\t\t\t  ")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_21')) + ".\n\n\t\t\t\t\t\t  ")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_22')) + ".\n\n\t\t\t\t\t\t  ")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_23')) + ".\n\n\t\t\t\t\t\t  ")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_24')) + ".\n\n\t\t\t\t\t\t  ")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_25')) + ".\n\n\t\t\t\t\t\t  ")])])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "../assets/pdf/Reg_SAC.pdf",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v(" →\n\t\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_07')))])])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "../assets/pdf/Hoja_Reclam.pdf",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v(" → " + _vm._s(_vm.$t('Customer_Service_text_08')))])])]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_26')) + ":\n\n\t\t\t\t  ")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', [_vm._v("\n\n\t\t\t\t\tDepartamento de Conducta de Mercado y Reclamaciones\n\n\t\t\t\t  ")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\tc/ Alcalá, 48\n\n\t\t\t\t  ")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t28014- Madrid\n\n\t\t\t\t  ")]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$t('Customer_Service_text_27')) + ": "), _vm._m(7)])])])]), _vm._v(" "), _c('logo-bar'), _vm._v(" "), _c('footer-bar')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("BARNA-TASA S.A.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Servicio de atención al cliente")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Còrsega, 168, 1º 1ª")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("08036 - Barcelona")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('p', [_c('strong', [_vm._v("servicio.cliente@barnatasa.com")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('p', [_c('strong', [_vm._v("BARNA-TASA S.A.")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Servicio de atención al cliente")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Còrsega, 168, 1º 1ª")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("08036 - Barcelona")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("BANCO DE ESPAÑA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://clientebancario.bde.es",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v("Reclamaciones - Oficina Virtual (Banco de España)")])])
}]}

/***/ }),
/* 2150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview",
    attrs: {
      "id": "preview"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.loading) ? _c('spinner') : [_c('search', {
    attrs: {
      "preview": true
    }
  }), _vm._v(" "), _c('editor', {
    attrs: {
      "isPreview": true
    }
  }), _vm._v(" "), _c('foot')]], 2)])
},staticRenderFns: []}

/***/ }),
/* 2151 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "editor__ghost"
  }, [_c('div', {
    staticClass: "highlights",
    attrs: {
      "id": "highlights"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 2152 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "share-note"
  }, [_c('div', {
    staticClass: "share-note__container"
  }, [_c('div', {
    staticClass: "share-note__copy"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.noteUrl),
      expression: "noteUrl"
    }],
    staticClass: "share-note__url",
    attrs: {
      "id": "share-note-url",
      "readonly": "true"
    },
    domProps: {
      "value": (_vm.noteUrl)
    },
    on: {
      "focus": _vm.selectUrl,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.noteUrl = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "share-note__button",
    attrs: {
      "data-clipboard-text": _vm.noteUrl,
      "id": "clipboardjs"
    },
    on: {
      "click": _vm.onCopyLink
    }
  }, [_vm._v("\n        " + _vm._s(_vm.copyButtonText) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "share-note__permission"
  }, [_c('button', {
    staticClass: "share-note__checkbox",
    class: _vm.activeNote.is_public ? 'on' : 'off',
    on: {
      "click": _vm.onTogglePermission
    }
  }, [_vm._v("\n        " + _vm._s(_vm.activeNote.is_public ? "On" : "Off") + "\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "share-note__info"
  }, [_vm._v("Anyone with the link can view")])])]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.onDone
    }
  }, [_vm._v("\n    Done\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 2153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "share-note"
  }, [_c('div', {
    staticClass: "share-note__container"
  }, [_c('div', {
    staticClass: "share-note__copy"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.noteUrl),
      expression: "noteUrl"
    }],
    staticClass: "share-note__url",
    attrs: {
      "id": "share-note-url",
      "readonly": "true"
    },
    domProps: {
      "value": (_vm.noteUrl)
    },
    on: {
      "focus": _vm.selectUrl,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.noteUrl = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "share-note__button",
    attrs: {
      "data-clipboard-text": _vm.noteUrl,
      "id": "clipboardjs"
    },
    on: {
      "click": _vm.onCopyLink
    }
  }, [_vm._v("\n        " + _vm._s(_vm.copyButtonText) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "share-note__permission"
  }, [_c('button', {
    staticClass: "share-note__checkbox",
    class: _vm.activeNote.is_public ? 'on' : 'off',
    on: {
      "click": _vm.onTogglePermission
    }
  }, [_vm._v("\n        " + _vm._s(_vm.activeNote.is_public ? "On" : "Off") + "\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "share-note__info"
  }, [_vm._v("Anyone with the link can view")])])]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.onDone
    }
  }, [_vm._v("\n    Done\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 2154 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-map-container"
  }, [_c('div', {
    ref: "vue-map",
    staticClass: "vue-map"
  }), _vm._v(" "), _c('div', {
    staticClass: "vue-map-hidden"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
},staticRenderFns: []}

/***/ }),
/* 2155 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "foot"
  }, [(_vm.showShareNote && _vm.activeNote) ? _c('bar-share-note', {
    on: {
      "onDone": _vm.onShareNote
    }
  }) : _c('bar-actions', {
    on: {
      "onShareNote": _vm.onShareNote
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 2156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auth",
    attrs: {
      "id": "signup"
    }
  }, [_c('h1', {
    staticClass: "auth__title text-center"
  }, [_vm._v(_vm._s(_vm.$t('Sign_Up')))]), _vm._v(" "), (_vm.error) ? _c('message', {
    attrs: {
      "text": _vm.error
    },
    on: {
      "closeMessage": _vm.closeMessage
    }
  }) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "auth__form"
  }, [_vm._l((_vm.fields), function(field) {
    return _c('field', {
      attrs: {
        "name": field.name,
        "type": field.type,
        "placeholder": field.placeholder,
        "autofocus": field.autofocus
      },
      model: {
        value: (field.value),
        callback: function($$v) {
          field.value = $$v
        },
        expression: "field.value"
      }
    })
  }), _vm._v(" "), _c('p', [_vm._v("* " + _vm._s(_vm.$t('Required_fields')))]), _vm._v(" "), _c('button', {
    staticClass: "auth__form__button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onSignUp($event)
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onSignUp($event)
      }
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.$t('Sign_Up')) + "\n\n\n\t\t")])], 2), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'login',
        query: {
          email: this.fields.email.value
        }
      }
    }
  }, [_vm._v("\n\t\t" + _vm._s(_vm.$t('Have_an_account_q_Log_in')) + "\n\n\n\t")])], 1)
},staticRenderFns: []}

/***/ }),
/* 2157 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page__logobar"
  }, [_c('div', [_c('a', {
    attrs: {
      "href": "http://www.barnatasa.com/"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "4rem"
    },
    attrs: {
      "src": __webpack_require__(1132),
      "alt": "BARNA-TASA"
    }
  })])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "http://www.bde.es/"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "6rem"
    },
    attrs: {
      "src": __webpack_require__(1134),
      "alt": "BDE"
    }
  })])])])
}]}

/***/ }),
/* 2158 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paginator"
  }, [_c('div', {
    staticClass: "paginator-body"
  }, [_vm._t("default", null, {
    data: _vm.data,
    pageNumber: _vm.pageNumber
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "paginator-footer",
    attrs: {
      "layout": "row center-justify"
    }
  }, [_c('div', {
    staticClass: "paginator-button paginator-page-previous",
    on: {
      "click": _vm.movePrevious
    }
  }, [_c('span', [_vm._v("←")])]), _vm._v(" "), _c('div', {
    staticClass: "paginator-page-numbers"
  }, _vm._l((_vm.pages.length), function(num) {
    return _c('div', {
      staticClass: "paginator-button paginator-page-number",
      class: {
        'active': num === _vm.pageNumber
      },
      on: {
        "click": function($event) {
          _vm.moveTo(num)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(num))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "paginator-button paginator-page-next",
    on: {
      "click": _vm.moveNext
    }
  }, [_c('span', [_vm._v("→")])])])])
},staticRenderFns: []}

/***/ }),
/* 2159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    class: _vm.className,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 2160 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "appraisals-index"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "filesOpen": _vm.filesOpen,
        "fileOpen": _vm.fileOpen,
        "fileId": _vm.appraisalfile.id,
        "fileNumber": _vm.appraisalfile.number,
        "reportOpen": _vm.reportOpen,
        "reportNumber": _vm.appraisalreport.number,
        "versionNumber": _vm.appraisalreport.version,
        "realEstates": _vm.appraisalreport_realestates,
        "realEstateId": _vm.realestate.id,
        "reportId": _vm.appraisalreport.id
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('Appraisal')) + " " + _vm._s(_vm.$t('of')) + " "), (_vm.appraisal.property_type) ? _c('span', [(_vm.currentLocale == 'ca') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_ca))]) : (_vm.currentLocale == 'en') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_es))])]) : _vm._e(), _vm._v(" " + _vm._s(_vm.$t('with')) + " " + _vm._s(_vm.$t('date')) + " " + _vm._s(_vm.appraisal.appraisaldate) + " " + _vm._s(_vm.$t('at')) + " "), (_vm.realestate.street_name) ? _c('span', [_vm._v(_vm._s(_vm.realestate.street_name))]) : _vm._e(), (_vm.realestate.street_number) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.street_number))]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v(" " + _vm._s(_vm.realestate.door))]) : _vm._e(), _vm._v(" "), (_vm.appraisal.dirty) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.appraisal.realestate_adopted_appraisal_method) ? _c('div', [(_vm.currentLocale == 'ca') ? _c('h2', [_vm._v(_vm._s(_vm.appraisal.realestate_adopted_appraisal_method.name_ca) + ": " + _vm._s(_vm._f("formatNumber")(_vm.appraisal.realestate_total_adopted_value)) + " €")]) : (_vm.currentLocale == 'en') ? _c('h2', [_vm._v(_vm._s(_vm.appraisal.realestate_adopted_appraisal_method.name_ca) + ": " + _vm._s(_vm._f("formatNumber")(_vm.appraisal.realestate_total_adopted_value)) + " €")]) : _c('h2', [_vm._v(_vm._s(_vm.appraisal.realestate_adopted_appraisal_method.name_es) + ": " + _vm._s(_vm._f("formatNumber")(_vm.appraisal.realestate_total_adopted_value)) + " €")])]) : _vm._e(), _vm._v(" "), (_vm.appraisal.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "datedata"
    }, [_c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Created')) + ": " + _vm._s(_vm.millis_to_time(_vm.appraisal.date_created)))]), _vm._v(" "), _c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Last_modified')) + ": " + _vm._s(_vm.millis_to_time(_vm.appraisal.date_modified)))])]), _vm._v(" "), _c('vue-tabs', {
      model: {
        value: (_vm.tabName),
        callback: function($$v) {
          _vm.tabName = $$v
        },
        expression: "tabName"
      }
    }, [_c('v-tab', {
      attrs: {
        "title": _vm.General_data_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Dades generals')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.General_data_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('General data')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.General_data_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Datos generales')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.General_data_text))]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Elements_included_in_this_valuation')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Property_type')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.property_typeValue,
        "options": _vm.property_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_property_type
      },
      model: {
        value: (_vm.appraisal.property_type),
        callback: function($$v) {
          _vm.appraisal.property_type = $$v
        },
        expression: "appraisal.property_type"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Parking_spots_included_number')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.parking_spots_included_number),
        expression: "appraisal.parking_spots_included_number"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.parking_spots_included_number)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.parking_spots_included_number = $event.target.value
        }, _vm.set_appraisal_parking_spots_included_number],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Storage_room_included_in_appraisal')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.storage_room),
        expression: "appraisal.storage_room"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.storage_room) ? _vm._i(_vm.appraisal.storage_room, null) > -1 : (_vm.appraisal.storage_room)
      },
      on: {
        "click": _vm.set_appraisal_storage_room,
        "__c": function($event) {
          var $$a = _vm.appraisal.storage_room,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.storage_room = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.storage_room = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.storage_room = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Appraisal_type')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Appraisal_type')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.appraisalTypeValue,
        "options": _vm.appraisalTypeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ?
          'name_ca' : (_vm.currentLocale === 'en') ?
          'name_en' : 'name_es',
        "searchable": false
      },
      on: {
        "input": _vm.set_appraisal_type
      },
      model: {
        value: (_vm.appraisal.type),
        callback: function($$v) {
          _vm.appraisal.type = $$v
        },
        expression: "appraisal.type"
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Date')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('Appraisal_purpose')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Date_of_the_appraisal_value')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.appraisaldate),
        expression: "appraisal.appraisaldate"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "date",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.appraisaldate)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.appraisaldate = $event.target.value
        }, _vm.set_appraisal_appraisaldate]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Appraisal_purpose')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.appraisalPurposeValue,
        "options": _vm.appraisalPurposeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ?
          'name_ca' : (_vm.currentLocale === 'en') ?
          'name_en' : 'name_es',
        "searchable": false
      },
      on: {
        "input": _vm.set_appraisal_purpose
      },
      model: {
        value: (_vm.appraisal.purpose),
        callback: function($$v) {
          _vm.appraisal.purpose = $$v
        },
        expression: "appraisal.purpose"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Market_value_adjustment_pct')) + " (%)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.reduction_pct),
        expression: "appraisal.reduction_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.reduction_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.reduction_pct = $event.target.value
        }, _vm.set_appraisal_reduction_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), (_vm.loadingAppraisalPurpose) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "1",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Loading')) + "...")], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Notes'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.purpose_notes),
        expression: "appraisal.purpose_notes"
      }],
      staticClass: "field__group__textarea",
      attrs: {
        "rows": "5",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.purpose_notes)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.purpose_notes = $event.target.value
        }, _vm.set_appraisal_purpose_notes]
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Visit')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Visit_date'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.visitdate),
        expression: "appraisal.visitdate"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "date",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.visitdate)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.visitdate = $event.target.value
        }, _vm.set_appraisal_visitdate]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Technician_who_performed_the_visit'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.technician_visitingValue,
        "options": _vm.object_to_array(_vm.appraisers),
        "track-by": "id",
        "label": 'complete_name',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_technician_visiting
      },
      model: {
        value: (_vm.appraisal.technician_visiting),
        callback: function($$v) {
          _vm.appraisal.technician_visiting = $$v
        },
        expression: "appraisal.technician_visiting"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Cadastral_data')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Cadastral_reference')))]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.realestate.cadastral_reference) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('button', {
      staticClass: "quote-request__aux__button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onOpenCadastralFile($event)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.onOpenCadastralFile($event)
        }
      }
    }, [_c('span', [_c('icon', {
      attrs: {
        "name": "external-link",
        "scale": "1",
        "color": "rgb(0, 79, 146)"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Open')) + " " + _vm._s(_vm.$t('Cadastral_file')))], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Construction_year')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.cadastral_construction_year),
        expression: "appraisal.cadastral_construction_year"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.cadastral_construction_year)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.cadastral_construction_year = $event.target.value
        }, _vm.set_appraisal_cadastral_construction_year],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Usage')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.cadastral_usage),
        expression: "appraisal.cadastral_usage"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.cadastral_usage)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.cadastral_usage = $event.target.value
        }, _vm.set_appraisal_cadastral_usage]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Floor')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.cadastral_floor),
        expression: "appraisal.cadastral_floor"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.cadastral_floor)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.cadastral_floor = $event.target.value
        }, _vm.set_appraisal_cadastral_floor]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Door')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.cadastral_door),
        expression: "appraisal.cadastral_door"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.cadastral_door)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.cadastral_door = $event.target.value
        }, _vm.set_appraisal_cadastral_door]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Block')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.cadastral_block),
        expression: "appraisal.cadastral_block"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.cadastral_block)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.cadastral_block = $event.target.value
        }, _vm.set_appraisal_cadastral_block]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Staircase')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.cadastral_staircase),
        expression: "appraisal.cadastral_staircase"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.cadastral_staircase)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.cadastral_staircase = $event.target.value
        }, _vm.set_appraisal_cadastral_staircase]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Built_area')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.built_cadastral_area),
        expression: "appraisal.built_cadastral_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.built_cadastral_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.built_cadastral_area = $event.target.value
        }, _vm.set_appraisal_built_cadastral_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Common_elements_cadastral_area')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.common_elements_cadastral_area),
        expression: "appraisal.common_elements_cadastral_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.common_elements_cadastral_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.common_elements_cadastral_area = $event.target.value
        }, _vm.set_appraisal_common_elements_cadastral_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Built_plus_common_elements_area')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.built_plus_common_elements_cadastral_area),
        expression: "appraisal.built_plus_common_elements_cadastral_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.built_plus_common_elements_cadastral_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.built_plus_common_elements_cadastral_area = $event.target.value
        }, _vm.set_appraisal_built_plus_common_elements_cadastral_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Registry_data')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Registry')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.registry_name),
        expression: "appraisal.registry_name"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.registry_name)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.registry_name = $event.target.value
        }, _vm.set_appraisal_registry_name]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Section')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.registry_section),
        expression: "appraisal.registry_section"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.registry_section)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.registry_section = $event.target.value
        }, _vm.set_appraisal_registry_section]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Volume')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.registry_volume),
        expression: "appraisal.registry_volume"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.registry_volume)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.registry_volume = $event.target.value
        }, _vm.set_appraisal_registry_volume]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Book')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.registry_book),
        expression: "appraisal.registry_book"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.registry_book)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.registry_book = $event.target.value
        }, _vm.set_appraisal_registry_book]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Page')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.registry_page),
        expression: "appraisal.registry_page"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.registry_page)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.registry_page = $event.target.value
        }, _vm.set_appraisal_registry_page]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Registry_real_estate_number')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.registry_real_estate_number),
        expression: "appraisal.registry_real_estate_number"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.registry_real_estate_number)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.registry_real_estate_number = $event.target.value
        }, _vm.set_appraisal_registry_real_estate_number]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v("IDUFIR")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.registry_idufir),
        expression: "appraisal.registry_idufir"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.registry_idufir)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.registry_idufir = $event.target.value
        }, _vm.set_appraisal_registry_idufir]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Holder')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.registry_owner),
        expression: "appraisal.registry_owner"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.registry_owner)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.registry_owner = $event.target.value
        }, _vm.set_appraisal_registry_owner]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Property_coef')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.registry_property_coef),
        expression: "appraisal.registry_property_coef"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.registry_property_coef)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.registry_property_coef = $event.target.value
        }, _vm.set_appraisal_registry_property_coef],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Net_area')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.net_registry_area),
        expression: "appraisal.net_registry_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.net_registry_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.net_registry_area = $event.target.value
        }, _vm.set_appraisal_net_registry_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Enclosed_area')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.enclosed_registry_area),
        expression: "appraisal.enclosed_registry_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.enclosed_registry_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.enclosed_registry_area = $event.target.value
        }, _vm.set_appraisal_enclosed_registry_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Covered_outdoors_area')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.covered_terraces_total_registry_area),
        expression: "appraisal.covered_terraces_total_registry_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.covered_terraces_total_registry_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.covered_terraces_total_registry_area = $event.target.value
        }, _vm.set_appraisal_covered_terraces_total_registry_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Uncovered_outdoors_area')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.uncovered_terraces_total_registry_area),
        expression: "appraisal.uncovered_terraces_total_registry_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.uncovered_terraces_total_registry_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.uncovered_terraces_total_registry_area = $event.target.value
        }, _vm.set_appraisal_uncovered_terraces_total_registry_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Built_area')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.built_registry_area),
        expression: "appraisal.built_registry_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.built_registry_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.built_registry_area = $event.target.value
        }, _vm.set_appraisal_built_registry_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Built_plus_common_elements_area')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.built_plus_common_elements_registry_area),
        expression: "appraisal.built_plus_common_elements_registry_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.built_plus_common_elements_registry_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.built_plus_common_elements_registry_area = $event.target.value
        }, _vm.set_appraisal_built_plus_common_elements_registry_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.urban_and_surroundings_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Urbanisme i entorn')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.urban_and_surroundings_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Urban planning and surroundings')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.urban_and_surroundings_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Urbanismo y entorno')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.urban_and_surroundings_text))]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Urban_planning_parameters')))]), _vm._v(" "), (_vm.muc_info_loading) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "1",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Loading')) + "...")], 1)]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-right": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onRequestMucInfo($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "globe",
        "text": "MUC Info",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Plan_type'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.urban_planning_type),
        expression: "appraisal.urban_planning_type"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.urban_planning_type)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.urban_planning_type = $event.target.value
        }, _vm.set_appraisal_urban_planning_type]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('File'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.urban_planning_file),
        expression: "appraisal.urban_planning_file"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.urban_planning_file)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.urban_planning_file = $event.target.value
        }, _vm.set_appraisal_urban_planning_file]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Council_qualification'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.urban_planning_council_qualification),
        expression: "appraisal.urban_planning_council_qualification"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.urban_planning_council_qualification)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.urban_planning_council_qualification = $event.target.value
        }, _vm.set_appraisal_urban_planning_council_qualification]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Council_qualification_description'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.urban_planning_council_qualification_description),
        expression: "appraisal.urban_planning_council_qualification_description"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.urban_planning_council_qualification_description)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.urban_planning_council_qualification_description = $event.target.value
        }, _vm.set_appraisal_urban_planning_council_qualification_description]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Council_classification'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.urban_planning_council_classification),
        expression: "appraisal.urban_planning_council_classification"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.urban_planning_council_classification)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.urban_planning_council_classification = $event.target.value
        }, _vm.set_appraisal_urban_planning_council_classification]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Council_classification_description'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.urban_planning_council_classification_description),
        expression: "appraisal.urban_planning_council_classification_description"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.urban_planning_council_classification_description)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.urban_planning_council_classification_description = $event.target.value
        }, _vm.set_appraisal_urban_planning_council_classification_description]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Regional_qualification'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.urban_planning_regional_qualification),
        expression: "appraisal.urban_planning_regional_qualification"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.urban_planning_regional_qualification)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.urban_planning_regional_qualification = $event.target.value
        }, _vm.set_appraisal_urban_planning_regional_qualification]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Regional_qualification_description'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.urban_planning_regional_qualification_description),
        expression: "appraisal.urban_planning_regional_qualification_description"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.urban_planning_regional_qualification_description)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.urban_planning_regional_qualification_description = $event.target.value
        }, _vm.set_appraisal_urban_planning_regional_qualification_description]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Regional_classification'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.urban_planning_regional_classification),
        expression: "appraisal.urban_planning_regional_classification"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.urban_planning_regional_classification)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.urban_planning_regional_classification = $event.target.value
        }, _vm.set_appraisal_urban_planning_regional_classification]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Regional_classification_description'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.urban_planning_regional_classification_description),
        expression: "appraisal.urban_planning_regional_classification_description"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.urban_planning_regional_classification_description)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.urban_planning_regional_classification_description = $event.target.value
        }, _vm.set_appraisal_urban_planning_regional_classification_description]
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('MUC_map')))]), _vm._v(" "), (_vm.muc_map_01_loading) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "1",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Loading')) + " Map 01...")], 1)]) : _vm._e(), _vm._v(" "), (_vm.muc_map_02_loading) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "1",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Loading')) + " Map 02...")], 1)]) : _vm._e(), _vm._v(" "), (_vm.muc_map_03_loading) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "1",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Loading')) + " Map 03...")], 1)]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-right": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onRequestMucMap($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "globe",
        "text": "Mapa del MUC",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container",
      staticStyle: {
        "justify-content": "baseline!important"
      }
    }, [(_vm.appraisal.map_urban_muc_land_colors) ? _c('div', [_c('div', {
      staticStyle: {
        "background": "transparent",
        "padding": "2em",
        "border": "1px solid lightgray",
        "margin": "2em",
        "box-shadow": "0 2px 4px rgba(0, 0, 0, 0.04)"
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "center",
        "padding-bottom": "1em"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('Map')) + " 1/3")])]), _vm._v(" "), _c('div', [_c('img', {
      attrs: {
        "src": _vm.appraisal.map_urban_muc_land_colors,
        "width": "640px",
        "height": "480px"
      }
    })]), _vm._v(" "), _c('div', [_c('table', {
      staticStyle: {
        "width": "640px",
        "text-align": "center"
      }
    }, [_c('tr', [_c('td', [_c('table', {
      staticStyle: {
        "width": "240px",
        "text-align": "center",
        "margin": "0 auto"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    })]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center!important"
      },
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUpMapUrbanMuc($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-up",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoLeftMapUrbanMuc($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-left",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoRightMapUrbanMuc($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-right",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center!important"
      },
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoDownMapUrbanMuc($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-down",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])])])]), _vm._v(" "), _c('td', [_c('table', {
      staticStyle: {
        "width": "240px",
        "text-align": "center",
        "margin": "0 auto"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('span', {
      staticClass: "small"
    }, [_vm._v("zoom: " + _vm._s(_vm.appraisal.map_urban_muc_land_colors_zoom))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onDecreaseZoomMapUrbanMuc($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "minus",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onIncreaseZoomMapUrbanMuc($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])])])])])])])]), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), (_vm.appraisal.map_urban_muc_council_qual) ? _c('div', [_c('div', {
      staticStyle: {
        "background": "transparent",
        "padding": "2em",
        "border": "1px solid lightgray",
        "margin": "2em",
        "box-shadow": "0 2px 4px rgba(0, 0, 0, 0.04)"
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "center",
        "padding-bottom": "1em"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('Map')) + " 2/3")])]), _vm._v(" "), _c('div', [_c('img', {
      attrs: {
        "src": _vm.appraisal.map_urban_muc_council_qual,
        "width": "640px",
        "height": "480px"
      }
    })]), _vm._v(" "), _c('div', [_c('table', {
      staticStyle: {
        "width": "640px",
        "text-align": "center"
      }
    }, [_c('tr', [_c('td', [_c('table', {
      staticStyle: {
        "width": "240px",
        "text-align": "center",
        "margin": "0 auto"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    })]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center!important"
      },
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUpMapUrbanMuc($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-up",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoLeftMapUrbanMuc($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-left",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoRightMapUrbanMuc($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-right",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center!important"
      },
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoDownMapUrbanMuc($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-down",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])])])]), _vm._v(" "), _c('td', [_c('table', {
      staticStyle: {
        "width": "240px",
        "text-align": "center",
        "margin": "0 auto"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('span', {
      staticClass: "small"
    }, [_vm._v("zoom: " + _vm._s(_vm.appraisal.map_urban_muc_council_qual_zoom))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onDecreaseZoomMapUrbanMuc($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "minus",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onIncreaseZoomMapUrbanMuc($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])])])])])])])]), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), (_vm.appraisal.map_urban_icc_topo) ? _c('div', [_c('div', {
      staticStyle: {
        "background": "transparent",
        "padding": "2em",
        "border": "1px solid lightgray",
        "margin": "2em",
        "box-shadow": "0 2px 4px rgba(0, 0, 0, 0.04)"
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "center",
        "padding-bottom": "1em"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('Map')) + " 3/3")])]), _vm._v(" "), _c('div', [_c('img', {
      attrs: {
        "src": _vm.appraisal.map_urban_icc_topo,
        "width": "640px",
        "height": "480px"
      }
    })]), _vm._v(" "), _c('div', [_c('table', {
      staticStyle: {
        "width": "640px",
        "text-align": "center"
      }
    }, [_c('tr', [_c('td', [_c('table', {
      staticStyle: {
        "width": "240px",
        "text-align": "center",
        "margin": "0 auto"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    })]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center!important"
      },
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUpMapUrbanMuc($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-up",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoLeftMapUrbanMuc($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-left",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoRightMapUrbanMuc($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-right",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center!important"
      },
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoDownMapUrbanMuc($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "arrow-down",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])])])]), _vm._v(" "), _c('td', [_c('table', {
      staticStyle: {
        "width": "240px",
        "text-align": "center",
        "margin": "0 auto"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('span', {
      staticClass: "small"
    }, [_vm._v("zoom: " + _vm._s(_vm.appraisal.map_urban_icc_topo_zoom))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onDecreaseZoomMapUrbanMuc($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "minus",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin": "0 auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onIncreaseZoomMapUrbanMuc($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus",
        "text": "",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray",
        "min_width": "32px",
        "max_width": "32px"
      }
    })], 1)])])])])])])])]), _vm._v(" "), _c('div')]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "form-section"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Locality')))]), _vm._v(" "), (_vm.idescat_info_loading) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "1",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Loading')) + "...")], 1)]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-right": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onRequestIdescatInfoByCodeIne($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "globe",
        "text": "Idescat Info",
        "icon_color": "rgb(0, 79, 146)",
        "text_color": "rgb(0, 79, 146)",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Nucleus_area')) + " (km²)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.nucleus_area),
        expression: "appraisal.nucleus_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.nucleus_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.nucleus_area = $event.target.value
        }, _vm.set_appraisal_nucleus_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Population')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.nucleus_population),
        expression: "appraisal.nucleus_population"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.nucleus_population)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.nucleus_population = $event.target.value
        }, _vm.set_appraisal_nucleus_population],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Population_density')) + " (hab/km²)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.nucleus_population_density),
        expression: "appraisal.nucleus_population_density"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.nucleus_population_density)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.nucleus_population_density = $event.target.value
        }, _vm.set_appraisal_nucleus_population_density],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Population_growth')) + " (" + _vm._s(_vm.$t('Gross_tax_per_1000_inhabitants')) + ")")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.nucleus_population_growth),
        expression: "appraisal.nucleus_population_growth"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.nucleus_population_growth)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.nucleus_population_growth = $event.target.value
        }, _vm.set_appraisal_nucleus_population_growth],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Nucleus_type')))]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.nucleus_type),
        expression: "appraisal.nucleus_type"
      }],
      staticClass: "field__group__textarea",
      attrs: {
        "rows": "2",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.nucleus_type)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.nucleus_type = $event.target.value
        }, _vm.set_appraisal_nucleus_type]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Employment_occupation')))]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.occupation_description),
        expression: "appraisal.occupation_description"
      }],
      staticClass: "field__group__textarea",
      attrs: {
        "rows": "3",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.occupation_description)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.occupation_description = $event.target.value
        }, _vm.set_appraisal_occupation_description]
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Surroundings')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('table', [_c('tr', [_c('td', [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Territorial_feature'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.surrounding_territorial_featureValue,
        "options": _vm.territorial_featureOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_surrounding_territorial_feature
      },
      model: {
        value: (_vm.appraisal.surrounding_territorial_feature),
        callback: function($$v) {
          _vm.appraisal.surrounding_territorial_feature = $$v
        },
        expression: "appraisal.surrounding_territorial_feature"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Income_level'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.surrounding_income_levelValue,
        "options": _vm.quality_levelOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_surrounding_income_level
      },
      model: {
        value: (_vm.appraisal.surrounding_income_level),
        callback: function($$v) {
          _vm.appraisal.surrounding_income_level = $$v
        },
        expression: "appraisal.surrounding_income_level"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Homogeneity_feature'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.surrounding_homogeneity_featureValue,
        "options": _vm.homogeneity_featureOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_surrounding_homogeneity_feature
      },
      model: {
        value: (_vm.appraisal.surrounding_homogeneity_feature),
        callback: function($$v) {
          _vm.appraisal.surrounding_homogeneity_feature = $$v
        },
        expression: "appraisal.surrounding_homogeneity_feature"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Main_uses'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.surrounding_main_usesValue,
        "options": _vm.usage_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_surrounding_main_uses
      },
      model: {
        value: (_vm.appraisal.surrounding_main_uses),
        callback: function($$v) {
          _vm.appraisal.surrounding_main_uses = $$v
        },
        expression: "appraisal.surrounding_main_uses"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Density'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.surrounding_densityValue,
        "options": _vm.quality_levelOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_surrounding_density
      },
      model: {
        value: (_vm.appraisal.surrounding_density),
        callback: function($$v) {
          _vm.appraisal.surrounding_density = $$v
        },
        expression: "appraisal.surrounding_density"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Accessibility'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.surrounding_accessibilityValue,
        "options": _vm.accessibility_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_surrounding_accessibility
      },
      model: {
        value: (_vm.appraisal.surrounding_accessibility),
        callback: function($$v) {
          _vm.appraisal.surrounding_accessibility = $$v
        },
        expression: "appraisal.surrounding_accessibility"
      }
    })], 1)])])])])]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('Building_development_level')))]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('div', {
      staticClass: "field-container"
    }, [_c('table', [_c('tr', [_c('td', [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Consolidation_degree'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.surrounding_consolidation_degreeValue,
        "options": _vm.degree_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_surrounding_consolidation_degree
      },
      model: {
        value: (_vm.appraisal.surrounding_consolidation_degree),
        callback: function($$v) {
          _vm.appraisal.surrounding_consolidation_degree = $$v
        },
        expression: "appraisal.surrounding_consolidation_degree"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Occupation_degree'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.surrounding_occupation_degreeValue,
        "options": _vm.degree_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_surrounding_occupation_degree
      },
      model: {
        value: (_vm.appraisal.surrounding_occupation_degree),
        callback: function($$v) {
          _vm.appraisal.surrounding_occupation_degree = $$v
        },
        expression: "appraisal.surrounding_occupation_degree"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Evolution'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.surrounding_evolution_speedValue,
        "options": _vm.evolution_speedOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_surrounding_evolution_speed
      },
      model: {
        value: (_vm.appraisal.surrounding_evolution_speed),
        callback: function($$v) {
          _vm.appraisal.surrounding_evolution_speed = $$v
        },
        expression: "appraisal.surrounding_evolution_speed"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Average_age'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.surrounding_average_ageValue,
        "options": _vm.average_ageOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_surrounding_average_age
      },
      model: {
        value: (_vm.appraisal.surrounding_average_age),
        callback: function($$v) {
          _vm.appraisal.surrounding_average_age = $$v
        },
        expression: "appraisal.surrounding_average_age"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Conservation_status'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.surrounding_conservation_statusValue,
        "options": _vm.conservation_statusOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_surrounding_conservation_status
      },
      model: {
        value: (_vm.appraisal.surrounding_conservation_status),
        callback: function($$v) {
          _vm.appraisal.surrounding_conservation_status = $$v
        },
        expression: "appraisal.surrounding_conservation_status"
      }
    })], 1)])])])])]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('Facilities')))]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('div', {
      staticClass: "field-container"
    }, [_c('table', [_c('tr', [_c('td', [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Commercial'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.surrounding_commercial_facilitiesValue,
        "options": _vm.levelOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_surrounding_commercial_facilities
      },
      model: {
        value: (_vm.appraisal.surrounding_commercial_facilities),
        callback: function($$v) {
          _vm.appraisal.surrounding_commercial_facilities = $$v
        },
        expression: "appraisal.surrounding_commercial_facilities"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Educational'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.surrounding_educational_facilitiesValue,
        "options": _vm.levelOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_surrounding_educational_facilities
      },
      model: {
        value: (_vm.appraisal.surrounding_educational_facilities),
        callback: function($$v) {
          _vm.appraisal.surrounding_educational_facilities = $$v
        },
        expression: "appraisal.surrounding_educational_facilities"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Public_parking'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.surrounding_public_parkingValue,
        "options": _vm.levelOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_surrounding_public_parking
      },
      model: {
        value: (_vm.appraisal.surrounding_public_parking),
        callback: function($$v) {
          _vm.appraisal.surrounding_public_parking = $$v
        },
        expression: "appraisal.surrounding_public_parking"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Medical_assistance'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.surrounding_medical_assistanceValue,
        "options": _vm.levelOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_surrounding_medical_assistance
      },
      model: {
        value: (_vm.appraisal.surrounding_medical_assistance),
        callback: function($$v) {
          _vm.appraisal.surrounding_medical_assistance = $$v
        },
        expression: "appraisal.surrounding_medical_assistance"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Leisure'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.surrounding_leisureValue,
        "options": _vm.levelOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_surrounding_leisure
      },
      model: {
        value: (_vm.appraisal.surrounding_leisure),
        callback: function($$v) {
          _vm.appraisal.surrounding_leisure = $$v
        },
        expression: "appraisal.surrounding_leisure"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Notes'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.surrounding_facilities_notes),
        expression: "appraisal.surrounding_facilities_notes"
      }],
      staticClass: "field__group__textarea",
      attrs: {
        "rows": "3",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.surrounding_facilities_notes)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.surrounding_facilities_notes = $event.target.value
        }, _vm.set_appraisal_surrounding_facilities_notes]
      }
    })])])])])])])]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('Communications')))]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('div', {
      staticClass: "field-container"
    }, [_c('table', [_c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Airport'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.communications_airport),
        expression: "appraisal.communications_airport"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.communications_airport)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.communications_airport = $event.target.value
        }, _vm.set_appraisal_communications_airport]
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Harbour'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.communications_harbour),
        expression: "appraisal.communications_harbour"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.communications_harbour)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.communications_harbour = $event.target.value
        }, _vm.set_appraisal_communications_harbour]
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Train'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.communications_train),
        expression: "appraisal.communications_train"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.communications_train)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.communications_train = $event.target.value
        }, _vm.set_appraisal_communications_train]
      }
    })])])])])]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('Public_transport')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('table', [_c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Urban_underground'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.public_transport_urban_underground),
        expression: "appraisal.public_transport_urban_underground"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.public_transport_urban_underground)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.public_transport_urban_underground = $event.target.value
        }, _vm.set_appraisal_public_transport_urban_underground]
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Interurban'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.public_transport_interurban),
        expression: "appraisal.public_transport_interurban"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.public_transport_interurban)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.public_transport_interurban = $event.target.value
        }, _vm.set_appraisal_public_transport_interurban]
      }
    })])])])])])])])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.land_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Terreny')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.land_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Terrain')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.land_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Terreno')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.land_text))]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form",
      attrs: {
        "action": ""
      }
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Plot_area')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('table', {
      staticStyle: {
        "width": "40em"
      }
    }, [_c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Registry_area')) + " (m²)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_registry_area),
        expression: "appraisal.land_registry_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.land_registry_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.land_registry_area = $event.target.value
        }, _vm.set_appraisal_land_registry_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Cadastral_area')) + " (m²)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_cadastral_area),
        expression: "appraisal.land_cadastral_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.land_cadastral_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.land_cadastral_area = $event.target.value
        }, _vm.set_appraisal_land_cadastral_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Checked_area')) + " (m²)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_checked_area),
        expression: "appraisal.land_checked_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.land_checked_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.land_checked_area = $event.target.value
        }, _vm.set_appraisal_land_checked_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Land_selected_area')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.land_selected_areaValue,
        "options": _vm.selected_areaOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_land_selected_area
      },
      model: {
        value: (_vm.appraisal.land_selected_area),
        callback: function($$v) {
          _vm.appraisal.land_selected_area = $$v
        },
        expression: "appraisal.land_selected_area"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Adopted_area')) + " (m²)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_adopted_area),
        expression: "appraisal.land_adopted_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.land_adopted_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.land_adopted_area = $event.target.value
        }, _vm.set_appraisal_land_adopted_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Notes_on_plot_area')) + " "), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_area_notes),
        expression: "appraisal.land_area_notes"
      }],
      staticClass: "field__group__textarea",
      attrs: {
        "rows": "5",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.land_area_notes)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.land_area_notes = $event.target.value
        }, _vm.set_appraisal_land_area_notes]
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Land_is_plot_according_to_law')) + " "), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_is_plot_according_to_law),
        expression: "appraisal.land_is_plot_according_to_law"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.land_is_plot_according_to_law) ? _vm._i(_vm.appraisal.land_is_plot_according_to_law, null) > -1 : (_vm.appraisal.land_is_plot_according_to_law)
      },
      on: {
        "input": _vm.set_appraisal_land_is_plot_according_to_law,
        "__c": function($event) {
          var $$a = _vm.appraisal.land_is_plot_according_to_law,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.land_is_plot_according_to_law = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.land_is_plot_according_to_law = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.land_is_plot_according_to_law = $$c
          }
        }
      }
    })])])])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Plot_occupation')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Plot_occupation')) + " "), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.plot_occupationValue,
        "options": _vm.plot_occupationOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_plot_occupation
      },
      model: {
        value: (_vm.appraisal.plot_occupation),
        callback: function($$v) {
          _vm.appraisal.plot_occupation = $$v
        },
        expression: "appraisal.plot_occupation"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Plot_free_area_usage')) + " "), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.plot_free_area_usageValue,
        "options": _vm.plot_free_area_usageOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_plot_free_area_usage
      },
      model: {
        value: (_vm.appraisal.plot_free_area_usage),
        callback: function($$v) {
          _vm.appraisal.plot_free_area_usage = $$v
        },
        expression: "appraisal.plot_free_area_usage"
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Infrastructures')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('table', {
      staticStyle: {
        "width": "60em"
      }
    }, [_c('tr', [_c('td', {
      staticStyle: {
        "width": "20em"
      }
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Paving')) + " "), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_infrastructure_paving),
        expression: "appraisal.land_infrastructure_paving"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.land_infrastructure_paving) ? _vm._i(_vm.appraisal.land_infrastructure_paving, null) > -1 : (_vm.appraisal.land_infrastructure_paving)
      },
      on: {
        "click": _vm.set_appraisal_land_infrastructure_paving,
        "__c": function($event) {
          var $$a = _vm.appraisal.land_infrastructure_paving,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.land_infrastructure_paving = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.land_infrastructure_paving = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.land_infrastructure_paving = $$c
          }
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Paving_execution_pct')) + " (%)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_infrastructure_paving_execution_pct),
        expression: "appraisal.land_infrastructure_paving_execution_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.land_infrastructure_paving_execution_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.land_infrastructure_paving_execution_pct = $event.target.value
        }, _vm.set_appraisal_land_infrastructure_paving_execution_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Sewage')) + " "), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_infrastructure_sewage),
        expression: "appraisal.land_infrastructure_sewage"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.land_infrastructure_sewage) ? _vm._i(_vm.appraisal.land_infrastructure_sewage, null) > -1 : (_vm.appraisal.land_infrastructure_sewage)
      },
      on: {
        "click": _vm.set_appraisal_land_infrastructure_sewage,
        "__c": function($event) {
          var $$a = _vm.appraisal.land_infrastructure_sewage,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.land_infrastructure_sewage = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.land_infrastructure_sewage = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.land_infrastructure_sewage = $$c
          }
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Sewage_execution_pct')) + " (%)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_infrastructure_sewage_execution_pct),
        expression: "appraisal.land_infrastructure_sewage_execution_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.land_infrastructure_sewage_execution_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.land_infrastructure_sewage_execution_pct = $event.target.value
        }, _vm.set_appraisal_land_infrastructure_sewage_execution_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Public_lighting')) + " "), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_infrastructure_public_lighting),
        expression: "appraisal.land_infrastructure_public_lighting"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.land_infrastructure_public_lighting) ? _vm._i(_vm.appraisal.land_infrastructure_public_lighting, null) > -1 : (_vm.appraisal.land_infrastructure_public_lighting)
      },
      on: {
        "click": _vm.set_appraisal_land_infrastructure_public_lighting,
        "__c": function($event) {
          var $$a = _vm.appraisal.land_infrastructure_public_lighting,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.land_infrastructure_public_lighting = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.land_infrastructure_public_lighting = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.land_infrastructure_public_lighting = $$c
          }
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Public_lighting_execution_pct')) + " (%)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_infrastructure_public_lighting_execution_pct),
        expression: "appraisal.land_infrastructure_public_lighting_execution_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.land_infrastructure_public_lighting_execution_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.land_infrastructure_public_lighting_execution_pct = $event.target.value
        }, _vm.set_appraisal_land_infrastructure_public_lighting_execution_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Water_supply')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_infrastructure_water_supply),
        expression: "appraisal.land_infrastructure_water_supply"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.land_infrastructure_water_supply) ? _vm._i(_vm.appraisal.land_infrastructure_water_supply, null) > -1 : (_vm.appraisal.land_infrastructure_water_supply)
      },
      on: {
        "click": _vm.set_appraisal_land_infrastructure_water_supply,
        "__c": function($event) {
          var $$a = _vm.appraisal.land_infrastructure_water_supply,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.land_infrastructure_water_supply = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.land_infrastructure_water_supply = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.land_infrastructure_water_supply = $$c
          }
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Water_supply_execution_pct')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_infrastructure_water_supply_execution_pct),
        expression: "appraisal.land_infrastructure_water_supply_execution_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.land_infrastructure_water_supply_execution_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.land_infrastructure_water_supply_execution_pct = $event.target.value
        }, _vm.set_appraisal_land_infrastructure_water_supply_execution_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Electricity_supply')) + " "), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_infrastructure_electricity_supply),
        expression: "appraisal.land_infrastructure_electricity_supply"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.land_infrastructure_electricity_supply) ? _vm._i(_vm.appraisal.land_infrastructure_electricity_supply, null) > -1 : (_vm.appraisal.land_infrastructure_electricity_supply)
      },
      on: {
        "click": _vm.set_appraisal_land_infrastructure_electricity_supply,
        "__c": function($event) {
          var $$a = _vm.appraisal.land_infrastructure_electricity_supply,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.land_infrastructure_electricity_supply = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.land_infrastructure_electricity_supply = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.land_infrastructure_electricity_supply = $$c
          }
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Electricity_supply_execution_pct')) + " (%)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_infrastructure_electricity_supply_execution_pct),
        expression: "appraisal.land_infrastructure_electricity_supply_execution_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.land_infrastructure_electricity_supply_execution_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.land_infrastructure_electricity_supply_execution_pct = $event.target.value
        }, _vm.set_appraisal_land_infrastructure_electricity_supply_execution_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Piped_gas')) + " "), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_infrastructure_piped_gas),
        expression: "appraisal.land_infrastructure_piped_gas"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.land_infrastructure_piped_gas) ? _vm._i(_vm.appraisal.land_infrastructure_piped_gas, null) > -1 : (_vm.appraisal.land_infrastructure_piped_gas)
      },
      on: {
        "click": _vm.set_appraisal_land_infrastructure_piped_gas,
        "__c": function($event) {
          var $$a = _vm.appraisal.land_infrastructure_piped_gas,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.land_infrastructure_piped_gas = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.land_infrastructure_piped_gas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.land_infrastructure_piped_gas = $$c
          }
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Piped_gas_execution_pct')) + " (%)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_infrastructure_piped_gas_execution_pct),
        expression: "appraisal.land_infrastructure_piped_gas_execution_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.land_infrastructure_piped_gas_execution_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.land_infrastructure_piped_gas_execution_pct = $event.target.value
        }, _vm.set_appraisal_land_infrastructure_piped_gas_execution_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Telephone_service')) + " "), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_infrastructure_telephone_service),
        expression: "appraisal.land_infrastructure_telephone_service"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.land_infrastructure_telephone_service) ? _vm._i(_vm.appraisal.land_infrastructure_telephone_service, null) > -1 : (_vm.appraisal.land_infrastructure_telephone_service)
      },
      on: {
        "click": _vm.set_appraisal_land_infrastructure_telephone_service,
        "__c": function($event) {
          var $$a = _vm.appraisal.land_infrastructure_telephone_service,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.land_infrastructure_telephone_service = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.land_infrastructure_telephone_service = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.land_infrastructure_telephone_service = $$c
          }
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Telephone_service_execution_pct')) + " (%)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_infrastructure_telephone_service_execution_pct),
        expression: "appraisal.land_infrastructure_telephone_service_execution_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.land_infrastructure_telephone_service_execution_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.land_infrastructure_telephone_service_execution_pct = $event.target.value
        }, _vm.set_appraisal_land_infrastructure_telephone_service_execution_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Gardened_areas')) + " "), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_infrastructure_gardened_areas),
        expression: "appraisal.land_infrastructure_gardened_areas"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.land_infrastructure_gardened_areas) ? _vm._i(_vm.appraisal.land_infrastructure_gardened_areas, null) > -1 : (_vm.appraisal.land_infrastructure_gardened_areas)
      },
      on: {
        "click": _vm.set_appraisal_land_infrastructure_gardened_areas,
        "__c": function($event) {
          var $$a = _vm.appraisal.land_infrastructure_gardened_areas,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.land_infrastructure_gardened_areas = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.land_infrastructure_gardened_areas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.land_infrastructure_gardened_areas = $$c
          }
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Gardened_areas_execution_pct')) + " (%)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_infrastructure_gardened_areas_execution_pct),
        expression: "appraisal.land_infrastructure_gardened_areas_execution_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.land_infrastructure_gardened_areas_execution_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.land_infrastructure_gardened_areas_execution_pct = $event.target.value
        }, _vm.set_appraisal_land_infrastructure_gardened_areas_execution_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Total_execution_pct')) + " (%)")]), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.land_infrastructure_total_execution_pct)) + " %")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Conservation_status')) + " "), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.land_infrastructure_conservation_statusValue,
        "options": _vm.conservation_statusOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_land_infrastructure_conservation_status
      },
      model: {
        value: (_vm.appraisal.land_infrastructure_conservation_status),
        callback: function($$v) {
          _vm.appraisal.land_infrastructure_conservation_status = $$v
        },
        expression: "appraisal.land_infrastructure_conservation_status"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Infrastructures_repercussion_cost')) + " (€/m²)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_infrastructure_repercussion_cost),
        expression: "appraisal.land_infrastructure_repercussion_cost"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.land_infrastructure_repercussion_cost)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.land_infrastructure_repercussion_cost = $event.target.value
        }, _vm.set_appraisal_land_infrastructure_repercussion_cost],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Pending_investment')) + " (€/m²)"), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm._f("formatNumber")(_vm.appraisal.land_infrastructure_pending_investment)) + " €/m²")])])])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Notes_on_plot_infrastructures')) + " "), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.land_infrastructure_notes),
        expression: "appraisal.land_infrastructure_notes"
      }],
      staticClass: "field__group__textarea",
      attrs: {
        "rows": "5",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.land_infrastructure_notes)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.land_infrastructure_notes = $event.target.value
        }, _vm.set_appraisal_land_infrastructure_notes]
      }
    })])])])])])])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.features_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Característiques')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.features_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Features')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.features_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Características')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.features_text) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "form-section"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Number_of_floors_and_use')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Floors_number_underground')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.floors_number_underground),
        expression: "appraisal.floors_number_underground"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.floors_number_underground)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.floors_number_underground = $event.target.value
        }, _vm.set_appraisal_floors_number_underground],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Floors_usage_underground')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.floors_usage_undergroundValue,
        "options": _vm.usage_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_floors_usage_underground
      },
      model: {
        value: (_vm.appraisal.floors_usage_underground),
        callback: function($$v) {
          _vm.appraisal.floors_usage_underground = $$v
        },
        expression: "appraisal.floors_usage_underground"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Groundfloor_usage')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.groundfloor_usageValue,
        "options": _vm.usage_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_groundfloor_usage
      },
      model: {
        value: (_vm.appraisal.groundfloor_usage),
        callback: function($$v) {
          _vm.appraisal.groundfloor_usage = $$v
        },
        expression: "appraisal.groundfloor_usage"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Floors_number_overground')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.floors_number_overground),
        expression: "appraisal.floors_number_overground"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.floors_number_overground)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.floors_number_overground = $event.target.value
        }, _vm.set_appraisal_floors_number_overground],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Floors_usage_overground')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.floors_usage_overgroundValue,
        "options": _vm.usage_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_floors_usage_overground
      },
      model: {
        value: (_vm.appraisal.floors_usage_overground),
        callback: function($$v) {
          _vm.appraisal.floors_usage_overground = $$v
        },
        expression: "appraisal.floors_usage_overground"
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Features')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('table', {
      staticStyle: {
        "width": "30em"
      }
    }, [_c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Lift')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.lift),
        expression: "appraisal.lift"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.lift) ? _vm._i(_vm.appraisal.lift, null) > -1 : (_vm.appraisal.lift)
      },
      on: {
        "input": _vm.set_appraisal_lift,
        "__c": function($event) {
          var $$a = _vm.appraisal.lift,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.lift = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.lift = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.lift = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Entrance_hall')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.entrance_hall),
        expression: "appraisal.entrance_hall"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.entrance_hall) ? _vm._i(_vm.appraisal.entrance_hall, null) > -1 : (_vm.appraisal.entrance_hall)
      },
      on: {
        "click": _vm.set_appraisal_entrance_hall,
        "__c": function($event) {
          var $$a = _vm.appraisal.entrance_hall,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.entrance_hall = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.entrance_hall = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.entrance_hall = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Doorman_space')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.doorman_space),
        expression: "appraisal.doorman_space"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.doorman_space) ? _vm._i(_vm.appraisal.doorman_space, null) > -1 : (_vm.appraisal.doorman_space)
      },
      on: {
        "click": _vm.set_appraisal_doorman_space,
        "__c": function($event) {
          var $$a = _vm.appraisal.doorman_space,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.doorman_space = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.doorman_space = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.doorman_space = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Staircase')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.staircase),
        expression: "appraisal.staircase"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.staircase) ? _vm._i(_vm.appraisal.staircase, null) > -1 : (_vm.appraisal.staircase)
      },
      on: {
        "click": _vm.set_appraisal_staircase,
        "__c": function($event) {
          var $$a = _vm.appraisal.staircase,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.staircase = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.staircase = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.staircase = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Swimming_pool')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.swimming_pool),
        expression: "appraisal.swimming_pool"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.swimming_pool) ? _vm._i(_vm.appraisal.swimming_pool, null) > -1 : (_vm.appraisal.swimming_pool)
      },
      on: {
        "click": _vm.set_appraisal_swimming_pool,
        "__c": function($event) {
          var $$a = _vm.appraisal.swimming_pool,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.swimming_pool = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.swimming_pool = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.swimming_pool = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Gardened_areas')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.gardened_areas),
        expression: "appraisal.gardened_areas"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.gardened_areas) ? _vm._i(_vm.appraisal.gardened_areas, null) > -1 : (_vm.appraisal.gardened_areas)
      },
      on: {
        "click": _vm.set_appraisal_gardened_areas,
        "__c": function($event) {
          var $$a = _vm.appraisal.gardened_areas,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.gardened_areas = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.gardened_areas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.gardened_areas = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Sports_facilities')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.sports_facilities),
        expression: "appraisal.sports_facilities"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.sports_facilities) ? _vm._i(_vm.appraisal.sports_facilities, null) > -1 : (_vm.appraisal.sports_facilities)
      },
      on: {
        "click": _vm.set_appraisal_sports_facilities,
        "__c": function($event) {
          var $$a = _vm.appraisal.sports_facilities,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.sports_facilities = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.sports_facilities = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.sports_facilities = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Community_room')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.community_room),
        expression: "appraisal.community_room"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.community_room) ? _vm._i(_vm.appraisal.community_room, null) > -1 : (_vm.appraisal.community_room)
      },
      on: {
        "click": _vm.set_appraisal_community_room,
        "__c": function($event) {
          var $$a = _vm.appraisal.community_room,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.community_room = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.community_room = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.community_room = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Community_parking')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.community_parking),
        expression: "appraisal.community_parking"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.community_parking) ? _vm._i(_vm.appraisal.community_parking, null) > -1 : (_vm.appraisal.community_parking)
      },
      on: {
        "click": _vm.set_appraisal_community_parking,
        "__c": function($event) {
          var $$a = _vm.appraisal.community_parking,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.community_parking = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.community_parking = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.community_parking = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Facilities_others')))]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.facilities_others),
        expression: "appraisal.facilities_others"
      }],
      staticClass: "field__group__textarea",
      attrs: {
        "rows": "3",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.facilities_others)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.facilities_others = $event.target.value
        }, _vm.set_appraisal_facilities_others]
      }
    })])])])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Qualities')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Quality_of_neighbourhood')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.quality_of_neighbourhoodValue,
        "options": _vm.quality_of_neighbourhoodOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_quality_of_neighbourhood
      },
      model: {
        value: (_vm.appraisal.quality_of_neighbourhood),
        callback: function($$v) {
          _vm.appraisal.quality_of_neighbourhood = $$v
        },
        expression: "appraisal.quality_of_neighbourhood"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Quality_of_situation')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.quality_of_situationValue,
        "options": _vm.quality_of_situationOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_quality_of_situation
      },
      model: {
        value: (_vm.appraisal.quality_of_situation),
        callback: function($$v) {
          _vm.appraisal.quality_of_situation = $$v
        },
        expression: "appraisal.quality_of_situation"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Quality_of_construction')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.quality_of_constructionValue,
        "options": _vm.quality_of_constructionOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_quality_of_construction
      },
      model: {
        value: (_vm.appraisal.quality_of_construction),
        callback: function($$v) {
          _vm.appraisal.quality_of_construction = $$v
        },
        expression: "appraisal.quality_of_construction"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Quality_of_realestate')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.quality_of_realestateValue,
        "options": _vm.quality_of_realestateOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_quality_of_realestate
      },
      model: {
        value: (_vm.appraisal.quality_of_realestate),
        callback: function($$v) {
          _vm.appraisal.quality_of_realestate = $$v
        },
        expression: "appraisal.quality_of_realestate"
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Age')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('conservation_status')) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Construction_year')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.construction_year),
        expression: "appraisal.construction_year"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.construction_year)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.construction_year = $event.target.value
        }, _vm.set_appraisal_construction_year],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Last_renovation_year')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.last_renovation_year),
        expression: "appraisal.last_renovation_year"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.last_renovation_year)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.last_renovation_year = $event.target.value
        }, _vm.set_appraisal_last_renovation_year],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Adopted_age')) + " (" + _vm._s(_vm.$t('Average')) + ")")]), _vm._v(" "), _c('strong', [_c('span', [_vm._v(_vm._s(_vm.appraisal.adopted_age))])])])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Conservation_status')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.conservation_statusValue,
        "options": _vm.conservation_statusOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_conservation_status
      },
      model: {
        value: (_vm.appraisal.conservation_status),
        callback: function($$v) {
          _vm.appraisal.conservation_status = $$v
        },
        expression: "appraisal.conservation_status"
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Structure')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('shell')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Foundation')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_foundationValue,
        "options": _vm.foundationOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_foundation
      },
      model: {
        value: (_vm.appraisal.realestate_foundation),
        callback: function($$v) {
          _vm.appraisal.realestate_foundation = $$v
        },
        expression: "appraisal.realestate_foundation"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Structure')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_structureValue,
        "options": _vm.structureOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_structure
      },
      model: {
        value: (_vm.appraisal.realestate_structure),
        callback: function($$v) {
          _vm.appraisal.realestate_structure = $$v
        },
        expression: "appraisal.realestate_structure"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Roof')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_roofValue,
        "options": _vm.roofOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_roof
      },
      model: {
        value: (_vm.appraisal.realestate_roof),
        callback: function($$v) {
          _vm.appraisal.realestate_roof = $$v
        },
        expression: "appraisal.realestate_roof"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('External_enclosures')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_external_enclosuresValue,
        "options": _vm.external_enclosuresOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_external_enclosures
      },
      model: {
        value: (_vm.appraisal.realestate_external_enclosures),
        callback: function($$v) {
          _vm.appraisal.realestate_external_enclosures = $$v
        },
        expression: "appraisal.realestate_external_enclosures"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Insulation')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_insulationValue,
        "options": _vm.insulationOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_insulation
      },
      model: {
        value: (_vm.appraisal.realestate_insulation),
        callback: function($$v) {
          _vm.appraisal.realestate_insulation = $$v
        },
        expression: "appraisal.realestate_insulation"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('External_carpentry')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_external_carpentryValue,
        "options": _vm.external_carpentry_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_external_carpentry
      },
      model: {
        value: (_vm.appraisal.realestate_external_carpentry),
        callback: function($$v) {
          _vm.appraisal.realestate_external_carpentry = $$v
        },
        expression: "appraisal.realestate_external_carpentry"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Glazing')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_glazingValue,
        "options": _vm.glazingOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_glazing
      },
      model: {
        value: (_vm.appraisal.realestate_glazing),
        callback: function($$v) {
          _vm.appraisal.realestate_glazing = $$v
        },
        expression: "appraisal.realestate_glazing"
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Interior_finishes')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "calc_table overflow_auto"
    }, [_c('table', {
      staticClass: "table-striped",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('tr', [_c('th', {
      staticStyle: {
        "width": "200px"
      }
    }), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "300px"
      }
    }, [_vm._v(_vm._s(_vm.$t('Paving')))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "300px"
      }
    }, [_vm._v(_vm._s(_vm.$t('Walls')))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "300px"
      }
    }, [_vm._v(_vm._s(_vm.$t('Ceilings')))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "300px"
      }
    }, [_vm._v(_vm._s(_vm.$t('Interior_carpentry')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [(_vm.appraisal.property_type.name_db == 'residential') ? _c('strong', [_vm._v(_vm._s(_vm.$t('Living')))]) : _c('strong', [_vm._v("General")])]), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_paving_livingValue,
        "options": _vm.pavingOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_paving_living
      },
      model: {
        value: (_vm.appraisal.realestate_interior_paving_living),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_paving_living = $$v
        },
        expression: "appraisal.realestate_interior_paving_living"
      }
    })], 1), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_walls_livingValue,
        "options": _vm.wallsOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_walls_living
      },
      model: {
        value: (_vm.appraisal.realestate_interior_walls_living),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_walls_living = $$v
        },
        expression: "appraisal.realestate_interior_walls_living"
      }
    })], 1), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_ceilings_livingValue,
        "options": _vm.ceilingsOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_ceilings_living
      },
      model: {
        value: (_vm.appraisal.realestate_interior_ceilings_living),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_ceilings_living = $$v
        },
        expression: "appraisal.realestate_interior_ceilings_living"
      }
    })], 1), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_carpentry_livingValue,
        "options": _vm.interior_carpentry_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_carpentry_living
      },
      model: {
        value: (_vm.appraisal.realestate_interior_carpentry_living),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_carpentry_living = $$v
        },
        expression: "appraisal.realestate_interior_carpentry_living"
      }
    })], 1)]), _vm._v(" "), (_vm.appraisal.property_type.name_db == 'residential') ? _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Circulations')))])]), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_paving_corridorValue,
        "options": _vm.pavingOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_paving_corridor
      },
      model: {
        value: (_vm.appraisal.realestate_interior_paving_corridor),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_paving_corridor = $$v
        },
        expression: "appraisal.realestate_interior_paving_corridor"
      }
    })], 1), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_walls_corridorValue,
        "options": _vm.wallsOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_walls_corridor
      },
      model: {
        value: (_vm.appraisal.realestate_interior_walls_corridor),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_walls_corridor = $$v
        },
        expression: "appraisal.realestate_interior_walls_corridor"
      }
    })], 1), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_ceilings_corridorValue,
        "options": _vm.ceilingsOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_ceilings_corridor
      },
      model: {
        value: (_vm.appraisal.realestate_interior_ceilings_corridor),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_ceilings_corridor = $$v
        },
        expression: "appraisal.realestate_interior_ceilings_corridor"
      }
    })], 1), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_carpentry_corridorValue,
        "options": _vm.interior_carpentry_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_carpentry_corridor
      },
      model: {
        value: (_vm.appraisal.realestate_interior_carpentry_corridor),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_carpentry_corridor = $$v
        },
        expression: "appraisal.realestate_interior_carpentry_corridor"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), (_vm.appraisal.property_type.name_db == 'residential') ? _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Bedrooms')))])]), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_paving_bedroomValue,
        "options": _vm.pavingOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_paving_bedroom
      },
      model: {
        value: (_vm.appraisal.realestate_interior_paving_bedroom),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_paving_bedroom = $$v
        },
        expression: "appraisal.realestate_interior_paving_bedroom"
      }
    })], 1), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_walls_bedroomValue,
        "options": _vm.wallsOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_walls_bedroom
      },
      model: {
        value: (_vm.appraisal.realestate_interior_walls_bedroom),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_walls_bedroom = $$v
        },
        expression: "appraisal.realestate_interior_walls_bedroom"
      }
    })], 1), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_ceilings_bedroomValue,
        "options": _vm.ceilingsOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_ceilings_bedroom
      },
      model: {
        value: (_vm.appraisal.realestate_interior_ceilings_bedroom),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_ceilings_bedroom = $$v
        },
        expression: "appraisal.realestate_interior_ceilings_bedroom"
      }
    })], 1), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_carpentry_bedroomValue,
        "options": _vm.interior_carpentry_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_carpentry_bedroom
      },
      model: {
        value: (_vm.appraisal.realestate_interior_carpentry_bedroom),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_carpentry_bedroom = $$v
        },
        expression: "appraisal.realestate_interior_carpentry_bedroom"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), (_vm.appraisal.property_type.name_db == 'residential') ? _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Kitchen')))])]), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_paving_kitchenValue,
        "options": _vm.pavingOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_paving_kitchen
      },
      model: {
        value: (_vm.appraisal.realestate_interior_paving_kitchen),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_paving_kitchen = $$v
        },
        expression: "appraisal.realestate_interior_paving_kitchen"
      }
    })], 1), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_walls_kitchenValue,
        "options": _vm.wallsOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_walls_kitchen
      },
      model: {
        value: (_vm.appraisal.realestate_interior_walls_kitchen),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_walls_kitchen = $$v
        },
        expression: "appraisal.realestate_interior_walls_kitchen"
      }
    })], 1), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_ceilings_kitchenValue,
        "options": _vm.ceilingsOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_ceilings_kitchen
      },
      model: {
        value: (_vm.appraisal.realestate_interior_ceilings_kitchen),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_ceilings_kitchen = $$v
        },
        expression: "appraisal.realestate_interior_ceilings_kitchen"
      }
    })], 1), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_carpentry_kitchenValue,
        "options": _vm.interior_carpentry_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_carpentry_kitchen
      },
      model: {
        value: (_vm.appraisal.realestate_interior_carpentry_kitchen),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_carpentry_kitchen = $$v
        },
        expression: "appraisal.realestate_interior_carpentry_kitchen"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), (_vm.appraisal.property_type.name_db == 'residential' || _vm.appraisal.property_type.name_db == 'retail_and_industrial' || _vm.appraisal.property_type.name_db == 'office') ? _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Bathrooms')))])]), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_paving_bathroomValue,
        "options": _vm.pavingOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_paving_bathroom
      },
      model: {
        value: (_vm.appraisal.realestate_interior_paving_bathroom),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_paving_bathroom = $$v
        },
        expression: "appraisal.realestate_interior_paving_bathroom"
      }
    })], 1), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_walls_bathroomValue,
        "options": _vm.wallsOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_walls_bathroom
      },
      model: {
        value: (_vm.appraisal.realestate_interior_walls_bathroom),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_walls_bathroom = $$v
        },
        expression: "appraisal.realestate_interior_walls_bathroom"
      }
    })], 1), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_ceilings_bathroomValue,
        "options": _vm.ceilingsOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_ceilings_bathroom
      },
      model: {
        value: (_vm.appraisal.realestate_interior_ceilings_bathroom),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_ceilings_bathroom = $$v
        },
        expression: "appraisal.realestate_interior_ceilings_bathroom"
      }
    })], 1), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_carpentry_bathroomValue,
        "options": _vm.interior_carpentry_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_carpentry_bathroom
      },
      model: {
        value: (_vm.appraisal.realestate_interior_carpentry_bathroom),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_carpentry_bathroom = $$v
        },
        expression: "appraisal.realestate_interior_carpentry_bathroom"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Quality')))])]), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_paving_qualityValue,
        "options": _vm.quality_of_finishesOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_paving_quality
      },
      model: {
        value: (_vm.appraisal.realestate_interior_paving_quality),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_paving_quality = $$v
        },
        expression: "appraisal.realestate_interior_paving_quality"
      }
    })], 1), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_walls_qualityValue,
        "options": _vm.quality_of_finishesOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_walls_quality
      },
      model: {
        value: (_vm.appraisal.realestate_interior_walls_quality),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_walls_quality = $$v
        },
        expression: "appraisal.realestate_interior_walls_quality"
      }
    })], 1), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_ceilings_qualityValue,
        "options": _vm.quality_of_finishesOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_ceilings_quality
      },
      model: {
        value: (_vm.appraisal.realestate_interior_ceilings_quality),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_ceilings_quality = $$v
        },
        expression: "appraisal.realestate_interior_ceilings_quality"
      }
    })], 1), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_interior_carpentry_qualityValue,
        "options": _vm.quality_of_finishesOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_interior_carpentry_quality
      },
      model: {
        value: (_vm.appraisal.realestate_interior_carpentry_quality),
        callback: function($$v) {
          _vm.appraisal.realestate_interior_carpentry_quality = $$v
        },
        expression: "appraisal.realestate_interior_carpentry_quality"
      }
    })], 1)])])])])]), _vm._v(" "), (_vm.appraisal.property_type.name_db == 'residential') ? _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Habitability_conditions')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Number_of_rooms_to_exterior')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.realestate_rooms_to_exterior_number),
        expression: "appraisal.realestate_rooms_to_exterior_number"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.realestate_rooms_to_exterior_number)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.realestate_rooms_to_exterior_number = $event.target.value
        }, _vm.set_appraisal_realestate_rooms_to_exterior_number],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Main_orientation')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_main_orientationValue,
        "options": _vm.main_orientationOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_main_orientation
      },
      model: {
        value: (_vm.appraisal.realestate_main_orientation),
        callback: function($$v) {
          _vm.appraisal.realestate_main_orientation = $$v
        },
        expression: "appraisal.realestate_main_orientation"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Views')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_main_viewsValue,
        "options": _vm.main_viewsOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_main_views
      },
      model: {
        value: (_vm.appraisal.realestate_main_views),
        callback: function($$v) {
          _vm.appraisal.realestate_main_views = $$v
        },
        expression: "appraisal.realestate_main_views"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Windows_size_and_quantity')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_windows_size_and_quantityValue,
        "options": _vm.windows_size_and_quantityOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_windows_size_and_quantity
      },
      model: {
        value: (_vm.appraisal.realestate_windows_size_and_quantity),
        callback: function($$v) {
          _vm.appraisal.realestate_windows_size_and_quantity = $$v
        },
        expression: "appraisal.realestate_windows_size_and_quantity"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Noise_facade')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_noise_facadeValue,
        "options": _vm.noise_levelOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_noise_facade
      },
      model: {
        value: (_vm.appraisal.realestate_noise_facade),
        callback: function($$v) {
          _vm.appraisal.realestate_noise_facade = $$v
        },
        expression: "appraisal.realestate_noise_facade"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Day_night_zoning')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.realestate_day_night_zoning),
        expression: "appraisal.realestate_day_night_zoning"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.realestate_day_night_zoning) ? _vm._i(_vm.appraisal.realestate_day_night_zoning, null) > -1 : (_vm.appraisal.realestate_day_night_zoning)
      },
      on: {
        "click": _vm.set_appraisal_realestate_day_night_zoning,
        "__c": function($event) {
          var $$a = _vm.appraisal.realestate_day_night_zoning,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.realestate_day_night_zoning = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.realestate_day_night_zoning = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.realestate_day_night_zoning = $$c
          }
        }
      }
    })])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Systems')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('table', {
      staticStyle: {
        "width": "40em"
      }
    }, [_c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Door_opener')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.realestate_systems_door_opener),
        expression: "appraisal.realestate_systems_door_opener"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.realestate_systems_door_opener) ? _vm._i(_vm.appraisal.realestate_systems_door_opener, null) > -1 : (_vm.appraisal.realestate_systems_door_opener)
      },
      on: {
        "click": _vm.set_appraisal_realestate_systems_door_opener,
        "__c": function($event) {
          var $$a = _vm.appraisal.realestate_systems_door_opener,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.realestate_systems_door_opener = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.realestate_systems_door_opener = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.realestate_systems_door_opener = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Fitted_cupboards')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.realestate_systems_fitted_cupboards),
        expression: "appraisal.realestate_systems_fitted_cupboards"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.realestate_systems_fitted_cupboards) ? _vm._i(_vm.appraisal.realestate_systems_fitted_cupboards, null) > -1 : (_vm.appraisal.realestate_systems_fitted_cupboards)
      },
      on: {
        "click": _vm.set_appraisal_realestate_systems_fitted_cupboards,
        "__c": function($event) {
          var $$a = _vm.appraisal.realestate_systems_fitted_cupboards,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.realestate_systems_fitted_cupboards = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.realestate_systems_fitted_cupboards = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.realestate_systems_fitted_cupboards = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Gas')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.realestate_systems_gas),
        expression: "appraisal.realestate_systems_gas"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.realestate_systems_gas) ? _vm._i(_vm.appraisal.realestate_systems_gas, null) > -1 : (_vm.appraisal.realestate_systems_gas)
      },
      on: {
        "click": _vm.set_appraisal_realestate_systems_gas,
        "__c": function($event) {
          var $$a = _vm.appraisal.realestate_systems_gas,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.realestate_systems_gas = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.realestate_systems_gas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.realestate_systems_gas = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "width": "15em"
      }
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Sanitary_fittings')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.realestate_systems_sanitary_fittings),
        expression: "appraisal.realestate_systems_sanitary_fittings"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.realestate_systems_sanitary_fittings) ? _vm._i(_vm.appraisal.realestate_systems_sanitary_fittings, null) > -1 : (_vm.appraisal.realestate_systems_sanitary_fittings)
      },
      on: {
        "click": _vm.set_appraisal_realestate_systems_sanitary_fittings,
        "__c": function($event) {
          var $$a = _vm.appraisal.realestate_systems_sanitary_fittings,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.realestate_systems_sanitary_fittings = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.realestate_systems_sanitary_fittings = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.realestate_systems_sanitary_fittings = $$c
          }
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Sanitary_fittings_quality')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_systems_sanitary_fittings_qualityValue,
        "options": _vm.quality_of_finishesOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_systems_sanitary_fittings_quality
      },
      model: {
        value: (_vm.appraisal.realestate_systems_sanitary_fittings_quality),
        callback: function($$v) {
          _vm.appraisal.realestate_systems_sanitary_fittings_quality = $$v
        },
        expression: "appraisal.realestate_systems_sanitary_fittings_quality"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Taps')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.realestate_systems_taps),
        expression: "appraisal.realestate_systems_taps"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.realestate_systems_taps) ? _vm._i(_vm.appraisal.realestate_systems_taps, null) > -1 : (_vm.appraisal.realestate_systems_taps)
      },
      on: {
        "click": _vm.set_appraisal_realestate_systems_taps,
        "__c": function($event) {
          var $$a = _vm.appraisal.realestate_systems_taps,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.realestate_systems_taps = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.realestate_systems_taps = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.realestate_systems_taps = $$c
          }
        }
      }
    })])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Taps_quality')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.realestate_systems_taps_qualityValue,
        "options": _vm.quality_of_finishesOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_realestate_systems_taps_quality
      },
      model: {
        value: (_vm.appraisal.realestate_systems_taps_quality),
        callback: function($$v) {
          _vm.appraisal.realestate_systems_taps_quality = $$v
        },
        expression: "appraisal.realestate_systems_taps_quality"
      }
    })], 1)])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Hot_water')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.realestate_systems_hot_water),
        expression: "appraisal.realestate_systems_hot_water"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.realestate_systems_hot_water) ? _vm._i(_vm.appraisal.realestate_systems_hot_water, null) > -1 : (_vm.appraisal.realestate_systems_hot_water)
      },
      on: {
        "click": _vm.set_appraisal_realestate_systems_hot_water,
        "__c": function($event) {
          var $$a = _vm.appraisal.realestate_systems_hot_water,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.realestate_systems_hot_water = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.realestate_systems_hot_water = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.realestate_systems_hot_water = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Heating')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.realestate_systems_heating),
        expression: "appraisal.realestate_systems_heating"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.realestate_systems_heating) ? _vm._i(_vm.appraisal.realestate_systems_heating, null) > -1 : (_vm.appraisal.realestate_systems_heating)
      },
      on: {
        "click": _vm.set_appraisal_realestate_systems_heating,
        "__c": function($event) {
          var $$a = _vm.appraisal.realestate_systems_heating,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.realestate_systems_heating = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.realestate_systems_heating = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.realestate_systems_heating = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Air_conditioning')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.realestate_systems_air_conditioning),
        expression: "appraisal.realestate_systems_air_conditioning"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.realestate_systems_air_conditioning) ? _vm._i(_vm.appraisal.realestate_systems_air_conditioning, null) > -1 : (_vm.appraisal.realestate_systems_air_conditioning)
      },
      on: {
        "click": _vm.set_appraisal_realestate_systems_air_conditioning,
        "__c": function($event) {
          var $$a = _vm.appraisal.realestate_systems_air_conditioning,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.realestate_systems_air_conditioning = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.realestate_systems_air_conditioning = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.realestate_systems_air_conditioning = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v("Tv")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.realestate_systems_tv),
        expression: "appraisal.realestate_systems_tv"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.realestate_systems_tv) ? _vm._i(_vm.appraisal.realestate_systems_tv, null) > -1 : (_vm.appraisal.realestate_systems_tv)
      },
      on: {
        "click": _vm.set_appraisal_realestate_systems_tv,
        "__c": function($event) {
          var $$a = _vm.appraisal.realestate_systems_tv,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.realestate_systems_tv = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.realestate_systems_tv = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.realestate_systems_tv = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Telephone')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.realestate_systems_telephone),
        expression: "appraisal.realestate_systems_telephone"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.realestate_systems_telephone) ? _vm._i(_vm.appraisal.realestate_systems_telephone, null) > -1 : (_vm.appraisal.realestate_systems_telephone)
      },
      on: {
        "click": _vm.set_appraisal_realestate_systems_telephone,
        "__c": function($event) {
          var $$a = _vm.appraisal.realestate_systems_telephone,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.realestate_systems_telephone = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.realestate_systems_telephone = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.realestate_systems_telephone = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Fire_prevention')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.realestate_systems_fire_prevention),
        expression: "appraisal.realestate_systems_fire_prevention"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.realestate_systems_fire_prevention) ? _vm._i(_vm.appraisal.realestate_systems_fire_prevention, null) > -1 : (_vm.appraisal.realestate_systems_fire_prevention)
      },
      on: {
        "click": _vm.set_appraisal_realestate_systems_fire_prevention,
        "__c": function($event) {
          var $$a = _vm.appraisal.realestate_systems_fire_prevention,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.realestate_systems_fire_prevention = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.realestate_systems_fire_prevention = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.realestate_systems_fire_prevention = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Intrusion_prevention')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.realestate_systems_intrusion_prevention),
        expression: "appraisal.realestate_systems_intrusion_prevention"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.realestate_systems_intrusion_prevention) ? _vm._i(_vm.appraisal.realestate_systems_intrusion_prevention, null) > -1 : (_vm.appraisal.realestate_systems_intrusion_prevention)
      },
      on: {
        "click": _vm.set_appraisal_realestate_systems_intrusion_prevention,
        "__c": function($event) {
          var $$a = _vm.appraisal.realestate_systems_intrusion_prevention,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.realestate_systems_intrusion_prevention = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.realestate_systems_intrusion_prevention = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.realestate_systems_intrusion_prevention = $$c
          }
        }
      }
    })])])])])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Real_estates_useful_life')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Real_estates_total_useful_life')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.useful_life_years),
        expression: "appraisal.useful_life_years"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.useful_life_years)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.useful_life_years = $event.target.value
        }, _vm.set_appraisal_useful_life_years],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Remaining_useful_life_years')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.appraisal.remaining_useful_life_years) + " " + _vm._s(_vm.$t('years')))])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Construction_cost')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Property_type')) + " (B.E.C.)")]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.bec_property_typeValue,
        "options": this.object_to_array(_vm.appraisal_bec_properties),
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_bec_property_type
      },
      model: {
        value: (_vm.appraisal.bec_property_type),
        callback: function($$v) {
          _vm.appraisal.bec_property_type = $$v
        },
        expression: "appraisal.bec_property_type"
      }
    })], 1), _vm._v(" "), (_vm.appraisal.bec_property_type) ? _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Number')) + " (B.E.C.)")]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.bec_numberValue,
        "options": this.object_to_array(_vm.appraisal_bec_prices),
        "track-by": "id",
        "label": 'number',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_bec_number
      },
      model: {
        value: (_vm.appraisal.bec_number),
        callback: function($$v) {
          _vm.appraisal.bec_number = $$v
        },
        expression: "appraisal.bec_number"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.appraisal.bec_number) ? _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Year')))]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.appraisal.bec_number.year) + " ")])]) : _vm._e(), _vm._v(" "), (_vm.appraisal.bec_number) ? _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Quarter')))]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.appraisal.bec_number.quarter) + " ")])]) : _vm._e()]), _vm._v(" "), (_vm.appraisal.bec_number) ? _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v("B.E.C. " + _vm._s(_vm.$t('Construction_cost')) + " total")]), _vm._v(" "), _c('strong', [_c('span', [_vm._v(" " + _vm._s(_vm._f("formatNumber")(_vm.appraisal.bec_number.total)) + " €/m²")])])]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Bec_adjustment_coef')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.bec_adjustment_coef),
        expression: "appraisal.bec_adjustment_coef"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "step": "0.05",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.bec_adjustment_coef)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.bec_adjustment_coef = $event.target.value
        }, _vm.set_appraisal_bec_adjustment_coef],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Adjusted_bec_price')))]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm._f("formatNumber")(_vm.appraisal.adjusted_bec_price)) + " €/m²")])])]) : _vm._e(), _vm._v(" "), (_vm.appraisal.bec_number) ? _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Expenses_and_industrial_benefit_bec_pct')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.expenses_and_industrial_benefit_bec_pct),
        expression: "appraisal.expenses_and_industrial_benefit_bec_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.expenses_and_industrial_benefit_bec_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.expenses_and_industrial_benefit_bec_pct = $event.target.value
        }, _vm.set_appraisal_expenses_and_industrial_benefit_bec_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Material_execution_cost')))]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm._f("formatNumber")(_vm.appraisal.material_execution_cost)) + " €/m²")])])]) : _vm._e(), _vm._v(" "), (_vm.appraisal.bec_number) ? _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Mec_adjustment_coef')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.mec_adjustment_coef),
        expression: "appraisal.mec_adjustment_coef"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "step": "0.05",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.mec_adjustment_coef)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.mec_adjustment_coef = $event.target.value
        }, _vm.set_appraisal_mec_adjustment_coef],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Adopted_material_execution_cost')))]), _vm._v(" "), _c('strong', [_c('span', [_vm._v(" " + _vm._s(_vm._f("formatNumber")(_vm.appraisal.adopted_material_execution_cost)) + " €/m²")])])])]) : _vm._e(), _vm._v(" "), (_vm.appraisal.bec_number) ? _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Construction_cost_notes')))]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.construction_cost_notes),
        expression: "appraisal.construction_cost_notes"
      }],
      staticClass: "field__group__textarea",
      attrs: {
        "rows": "5",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.construction_cost_notes)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.construction_cost_notes = $event.target.value
        }, _vm.set_appraisal_construction_cost_notes]
      }
    })])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Construction_status')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Construction_status')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.construction_statusValue,
        "options": _vm.construction_statusOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_construction_status
      },
      model: {
        value: (_vm.appraisal.construction_status),
        callback: function($$v) {
          _vm.appraisal.construction_status = $$v
        },
        expression: "appraisal.construction_status"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Construction_progress_percentage')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.total_construction_progress_pct),
        expression: "appraisal.total_construction_progress_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false",
        "max": "100",
        "step": "1",
        "min": "0"
      },
      domProps: {
        "value": (_vm.appraisal.total_construction_progress_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.total_construction_progress_pct = $event.target.value
        }, _vm.set_appraisal_total_construction_progress_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.appraisal.total_construction_progress_pct < 100) ? _c('span', {
      staticStyle: {
        "background": "lightyellow"
      }
    }, [_c('strong', [_vm._v("Nota:")]), _vm._v(" Degut a que l'immoble es troba en construcció, en els càlculs es forçarà que l'edifici no està depreciat per antiguitat (da = 1 - d = 100%)")]) : _vm._e()])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.Areas_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Superfícies')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.Areas_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Areas')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.Areas_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Superficies')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.Areas_text) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "form-section"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Net_areas')))]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCreateNewRoom($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus-circle",
        "text": _vm.new_room_button_text,
        "icon_color": "black",
        "text_color": _vm.editing_room_text_color,
        "disabled": _vm.editing_room,
        "border_color": _vm.editing_room_border_color
      }
    })], 1)]), _vm._v(" "), _c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "data-table-main",
        "source": _vm.object_to_array(_vm.appraisal_rooms),
        "filterable": false,
        "striped": _vm.room_table.striped,
        "editable": _vm.room_table.editable,
        "line-numbers": _vm.room_table.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-rooms",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.deleteRoom(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "trash-o",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }, {
        key: "netarea",
        fn: function(cell) {
          return [_c('div', {}, [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['netarea']),
              expression: "cell.row['netarea']"
            }],
            attrs: {
              "type": "number",
              "min": "0"
            },
            domProps: {
              "value": (cell.row['netarea'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'netarea';
                if (!Array.isArray($$exp)) {
                  cell.row['netarea'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, function($event) {
                _vm.set_room_netarea($event, cell.row)
              }],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])]
        }
      }, {
        key: "description",
        fn: function(cell) {
          return [_c('div', {}, [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['description']),
              expression: "cell.row['description']"
            }],
            attrs: {
              "type": "text"
            },
            domProps: {
              "value": (cell.row['description'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'description';
                if (!Array.isArray($$exp)) {
                  cell.row['description'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, function($event) {
                _vm.set_room_description($event, cell.row)
              }]
            }
          })])]
        }
      }, {
        key: "type",
        fn: function(cell) {
          return [_c('div', [_c('multiselect', {
            attrs: {
              "placeholder": "",
              "value": _vm.room_typeValue,
              "options": _vm.room_typeOptions,
              "track-by": "id",
              "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
              "searchable": false,
              "selectedLabel": "",
              "selectLabel": "",
              "deselectLabel": ""
            },
            on: {
              "input": function($event) {
                _vm.set_room_type($event, cell.row)
              }
            },
            model: {
              value: (cell.row['type']),
              callback: function($$v) {
                var $$exp = cell.row,
                  $$idx = 'type';
                if (!Array.isArray($$exp)) {
                  cell.row['type'] = $$v
                } else {
                  $$exp.splice($$idx, 1, $$v)
                }
              },
              expression: "cell.row['type']"
            }
          })], 1)]
        }
      }])
    }, [_vm._l((_vm.room_table.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "actions-rooms",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    })], 2)], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Bedrooms_and_bathrooms')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Bathrooms_number')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.bathrooms_number),
        expression: "appraisal.bathrooms_number"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.bathrooms_number)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.bathrooms_number = $event.target.value
        }, _vm.set_appraisal_bathrooms_number],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Bedrooms_number')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.bedrooms_number),
        expression: "appraisal.bedrooms_number"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.bedrooms_number)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.bedrooms_number = $event.target.value
        }, _vm.set_appraisal_bedrooms_number],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Enclosed_area')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Enclosed_checked_area')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.enclosed_checked_area),
        expression: "appraisal.enclosed_checked_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.enclosed_checked_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.enclosed_checked_area = $event.target.value
        }, _vm.set_appraisal_enclosed_checked_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field-group"
    }, [(!this.appraisal.enclosed_checked_area || this.appraisal.enclosed_checked_area < this.appraisal.net_checked_area) ? _c('div', [_c('message', {
      attrs: {
        "text": _vm.enclosed_checked_area_error_text,
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Proportional_part_of_common_elements')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Common_elements_cadastral_area')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.common_elements_cadastral_area),
        expression: "appraisal.common_elements_cadastral_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.common_elements_cadastral_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.common_elements_cadastral_area = $event.target.value
        }, _vm.set_appraisal_common_elements_cadastral_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Common_elements_registry_area')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.common_elements_registry_area),
        expression: "appraisal.common_elements_registry_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.common_elements_registry_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.common_elements_registry_area = $event.target.value
        }, _vm.set_appraisal_common_elements_registry_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Common_elements_checked_area')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.common_elements_checked_area),
        expression: "appraisal.common_elements_checked_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.common_elements_checked_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.common_elements_checked_area = $event.target.value
        }, _vm.set_appraisal_common_elements_checked_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Covered_outdoor_areas')))]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCreateNewCoveredOutdoor($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus-circle",
        "text": _vm.new_covered_outdoor_button_text,
        "icon_color": "black",
        "text_color": _vm.editing_covered_outdoor_text_color,
        "disabled": _vm.editing_covered_outdoor,
        "border_color": _vm.editing_covered_outdoor_border_color
      }
    })], 1)]), _vm._v(" "), _c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "covered-outdoor-table-main",
        "source": _vm.object_to_array(_vm.appraisal_covered_outdoors),
        "filterable": false,
        "striped": _vm.covered_outdoor_table.striped,
        "editable": _vm.covered_outdoor_table.editable,
        "line-numbers": _vm.covered_outdoor_table.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-covered-outdoors",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.deleteCoveredOutdoor(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "trash-o",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }, {
        key: "netarea",
        fn: function(cell) {
          return [_c('div', {}, [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['netarea']),
              expression: "cell.row['netarea']"
            }],
            attrs: {
              "type": "number",
              "min": "0"
            },
            domProps: {
              "value": (cell.row['netarea'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'netarea';
                if (!Array.isArray($$exp)) {
                  cell.row['netarea'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, function($event) {
                _vm.set_covered_outdoor_netarea($event, cell.row)
              }],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])]
        }
      }, {
        key: "description",
        fn: function(cell) {
          return [_c('div', {}, [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['description']),
              expression: "cell.row['description']"
            }],
            attrs: {
              "type": "text"
            },
            domProps: {
              "value": (cell.row['description'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'description';
                if (!Array.isArray($$exp)) {
                  cell.row['description'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, function($event) {
                _vm.set_covered_outdoor_description($event, cell.row)
              }]
            }
          })])]
        }
      }, {
        key: "type",
        fn: function(cell) {
          return [_c('div', [_c('multiselect', {
            attrs: {
              "placeholder": "",
              "value": _vm.covered_outdoor_typeValue,
              "options": _vm.covered_outdoor_typeOptions,
              "track-by": "id",
              "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
              "searchable": false,
              "selectedLabel": "",
              "selectLabel": "",
              "deselectLabel": ""
            },
            on: {
              "input": function($event) {
                _vm.set_covered_outdoor_type($event, cell.row)
              }
            },
            model: {
              value: (cell.row['type']),
              callback: function($$v) {
                var $$exp = cell.row,
                  $$idx = 'type';
                if (!Array.isArray($$exp)) {
                  cell.row['type'] = $$v
                } else {
                  $$exp.splice($$idx, 1, $$v)
                }
              },
              expression: "cell.row['type']"
            }
          })], 1)]
        }
      }])
    }, [_vm._l((_vm.covered_outdoor_table.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "actions-covered-outdoors",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    })], 2)], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Uncovered_outdoor_areas')))]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCreateNewUncoveredOutdoor($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus-circle",
        "text": _vm.new_uncovered_outdoor_button_text,
        "icon_color": "black",
        "text_color": _vm.editing_uncovered_outdoor_text_color,
        "disabled": _vm.editing_uncovered_outdoor,
        "border_color": _vm.editing_uncovered_outdoor_border_color
      }
    })], 1)]), _vm._v(" "), _c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "uncovered-outdoor-table-main",
        "source": _vm.object_to_array(_vm.appraisal_uncovered_outdoors),
        "filterable": false,
        "striped": _vm.uncovered_outdoor_table.striped,
        "editable": _vm.uncovered_outdoor_table.editable,
        "line-numbers": _vm.uncovered_outdoor_table.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-uncovered-outdoors",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.deleteUncoveredOutdoor(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "trash-o",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }, {
        key: "netarea",
        fn: function(cell) {
          return [_c('div', {}, [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['netarea']),
              expression: "cell.row['netarea']"
            }],
            attrs: {
              "type": "number",
              "min": "0"
            },
            domProps: {
              "value": (cell.row['netarea'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'netarea';
                if (!Array.isArray($$exp)) {
                  cell.row['netarea'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, function($event) {
                _vm.set_uncovered_outdoor_netarea($event, cell.row)
              }],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])]
        }
      }, {
        key: "description",
        fn: function(cell) {
          return [_c('div', {}, [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['description']),
              expression: "cell.row['description']"
            }],
            attrs: {
              "type": "text"
            },
            domProps: {
              "value": (cell.row['description'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'description';
                if (!Array.isArray($$exp)) {
                  cell.row['description'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, function($event) {
                _vm.set_uncovered_outdoor_description($event, cell.row)
              }]
            }
          })])]
        }
      }, {
        key: "type",
        fn: function(cell) {
          return [_c('div', [_c('multiselect', {
            attrs: {
              "placeholder": "",
              "value": _vm.uncovered_outdoor_typeValue,
              "options": _vm.uncovered_outdoor_typeOptions,
              "track-by": "id",
              "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
              "searchable": false,
              "selectedLabel": "",
              "selectLabel": "",
              "deselectLabel": ""
            },
            on: {
              "input": function($event) {
                _vm.set_uncovered_outdoor_type($event, cell.row)
              }
            },
            model: {
              value: (cell.row['type']),
              callback: function($$v) {
                var $$exp = cell.row,
                  $$idx = 'type';
                if (!Array.isArray($$exp)) {
                  cell.row['type'] = $$v
                } else {
                  $$exp.splice($$idx, 1, $$v)
                }
              },
              expression: "cell.row['type']"
            }
          })], 1)]
        }
      }])
    }, [_vm._l((_vm.uncovered_outdoor_table.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "actions-uncovered-outdoors",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    })], 2)], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Total_areas_summary_table')))]), _vm._v(" "), _c('div', {
      staticClass: "calc_table"
    }, [_c('table', {
      staticClass: "table-striped",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', {
      staticStyle: {
        "min-width": "120px",
        "text-align": "right"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Registry')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "min-width": "120px"
      }
    }, [_vm._v(_vm._s(_vm.$t('Cadaster')))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "min-width": "120px"
      }
    }, [_vm._v(_vm._s(_vm.$t('Checked')))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "min-width": "300px"
      }
    }, [_vm._v(_vm._s(_vm.$t('Selected')))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "min-width": "120px"
      }
    }, [_vm._v(_vm._s(_vm.$t('Adopted')))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Net_area')))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.net_registry_area)) + " m²")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.net_cadastral_area)) + " m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.net_checked_area)) + " m²")]), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.net_selected_areaValue,
        "options": _vm.selected_areaOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_net_selected_area
      },
      model: {
        value: (_vm.appraisal.net_selected_area),
        callback: function($$v) {
          _vm.appraisal.net_selected_area = $$v
        },
        expression: "appraisal.net_selected_area"
      }
    })], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.net_adopted_area)) + " m²")])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Enclosed_area')) + " (A)")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.enclosed_registry_area)) + " m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.enclosed_cadastral_area)) + " m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.enclosed_checked_area)) + " m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.enclosed_selected_areaValue,
        "options": _vm.selected_areaOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_enclosed_selected_area
      },
      model: {
        value: (_vm.appraisal.enclosed_selected_area),
        callback: function($$v) {
          _vm.appraisal.enclosed_selected_area = $$v
        },
        expression: "appraisal.enclosed_selected_area"
      }
    })], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.enclosed_adopted_area)) + " m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Covered_outdoor_area')) + " (B)")])]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("formatNumber")(_vm.appraisal.covered_terraces_total_registry_area)) + " m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("formatNumber")(_vm.appraisal.covered_terraces_total_cadastral_area)) + " m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("formatNumber")(_vm.appraisal.covered_terraces_total_checked_area)) + " m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.covered_outdoors_selected_areaValue,
        "options": _vm.selected_areaOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_covered_outdoors_selected_area
      },
      model: {
        value: (_vm.appraisal.covered_outdoors_selected_area),
        callback: function($$v) {
          _vm.appraisal.covered_outdoors_selected_area = $$v
        },
        expression: "appraisal.covered_outdoors_selected_area"
      }
    })], 1), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("formatNumber")(_vm.appraisal.covered_terraces_total_adopted_area)) + " m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Built_area')) + " ( (A+B) / 2 )")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.built_registry_area)) + " m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.built_cadastral_area)) + " m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.built_checked_area)) + " m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.built_selected_areaValue,
        "options": _vm.selected_areaOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_built_selected_area
      },
      model: {
        value: (_vm.appraisal.built_selected_area),
        callback: function($$v) {
          _vm.appraisal.built_selected_area = $$v
        },
        expression: "appraisal.built_selected_area"
      }
    })], 1), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.built_adopted_area)) + " m²")])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Common_elements')))])]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("formatNumber")(_vm.appraisal.common_elements_registry_area)) + " m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("formatNumber")(_vm.appraisal.common_elements_cadastral_area)) + " m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("formatNumber")(_vm.appraisal.common_elements_checked_area)) + " m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.common_elements_selected_areaValue,
        "options": _vm.selected_areaOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_common_elements_selected_area
      },
      model: {
        value: (_vm.appraisal.common_elements_selected_area),
        callback: function($$v) {
          _vm.appraisal.common_elements_selected_area = $$v
        },
        expression: "appraisal.common_elements_selected_area"
      }
    })], 1), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("formatNumber")(_vm.appraisal.common_elements_adopted_area)) + " m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Built_plus_common_elements')))])]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("formatNumber")(_vm.appraisal.built_plus_common_elements_registry_area)) + " m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("formatNumber")(_vm.appraisal.built_plus_common_elements_cadastral_area)) + " m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("formatNumber")(_vm.appraisal.built_plus_common_elements_checked_area)) + " m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.built_plus_common_elements_selected_areaValue,
        "options": _vm.selected_areaOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_built_plus_common_elements_selected_area
      },
      model: {
        value: (_vm.appraisal.built_plus_common_elements_selected_area),
        callback: function($$v) {
          _vm.appraisal.built_plus_common_elements_selected_area = $$v
        },
        expression: "appraisal.built_plus_common_elements_selected_area"
      }
    })], 1), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("formatNumber")(_vm.appraisal.built_plus_common_elements_adopted_area)) + " m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])])])])])])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.cession_and_rights_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Cessió, drets i protecció')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.cession_and_rights_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Cession, rights and protection')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.cession_and_rights_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Cessión, derechos y protección')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.cession_and_rights_text) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Occupancy')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Property_title')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.property_title),
        expression: "appraisal.property_title"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.property_title)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.property_title = $event.target.value
        }, _vm.set_appraisal_property_title]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Occupancy_status')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.occupancy_statusValue,
        "options": _vm.occupancy_statusOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_occupancy_status
      },
      model: {
        value: (_vm.appraisal.occupancy_status),
        callback: function($$v) {
          _vm.appraisal.occupancy_status = $$v
        },
        expression: "appraisal.occupancy_status"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Usage_assigned')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.usage_assigned),
        expression: "appraisal.usage_assigned"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.usage_assigned)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.usage_assigned = $event.target.value
        }, _vm.set_appraisal_usage_assigned]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field-group"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Property_usage')) + " (BdE)")]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.usage_typeBdEValue,
        "options": _vm.usage_typeBdEOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_usage_type
      },
      model: {
        value: (_vm.appraisal.usage_type),
        callback: function($$v) {
          _vm.appraisal.usage_type = $$v
        },
        expression: "appraisal.usage_type"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Inspection_realized')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.inspection_realized),
        expression: "appraisal.inspection_realized"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.inspection_realized)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.inspection_realized = $event.target.value
        }, _vm.set_appraisal_inspection_realized]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Economical_activity')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.economical_activity),
        expression: "appraisal.economical_activity"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.economical_activity)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.economical_activity = $event.target.value
        }, _vm.set_appraisal_economical_activity]
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Lease')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Is_it_rented_or_ceded_q')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.cession_boolean),
        expression: "appraisal.cession_boolean"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.cession_boolean) ? _vm._i(_vm.appraisal.cession_boolean, null) > -1 : (_vm.appraisal.cession_boolean)
      },
      on: {
        "click": _vm.set_appraisal_cession_boolean,
        "__c": function($event) {
          var $$a = _vm.appraisal.cession_boolean,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.cession_boolean = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.cession_boolean = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.cession_boolean = $$c
          }
        }
      }
    })])]), _vm._v(" "), (_vm.appraisal.cession_boolean) ? _c('div', [_c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Cession_contract_start_date')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.cession_contract_start_date),
        expression: "appraisal.cession_contract_start_date"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "date",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.cession_contract_start_date)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.cession_contract_start_date = $event.target.value
        }, _vm.set_appraisal_cession_contract_start_date]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Cession_contract_period_years')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.cession_contract_period_years),
        expression: "appraisal.cession_contract_period_years"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.cession_contract_period_years)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.cession_contract_period_years = $event.target.value
        }, _vm.set_appraisal_cession_contract_period_years],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Cession_contract_remaining_years')) + " (" + _vm._s(_vm.$t('acc_appraisal_date')) + ")")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.appraisal.cession_contract_remaining_years) + " " + _vm._s(_vm.$t('years')))])])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Cession_gross_monthly_income')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.cession_gross_monthly_income),
        expression: "appraisal.cession_gross_monthly_income"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.cession_gross_monthly_income)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.cession_gross_monthly_income = $event.target.value
        }, _vm.set_appraisal_cession_gross_monthly_income],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Cession_gross_yearly_income')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.cession_gross_yearly_income),
        expression: "appraisal.cession_gross_yearly_income"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.cession_gross_yearly_income)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.cession_gross_yearly_income = $event.target.value
        }, _vm.set_appraisal_cession_gross_yearly_income],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Landlord_expenses_pct')) + " (%)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.landlord_expenses_pct),
        expression: "appraisal.landlord_expenses_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.landlord_expenses_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.landlord_expenses_pct = $event.target.value
        }, _vm.set_appraisal_landlord_expenses_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Cession_net_yearly_income')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.cession_net_yearly_income)) + " €")])])]), _vm._v(" "), _c('div', {
      staticClass: "fiel-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Cession_gross_monthly_income_by_contract')))])])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Tenant_age_years')) + " (" + _vm._s(_vm.$t('years')) + ")")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.tenant_age_years),
        expression: "appraisal.tenant_age_years"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.tenant_age_years)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.tenant_age_years = $event.target.value
        }, _vm.set_appraisal_tenant_age_years],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Tenant_life_expectancy_years')) + " (" + _vm._s(_vm.$t('years')) + ")")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.tenant_life_expectancy_years),
        expression: "appraisal.tenant_life_expectancy_years"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.tenant_life_expectancy_years)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.tenant_life_expectancy_years = $event.target.value
        }, _vm.set_appraisal_tenant_life_expectancy_years],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Tenant_remaining_life_expectancy_years')) + " (" + _vm._s(_vm.$t('years')) + ")")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.appraisal.tenant_remaining_life_expectancy_years) + " " + _vm._s(_vm.$t('years')))])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Right_of_use')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('Bare_ownership')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Is_the_right_of_use_ceded_q')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.right_of_use_boolean),
        expression: "appraisal.right_of_use_boolean"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.right_of_use_boolean) ? _vm._i(_vm.appraisal.right_of_use_boolean, null) > -1 : (_vm.appraisal.right_of_use_boolean)
      },
      on: {
        "click": _vm.set_appraisal_right_of_use_boolean,
        "__c": function($event) {
          var $$a = _vm.appraisal.right_of_use_boolean,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.right_of_use_boolean = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.right_of_use_boolean = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.right_of_use_boolean = $$c
          }
        }
      }
    })])]), _vm._v(" "), (_vm.appraisal.right_of_use_boolean) ? _c('div', [_c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Usufructuary_age_years')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.usufructuary_age_years),
        expression: "appraisal.usufructuary_age_years"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.usufructuary_age_years)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.usufructuary_age_years = $event.target.value
        }, _vm.set_appraisal_usufructuary_age_years],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Protection_regime')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Is_the_real_estate_protected_q')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.protection_boolean),
        expression: "appraisal.protection_boolean"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.protection_boolean) ? _vm._i(_vm.appraisal.protection_boolean, null) > -1 : (_vm.appraisal.protection_boolean)
      },
      on: {
        "click": _vm.set_appraisal_protection_boolean,
        "__c": function($event) {
          var $$a = _vm.appraisal.protection_boolean,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.protection_boolean = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.protection_boolean = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.protection_boolean = $$c
          }
        }
      }
    })])]), _vm._v(" "), (_vm.appraisal.protection_boolean) ? _c('div', [_c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Protection_type')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.protection_typeValue,
        "options": _vm.protection_typeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_protection_type
      },
      model: {
        value: (_vm.appraisal.protection_type),
        callback: function($$v) {
          _vm.appraisal.protection_type = $$v
        },
        expression: "appraisal.protection_type"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Protection_regime')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.protection_regimeValue,
        "options": _vm.protection_regimeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_protection_regime
      },
      model: {
        value: (_vm.appraisal.protection_regime),
        callback: function($$v) {
          _vm.appraisal.protection_regime = $$v
        },
        expression: "appraisal.protection_regime"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Protection_zone')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.protection_zoneValue,
        "options": _vm.protection_zoneOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_protection_zone
      },
      model: {
        value: (_vm.appraisal.protection_zone),
        callback: function($$v) {
          _vm.appraisal.protection_zone = $$v
        },
        expression: "appraisal.protection_zone"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Maximum_legal_sale_price')) + " (€/m²)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.max_legal_price),
        expression: "appraisal.max_legal_price"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.max_legal_price)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.max_legal_price = $event.target.value
        }, _vm.set_appraisal_max_legal_price],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Maximum_legal_computable_area')) + " (m²)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.max_legal_area),
        expression: "appraisal.max_legal_area"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.max_legal_area)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.max_legal_area = $event.target.value
        }, _vm.set_appraisal_max_legal_area],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]) : _vm._e()])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.Market_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Mercat')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.Market_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Market')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.Market_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Mercado')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.Market_text) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Market_study')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Select')) + " " + _vm._s(_vm.$t('a')) + " " + _vm._s(_vm.$t('Market_study')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.marketstudy_idValue,
        "options": this.object_to_array(_vm.realestate_marketstudies),
        "track-by": "id",
        "label": 'id',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisal_marketstudy_id
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v("Id")]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.appraisal.marketstudy_id) + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Market_value')))]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm._f("formatNumber")(_vm.appraisal.market_value)) + " € ")])]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Market_unit_value')))]), _vm._v(" "), _c('strong', [_c('span', [_vm._v(" " + _vm._s(_vm._f("formatNumber")(_vm.appraisal.market_unit_value)) + " €/m² ")])])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('button', {
      staticClass: "quote-request__aux__button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onOpenMarketStudy($event)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.onOpenMarketStudy($event)
        }
      }
    }, [_c('span', [_c('icon', {
      attrs: {
        "name": "external-link",
        "scale": "1",
        "color": "rgb(0, 79, 146)"
      }
    }), _vm._v(" " + _vm._s(_vm.$t('Edit')) + " " + _vm._s(_vm.$t('Market_study')))], 1)])])])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.technical_values_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Valors tècnics')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.technical_values_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Technical values')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.technical_values_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Valores técnicos')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.technical_values_text))]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Construction_cost_by_contract')))]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Adjusted_bec_price')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.adjusted_bec_price))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('BEC_expenses_plus_builders_benefit_pct')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.expenses_and_industrial_benefit_bec_pct) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Material_execution_cost_as_new')))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm._f("formatNumber")(_vm.appraisal.material_execution_cost)) + " €/m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Mec_adjustment_coef')))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.mec_adjustment_coef),
        expression: "appraisal.mec_adjustment_coef"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "step": "0.05",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.mec_adjustment_coef)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.mec_adjustment_coef = $event.target.value
        }, _vm.set_appraisal_mec_adjustment_coef],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Adopted_material_execution_cost')))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm._f("formatNumber")(_vm.appraisal.adopted_material_execution_cost)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Integrity')) + " " + _vm._s(_vm.$t('or')) + " " + _vm._s(_vm.$t('remaining')) + " " + _vm._s(_vm.$t('of')) + " " + _vm._s(_vm.$t('Depreciation_by_antiquity')) + " (da = 100 - d)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.total_depreciation_pct) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Adopted_material_execution_cost_deprecated_by_antiquity')) + " (Cem))\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.deprecated_material_execution_cost)) + " €/m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Builders_industrial_benefit_percentage')))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.bc_pct),
        expression: "appraisal.bc_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.bc_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.bc_pct = $event.target.value
        }, _vm.set_appraisal_bc_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }), _vm._v(" %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Builders_industrial_benefit')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.bc)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Builders_general_expenses_percentage')) + " (% Gc)")]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.gc_pct),
        expression: "appraisal.gc_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.gc_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.gc_pct = $event.target.value
        }, _vm.set_appraisal_gc_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }), _vm._v(" %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Builders_general_expenses')) + " (Gc) ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.gc)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Builders_expenses_and_benefit_percentage')) + " (% Bc + % Gc)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.bc_and_gc_pct) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Builders_expenses_and_benefit')) + " (Bc + Gc) ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.bc_and_gc)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v(_vm._s(_vm.$t('Construction_costs')) + " (Cc = Cem + Bc + Gc) ")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.cc)) + " €/m²")])])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Development_expenses')))]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Honorarium_c_taxes_and_licenses_percentage')) + " (% HTL)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.htl_pct) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Honorarium_c_taxes_and_licenses')) + " (HTL)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.htl)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Non_recoverable_taxes_percentage')) + " % Impostos no recuperables (% INR)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.inr_pct) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Non_recoverable_taxes')) + " Impostos no recuperables (INR)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.inr)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Developers_administrative_expenses_percentage')) + " (% Ga)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.ga_pct) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Developers_administrative_expenses')) + " (Ga)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.ga)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Decennial_insurance_policy_expenses_percentage')) + " (% Gpd)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.gpd_pct) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Decennial_insurance_policy_expenses')) + " (Gpd)")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.gpd)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("% OCT")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.oct_pct) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("OCT")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.oct)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Development_expenses_percentage')) + " (% Gp = % HTL + % INR + % Ga + % Gpd + % OCT)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.gp_pct) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v(_vm._s(_vm.$t('Development_expenses')) + " (Gp = HTL + INR + Ga + Gpd + OCT)")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.gp)) + " €/m²")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Construction_costs')) + " (Cc)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.cc)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v(_vm._s(_vm.$t('Construction_replacement_cost')) + " (Cc + Gp)")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.cc_and_gp)) + " €/m²")])])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Developers_benefit')))]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Riskfree_rate')) + " (TLR)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.tlr_pct) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Risk_premium')) + " (PR)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.pr_pct) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Agravation_or_improvement_coeficient')) + " (Coef. AM)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.am_coef))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Freemarket_benefit')) + " (b1 = (TLR + PR) * Coef. AM )\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.b1_pct) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Minimum_benefit_acc_to_regulation')) + " (b2)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.b2_pct) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v(_vm._s(_vm.$t('Developers_benefit')) + "  (max: b1 vs b2)")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.appraisal.b_pct) + " %")])])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Land_market_value')))]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Building_market_value')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.market_unit_value)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Market_value_adjustment')) + " (%)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.market_value_appraiser_adjustment_pct),
        expression: "appraisal.market_value_appraiser_adjustment_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.market_value_appraiser_adjustment_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.market_value_appraiser_adjustment_pct = $event.target.value
        }, _vm.set_appraisal_market_value_appraiser_adjustment_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }), _vm._v(" %")])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v(_vm._s(_vm.$t('Adopted_building_market_value')) + " (VM)")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.adopted_market_unit_value)) + " €/m²")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Construction_costs')) + " (Cc)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.cc)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Development_expenses')) + " (Gp)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.gp)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Remaining_of_the_developers_benefit')) + " (1-b)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.b_remaining_pct) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v(_vm._s(_vm.$t('Land_market_value')) + " ( F = Vm * (1-b) - (Cc + Gp) )")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.f)) + " €/m²")])])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v("CRB: " + _vm._s(_vm.$t('Gross_Replacement_Cost')) + " (" + _vm._s(_vm.$t('finished_building')) + ")")]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Land_market_value')) + " (F)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.f)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('As_new_construction_cost')) + " (Ccb)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.ccb)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Development_expenses')) + " (Gpb)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.gpb)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v(_vm._s(_vm.$t('Gross_Replacement_Cost')) + " (CRB)")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.crb)) + " €/m²")])])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v("CRN: " + _vm._s(_vm.$t('Net_Replacement_Cost')) + " (" + _vm._s(_vm.$t('finished_building')) + ")")]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Land_market_value')) + " (F)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.f)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('As_new_construction_cost')) + " (Ccb)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.ccb)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Development_expenses')) + " (Gpb)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.gpb)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Construction_cost_and_development_expenses')) + " (Ccb + Gpb)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.ccb_and_gpb)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Adopted_age')) + " (A)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.adopted_age_years_old) + " " + _vm._s(_vm.$t('years')) + " (" + _vm._s(_vm.appraisal.adopted_age) + ")\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Estimated_useful_life')) + " (V"), _c('sub', [_vm._v("u")]), _vm._v(")\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.useful_life_years) + " " + _vm._s(_vm.$t('years')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Physical_depreciation')) + " (DFI = A * V"), _c('sub', [_vm._v("u")]), _vm._v(")\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.physical_depreciation_pct) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Functional_depreciation')) + " (DFU)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.functional_depreciation_pct) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Total_depreciation')) + " (D = (1 - DFI) * (1 - DFU))\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.total_depreciation_pct) + " %")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Deprecated_construction_cost')) + " (CCD = (Ccb + Gpb) * D)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.ccd)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Developers_administrative_expenses')) + " (Ga)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.ga)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Land_value_plus_deprecated_construction_cost')) + " (F + Ccd)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.deprecated_land_and_ccd)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("CRN: " + _vm._s(_vm.$t('Net_Replacement_Cost')) + " (" + _vm._s(_vm.$t('finished_building')) + ")")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.finished_realestate_crn)) + " €/m²")])])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v("CRN: " + _vm._s(_vm.$t('Net_Replacement_Cost')) + " (" + _vm._s(_vm.$t('real_estate_under_construction')) + ")")]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Land_market_value')) + " (F)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.f)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('As_new_construction_cost')) + " (Ccb)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.ccb)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Development_expenses')) + " (Gpb)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.gpb)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Construction_cost_and_development_expenses')) + " (Ccb + Gpb)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.ccb_and_gpb)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Construction_progress_percentage')) + " (%)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.total_construction_progress_pct),
        expression: "appraisal.total_construction_progress_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "max": "100",
        "step": "1",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.total_construction_progress_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.total_construction_progress_pct = $event.target.value
        }, _vm.set_appraisal_total_construction_progress_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }), _vm._v(" %\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Executed_construction_cost')) + " (Ccr)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.ccr)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Developers_administrative_expenses')) + " (" + _vm._s(_vm.$t('executed_construction')) + ") (Gar)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.gar)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Land_value_plus_executed_construction_cost')) + " (F + Ccr)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.executed_construction_cost)) + " €/m²")])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("CRN: " + _vm._s(_vm.$t('Net_Replacement_Cost')) + " (" + _vm._s(_vm.$t('real_estate_under_construction')) + ") (F + Ccr + Gar)")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.under_construction_realestate_crn)) + " €/m²")])])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Market_value')))]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('td', [_c('strong', [_vm._v(_vm._s(_vm.$t('Finished_building_market_value')) + " (VM)")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.adopted_market_unit_value)) + " €/m²")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.$t('Market_coeficient')) + " (K)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.k)))])])])])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.total_values_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Valors totals')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.total_values_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Total values')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.total_values_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Valores totales')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.total_values_text))]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Land_value')))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('Repercussion_method')))]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Built_area')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Unit_value')) + " (f)")]), _vm._v(" "), _c('th', [_vm._v(" " + _vm._s(_vm.$t('Land_total_value')) + " " + _vm._s(_vm.$t('by')) + " " + _vm._s(_vm.$t('Repercussion_method')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', [(_vm.appraisal.property_type) ? _c('span', [(_vm.currentLocale == 'ca') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_ca))]) : (_vm.currentLocale == 'en') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_es))])]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v("-" + _vm._s(_vm.realestate.door))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.adopted_area)) + " m²")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm._f("formatNumber")(_vm.appraisal.f)) + " €/m²")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.repercussion_method_land_value)) + " €")])])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Construction_value')))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('Cost_method')))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('Gross_Replacement_Cost')) + " (CRB)")]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Built_area')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Unit_value')) + " (Ccb + Gpb)")]), _vm._v(" "), _c('th', [_vm._v(" " + _vm._s(_vm.$t('Construction_value')) + " (CRB)")])]), _vm._v(" "), _c('tr', [_c('td', [(_vm.appraisal.property_type) ? _c('span', [(_vm.currentLocale == 'ca') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_ca))]) : (_vm.currentLocale == 'en') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_es))])]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v("-" + _vm._s(_vm.realestate.door))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.adopted_area)) + " m²")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm._f("formatNumber")(_vm.appraisal.ccb_and_gpb)) + " €/m²")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.cost_method_construction_crb_value)) + " €")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('Net_Replacement_Cost')) + " (CRN)")]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Built_area')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Unit_value')) + " " + _vm._s(_vm.$t('Deprecated_construction_cost')) + "  (Ccd)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', [_vm._v(" " + _vm._s(_vm.$t('Construction_value')) + " (CRN)")])]), _vm._v(" "), _c('tr', [_c('td', [(_vm.appraisal.property_type) ? _c('span', [(_vm.currentLocale == 'ca') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_ca))]) : (_vm.currentLocale == 'en') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_es))])]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v("-" + _vm._s(_vm.realestate.door))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.adopted_area)) + " m²")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm._f("formatNumber")(_vm.appraisal.ccd)) + " €/m²")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.cost_method_construction_crn_value)) + " €")])])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Real_estate_value')) + " (" + _vm._s(_vm.$t('Construction')) + " + " + _vm._s(_vm.$t('Land')) + ")")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('Cost_method')))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('Gross_Replacement_Cost')) + " (CRB)")]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Built_area')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Unit_value')) + " " + _vm._s(_vm.$t('Gross_Replacement_Cost')) + " (CRB)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', [_vm._v(" " + _vm._s(_vm.$t('Real_estate_value')) + " (CRB)")])]), _vm._v(" "), _c('tr', [_c('td', [(_vm.appraisal.property_type) ? _c('span', [(_vm.currentLocale == 'ca') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_ca))]) : (_vm.currentLocale == 'en') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_es))])]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v("-" + _vm._s(_vm.realestate.door))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.adopted_area)) + " m²")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm._f("formatNumber")(_vm.appraisal.crb)) + " €/m²")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.cost_method_realestate_crb_value)) + " €")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('Net_Replacement_Cost')) + " (CRN) (" + _vm._s(_vm.$t('finished_building')) + ")")]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Built_area')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Unit_value')) + " " + _vm._s(_vm.$t('Net_Replacement_Cost')) + "  (CRN)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', [_vm._v(" " + _vm._s(_vm.$t('Real_estate_value')) + " (CRN)")])]), _vm._v(" "), _c('tr', [_c('td', [(_vm.appraisal.property_type) ? _c('span', [(_vm.currentLocale == 'ca') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_ca))]) : (_vm.currentLocale == 'en') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_es))])]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v("-" + _vm._s(_vm.realestate.door))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.adopted_area)) + " m²")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.finished_realestate_crn)) + " €/m²")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.cost_method_realestate_crn_value)) + " €")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.appraisal.total_construction_progress_pct < 100) ? _c('h4', [_vm._v(_vm._s(_vm.$t('Net_Replacement_Cost')) + " (CRN) (" + _vm._s(_vm.$t('real_estate_under_construction')) + ")")]) : _vm._e(), _vm._v(" "), (_vm.appraisal.total_construction_progress_pct < 100) ? _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Built_area')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Unit_value')) + " " + _vm._s(_vm.$t('Net_Replacement_Cost')) + "  (CRN)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', [_vm._v(" " + _vm._s(_vm.$t('Real_estate_value')) + " (CRN)")])]), _vm._v(" "), _c('tr', [_c('td', [(_vm.appraisal.property_type) ? _c('span', [(_vm.currentLocale == 'ca') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_ca))]) : (_vm.currentLocale == 'en') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_es))])]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v("-" + _vm._s(_vm.realestate.door))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.adopted_area)) + " m²")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.under_construction_realestate_crn)) + " €/m²")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.cost_method_unfinished_realestate_crn_value)) + " €")])])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('Comparison_Method')))]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Built_area')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Unit_value')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Real_estate_value')) + " " + _vm._s(_vm.$t('by')) + " " + _vm._s(_vm.$t('Comparison_Method')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', [(_vm.appraisal.property_type) ? _c('span', [(_vm.currentLocale == 'ca') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_ca))]) : (_vm.currentLocale == 'en') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_es))])]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v("-" + _vm._s(_vm.realestate.door))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.adopted_area)) + " m²")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.adopted_market_unit_value)) + " €/m²\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.comparison_method)) + " €")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('Maximum_Legal_Method')))]), _vm._v(" "), (this.appraisal.protection_boolean) ? _c('div', [_c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Maximum_legal_computable_area')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Maximum_legal_sale_price')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Real_estate_value')) + " " + _vm._s(_vm.$t('by')) + " " + _vm._s(_vm.$t('Maximum_Legal_Method')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', [(_vm.appraisal.property_type) ? _c('span', [(_vm.currentLocale == 'ca') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_ca))]) : (_vm.currentLocale == 'en') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_es))])]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v("-" + _vm._s(_vm.realestate.door))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.max_legal_area)) + " m²")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.max_legal_price)) + " €/m²")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.max_legal_method)) + " €")])])])])]) : _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('The_Real_Estate_is_not_protected')) + ". " + _vm._s(_vm.$t('The_value_is_not_calculated')) + ".")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('Expected_Income_Update_Method')))]), _vm._v(" "), (this.appraisal.cession_boolean) ? _c('div', [_c('span', [_vm._v("(" + _vm._s(_vm.$t('Remaining_period_update')) + ". " + _vm._s(_vm.$t('Constant_income_with_CPI_update_clause')) + ")")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('Contracts_foreseeable_remaining_period')) + " (u)")]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Cession_contract_start_date')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Cession_contract_period_years')))]), _vm._v(" "), _c('th', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Cession_contract_remaining_years')) + " (" + _vm._s(_vm.$t('acc_appraisal_date')) + ") (n1)\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Realestates_remaining_useful_life')) + " (n2)")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Tenant_remaining_life_expectancy_years')) + " (n3)")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Contracts_foreseeable_remaining_period')) + " (min. n1/n2/n3)\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', [(_vm.appraisal.property_type) ? _c('span', [(_vm.currentLocale == 'ca') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_ca))]) : (_vm.currentLocale == 'en') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_es))])]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v("-" + _vm._s(_vm.realestate.door))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.cession_contract_start_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.cession_contract_period_years) + " " + _vm._s(_vm.$t('years')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.cession_contract_remaining_years) + " " + _vm._s(_vm.$t('years')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.remaining_useful_life_years) + " " + _vm._s(_vm.$t('years')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.appraisal.tenant_remaining_life_expectancy_years) + " " + _vm._s(_vm.$t('years')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.u) + " " + _vm._s(_vm.$t('years')))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('Real_Estates_residual_value')))]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Market_value')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Construction_cost_by_contract')) + " (CRB-Constr.)")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Buildings_useful_life')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Remaining_contract_years')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Residual_depreciation')))]), _vm._v(" "), _c('th', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Real_estates_residual_value_at_the_end_of_the_contracts_useful_life')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', [(_vm.appraisal.property_type) ? _c('span', [(_vm.currentLocale == 'ca') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_ca))]) : (_vm.currentLocale == 'en') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_es))])]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v("-" + _vm._s(_vm.realestate.door))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.comparison_method)) + " €")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("formatNumber")(_vm.appraisal.cost_method_construction_crb_value)) + " €\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.useful_life_years) + " " + _vm._s(_vm.$t('years')) + " ")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.appraisal.u) + " " + _vm._s(_vm.$t('years')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.residual_depreciation)) + " €")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.realestate_residual_value)) + " €\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('Current_value_of_future_rents')))]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Gross_yearly_rent_income')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Landlord_expenses_pct')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Net_yearly_rent_income')) + " (Rn)")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Remaining_contract_years')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Update_type')) + " (i) (%)")]), _vm._v(" "), _c('th', [_vm._v("Coef. 1: [(1 + i) ^ n - 1] / [(1 + i) ^ n * i]")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Current_value_of_future_rents')) + " (Rn * n * coef_1)\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', [(_vm.appraisal.property_type) ? _c('span', [(_vm.currentLocale == 'ca') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_ca))]) : (_vm.currentLocale == 'en') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_es))])]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v("-" + _vm._s(_vm.realestate.door))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.cession_gross_yearly_income)) + " €\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.landlord_expenses_pct) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.cession_net_yearly_income)) + " €\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.u) + " " + _vm._s(_vm.$t('years')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.i_pct),
        expression: "appraisal.i_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.i_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.i_pct = $event.target.value
        }, _vm.set_appraisal_i_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.coef_1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.current_future_income_value)) + " €\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('Current_reversion_value_calculation')))]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$t('Real_estates_residual_value_at_the_end_of_the_contracts_useful_life')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Remaining_contract_years')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Update_type')) + " (i) (%)")]), _vm._v(" "), _c('th', [_vm._v("Coef. 2: ((1 + i) ^ n )")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Updated_reversion_value')) + " (" + _vm._s(_vm.$t('Residual_value')) + "/ coef. 2)\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', [(_vm.appraisal.property_type) ? _c('span', [(_vm.currentLocale == 'ca') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_ca))]) : (_vm.currentLocale == 'en') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_es))])]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v("-" + _vm._s(_vm.realestate.door))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.cession_gross_yearly_income)) + " €\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.u) + " " + _vm._s(_vm.$t('years')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.i_pct),
        expression: "appraisal.i_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "min": "0",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.i_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.i_pct = $event.target.value
        }, _vm.set_appraisal_i_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.coef_2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.updated_reversion_value)) + " €\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('Update_value_calculation')))]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Current_value_of_future_rents')) + " (A)")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Updated_reversion_value')) + " (B)")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Update_value')) + " (A+B)")])]), _vm._v(" "), _c('tr', [_c('td', [(_vm.appraisal.property_type) ? _c('span', [(_vm.currentLocale == 'ca') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_ca))]) : (_vm.currentLocale == 'en') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_es))])]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v("-" + _vm._s(_vm.realestate.door))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.current_future_income_value)) + " €\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.updated_reversion_value)) + " €\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.update_value)) + " €")])])])]) : _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('The_Real_Estate_is_not_rented_or_ceded')) + ". " + _vm._s(_vm.$t('The_value_is_not_calculated')) + ".")])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Right_of_use_value')))]), _vm._v(" "), (this.appraisal.right_of_use_boolean) ? _c('div', [_c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Usufructuary_age_years')) + " (n)")]), _vm._v(" "), _c('th', [_vm._v("Coef. V"), _c('sub', [_vm._v("u")]), _vm._v(" (max: 10% vs. 0,7 - 0,01 * ( n - 20))\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Usufruct_value')) + " (VM * Coef. V"), _c('sub', [_vm._v("u")]), _vm._v(")")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Bare_ownership_value')) + " (VM * (1 - Coef. V"), _c('sub', [_vm._v("u")]), _vm._v("))\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', [(_vm.appraisal.property_type) ? _c('span', [(_vm.currentLocale == 'ca') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_ca))]) : (_vm.currentLocale == 'en') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_es))])]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v("-" + _vm._s(_vm.realestate.door))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.usufructuary_age_years) + " " + _vm._s(_vm.$t('years')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.appraisal.vu_coef))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.usufruct_value)) + " €")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.bare_ownership_value)) + " €")])])])])]) : _c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('There_is_no_cession_of_the_right_of_use')) + ". " + _vm._s(_vm.$t('The_value_is_not_calculated')) + ".")])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Insurance_value')) + " s/ R. D. 685/1982")]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Gross_Replacement_Cost')) + " (CRB)\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "width": "50px"
      }
    }), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Land_value')))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "width": "50px"
      }
    }), _vm._v(" "), _c('th', [_vm._v(" Total ")])]), _vm._v(" "), _c('tr', [_c('td', [(_vm.appraisal.property_type) ? _c('span', [(_vm.currentLocale == 'ca') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_ca))]) : (_vm.currentLocale == 'en') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_es))])]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v("-" + _vm._s(_vm.realestate.door))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.cost_method_realestate_crb_value)) + " €")]), _vm._v(" "), _c('td', [_vm._v(" - ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm._f("formatNumber")(_vm.appraisal.repercussion_method_land_value)) + " €")]), _vm._v(" "), _c('td', [_vm._v(" = ")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.insurance_value_rd_685_1982)) + " €")])])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Insurance_value')) + " s/ R. D. 246/1998, 716/2009")]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Appraisal_value')) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "width": "50px"
      }
    }), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Land_value')))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "width": "50px"
      }
    }), _vm._v(" "), _c('th', [_vm._v(" Total ")])]), _vm._v(" "), _c('tr', [_c('td', [(_vm.appraisal.property_type) ? _c('span', [(_vm.currentLocale == 'ca') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_ca))]) : (_vm.currentLocale == 'en') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_es))])]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v("-" + _vm._s(_vm.realestate.door))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.realestate_total_adopted_value)) + " €")]), _vm._v(" "), _c('td', [_vm._v(" - ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm._f("formatNumber")(_vm.appraisal.repercussion_method_land_value)) + " €")]), _vm._v(" "), _c('td', [_vm._v(" = ")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.insurance_value_rd_716_2009)) + " €")])])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Appraisal_total_value_determination')))]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc"
    }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Comparison_Method')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Adjusted_Comparison_Method')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Maximum_Legal_Method')))]), _vm._v(" "), (_vm.appraisal.cession_boolean) ? _c('th', [_vm._v(_vm._s(_vm.$t('Expected_Income_Update_Method')))]) : _vm._e(), _vm._v(" "), (_vm.appraisal.total_construction_progress_pct < 100) ? _c('th', [_vm._v(_vm._s(_vm.$t('Net_Replacement_Cost')) + " (" + _vm._s(_vm.$t('real_estate_under_construction')) + ")")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Adopted_value')))])]), _vm._v(" "), _c('tr', [_c('td', [(_vm.appraisal.property_type) ? _c('span', [(_vm.currentLocale == 'ca') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_ca))]) : (_vm.currentLocale == 'en') ? _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.appraisal.property_type.name_es))])]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v("-" + _vm._s(_vm.realestate.door))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.comparison_method)) + " €")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.adjusted_market_value)) + " €")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.max_legal_method)) + " €")]), _vm._v(" "), (_vm.appraisal.cession_boolean) ? _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.update_value)) + " €")]) : _vm._e(), _vm._v(" "), (_vm.appraisal.total_construction_progress_pct < 100) ? _c('td', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.cost_method_unfinished_realestate_crn_value)) + " €")]) : _vm._e(), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisal.realestate_total_adopted_value)) + " €")])])])])])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.warnings_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Advertiments i observacions')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.warnings_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Warnings and notes')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.warnings_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Advertencias y observaciones')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.warnings_text) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "form-section"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Constraints')))]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCreateNewConstraint($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus-circle",
        "text": _vm.new_constraint_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), (_vm.currentLocale === 'ca') ? _c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "constraint-table-main",
        "source": _vm.object_to_array(_vm.appraisal_constraints),
        "filterable": false,
        "striped": _vm.constraint_table_ca.striped,
        "editable": _vm.constraint_table_ca.editable,
        "line-numbers": _vm.constraint_table_ca.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-constraints_ca",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.edit_text
            },
            on: {
              "click": function($event) {
                _vm.editConstraint(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "pencil",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.deleteConstraint(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "trash-o",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }])
    }, [_vm._l((_vm.constraint_table_ca.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "actions-constraints_ca",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    })], 2)], 1)])]) : (_vm.currentLocale === 'en') ? _c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "constraint-table-main",
        "source": _vm.object_to_array(_vm.appraisal_constraints),
        "filterable": false,
        "striped": _vm.constraint_table_en.striped,
        "editable": _vm.constraint_table_en.editable,
        "line-numbers": _vm.constraint_table_en.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-constraints_en",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.edit_text
            },
            on: {
              "click": function($event) {
                _vm.editConstraint(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "pencil",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.deleteConstraint(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "trash-o",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }])
    }, _vm._l((_vm.constraint_table_en.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }))], 1)])]) : _c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "constraint-table-main",
        "source": _vm.object_to_array(_vm.appraisal_constraints),
        "filterable": false,
        "striped": _vm.constraint_table_es.striped,
        "editable": _vm.constraint_table_es.editable,
        "line-numbers": _vm.constraint_table_es.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-constraints_es",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.edit_text
            },
            on: {
              "click": function($event) {
                _vm.editConstraint(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "pencil",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.deleteConstraint(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "trash-o",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }])
    }, _vm._l((_vm.constraint_table_es.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }))], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Warnings')))]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCreateNewWarning($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus-circle",
        "text": _vm.new_warning_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), (_vm.currentLocale === 'ca') ? _c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "warning-table-main",
        "source": _vm.object_to_array(_vm.appraisal_warnings),
        "filterable": false,
        "striped": _vm.warning_table_ca.striped,
        "editable": _vm.warning_table_ca.editable,
        "line-numbers": _vm.warning_table_ca.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-warnings_ca",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.edit_text
            },
            on: {
              "click": function($event) {
                _vm.editWarning(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "pencil",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.deleteWarning(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "trash-o",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }])
    }, [_vm._l((_vm.warning_table_ca.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "actions-warnings_ca",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    })], 2)], 1)])]) : (_vm.currentLocale === 'en') ? _c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "warning-table-main",
        "source": _vm.object_to_array(_vm.appraisal_warnings),
        "filterable": false,
        "striped": _vm.warning_table_en.striped,
        "editable": _vm.warning_table_en.editable,
        "line-numbers": _vm.warning_table_en.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-warnings_em",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.edit_text
            },
            on: {
              "click": function($event) {
                _vm.editWarning(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "pencil",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.deleteWarning(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "trash-o",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }])
    }, [_vm._l((_vm.warning_table_en.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "actions-warnings_en",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    })], 2)], 1)])]) : _c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "warning-table-main",
        "source": _vm.object_to_array(_vm.appraisal_warnings),
        "filterable": false,
        "striped": _vm.warning_table_es.striped,
        "editable": _vm.warning_table_es.editable,
        "line-numbers": _vm.warning_table_es.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-warnings_es",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.edit_text
            },
            on: {
              "click": function($event) {
                _vm.editWarning(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "pencil",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.deleteWarning(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "trash-o",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }])
    }, [_vm._l((_vm.warning_table_es.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "actions-warnings_es",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    })], 2)], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Notes')))]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCreateNewNote($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus-circle",
        "text": _vm.new_note_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), (_vm.currentLocale === 'ca') ? _c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "note-table-main",
        "source": _vm.object_to_array(_vm.appraisal_notes),
        "filterable": false,
        "striped": _vm.note_table_ca.striped,
        "editable": _vm.note_table_ca.editable,
        "line-numbers": _vm.note_table_ca.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-notes_es",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.edit_text
            },
            on: {
              "click": function($event) {
                _vm.editNote(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "pencil",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.deleteNote(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "trash-o",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }])
    }, [_vm._l((_vm.note_table_ca.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "actions-notes_es",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    })], 2)], 1)])]) : (_vm.currentLocale === 'en') ? _c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "note-table-main",
        "source": _vm.object_to_array(_vm.appraisal_notes),
        "filterable": false,
        "striped": _vm.note_table_en.striped,
        "editable": _vm.note_table_en.editable,
        "line-numbers": _vm.note_table_en.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-notes_en",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.edit_text
            },
            on: {
              "click": function($event) {
                _vm.editNote(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "pencil",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.deleteNote(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "trash-o",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }])
    }, [_vm._l((_vm.note_table_en.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "actions-notes_en",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    })], 2)], 1)])]) : _c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "note-table-main",
        "source": _vm.object_to_array(_vm.appraisal_notes),
        "filterable": false,
        "striped": _vm.note_table_es.striped,
        "editable": _vm.note_table_es.editable,
        "line-numbers": _vm.note_table_es.lineNumbers
      }
    }, _vm._l((_vm.note_table_es.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }))], 1)])])])])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.checks_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Comprovacions')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.checks_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Checks')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.checks_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Comprobaciones')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.checks_text))]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('div', {
      staticClass: "field-container"
    }, [_c('table', {
      staticStyle: {
        "width": "60em"
      }
    }, [_c('tr', [_c('th', [_c('h4', [_vm._v(_vm._s(_vm.$t('Checkings_realized')))])]), _vm._v(" "), _c('th', [_c('h4', [_vm._v(_vm._s(_vm.$t('Documents_used')))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('table', {
      staticStyle: {
        "width": "30em"
      }
    }, [_c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Cadastral_data')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.checks_cadastral_data),
        expression: "appraisal.checks_cadastral_data"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.checks_cadastral_data) ? _vm._i(_vm.appraisal.checks_cadastral_data, null) > -1 : (_vm.appraisal.checks_cadastral_data)
      },
      on: {
        "click": _vm.set_appraisal_checks_cadastral_data,
        "__c": function($event) {
          var $$a = _vm.appraisal.checks_cadastral_data,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.checks_cadastral_data = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.checks_cadastral_data = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.checks_cadastral_data = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Conservation_status')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.checks_conservation_status),
        expression: "appraisal.checks_conservation_status"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.checks_conservation_status) ? _vm._i(_vm.appraisal.checks_conservation_status, null) > -1 : (_vm.appraisal.checks_conservation_status)
      },
      on: {
        "click": _vm.set_appraisal_checks_conservation_status,
        "__c": function($event) {
          var $$a = _vm.appraisal.checks_conservation_status,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.checks_conservation_status = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.checks_conservation_status = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.checks_conservation_status = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Expropriation_procedure')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.checks_expropriation_procedure),
        expression: "appraisal.checks_expropriation_procedure"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.checks_expropriation_procedure) ? _vm._i(_vm.appraisal.checks_expropriation_procedure, null) > -1 : (_vm.appraisal.checks_expropriation_procedure)
      },
      on: {
        "click": _vm.set_appraisal_checks_expropriation_procedure,
        "__c": function($event) {
          var $$a = _vm.appraisal.checks_expropriation_procedure,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.checks_expropriation_procedure = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.checks_expropriation_procedure = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.checks_expropriation_procedure = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Expropriation_plan')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.checks_expropriation_plan),
        expression: "appraisal.checks_expropriation_plan"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.checks_expropriation_plan) ? _vm._i(_vm.appraisal.checks_expropriation_plan, null) > -1 : (_vm.appraisal.checks_expropriation_plan)
      },
      on: {
        "click": _vm.set_appraisal_checks_expropriation_plan,
        "__c": function($event) {
          var $$a = _vm.appraisal.checks_expropriation_plan,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.checks_expropriation_plan = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.checks_expropriation_plan = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.checks_expropriation_plan = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Expropriation_admin_ruling')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.checks_expropriation_admin_ruling),
        expression: "appraisal.checks_expropriation_admin_ruling"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.checks_expropriation_admin_ruling) ? _vm._i(_vm.appraisal.checks_expropriation_admin_ruling, null) > -1 : (_vm.appraisal.checks_expropriation_admin_ruling)
      },
      on: {
        "click": _vm.set_appraisal_checks_expropriation_admin_ruling,
        "__c": function($event) {
          var $$a = _vm.appraisal.checks_expropriation_admin_ruling,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.checks_expropriation_admin_ruling = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.checks_expropriation_admin_ruling = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.checks_expropriation_admin_ruling = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Expropriation_file')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.checks_expropriation_file),
        expression: "appraisal.checks_expropriation_file"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.checks_expropriation_file) ? _vm._i(_vm.appraisal.checks_expropriation_file, null) > -1 : (_vm.appraisal.checks_expropriation_file)
      },
      on: {
        "click": _vm.set_appraisal_checks_expropriation_file,
        "__c": function($event) {
          var $$a = _vm.appraisal.checks_expropriation_file,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.checks_expropriation_file = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.checks_expropriation_file = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.checks_expropriation_file = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Interior_visit')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.checks_interior_visit),
        expression: "appraisal.checks_interior_visit"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.checks_interior_visit) ? _vm._i(_vm.appraisal.checks_interior_visit, null) > -1 : (_vm.appraisal.checks_interior_visit)
      },
      on: {
        "click": _vm.set_appraisal_checks_interior_visit,
        "__c": function($event) {
          var $$a = _vm.appraisal.checks_interior_visit,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.checks_interior_visit = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.checks_interior_visit = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.checks_interior_visit = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Occupancy')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.checks_occupancy),
        expression: "appraisal.checks_occupancy"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.checks_occupancy) ? _vm._i(_vm.appraisal.checks_occupancy, null) > -1 : (_vm.appraisal.checks_occupancy)
      },
      on: {
        "click": _vm.set_appraisal_checks_occupancy,
        "__c": function($event) {
          var $$a = _vm.appraisal.checks_occupancy,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.checks_occupancy = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.checks_occupancy = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.checks_occupancy = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Registry_data')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.checks_registry_data),
        expression: "appraisal.checks_registry_data"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.checks_registry_data) ? _vm._i(_vm.appraisal.checks_registry_data, null) > -1 : (_vm.appraisal.checks_registry_data)
      },
      on: {
        "click": _vm.set_appraisal_checks_registry_data,
        "__c": function($event) {
          var $$a = _vm.appraisal.checks_registry_data,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.checks_registry_data = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.checks_registry_data = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.checks_registry_data = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Servitudes')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.checks_servitudes),
        expression: "appraisal.checks_servitudes"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.checks_servitudes) ? _vm._i(_vm.appraisal.checks_servitudes, null) > -1 : (_vm.appraisal.checks_servitudes)
      },
      on: {
        "click": _vm.set_appraisal_checks_servitudes,
        "__c": function($event) {
          var $$a = _vm.appraisal.checks_servitudes,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.checks_servitudes = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.checks_servitudes = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.checks_servitudes = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Public_protection_regime')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.checks_subsidy_status),
        expression: "appraisal.checks_subsidy_status"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.checks_subsidy_status) ? _vm._i(_vm.appraisal.checks_subsidy_status, null) > -1 : (_vm.appraisal.checks_subsidy_status)
      },
      on: {
        "click": _vm.set_appraisal_checks_subsidy_status,
        "__c": function($event) {
          var $$a = _vm.appraisal.checks_subsidy_status,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.checks_subsidy_status = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.checks_subsidy_status = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.checks_subsidy_status = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Urban_parameters_suitability')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.checks_urban_planning),
        expression: "appraisal.checks_urban_planning"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.checks_urban_planning) ? _vm._i(_vm.appraisal.checks_urban_planning, null) > -1 : (_vm.appraisal.checks_urban_planning)
      },
      on: {
        "click": _vm.set_appraisal_checks_urban_planning,
        "__c": function($event) {
          var $$a = _vm.appraisal.checks_urban_planning,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.checks_urban_planning = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.checks_urban_planning = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.checks_urban_planning = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Other')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.checks_other),
        expression: "appraisal.checks_other"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.checks_other)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.checks_other = $event.target.value
        }, _vm.set_appraisal_checks_other]
      }
    })])])])])]), _vm._v(" "), _c('td', [_c('table', {
      staticStyle: {
        "width": "30em"
      }
    }, [_c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Approved_project_by_professional_association')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.docs_approved_project),
        expression: "appraisal.docs_approved_project"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.docs_approved_project) ? _vm._i(_vm.appraisal.docs_approved_project, null) > -1 : (_vm.appraisal.docs_approved_project)
      },
      on: {
        "click": _vm.set_appraisal_docs_approved_project,
        "__c": function($event) {
          var $$a = _vm.appraisal.docs_approved_project,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.docs_approved_project = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.docs_approved_project = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.docs_approved_project = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Cadastral_documents')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.docs_cadastral_data),
        expression: "appraisal.docs_cadastral_data"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.docs_cadastral_data) ? _vm._i(_vm.appraisal.docs_cadastral_data, null) > -1 : (_vm.appraisal.docs_cadastral_data)
      },
      on: {
        "click": _vm.set_appraisal_docs_cadastral_data,
        "__c": function($event) {
          var $$a = _vm.appraisal.docs_cadastral_data,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.docs_cadastral_data = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.docs_cadastral_data = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.docs_cadastral_data = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Construction_license')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.docs_construction_license),
        expression: "appraisal.docs_construction_license"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.docs_construction_license) ? _vm._i(_vm.appraisal.docs_construction_license, null) > -1 : (_vm.appraisal.docs_construction_license)
      },
      on: {
        "click": _vm.set_appraisal_docs_construction_license,
        "__c": function($event) {
          var $$a = _vm.appraisal.docs_construction_license,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.docs_construction_license = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.docs_construction_license = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.docs_construction_license = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Construction_last_certificate')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.docs_construction_last_certificate),
        expression: "appraisal.docs_construction_last_certificate"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.docs_construction_last_certificate) ? _vm._i(_vm.appraisal.docs_construction_last_certificate, null) > -1 : (_vm.appraisal.docs_construction_last_certificate)
      },
      on: {
        "click": _vm.set_appraisal_docs_construction_last_certificate,
        "__c": function($event) {
          var $$a = _vm.appraisal.docs_construction_last_certificate,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.docs_construction_last_certificate = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.docs_construction_last_certificate = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.docs_construction_last_certificate = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Construction_contract')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.docs_construction_contract),
        expression: "appraisal.docs_construction_contract"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.docs_construction_contract) ? _vm._i(_vm.appraisal.docs_construction_contract, null) > -1 : (_vm.appraisal.docs_construction_contract)
      },
      on: {
        "click": _vm.set_appraisal_docs_construction_contract,
        "__c": function($event) {
          var $$a = _vm.appraisal.docs_construction_contract,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.docs_construction_contract = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.docs_construction_contract = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.docs_construction_contract = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Occupancy_status')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.docs_occupancy_status),
        expression: "appraisal.docs_occupancy_status"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.docs_occupancy_status) ? _vm._i(_vm.appraisal.docs_occupancy_status, null) > -1 : (_vm.appraisal.docs_occupancy_status)
      },
      on: {
        "click": _vm.set_appraisal_docs_occupancy_status,
        "__c": function($event) {
          var $$a = _vm.appraisal.docs_occupancy_status,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.docs_occupancy_status = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.docs_occupancy_status = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.docs_occupancy_status = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Photographic_report')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.docs_photographic_report),
        expression: "appraisal.docs_photographic_report"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.docs_photographic_report) ? _vm._i(_vm.appraisal.docs_photographic_report, null) > -1 : (_vm.appraisal.docs_photographic_report)
      },
      on: {
        "click": _vm.set_appraisal_docs_photographic_report,
        "__c": function($event) {
          var $$a = _vm.appraisal.docs_photographic_report,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.docs_photographic_report = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.docs_photographic_report = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.docs_photographic_report = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Property_sketch')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.docs_property_sketch),
        expression: "appraisal.docs_property_sketch"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.docs_property_sketch) ? _vm._i(_vm.appraisal.docs_property_sketch, null) > -1 : (_vm.appraisal.docs_property_sketch)
      },
      on: {
        "click": _vm.set_appraisal_docs_property_sketch,
        "__c": function($event) {
          var $$a = _vm.appraisal.docs_property_sketch,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.docs_property_sketch = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.docs_property_sketch = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.docs_property_sketch = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Property_titles')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.docs_property_titles),
        expression: "appraisal.docs_property_titles"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.docs_property_titles) ? _vm._i(_vm.appraisal.docs_property_titles, null) > -1 : (_vm.appraisal.docs_property_titles)
      },
      on: {
        "click": _vm.set_appraisal_docs_property_titles,
        "__c": function($event) {
          var $$a = _vm.appraisal.docs_property_titles,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.docs_property_titles = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.docs_property_titles = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.docs_property_titles = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Situation_plan')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.docs_situation_plan),
        expression: "appraisal.docs_situation_plan"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.docs_situation_plan) ? _vm._i(_vm.appraisal.docs_situation_plan, null) > -1 : (_vm.appraisal.docs_situation_plan)
      },
      on: {
        "click": _vm.set_appraisal_docs_situation_plan,
        "__c": function($event) {
          var $$a = _vm.appraisal.docs_situation_plan,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.docs_situation_plan = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.docs_situation_plan = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.docs_situation_plan = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Subsidy_status')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.docs_subsidy_status),
        expression: "appraisal.docs_subsidy_status"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.docs_subsidy_status) ? _vm._i(_vm.appraisal.docs_subsidy_status, null) > -1 : (_vm.appraisal.docs_subsidy_status)
      },
      on: {
        "click": _vm.set_appraisal_docs_subsidy_status,
        "__c": function($event) {
          var $$a = _vm.appraisal.docs_subsidy_status,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.docs_subsidy_status = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.docs_subsidy_status = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.docs_subsidy_status = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Ten_year_insurance')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.docs_tenyear_insurance),
        expression: "appraisal.docs_tenyear_insurance"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.docs_tenyear_insurance) ? _vm._i(_vm.appraisal.docs_tenyear_insurance, null) > -1 : (_vm.appraisal.docs_tenyear_insurance)
      },
      on: {
        "click": _vm.set_appraisal_docs_tenyear_insurance,
        "__c": function($event) {
          var $$a = _vm.appraisal.docs_tenyear_insurance,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.docs_tenyear_insurance = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.docs_tenyear_insurance = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.docs_tenyear_insurance = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Urban_plan')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.docs_urban_plan),
        expression: "appraisal.docs_urban_plan"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisal.docs_urban_plan) ? _vm._i(_vm.appraisal.docs_urban_plan, null) > -1 : (_vm.appraisal.docs_urban_plan)
      },
      on: {
        "click": _vm.set_appraisal_docs_urban_plan,
        "__c": function($event) {
          var $$a = _vm.appraisal.docs_urban_plan,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisal.docs_urban_plan = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisal.docs_urban_plan = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisal.docs_urban_plan = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Other')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.docs_other),
        expression: "appraisal.docs_other"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.docs_other)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.docs_other = $event.target.value
        }, _vm.set_appraisal_docs_other]
      }
    })])])])])])])])])])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.annexes_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Annexes')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.annexes_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Annexes')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.annexes_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Anexos')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.annexes_text) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticStyle: {
        "background": "lightyellow",
        "padding": "1rem"
      }
    }, [_c('span', [_c('strong', [_vm._v("Nota:")]), _vm._v(" Les imatges han de ser carregades en format PNG o JPG. Altres formats no funcionaran correctament a l'hora d'imprimir el PDF de l'informe.")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
      staticClass: "form-section"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Photographs')))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "background-color": "#fafafc",
        "padding-left": "2rem",
        "padding-top": "0.5rem",
        "padding-bottom": "1rem",
        "margin-top": "1rem",
        "margin-bottom": "1rem",
        "margin-right": "1rem"
      }
    }, [_c('h4', [_vm._v(_vm._s(_vm.$t('Upload_files')))]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": "files",
        "name": "files[]",
        "accept": "image/*",
        "multiple": ""
      },
      on: {
        "change": _vm.uploadPhotographFiles
      }
    })]), _vm._v(" "), _c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "constraint-table-main",
        "source": _vm.object_to_array(_vm.appraisal_photographs),
        "filterable": false,
        "striped": _vm.photograph_table_ca.striped,
        "editable": _vm.photograph_table_ca.editable,
        "line-numbers": _vm.photograph_table_ca.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-photographs",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.edit_text
            },
            on: {
              "click": function($event) {
                _vm.editPhotograph(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "pencil",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.deletePhotograph(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "trash-o",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }, {
        key: "cover-checkbox",
        fn: function(cell) {
          return [_c('div', [_c('checkbox', {
            attrs: {
              "id": cell.row.id,
              "editable": _vm.editabletrue
            },
            on: {
              "toggle_flag": function($event) {
                _vm.set_appraisal_cover_photo(cell.row['is_cover_photo'], cell.row)
              }
            },
            model: {
              value: (cell.row['is_cover_photo']),
              callback: function($$v) {
                var $$exp = cell.row,
                  $$idx = 'is_cover_photo';
                if (!Array.isArray($$exp)) {
                  cell.row['is_cover_photo'] = $$v
                } else {
                  $$exp.splice($$idx, 1, $$v)
                }
              },
              expression: "cell.row['is_cover_photo']"
            }
          })], 1)]
        }
      }, {
        key: "thumbnail-photographs",
        fn: function(cell) {
          return [_c('div', [_c('img', {
            attrs: {
              "src": cell.row['thumb_url'],
              "width": "200px",
              "height": "auto"
            }
          })])]
        }
      }])
    }, [_vm._l((_vm.photograph_table_ca.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "thumbnail-photographs",
        "label": "Thumbnail",
        "width": "240px",
        "sortable": false,
        "groupable": false
      }
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "cover-checkbox",
        "label": _vm.cover_text,
        "width": "80px",
        "sortable": false,
        "groupable": false
      }
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "actions-photographs",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    })], 2)], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Registry_Documents')))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "background-color": "#fafafc",
        "padding-left": "2rem",
        "padding-top": "0.5rem",
        "padding-bottom": "1rem",
        "margin-top": "1rem",
        "margin-bottom": "1rem",
        "margin-right": "1rem"
      }
    }, [_c('h4', [_vm._v(_vm._s(_vm.$t('Upload_files')))]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": "files",
        "name": "files[]",
        "accept": "image/*",
        "multiple": ""
      },
      on: {
        "change": _vm.uploadRegistryAnnexFiles
      }
    })]), _vm._v(" "), _c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "constraint-table-main",
        "source": _vm.object_to_array(_vm.appraisal_registryannexes),
        "filterable": false,
        "striped": _vm.registryannex_table_ca.striped,
        "editable": _vm.registryannex_table_ca.editable,
        "line-numbers": _vm.registryannex_table_ca.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-registryannexes",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.edit_text
            },
            on: {
              "click": function($event) {
                _vm.editRegistryAnnex(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "pencil",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.deleteRegistryAnnex(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "trash-o",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }, {
        key: "thumbnail-photographs",
        fn: function(cell) {
          return [_c('div', [_c('img', {
            attrs: {
              "src": cell.row['thumb_url'],
              "width": "200px",
              "height": "auto"
            }
          })])]
        }
      }])
    }, [_vm._l((_vm.registryannex_table_ca.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "thumbnail-photographs",
        "label": "Thumbnail",
        "width": "240px",
        "sortable": false,
        "groupable": false
      }
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "actions-registryannexes",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    })], 2)], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Cadastral_Documents')))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "background-color": "#fafafc",
        "padding-left": "2rem",
        "padding-top": "0.5rem",
        "padding-bottom": "1rem",
        "margin-top": "1rem",
        "margin-bottom": "1rem",
        "margin-right": "1rem"
      }
    }, [_c('h4', [_vm._v(_vm._s(_vm.$t('Upload_files')))]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": "files",
        "name": "files[]",
        "accept": "image/*",
        "multiple": ""
      },
      on: {
        "change": _vm.uploadCadasterAnnexFiles
      }
    })]), _vm._v(" "), _c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "constraint-table-main",
        "source": _vm.object_to_array(_vm.appraisal_cadasterannexes),
        "filterable": false,
        "striped": _vm.cadasterannex_table_ca.striped,
        "editable": _vm.cadasterannex_table_ca.editable,
        "line-numbers": _vm.cadasterannex_table_ca.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-cadasterannexes",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.edit_text
            },
            on: {
              "click": function($event) {
                _vm.editCadasterAnnex(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "pencil",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.deleteCadasterAnnex(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "trash-o",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }, {
        key: "thumbnail-photographs",
        fn: function(cell) {
          return [_c('div', [_c('img', {
            attrs: {
              "src": cell.row['thumb_url'],
              "width": "200px",
              "height": "auto"
            }
          })])]
        }
      }])
    }, [_vm._l((_vm.cadasterannex_table_ca.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "thumbnail-photographs",
        "label": "Thumbnail",
        "width": "240px",
        "sortable": false,
        "groupable": false
      }
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "actions-cadasterannexes",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    })], 2)], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Urban_Planning_Documents')))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "background-color": "#fafafc",
        "padding-left": "2rem",
        "padding-top": "0.5rem",
        "padding-bottom": "1rem",
        "margin-top": "1rem",
        "margin-bottom": "1rem",
        "margin-right": "1rem"
      }
    }, [_c('h4', [_vm._v(_vm._s(_vm.$t('Upload_files')))]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": "files",
        "name": "files[]",
        "accept": "image/*",
        "multiple": ""
      },
      on: {
        "change": _vm.uploadUrbanAnnexFiles
      }
    })]), _vm._v(" "), _c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "constraint-table-main",
        "source": _vm.object_to_array(_vm.appraisal_urbanannexes),
        "filterable": false,
        "striped": _vm.urbanannex_table_ca.striped,
        "editable": _vm.urbanannex_table_ca.editable,
        "line-numbers": _vm.urbanannex_table_ca.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-urbanannexes",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.edit_text
            },
            on: {
              "click": function($event) {
                _vm.editUrbanAnnex(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "pencil",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.deleteUrbanAnnex(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "trash-o",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }, {
        key: "thumbnail-photographs",
        fn: function(cell) {
          return [_c('div', [_c('img', {
            attrs: {
              "src": cell.row['thumb_url'],
              "width": "200px",
              "height": "auto"
            }
          })])]
        }
      }])
    }, [_vm._l((_vm.urbanannex_table_ca.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "thumbnail-photographs",
        "label": "Thumbnail",
        "width": "240px",
        "sortable": false,
        "groupable": false
      }
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "actions-urbanannexes",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    })], 2)], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Plans')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('Sketches')))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "background-color": "#fafafc",
        "padding-left": "2rem",
        "padding-top": "0.5rem",
        "padding-bottom": "1rem",
        "margin-top": "1rem",
        "margin-bottom": "1rem",
        "margin-right": "1rem"
      }
    }, [_c('h4', [_vm._v(_vm._s(_vm.$t('Upload_files')))]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": "files",
        "name": "files[]",
        "accept": "image/*",
        "multiple": ""
      },
      on: {
        "change": _vm.uploadPlanAnnexFiles
      }
    })]), _vm._v(" "), _c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "constraint-table-main",
        "source": _vm.object_to_array(_vm.appraisal_planannexes),
        "filterable": false,
        "striped": _vm.planannex_table_ca.striped,
        "editable": _vm.planannex_table_ca.editable,
        "line-numbers": _vm.planannex_table_ca.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-planannexes",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.edit_text
            },
            on: {
              "click": function($event) {
                _vm.editPlanAnnex(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "pencil",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.deletePlanAnnex(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "trash-o",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }, {
        key: "thumbnail-photographs",
        fn: function(cell) {
          return [_c('div', [_c('img', {
            attrs: {
              "src": cell.row['thumb_url'],
              "width": "200px",
              "height": "auto"
            }
          })])]
        }
      }])
    }, [_vm._l((_vm.planannex_table_ca.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "thumbnail-photographs",
        "label": "Thumbnail",
        "width": "240px",
        "sortable": false,
        "groupable": false
      }
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "actions-planannexes",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    })], 2)], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Cession_Documents')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('Contracts')))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "background-color": "#fafafc",
        "padding-left": "2rem",
        "padding-top": "0.5rem",
        "padding-bottom": "1rem",
        "margin-top": "1rem",
        "margin-bottom": "1rem",
        "margin-right": "1rem"
      }
    }, [_c('h4', [_vm._v(_vm._s(_vm.$t('Upload_files')))]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": "files",
        "name": "files[]",
        "accept": "image/*",
        "multiple": ""
      },
      on: {
        "change": _vm.uploadCessionAnnexFiles
      }
    })]), _vm._v(" "), _c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "constraint-table-main",
        "source": _vm.object_to_array(_vm.appraisal_cessionannexes),
        "filterable": false,
        "striped": _vm.cessionannex_table_ca.striped,
        "editable": _vm.cessionannex_table_ca.editable,
        "line-numbers": _vm.cessionannex_table_ca.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-cessionannexes",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.edit_text
            },
            on: {
              "click": function($event) {
                _vm.editCessionAnnex(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "pencil",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.deleteCessionAnnex(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "trash-o",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }, {
        key: "thumbnail-photographs",
        fn: function(cell) {
          return [_c('div', [_c('img', {
            attrs: {
              "src": cell.row['thumb_url'],
              "width": "200px",
              "height": "auto"
            }
          })])]
        }
      }])
    }, [_vm._l((_vm.cessionannex_table_ca.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "thumbnail-photographs",
        "label": "Thumbnail",
        "width": "240px",
        "sortable": false,
        "groupable": false
      }
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "actions-cessionannexes",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    })], 2)], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Other_Documents')))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "background-color": "#fafafc",
        "padding-left": "2rem",
        "padding-top": "0.5rem",
        "padding-bottom": "1rem",
        "margin-top": "1rem",
        "margin-bottom": "1rem",
        "margin-right": "1rem"
      }
    }, [_c('h4', [_vm._v(_vm._s(_vm.$t('Upload_files')))]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": "files",
        "name": "files[]",
        "accept": "image/*",
        "multiple": ""
      },
      on: {
        "change": _vm.uploadOtherAnnexFiles
      }
    })]), _vm._v(" "), _c('div', {}, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "constraint-table-main",
        "source": _vm.object_to_array(_vm.appraisal_otherannexes),
        "filterable": false,
        "striped": _vm.otherannex_table_ca.striped,
        "editable": _vm.otherannex_table_ca.editable,
        "line-numbers": _vm.otherannex_table_ca.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-otherannexes",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.edit_text
            },
            on: {
              "click": function($event) {
                _vm.editOtherAnnex(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "pencil",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.deleteOtherAnnex(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "trash-o",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }, {
        key: "thumbnail-photographs",
        fn: function(cell) {
          return [_c('div', [_c('img', {
            attrs: {
              "src": cell.row['thumb_url'],
              "width": "200px",
              "height": "auto"
            }
          })])]
        }
      }])
    }, [_vm._l((_vm.otherannex_table_ca.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "thumbnail-photographs",
        "label": "Thumbnail",
        "width": "240px",
        "sortable": false,
        "groupable": false
      }
    }), _vm._v(" "), _c('datatable-column', {
      attrs: {
        "id": "actions-otherannexes",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    })], 2)], 1)])])])])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.metadata_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Metadades')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.metadata_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Metadatos')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.metadata_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Metadata')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.metadata_text) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Description')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Appraisal_description')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisal.description),
        expression: "appraisal.description"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisal.description)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisal.description = $event.target.value
        }, _vm.set_appraisal_description]
      }
    })])])])])])])])], 1), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUp($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "level-up",
        "text": _vm.goup_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentAppraisal({
            go_up: false
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentAppraisal({
            go_up: true
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_and_go_up_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), (_vm.appraisal.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e()], 1)], 1)]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 2161 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 2162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "warning-editor"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "filesOpen": _vm.filesOpen,
        "fileOpen": _vm.fileOpen,
        "reportOpen": _vm.reportOpen
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [_c('span', [_vm._v(_vm._s(_vm.$t('Warning')))]), (_vm.warning.dirty) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.warning.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "datedata"
    }, [_c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Created')) + ": " + _vm._s(_vm.millis_to_time(_vm.warning.date_created)))]), _vm._v(" "), _c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Last_modified')) + ": " + _vm._s(_vm.millis_to_time(_vm.warning.date_modified)))])]), _vm._v(" "), _c('vue-tabs', [_c('v-tab', {
      attrs: {
        "title": _vm.data_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Warning')) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Warnings_foreseen_by_law')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.warningValue,
        "options": _vm.default_warningOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_warning
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Catalan')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.warning.name_ca),
        expression: "warning.name_ca"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.warning.name_ca)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.warning.name_ca = $event.target.value
        }, _vm.set_warning_name_ca]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('English')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.warning.name_en),
        expression: "warning.name_en"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.warning.name_en)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.warning.name_en = $event.target.value
        }, _vm.set_warning_name_en]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Spanish')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.warning.name_es),
        expression: "warning.name_es"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.warning.name_es)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.warning.name_es = $event.target.value
        }, _vm.set_warning_name_es]
      }
    })])])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.metadata_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('form', {
      staticClass: "bt-form"
    })])])], 1), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUp($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "chevron-left",
        "text": _vm.goup_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentWarning({
            go_up: false
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentWarning({
            go_up: true
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_and_go_up_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), (_vm.warning.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e()], 1)], 1)]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 2163 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "appraisals-index"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "filesOpen": _vm.filesOpen,
        "reportOpen": _vm.reportOpen
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [(!_vm.entity.name) ? _c('span', [_vm._v(_vm._s(_vm.$t('New_entity')))]) : _c('span', [_vm._v(_vm._s(_vm.entity.name))]), _vm._v(" "), (_vm.entity.dirty) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.entity.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "datedata"
    }, [(_vm.entity.date_created) ? _c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Created')) + ": " + _vm._s(_vm.millis_to_time(_vm.entity.date_created)))]) : _vm._e(), _vm._v(" "), (_vm.entity.date_modified) ? _c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Last_modified')) + ": " + _vm._s(_vm.millis_to_time(_vm.entity.date_modified)))]) : _vm._e()]), _vm._v(" "), _c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Data')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Name')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.entity.name),
        expression: "entity.name"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.entity.name)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.entity.name = $event.target.value
        }, _vm.set_entity_name]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('TIN')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.entity.tin),
        expression: "entity.tin"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.entity.tin)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.entity.tin = $event.target.value
        }, _vm.set_entity_tin]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('BdE_code')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.entity.bde_code),
        expression: "entity.bde_code"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.entity.bde_code)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.entity.bde_code = $event.target.value
        }, _vm.set_entity_bde_code]
      }
    })])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUp($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "chevron-left",
        "text": _vm.goup_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentEntity({
            go_up: false
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentEntity({
            go_up: true
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_and_go_up_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), (_vm.entity.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e()], 1)])], 1)], 1)]
  ], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('hr')])
}]}

/***/ }),
/* 2164 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field__group",
    class: {
      active: _vm.isActive
    },
    on: {
      "click": _vm.onClick
    }
  }, [_c('label', {
    staticClass: "field__group__label"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), (_vm.type === 'password') ? _c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus",
      value: (_vm.autofocus),
      expression: "autofocus"
    }],
    staticClass: "field__group__input no-border",
    attrs: {
      "placeholder": _vm.placeholder,
      "autofocus": _vm.autofocus,
      "type": "password",
      "spellcheck": "false"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.onInput($event.target.value)
      },
      "focus": function($event) {
        _vm.isActive = true
      },
      "blur": function($event) {
        _vm.isActive = false
      }
    }
  }) : (_vm.type === 'email') ? _c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus",
      value: (_vm.autofocus),
      expression: "autofocus"
    }],
    staticClass: "field__group__input",
    attrs: {
      "placeholder": _vm.placeholder,
      "autofocus": _vm.autofocus,
      "type": "email",
      "spellcheck": "false"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.onInput($event.target.value)
      },
      "focus": function($event) {
        _vm.isActive = true
      },
      "blur": function($event) {
        _vm.isActive = false
      }
    }
  }) : (_vm.type === 'textarea') ? _c('textarea', {
    directives: [{
      name: "focus",
      rawName: "v-focus",
      value: (_vm.autofocus),
      expression: "autofocus"
    }],
    staticClass: "field__group__input",
    attrs: {
      "placeholder": _vm.placeholder,
      "autofocus": _vm.autofocus,
      "rows": "8",
      "spellcheck": "false"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.onInput($event.target.value)
      },
      "focus": function($event) {
        _vm.isActive = true
      },
      "blur": function($event) {
        _vm.isActive = false
      }
    }
  }) : _c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus",
      value: (_vm.autofocus),
      expression: "autofocus"
    }],
    staticClass: "field__group__input",
    attrs: {
      "placeholder": _vm.placeholder,
      "autofocus": _vm.autofocus,
      "type": "text",
      "spellcheck": "false"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.onInput($event.target.value)
      },
      "focus": function($event) {
        _vm.isActive = true
      },
      "blur": function($event) {
        _vm.isActive = false
      }
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 2165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message",
    style: ({
      color: _vm.text_color,
      borderColor: _vm.border_color,
      backgroundColor: _vm.background_color
    })
  }, [_c('span', {
    staticClass: "text"
  }, [_c('icon', {
    attrs: {
      "name": _vm.icon_name,
      "scale": "1",
      "color": _vm.icon_color
    }
  }), _vm._v(" \n      " + _vm._s(_vm.text) + "\n    ")], 1)])
},staticRenderFns: []}

/***/ }),
/* 2166 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "success-message"
  }, [_c('span', {
    staticClass: "success-text"
  }, [_vm._v("\n      " + _vm._s(_vm.text) + "\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "success-close",
    on: {
      "click": _vm.closeMessage
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 2167 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "registryannex-editor"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "filesOpen": _vm.filesOpen,
        "fileOpen": _vm.fileOpen,
        "reportOpen": _vm.reportOpen
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [_c('span', [_vm._v(_vm._s(_vm.$t('Annex')) + " \"" + _vm._s(_vm.registryannex.filename) + "\"")]), (_vm.registryannex.dirty) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.registryannex.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "datedata"
    }, [_c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Created')) + ": " + _vm._s(_vm.millis_to_time(_vm.registryannex.date_created)))]), _vm._v(" "), _c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Last_modified')) + ": " + _vm._s(_vm.millis_to_time(_vm.registryannex.date_modified)))])]), _vm._v(" "), _c('vue-tabs', [_c('v-tab', {
      attrs: {
        "title": _vm.data_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('div', {
      staticClass: "field-container"
    }, [(_vm.registryannex.url) ? _c('div', [_c('img', {
      attrs: {
        "src": _vm.registryannex.url,
        "width": "600px",
        "height": "auto"
      }
    })]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('File_name')) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('File_name')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.registryannex.filename))])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Image_footer')) + " ")]), _vm._v(" "), (_vm.registryannex.name_ca || _vm.currentLocale === 'ca') ? _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Image_footer')) + " " + _vm._s(_vm.$t('in')) + " " + _vm._s(_vm.$t('Catalan')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.registryannex.name_ca),
        expression: "registryannex.name_ca"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.registryannex.name_ca)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.registryannex.name_ca = $event.target.value
        }, _vm.set_registryannex_name_ca]
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.registryannex.name_en || _vm.currentLocale === 'en') ? _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Image_footer')) + " " + _vm._s(_vm.$t('in')) + " " + _vm._s(_vm.$t('English')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.registryannex.name_en),
        expression: "registryannex.name_en"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.registryannex.name_en)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.registryannex.name_en = $event.target.value
        }, _vm.set_registryannex_name_en]
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.registryannex.name_es || _vm.currentLocale === 'es') ? _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Image_footer')) + " " + _vm._s(_vm.$t('in')) + " " + _vm._s(_vm.$t('Spanish')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.registryannex.name_es),
        expression: "registryannex.name_es"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.registryannex.name_es)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.registryannex.name_es = $event.target.value
        }, _vm.set_registryannex_name_es]
      }
    })])]) : _vm._e()])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.metadata_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('form', {
      staticClass: "bt-form"
    })])])], 1), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUp($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "chevron-left",
        "text": _vm.goup_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentRegistryAnnex({
            go_up: false
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentRegistryAnnex({
            go_up: true
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_and_go_up_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), (_vm.registryannex.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e()], 1)], 1)]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 2168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "urbanannex-editor"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "filesOpen": _vm.filesOpen,
        "fileOpen": _vm.fileOpen,
        "reportOpen": _vm.reportOpen
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [_c('span', [_vm._v(_vm._s(_vm.$t('Annex')) + " \"" + _vm._s(_vm.urbanannex.filename) + "\"")]), (_vm.urbanannex.dirty) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.urbanannex.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "datedata"
    }, [_c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Created')) + ": " + _vm._s(_vm.millis_to_time(_vm.urbanannex.date_created)))]), _vm._v(" "), _c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Last_modified')) + ": " + _vm._s(_vm.millis_to_time(_vm.urbanannex.date_modified)))])]), _vm._v(" "), _c('vue-tabs', [_c('v-tab', {
      attrs: {
        "title": _vm.data_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('div', {
      staticClass: "field-container"
    }, [(_vm.urbanannex.url) ? _c('div', [_c('img', {
      attrs: {
        "src": _vm.urbanannex.url,
        "width": "600px",
        "height": "auto"
      }
    })]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('File_name')) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('File_name')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.urbanannex.filename))])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Image_footer')) + " ")]), _vm._v(" "), (_vm.urbanannex.name_ca || _vm.currentLocale === 'ca') ? _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Image_footer')) + " " + _vm._s(_vm.$t('in')) + " " + _vm._s(_vm.$t('Catalan')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.urbanannex.name_ca),
        expression: "urbanannex.name_ca"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.urbanannex.name_ca)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.urbanannex.name_ca = $event.target.value
        }, _vm.set_urbanannex_name_ca]
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.urbanannex.name_en || _vm.currentLocale === 'en') ? _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Image_footer')) + " " + _vm._s(_vm.$t('in')) + " " + _vm._s(_vm.$t('English')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.urbanannex.name_en),
        expression: "urbanannex.name_en"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.urbanannex.name_en)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.urbanannex.name_en = $event.target.value
        }, _vm.set_urbanannex_name_en]
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.urbanannex.name_es || _vm.currentLocale === 'es') ? _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Image_footer')) + " " + _vm._s(_vm.$t('in')) + " " + _vm._s(_vm.$t('Spanish')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.urbanannex.name_es),
        expression: "urbanannex.name_es"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.urbanannex.name_es)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.urbanannex.name_es = $event.target.value
        }, _vm.set_urbanannex_name_es]
      }
    })])]) : _vm._e()])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.metadata_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('form', {
      staticClass: "bt-form"
    })])])], 1), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUp($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "chevron-left",
        "text": _vm.goup_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentUrbanAnnex({
            go_up: false
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentUrbanAnnex({
            go_up: true
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_and_go_up_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), (_vm.urbanannex.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e()], 1)], 1)]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 2169 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "appraisals-index"
    }
  }, [(_vm.loading) ? _c('spinner') : [_c('side-nav-bar', {
    attrs: {
      "filesOpen": _vm.filesOpen,
      "fileOpen": _vm.fileOpen,
      "fileId": _vm.appraisalfile.id,
      "fileNumber": _vm.appraisalfile.number,
      "reportOpen": _vm.reportOpen,
      "reportNumber": _vm.appraisalreport.number,
      "versionNumber": _vm.appraisalreport.version,
      "realEstates": _vm.appraisalreport_realestates,
      "realEstateId": _vm.realestate.id,
      "reportId": _vm.appraisalreport.id
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "app-container"
  }, [_c('bar'), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('Edit_Appraisal'))), (_vm.appraisal.dirty) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "datedata"
  }, [_c('p', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('Created')) + ": " + _vm._s(_vm.millis_to_time(_vm.appraisal.date_created)))]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('Last_modified')) + ": " + _vm._s(_vm.millis_to_time(_vm.appraisal.date_modified)))])]), _vm._v(" "), _c('div', {
    staticClass: "tab_container"
  }, [_c('span', [_vm._v("hola!")])])], 1)]], 2)
},staticRenderFns: []}

/***/ }),
/* 2170 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "appraisalquote-editor"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), (_vm.selecting_realestate) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "dialog_container"
    }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('Select_Real_estate_to_be_added')) + " " + _vm._s(_vm.$t('or')) + " "), _c('span', {
      staticClass: "navspan",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCreateNewRealEstate()
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('create_a_new_one')))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Existing_Real_estates')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.importRealEstateValue,
        "options": _vm.object_to_array(_vm.realestates),
        "track-by": "id",
        "label": 'full_address',
        "searchable": true
      },
      on: {
        "input": _vm.set_import_realestate
      },
      model: {
        value: (_vm.appraisalquote.importRealEstate),
        callback: function($$v) {
          _vm.appraisalquote.importRealEstate = $$v
        },
        expression: "appraisalquote.importRealEstate"
      }
    })], 1)]), _vm._v(" "), _c('table', {
      staticClass: "dialog_buttons_table"
    }, [_c('tr', [_c('td', [_c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-right": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCancelImportNewRealEstate($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "times",
        "text": '',
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray",
        "min_width": "80px",
        "max_width": "80px"
      }
    })], 1)])]), _vm._v(" "), _c('td', [_c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onImportNewRealEstate({
            id: _vm.appraisalquote.importRealEstate.id
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "check",
        "text": '',
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray",
        "min_width": "80px",
        "max_width": "80px"
      }
    })], 1)])])])])])]) : _vm._e(), _vm._v(" "), (_vm.creating_contact) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "dialog_container"
    }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('Create_new_contact')))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "form-section"
    }, [_c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Person_type')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.value,
        "options": _vm.personTypeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ?
          'name_ca' : (_vm.currentLocale === 'en') ?
          'name_en' : 'name_es',
        "searchable": false
      },
      on: {
        "input": _vm.set_contact_person_type
      },
      model: {
        value: (_vm.contact.person_type),
        callback: function($$v) {
          _vm.contact.person_type = $$v
        },
        expression: "contact.person_type"
      }
    })], 1)]), _vm._v(" "), (_vm.contact.person_type) ? _c('div', [_c('div', {
      staticClass: "field-container"
    }, [(_vm.contact.person_type.id === 1) ? _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Title')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.value,
        "options": _vm.honorificTitleOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ?
          'abb_ca' : (_vm.currentLocale === 'en') ?
          'abb_en' : 'abb_es',
        "searchable": false
      },
      on: {
        "input": _vm.set_contact_title
      },
      model: {
        value: (_vm.contact.title),
        callback: function($$v) {
          _vm.contact.title = $$v
        },
        expression: "contact.title"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Name')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.contact.name),
        expression: "contact.name"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.contact.name)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.contact.name = $event.target.value
        }, _vm.set_contact_name]
      }
    })]), _vm._v(" "), (_vm.contact.person_type.id === 1) ? _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Surnames')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.contact.surnames),
        expression: "contact.surnames"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.contact.surnames)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.contact.surnames = $event.target.value
        }, _vm.set_contact_surnames]
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Main_email')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.contact.main_email),
        expression: "contact.main_email"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.contact.main_email)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.contact.main_email = $event.target.value
        }, _vm.set_contact_main_email]
      }
    })])]), _vm._v(" "), (_vm.contact.person_type.id === 1) ? _c('div', [_c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Organization_s_Company')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.contact.organization),
        expression: "contact.organization"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.contact.organization)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.contact.organization = $event.target.value
        }, _vm.set_contact_organization]
      }
    })])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('table', {
      staticClass: "dialog_buttons_table"
    }, [_c('tr', [_c('td', [_c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-right": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCancelCreateNewContact($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "times",
        "text": '',
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray",
        "min_width": "80px",
        "max_width": "80px"
      }
    })], 1)])]), _vm._v(" "), _c('td', [_c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCreateNewContact($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "check",
        "text": '',
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray",
        "min_width": "80px",
        "max_width": "80px"
      }
    })], 1)])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "filesOpen": _vm.filesOpen,
        "fileOpen": _vm.fileOpen,
        "fileId": _vm.appraisalfile.id,
        "fileNumber": _vm.appraisalfile.number,
        "quoteOpen": _vm.quoteOpen,
        "quoteNumber": _vm.appraisalquote.full_number,
        "realEstates": _vm.appraisalquote_realestates,
        "quoteId": _vm.appraisalquote.id
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('Appraisal_quote')) + " "), (_vm.appraisalquote.full_number) ? _c('span', [_vm._v(_vm._s(_vm.appraisalquote.full_number))]) : _vm._e(), (_vm.appraisalquote.dirty) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.appraisalquote.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "datedata"
    }, [_c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Created')) + ": " + _vm._s(_vm.millis_to_time(_vm.appraisalquote.date_created)))]), _vm._v(" "), _c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Last_modified')) + ": " + _vm._s(_vm.millis_to_time(_vm.appraisalquote.date_modified)))])]), _vm._v(" "), _c('vue-tabs', [_c('v-tab', {
      attrs: {
        "title": _vm.quotecontent_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Quote_petitioners')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container",
      staticStyle: {
        "background-color": "#fafafc",
        "padding": "2rem"
      }
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Surnames_name_or_company'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.petitionerValue,
        "options": _vm.object_to_array(_vm.contacts),
        "track-by": "id",
        "label": 'complete_name',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisalquote_petitioner
      },
      model: {
        value: (_vm.appraisalquote.petitioner),
        callback: function($$v) {
          _vm.appraisalquote.petitioner = $$v
        },
        expression: "appraisalquote.petitioner"
      }
    }, [_c('span', {
      style: ({
        color: _vm.no_result_color
      }),
      attrs: {
        "slot-scope": "props"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onAddNewContact($event)
        },
        "mouseover": function($event) {
          _vm.no_result_color = 'rgb(0, 135, 248)'
        },
        "mouseleave": function($event) {
          _vm.no_result_color = 'black'
        }
      },
      slot: "noResult"
    }, [_vm._v("Cap resultat. Click per crear nou.")])])], 1), _vm._v(" "), (_vm.appraisalquote.petitioner) ? _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onAddNewPetitioner($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus-circle",
        "text": _vm.add_petitioner_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), (_vm.object_length(_vm.appraisalquote_petitioners) > 0) ? _c('div', [_c('div', {
      staticClass: "text_table"
    }, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "data-table-appraisalquote_petitioners",
        "source": _vm.object_to_array(_vm.appraisalquote_petitioners),
        "filterable": false,
        "striped": _vm.petitioner_table.striped,
        "editable": _vm.petitioner_table.editable,
        "line-numbers": _vm.petitioner_table.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-petitioners",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.edit_text
            },
            on: {
              "click": function($event) {
                _vm.editContact(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "pencil",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.discardPetitioner(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "times",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }])
    }, [_c('datatable-column', {
      attrs: {
        "id": "actions-petitioners",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    }), _vm._v(" "), _vm._l((_vm.petitioner_table.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    })], 2)], 1)])])]) : _c('div', [_c('br'), _vm._v(_vm._s(_vm.$t('No_petitioners_text')))])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Date')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('Purpose')) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Date_of_quote'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalquote.quotedate),
        expression: "appraisalquote.quotedate"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "date",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisalquote.quotedate)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisalquote.quotedate = $event.target.value
        }, _vm.set_appraisalquote_quotedate]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Purpose')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.purposeValue,
        "options": _vm.purposeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisalquote_purpose
      },
      model: {
        value: (_vm.appraisalquote.purpose),
        callback: function($$v) {
          _vm.appraisalquote.purpose = $$v
        },
        expression: "appraisalquote.purpose"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Real_estates')) + " " + _vm._s(_vm.$t('valuated_in_this_quote')))]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSelectNewRealEstate($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus-circle",
        "text": _vm.select_real_estate_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), (_vm.object_length(_vm.appraisalquote_realestates) > 0) ? _c('div', [_c('div', {
      staticClass: "text_table"
    }, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "data-table-realestates",
        "source": _vm.object_to_array(_vm.appraisalquote_realestates),
        "filterable": false,
        "striped": _vm.realestate_table.striped,
        "editable": _vm.realestate_table.editable,
        "line-numbers": _vm.realestate_table.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-realestates",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.edit_text
            },
            on: {
              "click": function($event) {
                _vm.editRealEstate(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "pencil",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.discardRealEstate(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "times",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }, {
        key: "property_type",
        fn: function(cell) {
          return [(cell.row['property_type']) ? _c('span', [(_vm.currentLocale === 'ca') ? _c('span', [_vm._v(_vm._s(cell.row['property_type']['name_ca']))]) : (_vm.currentLocale === 'en') ? _c('span', [_vm._v(_vm._s(cell.row['property_type']['name_en']))]) : _c('span', [_vm._v(_vm._s(cell.row['property_type']['name_es']))])]) : _vm._e()]
        }
      }, {
        key: "appraisal_id",
        fn: function(cell) {
          return [_c('div', [_c('multiselect', {
            attrs: {
              "placeholder": "",
              "value": _vm.realestate_appraisaldateValue,
              "options": _vm.object_to_array(_vm.appraisalquote_realestates[cell.row['id']]['appraisals']),
              "track-by": "id",
              "label": 'id',
              "searchable": false,
              "selectedLabel": "",
              "selectLabel": "",
              "deselectLabel": ""
            },
            on: {
              "input": function($event) {
                _vm.set_appraisalquote_realestate_appraisal_id($event, cell.row['id'])
              }
            },
            model: {
              value: (cell.row['appraisal_id']),
              callback: function($$v) {
                var $$exp = cell.row,
                  $$idx = 'appraisal_id';
                if (!Array.isArray($$exp)) {
                  cell.row['appraisal_id'] = $$v
                } else {
                  $$exp.splice($$idx, 1, $$v)
                }
              },
              expression: "cell.row['appraisal_id']"
            }
          })], 1)]
        }
      }, {
        key: "appraisaldate",
        fn: function(cell) {
          return [_c('div', [(cell.row.appraisal_id) ? _c('span', [_vm._v(_vm._s(cell.row.appraisal_id.appraisaldate))]) : _vm._e()])]
        }
      }, {
        key: "realestate_total_adopted_value",
        fn: function(cell) {
          return [_c('div', [(cell.row.appraisal_id) ? _c('span', [_vm._v(_vm._s(_vm._f("formatNumber")(cell.row.appraisal_id.realestate_total_adopted_value)) + " €")]) : _vm._e()])]
        }
      }])
    }, [_c('datatable-column', {
      attrs: {
        "id": "actions-realestates",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    }), _vm._v(" "), _vm._l((_vm.realestate_table.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    })], 2)], 1)])])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Final_price')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Discount_pct')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalquote.discount_pct),
        expression: "appraisalquote.discount_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "max": "100",
        "min": "0",
        "step": "1",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisalquote.discount_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisalquote.discount_pct = $event.target.value
        }, _vm.set_appraisalquote_discount_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Final_price')))]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.appraisalquote.final_price)) + " €")])])])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Discount_notes')))]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalquote.discount_notes),
        expression: "appraisalquote.discount_notes"
      }],
      staticClass: "field__group__textarea",
      attrs: {
        "rows": "3",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisalquote.discount_notes)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisalquote.discount_notes = $event.target.value
        }, _vm.set_appraisalquote_discount_notes]
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Fiscal_parameters')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('VAT_pct')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalquote.vat_pct),
        expression: "appraisalquote.vat_pct"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisalquote.vat_pct)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisalquote.vat_pct = $event.target.value
        }, _vm.set_appraisalquote_vat_pct],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Payment_conditions')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Bank_name')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalquote.bank_name),
        expression: "appraisalquote.bank_name"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisalquote.bank_name)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisalquote.bank_name = $event.target.value
        }, _vm.set_appraisalquote_bank_name]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v("IBAN")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalquote.iban),
        expression: "appraisalquote.iban"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisalquote.iban)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisalquote.iban = $event.target.value
        }, _vm.set_appraisalquote_iban]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Court_assistance_fees')) + " (€)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalquote.court_assistance_fees),
        expression: "appraisalquote.court_assistance_fees"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisalquote.court_assistance_fees)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisalquote.court_assistance_fees = $event.target.value
        }, _vm.set_appraisalquote_court_assistance_fees],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Required_docs')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container",
      staticStyle: {
        "background-color": "#fafafc",
        "padding": "2rem"
      }
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Documentation_type')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.requireddocValue,
        "options": _vm.requireddocOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisalquote_requireddoc
      },
      model: {
        value: (_vm.appraisalquote.requireddoc),
        callback: function($$v) {
          _vm.appraisalquote.requireddoc = $$v
        },
        expression: "appraisalquote.requireddoc"
      }
    })], 1), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onAddNewRequiredDoc($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus-circle",
        "text": _vm.add_requireddoc_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), (_vm.object_length(_vm.appraisalquote_requireddocs) > 0) ? _c('div', [_c('div', {
      staticClass: "text_table"
    }, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "data-table-appraisalquote_requireddocs",
        "source": _vm.object_to_array(_vm.appraisalquote_requireddocs),
        "filterable": false,
        "striped": _vm.requireddoc_table.striped,
        "editable": _vm.requireddoc_table.editable,
        "line-numbers": _vm.requireddoc_table.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-requireddocs",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.discardRequiredDoc(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "times",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }])
    }, [_c('datatable-column', {
      attrs: {
        "id": "actions-requireddocs",
        "label": _vm.actions_text,
        "width": "80px",
        "sortable": false,
        "groupable": false
      }
    }), _vm._v(" "), _vm._l((_vm.requireddoc_table.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    })], 2)], 1)])])]) : _c('div', [_c('br'), _vm._v(_vm._s(_vm.$t('No_requireddocs_text')))])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Signature')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [(_vm.appraisalquote.signature_uid === _vm.user.id || !_vm.appraisalquote.is_signed) ? _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Sign_quote')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalquote.is_signed),
        expression: "appraisalquote.is_signed"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisalquote.is_signed) ? _vm._i(_vm.appraisalquote.is_signed, null) > -1 : (_vm.appraisalquote.is_signed)
      },
      on: {
        "click": _vm.set_appraisalquote_is_signed,
        "__c": function($event) {
          var $$a = _vm.appraisalquote.is_signed,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisalquote.is_signed = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisalquote.is_signed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisalquote.is_signed = $$c
          }
        }
      }
    })]) : _c('div', {
      staticClass: "field__group"
    }, [_c('span')]), _vm._v(" "), _c('div', {
      staticClass: "field-group"
    }, [(_vm.appraisalquote.is_signed) ? _c('div', [_c('img', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "src": _vm.appraisalquote.signature_base64,
        "alt": "s"
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.appraisalquote.signature_name))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Signed')) + " " + _vm._s(_vm._f("formatDateAsLocal")(_vm.appraisalquote.signature_date)))])]) : _vm._e()])]), _vm._v(" "), _c('hr')])]), _vm._v(" "), (_vm.object_length(_vm.appraisalquote_petitioners) > 0 && _vm.object_length(_vm.appraisalquote_realestates) > 0 && _vm.object_length(_vm.appraisalquote_requireddocs) > 0) ? _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCreatePdf($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "file-pdf-o",
        "text": _vm.pdf_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]) : _c('div', [(!this.appraisalquote_petitioners) ? _c('div', [_c('message', {
      attrs: {
        "text": _vm.petitioners_missing_error_text,
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : _vm._e(), _vm._v(" "), (!this.appraisalquote_realestates) ? _c('div', [_c('message', {
      attrs: {
        "text": _vm.realestates_missing_error_text,
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : _vm._e(), _vm._v(" "), (!this.appraisalquote_requireddocs) ? _c('div', [_c('message', {
      attrs: {
        "text": _vm.requireddocs_missing_error_text,
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : _vm._e()])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.metadata_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Description')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Appraisal_quote_description')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalquote.description),
        expression: "appraisalquote.description"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisalquote.description)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisalquote.description = $event.target.value
        }, _vm.set_appraisalquote_description]
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Quote_number')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Quote_number')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalquote.number),
        expression: "appraisalquote.number"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "maxlength": "2",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisalquote.number)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisalquote.number = $event.target.value
        }, _vm.set_appraisalquote_number],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Version')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalquote.version),
        expression: "appraisalquote.version"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "maxlength": "2",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisalquote.version)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisalquote.version = $event.target.value
        }, _vm.set_appraisalquote_version],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Status')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Status')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.statusValue,
        "options": _vm.status_quotesOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisalquote_status
      },
      model: {
        value: (_vm.appraisalquote.status),
        callback: function($$v) {
          _vm.appraisalquote.status = $$v
        },
        expression: "appraisalquote.status"
      }
    })], 1)])])])])])], 1), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUp($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "chevron-left",
        "text": _vm.goup_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentAppraisalQuote({
            go_up: false
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentAppraisalQuote({
            go_up: true
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_and_go_up_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), (_vm.appraisalquote.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e()], 1)], 1)]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 2171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "dashboard"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _c('div', {
      staticClass: "master_view"
    }, [_c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('div', {
      staticStyle: {
        "text-align": "center",
        "margin-top": "10vh"
      }
    }, [_c('h1', [_vm._v("Hola " + _vm._s(_vm.user.nickname) + " !")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "text-align": "center",
        "margin-top": "18vh"
      }
    }, [_c('h2', {
      staticStyle: {
        "color": "black"
      }
    }, [_vm._v("Bonell+Dòriga")])])], 1)])]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 2172 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "planannex-editor"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "filesOpen": _vm.filesOpen,
        "fileOpen": _vm.fileOpen,
        "reportOpen": _vm.reportOpen
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [_c('span', [_vm._v(_vm._s(_vm.$t('Annex')) + " \"" + _vm._s(_vm.planannex.filename) + "\"")]), (_vm.planannex.dirty) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.planannex.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "datedata"
    }, [_c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Created')) + ": " + _vm._s(_vm.millis_to_time(_vm.planannex.date_created)))]), _vm._v(" "), _c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Last_modified')) + ": " + _vm._s(_vm.millis_to_time(_vm.planannex.date_modified)))])]), _vm._v(" "), _c('vue-tabs', [_c('v-tab', {
      attrs: {
        "title": _vm.data_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('div', {
      staticClass: "field-container"
    }, [(_vm.planannex.url) ? _c('div', [_c('img', {
      attrs: {
        "src": _vm.planannex.url,
        "width": "600px",
        "height": "auto"
      }
    })]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('File_name')) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('File_name')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.planannex.filename))])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Image_footer')) + " ")]), _vm._v(" "), (_vm.planannex.name_ca || _vm.currentLocale === 'ca') ? _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Image_footer')) + " " + _vm._s(_vm.$t('in')) + " " + _vm._s(_vm.$t('Catalan')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.planannex.name_ca),
        expression: "planannex.name_ca"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.planannex.name_ca)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.planannex.name_ca = $event.target.value
        }, _vm.set_planannex_name_ca]
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.planannex.name_en || _vm.currentLocale === 'en') ? _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Image_footer')) + " " + _vm._s(_vm.$t('in')) + " " + _vm._s(_vm.$t('English')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.planannex.name_en),
        expression: "planannex.name_en"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.planannex.name_en)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.planannex.name_en = $event.target.value
        }, _vm.set_planannex_name_en]
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.planannex.name_es || _vm.currentLocale === 'es') ? _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Image_footer')) + " " + _vm._s(_vm.$t('in')) + " " + _vm._s(_vm.$t('Spanish')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.planannex.name_es),
        expression: "planannex.name_es"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.planannex.name_es)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.planannex.name_es = $event.target.value
        }, _vm.set_planannex_name_es]
      }
    })])]) : _vm._e()])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.metadata_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('form', {
      staticClass: "bt-form"
    })])])], 1), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUp($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "chevron-left",
        "text": _vm.goup_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentPlanAnnex({
            go_up: false
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentPlanAnnex({
            go_up: true
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_and_go_up_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), (_vm.planannex.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e()], 1)], 1)]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 2173 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "appraisals-index"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "filesOpen": _vm.filesOpen,
        "reportOpen": _vm.reportOpen
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [(!_vm.appraiser.surnames) ? _c('span', [_vm._v(_vm._s(_vm.$t('New_appraiser')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('Appraiser')) + " " + _vm._s(_vm.appraiser.name) + " " + _vm._s(_vm.appraiser.surnames))]), _vm._v(" "), (_vm.appraiser.dirty) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.appraiser.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "datedata"
    }, [_c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Created')) + ": " + _vm._s(_vm.millis_to_time(_vm.appraiser.date_created)))]), _vm._v(" "), _c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Last_modified')) + ": " + _vm._s(_vm.millis_to_time(_vm.appraiser.date_modified)))])]), _vm._v(" "), _c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Data')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Name')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraiser.name),
        expression: "appraiser.name"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraiser.name)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraiser.name = $event.target.value
        }, _vm.set_appraiser_name]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Surnames')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraiser.surnames),
        expression: "appraiser.surnames"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraiser.surnames)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraiser.surnames = $event.target.value
        }, _vm.set_appraiser_surnames]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('TIN')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraiser.tin),
        expression: "appraiser.tin"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraiser.tin)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraiser.tin = $event.target.value
        }, _vm.set_appraiser_tin]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Prof_assoc_reg_number')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraiser.prof_assoc_reg_number),
        expression: "appraiser.prof_assoc_reg_number"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraiser.prof_assoc_reg_number)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraiser.prof_assoc_reg_number = $event.target.value
        }, _vm.set_appraiser_prof_assoc_reg_number]
      }
    })])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoBack($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "chevron-left",
        "text": _vm.goback_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentAppraiser({
            goback: true
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), (_vm.appraiser.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e()], 1)])], 1)], 1)]
  ], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('hr')])
}]}

/***/ }),
/* 2174 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}

/***/ }),
/* 2175 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "appraisals-index"
    }
  }, [(_vm.loading) ? _c('spinner') : [_c('side-nav-bar', {
    attrs: {
      "fileOpen": _vm.fileOpen
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "app-container"
  }, [_c('bar'), _vm._v(" "), _c('h1', [_c('span', [_vm._v(_vm._s(_vm.$t('Index_of_Appraisals')) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', [_c('form', {
    staticClass: "bt-form"
  }, [_c('div', {
    staticClass: "form-section"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Appraisals')))]), _vm._v(" "), (_vm.all_realestate_appraisals.length > 0) ? _c('div', [_c('div', {
    staticClass: "grid-row",
    attrs: {
      "layout": "row top-stretch"
    }
  }, [_c('div', {
    staticClass: "grid-cell",
    attrs: {
      "layout": "row"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.all_real_estate_appraisals_table.filter),
      expression: "all_real_estate_appraisals_table.filter"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.filter_placeholder,
      "self": "size-x1",
      "data-intro": "You can filter the data in a datatable by typing in any of the filter fields",
      "data-step": "9",
      "data-position": "top"
    },
    domProps: {
      "value": (_vm.all_real_estate_appraisals_table.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.all_real_estate_appraisals_table.filter = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "grid-row",
    attrs: {
      "layout": "row top-stretch"
    }
  }, [_c('div', {
    staticClass: "grid-cell"
  }, [_c('paginator', {
    attrs: {
      "source": _vm.all_realestate_appraisals,
      "page-size": 10,
      "filter": _vm.all_real_estate_appraisals_table.filter,
      "data-intro": "Use the paginator to page data for easier viewing",
      "data-step": "10",
      "data-position": "top"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(page) {
        return [_c('datatable', {
          attrs: {
            "id": "data-table-all_real_estate_appraisals",
            "source": page.data,
            "filterable": false,
            "striped": _vm.all_real_estate_appraisals_table.striped,
            "editable": _vm.all_real_estate_appraisals_table.editable,
            "line-numbers": _vm.all_real_estate_appraisals_table.lineNumbers
          },
          scopedSlots: _vm._u([{
            key: "actions-all_real_estate_appraisals",
            fn: function(cell) {
              return [_c('table', {
                staticClass: "actions-table"
              }, [_c('tr', [_c('td', [_c('a', {
                staticStyle: {
                  "cursor": "pointer"
                },
                attrs: {
                  "title": _vm.edit_text
                },
                on: {
                  "click": function($event) {
                    _vm.editAppraisalReport(cell.row)
                  }
                }
              }, [_c('icon', {
                attrs: {
                  "name": "pencil",
                  "scale": "1",
                  "color": "gray"
                }
              })], 1)]), _vm._v(" "), _c('td', [_c('a', {
                staticStyle: {
                  "cursor": "pointer"
                },
                attrs: {
                  "title": _vm.duplicate_text
                },
                on: {
                  "click": function($event) {
                    _vm.duplicateAppraisalReport(cell.row)
                  }
                }
              }, [_c('icon', {
                attrs: {
                  "name": "files-o",
                  "scale": "1",
                  "color": "gray"
                }
              })], 1)]), _vm._v(" "), _c('td', [_c('a', {
                staticStyle: {
                  "cursor": "pointer"
                },
                attrs: {
                  "title": _vm.delete_text
                },
                on: {
                  "click": function($event) {
                    _vm.deleteAppraisalReport(cell.row)
                  }
                }
              }, [_c('icon', {
                attrs: {
                  "name": "trash-o",
                  "scale": "1",
                  "color": "gray"
                }
              })], 1)])])])]
            }
          }])
        }, [_vm._l((_vm.all_real_estate_appraisals_table.columns), function(column) {
          return _c('datatable-column', {
            attrs: {
              "id": column.id,
              "label": column.label,
              "width": column.width,
              "sortable": column.sortable,
              "groupable": column.groupable,
              "formatter": column.formatter
            }
          })
        }), _vm._v(" "), _c('datatable-column', {
          attrs: {
            "id": "actions-all_real_estate_appraisals",
            "label": _vm.actions_text,
            "sortable": false,
            "groupable": false
          }
        })], 2)]
      }
    }])
  })], 1)])]) : _vm._e()])])])], 1)]], 2)
},staticRenderFns: []}

/***/ }),
/* 2176 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home",
    class: _vm.theme,
    attrs: {
      "id": "services-page"
    }
  }, [_c('nav-bar'), _vm._v(" "), _c('swiper', {
    ref: "mySwiper2",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticStyle: {
      "height": "100%",
      "background-image": "url('../assets/img/mir4.jpg')",
      "background-size": "cover",
      "background-repeat": "no-repeat"
    }
  }, [_c('div', {
    staticClass: "slide-center"
  }, [_c('h1', {
    staticClass: "page__title-white"
  }, [_vm._v(_vm._s(_vm.$t('Services')))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "page",
    attrs: {
      "id": "quote-form"
    }
  }, [_c('h1', {
    staticClass: "page__title"
  }, [_vm._v(_vm._s(_vm.$t('Services')))]), _vm._v(" "), _c('hr', {
    staticClass: "page__hr"
  }), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(_vm.$t('Services_text_01')) + ".\n")]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(_vm.$t('Services_text_02')) + ".\n")]), _vm._v(" "), _c('div', {
    staticClass: "page__container main"
  }, [_c('div', {
    staticClass: "services-item"
  }, [_c('div', {
    staticClass: "icon-container"
  }, [_c('icon', {
    attrs: {
      "name": "balance-scale",
      "scale": "2",
      "color": "lightsteelblue"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "icon-container"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t('Official_Appraisals')) + "\n\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "services-item"
  }, [_c('div', {
    staticClass: "icon-container"
  }, [_c('icon', {
    attrs: {
      "name": "globe",
      "scale": "2",
      "color": "lightsteelblue"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "icon-container"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t('Energy_Certificates')) + "\n\n\n\n\n\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "services-item"
  }, [_c('div', {
    staticClass: "icon-container"
  }, [_c('icon', {
    attrs: {
      "name": "home",
      "scale": "2",
      "color": "lightsteelblue"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "icon-container"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t('Occupancy_Cards')) + "\n\n\n\n\n\n\n\n\n\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "services-item"
  }, [_c('div', {
    staticClass: "icon-container"
  }, [_c('icon', {
    attrs: {
      "name": "pencil",
      "scale": "2",
      "color": "lightsteelblue"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "icon-container"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t('Building_surveys')) + "\n\n\n\n\n\n\n\n\n\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "services-item"
  }, [_c('div', {
    staticClass: "icon-container"
  }, [_c('icon', {
    attrs: {
      "name": "gavel",
      "scale": "2",
      "color": "lightsteelblue"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "icon-container"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t('Expert_Opinions')) + "\n\t\t\t\t\t")])])])]), _vm._v(" "), _c('logo-bar'), _vm._v(" "), _c('footer-bar')], 1)
},staticRenderFns: []}

/***/ }),
/* 2177 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "marketstudies-index"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "bdefilesOpen": _vm.bdefilesOpen
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('BDE_files')))]), _vm._v(" "), (_vm.filesyear) ? _c('h1', [_vm._v(_vm._s(_vm.filesyear))]) : _vm._e(), _vm._v(" "), _c('vue-tabs', [_c('v-tab', {
      attrs: {
        "title": _vm.bde_appraisal_files_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v("Tasaciones " + _vm._s(_vm.filesyear))]), _vm._v(" "), _c('h4', [_vm._v("Resumen:")]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc",
      staticStyle: {
        "margin-bottom": "3em"
      }
    }, [_c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Número de tasaciones")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(_vm.numtasaciones))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Suma del valor de tasaciones")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.valortasaciones)) + " €")])])])]), _vm._v(" "), _c('h4', [_vm._v("Fichero de entrega BdE:")]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('button', {
      staticClass: "quote-request__aux__button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onOpenAppraisalFile($event)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.onOpenAppraisalFile($event)
        }
      }
    }, [_c('span', [_c('icon', {
      attrs: {
        "name": "external-link",
        "scale": "0.8",
        "color": "rgb(0, 79, 146)"
      }
    }), _vm._v(" "), _c('small', [_vm._v("Abrir ficha de entrega")])], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v("Separador \";\"")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.separator),
        expression: "separator"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.separator) ? _vm._i(_vm.separator, null) > -1 : (_vm.separator)
      },
      on: {
        "click": _vm.set_separator,
        "__c": function($event) {
          var $$a = _vm.separator,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.separator = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.separator = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.separator = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Fichas individuales:")]), _vm._v(" "), _vm._l((_vm.bde_appraisal_files[_vm.filesyear]), function(value, key) {
      return _c('table', {
        staticClass: "table-striped calc",
        staticStyle: {
          "margin-bottom": "3em"
        }
      }, [_c('caption', {
        staticStyle: {
          "text-align": "left"
        }
      }, [_c('small', [_c('strong', [_vm._v("# " + _vm._s(key) + "  " + _vm._s(value._id) + " ")])])]), _vm._v(" "), _c('tr', [_c('th', {
        staticStyle: {
          "text-align": "right"
        },
        attrs: {
          "width": "200px"
        }
      }, [_c('small', [_c('strong', [_vm._v("Campo")])])]), _vm._v(" "), _c('th', {
        staticStyle: {
          "text-align": "right"
        },
        attrs: {
          "width": "40px"
        }
      }, [_c('small', [_vm._v("Nº")])]), _vm._v(" "), _c('th', {
        staticStyle: {
          "text-align": "right"
        },
        attrs: {
          "width": "70px"
        }
      }, [_c('small', [_vm._v("Formato")])]), _vm._v(" "), _c('th', {
        staticStyle: {
          "text-align": "right"
        },
        attrs: {
          "width": "300px"
        }
      }, [_c('small', [_vm._v("Valor")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Código sociedad")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("1")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(4)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c01_cod_sociedad))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Fecha de referencia")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("2")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(6)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c02_fecha_ref))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Número de tasación")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("3")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(20)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c03_num_tasacion))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Fecha de tasación")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("4")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(8)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c04_fecha_tasacion))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Tipo de tasación")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("5")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(1)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c05_tipo_tasacion))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Finalidad de tasación")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("6")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(1)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c06_finalidad_tasacion))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("s/ Ley Mercado Hipotecario")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("7")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(1)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c07_sigue_leymh))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("s/ ECO/805/2003")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("8")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(1)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c08_sigue_eco))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Advertencias")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(1)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c09_hay_advertencias))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Condicionantes")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("10")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(1)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c10_hay_condicionantes))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Valor tasación")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("11")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(12)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c11_valor_tasacion))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Importe facturado")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("12")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(12)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c12_importe_facturado))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("NIF mandatario")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("13")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(11)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c13_nif_mandatario))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Nombre mandatario")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("14")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(60)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c14_nombre_mandatario))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Código BdE mandatario")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("15")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(4)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c15_codigo_mandatario))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("NIF solicitante")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("16")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(11)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c16_nif_solicitante))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Nombre solicitante")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("17")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(60)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c17_nombre_solicitante))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("NIF tasador")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("18")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(11)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c18_nif_tasador))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Nombre tasador")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("19")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(60)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c19_nombre_tasador))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("NIF supervisor")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("20")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(11)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c20_nif_supervisor))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Nombre supervisor")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("21")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(60)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c21_nombre_supervisor))])])])])
    })], 2)])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.bde_realestate_files_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v("Inmuebles " + _vm._s(_vm.filesyear))]), _vm._v(" "), _c('h4', [_vm._v("Resumen:")]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc",
      staticStyle: {
        "margin-bottom": "3em"
      }
    }, [_c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Número de inmuebles")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(_vm.numinmuebles))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Suma del valor de inmuebles")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.valorinmuebles)) + " €")])])])]), _vm._v(" "), _c('h4', [_vm._v("Fichero de entrega BdE:")]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('button', {
      staticClass: "quote-request__aux__button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onOpenRealestateFile($event)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.onOpenRealestateFile($event)
        }
      }
    }, [_c('span', [_c('icon', {
      attrs: {
        "name": "external-link",
        "scale": "0.8",
        "color": "rgb(0, 79, 146)"
      }
    }), _vm._v(" "), _c('small', [_vm._v("Abrir ficha de entrega")])], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v("Separador \";\"")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.separator),
        expression: "separator"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.separator) ? _vm._i(_vm.separator, null) > -1 : (_vm.separator)
      },
      on: {
        "click": _vm.set_separator,
        "__c": function($event) {
          var $$a = _vm.separator,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.separator = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.separator = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.separator = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Fichas individuales:")]), _vm._v(" "), _vm._l((_vm.bde_realestate_files[_vm.filesyear]), function(value, key) {
      return _c('table', {
        staticClass: "table-striped calc",
        staticStyle: {
          "margin-bottom": "3em"
        }
      }, [_c('caption', {
        staticStyle: {
          "text-align": "left"
        }
      }, [_c('small', [_c('strong', [_vm._v("# " + _vm._s(key) + " ")])])]), _vm._v(" "), _c('tr', [_c('th', {
        staticStyle: {
          "text-align": "right"
        },
        attrs: {
          "width": "200px"
        }
      }, [_c('small', [_c('strong', [_vm._v("Campo")])])]), _vm._v(" "), _c('th', {
        staticStyle: {
          "text-align": "right"
        },
        attrs: {
          "width": "40px"
        }
      }, [_c('small', [_vm._v("Nº")])]), _vm._v(" "), _c('th', {
        staticStyle: {
          "text-align": "right"
        },
        attrs: {
          "width": "70px"
        }
      }, [_c('small', [_vm._v("Formato")])]), _vm._v(" "), _c('th', {
        staticStyle: {
          "text-align": "right"
        },
        attrs: {
          "width": "300px"
        }
      }, [_c('small', [_vm._v("Valor")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Código sociedad")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("1")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(4)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c01_inm_cod_sociedad))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Fecha de referencia")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("2")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(6)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c02_inm_fecha_ref))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Número de tasación")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("3")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(20)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c03_inm_num_tasacion))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Nº elemento en informe")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("4")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(3)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c04_inm_num_elemento))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Tipo de activo")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("5")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(3)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c05_inm_tipo_activo))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Tipo de vivienda")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("6")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(1)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c06_inm_tipo_vivienda))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Uso del inmueble")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("7")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(1)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c07_inm_tipo_uso))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Estado ocupación")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("8")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(1)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c08_inm_estado_ocupacion))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Visita interior")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(1)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c09_inm_visita_interior))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Estado construcción")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("10")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(3)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c10_inm_estado_construccion))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Año construcción")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("11")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(4)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c11_inm_ano_construccion))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Año última rehab.")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("12")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(4)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c12_inm_ano_ultima_rehab))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Método valoración")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("13")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(3)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c13_inm_metodo_valoracion))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Valor tasación")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("14")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(12)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c14_inm_valor_tasacion))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Valor hipótesis edificio terminado")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("15")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(12)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c15_inm_valor_hipotesis_edif_terminado) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Valor reemplazamiento neto")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("16")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(12)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c16_inm_valor_reemplazamiento_neto))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Valor máximo legal")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("17")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(12)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c17_inm_valor_max_legal))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Valor actualización rentas")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("18")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(12)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c18_inm_valor_actualizacion))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Valor comparación")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("19")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(12)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c19_inm_valor_comparacion))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Ajuste valor comparación")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("20")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(3)v9(2)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c20_inm_ajuste_valor_comparacion))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Valor hipotecario")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("21")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(12)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c21_inm_valor_hipotecario))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("País")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("22")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(2)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c22_inm_pais))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Código INE Prov. + Mun.")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("23")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(5)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c23_inm_codigo_ine))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Municipio")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("24")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(50)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c24_inm_nombre_municipio))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Dirección")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("25")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(60)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c25_inm_direccion))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Código Postal")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("26")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(5)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c26_inm_codigo_postal))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Referencia Catastral")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("27")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(20)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c27_inm_ref_catastral))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("IDUFIR")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("28")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(14)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c28_inm_idufir))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Sección Censal")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("29")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(11)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c29_inm_seccion_censal))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Longitud EPSG:4326")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("30")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("-9(3)v9(7)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c30_inm_longitud_geolocalizacion))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Latitud EPSG:4326")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("31")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("-9(3)v9(7)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c31_inm_latitud_geolocalizacion))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Supf. Construida")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("32")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(6)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c32_inm_supf_const))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Supf. Construida con Z. C.")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("33")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(6)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c33_inm_supf_const_con_zc))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Supf. Útil")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("34")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(6)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c34_inm_supf_util))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Supf. Catastral")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("35")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(6)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c35_inm_supf_catastral))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Supf. Adoptada")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("36")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(6)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c36_inm_supf_adoptada))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Supf. Parcela")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("37")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(6)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c37_inm_supf_parcela))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Valor unitario (€/m2)")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("38")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(12)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c38_inm_valor_unitario))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Costes construcción (€/m2)")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("39")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(12)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c39_inm_costes_construccion))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Otros gastos necesarios (€/m2)")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("40")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(12)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c40_inm_otros_gastos_unitarios))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Nº baños")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("41")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(4)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c41_inm_num_banos))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Nº dormitorios")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("42")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(4)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c42_inm_num_dormitorios))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Zonas verdes")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("43")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(1)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c43_inm_zonas_verdes))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Piscina")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("44")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(1)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c44_inm_piscina))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Zonas deportivas")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("45")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(1)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c45_inm_zonas_deportivas))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Calefacción")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("46")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(1)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c46_inm_calefaccion))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Aire acondicionado")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("47")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(1)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c47_inm_aire_acondicionado))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Calidad construcción")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("48")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(1)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c48_inm_calidad_construccion))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Estado conservación")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("49")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(1)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c49_estado_conservacion))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Terraza cubierta (m2)")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("50")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(6)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c50_inm_m2_terraza_cubierta))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Terraza descubierta (m2)")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("51")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(6)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c51_inm_m2_terraza_descubierta))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Ascensor")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("52")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(1)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c52_inm_ascensor))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Nº planta")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("53")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(1)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c53_inm_num_planta))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Tipo planta")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("54")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(2)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c54_inm_tipo_planta))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Nº plazas garaje")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("55")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(4)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c55_inm_plazas_garaje))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Trastero")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("56")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(1)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c56_inm_trastero))])])])])
    })], 2)])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.bde_comparable_files_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v("Comparables " + _vm._s(_vm.filesyear))]), _vm._v(" "), _c('h4', [_vm._v("Resumen:")]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc",
      staticStyle: {
        "margin-bottom": "3em"
      }
    }, [_c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Número de comparables")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(_vm.numcomparables))])])])]), _vm._v(" "), _c('h4', [_vm._v("Fichero de entrega BdE:")]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('button', {
      staticClass: "quote-request__aux__button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onOpenComparableFile($event)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.onOpenComparableFile($event)
        }
      }
    }, [_c('span', [_c('icon', {
      attrs: {
        "name": "external-link",
        "scale": "0.8",
        "color": "rgb(0, 79, 146)"
      }
    }), _vm._v(" "), _c('small', [_vm._v("Abrir ficha de entrega")])], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v("Separador \";\"")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.separator),
        expression: "separator"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.separator) ? _vm._i(_vm.separator, null) > -1 : (_vm.separator)
      },
      on: {
        "click": _vm.set_separator,
        "__c": function($event) {
          var $$a = _vm.separator,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.separator = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.separator = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.separator = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Fichas individuales:")]), _vm._v(" "), _vm._l((_vm.bde_comparable_files[_vm.filesyear]), function(value, key) {
      return _c('table', {
        staticClass: "table-striped calc",
        staticStyle: {
          "margin-bottom": "3em"
        }
      }, [_c('caption', {
        staticStyle: {
          "text-align": "left"
        }
      }, [_c('small', [_c('strong', [_vm._v("# " + _vm._s(key) + " ")])])]), _vm._v(" "), _c('tr', [_c('th', {
        staticStyle: {
          "text-align": "right"
        },
        attrs: {
          "width": "200px"
        }
      }, [_c('small', [_c('strong', [_vm._v("Campo")])])]), _vm._v(" "), _c('th', {
        staticStyle: {
          "text-align": "right"
        },
        attrs: {
          "width": "40px"
        }
      }, [_c('small', [_vm._v("Nº")])]), _vm._v(" "), _c('th', {
        staticStyle: {
          "text-align": "right"
        },
        attrs: {
          "width": "70px"
        }
      }, [_c('small', [_vm._v("Formato")])]), _vm._v(" "), _c('th', {
        staticStyle: {
          "text-align": "right"
        },
        attrs: {
          "width": "300px"
        }
      }, [_c('small', [_vm._v("Valor")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Código sociedad")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("1")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(4)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c01_comp_cod_sociedad))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Fecha de referencia")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("2")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(6)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c02_comp_fecha_ref))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Código comparable")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("3")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(20)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c03_comp_identificador))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Fecha captura")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("4")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(8)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c04_comp_fecha_captura))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Tipo datos")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("5")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(3)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c05_comp_tipo_datos))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Visita interior")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("6")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(1)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c06_comp_visita_interior))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Contraste info Catastro")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("7")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(1)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c07_comp_contraste_catastro))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Datos contacto")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("8")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(12)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c08_comp_datos_contacto))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("País")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(2)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c09_comp_pais))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Código INE Prov. + Mun.")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("10")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(5)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c10_comp_codigo_ine))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Municipio")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("11")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(50)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c11_comp_municipio))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Dirección")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("12")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(60)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c12_comp_direccion))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Código postal")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("13")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(5)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c13_comp_codigo_postal))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Referencia Catastral")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("14")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(20)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c14_comp_ref_catastral))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("IDUFIR")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("15")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(14)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c15_comp_idufir))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Sección Censal")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("16")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(11)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c16_comp_seccion_censal))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Longitud EPSG:4326")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("17")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("-9(3)v9(7)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c17_comp_longitud))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Latitud EPSG:4326")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("18")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("-9(3)v9(7)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c18_comp_latitud))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Precio de oferta")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("19")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(12)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c19_comp_precio_oferta))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Precio de venta estimado")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("20")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(12)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c20_comp_precio_venta))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Supf. Catastral")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("21")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(6)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c21_comp_supf_catastral))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Supf. construida estimada")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("22")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(6)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c22_comp_supf_estimada))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Supf. parcela")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("23")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(6)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c23_comp_supf_parcela))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Precio unitario")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("24")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(12)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c24_comp_precio_unitario))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Año construcción")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("25")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(4)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c25_comp_ano_construccion))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Año última rehab.")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("26")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(4)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c26_comp_ano_ultima_rehab))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Tipo vivienda")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("27")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(1)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c27_comp_tipo_vivienda))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Nº baños")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("28")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(4)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c28_comp_num_banos))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Nº dormitorios")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("29")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(4)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c29_comp_num_dormitorios))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Zonas verdes")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("30")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(1)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c30_comp_zonas_verdes))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Piscina")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("31")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(1)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c31_comp_piscina))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Zonas deportivas")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("32")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(1)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c32_comp_zonas_deportivas))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Calefacción")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("33")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(1)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c33_comp_calefaccion))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Aire acondicionado")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("34")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(1)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c34_comp_aire_acondicionado))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Calidad construcción")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("35")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(1)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c35_comp_calidad_construccion))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Estado conservación")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("36")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(1)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c36_comp_estado_conservacion))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Terraza cubierta m2")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("37")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(6)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c37_comp_m2_terraza_cubierta))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Terraza descubierta m2")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("38")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(6)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c38_comp_m2_terraza_descubierta))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Ascensor")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("39")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(1)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c39_comp_ascensor))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Nº planta")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("40")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("-9(3)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c40_comp_num_planta))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Tipo de planta")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("41")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(2)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c41_comp_tipo_planta))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Nº plazas garaje")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("42")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(4)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c42_comp_num_plazas_garaje))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Trastero")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("43")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(1)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c43_comp_trastero))])])])])
    })], 2)])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.bde_relationships_files_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v("Relaciones " + _vm._s(_vm.filesyear))]), _vm._v(" "), _c('h4', [_vm._v("Resumen:")]), _vm._v(" "), _c('table', {
      staticClass: "table-striped calc",
      staticStyle: {
        "margin-bottom": "3em"
      }
    }, [_c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Número de filas")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(" " + _vm._s(_vm.numrelaciones))])])])]), _vm._v(" "), _c('h4', [_vm._v("Fichero de entrega BdE:")]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('button', {
      staticClass: "quote-request__aux__button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onOpenRelationshipsFile($event)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.onOpenRelationshipsFile($event)
        }
      }
    }, [_c('span', [_c('icon', {
      attrs: {
        "name": "external-link",
        "scale": "0.8",
        "color": "rgb(0, 79, 146)"
      }
    }), _vm._v(" "), _c('small', [_vm._v("Abrir ficha de entrega")])], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v("Separador \";\"")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.separator),
        expression: "separator"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.separator) ? _vm._i(_vm.separator, null) > -1 : (_vm.separator)
      },
      on: {
        "click": _vm.set_separator,
        "__c": function($event) {
          var $$a = _vm.separator,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.separator = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.separator = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.separator = $$c
          }
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Fichas individuales:")]), _vm._v(" "), _vm._l((_vm.bde_relationships_files[_vm.filesyear]), function(value, key) {
      return _c('table', {
        staticClass: "table-striped calc",
        staticStyle: {
          "margin-bottom": "3em"
        }
      }, [_c('caption', {
        staticStyle: {
          "text-align": "left"
        }
      }, [_c('small', [_c('strong', [_vm._v("# " + _vm._s(key) + " ")])])]), _vm._v(" "), _c('tr', [_c('th', {
        staticStyle: {
          "text-align": "right"
        },
        attrs: {
          "width": "200px"
        }
      }, [_c('small', [_c('strong', [_vm._v("Campo")])])]), _vm._v(" "), _c('th', {
        staticStyle: {
          "text-align": "right"
        },
        attrs: {
          "width": "40px"
        }
      }, [_c('small', [_vm._v("Nº")])]), _vm._v(" "), _c('th', {
        staticStyle: {
          "text-align": "right"
        },
        attrs: {
          "width": "70px"
        }
      }, [_c('small', [_vm._v("Formato")])]), _vm._v(" "), _c('th', {
        staticStyle: {
          "text-align": "right"
        },
        attrs: {
          "width": "300px"
        }
      }, [_c('small', [_vm._v("Valor")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Código sociedad")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("1")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(4)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c01_rel_cod_sociedad))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Fecha de referencia")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("2")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(6)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c02_rel_fecha_ref))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Número de tasación")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("3")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(20)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c03_rel_num_tasacion))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Nº elemento en informe")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("4")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("9(3)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c04_rel_num_elemento))])])]), _vm._v(" "), _c('tr', [_c('td', [_c('small', [_c('strong', [_vm._v("Código identificador del comparable")])])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("5")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v("X(20)")])]), _vm._v(" "), _c('td', [_c('small', [_vm._v(_vm._s(value.c05_rel_codigoidcomparable))])])])])
    })], 2)])])])])], 1), _vm._v(" "), _c('bar')], 1)], 1)]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 2178 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "appraisals-index"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "fileOpen": _vm.fileOpen,
        "fileNumber": _vm.appraisalfile.number
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [(!_vm.appraisalfile.number) ? _c('span', [_vm._v(_vm._s(_vm.$t('Edit')) + " " + _vm._s(_vm.$t('appraisal_file')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('File')) + " " + _vm._s(_vm.appraisalfile.number) + "\n\t\t\t\t\t")]), _vm._v(" "), (_vm.appraisalfile.dirty) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.appraisalfile.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "datedata"
    }, [_c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Created')) + ": " + _vm._s(_vm.millis_to_time(_vm.appraisalfile.date_created)))]), _vm._v(" "), _c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Last_modified')) + ": " + _vm._s(_vm.millis_to_time(_vm.appraisalfile.date_modified)))])]), _vm._v(" "), _c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('File_number')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('File_number')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalfile.number),
        expression: "appraisalfile.number"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisalfile.number)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisalfile.number = $event.target.value
        }, _vm.set_appraisalfile_number],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Description')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Appraisal_file_description')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalfile.description),
        expression: "appraisalfile.description"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisalfile.description)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisalfile.description = $event.target.value
        }, _vm.set_appraisalfile_description]
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Appraisal_quotes')) + " " + _vm._s(_vm.$t('contained_in_this_file')))]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.checkCreateNewAppraisalQuote($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus-circle",
        "text": _vm.new_appraisalquote_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), (_vm.object_length(_vm.appraisalfile_appraisalquotes) > 0) ? _c('div', [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('paginator', {
      attrs: {
        "source": _vm.object_to_array(_vm.appraisalfile_appraisalquotes),
        "page-size": 10,
        "filter": _vm.appraisalquote_table.filter,
        "data-intro": "Use the paginator to page data for easier viewing",
        "data-step": "10",
        "data-position": "top"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(page) {
          return [_c('datatable', {
            attrs: {
              "id": "data-table-appraisalquote",
              "source": page.data,
              "filterable": false,
              "striped": _vm.appraisalquote_table.striped,
              "editable": _vm.appraisalquote_table.editable,
              "line-numbers": _vm.appraisalquote_table.lineNumbers
            },
            scopedSlots: _vm._u([{
              key: "status",
              fn: function(cell) {
                return [(cell.row['status']) ? _c('div', [(_vm.currentLocale === 'ca') ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(cell.row['status'].name_ca))]) : (_vm.currentLocale === 'en') ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(cell.row['status'].name_en))]) : _c('span', [_vm._v(_vm._s(cell.row['status'].name_es))])]) : _vm._e()]
              }
            }, {
              key: "send_to_bde",
              fn: function(cell) {
                return [(cell.row['send_to_bde']) ? _c('div', [(_vm.currentLocale === 'ca') ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tSí\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'es') ? _c('span', [_vm._v("Sí\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('span', [_vm._v("Yes")]) : _vm._e()]) : _c('div', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tNo\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])]
              }
            }, {
              key: "actions-appraisalquote",
              fn: function(cell) {
                return [_c('table', {
                  staticClass: "actions-table"
                }, [_c('tr', [_c('td', [_c('a', {
                  staticStyle: {
                    "cursor": "pointer"
                  },
                  attrs: {
                    "title": _vm.edit_text
                  },
                  on: {
                    "click": function($event) {
                      _vm.checkEditAppraisalQuote(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "pencil",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1)]), _vm._v(" "), _c('td', [_c('a', {
                  staticStyle: {
                    "cursor": "pointer"
                  },
                  attrs: {
                    "title": _vm.duplicate_text
                  },
                  on: {
                    "click": function($event) {
                      _vm.duplicateAppraisalQuote(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "files-o",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1)]), _vm._v(" "), _c('td', [_c('a', {
                  staticStyle: {
                    "cursor": "pointer"
                  },
                  attrs: {
                    "title": _vm.delete_text
                  },
                  on: {
                    "click": function($event) {
                      _vm.deleteAppraisalQuote(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "trash-o",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1)])])])]
              }
            }])
          }, [_vm._l((_vm.appraisalquote_table.columns), function(column) {
            return _c('datatable-column', {
              attrs: {
                "id": column.id,
                "label": column.label,
                "width": column.width,
                "sortable": column.sortable,
                "groupable": column.groupable,
                "formatter": column.formatter
              }
            })
          }), _vm._v(" "), _c('datatable-column', {
            attrs: {
              "id": "actions-appraisalquote",
              "label": _vm.actions_text,
              "sortable": false,
              "groupable": false
            }
          })], 2)]
        }
      }])
    })], 1)])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Appraisal_invoices')) + " " + _vm._s(_vm.$t('contained_in_this_file_f')))]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.checkCreateNewAppraisalInvoice($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus-circle",
        "text": _vm.new_appraisalinvoice_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), (_vm.object_length(_vm.appraisalfile_appraisalinvoices) > 0) ? _c('div', [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('paginator', {
      attrs: {
        "source": _vm.object_to_array(_vm.appraisalfile_appraisalinvoices),
        "page-size": 10,
        "filter": _vm.appraisalinvoice_table.filter,
        "data-intro": "Use the paginator to page data for easier viewing",
        "data-step": "10",
        "data-position": "top"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(page) {
          return [_c('datatable', {
            attrs: {
              "id": "data-table-appraisalinvoice",
              "source": page.data,
              "filterable": false,
              "striped": _vm.appraisalinvoice_table.striped,
              "editable": _vm.appraisalinvoice_table.editable,
              "line-numbers": _vm.appraisalinvoice_table.lineNumbers
            },
            scopedSlots: _vm._u([{
              key: "status",
              fn: function(cell) {
                return [(cell.row['status']) ? _c('div', [(_vm.currentLocale === 'ca') ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(cell.row['status'].name_ca))]) : (_vm.currentLocale === 'en') ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(cell.row['status'].name_en))]) : _c('span', [_vm._v(_vm._s(cell.row['status'].name_es))])]) : _vm._e()]
              }
            }, {
              key: "send_to_bde",
              fn: function(cell) {
                return [(cell.row['send_to_bde']) ? _c('div', [(_vm.currentLocale === 'ca') ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tSí\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'es') ? _c('span', [_vm._v("Sí\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('span', [_vm._v("Yes")]) : _vm._e()]) : _c('div', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tNo\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])]
              }
            }, {
              key: "actions-appraisalinvoice",
              fn: function(cell) {
                return [_c('table', {
                  staticClass: "actions-table"
                }, [_c('tr', [_c('td', [_c('a', {
                  staticStyle: {
                    "cursor": "pointer"
                  },
                  attrs: {
                    "title": _vm.edit_text
                  },
                  on: {
                    "click": function($event) {
                      _vm.checkEditAppraisalInvoice(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "pencil",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1)]), _vm._v(" "), _c('td', [_c('a', {
                  staticStyle: {
                    "cursor": "pointer"
                  },
                  attrs: {
                    "title": _vm.duplicate_text
                  },
                  on: {
                    "click": function($event) {
                      _vm.duplicateAppraisalInvoice(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "files-o",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1)]), _vm._v(" "), _c('td', [_c('a', {
                  staticStyle: {
                    "cursor": "pointer"
                  },
                  attrs: {
                    "title": _vm.delete_text
                  },
                  on: {
                    "click": function($event) {
                      _vm.deleteAppraisalInvoice(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "trash-o",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1)])])])]
              }
            }])
          }, [_vm._l((_vm.appraisalinvoice_table.columns), function(column) {
            return _c('datatable-column', {
              attrs: {
                "id": column.id,
                "label": column.label,
                "width": column.width,
                "sortable": column.sortable,
                "groupable": column.groupable,
                "formatter": column.formatter
              }
            })
          }), _vm._v(" "), _c('datatable-column', {
            attrs: {
              "id": "actions-appraisalinvoice",
              "label": _vm.actions_text,
              "sortable": false,
              "groupable": false
            }
          })], 2)]
        }
      }])
    })], 1)])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Reports')) + " " + _vm._s(_vm.$t('contained_in_this_file')))]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.checkCreateNewAppraisalReport($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus-circle",
        "text": _vm.new_appraisalreport_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), (_vm.object_length(_vm.appraisalfile_appraisalreports) > 0) ? _c('div', [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('paginator', {
      attrs: {
        "source": _vm.object_to_array(_vm.appraisalfile_appraisalreports),
        "page-size": 10,
        "filter": _vm.appraisalreport_table.filter,
        "data-intro": "Use the paginator to page data for easier viewing",
        "data-step": "10",
        "data-position": "top"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(page) {
          return [_c('datatable', {
            attrs: {
              "id": "data-table-appraisalreport",
              "source": page.data,
              "filterable": false,
              "striped": _vm.appraisalreport_table.striped,
              "editable": _vm.appraisalreport_table.editable,
              "line-numbers": _vm.appraisalreport_table.lineNumbers
            },
            scopedSlots: _vm._u([{
              key: "status",
              fn: function(cell) {
                return [(cell.row['status']) ? _c('div', [(_vm.currentLocale === 'ca') ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(cell.row['status'].name_ca))]) : (_vm.currentLocale === 'en') ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(cell.row['status'].name_en))]) : _c('span', [_vm._v(_vm._s(cell.row['status'].name_es))])]) : _vm._e()]
              }
            }, {
              key: "send_to_bde",
              fn: function(cell) {
                return [(cell.row['send_to_bde']) ? _c('div', [(_vm.currentLocale === 'ca') ? _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tSí\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'es') ? _c('span', [_vm._v("Sí\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('span', [_vm._v("Yes")]) : _vm._e()]) : _c('div', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tNo\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])]
              }
            }, {
              key: "actions-appraisalreport",
              fn: function(cell) {
                return [_c('table', {
                  staticClass: "actions-table"
                }, [_c('tr', [_c('td', [_c('a', {
                  staticStyle: {
                    "cursor": "pointer"
                  },
                  attrs: {
                    "title": _vm.edit_text
                  },
                  on: {
                    "click": function($event) {
                      _vm.checkEditAppraisalReport(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "pencil",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1)]), _vm._v(" "), _c('td', [_c('a', {
                  staticStyle: {
                    "cursor": "pointer"
                  },
                  attrs: {
                    "title": _vm.duplicate_text
                  },
                  on: {
                    "click": function($event) {
                      _vm.duplicateAppraisalReport(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "files-o",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1)]), _vm._v(" "), _c('td', [_c('a', {
                  staticStyle: {
                    "cursor": "pointer"
                  },
                  attrs: {
                    "title": _vm.delete_text
                  },
                  on: {
                    "click": function($event) {
                      _vm.deleteAppraisalReport(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "trash-o",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1)])])])]
              }
            }])
          }, [_vm._l((_vm.appraisalreport_table.columns), function(column) {
            return _c('datatable-column', {
              attrs: {
                "id": column.id,
                "label": column.label,
                "width": column.width,
                "sortable": column.sortable,
                "groupable": column.groupable,
                "formatter": column.formatter
              }
            })
          }), _vm._v(" "), _c('datatable-column', {
            attrs: {
              "id": "actions-appraisalreport",
              "label": _vm.actions_text,
              "sortable": false,
              "groupable": false
            }
          })], 2)]
        }
      }])
    })], 1)])]) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUp($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "level-up",
        "text": _vm.goup_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentAppraisalFile({
            go_up: false
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentAppraisalFile({
            go_up: true
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_and_go_up_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), (_vm.appraisalfile.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e()], 1)])], 1)], 1)]
  ], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('hr')])
}]}

/***/ }),
/* 2179 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notfound",
    attrs: {
      "id": "notfound"
    }
  }, [_c('h1', {
    staticClass: "notfound__headline"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('Looking_for_something_q')) + "\n  ")]), _vm._v(" "), _c('h2', {
    staticClass: "notfound__subline"
  }, [_vm._v("\n    " + _vm._s(_vm.$t('We_are_sorry_c_the_page_you_requested_cannot_be_found')) + ".\n  ")]), _vm._v(" "), _c('router-link', {
    staticClass: "button primary large",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('Back_home')) + "\n  ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 2180 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search",
    attrs: {
      "id": "search"
    }
  }, [_c('div', {
    staticClass: "search__container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.query),
      expression: "query",
      modifiers: {
        "trim": true
      }
    }, {
      name: "focus",
      rawName: "v-focus",
      value: (true),
      expression: "true"
    }],
    ref: "input",
    staticClass: "search__input",
    attrs: {
      "id": "search-input",
      "type": "text",
      "placeholder": "Search or create",
      "spellcheck": "false",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "focus": function($event) {
        _vm.isSearchFocused = true
      },
      "blur": [function($event) {
        _vm.isSearchFocused = false
      }, function($event) {
        _vm.$forceUpdate()
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value.trim()
      }, _vm.updateQuery],
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onSearch($event)
      }
    }
  }), _vm._v(" "), _c('search-info', {
    attrs: {
      "resultsCount": _vm.filteredNotes.length,
      "queryLength": _vm.query.length,
      "selected": _vm.activeNote != null,
      "searching": _vm.isSearchFocused,
      "renaming": _vm.renamingId != null,
      "editing": _vm.editingId != null
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.preview),
      expression: "!preview"
    }],
    staticClass: "search__add",
    on: {
      "click": _vm.onCreate
    }
  })], 1), _vm._v(" "), _c('ul', {
    staticClass: "search__results"
  }, _vm._l((_vm.filteredNotes), function(note) {
    return _c('search-result', {
      key: note.id,
      staticClass: "list-complete-item",
      attrs: {
        "note": note,
        "isActive": _vm.activeNote && note.id == _vm.activeNote.id,
        "renaming": _vm.renamingId == note.id
      },
      on: {
        "onResultSelect": _vm.onSelect,
        "onRenameBlur": _vm.onRenameBlur
      }
    })
  }))])
},staticRenderFns: []}

/***/ }),
/* 2181 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "appraisers-index"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "filesOpen": _vm.filesOpen,
        "fileOpen": _vm.fileOpen,
        "reportOpen": _vm.reportOpen
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('Appraisers_Index')))]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCreateNewAppraiser($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus-circle",
        "text": _vm.new_appraiser_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell",
      attrs: {
        "layout": "row"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.customers.filter),
        expression: "customers.filter"
      }],
      attrs: {
        "type": "text",
        "placeholder": _vm.filter_placeholder,
        "self": "size-x1",
        "data-intro": "You can filter the data in a datatable by typing in any of the filter fields",
        "data-step": "9",
        "data-position": "top"
      },
      domProps: {
        "value": (_vm.customers.filter)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.customers.filter = $event.target.value
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('paginator', {
      attrs: {
        "source": _vm.appraisers_to_array(_vm.appraisers),
        "page-size": 10,
        "filter": _vm.customers.filter,
        "data-intro": "Use the paginator to page data for easier viewing",
        "data-step": "10",
        "data-position": "top"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(page) {
          return [_c('datatable', {
            attrs: {
              "id": "data-table-main",
              "source": page.data,
              "filterable": false,
              "striped": _vm.customers.striped,
              "editable": _vm.customers.editable,
              "line-numbers": _vm.customers.lineNumbers
            },
            scopedSlots: _vm._u([{
              key: "actions",
              fn: function(cell) {
                return [_c('a', {
                  staticStyle: {
                    "margin-right": "2rem",
                    "cursor": "pointer"
                  },
                  on: {
                    "click": function($event) {
                      _vm.editAppraiser(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "pencil",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1), _vm._v(" "), _c('a', {
                  staticStyle: {
                    "cursor": "pointer"
                  },
                  on: {
                    "click": function($event) {
                      _vm.deleteAppraiser(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "trash-o",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1)]
              }
            }])
          }, [_vm._l((_vm.customers.columns), function(column) {
            return _c('datatable-column', {
              attrs: {
                "id": column.id,
                "label": column.label,
                "width": column.width,
                "sortable": column.sortable,
                "groupable": column.groupable,
                "formatter": column.formatter
              }
            })
          }), _vm._v(" "), _c('datatable-column', {
            attrs: {
              "id": "actions",
              "label": "Actions",
              "sortable": false,
              "groupable": false
            }
          })], 2)]
        }
      }])
    })], 1)])], 1)], 1)]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 2182 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibcontainer"
  }, [_c('button', {
    staticClass: "ib medium",
    style: ({
      borderColor: _vm.border_color,
      backgroundColor: _vm.background_color,
      minWidth: _vm.min_width,
      maxWidth: _vm.max_width
    }),
    attrs: {
      "disabled": _vm.disabled == false
    }
  }, [_c('icon', {
    staticClass: "ibi",
    attrs: {
      "name": _vm.icon,
      "scale": "1",
      "color": _vm.icon_color
    }
  }), _vm._v("  "), _c('span', {
    style: ({
      color: _vm.text_color
    })
  }, [_vm._v(_vm._s(_vm.text))])], 1)])
},staticRenderFns: []}

/***/ }),
/* 2183 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-street-view-pano-container"
  }, [_c('div', {
    ref: "vue-street-view-pano",
    staticClass: "vue-street-view-pano"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 2184 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search__info"
  }, [(_vm.resultsCount == 1) ? _c('span', [_vm._v("\n    1 note\n  ")]) : _c('span', [_vm._v("\n    " + _vm._s(_vm.resultsCount) + " notes\n  ")]), _vm._v(" "), (_vm.editing || !_vm.searching) ? _c('span', [_c('span', {
    staticClass: "command"
  }, [_vm._v("esc")]), _vm._v(" to focus search\n  ")]) : (_vm.renaming) ? _c('span', [_c('span', {
    staticClass: "command"
  }, [_vm._v("enter")]), _vm._v(" to save title\n  ")]) : (_vm.queryLength > 0) ? _c('span', [_c('span', {
    staticClass: "command"
  }, [_vm._v("ctrl")]), _vm._v(" + "), _c('span', {
    staticClass: "command"
  }, [_vm._v("enter")]), _vm._v(" to create note\n  ")]) : (_vm.selected) ? _c('span', [_c('span', {
    staticClass: "command"
  }, [_vm._v("enter")]), _vm._v(" to edit note\n  ")]) : _c('span', [_vm._v("\n    Type to search\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 2185 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home",
    class: _vm.theme,
    attrs: {
      "id": "services-page"
    }
  }, [_c('nav-bar'), _vm._v(" "), _c('div', {
    staticClass: "page",
    attrs: {
      "id": "quote-form"
    }
  }, [_c('h1', {
    staticClass: "page__title"
  }, [_vm._v(_vm._s(_vm.$t('Contact')))]), _vm._v(" "), _c('hr', {
    staticClass: "page__hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "page__container main"
  }, [_c('div', {
    staticClass: "page__content left"
  }, [_c('span', [_c('icon', {
    attrs: {
      "name": "home",
      "scale": "1"
    }
  }), _vm._v(" Còrsega, 168, 1º 1ª, 08036 - Barcelona")], 1), _vm._v(" "), _c('span', [_c('icon', {
    attrs: {
      "name": "phone",
      "scale": "1"
    }
  }), _vm._v(" (+34) 93 410 05 32")], 1), _vm._v(" "), _c('span', [_c('icon', {
    attrs: {
      "name": "envelope",
      "scale": "1"
    }
  }), _vm._v(" info@barnatasa.com")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page__content right"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Office_hours')) + ":")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t('Mon.')) + " " + _vm._s(_vm.$t('to')) + " " + _vm._s(_vm.$t('Thu.')) + ": "), _c('strong', [_vm._v(_vm._s(_vm.$t('from')) + " 09:00h " + _vm._s(_vm.$t('to')) + " 13:00h")]), _vm._v(" " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('from')) + " "), _c('strong', [_vm._v("16:00h " + _vm._s(_vm.$t('to')) + " 19:00h")])]), _vm._v(" "), _c('li', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t('Fri.')) + ": "), _c('strong', [_vm._v(_vm._s(_vm.$t('from')) + " 09:00h " + _vm._s(_vm.$t('to')) + " 14:00h")])]), _vm._v(" "), _c('li', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t('Sat.')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('Sun.')) + ": "), _c('strong', [_vm._v(_vm._s(_vm.$t('closed')))])])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20vh"
    }
  }), _vm._v(" "), _c('logo-bar'), _vm._v(" "), _c('footer-bar')], 1)
},staticRenderFns: []}

/***/ }),
/* 2186 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "appraisalfiles-index"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "filesOpen": _vm.filesOpen
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('Appraisal_files_index')))]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCreateNewAppraisalFile($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus-circle",
        "text": _vm.new_appraisalfile_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell",
      attrs: {
        "layout": "row"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalfile_table.filter),
        expression: "appraisalfile_table.filter"
      }],
      attrs: {
        "type": "text",
        "placeholder": _vm.filter_placeholder,
        "self": "size-x1",
        "data-intro": "You can filter the data in a datatable by typing in any of the filter fields",
        "data-step": "9",
        "data-position": "top"
      },
      domProps: {
        "value": (_vm.appraisalfile_table.filter)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisalfile_table.filter = $event.target.value
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('paginator', {
      attrs: {
        "source": _vm._.orderBy(_vm.appraisalfiles_to_array(_vm.appraisalfiles), ['date_modified'], ['desc']),
        "page-size": 50,
        "filter": _vm.appraisalfile_table.filter,
        "data-intro": "Use the paginator to page data for easier viewing",
        "data-step": "50",
        "data-position": "top"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(page) {
          return [_c('datatable', {
            attrs: {
              "id": "data-table-main",
              "source": page.data,
              "filterable": false,
              "striped": _vm.appraisalfile_table.striped,
              "editable": _vm.appraisalfile_table.editable,
              "line-numbers": _vm.appraisalfile_table.lineNumbers
            },
            scopedSlots: _vm._u([{
              key: "number",
              fn: function(cell) {
                return [_c('span', {
                  staticClass: "navspan",
                  on: {
                    "click": function($event) {
                      $event.preventDefault();
                      _vm.goToFile(cell.row['id'])
                    }
                  }
                }, [_vm._v(_vm._s(cell.row['number']))])]
              }
            }, {
              key: "actions",
              fn: function(cell) {
                return [_c('a', {
                  staticStyle: {
                    "margin-right": "2rem",
                    "cursor": "pointer"
                  },
                  on: {
                    "click": function($event) {
                      _vm.editAppraisalFile(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "pencil",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1), _vm._v(" "), _c('a', {
                  staticStyle: {
                    "cursor": "pointer"
                  },
                  on: {
                    "click": function($event) {
                      _vm.deleteAppraisalFile(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "trash-o",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1)]
              }
            }])
          }, [_vm._l((_vm.appraisalfile_table.columns), function(column) {
            return _c('datatable-column', {
              attrs: {
                "id": column.id,
                "label": column.label,
                "width": column.width,
                "sortable": column.sortable,
                "groupable": column.groupable,
                "formatter": column.formatter
              }
            })
          }), _vm._v(" "), _c('datatable-column', {
            attrs: {
              "id": "actions",
              "label": "Actions",
              "sortable": false,
              "groupable": false
            }
          })], 2)]
        }
      }])
    })], 1)])], 1)], 1)]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 2187 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "otherannex-editor"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "filesOpen": _vm.filesOpen,
        "fileOpen": _vm.fileOpen,
        "reportOpen": _vm.reportOpen
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [_c('span', [_vm._v(_vm._s(_vm.$t('Annex')) + " \"" + _vm._s(_vm.otherannex.filename) + "\"")]), (_vm.otherannex.dirty) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.otherannex.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "datedata"
    }, [_c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Created')) + ": " + _vm._s(_vm.millis_to_time(_vm.otherannex.date_created)))]), _vm._v(" "), _c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Last_modified')) + ": " + _vm._s(_vm.millis_to_time(_vm.otherannex.date_modified)))])]), _vm._v(" "), _c('vue-tabs', [_c('v-tab', {
      attrs: {
        "title": _vm.data_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('div', {
      staticClass: "field-container"
    }, [(_vm.otherannex.url) ? _c('div', [_c('img', {
      attrs: {
        "src": _vm.otherannex.url,
        "width": "600px",
        "height": "auto"
      }
    })]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('File_name')) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('File_name')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.otherannex.filename))])])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Image_footer')) + " ")]), _vm._v(" "), (_vm.otherannex.name_ca || _vm.currentLocale === 'ca') ? _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Image_footer')) + " " + _vm._s(_vm.$t('in')) + " " + _vm._s(_vm.$t('Catalan')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.otherannex.name_ca),
        expression: "otherannex.name_ca"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.otherannex.name_ca)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.otherannex.name_ca = $event.target.value
        }, _vm.set_otherannex_name_ca]
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.otherannex.name_en || _vm.currentLocale === 'en') ? _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Image_footer')) + " " + _vm._s(_vm.$t('in')) + " " + _vm._s(_vm.$t('English')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.otherannex.name_en),
        expression: "otherannex.name_en"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.otherannex.name_en)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.otherannex.name_en = $event.target.value
        }, _vm.set_otherannex_name_en]
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.otherannex.name_es || _vm.currentLocale === 'es') ? _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Image_footer')) + " " + _vm._s(_vm.$t('in')) + " " + _vm._s(_vm.$t('Spanish')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.otherannex.name_es),
        expression: "otherannex.name_es"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.otherannex.name_es)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.otherannex.name_es = $event.target.value
        }, _vm.set_otherannex_name_es]
      }
    })])]) : _vm._e()])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.metadata_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('form', {
      staticClass: "bt-form"
    })])])], 1), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUp($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "chevron-left",
        "text": _vm.goup_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentOtherAnnex({
            go_up: false
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentOtherAnnex({
            go_up: true
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_and_go_up_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), (_vm.otherannex.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e()], 1)], 1)]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 2188 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "public",
    attrs: {
      "id": "public"
    }
  }, [(_vm.loading) ? _c('spinner') : _vm._e(), _vm._v(" "), (_vm.activeNote) ? [_c('header', {
    staticClass: "public__header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.activeNote.name))]), _vm._v(" "), _c('span', [_vm._v("Updated " + _vm._s(_vm._f("prettyDate")(_vm.activeNote.date_modified)))])]), _vm._v(" "), _c('div', {
    staticClass: "public__body",
    domProps: {
      "innerHTML": _vm._s(_vm.body)
    }
  }), _vm._v(" "), _c('footer', {
    staticClass: "public__footer"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("notational.co")])], 1)] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 2189 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nv",
    class: _vm.theme,
    attrs: {
      "id": "nv"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.loading) ? _c('spinner') : [_c('search'), _vm._v(" "), _c('editor'), _vm._v(" "), _c('foot')]], 2)])
},staticRenderFns: []}

/***/ }),
/* 2190 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "becproperty-editor"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "filesOpen": _vm.filesOpen,
        "fileOpen": _vm.fileOpen,
        "reportOpen": _vm.reportOpen
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [(_vm.currentLocale === 'ca') ? _c('span', [_vm._v(_vm._s(_vm.becproperty.name_ca))]) : (_vm.currentLocale === 'en') ? _c('span', [_vm._v(_vm._s(_vm.becproperty.name_en))]) : _c('span', [_vm._v(_vm._s(_vm.becproperty.name_es))]), (_vm.becproperty.dirty) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.becproperty.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "datedata"
    }, [_c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Created')) + ": " + _vm._s(_vm.millis_to_time(_vm.becproperty.date_created)))]), _vm._v(" "), _c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Last_modified')) + ": " + _vm._s(_vm.millis_to_time(_vm.becproperty.date_modified)))])]), _vm._v(" "), _c('vue-tabs', [_c('v-tab', {
      attrs: {
        "title": _vm.data_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Property_type')) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Name_ca')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becproperty.name_ca),
        expression: "becproperty.name_ca"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becproperty.name_ca)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becproperty.name_ca = $event.target.value
        }, _vm.set_becproperty_name_ca]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Name_en')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becproperty.name_en),
        expression: "becproperty.name_en"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becproperty.name_en)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becproperty.name_en = $event.target.value
        }, _vm.set_becproperty_name_en]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Name_es')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becproperty.name_es),
        expression: "becproperty.name_es"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.becproperty.name_es)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.becproperty.name_es = $event.target.value
        }, _vm.set_becproperty_name_es]
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "form-section"
    }, [_c('h3', [_vm._v("Números B.E.C.")]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCreateNewBecPrice($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus-circle",
        "text": _vm.new_becprice_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), (_vm._.size(_vm.becproperty_becprices) > 0) ? _c('div', [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell",
      attrs: {
        "layout": "row"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.becprices_table.filter),
        expression: "becprices_table.filter"
      }],
      attrs: {
        "type": "text",
        "placeholder": _vm.filter_placeholder,
        "self": "size-x1",
        "data-intro": "You can filter the data in a datatable by typing in any of the filter fields",
        "data-step": "9",
        "data-position": "top"
      },
      domProps: {
        "value": (_vm.becprices_table.filter)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.becprices_table.filter = $event.target.value
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('paginator', {
      attrs: {
        "source": this.object_to_array(_vm.becproperty_becprices),
        "page-size": 20,
        "filter": _vm.becprices_table.filter,
        "data-intro": "Use the paginator to page data for easier viewing",
        "data-step": "10",
        "data-position": "top"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(page) {
          return [_c('datatable', {
            attrs: {
              "id": "data-table-becprices",
              "source": page.data,
              "filterable": false,
              "striped": _vm.becprices_table.striped,
              "editable": _vm.becprices_table.editable,
              "line-numbers": _vm.becprices_table.lineNumbers
            },
            scopedSlots: _vm._u([{
              key: "actions-becprices",
              fn: function(cell) {
                return [_c('table', {
                  staticClass: "actions-table"
                }, [_c('tr', [_c('td', [_c('a', {
                  staticStyle: {
                    "cursor": "pointer"
                  },
                  attrs: {
                    "title": _vm.edit_text
                  },
                  on: {
                    "click": function($event) {
                      _vm.editBecPrice(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "pencil",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1)]), _vm._v(" "), _c('td', [_c('a', {
                  staticStyle: {
                    "cursor": "pointer"
                  },
                  attrs: {
                    "title": _vm.duplicate_text
                  },
                  on: {
                    "click": function($event) {
                      _vm.duplicateBecPrice(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "files-o",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1)]), _vm._v(" "), _c('td', [_c('a', {
                  staticStyle: {
                    "cursor": "pointer"
                  },
                  attrs: {
                    "title": _vm.delete_text
                  },
                  on: {
                    "click": function($event) {
                      _vm.deleteBecPrice(cell.row)
                    }
                  }
                }, [_c('icon', {
                  attrs: {
                    "name": "trash-o",
                    "scale": "1",
                    "color": "gray"
                  }
                })], 1)])])])]
              }
            }])
          }, [_vm._l((_vm.becprices_table.columns), function(column) {
            return _c('datatable-column', {
              attrs: {
                "id": column.id,
                "label": column.label,
                "width": column.width,
                "sortable": column.sortable,
                "groupable": column.groupable,
                "formatter": column.formatter
              }
            })
          }), _vm._v(" "), _c('datatable-column', {
            attrs: {
              "id": "actions-becprices",
              "label": _vm.actions_text,
              "sortable": false,
              "groupable": false
            }
          })], 2)]
        }
      }])
    })], 1)])]) : _vm._e()])])])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.metadata_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('form', {
      staticClass: "bt-form"
    })])])], 1), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUp($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "chevron-left",
        "text": _vm.goup_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentBecProperty({
            go_up: false
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentBecProperty({
            go_up: true
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_and_go_up_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), (_vm.becproperty.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e()], 1)], 1)]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 2191 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "datatable-collection"
  }, [(_vm.groupable) ? _c('table', {
    class: {
      'table-striped': _vm.striped
    }
  }, _vm._l((_vm.groups), function(data, group, index) {
    return _c('tr', [_c('td', {
      staticClass: "datatable-group",
      attrs: {
        "colspan": _vm.columnSpan
      }
    }, [_c('div', {
      staticClass: "datatable-group-header",
      attrs: {
        "layout": "row center-justify"
      }
    }, [_c('div', {
      attrs: {
        "self": "size-x1"
      }
    }, [_c('span', {
      staticClass: "datatable-group-label",
      style: (_vm.indentStyle)
    }, [_vm._v(_vm._s(_vm.groupingColumn.formatData(group)))])]), _vm._v(" "), (data.length > 1) ? _c('span', {
      staticClass: "label label-primary datatable-row-count"
    }, [_vm._v(_vm._s(data.length))]) : _vm._e()]), _vm._v(" "), _c('datatable-collection', {
      attrs: {
        "rows": data,
        "columns": _vm.columns,
        "striped": _vm.striped,
        "editable": _vm.editable,
        "line-numbers": _vm.lineNumbers,
        "aggregated": _vm.aggregated,
        "margin": _vm.margin,
        "grouping-columns": _vm.groupingColumns,
        "grouping-index": _vm.groupingIndex + 1,
        "collection-index": _vm.collectionIndex * index,
        "optimize": _vm.optimize,
        "message": _vm.message
      }
    })], 1)])
  })) : _c('table', {
    staticClass: "datatable-resultset",
    class: {
      'table-striped': _vm.striped
    }
  }, [(_vm.rows.length < 1) ? _c('tr', [_c('td', {
    staticClass: "datatable-info-cell",
    attrs: {
      "colspan": _vm.columnSpan
    }
  }, [_vm._v(_vm._s(_vm.message))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.rows), function(row, index) {
    return _c('tr', [(_vm.lineNumbers) ? _c('td', {
      staticClass: "datatable-cell datatable-linenumber-cell",
      style: ({
        width: _vm.margin
      })
    }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.collectionIndex + index + 1) + "\n\n\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.aggregated) ? _c('td', {
      staticClass: "datatable-cell datatable-aggregate-cell",
      style: ({
        width: '100px'
      })
    }, [_vm._v("\n\t\t\t\t \n\t\t\t")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.columns), function(column) {
      return _c('datatable-cell', {
        key: column.id,
        attrs: {
          "column": column,
          "row": row,
          "editable": _vm.editable,
          "optimize": _vm.optimize
        }
      })
    })], 2)
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 2192 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "constraint-editor"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "filesOpen": _vm.filesOpen,
        "fileOpen": _vm.fileOpen,
        "reportOpen": _vm.reportOpen
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [_c('span', [_vm._v(_vm._s(_vm.$t('Constraint')))]), (_vm.constraint.dirty) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.constraint.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "datedata"
    }, [_c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Created')) + ": " + _vm._s(_vm.millis_to_time(_vm.constraint.date_created)))]), _vm._v(" "), _c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Last_modified')) + ": " + _vm._s(_vm.millis_to_time(_vm.constraint.date_modified)))])]), _vm._v(" "), _c('vue-tabs', [_c('v-tab', {
      attrs: {
        "title": _vm.data_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Constraint')) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Constraints_foreseen_by_law')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.constraintValue,
        "options": _vm.default_constraintOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_constraint
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Catalan')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.constraint.name_ca),
        expression: "constraint.name_ca"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.constraint.name_ca)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.constraint.name_ca = $event.target.value
        }, _vm.set_constraint_name_ca]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('English')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.constraint.name_en),
        expression: "constraint.name_en"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.constraint.name_en)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.constraint.name_en = $event.target.value
        }, _vm.set_constraint_name_en]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Spanish')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.constraint.name_es),
        expression: "constraint.name_es"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.constraint.name_es)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.constraint.name_es = $event.target.value
        }, _vm.set_constraint_name_es]
      }
    })])])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.metadata_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('form', {
      staticClass: "bt-form"
    })])])], 1), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUp($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "chevron-left",
        "text": _vm.goup_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentConstraint({
            go_up: false
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentConstraint({
            go_up: true
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_and_go_up_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), (_vm.constraint.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e()], 1)], 1)]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 2193 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "appraisalreport-editor"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), (_vm.selecting_realestate) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "dialog_container"
    }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('Select_Real_estate_to_be_added')) + " " + _vm._s(_vm.$t('or')) + " "), _c('span', {
      staticClass: "navspan",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCreateNewRealEstate()
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('create_a_new_one')))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Existing_Real_estates')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.importRealEstateValue,
        "options": _vm.object_to_array(_vm.realestates),
        "track-by": "id",
        "label": 'full_address',
        "searchable": true
      },
      on: {
        "input": _vm.set_import_realestate
      },
      model: {
        value: (_vm.appraisalreport.importRealEstate),
        callback: function($$v) {
          _vm.appraisalreport.importRealEstate = $$v
        },
        expression: "appraisalreport.importRealEstate"
      }
    })], 1)]), _vm._v(" "), _c('table', {
      staticClass: "dialog_buttons_table"
    }, [_c('tr', [_c('td', [_c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-right": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCancelImportNewRealEstate($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "times",
        "text": '',
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray",
        "min_width": "80px",
        "max_width": "80px"
      }
    })], 1)])]), _vm._v(" "), _c('td', [_c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onImportNewRealEstate({
            id: _vm.appraisalreport.importRealEstate.id
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "check",
        "text": '',
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray",
        "min_width": "80px",
        "max_width": "80px"
      }
    })], 1)])])])])])]) : _vm._e(), _vm._v(" "), (_vm.creating_contact) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "dialog_container"
    }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.$t('Create_new_contact')))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "form-section"
    }, [_c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Person_type')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.value,
        "options": _vm.personTypeOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ?
          'name_ca' : (_vm.currentLocale === 'en') ?
          'name_en' : 'name_es',
        "searchable": false
      },
      on: {
        "input": _vm.set_contact_person_type
      },
      model: {
        value: (_vm.contact.person_type),
        callback: function($$v) {
          _vm.contact.person_type = $$v
        },
        expression: "contact.person_type"
      }
    })], 1)]), _vm._v(" "), (_vm.contact.person_type) ? _c('div', [_c('div', {
      staticClass: "field-container"
    }, [(_vm.contact.person_type.id === 1) ? _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Title')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.value,
        "options": _vm.honorificTitleOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ?
          'abb_ca' : (_vm.currentLocale === 'en') ?
          'abb_en' : 'abb_es',
        "searchable": false
      },
      on: {
        "input": _vm.set_contact_title
      },
      model: {
        value: (_vm.contact.title),
        callback: function($$v) {
          _vm.contact.title = $$v
        },
        expression: "contact.title"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Name')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.contact.name),
        expression: "contact.name"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.contact.name)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.contact.name = $event.target.value
        }, _vm.set_contact_name]
      }
    })]), _vm._v(" "), (_vm.contact.person_type.id === 1) ? _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Surnames')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.contact.surnames),
        expression: "contact.surnames"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.contact.surnames)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.contact.surnames = $event.target.value
        }, _vm.set_contact_surnames]
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Main_email')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.contact.main_email),
        expression: "contact.main_email"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.contact.main_email)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.contact.main_email = $event.target.value
        }, _vm.set_contact_main_email]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('TIN')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.contact.tin),
        expression: "contact.tin"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.contact.tin)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.contact.tin = $event.target.value
        }, _vm.set_contact_tin]
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Fiscal_address')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.contact.complete_fiscal_address),
        expression: "contact.complete_fiscal_address"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.contact.complete_fiscal_address)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.contact.complete_fiscal_address = $event.target.value
        }, _vm.set_contact_complete_fiscal_address]
      }
    })])])]) : _vm._e()]), _vm._v(" "), _c('table', {
      staticClass: "dialog_buttons_table"
    }, [_c('tr', [_c('td', [_c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-right": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCancelCreateNewContact($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "times",
        "text": '',
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray",
        "min_width": "80px",
        "max_width": "80px"
      }
    })], 1)])]), _vm._v(" "), _c('td', [_c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onCreateNewContact($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "check",
        "text": '',
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray",
        "min_width": "80px",
        "max_width": "80px"
      }
    })], 1)])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "filesOpen": _vm.filesOpen,
        "fileOpen": _vm.fileOpen,
        "fileId": _vm.appraisalfile.id,
        "fileNumber": _vm.appraisalfile.number,
        "reportOpen": _vm.reportOpen,
        "realEstates": _vm.appraisalreport_realestates,
        "reportId": _vm.appraisalreport.id
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('Appraisal_report')) + " "), (_vm.appraisalreport.full_number) ? _c('span', [_vm._v(_vm._s(_vm.appraisalreport.full_number))]) : _vm._e(), (_vm.appraisalreport.dirty) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.appraisalreport.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "datedata"
    }, [_c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Created')) + ": " + _vm._s(_vm.millis_to_time(_vm.appraisalreport.date_created)))]), _vm._v(" "), _c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Last_modified')) + ": " + _vm._s(_vm.millis_to_time(_vm.appraisalreport.date_modified)))])]), _vm._v(" "), _c('vue-tabs', [_c('v-tab', {
      attrs: {
        "title": _vm.reportcontent_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Title_and_date_of_report')) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Report_title'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalreport.title),
        expression: "appraisalreport.title"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisalreport.title)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisalreport.title = $event.target.value
        }, _vm.set_appraisalreport_title]
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Date_of_report'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalreport.reportdate),
        expression: "appraisalreport.reportdate"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "date",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisalreport.reportdate)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisalreport.reportdate = $event.target.value
        }, _vm.set_appraisalreport_reportdate]
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Send_to_bde_q')) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Send_to_bde_q')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalreport.send_to_bde),
        expression: "appraisalreport.send_to_bde"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisalreport.send_to_bde) ? _vm._i(_vm.appraisalreport.send_to_bde, null) > -1 : (_vm.appraisalreport.send_to_bde)
      },
      on: {
        "input": _vm.set_appraisalreport_send_to_bde,
        "__c": function($event) {
          var $$a = _vm.appraisalreport.send_to_bde,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisalreport.send_to_bde = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisalreport.send_to_bde = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisalreport.send_to_bde = $$c
          }
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Appraisal_petitioners')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container",
      staticStyle: {
        "background-color": "#fafafc",
        "padding": "2rem"
      }
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Surnames_name_or_company'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.petitionerValue,
        "options": _vm.object_to_array(_vm.contacts),
        "track-by": "id",
        "label": 'complete_name',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisalreport_petitioner
      },
      model: {
        value: (_vm.appraisalreport.petitioner),
        callback: function($$v) {
          _vm.appraisalreport.petitioner = $$v
        },
        expression: "appraisalreport.petitioner"
      }
    }, [_c('span', {
      style: ({
        color: _vm.no_result_color
      }),
      attrs: {
        "slot-scope": "props"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onAddNewContact($event)
        },
        "mouseover": function($event) {
          _vm.no_result_color = 'rgb(0, 135, 248)'
        },
        "mouseleave": function($event) {
          _vm.no_result_color = 'black'
        }
      },
      slot: "noResult"
    }, [_vm._v("Cap resultat. Click per crear nou.")])])], 1), _vm._v(" "), (_vm.appraisalreport.petitioner) ? _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onAddNewPetitioner($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus-circle",
        "text": _vm.add_petitioner_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), (_vm.object_length(_vm.appraisalreport_petitioners) > 0) ? _c('div', [_c('div', {
      staticClass: "text_table"
    }, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "data-table-appraisalreport_petitioners",
        "source": _vm.object_to_array(_vm.appraisalreport_petitioners),
        "filterable": false,
        "striped": _vm.petitioner_table.striped,
        "editable": _vm.petitioner_table.editable,
        "line-numbers": _vm.petitioner_table.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-petitioners",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.edit_text
            },
            on: {
              "click": function($event) {
                _vm.editContact(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "pencil",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.discardPetitioner(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "times",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }])
    }, [_c('datatable-column', {
      attrs: {
        "id": "actions-petitioners",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    }), _vm._v(" "), _vm._l((_vm.petitioner_table.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    })], 2)], 1)])])]) : _c('div', [_c('br'), _vm._v(_vm._s(_vm.$t('No_petitioners_text')))])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Mandatary')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Entity'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.entityValue,
        "options": _vm.object_to_array(_vm.entities),
        "track-by": "id",
        "label": 'name',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisalreport_entity
      },
      model: {
        value: (_vm.appraisalreport.entity),
        callback: function($$v) {
          _vm.appraisalreport.entity = $$v
        },
        expression: "appraisalreport.entity"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('TIN'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" ")]) : _vm._e()]), _vm._v(" "), (_vm.appraisalreport.entity) ? _c('span', [_vm._v(" " + _vm._s(_vm.appraisalreport.entity.tin) + " ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('BdE_code'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" ")]) : _vm._e()]), _vm._v(" "), (_vm.appraisalreport.entity) ? _c('span', [_vm._v(" " + _vm._s(_vm.appraisalreport.entity.bde_code) + " ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Appraiser')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Name'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.appraiserValue,
        "options": _vm.object_to_array(_vm.appraisers),
        "track-by": "id",
        "label": 'complete_name',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisalreport_appraiser
      },
      model: {
        value: (_vm.appraisalreport.appraiser),
        callback: function($$v) {
          _vm.appraisalreport.appraiser = $$v
        },
        expression: "appraisalreport.appraiser"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('TIN'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" ")]) : _vm._e()]), _vm._v(" "), (_vm.appraisalreport.appraiser) ? _c('span', [_vm._v(" " + _vm._s(_vm.appraisalreport.appraiser.tin) + " ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Prof_assoc_reg_number'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")]), _vm._v(" ")]) : _vm._e()]), _vm._v(" "), (_vm.appraisalreport.appraiser) ? _c('span', [_vm._v(" " + _vm._s(_vm.appraisalreport.appraiser.prof_assoc_reg_number) + " ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Supervisor')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Name'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")])]) : _vm._e()]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.supervisorValue,
        "options": _vm.object_to_array(_vm.supervisors),
        "track-by": "id",
        "label": 'complete_name',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisalreport_supervisor
      },
      model: {
        value: (_vm.appraisalreport.supervisor),
        callback: function($$v) {
          _vm.appraisalreport.supervisor = $$v
        },
        expression: "appraisalreport.supervisor"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('TIN'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "bde_tag"
    }, [_vm._v("BdE")]), _vm._v(" ")]) : _vm._e()]), _vm._v(" "), (_vm.appraisalreport.supervisor) ? _c('span', [_vm._v(" " + _vm._s(_vm.appraisalreport.supervisor.tin) + " ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Prof_assoc_reg_number'))), (_vm.tags_display) ? _c('span', [_vm._v(" "), _c('span', {
      staticClass: "pdf_tag"
    }, [_vm._v("PDF")]), _vm._v(" ")]) : _vm._e()]), _vm._v(" "), (_vm.appraisalreport.supervisor) ? _c('span', [_vm._v(" " + _vm._s(_vm.appraisalreport.supervisor.prof_assoc_reg_number) + " ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Real_estates')) + " " + _vm._s(_vm.$t('valuated_in_this_report')))]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSelectNewRealEstate($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "plus-circle",
        "text": _vm.select_real_estate_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), (_vm.object_length(_vm.appraisalreport_realestates) > 0) ? _c('div', [_c('div', {
      staticClass: "query_table"
    }, [_c('div', {
      staticClass: "grid-row",
      attrs: {
        "layout": "row top-stretch"
      }
    }, [_c('div', {
      staticClass: "grid-cell"
    }, [_c('datatable', {
      attrs: {
        "id": "data-table-main",
        "source": _vm._.sortBy(_vm.object_to_array(_vm.appraisalreport_realestates), 'index'),
        "filterable": false,
        "striped": _vm.realestate_table.striped,
        "editable": _vm.realestate_table.editable,
        "line-numbers": _vm.realestate_table.lineNumbers
      },
      scopedSlots: _vm._u([{
        key: "actions-realestates",
        fn: function(cell) {
          return [_c('table', {
            staticClass: "actions-table"
          }, [_c('tr', [_c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.edit_text
            },
            on: {
              "click": function($event) {
                _vm.editRealEstate(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "pencil",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)]), _vm._v(" "), _c('td', {
            staticClass: "actions_td"
          }, [_c('a', {
            staticStyle: {
              "cursor": "pointer"
            },
            attrs: {
              "title": _vm.delete_text
            },
            on: {
              "click": function($event) {
                _vm.discardRealEstate(cell.row)
              }
            }
          }, [_c('icon', {
            attrs: {
              "name": "times",
              "scale": ".9",
              "color": "gray"
            }
          })], 1)])])])]
        }
      }, {
        key: "index",
        fn: function(cell) {
          return [_c('div', [_c('input', {
            directives: [{
              name: "model",
              rawName: "v-model",
              value: (cell.row['index']),
              expression: "cell.row['index']"
            }],
            staticStyle: {
              "width": "40px"
            },
            attrs: {
              "type": "number"
            },
            domProps: {
              "value": (cell.row['index'])
            },
            on: {
              "input": [function($event) {
                if ($event.target.composing) { return; }
                var $$exp = cell.row,
                  $$idx = 'index';
                if (!Array.isArray($$exp)) {
                  cell.row['index'] = $event.target.value
                } else {
                  $$exp.splice($$idx, 1, $event.target.value)
                }
              }, function($event) {
                _vm.set_entity_index($event, cell.row)
              }],
              "blur": function($event) {
                _vm.$forceUpdate()
              }
            }
          })])]
        }
      }, {
        key: "property_type",
        fn: function(cell) {
          return [(cell.row['property_type']) ? _c('span', [(_vm.currentLocale === 'ca') ? _c('span', [_vm._v(_vm._s(cell.row['property_type']['name_ca']))]) : (_vm.currentLocale === 'en') ? _c('span', [_vm._v(_vm._s(cell.row['property_type']['name_en']))]) : _c('span', [_vm._v(_vm._s(cell.row['property_type']['name_es']))])]) : _vm._e()]
        }
      }, {
        key: "appraisal_id",
        fn: function(cell) {
          return [_c('div', [_c('multiselect', {
            attrs: {
              "placeholder": "",
              "value": _vm.realestate_appraisaldateValue,
              "options": _vm.object_to_array(_vm.appraisalreport_realestates[cell.row['id']]['appraisals']),
              "track-by": "id",
              "label": 'id',
              "searchable": false,
              "selectedLabel": "",
              "selectLabel": "",
              "deselectLabel": ""
            },
            on: {
              "input": function($event) {
                _vm.set_appraisalreport_realestate_appraisal_id($event, cell.row['id'])
              }
            },
            model: {
              value: (cell.row['appraisal_id']),
              callback: function($$v) {
                var $$exp = cell.row,
                  $$idx = 'appraisal_id';
                if (!Array.isArray($$exp)) {
                  cell.row['appraisal_id'] = $$v
                } else {
                  $$exp.splice($$idx, 1, $$v)
                }
              },
              expression: "cell.row['appraisal_id']"
            }
          })], 1)]
        }
      }, {
        key: "appraisaldate",
        fn: function(cell) {
          return [_c('div', [(cell.row.appraisal_id) ? _c('span', [_vm._v(_vm._s(cell.row.appraisal_id.appraisaldate))]) : _vm._e()])]
        }
      }, {
        key: "realestate_total_adopted_value",
        fn: function(cell) {
          return [_c('div', [(cell.row.appraisal_id) ? _c('span', [_vm._v(_vm._s(_vm._f("formatNumber")(cell.row.appraisal_id.realestate_total_adopted_value)) + " €")]) : _vm._e()])]
        }
      }])
    }, [_c('datatable-column', {
      attrs: {
        "id": "actions-realestates",
        "label": _vm.actions_text,
        "width": "160px",
        "sortable": false,
        "groupable": false
      }
    }), _vm._v(" "), _vm._l((_vm.realestate_table.columns), function(column) {
      return _c('datatable-column', {
        attrs: {
          "id": column.id,
          "label": column.label,
          "width": column.width,
          "sortable": column.sortable,
          "groupable": column.groupable,
          "aggregators": column.aggregators,
          "formatter": column.formatter
        }
      })
    })], 2)], 1)])])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Signature')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [(_vm.appraisalreport.signature_ap_uid === _vm.user.id || !_vm.appraisalreport.is_ap_signed) ? _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Appraisers_signature')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalreport.is_ap_signed),
        expression: "appraisalreport.is_ap_signed"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisalreport.is_ap_signed) ? _vm._i(_vm.appraisalreport.is_ap_signed, null) > -1 : (_vm.appraisalreport.is_ap_signed)
      },
      on: {
        "click": _vm.set_appraisalreport_is_ap_signed,
        "__c": function($event) {
          var $$a = _vm.appraisalreport.is_ap_signed,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisalreport.is_ap_signed = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisalreport.is_ap_signed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisalreport.is_ap_signed = $$c
          }
        }
      }
    })]) : _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Appraisers_signature')))]), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
      staticClass: "field-group"
    }, [(_vm.appraisalreport.is_ap_signed) ? _c('div', [_c('img', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "src": _vm.appraisalreport.signature_ap_base64,
        "alt": "s"
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.appraisalreport.signature_ap_name))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Signed')) + " " + _vm._s(_vm._f("formatDateAsLocal")(_vm.appraisalreport.signature_ap_date)))])]) : _vm._e()])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [(_vm.appraisalreport.signature_sv_uid === _vm.user.id || !_vm.appraisalreport.is_sv_signed) ? _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Supervisors_signature')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalreport.is_sv_signed),
        expression: "appraisalreport.is_sv_signed"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "checkbox",
        "spellcheck": "false"
      },
      domProps: {
        "checked": Array.isArray(_vm.appraisalreport.is_sv_signed) ? _vm._i(_vm.appraisalreport.is_sv_signed, null) > -1 : (_vm.appraisalreport.is_sv_signed)
      },
      on: {
        "click": _vm.set_appraisalreport_is_sv_signed,
        "__c": function($event) {
          var $$a = _vm.appraisalreport.is_sv_signed,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.appraisalreport.is_sv_signed = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.appraisalreport.is_sv_signed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.appraisalreport.is_sv_signed = $$c
          }
        }
      }
    })]) : _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Supervisors_signature')))]), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
      staticClass: "field-group"
    }, [(_vm.appraisalreport.is_sv_signed) ? _c('div', [_c('img', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "src": _vm.appraisalreport.signature_sv_base64,
        "alt": "s"
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(_vm.appraisalreport.signature_sv_name))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Signed')) + " " + _vm._s(_vm._f("formatDateAsLocal")(_vm.appraisalreport.signature_sv_date)))])]) : _vm._e()])]), _vm._v(" "), _c('hr')])]), _vm._v(" "), (!this.appraisalreport.title) ? _c('div', [_c('message', {
      attrs: {
        "text": _vm.report_title_error_text,
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm._.size(this.appraisalreport_realestates) < 1) ? _c('div', [_c('message', {
      attrs: {
        "text": _vm.realestates_missing_error_text,
        "icon_name": "exclamation",
        "icon_color": "darkred",
        "border_color": "red",
        "text_color": "darkred"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm._.size(this.appraisalreport_realestates) > 0) ? _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.checkBeforeOnCreatePdf($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "file-pdf-o",
        "text": _vm.pdf_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]) : _vm._e()])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.metadata_text
      }
    }, [_c('div', {
      staticClass: "tab_content"
    }, [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Description')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Appraisal_report_description')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalreport.description),
        expression: "appraisalreport.description"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "text",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisalreport.description)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisalreport.description = $event.target.value
        }, _vm.set_appraisalreport_description]
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Report_number')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Report_number')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalreport.number),
        expression: "appraisalreport.number"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "maxlength": "2",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisalreport.number)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisalreport.number = $event.target.value
        }, _vm.set_appraisalreport_number],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "field__group"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Version')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.appraisalreport.version),
        expression: "appraisalreport.version"
      }],
      staticClass: "field__group__input",
      attrs: {
        "type": "number",
        "maxlength": "2",
        "spellcheck": "false"
      },
      domProps: {
        "value": (_vm.appraisalreport.version)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.appraisalreport.version = $event.target.value
        }, _vm.set_appraisalreport_version],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Status')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    }, [_c('div', {
      staticClass: "ms-container"
    }, [_c('label', {
      staticClass: "field__group__label"
    }, [_vm._v(_vm._s(_vm.$t('Status')))]), _vm._v(" "), _c('multiselect', {
      attrs: {
        "placeholder": "",
        "value": _vm.statusValue,
        "options": _vm.status_reportsOptions,
        "track-by": "id",
        "label": (_vm.currentLocale === 'ca') ? 'name_ca' : (_vm.currentLocale === 'en') ? 'name_en' : 'name_es',
        "searchable": true
      },
      on: {
        "input": _vm.set_appraisalreport_status
      },
      model: {
        value: (_vm.appraisalreport.status),
        callback: function($$v) {
          _vm.appraisalreport.status = $$v
        },
        expression: "appraisalreport.status"
      }
    })], 1)])])])])])], 1), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUp($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "chevron-left",
        "text": _vm.goup_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentAppraisalReport({
            go_up: false
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentAppraisalReport({
            go_up: true
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_and_go_up_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), (_vm.appraisalreport.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e()], 1)], 1)]
  ], 2)
},staticRenderFns: []}

/***/ }),
/* 2194 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home",
    class: _vm.theme,
    attrs: {
      "id": "services-page"
    }
  }, [_c('nav-bar'), _vm._v(" "), _c('swiper', {
    ref: "mySwiper7",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticStyle: {
      "height": "100%",
      "background-image": "url('../assets/img/cm1.jpg')",
      "background-size": "cover",
      "background-repeat": "no-repeat"
    }
  }, [_c('div', {
    staticClass: "slide-center"
  }, [_c('h1', {
    staticClass: "page__title-white"
  }, [_vm._v(_vm._s(_vm.$t('Our_clients')))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "page",
    attrs: {
      "id": "quote-form"
    }
  }, [_c('h1', {
    staticClass: "page__title"
  }, [_vm._v(_vm._s(_vm.$t('Our_clients')))]), _vm._v(" "), _c('hr', {
    staticClass: "page__hr"
  }), _vm._v("\n\n\t\t" + _vm._s(_vm.$t('Clients_text_01')) + ":\n\n\n\n\n\n\t\t"), _c('ul', [_c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('Individuals')))]), _vm._v(".\n\t\t\t" + _vm._s(_vm.$t('Clients_text_02')) + ".\n\n\n\n\n\t\t\t")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('Law_firms')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('Auditors')))]), _vm._v(".\n\t\t\t" + _vm._s(_vm.$t('Clients_text_03')) + ".\n\t\t\t")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('Private_Enterprises')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('Financial_Entities')))]), _vm._v(".\n\t\t\t\t\t\t" + _vm._s(_vm.$t('Clients_text_04')) + ".")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('Public_Administrations')))]), _vm._v(".")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('Mutual_insurance_companies')) + ", " + _vm._s(_vm.$t('Hospitals')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('Medical_centers')))]), _vm._v(".")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('Cooperatives')))]), _vm._v(".")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('Foundations')))]), _vm._v(".")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('Property_developers')))]), _vm._v(".")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('Sports_clubs')))]), _vm._v(".")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('Insurance_companies')))]), _vm._v(".")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('Investment_groups')))]), _vm._v(".")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('Hotels')) + " " + _vm._s(_vm.$t('and')) + " " + _vm._s(_vm.$t('Restaurants')))]), _vm._v(".")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v(_vm._s(_vm.$t('Others')))]), _vm._v(".")])])]), _vm._v(" "), _c('logo-bar'), _vm._v(" "), _c('footer-bar')], 1)
},staticRenderFns: []}

/***/ }),
/* 2195 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search__info"
  }, [(_vm.resultsCount == 1) ? _c('span', [_vm._v("\n    1 note\n  ")]) : _c('span', [_vm._v("\n    " + _vm._s(_vm.resultsCount) + " notes\n  ")]), _vm._v(" "), (_vm.editing || !_vm.searching) ? _c('span', [_c('span', {
    staticClass: "command"
  }, [_vm._v("esc")]), _vm._v(" to focus search\n  ")]) : (_vm.renaming) ? _c('span', [_c('span', {
    staticClass: "command"
  }, [_vm._v("enter")]), _vm._v(" to save title\n  ")]) : (_vm.queryLength > 0) ? _c('span', [_c('span', {
    staticClass: "command"
  }, [_vm._v("ctrl")]), _vm._v(" + "), _c('span', {
    staticClass: "command"
  }, [_vm._v("enter")]), _vm._v(" to create note\n  ")]) : (_vm.selected) ? _c('span', [_c('span', {
    staticClass: "command"
  }, [_vm._v("enter")]), _vm._v(" to edit note\n  ")]) : _c('span', [_vm._v("\n    Type to search\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 2196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:!0});var VueLodash={install:function(e,t){e._=t,Object.defineProperties(e.prototype,{_:{get:function(){return t}}}),e.mixin({mounted:function(){}}),"undefined"!=typeof window&&window.Vue&&window.Vue.use(VueLodash)}};exports.default=VueLodash;

/***/ }),
/* 2197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.3.4
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING  = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p$1 = Promise$1.prototype;

p$1.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p$1.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p$1.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p$1.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p$1.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p = PromiseObj.prototype;

p.bind = function (context) {
    this.context = context;
    return this;
};

p.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p.finally = function (callback) {

    return this.then(function (value) {
            callback.call(this);
            return value;
        }, function (reason) {
            callback.call(this);
            return Promise.reject(reason);
        }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;

var ref$1 = [];
var slice = ref$1.slice;
var debug = false;
var ntick;

var inBrowser = typeof window !== 'undefined';

var Util = function (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
};

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}



function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

var root = function (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
};

/**
 * Query Parameter Transform.
 */

var query = function (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
};

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^\{\}]+)\}|([^\{\}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:\*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

var template = function (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
};

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

var xdrClient = function (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load') {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            resolve(request.respondWith(xdr.responseText, {status: status}));
        };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
};

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

var cors = function (request, next) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

    next();
};

/**
 * Form data Interceptor.
 */

var form = function (request, next) {

    if (isFormData(request.body)) {

        request.headers.delete('Content-Type');

    } else if (isObject(request.body) && request.emulateJSON) {

        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

    next();
};

/**
 * JSON Interceptor.
 */

var json = function (request, next) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    next(function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    });
};

function isJson(str) {

    var start = str.match(/^\[|^\{(?!\{)/), end = {'[': /]$/, '{': /}$/};

    return start && end[start[0]].test(str);
}

/**
 * JSONP client (Browser).
 */

var jsonpClient = function (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
};

/**
 * JSONP Interceptor.
 */

var jsonp = function (request, next) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

    next();
};

/**
 * Before Interceptor.
 */

var before = function (request, next) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

    next();
};

/**
 * HTTP method override Interceptor.
 */

var method = function (request, next) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

    next();
};

/**
 * Header Interceptor.
 */

var header = function (request, next) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

    next();
};

/**
 * XMLHttp client (Browser).
 */

var xhrClient = function (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

            var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                }
            );

            each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
            });

            resolve(response);
        };

        request.abort = function () { return xhr.abort(); };

        if (request.progress) {
            if (request.method === 'GET') {
                xhr.addEventListener('progress', request.progress);
            } else if (/^(POST|PUT)$/i.test(request.method)) {
                xhr.upload.addEventListener('progress', request.progress);
            }
        }

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
};

/**
 * Http client (Node).
 */

var nodeClient = function (request) {

    var client = __webpack_require__(2284);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                    status: resp.statusCode,
                    statusText: trim(resp.statusMessage)
                }
            );

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
};

/**
 * Base client.
 */

var Client = function (context) {

    var reqHandlers = [sendRequest], resHandlers = [], handler;

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        return new PromiseObj(function (resolve, reject) {

            function exec() {

                handler = reqHandlers.pop();

                if (isFunction(handler)) {
                    handler.call(context, request, next);
                } else {
                    warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
                    next();
                }
            }

            function next(response) {

                if (isFunction(response)) {

                    resHandlers.unshift(response);

                } else if (isObject(response)) {

                    resHandlers.forEach(function (handler) {
                        response = when(response, function (response) {
                            return handler.call(context, response) || response;
                        }, reject);
                    });

                    when(response, resolve, reject);

                    return;
                }

                exec();
            }

            exec();

        }, context);
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
};

function sendRequest(request, resolve) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    resolve(client(request));
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value){

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name){
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll (){
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl (){
    return Url(this);
};

Request.prototype.getBody = function getBody (){
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 2198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.6.0
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also regiseter instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    data.props = resolveProps(route, matched.props && matched.props[name]);

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    var val = extraQuery[key];
    parsedQuery[key] = Array.isArray(val) ? val.slice() : val;
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;
  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: location.query || {},
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var index$1 = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var index = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (index$1(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!index$1(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!index$1(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (index$1(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

index.parse = parse_1;
index.compile = compile_1;
index.tokensToFunction = tokensToFunction_1;
index.tokensToRegExp = tokensToRegExp_1;

/*  */

var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = index.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  var pathMap = oldPathMap || Object.create(null);
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var normalizedPath = normalizePath(path, parent);
  var pathToRegexpOptions = route.pathToRegexpOptions || {};

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = index(path, [], pathToRegexpOptions);
  if (false) {
    var keys = {};
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent) {
  path = path.replace(/\/$/, '');
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);
    if (!shouldScroll) {
      return
    }
    var isObject = typeof shouldScroll === 'object';
    if (isObject && typeof shouldScroll.selector === 'string') {
      var el = document.querySelector(shouldScroll.selector);
      if (el) {
        var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
        offset = normalizeOffset(offset);
        position = getElementPosition(el, offset);
      } else if (isValidPosition(shouldScroll)) {
        position = normalizePosition(shouldScroll);
      }
    } else if (isObject && isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }

    if (position) {
      window.scrollTo(position.x, position.y);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    window.addEventListener('popstate', function (e) {
      var current = this$1.current;
      this$1.transitionTo(getLocation(this$1.base), function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    window.addEventListener('hashchange', function () {
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        replaceHash(route.fullPath);
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function pushHash (path) {
  window.location.hash = path;
}

function replaceHash (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  window.location.replace((base + "#" + path));
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: {} };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.6.0';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 2199 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(934);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(31)("bea0967e", content, true);

/***/ }),
/* 2200 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(935);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(31)("264c6800", content, true);

/***/ }),
/* 2201 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(936);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(31)("55ec742e", content, true);

/***/ }),
/* 2202 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(937);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(31)("511390e8", content, true);

/***/ }),
/* 2203 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(938);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(31)("c552a218", content, true);

/***/ }),
/* 2204 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(939);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(31)("3fca8441", content, true);

/***/ }),
/* 2205 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(940);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(31)("aa2709b2", content, true);

/***/ }),
/* 2206 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(941);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(31)("b75f8e52", content, true);

/***/ }),
/* 2207 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(942);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(31)("42efe176", content, true);

/***/ }),
/* 2208 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(943);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(31)("77504528", content, true);

/***/ }),
/* 2209 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(944);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(31)("24b7a5bb", content, true);

/***/ }),
/* 2210 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(945);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(31)("783ab112", content, true);

/***/ }),
/* 2211 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(947);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(31)("0628a44e", content, true);

/***/ }),
/* 2212 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(948);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(31)("40733ad6", content, true);

/***/ }),
/* 2213 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(949);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(31)("324ce30a", content, true);

/***/ }),
/* 2214 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(950);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(31)("8e59d25c", content, true);

/***/ }),
/* 2215 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(951);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(31)("d4a6a14c", content, true);

/***/ }),
/* 2216 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(952);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(31)("028fed67", content, true);

/***/ }),
/* 2217 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(953);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(31)("ede1a6c6", content, true);

/***/ }),
/* 2218 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(954);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(31)("4a39eb94", content, true);

/***/ }),
/* 2219 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(955);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(31)("4e0790c0", content, true);

/***/ }),
/* 2220 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(956);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(31)("617c948e", content, true);

/***/ }),
/* 2221 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(957);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(31)("03fd0f92", content, true);

/***/ }),
/* 2222 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(958);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(31)("2be2ff2d", content, true);

/***/ }),
/* 2223 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(959);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(31)("713b35a0", content, true);

/***/ }),
/* 2224 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(960);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(31)("630cd620", content, true);

/***/ }),
/* 2225 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(961);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(31)("1ef4a451", content, true);

/***/ }),
/* 2226 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(962);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(31)("8861473a", content, true);

/***/ }),
/* 2227 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(963);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(31)("8c400f1c", content, true);

/***/ }),
/* 2228 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 2229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(9);

var _lodash2 = _interopRequireDefault(_lodash);

var _eventsBinder = __webpack_require__(69);

var _eventsBinder2 = _interopRequireDefault(_eventsBinder);

var _propsBinder = __webpack_require__(52);

var _propsBinder2 = _interopRequireDefault(_propsBinder);

var _mapElementMixin = __webpack_require__(76);

var _mapElementMixin2 = _interopRequireDefault(_mapElementMixin);

var _getPropsValuesMixin = __webpack_require__(64);

var _getPropsValuesMixin2 = _interopRequireDefault(_getPropsValuesMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  center: {
    type: Object,
    twoWay: true,
    required: true
  },
  radius: {
    type: Number,
    default: 1000,
    twoWay: true
  },
  draggable: {
    type: Boolean,
    default: false
  },
  editable: {
    type: Boolean,
    default: false
  },
  options: {
    type: Object,
    twoWay: false
  }
};

var events = ['click', 'dblclick', 'drag', 'dragend', 'dragstart', 'mousedown', 'mousemove', 'mouseout', 'mouseover', 'mouseup', 'rightclick'];

exports.default = {
  mixins: [_mapElementMixin2.default, _getPropsValuesMixin2.default],
  props: props,
  version: 2,

  render: function render() {
    return '';
  },
  deferredReady: function deferredReady() {
    var options = _lodash2.default.clone(this.getPropsValues());
    options.map = this.$map;
    delete options.bounds;
    this.createCircle(options);
  },


  methods: {
    createCircle: function createCircle(options) {
      var _this = this;

      this.$circleObject = new google.maps.Circle(options);
      // we cant bind bounds because there is no `setBounds` method
      // on the Circle object
      var boundProps = _lodash2.default.clone(props);
      delete boundProps.bounds;
      (0, _propsBinder2.default)(this, this.$circleObject, boundProps);
      (0, _eventsBinder2.default)(this, this.$circleObject, events);

      var updateBounds = function updateBounds() {
        _this.$emit('bounds_changed', _this.$circleObject.getBounds());
      };

      this.$on('radius_changed', updateBounds);
      this.$on('center_changed', updateBounds);
    }
  },

  destroyed: function destroyed() {
    if (this.$circleObject) {
      this.$circleObject.setMap(null);
    }
  }
};

/***/ }),
/* 2230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(9);

var _lodash2 = _interopRequireDefault(_lodash);

var _eventsBinder = __webpack_require__(69);

var _eventsBinder2 = _interopRequireDefault(_eventsBinder);

var _propsBinder = __webpack_require__(52);

var _propsBinder2 = _interopRequireDefault(_propsBinder);

var _mapElementMixin = __webpack_require__(76);

var _mapElementMixin2 = _interopRequireDefault(_mapElementMixin);

var _getPropsValuesMixin = __webpack_require__(64);

var _getPropsValuesMixin2 = _interopRequireDefault(_getPropsValuesMixin);

var _markerClustererPlus = __webpack_require__(1172);

var _markerClustererPlus2 = _interopRequireDefault(_markerClustererPlus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* vim: set softtabstop=2 shiftwidth=2 expandtab : */

/**
  * @class Cluster
  * @prop $clusterObject -- Exposes the marker clusterer to
        descendent Marker classes. Override this if you area
        extending the class
**/

var props = {
  maxZoom: {
    type: Number,
    twoWay: false
  },
  calculator: {
    type: Function,
    twoWay: false
  },
  gridSize: {
    type: Number,
    twoWay: false
  },
  styles: {
    type: Array,
    twoWay: false
  }
};

var events = ['click', 'rightclick', 'dblclick', 'drag', 'dragstart', 'dragend', 'mouseup', 'mousedown', 'mouseover', 'mouseout'];

exports.default = {
  mixins: [_mapElementMixin2.default, _getPropsValuesMixin2.default],
  props: props,

  render: function render(h) {
    // <div><slot></slot></div>
    return h('div', this.$slots.default);
  },
  deferredReady: function deferredReady() {
    var _this = this;

    var options = _lodash2.default.clone(this.getPropsValues());

    if (typeof _markerClustererPlus2.default === 'undefined') {
      /* eslint-disable no-console */
      console.error('MarkerClusterer is not installed! require() it or include it from https://cdnjs.cloudflare.com/ajax/libs/js-marker-clusterer/1.0.0/markerclusterer.js');
      throw new Error('MarkerClusterer is not installed! require() it or include it from https://cdnjs.cloudflare.com/ajax/libs/js-marker-clusterer/1.0.0/markerclusterer.js');
    }

    this.$clusterObject = new _markerClustererPlus2.default(this.$map, [], options);

    (0, _propsBinder2.default)(this, this.$clusterObject, props, {
      afterModelChanged: function afterModelChanged(a, v) {
        // eslint-disable-line no-unused-vars
        var oldMarkers = _this.$clusterObject.getMarkers();
        _this.$clusterObject.clearMarkers();
        _this.$clusterObject.addMarkers(oldMarkers);
      }
    });
    (0, _eventsBinder2.default)(this, this.$clusterObject, events);
  },
  beforeDestroy: function beforeDestroy() {
    var _this2 = this;

    /* Performance optimization when destroying a large number of markers */
    this.$children.forEach(function (marker) {
      if (marker.$clusterObject === _this2.$clusterObject) {
        marker.$clusterObject = null;
      }
    });

    this.$clusterObject.clearMarkers();
  }
};

/***/ }),
/* 2231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(9);

var _lodash2 = _interopRequireDefault(_lodash);

var _eventsBinder = __webpack_require__(69);

var _eventsBinder2 = _interopRequireDefault(_eventsBinder);

var _propsBinder = __webpack_require__(52);

var _propsBinder2 = _interopRequireDefault(_propsBinder);

var _getPropsValuesMixin = __webpack_require__(64);

var _getPropsValuesMixin2 = _interopRequireDefault(_getPropsValuesMixin);

var _mapElementMixin = __webpack_require__(76);

var _mapElementMixin2 = _interopRequireDefault(_mapElementMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  animation: {
    twoWay: true,
    type: Number
  },
  attribution: {
    type: Object
  },
  clickable: {
    type: Boolean,
    twoWay: true,
    default: true
  },
  cursor: {
    type: String,
    twoWay: true
  },
  draggable: {
    type: Boolean,
    twoWay: true,
    default: false
  },
  icon: {
    twoWay: true
  },
  label: {},
  opacity: {
    type: Number,
    default: 1
  },
  place: {
    type: Object
  },
  position: {
    type: Object,
    twoWay: true
  },
  shape: {
    type: Object,
    twoWay: true
  },
  title: {
    type: String,
    twoWay: true
  },
  zIndex: {
    type: Number,
    twoWay: true
  },
  visible: {
    twoWay: true,
    default: true
  }
};

var events = ['click', 'rightclick', 'dblclick', 'drag', 'dragstart', 'dragend', 'mouseup', 'mousedown', 'mouseover', 'mouseout'];

/**
 * @class Marker
 *
 * Marker class with extra support for
 *
 * - Embedded info windows
 * - Clustered markers
 *
 * Support for clustered markers is for backward-compatability
 * reasons. Otherwise we should use a cluster-marker mixin or
 * subclass.
 */
exports.default = {
  mixins: [_mapElementMixin2.default, _getPropsValuesMixin2.default],
  props: props,

  render: function render(h) {
    if (!this.$slots.default || this.$slots.default.length == 0) {
      return '';
    } else if (this.$slots.default.length == 1) {
      // So that infowindows can have a marker parent
      return this.$slots.default[0];
    } else {
      return h('div', this.$slots.default);
    }
  },
  destroyed: function destroyed() {
    if (!this.$markerObject) return;

    if (this.$clusterObject) {
      this.$clusterObject.removeMarker(this.$markerObject);
    } else {
      this.$markerObject.setMap(null);
    }
  },
  deferredReady: function deferredReady() {
    var _this = this;

    var options = _lodash2.default.mapValues(props, function (value, prop) {
      return _this[prop];
    });
    options.map = this.$map;

    // search ancestors for cluster object
    var search = this.$findAncestor(function (ans) {
      return ans.$clusterObject;
    });

    this.$clusterObject = search ? search.$clusterObject : null;
    this.createMarker(options);
  },


  methods: {
    createMarker: function createMarker(options) {
      this.$markerObject = new google.maps.Marker(options);
      (0, _propsBinder2.default)(this, this.$markerObject, props);
      (0, _eventsBinder2.default)(this, this.$markerObject, events);

      if (this.$clusterObject) {
        this.$clusterObject.addMarker(this.$markerObject);
      }
    }
  }
};

/***/ }),
/* 2232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(472);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _lodash = __webpack_require__(9);

var _lodash2 = _interopRequireDefault(_lodash);

var _eventsBinder = __webpack_require__(69);

var _eventsBinder2 = _interopRequireDefault(_eventsBinder);

var _propsBinder = __webpack_require__(52);

var _propsBinder2 = _interopRequireDefault(_propsBinder);

var _mapElementMixin = __webpack_require__(76);

var _mapElementMixin2 = _interopRequireDefault(_mapElementMixin);

var _getPropsValuesMixin = __webpack_require__(64);

var _getPropsValuesMixin2 = _interopRequireDefault(_getPropsValuesMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  draggable: {
    type: Boolean
  },
  editable: {
    type: Boolean
  },
  options: {
    type: Object
  },
  path: {
    type: Array,
    twoWay: true
  },
  paths: {
    type: Array,
    twoWay: true
  },
  deepWatch: {
    type: Boolean,
    default: false
  }
};

var events = ['click', 'dblclick', 'drag', 'dragend', 'dragstart', 'mousedown', 'mousemove', 'mouseout', 'mouseover', 'mouseup', 'rightclick'];

exports.default = {
  mixins: [_mapElementMixin2.default, _getPropsValuesMixin2.default],
  props: props,

  render: function render() {
    return '';
  },
  destroyed: function destroyed() {
    if (this.$polygonObject) {
      this.$polygonObject.setMap(null);
    }
  },
  deferredReady: function deferredReady() {
    var _this = this;

    var options = _lodash2.default.clone(this.getPropsValues());
    delete options.options;
    _lodash2.default.assign(options, this.options);
    if (!options.path) {
      delete options.path;
    }
    if (!options.paths) {
      delete options.paths;
    }
    this.$polygonObject = new google.maps.Polygon(options);

    (0, _propsBinder2.default)(this, this.$polygonObject, _lodash2.default.omit(props, ['path', 'paths', 'deepWatch']));
    (0, _eventsBinder2.default)(this, this.$polygonObject, events);

    var clearEvents = function clearEvents() {};

    // Watch paths, on our own, because we do not want to set either when it is
    // empty
    this.$watch('paths', function (paths) {
      if (paths) {
        clearEvents();

        _this.$polygonObject.setPaths(paths);

        var updatePaths = function updatePaths() {
          _this.$emit('paths_changed', _this.$polygonObject.getPaths());
        };
        var eventListeners = [];

        var mvcArray = _this.$polygonObject.getPaths();
        for (var i = 0; i < mvcArray.getLength(); i++) {
          var mvcPath = mvcArray.getAt(i);
          eventListeners.push([mvcPath, mvcPath.addListener('insert_at', updatePaths)]);
          eventListeners.push([mvcPath, mvcPath.addListener('remove_at', updatePaths)]);
          eventListeners.push([mvcPath, mvcPath.addListener('set_at', updatePaths)]);
        }
        eventListeners.push([mvcArray, mvcArray.addListener('insert_at', updatePaths)]);
        eventListeners.push([mvcArray, mvcArray.addListener('remove_at', updatePaths)]);
        eventListeners.push([mvcArray, mvcArray.addListener('set_at', updatePaths)]);

        clearEvents = function clearEvents() {
          eventListeners.map(function (_ref) {
            var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
                obj = _ref2[0],
                listenerHandle = _ref2[1];

            return (// eslint-disable-line no-unused-vars
              google.maps.event.removeListener(listenerHandle)
            );
          });
        };
      }
    }, {
      deep: this.deepWatch,
      immediate: true
    });

    this.$watch('path', function (path) {
      if (path) {
        clearEvents();

        _this.$polygonObject.setPaths(path);

        var mvcPath = _this.$polygonObject.getPath();
        var eventListeners = [];

        var updatePaths = function updatePaths() {
          _this.$emit('path_changed', _this.$polygonObject.getPath());
        };

        eventListeners.push([mvcPath, mvcPath.addListener('insert_at', updatePaths)]);
        eventListeners.push([mvcPath, mvcPath.addListener('remove_at', updatePaths)]);
        eventListeners.push([mvcPath, mvcPath.addListener('set_at', updatePaths)]);

        clearEvents = function clearEvents() {
          eventListeners.map(function (_ref3) {
            var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
                obj = _ref4[0],
                listenerHandle = _ref4[1];

            return (// eslint-disable-line no-unused-vars
              google.maps.event.removeListener(listenerHandle)
            );
          });
        };
      }
    }, {
      deep: this.deepWatch,
      immediate: true
    });

    // Display the map
    this.$polygonObject.setMap(this.$map);
  }
};

/***/ }),
/* 2233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(472);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _lodash = __webpack_require__(9);

var _lodash2 = _interopRequireDefault(_lodash);

var _eventsBinder = __webpack_require__(69);

var _eventsBinder2 = _interopRequireDefault(_eventsBinder);

var _propsBinder = __webpack_require__(52);

var _propsBinder2 = _interopRequireDefault(_propsBinder);

var _mapElementMixin = __webpack_require__(76);

var _mapElementMixin2 = _interopRequireDefault(_mapElementMixin);

var _getPropsValuesMixin = __webpack_require__(64);

var _getPropsValuesMixin2 = _interopRequireDefault(_getPropsValuesMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  draggable: {
    type: Boolean
  },
  editable: {
    type: Boolean
  },
  options: {
    twoWay: false,
    type: Object
  },
  path: {
    type: Array,
    twoWay: true
  },
  deepWatch: {
    type: Boolean,
    default: false
  }
};

var events = ['click', 'dblclick', 'drag', 'dragend', 'dragstart', 'mousedown', 'mousemove', 'mouseout', 'mouseover', 'mouseup', 'rightclick'];

exports.default = {
  mixins: [_mapElementMixin2.default, _getPropsValuesMixin2.default],
  props: props,

  render: function render() {
    return '';
  },
  destroyed: function destroyed() {
    if (this.$polylineObject) {
      this.$polylineObject.setMap(null);
    }
  },
  deferredReady: function deferredReady() {
    var _this = this;

    var options = _lodash2.default.clone(this.getPropsValues());
    delete options.options;
    _lodash2.default.assign(options, this.options);
    this.$polylineObject = new google.maps.Polyline(options);
    this.$polylineObject.setMap(this.$map);

    (0, _propsBinder2.default)(this, this.$polylineObject, _lodash2.default.omit(props, ['deepWatch', 'path']));
    (0, _eventsBinder2.default)(this, this.$polylineObject, events);

    var clearEvents = function clearEvents() {};

    this.$watch('path', function (path) {
      if (path) {
        clearEvents();

        _this.$polylineObject.setPath(path);

        var mvcPath = _this.$polylineObject.getPath();
        var eventListeners = [];

        var updatePaths = function updatePaths() {
          _this.$emit('path_changed', _this.$polylineObject.getPath());
        };

        eventListeners.push([mvcPath, mvcPath.addListener('insert_at', updatePaths)]);
        eventListeners.push([mvcPath, mvcPath.addListener('remove_at', updatePaths)]);
        eventListeners.push([mvcPath, mvcPath.addListener('set_at', updatePaths)]);

        clearEvents = function clearEvents() {
          eventListeners.map(function (_ref) {
            var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
                obj = _ref2[0],
                listenerHandle = _ref2[1];

            return (// eslint-disable-line no-unused-vars
              google.maps.event.removeListener(listenerHandle)
            );
          });
        };
      }
    }, {
      deep: this.deepWatch
    });

    // Display the map
    this.$polylineObject.setMap(this.$map);
  }
};

/***/ }),
/* 2234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(9);

var _lodash2 = _interopRequireDefault(_lodash);

var _eventsBinder = __webpack_require__(69);

var _eventsBinder2 = _interopRequireDefault(_eventsBinder);

var _propsBinder = __webpack_require__(52);

var _propsBinder2 = _interopRequireDefault(_propsBinder);

var _mapElementMixin = __webpack_require__(76);

var _mapElementMixin2 = _interopRequireDefault(_mapElementMixin);

var _getPropsValuesMixin = __webpack_require__(64);

var _getPropsValuesMixin2 = _interopRequireDefault(_getPropsValuesMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  bounds: {
    type: Object,
    twoWay: true
  },
  draggable: {
    type: Boolean,
    default: false
  },
  editable: {
    type: Boolean,
    default: false
  },
  options: {
    type: Object,
    twoWay: false
  }
};

var events = ['click', 'dblclick', 'drag', 'dragend', 'dragstart', 'mousedown', 'mousemove', 'mouseout', 'mouseover', 'mouseup', 'rightclick'];

exports.default = {
  mixins: [_mapElementMixin2.default, _getPropsValuesMixin2.default],
  props: props,

  render: function render() {
    return '';
  },
  deferredReady: function deferredReady() {
    var options = _lodash2.default.clone(this.getPropsValues());
    options.map = this.$map;
    this.createRectangle(options);
  },


  methods: {
    createRectangle: function createRectangle(options) {
      this.$rectangleObject = new google.maps.Rectangle(options);
      (0, _propsBinder2.default)(this, this.$rectangleObject, props);
      (0, _eventsBinder2.default)(this, this.$rectangleObject, events);
    }
  },

  destroyed: function destroyed() {
    if (this.$rectangleObject) {
      this.$rectangleObject.setMap(null);
    }
  }
};

/***/ }),
/* 2235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2240), __esModule: true };

/***/ }),
/* 2236 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2241), __esModule: true };

/***/ }),
/* 2237 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2242), __esModule: true };

/***/ }),
/* 2238 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2244), __esModule: true };

/***/ }),
/* 2239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Symbol = __webpack_require__(2238)["default"];

exports["default"] = function (obj) {
  return obj && obj.constructor === _Symbol ? "symbol" : typeof obj;
};

exports.__esModule = true;

/***/ }),
/* 2240 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(233);
__webpack_require__(232);
module.exports = __webpack_require__(2272);

/***/ }),
/* 2241 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(233);
__webpack_require__(232);
module.exports = __webpack_require__(2273);

/***/ }),
/* 2242 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2275);
module.exports = __webpack_require__(65).Object.keys;

/***/ }),
/* 2243 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(478);
__webpack_require__(232);
__webpack_require__(233);
__webpack_require__(2276);
module.exports = __webpack_require__(65).Promise;

/***/ }),
/* 2244 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2277);
__webpack_require__(478);
module.exports = __webpack_require__(65).Symbol;

/***/ }),
/* 2245 */
/***/ (function(module, exports) {

module.exports = function(){ /* empty */ };

/***/ }),
/* 2246 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(160)
  , document = __webpack_require__(70).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 2247 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var $ = __webpack_require__(53);
module.exports = function(it){
  var keys       = $.getKeys(it)
    , getSymbols = $.getSymbols;
  if(getSymbols){
    var symbols = getSymbols(it)
      , isEnum  = $.isEnum
      , i       = 0
      , key;
    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))keys.push(key);
  }
  return keys;
};

/***/ }),
/* 2248 */
/***/ (function(module, exports, __webpack_require__) {

var ctx         = __webpack_require__(118)
  , call        = __webpack_require__(2255)
  , isArrayIter = __webpack_require__(2253)
  , anObject    = __webpack_require__(92)
  , toLength    = __webpack_require__(2270)
  , getIterFn   = __webpack_require__(477);
module.exports = function(iterable, entries, fn, that){
  var iterFn = getIterFn(iterable)
    , f      = ctx(fn, that, entries ? 2 : 1)
    , index  = 0
    , length, step, iterator;
  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
    entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
    call(iterator, f, step.value, entries);
  }
};

/***/ }),
/* 2249 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(162)
  , getNames  = __webpack_require__(53).getNames
  , toString  = {}.toString;

var windowNames = typeof window == 'object' && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function(it){
  try {
    return getNames(it);
  } catch(e){
    return windowNames.slice();
  }
};

module.exports.get = function getOwnPropertyNames(it){
  if(windowNames && toString.call(it) == '[object Window]')return getWindowNames(it);
  return getNames(toIObject(it));
};

/***/ }),
/* 2250 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(70).document && document.documentElement;

/***/ }),
/* 2251 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that){
  var un = that === undefined;
  switch(args.length){
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return              fn.apply(that, args);
};

/***/ }),
/* 2252 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(117);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 2253 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators  = __webpack_require__(100)
  , ITERATOR   = __webpack_require__(48)('iterator')
  , ArrayProto = Array.prototype;

module.exports = function(it){
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

/***/ }),
/* 2254 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(117);
module.exports = Array.isArray || function(arg){
  return cof(arg) == 'Array';
};

/***/ }),
/* 2255 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(92);
module.exports = function(iterator, fn, value, entries){
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch(e){
    var ret = iterator['return'];
    if(ret !== undefined)anObject(ret.call(iterator));
    throw e;
  }
};

/***/ }),
/* 2256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $              = __webpack_require__(53)
  , descriptor     = __webpack_require__(230)
  , setToStringTag = __webpack_require__(161)
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(228)(IteratorPrototype, __webpack_require__(48)('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = $.create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),
/* 2257 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR     = __webpack_require__(48)('iterator')
  , SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function(){ SAFE_CLOSING = true; };
  Array.from(riter, function(){ throw 2; });
} catch(e){ /* empty */ }

module.exports = function(exec, skipClosing){
  if(!skipClosing && !SAFE_CLOSING)return false;
  var safe = false;
  try {
    var arr  = [7]
      , iter = arr[ITERATOR]();
    iter.next = function(){ return {done: safe = true}; };
    arr[ITERATOR] = function(){ return iter; };
    exec(arr);
  } catch(e){ /* empty */ }
  return safe;
};

/***/ }),
/* 2258 */
/***/ (function(module, exports) {

module.exports = function(done, value){
  return {value: value, done: !!done};
};

/***/ }),
/* 2259 */
/***/ (function(module, exports, __webpack_require__) {

var $         = __webpack_require__(53)
  , toIObject = __webpack_require__(162);
module.exports = function(object, el){
  var O      = toIObject(object)
    , keys   = $.getKeys(O)
    , length = keys.length
    , index  = 0
    , key;
  while(length > index)if(O[key = keys[index++]] === el)return key;
};

/***/ }),
/* 2260 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(70)
  , macrotask = __webpack_require__(2269).set
  , Observer  = global.MutationObserver || global.WebKitMutationObserver
  , process   = global.process
  , Promise   = global.Promise
  , isNode    = __webpack_require__(117)(process) == 'process'
  , head, last, notify;

var flush = function(){
  var parent, domain, fn;
  if(isNode && (parent = process.domain)){
    process.domain = null;
    parent.exit();
  }
  while(head){
    domain = head.domain;
    fn     = head.fn;
    if(domain)domain.enter();
    fn(); // <- currently we use it only for Promise - try / catch not required
    if(domain)domain.exit();
    head = head.next;
  } last = undefined;
  if(parent)parent.enter();
};

// Node.js
if(isNode){
  notify = function(){
    process.nextTick(flush);
  };
// browsers with MutationObserver
} else if(Observer){
  var toggle = 1
    , node   = document.createTextNode('');
  new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
  notify = function(){
    node.data = toggle = -toggle;
  };
// environments with maybe non-completely correct, but existent Promise
} else if(Promise && Promise.resolve){
  notify = function(){
    Promise.resolve().then(flush);
  };
// for other environments - macrotask based on:
// - setImmediate
// - MessageChannel
// - window.postMessag
// - onreadystatechange
// - setTimeout
} else {
  notify = function(){
    // strange IE + webpack dev server bug - use .call(global)
    macrotask.call(global, flush);
  };
}

module.exports = function asap(fn){
  var task = {fn: fn, next: undefined, domain: isNode && process.domain};
  if(last)last.next = task;
  if(!head){
    head = task;
    notify();
  } last = task;
};

/***/ }),
/* 2261 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(159)
  , core    = __webpack_require__(65)
  , fails   = __webpack_require__(226);
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};

/***/ }),
/* 2262 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(231);
module.exports = function(target, src){
  for(var key in src)redefine(target, key, src[key]);
  return target;
};

/***/ }),
/* 2263 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y){
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

/***/ }),
/* 2264 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var getDesc  = __webpack_require__(53).getDesc
  , isObject = __webpack_require__(160)
  , anObject = __webpack_require__(92);
var check = function(O, proto){
  anObject(O);
  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function(test, buggy, set){
      try {
        set = __webpack_require__(118)(Function.call, getDesc(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch(e){ buggy = true; }
      return function setPrototypeOf(O, proto){
        check(O, proto);
        if(buggy)O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

/***/ }),
/* 2265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core        = __webpack_require__(65)
  , $           = __webpack_require__(53)
  , DESCRIPTORS = __webpack_require__(158)
  , SPECIES     = __webpack_require__(48)('species');

module.exports = function(KEY){
  var C = core[KEY];
  if(DESCRIPTORS && C && !C[SPECIES])$.setDesc(C, SPECIES, {
    configurable: true,
    get: function(){ return this; }
  });
};

/***/ }),
/* 2266 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject  = __webpack_require__(92)
  , aFunction = __webpack_require__(223)
  , SPECIES   = __webpack_require__(48)('species');
module.exports = function(O, D){
  var C = anObject(O).constructor, S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

/***/ }),
/* 2267 */
/***/ (function(module, exports) {

module.exports = function(it, Constructor, name){
  if(!(it instanceof Constructor))throw TypeError(name + ": use the 'new' operator!");
  return it;
};

/***/ }),
/* 2268 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(475)
  , defined   = __webpack_require__(225);
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),
/* 2269 */
/***/ (function(module, exports, __webpack_require__) {

var ctx                = __webpack_require__(118)
  , invoke             = __webpack_require__(2251)
  , html               = __webpack_require__(2250)
  , cel                = __webpack_require__(2246)
  , global             = __webpack_require__(70)
  , process            = global.process
  , setTask            = global.setImmediate
  , clearTask          = global.clearImmediate
  , MessageChannel     = global.MessageChannel
  , counter            = 0
  , queue              = {}
  , ONREADYSTATECHANGE = 'onreadystatechange'
  , defer, channel, port;
var run = function(){
  var id = +this;
  if(queue.hasOwnProperty(id)){
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listner = function(event){
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if(!setTask || !clearTask){
  setTask = function setImmediate(fn){
    var args = [], i = 1;
    while(arguments.length > i)args.push(arguments[i++]);
    queue[++counter] = function(){
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id){
    delete queue[id];
  };
  // Node.js 0.8-
  if(__webpack_require__(117)(process) == 'process'){
    defer = function(id){
      process.nextTick(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if(MessageChannel){
    channel = new MessageChannel;
    port    = channel.port2;
    channel.port1.onmessage = listner;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
    defer = function(id){
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listner, false);
  // IE8-
  } else if(ONREADYSTATECHANGE in cel('script')){
    defer = function(id){
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function(id){
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set:   setTask,
  clear: clearTask
};

/***/ }),
/* 2270 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(475)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 2271 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(225);
module.exports = function(it){
  return Object(defined(it));
};

/***/ }),
/* 2272 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(92)
  , get      = __webpack_require__(477);
module.exports = __webpack_require__(65).getIterator = function(it){
  var iterFn = get(it);
  if(typeof iterFn != 'function')throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};

/***/ }),
/* 2273 */
/***/ (function(module, exports, __webpack_require__) {

var classof   = __webpack_require__(224)
  , ITERATOR  = __webpack_require__(48)('iterator')
  , Iterators = __webpack_require__(100);
module.exports = __webpack_require__(65).isIterable = function(it){
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    || Iterators.hasOwnProperty(classof(O));
};

/***/ }),
/* 2274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(2245)
  , step             = __webpack_require__(2258)
  , Iterators        = __webpack_require__(100)
  , toIObject        = __webpack_require__(162);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(473)(Array, 'Array', function(iterated, kind){
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , kind  = this._k
    , index = this._i++;
  if(!O || index >= O.length){
    this._t = undefined;
    return step(1);
  }
  if(kind == 'keys'  )return step(0, index);
  if(kind == 'values')return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 2275 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(2271);

__webpack_require__(2261)('keys', function($keys){
  return function keys(it){
    return $keys(toObject(it));
  };
});

/***/ }),
/* 2276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $          = __webpack_require__(53)
  , LIBRARY    = __webpack_require__(229)
  , global     = __webpack_require__(70)
  , ctx        = __webpack_require__(118)
  , classof    = __webpack_require__(224)
  , $export    = __webpack_require__(159)
  , isObject   = __webpack_require__(160)
  , anObject   = __webpack_require__(92)
  , aFunction  = __webpack_require__(223)
  , strictNew  = __webpack_require__(2267)
  , forOf      = __webpack_require__(2248)
  , setProto   = __webpack_require__(2264).set
  , same       = __webpack_require__(2263)
  , SPECIES    = __webpack_require__(48)('species')
  , speciesConstructor = __webpack_require__(2266)
  , asap       = __webpack_require__(2260)
  , PROMISE    = 'Promise'
  , process    = global.process
  , isNode     = classof(process) == 'process'
  , P          = global[PROMISE]
  , empty      = function(){ /* empty */ }
  , Wrapper;

var testResolve = function(sub){
  var test = new P(empty), promise;
  if(sub)test.constructor = function(exec){
    exec(empty, empty);
  };
  (promise = P.resolve(test))['catch'](empty);
  return promise === test;
};

var USE_NATIVE = function(){
  var works = false;
  function P2(x){
    var self = new P(x);
    setProto(self, P2.prototype);
    return self;
  }
  try {
    works = P && P.resolve && testResolve();
    setProto(P2, P);
    P2.prototype = $.create(P.prototype, {constructor: {value: P2}});
    // actual Firefox has broken subclass support, test that
    if(!(P2.resolve(5).then(function(){}) instanceof P2)){
      works = false;
    }
    // actual V8 bug, https://code.google.com/p/v8/issues/detail?id=4162
    if(works && __webpack_require__(158)){
      var thenableThenGotten = false;
      P.resolve($.setDesc({}, 'then', {
        get: function(){ thenableThenGotten = true; }
      }));
      works = thenableThenGotten;
    }
  } catch(e){ works = false; }
  return works;
}();

// helpers
var sameConstructor = function(a, b){
  // library wrapper special case
  if(LIBRARY && a === P && b === Wrapper)return true;
  return same(a, b);
};
var getConstructor = function(C){
  var S = anObject(C)[SPECIES];
  return S != undefined ? S : C;
};
var isThenable = function(it){
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var PromiseCapability = function(C){
  var resolve, reject;
  this.promise = new C(function($$resolve, $$reject){
    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject  = $$reject;
  });
  this.resolve = aFunction(resolve),
  this.reject  = aFunction(reject)
};
var perform = function(exec){
  try {
    exec();
  } catch(e){
    return {error: e};
  }
};
var notify = function(record, isReject){
  if(record.n)return;
  record.n = true;
  var chain = record.c;
  asap(function(){
    var value = record.v
      , ok    = record.s == 1
      , i     = 0;
    var run = function(reaction){
      var handler = ok ? reaction.ok : reaction.fail
        , resolve = reaction.resolve
        , reject  = reaction.reject
        , result, then;
      try {
        if(handler){
          if(!ok)record.h = true;
          result = handler === true ? value : handler(value);
          if(result === reaction.promise){
            reject(TypeError('Promise-chain cycle'));
          } else if(then = isThenable(result)){
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch(e){
        reject(e);
      }
    };
    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
    chain.length = 0;
    record.n = false;
    if(isReject)setTimeout(function(){
      var promise = record.p
        , handler, console;
      if(isUnhandled(promise)){
        if(isNode){
          process.emit('unhandledRejection', value, promise);
        } else if(handler = global.onunhandledrejection){
          handler({promise: promise, reason: value});
        } else if((console = global.console) && console.error){
          console.error('Unhandled promise rejection', value);
        }
      } record.a = undefined;
    }, 1);
  });
};
var isUnhandled = function(promise){
  var record = promise._d
    , chain  = record.a || record.c
    , i      = 0
    , reaction;
  if(record.h)return false;
  while(chain.length > i){
    reaction = chain[i++];
    if(reaction.fail || !isUnhandled(reaction.promise))return false;
  } return true;
};
var $reject = function(value){
  var record = this;
  if(record.d)return;
  record.d = true;
  record = record.r || record; // unwrap
  record.v = value;
  record.s = 2;
  record.a = record.c.slice();
  notify(record, true);
};
var $resolve = function(value){
  var record = this
    , then;
  if(record.d)return;
  record.d = true;
  record = record.r || record; // unwrap
  try {
    if(record.p === value)throw TypeError("Promise can't be resolved itself");
    if(then = isThenable(value)){
      asap(function(){
        var wrapper = {r: record, d: false}; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch(e){
          $reject.call(wrapper, e);
        }
      });
    } else {
      record.v = value;
      record.s = 1;
      notify(record, false);
    }
  } catch(e){
    $reject.call({r: record, d: false}, e); // wrap
  }
};

// constructor polyfill
if(!USE_NATIVE){
  // 25.4.3.1 Promise(executor)
  P = function Promise(executor){
    aFunction(executor);
    var record = this._d = {
      p: strictNew(this, P, PROMISE),         // <- promise
      c: [],                                  // <- awaiting reactions
      a: undefined,                           // <- checked in isUnhandled reactions
      s: 0,                                   // <- state
      d: false,                               // <- done
      v: undefined,                           // <- value
      h: false,                               // <- handled rejection
      n: false                                // <- notify
    };
    try {
      executor(ctx($resolve, record, 1), ctx($reject, record, 1));
    } catch(err){
      $reject.call(record, err);
    }
  };
  __webpack_require__(2262)(P.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected){
      var reaction = new PromiseCapability(speciesConstructor(this, P))
        , promise  = reaction.promise
        , record   = this._d;
      reaction.ok   = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      record.c.push(reaction);
      if(record.a)record.a.push(reaction);
      if(record.s)notify(record, false);
      return promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function(onRejected){
      return this.then(undefined, onRejected);
    }
  });
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: P});
__webpack_require__(161)(P, PROMISE);
__webpack_require__(2265)(PROMISE);
Wrapper = __webpack_require__(65)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r){
    var capability = new PromiseCapability(this)
      , $$reject   = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (!USE_NATIVE || testResolve(true)), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x){
    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
    if(x instanceof P && sameConstructor(x.constructor, this))return x;
    var capability = new PromiseCapability(this)
      , $$resolve  = capability.resolve;
    $$resolve(x);
    return capability.promise;
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(2257)(function(iter){
  P.all(iter)['catch'](function(){});
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable){
    var C          = getConstructor(this)
      , capability = new PromiseCapability(C)
      , resolve    = capability.resolve
      , reject     = capability.reject
      , values     = [];
    var abrupt = perform(function(){
      forOf(iterable, false, values.push, values);
      var remaining = values.length
        , results   = Array(remaining);
      if(remaining)$.each.call(values, function(promise, index){
        var alreadyCalled = false;
        C.resolve(promise).then(function(value){
          if(alreadyCalled)return;
          alreadyCalled = true;
          results[index] = value;
          --remaining || resolve(results);
        }, reject);
      });
      else resolve(results);
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable){
    var C          = getConstructor(this)
      , capability = new PromiseCapability(C)
      , reject     = capability.reject;
    var abrupt = perform(function(){
      forOf(iterable, false, function(promise){
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  }
});

/***/ }),
/* 2277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var $              = __webpack_require__(53)
  , global         = __webpack_require__(70)
  , has            = __webpack_require__(227)
  , DESCRIPTORS    = __webpack_require__(158)
  , $export        = __webpack_require__(159)
  , redefine       = __webpack_require__(231)
  , $fails         = __webpack_require__(226)
  , shared         = __webpack_require__(474)
  , setToStringTag = __webpack_require__(161)
  , uid            = __webpack_require__(476)
  , wks            = __webpack_require__(48)
  , keyOf          = __webpack_require__(2259)
  , $names         = __webpack_require__(2249)
  , enumKeys       = __webpack_require__(2247)
  , isArray        = __webpack_require__(2254)
  , anObject       = __webpack_require__(92)
  , toIObject      = __webpack_require__(162)
  , createDesc     = __webpack_require__(230)
  , getDesc        = $.getDesc
  , setDesc        = $.setDesc
  , _create        = $.create
  , getNames       = $names.get
  , $Symbol        = global.Symbol
  , $JSON          = global.JSON
  , _stringify     = $JSON && $JSON.stringify
  , setter         = false
  , HIDDEN         = wks('_hidden')
  , isEnum         = $.isEnum
  , SymbolRegistry = shared('symbol-registry')
  , AllSymbols     = shared('symbols')
  , useNative      = typeof $Symbol == 'function'
  , ObjectProto    = Object.prototype;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function(){
  return _create(setDesc({}, 'a', {
    get: function(){ return setDesc(this, 'a', {value: 7}).a; }
  })).a != 7;
}) ? function(it, key, D){
  var protoDesc = getDesc(ObjectProto, key);
  if(protoDesc)delete ObjectProto[key];
  setDesc(it, key, D);
  if(protoDesc && it !== ObjectProto)setDesc(ObjectProto, key, protoDesc);
} : setDesc;

var wrap = function(tag){
  var sym = AllSymbols[tag] = _create($Symbol.prototype);
  sym._k = tag;
  DESCRIPTORS && setter && setSymbolDesc(ObjectProto, tag, {
    configurable: true,
    set: function(value){
      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    }
  });
  return sym;
};

var isSymbol = function(it){
  return typeof it == 'symbol';
};

var $defineProperty = function defineProperty(it, key, D){
  if(D && has(AllSymbols, key)){
    if(!D.enumerable){
      if(!has(it, HIDDEN))setDesc(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
      D = _create(D, {enumerable: createDesc(0, false)});
    } return setSymbolDesc(it, key, D);
  } return setDesc(it, key, D);
};
var $defineProperties = function defineProperties(it, P){
  anObject(it);
  var keys = enumKeys(P = toIObject(P))
    , i    = 0
    , l = keys.length
    , key;
  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P){
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key){
  var E = isEnum.call(this, key);
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key]
    ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
  var D = getDesc(it = toIObject(it), key);
  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it){
  var names  = getNames(toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i)if(!has(AllSymbols, key = names[i++]) && key != HIDDEN)result.push(key);
  return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
  var names  = getNames(toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i)if(has(AllSymbols, key = names[i++]))result.push(AllSymbols[key]);
  return result;
};
var $stringify = function stringify(it){
  if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
  var args = [it]
    , i    = 1
    , $$   = arguments
    , replacer, $replacer;
  while($$.length > i)args.push($$[i++]);
  replacer = args[1];
  if(typeof replacer == 'function')$replacer = replacer;
  if($replacer || !isArray(replacer))replacer = function(key, value){
    if($replacer)value = $replacer.call(this, key, value);
    if(!isSymbol(value))return value;
  };
  args[1] = replacer;
  return _stringify.apply($JSON, args);
};
var buggyJSON = $fails(function(){
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
});

// 19.4.1.1 Symbol([description])
if(!useNative){
  $Symbol = function Symbol(){
    if(isSymbol(this))throw TypeError('Symbol is not a constructor');
    return wrap(uid(arguments.length > 0 ? arguments[0] : undefined));
  };
  redefine($Symbol.prototype, 'toString', function toString(){
    return this._k;
  });

  isSymbol = function(it){
    return it instanceof $Symbol;
  };

  $.create     = $create;
  $.isEnum     = $propertyIsEnumerable;
  $.getDesc    = $getOwnPropertyDescriptor;
  $.setDesc    = $defineProperty;
  $.setDescs   = $defineProperties;
  $.getNames   = $names.get = $getOwnPropertyNames;
  $.getSymbols = $getOwnPropertySymbols;

  if(DESCRIPTORS && !__webpack_require__(229)){
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }
}

var symbolStatics = {
  // 19.4.2.1 Symbol.for(key)
  'for': function(key){
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key){
    return keyOf(SymbolRegistry, key);
  },
  useSetter: function(){ setter = true; },
  useSimple: function(){ setter = false; }
};
// 19.4.2.2 Symbol.hasInstance
// 19.4.2.3 Symbol.isConcatSpreadable
// 19.4.2.4 Symbol.iterator
// 19.4.2.6 Symbol.match
// 19.4.2.8 Symbol.replace
// 19.4.2.9 Symbol.search
// 19.4.2.10 Symbol.species
// 19.4.2.11 Symbol.split
// 19.4.2.12 Symbol.toPrimitive
// 19.4.2.13 Symbol.toStringTag
// 19.4.2.14 Symbol.unscopables
$.each.call((
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,' +
  'species,split,toPrimitive,toStringTag,unscopables'
).split(','), function(it){
  var sym = wks(it);
  symbolStatics[it] = useNative ? sym : wrap(sym);
});

setter = true;

$export($export.G + $export.W, {Symbol: $Symbol});

$export($export.S, 'Symbol', symbolStatics);

$export($export.S + $export.F * !useNative, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!useNative || buggyJSON), 'JSON', {stringify: $stringify});

// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 2278 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.vuexI18n = factory());
}(this, (function () { 'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

/* vuex-i18n-store defines a vuex module to store locale translations. Make sure
** to also include the file vuex-i18n.js to enable easy access to localized
** strings in your vue components.
*/

// define a simple vuex module to handle locale translations
var i18nVuexModule = {
	state: {
		locale: null,
		fallback: null,
		translations: {}
	},
	mutations: {

		// set the current locale
		SET_LOCALE: function SET_LOCALE(state, payload) {
			state.locale = payload.locale;
		},


		// add a new locale
		ADD_LOCALE: function ADD_LOCALE(state, payload) {
			// reduce the given translations to a single-depth tree
			var translations = flattenTranslations(payload.translations);
			state.translations[payload.locale] = translations;
		},


		// add a new locale
		REMOVE_LOCALE: function REMOVE_LOCALE(state, payload) {

			// check if the given locale is present in the state
			if (state.translations.hasOwnProperty(payload.locale)) {

				// check if the current locale is the given locale to remvoe
				if (state.locale === payload.locale) {
					// reset the current locale
					state.locale = null;
				}

				// create a copy of the translations object
				var translationCopy = Object.assign({}, state.translations);

				// remove the given locale
				delete translationCopy[payload.locale];

				// set the state to the new object
				state.translations = translationCopy;
			}
		},
		SET_FALLBACK_LOCALE: function SET_FALLBACK_LOCALE(state, payload) {
			state.fallback = payload.locale;
		}
	},
	actions: {

		// set the current locale
		setLocale: function setLocale(context, payload) {
			context.commit({
				type: 'SET_LOCALE',
				locale: payload.locale
			});
		},


		// add a new locale with translations
		addLocale: function addLocale(context, payload) {
			context.commit({
				type: 'ADD_LOCALE',
				locale: payload.locale,
				translations: payload.translations
			});
		},


		// remove the given locale translations
		removeLocale: function removeLocale(context, payload) {
			context.commit({
				type: 'REMOVE_LOCALE',
				locale: payload.locale,
				translations: payload.translations
			});
		},
		setFallbackLocale: function setFallbackLocale(context, payload) {
			context.commit({
				type: 'SET_FALLBACK_LOCALE',
				locale: payload.locale
			});
		}
	}
};

// flattenTranslations will convert object trees for translations into a
// single-depth object tree
var flattenTranslations = function flattenTranslations(translations) {

	var toReturn = {};

	for (var i in translations) {

		// check if the property is present
		if (!translations.hasOwnProperty(i)) {
			continue;
		}

		// get the type of the property
		var objType = _typeof(translations[i]);

		// allow unflattened array of strings
		if (isArray(translations[i])) {

			var count = translations[i].length;

			for (var index = 0; index < count; index++) {
				var itemType = _typeof(translations[i][index]);

				if (itemType !== 'string') {
					console.warn('vuex-i18n:', 'currently only arrays of strings are fully supported', translations[i]);
					break;
				}
			}

			toReturn[i] = translations[i];
		} else if (objType == 'object' && objType !== null) {

			var flatObject = flattenTranslations(translations[i]);

			for (var x in flatObject) {
				if (!flatObject.hasOwnProperty(x)) continue;

				toReturn[i + '.' + x] = flatObject[x];
			}
		} else {
			toReturn[i] = translations[i];
		}
	}
	return toReturn;
};

// check if the given object is an array
function isArray(obj) {
	return !!obj && Array === obj.constructor;
}

/* vuex-i18n defines the Vuexi18nPlugin to enable localization using a vuex
** module to store the translation information. Make sure to also include the
** file vuex-i18n-store.js to include a respective vuex module.
*/

// initialize the plugin object
var VuexI18nPlugin = {};

// internationalization plugin for vue js using vuex
VuexI18nPlugin.install = function install(Vue, store) {
	var moduleName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'i18n';


	store.registerModule(moduleName, i18nVuexModule);

	// check if the plugin was correctly initialized
	if (store.state.hasOwnProperty(moduleName) === false) {
		console.error('i18n vuex module is not correctly initialized. Please check the module name:', moduleName);

		// always return the key if module is not initialized correctly
		Vue.prototype.$i18n = function (key) {
			return key;
		};

		Vue.prototype.$getLanguage = function () {
			return null;
		};

		Vue.prototype.$setLanguage = function () {
			console.error('i18n vuex module is not correctly initialized');
		};

		return;
	}

	// get localized string from store
	var translate = function $t(key, options, pluralization) {

		// get the current language from the store
		var locale = store.state[moduleName].locale;

		return translateInLanguage(locale, key, options, pluralization);
	};

	// get localized string from store in a given language if available
	var translateInLanguage = function translateInLanguage(locale, key, options, pluralization) {

		// get the current language from the store
		var fallback = store.state[moduleName].fallback;
		var translations = store.state[moduleName].translations;

		// flag for translation to exist or not
		var translationExist = true;

		// check if the language exists in the store. return the key if not
		if (translations.hasOwnProperty(locale) === false) {
			translationExist = false;

			// check if the key exists in the store. return the key if not
		} else if (translations[locale].hasOwnProperty(key) === false) {
			translationExist = false;
		}

		// return the value from the store
		if (translationExist === true) {
			return render(translations[locale][key], options, pluralization);
		}

		// check if a vaild fallback exists in the store. return the key if not
		if (translations.hasOwnProperty(fallback) === false) {
			return render(key, options, pluralization);
		}

		// check if the key exists in the fallback in the store. return the key if not
		if (translations[fallback].hasOwnProperty(key) === false) {
			return render(key, options, pluralization);
		}

		return render(translations[fallback][key], options, pluralization);
	};

	// set fallback locale
	var setFallbackLocale = function setFallbackLocale(locale) {
		store.dispatch({
			type: 'setFallbackLocale',
			locale: locale
		});
	};

	var setLocale = function setLocale(locale) {
		store.dispatch({
			type: 'setLocale',
			locale: locale
		});
	};

	var getLocale = function getLocale() {
		return store.state[moduleName].locale;
	};

	// add predefined translations to the store
	var addLocale = function addLocale(locale, translations) {
		return store.dispatch({
			type: 'addLocale',
			locale: locale,
			translations: translations
		});
	};

	// remove the givne locale from the store
	var removeLocale = function removeLocale(locale) {
		if (store.state[moduleName].translations.hasOwnProperty(locale)) {
			store.dispatch({
				type: 'removeLocale',
				locale: locale
			});
		}
	};

	// check if the given locale is already loaded
	var checkLocaleExists = function checkLocaleExists(locale) {
		return store.state[moduleName].translations.hasOwnProperty(locale);
	};

	// register vue prototype methods
	Vue.prototype.$i18n = {
		locale: getLocale,
		set: setLocale,
		add: addLocale,
		remove: removeLocale,
		fallback: setFallbackLocale,
		exists: checkLocaleExists
	};

	// register global methods
	Vue.i18n = {
		locale: getLocale,
		set: setLocale,
		add: addLocale,
		remove: removeLocale,
		fallback: setFallbackLocale,
		exists: checkLocaleExists,
		translate: translate,
		translateIn: translateInLanguage
	};

	// register the translation function on the vue instance
	Vue.prototype.$t = translate;

	// register the specific language translation function on the vue instance
	Vue.prototype.$tlang = translateInLanguage;

	// register a filter function for translations
	Vue.filter('translate', translate);
};

// replace will replace the given replacements in the translation string
var replace = function replace(translation, replacements) {
	var warn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;


	// check if the object has a replace property
	if (!translation.replace) {
		return translation;
	}

	return translation.replace(/\{\w+\}/g, function (placeholder) {

		var key = placeholder.replace('{', '').replace('}', '');

		if (replacements[key] !== undefined) {
			return replacements[key];
		}

		// warn user that the placeholder has not been found
		if (warn === true) {
			console.group('Not all placeholder founds');
			console.warn('Text:', translation);
			console.warn('Placeholder:', placeholder);
			console.groupEnd();
		}

		// return the original placeholder
		return placeholder;
	});
};

// render will return the given translation object
var render = function render(translation) {
	var replacements = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	var pluralization = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;


	// get the type of the property
	var objType = typeof translation === 'undefined' ? 'undefined' : _typeof(translation);
	var pluralizationType = typeof pluralization === 'undefined' ? 'undefined' : _typeof(pluralization);

	var replacedText = function replacedText() {

		if (isArray$1(translation)) {

			// replace the placeholder elements in all sub-items
			return translation.map(function (item) {
				return replace(item, replacements, false);
			});
		} else if (objType === 'string') {
			return replace(translation, replacements);
		}
	};

	// return translation item directly
	if (pluralization === null) {
		return replacedText();
	}

	// check if pluralization value is countable
	if (pluralizationType !== 'number') {
		console.warn('pluralization is not a number');
		return replacedText();
	}

	// check for pluralization and return the correct part of the string
	var translatedText = replacedText().split(':::');

	// return the left side on singular, the right side for plural
	// 0 has plural notation
	if (pluralization === 1) {
		return translatedText[0].trim();
	}

	// use singular version for -1 as well
	if (pluralization === -1) {
		return translatedText[0].trim();
	}

	if (translatedText.length > 1) {
		return translatedText[1].trim();
	}

	console.warn('no pluralized translation provided in ', translation);
	return translatedText[0].trim();
};

// check if the given object is an array
function isArray$1(obj) {
	return !!obj && Array === obj.constructor;
}

// import the vuex module for localization
// import the corresponding plugin for vue
// export both modules as one file
var index = {
	store: i18nVuexModule,
	plugin: VuexI18nPlugin
};

return index;

})));


/***/ }),
/* 2279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (parseString);

var NEUTRAL = 1;
var KEYWORD = 2;
var NUMBER = 3;
var QUOTED = 4;
var AFTERQUOTE = 5;
var ENDED = -1;
var whitespace = /\s/;
var latin = /[A-Za-z]/;
var keyword = /[A-Za-z84]/;
var endThings = /[,\]]/;
var digets = /[\d\.E\-\+]/;
// const ignoredChar = /[\s_\-\/\(\)]/g;
function Parser(text) {
  if (typeof text !== 'string') {
    throw new Error('not a string');
  }
  this.text = text.trim();
  this.level = 0;
  this.place = 0;
  this.root = null;
  this.stack = [];
  this.currentObject = null;
  this.state = NEUTRAL;
}
Parser.prototype.readCharicter = function() {
  var char = this.text[this.place++];
  if (this.state !== QUOTED) {
    while (whitespace.test(char)) {
      if (this.place >= this.text.length) {
        return;
      }
      char = this.text[this.place++];
    }
  }
  switch (this.state) {
    case NEUTRAL:
      return this.neutral(char);
    case KEYWORD:
      return this.keyword(char)
    case QUOTED:
      return this.quoted(char);
    case AFTERQUOTE:
      return this.afterquote(char);
    case NUMBER:
      return this.number(char);
    case ENDED:
      return;
  }
};
Parser.prototype.afterquote = function(char) {
  if (char === '"') {
    this.word += '"';
    this.state = QUOTED;
    return;
  }
  if (endThings.test(char)) {
    this.word = this.word.trim();
    this.afterItem(char);
    return;
  }
  throw new Error('havn\'t handled "' +char + '" in afterquote yet, index ' + this.place);
};
Parser.prototype.afterItem = function(char) {
  if (char === ',') {
    if (this.word !== null) {
      this.currentObject.push(this.word);
    }
    this.word = null;
    this.state = NEUTRAL;
    return;
  }
  if (char === ']') {
    this.level--;
    if (this.word !== null) {
      this.currentObject.push(this.word);
      this.word = null;
    }
    this.state = NEUTRAL;
    this.currentObject = this.stack.pop();
    if (!this.currentObject) {
      this.state = ENDED;
    }

    return;
  }
};
Parser.prototype.number = function(char) {
  if (digets.test(char)) {
    this.word += char;
    return;
  }
  if (endThings.test(char)) {
    this.word = parseFloat(this.word);
    this.afterItem(char);
    return;
  }
  throw new Error('havn\'t handled "' +char + '" in number yet, index ' + this.place);
};
Parser.prototype.quoted = function(char) {
  if (char === '"') {
    this.state = AFTERQUOTE;
    return;
  }
  this.word += char;
  return;
};
Parser.prototype.keyword = function(char) {
  if (keyword.test(char)) {
    this.word += char;
    return;
  }
  if (char === '[') {
    var newObjects = [];
    newObjects.push(this.word);
    this.level++;
    if (this.root === null) {
      this.root = newObjects;
    } else {
      this.currentObject.push(newObjects);
    }
    this.stack.push(this.currentObject);
    this.currentObject = newObjects;
    this.state = NEUTRAL;
    return;
  }
  if (endThings.test(char)) {
    this.afterItem(char);
    return;
  }
  throw new Error('havn\'t handled "' +char + '" in keyword yet, index ' + this.place);
};
Parser.prototype.neutral = function(char) {
  if (latin.test(char)) {
    this.word = char;
    this.state = KEYWORD;
    return;
  }
  if (char === '"') {
    this.word = '';
    this.state = QUOTED;
    return;
  }
  if (digets.test(char)) {
    this.word = char;
    this.state = NUMBER;
    return;
  }
  if (endThings.test(char)) {
    this.afterItem(char);
    return;
  }
  throw new Error('havn\'t handled "' +char + '" in neutral yet, index ' + this.place);
};
Parser.prototype.output = function() {
  while (this.place < this.text.length) {
    this.readCharicter();
  }
  if (this.state === ENDED) {
    return this.root;
  }
  throw new Error('unable to parse string "' +this.text + '". State is ' + this.state);
};

function parseString(txt) {
  var parser = new Parser(txt);
  return parser.output();
}


/***/ }),
/* 2280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sExpr;


function mapit(obj, key, value) {
  if (Array.isArray(key)) {
    value.unshift(key);
    key = null;
  }
  var thing = key ? {} : obj;

  var out = value.reduce(function(newObj, item) {
    sExpr(item, newObj);
    return newObj
  }, thing);
  if (key) {
    obj[key] = out;
  }
}

function sExpr(v, obj) {
  if (!Array.isArray(v)) {
    obj[v] = true;
    return;
  }
  var key = v.shift();
  if (key === 'PARAMETER') {
    key = v.shift();
  }
  if (v.length === 1) {
    if (Array.isArray(v[0])) {
      obj[key] = {};
      sExpr(v[0], obj[key]);
      return;
    }
    obj[key] = v[0];
    return;
  }
  if (!v.length) {
    obj[key] = true;
    return;
  }
  if (key === 'TOWGS84') {
    obj[key] = v;
    return;
  }
  if (!Array.isArray(key)) {
    obj[key] = {};
  }

  var i;
  switch (key) {
    case 'UNIT':
    case 'PRIMEM':
    case 'VERT_DATUM':
      obj[key] = {
        name: v[0].toLowerCase(),
        convert: v[1]
      };
      if (v.length === 3) {
        sExpr(v[2], obj[key]);
      }
      return;
    case 'SPHEROID':
    case 'ELLIPSOID':
      obj[key] = {
        name: v[0],
        a: v[1],
        rf: v[2]
      };
      if (v.length === 4) {
        sExpr(v[3], obj[key]);
      }
      return;
    case 'PROJECTEDCRS':
    case 'PROJCRS':
    case 'GEOGCS':
    case 'GEOCCS':
    case 'PROJCS':
    case 'LOCAL_CS':
    case 'GEODCRS':
    case 'GEODETICCRS':
    case 'GEODETICDATUM':
    case 'EDATUM':
    case 'ENGINEERINGDATUM':
    case 'VERT_CS':
    case 'VERTCRS':
    case 'VERTICALCRS':
    case 'COMPD_CS':
    case 'COMPOUNDCRS':
    case 'ENGINEERINGCRS':
    case 'ENGCRS':
    case 'FITTED_CS':
    case 'LOCAL_DATUM':
    case 'DATUM':
      v[0] = ['name', v[0]];
      mapit(obj, key, v);
      return;
    default:
      i = -1;
      while (++i < v.length) {
        if (!Array.isArray(v[i])) {
          return sExpr(v, obj[key]);
        }
      }
      return mapit(obj, key, v);
  }
}


/***/ }),
/* 2281 */
/***/ (function(module, exports) {

module.exports = {
	"A_BdE_homologated_company": "Societat Homologada pel Banco de España",
	"About_BARNATASA": "About BARNA-TASA, S.A.",
	"About_text_01": "BARNA-TASA és una Societat de Taxació Homologada pel Banco de España, inscrita en el Registre Oficial d'Entitats de Taxació amb el nº 4.470 i data d'inscripció 26 de juny de 1.995",
	"About_text_02": "La societat està formada per un grup d'arquitectes, enginyers i especialistes en el camp de la valoració i taxació immobiliàries i un ampli coneixemnt del sector, amb més de 30 anys de trajectòria",
	"About_us": "Sobre nosaltres",
	"acc_Budget": "s/ Pressupost",
	"acc_appraisal_date": "s/ data de taxació",
	"Actions": "Accions",
	"Ad": "Anunci",
	"Ad_address": "Adreça tal i com apareix a l'anunci",
	"Ad_code": "Codi de l'anunci",
	"Ad_data_type": "Tipus de dades",
	"Ad_database_query": "Consulta d'anuncis a la base de dades",
	"Ad_date": "Data de l'anunci",
	"Ad_type": "Tipus d'anunci",
	"Ads": "Anuncis",
	"Adaptability": "Adaptabilitat",
	"Add_address": "Afegir adreça",
	"Add_appraisal": "Afegir taxació",
	"Add_appraisal_file": "Afegir expedient de taxació",
	"Add_appraisal_report": "Afegir informe de taxació",
	"Add_contact": "Afegir contacte",
	"Add_entity": "Afegir entitat",
	"Add_email": "Afegir e-mail",
	"Add_market_study": "Afegir estudi de mercat",
	"Add_real_estate": "Afegir immoble",
	"Add_room": "Afegir estança",
	"Add_telephone_number": "Afegir nº de telèfon",
	"Add_to_comparables_list": "Afegir a la llista de comparables",
	"Address": "Adreça",
	"Address_description": "Descripció de l'adreça",
	"Addresses": "Adreces",
	"Adjusted_Comparison_Method": "Mètode de Comparació Ajustat",
	"Adopted_age": "Antiguitat considerada",
	"Adopted_area": "Superfície adoptada",
	"Adopted_building_market_value": "Valor de mercat de l'edificació adoptat",
	"Adopted_material_execution_cost": "Cost d'execució material adoptat",
	"Adopted_material_execution_cost_deprecated_by_antiquity": "Cost d'execució material adoptat depreciat per antiguitat",
	"Adopted_value": "Valor adoptat",
	"Age": "Antiguitat",
	"Agravation_or_improvement_coeficient": "Coeficient d'agreujament o millora",
	"Air_conditioning": "Aire acondicionat",
	"and": "i",
	"and_limit_date": "i la data límit",
	"annexes": "annexes",
	"Annexes": "Annexes",
	"Addressing_title": "Títol de tractament",
	"Advertisements_between_starting_date": "Anuncis entre la data d'inici",
	"appraisal": "taxació",
	"Appraisal": "Taxació",
	"appraisal_company": "societat de taxació",
	"appraisal_file": "expedient de taxació",
	"Appraisal_date": "Data de taxació",
	"Appraisal_description": "Descripció de la taxació",
	"Appraisal_file": "Expedient de taxació",
	"Appraisal_files": "Expedients de taxació",
	"Appraisal_file_description": "Descripció de l'expedient de taxació",
	"Appraisal_files_index": "Índex d'expedients de taxació",
	"appraisal_report": "informe de taxació",
	"Appraisal_report": "Informe de taxació",
	"Appraisal_report_description": "Descripció de l'informe de taxació",
	"Appraisal_reports": "Informes de taxació",
	"Appraisal_petitioner": "Sol·licitant de taxació",
	"Appraisal_petitioners": "Sol·licitants de taxació",
	"Appraisal_purpose": "Finalitat de la taxació",
	"Appraisal_Requests": "Sol·licituds de taxació",
	"Appraisal_total_value_determination": "Determinació del valor total de taxació",
	"Appraisal_type": "Tipus de taxació",
	"Appraisal_value": "Valor de taxació",
	"Appraisals": "Taxacions",
	"Appraisals_and_valuations": "Taxacions i valoracions",
	"Appraisals_Index": "Índex de Taxacions",
	"Appraisals_for_all_purposes": "Taxacions per a totes les finalitats",
	"Appraisals_of_the_Real_Estate": "Taxacions de l'Immoble",
	"Appraised": "Taxat",
	"Appraised_real_estates": "Immobles taxats",
	"Appraised_real_estates_in_this_report": "Immobles taxats en aquest informe",
	"Appraised_real_estate": "Immoble taxat",
	"Appraiser": "Taxador",
	"Approximate_property_area": "Superfície aproximada de l'immoble",
	"Are_you_sure_q": "N'estàs segur?",
	"Area": "Superfície",
	"Areas": "Superfícies",
	"areas": "superfícies",
	"As_new_construction_cost": "Cost de construcció a nou",
	"Assets_value_update": "Actualització del valor de patrimonis",
	"Assurance": "Garantia",
	"at": "a",
	"Auditors": "Auditors",
	"average": "mitjana",
	"Average": "Mitjana",
	"Back_home": "Tornar a l'inici",
	"Back_to_safety": "Tornar a un lloc segur",
	"Bare_ownership": "Nua propietat",
	"Bare_ownership_value": "Valor de la nua propietat",
	"Barnatasa_cover_short_description": "Societat Especialitzada en Valoracions i Taxacions",
	"Barnatasa_header": "BARNA-TASA, S.A. Societat inscrita al Registre Oficial d'Entitats de Taxació amb el número 4.470. Data d'inscripció a Banco de España: 26/06/1.995",
	"Barnatasa_footer": "Fi de pàgina. Dors no utilitzable. Qualsevol anotació en el mateix és nul·la i sense cap efecte.",
	"Barnatasa_header_portrait": "Societat inscrita al Registre Oficial d'Entitats de Taxació amb el nº 4.460. Data d'inscripció a Banco de España 26/06/1995. Reg. Merc. Barcelona, Foli 12, Volum 28.173, Full B-132.666, NIF A-60840543",
	"Bathrooms": "Banys",
	"Bathrooms_number": "nº de Banys",
	"BdE_code": "codi BdE",
	"Bedrooms": "Dormitoris",
	"Bedrooms_number": "nº de Dormitoris",
	"Block": "Bloc",
	"Building_surveys": "Aixecaments de plànols",
	"Budget_request": "Sol·licitud de pressupost",
	"Builders_general_expenses_percentage": "Percentatge despeses generals del constructor",
	"Builders_general_expenses": "Despeses generals del constructor",
	"Builders_expenses_and_benefit_percentage": "Percentatge de Despeses + Benefici del constructor",
	"Builders_expenses_and_benefit": "Despeses + Benefici del constructor",
	"Builders_industrial_benefit_percentage": "Percentatge del benefici industrial tipus del constructor",
	"Builders_industrial_benefit": "Benefici industrial del constructor",
	"Building_market_value": "Valor de mercat de l'edificació",
	"real_estate_under_construction": "immoble en construcció",
	"Buildings": "Edificis",
	"Buildings_useful_life": "Vida útil de l'edifici",
	"Built_area": "Superfície construïda",
	"by": "per",
	"By": "Per",
	"Cadastral_area": "Superfície Cadastral",
	"Cadastral_data": "Dades cadastrals",
	"Cadastral_data_check": "Comprovació Cadastre",
	"Cadastral_List": "Llistat del Cadastre",
	"Cadastral_Map": "Mapa del Cadastre",
	"Cadastral_reference": "Referència cadastral",
	"Cadastral_Reference_less_20_positions_error_text": "La Referència Cadastral té menys de 20 posicions",
	"Calculate_values": "Calcular valors",
	"Calendar": "Calendari",
	"Cancel": "Cancel·lar",
	"Capture_date": "Data de captura",
	"Catalan": "Català",
	"Census_section": "Secció censal",
	"Census_section_code": "Codi de secció censal",
	"certificates": "certificats",
	"cession": "cessió",
	"Cession": "Cessió",
	"Cession_contract_period_years": "Duració del contracte (anys)",
	"Cession_contract_remaining_years": "Anys restants de contracte",
	"Cession_contract_start_date": "Data d'inici del contracte",
	"Cession_gross_monthly_income": "Renda bruta mensual actual",
	"Cession_gross_yearly_income": "Renda bruta anual actual",
	"Cession_gross_monthly_income_by_contract": "Renda bruta mensual de contracte",
	"Cession_gross_yearly_income_by_contract": "Renda bruta anual de contracte",
	"Cession_net_yearly_income": "Renda neta anual",
	"Clients_text_01": "BARNA-TASA, S.A. disposa d'una àmplia cartera de clients i treballa amb tot tipus de clients de l'àmbit privat i públic. A destacar",
	"Clients_text_02": "BARNA-TASA S.A. ofereix una àmplia gama de serveis destinats a ajudar en la presa de decisions relatives a la valoració i comprovació de l'estat d'immobles i altres béns",
	"Clients_text_03": "L'objectiu de BARNA-TASA S.A. és recolzar als clients dels millors despatxos d'advocats i auditors nacionals i internacionals, en aquelles operacions que requereixin una valoració immobiliaria. Des d'una valoració per a un procés d'expropiació, fins a les valoracions necessàries en operacions de fusió i adquisició, assessorament en desinversió d'actius i reestructuracions, abarcant tots els sectors",
	"Clients_text_04": "Un entorn empresarial com l'actual genera a les empreses la necessitat d'emprendre projectes complexos i, alhora, decisius en el seu dia a dia. Coneixedora d'aquesta circumstància, BARNA-TAXA S.A. posa la seva experiència, professionalitat i coneixement del mercat, a disposició de petites-grans empreses i entitats financeres en un ampli ventall de serveis, garantint un tracte personalitzat i professional",
	"closed": "tancat",
	"Changes_will_be_lost_p_continue_q": "Es perdran els canvis. Continuar?",
	"Checks": "Comprovacions",
	"Checks_performed": "Comprovacions realitzades",
	"Code": "Codi",
	"Commercial_premises": "Locals comercials",
	"Commission": "Encàrrec",
	"Commitment": "Compromís",
	"Company_code": "Codi de Societat",
	"Company_or_business_name": "Empresa o raó social",
	"Comparable_database_query": "Consulta de comparables a la base de dades",
	"Comparable_type": "Tipus de comparable",
	"comparables": "comparables",
	"Comparables": "Comparables",
	"Comparison_Method": "Mètode de Comparació",
	"Confidentiality": "Confidencialitat",
	"Confirm_Password": "Confirmar Contrassenya",
	"Conservation": "Conservació",
	"Conservation_status": "Estat de conservació",
	"Constant_income_with_CPI_update_clause": "Renda constant amb clàusula d'actualització de l'IPC",
	"construction": "construcció",
	"Construction": "Construcció",
	"Construction_cost": "Cost de construcció",
	"Construction_cost_by_contract": "Cost de construcció per contracta",
	"Construction_cost_and_development_expenses": "Cost de construcció i despeses de promoció",
	"Construction_costs": "Costos de construcció",
	"Construction_progress_percentage": "Percentatge de construcció realitzada",
	"Construction_replacement_cost": "Cost de reposició de la construcció",
	"Construction_value": "Valor de la construcció",
	"construction_year": "any de construcció",
	"Construction_year": "Any de construcció",
	"Contact": "Contacte",
	"Contact_data": "Dades de contacte",
	"Contact_Data": "Dades del Contacte",
	"Contact_file": "Fitxa del contacte",
	"Contact_name": "Nom del contacte",
	"Contact_telephone": "Telèfon de contacte",
	"Contacts": "Contactes",
	"Contacts_Index": "Índex de Contactes",
	"contained_in_this_file": "continguts en aquest expedient",
	"contained_in_this_file_f": "contingudes en aquest expedient",
	"Continue_q": "Continuar?",
	"Contracts_foreseeable_remaining_period": "Duració restant previsible de contracte",
	"Cooperatives": "Cooperatives",
	"Corrected_market_value": "Valor de mercat corregit",
	"Corrected_unit_market_value": "Valor unitari corregit",
	"Correction": "Correcció",
	"Correction_of_values": "Correcció de valors",
	"Cost_method": "Mètode del cost",
	"Council_classification": "Classificació Ajuntament",
	"Council_classification_description": "Descripció Classificació Ajuntament",
	"Council_qualification": "Qualificació Ajuntament",
	"Council_qualification_description": "Descripció Qualificació Ajuntament",
	"Regional_classification": "Classificació MUC",
	"Regional_classification_description": "Descripció Classificació MUC",
	"Regional_qualification": "Qualificació MUC",
	"Regional_qualification_description": "Descripció Qualificació MUC",
	"Country": "País",
	"Country_s_State": "País / Estat",
	"Covered_outdoor_area": "Superfícies exteriors cobertes",
	"Create_a_new_contact": "Crear un nou contacte",
	"Created": "Creat",
	"Creation": "Creació",
	"Current_reversion_value_calculation": "Càlcul del valor actual de reversió",
	"Current_value_of_future_rents": "Valor actual de rendes futures",
	"Customer_Service": "Servei d'Atenció al Client",
	"Customer_Service_text_01": "posa a disposició dels seus clients el seu",
	"Customer_Service_text_02": "al que els seus clients poden dirigir les queixes, suggerències i reclamacions relacionades amb el servei donat per la Societat",
	"Customer_Service_text_03": "Les funcions del SAC són",
	"Customer_Service_text_04": "Atendre i resoldre les queixes, reclamacions i consultes presentades, directa o mitjançant representació, via persones físiques o jurídiques, nacionals o extrangeres, clients de la Societat, quan aquestes es refereixin a interessos o drets legalment reconeguts relacionats amb operacions, contractes o serveis donats per l'empresa, tant si deriven dels propis contractes, de la normativa de transparencia i protecció de la clientela o de les bones pràctiques i usos, en particular del principi d'equitat",
	"Customer_Service_text_05": "Fer arribar a la direcció de l'empresa les recomanacions i suggerències sobre tots aquells aspectes que, en la seva opinió, suposin un enfortiment de les bones relacions i mútua confiança que ha d'existir entre l'empresa i els seus clients",
	"Customer_Service_text_06": "Els deures d'informació del SAC queden recollits a la legislació vigent Ordre ECO/734/2004, de 11 de març, sobre els departaments i serveis d'atenció al client de les entitats financeres",
	"Customer_Service_text_07": "Accés al Reglament del Servei d'Atenció al Client de BARNA-TASA, S.A.",
	"Customer_Service_text_08": "Accés al full de reclamacions",
	"Customer_Service_text_09": "Legislació aplicable per a la defensa del client de serveis financers",
	"Customer_Service_text_10": "Llei 2/2011 de 4 de març d'Economia Sostenible",
	"Customer_Service_text_11": "Ordre ECC/2502/2012 de 16 de novembre, a través de la qual es regula el procediment de presentació de reclamacions davant dels serveis de reclamacions del Banco de España, la Comissió Nacional del Mercat de Valors i la Direcció General d'Assegurances i Fons de Pensions",
	"Customer_Service_text_12": "Ordre ECO/734/2004. De 11 de març, sobre els departaments i serveis d'atenció al client i el defensor del client de les entitats financeres",
	"Customer_Service_text_13": "Pot contactar amb nosaltres a través dels següents mitjans",
	"Customer_Service_text_14": "En persona, a l'oficina d'atenció al públic del Servei d'Atenció al Client (de 10h a 13h i de 16h a 19h). Adreça",
	"Customer_Service_text_15": "Per correu certificat dirigit a",
	"Customer_Service_text_16": "Posem a disposició dels clients un formulari de queixes i reclamacions, que trobarà en aquest",
	"Customer_Service_text_17": "El formulari és de caràcter voluntari i haurà de incloure la següent informació",
	"Customer_Service_text_18": "Nom i cognoms de l'interessat",
	"Customer_Service_text_19": "Domicili de l'interessat (i si fós el cas, de la persona que el representi)",
	"Customer_Service_text_20": "Per a persones físiques: el NIF de l'interessat",
	"Customer_Service_text_21": "Per a persones jurídiques: el CIF i les dades de registre mercantil",
	"Customer_Service_text_22": "Motiu de la queixa, especificant amb claredat les qüestions sobre les que es sol·licita un pronunciament",
	"Customer_Service_text_23": "Nº d'expedient de taxació",
	"Customer_Service_text_24": "Lloc, data i firma",
	"Customer_Service_text_25": "Proves documentals (donat el cas)",
	"Customer_Service_text_26": "En el cas d'haver-se esgotat les vies disponibles a través del Departament d'Atenció al Client (haver-se denegat, desestimat o haver transcorregut més de dos mesos sense resolució), es podrà presentar una reclamació al Departamento de Conducta de Mercado y Reclamaciones del Banco de España, amb les següents dades de contacte",
	"Customer_Service_text_27": "O per via telemàtica a través de l'Oficina Virtual",
	"Data": "Dades",
	"Data_of_property_to_be_appraised": "Dades de l'immoble a taxar",
	"Data_tabulation": "Tabulació de dades",
	"date": "data",
	"Date": "Data",
	"Date_of_the_appraisal_value": "Data del valor de taxació",
	"Date_of_report": "Data de l'informe",
	"Date_of_quote": "Data del pressupost",
	"Date_of_invoice": "Data de la factura",
	"Delete": "Eliminar",
	"Deprecated_construction_cost": "Cost de construcció depreciat",
	"Depreciation_by_antiquity": "Depreciació per antiguitat",
	"description": "descripció",
	"Description": "Descripció",
	"Discard": "Descartar",
	"Distance": "Distància",
	"Door": "Porta",
	"Duplicate": "Duplicar",
	"Dwelling_type": "Tipus d'habitatge",
	"Dwellings": "Habitatges",
	"e-mail": "correu electrònic",
	"E-mail": "Correu electrònic",
	"E-mail_address": "Adreça de correu electrònic",
	"E-mail_addresses": "Adreces de correu electrònic",
	"E-mail_description": "Descripció del correu electrònic",
	"Email": "Correu electrònic",
	"Email address": "Adreça de correu electrònic",
	"Edit": "Editar",
	"Edit_ad": "Editar anunci",
	"Edit_address": "Editar adreça",
	"Edit_Appraisal": "Editar taxació",
	"Edit_contact": "Editar contacte",
	"Edit_real_estate": "Editar immoble",
	"Edit_Real_Estate": "Editar Immoble",
	"Email_Address": "Adreça de correu electrònic",
	"Energy_Certificates": "Certificats Energètics",
	"Energy_Efficiency_Certificate": "Certificat d'Eficiència Energètica",
	"Entities": "Entitats",
	"Entities_Index": "Índex d'Entitats",
	"Entity": "Entitat",
	"EPSG_missing_text": "Manquen les coordenades X i Y EPSG:25831 per a poder obtenir la referència cadastral i el codi de secció censal. Es poden consultar amb el botó de Geolocalitzar",
	"Estimated_sale_price": "Preu de venta estimat",
	"Estimated_unit_sale_price": "Preu unitari estimat",
	"Estimated_useful_life": "Vida útil estimada",
	"Executed_construction_cost": "Cost de construcció realitzada",
	"Expected_Income_Update_Method": "Mètode Actualització de Renda Esperada",
	"Experience": "Experiència",
	"Experience_text": "Més de 30 anys de trajectòria oferint el millor servei al millor preu",
	"Expert_Opinions": "Dictàmens Pericials",
	"expert_opinions": "dictàmens pericials",
	"Expropriations": "Expropiacions",
	"External_storage_room": "Traster",
	"features": "característiques",
	"Features": "Característiques",
	"Fees": "Honoraris",
	"file": "expedient",
	"File": "Expedient",
	"File_description": "Descripció de l'expedient",
	"Files": "Expedients",
	"File_number": "Nº d'expedient",
	"Final_unit_price": "Preu unitari final",
	"Financial_Entities": "Entitats Financeres",
	"finished_real_estate": "immoble acabat",
	"finishes": "acabats",
	"Finishes": "Acabats",
	"Fiscal_Address": "Adreça Fiscal",
	"Fiscal_address": "Adreça fiscal",
	"fixtures": "instal·lacions",
	"Fixtures": "Instal·lacions",
	"Floor": "Planta",
	"Floor_number": "Nº Planta",
	"Floor_type": "Tipus de planta",
	"For_all_purposes": "Per a totes les finalitats",
	"Foundations": "Fundacions",
	"Freemarket_benefit": "Benefici mercat lliure",
	"Fri.": "Dv.",
	"from": "de",
	"Functional_depreciation": "Depreciació funcional",
	"General_data": "Dades generals",
	"Green_areas": "Jardí / Zones enjardinades",
	"Have_an_account_q_Log_in": "Ja tens un compte? Inicia sessió",
	"Heating": "Calefacció",
	"Height_situation": "Situació en alçada",
	"Higher_values": "Valors superiors",
	"Home_text_01": "Bonell+Dòriga architects, Barcelona",
	"homogenisation": "homogeneïtzació",
	"Homogenisation": "Homogeneïtzació",
	"Homogenisation_of_values": "Homogeneïtzació de valors",
	"Homologated_company": "Societat Homologada",
	"Homologated_Appraisal_Company_c_since_1995": "Societat de Taxació Homologada, des de 1995",
	"Homologated_text_01_part01": "Inscrita en el",
	"Homologated_text_01_part02": "d'Entitats de Taxació del Banco de España, amb nº 4.470 i data 26/06/1.995",
	"Honorarium_c_taxes_and_licenses": "Honoraris facultatius, taxes i llicències",
	"Honorarium_c_taxes_and_licenses_percentage": "Percentatge d'honoraris facultatius, taxes i llicències",
	"Hospitals": "Hospitals",
	"Hotels": "Hotels",
	"Decennial_insurance_policy_expenses": "Despeses de pòlissa d'assegurança decennal",
	"Decennial_insurance_policy_expenses_percentage": "Percentatge de despeses de pòlissa d'assegurança decennal",
	"Developers_administrative_expenses": "Despeses administratives del promotor",
	"Developers_administrative_expenses_percentage": "Percentatge de despeses administratives del promotor",
	"Developers_benefit": "Benefici del promotor",
	"Development_expenses": "Despeses de promoció",
	"Development_expenses_percentage": "Percentatge de despeses de promoció",
	"Other_elements_included_in_this_valuation_price": "Altres elements inclosos en aquesta valoració",
	"Geographical_area": "Àmbit geogràfic",
	"Geolocate": "Geolocalitzar",
	"go_back": "tornar enrere",
	"Go_back": "Tornar enrere",
	"go_up": "tornar amunt",
	"Go_up": "Tornar amunt",
	"Gross_Replacement_Cost": "Cost de Reemplaçament-reposició Brut",
	"Gross_yearly_rent_income": "Renda bruta anual de lloguer",
	"Geolocation": "Geolocalització",
	"Identification": "Identificació",
	"in_01": "en",
	"In_accordance_with_eco_decree_q": "s/ Ordre ECO?",
	"In_accordance_with_mortgage_market_law_q": "s/ Llei del Mercat Hipotecari?",
	"Independence": "Independència",
	"Independent_professionals": "Professionals independents",
	"Independent_pl": "Independents",
	"Index_of_Appraisals": "Índex de Taxacions",
	"Individuals": "Particulars",
	"Industrial_warehouses": "Naus industrials",
	"Info_source": "Font de la informació",
	"Infrastructures": "Infraestructures",
	"Paving_execution_pct": "Percentatge d'execució de pavimentació",
	"Sewage_execution_pct": "Percentatge d'execució de clavegueram",
	"Public_lighting_execution_pct": "Percentatge d'execució d'enllumenat públic",
	"Water_supply_execution_pct": "Percentatge d'execució de subministrament d'aigua",
	"Electricity_supply_execution_pct": "Percentatge d'execució de subministrament elèctric",
	"Piped_gas_execution_pct": "Percentatge d'execució de gas canalitzat",
	"Telephone_service_execution_pct": "Percentatge d'execució de servei telefònic",
	"Gardened_areas_execution_pct": "Percentatge d'execució de zones enjardinades",
	"Total_execution_pct": "Percentatge d'execució total infraestructures",
	"Infrastructures_repercussion_cost": "Cost de repercussió infraestructures",
	"Pending_investment": "Inversió pendent",
	"Paving": "Pavimentació",
	"Sewage": "Clavegueram",
	"Public_lighting": "Enllumenat públic",
	"Electricity_supply": "Subministrament electricitat",
	"Piped_gas": "Gas canalitzat",
	"Telephone_service": "Servei telefònic",
	"Gardened_areas": "Zones enjardindes",
	"Land_is_plot_according_to_law": "Té el terreny consideració de solar segons la Llei del Sòl?",
	"Notes_on_plot_infrastructures": "Observacions sobre les infraestructures",
	"Notes_on_plot_area": "Observacions sobre la superfície del terreny",
	"Informative_Appraisal_Fees": "Honoraris Taxació Informativa",
	"Initial_Data": "Dades Inicials",
	"Initial_unit_price": "Preu unitari inicial",
	"Innovation": "Innovació",
	"Insurance_companies": "Companyies d'assegurances",
	"Insurance_value": "Valor de l'assegurança",
	"Interior_visit_check": "Visita interior",
	"Internal_regulation": "Reglament intern",
	"Invalid_email_address": "L'adreça d'e-mail és incorrecta",
	"Investment_groups": "Grups d'inversió",
	"Invoices": "Factures",
	"Is_it_rented_or_ceded_q": "L'immoble està llogat o cedit?",
	"Is_the_real_estate_protected_q": "L'immoble està protegit?",
	"Is_the_right_of_use_ceded_q": "El dret d'ús de l'immoble està cedit?",
	"land": "sòl",
	"Land": "Sòl",
	"Land_area": "Superfície de terreny",
	"Land_registry_area": "Superfície registral del terreny",
	"Land_market_value": "Valor de mercat del sòl",
	"Land_pl": "Terrenys",
	"Land_total_value": "Valor total del sòl",
	"Land_value": "Valor del sòl",
	"Land_value_plus_deprecated_construction_cost": "Valor del sòl més cost de construcció depreciat",
	"Land_value_plus_executed_construction_cost": "Valor del sòl més cost de construcció realitzada",
	"Landlord_expenses_pct": "Percentatge net restant degut a despeses del arrendador",
	"Language": "Idioma",
	"Last_modified": "Última modificació",
	"last_renovation_year": "últim any de rehabilitació",
	"Last_renovation_year": "Últim any de rehabilitació integral",
	"Appraisal_adopted_area_missing_error_text": "Manca introduir la superfície construïda de l'immoble de referència per a poder procedir amb l'estudi de mercat",
	"Appraisal_property_type_missing_error_text": "Manca introduir el tipus d'immoble corresponent a l'immoble de referència per a poder procedir amb l'estudi de mercat",
	"Lat_lng_missing_error_text": "Manca introduir les coordenades de latitud i longitud per a l'immoble actual",
	"Ad_type_missing_error_text": "Manca introduir el tipus d'anunci que es vol obtenir per a poder fer la consulta",
	"Date_missing_error_text": "Manca introduir el rang de dates (inici i final) per a poder consultar els anuncis",
	"Adopted_age_missing_error_text": "Manca introduir l'antiguitat considerada per a poder proseguir",
	"Adopted_age_length_error_text": "L'antiguitat considerada ha de ser un any amb format 'YYYY'",
	"Adopted_area_missing_error_text": "Manca introduir la superfície construida adoptada per a poder proseguir",
	"Property_type_missing_error_text": "Manca introduir el tipus d 'immoble per a poder proseguir",
	"Latitude": "Latitud",
	"Law_firms": "Despatxos jurídics",
	"Lift": "Ascensor",
	"link": "Enllaç",
	"Loading": "Carregant",
	"Log_In": "Inicia la sessió",
	"Longitude": "Longitud",
	"Looking_for_something_q": "Buscant alguna cosa?",
	"Lower_limit": "Límit inferior",
	"Market": "Mercat",
	"Market_calculations": "Càlculs del mercat",
	"Market_studies_for_this_real_estate": "Estudis de mercat per a aquest immoble",
	"Market_study": "Estudi de mercat",
	"Market_study_for": "Estudi de mercat per a",
	"Market_unit_value": "Valor unitari de mercat",
	"Market_value": "Valor de mercat",
	"Machinery": "Maquinària",
	"Market_coeficient": "Coeficient de mercat",
	"Market_value_adjustment": "Ajust del valor de mercat",
	"Market_value_of_the_appraised_realestate": "Valor de mercat de l'immoble taxat",
	"Market_value_reduction_pct": "Reducció valor mercat (%)",
	"Market_studies": "Estudis de mercat",
	"Material_execution_cost": "Cost d'execució material",
	"Materials": "Materials",
	"Maximum_legal_computable_area": "Superfície legal màxima computable",
	"Maximum_legal_sale_price": "Preu de venta màxim legal",
	"Maximum_Legal_Method": "Mètode Màxim Legal",
	"Measurements": "Amidaments",
	"Mec_adjustment_coef": "Coeficient d'ajust del cost d'execució material",
	"Medical_centers": "Centres mèdics",
	"Messages": "Missatges",
	"Metadata": "Metadades",
	"Minimum_benefit_acc_to_regulation": "Benefici mínim segons la norma",
	"Minimum_fees": "Honoraris mínims",
	"Modification": "Modificació",
	"Modified": "Modificat",
	"Mon.": "Dl.",
	"Mortgage_Appraisal_Fees": "Honoraris Taxació Hipotecària",
	"Municipality": "Municipi",
	"Mutual_insurance_companies": "Mútues",
	"Name": "Nom",
	"Name_and_surnames": "Nom i cognoms",
	"Name_and_TIN": "Nom i NIF/CIF",
	"net_area": "superfície útil",
	"Net_area": "Superfície útil",
	"Net_areas": "Superfícies útils",
	"Net_yearly_rent_income": "Renda neta anual de lloguer",
	"Net_Replacement_Cost": "Cost de Reemplaçament-reposició Net",
	"New_address": "Nova adreça",
	"New_appraisal_file": "Nou expedient de taxació",
	"New_contact": "Nou contacte",
	"New_entity": "Nova entitat",
	"Number": "Número",
	"Number_of_floors_and_use": "Nº de plantes i ús",
	"No_address_registered": "Cap adreça registrada",
	"No_contact_registered": "Cap contacte registrat",
	"No_email_address_registered": "Cap adreça de correu electrònic registrada",
	"No_telephone_number_registered": "Cap nº de telèfon registrat",
	"No_results": "Cap resultat",
	"Non_recoverable_taxes_percentage": "Percentatge d'impostos no recuperables",
	"Non_recoverable_taxes": "Impostos no recuperables",
	"Not_found_message": "No s'ha trobat la pàgina, comprova que la URL sigui correcta",
	"notes": "observacions",
	"Notes": "Observacions",
	"Notes_1": "Observacions 1",
	"Notes_2": "Observacions 2",
	"Notes_on_mortgage_valuation_validity": "Observacions sobre la validesa de la taxació per a fins hipotecaris",
	"Occupancy_Card": "Cèdul·la d'Habitabilitat",
	"Occupancy_Cards": "Cèdul·les d'habitabilitat",
	"Occupancy_Card_and_Certificate": "Certificat i Cèdul·la d'Habitabilitat",
	"Occupancy_Certificate": "Certificat d'Habilitat",
	"occupancy_certificates": "cèdul·les d'habitabilitat",
	"of": "de",
	"of_the_excess_of": "de l'excés de",
	"of_the_same_property": "del mateix immoble",
	"Offer_price": "Preu de l'oferta",
	"Offer_unit_price": "Preu unitari de l'oferta",
	"Official_Appraisals": "Taxacions Oficials",
	"Office_hours": "Horari d'oficines",
	"Official_appraisals_for_all_purposes": "Taxacions oficials per a tota finalitat",
	"Official_Register": "Registre Oficial",
	"Offices": "Oficines",
	"Open": "Obrir",
	"Open_link_in_new_tab": "Obrir link en una nova pestanya",
	"Orientation": "Orientació",
	"Organization_s_Company": "Organització / Empresa",
	"Other_services": "Altres serveis",
	"other_services": "altres serveis",
	"others": "altres",
	"Our_clients": "Els nostres clients",
	"Our_services": "Nuestros servicios",
	"Our_workflow": "Nuestro flujo de trabajo",
	"PA_registration_number": "Nº col·legiat",
	"Page_not_found": "Pàgina no trobada",
	"Parking_lots_number": "nº Places d'aparcament",
	"Parking_spaces": "Places d'aparcament",
	"Password": "Contrassenya",
	"Person_type": "Tipus de persona",
	"Petitioner": "Sol·licitant",
	"Petitioner_data": "Dades del sol·licitant",
	"Petitioner_type": "Tipus de sol·licitant",
	"Philosophy": "Filosofia",
	"Philosophy_text_01": "La filosofia de la societat es pot resumir en tres principis fonamentals: professionalitat, rapidesa i ètica. Tot plegat unit a un bon equip de professionals i a un control de qualitat exhaustiu",
	"Philosophy_text_02": "Els nostres valors defineixen la nostra identitat com a empresa i constitueixen la força propulsora de com fem dia a dia el nostre treball. Considerem que el nostre èxit és conseqüència dels mateixos, entre els quals destaquem",
	"Philosophy_text_03": "Auditoria contínua dels nostres processos de realització de taxacions i valoracions amb la implementació de les últimes tecnologies. BARNA-TAXA, SA disposa de programari especialment desenvolupat per a l'exercici de la valoració emprant les eines informàtiques més adequades. Tots els nostres informes incorporen certificació de firma digital",
	"Philosophy_text_04": "És una societat l'accionariat i junta directiva és privat i NO VINCULAT a cap entitat financera ni grup immobiliari. BARNA-TAXA, S. A. no intermèdia en operacions de compravenda en el mercat, pel que els seus serveis es presten des de la més absoluta independència",
	"Philosophy_text_05": "Capacitat de resposta contrastada, efectivitat i equilibri de les nostres valoracions. Compromís de complir els requisits i processos necessaris per a la satisfacció del client",
	"Philosophy_text_06": "El nostre sistema de qualitat es basa en els següents principis: La millora contínua i superació com a objectiu permanent, la qual cosa s'aconsegueix especialment a través del compromís de tota l'organització i l'anàlisi sistemàtica dels resultats de qualitat. Satisfer les necessitats i expectatives dels clients, complint els temps de lliurament acordats amb els clients i treballant en la millora dels mateixos, lliurant sempre un bon producte a la primera. El compliment dels requisits, ja siguin reglamentaris i legals, particulars dels nostres clients o de qualsevol altra índole, donant així resposta a totes les parts interessades",
	"Philosophy_text_07": "Assegurar el compliment de la normativa vigent i la feina ben feta",
	"Philosophy_text_08": "El fet d'estar homologats i inscrits amb el número 4.470 en el Registre de Societats de Taxació del Banc d'Espanya i estar subjectes a la supervisió, garanteix el rigor l'objectivitat i la transparència absoluta dels nostres informes de valoració",
	"Philosophy_text_09": "Més de tres dècades en el camp de la taxació avalen el nostre treball",
	"Philosophy_text_10": "La confidencialitat dels treballs que la normativa exigeix, està garantida pel secret professional que regeix la conducta dels nostres tècnics. BARNA-TAXA S.A. no revela informació a terceres persones",
	"Philosophy_text_11": "BARNA-TAXA, S. A. estableix un marc de conducta per a la societat i els seus treballadors",
	"Physical_depreciation": "Depreciació física",
	"Pick_an_option": "Selecciona una opció",
	"Plan_type": "Tipus de pla",
	"Plot_area": "Superfície del solar",
	"Please_enter_a_name": "Per favor, introdueixi el nom del sol·licitant",
	"Please_enter_a_surname": "Per favor, introdueixi el cognom del sol·licitant",
	"Please_enter_a_telephone_number": "Per favor, introdueixi un número de telèfon",
	"Please_enter_an_email_address": "Per favor, introdueixi una adreça d'e-mail",
	"Please_enter_the_type_of_property": "Per favor, introdueixi el tipus de immoble a taxar",
	"Please_enter_the_address_of_the_property": "Per favor, introdueixi l'adreça de l'immoble",
	"Please_enter_the_postal_code": "Per favor, introdueixi el codi postal de l'immoble",
	"Please_enter_the_municipality": "Per favor, introdueixi el municipi",
	"Please_enter_the_area_of_the_property": "Per favor, introdueixi la superfície de l'immoble",
	"Please_enter_the_purpose_of_the_appraisal": "Per favor, introdueixi la finalitat de la taxació",
	"Postal_code": "Codi postal",
	"Prefix": "Prefix",
	"Price": "Preu",
	"Pricing": "Tarifes",
	"Pricing_and_Quotes": "Tarifes i Pressupost",
	"Pricing_text_01": "Oferim dos tipus de valoracions: la valoració hipotecària i la valoració informativa, segons la seva finalitat",
	"Pricing_text_02": "Obtindrà en un plaç màxim de 24h el pressupost per escrit de la seva taxació, sense compromís",
	"Pricing_text_03": "Descompte per volum d'encàrrec. IVA APLICABLE: 21%",
	"Pricing_text_04": "Taxació hipotecària: Regulada per la normativa ECO 805/2003 i disposicions concordants",
	"Pricing_text_05": "Les localitats fora de Barcelona capital i àrea metropolitana tindran increment per desplaçament",
	"Pricing_text_06": "Descompte especial per a les comandes de Informe de Taxació + Certificat d'un mateix immoble",
	"Print_report_in_PDF": "Imprimir informe en PDF",
	"Private_Enterprises": "Empreses Privades",
	"Professional_association": "Col·legi professional",
	"Professional_ethics": "Ètica professional",
	"Professional_qualification": "Titulació",
	"Professionalism": "Professionalitat",
	"Professionals_text_01_part_01": "Una societat d'",
	"Professionals_text_01_part_02": "arquitectes, enginyers i especialistes totalment independents",
	"Professionals_text_01_part_03": ", sense vinculació amb entitats financeres ni grups empresarials",
	"Properties_under_economic_exploitation": "Immobles en explotació econòmica",
	"Professionals_with_experience": "Professionales con experiencia",
	"Properties": "Immobles",
	"Property_data": "Dades de l'immoble",
	"Property_developers": "Promotors Immobiliaris",
	"Property_developments": "Promocions immobiliàries",
	"Property_purchase-sale": "Compra-venta d'immobles",
	"Property_type": "Tipus d'immoble",
	"Property_types": "Tipus d'immobles",
	"Property_valuation_services": "Serveis de valoració immobiliària",
	"Property_visit": "Visita a l'immoble",
	"protection": "protecció",
	"Protection": "Protecció",
	"Protection_type": "Tipus de protecció",
	"Protection_regime": "Règim de protecció",
	"Protection_zone": "Zona de protecció",
	"Province": "Provincia",
	"Public_Administrations": "Administracions públiques",
	"purpose": "finalitat",
	"Qualities": "Qualitats",
	"Qualities_comparison": "Comparació de qualitats",
	"Quality": "Qualitat",
	"Quality_of_construction": "Qualitat de la construcció",
	"Quality_of_neighbourhood": "Qualitat del barri",
	"Quality_of_realestate": "Qualitat de l'element",
	"Quality_of_situation": "Qualitat de la situació",
	"Query_comparables": "Consultar comparables",
	"Query_real_estates": "Consultar immobles",
	"Query_result": "Resultat de la consulta",
	"Quote_request": "Sol·licitud de pressupost",
	"Quotes": "Pressupostos",
	"Real_estate": "Immoble",
	"Real_estates": "Immobles",
	"Real_estates_index": "Índex d'immobles",
	"Real_Estates_residual_value": "Valor residual de l'immoble",
	"Real_estates_residual_value_at_the_end_of_the_contracts_useful_life": "Valor residual de l'immoble al final de la vida útil del contracte",
	"Real_estate_referral": "Immoble de referència",
	"Real_estate_value": "Valor de l'immoble",
	"Realestates_remaining_useful_life": "Vida útil restant de l'immoble",
	"RealEstate_description": "Descripció de l'immoble",
	"Reduction": "Reducció",
	"Reduction_pct": "Reducció (%)",
	"Registry_data": "Dades registrals",
	"Registry_identification_data": "Identificació registral",
	"Register_name": "Nom del Registre",
	"Regression_line": "Línia de regressió",
	"Regression_line_calculation": "Càlcul de la línia de regressió",
	"Remaining_contract_years": "Anys restants de contracte",
	"Remaining_of_the_developers_benefit": "Restant del benefici del promotor",
	"Remaining_period_update": "Actualització del període restant",
	"Repercussion_method": "Mètode de repercussió",
	"Report": "Informe",
	"Report_title_missing_error_text": "Manca el títol de l'informe",
	"reports": "informes",
	"Report_content": "Contingut de l'informe",
	"Report_content_text_01": "Visita a l'immoble i elaboració d'informe oficial realitzat per un tècnic qualificat de Barna-Tasa",
	"Report_content_text_02": "Identificació i localització. Característiques de l'immoble. Dades cadastrals i registrals",
	"Report_content_text_03": "Fotografies i croquis de l'immoble",
	"Report_content_text_04": "Estudi de mercat real, selecció de mostres i càlcul de valors de l'informe",
	"Report_date": "Data de l'informe",
	"Report_number": "Nº d'informe",
	"Report_title": "Títol de l'informe",
	"Representative": "Representant",
	"representative_sample": "mostra representativa",
	"Representative_sample": "Mostra representativa",
	"Representative_TIN": "NIF del representant",
	"Report_language": "Idioma de l'informe",
	"Requesting": "Sol·licitant",
	"Request_a_quote": "Sol·licitar pressupost",
	"Request_a_quote_24h": "Sol·liciti pressupost (24h)",
	"Request_a_quote_here": "Sol·liciti pressupost aquí",
	"Request_a_quote_for_an_appraisal": "Sol·licitar pressupost de taxació",
	"Request_successfully_sent": "Sol·licitud correctament enviada",
	"Required_fields": "Camps necessaris",
	"Residual_depreciation": "Depreciació residual",
	"Residual_value": "Valor residual",
	"Restaurants": "Restaurants",
	"Restringit": "Restringit",
	"Right_of_use": "Dret d'ús",
	"Right_of_use_value": "Valor del dret d'ús",
	"rights": "drets",
	"Rights": "Drets",
	"Rigor": "Rigor",
	"Risk_premium": "Prima de risc",
	"Riskfree_rate": "Taxa lliure de risc",
	"Room": "Habitació",
	"Rooms": "Habitacions",
	"Sat.": "Ds.",
	"Save": "Desar",
	"Save_and_go_back": "Desar i tornar",
	"Save_valuation": "Desar taxació",
	"Search_radius_km": "Radi de búsqueda (km)",
	"Security": "Seguretat",
	"Selected_comparables": "Comparables seleccionats",
	"Send_to_bde_q": "Enviar al BdE?",
	"Services": "Serveis",
	"Services_text_01": "BARNA-TASA, S.A. és una societat especialitzada en la VALORACIÓ DE BÉNS, homologada i registrada al 'Banco de España' amb el número 4.470 en el Registro Oficial de Entidades de Tasación. La nostra experiència es basa en més de 30 anys d'exercici professional en l'àmbit de taxacions, valoracions i peritatges de la construcció",
	"Services_text_02": "El nostre principal servei s'emmarca en el camp de les valoracions i les taxacions amb totes les finalitats. També oferim un ventall de serveis relacionats amb el món de la arquitectura i el peritatge, des de la el·laboració de dictàmens i peritatges de construcció fins a certificats, cèdul·les i aixecaments de plànols",
	"Services_text_03": "Realitzem taxacions per a totes les finalitats. Oferim dos tipus de taxacions segons la seva finalitat",
	"Services_text_04": "La tipologia habitual de béns immobles i drets que valorem mitjançant el corresponent informe de taxació és la següent",
	"Services_text_05": "Acceptació de l'encàrrec i entrega de documentació necessària",
	"Services_text_06": "Visita al immoble per part d'un tècnic de BARNA-TASA",
	"Services_text_07": "El·laboració de l'informe o informes per part de BARNA-TASA",
	"Services_text_08": "Entrega de l'informe en format digital i/o paper",
	"Sign_Up": "Registra't",
	"Source": "Font",
	"Sports_clubs": "Clubs esportius",
	"Sports_facilities": "Instal·lacions esportives",
	"Staircase": "Escala",
	"Standard_deviation_of_the_sample": "Desviació estàndard de la mostra",
	"Storerooms": "Trasters",
	"Street_name": "Nom de via",
	"Street_number": "Nº via",
	"Structure": "Estructura",
	"Sun.": "Dg.",
	"Supervisor": "Supervisor",
	"Surnames": "Cognoms",
	"Surnames_name": "Cognoms, Nom",
	"Surnames_name_or_company": "'Cognoms, Nom' o 'Nom de l'empresa'",
	"Surroundings": "Entorn",
	"Surveying": "Aixecament de plànols",
	"Swimming_pool": "Piscina",
	"Tasks": "Tasques",
	"Taxes": "Impostos",
	"technical_values": "valors tècnics",
	"Technical_values": "Valors tècnics",
	"Technology": "Tecnologia",
	"Team_text": "La societat està formada per un grup d'arquitectes, enginyers i especialistes en taxacions amb un ampli coneixement sobre el mercat immobiliari i amb una experiència contrastada de més de 30 anys en el camp de la valoració immobiliària",
	"Teamwork": "Treball en equip",
	"Telephone": "Telèfon",
	"Telephone_contact": "Telèfon de contacte",
	"telephone_number": "nº de telèfon",
	"Telephone_number": "Nº de Telèfon",
	"Telephone_numbers": "Números de telèfon",
	"Tenant_age_years": "Edat de l'arrendatari",
	"Tenant_life_expectancy_years": "Esperança de vida",
	"Tenant_remaining_life_expectancy_years": "Vida restant estimada arrendatari",
	"Terrain": "Terreny",
	"Testamentary_shares": "Participacions testamentàries",
	"The_company": "L'Empresa",
	"The_page_contains_unsaved_changes": "La pàgina actual conté canvis no desats",
	"The_passwords_do_not_match": "Les contrassenyes no coincideixen",
	"thousand": "mil",
	"thousand_euros": "mil euros",
	"thousands_of_euros": "milers d'euros (€)",
	"Thu.": "Dj.",
	"TIN": "NIF / CIF",
	"Title": "Títol",
	"Title_and_date_of_report": "Títol i data de l'informe",
	"Title_s_Honorific": "Títol / Tractament",
	"to": "a",
	"Total_depreciation": "Depreciació total",
	"Total_value": "Valor total",
	"total_values": "valors totals",
	"Total_values": "Valors totals",
	"Transparency": "Transparència",
	"Trust": "Confiança",
	"type": "tipus",
	"Type": "Tipus",
	"Type_here_to_filter_paginated_data": "Escriu aquí per filtrar les dades paginades",
	"Typical_deviation": "Desviació típica",
	"Typology": "Tipologia",
	"Others": "Altres",
	"Type_of_property": "Tipus d'immoble",
	"Uncovered_outdoor_area": "Superfícies exteriors descobertes",
	"Unit_price": "Preu unitari",
	"Unit_value": "Valor unitari",
	"universal_sample": "mostra universal",
	"Universal_sample": "Mostra universal",
	"Update_type": "Tipus d'actualització",
	"Update_value": "Valor d'actualització",
	"Update_value_calculation": "Càlcul del valor d'actualització",
	"Updated_reversion_value": "Valor de reversió actualitzat",
	"Upper_limit": "Límit superior",
	"Urban_planning_parameters": "Paràmetres urbanístics",
	"Url": "Link",
	"Useful_life": "Vida útil",
	"Usufruct": "Usdefruit",
	"Usufruct_value": "Valor de l'usdefruit",
	"Usufructuary_age_years": "Edat de l'usufructuari",
	"valuated_in_this_report": "valorats en aquest informe",
	"Valuation": "Valoració",
	"Valuation_pricing": "Tarifes de taxació",
	"valuations": "valoracions",
	"Valuation_date": "Data de valoració",
	"Valuation_purpose": "Finalitat de la valoració",
	"Valuation_report": "Informe de valoració",
	"Valuation_type": "Tipus de valoració",
	"Value_date": "Data del valor",
	"Version": "Versió",
	"Visits": "Visites",
	"VAT": "IVA",
	"Warnings": "Advertiments",
	"We_are_sorry_c_the_page_you_requested_cannot_be_found": "Ho sentim, no trobem la pàgina sol·licitada",
	"Weighing": "Ponderació",
	"Welcome_message": "Benvingut a la App de Barnatasa",
	"What_you_need_to_provide": "Què necessites aportar?",
	"with": "amb",
	"without_saving": "sense desar",
	"Workflow": "Flux de treball",
	"Wrong_date_message": "La data és incompleta o incorrecta",
	"years": "anys",
	"You_are_about_to_delete": "S'eliminarà",
	"Registry_area": "Superfície Registral",
	"Checked_area": "Superfície comprovada",
	"Plot_occupation": "Ocupació del solar",
	"Plot_free_area_usage": "Ús de la superfície lliure del solar",
	"Floors_number_underground": "Nª de plantes sota rasant",
	"Floors_number_overground": "Nº de plantes sobre rasant",
	"Parking_slots_included_in_appraisal_number": "Nº de places de garatge incloses en la valoració",
	"Entrance_hall": "Portal",
	"Doorman_space": "Porteria",
	"Community_room": "Sala comunitària",
	"Storage_room_included_in_appraisal": "Traster inclòs",
	"Community_parking": "Garatge",
	"Facilities_others": "Altres",
	"Floors_usage_underground": "Ús sota rasant",
	"Floors_usage_overground": "Ús sobre rasant",
	"Groundfloor_usage": "Ús planta baixa",
	"Real_estates_useful_life": "Vida útil de l'immoble",
	"Real_estates_total_useful_life": "Vida útil total de l'immoble",
	"Remaining_useful_life_years": "Anys restants de vida útil",
	"Urban_and_surroundings_text": "Urbanisme i entorn",
	"Communications": "Comunicacions",
	"Airport": "Aeroport",
	"Harbour": "Port",
	"Train": "Tren",
	"Public_transport": "Transport públic",
	"Urban_underground": "Urbà subterrani",
	"Interurban": "Interurbà",
	"Territorial_feature": "Característica territorial",
	"Income_level": "Nivell de la renta",
	"Homogeneity_feature": "Trets d'homogeneïtat",
	"Main_uses": "Usos dominants",
	"Density": "Densitat",
	"Accessibility": "Accessibilitat",
	"Consolidation_degree": "Grau de consolidació",
	"Occupation_degree": "Grau d'ocupació",
	"Evolution": "Evolució",
	"Average_age": "Antiguitat característica",
	"Commercial": "Comercial",
	"Educational": "Educacional",
	"Public_parking": "Aparcament públic",
	"Medical_assistance": "Assistència mèdica",
	"Leisure": "Oci",
	"Building_development_level": "Nivell de desenvolupament de l'edificació",
	"Facilities": "Equipaments",
	"MUC_map": "Mapa del MUC",
	"Registry": "Registre",
	"Section": "Secció",
	"Volume": "Volum",
	"Book": "Llibre",
	"Page": "Pàgina",
	"Registry_real_estate_number": "Nº de finca registral",
	"Holder": "Titular",
	"Property_coef": "Coeficient de propietat",
	"Bedrooms_and_bathrooms": "Dormitoris i banys",
	"Covered_outdoor_areas": "Superfícies exteriors cobertes",
	"Uncovered_outdoor_areas": "Superfícies exteriors descobertes",
	"Add_covered_outdoor": "Afegir espai exterior cobert",
	"Add_uncovered_outdoor": "Afegir espai exterior descobert",
	"Enclosed_area": "Superfície tancada",
	"Enclosed_checked_area": "Superfície tancada comprovada",
	"Low_enclosed_checked_area_error_text": "La superfície tancada comprovada és inferior a la superfície total útil",
	"Proportional_part_of_common_elements": "Part proporcional d'elements comuns",
	"Common_elements_cadastral_area": "Elements Comuns Cadastre",
	"Common_elements_registry_area": "Elements Comuns Registre",
	"Common_elements_checked_area": "Elements Comuns Comprovada",
	"Common_elements_adopted_area": "Elements Comuns Adoptada",
	"Total_areas_summary_table": "Resum de superfícies totals",
	"Register": "Registre",
	"Cadaster": "Cadastre",
	"Checked": "Comprovada",
	"Selected": "Seleccionada",
	"Adopted": "Adoptada",
	"Usage": "Ús",
	"Covered_outdoors_area": "Superfície espais coberts exteriors",
	"Uncovered_outdoors_area": "Superfície espais descoberts exteriors",
	"Built_plus_common_elements_area": "Superfície Construïda + Elem. Com.",
	"Built_plus_common_elements": "Construïda + Elem. Com.",
	"Common_elements": "Elements comuns",
	"Number_of_rooms_to_exterior": "Nº d'habitacions a exterior",
	"Day_night_zoning": "Zonificació dia / nit",
	"Door_opener": "Porter automàtic",
	"Fitted_cupboards": "Armaris encastats",
	"Gas": "Gas",
	"Sanitary_fittings": "Aparells sanitaris",
	"Taps": "Aixetes",
	"Hot_water": "Aigua calenta",
	"Fire_prevention": "Prevenció al foc",
	"Intrusion_prevention": "Prevenció a l'intrusió",
	"Foundation": "Fonamentació",
	"Roof": "Coberta",
	"External_enclosures": "Tancaments exteriors",
	"Insulation": "Aïllament",
	"External_carpentry": "Carpinteria exterior",
	"Glazing": "Envidrament",
	"Views": "Vistes",
	"Windows_size_and_quantity": "Dimensió i quantitat de finestres",
	"Noise_facade": "Nivell de soroll en façana",
	"Systems": "Instal·lacions",
	"conservation_status": "estat de conservació",
	"Building_shell": "Envolupant de l'edifici",
	"building_shell": "envolupant de l'edifici",
	"Shell": "Envolupant",
	"shell": "envolupant",
	"Interior_finishes": "Acabats interiors",
	"Living": "Estar",
	"Kitchen": "Cuina",
	"Walls": "Parets",
	"Ceilings": "Sostres",
	"Interior_carpentry": "Fusteria interior",
	"Circulations": "Circulacions",
	"BdE_files": "Fitxes BdE",
	"Construction_prices": "Costos de construcció",
	"Add_bec_property": "Afegir tipus d'immoble",
	"Add_bec_number": "Afegir nº B.E.C.",
	"Year": "Any",
	"Quarter": "Trimestre",
	"Bec_adjustment_coef": "Coeficient d'ajust del B.E.C.",
	"Adjusted_bec_price": "Preu ajustat del B.E.C.",
	"Expenses_and_industrial_benefit_bec_pct": "Percentatge de Despeses i Benefici Industrial.",
	"Construction_status": "Estat de construcció",
	"Construction_cost_notes": "Observacions sobre el cost de construcció",
	"Mandatary": "Mandatari",
	"Mandatary_entity": "Entitat mandatària",
	"Acc_mortgage_market_law_q": "Segueix la llei del mercat hipotecari?",
	"Acc_eco_decree_q": "Segueix la ordre ECO/805/2003?",
	"location": "localització",
	"Registry_property": "Finca registral",
	"Cadastral_file": "Fitxa Cadastral",
	"Nucleus_area": "Superfície del municipi",
	"Nucleus_type": "Tipus de nucli",
	"Locality": "Localitat",
	"Employment_occupation": "Ocupació laboral",
	"Population": "Població",
	"Population_density": "Densitat de població",
	"Population_growth": "Creixement de població",
	"Last_year": "Últim any",
	"Terrain_description": "Descripció del terreny",
	"Terrain_infrastructures": "Infraestructures del terreny",
	"Execution": "Execució",
	"Water_supply": "Subministrament d'aigua",
	"Terrain_area": "Superfície del terreny",
	"Site_quality": "Qualitat de l'emplaçament",
	"Underground_levels": "Nivells sota rasant",
	"Ground_level": "Nivell rasant",
	"Overground_levels": "Nivells sobre rasant",
	"Building_description": "Descripció de l'edificació",
	"Checkings_realized": "Comprovacions realitzades",
	"Documents_used": "Documentació utilitzada",
	"Interior_visit": "Visita interior de l'immoble",
	"Expropriation_procedure": "Procediment d'expropiació",
	"Expropriation_plan": "Pla o projecte d'expropriació",
	"Expropriation_admin_ruling": "Resolució administrativa expropiació",
	"Expropriation_file": "Expedient d'expropriació",
	"Occupancy": "Estat d'ocupació i ús",
	"Servitudes": "Servituds",
	"Public_protection_regime": "Règim de protecció pública",
	"Urban_paramaters_suitability": "Adequació al planejament urbanístic",
	"Another": "Una altra",
	"Approved_project_by_professional_association": "Projecte visat pel col·legi professional",
	"Cadastral_documents": "Documentació cadastral",
	"Construction_license": "Llicència de construcció",
	"Construction_last_certificate": "Últim certificat de construcció",
	"Construction_contract": "Contracte de construcció",
	"Occupancy_status": "Estat d'ocupació",
	"Photographic_report": "Reportatge fotogràfic",
	"Property_sketch": "Croquis de l'immoble",
	"Property_titles": "Document de propietat segons normativa",
	"Situation_plan": "Plànol de situació",
	"Ten_year_insurance": "Assegurança decennal",
	"Urban_plan": "Plànol urbanístic",
	"Habitability_conditions": "Condicions d'habitabilitat",
	"Main_orientation": "Orientació principal",
	"Property_title": "Títol de propietat",
	"Usage_assigned": "Ús assignat",
	"Usage_assigned_by_the_owner": "Ús assignat per la propietat",
	"Inspection_realized": "Comprovació realitzada",
	"Economical_activity": "Activitat econòmica",
	"Real_rights": "Drets reals",
	"Bulletin_number": "Nº de Butlletí",
	"a": "un",
	"Select": "Seleccionar",
	"Market_data": "Dades de mercat",
	"Market_samples": "Mostres de mercat",
	"Offer_date": "Data de l'oferta",
	"Sample": "Mostra",
	"Market_analysis": "Anàlisi de mercat",
	"Prices_estimated_yearly_evolution_pct": "Preus - evolució anual, variació estimada (%)",
	"Market_value_evolution_probability_pct": "Previsió evolució del valor de comparació (%)",
	"Offer_production": "Oferta - producció",
	"Offer_yearly_stock": "Oferta - Estoc anual",
	"Offer_trend": "Oferta - tendència",
	"Demand_level": "Demanda - nivell",
	"Demand_speed_of_sales": "Demanda - velocitat de vendes",
	"Demand_trend": "Demanda - tendència",
	"Prices_expectancy": "Preus - Expectativa",
	"Prices_past_cicles_volatility": "Expectativa - Volatilitat de cicles passats",
	"Market_conjuncture": "Conjuntura de mercat",
	"Market_value_reduction_probability_expectancy": "Expectativa - Probabilitat de reducció del valor de comparació",
	"Offer": "Oferta",
	"Demand": "Demanda",
	"Expectation": "Expectativa",
	"Prices": "Preus",
	"Maximum": "Màxim",
	"Minimum": "Mínim",
	"Mean": "Mitjana",
	"Median": "Mediana",
	"Market_prices": "Preus del mercat",
	"Neighbourhood": "Barri",
	"Situation": "Situació",
	"Samples": "Mostres",
	"Similarities": "Similituds",
	"Statistical_deviations": "Desviacions estadístiques",
	"Typical_deviation_of_the_sample": "Desviació típica de la mostra",
	"Technical_values_calculation": "Càlcul de valors tècnics",
	"Material_execution_cost_as_new": "Cost d'execució material a nou",
	"Finished_building_market_value": "Valor de mercat edifici acabat",
	"finished_building": "immoble acabat",
	"Total_values_calculation": "Càlcul de valors totals",
	"year": "any",
	"Other_values": "Altres valors",
	"Appraisal_value_determination_text": "D'acord amb els criteris establerts en l'ordre ECO 805/2003, el valor aplicable és:",
	"Add_constraint": "Afegir condicionant",
	"Add_warning": "Afegir advertiment",
	"Add_note": "Afegir observació",
	"Constraints": "Condicionants",
	"Constraints_foreseen_by_law": "Condicionants previstos per Llei",
	"Warnings_foreseen_by_law": "Advertiments previstos per Llei",
	"Notes_foreseen_by_barnatasa": "Observacions previstes per BARNA-TASA S.A.",
	"English": "Anglès",
	"Spanish": "Castellà",
	"The_Real_Estate_is_not_protected": "L'immoble no està protegit",
	"The_Real_Estate_is_not_rented_or_ceded": "L'immoble no està llogat o cedit",
	"There_is_no_cession_of_the_right_of_use": "El dret d'ús de l'immoble no està cedit",
	"The_value_is_not_calculated": "El valor no es calcula",
	"Elements_included_in_this_valuation": "Elements inclosos en aquesta valoració",
	"Market_value_adjustment_pct": "Percentatge d'ajust del valor de mercat",
	"Constraint": "Condicionant",
	"Warning": "Advertiment",
	"Note": "Observació",
	"Upload_photographs": "Carregar fotografies",
	"Photograph": "Fotografia",
	"Photographs": "Fotografies",
	"Image_footer": "Peu d'imatge",
	"Upload_files": "Carregar arxius",
	"File_name": "Nom de l'arxiu",
	"in": "en",
	"Registry_Documents": "Documents Registrals",
	"Cadastral_Documents": "Documents Cadastrals",
	"Urban_Planning_Documents": "Documents Urbanístics",
	"Plans": "Plànols",
	"Sketches": "Croquis",
	"Cession_Documents": "Documents de Cessió",
	"Contracts": "Contractes",
	"Other_Documents": "Altres Documents",
	"with_date": "amb data",
	"Date_of_issue": "Data d'emissió",
	"Signatures": "Signatures",
	"Report_date_of_issue": "Data d'emissió de l'informe",
	"Professional_that_visited_the_property": "Tècnic que va realitzar la visita",
	"Date_of_visit": "Data de la visita",
	"Appraisers": "Taxadors",
	"Supervisors": "Supervisors",
	"Appraisers_Index": "Índex de Taxadors",
	"Supervisors_Index": "Índex de Supervisors",
	"Add_appraiser": "Afegir taxador",
	"Add_supervisor": "Afegir supervisor",
	"Prof_assoc_reg_number": "Nº col·legiat",
	"Visit_date": "Data de la visita",
	"Technician_who_performed_the_visit": "Tècnic visita",
	"Visit": "Visita",
	"Floor_name": "Nom de planta",
	"Import_comparable_set": "Importar conjunt de comparables",
	"Import_comparable_set_from_another_market_study": "Importar conjunt de comparables d'un altre estudi de mercat",
	"There_are_unsaved_changes": "Hi ha canvis no desats",
	"Unsaved_data_will_be_lost": "Es perdran les dades no desades",
	"Cover": "Portada",
	"Annexed_documents": "Documents annexes",
	"Report_of": "Informe de",
	"correlated_pages_numbered_from": "pàgines correlatives, numerades de ",
	"technician": "tècnic",
	"Sanitary_fittings_quality": "Qualitat aparells sanitaris",
	"Taps_quality": "Qualitat aixetes",
	"Land_selected_area": "Mètode de selecció",
	"Urban_parameters_suitability": "Adequació al planejament urbanístic",
	"Maps": "Mapes",
	"Situation_maps": "Mapes de situació i emplaçament",
	"Other": "Altra",
	"Subsidy_status": "Qualificació de protecció pública",
	"Quote": "Pressupost",
	"Appraisal_quote": "Pressupost de taxació",
	"Appraisal_quotes": "Pressupostos de taxació",
	"Add_appraisal_quote": "Afegir pressupost de taxació",
	"Title_and_date_of_quote": "Títol i data del pressupost",
	"valuated_in_this_quote": "valorats en aquest pressupost",
	"Quote_title_missing_error_text": "Manca el títol del pressupost",
	"Print_quote_in_PDF": "Imprimir pressupost en PDF",
	"Create_new_real_estate": "Crear nou immoble",
	"Select_Real_estate_to_be_added": "Selecciona l'immoble a afegir",
	"Existing_Real_estates": "Immobles existents a la base de dades",
	"create_a_new_one": "crea'n un de nou",
	"staircase": "escala",
	"block": "bloc",
	"door": "porta",
	"Full_address": "Adreça completa",
	"Status": "Estat",
	"Quote_number": "Nº de pressupost",
	"Quote_content": "Contingut del pressupost",
	"Quote_title": "Títol del pressupost",
	"Travel_expenses": "Despeses de viatge",
	"Travel_one_way_hours": "Hores de viatge (anada)",
	"Travel_both_ways_hours": "Hores totals de viatge (anada i tornada)",
	"Travel_fees_per_hour": "Honoraris per hora de viatge",
	"Total_car_expenses_one_way": "Despeses de benzina i peatges (anada)",
	"Total_car_expenses_both_ways": "Despeses totals de benzina i peatges (anada i tornada)",
	"Total_travel_fees": "Despeses totals per desplaçament",
	"Quote_area_average_unit_price": "Mitjana de preus de la zona (€/m2)",
	"Quote_base_fees": "Honoraris base",
	"Quote_excess_pct": "% de l'excés dels honoraris base",
	"Quote_base_price": "Honoraris finals",
	"Quote_base_price_coef": "Coeficient d'ajust",
	"Valuation_quote": "Pressupost de taxació",
	"Appraisal_cost": "Cost de taxació",
	"Appraisal_fees": "Honoraris de taxació",
	"Appraisal_price": "Preu de taxació",
	"hours": "hores",
	"Area_prices": "Preus de la zona",
	"Area_average_unit_price": "Mitjana de preus de la zona",
	"Ads_date_range": "Franja de dates dels anuncis",
	"Current_area_prices": "Preus actuals de la zona",
	"pre_appraisal": "pre-taxació",
	"Pre_appraisal": "Pre-taxació",
	"Estimated_built_area": "Superfície construida estimada",
	"Pre_appraisal_value": "Valor de pre-taxació",
	"Area_average_price_coef": "Coeficient d'ajust del preu",
	"Adopted_area_average_price": "Preu unitari adoptat",
	"Car_fuel_expenses_one_way": "Cost de Benzina (anada)",
	"Car_fuel_expenses_both_ways": "Cost de Benzina (anada i tornada)",
	"Car_toll_expenses_one_way": "Cost dels Peatges (anada)",
	"Car_toll_expenses_both_ways": "Cost dels Peatges (anada i tornada)",
	"Valuation_pricing_info_table": "Taula de tarifes de taxació",
	"Check_prices": "Buscar preus",
	"Add_ad_manually": "Afegir nou anunci manualment",
	"Ads_index": "Índex d'anuncis",
	"Go_back_to_market_study": "Tornar a l'estudi de mercat",
	"Offer_price_reduction_coef": "Coeficient reductor del preu",
	"Cession_files": "Documents d'arrendament",
	"Lease": "Arrendament",
	"Gross_tax_per_1000_inhabitants": "Taxa bruta per cada 1.000 habitants",
	"Site": "Emplaçament",
	"Urban_planning": "Urbanisme",
	"Construction_description": "Descripció de la construcció",
	"Status_on_occupancy_protection_cession_usage_and_real_rights": "Estat d'ocupació, règim de protecció, cessió, ús i drets reals",
	"Real_rights_protection_and_occupation": "Drets reals, protecció i ocupació",
	"PA_number": "Nº de col·legiat",
	"Quote_petitioner": "Sol·licitant del pressupost",
	"Quote_petitioners": "Sol·licitants de pressupost",
	"Dear": "Benvolgut",
	"Dear_m": "Benvolgut",
	"Dear_f": "Benvolguda",
	"Quote_sentence_01": "Ens plau adjuntar pressupost d'honoraris per a l'Informe de Taxació dels següents immobles",
	"with_purpose": "amb finalitat",
	"Approx_area": "Superfície aprox.",
	"Signed": "Signat",
	"Amount_money": "Import",
	"Total_cost_including_VAT": "Cost total (IVA inclòs)",
	"Fiscal_parameters": "Paràmetres fiscals",
	"VAT_pct": "IVA (%)",
	"Quote_sentence_02": "Es realitzarà pagament del 50% a l'inici del treball i el 50% restant a l'entrega dels Informes de Taxació",
	"Quote_sentence_03": "Abonar al compte bancari de BARNA-TASA, S.A.",
	"Quote_sentence_04": "Tasques a realitzar per a confecccionar els informes de taxació",
	"Quote_sentence_05": "Visita als immobles per un tècnic Arquitecte o Enginyer de BARNA-TASA",
	"Quote_sentence_06": "Elaboració de l'informe. Contingut",
	"Payment_details": "Detalls de pagament",
	"Required_documentation": "Documentació necessària",
	"Quote_sentence_07": "Entrega dels informes en format digital (PDF)",
	"Quote_sentence_08": "Si es requereix l'entrega en paper (opcional) s'aplicarà un cost addicional de 15 € en concepte d'impressió i enviament",
	"Quote_sentence_09": "Nom, NIF i adreça del sol·licitant",
	"Quote_sentence_10": "Nom, NIF i adreça fiscal per a la factura",
	"Quote_sentence_11": "Còpia completa de l'escriptura o de la nota registral",
	"Quote_sentence_12": "Còpia del IBI (dades Cadastrals) (opcional)",
	"Quote_sentence_13": "Còpia del contracte de lloguer i un rebut actualitzat si es tracta d'un immoble en lloguer",
	"Quote_sentence_14": "Finalitat de la taxació (adquisició o venta, constituir garanties hipotecàries, expropiació...)",
	"Quote_sentence_15": "Nom i telèfon de la persona de contacte per a visitar la finca",
	"Quote_sentence_16": "Plànols de la finca (opcional)",
	"At_your_disposal_for_any_clarification": "A la seva disposició per a qualsevol aclariment",
	"Kindest_regards": "Rebi les nostres cordials salutacions",
	"CFO_CHRO_female": "Directora de Finances i Recursos Humans",
	"Additional_costs": "Altres imports",
	"Quote_sentence_17": "En el cas de ser necessària l'assistència del tècnic als jutjats per ratificació de l'informe el cost serà de",
	"Quote_sentence_18": "L'entrega de  l'informe es farà en format digital (PDF). En cas de requerir-se l'entrega de l'informe en paper, el cost serà de 15 € en concepte d'impressió i enviament",
	"Appraisal_invoice": "Factura",
	"Appraisal_invoices": "Factures",
	"Add_appraisal_invoice": "Afegir factura",
	"Title_and_date_of_invoice": "Títol i data de factura",
	"valuated_in_this_invoice": "valorats en aquesta factura",
	"Invoice_title_missing_error_text": "Manca el títol de la factura",
	"Print_invoice_in_PDF": "Imprimir factura en PDF",
	"Valuation_invoice": "Factura",
	"Invoice": "Factura",
	"Client": "Client",
	"Invoice_number": "Nº de factura",
	"Invoice_content": "Contingut de la factura",
	"Invoice_title": "Títol de la factura",
	"Add_petitioner": "Afegir sol·licitant",
	"Create_new_contact": "Crear nou contacte",
	"No_petitioners_text": "No s'ha afegit cap contacte a la llista de sol·licitants. Selecciona un contacte i afegeix-lo a la llista fent click a 'afegir sol·licitant'",
	"No_records": "No hi ha registres",
	"Quotes_requested_by": "Pressupostos sol·licitats per",
	"Dear_sir_or_madam": "Benvolgut Sr. / Sra.",
	"Dear_sirs_or_madams": "Benvolguts Srs. / Sres.",
	"Dear_sir": "Benvolgut senyor",
	"Dear_madam": "Benvolguda senyora",
	"Dear_sirs": "Benvolguts senyors",
	"Dear_madams": "Benvolgudes senyores",
	"Dear_madams_and_sirs": "Benvolgudes senyores i senyors",
	"Dear_madam_and_sir": "Benvolguda senyora i senyor",
	"Dear_pl": "Benvolguts",
	"Dear_pl_f_m": "Benvolgudes i benvolguts",
	"Dear_pl_f": "Benvolgudes",
	"Dear_pl_m": "Benvolguts",
	"Main_email": "Adreça d'e-mail principal",
	"Add_other_email": "Afegir e-mail addicional",
	"Complete_name": "Nom complet",
	"Payment_conditions": "Condicions de pagament",
	"Note_w": "Nota",
	"Final_price": "Preu final",
	"Discount_pct": "Descompte (%)",
	"Discount_notes": "Observacions sobre el descompte",
	"Bank_name": "Nom del banc",
	"Court_assistance_fees": "Honoraris assistència judici",
	"Required_docs": "Documentació necessària",
	"Documentation_type": "Tipus de documentació",
	"Add_required_doc": "Afegir a la llista",
	"Document": "Document",
	"Petitioners_missing_error_text": "Falta indicar el sol·licitant de pressupost",
	"Realestates_missing_error_text": "Falta indicar els immobles del pressupost",
	"Requireddocs_missing_error_text": "Falta indicar la documentació necessària",
	"Discount": "Descompte",
	"Fees_incl_discount": "Honoraris amb descompte",
	"Quote_reference": "Pressupost associat a la factura",
	"Invoice_lines": "Línies de factura",
	"Add_invoice_line": "Afegir línia de factura",
	"Units": "Unitats",
	"Import_quote_concepts": "Importar conceptes del pressupost",
	"invoice": "factura",
	"line": "línia",
	"Lines_missing_error_text": "Falta introduir els conceptes de la factura",
	"Concept": "Concepte",
	"Add_client": "Afegir client",
	"Complete_fiscal_address": "Adreça fiscal completa",
	"Appraisal_invoice_description": "Descripció de la factura",
	"Invoice_to": "Factura a",
	"Emited_by": "Emesa per",
	"Invoice_Total": "Total Factura",
	"Emmission_date": "Data d'emissió",
	"Reference": "Referència",
	"Appraisal_invoices_index": "Índex de Factures",
	"Appraisal_quotes_index": "Índex de Pressupostos",
	"Invoice_fiscal_number": "Nº fiscal de factura",
	"Billing": "Facturació",
	"invoice_fiscal_number": "nº fiscal de factura",
	"Last_m": "Últim",
	"invoice_number": "nº de factura",
	"Last_created_invoice": "Última factura creada",
	"Welcome": "Benvingut",
	"Ad_description": "Descripció de l'anunci",
	"Upload_to_database": "Desar i incorporar a la base de dades",
	"Address_referral": "Adreça de referència",
	"Max_distance": "Distància màx.",
	"Print_report_s_certificate_in_PDF": "Imprimir informe/certificat en PDF",
	"Appraisal_certificate": "Certificat de taxació",
	"Certificate_text_01": "Ferran López-Doriga Fontcuberta, Arquitecte Superior, en qualitat de Director i Supervisor de Taxacions de BARNA-TASA, S.A., inscrita en el Registre Oficial de Societats de Taxació del Banco de España, amb el nº 4.470 i data d'inscripció 26 de Juny de 1.995,",
	"Certificate_text_02": "Que amb el número d'Expedient",
	"Certificate_text_03": "s'ha efectuat un informe de taxació amb data",
	"Certificate_text_04": "i la taxació consta en resum de les següents dades",
	"Certificate_text_05": "Per a que consti als efectes oportuns, firmo el present certificat a Barcelona, ",
	"certifies": "certifica",
	"Petitioner_TIN": "NIF del sol·licitant",
	"Petitioner_address": "Adreça del sol·licitant",
	"registered_in": "inscrita en",
	"from_the": "del",
	"Method_used_to_calculate_the_value": "Mètode utilitzat per calcular el valor adoptat",
	"Cost_value_current_state": "Valor del Cost a estat actual",
	"Comparison_value": "Valor de Comparació",
	"Maximum_legal_value": "Valor Màxim Legal",
	"Adjusted_market_value": "Valor de Mercat Ajustat",
	"Total_appraisal_value": "Valor total de taxació",
	"Real_estates_missing_error_text": "Manca afegir els immobles que conformen l'informe de taxació",
	"Sign_quote": "Signar pressupost",
	"Sign_appraisalreport": "Signar informe de taxació",
	"Appraiser_sign_appraisalreport": "Signar informe de taxació (Taxador)",
	"Supervisor_sign_appraisalreport": "Signar informe de taxació (Supervisor)",
	"Sign_invoice": "Signar factura",
	"Sign_certificate": "Signar certificat",
	"Signature": "Signatura",
	"Appraisers_signature": "Firma del Taxador",
	"Supervisors_signature": "Firma del Supervisor",
	"Main_telephonenumber": "Nº de telèfon principal",
	"Purpose": "Finalitat",
	"BEC_expenses_plus_builders_benefit_pct": "% de despeses i benefici del promotor en el preu del BEC",
	"pkg_number": "Nº de plaça",
	"Index": "Índex",
	"Cession_type": "Tipus de cessió",
	"Real_right_type": "Tipus de dret real",
	"Reports": "Informes",
	"Other_files": "Altres documents",
	"Construction_reposition_cost_as_new": "Cost de reposició de la construcció a nou",
	"Construction_value_in_actual_state": "Valor de la construcció a estat actual",
	"executed_construction": "construcció realitzada",
	"Integrity": "Integritat",
	"remaining": "restant",
	"or": "o",
	"Project": "Projecte",
	"Projects": "Projectes",
	"Add_project": "Afegir projecte",
	"Projects_of_the_Real_Estate": "Projectes",
	"BDE_files_index": "Índex de fitxes del BDE",
	"BDE_files": "Fitxes del BDE",
	"Asset_type": "Tipus d'actiu",
	"Property_usage": "Ús de l'immoble",
	"Parking_spots_included_number": "Nombre de places de pàrquing incloses",
	"BdE_appraisal_files": "Taxacions",
	"BdE_realestate_files": "Immobles",
	"BdE_comparable_files": "Comparables",
	"BdE_relationships_files": "Relacions",
	"Insurance_value_rd_1982_text": "Valor de reemplaçament brut, exclòs el valor del terreny",
	"Insurance_value_rd_2009_text": "Valor de taxació, exclòs el valor del terreny",
	"VAT_not_included": "IVA no inclòs",
	"EEC_conditions": "Habitatges de fins a 100 m² a l'Àrea Metropolitana de Barcelona: 125 €+ IVA",
	"OCC_conditions": "Habitatges de fins a 100 m² a l'Àrea Metropolitana de Barcelona: 125 €+ IVA",
	"EECOCC_conditions": "Habitatges de fins a 100 m² a l'Àrea Metropolitana de Barcelona: 210 €+ IVA",
	"OT_conditions": "Altres tipologies segons pressupost"
};

/***/ }),
/* 2282 */
/***/ (function(module, exports) {

module.exports = {
	"A_BdE_homologated_company": "Company homologated by the Banco de España",
	"About_BARNATASA": "About BARNA-TASA, S.A.",
	"About_text_01": "BARNA-TASA is an Appraisal Company, homologated by the Banco de España, inscribed in the Official Register of Appraisal Entities with nº 4.470 and registration date: June 26th 1.995",
	"About_text_02": "The company is formed by a group of architects, engineers and specialists in the real estate appraisal and valuation field and count with a wide knowledge in the area, with more than 30 years of experience",
	"About_us": "About Us",
	"acc_Budget": "acc. Budget",
	"acc_appraisal_date": "acc. appraisal date",
	"Actions": "Actions",
	"Ad": "Ad",
	"Ads": "Ads",
	"Ad_address": "Address as stated in the ad",
	"Adaptability": "Adaptability",
	"Ad_code": "Ad code",
	"Ad_data_type": "Ad data type",
	"Ad_database_query": "Ad database query",
	"Ad_date": "Ad date",
	"Ad_type": "Ad type",
	"Add_address": "Add new address",
	"Add_appraisal": "Add appraisal",
	"Add_appraisal_file": "Add appraisal file",
	"Add_appraisal_report": "Add appraisal report",
	"Add_contact": "Add new contact",
	"Add_entity": "Add entity",
	"Add_email": "Add new email",
	"Add_market_study": "Add market study",
	"Add_real_estate": "Add real estate",
	"Add_room": "Add room",
	"Add_telephone_number": "Add new telephone number",
	"Add_to_comparables_list": "Add to comparables list",
	"Address": "Address",
	"Address_description": "Address description",
	"Addresses": "Adresses",
	"Adjusted_Comparison_Method": "Adjusted Comparison Method",
	"Adopted_age": "Adopted age",
	"Adopted_area": "Adopted area",
	"Adopted_building_market_value": "Adopted building market value",
	"Adopted_material_execution_cost": "Adopted material execution cost",
	"Adopted_material_execution_cost_deprecated_by_antiquity": "Adopted material execution cost deprecated by antiquity",
	"Adopted_value": "Adopted value",
	"Air_conditioning": "Air conditioning",
	"and": "and",
	"and_limit_date": "and limit date",
	"annexes": "annexes",
	"Annexes": "Annexes",
	"Age": "Age",
	"Agravation_or_improvement_coeficient": "Agravation or improvement coeficient",
	"Addressing_title": "Addressing title",
	"Advertisements_between_starting_date": "Advertisements between starting date",
	"appraisal": "appraisal",
	"Appraisal": "Appraisal",
	"appraisal_company": "appraisal company",
	"appraisal_file": "appraisal file",
	"Appraisal_date": "Appraisal date",
	"Appraisal_description": "Appraisal description",
	"Appraisal_file": "Appraisal file",
	"Appraisal_files": "Appraisal files",
	"Appraisal_file_description": "Appraisal file description",
	"Appraisal_files_index": "Appraisal files index",
	"Appraisal_purpose": "Appraisal purpose",
	"appraisal_report": "appraisal report",
	"Appraisal_report": "Appraisal report",
	"Appraisal_report_description": "Appraisal report description",
	"Appraisal_reports": "Appraisal reports",
	"Appraisal_petitioner": "Appraisal petitioner",
	"Appraisal_petitioners": "Appraisal petitioners",
	"Appraisal_Requests": "Appraisal Requests",
	"Appraisal_type": "Appraisal type",
	"Appraisal_total_value_determination": "Appraisal total value determination",
	"Appraisal_value": "Appraisal value",
	"Appraisals": "Appraisals",
	"Appraisals_and_valuations": "Appraisals and valuations",
	"Appraisals_Index": "Appraisals Index",
	"Appraisals_for_all_purposes": "Appraisals for all purposes",
	"Appraisals_of_the_Real_Estate": "Appraisals of the Real Estate",
	"Appraised": "Appraised",
	"Appraised_real_estates": "Appraised Real Estates",
	"Appraised_real_estates_in_this_report": "Real Estates appraised in this report",
	"Appraised_real_estate": "Appraised Real Estate",
	"Appraiser": "Appraiser",
	"Approximate_property_area": "Approximate property area",
	"Area": "Area",
	"Areas": "Areas",
	"areas": "areas",
	"Are_you_sure_q": "Are you sure?",
	"As_new_construction_cost": "As new Construction Cost",
	"Assets_value_update": "Assets value update",
	"Assurance": "Assurance",
	"at": "at",
	"Auditors": "Auditors",
	"average": "average",
	"Average": "Average",
	"Back_home": "Back home",
	"Back_to_safety": "Back to safety",
	"Bare_ownership": "Bare ownership",
	"Bare_ownership_value": "Bare ownership value",
	"Barnatasa_cover_short_description": "Company specialized in Valuations and Appraisals",
	"Barnatasa_header": "BARNA-TASA, S.A. registered in the Official Registry of Appraisal Entities from the Banco de España with number 4.470. Inscription date: 26/06/1.995",
	"Barnatasa_footer": "End of page. Reverse unusable. Any annotation on the back is null and without effect.",
	"Barnatasa_header_portrait": "BARNA-TASA, S.A. registered in the Official Registry of Appraisal Entities from the Banco de España with nº 4.470, Date 26/06/1995. Reg. Merc. Barcelona, Page 12, Volume 28.173 Page B-132.666, TIN A-60840543",
	"Bathrooms": "Bathrooms",
	"Bathrooms_number": "Bathrooms number",
	"BdE_code": "BdE code",
	"Bedrooms": "Bedrooms",
	"Bedrooms_number": "Bedrooms nº",
	"Block": "Block",
	"Building_Surveys": "Building surveys",
	"Buildings": "Buildings",
	"Buildings_useful_life": "Building's useful life",
	"Built_area": "Built area",
	"Budget_request": "Budget request",
	"Builders_general_expenses_percentage": "Builder's general expenses percentage",
	"Builders_general_expenses": "Builder's general expenses",
	"Builders_expenses_and_benefit_percentage": "Builder's expenses and benefit percentage",
	"Builders_expenses_and_benefit": "Builder's expenses and benefit",
	"Builders_industrial_benefit_percentage": "Builder's industrial benefit percentage",
	"Builders_industrial_benefit": "Benefici industrial del constructor",
	"Building_market_value": "Building market value",
	"real_estate_under_construction": "building under construction",
	"by": "by",
	"By": "By",
	"Cadastral_area": "Cadastral area",
	"Cadastral_data_check": "Cadastral data check",
	"Cadastral_data": "Cadastral data",
	"Cadastral_List": "Cadastral List",
	"Cadastral_Map": "Cadastral Map",
	"Cadastral_reference": "Cadastral reference",
	"Cadastral_Reference_less_20_positions_error_text": "The Cadastral Reference has less than 20 positions",
	"Calculate_values": "Calculate values",
	"Calendar": "Calendar",
	"Cancel": "Cancel",
	"Capture_date": "Capture date",
	"Catalan": "Catalan",
	"Census_section": "Census section",
	"Census_section_code": "Census section code",
	"certificates": "certificates",
	"cession": "cession",
	"Cession": "Cession",
	"Cession_contract_period_years": "Contract period in years",
	"Cession_contract_remaining_years": "Remaning contract years",
	"Cession_contract_start_date": "Contract start date",
	"Cession_gross_monthly_income": "Rent gross monthly income",
	"Cession_gross_yearly_income": "Rent gross yearly income",
	"Cession_net_yearly_income": "Rent net yearly income",
	"Clients_text_01": "BARNA-TASA, S.A. has an extensive client portfolio and works with all kinds of clients, both from the private and public sector. To be mentioned",
	"Clients_text_02": "BARNA-TASA S.A. offers a wide range of services aimed at assisting in decision-making regarding the valuation and verification of the real estate and other assets",
	"Clients_text_03": "The aim of BARNA-TASA, S.A. is to provide support to the clients of the best national and international law firms and auditors in those operations that require a real estate valuation. From a valuation for an expropriation process to the necessary valuations in merger and acquisition operations, advice on asset divestment and restructuring, covering any sector",
	"Clients_text_04": "A business environment like the current one generates the necessity to undertake complex projects and, at the same time, key decision making every day for the enterprises. Knowing this circumstances, BARNA-TASA S.A. offers its experience, professionalism and market knowledge to both small and big sized companies and financial institutions through a wide range of services, ensuring a personalized and professional treatment",
	"closed": "closed",
	"Changes_will_be_lost_p_continue_q": "Changes will be lost. Continue?",
	"Checks": "Checks",
	"Checks_performed": "Performed checks",
	"Code": "Code",
	"Commercial_premises": "Commercial premises",
	"Commission": "Commision",
	"Commitment": "Commitment",
	"Company_code": "Company code",
	"Company_or_business_name": "Company or business name",
	"Comparable_database_query": "Comparable database query",
	"Comparable_type": "Type of comparable",
	"comparables": "comparables",
	"Comparables": "Comparables",
	"Comparison_Method": "Comparison Method",
	"Confidentiality": "Confidentiality",
	"Confirm_Password": "Confirm Password",
	"Conservation": "Conservation",
	"Conservation_status": "Conservation status",
	"Constant_income_with_CPI_update_clause": "Constant income with Consumer Price Index update clause",
	"construction": "construction",
	"Construction": "Construction",
	"Construction_cost": "Construction cost",
	"Construction_cost_and_development_expenses": "Construction cost and development expenses",
	"Construction_cost_by_contract": "Construction cost by contract",
	"Construction_costs": "Construction costs",
	"Construction_progress_percentage": "Construction progress percentage",
	"Construction_replacement_cost": "Construction replacement cost",
	"Construction_value": "Construction value",
	"construction_year": "construction year",
	"Construction_year": "Construction year",
	"Contact": "Contact",
	"Contact_data": "Contact data",
	"Contact_Data": "Contact Data",
	"Contact_file": "Contact file",
	"Contact_name": "Contact name",
	"Contact_telephone": "Contact telephone",
	"Contacts": "Contacts",
	"Contacts_Index": "Contacts Index",
	"contained_in_this_file": "contained in this file",
	"contained_in_this_file_f": "contained in this file",
	"Continue_q": "Continue?",
	"Contracts_foreseeable_remaining_period": "Contract's foreseeable remaining period",
	"Cooperatives": "Cooperatives",
	"Corrected_market_value": "Corrected market value",
	"Corrected_unit_market_value": "Corrected unit value",
	"Correction": "Correction",
	"Correction_of_values": "Correction of values",
	"Cost_method": "Cost method",
	"Council_classification": "Council Classification",
	"Council_classification_description": "Council Classification Description",
	"Council_qualification": "Council Qualifitacion",
	"Council_qualification_description": "Council Qualification Description",
	"Regional_classification": "Regional Classification",
	"Regional_classification_description": "Regional Classification Description",
	"Regional_qualification": "Regional Qualification",
	"Regional_qualification_description": "Regional Qualification Description",
	"Country": "Country",
	"Country_s_State": "Country / State",
	"Covered_outdoor_area": "Covered outdoor area",
	"Create_a_new_contact": "Create a new contact",
	"Created": "Created",
	"Creation": "Creation",
	"Current_reversion_value_calculation": "Current reversion value calculation",
	"Current_value_of_future_rents": "Current value of future rents",
	"Customer_Service": "Customer Service",
	"Customer_Service_text_01": "offers the clients their",
	"Customer_Service_text_02": "to which they can direct their suggestions and complaints in accordance to the service provided by the Company",
	"Customer_Service_text_03": "The functions of the CS are",
	"Customer_Service_text_04": "Attend and address the complaints and inquires which are presented, directly or through representation, by natural or legal persons, national or foreigners, clients of the Company, whenever they reference the interests or rights that are legally acknowledged to be related with the operations, contracts or services provided by the company, both if they derivate from the main contracts or the regulations for the transparency, client protection or good practices and uses, in particular with the equity principle",
	"Customer_Service_text_05": "Deliver to the directorate of the company all the recommendations and suggestions that, in their opinion, will improve the good relationship and mutual trust that should exist between the company and its clients",
	"Customer_Service_text_06": "The information duties of this CS are reflected in the current legislation Orden ECO/734/2004, from march 11th, about the departments and customer services of the financial entities",
	"Customer_Service_text_07": "Access to the Customer Service Regulations from BARNA-TASA, S.A.",
	"Customer_Service_text_08": "Access to the claims sheet",
	"Customer_Service_text_09": "Applicable legislation for the defense of the client of financial services",
	"Customer_Service_text_10": "Law 2/2011 from march 4th of Sustainable Economy",
	"Customer_Service_text_11": "ECC/2502/2012 from November 16th",
	"Customer_Service_text_12": "ECO/734/2004 from March 11th",
	"Customer_Service_text_13": "You can contact us trough the following options",
	"Customer_Service_text_14": "In person, in the Customer Service office (from 10:00 to 13:00 and from 16:00 to 19:00). Address",
	"Customer_Service_text_15": "By certified mail, addressed to",
	"Customer_Service_text_16": "A complaint form is available to the customers, that you will found in this",
	"Customer_Service_text_17": "The form is voluntary and will contain the following information",
	"Customer_Service_text_18": "Name and Surnames of the interested",
	"Customer_Service_text_19": "Domicile address of the interested (and if applicable, the address of the representative)",
	"Customer_Service_text_20": "Natural persons: the Tax Identification Number of the interested",
	"Customer_Service_text_21": "Legal persons: the Tax Identification Number and the Commercial Registry data",
	"Customer_Service_text_22": "Reason for the complaint, clearly specifying the issues on which a ruling is requested",
	"Customer_Service_text_23": "Número de expediente de tasación",
	"Customer_Service_text_24": "Lugar, fecha y firma",
	"Customer_Service_text_25": "Documentary evidence (if it is applicable)",
	"Customer_Service_text_26": "In the event of exhausting all the avaiable routes through the Customer Service (denied, dismissed or more than two months elapsed without resolution), a complaint may be filed in the Departamento de Conducta de Mercado y Reclamaciones of the Banco de España whose contact details are",
	"Customer_Service_text_27": "Or online through the virtual office",
	"Data": "Data",
	"Data_tabulation": "Data tabulation",
	"date": "date",
	"Date": "Date",
	"Data_of_property_to_be_appraised": "Data of property to be appraised",
	"Date_of_the_appraisal_value": "Date of the appraisal value",
	"Date_of_report": "Date of report",
	"Date_of_quote": "Date of quote",
	"Date_of_invoice": "Date of invoice",
	"Delete": "Delete",
	"Deprecated_construction_cost": "Deprecated construction cost",
	"Depreciation_by_antiquity": "Depreciation by antiquity",
	"description": "description",
	"Description": "Description",
	"Discard": "Discard",
	"Distance": "Distance",
	"Door": "Door",
	"Duplicate": "Duplicate",
	"Dwellings": "Dwellings",
	"Dwelling_type": "Tipo de vivienda",
	"e-mail": "e-mail",
	"E-mail": "E-mail",
	"E-mail_address": "E-mail address",
	"E-mail_addresses": "E-mail addresses",
	"E-mail_description": "E-mail description",
	"Email": "E-mail",
	"Email address": "E-mail address",
	"Edit": "Edit",
	"Edit_ad": "Edit ad",
	"Edit_address": "Edit address",
	"Edit_Appraisal": "Edit appraisal",
	"Edit_real_estate": "Edit real estate",
	"Edit_Real_Estate": "Edit Real Estate",
	"Edit_contact": "Edit contact",
	"Email_Address": "E-mail Address",
	"Energy_Certificates": "Energy Certificates",
	"Energy_Efficiency_Certificate": "Energy Efficiency Certificate",
	"Entities": "Entities",
	"Entities_Index": "Entities Index",
	"Entity": "Entity",
	"EPSG_missing_text": "Coordinates X and Y EPSG:25831 are missing. They are necessary in order to retrieve the cadastral and census section data. They can be obtained pressing the Geolocate button",
	"Estimated_sale_price": "Estimated sale price",
	"Estimated_unit_sale_price": "Estimated unit price",
	"Estimated_useful_life": "Estimated useful life",
	"Executed_construction_cost": "Executed construction cost",
	"Expected_Income_Update_Method": "Expected Income Update Method",
	"Experience": "Experience",
	"Experience_text": "More than 30 years of experience offering the best service at the best price",
	"Expert_Opinions": "Expert Opinions",
	"expert_opinions": "expert opinions",
	"Expropriations": "Expropriations",
	"External_storage_room": "Storage room",
	"features": "features",
	"Features": "Features",
	"Fees": "Fees",
	"file": "file",
	"File": "File",
	"File_description": "File description",
	"Files": "Files",
	"File_number": "File nº",
	"Final_unit_price": "Final unit price",
	"Financial_Entities": "Financial Entities",
	"finished_real_estate": "Finished Real Estate",
	"finishes": "finishes",
	"Finishes": "Finishes",
	"fixtures": "fixtures",
	"Fixtures": "Fixtures",
	"Fiscal_Address": "Fiscal Address",
	"Fiscal_address": "Fiscal address",
	"Floor": "Floor",
	"Floor_number": "Floor nº",
	"Floor_type": "Floor type",
	"For_all_purposes": "For all purposes",
	"Foundations": "Foundations",
	"Freemarket_benefit": "Free-market benefit",
	"Fri.": "Fri.",
	"from": "from",
	"Functional_depreciation": "Functional depreciation",
	"General_data": "General data",
	"Green_areas": "Garden / Green areas",
	"Have_an_account_q_Log_in": "Have an account? Log in",
	"Heating": "Heating",
	"Height_situation": "Height situation",
	"Higher_values": "Higher values",
	"Home_text_01": "Official Appraisal Company, from 1995, in the Official Register for Appraisal Entities of the Banco de España",
	"homogenisation": "homogenisation",
	"Homogenisation": "Homogenisation",
	"Homogenisation_of_values": "Homogenisation of values",
	"Homologated_Appraisal_Company_c_since_1995": "Homologated Appraisal Company, since 1995",
	"Homologated_company": "Homologated company",
	"Homologated_text_01_part01": "Company inscribed in the",
	"Homologated_text_01_part02": "of Appraisal Entities of the Banco de España, with nº 4470 and date 26/06/1995",
	"Honorarium_c_taxes_and_licenses": "Honorarium, taxes and licenses",
	"Honorarium_c_taxes_and_licenses_percentage": "Honorarium, taxes and licenses percentage",
	"Hospitals": "Hospitals",
	"Hotels": "Hotels",
	"Decennial_insurance_policy_expenses": "Decennial insurance policy expenses",
	"Decennial_insurance_policy_expenses_percentage": "Decennial insurance policy expenses percentage",
	"Developers_administrative_expenses": "Developer's administrative expenses",
	"Developers_administrative_expenses_percentage": "Developer's administrative expenses percentage",
	"Developers_benefit": "Developer's benefit",
	"Development_expenses": "Development expenses",
	"Development_expenses_percentage": "Development expenses percentage",
	"Geographical_area": "Geographical area",
	"Geolocate": "Geolocate",
	"Identification": "Identification",
	"go_back": "go back",
	"Go_back": "Go back",
	"go_up": "go up",
	"Go_up": "Go up",
	"Gross_Replacement_Cost": "Gross Replacement Cost",
	"Gross_yearly_rent_income": "Gross yearly rental income",
	"in_01": "in",
	"In_accordance_with_eco_decree_q": "In acc. with ECO Decree?",
	"In_accordance_with_mortgage_market_law_q": "In acc. with Mortgage Market Law?",
	"Independence": "Independence",
	"Independent_professionals": "Independent professionals",
	"Independent_pl": "Independent",
	"Index_of_Appraisals": "Index of Appraisals",
	"Individuals": "Individuals",
	"Industrial_warehouses": "Industrial warehouses",
	"Info_source": "Information source",
	"Infrastructures": "Infrastructures",
	"Paving_execution_pct": "Paving execution percentage",
	"Sewage_execution_pct": "Sewage execution percentage",
	"Public_lighting_execution_pct": "Public lighting execution percentage",
	"Water_supply_execution_pct": "Water supply execution percentage",
	"Electricity_supply_execution_pct": "Electricity supply execution percentage",
	"Piped_gas_execution_pct": "Piped gas execution percentage",
	"Telephone_service_execution_pct": "Telephone service execution percentage",
	"Gardened_areas_execution_pct": "Gardened areas execution percentage",
	"Total_execution_pct": "Infrastructures total execution percentage",
	"Infrastructures_repercussion_cost": "Infrastructures repercussion cost",
	"Pending_investment": "Pending investment",
	"Paving": "Paving",
	"Sewage": "Sewage",
	"Public_lighting": "Public lighting",
	"Electricity_supply": "Electricity supply",
	"Piped_gas": "Piped gas",
	"Telephone_service": "Telephone service",
	"Gardened_areas": "Gardened areas",
	"Land_is_plot_according_to_law": "Is the terrain considered a plot according to the Ley del Suelo?",
	"Notes_on_plot_infrastructures": "Notes on the infrastructures",
	"Notes_on_plot_area": "Notes on the area of the terrain",
	"Informative_Appraisal_Fees": "Informative Appraisal Fees",
	"Initial_Data": "Initial Data",
	"Initial_unit_price": "Initial unit price",
	"Innovation": "Innovation",
	"Insurance_companies": "Insurance companies",
	"Insurance_value": "Insurance value",
	"Interior_visit_check": "Interior visit check",
	"Internal_regulation": "Internal regulation",
	"Invalid_email_address": "Invalid email address",
	"Investment_groups": "Investment groups",
	"Invoices": "Invoices",
	"Is_it_rented_or_ceded_q": "Is the Real Estate rented or ceded?",
	"Is_the_real_estate_protected_q": "Is the Real Estate protected?",
	"Is_the_right_of_use_ceded_q": "Is the Real Estate's right of use ceded?",
	"land": "land",
	"Land": "Land",
	"Land_area": "Land area",
	"Land_registry_area": "Land registry area",
	"Land_pl": "Land",
	"Land_total_value": "Land total value",
	"Land_value": "Land value",
	"Land_value_plus_deprecated_construction_cost": "Land value plus deprecated construcion cost",
	"Land_value_plus_executed_construction_cost": "Land value plus executed construcion cost",
	"Landlord_expenses_pct": "Remaining net income percentage due to landlord's expenses",
	"Language": "Language",
	"Last_modified": "Last modified",
	"last_renovation_year": "last renovation year",
	"Last_renovation_year": "Last renovation year",
	"Appraisal_adopted_area_missing_error_text": "The built area of the appraised property is missing",
	"Appraisal_property_type_missing_error_text": "The property type is missing",
	"Lat_lng_missing_error_text": "The coordinates (latitude and longitude) for the real estate are missing",
	"Ad_type_missing_error_text": "The ad type is missing",
	"Date_missing_error_text": "The dates are missing",
	"Adopted_age_missing_error_text": "Adopted age is missing",
	"Adopted_age_length_error_text": "Adopted age should be a year, and have the format 'YYYY'",
	"Adopted_area_missing_error_text": "Built area is missing",
	"Property_type_missing_error_text": "Realestate type is missing",
	"Land_market_value": "Land market value",
	"Latitude": "Latitude",
	"Law_firms": "Law firms",
	"Lift": "Lift",
	"link": "link",
	"Loading": "Loading",
	"Log_In": "Log In",
	"Longitude": "Longitude",
	"Looking_for_something_q": "Looking for something?",
	"Lower_limit": "Lower limit",
	"Machinery": "Machinery",
	"Market_coeficient": "Market coeficient",
	"Market_value_adjustment": "Market value adjustment",
	"Market_value_of_the_appraised_realestate": "Market value of the appraised realestate",
	"Market": "Market",
	"Market_calculations": "Market calculations",
	"Market_studies_for_this_real_estate": "Market studies for this real estate",
	"Market_study": "Market study",
	"Market_study_for": "Market study for",
	"Market_unit_value": "Market unit value",
	"Market_value": "Market value",
	"Market_value_reduction_pct": "Market value reduction (%)",
	"Market_studies": "Market studies",
	"Material_execution_cost": "Material execution cost",
	"Materials": "Materials",
	"Maximum_legal_computable_area": "Maximum legal computable area",
	"Maximum_legal_sale_price": "Maximum legal sale price",
	"Maximum_Legal_Method": "Maximum Legal Method",
	"Mec_adjustment_coef": "Adjustment coefficient of the material execution cost ",
	"Measurements": "Measurements",
	"Medical_centers": "Medical centers",
	"Messages": "Messages",
	"Metadata": "Metadata",
	"Minimum_benefit_acc_to_regulation": "Minimum benefit according to regulation",
	"Minimum_fees": "Minimum fees",
	"Modification": "Modification",
	"Modified": "Modified",
	"Mon.": "Mon.",
	"Mortgage_Appraisal_Fees": "Mortgage Appraisal Fees",
	"Municipality": "Municipality",
	"Mutual_insurance_companies": "Mutual insurance companies",
	"Name": "Name",
	"Name_and_surnames": "Name and surnames",
	"Name_and_TIN": "Name and Tax Identification Number",
	"net_area": "net area",
	"Net_area": "Net area",
	"Net_areas": "Net areas",
	"Net_Replacement_Cost": "Net Replacement Cost",
	"Net_yearly_rent_income": "Net yearly rental income",
	"New_address": "New address",
	"New_appraisal_file": "New appraisal file",
	"New_contact": "New contact",
	"New_entity": "New entity",
	"Number": "Number",
	"Number_of_floors_and_use": "Number of floors and use",
	"No_address_registered": "No address registered",
	"No_contact_registered": "No contact registered",
	"No_email_address_registered": "No email address registered",
	"No_telephone_number_registered": "No telephone number registered",
	"No_results": "No results",
	"Non_recoverable_taxes": "Non-recoverable taxes",
	"Non_recoverable_taxes_percentage": "Non-recoverable taxes percentage",
	"Not_found_message": "Page not found",
	"notes": "notes",
	"Notes": "Notes",
	"Notes_1": "Notes 1",
	"Notes_2": "Notes 2",
	"Notes_on_mortgage_valuation_validity": "Notes on the validity of the valuation for mortgage guarantees",
	"Occupancy_Card": "Occupancy Card",
	"Occupancy_Cards": "Occupancy Cards",
	"Occupancy_Card_and_Certificate": "Occupancy Card and Certificate",
	"Occupancy_Certificate": "Occupancy Certificate",
	"occupancy_certificates": "occupancy certificates",
	"of": "of",
	"of_the_excess_of": "of the excess of",
	"of_the_same_property": "of the same property",
	"Office_hours": "Office hours",
	"Offer_price": "Offer price",
	"Offer_unit_price": "Offer unit price",
	"Official_Appraisals": "Official Appraisals",
	"Official_appraisals_for_all_purposes": "Official appraisals for all purposes",
	"Official_Register": "Official Register",
	"Offices": "Offices",
	"Open": "Open",
	"Open_link_in_new_tab": "Open link in new tab",
	"Organization_s_Company": "Organization / Company",
	"Orientation": "Orientation",
	"Other_elements_included_in_this_valuation_price": "Other elements included in this valuation price",
	"Other_services": "Other services",
	"other_services": "other services",
	"others": "others",
	"Our_clients": "Our clients",
	"Our_services": "Our services",
	"Our_workflow": "Our workflow",
	"PA_registration_number": "PA reg. number",
	"Page_not_found": "Page not found",
	"Parking_lots_number": "Parking lots number",
	"Parking_spaces": "Parking spaces",
	"Password": "Password",
	"Person_type": "Person type",
	"Petitioner": "Petitioner",
	"Petitioner_data": "Petitioner data",
	"Petitioner_type": "Petitioner type",
	"Philosophy": "Filosofia",
	"Philosophy_text_01": "The company's vision can be summarized in three fundamental principles: professionalism, rapidity and ethics. All together with a good team of professionals and a thorough quality control",
	"Philosophy_text_02": "Our values define our identity as a company and constitute the driving force of how we do our work day by day. We believe that our success is a consequence of them, among which we highlight",
	"Philosophy_text_03": "Continuous auditing of our appraisal and valuation processes together with the use of the latest technologies. BARNA-TASA, S.A. has specially developed software for the valuation process using the most appropriate computer tools. All our reports include digital signature certification",
	"Philosophy_text_04": "It is a company whose shareholders and board of directors is private and NOT LINKED to any Financial Institution or real estate group. BARNA-TASA, S.A not intermediate in transactions of sale in the market, reason why its services lend themselves of the most absolute independence",
	"Philosophy_text_05": "Responsiveness, effectiveness and balance of our assessments. Commitment to fulfill the requirements and processes required for customer satisfaction",
	"Philosophy_text_06": "Our quality system is based on the following principles: Continuous improvement and improvement as a permanent objective, which is achieved especially through the commitment of the entire organization and the systematic analysis of quality results. To satisfy the needs and expectations of the customers, fulfilling the delivery times agreed with the clients and working on the improvement of them, always delivering a good product to the first one. Compliance with the requirements, whether regulatory and legal, particular of our clients or any other, thus giving response to all interested parties",
	"Philosophy_text_07": "Ensure compliance with current regulations and work well done",
	"Philosophy_text_08": "The fact that they are registered and registered with the number 4,470 in the Register of Valuation Companies of the Banco de España and subject to supervision, guarantees the strictness of objectivity and absolute transparency of our valuation reports",
	"Philosophy_text_09": "More than three decades in the field of appraisal endorse our work",
	"Philosophy_text_10": "The confidentiality of the work required by the regulations is guaranteed by the professional secrecy that governs the conduct of our technicians. BARNA-TASA S.A. Does not disclose information to third parties",
	"Philosophy_text_11": "BARNA-TASA, S. A. establishes a framework of conduct for society and its workers",
	"Physical_depreciation": "Physical depreciation",
	"Pick_an_option": "Pick an option",
	"Plan_type": "Planning type",
	"Please_enter_a_name": "Please enter a name",
	"Please_enter_a_surname": "Please enter a surname",
	"Please_enter_a_telephone_number": "Please enter a telephone number",
	"Please_enter_an_email_address": "Please enter an email address",
	"Please_enter_the_type_of_property": "Please enter the type of property",
	"Please_enter_the_address_of_the_property": "Please enter the address of the property",
	"Please_enter_the_postal_code": "Please enter the postal code",
	"Please_enter_the_municipality": "Please enter the municipality",
	"Please_enter_the_area_of_the_property": "Please enter the area of the property",
	"Please_enter_the_purpose_of_the_appraisal": "Please enter the purpose of the_appraisal",
	"Plot_area": "Plot area",
	"Postal_code": "Postal code",
	"Prefix": "Prefix",
	"Price": "Price",
	"Pricing": "Pricing",
	"Pricing_and_Quotes": "Pricing and Quotes",
	"Pricing_text_01": "We offer two types of valuations: the mortgage valuation and the informative valuation, according to its purpose",
	"Pricing_text_02": "You will get a written estimate of your valuation in a maximum of 24 hours, without any commitment",
	"Pricing_text_03": "Volume discount. APPLICABLE VAT: 21%",
	"Pricing_text_04": "Mortgage valuation: Regulated by ECO regulation 805/2003 and related provisions",
	"Pricing_text_05": "The locations outside Barcelona capital and metropolitan area will have transportation fees",
	"Pricing_text_06": "Special discount for the orders of the Taxation Report + Certificate of the same property",
	"Print_report_in_PDF": "Print report in PDF",
	"Private_Enterprises": "Private Enterprises",
	"Professional_association": "Prof. Association",
	"Professional_ethics": "Professional ethics",
	"Professional_qualification": "Prof. Qualification",
	"Professionalism": "Professionalism",
	"Professionals_text_01_part_01": "A company formed by",
	"Professionals_text_01_part_02": "fully independent architects, engineers and specialists",
	"Professionals_text_01_part_03": ", without any bounds to financial institutions or business groups of any kind",
	"Properties": "Properties",
	"Properties_under_economic_exploitation": "Properties under economic exploitation",
	"Property_data": "Property data",
	"Property_developers": "Property developers",
	"Property_purchase-sale": "Property purchase-sale",
	"Property_developments": "Property developments",
	"Property_type": "Property type",
	"Property_types": "Property types",
	"Property_valuation_services": "Property valuation services",
	"Property_visit": "Property visit",
	"protection": "protection",
	"Protection": "Protection",
	"Protection_type": "Protection type",
	"Protection_regime": "Protection regime",
	"Protection_zone": "Protection zone",
	"Province": "Province",
	"Public_Administrations": "Public Administrations",
	"purpose": "purpose",
	"Qualities": "Qualities",
	"Qualities_comparison": "Qualities comparison",
	"Quality": "Quality",
	"Quality_of_construction": "Construction quality",
	"Quality_of_neighbourhood": "Neighbourhood quality",
	"Quality_of_realestate": "Realestate quality",
	"Quality_of_situation": "Situation quality",
	"Query_comparables": "Query comparables",
	"Query_real_estates": "Query Real Estates",
	"Query_result": "Query result",
	"Quote_request": "Budget request",
	"Quotes": "Budgets",
	"Real_estate": "Real Estate",
	"Real_estates": "Real Estates",
	"Real_estates_index": "Real Estates index",
	"Real_Estates_residual_value": "Valor residual de l'immoble",
	"Real_estates_residual_value_at_the_end_of_the_contracts_useful_life": "Real Estate's residual value at the end of the contract's useful life",
	"Real_estate_referral": "Real Estate Referral",
	"Realestates_remaining_useful_life": "Real Estate's remaining useful life",
	"Real_estate_value": "Real Estate value",
	"RealEstate_description": "Real Estate description",
	"Reduction": "Reduction",
	"Reduction_pct": "Reduction (%)",
	"Registry_data": "Registry data",
	"Registry_identification_data": "Registry identification data",
	"Register_name": "Name of Register",
	"Regression_line": "Regression line",
	"Regression_line_calculation": "Regression line calculation",
	"Remaining_contract_years": "Remaining contract years",
	"Remaining_period_update": "Remanining period update",
	"Remaining_of_the_developers_benefit": "Remaining of the developers benefit",
	"Repercussion_method": "Repercussion method",
	"Report": "Report",
	"reports": "reports",
	"Report_content": "Report content",
	"Report_content_text_01": "Visit of the property and preparation of an official report by a qualified technician of BARNA-TASA",
	"Report_content_text_02": "Identification and location. Property specifications. Cadastral and Registry data",
	"Report_content_text_03": "Pictures and sketch of the property",
	"Report_content_text_04": "Real market study, sample selection and value calculation",
	"Report_date": "Report date",
	"Report_language": "Report language",
	"Requesting": "Requesting",
	"Report_number": "Report number",
	"Report_title": "Report title",
	"Report_title_missing_error_text": "The report title is missing",
	"Representative": "Representative",
	"representative_sample": "representative sample",
	"Representative_sample": "Representative sample",
	"Representative_TIN": "TIN of the representative",
	"Request_a_quote": "Request a quote",
	"Request_a_quote_24h": "Request a quote (24h)",
	"Request_a_quote_here": "Request a quote here",
	"Request_a_quote_for_an_appraisal": "Request a quote for an appraisal",
	"Request_successfully_sent": "Request successfully sent",
	"Required_fields": "Required fields",
	"Residual_depreciation": "Residual depreciation",
	"Residual_value": "Residual value",
	"Restaurants": "Restaurants",
	"Restricted": "Restricted",
	"Right_of_use": "Right of use",
	"Right_of_use_value": "Right of use value",
	"rights": "rights",
	"Rights": "rights",
	"Rigor": "Rigor",
	"Risk_premium": "Risk premium",
	"Riskfree_rate": "Risk-free rate",
	"Room": "Room",
	"Rooms": "Rooms",
	"Sat.": "Sat.",
	"Save": "Save",
	"Save_and_go_back": "Save and go back",
	"Save_valuation": "Save valuation",
	"Search_radius_km": "Search radius (km)",
	"Security": "Security",
	"Selected_comparables": "Selected comparables",
	"Send_to_bde_q": "Send to BdE?",
	"Services": "Services",
	"Services_text_01": "BARNA-TASA, S.A. Is a company specialized in ASSESSMENT OF GOODS, approved and registered in the Banco de España with the number 4,470 in the Official Registry of Appraisal Entities. Our experience is based on more than 30 years of professional exercise in the field of appraisals, valuations and construction surveys",
	"Services_text_02": "Our main service is framed in the field of valuations and appraisals for all purposes. We also offer a range of services related to the world of architecture and expertise, from the elaboration of construction reports and opinions to certificates, certificates and floor surveys",
	"Services_text_03": "We carry out appraisals for all purposes. We offer two types of appraisals according to their purpose",
	"Services_text_04": "The usual type of real estate and rights that we value through the corresponding appraisal report is as follows",
	"Services_text_05": "Acceptance of the order and delivery of necessary documentation",
	"Services_text_06": "Visit to the building by a technician from BARNA-TASA",
	"Services_text_07": "Preparation of the report or reports by BARNA-TASA",
	"Services_text_08": "Delivery of the report in digital format and / or paper",
	"Sign_Up": "Sign Up",
	"Source": "Source",
	"Sports_clubs": "Sports clubs",
	"Sports_facilities": "Sports facilities",
	"Staircase": "Staircase",
	"Standard_deviation_of_the_sample": "Standard deviation of the sample",
	"Storerooms": "Storerooms",
	"Street_name": "Street",
	"Street_number": "Nº",
	"Structure": "Structure",
	"Sun.": "Sun.",
	"Supervisor": "Supervisor",
	"Surnames": "Surnames",
	"Surnames_name": "Surnames, Name",
	"Surroundings": "Surroundings",
	"Surveying": "Surveying",
	"Swimming_pool": "Swimming pool",
	"Tasks": "Tasks",
	"Taxes": "Taxes",
	"technical_values": "technical values",
	"Technical_values": "Technical values",
	"Technology": "Technology",
	"Tenant_age_years": "Tenant's age",
	"Tenant_life_expectancy_years": "Life expectancy",
	"Tenant_remaining_life_expectancy_years": "Tenant's remaining life expectancy",
	"Team_text": "The company is formed by a group of architects, engineers and specialists in appraisals and valuations with a wide knowledge on the real estate market and with an experience of more than 30 years in the field of real estate appraisals and valuations",
	"Teamwork": "Teamwork",
	"Telephone": "Telephone",
	"Telephone_contact": "Telephone contact",
	"telephone_number": "nº de telèfon",
	"Telephone_number": "Telephone nº",
	"Telephone_numbers": "Telephone numbers",
	"Terrain": "Terrain",
	"Testamentary_shares": "Testamentary shares",
	"thousand": "thousand",
	"thousand_euros": "thousand euros",
	"The_company": "The Company",
	"The_page_contains_unsaved_changes": "The current page contains unsaved changes",
	"The_passwords_do_not_match": "The passwords do not match",
	"thousands_of_euros": "thousands of euros (€)",
	"Thu.": "Thu.",
	"TIN": "TIN",
	"Title": "Title",
	"Title_and_date_of_report": "Title and date of report",
	"Title_s_Honorific": "Títle / Honorific",
	"Total_depreciation": "Total depreciation",
	"Total_value": "Total value",
	"Transparency": "Transparency",
	"Trust": "Trust",
	"type": "type",
	"Type": "Type",
	"Type_here_to_filter_paginated_data": "Type here to filter paginated data",
	"Type_of_property": "Type of property",
	"Typical_deviation": "Typical deviation",
	"Typology": "Typology",
	"Uncovered_outdoor_area": "Uncovered outdoor area",
	"Unit_price": "Unit price",
	"Unit_value": "Unit value",
	"universal_sample": "universal sample",
	"Universal_sample": "Universal sample",
	"Updated_reversion_value": "Updated reversion value",
	"Update_type": "Update type",
	"Update_value": "Update value",
	"Update_value_calculation": "Update value calculation",
	"Upper_limit": "Upper limit",
	"Url": "Link",
	"Useful_life": "Useful life",
	"Usufruct": "Usufruct",
	"Usufruct_value": "Usufruct value",
	"Usufructuary_age_years": "Age of the usufructuary",
	"Urban_planning_parameters": "Urban planning parameters",
	"valuated_in_this_report": "valuated in this report",
	"to": "to",
	"total_values": "total values",
	"Total_values": "Total values",
	"Others": "Others",
	"Valuation": "Valuation",
	"Valuation_pricing": "Valuation pricing",
	"Valuation_report": "Valuation report",
	"valuations": "valuations",
	"Valuation_date": "Date of appraisal value",
	"Valuation_purpose": "Valuation purpose",
	"Valuation_type": "Valuation type",
	"Value_date": "Value date",
	"Version": "Version",
	"Visits": "Visits",
	"VAT": "VAT",
	"Warnings": "Warnings",
	"We_are_sorry_c_the_page_you_requested_cannot_be_found": "We're sorry, the page you requested cannot be found",
	"Weighing": "Weighing",
	"Welcome_message": "Welcome to Barnatasa app",
	"What_you_need_to_provide": "What you need to provide",
	"with": "with",
	"without_saving": "without saving",
	"Workflow": "Workflow",
	"Wrong_date_message": "Date is incomplete or wrong",
	"years": "years",
	"You_are_about_to_delete": "You are about to delete",
	"Registry_area": "Registry area",
	"Checked_area": "Checked area",
	"Plot_occupation": "Plot occupation",
	"Plot_free_area_usage": "Use of the plot's free area",
	"Floors_number_underground": "Nª of floors under ground",
	"Floors_number_overground": "Nº of floors over ground",
	"Parking_slots_included_in_appraisal_number": "Nº of parking slots included in the valuation",
	"Entrance_hall": "Entrance hall",
	"Doorman_space": "Doorman space",
	"Community_room": "Community room",
	"Storage_room_included_in_appraisal": "Storage room included in the valuation",
	"Community_parking": "Parking",
	"Facilities_others": "Others",
	"Floors_usage_underground": "Use under ground",
	"Floors_usage_overground": "Use over ground",
	"Groundfloor_usage": "Use ground floor",
	"Real_estates_useful_life": "Real Estate's useful life",
	"Real_estates_total_useful_life": "Property's total useful life",
	"Remaining_useful_life_years": "Remanining useful life years",
	"Urban_and_surroundings_text": "Urban planning and surroundings",
	"Communications": "Communications",
	"Airport": "Airport",
	"Harbour": "Harbour",
	"Train": "Train",
	"Public_transport": "Public transport",
	"Urban_underground": "Urban underground",
	"Interurban": "Interurban",
	"Territorial_feature": "Territorial feature",
	"Income_level": "Income level",
	"Homogeneity_feature": "Homogeneity feature",
	"Main_uses": "Main uses",
	"Density": "Density",
	"Accessibility": "Accessibility",
	"Consolidation_degree": "Consolidation degree",
	"Occupation_degree": "Occupation degree",
	"Evolution": "Evolution",
	"Average_age": "Average age",
	"Commercial": "Commercial",
	"Educational": "Educational",
	"Public_parking": "Public parking",
	"Medical_assistance": "Medical assistance",
	"Leisure": "Leisure",
	"Building_development_level": "Nivell de desenvolupament de l'edificació",
	"Facilities": "Equipaments",
	"MUC_map": "MUC map",
	"Registry": "Registry",
	"Section": "Section",
	"Volume": "Volume",
	"Book": "Book",
	"Page": "Page",
	"Registry_real_estate_number": "Registry Property Nº",
	"Holder": "Holder",
	"Property_coef": "Property coefficient",
	"Bedrooms_and_bathrooms": "Bedrooms and bathrooms",
	"Covered_outdoor_areas": "Covered outdoor areas",
	"Uncovered_outdoor_areas": "Uncovered outdoor areas",
	"Add_covered_outdoor": "Add covered outdoor space",
	"Add_uncovered_outdoor": "Add uncovered outdoor space",
	"Enclosed_area": "Enclosed area",
	"Enclosed_checked_area": "Enclosed checked area",
	"Low_enclosed_checked_area_error_text": "The enclosed checked area is less than the total net area",
	"Proportional_part_of_common_elements": "Proportional part of common elements",
	"Common_elements_cadastral_area": "Common Elements Cadaster",
	"Common_elements_registry_area": "Common Elements Registr)",
	"Common_elements_checked_area": "Common Elements(Checked",
	"Common_elements_adopted_area": "Common Elements Adopted",
	"Total_areas_summary_table": "Total areas summary table",
	"Register": "Registre",
	"Cadaster": "Cadastre",
	"Checked": "Comprobada",
	"Selected": "Seleccionada",
	"Adopted": "Adoptada",
	"Usage": "Usage",
	"Covered_outdoors_area": "Area of covered outdoor spaces",
	"Uncovered_outdoors_area": "Area of uncovered outdoor spaces",
	"Built_plus_common_elements_area": "Built area + Common Elements",
	"Built_plus_common_elements": "Built + Common Elements",
	"Common_elements": "Common elements",
	"Number_of_rooms_to_exterior": "Nº of rooms to exterior",
	"Day_night_zoning": "Day / night zoning",
	"Door_opener": "Door opener",
	"Fitted_cupboards": "Fitted cupboards",
	"Gas": "Gas",
	"Sanitary_fittings": "Sanitary fittings",
	"Taps": "Taps",
	"Hot_water": "Hot water",
	"Fire_prevention": "Fire prevention",
	"Intrusion_prevention": "Intrusion prevention",
	"Foundation": "Foundation",
	"Roof": "Roof",
	"External_enclosures": "External enclosures",
	"Insulation": "Insulation",
	"External_carpentry": "External carpentry",
	"Glazing": "Glazing",
	"Views": "Views",
	"Windows_size_and_quantity": "Size and quantity of windows",
	"Noise_facade": "Noise level on facade",
	"Systems": "Systems",
	"conservation_status": "conservation status",
	"Building_shell": "Building shell",
	"building_shell": "building shell",
	"Shell": "Shell",
	"shell": "shell",
	"Interior_finishes": "Interior finishes",
	"Living": "Living",
	"Kitchen": "Kitchen",
	"Walls": "Walls",
	"Ceilings": "Ceilings",
	"Interior_carpentry": "Interior carpentry",
	"Circulations": "Circulations",
	"BdE_files": "BdE Files",
	"Construction_prices": "Construction costs",
	"Add_bec_property": "Add Real Estate Type",
	"Add_bec_number": "Add B.E.C. nº",
	"Year": "Year",
	"Quarter": "Quarter",
	"Bec_adjustment_coef": "B.E.C. Adjustment coeficient",
	"Adjusted_bec_price": "Adjusted B.E.C. price.",
	"Expenses_and_industrial_benefit_bec_pct": "Percentage of expenses and industrial benefit",
	"Construction_status": "Construction status",
	"Construction_cost_notes": "Notes on the construction cost",
	"Mandatary": "Mandatary",
	"Mandatary_entity": "Mandatary entity",
	"Acc_mortgage_market_law_q": "is it following the mortgage market law?",
	"Acc_eco_decree_q": "is it following the ECO/805/2003 decree?",
	"location": "location",
	"Registry_property": "Registry property",
	"Cadastral_file": "Cadastral File",
	"Nucleus_area": "Municipality area",
	"Nucleus_type": "Type of nucleus",
	"Locality": "Locality",
	"Employment_occupation": "Employment occupation",
	"Population": "Population",
	"Population_density": "Population density",
	"Population_growth": "Population growth",
	"Last_year": "Last year",
	"Terrain_description": "Terrain description",
	"Terrain_infrastructures": "Terrain infrastructures",
	"Execution": "Execution",
	"Water_supply": "Water supply",
	"Terrain_area": "Terrain area",
	"Site_quality": "Site quality",
	"Underground_levels": "Underground levels",
	"Ground_level": "Ground level",
	"Overground_levels": "Overground levels",
	"Building_description": "Building description",
	"Checkings_realized": "Comprovacions realitzades",
	"Documents_used": "Documentació utilitzada",
	"Interior_visit": "Visita interior de l'immoble",
	"Expropriation_procedure": "Procediment d'expropiació",
	"Expropriation_plan": "Pla o projecte d'expropriació",
	"Expropriation_admin_ruling": "Resolució administrativa expropiació",
	"Expropriation_file": "Expedient d'expropriació",
	"Occupancy": "Estat d'ocupació i ús",
	"Servitudes": "Servituds",
	"Public_protection_regime": "Règim de protecció pública",
	"Urban_paramaters_suitability": "Adequació al planejament urbanístic",
	"Another": "Another",
	"Approved_project_by_professional_association": "Projecte visat pel col·legi professional",
	"Cadastral_documents": "Documentació cadastral",
	"Construction_license": "Llicència de construcció",
	"Construction_last_certificate": "Últim certificat de construcció",
	"Construction_contract": "Contracte de construcció",
	"Occupancy_status": "Estat d'ocupació",
	"Photographic_report": "Reportatge fotogràfic",
	"Property_sketch": "Croquis de l'immoble",
	"Property_titles": "Document de propietat segons normativa",
	"Situation_plan": "Plànol de situació",
	"Ten_year_insurance": "Assegurança decennal",
	"Urban_plan": "Plànol urbanístic",
	"Habitability_conditions": "Habitability conditions",
	"Main_orientation": "Main orientation",
	"Property_title": "Property_title",
	"Usage_assigned": "Usage_assigned",
	"Usage_assigned_by_the_owner": "Usage assigned by the owner",
	"Inspection_realized": "Inspection realized",
	"Economical_activity": "Economical activity",
	"Real_rights": "Real rights",
	"Bulletin_number": "Bulletin nº",
	"a": "a",
	"Select": "Select",
	"Market_data": "Market data",
	"Market_samples": "Market samples",
	"Offer_date": "Offer date",
	"Sample": "Sample",
	"Market_analysis": "Market analysis",
	"Prices_estimated_yearly_evolution_pct": "Prices - annual evolution, estimated variation (%)",
	"Market_value_evolution_probability_pct": "Forecast evolution of the comparison value (%)",
	"Offer_production": "Offer - production",
	"Offer_yearly_stock": "Offer - Annual stock",
	"Offer_trend": "Offer - trend",
	"Demand_level": "Demand - level",
	"Demand_speed_of_sales": "Demand - speed of sales",
	"Demand_trend": "Demand - trend",
	"Prices_expectancy": "Prices - Expectation",
	"Prices_past_cicles_volatility": "Expectation - Volatility of past cycles",
	"Market_conjuncture": "Market conjuncture",
	"Market_value_reduction_probability_expectancy": "Expectation - Probability of reduction of the comparison value",
	"Offer": "Offer",
	"Demand": "Demand",
	"Expectation": "Expectation",
	"Maximum": "Maximum",
	"Minimum": "Minimum",
	"Mean": "Mean",
	"Median": "Median",
	"Market_prices": "Market prices",
	"Neighbourhood": "Neighbourhood",
	"Situation": "Situation",
	"Samples": "Samples",
	"Similarities": "Similarities",
	"Statistical_deviations": "Statistical deviations",
	"Typical_deviation_of_the_sample": "Typical deviation of the sample",
	"Technical_values_calculation": "Technical values calculation",
	"Material_execution_cost_as_new": "Material execution cost (as new)",
	"Finished_building_market_value": "Finished building market value",
	"finished_building": "finished building",
	"Total_values_calculation": "Total values calculation",
	"year": "year",
	"Other_values": "Other values",
	"Appraisal_value_determination_text": "In accordance with the criteria set in the ECO 805/2003 order, the applicable value is:",
	"Add_constraint": "Add constraint",
	"Add_warning": "Add warning",
	"Add_note": "Add note",
	"Constraints": "Constraints",
	"Constraints_foreseen_by_law": "Constraints foreseen by Law",
	"Warnings_foreseen_by_law": "Warnings foreseen by Law",
	"Notes_foreseen_by_barnatasa": "Notes foreseen by BARNA-TASA S.A.",
	"English": "English",
	"Spanish": "Spanish",
	"The_Real_Estate_is_not_protected": "The Real Estate is nor protected",
	"The_Real_Estate_is_not_rented_or_ceded": "The Real Estate is not rented or ceded",
	"There_is_no_cession_of_the_right_of_use": "There is no cession of the right of use",
	"The_value_is_not_calculated": "The value is not calculated",
	"Elements_included_in_this_valuation": "Elements included in this valuation",
	"Market_value_adjustment_pct": "Market value adjustment percentage",
	"Constraint": "Constraint",
	"Warning": "Warning",
	"Note": "Note",
	"Upload_photographs": "Upload photographs",
	"Photograph": "Photograph",
	"Photographs": "Photographs",
	"Image_footer": "Image footer",
	"Upload_files": "Upload files",
	"File_name": "File name",
	"in": "in",
	"Registry_Documents": "Registry Documents",
	"Cadastral_Documents": "Cadastral Documents",
	"Plans": "Plans",
	"Sketches": "Sketches",
	"Cession_Documents": "Cession Documents",
	"Contracts": "Contracts",
	"Other_Documents": "Other Documents",
	"with_date": "on date of",
	"Date_of_issue": "Date of issue",
	"Signatures": "Signatures",
	"Report_date_of_issue": "Report date of issue",
	"Professional_that_visited_the_property": "Professional that visited the property",
	"Date_of_visit": "Date of visit",
	"Appraisers": "Appraisers",
	"Supervisors": "Supervisors",
	"Appraisers_Index": "Index of Appraisers",
	"Supervisors_Index": "Index of Supervisors",
	"Add_appraiser": "Add appraiser",
	"Add_supervisor": "Add supervisor",
	"Prof_assoc_reg_number": "Nº col·legiat",
	"Visit_date": "Visit date",
	"Technician_who_performed_the_visit": "Technician visiting",
	"Visit": "Visit",
	"Floor_name": "Floor name",
	"Import_comparable_set": "Import comparable set",
	"Import_comparable_set_from_another_market_study": "Import comparable set from another market study",
	"There_are_unsaved_changes": "There are unsaved changes",
	"Unsaved_data_will_be_lost": "Unsaved data will be lost",
	"Cover": "Cover",
	"Annexed_documents": "Annexed documents",
	"Photographies": "Photographies",
	"Report_of": "Report of",
	"correlated_pages_numbered_from": "correlated pages, numbered from",
	"technician": "technician",
	"Sanitary_fittings_quality": "Quality of sanitary fittings",
	"Taps_quality": "Quality of taps",
	"Land_selected_area": "Selection method",
	"Urban_parameters_suitability": "Suitability to the urban planning parameters",
	"Maps": "Maps",
	"Situation_maps": "Situation maps",
	"Other": "Other",
	"Subsidy_status": "Public protection qualification",
	"Quote": "Quote",
	"Appraisal_quote": "Appraisal quote",
	"Appraisal_quotes": "Appraisal quotes",
	"Add_appraisal_quote": "Add new appraisal quote",
	"Title_and_date_of_quote": "Title and date of quote",
	"valuated_in_this_quote": "valuated in this quote",
	"Quote_title_missing_error_text": "The quote title is missing",
	"Print_quote_in_PDF": "Print quote in PDF",
	"Create_new_real_estate": "Create new Real Estate",
	"Select_Real_estate_to_be_added": "Select Real Estate to be added",
	"Existing_Real_estates": "Existing Real Estates in database",
	"create_a_new_one": "create a new one",
	"staircase": "staircase",
	"block": "block",
	"door": "door",
	"Full_address": "Full address",
	"Status": "Status",
	"Quote_number": "Nº de presupuesto",
	"Quote_content": "Contenido del presupuesto",
	"Quote_title": "Quote title",
	"Travel_expenses": "Travel expenses",
	"Travel_one_way_hours": "Travel hours (one way)",
	"Travel_both_ways_hours": "Travel hours (both ways)",
	"Travel_fees_per_hour": "Travel fees per hour",
	"Total_car_expenses_one_way": "Travel expenses (one way)",
	"Total_car_expenses_both_ways": "Travel expenses (both ways)",
	"Total_travel_fees": "Total travel fees",
	"Quote_area_average_unit_price": "Area average price (€/m2)",
	"Quote_base_fees": "Base fees",
	"Quote_excess_pct": "% excess from base fees",
	"Quote_base_price": "Total fees",
	"Quote_base_price_coef": "Adjustment coef.",
	"Valuation_quote": "Valuation quote",
	"Appraisal_cost": "Appraisal cost",
	"Appraisal_fees": "Appraisal fees",
	"Appraisal_price": "Appraisal price",
	"hours": "hours",
	"Area_prices": "Prices of this area",
	"Area_average_unit_price": "Average price of this area",
	"Ads_date_range": "Ads date range",
	"Current_area_prices": "Current area prices",
	"pre_appraisal": "pre-appraisal",
	"Pre_appraisal": "Pre-appraisal",
	"Estimated_built_area": "Estimated built area",
	"Pre_appraisal_value": "Pre-appraisal value",
	"Area_average_price_coef": "Price adjustment coefficient",
	"Adopted_area_average_price": "Adopted unit price",
	"Car_fuel_expenses_one_way": "Fuel expenses (one way)",
	"Car_fuel_expenses_both_ways": "Fuel expenses (both ways)",
	"Car_toll_expenses_one_way": "Toll expenses (one way)",
	"Car_toll_expenses_both_ways": "Toll expenses (both ways)",
	"Valuation_pricing_info_table": "Valuation pricing info table",
	"Check_prices": "Check prices",
	"Add_ad_manually": "Ad new add manually",
	"Ads_index": "Ads index",
	"Go_back_to_market_study": "Go back to market study",
	"Offer_price_reduction_coef": "Price reduction coefficient",
	"Cession_files": "Lease files",
	"Lease": "Lease",
	"Gross_tax_per_1000_inhabitants": "Gross tax per 1000 inhabitants",
	"Site": "Site",
	"Urban_planning": "Urban planning",
	"Construction_description": "Construction description",
	"Status_on_occupancy_protection_cession_usage_and_real_rights": "Occupancy status, protection regime, cession, usage and real rights",
	"Real_rights_protection_and_occupation": "Real rights, protection and occupation",
	"PA_number": "Prof. registration nº",
	"Quote_petitioner": "Quote petitioner",
	"Quote_petitioners": "Quote petitioners",
	"Dear": "Dear",
	"Dear_m": "Dear",
	"Dear_f": "Dear",
	"Quote_sentence_01": "We are pleased to attach the Fees Budget for the Appraisal Report of the following Real Estates:",
	"Approx_area": "Approx. area",
	"Signed": "Signed",
	"Amount_money": "Amount",
	"Total_cost_including_VAT": "Total cost (VAT included)",
	"Fiscal_parameters": "Fiscal parameters",
	"VAT_pct": "VAT (%)",
	"Quote_sentence_02": "Payment conditions: 50% on start and 50% on the delivery of the Appraisal Reports",
	"Quote_sentence_03": "Bank transfer to",
	"Quote_sentence_04": "Tasks to do in order to prepare the Appraisal Reports",
	"Quote_sentence_05": "Visit of the Real Estate by a technician, Architect/Engineer from BARNA-TASA",
	"Quote_sentence_06": "Making of the Appraisal Report. Content",
	"Payment_details": "Payment details",
	"Required_documentation": "Required documentation",
	"Quote_sentence_07": "Delivery of the reports in digital form (PDF)",
	"Quote_sentence_08": "If a paper version is required, an additional cost of 15 € will be applied for the printing and post delivery",
	"Quote_sentence_09": "Petitioner's name, tax nº and address",
	"Quote_sentence_10": "Invoice details: name, tax nº and address",
	"Quote_sentence_11": "Copy of the property deeds",
	"Quote_sentence_12": "Copy of the IBI tax receipt (Cadastral data) (optional)",
	"Quote_sentence_13": "Copy of the rental contract and an updated receipt (if under rent)",
	"Quote_sentence_14": "Purpose of the appraisal (buy/sell, mortgage guarantees, ...)",
	"Quote_sentence_15": "Name and telephone number of the contact person in order to visit the property",
	"Quote_sentence_16": "Plans/architectural drawing of the property (optional)",
	"At_your_disposal_for_any_clarification": "At your disposal for any clarification",
	"Kindest_regards": "Kindest Regards",
	"CFO_CHRO_female": "Chief Financial and Human Resources Officer",
	"Additional_costs": "Other costs",
	"Quote_sentence_17": "In the event of assistance of the technician in court to ratify the report the cost will be 150 € + VAT",
	"Quote_sentence_18": "The report will be delivered in digital form (PDF). If a paper version is needed the cost will be 15 €, under the concept of printing and post delivery",
	"Appraisal_invoice": "Invoice",
	"Appraisal_invoices": "Invoices",
	"Add_appraisal_invoice": "Add invoice",
	"Title_and_date_of_invoice": "Title and date of invoice",
	"valuated_in_this_invoice": "valuated in this invoice",
	"Invoice_title_missing_error_text": "Invoice title is missing",
	"Print_invoice_in_PDF": "Print invoice in PDF",
	"Valuation_invoice": "Invoice",
	"Invoice": "Invoice",
	"Client": "Client",
	"Invoice_number": "Invoice nº",
	"Invoice_content": "Invoice content",
	"Invoice_title": "Invoice title",
	"Add_petitioner": "Add petitioner",
	"Create_new_contact": "Create new contact",
	"No_petitioners_text": "No contacts added. Please, select from the list and click on 'add petitioner'",
	"Surnames_name_or_company": "'Surnames, Name' or 'Company name'",
	"No_records": "No records",
	"Quotes_requested_by": "Quotes requested by",
	"Dear_sir_or_madam": "Dear Sir/Madam",
	"Dear_sirs_or_madams": "Dear Sirs/Madams",
	"Dear_sir": "Dear Sir",
	"Dear_madam": "Dear Madam",
	"Dear_sirs": "Dear Sirs",
	"Dear_madams": "Dear Madams",
	"Dear_madams_and_sirs": "Dear Madams and Sirs",
	"Dear_madam_and_sir": "Dear Madam and Sir",
	"Dear_pl": "Dear",
	"Dear_pl_f_m": "Dear",
	"Dear_pl_f": "Dear",
	"Dear_pl_m": "Dear",
	"Main_email": "Main e-mail address",
	"Add_other_email": "Add other e-mail",
	"Complete_name": "Complete_name",
	"Payment_conditions": "Payment conditions",
	"Note_w": "Note",
	"Final_price": "Final price",
	"Discount_pct": "Discount (%)",
	"Discount_notes": "Notes on the discount",
	"Bank_name": "Bank name",
	"Court_assistance_fees": "Court attendance fees",
	"Required_docs": "Required doc",
	"Documentation_type": "Documentation type",
	"Add_required_doc": "Add to the list",
	"Document": "Document",
	"Petitioners_missing_error_text": "Falta indicar el sol·licitant de pressupost",
	"Realestates_missing_error_text": "Falta indicar els immobles del pressupost",
	"Requireddocs_missing_error_text": "Falta indicar la documentació necessària",
	"Discount": "Discount",
	"Fees_incl_discount": "Fees including discount",
	"Quote_reference": "Quote reference for this invoice",
	"Invoice_lines": "Invoice lines",
	"Add_invoice_line": "Add invoice line",
	"Units": "Units",
	"Import_quote_concepts": "Importar concepts from quote",
	"invoice": "invoice",
	"line": "line",
	"Lines_missing_error_text": "Falta introduir els conceptes de la factura",
	"Concept": "Concept",
	"Add_client": "Add client",
	"Appraisal_invoice_description": "Descripction of the invoice",
	"Invoice_to": "Invoice to",
	"Emited_by": "Emited by",
	"Invoice_Total": "Invoice Total",
	"Emmission_date": "Emmission date",
	"Reference": "Reference",
	"Appraisal_invoices_index": "Index of Invoices",
	"Appraisal_quotes_index": "Index of Quotes",
	"Invoice_fiscal_number": "Invoice Fiscal Nº",
	"Billing": "Billing",
	"invoice_fiscal_number": "invoice fiscal nº",
	"Last_m": "Last",
	"invoice_number": "invoice",
	"Last_created_invoice": "Last created invoice",
	"Welcome": "Welcome",
	"Ad_description": "Ad description",
	"Upload_to_database": "Save and upload to database",
	"Address_referral": "Address referral",
	"Max_distance": "Max. distance",
	"Print_report_s_certificate_in_PDF": "Print Report/Certificate in PDF",
	"Appraisal_certificate": "Appraisal certificate",
	"Certificate_text_01": "Ferran López-Doriga Fontcuberta, Architect, Director and Technical Supervisor of BARNA-TASA, S.A., registered company in the Registro Oficial de Sociedades de Tasación del Banco de España, nº 4.470 and inscription date June 26th 1.995,",
	"Certificate_text_02": "That with File nº",
	"Certificate_text_03": "a valuation report has been made on date",
	"Certificate_text_04": "and the valuation contains the following data",
	"Certificate_text_05": "I hereby sign the present certificate in Barcelona, ",
	"certifies": "certifies",
	"Petitioner_TIN": "Petitioner's Tax Id. Nr",
	"Petitioner_address": "Address of the Petitioner",
	"registered_in": "registered en",
	"from_the": "from the",
	"Method_used_to_calculate_the_value": "Method used to calculate the adopted_value",
	"Cost_value_current_state": "Cost value in the current state",
	"Comparison_value": "Comparison value",
	"Maximum_legal_value": "Maximum legal value",
	"Adjusted_market_value": "Adjusted market value",
	"Total_appraisal_value": "Total appraisal value",
	"Real_estates_missing_error_text": "No Real Estates have been added to this report",
	"Sign_quote": "Sign quote",
	"Sign_appraisalreport": "Sign report",
	"Appraiser_sign_appraisalreport": "Sign report (Appraiser)",
	"Supervisor_sign_appraisalreport": "Sign report (Supervisor)",
	"Sign_invoice": "Sign invoice",
	"Sign_certificate": "Sign certificate",
	"Signature": "Signature",
	"Appraisers_signature": "Signature of the Appraiser",
	"Supervisors_signature": "Signature of the Supervisor",
	"Main_telephonenumber": "Main telephone nº",
	"with_purpose": "with purpose",
	"Purpose": "Purpose",
	"Prices": "Prices",
	"BEC_expenses_plus_builders_benefit_pct": "% of expenses and builders benefit included in BEC's price",
	"pkg_number": "Parking-spot Nº",
	"Index": "Index",
	"Cession_type": "Cession type",
	"Real_right_type": "Real Right Type",
	"Reports": "Reports",
	"Other_files": "Other files",
	"Construction_reposition_cost_as_new": "Construction reposition cost as new",
	"Construction_value_in_actual_state": "Value of the construction in actual state",
	"executed_construction": "executed construction",
	"Integrity": "Integrity",
	"remaining": "remaining",
	"or": "or",
	"Project": "Project",
	"Projects": "Projects",
	"Add_project": "Add project",
	"Projects_of_the_Real_Estate": "Projects",
	"BDE_files_index": "BDE files index",
	"BDE_files": "BDE files",
	"Asset_type": "Asset type",
	"Property_usage": "Usage of the property",
	"Parking_spots_included_number": "Nº of parking spots included",
	"BdE_appraisal_files": "Appraisals",
	"BdE_realestate_files": "Real Estates",
	"BdE_comparable_files": "Comparables",
	"BdE_relationships_files": "Relationships",
	"Insurance_value_rd_1982_text": "Gross replacement cost excluding the value of the land",
	"Insurance_value_rd_2009_text": "Appraisal value excluding the value of the land",
	"VAT_not_included": "VAT not included",
	"EEC_conditions": "Dwellings up to 100 sqm in Barcelona's Metropolitan Area: 125 €+ IVA",
	"OCC_conditions": "Dwellings up to 100 sqm in Barcelona's Metropolitan Area: 125 €+ IVA",
	"EECOCC_conditions": "Dwellings up to 100 sqm in Barcelona's Metropolitan Area: 210 €+ IVA",
	"OT_conditions": "Altres tipologies segons pressupost"
};

/***/ }),
/* 2283 */
/***/ (function(module, exports) {

module.exports = {
	"A_BdE_homologated_company": "Sociedad Homologada por el Banco de España",
	"About_BARNATASA": "Sobre BARNA-TASA, S.A.",
	"About_text_01": "BARNA-TASA es una Sociedad de Tasación Homologada por el Banco de España, inscrita en el Registro Oficial de Entidades de Tasación con el nº 4.470 y fecha de inscripción 26 de junio de 1.995",
	"About_text_02": "La sociedad está formada por un grupo de arquitectos, ingenieros y especialistas en el campo de la valoración y tasación inmmobiliarias y un amplio conocimiento del sector, con más de 30 años de trayectoria",
	"About_us": "Sobre nosotros",
	"acc_Budget": "s/ Presupuesto",
	"acc_appraisal_date": "s/ fecha de tasación",
	"Actions": "Acciones",
	"Ad": "Anuncio",
	"Ads": "Anuncios",
	"Ad_address": "Dirección tal y como aparece en el anuncio",
	"Ad_code": "Código del anuncio",
	"Ad_database_query": "Consulta de anuncios en la base de datos",
	"Ad_data_type": "Tipo de datos",
	"Ad_date": "Fecha del anuncio",
	"Ad_type": "Tipo de anuncio",
	"Adaptability": "Adaptabilidad",
	"Add_address": "Añadir dirección",
	"Add_appraisal": "Añadir tasación",
	"Add_appraisal_file": "Añadir expediente de tasación",
	"Add_appraisal_report": "Añadir informe de tasación",
	"Add_contact": "Añadir contacto",
	"Add_email": "Añadir email",
	"Add_entity": "Añadir entidad",
	"Add_market_study": "Añadir estudio de mercado",
	"Add_real_estate": "Añadir inmueble",
	"Add_room": "Añadir estancia",
	"Add_telephone_number": "Añadir nº de teléfono",
	"Add_to_comparables_list": "Añadir a la lista de comparables",
	"Address": "Dirección",
	"Address_description": "Descripción de la dirección",
	"Addresses": "Direcciones",
	"Adjusted_Comparison_Method": "Método de Comparación Ajustado",
	"Adopted_age": "Antigüedad considerada",
	"Adopted_area": "Superficie adoptada",
	"Adopted_building_market_value": "Valor de mercado de la edificación adoptado",
	"Adopted_material_execution_cost": "Coste de ejecución material adoptado",
	"Adopted_material_execution_cost_deprecated_by_antiquity": "Coste de ejecución material adoptado depreciado por antigüedad",
	"Adopted_value": "Valor adoptado",
	"Age": "Antigüedad",
	"Agravation_or_improvement_coeficient": "Coeficiente de agravación o mejora",
	"Air_conditioning": "Aire acondicionado",
	"and": "y",
	"and_limit_date": "y la fecha límite",
	"annexes": "anexos",
	"Annexes": "Anexos",
	"Addressing_title": "Título de tratamiento",
	"Advertisements_between_starting_date": "Anuncios entre la fecha de inicio",
	"appraisal": "tasación",
	"Appraisal": "Tasación",
	"appraisal_company": "sociedad de tasación",
	"Appraisal_date": "Fecha de tasación",
	"appraisal_file": "expediente de tasación",
	"Appraisal_description": "Descripción de la tasación",
	"Appraisal_file": "Expediente de tasación",
	"Appraisal_files": "Expedientes de tasación",
	"Appraisal_file_description": "Descripción de expediente de tasación",
	"Appraisal_files_index": "Índice de expedientes de tasación",
	"Appraisal_petitioner": "Solicitante de tasación",
	"Appraisal_petitioners": "Solicitantes de tasación",
	"Appraisal_purpose": "Finalidad de la tasación",
	"appraisal_report": "informe de tasación",
	"Appraisal_report": "Informe de tasación",
	"Appraisal_report_description": "Descripción del informe de tasación",
	"Appraisal_reports": "Informes de tasación",
	"Appraisal_Requests": "Solicitudes de tasación",
	"Appraisal_total_value_determination": "Determinación del valor total de tasación",
	"Appraisal_type": "Tipo de tasación",
	"Appraisal_value": "Valor de tasación",
	"Appraisals": "Tasaciones",
	"Appraisals_for_all_purposes": "Tasaciones para todas las finalidades",
	"Appraisals_and_valuations": "Tasaciones y valoraciones",
	"Appraisals_Index": "Índice de Tasaciones",
	"Appraisals_of_the_Real_Estate": "Tasaciones del Inmueble",
	"Appraised": "Tasado",
	"Appraised_real_estates": "Inmuebles tasados",
	"Appraised_real_estates_in_this_report": "Inmuebles tasados en este informe",
	"Appraised_real_estate": "Inmueble tasado",
	"Appraiser": "Tasador",
	"Approximate_property_area": "Superfície aproximada del inmueble",
	"Area": "Superficie",
	"Areas": "Superficies",
	"areas": "superficies",
	"Are_you_sure_q": "Estás seguro?",
	"As_new_construction_cost": "Coste de construcción a nuevo",
	"Assets_value_update": "Actualización del valor de patrimonios",
	"Assurance": "Garantía",
	"at": "en",
	"Auditors": "Auditores",
	"average": "media",
	"Average": "Media",
	"Back_home": "Volver al inicio",
	"Bedrooms": "Dormitorios",
	"Building_Surveys": "Levantamientos de planos",
	"Back_to_safety": "Volver a un lugar seguro",
	"Bare_ownership": "Nuda propiedad",
	"Bare_ownership_value": "Valor de la nuda propiedad",
	"Barnatasa_cover_short_description": "Sociedad Especializada en Valoraciones y Tasaciones",
	"Barnatasa_header": "BARNA-TASA, S.A. Sociedad inscrita al Registro Oficial de Entidades de Tasación con el número 4.470. Fecha de inscripción en Banco de España: 26/06/1.995",
	"Barnatasa_footer": "Fin de página. Dorso no utilizable. Cualquier anotación en el mismo es nula y sin efecto.",
	"Barnatasa_header_portrait": "Sociedad inscrita en el Registro Oficial de Entidades de Tasación con el nº 4.460. Fecha de inscripción en Banco de España 26/06/1995. Reg. Merc. Barcelona, Folio 12, Tomo 28.173, Hoja B-132.666, NIF A-60840543",
	"Bathrooms": "Baños",
	"Bathrooms_number": "nº de Baños",
	"BdE_code": "código BdE",
	"Bedrooms_number": "nº de Dormitorios",
	"Block": "Bloque",
	"Budget_request": "Solicitud de presupuesto",
	"Builders_general_expenses_percentage": "Porcentaje de gastos generales del constructor",
	"Builders_general_expenses": "Gastos generales del constructor",
	"Builders_expenses_and_benefit_percentage": "Porcentaje de Gastos + Beneficio del constructor",
	"Builders_expenses_and_benefit": "Gastos + Beneficio del constructor",
	"Builders_industrial_benefit_percentage": "Porcentaje del Beneficio industrial tipo del constructor",
	"Builders_industrial_benefit": "Beneficio industrial del constructor",
	"Building_market_value": "Valor de mercado de la edificación",
	"real_estate_under_construction": "inmueble en construcción",
	"Buildings": "Edificios",
	"Buildings_useful_life": "Vida útil del edificio",
	"Built_area": "Superficie construida",
	"by": "por",
	"By": "Por",
	"Cadastral_area": "Superficie Catastral",
	"Cadastral_data_check": "Comprobación catastro",
	"Cadastral_data": "Datos catastrales",
	"Cadastral_List": "Listado del Catastro",
	"Cadastral_Map": "Mapa del Catastro",
	"Cadastral_reference": "Referencia catastral",
	"Cadastral_Reference_less_20_positions_error_text": "La Referencia Catastral tiene menos de 20 posiciones",
	"Calculate_values": "Calcular valores",
	"Calendar": "Calendario",
	"Cancel": "Cancelar",
	"Capture_date": "Fecha de captura",
	"Census_section": "Sección censal",
	"Census_section_code": "Código de sección censal",
	"Catalan": "Catalán",
	"certificates": "certificados",
	"cession": "cesión",
	"Cession": "Cesión",
	"Cession_contract_period_years": "Duración del contrato (años)",
	"Cession_contract_remaining_years": "Años restantes de contrato",
	"Cession_contract_start_date": "Fecha de inicio del contrato",
	"Cession_gross_monthly_income": "Renta bruta mensual del contrato",
	"Cession_gross_yearly_income": "Renta bruta anual del contrato",
	"Cession_net_yearly_income": "Renta neta anual",
	"Changes_will_be_lost_p_continue_q": "Se perderán los cambios. ¿Continuar?",
	"Checks": "Comprobaciones",
	"Checks_performed": "Comprobaciones realizadas",
	"Code": "Código",
	"Clients_text_01": "BARNA-TASA, S.A. cuenta con una amplia cartera de clientes y trabaja con todo tipo de clientes del ámbito privado y público. De los que destacamos",
	"Clients_text_02": "BARNA-TASA S.A. ofrece una amplia gama de servicios destinados a ayudar en la toma de decisiones relativas a la valoración y comprobación del estado de inmuebles y otros bienes",
	"Clients_text_03": "El objetivo de BARNA-TASA S.A. es apoyar a los clientes de las mejores firmas de abogados y auditoras nacionales e internacionales, en aquellas operaciones que requieran una valoración inmobiliaria. Desde una valoración para un proceso de expropiación, hasta las valoraciones necesarias en operaciones de fusión y adquisición, asesoramiento en desinversión de activos y reestructuraciones, abarcando además cualquier sector",
	"Clients_text_04": "Un entorno empresarial como el actual genera a las empresas la necesidad de acometer proyectos complejos y, a la vez, decisivos en su día a día. Conocedora de esta circunstancia, BARNA-TASA S.A. pone su experiencia, profesionalidad y conocimiento del mercado, a disposición de pequeñas-grandes empresas y entidades financieras en un amplio abanico de servicios, garantizando un trato personalizado y profesional",
	"closed": "cerrado",
	"Commercial_premises": "Locales comerciales",
	"Commission": "Encargo",
	"Commitment": "Compromiso",
	"Company_code": "Código de Sociedad",
	"Company_or_business_name": "Empresa o razón social",
	"Comparable_type": "Tipo de comparable",
	"Comparable_database_query": "Consulta de comprables en la base de datos",
	"comparables": "comparables",
	"Comparables": "Comparables",
	"Comparison_Method": "Método de Comparación",
	"Confidentiality": "Confidencialidad",
	"Confirm_Password": "Confirmar Contraseña",
	"Constant_income_with_CPI_update_clause": "Renta constante con cláusula de actualización del IPC",
	"Conservation": "Conservación",
	"Conservation_status": "Estado de conservación",
	"construction": "construcción",
	"Construction": "Construcción",
	"Construction_cost": "Coste de construcción",
	"Construction_cost_and_development_expenses": "Coste de construcción y gastos de promoción",
	"Construction_cost_by_contract": "Coste de construcción por contrata",
	"Construction_costs": "Costes de construcción",
	"Construction_progress_percentage": "Porcentaje de construcción realizada",
	"Construction_replacement_cost": "Coste de reposición de la construcción",
	"Construction_value": "Valor de la construcción",
	"construction_year": "año de construcción",
	"Construction_year": "Año de construcción",
	"Contact": "Contacto",
	"Contact_data": "Datos de contacto",
	"Contact_Data": "Datos del Contacto",
	"Contact_file": "Ficha del contacto",
	"Contact_name": "Nombre del contacto",
	"Contact_telephone": "Teléfono de contacto",
	"Contacts": "Contactos",
	"Contacts_Index": "Índice de Contactos",
	"contained_in_this_file": "contenidos en este expediente",
	"contained_in_this_file_f": "contenidas en este expediente",
	"Continue_q": "Continuar?",
	"Contracts_foreseeable_remaining_period": "Duración restante previsible de contrato",
	"Cooperatives": "Cooperativas",
	"Corrected_market_value": "Valor de mercado corregido",
	"Corrected_unit_market_value": "Valor unitario corregido",
	"Correction": "Corrección",
	"Correction_of_values": "Corrección de valores",
	"Cost_method": "Método del coste",
	"Council_classification": "Clasificación Ayuntamiento",
	"Council_classification_description": "Descripción Clasificación Ayuntamiento",
	"Council_qualification": "Calificación Ayuntamiento",
	"Council_qualification_description": "Descripción Calificación Ayuntamiento",
	"Regional_classification": "Clasificación MUC",
	"Regional_classification_description": "Descripción Clasificación MUC",
	"Regional_qualification": "Calificación MUC",
	"Regional_qualification_description": "Descripción Calificación MUC",
	"Country": "País",
	"Country_s_State": "País / Estado",
	"Covered_outdoor_area": "Superficies exteriores cubiertas",
	"Create_a_new_contact": "Crear un nuevo contacto",
	"Created": "Creado",
	"Creation": "Creación",
	"Current_reversion_value_calculation": "Cálculo del valor actual de reversión",
	"Current_value_of_future_rents": "Valor actual de rentas futuras",
	"Customer_Service": "Servicio de Atención al Cliente",
	"Customer_Service_text_01": "pone a disposición de sus clientes su",
	"Customer_Service_text_02": "al que estos pueden dirigir tanto las quejas, sugerencias y reclamaciones relacionadas con el servicio prestado por la Sociedad",
	"Customer_Service_text_03": "Las funciones del SAC son",
	"Customer_Service_text_04": "Atender y resolver las quejas, reclamaciones y consultas presentadas, directa o mediante representación, por personas físicas o jurídicas, españolas o extranjeras clientes de la Sociedad, cuando las mismas se refieran a intereses o derechos legalmente reconocidos relacionados con operaciones, contratos o servicios prestados por la empresa, ya deriven de los propios contratos, de la normativa de transparencia y protección de la clientela o de las buenas prácticas y usos, en particular del principio de equidad",
	"Customer_Service_text_05": "Hacer llegar a la dirección  de la empresa las recomendaciones y sugerencias sobre todos aquellos aspectos que, en su opinión, supongan un fortalecimiento de las buenas relaciones y mutua confianza que deben existir entre la empresa y sus clientes",
	"Customer_Service_text_06": "Los deberes de información de este SAC quedan recogidas en la vigente legislación Orden ECO/734/2004, de 11 de marzo, sobre los departamentos y servicios de atención al cliente de las entidades financieras",
	"Customer_Service_text_07": "Acceso al Reglamento del Servicio de Atención al Cliente de BARNA-TASA, S.A.",
	"Customer_Service_text_08": "Acceso a la hoja de reclamaciones",
	"Customer_Service_text_09": "Legislación aplicable para la defensa del cliente de servicios financieros",
	"Customer_Service_text_10": "Ley 2/2011 de 4 de marzo de Economía Sostenible",
	"Customer_Service_text_11": "Orden ECC/2502/2012 de 16 de noviembre, por la que se regula el procedimiento de presentación de reclamaciones ante los servicios de reclamaciones del Banco de España, la Comisión Nacional del Mercado de Valores y la Dirección General de Seguros y Fondos de Pensiones",
	"Customer_Service_text_12": "Orden ECO/734/2004. De 11 de marzo, sobre los departamentos y servicios de atención al cliente y el defensor del cliente de las entidades financieras",
	"Customer_Service_text_13": "Puede contactar con nosotros a través de los siguientes medios",
	"Customer_Service_text_14": "En persona, en la oficina de atención al público del Servicio de Atención al Cliente (de 10h a 13h y de 16h a 19h). Dirección",
	"Customer_Service_text_15": "Por correo certificado dirigido a",
	"Customer_Service_text_16": "Ponemos a disposición de los clientes un formulario de quejas y reclamaciones, que encontrará en este",
	"Customer_Service_text_17": "El formulario es de carácter voluntario y contendrá la siguiente información",
	"Customer_Service_text_18": "Nombre y apellidos del interesado",
	"Customer_Service_text_19": "Domicilio del interesado (y en su caso de la persona que lo represente)",
	"Customer_Service_text_20": "Para personas físicas: el NIF del interesado",
	"Customer_Service_text_21": "Para personas jurídicas: el CIF y los datos referidos al registro mercantil",
	"Customer_Service_text_22": "Motivo de la queja, especificando claramente las cuestiones sobre las que se solicita un pronunciamiento",
	"Customer_Service_text_23": "Appraisal file Nº",
	"Customer_Service_text_24": "Lugar, fecha y firma",
	"Customer_Service_text_25": "Pruebas documentales (en su caso)",
	"Customer_Service_text_26": "En el caso de haber agotado las vías a través del Departamento de Atención al Cliente( haberse denegado, desestimado o haber transcurrido más de dos meses sin resolución), se podrá interponer reclamación ante el Departamento de Conducta de Mercado y Reclamaciones cuyos datos de contacto son",
	"Customer_Service_text_27": "O por vía telemática a través de la Oficina Virtual",
	"Data": "Datos",
	"Data_tabulation": "Tabulación de datos",
	"date": "fecha",
	"Date": "Fecha",
	"Data_of_property_to_be_appraised": "Datos del inmueble a tasar",
	"Date_of_the_appraisal_value": "Fecha del valor de tasación",
	"Date_of_report": "Fecha del informe",
	"Date_of_quote": "Fecha del presupuesto",
	"Date_of_invoice": "Fecha de la factura",
	"Delete": "Eliminar",
	"Deprecated_construction_cost": "Coste de construcción depreciado",
	"Depreciation_by_antiquity": "Depreciación por antigüedad",
	"description": "description",
	"Description": "Descripción",
	"Discard": "Descartar",
	"Distance": "Distancia",
	"Door": "Puerta",
	"Duplicate": "Duplicar",
	"Dwellings": "Viviendas",
	"Dwelling_type": "Tipo de vivienda",
	"e-mail": "correo electrónico",
	"E-mail": "Correo electrónico",
	"E-mail_address": "Dirección de correo electrónico",
	"E-mail_addresses": "Direcciones de correo electrónico",
	"E-mail_description": "Descripción del correo electrónico",
	"Email": "Correo electrónico",
	"Email address": "Dirección de correo electrónico",
	"Edit_ad": "Editar anuncio",
	"Edit": "Editar",
	"Edit_address": "Editar dirección",
	"Edit_Appraisal": "Editar tasación",
	"Edit_real_estate": "Editar inmueble",
	"Edit_Real_Estate": "Editar Inmueble",
	"Edit_contact": "Editar contacto",
	"Email_Address": "Dirección de Correo Electrónico",
	"Energy_Certificates": "Certificados Energéticos",
	"Energy_Efficiency_Certificate": "Certificado de Eficiencia Energética",
	"Entities": "Entidades",
	"Entities_Index": "Índice de Entidades",
	"Entity": "Entidad",
	"EPSG_missing_text": "Faltan las cordenadas X e Y EPSG:25831 para poder obtener la referencia catastral y el código de sección censal. Se pueden consultar con el botón de Geolocalizar",
	"Estimated_sale_price": "Precio de venta estimado",
	"Estimated_unit_sale_price": "Precio unitario estimado",
	"Estimated_useful_life": "Vida útil estimada",
	"Executed_construction_cost": "Coste de construcción realizada",
	"Expected_Income_Update_Method": "Método Actualización de Renta Esperada",
	"Experience": "Experiencia",
	"Experience_text": "Más de 30 años de trayectoria ofreciendo el mejor servicio al mejor precio",
	"Expert_Opinions": "Dictámenes Periciales",
	"expert_opinions": "dictámenes periciales",
	"Expropriations": "Expropiaciones",
	"External_storage_room": "Trastero",
	"features": "características",
	"Features": "Características",
	"Fees": "Honorarios",
	"file": "expediente",
	"File": "Expediente",
	"File_description": "Descripción del expediente",
	"Files": "Expedientes",
	"File_number": "Nº de expediente",
	"Final_unit_price": "Precio unitario final",
	"Fiscal_Address": "Dirección Fiscal",
	"Fiscal_address": "Dirección fiscal",
	"Floor": "Planta",
	"Floor_number": "Nº Planta",
	"Floor_type": "Tipo de planta",
	"Financial_Entities": "Entidades Financieras",
	"finished_real_estate": "inmueble terminado",
	"finishes": "acabados",
	"Finishes": "Acabados",
	"fixtures": "instalaciones",
	"Fixtures": "Instalaciones",
	"For_all_purposes": "Para todas las finalidades",
	"Foundations": "Fundaciones",
	"Freemarket_benefit": "Beneficio mercado libre",
	"Fri.": "Vie.",
	"from": "de",
	"Functional_depreciation": "Depreciación funcional",
	"General_data": "Datos generales",
	"Green_areas": "Jardín / Zonas ajardinadas",
	"from_the_excess_of": "del exceso de",
	"Have_an_account_q_Log_in": "Ya tienes una cuenta? Inicia sesión",
	"Heating": "Calefacción",
	"Height_situation": "Situación en altura",
	"Higher_values": "Valores superiores",
	"Home_text_01": "Sociedad de tasación homologada, desde 1995, en el Registro Oficial de Entidades de Tasación del Banco de España",
	"homogenisation": "homogeneización",
	"Homogenisation": "Homogeneización",
	"Homogenisation_of_values": "Homogeneización de valores",
	"Homologated_company": "Sociedad homologada",
	"Homologated_Appraisal_Company_c_since_1995": "Sociedad de Tasación Homologada, desde 1995",
	"Homologated_text_01_part01": "Inscrita en el",
	"Homologated_text_01_part02": "de Entidades de Tasación del Banco de España, con nº 4.470 y fecha 26/06/1.995",
	"Honorarium_c_taxes_and_licenses": "Honorarios facultativos, tasas y licencias",
	"Honorarium_c_taxes_and_licenses_percentage": "Porcentaje de honorarios facultativos, tasas y licencias",
	"Hospitals": "Hospitales",
	"Hotels": "Hoteles",
	"Decennial_insurance_policy_expenses": "Gastos de póliza de seguro decenal",
	"Decennial_insurance_policy_expenses_percentage": "Porcentaje de gastos de póliza de seguro decenal",
	"Developers_administrative_expenses": "Gastos administrativos del promotor",
	"Developers_administrative_expenses_percentage": "Porcentaje de gastos administrativos del promotor",
	"Developers_benefit": "Beneficio del promotor",
	"Development_expenses": "Gastos de promoción",
	"Development_expenses_percentage": "Porcentaje de gastos de promoción",
	"Geographical_area": "Ámbito geográfico",
	"Geolocate": "Geolocalizar",
	"Identification": "Identificación",
	"go_back": "volver atrás",
	"Go_back": "Volver atrás",
	"go_up": "volver arriba",
	"Go_up": "volver arriba",
	"Gross_Replacement_Cost": "Coste de Reemplazamiento-reposición Bruto",
	"Gross_yearly_rent_income": "Renta bruta anual de alquiler",
	"Geolocation": "Geolocalización",
	"in_01": "en",
	"In_accordance_with_eco_decree_q": "¿s/ Orden ECO?",
	"In_accordance_with_mortgage_market_law_q": "¿s/ Ley Mercado Hipotecario?",
	"Independence": "Independencia",
	"Independent_professionals": "Profesionales independientes",
	"Independent_pl": "Independientes",
	"Index_of_Appraisals": "Índice de Tasaciones",
	"Individuals": "Particulars",
	"Industrial_warehouses": "Naves industriales",
	"Info_source": "Fuente de la información",
	"Informative_Appraisal_Fees": "Honorarios Tasación Informativa",
	"Infrastructures": "Infraestructuras",
	"Paving_execution_pct": "Porcentaje de ejecución de pavimentación",
	"Sewage_execution_pct": "Porcentaje de ejecución de alcantarillado",
	"Public_lighting_execution_pct": "Porcentaje de ejecución de alumbrado público",
	"Water_supply_execution_pct": "Porcentaje de ejecución de suministro de agua",
	"Electricity_supply_execution_pct": "Porcentaje de ejecución de suministo eléctrico",
	"Piped_gas_execution_pct": "Porcentaje de ejecución de gas canalizado",
	"Telephone_service_execution_pct": "Porcentaje de ejecución de servicio telefónico",
	"Gardened_areas_execution_pct": "Porcentaje de ejecución de zonas ajardinadas",
	"Total_execution_pct": "Porcentaje de ejecución total infraestructuras",
	"Infrastructures_repercussion_cost": "Coste de repercusión infraestructuras",
	"Pending_investment": "Inversión pendiente",
	"Paving": "Pavimentación",
	"Sewage": "Alcantarillado",
	"Public_lighting": "Alumbrado público",
	"Electricity_supply": "Suministro electricidad",
	"Piped_gas": "Gas canalizado",
	"Telephone_service": "Servicio telefónico",
	"Gardened_areas": "Zonas ajardinadas",
	"Land_is_plot_according_to_law": "¿Tiene el terreno consideración de solar según la Ley del Suelo?",
	"Notes_on_plot_infrastructures": "Observaciones sobre las infraestructuras",
	"Notes_on_plot_area": "Observaciones sobre la superficie del terreno",
	"Initial_Data": "Datos Iniciales",
	"Initial_unit_price": "Precio unitario inicial",
	"Innovation": "Innovación",
	"Insurance_companies": "Compañías de seguros",
	"Insurance_value": "Valor del seguro",
	"Interior_visit_check": "Visita interior",
	"Internal_regulation": "Reglamento interno",
	"Invalid_email_address": "La dirección de e-mail es incorrecta",
	"Investment_groups": "Grupos de inversión",
	"Invoices": "Facturas",
	"Is_it_rented_or_ceded_q": "¿El inmueble está alquilado o cedido?",
	"Is_the_real_estate_protected_q": "Está el inmueble protegido?",
	"Is_the_right_of_use_ceded_q": "El derecho de uso del inmueble está cedido?",
	"land": "suelo",
	"Land": "Suelo",
	"Land_area": "Superficie de terreno",
	"Land_registry_area": "Superficie registral del terreno",
	"Land_market_value": "Valor de mercado del suelo",
	"Land_pl": "Terrenos",
	"Land_total_value": "Valor total del suelo",
	"Land_value": "Valor del suelo",
	"Land_value_plus_deprecated_construction_cost": "Valor del suelo más coste de construcción depreciado",
	"Land_value_plus_executed_construction_cost": "Valor del suelo más coste de construcción realizada",
	"Landlord_expenses_pct": "Porcentaje neto restante debido a gastos del arrendador",
	"Language": "Idioma",
	"Last_modified": "Última modificación",
	"last_renovation_year": "Último año de rehabilitación",
	"Last_renovation_year": "Último año de rehabilitación integral",
	"Latitude": "Latitud",
	"Appraisal_adopted_area_missing_error_text": "Es necesario introducir la superficie construida del inmueble de referencia para poder proceder con el estudio de mercado",
	"Appraisal_property_type_missing_error_text": "Es necesario introducir el tipo de inmueble correspondiente al inmueble de referencia para poder realizar la consulta",
	"Lat_lng_missing_error_text": "Es necesario introducir las coordenadas de latitud y longitud para el inmueble actual",
	"Ad_type_missing_error_text": "Es necesario introducir el tipo de anuncio que se quiere obtener para poder realizar la consulta",
	"Date_missing_error_text": "Es necesario introdcir el rango de fechas (inicio y final) para poder consultar los anuncios",
	"Adopted_age_missing_error_text": "Es necesario introducir la antigüedad adoptada para poder proseguir",
	"Adopted_age_length_error_text": "La antigüedad adoptada tiene que ser un año, con formato 'YYYY'",
	"Adopted_area_missing_error_text": "Es necesario introducir la superficie construida para poder proseguir",
	"Property_type_missing_error_text": "Es necesario introducir el tipo de inmueble para poder proseguir",
	"Law_firms": "Despachos jurídicos",
	"Lift": "Ascensor",
	"link": "enlace",
	"Loading": "Cargando",
	"Log_In": "Iniciar sesión",
	"Longitude": "Longitud",
	"Looking_for_something_q": "Buscando algo?",
	"Lower_limit": "Límite inferior",
	"Machinery": "Maquinaria",
	"Market_coeficient": "Coeficiente de mercado",
	"Market_value_adjustment": "Ajuste del valor de mercado",
	"Market_value_of_the_appraised_realestate": "Valor de mercado del inmueble tasado",
	"Market": "Mercado",
	"Market_calculations": "Cálculos del mercado",
	"Market_studies_for_this_real_estate": "Estudios de mercado para este inmueble",
	"Market_study": "Estudio de mercado",
	"Market_study_for": "Estudio de mercado para",
	"Market_value_reduction_pct": "Reducción valor mercado (%)",
	"Market_studies": "Estudios de mercado",
	"Material_execution_cost": "Coste de ejecución material",
	"Market_unit_value": "Valor unitario de mercado",
	"Market_value": "Valor de mercado",
	"Maximum_Legal_Method": "Método Máximo Legal",
	"Mec_adjustment_coef": "Coeficiente de ajuste del coste de ejecución material",
	"Materials": "Materiales",
	"Maximum_legal_computable_area": "Superfície legal máxima computable",
	"Maximum_legal_sale_price": "Precio de venta máximo legal",
	"Measurements": "Mediciones",
	"Medical_centers": "Centros médicos",
	"Messages": "Mensajes",
	"Metadata": "Metadatos",
	"Minimum_benefit_acc_to_regulation": "Beneficio mínimo según la norma",
	"Minimum_fees": "Honorarios mínimos",
	"Modification": "Modificación",
	"Modified": "Modificado",
	"Mon.": "Lun.",
	"Mortgage_Appraisal_Fees": "Honorarios Tasación Hipotecaria",
	"Municipality": "Municipio",
	"Mutual_insurance_companies": "Mutuas",
	"Name": "Nombre",
	"Name_and_surnames": "Nombre y apellidos",
	"Name_and_TIN": "Nombre y NIF/CIF",
	"net_area": "superficie útil",
	"Net_area": "Superficie útil",
	"Net_areas": "Superficies útiles",
	"Net_Replacement_Cost": "Coste de Reemplazamiento-reposición Neto",
	"Net_yearly_rent_income": "Renta neta anual de alquiler",
	"New_address": "Nueva dirección",
	"New_appraisal_file": "Nuevo expediente de tasación",
	"New_contact": "Contacto nuevo",
	"New_entity": "Nueva entidad",
	"Number": "Número",
	"Number_of_floors_and_use": "Nº de plantas y uso",
	"No_address_registered": "Ninguna dirección registrada",
	"No_contact_registered": "Ningún contacto registrado",
	"No_email_address_registered": "Ningúna dirección de correo electrónico registrada",
	"No_telephone_number_registered": "Ningún nº de teléfono registrado",
	"No_results": "Ningún resultado",
	"Non_recoverable_taxes": "Impuestos no recuperables",
	"Non_recoverable_taxes_percentage": "Porcentaje de impuestos no recuperables",
	"Not_found_message": "Página no encontrada",
	"notes": "observaciones",
	"Notes": "Observaciones",
	"Notes_1": "Observaciones 1",
	"Notes_2": "Observaciones 2",
	"Notes_on_mortgage_valuation_validity": "Observaciones sobre la validez de la tasación para fines hipotecarios",
	"Occupancy_Card": "Cédula de habitabilidad",
	"Occupancy_Cards": "Cédulas de habitabilidad",
	"Occupancy_Card_and_Certificate": "Certificado y Cédula de Habitabilidad",
	"Occupancy_Certificate": "Certificado de habilidad",
	"occupancy_certificates": "cèdulas de habitabilidad",
	"of": "de",
	"of_the_excess_of": "del exceso de",
	"of_the_same_property": "del mismo inmueble",
	"Offer_price": "Precio de la oferta",
	"Offer_unit_price": "Precio unitario de la oferta",
	"Official_Appraisals": "Tasaciones Oficiales",
	"Official_appraisals_for_all_purposes": "Tasaciones oficiales para toda finalidad",
	"Office_hours": "Horario de oficinas",
	"Official_Register": "Registro Oficial",
	"Offices": "Oficinas",
	"Open": "Abrir",
	"Open_link_in_new_tab": "Abrir link en una nueva pestaña",
	"Organization_s_Company": "Organización / Empresa",
	"Orientation": "Orientación",
	"Other_services": "Otros servicios",
	"other_services": "otros servicios",
	"others": "others",
	"Other_elements_included_in_this_valuation_price": "Otros elementos incluidos en esta valoración",
	"Our_clients": "Nuestros clientes",
	"Our_services": "Nuestros servicios",
	"Our_workflow": "Nuestro flujo de trabajo",
	"PA_registration_number": "Nº colegiado",
	"Page_not_found": "Página no encontrada",
	"Parking_lots_number": "nº Plazas de garaje",
	"Parking_spaces": "Plazas de garaje",
	"Password": "Contraseña",
	"Person_type": "Tipo de persona",
	"Petitioner": "Solicitante",
	"Petitioner_data": "Datos del solicitante",
	"Petitioner_type": "Tipo de solicitante",
	"Philosophy": "Filosofía",
	"Philosophy_text_01": "La filosofía de la sociedad se puede resumir en tres principios fundamentales: profesionalidad, rapidez y ética. Todo ello unido a un buen equipo de profesionales y a un control de calidad exhaustivo",
	"Philosophy_text_02": "Para BARNA-TASA, S.A. los valores definen nuestra identidad como empresa y constituyen la fuerza propulsora del cómo hacemos día a día nuestro trabajo. Consideramos que nuestro éxito es consecuencia de los mismos, entre los que destacamos",
	"Philosophy_text_03": "Auditoría continua de nuestros procesos de realización de tasaciones y valoraciones unido al empleo de las últimas tecnologías. BARNA-TASA, S.A. dispone de software especialmente desarrollado para el ejercicio de la valoración empleando las herramientas informáticas más adecuadas. Todos nuestros informes incorporan certificación de firma digital",
	"Philosophy_text_04": "Es una sociedad cuyo accionariado y junta directiva es privado y NO VINCULADO a ninguna Entidad Financiera ni grupo immobiliario. BARNA-TASA, S. A. no intermedia en operaciones de compraventa en el mercado, por lo que sus servicios se prestan des de la más absoluta independencia",
	"Philosophy_text_05": "Capacidad de respuesta contrastada, efectividad y equilibrio de nuestras valoraciones. Compromiso de cumplir los requisitos y procesos necesarios para la satisfacción del cliente",
	"Philosophy_text_06": "Nuestro sistema de calidad se basa en los siguientes principios: La mejora continua y superación como objetivo permanente, lo cual se consigue especialmente a través del compromiso de toda la organización y del análisis sistemático de los resultados de calidad. Satisfacer las necesidades y expectativas de los clientes, cumpliendo los tiempos de entrega acordados con los clientes y trabajando en la mejora de los mismos, entregando siempre un buen producto a la primera. El cumplimiento de los requisitos, ya sean reglamentarios y legales, particulares de nuestros clientes o de cualquier otra índole, dando así respuesta a todas las partes interesadas",
	"Philosophy_text_07": "Asegurar el cumplimiento de la normativa vigente y el trabajo bien hecho",
	"Philosophy_text_08": "El hecho de estar homologados e inscritos con el número 4.470 en el Registro de Sociedades de Tasación del Banco de España y estar sujetos a la supervisión, garantiza el rigor la objetividad y la transparencia absoluta de nuestros informes de valoración",
	"Philosophy_text_09": "Más de tres décadas en el campo de la tasación avalan nuestro trabajo",
	"Philosophy_text_10": "La confidencialidad de los trabajos que la normativa exige, está garantizada por el secreto profesional que rige la conducta de nuestros técnicos. BARNA-TASA S.A. no revela información a terceras personas",
	"Philosophy_text_11": "BARNA-TASA, S. A. establece un marco de conducta para la sociedad y sus trabajadores",
	"Physical_depreciation": "Depreciación física",
	"Pick_an_option": "Selecciona una opción",
	"Plan_type": "Tipo de plan",
	"Please_enter_a_name": "Por favor, introduzca un nombre",
	"Please_enter_a_surname": "Por favor, introduzca un apellido",
	"Please_enter_a_telephone_number": "Por favor, introduzca un número de teléfono",
	"Please_enter_an_email_address": "Por favor, introduzca una dirección de correo electrónico",
	"Please_enter_the_type_of_property": "Por favor, introduzca el tipo de inmueble a tasar",
	"Please_enter_the_address_of_the_property": "Por favor, introduzca la dirección del inmueble",
	"Please_enter_the_postal_code": "Por favor, intoruzca el código postal del inmueble",
	"Please_enter_the_municipality": "Por favor, introduzca el municipio",
	"Please_enter_the_area_of_the_property": "Por favor, introduzca la superficie del inmueble",
	"Please_enter_the_purpose_of_the_appraisal": "Por favor, introduzca la finalidad de la tasación",
	"Plot_area": "Superficie del solar",
	"Postal_code": "Código postal",
	"Prefix": "Prefijo",
	"Price": "Precio",
	"Pricing": "Tarifas",
	"Pricing_and_Quotes": "Tarifas y Presupuesto",
	"Pricing_text_01": "Ofrecemos dos tipos de valoraciones: la valoración hipotecaria y la valoración informativa, según su finalidad",
	"Pricing_text_02": "Obtendrá en un plazo máximo de 24h el presupuesto por escrito de su tasación, sin compromiso",
	"Pricing_text_03": "Descuento por volumen de encargo. IVA APLICABLE: 21%",
	"Pricing_text_04": "Tasación hipotecaria: Regulada por la normativa ECO 805/2003 y disposiciones concordantes",
	"Pricing_text_05": "Las localidades fuera de Barcelona capital y área metropolitana tendrán incremento por desplazamiento",
	"Pricing_text_06": "Descuento especial para los pedidos de Informe de Tasación + Certificado de un mismo inmueble",
	"Print_report_in_PDF": "Imprimir informe en PDF",
	"Private_Enterprises": "Empresas Privadas",
	"Professional_association": "Colegio profesional",
	"Professional_ethics": "Ética profesional",
	"Professional_qualification": "Titulación",
	"Professionalism": "Profesionalidad",
	"Professionals_text_01_part_01": "Una sociedad de",
	"Professionals_text_01_part_02": "arquitectos, ingenieros y especialistas totalmente independientes",
	"Professionals_text_01_part_03": ", sin vinculación con entidades financieras ni grupos empresariales",
	"Properties": "Inmuebles",
	"Properties_under_economic_exploitation": "Inmuebles en explotación económica",
	"Property_data": "Datos del inmueble",
	"Property_developers": "Promotores inmobiliarios",
	"Property_developments": "Promociones inmobiliarias",
	"Property_purchase-sale": "Compraventa de inmuebles",
	"Property_type": "Tipo de inmueble",
	"Property_types": "Tipos de inmuebles",
	"Property_valuation_services": "Servicios de valoración inmobiliaria",
	"Property_visit": "Visita al inmueble",
	"protection": "protección",
	"Protection": "Protección",
	"Protection_type": "Tipo de protección",
	"Protection_regime": "Régimen de protección",
	"Protection_zone": "Zona de protección",
	"Province": "Provincia",
	"Public_Administrations": "Administraciones públicas",
	"purpose": "finalidad",
	"Qualities": "Calidades",
	"Qualities_comparison": "Comparación de calidades",
	"Quality": "Calidad",
	"Quality_of_construction": "Calidad de la construcción",
	"Quality_of_neighbourhood": "Calidad del barrio",
	"Quality_of_realestate": "Calidad del elemento",
	"Quality_of_situation": "Calidad de la situación",
	"Query_comparables": "Consultar comparables",
	"Query_real_estates": "Consultar inmuebles",
	"Query_result": "Resultado de la consulta",
	"Quote_request": "Solicitud de presupuesto",
	"Quotes": "Presupuestos",
	"Real_estate": "Inmueble",
	"Real_estates": "Inmuebles",
	"Real_estates_index": "Índice de inmuebles",
	"Real_estate_referral": "Inmueble de referencia",
	"Realestates_remaining_useful_life": "Vida útil restante del inmueble",
	"Real_estates_residual_value_at_the_end_of_the_contracts_useful_life": "Valor residual del inmueble al final de la vida útil del contrato",
	"Real_estate_value": "Valor del inmueble",
	"RealEstate_description": "Descripción del inmueble",
	"Reduction": "Reducción",
	"Reduction_pct": "Reducción (%)",
	"Registry_data": "Datos registrales",
	"Registry_identification_data": "Identificación registral",
	"Register_name": "Nombre del Registro",
	"Regression_line": "Línea de regresión",
	"Regression_line_calculation": "Cálculo de la línea de regresión",
	"Remaining_contract_years": "Años restantes de contrato",
	"Remaining_period_update": "Actualización del período restante",
	"Remaining_of_the_developers_benefit": "Restante del beneficio del promotor",
	"Repercussion_method": "Método de repercusión",
	"Report": "Informe",
	"reports": "informes",
	"Report_content": "Contenido del informe",
	"Report_content_text_01": "Visita al inmueble y elaboración de informe oficial realizado por un técnico qualificado de Barna-Tasa",
	"Report_content_text_02": "Identificación y localización. Características del inmueble. Datos catastrales y registrales",
	"Report_content_text_03": "Fotografías y croquis del inmueble",
	"Report_content_text_04": "Estudio de mercado real, selección de muestras y cálculo de valores del informe",
	"Report_date": "Fecha del informe",
	"Report_language": "Idioma del informe",
	"Requesting": "Solicitando",
	"Report_number": "Nº de informe",
	"Report_title": "Título del informe",
	"Report_title_missing_error_text": "Falta el título del informe",
	"Representative": "Representante",
	"representative_sample": "muestra representativa",
	"Representative_sample": "Muestra representativa",
	"Representative_TIN": "NIF del representante",
	"Request_a_quote": "Solicitar presupuesto",
	"Request_a_quote_24h": "Solicite presupuesto (24h)",
	"Request_a_quote_here": "Solicite presupuesto aquí",
	"Request_a_quote_for_an_appraisal": "Solicitar presupuesto de tasación",
	"Request_successfully_sent": "Solicitud correctamente enviada",
	"Required_fields": "Campos requeridos",
	"Residual_depreciation": "Depreciación residual",
	"Residual_value": "Valor residual",
	"Restaurants": "Restaurantes",
	"Restricted": "Restringido",
	"Right_of_use": "Derecho de uso",
	"Right_of_use_value": "Valor del derecho de uso",
	"rights": "derechos",
	"Rights": "Derechos",
	"Rigor": "Rigor",
	"Risk_premium": "Prima de riesgo",
	"Riskfree_rate": "Tasa libre de riesgo",
	"Room": "Habitación",
	"Rooms": "Habitaciones",
	"Sat.": "Sáb.",
	"Save": "Guardar",
	"Save_and_go_back": "Guardar y volver",
	"Save_valuation": "Guardar tasación",
	"Search_radius_km": "Radio de búsqueda (km)",
	"Security": "Seguridad",
	"Selected_comparables": "Comparables seleccionados",
	"Send_to_bde_q": "¿Enviar al BdE?",
	"Services": "Servicios",
	"Services_text_01": "BARNA-TASA, S.A. es una sociedad especializada en la VALORACIÓN DE BIENES, homologada y registrada en el Banco de España 'con el número 4.470 en el Registro Oficial de Entidades de Tasación. Nuestra experiencia se basa en más de 30 años de ejercicio profesional en el ámbito de tasaciones, valoraciones y peritajes de la construcción",
	"Services_text_02": "Nuestro principal servicio se enmarca en el campo de las valoraciones y tasaciones con todas las finalidades. También ofrecemos un abanico de servicios relacionados con el mundo de la arquitectura y el peritaje, desde la elaboración de dictámenes y peritajes de construcción hasta certificados, cédulas y levantamientos de planos",
	"Services_text_03": "Realizamos tasaciones para todas las finalidades. Ofrecemos dos tipos de tasaciones según su finalidad",
	"Services_text_04": "La tipología habitual de bienes inmuebles y derechos que valoramos mediante el correspondiente informe de tasación es la siguiente",
	"Services_text_05": "Aceptación del encargo y entrega de documentación necesaria",
	"Services_text_06": "Visita al inmueble por parte de un técnico de BARNA-TASA",
	"Services_text_07": "Elaboración del informe o informes por parte de BARNA-TASA",
	"Services_text_08": "Entrega del informe en formato digital y / o papel",
	"Sign_Up": "Regístrate",
	"Source": "Fuente",
	"Sports_clubs": "Clubs deportivos",
	"Sports_facilities": "Instalaciones deportivas",
	"Staircase": "Escalera",
	"Standard_deviation_of_the_sample": "Desviación estándar de la muestra",
	"Storerooms": "Trasteros",
	"Street_name": "Nombre de vía",
	"Street_number": "Nº vía",
	"Structure": "Estructura",
	"Sun.": "Dom.",
	"Supervisor": "Supervisor",
	"Surnames": "Apellidos",
	"Surnames_name": "Apellidos, Nombre",
	"Surroundings": "Entorno",
	"Surveying": "Levantamiento de planos",
	"Swimming_pool": "Piscina",
	"Tasks": "Tareas",
	"Taxes": "Impuestos",
	"technical_values": "valores técnicos",
	"Technical_values": "Valores técnicos",
	"Technology": "Tecnología",
	"Team_text": "La sociedad está formada por un grupo de arquitectos, ingenieros y especialistas en tasaciones con un amplio conocimiento del mercado inmobiliario y con una experiencia contrastada de más de 30 años en el campo de la valoración inmobiliaria",
	"Teamwork": "Trabajo en equipo",
	"Telephone": "Teléfono",
	"Telephone_contact": "Teléfono de contacto",
	"telephone_number": "nº de telèfon",
	"Telephone_number": "Nº de Teléfono",
	"Telephone_numbers": "Números de teléfono",
	"Tenant_age_years": "Edad del arrendatario",
	"Tenant_remaining_life_expectancy_years": "Vida restante estimada arrendatario",
	"Terrain": "Terreno",
	"Testamentary_shares": "Participaciones testamentarias",
	"The_company": "La Empresa",
	"The_page_contains_unsaved_changes": "La página actual contiene cambios no guardados",
	"The_passwords_do_not_match": "Las contraseñas no coinciden",
	"thousand": "mil",
	"thousand_euros": "mil euros",
	"thousands_of_euros": "miles de euros (€)",
	"Thu.": "Jue.",
	"to": "a",
	"Total_depreciation": "Depreciación total",
	"Total_value": "Valor total",
	"total_values": "valores totales",
	"Total_values": "Valores totales",
	"Trust": "Confianza",
	"Others": "Otros",
	"TIN": "NIF / CIF",
	"Title": "Título",
	"Title_and_date_of_report": "Título y fecha del informe",
	"Title_s_Honorific": "Título / Tratamiento",
	"Transparency": "Transparencia",
	"type": "tipo",
	"Type": "Tipo",
	"Type_here_to_filter_paginated_data": "Escribe aquí para filtrar los datos paginados",
	"Type_of_property": "Tipo de inmueble",
	"Typical_deviation": "Desviación típica",
	"Typology": "Tipología",
	"Uncovered_outdoor_area": "Superficies exteriores descubiertas",
	"Unit_price": "Precio unitario",
	"Unit_value": "Valor unitario",
	"universal_sample": "muestra universal",
	"Universal_sample": "Muestra universal",
	"Updated_reversion_value": "Valor de reversión actualizado",
	"Update_type": "Tipo de actualización",
	"Update_value": "Valor de actualización",
	"Update_value_calculation": "Cálculo del valor de actualización",
	"Upper_limit": "Límite superior",
	"Url": "Link",
	"Useful_life": "Vida útil",
	"Usufruct": "Usufructo",
	"Usufruct_value": "Valor del usufructo",
	"Usufructuary_age_years": "Edad del usufructuario",
	"Urban_planning_parameters": "Parámetros urbanísticos",
	"valuated_in_this_report": "valorados en este informe",
	"Valuation": "Tasación",
	"Valuation_pricing": "Tarifas de tasación",
	"valuations": "valoraciones",
	"Valuation_date": "Fecha del valor de tasación",
	"Valuation_purpose": "Finalidad de la valoración",
	"Valuation_report": "Informe de valoración",
	"Valuation_type": "Tipo de tasación",
	"Value_date": "Fecha del valor",
	"Version": "Versión",
	"VAT": "IVA",
	"Visits": "Visitas",
	"Warnings": "Advertencias",
	"We_are_sorry_c_the_page_you_requested_cannot_be_found": "Lo sentimos, no podemos encontrar la página solicitada",
	"Weighing": "Ponderación",
	"Welcome_message": "Bienvenido a la App de Barnatasa",
	"What_you_need_to_provide": "Qué necesitas aportar?",
	"with": "con",
	"without_saving": "sin guardar",
	"Workflow": "Flujo de trabajo",
	"Wrong_date_message": "La fecha es incompleta o incorrecta",
	"years": "años",
	"You_are_about_to_delete": "Se eliminará",
	"Registry_area": "Superficie Registral",
	"Checked_area": "Superficie comprobada",
	"Plot_occupation": "Ocupación del solar",
	"Plot_free_area_usage": "Uso de la superficie libre del solar",
	"Floors_number_underground": "Nª de plantas bajo rasante",
	"Floors_number_overground": "Nº de plantas sobre rasante",
	"Parking_slots_included_in_appraisal_number": "Nº de plazas de garaje incluidas en la valoración",
	"Entrance_hall": "Portal",
	"Doorman_space": "Portería",
	"Community_room": "Sala comunitaria",
	"Storage_room_included_in_appraisal": "Trastero incluido",
	"Community_parking": "Garaje",
	"Facilities_others": "Otros",
	"Floors_usage_underground": "Uso bajo rasante",
	"Floors_usage_overground": "Uso sobre rasante",
	"Groundfloor_usage": "Uso planta baja",
	"Real_estates_useful_life": "Vida útil del inmueble",
	"Real_estates_total_useful_life": "Vida útil total del inmueble",
	"Remaining_useful_life_years": "Años restantes de vida útil",
	"Urban_and_surroundings_text": "Urbanismo y entorno",
	"Communications": "Comunicaciones",
	"Airport": "Aeropuerto",
	"Harbour": "Puerto",
	"Train": "Tren",
	"Public_transport": "Transporte público",
	"Urban_underground": "Urbano subterráneo",
	"Interurban": "Interurbano",
	"Territorial_feature": "Característica territorial",
	"Income_level": "Nivel de la renta",
	"Homogeneity_feature": "Rasgos de homogeneidad",
	"Main_uses": "Usos dominantes",
	"Density": "Densidad",
	"Accessibility": "Accesibilidad",
	"Consolidation_degree": "Grado de consolidación",
	"Occupation_degree": "Grado de ocupación",
	"Evolution": "Evolución",
	"Average_age": "Antigüedad característica",
	"Commercial": "Comercial",
	"Educational": "Educacional",
	"Public_parking": "Aparcamiento público",
	"Medical_assistance": "Asistencia médica",
	"Leisure": "Ocio",
	"Building_development_level": "Nivell de desenvolupament de l'edificació",
	"Facilities": "Equipamientos",
	"MUC_map": "Mapa del MUC",
	"Registry": "Registro",
	"Section": "Sección",
	"Volume": "Tomo",
	"Book": "Libro",
	"Page": "Página",
	"Registry_real_estate_number": "Nº de finca registral",
	"Holder": "Titular",
	"Property_coef": "Coeficiente de propiedad",
	"Bedrooms_and_bathrooms": "Dormitorios y baños",
	"Covered_outdoor_areas": "Superficies exteriores cubiertas",
	"Uncovered_outdoor_areas": "Superficies exteriores descubiertas",
	"Add_covered_outdoor": "Añadir espacio exterior cubierto",
	"Add_uncovered_outdoor": "Añadir espacio exterior descubierto",
	"Enclosed_area": "Superficie cerrada",
	"Enclosed_checked_area": "Superficie cerrada comprobada",
	"Low_enclosed_checked_area_error_text": "La superficie cerrada comprobada es inferior a la superficie total útil",
	"Proportional_part_of_common_elements": "Parte proporcional de elementos comunes",
	"Common_elements_cadastral_area": "Elementos Comunes Catastro",
	"Common_elements_registry_area": "Elementos Comunes Registro",
	"Common_elements_checked_area": "Elementos Comunes Comprobada",
	"Common_elements_adopted_area": "Elementos Comunes Adoptada",
	"Total_areas_summary_table": "Resumen de superficies totales",
	"Register": "Registro",
	"Cadaster": "Catastro",
	"Checked": "Comprobada",
	"Selected": "Seleccionada",
	"Adopted": "Adoptada",
	"Usage": "Uso",
	"Covered_outdoors_area": "Superficie espacios cubiertos exteriores",
	"Uncovered_outdoors_area": "Superiície espacios descubiertos exteriores",
	"Built_plus_common_elements_area": "Superficie Construida + Elem. Com.",
	"Built_plus_common_elements": "Construida + Elem. Com.",
	"Common_elements": "Elementos comunes",
	"Number_of_rooms_to_exterior": "Nº de habitaciones exteriores",
	"Day_night_zoning": "Zonificación día / noche",
	"Door_opener": "Portero automático",
	"Fitted_cupboards": "Armarios empotrados",
	"Gas": "Gas",
	"Sanitary_fittings": "Aparatos sanitarios",
	"Taps": "Grifería",
	"Hot_water": "Agua caliente",
	"Fire_prevention": "Prevención al fuego",
	"Intrusion_prevention": "Prevención al intrusismo",
	"Foundation": "Cimentación",
	"Roof": "Cubierta",
	"External_enclosures": "Cerramientos exteriores",
	"Insulation": "Aislamiento",
	"External_carpentry": "Carpintería exterior",
	"Glazing": "Acristalamiento",
	"Views": "Vistas",
	"Windows_size_and_quantity": "Dimensión y cantidad de ventanas",
	"Noise_facade": "Nivel de ruido en fachada",
	"Systems": "Instalaciones",
	"conservation_status": "estado de conservación",
	"Building_shell": "Envolvente del edificio",
	"building_shell": "envolvente del edificio",
	"Shell": "Envolvente",
	"shell": "envolvente",
	"Interior_finishes": "Acabados interiores",
	"Living": "Estar",
	"Kitchen": "Cocina",
	"Walls": "Paredes",
	"Ceilings": "Techos",
	"Interior_carpentry": "Carpintería interior",
	"Circulations": "Circulaciones",
	"BdE_files": "Fichas BdE",
	"Construction_prices": "Costes de construcción",
	"Add_bec_property": "Añadir tipo de inmueble",
	"Add_bec_number": "Añadir nº B.E.C.",
	"Year": "Año",
	"Quarter": "Trimestre",
	"Bec_adjustment_coef": "Coeficiente de ajuste del B.E.C.",
	"Adjusted_bec_price": "Precio ajustado del B.E.C.",
	"Expenses_and_industrial_benefit_bec_pct": "Porcentaje de Gastos y Beneficio Industrial",
	"Construction_status": "Estado de construcción",
	"Construction_cost_notes": "Observaciones sobre el coste de construcción",
	"Mandatary": "Mandatario",
	"Mandatary_entity": "Entidad mandataria",
	"Acc_mortgage_market_law_q": "Sigue la ley del mercado hipotecario?",
	"Acc_eco_decree_q": "Sigue la orden ECO/805/2003?",
	"location": "localización",
	"Registry_property": "Finca registral",
	"Cadastral_file": "Ficha Cadastral",
	"Nucleus_area": "Superficie del municipio",
	"Nucleus_type": "Tipo de núcleo",
	"Locality": "Localidad",
	"Employment_occupation": "Ocupación laboral",
	"Population": "Población",
	"Population_density": "Densidad de población",
	"Population_growth": "Crecimiento de población",
	"Last_year": "Último año",
	"Terrain_description": "Descripción del terreno",
	"Terrain_infrastructures": "Infraestructuras del terreno",
	"Execution": "Ejecución",
	"Water_supply": "Suministro de agua",
	"Terrain_area": "Superficie del terreno",
	"Site_quality": "Calidad del emplazamiento",
	"Underground_levels": "Niveles bajo rasante",
	"Ground_level": "Nivel rasante",
	"Overground_levels": "Niveles sobre rasante",
	"Building_description": "Descripción de la edificación",
	"Checkings_realized": "Comprobaciones realizadas",
	"Documents_used": "Documentación utilizada",
	"Interior_visit": "Visita interior del inmueble",
	"Expropriation_procedure": "Procedimiento de expropiación",
	"Expropriation_plan": "Plan o proyecto de expropiación",
	"Expropriation_admin_ruling": "Resolución administrativa expropiació",
	"Expropriation_file": "Expediente de expropiación",
	"Occupancy": "Estado de ocupación y uso",
	"Servitudes": "Servidumbres",
	"Public_protection_regime": "Régimen de protección pública",
	"Urban_paramaters_suitability": "Adecuación al planeamiento urbanístico",
	"Another": "Otra",
	"Approved_project_by_professional_association": "Proyecto visado por el colegio profesional",
	"Cadastral_documents": "Documentación catastral",
	"Construction_license": "Licencia de construcción",
	"Construction_last_certificate": "Último certificado de construcción",
	"Construction_contract": "Contrato de construcción",
	"Occupancy_status": "Estado de ocupación",
	"Photographic_report": "Reportaje fotográfico",
	"Property_sketch": "Croquis del inmueble",
	"Property_titles": "Documento de propiedad según normativa",
	"Situation_plan": "Plano de situación",
	"Ten_year_insurance": "Seguro decenal",
	"Urban_plan": "Plano urbanístico",
	"Habitability_conditions": "Condiciones de habitabilidad",
	"Main_orientation": "Orientación principal",
	"Property_title": "Título de propiedad",
	"Usage_assigned": "Uso asignado",
	"Usage_assigned_by_the_owner": "Uso asignado por la propiedad",
	"Inspection_realized": "Comprobación realizada",
	"Economical_activity": "Actividad económica",
	"Real_rights": "Derechos reales",
	"Bulletin_number": "Nº de Boletín",
	"a": "un",
	"Select": "Seleccionar",
	"Market_data": "Datos de mercado",
	"Market_samples": "Muestras de mercado",
	"Offer_date": "Fecha de la oferta",
	"Sample": "Muestra",
	"Market_analysis": "Análisis de mercado",
	"Prices_estimated_yearly_evolution_pct": "Precios - evolución anual, variación estimada (%)",
	"Market_value_evolution_probability_pct": "Previsión evolución del valor de comparación (%)",
	"Offer_production": "Oferta - producción",
	"Offer_yearly_stock": "Oferta - Stock anual",
	"Offer_trend": "Oferta - tendencia",
	"Demand_level": "Demanda - nivel",
	"Demand_speed_of_sales": "Demanda - velocidad de ventas",
	"Demand_trend": "Demanda - tendencia",
	"Prices_expectancy": "Precios - Expectativa",
	"Prices_past_cicles_volatility": "Expectativa - Volatilidad de ciclos pasados",
	"Market_conjuncture": "Coyuntura de mercado",
	"Market_value_reduction_probability_expectancy": "Expectativa - Probabilidad de reducción del valor de comparación",
	"Offer": "Oferta",
	"Demand": "Demanda",
	"Expectation": "Expectativa",
	"Maximum": "Máximo",
	"Minimum": "Mínimo",
	"Mean": "Media",
	"Median": "Mediana",
	"Market_prices": "Precios del mercado",
	"Neighbourhood": "Barrio",
	"Situation": "Situación",
	"Samples": "Muestras",
	"Similarities": "Similitudes",
	"Statistical_deviations": "Desviaciones estadísticas",
	"Typical_deviation_of_the_sample": "Desviación típica de la muestra",
	"Technical_values_calculation": "Cálculo de valores técnicos",
	"Material_execution_cost_as_new": "Coste de ejecución material a nuevo",
	"Finished_building_market_value": "Valor de mercado edificio acabado",
	"finished_building": "inmueble acabado",
	"Total_values_calculation": "Cálculo de valores totales",
	"year": "año",
	"Other_values": "Otros valores",
	"Appraisal_value_determination_text": "De acuerdo con los criterios establecidos en la orden ECO 805/2003, el valor aplicable es el siguiente:",
	"Add_constraint": "Añadir condicionante",
	"Add_warning": "Añadir advertencia",
	"Add_note": "Añadir observación",
	"Constraints": "Condicionantes",
	"Constraints_foreseen_by_law": "Condicionantes previstos por Ley",
	"Warnings_foreseen_by_law": "Advertencias previstas por Ley",
	"Notes_foreseen_by_barnatasa": "Observaciones previstas por BARNA-TASA S.A.",
	"English": "Inglés",
	"Spanish": "Castellano",
	"The_Real_Estate_is_not_protected": "El inmueble no está protegido",
	"The_Real_Estate_is_not_rented_or_ceded": "El inmueble no está alquilado o cedido",
	"There_is_no_cession_of_the_right_of_use": "El derecho de uso del inmueble no está cedido",
	"The_value_is_not_calculated": "El valor no se calcula",
	"Elements_included_in_this_valuation": "Elementos incluidos en esta valoración",
	"Market_value_adjustment_pct": "Porcentaje de ajuste del valor de mercado",
	"Constraint": "Condicionante",
	"Warning": "Advertencia",
	"Note": "Observación",
	"Upload_photographs": "Cargar fotografías",
	"Photograph": "Fotografía",
	"Photographs": "Fotografías",
	"Image_footer": "Pie de imagen",
	"Upload_files": "Cargar archivos",
	"File_name": "Nombre del archivo",
	"in": "en",
	"Registry_Documents": "Documentos Registrales",
	"Cadastral_Documents": "Documentos Catastrales",
	"Plans": "Planos",
	"Sketches": "Croquis",
	"Cession_Documents": "Documentos de Cessión",
	"Contracts": "Contratos",
	"Other_Documents": "Otros Documentos",
	"with_date": "con fecha",
	"Date_of_issue": "Fecha de emisión",
	"Signatures": "Firmas",
	"Report_date_of_issue": "Fecha de emisión del informe",
	"Professional_that_visited_the_property": "Técnico que realizó la visita",
	"Date_of_visit": "Fecha de la visita",
	"Appraisers": "Tasadores",
	"Supervisors": "Supervisores",
	"Appraisers_Index": "Índice de Tasadores",
	"Supervisors_Index": "Índice de Supervisores",
	"Add_appraiser": "Añadir tasador",
	"Add_supervisor": "Añadir supervisor",
	"Visit_date": "Fecha de la visita",
	"Technician_who_performed_the_visit": "Técnico visita",
	"Visit": "Visita",
	"Floor_name": "Nombre de planta",
	"Import_comparable_set": "Importar conjunto de comparables",
	"Import_comparable_set_from_another_market_study": "Importar conjunto de comparables from another market study",
	"There_are_unsaved_changes": "Existen cambios no guardados",
	"Unsaved_data_will_be_lost": "Se perderán los datos no guardados",
	"Cover": "Portada",
	"Annexed_documents": "Documentos anexos",
	"Photographies": "Fotografías",
	"Report_of": "Informe de",
	"correlated_pages_numbered_from": "páginas correlativas, numerades de ",
	"technician": "técnico",
	"Sanitary_fittings_quality": "Calidad aparatos sanitarios",
	"Taps_quality": "Calidad grifería",
	"Land_selected_area": "Método de selección",
	"Urban_parameters_suitability": "Adecuación al plan urbanístico",
	"Maps": "Mapas",
	"Situation_maps": "Mapas de situación y emplazamiento",
	"Other": "Otra",
	"Subsidy_status": "Calificación de protección pública",
	"Quote": "Presupuesto",
	"Appraisal_quote": "Presupuesto de tasación",
	"Appraisal_quotes": "Presupuestos de tasación",
	"Add_appraisal_quote": "Añadir presupuesto de tasación",
	"Title_and_date_of_quote": "Título y fecha del presupuesto",
	"valuated_in_this_quote": "valorados en este presupuesto",
	"Quote_title_missing_error_text": "Falta el título del presupuesto",
	"Print_quote_in_PDF": "Imprimir presupuesto en PDF",
	"Create_new_real_estate": "Crear nuevo inmueble",
	"Select_Real_estate_to_be_added": "Selecciona inmueble a añadir",
	"Existing_Real_estates": "Inmuebles existentes en la base de datos",
	"create_a_new_one": "crea uno nuevo",
	"staircase": "escalera",
	"block": "bloque",
	"door": "puerta",
	"Full_address": "Dirección completa",
	"Status": "Estado",
	"Quote_number": "Nº de presupuesto",
	"Quote_content": "Contenido del presupuesto",
	"Quote_title": "Título del presupuesto",
	"Travel_expenses": "Gastos de desplazamiento",
	"Travel_one_way_hours": "Horas de viaje (ida)",
	"Travel_both_ways_hours": "Horas de viaje (ida y vuelta)",
	"Travel_fees_per_hour": "Honorarios por hora de viaje",
	"Total_car_expenses_one_way": "Gastos de gasolina y peajes (ida)",
	"Total_car_expenses_both_ways": "Gastos totales de gasolina y peajes (ida y vuelta)",
	"Total_travel_fees": "Gastos totales por desplazamiento",
	"Quote_area_average_unit_price": "Media de precios de la zona (€/m2)",
	"Quote_base_fees": "Honorarios base",
	"Quote_excess_pct": "% del exceso de honorarios base",
	"Quote_base_price": "Honorarios finales",
	"Quote_base_price_coef": "Coeficiente de ajuste",
	"Valuation_quote": "Presupuesto de tasación",
	"Appraisal_cost": "Coste de tasación",
	"Appraisal_fees": "Honorarios de tasación",
	"Appraisal_price": "Precio de tasación",
	"hours": "horas",
	"Area_prices": "Precios de la zona",
	"Area_average_unit_price": "Precio medio de la zona",
	"Ads_date_range": "Rango de fechas de los anuncios",
	"Current_area_prices": "Precios actuales de la zona",
	"pre_appraisal": "pre-tasación",
	"Pre_appraisal": "Pre-tasación",
	"Estimated_built_area": "Superficie construida estimada",
	"Pre_appraisal_value": "Valor de pre-tasación",
	"Area_average_price_coef": "Coeficiente de ajuste del precio",
	"Adopted_area_average_price": "Precio unitario adoptado",
	"Car_fuel_expenses_one_way": "Coste Gasolina (ida)",
	"Car_fuel_expenses_both_ways": "Coste Gasolina (ida y vuelta)",
	"Car_toll_expenses_one_way": "Coste Peajes (ida)",
	"Car_toll_expenses_both_ways": "Coste Peajes (ida y vuelta)",
	"Valuation_pricing_info_table": "Tabla de precios de tasación",
	"Check_prices": "Buscar precios",
	"Add_ad_manually": "Añadir nuevo anuncio manualmente",
	"Ads_index": "Índice de anuncios",
	"Go_back_to_market_study": "Volver al estudio de mercado",
	"Offer_price_reduction_coef": "Coeficiente reductor del precio",
	"Cession_files": "Documentps de arrendamiento",
	"Lease": "Arrendamiento",
	"Gross_tax_per_1000_inhabitants": "Tasa bruta por cada 1.000 habitantes",
	"Site": "Emplazamiento",
	"Urban_planning": "Urbanismo",
	"Construction_description": "Descripción de la construcción",
	"Status_on_occupancy_protection_cession_usage_and_real_rights": "Estado de ocupación, régimen de protección, cesión, uso y derechos reales",
	"Real_rights_protection_and_occupation": "Derechos reales, protección y ocupación",
	"PA_number": "Nº de colegiado",
	"Quote_petitioner": "Solicitante del presupuesto",
	"Quote_petitioners": "Solicitantes de presupuesto",
	"Dear": "Estimado",
	"Dear_m": "Estimado",
	"Dear_f": "Estimada",
	"Quote_sentence_01": "Nos place adjuntar presupuesto de honorarios para el Informe de Tasación de los seguientes inmmuebles:",
	"Approx_area": "Superficie aprox.",
	"Signed": "Firmado",
	"Amount_money": "Importe",
	"Total_cost_including_VAT": "Coste total (IVA incluïdo)",
	"Fiscal_parameters": "Parámetros fiscales",
	"VAT_pct": "IVA (%)",
	"Quote_sentence_02": "Se realizará pago del 50% al inicio del trabajo y el 50% restante a la entrega de los Informes de Tasación",
	"Quote_sentence_03": "Abonar en cuenta bancaria de BARNA-TASA, S.A.",
	"Quote_sentence_04": "Tareas a realizar para confecccionar los informes de tasación",
	"Quote_sentence_05": "Visita a los inmuebles por un técnico Arquitecto o Ingeniero de BARNA-TASA",
	"Quote_sentence_06": "Elaboración del informe. Contenido",
	"Payment_details": "Detalles de pago",
	"Required_documentation": "Documentación necesaria",
	"Quote_sentence_07": "Entrega de los informes en formato digital (PDF)",
	"Quote_sentence_08": "Si se requiere de entrega en papel (opcional) se aplicará un coste adicional de 15 € en concepto de impresión y envío",
	"Quote_sentence_09": "Nombre, NIF y dirección del solicitante",
	"Quote_sentence_10": "Nombre NIF y dirección fiscal para la factura",
	"Quote_sentence_11": "Copia completa de la escritura o de la nota registral",
	"Quote_sentence_12": "Copia del IBI (datos Catastrales) (opcional)",
	"Quote_sentence_13": "Copia del contrato de alquiler y un recibo actualizado si se trata de un inmueble en alquiler",
	"Quote_sentence_14": "Finalidad de la tasación (adquisición o venta, constituir garantías hipotecarias, expropiación...)",
	"Quote_sentence_15": "Nombre y teléfono de la persona de contacto para visitar la finca",
	"Quote_sentence_16": "Planos de la finca (opcional)",
	"At_your_disposal_for_any_clarification": "A su disposición para cualquier acalaración",
	"Kindest_regards": "Reciba nuestra cordial salutación",
	"CFO_CHRO_female": "Directora de Finanzas y Recursos Humanos",
	"Additional_costs": "Otros importes",
	"Quote_sentence_17": "En el caso de ser necessaria la assistencia del técnico en el juzgado para la ratificación del informe el coste será de 150 € + IVA",
	"Quote_sentence_18": "La entrega del informe se hará en formato digital (PDF). En el caso de requerirse la entrega del informe en papel, el coste será de 15 € en concepto de impresión y envío",
	"Appraisal_invoice": "Factura",
	"Appraisal_invoices": "Facturas",
	"Add_appraisal_invoice": "Añadir factura",
	"Title_and_date_of_invoice": "Título y fecha de factura",
	"valuated_in_this_invoice": "valorados en esta factura",
	"Invoice_title_missing_error_text": "Falta el título de la factura",
	"Print_invoice_in_PDF": "Imprimir factura en PDF",
	"Valuation_invoice": "Factura",
	"Invoice": "Factura",
	"Client": "Cliente",
	"Invoice_number": "Nº de factura",
	"Invoice_content": "Contenido de la factura",
	"Invoice_title": "Título de la factura",
	"Add_petitioner": "Añadir solicitante",
	"Create_new_contact": "Crear nuevo contacto",
	"No_petitioners_text": "No se ha añadido ningún contacto en la lista de solicitantes. Seleccione un contacto de la lista y haga click en 'añadir solicitante''",
	"Surnames_name_or_company": "'Apellidos, Nombre' o 'Nombre de la empresa'",
	"No_records": "No existen registros",
	"Quotes_requested_by": "Presupuestos solicitados por",
	"Dear_sir_or_madam": "Querido Sr. / Sra.",
	"Dear_sirs_or_madams": "Queridos Sres. / Sras.",
	"Dear_sir": "Querido senyor",
	"Dear_madam": "Querida senyora",
	"Dear_sirs": "Queridos señores",
	"Dear_madams": "Queridas señoras",
	"Dear_madams_and_sirs": "Queridas señoras y señores",
	"Dear_madam_and_sir": "Querida señora y señor",
	"Dear_pl": "Queridos",
	"Dear_pl_f_m": "Queridas y queridos",
	"Dear_pl_f": "Queridas",
	"Dear_pl_m": "Queridos",
	"Main_email": "Dirección de E-mail principal",
	"Add_other_email": "Añadir e-mail adicional",
	"Complete_name": "Nombre completo",
	"Payment_conditions": "Condiciones de pago",
	"Note_w": "Nota",
	"Final_price": "Precio final",
	"Discount_pct": "Descuento (%)",
	"Discount_notes": "Nota sobre el descuento",
	"Bank_name": "Nombre del banco",
	"Court_assistance_fees": "Honorarios assistencia juicio",
	"Required_docs": "Documentación necessaria",
	"Documentation_type": "Tipo de documentación",
	"Add_required_doc": "Añadir en la lista",
	"Document": "Documento",
	"Petitioners_missing_error_text": "Falta añadir el solicitante de presupuesto",
	"Realestates_missing_error_text": "Falta añadir los inmuebles del presupuesto",
	"Requireddocs_missing_error_text": "Falta añadir la documentación necesaria",
	"Discount": "Descuento",
	"Fees_incl_discount": "Honorarios con descuento",
	"Quote_reference": "Presupuesto asociado a la factura",
	"Invoice_lines": "Linias de factura",
	"Add_invoice_line": "Añadir linia de factura",
	"Units": "Unidades",
	"Import_quote_concepts": "Importar conceptos del presupuesto",
	"invoice": "factura",
	"line": "linia",
	"Lines_missing_error_text": "Falta introducir los conceptos de la factura",
	"Concept": "Concepto",
	"Add_client": "Añadir cliente",
	"Appraisal_invoice_description": "Descripción de la factura",
	"Invoice_to": "Factura a",
	"Emited_by": "Emitida por",
	"Invoice_Total": "Total Factura",
	"Emmission_date": "Fecha de emisión",
	"Reference": "Referencia",
	"Appraisal_invoices_index": "Índice de facturas",
	"Appraisal_quotes_index": "Índice de presupuestos",
	"Invoice_fiscal_number": "Nº fiscal de factura",
	"Billing": "Facturación",
	"invoice_fiscal_number": "nº fiscal de factura",
	"Last_m": "Último",
	"invoice_number": "nº de factura",
	"Last_created_invoice": "Última factura creada",
	"Welcome": "Bienvenido",
	"Ad_description": "Descripción del anuncio",
	"Upload_to_database": "Guardar e incorporar a la base de datos",
	"Address_referral": "Dirección de referencia",
	"Max_distance": "Distancia máx.",
	"Print_report_s_certificate_in_PDF": "Imprimir informe/certificado en PDF",
	"Appraisal_certificate": "Certificado de tasación",
	"Certificate_text_01": "Ferran López-Doriga Fontcuberta, Arquitecto Superior, en calidad de Director y Supervisor de Tasaciones de BARNA-TASA, S.A., inscrita en el Registro Oficial de Sociedades de Tasación del Banco de España, con el nº 4.470 y fecha de inscripción 26 de Junio de 1.995,",
	"Certificate_text_02": "Que con el número de Expediente",
	"Certificate_text_03": "se ha efectuado un informe de tasación con fecha<",
	"Certificate_text_04": "y la tasación consta en resumen de los siguientes datos",
	"Certificate_text_05": "Para que conste a los efectos oportunos, firmo el presente certificado en Barcelona, ",
	"certifies": "certifica",
	"Petitioner_TIN": "NIF del solicitante",
	"Petitioner_address": "Dirección del solicitante",
	"registered_in": "inscrita en",
	"from_the": "del",
	"Method_used_to_calculate_the_value": "Método utilizado para calcular el valor adoptado",
	"Cost_value_current_state": "Valor del Coste a estado actual",
	"Comparison_value": "Valor de Comparación",
	"Maximum_legal_value": "Valor Máximo Legal",
	"Adjusted_market_value": "Valor de Mercado Ajustado",
	"Total_appraisal_value": "Valor total de tasación",
	"Real_estates_missing_error_text": "Falta añadir los inmuebles que conforman el informe de tasación",
	"Sign_quote": "Firmar presupuesto",
	"Sign_appraisalreport": "Firmar informe de tasación",
	"Appraiser_sign_appraisalreport": "Firmar informe (Tasador)",
	"Supervisor_sign_appraisalreport": "Firmar informe (Supervisor)",
	"Sign_invoice": "Firmar factura",
	"Sign_certificate": "Firmar certificado",
	"Signature": "Firma",
	"Appraisers_signature": "Firma del Tasador",
	"Supervisors_signature": "Firma del Supervisor",
	"Main_telephonenumber": "Nº de teléfono principal",
	"with_purpose": "con finalidad",
	"Purpose": "Finalidad",
	"Prices": "Precios",
	"Urban_Planning_Documents": "Documentos Urbanísticos",
	"BEC_expenses_plus_builders_benefit_pct": "% de gastos y beneficio del promotor en el precio del BEC",
	"pkg_number": "Nº de plaza",
	"Index": "Índice",
	"Cession_type": "Tipo de cesión",
	"Real_right_type": "Tipo de rerecho real",
	"Reports": "Informes",
	"Other_files": "Otros documentos",
	"Construction_reposition_cost_as_new": "Coste de reposición de la construcción a nuevo",
	"Construction_value_in_actual_state": "Valor de la construcción a estado actual",
	"executed_construction": "construcción realizada",
	"Integrity": "Integridad",
	"remaining": "restante",
	"or": "o",
	"Project": "Proyecto",
	"Projects": "Proyectos",
	"Add_project": "Añadir proyecto",
	"Projects_of_the_Real_Estate": "Proyectos",
	"BDE_files_index": "Índice de ficheros del BDE",
	"BDE_files": "Ficheros del BDE",
	"Asset_type": "Tipo de activo",
	"Property_usage": "Uso del inmueble",
	"Parking_spots_included_number": "Nº de plazas de parking incluidas",
	"BdE_appraisal_files": "Tasaciones",
	"BdE_realestate_files": "Inmuebles",
	"BdE_comparable_files": "Comparables",
	"BdE_relationships_files": "Relaciones",
	"Insurance_value_rd_1982_text": "Valor de reemplazamiento bruto excluido el valor del terreno",
	"Insurance_value_rd_2009_text": "Valor de tasación excluido el valor del terreno",
	"VAT_not_included": "IVA no incluido",
	"EEC_conditions": "Viviendas de hasta 100 m² en el Área Metropolitana de Barcelona: 125 €+ IVA",
	"OCC_conditions": "Viviendas de hasta 100 m² en el Área Metropolitana de Barcelona: 125 €+ IVA",
	"EECOCC_conditions": "Viviendas de hasta 100 m² en el Área Metropolitana de Barcelona: 210 €+ IVA",
	"OT_conditions": "Altres tipologies segons pressupost"
};

/***/ }),
/* 2284 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js